/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".bundle.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(316);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(3165);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {
		return null;
	}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = typeof options.transform === 'function'
		 ? options.transform(obj.css) 
		 : options.transform.default(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            __webpack_require__(1546)("./" + name);
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(539)(module)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AppConstants = {
  api: '/api',
  appName: 'Rangers',

  defaultPageSize: 1000,
  defaultPageLimit: 10,
  scanLimit: 11,
  scan_enter_suffix: '$M',
  isEnableMultiFunction: true,
  defaultBagOutScanLimit: 10,
  states: [{ label: 'Alabama', value: 'AL' }, { label: 'Alaska', value: 'AK' }, { label: 'American Samoa', value: 'AS' }, { label: 'Arizona', value: 'AZ' }, { label: 'Arkansas', value: 'AR' }, { label: 'California', value: 'CA' }, { label: 'Colorado', value: 'CO' }, { label: 'Connecticut', value: 'CT' }, { label: 'Delaware', value: 'DE' }, { label: 'District Of Columbia', value: 'DC' }, { label: 'Florida', value: 'FL' }, { label: 'Georgia', value: 'GA' }, { label: 'Guam', value: 'GU' }, { label: 'Hawaii', value: 'HI' }, { label: 'Idaho', value: 'ID' }, { label: 'Illinois', value: 'IL' }, { label: 'Indiana', value: 'IN' }, { label: 'Iowa', value: 'IA' }, { label: 'Kansas', value: 'KS' }, { label: 'Kentucky', value: 'KY' }, { label: 'Louisiana', value: 'LA' }, { label: 'Maine', value: 'ME' }, { label: 'Marshall Islands', value: 'MH' }, { label: 'Maryland', value: 'MD' }, { label: 'Massachusetts', value: 'MA' }, { label: 'Michigan', value: 'MI' }, { label: 'Minnesota', value: 'MN' }, { label: 'Mississippi', value: 'MS' }, { label: 'Missouri', value: 'MO' }, { label: 'Montana', value: 'MT' }, { label: 'Nebraska', value: 'NE' }, { label: 'Nevada', value: 'NV' }, { label: 'New Hampshire', value: 'NH' }, { label: 'New Jersey', value: 'NJ' }, { label: 'New Mexico', value: 'NM' }, { label: 'New York', value: 'NY' }, { label: 'North Carolina', value: 'NC' }, { label: 'North Dakota', value: 'ND' }, { label: 'Northern Mariana Islands', value: 'MP' }, { label: 'Ohio', value: 'OH' }, { label: 'Oklahoma', value: 'OK' }, { label: 'Oregon', value: 'OR' }, { label: 'Palau', value: 'PW' }, { label: 'Pennsylvania', value: 'PA' }, { label: 'Puerto Rico', value: 'PR' }, { label: 'Rhode Island', value: 'RI' }, { label: 'South Carolina', value: 'SC' }, { label: 'South Dakota', value: 'SD' }, { label: 'Tennessee', value: 'TN' }, { label: 'Texas', value: 'TX' }, { label: 'Utah', value: 'UT' }, { label: 'Vermont', value: 'VT' }, { label: 'Virgin Islands', value: 'VI' }, { label: 'Virginia', value: 'VA' }, { label: 'Washington', value: 'WA' }, { label: 'West Virginia', value: 'WV' }, { label: 'Wisconsin', value: 'WI' }, { label: 'Wyoming', value: 'WY' }]
};

exports.default = AppConstants;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(670), __esModule: true };

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(624);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(622);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var core = __webpack_require__(63);
var hide = __webpack_require__(47);
var redefine = __webpack_require__(48);
var ctx = __webpack_require__(64);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(671), __esModule: true };

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(617);
module.exports = angular;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(623);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(674), __esModule: true };

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Random utility functions used in the UI-Router code
 *
 * These functions are exported, but are subject to change without notice.
 *
 * @preferred
 * @module common
 */
/** for typedoc */
var predicates_1 = __webpack_require__(21);
var hof_1 = __webpack_require__(26);
var coreservices_1 = __webpack_require__(40);
var w = typeof window === 'undefined' ? {} : window;
var angular = w.angular || {};
exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
exports.copy = angular.copy || _copy;
exports.forEach = angular.forEach || _forEach;
exports.extend = Object.assign || _extend;
exports.equals = angular.equals || _equals;
function identity(x) { return x; }
exports.identity = identity;
function noop() { }
exports.noop = noop;
/**
 * Builds proxy functions on the `to` object which pass through to the `from` object.
 *
 * For each key in `fnNames`, creates a proxy function on the `to` object.
 * The proxy function calls the real function on the `from` object.
 *
 *
 * #### Example:
 * This example creates an new class instance whose functions are prebound to the new'd object.
 * ```js
 * class Foo {
 *   constructor(data) {
 *     // Binds all functions from Foo.prototype to 'this',
 *     // then copies them to 'this'
 *     bindFunctions(Foo.prototype, this, this);
 *     this.data = data;
 *   }
 *
 *   log() {
 *     console.log(this.data);
 *   }
 * }
 *
 * let myFoo = new Foo([1,2,3]);
 * var logit = myFoo.log;
 * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
 * ```
 *
 * #### Example:
 * This example creates a bound version of a service function, and copies it to another object
 * ```
 *
 * var SomeService = {
 *   this.data = [3, 4, 5];
 *   this.log = function() {
 *     console.log(this.data);
 *   }
 * }
 *
 * // Constructor fn
 * function OtherThing() {
 *   // Binds all functions from SomeService to SomeService,
 *   // then copies them to 'this'
 *   bindFunctions(SomeService, this, SomeService);
 * }
 *
 * let myOtherThing = new OtherThing();
 * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
 * ```
 *
 * @param source A function that returns the source object which contains the original functions to be bound
 * @param target A function that returns the target object which will receive the bound functions
 * @param bind A function that returns the object which the functions will be bound to
 * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
 * @param latebind If true, the binding of the function is delayed until the first time it's invoked
 */
function createProxyFunctions(source, target, bind, fnNames, latebind) {
    if (latebind === void 0) { latebind = false; }
    var bindFunction = function (fnName) {
        return source()[fnName].bind(bind());
    };
    var makeLateRebindFn = function (fnName) { return function lateRebindFunction() {
        target[fnName] = bindFunction(fnName);
        return target[fnName].apply(null, arguments);
    }; };
    fnNames = fnNames || Object.keys(source());
    return fnNames.reduce(function (acc, name) {
        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
        return acc;
    }, target);
}
exports.createProxyFunctions = createProxyFunctions;
/**
 * prototypal inheritance helper.
 * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
 */
exports.inherit = function (parent, extra) {
    return exports.extend(Object.create(parent), extra);
};
/**
 * Given an arguments object, converts the arguments at index idx and above to an array.
 * This is similar to es6 rest parameters.
 *
 * Optionally, the argument at index idx may itself already be an array.
 *
 * For example,
 * given either:
 *        arguments = [ obj, "foo", "bar" ]
 * or:
 *        arguments = [ obj, ["foo", "bar"] ]
 * then:
 *        restArgs(arguments, 1) == ["foo", "bar"]
 *
 * This allows functions like pick() to be implemented such that it allows either a bunch
 * of string arguments (like es6 rest parameters), or a single array of strings:
 *
 * given:
 *        var obj = { foo: 1, bar: 2, baz: 3 };
 * then:
 *        pick(obj, "foo", "bar");   // returns { foo: 1, bar: 2 }
 *        pick(obj, ["foo", "bar"]); // returns { foo: 1, bar: 2 }
 */
var restArgs = function (args, idx) {
    if (idx === void 0) { idx = 0; }
    return Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(args, idx));
};
/** Given an array, returns true if the object is found in the array, (using indexOf) */
exports.inArray = hof_1.curry(_inArray);
function _inArray(array, obj) {
    return array.indexOf(obj) !== -1;
}
exports._inArray = _inArray;
/**
 * Given an array, and an item, if the item is found in the array, it removes it (in-place).
 * The same array is returned
 */
exports.removeFrom = hof_1.curry(_removeFrom);
function _removeFrom(array, obj) {
    var idx = array.indexOf(obj);
    if (idx >= 0)
        array.splice(idx, 1);
    return array;
}
exports._removeFrom = _removeFrom;
/** pushes a values to an array and returns the value */
exports.pushTo = hof_1.curry(_pushTo);
function _pushTo(arr, val) {
    return (arr.push(val), val);
}
exports._pushTo = _pushTo;
/** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
exports.deregAll = function (functions) {
    return functions.slice().forEach(function (fn) {
        typeof fn === 'function' && fn();
        exports.removeFrom(functions, fn);
    });
};
/**
 * Applies a set of defaults to an options object.  The options object is filtered
 * to only those properties of the objects in the defaultsList.
 * Earlier objects in the defaultsList take precedence when applying defaults.
 */
function defaults(opts) {
    var defaultsList = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        defaultsList[_i - 1] = arguments[_i];
    }
    var _defaultsList = defaultsList.concat({}).reverse();
    var defaultVals = exports.extend.apply(null, _defaultsList);
    return exports.extend({}, defaultVals, pick(opts || {}, Object.keys(defaultVals)));
}
exports.defaults = defaults;
/** Reduce function that merges each element of the list into a single object, using extend */
exports.mergeR = function (memo, item) { return exports.extend(memo, item); };
/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
    var path = [];
    for (var n in first.path) {
        if (first.path[n] !== second.path[n])
            break;
        path.push(first.path[n]);
    }
    return path;
}
exports.ancestors = ancestors;
/**
 * Return a copy of the object only containing the whitelisted properties.
 *
 * #### Example:
 * ```
 * var foo = { a: 1, b: 2, c: 3 };
 * var ab = pick(foo, ['a', 'b']); // { a: 1, b: 2 }
 * ```
 * @param obj the source object
 * @param propNames an Array of strings, which are the whitelisted property names
 */
function pick(obj, propNames) {
    var objCopy = {};
    for (var prop_1 in obj) {
        if (propNames.indexOf(prop_1) !== -1) {
            objCopy[prop_1] = obj[prop_1];
        }
    }
    return objCopy;
}
exports.pick = pick;
/**
 * Return a copy of the object omitting the blacklisted properties.
 *
 * @example
 * ```
 *
 * var foo = { a: 1, b: 2, c: 3 };
 * var ab = omit(foo, ['a', 'b']); // { c: 3 }
 * ```
 * @param obj the source object
 * @param propNames an Array of strings, which are the blacklisted property names
 */
function omit(obj, propNames) {
    return Object.keys(obj)
        .filter(hof_1.not(exports.inArray(propNames)))
        .reduce(function (acc, key) { return (acc[key] = obj[key], acc); }, {});
}
exports.omit = omit;
/**
 * Maps an array, or object to a property (by name)
 */
function pluck(collection, propName) {
    return map(collection, hof_1.prop(propName));
}
exports.pluck = pluck;
/** Filters an Array or an Object's properties based on a predicate */
function filter(collection, callback) {
    var arr = predicates_1.isArray(collection), result = arr ? [] : {};
    var accept = arr ? function (x) { return result.push(x); } : function (x, key) { return result[key] = x; };
    exports.forEach(collection, function (item, i) {
        if (callback(item, i))
            accept(item, i);
    });
    return result;
}
exports.filter = filter;
/** Finds an object from an array, or a property of an object, that matches a predicate */
function find(collection, callback) {
    var result;
    exports.forEach(collection, function (item, i) {
        if (result)
            return;
        if (callback(item, i))
            result = item;
    });
    return result;
}
exports.find = find;
/** Given an object, returns a new object, where each property is transformed by the callback function */
exports.mapObj = map;
/** Maps an array or object properties using a callback function */
function map(collection, callback) {
    var result = predicates_1.isArray(collection) ? [] : {};
    exports.forEach(collection, function (item, i) { return result[i] = callback(item, i); });
    return result;
}
exports.map = map;
/**
 * Given an object, return its enumerable property values
 *
 * @example
 * ```
 *
 * let foo = { a: 1, b: 2, c: 3 }
 * let vals = values(foo); // [ 1, 2, 3 ]
 * ```
 */
exports.values = function (obj) {
    return Object.keys(obj).map(function (key) { return obj[key]; });
};
/**
 * Reduce function that returns true if all of the values are truthy.
 *
 * @example
 * ```
 *
 * let vals = [ 1, true, {}, "hello world"];
 * vals.reduce(allTrueR, true); // true
 *
 * vals.push(0);
 * vals.reduce(allTrueR, true); // false
 * ```
 */
exports.allTrueR = function (memo, elem) { return memo && elem; };
/**
 * Reduce function that returns true if any of the values are truthy.
 *
 *  * @example
 * ```
 *
 * let vals = [ 0, null, undefined ];
 * vals.reduce(anyTrueR, true); // false
 *
 * vals.push("hello world");
 * vals.reduce(anyTrueR, true); // true
 * ```
 */
exports.anyTrueR = function (memo, elem) { return memo || elem; };
/**
 * Reduce function which un-nests a single level of arrays
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
 * ```
 */
exports.unnestR = function (memo, elem) { return memo.concat(elem); };
/**
 * Reduce function which recursively un-nests all arrays
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
 * ```
 */
exports.flattenR = function (memo, elem) {
    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
};
/**
 * Reduce function that pushes an object to an array, then returns the array.
 * Mostly just for [[flattenR]] and [[uniqR]]
 */
function pushR(arr, obj) {
    arr.push(obj);
    return arr;
}
exports.pushR = pushR;
/** Reduce function that filters out duplicates */
exports.uniqR = function (acc, token) {
    return exports.inArray(acc, token) ? acc : pushR(acc, token);
};
/**
 * Return a new array with a single level of arrays unnested.
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
 * ```
 */
exports.unnest = function (arr) { return arr.reduce(exports.unnestR, []); };
/**
 * Return a completely flattened version of an array.
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
 * ```
 */
exports.flatten = function (arr) { return arr.reduce(exports.flattenR, []); };
/**
 * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
 * @example
 * ```
 *
 * let isNumber = (obj) => typeof(obj) === 'number';
 * let allNumbers = [ 1, 2, 3, 4, 5 ];
 * allNumbers.filter(assertPredicate(isNumber)); //OK
 *
 * let oneString = [ 1, 2, 3, 4, "5" ];
 * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
 * ```
 */
exports.assertPredicate = assertFn;
/**
 * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
 * @example
 * ```
 *
 * var data = { foo: 1, bar: 2 };
 *
 * let keys = [ 'foo', 'bar' ]
 * let values = keys.map(assertMap(key => data[key], "Key not found"));
 * // values is [1, 2]
 *
 * let keys = [ 'foo', 'bar', 'baz' ]
 * let values = keys.map(assertMap(key => data[key], "Key not found"));
 * // throws Error("Key not found")
 * ```
 */
exports.assertMap = assertFn;
function assertFn(predicateOrMap, errMsg) {
    if (errMsg === void 0) { errMsg = "assert failure"; }
    return function (obj) {
        var result = predicateOrMap(obj);
        if (!result) {
            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
        }
        return result;
    };
}
exports.assertFn = assertFn;
/**
 * Like _.pairs: Given an object, returns an array of key/value pairs
 *
 * @example
 * ```
 *
 * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
 * ```
 */
exports.pairs = function (obj) {
    return Object.keys(obj).map(function (key) { return [key, obj[key]]; });
};
/**
 * Given two or more parallel arrays, returns an array of tuples where
 * each tuple is composed of [ a[i], b[i], ... z[i] ]
 *
 * @example
 * ```
 *
 * let foo = [ 0, 2, 4, 6 ];
 * let bar = [ 1, 3, 5, 7 ];
 * let baz = [ 10, 30, 50, 70 ];
 * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
 * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
 * ```
 */
function arrayTuples() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length === 0)
        return [];
    var maxArrayLen = args.reduce(function (min, arr) { return Math.min(arr.length, min); }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
    var i, result = [];
    for (i = 0; i < maxArrayLen; i++) {
        // This is a hot function
        // Unroll when there are 1-4 arguments
        switch (args.length) {
            case 1:
                result.push([args[0][i]]);
                break;
            case 2:
                result.push([args[0][i], args[1][i]]);
                break;
            case 3:
                result.push([args[0][i], args[1][i], args[2][i]]);
                break;
            case 4:
                result.push([args[0][i], args[1][i], args[2][i], args[3][i]]);
                break;
            default:
                result.push(args.map(function (array) { return array[i]; }));
                break;
        }
    }
    return result;
}
exports.arrayTuples = arrayTuples;
/**
 * Reduce function which builds an object from an array of [key, value] pairs.
 *
 * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
 *
 * Each keyValueTuple should be an array with values [ key: string, value: any ]
 *
 * @example
 * ```
 *
 * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
 *
 * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
 *
 * // Or, more simply:
 * var pairsToObj = pairs.reduce(applyPairs, {})
 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
 * ```
 */
function applyPairs(memo, keyValTuple) {
    var key, value;
    if (predicates_1.isArray(keyValTuple))
        key = keyValTuple[0], value = keyValTuple[1];
    if (!predicates_1.isString(key))
        throw new Error("invalid parameters to applyPairs");
    memo[key] = value;
    return memo;
}
exports.applyPairs = applyPairs;
/** Get the last element of an array */
function tail(arr) {
    return arr.length && arr[arr.length - 1] || undefined;
}
exports.tail = tail;
/**
 * shallow copy from src to dest
 *
 * note: This is a shallow copy, while angular.copy is a deep copy.
 * ui-router uses `copy` only to make copies of state parameters.
 */
function _copy(src, dest) {
    if (dest)
        Object.keys(dest).forEach(function (key) { return delete dest[key]; });
    if (!dest)
        dest = {};
    return exports.extend(dest, src);
}
/** Naive forEach implementation works with Objects or Arrays */
function _forEach(obj, cb, _this) {
    if (predicates_1.isArray(obj))
        return obj.forEach(cb, _this);
    Object.keys(obj).forEach(function (key) { return cb(obj[key], key); });
}
function _extend(toObj) {
    for (var i = 1; i < arguments.length; i++) {
        var obj = arguments[i];
        if (!obj)
            continue;
        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; j++) {
            toObj[keys[j]] = obj[keys[j]];
        }
    }
    return toObj;
}
exports._extend = _extend;
function _equals(o1, o2) {
    if (o1 === o2)
        return true;
    if (o1 === null || o2 === null)
        return false;
    if (o1 !== o1 && o2 !== o2)
        return true; // NaN === NaN
    var t1 = typeof o1, t2 = typeof o2;
    if (t1 !== t2 || t1 !== 'object')
        return false;
    var tup = [o1, o2];
    if (hof_1.all(predicates_1.isArray)(tup))
        return _arraysEq(o1, o2);
    if (hof_1.all(predicates_1.isDate)(tup))
        return o1.getTime() === o2.getTime();
    if (hof_1.all(predicates_1.isRegExp)(tup))
        return o1.toString() === o2.toString();
    if (hof_1.all(predicates_1.isFunction)(tup))
        return true; // meh
    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
    if (predicates.map(hof_1.any).reduce(function (b, fn) { return b || !!fn(tup); }, false))
        return false;
    var key, keys = {};
    for (key in o1) {
        if (!_equals(o1[key], o2[key]))
            return false;
        keys[key] = true;
    }
    for (key in o2) {
        if (!keys[key])
            return false;
    }
    return true;
}
function _arraysEq(a1, a2) {
    if (a1.length !== a2.length)
        return false;
    return arrayTuples(a1, a2).reduce(function (b, t) { return b && _equals(t[0], t[1]); }, true);
}
/**
 * Create a sort function
 *
 * Creates a sort function which sorts by a numeric property.
 *
 * The `propFn` should return the property as a number which can be sorted.
 *
 * #### Example:
 * This example returns the `priority` prop.
 * ```js
 * var sortfn = sortBy(obj => obj.priority)
 * // equivalent to:
 * var longhandSortFn = (a, b) => a.priority - b.priority;
 * ```
 *
 * #### Example:
 * This example uses [[prop]]
 * ```js
 * var sortfn = sortBy(prop('priority'))
 * ```
 *
 * The `checkFn` can be used to exclude objects from sorting.
 *
 * #### Example:
 * This example only sorts objects with type === 'FOO'
 * ```js
 * var sortfn = sortBy(prop('priority'), propEq('type', 'FOO'))
 * ```
 *
 * @param propFn a function that returns the property (as a number)
 * @param checkFn a predicate
 *
 * @return a sort function like: `(a, b) => (checkFn(a) && checkFn(b)) ? propFn(a) - propFn(b) : 0`
 */
exports.sortBy = function (propFn, checkFn) {
    if (checkFn === void 0) { checkFn = hof_1.val(true); }
    return function (a, b) {
        return (checkFn(a) && checkFn(b)) ? propFn(a) - propFn(b) : 0;
    };
};
/**
 * Composes a list of sort functions
 *
 * Creates a sort function composed of multiple sort functions.
 * Each sort function is invoked in series.
 * The first sort function to return non-zero "wins".
 *
 * @param sortFns list of sort functions
 */
exports.composeSort = function () {
    var sortFns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sortFns[_i] = arguments[_i];
    }
    return function composedSort(a, b) {
        return sortFns.reduce(function (prev, fn) { return prev || fn(a, b); }, 0);
    };
};
// issue #2676
exports.silenceUncaughtInPromise = function (promise) {
    return promise.catch(function (e) { return 0; }) && promise;
};
exports.silentRejection = function (error) {
    return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error));
};
//# sourceMappingURL=common.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(659), __esModule: true };

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(664), __esModule: true };

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** Predicates
 *
 * These predicates return true/false based on the input.
 * Although these functions are exported, they are subject to change without notice.
 *
 * @module common_predicates
 */
/** */
var hof_1 = __webpack_require__(26);
var stateObject_1 = __webpack_require__(183);
var toStr = Object.prototype.toString;
var tis = function (t) { return function (x) { return typeof (x) === t; }; };
exports.isUndefined = tis('undefined');
exports.isDefined = hof_1.not(exports.isUndefined);
exports.isNull = function (o) { return o === null; };
exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
exports.isFunction = tis('function');
exports.isNumber = tis('number');
exports.isString = tis('string');
exports.isObject = function (x) { return x !== null && typeof x === 'object'; };
exports.isArray = Array.isArray;
exports.isDate = (function (x) { return toStr.call(x) === '[object Date]'; });
exports.isRegExp = (function (x) { return toStr.call(x) === '[object RegExp]'; });
exports.isState = stateObject_1.StateObject.isState;
/**
 * Predicate which checks if a value is injectable
 *
 * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
 * where all the elements in the array are Strings, except the last one, which is a Function
 */
function isInjectable(val) {
    if (exports.isArray(val) && val.length) {
        var head = val.slice(0, -1), tail = val.slice(-1);
        return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
    }
    return exports.isFunction(val);
}
exports.isInjectable = isInjectable;
/**
 * Predicate which checks if a value looks like a Promise
 *
 * It is probably a Promise if it's an object, and it has a `then` property which is a Function
 */
exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
//# sourceMappingURL=predicates.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121), __webpack_require__(539)(module)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(619);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(136)('wks');
var uid = __webpack_require__(104);
var Symbol = __webpack_require__(16).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Higher order functions
 *
 * These utility functions are exported, but are subject to change without notice.
 *
 * @module common_hof
 */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
 *
 * Given a function with N parameters, returns a new function that supports partial application.
 * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
 * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
 * accept more parameters until all N parameters have been supplied.
 *
 *
 * This contrived example uses a partially applied function as an predicate, which returns true
 * if an object is found in both arrays.
 * @example
 * ```
 * // returns true if an object is in both of the two arrays
 * function inBoth(array1, array2, object) {
 *   return array1.indexOf(object) !== -1 &&
 *          array2.indexOf(object) !== 1;
 * }
 * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
 * let foos = [obj1, obj3]
 * let bars = [obj3, obj4, obj5]
 *
 * // A curried "copy" of inBoth
 * let curriedInBoth = curry(inBoth);
 * // Partially apply both the array1 and array2
 * let inFoosAndBars = curriedInBoth(foos, bars);
 *
 * // Supply the final argument; since all arguments are
 * // supplied, the original inBoth function is then called.
 * let obj1InBoth = inFoosAndBars(obj1); // false
 *
 * // Use the inFoosAndBars as a predicate.
 * // Filter, on each iteration, supplies the final argument
 * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
 * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
 *
 * ```
 *
 * Stolen from: http://stackoverflow.com/questions/4394747/javascript-curry-function
 *
 * @param fn
 * @returns {*|function(): (*|any)}
 */
function curry(fn) {
    var initial_args = [].slice.apply(arguments, [1]);
    var func_args_length = fn.length;
    function curried(args) {
        if (args.length >= func_args_length)
            return fn.apply(null, args);
        return function () {
            return curried(args.concat([].slice.apply(arguments)));
        };
    }
    return curried(initial_args);
}
exports.curry = curry;
/**
 * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
 * given: f(x), g(x), h(x)
 * let composed = compose(f,g,h)
 * then, composed is: f(g(h(x)))
 */
function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function () {
        var i = start, result = args[start].apply(this, arguments);
        while (i--)
            result = args[i].call(this, result);
        return result;
    };
}
exports.compose = compose;
/**
 * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
 * given: f(x), g(x), h(x)
 * let piped = pipe(f,g,h);
 * then, piped is: h(g(f(x)))
 */
function pipe() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    return compose.apply(null, [].slice.call(arguments).reverse());
}
exports.pipe = pipe;
/**
 * Given a property name, returns a function that returns that property from an object
 * let obj = { foo: 1, name: "blarg" };
 * let getName = prop("name");
 * getName(obj) === "blarg"
 */
exports.prop = function (name) {
    return function (obj) { return obj && obj[name]; };
};
/**
 * Given a property name and a value, returns a function that returns a boolean based on whether
 * the passed object has a property that matches the value
 * let obj = { foo: 1, name: "blarg" };
 * let getName = propEq("name", "blarg");
 * getName(obj) === true
 */
exports.propEq = curry(function (name, val, obj) { return obj && obj[name] === val; });
/**
 * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
 * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
 * let getName = prop("nestedObj.name");
 * getName(obj) === "blarg"
 * let propNotFound = prop("this.property.doesnt.exist");
 * propNotFound(obj) === undefined
 */
exports.parse = function (name) {
    return pipe.apply(null, name.split(".").map(exports.prop));
};
/**
 * Given a function that returns a truthy or falsey value, returns a
 * function that returns the opposite (falsey or truthy) value given the same inputs
 */
exports.not = function (fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return !fn.apply(null, args);
    };
};
/**
 * Given two functions that return truthy or falsey values, returns a function that returns truthy
 * if both functions return truthy for the given arguments
 */
function and(fn1, fn2) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn1.apply(null, args) && fn2.apply(null, args);
    };
}
exports.and = and;
/**
 * Given two functions that return truthy or falsey values, returns a function that returns truthy
 * if at least one of the functions returns truthy for the given arguments
 */
function or(fn1, fn2) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn1.apply(null, args) || fn2.apply(null, args);
    };
}
exports.or = or;
/**
 * Check if all the elements of an array match a predicate function
 *
 * @param fn1 a predicate function `fn1`
 * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
 */
exports.all = function (fn1) {
    return function (arr) { return arr.reduce(function (b, x) { return b && !!fn1(x); }, true); };
};
exports.any = function (fn1) {
    return function (arr) { return arr.reduce(function (b, x) { return b || !!fn1(x); }, false); };
};
/** Given a class, returns a Predicate function that returns true if the object is of that class */
exports.is = function (ctor) {
    return function (obj) {
        return (obj != null && obj.constructor === ctor || obj instanceof ctor);
    };
};
/** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
exports.eq = function (val) { return function (other) {
    return val === other;
}; };
/** Given a value, returns a function which returns the value */
exports.val = function (v) { return function () { return v; }; };
function invoke(fnName, args) {
    return function (obj) {
        return obj[fnName].apply(obj, args);
    };
}
exports.invoke = invoke;
/**
 * Sorta like Pattern Matching (a functional programming conditional construct)
 *
 * See http://c2.com/cgi/wiki?PatternMatching
 *
 * This is a conditional construct which allows a series of predicates and output functions
 * to be checked and then applied.  Each predicate receives the input.  If the predicate
 * returns truthy, then its matching output function (mapping function) is provided with
 * the input and, then the result is returned.
 *
 * Each combination (2-tuple) of predicate + output function should be placed in an array
 * of size 2: [ predicate, mapFn ]
 *
 * These 2-tuples should be put in an outer array.
 *
 * @example
 * ```
 *
 * // Here's a 2-tuple where the first element is the isString predicate
 * // and the second element is a function that returns a description of the input
 * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
 *
 * // Second tuple: predicate "isNumber", mapfn returns a description
 * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
 *
 * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
 *
 * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
 *
 * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
 *
 * console.log(descriptionOf(undefined)); // 'notdefined'
 * console.log(descriptionOf(55)); // '(55) That's a number!'
 * console.log(descriptionOf("foo")); // 'Here's your string foo'
 * ```
 *
 * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
 * with a Predicate and a mapping/output function
 * @returns {function(any): *}
 */
function pattern(struct) {
    return function (x) {
        for (var i = 0; i < struct.length; i++) {
            if (struct[i][0](x))
                return struct[i][1](x);
        }
    };
}
exports.pattern = pattern;
//# sourceMappingURL=hof.js.map

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(66);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(17)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(39);
var core = __webpack_require__(22);
var ctx = __webpack_require__(77);
var hide = __webpack_require__(84);
var has = __webpack_require__(92);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(11);
var IE8_DOM_DEFINE = __webpack_require__(350);
var toPrimitive = __webpack_require__(74);
var dP = Object.defineProperty;

exports.f = __webpack_require__(29) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(626);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(625);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(72);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingBase = function () {
	function SettingBase() {
		(0, _classCallCheck3.default)(this, SettingBase);
	}

	(0, _createClass3.default)(SettingBase, [{
		key: '$onInit',
		value: function $onInit() {
			if (this.$state.current.name === '' + this.id) {
				if (this.id == 'delivery-region-routing') {
					this.$state.go(this.id + '.create');
				} else this.$state.go(this.id + '.all', { page: 1 });
			}
		}
	}, {
		key: 'goToAll',
		value: function goToAll() {
			this.$state.go(this.id + '.all', {
				page: 1
			});
		}
	}]);
	return SettingBase;
}();

exports.default = SettingBase;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(657), __esModule: true };

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(316);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(75);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    /* istanbul ignore next */
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.StringMask = factory();
    }
}(this, function() {
    var tokens = {
        '0': {pattern: /\d/, _default: '0'},
        '9': {pattern: /\d/, optional: true},
        '#': {pattern: /\d/, optional: true, recursive: true},
        'A': {pattern: /[a-zA-Z0-9]/},
        'S': {pattern: /[a-zA-Z]/},
        'U': {pattern: /[a-zA-Z]/, transform: function(c) { return c.toLocaleUpperCase(); }},
        'L': {pattern: /[a-zA-Z]/, transform: function(c) { return c.toLocaleLowerCase(); }},
        '$': {escape: true}
    };

    function isEscaped(pattern, pos) {
        var count = 0;
        var i = pos - 1;
        var token = {escape: true};
        while (i >= 0 && token && token.escape) {
            token = tokens[pattern.charAt(i)];
            count += token && token.escape ? 1 : 0;
            i--;
        }
        return count > 0 && count % 2 === 1;
    }

    function calcOptionalNumbersToUse(pattern, value) {
        var numbersInP = pattern.replace(/[^0]/g,'').length;
        var numbersInV = value.replace(/[^\d]/g,'').length;
        return numbersInV - numbersInP;
    }

    function concatChar(text, character, options, token) {
        if (token && typeof token.transform === 'function') {
            character = token.transform(character);
        }
        if (options.reverse) {
            return character + text;
        }
        return text + character;
    }

    function hasMoreTokens(pattern, pos, inc) {
        var pc = pattern.charAt(pos);
        var token = tokens[pc];
        if (pc === '') {
            return false;
        }
        return token && !token.escape ? true : hasMoreTokens(pattern, pos + inc, inc);
    }

    function hasMoreRecursiveTokens(pattern, pos, inc) {
        var pc = pattern.charAt(pos);
        var token = tokens[pc];
        if (pc === '') {
            return false;
        }
        return token && token.recursive ? true : hasMoreRecursiveTokens(pattern, pos + inc, inc);
    }

    function insertChar(text, char, position) {
        var t = text.split('');
        t.splice(position, 0, char);
        return t.join('');
    }

    function StringMask(pattern, opt) {
        this.options = opt || {};
        this.options = {
            reverse: this.options.reverse || false,
            usedefaults: this.options.usedefaults || this.options.reverse
        };
        this.pattern = pattern;
    }

    StringMask.prototype.process = function proccess(value) {
        if (!value) {
            return {result: '', valid: false};
        }
        value = value + '';
        var pattern2 = this.pattern;
        var valid = true;
        var formatted = '';
        var valuePos = this.options.reverse ? value.length - 1 : 0;
        var patternPos = 0;
        var optionalNumbersToUse = calcOptionalNumbersToUse(pattern2, value);
        var escapeNext = false;
        var recursive = [];
        var inRecursiveMode = false;

        var steps = {
            start: this.options.reverse ? pattern2.length - 1 : 0,
            end: this.options.reverse ? -1 : pattern2.length,
            inc: this.options.reverse ? -1 : 1
        };

        function continueCondition(options) {
            if (!inRecursiveMode && !recursive.length && hasMoreTokens(pattern2, patternPos, steps.inc)) {
                // continue in the normal iteration
                return true;
            } else if (!inRecursiveMode && recursive.length &&
                hasMoreRecursiveTokens(pattern2, patternPos, steps.inc)) {
                // continue looking for the recursive tokens
                // Note: all chars in the patterns after the recursive portion will be handled as static string
                return true;
            } else if (!inRecursiveMode) {
                // start to handle the recursive portion of the pattern
                inRecursiveMode = recursive.length > 0;
            }

            if (inRecursiveMode) {
                var pc = recursive.shift();
                recursive.push(pc);
                if (options.reverse && valuePos >= 0) {
                    patternPos++;
                    pattern2 = insertChar(pattern2, pc, patternPos);
                    return true;
                } else if (!options.reverse && valuePos < value.length) {
                    pattern2 = insertChar(pattern2, pc, patternPos);
                    return true;
                }
            }
            return patternPos < pattern2.length && patternPos >= 0;
        }

        /**
         * Iterate over the pattern's chars parsing/matching the input value chars
         * until the end of the pattern. If the pattern ends with recursive chars
         * the iteration will continue until the end of the input value.
         *
         * Note: The iteration must stop if an invalid char is found.
         */
        for (patternPos = steps.start; continueCondition(this.options); patternPos = patternPos + steps.inc) {
            // Value char
            var vc = value.charAt(valuePos);
            // Pattern char to match with the value char
            var pc = pattern2.charAt(patternPos);

            var token = tokens[pc];
            if (recursive.length && token && !token.recursive) {
                // In the recursive portion of the pattern: tokens not recursive must be seen as static chars
                token = null;
            }

            // 1. Handle escape tokens in pattern
            // go to next iteration: if the pattern char is a escape char or was escaped
            if (!inRecursiveMode || vc) {
                if (this.options.reverse && isEscaped(pattern2, patternPos)) {
                    // pattern char is escaped, just add it and move on
                    formatted = concatChar(formatted, pc, this.options, token);
                    // skip escape token
                    patternPos = patternPos + steps.inc;
                    continue;
                } else if (!this.options.reverse && escapeNext) {
                    // pattern char is escaped, just add it and move on
                    formatted = concatChar(formatted, pc, this.options, token);
                    escapeNext = false;
                    continue;
                } else if (!this.options.reverse && token && token.escape) {
                    // mark to escape the next pattern char
                    escapeNext = true;
                    continue;
                }
            }

            // 2. Handle recursive tokens in pattern
            // go to next iteration: if the value str is finished or
            //                       if there is a normal token in the recursive portion of the pattern
            if (!inRecursiveMode && token && token.recursive) {
                // save it to repeat in the end of the pattern and handle the value char now
                recursive.push(pc);
            } else if (inRecursiveMode && !vc) {
                // in recursive mode but value is finished. Add the pattern char if it is not a recursive token
                formatted = concatChar(formatted, pc, this.options, token);
                continue;
            } else if (!inRecursiveMode && recursive.length > 0 && !vc) {
                // recursiveMode not started but already in the recursive portion of the pattern
                continue;
            }

            // 3. Handle the value
            // break iterations: if value is invalid for the given pattern
            if (!token) {
                // add char of the pattern
                formatted = concatChar(formatted, pc, this.options, token);
                if (!inRecursiveMode && recursive.length) {
                    // save it to repeat in the end of the pattern
                    recursive.push(pc);
                }
            } else if (token.optional) {
                // if token is optional, only add the value char if it matchs the token pattern
                //                       if not, move on to the next pattern char
                if (token.pattern.test(vc) && optionalNumbersToUse) {
                    formatted = concatChar(formatted, vc, this.options, token);
                    valuePos = valuePos + steps.inc;
                    optionalNumbersToUse--;
                } else if (recursive.length > 0 && vc) {
                    valid = false;
                    break;
                }
            } else if (token.pattern.test(vc)) {
                // if token isn't optional the value char must match the token pattern
                formatted = concatChar(formatted, vc, this.options, token);
                valuePos = valuePos + steps.inc;
            } else if (!vc && token._default && this.options.usedefaults) {
                // if the token isn't optional and has a default value, use it if the value is finished
                formatted = concatChar(formatted, token._default, this.options, token);
            } else {
                // the string value don't match the given pattern
                valid = false;
                break;
            }
        }

        return {result: formatted, valid: valid};
    };

    StringMask.prototype.apply = function(value) {
        return this.process(value).result;
    };

    StringMask.prototype.validate = function(value) {
        return this.process(value).valid;
    };

    StringMask.process = function(value, pattern, options) {
        return new StringMask(pattern, options).process(value);
    };

    StringMask.apply = function(value, pattern, options) {
        return new StringMask(pattern, options).apply(value);
    };

    StringMask.validate = function(value, pattern, options) {
        return new StringMask(pattern, options).validate(value);
    };

    return StringMask;
}));


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.notImplemented = function (fnname) { return function () {
    throw new Error(fnname + "(): No coreservices implementation for UI-Router is loaded.");
}; };
var services = {
    $q: undefined,
    $injector: undefined,
};
exports.services = services;
//# sourceMappingURL=coreservices.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(667), __esModule: true };

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(201)('wks');
var uid = __webpack_require__(158);
var Symbol = __webpack_require__(39).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonBase = function CommonBase(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, CommonBase);

    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.Service = Service;
    this.Modal = Modal;
    this.$translate = $translate;
    this.$stateParams = $stateParams;
};

exports.default = CommonBase;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(673), __esModule: true };

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(675), __esModule: true };

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31);
var createDesc = __webpack_require__(100);
module.exports = __webpack_require__(29) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var hide = __webpack_require__(47);
var has = __webpack_require__(55);
var SRC = __webpack_require__(104)('src');
var $toString = __webpack_require__(731);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(63).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var fails = __webpack_require__(17);
var defined = __webpack_require__(72);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TNTControlBase = function () {
	function TNTControlBase() {
		(0, _classCallCheck3.default)(this, TNTControlBase);
	}

	(0, _createClass3.default)(TNTControlBase, [{
		key: '$onInit',
		value: function $onInit() {
			if (this.$state.current.name === '' + this.id) {
				this.$state.go(this.id + '.all', { page: 1 });
			}
		}
	}, {
		key: 'goToAll',
		value: function goToAll() {
			this.$state.go(this.id + '.all', {
				page: 1
			});
		}
	}]);
	return TNTControlBase;
}();

exports.default = TNTControlBase;

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module common
 */ /** */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(145));
__export(__webpack_require__(554));
__export(__webpack_require__(555));
__export(__webpack_require__(556));
__export(__webpack_require__(557));
__export(__webpack_require__(558));
__export(__webpack_require__(559));
__export(__webpack_require__(563));
__export(__webpack_require__(287));
__export(__webpack_require__(292));
__export(__webpack_require__(560));
__export(__webpack_require__(553));
//# sourceMappingURL=index.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(91)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(135);
var createDesc = __webpack_require__(100);
var toIObject = __webpack_require__(58);
var toPrimitive = __webpack_require__(74);
var has = __webpack_require__(55);
var IE8_DOM_DEFINE = __webpack_require__(350);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(29) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(55);
var toObject = __webpack_require__(33);
var IE_PROTO = __webpack_require__(226)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(134);
var defined = __webpack_require__(72);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.1.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2016-09-22T22:30Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.1.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			resolve.call( undefined, value );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.call( undefined, value );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && jQuery.nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

function manipulationTarget( elem, content ) {
	if ( jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return elem.getElementsByTagName( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );

	// Support: IE <=9 only
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var val,
		valueIsBorderBox = true,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Support: IE <=11 only
	// Running getBoundingClientRect on a disconnected node
	// in IE throws an error.
	if ( elem.getClientRects().length ) {
		val = elem.getBoundingClientRect()[ name ];
	}

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				style[ name ] = value;
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function raf() {
	if ( timerId ) {
		window.requestAnimationFrame( raf );
		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off or if document is hidden
	if ( jQuery.fx.off || document.hidden ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.requestAnimationFrame ?
			window.requestAnimationFrame( raf ) :
			window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	if ( window.cancelAnimationFrame ) {
		window.cancelAnimationFrame( timerId );
	} else {
		window.clearInterval( timerId );
	}

	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( jQuery.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win, rect, doc,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		// Make sure element is not hidden (display: none)
		if ( rect.width || rect.height ) {
			doc = elem.ownerDocument;
			win = getWindow( doc );
			docElem = doc.documentElement;

			return {
				top: rect.top + win.pageYOffset - docElem.clientTop,
				left: rect.left + win.pageXOffset - docElem.clientLeft
			};
		}

		// Return zeros for disconnected and hidden elements (gh-2310)
		return rect;
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.parseJSON = JSON.parse;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}





return jQuery;
} );


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function maskFactory(maskDefinition) {
	return function MaskDirective() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, element, attrs, ctrl) {
				ctrl.$formatters.push(function formatter(value) {
					if (ctrl.$isEmpty(value)) {
						return value;
					}

					var cleanValue = maskDefinition.clearValue(value);
					return maskDefinition.format(cleanValue);
				});

				ctrl.$parsers.push(function parser(value) {
					if (ctrl.$isEmpty(value)) {
						return value;
					}

					var cleanValue = maskDefinition.clearValue(value);
					var formattedValue = maskDefinition.format(cleanValue);

					if (ctrl.$viewValue !== formattedValue) {
						ctrl.$setViewValue(formattedValue);
						ctrl.$render();
					}

					if (angular.isUndefined(maskDefinition.getModelValue)) {
						return cleanValue;
					}

					var actualModelType = typeof ctrl.$modelValue;
					return maskDefinition.getModelValue(formattedValue, actualModelType);
				});

				angular.forEach(maskDefinition.validations, function(validatorFn, validationErrorKey) {
					ctrl.$validators[validationErrorKey] = function validator(modelValue, viewValue) {
						return ctrl.$isEmpty(modelValue) || validatorFn(modelValue, viewValue);
					};
				});
			}
		};
	};
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(70);
var IE8_DOM_DEFINE = __webpack_require__(323);
var toPrimitive = __webpack_require__(203);
var dP = Object.defineProperty;

exports.f = __webpack_require__(53) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(43);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(17);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return root; });
/* harmony export (immutable) */ __webpack_exports__["b"] = Selection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectAll__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enter__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exit__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__merge__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__order__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sort__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__call__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__node__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__size__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__empty__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__each__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attr__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__property__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__classed__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__text__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__html__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raise__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lower__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__append__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__insert__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__remove__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__clone__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__datum__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__on__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__dispatch__ = __webpack_require__(1208);































var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: __WEBPACK_IMPORTED_MODULE_0__select__["a" /* default */],
  selectAll: __WEBPACK_IMPORTED_MODULE_1__selectAll__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_2__filter__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */],
  enter: __WEBPACK_IMPORTED_MODULE_4__enter__["a" /* default */],
  exit: __WEBPACK_IMPORTED_MODULE_5__exit__["a" /* default */],
  merge: __WEBPACK_IMPORTED_MODULE_6__merge__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_7__order__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_8__sort__["a" /* default */],
  call: __WEBPACK_IMPORTED_MODULE_9__call__["a" /* default */],
  nodes: __WEBPACK_IMPORTED_MODULE_10__nodes__["a" /* default */],
  node: __WEBPACK_IMPORTED_MODULE_11__node__["a" /* default */],
  size: __WEBPACK_IMPORTED_MODULE_12__size__["a" /* default */],
  empty: __WEBPACK_IMPORTED_MODULE_13__empty__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_14__each__["a" /* default */],
  attr: __WEBPACK_IMPORTED_MODULE_15__attr__["a" /* default */],
  style: __WEBPACK_IMPORTED_MODULE_16__style__["b" /* default */],
  property: __WEBPACK_IMPORTED_MODULE_17__property__["a" /* default */],
  classed: __WEBPACK_IMPORTED_MODULE_18__classed__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_19__text__["a" /* default */],
  html: __WEBPACK_IMPORTED_MODULE_20__html__["a" /* default */],
  raise: __WEBPACK_IMPORTED_MODULE_21__raise__["a" /* default */],
  lower: __WEBPACK_IMPORTED_MODULE_22__lower__["a" /* default */],
  append: __WEBPACK_IMPORTED_MODULE_23__append__["a" /* default */],
  insert: __WEBPACK_IMPORTED_MODULE_24__insert__["a" /* default */],
  remove: __WEBPACK_IMPORTED_MODULE_25__remove__["a" /* default */],
  clone: __WEBPACK_IMPORTED_MODULE_26__clone__["a" /* default */],
  datum: __WEBPACK_IMPORTED_MODULE_27__datum__["a" /* default */],
  on: __WEBPACK_IMPORTED_MODULE_28__on__["c" /* default */],
  dispatch: __WEBPACK_IMPORTED_MODULE_29__dispatch__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (selection);


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/$1c.png";

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/scan_error.png";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(64);
var IObject = __webpack_require__(134);
var toObject = __webpack_require__(33);
var toLength = __webpack_require__(27);
var asc = __webpack_require__(210);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(9);
var core = __webpack_require__(63);
var fails = __webpack_require__(17);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(656), __esModule: true };

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(660), __esModule: true };

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(126);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(372);
var $export = __webpack_require__(9);
var shared = __webpack_require__(136)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(376))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(29)) {
  var LIBRARY = __webpack_require__(87);
  var global = __webpack_require__(16);
  var fails = __webpack_require__(17);
  var $export = __webpack_require__(9);
  var $typed = __webpack_require__(172);
  var $buffer = __webpack_require__(231);
  var ctx = __webpack_require__(64);
  var anInstance = __webpack_require__(95);
  var propertyDesc = __webpack_require__(100);
  var hide = __webpack_require__(47);
  var redefineAll = __webpack_require__(101);
  var toInteger = __webpack_require__(66);
  var toLength = __webpack_require__(27);
  var toIndex = __webpack_require__(370);
  var toAbsoluteIndex = __webpack_require__(103);
  var toPrimitive = __webpack_require__(74);
  var has = __webpack_require__(55);
  var classof = __webpack_require__(115);
  var isObject = __webpack_require__(20);
  var toObject = __webpack_require__(33);
  var isArrayIter = __webpack_require__(217);
  var create = __webpack_require__(97);
  var getPrototypeOf = __webpack_require__(57);
  var gOPN = __webpack_require__(98).f;
  var getIterFn = __webpack_require__(233);
  var uid = __webpack_require__(104);
  var wks = __webpack_require__(25);
  var createArrayMethod = __webpack_require__(71);
  var createArrayIncludes = __webpack_require__(160);
  var speciesConstructor = __webpack_require__(137);
  var ArrayIterators = __webpack_require__(234);
  var Iterators = __webpack_require__(116);
  var $iterDetect = __webpack_require__(165);
  var setSpecies = __webpack_require__(102);
  var arrayFill = __webpack_require__(209);
  var arrayCopyWithin = __webpack_require__(342);
  var $DP = __webpack_require__(31);
  var $GOPD = __webpack_require__(56);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/H-icon.png";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonTNTControlBase = function CommonTNTControlBase(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, CommonTNTControlBase);

    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.Service = Service;
    this.Modal = Modal;
    this.$translate = $translate;
    this.$stateParams = $stateParams;
};

exports.default = CommonTNTControlBase;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Functions that manipulate strings
 *
 * Although these functions are exported, they are subject to change without notice.
 *
 * @module common_strings
 */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
var predicates_1 = __webpack_require__(21);
var rejectFactory_1 = __webpack_require__(123);
var common_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(26);
var transition_1 = __webpack_require__(148);
var resolvable_1 = __webpack_require__(122);
/**
 * Returns a string shortened to a maximum length
 *
 * If the string is already less than the `max` length, return the string.
 * Else return the string, shortened to `max - 3` and append three dots ("...").
 *
 * @param max the maximum length of the string to return
 * @param str the input string
 */
function maxLength(max, str) {
    if (str.length <= max)
        return str;
    return str.substr(0, max - 3) + "...";
}
exports.maxLength = maxLength;
/**
 * Returns a string, with spaces added to the end, up to a desired str length
 *
 * If the string is already longer than the desired length, return the string.
 * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
 *
 * @param length the desired length of the string to return
 * @param str the input string
 */
function padString(length, str) {
    while (str.length < length)
        str += " ";
    return str;
}
exports.padString = padString;
function kebobString(camelCase) {
    return camelCase
        .replace(/^([A-Z])/, function ($1) { return $1.toLowerCase(); }) // replace first char
        .replace(/([A-Z])/g, function ($1) { return "-" + $1.toLowerCase(); }); // replace rest
}
exports.kebobString = kebobString;
function _toJson(obj) {
    return JSON.stringify(obj);
}
function _fromJson(json) {
    return predicates_1.isString(json) ? JSON.parse(json) : json;
}
function promiseToString(p) {
    return "Promise(" + JSON.stringify(p) + ")";
}
function functionToString(fn) {
    var fnStr = fnToString(fn);
    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
    var fnName = fn['name'] || "";
    if (fnName && toStr.match(/function \(/)) {
        return 'function ' + fnName + toStr.substr(9);
    }
    return toStr;
}
exports.functionToString = functionToString;
function fnToString(fn) {
    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
    return _fn && _fn.toString() || "undefined";
}
exports.fnToString = fnToString;
var stringifyPatternFn = null;
var stringifyPattern = function (value) {
    var isRejection = rejectFactory_1.Rejection.isRejectionPromise;
    stringifyPatternFn = stringifyPatternFn || hof_1.pattern([
        [hof_1.not(predicates_1.isDefined), hof_1.val("undefined")],
        [predicates_1.isNull, hof_1.val("null")],
        [predicates_1.isPromise, hof_1.val("[Promise]")],
        [isRejection, function (x) { return x._transitionRejection.toString(); }],
        [hof_1.is(rejectFactory_1.Rejection), hof_1.invoke("toString")],
        [hof_1.is(transition_1.Transition), hof_1.invoke("toString")],
        [hof_1.is(resolvable_1.Resolvable), hof_1.invoke("toString")],
        [predicates_1.isInjectable, functionToString],
        [hof_1.val(true), common_1.identity]
    ]);
    return stringifyPatternFn(value);
};
function stringify(o) {
    var seen = [];
    function format(val) {
        if (predicates_1.isObject(val)) {
            if (seen.indexOf(val) !== -1)
                return '[circular ref]';
            seen.push(val);
        }
        return stringifyPattern(val);
    }
    return JSON.stringify(o, function (key, val) { return format(val); }).replace(/\\"/g, '"');
}
exports.stringify = stringify;
/** Returns a function that splits a string on a character or substring */
exports.beforeAfterSubstr = function (char) { return function (str) {
    if (!str)
        return ["", ""];
    var idx = str.indexOf(char);
    if (idx === -1)
        return [str, ""];
    return [str.substr(0, idx), str.substr(idx + 1)];
}; };
/**
 * Splits on a delimiter, but returns the delimiters in the array
 *
 * #### Example:
 * ```js
 * var splitOnSlashes = splitOnDelim('/');
 * splitOnSlashes("/foo"); // ["/", "foo"]
 * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
 * ```
 */
function splitOnDelim(delim) {
    var re = new RegExp("(" + delim + ")", "g");
    return function (str) {
        return str.split(re).filter(common_1.identity);
    };
}
exports.splitOnDelim = splitOnDelim;
;
/**
 * Reduce fn that joins neighboring strings
 *
 * Given an array of strings, returns a new array
 * where all neighboring strings have been joined.
 *
 * #### Example:
 * ```js
 * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
 * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
 * ```
 */
function joinNeighborsR(acc, x) {
    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x))
        return acc.slice(0, -1).concat(common_1.tail(acc) + x);
    return common_1.pushR(acc, x);
}
exports.joinNeighborsR = joinNeighborsR;
;
//# sourceMappingURL=strings.js.map

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * # Transition tracing (debug)
 *
 * Enable transition tracing to print transition information to the console,
 * in order to help debug your application.
 * Tracing logs detailed information about each Transition to your console.
 *
 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
 *
 * ### ES6
 * ```js
 * import {trace} from "ui-router-ng2"; // or "angular-ui-router"
 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
 * ```
 *
 * ### CJS
 * ```js
 * let trace = require("angular-ui-router").trace; // or "ui-router-ng2"
 * trace.enable("TRANSITION", "VIEWCONFIG");
 * ```
 *
 * ### Globals
 * ```js
 * let trace = window["angular-ui-router"].trace; // or "ui-router-ng2"
 * trace.enable(); // Trace everything (very verbose)
 * ```
 *
 * ### Angular 1:
 * ```js
 * app.run($trace => $trace.enable());
 * ```
 *
 * @coreapi
 * @module trace
 */ /** for typedoc */
var hof_1 = __webpack_require__(26);
var predicates_1 = __webpack_require__(21);
var strings_1 = __webpack_require__(82);
/** @hidden */
function uiViewString(viewData) {
    if (!viewData)
        return 'ui-view (defunct)';
    return "[ui-view#" + viewData.id + " tag " +
        ("in template from '" + (viewData.creationContext && viewData.creationContext.name || '(root)') + "' state]: ") +
        ("fqn: '" + viewData.fqn + "', ") +
        ("name: '" + viewData.name + "@" + viewData.creationContext + "')");
}
/** @hidden */
var viewConfigString = function (viewConfig) {
    return "[ViewConfig#" + viewConfig.$id + " from '" + (viewConfig.viewDecl.$context.name || '(root)') + "' state]: target ui-view: '" + viewConfig.viewDecl.$uiViewName + "@" + viewConfig.viewDecl.$uiViewContextAnchor + "'";
};
/** @hidden */
function normalizedCat(input) {
    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
}
/**
 * Trace categories Enum
 *
 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
 *
 * `trace.enable(Category.TRANSITION)`
 *
 * These can also be provided using a matching string, or position ordinal
 *
 * `trace.enable("TRANSITION")`
 *
 * `trace.enable(1)`
 */
var Category;
(function (Category) {
    Category[Category["RESOLVE"] = 0] = "RESOLVE";
    Category[Category["TRANSITION"] = 1] = "TRANSITION";
    Category[Category["HOOK"] = 2] = "HOOK";
    Category[Category["UIVIEW"] = 3] = "UIVIEW";
    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
})(Category = exports.Category || (exports.Category = {}));
/** @hidden */ var _tid = hof_1.parse("$id");
/** @hidden */ var _rid = hof_1.parse("router.$id");
/** @hidden */ var transLbl = function (trans) { return "Transition #" + _tid(trans) + "-" + _rid(trans); };
/**
 * Prints UI-Router Transition trace information to the console.
 */
var Trace = (function () {
    /** @hidden */
    function Trace() {
        /** @hidden */
        this._enabled = {};
        this.approximateDigests = 0;
    }
    /** @hidden */
    Trace.prototype._set = function (enabled, categories) {
        var _this = this;
        if (!categories.length) {
            categories = Object.keys(Category)
                .map(function (k) { return parseInt(k, 10); })
                .filter(function (k) { return !isNaN(k); })
                .map(function (key) { return Category[key]; });
        }
        categories.map(normalizedCat).forEach(function (category) { return _this._enabled[category] = enabled; });
    };
    /**
     * Enables a trace [[Category]]
     *
     * ```js
     * trace.enable("TRANSITION");
     * ```
     *
     * @param categories categories to enable. If `categories` is omitted, all categories are enabled.
     *        Also takes strings (category name) or ordinal (category position)
     */
    Trace.prototype.enable = function () {
        var categories = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            categories[_i] = arguments[_i];
        }
        this._set(true, categories);
    };
    /**
     * Disables a trace [[Category]]
     *
     * ```js
     * trace.disable("VIEWCONFIG");
     * ```
     *
     * @param categories categories to disable. If `categories` is omitted, all categories are disabled.
     *        Also takes strings (category name) or ordinal (category position)
     */
    Trace.prototype.disable = function () {
        var categories = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            categories[_i] = arguments[_i];
        }
        this._set(false, categories);
    };
    /**
     * Retrieves the enabled stateus of a [[Category]]
     *
     * ```js
     * trace.enabled("VIEWCONFIG"); // true or false
     * ```
     *
     * @returns boolean true if the category is enabled
     */
    Trace.prototype.enabled = function (category) {
        return !!this._enabled[normalizedCat(category)];
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceTransitionStart = function (trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        console.log(transLbl(trans) + ": Started  -> " + strings_1.stringify(trans));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceTransitionIgnored = function (trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        console.log(transLbl(trans) + ": Ignored  <> " + strings_1.stringify(trans));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceHookInvocation = function (step, trans, options) {
        if (!this.enabled(Category.HOOK))
            return;
        var event = hof_1.parse("traceData.hookType")(options) || "internal", context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown", name = strings_1.functionToString(step.registeredHook.callback);
        console.log(transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
        if (!this.enabled(Category.HOOK))
            return;
        console.log(transLbl(trans) + ":   <- Hook returned: " + strings_1.maxLength(200, strings_1.stringify(hookResult)));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceResolvePath = function (path, when, trans) {
        if (!this.enabled(Category.RESOLVE))
            return;
        console.log(transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
        if (!this.enabled(Category.RESOLVE))
            return;
        console.log(transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + strings_1.maxLength(200, strings_1.stringify(resolvable.data)));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceError = function (reason, trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        console.log(transLbl(trans) + ": <- Rejected " + strings_1.stringify(trans) + ", reason: " + reason);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceSuccess = function (finalState, trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        console.log(transLbl(trans) + ": <- Success  " + strings_1.stringify(trans) + ", final state: " + finalState.name);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
        if (extra === void 0) { extra = ""; }
        if (!this.enabled(Category.UIVIEW))
            return;
        console.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
        if (!this.enabled(Category.UIVIEW))
            return;
        this.traceUIViewEvent("Updating", viewData, " with ViewConfig from context='" + context + "'");
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewFill = function (viewData, html) {
        if (!this.enabled(Category.UIVIEW))
            return;
        this.traceUIViewEvent("Fill", viewData, " with: " + strings_1.maxLength(200, html));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
        if (!this.enabled(Category.VIEWCONFIG))
            return;
        console.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
        if (!this.enabled(Category.VIEWCONFIG))
            return;
        console.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
    };
    return Trace;
}());
exports.Trace = Trace;
/**
 * The [[Trace]] singleton
 *
 * #### Example:
 * ```js
 * import {trace} from "angular-ui-router";
 * trace.enable(1, 5);
 * ```
 */
var trace = new Trace();
exports.trace = trace;
//# sourceMappingURL=trace.js.map

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(61);
var createDesc = __webpack_require__(131);
module.exports = __webpack_require__(53) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(194);
var defined = __webpack_require__(191);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(25)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(47)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(104)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(55);
var setDesc = __webpack_require__(31).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(17)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Check.png";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module state
 */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
/**
 * Encapsulate the target (destination) state/params/options of a [[Transition]].
 *
 * This class is frequently used to redirect a transition to a new destination.
 *
 * See:
 *
 * - [[HookResult]]
 * - [[TransitionHookFn]]
 * - [[TransitionService.onStart]]
 *
 * To create a `TargetState`, use [[StateService.target]].
 *
 * ---
 *
 * This class wraps:
 *
 * 1) an identifier for a state
 * 2) a set of parameters
 * 3) and transition options
 * 4) the registered state object (the [[StateDeclaration]])
 *
 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
 * either be a *state object* (a [[StateDeclaration]] or [[StateObject]]) or a *state name* (a string).
 * The `TargetState` class normalizes those options.
 *
 * A `TargetState` may be valid (the state being targeted exists in the registry)
 * or invalid (the state being targeted is not registered).
 */
var TargetState = (function () {
    /**
     * The TargetState constructor
     *
     * Note: Do not construct a `TargetState` manually.
     * To create a `TargetState`, use the [[StateService.target]] factory method.
     *
     * @param _identifier An identifier for a state.
     *    Either a fully-qualified state name, or the object used to define the state.
     * @param _definition The internal state representation, if exists.
     * @param _params Parameters for the target state
     * @param _options Transition options.
     *
     * @internalapi
     */
    function TargetState(_identifier, _definition, _params, _options) {
        if (_options === void 0) { _options = {}; }
        this._identifier = _identifier;
        this._definition = _definition;
        this._options = _options;
        this._params = _params || {};
    }
    /** The name of the state this object targets */
    TargetState.prototype.name = function () {
        return this._definition && this._definition.name || this._identifier;
    };
    /** The identifier used when creating this TargetState */
    TargetState.prototype.identifier = function () {
        return this._identifier;
    };
    /** The target parameter values */
    TargetState.prototype.params = function () {
        return this._params;
    };
    /** The internal state object (if it was found) */
    TargetState.prototype.$state = function () {
        return this._definition;
    };
    /** The internal state declaration (if it was found) */
    TargetState.prototype.state = function () {
        return this._definition && this._definition.self;
    };
    /** The target options */
    TargetState.prototype.options = function () {
        return this._options;
    };
    /** True if the target state was found */
    TargetState.prototype.exists = function () {
        return !!(this._definition && this._definition.self);
    };
    /** True if the object is valid */
    TargetState.prototype.valid = function () {
        return !this.error();
    };
    /** If the object is invalid, returns the reason why */
    TargetState.prototype.error = function () {
        var base = this.options().relative;
        if (!this._definition && !!base) {
            var stateName = base.name ? base.name : base;
            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
        }
        if (!this._definition)
            return "No such state '" + this.name() + "'";
        if (!this._definition.self)
            return "State '" + this.name() + "' has an invalid definition";
    };
    TargetState.prototype.toString = function () {
        return "'" + this.name() + "'" + common_1.toJson(this.params());
    };
    return TargetState;
}());
/** Returns true if the object has a state property that might be a state or state name */
TargetState.isDef = function (obj) {
    return obj && obj.state && (predicates_1.isString(obj.state) || predicates_1.isString(obj.state.name));
};
exports.TargetState = TargetState;
//# sourceMappingURL=targetState.js.map

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(191);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(693)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(195)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(64);
var call = __webpack_require__(353);
var isArrayIter = __webpack_require__(217);
var anObject = __webpack_require__(11);
var toLength = __webpack_require__(27);
var getIterFn = __webpack_require__(233);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(11);
var dPs = __webpack_require__(359);
var enumBugKeys = __webpack_require__(213);
var IE_PROTO = __webpack_require__(226)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(212)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(215).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(361);
var hiddenKeys = __webpack_require__(213).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(361);
var enumBugKeys = __webpack_require__(213);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(48);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var dP = __webpack_require__(31);
var DESCRIPTORS = __webpack_require__(29);
var SPECIES = __webpack_require__(25)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(66);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/spritesheet.png";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationBaseController = function (_CommonBase) {
  LocationBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(LocationBaseController, _CommonBase);

  /*@ngInject*/
  function LocationBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, LocationBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LocationBaseController.__proto__ || (0, _getPrototypeOf2.default)(LocationBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.model = {};
    _this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: 'Yes',
        off: 'No'
      },
      onColor: 'success',
      offColor: 'danger'
    };
    return _this;
  }

  (0, _createClass3.default)(LocationBaseController, [{
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        _this2.Modal.confirm({
          header: _this2.$translate.instant('location.create_another_title'),
          message: _this2.$translate.instant('location.create_another_message'),
          callback: function callback(_ref) {
            var modal = _ref.modal,
                $scope = _ref.$scope;

            _this2.reset();
            modal.close();
            resolve(true);
          },
          negative: function negative(_ref2) {
            var modal = _ref2.modal,
                $scope = _ref2.$scope;

            modal.close();
            window.history.go(-1);
            resolve(false);
          },
          type: 'primary',
          buttons: ['common.yes', 'common.no']
        });
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      // for (let key in this.model) {
      //   if (typeof (this.model[key]) == 'string') {
      //     this.model[key] = ''
      //   } else if (typeof (this.model[key]) == 'boolean') {
      //     this.model[key] = false
      //   } else {
      //     this.model[key] = ''
      //   }
      // }

      this.clearErrors();
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();
      for (var key in this.model) {
        if (!this.model[key] && typeof this.model[key] == 'string') {
          this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory');
        }
      }

      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return LocationBaseController;
}(_commonBase2.default);

exports.default = LocationBaseController;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TNTBillingBase = function () {
	function TNTBillingBase() {
		(0, _classCallCheck3.default)(this, TNTBillingBase);
	}

	(0, _createClass3.default)(TNTBillingBase, [{
		key: '$onInit',
		value: function $onInit() {
			if (this.$state.current.name === '' + this.id) {
				this.$state.go(this.id + '.all', { page: 1 });
			}
		}
	}, {
		key: 'goToAll',
		value: function goToAll() {
			this.$state.go(this.id + '.all', {
				page: 1
			});
		}
	}]);
	return TNTBillingBase;
}();

exports.default = TNTBillingBase;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module params
 */ /** for typedoc */
var common_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(26);
var predicates_1 = __webpack_require__(21);
var coreservices_1 = __webpack_require__(40);
var paramType_1 = __webpack_require__(181);
/** @hidden */ var hasOwn = Object.prototype.hasOwnProperty;
/** @hidden */ var isShorthand = function (cfg) {
    return ["value", "type", "squash", "array", "dynamic"].filter(hasOwn.bind(cfg || {})).length === 0;
};
/** @internalapi */
var DefType;
(function (DefType) {
    DefType[DefType["PATH"] = 0] = "PATH";
    DefType[DefType["SEARCH"] = 1] = "SEARCH";
    DefType[DefType["CONFIG"] = 2] = "CONFIG";
})(DefType = exports.DefType || (exports.DefType = {}));
/** @hidden */
function unwrapShorthand(cfg) {
    cfg = isShorthand(cfg) && { value: cfg } || cfg;
    getStaticDefaultValue['__cacheable'] = true;
    function getStaticDefaultValue() {
        return cfg.value;
    }
    return common_1.extend(cfg, {
        $$fn: predicates_1.isInjectable(cfg.value) ? cfg.value : getStaticDefaultValue,
    });
}
/** @hidden */
function getType(cfg, urlType, location, id, paramTypes) {
    if (cfg.type && urlType && urlType.name !== 'string')
        throw new Error("Param '" + id + "' has two type configurations.");
    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
        return paramTypes.type(cfg.type);
    if (urlType)
        return urlType;
    if (!cfg.type) {
        var type = location === DefType.CONFIG ? "any" :
            location === DefType.PATH ? "path" :
                location === DefType.SEARCH ? "query" : "string";
        return paramTypes.type(type);
    }
    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
}
/**
 * @internalapi
 * returns false, true, or the squash value to indicate the "default parameter url squash policy".
 */
function getSquashPolicy(config, isOptional, defaultPolicy) {
    var squash = config.squash;
    if (!isOptional || squash === false)
        return false;
    if (!predicates_1.isDefined(squash) || squash == null)
        return defaultPolicy;
    if (squash === true || predicates_1.isString(squash))
        return squash;
    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
}
/** @internalapi */
function getReplace(config, arrayMode, isOptional, squash) {
    var replace, configuredKeys, defaultPolicy = [
        { from: "", to: (isOptional || arrayMode ? undefined : "") },
        { from: null, to: (isOptional || arrayMode ? undefined : "") },
    ];
    replace = predicates_1.isArray(config.replace) ? config.replace : [];
    if (predicates_1.isString(squash))
        replace.push({ from: squash, to: undefined });
    configuredKeys = common_1.map(replace, hof_1.prop("from"));
    return common_1.filter(defaultPolicy, function (item) { return configuredKeys.indexOf(item.from) === -1; }).concat(replace);
}
/** @internalapi */
var Param = (function () {
    function Param(id, type, config, location, urlMatcherFactory) {
        config = unwrapShorthand(config);
        type = getType(config, type, location, id, urlMatcherFactory.paramTypes);
        var arrayMode = getArrayMode();
        type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
        var isOptional = config.value !== undefined || location === DefType.SEARCH;
        var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
        var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
        var squash = getSquashPolicy(config, isOptional, urlMatcherFactory.defaultSquashPolicy());
        var replace = getReplace(config, arrayMode, isOptional, squash);
        var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
        function getArrayMode() {
            var arrayDefaults = { array: (location === DefType.SEARCH ? "auto" : false) };
            var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
        }
        common_1.extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config });
    }
    Param.prototype.isDefaultValue = function (value) {
        return this.isOptional && this.type.equals(this.value(), value);
    };
    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    Param.prototype.value = function (value) {
        var _this = this;
        /**
         * [Internal] Get the default value of a parameter, which may be an injectable function.
         */
        var getDefaultValue = function () {
            if (_this._defaultValueCache)
                return _this._defaultValueCache.defaultValue;
            if (!coreservices_1.services.$injector)
                throw new Error("Injectable functions cannot be called at configuration time");
            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
                throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
            if (_this.config.$$fn['__cacheable']) {
                _this._defaultValueCache = { defaultValue: defaultValue };
            }
            return defaultValue;
        };
        var replaceSpecialValues = function (val) {
            for (var _i = 0, _a = _this.replace; _i < _a.length; _i++) {
                var tuple = _a[_i];
                if (tuple.from === val)
                    return tuple.to;
            }
            return val;
        };
        value = replaceSpecialValues(value);
        return predicates_1.isUndefined(value) ? getDefaultValue() : this.type.$normalize(value);
    };
    Param.prototype.isSearch = function () {
        return this.location === DefType.SEARCH;
    };
    Param.prototype.validates = function (value) {
        // There was no parameter value, but the param is optional
        if ((predicates_1.isUndefined(value) || value === null) && this.isOptional)
            return true;
        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
        var normalized = this.type.$normalize(value);
        if (!this.type.is(normalized))
            return false;
        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
        var encoded = this.type.encode(normalized);
        return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
    };
    Param.prototype.toString = function () {
        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
    };
    Param.values = function (params, values) {
        if (values === void 0) { values = {}; }
        var paramValues = {};
        for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
            var param = params_1[_i];
            paramValues[param.id] = param.value(values[param.id]);
        }
        return paramValues;
    };
    /**
     * Finds [[Param]] objects which have different param values
     *
     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
     *
     * @param params: The list of Param objects to filter
     * @param values1: The first set of parameter values
     * @param values2: the second set of parameter values
     *
     * @returns any Param objects whose values were different between values1 and values2
     */
    Param.changed = function (params, values1, values2) {
        if (values1 === void 0) { values1 = {}; }
        if (values2 === void 0) { values2 = {}; }
        return params.filter(function (param) { return !param.type.equals(values1[param.id], values2[param.id]); });
    };
    /**
     * Checks if two param value objects are equal (for a set of [[Param]] objects)
     *
     * @param params The list of [[Param]] objects to check
     * @param values1 The first set of param values
     * @param values2 The second set of param values
     *
     * @returns true if the param values in values1 and values2 are equal
     */
    Param.equals = function (params, values1, values2) {
        if (values1 === void 0) { values1 = {}; }
        if (values2 === void 0) { values2 = {}; }
        return Param.changed(params, values1, values2).length === 0;
    };
    /** Returns true if a the parameter values are valid, according to the Param definitions */
    Param.validates = function (params, values) {
        if (values === void 0) { values = {}; }
        return params.map(function (param) { return param.validates(values[param.id]); }).reduce(common_1.allTrueR, true);
    };
    return Param;
}());
exports.Param = Param;
//# sourceMappingURL=param.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TransitionHookPhase;
(function (TransitionHookPhase) {
    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
    TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
})(TransitionHookPhase = exports.TransitionHookPhase || (exports.TransitionHookPhase = {}));
var TransitionHookScope;
(function (TransitionHookScope) {
    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
})(TransitionHookScope = exports.TransitionHookScope || (exports.TransitionHookScope = {}));
//# sourceMappingURL=interface.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ng_from_import = __webpack_require__(12);
var ng_from_global = angular;
exports.ng = (ng_from_import && ng_from_import.module) ? ng_from_import : ng_from_global;
//# sourceMappingURL=angular.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(331);
var enumBugKeys = __webpack_require__(193);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(699);
var global = __webpack_require__(39);
var hide = __webpack_require__(84);
var Iterators = __webpack_require__(112);
var TO_STRING_TAG = __webpack_require__(42)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(62);
var TAG = __webpack_require__(25)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(31).f;
var has = __webpack_require__(55);
var TAG = __webpack_require__(25)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var defined = __webpack_require__(72);
var fails = __webpack_require__(17);
var spaces = __webpack_require__(229);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/undo-icon.png";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonTNTBillingBase = function CommonTNTBillingBase(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, CommonTNTBillingBase);

    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.Service = Service;
    this.Modal = Modal;
    this.$translate = $translate;
    this.$stateParams = $stateParams;
};

exports.default = CommonTNTBillingBase;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module resolve
 */ /** for typedoc */
var common_1 = __webpack_require__(15);
var coreservices_1 = __webpack_require__(40);
var trace_1 = __webpack_require__(83);
var strings_1 = __webpack_require__(82);
var predicates_1 = __webpack_require__(21);
// TODO: explicitly make this user configurable
exports.defaultResolvePolicy = {
    when: "LAZY",
    async: "WAIT"
};
/**
 * The basic building block for the resolve system.
 *
 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
 * and the unwrapped-when-complete (.data) result of the resolveFn.
 *
 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
 * resolveFn) and returns the resulting promise.
 *
 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
 * parameter to those fns.
 */
var Resolvable = (function () {
    function Resolvable(arg1, resolveFn, deps, policy, data) {
        this.resolved = false;
        this.promise = undefined;
        if (arg1 instanceof Resolvable) {
            common_1.extend(this, arg1);
        }
        else if (predicates_1.isFunction(resolveFn)) {
            if (arg1 == null || arg1 == undefined)
                throw new Error("new Resolvable(): token argument is required");
            if (!predicates_1.isFunction(resolveFn))
                throw new Error("new Resolvable(): resolveFn argument must be a function");
            this.token = arg1;
            this.policy = policy;
            this.resolveFn = resolveFn;
            this.deps = deps || [];
            this.data = data;
            this.resolved = data !== undefined;
            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
        }
        else if (predicates_1.isObject(arg1) && arg1.token && predicates_1.isFunction(arg1.resolveFn)) {
            var literal = arg1;
            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
        }
    }
    Resolvable.prototype.getPolicy = function (state) {
        var thisPolicy = this.policy || {};
        var statePolicy = state && state.resolvePolicy || {};
        return {
            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async,
        };
    };
    /**
     * Asynchronously resolve this Resolvable's data
     *
     * Given a ResolveContext that this Resolvable is found in:
     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
     * and update the Resolvable's state
     */
    Resolvable.prototype.resolve = function (resolveContext, trans) {
        var _this = this;
        var $q = coreservices_1.services.$q;
        // Gets all dependencies from ResolveContext and wait for them to be resolved
        var getResolvableDependencies = function () {
            return $q.all(resolveContext.getDependencies(_this).map(function (resolvable) {
                return resolvable.get(resolveContext, trans);
            }));
        };
        // Invokes the resolve function passing the resolved dependencies as arguments
        var invokeResolveFn = function (resolvedDeps) {
            return _this.resolveFn.apply(null, resolvedDeps);
        };
        /**
         * For RXWAIT policy:
         *
         * Given an observable returned from a resolve function:
         * - enables .cache() mode (this allows multicast subscribers)
         * - then calls toPromise() (this triggers subscribe() and thus fetches)
         * - Waits for the promise, then return the cached observable (not the first emitted value).
         */
        var waitForRx = function (observable$) {
            var cached = observable$.cache(1);
            return cached.take(1).toPromise().then(function () { return cached; });
        };
        // If the resolve policy is RXWAIT, wait for the observable to emit something. otherwise pass through.
        var node = resolveContext.findNode(this);
        var state = node && node.state;
        var maybeWaitForRx = this.getPolicy(state).async === "RXWAIT" ? waitForRx : common_1.identity;
        // After the final value has been resolved, update the state of the Resolvable
        var applyResolvedValue = function (resolvedValue) {
            _this.data = resolvedValue;
            _this.resolved = true;
            trace_1.trace.traceResolvableResolved(_this, trans);
            return _this.data;
        };
        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
        return this.promise = $q.when()
            .then(getResolvableDependencies)
            .then(invokeResolveFn)
            .then(maybeWaitForRx)
            .then(applyResolvedValue);
    };
    /**
     * Gets a promise for this Resolvable's data.
     *
     * Fetches the data and returns a promise.
     * Returns the existing promise if it has already been fetched once.
     */
    Resolvable.prototype.get = function (resolveContext, trans) {
        return this.promise || this.resolve(resolveContext, trans);
    };
    Resolvable.prototype.toString = function () {
        return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
    };
    Resolvable.prototype.clone = function () {
        return new Resolvable(this);
    };
    return Resolvable;
}());
Resolvable.fromData = function (token, data) {
    return new Resolvable(token, function () { return data; }, null, null, data);
};
exports.Resolvable = Resolvable;
//# sourceMappingURL=resolvable.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module transition
 */ /** for typedoc */

Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(15);
var strings_1 = __webpack_require__(82);
var hof_1 = __webpack_require__(26);
var RejectType;
(function (RejectType) {
    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
    RejectType[RejectType["INVALID"] = 4] = "INVALID";
    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
    RejectType[RejectType["ERROR"] = 6] = "ERROR";
})(RejectType = exports.RejectType || (exports.RejectType = {}));
/** @hidden */ var id = 0;
var Rejection = (function () {
    function Rejection(type, message, detail) {
        this.$id = id++;
        this.type = type;
        this.message = message;
        this.detail = detail;
    }
    Rejection.prototype.toString = function () {
        var detailString = function (d) {
            return d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d);
        };
        var detail = detailString(this.detail);
        var _a = this, $id = _a.$id, type = _a.type, message = _a.message;
        return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
    };
    Rejection.prototype.toPromise = function () {
        return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
    };
    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
    Rejection.isRejectionPromise = function (obj) {
        return obj && (typeof obj.then === 'function') && hof_1.is(Rejection)(obj._transitionRejection);
    };
    /** Returns a Rejection due to transition superseded */
    Rejection.superseded = function (detail, options) {
        var message = "The transition has been superseded by a different transition";
        var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
        if (options && options.redirected) {
            rejection.redirected = true;
        }
        return rejection;
    };
    /** Returns a Rejection due to redirected transition */
    Rejection.redirected = function (detail) {
        return Rejection.superseded(detail, { redirected: true });
    };
    /** Returns a Rejection due to invalid transition */
    Rejection.invalid = function (detail) {
        var message = "This transition is invalid";
        return new Rejection(RejectType.INVALID, message, detail);
    };
    /** Returns a Rejection due to ignored transition */
    Rejection.ignored = function (detail) {
        var message = "The transition was ignored";
        return new Rejection(RejectType.IGNORED, message, detail);
    };
    /** Returns a Rejection due to aborted transition */
    Rejection.aborted = function (detail) {
        var message = "The transition has been aborted";
        return new Rejection(RejectType.ABORTED, message, detail);
    };
    /** Returns a Rejection due to aborted transition */
    Rejection.errored = function (detail) {
        var message = "The transition errored";
        return new Rejection(RejectType.ERROR, message, detail);
    };
    /**
     * Returns a Rejection
     *
     * Normalizes a value as a Rejection.
     * If the value is already a Rejection, returns it.
     * Otherwise, wraps and returns the value as a Rejection (Rejection type: ERROR).
     *
     * @returns `detail` if it is already a `Rejection`, else returns an ERROR Rejection.
     */
    Rejection.normalize = function (detail) {
        return hof_1.is(Rejection)(detail) ? detail : Rejection.errored(detail);
    };
    return Rejection;
}());
exports.Rejection = Rejection;
//# sourceMappingURL=rejectFactory.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module transition
 */
/** for typedoc */
var interface_1 = __webpack_require__(110);
var common_1 = __webpack_require__(15);
var strings_1 = __webpack_require__(82);
var predicates_1 = __webpack_require__(21);
var hof_1 = __webpack_require__(26);
var trace_1 = __webpack_require__(83);
var coreservices_1 = __webpack_require__(40);
var rejectFactory_1 = __webpack_require__(123);
var targetState_1 = __webpack_require__(90);
var defaultOptions = {
    current: common_1.noop,
    transition: null,
    traceData: {},
    bind: null,
};
/** @hidden */
var TransitionHook = (function () {
    function TransitionHook(transition, stateContext, registeredHook, options) {
        var _this = this;
        this.transition = transition;
        this.stateContext = stateContext;
        this.registeredHook = registeredHook;
        this.options = options;
        this.isSuperseded = function () {
            return _this.type.hookPhase === interface_1.TransitionHookPhase.RUN && !_this.options.transition.isActive();
        };
        this.options = common_1.defaults(options, defaultOptions);
        this.type = registeredHook.eventType;
    }
    TransitionHook.prototype.logError = function (err) {
        this.transition.router.stateService.defaultErrorHandler()(err);
    };
    TransitionHook.prototype.invokeHook = function () {
        var _this = this;
        var hook = this.registeredHook;
        if (hook._deregistered)
            return;
        var notCurrent = this.getNotCurrentRejection();
        if (notCurrent)
            return notCurrent;
        var options = this.options;
        trace_1.trace.traceHookInvocation(this, this.transition, options);
        var invokeCallback = function () {
            return hook.callback.call(options.bind, _this.transition, _this.stateContext);
        };
        var normalizeErr = function (err) {
            return rejectFactory_1.Rejection.normalize(err).toPromise();
        };
        var handleError = function (err) {
            return hook.eventType.getErrorHandler(_this)(err);
        };
        var handleResult = function (result) {
            return hook.eventType.getResultHandler(_this)(result);
        };
        try {
            var result = invokeCallback();
            if (!this.type.synchronous && predicates_1.isPromise(result)) {
                return result.catch(normalizeErr)
                    .then(handleResult, handleError);
            }
            else {
                return handleResult(result);
            }
        }
        catch (err) {
            // If callback throws (synchronously)
            return handleError(rejectFactory_1.Rejection.normalize(err));
        }
    };
    /**
     * This method handles the return value of a Transition Hook.
     *
     * A hook can return false (cancel), a TargetState (redirect),
     * or a promise (which may later resolve to false or a redirect)
     *
     * This also handles "transition superseded" -- when a new transition
     * was started while the hook was still running
     */
    TransitionHook.prototype.handleHookResult = function (result) {
        var _this = this;
        var notCurrent = this.getNotCurrentRejection();
        if (notCurrent)
            return notCurrent;
        // Hook returned a promise
        if (predicates_1.isPromise(result)) {
            // Wait for the promise, then reprocess with the resulting value
            return result.then(function (val) { return _this.handleHookResult(val); });
        }
        trace_1.trace.traceHookResult(result, this.transition, this.options);
        // Hook returned false
        if (result === false) {
            // Abort this Transition
            return rejectFactory_1.Rejection.aborted("Hook aborted transition").toPromise();
        }
        var isTargetState = hof_1.is(targetState_1.TargetState);
        // hook returned a TargetState
        if (isTargetState(result)) {
            // Halt the current Transition and redirect (a new Transition) to the TargetState.
            return rejectFactory_1.Rejection.redirected(result).toPromise();
        }
    };
    /**
     * Return a Rejection promise if the transition is no longer current due
     * to a stopped router (disposed), or a new transition has started and superseded this one.
     */
    TransitionHook.prototype.getNotCurrentRejection = function () {
        var router = this.transition.router;
        // The router is stopped
        if (router._disposed) {
            return rejectFactory_1.Rejection.aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
        }
        if (this.transition._aborted) {
            return rejectFactory_1.Rejection.aborted().toPromise();
        }
        // This transition is no longer current.
        // Another transition started while this hook was still running.
        if (this.isSuperseded()) {
            // Abort this transition
            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
        }
    };
    TransitionHook.prototype.toString = function () {
        var _a = this, options = _a.options, registeredHook = _a.registeredHook;
        var event = hof_1.parse("traceData.hookType")(options) || "internal", context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown", name = strings_1.fnToString(registeredHook.callback);
        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
    };
    /**
     * Chains together an array of TransitionHooks.
     *
     * Given a list of [[TransitionHook]] objects, chains them together.
     * Each hook is invoked after the previous one completes.
     *
     * #### Example:
     * ```js
     * var hooks: TransitionHook[] = getHooks();
     * let promise: Promise<any> = TransitionHook.chain(hooks);
     *
     * promise.then(handleSuccess, handleError);
     * ```
     *
     * @param hooks the list of hooks to chain together
     * @param waitFor if provided, the chain is `.then()`'ed off this promise
     * @returns a `Promise` for sequentially invoking the hooks (in order)
     */
    TransitionHook.chain = function (hooks, waitFor) {
        // Chain the next hook off the previous
        var createHookChainR = function (prev, nextHook) {
            return prev.then(function () { return nextHook.invokeHook(); });
        };
        return hooks.reduce(createHookChainR, waitFor || coreservices_1.services.$q.when());
    };
    /**
     * Invokes all the provided TransitionHooks, in order.
     * Each hook's return value is checked.
     * If any hook returns a promise, then the rest of the hooks are chained off that promise, and the promise is returned.
     * If no hook returns a promise, then all hooks are processed synchronously.
     *
     * @param hooks the list of TransitionHooks to invoke
     * @param doneCallback a callback that is invoked after all the hooks have successfully completed
     *
     * @returns a promise for the async result, or the result of the callback
     */
    TransitionHook.invokeHooks = function (hooks, doneCallback) {
        for (var idx = 0; idx < hooks.length; idx++) {
            var hookResult = hooks[idx].invokeHook();
            if (predicates_1.isPromise(hookResult)) {
                var remainingHooks = hooks.slice(idx + 1);
                return TransitionHook.chain(remainingHooks, hookResult)
                    .then(doneCallback);
            }
        }
        return doneCallback();
    };
    /**
     * Run all TransitionHooks, ignoring their return value.
     */
    TransitionHook.runAllHooks = function (hooks) {
        hooks.forEach(function (hook) { return hook.invokeHook(); });
    };
    return TransitionHook;
}());
/**
 * These GetResultHandler(s) are used by [[invokeHook]] below
 * Each HookType chooses a GetResultHandler (See: [[TransitionService._defineCoreEvents]])
 */
TransitionHook.HANDLE_RESULT = function (hook) { return function (result) {
    return hook.handleHookResult(result);
}; };
/**
 * If the result is a promise rejection, log it.
 * Otherwise, ignore the result.
 */
TransitionHook.LOG_REJECTED_RESULT = function (hook) { return function (result) {
    predicates_1.isPromise(result) && result.catch(function (err) {
        return hook.logError(rejectFactory_1.Rejection.normalize(err));
    });
    return undefined;
}; };
/**
 * These GetErrorHandler(s) are used by [[invokeHook]] below
 * Each HookType chooses a GetErrorHandler (See: [[TransitionService._defineCoreEvents]])
 */
TransitionHook.LOG_ERROR = function (hook) { return function (error) {
    return hook.logError(error);
}; };
TransitionHook.REJECT_ERROR = function (hook) { return function (error) {
    return common_1.silentRejection(error);
}; };
TransitionHook.THROW_ERROR = function (hook) { return function (error) {
    throw error;
}; };
exports.TransitionHook = TransitionHook;
//# sourceMappingURL=transitionHook.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var index_1 = __webpack_require__(145);
var common_1 = __webpack_require__(15);
var beforeAfterSubstr = function (char) { return function (str) {
    if (!str)
        return ["", ""];
    var idx = str.indexOf(char);
    if (idx === -1)
        return [str, ""];
    return [str.substr(0, idx), str.substr(idx + 1)];
}; };
exports.splitHash = beforeAfterSubstr("#");
exports.splitQuery = beforeAfterSubstr("?");
exports.splitEqual = beforeAfterSubstr("=");
exports.trimHashVal = function (str) { return str ? str.replace(/^#/, "") : ""; };
exports.keyValsToObjectR = function (accum, _a) {
    var key = _a[0], val = _a[1];
    if (!accum.hasOwnProperty(key)) {
        accum[key] = val;
    }
    else if (index_1.isArray(accum[key])) {
        accum[key].push(val);
    }
    else {
        accum[key] = [accum[key], val];
    }
    return accum;
};
exports.getParams = function (queryString) {
    return queryString.split("&").filter(common_1.identity).map(exports.splitEqual).reduce(exports.keyValsToObjectR, {});
};
function parseUrl(url) {
    var orEmptyString = function (x) { return x || ""; };
    var _a = exports.splitHash(url).map(orEmptyString), beforehash = _a[0], hash = _a[1];
    var _b = exports.splitQuery(beforehash).map(orEmptyString), path = _b[0], search = _b[1];
    return { path: path, search: search, hash: hash, url: url };
}
exports.parseUrl = parseUrl;
exports.buildUrl = function (loc) {
    var path = loc.path();
    var searchObject = loc.search();
    var hash = loc.hash();
    var search = Object.keys(searchObject).map(function (key) {
        var param = searchObject[key];
        var vals = index_1.isArray(param) ? param : [param];
        return vals.map(function (val) { return key + "=" + val; });
    }).reduce(common_1.unnestR, []).join("&");
    return path + (search ? "?" + search : "") + (hash ? "#" + hash : "");
};
function locationPluginFactory(name, isHtml5, serviceClass, configurationClass) {
    return function (router) {
        var service = router.locationService = new serviceClass(router);
        var configuration = router.locationConfig = new configurationClass(router, isHtml5);
        function dispose(router) {
            router.dispose(service);
            router.dispose(configuration);
        }
        return { name: name, service: service, configuration: configuration, dispose: dispose };
    };
}
exports.locationPluginFactory = locationPluginFactory;
//# sourceMappingURL=utils.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(77);
var call = __webpack_require__(326);
var isArrayIter = __webpack_require__(324);
var anObject = __webpack_require__(70);
var toLength = __webpack_require__(157);
var getIterFn = __webpack_require__(207);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(61).f;
var has = __webpack_require__(92);
var TAG = __webpack_require__(42)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(11);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(62);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 135 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(63);
var global = __webpack_require__(16);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(87) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(11);
var aFunction = __webpack_require__(43);
var SPECIES = __webpack_require__(25)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/P-grey-icon.png";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-1-print.png";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-10-print.png";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-25-print.png";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-5-print.png";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-50-print.png";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module core
 */
/**
 * Matches state names using glob-like pattern strings.
 *
 * Globs can be used in specific APIs including:
 *
 * - [[StateService.is]]
 * - [[StateService.includes]]
 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
 *
 * A `Glob` string is a pattern which matches state names.
 * Nested state names are split into segments (separated by a dot) when processing.
 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
 *
 * Globs work according to the following rules:
 *
 * ### Exact match:
 *
 * The glob `'A.B'` matches the state named exactly `'A.B'`.
 *
 * | Glob        |Matches states named|Does not match state named|
 * |:------------|:--------------------|:---------------------|
 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
 *
 * ### Single star (`*`)
 *
 * A single star (`*`) is a wildcard that matches exactly one segment.
 *
 * | Glob        |Matches states named  |Does not match state named |
 * |:------------|:---------------------|:--------------------------|
 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
 *
 * ### Double star (`**`)
 *
 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
 *
 * | Glob        |Matches states named                           |Does not match state named         |
 * |:------------|:----------------------------------------------|:----------------------------------|
 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
 *
 */
var Glob = (function () {
    function Glob(text) {
        this.text = text;
        this.glob = text.split('.');
        var regexpString = this.text.split('.')
            .map(function (seg) {
            if (seg === '**')
                return '(?:|(?:\\.[^.]*)*)';
            if (seg === '*')
                return '\\.[^.]*';
            return '\\.' + seg;
        }).join('');
        this.regexp = new RegExp("^" + regexpString + "$");
    }
    Glob.prototype.matches = function (name) {
        return this.regexp.test('.' + name);
    };
    /** Returns true if the string has glob-like characters in it */
    Glob.is = function (text) {
        return !!/[!,*]+/.exec(text);
    };
    /** Returns a glob from the string, or null if the string isn't Glob-like */
    Glob.fromString = function (text) {
        return Glob.is(text) ? new Glob(text) : null;
    };
    return Glob;
}());
exports.Glob = Glob;
//# sourceMappingURL=glob.js.map

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/** @module common */ /** for typedoc */
__export(__webpack_require__(15));
__export(__webpack_require__(40));
__export(__webpack_require__(144));
__export(__webpack_require__(26));
__export(__webpack_require__(21));
__export(__webpack_require__(180));
__export(__webpack_require__(82));
__export(__webpack_require__(83));
//# sourceMappingURL=index.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module path */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(26);
var targetState_1 = __webpack_require__(90);
var pathNode_1 = __webpack_require__(182);
/**
 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
 */
var PathUtils = (function () {
    function PathUtils() {
    }
    /** Given a PathNode[], create an TargetState */
    PathUtils.makeTargetState = function (path) {
        var state = common_1.tail(path).state;
        return new targetState_1.TargetState(state, state, path.map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {}));
    };
    PathUtils.buildPath = function (targetState) {
        var toParams = targetState.params();
        return targetState.$state().path.map(function (state) { return new pathNode_1.PathNode(state).applyRawParams(toParams); });
    };
    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
    PathUtils.buildToPath = function (fromPath, targetState) {
        var toPath = PathUtils.buildPath(targetState);
        if (targetState.options().inherit) {
            return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
        }
        return toPath;
    };
    /**
     * Creates ViewConfig objects and adds to nodes.
     *
     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
     */
    PathUtils.applyViewConfigs = function ($view, path, states) {
        // Only apply the viewConfigs to the nodes for the given states
        path.filter(function (node) { return common_1.inArray(states, node.state); }).forEach(function (node) {
            var viewDecls = common_1.values(node.state.views || {});
            var subPath = PathUtils.subPath(path, function (n) { return n === node; });
            var viewConfigs = viewDecls.map(function (view) { return $view.createViewConfig(subPath, view); });
            node.views = viewConfigs.reduce(common_1.unnestR, []);
        });
    };
    /**
     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
     *
     * For a parameter in a node to be inherited from the from path:
     * - The toPath's node must have a matching node in the fromPath (by state).
     * - The parameter name must not be found in the toKeys parameter array.
     *
     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
     * it is not inherited from the fromPath.
     */
    PathUtils.inheritParams = function (fromPath, toPath, toKeys) {
        if (toKeys === void 0) { toKeys = []; }
        function nodeParamVals(path, state) {
            var node = common_1.find(path, hof_1.propEq('state', state));
            return common_1.extend({}, node && node.paramValues);
        }
        var noInherit = fromPath.map(function (node) { return node.paramSchema; })
            .reduce(common_1.unnestR, [])
            .filter(function (param) { return !param.inherit; })
            .map(hof_1.prop('id'));
        /**
         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
         */
        function makeInheritedParamsNode(toNode) {
            // All param values for the node (may include default key/vals, when key was not found in toParams)
            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
            // limited to only those keys found in toParams
            var incomingParamVals = common_1.pick(toParamVals, toKeys);
            toParamVals = common_1.omit(toParamVals, toKeys);
            var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
            return new pathNode_1.PathNode(toNode.state).applyRawParams(ownParamVals);
        }
        // The param keys specified by the incoming toParams
        return toPath.map(makeInheritedParamsNode);
    };
    /**
     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
     */
    PathUtils.treeChanges = function (fromPath, toPath, reloadState) {
        var keep = 0, max = Math.min(fromPath.length, toPath.length);
        var nodesMatch = function (node1, node2) {
            return node1.equals(node2, PathUtils.nonDynamicParams);
        };
        while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
            keep++;
        }
        /** Given a retained node, return a new node which uses the to node's param values */
        function applyToParams(retainedNode, idx) {
            var cloned = pathNode_1.PathNode.clone(retainedNode);
            cloned.paramValues = toPath[idx].paramValues;
            return cloned;
        }
        var from, retained, exiting, entering, to;
        from = fromPath;
        retained = from.slice(0, keep);
        exiting = from.slice(keep);
        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
        var retainedWithToParams = retained.map(applyToParams);
        entering = toPath.slice(keep);
        to = (retainedWithToParams).concat(entering);
        return { from: from, to: to, retained: retained, exiting: exiting, entering: entering };
    };
    /**
     * Returns a new path which is: the subpath of the first path which matches the second path.
     *
     * The new path starts from root and contains any nodes that match the nodes in the second path.
     * It stops before the first non-matching node.
     *
     * Nodes are compared using their state property and their parameter values.
     * If a `paramsFn` is provided, only the [[Param]] returned by the function will be considered when comparing nodes.
     *
     * @param pathA the first path
     * @param pathB the second path
     * @param paramsFn a function which returns the parameters to consider when comparing
     *
     * @returns an array of PathNodes from the first path which match the nodes in the second path
     */
    PathUtils.matching = function (pathA, pathB, paramsFn) {
        var done = false;
        var tuples = common_1.arrayTuples(pathA, pathB);
        return tuples.reduce(function (matching, _a) {
            var nodeA = _a[0], nodeB = _a[1];
            done = done || !nodeA.equals(nodeB, paramsFn);
            return done ? matching : matching.concat(nodeA);
        }, []);
    };
    /**
     * Returns true if two paths are identical.
     *
     * @param pathA
     * @param pathB
     * @param paramsFn a function which returns the parameters to consider when comparing
     * @returns true if the the states and parameter values for both paths are identical
     */
    PathUtils.equals = function (pathA, pathB, paramsFn) {
        return pathA.length === pathB.length &&
            PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
    };
    /**
     * Return a subpath of a path, which stops at the first matching node
     *
     * Given an array of nodes, returns a subset of the array starting from the first node,
     * stopping when the first node matches the predicate.
     *
     * @param path a path of [[PathNode]]s
     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
     * @returns a subpath up to the matching node, or undefined if no match is found
     */
    PathUtils.subPath = function (path, predicate) {
        var node = common_1.find(path, predicate);
        var elementIdx = path.indexOf(node);
        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
    };
    return PathUtils;
}());
PathUtils.nonDynamicParams = function (node) {
    return node.state.parameters({ inherit: false })
        .filter(function (param) { return !param.dynamic; });
};
/** Gets the raw parameter values from a path */
PathUtils.paramValues = function (path) {
    return path.reduce(function (acc, node) { return common_1.extend(acc, node.paramValues); }, {});
};
exports.PathUtils = PathUtils;
//# sourceMappingURL=pathFactory.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module resolve */
/** for typedoc */
var common_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(26);
var trace_1 = __webpack_require__(83);
var coreservices_1 = __webpack_require__(40);
var interface_1 = __webpack_require__(291);
var resolvable_1 = __webpack_require__(122);
var pathFactory_1 = __webpack_require__(146);
var strings_1 = __webpack_require__(82);
var when = interface_1.resolvePolicies.when;
var ALL_WHENS = [when.EAGER, when.LAZY];
var EAGER_WHENS = [when.EAGER];
exports.NATIVE_INJECTOR_TOKEN = "Native Injector";
/**
 * Encapsulates Dependency Injection for a path of nodes
 *
 * UI-Router states are organized as a tree.
 * A nested state has a path of ancestors to the root of the tree.
 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
 *
 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
 */
var ResolveContext = (function () {
    function ResolveContext(_path) {
        this._path = _path;
    }
    /** Gets all the tokens found in the resolve context, de-duplicated */
    ResolveContext.prototype.getTokens = function () {
        return this._path.reduce(function (acc, node) { return acc.concat(node.resolvables.map(function (r) { return r.token; })); }, []).reduce(common_1.uniqR, []);
    };
    /**
     * Gets the Resolvable that matches the token
     *
     * Gets the last Resolvable that matches the token in this context, or undefined.
     * Throws an error if it doesn't exist in the ResolveContext
     */
    ResolveContext.prototype.getResolvable = function (token) {
        var matching = this._path.map(function (node) { return node.resolvables; })
            .reduce(common_1.unnestR, [])
            .filter(function (r) { return r.token === token; });
        return common_1.tail(matching);
    };
    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
    ResolveContext.prototype.getPolicy = function (resolvable) {
        var node = this.findNode(resolvable);
        return resolvable.getPolicy(node.state);
    };
    /**
     * Returns a ResolveContext that includes a portion of this one
     *
     * Given a state, this method creates a new ResolveContext from this one.
     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
     *
     * #### Why
     *
     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
     * This method is used to create a narrower context when injecting ancestor nodes.
     *
     * @example
     * `let ABCD = new ResolveContext([A, B, C, D]);`
     *
     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
     * However, `B` should only be able to access resolvables from `A`, `B`.
     *
     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
     * `let AB = ABCD.subcontext(a)`
     */
    ResolveContext.prototype.subContext = function (state) {
        return new ResolveContext(pathFactory_1.PathUtils.subPath(this._path, function (node) { return node.state === state; }));
    };
    /**
     * Adds Resolvables to the node that matches the state
     *
     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
     * The resolvable is added to the node matching the `state` parameter.
     *
     * These new resolvables are not automatically fetched.
     * The calling code should either fetch them, fetch something that depends on them,
     * or rely on [[resolvePath]] being called when some state is being entered.
     *
     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
     *
     * @param newResolvables the new Resolvables
     * @param state Used to find the node to put the resolvable on
     */
    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
        var node = common_1.find(this._path, hof_1.propEq('state', state));
        var keys = newResolvables.map(function (r) { return r.token; });
        node.resolvables = node.resolvables.filter(function (r) { return keys.indexOf(r.token) === -1; }).concat(newResolvables);
    };
    /**
     * Returns a promise for an array of resolved path Element promises
     *
     * @param when
     * @param trans
     * @returns {Promise<any>|any}
     */
    ResolveContext.prototype.resolvePath = function (when, trans) {
        var _this = this;
        if (when === void 0) { when = "LAZY"; }
        // This option determines which 'when' policy Resolvables we are about to fetch.
        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : "LAZY";
        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
        // get the subpath to the state argument, if provided
        trace_1.trace.traceResolvePath(this._path, when, trans);
        var matchesPolicy = function (acceptedVals, whenOrAsync) {
            return function (resolvable) {
                return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
            };
        };
        // Trigger all the (matching) Resolvables in the path
        // Reduce all the "WAIT" Resolvables into an array
        var promises = this._path.reduce(function (acc, node) {
            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
            var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
            var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
            // For the matching Resolvables, start their async fetch process.
            var subContext = _this.subContext(node.state);
            var getResult = function (r) { return r.get(subContext, trans)
                .then(function (value) { return ({ token: r.token, value: value }); }); };
            nowait.forEach(getResult);
            return acc.concat(wait.map(getResult));
        }, []);
        // Wait for all the "WAIT" resolvables
        return coreservices_1.services.$q.all(promises);
    };
    ResolveContext.prototype.injector = function () {
        return this._injector || (this._injector = new UIInjectorImpl(this));
    };
    ResolveContext.prototype.findNode = function (resolvable) {
        return common_1.find(this._path, function (node) { return common_1.inArray(node.resolvables, resolvable); });
    };
    /**
     * Gets the async dependencies of a Resolvable
     *
     * Given a Resolvable, returns its dependencies as a Resolvable[]
     */
    ResolveContext.prototype.getDependencies = function (resolvable) {
        var _this = this;
        var node = this.findNode(resolvable);
        // Find which other resolvables are "visible" to the `resolvable` argument
        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
        var subPath = pathFactory_1.PathUtils.subPath(this._path, function (x) { return x === node; }) || this._path;
        var availableResolvables = subPath
            .reduce(function (acc, node) { return acc.concat(node.resolvables); }, []) //all of subpath's resolvables
            .filter(function (res) { return res !== resolvable; }); // filter out the `resolvable` argument
        var getDependency = function (token) {
            var matching = availableResolvables.filter(function (r) { return r.token === token; });
            if (matching.length)
                return common_1.tail(matching);
            var fromInjector = _this.injector().getNative(token);
            if (!fromInjector) {
                throw new Error("Could not find Dependency Injection token: " + strings_1.stringify(token));
            }
            return new resolvable_1.Resolvable(token, function () { return fromInjector; }, [], fromInjector);
        };
        return resolvable.deps.map(getDependency);
    };
    return ResolveContext;
}());
exports.ResolveContext = ResolveContext;
var UIInjectorImpl = (function () {
    function UIInjectorImpl(context) {
        this.context = context;
        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
    }
    UIInjectorImpl.prototype.get = function (token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable) {
            if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
                return resolvable.get(this.context);
            }
            if (!resolvable.resolved) {
                throw new Error("Resolvable async .get() not complete:" + strings_1.stringify(resolvable.token));
            }
            return resolvable.data;
        }
        return this.native && this.native.get(token);
    };
    UIInjectorImpl.prototype.getAsync = function (token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable)
            return resolvable.get(this.context);
        return coreservices_1.services.$q.when(this.native.get(token));
    };
    UIInjectorImpl.prototype.getNative = function (token) {
        return this.native && this.native.get(token);
    };
    return UIInjectorImpl;
}());
//# sourceMappingURL=resolveContext.js.map

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module transition
 */
/** for typedoc */
var trace_1 = __webpack_require__(83);
var coreservices_1 = __webpack_require__(40);
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
var hof_1 = __webpack_require__(26);
var interface_1 = __webpack_require__(110); // has or is using
var transitionHook_1 = __webpack_require__(124);
var hookRegistry_1 = __webpack_require__(184);
var hookBuilder_1 = __webpack_require__(298);
var pathFactory_1 = __webpack_require__(146);
var targetState_1 = __webpack_require__(90);
var param_1 = __webpack_require__(109);
var resolvable_1 = __webpack_require__(122);
var resolveContext_1 = __webpack_require__(147);
/** @hidden */
var stateSelf = hof_1.prop("self");
/**
 * Represents a transition between two states.
 *
 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
 *
 * This object contains all contextual information about the to/from states, parameters, resolves.
 * It has information about all states being entered and exited as a result of the transition.
 */
var Transition = (function () {
    /**
     * Creates a new Transition object.
     *
     * If the target state is not valid, an error is thrown.
     *
     * @internalapi
     *
     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
     *        encapsulates the "from state".
     * @param targetState The target state and parameters being transitioned to (also, the transition options)
     * @param router The [[UIRouter]] instance
     */
    function Transition(fromPath, targetState, router) {
        var _this = this;
        /** @hidden */
        this._deferred = coreservices_1.services.$q.defer();
        /**
         * This promise is resolved or rejected based on the outcome of the Transition.
         *
         * When the transition is successful, the promise is resolved
         * When the transition is unsuccessful, the promise is rejected with the [[Rejection]] or javascript error
         */
        this.promise = this._deferred.promise;
        /** @hidden Holds the hook registration functions such as those passed to Transition.onStart() */
        this._registeredHooks = {};
        /** @hidden */
        this._hookBuilder = new hookBuilder_1.HookBuilder(this);
        /** Checks if this transition is currently active/running. */
        this.isActive = function () {
            return _this.router.globals.transition === _this;
        };
        this.router = router;
        this._targetState = targetState;
        if (!targetState.valid()) {
            throw new Error(targetState.error());
        }
        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
        this.$id = router.transitionService._transitionCount++;
        var toPath = pathFactory_1.PathUtils.buildToPath(fromPath, targetState);
        this._treeChanges = pathFactory_1.PathUtils.treeChanges(fromPath, toPath, this._options.reloadState);
        this.createTransitionHookRegFns();
        var onCreateHooks = this._hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
        transitionHook_1.TransitionHook.invokeHooks(onCreateHooks, function () { return null; });
        this.applyViewConfigs(router);
    }
    /** @hidden */
    Transition.prototype.onBefore = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onStart = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onExit = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onRetain = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onEnter = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onFinish = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onSuccess = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onError = function (criteria, callback, options) { return; };
    /** @hidden
     * Creates the transition-level hook registration functions
     * (which can then be used to register hooks)
     */
    Transition.prototype.createTransitionHookRegFns = function () {
        var _this = this;
        this.router.transitionService._pluginapi._getEvents()
            .filter(function (type) { return type.hookPhase !== interface_1.TransitionHookPhase.CREATE; })
            .forEach(function (type) { return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type); });
    };
    /** @internalapi */
    Transition.prototype.getHooks = function (hookName) {
        return this._registeredHooks[hookName];
    };
    Transition.prototype.applyViewConfigs = function (router) {
        var enteringStates = this._treeChanges.entering.map(function (node) { return node.state; });
        pathFactory_1.PathUtils.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
    };
    /**
     * @internalapi
     *
     * @returns the internal from [State] object
     */
    Transition.prototype.$from = function () {
        return common_1.tail(this._treeChanges.from).state;
    };
    /**
     * @internalapi
     *
     * @returns the internal to [State] object
     */
    Transition.prototype.$to = function () {
        return common_1.tail(this._treeChanges.to).state;
    };
    /**
     * Returns the "from state"
     *
     * Returns the state that the transition is coming *from*.
     *
     * @returns The state declaration object for the Transition's ("from state").
     */
    Transition.prototype.from = function () {
        return this.$from().self;
    };
    /**
     * Returns the "to state"
     *
     * Returns the state that the transition is going *to*.
     *
     * @returns The state declaration object for the Transition's target state ("to state").
     */
    Transition.prototype.to = function () {
        return this.$to().self;
    };
    /**
     * Gets the Target State
     *
     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
     *
     * @returns the [[TargetState]] of this Transition
     */
    Transition.prototype.targetState = function () {
        return this._targetState;
    };
    /**
     * Determines whether two transitions are equivalent.
     * @deprecated
     */
    Transition.prototype.is = function (compare) {
        if (compare instanceof Transition) {
            // TODO: Also compare parameters
            return this.is({ to: compare.$to().name, from: compare.$from().name });
        }
        return !((compare.to && !hookRegistry_1.matchState(this.$to(), compare.to)) ||
            (compare.from && !hookRegistry_1.matchState(this.$from(), compare.from)));
    };
    Transition.prototype.params = function (pathname) {
        if (pathname === void 0) { pathname = "to"; }
        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {}));
    };
    /**
     * Creates a [[UIInjector]] Dependency Injector
     *
     * Returns a Dependency Injector for the Transition's target state (to state).
     * The injector provides resolve values which the target state has access to.
     *
     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
     *
     * #### Example:
     * ```js
     * .onEnter({ entering: 'myState' }, trans => {
     *   var myResolveValue = trans.injector().get('myResolve');
     *   // Inject a global service from the global/native injector (if it exists)
     *   var MyService = trans.injector().get('MyService');
     * })
     * ```
     *
     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
     * You can use [[UIInjector.getAsync]] to get a promise for the data.
     * #### Example:
     * ```js
     * .onBefore({}, trans => {
     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
     *     return myResolveValue !== 'ABORT';
     *   });
     * });
     * ```
     *
     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
     * #### Example:
     * ```js
     * .onEnter({ to: 'foo.bar' }, trans => {
     *   // returns result of `foo` state's `data` resolve
     *   // even though `foo.bar` also has a `data` resolve
     *   var fooData = trans.injector('foo').get('data');
     * });
     * ```
     *
     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
     * The resolve data from the `from` path will be returned.
     * #### Example:
     * ```js
     * .onExit({ exiting: 'foo.bar' }, trans => {
     *   // Gets the resolve value of `data` from the exiting state.
     *   var fooData = trans.injector(null, 'foo.bar').get('data');
     * });
     * ```
     *
     *
     * @param state Limits the resolves provided to only the resolves the provided state has access to.
     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
     *
     * @returns a [[UIInjector]]
     */
    Transition.prototype.injector = function (state, pathName) {
        if (pathName === void 0) { pathName = "to"; }
        var path = this._treeChanges[pathName];
        if (state)
            path = pathFactory_1.PathUtils.subPath(path, function (node) { return node.state === state || node.state.name === state; });
        return new resolveContext_1.ResolveContext(path).injector();
    };
    /**
     * Gets all available resolve tokens (keys)
     *
     * This method can be used in conjunction with [[injector]] to inspect the resolve values
     * available to the Transition.
     *
     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
     * in the Transition's [[TreeChanges.to]] path.
     *
     * #### Example:
     * This example logs all resolve values
     * ```js
     * let tokens = trans.getResolveTokens();
     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
     * ```
     *
     * #### Example:
     * This example creates promises for each resolve value.
     * This triggers fetches of resolves (if any have not yet been fetched).
     * When all promises have all settled, it logs the resolve values.
     * ```js
     * let tokens = trans.getResolveTokens();
     * let promise = tokens.map(token => trans.injector().getAsync(token));
     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
     * ```
     *
     * Note: Angular 1 users whould use `$q.all()`
     *
     * @param pathname resolve context's path name (e.g., `to` or `from`)
     *
     * @returns an array of resolve tokens (keys)
     */
    Transition.prototype.getResolveTokens = function (pathname) {
        if (pathname === void 0) { pathname = "to"; }
        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
    };
    /**
     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
     *
     * #### Example:
     * ```js
     * transitionService.onBefore({}, transition => {
     *   transition.addResolvable({
     *     token: 'myResolve',
     *     deps: ['MyService'],
     *     resolveFn: myService => myService.getData()
     *   });
     * });
     * ```
     *
     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
     */
    Transition.prototype.addResolvable = function (resolvable, state) {
        if (state === void 0) { state = ""; }
        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
        var stateName = (typeof state === "string") ? state : state.name;
        var topath = this._treeChanges.to;
        var targetNode = common_1.find(topath, function (node) { return node.state.name === stateName; });
        var resolveContext = new resolveContext_1.ResolveContext(topath);
        resolveContext.addResolvables([resolvable], targetNode.state);
    };
    /**
     * Gets the transition from which this transition was redirected.
     *
     * If the current transition is a redirect, this method returns the transition that was redirected.
     *
     * #### Example:
     * ```js
     * let transitionA = $state.go('A').transition
     * transitionA.onStart({}, () => $state.target('B'));
     * $transitions.onSuccess({ to: 'B' }, (trans) => {
     *   trans.to().name === 'B'; // true
     *   trans.redirectedFrom() === transitionA; // true
     * });
     * ```
     *
     * @returns The previous Transition, or null if this Transition is not the result of a redirection
     */
    Transition.prototype.redirectedFrom = function () {
        return this._options.redirectedFrom || null;
    };
    /**
     * Gets the original transition in a redirect chain
     *
     * A transition might belong to a long chain of multiple redirects.
     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
     *
     * #### Example:
     * ```js
     * // states
     * registry.register({ name: 'A', redirectTo: 'B' });
     * registry.register({ name: 'B', redirectTo: 'C' });
     * registry.register({ name: 'C', redirectTo: 'D' });
     * registry.register({ name: 'D' });
     *
     * let transitionA = $state.go('A').transition
     *
     * $transitions.onSuccess({ to: 'D' }, (trans) => {
     *   trans.to().name === 'D'; // true
     *   trans.redirectedFrom().to().name === 'C'; // true
     *   trans.originalTransition() === transitionA; // true
     *   trans.originalTransition().to().name === 'A'; // true
     * });
     * ```
     *
     * @returns The original Transition that started a redirect chain
     */
    Transition.prototype.originalTransition = function () {
        var rf = this.redirectedFrom();
        return (rf && rf.originalTransition()) || this;
    };
    /**
     * Get the transition options
     *
     * @returns the options for this Transition.
     */
    Transition.prototype.options = function () {
        return this._options;
    };
    /**
     * Gets the states being entered.
     *
     * @returns an array of states that will be entered during this transition.
     */
    Transition.prototype.entering = function () {
        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
    };
    /**
     * Gets the states being exited.
     *
     * @returns an array of states that will be exited during this transition.
     */
    Transition.prototype.exiting = function () {
        return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
    };
    /**
     * Gets the states being retained.
     *
     * @returns an array of states that are already entered from a previous Transition, that will not be
     *    exited during this Transition
     */
    Transition.prototype.retained = function () {
        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
    };
    /**
     * Get the [[ViewConfig]]s associated with this Transition
     *
     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
     *
     * @param pathname the name of the path to fetch views for:
     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
     *
     * @returns a list of ViewConfig objects for the given path.
     */
    Transition.prototype.views = function (pathname, state) {
        if (pathname === void 0) { pathname = "entering"; }
        var path = this._treeChanges[pathname];
        path = !state ? path : path.filter(hof_1.propEq('state', state));
        return path.map(hof_1.prop("views")).filter(common_1.identity).reduce(common_1.unnestR, []);
    };
    Transition.prototype.treeChanges = function (pathname) {
        return pathname ? this._treeChanges[pathname] : this._treeChanges;
    };
    /**
     * Creates a new transition that is a redirection of the current one.
     *
     * This transition can be returned from a [[TransitionService]] hook to
     * redirect a transition to a new state and/or set of parameters.
     *
     * @internalapi
     *
     * @returns Returns a new [[Transition]] instance.
     */
    Transition.prototype.redirect = function (targetState) {
        var redirects = 1, trans = this;
        while ((trans = trans.redirectedFrom()) != null) {
            if (++redirects > 20)
                throw new Error("Too many consecutive Transition redirects (20+)");
        }
        var redirectOpts = { redirectedFrom: this, source: "redirect" };
        // If the original transition was caused by URL sync, then use { location: 'replace' }
        // on the new transition (unless the target state explicitly specifies location: false).
        // This causes the original url to be replaced with the url for the redirect target
        // so the original url disappears from the browser history.
        if (this.options().source === 'url' && targetState.options().location !== false) {
            redirectOpts.location = 'replace';
        }
        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
        targetState = new targetState_1.TargetState(targetState.identifier(), targetState.$state(), targetState.params(), newOptions);
        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
        var originalEnteringNodes = this._treeChanges.entering;
        var redirectEnteringNodes = newTransition._treeChanges.entering;
        // --- Re-use resolve data from original transition ---
        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
        // (because of the redirect), the resolves fetched by the original transition are still valid in the
        // redirected transition.
        //
        // This allows you to define a redirect on a parent state which depends on an async resolve value.
        // You can wait for the resolve, then redirect to a child state based on the result.
        // The redirected transition does not have to re-fetch the resolve.
        // ---------------------------------------------------------
        var nodeIsReloading = function (reloadState) { return function (node) {
            return reloadState && node.state.includes[reloadState.name];
        }; };
        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
        var matchingEnteringNodes = pathFactory_1.PathUtils.matching(redirectEnteringNodes, originalEnteringNodes, pathFactory_1.PathUtils.nonDynamicParams)
            .filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
        matchingEnteringNodes.forEach(function (node, idx) {
            node.resolvables = originalEnteringNodes[idx].resolvables;
        });
        return newTransition;
    };
    /** @hidden If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
    Transition.prototype._changedParams = function () {
        var tc = this._treeChanges;
        /** Return undefined if it's not a "dynamic" transition, for the following reasons */
        // If user explicitly wants a reload
        if (this._options.reload)
            return undefined;
        // If any states are exiting or entering
        if (tc.exiting.length || tc.entering.length)
            return undefined;
        // If to/from path lengths differ
        if (tc.to.length !== tc.from.length)
            return undefined;
        // If the to/from paths are different
        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from)
            .map(function (tuple) { return tuple[0].state !== tuple[1].state; })
            .reduce(common_1.anyTrueR, false);
        if (pathsDiffer)
            return undefined;
        // Find any parameter values that differ
        var nodeSchemas = tc.to.map(function (node) { return node.paramSchema; });
        var _a = [tc.to, tc.from].map(function (path) { return path.map(function (x) { return x.paramValues; }); }), toValues = _a[0], fromValues = _a[1];
        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
        return tuples.map(function (_a) {
            var schema = _a[0], toVals = _a[1], fromVals = _a[2];
            return param_1.Param.changed(schema, toVals, fromVals);
        }).reduce(common_1.unnestR, []);
    };
    /**
     * Returns true if the transition is dynamic.
     *
     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
     *
     * @returns true if the Transition is dynamic
     */
    Transition.prototype.dynamic = function () {
        var changes = this._changedParams();
        return !changes ? false : changes.map(function (x) { return x.dynamic; }).reduce(common_1.anyTrueR, false);
    };
    /**
     * Returns true if the transition is ignored.
     *
     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
     *
     * @returns true if the Transition is ignored.
     */
    Transition.prototype.ignored = function () {
        return !!this._ignoredReason();
    };
    /** @hidden */
    Transition.prototype._ignoredReason = function () {
        var pending = this.router.globals.transition;
        var reloadState = this._options.reloadState;
        var same = function (pathA, pathB) {
            if (pathA.length !== pathB.length)
                return false;
            var matching = pathFactory_1.PathUtils.matching(pathA, pathB);
            return pathA.length === matching.filter(function (node) { return !reloadState || !node.state.includes[reloadState.name]; }).length;
        };
        var newTC = this.treeChanges();
        var pendTC = pending && pending.treeChanges();
        if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting))
            return "SameAsPending";
        if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to))
            return "SameAsCurrent";
    };
    /**
     * Runs the transition
     *
     * This method is generally called from the [[StateService.transitionTo]]
     *
     * @internalapi
     *
     * @returns a promise for a successful transition.
     */
    Transition.prototype.run = function () {
        var _this = this;
        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
        // Gets transition hooks array for the given phase
        var getHooksFor = function (phase) {
            return _this._hookBuilder.buildHooksForPhase(phase);
        };
        // When the chain is complete, then resolve or reject the deferred
        var transitionSuccess = function () {
            trace_1.trace.traceSuccess(_this.$to(), _this);
            _this.success = true;
            _this._deferred.resolve(_this.to());
            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.SUCCESS));
        };
        var transitionError = function (reason) {
            trace_1.trace.traceError(reason, _this);
            _this.success = false;
            _this._deferred.reject(reason);
            _this._error = reason;
            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.ERROR));
        };
        var runTransition = function () {
            // Wait to build the RUN hook chain until the BEFORE hooks are done
            // This allows a BEFORE hook to dynamically add additional RUN hooks via the Transition object.
            var allRunHooks = getHooksFor(interface_1.TransitionHookPhase.RUN);
            var done = function () { return coreservices_1.services.$q.when(undefined); };
            return transitionHook_1.TransitionHook.invokeHooks(allRunHooks, done);
        };
        var startTransition = function () {
            var globals = _this.router.globals;
            globals.lastStartedTransitionId = _this.$id;
            globals.transition = _this;
            globals.transitionHistory.enqueue(_this);
            trace_1.trace.traceTransitionStart(_this);
            return coreservices_1.services.$q.when(undefined);
        };
        var allBeforeHooks = getHooksFor(interface_1.TransitionHookPhase.BEFORE);
        transitionHook_1.TransitionHook.invokeHooks(allBeforeHooks, startTransition)
            .then(runTransition)
            .then(transitionSuccess, transitionError);
        return this.promise;
    };
    /**
     * Checks if the Transition is valid
     *
     * @returns true if the Transition is valid
     */
    Transition.prototype.valid = function () {
        return !this.error() || this.success !== undefined;
    };
    /**
     * Aborts this transition
     *
     * Imperative API to abort a Transition.
     * This only applies to Transitions that are not yet complete.
     */
    Transition.prototype.abort = function () {
        // Do not set flag if the transition is already complete
        if (predicates_1.isUndefined(this.success)) {
            this._aborted = true;
        }
    };
    /**
     * The Transition error reason.
     *
     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
     *
     * @returns an error message explaining why the transition is invalid, or the reason the transition failed.
     */
    Transition.prototype.error = function () {
        var state = this.$to();
        if (state.self.abstract)
            return "Cannot transition to abstract state '" + state.name + "'";
        if (!param_1.Param.validates(state.parameters(), this.params()))
            return "Param values not valid for state '" + state.name + "'";
        if (this.success === false)
            return this._error;
    };
    /**
     * A string representation of the Transition
     *
     * @returns A string representation of the Transition
     */
    Transition.prototype.toString = function () {
        var fromStateOrName = this.from();
        var toStateOrName = this.to();
        var avoidEmptyHash = function (params) {
            return (params["#"] !== null && params["#"] !== undefined) ? params : common_1.omit(params, ["#"]);
        };
        // (X) means the to state is invalid.
        var id = this.$id, from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = common_1.toJson(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))), toValid = this.valid() ? "" : "(X) ", to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = common_1.toJson(avoidEmptyHash(this.params()));
        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
    };
    return Transition;
}());
/** @hidden */
Transition.diToken = Transition;
exports.Transition = Transition;
//# sourceMappingURL=transition.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module url
 */
/** for typedoc */
var common_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(26);
var predicates_1 = __webpack_require__(21);
var param_1 = __webpack_require__(109);
var strings_1 = __webpack_require__(82);
/** @hidden */
function quoteRegExp(string, param) {
    var surroundPattern = ['', ''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!param)
        return result;
    switch (param.squash) {
        case false:
            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
            break;
        case true:
            result = result.replace(/\/$/, '');
            surroundPattern = ['(?:\/(', ')|\/)?'];
            break;
        default:
            surroundPattern = ["(" + param.squash + "|", ')?'];
            break;
    }
    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
}
/** @hidden */
var memoizeTo = function (obj, prop, fn) {
    return obj[prop] = obj[prop] || fn();
};
/** @hidden */
var splitOnSlash = strings_1.splitOnDelim('/');
/**
 * Matches URLs against patterns.
 *
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL.
 *
 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
 * parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by [[UrlMatcher.exec]].
 *
 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
 * or colon placeholders (`/somePath/:param`).
 *
 * - *A parameter RegExp* may be defined for a param after a colon
 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
 * The regexp must match for the url to be matched.
 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
 *
 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
 *   See [[UrlMatcherFactory.type]] for more information.
 *
 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
 *   A catch-all * parameter value will contain the remainder of the URL.
 *
 * ---
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters).
 * A path parameter matches any number of characters other than '/'. For catch-all
 * placeholders the path parameter matches any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 */
var UrlMatcher = (function () {
    /**
     * @param pattern The pattern to compile into a matcher.
     * @param paramTypes The [[ParamTypes]] registry
     * @param config  A configuration object
     * - `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
     * - `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
     */
    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
        var _this = this;
        this.config = config;
        /** @hidden */
        this._cache = { path: [this] };
        /** @hidden */
        this._children = [];
        /** @hidden */
        this._params = [];
        /** @hidden */
        this._segments = [];
        /** @hidden */
        this._compiled = [];
        this.pattern = pattern;
        this.config = common_1.defaults(this.config, {
            params: {},
            strict: true,
            caseInsensitive: false,
            paramMap: common_1.identity
        });
        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
        //   '*' name
        //   ':' name
        //   '{' name '}'
        //   '{' name ':' regexp '}'
        // The regular expression is somewhat complicated due to the need to allow curly braces
        // inside the regular expression. The placeholder regexp breaks down as follows:
        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
        //    [^{}\\]+                       - anything other than curly braces or backslash
        //    \\.                            - a backslash escape
        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g, searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g, last = 0, m, patterns = [];
        var checkParamErrors = function (id) {
            if (!UrlMatcher.nameValidator.test(id))
                throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
            if (common_1.find(_this._params, hof_1.propEq('id', id)))
                throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
        };
        // Split into static segments separated by path parameter placeholders.
        // The number of segments is always 1 more than the number of parameters.
        var matchDetails = function (m, isSearch) {
            // IE[78] returns '' for unmatched groups instead of null
            var id = m[2] || m[3];
            var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '.*' : null);
            var makeRegexpType = function (regexp) { return common_1.inherit(paramTypes.type(isSearch ? "query" : "path"), {
                pattern: new RegExp(regexp, _this.config.caseInsensitive ? 'i' : undefined)
            }); };
            return {
                id: id,
                regexp: regexp,
                cfg: _this.config.params[id],
                segment: pattern.substring(last, m.index),
                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp)
            };
        };
        var p, segment;
        while ((m = placeholder.exec(pattern))) {
            p = matchDetails(m, false);
            if (p.segment.indexOf('?') >= 0)
                break; // we're into the search part
            checkParamErrors(p.id);
            this._params.push(paramFactory.fromPath(p.id, p.type, this.config.paramMap(p.cfg, false)));
            this._segments.push(p.segment);
            patterns.push([p.segment, common_1.tail(this._params)]);
            last = placeholder.lastIndex;
        }
        segment = pattern.substring(last);
        // Find any search parameter names and remove them from the last segment
        var i = segment.indexOf('?');
        if (i >= 0) {
            var search = segment.substring(i);
            segment = segment.substring(0, i);
            if (search.length > 0) {
                last = 0;
                while ((m = searchPlaceholder.exec(search))) {
                    p = matchDetails(m, true);
                    checkParamErrors(p.id);
                    this._params.push(paramFactory.fromSearch(p.id, p.type, this.config.paramMap(p.cfg, true)));
                    last = placeholder.lastIndex;
                    // check if ?&
                }
            }
        }
        this._segments.push(segment);
        this._compiled = patterns.map(function (pattern) { return quoteRegExp.apply(null, pattern); }).concat(quoteRegExp(segment));
    }
    /**
     * Creates a new concatenated UrlMatcher
     *
     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
     *
     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
     */
    UrlMatcher.prototype.append = function (url) {
        this._children.push(url);
        url._cache = {
            path: this._cache.path.concat(url),
            parent: this,
            pattern: null,
        };
        return url;
    };
    /** @hidden */
    UrlMatcher.prototype.isRoot = function () {
        return this._cache.path[0] === this;
    };
    /** Returns the input pattern string */
    UrlMatcher.prototype.toString = function () {
        return this.pattern;
    };
    /**
     * Tests the specified url/path against this matcher.
     *
     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
     * parameter values.  Returns null if the path does not match.
     *
     * The returned object contains the values
     * of any search parameters that are mentioned in the pattern, but their value may be null if
     * they are not present in `search`. This means that search parameters are always treated
     * as optional.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
     *   x: '1', q: 'hello'
     * });
     * // returns { id: 'bob', q: 'hello', r: null }
     * ```
     *
     * @param path    The URL path to match, e.g. `$location.path()`.
     * @param search  URL search parameters, e.g. `$location.search()`.
     * @param hash    URL hash e.g. `$location.hash()`.
     * @param options
     *
     * @returns The captured parameter values.
     */
    UrlMatcher.prototype.exec = function (path, search, hash, options) {
        var _this = this;
        if (search === void 0) { search = {}; }
        if (options === void 0) { options = {}; }
        var match = memoizeTo(this._cache, 'pattern', function () {
            return new RegExp([
                '^',
                common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''),
                _this.config.strict === false ? '\/?' : '',
                '$'
            ].join(''), _this.config.caseInsensitive ? 'i' : undefined);
        }).exec(path);
        if (!match)
            return null;
        //options = defaults(options, { isolate: false });
        var allParams = this.parameters(), pathParams = allParams.filter(function (param) { return !param.isSearch(); }), searchParams = allParams.filter(function (param) { return param.isSearch(); }), nPathSegments = this._cache.path.map(function (urlm) { return urlm._segments.length - 1; }).reduce(function (a, x) { return a + x; }), values = {};
        if (nPathSegments !== match.length - 1)
            throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
        function decodePathArray(string) {
            var reverseString = function (str) { return str.split("").reverse().join(""); };
            var unquoteDashes = function (str) { return str.replace(/\\-/g, "-"); };
            var split = reverseString(string).split(/-(?!\\)/);
            var allReversed = common_1.map(split, reverseString);
            return common_1.map(allReversed, unquoteDashes).reverse();
        }
        for (var i = 0; i < nPathSegments; i++) {
            var param = pathParams[i];
            var value = match[i + 1];
            // if the param value matches a pre-replace pair, replace the value before decoding.
            for (var j = 0; j < param.replace.length; j++) {
                if (param.replace[j].from === value)
                    value = param.replace[j].to;
            }
            if (value && param.array === true)
                value = decodePathArray(value);
            if (predicates_1.isDefined(value))
                value = param.type.decode(value);
            values[param.id] = param.value(value);
        }
        searchParams.forEach(function (param) {
            var value = search[param.id];
            for (var j = 0; j < param.replace.length; j++) {
                if (param.replace[j].from === value)
                    value = param.replace[j].to;
            }
            if (predicates_1.isDefined(value))
                value = param.type.decode(value);
            values[param.id] = param.value(value);
        });
        if (hash)
            values["#"] = hash;
        return values;
    };
    /**
     * @hidden
     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
     *
     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
     *    pattern has no parameters, an empty array is returned.
     */
    UrlMatcher.prototype.parameters = function (opts) {
        if (opts === void 0) { opts = {}; }
        if (opts.inherit === false)
            return this._params;
        return common_1.unnest(this._cache.path.map(function (matcher) { return matcher._params; }));
    };
    /**
     * @hidden
     * Returns a single parameter from this UrlMatcher by id
     *
     * @param id
     * @param opts
     * @returns {T|Param|any|boolean|UrlMatcher|null}
     */
    UrlMatcher.prototype.parameter = function (id, opts) {
        var _this = this;
        if (opts === void 0) { opts = {}; }
        var findParam = function () {
            for (var _i = 0, _a = _this._params; _i < _a.length; _i++) {
                var param = _a[_i];
                if (param.id === id)
                    return param;
            }
        };
        var parent = this._cache.parent;
        return findParam() || (opts.inherit !== false && parent && parent.parameter(id, opts)) || null;
    };
    /**
     * Validates the input parameter values against this UrlMatcher
     *
     * Checks an object hash of parameters to validate their correctness according to the parameter
     * types of this `UrlMatcher`.
     *
     * @param params The object hash of parameters to validate.
     * @returns Returns `true` if `params` validates, otherwise `false`.
     */
    UrlMatcher.prototype.validates = function (params) {
        var validParamVal = function (param, val) {
            return !param || param.validates(val);
        };
        params = params || {};
        // I'm not sure why this checks only the param keys passed in, and not all the params known to the matcher
        var paramSchema = this.parameters().filter(function (paramDef) { return params.hasOwnProperty(paramDef.id); });
        return paramSchema.map(function (paramDef) { return validParamVal(paramDef, params[paramDef.id]); }).reduce(common_1.allTrueR, true);
    };
    /**
     * Given a set of parameter values, creates a URL from this UrlMatcher.
     *
     * Creates a URL that matches this pattern by substituting the specified values
     * for the path and search parameters.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
     * // returns '/user/bob?q=yes'
     * ```
     *
     * @param values  the values to substitute for the parameters in this pattern.
     * @returns the formatted URL (path and optionally search part).
     */
    UrlMatcher.prototype.format = function (values) {
        if (values === void 0) { values = {}; }
        // Build the full path of UrlMatchers (including all parent UrlMatchers)
        var urlMatchers = this._cache.path;
        // Extract all the static segments and Params (processed as ParamDetails)
        // into an ordered array
        var pathSegmentsAndParams = urlMatchers.map(UrlMatcher.pathSegmentsAndParams)
            .reduce(common_1.unnestR, [])
            .map(function (x) { return predicates_1.isString(x) ? x : getDetails(x); });
        // Extract the query params into a separate array
        var queryParams = urlMatchers.map(UrlMatcher.queryParams)
            .reduce(common_1.unnestR, [])
            .map(getDetails);
        var isInvalid = function (param) { return param.isValid === false; };
        if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) {
            return null;
        }
        /**
         * Given a Param, applies the parameter value, then returns detailed information about it
         */
        function getDetails(param) {
            // Normalize to typed value
            var value = param.value(values[param.id]);
            var isValid = param.validates(value);
            var isDefaultValue = param.isDefaultValue(value);
            // Check if we're in squash mode for the parameter
            var squash = isDefaultValue ? param.squash : false;
            // Allow the Parameter's Type to encode the value
            var encoded = param.type.encode(value);
            return { param: param, value: value, isValid: isValid, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
        }
        // Build up the path-portion from the list of static segments and parameters
        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
            // The element is a static segment (a raw string); just append it
            if (predicates_1.isString(x))
                return acc + x;
            // Otherwise, it's a ParamDetails.
            var squash = x.squash, encoded = x.encoded, param = x.param;
            // If squash is === true, try to remove a slash from the path
            if (squash === true)
                return (acc.match(/\/$/)) ? acc.slice(0, -1) : acc;
            // If squash is a string, use the string for the param value
            if (predicates_1.isString(squash))
                return acc + squash;
            if (squash !== false)
                return acc; // ?
            if (encoded == null)
                return acc;
            // If this parameter value is an array, encode the value using encodeDashes
            if (predicates_1.isArray(encoded))
                return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join("-");
            // If the parameter type is "raw", then do not encodeURIComponent
            if (param.raw)
                return acc + encoded;
            // Encode the value
            return acc + encodeURIComponent(encoded);
        }, "");
        // Build the query string by applying parameter values (array or regular)
        // then mapping to key=value, then flattening and joining using "&"
        var queryString = queryParams.map(function (paramDetails) {
            var param = paramDetails.param, squash = paramDetails.squash, encoded = paramDetails.encoded, isDefaultValue = paramDetails.isDefaultValue;
            if (encoded == null || (isDefaultValue && squash !== false))
                return;
            if (!predicates_1.isArray(encoded))
                encoded = [encoded];
            if (encoded.length === 0)
                return;
            if (!param.raw)
                encoded = common_1.map(encoded, encodeURIComponent);
            return encoded.map(function (val) { return param.id + "=" + val; });
        }).filter(common_1.identity).reduce(common_1.unnestR, []).join("&");
        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
        return pathString + (queryString ? "?" + queryString : "") + (values["#"] ? "#" + values["#"] : "");
    };
    /** @hidden */
    UrlMatcher.encodeDashes = function (str) {
        return encodeURIComponent(str).replace(/-/g, function (c) { return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase(); });
    };
    /** @hidden Given a matcher, return an array with the matcher's path segments and path params, in order */
    UrlMatcher.pathSegmentsAndParams = function (matcher) {
        var staticSegments = matcher._segments;
        var pathParams = matcher._params.filter(function (p) { return p.location === param_1.DefType.PATH; });
        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined))
            .reduce(common_1.unnestR, [])
            .filter(function (x) { return x !== "" && predicates_1.isDefined(x); });
    };
    /** @hidden Given a matcher, return an array with the matcher's query params */
    UrlMatcher.queryParams = function (matcher) {
        return matcher._params.filter(function (p) { return p.location === param_1.DefType.SEARCH; });
    };
    /**
     * Compare two UrlMatchers
     *
     * This comparison function converts a UrlMatcher into static and dynamic path segments.
     * Each static path segment is a static string between a path separator (slash character).
     * Each dynamic segment is a path parameter.
     *
     * The comparison function sorts static segments before dynamic ones.
     */
    UrlMatcher.compare = function (a, b) {
        /**
         * Turn a UrlMatcher and all its parent matchers into an array
         * of slash literals '/', string literals, and Param objects
         *
         * This example matcher matches strings like "/foo/:param/tail":
         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
         *
         * Caches the result as `matcher._cache.segments`
         */
        var segments = function (matcher) {
            return matcher._cache.segments = matcher._cache.segments ||
                matcher._cache.path.map(UrlMatcher.pathSegmentsAndParams)
                    .reduce(common_1.unnestR, [])
                    .reduce(strings_1.joinNeighborsR, [])
                    .map(function (x) { return predicates_1.isString(x) ? splitOnSlash(x) : x; })
                    .reduce(common_1.unnestR, []);
        };
        /**
         * Gets the sort weight for each segment of a UrlMatcher
         *
         * Caches the result as `matcher._cache.weights`
         */
        var weights = function (matcher) {
            return matcher._cache.weights = matcher._cache.weights ||
                segments(matcher).map(function (segment) {
                    // Sort slashes first, then static strings, the Params
                    if (segment === '/')
                        return 1;
                    if (predicates_1.isString(segment))
                        return 2;
                    if (segment instanceof param_1.Param)
                        return 3;
                });
        };
        var cmp, i, pairs = common_1.arrayTuples(weights(a), weights(b));
        for (i = 0; i < pairs.length; i++) {
            cmp = pairs[i][0] - pairs[i][1];
            if (cmp !== 0)
                return cmp;
        }
        return 0;
    };
    return UrlMatcher;
}());
/** @hidden */
UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
exports.UrlMatcher = UrlMatcher;
//# sourceMappingURL=urlMatcher.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @internalapi
 * @module vanilla
 */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(125);
var predicates_1 = __webpack_require__(21);
var common_1 = __webpack_require__(15);
/** A base `LocationServices` */
var BaseLocationServices = (function () {
    function BaseLocationServices(router, fireAfterUpdate) {
        var _this = this;
        this.fireAfterUpdate = fireAfterUpdate;
        this._listener = function (evt) { return _this._listeners.forEach(function (cb) { return cb(evt); }); };
        this._listeners = [];
        this.hash = function () { return utils_1.parseUrl(_this._get()).hash; };
        this.path = function () { return utils_1.parseUrl(_this._get()).path; };
        this.search = function () { return utils_1.getParams(utils_1.parseUrl(_this._get()).search); };
        this._location = window && window.location;
        this._history = window && window.history;
    }
    BaseLocationServices.prototype.url = function (url, replace) {
        if (replace === void 0) { replace = true; }
        if (predicates_1.isDefined(url) && url !== this._get()) {
            this._set(null, null, url, replace);
            if (this.fireAfterUpdate) {
                var evt_1 = common_1.extend(new Event("locationchange"), { url: url });
                this._listeners.forEach(function (cb) { return cb(evt_1); });
            }
        }
        return utils_1.buildUrl(this);
    };
    BaseLocationServices.prototype.onChange = function (cb) {
        var _this = this;
        this._listeners.push(cb);
        return function () { return common_1.removeFrom(_this._listeners, cb); };
    };
    BaseLocationServices.prototype.dispose = function (router) {
        common_1.deregAll(this._listeners);
    };
    return BaseLocationServices;
}());
exports.BaseLocationServices = BaseLocationServices;
//# sourceMappingURL=baseLocationService.js.map

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);

var m = angular.module('ui.utils.masks.helpers', []);

module.exports = m.name;

m.factory('PreFormatters', [function() {
	function clearDelimitersAndLeadingZeros(value) {
		if (value === '0') {
			return '0';
		}

		var cleanValue = value.replace(/^-/,'').replace(/^0*/, '');
		return cleanValue.replace(/[^0-9]/g, '');
	}

	function prepareNumberToFormatter(value, decimals) {
		return clearDelimitersAndLeadingZeros((parseFloat(value)).toFixed(decimals));
	}

	return {
		clearDelimitersAndLeadingZeros: clearDelimitersAndLeadingZeros,
		prepareNumberToFormatter: prepareNumberToFormatter
	};
}])
.factory('NumberMasks', [function() {
	return {
		viewMask: function(decimals, decimalDelimiter, thousandsDelimiter) {
			var mask = '#' + thousandsDelimiter + '##0';

			if (decimals > 0) {
				mask += decimalDelimiter;
				for (var i = 0; i < decimals; i++) {
					mask += '0';
				}
			}

			return new StringMask(mask, {
				reverse: true
			});
		},
		modelMask: function(decimals) {
			var mask = '###0';

			if (decimals > 0) {
				mask += '.';
				for (var i = 0; i < decimals; i++) {
					mask += '0';
				}
			}

			return new StringMask(mask, {
				reverse: true
			});
		}
	};
}]);


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * br-validations
 * A library of validations applicable to several Brazilian data like I.E., CNPJ, CPF and others
 * @version v0.2.4
 * @link http://github.com/the-darc/br-validations
 * @license MIT
 */
(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.BrV = factory();
	}
}(this, function () {
var CNPJ = {};

CNPJ.validate = function(c) {
	var b = [6,5,4,3,2,9,8,7,6,5,4,3,2];
	c = c.replace(/[^\d]/g,'');

	var r = /^(0{14}|1{14}|2{14}|3{14}|4{14}|5{14}|6{14}|7{14}|8{14}|9{14})$/;
	if (!c || c.length !== 14 || r.test(c)) {
		return false;
	}
	c = c.split('');

	for (var i = 0, n = 0; i < 12; i++) {
		n += c[i] * b[i+1];
	}
	n = 11 - n%11;
	n = n >= 10 ? 0 : n;
	if (parseInt(c[12]) !== n)  {
		return false;
	}

	for (i = 0, n = 0; i <= 12; i++) {
		n += c[i] * b[i];
	}
	n = 11 - n%11;
	n = n >= 10 ? 0 : n;
	if (parseInt(c[13]) !== n)  {
		return false;
	}
	return true;
};


var CPF = {};

CPF.validate = function(cpf) {
	cpf = cpf.replace(/[^\d]+/g,'');
	var r = /^(0{11}|1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11})$/;
	if (!cpf || cpf.length !== 11 || r.test(cpf)) {
		return false;
	}
	function validateDigit(digit) {
		var add = 0;
		var init = digit - 9;
		for (var i = 0; i < 9; i ++) {
			add += parseInt(cpf.charAt(i + init)) * (i+1);
		}
		return (add%11)%10 === parseInt(cpf.charAt(digit));
	}
	return validateDigit(9) && validateDigit(10);
};

var IE = function(uf) {
	if (!(this instanceof IE)) {
		return new IE(uf);
	}

	this.rules = IErules[uf] || [];
	this.rule;
	IE.prototype._defineRule = function(value) {
		this.rule = undefined;
		for (var r = 0; r < this.rules.length && this.rule === undefined; r++) {
			var str = value.replace(/[^\d]/g,'');
			var ruleCandidate = this.rules[r];
			if (str.length === ruleCandidate.chars && (!ruleCandidate.match || ruleCandidate.match.test(value))) {
				this.rule = ruleCandidate;
			}
		}
		return !!this.rule;
	};

	IE.prototype.validate = function(value) {
		if (!value || !this._defineRule(value)) {
			return false;
		}
		return this.rule.validate(value);
	};
};

var IErules = {};

var algorithmSteps = {
	handleStr: {
		onlyNumbers: function(str) {
			return str.replace(/[^\d]/g,'').split('');
		},
		mgSpec: function(str) {
			var s = str.replace(/[^\d]/g,'');
			s = s.substr(0,3)+'0'+s.substr(3, s.length);
			return s.split('');
		}
	},
	sum: {
		normalSum: function(handledStr, pesos) {
			var nums = handledStr;
			var sum = 0;
			for (var i = 0; i < pesos.length; i++) {
				sum += parseInt(nums[i]) * pesos[i];
			}
			return sum;
		},
		individualSum: function(handledStr, pesos) {
			var nums = handledStr;
			var sum = 0;
			for (var i = 0; i < pesos.length; i++) {
				var mult = parseInt(nums[i]) * pesos[i];
				sum += mult%10 + parseInt(mult/10);
			}
			return sum;
		},
		apSpec: function(handledStr, pesos) {
			var sum = this.normalSum(handledStr, pesos);
			var ref = handledStr.join('');
			if (ref >= '030000010' && ref <= '030170009') {
				return sum + 5;
			}
			if (ref >= '030170010' && ref <= '030190229') {
				return sum + 9;
			}
			return sum;
		}
	},
	rest: {
		mod11: function(sum) {
			return sum%11;
		},
		mod10: function(sum) {
			return sum%10;
		},
		mod9: function(sum) {
			return sum%9;
		}
	},
	expectedDV: {
		minusRestOf11: function(rest) {
			return rest < 2 ? 0 : 11 - rest;
		},
		minusRestOf11v2: function(rest) {
			return rest < 2 ? 11 - rest - 10 : 11 - rest;
		},
		minusRestOf10: function(rest) {
			return rest < 1 ? 0 : 10 - rest;
		},
		mod10: function(rest) {
			return rest%10;
		},
		goSpec: function(rest, handledStr) {
			var ref = handledStr.join('');
			if (rest === 1) {
				return ref >= '101031050' && ref <= '101199979' ? 1 : 0;
			}
			return rest === 0 ? 0 : 11 - rest;
		},
		apSpec: function(rest, handledStr) {
			var ref = handledStr.join('');
			if (rest === 0) {
				return ref >= '030170010' && ref <= '030190229' ? 1 : 0;
			}
			return rest === 1 ? 0 : 11 - rest;
		},
		voidFn: function(rest) {
			return rest;
		}
	}
};


/**
 * options {
 *     pesos: Array of values used to operate in sum step
 *     dvPos: Position of the DV to validate considering the handledStr
 *     algorithmSteps: The four DV's validation algorithm steps names
 * }
 */
function validateDV(value, options) {
	var steps = options.algorithmSteps;

	// Step 01: Handle String
	var handledStr = algorithmSteps.handleStr[steps[0]](value);

	// Step 02: Sum chars
	var sum = algorithmSteps.sum[steps[1]](handledStr, options.pesos);

	// Step 03: Rest calculation
	var rest = algorithmSteps.rest[steps[2]](sum);

	// Fixed Step: Get current DV
	var currentDV = parseInt(handledStr[options.dvpos]);

	// Step 04: Expected DV calculation
	var expectedDV = algorithmSteps.expectedDV[steps[3]](rest, handledStr);

	// Fixed step: DV verification
	return currentDV === expectedDV;
}

function validateIE(value, rule) {
	if (rule.match && !rule.match.test(value)) {
		return false;
	}
	for (var i = 0; i < rule.dvs.length; i++) {
		// console.log('>> >> dv'+i);
		if (!validateDV(value, rule.dvs[i])) {
			return false;
		}
	}
	return true;
}

IErules.PE = [{
	//mask: new StringMask('0000000-00'),
	chars: 9,
	dvs: [{
		dvpos: 7,
		pesos: [8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	},{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
},{
	// mask: new StringMask('00.0.000.0000000-0'),
	chars: 14,
	pesos: [[1,2,3,4,5,9,8,7,6,5,4,3,2]],
	dvs: [{
		dvpos: 13,
		pesos: [5,4,3,2,1,9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11v2']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.RS = [{
	// mask: new StringMask('000/0000000'),
	chars: 10,
	dvs: [{
		dvpos: 9,
		pesos: [2,9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.AC = [{
	// mask: new StringMask('00.000.000/000-00'),
	chars: 13,
	match: /^01/,
	dvs: [{
		dvpos: 11,
		pesos: [4,3,2,9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	},{
		dvpos: 12,
		pesos: [5,4,3,2,9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.MG = [{
	// mask: new StringMask('000.000.000/0000'),
	chars: 13,
	dvs: [{
		dvpos: 12,
		pesos: [1,2,1,2,1,2,1,2,1,2,1,2],
		algorithmSteps: ['mgSpec', 'individualSum', 'mod10', 'minusRestOf10']
	},{
		dvpos: 12,
		pesos: [3,2,11,10,9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.SP = [{
	// mask: new StringMask('000.000.000.000'),
	chars: 12,
	match: /^[0-9]/,
	dvs: [{
		dvpos: 8,
		pesos: [1,3,4,5,6,7,8,10],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'mod10']
	},{
		dvpos: 11,
		pesos: [3,2,10,9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'mod10']
	}],
	validate: function(value) { return validateIE(value, this); }
},{
	// mask: new StringMask('P-00000000.0/000')
	chars: 12,
	match: /^P/i,
	dvs: [{
		dvpos: 8,
		pesos: [1,3,4,5,6,7,8,10],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'mod10']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.DF = [{
	// mask: new StringMask('00000000000-00'),
	chars: 13,
	dvs: [{
		dvpos: 11,
		pesos: [4,3,2,9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	},{
		dvpos: 12,
		pesos: [5,4,3,2,9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.ES = [{
	// mask: new StringMask('000.000.00-0')
	chars: 9,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.BA = [{
	// mask: new StringMask('000000-00')
	chars: 8,
	match: /^[0123458]/,
	dvs: [{
		dvpos: 7,
		pesos: [7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod10', 'minusRestOf10']
	},{
		dvpos: 6,
		pesos: [8,7,6,5,4,3,0,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod10', 'minusRestOf10']
	}],
	validate: function(value) { return validateIE(value, this); }
},{
	chars: 8,
	match: /^[679]/,
	dvs: [{
		dvpos: 7,
		pesos: [7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	},{
		dvpos: 6,
		pesos: [8,7,6,5,4,3,0,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
},{
	// mask: new StringMask('0000000-00')
	chars: 9,
	match: /^[0-9][0123458]/,
	dvs: [{
		dvpos: 8,
		pesos: [8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod10', 'minusRestOf10']
	},{
		dvpos: 7,
		pesos: [9,8,7,6,5,4,3,0,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod10', 'minusRestOf10']
	}],
	validate: function(value) { return validateIE(value, this); }
},{
	chars: 9,
	match: /^[0-9][679]/,
	dvs: [{
		dvpos: 8,
		pesos: [8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	},{
		dvpos: 7,
		pesos: [9,8,7,6,5,4,3,0,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.AM = [{
	//mask: new StringMask('00.000.000-0')
	chars: 9,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.RN = [{
	// {mask: new StringMask('00.000.000-0')
	chars: 9,
	match: /^20/,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
},{
	// {mask: new StringMask('00.0.000.000-0'), chars: 10}
	chars: 10,
	match: /^20/,
	dvs: [{
		dvpos: 8,
		pesos: [10,9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.RO = [{
	// mask: new StringMask('0000000000000-0')
	chars: 14,
	dvs: [{
		dvpos: 13,
		pesos: [6,5,4,3,2,9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.PR = [{
	// mask: new StringMask('00000000-00')
	chars: 10,
	dvs: [{
		dvpos: 8,
		pesos: [3,2,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	},{
		dvpos: 9,
		pesos: [4,3,2,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.SC = [{
	// {mask: new StringMask('000.000.000'), uf: 'SANTA CATARINA'}
	chars: 9,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.RJ = [{
	// {mask: new StringMask('00.000.00-0'), uf: 'RIO DE JANEIRO'}
	chars: 8,
	dvs: [{
		dvpos: 7,
		pesos: [2,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.PA = [{
	// {mask: new StringMask('00-000000-0')
	chars: 9,
	match: /^15/,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.SE = [{
	// {mask: new StringMask('00000000-0')
	chars: 9,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.PB = [{
	// {mask: new StringMask('00000000-0')
	chars: 9,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.CE = [{
	// {mask: new StringMask('00000000-0')
	chars: 9,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.PI = [{
	// {mask: new StringMask('000000000')
	chars: 9,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.MA = [{
	// {mask: new StringMask('000000000')
	chars: 9,
	match: /^12/,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.MT = [{
	// {mask: new StringMask('0000000000-0')
	chars: 11,
	dvs: [{
		dvpos: 10,
		pesos: [3,2,9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.MS = [{
	// {mask: new StringMask('000000000')
	chars: 9,
	match: /^28/,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.TO = [{
	// {mask: new StringMask('00000000000'),
	chars: 11,
	match: /^[0-9]{2}((0[123])|(99))/,
	dvs: [{
		dvpos: 10,
		pesos: [9,8,0,0,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.AL = [{
	// {mask: new StringMask('000000000')
	chars: 9,
	match: /^24[03578]/,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'minusRestOf11']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.RR = [{
	// {mask: new StringMask('00000000-0')
	chars: 9,
	match: /^24/,
	dvs: [{
		dvpos: 8,
		pesos: [1,2,3,4,5,6,7,8],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod9', 'voidFn']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.GO = [{
	// {mask: new StringMask('00.000.000-0')
	chars: 9,
	match: /^1[015]/,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'normalSum', 'mod11', 'goSpec']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

IErules.AP = [{
	// {mask: new StringMask('000000000')
	chars: 9,
	match: /^03/,
	dvs: [{
		dvpos: 8,
		pesos: [9,8,7,6,5,4,3,2],
		algorithmSteps: ['onlyNumbers', 'apSpec', 'mod11', 'apSpec']
	}],
	validate: function(value) { return validateIE(value, this); }
}];

	return {
		ie: IE,
		cpf: CPF,
		cnpj: CNPJ
	};
}));

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(127);
var TAG = __webpack_require__(42)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(158)('meta');
var isObject = __webpack_require__(54);
var has = __webpack_require__(92);
var setDesc = __webpack_require__(61).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(91)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(70);
var dPs = __webpack_require__(690);
var enumBugKeys = __webpack_require__(193);
var IE_PROTO = __webpack_require__(200)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(192)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(322).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(30);
var core = __webpack_require__(22);
var fails = __webpack_require__(91);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(202);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 159 */
/***/ (function(module, exports) {



/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(58);
var toLength = __webpack_require__(27);
var toAbsoluteIndex = __webpack_require__(103);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(48);
var redefineAll = __webpack_require__(101);
var meta = __webpack_require__(88);
var forOf = __webpack_require__(96);
var anInstance = __webpack_require__(95);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(17);
var $iterDetect = __webpack_require__(165);
var setToStringTag = __webpack_require__(117);
var inheritIfRequired = __webpack_require__(216);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(373);
var redefine = __webpack_require__(48);
var hide = __webpack_require__(47);
var fails = __webpack_require__(17);
var defined = __webpack_require__(72);
var wks = __webpack_require__(25);
var regexpExec = __webpack_require__(224);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(62);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(20);
var cof = __webpack_require__(62);
var MATCH = __webpack_require__(25)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(25)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(87) || !__webpack_require__(17)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(16)[K];
});


/***/ }),
/* 167 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(115);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(9);
var aFunction = __webpack_require__(43);
var ctx = __webpack_require__(64);
var forOf = __webpack_require__(96);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(9);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(66);
var defined = __webpack_require__(72);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var hide = __webpack_require__(47);
var uid = __webpack_require__(104);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__namespaces__ = __webpack_require__(236);



function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */] && document.documentElement.namespaceURI === __WEBPACK_IMPORTED_MODULE_1__namespaces__["b" /* xhtml */]
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var fullname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
});


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/alert.png";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/bag-off.png";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTBillingBase2 = __webpack_require__(120);

var _CommonTNTBillingBase3 = _interopRequireDefault(_CommonTNTBillingBase2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surchargeTypes = ['INSURANCE', 'FUEL', 'SECURITY', 'LIABILITY'];

var CustomerBaseController = function (_CommonTNTBillingBase) {
  CustomerBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(CustomerBaseController, _CommonTNTBillingBase);

  /*@ngInject*/
  function CustomerBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, CustomerBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomerBaseController.__proto__ || (0, _getPrototypeOf2.default)(CustomerBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.model = {};
    _this.id = 'customer';

    _this.surchargeTypeList = surchargeTypes;
    _this.surchargeLabelKeys = {
      INSURANCE: 'customer.surcharge_insurance',
      FUEL: 'customer.surcharge_fuel',
      SECURITY: 'customer.surcharge_security',
      LIABILITY: 'customer.surcharge_liability'
    };

    _this.intervalOptions = [{ label: _this.$translate.instant('customer.surcharge_interval_weekly'), value: 'WEEKLY' }, { label: _this.$translate.instant('customer.surcharge_interval_bi_weekly'), value: 'BI_WEEKLY' }, { label: _this.$translate.instant('customer.surcharge_interval_monthly'), value: 'MONTHLY' }, { label: _this.$translate.instant('customer.surcharge_interval_quarterly'), value: 'QUARTERLY' }];

    _this.billingEventPageLimit = 100;
    return _this;
  }

  (0, _createClass3.default)(CustomerBaseController, [{
    key: 'buildDefaultSurcharges',
    value: function buildDefaultSurcharges() {
      var surcharges = {};
      surchargeTypes.forEach(function (type) {
        surcharges[type] = {
          enabled: false,
          percentage: null,
          interval: null,
          billingEventOptions: [],
          billingEvents: []
        };
      });
      return surcharges;
    }
  }, {
    key: 'getBillingEventOptions',
    value: function getBillingEventOptions() {
      var _this2 = this;

      var fetchPage = function fetchPage(offset, accumulated) {
        return _this2.BillableEventsService.all(null, offset, _this2.billingEventPageLimit).then(function (data) {
          var merged = accumulated.concat(data.results);
          return merged.length < data.total ? fetchPage(offset + _this2.billingEventPageLimit, merged) : merged;
        });
      };

      return fetchPage(0, []).then(function (results) {
        var options = results.map(function (event) {
          return {
            id: event.id,
            label: _this2.$translate.instant('entry_type.' + event.type),
            value: event.type
          };
        });
        return _lodash2.default.sortBy(options, ['label', 'ASC']);
      });
    }
  }, {
    key: 'applySurchargeOptions',
    value: function applySurchargeOptions(surcharges, billingEventOptions) {
      surchargeTypes.forEach(function (type) {
        surcharges[type].billingEventOptions = _lodash2.default.cloneDeep(billingEventOptions);
      });
    }
  }, {
    key: 'applySurchargeData',
    value: function applySurchargeData(surcharges, customerDetail) {
      if (!customerDetail) return;

      var surchargeBillingEvents = customerDetail.surchargeBillingEvents || {};

      surchargeTypes.forEach(function (type) {
        var prefix = type.toLowerCase();
        var percentage = customerDetail[prefix + 'Percentage'];
        var billableEventIds = surchargeBillingEvents[type] || [];

        surcharges[type].enabled = !!customerDetail[prefix + 'Enabled'];
        surcharges[type].percentage = percentage !== null && percentage !== undefined ? percentage : null;
        surcharges[type].interval = customerDetail[prefix + 'Interval'];
        surcharges[type].billingEventOptions.forEach(function (option) {
          option.ticked = billableEventIds.includes(option.id);
        });
      });
    }
  }, {
    key: 'mapSurchargesForSubmit',
    value: function mapSurchargesForSubmit(surcharges) {
      var _this3 = this;

      var customerFields = {};
      var surchargeBillingEvents = {};

      surchargeTypes.forEach(function (type) {
        var surcharge = surcharges[type];
        var prefix = type.toLowerCase();

        customerFields[prefix + 'Enabled'] = !!surcharge.enabled;
        customerFields[prefix + 'Percentage'] = surcharge.enabled ? _this3.convertSurchargePercentage(surcharge.percentage) : null;
        customerFields[prefix + 'Interval'] = surcharge.enabled ? surcharge.interval : null;
        surchargeBillingEvents[type] = surcharge.enabled ? (surcharge.billingEvents || []).map(function (event) {
          return event.id;
        }) : [];
      });

      return { customerFields: customerFields, surchargeBillingEvents: surchargeBillingEvents };
    }
  }, {
    key: 'convertSurchargePercentage',
    value: function convertSurchargePercentage(value) {
      if (!value && value !== 0) return null;
      return Number(String(value).replace('%', ''));
    }
  }, {
    key: 'surchargeBillingEventsMissing',
    value: function surchargeBillingEventsMissing(surcharges) {
      return surchargeTypes.some(function (type) {
        return surcharges[type].enabled && (surcharges[type].billingEvents || []).length === 0;
      });
    }
  }, {
    key: 'blockNonNumericKeypress',
    value: function blockNonNumericKeypress($event) {
      var charCode = $event.which || $event.keyCode;
      var isDigit = charCode >= 48 && charCode <= 57;
      var isDot = charCode === 46;

      if (!isDigit && !isDot) {
        $event.preventDefault();
        return;
      }

      if (isDot && String($event.target.value || '').includes('.')) $event.preventDefault(); // only one dot
    }
  }, {
    key: 'reset',
    value: function reset() {
      // for (let key in this.model) {
      //   this.model[key] = ''
      // }
      //this.clearErrors()
    }
  }, {
    key: 'askCreate',
    value: function askCreate() {
      var _this4 = this;

      this.Modal.confirm({
        header: this.$translate.instant(this.id + '.create_another_title'),
        message: this.$translate.instant(this.id + '.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this4.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();
      // for (let key in this.model) {
      //   if (!this.model[key]) {
      //     this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory')
      //   }
      // }
      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return CustomerBaseController;
}(_CommonTNTBillingBase3.default);

exports.default = CustomerBaseController;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTControlBase2 = __webpack_require__(81);

var _CommonTNTControlBase3 = _interopRequireDefault(_CommonTNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SetupBaseController = function (_CommonTNTControlBase) {
  SetupBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(SetupBaseController, _CommonTNTControlBase);

  /*@ngInject*/
  function SetupBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, SetupBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SetupBaseController.__proto__ || (0, _getPrototypeOf2.default)(SetupBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.model = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: 'Yes',
        off: 'No'
      },
      onColor: 'success',
      offColor: 'danger'
    };

    return _this;
  }

  (0, _createClass3.default)(SetupBaseController, [{
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant('setup.create_another_title'),
        message: this.$translate.instant('setup.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();

      for (var key in this.model) {
        if (!this.model[key]) {
          this.addError(key, key + ' is mandatory');
        }
      }

      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return SetupBaseController;
}(_CommonTNTControlBase3.default);

exports.default = SetupBaseController;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module common
 */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
var Queue = (function () {
    function Queue(_items, _limit) {
        if (_items === void 0) { _items = []; }
        if (_limit === void 0) { _limit = null; }
        this._items = _items;
        this._limit = _limit;
    }
    Queue.prototype.enqueue = function (item) {
        var items = this._items;
        items.push(item);
        if (this._limit && items.length > this._limit)
            items.shift();
        return item;
    };
    Queue.prototype.dequeue = function () {
        if (this.size())
            return this._items.splice(0, 1)[0];
    };
    Queue.prototype.clear = function () {
        var current = this._items;
        this._items = [];
        return current;
    };
    Queue.prototype.size = function () {
        return this._items.length;
    };
    Queue.prototype.remove = function (item) {
        var idx = this._items.indexOf(item);
        return idx > -1 && this._items.splice(idx, 1)[0];
    };
    Queue.prototype.peekTail = function () {
        return this._items[this._items.length - 1];
    };
    Queue.prototype.peekHead = function () {
        if (this.size())
            return this._items[0];
    };
    return Queue;
}());
exports.Queue = Queue;
//# sourceMappingURL=queue.js.map

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module params
 */
/** */
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
/**
 * An internal class which implements [[ParamTypeDefinition]].
 *
 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
 * When a param type definition is registered, an instance of this class is created internally.
 *
 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
 *
 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
 *
 * #### Example:
 * ```js
 * var paramTypeDef = {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 *
 * var paramType = new ParamType(paramTypeDef);
 * ```
 * @internalapi
 */
var ParamType = (function () {
    /**
     * @param def  A configuration object which contains the custom type definition.  The object's
     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
     * @returns a new ParamType object
     */
    function ParamType(def) {
        /** @inheritdoc */
        this.pattern = /.*/;
        /** @inheritdoc */
        this.inherit = true;
        common_1.extend(this, def);
    }
    // consider these four methods to be "abstract methods" that should be overridden
    /** @inheritdoc */
    ParamType.prototype.is = function (val, key) { return true; };
    /** @inheritdoc */
    ParamType.prototype.encode = function (val, key) { return val; };
    /** @inheritdoc */
    ParamType.prototype.decode = function (val, key) { return val; };
    /** @inheritdoc */
    ParamType.prototype.equals = function (a, b) { return a == b; };
    ParamType.prototype.$subPattern = function () {
        var sub = this.pattern.toString();
        return sub.substr(1, sub.length - 2);
    };
    ParamType.prototype.toString = function () {
        return "{ParamType:" + this.name + "}";
    };
    /** Given an encoded string, or a decoded object, returns a decoded object */
    ParamType.prototype.$normalize = function (val) {
        return this.is(val) ? val : this.decode(val);
    };
    /**
     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
     * e.g.:
     * - urlmatcher pattern "/path?{queryParam[]:int}"
     * - url: "/path?queryParam=1&queryParam=2
     * - $stateParams.queryParam will be [1, 2]
     * if `mode` is "auto", then
     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
     */
    ParamType.prototype.$asArray = function (mode, isSearch) {
        if (!mode)
            return this;
        if (mode === "auto" && !isSearch)
            throw new Error("'auto' array mode is for query parameters only");
        return new ArrayType(this, mode);
    };
    return ParamType;
}());
exports.ParamType = ParamType;
/**
 * Wraps up a `ParamType` object to handle array values.
 * @internalapi
 */
function ArrayType(type, mode) {
    var _this = this;
    // Wrap non-array value as array
    function arrayWrap(val) {
        return predicates_1.isArray(val) ? val : (predicates_1.isDefined(val) ? [val] : []);
    }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
        switch (val.length) {
            case 0: return undefined;
            case 1: return mode === "auto" ? val[0] : val;
            default: return val;
        }
    }
    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
        return function handleArray(val) {
            if (predicates_1.isArray(val) && val.length === 0)
                return val;
            var arr = arrayWrap(val);
            var result = common_1.map(arr, callback);
            return (allTruthyMode === true) ? common_1.filter(result, function (x) { return !x; }).length === 0 : arrayUnwrap(result);
        };
    }
    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
        return function handleArray(val1, val2) {
            var left = arrayWrap(val1), right = arrayWrap(val2);
            if (left.length !== right.length)
                return false;
            for (var i = 0; i < left.length; i++) {
                if (!callback(left[i], right[i]))
                    return false;
            }
            return true;
        };
    }
    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
        var paramTypeFn = type[name].bind(type);
        var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
        _this[name] = wrapperFn(paramTypeFn);
    });
    common_1.extend(this, {
        dynamic: type.dynamic,
        name: type.name,
        pattern: type.pattern,
        inherit: type.inherit,
        is: arrayHandler(type.is.bind(type), true),
        $arrayMode: mode
    });
}
//# sourceMappingURL=paramType.js.map

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module path */ /** for typedoc */
var common_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(26);
var param_1 = __webpack_require__(109);
/**
 * @internalapi
 *
 * A node in a [[TreeChanges]] path
 *
 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
 * Each PathNode corresponds to a state being entered, exited, or retained.
 * The stateful information includes parameter values and resolve data.
 */
var PathNode = (function () {
    function PathNode(stateOrNode) {
        if (stateOrNode instanceof PathNode) {
            var node = stateOrNode;
            this.state = node.state;
            this.paramSchema = node.paramSchema.slice();
            this.paramValues = common_1.extend({}, node.paramValues);
            this.resolvables = node.resolvables.slice();
            this.views = node.views && node.views.slice();
        }
        else {
            var state = stateOrNode;
            this.state = state;
            this.paramSchema = state.parameters({ inherit: false });
            this.paramValues = {};
            this.resolvables = state.resolvables.map(function (res) { return res.clone(); });
        }
    }
    /** Sets [[paramValues]] for the node, from the values of an object hash */
    PathNode.prototype.applyRawParams = function (params) {
        var getParamVal = function (paramDef) { return [paramDef.id, paramDef.value(params[paramDef.id])]; };
        this.paramValues = this.paramSchema.reduce(function (memo, pDef) { return common_1.applyPairs(memo, getParamVal(pDef)); }, {});
        return this;
    };
    /** Gets a specific [[Param]] metadata that belongs to the node */
    PathNode.prototype.parameter = function (name) {
        return common_1.find(this.paramSchema, hof_1.propEq("id", name));
    };
    /**
     * @returns true if the state and parameter values for another PathNode are
     * equal to the state and param values for this PathNode
     */
    PathNode.prototype.equals = function (node, paramsFn) {
        var diff = this.diff(node, paramsFn);
        return diff && diff.length === 0;
    };
    /**
     * Finds Params with different parameter values on another PathNode.
     *
     * Given another node (of the same state), finds the parameter values which differ.
     * Returns the [[Param]] (schema objects) whose parameter values differ.
     *
     * Given another node for a different state, returns `false`
     *
     * @param node The node to compare to
     * @param paramsFn A function that returns which parameters should be compared.
     * @returns The [[Param]]s which differ, or null if the two nodes are for different states
     */
    PathNode.prototype.diff = function (node, paramsFn) {
        if (this.state !== node.state)
            return false;
        var params = paramsFn ? paramsFn(this) : this.paramSchema;
        return param_1.Param.changed(params, this.paramValues, node.paramValues);
    };
    /** Returns a clone of the PathNode */
    PathNode.clone = function (node) {
        return new PathNode(node);
    };
    return PathNode;
}());
exports.PathNode = PathNode;
//# sourceMappingURL=pathNode.js.map

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(26);
var glob_1 = __webpack_require__(144);
var predicates_1 = __webpack_require__(21);
/**
 * Internal representation of a UI-Router state.
 *
 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
 *
 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[StateObject]] object.
 *
 * This class prototypally inherits from the corresponding [[StateDeclaration]].
 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
 */
var StateObject = (function () {
    /** @deprecated use State.create() */
    function StateObject(config) {
        return StateObject.create(config || {});
    }
    /**
     * Create a state object to put the private/internal implementation details onto.
     * The object's prototype chain looks like:
     * (Internal State Object) -> (Copy of State.prototype) -> (State Declaration object) -> (State Declaration's prototype...)
     *
     * @param stateDecl the user-supplied State Declaration
     * @returns {StateObject} an internal State object
     */
    StateObject.create = function (stateDecl) {
        stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
        var state = common_1.inherit(common_1.inherit(stateDecl, StateObject.prototype));
        stateDecl.$$state = function () { return state; };
        state.self = stateDecl;
        state.__stateObjectCache = {
            nameGlob: glob_1.Glob.fromString(state.name) // might return null
        };
        return state;
    };
    /**
     * Returns true if the provided parameter is the same state.
     *
     * Compares the identity of the state against the passed value, which is either an object
     * reference to the actual `State` instance, the original definition object passed to
     * `$stateProvider.state()`, or the fully-qualified name.
     *
     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
     * @returns Returns `true` if `ref` matches the current `State` instance.
     */
    StateObject.prototype.is = function (ref) {
        return this === ref || this.self === ref || this.fqn() === ref;
    };
    /**
     * @deprecated this does not properly handle dot notation
     * @returns Returns a dot-separated name of the state.
     */
    StateObject.prototype.fqn = function () {
        if (!this.parent || !(this.parent instanceof this.constructor))
            return this.name;
        var name = this.parent.fqn();
        return name ? name + "." + this.name : this.name;
    };
    /**
     * Returns the root node of this state's tree.
     *
     * @returns The root of this state's tree.
     */
    StateObject.prototype.root = function () {
        return this.parent && this.parent.root() || this;
    };
    /**
     * Gets the state's `Param` objects
     *
     * Gets the list of [[Param]] objects owned by the state.
     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] objects.
     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
     *
     * @param opts options
     */
    StateObject.prototype.parameters = function (opts) {
        opts = common_1.defaults(opts, { inherit: true, matchingKeys: null });
        var inherited = opts.inherit && this.parent && this.parent.parameters() || [];
        return inherited.concat(common_1.values(this.params))
            .filter(function (param) { return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id); });
    };
    /**
     * Returns a single [[Param]] that is owned by the state
     *
     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]]s.
     * @param id the name of the [[Param]] to return
     * @param opts options
     */
    StateObject.prototype.parameter = function (id, opts) {
        if (opts === void 0) { opts = {}; }
        return (this.url && this.url.parameter(id, opts) ||
            common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) ||
            opts.inherit && this.parent && this.parent.parameter(id));
    };
    StateObject.prototype.toString = function () {
        return this.fqn();
    };
    return StateObject;
}());
/** Predicate which returns true if the object is an class with @State() decorator */
StateObject.isStateClass = function (stateDecl) {
    return predicates_1.isFunction(stateDecl) && stateDecl['__uiRouterState'] === true;
};
/** Predicate which returns true if the object is an internal [[StateObject]] object */
StateObject.isState = function (obj) {
    return predicates_1.isObject(obj['__stateObjectCache']);
};
exports.StateObject = StateObject;
//# sourceMappingURL=stateObject.js.map

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module transition
 */ /** for typedoc */
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
var interface_1 = __webpack_require__(110); // has or is using
var glob_1 = __webpack_require__(144);
/**
 * Determines if the given state matches the matchCriteria
 *
 * @hidden
 *
 * @param state a State Object to test against
 * @param criterion
 * - If a string, matchState uses the string as a glob-matcher against the state name
 * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
 *   and returns a positive match if any of the globs match.
 * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
 * @returns {boolean}
 */
function matchState(state, criterion) {
    var toMatch = predicates_1.isString(criterion) ? [criterion] : criterion;
    function matchGlobs(_state) {
        var globStrings = toMatch;
        for (var i = 0; i < globStrings.length; i++) {
            var glob = new glob_1.Glob(globStrings[i]);
            if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
                return true;
            }
        }
        return false;
    }
    var matchFn = (predicates_1.isFunction(toMatch) ? toMatch : matchGlobs);
    return !!matchFn(state);
}
exports.matchState = matchState;
/**
 * @internalapi
 * The registration data for a registered transition hook
 */
var RegisteredHook = (function () {
    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, options) {
        if (options === void 0) { options = {}; }
        this.tranSvc = tranSvc;
        this.eventType = eventType;
        this.callback = callback;
        this.matchCriteria = matchCriteria;
        this.priority = options.priority || 0;
        this.bind = options.bind || null;
        this._deregistered = false;
    }
    /**
     * Gets the matching [[PathNode]]s
     *
     * Given an array of [[PathNode]]s, and a [[HookMatchCriterion]], returns an array containing
     * the [[PathNode]]s that the criteria matches, or `null` if there were no matching nodes.
     *
     * Returning `null` is significant to distinguish between the default
     * "match-all criterion value" of `true` compared to a `() => true` function,
     * when the nodes is an empty array.
     *
     * This is useful to allow a transition match criteria of `entering: true`
     * to still match a transition, even when `entering === []`.  Contrast that
     * with `entering: (state) => true` which only matches when a state is actually
     * being entered.
     */
    RegisteredHook.prototype._matchingNodes = function (nodes, criterion) {
        if (criterion === true)
            return nodes;
        var matching = nodes.filter(function (node) { return matchState(node.state, criterion); });
        return matching.length ? matching : null;
    };
    /**
     * Gets the default match criteria (all `true`)
     *
     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
     *
     * ```js
     * {
     *   to: true,
     *   from: true,
     *   entering: true,
     *   exiting: true,
     *   retained: true,
     * }
     */
    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
        return common_1.map(this.tranSvc._pluginapi._getPathTypes(), function () { return true; });
    };
    /**
     * Gets matching nodes as [[IMatchingNodes]]
     *
     * Create a IMatchingNodes object from the TransitionHookTypes that is roughly equivalent to:
     *
     * ```js
     * let matches: IMatchingNodes = {
     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
     * };
     * ```
     */
    RegisteredHook.prototype._getMatchingNodes = function (treeChanges) {
        var _this = this;
        var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
        var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
        return paths.reduce(function (mn, pathtype) {
            // STATE scope criteria matches against every node in the path.
            // TRANSITION scope criteria matches against only the last node in the path
            var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
            var path = treeChanges[pathtype.name] || [];
            var nodes = isStateHook ? path : [common_1.tail(path)];
            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name]);
            return mn;
        }, {});
    };
    /**
     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
     *
     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
     */
    RegisteredHook.prototype.matches = function (treeChanges) {
        var matches = this._getMatchingNodes(treeChanges);
        // Check if all the criteria matched the TreeChanges object
        var allMatched = common_1.values(matches).every(common_1.identity);
        return allMatched ? matches : null;
    };
    return RegisteredHook;
}());
exports.RegisteredHook = RegisteredHook;
/** @hidden Return a registration function of the requested type. */
function makeEvent(registry, transitionService, eventType) {
    // Create the object which holds the registered transition hooks.
    var _registeredHooks = registry._registeredHooks = (registry._registeredHooks || {});
    var hooks = _registeredHooks[eventType.name] = [];
    // Create hook registration function on the IHookRegistry for the event
    registry[eventType.name] = hookRegistrationFn;
    function hookRegistrationFn(matchObject, callback, options) {
        if (options === void 0) { options = {}; }
        var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, options);
        hooks.push(registeredHook);
        return function deregisterEventHook() {
            registeredHook._deregistered = true;
            common_1.removeFrom(hooks)(registeredHook);
        };
    }
    return hookRegistrationFn;
}
exports.makeEvent = makeEvent;
//# sourceMappingURL=hookRegistry.js.map

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module transition
 */
/** for typedoc */
var interface_1 = __webpack_require__(110);
var transition_1 = __webpack_require__(148);
var hookRegistry_1 = __webpack_require__(184);
var coreResolvables_1 = __webpack_require__(544);
var redirectTo_1 = __webpack_require__(548);
var onEnterExitRetain_1 = __webpack_require__(547);
var resolve_1 = __webpack_require__(549);
var views_1 = __webpack_require__(552);
var updateGlobals_1 = __webpack_require__(550);
var url_1 = __webpack_require__(551);
var lazyLoad_1 = __webpack_require__(288);
var transitionEventType_1 = __webpack_require__(299);
var transitionHook_1 = __webpack_require__(124);
var predicates_1 = __webpack_require__(21);
var common_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(26);
var ignoredTransition_1 = __webpack_require__(545);
var invalidTransition_1 = __webpack_require__(546);
/**
 * The default [[Transition]] options.
 *
 * Include this object when applying custom defaults:
 * let reloadOpts = { reload: true, notify: true }
 * let options = defaults(theirOpts, customDefaults, defaultOptions);
 */
exports.defaultTransOpts = {
    location: true,
    relative: null,
    inherit: false,
    notify: true,
    reload: false,
    custom: {},
    current: function () { return null; },
    source: "unknown"
};
/**
 * This class provides services related to Transitions.
 *
 * - Most importantly, it allows global Transition Hooks to be registered.
 * - It allows the default transition error handler to be set.
 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
 *
 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
 */
var TransitionService = (function () {
    /** @hidden */
    function TransitionService(_router) {
        /** @hidden */
        this._transitionCount = 0;
        /** @hidden The transition hook types, such as `onEnter`, `onStart`, etc */
        this._eventTypes = [];
        /** @hidden The registered transition hooks */
        this._registeredHooks = {};
        /** @hidden The  paths on a criteria object */
        this._criteriaPaths = {};
        this._router = _router;
        this.$view = _router.viewService;
        this._deregisterHookFns = {};
        this._pluginapi = common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), [
            '_definePathType',
            '_defineEvent',
            '_getPathTypes',
            '_getEvents',
            'getHooks',
        ]);
        this._defineCorePaths();
        this._defineCoreEvents();
        this._registerCoreTransitionHooks();
    }
    /**
     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
     *
     * Registers a transition lifecycle hook, which is invoked during transition construction.
     *
     * This low level hook should only be used by plugins.
     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
     * The Sticky States plugin uses this hook to modify the treechanges.
     *
     * ### Lifecycle
     *
     * `onCreate` hooks are invoked *while a transition is being constructed*.
     *
     * ### Return value
     *
     * The hook's return value is ignored
     *
     * @internalapi
     * @param criteria defines which Transitions the Hook should be invoked for.
     * @param callback the hook function which will be invoked.
     * @param options the registration options
     * @returns a function which deregisters the hook.
     */
    TransitionService.prototype.onCreate = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onBefore = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onStart = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onExit = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onRetain = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onEnter = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onFinish = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onSuccess = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onError = function (criteria, callback, options) { return; };
    /**
     * dispose
     * @internalapi
     */
    TransitionService.prototype.dispose = function (router) {
        common_1.values(this._registeredHooks).forEach(function (hooksArray) { return hooksArray.forEach(function (hook) {
            hook._deregistered = true;
            common_1.removeFrom(hooksArray, hook);
        }); });
    };
    /**
     * Creates a new [[Transition]] object
     *
     * This is a factory function for creating new Transition objects.
     * It is used internally by the [[StateService]] and should generally not be called by application code.
     *
     * @param fromPath the path to the current state (the from state)
     * @param targetState the target state (destination)
     * @returns a Transition
     */
    TransitionService.prototype.create = function (fromPath, targetState) {
        return new transition_1.Transition(fromPath, targetState, this._router);
    };
    /** @hidden */
    TransitionService.prototype._defineCoreEvents = function () {
        var Phase = interface_1.TransitionHookPhase;
        var TH = transitionHook_1.TransitionHook;
        var paths = this._criteriaPaths;
        var NORMAL_SORT = false, REVERSE_SORT = true;
        var ASYNCHRONOUS = false, SYNCHRONOUS = true;
        this._defineEvent("onCreate", Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
        this._defineEvent("onBefore", Phase.BEFORE, 0, paths.to);
        this._defineEvent("onStart", Phase.RUN, 0, paths.to);
        this._defineEvent("onExit", Phase.RUN, 100, paths.exiting, REVERSE_SORT);
        this._defineEvent("onRetain", Phase.RUN, 200, paths.retained);
        this._defineEvent("onEnter", Phase.RUN, 300, paths.entering);
        this._defineEvent("onFinish", Phase.RUN, 400, paths.to);
        this._defineEvent("onSuccess", Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
        this._defineEvent("onError", Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
    };
    /** @hidden */
    TransitionService.prototype._defineCorePaths = function () {
        var STATE = interface_1.TransitionHookScope.STATE, TRANSITION = interface_1.TransitionHookScope.TRANSITION;
        this._definePathType("to", TRANSITION);
        this._definePathType("from", TRANSITION);
        this._definePathType("exiting", STATE);
        this._definePathType("retained", STATE);
        this._definePathType("entering", STATE);
    };
    /** @hidden */
    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
        if (reverseSort === void 0) { reverseSort = false; }
        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
        if (synchronous === void 0) { synchronous = false; }
        var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
        this._eventTypes.push(eventType);
        hookRegistry_1.makeEvent(this, this, eventType);
    };
    ;
    /** @hidden */
    TransitionService.prototype._getEvents = function (phase) {
        var transitionHookTypes = predicates_1.isDefined(phase) ?
            this._eventTypes.filter(function (type) { return type.hookPhase === phase; }) :
            this._eventTypes.slice();
        return transitionHookTypes.sort(function (l, r) {
            var cmpByPhase = l.hookPhase - r.hookPhase;
            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
        });
    };
    /**
     * Adds a Path to be used as a criterion against a TreeChanges path
     *
     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
     * Each state in the exiting path is checked against the criteria and returned as part of the match.
     *
     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
     *
     * @hidden
     */
    TransitionService.prototype._definePathType = function (name, hookScope) {
        this._criteriaPaths[name] = { name: name, scope: hookScope };
    };
    /** * @hidden */
    TransitionService.prototype._getPathTypes = function () {
        return this._criteriaPaths;
    };
    /** @hidden */
    TransitionService.prototype.getHooks = function (hookName) {
        return this._registeredHooks[hookName];
    };
    /** @hidden */
    TransitionService.prototype._registerCoreTransitionHooks = function () {
        var fns = this._deregisterHookFns;
        fns.addCoreResolves = coreResolvables_1.registerAddCoreResolvables(this);
        fns.ignored = ignoredTransition_1.registerIgnoredTransitionHook(this);
        fns.invalid = invalidTransition_1.registerInvalidTransitionHook(this);
        // Wire up redirectTo hook
        fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
        // Wire up onExit/Retain/Enter state hooks
        fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
        fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
        fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
        // Wire up Resolve hooks
        fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
        fns.lazyResolve = resolve_1.registerLazyResolveState(this);
        // Wire up the View management hooks
        fns.loadViews = views_1.registerLoadEnteringViews(this);
        fns.activateViews = views_1.registerActivateViews(this);
        // Updates global state after a transition
        fns.updateGlobals = updateGlobals_1.registerUpdateGlobalState(this);
        // After globals.current is updated at priority: 10000
        fns.updateUrl = url_1.registerUpdateUrl(this);
        // Lazy load state trees
        fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
    };
    return TransitionService;
}());
exports.TransitionService = TransitionService;
//# sourceMappingURL=transitionService.js.map

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	maxNumber: function(ctrl, value, limit) {
		var max = parseFloat(limit, 10);
		return ctrl.$isEmpty(value) || isNaN(max) || value <= max;
	},
	minNumber: function(ctrl, value, limit) {
		var min = parseFloat(limit, 10);
		return ctrl.$isEmpty(value) || isNaN(min) || value >= min;
	}
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * # Angular 1 types
 *
 * UI-Router core provides various Typescript types which you can use for code completion and validating parameter values, etc.
 * The customizations to the core types for Angular UI-Router are documented here.
 *
 * The optional [[$resolve]] service is also documented here.
 *
 * @module ng1
 * @preferred
 */
/** for typedoc */
var angular_1 = __webpack_require__(111);
var core_1 = __webpack_require__(52);
var views_1 = __webpack_require__(188);
var templateFactory_1 = __webpack_require__(615);
var stateProvider_1 = __webpack_require__(313);
var onEnterExitRetain_1 = __webpack_require__(614);
var locationServices_1 = __webpack_require__(612);
var urlRouterProvider_1 = __webpack_require__(314);
angular_1.ng.module("ui.router.angular1", []);
var mod_init = angular_1.ng.module('ui.router.init', []);
var mod_util = angular_1.ng.module('ui.router.util', ['ng', 'ui.router.init']);
var mod_rtr = angular_1.ng.module('ui.router.router', ['ui.router.util']);
var mod_state = angular_1.ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
var mod_main = angular_1.ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
var mod_cmpt = angular_1.ng.module('ui.router.compat', ['ui.router']); // tslint:disable-line
var router = null;
$uiRouter.$inject = ['$locationProvider'];
/** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
function $uiRouter($locationProvider) {
    // Create a new instance of the Router when the $uiRouterProvider is initialized
    router = this.router = new core_1.UIRouter();
    router.stateProvider = new stateProvider_1.StateProvider(router.stateRegistry, router.stateService);
    // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
    router.stateRegistry.decorator("views", views_1.ng1ViewsBuilder);
    router.stateRegistry.decorator("onExit", onEnterExitRetain_1.getStateHookBuilder("onExit"));
    router.stateRegistry.decorator("onRetain", onEnterExitRetain_1.getStateHookBuilder("onRetain"));
    router.stateRegistry.decorator("onEnter", onEnterExitRetain_1.getStateHookBuilder("onEnter"));
    router.viewService._pluginapi._viewConfigFactory('ng1', views_1.getNg1ViewConfigFactory());
    var ng1LocationService = router.locationService = router.locationConfig = new locationServices_1.Ng1LocationServices($locationProvider);
    locationServices_1.Ng1LocationServices.monkeyPatchPathParameterType(router);
    // backwards compat: also expose router instance as $uiRouterProvider.router
    router['router'] = router;
    router['$get'] = $get;
    $get.$inject = ['$location', '$browser', '$sniffer', '$rootScope', '$http', '$templateCache'];
    function $get($location, $browser, $sniffer, $rootScope, $http, $templateCache) {
        ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser);
        delete router['router'];
        delete router['$get'];
        return router;
    }
    return router;
}
var getProviderFor = function (serviceName) { return ['$uiRouterProvider', function ($urp) {
        var service = $urp.router[serviceName];
        service["$get"] = function () { return service; };
        return service;
    }]; };
// This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
runBlock.$inject = ['$injector', '$q', '$uiRouter'];
function runBlock($injector, $q, $uiRouter) {
    core_1.services.$injector = $injector;
    core_1.services.$q = $q;
    // The $injector is now available.
    // Find any resolvables that had dependency annotation deferred
    $uiRouter.stateRegistry.get()
        .map(function (x) { return x.$$state().resolvables; })
        .reduce(core_1.unnestR, [])
        .filter(function (x) { return x.deps === "deferred"; })
        .forEach(function (resolvable) { return resolvable.deps = $injector.annotate(resolvable.resolveFn); });
}
// $urlRouter service and $urlRouterProvider
var getUrlRouterProvider = function (uiRouter) {
    return uiRouter.urlRouterProvider = new urlRouterProvider_1.UrlRouterProvider(uiRouter);
};
// $state service and $stateProvider
// $urlRouter service and $urlRouterProvider
var getStateProvider = function () {
    return core_1.extend(router.stateProvider, { $get: function () { return router.stateService; } });
};
watchDigests.$inject = ['$rootScope'];
function watchDigests($rootScope) {
    $rootScope.$watch(function () { core_1.trace.approximateDigests++; });
}
exports.watchDigests = watchDigests;
mod_init.provider("$uiRouter", $uiRouter);
mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
mod_util.provider('$urlService', getProviderFor('urlService'));
mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
mod_util.provider('$templateFactory', function () { return new templateFactory_1.TemplateFactory(); });
mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
mod_state.provider('$transitions', getProviderFor('transitionService'));
mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
mod_main.factory('$view', function () { return router.viewService; });
mod_main.service("$trace", function () { return core_1.trace; });
mod_main.run(watchDigests);
mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
mod_state.run(['$state', function ($state) { }]);
mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
mod_init.run(runBlock);
/** @hidden TODO: find a place to move this */
exports.getLocals = function (ctx) {
    var tokens = ctx.getTokens().filter(core_1.isString);
    var tuples = tokens.map(function (key) {
        var resolvable = ctx.getResolvable(key);
        var waitPolicy = ctx.getPolicy(resolvable).async;
        return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
    });
    return tuples.reduce(core_1.applyPairs, {});
};
//# sourceMappingURL=services.js.map

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(52);
function getNg1ViewConfigFactory() {
    var templateFactory = null;
    return function (path, view) {
        templateFactory = templateFactory || core_1.services.$injector.get("$templateFactory");
        return [new Ng1ViewConfig(path, view, templateFactory)];
    };
}
exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
var hasAnyKey = function (keys, obj) {
    return keys.reduce(function (acc, key) { return acc || core_1.isDefined(obj[key]); }, false);
};
/**
 * This is a [[StateBuilder.builder]] function for angular1 `views`.
 *
 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
 * handles the `views` property with logic specific to @uirouter/angularjs (ng1).
 *
 * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
 * and applies the state-level configuration to a view named `$default`.
 */
function ng1ViewsBuilder(state) {
    // Do not process root state
    if (!state.parent)
        return {};
    var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allViewKeys = compKeys.concat(nonCompKeys);
    // Do not allow a state to have both state-level props and also a `views: {}` property.
    // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
    // However, the `$default` approach should not be mixed with a separate `views: ` block.
    if (core_1.isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
        throw new Error("State '" + state.name + "' has a 'views' object. " +
            "It cannot also have \"view properties\" at the state level.  " +
            "Move the following properties into a view (in the 'views' object): " +
            (" " + allViewKeys.filter(function (key) { return core_1.isDefined(state[key]); }).join(", ")));
    }
    var views = {}, viewsObject = state.views || { "$default": core_1.pick(state, allViewKeys) };
    core_1.forEach(viewsObject, function (config, name) {
        // Account for views: { "": { template... } }
        name = name || "$default";
        // Account for views: { header: "headerComponent" }
        if (core_1.isString(config))
            config = { component: config };
        // Make a shallow copy of the config object
        config = core_1.extend({}, config);
        // Do not allow a view to mix props for component-style view with props for template/controller-style view
        if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
            throw new Error("Cannot combine: " + compKeys.join("|") + " with: " + nonCompKeys.join("|") + " in stateview: '" + name + "@" + state.name + "'");
        }
        config.resolveAs = config.resolveAs || '$resolve';
        config.$type = "ng1";
        config.$context = state;
        config.$name = name;
        var normalized = core_1.ViewService.normalizeUIViewTarget(config.$context, config.$name);
        config.$uiViewName = normalized.uiViewName;
        config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
        views[name] = config;
    });
    return views;
}
exports.ng1ViewsBuilder = ng1ViewsBuilder;
var id = 0;
var Ng1ViewConfig = (function () {
    function Ng1ViewConfig(path, viewDecl, factory) {
        var _this = this;
        this.path = path;
        this.viewDecl = viewDecl;
        this.factory = factory;
        this.$id = id++;
        this.loaded = false;
        this.getTemplate = function (uiView, context) {
            return _this.component ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings) : _this.template;
        };
    }
    Ng1ViewConfig.prototype.load = function () {
        var _this = this;
        var $q = core_1.services.$q;
        var context = new core_1.ResolveContext(this.path);
        var params = this.path.reduce(function (acc, node) { return core_1.extend(acc, node.paramValues); }, {});
        var promises = {
            template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
            controller: $q.when(this.getController(context))
        };
        return $q.all(promises).then(function (results) {
            core_1.trace.traceViewServiceEvent("Loaded", _this);
            _this.controller = results.controller;
            core_1.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
            return _this;
        });
    };
    /**
     * Gets the controller for a view configuration.
     *
     * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
     */
    Ng1ViewConfig.prototype.getController = function (context) {
        var provider = this.viewDecl.controllerProvider;
        if (!core_1.isInjectable(provider))
            return this.viewDecl.controller;
        var deps = core_1.services.$injector.annotate(provider);
        var providerFn = core_1.isArray(provider) ? core_1.tail(provider) : provider;
        var resolvable = new core_1.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    return Ng1ViewConfig;
}());
exports.Ng1ViewConfig = Ng1ViewConfig;
//# sourceMappingURL=views.js.map

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(668), __esModule: true };

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 191 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);
var document = __webpack_require__(39).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 193 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(127);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(129);
var $export = __webpack_require__(30);
var redefine = __webpack_require__(335);
var hide = __webpack_require__(84);
var Iterators = __webpack_require__(112);
var $iterCreate = __webpack_require__(687);
var setToStringTag = __webpack_require__(132);
var getPrototypeOf = __webpack_require__(330);
var ITERATOR = __webpack_require__(42)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(126);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(130);
var createDesc = __webpack_require__(131);
var toIObject = __webpack_require__(85);
var toPrimitive = __webpack_require__(203);
var has = __webpack_require__(92);
var IE8_DOM_DEFINE = __webpack_require__(323);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(53) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 198 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(84);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(201)('keys');
var uid = __webpack_require__(158);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(22);
var global = __webpack_require__(39);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(129) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(54);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(39);
var core = __webpack_require__(22);
var LIBRARY = __webpack_require__(129);
var wksExt = __webpack_require__(206);
var defineProperty = __webpack_require__(61).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(42);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(153);
var ITERATOR = __webpack_require__(42)('iterator');
var Iterators = __webpack_require__(112);
module.exports = __webpack_require__(22).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(171)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(33);
var toAbsoluteIndex = __webpack_require__(103);
var toLength = __webpack_require__(27);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(727);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(31);
var createDesc = __webpack_require__(100);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(16).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 213 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(25)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(16).document;
module.exports = document && document.documentElement;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var setPrototypeOf = __webpack_require__(225).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(116);
var ITERATOR = __webpack_require__(25)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(97);
var descriptor = __webpack_require__(100);
var setToStringTag = __webpack_require__(117);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(47)(IteratorPrototype, __webpack_require__(25)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(87);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(48);
var hide = __webpack_require__(47);
var Iterators = __webpack_require__(116);
var $iterCreate = __webpack_require__(218);
var setToStringTag = __webpack_require__(117);
var getPrototypeOf = __webpack_require__(57);
var ITERATOR = __webpack_require__(25)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var macrotask = __webpack_require__(230).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(62)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(43);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(133);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(11);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(64)(Function.call, __webpack_require__(56).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(136)('keys');
var uid = __webpack_require__(104);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(164);
var defined = __webpack_require__(72);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(66);
var defined = __webpack_require__(72);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(64);
var invoke = __webpack_require__(351);
var html = __webpack_require__(215);
var cel = __webpack_require__(212);
var global = __webpack_require__(16);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(62)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(29);
var LIBRARY = __webpack_require__(87);
var $typed = __webpack_require__(172);
var hide = __webpack_require__(47);
var redefineAll = __webpack_require__(101);
var fails = __webpack_require__(17);
var anInstance = __webpack_require__(95);
var toInteger = __webpack_require__(66);
var toLength = __webpack_require__(27);
var toIndex = __webpack_require__(370);
var gOPN = __webpack_require__(98).f;
var dP = __webpack_require__(31).f;
var arrayFill = __webpack_require__(209);
var setToStringTag = __webpack_require__(117);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var core = __webpack_require__(63);
var LIBRARY = __webpack_require__(87);
var wksExt = __webpack_require__(371);
var defineProperty = __webpack_require__(31).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(115);
var ITERATOR = __webpack_require__(25)('iterator');
var Iterators = __webpack_require__(116);
module.exports = __webpack_require__(63).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(86);
var step = __webpack_require__(354);
var Iterators = __webpack_require__(116);
var toIObject = __webpack_require__(58);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(219)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespaces__ = __webpack_require__(236);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */].hasOwnProperty(prefix) ? {space: __WEBPACK_IMPORTED_MODULE_0__namespaces__["a" /* default */][prefix], local: name} : name;
});


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return xhtml; });
var xhtml = "http://www.w3.org/1999/xhtml";

/* harmony default export */ __webpack_exports__["a"] = ({
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
});


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return event; });
/* harmony export (immutable) */ __webpack_exports__["b"] = customEvent;
var filterEvents = {};

var event = null;

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!("onmouseenter" in element)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = event; // Events can be reentrant (e.g., focus).
    event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      event = event0;
    }
  };
}

function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

/* harmony default export */ __webpack_exports__["c"] = (function(typename, value, capture) {
  var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
});

function customEvent(event1, listener, that, args) {
  var event0 = event;
  event1.sourceEvent = event;
  event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    event = event0;
  }
}


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function none() {}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
});


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_on__ = __webpack_require__(237);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var current = __WEBPACK_IMPORTED_MODULE_0__selection_on__["a" /* event */], source;
  while (source = current.sourceEvent) current = source;
  return current;
});


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Order_Type_A_Icon.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/P-orange-icon.png";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/arrow-inbound.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/atm.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/bank.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/carrier.png";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin.png";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/delivery.png";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/emergency.png";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/internal.png";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/key-on.png";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/locker.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/logistic.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/nsng.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/oncall.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/regular.png";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/spritesheet-2x.png";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/stops.png";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/tanker.png";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/truck.png";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/vault.png";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/window.png";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BatchBaseController = function (_CommonBase) {
  BatchBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(BatchBaseController, _CommonBase);

  /*@ngInject*/
  function BatchBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, BatchBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BatchBaseController.__proto__ || (0, _getPrototypeOf2.default)(BatchBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.model = {};
    return _this;
  }

  (0, _createClass3.default)(BatchBaseController, [{
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant('batch.create_another_title'),
        message: this.$translate.instant('batch.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();
      for (var key in this.model) {
        if (!this.model[key]) {
          this.addError(key, key + ' is mandatory');
        }
      }
      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return BatchBaseController;
}(_commonBase2.default);

exports.default = BatchBaseController;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchBaseController = function (_CommonBase) {
  BranchBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(BranchBaseController, _CommonBase);

  /*@ngInject*/
  function BranchBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, BranchBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BranchBaseController.__proto__ || (0, _getPrototypeOf2.default)(BranchBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.model = {};
    return _this;
  }

  (0, _createClass3.default)(BranchBaseController, [{
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant('branch.create_another_title'),
        message: this.$translate.instant('branch.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();
      for (var key in this.model) {
        if (this.model[key] === undefined || this.model[key] === null) {
          this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory');
        }
      }
      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return BranchBaseController;
}(_commonBase2.default);

exports.default = BranchBaseController;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceBaseController = function (_CommonBase) {
    BranchFundingSourceBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(BranchFundingSourceBaseController, _CommonBase);

    /*@ngInject*/
    function BranchFundingSourceBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, BranchFundingSourceBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BranchFundingSourceBaseController.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(BranchFundingSourceBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.Modal.confirm({
                    header: _this2.$translate.instant('branchFundingSource.create_another_title'),
                    message: _this2.$translate.instant('branchFundingSource.create_another_message'),
                    callback: function callback(_ref) {
                        var modal = _ref.modal,
                            $scope = _ref.$scope;

                        _this2.reset();
                        modal.close();
                        resolve(true);
                    },
                    negative: function negative(_ref2) {
                        var modal = _ref2.modal,
                            $scope = _ref2.$scope;

                        modal.close();
                        window.history.go(-1);
                        resolve(false);
                    },
                    type: 'primary',
                    buttons: ['common.yes', 'common.no']
                });
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + 'is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return BranchFundingSourceBaseController;
}(_commonBase2.default);

exports.default = BranchFundingSourceBaseController;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceHolidayBaseController = function (_CommonBase) {
    BranchFundingSourceHolidayBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(BranchFundingSourceHolidayBaseController, _CommonBase);

    /*@ngInject*/
    function BranchFundingSourceHolidayBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, BranchFundingSourceHolidayBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BranchFundingSourceHolidayBaseController.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceHolidayBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(BranchFundingSourceHolidayBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.Modal.confirm({
                    header: _this2.$translate.instant('branchFundingSourceHoliday.create_another_title'),
                    message: _this2.$translate.instant('branchFundingSourceHoliday.create_another_message'),
                    callback: function callback(_ref) {
                        var modal = _ref.modal,
                            $scope = _ref.$scope;

                        _this2.reset();
                        modal.close();
                        resolve(true);
                    },
                    negative: function negative(_ref2) {
                        var modal = _ref2.modal,
                            $scope = _ref2.$scope;

                        modal.close();
                        window.history.go(-1);
                        resolve(false);
                    },
                    type: 'primary',
                    buttons: ['common.yes', 'common.no']
                });
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + 'is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return BranchFundingSourceHolidayBaseController;
}(_commonBase2.default);

exports.default = BranchFundingSourceHolidayBaseController;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarrierBaseController = function (_CommonBase) {
  CarrierBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(CarrierBaseController, _CommonBase);

  /*@ngInject*/
  function CarrierBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, CarrierBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CarrierBaseController.__proto__ || (0, _getPrototypeOf2.default)(CarrierBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.model = {};
    _this.id = 'carrier';
    return _this;
  }

  (0, _createClass3.default)(CarrierBaseController, [{
    key: 'reset',
    value: function reset() {
      this.model = angular.copy(this.defaultModel);
      this.clearErrors();
    }
  }, {
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant(this.id + '.create_another_title'),
        message: this.$translate.instant(this.id + '.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();
      for (var key in this.model) {
        if (!this.model[key] && typeof this.model[key] == 'string') {
          this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory');
        }
      }

      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return CarrierBaseController;
}(_commonBase2.default);

exports.default = CarrierBaseController;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemBaseController = function (_CommonBase) {
  ItemBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(ItemBaseController, _CommonBase);

  /*@ngInject*/
  function ItemBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, ItemBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ItemBaseController.__proto__ || (0, _getPrototypeOf2.default)(ItemBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.model = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: 'Yes',
        off: 'No'
      },
      onColor: 'success',
      offColor: 'danger'
    };

    return _this;
  }

  (0, _createClass3.default)(ItemBaseController, [{
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant('item.create_another_title'),
        message: this.$translate.instant('item.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();

      for (var key in this.model) {
        if (!this.model[key]) {
          this.addError(key, key + ' is mandatory');
        }
      }

      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return ItemBaseController;
}(_commonBase2.default);

exports.default = ItemBaseController;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemTypeBaseController = function (_CommonBase) {
  ItemTypeBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(ItemTypeBaseController, _CommonBase);

  /*@ngInject*/
  function ItemTypeBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, ItemTypeBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ItemTypeBaseController.__proto__ || (0, _getPrototypeOf2.default)(ItemTypeBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.model = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: 'Yes',
        off: 'No'
      },
      onColor: 'success',
      offColor: 'danger'
    };

    return _this;
  }

  (0, _createClass3.default)(ItemTypeBaseController, [{
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant('item.create_another_title'),
        message: this.$translate.instant('item.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();

      for (var key in this.model) {
        if (!this.model[key]) {
          this.addError(key, key + ' is mandatory');
        }
      }

      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return ItemTypeBaseController;
}(_commonBase2.default);

exports.default = ItemTypeBaseController;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoutesBaseController = function (_CommonBase) {
  RoutesBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(RoutesBaseController, _CommonBase);

  /*@ngInject*/
  function RoutesBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, RoutesBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RoutesBaseController.__proto__ || (0, _getPrototypeOf2.default)(RoutesBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.model = {};
    _this.id = 'route';
    _this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: 'Yes',
        off: 'No'
      },
      onColor: 'success',
      offColor: 'danger'
    };
    return _this;
  }

  (0, _createClass3.default)(RoutesBaseController, [{
    key: 'reset',
    value: function reset() {
      for (var key in this.model) {
        this.model[key] = '';
      }
      this.model.loadTruck = false;
      this.clearErrors();
    }
  }, {
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        _this2.Modal.confirm({
          header: _this2.$translate.instant(_this2.id + '.create_another_title'),
          message: _this2.$translate.instant(_this2.id + '.create_another_message'),
          callback: function callback(_ref) {
            var modal = _ref.modal,
                $scope = _ref.$scope;

            _this2.reset();
            modal.close();
            resolve(true);
          },
          negative: function negative(_ref2) {
            var modal = _ref2.modal,
                $scope = _ref2.$scope;

            modal.close();
            window.history.go(-1);
            resolve(false);
          },
          type: 'primary',
          buttons: ['common.yes', 'common.no']
        });
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();
      for (var key in this.model) {
        if (!this.model[key] && typeof this.model[key] == 'string') {
          this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory');
        }
      }

      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return RoutesBaseController;
}(_commonBase2.default);

exports.default = RoutesBaseController;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceTicketPartsBaseController = function (_CommonBase) {
    ServiceTicketPartsBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(ServiceTicketPartsBaseController, _CommonBase);

    /*@ngInject*/
    function ServiceTicketPartsBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, ServiceTicketPartsBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceTicketPartsBaseController.__proto__ || (0, _getPrototypeOf2.default)(ServiceTicketPartsBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(ServiceTicketPartsBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.Modal.confirm({
                    header: _this2.$translate.instant('common.Create'),
                    message: _this2.$translate.instant('serviceTicketParts.create_another_message'),
                    callback: function callback(_ref) {
                        var modal = _ref.modal,
                            $scope = _ref.$scope;

                        _this2.reset();
                        modal.close();
                        resolve(true);
                    },
                    negative: function negative(_ref2) {
                        var modal = _ref2.modal,
                            $scope = _ref2.$scope;

                        modal.close();
                        window.history.go(-1);
                        resolve(false);
                    },
                    type: 'primary',
                    buttons: ['common.yes', 'common.no']
                });
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + 'is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return ServiceTicketPartsBaseController;
}(_commonBase2.default);

exports.default = ServiceTicketPartsBaseController;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTBillingBase2 = __webpack_require__(120);

var _CommonTNTBillingBase3 = _interopRequireDefault(_CommonTNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillableEventsBaseController = function (_CommonTNTBillingBase) {
    BillableEventsBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(BillableEventsBaseController, _CommonTNTBillingBase);

    /*@ngInject*/
    function BillableEventsBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, BillableEventsBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BillableEventsBaseController.__proto__ || (0, _getPrototypeOf2.default)(BillableEventsBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(BillableEventsBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.Modal.confirm({
                    header: _this2.$translate.instant('billableEvents.create_another_title'),
                    message: _this2.$translate.instant('billableEvents.create_another_message'),
                    callback: function callback(_ref) {
                        var modal = _ref.modal,
                            $scope = _ref.$scope;

                        _this2.reset();
                        modal.close();
                        resolve(true);
                    },
                    negative: function negative(_ref2) {
                        var modal = _ref2.modal,
                            $scope = _ref2.$scope;

                        modal.close();
                        window.history.go(-1);
                        resolve(false);
                    },
                    type: 'primary',
                    buttons: ['common.yes', 'common.no']
                });
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + 'is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return BillableEventsBaseController;
}(_CommonTNTBillingBase3.default);

exports.default = BillableEventsBaseController;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTBillingBase2 = __webpack_require__(120);

var _CommonTNTBillingBase3 = _interopRequireDefault(_CommonTNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractBaseController = function (_CommonTNTBillingBase) {
  ContractBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(ContractBaseController, _CommonTNTBillingBase);

  /*@ngInject*/
  function ContractBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, ContractBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ContractBaseController.__proto__ || (0, _getPrototypeOf2.default)(ContractBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.model = {};
    return _this;
  }

  (0, _createClass3.default)(ContractBaseController, [{
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        _this2.Modal.confirm({
          header: _this2.$translate.instant('contract.create_another_title'),
          message: _this2.$translate.instant('contract.create_another_message'),
          callback: function callback(_ref) {
            var modal = _ref.modal,
                $scope = _ref.$scope;

            _this2.reset();
            modal.close();
            resolve(true);
          },
          negative: function negative(_ref2) {
            var modal = _ref2.modal,
                $scope = _ref2.$scope;

            modal.close();
            window.history.go(-1);
            resolve(false);
          },
          type: 'primary',
          buttons: ['common.yes', 'common.no']
        });
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();
      for (var key in this.model) {
        if (!this.model[key]) {
          this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory');
        }
      }
      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return ContractBaseController;
}(_CommonTNTBillingBase3.default);

exports.default = ContractBaseController;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTBillingBase2 = __webpack_require__(120);

var _CommonTNTBillingBase3 = _interopRequireDefault(_CommonTNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationDistanceBaseController = function (_CommonTNTBillingBase) {
    LocationDistanceBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(LocationDistanceBaseController, _CommonTNTBillingBase);

    /*@ngInject*/
    function LocationDistanceBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, LocationDistanceBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LocationDistanceBaseController.__proto__ || (0, _getPrototypeOf2.default)(LocationDistanceBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(LocationDistanceBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.Modal.confirm({
                    header: _this2.$translate.instant('common.Create'),
                    message: _this2.$translate.instant('common.create_another_record'),
                    callback: function callback(_ref) {
                        var modal = _ref.modal,
                            $scope = _ref.$scope;

                        _this2.reset();
                        modal.close();
                        resolve(true);
                    },
                    negative: function negative(_ref2) {
                        var modal = _ref2.modal,
                            $scope = _ref2.$scope;

                        modal.close();
                        window.history.go(-1);
                        resolve(false);
                    },
                    type: 'primary',
                    buttons: ['common.yes', 'common.no']
                });
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + 'is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return LocationDistanceBaseController;
}(_CommonTNTBillingBase3.default);

exports.default = LocationDistanceBaseController;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTControlBase2 = __webpack_require__(81);

var _CommonTNTControlBase3 = _interopRequireDefault(_CommonTNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileBaseController = function (_CommonTNTControlBase) {
    ATMLoadProfileBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(ATMLoadProfileBaseController, _CommonTNTControlBase);

    /*@ngInject*/
    function ATMLoadProfileBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, ATMLoadProfileBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ATMLoadProfileBaseController.__proto__ || (0, _getPrototypeOf2.default)(ATMLoadProfileBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(ATMLoadProfileBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            this.Modal.confirm({
                header: this.$translate.instant('atm_load_profile.create_another_title'),
                message: this.$translate.instant('atm_load_profile.create_another_message'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    _this2.reset();
                    modal.close();
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal,
                        $scope = _ref2.$scope;

                    modal.close();
                    window.history.go(-1);
                },
                type: 'primary',
                buttons: ['common.yes', 'common.no']
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return ATMLoadProfileBaseController;
}(_CommonTNTControlBase3.default);

exports.default = ATMLoadProfileBaseController;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTControlBase2 = __webpack_require__(81);

var _CommonTNTControlBase3 = _interopRequireDefault(_CommonTNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterBaseController = function (_CommonTNTControlBase) {
    CostCenterBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(CostCenterBaseController, _CommonTNTControlBase);

    /*@ngInject*/
    function CostCenterBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, CostCenterBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CostCenterBaseController.__proto__ || (0, _getPrototypeOf2.default)(CostCenterBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(CostCenterBaseController, [{
        key: 'reset',
        value: function reset() {
            this.clearErrors();
            this.model = angular.copy(this.defaultModel);
        }
    }, {
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            this.Modal.confirm({
                header: this.$translate.instant('costCenter.create_another_title'),
                message: this.$translate.instant('costCenter.create_another_message'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    _this2.reset();
                    modal.close();
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal,
                        $scope = _ref2.$scope;

                    modal.close();
                    window.history.go(-1);
                },
                type: 'primary',
                buttons: ['common.yes', 'common.no']
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return CostCenterBaseController;
}(_CommonTNTControlBase3.default);

exports.default = CostCenterBaseController;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTControlBase2 = __webpack_require__(81);

var _CommonTNTControlBase3 = _interopRequireDefault(_CommonTNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DenominationBaseController = function (_CommonTNTControlBase) {
    DenominationBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(DenominationBaseController, _CommonTNTControlBase);

    /*@ngInject*/
    function DenominationBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, DenominationBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DenominationBaseController.__proto__ || (0, _getPrototypeOf2.default)(DenominationBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        _this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: 'Yes',
                off: 'No'
            },
            onColor: 'success',
            offColor: 'danger'
        };
        _this.packagingOptions = ['BOXED', 'BAGGED', 'ROLLED', 'INDIVIDUAL'];
        return _this;
    }

    (0, _createClass3.default)(DenominationBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            this.Modal.confirm({
                header: this.$translate.instant('denomination.create_another_title'),
                message: this.$translate.instant('denomination.create_another_message'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    _this2.reset();
                    modal.close();
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal,
                        $scope = _ref2.$scope;

                    modal.close();
                    window.history.go(-1);
                },
                type: 'primary',
                buttons: ['common.yes', 'common.no']
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return DenominationBaseController;
}(_CommonTNTControlBase3.default);

exports.default = DenominationBaseController;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnvironmentConfigBaseController = function (_CommonBase) {
    EnvironmentConfigBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(EnvironmentConfigBaseController, _CommonBase);

    /*@ngInject*/
    function EnvironmentConfigBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, EnvironmentConfigBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EnvironmentConfigBaseController.__proto__ || (0, _getPrototypeOf2.default)(EnvironmentConfigBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(EnvironmentConfigBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.Modal.confirm({
                    header: _this2.$translate.instant('common.Create'),
                    message: _this2.$translate.instant('environmentConfig.create_another_message'),
                    callback: function callback(_ref) {
                        var modal = _ref.modal,
                            $scope = _ref.$scope;

                        _this2.reset();
                        modal.close();
                        resolve(true);
                    },
                    negative: function negative(_ref2) {
                        var modal = _ref2.modal,
                            $scope = _ref2.$scope;

                        modal.close();
                        window.history.go(-1);
                        resolve(false);
                    },
                    type: 'primary',
                    buttons: ['common.yes', 'common.no']
                });
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + 'is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return EnvironmentConfigBaseController;
}(_commonBase2.default);

exports.default = EnvironmentConfigBaseController;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTControlBase2 = __webpack_require__(81);

var _CommonTNTControlBase3 = _interopRequireDefault(_CommonTNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationZoneBaseController = function (_CommonTNTControlBase) {
    LocationZoneBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(LocationZoneBaseController, _CommonTNTControlBase);

    /*@ngInject*/
    function LocationZoneBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, LocationZoneBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LocationZoneBaseController.__proto__ || (0, _getPrototypeOf2.default)(LocationZoneBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(LocationZoneBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.Modal.confirm({
                    header: _this2.$translate.instant('common.Create'),
                    message: _this2.$translate.instant('locationZone.create_another_message'),
                    callback: function callback(_ref) {
                        var modal = _ref.modal,
                            $scope = _ref.$scope;

                        _this2.reset();
                        modal.close();
                        resolve(true);
                    },
                    negative: function negative(_ref2) {
                        var modal = _ref2.modal,
                            $scope = _ref2.$scope;

                        modal.close();
                        window.history.go(-1);
                        resolve(false);
                    },
                    type: 'primary',
                    buttons: ['common.yes', 'common.no']
                });
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + 'is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return LocationZoneBaseController;
}(_CommonTNTControlBase3.default);

exports.default = LocationZoneBaseController;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTControlBase2 = __webpack_require__(81);

var _CommonTNTControlBase3 = _interopRequireDefault(_CommonTNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageBaseController = function (_CommonTNTControlBase) {
  MessageBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(MessageBaseController, _CommonTNTControlBase);

  /*@ngInject*/
  function MessageBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, MessageBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MessageBaseController.__proto__ || (0, _getPrototypeOf2.default)(MessageBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.model = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: _this.$translate.instant('common.yes'),
        off: _this.$translate.instant('common.no')
      },
      onColor: 'success',
      offColor: 'danger'
    };

    return _this;
  }

  (0, _createClass3.default)(MessageBaseController, [{
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant('message.create_another_title'),
        message: this.$translate.instant('message.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: [this.$translate.instant('common.yes'), this.$translate.instant('common.no')]
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();

      for (var key in this.model) {
        if (!this.model[key]) {
          this.addError(key, key + ' is mandatory');
        }
      }

      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return MessageBaseController;
}(_CommonTNTControlBase3.default);

exports.default = MessageBaseController;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTControlBase2 = __webpack_require__(81);

var _CommonTNTControlBase3 = _interopRequireDefault(_CommonTNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementBaseController = function (_CommonTNTControlBase) {
    NotificationManagementBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(NotificationManagementBaseController, _CommonTNTControlBase);

    /*@ngInject*/
    function NotificationManagementBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, NotificationManagementBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationManagementBaseController.__proto__ || (0, _getPrototypeOf2.default)(NotificationManagementBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(NotificationManagementBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            this.Modal.confirm({
                header: this.$translate.instant('notification_management.create_another_title'),
                message: this.$translate.instant('notification_management.create_another_message'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    _this2.reset();
                    modal.close();
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal,
                        $scope = _ref2.$scope;

                    modal.close();
                    window.history.go(-1);
                },
                type: 'primary',
                buttons: ['common.yes', 'common.no']
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return NotificationManagementBaseController;
}(_CommonTNTControlBase3.default);

exports.default = NotificationManagementBaseController;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTControlBase2 = __webpack_require__(81);

var _CommonTNTControlBase3 = _interopRequireDefault(_CommonTNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesBaseController = function (_CommonTNTControlBase) {
    ServiceAssignmentRulesBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(ServiceAssignmentRulesBaseController, _CommonTNTControlBase);

    /*@ngInject*/
    function ServiceAssignmentRulesBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, ServiceAssignmentRulesBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceAssignmentRulesBaseController.__proto__ || (0, _getPrototypeOf2.default)(ServiceAssignmentRulesBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(ServiceAssignmentRulesBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            this.Modal.confirm({
                header: this.$translate.instant('service_assignment_rules.create_another_title'),
                message: this.$translate.instant('service_assignment_rules.create_another_message'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    _this2.reset();
                    modal.close();
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal,
                        $scope = _ref2.$scope;

                    modal.close();
                    window.history.go(-1);
                },
                type: 'primary',
                buttons: ['common.yes', 'common.no']
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return ServiceAssignmentRulesBaseController;
}(_CommonTNTControlBase3.default);

exports.default = ServiceAssignmentRulesBaseController;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTControlBase2 = __webpack_require__(81);

var _CommonTNTControlBase3 = _interopRequireDefault(_CommonTNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiptypeBaseController = function (_CommonTNTControlBase) {
  ShiptypeBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(ShiptypeBaseController, _CommonTNTControlBase);

  /*@ngInject*/
  function ShiptypeBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, ShiptypeBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShiptypeBaseController.__proto__ || (0, _getPrototypeOf2.default)(ShiptypeBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.model = {};
    return _this;
  }

  (0, _createClass3.default)(ShiptypeBaseController, [{
    key: 'reset',
    value: function reset() {
      this.clearErrors();
      this.model = angular.copy(this.defaultModel);
    }
  }, {
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant('shiptype.create_another_title'),
        message: this.$translate.instant('shiptype.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();
      for (var key in this.model) {
        if (!this.model[key]) {
          this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory');
        }
      }
      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return ShiptypeBaseController;
}(_CommonTNTControlBase3.default);

exports.default = ShiptypeBaseController;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TruckBaseController = function (_CommonBase) {
  TruckBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(TruckBaseController, _CommonBase);

  /*@ngInject*/
  function TruckBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, TruckBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TruckBaseController.__proto__ || (0, _getPrototypeOf2.default)(TruckBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.model = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: 'Yes',
        off: 'No'
      },
      onColor: 'success',
      offColor: 'danger'
    };

    return _this;
  }

  (0, _createClass3.default)(TruckBaseController, [{
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant('truck.create_another_title'),
        message: this.$translate.instant('truck.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();

      for (var key in this.model) {
        if (!this.model[key]) {
          this.addError(key, key + ' is mandatory');
        }
      }

      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return TruckBaseController;
}(_commonBase2.default);

exports.default = TruckBaseController;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersBaseController = function (_CommonBase) {
  UsersBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(UsersBaseController, _CommonBase);

  /*@ngInject*/
  function UsersBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, UsersBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UsersBaseController.__proto__ || (0, _getPrototypeOf2.default)(UsersBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.loading = false;
    _this.autoDetecting = false;
    _this.errorMessage = '';
    _this.model = {};
    _this.render = false;
    _this.apiKey = '';

    _this.customerPermissions = ['service_tickets', 'branch_mgmt', 'branch_mgmt_locations', 'branch_mgmt_items', 'branch_mgmt_orders', 'master_cash_schedule', 'branch_mgmt_cash_transactions', 'setting', 'setting-location', 'branch_mgmt_customer_pickup_reports', 'on_demand_call', 'pickup_request_management', 'branch_mgmt_deposit_reports', 'tnt_react_app',
    // Added permissions for customer users
    'branch_mgmt_daily_balance_sheet', 'branch_mgmt_cancelled_shipments', 'branch_mgmt_billing_approval', 'branch_mgmt_contact_request', 'branch_mgmt_stop_scheduling', 'branch_mgmt_bin_manifest', 'branch_mgmt_average_daily_balance', 'bulk_cash_management', 'cash_activity', 'shipment_batch', 'ach_management', 'branch_mgmt_billing_approval_create_billing_record', 'branch_mgmt_billing_approval_approve_billing_record', 'branch_mgmt_billing_approval_edit_billing_record', 'branch_mgmt_billing_approval_delete_billing_record', 'tnt_billing', 'tnt_billing_billable_events', 'tnt_billing_billing_category', 'tnt_billing_contract', 'tnt_billing_customer', 'tnt_billing_location_distance', 'tnt_billing_fuel_surcharges', 'price_point', 'tnt_billing_contract_type'];

    _this.states = _app2.default.states;
    return _this;
  }

  (0, _createClass3.default)(UsersBaseController, [{
    key: 'resetText',
    value: function resetText() {
      this.model.state = null;
      this.model.country = null;
    }
  }, {
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant('users.create_another_title'),
        message: this.$translate.instant('users.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      for (var key in this.model) {
        if (typeof this.model[key] == 'string') {
          this.model[key] = '';
        } else if (typeof this.model[key] == 'boolean') {
          this.model[key] = false;
        }
      }

      this.clearErrors();
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();
      // for (let key in this.model) {
      //   if (!this.model[key] && typeof (this.model[key]) == 'string') {
      //     this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory')
      //   }
      //}

      return true; //Object.keys(this.errors).length <= 0
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }, {
    key: 'autoDetect',
    value: function autoDetect() {
      var _this3 = this;

      var address = '';

      if (this.model.address) address += this.model.address + ", ";
      if (this.model.city) address += this.model.city + ", ";
      if (this.model.state) address += this.model.state + ", ";
      if (this.model.zip) address += this.model.zip + ", ";
      if (this.model.isNonUSLocation && this.model.country) {
        address += this.model.country;
      } else {
        address += 'US';
      }

      if (!address.trim() || address === 'US') {
        return;
      }

      if (typeof google === 'undefined' || !google.maps || !google.maps.Geocoder) {
        this.Modal.errorModal('Google Maps API is not loaded');
        return;
      }

      this.autoDetecting = true;
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': address }, function (results, status) {
        _this3.autoDetecting = false;
        if (status === 'OK' && results && results.length > 0) {
          _this3.model.lat = results[0].geometry.location.lat();
          _this3.model.long = results[0].geometry.location.lng();
          if (_this3.$scope) {
            _this3.$scope.$apply();
          }
        } else if (status === 'ZERO_RESULTS') {
          _this3.Modal.errorModal(_this3.$translate.instant('location.zero_results'));
        } else {
          _this3.Modal.errorModal(_this3.$translate.instant('location.invalidAddress'));
        }
      });
    }
  }]);
  return UsersBaseController;
}(_commonBase2.default);

exports.default = UsersBaseController;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VaultBaseController = function (_CommonBase) {
  VaultBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(VaultBaseController, _CommonBase);

  /*@ngInject*/
  function VaultBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, VaultBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VaultBaseController.__proto__ || (0, _getPrototypeOf2.default)(VaultBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.model = {};
    return _this;
  }

  (0, _createClass3.default)(VaultBaseController, [{
    key: 'askCreate',
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant('vault.create_another_title'),
        message: this.$translate.instant('vault.create_another_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.reset();
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal,
              $scope = _ref2.$scope;

          modal.close();
          window.history.go(-1);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.clearErrors();
      for (var key in this.model) {
        if (!this.model[key]) {
          this.addError(key, key + ' is mandatory');
        }
      }
      return (0, _keys2.default)(this.errors).length <= 0;
    }
  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = '';
    }
  }, {
    key: 'addError',
    value: function addError(id, message) {
      this.errors[id] = message;
    }
  }]);
  return VaultBaseController;
}(_commonBase2.default);

exports.default = VaultBaseController;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module core
 */ /** */
var stateParams_1 = __webpack_require__(290);
var queue_1 = __webpack_require__(180);
/**
 * Global router state
 *
 * This is where we hold the global mutable state such as current state, current
 * params, current transition, etc.
 */
var UIRouterGlobals = (function () {
    function UIRouterGlobals() {
        /**
         * Current parameter values
         *
         * The parameter values from the latest successful transition
         */
        this.params = new stateParams_1.StateParams();
        /** @internalapi */
        this.lastStartedTransitionId = -1;
        /** @internalapi */
        this.transitionHistory = new queue_1.Queue([], 1);
        /** @internalapi */
        this.successfulTransitions = new queue_1.Queue([], 1);
    }
    UIRouterGlobals.prototype.dispose = function () {
        this.transitionHistory.clear();
        this.successfulTransitions.clear();
        this.transition = null;
    };
    return UIRouterGlobals;
}());
exports.UIRouterGlobals = UIRouterGlobals;
//# sourceMappingURL=globals.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var coreservices_1 = __webpack_require__(40);
/**
 * A [[TransitionHookFn]] that performs lazy loading
 *
 * When entering a state "abc" which has a `lazyLoad` function defined:
 * - Invoke the `lazyLoad` function (unless it is already in process)
 *   - Flag the hook function as "in process"
 *   - The function should return a promise (that resolves when lazy loading is complete)
 * - Wait for the promise to settle
 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
 *   - Flag the hook function as "not in process"
 * - If the hook was successful
 *   - Remove the `lazyLoad` function from the state declaration
 * - If all the hooks were successful
 *   - Retry the transition (by returning a TargetState)
 *
 * ```
 * .state('abc', {
 *   component: 'fooComponent',
 *   lazyLoad: () => System.import('./fooComponent')
 *   });
 * ```
 *
 * See [[StateDeclaration.lazyLoad]]
 */
var lazyLoadHook = function (transition) {
    var router = transition.router;
    function retryTransition() {
        if (transition.originalTransition().options().source !== 'url') {
            // The original transition was not triggered via url sync
            // The lazy state should be loaded now, so re-try the original transition
            var orig = transition.targetState();
            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
        }
        // The original transition was triggered via url sync
        // Run the URL rules and find the best match
        var $url = router.urlService;
        var result = $url.match($url.parts());
        var rule = result && result.rule;
        // If the best match is a state, redirect the transition (instead
        // of calling sync() which supersedes the current transition)
        if (rule && rule.type === "STATE") {
            var state = rule.state;
            var params = result.match;
            return router.stateService.target(state, params, transition.options());
        }
        // No matching state found, so let .sync() choose the best non-state match/otherwise
        router.urlService.sync();
    }
    var promises = transition.entering()
        .filter(function (state) { return !!state.$$state().lazyLoad; })
        .map(function (state) { return lazyLoadState(transition, state); });
    return coreservices_1.services.$q.all(promises).then(retryTransition);
};
exports.registerLazyLoadHook = function (transitionService) {
    return transitionService.onBefore({ entering: function (state) { return !!state.lazyLoad; } }, lazyLoadHook);
};
/**
 * Invokes a state's lazy load function
 *
 * @param transition a Transition context
 * @param state the state to lazy load
 * @returns A promise for the lazy load result
 */
function lazyLoadState(transition, state) {
    var lazyLoadFn = state.$$state().lazyLoad;
    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
    var promise = lazyLoadFn['_promise'];
    if (!promise) {
        var success = function (result) {
            delete state.lazyLoad;
            delete state.$$state().lazyLoad;
            delete lazyLoadFn['_promise'];
            return result;
        };
        var error = function (err) {
            delete lazyLoadFn['_promise'];
            return coreservices_1.services.$q.reject(err);
        };
        promise = lazyLoadFn['_promise'] =
            coreservices_1.services.$q.when(lazyLoadFn(transition, state))
                .then(updateStateRegistry)
                .then(success, error);
    }
    /** Register any lazy loaded state definitions */
    function updateStateRegistry(result) {
        if (result && Array.isArray(result.states)) {
            result.states.forEach(function (state) { return transition.router.stateRegistry.register(state); });
        }
        return result;
    }
    return promise;
}
exports.lazyLoadState = lazyLoadState;
//# sourceMappingURL=lazyLoad.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module params
 */
/** */
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
var hof_1 = __webpack_require__(26);
var coreservices_1 = __webpack_require__(40);
var paramType_1 = __webpack_require__(181);
/**
 * A registry for parameter types.
 *
 * This registry manages the built-in (and custom) parameter types.
 *
 * The built-in parameter types are:
 *
 * - [[string]]
 * - [[path]]
 * - [[query]]
 * - [[hash]]
 * - [[int]]
 * - [[bool]]
 * - [[date]]
 * - [[json]]
 * - [[any]]
 */
var ParamTypes = (function () {
    /** @internalapi */
    function ParamTypes() {
        /** @hidden */
        this.enqueue = true;
        /** @hidden */
        this.typeQueue = [];
        /** @internalapi */
        this.defaultTypes = common_1.pick(ParamTypes.prototype, ["hash", "string", "query", "path", "int", "bool", "date", "json", "any"]);
        // Register default types. Store them in the prototype of this.types.
        var makeType = function (definition, name) {
            return new paramType_1.ParamType(common_1.extend({ name: name }, definition));
        };
        this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
    }
    /** @internalapi */
    ParamTypes.prototype.dispose = function () {
        this.types = {};
    };
    /**
     * Registers a parameter type
     *
     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
     */
    ParamTypes.prototype.type = function (name, definition, definitionFn) {
        if (!predicates_1.isDefined(definition))
            return this.types[name];
        if (this.types.hasOwnProperty(name))
            throw new Error("A type named '" + name + "' has already been defined.");
        this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
        if (definitionFn) {
            this.typeQueue.push({ name: name, def: definitionFn });
            if (!this.enqueue)
                this._flushTypeQueue();
        }
        return this;
    };
    /** @internalapi */
    ParamTypes.prototype._flushTypeQueue = function () {
        while (this.typeQueue.length) {
            var type = this.typeQueue.shift();
            if (type.pattern)
                throw new Error("You cannot override a type's .pattern at runtime.");
            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
        }
    };
    return ParamTypes;
}());
exports.ParamTypes = ParamTypes;
/** @hidden */
function initDefaultTypes() {
    var makeDefaultType = function (def) {
        var valToString = function (val) {
            return val != null ? val.toString() : val;
        };
        var defaultTypeBase = {
            encode: valToString,
            decode: valToString,
            is: hof_1.is(String),
            pattern: /.*/,
            equals: function (a, b) { return a == b; },
        };
        return common_1.extend({}, defaultTypeBase, def);
    };
    // Default Parameter Type Definitions
    common_1.extend(ParamTypes.prototype, {
        string: makeDefaultType({}),
        path: makeDefaultType({
            pattern: /[^/]*/,
        }),
        query: makeDefaultType({}),
        hash: makeDefaultType({
            inherit: false,
        }),
        int: makeDefaultType({
            decode: function (val) { return parseInt(val, 10); },
            is: function (val) {
                return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
            },
            pattern: /-?\d+/,
        }),
        bool: makeDefaultType({
            encode: function (val) { return val && 1 || 0; },
            decode: function (val) { return parseInt(val, 10) !== 0; },
            is: hof_1.is(Boolean),
            pattern: /0|1/
        }),
        date: makeDefaultType({
            encode: function (val) {
                return !this.is(val) ? undefined : [
                    val.getFullYear(),
                    ('0' + (val.getMonth() + 1)).slice(-2),
                    ('0' + val.getDate()).slice(-2)
                ].join("-");
            },
            decode: function (val) {
                if (this.is(val))
                    return val;
                var match = this.capture.exec(val);
                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
            },
            is: function (val) { return val instanceof Date && !isNaN(val.valueOf()); },
            equals: function (l, r) {
                return ['getFullYear', 'getMonth', 'getDate']
                    .reduce(function (acc, fn) { return acc && l[fn]() === r[fn](); }, true);
            },
            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
        }),
        json: makeDefaultType({
            encode: common_1.toJson,
            decode: common_1.fromJson,
            is: hof_1.is(Object),
            equals: common_1.equals,
            pattern: /[^/]*/
        }),
        // does not encode/decode
        any: makeDefaultType({
            encode: common_1.identity,
            decode: common_1.identity,
            is: function () { return true; },
            equals: common_1.equals,
        }),
    });
}
initDefaultTypes();
//# sourceMappingURL=paramTypes.js.map

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module params
 */
/** */
var common_1 = __webpack_require__(15);
/** @internalapi */
var StateParams = (function () {
    function StateParams(params) {
        if (params === void 0) { params = {}; }
        common_1.extend(this, params);
    }
    /**
     * Merges a set of parameters with all parameters inherited between the common parents of the
     * current state and a given destination state.
     *
     * @param {Object} newParams The set of parameters which will be composited with inherited params.
     * @param {Object} $current Internal definition of object representing the current state.
     * @param {Object} $to Internal definition of object representing state to transition to.
     */
    StateParams.prototype.$inherit = function (newParams, $current, $to) {
        var parents = common_1.ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
        for (var i in parents) {
            if (!parents[i] || !parents[i].params)
                continue;
            parentParams = Object.keys(parents[i].params);
            if (!parentParams.length)
                continue;
            for (var j in parentParams) {
                if (inheritList.indexOf(parentParams[j]) >= 0)
                    continue;
                inheritList.push(parentParams[j]);
                inherited[parentParams[j]] = this[parentParams[j]];
            }
        }
        return common_1.extend({}, inherited, newParams);
    };
    ;
    return StateParams;
}());
exports.StateParams = StateParams;
//# sourceMappingURL=stateParams.js.map

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @internalapi */
exports.resolvePolicies = {
    when: {
        LAZY: "LAZY",
        EAGER: "EAGER"
    },
    async: {
        WAIT: "WAIT",
        NOWAIT: "NOWAIT",
        RXWAIT: "RXWAIT"
    }
};
//# sourceMappingURL=interface.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module core
 */ /** */
var urlMatcherFactory_1 = __webpack_require__(300);
var urlRouter_1 = __webpack_require__(301);
var transitionService_1 = __webpack_require__(185);
var view_1 = __webpack_require__(311);
var stateRegistry_1 = __webpack_require__(296);
var stateService_1 = __webpack_require__(297);
var globals_1 = __webpack_require__(287);
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
var urlService_1 = __webpack_require__(303);
var trace_1 = __webpack_require__(83);
/** @hidden */
var _routerInstance = 0;
/**
 * The master class used to instantiate an instance of UI-Router.
 *
 * UI-Router (for each specific framework) will create an instance of this class during bootstrap.
 * This class instantiates and wires the UI-Router services together.
 *
 * After a new instance of the UIRouter class is created, it should be configured for your app.
 * For instance, app states should be registered with the [[UIRouter.stateRegistry]].
 *
 * ---
 *
 * Normally the framework code will bootstrap UI-Router.
 * If you are bootstrapping UIRouter manually, tell it to monitor the URL by calling
 * [[UrlService.listen]] then [[UrlService.sync]].
 */
var UIRouter = (function () {
    /**
     * Creates a new `UIRouter` object
     *
     * @param locationService a [[LocationServices]] implementation
     * @param locationConfig a [[LocationConfig]] implementation
     * @internalapi
     */
    function UIRouter(locationService, locationConfig) {
        if (locationService === void 0) { locationService = urlService_1.UrlService.locationServiceStub; }
        if (locationConfig === void 0) { locationConfig = urlService_1.UrlService.locationConfigStub; }
        this.locationService = locationService;
        this.locationConfig = locationConfig;
        /** @hidden */ this.$id = _routerInstance++;
        /** @hidden */ this._disposed = false;
        /** @hidden */ this._disposables = [];
        /** Provides trace information to the console */
        this.trace = trace_1.trace;
        /** Provides services related to ui-view synchronization */
        this.viewService = new view_1.ViewService();
        /** Provides services related to Transitions */
        this.transitionService = new transitionService_1.TransitionService(this);
        /** Global router state */
        this.globals = new globals_1.UIRouterGlobals();
        /**
         * Deprecated for public use. Use [[urlService]] instead.
         * @deprecated Use [[urlService]] instead
         */
        this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory();
        /**
         * Deprecated for public use. Use [[urlService]] instead.
         * @deprecated Use [[urlService]] instead
         */
        this.urlRouter = new urlRouter_1.UrlRouter(this);
        /** Provides a registry for states, and related registration services */
        this.stateRegistry = new stateRegistry_1.StateRegistry(this);
        /** Provides services related to states */
        this.stateService = new stateService_1.StateService(this);
        /** Provides services related to the URL */
        this.urlService = new urlService_1.UrlService(this);
        /** @hidden */
        this._plugins = {};
        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
        this.globals.$current = this.stateRegistry.root();
        this.globals.current = this.globals.$current.self;
        this.disposable(this.globals);
        this.disposable(this.stateService);
        this.disposable(this.stateRegistry);
        this.disposable(this.transitionService);
        this.disposable(this.urlRouter);
        this.disposable(locationService);
        this.disposable(locationConfig);
    }
    /** Registers an object to be notified when the router is disposed */
    UIRouter.prototype.disposable = function (disposable) {
        this._disposables.push(disposable);
    };
    /**
     * Disposes this router instance
     *
     * When called, clears resources retained by the router by calling `dispose(this)` on all
     * registered [[disposable]] objects.
     *
     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
     *
     * @param disposable (optional) the disposable to dispose
     */
    UIRouter.prototype.dispose = function (disposable) {
        var _this = this;
        if (disposable && predicates_1.isFunction(disposable.dispose)) {
            disposable.dispose(this);
            return undefined;
        }
        this._disposed = true;
        this._disposables.slice().forEach(function (d) {
            try {
                typeof d.dispose === 'function' && d.dispose(_this);
                common_1.removeFrom(_this._disposables, d);
            }
            catch (ignored) { }
        });
    };
    /**
     * Adds a plugin to UI-Router
     *
     * This method adds a UI-Router Plugin.
     * A plugin can enhance or change UI-Router behavior using any public API.
     *
     * #### Example:
     * ```js
     * import { MyCoolPlugin } from "ui-router-cool-plugin";
     *
     * var plugin = router.addPlugin(MyCoolPlugin);
     * ```
     *
     * ### Plugin authoring
     *
     * A plugin is simply a class (or constructor function) which accepts a [[UIRouter]] instance and (optionally) an options object.
     *
     * The plugin can implement its functionality using any of the public APIs of [[UIRouter]].
     * For example, it may configure router options or add a Transition Hook.
     *
     * The plugin can then be published as a separate module.
     *
     * #### Example:
     * ```js
     * export class MyAuthPlugin implements UIRouterPlugin {
     *   constructor(router: UIRouter, options: any) {
     *     this.name = "MyAuthPlugin";
     *     let $transitions = router.transitionService;
     *     let $state = router.stateService;
     *
     *     let authCriteria = {
     *       to: (state) => state.data && state.data.requiresAuth
     *     };
     *
     *     function authHook(transition: Transition) {
     *       let authService = transition.injector().get('AuthService');
     *       if (!authService.isAuthenticated()) {
     *         return $state.target('login');
     *       }
     *     }
     *
     *     $transitions.onStart(authCriteria, authHook);
     *   }
     * }
     * ```
     *
     * @param plugin one of:
     *        - a plugin class which implements [[UIRouterPlugin]]
     *        - a constructor function for a [[UIRouterPlugin]] which accepts a [[UIRouter]] instance
     *        - a factory function which accepts a [[UIRouter]] instance and returns a [[UIRouterPlugin]] instance
     * @param options options to pass to the plugin class/factory
     * @returns the registered plugin instance
     */
    UIRouter.prototype.plugin = function (plugin, options) {
        if (options === void 0) { options = {}; }
        var pluginInstance = new plugin(this, options);
        if (!pluginInstance.name)
            throw new Error("Required property `name` missing on plugin: " + pluginInstance);
        this._disposables.push(pluginInstance);
        return this._plugins[pluginInstance.name] = pluginInstance;
    };
    UIRouter.prototype.getPlugin = function (pluginName) {
        return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
    };
    return UIRouter;
}());
exports.UIRouter = UIRouter;
//# sourceMappingURL=router.js.map

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module state */ /** for typedoc */
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
var strings_1 = __webpack_require__(82);
var hof_1 = __webpack_require__(26);
var resolvable_1 = __webpack_require__(122);
var coreservices_1 = __webpack_require__(40);
var parseUrl = function (url) {
    if (!predicates_1.isString(url))
        return false;
    var root = url.charAt(0) === '^';
    return { val: root ? url.substring(1) : url, root: root };
};
function nameBuilder(state) {
    return state.name;
}
function selfBuilder(state) {
    state.self.$$state = function () { return state; };
    return state.self;
}
function dataBuilder(state) {
    if (state.parent && state.parent.data) {
        state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
    }
    return state.data;
}
var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
    return function urlBuilder(state) {
        var stateDec = state;
        // For future states, i.e., states whose name ends with `.**`,
        // match anything that starts with the url prefix
        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
            stateDec.url += "{remainder:any}"; // match any path (.*)
        }
        var parsed = parseUrl(stateDec.url), parent = state.parent;
        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, {
            params: state.params || {},
            paramMap: function (paramConfig, isSearch) {
                if (stateDec.reloadOnSearch === false && isSearch)
                    paramConfig = common_1.extend(paramConfig || {}, { dynamic: true });
                return paramConfig;
            }
        });
        if (!url)
            return null;
        if (!$urlMatcherFactoryProvider.isMatcher(url))
            throw new Error("Invalid url '" + url + "' in state '" + state + "'");
        return (parsed && parsed.root) ? url : ((parent && parent.navigable) || root()).url.append(url);
    };
};
var getNavigableBuilder = function (isRoot) {
    return function navigableBuilder(state) {
        return !isRoot(state) && state.url ? state : (state.parent ? state.parent.navigable : null);
    };
};
var getParamsBuilder = function (paramFactory) {
    return function paramsBuilder(state) {
        var makeConfigParam = function (config, id) { return paramFactory.fromConfig(id, null, config); };
        var urlParams = (state.url && state.url.parameters({ inherit: false })) || [];
        var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
        return urlParams.concat(nonUrlParams).map(function (p) { return [p.id, p]; }).reduce(common_1.applyPairs, {});
    };
};
function pathBuilder(state) {
    return state.parent ? state.parent.path.concat(state) : [state];
}
function includesBuilder(state) {
    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
    includes[state.name] = true;
    return includes;
}
/**
 * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
 *
 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
 * validates the `resolve` property and converts it to a [[Resolvable]] array.
 *
 * resolve: input value can be:
 *
 * {
 *   // analyzed but not injected
 *   myFooResolve: function() { return "myFooData"; },
 *
 *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
 *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
 *
 *   // Array split; "DependencyName" dep as string
 *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
 *
 *   // Array split; DependencyType dep as token (compared using ===)
 *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
 *
 *   // val.$inject used as deps
 *   // where:
 *   //     corgeResolve.$inject = ["DependencyName"];
 *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
 *   // then "DependencyName" dep as string
 *   myCorgeResolve: corgeResolve,
 *
 *  // inject service by name
 *  // When a string is found, desugar creating a resolve that injects the named service
 *   myGraultResolve: "SomeService"
 * }
 *
 * or:
 *
 * [
 *   new Resolvable("myFooResolve", function() { return "myFooData" }),
 *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
 *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
 * ]
 */
function resolvablesBuilder(state) {
    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
    var objects2Tuples = function (resolveObj, resolvePolicies) {
        return Object.keys(resolveObj || {}).map(function (token) { return ({ token: token, val: resolveObj[token], deps: undefined, policy: resolvePolicies[token] }); });
    };
    /** fetch DI annotations from a function or ng1-style array */
    var annotate = function (fn) {
        var $injector = coreservices_1.services.$injector;
        // ng1 doesn't have an $injector until runtime.
        // If the $injector doesn't exist, use "deferred" literal as a
        // marker indicating they should be annotated when runtime starts
        return fn['$inject'] || ($injector && $injector.annotate(fn, $injector.strictDi)) || "deferred";
    };
    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
    var isResolveLiteral = function (obj) { return !!(obj.token && obj.resolveFn); };
    /** true if the object looks like a provide literal, or a ng2 Provider */
    var isLikeNg2Provider = function (obj) { return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass)); };
    /** true if the object looks like a tuple from obj2Tuples */
    var isTupleFromObj = function (obj) { return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val))); };
    /** extracts the token from a Provider or provide literal */
    var token = function (p) { return p.provide || p.token; };
    /** Given a literal resolve or provider object, returns a Resolvable */
    var literal2Resolvable = hof_1.pattern([
        [hof_1.prop('resolveFn'), function (p) { return new resolvable_1.Resolvable(token(p), p.resolveFn, p.deps, p.policy); }],
        [hof_1.prop('useFactory'), function (p) { return new resolvable_1.Resolvable(token(p), p.useFactory, (p.deps || p.dependencies), p.policy); }],
        [hof_1.prop('useClass'), function (p) { return new resolvable_1.Resolvable(token(p), function () { return new p.useClass(); }, [], p.policy); }],
        [hof_1.prop('useValue'), function (p) { return new resolvable_1.Resolvable(token(p), function () { return p.useValue; }, [], p.policy, p.useValue); }],
        [hof_1.prop('useExisting'), function (p) { return new resolvable_1.Resolvable(token(p), common_1.identity, [p.useExisting], p.policy); }],
    ]);
    var tuple2Resolvable = hof_1.pattern([
        [hof_1.pipe(hof_1.prop("val"), predicates_1.isString), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy); }],
        [hof_1.pipe(hof_1.prop("val"), predicates_1.isArray), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy); }],
        [hof_1.pipe(hof_1.prop("val"), predicates_1.isFunction), function (tuple) { return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy); }],
    ]);
    var item2Resolvable = hof_1.pattern([
        [hof_1.is(resolvable_1.Resolvable), function (r) { return r; }],
        [isResolveLiteral, literal2Resolvable],
        [isLikeNg2Provider, literal2Resolvable],
        [isTupleFromObj, tuple2Resolvable],
        [hof_1.val(true), function (obj) { throw new Error("Invalid resolve value: " + strings_1.stringify(obj)); }]
    ]);
    // If resolveBlock is already an array, use it as-is.
    // Otherwise, assume it's an object and convert to an Array of tuples
    var decl = state.resolve;
    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
    return items.map(item2Resolvable);
}
exports.resolvablesBuilder = resolvablesBuilder;
/**
 * @internalapi A internal global service
 *
 * StateBuilder is a factory for the internal [[StateObject]] objects.
 *
 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
 * [[StateObject]] object, which has an API and is used internally.
 *
 * Custom properties or API may be added to the internal [[StateObject]] object by registering a decorator function
 * using the [[builder]] method.
 */
var StateBuilder = (function () {
    function StateBuilder(matcher, urlMatcherFactory) {
        this.matcher = matcher;
        var self = this;
        var root = function () { return matcher.find(""); };
        var isRoot = function (state) { return state.name === ""; };
        function parentBuilder(state) {
            if (isRoot(state))
                return null;
            return matcher.find(self.parentName(state)) || root();
        }
        this.builders = {
            name: [nameBuilder],
            self: [selfBuilder],
            parent: [parentBuilder],
            data: [dataBuilder],
            // Build a URLMatcher if necessary, either via a relative or absolute URL
            url: [getUrlBuilder(urlMatcherFactory, root)],
            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
            navigable: [getNavigableBuilder(isRoot)],
            params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
            // Each framework-specific ui-router implementation should define its own `views` builder
            // e.g., src/ng1/statebuilders/views.ts
            views: [],
            // Keep a full path from the root down to this state as this is needed for state activation.
            path: [pathBuilder],
            // Speed up $state.includes() as it's used a lot
            includes: [includesBuilder],
            resolvables: [resolvablesBuilder]
        };
    }
    /**
     * Registers a [[BuilderFunction]] for a specific [[StateObject]] property (e.g., `parent`, `url`, or `path`).
     * More than one BuilderFunction can be registered for a given property.
     *
     * The BuilderFunction(s) will be used to define the property on any subsequently built [[StateObject]] objects.
     *
     * @param name The name of the State property being registered for.
     * @param fn The BuilderFunction which will be used to build the State property
     * @returns a function which deregisters the BuilderFunction
     */
    StateBuilder.prototype.builder = function (name, fn) {
        var builders = this.builders;
        var array = builders[name] || [];
        // Backwards compat: if only one builder exists, return it, else return whole arary.
        if (predicates_1.isString(name) && !predicates_1.isDefined(fn))
            return array.length > 1 ? array : array[0];
        if (!predicates_1.isString(name) || !predicates_1.isFunction(fn))
            return;
        builders[name] = array;
        builders[name].push(fn);
        return function () { return builders[name].splice(builders[name].indexOf(fn, 1)) && null; };
    };
    /**
     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
     * properties and API built.
     *
     * @param state an uninitialized State object
     * @returns the built State object
     */
    StateBuilder.prototype.build = function (state) {
        var _a = this, matcher = _a.matcher, builders = _a.builders;
        var parent = this.parentName(state);
        if (parent && !matcher.find(parent, undefined, false)) {
            return null;
        }
        for (var key in builders) {
            if (!builders.hasOwnProperty(key))
                continue;
            var chain = builders[key].reduce(function (parentFn, step) { return function (_state) { return step(_state, parentFn); }; }, common_1.noop);
            state[key] = chain(state);
        }
        return state;
    };
    StateBuilder.prototype.parentName = function (state) {
        var name = state.name || "";
        var segments = name.split('.');
        if (segments.length > 1) {
            if (state.parent) {
                throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
            }
            var lastSegment = segments.pop();
            if (lastSegment === '**')
                segments.pop();
            return segments.join(".");
        }
        if (!state.parent)
            return "";
        return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
    };
    StateBuilder.prototype.name = function (state) {
        var name = state.name;
        if (name.indexOf('.') !== -1 || !state.parent)
            return name;
        var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
        return parentName ? parentName + "." + name : name;
    };
    return StateBuilder;
}());
exports.StateBuilder = StateBuilder;
//# sourceMappingURL=stateBuilder.js.map

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module state */ /** for typedoc */
var predicates_1 = __webpack_require__(21);
var common_1 = __webpack_require__(15);
var StateMatcher = (function () {
    function StateMatcher(_states) {
        this._states = _states;
    }
    StateMatcher.prototype.isRelative = function (stateName) {
        stateName = stateName || "";
        return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
    };
    StateMatcher.prototype.find = function (stateOrName, base, matchGlob) {
        if (matchGlob === void 0) { matchGlob = true; }
        if (!stateOrName && stateOrName !== "")
            return undefined;
        var isStr = predicates_1.isString(stateOrName);
        var name = isStr ? stateOrName : stateOrName.name;
        if (this.isRelative(name))
            name = this.resolvePath(name, base);
        var state = this._states[name];
        if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
            return state;
        }
        else if (isStr && matchGlob) {
            var _states = common_1.values(this._states);
            var matches = _states.filter(function (state) {
                return state.__stateObjectCache.nameGlob &&
                    state.__stateObjectCache.nameGlob.matches(name);
            });
            if (matches.length > 1) {
                console.log("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) { return match.name; }));
            }
            return matches[0];
        }
        return undefined;
    };
    StateMatcher.prototype.resolvePath = function (name, base) {
        if (!base)
            throw new Error("No reference point given for path '" + name + "'");
        var baseState = this.find(base);
        var splitName = name.split("."), i = 0, pathLength = splitName.length, current = baseState;
        for (; i < pathLength; i++) {
            if (splitName[i] === "" && i === 0) {
                current = baseState;
                continue;
            }
            if (splitName[i] === "^") {
                if (!current.parent)
                    throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
                current = current.parent;
                continue;
            }
            break;
        }
        var relName = splitName.slice(i).join(".");
        return current.name + (current.name && relName ? "." : "") + relName;
    };
    return StateMatcher;
}());
exports.StateMatcher = StateMatcher;
//# sourceMappingURL=stateMatcher.js.map

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module state */ /** for typedoc */
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
var stateObject_1 = __webpack_require__(183);
var hof_1 = __webpack_require__(26);
/** @internalapi */
var StateQueueManager = (function () {
    function StateQueueManager($registry, $urlRouter, states, builder, listeners) {
        this.$registry = $registry;
        this.$urlRouter = $urlRouter;
        this.states = states;
        this.builder = builder;
        this.listeners = listeners;
        this.queue = [];
        this.matcher = $registry.matcher;
    }
    /** @internalapi */
    StateQueueManager.prototype.dispose = function () {
        this.queue = [];
    };
    StateQueueManager.prototype.register = function (stateDecl) {
        var queue = this.queue;
        var state = stateObject_1.StateObject.create(stateDecl);
        var name = state.name;
        if (!predicates_1.isString(name))
            throw new Error("State must have a valid name");
        if (this.states.hasOwnProperty(name) || common_1.inArray(queue.map(hof_1.prop('name')), name))
            throw new Error("State '" + name + "' is already defined");
        queue.push(state);
        this.flush();
        return state;
    };
    StateQueueManager.prototype.flush = function () {
        var _this = this;
        var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
        var registered = [], // states that got registered
        orphans = [], // states that don't yet have a parent registered
        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
        var getState = function (name) {
            return _this.states.hasOwnProperty(name) && _this.states[name];
        };
        while (queue.length > 0) {
            var state = queue.shift();
            var name_1 = state.name;
            var result = builder.build(state);
            var orphanIdx = orphans.indexOf(state);
            if (result) {
                var existingState = getState(name_1);
                if (existingState && existingState.name === name_1) {
                    throw new Error("State '" + name_1 + "' is already defined");
                }
                var existingFutureState = getState(name_1 + ".**");
                if (existingFutureState) {
                    // Remove future state of the same name
                    this.$registry.deregister(existingFutureState);
                }
                states[name_1] = state;
                this.attachRoute(state);
                if (orphanIdx >= 0)
                    orphans.splice(orphanIdx, 1);
                registered.push(state);
                continue;
            }
            var prev = previousQueueLength[name_1];
            previousQueueLength[name_1] = queue.length;
            if (orphanIdx >= 0 && prev === queue.length) {
                // Wait until two consecutive iterations where no additional states were dequeued successfully.
                // throw new Error(`Cannot register orphaned state '${name}'`);
                queue.push(state);
                return states;
            }
            else if (orphanIdx < 0) {
                orphans.push(state);
            }
            queue.push(state);
        }
        if (registered.length) {
            this.listeners.forEach(function (listener) { return listener("registered", registered.map(function (s) { return s.self; })); });
        }
        return states;
    };
    StateQueueManager.prototype.attachRoute = function (state) {
        if (state.abstract || !state.url)
            return;
        this.$urlRouter.rule(this.$urlRouter.urlRuleFactory.create(state));
    };
    return StateQueueManager;
}());
exports.StateQueueManager = StateQueueManager;
//# sourceMappingURL=stateQueueManager.js.map

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module state
 */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
var stateMatcher_1 = __webpack_require__(294);
var stateBuilder_1 = __webpack_require__(293);
var stateQueueManager_1 = __webpack_require__(295);
var common_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(26);
var StateRegistry = (function () {
    /** @internalapi */
    function StateRegistry(_router) {
        this._router = _router;
        this.states = {};
        this.listeners = [];
        this.matcher = new stateMatcher_1.StateMatcher(this.states);
        this.builder = new stateBuilder_1.StateBuilder(this.matcher, _router.urlMatcherFactory);
        this.stateQueue = new stateQueueManager_1.StateQueueManager(this, _router.urlRouter, this.states, this.builder, this.listeners);
        this._registerRoot();
    }
    /** @internalapi */
    StateRegistry.prototype._registerRoot = function () {
        var rootStateDef = {
            name: '',
            url: '^',
            views: null,
            params: {
                '#': { value: null, type: 'hash', dynamic: true }
            },
            abstract: true
        };
        var _root = this._root = this.stateQueue.register(rootStateDef);
        _root.navigable = null;
    };
    /** @internalapi */
    StateRegistry.prototype.dispose = function () {
        var _this = this;
        this.stateQueue.dispose();
        this.listeners = [];
        this.get().forEach(function (state) { return _this.get(state) && _this.deregister(state); });
    };
    /**
     * Listen for a State Registry events
     *
     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
     *
     * #### Example:
     * ```js
     * let allStates = registry.get();
     *
     * // Later, invoke deregisterFn() to remove the listener
     * let deregisterFn = registry.onStatesChanged((event, states) => {
     *   switch(event) {
     *     case: 'registered':
     *       states.forEach(state => allStates.push(state));
     *       break;
     *     case: 'deregistered':
     *       states.forEach(state => {
     *         let idx = allStates.indexOf(state);
     *         if (idx !== -1) allStates.splice(idx, 1);
     *       });
     *       break;
     *   }
     * });
     * ```
     *
     * @param listener a callback function invoked when the registered states changes.
     *        The function receives two parameters, `event` and `state`.
     *        See [[StateRegistryListener]]
     * @return a function that deregisters the listener
     */
    StateRegistry.prototype.onStatesChanged = function (listener) {
        this.listeners.push(listener);
        return function deregisterListener() {
            common_1.removeFrom(this.listeners)(listener);
        }.bind(this);
    };
    /**
     * Gets the implicit root state
     *
     * Gets the root of the state tree.
     * The root state is implicitly created by UI-Router.
     * Note: this returns the internal [[StateObject]] representation, not a [[StateDeclaration]]
     *
     * @return the root [[StateObject]]
     */
    StateRegistry.prototype.root = function () {
        return this._root;
    };
    /**
     * Adds a state to the registry
     *
     * Registers a [[StateDeclaration]] or queues it for registration.
     *
     * Note: a state will be queued if the state's parent isn't yet registered.
     *
     * @param stateDefinition the definition of the state to register.
     * @returns the internal [[StateObject]] object.
     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
     *          If the state was only queued, then the object is not fully built.
     */
    StateRegistry.prototype.register = function (stateDefinition) {
        return this.stateQueue.register(stateDefinition);
    };
    /** @hidden */
    StateRegistry.prototype._deregisterTree = function (state) {
        var _this = this;
        var all = this.get().map(function (s) { return s.$$state(); });
        var getChildren = function (states) {
            var children = all.filter(function (s) { return states.indexOf(s.parent) !== -1; });
            return children.length === 0 ? children : children.concat(getChildren(children));
        };
        var children = getChildren([state]);
        var deregistered = [state].concat(children).reverse();
        deregistered.forEach(function (state) {
            var $ur = _this._router.urlRouter;
            // Remove URL rule
            $ur.rules().filter(hof_1.propEq("state", state)).forEach($ur.removeRule.bind($ur));
            // Remove state from registry
            delete _this.states[state.name];
        });
        return deregistered;
    };
    /**
     * Removes a state from the registry
     *
     * This removes a state from the registry.
     * If the state has children, they are are also removed from the registry.
     *
     * @param stateOrName the state's name or object representation
     * @returns {StateObject[]} a list of removed states
     */
    StateRegistry.prototype.deregister = function (stateOrName) {
        var _state = this.get(stateOrName);
        if (!_state)
            throw new Error("Can't deregister state; not found: " + stateOrName);
        var deregisteredStates = this._deregisterTree(_state.$$state());
        this.listeners.forEach(function (listener) { return listener("deregistered", deregisteredStates.map(function (s) { return s.self; })); });
        return deregisteredStates;
    };
    StateRegistry.prototype.get = function (stateOrName, base) {
        var _this = this;
        if (arguments.length === 0)
            return Object.keys(this.states).map(function (name) { return _this.states[name].self; });
        var found = this.matcher.find(stateOrName, base);
        return found && found.self || null;
    };
    StateRegistry.prototype.decorator = function (name, func) {
        return this.builder.builder(name, func);
    };
    return StateRegistry;
}());
exports.StateRegistry = StateRegistry;
//# sourceMappingURL=stateRegistry.js.map

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module state
 */
/** */
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
var queue_1 = __webpack_require__(180);
var coreservices_1 = __webpack_require__(40);
var pathFactory_1 = __webpack_require__(146);
var pathNode_1 = __webpack_require__(182);
var transitionService_1 = __webpack_require__(185);
var rejectFactory_1 = __webpack_require__(123);
var targetState_1 = __webpack_require__(90);
var param_1 = __webpack_require__(109);
var glob_1 = __webpack_require__(144);
var resolveContext_1 = __webpack_require__(147);
var lazyLoad_1 = __webpack_require__(288);
var hof_1 = __webpack_require__(26);
/**
 * Provides state related service functions
 *
 * This class provides services related to ui-router states.
 * An instance of this class is located on the global [[UIRouter]] object.
 */
var StateService = (function () {
    /** @internalapi */
    function StateService(router) {
        this.router = router;
        /** @internalapi */
        this.invalidCallbacks = [];
        /** @hidden */
        this._defaultErrorHandler = function $defaultErrorHandler($error$) {
            if ($error$ instanceof Error && $error$.stack) {
                console.error($error$);
                console.error($error$.stack);
            }
            else if ($error$ instanceof rejectFactory_1.Rejection) {
                console.error($error$.toString());
                if ($error$.detail && $error$.detail.stack)
                    console.error($error$.detail.stack);
            }
            else {
                console.error($error$);
            }
        };
        var getters = ['current', '$current', 'params', 'transition'];
        var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
        common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
    }
    Object.defineProperty(StateService.prototype, "transition", {
        /**
         * The [[Transition]] currently in progress (or null)
         *
         * This is a passthrough through to [[UIRouterGlobals.transition]]
         */
        get: function () { return this.router.globals.transition; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "params", {
        /**
         * The latest successful state parameters
         *
         * This is a passthrough through to [[UIRouterGlobals.params]]
         */
        get: function () { return this.router.globals.params; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "current", {
        /**
         * The current [[StateDeclaration]]
         *
         * This is a passthrough through to [[UIRouterGlobals.current]]
         */
        get: function () { return this.router.globals.current; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "$current", {
        /**
         * The current [[StateObject]]
         *
         * This is a passthrough through to [[UIRouterGlobals.$current]]
         */
        get: function () { return this.router.globals.$current; },
        enumerable: true,
        configurable: true
    });
    /** @internalapi */
    StateService.prototype.dispose = function () {
        this.defaultErrorHandler(common_1.noop);
        this.invalidCallbacks = [];
    };
    /**
     * Handler for when [[transitionTo]] is called with an invalid state.
     *
     * Invokes the [[onInvalid]] callbacks, in natural order.
     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
     *
     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
     *
     * @internalapi
     */
    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
        var _this = this;
        var fromState = pathFactory_1.PathUtils.makeTargetState(fromPath);
        var globals = this.router.globals;
        var latestThing = function () { return globals.transitionHistory.peekTail(); };
        var latest = latestThing();
        var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
        var injector = new resolveContext_1.ResolveContext(fromPath).injector();
        var checkForRedirect = function (result) {
            if (!(result instanceof targetState_1.TargetState)) {
                return;
            }
            var target = result;
            // Recreate the TargetState, in case the state is now defined.
            target = _this.target(target.identifier(), target.params(), target.options());
            if (!target.valid()) {
                return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
            }
            if (latestThing() !== latest) {
                return rejectFactory_1.Rejection.superseded().toPromise();
            }
            return _this.transitionTo(target.identifier(), target.params(), target.options());
        };
        function invokeNextCallback() {
            var nextCallback = callbackQueue.dequeue();
            if (nextCallback === undefined)
                return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
            return callbackResult.then(checkForRedirect).then(function (result) { return result || invokeNextCallback(); });
        }
        return invokeNextCallback();
    };
    /**
     * Registers an Invalid State handler
     *
     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
     * has been called with an invalid state reference parameter
     *
     * Example:
     * ```js
     * stateService.onInvalid(function(to, from, injector) {
     *   if (to.name() === 'foo') {
     *     let lazyLoader = injector.get('LazyLoadService');
     *     return lazyLoader.load('foo')
     *         .then(() => stateService.target('foo'));
     *   }
     * });
     * ```
     *
     * @param {function} callback invoked when the toState is invalid
     *   This function receives the (invalid) toState, the fromState, and an injector.
     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
     *   If one is returned, it is treated as a redirect.
     *
     * @returns a function which deregisters the callback
     */
    StateService.prototype.onInvalid = function (callback) {
        this.invalidCallbacks.push(callback);
        return function deregisterListener() {
            common_1.removeFrom(this.invalidCallbacks)(callback);
        }.bind(this);
    };
    /**
     * Reloads the current state
     *
     * A method that force reloads the current state, or a partial state hierarchy.
     * All resolves are re-resolved, and components reinstantiated.
     *
     * #### Example:
     * ```js
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * ```
     *
     * Note: `reload()` is just an alias for:
     *
     * ```js
     * $state.transitionTo($state.current, $state.params, {
     *   reload: true, inherit: false
     * });
     * ```
     *
     * @param reloadState A state name or a state object.
     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
     *
     * #### Example:
     * ```js
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
     * //and current state is 'contacts.detail.item'
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * ```
     *
     * @returns A promise representing the state of the new transition. See [[StateService.go]]
     */
    StateService.prototype.reload = function (reloadState) {
        return this.transitionTo(this.current, this.params, {
            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
            inherit: false,
            notify: false,
        });
    };
    ;
    /**
     * Transition to a different state and/or parameters
     *
     * Convenience method for transitioning to a new state.
     *
     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
     * `{ location: true, inherit: true, relative: router.globals.$current, notify: true }`.
     * This allows you to use either an absolute or relative `to` argument (because of `relative: router.globals.$current`).
     * It also allows you to specify * only the parameters you'd like to update, while letting unspecified parameters
     * inherit from the current parameter values (because of `inherit: true`).
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * ```
     *
     * @param to Absolute state name, state object, or relative state path (relative to current state).
     *
     * Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to the parent state
     * - `$state.go('^.sibling')` - if current state is `home.child`, will go to the `home.sibling` state
     * - `$state.go('.child.grandchild')` - if current state is home, will go to the `home.child.grandchild` state
     *
     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
     *
     *    Any parameters that are not specified will be inherited from current parameter values (because of `inherit: true`).
     *    This allows, for example, going to a sibling state that shares parameters defined by a parent state.
     *
     * @param options Transition options
     *
     * @returns {promise} A promise representing the state of the new transition.
     */
    StateService.prototype.go = function (to, params, options) {
        var defautGoOpts = { relative: this.$current, inherit: true };
        var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
        return this.transitionTo(to, params, transOpts);
    };
    ;
    /**
     * Creates a [[TargetState]]
     *
     * This is a factory method for creating a TargetState
     *
     * This may be returned from a Transition Hook to redirect a transition, for example.
     */
    StateService.prototype.target = function (identifier, params, options) {
        if (options === void 0) { options = {}; }
        // If we're reloading, find the state object to reload from
        if (predicates_1.isObject(options.reload) && !options.reload.name)
            throw new Error('Invalid reload state object');
        var reg = this.router.stateRegistry;
        options.reloadState = options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
        if (options.reload && !options.reloadState)
            throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
        var stateDefinition = reg.matcher.find(identifier, options.relative);
        return new targetState_1.TargetState(identifier, stateDefinition, params, options);
    };
    ;
    StateService.prototype.getCurrentPath = function () {
        var _this = this;
        var globals = this.router.globals;
        var latestSuccess = globals.successfulTransitions.peekTail();
        var rootPath = function () { return [new pathNode_1.PathNode(_this.router.stateRegistry.root())]; };
        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
    };
    /**
     * Low-level method for transitioning to a new state.
     *
     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * ```
     *
     * @param to State name or state object.
     * @param toParams A map of the parameters that will be sent to the state,
     *      will populate $stateParams.
     * @param options Transition options
     *
     * @returns A promise representing the state of the new transition. See [[go]]
     */
    StateService.prototype.transitionTo = function (to, toParams, options) {
        var _this = this;
        if (toParams === void 0) { toParams = {}; }
        if (options === void 0) { options = {}; }
        var router = this.router;
        var globals = router.globals;
        options = common_1.defaults(options, transitionService_1.defaultTransOpts);
        var getCurrent = function () {
            return globals.transition;
        };
        options = common_1.extend(options, { current: getCurrent });
        var ref = this.target(to, toParams, options);
        var currentPath = this.getCurrentPath();
        if (!ref.exists())
            return this._handleInvalidTargetState(currentPath, ref);
        if (!ref.valid())
            return common_1.silentRejection(ref.error());
        /**
         * Special handling for Ignored, Aborted, and Redirected transitions
         *
         * The semantics for the transition.run() promise and the StateService.transitionTo()
         * promise differ. For instance, the run() promise may be rejected because it was
         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
         */
        var rejectedTransitionHandler = function (transition) { return function (error) {
            if (error instanceof rejectFactory_1.Rejection) {
                var isLatest = router.globals.lastStartedTransitionId === transition.$id;
                if (error.type === rejectFactory_1.RejectType.IGNORED) {
                    isLatest && router.urlRouter.update();
                    // Consider ignored `Transition.run()` as a successful `transitionTo`
                    return coreservices_1.services.$q.when(globals.current);
                }
                var detail = error.detail;
                if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
                    // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
                    // by returning the promise for the new (redirect) `Transition.run()`.
                    var redirect = transition.redirect(detail);
                    return redirect.run().catch(rejectedTransitionHandler(redirect));
                }
                if (error.type === rejectFactory_1.RejectType.ABORTED) {
                    isLatest && router.urlRouter.update();
                    return coreservices_1.services.$q.reject(error);
                }
            }
            var errorHandler = _this.defaultErrorHandler();
            errorHandler(error);
            return coreservices_1.services.$q.reject(error);
        }; };
        var transition = this.router.transitionService.create(currentPath, ref);
        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
        common_1.silenceUncaughtInPromise(transitionToPromise); // issue #2676
        // Return a promise for the transition, which also has the transition object on it.
        return common_1.extend(transitionToPromise, { transition: transition });
    };
    ;
    /**
     * Checks if the current state *is* the provided state
     *
     * Similar to [[includes]] but only checks for the full state name.
     * If params is supplied then it will be tested for strict equality against the current
     * active params object, so all params must match with none missing and no extras.
     *
     * #### Example:
     * ```js
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     * ```
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * ```html
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * ```
     *
     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns Returns true if it is the state.
     */
    StateService.prototype.is = function (stateOrName, params, options) {
        options = common_1.defaults(options, { relative: this.$current });
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
        if (!predicates_1.isDefined(state))
            return undefined;
        if (this.$current !== state)
            return false;
        if (!params)
            return true;
        var schema = state.parameters({ inherit: true, matchingKeys: params });
        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
    };
    ;
    /**
     * Checks if the current state *includes* the provided state
     *
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * #### Example when `$state.$current.name === 'contacts.details.item'`
     * ```js
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     * ```
     *
     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
     * ```js
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * ```
     *
     * @param stateOrName A partial name, relative name, glob pattern,
     *   or state object to be searched for within the current state name.
     * @param params A param object, e.g. `{sectionId: section.id}`,
     *   that you'd like to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    StateService.prototype.includes = function (stateOrName, params, options) {
        options = common_1.defaults(options, { relative: this.$current });
        var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
        if (glob) {
            if (!glob.matches(this.$current.name))
                return false;
            stateOrName = this.$current.name;
        }
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
        if (!predicates_1.isDefined(state))
            return undefined;
        if (!predicates_1.isDefined(include[state.name]))
            return false;
        if (!params)
            return true;
        var schema = state.parameters({ inherit: true, matchingKeys: params });
        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
    };
    ;
    /**
     * Generates a URL for a state and parameters
     *
     * Returns the url for the given state populated with the given params.
     *
     * #### Example:
     * ```js
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * ```
     *
     * @param stateOrName The state name or state object you'd like to generate a url from.
     * @param params An object of parameter values to fill the state's required parameters.
     * @param options Options object. The options are:
     *
     * @returns {string} compiled state url
     */
    StateService.prototype.href = function (stateOrName, params, options) {
        var defaultHrefOpts = {
            lossy: true,
            inherit: true,
            absolute: false,
            relative: this.$current,
        };
        options = common_1.defaults(options, defaultHrefOpts);
        params = params || {};
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
        if (!predicates_1.isDefined(state))
            return null;
        if (options.inherit)
            params = this.params.$inherit(params, this.$current, state);
        var nav = (state && options.lossy) ? state.navigable : state;
        if (!nav || nav.url === undefined || nav.url === null) {
            return null;
        }
        return this.router.urlRouter.href(nav.url, params, {
            absolute: options.absolute,
        });
    };
    ;
    /**
     * Sets or gets the default [[transitionTo]] error handler.
     *
     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
     * This includes errors caused by resolves and transition hooks.
     *
     * Note:
     * This handler does not receive certain Transition rejections.
     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
     *
     * The built-in default error handler logs the error to the console.
     *
     * You can provide your own custom handler.
     *
     * #### Example:
     * ```js
     * stateService.defaultErrorHandler(function() {
     *   // Do not log transitionTo errors
     * });
     * ```
     *
     * @param handler a global error handler function
     * @returns the current global error handler
     */
    StateService.prototype.defaultErrorHandler = function (handler) {
        return this._defaultErrorHandler = handler || this._defaultErrorHandler;
    };
    StateService.prototype.get = function (stateOrName, base) {
        var reg = this.router.stateRegistry;
        if (arguments.length === 0)
            return reg.get();
        return reg.get(stateOrName, base || this.$current);
    };
    /**
     * Lazy loads a state
     *
     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
     *
     * @param stateOrName the state that should be lazy loaded
     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
     * This noop transition is not actually run.
     *
     * @returns a promise to lazy load
     */
    StateService.prototype.lazyLoad = function (stateOrName, transition) {
        var state = this.get(stateOrName);
        if (!state || !state.lazyLoad)
            throw new Error("Can not lazy load " + stateOrName);
        var currentPath = this.getCurrentPath();
        var target = pathFactory_1.PathUtils.makeTargetState(currentPath);
        transition = transition || this.router.transitionService.create(currentPath, target);
        return lazyLoad_1.lazyLoadState(transition, state);
    };
    return StateService;
}());
exports.StateService = StateService;
//# sourceMappingURL=stateService.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module transition
 */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
var interface_1 = __webpack_require__(110);
var transitionHook_1 = __webpack_require__(124);
/**
 * This class returns applicable TransitionHooks for a specific Transition instance.
 *
 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
 * determined by the type of hook)
 *
 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
 *
 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
 * in the Transition class, so we must also provide the Transition's _treeChanges)
 *
 */
var HookBuilder = (function () {
    function HookBuilder(transition) {
        this.transition = transition;
    }
    HookBuilder.prototype.buildHooksForPhase = function (phase) {
        var _this = this;
        var $transitions = this.transition.router.transitionService;
        return $transitions._pluginapi._getEvents(phase)
            .map(function (type) { return _this.buildHooks(type); })
            .reduce(common_1.unnestR, [])
            .filter(common_1.identity);
    };
    /**
     * Returns an array of newly built TransitionHook objects.
     *
     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
     * - For each of the [[PathNode]]s, creates a TransitionHook
     *
     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
     */
    HookBuilder.prototype.buildHooks = function (hookType) {
        var transition = this.transition;
        var treeChanges = transition.treeChanges();
        // Find all the matching registered hooks for a given hook type
        var matchingHooks = this.getMatchingHooks(hookType, treeChanges);
        if (!matchingHooks)
            return [];
        var baseHookOptions = {
            transition: transition,
            current: transition.options().current
        };
        var makeTransitionHooks = function (hook) {
            // Fetch the Nodes that caused this hook to match.
            var matches = hook.matches(treeChanges);
            // Select the PathNode[] that will be used as TransitionHook context objects
            var matchingNodes = matches[hookType.criteriaMatchPath.name];
            // Return an array of HookTuples
            return matchingNodes.map(function (node) {
                var _options = common_1.extend({
                    bind: hook.bind,
                    traceData: { hookType: hookType.name, context: node }
                }, baseHookOptions);
                var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state.self : null;
                var transitionHook = new transitionHook_1.TransitionHook(transition, state, hook, _options);
                return { hook: hook, node: node, transitionHook: transitionHook };
            });
        };
        return matchingHooks.map(makeTransitionHooks)
            .reduce(common_1.unnestR, [])
            .sort(tupleSort(hookType.reverseSort))
            .map(function (tuple) { return tuple.transitionHook; });
    };
    /**
     * Finds all RegisteredHooks from:
     * - The Transition object instance hook registry
     * - The TransitionService ($transitions) global hook registry
     *
     * which matched:
     * - the eventType
     * - the matchCriteria (to, from, exiting, retained, entering)
     *
     * @returns an array of matched [[RegisteredHook]]s
     */
    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges) {
        var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
        // Instance and Global hook registries
        var $transitions = this.transition.router.transitionService;
        var registries = isCreate ? [$transitions] : [this.transition, $transitions];
        return registries.map(function (reg) { return reg.getHooks(hookType.name); }) // Get named hooks from registries
            .filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)) // Sanity check
            .reduce(common_1.unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
            .filter(function (hook) { return hook.matches(treeChanges); }); // Only those satisfying matchCriteria
    };
    return HookBuilder;
}());
exports.HookBuilder = HookBuilder;
/**
 * A factory for a sort function for HookTuples.
 *
 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
 * the EventHook priority.
 *
 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
 * @returns a tuple sort function
 */
function tupleSort(reverseDepthSort) {
    if (reverseDepthSort === void 0) { reverseDepthSort = false; }
    return function nodeDepthThenPriority(l, r) {
        var factor = reverseDepthSort ? -1 : 1;
        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
    };
}
//# sourceMappingURL=hookBuilder.js.map

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var transitionHook_1 = __webpack_require__(124);
/**
 * This class defines a type of hook, such as `onBefore` or `onEnter`.
 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
 *
 * @interalapi
 */
var TransitionEventType = (function () {
    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
        if (reverseSort === void 0) { reverseSort = false; }
        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
        if (synchronous === void 0) { synchronous = false; }
        this.name = name;
        this.hookPhase = hookPhase;
        this.hookOrder = hookOrder;
        this.criteriaMatchPath = criteriaMatchPath;
        this.reverseSort = reverseSort;
        this.getResultHandler = getResultHandler;
        this.getErrorHandler = getErrorHandler;
        this.synchronous = synchronous;
    }
    return TransitionEventType;
}());
exports.TransitionEventType = TransitionEventType;
//# sourceMappingURL=transitionEventType.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module url
 */ /** for typedoc */
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
var urlMatcher_1 = __webpack_require__(149);
var param_1 = __webpack_require__(109);
var paramTypes_1 = __webpack_require__(289);
/**
 * Factory for [[UrlMatcher]] instances.
 *
 * The factory is available to ng1 services as
 * `$urlMatcherFactor` or ng1 providers as `$urlMatcherFactoryProvider`.
 */
var UrlMatcherFactory = (function () {
    function UrlMatcherFactory() {
        var _this = this;
        /** @hidden */ this.paramTypes = new paramTypes_1.ParamTypes();
        /** @hidden */ this._isCaseInsensitive = false;
        /** @hidden */ this._isStrictMode = true;
        /** @hidden */ this._defaultSquashPolicy = false;
        /** @hidden */
        this._getConfig = function (config) {
            return common_1.extend({ strict: _this._isStrictMode, caseInsensitive: _this._isCaseInsensitive }, config);
        };
        /** @internalapi Creates a new [[Param]] for a given location (DefType) */
        this.paramFactory = {
            /** Creates a new [[Param]] from a CONFIG block */
            fromConfig: function (id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.CONFIG, _this);
            },
            /** Creates a new [[Param]] from a url PATH */
            fromPath: function (id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.PATH, _this);
            },
            /** Creates a new [[Param]] from a url SEARCH */
            fromSearch: function (id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.SEARCH, _this);
            },
        };
        common_1.extend(this, { UrlMatcher: urlMatcher_1.UrlMatcher, Param: param_1.Param });
    }
    /** @inheritdoc */
    UrlMatcherFactory.prototype.caseInsensitive = function (value) {
        return this._isCaseInsensitive = predicates_1.isDefined(value) ? value : this._isCaseInsensitive;
    };
    /** @inheritdoc */
    UrlMatcherFactory.prototype.strictMode = function (value) {
        return this._isStrictMode = predicates_1.isDefined(value) ? value : this._isStrictMode;
    };
    /** @inheritdoc */
    UrlMatcherFactory.prototype.defaultSquashPolicy = function (value) {
        if (predicates_1.isDefined(value) && value !== true && value !== false && !predicates_1.isString(value))
            throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
        return this._defaultSquashPolicy = predicates_1.isDefined(value) ? value : this._defaultSquashPolicy;
    };
    /**
     * Creates a [[UrlMatcher]] for the specified pattern.
     *
     * @param pattern  The URL pattern.
     * @param config  The config object hash.
     * @returns The UrlMatcher.
     */
    UrlMatcherFactory.prototype.compile = function (pattern, config) {
        return new urlMatcher_1.UrlMatcher(pattern, this.paramTypes, this.paramFactory, this._getConfig(config));
    };
    /**
     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
     *
     * @param object  The object to perform the type check against.
     * @returns `true` if the object matches the `UrlMatcher` interface, by
     *          implementing all the same methods.
     */
    UrlMatcherFactory.prototype.isMatcher = function (object) {
        // TODO: typeof?
        if (!predicates_1.isObject(object))
            return false;
        var result = true;
        common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
            if (predicates_1.isFunction(val))
                result = result && (predicates_1.isDefined(object[name]) && predicates_1.isFunction(object[name]));
        });
        return result;
    };
    ;
    /**
     * Creates and registers a custom [[ParamType]] object
     *
     * A [[ParamType]] can be used to generate URLs with typed parameters.
     *
     * @param name  The type name.
     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
     * @param definitionFn A function that is injected before the app runtime starts.
     *        The result of this function should be a [[ParamTypeDefinition]].
     *        The result is merged into the existing `definition`.
     *        See [[ParamType]] for information on the values accepted.
     *
     * @returns - if a type was registered: the [[UrlMatcherFactory]]
     *   - if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
     *
     * Note: Register custom types *before using them* in a state definition.
     *
     * See [[ParamTypeDefinition]] for examples
     */
    UrlMatcherFactory.prototype.type = function (name, definition, definitionFn) {
        var type = this.paramTypes.type(name, definition, definitionFn);
        return !predicates_1.isDefined(definition) ? type : this;
    };
    ;
    /** @hidden */
    UrlMatcherFactory.prototype.$get = function () {
        this.paramTypes.enqueue = false;
        this.paramTypes._flushTypeQueue();
        return this;
    };
    ;
    /** @internalapi */
    UrlMatcherFactory.prototype.dispose = function () {
        this.paramTypes.dispose();
    };
    return UrlMatcherFactory;
}());
exports.UrlMatcherFactory = UrlMatcherFactory;
//# sourceMappingURL=urlMatcherFactory.js.map

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module url
 */
/** for typedoc */
var common_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(21);
var urlMatcher_1 = __webpack_require__(149);
var hof_1 = __webpack_require__(26);
var urlRule_1 = __webpack_require__(302);
var targetState_1 = __webpack_require__(90);
/** @hidden */
function appendBasePath(url, isHtml5, absolute, baseHref) {
    if (baseHref === '/')
        return url;
    if (isHtml5)
        return baseHref.slice(0, -1) + url;
    if (absolute)
        return baseHref.slice(1) + url;
    return url;
}
/** @hidden */
var getMatcher = hof_1.prop("urlMatcher");
/**
 * Default rule priority sorting function.
 *
 * Sorts rules by:
 *
 * - Explicit priority (set rule priority using [[UrlRulesApi.when]])
 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
 * - Registration order (for rule types other than STATE and URLMATCHER)
 *
 * @coreapi
 */
var defaultRuleSortFn;
defaultRuleSortFn = common_1.composeSort(common_1.sortBy(hof_1.pipe(hof_1.prop("priority"), function (x) { return -x; })), common_1.sortBy(hof_1.pipe(hof_1.prop("type"), function (type) { return ({ "STATE": 4, "URLMATCHER": 4, "REGEXP": 3, "RAW": 2, "OTHER": 1 })[type]; })), function (a, b) { return (getMatcher(a) && getMatcher(b)) ? urlMatcher_1.UrlMatcher.compare(getMatcher(a), getMatcher(b)) : 0; }, common_1.sortBy(hof_1.prop("$id"), common_1.inArray(["REGEXP", "RAW", "OTHER"])));
/**
 * Updates URL and responds to URL changes
 *
 * ### Deprecation warning:
 * This class is now considered to be an internal API
 * Use the [[UrlService]] instead.
 * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
 *
 * This class updates the URL when the state changes.
 * It also responds to changes in the URL.
 */
var UrlRouter = (function () {
    /** @hidden */
    function UrlRouter(router) {
        /** @hidden */ this._sortFn = defaultRuleSortFn;
        /** @hidden */ this._rules = [];
        /** @hidden */ this.interceptDeferred = false;
        /** @hidden */ this._id = 0;
        /** @hidden */ this._sorted = false;
        this._router = router;
        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
        common_1.createProxyFunctions(hof_1.val(UrlRouter.prototype), this, hof_1.val(this));
    }
    /** @internalapi */
    UrlRouter.prototype.dispose = function () {
        this.listen(false);
        this._rules = [];
        delete this._otherwiseFn;
    };
    /** @inheritdoc */
    UrlRouter.prototype.sort = function (compareFn) {
        this._rules.sort(this._sortFn = compareFn || this._sortFn);
        this._sorted = true;
    };
    UrlRouter.prototype.ensureSorted = function () {
        this._sorted || this.sort();
    };
    /**
     * Given a URL, check all rules and return the best [[MatchResult]]
     * @param url
     * @returns {MatchResult}
     */
    UrlRouter.prototype.match = function (url) {
        var _this = this;
        this.ensureSorted();
        url = common_1.extend({ path: '', search: {}, hash: '' }, url);
        var rules = this.rules();
        if (this._otherwiseFn)
            rules.push(this._otherwiseFn);
        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
        var checkRule = function (rule) {
            var match = rule.match(url, _this._router);
            return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
        };
        // The rules are pre-sorted.
        // - Find the first matching rule.
        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
        // - Choose the rule with the highest match weight.
        var best;
        for (var i = 0; i < rules.length; i++) {
            // Stop when there is a 'best' rule and the next rule sorts differently than it.
            if (best && this._sortFn(rules[i], best.rule) !== 0)
                break;
            var current = checkRule(rules[i]);
            // Pick the best MatchResult
            best = (!best || current && current.weight > best.weight) ? current : best;
        }
        return best;
    };
    /** @inheritdoc */
    UrlRouter.prototype.sync = function (evt) {
        if (evt && evt.defaultPrevented)
            return;
        var router = this._router, $url = router.urlService, $state = router.stateService;
        var url = {
            path: $url.path(), search: $url.search(), hash: $url.hash(),
        };
        var best = this.match(url);
        var applyResult = hof_1.pattern([
            [predicates_1.isString, function (newurl) { return $url.url(newurl, true); }],
            [targetState_1.TargetState.isDef, function (def) { return $state.go(def.state, def.params, def.options); }],
            [hof_1.is(targetState_1.TargetState), function (target) { return $state.go(target.state(), target.params(), target.options()); }],
        ]);
        applyResult(best && best.rule.handler(best.match, url, router));
    };
    /** @inheritdoc */
    UrlRouter.prototype.listen = function (enabled) {
        var _this = this;
        if (enabled === false) {
            this._stopFn && this._stopFn();
            delete this._stopFn;
        }
        else {
            return this._stopFn = this._stopFn || this._router.urlService.onChange(function (evt) { return _this.sync(evt); });
        }
    };
    /**
     * Internal API.
     * @internalapi
     */
    UrlRouter.prototype.update = function (read) {
        var $url = this._router.locationService;
        if (read) {
            this.location = $url.path();
            return;
        }
        if ($url.path() === this.location)
            return;
        $url.url(this.location, true);
    };
    /**
     * Internal API.
     *
     * Pushes a new location to the browser history.
     *
     * @internalapi
     * @param urlMatcher
     * @param params
     * @param options
     */
    UrlRouter.prototype.push = function (urlMatcher, params, options) {
        var replace = options && !!options.replace;
        this._router.urlService.url(urlMatcher.format(params || {}), replace);
    };
    /**
     * Builds and returns a URL with interpolated parameters
     *
     * #### Example:
     * ```js
     * matcher = $umf.compile("/about/:person");
     * params = { person: "bob" };
     * $bob = $urlRouter.href(matcher, params);
     * // $bob == "/about/bob";
     * ```
     *
     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
     * @param params An object of parameter values to fill the matcher's required parameters.
     * @param options Options object. The options are:
     *
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     *
     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
     */
    UrlRouter.prototype.href = function (urlMatcher, params, options) {
        var url = urlMatcher.format(params);
        if (url == null)
            return null;
        options = options || { absolute: false };
        var cfg = this._router.urlService.config;
        var isHtml5 = cfg.html5Mode();
        if (!isHtml5 && url !== null) {
            url = "#" + cfg.hashPrefix() + url;
        }
        url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
        if (!options.absolute || !url) {
            return url;
        }
        var slash = (!isHtml5 && url ? '/' : ''), port = cfg.port();
        port = (port === 80 || port === 443 ? '' : ':' + port);
        return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
    };
    /**
     * Manually adds a URL Rule.
     *
     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
     * This api can be used directly for more control (to register a [[BaseUrlRule]], for example).
     * Rules can be created using [[UrlRouter.urlRuleFactory]], or create manually as simple objects.
     *
     * A rule should have a `match` function which returns truthy if the rule matched.
     * It should also have a `handler` function which is invoked if the rule is the best match.
     *
     * @return a function that deregisters the rule
     */
    UrlRouter.prototype.rule = function (rule) {
        var _this = this;
        if (!urlRule_1.UrlRuleFactory.isUrlRule(rule))
            throw new Error("invalid rule");
        rule.$id = this._id++;
        rule.priority = rule.priority || 0;
        this._rules.push(rule);
        this._sorted = false;
        return function () { return _this.removeRule(rule); };
    };
    /** @inheritdoc */
    UrlRouter.prototype.removeRule = function (rule) {
        common_1.removeFrom(this._rules, rule);
    };
    /** @inheritdoc */
    UrlRouter.prototype.rules = function () {
        this.ensureSorted();
        return this._rules.slice();
    };
    /** @inheritdoc */
    UrlRouter.prototype.otherwise = function (handler) {
        var handlerFn = getHandlerFn(handler);
        this._otherwiseFn = this.urlRuleFactory.create(hof_1.val(true), handlerFn);
        this._sorted = false;
    };
    ;
    /** @inheritdoc */
    UrlRouter.prototype.initial = function (handler) {
        var handlerFn = getHandlerFn(handler);
        var matchFn = function (urlParts, router) {
            return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
        };
        this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
    };
    ;
    /** @inheritdoc */
    UrlRouter.prototype.when = function (matcher, handler, options) {
        var rule = this.urlRuleFactory.create(matcher, handler);
        if (predicates_1.isDefined(options && options.priority))
            rule.priority = options.priority;
        this.rule(rule);
        return rule;
    };
    ;
    /** @inheritdoc */
    UrlRouter.prototype.deferIntercept = function (defer) {
        if (defer === undefined)
            defer = true;
        this.interceptDeferred = defer;
    };
    ;
    return UrlRouter;
}());
exports.UrlRouter = UrlRouter;
function getHandlerFn(handler) {
    if (!predicates_1.isFunction(handler) && !predicates_1.isString(handler) && !hof_1.is(targetState_1.TargetState)(handler) && !targetState_1.TargetState.isDef(handler)) {
        throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
    }
    return predicates_1.isFunction(handler) ? handler : hof_1.val(handler);
}
//# sourceMappingURL=urlRouter.js.map

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module url
 */ /** */
var urlMatcher_1 = __webpack_require__(149);
var predicates_1 = __webpack_require__(21);
var common_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(26);
/**
 * Creates a [[UrlRule]]
 *
 * Creates a [[UrlRule]] from a:
 *
 * - `string`
 * - [[UrlMatcher]]
 * - `RegExp`
 * - [[StateObject]]
 * @internalapi
 */
var UrlRuleFactory = (function () {
    function UrlRuleFactory(router) {
        this.router = router;
    }
    UrlRuleFactory.prototype.compile = function (str) {
        return this.router.urlMatcherFactory.compile(str);
    };
    UrlRuleFactory.prototype.create = function (what, handler) {
        var _this = this;
        var makeRule = hof_1.pattern([
            [predicates_1.isString, function (_what) { return makeRule(_this.compile(_what)); }],
            [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) { return _this.fromUrlMatcher(_what, handler); }],
            [predicates_1.isState, function (_what) { return _this.fromState(_what, _this.router); }],
            [hof_1.is(RegExp), function (_what) { return _this.fromRegExp(_what, handler); }],
            [predicates_1.isFunction, function (_what) { return new BaseUrlRule(_what, handler); }],
        ]);
        var rule = makeRule(what);
        if (!rule)
            throw new Error("invalid 'what' in when()");
        return rule;
    };
    /**
     * A UrlRule which matches based on a UrlMatcher
     *
     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     *
     * ## Handler as UrlMatcher
     *
     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
     * The url is replaced with the result.
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var handler = $umf.compile("/home/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     */
    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
        var _handler = handler;
        if (predicates_1.isString(handler))
            handler = this.router.urlMatcherFactory.compile(handler);
        if (hof_1.is(urlMatcher_1.UrlMatcher)(handler))
            _handler = function (match) { return handler.format(match); };
        function match(url) {
            var match = urlMatcher.exec(url.path, url.search, url.hash);
            return urlMatcher.validates(match) && match;
        }
        // Prioritize URLs, lowest to highest:
        // - Some optional URL parameters, but none matched
        // - No optional parameters in URL
        // - Some optional parameters, some matched
        // - Some optional parameters, all matched
        function matchPriority(params) {
            var optional = urlMatcher.parameters().filter(function (param) { return param.isOptional; });
            if (!optional.length)
                return 0.000001;
            var matched = optional.filter(function (param) { return params[param.id]; });
            return matched.length / optional.length;
        }
        var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: "URLMATCHER" };
        return common_1.extend(new BaseUrlRule(match, _handler), details);
    };
    /**
     * A UrlRule which matches a state by its url
     *
     * #### Example:
     * ```js
     * var rule = factory.fromState($state.get('foo'), router);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match);
     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
     * ```
     */
    UrlRuleFactory.prototype.fromState = function (state, router) {
        /**
         * Handles match by transitioning to matched state
         *
         * First checks if the router should start a new transition.
         * A new transition is not required if the current state's URL
         * and the new URL are already identical
         */
        var handler = function (match) {
            var $state = router.stateService;
            var globals = router.globals;
            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
                $state.transitionTo(state, match, { inherit: true, source: "url" });
            }
        };
        var details = { state: state, type: "STATE" };
        return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
    };
    /**
     * A UrlRule which matches based on a regular expression
     *
     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - regexp match array (from `regexp`)
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     *
     * ## Handler as string
     *
     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
     * The string is first interpolated using `string.replace()` style pattern.
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     */
    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
        if (regexp.global || regexp.sticky)
            throw new Error("Rule RegExp must not be global or sticky");
        /**
         * If handler is a string, the url will be replaced by the string.
         * If the string has any String.replace() style variables in it (like `$2`),
         * they will be replaced by the captures from [[match]]
         */
        var redirectUrlTo = function (match) {
            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
            return handler.replace(/\$(\$|\d{1,2})/, function (m, what) {
                return match[what === '$' ? 0 : Number(what)];
            });
        };
        var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
        var match = function (url) {
            return regexp.exec(url.path);
        };
        var details = { regexp: regexp, type: "REGEXP" };
        return common_1.extend(new BaseUrlRule(match, _handler), details);
    };
    return UrlRuleFactory;
}());
UrlRuleFactory.isUrlRule = function (obj) {
    return obj && ['type', 'match', 'handler'].every(function (key) { return predicates_1.isDefined(obj[key]); });
};
exports.UrlRuleFactory = UrlRuleFactory;
/**
 * A base rule which calls `match`
 *
 * The value from the `match` function is passed through to the `handler`.
 * @internalapi
 */
var BaseUrlRule = (function () {
    function BaseUrlRule(match, handler) {
        var _this = this;
        this.match = match;
        this.type = "RAW";
        this.matchPriority = function (match) { return 0 - _this.$id; };
        this.handler = handler || common_1.identity;
    }
    return BaseUrlRule;
}());
exports.BaseUrlRule = BaseUrlRule;
//# sourceMappingURL=urlRule.js.map

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module url
 */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
var coreservices_1 = __webpack_require__(40);
var common_1 = __webpack_require__(15);
/** @hidden */
var makeStub = function (keys) {
    return keys.reduce(function (acc, key) { return (acc[key] = coreservices_1.notImplemented(key), acc); }, { dispose: common_1.noop });
};
/** @hidden */ var locationServicesFns = ["url", "path", "search", "hash", "onChange"];
/** @hidden */ var locationConfigFns = ["port", "protocol", "host", "baseHref", "html5Mode", "hashPrefix"];
/** @hidden */ var umfFns = ["type", "caseInsensitive", "strictMode", "defaultSquashPolicy"];
/** @hidden */ var rulesFns = ["sort", "when", "initial", "otherwise", "rules", "rule", "removeRule"];
/** @hidden */ var syncFns = ["deferIntercept", "listen", "sync", "match"];
/**
 * API for URL management
 */
var UrlService = (function () {
    /** @hidden */
    function UrlService(router, lateBind) {
        if (lateBind === void 0) { lateBind = true; }
        this.router = router;
        this.rules = {};
        this.config = {};
        // proxy function calls from UrlService to the LocationService/LocationConfig
        var locationServices = function () { return router.locationService; };
        common_1.createProxyFunctions(locationServices, this, locationServices, locationServicesFns, lateBind);
        var locationConfig = function () { return router.locationConfig; };
        common_1.createProxyFunctions(locationConfig, this.config, locationConfig, locationConfigFns, lateBind);
        var umf = function () { return router.urlMatcherFactory; };
        common_1.createProxyFunctions(umf, this.config, umf, umfFns);
        var urlRouter = function () { return router.urlRouter; };
        common_1.createProxyFunctions(urlRouter, this.rules, urlRouter, rulesFns);
        common_1.createProxyFunctions(urlRouter, this, urlRouter, syncFns);
    }
    UrlService.prototype.url = function (newurl, replace, state) { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.path = function () { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.search = function () { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.hash = function () { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.onChange = function (callback) { return; };
    ;
    /**
     * Returns the current URL parts
     *
     * This method returns the current URL components as a [[UrlParts]] object.
     *
     * @returns the current url parts
     */
    UrlService.prototype.parts = function () {
        return { path: this.path(), search: this.search(), hash: this.hash() };
    };
    UrlService.prototype.dispose = function () { };
    /** @inheritdoc */
    UrlService.prototype.sync = function (evt) { return; };
    /** @inheritdoc */
    UrlService.prototype.listen = function (enabled) { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.deferIntercept = function (defer) { return; };
    /** @inheritdoc */
    UrlService.prototype.match = function (urlParts) { return; };
    return UrlService;
}());
/** @hidden */
UrlService.locationServiceStub = makeStub(locationServicesFns);
/** @hidden */
UrlService.locationConfigStub = makeStub(locationConfigFns);
exports.UrlService = UrlService;
//# sourceMappingURL=urlService.js.map

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var predicates_1 = __webpack_require__(21);
/** A `LocationConfig` that delegates to the browser's `location` object */
var BrowserLocationConfig = (function () {
    function BrowserLocationConfig(router, _isHtml5) {
        if (_isHtml5 === void 0) { _isHtml5 = false; }
        this._isHtml5 = _isHtml5;
        this._baseHref = undefined;
        this._hashPrefix = "";
    }
    BrowserLocationConfig.prototype.port = function () {
        if (location.port) {
            return Number(location.port);
        }
        return this.protocol() === 'https' ? 443 : 80;
    };
    BrowserLocationConfig.prototype.protocol = function () {
        return location.protocol.replace(/:/g, '');
    };
    BrowserLocationConfig.prototype.host = function () {
        return location.host;
    };
    BrowserLocationConfig.prototype.html5Mode = function () {
        return this._isHtml5;
    };
    BrowserLocationConfig.prototype.hashPrefix = function (newprefix) {
        return predicates_1.isDefined(newprefix) ? this._hashPrefix = newprefix : this._hashPrefix;
    };
    ;
    BrowserLocationConfig.prototype.baseHref = function (href) {
        return predicates_1.isDefined(href) ? this._baseHref = href : this._baseHref || this.applyDocumentBaseHref();
    };
    BrowserLocationConfig.prototype.applyDocumentBaseHref = function () {
        var baseTags = document.getElementsByTagName("base");
        return this._baseHref = baseTags.length ? baseTags[0].href.substr(location.origin.length) : "";
    };
    BrowserLocationConfig.prototype.dispose = function () { };
    return BrowserLocationConfig;
}());
exports.BrowserLocationConfig = BrowserLocationConfig;
//# sourceMappingURL=browserLocationConfig.js.map

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var utils_1 = __webpack_require__(125);
var baseLocationService_1 = __webpack_require__(150);
/** A `LocationServices` that uses the browser hash "#" to get/set the current location */
var HashLocationService = (function (_super) {
    __extends(HashLocationService, _super);
    function HashLocationService(router) {
        var _this = _super.call(this, router, false) || this;
        window.addEventListener('hashchange', _this._listener, false);
        return _this;
    }
    HashLocationService.prototype._get = function () {
        return utils_1.trimHashVal(this._location.hash);
    };
    HashLocationService.prototype._set = function (state, title, url, replace) {
        this._location.hash = url;
    };
    HashLocationService.prototype.dispose = function (router) {
        _super.prototype.dispose.call(this, router);
        window.removeEventListener('hashchange', this._listener);
    };
    return HashLocationService;
}(baseLocationService_1.BaseLocationServices));
exports.HashLocationService = HashLocationService;
//# sourceMappingURL=hashLocationService.js.map

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var index_1 = __webpack_require__(145);
// globally available injectables
var globals = {};
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var ARGUMENT_NAMES = /([^\s,]+)/g;
/**
 * A basic angular1-like injector api
 *
 * This object implements four methods similar to the
 * [angular 1 dependency injector](https://docs.angularjs.org/api/auto/service/$injector)
 *
 * UI-Router evolved from an angular 1 library to a framework agnostic library.
 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
 *
 * This object provides a naive implementation of a globally scoped dependency injection system.
 * It supports the following DI approaches:
 *
 * ### Function parameter names
 *
 * A function's `.toString()` is called, and the parameter names are parsed.
 * This only works when the parameter names aren't "mangled" by a minifier such as UglifyJS.
 *
 * ```js
 * function injectedFunction(FooService, BarService) {
 *   // FooService and BarService are injected
 * }
 * ```
 *
 * ### Function annotation
 *
 * A function may be annotated with an array of dependency names as the `$inject` property.
 *
 * ```js
 * injectedFunction.$inject = [ 'FooService', 'BarService' ];
 * function injectedFunction(fs, bs) {
 *   // FooService and BarService are injected as fs and bs parameters
 * }
 * ```
 *
 * ### Array notation
 *
 * An array provides the names of the dependencies to inject (as strings).
 * The function is the last element of the array.
 *
 * ```js
 * [ 'FooService', 'BarService', function (fs, bs) {
 *   // FooService and BarService are injected as fs and bs parameters
 * }]
 * ```
 *
 * @type {$InjectorLike}
 */
exports.$injector = {
    /** Gets an object from DI based on a string token */
    get: function (name) { return globals[name]; },
    /** Returns true if an object named `name` exists in global DI */
    has: function (name) { return exports.$injector.get(name) != null; },
    /**
     * Injects a function
     *
     * @param fn the function to inject
     * @param context the function's `this` binding
     * @param locals An object with additional DI tokens and values, such as `{ someToken: { foo: 1 } }`
     */
    invoke: function (fn, context, locals) {
        var all = index_1.extend({}, globals, locals || {});
        var params = exports.$injector.annotate(fn);
        var ensureExist = index_1.assertPredicate(function (key) { return all.hasOwnProperty(key); }, function (key) { return "DI can't find injectable: '" + key + "'"; });
        var args = params.filter(ensureExist).map(function (x) { return all[x]; });
        if (index_1.isFunction(fn))
            return fn.apply(context, args);
        else
            return fn.slice(-1)[0].apply(context, args);
    },
    /**
     * Returns a function's dependencies
     *
     * Analyzes a function (or array) and returns an array of DI tokens that the function requires.
     * @return an array of `string`s
     */
    annotate: function (fn) {
        if (!index_1.isInjectable(fn))
            throw new Error("Not an injectable function: " + fn);
        if (fn && fn.$inject)
            return fn.$inject;
        if (index_1.isArray(fn))
            return fn.slice(0, -1);
        var fnStr = fn.toString().replace(STRIP_COMMENTS, '');
        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
        return result || [];
    }
};
//# sourceMappingURL=injector.js.map

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var predicates_1 = __webpack_require__(21);
var common_1 = __webpack_require__(15);
/** A `LocationConfig` mock that gets/sets all config from an in-memory object */
var MemoryLocationConfig = (function () {
    function MemoryLocationConfig() {
        var _this = this;
        this._baseHref = '';
        this._port = 80;
        this._protocol = "http";
        this._host = "localhost";
        this._hashPrefix = "";
        this.port = function () { return _this._port; };
        this.protocol = function () { return _this._protocol; };
        this.host = function () { return _this._host; };
        this.baseHref = function () { return _this._baseHref; };
        this.html5Mode = function () { return false; };
        this.hashPrefix = function (newval) { return predicates_1.isDefined(newval) ? _this._hashPrefix = newval : _this._hashPrefix; };
        this.dispose = common_1.noop;
    }
    return MemoryLocationConfig;
}());
exports.MemoryLocationConfig = MemoryLocationConfig;
//# sourceMappingURL=memoryLocationConfig.js.map

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var baseLocationService_1 = __webpack_require__(150);
/** A `LocationServices` that gets/sets the current location from an in-memory object */
var MemoryLocationService = (function (_super) {
    __extends(MemoryLocationService, _super);
    function MemoryLocationService(router) {
        return _super.call(this, router, true) || this;
    }
    MemoryLocationService.prototype._get = function () {
        return this._url;
    };
    MemoryLocationService.prototype._set = function (state, title, url, replace) {
        this._url = url;
    };
    return MemoryLocationService;
}(baseLocationService_1.BaseLocationServices));
exports.MemoryLocationService = MemoryLocationService;
//# sourceMappingURL=memoryLocationService.js.map

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(125);
var baseLocationService_1 = __webpack_require__(150);
/**
 * A `LocationServices` that gets/sets the current location using the browser's `location` and `history` apis
 *
 * Uses `history.pushState` and `history.replaceState`
 */
var PushStateLocationService = (function (_super) {
    __extends(PushStateLocationService, _super);
    function PushStateLocationService(router) {
        var _this = _super.call(this, router, true) || this;
        _this._config = router.urlService.config;
        window.addEventListener("popstate", _this._listener, false);
        return _this;
    }
    ;
    PushStateLocationService.prototype._get = function () {
        var _a = this._location, pathname = _a.pathname, hash = _a.hash, search = _a.search;
        search = utils_1.splitQuery(search)[1]; // strip ? if found
        hash = utils_1.splitHash(hash)[1]; // strip # if found
        return pathname + (search ? "?" + search : "") + (hash ? "$" + search : "");
    };
    PushStateLocationService.prototype._set = function (state, title, url, replace) {
        var _a = this, _config = _a._config, _history = _a._history;
        var fullUrl = _config.baseHref() + url;
        if (replace) {
            _history.replaceState(state, title, fullUrl);
        }
        else {
            _history.pushState(state, title, fullUrl);
        }
    };
    PushStateLocationService.prototype.dispose = function (router) {
        _super.prototype.dispose.call(this, router);
        window.removeEventListener("popstate", this._listener);
    };
    return PushStateLocationService;
}(baseLocationService_1.BaseLocationServices));
exports.PushStateLocationService = PushStateLocationService;
//# sourceMappingURL=pushStateLocationService.js.map

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var index_1 = __webpack_require__(145);
/**
 * An angular1-like promise api
 *
 * This object implements four methods similar to the
 * [angular 1 promise api](https://docs.angularjs.org/api/ng/service/$q)
 *
 * UI-Router evolved from an angular 1 library to a framework agnostic library.
 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
 *
 * This API provides native ES6 promise support wrapped as a $q-like API.
 * Internally, UI-Router uses this $q object to perform promise operations.
 * The `angular-ui-router` (ui-router for angular 1) uses the $q API provided by angular.
 *
 * $q-like promise api
 */
exports.$q = {
    /** Normalizes a value as a promise */
    when: function (val) { return new Promise(function (resolve, reject) { return resolve(val); }); },
    /** Normalizes a value as a promise rejection */
    reject: function (val) { return new Promise(function (resolve, reject) { reject(val); }); },
    /** @returns a deferred object, which has `resolve` and `reject` functions */
    defer: function () {
        var deferred = {};
        deferred.promise = new Promise(function (resolve, reject) {
            deferred.resolve = resolve;
            deferred.reject = reject;
        });
        return deferred;
    },
    /** Like Promise.all(), but also supports object key/promise notation like $q */
    all: function (promises) {
        if (index_1.isArray(promises)) {
            return Promise.all(promises);
        }
        if (index_1.isObject(promises)) {
            // Convert promises map to promises array.
            // When each promise resolves, map it to a tuple { key: key, val: val }
            var chain = Object.keys(promises)
                .map(function (key) { return promises[key].then(function (val) { return ({ key: key, val: val }); }); });
            // Then wait for all promises to resolve, and convert them back to an object
            return exports.$q.all(chain).then(function (values) {
                return values.reduce(function (acc, tuple) { acc[tuple.key] = tuple.val; return acc; }, {});
            });
        }
    }
};
//# sourceMappingURL=q.js.map

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @coreapi
 * @module view
 */ /** for typedoc */
var common_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(26);
var predicates_1 = __webpack_require__(21);
var trace_1 = __webpack_require__(83);
/**
 * The View service
 *
 * This service pairs existing `ui-view` components (which live in the DOM)
 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
 *
 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
 *   The views from exited states are deactivated via [[deactivateViewConfig]].
 *   (See: the [[registerActivateViews]] Transition Hook)
 *
 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
 *
 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[ActiveUIView]])
 * are configured with the matching [[ViewConfig]](s)
 *
 */
var ViewService = (function () {
    function ViewService() {
        var _this = this;
        this._uiViews = [];
        this._viewConfigs = [];
        this._viewConfigFactories = {};
        this._pluginapi = {
            _rootViewContext: this._rootViewContext.bind(this),
            _viewConfigFactory: this._viewConfigFactory.bind(this),
            _registeredUIViews: function () { return _this._uiViews; },
            _activeViewConfigs: function () { return _this._viewConfigs; },
        };
    }
    ViewService.prototype._rootViewContext = function (context) {
        return this._rootContext = context || this._rootContext;
    };
    ;
    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
        this._viewConfigFactories[viewType] = factory;
    };
    ViewService.prototype.createViewConfig = function (path, decl) {
        var cfgFactory = this._viewConfigFactories[decl.$type];
        if (!cfgFactory)
            throw new Error("ViewService: No view config factory registered for type " + decl.$type);
        var cfgs = cfgFactory(path, decl);
        return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
    };
    /**
     * Deactivates a ViewConfig.
     *
     * This function deactivates a `ViewConfig`.
     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
     *
     * @param viewConfig The ViewConfig view to deregister.
     */
    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
        trace_1.trace.traceViewServiceEvent("<- Removing", viewConfig);
        common_1.removeFrom(this._viewConfigs, viewConfig);
    };
    ViewService.prototype.activateViewConfig = function (viewConfig) {
        trace_1.trace.traceViewServiceEvent("-> Registering", viewConfig);
        this._viewConfigs.push(viewConfig);
    };
    ViewService.prototype.sync = function () {
        var _this = this;
        var uiViewsByFqn = this._uiViews.map(function (uiv) { return [uiv.fqn, uiv]; }).reduce(common_1.applyPairs, {});
        // Return a weighted depth value for a uiView.
        // The depth is the nesting depth of ui-views (based on FQN; times 10,000)
        // plus the depth of the state that is populating the uiView
        function uiViewDepth(uiView) {
            var stateDepth = function (context) {
                return context && context.parent ? stateDepth(context.parent) + 1 : 1;
            };
            return (uiView.fqn.split(".").length * 10000) + stateDepth(uiView.creationContext);
        }
        // Return the ViewConfig's context's depth in the context tree.
        function viewConfigDepth(config) {
            var context = config.viewDecl.$context, count = 0;
            while (++count && context.parent)
                context = context.parent;
            return count;
        }
        // Given a depth function, returns a compare function which can return either ascending or descending order
        var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) { return posNeg * (depthFn(left) - depthFn(right)); });
        var matchingConfigPair = function (uiView) {
            var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
            if (matchingConfigs.length > 1) {
                // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
                // Sort by depth and return the match from the deepest child
                // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
                matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
            }
            return [uiView, matchingConfigs[0]];
        };
        var configureUIView = function (_a) {
            var uiView = _a[0], viewConfig = _a[1];
            // If a parent ui-view is reconfigured, it could destroy child ui-views.
            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
            if (_this._uiViews.indexOf(uiView) !== -1)
                uiView.configUpdated(viewConfig);
        };
        // Sort views by FQN and state depth. Process uiviews nearest the root first.
        this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair).forEach(configureUIView);
    };
    ;
    /**
     * Registers a `ui-view` component
     *
     * When a `ui-view` component is created, it uses this method to register itself.
     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
     *
     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
     * and what the view's state context is.
     *
     * Note: There is no corresponding `deregisterUIView`.
     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
     *
     * @param uiView The metadata for a UIView
     * @return a de-registration function used when the view is destroyed.
     */
    ViewService.prototype.registerUIView = function (uiView) {
        trace_1.trace.traceViewServiceUIViewEvent("-> Registering", uiView);
        var uiViews = this._uiViews;
        var fqnMatches = function (uiv) { return uiv.fqn === uiView.fqn; };
        if (uiViews.filter(fqnMatches).length)
            trace_1.trace.traceViewServiceUIViewEvent("!!!! duplicate uiView named:", uiView);
        uiViews.push(uiView);
        this.sync();
        return function () {
            var idx = uiViews.indexOf(uiView);
            if (idx === -1) {
                trace_1.trace.traceViewServiceUIViewEvent("Tried removing non-registered uiView", uiView);
                return;
            }
            trace_1.trace.traceViewServiceUIViewEvent("<- Deregistering", uiView);
            common_1.removeFrom(uiViews)(uiView);
        };
    };
    ;
    /**
     * Returns the list of views currently available on the page, by fully-qualified name.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */
    ViewService.prototype.available = function () {
        return this._uiViews.map(hof_1.prop("fqn"));
    };
    /**
     * Returns the list of views on the page containing loaded content.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */
    ViewService.prototype.active = function () {
        return this._uiViews.filter(hof_1.prop("$config")).map(hof_1.prop("name"));
    };
    /**
     * Normalizes a view's name from a state.views configuration block.
     *
     * This should be used by a framework implementation to calculate the values for
     * [[_ViewDeclaration.$uiViewName]] and [[_ViewDeclaration.$uiViewContextAnchor]].
     *
     * @param context the context object (state declaration) that the view belongs to
     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
     *
     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
     */
    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
        if (rawViewName === void 0) { rawViewName = ""; }
        // TODO: Validate incoming view name with a regexp to allow:
        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
        var viewAtContext = rawViewName.split("@");
        var uiViewName = viewAtContext[0] || "$default"; // default to unnamed view
        var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : "^"; // default to parent context
        // Handle relative view-name sugar syntax.
        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
        if (relativeViewNameSugar) {
            // Clobbers existing contextAnchor (rawViewName validation will fix this)
            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
        }
        if (uiViewName.charAt(0) === '!') {
            uiViewName = uiViewName.substr(1);
            uiViewContextAnchor = ""; // target absolutely from root
        }
        // handle parent relative targeting "^.^.^"
        var relativeMatch = /^(\^(?:\.\^)*)$/;
        if (relativeMatch.exec(uiViewContextAnchor)) {
            var anchor = uiViewContextAnchor.split(".").reduce((function (anchor, x) { return anchor.parent; }), context);
            uiViewContextAnchor = anchor.name;
        }
        else if (uiViewContextAnchor === '.') {
            uiViewContextAnchor = context.name;
        }
        return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
    };
    return ViewService;
}());
/**
 * Given a ui-view and a ViewConfig, determines if they "match".
 *
 * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
 * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
 *
 * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
 * can be a segmented ui-view path, describing a portion of a ui-view fqn.
 *
 * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
 *
 * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
 * - the ui-view's name matches the ViewConfig's target name
 * - the ui-view's context matches the ViewConfig's anchor
 *
 * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
 * - There exists a parent ui-view where:
 *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
 *    - the parent ui-view's context matches the ViewConfig's anchor
 * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
 *
 * Example:
 *
 * DOM:
 * <ui-view>                        <!-- created in the root context (name: "") -->
 *   <ui-view name="foo">                <!-- created in the context named: "A"      -->
 *     <ui-view>                    <!-- created in the context named: "A.B"    -->
 *       <ui-view name="bar">            <!-- created in the context named: "A.B.C"  -->
 *       </ui-view>
 *     </ui-view>
 *   </ui-view>
 * </ui-view>
 *
 * uiViews: [
 *  { fqn: "$default",                  creationContext: { name: "" } },
 *  { fqn: "$default.foo",              creationContext: { name: "A" } },
 *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
 *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
 * ]
 *
 * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
 *
 * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
 * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
 * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
 * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
 *
 * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
 * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
 * - There exists a parent ui-view (which has fqn: "$default.foo") where:
 *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
 *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
 * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
 *   the tail of the ui-view's fqn "default.bar"
 *
 * @internalapi
 */
ViewService.matches = function (uiViewsByFqn, uiView) { return function (viewConfig) {
    // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
    if (uiView.$type !== viewConfig.viewDecl.$type)
        return false;
    // Split names apart from both viewConfig and uiView into segments
    var vc = viewConfig.viewDecl;
    var vcSegments = vc.$uiViewName.split(".");
    var uivSegments = uiView.fqn.split(".");
    // Check if the tails of the segment arrays match. ex, these arrays' tails match:
    // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
    if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
        return false;
    // Now check if the fqn ending at the first segment of the viewConfig matches the context:
    // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
    var negOffset = (1 - vcSegments.length) || undefined;
    var fqnToFirstSegment = uivSegments.slice(0, negOffset).join(".");
    var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
    return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
}; };
exports.ViewService = ViewService;
//# sourceMappingURL=view.js.map

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Main entry point for angular 1.x build
 * @module ng1
 */ /** */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var core = __webpack_require__(52);
exports.core = core;
__export(__webpack_require__(52));
__export(__webpack_require__(187));
__export(__webpack_require__(188));
__export(__webpack_require__(313));
__export(__webpack_require__(314));
__webpack_require__(611);
__webpack_require__(609);
__webpack_require__(613);
__webpack_require__(610);
__webpack_require__(616);
exports.default = "ui.router";
//# sourceMappingURL=index.js.map

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module ng1 */ /** for typedoc */
var core_1 = __webpack_require__(52);
/**
 * The Angular 1 `StateProvider`
 *
 * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
var StateProvider = (function () {
    function StateProvider(stateRegistry, stateService) {
        this.stateRegistry = stateRegistry;
        this.stateService = stateService;
        core_1.createProxyFunctions(core_1.val(StateProvider.prototype), this, core_1.val(this));
    }
    /**
     * Decorates states when they are registered
     *
     * Allows you to extend (carefully) or override (at your own peril) the
     * `stateBuilder` object used internally by [[StateRegistry]].
     * This can be used to add custom functionality to ui-router,
     * for example inferring templateUrl based on the state name.
     *
     * When passing only a name, it returns the current (original or decorated) builder
     * function that matches `name`.
     *
     * The builder functions that can be decorated are listed below. Though not all
     * necessarily have a good use case for decoration, that is up to you to decide.
     *
     * In addition, users can attach custom decorators, which will generate new
     * properties within the state's internal definition. There is currently no clear
     * use-case for this beyond accessing internal states (i.e. $state.$current),
     * however, expect this to become increasingly relevant as we introduce additional
     * meta-programming features.
     *
     * **Warning**: Decorators should not be interdependent because the order of
     * execution of the builder functions in non-deterministic. Builder functions
     * should only be dependent on the state definition object and super function.
     *
     *
     * Existing builder functions and current return values:
     *
     * - **parent** `{object}` - returns the parent state object.
     * - **data** `{object}` - returns state data, including any inherited data that is not
     *   overridden by own values (if any).
     * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
     *   or `null`.
     * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
     *   navigable).
     * - **params** `{object}` - returns an array of state params that are ensured to
     *   be a super-set of parent's params.
     * - **views** `{object}` - returns a views object where each key is an absolute view
     *   name (i.e. "viewName@stateName") and each value is the config object
     *   (template, controller) for the view. Even when you don't use the views object
     *   explicitly on a state config, one is still created for you internally.
     *   So by decorating this builder function you have access to decorating template
     *   and controller properties.
     * - **ownParams** `{object}` - returns an array of params that belong to the state,
     *   not including any params defined by ancestor states.
     * - **path** `{string}` - returns the full path from the root down to this state.
     *   Needed for state activation.
     * - **includes** `{object}` - returns an object that includes every state that
     *   would pass a `$state.includes()` test.
     *
     * #### Example:
     * Override the internal 'views' builder with a function that takes the state
     * definition, and a reference to the internal function being overridden:
     * ```js
     * $stateProvider.decorator('views', function (state, parent) {
     *   let result = {},
     *       views = parent(state);
     *
     *   angular.forEach(views, function (config, name) {
     *     let autoName = (state.name + '.' + name).replace('.', '/');
     *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
     *     result[name] = config;
     *   });
     *   return result;
     * });
     *
     * $stateProvider.state('home', {
     *   views: {
     *     'contact.list': { controller: 'ListController' },
     *     'contact.item': { controller: 'ItemController' }
     *   }
     * });
     * ```
     *
     *
     * ```js
     * // Auto-populates list and item views with /partials/home/contact/list.html,
     * // and /partials/home/contact/item.html, respectively.
     * $state.go('home');
     * ```
     *
     * @param {string} name The name of the builder function to decorate.
     * @param {object} func A function that is responsible for decorating the original
     * builder function. The function receives two parameters:
     *
     *   - `{object}` - state - The state config object.
     *   - `{object}` - super - The original builder function.
     *
     * @return {object} $stateProvider - $stateProvider instance
     */
    StateProvider.prototype.decorator = function (name, func) {
        return this.stateRegistry.decorator(name, func) || this;
    };
    StateProvider.prototype.state = function (name, definition) {
        if (core_1.isObject(name)) {
            definition = name;
        }
        else {
            definition.name = name;
        }
        this.stateRegistry.register(definition);
        return this;
    };
    /**
     * Registers an invalid state handler
     *
     * This is a passthrough to [[StateService.onInvalid]] for ng1.
     */
    StateProvider.prototype.onInvalid = function (callback) {
        return this.stateService.onInvalid(callback);
    };
    return StateProvider;
}());
exports.StateProvider = StateProvider;
//# sourceMappingURL=stateProvider.js.map

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module url */ /** */
var core_1 = __webpack_require__(52);
var core_2 = __webpack_require__(52);
/**
 * Manages rules for client-side URL
 *
 * ### Deprecation warning:
 * This class is now considered to be an internal API
 * Use the [[UrlService]] instead.
 * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
 *
 * This class manages the router rules for what to do when the URL changes.
 *
 * This provider remains for backwards compatibility.
 *
 * @deprecated
 */
var UrlRouterProvider = (function () {
    /** @hidden */
    function UrlRouterProvider(router) {
        this._router = router;
        this._urlRouter = router.urlRouter;
    }
    /** @hidden */
    UrlRouterProvider.prototype.$get = function () {
        var urlRouter = this._urlRouter;
        urlRouter.update(true);
        if (!urlRouter.interceptDeferred)
            urlRouter.listen();
        return urlRouter;
    };
    /**
     * Registers a url handler function.
     *
     * Registers a low level url handler (a `rule`).
     * A rule detects specific URL patterns and returns a redirect, or performs some action.
     *
     * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Here's an example of how you might allow case insensitive urls
     *   $urlRouterProvider.rule(function ($injector, $location) {
     *     var path = $location.path(),
     *         normalized = path.toLowerCase();
     *
     *     if (path !== normalized) {
     *       return normalized;
     *     }
     *   });
     * });
     * ```
     *
     * @param ruleFn
     * Handler function that takes `$injector` and `$location` services as arguments.
     * You can use them to detect a url and return a different url as a string.
     *
     * @return [[UrlRouterProvider]] (`this`)
     */
    UrlRouterProvider.prototype.rule = function (ruleFn) {
        var _this = this;
        if (!core_2.isFunction(ruleFn))
            throw new Error("'rule' must be a function");
        var match = function () {
            return ruleFn(core_2.services.$injector, _this._router.locationService);
        };
        var rule = new core_1.BaseUrlRule(match, core_2.identity);
        this._urlRouter.rule(rule);
        return this;
    };
    ;
    /**
     * Defines the path or behavior to use when no url can be matched.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // if the path doesn't match any of the urls you configured
     *   // otherwise will take care of routing the user to the
     *   // specified url
     *   $urlRouterProvider.otherwise('/index');
     *
     *   // Example of using function rule as param
     *   $urlRouterProvider.otherwise(function ($injector, $location) {
     *     return '/a/valid/url';
     *   });
     * });
     * ```
     *
     * @param rule
     * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
     * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
     *
     * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
     */
    UrlRouterProvider.prototype.otherwise = function (rule) {
        var _this = this;
        var urlRouter = this._urlRouter;
        if (core_2.isString(rule)) {
            urlRouter.otherwise(rule);
        }
        else if (core_2.isFunction(rule)) {
            urlRouter.otherwise(function () { return rule(core_2.services.$injector, _this._router.locationService); });
        }
        else {
            throw new Error("'rule' must be a string or function");
        }
        return this;
    };
    ;
    /**
     * Registers a handler for a given url matching.
     *
     * If the handler is a string, it is
     * treated as a redirect, and is interpolated according to the syntax of match
     * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
     *
     * If the handler is a function, it is injectable.
     * It gets invoked if `$location` matches.
     * You have the option of inject the match object as `$match`.
     *
     * The handler can return
     *
     * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
     *   will continue trying to find another one that matches.
     * - **string** which is treated as a redirect and passed to `$location.url()`
     * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
     *     if ($state.$current.navigable !== state ||
     *         !equalForKeys($match, $stateParams) {
     *      $state.transitionTo(state, $match, false);
     *     }
     *   });
     * });
     * ```
     *
     * @param what A pattern string to match, compiled as a [[UrlMatcher]].
     * @param handler The path (or function that returns a path) that you want to redirect your user to.
     * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
     *
     * Note: the handler may also invoke arbitrary code, such as `$state.go()`
     */
    UrlRouterProvider.prototype.when = function (what, handler) {
        if (core_2.isArray(handler) || core_2.isFunction(handler)) {
            handler = UrlRouterProvider.injectableHandler(this._router, handler);
        }
        this._urlRouter.when(what, handler);
        return this;
    };
    ;
    UrlRouterProvider.injectableHandler = function (router, handler) {
        return function (match) {
            return core_2.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params });
        };
    };
    /**
     * Disables monitoring of the URL.
     *
     * Call this method before UI-Router has bootstrapped.
     * It will stop UI-Router from performing the initial url sync.
     *
     * This can be useful to perform some asynchronous initialization before the router starts.
     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Prevent $urlRouter from automatically intercepting URL changes;
     *   $urlRouterProvider.deferIntercept();
     * })
     *
     * app.run(function (MyService, $urlRouter, $http) {
     *   $http.get("/stuff").then(function(resp) {
     *     MyService.doStuff(resp.data);
     *     $urlRouter.listen();
     *     $urlRouter.sync();
     *   });
     * });
     * ```
     *
     * @param defer Indicates whether to defer location change interception.
     *        Passing no parameter is equivalent to `true`.
     */
    UrlRouterProvider.prototype.deferIntercept = function (defer) {
        this._urlRouter.deferIntercept(defer);
    };
    ;
    return UrlRouterProvider;
}());
exports.UrlRouterProvider = UrlRouterProvider;
//# sourceMappingURL=urlRouterProvider.js.map

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(662), __esModule: true };

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(666), __esModule: true };

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.line=n():(t.britecharts=t.britecharts||{},t.britecharts.line=n())}(window,(function(){return function(t){var n={};function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:r})},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.t=function(t,n){if(1&n&&(t=e(t)),8&n)return t;if(4&n&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(e.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&n&&"string"!=typeof t)for(var i in t)e.d(r,i,function(n){return t[n]}.bind(null,i));return r},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.p="",e(e.s=101)}([function(t,n,e){"use strict";e.d(n,"a",(function(){return o}));var r=new Date,i=new Date;function o(t,n,e,u){function a(n){return t(n=0===arguments.length?new Date:new Date(+n)),n}return a.floor=function(n){return t(n=new Date(+n)),n},a.ceil=function(e){return t(e=new Date(e-1)),n(e,1),t(e),e},a.round=function(t){var n=a(t),e=a.ceil(t);return t-n<e-t?n:e},a.offset=function(t,e){return n(t=new Date(+t),null==e?1:Math.floor(e)),t},a.range=function(e,r,i){var o,u=[];if(e=a.ceil(e),i=null==i?1:Math.floor(i),!(e<r&&i>0))return u;do{u.push(o=new Date(+e)),n(e,i),t(e)}while(o<e&&e<r);return u},a.filter=function(e){return o((function(n){if(n>=n)for(;t(n),!e(n);)n.setTime(n-1)}),(function(t,r){if(t>=t)if(r<0)for(;++r<=0;)for(;n(t,-1),!e(t););else for(;--r>=0;)for(;n(t,1),!e(t););}))},e&&(a.count=function(n,o){return r.setTime(+n),i.setTime(+o),t(r),t(i),Math.floor(e(r,i))},a.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?a.filter(u?function(n){return u(n)%t==0}:function(n){return a.count(0,n)%t==0}):a:null}),a}},function(t,n,e){"use strict";e.d(n,"d",(function(){return r})),e.d(n,"c",(function(){return i})),e.d(n,"b",(function(){return o})),e.d(n,"a",(function(){return u})),e.d(n,"e",(function(){return a}));var r=1e3,i=6e4,o=36e5,u=864e5,a=6048e5},function(t,n,e){"use strict";e.r(n);var r=function(t,n){return t<n?-1:t>n?1:t>=n?0:NaN},i=function(t){var n;return 1===t.length&&(n=t,t=function(t,e){return r(n(t),e)}),{left:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var o=r+i>>>1;t(n[o],e)<0?r=o+1:i=o}return r},right:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var o=r+i>>>1;t(n[o],e)>0?i=o:r=o+1}return r}}};var o=i(r),u=o.right,a=o.left,c=u,s=function(t,n){null==n&&(n=l);for(var e=0,r=t.length-1,i=t[0],o=new Array(r<0?0:r);e<r;)o[e]=n(i,i=t[++e]);return o};function l(t,n){return[t,n]}var f=function(t,n,e){var r,i,o,u,a=t.length,c=n.length,s=new Array(a*c);for(null==e&&(e=l),r=o=0;r<a;++r)for(u=t[r],i=0;i<c;++i,++o)s[o]=e(u,n[i]);return s},h=function(t,n){return n<t?-1:n>t?1:n>=t?0:NaN},d=function(t){return null===t?NaN:+t},p=function(t,n){var e,r,i=t.length,o=0,u=-1,a=0,c=0;if(null==n)for(;++u<i;)isNaN(e=d(t[u]))||(c+=(r=e-a)*(e-(a+=r/++o)));else for(;++u<i;)isNaN(e=d(n(t[u],u,t)))||(c+=(r=e-a)*(e-(a+=r/++o)));if(o>1)return c/(o-1)},y=function(t,n){var e=p(t,n);return e?Math.sqrt(e):e},g=function(t,n){var e,r,i,o=t.length,u=-1;if(null==n){for(;++u<o;)if(null!=(e=t[u])&&e>=e)for(r=i=e;++u<o;)null!=(e=t[u])&&(r>e&&(r=e),i<e&&(i=e))}else for(;++u<o;)if(null!=(e=n(t[u],u,t))&&e>=e)for(r=i=e;++u<o;)null!=(e=n(t[u],u,t))&&(r>e&&(r=e),i<e&&(i=e));return[r,i]},v=Array.prototype,_=v.slice,m=v.map,x=function(t){return function(){return t}},b=function(t){return t},w=function(t,n,e){t=+t,n=+n,e=(i=arguments.length)<2?(n=t,t=0,1):i<3?1:+e;for(var r=-1,i=0|Math.max(0,Math.ceil((n-t)/e)),o=new Array(i);++r<i;)o[r]=t+r*e;return o},M=Math.sqrt(50),T=Math.sqrt(10),k=Math.sqrt(2),O=function(t,n,e){var r,i,o,u,a=-1;if(e=+e,(t=+t)===(n=+n)&&e>0)return[t];if((r=n<t)&&(i=t,t=n,n=i),0===(u=A(t,n,e))||!isFinite(u))return[];if(u>0)for(t=Math.ceil(t/u),n=Math.floor(n/u),o=new Array(i=Math.ceil(n-t+1));++a<i;)o[a]=(t+a)*u;else for(t=Math.floor(t*u),n=Math.ceil(n*u),o=new Array(i=Math.ceil(t-n+1));++a<i;)o[a]=(t-a)/u;return r&&o.reverse(),o};function A(t,n,e){var r=(n-t)/Math.max(0,e),i=Math.floor(Math.log(r)/Math.LN10),o=r/Math.pow(10,i);return i>=0?(o>=M?10:o>=T?5:o>=k?2:1)*Math.pow(10,i):-Math.pow(10,-i)/(o>=M?10:o>=T?5:o>=k?2:1)}function S(t,n,e){var r=Math.abs(n-t)/Math.max(0,e),i=Math.pow(10,Math.floor(Math.log(r)/Math.LN10)),o=r/i;return o>=M?i*=10:o>=T?i*=5:o>=k&&(i*=2),n<t?-i:i}var C=function(t){return Math.ceil(Math.log(t.length)/Math.LN2)+1},N=function(){var t=b,n=g,e=C;function r(r){var i,o,u=r.length,a=new Array(u);for(i=0;i<u;++i)a[i]=t(r[i],i,r);var s=n(a),l=s[0],f=s[1],h=e(a,l,f);Array.isArray(h)||(h=S(l,f,h),h=w(Math.ceil(l/h)*h,f,h));for(var d=h.length;h[0]<=l;)h.shift(),--d;for(;h[d-1]>f;)h.pop(),--d;var p,y=new Array(d+1);for(i=0;i<=d;++i)(p=y[i]=[]).x0=i>0?h[i-1]:l,p.x1=i<d?h[i]:f;for(i=0;i<u;++i)l<=(o=a[i])&&o<=f&&y[c(h,o,0,d)].push(r[i]);return y}return r.value=function(n){return arguments.length?(t="function"==typeof n?n:x(n),r):t},r.domain=function(t){return arguments.length?(n="function"==typeof t?t:x([t[0],t[1]]),r):n},r.thresholds=function(t){return arguments.length?(e="function"==typeof t?t:Array.isArray(t)?x(_.call(t)):x(t),r):e},r},E=function(t,n,e){if(null==e&&(e=d),r=t.length){if((n=+n)<=0||r<2)return+e(t[0],0,t);if(n>=1)return+e(t[r-1],r-1,t);var r,i=(r-1)*n,o=Math.floor(i),u=+e(t[o],o,t);return u+(+e(t[o+1],o+1,t)-u)*(i-o)}},D=function(t,n,e){return t=m.call(t,d).sort(r),Math.ceil((e-n)/(2*(E(t,.75)-E(t,.25))*Math.pow(t.length,-1/3)))},j=function(t,n,e){return Math.ceil((e-n)/(3.5*y(t)*Math.pow(t.length,-1/3)))},F=function(t,n){var e,r,i=t.length,o=-1;if(null==n){for(;++o<i;)if(null!=(e=t[o])&&e>=e)for(r=e;++o<i;)null!=(e=t[o])&&e>r&&(r=e)}else for(;++o<i;)if(null!=(e=n(t[o],o,t))&&e>=e)for(r=e;++o<i;)null!=(e=n(t[o],o,t))&&e>r&&(r=e);return r},P=function(t,n){var e,r=t.length,i=r,o=-1,u=0;if(null==n)for(;++o<r;)isNaN(e=d(t[o]))?--i:u+=e;else for(;++o<r;)isNaN(e=d(n(t[o],o,t)))?--i:u+=e;if(i)return u/i},L=function(t,n){var e,i=t.length,o=-1,u=[];if(null==n)for(;++o<i;)isNaN(e=d(t[o]))||u.push(e);else for(;++o<i;)isNaN(e=d(n(t[o],o,t)))||u.push(e);return E(u.sort(r),.5)},I=function(t){for(var n,e,r,i=t.length,o=-1,u=0;++o<i;)u+=t[o].length;for(e=new Array(u);--i>=0;)for(n=(r=t[i]).length;--n>=0;)e[--u]=r[n];return e},U=function(t,n){var e,r,i=t.length,o=-1;if(null==n){for(;++o<i;)if(null!=(e=t[o])&&e>=e)for(r=e;++o<i;)null!=(e=t[o])&&r>e&&(r=e)}else for(;++o<i;)if(null!=(e=n(t[o],o,t))&&e>=e)for(r=e;++o<i;)null!=(e=n(t[o],o,t))&&r>e&&(r=e);return r},R=function(t,n){for(var e=n.length,r=new Array(e);e--;)r[e]=t[n[e]];return r},B=function(t,n){if(e=t.length){var e,i,o=0,u=0,a=t[u];for(null==n&&(n=r);++o<e;)(n(i=t[o],a)<0||0!==n(a,a))&&(a=i,u=o);return 0===n(a,a)?u:void 0}},H=function(t,n,e){for(var r,i,o=(null==e?t.length:e)-(n=null==n?0:+n);o;)i=Math.random()*o--|0,r=t[o+n],t[o+n]=t[i+n],t[i+n]=r;return t},Y=function(t,n){var e,r=t.length,i=-1,o=0;if(null==n)for(;++i<r;)(e=+t[i])&&(o+=e);else for(;++i<r;)(e=+n(t[i],i,t))&&(o+=e);return o},q=function(t){if(!(i=t.length))return[];for(var n=-1,e=U(t,z),r=new Array(e);++n<e;)for(var i,o=-1,u=r[n]=new Array(i);++o<i;)u[o]=t[o][n];return r};function z(t){return t.length}var G=function(){return q(arguments)};e.d(n,"bisect",(function(){return c})),e.d(n,"bisectRight",(function(){return u})),e.d(n,"bisectLeft",(function(){return a})),e.d(n,"ascending",(function(){return r})),e.d(n,"bisector",(function(){return i})),e.d(n,"cross",(function(){return f})),e.d(n,"descending",(function(){return h})),e.d(n,"deviation",(function(){return y})),e.d(n,"extent",(function(){return g})),e.d(n,"histogram",(function(){return N})),e.d(n,"thresholdFreedmanDiaconis",(function(){return D})),e.d(n,"thresholdScott",(function(){return j})),e.d(n,"thresholdSturges",(function(){return C})),e.d(n,"max",(function(){return F})),e.d(n,"mean",(function(){return P})),e.d(n,"median",(function(){return L})),e.d(n,"merge",(function(){return I})),e.d(n,"min",(function(){return U})),e.d(n,"pairs",(function(){return s})),e.d(n,"permute",(function(){return R})),e.d(n,"quantile",(function(){return E})),e.d(n,"range",(function(){return w})),e.d(n,"scan",(function(){return B})),e.d(n,"shuffle",(function(){return H})),e.d(n,"sum",(function(){return Y})),e.d(n,"ticks",(function(){return O})),e.d(n,"tickIncrement",(function(){return A})),e.d(n,"tickStep",(function(){return S})),e.d(n,"transpose",(function(){return q})),e.d(n,"variance",(function(){return p})),e.d(n,"zip",(function(){return G}))},function(t,n,e){"use strict";e.d(n,"g",(function(){return u})),e.d(n,"c",(function(){return a})),e.d(n,"k",(function(){return c})),e.d(n,"m",(function(){return s})),e.d(n,"i",(function(){return l})),e.d(n,"a",(function(){return f})),e.d(n,"e",(function(){return h})),e.d(n,"h",(function(){return d})),e.d(n,"d",(function(){return p})),e.d(n,"l",(function(){return y})),e.d(n,"n",(function(){return g})),e.d(n,"j",(function(){return v})),e.d(n,"b",(function(){return _})),e.d(n,"f",(function(){return m}));var r=e(0),i=e(1);function o(t){return Object(r.a)((function(n){n.setDate(n.getDate()-(n.getDay()+7-t)%7),n.setHours(0,0,0,0)}),(function(t,n){t.setDate(t.getDate()+7*n)}),(function(t,n){return(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*i.c)/i.e}))}var u=o(0),a=o(1),c=o(2),s=o(3),l=o(4),f=o(5),h=o(6),d=u.range,p=a.range,y=c.range,g=s.range,v=l.range,_=f.range,m=h.range},function(t,n,e){"use strict";e.d(n,"g",(function(){return u})),e.d(n,"c",(function(){return a})),e.d(n,"k",(function(){return c})),e.d(n,"m",(function(){return s})),e.d(n,"i",(function(){return l})),e.d(n,"a",(function(){return f})),e.d(n,"e",(function(){return h})),e.d(n,"h",(function(){return d})),e.d(n,"d",(function(){return p})),e.d(n,"l",(function(){return y})),e.d(n,"n",(function(){return g})),e.d(n,"j",(function(){return v})),e.d(n,"b",(function(){return _})),e.d(n,"f",(function(){return m}));var r=e(0),i=e(1);function o(t){return Object(r.a)((function(n){n.setUTCDate(n.getUTCDate()-(n.getUTCDay()+7-t)%7),n.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCDate(t.getUTCDate()+7*n)}),(function(t,n){return(n-t)/i.e}))}var u=o(0),a=o(1),c=o(2),s=o(3),l=o(4),f=o(5),h=o(6),d=u.range,p=a.range,y=c.range,g=s.range,v=l.range,_=f.range,m=h.range},function(t,n,e){"use strict";n.a=function(t,n){return t=+t,n=+n,function(e){return t*(1-e)+n*e}}},function(t,n,e){"use strict";e.r(n);var r=e(12),i=e(32),o=function(t){return Object(i.a)(Object(r.a)(t).call(document.documentElement))},u=0;function a(){return new c}function c(){this._="@"+(++u).toString(36)}c.prototype=a.prototype={constructor:c,get:function(t){for(var n=this._;!(n in t);)if(!(t=t.parentNode))return;return t[n]},set:function(t,n){return t[this._]=n},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}};var s=e(34),l=e(59),f=e(20),h=e(14),d=e(13),p=e(9),y=function(t){return"string"==typeof t?new p.a([document.querySelectorAll(t)],[document.documentElement]):new p.a([null==t?[]:t],p.c)},g=e(19),v=e(33),_=e(35),m=e(60),x=e(22),b=function(t,n){null==n&&(n=Object(x.a)().touches);for(var e=0,r=n?n.length:0,i=new Array(r);e<r;++e)i[e]=Object(d.a)(t,n[e]);return i},w=e(21),M=e(17);e.d(n,"create",(function(){return o})),e.d(n,"creator",(function(){return r.a})),e.d(n,"local",(function(){return a})),e.d(n,"matcher",(function(){return s.a})),e.d(n,"mouse",(function(){return l.a})),e.d(n,"namespace",(function(){return f.a})),e.d(n,"namespaces",(function(){return h.a})),e.d(n,"clientPoint",(function(){return d.a})),e.d(n,"select",(function(){return i.a})),e.d(n,"selectAll",(function(){return y})),e.d(n,"selection",(function(){return p.b})),e.d(n,"selector",(function(){return g.a})),e.d(n,"selectorAll",(function(){return v.a})),e.d(n,"style",(function(){return _.b})),e.d(n,"touch",(function(){return m.a})),e.d(n,"touches",(function(){return b})),e.d(n,"window",(function(){return w.a})),e.d(n,"event",(function(){return M.c})),e.d(n,"customEvent",(function(){return M.a}))},function(t,n,e){"use strict";e.d(n,"a",(function(){return i})),e.d(n,"d",(function(){return o})),e.d(n,"c",(function(){return u})),e.d(n,"e",(function(){return x})),e.d(n,"h",(function(){return M})),e.d(n,"g",(function(){return T})),e.d(n,"b",(function(){return k})),e.d(n,"f",(function(){return E}));var r=e(11);function i(){}var o=.7,u=1/o,a="\\s*([+-]?\\d+)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",s="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",l=/^#([0-9a-f]{3,8})$/,f=new RegExp("^rgb\\("+[a,a,a]+"\\)$"),h=new RegExp("^rgb\\("+[s,s,s]+"\\)$"),d=new RegExp("^rgba\\("+[a,a,a,c]+"\\)$"),p=new RegExp("^rgba\\("+[s,s,s,c]+"\\)$"),y=new RegExp("^hsl\\("+[c,s,s]+"\\)$"),g=new RegExp("^hsla\\("+[c,s,s,c]+"\\)$"),v={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};function _(){return this.rgb().formatHex()}function m(){return this.rgb().formatRgb()}function x(t){var n,e;return t=(t+"").trim().toLowerCase(),(n=l.exec(t))?(e=n[1].length,n=parseInt(n[1],16),6===e?b(n):3===e?new k(n>>8&15|n>>4&240,n>>4&15|240&n,(15&n)<<4|15&n,1):8===e?new k(n>>24&255,n>>16&255,n>>8&255,(255&n)/255):4===e?new k(n>>12&15|n>>8&240,n>>8&15|n>>4&240,n>>4&15|240&n,((15&n)<<4|15&n)/255):null):(n=f.exec(t))?new k(n[1],n[2],n[3],1):(n=h.exec(t))?new k(255*n[1]/100,255*n[2]/100,255*n[3]/100,1):(n=d.exec(t))?w(n[1],n[2],n[3],n[4]):(n=p.exec(t))?w(255*n[1]/100,255*n[2]/100,255*n[3]/100,n[4]):(n=y.exec(t))?C(n[1],n[2]/100,n[3]/100,1):(n=g.exec(t))?C(n[1],n[2]/100,n[3]/100,n[4]):v.hasOwnProperty(t)?b(v[t]):"transparent"===t?new k(NaN,NaN,NaN,0):null}function b(t){return new k(t>>16&255,t>>8&255,255&t,1)}function w(t,n,e,r){return r<=0&&(t=n=e=NaN),new k(t,n,e,r)}function M(t){return t instanceof i||(t=x(t)),t?new k((t=t.rgb()).r,t.g,t.b,t.opacity):new k}function T(t,n,e,r){return 1===arguments.length?M(t):new k(t,n,e,null==r?1:r)}function k(t,n,e,r){this.r=+t,this.g=+n,this.b=+e,this.opacity=+r}function O(){return"#"+S(this.r)+S(this.g)+S(this.b)}function A(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}function S(t){return((t=Math.max(0,Math.min(255,Math.round(t)||0)))<16?"0":"")+t.toString(16)}function C(t,n,e,r){return r<=0?t=n=e=NaN:e<=0||e>=1?t=n=NaN:n<=0&&(t=NaN),new D(t,n,e,r)}function N(t){if(t instanceof D)return new D(t.h,t.s,t.l,t.opacity);if(t instanceof i||(t=x(t)),!t)return new D;if(t instanceof D)return t;var n=(t=t.rgb()).r/255,e=t.g/255,r=t.b/255,o=Math.min(n,e,r),u=Math.max(n,e,r),a=NaN,c=u-o,s=(u+o)/2;return c?(a=n===u?(e-r)/c+6*(e<r):e===u?(r-n)/c+2:(n-e)/c+4,c/=s<.5?u+o:2-u-o,a*=60):c=s>0&&s<1?0:a,new D(a,c,s,t.opacity)}function E(t,n,e,r){return 1===arguments.length?N(t):new D(t,n,e,null==r?1:r)}function D(t,n,e,r){this.h=+t,this.s=+n,this.l=+e,this.opacity=+r}function j(t,n,e){return 255*(t<60?n+(e-n)*t/60:t<180?e:t<240?n+(e-n)*(240-t)/60:n)}Object(r.a)(i,x,{copy:function(t){return Object.assign(new this.constructor,this,t)},displayable:function(){return this.rgb().displayable()},hex:_,formatHex:_,formatHsl:function(){return N(this).formatHsl()},formatRgb:m,toString:m}),Object(r.a)(k,T,Object(r.b)(i,{brighter:function(t){return t=null==t?u:Math.pow(u,t),new k(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?o:Math.pow(o,t),new k(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return-.5<=this.r&&this.r<255.5&&-.5<=this.g&&this.g<255.5&&-.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1},hex:O,formatHex:O,formatRgb:A,toString:A})),Object(r.a)(D,E,Object(r.b)(i,{brighter:function(t){return t=null==t?u:Math.pow(u,t),new D(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?o:Math.pow(o,t),new D(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),n=isNaN(t)||isNaN(this.s)?0:this.s,e=this.l,r=e+(e<.5?e:1-e)*n,i=2*e-r;return new k(j(t>=240?t-240:t+120,i,r),j(t,i,r),j(t<120?t+240:t-120,i,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1},formatHsl:function(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"hsl(":"hsla(")+(this.h||0)+", "+100*(this.s||0)+"%, "+100*(this.l||0)+"%"+(1===t?")":", "+t+")")}}))},function(t,n,e){"use strict";var r=e(18);n.a=function(t){return(t=Object(r.a)(Math.abs(t)))?t[1]:NaN}},function(t,n,e){"use strict";var r=e(19),i=e(33),o=e(34),u=function(t){return new Array(t.length)};function a(t,n){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=n}a.prototype={constructor:a,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,n){return this._parent.insertBefore(t,n)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}};function c(t,n,e,r,i,o){for(var u,c=0,s=n.length,l=o.length;c<l;++c)(u=n[c])?(u.__data__=o[c],r[c]=u):e[c]=new a(t,o[c]);for(;c<s;++c)(u=n[c])&&(i[c]=u)}function s(t,n,e,r,i,o,u){var c,s,l,f={},h=n.length,d=o.length,p=new Array(h);for(c=0;c<h;++c)(s=n[c])&&(p[c]=l="$"+u.call(s,s.__data__,c,n),l in f?i[c]=s:f[l]=s);for(c=0;c<d;++c)(s=f[l="$"+u.call(t,o[c],c,o)])?(r[c]=s,s.__data__=o[c],f[l]=null):e[c]=new a(t,o[c]);for(c=0;c<h;++c)(s=n[c])&&f[p[c]]===s&&(i[c]=s)}function l(t,n){return t<n?-1:t>n?1:t>=n?0:NaN}var f=e(20);function h(t){return function(){this.removeAttribute(t)}}function d(t){return function(){this.removeAttributeNS(t.space,t.local)}}function p(t,n){return function(){this.setAttribute(t,n)}}function y(t,n){return function(){this.setAttributeNS(t.space,t.local,n)}}function g(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttribute(t):this.setAttribute(t,e)}}function v(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,e)}}var _=e(35);function m(t){return function(){delete this[t]}}function x(t,n){return function(){this[t]=n}}function b(t,n){return function(){var e=n.apply(this,arguments);null==e?delete this[t]:this[t]=e}}function w(t){return t.trim().split(/^|\s+/)}function M(t){return t.classList||new T(t)}function T(t){this._node=t,this._names=w(t.getAttribute("class")||"")}function k(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.add(n[r])}function O(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.remove(n[r])}function A(t){return function(){k(this,t)}}function S(t){return function(){O(this,t)}}function C(t,n){return function(){(n.apply(this,arguments)?k:O)(this,t)}}T.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var n=this._names.indexOf(t);n>=0&&(this._names.splice(n,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}};function N(){this.textContent=""}function E(t){return function(){this.textContent=t}}function D(t){return function(){var n=t.apply(this,arguments);this.textContent=null==n?"":n}}function j(){this.innerHTML=""}function F(t){return function(){this.innerHTML=t}}function P(t){return function(){var n=t.apply(this,arguments);this.innerHTML=null==n?"":n}}function L(){this.nextSibling&&this.parentNode.appendChild(this)}function I(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}var U=e(12);function R(){return null}function B(){var t=this.parentNode;t&&t.removeChild(this)}function H(){var t=this.cloneNode(!1),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}function Y(){var t=this.cloneNode(!0),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}var q=e(17),z=e(21);function G(t,n,e){var r=Object(z.a)(t),i=r.CustomEvent;"function"==typeof i?i=new i(n,e):(i=r.document.createEvent("Event"),e?(i.initEvent(n,e.bubbles,e.cancelable),i.detail=e.detail):i.initEvent(n,!1,!1)),t.dispatchEvent(i)}function V(t,n){return function(){return G(this,t,n)}}function X(t,n){return function(){return G(this,t,n.apply(this,arguments))}}e.d(n,"c",(function(){return W})),e.d(n,"a",(function(){return $}));var W=[null];function $(t,n){this._groups=t,this._parents=n}function Z(){return new $([[document.documentElement]],W)}$.prototype=Z.prototype={constructor:$,select:function(t){"function"!=typeof t&&(t=Object(r.a)(t));for(var n=this._groups,e=n.length,i=new Array(e),o=0;o<e;++o)for(var u,a,c=n[o],s=c.length,l=i[o]=new Array(s),f=0;f<s;++f)(u=c[f])&&(a=t.call(u,u.__data__,f,c))&&("__data__"in u&&(a.__data__=u.__data__),l[f]=a);return new $(i,this._parents)},selectAll:function(t){"function"!=typeof t&&(t=Object(i.a)(t));for(var n=this._groups,e=n.length,r=[],o=[],u=0;u<e;++u)for(var a,c=n[u],s=c.length,l=0;l<s;++l)(a=c[l])&&(r.push(t.call(a,a.__data__,l,c)),o.push(a));return new $(r,o)},filter:function(t){"function"!=typeof t&&(t=Object(o.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var u,a=n[i],c=a.length,s=r[i]=[],l=0;l<c;++l)(u=a[l])&&t.call(u,u.__data__,l,a)&&s.push(u);return new $(r,this._parents)},data:function(t,n){if(!t)return g=new Array(this.size()),h=-1,this.each((function(t){g[++h]=t})),g;var e,r=n?s:c,i=this._parents,o=this._groups;"function"!=typeof t&&(e=t,t=function(){return e});for(var u=o.length,a=new Array(u),l=new Array(u),f=new Array(u),h=0;h<u;++h){var d=i[h],p=o[h],y=p.length,g=t.call(d,d&&d.__data__,h,i),v=g.length,_=l[h]=new Array(v),m=a[h]=new Array(v);r(d,p,_,m,f[h]=new Array(y),g,n);for(var x,b,w=0,M=0;w<v;++w)if(x=_[w]){for(w>=M&&(M=w+1);!(b=m[M])&&++M<v;);x._next=b||null}}return(a=new $(a,i))._enter=l,a._exit=f,a},enter:function(){return new $(this._enter||this._groups.map(u),this._parents)},exit:function(){return new $(this._exit||this._groups.map(u),this._parents)},join:function(t,n,e){var r=this.enter(),i=this,o=this.exit();return r="function"==typeof t?t(r):r.append(t+""),null!=n&&(i=n(i)),null==e?o.remove():e(o),r&&i?r.merge(i).order():i},merge:function(t){for(var n=this._groups,e=t._groups,r=n.length,i=e.length,o=Math.min(r,i),u=new Array(r),a=0;a<o;++a)for(var c,s=n[a],l=e[a],f=s.length,h=u[a]=new Array(f),d=0;d<f;++d)(c=s[d]||l[d])&&(h[d]=c);for(;a<r;++a)u[a]=n[a];return new $(u,this._parents)},order:function(){for(var t=this._groups,n=-1,e=t.length;++n<e;)for(var r,i=t[n],o=i.length-1,u=i[o];--o>=0;)(r=i[o])&&(u&&4^r.compareDocumentPosition(u)&&u.parentNode.insertBefore(r,u),u=r);return this},sort:function(t){function n(n,e){return n&&e?t(n.__data__,e.__data__):!n-!e}t||(t=l);for(var e=this._groups,r=e.length,i=new Array(r),o=0;o<r;++o){for(var u,a=e[o],c=a.length,s=i[o]=new Array(c),f=0;f<c;++f)(u=a[f])&&(s[f]=u);s.sort(n)}return new $(i,this._parents).order()},call:function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this},nodes:function(){var t=new Array(this.size()),n=-1;return this.each((function(){t[++n]=this})),t},node:function(){for(var t=this._groups,n=0,e=t.length;n<e;++n)for(var r=t[n],i=0,o=r.length;i<o;++i){var u=r[i];if(u)return u}return null},size:function(){var t=0;return this.each((function(){++t})),t},empty:function(){return!this.node()},each:function(t){for(var n=this._groups,e=0,r=n.length;e<r;++e)for(var i,o=n[e],u=0,a=o.length;u<a;++u)(i=o[u])&&t.call(i,i.__data__,u,o);return this},attr:function(t,n){var e=Object(f.a)(t);if(arguments.length<2){var r=this.node();return e.local?r.getAttributeNS(e.space,e.local):r.getAttribute(e)}return this.each((null==n?e.local?d:h:"function"==typeof n?e.local?v:g:e.local?y:p)(e,n))},style:_.a,property:function(t,n){return arguments.length>1?this.each((null==n?m:"function"==typeof n?b:x)(t,n)):this.node()[t]},classed:function(t,n){var e=w(t+"");if(arguments.length<2){for(var r=M(this.node()),i=-1,o=e.length;++i<o;)if(!r.contains(e[i]))return!1;return!0}return this.each(("function"==typeof n?C:n?A:S)(e,n))},text:function(t){return arguments.length?this.each(null==t?N:("function"==typeof t?D:E)(t)):this.node().textContent},html:function(t){return arguments.length?this.each(null==t?j:("function"==typeof t?P:F)(t)):this.node().innerHTML},raise:function(){return this.each(L)},lower:function(){return this.each(I)},append:function(t){var n="function"==typeof t?t:Object(U.a)(t);return this.select((function(){return this.appendChild(n.apply(this,arguments))}))},insert:function(t,n){var e="function"==typeof t?t:Object(U.a)(t),i=null==n?R:"function"==typeof n?n:Object(r.a)(n);return this.select((function(){return this.insertBefore(e.apply(this,arguments),i.apply(this,arguments)||null)}))},remove:function(){return this.each(B)},clone:function(t){return this.select(t?Y:H)},datum:function(t){return arguments.length?this.property("__data__",t):this.node().__data__},on:q.b,dispatch:function(t,n){return this.each(("function"==typeof n?X:V)(t,n))}};n.b=Z},function(t,n,e){"use strict";e.d(n,"c",(function(){return o})),e.d(n,"b",(function(){return u})),e.d(n,"a",(function(){return a}));var r=e(23);function i(t,n){return function(e){return t+e*n}}function o(t,n){var e=n-t;return e?i(t,e>180||e<-180?e-360*Math.round(e/360):e):Object(r.a)(isNaN(t)?n:t)}function u(t){return 1==(t=+t)?a:function(n,e){return e-n?function(t,n,e){return t=Math.pow(t,e),n=Math.pow(n,e)-t,e=1/e,function(r){return Math.pow(t+r*n,e)}}(n,e,t):Object(r.a)(isNaN(n)?e:n)}}function a(t,n){var e=n-t;return e?i(t,e):Object(r.a)(isNaN(t)?n:t)}},function(t,n,e){"use strict";function r(t,n){var e=Object.create(t.prototype);for(var r in n)e[r]=n[r];return e}e.d(n,"b",(function(){return r})),n.a=function(t,n,e){t.prototype=n.prototype=e,e.constructor=t}},function(t,n,e){"use strict";var r=e(20),i=e(14);function o(t){return function(){var n=this.ownerDocument,e=this.namespaceURI;return e===i.b&&n.documentElement.namespaceURI===i.b?n.createElement(t):n.createElementNS(e,t)}}function u(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}n.a=function(t){var n=Object(r.a)(t);return(n.local?u:o)(n)}},function(t,n,e){"use strict";n.a=function(t,n){var e=t.ownerSVGElement||t;if(e.createSVGPoint){var r=e.createSVGPoint();return r.x=n.clientX,r.y=n.clientY,[(r=r.matrixTransform(t.getScreenCTM().inverse())).x,r.y]}var i=t.getBoundingClientRect();return[n.clientX-i.left-t.clientLeft,n.clientY-i.top-t.clientTop]}},function(t,n,e){"use strict";e.d(n,"b",(function(){return r}));var r="http://www.w3.org/1999/xhtml";n.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setMonth(0,1),t.setHours(0,0,0,0)}),(function(t,n){t.setFullYear(t.getFullYear()+n)}),(function(t,n){return n.getFullYear()-t.getFullYear()}),(function(t){return t.getFullYear()}));i.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)((function(n){n.setFullYear(Math.floor(n.getFullYear()/t)*t),n.setMonth(0,1),n.setHours(0,0,0,0)}),(function(n,e){n.setFullYear(n.getFullYear()+e*t)})):null},n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCFullYear(t.getUTCFullYear()+n)}),(function(t,n){return n.getUTCFullYear()-t.getUTCFullYear()}),(function(t){return t.getUTCFullYear()}));i.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)((function(n){n.setUTCFullYear(Math.floor(n.getUTCFullYear()/t)*t),n.setUTCMonth(0,1),n.setUTCHours(0,0,0,0)}),(function(n,e){n.setUTCFullYear(n.getUTCFullYear()+e*t)})):null},n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"c",(function(){return i})),e.d(n,"a",(function(){return l}));var r={},i=null;"undefined"!=typeof document&&("onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"}));function o(t,n,e){return t=u(t,n,e),function(n){var e=n.relatedTarget;e&&(e===this||8&e.compareDocumentPosition(this))||t.call(this,n)}}function u(t,n,e){return function(r){var o=i;i=r;try{t.call(this,this.__data__,n,e)}finally{i=o}}}function a(t){return t.trim().split(/^|\s+/).map((function(t){var n="",e=t.indexOf(".");return e>=0&&(n=t.slice(e+1),t=t.slice(0,e)),{type:t,name:n}}))}function c(t){return function(){var n=this.__on;if(n){for(var e,r=0,i=-1,o=n.length;r<o;++r)e=n[r],t.type&&e.type!==t.type||e.name!==t.name?n[++i]=e:this.removeEventListener(e.type,e.listener,e.capture);++i?n.length=i:delete this.__on}}}function s(t,n,e){var i=r.hasOwnProperty(t.type)?o:u;return function(r,o,u){var a,c=this.__on,s=i(n,o,u);if(c)for(var l=0,f=c.length;l<f;++l)if((a=c[l]).type===t.type&&a.name===t.name)return this.removeEventListener(a.type,a.listener,a.capture),this.addEventListener(a.type,a.listener=s,a.capture=e),void(a.value=n);this.addEventListener(t.type,s,e),a={type:t.type,name:t.name,value:n,listener:s,capture:e},c?c.push(a):this.__on=[a]}}function l(t,n,e,r){var o=i;t.sourceEvent=i,i=t;try{return n.apply(e,r)}finally{i=o}}n.b=function(t,n,e){var r,i,o=a(t+""),u=o.length;if(!(arguments.length<2)){for(l=n?s:c,null==e&&(e=!1),r=0;r<u;++r)this.each(l(o[r],n,e));return this}var l=this.node().__on;if(l)for(var f,h=0,d=l.length;h<d;++h)for(r=0,f=l[h];r<u;++r)if((i=o[r]).type===f.type&&i.name===f.name)return f.value}},function(t,n,e){"use strict";n.a=function(t,n){if((e=(t=n?t.toExponential(n-1):t.toExponential()).indexOf("e"))<0)return null;var e,r=t.slice(0,e);return[r.length>1?r[0]+r.slice(2):r,+t.slice(e+1)]}},function(t,n,e){"use strict";function r(){}n.a=function(t){return null==t?r:function(){return this.querySelector(t)}}},function(t,n,e){"use strict";var r=e(14);n.a=function(t){var n=t+="",e=n.indexOf(":");return e>=0&&"xmlns"!==(n=t.slice(0,e))&&(t=t.slice(e+1)),r.a.hasOwnProperty(n)?{space:r.a[n],local:t}:t}},function(t,n,e){"use strict";n.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,n,e){"use strict";var r=e(17);n.a=function(){for(var t,n=r.c;t=n.sourceEvent;)n=t;return n}},function(t,n,e){"use strict";n.a=function(t){return function(){return t}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"a",(function(){return o}));var r=/^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;function i(t){if(!(n=r.exec(t)))throw new Error("invalid format: "+t);var n;return new o({fill:n[1],align:n[2],sign:n[3],symbol:n[4],zero:n[5],width:n[6],comma:n[7],precision:n[8]&&n[8].slice(1),trim:n[9],type:n[10]})}function o(t){this.fill=void 0===t.fill?" ":t.fill+"",this.align=void 0===t.align?">":t.align+"",this.sign=void 0===t.sign?"-":t.sign+"",this.symbol=void 0===t.symbol?"":t.symbol+"",this.zero=!!t.zero,this.width=void 0===t.width?void 0:+t.width,this.comma=!!t.comma,this.precision=void 0===t.precision?void 0:+t.precision,this.trim=!!t.trim,this.type=void 0===t.type?"":t.type+""}i.prototype=o.prototype,o.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(void 0===this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(void 0===this.precision?"":"."+Math.max(0,0|this.precision))+(this.trim?"~":"")+this.type}},function(t,n,e){"use strict";function r(t){return ArrayBuffer.isView(t)&&!(t instanceof DataView)}e.d(n,"b",(function(){return r})),n.a=function(t,n){n||(n=[]);var e,r=t?Math.min(n.length,t.length):0,i=n.slice();return function(o){for(e=0;e<r;++e)i[e]=t[e]*(1-o)+n[e]*o;return i}}},function(t,n,e){"use strict";function r(t,n,e,r,i){var o=t*t,u=o*t;return((1-3*t+3*o-u)*n+(4-6*o+3*u)*e+(1+3*t+3*o-3*u)*r+u*i)/6}e.d(n,"a",(function(){return r})),n.b=function(t){var n=t.length-1;return function(e){var i=e<=0?e=0:e>=1?(e=1,n-1):Math.floor(e*n),o=t[i],u=t[i+1],a=i>0?t[i-1]:2*o-u,c=i<n-1?t[i+2]:2*u-o;return r((e-i/n)*n,a,o,u,c)}}},function(t,n,e){"use strict";e.d(n,"a",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setHours(0,0,0,0)}),(function(t,n){t.setDate(t.getDate()+n)}),(function(t,n){return(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*i.c)/i.a}),(function(t){return t.getDate()-1}));n.b=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCDate(t.getUTCDate()+n)}),(function(t,n){return(n-t)/i.a}),(function(t){return t.getUTCDate()-1}));n.a=o;var u=o.range},function(t,n,e){"use strict";function r(t){return t*t*t}function i(t){return--t*t*t+1}function o(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.d(n,"a",(function(){return r})),e.d(n,"c",(function(){return i})),e.d(n,"b",(function(){return o}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds())}),(function(t,n){t.setTime(+t+n*i.d)}),(function(t,n){return(n-t)/i.d}),(function(t){return t.getUTCSeconds()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(){}),(function(t,n){t.setTime(+t+n)}),(function(t,n){return n-t}));i.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?Object(r.a)((function(n){n.setTime(Math.floor(n/t)*t)}),(function(n,e){n.setTime(+n+e*t)}),(function(n,e){return(e-n)/t})):i:null},n.a=i;var o=i.range},function(t,n,e){"use strict";var r=e(9);n.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,n,e){"use strict";function r(){return[]}n.a=function(t){return null==t?r:function(){return this.querySelectorAll(t)}}},function(t,n,e){"use strict";n.a=function(t){return function(){return this.matches(t)}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return a}));var r=e(21);function i(t){return function(){this.style.removeProperty(t)}}function o(t,n,e){return function(){this.style.setProperty(t,n,e)}}function u(t,n,e){return function(){var r=n.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,e)}}function a(t,n){return t.style.getPropertyValue(n)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(n)}n.a=function(t,n,e){return arguments.length>1?this.each((null==n?i:"function"==typeof n?u:o)(t,n,null==e?"":e)):a(this.node(),t)}},function(t,n,e){"use strict";var r=e(7),i=e(39),o=e(57),u=e(56),a=e(5),c=e(58),s=e(55),l=e(23),f=e(25);n.a=function(t,n){var e,h=typeof n;return null==n||"boolean"===h?Object(l.a)(n):("number"===h?a.a:"string"===h?(e=Object(r.e)(n))?(n=e,i.a):s.a:n instanceof r.e?i.a:n instanceof Date?u.a:Object(f.b)(n)?f.a:Array.isArray(n)?o.b:"function"!=typeof n.valueOf&&"function"!=typeof n.toString||isNaN(n)?c.a:a.a)(t,n)}},function(t,n,e){"use strict";var r,i=e(8),o=e(24),u=e(18),a=function(t,n){var e=Object(u.a)(t,n);if(!e)return t+"";var r=e[0],i=e[1];return i<0?"0."+new Array(-i).join("0")+r:r.length>i+1?r.slice(0,i+1)+"."+r.slice(i+1):r+new Array(i-r.length+2).join("0")},c={"%":function(t,n){return(100*t).toFixed(n)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,n){return t.toExponential(n)},f:function(t,n){return t.toFixed(n)},g:function(t,n){return t.toPrecision(n)},o:function(t){return Math.round(t).toString(8)},p:function(t,n){return a(100*t,n)},r:a,s:function(t,n){var e=Object(u.a)(t,n);if(!e)return t+"";var i=e[0],o=e[1],a=o-(r=3*Math.max(-8,Math.min(8,Math.floor(o/3))))+1,c=i.length;return a===c?i:a>c?i+new Array(a-c+1).join("0"):a>0?i.slice(0,a)+"."+i.slice(a):"0."+new Array(1-a).join("0")+Object(u.a)(t,Math.max(0,n+a-1))[0]},X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}},s=function(t){return t},l=Array.prototype.map,f=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];n.a=function(t){var n,e,u=void 0===t.grouping||void 0===t.thousands?s:(n=l.call(t.grouping,Number),e=t.thousands+"",function(t,r){for(var i=t.length,o=[],u=0,a=n[0],c=0;i>0&&a>0&&(c+a+1>r&&(a=Math.max(1,r-c)),o.push(t.substring(i-=a,i+a)),!((c+=a+1)>r));)a=n[u=(u+1)%n.length];return o.reverse().join(e)}),a=void 0===t.currency?"":t.currency[0]+"",h=void 0===t.currency?"":t.currency[1]+"",d=void 0===t.decimal?".":t.decimal+"",p=void 0===t.numerals?s:function(t){return function(n){return n.replace(/[0-9]/g,(function(n){return t[+n]}))}}(l.call(t.numerals,String)),y=void 0===t.percent?"%":t.percent+"",g=void 0===t.minus?"-":t.minus+"",v=void 0===t.nan?"NaN":t.nan+"";function _(t){var n=(t=Object(o.b)(t)).fill,e=t.align,i=t.sign,s=t.symbol,l=t.zero,_=t.width,m=t.comma,x=t.precision,b=t.trim,w=t.type;"n"===w?(m=!0,w="g"):c[w]||(void 0===x&&(x=12),b=!0,w="g"),(l||"0"===n&&"="===e)&&(l=!0,n="0",e="=");var M="$"===s?a:"#"===s&&/[boxX]/.test(w)?"0"+w.toLowerCase():"",T="$"===s?h:/[%p]/.test(w)?y:"",k=c[w],O=/[defgprs%]/.test(w);function A(t){var o,a,c,s=M,h=T;if("c"===w)h=k(t)+h,t="";else{var y=(t=+t)<0;if(t=isNaN(t)?v:k(Math.abs(t),x),b&&(t=function(t){t:for(var n,e=t.length,r=1,i=-1;r<e;++r)switch(t[r]){case".":i=n=r;break;case"0":0===i&&(i=r),n=r;break;default:if(!+t[r])break t;i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}(t)),y&&0==+t&&(y=!1),s=(y?"("===i?i:g:"-"===i||"("===i?"":i)+s,h=("s"===w?f[8+r/3]:"")+h+(y&&"("===i?")":""),O)for(o=-1,a=t.length;++o<a;)if(48>(c=t.charCodeAt(o))||c>57){h=(46===c?d+t.slice(o+1):t.slice(o))+h,t=t.slice(0,o);break}}m&&!l&&(t=u(t,1/0));var A=s.length+t.length+h.length,S=A<_?new Array(_-A+1).join(n):"";switch(m&&l&&(t=u(S+t,S.length?_-h.length:1/0),S=""),e){case"<":t=s+t+h+S;break;case"=":t=s+S+t+h;break;case"^":t=S.slice(0,A=S.length>>1)+s+t+h+S.slice(A);break;default:t=S+s+t+h}return p(t)}return x=void 0===x?6:/[gprs]/.test(w)?Math.max(1,Math.min(21,x)):Math.max(0,Math.min(20,x)),A.toString=function(){return t+""},A}return{format:_,formatPrefix:function(t,n){var e=_(((t=Object(o.b)(t)).type="f",t)),r=3*Math.max(-8,Math.min(8,Math.floor(Object(i.a)(n)/3))),u=Math.pow(10,-r),a=f[8+r/3];return function(t){return e(u*t)+a}}}}},function(t,n,e){"use strict";e.r(n);var r=e(0);e.d(n,"timeInterval",(function(){return r.a}));var i=e(31);e.d(n,"timeMillisecond",(function(){return i.a})),e.d(n,"timeMilliseconds",(function(){return i.b})),e.d(n,"utcMillisecond",(function(){return i.a})),e.d(n,"utcMilliseconds",(function(){return i.b}));var o=e(30);e.d(n,"timeSecond",(function(){return o.a})),e.d(n,"timeSeconds",(function(){return o.b})),e.d(n,"utcSecond",(function(){return o.a})),e.d(n,"utcSeconds",(function(){return o.b}));var u=e(49);e.d(n,"timeMinute",(function(){return u.a})),e.d(n,"timeMinutes",(function(){return u.b}));var a=e(48);e.d(n,"timeHour",(function(){return a.a})),e.d(n,"timeHours",(function(){return a.b}));var c=e(27);e.d(n,"timeDay",(function(){return c.b})),e.d(n,"timeDays",(function(){return c.a}));var s=e(3);e.d(n,"timeWeek",(function(){return s.g})),e.d(n,"timeWeeks",(function(){return s.h})),e.d(n,"timeSunday",(function(){return s.g})),e.d(n,"timeSundays",(function(){return s.h})),e.d(n,"timeMonday",(function(){return s.c})),e.d(n,"timeMondays",(function(){return s.d})),e.d(n,"timeTuesday",(function(){return s.k})),e.d(n,"timeTuesdays",(function(){return s.l})),e.d(n,"timeWednesday",(function(){return s.m})),e.d(n,"timeWednesdays",(function(){return s.n})),e.d(n,"timeThursday",(function(){return s.i})),e.d(n,"timeThursdays",(function(){return s.j})),e.d(n,"timeFriday",(function(){return s.a})),e.d(n,"timeFridays",(function(){return s.b})),e.d(n,"timeSaturday",(function(){return s.e})),e.d(n,"timeSaturdays",(function(){return s.f}));var l=e(47);e.d(n,"timeMonth",(function(){return l.a})),e.d(n,"timeMonths",(function(){return l.b}));var f=e(15);e.d(n,"timeYear",(function(){return f.a})),e.d(n,"timeYears",(function(){return f.b}));var h=e(52);e.d(n,"utcMinute",(function(){return h.a})),e.d(n,"utcMinutes",(function(){return h.b}));var d=e(51);e.d(n,"utcHour",(function(){return d.a})),e.d(n,"utcHours",(function(){return d.b}));var p=e(28);e.d(n,"utcDay",(function(){return p.a})),e.d(n,"utcDays",(function(){return p.b}));var y=e(4);e.d(n,"utcWeek",(function(){return y.g})),e.d(n,"utcWeeks",(function(){return y.h})),e.d(n,"utcSunday",(function(){return y.g})),e.d(n,"utcSundays",(function(){return y.h})),e.d(n,"utcMonday",(function(){return y.c})),e.d(n,"utcMondays",(function(){return y.d})),e.d(n,"utcTuesday",(function(){return y.k})),e.d(n,"utcTuesdays",(function(){return y.l})),e.d(n,"utcWednesday",(function(){return y.m})),e.d(n,"utcWednesdays",(function(){return y.n})),e.d(n,"utcThursday",(function(){return y.i})),e.d(n,"utcThursdays",(function(){return y.j})),e.d(n,"utcFriday",(function(){return y.a})),e.d(n,"utcFridays",(function(){return y.b})),e.d(n,"utcSaturday",(function(){return y.e})),e.d(n,"utcSaturdays",(function(){return y.f}));var g=e(50);e.d(n,"utcMonth",(function(){return g.a})),e.d(n,"utcMonths",(function(){return g.b}));var v=e(16);e.d(n,"utcYear",(function(){return v.a})),e.d(n,"utcYears",(function(){return v.b}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return c})),e.d(n,"c",(function(){return s}));var r=e(7),i=e(26),o=e(53),u=e(10);function a(t){return function(n){var e,i,o=n.length,u=new Array(o),a=new Array(o),c=new Array(o);for(e=0;e<o;++e)i=Object(r.g)(n[e]),u[e]=i.r||0,a[e]=i.g||0,c[e]=i.b||0;return u=t(u),a=t(a),c=t(c),i.opacity=1,function(t){return i.r=u(t),i.g=a(t),i.b=c(t),i+""}}}n.a=function t(n){var e=Object(u.b)(n);function i(t,n){var i=e((t=Object(r.g)(t)).r,(n=Object(r.g)(n)).r),o=e(t.g,n.g),a=e(t.b,n.b),c=Object(u.a)(t.opacity,n.opacity);return function(n){return t.r=i(n),t.g=o(n),t.b=a(n),t.opacity=c(n),t+""}}return i.gamma=t,i}(1);var c=a(i.b),s=a(o.a)},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"c",(function(){return o})),e.d(n,"a",(function(){return a}));var r,i,o,u=e(37);function a(t){return r=Object(u.a)(t),i=r.format,o=r.formatPrefix,r}a({decimal:".",thousands:",",grouping:[3],currency:["$",""],minus:"-"})},,,,function(t,n,e){"use strict";e.r(n);var r=e(40);e.d(n,"formatDefaultLocale",(function(){return r.a})),e.d(n,"format",(function(){return r.b})),e.d(n,"formatPrefix",(function(){return r.c}));var i=e(37);e.d(n,"formatLocale",(function(){return i.a}));var o=e(24);e.d(n,"formatSpecifier",(function(){return o.b})),e.d(n,"FormatSpecifier",(function(){return o.a}));var u=e(61);e.d(n,"precisionFixed",(function(){return u.a}));var a=e(62);e.d(n,"precisionPrefix",(function(){return a.a}));var c=e(63);e.d(n,"precisionRound",(function(){return c.a}))},function(t,n,e){"use strict";e.r(n);function r(){}function i(t,n){var e=new r;if(t instanceof r)t.each((function(t,n){e.set(n,t)}));else if(Array.isArray(t)){var i,o=-1,u=t.length;if(null==n)for(;++o<u;)e.set(o,t[o]);else for(;++o<u;)e.set(n(i=t[o],o,t),i)}else if(t)for(var a in t)e.set(a,t[a]);return e}r.prototype=i.prototype={constructor:r,has:function(t){return"$"+t in this},get:function(t){return this["$"+t]},set:function(t,n){return this["$"+t]=n,this},remove:function(t){var n="$"+t;return n in this&&delete this[n]},clear:function(){for(var t in this)"$"===t[0]&&delete this[t]},keys:function(){var t=[];for(var n in this)"$"===n[0]&&t.push(n.slice(1));return t},values:function(){var t=[];for(var n in this)"$"===n[0]&&t.push(this[n]);return t},entries:function(){var t=[];for(var n in this)"$"===n[0]&&t.push({key:n.slice(1),value:this[n]});return t},size:function(){var t=0;for(var n in this)"$"===n[0]&&++t;return t},empty:function(){for(var t in this)if("$"===t[0])return!1;return!0},each:function(t){for(var n in this)"$"===n[0]&&t(this[n],n.slice(1),this)}};var o=i,u=function(){var t,n,e,r=[],i=[];function u(e,i,a,c){if(i>=r.length)return null!=t&&e.sort(t),null!=n?n(e):e;for(var s,l,f,h=-1,d=e.length,p=r[i++],y=o(),g=a();++h<d;)(f=y.get(s=p(l=e[h])+""))?f.push(l):y.set(s,[l]);return y.each((function(t,n){c(g,n,u(t,i,a,c))})),g}return e={object:function(t){return u(t,0,a,c)},map:function(t){return u(t,0,s,l)},entries:function(t){return function t(e,o){if(++o>r.length)return e;var u,a=i[o-1];return null!=n&&o>=r.length?u=e.entries():(u=[],e.each((function(n,e){u.push({key:e,values:t(n,o)})}))),null!=a?u.sort((function(t,n){return a(t.key,n.key)})):u}(u(t,0,s,l),0)},key:function(t){return r.push(t),e},sortKeys:function(t){return i[r.length-1]=t,e},sortValues:function(n){return t=n,e},rollup:function(t){return n=t,e}}};function a(){return{}}function c(t,n,e){t[n]=e}function s(){return o()}function l(t,n,e){t.set(n,e)}function f(){}var h=o.prototype;function d(t,n){var e=new f;if(t instanceof f)t.each((function(t){e.add(t)}));else if(t){var r=-1,i=t.length;if(null==n)for(;++r<i;)e.add(t[r]);else for(;++r<i;)e.add(n(t[r],r,t))}return e}f.prototype=d.prototype={constructor:f,has:h.has,add:function(t){return this["$"+(t+="")]=t,this},remove:h.remove,clear:h.clear,values:h.keys,size:h.size,empty:h.empty,each:h.each};var p=d,y=function(t){var n=[];for(var e in t)n.push(e);return n},g=function(t){var n=[];for(var e in t)n.push(t[e]);return n},v=function(t){var n=[];for(var e in t)n.push({key:e,value:t[e]});return n};e.d(n,"nest",(function(){return u})),e.d(n,"set",(function(){return p})),e.d(n,"map",(function(){return o})),e.d(n,"keys",(function(){return y})),e.d(n,"values",(function(){return g})),e.d(n,"entries",(function(){return v}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"c",(function(){return o})),e.d(n,"d",(function(){return u})),e.d(n,"e",(function(){return a})),e.d(n,"a",(function(){return s}));var r,i,o,u,a,c=e(54);function s(t){return r=Object(c.a)(t),i=r.format,o=r.parse,u=r.utcFormat,a=r.utcParse,r}s({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setDate(1),t.setHours(0,0,0,0)}),(function(t,n){t.setMonth(t.getMonth()+n)}),(function(t,n){return n.getMonth()-t.getMonth()+12*(n.getFullYear()-t.getFullYear())}),(function(t){return t.getMonth()}));n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds()-t.getSeconds()*i.d-t.getMinutes()*i.c)}),(function(t,n){t.setTime(+t+n*i.b)}),(function(t,n){return(n-t)/i.b}),(function(t){return t.getHours()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds()-t.getSeconds()*i.d)}),(function(t,n){t.setTime(+t+n*i.c)}),(function(t,n){return(n-t)/i.c}),(function(t){return t.getMinutes()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setUTCDate(1),t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCMonth(t.getUTCMonth()+n)}),(function(t,n){return n.getUTCMonth()-t.getUTCMonth()+12*(n.getUTCFullYear()-t.getUTCFullYear())}),(function(t){return t.getUTCMonth()}));n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCMinutes(0,0,0)}),(function(t,n){t.setTime(+t+n*i.b)}),(function(t,n){return(n-t)/i.b}),(function(t){return t.getUTCHours()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCSeconds(0,0)}),(function(t,n){t.setTime(+t+n*i.c)}),(function(t,n){return(n-t)/i.c}),(function(t){return t.getUTCMinutes()}));n.a=o;var u=o.range},function(t,n,e){"use strict";var r=e(26);n.a=function(t){var n=t.length;return function(e){var i=Math.floor(((e%=1)<0?++e:e)*n),o=t[(i+n-1)%n],u=t[i%n],a=t[(i+1)%n],c=t[(i+2)%n];return Object(r.a)((e-i/n)*n,o,u,a,c)}}},function(t,n,e){"use strict";e.d(n,"a",(function(){return h}));var r=e(4),i=e(28),o=e(3),u=e(27),a=e(15),c=e(16);function s(t){if(0<=t.y&&t.y<100){var n=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return n.setFullYear(t.y),n}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function l(t){if(0<=t.y&&t.y<100){var n=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return n.setUTCFullYear(t.y),n}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function f(t,n,e){return{y:t,m:n,d:e,H:0,M:0,S:0,L:0}}function h(t){var n=t.dateTime,e=t.date,a=t.time,c=t.periods,h=t.days,p=t.shortDays,y=t.months,g=t.shortMonths,v=m(c),_=x(c),Tt=m(h),kt=x(h),Ot=m(p),At=x(p),St=m(y),Ct=x(y),Nt=m(g),Et=x(g),Dt={a:function(t){return p[t.getDay()]},A:function(t){return h[t.getDay()]},b:function(t){return g[t.getMonth()]},B:function(t){return y[t.getMonth()]},c:null,d:H,e:H,f:V,H:Y,I:q,j:z,L:G,m:X,M:W,p:function(t){return c[+(t.getHours()>=12)]},q:function(t){return 1+~~(t.getMonth()/3)},Q:wt,s:Mt,S:$,u:Z,U:Q,V:J,w:K,W:tt,x:null,X:null,y:nt,Y:et,Z:rt,"%":bt},jt={a:function(t){return p[t.getUTCDay()]},A:function(t){return h[t.getUTCDay()]},b:function(t){return g[t.getUTCMonth()]},B:function(t){return y[t.getUTCMonth()]},c:null,d:it,e:it,f:st,H:ot,I:ut,j:at,L:ct,m:lt,M:ft,p:function(t){return c[+(t.getUTCHours()>=12)]},q:function(t){return 1+~~(t.getUTCMonth()/3)},Q:wt,s:Mt,S:ht,u:dt,U:pt,V:yt,w:gt,W:vt,x:null,X:null,y:_t,Y:mt,Z:xt,"%":bt},Ft={a:function(t,n,e){var r=Ot.exec(n.slice(e));return r?(t.w=At[r[0].toLowerCase()],e+r[0].length):-1},A:function(t,n,e){var r=Tt.exec(n.slice(e));return r?(t.w=kt[r[0].toLowerCase()],e+r[0].length):-1},b:function(t,n,e){var r=Nt.exec(n.slice(e));return r?(t.m=Et[r[0].toLowerCase()],e+r[0].length):-1},B:function(t,n,e){var r=St.exec(n.slice(e));return r?(t.m=Ct[r[0].toLowerCase()],e+r[0].length):-1},c:function(t,e,r){return It(t,n,e,r)},d:E,e:E,f:I,H:j,I:j,j:D,L:L,m:N,M:F,p:function(t,n,e){var r=v.exec(n.slice(e));return r?(t.p=_[r[0].toLowerCase()],e+r[0].length):-1},q:C,Q:R,s:B,S:P,u:w,U:M,V:T,w:b,W:k,x:function(t,n,r){return It(t,e,n,r)},X:function(t,n,e){return It(t,a,n,e)},y:A,Y:O,Z:S,"%":U};function Pt(t,n){return function(e){var r,i,o,u=[],a=-1,c=0,s=t.length;for(e instanceof Date||(e=new Date(+e));++a<s;)37===t.charCodeAt(a)&&(u.push(t.slice(c,a)),null!=(i=d[r=t.charAt(++a)])?r=t.charAt(++a):i="e"===r?" ":"0",(o=n[r])&&(r=o(e,i)),u.push(r),c=a+1);return u.push(t.slice(c,a)),u.join("")}}function Lt(t,n){return function(e){var a,c,h=f(1900,void 0,1);if(It(h,t,e+="",0)!=e.length)return null;if("Q"in h)return new Date(h.Q);if("s"in h)return new Date(1e3*h.s+("L"in h?h.L:0));if(!n||"Z"in h||(h.Z=0),"p"in h&&(h.H=h.H%12+12*h.p),void 0===h.m&&(h.m="q"in h?h.q:0),"V"in h){if(h.V<1||h.V>53)return null;"w"in h||(h.w=1),"Z"in h?(c=(a=l(f(h.y,0,1))).getUTCDay(),a=c>4||0===c?r.c.ceil(a):Object(r.c)(a),a=i.a.offset(a,7*(h.V-1)),h.y=a.getUTCFullYear(),h.m=a.getUTCMonth(),h.d=a.getUTCDate()+(h.w+6)%7):(c=(a=s(f(h.y,0,1))).getDay(),a=c>4||0===c?o.c.ceil(a):Object(o.c)(a),a=u.b.offset(a,7*(h.V-1)),h.y=a.getFullYear(),h.m=a.getMonth(),h.d=a.getDate()+(h.w+6)%7)}else("W"in h||"U"in h)&&("w"in h||(h.w="u"in h?h.u%7:"W"in h?1:0),c="Z"in h?l(f(h.y,0,1)).getUTCDay():s(f(h.y,0,1)).getDay(),h.m=0,h.d="W"in h?(h.w+6)%7+7*h.W-(c+5)%7:h.w+7*h.U-(c+6)%7);return"Z"in h?(h.H+=h.Z/100|0,h.M+=h.Z%100,l(h)):s(h)}}function It(t,n,e,r){for(var i,o,u=0,a=n.length,c=e.length;u<a;){if(r>=c)return-1;if(37===(i=n.charCodeAt(u++))){if(i=n.charAt(u++),!(o=Ft[i in d?n.charAt(u++):i])||(r=o(t,e,r))<0)return-1}else if(i!=e.charCodeAt(r++))return-1}return r}return(Dt.x=Pt(e,Dt),Dt.X=Pt(a,Dt),Dt.c=Pt(n,Dt),jt.x=Pt(e,jt),jt.X=Pt(a,jt),jt.c=Pt(n,jt),{format:function(t){var n=Pt(t+="",Dt);return n.toString=function(){return t},n},parse:function(t){var n=Lt(t+="",!1);return n.toString=function(){return t},n},utcFormat:function(t){var n=Pt(t+="",jt);return n.toString=function(){return t},n},utcParse:function(t){var n=Lt(t+="",!0);return n.toString=function(){return t},n}})}var d={"-":"",_:" ",0:"0"},p=/^\s*\d+/,y=/^%/,g=/[\\^$*+?|[\]().{}]/g;function v(t,n,e){var r=t<0?"-":"",i=(r?-t:t)+"",o=i.length;return r+(o<e?new Array(e-o+1).join(n)+i:i)}function _(t){return t.replace(g,"\\$&")}function m(t){return new RegExp("^(?:"+t.map(_).join("|")+")","i")}function x(t){for(var n={},e=-1,r=t.length;++e<r;)n[t[e].toLowerCase()]=e;return n}function b(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.w=+r[0],e+r[0].length):-1}function w(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.u=+r[0],e+r[0].length):-1}function M(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.U=+r[0],e+r[0].length):-1}function T(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.V=+r[0],e+r[0].length):-1}function k(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.W=+r[0],e+r[0].length):-1}function O(t,n,e){var r=p.exec(n.slice(e,e+4));return r?(t.y=+r[0],e+r[0].length):-1}function A(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),e+r[0].length):-1}function S(t,n,e){var r=/^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(n.slice(e,e+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),e+r[0].length):-1}function C(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.q=3*r[0]-3,e+r[0].length):-1}function N(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.m=r[0]-1,e+r[0].length):-1}function E(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.d=+r[0],e+r[0].length):-1}function D(t,n,e){var r=p.exec(n.slice(e,e+3));return r?(t.m=0,t.d=+r[0],e+r[0].length):-1}function j(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.H=+r[0],e+r[0].length):-1}function F(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.M=+r[0],e+r[0].length):-1}function P(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.S=+r[0],e+r[0].length):-1}function L(t,n,e){var r=p.exec(n.slice(e,e+3));return r?(t.L=+r[0],e+r[0].length):-1}function I(t,n,e){var r=p.exec(n.slice(e,e+6));return r?(t.L=Math.floor(r[0]/1e3),e+r[0].length):-1}function U(t,n,e){var r=y.exec(n.slice(e,e+1));return r?e+r[0].length:-1}function R(t,n,e){var r=p.exec(n.slice(e));return r?(t.Q=+r[0],e+r[0].length):-1}function B(t,n,e){var r=p.exec(n.slice(e));return r?(t.s=+r[0],e+r[0].length):-1}function H(t,n){return v(t.getDate(),n,2)}function Y(t,n){return v(t.getHours(),n,2)}function q(t,n){return v(t.getHours()%12||12,n,2)}function z(t,n){return v(1+u.b.count(Object(a.a)(t),t),n,3)}function G(t,n){return v(t.getMilliseconds(),n,3)}function V(t,n){return G(t,n)+"000"}function X(t,n){return v(t.getMonth()+1,n,2)}function W(t,n){return v(t.getMinutes(),n,2)}function $(t,n){return v(t.getSeconds(),n,2)}function Z(t){var n=t.getDay();return 0===n?7:n}function Q(t,n){return v(o.g.count(Object(a.a)(t)-1,t),n,2)}function J(t,n){var e=t.getDay();return t=e>=4||0===e?Object(o.i)(t):o.i.ceil(t),v(o.i.count(Object(a.a)(t),t)+(4===Object(a.a)(t).getDay()),n,2)}function K(t){return t.getDay()}function tt(t,n){return v(o.c.count(Object(a.a)(t)-1,t),n,2)}function nt(t,n){return v(t.getFullYear()%100,n,2)}function et(t,n){return v(t.getFullYear()%1e4,n,4)}function rt(t){var n=t.getTimezoneOffset();return(n>0?"-":(n*=-1,"+"))+v(n/60|0,"0",2)+v(n%60,"0",2)}function it(t,n){return v(t.getUTCDate(),n,2)}function ot(t,n){return v(t.getUTCHours(),n,2)}function ut(t,n){return v(t.getUTCHours()%12||12,n,2)}function at(t,n){return v(1+i.a.count(Object(c.a)(t),t),n,3)}function ct(t,n){return v(t.getUTCMilliseconds(),n,3)}function st(t,n){return ct(t,n)+"000"}function lt(t,n){return v(t.getUTCMonth()+1,n,2)}function ft(t,n){return v(t.getUTCMinutes(),n,2)}function ht(t,n){return v(t.getUTCSeconds(),n,2)}function dt(t){var n=t.getUTCDay();return 0===n?7:n}function pt(t,n){return v(r.g.count(Object(c.a)(t)-1,t),n,2)}function yt(t,n){var e=t.getUTCDay();return t=e>=4||0===e?Object(r.i)(t):r.i.ceil(t),v(r.i.count(Object(c.a)(t),t)+(4===Object(c.a)(t).getUTCDay()),n,2)}function gt(t){return t.getUTCDay()}function vt(t,n){return v(r.c.count(Object(c.a)(t)-1,t),n,2)}function _t(t,n){return v(t.getUTCFullYear()%100,n,2)}function mt(t,n){return v(t.getUTCFullYear()%1e4,n,4)}function xt(){return"+0000"}function bt(){return"%"}function wt(t){return+t}function Mt(t){return Math.floor(+t/1e3)}},function(t,n,e){"use strict";var r=e(5),i=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,o=new RegExp(i.source,"g");n.a=function(t,n){var e,u,a,c=i.lastIndex=o.lastIndex=0,s=-1,l=[],f=[];for(t+="",n+="";(e=i.exec(t))&&(u=o.exec(n));)(a=u.index)>c&&(a=n.slice(c,a),l[s]?l[s]+=a:l[++s]=a),(e=e[0])===(u=u[0])?l[s]?l[s]+=u:l[++s]=u:(l[++s]=null,f.push({i:s,x:Object(r.a)(e,u)})),c=o.lastIndex;return c<n.length&&(a=n.slice(c),l[s]?l[s]+=a:l[++s]=a),l.length<2?f[0]?function(t){return function(n){return t(n)+""}}(f[0].x):function(t){return function(){return t}}(n):(n=f.length,function(t){for(var e,r=0;r<n;++r)l[(e=f[r]).i]=e.x(t);return l.join("")})}},function(t,n,e){"use strict";n.a=function(t,n){var e=new Date;return t=+t,n=+n,function(r){return e.setTime(t*(1-r)+n*r),e}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(36),i=e(25);function o(t,n){var e,i=n?n.length:0,o=t?Math.min(i,t.length):0,u=new Array(o),a=new Array(i);for(e=0;e<o;++e)u[e]=Object(r.a)(t[e],n[e]);for(;e<i;++e)a[e]=n[e];return function(t){for(e=0;e<o;++e)a[e]=u[e](t);return a}}n.a=function(t,n){return(Object(i.b)(n)?i.a:o)(t,n)}},function(t,n,e){"use strict";var r=e(36);n.a=function(t,n){var e,i={},o={};for(e in null!==t&&"object"==typeof t||(t={}),null!==n&&"object"==typeof n||(n={}),n)e in t?i[e]=Object(r.a)(t[e],n[e]):o[e]=n[e];return function(t){for(e in i)o[e]=i[e](t);return o}}},function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t){var n=Object(r.a)();return n.changedTouches&&(n=n.changedTouches[0]),Object(i.a)(t,n)}},function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t,n,e){arguments.length<3&&(e=n,n=Object(r.a)().changedTouches);for(var o,u=0,a=n?n.length:0;u<a;++u)if((o=n[u]).identifier===e)return Object(i.a)(t,o);return null}},function(t,n,e){"use strict";var r=e(8);n.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(n)/3)))-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return t=Math.abs(t),n=Math.abs(n)-t,Math.max(0,Object(r.a)(n)-Object(r.a)(t))+1}},function(t,n,e){"use strict";function r(t){return+t}function i(t){return t*t}function o(t){return t*(2-t)}function u(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.r(n);var a=e(29),c=function t(n){function e(t){return Math.pow(t,n)}return n=+n,e.exponent=t,e}(3),s=function t(n){function e(t){return 1-Math.pow(1-t,n)}return n=+n,e.exponent=t,e}(3),l=function t(n){function e(t){return((t*=2)<=1?Math.pow(t,n):2-Math.pow(2-t,n))/2}return n=+n,e.exponent=t,e}(3),f=Math.PI,h=f/2;function d(t){return 1-Math.cos(t*h)}function p(t){return Math.sin(t*h)}function y(t){return(1-Math.cos(f*t))/2}function g(t){return Math.pow(2,10*t-10)}function v(t){return 1-Math.pow(2,-10*t)}function _(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}function m(t){return 1-Math.sqrt(1-t*t)}function x(t){return Math.sqrt(1- --t*t)}function b(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}var w=7.5625;function M(t){return 1-T(1-t)}function T(t){return(t=+t)<4/11?w*t*t:t<8/11?w*(t-=6/11)*t+.75:t<10/11?w*(t-=9/11)*t+.9375:w*(t-=21/22)*t+63/64}function k(t){return((t*=2)<=1?1-T(1-t):T(t-1)+1)/2}var O=function t(n){function e(t){return t*t*((n+1)*t-n)}return n=+n,e.overshoot=t,e}(1.70158),A=function t(n){function e(t){return--t*t*((n+1)*t+n)+1}return n=+n,e.overshoot=t,e}(1.70158),S=function t(n){function e(t){return((t*=2)<1?t*t*((n+1)*t-n):(t-=2)*t*((n+1)*t+n)+2)/2}return n=+n,e.overshoot=t,e}(1.70158),C=2*Math.PI,N=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=C);function i(t){return n*Math.pow(2,10*--t)*Math.sin((r-t)/e)}return i.amplitude=function(n){return t(n,e*C)},i.period=function(e){return t(n,e)},i}(1,.3),E=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=C);function i(t){return 1-n*Math.pow(2,-10*(t=+t))*Math.sin((t+r)/e)}return i.amplitude=function(n){return t(n,e*C)},i.period=function(e){return t(n,e)},i}(1,.3),D=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=C);function i(t){return((t=2*t-1)<0?n*Math.pow(2,10*t)*Math.sin((r-t)/e):2-n*Math.pow(2,-10*t)*Math.sin((r+t)/e))/2}return i.amplitude=function(n){return t(n,e*C)},i.period=function(e){return t(n,e)},i}(1,.3);e.d(n,"easeLinear",(function(){return r})),e.d(n,"easeQuad",(function(){return u})),e.d(n,"easeQuadIn",(function(){return i})),e.d(n,"easeQuadOut",(function(){return o})),e.d(n,"easeQuadInOut",(function(){return u})),e.d(n,"easeCubic",(function(){return a.b})),e.d(n,"easeCubicIn",(function(){return a.a})),e.d(n,"easeCubicOut",(function(){return a.c})),e.d(n,"easeCubicInOut",(function(){return a.b})),e.d(n,"easePoly",(function(){return l})),e.d(n,"easePolyIn",(function(){return c})),e.d(n,"easePolyOut",(function(){return s})),e.d(n,"easePolyInOut",(function(){return l})),e.d(n,"easeSin",(function(){return y})),e.d(n,"easeSinIn",(function(){return d})),e.d(n,"easeSinOut",(function(){return p})),e.d(n,"easeSinInOut",(function(){return y})),e.d(n,"easeExp",(function(){return _})),e.d(n,"easeExpIn",(function(){return g})),e.d(n,"easeExpOut",(function(){return v})),e.d(n,"easeExpInOut",(function(){return _})),e.d(n,"easeCircle",(function(){return b})),e.d(n,"easeCircleIn",(function(){return m})),e.d(n,"easeCircleOut",(function(){return x})),e.d(n,"easeCircleInOut",(function(){return b})),e.d(n,"easeBounce",(function(){return T})),e.d(n,"easeBounceIn",(function(){return M})),e.d(n,"easeBounceOut",(function(){return T})),e.d(n,"easeBounceInOut",(function(){return k})),e.d(n,"easeBack",(function(){return S})),e.d(n,"easeBackIn",(function(){return O})),e.d(n,"easeBackOut",(function(){return A})),e.d(n,"easeBackInOut",(function(){return S})),e.d(n,"easeElastic",(function(){return E})),e.d(n,"easeElasticIn",(function(){return N})),e.d(n,"easeElasticOut",(function(){return E})),e.d(n,"easeElasticInOut",(function(){return D}))},function(t,n,e){"use strict";var r;void 0===(r=function(){return{colorSchemas:{britecharts:["#6aedc7","#39c2c9","#ffce00","#ffa71a","#f866b9","#998ce3"],grey:["#F8F8FA","#EFF2F5","#D2D6DF","#C3C6CF","#ADB0B6","#666A73","#45494E","#363A43","#282C35"],orange:["#fcc870","#ffa71a","#fb8825","#f6682f","#db5a2c","#bf4c28","#a43b1c","#892a10","#f9e9c5"],blueGreen:["#ccf7f6","#70e4e0","#00d8d2","#00acaf","#007f8c","#005e66","#003c3f","#002d2f","#0d2223"],teal:["#ccfffe","#94f7f4","#00fff8","#1de1e1","#39c2c9","#2e9a9d","#227270","#1a5957","#133f3e"],green:["#edfff7","#d7ffef","#c0ffe7","#95f5d7","#6aedc7","#59c3a3","#479980","#34816a","#206953"],yellow:["#f9f2b3","#fbe986","#fce05a","#fed72d","#ffce00","#fcc11c","#f9b438","#eda629","#e09819"],pink:["#fdd1ea","#fb9cd2","#f866b9","#fc40b6","#ff1ab3","#e3239d","#c62c86","#a62073","#85135f"],purple:["#ddd6fc","#bbb1f0","#998ce3","#8e6bc1","#824a9e","#77337f","#6b1c60","#591650","#470f3f"],red:["#ffd8d4","#ffb5b0","#ff938c","#ff766c","#ff584c","#f04b42","#e03d38","#be2e29","#9c1e19"]},colorSchemasHuman:{britecharts:"Britecharts Default",grey:"Britecharts Grey",orange:"Orange",blueGreen:"Blue",teal:"Light Blue",green:"Green",yellow:"Yellow",pink:"Pink",purple:"Purple",red:"Red"},colorGradients:{greenBlue:["#39C7EA","#4CDCBA"],orangePink:["#FBC670","#F766B8"],bluePurple:["#3DC3C9","#824a9e"]},colorGradientsHuman:{greenBlue:"Green to Blue",orangePink:"Orange to Pink",bluePurple:"Blue to Purple"},singleColors:{aloeGreen:["#7bdcc0"],greenColor:["#6aedc7"],blueColor:["#39c2c9"],yellowColor:["#ffce00"],orangeColor:["#ffa71a"],pinkColor:["#f866b9"],purpleColor:["#998ce3"]},singleColorsHuman:{aloeGreen:"Aloe Green",greenColor:"Green",blueColor:"Blue",yellowColor:"Yellow",orangeColor:"Orange",pinkColor:"Pink",purpleColor:"Purple"}}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";e.r(n);var r=e(46),i=e(54);var o=Date.prototype.toISOString?function(t){return t.toISOString()}:Object(r.d)("%Y-%m-%dT%H:%M:%S.%LZ");var u=+new Date("2000-01-01T00:00:00.000Z")?function(t){var n=new Date(t);return isNaN(n)?null:n}:Object(r.e)("%Y-%m-%dT%H:%M:%S.%LZ");e.d(n,"timeFormatDefaultLocale",(function(){return r.a})),e.d(n,"timeFormat",(function(){return r.b})),e.d(n,"timeParse",(function(){return r.c})),e.d(n,"utcFormat",(function(){return r.d})),e.d(n,"utcParse",(function(){return r.e})),e.d(n,"timeFormatLocale",(function(){return i.a})),e.d(n,"isoFormat",(function(){return o})),e.d(n,"isoParse",(function(){return u}))},,function(t,n,e){"use strict";e.r(n);var r=e(69);e.d(n,"dispatch",(function(){return r.a}))},function(t,n,e){"use strict";var r={value:function(){}};function i(){for(var t,n=0,e=arguments.length,r={};n<e;++n){if(!(t=arguments[n]+"")||t in r||/[\s.]/.test(t))throw new Error("illegal type: "+t);r[t]=[]}return new o(r)}function o(t){this._=t}function u(t,n){return t.trim().split(/^|\s+/).map((function(t){var e="",r=t.indexOf(".");if(r>=0&&(e=t.slice(r+1),t=t.slice(0,r)),t&&!n.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:e}}))}function a(t,n){for(var e,r=0,i=t.length;r<i;++r)if((e=t[r]).name===n)return e.value}function c(t,n,e){for(var i=0,o=t.length;i<o;++i)if(t[i].name===n){t[i]=r,t=t.slice(0,i).concat(t.slice(i+1));break}return null!=e&&t.push({name:n,value:e}),t}o.prototype=i.prototype={constructor:o,on:function(t,n){var e,r=this._,i=u(t+"",r),o=-1,s=i.length;if(!(arguments.length<2)){if(null!=n&&"function"!=typeof n)throw new Error("invalid callback: "+n);for(;++o<s;)if(e=(t=i[o]).type)r[e]=c(r[e],t.name,n);else if(null==n)for(e in r)r[e]=c(r[e],t.name,null);return this}for(;++o<s;)if((e=(t=i[o]).type)&&(e=a(r[e],t.name)))return e},copy:function(){var t={},n=this._;for(var e in n)t[e]=n[e].slice();return new o(t)},call:function(t,n){if((e=arguments.length-2)>0)for(var e,r,i=new Array(e),o=0;o<e;++o)i[o]=arguments[o+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(o=0,e=(r=this._[t]).length;o<e;++o)r[o].value.apply(n,i)},apply:function(t,n,e){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],i=0,o=r.length;i<o;++i)r[i].value.apply(n,e)}},n.a=i},function(t,n,e){"use strict";var r;void 0===(r=function(){var t=e(71),n=e(38);return{axisTimeCombinations:{MINUTE_HOUR:"minute-hour",HOUR_DAY:"hour-daymonth",DAY_MONTH:"day-month",MONTH_YEAR:"month-year",CUSTOM:"custom"},curveMap:{linear:t.curveLinear,basis:t.curveBasis,cardinal:t.curveCardinal,catmullRom:t.curveCatmullRom,monotoneX:t.curveMonotoneX,monotoneY:t.curveMonotoneY,natural:t.curveNatural,step:t.curveStep,stepAfter:t.curveStepAfter,stepBefore:t.curveStepBefore},emptyDonutData:[{quantity:1,percentage:100}],hoursHuman:["00h","01h","02h","03h","04h","05h","06h","07h","08h","09h","10h","11h","12h","13h","14h","15h","16h","17h","18h","19h","20h","21h","22h","23h"],timeBenchmarks:{ONE_AND_A_HALF_YEARS:47304e6,ONE_YEAR:31536000365,ONE_DAY:86400001},lineGradientId:"lineGradientId",timeIntervals:{timeMillisecond:n.timeMillisecond,utcMillisecond:n.utcMillisecond,timeSecond:n.timeSecond,utcSecond:n.utcSecond,timeMinute:n.timeMinute,utcMinute:n.utcMinute,timeHour:n.timeHour,utcHour:n.utcHour,timeDay:n.timeDay,utcDay:n.utcDay,timeWeek:n.timeWeek,utcWeek:n.utcWeek,timeSunday:n.timeSunday,utcSunday:n.utcSunday,timeMonday:n.timeMonday,utcMonday:n.utcMonday,timeTuesday:n.timeTuesday,utcTuesday:n.utcTuesday,timeWednesday:n.timeWednesday,utcWednesday:n.utcWednesday,timeThursday:n.timeThursday,utcThursday:n.utcThursday,timeFriday:n.timeFriday,utcFriday:n.utcFriday,timeSaturday:n.timeSaturday,utcSaturday:n.utcSaturday,timeMonth:n.timeMonth,utcMonth:n.utcMonth,timeYear:n.timeYear,utcYear:n.utcYear},FORMAT_LOCALE_URL:"https://cdn.jsdelivr.net/npm/d3-format/locale"}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";e.r(n);var r=Math.PI,i=2*r,o=i-1e-6;function u(){this._x0=this._y0=this._x1=this._y1=null,this._=""}function a(){return new u}u.prototype=a.prototype={constructor:u,moveTo:function(t,n){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+n)},closePath:function(){null!==this._x1&&(this._x1=this._x0,this._y1=this._y0,this._+="Z")},lineTo:function(t,n){this._+="L"+(this._x1=+t)+","+(this._y1=+n)},quadraticCurveTo:function(t,n,e,r){this._+="Q"+ +t+","+ +n+","+(this._x1=+e)+","+(this._y1=+r)},bezierCurveTo:function(t,n,e,r,i,o){this._+="C"+ +t+","+ +n+","+ +e+","+ +r+","+(this._x1=+i)+","+(this._y1=+o)},arcTo:function(t,n,e,i,o){t=+t,n=+n,e=+e,i=+i,o=+o;var u=this._x1,a=this._y1,c=e-t,s=i-n,l=u-t,f=a-n,h=l*l+f*f;if(o<0)throw new Error("negative radius: "+o);if(null===this._x1)this._+="M"+(this._x1=t)+","+(this._y1=n);else if(h>1e-6)if(Math.abs(f*c-s*l)>1e-6&&o){var d=e-u,p=i-a,y=c*c+s*s,g=d*d+p*p,v=Math.sqrt(y),_=Math.sqrt(h),m=o*Math.tan((r-Math.acos((y+h-g)/(2*v*_)))/2),x=m/_,b=m/v;Math.abs(x-1)>1e-6&&(this._+="L"+(t+x*l)+","+(n+x*f)),this._+="A"+o+","+o+",0,0,"+ +(f*d>l*p)+","+(this._x1=t+b*c)+","+(this._y1=n+b*s)}else this._+="L"+(this._x1=t)+","+(this._y1=n);else;},arc:function(t,n,e,u,a,c){t=+t,n=+n,c=!!c;var s=(e=+e)*Math.cos(u),l=e*Math.sin(u),f=t+s,h=n+l,d=1^c,p=c?u-a:a-u;if(e<0)throw new Error("negative radius: "+e);null===this._x1?this._+="M"+f+","+h:(Math.abs(this._x1-f)>1e-6||Math.abs(this._y1-h)>1e-6)&&(this._+="L"+f+","+h),e&&(p<0&&(p=p%i+i),p>o?this._+="A"+e+","+e+",0,1,"+d+","+(t-s)+","+(n-l)+"A"+e+","+e+",0,1,"+d+","+(this._x1=f)+","+(this._y1=h):p>1e-6&&(this._+="A"+e+","+e+",0,"+ +(p>=r)+","+d+","+(this._x1=t+e*Math.cos(a))+","+(this._y1=n+e*Math.sin(a))))},rect:function(t,n,e,r){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+n)+"h"+ +e+"v"+ +r+"h"+-e+"Z"},toString:function(){return this._}};var c=a,s=function(t){return function(){return t}},l=Math.abs,f=Math.atan2,h=Math.cos,d=Math.max,p=Math.min,y=Math.sin,g=Math.sqrt,v=Math.PI,_=v/2,m=2*v;function x(t){return t>1?0:t<-1?v:Math.acos(t)}function b(t){return t>=1?_:t<=-1?-_:Math.asin(t)}function w(t){return t.innerRadius}function M(t){return t.outerRadius}function T(t){return t.startAngle}function k(t){return t.endAngle}function O(t){return t&&t.padAngle}function A(t,n,e,r,i,o,u,a){var c=e-t,s=r-n,l=u-i,f=a-o,h=f*c-l*s;if(!(h*h<1e-12))return[t+(h=(l*(n-o)-f*(t-i))/h)*c,n+h*s]}function S(t,n,e,r,i,o,u){var a=t-e,c=n-r,s=(u?o:-o)/g(a*a+c*c),l=s*c,f=-s*a,h=t+l,p=n+f,y=e+l,v=r+f,_=(h+y)/2,m=(p+v)/2,x=y-h,b=v-p,w=x*x+b*b,M=i-o,T=h*v-y*p,k=(b<0?-1:1)*g(d(0,M*M*w-T*T)),O=(T*b-x*k)/w,A=(-T*x-b*k)/w,S=(T*b+x*k)/w,C=(-T*x+b*k)/w,N=O-_,E=A-m,D=S-_,j=C-m;return N*N+E*E>D*D+j*j&&(O=S,A=C),{cx:O,cy:A,x01:-l,y01:-f,x11:O*(i/M-1),y11:A*(i/M-1)}}var C=function(){var t=w,n=M,e=s(0),r=null,i=T,o=k,u=O,a=null;function d(){var s,d,w=+t.apply(this,arguments),M=+n.apply(this,arguments),T=i.apply(this,arguments)-_,k=o.apply(this,arguments)-_,O=l(k-T),C=k>T;if(a||(a=s=c()),M<w&&(d=M,M=w,w=d),M>1e-12)if(O>m-1e-12)a.moveTo(M*h(T),M*y(T)),a.arc(0,0,M,T,k,!C),w>1e-12&&(a.moveTo(w*h(k),w*y(k)),a.arc(0,0,w,k,T,C));else{var N,E,D=T,j=k,F=T,P=k,L=O,I=O,U=u.apply(this,arguments)/2,R=U>1e-12&&(r?+r.apply(this,arguments):g(w*w+M*M)),B=p(l(M-w)/2,+e.apply(this,arguments)),H=B,Y=B;if(R>1e-12){var q=b(R/w*y(U)),z=b(R/M*y(U));(L-=2*q)>1e-12?(F+=q*=C?1:-1,P-=q):(L=0,F=P=(T+k)/2),(I-=2*z)>1e-12?(D+=z*=C?1:-1,j-=z):(I=0,D=j=(T+k)/2)}var G=M*h(D),V=M*y(D),X=w*h(P),W=w*y(P);if(B>1e-12){var $,Z=M*h(j),Q=M*y(j),J=w*h(F),K=w*y(F);if(O<v&&($=A(G,V,J,K,Z,Q,X,W))){var tt=G-$[0],nt=V-$[1],et=Z-$[0],rt=Q-$[1],it=1/y(x((tt*et+nt*rt)/(g(tt*tt+nt*nt)*g(et*et+rt*rt)))/2),ot=g($[0]*$[0]+$[1]*$[1]);H=p(B,(w-ot)/(it-1)),Y=p(B,(M-ot)/(it+1))}}I>1e-12?Y>1e-12?(N=S(J,K,G,V,M,Y,C),E=S(Z,Q,X,W,M,Y,C),a.moveTo(N.cx+N.x01,N.cy+N.y01),Y<B?a.arc(N.cx,N.cy,Y,f(N.y01,N.x01),f(E.y01,E.x01),!C):(a.arc(N.cx,N.cy,Y,f(N.y01,N.x01),f(N.y11,N.x11),!C),a.arc(0,0,M,f(N.cy+N.y11,N.cx+N.x11),f(E.cy+E.y11,E.cx+E.x11),!C),a.arc(E.cx,E.cy,Y,f(E.y11,E.x11),f(E.y01,E.x01),!C))):(a.moveTo(G,V),a.arc(0,0,M,D,j,!C)):a.moveTo(G,V),w>1e-12&&L>1e-12?H>1e-12?(N=S(X,W,Z,Q,w,-H,C),E=S(G,V,J,K,w,-H,C),a.lineTo(N.cx+N.x01,N.cy+N.y01),H<B?a.arc(N.cx,N.cy,H,f(N.y01,N.x01),f(E.y01,E.x01),!C):(a.arc(N.cx,N.cy,H,f(N.y01,N.x01),f(N.y11,N.x11),!C),a.arc(0,0,w,f(N.cy+N.y11,N.cx+N.x11),f(E.cy+E.y11,E.cx+E.x11),C),a.arc(E.cx,E.cy,H,f(E.y11,E.x11),f(E.y01,E.x01),!C))):a.arc(0,0,w,P,F,C):a.lineTo(X,W)}else a.moveTo(0,0);if(a.closePath(),s)return a=null,s+""||null}return d.centroid=function(){var e=(+t.apply(this,arguments)+ +n.apply(this,arguments))/2,r=(+i.apply(this,arguments)+ +o.apply(this,arguments))/2-v/2;return[h(r)*e,y(r)*e]},d.innerRadius=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),d):t},d.outerRadius=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),d):n},d.cornerRadius=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),d):e},d.padRadius=function(t){return arguments.length?(r=null==t?null:"function"==typeof t?t:s(+t),d):r},d.startAngle=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),d):i},d.endAngle=function(t){return arguments.length?(o="function"==typeof t?t:s(+t),d):o},d.padAngle=function(t){return arguments.length?(u="function"==typeof t?t:s(+t),d):u},d.context=function(t){return arguments.length?(a=null==t?null:t,d):a},d};function N(t){this._context=t}N.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._point=0},lineEnd:function(){(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;default:this._context.lineTo(t,n)}}};var E=function(t){return new N(t)};function D(t){return t[0]}function j(t){return t[1]}var F=function(){var t=D,n=j,e=s(!0),r=null,i=E,o=null;function u(u){var a,s,l,f=u.length,h=!1;for(null==r&&(o=i(l=c())),a=0;a<=f;++a)!(a<f&&e(s=u[a],a,u))===h&&((h=!h)?o.lineStart():o.lineEnd()),h&&o.point(+t(s,a,u),+n(s,a,u));if(l)return o=null,l+""||null}return u.x=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),u):t},u.y=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),u):n},u.defined=function(t){return arguments.length?(e="function"==typeof t?t:s(!!t),u):e},u.curve=function(t){return arguments.length?(i=t,null!=r&&(o=i(r)),u):i},u.context=function(t){return arguments.length?(null==t?r=o=null:o=i(r=t),u):r},u},P=function(){var t=D,n=null,e=s(0),r=j,i=s(!0),o=null,u=E,a=null;function l(s){var l,f,h,d,p,y=s.length,g=!1,v=new Array(y),_=new Array(y);for(null==o&&(a=u(p=c())),l=0;l<=y;++l){if(!(l<y&&i(d=s[l],l,s))===g)if(g=!g)f=l,a.areaStart(),a.lineStart();else{for(a.lineEnd(),a.lineStart(),h=l-1;h>=f;--h)a.point(v[h],_[h]);a.lineEnd(),a.areaEnd()}g&&(v[l]=+t(d,l,s),_[l]=+e(d,l,s),a.point(n?+n(d,l,s):v[l],r?+r(d,l,s):_[l]))}if(p)return a=null,p+""||null}function f(){return F().defined(i).curve(u).context(o)}return l.x=function(e){return arguments.length?(t="function"==typeof e?e:s(+e),n=null,l):t},l.x0=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),l):t},l.x1=function(t){return arguments.length?(n=null==t?null:"function"==typeof t?t:s(+t),l):n},l.y=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),r=null,l):e},l.y0=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),l):e},l.y1=function(t){return arguments.length?(r=null==t?null:"function"==typeof t?t:s(+t),l):r},l.lineX0=l.lineY0=function(){return f().x(t).y(e)},l.lineY1=function(){return f().x(t).y(r)},l.lineX1=function(){return f().x(n).y(e)},l.defined=function(t){return arguments.length?(i="function"==typeof t?t:s(!!t),l):i},l.curve=function(t){return arguments.length?(u=t,null!=o&&(a=u(o)),l):u},l.context=function(t){return arguments.length?(null==t?o=a=null:a=u(o=t),l):o},l},L=function(t,n){return n<t?-1:n>t?1:n>=t?0:NaN},I=function(t){return t},U=function(){var t=I,n=L,e=null,r=s(0),i=s(m),o=s(0);function u(u){var a,c,s,l,f,h=u.length,d=0,p=new Array(h),y=new Array(h),g=+r.apply(this,arguments),v=Math.min(m,Math.max(-m,i.apply(this,arguments)-g)),_=Math.min(Math.abs(v)/h,o.apply(this,arguments)),x=_*(v<0?-1:1);for(a=0;a<h;++a)(f=y[p[a]=a]=+t(u[a],a,u))>0&&(d+=f);for(null!=n?p.sort((function(t,e){return n(y[t],y[e])})):null!=e&&p.sort((function(t,n){return e(u[t],u[n])})),a=0,s=d?(v-h*x)/d:0;a<h;++a,g=l)c=p[a],l=g+((f=y[c])>0?f*s:0)+x,y[c]={data:u[c],index:a,value:f,startAngle:g,endAngle:l,padAngle:_};return y}return u.value=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),u):t},u.sortValues=function(t){return arguments.length?(n=t,e=null,u):n},u.sort=function(t){return arguments.length?(e=t,n=null,u):e},u.startAngle=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),u):r},u.endAngle=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),u):i},u.padAngle=function(t){return arguments.length?(o="function"==typeof t?t:s(+t),u):o},u},R=H(E);function B(t){this._curve=t}function H(t){function n(n){return new B(t(n))}return n._curve=t,n}function Y(t){var n=t.curve;return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t.curve=function(t){return arguments.length?n(H(t)):n()._curve},t}B.prototype={areaStart:function(){this._curve.areaStart()},areaEnd:function(){this._curve.areaEnd()},lineStart:function(){this._curve.lineStart()},lineEnd:function(){this._curve.lineEnd()},point:function(t,n){this._curve.point(n*Math.sin(t),n*-Math.cos(t))}};var q=function(){return Y(F().curve(R))},z=function(){var t=P().curve(R),n=t.curve,e=t.lineX0,r=t.lineX1,i=t.lineY0,o=t.lineY1;return t.angle=t.x,delete t.x,t.startAngle=t.x0,delete t.x0,t.endAngle=t.x1,delete t.x1,t.radius=t.y,delete t.y,t.innerRadius=t.y0,delete t.y0,t.outerRadius=t.y1,delete t.y1,t.lineStartAngle=function(){return Y(e())},delete t.lineX0,t.lineEndAngle=function(){return Y(r())},delete t.lineX1,t.lineInnerRadius=function(){return Y(i())},delete t.lineY0,t.lineOuterRadius=function(){return Y(o())},delete t.lineY1,t.curve=function(t){return arguments.length?n(H(t)):n()._curve},t},G=function(t,n){return[(n=+n)*Math.cos(t-=Math.PI/2),n*Math.sin(t)]},V=Array.prototype.slice;function X(t){return t.source}function W(t){return t.target}function $(t){var n=X,e=W,r=D,i=j,o=null;function u(){var u,a=V.call(arguments),s=n.apply(this,a),l=e.apply(this,a);if(o||(o=u=c()),t(o,+r.apply(this,(a[0]=s,a)),+i.apply(this,a),+r.apply(this,(a[0]=l,a)),+i.apply(this,a)),u)return o=null,u+""||null}return u.source=function(t){return arguments.length?(n=t,u):n},u.target=function(t){return arguments.length?(e=t,u):e},u.x=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),u):r},u.y=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),u):i},u.context=function(t){return arguments.length?(o=null==t?null:t,u):o},u}function Z(t,n,e,r,i){t.moveTo(n,e),t.bezierCurveTo(n=(n+r)/2,e,n,i,r,i)}function Q(t,n,e,r,i){t.moveTo(n,e),t.bezierCurveTo(n,e=(e+i)/2,r,e,r,i)}function J(t,n,e,r,i){var o=G(n,e),u=G(n,e=(e+i)/2),a=G(r,e),c=G(r,i);t.moveTo(o[0],o[1]),t.bezierCurveTo(u[0],u[1],a[0],a[1],c[0],c[1])}function K(){return $(Z)}function tt(){return $(Q)}function nt(){var t=$(J);return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t}var et={draw:function(t,n){var e=Math.sqrt(n/v);t.moveTo(e,0),t.arc(0,0,e,0,m)}},rt={draw:function(t,n){var e=Math.sqrt(n/5)/2;t.moveTo(-3*e,-e),t.lineTo(-e,-e),t.lineTo(-e,-3*e),t.lineTo(e,-3*e),t.lineTo(e,-e),t.lineTo(3*e,-e),t.lineTo(3*e,e),t.lineTo(e,e),t.lineTo(e,3*e),t.lineTo(-e,3*e),t.lineTo(-e,e),t.lineTo(-3*e,e),t.closePath()}},it=Math.sqrt(1/3),ot=2*it,ut={draw:function(t,n){var e=Math.sqrt(n/ot),r=e*it;t.moveTo(0,-e),t.lineTo(r,0),t.lineTo(0,e),t.lineTo(-r,0),t.closePath()}},at=Math.sin(v/10)/Math.sin(7*v/10),ct=Math.sin(m/10)*at,st=-Math.cos(m/10)*at,lt={draw:function(t,n){var e=Math.sqrt(.8908130915292852*n),r=ct*e,i=st*e;t.moveTo(0,-e),t.lineTo(r,i);for(var o=1;o<5;++o){var u=m*o/5,a=Math.cos(u),c=Math.sin(u);t.lineTo(c*e,-a*e),t.lineTo(a*r-c*i,c*r+a*i)}t.closePath()}},ft={draw:function(t,n){var e=Math.sqrt(n),r=-e/2;t.rect(r,r,e,e)}},ht=Math.sqrt(3),dt={draw:function(t,n){var e=-Math.sqrt(n/(3*ht));t.moveTo(0,2*e),t.lineTo(-ht*e,-e),t.lineTo(ht*e,-e),t.closePath()}},pt=Math.sqrt(3)/2,yt=1/Math.sqrt(12),gt=3*(yt/2+1),vt={draw:function(t,n){var e=Math.sqrt(n/gt),r=e/2,i=e*yt,o=r,u=e*yt+e,a=-o,c=u;t.moveTo(r,i),t.lineTo(o,u),t.lineTo(a,c),t.lineTo(-.5*r-pt*i,pt*r+-.5*i),t.lineTo(-.5*o-pt*u,pt*o+-.5*u),t.lineTo(-.5*a-pt*c,pt*a+-.5*c),t.lineTo(-.5*r+pt*i,-.5*i-pt*r),t.lineTo(-.5*o+pt*u,-.5*u-pt*o),t.lineTo(-.5*a+pt*c,-.5*c-pt*a),t.closePath()}},_t=[et,rt,ut,ft,lt,dt,vt],mt=function(){var t=s(et),n=s(64),e=null;function r(){var r;if(e||(e=r=c()),t.apply(this,arguments).draw(e,+n.apply(this,arguments)),r)return e=null,r+""||null}return r.type=function(n){return arguments.length?(t="function"==typeof n?n:s(n),r):t},r.size=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),r):n},r.context=function(t){return arguments.length?(e=null==t?null:t,r):e},r},xt=function(){};function bt(t,n,e){t._context.bezierCurveTo((2*t._x0+t._x1)/3,(2*t._y0+t._y1)/3,(t._x0+2*t._x1)/3,(t._y0+2*t._y1)/3,(t._x0+4*t._x1+n)/6,(t._y0+4*t._y1+e)/6)}function wt(t){this._context=t}wt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){switch(this._point){case 3:bt(this,this._x1,this._y1);case 2:this._context.lineTo(this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3,this._context.lineTo((5*this._x0+this._x1)/6,(5*this._y0+this._y1)/6);default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var Mt=function(t){return new wt(t)};function Tt(t){this._context=t}Tt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._y0=this._y1=this._y2=this._y3=this._y4=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x2,this._y2),this._context.closePath();break;case 2:this._context.moveTo((this._x2+2*this._x3)/3,(this._y2+2*this._y3)/3),this._context.lineTo((this._x3+2*this._x2)/3,(this._y3+2*this._y2)/3),this._context.closePath();break;case 3:this.point(this._x2,this._y2),this.point(this._x3,this._y3),this.point(this._x4,this._y4)}},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._x2=t,this._y2=n;break;case 1:this._point=2,this._x3=t,this._y3=n;break;case 2:this._point=3,this._x4=t,this._y4=n,this._context.moveTo((this._x0+4*this._x1+t)/6,(this._y0+4*this._y1+n)/6);break;default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var kt=function(t){return new Tt(t)};function Ot(t){this._context=t}Ot.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3;var e=(this._x0+4*this._x1+t)/6,r=(this._y0+4*this._y1+n)/6;this._line?this._context.lineTo(e,r):this._context.moveTo(e,r);break;case 3:this._point=4;default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var At=function(t){return new Ot(t)};function St(t,n){this._basis=new wt(t),this._beta=n}St.prototype={lineStart:function(){this._x=[],this._y=[],this._basis.lineStart()},lineEnd:function(){var t=this._x,n=this._y,e=t.length-1;if(e>0)for(var r,i=t[0],o=n[0],u=t[e]-i,a=n[e]-o,c=-1;++c<=e;)r=c/e,this._basis.point(this._beta*t[c]+(1-this._beta)*(i+r*u),this._beta*n[c]+(1-this._beta)*(o+r*a));this._x=this._y=null,this._basis.lineEnd()},point:function(t,n){this._x.push(+t),this._y.push(+n)}};var Ct=function t(n){function e(t){return 1===n?new wt(t):new St(t,n)}return e.beta=function(n){return t(+n)},e}(.85);function Nt(t,n,e){t._context.bezierCurveTo(t._x1+t._k*(t._x2-t._x0),t._y1+t._k*(t._y2-t._y0),t._x2+t._k*(t._x1-n),t._y2+t._k*(t._y1-e),t._x2,t._y2)}function Et(t,n){this._context=t,this._k=(1-n)/6}Et.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:Nt(this,this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2,this._x1=t,this._y1=n;break;case 2:this._point=3;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Dt=function t(n){function e(t){return new Et(t,n)}return e.tension=function(n){return t(+n)},e}(0);function jt(t,n){this._context=t,this._k=(1-n)/6}jt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._x3=t,this._y3=n;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=n);break;case 2:this._point=3,this._x5=t,this._y5=n;break;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Ft=function t(n){function e(t){return new jt(t,n)}return e.tension=function(n){return t(+n)},e}(0);function Pt(t,n){this._context=t,this._k=(1-n)/6}Pt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Lt=function t(n){function e(t){return new Pt(t,n)}return e.tension=function(n){return t(+n)},e}(0);function It(t,n,e){var r=t._x1,i=t._y1,o=t._x2,u=t._y2;if(t._l01_a>1e-12){var a=2*t._l01_2a+3*t._l01_a*t._l12_a+t._l12_2a,c=3*t._l01_a*(t._l01_a+t._l12_a);r=(r*a-t._x0*t._l12_2a+t._x2*t._l01_2a)/c,i=(i*a-t._y0*t._l12_2a+t._y2*t._l01_2a)/c}if(t._l23_a>1e-12){var s=2*t._l23_2a+3*t._l23_a*t._l12_a+t._l12_2a,l=3*t._l23_a*(t._l23_a+t._l12_a);o=(o*s+t._x1*t._l23_2a-n*t._l12_2a)/l,u=(u*s+t._y1*t._l23_2a-e*t._l12_2a)/l}t._context.bezierCurveTo(r,i,o,u,t._x2,t._y2)}function Ut(t,n){this._context=t,this._alpha=n}Ut.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:this.point(this._x2,this._y2)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Rt=function t(n){function e(t){return n?new Ut(t,n):new Et(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function Bt(t,n){this._context=t,this._alpha=n}Bt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._x3=t,this._y3=n;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=n);break;case 2:this._point=3,this._x5=t,this._y5=n;break;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Ht=function t(n){function e(t){return n?new Bt(t,n):new jt(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function Yt(t,n){this._context=t,this._alpha=n}Yt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var qt=function t(n){function e(t){return n?new Yt(t,n):new Pt(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function zt(t){this._context=t}zt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._point=0},lineEnd:function(){this._point&&this._context.closePath()},point:function(t,n){t=+t,n=+n,this._point?this._context.lineTo(t,n):(this._point=1,this._context.moveTo(t,n))}};var Gt=function(t){return new zt(t)};function Vt(t){return t<0?-1:1}function Xt(t,n,e){var r=t._x1-t._x0,i=n-t._x1,o=(t._y1-t._y0)/(r||i<0&&-0),u=(e-t._y1)/(i||r<0&&-0),a=(o*i+u*r)/(r+i);return(Vt(o)+Vt(u))*Math.min(Math.abs(o),Math.abs(u),.5*Math.abs(a))||0}function Wt(t,n){var e=t._x1-t._x0;return e?(3*(t._y1-t._y0)/e-n)/2:n}function $t(t,n,e){var r=t._x0,i=t._y0,o=t._x1,u=t._y1,a=(o-r)/3;t._context.bezierCurveTo(r+a,i+a*n,o-a,u-a*e,o,u)}function Zt(t){this._context=t}function Qt(t){this._context=new Jt(t)}function Jt(t){this._context=t}function Kt(t){return new Zt(t)}function tn(t){return new Qt(t)}function nn(t){this._context=t}function en(t){var n,e,r=t.length-1,i=new Array(r),o=new Array(r),u=new Array(r);for(i[0]=0,o[0]=2,u[0]=t[0]+2*t[1],n=1;n<r-1;++n)i[n]=1,o[n]=4,u[n]=4*t[n]+2*t[n+1];for(i[r-1]=2,o[r-1]=7,u[r-1]=8*t[r-1]+t[r],n=1;n<r;++n)e=i[n]/o[n-1],o[n]-=e,u[n]-=e*u[n-1];for(i[r-1]=u[r-1]/o[r-1],n=r-2;n>=0;--n)i[n]=(u[n]-i[n+1])/o[n];for(o[r-1]=(t[r]+i[r-1])/2,n=0;n<r-1;++n)o[n]=2*t[n+1]-i[n+1];return[i,o]}Zt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=this._t0=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x1,this._y1);break;case 3:$t(this,this._t0,Wt(this,this._t0))}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){var e=NaN;if(n=+n,(t=+t)!==this._x1||n!==this._y1){switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3,$t(this,Wt(this,e=Xt(this,t,n)),e);break;default:$t(this,this._t0,e=Xt(this,t,n))}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n,this._t0=e}}},(Qt.prototype=Object.create(Zt.prototype)).point=function(t,n){Zt.prototype.point.call(this,n,t)},Jt.prototype={moveTo:function(t,n){this._context.moveTo(n,t)},closePath:function(){this._context.closePath()},lineTo:function(t,n){this._context.lineTo(n,t)},bezierCurveTo:function(t,n,e,r,i,o){this._context.bezierCurveTo(n,t,r,e,o,i)}},nn.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=[],this._y=[]},lineEnd:function(){var t=this._x,n=this._y,e=t.length;if(e)if(this._line?this._context.lineTo(t[0],n[0]):this._context.moveTo(t[0],n[0]),2===e)this._context.lineTo(t[1],n[1]);else for(var r=en(t),i=en(n),o=0,u=1;u<e;++o,++u)this._context.bezierCurveTo(r[0][o],i[0][o],r[1][o],i[1][o],t[u],n[u]);(this._line||0!==this._line&&1===e)&&this._context.closePath(),this._line=1-this._line,this._x=this._y=null},point:function(t,n){this._x.push(+t),this._y.push(+n)}};var rn=function(t){return new nn(t)};function on(t,n){this._context=t,this._t=n}on.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=this._y=NaN,this._point=0},lineEnd:function(){0<this._t&&this._t<1&&2===this._point&&this._context.lineTo(this._x,this._y),(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line>=0&&(this._t=1-this._t,this._line=1-this._line)},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;default:if(this._t<=0)this._context.lineTo(this._x,n),this._context.lineTo(t,n);else{var e=this._x*(1-this._t)+t*this._t;this._context.lineTo(e,this._y),this._context.lineTo(e,n)}}this._x=t,this._y=n}};var un=function(t){return new on(t,.5)};function an(t){return new on(t,0)}function cn(t){return new on(t,1)}var sn=function(t,n){if((i=t.length)>1)for(var e,r,i,o=1,u=t[n[0]],a=u.length;o<i;++o)for(r=u,u=t[n[o]],e=0;e<a;++e)u[e][1]+=u[e][0]=isNaN(r[e][1])?r[e][0]:r[e][1]},ln=function(t){for(var n=t.length,e=new Array(n);--n>=0;)e[n]=n;return e};function fn(t,n){return t[n]}var hn=function(){var t=s([]),n=ln,e=sn,r=fn;function i(i){var o,u,a=t.apply(this,arguments),c=i.length,s=a.length,l=new Array(s);for(o=0;o<s;++o){for(var f,h=a[o],d=l[o]=new Array(c),p=0;p<c;++p)d[p]=f=[0,+r(i[p],h,p,i)],f.data=i[p];d.key=h}for(o=0,u=n(l);o<s;++o)l[u[o]].index=o;return e(l,u),l}return i.keys=function(n){return arguments.length?(t="function"==typeof n?n:s(V.call(n)),i):t},i.value=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),i):r},i.order=function(t){return arguments.length?(n=null==t?ln:"function"==typeof t?t:s(V.call(t)),i):n},i.offset=function(t){return arguments.length?(e=null==t?sn:t,i):e},i},dn=function(t,n){if((r=t.length)>0){for(var e,r,i,o=0,u=t[0].length;o<u;++o){for(i=e=0;e<r;++e)i+=t[e][o][1]||0;if(i)for(e=0;e<r;++e)t[e][o][1]/=i}sn(t,n)}},pn=function(t,n){if((a=t.length)>0)for(var e,r,i,o,u,a,c=0,s=t[n[0]].length;c<s;++c)for(o=u=0,e=0;e<a;++e)(i=(r=t[n[e]][c])[1]-r[0])>0?(r[0]=o,r[1]=o+=i):i<0?(r[1]=u,r[0]=u+=i):(r[0]=0,r[1]=i)},yn=function(t,n){if((e=t.length)>0){for(var e,r=0,i=t[n[0]],o=i.length;r<o;++r){for(var u=0,a=0;u<e;++u)a+=t[u][r][1]||0;i[r][1]+=i[r][0]=-a/2}sn(t,n)}},gn=function(t,n){if((i=t.length)>0&&(r=(e=t[n[0]]).length)>0){for(var e,r,i,o=0,u=1;u<r;++u){for(var a=0,c=0,s=0;a<i;++a){for(var l=t[n[a]],f=l[u][1]||0,h=(f-(l[u-1][1]||0))/2,d=0;d<a;++d){var p=t[n[d]];h+=(p[u][1]||0)-(p[u-1][1]||0)}c+=f,s+=h*f}e[u-1][1]+=e[u-1][0]=o,c&&(o-=s/c)}e[u-1][1]+=e[u-1][0]=o,sn(t,n)}},vn=function(t){var n=t.map(_n);return ln(t).sort((function(t,e){return n[t]-n[e]}))};function _n(t){for(var n,e=-1,r=0,i=t.length,o=-1/0;++e<i;)(n=+t[e][1])>o&&(o=n,r=e);return r}var mn=function(t){var n=t.map(xn);return ln(t).sort((function(t,e){return n[t]-n[e]}))};function xn(t){for(var n,e=0,r=-1,i=t.length;++r<i;)(n=+t[r][1])&&(e+=n);return e}var bn=function(t){return mn(t).reverse()},wn=function(t){var n,e,r=t.length,i=t.map(xn),o=vn(t),u=0,a=0,c=[],s=[];for(n=0;n<r;++n)e=o[n],u<a?(u+=i[e],c.push(e)):(a+=i[e],s.push(e));return s.reverse().concat(c)},Mn=function(t){return ln(t).reverse()};e.d(n,"arc",(function(){return C})),e.d(n,"area",(function(){return P})),e.d(n,"line",(function(){return F})),e.d(n,"pie",(function(){return U})),e.d(n,"areaRadial",(function(){return z})),e.d(n,"radialArea",(function(){return z})),e.d(n,"lineRadial",(function(){return q})),e.d(n,"radialLine",(function(){return q})),e.d(n,"pointRadial",(function(){return G})),e.d(n,"linkHorizontal",(function(){return K})),e.d(n,"linkVertical",(function(){return tt})),e.d(n,"linkRadial",(function(){return nt})),e.d(n,"symbol",(function(){return mt})),e.d(n,"symbols",(function(){return _t})),e.d(n,"symbolCircle",(function(){return et})),e.d(n,"symbolCross",(function(){return rt})),e.d(n,"symbolDiamond",(function(){return ut})),e.d(n,"symbolSquare",(function(){return ft})),e.d(n,"symbolStar",(function(){return lt})),e.d(n,"symbolTriangle",(function(){return dt})),e.d(n,"symbolWye",(function(){return vt})),e.d(n,"curveBasisClosed",(function(){return kt})),e.d(n,"curveBasisOpen",(function(){return At})),e.d(n,"curveBasis",(function(){return Mt})),e.d(n,"curveBundle",(function(){return Ct})),e.d(n,"curveCardinalClosed",(function(){return Ft})),e.d(n,"curveCardinalOpen",(function(){return Lt})),e.d(n,"curveCardinal",(function(){return Dt})),e.d(n,"curveCatmullRomClosed",(function(){return Ht})),e.d(n,"curveCatmullRomOpen",(function(){return qt})),e.d(n,"curveCatmullRom",(function(){return Rt})),e.d(n,"curveLinearClosed",(function(){return Gt})),e.d(n,"curveLinear",(function(){return E})),e.d(n,"curveMonotoneX",(function(){return Kt})),e.d(n,"curveMonotoneY",(function(){return tn})),e.d(n,"curveNatural",(function(){return rn})),e.d(n,"curveStep",(function(){return un})),e.d(n,"curveStepAfter",(function(){return cn})),e.d(n,"curveStepBefore",(function(){return an})),e.d(n,"stack",(function(){return hn})),e.d(n,"stackOffsetExpand",(function(){return dn})),e.d(n,"stackOffsetDiverging",(function(){return pn})),e.d(n,"stackOffsetNone",(function(){return sn})),e.d(n,"stackOffsetSilhouette",(function(){return yn})),e.d(n,"stackOffsetWiggle",(function(){return gn})),e.d(n,"stackOrderAppearance",(function(){return vn})),e.d(n,"stackOrderAscending",(function(){return mn})),e.d(n,"stackOrderDescending",(function(){return bn})),e.d(n,"stackOrderInsideOut",(function(){return wn})),e.d(n,"stackOrderNone",(function(){return ln})),e.d(n,"stackOrderReverse",(function(){return Mn}))},function(t,n,e){"use strict";e.r(n);var r,i,o=e(9),u=e(69),a=0,c=0,s=0,l=0,f=0,h=0,d="object"==typeof performance&&performance.now?performance:Date,p="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};function y(){return f||(p(g),f=d.now()+h)}function g(){f=0}function v(){this._call=this._time=this._next=null}function _(t,n,e){var r=new v;return r.restart(t,n,e),r}function m(){f=(l=d.now())+h,a=c=0;try{!function(){y(),++a;for(var t,n=r;n;)(t=f-n._time)>=0&&n._call.call(null,t),n=n._next;--a}()}finally{a=0,function(){var t,n,e=r,o=1/0;for(;e;)e._call?(o>e._time&&(o=e._time),t=e,e=e._next):(n=e._next,e._next=null,e=t?t._next=n:r=n);i=t,b(o)}(),f=0}}function x(){var t=d.now(),n=t-l;n>1e3&&(h-=n,l=t)}function b(t){a||(c&&(c=clearTimeout(c)),t-f>24?(t<1/0&&(c=setTimeout(m,t-d.now()-h)),s&&(s=clearInterval(s))):(s||(l=d.now(),s=setInterval(x,1e3)),a=1,p(m)))}v.prototype=_.prototype={constructor:v,restart:function(t,n,e){if("function"!=typeof t)throw new TypeError("callback is not a function");e=(null==e?y():+e)+(null==n?0:+n),this._next||i===this||(i?i._next=this:r=this,i=this),this._call=t,this._time=e,b()},stop:function(){this._call&&(this._call=null,this._time=1/0,b())}};var w=function(t,n,e){var r=new v;return n=null==n?0:+n,r.restart((function(e){r.stop(),t(e+n)}),n,e),r},M=Object(u.a)("start","end","cancel","interrupt"),T=[],k=function(t,n,e,r,i,o){var u=t.__transition;if(u){if(e in u)return}else t.__transition={};!function(t,n,e){var r,i=t.__transition;function o(c){var s,l,f,h;if(1!==e.state)return a();for(s in i)if((h=i[s]).name===e.name){if(3===h.state)return w(o);4===h.state?(h.state=6,h.timer.stop(),h.on.call("interrupt",t,t.__data__,h.index,h.group),delete i[s]):+s<n&&(h.state=6,h.timer.stop(),h.on.call("cancel",t,t.__data__,h.index,h.group),delete i[s])}if(w((function(){3===e.state&&(e.state=4,e.timer.restart(u,e.delay,e.time),u(c))})),e.state=2,e.on.call("start",t,t.__data__,e.index,e.group),2===e.state){for(e.state=3,r=new Array(f=e.tween.length),s=0,l=-1;s<f;++s)(h=e.tween[s].value.call(t,t.__data__,e.index,e.group))&&(r[++l]=h);r.length=l+1}}function u(n){for(var i=n<e.duration?e.ease.call(null,n/e.duration):(e.timer.restart(a),e.state=5,1),o=-1,u=r.length;++o<u;)r[o].call(t,i);5===e.state&&(e.on.call("end",t,t.__data__,e.index,e.group),a())}function a(){for(var r in e.state=6,e.timer.stop(),delete i[n],i)return;delete t.__transition}i[n]=e,e.timer=_((function(t){e.state=1,e.timer.restart(o,e.delay,e.time),e.delay<=t&&o(t-e.delay)}),0,e.time)}(t,e,{name:n,index:r,group:i,on:M,tween:T,time:o.time,delay:o.delay,duration:o.duration,ease:o.ease,timer:null,state:0})};function O(t,n){var e=S(t,n);if(e.state>0)throw new Error("too late; already scheduled");return e}function A(t,n){var e=S(t,n);if(e.state>3)throw new Error("too late; already running");return e}function S(t,n){var e=t.__transition;if(!e||!(e=e[n]))throw new Error("transition not found");return e}var C=function(t,n){var e,r,i,o=t.__transition,u=!0;if(o){for(i in n=null==n?null:n+"",o)(e=o[i]).name===n?(r=e.state>2&&e.state<5,e.state=6,e.timer.stop(),e.on.call(r?"interrupt":"cancel",t,t.__data__,e.index,e.group),delete o[i]):u=!1;u&&delete t.__transition}},N=e(74),E=e(20);function D(t,n){var e,r;return function(){var i=A(this,t),o=i.tween;if(o!==e)for(var u=0,a=(r=e=o).length;u<a;++u)if(r[u].name===n){(r=r.slice()).splice(u,1);break}i.tween=r}}function j(t,n,e){var r,i;if("function"!=typeof e)throw new Error;return function(){var o=A(this,t),u=o.tween;if(u!==r){i=(r=u).slice();for(var a={name:n,value:e},c=0,s=i.length;c<s;++c)if(i[c].name===n){i[c]=a;break}c===s&&i.push(a)}o.tween=i}}function F(t,n,e){var r=t._id;return t.each((function(){var t=A(this,r);(t.value||(t.value={}))[n]=e.apply(this,arguments)})),function(t){return S(t,r).value[n]}}var P=e(7),L=e(5),I=e(39),U=e(55),R=function(t,n){var e;return("number"==typeof n?L.a:n instanceof P.e?I.a:(e=Object(P.e)(n))?(n=e,I.a):U.a)(t,n)};function B(t){return function(){this.removeAttribute(t)}}function H(t){return function(){this.removeAttributeNS(t.space,t.local)}}function Y(t,n,e){var r,i,o=e+"";return function(){var u=this.getAttribute(t);return u===o?null:u===r?i:i=n(r=u,e)}}function q(t,n,e){var r,i,o=e+"";return function(){var u=this.getAttributeNS(t.space,t.local);return u===o?null:u===r?i:i=n(r=u,e)}}function z(t,n,e){var r,i,o;return function(){var u,a,c=e(this);if(null!=c)return(u=this.getAttribute(t))===(a=c+"")?null:u===r&&a===i?o:(i=a,o=n(r=u,c));this.removeAttribute(t)}}function G(t,n,e){var r,i,o;return function(){var u,a,c=e(this);if(null!=c)return(u=this.getAttributeNS(t.space,t.local))===(a=c+"")?null:u===r&&a===i?o:(i=a,o=n(r=u,c));this.removeAttributeNS(t.space,t.local)}}function V(t,n){return function(e){this.setAttribute(t,n.call(this,e))}}function X(t,n){return function(e){this.setAttributeNS(t.space,t.local,n.call(this,e))}}function W(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&X(t,i)),e}return i._value=n,i}function $(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&V(t,i)),e}return i._value=n,i}function Z(t,n){return function(){O(this,t).delay=+n.apply(this,arguments)}}function Q(t,n){return n=+n,function(){O(this,t).delay=n}}function J(t,n){return function(){A(this,t).duration=+n.apply(this,arguments)}}function K(t,n){return n=+n,function(){A(this,t).duration=n}}function tt(t,n){if("function"!=typeof n)throw new Error;return function(){A(this,t).ease=n}}var nt=e(34);function et(t,n,e){var r,i,o=function(t){return(t+"").trim().split(/^|\s+/).every((function(t){var n=t.indexOf(".");return n>=0&&(t=t.slice(0,n)),!t||"start"===t}))}(n)?O:A;return function(){var u=o(this,t),a=u.on;a!==r&&(i=(r=a).copy()).on(n,e),u.on=i}}var rt=e(19),it=e(33),ot=o.b.prototype.constructor,ut=e(35);function at(t){return function(){this.style.removeProperty(t)}}function ct(t,n,e){return function(r){this.style.setProperty(t,n.call(this,r),e)}}function st(t,n,e){var r,i;function o(){var o=n.apply(this,arguments);return o!==i&&(r=(i=o)&&ct(t,o,e)),r}return o._value=n,o}function lt(t){return function(n){this.textContent=t.call(this,n)}}function ft(t){var n,e;function r(){var r=t.apply(this,arguments);return r!==e&&(n=(e=r)&&lt(r)),n}return r._value=t,r}var ht=0;function dt(t,n,e,r){this._groups=t,this._parents=n,this._name=e,this._id=r}function pt(t){return Object(o.b)().transition(t)}function yt(){return++ht}var gt=o.b.prototype;dt.prototype=pt.prototype={constructor:dt,select:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(rt.a)(t));for(var r=this._groups,i=r.length,o=new Array(i),u=0;u<i;++u)for(var a,c,s=r[u],l=s.length,f=o[u]=new Array(l),h=0;h<l;++h)(a=s[h])&&(c=t.call(a,a.__data__,h,s))&&("__data__"in a&&(c.__data__=a.__data__),f[h]=c,k(f[h],n,e,h,f,S(a,e)));return new dt(o,this._parents,n,e)},selectAll:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(it.a)(t));for(var r=this._groups,i=r.length,o=[],u=[],a=0;a<i;++a)for(var c,s=r[a],l=s.length,f=0;f<l;++f)if(c=s[f]){for(var h,d=t.call(c,c.__data__,f,s),p=S(c,e),y=0,g=d.length;y<g;++y)(h=d[y])&&k(h,n,e,y,d,p);o.push(d),u.push(c)}return new dt(o,u,n,e)},filter:function(t){"function"!=typeof t&&(t=Object(nt.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o,u=n[i],a=u.length,c=r[i]=[],s=0;s<a;++s)(o=u[s])&&t.call(o,o.__data__,s,u)&&c.push(o);return new dt(r,this._parents,this._name,this._id)},merge:function(t){if(t._id!==this._id)throw new Error;for(var n=this._groups,e=t._groups,r=n.length,i=e.length,o=Math.min(r,i),u=new Array(r),a=0;a<o;++a)for(var c,s=n[a],l=e[a],f=s.length,h=u[a]=new Array(f),d=0;d<f;++d)(c=s[d]||l[d])&&(h[d]=c);for(;a<r;++a)u[a]=n[a];return new dt(u,this._parents,this._name,this._id)},selection:function(){return new ot(this._groups,this._parents)},transition:function(){for(var t=this._name,n=this._id,e=yt(),r=this._groups,i=r.length,o=0;o<i;++o)for(var u,a=r[o],c=a.length,s=0;s<c;++s)if(u=a[s]){var l=S(u,n);k(u,t,e,s,a,{time:l.time+l.delay+l.duration,delay:0,duration:l.duration,ease:l.ease})}return new dt(r,this._parents,t,e)},call:gt.call,nodes:gt.nodes,node:gt.node,size:gt.size,empty:gt.empty,each:gt.each,on:function(t,n){var e=this._id;return arguments.length<2?S(this.node(),e).on.on(t):this.each(et(e,t,n))},attr:function(t,n){var e=Object(E.a)(t),r="transform"===e?N.b:R;return this.attrTween(t,"function"==typeof n?(e.local?G:z)(e,r,F(this,"attr."+t,n)):null==n?(e.local?H:B)(e):(e.local?q:Y)(e,r,n))},attrTween:function(t,n){var e="attr."+t;if(arguments.length<2)return(e=this.tween(e))&&e._value;if(null==n)return this.tween(e,null);if("function"!=typeof n)throw new Error;var r=Object(E.a)(t);return this.tween(e,(r.local?W:$)(r,n))},style:function(t,n,e){var r="transform"==(t+="")?N.a:R;return null==n?this.styleTween(t,function(t,n){var e,r,i;return function(){var o=Object(ut.b)(this,t),u=(this.style.removeProperty(t),Object(ut.b)(this,t));return o===u?null:o===e&&u===r?i:i=n(e=o,r=u)}}(t,r)).on("end.style."+t,at(t)):"function"==typeof n?this.styleTween(t,function(t,n,e){var r,i,o;return function(){var u=Object(ut.b)(this,t),a=e(this),c=a+"";return null==a&&(this.style.removeProperty(t),c=a=Object(ut.b)(this,t)),u===c?null:u===r&&c===i?o:(i=c,o=n(r=u,a))}}(t,r,F(this,"style."+t,n))).each(function(t,n){var e,r,i,o,u="style."+n,a="end."+u;return function(){var c=A(this,t),s=c.on,l=null==c.value[u]?o||(o=at(n)):void 0;s===e&&i===l||(r=(e=s).copy()).on(a,i=l),c.on=r}}(this._id,t)):this.styleTween(t,function(t,n,e){var r,i,o=e+"";return function(){var u=Object(ut.b)(this,t);return u===o?null:u===r?i:i=n(r=u,e)}}(t,r,n),e).on("end.style."+t,null)},styleTween:function(t,n,e){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==n)return this.tween(r,null);if("function"!=typeof n)throw new Error;return this.tween(r,st(t,n,null==e?"":e))},text:function(t){return this.tween("text","function"==typeof t?function(t){return function(){var n=t(this);this.textContent=null==n?"":n}}(F(this,"text",t)):function(t){return function(){this.textContent=t}}(null==t?"":t+""))},textTween:function(t){var n="text";if(arguments.length<1)return(n=this.tween(n))&&n._value;if(null==t)return this.tween(n,null);if("function"!=typeof t)throw new Error;return this.tween(n,ft(t))},remove:function(){return this.on("end.remove",(t=this._id,function(){var n=this.parentNode;for(var e in this.__transition)if(+e!==t)return;n&&n.removeChild(this)}));var t},tween:function(t,n){var e=this._id;if(t+="",arguments.length<2){for(var r,i=S(this.node(),e).tween,o=0,u=i.length;o<u;++o)if((r=i[o]).name===t)return r.value;return null}return this.each((null==n?D:j)(e,t,n))},delay:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?Z:Q)(n,t)):S(this.node(),n).delay},duration:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?J:K)(n,t)):S(this.node(),n).duration},ease:function(t){var n=this._id;return arguments.length?this.each(tt(n,t)):S(this.node(),n).ease},end:function(){var t,n,e=this,r=e._id,i=e.size();return new Promise((function(o,u){var a={value:u},c={value:function(){0==--i&&o()}};e.each((function(){var e=A(this,r),i=e.on;i!==t&&((n=(t=i).copy())._.cancel.push(a),n._.interrupt.push(a),n._.end.push(c)),e.on=n}))}))}};var vt={time:null,delay:0,duration:250,ease:e(29).b};function _t(t,n){for(var e;!(e=t.__transition)||!(e=e[n]);)if(!(t=t.parentNode))return vt.time=y(),vt;return e}o.b.prototype.interrupt=function(t){return this.each((function(){C(this,t)}))},o.b.prototype.transition=function(t){var n,e;t instanceof dt?(n=t._id,t=t._name):(n=yt(),(e=vt).time=y(),t=null==t?null:t+"");for(var r=this._groups,i=r.length,o=0;o<i;++o)for(var u,a=r[o],c=a.length,s=0;s<c;++s)(u=a[s])&&k(u,t,n,s,a,e||_t(u,n));return new dt(r,this._parents,t,n)};var mt=[null],xt=function(t,n){var e,r,i=t.__transition;if(i)for(r in n=null==n?null:n+"",i)if((e=i[r]).state>1&&e.name===n)return new dt([[t]],mt,n,+r);return null};e.d(n,"transition",(function(){return pt})),e.d(n,"active",(function(){return xt})),e.d(n,"interrupt",(function(){return C}))},,function(t,n,e){"use strict";var r,i,o,u,a=e(5),c=180/Math.PI,s={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1},l=function(t,n,e,r,i,o){var u,a,s;return(u=Math.sqrt(t*t+n*n))&&(t/=u,n/=u),(s=t*e+n*r)&&(e-=t*s,r-=n*s),(a=Math.sqrt(e*e+r*r))&&(e/=a,r/=a,s/=a),t*r<n*e&&(t=-t,n=-n,s=-s,u=-u),{translateX:i,translateY:o,rotate:Math.atan2(n,t)*c,skewX:Math.atan(s)*c,scaleX:u,scaleY:a}};function f(t,n,e,r){function i(t){return t.length?t.pop()+" ":""}return function(o,u){var c=[],s=[];return o=t(o),u=t(u),function(t,r,i,o,u,c){if(t!==i||r!==o){var s=u.push("translate(",null,n,null,e);c.push({i:s-4,x:Object(a.a)(t,i)},{i:s-2,x:Object(a.a)(r,o)})}else(i||o)&&u.push("translate("+i+n+o+e)}(o.translateX,o.translateY,u.translateX,u.translateY,c,s),function(t,n,e,o){t!==n?(t-n>180?n+=360:n-t>180&&(t+=360),o.push({i:e.push(i(e)+"rotate(",null,r)-2,x:Object(a.a)(t,n)})):n&&e.push(i(e)+"rotate("+n+r)}(o.rotate,u.rotate,c,s),function(t,n,e,o){t!==n?o.push({i:e.push(i(e)+"skewX(",null,r)-2,x:Object(a.a)(t,n)}):n&&e.push(i(e)+"skewX("+n+r)}(o.skewX,u.skewX,c,s),function(t,n,e,r,o,u){if(t!==e||n!==r){var c=o.push(i(o)+"scale(",null,",",null,")");u.push({i:c-4,x:Object(a.a)(t,e)},{i:c-2,x:Object(a.a)(n,r)})}else 1===e&&1===r||o.push(i(o)+"scale("+e+","+r+")")}(o.scaleX,o.scaleY,u.scaleX,u.scaleY,c,s),o=u=null,function(t){for(var n,e=-1,r=s.length;++e<r;)c[(n=s[e]).i]=n.x(t);return c.join("")}}}e.d(n,"a",(function(){return h})),e.d(n,"b",(function(){return d}));var h=f((function(t){return"none"===t?s:(r||(r=document.createElement("DIV"),i=document.documentElement,o=document.defaultView),r.style.transform=t,t=o.getComputedStyle(i.appendChild(r),null).getPropertyValue("transform"),i.removeChild(r),t=t.slice(7,-1).split(","),l(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}),"px, ","px)","deg)"),d=f((function(t){return null==t?s:(u||(u=document.createElementNS("http://www.w3.org/2000/svg","g")),u.setAttribute("transform",t),(t=u.transform.baseVal.consolidate())?(t=t.matrix,l(t.a,t.b,t.c,t.d,t.e,t.f)):s)}),", ",")",")")},function(t,n,e){"use strict";e.r(n);var r=e(2);function i(t,n){switch(arguments.length){case 0:break;case 1:this.range(t);break;default:this.range(n).domain(t)}return this}function o(t,n){switch(arguments.length){case 0:break;case 1:this.interpolator(t);break;default:this.interpolator(n).domain(t)}return this}var u=e(45),a=Array.prototype,c=a.map,s=a.slice,l={name:"implicit"};function f(){var t=Object(u.map)(),n=[],e=[],r=l;function o(i){var o=i+"",u=t.get(o);if(!u){if(r!==l)return r;t.set(o,u=n.push(i))}return e[(u-1)%e.length]}return o.domain=function(e){if(!arguments.length)return n.slice();n=[],t=Object(u.map)();for(var r,i,a=-1,c=e.length;++a<c;)t.has(i=(r=e[a])+"")||t.set(i,n.push(r));return o},o.range=function(t){return arguments.length?(e=s.call(t),o):e.slice()},o.unknown=function(t){return arguments.length?(r=t,o):r},o.copy=function(){return f(n,e).unknown(r)},i.apply(o,arguments),o}function h(){var t,n,e=f().unknown(void 0),o=e.domain,u=e.range,a=[0,1],c=!1,s=0,l=0,d=.5;function p(){var e=o().length,i=a[1]<a[0],f=a[i-0],h=a[1-i];t=(h-f)/Math.max(1,e-s+2*l),c&&(t=Math.floor(t)),f+=(h-f-t*(e-s))*d,n=t*(1-s),c&&(f=Math.round(f),n=Math.round(n));var p=Object(r.range)(e).map((function(n){return f+t*n}));return u(i?p.reverse():p)}return delete e.unknown,e.domain=function(t){return arguments.length?(o(t),p()):o()},e.range=function(t){return arguments.length?(a=[+t[0],+t[1]],p()):a.slice()},e.rangeRound=function(t){return a=[+t[0],+t[1]],c=!0,p()},e.bandwidth=function(){return n},e.step=function(){return t},e.round=function(t){return arguments.length?(c=!!t,p()):c},e.padding=function(t){return arguments.length?(s=Math.min(1,l=+t),p()):s},e.paddingInner=function(t){return arguments.length?(s=Math.min(1,t),p()):s},e.paddingOuter=function(t){return arguments.length?(l=+t,p()):l},e.align=function(t){return arguments.length?(d=Math.max(0,Math.min(1,t)),p()):d},e.copy=function(){return h(o(),a).round(c).paddingInner(s).paddingOuter(l).align(d)},i.apply(p(),arguments)}function d(t){var n=t.copy;return t.padding=t.paddingOuter,delete t.paddingInner,delete t.paddingOuter,t.copy=function(){return d(n())},t}function p(){return d(h.apply(null,arguments).paddingInner(1))}var y=e(36),g=e(5),v=e(81),_=function(t){return+t},m=[0,1];function x(t){return t}function b(t,n){return(n-=t=+t)?function(e){return(e-t)/n}:(e=isNaN(n)?NaN:.5,function(){return e});var e}function w(t){var n,e=t[0],r=t[t.length-1];return e>r&&(n=e,e=r,r=n),function(t){return Math.max(e,Math.min(r,t))}}function M(t,n,e){var r=t[0],i=t[1],o=n[0],u=n[1];return i<r?(r=b(i,r),o=e(u,o)):(r=b(r,i),o=e(o,u)),function(t){return o(r(t))}}function T(t,n,e){var i=Math.min(t.length,n.length)-1,o=new Array(i),u=new Array(i),a=-1;for(t[i]<t[0]&&(t=t.slice().reverse(),n=n.slice().reverse());++a<i;)o[a]=b(t[a],t[a+1]),u[a]=e(n[a],n[a+1]);return function(n){var e=Object(r.bisect)(t,n,1,i)-1;return u[e](o[e](n))}}function k(t,n){return n.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown())}function O(){var t,n,e,r,i,o,u=m,a=m,l=y.a,f=x;function h(){return r=Math.min(u.length,a.length)>2?T:M,i=o=null,d}function d(n){return isNaN(n=+n)?e:(i||(i=r(u.map(t),a,l)))(t(f(n)))}return d.invert=function(e){return f(n((o||(o=r(a,u.map(t),g.a)))(e)))},d.domain=function(t){return arguments.length?(u=c.call(t,_),f===x||(f=w(u)),h()):u.slice()},d.range=function(t){return arguments.length?(a=s.call(t),h()):a.slice()},d.rangeRound=function(t){return a=s.call(t),l=v.a,h()},d.clamp=function(t){return arguments.length?(f=t?w(u):x,d):f!==x},d.interpolate=function(t){return arguments.length?(l=t,h()):l},d.unknown=function(t){return arguments.length?(e=t,d):e},function(e,r){return t=e,n=r,h()}}function A(t,n){return O()(t,n)}var S=e(24),C=e(62),N=e(40),E=e(63),D=e(61),j=function(t,n,e,i){var o,u=Object(r.tickStep)(t,n,e);switch((i=Object(S.b)(null==i?",f":i)).type){case"s":var a=Math.max(Math.abs(t),Math.abs(n));return null!=i.precision||isNaN(o=Object(C.a)(u,a))||(i.precision=o),Object(N.c)(i,a);case"":case"e":case"g":case"p":case"r":null!=i.precision||isNaN(o=Object(E.a)(u,Math.max(Math.abs(t),Math.abs(n))))||(i.precision=o-("e"===i.type));break;case"f":case"%":null!=i.precision||isNaN(o=Object(D.a)(u))||(i.precision=o-2*("%"===i.type))}return Object(N.b)(i)};function F(t){var n=t.domain;return t.ticks=function(t){var e=n();return Object(r.ticks)(e[0],e[e.length-1],null==t?10:t)},t.tickFormat=function(t,e){var r=n();return j(r[0],r[r.length-1],null==t?10:t,e)},t.nice=function(e){null==e&&(e=10);var i,o=n(),u=0,a=o.length-1,c=o[u],s=o[a];return s<c&&(i=c,c=s,s=i,i=u,u=a,a=i),(i=Object(r.tickIncrement)(c,s,e))>0?(c=Math.floor(c/i)*i,s=Math.ceil(s/i)*i,i=Object(r.tickIncrement)(c,s,e)):i<0&&(c=Math.ceil(c*i)/i,s=Math.floor(s*i)/i,i=Object(r.tickIncrement)(c,s,e)),i>0?(o[u]=Math.floor(c/i)*i,o[a]=Math.ceil(s/i)*i,n(o)):i<0&&(o[u]=Math.ceil(c*i)/i,o[a]=Math.floor(s*i)/i,n(o)),t},t}function P(){var t=A(x,x);return t.copy=function(){return k(t,P())},i.apply(t,arguments),F(t)}function L(t){var n;function e(t){return isNaN(t=+t)?n:t}return e.invert=e,e.domain=e.range=function(n){return arguments.length?(t=c.call(n,_),e):t.slice()},e.unknown=function(t){return arguments.length?(n=t,e):n},e.copy=function(){return L(t).unknown(n)},t=arguments.length?c.call(t,_):[0,1],F(e)}var I=function(t,n){var e,r=0,i=(t=t.slice()).length-1,o=t[r],u=t[i];return u<o&&(e=r,r=i,i=e,e=o,o=u,u=e),t[r]=n.floor(o),t[i]=n.ceil(u),t};function U(t){return Math.log(t)}function R(t){return Math.exp(t)}function B(t){return-Math.log(-t)}function H(t){return-Math.exp(-t)}function Y(t){return isFinite(t)?+("1e"+t):t<0?0:t}function q(t){return function(n){return-t(-n)}}function z(t){var n,e,i=t(U,R),o=i.domain,u=10;function a(){return n=function(t){return t===Math.E?Math.log:10===t&&Math.log10||2===t&&Math.log2||(t=Math.log(t),function(n){return Math.log(n)/t})}(u),e=function(t){return 10===t?Y:t===Math.E?Math.exp:function(n){return Math.pow(t,n)}}(u),o()[0]<0?(n=q(n),e=q(e),t(B,H)):t(U,R),i}return i.base=function(t){return arguments.length?(u=+t,a()):u},i.domain=function(t){return arguments.length?(o(t),a()):o()},i.ticks=function(t){var i,a=o(),c=a[0],s=a[a.length-1];(i=s<c)&&(d=c,c=s,s=d);var l,f,h,d=n(c),p=n(s),y=null==t?10:+t,g=[];if(!(u%1)&&p-d<y){if(d=Math.round(d)-1,p=Math.round(p)+1,c>0){for(;d<p;++d)for(f=1,l=e(d);f<u;++f)if(!((h=l*f)<c)){if(h>s)break;g.push(h)}}else for(;d<p;++d)for(f=u-1,l=e(d);f>=1;--f)if(!((h=l*f)<c)){if(h>s)break;g.push(h)}}else g=Object(r.ticks)(d,p,Math.min(p-d,y)).map(e);return i?g.reverse():g},i.tickFormat=function(t,r){if(null==r&&(r=10===u?".0e":","),"function"!=typeof r&&(r=Object(N.b)(r)),t===1/0)return r;null==t&&(t=10);var o=Math.max(1,u*t/i.ticks().length);return function(t){var i=t/e(Math.round(n(t)));return i*u<u-.5&&(i*=u),i<=o?r(t):""}},i.nice=function(){return o(I(o(),{floor:function(t){return e(Math.floor(n(t)))},ceil:function(t){return e(Math.ceil(n(t)))}}))},i}function G(){var t=z(O()).domain([1,10]);return t.copy=function(){return k(t,G()).base(t.base())},i.apply(t,arguments),t}function V(t){return function(n){return Math.sign(n)*Math.log1p(Math.abs(n/t))}}function X(t){return function(n){return Math.sign(n)*Math.expm1(Math.abs(n))*t}}function W(t){var n=1,e=t(V(n),X(n));return e.constant=function(e){return arguments.length?t(V(n=+e),X(n)):n},F(e)}function $(){var t=W(O());return t.copy=function(){return k(t,$()).constant(t.constant())},i.apply(t,arguments)}function Z(t){return function(n){return n<0?-Math.pow(-n,t):Math.pow(n,t)}}function Q(t){return t<0?-Math.sqrt(-t):Math.sqrt(t)}function J(t){return t<0?-t*t:t*t}function K(t){var n=t(x,x),e=1;function r(){return 1===e?t(x,x):.5===e?t(Q,J):t(Z(e),Z(1/e))}return n.exponent=function(t){return arguments.length?(e=+t,r()):e},F(n)}function tt(){var t=K(O());return t.copy=function(){return k(t,tt()).exponent(t.exponent())},i.apply(t,arguments),t}function nt(){return tt.apply(null,arguments).exponent(.5)}function et(){var t,n=[],e=[],o=[];function u(){var t=0,i=Math.max(1,e.length);for(o=new Array(i-1);++t<i;)o[t-1]=Object(r.quantile)(n,t/i);return a}function a(n){return isNaN(n=+n)?t:e[Object(r.bisect)(o,n)]}return a.invertExtent=function(t){var r=e.indexOf(t);return r<0?[NaN,NaN]:[r>0?o[r-1]:n[0],r<o.length?o[r]:n[n.length-1]]},a.domain=function(t){if(!arguments.length)return n.slice();n=[];for(var e,i=0,o=t.length;i<o;++i)null==(e=t[i])||isNaN(e=+e)||n.push(e);return n.sort(r.ascending),u()},a.range=function(t){return arguments.length?(e=s.call(t),u()):e.slice()},a.unknown=function(n){return arguments.length?(t=n,a):t},a.quantiles=function(){return o.slice()},a.copy=function(){return et().domain(n).range(e).unknown(t)},i.apply(a,arguments)}function rt(){var t,n=0,e=1,o=1,u=[.5],a=[0,1];function c(n){return n<=n?a[Object(r.bisect)(u,n,0,o)]:t}function l(){var t=-1;for(u=new Array(o);++t<o;)u[t]=((t+1)*e-(t-o)*n)/(o+1);return c}return c.domain=function(t){return arguments.length?(n=+t[0],e=+t[1],l()):[n,e]},c.range=function(t){return arguments.length?(o=(a=s.call(t)).length-1,l()):a.slice()},c.invertExtent=function(t){var r=a.indexOf(t);return r<0?[NaN,NaN]:r<1?[n,u[0]]:r>=o?[u[o-1],e]:[u[r-1],u[r]]},c.unknown=function(n){return arguments.length?(t=n,c):c},c.thresholds=function(){return u.slice()},c.copy=function(){return rt().domain([n,e]).range(a).unknown(t)},i.apply(F(c),arguments)}function it(){var t,n=[.5],e=[0,1],o=1;function u(i){return i<=i?e[Object(r.bisect)(n,i,0,o)]:t}return u.domain=function(t){return arguments.length?(n=s.call(t),o=Math.min(n.length,e.length-1),u):n.slice()},u.range=function(t){return arguments.length?(e=s.call(t),o=Math.min(n.length,e.length-1),u):e.slice()},u.invertExtent=function(t){var r=e.indexOf(t);return[n[r-1],n[r]]},u.unknown=function(n){return arguments.length?(t=n,u):t},u.copy=function(){return it().domain(n).range(e).unknown(t)},i.apply(u,arguments)}var ot=e(15),ut=e(47),at=e(3),ct=e(27),st=e(48),lt=e(49),ft=e(30),ht=e(31),dt=e(46);function pt(t){return new Date(t)}function yt(t){return t instanceof Date?+t:+new Date(+t)}function gt(t,n,e,i,o,u,a,s,l){var f=A(x,x),h=f.invert,d=f.domain,p=l(".%L"),y=l(":%S"),g=l("%I:%M"),v=l("%I %p"),_=l("%a %d"),m=l("%b %d"),b=l("%B"),w=l("%Y"),M=[[a,1,1e3],[a,5,5e3],[a,15,15e3],[a,30,3e4],[u,1,6e4],[u,5,3e5],[u,15,9e5],[u,30,18e5],[o,1,36e5],[o,3,108e5],[o,6,216e5],[o,12,432e5],[i,1,864e5],[i,2,1728e5],[e,1,6048e5],[n,1,2592e6],[n,3,7776e6],[t,1,31536e6]];function T(r){return(a(r)<r?p:u(r)<r?y:o(r)<r?g:i(r)<r?v:n(r)<r?e(r)<r?_:m:t(r)<r?b:w)(r)}function O(n,e,i,o){if(null==n&&(n=10),"number"==typeof n){var u=Math.abs(i-e)/n,a=Object(r.bisector)((function(t){return t[2]})).right(M,u);a===M.length?(o=Object(r.tickStep)(e/31536e6,i/31536e6,n),n=t):a?(o=(a=M[u/M[a-1][2]<M[a][2]/u?a-1:a])[1],n=a[0]):(o=Math.max(Object(r.tickStep)(e,i,n),1),n=s)}return null==o?n:n.every(o)}return f.invert=function(t){return new Date(h(t))},f.domain=function(t){return arguments.length?d(c.call(t,yt)):d().map(pt)},f.ticks=function(t,n){var e,r=d(),i=r[0],o=r[r.length-1],u=o<i;return u&&(e=i,i=o,o=e),e=(e=O(t,i,o,n))?e.range(i,o+1):[],u?e.reverse():e},f.tickFormat=function(t,n){return null==n?T:l(n)},f.nice=function(t,n){var e=d();return(t=O(t,e[0],e[e.length-1],n))?d(I(e,t)):f},f.copy=function(){return k(f,gt(t,n,e,i,o,u,a,s,l))},f}var vt=function(){return i.apply(gt(ot.a,ut.a,at.g,ct.b,st.a,lt.a,ft.a,ht.a,dt.b).domain([new Date(2e3,0,1),new Date(2e3,0,2)]),arguments)},_t=e(16),mt=e(50),xt=e(4),bt=e(28),wt=e(51),Mt=e(52),Tt=function(){return i.apply(gt(_t.a,mt.a,xt.g,bt.a,wt.a,Mt.a,ft.a,ht.a,dt.d).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)]),arguments)};function kt(){var t,n,e,r,i,o=0,u=1,a=x,c=!1;function s(n){return isNaN(n=+n)?i:a(0===e?.5:(n=(r(n)-t)*e,c?Math.max(0,Math.min(1,n)):n))}return s.domain=function(i){return arguments.length?(t=r(o=+i[0]),n=r(u=+i[1]),e=t===n?0:1/(n-t),s):[o,u]},s.clamp=function(t){return arguments.length?(c=!!t,s):c},s.interpolator=function(t){return arguments.length?(a=t,s):a},s.unknown=function(t){return arguments.length?(i=t,s):i},function(i){return r=i,t=i(o),n=i(u),e=t===n?0:1/(n-t),s}}function Ot(t,n){return n.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown())}function At(){var t=F(kt()(x));return t.copy=function(){return Ot(t,At())},o.apply(t,arguments)}function St(){var t=z(kt()).domain([1,10]);return t.copy=function(){return Ot(t,St()).base(t.base())},o.apply(t,arguments)}function Ct(){var t=W(kt());return t.copy=function(){return Ot(t,Ct()).constant(t.constant())},o.apply(t,arguments)}function Nt(){var t=K(kt());return t.copy=function(){return Ot(t,Nt()).exponent(t.exponent())},o.apply(t,arguments)}function Et(){return Nt.apply(null,arguments).exponent(.5)}function Dt(){var t=[],n=x;function e(e){if(!isNaN(e=+e))return n((Object(r.bisect)(t,e)-1)/(t.length-1))}return e.domain=function(n){if(!arguments.length)return t.slice();t=[];for(var i,o=0,u=n.length;o<u;++o)null==(i=n[o])||isNaN(i=+i)||t.push(i);return t.sort(r.ascending),e},e.interpolator=function(t){return arguments.length?(n=t,e):n},e.copy=function(){return Dt(n).domain(t)},o.apply(e,arguments)}function jt(){var t,n,e,r,i,o,u,a=0,c=.5,s=1,l=x,f=!1;function h(t){return isNaN(t=+t)?u:(t=.5+((t=+o(t))-n)*(t<n?r:i),l(f?Math.max(0,Math.min(1,t)):t))}return h.domain=function(u){return arguments.length?(t=o(a=+u[0]),n=o(c=+u[1]),e=o(s=+u[2]),r=t===n?0:.5/(n-t),i=n===e?0:.5/(e-n),h):[a,c,s]},h.clamp=function(t){return arguments.length?(f=!!t,h):f},h.interpolator=function(t){return arguments.length?(l=t,h):l},h.unknown=function(t){return arguments.length?(u=t,h):u},function(u){return o=u,t=u(a),n=u(c),e=u(s),r=t===n?0:.5/(n-t),i=n===e?0:.5/(e-n),h}}function Ft(){var t=F(jt()(x));return t.copy=function(){return Ot(t,Ft())},o.apply(t,arguments)}function Pt(){var t=z(jt()).domain([.1,1,10]);return t.copy=function(){return Ot(t,Pt()).base(t.base())},o.apply(t,arguments)}function Lt(){var t=W(jt());return t.copy=function(){return Ot(t,Lt()).constant(t.constant())},o.apply(t,arguments)}function It(){var t=K(jt());return t.copy=function(){return Ot(t,It()).exponent(t.exponent())},o.apply(t,arguments)}function Ut(){return It.apply(null,arguments).exponent(.5)}e.d(n,"scaleBand",(function(){return h})),e.d(n,"scalePoint",(function(){return p})),e.d(n,"scaleIdentity",(function(){return L})),e.d(n,"scaleLinear",(function(){return P})),e.d(n,"scaleLog",(function(){return G})),e.d(n,"scaleSymlog",(function(){return $})),e.d(n,"scaleOrdinal",(function(){return f})),e.d(n,"scaleImplicit",(function(){return l})),e.d(n,"scalePow",(function(){return tt})),e.d(n,"scaleSqrt",(function(){return nt})),e.d(n,"scaleQuantile",(function(){return et})),e.d(n,"scaleQuantize",(function(){return rt})),e.d(n,"scaleThreshold",(function(){return it})),e.d(n,"scaleTime",(function(){return vt})),e.d(n,"scaleUtc",(function(){return Tt})),e.d(n,"scaleSequential",(function(){return At})),e.d(n,"scaleSequentialLog",(function(){return St})),e.d(n,"scaleSequentialPow",(function(){return Nt})),e.d(n,"scaleSequentialSqrt",(function(){return Et})),e.d(n,"scaleSequentialSymlog",(function(){return Ct})),e.d(n,"scaleSequentialQuantile",(function(){return Dt})),e.d(n,"scaleDiverging",(function(){return Ft})),e.d(n,"scaleDivergingLog",(function(){return Pt})),e.d(n,"scaleDivergingPow",(function(){return It})),e.d(n,"scaleDivergingSqrt",(function(){return Ut})),e.d(n,"scaleDivergingSymlog",(function(){return Lt})),e.d(n,"tickFormat",(function(){return j}))},function(t,n,e){"use strict";var r;void 0===(r=function(t){var n=e(65).colorSchemas,r=(e(70),e(77)),i="undefined"!=typeof window,o=navigator.msSaveOrOpenBlob,u=i&&window.btoa;u||(u=e(78).encode);var a={styleClass:"britechartStyle",defaultFilename:"britechart.png",chartBackground:"white",imageSourceBase:"data:image/svg+xml;base64,",titleFontSize:"15px",titleFontFamily:"'Benton Sans', sans-serif",titleTopOffset:15,get styleBackgroundString(){return"<style>svg{background:"+this.chartBackground+";}</style>"}};function c(t,n){if(t){t.attr("version",1.1).attr("xmlns","http://www.w3.org/2000/svg");var e=r.initializeSerializer()(t.node());return e=function(t){if(navigator.userAgent.search("FireFox")>-1)return t.replace(/url.*&quot;\)/,'url(&quot;linearGradient[id*="-gradient-"]&quot;);');return t}(e),e=function(t){return t.replace(">",">"+a.styleBackgroundString)}(e=h.call(this,e,n,parseInt(t.attr("width"),10)))}}function s(t){var n=new Image;return n.src=""+a.imageSourceBase+u(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g,(function(t,n){return String.fromCharCode("0x"+n)}))),n}function l(t,n){return n.getContext("2d").drawImage(t,0,0),n}function f(t,n,e){e.preventDefault(),function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:a.defaultFilename,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"image/png",r=t.toDataURL(e),i=document.createElement("a");i.href=r,i.download=n,document.body.appendChild(i),i.click(),document.body.removeChild(i)}(l(this,t),n)}function h(t,e,r){if(!e||!r)return t;var i=n.grey;return t=t.replace(/<g/,'<text x="'+this.margin().left+'" y="'+a.titleTopOffset+'" font-family="'+a.titleFontFamily+'" font-size="'+a.titleFontSize+'" fill="'+i[6]+'"> '+e+" </text><g ")}return{exportChart:function(t,n,e){if(o)return console.error("Sorry, this feature is not available for IE. If you require this to work, check this issue https://github.com/britecharts/britecharts/pull/652"),!1;var r,i,u,a=s(c.call(this,t,e));a.onload=f.bind(a,(r=this.width(),i=this.height(),(u=document.createElement("canvas")).height=i,u.width=r,u),n)},convertSvgToHtml:c,createImage:s,drawImageOnCanvas:l}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";var r,i,o;t.exports=(r={BASE:!0,HEAD:!0,HTML:!0,META:!0,NOFRAME:!0,NOSCRIPT:!0,PARAM:!0,SCRIPT:!0,STYLE:!0,TITLE:!0},i=["A","ABBR","ADDRESS","AREA","ARTICLE","ASIDE","AUDIO","B","BASE","BDI","BDO","BLOCKQUOTE","BODY","BR","BUTTON","CANVAS","CAPTION","CENTER","CITE","CODE","COL","COLGROUP","COMMAND","DATALIST","DD","DEL","DETAILS","DFN","DIV","DL","DT","EM","EMBED","FIELDSET","FIGCAPTION","FIGURE","FONT","FOOTER","FORM","H1","H2","H3","H4","H5","H6","HEAD","HEADER","HGROUP","HR","HTML","I","IFRAME","IMG","INPUT","INS","KBD","LABEL","LEGEND","LI","LINK","MAP","MARK","MATH","MENU","META","METER","NAV","NOBR","NOSCRIPT","OBJECT","OL","OPTION","OPTGROUP","OUTPUT","P","PARAM","PRE","PROGRESS","Q","RP","RT","RUBY","S","SAMP","SCRIPT","SECTION","SELECT","SMALL","SOURCE","SPAN","STRONG","STYLE","SUB","SUMMARY","SUP","SVG","TABLE","TBODY","TD","TEXTAREA","TFOOT","TH","THEAD","TIME","TITLE","TR","TRACK","U","UL","VAR","VIDEO","WBR"],o=function(t){var n={},e=document.body.appendChild(document.createElement(t)),r=window.getComputedStyle(e);return[].forEach.call(r,(function(t){n[t]=r[t]})),document.body.removeChild(e),n},{initializeSerializer:function(){var t={};return[].forEach.call(i,(function(n){r[n]||(t[n]=o(n))})),function(n){var e,i=[],u=void 0,a=void 0,c=void 0;if(n&&n.nodeType===Node.ELEMENT_NODE)return i=[],u=n.querySelectorAll("*"),[].forEach.call(u,(function(n,e){var u;r[n.tagName]||(a=window.getComputedStyle(n),u=(u=n.tagName).toUpperCase(),t[u]||(t[u]=o(u)),c=t[u],i[e]=n.style.cssText,[].forEach.call(a,(function(t){a[t]!==c[t]&&(n.style[t]=a[t])})))})),e=n.outerHTML,u=[].map.call(u,(function(t,n){return t.style.cssText=i[n],t})),e}}})},function(t,n,e){(function(t,r){var i;/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */!function(o){var u=n,a=(t&&t.exports,"object"==typeof r&&r);a.global!==a&&a.window;var c=function(t){this.message=t};(c.prototype=new Error).name="InvalidCharacterError";var s=function(t){throw new c(t)},l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",f=/[\t\n\f\r ]/g,h={encode:function(t){t=String(t),/[^\0-\xFF]/.test(t)&&s("The string to be encoded contains characters outside of the Latin1 range.");for(var n,e,r,i,o=t.length%3,u="",a=-1,c=t.length-o;++a<c;)n=t.charCodeAt(a)<<16,e=t.charCodeAt(++a)<<8,r=t.charCodeAt(++a),u+=l.charAt((i=n+e+r)>>18&63)+l.charAt(i>>12&63)+l.charAt(i>>6&63)+l.charAt(63&i);return 2==o?(n=t.charCodeAt(a)<<8,e=t.charCodeAt(++a),u+=l.charAt((i=n+e)>>10)+l.charAt(i>>4&63)+l.charAt(i<<2&63)+"="):1==o&&(i=t.charCodeAt(a),u+=l.charAt(i>>2)+l.charAt(i<<4&63)+"=="),u},decode:function(t){var n=(t=String(t).replace(f,"")).length;n%4==0&&(n=(t=t.replace(/==?$/,"")).length),(n%4==1||/[^+a-zA-Z0-9/]/.test(t))&&s("Invalid character: the string to be decoded is not correctly encoded.");for(var e,r,i=0,o="",u=-1;++u<n;)r=l.indexOf(t.charAt(u)),e=i%4?64*e+r:r,i++%4&&(o+=String.fromCharCode(255&e>>(-2*i&6)));return o},version:"0.1.0"};void 0===(i=function(){return h}.call(n,e,n,t))||(t.exports=i)}()}).call(this,e(79)(t),e(80))},function(t,n){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,n){var e;e=function(){return this}();try{e=e||new Function("return this")()}catch(t){"object"==typeof window&&(e=window)}t.exports=e},function(t,n,e){"use strict";n.a=function(t,n){return t=+t,n=+n,function(e){return Math.round(t*(1-e)+n*e)}}},,function(t,n,e){"use strict";var r;void 0===(r=function(){return{bar:'\n            <svg class="load-state bar-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 711 325">\n              \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(0 29)">\n                        <g stroke="#EFF2F5" stroke-dasharray="4 4">\n                            <path d="M.400592911 200.302477L710.674315 200.302477M.400592884 131.172748L710.674315 131.172748M.324410282 64.2071321L710.621499 64.2071321M.291004517.563888874L709.82431.563888889"/>\n                        </g>\n                        <g fill="#D2D6DF" transform="translate(63.08 11)">\n                            <polygon points="-.08 176 23.92 176 23.92 255 -.08 255"/>\n                            <polygon points="50.829 147 74.829 147 74.829 255 50.829 255"/>\n                            <polygon points="254.465 0 278.465 0 278.465 255 254.465 255"/>\n                            <polygon points="458.102 169 482.102 169 482.102 255 458.102 255"/>\n                            <polygon points="152.647 82 176.647 82 176.647 255 152.647 255"/>\n                            <polygon points="356.283 66 380.283 66 380.283 255 356.283 255"/>\n                            <polygon points="559.92 229 583.92 229 583.92 255 559.92 255"/>\n                            <polygon points="101.738 115 125.738 115 125.738 255 101.738 255"/>\n                            <polygon points="305.374 42 329.374 42 329.374 255 305.374 255"/>\n                            <polygon points="509.011 201 533.011 201 533.011 255 509.011 255"/>\n                            <polygon points="203.556 19 227.556 19 227.556 255 203.556 255"/>\n                            <polygon points="407.192 115 431.192 115 431.192 255 407.192 255"/>\n                        </g>\n                    </g>\n                    <polygon fill="#D2D6DF" fill-rule="nonzero" points="0 295 711 295 711 294 0 294"/>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',donut:'\n            <svg class="load-state donut-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 376 331">\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(116 107)">\n                        <circle cx="72" cy="72" r="72" stroke="#EFF2F5" stroke-linecap="round" stroke-width="9.6"/>\n                        <path stroke="#D2D6DF" stroke-width="19.2" d="M126.153559,119.524055 C137.264629,106.845712 144,90.2321371 144,72.0444604 C144,32.2554036 111.764502,0 72,0"/>\n                        <circle cx="72" cy="72" r="67.2" fill="#FFF"/>\n                    </g>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',line:'\n            <svg\n                class="load-state line-load-state"\n                xmlns="http://www.w3.org/2000/svg"\n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path\n                    id="chart-bg"\n                    class="chart-bg"\n                    style="stroke:#C3C6CF;"\n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n                <polyline\n                    id="chart-line"\n                    class="chart-line"\n                    style="stroke:#C3C6CF;stroke-width:4;fill:none;"\n                    points="8.8,175.8 62.4,237.7 116.1,184.7 169.7,175.8 223.3,57 277,176.8 330.6,176.8 384.3,122.5 437.9,176.8 491.6,176.8 545.2,218.4 598.8,122.5 652.5,184.7 706.1,135.1 "\n                />\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',stackedArea:'\n            <svg\n                class="load-state stacked-area-load-state"\n                xmlns="http://www.w3.org/2000/svg"\n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path\n                    id="chart-bg"\n                    class="chart-bg"\n                    style="stroke:#C3C6CF;"\n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n                <g transform="translate(20 50)">\n                    <path\n                        id="chart-area"\n                        strokeLinecap="square"\n                        d="M0.34233103,0.593688165 L709.977885,0.593688189"\n                        transform="translate(.01 227.976)"\n                    />\n                    <path fill="#C3C6CF" d="M0.528124801,224.014648 L0.528124801,177.734375 L53.3834796,177.734375 C71.5390789,177.734375 86.8277373,168.972754 101.240241,151.662202 C112.578335,138.044258 121.139826,123.110227 136.974507,91.596773 C137.343842,90.8617404 139.300293,86.9654028 139.856735,85.8583549 C155.041692,55.6476711 163.354313,41.0906306 174.319873,27.7179171 C188.951312,9.87459412 204.885845,0.5 223.830634,0.5 C242.123071,0.5 257.291724,8.27027858 270.907992,23.1359289 C281.228683,34.4036118 289.135925,47.1272372 302.542017,72.085092 C303.275893,73.4513345 306.289669,79.0766612 307.063369,80.5168656 C321.41025,107.222876 330.088083,120.97663 341.470704,132.92446 C355.88994,148.05969 371.908861,155.792969 391.654853,155.792969 C412.142049,155.792969 428.763593,152.325614 442.880698,145.765582 C454.197328,140.506893 463.373931,133.679865 473.786035,123.626931 C476.528659,120.978915 486.44777,110.911455 488.791866,108.6483 C502.907223,95.0203436 514.194325,88.9355469 530.135322,88.9355469 C546.532652,88.9355469 559.505909,97.338499 575.973261,115.41103 C579.723508,119.526837 593.103621,135.086814 592.915496,134.871799 C605.09738,148.794859 614.368835,157.635549 625.072091,164.58539 C638.386599,173.230769 652.701021,177.734375 669.279853,177.734375 L673.779853,177.734375 L673.779853,224.014648 L0.528124801,224.014648 Z" />\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        '}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";e.r(n);var r=Array.prototype.slice,i=function(t){return t};function o(t){return"translate("+(t+.5)+",0)"}function u(t){return"translate(0,"+(t+.5)+")"}function a(t){return function(n){return+t(n)}}function c(t){var n=Math.max(0,t.bandwidth()-1)/2;return t.round()&&(n=Math.round(n)),function(e){return+t(e)+n}}function s(){return!this.__axis}function l(t,n){var e=[],l=null,f=null,h=6,d=6,p=3,y=1===t||4===t?-1:1,g=4===t||2===t?"x":"y",v=1===t||3===t?o:u;function _(r){var o=null==l?n.ticks?n.ticks.apply(n,e):n.domain():l,u=null==f?n.tickFormat?n.tickFormat.apply(n,e):i:f,_=Math.max(h,0)+p,m=n.range(),x=+m[0]+.5,b=+m[m.length-1]+.5,w=(n.bandwidth?c:a)(n.copy()),M=r.selection?r.selection():r,T=M.selectAll(".domain").data([null]),k=M.selectAll(".tick").data(o,n).order(),O=k.exit(),A=k.enter().append("g").attr("class","tick"),S=k.select("line"),C=k.select("text");T=T.merge(T.enter().insert("path",".tick").attr("class","domain").attr("stroke","currentColor")),k=k.merge(A),S=S.merge(A.append("line").attr("stroke","currentColor").attr(g+"2",y*h)),C=C.merge(A.append("text").attr("fill","currentColor").attr(g,y*_).attr("dy",1===t?"0em":3===t?"0.71em":"0.32em")),r!==M&&(T=T.transition(r),k=k.transition(r),S=S.transition(r),C=C.transition(r),O=O.transition(r).attr("opacity",1e-6).attr("transform",(function(t){return isFinite(t=w(t))?v(t):this.getAttribute("transform")})),A.attr("opacity",1e-6).attr("transform",(function(t){var n=this.parentNode.__axis;return v(n&&isFinite(n=n(t))?n:w(t))}))),O.remove(),T.attr("d",4===t||2==t?d?"M"+y*d+","+x+"H0.5V"+b+"H"+y*d:"M0.5,"+x+"V"+b:d?"M"+x+","+y*d+"V0.5H"+b+"V"+y*d:"M"+x+",0.5H"+b),k.attr("opacity",1).attr("transform",(function(t){return v(w(t))})),S.attr(g+"2",y*h),C.attr(g,y*_).text(u),M.filter(s).attr("fill","none").attr("font-size",10).attr("font-family","sans-serif").attr("text-anchor",2===t?"start":4===t?"end":"middle"),M.each((function(){this.__axis=w}))}return _.scale=function(t){return arguments.length?(n=t,_):n},_.ticks=function(){return e=r.call(arguments),_},_.tickArguments=function(t){return arguments.length?(e=null==t?[]:r.call(t),_):e.slice()},_.tickValues=function(t){return arguments.length?(l=null==t?null:r.call(t),_):l&&l.slice()},_.tickFormat=function(t){return arguments.length?(f=t,_):f},_.tickSize=function(t){return arguments.length?(h=d=+t,_):h},_.tickSizeInner=function(t){return arguments.length?(h=+t,_):h},_.tickSizeOuter=function(t){return arguments.length?(d=+t,_):d},_.tickPadding=function(t){return arguments.length?(p=+t,_):p},_}function f(t){return l(1,t)}function h(t){return l(2,t)}function d(t){return l(3,t)}function p(t){return l(4,t)}e.d(n,"axisTop",(function(){return f})),e.d(n,"axisRight",(function(){return h})),e.d(n,"axisBottom",(function(){return d})),e.d(n,"axisLeft",(function(){return p}))},function(t,n,e){"use strict";var r;void 0===(r=function(t){var n=e(44),r=e(2),i=0,o={small:{limit:10,format:n.format("")},medium:{limit:1e3,format:n.format("")},large:{limit:null,format:n.format(".2s")}},u={small:{limit:10,format:n.format(".3f")},medium:{limit:100,format:n.format(".1f")},large:{limit:null,format:n.format(".2s")}},a=function(t,n){var e="large";return t<n.small.limit?e="small":t<n.medium.limit&&(e="medium"),e};return{calculatePercent:function(t,e,r){var i=e?t/e*100:0;return n.format(r)(i)},calcLinearRegression:function(t){var n=t.length,e=0,i=0,o=0,u=0;t.forEach((function(t){e+=t.x,i+=t.y,o+=t.x*t.y,u+=t.x*t.x}));var a=n*u-e*e,c=(i*u-e*o)/a,s=(n*o-e*i)/a,l=r.min(t,(function(t){return t.x})),f=r.max(t,(function(t){return t.x}));return{x1:l,y1:s*n+c,x2:f,y2:s*f+c}},isInteger:function(t){return t%1==0},formatDecimalValue:function(t){var n=a(t,u);return(0,u[n].format)(t)},formatIntegerValue:function(t){var n=a(t,o);return(0,o[n].format)(t)},uniqueId:function(t){var n=++i;return t.toString()+"-"+n}}}.call(n,e,n,t))||(t.exports=r)},,,function(t,n,e){"use strict";var r;void 0===(r=function(t){e(44);return{addDays:function(t,n){var e=new Date(t);return e.setDate(e.getDate()+n),String(e)},convertMillisecondsToDays:function(t){return Math.ceil(t/864e5)},diffDays:function(t,n){return Math.ceil(Math.abs((new Date(t).getTime()-new Date(n).getTime())/864e5))},getLocaleDateFormatter:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"day",e=localeTimeMap[n],r=new Intl.DateTimeFormat(t,e);return function(t){return r.format(t)}}}}.call(n,e,n,t))||(t.exports=r)},,function(t,n,e){"use strict";var r,i=function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,n){var e=[],r=!0,i=!1,o=void 0;try{for(var u,a=t[Symbol.iterator]();!(r=(u=a.next()).done)&&(e.push(u.value),!n||e.length!==n);r=!0);}catch(t){i=!0,o=t}finally{try{!r&&a.return&&a.return()}finally{if(i)throw o}}return e}(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};function u(t,n,e){return n in t?Object.defineProperty(t,n,{value:e,enumerable:!0,configurable:!0,writable:!0}):t[n]=e,t}void 0===(r=function(t){var n,r=e(38),a=e(66),c=e(70),s=c.axisTimeCombinations,l=c.timeBenchmarks,f=e(88),h=f.convertMillisecondsToDays,d=f.getLocaleDateFormatter,p={minute:a.timeFormat("%M m"),hour:a.timeFormat("%H %p"),day:a.timeFormat("%e"),daymonth:a.timeFormat("%d %b"),month:a.timeFormat("%b"),year:a.timeFormat("%Y")},y=(u(n={},s.MINUTE_HOUR,r.timeHour.every(1)),u(n,s.HOUR_DAY,r.timeDay.every(1)),u(n,s.DAY_MONTH,r.timeMonth.every(1)),u(n,s.MONTH_YEAR,r.timeYear.every(1)),n),g=function(t){var n=l.ONE_YEAR;return t<l.ONE_DAY?s.HOUR_DAY:t<n?s.DAY_MONTH:s.MONTH_YEAR},v=function(t,n){var e=Math.ceil(t/70);return n<5?r.timeDay:Math.min(n,e)};return{getTimeSeriesAxis:function(t,n){var e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,u=new Date(t[0].date),a=new Date(t[t.length-1].date),c=a-u;r&&("undefined"==typeof Intl||"object"===("undefined"==typeof Intl?"undefined":o(Intl))&&!Intl.DateTimeFormat)&&(r=null),e||(e=g(c));var s=e.split("-"),l=i(s,2),f=l[0],_=l[1],m=y[e],x=v(n,h(c));return{minor:{format:r?d(r,f):p[f],tick:x},major:{format:r?d(r,_):p[_],tick:m}}},getSortedNumberAxis:function(t,n){var e=t[0].date;return{tick:function(t,n){var e=Math.ceil(t/70);return Math.min(n,e)}(n,t[t.length-1].date-e)}}}}.call(n,e,n,t))||(t.exports=r)},,function(t,n,e){"use strict";var r;void 0===(r=function(t){e(6);var n="highlight-filter";return{bounceCircleHighlight:function(t,n,e){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2*e,i=100,o=50;t.transition().ease(n).duration(i).attr("r",r).transition().ease(n).delay(o).duration(i).attr("r",e)},createFilterContainer:function(t){return t.append("defs").append("filter").attr("id",n)},createGausianBlur:function(t){return t.append("feGaussianBlur").attr("stdDeviation",1).attr("result","coloredBlur"),n},createWhiteGlow:function(t){t.attr("x","-5000%").attr("y","-5000%").attr("width","10000%").attr("height","10000%"),t.append("feFlood").attr("result","flood").attr("flood-color","#ffffff").attr("flood-opacity","1"),t.append("feComposite").attr("result","mask").attr("in2","SourceGraphic").attr("operator","in").attr("in","flood"),t.append("feMorphology").attr("result","dilated").attr("operator","dilate").attr("radius","2").attr("in","mask"),t.append("feGaussianBlur").attr("result","blurred").attr("stdDeviation","5").attr("in","dilated");var e=t.append("feMerge");return e.append("feMergeNode").attr("in","blurred"),e.append("feMergeNode").attr("in","SourceGraphic"),n},createGlow:function(t){t.attr("x","-30%").attr("y","-30%").attr("width","160%").attr("height","160%"),t.append("feGaussianBlur").attr("stdDeviation","0.9 0.9").attr("result","glow");var e=t.append("feMerge");return e.append("feMergeNode").attr("in","glow"),e.append("feMergeNode").attr("in","glow"),e.append("feMergeNode").attr("in","glow"),n},createGlowWithMatrix:function(t){t.attr("x","-500%").attr("y","-500%").attr("width","1800%").attr("height","1800%"),t.append("feColorMatrix").attr("type","matrix").attr("values","0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"),t.append("feGaussianBlur").attr("stdDeviation","1").attr("result","coloredBlur").attr("in","SourceGraphic");var e=t.append("feMerge");return e.append("feMergeNode").attr("in","coloredBlur"),e.append("feMergeNode").attr("in","SourceGraphic"),n}}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";var r;void 0===(r=function(t){return{castValueToType:function(t,n){return"number"===n?Number(t):new Date(t)}}}.call(n,e,n,t))||(t.exports=r)},,,,,,,,function(t,n,e){"use strict";var r,i=function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,n){var e=[],r=!0,i=!1,o=void 0;try{for(var u,a=t[Symbol.iterator]();!(r=(u=a.next()).done)&&(e.push(u.value),!n||e.length!==n);r=!0);}catch(t){i=!0,o=t}finally{try{!r&&a.return&&a.return()}finally{if(i)throw o}}return e}(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")},o=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r])}return t};function u(t){if(Array.isArray(t)){for(var n=0,e=Array(t.length);n<t.length;n++)e[n]=t[n];return e}return Array.from(t)}void 0===(r=function(t){var n=e(2),r=e(84),a=e(45),c=e(68),s=e(64),l=e(44),f=e(75),h=e(71),d=e(6),p=(e(72),e(66)),y=e(76).exportChart,g=e(65),v=e(83).line,_=e(90),m=_.getTimeSeriesAxis,x=_.getSortedNumberAxis,b=e(93).castValueToType,w=e(70),M=w.axisTimeCombinations,T=w.curveMap,k=e(92),O=k.createFilterContainer,A=k.createGlowWithMatrix,S=k.bounceCircleHighlight,C=e(85),N=C.formatIntegerValue,E=C.formatDecimalValue,D=C.isInteger,j=C.uniqueId;return function(){var t={top:60,right:30,bottom:40,left:70},e=960,_=500,w=v,k=null,C=480,F=void 0,P=void 0,L=void 0,I=void 0,U=void 0,R=void 0,B=void 0,H=void 0,Y=void 0,q=void 0,z=15,G=g.colorSchemas.britecharts,V=g.colorGradients.greenBlue,X=void 0,W=void 0,$=j("one-line-gradient"),Z=null,Q=null,J="date",K="linear",tt=null,nt=null,et=null,rt=void 0,it=!1,ot=!1,ut=s.easeQuadInOut,at=void 0,ct="linear",st=void 0,lt=void 0,ft="date",ht="value",dt="topic",pt=null,yt=null,gt=null,vt=null,_t=36,mt=5,xt=void 0,bt=void 0,wt=void 0,Mt=void 0,Tt=[],kt=null,Ot={},At=function(t){return t.date},St=function(t){return t.value},Ct=function(t){return t.topic},Nt=function(t){return t.topicName},Et=c.dispatch("customMouseOver","customMouseOut","customMouseMove","customDataEntryClick","customTouchMove");function Dt(c){c.each((function(c){var s,l,y=function(t){var n=t.dataByTopic,e=t.dataSorted,r=t.data;if(!n&&!r)throw new Error("Data needs to have a dataByTopic or data property. See more in http://britecharts.github.io/britecharts/global.html#LineChartData__anchor");n?r=n.reduce((function(t,n){return n.dates.forEach((function(e){t.push({topicName:n.topicName,name:n[dt],date:e[ft],value:e[ht]})})),t}),[]):n=a.nest().key(Nt).entries(r).map((function(t){return{topic:t.values[0].name,topicName:t.key,dates:t.values}}));return e=a.nest().key(At).entries(r).map((function(t){return{date:b(t.key,J),topics:t.values}})),{dataByTopic:n.reduce((function(t,n){var e=n.dates,r=function(t,n){var e={};for(var r in t)n.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e}(n,["dates"]),i=e.map((function(t){return{date:b(t[ft],J),value:(n=t[ht],null===n?null:+n)};var n}));return t.push(o({dates:i},r)),t}),[]),dataSorted:e}}(c);st=y.dataByTopic,lt=y.dataSorted,L=e-t.left-t.right,I=_-t.top-t.bottom,function(){o=n.min(st,(function(t){var e=t.dates;return n.min(e,At)})),u=n.max(st,(function(t){var e=t.dates;return n.max(e,At)})),U="number"===J?"logarithmic"===K?f.scaleLog().domain([o,u]).rangeRound([0,L]):f.scaleLinear().domain([o,u]).rangeRound([0,L]):f.scaleTime().domain([o,u]).rangeRound([0,L]),t=n.max(st,(function(t){var e=t.dates;return n.max(e,St)})),e=n.min(st,(function(t){var e=t.dates;return n.min(e,St)})),r=e<0?e:0,i=0===e&&0===t?1:t,R=f.scaleLinear().domain([r,i]).rangeRound([I,0]).nice();var t,e,r,i;var o,u;var a=(B=f.scaleOrdinal().range(G).domain(st.map(Ct))).range();X=B.domain().reduce((function(t,n,e){return t[n]=a[e],t}),{})}(),function(n){F||(F=d.select(n).append("svg").classed("britechart line-chart",!0),function(){var n=F.append("g").classed("container-group",!0).attr("transform","translate("+t.left+","+t.top+")");n.append("g").classed("x-axis-group",!0).append("g").classed("axis x",!0),n.selectAll(".x-axis-group").append("g").classed("month-axis",!0),n.append("g").classed("y-axis-group",!0).append("g").classed("axis y",!0),n.append("g").classed("grid-lines-group",!0),n.append("g").classed("custom-lines-group",!0),n.append("g").classed("chart-group",!0),n.append("g").classed("metadata-group",!0)}());F.attr("width",e).attr("height",_)}(this),function(){var i=void 0,o=void 0;if("number"===J)i=x(lt,e),o=null,H="logarithmic"===K?r.axisBottom(U).ticks(i.tick,"e").tickFormat((function(t){var n=Math.log(t)/Math.LN10;return Math.abs(Math.round(n)-n)<1e-6?"10^"+Math.round(n):""})):r.axisBottom(U).ticks(i.tick).tickFormat(Ft);else{if("custom"===tt&&"string"==typeof et)i={tick:nt,format:p.timeFormat(et)},o=null;else{var u=m(lt,e,tt,rt);i=u.minor,o=u.major,Y=r.axisBottom(U).ticks(o.tick).tickSize(0,0).tickFormat(o.format)}H=r.axisBottom(U).ticks(i.tick).tickSize(10,0).tickPadding(5).tickFormat(i.format)}q=r.axisLeft(R).ticks(mt).tickSize([0]).tickPadding(5).tickFormat(Ft),function(e,r){F.select(".grid-lines-group").selectAll("line").remove();var i=n.min(st,(function(t){var e=t.dates;return n.min(e,St)}))<0;"horizontal"!==kt&&"full"!==kt||F.select(".grid-lines-group").selectAll("line.horizontal-grid-line").data(R.ticks(r)).enter().append("line").attr("class","horizontal-grid-line").attr("x1",-z-30).attr("x2",L).attr("y1",(function(t){return R(t)})).attr("y2",(function(t){return R(t)})).classed("horizontal-grid-line--highlighted",(function(t){return i&&0===t}));"vertical"!==kt&&"full"!==kt||F.select(".grid-lines-group").selectAll("line.vertical-grid-line").data(U.ticks(e)).enter().append("line").attr("class","vertical-grid-line").attr("y1",0).attr("y2",I).attr("x1",(function(t){return U(t)})).attr("x2",(function(t){return U(t)}));F.select(".grid-lines-group").selectAll("line.extended-x-line").data([0]).enter().append("line").attr("class","extended-x-line").attr("x1",-z-30).attr("x2",L).attr("y1",_-t.bottom-t.top).attr("y2",_-t.bottom-t.top)}(i.tick,mt),function(){F.select(".custom-lines-group").selectAll("line").remove();var t=Tt.map((function(t){return t.y}));F.select(".custom-lines-group").selectAll("line.custom-line").data(t).enter().append("line").attr("class","custom-line").attr("x1",0).attr("x2",L).attr("y1",(function(t){return R(t)})).attr("y2",(function(t){return R(t)})).attr("stroke",(function(t){return n=t,Tt.find((function(t){return t.y===n})).color||"#C3C6CF";var n})).attr("fill","none");var n=!0,e=!1,r=void 0;try{for(var i,o=Tt[Symbol.iterator]();!(n=(i=o.next()).done);n=!0){var u=i.value;u.name&&F.select(".custom-lines-group").append("text").attr("x",L).attr("y",R(u.y)-6).attr("class","custom-line-annotation").attr("text-anchor","end").attr("dominant-baseline","baseline").text(u.name)}}catch(t){e=!0,r=t}finally{try{!n&&o.return&&o.return()}finally{if(e)throw r}}}()}(),function(){F.select(".x-axis-group .axis.x").attr("transform","translate(0, "+I+")").call(H),"custom"!==tt&&"number"!==J&&F.select(".x-axis-group .month-axis").attr("transform","translate(0, "+(I+28)+")").call(Y);if(pt){yt&&F.selectAll(".x-axis-label").remove();var t=L/2,n=I+28+36;yt=F.select(".x-axis-group").append("text").attr("x",t).attr("y",n).attr("text-anchor","middle").attr("class","x-axis-label").text(pt)}if(F.select(".y-axis-group .axis.y").attr("transform","translate("+-z+", 0)").call(q).call(jt),gt){vt&&F.selectAll(".y-axis-label").remove();var e=-_t-z,r=-I/2;vt=F.select(".y-axis-group").append("text").attr("x",r).attr("y",e).attr("text-anchor","middle").attr("transform","rotate(270)").attr("class","y-axis-label").text(gt)}}(),W||(W=F.select(".metadata-group").append("linearGradient").attr("id",$).attr("x1","0%").attr("y1","0%").attr("x2","100%").attr("y2","0%").attr("gradientUnits","userSpaceOnUse").selectAll("stop").data([{offset:"0%",color:V[0]},{offset:"100%",color:V[1]}]).enter().append("stop").attr("offset",(function(t){return t.offset})).attr("stop-color",(function(t){return t.color}))),s=void 0,l=void 0,Ot={},l=h.line().curve(T[ct]).x((function(t){var n=t.date;return U(n)})).defined((function(t){return null!==t.value})).y((function(t){var n=t.value;return R(n)})),s=F.select(".chart-group").selectAll(".line").data(st,Ct),P=s.enter().append("g").attr("class","topic").append("path").attr("class","line").merge(s).attr("id",(function(t){return t.topic})).attr("d",(function(t){var n=t.dates;return l(n)})).style("stroke",(function(t){return 1===st.length?"url(#"+$+")":(n=t.topic,B(n));var n})).style("fill","none"),s.exit().remove(),ot&&(at=F.append("rect").attr("class","masking-rectangle").attr("width",e).attr("height",_).attr("x",0).attr("y",0)).transition().duration(1500).ease(ut).attr("x",e).on("end",(function(){return at.remove()})),e>C&&(xt||(xt=F.select(".metadata-group").append("rect").attr("class","overlay").attr("y1",0).attr("y2",_).attr("height",I).attr("width",L).attr("fill","rgba(0, 0, 0, 0)").style("display","none")),bt||(bt=F.select(".metadata-group").append("g").attr("class","hover-marker vertical-marker-container").attr("transform","translate(9999, 0)"),wt=bt.selectAll("path").data([{x1:0,y1:0,x2:0,y2:0}]).enter().append("line").classed("vertical-marker",!0).attr("x1",0).attr("y1",I).attr("x2",0).attr("y2",0)),F.on("mouseover",(function(t){!function(t,n){xt.style("display","block"),wt.classed("bc-is-active",!0),Et.call("customMouseOver",t,n,d.mouse(t))}(this,t)})).on("mouseout",(function(t){!function(t,n){xt.style("display","none"),wt.classed("bc-is-active",!1),bt.attr("transform","translate(9999, 0)"),Et.call("customMouseOut",t,n,d.mouse(t))}(this,t)})).on("mousemove",(function(e){var r,o,u,a,c,s,l,f,h,p,y,g,v,_,m,x,w;h=this,p=d.mouse(h),y=i(p,2),g=y[0],v=y[1],_=-t.left,r=g+_,c=U.invert(r),s=(0,n.bisector(At).left)(lt,c,1),l=lt[s],f=lt[s-1],m=f&&l?(o=c,u=l,a=f,"number"===J?o-u.date>a.date-o?u:a:new Date(o).getTime()-new Date(u.date).getTime()>new Date(a.date).getTime()-new Date(o).getTime()?u:a):l,x=void 0,m&&(x=U(b(m.date,J)),w=x,bt.attr("transform","translate("+w+",0)"),function(t){bt.selectAll(".circle-container").remove();var n=P.nodes().reduce((function(t,n){return t[n.id]=n,t}),{}),e=t.topics.map((function(t){return{topic:t,node:n[t.name]}})).filter((function(t){return!!t.topic})).sort((function(t,n){return X[t.topic.name]<X[n.topic.name]}));t.topics=e.map((function(t){return t.topic})),t.topics.forEach((function(n,r){var i=bt.append("g").classed("circle-container",!0).append("circle").classed("data-point-highlighter",!0).attr("cx",12).attr("cy",0).attr("r",5).style("stroke-width",(function(){return it?5:2})).style("stroke",X[n.name]).style("cursor","pointer").on("click",(function(){!function(t){Z||(Z=O(F.select(".metadata-group")),Q=A(Z));var n=d.select(t);n.style("stroke-width",5).style("stroke-opacity",.6).attr("filter","url(#"+Q+")"),S(n,ut,5)}(this),function(t,n){Et.call("customDataEntryClick",t,n,d.mouse(t))}(this,n)})).on("mouseout",(function(){var t;t=this,d.select(t).attr("filter","none")})),o=e[r].node,u=Pt(U(b(t.topics[r].date,J)),o,n.name);i.attr("transform","translate( -12, "+u+" )")}))}(m),Et.call("customMouseMove",h,m,X,x,v))}))),it&&function(){F.select(".chart-group").selectAll(".data-points-container").remove();var t=P.nodes().reduce((function(t,n){return t[n.id]=n,t}),{}),n=lt.reduce((function(n,e){var r=e.topics.map((function(n){return{topic:n,node:t[n.name]}}));return n=[].concat(u(n),u(r))}),[]);F.select(".chart-group").append("g").classed("data-points-container",!0).selectAll("circle").data(n).enter().append("circle").classed("data-point-mark",!0).attr("r",5).style("stroke-width",2).style("stroke",(function(t){return X[t.topic.name]})).style("cursor","pointer").attr("cx",(function(t){return U(b(t.topic.date,J))})).attr("cy",(function(t){return Pt(U(b(t.topic.date,J)),t.node,t.topic.name)}))}(),F.on("touchmove",(function(t){!function(t,n){Et.call("customTouchMove",t,n,d.touch(t))}(this,t)}))}))}function jt(t){t.selectAll(".tick text").attr("transform","translate(0, -7)")}function Ft(t){var n=void 0;return n=D(t)?N:E,Mt&&(n=l.format(Mt)),n(t)}function Pt(t,n,e,r){var i=e+"-"+t;if(i in Ot)return Ot[i];r=r||.01;var o=0,u=n.getTotalLength(),a=void 0;try{a=n.getPointAtLength((u+o)/2)}catch(t){a={x:0,y:0}}for(var c=0;t<a.x-r||t>a.x+r;){var s=(o+u)/2;try{a=n.getPointAtLength(s)}catch(t){a={x:0,y:0}}if(t<a.x?u=s:o=s,100<(c+=1))break}return Ot[i]=a.y,Ot[i]}return Dt.aspectRatio=function(t){return arguments.length?(k=t,this):k},Dt.xAxisLabel=function(t){return arguments.length?(pt=t,this):pt},Dt.yAxisLabel=function(t){return arguments.length?(gt=t,this):gt},Dt.colorSchema=function(t){return arguments.length?(G=t,this):G},Dt.dateLabel=function(t){return arguments.length?(ft=t,this):ft},Dt.xAxisFormat=function(t){return arguments.length?(tt=t,this):tt},Dt.xAxisCustomFormat=function(t){return arguments.length?(et=t,this):et},Dt.xTicks=function(t){return arguments.length?(nt=t,this):nt},Dt.grid=function(t){return arguments.length?(kt=t,this):kt},Dt.height=function(t){return arguments.length?(k&&(e=Math.ceil(t/k)),_=t,this):_},Dt.isAnimated=function(t){return arguments.length?(ot=t,this):ot},Dt.loadingState=function(t){return arguments.length?(w=t,this):w},Dt.margin=function(n){return arguments.length?(t=o({},t,n),this):t},Dt.numberFormat=function(t){return arguments.length?(Mt=t,this):Mt},Dt.lineCurve=function(t){return arguments.length?(ct=t,this):ct},Dt.lineGradient=function(t){return arguments.length?(V=t,this):V},Dt.shouldShowAllDataPoints=function(t){return arguments.length?(it=t,this):it},Dt.tooltipThreshold=function(t){return arguments.length?(C=t,this):C},Dt.topicLabel=function(t){return arguments.length?(dt=t,this):dt},Dt.valueLabel=function(t){return arguments.length?(ht=t,this):ht},Dt.yAxisLabelPadding=function(t){return arguments.length?(_t=t,this):_t},Dt.yTicks=function(t){return arguments.length?(mt=t,this):mt},Dt.width=function(t){return arguments.length?(k&&(_=Math.ceil(t*k)),e=t,this):e},Dt.locale=function(t){return arguments.length?(rt=t,this):rt},Dt.lines=function(t){return arguments.length?(Tt=t,this):Tt},Dt.exportChart=function(t,n){y.call(Dt,F,t,n)},Dt.on=function(){var t=Et.on.apply(Et,arguments);return t===Et?Dt:t},Dt.axisTimeCombinations=M,Dt.xAxisValueType=function(t){return arguments.length?(J=t,this):J},Dt.xAxisScale=function(t){return arguments.length?(K=t,this):K},Dt}}.call(n,e,n,t))||(t.exports=r)}])}));
//# sourceMappingURL=line.min.js.map

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.tooltip=n():(t.britecharts=t.britecharts||{},t.britecharts.tooltip=n())}(window,(function(){return function(t){var n={};function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:r})},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.t=function(t,n){if(1&n&&(t=e(t)),8&n)return t;if(4&n&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(e.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&n&&"string"!=typeof t)for(var i in t)e.d(r,i,function(n){return t[n]}.bind(null,i));return r},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.p="",e(e.s=108)}([function(t,n,e){"use strict";e.d(n,"a",(function(){return u}));var r=new Date,i=new Date;function u(t,n,e,o){function a(n){return t(n=0===arguments.length?new Date:new Date(+n)),n}return a.floor=function(n){return t(n=new Date(+n)),n},a.ceil=function(e){return t(e=new Date(e-1)),n(e,1),t(e),e},a.round=function(t){var n=a(t),e=a.ceil(t);return t-n<e-t?n:e},a.offset=function(t,e){return n(t=new Date(+t),null==e?1:Math.floor(e)),t},a.range=function(e,r,i){var u,o=[];if(e=a.ceil(e),i=null==i?1:Math.floor(i),!(e<r&&i>0))return o;do{o.push(u=new Date(+e)),n(e,i),t(e)}while(u<e&&e<r);return o},a.filter=function(e){return u((function(n){if(n>=n)for(;t(n),!e(n);)n.setTime(n-1)}),(function(t,r){if(t>=t)if(r<0)for(;++r<=0;)for(;n(t,-1),!e(t););else for(;--r>=0;)for(;n(t,1),!e(t););}))},e&&(a.count=function(n,u){return r.setTime(+n),i.setTime(+u),t(r),t(i),Math.floor(e(r,i))},a.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?a.filter(o?function(n){return o(n)%t==0}:function(n){return a.count(0,n)%t==0}):a:null}),a}},function(t,n,e){"use strict";e.d(n,"d",(function(){return r})),e.d(n,"c",(function(){return i})),e.d(n,"b",(function(){return u})),e.d(n,"a",(function(){return o})),e.d(n,"e",(function(){return a}));var r=1e3,i=6e4,u=36e5,o=864e5,a=6048e5},function(t,n,e){"use strict";e.r(n);var r=function(t,n){return t<n?-1:t>n?1:t>=n?0:NaN},i=function(t){var n;return 1===t.length&&(n=t,t=function(t,e){return r(n(t),e)}),{left:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var u=r+i>>>1;t(n[u],e)<0?r=u+1:i=u}return r},right:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var u=r+i>>>1;t(n[u],e)>0?i=u:r=u+1}return r}}};var u=i(r),o=u.right,a=u.left,c=o,s=function(t,n){null==n&&(n=l);for(var e=0,r=t.length-1,i=t[0],u=new Array(r<0?0:r);e<r;)u[e]=n(i,i=t[++e]);return u};function l(t,n){return[t,n]}var f=function(t,n,e){var r,i,u,o,a=t.length,c=n.length,s=new Array(a*c);for(null==e&&(e=l),r=u=0;r<a;++r)for(o=t[r],i=0;i<c;++i,++u)s[u]=e(o,n[i]);return s},h=function(t,n){return n<t?-1:n>t?1:n>=t?0:NaN},d=function(t){return null===t?NaN:+t},_=function(t,n){var e,r,i=t.length,u=0,o=-1,a=0,c=0;if(null==n)for(;++o<i;)isNaN(e=d(t[o]))||(c+=(r=e-a)*(e-(a+=r/++u)));else for(;++o<i;)isNaN(e=d(n(t[o],o,t)))||(c+=(r=e-a)*(e-(a+=r/++u)));if(u>1)return c/(u-1)},p=function(t,n){var e=_(t,n);return e?Math.sqrt(e):e},y=function(t,n){var e,r,i,u=t.length,o=-1;if(null==n){for(;++o<u;)if(null!=(e=t[o])&&e>=e)for(r=i=e;++o<u;)null!=(e=t[o])&&(r>e&&(r=e),i<e&&(i=e))}else for(;++o<u;)if(null!=(e=n(t[o],o,t))&&e>=e)for(r=i=e;++o<u;)null!=(e=n(t[o],o,t))&&(r>e&&(r=e),i<e&&(i=e));return[r,i]},v=Array.prototype,g=v.slice,m=v.map,x=function(t){return function(){return t}},b=function(t){return t},w=function(t,n,e){t=+t,n=+n,e=(i=arguments.length)<2?(n=t,t=0,1):i<3?1:+e;for(var r=-1,i=0|Math.max(0,Math.ceil((n-t)/e)),u=new Array(i);++r<i;)u[r]=t+r*e;return u},M=Math.sqrt(50),T=Math.sqrt(10),O=Math.sqrt(2),S=function(t,n,e){var r,i,u,o,a=-1;if(e=+e,(t=+t)===(n=+n)&&e>0)return[t];if((r=n<t)&&(i=t,t=n,n=i),0===(o=A(t,n,e))||!isFinite(o))return[];if(o>0)for(t=Math.ceil(t/o),n=Math.floor(n/o),u=new Array(i=Math.ceil(n-t+1));++a<i;)u[a]=(t+a)*o;else for(t=Math.floor(t*o),n=Math.ceil(n*o),u=new Array(i=Math.ceil(t-n+1));++a<i;)u[a]=(t-a)/o;return r&&u.reverse(),u};function A(t,n,e){var r=(n-t)/Math.max(0,e),i=Math.floor(Math.log(r)/Math.LN10),u=r/Math.pow(10,i);return i>=0?(u>=M?10:u>=T?5:u>=O?2:1)*Math.pow(10,i):-Math.pow(10,-i)/(u>=M?10:u>=T?5:u>=O?2:1)}function N(t,n,e){var r=Math.abs(n-t)/Math.max(0,e),i=Math.pow(10,Math.floor(Math.log(r)/Math.LN10)),u=r/i;return u>=M?i*=10:u>=T?i*=5:u>=O&&(i*=2),n<t?-i:i}var j=function(t){return Math.ceil(Math.log(t.length)/Math.LN2)+1},k=function(){var t=b,n=y,e=j;function r(r){var i,u,o=r.length,a=new Array(o);for(i=0;i<o;++i)a[i]=t(r[i],i,r);var s=n(a),l=s[0],f=s[1],h=e(a,l,f);Array.isArray(h)||(h=N(l,f,h),h=w(Math.ceil(l/h)*h,f,h));for(var d=h.length;h[0]<=l;)h.shift(),--d;for(;h[d-1]>f;)h.pop(),--d;var _,p=new Array(d+1);for(i=0;i<=d;++i)(_=p[i]=[]).x0=i>0?h[i-1]:l,_.x1=i<d?h[i]:f;for(i=0;i<o;++i)l<=(u=a[i])&&u<=f&&p[c(h,u,0,d)].push(r[i]);return p}return r.value=function(n){return arguments.length?(t="function"==typeof n?n:x(n),r):t},r.domain=function(t){return arguments.length?(n="function"==typeof t?t:x([t[0],t[1]]),r):n},r.thresholds=function(t){return arguments.length?(e="function"==typeof t?t:Array.isArray(t)?x(g.call(t)):x(t),r):e},r},C=function(t,n,e){if(null==e&&(e=d),r=t.length){if((n=+n)<=0||r<2)return+e(t[0],0,t);if(n>=1)return+e(t[r-1],r-1,t);var r,i=(r-1)*n,u=Math.floor(i),o=+e(t[u],u,t);return o+(+e(t[u+1],u+1,t)-o)*(i-u)}},E=function(t,n,e){return t=m.call(t,d).sort(r),Math.ceil((e-n)/(2*(C(t,.75)-C(t,.25))*Math.pow(t.length,-1/3)))},D=function(t,n,e){return Math.ceil((e-n)/(3.5*p(t)*Math.pow(t.length,-1/3)))},U=function(t,n){var e,r,i=t.length,u=-1;if(null==n){for(;++u<i;)if(null!=(e=t[u])&&e>=e)for(r=e;++u<i;)null!=(e=t[u])&&e>r&&(r=e)}else for(;++u<i;)if(null!=(e=n(t[u],u,t))&&e>=e)for(r=e;++u<i;)null!=(e=n(t[u],u,t))&&e>r&&(r=e);return r},F=function(t,n){var e,r=t.length,i=r,u=-1,o=0;if(null==n)for(;++u<r;)isNaN(e=d(t[u]))?--i:o+=e;else for(;++u<r;)isNaN(e=d(n(t[u],u,t)))?--i:o+=e;if(i)return o/i},P=function(t,n){var e,i=t.length,u=-1,o=[];if(null==n)for(;++u<i;)isNaN(e=d(t[u]))||o.push(e);else for(;++u<i;)isNaN(e=d(n(t[u],u,t)))||o.push(e);return C(o.sort(r),.5)},Y=function(t){for(var n,e,r,i=t.length,u=-1,o=0;++u<i;)o+=t[u].length;for(e=new Array(o);--i>=0;)for(n=(r=t[i]).length;--n>=0;)e[--o]=r[n];return e},I=function(t,n){var e,r,i=t.length,u=-1;if(null==n){for(;++u<i;)if(null!=(e=t[u])&&e>=e)for(r=e;++u<i;)null!=(e=t[u])&&r>e&&(r=e)}else for(;++u<i;)if(null!=(e=n(t[u],u,t))&&e>=e)for(r=e;++u<i;)null!=(e=n(t[u],u,t))&&r>e&&(r=e);return r},L=function(t,n){for(var e=n.length,r=new Array(e);e--;)r[e]=t[n[e]];return r},H=function(t,n){if(e=t.length){var e,i,u=0,o=0,a=t[o];for(null==n&&(n=r);++u<e;)(n(i=t[u],a)<0||0!==n(a,a))&&(a=i,o=u);return 0===n(a,a)?o:void 0}},q=function(t,n,e){for(var r,i,u=(null==e?t.length:e)-(n=null==n?0:+n);u;)i=Math.random()*u--|0,r=t[u+n],t[u+n]=t[i+n],t[i+n]=r;return t},R=function(t,n){var e,r=t.length,i=-1,u=0;if(null==n)for(;++i<r;)(e=+t[i])&&(u+=e);else for(;++i<r;)(e=+n(t[i],i,t))&&(u+=e);return u},B=function(t){if(!(i=t.length))return[];for(var n=-1,e=I(t,z),r=new Array(e);++n<e;)for(var i,u=-1,o=r[n]=new Array(i);++u<i;)o[u]=t[u][n];return r};function z(t){return t.length}var X=function(){return B(arguments)};e.d(n,"bisect",(function(){return c})),e.d(n,"bisectRight",(function(){return o})),e.d(n,"bisectLeft",(function(){return a})),e.d(n,"ascending",(function(){return r})),e.d(n,"bisector",(function(){return i})),e.d(n,"cross",(function(){return f})),e.d(n,"descending",(function(){return h})),e.d(n,"deviation",(function(){return p})),e.d(n,"extent",(function(){return y})),e.d(n,"histogram",(function(){return k})),e.d(n,"thresholdFreedmanDiaconis",(function(){return E})),e.d(n,"thresholdScott",(function(){return D})),e.d(n,"thresholdSturges",(function(){return j})),e.d(n,"max",(function(){return U})),e.d(n,"mean",(function(){return F})),e.d(n,"median",(function(){return P})),e.d(n,"merge",(function(){return Y})),e.d(n,"min",(function(){return I})),e.d(n,"pairs",(function(){return s})),e.d(n,"permute",(function(){return L})),e.d(n,"quantile",(function(){return C})),e.d(n,"range",(function(){return w})),e.d(n,"scan",(function(){return H})),e.d(n,"shuffle",(function(){return q})),e.d(n,"sum",(function(){return R})),e.d(n,"ticks",(function(){return S})),e.d(n,"tickIncrement",(function(){return A})),e.d(n,"tickStep",(function(){return N})),e.d(n,"transpose",(function(){return B})),e.d(n,"variance",(function(){return _})),e.d(n,"zip",(function(){return X}))},function(t,n,e){"use strict";e.d(n,"g",(function(){return o})),e.d(n,"c",(function(){return a})),e.d(n,"k",(function(){return c})),e.d(n,"m",(function(){return s})),e.d(n,"i",(function(){return l})),e.d(n,"a",(function(){return f})),e.d(n,"e",(function(){return h})),e.d(n,"h",(function(){return d})),e.d(n,"d",(function(){return _})),e.d(n,"l",(function(){return p})),e.d(n,"n",(function(){return y})),e.d(n,"j",(function(){return v})),e.d(n,"b",(function(){return g})),e.d(n,"f",(function(){return m}));var r=e(0),i=e(1);function u(t){return Object(r.a)((function(n){n.setDate(n.getDate()-(n.getDay()+7-t)%7),n.setHours(0,0,0,0)}),(function(t,n){t.setDate(t.getDate()+7*n)}),(function(t,n){return(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*i.c)/i.e}))}var o=u(0),a=u(1),c=u(2),s=u(3),l=u(4),f=u(5),h=u(6),d=o.range,_=a.range,p=c.range,y=s.range,v=l.range,g=f.range,m=h.range},function(t,n,e){"use strict";e.d(n,"g",(function(){return o})),e.d(n,"c",(function(){return a})),e.d(n,"k",(function(){return c})),e.d(n,"m",(function(){return s})),e.d(n,"i",(function(){return l})),e.d(n,"a",(function(){return f})),e.d(n,"e",(function(){return h})),e.d(n,"h",(function(){return d})),e.d(n,"d",(function(){return _})),e.d(n,"l",(function(){return p})),e.d(n,"n",(function(){return y})),e.d(n,"j",(function(){return v})),e.d(n,"b",(function(){return g})),e.d(n,"f",(function(){return m}));var r=e(0),i=e(1);function u(t){return Object(r.a)((function(n){n.setUTCDate(n.getUTCDate()-(n.getUTCDay()+7-t)%7),n.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCDate(t.getUTCDate()+7*n)}),(function(t,n){return(n-t)/i.e}))}var o=u(0),a=u(1),c=u(2),s=u(3),l=u(4),f=u(5),h=u(6),d=o.range,_=a.range,p=c.range,y=s.range,v=l.range,g=f.range,m=h.range},function(t,n,e){"use strict";n.a=function(t,n){return t=+t,n=+n,function(e){return t*(1-e)+n*e}}},function(t,n,e){"use strict";e.r(n);var r=e(12),i=e(32),u=function(t){return Object(i.a)(Object(r.a)(t).call(document.documentElement))},o=0;function a(){return new c}function c(){this._="@"+(++o).toString(36)}c.prototype=a.prototype={constructor:c,get:function(t){for(var n=this._;!(n in t);)if(!(t=t.parentNode))return;return t[n]},set:function(t,n){return t[this._]=n},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}};var s=e(34),l=e(59),f=e(20),h=e(14),d=e(13),_=e(9),p=function(t){return"string"==typeof t?new _.a([document.querySelectorAll(t)],[document.documentElement]):new _.a([null==t?[]:t],_.c)},y=e(19),v=e(33),g=e(35),m=e(60),x=e(22),b=function(t,n){null==n&&(n=Object(x.a)().touches);for(var e=0,r=n?n.length:0,i=new Array(r);e<r;++e)i[e]=Object(d.a)(t,n[e]);return i},w=e(21),M=e(17);e.d(n,"create",(function(){return u})),e.d(n,"creator",(function(){return r.a})),e.d(n,"local",(function(){return a})),e.d(n,"matcher",(function(){return s.a})),e.d(n,"mouse",(function(){return l.a})),e.d(n,"namespace",(function(){return f.a})),e.d(n,"namespaces",(function(){return h.a})),e.d(n,"clientPoint",(function(){return d.a})),e.d(n,"select",(function(){return i.a})),e.d(n,"selectAll",(function(){return p})),e.d(n,"selection",(function(){return _.b})),e.d(n,"selector",(function(){return y.a})),e.d(n,"selectorAll",(function(){return v.a})),e.d(n,"style",(function(){return g.b})),e.d(n,"touch",(function(){return m.a})),e.d(n,"touches",(function(){return b})),e.d(n,"window",(function(){return w.a})),e.d(n,"event",(function(){return M.c})),e.d(n,"customEvent",(function(){return M.a}))},function(t,n,e){"use strict";e.d(n,"a",(function(){return i})),e.d(n,"d",(function(){return u})),e.d(n,"c",(function(){return o})),e.d(n,"e",(function(){return x})),e.d(n,"h",(function(){return M})),e.d(n,"g",(function(){return T})),e.d(n,"b",(function(){return O})),e.d(n,"f",(function(){return C}));var r=e(11);function i(){}var u=.7,o=1/u,a="\\s*([+-]?\\d+)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",s="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",l=/^#([0-9a-f]{3,8})$/,f=new RegExp("^rgb\\("+[a,a,a]+"\\)$"),h=new RegExp("^rgb\\("+[s,s,s]+"\\)$"),d=new RegExp("^rgba\\("+[a,a,a,c]+"\\)$"),_=new RegExp("^rgba\\("+[s,s,s,c]+"\\)$"),p=new RegExp("^hsl\\("+[c,s,s]+"\\)$"),y=new RegExp("^hsla\\("+[c,s,s,c]+"\\)$"),v={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};function g(){return this.rgb().formatHex()}function m(){return this.rgb().formatRgb()}function x(t){var n,e;return t=(t+"").trim().toLowerCase(),(n=l.exec(t))?(e=n[1].length,n=parseInt(n[1],16),6===e?b(n):3===e?new O(n>>8&15|n>>4&240,n>>4&15|240&n,(15&n)<<4|15&n,1):8===e?new O(n>>24&255,n>>16&255,n>>8&255,(255&n)/255):4===e?new O(n>>12&15|n>>8&240,n>>8&15|n>>4&240,n>>4&15|240&n,((15&n)<<4|15&n)/255):null):(n=f.exec(t))?new O(n[1],n[2],n[3],1):(n=h.exec(t))?new O(255*n[1]/100,255*n[2]/100,255*n[3]/100,1):(n=d.exec(t))?w(n[1],n[2],n[3],n[4]):(n=_.exec(t))?w(255*n[1]/100,255*n[2]/100,255*n[3]/100,n[4]):(n=p.exec(t))?j(n[1],n[2]/100,n[3]/100,1):(n=y.exec(t))?j(n[1],n[2]/100,n[3]/100,n[4]):v.hasOwnProperty(t)?b(v[t]):"transparent"===t?new O(NaN,NaN,NaN,0):null}function b(t){return new O(t>>16&255,t>>8&255,255&t,1)}function w(t,n,e,r){return r<=0&&(t=n=e=NaN),new O(t,n,e,r)}function M(t){return t instanceof i||(t=x(t)),t?new O((t=t.rgb()).r,t.g,t.b,t.opacity):new O}function T(t,n,e,r){return 1===arguments.length?M(t):new O(t,n,e,null==r?1:r)}function O(t,n,e,r){this.r=+t,this.g=+n,this.b=+e,this.opacity=+r}function S(){return"#"+N(this.r)+N(this.g)+N(this.b)}function A(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}function N(t){return((t=Math.max(0,Math.min(255,Math.round(t)||0)))<16?"0":"")+t.toString(16)}function j(t,n,e,r){return r<=0?t=n=e=NaN:e<=0||e>=1?t=n=NaN:n<=0&&(t=NaN),new E(t,n,e,r)}function k(t){if(t instanceof E)return new E(t.h,t.s,t.l,t.opacity);if(t instanceof i||(t=x(t)),!t)return new E;if(t instanceof E)return t;var n=(t=t.rgb()).r/255,e=t.g/255,r=t.b/255,u=Math.min(n,e,r),o=Math.max(n,e,r),a=NaN,c=o-u,s=(o+u)/2;return c?(a=n===o?(e-r)/c+6*(e<r):e===o?(r-n)/c+2:(n-e)/c+4,c/=s<.5?o+u:2-o-u,a*=60):c=s>0&&s<1?0:a,new E(a,c,s,t.opacity)}function C(t,n,e,r){return 1===arguments.length?k(t):new E(t,n,e,null==r?1:r)}function E(t,n,e,r){this.h=+t,this.s=+n,this.l=+e,this.opacity=+r}function D(t,n,e){return 255*(t<60?n+(e-n)*t/60:t<180?e:t<240?n+(e-n)*(240-t)/60:n)}Object(r.a)(i,x,{copy:function(t){return Object.assign(new this.constructor,this,t)},displayable:function(){return this.rgb().displayable()},hex:g,formatHex:g,formatHsl:function(){return k(this).formatHsl()},formatRgb:m,toString:m}),Object(r.a)(O,T,Object(r.b)(i,{brighter:function(t){return t=null==t?o:Math.pow(o,t),new O(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?u:Math.pow(u,t),new O(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return-.5<=this.r&&this.r<255.5&&-.5<=this.g&&this.g<255.5&&-.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1},hex:S,formatHex:S,formatRgb:A,toString:A})),Object(r.a)(E,C,Object(r.b)(i,{brighter:function(t){return t=null==t?o:Math.pow(o,t),new E(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?u:Math.pow(u,t),new E(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),n=isNaN(t)||isNaN(this.s)?0:this.s,e=this.l,r=e+(e<.5?e:1-e)*n,i=2*e-r;return new O(D(t>=240?t-240:t+120,i,r),D(t,i,r),D(t<120?t+240:t-120,i,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1},formatHsl:function(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"hsl(":"hsla(")+(this.h||0)+", "+100*(this.s||0)+"%, "+100*(this.l||0)+"%"+(1===t?")":", "+t+")")}}))},function(t,n,e){"use strict";var r=e(18);n.a=function(t){return(t=Object(r.a)(Math.abs(t)))?t[1]:NaN}},function(t,n,e){"use strict";var r=e(19),i=e(33),u=e(34),o=function(t){return new Array(t.length)};function a(t,n){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=n}a.prototype={constructor:a,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,n){return this._parent.insertBefore(t,n)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}};function c(t,n,e,r,i,u){for(var o,c=0,s=n.length,l=u.length;c<l;++c)(o=n[c])?(o.__data__=u[c],r[c]=o):e[c]=new a(t,u[c]);for(;c<s;++c)(o=n[c])&&(i[c]=o)}function s(t,n,e,r,i,u,o){var c,s,l,f={},h=n.length,d=u.length,_=new Array(h);for(c=0;c<h;++c)(s=n[c])&&(_[c]=l="$"+o.call(s,s.__data__,c,n),l in f?i[c]=s:f[l]=s);for(c=0;c<d;++c)(s=f[l="$"+o.call(t,u[c],c,u)])?(r[c]=s,s.__data__=u[c],f[l]=null):e[c]=new a(t,u[c]);for(c=0;c<h;++c)(s=n[c])&&f[_[c]]===s&&(i[c]=s)}function l(t,n){return t<n?-1:t>n?1:t>=n?0:NaN}var f=e(20);function h(t){return function(){this.removeAttribute(t)}}function d(t){return function(){this.removeAttributeNS(t.space,t.local)}}function _(t,n){return function(){this.setAttribute(t,n)}}function p(t,n){return function(){this.setAttributeNS(t.space,t.local,n)}}function y(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttribute(t):this.setAttribute(t,e)}}function v(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,e)}}var g=e(35);function m(t){return function(){delete this[t]}}function x(t,n){return function(){this[t]=n}}function b(t,n){return function(){var e=n.apply(this,arguments);null==e?delete this[t]:this[t]=e}}function w(t){return t.trim().split(/^|\s+/)}function M(t){return t.classList||new T(t)}function T(t){this._node=t,this._names=w(t.getAttribute("class")||"")}function O(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.add(n[r])}function S(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.remove(n[r])}function A(t){return function(){O(this,t)}}function N(t){return function(){S(this,t)}}function j(t,n){return function(){(n.apply(this,arguments)?O:S)(this,t)}}T.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var n=this._names.indexOf(t);n>=0&&(this._names.splice(n,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}};function k(){this.textContent=""}function C(t){return function(){this.textContent=t}}function E(t){return function(){var n=t.apply(this,arguments);this.textContent=null==n?"":n}}function D(){this.innerHTML=""}function U(t){return function(){this.innerHTML=t}}function F(t){return function(){var n=t.apply(this,arguments);this.innerHTML=null==n?"":n}}function P(){this.nextSibling&&this.parentNode.appendChild(this)}function Y(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}var I=e(12);function L(){return null}function H(){var t=this.parentNode;t&&t.removeChild(this)}function q(){var t=this.cloneNode(!1),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}function R(){var t=this.cloneNode(!0),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}var B=e(17),z=e(21);function X(t,n,e){var r=Object(z.a)(t),i=r.CustomEvent;"function"==typeof i?i=new i(n,e):(i=r.document.createEvent("Event"),e?(i.initEvent(n,e.bubbles,e.cancelable),i.detail=e.detail):i.initEvent(n,!1,!1)),t.dispatchEvent(i)}function W(t,n){return function(){return X(this,t,n)}}function V(t,n){return function(){return X(this,t,n.apply(this,arguments))}}e.d(n,"c",(function(){return Z})),e.d(n,"a",(function(){return $}));var Z=[null];function $(t,n){this._groups=t,this._parents=n}function Q(){return new $([[document.documentElement]],Z)}$.prototype=Q.prototype={constructor:$,select:function(t){"function"!=typeof t&&(t=Object(r.a)(t));for(var n=this._groups,e=n.length,i=new Array(e),u=0;u<e;++u)for(var o,a,c=n[u],s=c.length,l=i[u]=new Array(s),f=0;f<s;++f)(o=c[f])&&(a=t.call(o,o.__data__,f,c))&&("__data__"in o&&(a.__data__=o.__data__),l[f]=a);return new $(i,this._parents)},selectAll:function(t){"function"!=typeof t&&(t=Object(i.a)(t));for(var n=this._groups,e=n.length,r=[],u=[],o=0;o<e;++o)for(var a,c=n[o],s=c.length,l=0;l<s;++l)(a=c[l])&&(r.push(t.call(a,a.__data__,l,c)),u.push(a));return new $(r,u)},filter:function(t){"function"!=typeof t&&(t=Object(u.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o,a=n[i],c=a.length,s=r[i]=[],l=0;l<c;++l)(o=a[l])&&t.call(o,o.__data__,l,a)&&s.push(o);return new $(r,this._parents)},data:function(t,n){if(!t)return y=new Array(this.size()),h=-1,this.each((function(t){y[++h]=t})),y;var e,r=n?s:c,i=this._parents,u=this._groups;"function"!=typeof t&&(e=t,t=function(){return e});for(var o=u.length,a=new Array(o),l=new Array(o),f=new Array(o),h=0;h<o;++h){var d=i[h],_=u[h],p=_.length,y=t.call(d,d&&d.__data__,h,i),v=y.length,g=l[h]=new Array(v),m=a[h]=new Array(v);r(d,_,g,m,f[h]=new Array(p),y,n);for(var x,b,w=0,M=0;w<v;++w)if(x=g[w]){for(w>=M&&(M=w+1);!(b=m[M])&&++M<v;);x._next=b||null}}return(a=new $(a,i))._enter=l,a._exit=f,a},enter:function(){return new $(this._enter||this._groups.map(o),this._parents)},exit:function(){return new $(this._exit||this._groups.map(o),this._parents)},join:function(t,n,e){var r=this.enter(),i=this,u=this.exit();return r="function"==typeof t?t(r):r.append(t+""),null!=n&&(i=n(i)),null==e?u.remove():e(u),r&&i?r.merge(i).order():i},merge:function(t){for(var n=this._groups,e=t._groups,r=n.length,i=e.length,u=Math.min(r,i),o=new Array(r),a=0;a<u;++a)for(var c,s=n[a],l=e[a],f=s.length,h=o[a]=new Array(f),d=0;d<f;++d)(c=s[d]||l[d])&&(h[d]=c);for(;a<r;++a)o[a]=n[a];return new $(o,this._parents)},order:function(){for(var t=this._groups,n=-1,e=t.length;++n<e;)for(var r,i=t[n],u=i.length-1,o=i[u];--u>=0;)(r=i[u])&&(o&&4^r.compareDocumentPosition(o)&&o.parentNode.insertBefore(r,o),o=r);return this},sort:function(t){function n(n,e){return n&&e?t(n.__data__,e.__data__):!n-!e}t||(t=l);for(var e=this._groups,r=e.length,i=new Array(r),u=0;u<r;++u){for(var o,a=e[u],c=a.length,s=i[u]=new Array(c),f=0;f<c;++f)(o=a[f])&&(s[f]=o);s.sort(n)}return new $(i,this._parents).order()},call:function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this},nodes:function(){var t=new Array(this.size()),n=-1;return this.each((function(){t[++n]=this})),t},node:function(){for(var t=this._groups,n=0,e=t.length;n<e;++n)for(var r=t[n],i=0,u=r.length;i<u;++i){var o=r[i];if(o)return o}return null},size:function(){var t=0;return this.each((function(){++t})),t},empty:function(){return!this.node()},each:function(t){for(var n=this._groups,e=0,r=n.length;e<r;++e)for(var i,u=n[e],o=0,a=u.length;o<a;++o)(i=u[o])&&t.call(i,i.__data__,o,u);return this},attr:function(t,n){var e=Object(f.a)(t);if(arguments.length<2){var r=this.node();return e.local?r.getAttributeNS(e.space,e.local):r.getAttribute(e)}return this.each((null==n?e.local?d:h:"function"==typeof n?e.local?v:y:e.local?p:_)(e,n))},style:g.a,property:function(t,n){return arguments.length>1?this.each((null==n?m:"function"==typeof n?b:x)(t,n)):this.node()[t]},classed:function(t,n){var e=w(t+"");if(arguments.length<2){for(var r=M(this.node()),i=-1,u=e.length;++i<u;)if(!r.contains(e[i]))return!1;return!0}return this.each(("function"==typeof n?j:n?A:N)(e,n))},text:function(t){return arguments.length?this.each(null==t?k:("function"==typeof t?E:C)(t)):this.node().textContent},html:function(t){return arguments.length?this.each(null==t?D:("function"==typeof t?F:U)(t)):this.node().innerHTML},raise:function(){return this.each(P)},lower:function(){return this.each(Y)},append:function(t){var n="function"==typeof t?t:Object(I.a)(t);return this.select((function(){return this.appendChild(n.apply(this,arguments))}))},insert:function(t,n){var e="function"==typeof t?t:Object(I.a)(t),i=null==n?L:"function"==typeof n?n:Object(r.a)(n);return this.select((function(){return this.insertBefore(e.apply(this,arguments),i.apply(this,arguments)||null)}))},remove:function(){return this.each(H)},clone:function(t){return this.select(t?R:q)},datum:function(t){return arguments.length?this.property("__data__",t):this.node().__data__},on:B.b,dispatch:function(t,n){return this.each(("function"==typeof n?V:W)(t,n))}};n.b=Q},function(t,n,e){"use strict";e.d(n,"c",(function(){return u})),e.d(n,"b",(function(){return o})),e.d(n,"a",(function(){return a}));var r=e(23);function i(t,n){return function(e){return t+e*n}}function u(t,n){var e=n-t;return e?i(t,e>180||e<-180?e-360*Math.round(e/360):e):Object(r.a)(isNaN(t)?n:t)}function o(t){return 1==(t=+t)?a:function(n,e){return e-n?function(t,n,e){return t=Math.pow(t,e),n=Math.pow(n,e)-t,e=1/e,function(r){return Math.pow(t+r*n,e)}}(n,e,t):Object(r.a)(isNaN(n)?e:n)}}function a(t,n){var e=n-t;return e?i(t,e):Object(r.a)(isNaN(t)?n:t)}},function(t,n,e){"use strict";function r(t,n){var e=Object.create(t.prototype);for(var r in n)e[r]=n[r];return e}e.d(n,"b",(function(){return r})),n.a=function(t,n,e){t.prototype=n.prototype=e,e.constructor=t}},function(t,n,e){"use strict";var r=e(20),i=e(14);function u(t){return function(){var n=this.ownerDocument,e=this.namespaceURI;return e===i.b&&n.documentElement.namespaceURI===i.b?n.createElement(t):n.createElementNS(e,t)}}function o(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}n.a=function(t){var n=Object(r.a)(t);return(n.local?o:u)(n)}},function(t,n,e){"use strict";n.a=function(t,n){var e=t.ownerSVGElement||t;if(e.createSVGPoint){var r=e.createSVGPoint();return r.x=n.clientX,r.y=n.clientY,[(r=r.matrixTransform(t.getScreenCTM().inverse())).x,r.y]}var i=t.getBoundingClientRect();return[n.clientX-i.left-t.clientLeft,n.clientY-i.top-t.clientTop]}},function(t,n,e){"use strict";e.d(n,"b",(function(){return r}));var r="http://www.w3.org/1999/xhtml";n.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=Object(r.a)((function(t){t.setMonth(0,1),t.setHours(0,0,0,0)}),(function(t,n){t.setFullYear(t.getFullYear()+n)}),(function(t,n){return n.getFullYear()-t.getFullYear()}),(function(t){return t.getFullYear()}));i.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)((function(n){n.setFullYear(Math.floor(n.getFullYear()/t)*t),n.setMonth(0,1),n.setHours(0,0,0,0)}),(function(n,e){n.setFullYear(n.getFullYear()+e*t)})):null},n.a=i;var u=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=Object(r.a)((function(t){t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCFullYear(t.getUTCFullYear()+n)}),(function(t,n){return n.getUTCFullYear()-t.getUTCFullYear()}),(function(t){return t.getUTCFullYear()}));i.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)((function(n){n.setUTCFullYear(Math.floor(n.getUTCFullYear()/t)*t),n.setUTCMonth(0,1),n.setUTCHours(0,0,0,0)}),(function(n,e){n.setUTCFullYear(n.getUTCFullYear()+e*t)})):null},n.a=i;var u=i.range},function(t,n,e){"use strict";e.d(n,"c",(function(){return i})),e.d(n,"a",(function(){return l}));var r={},i=null;"undefined"!=typeof document&&("onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"}));function u(t,n,e){return t=o(t,n,e),function(n){var e=n.relatedTarget;e&&(e===this||8&e.compareDocumentPosition(this))||t.call(this,n)}}function o(t,n,e){return function(r){var u=i;i=r;try{t.call(this,this.__data__,n,e)}finally{i=u}}}function a(t){return t.trim().split(/^|\s+/).map((function(t){var n="",e=t.indexOf(".");return e>=0&&(n=t.slice(e+1),t=t.slice(0,e)),{type:t,name:n}}))}function c(t){return function(){var n=this.__on;if(n){for(var e,r=0,i=-1,u=n.length;r<u;++r)e=n[r],t.type&&e.type!==t.type||e.name!==t.name?n[++i]=e:this.removeEventListener(e.type,e.listener,e.capture);++i?n.length=i:delete this.__on}}}function s(t,n,e){var i=r.hasOwnProperty(t.type)?u:o;return function(r,u,o){var a,c=this.__on,s=i(n,u,o);if(c)for(var l=0,f=c.length;l<f;++l)if((a=c[l]).type===t.type&&a.name===t.name)return this.removeEventListener(a.type,a.listener,a.capture),this.addEventListener(a.type,a.listener=s,a.capture=e),void(a.value=n);this.addEventListener(t.type,s,e),a={type:t.type,name:t.name,value:n,listener:s,capture:e},c?c.push(a):this.__on=[a]}}function l(t,n,e,r){var u=i;t.sourceEvent=i,i=t;try{return n.apply(e,r)}finally{i=u}}n.b=function(t,n,e){var r,i,u=a(t+""),o=u.length;if(!(arguments.length<2)){for(l=n?s:c,null==e&&(e=!1),r=0;r<o;++r)this.each(l(u[r],n,e));return this}var l=this.node().__on;if(l)for(var f,h=0,d=l.length;h<d;++h)for(r=0,f=l[h];r<o;++r)if((i=u[r]).type===f.type&&i.name===f.name)return f.value}},function(t,n,e){"use strict";n.a=function(t,n){if((e=(t=n?t.toExponential(n-1):t.toExponential()).indexOf("e"))<0)return null;var e,r=t.slice(0,e);return[r.length>1?r[0]+r.slice(2):r,+t.slice(e+1)]}},function(t,n,e){"use strict";function r(){}n.a=function(t){return null==t?r:function(){return this.querySelector(t)}}},function(t,n,e){"use strict";var r=e(14);n.a=function(t){var n=t+="",e=n.indexOf(":");return e>=0&&"xmlns"!==(n=t.slice(0,e))&&(t=t.slice(e+1)),r.a.hasOwnProperty(n)?{space:r.a[n],local:t}:t}},function(t,n,e){"use strict";n.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,n,e){"use strict";var r=e(17);n.a=function(){for(var t,n=r.c;t=n.sourceEvent;)n=t;return n}},function(t,n,e){"use strict";n.a=function(t){return function(){return t}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"a",(function(){return u}));var r=/^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;function i(t){if(!(n=r.exec(t)))throw new Error("invalid format: "+t);var n;return new u({fill:n[1],align:n[2],sign:n[3],symbol:n[4],zero:n[5],width:n[6],comma:n[7],precision:n[8]&&n[8].slice(1),trim:n[9],type:n[10]})}function u(t){this.fill=void 0===t.fill?" ":t.fill+"",this.align=void 0===t.align?">":t.align+"",this.sign=void 0===t.sign?"-":t.sign+"",this.symbol=void 0===t.symbol?"":t.symbol+"",this.zero=!!t.zero,this.width=void 0===t.width?void 0:+t.width,this.comma=!!t.comma,this.precision=void 0===t.precision?void 0:+t.precision,this.trim=!!t.trim,this.type=void 0===t.type?"":t.type+""}i.prototype=u.prototype,u.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(void 0===this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(void 0===this.precision?"":"."+Math.max(0,0|this.precision))+(this.trim?"~":"")+this.type}},,function(t,n,e){"use strict";function r(t,n,e,r,i){var u=t*t,o=u*t;return((1-3*t+3*u-o)*n+(4-6*u+3*o)*e+(1+3*t+3*u-3*o)*r+o*i)/6}e.d(n,"a",(function(){return r})),n.b=function(t){var n=t.length-1;return function(e){var i=e<=0?e=0:e>=1?(e=1,n-1):Math.floor(e*n),u=t[i],o=t[i+1],a=i>0?t[i-1]:2*u-o,c=i<n-1?t[i+2]:2*o-u;return r((e-i/n)*n,a,u,o,c)}}},function(t,n,e){"use strict";e.d(n,"a",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(t){t.setHours(0,0,0,0)}),(function(t,n){t.setDate(t.getDate()+n)}),(function(t,n){return(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*i.c)/i.a}),(function(t){return t.getDate()-1}));n.b=u;var o=u.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(t){t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCDate(t.getUTCDate()+n)}),(function(t,n){return(n-t)/i.a}),(function(t){return t.getUTCDate()-1}));n.a=u;var o=u.range},function(t,n,e){"use strict";function r(t){return t*t*t}function i(t){return--t*t*t+1}function u(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.d(n,"a",(function(){return r})),e.d(n,"c",(function(){return i})),e.d(n,"b",(function(){return u}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds())}),(function(t,n){t.setTime(+t+n*i.d)}),(function(t,n){return(n-t)/i.d}),(function(t){return t.getUTCSeconds()}));n.a=u;var o=u.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=Object(r.a)((function(){}),(function(t,n){t.setTime(+t+n)}),(function(t,n){return n-t}));i.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?Object(r.a)((function(n){n.setTime(Math.floor(n/t)*t)}),(function(n,e){n.setTime(+n+e*t)}),(function(n,e){return(e-n)/t})):i:null},n.a=i;var u=i.range},function(t,n,e){"use strict";var r=e(9);n.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,n,e){"use strict";function r(){return[]}n.a=function(t){return null==t?r:function(){return this.querySelectorAll(t)}}},function(t,n,e){"use strict";n.a=function(t){return function(){return this.matches(t)}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return a}));var r=e(21);function i(t){return function(){this.style.removeProperty(t)}}function u(t,n,e){return function(){this.style.setProperty(t,n,e)}}function o(t,n,e){return function(){var r=n.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,e)}}function a(t,n){return t.style.getPropertyValue(n)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(n)}n.a=function(t,n,e){return arguments.length>1?this.each((null==n?i:"function"==typeof n?o:u)(t,n,null==e?"":e)):a(this.node(),t)}},,function(t,n,e){"use strict";var r,i=e(8),u=e(24),o=e(18),a=function(t,n){var e=Object(o.a)(t,n);if(!e)return t+"";var r=e[0],i=e[1];return i<0?"0."+new Array(-i).join("0")+r:r.length>i+1?r.slice(0,i+1)+"."+r.slice(i+1):r+new Array(i-r.length+2).join("0")},c={"%":function(t,n){return(100*t).toFixed(n)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,n){return t.toExponential(n)},f:function(t,n){return t.toFixed(n)},g:function(t,n){return t.toPrecision(n)},o:function(t){return Math.round(t).toString(8)},p:function(t,n){return a(100*t,n)},r:a,s:function(t,n){var e=Object(o.a)(t,n);if(!e)return t+"";var i=e[0],u=e[1],a=u-(r=3*Math.max(-8,Math.min(8,Math.floor(u/3))))+1,c=i.length;return a===c?i:a>c?i+new Array(a-c+1).join("0"):a>0?i.slice(0,a)+"."+i.slice(a):"0."+new Array(1-a).join("0")+Object(o.a)(t,Math.max(0,n+a-1))[0]},X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}},s=function(t){return t},l=Array.prototype.map,f=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];n.a=function(t){var n,e,o=void 0===t.grouping||void 0===t.thousands?s:(n=l.call(t.grouping,Number),e=t.thousands+"",function(t,r){for(var i=t.length,u=[],o=0,a=n[0],c=0;i>0&&a>0&&(c+a+1>r&&(a=Math.max(1,r-c)),u.push(t.substring(i-=a,i+a)),!((c+=a+1)>r));)a=n[o=(o+1)%n.length];return u.reverse().join(e)}),a=void 0===t.currency?"":t.currency[0]+"",h=void 0===t.currency?"":t.currency[1]+"",d=void 0===t.decimal?".":t.decimal+"",_=void 0===t.numerals?s:function(t){return function(n){return n.replace(/[0-9]/g,(function(n){return t[+n]}))}}(l.call(t.numerals,String)),p=void 0===t.percent?"%":t.percent+"",y=void 0===t.minus?"-":t.minus+"",v=void 0===t.nan?"NaN":t.nan+"";function g(t){var n=(t=Object(u.b)(t)).fill,e=t.align,i=t.sign,s=t.symbol,l=t.zero,g=t.width,m=t.comma,x=t.precision,b=t.trim,w=t.type;"n"===w?(m=!0,w="g"):c[w]||(void 0===x&&(x=12),b=!0,w="g"),(l||"0"===n&&"="===e)&&(l=!0,n="0",e="=");var M="$"===s?a:"#"===s&&/[boxX]/.test(w)?"0"+w.toLowerCase():"",T="$"===s?h:/[%p]/.test(w)?p:"",O=c[w],S=/[defgprs%]/.test(w);function A(t){var u,a,c,s=M,h=T;if("c"===w)h=O(t)+h,t="";else{var p=(t=+t)<0;if(t=isNaN(t)?v:O(Math.abs(t),x),b&&(t=function(t){t:for(var n,e=t.length,r=1,i=-1;r<e;++r)switch(t[r]){case".":i=n=r;break;case"0":0===i&&(i=r),n=r;break;default:if(!+t[r])break t;i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}(t)),p&&0==+t&&(p=!1),s=(p?"("===i?i:y:"-"===i||"("===i?"":i)+s,h=("s"===w?f[8+r/3]:"")+h+(p&&"("===i?")":""),S)for(u=-1,a=t.length;++u<a;)if(48>(c=t.charCodeAt(u))||c>57){h=(46===c?d+t.slice(u+1):t.slice(u))+h,t=t.slice(0,u);break}}m&&!l&&(t=o(t,1/0));var A=s.length+t.length+h.length,N=A<g?new Array(g-A+1).join(n):"";switch(m&&l&&(t=o(N+t,N.length?g-h.length:1/0),N=""),e){case"<":t=s+t+h+N;break;case"=":t=s+N+t+h;break;case"^":t=N.slice(0,A=N.length>>1)+s+t+h+N.slice(A);break;default:t=N+s+t+h}return _(t)}return x=void 0===x?6:/[gprs]/.test(w)?Math.max(1,Math.min(21,x)):Math.max(0,Math.min(20,x)),A.toString=function(){return t+""},A}return{format:g,formatPrefix:function(t,n){var e=g(((t=Object(u.b)(t)).type="f",t)),r=3*Math.max(-8,Math.min(8,Math.floor(Object(i.a)(n)/3))),o=Math.pow(10,-r),a=f[8+r/3];return function(t){return e(o*t)+a}}}}},function(t,n,e){"use strict";e.r(n);var r=e(0);e.d(n,"timeInterval",(function(){return r.a}));var i=e(31);e.d(n,"timeMillisecond",(function(){return i.a})),e.d(n,"timeMilliseconds",(function(){return i.b})),e.d(n,"utcMillisecond",(function(){return i.a})),e.d(n,"utcMilliseconds",(function(){return i.b}));var u=e(30);e.d(n,"timeSecond",(function(){return u.a})),e.d(n,"timeSeconds",(function(){return u.b})),e.d(n,"utcSecond",(function(){return u.a})),e.d(n,"utcSeconds",(function(){return u.b}));var o=e(49);e.d(n,"timeMinute",(function(){return o.a})),e.d(n,"timeMinutes",(function(){return o.b}));var a=e(48);e.d(n,"timeHour",(function(){return a.a})),e.d(n,"timeHours",(function(){return a.b}));var c=e(27);e.d(n,"timeDay",(function(){return c.b})),e.d(n,"timeDays",(function(){return c.a}));var s=e(3);e.d(n,"timeWeek",(function(){return s.g})),e.d(n,"timeWeeks",(function(){return s.h})),e.d(n,"timeSunday",(function(){return s.g})),e.d(n,"timeSundays",(function(){return s.h})),e.d(n,"timeMonday",(function(){return s.c})),e.d(n,"timeMondays",(function(){return s.d})),e.d(n,"timeTuesday",(function(){return s.k})),e.d(n,"timeTuesdays",(function(){return s.l})),e.d(n,"timeWednesday",(function(){return s.m})),e.d(n,"timeWednesdays",(function(){return s.n})),e.d(n,"timeThursday",(function(){return s.i})),e.d(n,"timeThursdays",(function(){return s.j})),e.d(n,"timeFriday",(function(){return s.a})),e.d(n,"timeFridays",(function(){return s.b})),e.d(n,"timeSaturday",(function(){return s.e})),e.d(n,"timeSaturdays",(function(){return s.f}));var l=e(47);e.d(n,"timeMonth",(function(){return l.a})),e.d(n,"timeMonths",(function(){return l.b}));var f=e(15);e.d(n,"timeYear",(function(){return f.a})),e.d(n,"timeYears",(function(){return f.b}));var h=e(52);e.d(n,"utcMinute",(function(){return h.a})),e.d(n,"utcMinutes",(function(){return h.b}));var d=e(51);e.d(n,"utcHour",(function(){return d.a})),e.d(n,"utcHours",(function(){return d.b}));var _=e(28);e.d(n,"utcDay",(function(){return _.a})),e.d(n,"utcDays",(function(){return _.b}));var p=e(4);e.d(n,"utcWeek",(function(){return p.g})),e.d(n,"utcWeeks",(function(){return p.h})),e.d(n,"utcSunday",(function(){return p.g})),e.d(n,"utcSundays",(function(){return p.h})),e.d(n,"utcMonday",(function(){return p.c})),e.d(n,"utcMondays",(function(){return p.d})),e.d(n,"utcTuesday",(function(){return p.k})),e.d(n,"utcTuesdays",(function(){return p.l})),e.d(n,"utcWednesday",(function(){return p.m})),e.d(n,"utcWednesdays",(function(){return p.n})),e.d(n,"utcThursday",(function(){return p.i})),e.d(n,"utcThursdays",(function(){return p.j})),e.d(n,"utcFriday",(function(){return p.a})),e.d(n,"utcFridays",(function(){return p.b})),e.d(n,"utcSaturday",(function(){return p.e})),e.d(n,"utcSaturdays",(function(){return p.f}));var y=e(50);e.d(n,"utcMonth",(function(){return y.a})),e.d(n,"utcMonths",(function(){return y.b}));var v=e(16);e.d(n,"utcYear",(function(){return v.a})),e.d(n,"utcYears",(function(){return v.b}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return c})),e.d(n,"c",(function(){return s}));var r=e(7),i=e(26),u=e(53),o=e(10);function a(t){return function(n){var e,i,u=n.length,o=new Array(u),a=new Array(u),c=new Array(u);for(e=0;e<u;++e)i=Object(r.g)(n[e]),o[e]=i.r||0,a[e]=i.g||0,c[e]=i.b||0;return o=t(o),a=t(a),c=t(c),i.opacity=1,function(t){return i.r=o(t),i.g=a(t),i.b=c(t),i+""}}}n.a=function t(n){var e=Object(o.b)(n);function i(t,n){var i=e((t=Object(r.g)(t)).r,(n=Object(r.g)(n)).r),u=e(t.g,n.g),a=e(t.b,n.b),c=Object(o.a)(t.opacity,n.opacity);return function(n){return t.r=i(n),t.g=u(n),t.b=a(n),t.opacity=c(n),t+""}}return i.gamma=t,i}(1);var c=a(i.b),s=a(u.a)},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"c",(function(){return u})),e.d(n,"a",(function(){return a}));var r,i,u,o=e(37);function a(t){return r=Object(o.a)(t),i=r.format,u=r.formatPrefix,r}a({decimal:".",thousands:",",grouping:[3],currency:["$",""],minus:"-"})},,,,function(t,n,e){"use strict";e.r(n);var r=e(40);e.d(n,"formatDefaultLocale",(function(){return r.a})),e.d(n,"format",(function(){return r.b})),e.d(n,"formatPrefix",(function(){return r.c}));var i=e(37);e.d(n,"formatLocale",(function(){return i.a}));var u=e(24);e.d(n,"formatSpecifier",(function(){return u.b})),e.d(n,"FormatSpecifier",(function(){return u.a}));var o=e(61);e.d(n,"precisionFixed",(function(){return o.a}));var a=e(62);e.d(n,"precisionPrefix",(function(){return a.a}));var c=e(63);e.d(n,"precisionRound",(function(){return c.a}))},,function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"c",(function(){return u})),e.d(n,"d",(function(){return o})),e.d(n,"e",(function(){return a})),e.d(n,"a",(function(){return s}));var r,i,u,o,a,c=e(54);function s(t){return r=Object(c.a)(t),i=r.format,u=r.parse,o=r.utcFormat,a=r.utcParse,r}s({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=Object(r.a)((function(t){t.setDate(1),t.setHours(0,0,0,0)}),(function(t,n){t.setMonth(t.getMonth()+n)}),(function(t,n){return n.getMonth()-t.getMonth()+12*(n.getFullYear()-t.getFullYear())}),(function(t){return t.getMonth()}));n.a=i;var u=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds()-t.getSeconds()*i.d-t.getMinutes()*i.c)}),(function(t,n){t.setTime(+t+n*i.b)}),(function(t,n){return(n-t)/i.b}),(function(t){return t.getHours()}));n.a=u;var o=u.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds()-t.getSeconds()*i.d)}),(function(t,n){t.setTime(+t+n*i.c)}),(function(t,n){return(n-t)/i.c}),(function(t){return t.getMinutes()}));n.a=u;var o=u.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=Object(r.a)((function(t){t.setUTCDate(1),t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCMonth(t.getUTCMonth()+n)}),(function(t,n){return n.getUTCMonth()-t.getUTCMonth()+12*(n.getUTCFullYear()-t.getUTCFullYear())}),(function(t){return t.getUTCMonth()}));n.a=i;var u=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(t){t.setUTCMinutes(0,0,0)}),(function(t,n){t.setTime(+t+n*i.b)}),(function(t,n){return(n-t)/i.b}),(function(t){return t.getUTCHours()}));n.a=u;var o=u.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(t){t.setUTCSeconds(0,0)}),(function(t,n){t.setTime(+t+n*i.c)}),(function(t,n){return(n-t)/i.c}),(function(t){return t.getUTCMinutes()}));n.a=u;var o=u.range},function(t,n,e){"use strict";var r=e(26);n.a=function(t){var n=t.length;return function(e){var i=Math.floor(((e%=1)<0?++e:e)*n),u=t[(i+n-1)%n],o=t[i%n],a=t[(i+1)%n],c=t[(i+2)%n];return Object(r.a)((e-i/n)*n,u,o,a,c)}}},function(t,n,e){"use strict";e.d(n,"a",(function(){return h}));var r=e(4),i=e(28),u=e(3),o=e(27),a=e(15),c=e(16);function s(t){if(0<=t.y&&t.y<100){var n=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return n.setFullYear(t.y),n}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function l(t){if(0<=t.y&&t.y<100){var n=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return n.setUTCFullYear(t.y),n}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function f(t,n,e){return{y:t,m:n,d:e,H:0,M:0,S:0,L:0}}function h(t){var n=t.dateTime,e=t.date,a=t.time,c=t.periods,h=t.days,_=t.shortDays,p=t.months,y=t.shortMonths,v=m(c),g=x(c),Tt=m(h),Ot=x(h),St=m(_),At=x(_),Nt=m(p),jt=x(p),kt=m(y),Ct=x(y),Et={a:function(t){return _[t.getDay()]},A:function(t){return h[t.getDay()]},b:function(t){return y[t.getMonth()]},B:function(t){return p[t.getMonth()]},c:null,d:q,e:q,f:W,H:R,I:B,j:z,L:X,m:V,M:Z,p:function(t){return c[+(t.getHours()>=12)]},q:function(t){return 1+~~(t.getMonth()/3)},Q:wt,s:Mt,S:$,u:Q,U:G,V:J,w:K,W:tt,x:null,X:null,y:nt,Y:et,Z:rt,"%":bt},Dt={a:function(t){return _[t.getUTCDay()]},A:function(t){return h[t.getUTCDay()]},b:function(t){return y[t.getUTCMonth()]},B:function(t){return p[t.getUTCMonth()]},c:null,d:it,e:it,f:st,H:ut,I:ot,j:at,L:ct,m:lt,M:ft,p:function(t){return c[+(t.getUTCHours()>=12)]},q:function(t){return 1+~~(t.getUTCMonth()/3)},Q:wt,s:Mt,S:ht,u:dt,U:_t,V:pt,w:yt,W:vt,x:null,X:null,y:gt,Y:mt,Z:xt,"%":bt},Ut={a:function(t,n,e){var r=St.exec(n.slice(e));return r?(t.w=At[r[0].toLowerCase()],e+r[0].length):-1},A:function(t,n,e){var r=Tt.exec(n.slice(e));return r?(t.w=Ot[r[0].toLowerCase()],e+r[0].length):-1},b:function(t,n,e){var r=kt.exec(n.slice(e));return r?(t.m=Ct[r[0].toLowerCase()],e+r[0].length):-1},B:function(t,n,e){var r=Nt.exec(n.slice(e));return r?(t.m=jt[r[0].toLowerCase()],e+r[0].length):-1},c:function(t,e,r){return Yt(t,n,e,r)},d:C,e:C,f:Y,H:D,I:D,j:E,L:P,m:k,M:U,p:function(t,n,e){var r=v.exec(n.slice(e));return r?(t.p=g[r[0].toLowerCase()],e+r[0].length):-1},q:j,Q:L,s:H,S:F,u:w,U:M,V:T,w:b,W:O,x:function(t,n,r){return Yt(t,e,n,r)},X:function(t,n,e){return Yt(t,a,n,e)},y:A,Y:S,Z:N,"%":I};function Ft(t,n){return function(e){var r,i,u,o=[],a=-1,c=0,s=t.length;for(e instanceof Date||(e=new Date(+e));++a<s;)37===t.charCodeAt(a)&&(o.push(t.slice(c,a)),null!=(i=d[r=t.charAt(++a)])?r=t.charAt(++a):i="e"===r?" ":"0",(u=n[r])&&(r=u(e,i)),o.push(r),c=a+1);return o.push(t.slice(c,a)),o.join("")}}function Pt(t,n){return function(e){var a,c,h=f(1900,void 0,1);if(Yt(h,t,e+="",0)!=e.length)return null;if("Q"in h)return new Date(h.Q);if("s"in h)return new Date(1e3*h.s+("L"in h?h.L:0));if(!n||"Z"in h||(h.Z=0),"p"in h&&(h.H=h.H%12+12*h.p),void 0===h.m&&(h.m="q"in h?h.q:0),"V"in h){if(h.V<1||h.V>53)return null;"w"in h||(h.w=1),"Z"in h?(c=(a=l(f(h.y,0,1))).getUTCDay(),a=c>4||0===c?r.c.ceil(a):Object(r.c)(a),a=i.a.offset(a,7*(h.V-1)),h.y=a.getUTCFullYear(),h.m=a.getUTCMonth(),h.d=a.getUTCDate()+(h.w+6)%7):(c=(a=s(f(h.y,0,1))).getDay(),a=c>4||0===c?u.c.ceil(a):Object(u.c)(a),a=o.b.offset(a,7*(h.V-1)),h.y=a.getFullYear(),h.m=a.getMonth(),h.d=a.getDate()+(h.w+6)%7)}else("W"in h||"U"in h)&&("w"in h||(h.w="u"in h?h.u%7:"W"in h?1:0),c="Z"in h?l(f(h.y,0,1)).getUTCDay():s(f(h.y,0,1)).getDay(),h.m=0,h.d="W"in h?(h.w+6)%7+7*h.W-(c+5)%7:h.w+7*h.U-(c+6)%7);return"Z"in h?(h.H+=h.Z/100|0,h.M+=h.Z%100,l(h)):s(h)}}function Yt(t,n,e,r){for(var i,u,o=0,a=n.length,c=e.length;o<a;){if(r>=c)return-1;if(37===(i=n.charCodeAt(o++))){if(i=n.charAt(o++),!(u=Ut[i in d?n.charAt(o++):i])||(r=u(t,e,r))<0)return-1}else if(i!=e.charCodeAt(r++))return-1}return r}return(Et.x=Ft(e,Et),Et.X=Ft(a,Et),Et.c=Ft(n,Et),Dt.x=Ft(e,Dt),Dt.X=Ft(a,Dt),Dt.c=Ft(n,Dt),{format:function(t){var n=Ft(t+="",Et);return n.toString=function(){return t},n},parse:function(t){var n=Pt(t+="",!1);return n.toString=function(){return t},n},utcFormat:function(t){var n=Ft(t+="",Dt);return n.toString=function(){return t},n},utcParse:function(t){var n=Pt(t+="",!0);return n.toString=function(){return t},n}})}var d={"-":"",_:" ",0:"0"},_=/^\s*\d+/,p=/^%/,y=/[\\^$*+?|[\]().{}]/g;function v(t,n,e){var r=t<0?"-":"",i=(r?-t:t)+"",u=i.length;return r+(u<e?new Array(e-u+1).join(n)+i:i)}function g(t){return t.replace(y,"\\$&")}function m(t){return new RegExp("^(?:"+t.map(g).join("|")+")","i")}function x(t){for(var n={},e=-1,r=t.length;++e<r;)n[t[e].toLowerCase()]=e;return n}function b(t,n,e){var r=_.exec(n.slice(e,e+1));return r?(t.w=+r[0],e+r[0].length):-1}function w(t,n,e){var r=_.exec(n.slice(e,e+1));return r?(t.u=+r[0],e+r[0].length):-1}function M(t,n,e){var r=_.exec(n.slice(e,e+2));return r?(t.U=+r[0],e+r[0].length):-1}function T(t,n,e){var r=_.exec(n.slice(e,e+2));return r?(t.V=+r[0],e+r[0].length):-1}function O(t,n,e){var r=_.exec(n.slice(e,e+2));return r?(t.W=+r[0],e+r[0].length):-1}function S(t,n,e){var r=_.exec(n.slice(e,e+4));return r?(t.y=+r[0],e+r[0].length):-1}function A(t,n,e){var r=_.exec(n.slice(e,e+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),e+r[0].length):-1}function N(t,n,e){var r=/^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(n.slice(e,e+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),e+r[0].length):-1}function j(t,n,e){var r=_.exec(n.slice(e,e+1));return r?(t.q=3*r[0]-3,e+r[0].length):-1}function k(t,n,e){var r=_.exec(n.slice(e,e+2));return r?(t.m=r[0]-1,e+r[0].length):-1}function C(t,n,e){var r=_.exec(n.slice(e,e+2));return r?(t.d=+r[0],e+r[0].length):-1}function E(t,n,e){var r=_.exec(n.slice(e,e+3));return r?(t.m=0,t.d=+r[0],e+r[0].length):-1}function D(t,n,e){var r=_.exec(n.slice(e,e+2));return r?(t.H=+r[0],e+r[0].length):-1}function U(t,n,e){var r=_.exec(n.slice(e,e+2));return r?(t.M=+r[0],e+r[0].length):-1}function F(t,n,e){var r=_.exec(n.slice(e,e+2));return r?(t.S=+r[0],e+r[0].length):-1}function P(t,n,e){var r=_.exec(n.slice(e,e+3));return r?(t.L=+r[0],e+r[0].length):-1}function Y(t,n,e){var r=_.exec(n.slice(e,e+6));return r?(t.L=Math.floor(r[0]/1e3),e+r[0].length):-1}function I(t,n,e){var r=p.exec(n.slice(e,e+1));return r?e+r[0].length:-1}function L(t,n,e){var r=_.exec(n.slice(e));return r?(t.Q=+r[0],e+r[0].length):-1}function H(t,n,e){var r=_.exec(n.slice(e));return r?(t.s=+r[0],e+r[0].length):-1}function q(t,n){return v(t.getDate(),n,2)}function R(t,n){return v(t.getHours(),n,2)}function B(t,n){return v(t.getHours()%12||12,n,2)}function z(t,n){return v(1+o.b.count(Object(a.a)(t),t),n,3)}function X(t,n){return v(t.getMilliseconds(),n,3)}function W(t,n){return X(t,n)+"000"}function V(t,n){return v(t.getMonth()+1,n,2)}function Z(t,n){return v(t.getMinutes(),n,2)}function $(t,n){return v(t.getSeconds(),n,2)}function Q(t){var n=t.getDay();return 0===n?7:n}function G(t,n){return v(u.g.count(Object(a.a)(t)-1,t),n,2)}function J(t,n){var e=t.getDay();return t=e>=4||0===e?Object(u.i)(t):u.i.ceil(t),v(u.i.count(Object(a.a)(t),t)+(4===Object(a.a)(t).getDay()),n,2)}function K(t){return t.getDay()}function tt(t,n){return v(u.c.count(Object(a.a)(t)-1,t),n,2)}function nt(t,n){return v(t.getFullYear()%100,n,2)}function et(t,n){return v(t.getFullYear()%1e4,n,4)}function rt(t){var n=t.getTimezoneOffset();return(n>0?"-":(n*=-1,"+"))+v(n/60|0,"0",2)+v(n%60,"0",2)}function it(t,n){return v(t.getUTCDate(),n,2)}function ut(t,n){return v(t.getUTCHours(),n,2)}function ot(t,n){return v(t.getUTCHours()%12||12,n,2)}function at(t,n){return v(1+i.a.count(Object(c.a)(t),t),n,3)}function ct(t,n){return v(t.getUTCMilliseconds(),n,3)}function st(t,n){return ct(t,n)+"000"}function lt(t,n){return v(t.getUTCMonth()+1,n,2)}function ft(t,n){return v(t.getUTCMinutes(),n,2)}function ht(t,n){return v(t.getUTCSeconds(),n,2)}function dt(t){var n=t.getUTCDay();return 0===n?7:n}function _t(t,n){return v(r.g.count(Object(c.a)(t)-1,t),n,2)}function pt(t,n){var e=t.getUTCDay();return t=e>=4||0===e?Object(r.i)(t):r.i.ceil(t),v(r.i.count(Object(c.a)(t),t)+(4===Object(c.a)(t).getUTCDay()),n,2)}function yt(t){return t.getUTCDay()}function vt(t,n){return v(r.c.count(Object(c.a)(t)-1,t),n,2)}function gt(t,n){return v(t.getUTCFullYear()%100,n,2)}function mt(t,n){return v(t.getUTCFullYear()%1e4,n,4)}function xt(){return"+0000"}function bt(){return"%"}function wt(t){return+t}function Mt(t){return Math.floor(+t/1e3)}},function(t,n,e){"use strict";var r=e(5),i=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,u=new RegExp(i.source,"g");n.a=function(t,n){var e,o,a,c=i.lastIndex=u.lastIndex=0,s=-1,l=[],f=[];for(t+="",n+="";(e=i.exec(t))&&(o=u.exec(n));)(a=o.index)>c&&(a=n.slice(c,a),l[s]?l[s]+=a:l[++s]=a),(e=e[0])===(o=o[0])?l[s]?l[s]+=o:l[++s]=o:(l[++s]=null,f.push({i:s,x:Object(r.a)(e,o)})),c=u.lastIndex;return c<n.length&&(a=n.slice(c),l[s]?l[s]+=a:l[++s]=a),l.length<2?f[0]?function(t){return function(n){return t(n)+""}}(f[0].x):function(t){return function(){return t}}(n):(n=f.length,function(t){for(var e,r=0;r<n;++r)l[(e=f[r]).i]=e.x(t);return l.join("")})}},,,,function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t){var n=Object(r.a)();return n.changedTouches&&(n=n.changedTouches[0]),Object(i.a)(t,n)}},function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t,n,e){arguments.length<3&&(e=n,n=Object(r.a)().changedTouches);for(var u,o=0,a=n?n.length:0;o<a;++o)if((u=n[o]).identifier===e)return Object(i.a)(t,u);return null}},function(t,n,e){"use strict";var r=e(8);n.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(n)/3)))-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return t=Math.abs(t),n=Math.abs(n)-t,Math.max(0,Object(r.a)(n)-Object(r.a)(t))+1}},function(t,n,e){"use strict";function r(t){return+t}function i(t){return t*t}function u(t){return t*(2-t)}function o(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.r(n);var a=e(29),c=function t(n){function e(t){return Math.pow(t,n)}return n=+n,e.exponent=t,e}(3),s=function t(n){function e(t){return 1-Math.pow(1-t,n)}return n=+n,e.exponent=t,e}(3),l=function t(n){function e(t){return((t*=2)<=1?Math.pow(t,n):2-Math.pow(2-t,n))/2}return n=+n,e.exponent=t,e}(3),f=Math.PI,h=f/2;function d(t){return 1-Math.cos(t*h)}function _(t){return Math.sin(t*h)}function p(t){return(1-Math.cos(f*t))/2}function y(t){return Math.pow(2,10*t-10)}function v(t){return 1-Math.pow(2,-10*t)}function g(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}function m(t){return 1-Math.sqrt(1-t*t)}function x(t){return Math.sqrt(1- --t*t)}function b(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}var w=7.5625;function M(t){return 1-T(1-t)}function T(t){return(t=+t)<4/11?w*t*t:t<8/11?w*(t-=6/11)*t+.75:t<10/11?w*(t-=9/11)*t+.9375:w*(t-=21/22)*t+63/64}function O(t){return((t*=2)<=1?1-T(1-t):T(t-1)+1)/2}var S=function t(n){function e(t){return t*t*((n+1)*t-n)}return n=+n,e.overshoot=t,e}(1.70158),A=function t(n){function e(t){return--t*t*((n+1)*t+n)+1}return n=+n,e.overshoot=t,e}(1.70158),N=function t(n){function e(t){return((t*=2)<1?t*t*((n+1)*t-n):(t-=2)*t*((n+1)*t+n)+2)/2}return n=+n,e.overshoot=t,e}(1.70158),j=2*Math.PI,k=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=j);function i(t){return n*Math.pow(2,10*--t)*Math.sin((r-t)/e)}return i.amplitude=function(n){return t(n,e*j)},i.period=function(e){return t(n,e)},i}(1,.3),C=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=j);function i(t){return 1-n*Math.pow(2,-10*(t=+t))*Math.sin((t+r)/e)}return i.amplitude=function(n){return t(n,e*j)},i.period=function(e){return t(n,e)},i}(1,.3),E=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=j);function i(t){return((t=2*t-1)<0?n*Math.pow(2,10*t)*Math.sin((r-t)/e):2-n*Math.pow(2,-10*t)*Math.sin((r+t)/e))/2}return i.amplitude=function(n){return t(n,e*j)},i.period=function(e){return t(n,e)},i}(1,.3);e.d(n,"easeLinear",(function(){return r})),e.d(n,"easeQuad",(function(){return o})),e.d(n,"easeQuadIn",(function(){return i})),e.d(n,"easeQuadOut",(function(){return u})),e.d(n,"easeQuadInOut",(function(){return o})),e.d(n,"easeCubic",(function(){return a.b})),e.d(n,"easeCubicIn",(function(){return a.a})),e.d(n,"easeCubicOut",(function(){return a.c})),e.d(n,"easeCubicInOut",(function(){return a.b})),e.d(n,"easePoly",(function(){return l})),e.d(n,"easePolyIn",(function(){return c})),e.d(n,"easePolyOut",(function(){return s})),e.d(n,"easePolyInOut",(function(){return l})),e.d(n,"easeSin",(function(){return p})),e.d(n,"easeSinIn",(function(){return d})),e.d(n,"easeSinOut",(function(){return _})),e.d(n,"easeSinInOut",(function(){return p})),e.d(n,"easeExp",(function(){return g})),e.d(n,"easeExpIn",(function(){return y})),e.d(n,"easeExpOut",(function(){return v})),e.d(n,"easeExpInOut",(function(){return g})),e.d(n,"easeCircle",(function(){return b})),e.d(n,"easeCircleIn",(function(){return m})),e.d(n,"easeCircleOut",(function(){return x})),e.d(n,"easeCircleInOut",(function(){return b})),e.d(n,"easeBounce",(function(){return T})),e.d(n,"easeBounceIn",(function(){return M})),e.d(n,"easeBounceOut",(function(){return T})),e.d(n,"easeBounceInOut",(function(){return O})),e.d(n,"easeBack",(function(){return N})),e.d(n,"easeBackIn",(function(){return S})),e.d(n,"easeBackOut",(function(){return A})),e.d(n,"easeBackInOut",(function(){return N})),e.d(n,"easeElastic",(function(){return C})),e.d(n,"easeElasticIn",(function(){return k})),e.d(n,"easeElasticOut",(function(){return C})),e.d(n,"easeElasticInOut",(function(){return E}))},,function(t,n,e){"use strict";e.r(n);var r=e(46),i=e(54);var u=Date.prototype.toISOString?function(t){return t.toISOString()}:Object(r.d)("%Y-%m-%dT%H:%M:%S.%LZ");var o=+new Date("2000-01-01T00:00:00.000Z")?function(t){var n=new Date(t);return isNaN(n)?null:n}:Object(r.e)("%Y-%m-%dT%H:%M:%S.%LZ");e.d(n,"timeFormatDefaultLocale",(function(){return r.a})),e.d(n,"timeFormat",(function(){return r.b})),e.d(n,"timeParse",(function(){return r.c})),e.d(n,"utcFormat",(function(){return r.d})),e.d(n,"utcParse",(function(){return r.e})),e.d(n,"timeFormatLocale",(function(){return i.a})),e.d(n,"isoFormat",(function(){return u})),e.d(n,"isoParse",(function(){return o}))},,,function(t,n,e){"use strict";var r={value:function(){}};function i(){for(var t,n=0,e=arguments.length,r={};n<e;++n){if(!(t=arguments[n]+"")||t in r||/[\s.]/.test(t))throw new Error("illegal type: "+t);r[t]=[]}return new u(r)}function u(t){this._=t}function o(t,n){return t.trim().split(/^|\s+/).map((function(t){var e="",r=t.indexOf(".");if(r>=0&&(e=t.slice(r+1),t=t.slice(0,r)),t&&!n.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:e}}))}function a(t,n){for(var e,r=0,i=t.length;r<i;++r)if((e=t[r]).name===n)return e.value}function c(t,n,e){for(var i=0,u=t.length;i<u;++i)if(t[i].name===n){t[i]=r,t=t.slice(0,i).concat(t.slice(i+1));break}return null!=e&&t.push({name:n,value:e}),t}u.prototype=i.prototype={constructor:u,on:function(t,n){var e,r=this._,i=o(t+"",r),u=-1,s=i.length;if(!(arguments.length<2)){if(null!=n&&"function"!=typeof n)throw new Error("invalid callback: "+n);for(;++u<s;)if(e=(t=i[u]).type)r[e]=c(r[e],t.name,n);else if(null==n)for(e in r)r[e]=c(r[e],t.name,null);return this}for(;++u<s;)if((e=(t=i[u]).type)&&(e=a(r[e],t.name)))return e},copy:function(){var t={},n=this._;for(var e in n)t[e]=n[e].slice();return new u(t)},call:function(t,n){if((e=arguments.length-2)>0)for(var e,r,i=new Array(e),u=0;u<e;++u)i[u]=arguments[u+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(u=0,e=(r=this._[t]).length;u<e;++u)r[u].value.apply(n,i)},apply:function(t,n,e){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],i=0,u=r.length;i<u;++i)r[i].value.apply(n,e)}},n.a=i},function(t,n,e){"use strict";var r;void 0===(r=function(){var t=e(71),n=e(38);return{axisTimeCombinations:{MINUTE_HOUR:"minute-hour",HOUR_DAY:"hour-daymonth",DAY_MONTH:"day-month",MONTH_YEAR:"month-year",CUSTOM:"custom"},curveMap:{linear:t.curveLinear,basis:t.curveBasis,cardinal:t.curveCardinal,catmullRom:t.curveCatmullRom,monotoneX:t.curveMonotoneX,monotoneY:t.curveMonotoneY,natural:t.curveNatural,step:t.curveStep,stepAfter:t.curveStepAfter,stepBefore:t.curveStepBefore},emptyDonutData:[{quantity:1,percentage:100}],hoursHuman:["00h","01h","02h","03h","04h","05h","06h","07h","08h","09h","10h","11h","12h","13h","14h","15h","16h","17h","18h","19h","20h","21h","22h","23h"],timeBenchmarks:{ONE_AND_A_HALF_YEARS:47304e6,ONE_YEAR:31536000365,ONE_DAY:86400001},lineGradientId:"lineGradientId",timeIntervals:{timeMillisecond:n.timeMillisecond,utcMillisecond:n.utcMillisecond,timeSecond:n.timeSecond,utcSecond:n.utcSecond,timeMinute:n.timeMinute,utcMinute:n.utcMinute,timeHour:n.timeHour,utcHour:n.utcHour,timeDay:n.timeDay,utcDay:n.utcDay,timeWeek:n.timeWeek,utcWeek:n.utcWeek,timeSunday:n.timeSunday,utcSunday:n.utcSunday,timeMonday:n.timeMonday,utcMonday:n.utcMonday,timeTuesday:n.timeTuesday,utcTuesday:n.utcTuesday,timeWednesday:n.timeWednesday,utcWednesday:n.utcWednesday,timeThursday:n.timeThursday,utcThursday:n.utcThursday,timeFriday:n.timeFriday,utcFriday:n.utcFriday,timeSaturday:n.timeSaturday,utcSaturday:n.utcSaturday,timeMonth:n.timeMonth,utcMonth:n.utcMonth,timeYear:n.timeYear,utcYear:n.utcYear},FORMAT_LOCALE_URL:"https://cdn.jsdelivr.net/npm/d3-format/locale"}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";e.r(n);var r=Math.PI,i=2*r,u=i-1e-6;function o(){this._x0=this._y0=this._x1=this._y1=null,this._=""}function a(){return new o}o.prototype=a.prototype={constructor:o,moveTo:function(t,n){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+n)},closePath:function(){null!==this._x1&&(this._x1=this._x0,this._y1=this._y0,this._+="Z")},lineTo:function(t,n){this._+="L"+(this._x1=+t)+","+(this._y1=+n)},quadraticCurveTo:function(t,n,e,r){this._+="Q"+ +t+","+ +n+","+(this._x1=+e)+","+(this._y1=+r)},bezierCurveTo:function(t,n,e,r,i,u){this._+="C"+ +t+","+ +n+","+ +e+","+ +r+","+(this._x1=+i)+","+(this._y1=+u)},arcTo:function(t,n,e,i,u){t=+t,n=+n,e=+e,i=+i,u=+u;var o=this._x1,a=this._y1,c=e-t,s=i-n,l=o-t,f=a-n,h=l*l+f*f;if(u<0)throw new Error("negative radius: "+u);if(null===this._x1)this._+="M"+(this._x1=t)+","+(this._y1=n);else if(h>1e-6)if(Math.abs(f*c-s*l)>1e-6&&u){var d=e-o,_=i-a,p=c*c+s*s,y=d*d+_*_,v=Math.sqrt(p),g=Math.sqrt(h),m=u*Math.tan((r-Math.acos((p+h-y)/(2*v*g)))/2),x=m/g,b=m/v;Math.abs(x-1)>1e-6&&(this._+="L"+(t+x*l)+","+(n+x*f)),this._+="A"+u+","+u+",0,0,"+ +(f*d>l*_)+","+(this._x1=t+b*c)+","+(this._y1=n+b*s)}else this._+="L"+(this._x1=t)+","+(this._y1=n);else;},arc:function(t,n,e,o,a,c){t=+t,n=+n,c=!!c;var s=(e=+e)*Math.cos(o),l=e*Math.sin(o),f=t+s,h=n+l,d=1^c,_=c?o-a:a-o;if(e<0)throw new Error("negative radius: "+e);null===this._x1?this._+="M"+f+","+h:(Math.abs(this._x1-f)>1e-6||Math.abs(this._y1-h)>1e-6)&&(this._+="L"+f+","+h),e&&(_<0&&(_=_%i+i),_>u?this._+="A"+e+","+e+",0,1,"+d+","+(t-s)+","+(n-l)+"A"+e+","+e+",0,1,"+d+","+(this._x1=f)+","+(this._y1=h):_>1e-6&&(this._+="A"+e+","+e+",0,"+ +(_>=r)+","+d+","+(this._x1=t+e*Math.cos(a))+","+(this._y1=n+e*Math.sin(a))))},rect:function(t,n,e,r){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+n)+"h"+ +e+"v"+ +r+"h"+-e+"Z"},toString:function(){return this._}};var c=a,s=function(t){return function(){return t}},l=Math.abs,f=Math.atan2,h=Math.cos,d=Math.max,_=Math.min,p=Math.sin,y=Math.sqrt,v=Math.PI,g=v/2,m=2*v;function x(t){return t>1?0:t<-1?v:Math.acos(t)}function b(t){return t>=1?g:t<=-1?-g:Math.asin(t)}function w(t){return t.innerRadius}function M(t){return t.outerRadius}function T(t){return t.startAngle}function O(t){return t.endAngle}function S(t){return t&&t.padAngle}function A(t,n,e,r,i,u,o,a){var c=e-t,s=r-n,l=o-i,f=a-u,h=f*c-l*s;if(!(h*h<1e-12))return[t+(h=(l*(n-u)-f*(t-i))/h)*c,n+h*s]}function N(t,n,e,r,i,u,o){var a=t-e,c=n-r,s=(o?u:-u)/y(a*a+c*c),l=s*c,f=-s*a,h=t+l,_=n+f,p=e+l,v=r+f,g=(h+p)/2,m=(_+v)/2,x=p-h,b=v-_,w=x*x+b*b,M=i-u,T=h*v-p*_,O=(b<0?-1:1)*y(d(0,M*M*w-T*T)),S=(T*b-x*O)/w,A=(-T*x-b*O)/w,N=(T*b+x*O)/w,j=(-T*x+b*O)/w,k=S-g,C=A-m,E=N-g,D=j-m;return k*k+C*C>E*E+D*D&&(S=N,A=j),{cx:S,cy:A,x01:-l,y01:-f,x11:S*(i/M-1),y11:A*(i/M-1)}}var j=function(){var t=w,n=M,e=s(0),r=null,i=T,u=O,o=S,a=null;function d(){var s,d,w=+t.apply(this,arguments),M=+n.apply(this,arguments),T=i.apply(this,arguments)-g,O=u.apply(this,arguments)-g,S=l(O-T),j=O>T;if(a||(a=s=c()),M<w&&(d=M,M=w,w=d),M>1e-12)if(S>m-1e-12)a.moveTo(M*h(T),M*p(T)),a.arc(0,0,M,T,O,!j),w>1e-12&&(a.moveTo(w*h(O),w*p(O)),a.arc(0,0,w,O,T,j));else{var k,C,E=T,D=O,U=T,F=O,P=S,Y=S,I=o.apply(this,arguments)/2,L=I>1e-12&&(r?+r.apply(this,arguments):y(w*w+M*M)),H=_(l(M-w)/2,+e.apply(this,arguments)),q=H,R=H;if(L>1e-12){var B=b(L/w*p(I)),z=b(L/M*p(I));(P-=2*B)>1e-12?(U+=B*=j?1:-1,F-=B):(P=0,U=F=(T+O)/2),(Y-=2*z)>1e-12?(E+=z*=j?1:-1,D-=z):(Y=0,E=D=(T+O)/2)}var X=M*h(E),W=M*p(E),V=w*h(F),Z=w*p(F);if(H>1e-12){var $,Q=M*h(D),G=M*p(D),J=w*h(U),K=w*p(U);if(S<v&&($=A(X,W,J,K,Q,G,V,Z))){var tt=X-$[0],nt=W-$[1],et=Q-$[0],rt=G-$[1],it=1/p(x((tt*et+nt*rt)/(y(tt*tt+nt*nt)*y(et*et+rt*rt)))/2),ut=y($[0]*$[0]+$[1]*$[1]);q=_(H,(w-ut)/(it-1)),R=_(H,(M-ut)/(it+1))}}Y>1e-12?R>1e-12?(k=N(J,K,X,W,M,R,j),C=N(Q,G,V,Z,M,R,j),a.moveTo(k.cx+k.x01,k.cy+k.y01),R<H?a.arc(k.cx,k.cy,R,f(k.y01,k.x01),f(C.y01,C.x01),!j):(a.arc(k.cx,k.cy,R,f(k.y01,k.x01),f(k.y11,k.x11),!j),a.arc(0,0,M,f(k.cy+k.y11,k.cx+k.x11),f(C.cy+C.y11,C.cx+C.x11),!j),a.arc(C.cx,C.cy,R,f(C.y11,C.x11),f(C.y01,C.x01),!j))):(a.moveTo(X,W),a.arc(0,0,M,E,D,!j)):a.moveTo(X,W),w>1e-12&&P>1e-12?q>1e-12?(k=N(V,Z,Q,G,w,-q,j),C=N(X,W,J,K,w,-q,j),a.lineTo(k.cx+k.x01,k.cy+k.y01),q<H?a.arc(k.cx,k.cy,q,f(k.y01,k.x01),f(C.y01,C.x01),!j):(a.arc(k.cx,k.cy,q,f(k.y01,k.x01),f(k.y11,k.x11),!j),a.arc(0,0,w,f(k.cy+k.y11,k.cx+k.x11),f(C.cy+C.y11,C.cx+C.x11),j),a.arc(C.cx,C.cy,q,f(C.y11,C.x11),f(C.y01,C.x01),!j))):a.arc(0,0,w,F,U,j):a.lineTo(V,Z)}else a.moveTo(0,0);if(a.closePath(),s)return a=null,s+""||null}return d.centroid=function(){var e=(+t.apply(this,arguments)+ +n.apply(this,arguments))/2,r=(+i.apply(this,arguments)+ +u.apply(this,arguments))/2-v/2;return[h(r)*e,p(r)*e]},d.innerRadius=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),d):t},d.outerRadius=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),d):n},d.cornerRadius=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),d):e},d.padRadius=function(t){return arguments.length?(r=null==t?null:"function"==typeof t?t:s(+t),d):r},d.startAngle=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),d):i},d.endAngle=function(t){return arguments.length?(u="function"==typeof t?t:s(+t),d):u},d.padAngle=function(t){return arguments.length?(o="function"==typeof t?t:s(+t),d):o},d.context=function(t){return arguments.length?(a=null==t?null:t,d):a},d};function k(t){this._context=t}k.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._point=0},lineEnd:function(){(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;default:this._context.lineTo(t,n)}}};var C=function(t){return new k(t)};function E(t){return t[0]}function D(t){return t[1]}var U=function(){var t=E,n=D,e=s(!0),r=null,i=C,u=null;function o(o){var a,s,l,f=o.length,h=!1;for(null==r&&(u=i(l=c())),a=0;a<=f;++a)!(a<f&&e(s=o[a],a,o))===h&&((h=!h)?u.lineStart():u.lineEnd()),h&&u.point(+t(s,a,o),+n(s,a,o));if(l)return u=null,l+""||null}return o.x=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),o):t},o.y=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),o):n},o.defined=function(t){return arguments.length?(e="function"==typeof t?t:s(!!t),o):e},o.curve=function(t){return arguments.length?(i=t,null!=r&&(u=i(r)),o):i},o.context=function(t){return arguments.length?(null==t?r=u=null:u=i(r=t),o):r},o},F=function(){var t=E,n=null,e=s(0),r=D,i=s(!0),u=null,o=C,a=null;function l(s){var l,f,h,d,_,p=s.length,y=!1,v=new Array(p),g=new Array(p);for(null==u&&(a=o(_=c())),l=0;l<=p;++l){if(!(l<p&&i(d=s[l],l,s))===y)if(y=!y)f=l,a.areaStart(),a.lineStart();else{for(a.lineEnd(),a.lineStart(),h=l-1;h>=f;--h)a.point(v[h],g[h]);a.lineEnd(),a.areaEnd()}y&&(v[l]=+t(d,l,s),g[l]=+e(d,l,s),a.point(n?+n(d,l,s):v[l],r?+r(d,l,s):g[l]))}if(_)return a=null,_+""||null}function f(){return U().defined(i).curve(o).context(u)}return l.x=function(e){return arguments.length?(t="function"==typeof e?e:s(+e),n=null,l):t},l.x0=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),l):t},l.x1=function(t){return arguments.length?(n=null==t?null:"function"==typeof t?t:s(+t),l):n},l.y=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),r=null,l):e},l.y0=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),l):e},l.y1=function(t){return arguments.length?(r=null==t?null:"function"==typeof t?t:s(+t),l):r},l.lineX0=l.lineY0=function(){return f().x(t).y(e)},l.lineY1=function(){return f().x(t).y(r)},l.lineX1=function(){return f().x(n).y(e)},l.defined=function(t){return arguments.length?(i="function"==typeof t?t:s(!!t),l):i},l.curve=function(t){return arguments.length?(o=t,null!=u&&(a=o(u)),l):o},l.context=function(t){return arguments.length?(null==t?u=a=null:a=o(u=t),l):u},l},P=function(t,n){return n<t?-1:n>t?1:n>=t?0:NaN},Y=function(t){return t},I=function(){var t=Y,n=P,e=null,r=s(0),i=s(m),u=s(0);function o(o){var a,c,s,l,f,h=o.length,d=0,_=new Array(h),p=new Array(h),y=+r.apply(this,arguments),v=Math.min(m,Math.max(-m,i.apply(this,arguments)-y)),g=Math.min(Math.abs(v)/h,u.apply(this,arguments)),x=g*(v<0?-1:1);for(a=0;a<h;++a)(f=p[_[a]=a]=+t(o[a],a,o))>0&&(d+=f);for(null!=n?_.sort((function(t,e){return n(p[t],p[e])})):null!=e&&_.sort((function(t,n){return e(o[t],o[n])})),a=0,s=d?(v-h*x)/d:0;a<h;++a,y=l)c=_[a],l=y+((f=p[c])>0?f*s:0)+x,p[c]={data:o[c],index:a,value:f,startAngle:y,endAngle:l,padAngle:g};return p}return o.value=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),o):t},o.sortValues=function(t){return arguments.length?(n=t,e=null,o):n},o.sort=function(t){return arguments.length?(e=t,n=null,o):e},o.startAngle=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),o):r},o.endAngle=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),o):i},o.padAngle=function(t){return arguments.length?(u="function"==typeof t?t:s(+t),o):u},o},L=q(C);function H(t){this._curve=t}function q(t){function n(n){return new H(t(n))}return n._curve=t,n}function R(t){var n=t.curve;return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t.curve=function(t){return arguments.length?n(q(t)):n()._curve},t}H.prototype={areaStart:function(){this._curve.areaStart()},areaEnd:function(){this._curve.areaEnd()},lineStart:function(){this._curve.lineStart()},lineEnd:function(){this._curve.lineEnd()},point:function(t,n){this._curve.point(n*Math.sin(t),n*-Math.cos(t))}};var B=function(){return R(U().curve(L))},z=function(){var t=F().curve(L),n=t.curve,e=t.lineX0,r=t.lineX1,i=t.lineY0,u=t.lineY1;return t.angle=t.x,delete t.x,t.startAngle=t.x0,delete t.x0,t.endAngle=t.x1,delete t.x1,t.radius=t.y,delete t.y,t.innerRadius=t.y0,delete t.y0,t.outerRadius=t.y1,delete t.y1,t.lineStartAngle=function(){return R(e())},delete t.lineX0,t.lineEndAngle=function(){return R(r())},delete t.lineX1,t.lineInnerRadius=function(){return R(i())},delete t.lineY0,t.lineOuterRadius=function(){return R(u())},delete t.lineY1,t.curve=function(t){return arguments.length?n(q(t)):n()._curve},t},X=function(t,n){return[(n=+n)*Math.cos(t-=Math.PI/2),n*Math.sin(t)]},W=Array.prototype.slice;function V(t){return t.source}function Z(t){return t.target}function $(t){var n=V,e=Z,r=E,i=D,u=null;function o(){var o,a=W.call(arguments),s=n.apply(this,a),l=e.apply(this,a);if(u||(u=o=c()),t(u,+r.apply(this,(a[0]=s,a)),+i.apply(this,a),+r.apply(this,(a[0]=l,a)),+i.apply(this,a)),o)return u=null,o+""||null}return o.source=function(t){return arguments.length?(n=t,o):n},o.target=function(t){return arguments.length?(e=t,o):e},o.x=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),o):r},o.y=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),o):i},o.context=function(t){return arguments.length?(u=null==t?null:t,o):u},o}function Q(t,n,e,r,i){t.moveTo(n,e),t.bezierCurveTo(n=(n+r)/2,e,n,i,r,i)}function G(t,n,e,r,i){t.moveTo(n,e),t.bezierCurveTo(n,e=(e+i)/2,r,e,r,i)}function J(t,n,e,r,i){var u=X(n,e),o=X(n,e=(e+i)/2),a=X(r,e),c=X(r,i);t.moveTo(u[0],u[1]),t.bezierCurveTo(o[0],o[1],a[0],a[1],c[0],c[1])}function K(){return $(Q)}function tt(){return $(G)}function nt(){var t=$(J);return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t}var et={draw:function(t,n){var e=Math.sqrt(n/v);t.moveTo(e,0),t.arc(0,0,e,0,m)}},rt={draw:function(t,n){var e=Math.sqrt(n/5)/2;t.moveTo(-3*e,-e),t.lineTo(-e,-e),t.lineTo(-e,-3*e),t.lineTo(e,-3*e),t.lineTo(e,-e),t.lineTo(3*e,-e),t.lineTo(3*e,e),t.lineTo(e,e),t.lineTo(e,3*e),t.lineTo(-e,3*e),t.lineTo(-e,e),t.lineTo(-3*e,e),t.closePath()}},it=Math.sqrt(1/3),ut=2*it,ot={draw:function(t,n){var e=Math.sqrt(n/ut),r=e*it;t.moveTo(0,-e),t.lineTo(r,0),t.lineTo(0,e),t.lineTo(-r,0),t.closePath()}},at=Math.sin(v/10)/Math.sin(7*v/10),ct=Math.sin(m/10)*at,st=-Math.cos(m/10)*at,lt={draw:function(t,n){var e=Math.sqrt(.8908130915292852*n),r=ct*e,i=st*e;t.moveTo(0,-e),t.lineTo(r,i);for(var u=1;u<5;++u){var o=m*u/5,a=Math.cos(o),c=Math.sin(o);t.lineTo(c*e,-a*e),t.lineTo(a*r-c*i,c*r+a*i)}t.closePath()}},ft={draw:function(t,n){var e=Math.sqrt(n),r=-e/2;t.rect(r,r,e,e)}},ht=Math.sqrt(3),dt={draw:function(t,n){var e=-Math.sqrt(n/(3*ht));t.moveTo(0,2*e),t.lineTo(-ht*e,-e),t.lineTo(ht*e,-e),t.closePath()}},_t=Math.sqrt(3)/2,pt=1/Math.sqrt(12),yt=3*(pt/2+1),vt={draw:function(t,n){var e=Math.sqrt(n/yt),r=e/2,i=e*pt,u=r,o=e*pt+e,a=-u,c=o;t.moveTo(r,i),t.lineTo(u,o),t.lineTo(a,c),t.lineTo(-.5*r-_t*i,_t*r+-.5*i),t.lineTo(-.5*u-_t*o,_t*u+-.5*o),t.lineTo(-.5*a-_t*c,_t*a+-.5*c),t.lineTo(-.5*r+_t*i,-.5*i-_t*r),t.lineTo(-.5*u+_t*o,-.5*o-_t*u),t.lineTo(-.5*a+_t*c,-.5*c-_t*a),t.closePath()}},gt=[et,rt,ot,ft,lt,dt,vt],mt=function(){var t=s(et),n=s(64),e=null;function r(){var r;if(e||(e=r=c()),t.apply(this,arguments).draw(e,+n.apply(this,arguments)),r)return e=null,r+""||null}return r.type=function(n){return arguments.length?(t="function"==typeof n?n:s(n),r):t},r.size=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),r):n},r.context=function(t){return arguments.length?(e=null==t?null:t,r):e},r},xt=function(){};function bt(t,n,e){t._context.bezierCurveTo((2*t._x0+t._x1)/3,(2*t._y0+t._y1)/3,(t._x0+2*t._x1)/3,(t._y0+2*t._y1)/3,(t._x0+4*t._x1+n)/6,(t._y0+4*t._y1+e)/6)}function wt(t){this._context=t}wt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){switch(this._point){case 3:bt(this,this._x1,this._y1);case 2:this._context.lineTo(this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3,this._context.lineTo((5*this._x0+this._x1)/6,(5*this._y0+this._y1)/6);default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var Mt=function(t){return new wt(t)};function Tt(t){this._context=t}Tt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._y0=this._y1=this._y2=this._y3=this._y4=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x2,this._y2),this._context.closePath();break;case 2:this._context.moveTo((this._x2+2*this._x3)/3,(this._y2+2*this._y3)/3),this._context.lineTo((this._x3+2*this._x2)/3,(this._y3+2*this._y2)/3),this._context.closePath();break;case 3:this.point(this._x2,this._y2),this.point(this._x3,this._y3),this.point(this._x4,this._y4)}},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._x2=t,this._y2=n;break;case 1:this._point=2,this._x3=t,this._y3=n;break;case 2:this._point=3,this._x4=t,this._y4=n,this._context.moveTo((this._x0+4*this._x1+t)/6,(this._y0+4*this._y1+n)/6);break;default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var Ot=function(t){return new Tt(t)};function St(t){this._context=t}St.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3;var e=(this._x0+4*this._x1+t)/6,r=(this._y0+4*this._y1+n)/6;this._line?this._context.lineTo(e,r):this._context.moveTo(e,r);break;case 3:this._point=4;default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var At=function(t){return new St(t)};function Nt(t,n){this._basis=new wt(t),this._beta=n}Nt.prototype={lineStart:function(){this._x=[],this._y=[],this._basis.lineStart()},lineEnd:function(){var t=this._x,n=this._y,e=t.length-1;if(e>0)for(var r,i=t[0],u=n[0],o=t[e]-i,a=n[e]-u,c=-1;++c<=e;)r=c/e,this._basis.point(this._beta*t[c]+(1-this._beta)*(i+r*o),this._beta*n[c]+(1-this._beta)*(u+r*a));this._x=this._y=null,this._basis.lineEnd()},point:function(t,n){this._x.push(+t),this._y.push(+n)}};var jt=function t(n){function e(t){return 1===n?new wt(t):new Nt(t,n)}return e.beta=function(n){return t(+n)},e}(.85);function kt(t,n,e){t._context.bezierCurveTo(t._x1+t._k*(t._x2-t._x0),t._y1+t._k*(t._y2-t._y0),t._x2+t._k*(t._x1-n),t._y2+t._k*(t._y1-e),t._x2,t._y2)}function Ct(t,n){this._context=t,this._k=(1-n)/6}Ct.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:kt(this,this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2,this._x1=t,this._y1=n;break;case 2:this._point=3;default:kt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Et=function t(n){function e(t){return new Ct(t,n)}return e.tension=function(n){return t(+n)},e}(0);function Dt(t,n){this._context=t,this._k=(1-n)/6}Dt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._x3=t,this._y3=n;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=n);break;case 2:this._point=3,this._x5=t,this._y5=n;break;default:kt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Ut=function t(n){function e(t){return new Dt(t,n)}return e.tension=function(n){return t(+n)},e}(0);function Ft(t,n){this._context=t,this._k=(1-n)/6}Ft.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:kt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Pt=function t(n){function e(t){return new Ft(t,n)}return e.tension=function(n){return t(+n)},e}(0);function Yt(t,n,e){var r=t._x1,i=t._y1,u=t._x2,o=t._y2;if(t._l01_a>1e-12){var a=2*t._l01_2a+3*t._l01_a*t._l12_a+t._l12_2a,c=3*t._l01_a*(t._l01_a+t._l12_a);r=(r*a-t._x0*t._l12_2a+t._x2*t._l01_2a)/c,i=(i*a-t._y0*t._l12_2a+t._y2*t._l01_2a)/c}if(t._l23_a>1e-12){var s=2*t._l23_2a+3*t._l23_a*t._l12_a+t._l12_2a,l=3*t._l23_a*(t._l23_a+t._l12_a);u=(u*s+t._x1*t._l23_2a-n*t._l12_2a)/l,o=(o*s+t._y1*t._l23_2a-e*t._l12_2a)/l}t._context.bezierCurveTo(r,i,u,o,t._x2,t._y2)}function It(t,n){this._context=t,this._alpha=n}It.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:this.point(this._x2,this._y2)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3;default:Yt(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Lt=function t(n){function e(t){return n?new It(t,n):new Ct(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function Ht(t,n){this._context=t,this._alpha=n}Ht.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._x3=t,this._y3=n;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=n);break;case 2:this._point=3,this._x5=t,this._y5=n;break;default:Yt(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var qt=function t(n){function e(t){return n?new Ht(t,n):new Dt(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function Rt(t,n){this._context=t,this._alpha=n}Rt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:Yt(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Bt=function t(n){function e(t){return n?new Rt(t,n):new Ft(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function zt(t){this._context=t}zt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._point=0},lineEnd:function(){this._point&&this._context.closePath()},point:function(t,n){t=+t,n=+n,this._point?this._context.lineTo(t,n):(this._point=1,this._context.moveTo(t,n))}};var Xt=function(t){return new zt(t)};function Wt(t){return t<0?-1:1}function Vt(t,n,e){var r=t._x1-t._x0,i=n-t._x1,u=(t._y1-t._y0)/(r||i<0&&-0),o=(e-t._y1)/(i||r<0&&-0),a=(u*i+o*r)/(r+i);return(Wt(u)+Wt(o))*Math.min(Math.abs(u),Math.abs(o),.5*Math.abs(a))||0}function Zt(t,n){var e=t._x1-t._x0;return e?(3*(t._y1-t._y0)/e-n)/2:n}function $t(t,n,e){var r=t._x0,i=t._y0,u=t._x1,o=t._y1,a=(u-r)/3;t._context.bezierCurveTo(r+a,i+a*n,u-a,o-a*e,u,o)}function Qt(t){this._context=t}function Gt(t){this._context=new Jt(t)}function Jt(t){this._context=t}function Kt(t){return new Qt(t)}function tn(t){return new Gt(t)}function nn(t){this._context=t}function en(t){var n,e,r=t.length-1,i=new Array(r),u=new Array(r),o=new Array(r);for(i[0]=0,u[0]=2,o[0]=t[0]+2*t[1],n=1;n<r-1;++n)i[n]=1,u[n]=4,o[n]=4*t[n]+2*t[n+1];for(i[r-1]=2,u[r-1]=7,o[r-1]=8*t[r-1]+t[r],n=1;n<r;++n)e=i[n]/u[n-1],u[n]-=e,o[n]-=e*o[n-1];for(i[r-1]=o[r-1]/u[r-1],n=r-2;n>=0;--n)i[n]=(o[n]-i[n+1])/u[n];for(u[r-1]=(t[r]+i[r-1])/2,n=0;n<r-1;++n)u[n]=2*t[n+1]-i[n+1];return[i,u]}Qt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=this._t0=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x1,this._y1);break;case 3:$t(this,this._t0,Zt(this,this._t0))}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){var e=NaN;if(n=+n,(t=+t)!==this._x1||n!==this._y1){switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3,$t(this,Zt(this,e=Vt(this,t,n)),e);break;default:$t(this,this._t0,e=Vt(this,t,n))}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n,this._t0=e}}},(Gt.prototype=Object.create(Qt.prototype)).point=function(t,n){Qt.prototype.point.call(this,n,t)},Jt.prototype={moveTo:function(t,n){this._context.moveTo(n,t)},closePath:function(){this._context.closePath()},lineTo:function(t,n){this._context.lineTo(n,t)},bezierCurveTo:function(t,n,e,r,i,u){this._context.bezierCurveTo(n,t,r,e,u,i)}},nn.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=[],this._y=[]},lineEnd:function(){var t=this._x,n=this._y,e=t.length;if(e)if(this._line?this._context.lineTo(t[0],n[0]):this._context.moveTo(t[0],n[0]),2===e)this._context.lineTo(t[1],n[1]);else for(var r=en(t),i=en(n),u=0,o=1;o<e;++u,++o)this._context.bezierCurveTo(r[0][u],i[0][u],r[1][u],i[1][u],t[o],n[o]);(this._line||0!==this._line&&1===e)&&this._context.closePath(),this._line=1-this._line,this._x=this._y=null},point:function(t,n){this._x.push(+t),this._y.push(+n)}};var rn=function(t){return new nn(t)};function un(t,n){this._context=t,this._t=n}un.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=this._y=NaN,this._point=0},lineEnd:function(){0<this._t&&this._t<1&&2===this._point&&this._context.lineTo(this._x,this._y),(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line>=0&&(this._t=1-this._t,this._line=1-this._line)},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;default:if(this._t<=0)this._context.lineTo(this._x,n),this._context.lineTo(t,n);else{var e=this._x*(1-this._t)+t*this._t;this._context.lineTo(e,this._y),this._context.lineTo(e,n)}}this._x=t,this._y=n}};var on=function(t){return new un(t,.5)};function an(t){return new un(t,0)}function cn(t){return new un(t,1)}var sn=function(t,n){if((i=t.length)>1)for(var e,r,i,u=1,o=t[n[0]],a=o.length;u<i;++u)for(r=o,o=t[n[u]],e=0;e<a;++e)o[e][1]+=o[e][0]=isNaN(r[e][1])?r[e][0]:r[e][1]},ln=function(t){for(var n=t.length,e=new Array(n);--n>=0;)e[n]=n;return e};function fn(t,n){return t[n]}var hn=function(){var t=s([]),n=ln,e=sn,r=fn;function i(i){var u,o,a=t.apply(this,arguments),c=i.length,s=a.length,l=new Array(s);for(u=0;u<s;++u){for(var f,h=a[u],d=l[u]=new Array(c),_=0;_<c;++_)d[_]=f=[0,+r(i[_],h,_,i)],f.data=i[_];d.key=h}for(u=0,o=n(l);u<s;++u)l[o[u]].index=u;return e(l,o),l}return i.keys=function(n){return arguments.length?(t="function"==typeof n?n:s(W.call(n)),i):t},i.value=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),i):r},i.order=function(t){return arguments.length?(n=null==t?ln:"function"==typeof t?t:s(W.call(t)),i):n},i.offset=function(t){return arguments.length?(e=null==t?sn:t,i):e},i},dn=function(t,n){if((r=t.length)>0){for(var e,r,i,u=0,o=t[0].length;u<o;++u){for(i=e=0;e<r;++e)i+=t[e][u][1]||0;if(i)for(e=0;e<r;++e)t[e][u][1]/=i}sn(t,n)}},_n=function(t,n){if((a=t.length)>0)for(var e,r,i,u,o,a,c=0,s=t[n[0]].length;c<s;++c)for(u=o=0,e=0;e<a;++e)(i=(r=t[n[e]][c])[1]-r[0])>0?(r[0]=u,r[1]=u+=i):i<0?(r[1]=o,r[0]=o+=i):(r[0]=0,r[1]=i)},pn=function(t,n){if((e=t.length)>0){for(var e,r=0,i=t[n[0]],u=i.length;r<u;++r){for(var o=0,a=0;o<e;++o)a+=t[o][r][1]||0;i[r][1]+=i[r][0]=-a/2}sn(t,n)}},yn=function(t,n){if((i=t.length)>0&&(r=(e=t[n[0]]).length)>0){for(var e,r,i,u=0,o=1;o<r;++o){for(var a=0,c=0,s=0;a<i;++a){for(var l=t[n[a]],f=l[o][1]||0,h=(f-(l[o-1][1]||0))/2,d=0;d<a;++d){var _=t[n[d]];h+=(_[o][1]||0)-(_[o-1][1]||0)}c+=f,s+=h*f}e[o-1][1]+=e[o-1][0]=u,c&&(u-=s/c)}e[o-1][1]+=e[o-1][0]=u,sn(t,n)}},vn=function(t){var n=t.map(gn);return ln(t).sort((function(t,e){return n[t]-n[e]}))};function gn(t){for(var n,e=-1,r=0,i=t.length,u=-1/0;++e<i;)(n=+t[e][1])>u&&(u=n,r=e);return r}var mn=function(t){var n=t.map(xn);return ln(t).sort((function(t,e){return n[t]-n[e]}))};function xn(t){for(var n,e=0,r=-1,i=t.length;++r<i;)(n=+t[r][1])&&(e+=n);return e}var bn=function(t){return mn(t).reverse()},wn=function(t){var n,e,r=t.length,i=t.map(xn),u=vn(t),o=0,a=0,c=[],s=[];for(n=0;n<r;++n)e=u[n],o<a?(o+=i[e],c.push(e)):(a+=i[e],s.push(e));return s.reverse().concat(c)},Mn=function(t){return ln(t).reverse()};e.d(n,"arc",(function(){return j})),e.d(n,"area",(function(){return F})),e.d(n,"line",(function(){return U})),e.d(n,"pie",(function(){return I})),e.d(n,"areaRadial",(function(){return z})),e.d(n,"radialArea",(function(){return z})),e.d(n,"lineRadial",(function(){return B})),e.d(n,"radialLine",(function(){return B})),e.d(n,"pointRadial",(function(){return X})),e.d(n,"linkHorizontal",(function(){return K})),e.d(n,"linkVertical",(function(){return tt})),e.d(n,"linkRadial",(function(){return nt})),e.d(n,"symbol",(function(){return mt})),e.d(n,"symbols",(function(){return gt})),e.d(n,"symbolCircle",(function(){return et})),e.d(n,"symbolCross",(function(){return rt})),e.d(n,"symbolDiamond",(function(){return ot})),e.d(n,"symbolSquare",(function(){return ft})),e.d(n,"symbolStar",(function(){return lt})),e.d(n,"symbolTriangle",(function(){return dt})),e.d(n,"symbolWye",(function(){return vt})),e.d(n,"curveBasisClosed",(function(){return Ot})),e.d(n,"curveBasisOpen",(function(){return At})),e.d(n,"curveBasis",(function(){return Mt})),e.d(n,"curveBundle",(function(){return jt})),e.d(n,"curveCardinalClosed",(function(){return Ut})),e.d(n,"curveCardinalOpen",(function(){return Pt})),e.d(n,"curveCardinal",(function(){return Et})),e.d(n,"curveCatmullRomClosed",(function(){return qt})),e.d(n,"curveCatmullRomOpen",(function(){return Bt})),e.d(n,"curveCatmullRom",(function(){return Lt})),e.d(n,"curveLinearClosed",(function(){return Xt})),e.d(n,"curveLinear",(function(){return C})),e.d(n,"curveMonotoneX",(function(){return Kt})),e.d(n,"curveMonotoneY",(function(){return tn})),e.d(n,"curveNatural",(function(){return rn})),e.d(n,"curveStep",(function(){return on})),e.d(n,"curveStepAfter",(function(){return cn})),e.d(n,"curveStepBefore",(function(){return an})),e.d(n,"stack",(function(){return hn})),e.d(n,"stackOffsetExpand",(function(){return dn})),e.d(n,"stackOffsetDiverging",(function(){return _n})),e.d(n,"stackOffsetNone",(function(){return sn})),e.d(n,"stackOffsetSilhouette",(function(){return pn})),e.d(n,"stackOffsetWiggle",(function(){return yn})),e.d(n,"stackOrderAppearance",(function(){return vn})),e.d(n,"stackOrderAscending",(function(){return mn})),e.d(n,"stackOrderDescending",(function(){return bn})),e.d(n,"stackOrderInsideOut",(function(){return wn})),e.d(n,"stackOrderNone",(function(){return ln})),e.d(n,"stackOrderReverse",(function(){return Mn}))},function(t,n,e){"use strict";e.r(n);var r,i,u=e(9),o=e(69),a=0,c=0,s=0,l=0,f=0,h=0,d="object"==typeof performance&&performance.now?performance:Date,_="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};function p(){return f||(_(y),f=d.now()+h)}function y(){f=0}function v(){this._call=this._time=this._next=null}function g(t,n,e){var r=new v;return r.restart(t,n,e),r}function m(){f=(l=d.now())+h,a=c=0;try{!function(){p(),++a;for(var t,n=r;n;)(t=f-n._time)>=0&&n._call.call(null,t),n=n._next;--a}()}finally{a=0,function(){var t,n,e=r,u=1/0;for(;e;)e._call?(u>e._time&&(u=e._time),t=e,e=e._next):(n=e._next,e._next=null,e=t?t._next=n:r=n);i=t,b(u)}(),f=0}}function x(){var t=d.now(),n=t-l;n>1e3&&(h-=n,l=t)}function b(t){a||(c&&(c=clearTimeout(c)),t-f>24?(t<1/0&&(c=setTimeout(m,t-d.now()-h)),s&&(s=clearInterval(s))):(s||(l=d.now(),s=setInterval(x,1e3)),a=1,_(m)))}v.prototype=g.prototype={constructor:v,restart:function(t,n,e){if("function"!=typeof t)throw new TypeError("callback is not a function");e=(null==e?p():+e)+(null==n?0:+n),this._next||i===this||(i?i._next=this:r=this,i=this),this._call=t,this._time=e,b()},stop:function(){this._call&&(this._call=null,this._time=1/0,b())}};var w=function(t,n,e){var r=new v;return n=null==n?0:+n,r.restart((function(e){r.stop(),t(e+n)}),n,e),r},M=Object(o.a)("start","end","cancel","interrupt"),T=[],O=function(t,n,e,r,i,u){var o=t.__transition;if(o){if(e in o)return}else t.__transition={};!function(t,n,e){var r,i=t.__transition;function u(c){var s,l,f,h;if(1!==e.state)return a();for(s in i)if((h=i[s]).name===e.name){if(3===h.state)return w(u);4===h.state?(h.state=6,h.timer.stop(),h.on.call("interrupt",t,t.__data__,h.index,h.group),delete i[s]):+s<n&&(h.state=6,h.timer.stop(),h.on.call("cancel",t,t.__data__,h.index,h.group),delete i[s])}if(w((function(){3===e.state&&(e.state=4,e.timer.restart(o,e.delay,e.time),o(c))})),e.state=2,e.on.call("start",t,t.__data__,e.index,e.group),2===e.state){for(e.state=3,r=new Array(f=e.tween.length),s=0,l=-1;s<f;++s)(h=e.tween[s].value.call(t,t.__data__,e.index,e.group))&&(r[++l]=h);r.length=l+1}}function o(n){for(var i=n<e.duration?e.ease.call(null,n/e.duration):(e.timer.restart(a),e.state=5,1),u=-1,o=r.length;++u<o;)r[u].call(t,i);5===e.state&&(e.on.call("end",t,t.__data__,e.index,e.group),a())}function a(){for(var r in e.state=6,e.timer.stop(),delete i[n],i)return;delete t.__transition}i[n]=e,e.timer=g((function(t){e.state=1,e.timer.restart(u,e.delay,e.time),e.delay<=t&&u(t-e.delay)}),0,e.time)}(t,e,{name:n,index:r,group:i,on:M,tween:T,time:u.time,delay:u.delay,duration:u.duration,ease:u.ease,timer:null,state:0})};function S(t,n){var e=N(t,n);if(e.state>0)throw new Error("too late; already scheduled");return e}function A(t,n){var e=N(t,n);if(e.state>3)throw new Error("too late; already running");return e}function N(t,n){var e=t.__transition;if(!e||!(e=e[n]))throw new Error("transition not found");return e}var j=function(t,n){var e,r,i,u=t.__transition,o=!0;if(u){for(i in n=null==n?null:n+"",u)(e=u[i]).name===n?(r=e.state>2&&e.state<5,e.state=6,e.timer.stop(),e.on.call(r?"interrupt":"cancel",t,t.__data__,e.index,e.group),delete u[i]):o=!1;o&&delete t.__transition}},k=e(74),C=e(20);function E(t,n){var e,r;return function(){var i=A(this,t),u=i.tween;if(u!==e)for(var o=0,a=(r=e=u).length;o<a;++o)if(r[o].name===n){(r=r.slice()).splice(o,1);break}i.tween=r}}function D(t,n,e){var r,i;if("function"!=typeof e)throw new Error;return function(){var u=A(this,t),o=u.tween;if(o!==r){i=(r=o).slice();for(var a={name:n,value:e},c=0,s=i.length;c<s;++c)if(i[c].name===n){i[c]=a;break}c===s&&i.push(a)}u.tween=i}}function U(t,n,e){var r=t._id;return t.each((function(){var t=A(this,r);(t.value||(t.value={}))[n]=e.apply(this,arguments)})),function(t){return N(t,r).value[n]}}var F=e(7),P=e(5),Y=e(39),I=e(55),L=function(t,n){var e;return("number"==typeof n?P.a:n instanceof F.e?Y.a:(e=Object(F.e)(n))?(n=e,Y.a):I.a)(t,n)};function H(t){return function(){this.removeAttribute(t)}}function q(t){return function(){this.removeAttributeNS(t.space,t.local)}}function R(t,n,e){var r,i,u=e+"";return function(){var o=this.getAttribute(t);return o===u?null:o===r?i:i=n(r=o,e)}}function B(t,n,e){var r,i,u=e+"";return function(){var o=this.getAttributeNS(t.space,t.local);return o===u?null:o===r?i:i=n(r=o,e)}}function z(t,n,e){var r,i,u;return function(){var o,a,c=e(this);if(null!=c)return(o=this.getAttribute(t))===(a=c+"")?null:o===r&&a===i?u:(i=a,u=n(r=o,c));this.removeAttribute(t)}}function X(t,n,e){var r,i,u;return function(){var o,a,c=e(this);if(null!=c)return(o=this.getAttributeNS(t.space,t.local))===(a=c+"")?null:o===r&&a===i?u:(i=a,u=n(r=o,c));this.removeAttributeNS(t.space,t.local)}}function W(t,n){return function(e){this.setAttribute(t,n.call(this,e))}}function V(t,n){return function(e){this.setAttributeNS(t.space,t.local,n.call(this,e))}}function Z(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&V(t,i)),e}return i._value=n,i}function $(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&W(t,i)),e}return i._value=n,i}function Q(t,n){return function(){S(this,t).delay=+n.apply(this,arguments)}}function G(t,n){return n=+n,function(){S(this,t).delay=n}}function J(t,n){return function(){A(this,t).duration=+n.apply(this,arguments)}}function K(t,n){return n=+n,function(){A(this,t).duration=n}}function tt(t,n){if("function"!=typeof n)throw new Error;return function(){A(this,t).ease=n}}var nt=e(34);function et(t,n,e){var r,i,u=function(t){return(t+"").trim().split(/^|\s+/).every((function(t){var n=t.indexOf(".");return n>=0&&(t=t.slice(0,n)),!t||"start"===t}))}(n)?S:A;return function(){var o=u(this,t),a=o.on;a!==r&&(i=(r=a).copy()).on(n,e),o.on=i}}var rt=e(19),it=e(33),ut=u.b.prototype.constructor,ot=e(35);function at(t){return function(){this.style.removeProperty(t)}}function ct(t,n,e){return function(r){this.style.setProperty(t,n.call(this,r),e)}}function st(t,n,e){var r,i;function u(){var u=n.apply(this,arguments);return u!==i&&(r=(i=u)&&ct(t,u,e)),r}return u._value=n,u}function lt(t){return function(n){this.textContent=t.call(this,n)}}function ft(t){var n,e;function r(){var r=t.apply(this,arguments);return r!==e&&(n=(e=r)&&lt(r)),n}return r._value=t,r}var ht=0;function dt(t,n,e,r){this._groups=t,this._parents=n,this._name=e,this._id=r}function _t(t){return Object(u.b)().transition(t)}function pt(){return++ht}var yt=u.b.prototype;dt.prototype=_t.prototype={constructor:dt,select:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(rt.a)(t));for(var r=this._groups,i=r.length,u=new Array(i),o=0;o<i;++o)for(var a,c,s=r[o],l=s.length,f=u[o]=new Array(l),h=0;h<l;++h)(a=s[h])&&(c=t.call(a,a.__data__,h,s))&&("__data__"in a&&(c.__data__=a.__data__),f[h]=c,O(f[h],n,e,h,f,N(a,e)));return new dt(u,this._parents,n,e)},selectAll:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(it.a)(t));for(var r=this._groups,i=r.length,u=[],o=[],a=0;a<i;++a)for(var c,s=r[a],l=s.length,f=0;f<l;++f)if(c=s[f]){for(var h,d=t.call(c,c.__data__,f,s),_=N(c,e),p=0,y=d.length;p<y;++p)(h=d[p])&&O(h,n,e,p,d,_);u.push(d),o.push(c)}return new dt(u,o,n,e)},filter:function(t){"function"!=typeof t&&(t=Object(nt.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var u,o=n[i],a=o.length,c=r[i]=[],s=0;s<a;++s)(u=o[s])&&t.call(u,u.__data__,s,o)&&c.push(u);return new dt(r,this._parents,this._name,this._id)},merge:function(t){if(t._id!==this._id)throw new Error;for(var n=this._groups,e=t._groups,r=n.length,i=e.length,u=Math.min(r,i),o=new Array(r),a=0;a<u;++a)for(var c,s=n[a],l=e[a],f=s.length,h=o[a]=new Array(f),d=0;d<f;++d)(c=s[d]||l[d])&&(h[d]=c);for(;a<r;++a)o[a]=n[a];return new dt(o,this._parents,this._name,this._id)},selection:function(){return new ut(this._groups,this._parents)},transition:function(){for(var t=this._name,n=this._id,e=pt(),r=this._groups,i=r.length,u=0;u<i;++u)for(var o,a=r[u],c=a.length,s=0;s<c;++s)if(o=a[s]){var l=N(o,n);O(o,t,e,s,a,{time:l.time+l.delay+l.duration,delay:0,duration:l.duration,ease:l.ease})}return new dt(r,this._parents,t,e)},call:yt.call,nodes:yt.nodes,node:yt.node,size:yt.size,empty:yt.empty,each:yt.each,on:function(t,n){var e=this._id;return arguments.length<2?N(this.node(),e).on.on(t):this.each(et(e,t,n))},attr:function(t,n){var e=Object(C.a)(t),r="transform"===e?k.b:L;return this.attrTween(t,"function"==typeof n?(e.local?X:z)(e,r,U(this,"attr."+t,n)):null==n?(e.local?q:H)(e):(e.local?B:R)(e,r,n))},attrTween:function(t,n){var e="attr."+t;if(arguments.length<2)return(e=this.tween(e))&&e._value;if(null==n)return this.tween(e,null);if("function"!=typeof n)throw new Error;var r=Object(C.a)(t);return this.tween(e,(r.local?Z:$)(r,n))},style:function(t,n,e){var r="transform"==(t+="")?k.a:L;return null==n?this.styleTween(t,function(t,n){var e,r,i;return function(){var u=Object(ot.b)(this,t),o=(this.style.removeProperty(t),Object(ot.b)(this,t));return u===o?null:u===e&&o===r?i:i=n(e=u,r=o)}}(t,r)).on("end.style."+t,at(t)):"function"==typeof n?this.styleTween(t,function(t,n,e){var r,i,u;return function(){var o=Object(ot.b)(this,t),a=e(this),c=a+"";return null==a&&(this.style.removeProperty(t),c=a=Object(ot.b)(this,t)),o===c?null:o===r&&c===i?u:(i=c,u=n(r=o,a))}}(t,r,U(this,"style."+t,n))).each(function(t,n){var e,r,i,u,o="style."+n,a="end."+o;return function(){var c=A(this,t),s=c.on,l=null==c.value[o]?u||(u=at(n)):void 0;s===e&&i===l||(r=(e=s).copy()).on(a,i=l),c.on=r}}(this._id,t)):this.styleTween(t,function(t,n,e){var r,i,u=e+"";return function(){var o=Object(ot.b)(this,t);return o===u?null:o===r?i:i=n(r=o,e)}}(t,r,n),e).on("end.style."+t,null)},styleTween:function(t,n,e){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==n)return this.tween(r,null);if("function"!=typeof n)throw new Error;return this.tween(r,st(t,n,null==e?"":e))},text:function(t){return this.tween("text","function"==typeof t?function(t){return function(){var n=t(this);this.textContent=null==n?"":n}}(U(this,"text",t)):function(t){return function(){this.textContent=t}}(null==t?"":t+""))},textTween:function(t){var n="text";if(arguments.length<1)return(n=this.tween(n))&&n._value;if(null==t)return this.tween(n,null);if("function"!=typeof t)throw new Error;return this.tween(n,ft(t))},remove:function(){return this.on("end.remove",(t=this._id,function(){var n=this.parentNode;for(var e in this.__transition)if(+e!==t)return;n&&n.removeChild(this)}));var t},tween:function(t,n){var e=this._id;if(t+="",arguments.length<2){for(var r,i=N(this.node(),e).tween,u=0,o=i.length;u<o;++u)if((r=i[u]).name===t)return r.value;return null}return this.each((null==n?E:D)(e,t,n))},delay:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?Q:G)(n,t)):N(this.node(),n).delay},duration:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?J:K)(n,t)):N(this.node(),n).duration},ease:function(t){var n=this._id;return arguments.length?this.each(tt(n,t)):N(this.node(),n).ease},end:function(){var t,n,e=this,r=e._id,i=e.size();return new Promise((function(u,o){var a={value:o},c={value:function(){0==--i&&u()}};e.each((function(){var e=A(this,r),i=e.on;i!==t&&((n=(t=i).copy())._.cancel.push(a),n._.interrupt.push(a),n._.end.push(c)),e.on=n}))}))}};var vt={time:null,delay:0,duration:250,ease:e(29).b};function gt(t,n){for(var e;!(e=t.__transition)||!(e=e[n]);)if(!(t=t.parentNode))return vt.time=p(),vt;return e}u.b.prototype.interrupt=function(t){return this.each((function(){j(this,t)}))},u.b.prototype.transition=function(t){var n,e;t instanceof dt?(n=t._id,t=t._name):(n=pt(),(e=vt).time=p(),t=null==t?null:t+"");for(var r=this._groups,i=r.length,u=0;u<i;++u)for(var o,a=r[u],c=a.length,s=0;s<c;++s)(o=a[s])&&O(o,t,n,s,a,e||gt(o,n));return new dt(r,this._parents,t,n)};var mt=[null],xt=function(t,n){var e,r,i=t.__transition;if(i)for(r in n=null==n?null:n+"",i)if((e=i[r]).state>1&&e.name===n)return new dt([[t]],mt,n,+r);return null};e.d(n,"transition",(function(){return _t})),e.d(n,"active",(function(){return xt})),e.d(n,"interrupt",(function(){return j}))},,function(t,n,e){"use strict";var r,i,u,o,a=e(5),c=180/Math.PI,s={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1},l=function(t,n,e,r,i,u){var o,a,s;return(o=Math.sqrt(t*t+n*n))&&(t/=o,n/=o),(s=t*e+n*r)&&(e-=t*s,r-=n*s),(a=Math.sqrt(e*e+r*r))&&(e/=a,r/=a,s/=a),t*r<n*e&&(t=-t,n=-n,s=-s,o=-o),{translateX:i,translateY:u,rotate:Math.atan2(n,t)*c,skewX:Math.atan(s)*c,scaleX:o,scaleY:a}};function f(t,n,e,r){function i(t){return t.length?t.pop()+" ":""}return function(u,o){var c=[],s=[];return u=t(u),o=t(o),function(t,r,i,u,o,c){if(t!==i||r!==u){var s=o.push("translate(",null,n,null,e);c.push({i:s-4,x:Object(a.a)(t,i)},{i:s-2,x:Object(a.a)(r,u)})}else(i||u)&&o.push("translate("+i+n+u+e)}(u.translateX,u.translateY,o.translateX,o.translateY,c,s),function(t,n,e,u){t!==n?(t-n>180?n+=360:n-t>180&&(t+=360),u.push({i:e.push(i(e)+"rotate(",null,r)-2,x:Object(a.a)(t,n)})):n&&e.push(i(e)+"rotate("+n+r)}(u.rotate,o.rotate,c,s),function(t,n,e,u){t!==n?u.push({i:e.push(i(e)+"skewX(",null,r)-2,x:Object(a.a)(t,n)}):n&&e.push(i(e)+"skewX("+n+r)}(u.skewX,o.skewX,c,s),function(t,n,e,r,u,o){if(t!==e||n!==r){var c=u.push(i(u)+"scale(",null,",",null,")");o.push({i:c-4,x:Object(a.a)(t,e)},{i:c-2,x:Object(a.a)(n,r)})}else 1===e&&1===r||u.push(i(u)+"scale("+e+","+r+")")}(u.scaleX,u.scaleY,o.scaleX,o.scaleY,c,s),u=o=null,function(t){for(var n,e=-1,r=s.length;++e<r;)c[(n=s[e]).i]=n.x(t);return c.join("")}}}e.d(n,"a",(function(){return h})),e.d(n,"b",(function(){return d}));var h=f((function(t){return"none"===t?s:(r||(r=document.createElement("DIV"),i=document.documentElement,u=document.defaultView),r.style.transform=t,t=u.getComputedStyle(i.appendChild(r),null).getPropertyValue("transform"),i.removeChild(r),t=t.slice(7,-1).split(","),l(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}),"px, ","px)","deg)"),d=f((function(t){return null==t?s:(o||(o=document.createElementNS("http://www.w3.org/2000/svg","g")),o.setAttribute("transform",t),(t=o.transform.baseVal.consolidate())?(t=t.matrix,l(t.a,t.b,t.c,t.d,t.e,t.f)):s)}),", ",")",")")},,,,,,,,,,,function(t,n,e){"use strict";var r;void 0===(r=function(t){var n=e(44),r=e(2),i=0,u={small:{limit:10,format:n.format("")},medium:{limit:1e3,format:n.format("")},large:{limit:null,format:n.format(".2s")}},o={small:{limit:10,format:n.format(".3f")},medium:{limit:100,format:n.format(".1f")},large:{limit:null,format:n.format(".2s")}},a=function(t,n){var e="large";return t<n.small.limit?e="small":t<n.medium.limit&&(e="medium"),e};return{calculatePercent:function(t,e,r){var i=e?t/e*100:0;return n.format(r)(i)},calcLinearRegression:function(t){var n=t.length,e=0,i=0,u=0,o=0;t.forEach((function(t){e+=t.x,i+=t.y,u+=t.x*t.y,o+=t.x*t.x}));var a=n*o-e*e,c=(i*o-e*u)/a,s=(n*u-e*i)/a,l=r.min(t,(function(t){return t.x})),f=r.max(t,(function(t){return t.x}));return{x1:l,y1:s*n+c,x2:f,y2:s*f+c}},isInteger:function(t){return t%1==0},formatDecimalValue:function(t){var n=a(t,o);return(0,o[n].format)(t)},formatIntegerValue:function(t){var n=a(t,u);return(0,u[n].format)(t)},uniqueId:function(t){var n=++i;return t.toString()+"-"+n}}}.call(n,e,n,t))||(t.exports=r)},,function(t,n,e){"use strict";var r;void 0===(r=function(t){var n=e(6),r=1.2,i=10,u=.9,o=.6,a="value",c="label",s=function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:12,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"Arial",r=document.createElement("canvas"),i=r.getContext("2d");return i.font=n+"px "+e,i.measureText(t).width};return{getTextWidth:s,wrapText:function(t,e,s,l){var f=n.select(l),h=f.text().split(/\s+/).reverse(),d=void 0,_=[],p=0,y=r*u,v=f.attr("y"),g=parseFloat(f.attr("dy")),m=e*o,x=f.text(null).append("tspan").attr("x",t).attr("y",v-5).attr("dy",g+"em").classed(a,!0).style("font-size",e+"px");for(x.text(h.pop()),x=f.append("tspan").classed(c,!0).attr("x",t).attr("y",v+i).attr("dy",++p*y+g+"em").style("font-size",m+"px");d=h.pop();)_.push(d),x.text(_.join(" ")),x.node()&&x.node().getComputedTextLength()>s-50&&(_.pop(),x.text(_.join(" ")),_=[d],x=f.append("tspan").classed(c,!0).attr("x",t).attr("y",v+i).attr("dy",++p*y+g+"em").text(d).style("font-size",m+"px"))},wrapTextWithEllipses:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2;t.each((function(){var u,o,a,c,s,l,f;for(u=(t=n.select(this)).text().split(/\s+/).reverse(),a=[],c=0,1.2,s=t.attr("y"),l=parseFloat(t.attr("dy")),f=t.text(null).append("tspan").attr("x",r).attr("y",s).attr("dy",l+"em");o=u.pop();)if(a.push(o),f.text(a.join(" ")),f.node()&&f.node().getComputedTextLength()>e){if(a.pop(),f.text(a.join(" ")),!(c<i-1)){a.push("..."),f.text(a.join(" "));break}a=[o],f=t.append("tspan").attr("x",r).attr("y",s).attr("dy",1.2*++c+l+"em").text(o),t.classed("adjust-upwards",!0)}}))},getApproximateNumberOfLines:function(t,n,e){var r=t.split(/\s+/).reverse(),i=[],u=1,o=!0,a=!1,c=void 0;try{for(var l,f=r[Symbol.iterator]();!(o=(l=f.next()).done);o=!0){var h=l.value;i.push(h),s(i.join(" "),n,"Karla, sans-serif")>e&&(i.pop(),i=[h],++u)}}catch(t){a=!0,c=t}finally{try{!o&&f.return&&f.return()}finally{if(a)throw c}}return u}}}.call(n,e,n,t))||(t.exports=r)},,,,,,,,,,,,,,,,,,,,,function(t,n,e){"use strict";var r,i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},u=function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,n){var e=[],r=!0,i=!1,u=void 0;try{for(var o,a=t[Symbol.iterator]();!(r=(o=a.next()).done)&&(e.push(o.value),!n||e.length!==n);r=!0);}catch(t){i=!0,u=t}finally{try{!r&&a.return&&a.return()}finally{if(i)throw u}}return e}(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")};void 0===(r=function(t){var n=e(64),r=e(44),o=e(6),a=(e(72),e(66)),c=e(70).axisTimeCombinations,s=e(85),l=s.formatIntegerValue,f=s.formatDecimalValue,h=s.isInteger,d=e(87),_=d.getTextWidth,p=d.getApproximateNumberOfLines;return function(){var t=2,e=2,s=2,d=2,y="Tooltip title",v=!0,g=void 0,m={y:-55,x:0},x=void 0,b=void 0,w=void 0,M=void 0,T=48,O=0,S=37,A=void 0,N=0,j=void 0,k=n.easeQuadInOut,C=void 0,E="date",D="value",U="name",F="topics",P=c.DAY_MONTH,Y="date",I=null,L=null,H=[],q=null,R=null,B=a.timeFormat("%b %d, %Y"),z=a.timeFormat("%b %d, %I %p"),X=void 0,W=void 0;function V(n){n.each((function(n){250-d-e,45-t-s,n,function(n){W||((W=o.select(n).append("g").classed("britechart britechart-tooltip",!0).style("visibility","hidden")).append("g").classed("tooltip-container-group select-disable",!0).attr("transform","translate( "+d+", "+t+")").append("g").classed("tooltip-group",!0),x=W.selectAll(".tooltip-group").append("g").classed("tooltip-text",!0),g=x.append("rect").classed("tooltip-text-container",!0).attr("x",-54.5).attr("y",0).attr("width",250).attr("height",T).attr("rx",3).attr("ry",3).style("fill","#FFFFFF").style("stroke","#D2D6DF").style("stroke-width",1),M=x.append("text").classed("tooltip-title",!0).attr("x",J()).attr("dy",".35em").attr("y",16).style("fill","#6D717A"),e=G(Date.now()),(r=p(e,16,230))>1&&(N=17*(r-1)),b=x.append("line").classed("tooltip-divider",!0).attr("x1",-46.5).attr("x2",265).attr("y1",31+N).attr("y2",31+N).style("stroke","#D2D6DF"),w=x.append("g").classed("tooltip-body",!0).style("transform","translateY(8px)").style("fill","#282C35"));var e,r;W.transition().attr("width",250).attr("height",45),V.hide()}(this)}))}function Z(t){var n=t[D];return t.missingValue?"-":function(t){if(null!==R)return R(t);var n=f;return t?(null!==q?n=r.format(q):h(t)&&(n=l),n(t)):0}(n).toString()}function $(t){var n,e,r=t[U],i=void 0,u=void 0;n=t.topicName||r,e=Z(t),u=w.append("text").classed("tooltip-left-text",!0).attr("dy","1em").attr("x",O).attr("y",S).style("fill","#000000").text(n).call(K,170,-25),i=w.append("text").classed("tooltip-right-text",!0).attr("dy","1em").attr("x",O).attr("y",S).style("fill","#000000").text(e),A=u.node().getBBox().height?u.node().getBBox().height:A,T+=A+5,j=i.node().getBBox().width?i.node().getBBox().width:j,i.attr("x",250-j-10-62.5),w.append("circle").classed("tooltip-circle",!0).attr("cx",-39.5).attr("cy",S+8).attr("r",5).style("fill",C[r]).style("stroke-width",1),S+=A+7}function Q(t,n,e){var r,i,o=(r=u([n,e],2),i=r[0],r[1],[i-250<0?65:-205,m.y]),a=u(o,2),c=a[0],s=a[1];g.attr("width",250).attr("height",T+10),x.transition().duration(100).ease(k).attr("transform","translate("+c+", "+s+")"),b.attr("x2",190)}function G(t){var n=y,e=function(t){if("number"===Y)return Number(t);return function(t){var n=I||P,e=null,r={month:"short",day:"numeric"};n===c.DAY_MONTH||n===c.MONTH_YEAR?(e=B,r.year="numeric"):n===c.HOUR_DAY||n===c.MINUTE_HOUR?(e=z,r.hour="numeric"):n===c.CUSTOM&&"string"==typeof L&&(e=a.timeFormat(L));if(X&&"undefined"!=typeof Intl&&"object"===("undefined"==typeof Intl?"undefined":i(Intl))&&Intl.DateTimeFormat){return Intl.DateTimeFormat(X,r).format(t)}return e(t)}(new Date(t))}(t);return n.length?v&&(n=n+" - "+e):n=e,n}function J(){return-46.5}function K(t,n){var e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;t.each((function(){var r,i,u,a,c,s,l;for(r=(t=o.select(this)).text().split(/\s+/).reverse(),u=[],a=0,1.2,c=t.attr("y"),s=parseFloat(t.attr("dy")),l=t.text(null).append("tspan").attr("x",e).attr("y",c).attr("dy",s+"em");i=r.pop();){u.push(i),l.text(u.join(" ")),_(u.join(" "),16,"Karla, sans-serif")>n&&(u.pop(),l.text(u.join(" ")),a<2&&(u=[i],l=t.append("tspan").attr("x",e).attr("y",c).attr("dy",1.2*++a+s+"em").text(i)))}}))}function tt(t){var n=t[F];H.length?n=function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:H;return n.map((function(n){return t.filter((function(t){return t.name===n}))[0]}))}(n):n.length&&n[0].name&&(n=function(t){return t.map((function(t){return t})).sort((function(t,n){return t.name>n.name?1:t.name===n.name?0:-1}))}(n)),w.selectAll("text").remove(),w.selectAll("circle").remove(),function(t){var n=G(t[E]);M.text(n).call(K,230,J())}(t),T=48+N,S=37+N,O=0,n.forEach($)}function nt(t,n,e){tt(t),Q(0,n,e)}return V.axisTimeCombinations=c,V.dateFormat=function(t){return arguments.length?(I=t,this):I||P},V.dateCustomFormat=function(t){return arguments.length?(L=t,this):L},V.dateLabel=function(t){return arguments.length?(E=t,this):E},V.hide=function(){return W.style("visibility","hidden"),this},V.locale=function(t){return arguments.length?(X=t,this):X},V.nameLabel=function(t){return arguments.length?(U=t,this):U},V.numberFormat=function(t){return arguments.length?(q=t,this):q},V.valueFormatter=function(t){return arguments.length?(R=t,this):R},V.shouldShowDateInTitle=function(t){return arguments.length?(v=t,this):v},V.show=function(){return W.style("visibility","visible"),this},V.title=function(t){return arguments.length?(y=t,this):y},V.tooltipOffset=function(t){return arguments.length?(m=t,this):m},V.topicsOrder=function(t){return arguments.length?(H=t,this):H},V.topicLabel=function(t){return arguments.length?(F=t,this):F},V.update=function(t,n,e){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null;return C=n,nt(t,e,r),this},V.valueLabel=function(t){return arguments.length?(D=t,this):D},V.xAxisValueType=function(t){return arguments.length?(Y=t,this):Y},V}}.call(n,e,n,t))||(t.exports=r)}])}));
//# sourceMappingURL=tooltip.min.js.map

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(61).f;
var create = __webpack_require__(155);
var redefineAll = __webpack_require__(199);
var ctx = __webpack_require__(77);
var anInstance = __webpack_require__(190);
var forOf = __webpack_require__(128);
var $iterDefine = __webpack_require__(195);
var step = __webpack_require__(328);
var setSpecies = __webpack_require__(338);
var DESCRIPTORS = __webpack_require__(53);
var fastKey = __webpack_require__(154).fastKey;
var validate = __webpack_require__(204);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(153);
var from = __webpack_require__(679);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(39);
var $export = __webpack_require__(30);
var meta = __webpack_require__(154);
var fails = __webpack_require__(91);
var hide = __webpack_require__(84);
var redefineAll = __webpack_require__(199);
var forOf = __webpack_require__(128);
var anInstance = __webpack_require__(190);
var isObject = __webpack_require__(54);
var setToStringTag = __webpack_require__(132);
var dP = __webpack_require__(61).f;
var each = __webpack_require__(681)(0);
var DESCRIPTORS = __webpack_require__(53);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(39).document;
module.exports = document && document.documentElement;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(53) && !__webpack_require__(91)(function () {
  return Object.defineProperty(__webpack_require__(192)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(112);
var ITERATOR = __webpack_require__(42)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(127);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(70);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(42)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(331);
var hiddenKeys = __webpack_require__(193).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(92);
var toObject = __webpack_require__(93);
var IE_PROTO = __webpack_require__(200)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(92);
var toIObject = __webpack_require__(85);
var arrayIndexOf = __webpack_require__(680)(false);
var IE_PROTO = __webpack_require__(200)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(53);
var getKeys = __webpack_require__(113);
var toIObject = __webpack_require__(85);
var isEnum = __webpack_require__(130).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(70);
var isObject = __webpack_require__(54);
var newPromiseCapability = __webpack_require__(196);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(84);


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(30);
var aFunction = __webpack_require__(126);
var ctx = __webpack_require__(77);
var forOf = __webpack_require__(128);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(30);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(39);
var core = __webpack_require__(22);
var dP = __webpack_require__(61);
var DESCRIPTORS = __webpack_require__(53);
var SPECIES = __webpack_require__(42)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(70);
var aFunction = __webpack_require__(126);
var SPECIES = __webpack_require__(42)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(77);
var invoke = __webpack_require__(686);
var html = __webpack_require__(322);
var cel = __webpack_require__(192);
var global = __webpack_require__(39);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(127)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(62);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(33);
var toAbsoluteIndex = __webpack_require__(103);
var toLength = __webpack_require__(27);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(96);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(43);
var toObject = __webpack_require__(33);
var IObject = __webpack_require__(134);
var toLength = __webpack_require__(27);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(43);
var isObject = __webpack_require__(20);
var invoke = __webpack_require__(351);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(31).f;
var create = __webpack_require__(97);
var redefineAll = __webpack_require__(101);
var ctx = __webpack_require__(64);
var anInstance = __webpack_require__(95);
var forOf = __webpack_require__(96);
var $iterDefine = __webpack_require__(219);
var step = __webpack_require__(354);
var setSpecies = __webpack_require__(102);
var DESCRIPTORS = __webpack_require__(29);
var fastKey = __webpack_require__(88).fastKey;
var validate = __webpack_require__(105);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(115);
var from = __webpack_require__(343);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(101);
var getWeak = __webpack_require__(88).getWeak;
var anObject = __webpack_require__(11);
var isObject = __webpack_require__(20);
var anInstance = __webpack_require__(95);
var forOf = __webpack_require__(96);
var createArrayMethod = __webpack_require__(71);
var $has = __webpack_require__(55);
var validate = __webpack_require__(105);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(163);
var isObject = __webpack_require__(20);
var toLength = __webpack_require__(27);
var ctx = __webpack_require__(64);
var IS_CONCAT_SPREADABLE = __webpack_require__(25)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(29) && !__webpack_require__(17)(function () {
  return Object.defineProperty(__webpack_require__(212)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 351 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(20);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(11);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(221);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 356 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 357 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(29);
var getKeys = __webpack_require__(99);
var gOPS = __webpack_require__(167);
var pIE = __webpack_require__(135);
var toObject = __webpack_require__(33);
var IObject = __webpack_require__(134);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(17)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31);
var anObject = __webpack_require__(11);
var getKeys = __webpack_require__(99);

module.exports = __webpack_require__(29) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(58);
var gOPN = __webpack_require__(98).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(55);
var toIObject = __webpack_require__(58);
var arrayIndexOf = __webpack_require__(160)(false);
var IE_PROTO = __webpack_require__(226)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(29);
var getKeys = __webpack_require__(99);
var toIObject = __webpack_require__(58);
var isEnum = __webpack_require__(135).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(98);
var gOPS = __webpack_require__(167);
var anObject = __webpack_require__(11);
var Reflect = __webpack_require__(16).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(16).parseFloat;
var $trim = __webpack_require__(118).trim;

module.exports = 1 / $parseFloat(__webpack_require__(229) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(16).parseInt;
var $trim = __webpack_require__(118).trim;
var ws = __webpack_require__(229);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(11);
var isObject = __webpack_require__(20);
var newPromiseCapability = __webpack_require__(223);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 368 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(27);
var repeat = __webpack_require__(228);
var defined = __webpack_require__(72);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(66);
var toLength = __webpack_require__(27);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(25);


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(346);
var validate = __webpack_require__(105);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(161)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(224);
__webpack_require__(9)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(29) && /./g.flags != 'g') __webpack_require__(31).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(133)
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(346);
var validate = __webpack_require__(105);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(161)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var each = __webpack_require__(71)(0);
var redefine = __webpack_require__(48);
var meta = __webpack_require__(88);
var assign = __webpack_require__(358);
var weak = __webpack_require__(348);
var isObject = __webpack_require__(20);
var validate = __webpack_require__(105);
var NATIVE_WEAK_MAP = __webpack_require__(105);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(161)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_create__ = __webpack_require__(1197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_0__src_create__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_creator__ = __webpack_require__(174);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "creator", function() { return __WEBPACK_IMPORTED_MODULE_1__src_creator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_local__ = __webpack_require__(1198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "local", function() { return __WEBPACK_IMPORTED_MODULE_2__src_local__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_matcher__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_3__src_matcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_mouse__ = __webpack_require__(1199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mouse", function() { return __WEBPACK_IMPORTED_MODULE_4__src_mouse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_namespace__ = __webpack_require__(235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "namespace", function() { return __WEBPACK_IMPORTED_MODULE_5__src_namespace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_namespaces__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "namespaces", function() { return __WEBPACK_IMPORTED_MODULE_6__src_namespaces__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_point__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clientPoint", function() { return __WEBPACK_IMPORTED_MODULE_7__src_point__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_select__ = __webpack_require__(379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_8__src_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_selectAll__ = __webpack_require__(1200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectAll", function() { return __WEBPACK_IMPORTED_MODULE_9__src_selectAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_selection_index__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selection", function() { return __WEBPACK_IMPORTED_MODULE_10__src_selection_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_selector__ = __webpack_require__(238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selector", function() { return __WEBPACK_IMPORTED_MODULE_11__src_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__ = __webpack_require__(383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectorAll", function() { return __WEBPACK_IMPORTED_MODULE_12__src_selectorAll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_selection_style__ = __webpack_require__(382);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "style", function() { return __WEBPACK_IMPORTED_MODULE_13__src_selection_style__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_touch__ = __webpack_require__(1228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "touch", function() { return __WEBPACK_IMPORTED_MODULE_14__src_touch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_touches__ = __webpack_require__(1229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "touches", function() { return __WEBPACK_IMPORTED_MODULE_15__src_touches__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_window__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "window", function() { return __WEBPACK_IMPORTED_MODULE_16__src_window__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_selection_on__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "event", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "customEvent", function() { return __WEBPACK_IMPORTED_MODULE_17__src_selection_on__["b"]; });




















/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (matcher);


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["b" /* Selection */]([[document.querySelector(selector)]], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["b" /* Selection */]([[selector]], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = EnterNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(67);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["b" /* Selection */](this._enter || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(update) {
  return new Array(update.length);
});


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = styleValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(240);


function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
});

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node).getComputedStyle(node, null).getPropertyValue(name);
}


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function empty() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f0b82e25258d6348fd7781b1ea8ca7d5.mp3";

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "823c1d05c7a52119874c19158f2c4e0d.mp3";

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f4769f9bdb7466be65088239c12046d1.eot";

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BagCount.png";

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/C-orange-icon.png";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/H-grey-icon.png";

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/H-orange-icon.png";

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Inactive.png";

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/T-grey-icon.png";

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/T-orange-icon.png";

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Transfer-On.png";

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/app_download.png";

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/arrow-outbound-orange.png";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/bag-off-green.png";

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/bagarrow-off.png";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/bagarrowleft-off.png";

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/delivered.png";

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/english.png";

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/hold.png";

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/misc.png";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/packed.png";

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/pick-up.png";

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/service_ticket.png";

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/spanish.png";

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'كانون الثاني يناير',
    'شباط فبراير',
    'آذار مارس',
    'نيسان أبريل',
    'أيار مايو',
    'حزيران يونيو',
    'تموز يوليو',
    'آب أغسطس',
    'أيلول سبتمبر',
    'تشرين الأول أكتوبر',
    'تشرين الثاني نوفمبر',
    'كانون الأول ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : '[el] D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH.mm',
        LLLL : 'dddd, D. MMMM YYYY HH.mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number,
        suffix;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}일/,
    ordinal : '%d일',
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: '[W] dddd [o] LT',
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[haftaya] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen hafta] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日Ah点mm分',
        LLLL : 'YYYY年MMMD日ddddAh点mm分',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var permissions = {
	'tnt_billing': {
		title_key: 'common.side_menu.tnt_billing',
		icon: 'glyphicon glyphicon-calendar',
		state: 'tntBilling',
		menu: true,
		permission: {
			view: false,
			default_redirect: false
		},
		child: {
			'tnt_billing_billable_events': {
				title_key: 'billableEvents.menu.title',
				title: 'Billable Events',
				redirectState: 'billable_events',
				permission: {
					view: false,
					create: false,
					edit: false,
					delete: false,
					default_redirect: false
				}
			},
			'tnt_billing_billing_category': {
				title_key: 'billingCategory.menu.title',
				title: 'Billing Category',
				redirectState: 'billing_category',
				permission: {
					view: false,
					create: false,
					edit: false,
					// delete: false
					default_redirect: false
				}
			},
			'tnt_billing_contract': {
				title_key: 'contract.contract',
				title: 'Contract',
				redirectState: 'contract',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false,
					default_redirect: false
				}
			},
			'tnt_billing_customer': {
				title_key: 'location.customer',
				title: 'Customer',
				redirectState: 'customer',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false,
					default_redirect: false
				}
			},
			'tnt_billing_location_distance': {
				title_key: 'locationDistance.menu.title',
				title: 'Location Distance',
				redirectState: 'location_distance',
				permission: {
					edit: false,
					view: false,
					create: false,
					default_redirect: false
				}
			},
			'tnt_billing_fuel_surcharges': {
				title_key: 'common.side_menu.fuel_surcharges',
				title: 'Fuel Surcharges',
				// icon: 'glyphicon glyphicon-usd',
				// state: 'fuelSurcharges',
				state: 'tntBilling',
				redirectState: 'fuel_surcharges',
				menu: true,
				permission: {
					edit: false,
					view: false,
					create: false,
					default_redirect: false
				},
				expand: false,
				child: {
					'price_point': {
						title_key: 'price_point',
						title: 'Price Point',
						permission: {
							edit: false,
							view: false,
							create: false
						}
					}
				}
			},
			'tnt_billing_contract_type': {
				title_key: 'contractType.menu.title',
				title: 'Contract Type',
				redirectState: 'contract_type',
				permission: {
					edit: false,
					view: false,
					create: false,
					default_redirect: false
				}
			}
		}
	},
	'tnt_control': {
		title_key: 'common.side_menu.tnt_control',
		icon: 'glyphicon glyphicon-asterisk',
		state: 'tntControl',
		menu: true,
		permission: {
			view: false
		},
		child: {
			// 'tnt_control_configuration': {
			// 	title_key: 'configuration.menu.title',
			// 	title: 'Configuaration',
			// 	permission: {
			// 		view: false,
			// 		create: false,
			// 		edit: false,
			// 		delete: false
			// 	}
			// },
			'tnt_control_branch_setup': {
				title_key: 'setup.menu.title',
				title: 'Setup',
				permission: {
					view: false,
					create: false,
					edit: false,
					changeVaultDate: false
					// delete: false,
				}
			},
			'tnt_control_shiptype': {
				title_key: 'addBagModal.shiptype',
				title: 'Shiptype',
				permission: {
					view: false,
					create: false,
					edit: false

				}
			},
			'tnt_control_denomination': {
				title_key: 'denomination.menu.title',
				title: 'Denomination',
				permission: {
					view: false,
					create: false,
					edit: false
					// delete: false,
				}
			},
			'tnt_control_currency': {
				title_key: 'currency.menu.title',
				title: 'Currency',
				permission: {
					view: true,
					create: true,
					edit: true
					// delete: false,
				}
			},
			'tnt_control_message': {
				title_key: 'message.types.M',
				title: 'Message',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'tnt_control_mobile_app': {
				title_key: 'mobileApp.menu.title',
				title: 'Mobile App',
				permission: {
					view: false,
					create: false
				}
			},
			'tnt_control_user_permission_report': {
				title_key: 'userPermissionReport.menu.title',
				title: 'User Permission Report',
				permission: {
					view: false
				}
			},
			'tnt_control_atm_load_profile': {
				title_key: 'atmLoadProfile.menu.title',
				title: 'ATM Load Profile',
				permission: {
					edit: false,
					view: false,
					create: false
				}
			},
			'tnt_control_cost_center': {
				title_key: 'costCenter.menu.title',
				title: 'Cost Centers',
				permission: {
					edit: false,
					view: false,
					create: false
				}
			},
			'tnt_control_environment_config': {
				title_key: 'environment_config.menu.title',
				title: 'Environment Config',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			},
			'tnt_control_location_zone': {
				title_key: 'locationZone.menu.title',
				title: 'Location Zone',
				permission: {
					view: false,
					// create: false,
					edit: false,
					delete: false
				}
			},
			'tnt_control_notification_management': {
				title_key: 'notificationManagement.menu.title',
				title: 'Notification Management',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			},
			'tnt_control_service_assignment_rules': {
				title_key: 'serviceAssignmentRules.menu.title',
				title: 'Service Assignment Rules',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			}
		}
	},
	'branch_mgmt': {
		title_key: 'common.side_menu.branch_mgmt',
		icon: 'glyphicon glyphicon-map-marker',
		state: 'branchManagement',
		menu: true,
		permission: {
			view: false,
			default_redirect: false
		},
		child: {
			'branch_mgmt_routes': {
				title_key: 'route.all_routes',
				title: 'Routes',
				permission: {
					all: false
				}
			},
			'branch_mgmt_locations': {
				title_key: 'location.menu.title',
				title: 'Locations',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.locations'
			},
			'branch_mgmt_items': {
				title_key: 'branch_mgmt.items.title',
				title: 'Items',
				permission: {
					all: false,
					edit: false,
					default_redirect: false
				},
				state: 'branchManagement.items'
			},
			'branch_mgmt_tankers': {
				title_key: 'branch_mgmt.tankers.title',
				title: 'Tankers',
				permission: {
					all: false
				}
			},
			'branch_mgmt_bagouts': {
				title_key: 'branch_mgmt.bagout.title',
				title: 'Bagouts',
				permission: {
					all: false
				}
			},
			'branch_mgmt_orders': {
				title_key: 'branch_mgmt.orders.title',
				permission: {
					all: false,
					export_print: false,
					default_redirect: false
				},
				state: 'branchManagement.orders'
			},
			'branch_mgmt_item_holds': {
				title_key: 'branch_mgmt.item_holds.title',
				title: 'Item Holds',
				permission: {
					all: false
				}
			},
			'branch_mgmt_location_holds': {
				title_key: 'branch_mgmt.locationhold.title',
				title: 'Location Holds',
				permission: {
					all: false
				}
			},
			'branch_mgmt_bypass_code': {
				title_key: 'branch_mgmt.bypass_code.title',
				title: '4P Bypass Code',
				permission: {
					all: false
				}
			}, 'branch_mgmt_daily_balance_sheet': {
				title_key: 'branch_mgmt.daily_balance_sheet.title',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.dailyBalanceSheet'
			},
			'branch_mgmt_monthly_report': {
				title_key: 'branch_mgmt.monthly_report.title',
				title: 'Monthly Report',
				permission: {
					all: false
				}
			},
			'branch_mgmt_deleted_shipments': {
				title_key: 'branch_mgmt.deleted_shipments.title',
				title: 'Deleted Shipments',
				permission: {
					all: false
				}
			},
			'branch_mgmt_cancelled_shipments': {
				title_key: 'branch_mgmt.cancelled_shipments.title',
				title: 'Cancelled Shipments',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.cancelledShipments'
			},
			'branch_mgmt_branch_performance': {
				title_key: 'branch_mgmt.branch_performance.title',
				title: 'Branch Performance',
				permission: {
					all: false
				}
			},
			'branch_mgmt_final_residual_count_commit': {
				title_key: 'branch_mgmt.final_residual_count_commit.title',
				title: 'Final Residual Count Commit',
				permission: {
					all: false
				}
			},
			'branch_mgmt_cash_transactions': {
				title_key: 'branch_mgmt.cash_transactions.title',
				title: 'Cash Transactions',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.cashDeliveries'
			},
			'branch_mgmt_tnt_bypass_code': {
				title_key: 'branch_mgmt.tnt_bypass_code.title',
				title: 'TNT Bypass Code',
				permission: {
					all: false,
					overrideClose: false
				}
			},
			'branch_mgmt_physical_cash_count': {
				title_key: 'branch_mgmt.physical_cash_count.title',
				title: 'Physical Cash Count',
				permission: {
					all: false,
					edit: false
				}
			},
			'branch_mgmt_lock_open_errors': {
				title_key: 'branch_mgmt.lock_open_errors.title',
				title: 'Lock Open Errors',
				permission: {
					all: false
				}
			},
			'branch_mgmt_billing_approval': {
				title_key: 'branch_mgmt.billing_approval.title',
				title: 'Billing Approval',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.billingApproval',
				menu: true,
				expand: false,
				child: {
					'branch_mgmt_billing_approval_create_billing_record': {
						title_key: 'branch_mgmt.billing_approval.create_billing_record.title',
						title: 'Create Billing Record',
						permission: {
							allow: false
						}
					},
					'branch_mgmt_billing_approval_approve_billing_record': {
						title_key: 'branch_mgmt.billing_approval.approve_billing_record.title',
						title: 'Approve Billing Record',
						permission: {
							allow: false
						}
					},
					'branch_mgmt_billing_approval_edit_billing_record': {
						title_key: 'branch_mgmt.billing_approval.edit_billing_record.title',
						title: 'Edit Billing Record',
						permission: {
							allow: false
						}
					},
					'branch_mgmt_billing_approval_delete_billing_record': {
						title_key: 'branch_mgmt.billing_approval.delete_billing_record.title',
						title: 'Delete Billing Record',
						permission: {
							allow: false
						}
					}
				}
			},
			'branch_mgmt_count_variances': {
				title_key: 'branch_mgmt.count_variances.title',
				title: 'Count Variances',
				permission: {
					all: false
				}
			},
			'branch_mgmt_restore_route_assignments': {
				title_key: 'branch_mgmt.restore_route_assignments.title',
				title: 'Restore Route Assignments',
				permission: {
					all: false
				}
			},
			'branch_mgmt_stop_performance': {
				title_key: 'branch_mgmt.stop_performance.title',
				title: 'Stop Performance',
				permission: {
					all: false
				}
			},
			'branch_mgmt_customer_pickup_reports': {
				title_key: 'branch_mgmt.customer_pickup_reports.title',
				title: 'Customer Pickup Reports',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.customerPickupReports'
			},
			'branch_mgmt_contact_request': {
				title_key: 'branch_mgmt.contact_request.title',
				title: 'Contact Request',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.contactRequest'
			},
			'branch_mgmt_import_file_view': {
				title_key: 'branch_mgmt.import_file_view.title',
				title: 'ImportFile View',
				permission: {
					all: false
				}
			},
			'branch_mgmt_stop_scheduling': {
				title_key: 'branch_mgmt.stop_scheduling.title',
				title: 'Stop Scheduling',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.stopScheduling'
			},
			'branch_mgmt_average_daily_balance': {
				title_key: 'branch_mgmt.average_daily_balance.title',
				title: 'Average Daily Vault Balance',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.averageDailyBalance'
			},
			'branch_mgmt_bin_manifest': {
				title_key: 'branch_mgmt.bin_manifest.title',
				title: 'Bin Manifest',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.binManifest'
			},
			'branch_mgmt_deposit_reports': {
				title_key: 'branch_mgmt.deposit_reports.title',
				title: 'Deposit Reports',
				permission: {
					all: false,
					default_redirect: false
				},
				state: 'branchManagement.depositReports'
			},
			'branch_mgmt_mileage_report': {
				title_key: 'Mileage Report',
				title: 'Mileage Report',
				permission: {
					all: false
				}
			}
		}
	},
	'vault_operations': {
		title_key: 'common.side_menu.vault_operations',
		icon: '	glyphicon glyphicon-hdd',
		state: 'vaultOperations',
		menu: true,
		permission: {
			all: false
		}
	},
	'service_tickets': {
		title_key: 'common.side_menu.service_tickets',
		icon: 'glyphicon glyphicon glyphicon-tag',
		state: 'serviceTickets',
		menu: true,
		permission: {
			all: false,
			create: false,
			edit: false,
			assign: false,
			updateExternal: false,
			default_redirect: false
		}
	},
	'reporting': {
		title_key: 'common.side_menu.reporting',
		icon: 'glyphicon glyphicon-list-alt',
		state: 'reporting',
		menu: true,
		permission: {
			view: false
		},
		child: {
			'reporting_liability': {
				title_key: 'liability.menu.title',
				title: 'Liability',
				permission: {
					view: false
				}
			},
			'reporting_route_performance': {
				title_key: 'route_performance.menu.title',
				title: 'Route Performance',
				permission: {
					view: false
				}
			},
			'reporting_on_hold': {
				title_key: 'on_hold.menu.title',
				title: 'On Hold',
				permission: {
					view: false
				}
			}
		}
	},
	'route_control': {
		title_key: 'common.side_menu.route_control',
		icon: 'glyphicon glyphicon-map-marker',
		state: 'routeControl',
		menu: true,
		permission: {
			stopTransfer: false,
			adHocCheckin: false,
			all: false
		}
	},
	'check_out': {
		title_key: 'common.side_menu.check_out',
		icon: 'glyphicon glyphicon-backward',
		state: 'checkout',
		menu: true,
		permission: {
			all: false
		}
	},
	'check_in': {
		title_key: 'common.side_menu.check_in',
		icon: 'glyphicon glyphicon-forward',
		state: 'checkin',
		menu: true,
		permission: {
			all: false
		}
	},
	'route_throw': {
		title_key: 'common.side_menu.route_throw',
		icon: 'glyphicon glyphicon-backward',
		state: 'routeThrow',
		menu: true,
		permission: {
			all: false
		}
	},
	// 'downsort': {
	// 	title_key: 'common.side_menu.downsort',
	// 	icon: 'glyphicon glyphicon-arrow-down',
	// 	menu: true,
	// 	permission: {
	// 		all: false
	// 	}
	// },
	'bag_out': {
		title_key: 'common.side_menu.bag_out',
		icon: 'glyphicon glyphicon-briefcase',
		state: 'bagout',
		menu: true,
		permission: {
			all: false
		}
	},
	'bulk_transfer': {
		title_key: 'common.side_menu.bulk_transfer',
		icon: 'glyphicon glyphicon-transfer',
		state: 'bulkTransfer',
		menu: true,
		permission: {
			all: false
		},
		expand: false,
		child: {
			'bulk_transfer_new': {
				title_key: 'bulk_transfer.tab.new',
				title: 'New',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			},
			'bulk_transfer_active': {
				title_key: 'bulk_transfer.tab.active',
				title: 'Active',
				permission: {
					view: false,
					edit: false
				}
			},
			'bulk_transfer_closed': {
				title_key: 'bulk_transfer.tab.closed',
				title: 'Closed',
				permission: {
					view: false
				}
			}
		}
	},
	'route_progress': {
		title_key: 'common.side_menu.route_progress',
		icon: 'glyphicon glyphicon-road',
		state: 'routeProgress',
		menu: true,
		permission: {
			all: false
		}
	},
	'route_stats': {
		title_key: 'common.side_menu.route_stats',
		icon: 'glyphicon glyphicon-map-marker',
		state: 'routeStats',
		menu: true,
		permission: {
			all: false
		}
	},
	'setting': {
		title_key: 'common.side_menu.settings',
		icon: 'glyphicon glyphicon-cog',
		state: 'settings',
		menu: true,
		permission: {
			all: false,
			default_redirect: false
		},
		expand: false,
		child: {
			'setting-vault': {
				title_key: 'setup.vault',
				title: 'Vault',
				permission: {
					edit: false,
					delete: false,
					view: false,
					create: false
				}
			},
			// 'setting-customer': {
			// 	title_key: 'location.customer',
			// 	title: 'Customer',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false
			// 	}
			// },
			// 'setting-contract': {
			// 	title_key: 'contract.contract',
			// 	title: 'Contract',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false
			// 	}
			// },
			'setting-items-type': {
				title_key: 'itemType.type',
				title: 'Item Type',
				permission: {
					edit: false,
					//delete: false,
					view: false,
					create: false
				}
			},
			'setting-items': {
				title_key: 'item.items',
				title: 'Item',
				permission: {
					edit: false,
					delete: false,
					view: false,
					create: false
				}
			},
			'setting-routes': {
				title_key: 'route.all_routes',
				title: 'Routes',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'setting-carrier': {
				title_key: 'routeControl.carrier',
				title: 'Carrier',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'setting-truck': {
				title_key: 'branch_mgmt.location_truck',
				title: 'Truck',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'setting-batch': {
				title_key: 'addBagModal.batch',
				title: 'Batch',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'setting-location': {
				title_key: 'bagout.location',
				title: 'Location',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false,
					importLocations: false,
					clone: false,
					editCustomer: false,
					deleteSaveLater: false,
					default_redirect: false
				},
				state: 'location.all'
			},
			'setting-branch': {
				title_key: 'checkout.branch',
				title: 'Branch',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			// 'setting-shiptype': {
			// 	title_key: 'addBagModal.shiptype',
			// 	title: 'Shiptype',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false

			// 	}
			// },
			'setting-users': {
				title_key: 'log.users',
				title: 'Users',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			// 'setting-message': {
			// 	title_key: 'message.types.M',
			// 	title: 'Message',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false
			// 	}
			// },
			'setting-holiday': {
				title_key: 'location.hol',
				title: 'Holiday',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			// 'setting-setup': {
			// 	title_key: 'setup.menu.title',
			// 	title: 'Setup',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false
			// 	}
			// },
			// 'setting-denomination': {
			// 	title_key: 'denomination.menu.title',
			// 	title: 'Denomination',
			// 	permission: {
			// 		edit: false,
			// 		// delete: false,
			// 		view: false,
			// 		create: false
			// 	}
			// },
			'setting-branch-funding-source': {
				title_key: 'branchFundingSource.menu.title',
				title: 'Branch Funding Source',
				permission: {
					edit: false,
					// delete: false,
					view: false,
					create: false
				}
			},
			'setting-branch-funding-source-holiday': {
				title_key: 'branchFundingSourceHoliday.menu.title',
				title: 'Branch Funding Source Holiday',
				permission: {
					edit: false,
					delete: false,
					view: false,
					create: false
				}
			},
			// 'setting-mobile-app': {
			// 	title_key: 'mobileApp.menu.title',
			// 	title: 'Mobile App',
			// 	permission: {
			// 		create: false,
			// 		view: false
			// 	}
			// },
			'setting-log': {
				title_key: 'log.menu.title',
				title: 'Log',
				permission: {
					view: false
				}
			},
			// 'setting-accounts': {
			// 	title_key: 'account.menu.title',
			// 	title: 'Account',
			// 	// permission: {
			// 		// view: false
			// 	// }
			// },
			'setting-reset-atm-code': {
				title_key: 'resetAtmCode.menu.title',
				title: 'Reset ATM Code',
				permission: {
					view: false
				}
			},
			// 'setting-soft-deleted-shipments': {
			// 	title_key: 'softDeletedShipments.menu.title',
			// 	title: 'Soft Deleted Shipments',
			// 	permission: {
			// 		view: false
			// 	}
			// }, 
			'setting-service-checklist': {
				title_key: 'serviceSettings.checklist.title',
				title: 'Service Checklist',
				permission: {
					view: false,
					create: false,
					edit: false,
					delete: false
				}
			},
			'setting-service-settings': {
				title_key: 'serviceSettings.menu.title',
				title: 'Service Settings',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			},
			'setting-delivery-region-routing': {
				title_key: 'deliveryRegionRouting.menu.title',
				title: 'Service Zones',
				permission: {
					view: false,
					create: false,
					edit: false
				}
			},
			'setting-service-ticket-parts': {
				title_key: 'serviceTicketParts.menu.title',
				title: 'Service Ticket Parts',
				permission: {
					view: false,
					create: false,
					edit: false,
					delete: false
				}
			},
			"setting-preventative-maintenance": {
				title_key: 'Preventative Maintenance',
				title: 'Preventative Maintenance',
				permission: {
					view: false,
					create: false,
					edit: false,
					delete: false
				}
			}
		}
	},
	'route_sheet': {

		title_key: 'common.side_menu.route_sheet',
		icon: 'glyphicon glyphicon-map-marker',
		state: 'routeSheet',
		menu: true,
		permission: {
			all: false
		}
	},
	'shipment_batch': {

		title_key: 'common.side_menu.shipment_batch',
		icon: 'glyphicon glyphicon-list',
		state: 'shipmentBatch',
		menu: true,
		permission: {
			all: false
		}
	},
	'coin_pull_report': {

		title_key: 'common.side_menu.coin_pull_report',
		icon: 'glyphicon glyphicon-list',
		state: 'coin-pull-report',
		menu: true,
		permission: {
			all: false
		}
	},
	'vault_close': {

		title_key: 'common.side_menu.vault_close',
		icon: 'glyphicon glyphicon-lock',
		state: 'vaultClose',
		menu: true,
		permission: {
			all: false
		}
	},
	'order_packing': {
		title_key: 'common.side_menu.order_packing',
		icon: 'glyphicon glyphicon-compressed',
		state: 'orderPacking',
		menu: true,
		permission: {
			all: false,
			editRoute: false
		},
		child: {
			'currency_pick_report': {
				title_key: 'common.side_menu.currency_pick_report',
				icon: 'glyphicon glyphicon-list-alt',
				menu: true,
				permission: {
					view: false
				}
			}
		}
	},
	'cash_activity': {
		title_key: 'common.side_menu.cash_activity',
		icon: 'glyphicon glyphicon-list-alt',
		state: 'cashActivity',
		menu: true,
		permission: {
			customer: false,
			funding_source: false,
			default_redirect: false
		}
	},
	'ach_management': {
		title_key: 'common.side_menu.ach_management',
		icon: 'glyphicon glyphicon-briefcase',
		state: 'achManagement',
		menu: true,
		permission: {
			all: false,
			default_redirect: false
		}
	},
	'bulk_cash_management': {
		title_key: 'common.side_menu.bulk_cash_management',
		icon: 'glyphicon glyphicon-align-justify',
		state: 'bulkCashManagement',
		menu: true,
		permission: {
			view: false,
			all: false,
			debit: false,
			report: false,
			export: false,
			default_redirect: false
		}
	},
	'atm_count': {
		title_key: 'branch_mgmt.cash_count',
		icon: 'glyphicon glyphicon-credit-card',
		state: 'atmCount',
		menu: true,
		permission: {
			editCommitted: false,
			all: false
		}
	},
	'master_cash_schedule': {
		title_key: 'common.side_menu.master_cash_schedule',
		icon: 'glyphicon glyphicon-dashboard',
		state: 'masterCashSchedule',
		menu: true,
		permission: {
			all: false,
			view: false,
			create: false,
			edit: false,
			delete: false,
			atRisk: false,
			default_redirect: false
		},
		expand: false,
		child: {
			'scheduled_shipment': {
				title_key: 'scheduled_shipment.title',
				title: 'Scheduled Shipment',
				permission: {
					edit: false,
					view: false,
					create: false
				}
			}
		}
	},
	'deposit_packing': {
		title_key: 'common.side_menu.deposit_packing',
		icon: 'glyphicon glyphicon-folder-close',
		state: 'depositPacking',
		menu: true,
		permission: {
			all: false
		}
	},
	'tnt_react_app': {
		title_key: "React App",
		icon: "glyphicon glyphicon-asterisk",
		state: "tntReactApp",
		menu: true,
		permission: {
			all: false,
			default_redirect: false
		}
	},
	'on_demand_call': {
		title_key: "On Demand Service",
		icon: "glyphicon glyphicon-map-marker",
		state: "onDemandCall",
		menu: true,
		permission: {
			all: false,
			default_redirect: false
		}
	},
	'coin_management': {
		title_key: "Coin Management",
		icon: "glyphicon glyphicon glyphicon-compressed",
		state: "coinManagement",
		menu: true,
		permission: {
			all: false
		}
	},
	'pickup_request_management': {
		title_key: "Pickup Request",
		icon: "glyphicon glyphicon-inbox",
		state: "pickupRequestManagement",
		menu: true,
		permission: {
			view: false,
			edit: false,
			delete: false,
			default_redirect: false
		}
	},
	"atm_codes_management": {
		title_key: 'common.side_menu.atm_codes_mgmt',
		icon: 'glyphicon glyphicon-modal-window',
		state: 'atmCodesManagement',
		menu: true,
		permission: {
			all: false
		}
	},
	"system_configuration": {
		title_key: 'System Configuration',
		icon: 'glyphicon glyphicon-modal-window',
		state: 'systemConfiguration',
		menu: true,
		permission: {
			all: false
		}
	},
	"tnt_app_event_logs": {
		title_key: 'TNT App Event Logs',
		icon: 'glyphicon glyphicon-list-alt',
		state: 'appEventLogs',
		menu: true,
		permission: {
			all: false
		}
	}
	// 'vault_balance': {
	// 	title_key: 'common.side_menu.vault_balance',
	// 	icon: 'glyphicon glyphicon-piggy-bank',
	// 	state: 'vaultBalance',
	// 	menu: true,
	// 	permission: {
	// 		all: false
	// 	}
	// }
};

var AuthFactory = function AuthFactory($http, $cookies) {
	var login = function login(userCredentials) {
		return $http.post(_app2.default.api + '/user/authenticate', userCredentials).then(function (res) {
			var data = res.data;
			if (data && data.message !== 'failed' && !data.validate2FA) {
				$cookies.putObject('user', data);

				localStorage.setItem('user', data.id);
				localStorage.setItem('loginTime', new Date().getTime());
				localStorage.setItem('email', data.email);
				localStorage.setItem('name', data.name);
				return res.data;
			} else {
				return res.data;
			}
		});
	};

	var isUserEmailExist = function isUserEmailExist(userCredentials) {
		return $http.post(_app2.default.api + '/user/verify-email', userCredentials).then(function (res) {
			return res.data;
		});
	};
	var resetUserPassword = function resetUserPassword(userCredentials) {
		return $http.post(_app2.default.api + '/user/reset-password', userCredentials).then(function (res) {
			return res.data;
		});
	};

	var isAuthenticated = function isAuthenticated() {
		return !!localStorage.getItem('email') || !!localStorage.getItem('user');
	};

	var logout = function logout() {
		return $http.post(_app2.default.api + '/user/logout').then(function (res) {
			localStorage.removeItem('user');
			localStorage.removeItem('loginTime');
			localStorage.removeItem('email');
			localStorage.removeItem('name');
			localStorage.removeItem('sessionLength');
		});
	};

	var permissionMap = function permissionMap() {
		return permissions;
	};
	var permission = function permission() {
		var permissionsCopy = angular.copy(permissions);

		// vault tab is commented out in setting tabs
		delete permissionsCopy.setting.child['setting-vault'];
		return permissionsCopy;
	};

	return {
		login: login,
		logout: logout,
		permissionMap: permissionMap,
		isAuthenticated: isAuthenticated,
		permission: permission,
		isUserEmailExist: isUserEmailExist,
		resetUserPassword: resetUserPassword
	};
};

AuthFactory.$inject = ['$http', '$cookies'];

exports.default = AuthFactory;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _access_denied = __webpack_require__(1613);

var _access_denied2 = _interopRequireDefault(_access_denied);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var access_deniedModule = angular.module('access_denied', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/app/login');

  $stateProvider.state('access_denied', {
    url: '/access_denied',
    component: 'accessDenied',
    data: {
      requireLogin: true
    },
    parent: 'app'
  });
}]).component('accessDenied', _access_denied2.default).name;

exports.default = access_deniedModule;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationHoldsController = function () {
  /*@ngInject*/
  LocationHoldsController.$inject = ["Auth", "$state", "User", "UserService", "RouteService", "DataCounter", "$translate", "$location", "$q", "Modal", "BranchService", "HoldLocationService", "$scope", "DateUtil", "SetupService", "$filter", "Navigation", "UsersService", "UserBranchService", "$rootScope"];
  function LocationHoldsController(Auth, $state, User, UserService, RouteService, DataCounter, $translate, $location, $q, Modal, BranchService, HoldLocationService, $scope, DateUtil, SetupService, $filter, Navigation, UsersService, UserBranchService, $rootScope) {
    var _this = this;

    (0, _classCallCheck3.default)(this, LocationHoldsController);

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.Modal = Modal;
    this.DataCounter = DataCounter;
    this.$scope = $scope;
    this.HoldLocationService = HoldLocationService;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.sortColumn = "locationId";
    this.reverseSort = true;
    this.allowBulkRelease = true;
    this.moment = moment;
    this.$filter = $filter;
    this.Navigation = Navigation;
    this.UsersService = UsersService;
    this.UserBranchService = UserBranchService;
    this.$rootScope = $rootScope;

    this.model = {
      loading: false,
      lastChecked: null,
      search: null,
      branch: User.getUser().branchId,
      dateRange: {
        startDate: null,
        endDate: null
      },
      includeReleased: false,

      dateRangPickerOptions: {
        autoApply: true,
        maxDate: moment(),
        eventHandlers: {
          'apply.daterangepicker': function applyDaterangepicker() {
            _this.loadData();
          }
        },
        ranges: {
          'Today': [moment().startOf('day'), moment()],
          'Current Week': [moment().startOf('week'), moment()],
          'Current Month': [moment().startOf('month'), moment()]
        }
      }
    };
    this.statusList = [{
      lable: 'All',
      value: ''
    }, {
      lable: 'On Hold',
      value: 'ON_HOLD'
    }, {
      lable: 'Released',
      value: 'RELEASED'
    }];
    this._searchStatus = 'ON_HOLD';

    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: 10,
      maxPages: 10
    };

    this.locations = [];
    this.branches = [];
    this.currentVaultDate = "";
    this.userDetails = this.User.getUser();
    this.loggedInUser = this.User.getUser().id;
    this.localLang = {
      selectAll: this.$translate.instant('common.selectall'),
      selectNone: this.$translate.instant('common.selectnone'),
      reset: this.$translate.instant('shipmentBatch.reset'),
      search: this.$translate.instant('common.search'),
      nothingSelected: this.$translate.instant('branch.all_branches') //default-label is deprecated and replaced with this.
    };
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/location-holds');
  }

  (0, _createClass3.default)(LocationHoldsController, [{
    key: 'loadPermission',
    value: function loadPermission() {
      var _this2 = this;

      this.acl = {};
      this.hasACL = {};

      [].forEach(function (permissionKey) {
        _this2.acl[permissionKey] = _this2.User.getACL(permissionKey);

        _this2.hasACL[permissionKey] = {};

        _this2.acl[permissionKey].forEach(function (permission) {
          _this2.hasACL[permissionKey][permission] = true;
        });
      });
    }
  }, {
    key: 'updateLastChecked',
    value: function updateLastChecked() {
      this.model.lastChecked = moment(this.currentVaultDate).format('MM-DD-YYYY');
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      this.loadData();
    }
  }, {
    key: 'search',
    value: function search() {
      this.pagination.page = 1;
      this.loadData();
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      this.model.search = this.model.search || '';
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'locationId',
            condition: 'like',
            data: '%' + this.model.search + '%'
          }],
          operator: 'AND'
        }
      };

      if (this._searchStatus) {
        searchObj.queryJSON.rules.push({
          field: 'status',
          condition: '=',
          data: this._searchStatus
        });
      }
      // if (this.model.dateRange.startDate && this.model.dateRange.endDate) {
      //   searchObj.queryJSON.rules.push({
      //     field: 'holdDate',
      //     condition: '>',
      //     data: this.model.dateRange.startDate.toDate()
      //   });
      //   searchObj.queryJSON.rules.push({
      //     field: 'holdDate',
      //     condition: '<',
      //     data: this.model.dateRange.endDate.toDate()
      //   });
      // }

      return searchObj.queryJSON.rules.length ? searchObj : null;
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      setTimeout(function () {
        // const searchObj = this.generateSearchObj();
        _this3.model.loading = true;
        _this3.updateLastChecked();

        var branch = _this3.model.selectedBranch && _this3.model.selectedBranch.length ? _this3.model.selectedBranch.map(function (d) {
          return d.branchId;
        }).toString() : _this3.model.branch;

        // return this.HoldLocationService.all(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
        _this3.HoldLocationService.getHoldLocation(_this3.model.search, branch, _this3._searchStatus, _this3.pagination.pageLimit, (_this3.pagination.page - 1) * _this3.pagination.pageLimit).then(function (data) {
          _this3.pagination.total = data.total;
          _this3.pagination.loading = false;
          _this3.locations = data.results;

          var isOnHold = _this3.locations.filter(function (loc) {
            return loc.status == 'ON_HOLD';
          });

          var obj = { totalRecords: data.total };
          _this3.$rootScope.$broadcast('setLocationHoldCount', obj);

          _this3.allowBulkRelease = isOnHold.length ? false : true;
        }).catch(function (err) {
          // this.error = err.message;
          if (err && err.data && err.data.message) {
            _this3.Modal.errorModal(err.data.message);
          }
          console.log(err);
        }).finally(function () {
          _this3.model.loading = false;
        });
      });
    }

    // release location from Hold

  }, {
    key: 'releaseLocation',
    value: function releaseLocation(heldLocation) {
      var _this4 = this;

      if (this.allowOnce) return;
      this.allowOnce = true;

      this.UsersService.checkSupervisor(this.loggedInUser).then(function (userInfo) {
        _this4.Modal.locationHoldRelease(heldLocation, !userInfo.supervisor, function (_ref) {
          var supervisorId = _ref.supervisorId,
              comment = _ref.comment,
              modal = _ref.modal;

          // const { location: { id } } = heldLocation;

          _this4.HoldLocationService.release(userInfo.supervisor ? userInfo.id : supervisorId, heldLocation.locationId, comment, _this4.model.branch).then(function (holdLocationData) {
            _this4.allowOnce = false;
            var data = _this4.DataCounter.getCounterForLocationHold();
            _this4.DataCounter.setCounterForLocationHold(data - 1);
            modal.close();
            _this4.refresh();
          }).catch(function (err) {
            _this4.allowOnce = false;
            var errorCode = err && err.data && err.data.message;
            modal.close();
            if (errorCode) {
              _this4.Modal.errorModal('error.' + errorCode);
            } else {
              console.log(err);
            }
          });
        }, function (_ref2) {
          var modal = _ref2.modal;

          _this4.allowOnce = false;
          if (modal) modal.close();
        });
      }).catch(function (err) {
        _this4.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this5 = this;

      // this.model.dateRange.startDate = this.model.dateRangPickerOptions.ranges.Today[0];
      // this.model.dateRange.endDate = this.model.dateRangPickerOptions.ranges.Today[1];
      this.model.dateRange;

      this.$q.all([this.SetupService.get(this.model.branch), this.loadUserBranches()]).then(function (data) {
        _this5.currentVaultDate = _this5.DateUtil.getUTCDate(data[0].currentVaultDate);
      }).then(function () {
        _this5.loadData();
        _this5.loadPermission();
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'bulkReleased',
    value: function bulkReleased() {
      var _this6 = this;

      if (this.isReleased) return;
      this.isReleased = true;

      this.UsersService.checkSupervisor(this.loggedInUser).then(function (userInfo) {
        _this6.Modal.locationHoldRelease(false, !userInfo.supervisor, function (_ref3) {
          var supervisorId = _ref3.supervisorId,
              comment = _ref3.comment,
              modal = _ref3.modal;

          _this6.HoldLocationService.release(userInfo.supervisor ? userInfo.id : supervisorId, null, comment, _this6.model.branch).then(function (holdLocationData) {
            modal.close();
            _this6.isReleased = false;
            var data = _this6.DataCounter.getCounterForLocationHold();
            _this6.DataCounter.setCounterForLocationHold(0);
          }).then(function () {
            _this6.loadData();
            _this6.isReleased = false;
          }).catch(function (err) {
            modal.close();
            var errorCode = err && err.data && err.data.message;
            _this6.isReleased = false;
            if (errorCode) {
              _this6.Modal.errorModal('error.' + errorCode);
            } else {
              console.log(err);
            }
          });
        }, function (_ref4) {
          var modal = _ref4.modal;

          _this6.isReleased = false;
          if (modal) modal.close();
        });
      }).catch(function (err) {
        _this6.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: 'SortData',
    value: function SortData(column) {
      this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
      this.sortColumn = column;
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(locationId) {
      this.Navigation.goToServiceHistory(locationId, null, true, null);
    }
  }, {
    key: 'loadUserBranches',
    value: function loadUserBranches() {
      var _this7 = this;

      this.UserBranchService.getUserBranches(this.loggedInUser).then(function (data) {
        _this7.model.userBranchList = data.results;
        _this7.model.totalBranches = _this7.model.userBranchList.length;

        _this7.model.userBranchList.filter(function (branch) {
          if (branch.branchId == _this7.model.branch) {
            branch.ticked = true;
          }
        });
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'resetPagination',
    value: function resetPagination() {
      this.pagination.page = 1;
    }
  }]);
  return LocationHoldsController;
}();

exports.default = LocationHoldsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _settings = __webpack_require__(2067);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var settingsModule = angular.module('settings', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('settings', {
    url: '/settings',
    component: 'settings',
    data: {
      requireLogin: true
    },
    parent: 'app',
    children: ['users', 'branch', 'batch', 'itemType', 'items', 'location', 'carrier', 'truck', 'holiday', 'routes', 'log', 'branch_funding_source', 'reset_atm_code', 'service-settings', 'branch_funding_source_holiday', 'delivery_region_routing', 'service_ticket_parts', 'preventative-maintenance'],
    resolve: {
      acl: ["User", function acl(User) {
        return User.getACL('setting');
      }]
    }
  }).state('users', {
    url: '/users',
    component: 'users',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('branch', {
    url: '/branch',
    component: 'branch',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  })
  // .state('customer', {
  //   url: '/customer',
  //   component: 'customer',
  //   parent: 'settings',
  //   resolve: {
  //     hasACL: () => ({})
  //   }
  // })
  // .state('contract', {
  //   url: '/contract',
  //   component: 'contract',
  //   parent: 'settings',
  //   resolve: {
  //     hasACL: () => ({})
  //   }
  // })
  .state('items-type', {
    url: '/items-type',
    component: 'itemType',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('items', {
    url: '/items',
    component: 'items',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('routes', {
    url: '/routes',
    component: 'routes',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('location', {
    url: '/location',
    component: 'location',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  })
  // .state('message', {
  //   url: '/message',
  //   component: 'message',
  //   parent: 'settings',
  //   resolve: {
  //     hasACL: () => ({}),
  //     testing2: () => 'dsadas'
  //   }
  // })
  .state('carrier', {
    url: '/carrier',
    component: 'carrier',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  })
  // .state('shiptype', {
  //   url: '/shiptype',
  //   component: 'shiptype',
  //   parent: 'settings',
  //   resolve: {
  //     hasACL: () => ({})
  //   }
  // })
  .state('truck', {
    url: '/truck',
    component: 'truck',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('vault', {
    url: '/vault',
    component: 'vault',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('batch', {
    url: '/batch',
    component: 'batch',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('holiday', {
    url: '/holiday',
    component: 'holiday',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  })
  // .state('setup', {
  //   url: '/setup',
  //   component: 'setup',
  //   parent: 'settings',
  //   resolve: {
  //     hasACL: () => ({})
  //   }
  // })
  // .state('denomination', {
  //   url: '/denomination',
  //   component: 'denomination',
  //   parent: 'settings',
  //   resolve: {
  //     hasACL: () => ({})
  //   }
  // })
  .state('branch-funding-source', {
    url: '/branch-funding-source',
    component: 'branchFundingSource',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('log', {
    url: '/log',
    component: 'log',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('tntBilling', {
    url: '/tnt-billing',
    component: 'tntBilling',
    data: {
      requireLogin: true,
      requireACL: 'tnt_billing.view'
    },
    parent: 'app',
    children: ['tnt_billing_billable_events', 'tnt_billing_billing_category', 'tnt_billing_contract', 'tnt_billing_customer', 'tnt_billing_location_distance', 'tnt_billing_fuel_surcharges'],
    resolve: {
      acl: ["User", function acl(User) {
        return User.getACL('tntBilling');
      }]
    }
  }).state('tntControl', {
    url: '/tnt-control',
    component: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control.view'
    },
    parent: 'app',
    children: [
    // 'tnt_control_configuration',
    'tnt_control_branch_setup', 'tnt_control_shiptype', 'tnt_control_denomination', 'tnt_control_currency', 'tnt_control_message', 'tnt_control_mobile_app'],
    resolve: {
      acl: ["User", function acl(User) {
        return User.getACL('tntControl');
      }]
    }
  }).state('reporting', {
    url: '/reporting',
    component: 'reporting',
    data: {
      requireLogin: true,
      requireACL: 'reporting.view'
    },
    parent: 'app',
    children: ['reporting_liability', 'reporting_route_performance'],
    resolve: {
      acl: ["User", function acl(User) {
        return User.getACL('_reporting');
      }]
    }
  }).state('branchManagement', {
    url: '/branch-management',
    component: 'branchManagement',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt.view'
    },
    parent: 'app',
    children: ['branch_mgmt_routes', 'branch_mgmt_locations', 'branch_mgmt_items', 'branch_mgmt_tankers', 'branch_mgmt_bagouts', 'branch_mgmt_orders', 'branch_mgmt_item_holds', 'branch_mgmt_location_holds', 'branch_mgmt_bypass_code', 'branch_mgmt_daily_balance_sheet', 'branch_mgmt_monthly_report', 'branch_mgmt_deleted_shipments', 'branch_mgmt_cancelled_shipments', 'branch_mgmt_branch_performance', 'branch_mgmt_final_residual_count_commit', 'branch_mgmt_cash_transactions', 'branch_mgmt_tnt_bypass_code', 'branch_mgmt_physical_cash_count', 'branch_mgmt_lock_open_errors', 'branch_mgmt_billing_approval', 'branch_mgmt_count_variances']
  })
  // .state('mobile-app', {
  //   url: '/mobile-app',
  //   component: 'mobileApp',
  //   parent: 'settings',
  //   resolve: {
  //     hasACL: () => ({})
  //   }
  // })
  // .state('accounts', {
  //   url: '/accounts',
  //   component: 'accounts',
  //   parent: 'settings',
  //   // resolve: {
  //   //   hasACL: () => ({})
  //   // }
  // })
  .state('reset-atm-code', {
    url: '/reset-atm-code',
    component: 'resetAtmCode',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('soft-deleted-shipments', {
    url: '/soft-deleted-shipments',
    component: 'softDeletedShipments',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('service-settings', {
    url: '/service-settings',
    component: 'serviceSettings',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  })
  // .state('billable-events', {
  //   url: '/billable-events',
  //   component: 'billableEvents',
  //   parent: 'settings',
  //   resolve: {
  //     hasACL: () => ({})
  //   }
  // })
  // .state('billing-category', {
  //   url: '/billing-category',
  //   component: 'billingCategory',
  //   parent: 'settings',
  //   resolve: {
  //     hasACL: () => ({})
  //   }
  // })
  .state('branch-funding-source-holiday', {
    url: '/branch-funding-source-holiday',
    component: 'branchFundingSourceHoliday',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('delivery-region-routing', {
    url: '/delivery-region-routing',
    component: 'deliveryRegionRouting',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('service-ticket-parts', {
    url: '/service-ticket-parts',
    component: 'serviceTicketParts',
    parent: 'settings',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('preventative-maintenance', {
    url: '/v2/index.html#/preventative-maintenance',
    component: 'preventativeMaintenance',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  });
}]).component('settings', _settings2.default).name;

exports.default = settingsModule;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTBillingBase2 = __webpack_require__(120);

var _CommonTNTBillingBase3 = _interopRequireDefault(_CommonTNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingCategoryBaseController = function (_CommonTNTBillingBase) {
    BillingCategoryBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(BillingCategoryBaseController, _CommonTNTBillingBase);

    /*@ngInject*/
    function BillingCategoryBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, BillingCategoryBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BillingCategoryBaseController.__proto__ || (0, _getPrototypeOf2.default)(BillingCategoryBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        _this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: 'Yes',
                off: 'No'
            },
            onColor: 'success',
            offColor: 'danger'
        };
        return _this;
    }

    (0, _createClass3.default)(BillingCategoryBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.Modal.confirm({
                    header: _this2.$translate.instant('billingCategory.create_another_title'),
                    message: _this2.$translate.instant('billingCategory.create_another_message'),
                    callback: function callback(_ref) {
                        var modal = _ref.modal,
                            $scope = _ref.$scope;

                        _this2.reset();
                        modal.close();
                        resolve(true);
                    },
                    negative: function negative(_ref2) {
                        var modal = _ref2.modal,
                            $scope = _ref2.$scope;

                        modal.close();
                        window.history.go(-1);
                        resolve(false);
                    },
                    type: 'primary',
                    buttons: ['common.yes', 'common.no']
                });
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + 'is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return BillingCategoryBaseController;
}(_CommonTNTBillingBase3.default);

exports.default = BillingCategoryBaseController;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CommonTNTBillingBase2 = __webpack_require__(120);

var _CommonTNTBillingBase3 = _interopRequireDefault(_CommonTNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractTypeBaseController = function (_CommonTNTBillingBase) {
    ContractTypeBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
    (0, _inherits3.default)(ContractTypeBaseController, _CommonTNTBillingBase);

    /*@ngInject*/
    function ContractTypeBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
        (0, _classCallCheck3.default)(this, ContractTypeBaseController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ContractTypeBaseController.__proto__ || (0, _getPrototypeOf2.default)(ContractTypeBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

        _this.errors = {};
        _this.loading = false;
        _this.errorMessage = '';
        _this.model = {};
        _this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: 'Yes',
                off: 'No'
            },
            onColor: 'success',
            offColor: 'danger'
        };
        return _this;
    }

    (0, _createClass3.default)(ContractTypeBaseController, [{
        key: 'askCreate',
        value: function askCreate() {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.Modal.confirm({
                    header: _this2.$translate.instant('contractType.create_another_title'),
                    message: _this2.$translate.instant('contractType.create_another_message'),
                    callback: function callback(_ref) {
                        var modal = _ref.modal,
                            $scope = _ref.$scope;

                        _this2.reset();
                        modal.close();
                        resolve(true);
                    },
                    negative: function negative(_ref2) {
                        var modal = _ref2.modal,
                            $scope = _ref2.$scope;

                        modal.close();
                        window.history.go(-1);
                        resolve(false);
                    },
                    type: 'primary',
                    buttons: ['common.yes', 'common.no']
                });
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.clearErrors();
            for (var key in this.model) {
                if (!this.model[key]) {
                    this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + 'is mandatory');
                }
            }
            return (0, _keys2.default)(this.errors).length <= 0;
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.errors = {};
            this.errorMessage = '';
        }
    }, {
        key: 'addError',
        value: function addError(id, message) {
            this.errors[id] = message;
        }
    }]);
    return ContractTypeBaseController;
}(_CommonTNTBillingBase3.default);

exports.default = ContractTypeBaseController;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _customerBase = __webpack_require__(178);

var _customerBase2 = _interopRequireDefault(_customerBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceOptionController = function (_customerBaseControll) {
	ServiceOptionController.$inject = ["Modal", "$stateParams", "$translate", "$q", "Auth", "$state", "$scope"];
	(0, _inherits3.default)(ServiceOptionController, _customerBaseControll);

	/*@ngInject*/
	function ServiceOptionController(Modal, $stateParams, $translate, $q, Auth, $state, $scope) {
		(0, _classCallCheck3.default)(this, ServiceOptionController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceOptionController.__proto__ || (0, _getPrototypeOf2.default)(ServiceOptionController)).call(this, Auth, $state, Modal, $translate, $stateParams, $scope));

		_this.unitBasisOptions = [{
			label: $translate.instant('common.rolled_coin'),
			key: 'rolled_coin'
		}, {
			label: $translate.instant('common.loose_coin'),
			key: 'loose_coin'
		}, {
			label: $translate.instant('common.currency_deposit'),
			key: 'currency_deposit'
		}, {
			label: $translate.instant('common.transport'),
			key: 'transport'
		}, {
			label: $translate.instant('common.non_scheduled_transport'),
			key: 'non_scheduled_transport'
		}, {
			label: $translate.instant('common.stop_time'),
			key: 'stop_time'
		}, {
			label: $translate.instant('common.excess_stop_time'),
			key: 'excess_stop_time'
		}, {
			label: $translate.instant('common.ATM_load'),
			key: 'ATM_load'
		}, {
			label: $translate.instant('common.AMT_count'),
			key: 'AMT_count'
		}, {
			label: $translate.instant('common.FLM'),
			key: 'FLM'
		}, {
			label: $translate.instant('common.Misc'),
			key: 'Misc'
		}];

		_this.unitBasisOptionsChildren = {
			'rolled_coin': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			}, {
				label: $translate.instant('common.box'),
				value: 'PER_BOX'
			}, {
				label: $translate.instant('common.roll'),
				value: 'PER_ROLL'
			}, {
				label: $translate.instant('common.thousand'),
				value: 'PER_THOUSAND'
			}],
			'loose_coin': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			}, {
				label: $translate.instant('common.bag'),
				value: 'PER_BAG'
			}, {
				label: $translate.instant('common.amount'),
				value: 'PER_AMOUNT'
			}],
			'currency_deposit': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			}, {
				label: $translate.instant('common.bill'),
				value: 'PER_BILL'
			}, {
				label: $translate.instant('common.thousand'),
				value: 'PER_THOUSAND'
			}, {
				label: $translate.instant('common.hundred'),
				value: 'PER_HUNDRED'
			}, {
				label: $translate.instant('customer.deposit'),
				value: 'PER_DEPOSIT'
			}],
			'transport': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			}, {
				label: $translate.instant('common.trip'),
				value: 'PER_TRIP'
			}, {
				label: $translate.instant('common.monthlyprebill'),
				value: 'MONTHLY_PREBILL'
			}],
			'non_scheduled_transport': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			}, {
				label: $translate.instant('common.trip'),
				value: 'PER_TRIP'
			}],
			'stop_time': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			}, {
				label: $translate.instant('common.minute'),
				value: 'PER_MINUTE'
			}, {
				label: $translate.instant('common.flat'),
				value: 'FLAT_RATE'
			}],
			'excess_stop_time': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			}, {
				label: $translate.instant('common.minute'),
				value: 'PER_MINUTE'
			}, {
				label: $translate.instant('common.flat'),
				value: 'FLAT_RATE'
			}],
			'ATM_load': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			}, {
				label: $translate.instant('common.load'),
				value: 'PER_LOAD'
			}, {
				label: $translate.instant('common.flat'),
				value: 'FLAT_MONTHLY'
			}],
			'AMT_count': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			}, {
				label: $translate.instant('common.count'),
				value: 'PER_COUNT'
			}, {
				label: $translate.instant('common.monthly'),
				value: 'FLAT_MONTHLY'
			}, {
				label: $translate.instant('common.load'),
				value: 'PER_LOAD'
			}],
			'FLM': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			}, {
				label: $translate.instant('common.monthly'),
				value: 'FLAT_MONTHLY'
			}, {
				label: $translate.instant('common.call'),
				value: 'PER_CALL'
			}],
			'Misc': [{
				label: $translate.instant('common.none'),
				value: 'NONE'
			}, {
				label: $translate.instant('common.unit'),
				value: 'PER_UNIT'
			}, {
				label: $translate.instant('common.monthly'),
				value: 'FLAT_MONTHLY'
			}]
		};

		_this.unitBasisModels = {
			'rolled_coin': {
				basis: 'rolledCoinRateBasis',
				rate: 'rolledCoinChargeRate',
				billToCategory: 'rolledCoinBillToCategory'
			},
			'loose_coin': {
				basis: 'looseCoinRateBasis',
				rate: 'looseCoinChargeRate',
				billToCategory: 'looseCoinBillToCategory'
			},
			'currency_deposit': {
				basis: 'currencyDepositRateBasis',
				rate: 'currencyDepositChargeRate',
				billToCategory: 'currencyDepositBillToCategory'
			},
			'transport': {
				basis: 'transportRateBasis',
				rate: 'transportChargeRate',
				billToCategory: 'transportBillToCategory'
			},
			'non_scheduled_transport': {
				basis: 'noScheduledTransportRateBasis',
				rate: 'noScheduledTransportChargeRate',
				billToCategory: 'noScheduledTransportBillToCategory'
			},
			'stop_time': {
				basis: 'stopTimeRateBasis',
				rate: 'stopTimeChargeRate',
				billToCategory: 'stopTimeBillToCategory'
			},
			'excess_stop_time': {
				basis: 'excessStopTimeRateBasis',
				rate: 'excessStopTimeChargeRate',
				billToCategory: 'excessStopTimeBillToCategory'
			},
			'ATM_load': {
				basis: 'atmLoadRateBasis',
				rate: 'atmLoadChargeRate',
				billToCategory: 'atmLoadBillToCategory'
			},
			'AMT_count': {
				basis: 'atmCountRateBasis',
				rate: 'atmCountChargeRate',
				billToCategory: 'atmCountBillToCategory'
			},
			'FLM': {
				basis: 'flmRateBasis',
				rate: 'flmChargeRate',
				billToCategory: 'flmBillToCategory'
			},
			'Misc': {
				basis: 'miscItemRateBasis',
				rate: 'miscItemChargeRate',
				billToCategory: 'miscItemBillToCategory'
			}
		};

		_this.serviceOptions = _this.unitBasisOptions;

		_this.selectedUnitBasisOptions = [];

		_this.billToCategoryOptions = [{
			label: $translate.instant('contract.changeOrder'),
			value: 'CHANGE_ORDER'
		}, {
			label: $translate.instant('contract.transport'),
			value: 'TRANSPORT'
		}, {
			label: $translate.instant('customer.deposit'),
			value: 'DEPOSIT'
		}];

		_this.DEFAULT_BASIS = null;
		_this.DEFAULT_BILL_TO_CATEGORY = null;
		return _this;
	}

	(0, _createClass3.default)(ServiceOptionController, [{
		key: '$onInit',
		value: function $onInit() {
			this.selectedUnitBasisOptions = this.getUnitBasisOptions();
		}
	}, {
		key: 'removeUnitBasisOption',
		value: function removeUnitBasisOption(index) {
			var serviceToRemove = this.selectedUnitBasisOptions[index];
			var models = serviceToRemove.serviceName && serviceToRemove.serviceName.key ? this.unitBasisModels[serviceToRemove.serviceName.key] : null;

			if (models) {
				this.model[models.basis] = null;
				this.model[models.rate] = null;
				this.model[models.billToCategory] = null;
			}
			this.selectedUnitBasisOptions.splice(index, 1);
		}
	}, {
		key: 'isNoneSelected',
		value: function isNoneSelected(unitBasisOption) {
			return this.model[unitBasisOption.models.basis] === 'NONE';
		}
	}, {
		key: 'addUnitBasisOption',
		value: function addUnitBasisOption() {
			this.selectedUnitBasisOptions.push({
				serviceName: null,
				options: null,
				models: null
			});
		}

		// checkForDuplicates(unitBasisOption, index){
		// 	var found = false;
		// 	this.selectedUnitBasisOptions.forEach(function(opt, idx){
		// 		if(index != idx &&
		// 			unitBasisOption.serviceName === opt.serviceName &&
		// 			unitBasisOption.basis === opt.basis &&
		// 			unitBasisOption.billToCategory === opt.billToCategory){
		// 				found = true;	
		// 			}
		// 	});

		// 	if(found) {
		// 		unitBasisOption.duplicate = true;
		// 	}else{
		// 		unitBasisOption.duplicate = false;
		// 	}
		// }

	}, {
		key: 'unitBasisOptionChanged',
		value: function unitBasisOptionChanged(unitBasisOption, index) {
			var oldItems = this.getUnitBasisOptions();
			var selectedService = unitBasisOption.serviceName.key;
			unitBasisOption.options = this.unitBasisOptionsChildren[selectedService];
			unitBasisOption.models = this.unitBasisModels[selectedService];

			if (!this.model[unitBasisOption.models.basis]) {
				this.model[unitBasisOption.models.basis] = this.DEFAULT_BASIS;
			}
			if (!this.model[unitBasisOption.models.billToCategory]) {
				this.model[unitBasisOption.models.billToCategory] = this.DEFAULT_BILL_TO_CATEGORY;
			}
			if (!this.model[unitBasisOption.models.rate]) {
				this.model[unitBasisOption.models.rate] = null;
			}

			if (oldItems[index] && oldItems[index].serviceName.key !== unitBasisOption.serviceName.key) {
				this.model[oldItems[index].models.basis] = null;
				this.model[oldItems[index].models.billToCategory] = null;
				this.model[oldItems[index].models.rate] = null;
			}
		}
	}, {
		key: 'getUnitBasisOptions',
		value: function getUnitBasisOptions() {
			var _this2 = this;

			var unitBasisOptions = [];
			var billToCategoryOptions = [];
			this.serviceOptions.forEach(function (serviceName, index) {
				var models = _this2.unitBasisModels[serviceName.key];

				if (_this2.model[models.basis] && _this2.model[models.basis] !== 'NONE' || _this2.model[models.rate] || _this2.model[models.billToCategory]) {
					unitBasisOptions.push({
						serviceName: serviceName,
						options: _this2.unitBasisOptionsChildren[serviceName.key],
						models: _this2.unitBasisModels[serviceName.key]

					});
				} else {
					_this2.model[models.basis] = null;
					_this2.model[models.rate] = null;
					_this2.model[models.billToCategory] = null;
				}
			});

			return unitBasisOptions;
		}
	}]);
	return ServiceOptionController;
}(_customerBase2.default);

exports.default = ServiceOptionController;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _setupBase = __webpack_require__(179);

var _setupBase2 = _interopRequireDefault(_setupBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrefixTableController = function (_setupBaseController) {
  PrefixTableController.$inject = ["Auth", "$state", "User", "SetupService", "Modal", "$translate", "$stateParams", "$scope"];
  (0, _inherits3.default)(PrefixTableController, _setupBaseController);

  /*@ngInject*/

  function PrefixTableController(Auth, $state, User, SetupService, Modal, $translate, $stateParams, $scope) {
    (0, _classCallCheck3.default)(this, PrefixTableController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PrefixTableController.__proto__ || (0, _getPrototypeOf2.default)(PrefixTableController)).call(this, Auth, $state, User, SetupService, Modal, $translate, $stateParams, $scope));

    _this.avaialablePrefixes = [{ value: 'messenger', label: 'Messenger' }, { value: 'route', label: 'Route' }, { value: 'bagout', label: 'Bagout' }, { value: 'employee', label: 'Employee' }, { value: 'location', label: 'Location' }, { value: 'tanker', label: 'Tanker' }, { value: 'vehicle', label: 'Vehicle' }, { value: 'branch', label: 'Branch' }, { value: 'window', label: 'Window' }, { value: 'deliveryAndPickups', label: 'Delivery And Pickups' }];
    _this.model = [];
    _this.$scope = $scope;
    _this.prefixes = _this.prefixes || {};
    return _this;
  }

  (0, _createClass3.default)(PrefixTableController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.$scope.$watch(function () {
        return _this2.prefixes && (0, _stringify2.default)(_this2.prefixes);
      }, function (newValue, oldValue) {
        if (_this2.pullModel) {
          _this2.pullModel();
        }
      });

      this.$scope.$watch(function () {
        return (0, _stringify2.default)(_this2.model);
      }, function (newValue, oldValue) {
        if (!!_this2.model) {
          _this2.pushModel();
        }
      });
    }
  }, {
    key: 'pullModel',
    value: function pullModel() {
      var _this3 = this;

      var _loop = function _loop(prefixType) {
        var prefixArray = _this3.prefixes[prefixType];

        prefixArray.forEach(function (prefixChar) {
          _this3.model.push({
            type: prefixType,
            value: prefixChar
          });
        });
      };

      for (var prefixType in this.prefixes) {
        _loop(prefixType);
      }
    }
  }, {
    key: 'pushModel',
    value: function pushModel() {
      var newPrefix = {};

      this.model.forEach(function (_ref) {
        var type = _ref.type,
            value = _ref.value;

        if (newPrefix[type]) {
          newPrefix[type].push(value);
        } else {
          newPrefix[type] = [value];
        }
      });

      this.modelValue = newPrefix;
    }
  }, {
    key: 'addNewPrefix',
    value: function addNewPrefix() {
      this.model.push({
        type: null,
        value: ''
      });
    }
  }, {
    key: 'removePrefix',
    value: function removePrefix(index) {
      this.model.splice(index, 1);
    }

    // deletePrefixes(index) {
    //   console.log("555");
    //   this.Modal.confirm({
    //     header: this.$translate.instant('common.confirm_delete_title'),
    //     message: this.$translate.instant('common.confirm_delete_message'),
    //     callback: ({
    // 			modal,
    //       $scope
    // 		}) => {
    // 				this.model.splice(index, 1);
    // 				modal.close()					
    // 		},
    //     negative: ({
    // 			modal,
    //       $scope
    // 		}) => {
    //       modal.close()
    //     },
    //     type: 'primary',
    //     buttons: ['common.yes', 'common.no']
    //   })
    // }

  }]);
  return PrefixTableController;
}(_setupBase2.default);

exports.default = PrefixTableController;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en = __webpack_require__(2393);

var _en2 = _interopRequireDefault(_en);

var _es = __webpack_require__(2394);

var _es2 = _interopRequireDefault(_es);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languages = { E: _en2.default, S: _es2.default };

exports.default = languages;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(931);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!./britecharts.min.css", function() {
		var newContent = require("!!../../../css-loader/index.js!./britecharts.min.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(996);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./items.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./items.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1006);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./physical_cash_count.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./physical_cash_count.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1007);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./print_physical_cash_count.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./print_physical_cash_count.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1065);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_packed_orders.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_packed_orders.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1144);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./denomination.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./denomination.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1145);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./environment_config.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./environment_config.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(632)
var ieee754 = __webpack_require__(1538)
var isArray = __webpack_require__(1539)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(925);

__webpack_require__(618);

__webpack_require__(655);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = __webpack_require__(312);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularCookies = __webpack_require__(569);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularSanitize = __webpack_require__(601);

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _angularAnimate = __webpack_require__(565);

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _angularLoadingBar = __webpack_require__(598);

var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);

__webpack_require__(1576);

__webpack_require__(1887);

__webpack_require__(2399);

__webpack_require__(2442);

var _app = __webpack_require__(1547);

var _app2 = _interopRequireDefault(_app);

var _languageLoader = __webpack_require__(2392);

var _languageLoader2 = _interopRequireDefault(_languageLoader);

__webpack_require__(2911);

__webpack_require__(607);

__webpack_require__(604);

__webpack_require__(603);

__webpack_require__(566);

__webpack_require__(599);

__webpack_require__(572);

__webpack_require__(605);

__webpack_require__(3167);

__webpack_require__(608);

__webpack_require__(633);

__webpack_require__(2906);

__webpack_require__(570);

__webpack_require__(1536);

__webpack_require__(1540);

__webpack_require__(2908);

__webpack_require__(636);

__webpack_require__(567);

__webpack_require__(649);

__webpack_require__(2901);

__webpack_require__(2898);

__webpack_require__(573);

__webpack_require__(2900);

__webpack_require__(2910);

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _app3 = __webpack_require__(5);

var _app4 = _interopRequireDefault(_app3);

var _app5 = __webpack_require__(2389);

var _app6 = _interopRequireDefault(_app5);

var _app7 = __webpack_require__(2390);

var _app8 = _interopRequireDefault(_app7);

var _auth = __webpack_require__(523);

var _auth2 = _interopRequireDefault(_auth);

__webpack_require__(1548);

__webpack_require__(1544);

__webpack_require__(2909);

__webpack_require__(1549);

__webpack_require__(2902);

__webpack_require__(1545);

__webpack_require__(602);

__webpack_require__(1542);

__webpack_require__(1543);

__webpack_require__(2899);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.moment = _moment2.default;

_angular2.default.module('app', [_angularUiRouter2.default, _angularCookies2.default, _angularSanitize2.default, 'ngAnimate', 'angular-loading-bar', 'pascalprecht.translate', 'ng-currency', 'ui.bootstrap', 'ui.bootstrap.tpls', 'ui.bootstrap.datetimepicker', 'ui.bootstrap.popover', 'ui.select', 'ui.calendar', 'ui.utils.masks', 'daterangepicker', 'frapontillo.bootstrap-switch', 'moment-picker', 'dndLists', "isteven-multi-select", 'ngToast', 'angular-barcode', 'app.common', 'app.components', 'app.layout', 'app.services', 'timer', 'ngIdle']).factory('LanguageLoaderService', _languageLoader2.default).constant('AppConstants', _app4.default).config(_app6.default).run(_app8.default).component('app', _app2.default);

/***/ }),
/* 543 */,
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module hooks */ /** */
var transition_1 = __webpack_require__(148);
var router_1 = __webpack_require__(292);
function addCoreResolvables(trans) {
    trans.addResolvable({ token: router_1.UIRouter, deps: [], resolveFn: function () { return trans.router; }, data: trans.router }, "");
    trans.addResolvable({ token: transition_1.Transition, deps: [], resolveFn: function () { return trans; }, data: trans }, "");
    trans.addResolvable({ token: '$transition$', deps: [], resolveFn: function () { return trans; }, data: trans }, "");
    trans.addResolvable({ token: '$stateParams', deps: [], resolveFn: function () { return trans.params(); }, data: trans.params() }, "");
    trans.entering().forEach(function (state) {
        trans.addResolvable({ token: '$state$', deps: [], resolveFn: function () { return state; }, data: state }, state);
    });
}
exports.registerAddCoreResolvables = function (transitionService) {
    return transitionService.onCreate({}, addCoreResolvables);
};
//# sourceMappingURL=coreResolvables.js.map

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module hooks */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
var trace_1 = __webpack_require__(83);
var rejectFactory_1 = __webpack_require__(123);
/**
 * A [[TransitionHookFn]] that skips a transition if it should be ignored
 *
 * This hook is invoked at the end of the onBefore phase.
 *
 * If the transition should be ignored (because no parameter or states changed)
 * then the transition is ignored and not processed.
 */
function ignoredHook(trans) {
    var ignoredReason = trans._ignoredReason();
    if (!ignoredReason)
        return;
    trace_1.trace.traceTransitionIgnored(trans);
    var pending = trans.router.globals.transition;
    // The user clicked a link going back to the *current state* ('A')
    // However, there is also a pending transition in flight (to 'B')
    // Abort the transition to 'B' because the user now wants to be back at 'A'.
    if (ignoredReason === 'SameAsCurrent' && pending) {
        pending.abort();
    }
    return rejectFactory_1.Rejection.ignored().toPromise();
}
exports.registerIgnoredTransitionHook = function (transitionService) {
    return transitionService.onBefore({}, ignoredHook, { priority: -9999 });
};
//# sourceMappingURL=ignoredTransition.js.map

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module hooks */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A [[TransitionHookFn]] that rejects the Transition if it is invalid
 *
 * This hook is invoked at the end of the onBefore phase.
 * If the transition is invalid (for example, param values do not validate)
 * then the transition is rejected.
 */
function invalidTransitionHook(trans) {
    if (!trans.valid()) {
        throw new Error(trans.error());
    }
}
exports.registerInvalidTransitionHook = function (transitionService) {
    return transitionService.onBefore({}, invalidTransitionHook, { priority: -10000 });
};
//# sourceMappingURL=invalidTransition.js.map

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A factory which creates an onEnter, onExit or onRetain transition hook function
 *
 * The returned function invokes the (for instance) state.onEnter hook when the
 * state is being entered.
 *
 * @hidden
 */
function makeEnterExitRetainHook(hookName) {
    return function (transition, state) {
        var _state = state.$$state();
        var hookFn = _state[hookName];
        return hookFn(transition, state);
    };
}
/**
 * The [[TransitionStateHookFn]] for onExit
 *
 * When the state is being exited, the state's .onExit function is invoked.
 *
 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
 *
 * See: [[IHookRegistry.onExit]]
 */
var onExitHook = makeEnterExitRetainHook('onExit');
exports.registerOnExitHook = function (transitionService) {
    return transitionService.onExit({ exiting: function (state) { return !!state.onExit; } }, onExitHook);
};
/**
 * The [[TransitionStateHookFn]] for onRetain
 *
 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
 *
 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
 *
 * See: [[IHookRegistry.onRetain]]
 */
var onRetainHook = makeEnterExitRetainHook('onRetain');
exports.registerOnRetainHook = function (transitionService) {
    return transitionService.onRetain({ retained: function (state) { return !!state.onRetain; } }, onRetainHook);
};
/**
 * The [[TransitionStateHookFn]] for onEnter
 *
 * When the state is being entered, the state's .onEnter function is invoked.
 *
 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
 *
 * See: [[IHookRegistry.onEnter]]
 */
var onEnterHook = makeEnterExitRetainHook('onEnter');
exports.registerOnEnterHook = function (transitionService) {
    return transitionService.onEnter({ entering: function (state) { return !!state.onEnter; } }, onEnterHook);
};
//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module hooks */ /** */
var predicates_1 = __webpack_require__(21);
var coreservices_1 = __webpack_require__(40);
var targetState_1 = __webpack_require__(90);
/**
 * A [[TransitionHookFn]] that redirects to a different state or params
 *
 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
 *
 * See [[StateDeclaration.redirectTo]]
 */
var redirectToHook = function (trans) {
    var redirect = trans.to().redirectTo;
    if (!redirect)
        return;
    var $state = trans.router.stateService;
    function handleResult(result) {
        if (!result)
            return;
        if (result instanceof targetState_1.TargetState)
            return result;
        if (predicates_1.isString(result))
            return $state.target(result, trans.params(), trans.options());
        if (result['state'] || result['params'])
            return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
    }
    if (predicates_1.isFunction(redirect)) {
        return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
    }
    return handleResult(redirect);
};
exports.registerRedirectToHook = function (transitionService) {
    return transitionService.onStart({ to: function (state) { return !!state.redirectTo; } }, redirectToHook);
};
//# sourceMappingURL=redirectTo.js.map

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module hooks */
/** for typedoc */
var common_1 = __webpack_require__(15);
var resolveContext_1 = __webpack_require__(147);
var hof_1 = __webpack_require__(26);
/**
 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
 *
 * Registered using `transitionService.onStart({}, eagerResolvePath);`
 *
 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
 *
 * See [[StateDeclaration.resolve]]
 */
var eagerResolvePath = function (trans) {
    return new resolveContext_1.ResolveContext(trans.treeChanges().to)
        .resolvePath("EAGER", trans)
        .then(common_1.noop);
};
exports.registerEagerResolvePath = function (transitionService) {
    return transitionService.onStart({}, eagerResolvePath, { priority: 1000 });
};
/**
 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
 *
 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState);`
 *
 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
 *
 * See [[StateDeclaration.resolve]]
 */
var lazyResolveState = function (trans, state) {
    return new resolveContext_1.ResolveContext(trans.treeChanges().to)
        .subContext(state.$$state())
        .resolvePath("LAZY", trans)
        .then(common_1.noop);
};
exports.registerLazyResolveState = function (transitionService) {
    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: 1000 });
};
//# sourceMappingURL=resolve.js.map

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(15);
/**
 * A [[TransitionHookFn]] which updates global UI-Router state
 *
 * Registered using `transitionService.onBefore({}, updateGlobalState);`
 *
 * Before a [[Transition]] starts, updates the global value of "the current transition" ([[Globals.transition]]).
 * After a successful [[Transition]], updates the global values of "the current state"
 * ([[Globals.current]] and [[Globals.$current]]) and "the current param values" ([[Globals.params]]).
 *
 * See also the deprecated properties:
 * [[StateService.transition]], [[StateService.current]], [[StateService.params]]
 */
var updateGlobalState = function (trans) {
    var globals = trans.router.globals;
    var transitionSuccessful = function () {
        globals.successfulTransitions.enqueue(trans);
        globals.$current = trans.$to();
        globals.current = globals.$current.self;
        common_1.copy(trans.params(), globals.params);
    };
    var clearCurrentTransition = function () {
        // Do not clear globals.transition if a different transition has started in the meantime
        if (globals.transition === trans)
            globals.transition = null;
    };
    trans.onSuccess({}, transitionSuccessful, { priority: 10000 });
    trans.promise.then(clearCurrentTransition, clearCurrentTransition);
};
exports.registerUpdateGlobalState = function (transitionService) {
    return transitionService.onCreate({}, updateGlobalState);
};
//# sourceMappingURL=updateGlobals.js.map

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A [[TransitionHookFn]] which updates the URL after a successful transition
 *
 * Registered using `transitionService.onSuccess({}, updateUrl);`
 */
var updateUrl = function (transition) {
    var options = transition.options();
    var $state = transition.router.stateService;
    var $urlRouter = transition.router.urlRouter;
    // Dont update the url in these situations:
    // The transition was triggered by a URL sync (options.source === 'url')
    // The user doesn't want the url to update (options.location === false)
    // The destination state, and all parents have no navigable url
    if (options.source !== 'url' && options.location && $state.$current.navigable) {
        var urlOptions = { replace: options.location === 'replace' };
        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
    }
    $urlRouter.update(true);
};
exports.registerUpdateUrl = function (transitionService) {
    return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
};
//# sourceMappingURL=url.js.map

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module hooks */ /** for typedoc */
var common_1 = __webpack_require__(15);
var coreservices_1 = __webpack_require__(40);
/**
 * A [[TransitionHookFn]] which waits for the views to load
 *
 * Registered using `transitionService.onStart({}, loadEnteringViews);`
 *
 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
 * In angular 1, this includes loading the templates.
 */
var loadEnteringViews = function (transition) {
    var $q = coreservices_1.services.$q;
    var enteringViews = transition.views("entering");
    if (!enteringViews.length)
        return;
    return $q.all(enteringViews.map(function (view) { return $q.when(view.load()); })).then(common_1.noop);
};
exports.registerLoadEnteringViews = function (transitionService) {
    return transitionService.onFinish({}, loadEnteringViews);
};
/**
 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
 *
 * Registered using `transitionService.onSuccess({}, activateViews);`
 *
 * After a transition is complete, this hook deactivates the old views from the previous state,
 * and activates the new views from the destination state.
 *
 * See [[ViewService]]
 */
var activateViews = function (transition) {
    var enteringViews = transition.views("entering");
    var exitingViews = transition.views("exiting");
    if (!enteringViews.length && !exitingViews.length)
        return;
    var $view = transition.router.viewService;
    exitingViews.forEach(function (vc) { return $view.deactivateViewConfig(vc); });
    enteringViews.forEach(function (vc) { return $view.activateViewConfig(vc); });
    $view.sync();
};
exports.registerActivateViews = function (transitionService) {
    return transitionService.onSuccess({}, activateViews);
};
//# sourceMappingURL=views.js.map

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * # Core classes and interfaces
 *
 * The classes and interfaces that are core to ui-router and do not belong
 * to a more specific subsystem (such as resolve).
 *
 * @coreapi
 * @preferred
 * @module core
 */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
/** @internalapi */
var UIRouterPluginBase = (function () {
    function UIRouterPluginBase() {
    }
    UIRouterPluginBase.prototype.dispose = function (router) { };
    return UIRouterPluginBase;
}());
exports.UIRouterPluginBase = UIRouterPluginBase;
//# sourceMappingURL=interface.js.map

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(109));
__export(__webpack_require__(289));
__export(__webpack_require__(290));
__export(__webpack_require__(181));
//# sourceMappingURL=index.js.map

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/** @module path */ /** for typedoc */
__export(__webpack_require__(182));
__export(__webpack_require__(146));
//# sourceMappingURL=index.js.map

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/** @module resolve */ /** for typedoc */
__export(__webpack_require__(291));
__export(__webpack_require__(122));
__export(__webpack_require__(147));
//# sourceMappingURL=index.js.map

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(293));
__export(__webpack_require__(183));
__export(__webpack_require__(294));
__export(__webpack_require__(295));
__export(__webpack_require__(296));
__export(__webpack_require__(297));
__export(__webpack_require__(90));
//# sourceMappingURL=index.js.map

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * # Transition subsystem
 *
 * This module contains APIs related to a Transition.
 *
 * See:
 * - [[TransitionService]]
 * - [[Transition]]
 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
 *
 * @coreapi
 * @preferred
 * @module transition
 */ /** for typedoc */
__export(__webpack_require__(110));
__export(__webpack_require__(298));
__export(__webpack_require__(184));
__export(__webpack_require__(123));
__export(__webpack_require__(148));
__export(__webpack_require__(124));
__export(__webpack_require__(299));
__export(__webpack_require__(185));
//# sourceMappingURL=index.js.map

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(149));
__export(__webpack_require__(300));
__export(__webpack_require__(301));
__export(__webpack_require__(302));
__export(__webpack_require__(303));
//# sourceMappingURL=index.js.map

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
__export(__webpack_require__(561));
//# sourceMappingURL=vanilla.js.map

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(310));
__export(__webpack_require__(306));
__export(__webpack_require__(150));
__export(__webpack_require__(305));
__export(__webpack_require__(308));
__export(__webpack_require__(309));
__export(__webpack_require__(307));
__export(__webpack_require__(304));
__export(__webpack_require__(125));
__export(__webpack_require__(562));
//# sourceMappingURL=index.js.map

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internalapi
 * @module vanilla
 */
/** */
var browserLocationConfig_1 = __webpack_require__(304);
var hashLocationService_1 = __webpack_require__(305);
var utils_1 = __webpack_require__(125);
var pushStateLocationService_1 = __webpack_require__(309);
var memoryLocationService_1 = __webpack_require__(308);
var memoryLocationConfig_1 = __webpack_require__(307);
var injector_1 = __webpack_require__(306);
var q_1 = __webpack_require__(310);
var coreservices_1 = __webpack_require__(40);
function servicesPlugin(router) {
    coreservices_1.services.$injector = injector_1.$injector;
    coreservices_1.services.$q = q_1.$q;
    return { name: "vanilla.services", $q: q_1.$q, $injector: injector_1.$injector, dispose: function () { return null; } };
}
exports.servicesPlugin = servicesPlugin;
/** A `UIRouterPlugin` uses the browser hash to get/set the current location */
exports.hashLocationPlugin = utils_1.locationPluginFactory('vanilla.hashBangLocation', false, hashLocationService_1.HashLocationService, browserLocationConfig_1.BrowserLocationConfig);
/** A `UIRouterPlugin` that gets/sets the current location using the browser's `location` and `history` apis */
exports.pushStateLocationPlugin = utils_1.locationPluginFactory("vanilla.pushStateLocation", true, pushStateLocationService_1.PushStateLocationService, browserLocationConfig_1.BrowserLocationConfig);
/** A `UIRouterPlugin` that gets/sets the current location from an in-memory object */
exports.memoryLocationPlugin = utils_1.locationPluginFactory("vanilla.memoryLocation", false, memoryLocationService_1.MemoryLocationService, memoryLocationConfig_1.MemoryLocationConfig);
//# sourceMappingURL=plugins.js.map

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(311));
//# sourceMappingURL=index.js.map

/***/ }),
/* 564 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.6.5
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var ELEMENT_NODE = 1;
var COMMENT_NODE = 8;

var ADD_CLASS_SUFFIX = '-add';
var REMOVE_CLASS_SUFFIX = '-remove';
var EVENT_CLASS_PREFIX = 'ng-';
var ACTIVE_CLASS_SUFFIX = '-active';
var PREPARE_CLASS_SUFFIX = '-prepare';

var NG_ANIMATE_CLASSNAME = 'ng-animate';
var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';

// Detect proper transitionend/animationend event names.
var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;

// If unprefixed events are not supported but webkit-prefixed are, use the latter.
// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
// Register both events in case `window.onanimationend` is not supported because of that,
// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
// therefore there is no reason to test anymore for other vendor prefixes:
// http://caniuse.com/#search=transition
if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  TRANSITION_PROP = 'WebkitTransition';
  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
} else {
  TRANSITION_PROP = 'transition';
  TRANSITIONEND_EVENT = 'transitionend';
}

if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  ANIMATION_PROP = 'WebkitAnimation';
  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
} else {
  ANIMATION_PROP = 'animation';
  ANIMATIONEND_EVENT = 'animationend';
}

var DURATION_KEY = 'Duration';
var PROPERTY_KEY = 'Property';
var DELAY_KEY = 'Delay';
var TIMING_KEY = 'TimingFunction';
var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
var ANIMATION_PLAYSTATE_KEY = 'PlayState';
var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;

var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;

var ngMinErr = angular.$$minErr('ng');
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function packageStyles(options) {
  var styles = {};
  if (options && (options.to || options.from)) {
    styles.to = options.to;
    styles.from = options.from;
  }
  return styles;
}

function pendClasses(classes, fix, isPrefix) {
  var className = '';
  classes = isArray(classes)
      ? classes
      : classes && isString(classes) && classes.length
          ? classes.split(/\s+/)
          : [];
  forEach(classes, function(klass, i) {
    if (klass && klass.length > 0) {
      className += (i > 0) ? ' ' : '';
      className += isPrefix ? fix + klass
                            : klass + fix;
    }
  });
  return className;
}

function removeFromArray(arr, val) {
  var index = arr.indexOf(val);
  if (val >= 0) {
    arr.splice(index, 1);
  }
}

function stripCommentsFromElement(element) {
  if (element instanceof jqLite) {
    switch (element.length) {
      case 0:
        return element;

      case 1:
        // there is no point of stripping anything if the element
        // is the only element within the jqLite wrapper.
        // (it's important that we retain the element instance.)
        if (element[0].nodeType === ELEMENT_NODE) {
          return element;
        }
        break;

      default:
        return jqLite(extractElementNode(element));
    }
  }

  if (element.nodeType === ELEMENT_NODE) {
    return jqLite(element);
  }
}

function extractElementNode(element) {
  if (!element[0]) return element;
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function $$addClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.addClass(elm, className);
  });
}

function $$removeClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.removeClass(elm, className);
  });
}

function applyAnimationClassesFactory($$jqLite) {
  return function(element, options) {
    if (options.addClass) {
      $$addClass($$jqLite, element, options.addClass);
      options.addClass = null;
    }
    if (options.removeClass) {
      $$removeClass($$jqLite, element, options.removeClass);
      options.removeClass = null;
    }
  };
}

function prepareAnimationOptions(options) {
  options = options || {};
  if (!options.$$prepared) {
    var domOperation = options.domOperation || noop;
    options.domOperation = function() {
      options.$$domOperationFired = true;
      domOperation();
      domOperation = noop;
    };
    options.$$prepared = true;
  }
  return options;
}

function applyAnimationStyles(element, options) {
  applyAnimationFromStyles(element, options);
  applyAnimationToStyles(element, options);
}

function applyAnimationFromStyles(element, options) {
  if (options.from) {
    element.css(options.from);
    options.from = null;
  }
}

function applyAnimationToStyles(element, options) {
  if (options.to) {
    element.css(options.to);
    options.to = null;
  }
}

function mergeAnimationDetails(element, oldAnimation, newAnimation) {
  var target = oldAnimation.options || {};
  var newOptions = newAnimation.options || {};

  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);

  if (newOptions.preparationClasses) {
    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
    delete newOptions.preparationClasses;
  }

  // noop is basically when there is no callback; otherwise something has been set
  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;

  extend(target, newOptions);

  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
  if (realDomOperation) {
    target.domOperation = realDomOperation;
  }

  if (classes.addClass) {
    target.addClass = classes.addClass;
  } else {
    target.addClass = null;
  }

  if (classes.removeClass) {
    target.removeClass = classes.removeClass;
  } else {
    target.removeClass = null;
  }

  oldAnimation.addClass = target.addClass;
  oldAnimation.removeClass = target.removeClass;

  return target;
}

function resolveElementClasses(existing, toAdd, toRemove) {
  var ADD_CLASS = 1;
  var REMOVE_CLASS = -1;

  var flags = {};
  existing = splitClassesToLookup(existing);

  toAdd = splitClassesToLookup(toAdd);
  forEach(toAdd, function(value, key) {
    flags[key] = ADD_CLASS;
  });

  toRemove = splitClassesToLookup(toRemove);
  forEach(toRemove, function(value, key) {
    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
  });

  var classes = {
    addClass: '',
    removeClass: ''
  };

  forEach(flags, function(val, klass) {
    var prop, allow;
    if (val === ADD_CLASS) {
      prop = 'addClass';
      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
    } else if (val === REMOVE_CLASS) {
      prop = 'removeClass';
      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
    }
    if (allow) {
      if (classes[prop].length) {
        classes[prop] += ' ';
      }
      classes[prop] += klass;
    }
  });

  function splitClassesToLookup(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    var obj = {};
    forEach(classes, function(klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  return classes;
}

function getDomNode(element) {
  return (element instanceof jqLite) ? element[0] : element;
}

function applyGeneratedPreparationClasses(element, event, options) {
  var classes = '';
  if (event) {
    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
  }
  if (options.addClass) {
    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
  }
  if (options.removeClass) {
    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
  }
  if (classes.length) {
    options.preparationClasses = classes;
    element.addClass(classes);
  }
}

function clearGeneratedClasses(element, options) {
  if (options.preparationClasses) {
    element.removeClass(options.preparationClasses);
    options.preparationClasses = null;
  }
  if (options.activeClasses) {
    element.removeClass(options.activeClasses);
    options.activeClasses = null;
  }
}

function blockTransitions(node, duration) {
  // we use a negative delay value since it performs blocking
  // yet it doesn't kill any existing transitions running on the
  // same element which makes this safe for class-based animations
  var value = duration ? '-' + duration + 's' : '';
  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
  return [TRANSITION_DELAY_PROP, value];
}

function blockKeyframeAnimations(node, applyBlock) {
  var value = applyBlock ? 'paused' : '';
  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
  applyInlineStyle(node, [key, value]);
  return [key, value];
}

function applyInlineStyle(node, styleTuple) {
  var prop = styleTuple[0];
  var value = styleTuple[1];
  node.style[prop] = value;
}

function concatWithSpace(a,b) {
  if (!a) return b;
  if (!b) return a;
  return a + ' ' + b;
}

var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
  var queue, cancelFn;

  function scheduler(tasks) {
    // we make a copy since RAFScheduler mutates the state
    // of the passed in array variable and this would be difficult
    // to track down on the outside code
    queue = queue.concat(tasks);
    nextTick();
  }

  queue = scheduler.queue = [];

  /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */
  scheduler.waitUntilQuiet = function(fn) {
    if (cancelFn) cancelFn();

    cancelFn = $$rAF(function() {
      cancelFn = null;
      fn();
      nextTick();
    });
  };

  return scheduler;

  function nextTick() {
    if (!queue.length) return;

    var items = queue.shift();
    for (var i = 0; i < items.length; i++) {
      items[i]();
    }

    if (!cancelFn) {
      $$rAF(function() {
        if (!cancelFn) nextTick();
      });
    }
  }
}];

/**
 * @ngdoc directive
 * @name ngAnimateChildren
 * @restrict AE
 * @element ANY
 *
 * @description
 *
 * ngAnimateChildren allows you to specify that children of this element should animate even if any
 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
 * (structural) animation, child elements that also have an active structural animation are not animated.
 *
 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
 *
 *
 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
 *
 * @example
 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
     <file name="index.html">
       <div ng-controller="MainController as main">
         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
         <hr>
         <div ng-animate-children="{{main.animateChildren}}">
           <div ng-if="main.enterElement" class="container">
             List of items:
             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
           </div>
         </div>
       </div>
     </file>
     <file name="animations.css">

      .container.ng-enter,
      .container.ng-leave {
        transition: all ease 1.5s;
      }

      .container.ng-enter,
      .container.ng-leave-active {
        opacity: 0;
      }

      .container.ng-leave,
      .container.ng-enter-active {
        opacity: 1;
      }

      .item {
        background: firebrick;
        color: #FFF;
        margin-bottom: 10px;
      }

      .item.ng-enter,
      .item.ng-leave {
        transition: transform 1.5s ease;
      }

      .item.ng-enter {
        transform: translateX(50px);
      }

      .item.ng-enter-active {
        transform: translateX(0);
      }
    </file>
    <file name="script.js">
      angular.module('ngAnimateChildren', ['ngAnimate'])
        .controller('MainController', function MainController() {
          this.animateChildren = false;
          this.enterElement = false;
        });
    </file>
  </example>
 */
var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
  return {
    link: function(scope, element, attrs) {
      var val = attrs.ngAnimateChildren;
      if (isString(val) && val.length === 0) { //empty attribute
        element.data(NG_ANIMATE_CHILDREN_DATA, true);
      } else {
        // Interpolate and set the value, so that it is available to
        // animations that run right after compilation
        setData($interpolate(val)(scope));
        attrs.$observe('ngAnimateChildren', setData);
      }

      function setData(value) {
        value = value === 'on' || value === 'true';
        element.data(NG_ANIMATE_CHILDREN_DATA, value);
      }
    }
  };
}];

/* exported $AnimateCssProvider */

var ANIMATE_TIMER_KEY = '$$animateCss';

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## Usage
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
 *    the animation is closed. This is useful for when the styles are used purely for the sake of
 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
 *    By default this value is set to `false`.
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */
var ONE_SECOND = 1000;

var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var CLOSING_TIME_BUFFER = 1.5;

var DETECT_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP,
  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
};

var DETECT_STAGGER_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP
};

function getCssKeyframeDurationStyle(duration) {
  return [ANIMATION_DURATION_PROP, duration + 's'];
}

function getCssDelayStyle(delay, isKeyframeAnimation) {
  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
  return [prop, delay + 's'];
}

function computeCssStyles($window, element, properties) {
  var styles = Object.create(null);
  var detectedStyles = $window.getComputedStyle(element) || {};
  forEach(properties, function(formalStyleName, actualStyleName) {
    var val = detectedStyles[formalStyleName];
    if (val) {
      var c = val.charAt(0);

      // only numerical-based values have a negative sign or digit as the first value
      if (c === '-' || c === '+' || c >= 0) {
        val = parseMaxTime(val);
      }

      // by setting this to null in the event that the delay is not set or is set directly as 0
      // then we can still allow for negative values to be used later on and not mistake this
      // value for being greater than any other negative value.
      if (val === 0) {
        val = null;
      }
      styles[actualStyleName] = val;
    }
  });

  return styles;
}

function parseMaxTime(str) {
  var maxValue = 0;
  var values = str.split(/\s*,\s*/);
  forEach(values, function(value) {
    // it's always safe to consider only second values and omit `ms` values since
    // getComputedStyle will always handle the conversion for us
    if (value.charAt(value.length - 1) === 's') {
      value = value.substring(0, value.length - 1);
    }
    value = parseFloat(value) || 0;
    maxValue = maxValue ? Math.max(value, maxValue) : value;
  });
  return maxValue;
}

function truthyTimingValue(val) {
  return val === 0 || val != null;
}

function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
  var style = TRANSITION_PROP;
  var value = duration + 's';
  if (applyOnlyDuration) {
    style += DURATION_KEY;
  } else {
    value += ' linear all';
  }
  return [style, value];
}

function createLocalCacheLookup() {
  var cache = Object.create(null);
  return {
    flush: function() {
      cache = Object.create(null);
    },

    count: function(key) {
      var entry = cache[key];
      return entry ? entry.total : 0;
    },

    get: function(key) {
      var entry = cache[key];
      return entry && entry.value;
    },

    put: function(key, value) {
      if (!cache[key]) {
        cache[key] = { total: 1, value: value };
      } else {
        cache[key].total++;
      }
    }
  };
}

// we do not reassign an already present style value since
// if we detect the style property value again we may be
// detecting styles that were added via the `from` styles.
// We make use of `isDefined` here since an empty string
// or null value (which is what getPropertyValue will return
// for a non-existing style) will still be marked as a valid
// value for the style (a falsy value implies that the style
// is to be removed at the end of the animation). If we had a simple
// "OR" statement then it would not be enough to catch that.
function registerRestorableStyles(backup, node, properties) {
  forEach(properties, function(prop) {
    backup[prop] = isDefined(backup[prop])
        ? backup[prop]
        : node.style.getPropertyValue(prop);
  });
}

var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var gcsLookup = createLocalCacheLookup();
  var gcsStaggerLookup = createLocalCacheLookup();

  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    var parentCounter = 0;
    function gcsHashFn(node, extraClasses) {
      var KEY = '$$ngAnimateParentKey';
      var parentNode = node.parentNode;
      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
    }

    function computeCachedCssStyles(node, className, cacheKey, properties) {
      var timings = gcsLookup.get(cacheKey);

      if (!timings) {
        timings = computeCssStyles($window, node, properties);
        if (timings.animationIterationCount === 'infinite') {
          timings.animationIterationCount = 1;
        }
      }

      // we keep putting this in multiple times even though the value and the cacheKey are the same
      // because we're keeping an internal tally of how many duplicate animations are detected.
      gcsLookup.put(cacheKey, timings);
      return timings;
    }

    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
      var stagger;

      // if we have one or more existing matches of matching elements
      // containing the same parent + CSS styles (which is how cacheKey works)
      // then staggering is possible
      if (gcsLookup.count(cacheKey) > 0) {
        stagger = gcsStaggerLookup.get(cacheKey);

        if (!stagger) {
          var staggerClassName = pendClasses(className, '-stagger');

          $$jqLite.addClass(node, staggerClassName);

          stagger = computeCssStyles($window, node, properties);

          // force the conversion of a null value to zero incase not set
          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);

          $$jqLite.removeClass(node, staggerClassName);

          gcsStaggerLookup.put(cacheKey, stagger);
        }
      }

      return stagger || {};
    }

    var rafWaitQueue = [];
    function waitUntilQuiet(callback) {
      rafWaitQueue.push(callback);
      $$rAFScheduler.waitUntilQuiet(function() {
        gcsLookup.flush();
        gcsStaggerLookup.flush();

        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
        var pageWidth = $$forceReflow();

        // we use a for loop to ensure that if the queue is changed
        // during this looping then it will consider new requests
        for (var i = 0; i < rafWaitQueue.length; i++) {
          rafWaitQueue[i](pageWidth);
        }
        rafWaitQueue.length = 0;
      });
    }

    function computeTimings(node, className, cacheKey) {
      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
      var aD = timings.animationDelay;
      var tD = timings.transitionDelay;
      timings.maxDelay = aD && tD
          ? Math.max(aD, tD)
          : (aD || tD);
      timings.maxDuration = Math.max(
          timings.animationDuration * timings.animationIterationCount,
          timings.transitionDuration);

      return timings;
    }

    return function init(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = prepareAnimationOptions(copy(options));
      }

      var restoreStyles = {};
      var node = getDomNode(element);
      if (!node
          || !node.parentNode
          || !$$animateQueue.enabled()) {
        return closeAndReturnNoopAnimator();
      }

      var temporaryStyles = [];
      var classes = element.attr('class');
      var styles = packageStyles(options);
      var animationClosed;
      var animationPaused;
      var animationCompleted;
      var runner;
      var runnerHost;
      var maxDelay;
      var maxDelayTime;
      var maxDuration;
      var maxDurationTime;
      var startTime;
      var events = [];

      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
        return closeAndReturnNoopAnimator();
      }

      var method = options.event && isArray(options.event)
            ? options.event.join(' ')
            : options.event;

      var isStructural = method && options.structural;
      var structuralClassName = '';
      var addRemoveClassName = '';

      if (isStructural) {
        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
      } else if (method) {
        structuralClassName = method;
      }

      if (options.addClass) {
        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
      }

      if (options.removeClass) {
        if (addRemoveClassName.length) {
          addRemoveClassName += ' ';
        }
        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
      }

      // there may be a situation where a structural animation is combined together
      // with CSS classes that need to resolve before the animation is computed.
      // However this means that there is no explicit CSS code to block the animation
      // from happening (by setting 0s none in the class name). If this is the case
      // we need to apply the classes before the first rAF so we know to continue if
      // there actually is a detected transition or keyframe animation
      if (options.applyClassesEarly && addRemoveClassName.length) {
        applyAnimationClasses(element, options);
      }

      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
      var fullClassName = classes + ' ' + preparationClasses;
      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;

      // there is no way we can trigger an animation if no styles and
      // no classes are being applied which would then trigger a transition,
      // unless there a is raw keyframe value that is applied to the element.
      if (!containsKeyframeAnimation
           && !hasToStyles
           && !preparationClasses) {
        return closeAndReturnNoopAnimator();
      }

      var cacheKey, stagger;
      if (options.stagger > 0) {
        var staggerVal = parseFloat(options.stagger);
        stagger = {
          transitionDelay: staggerVal,
          animationDelay: staggerVal,
          transitionDuration: 0,
          animationDuration: 0
        };
      } else {
        cacheKey = gcsHashFn(node, fullClassName);
        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
      }

      if (!options.$$skipPreparationClasses) {
        $$jqLite.addClass(element, preparationClasses);
      }

      var applyOnlyDuration;

      if (options.transitionStyle) {
        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
        applyInlineStyle(node, transitionStyle);
        temporaryStyles.push(transitionStyle);
      }

      if (options.duration >= 0) {
        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);

        // we set the duration so that it will be picked up by getComputedStyle later
        applyInlineStyle(node, durationStyle);
        temporaryStyles.push(durationStyle);
      }

      if (options.keyframeStyle) {
        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
        applyInlineStyle(node, keyframeStyle);
        temporaryStyles.push(keyframeStyle);
      }

      var itemIndex = stagger
          ? options.staggerIndex >= 0
              ? options.staggerIndex
              : gcsLookup.count(cacheKey)
          : 0;

      var isFirst = itemIndex === 0;

      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
      // without causing any combination of transitions to kick in. By adding a negative delay value
      // it forces the setup class' transition to end immediately. We later then remove the negative
      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
      // that if there is no transition defined then nothing will happen and this will also allow
      // other transitions to be stacked on top of each other without any chopping them out.
      if (isFirst && !options.skipBlocking) {
        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
      }

      var timings = computeTimings(node, fullClassName, cacheKey);
      var relativeDelay = timings.maxDelay;
      maxDelay = Math.max(relativeDelay, 0);
      maxDuration = timings.maxDuration;

      var flags = {};
      flags.hasTransitions          = timings.transitionDuration > 0;
      flags.hasAnimations           = timings.animationDuration > 0;
      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
      flags.applyTransitionDuration = hasToStyles && (
                                        (flags.hasTransitions && !flags.hasTransitionAll)
                                         || (flags.hasAnimations && !flags.hasTransitions));
      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
      flags.recalculateTimingStyles = addRemoveClassName.length > 0;

      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;

        if (flags.applyTransitionDuration) {
          flags.hasTransitions = true;
          timings.transitionDuration = maxDuration;
          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
        }

        if (flags.applyAnimationDuration) {
          flags.hasAnimations = true;
          timings.animationDuration = maxDuration;
          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
        }
      }

      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
        return closeAndReturnNoopAnimator();
      }

      if (options.delay != null) {
        var delayStyle;
        if (typeof options.delay !== 'boolean') {
          delayStyle = parseFloat(options.delay);
          // number in options.delay means we have to recalculate the delay for the closing timeout
          maxDelay = Math.max(delayStyle, 0);
        }

        if (flags.applyTransitionDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle));
        }

        if (flags.applyAnimationDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
        }
      }

      // we need to recalculate the delay value since we used a pre-emptive negative
      // delay value and the delay value is required for the final event checking. This
      // property will ensure that this will happen after the RAF phase has passed.
      if (options.duration == null && timings.transitionDuration > 0) {
        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
      }

      maxDelayTime = maxDelay * ONE_SECOND;
      maxDurationTime = maxDuration * ONE_SECOND;
      if (!options.skipBlocking) {
        flags.blockTransition = timings.transitionDuration > 0;
        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
                                       stagger.animationDelay > 0 &&
                                       stagger.animationDuration === 0;
      }

      if (options.from) {
        if (options.cleanupStyles) {
          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
        }
        applyAnimationFromStyles(element, options);
      }

      if (flags.blockTransition || flags.blockKeyframeAnimation) {
        applyBlocking(maxDuration);
      } else if (!options.skipBlocking) {
        blockTransitions(node, false);
      }

      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
      return {
        $$willAnimate: true,
        end: endFn,
        start: function() {
          if (animationClosed) return;

          runnerHost = {
            end: endFn,
            cancel: cancelFn,
            resume: null, //this will be set during the start() phase
            pause: null
          };

          runner = new $$AnimateRunner(runnerHost);

          waitUntilQuiet(start);

          // we don't have access to pause/resume the animation
          // since it hasn't run yet. AnimateRunner will therefore
          // set noop functions for resume and pause and they will
          // later be overridden once the animation is triggered
          return runner;
        }
      };

      function endFn() {
        close();
      }

      function cancelFn() {
        close(true);
      }

      function close(rejected) {
        // if the promise has been called already then we shouldn't close
        // the animation again
        if (animationClosed || (animationCompleted && animationPaused)) return;
        animationClosed = true;
        animationPaused = false;

        if (!options.$$skipPreparationClasses) {
          $$jqLite.removeClass(element, preparationClasses);
        }
        $$jqLite.removeClass(element, activeClasses);

        blockKeyframeAnimations(node, false);
        blockTransitions(node, false);

        forEach(temporaryStyles, function(entry) {
          // There is only one way to remove inline style properties entirely from elements.
          // By using `removeProperty` this works, but we need to convert camel-cased CSS
          // styles down to hyphenated values.
          node.style[entry[0]] = '';
        });

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);

        if (Object.keys(restoreStyles).length) {
          forEach(restoreStyles, function(value, prop) {
            if (value) {
              node.style.setProperty(prop, value);
            } else {
              node.style.removeProperty(prop);
            }
          });
        }

        // the reason why we have this option is to allow a synchronous closing callback
        // that is fired as SOON as the animation ends (when the CSS is removed) or if
        // the animation never takes off at all. A good example is a leave animation since
        // the element must be removed just after the animation is over or else the element
        // will appear on screen for one animation frame causing an overbearing flicker.
        if (options.onDone) {
          options.onDone();
        }

        if (events && events.length) {
          // Remove the transitionend / animationend listener(s)
          element.off(events.join(' '), onAnimationProgress);
        }

        //Cancel the fallback closing timeout and remove the timer data
        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
        if (animationTimerData) {
          $timeout.cancel(animationTimerData[0].timer);
          element.removeData(ANIMATE_TIMER_KEY);
        }

        // if the preparation function fails then the promise is not setup
        if (runner) {
          runner.complete(!rejected);
        }
      }

      function applyBlocking(duration) {
        if (flags.blockTransition) {
          blockTransitions(node, duration);
        }

        if (flags.blockKeyframeAnimation) {
          blockKeyframeAnimations(node, !!duration);
        }
      }

      function closeAndReturnNoopAnimator() {
        runner = new $$AnimateRunner({
          end: endFn,
          cancel: cancelFn
        });

        // should flush the cache animation
        waitUntilQuiet(noop);
        close();

        return {
          $$willAnimate: false,
          start: function() {
            return runner;
          },
          end: endFn
        };
      }

      function onAnimationProgress(event) {
        event.stopPropagation();
        var ev = event.originalEvent || event;

        // we now always use `Date.now()` due to the recent changes with
        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
        var timeStamp = ev.$manualTimeStamp || Date.now();

        /* Firefox (or possibly just Gecko) likes to not round values up
         * when a ms measurement is used for the animation */
        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));

        /* $manualTimeStamp is a mocked timeStamp value which is set
         * within browserTrigger(). This is only here so that tests can
         * mock animations properly. Real events fallback to event.timeStamp,
         * or, if they don't, then a timeStamp is automatically created for them.
         * We're checking to see if the timeStamp surpasses the expected delay,
         * but we're using elapsedTime instead of the timeStamp on the 2nd
         * pre-condition since animationPauseds sometimes close off early */
        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
          // we set this flag to ensure that if the transition is paused then, when resumed,
          // the animation will automatically close itself since transitions cannot be paused.
          animationCompleted = true;
          close();
        }
      }

      function start() {
        if (animationClosed) return;
        if (!node.parentNode) {
          close();
          return;
        }

        // even though we only pause keyframe animations here the pause flag
        // will still happen when transitions are used. Only the transition will
        // not be paused since that is not possible. If the animation ends when
        // paused then it will not complete until unpaused or cancelled.
        var playPause = function(playAnimation) {
          if (!animationCompleted) {
            animationPaused = !playAnimation;
            if (timings.animationDuration) {
              var value = blockKeyframeAnimations(node, animationPaused);
              if (animationPaused) {
                temporaryStyles.push(value);
              } else {
                removeFromArray(temporaryStyles, value);
              }
            }
          } else if (animationPaused && playAnimation) {
            animationPaused = false;
            close();
          }
        };

        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
        // being inherited from the parent. If the transition duration is zero then we can safely
        // rely that the delay value is an intentional stagger delay style.
        var maxStagger = itemIndex > 0
                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
                            (timings.animationDuration && stagger.animationDuration === 0))
                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
        if (maxStagger) {
          $timeout(triggerAnimationStart,
                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
                   false);
        } else {
          triggerAnimationStart();
        }

        // this will decorate the existing promise runner with pause/resume methods
        runnerHost.resume = function() {
          playPause(true);
        };

        runnerHost.pause = function() {
          playPause(false);
        };

        function triggerAnimationStart() {
          // just incase a stagger animation kicks in when the animation
          // itself was cancelled entirely
          if (animationClosed) return;

          applyBlocking(false);

          forEach(temporaryStyles, function(entry) {
            var key = entry[0];
            var value = entry[1];
            node.style[key] = value;
          });

          applyAnimationClasses(element, options);
          $$jqLite.addClass(element, activeClasses);

          if (flags.recalculateTimingStyles) {
            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
            cacheKey = gcsHashFn(node, fullClassName);

            timings = computeTimings(node, fullClassName, cacheKey);
            relativeDelay = timings.maxDelay;
            maxDelay = Math.max(relativeDelay, 0);
            maxDuration = timings.maxDuration;

            if (maxDuration === 0) {
              close();
              return;
            }

            flags.hasTransitions = timings.transitionDuration > 0;
            flags.hasAnimations = timings.animationDuration > 0;
          }

          if (flags.applyAnimationDelay) {
            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
                  ? parseFloat(options.delay)
                  : relativeDelay;

            maxDelay = Math.max(relativeDelay, 0);
            timings.animationDelay = relativeDelay;
            delayStyle = getCssDelayStyle(relativeDelay, true);
            temporaryStyles.push(delayStyle);
            node.style[delayStyle[0]] = delayStyle[1];
          }

          maxDelayTime = maxDelay * ONE_SECOND;
          maxDurationTime = maxDuration * ONE_SECOND;

          if (options.easing) {
            var easeProp, easeVal = options.easing;
            if (flags.hasTransitions) {
              easeProp = TRANSITION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
            if (flags.hasAnimations) {
              easeProp = ANIMATION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
          }

          if (timings.transitionDuration) {
            events.push(TRANSITIONEND_EVENT);
          }

          if (timings.animationDuration) {
            events.push(ANIMATIONEND_EVENT);
          }

          startTime = Date.now();
          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
          var endTime = startTime + timerTime;

          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
          var setupFallbackTimer = true;
          if (animationsData.length) {
            var currentTimerData = animationsData[0];
            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
            if (setupFallbackTimer) {
              $timeout.cancel(currentTimerData.timer);
            } else {
              animationsData.push(close);
            }
          }

          if (setupFallbackTimer) {
            var timer = $timeout(onAnimationExpired, timerTime, false);
            animationsData[0] = {
              timer: timer,
              expectedEndTime: endTime
            };
            animationsData.push(close);
            element.data(ANIMATE_TIMER_KEY, animationsData);
          }

          if (events.length) {
            element.on(events.join(' '), onAnimationProgress);
          }

          if (options.to) {
            if (options.cleanupStyles) {
              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
            }
            applyAnimationToStyles(element, options);
          }
        }

        function onAnimationExpired() {
          var animationsData = element.data(ANIMATE_TIMER_KEY);

          // this will be false in the event that the element was
          // removed from the DOM (via a leave animation or something
          // similar)
          if (animationsData) {
            for (var i = 1; i < animationsData.length; i++) {
              animationsData[i]();
            }
            element.removeData(ANIMATE_TIMER_KEY);
          }
        }
      }
    };
  }];
}];

var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateCssDriver');

  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';

  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';

  function isDocumentFragment(node) {
    return node.parentNode && node.parentNode.nodeType === 11;
  }

  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {

    // only browsers that support these properties can render animations
    if (!$sniffer.animations && !$sniffer.transitions) return noop;

    var bodyNode = $document[0].body;
    var rootNode = getDomNode($rootElement);

    var rootBodyElement = jqLite(
      // this is to avoid using something that exists outside of the body
      // we also special case the doc fragment case because our unit test code
      // appends the $rootElement to the body after the app has been bootstrapped
      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
    );

    return function initDriverFn(animationDetails) {
      return animationDetails.from && animationDetails.to
          ? prepareFromToAnchorAnimation(animationDetails.from,
                                         animationDetails.to,
                                         animationDetails.classes,
                                         animationDetails.anchors)
          : prepareRegularAnimation(animationDetails);
    };

    function filterCssClasses(classes) {
      //remove all the `ng-` stuff
      return classes.replace(/\bng-\S+\b/g, '');
    }

    function getUniqueValues(a, b) {
      if (isString(a)) a = a.split(' ');
      if (isString(b)) b = b.split(' ');
      return a.filter(function(val) {
        return b.indexOf(val) === -1;
      }).join(' ');
    }

    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
      var startingClasses = filterCssClasses(getClassVal(clone));

      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);

      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);

      rootBodyElement.append(clone);

      var animatorIn, animatorOut = prepareOutAnimation();

      // the user may not end up using the `out` animation and
      // only making use of the `in` animation or vice-versa.
      // In either case we should allow this and not assume the
      // animation is over unless both animations are not used.
      if (!animatorOut) {
        animatorIn = prepareInAnimation();
        if (!animatorIn) {
          return end();
        }
      }

      var startingAnimator = animatorOut || animatorIn;

      return {
        start: function() {
          var runner;

          var currentAnimation = startingAnimator.start();
          currentAnimation.done(function() {
            currentAnimation = null;
            if (!animatorIn) {
              animatorIn = prepareInAnimation();
              if (animatorIn) {
                currentAnimation = animatorIn.start();
                currentAnimation.done(function() {
                  currentAnimation = null;
                  end();
                  runner.complete();
                });
                return currentAnimation;
              }
            }
            // in the event that there is no `in` animation
            end();
            runner.complete();
          });

          runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn
          });

          return runner;

          function endFn() {
            if (currentAnimation) {
              currentAnimation.end();
            }
          }
        }
      };

      function calculateAnchorStyles(anchor) {
        var styles = {};

        var coords = getDomNode(anchor).getBoundingClientRect();

        // we iterate directly since safari messes up and doesn't return
        // all the keys for the coords object when iterated
        forEach(['width','height','top','left'], function(key) {
          var value = coords[key];
          switch (key) {
            case 'top':
              value += bodyNode.scrollTop;
              break;
            case 'left':
              value += bodyNode.scrollLeft;
              break;
          }
          styles[key] = Math.floor(value) + 'px';
        });
        return styles;
      }

      function prepareOutAnimation() {
        var animator = $animateCss(clone, {
          addClass: NG_OUT_ANCHOR_CLASS_NAME,
          delay: true,
          from: calculateAnchorStyles(outAnchor)
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function getClassVal(element) {
        return element.attr('class') || '';
      }

      function prepareInAnimation() {
        var endingClasses = filterCssClasses(getClassVal(inAnchor));
        var toAdd = getUniqueValues(endingClasses, startingClasses);
        var toRemove = getUniqueValues(startingClasses, endingClasses);

        var animator = $animateCss(clone, {
          to: calculateAnchorStyles(inAnchor),
          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
          delay: true
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function end() {
        clone.remove();
        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
      }
    }

    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
      var fromAnimation = prepareRegularAnimation(from, noop);
      var toAnimation = prepareRegularAnimation(to, noop);

      var anchorAnimations = [];
      forEach(anchors, function(anchor) {
        var outElement = anchor['out'];
        var inElement = anchor['in'];
        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
        if (animator) {
          anchorAnimations.push(animator);
        }
      });

      // no point in doing anything when there are no elements to animate
      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;

      return {
        start: function() {
          var animationRunners = [];

          if (fromAnimation) {
            animationRunners.push(fromAnimation.start());
          }

          if (toAnimation) {
            animationRunners.push(toAnimation.start());
          }

          forEach(anchorAnimations, function(animation) {
            animationRunners.push(animation.start());
          });

          var runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
          });

          $$AnimateRunner.all(animationRunners, function(status) {
            runner.complete(status);
          });

          return runner;

          function endFn() {
            forEach(animationRunners, function(runner) {
              runner.end();
            });
          }
        }
      };
    }

    function prepareRegularAnimation(animationDetails) {
      var element = animationDetails.element;
      var options = animationDetails.options || {};

      if (animationDetails.structural) {
        options.event = animationDetails.event;
        options.structural = true;
        options.applyClassesEarly = true;

        // we special case the leave animation since we want to ensure that
        // the element is removed as soon as the animation is over. Otherwise
        // a flicker might appear or the element may not be removed at all
        if (animationDetails.event === 'leave') {
          options.onDone = options.domOperation;
        }
      }

      // We assign the preparationClasses as the actual animation event since
      // the internals of $animateCss will just suffix the event token values
      // with `-active` to trigger the animation.
      if (options.preparationClasses) {
        options.event = concatWithSpace(options.event, options.preparationClasses);
      }

      var animator = $animateCss(element, options);

      // the driver lookup code inside of $$animation attempts to spawn a
      // driver one by one until a driver returns a.$$willAnimate animator object.
      // $animateCss will always return an object, however, it will pass in
      // a flag as a hint as to whether an animation was detected or not
      return animator.$$willAnimate ? animator : null;
    }
  }];
}];

// TODO(matsko): use caching here to speed things up for detection
// TODO(matsko): add documentation
//  by the time...

var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
       function($injector,   $$AnimateRunner,   $$jqLite) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
         // $animateJs(element, 'enter');
    return function(element, event, classes, options) {
      var animationClosed = false;

      // the `classes` argument is optional and if it is not used
      // then the classes will be resolved from the element's className
      // property as well as options.addClass/options.removeClass.
      if (arguments.length === 3 && isObject(classes)) {
        options = classes;
        classes = null;
      }

      options = prepareAnimationOptions(options);
      if (!classes) {
        classes = element.attr('class') || '';
        if (options.addClass) {
          classes += ' ' + options.addClass;
        }
        if (options.removeClass) {
          classes += ' ' + options.removeClass;
        }
      }

      var classesToAdd = options.addClass;
      var classesToRemove = options.removeClass;

      // the lookupAnimations function returns a series of animation objects that are
      // matched up with one or more of the CSS classes. These animation objects are
      // defined via the module.animation factory function. If nothing is detected then
      // we don't return anything which then makes $animation query the next driver.
      var animations = lookupAnimations(classes);
      var before, after;
      if (animations.length) {
        var afterFn, beforeFn;
        if (event === 'leave') {
          beforeFn = 'leave';
          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
        } else {
          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
          afterFn = event;
        }

        if (event !== 'enter' && event !== 'move') {
          before = packageAnimations(element, event, options, animations, beforeFn);
        }
        after  = packageAnimations(element, event, options, animations, afterFn);
      }

      // no matching animations
      if (!before && !after) return;

      function applyOptions() {
        options.domOperation();
        applyAnimationClasses(element, options);
      }

      function close() {
        animationClosed = true;
        applyOptions();
        applyAnimationStyles(element, options);
      }

      var runner;

      return {
        $$willAnimate: true,
        end: function() {
          if (runner) {
            runner.end();
          } else {
            close();
            runner = new $$AnimateRunner();
            runner.complete(true);
          }
          return runner;
        },
        start: function() {
          if (runner) {
            return runner;
          }

          runner = new $$AnimateRunner();
          var closeActiveAnimations;
          var chain = [];

          if (before) {
            chain.push(function(fn) {
              closeActiveAnimations = before(fn);
            });
          }

          if (chain.length) {
            chain.push(function(fn) {
              applyOptions();
              fn(true);
            });
          } else {
            applyOptions();
          }

          if (after) {
            chain.push(function(fn) {
              closeActiveAnimations = after(fn);
            });
          }

          runner.setHost({
            end: function() {
              endAnimations();
            },
            cancel: function() {
              endAnimations(true);
            }
          });

          $$AnimateRunner.chain(chain, onComplete);
          return runner;

          function onComplete(success) {
            close(success);
            runner.complete(success);
          }

          function endAnimations(cancelled) {
            if (!animationClosed) {
              (closeActiveAnimations || noop)(cancelled);
              onComplete(cancelled);
            }
          }
        }
      };

      function executeAnimationFn(fn, element, event, options, onDone) {
        var args;
        switch (event) {
          case 'animate':
            args = [element, options.from, options.to, onDone];
            break;

          case 'setClass':
            args = [element, classesToAdd, classesToRemove, onDone];
            break;

          case 'addClass':
            args = [element, classesToAdd, onDone];
            break;

          case 'removeClass':
            args = [element, classesToRemove, onDone];
            break;

          default:
            args = [element, onDone];
            break;
        }

        args.push(options);

        var value = fn.apply(fn, args);
        if (value) {
          if (isFunction(value.start)) {
            value = value.start();
          }

          if (value instanceof $$AnimateRunner) {
            value.done(onDone);
          } else if (isFunction(value)) {
            // optional onEnd / onCancel callback
            return value;
          }
        }

        return noop;
      }

      function groupEventedAnimations(element, event, options, animations, fnName) {
        var operations = [];
        forEach(animations, function(ani) {
          var animation = ani[fnName];
          if (!animation) return;

          // note that all of these animations will run in parallel
          operations.push(function() {
            var runner;
            var endProgressCb;

            var resolved = false;
            var onAnimationComplete = function(rejected) {
              if (!resolved) {
                resolved = true;
                (endProgressCb || noop)(rejected);
                runner.complete(!rejected);
              }
            };

            runner = new $$AnimateRunner({
              end: function() {
                onAnimationComplete();
              },
              cancel: function() {
                onAnimationComplete(true);
              }
            });

            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
              var cancelled = result === false;
              onAnimationComplete(cancelled);
            });

            return runner;
          });
        });

        return operations;
      }

      function packageAnimations(element, event, options, animations, fnName) {
        var operations = groupEventedAnimations(element, event, options, animations, fnName);
        if (operations.length === 0) {
          var a, b;
          if (fnName === 'beforeSetClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
          } else if (fnName === 'setClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
          }

          if (a) {
            operations = operations.concat(a);
          }
          if (b) {
            operations = operations.concat(b);
          }
        }

        if (operations.length === 0) return;

        // TODO(matsko): add documentation
        return function startAnimation(callback) {
          var runners = [];
          if (operations.length) {
            forEach(operations, function(animateFn) {
              runners.push(animateFn());
            });
          }

          if (runners.length) {
            $$AnimateRunner.all(runners, callback);
          }  else {
            callback();
          }

          return function endFn(reject) {
            forEach(runners, function(runner) {
              if (reject) {
                runner.cancel();
              } else {
                runner.end();
              }
            });
          };
        };
      }
    };

    function lookupAnimations(classes) {
      classes = isArray(classes) ? classes : classes.split(' ');
      var matches = [], flagMap = {};
      for (var i = 0; i < classes.length; i++) {
        var klass = classes[i],
            animationFactory = $animateProvider.$$registeredAnimations[klass];
        if (animationFactory && !flagMap[klass]) {
          matches.push($injector.get(animationFactory));
          flagMap[klass] = true;
        }
      }
      return matches;
    }
  }];
}];

var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateJsDriver');
  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
    return function initDriverFn(animationDetails) {
      if (animationDetails.from && animationDetails.to) {
        var fromAnimation = prepareAnimation(animationDetails.from);
        var toAnimation = prepareAnimation(animationDetails.to);
        if (!fromAnimation && !toAnimation) return;

        return {
          start: function() {
            var animationRunners = [];

            if (fromAnimation) {
              animationRunners.push(fromAnimation.start());
            }

            if (toAnimation) {
              animationRunners.push(toAnimation.start());
            }

            $$AnimateRunner.all(animationRunners, done);

            var runner = new $$AnimateRunner({
              end: endFnFactory(),
              cancel: endFnFactory()
            });

            return runner;

            function endFnFactory() {
              return function() {
                forEach(animationRunners, function(runner) {
                  // at this point we cannot cancel animations for groups just yet. 1.5+
                  runner.end();
                });
              };
            }

            function done(status) {
              runner.complete(status);
            }
          }
        };
      } else {
        return prepareAnimation(animationDetails);
      }
    };

    function prepareAnimation(animationDetails) {
      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
      var element = animationDetails.element;
      var event = animationDetails.event;
      var options = animationDetails.options;
      var classes = animationDetails.classes;
      return $$animateJs(element, event, classes, options);
    }
  }];
}];

var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var PRE_DIGEST_STATE = 1;
  var RUNNING_STATE = 2;
  var ONE_SPACE = ' ';

  var rules = this.rules = {
    skip: [],
    cancel: [],
    join: []
  };

  function makeTruthyCssClassMap(classString) {
    if (!classString) {
      return null;
    }

    var keys = classString.split(ONE_SPACE);
    var map = Object.create(null);

    forEach(keys, function(key) {
      map[key] = true;
    });
    return map;
  }

  function hasMatchingClasses(newClassString, currentClassString) {
    if (newClassString && currentClassString) {
      var currentClassMap = makeTruthyCssClassMap(currentClassString);
      return newClassString.split(ONE_SPACE).some(function(className) {
        return currentClassMap[className];
      });
    }
  }

  function isAllowed(ruleType, currentAnimation, previousAnimation) {
    return rules[ruleType].some(function(fn) {
      return fn(currentAnimation, previousAnimation);
    });
  }

  function hasAnimationClasses(animation, and) {
    var a = (animation.addClass || '').length > 0;
    var b = (animation.removeClass || '').length > 0;
    return and ? a && b : a || b;
  }

  rules.join.push(function(newAnimation, currentAnimation) {
    // if the new animation is class-based then we can just tack that on
    return !newAnimation.structural && hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // there is no need to animate anything if no classes are being added and
    // there is no structural animation that will be triggered
    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // why should we trigger a new structural animation if the element will
    // be removed from the DOM anyway?
    return currentAnimation.event === 'leave' && newAnimation.structural;
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // if there is an ongoing current animation then don't even bother running the class-based animation
    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // there can never be two structural animations running at the same time
    return currentAnimation.structural && newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // if the previous animation is already running, but the new animation will
    // be triggered, but the new animation is structural
    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // cancel the animation if classes added / removed in both animation cancel each other out,
    // but only if the current animation isn't structural

    if (currentAnimation.structural) return false;

    var nA = newAnimation.addClass;
    var nR = newAnimation.removeClass;
    var cA = currentAnimation.addClass;
    var cR = currentAnimation.removeClass;

    // early detection to save the global CPU shortage :)
    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
      return false;
    }

    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
  });

  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map',
               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
               '$$isDocumentHidden',
       function($$rAF,   $rootScope,   $rootElement,   $document,   $$Map,
                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
                $$isDocumentHidden) {

    var activeAnimationsLookup = new $$Map();
    var disabledElementsLookup = new $$Map();
    var animationsEnabled = null;

    function postDigestTaskFactory() {
      var postDigestCalled = false;
      return function(fn) {
        // we only issue a call to postDigest before
        // it has first passed. This prevents any callbacks
        // from not firing once the animation has completed
        // since it will be out of the digest cycle.
        if (postDigestCalled) {
          fn();
        } else {
          $rootScope.$$postDigest(function() {
            postDigestCalled = true;
            fn();
          });
        }
      };
    }

    // Wait until all directive and route-related templates are downloaded and
    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
    // all of the remote templates being currently downloaded. If there are no
    // templates currently downloading then the watcher will still fire anyway.
    var deregisterWatch = $rootScope.$watch(
      function() { return $templateRequest.totalPendingRequests === 0; },
      function(isEmpty) {
        if (!isEmpty) return;
        deregisterWatch();

        // Now that all templates have been downloaded, $animate will wait until
        // the post digest queue is empty before enabling animations. By having two
        // calls to $postDigest calls we can ensure that the flag is enabled at the
        // very end of the post digest queue. Since all of the animations in $animate
        // use $postDigest, it's important that the code below executes at the end.
        // This basically means that the page is fully downloaded and compiled before
        // any animations are triggered.
        $rootScope.$$postDigest(function() {
          $rootScope.$$postDigest(function() {
            // we check for null directly in the event that the application already called
            // .enabled() with whatever arguments that it provided it with
            if (animationsEnabled === null) {
              animationsEnabled = true;
            }
          });
        });
      }
    );

    var callbackRegistry = Object.create(null);

    // remember that the `customFilter`/`classNameFilter` are set during the
    // provider/config stage therefore we can optimize here and setup helper functions
    var customFilter = $animateProvider.customFilter();
    var classNameFilter = $animateProvider.classNameFilter();
    var returnTrue = function() { return true; };

    var isAnimatableByFilter = customFilter || returnTrue;
    var isAnimatableClassName = !classNameFilter ? returnTrue : function(node, options) {
      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
      return classNameFilter.test(className);
    };

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function normalizeAnimationDetails(element, animation) {
      return mergeAnimationDetails(element, animation, {});
    }

    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
      // eslint-disable-next-line no-bitwise
      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
    };

    function findCallbacks(targetParentNode, targetNode, event) {
      var matches = [];
      var entries = callbackRegistry[event];
      if (entries) {
        forEach(entries, function(entry) {
          if (contains.call(entry.node, targetNode)) {
            matches.push(entry.callback);
          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
            matches.push(entry.callback);
          }
        });
      }

      return matches;
    }

    function filterFromRegistry(list, matchContainer, matchCallback) {
      var containerNode = extractElementNode(matchContainer);
      return list.filter(function(entry) {
        var isMatch = entry.node === containerNode &&
                        (!matchCallback || entry.callback === matchCallback);
        return !isMatch;
      });
    }

    function cleanupEventListeners(phase, node) {
      if (phase === 'close' && !node.parentNode) {
        // If the element is not attached to a parentNode, it has been removed by
        // the domOperation, and we can safely remove the event callbacks
        $animate.off(node);
      }
    }

    var $animate = {
      on: function(event, container, callback) {
        var node = extractElementNode(container);
        callbackRegistry[event] = callbackRegistry[event] || [];
        callbackRegistry[event].push({
          node: node,
          callback: callback
        });

        // Remove the callback when the element is removed from the DOM
        jqLite(container).on('$destroy', function() {
          var animationDetails = activeAnimationsLookup.get(node);

          if (!animationDetails) {
            // If there's an animation ongoing, the callback calling code will remove
            // the event listeners. If we'd remove here, the callbacks would be removed
            // before the animation ends
            $animate.off(event, container, callback);
          }
        });
      },

      off: function(event, container, callback) {
        if (arguments.length === 1 && !isString(arguments[0])) {
          container = arguments[0];
          for (var eventType in callbackRegistry) {
            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
          }

          return;
        }

        var entries = callbackRegistry[event];
        if (!entries) return;

        callbackRegistry[event] = arguments.length === 1
            ? null
            : filterFromRegistry(entries, container, callback);
      },

      pin: function(element, parentElement) {
        assertArg(isElement(element), 'element', 'not an element');
        assertArg(isElement(parentElement), 'parentElement', 'not an element');
        element.data(NG_ANIMATE_PIN_DATA, parentElement);
      },

      push: function(element, event, options, domOperation) {
        options = options || {};
        options.domOperation = domOperation;
        return queueAnimation(element, event, options);
      },

      // this method has four signatures:
      //  () - global getter
      //  (bool) - global setter
      //  (element) - element getter
      //  (element, bool) - element setter<F37>
      enabled: function(element, bool) {
        var argCount = arguments.length;

        if (argCount === 0) {
          // () - Global getter
          bool = !!animationsEnabled;
        } else {
          var hasElement = isElement(element);

          if (!hasElement) {
            // (bool) - Global setter
            bool = animationsEnabled = !!element;
          } else {
            var node = getDomNode(element);

            if (argCount === 1) {
              // (element) - Element getter
              bool = !disabledElementsLookup.get(node);
            } else {
              // (element, bool) - Element setter
              disabledElementsLookup.set(node, !bool);
            }
          }
        }

        return bool;
      }
    };

    return $animate;

    function queueAnimation(originalElement, event, initialOptions) {
      // we always make a copy of the options since
      // there should never be any side effects on
      // the input data when running `$animateCss`.
      var options = copy(initialOptions);

      var element = stripCommentsFromElement(originalElement);
      var node = getDomNode(element);
      var parentNode = node && node.parentNode;

      options = prepareAnimationOptions(options);

      // we create a fake runner with a working promise.
      // These methods will become available after the digest has passed
      var runner = new $$AnimateRunner();

      // this is used to trigger callbacks in postDigest mode
      var runInNextPostDigestOrNow = postDigestTaskFactory();

      if (isArray(options.addClass)) {
        options.addClass = options.addClass.join(' ');
      }

      if (options.addClass && !isString(options.addClass)) {
        options.addClass = null;
      }

      if (isArray(options.removeClass)) {
        options.removeClass = options.removeClass.join(' ');
      }

      if (options.removeClass && !isString(options.removeClass)) {
        options.removeClass = null;
      }

      if (options.from && !isObject(options.from)) {
        options.from = null;
      }

      if (options.to && !isObject(options.to)) {
        options.to = null;
      }

      // If animations are hard-disabled for the whole application there is no need to continue.
      // There are also situations where a directive issues an animation for a jqLite wrapper that
      // contains only comment nodes. In this case, there is no way we can perform an animation.
      if (!animationsEnabled ||
          !node ||
          !isAnimatableByFilter(node, event, initialOptions) ||
          !isAnimatableClassName(node, options)) {
        close();
        return runner;
      }

      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      var documentHidden = $$isDocumentHidden();

      // This is a hard disable of all animations the element itself, therefore  there is no need to
      // continue further past this point if not enabled
      // Animations are also disabled if the document is currently hidden (page is not visible
      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
      var skipAnimations = documentHidden || disabledElementsLookup.get(node);
      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
      var hasExistingAnimation = !!existingAnimation.state;

      // there is no point in traversing the same collection of parent ancestors if a followup
      // animation will be run on the same element that already did all that checking work
      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
        skipAnimations = !areAnimationsAllowed(node, parentNode, event);
      }

      if (skipAnimations) {
        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
        if (documentHidden) notifyProgress(runner, event, 'start');
        close();
        if (documentHidden) notifyProgress(runner, event, 'close');
        return runner;
      }

      if (isStructural) {
        closeChildAnimations(node);
      }

      var newAnimation = {
        structural: isStructural,
        element: element,
        event: event,
        addClass: options.addClass,
        removeClass: options.removeClass,
        close: close,
        options: options,
        runner: runner
      };

      if (hasExistingAnimation) {
        var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
        if (skipAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            close();
            return runner;
          } else {
            mergeAnimationDetails(element, existingAnimation, newAnimation);
            return existingAnimation.runner;
          }
        }
        var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
        if (cancelAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            // this will end the animation right away and it is safe
            // to do so since the animation is already running and the
            // runner callback code will run in async
            existingAnimation.runner.end();
          } else if (existingAnimation.structural) {
            // this means that the animation is queued into a digest, but
            // hasn't started yet. Therefore it is safe to run the close
            // method which will call the runner methods in async.
            existingAnimation.close();
          } else {
            // this will merge the new animation options into existing animation options
            mergeAnimationDetails(element, existingAnimation, newAnimation);

            return existingAnimation.runner;
          }
        } else {
          // a joined animation means that this animation will take over the existing one
          // so an example would involve a leave animation taking over an enter. Then when
          // the postDigest kicks in the enter will be ignored.
          var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
          if (joinAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              normalizeAnimationDetails(element, newAnimation);
            } else {
              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);

              event = newAnimation.event = existingAnimation.event;
              options = mergeAnimationDetails(element, existingAnimation, newAnimation);

              //we return the same runner since only the option values of this animation will
              //be fed into the `existingAnimation`.
              return existingAnimation.runner;
            }
          }
        }
      } else {
        // normalization in this case means that it removes redundant CSS classes that
        // already exist (addClass) or do not exist (removeClass) on the element
        normalizeAnimationDetails(element, newAnimation);
      }

      // when the options are merged and cleaned up we may end up not having to do
      // an animation at all, therefore we should check this before issuing a post
      // digest callback. Structural animations will always run no matter what.
      var isValidAnimation = newAnimation.structural;
      if (!isValidAnimation) {
        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
                            || hasAnimationClasses(newAnimation);
      }

      if (!isValidAnimation) {
        close();
        clearElementAnimationState(node);
        return runner;
      }

      // the counter keeps track of cancelled animations
      var counter = (existingAnimation.counter || 0) + 1;
      newAnimation.counter = counter;

      markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);

      $rootScope.$$postDigest(function() {
        // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
        // happen if the animated element is a transcluded clone and also has a `templateUrl`
        // directive on it. Therefore, we must recreate `element` in order to interact with the
        // actual DOM nodes.
        // Note: We still need to use the old `node` for certain things, such as looking up in
        //       HashMaps where it was used as the key.

        element = stripCommentsFromElement(originalElement);

        var animationDetails = activeAnimationsLookup.get(node);
        var animationCancelled = !animationDetails;
        animationDetails = animationDetails || {};

        // if addClass/removeClass is called before something like enter then the
        // registered parent element may not be present. The code below will ensure
        // that a final value for parent element is obtained
        var parentElement = element.parent() || [];

        // animate/structural/class-based animations all have requirements. Otherwise there
        // is no point in performing an animation. The parent node must also be set.
        var isValidAnimation = parentElement.length > 0
                                && (animationDetails.event === 'animate'
                                    || animationDetails.structural
                                    || hasAnimationClasses(animationDetails));

        // this means that the previous animation was cancelled
        // even if the follow-up animation is the same event
        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
          // if another animation did not take over then we need
          // to make sure that the domOperation and options are
          // handled accordingly
          if (animationCancelled) {
            applyAnimationClasses(element, options);
            applyAnimationStyles(element, options);
          }

          // if the event changed from something like enter to leave then we do
          // it, otherwise if it's the same then the end result will be the same too
          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
            options.domOperation();
            runner.end();
          }

          // in the event that the element animation was not cancelled or a follow-up animation
          // isn't allowed to animate from here then we need to clear the state of the element
          // so that any future animations won't read the expired animation data.
          if (!isValidAnimation) {
            clearElementAnimationState(node);
          }

          return;
        }

        // this combined multiple class to addClass / removeClass into a setClass event
        // so long as a structural event did not take over the animation
        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
            ? 'setClass'
            : animationDetails.event;

        markElementAnimationState(node, RUNNING_STATE);
        var realRunner = $$animation(element, event, animationDetails.options);

        // this will update the runner's flow-control events based on
        // the `realRunner` object.
        runner.setHost(realRunner);
        notifyProgress(runner, event, 'start', {});

        realRunner.done(function(status) {
          close(!status);
          var animationDetails = activeAnimationsLookup.get(node);
          if (animationDetails && animationDetails.counter === counter) {
            clearElementAnimationState(node);
          }
          notifyProgress(runner, event, 'close', {});
        });
      });

      return runner;

      function notifyProgress(runner, event, phase, data) {
        runInNextPostDigestOrNow(function() {
          var callbacks = findCallbacks(parentNode, node, event);
          if (callbacks.length) {
            // do not optimize this call here to RAF because
            // we don't know how heavy the callback code here will
            // be and if this code is buffered then this can
            // lead to a performance regression.
            $$rAF(function() {
              forEach(callbacks, function(callback) {
                callback(element, phase, data);
              });
              cleanupEventListeners(phase, node);
            });
          } else {
            cleanupEventListeners(phase, node);
          }
        });
        runner.progress(event, phase, data);
      }

      function close(reject) {
        clearGeneratedClasses(element, options);
        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();
        runner.complete(!reject);
      }
    }

    function closeChildAnimations(node) {
      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
      forEach(children, function(child) {
        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
        var animationDetails = activeAnimationsLookup.get(child);
        if (animationDetails) {
          switch (state) {
            case RUNNING_STATE:
              animationDetails.runner.end();
              /* falls through */
            case PRE_DIGEST_STATE:
              activeAnimationsLookup.delete(child);
              break;
          }
        }
      });
    }

    function clearElementAnimationState(node) {
      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
      activeAnimationsLookup.delete(node);
    }

    /**
     * This fn returns false if any of the following is true:
     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
     * b) a parent element has an ongoing structural animation, and animateChildren is false
     * c) the element is not a child of the body
     * d) the element is not a child of the $rootElement
     */
    function areAnimationsAllowed(node, parentNode, event) {
      var bodyNode = $document[0].body;
      var rootNode = getDomNode($rootElement);

      var bodyNodeDetected = (node === bodyNode) || node.nodeName === 'HTML';
      var rootNodeDetected = (node === rootNode);
      var parentAnimationDetected = false;
      var elementDisabled = disabledElementsLookup.get(node);
      var animateChildren;

      var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
      if (parentHost) {
        parentNode = getDomNode(parentHost);
      }

      while (parentNode) {
        if (!rootNodeDetected) {
          // angular doesn't want to attempt to animate elements outside of the application
          // therefore we need to ensure that the rootElement is an ancestor of the current element
          rootNodeDetected = (parentNode === rootNode);
        }

        if (parentNode.nodeType !== ELEMENT_NODE) {
          // no point in inspecting the #document element
          break;
        }

        var details = activeAnimationsLookup.get(parentNode) || {};
        // either an enter, leave or move animation will commence
        // therefore we can't allow any animations to take place
        // but if a parent animation is class-based then that's ok
        if (!parentAnimationDetected) {
          var parentNodeDisabled = disabledElementsLookup.get(parentNode);

          if (parentNodeDisabled === true && elementDisabled !== false) {
            // disable animations if the user hasn't explicitly enabled animations on the
            // current element
            elementDisabled = true;
            // element is disabled via parent element, no need to check anything else
            break;
          } else if (parentNodeDisabled === false) {
            elementDisabled = false;
          }
          parentAnimationDetected = details.structural;
        }

        if (isUndefined(animateChildren) || animateChildren === true) {
          var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
          if (isDefined(value)) {
            animateChildren = value;
          }
        }

        // there is no need to continue traversing at this point
        if (parentAnimationDetected && animateChildren === false) break;

        if (!bodyNodeDetected) {
          // we also need to ensure that the element is or will be a part of the body element
          // otherwise it is pointless to even issue an animation to be rendered
          bodyNodeDetected = (parentNode === bodyNode);
        }

        if (bodyNodeDetected && rootNodeDetected) {
          // If both body and root have been found, any other checks are pointless,
          // as no animation data should live outside the application
          break;
        }

        if (!rootNodeDetected) {
          // If `rootNode` is not detected, check if `parentNode` is pinned to another element
          parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
          if (parentHost) {
            // The pin target element becomes the next parent element
            parentNode = getDomNode(parentHost);
            continue;
          }
        }

        parentNode = parentNode.parentNode;
      }

      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
      return allowAnimation && rootNodeDetected && bodyNodeDetected;
    }

    function markElementAnimationState(node, state, details) {
      details = details || {};
      details.state = state;

      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);

      var oldValue = activeAnimationsLookup.get(node);
      var newValue = oldValue
          ? extend(oldValue, details)
          : details;
      activeAnimationsLookup.set(node, newValue);
    }
  }];
}];

/* exported $$AnimationProvider */

var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';

  var drivers = this.drivers = [];

  var RUNNER_STORAGE_KEY = '$$animationRunner';

  function setRunner(element, runner) {
    element.data(RUNNER_STORAGE_KEY, runner);
  }

  function removeRunner(element) {
    element.removeData(RUNNER_STORAGE_KEY);
  }

  function getRunner(element) {
    return element.data(RUNNER_STORAGE_KEY);
  }

  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler',
       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$Map,   $$rAFScheduler) {

    var animationQueue = [];
    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function sortAnimations(animations) {
      var tree = { children: [] };
      var i, lookup = new $$Map();

      // this is done first beforehand so that the map
      // is filled with a list of the elements that will be animated
      for (i = 0; i < animations.length; i++) {
        var animation = animations[i];
        lookup.set(animation.domNode, animations[i] = {
          domNode: animation.domNode,
          fn: animation.fn,
          children: []
        });
      }

      for (i = 0; i < animations.length; i++) {
        processNode(animations[i]);
      }

      return flatten(tree);

      function processNode(entry) {
        if (entry.processed) return entry;
        entry.processed = true;

        var elementNode = entry.domNode;
        var parentNode = elementNode.parentNode;
        lookup.set(elementNode, entry);

        var parentEntry;
        while (parentNode) {
          parentEntry = lookup.get(parentNode);
          if (parentEntry) {
            if (!parentEntry.processed) {
              parentEntry = processNode(parentEntry);
            }
            break;
          }
          parentNode = parentNode.parentNode;
        }

        (parentEntry || tree).children.push(entry);
        return entry;
      }

      function flatten(tree) {
        var result = [];
        var queue = [];
        var i;

        for (i = 0; i < tree.children.length; i++) {
          queue.push(tree.children[i]);
        }

        var remainingLevelEntries = queue.length;
        var nextLevelEntries = 0;
        var row = [];

        for (i = 0; i < queue.length; i++) {
          var entry = queue[i];
          if (remainingLevelEntries <= 0) {
            remainingLevelEntries = nextLevelEntries;
            nextLevelEntries = 0;
            result.push(row);
            row = [];
          }
          row.push(entry.fn);
          entry.children.forEach(function(childEntry) {
            nextLevelEntries++;
            queue.push(childEntry);
          });
          remainingLevelEntries--;
        }

        if (row.length) {
          result.push(row);
        }

        return result;
      }
    }

    // TODO(matsko): document the signature in a better way
    return function(element, event, options) {
      options = prepareAnimationOptions(options);
      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      // there is no animation at the current moment, however
      // these runner methods will get later updated with the
      // methods leading into the driver's end/cancel methods
      // for now they just stop the animation from starting
      var runner = new $$AnimateRunner({
        end: function() { close(); },
        cancel: function() { close(true); }
      });

      if (!drivers.length) {
        close();
        return runner;
      }

      setRunner(element, runner);

      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
      var tempClasses = options.tempClasses;
      if (tempClasses) {
        classes += ' ' + tempClasses;
        options.tempClasses = null;
      }

      var prepareClassName;
      if (isStructural) {
        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
        $$jqLite.addClass(element, prepareClassName);
      }

      animationQueue.push({
        // this data is used by the postDigest code and passed into
        // the driver step function
        element: element,
        classes: classes,
        event: event,
        structural: isStructural,
        options: options,
        beforeStart: beforeStart,
        close: close
      });

      element.on('$destroy', handleDestroyedElement);

      // we only want there to be one function called within the post digest
      // block. This way we can group animations for all the animations that
      // were apart of the same postDigest flush call.
      if (animationQueue.length > 1) return runner;

      $rootScope.$$postDigest(function() {
        var animations = [];
        forEach(animationQueue, function(entry) {
          // the element was destroyed early on which removed the runner
          // form its storage. This means we can't animate this element
          // at all and it already has been closed due to destruction.
          if (getRunner(entry.element)) {
            animations.push(entry);
          } else {
            entry.close();
          }
        });

        // now any future animations will be in another postDigest
        animationQueue.length = 0;

        var groupedAnimations = groupAnimations(animations);
        var toBeSortedAnimations = [];

        forEach(groupedAnimations, function(animationEntry) {
          toBeSortedAnimations.push({
            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
            fn: function triggerAnimationStart() {
              // it's important that we apply the `ng-animate` CSS class and the
              // temporary classes before we do any driver invoking since these
              // CSS classes may be required for proper CSS detection.
              animationEntry.beforeStart();

              var startAnimationFn, closeFn = animationEntry.close;

              // in the event that the element was removed before the digest runs or
              // during the RAF sequencing then we should not trigger the animation.
              var targetElement = animationEntry.anchors
                  ? (animationEntry.from.element || animationEntry.to.element)
                  : animationEntry.element;

              if (getRunner(targetElement)) {
                var operation = invokeFirstDriver(animationEntry);
                if (operation) {
                  startAnimationFn = operation.start;
                }
              }

              if (!startAnimationFn) {
                closeFn();
              } else {
                var animationRunner = startAnimationFn();
                animationRunner.done(function(status) {
                  closeFn(!status);
                });
                updateAnimationRunners(animationEntry, animationRunner);
              }
            }
          });
        });

        // we need to sort each of the animations in order of parent to child
        // relationships. This ensures that the child classes are applied at the
        // right time.
        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
      });

      return runner;

      // TODO(matsko): change to reference nodes
      function getAnchorNodes(node) {
        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
              ? [node]
              : node.querySelectorAll(SELECTOR);
        var anchors = [];
        forEach(items, function(node) {
          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
          if (attr && attr.length) {
            anchors.push(node);
          }
        });
        return anchors;
      }

      function groupAnimations(animations) {
        var preparedAnimations = [];
        var refLookup = {};
        forEach(animations, function(animation, index) {
          var element = animation.element;
          var node = getDomNode(element);
          var event = animation.event;
          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];

          if (anchorNodes.length) {
            var direction = enterOrMove ? 'to' : 'from';

            forEach(anchorNodes, function(anchor) {
              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
              refLookup[key] = refLookup[key] || {};
              refLookup[key][direction] = {
                animationID: index,
                element: jqLite(anchor)
              };
            });
          } else {
            preparedAnimations.push(animation);
          }
        });

        var usedIndicesLookup = {};
        var anchorGroups = {};
        forEach(refLookup, function(operations, key) {
          var from = operations.from;
          var to = operations.to;

          if (!from || !to) {
            // only one of these is set therefore we can't have an
            // anchor animation since all three pieces are required
            var index = from ? from.animationID : to.animationID;
            var indexKey = index.toString();
            if (!usedIndicesLookup[indexKey]) {
              usedIndicesLookup[indexKey] = true;
              preparedAnimations.push(animations[index]);
            }
            return;
          }

          var fromAnimation = animations[from.animationID];
          var toAnimation = animations[to.animationID];
          var lookupKey = from.animationID.toString();
          if (!anchorGroups[lookupKey]) {
            var group = anchorGroups[lookupKey] = {
              structural: true,
              beforeStart: function() {
                fromAnimation.beforeStart();
                toAnimation.beforeStart();
              },
              close: function() {
                fromAnimation.close();
                toAnimation.close();
              },
              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
              from: fromAnimation,
              to: toAnimation,
              anchors: [] // TODO(matsko): change to reference nodes
            };

            // the anchor animations require that the from and to elements both have at least
            // one shared CSS class which effectively marries the two elements together to use
            // the same animation driver and to properly sequence the anchor animation.
            if (group.classes.length) {
              preparedAnimations.push(group);
            } else {
              preparedAnimations.push(fromAnimation);
              preparedAnimations.push(toAnimation);
            }
          }

          anchorGroups[lookupKey].anchors.push({
            'out': from.element, 'in': to.element
          });
        });

        return preparedAnimations;
      }

      function cssClassesIntersection(a,b) {
        a = a.split(' ');
        b = b.split(' ');
        var matches = [];

        for (var i = 0; i < a.length; i++) {
          var aa = a[i];
          if (aa.substring(0,3) === 'ng-') continue;

          for (var j = 0; j < b.length; j++) {
            if (aa === b[j]) {
              matches.push(aa);
              break;
            }
          }
        }

        return matches.join(' ');
      }

      function invokeFirstDriver(animationDetails) {
        // we loop in reverse order since the more general drivers (like CSS and JS)
        // may attempt more elements, but custom drivers are more particular
        for (var i = drivers.length - 1; i >= 0; i--) {
          var driverName = drivers[i];
          var factory = $injector.get(driverName);
          var driver = factory(animationDetails);
          if (driver) {
            return driver;
          }
        }
      }

      function beforeStart() {
        element.addClass(NG_ANIMATE_CLASSNAME);
        if (tempClasses) {
          $$jqLite.addClass(element, tempClasses);
        }
        if (prepareClassName) {
          $$jqLite.removeClass(element, prepareClassName);
          prepareClassName = null;
        }
      }

      function updateAnimationRunners(animation, newRunner) {
        if (animation.from && animation.to) {
          update(animation.from.element);
          update(animation.to.element);
        } else {
          update(animation.element);
        }

        function update(element) {
          var runner = getRunner(element);
          if (runner) runner.setHost(newRunner);
        }
      }

      function handleDestroyedElement() {
        var runner = getRunner(element);
        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
          runner.end();
        }
      }

      function close(rejected) {
        element.off('$destroy', handleDestroyedElement);
        removeRunner(element);

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();

        if (tempClasses) {
          $$jqLite.removeClass(element, tempClasses);
        }

        element.removeClass(NG_ANIMATE_CLASSNAME);
        runner.complete(!rejected);
      }
    };
  }];
}];

/**
 * @ngdoc directive
 * @name ngAnimateSwap
 * @restrict A
 * @scope
 *
 * @description
 *
 * ngAnimateSwap is a animation-oriented directive that allows for the container to
 * be removed and entered in whenever the associated expression changes. A
 * common usecase for this directive is a rotating banner or slider component which
 * contains one image being present at a time. When the active image changes
 * then the old image will perform a `leave` animation and the new element
 * will be inserted via an `enter` animation.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|--------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
 *
 * @example
 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
 *          deps="angular-animate.js"
 *          animations="true" fixBase="true">
 *   <file name="index.html">
 *     <div class="container" ng-controller="AppCtrl">
 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
 *         {{ number }}
 *       </div>
 *     </div>
 *   </file>
 *   <file name="script.js">
 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
 *         $scope.number = 0;
 *         $interval(function() {
 *           $scope.number++;
 *         }, 1000);
 *
 *         var colors = ['red','blue','green','yellow','orange'];
 *         $scope.colorClass = function(number) {
 *           return colors[number % colors.length];
 *         };
 *       }]);
 *   </file>
 *  <file name="animations.css">
 *  .container {
 *    height:250px;
 *    width:250px;
 *    position:relative;
 *    overflow:hidden;
 *    border:2px solid black;
 *  }
 *  .container .cell {
 *    font-size:150px;
 *    text-align:center;
 *    line-height:250px;
 *    position:absolute;
 *    top:0;
 *    left:0;
 *    right:0;
 *    border-bottom:2px solid black;
 *  }
 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
 *    transition:0.5s linear all;
 *  }
 *  .swap-animation.ng-enter {
 *    top:-250px;
 *  }
 *  .swap-animation.ng-enter-active {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave-active {
 *    top:250px;
 *  }
 *  .red { background:red; }
 *  .green { background:green; }
 *  .blue { background:blue; }
 *  .yellow { background:yellow; }
 *  .orange { background:orange; }
 *  </file>
 * </example>
 */
var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
  return {
    restrict: 'A',
    transclude: 'element',
    terminal: true,
    priority: 600, // we use 600 here to ensure that the directive is caught before others
    link: function(scope, $element, attrs, ctrl, $transclude) {
      var previousElement, previousScope;
      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
        if (previousElement) {
          $animate.leave(previousElement);
        }
        if (previousScope) {
          previousScope.$destroy();
          previousScope = null;
        }
        if (value || value === 0) {
          previousScope = scope.$new();
          $transclude(previousScope, function(element) {
            previousElement = element;
            $animate.enter(element, null, $element);
          });
        }
      });
    }
  };
}];

/**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
 *
 * <div doc-module-components="ngAnimate"></div>
 *
 * # Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                                                | Supported Animations                                                     |
 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
 *
 * (More information can be found by visiting each the documentation associated with each directive.)
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by Angular when an underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=!bool">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
 *     to not accidentally inherit a delay property from another CSS class &#42;/
 *   transition-duration: 0s;
 *
 *   /&#42; if you are using animations instead of transitions you should configure as follows:
 *     animation-delay: 0.1s;
 *     animation-duration: 0s; &#42;/
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ### The `ng-[event]-prepare` class
 *
 * This is a special class that can be used to prevent unwanted flickering / flash of content before
 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
 * before the actual animation starts (after waiting for a $digest).
 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
 *
 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
 * into elements that have class-based animations such as `ngClass`.
 *
 * ```html
 * <div ng-class="{red: myProp}">
 *   <div ng-class="{blue: myProp}">
 *     <div class="message" ng-if="myProp"></div>
 *   </div>
 * </div>
 * ```
 *
 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
 *
 * ```css
 * .message.ng-enter-prepare {
 *   opacity: 0;
 * }
 *
 * ```
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the animation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that angular
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]);
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true,
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#!/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id: 1, title: 'Miss Beulah Roob' },
            { id: 2, title: 'Trent Morissette' },
            { id: 3, title: 'Miss Ava Pouros' },
            { id: 4, title: 'Rod Pouros' },
            { id: 5, title: 'Abdul Rice' },
            { id: 6, title: 'Laurie Rutherford Sr.' },
            { id: 7, title: 'Nakia McLaughlin' },
            { id: 8, title: 'Jordon Blanda DVM' },
            { id: 9, title: 'Rhoda Hand' },
            { id: 10, title: 'Alexandrea Sauer' }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams',
            function ProfileController($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#!/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
 */

var copy;
var extend;
var forEach;
var isArray;
var isDefined;
var isElement;
var isFunction;
var isObject;
var isString;
var isUndefined;
var jqLite;
var noop;

/**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
 */
angular.module('ngAnimate', [], function initAngularHelpers() {
  // Access helpers from angular core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  noop        = angular.noop;
  copy        = angular.copy;
  extend      = angular.extend;
  jqLite      = angular.element;
  forEach     = angular.forEach;
  isArray     = angular.isArray;
  isString    = angular.isString;
  isObject    = angular.isObject;
  isUndefined = angular.isUndefined;
  isDefined   = angular.isDefined;
  isFunction  = angular.isFunction;
  isElement   = angular.isElement;
})
  .info({ angularVersion: '1.6.5' })
  .directive('ngAnimateSwap', ngAnimateSwapDirective)

  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
  .factory('$$rAFScheduler', $$rAFSchedulerFactory)

  .provider('$$animateQueue', $$AnimateQueueProvider)
  .provider('$$animation', $$AnimationProvider)

  .provider('$animateCss', $AnimateCssProvider)
  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)

  .provider('$$animateJs', $$AnimateJsProvider)
  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);


})(window, window.angular);


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(564);
module.exports = 'ngAnimate';


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("angular-barcode",[],e):"object"==typeof exports?exports["angular-barcode"]=e():t["angular-barcode"]=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return t[r].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(43),i=r(o);e.default=angular.module("angular-barcode",[]).directive("angularBarcode",i.default),t.exports=e.default},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function t(e,r){n(this,t),this.data=e,this.text=r.text||e,this.options=r};e.default=r},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(){n(this,t),this.startBin="101",this.endBin="101",this.middleBin="01010",this.Lbinary=["0001101","0011001","0010011","0111101","0100011","0110001","0101111","0111011","0110111","0001011"],this.Gbinary=["0100111","0110011","0011011","0100001","0011101","0111001","0000101","0010001","0001001","0010111"],this.Rbinary=["1110010","1100110","1101100","1000010","1011100","1001110","1010000","1000100","1001000","1110100"]}return t.prototype.encode=function(t,e,n){var r="";n=n||"";for(var o=0;o<t.length;o++)"L"==e[o]?r+=this.Lbinary[t[o]]:"G"==e[o]?r+=this.Gbinary[t[o]]:"R"==e[o]&&(r+=this.Rbinary[t[o]]),o<t.length-1&&(r+=n);return r},t}();e.default=r},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function u(t,e){for(var n=0;n<e;n++)t="0"+t;return t}Object.defineProperty(e,"__esModule",{value:!0});var s=n(1),c=r(s),f=function(t){function e(n,r){return o(this,e),i(this,t.call(this,n,r))}return a(e,t),e.prototype.encode=function(){for(var t="110",e=0;e<this.data.length;e++){var n=parseInt(this.data[e]),r=n.toString(2);r=u(r,4-r.length);for(var o=0;o<r.length;o++)t+="0"==r[o]?"100":"110"}return t+="1001",{data:t,text:this.text}},e.prototype.valid=function(){return this.data.search(/^[0-9]+$/)!==-1},e}(c.default);e.default=f},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var u=n(1),s=r(u),c=function(t){function e(n,r){o(this,e);var a=i(this,t.call(this,n.substring(1),r));a.bytes=[];for(var u=0;u<n.length;++u)a.bytes.push(n.charCodeAt(u));return a.encodings=[740,644,638,176,164,100,224,220,124,608,604,572,436,244,230,484,260,254,650,628,614,764,652,902,868,836,830,892,844,842,752,734,590,304,112,94,416,128,122,672,576,570,464,422,134,496,478,142,910,678,582,768,762,774,880,862,814,896,890,818,914,602,930,328,292,200,158,68,62,424,412,232,218,76,74,554,616,978,556,146,340,212,182,508,268,266,956,940,938,758,782,974,400,310,118,512,506,960,954,502,518,886,966,668,680,692,5379],a}return a(e,t),e.prototype.encode=function(){var t,e=this.bytes,n=e.shift()-105;if(103===n)t=this.nextA(e,1);else if(104===n)t=this.nextB(e,1);else{if(105!==n)throw new f;t=this.nextC(e,1)}return{text:this.text==this.data?this.text.replace(/[^\x20-\x7E]/g,""):this.text,data:this.getEncoding(n)+t.result+this.getEncoding((t.checksum+n)%103)+this.getEncoding(106)}},e.prototype.getEncoding=function(t){return this.encodings[t]?(this.encodings[t]+1e3).toString(2):""},e.prototype.valid=function(){return this.data.search(/^[\x00-\x7F\xC8-\xD3]+$/)!==-1},e.prototype.nextA=function(t,e){if(t.length<=0)return{result:"",checksum:0};var n,r;if(t[0]>=200)r=t[0]-105,t.shift(),99===r?n=this.nextC(t,e+1):100===r?n=this.nextB(t,e+1):98===r?(t[0]=t[0]>95?t[0]-96:t[0],n=this.nextA(t,e+1)):n=this.nextA(t,e+1);else{var o=t[0];r=o<32?o+64:o-32,t.shift(),n=this.nextA(t,e+1)}var i=this.getEncoding(r),a=r*e;return{result:i+n.result,checksum:a+n.checksum}},e.prototype.nextB=function(t,e){if(t.length<=0)return{result:"",checksum:0};var n,r;t[0]>=200?(r=t[0]-105,t.shift(),99===r?n=this.nextC(t,e+1):101===r?n=this.nextA(t,e+1):98===r?(t[0]=t[0]<32?t[0]+96:t[0],n=this.nextB(t,e+1)):n=this.nextB(t,e+1)):(r=t[0]-32,t.shift(),n=this.nextB(t,e+1));var o=this.getEncoding(r),i=r*e;return{result:o+n.result,checksum:i+n.checksum}},e.prototype.nextC=function(t,e){if(t.length<=0)return{result:"",checksum:0};var n,r;t[0]>=200?(r=t[0]-105,t.shift(),n=100===r?this.nextB(t,e+1):101===r?this.nextA(t,e+1):this.nextC(t,e+1)):(r=10*(t[0]-48)+t[1]-48,t.shift(),t.shift(),n=this.nextC(t,e+1));var o=this.getEncoding(r),i=r*e;return{result:o+n.result,checksum:i+n.checksum}},e}(s.default),f=function(t){function e(){o(this,e);var n=i(this,t.call(this));return n.name="InvalidStartCharacterException",n.message="The encoding does not start with a start character.",n}return a(e,t),e}(Error);e.default=c},function(t,e){"use strict";function n(t){for(var e=0,n=0;n<t.length;n++){var r=parseInt(t[n]);e+=(n+t.length)%2===0?r:2*r%10+Math.floor(2*r/10)}return(10-e%10)%10}function r(t){for(var e=0,n=[2,3,4,5,6,7],r=0;r<t.length;r++){var o=parseInt(t[t.length-1-r]);e+=n[r%n.length]*o}return(11-e%11)%11}Object.defineProperty(e,"__esModule",{value:!0}),e.mod10=n,e.mod11=r},function(t,e){"use strict";function n(t,e){var n,r={};for(n in t)t.hasOwnProperty(n)&&(r[n]=t[n]);for(n in e)e.hasOwnProperty(n)&&"undefined"!=typeof e[n]&&(r[n]=e[n]);return r}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function o(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var i=function(t){function e(o,i){n(this,e);var a=r(this,t.call(this));return a.name="InvalidInputException",a.symbology=o,a.input=i,a.message='"'+a.input+'" is not a valid input for '+a.symbology,a}return o(e,t),e}(Error),a=function(t){function e(){n(this,e);var o=r(this,t.call(this));return o.name="InvalidElementException",o.message="Not supported type to render on",o}return o(e,t),e}(Error),u=function(t){function e(){n(this,e);var o=r(this,t.call(this));return o.name="NoElementException",o.message="No element to render on.",o}return o(e,t),e}(Error);e.InvalidInputException=i,e.InvalidElementException=a,e.NoElementException=u},function(t,e){"use strict";function n(t){var e=["width","height","textMargin","fontSize","margin","marginTop","marginBottom","marginLeft","marginRight"];for(var n in e)e.hasOwnProperty(n)&&(n=e[n],"string"==typeof t[n]&&(t[n]=parseInt(t[n],10)));return"string"==typeof t.displayValue&&(t.displayValue="false"!=t.displayValue),t}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n={width:2,height:100,format:"auto",displayValue:!0,fontOptions:"",font:"monospace",text:void 0,textAlign:"center",textPosition:"bottom",textMargin:2,fontSize:20,background:"#ffffff",lineColor:"#000000",margin:10,marginTop:void 0,marginBottom:void 0,marginLeft:void 0,marginRight:void 0,valid:function(){}};e.default=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){return e.height+(e.displayValue&&t.text.length>0?e.fontSize+e.textMargin:0)+e.marginTop+e.marginBottom}function i(t,e,n){if(n.displayValue&&e<t){if("center"==n.textAlign)return Math.floor((t-e)/2);if("left"==n.textAlign)return 0;if("right"==n.textAlign)return Math.floor(t-e)}return 0}function a(t,e,n){for(var r=0;r<t.length;r++){var a,u=t[r],s=(0,l.default)(e,u.options);a=s.displayValue?c(u.text,s,n):0;var f=u.data.length*s.width;u.width=Math.ceil(Math.max(a,f)),u.height=o(u,s),u.barcodePadding=i(a,f,s)}}function u(t){for(var e=0,n=0;n<t.length;n++)e+=t[n].width;return e}function s(t){for(var e=0,n=0;n<t.length;n++)t[n].height>e&&(e=t[n].height);return e}function c(t,e,n){var r;r="undefined"==typeof n?document.createElement("canvas").getContext("2d"):n,r.font=e.fontOptions+" "+e.fontSize+"px "+e.font;var o=r.measureText(t).width;return o}Object.defineProperty(e,"__esModule",{value:!0}),e.getTotalWidthOfEncodings=e.calculateEncodingAttributes=e.getBarcodePadding=e.getEncodingHeight=e.getMaximumHeightOfEncodings=void 0;var f=n(6),l=r(f);e.getMaximumHeightOfEncodings=s,e.getEncodingHeight=o,e.getBarcodePadding=i,e.calculateEncodingAttributes=a,e.getTotalWidthOfEncodings=u},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){E.prototype[e]=E.prototype[e.toUpperCase()]=E.prototype[e.toLowerCase()]=function(n,r){var o=this;return o._errorHandler.wrapBarcodeCall(function(){var a=(0,l.default)(o._options,r);a=(0,_.default)(a);var u=t[e],s=i(n,u,a);return o._encodings.push(s),o})}}function i(t,e,n){t=""+t;var r=new e(t,n);if(!r.valid())throw new m.InvalidInputException(r.constructor.name,t);var o=r.encode();o=(0,d.default)(o);for(var i=0;i<o.length;i++)o[i].options=(0,l.default)(n,o[i].options);return o}function a(){return c.default.CODE128?"CODE128":Object.keys(c.default)[0]}function u(t,e,n){e=(0,d.default)(e);for(var r=0;r<e.length;r++)e[r].options=(0,l.default)(n,e[r].options),(0,y.default)(e[r].options);(0,y.default)(n);var o=t.renderer,i=new o(t.element,e,n);i.render(),t.afterRender&&t.afterRender()}var s=n(33),c=r(s),f=n(6),l=r(f),p=n(39),d=r(p),h=n(36),y=r(h),b=n(38),g=r(b),v=n(8),_=r(v),w=n(35),x=r(w),m=n(7),O=n(9),C=r(O),E=function(){},j=function(t,e,n){var r=new E;if("undefined"==typeof t)throw Error("No element to render on was provided.");return r._renderProperties=(0,g.default)(t),r._encodings=[],r._options=C.default,r._errorHandler=new x.default(r),"undefined"!=typeof e&&(n=n||{},n.format||(n.format=a()),r.options(n)[n.format](e,n).render()),r};j.getModule=function(t){return c.default[t]};for(var P in c.default)c.default.hasOwnProperty(P)&&o(c.default,P);E.prototype.options=function(t){return this._options=(0,l.default)(this._options,t),this},E.prototype.blank=function(t){var e="0".repeat(t);return this._encodings.push({data:e}),this},E.prototype.init=function(){if(this._renderProperties){Array.isArray(this._renderProperties)||(this._renderProperties=[this._renderProperties]);var t;for(var e in this._renderProperties){t=this._renderProperties[e];var n=(0,l.default)(this._options,t.options);"auto"==n.format&&(n.format=a()),this._errorHandler.wrapBarcodeCall(function(){var e=n.value,r=c.default[n.format.toUpperCase()],o=i(e,r,n);u(t,o,n)})}}},E.prototype.render=function(){if(!this._renderProperties)throw new m.NoElementException;if(Array.isArray(this._renderProperties))for(var t=0;t<this._renderProperties.length;t++)u(this._renderProperties[t],this._encodings,this._options);else u(this._renderProperties,this._encodings,this._options);return this},E.prototype._defaults=C.default,"undefined"!=typeof window&&(window.JsBarcode=j),"undefined"!=typeof jQuery&&(jQuery.fn.JsBarcode=function(t,e){var n=[];return jQuery(this).each(function(){n.push(this)}),j(n,t,e)}),t.exports=j},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var u=n(4),s=r(u),c=function(t){function e(n,r){return o(this,e),i(this,t.call(this,String.fromCharCode(208)+n,r))}return a(e,t),e.prototype.valid=function(){return this.data.search(/^[\x00-\x5F\xC8-\xCF]+$/)!==-1},e}(s.default);e.default=c},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var u=n(4),s=r(u),c=function(t){function e(n,r){return o(this,e),i(this,t.call(this,String.fromCharCode(209)+n,r))}return a(e,t),e.prototype.valid=function(){return this.data.search(/^[\x20-\x7F\xC8-\xCF]+$/)!==-1},e}(s.default);e.default=c},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var u=n(4),s=r(u),c=function(t){function e(n,r){return o(this,e),i(this,t.call(this,String.fromCharCode(210)+n,r))}return a(e,t),e.prototype.valid=function(){return this.data.search(/^(\xCF*[0-9]{2}\xCF*)+$/)!==-1},e}(s.default);e.default=c},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function u(t){var e,n=t.match(/^[\x00-\x5F\xC8-\xCF]*/)[0].length,r=t.match(/^[\x20-\x7F\xC8-\xCF]*/)[0].length,o=t.match(/^(\xCF*[0-9]{2}\xCF*)*/)[0].length;return e=o>=2?String.fromCharCode(210)+f(t):n>r?String.fromCharCode(208)+s(t):String.fromCharCode(209)+c(t),e=e.replace(/[\xCD\xCE]([^])[\xCD\xCE]/,function(t,e){return String.fromCharCode(203)+e})}function s(t){var e=t.match(/^([\x00-\x5F\xC8-\xCF]+?)(([0-9]{2}){2,})([^0-9]|$)/);if(e)return e[1]+String.fromCharCode(204)+f(t.substring(e[1].length));var n=t.match(/^[\x00-\x5F\xC8-\xCF]+/);return n[0].length===t.length?t:n[0]+String.fromCharCode(205)+c(t.substring(n[0].length))}function c(t){var e=t.match(/^([\x20-\x7F\xC8-\xCF]+?)(([0-9]{2}){2,})([^0-9]|$)/);if(e)return e[1]+String.fromCharCode(204)+f(t.substring(e[1].length));var n=t.match(/^[\x20-\x7F\xC8-\xCF]+/);return n[0].length===t.length?t:n[0]+String.fromCharCode(206)+s(t.substring(n[0].length))}function f(t){var e=t.match(/^(\xCF*[0-9]{2}\xCF*)+/)[0],n=e.length;if(n===t.length)return t;t=t.substring(n);var r=t.match(/^[\x00-\x5F\xC8-\xCF]*/)[0].length,o=t.match(/^[\x20-\x7F\xC8-\xCF]*/)[0].length;return r>=o?e+String.fromCharCode(206)+s(t):e+String.fromCharCode(205)+c(t)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(4),p=r(l),d=function(t){function e(n,r){if(o(this,e),n.search(/^[\x00-\x7F\xC8-\xD3]+$/)!==-1)var a=i(this,t.call(this,u(n),r));else var a=i(this,t.call(this,n,r));return i(a)}return a(e,t),e}(p.default);e.default=d},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.CODE128C=e.CODE128B=e.CODE128A=e.CODE128=void 0;var o=n(15),i=r(o),a=n(12),u=r(a),s=n(13),c=r(s),f=n(14),l=r(f);e.CODE128=i.default,e.CODE128A=u.default,e.CODE128B=c.default,e.CODE128C=l.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function u(t){return s(f(t))}function s(t){return b[t].toString(2)}function c(t){return y[t]}function f(t){return y.indexOf(t)}function l(t){for(var e=0,n=0;n<t.length;n++)e+=f(t[n]);return e%=43}Object.defineProperty(e,"__esModule",{value:!0}),e.CODE39=void 0;var p=n(1),d=r(p),h=function(t){function e(n,r){return o(this,e),n=n.toUpperCase(),r.mod43&&(n+=c(l(n))),i(this,t.call(this,n,r))}return a(e,t),e.prototype.encode=function(){for(var t=u("*"),e=0;e<this.data.length;e++)t+=u(this.data[e])+"0";return t+=u("*"),{data:t,text:this.text}},e.prototype.valid=function(){return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/)!==-1},e}(d.default),y=["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","-","."," ","$","/","+","%","*"],b=[20957,29783,23639,30485,20951,29813,23669,20855,29789,23645,29975,23831,30533,22295,30149,24005,21623,29981,23837,22301,30023,23879,30545,22343,30161,24017,21959,30065,23921,22385,29015,18263,29141,17879,29045,18293,17783,29021,18269,17477,17489,17681,20753,35770];e.CODE39=h},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function u(t){var e,n=0;for(e=0;e<12;e+=2)n+=parseInt(t[e]);for(e=1;e<12;e+=2)n+=3*parseInt(t[e]);return(10-n%10)%10}Object.defineProperty(e,"__esModule",{value:!0});var s=n(2),c=r(s),f=n(1),l=r(f),p=function(t){function e(n,r){o(this,e),n.search(/^[0-9]{12}$/)!==-1&&(n+=u(n));var a=i(this,t.call(this,n,r));return!r.flat&&r.fontSize>10*r.width?a.fontSize=10*r.width:a.fontSize=r.fontSize,a.guardHeight=r.height+a.fontSize/2+r.textMargin,a.lastChar=r.lastChar,a}return a(e,t),e.prototype.valid=function(){return this.data.search(/^[0-9]{13}$/)!==-1&&this.data[12]==u(this.data)},e.prototype.encode=function(){return this.options.flat?this.flatEncoding():this.guardedEncoding()},e.prototype.getStructure=function(){return["LLLLLL","LLGLGG","LLGGLG","LLGGGL","LGLLGG","LGGLLG","LGGGLL","LGLGLG","LGLGGL","LGGLGL"]},e.prototype.guardedEncoding=function(){var t=new c.default,e=[],n=this.getStructure()[this.data[0]],r=this.data.substr(1,6),o=this.data.substr(7,6);return this.options.displayValue&&e.push({data:"000000000000",text:this.text.substr(0,1),options:{textAlign:"left",fontSize:this.fontSize}}),e.push({data:"101",options:{height:this.guardHeight}}),e.push({data:t.encode(r,n),text:this.text.substr(1,6),options:{fontSize:this.fontSize}}),e.push({data:"01010",options:{height:this.guardHeight}}),e.push({data:t.encode(o,"RRRRRR"),text:this.text.substr(7,6),options:{fontSize:this.fontSize}}),e.push({data:"101",options:{height:this.guardHeight}}),this.options.lastChar&&this.options.displayValue&&(e.push({data:"00"}),e.push({data:"00000",text:this.options.lastChar,options:{fontSize:this.fontSize}})),e},e.prototype.flatEncoding=function(){var t=new c.default,e="",n=this.getStructure()[this.data[0]];return e+="101",e+=t.encode(this.data.substr(1,6),n),e+="01010",e+=t.encode(this.data.substr(7,6),"RRRRRR"),e+="101",{data:e,text:this.text}},e}(l.default);e.default=p},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var u=n(2),s=r(u),c=n(1),f=r(c),l=function(t){function e(n,r){o(this,e);var a=i(this,t.call(this,n,r));return a.structure=["LL","LG","GL","GG"],a}return a(e,t),e.prototype.valid=function(){return this.data.search(/^[0-9]{2}$/)!==-1},e.prototype.encode=function(){var t=new s.default,e=this.structure[parseInt(this.data)%4],n="1011";return n+=t.encode(this.data,e,"01"),{data:n,text:this.text}},e}(f.default);e.default=l},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var u=n(2),s=r(u),c=n(1),f=r(c),l=function(t){function e(n,r){o(this,e);var a=i(this,t.call(this,n,r));return a.structure=["GGLLL","GLGLL","GLLGL","GLLLG","LGGLL","LLGGL","LLLGG","LGLGL","LGLLG","LLGLG"],a}return a(e,t),e.prototype.valid=function(){return this.data.search(/^[0-9]{5}$/)!==-1},e.prototype.encode=function(){var t=new s.default,e=this.checksum(),n="1011";return n+=t.encode(this.data,this.structure[e],"01"),{data:n,text:this.text}},e.prototype.checksum=function(){var t=0;return t+=3*parseInt(this.data[0]),t+=9*parseInt(this.data[1]),t+=3*parseInt(this.data[2]),t+=9*parseInt(this.data[3]),t+=3*parseInt(this.data[4]),t%10},e}(f.default);e.default=l},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function u(t){var e,n=0;for(e=0;e<7;e+=2)n+=3*parseInt(t[e]);for(e=1;e<7;e+=2)n+=parseInt(t[e]);return(10-n%10)%10}Object.defineProperty(e,"__esModule",{value:!0});var s=n(2),c=r(s),f=n(1),l=r(f),p=function(t){function e(n,r){return o(this,e),n.search(/^[0-9]{7}$/)!==-1&&(n+=u(n)),i(this,t.call(this,n,r))}return a(e,t),e.prototype.valid=function(){return this.data.search(/^[0-9]{8}$/)!==-1&&this.data[7]==u(this.data)},e.prototype.encode=function(){var t=new c.default,e="",n=this.data.substr(0,4),r=this.data.substr(4,4);return e+=t.startBin,e+=t.encode(n,"LLLL"),e+=t.middleBin,e+=t.encode(r,"RRRR"),e+=t.endBin,{data:e,text:this.text}},e}(l.default);e.default=p},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function u(t){var e,n=0;for(e=1;e<11;e+=2)n+=parseInt(t[e]);for(e=0;e<11;e+=2)n+=3*parseInt(t[e]);return(10-n%10)%10}Object.defineProperty(e,"__esModule",{value:!0});var s=n(2),c=r(s),f=n(1),l=r(f),p=function(t){function e(n,r){o(this,e),n.search(/^[0-9]{11}$/)!==-1&&(n+=u(n));var a=i(this,t.call(this,n,r));return a.displayValue=r.displayValue,r.fontSize>10*r.width?a.fontSize=10*r.width:a.fontSize=r.fontSize,a.guardHeight=r.height+a.fontSize/2+r.textMargin,a}return a(e,t),e.prototype.valid=function(){return this.data.search(/^[0-9]{12}$/)!==-1&&this.data[11]==u(this.data)},e.prototype.encode=function(){return this.options.flat?this.flatEncoding():this.guardedEncoding()},e.prototype.flatEncoding=function(){var t=new c.default,e="";return e+="101",e+=t.encode(this.data.substr(0,6),"LLLLLL"),e+="01010",e+=t.encode(this.data.substr(6,6),"RRRRRR"),e+="101",{data:e,text:this.text}},e.prototype.guardedEncoding=function(){var t=new c.default,e=[];return this.displayValue&&e.push({data:"00000000",text:this.text.substr(0,1),options:{textAlign:"left",fontSize:this.fontSize}}),e.push({data:"101"+t.encode(this.data[0],"L"),options:{height:this.guardHeight}}),e.push({data:t.encode(this.data.substr(1,5),"LLLLL"),text:this.text.substr(1,5),options:{fontSize:this.fontSize}}),e.push({data:"01010",options:{height:this.guardHeight}}),e.push({data:t.encode(this.data.substr(6,5),"RRRRR"),text:this.text.substr(6,5),options:{fontSize:this.fontSize}}),e.push({data:t.encode(this.data[11],"R")+"101",options:{height:this.guardHeight}}),this.displayValue&&e.push({data:"00000000",text:this.text.substr(11,1),options:{textAlign:"right",fontSize:this.fontSize}}),e},e}(l.default);e.default=p},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.UPC=e.EAN2=e.EAN5=e.EAN8=e.EAN13=void 0;var o=n(18),i=r(o),a=n(21),u=r(a),s=n(20),c=r(s),f=n(19),l=r(f),p=n(22),d=r(p);e.EAN13=i.default,e.EAN8=u.default,e.EAN5=c.default,e.EAN2=l.default,e.UPC=d.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.GenericBarcode=void 0;var u=n(1),s=r(u),c=function(t){function e(n,r){return o(this,e),i(this,t.call(this,n,r))}return a(e,t),e.prototype.encode=function(){return{data:"10101010101010101010101010101010101010101",text:this.text}},e.prototype.valid=function(){return!0},e}(s.default);e.GenericBarcode=c},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function u(t){for(var e=0,n=0;n<13;n++)e+=parseInt(t[n])*(3-n%2*2);return 10*Math.ceil(e/10)-e}Object.defineProperty(e,"__esModule",{value:!0}),e.ITF14=void 0;var s=n(1),c=r(s),f=function(t){function e(n,r){o(this,e),n.search(/^[0-9]{13}$/)!==-1&&(n+=u(n));var a=i(this,t.call(this,n,r));return a.binaryRepresentation={0:"00110",1:"10001",2:"01001",3:"11000",4:"00101",5:"10100",6:"01100",7:"00011",8:"10010",9:"01010"},a}return a(e,t),e.prototype.valid=function(){return this.data.search(/^[0-9]{14}$/)!==-1&&this.data[13]==u(this.data)},e.prototype.encode=function(){for(var t="1010",e=0;e<14;e+=2)t+=this.calculatePair(this.data.substr(e,2));return t+="11101",{data:t,text:this.text}},e.prototype.calculatePair=function(t){for(var e="",n=this.binaryRepresentation[t[0]],r=this.binaryRepresentation[t[1]],o=0;o<5;o++)e+="1"==n[o]?"111":"1",e+="1"==r[o]?"000":"0";return e},e}(c.default);e.ITF14=f},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e);
}Object.defineProperty(e,"__esModule",{value:!0}),e.ITF=void 0;var u=n(1),s=r(u),c=function(t){function e(n,r){o(this,e);var a=i(this,t.call(this,n,r));return a.binaryRepresentation={0:"00110",1:"10001",2:"01001",3:"11000",4:"00101",5:"10100",6:"01100",7:"00011",8:"10010",9:"01010"},a}return a(e,t),e.prototype.valid=function(){return this.data.search(/^([0-9]{2})+$/)!==-1},e.prototype.encode=function(){for(var t="1010",e=0;e<this.data.length;e+=2)t+=this.calculatePair(this.data.substr(e,2));return t+="11101",{data:t,text:this.text}},e.prototype.calculatePair=function(t){for(var e="",n=this.binaryRepresentation[t[0]],r=this.binaryRepresentation[t[1]],o=0;o<5;o++)e+="1"==n[o]?"111":"1",e+="1"==r[o]?"000":"0";return e},e}(s.default);e.ITF=c},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var u=n(3),s=r(u),c=n(5),f=function(t){function e(n,r){return o(this,e),i(this,t.call(this,n+(0,c.mod10)(n),r))}return a(e,t),e}(s.default);e.default=f},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var u=n(3),s=r(u),c=n(5),f=function(t){function e(n,r){return o(this,e),n+=(0,c.mod10)(n),n+=(0,c.mod10)(n),i(this,t.call(this,n,r))}return a(e,t),e}(s.default);e.default=f},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var u=n(3),s=r(u),c=n(5),f=function(t){function e(n,r){return o(this,e),i(this,t.call(this,n+(0,c.mod11)(n),r))}return a(e,t),e}(s.default);e.default=f},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var u=n(3),s=r(u),c=n(5),f=function(t){function e(n,r){return o(this,e),n+=(0,c.mod11)(n),n+=(0,c.mod10)(n),i(this,t.call(this,n,r))}return a(e,t),e}(s.default);e.default=f},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.MSI1110=e.MSI1010=e.MSI11=e.MSI10=e.MSI=void 0;var o=n(3),i=r(o),a=n(27),u=r(a),s=n(29),c=r(s),f=n(28),l=r(f),p=n(30),d=r(p);e.MSI=i.default,e.MSI10=u.default,e.MSI11=c.default,e.MSI1010=l.default,e.MSI1110=d.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.codabar=void 0;var u=n(1),s=r(u),c=function(t){function e(n,r){o(this,e),0===n.search(/^[0-9\-\$\:\.\+\/]+$/)&&(n="A"+n+"A");var a=i(this,t.call(this,n.toUpperCase(),r));return a.text=a.options.text||a.text.replace(/[A-D]/g,""),a}return a(e,t),e.prototype.valid=function(){return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/)!==-1},e.prototype.encode=function(){for(var t=[],e=this.getEncodings(),n=0;n<this.data.length;n++)t.push(e[this.data.charAt(n)]),n!==this.data.length-1&&t.push("0");return{text:this.text,data:t.join("")}},e.prototype.getEncodings=function(){return{0:"101010011",1:"101011001",2:"101001011",3:"110010101",4:"101101001",5:"110101001",6:"100101011",7:"100101101",8:"100110101",9:"110100101","-":"101001101",$:"101100101",":":"1101011011","/":"1101101011",".":"1101101101","+":"101100110011",A:"1011001001",B:"1010010011",C:"1001001011",D:"1010011001"}},e}(s.default);e.codabar=c},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(17),o=n(16),i=n(23),a=n(25),u=n(26),s=n(31),c=n(34),f=n(32),l=n(24);e.default={CODE39:r.CODE39,CODE128:o.CODE128,CODE128A:o.CODE128A,CODE128B:o.CODE128B,CODE128C:o.CODE128C,EAN13:i.EAN13,EAN8:i.EAN8,EAN5:i.EAN5,EAN2:i.EAN2,UPC:i.UPC,ITF14:a.ITF14,ITF:u.ITF,MSI:s.MSI,MSI10:s.MSI10,MSI11:s.MSI11,MSI1010:s.MSI1010,MSI1110:s.MSI1110,pharmacode:c.pharmacode,codabar:f.codabar,GenericBarcode:l.GenericBarcode}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0}),e.pharmacode=void 0;var u=n(1),s=r(u),c=function(t){function e(n,r){o(this,e);var a=i(this,t.call(this,n,r));return a.number=parseInt(n,10),a}return a(e,t),e.prototype.encode=function(){for(var t=this.number,e="";!isNaN(t)&&0!=t;)t%2===0?(e="11100"+e,t=(t-2)/2):(e="100"+e,t=(t-1)/2);return e=e.slice(0,-2),{data:e,text:this.text}},e.prototype.valid=function(){return this.number>=3&&this.number<=131070},e}(s.default);e.pharmacode=c},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(e){n(this,t),this.api=e}return t.prototype.handleCatch=function(t){if("InvalidInputException"!==t.name)throw t;if(this.api._options.valid===this.api._defaults.valid)throw t.message;this.api._options.valid(!1),this.api.render=function(){}},t.prototype.wrapBarcodeCall=function(t){try{var e=t.apply(void 0,arguments);return this.api._options.valid(!0),e}catch(t){return this.handleCatch(t),this.api}},t}();e.default=r},function(t,e){"use strict";function n(t){return t.marginTop=t.marginTop||t.margin,t.marginBottom=t.marginBottom||t.margin,t.marginRight=t.marginRight||t.margin,t.marginLeft=t.marginLeft||t.margin,t}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t){var e={};for(var n in s.default)s.default.hasOwnProperty(n)&&(t.hasAttribute("jsbarcode-"+n.toLowerCase())&&(e[n]=t.getAttribute("jsbarcode-"+n.toLowerCase())),t.hasAttribute("data-"+n.toLowerCase())&&(e[n]=t.getAttribute("data-"+n.toLowerCase())));return e.value=t.getAttribute("jsbarcode-value")||t.getAttribute("data-value"),e=(0,a.default)(e)}Object.defineProperty(e,"__esModule",{value:!0});var i=n(8),a=r(i),u=n(9),s=r(u);e.default=o},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t){if("string"==typeof t)return i(t);if(Array.isArray(t)){for(var e=[],n=0;n<t.length;n++)e.push(o(t[n]));return e}if("undefined"!=typeof HTMLCanvasElement&&t instanceof HTMLImageElement)return a(t);if("undefined"!=typeof SVGElement&&t instanceof SVGElement)return{element:t,options:(0,s.default)(t),renderer:f.default.SVGRenderer};if("undefined"!=typeof HTMLCanvasElement&&t instanceof HTMLCanvasElement)return{element:t,options:(0,s.default)(t),renderer:f.default.CanvasRenderer};if(t.getContext)return{element:t,renderer:f.default.CanvasRenderer};throw new l.InvalidElementException}function i(t){var e=document.querySelectorAll(t);if(0!==e.length){for(var n=[],r=0;r<e.length;r++)n.push(o(e[r]));return n}}function a(t){var e=document.createElement("canvas");return{element:e,options:(0,s.default)(t),renderer:f.default.CanvasRenderer,afterRender:function(){t.setAttribute("src",e.toDataURL())}}}Object.defineProperty(e,"__esModule",{value:!0});var u=n(37),s=r(u),c=n(41),f=r(c),l=n(7);e.default=o},function(t,e){"use strict";function n(t){function e(t){if(Array.isArray(t))for(var r=0;r<t.length;r++)e(t[r]);else t.text=t.text||"",t.data=t.data||"",n.push(t)}var n=[];return e(t),n}Object.defineProperty(e,"__esModule",{value:!0}),e.default=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var i=n(6),a=r(i),u=n(10),s=function(){function t(e,n,r){o(this,t),this.canvas=e,this.encodings=n,this.options=r}return t.prototype.render=function(){if(!this.canvas.getContext)throw new Error("The browser does not support canvas.");this.prepareCanvas();for(var t=0;t<this.encodings.length;t++){var e=(0,a.default)(this.options,this.encodings[t].options);this.drawCanvasBarcode(e,this.encodings[t]),this.drawCanvasText(e,this.encodings[t]),this.moveCanvasDrawing(this.encodings[t])}this.restoreCanvas()},t.prototype.prepareCanvas=function(){var t=this.canvas.getContext("2d");t.save(),(0,u.calculateEncodingAttributes)(this.encodings,this.options,t);var e=(0,u.getTotalWidthOfEncodings)(this.encodings),n=(0,u.getMaximumHeightOfEncodings)(this.encodings);this.canvas.width=e+this.options.marginLeft+this.options.marginRight,this.canvas.height=n,t.clearRect(0,0,this.canvas.width,this.canvas.height),this.options.background&&(t.fillStyle=this.options.background,t.fillRect(0,0,this.canvas.width,this.canvas.height)),t.translate(this.options.marginLeft,0)},t.prototype.drawCanvasBarcode=function(t,e){var n,r=this.canvas.getContext("2d"),o=e.data;n="top"==t.textPosition?t.marginTop+t.fontSize+t.textMargin:t.marginTop,r.fillStyle=t.lineColor;for(var i=0;i<o.length;i++){var a=i*t.width+e.barcodePadding;"1"===o[i]?r.fillRect(a,n,t.width,t.height):o[i]&&r.fillRect(a,n,t.width,t.height*o[i])}},t.prototype.drawCanvasText=function(t,e){var n=this.canvas.getContext("2d"),r=t.fontOptions+" "+t.fontSize+"px "+t.font;if(t.displayValue){var o,i;i="top"==t.textPosition?t.marginTop+t.fontSize-t.textMargin:t.height+t.textMargin+t.marginTop+t.fontSize,n.font=r,"left"==t.textAlign||e.barcodePadding>0?(o=0,n.textAlign="left"):"right"==t.textAlign?(o=e.width-1,n.textAlign="right"):(o=e.width/2,n.textAlign="center"),n.fillText(e.text,o,i)}},t.prototype.moveCanvasDrawing=function(t){var e=this.canvas.getContext("2d");e.translate(t.width,0)},t.prototype.restoreCanvas=function(){var t=this.canvas.getContext("2d");t.restore()},t}();e.default=s},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(40),i=r(o),a=n(42),u=r(a);e.default={CanvasRenderer:i.default,SVGRenderer:u.default}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e,n){var r=document.createElementNS(l,"g");return r.setAttribute("transform","translate("+t+", "+e+")"),n.appendChild(r),r}function a(t,e){t.setAttribute("style","fill:"+e.lineColor+";")}function u(t,e,n,r,o){var i=document.createElementNS(l,"rect");return i.setAttribute("x",t),i.setAttribute("y",e),i.setAttribute("width",n),i.setAttribute("height",r),o.appendChild(i),i}Object.defineProperty(e,"__esModule",{value:!0});var s=n(6),c=r(s),f=n(10),l="http://www.w3.org/2000/svg",p=function(){function t(e,n,r){o(this,t),this.svg=e,this.encodings=n,this.options=r}return t.prototype.render=function(){var t=this.options.marginLeft;this.prepareSVG();for(var e=0;e<this.encodings.length;e++){var n=this.encodings[e],r=(0,c.default)(this.options,n.options),o=i(t,r.marginTop,this.svg);a(o,r),this.drawSvgBarcode(o,r,n),this.drawSVGText(o,r,n),t+=n.width}},t.prototype.prepareSVG=function(){for(;this.svg.firstChild;)this.svg.removeChild(this.svg.firstChild);(0,f.calculateEncodingAttributes)(this.encodings,this.options);var t=(0,f.getTotalWidthOfEncodings)(this.encodings),e=(0,f.getMaximumHeightOfEncodings)(this.encodings),n=t+this.options.marginLeft+this.options.marginRight;this.setSvgAttributes(n,e),this.options.background&&u(0,0,n,e,this.svg).setAttribute("style","fill:"+this.options.background+";")},t.prototype.drawSvgBarcode=function(t,e,n){var r,o=n.data;r="top"==e.textPosition?e.fontSize+e.textMargin:0;for(var i=0,a=0,s=0;s<o.length;s++)a=s*e.width+n.barcodePadding,"1"===o[s]?i++:i>0&&(u(a-e.width*i,r,e.width*i,e.height,t),i=0);i>0&&u(a-e.width*(i-1),r,e.width*i,e.height,t)},t.prototype.drawSVGText=function(t,e,n){var r=document.createElementNS(l,"text");if(e.displayValue){var o,i;r.setAttribute("style","font:"+e.fontOptions+" "+e.fontSize+"px "+e.font),i="top"==e.textPosition?e.fontSize-e.textMargin:e.height+e.textMargin+e.fontSize,"left"==e.textAlign||n.barcodePadding>0?(o=0,r.setAttribute("text-anchor","start")):"right"==e.textAlign?(o=n.width-1,r.setAttribute("text-anchor","end")):(o=n.width/2,r.setAttribute("text-anchor","middle")),r.setAttribute("x",o),r.setAttribute("y",i),r.appendChild(document.createTextNode(n.text)),t.appendChild(r)}},t.prototype.setSvgAttributes=function(t,e){var n=this.svg;n.setAttribute("width",t+"px"),n.setAttribute("height",e+"px"),n.setAttribute("x","0px"),n.setAttribute("y","0px"),n.setAttribute("viewBox","0 0 "+t+" "+e),n.setAttribute("xmlns",l),n.setAttribute("version","1.1"),n.style.transform="translate(0,0)"},t}();e.default=p},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(11),i=r(o);e.default=function(){"ngInject";return{replace:!0,restrict:"E",require:"ngModel",scope:{bcType:"@",bcClass:"@?",bcOptions:"="},template:"",link:function(t,e,n,r){var o=function(){var e=t.bcClass||"barcode",n="";switch(t.bcType){case"svg":n='<svg class="'+e+'"></svg>';break;case"img":n='<img class="'+e+'">';break;case"canvas":n='<canvas class="'+e+'"></canvas>';break;default:n='<img class="'+e+'">'}return n},a={format:"CODE128",lineColor:"#000000",width:2,height:100,displayValue:!1,fontOptions:"",font:"monospace",textAlign:"center",textPosition:"bottom",textMargin:2,fontSize:20,background:"#ffffff",margin:10,marginTop:10,marginBottom:10,marginLeft:10,marginRight:10,valid:function(){return!0}},u=function(t){return Object.keys(a).forEach(function(e){t.hasOwnProperty(e)?t[e]=t[e]||a[e]:t[e]=a[e]}),t},s=function(t){var n=angular.element(o()),a=r.$viewValue||"",u=(0,i.default)(n[0],a,t);return angular.forEach(e.children(),function(t){return t.remove()}),e.append(n),u};s(u(t.hasOwnProperty("bcOptions")&&"undefined"!=typeof t.bcOptions?t.bcOptions:a)),t.$watch("bcOptions",function(t){s(t)},!0),r.$render=function(){s(t.bcOptions)}}}},t.exports=e.default}])});
//# sourceMappingURL=angular-barcode.js.map

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * angular-bootstrap-switch
 * @version v0.5.1 - 2016-06-04
 * @author Francesco Pontillo (francescopontillo@gmail.com)
 * @link https://github.com/frapontillo/angular-bootstrap-switch
 * @license Apache License 2.0(http://www.apache.org/licenses/LICENSE-2.0.html)
**/

(function() {
'use strict';

// Source: common/module.js
angular.module('frapontillo.bootstrap-switch', []);

// Source: dist/.temp/directives/bsSwitch.js
angular.module('frapontillo.bootstrap-switch')
  .directive('bsSwitch', ["$parse", "$timeout", function ($parse, $timeout) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function link(scope, element, attrs, controller) {
        var isInit = false;

        /**
         * Return the true value for this specific checkbox.
         * @returns {Object} representing the true view value; if undefined, returns true.
         */
        var getTrueValue = function() {
          if (attrs.type === 'radio') {
            return attrs.value || $parse(attrs.ngValue)(scope) || true;
          }
          var trueValue = ($parse(attrs.ngTrueValue)(scope));
          if (angular.isUndefined(trueValue)) {
            trueValue = true;
          }
          return trueValue;
        };

        /**
         * Get a boolean value from a boolean-like string, evaluating it on the current scope.
         * @param value The input object
         * @returns {boolean} A boolean value
         */
        var getBooleanFromString = function(value) {
          return scope.$eval(value) === true;
        };

        /**
         * Get a boolean value from a boolean-like string, defaulting to true if undefined.
         * @param value The input object
         * @returns {boolean} A boolean value
         */
        var getBooleanFromStringDefTrue = function(value) {
          return (value === true || value === 'true' || !value);
        };

        /**
         * Returns the value if it is truthy, or undefined.
         *
         * @param value The value to check.
         * @returns the original value if it is truthy, {@link undefined} otherwise.
         */
        var getValueOrUndefined = function (value) {
          return (value ? value : undefined);
        };

        /**
         * Returns a function that executes the provided expression
         *
         * @param value The string expression
         * @return a function that evaluates the expression
         */
        var getExprFromString = function (value) {
          if (angular.isUndefined(value)) {
            return angular.noop;
          }
          return function () {
            scope.$evalAsync(value);
          };
        };

        /**
         * Get the value of the angular-bound attribute, given its name.
         * The returned value may or may not equal the attribute value, as it may be transformed by a function.
         *
         * @param attrName  The angular-bound attribute name to get the value for
         * @returns {*}     The attribute value
         */
        var getSwitchAttrValue = function(attrName) {
          var map = {
            'switchRadioOff': getBooleanFromStringDefTrue,
            'switchActive': function(value) {
              return !getBooleanFromStringDefTrue(value);
            },
            'switchAnimate': getBooleanFromStringDefTrue,
            'switchLabel': function(value) {
              return value ? value : '&nbsp;';
            },
            'switchIcon': function(value) {
              if (value) {
                return '<span class=\'' + value + '\'></span>';
              }
            },
            'switchWrapper': function(value) {
              return value || 'wrapper';
            },
            'switchInverse': getBooleanFromString,
            'switchReadonly': getBooleanFromString,
            'switchChange': getExprFromString
          };
          var transFn = map[attrName] || getValueOrUndefined;
          return transFn(attrs[attrName]);
        };

        /**
         * Set a bootstrapSwitch parameter according to the angular-bound attribute.
         * The parameter will be changed only if the switch has already been initialized
         * (to avoid creating it before the model is ready).
         *
         * @param element   The switch to apply the parameter modification to
         * @param attr      The name of the switch parameter
         * @param modelAttr The name of the angular-bound parameter
         */
        var setSwitchParamMaybe = function(element, attr, modelAttr) {
          if (!isInit) {
            return;
          }
          var newValue = getSwitchAttrValue(modelAttr);
          element.bootstrapSwitch(attr, newValue);
        };

        var setActive = function() {
          setSwitchParamMaybe(element, 'disabled', 'switchActive');
        };

        /**
         * If the directive has not been initialized yet, do so.
         */
        var initMaybe = function() {
          // if it's the first initialization
          if (!isInit) {
            var viewValue = (controller.$modelValue === getTrueValue());
            isInit = !isInit;
            // Bootstrap the switch plugin
            element.bootstrapSwitch({
              radioAllOff: getSwitchAttrValue('switchRadioOff'),
              disabled: getSwitchAttrValue('switchActive'),
              state: viewValue,
              onText: getSwitchAttrValue('switchOnText'),
              offText: getSwitchAttrValue('switchOffText'),
              onColor: getSwitchAttrValue('switchOnColor'),
              offColor: getSwitchAttrValue('switchOffColor'),
              animate: getSwitchAttrValue('switchAnimate'),
              size: getSwitchAttrValue('switchSize'),
              labelText: attrs.switchLabel ? getSwitchAttrValue('switchLabel') : getSwitchAttrValue('switchIcon'),
              wrapperClass: getSwitchAttrValue('switchWrapper'),
              handleWidth: getSwitchAttrValue('switchHandleWidth'),
              labelWidth: getSwitchAttrValue('switchLabelWidth'),
              inverse: getSwitchAttrValue('switchInverse'),
              readonly: getSwitchAttrValue('switchReadonly')
            });
            if (attrs.type === 'radio') {
              controller.$setViewValue(controller.$modelValue);
            } else {
              controller.$setViewValue(viewValue);
            }
          }
        };

        var switchChange = getSwitchAttrValue('switchChange');

        /**
         * Listen to model changes.
         */
        var listenToModel = function () {

          attrs.$observe('switchActive', function (newValue) {

            var active = getBooleanFromStringDefTrue(newValue);
            // if we are disabling the switch, delay the deactivation so that the toggle can be switched
            if (!active) {
              $timeout(setActive);
            } else {
              // if we are enabling the switch, set active right away
              setActive();
            }
          });

          // When the model changes
          controller.$render = function () {
            initMaybe();
            var newValue = controller.$modelValue;
            if (newValue !== undefined && newValue !== null) {
              element.bootstrapSwitch('state', newValue === getTrueValue(), true);
            } else {
              element.bootstrapSwitch('indeterminate', true, true);
              controller.$setViewValue(undefined);
            }
            switchChange();
          };

          // angular attribute to switch property bindings
          var bindings = {
            'switchRadioOff': 'radioAllOff',
            'switchOnText': 'onText',
            'switchOffText': 'offText',
            'switchOnColor': 'onColor',
            'switchOffColor': 'offColor',
            'switchAnimate': 'animate',
            'switchSize': 'size',
            'switchLabel': 'labelText',
            'switchIcon': 'labelText',
            'switchWrapper': 'wrapperClass',
            'switchHandleWidth': 'handleWidth',
            'switchLabelWidth': 'labelWidth',
            'switchInverse': 'inverse',
            'switchReadonly': 'readonly'
          };

          var observeProp = function(prop, bindings) {
            return function() {
              attrs.$observe(prop, function () {
                setSwitchParamMaybe(element, bindings[prop], prop);
              });
            };
          };

          // for every angular-bound attribute, observe it and trigger the appropriate switch function
          for (var prop in bindings) {
            attrs.$observe(prop, observeProp(prop, bindings));
          }
        };

        /**
         * Listen to view changes.
         */
        var listenToView = function () {

          if (attrs.type === 'radio') {
            // when the switch is clicked
            element.on('change.bootstrapSwitch', function (e) {
              // discard not real change events
              if ((controller.$modelValue === controller.$viewValue) && (e.target.checked !== $(e.target).bootstrapSwitch('state'))) {
                // $setViewValue --> $viewValue --> $parsers --> $modelValue
                // if the switch is indeed selected
                if (e.target.checked) {
                  // set its value into the view
                  controller.$setViewValue(getTrueValue());
                } else if (getTrueValue() === controller.$viewValue) {
                  // otherwise if it's been deselected, delete the view value
                  controller.$setViewValue(undefined);
                }
                switchChange();
              }
            });
          } else {
            // When the checkbox switch is clicked, set its value into the ngModel
            element.on('switchChange.bootstrapSwitch', function (e) {
              // $setViewValue --> $viewValue --> $parsers --> $modelValue
              controller.$setViewValue(e.target.checked);
              switchChange();
            });
          }
        };

        // Listen and respond to view changes
        listenToView();

        // Listen and respond to model changes
        listenToModel();

        // On destroy, collect ya garbage
        scope.$on('$destroy', function () {
          element.bootstrapSwitch('destroy');
        });
      }
    };
  }])
  .directive('bsSwitch', function () {
    return {
      restrict: 'E',
      require: 'ngModel',
      template: '<input bs-switch>',
      replace: true
    };
  });

// Source: bsSwitch.suffix
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 568 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.6.1
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/**
 * @ngdoc module
 * @name ngCookies
 * @description
 *
 * # ngCookies
 *
 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
 *
 *
 * <div doc-module-components="ngCookies"></div>
 *
 * See {@link ngCookies.$cookies `$cookies`} for usage.
 */


angular.module('ngCookies', ['ng']).
  /**
   * @ngdoc provider
   * @name $cookiesProvider
   * @description
   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
   * */
   provider('$cookies', [/** @this */function $CookiesProvider() {
    /**
     * @ngdoc property
     * @name $cookiesProvider#defaults
     * @description
     *
     * Object containing default options to pass when setting cookies.
     *
     * The object may have following properties:
     *
     * - **path** - `{string}` - The cookie will be available only for this path and its
     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
     * - **domain** - `{string}` - The cookie will be available only for this domain and
     *   its sub-domains. For security reasons the user agent will not accept the cookie
     *   if the current domain is not a sub-domain of this domain or equal to it.
     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
     *   or a Date object indicating the exact date/time this cookie will expire.
     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
     *   secured connection.
     *
     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
     * This is important so that cookies will be visible for all routes when html5mode is enabled.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesProviderExample', ['ngCookies'])
     *   .config(['$cookiesProvider', function($cookiesProvider) {
     *     // Setting default options
     *     $cookiesProvider.defaults.domain = 'foo.com';
     *     $cookiesProvider.defaults.secure = true;
     *   }]);
     * ```
     **/
    var defaults = this.defaults = {};

    function calcOptions(options) {
      return options ? angular.extend({}, defaults, options) : defaults;
    }

    /**
     * @ngdoc service
     * @name $cookies
     *
     * @description
     * Provides read/write access to browser's cookies.
     *
     * <div class="alert alert-info">
     * Up until Angular 1.3, `$cookies` exposed properties that represented the
     * current browser cookie values. In version 1.4, this behavior has changed, and
     * `$cookies` now provides a standard api of getters, setters etc.
     * </div>
     *
     * Requires the {@link ngCookies `ngCookies`} module to be installed.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesExample', ['ngCookies'])
     *   .controller('ExampleController', ['$cookies', function($cookies) {
     *     // Retrieving a cookie
     *     var favoriteCookie = $cookies.get('myFavorite');
     *     // Setting a cookie
     *     $cookies.put('myFavorite', 'oatmeal');
     *   }]);
     * ```
     */
    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
      return {
        /**
         * @ngdoc method
         * @name $cookies#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {string} Raw cookie value.
         */
        get: function(key) {
          return $$cookieReader()[key];
        },

        /**
         * @ngdoc method
         * @name $cookies#getObject
         *
         * @description
         * Returns the deserialized value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */
        getObject: function(key) {
          var value = this.get(key);
          return value ? angular.fromJson(value) : value;
        },

        /**
         * @ngdoc method
         * @name $cookies#getAll
         *
         * @description
         * Returns a key value object with all the cookies
         *
         * @returns {Object} All cookies
         */
        getAll: function() {
          return $$cookieReader();
        },

        /**
         * @ngdoc method
         * @name $cookies#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {string} value Raw value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        put: function(key, value, options) {
          $$cookieWriter(key, value, calcOptions(options));
        },

        /**
         * @ngdoc method
         * @name $cookies#putObject
         *
         * @description
         * Serializes and sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        putObject: function(key, value, options) {
          this.put(key, angular.toJson(value), options);
        },

        /**
         * @ngdoc method
         * @name $cookies#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        remove: function(key, options) {
          $$cookieWriter(key, undefined, calcOptions(options));
        }
      };
    }];
  }]);

angular.module('ngCookies').
/**
 * @ngdoc service
 * @name $cookieStore
 * @deprecated
 * sinceVersion="v1.4.0"
 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
 *
 * @requires $cookies
 *
 * @description
 * Provides a key-value (string-object) storage, that is backed by session cookies.
 * Objects put or retrieved from this storage are automatically serialized or
 * deserialized by angular's toJson/fromJson.
 *
 * Requires the {@link ngCookies `ngCookies`} module to be installed.
 *
 * @example
 *
 * ```js
 * angular.module('cookieStoreExample', ['ngCookies'])
 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
 *     // Put cookie
 *     $cookieStore.put('myFavorite','oatmeal');
 *     // Get cookie
 *     var favoriteCookie = $cookieStore.get('myFavorite');
 *     // Removing a cookie
 *     $cookieStore.remove('myFavorite');
 *   }]);
 * ```
 */
 factory('$cookieStore', ['$cookies', function($cookies) {

    return {
      /**
       * @ngdoc method
       * @name $cookieStore#get
       *
       * @description
       * Returns the value of given cookie key
       *
       * @param {string} key Id to use for lookup.
       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
       */
      get: function(key) {
        return $cookies.getObject(key);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#put
       *
       * @description
       * Sets a value for given cookie key
       *
       * @param {string} key Id for the `value`.
       * @param {Object} value Value to be stored.
       */
      put: function(key, value) {
        $cookies.putObject(key, value);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#remove
       *
       * @description
       * Remove given cookie
       *
       * @param {string} key Id of the key-value pair to delete.
       */
      remove: function(key) {
        $cookies.remove(key);
      }
    };

  }]);

/**
 * @name $$cookieWriter
 * @requires $document
 *
 * @description
 * This is a private service for writing cookies
 *
 * @param {string} name Cookie name
 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
 * @param {Object=} options Object with options that need to be stored for the cookie.
 */
function $$CookieWriter($document, $log, $browser) {
  var cookiePath = $browser.baseHref();
  var rawDocument = $document[0];

  function buildCookieString(name, value, options) {
    var path, expires;
    options = options || {};
    expires = options.expires;
    path = angular.isDefined(options.path) ? options.path : cookiePath;
    if (angular.isUndefined(value)) {
      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
      value = '';
    }
    if (angular.isString(expires)) {
      expires = new Date(expires);
    }

    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    str += path ? ';path=' + path : '';
    str += options.domain ? ';domain=' + options.domain : '';
    str += expires ? ';expires=' + expires.toUTCString() : '';
    str += options.secure ? ';secure' : '';

    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
    // - 300 cookies
    // - 20 cookies per unique domain
    // - 4096 bytes per cookie
    var cookieLength = str.length + 1;
    if (cookieLength > 4096) {
      $log.warn('Cookie \'' + name +
        '\' possibly not set or overflowed because it was too large (' +
        cookieLength + ' > 4096 bytes)!');
    }

    return str;
  }

  return function(name, value, options) {
    rawDocument.cookie = buildCookieString(name, value, options);
  };
}

$$CookieWriter.$inject = ['$document', '$log', '$browser'];

angular.module('ngCookies').provider('$$cookieWriter', /** @this */ function $$CookieWriterProvider() {
  this.$get = $$CookieWriter;
});


})(window, window.angular);


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(568);
module.exports = 'ngCookies';


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(571);
module.exports = 'daterangepicker'


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, moment) {(function() {
  var picker;

  picker = angular.module('daterangepicker', []);

  picker.constant('dateRangePickerConfig', {
    clearLabel: 'Clear',
    locale: {
      separator: ' - ',
      format: 'YYYY-MM-DD'
    }
  });

  picker.directive('dateRangePicker', ['$compile', '$timeout', '$parse', 'dateRangePickerConfig', function($compile, $timeout, $parse, dateRangePickerConfig) {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: {
        min: '=',
        max: '=',
        model: '=ngModel',
        opts: '=options',
        clearable: '='
      },
      link: function($scope, element, attrs, modelCtrl) {
        var _clear, _init, _initBoundaryField, _mergeOpts, _picker, _setDatePoint, _setEndDate, _setStartDate, _validate, _validateMax, _validateMin, customOpts, el, opts;
        _mergeOpts = function() {
          var extend, localeExtend;
          localeExtend = angular.extend.apply(angular, Array.prototype.slice.call(arguments).map(function(opt) {
            return opt != null ? opt.locale : void 0;
          }).filter(function(opt) {
            return !!opt;
          }));
          extend = angular.extend.apply(angular, arguments);
          extend.locale = localeExtend;
          return extend;
        };
        el = $(element);
        customOpts = $scope.opts;
        opts = _mergeOpts({
          locale: {}
        }, dateRangePickerConfig, customOpts);
        _picker = null;
        _clear = function() {
          _picker.setStartDate();
          return _picker.setEndDate();
        };
        _setDatePoint = function(setter) {
          return function(newValue) {
            if (_picker && newValue) {
              return setter(moment(newValue));
            }
          };
        };
        _setStartDate = _setDatePoint(function(m) {
          if (_picker.endDate < m) {
            _picker.setEndDate(m);
          }
          opts.startDate = m;
          return _picker.setStartDate(m);
        });
        _setEndDate = _setDatePoint(function(m) {
          if (_picker.startDate > m) {
            _picker.setStartDate(m);
          }
          opts.endDate = m;
          return _picker.setEndDate(m);
        });
        _validate = function(validator) {
          return function(boundary, actual) {
            if (boundary && actual) {
              return validator(moment(boundary), moment(actual));
            } else {
              return true;
            }
          };
        };
        _validateMin = _validate(function(min, start) {
          return min.isBefore(start) || min.isSame(start, 'day');
        });
        _validateMax = _validate(function(max, end) {
          return max.isAfter(end) || max.isSame(end, 'day');
        });
        modelCtrl.$formatters.push(function(objValue) {
          var f;
          f = function(date) {
            if (!moment.isMoment(date)) {
              return moment(date).format(opts.locale.format);
            } else {
              return date.format(opts.locale.format);
            }
          };
          if (opts.singleDatePicker && objValue) {
            return f(objValue);
          } else if (objValue.startDate) {
            return [f(objValue.startDate), f(objValue.endDate)].join(opts.locale.separator);
          } else {
            return '';
          }
        });
        modelCtrl.$render = function() {
          if (modelCtrl.$modelValue && modelCtrl.$modelValue.startDate) {
            _setStartDate(modelCtrl.$modelValue.startDate);
            _setEndDate(modelCtrl.$modelValue.endDate);
          } else {
            _clear();
          }
          return el.val(modelCtrl.$viewValue);
        };
        modelCtrl.$parsers.push(function(val) {
          var f, objValue, x;
          f = function(value) {
            return moment(value, opts.locale.format);
          };
          objValue = {
            startDate: null,
            endDate: null
          };
          if (angular.isString(val) && val.length > 0) {
            if (opts.singleDatePicker) {
              objValue = f(val);
            } else {
              x = val.split(opts.locale.separator).map(f);
              objValue.startDate = x[0];
              objValue.endDate = x[1];
            }
          }
          return objValue;
        });
        modelCtrl.$isEmpty = function(val) {
          return !(angular.isString(val) && val.length > 0);
        };
        _init = function() {
          var eventType, results;
          el.daterangepicker(angular.extend(opts, {
            autoUpdateInput: false
          }), function(start, end) {
            return $scope.$apply(function() {
              return $scope.model = opts.singleDatePicker ? start : {
                startDate: start,
                endDate: end
              };
            });
          });
          _picker = el.data('daterangepicker');
          results = [];
          for (eventType in opts.eventHandlers) {
            results.push(el.on(eventType, function(e) {
              var eventName;
              eventName = e.type + '.' + e.namespace;
              return $scope.$evalAsync(opts.eventHandlers[eventName]);
            }));
          }
          return results;
        };
        _init();
        $scope.$watch('model.startDate', function(n) {
          return _setStartDate(n);
        });
        $scope.$watch('model.endDate', function(n) {
          return _setEndDate(n);
        });
        _initBoundaryField = function(field, validator, modelField, optName) {
          if (attrs[field]) {
            modelCtrl.$validators[field] = function(value) {
              return value && validator(opts[optName], value[modelField]);
            };
            return $scope.$watch(field, function(date) {
              opts[optName] = date ? moment(date) : false;
              return _init();
            });
          }
        };
        _initBoundaryField('min', _validateMin, 'startDate', 'minDate');
        _initBoundaryField('max', _validateMax, 'endDate', 'maxDate');
        if (attrs.options) {
          $scope.$watch('opts', function(newOpts) {
            opts = _mergeOpts(opts, newOpts);
            return _init();
          }, true);
        }
        if (attrs.clearable) {
          $scope.$watch('clearable', function(newClearable) {
            if (newClearable) {
              opts = _mergeOpts(opts, {
                locale: {
                  cancelLabel: opts.clearLabel
                }
              });
            }
            _init();
            if (newClearable) {
              return el.on('cancel.daterangepicker', function() {
                return $scope.$apply(function() {
                  return $scope.model = opts.singleDatePicker ? null : {
                    startDate: null,
                    endDate: null
                  };
                });
              });
            }
          });
        }
        return $scope.$on('$destroy', function() {
          return _picker != null ? _picker.remove() : void 0;
        });
      }
    };
  }]);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(4)))

/***/ }),
/* 572 */
/***/ (function(module, exports) {

/**
 * angular-drag-and-drop-lists v2.1.0
 *
 * Copyright (c) 2014 Marcel Juenemann marcel@juenemann.cc
 * Copyright (c) 2014-2017 Google Inc.
 * https://github.com/marceljuenemann/angular-drag-and-drop-lists
 *
 * License: MIT
 */
(function(dndLists) {

  // In standard-compliant browsers we use a custom mime type and also encode the dnd-type in it.
  // However, IE and Edge only support a limited number of mime types. The workarounds are described
  // in https://github.com/marceljuenemann/angular-drag-and-drop-lists/wiki/Data-Transfer-Design
  var MIME_TYPE = 'application/x-dnd';
  var EDGE_MIME_TYPE = 'application/json';
  var MSIE_MIME_TYPE = 'Text';

  // All valid HTML5 drop effects, in the order in which we prefer to use them.
  var ALL_EFFECTS = ['move', 'copy', 'link'];

  /**
   * Use the dnd-draggable attribute to make your element draggable
   *
   * Attributes:
   * - dnd-draggable      Required attribute. The value has to be an object that represents the data
   *                      of the element. In case of a drag and drop operation the object will be
   *                      serialized and unserialized on the receiving end.
   * - dnd-effect-allowed Use this attribute to limit the operations that can be performed. Valid
   *                      options are "move", "copy" and "link", as well as "all", "copyMove",
   *                      "copyLink" and "linkMove". The semantics of these operations are up to you
   *                      and have to be implemented using the callbacks described below. If you
   *                      allow multiple options, the user can choose between them by using the
   *                      modifier keys (OS specific). The cursor will be changed accordingly,
   *                      expect for IE and Edge, where this is not supported.
   * - dnd-type           Use this attribute if you have different kinds of items in your
   *                      application and you want to limit which items can be dropped into which
   *                      lists. Combine with dnd-allowed-types on the dnd-list(s). This attribute
   *                      must be a lower case string. Upper case characters can be used, but will
   *                      be converted to lower case automatically.
   * - dnd-disable-if     You can use this attribute to dynamically disable the draggability of the
   *                      element. This is useful if you have certain list items that you don't want
   *                      to be draggable, or if you want to disable drag & drop completely without
   *                      having two different code branches (e.g. only allow for admins).
   *
   * Callbacks:
   * - dnd-dragstart      Callback that is invoked when the element was dragged. The original
   *                      dragstart event will be provided in the local event variable.
   * - dnd-moved          Callback that is invoked when the element was moved. Usually you will
   *                      remove your element from the original list in this callback, since the
   *                      directive is not doing that for you automatically. The original dragend
   *                      event will be provided in the local event variable.
   * - dnd-copied         Same as dnd-moved, just that it is called when the element was copied
   *                      instead of moved, so you probably want to implement a different logic.
   * - dnd-linked         Same as dnd-moved, just that it is called when the element was linked
   *                      instead of moved, so you probably want to implement a different logic.
   * - dnd-canceled       Callback that is invoked if the element was dragged, but the operation was
   *                      canceled and the element was not dropped. The original dragend event will
   *                      be provided in the local event variable.
   * - dnd-dragend        Callback that is invoked when the drag operation ended. Available local
   *                      variables are event and dropEffect.
   * - dnd-selected       Callback that is invoked when the element was clicked but not dragged.
   *                      The original click event will be provided in the local event variable.
   * - dnd-callback       Custom callback that is passed to dropzone callbacks and can be used to
   *                      communicate between source and target scopes. The dropzone can pass user
   *                      defined variables to this callback.
   *
   * CSS classes:
   * - dndDragging        This class will be added to the element while the element is being
   *                      dragged. It will affect both the element you see while dragging and the
   *                      source element that stays at it's position. Do not try to hide the source
   *                      element with this class, because that will abort the drag operation.
   * - dndDraggingSource  This class will be added to the element after the drag operation was
   *                      started, meaning it only affects the original element that is still at
   *                      it's source position, and not the "element" that the user is dragging with
   *                      his mouse pointer.
   */
  dndLists.directive('dndDraggable', ['$parse', '$timeout', function($parse, $timeout) {
    return function(scope, element, attr) {
      // Set the HTML5 draggable attribute on the element.
      element.attr("draggable", "true");

      // If the dnd-disable-if attribute is set, we have to watch that.
      if (attr.dndDisableIf) {
        scope.$watch(attr.dndDisableIf, function(disabled) {
          element.attr("draggable", !disabled);
        });
      }

      /**
       * When the drag operation is started we have to prepare the dataTransfer object,
       * which is the primary way we communicate with the target element
       */
      element.on('dragstart', function(event) {
        event = event.originalEvent || event;

        // Check whether the element is draggable, since dragstart might be triggered on a child.
        if (element.attr('draggable') == 'false') return true;

        // Initialize global state.
        dndState.isDragging = true;
        dndState.itemType = attr.dndType && scope.$eval(attr.dndType).toLowerCase();

        // Set the allowed drop effects. See below for special IE handling.
        dndState.dropEffect = "none";
        dndState.effectAllowed = attr.dndEffectAllowed || ALL_EFFECTS[0];
        event.dataTransfer.effectAllowed = dndState.effectAllowed;

        // Internet Explorer and Microsoft Edge don't support custom mime types, see design doc:
        // https://github.com/marceljuenemann/angular-drag-and-drop-lists/wiki/Data-Transfer-Design
        var item = scope.$eval(attr.dndDraggable);
        var mimeType = MIME_TYPE + (dndState.itemType ? ('-' + dndState.itemType) : '');
        try {
          event.dataTransfer.setData(mimeType, angular.toJson(item));
        } catch (e) {
          // Setting a custom MIME type did not work, we are probably in IE or Edge.
          var data = angular.toJson({item: item, type: dndState.itemType});
          try {
            event.dataTransfer.setData(EDGE_MIME_TYPE, data);
          } catch (e) {
            // We are in Internet Explorer and can only use the Text MIME type. Also note that IE
            // does not allow changing the cursor in the dragover event, therefore we have to choose
            // the one we want to display now by setting effectAllowed.
            var effectsAllowed = filterEffects(ALL_EFFECTS, dndState.effectAllowed);
            event.dataTransfer.effectAllowed = effectsAllowed[0];
            event.dataTransfer.setData(MSIE_MIME_TYPE, data);
          }
        }

        // Add CSS classes. See documentation above.
        element.addClass("dndDragging");
        $timeout(function() { element.addClass("dndDraggingSource"); }, 0);

        // Try setting a proper drag image if triggered on a dnd-handle (won't work in IE).
        if (event._dndHandle && event.dataTransfer.setDragImage) {
          event.dataTransfer.setDragImage(element[0], 0, 0);
        }

        // Invoke dragstart callback and prepare extra callback for dropzone.
        $parse(attr.dndDragstart)(scope, {event: event});
        if (attr.dndCallback) {
          var callback = $parse(attr.dndCallback);
          dndState.callback = function(params) { return callback(scope, params || {}); };
        }

        event.stopPropagation();
      });

      /**
       * The dragend event is triggered when the element was dropped or when the drag
       * operation was aborted (e.g. hit escape button). Depending on the executed action
       * we will invoke the callbacks specified with the dnd-moved or dnd-copied attribute.
       */
      element.on('dragend', function(event) {
        event = event.originalEvent || event;

        // Invoke callbacks. Usually we would use event.dataTransfer.dropEffect to determine
        // the used effect, but Chrome has not implemented that field correctly. On Windows
        // it always sets it to 'none', while Chrome on Linux sometimes sets it to something
        // else when it's supposed to send 'none' (drag operation aborted).
        scope.$apply(function() {
          var dropEffect = dndState.dropEffect;
          var cb = {copy: 'dndCopied', link: 'dndLinked', move: 'dndMoved', none: 'dndCanceled'};
          $parse(attr[cb[dropEffect]])(scope, {event: event});
          $parse(attr.dndDragend)(scope, {event: event, dropEffect: dropEffect});
        });

        // Clean up
        dndState.isDragging = false;
        dndState.callback = undefined;
        element.removeClass("dndDragging");
        element.removeClass("dndDraggingSource");
        event.stopPropagation();

        // In IE9 it is possible that the timeout from dragstart triggers after the dragend handler.
        $timeout(function() { element.removeClass("dndDraggingSource"); }, 0);
      });

      /**
       * When the element is clicked we invoke the callback function
       * specified with the dnd-selected attribute.
       */
      element.on('click', function(event) {
        if (!attr.dndSelected) return;

        event = event.originalEvent || event;
        scope.$apply(function() {
          $parse(attr.dndSelected)(scope, {event: event});
        });

        // Prevent triggering dndSelected in parent elements.
        event.stopPropagation();
      });

      /**
       * Workaround to make element draggable in IE9
       */
      element.on('selectstart', function() {
        if (this.dragDrop) this.dragDrop();
      });
    };
  }]);

  /**
   * Use the dnd-list attribute to make your list element a dropzone. Usually you will add a single
   * li element as child with the ng-repeat directive. If you don't do that, we will not be able to
   * position the dropped element correctly. If you want your list to be sortable, also add the
   * dnd-draggable directive to your li element(s).
   *
   * Attributes:
   * - dnd-list             Required attribute. The value has to be the array in which the data of
   *                        the dropped element should be inserted. The value can be blank if used
   *                        with a custom dnd-drop handler that always returns true.
   * - dnd-allowed-types    Optional array of allowed item types. When used, only items that had a
   *                        matching dnd-type attribute will be dropable. Upper case characters will
   *                        automatically be converted to lower case.
   * - dnd-effect-allowed   Optional string expression that limits the drop effects that can be
   *                        performed in the list. See dnd-effect-allowed on dnd-draggable for more
   *                        details on allowed options. The default value is all.
   * - dnd-disable-if       Optional boolean expresssion. When it evaluates to true, no dropping
   *                        into the list is possible. Note that this also disables rearranging
   *                        items inside the list.
   * - dnd-horizontal-list  Optional boolean expresssion. When it evaluates to true, the positioning
   *                        algorithm will use the left and right halfs of the list items instead of
   *                        the upper and lower halfs.
   * - dnd-external-sources Optional boolean expression. When it evaluates to true, the list accepts
   *                        drops from sources outside of the current browser tab. This allows to
   *                        drag and drop accross different browser tabs. The only major browser
   *                        that does not support this is currently Microsoft Edge.
   *
   * Callbacks:
   * - dnd-dragover         Optional expression that is invoked when an element is dragged over the
   *                        list. If the expression is set, but does not return true, the element is
   *                        not allowed to be dropped. The following variables will be available:
   *                        - event: The original dragover event sent by the browser.
   *                        - index: The position in the list at which the element would be dropped.
   *                        - type: The dnd-type set on the dnd-draggable, or undefined if non was
   *                          set. Will be null for drops from external sources in IE and Edge,
   *                          since we don't know the type in those cases.
   *                        - dropEffect: One of move, copy or link, see dnd-effect-allowed.
   *                        - external: Whether the element was dragged from an external source.
   *                        - callback: If dnd-callback was set on the source element, this is a
   *                          function reference to the callback. The callback can be invoked with
   *                          custom variables like this: callback({var1: value1, var2: value2}).
   *                          The callback will be executed on the scope of the source element. If
   *                          dnd-external-sources was set and external is true, this callback will
   *                          not be available.
   * - dnd-drop             Optional expression that is invoked when an element is dropped on the
   *                        list. The same variables as for dnd-dragover will be available, with the
   *                        exception that type is always known and therefore never null. There
   *                        will also be an item variable, which is the transferred object. The
   *                        return value determines the further handling of the drop:
   *                        - falsy: The drop will be canceled and the element won't be inserted.
   *                        - true: Signalises that the drop is allowed, but the dnd-drop
   *                          callback already took care of inserting the element.
   *                        - otherwise: All other return values will be treated as the object to
   *                          insert into the array. In most cases you want to simply return the
   *                          item parameter, but there are no restrictions on what you can return.
   * - dnd-inserted         Optional expression that is invoked after a drop if the element was
   *                        actually inserted into the list. The same local variables as for
   *                        dnd-drop will be available. Note that for reorderings inside the same
   *                        list the old element will still be in the list due to the fact that
   *                        dnd-moved was not called yet.
   *
   * CSS classes:
   * - dndPlaceholder       When an element is dragged over the list, a new placeholder child
   *                        element will be added. This element is of type li and has the class
   *                        dndPlaceholder set. Alternatively, you can define your own placeholder
   *                        by creating a child element with dndPlaceholder class.
   * - dndDragover          Will be added to the list while an element is dragged over the list.
   */
  dndLists.directive('dndList', ['$parse', function($parse) {
    return function(scope, element, attr) {
      // While an element is dragged over the list, this placeholder element is inserted
      // at the location where the element would be inserted after dropping.
      var placeholder = getPlaceholderElement();
      placeholder.remove();

      var placeholderNode = placeholder[0];
      var listNode = element[0];
      var listSettings = {};

      /**
       * The dragenter event is fired when a dragged element or text selection enters a valid drop
       * target. According to the spec, we either need to have a dropzone attribute or listen on
       * dragenter events and call preventDefault(). It should be noted though that no browser seems
       * to enforce this behaviour.
       */
      element.on('dragenter', function (event) {
        event = event.originalEvent || event;

        // Calculate list properties, so that we don't have to repeat this on every dragover event.
        var types = attr.dndAllowedTypes && scope.$eval(attr.dndAllowedTypes);
        listSettings = {
          allowedTypes: angular.isArray(types) && types.join('|').toLowerCase().split('|'),
          disabled: attr.dndDisableIf && scope.$eval(attr.dndDisableIf),
          externalSources: attr.dndExternalSources && scope.$eval(attr.dndExternalSources),
          horizontal: attr.dndHorizontalList && scope.$eval(attr.dndHorizontalList)
        };

        var mimeType = getMimeType(event.dataTransfer.types);
        if (!mimeType || !isDropAllowed(getItemType(mimeType))) return true;
        event.preventDefault();
      });

      /**
       * The dragover event is triggered "every few hundred milliseconds" while an element
       * is being dragged over our list, or over an child element.
       */
      element.on('dragover', function(event) {
        event = event.originalEvent || event;

        // Check whether the drop is allowed and determine mime type.
        var mimeType = getMimeType(event.dataTransfer.types);
        var itemType = getItemType(mimeType);
        if (!mimeType || !isDropAllowed(itemType)) return true;

        // Make sure the placeholder is shown, which is especially important if the list is empty.
        if (placeholderNode.parentNode != listNode) {
          element.append(placeholder);
        }

        if (event.target != listNode) {
          // Try to find the node direct directly below the list node.
          var listItemNode = event.target;
          while (listItemNode.parentNode != listNode && listItemNode.parentNode) {
            listItemNode = listItemNode.parentNode;
          }

          if (listItemNode.parentNode == listNode && listItemNode != placeholderNode) {
            // If the mouse pointer is in the upper half of the list item element,
            // we position the placeholder before the list item, otherwise after it.
            var rect = listItemNode.getBoundingClientRect();
            if (listSettings.horizontal) {
              var isFirstHalf = event.clientX < rect.left + rect.width / 2;
            } else {
              var isFirstHalf = event.clientY < rect.top + rect.height / 2;
            }
            listNode.insertBefore(placeholderNode,
                isFirstHalf ? listItemNode : listItemNode.nextSibling);
          }
        }

        // In IE we set a fake effectAllowed in dragstart to get the correct cursor, we therefore
        // ignore the effectAllowed passed in dataTransfer. We must also not access dataTransfer for
        // drops from external sources, as that throws an exception.
        var ignoreDataTransfer = mimeType == MSIE_MIME_TYPE;
        var dropEffect = getDropEffect(event, ignoreDataTransfer);
        if (dropEffect == 'none') return stopDragover();

        // At this point we invoke the callback, which still can disallow the drop.
        // We can't do this earlier because we want to pass the index of the placeholder.
        if (attr.dndDragover && !invokeCallback(attr.dndDragover, event, dropEffect, itemType)) {
          return stopDragover();
        }

        // Set dropEffect to modify the cursor shown by the browser, unless we're in IE, where this
        // is not supported. This must be done after preventDefault in Firefox.
        event.preventDefault();
        if (!ignoreDataTransfer) {
          event.dataTransfer.dropEffect = dropEffect;
        }

        element.addClass("dndDragover");
        event.stopPropagation();
        return false;
      });

      /**
       * When the element is dropped, we use the position of the placeholder element as the
       * position where we insert the transferred data. This assumes that the list has exactly
       * one child element per array element.
       */
      element.on('drop', function(event) {
        event = event.originalEvent || event;

        // Check whether the drop is allowed and determine mime type.
        var mimeType = getMimeType(event.dataTransfer.types);
        var itemType = getItemType(mimeType);
        if (!mimeType || !isDropAllowed(itemType)) return true;

        // The default behavior in Firefox is to interpret the dropped element as URL and
        // forward to it. We want to prevent that even if our drop is aborted.
        event.preventDefault();

        // Unserialize the data that was serialized in dragstart.
        try {
          var data = JSON.parse(event.dataTransfer.getData(mimeType));
        } catch(e) {
          return stopDragover();
        }

        // Drops with invalid types from external sources might not have been filtered out yet.
        if (mimeType == MSIE_MIME_TYPE || mimeType == EDGE_MIME_TYPE) {
          itemType = data.type || undefined;
          data = data.item;
          if (!isDropAllowed(itemType)) return stopDragover();
        }

        // Special handling for internal IE drops, see dragover handler.
        var ignoreDataTransfer = mimeType == MSIE_MIME_TYPE;
        var dropEffect = getDropEffect(event, ignoreDataTransfer);
        if (dropEffect == 'none') return stopDragover();

        // Invoke the callback, which can transform the transferredObject and even abort the drop.
        var index = getPlaceholderIndex();
        if (attr.dndDrop) {
          data = invokeCallback(attr.dndDrop, event, dropEffect, itemType, index, data);
          if (!data) return stopDragover();
        }

        // The drop is definitely going to happen now, store the dropEffect.
        dndState.dropEffect = dropEffect;
        if (!ignoreDataTransfer) {
          event.dataTransfer.dropEffect = dropEffect;
        }

        // Insert the object into the array, unless dnd-drop took care of that (returned true).
        if (data !== true) {
          scope.$apply(function() {
            scope.$eval(attr.dndList).splice(index, 0, data);
          });
        }
        invokeCallback(attr.dndInserted, event, dropEffect, itemType, index, data);

        // Clean up
        stopDragover();
        event.stopPropagation();
        return false;
      });

      /**
       * We have to remove the placeholder when the element is no longer dragged over our list. The
       * problem is that the dragleave event is not only fired when the element leaves our list,
       * but also when it leaves a child element. Therefore, we determine whether the mouse cursor
       * is still pointing to an element inside the list or not.
       */
      element.on('dragleave', function(event) {
        event = event.originalEvent || event;

        var newTarget = document.elementFromPoint(event.clientX, event.clientY);
        if (listNode.contains(newTarget) && !event._dndPhShown) {
          // Signalize to potential parent lists that a placeholder is already shown.
          event._dndPhShown = true;
        } else {
          stopDragover();
        }
      });

      /**
       * Given the types array from the DataTransfer object, returns the first valid mime type.
       * A type is valid if it starts with MIME_TYPE, or it equals MSIE_MIME_TYPE or EDGE_MIME_TYPE.
       */
      function getMimeType(types) {
        if (!types) return MSIE_MIME_TYPE; // IE 9 workaround.
        for (var i = 0; i < types.length; i++) {
          if (types[i] == MSIE_MIME_TYPE || types[i] == EDGE_MIME_TYPE ||
              types[i].substr(0, MIME_TYPE.length) == MIME_TYPE) {
            return types[i];
          }
        }
        return null;
      }

      /**
       * Determines the type of the item from the dndState, or from the mime type for items from
       * external sources. Returns undefined if no item type was set and null if the item type could
       * not be determined.
       */
      function getItemType(mimeType) {
        if (dndState.isDragging) return dndState.itemType || undefined;
        if (mimeType == MSIE_MIME_TYPE || mimeType == EDGE_MIME_TYPE) return null;
        return (mimeType && mimeType.substr(MIME_TYPE.length + 1)) || undefined;
      }

      /**
       * Checks various conditions that must be fulfilled for a drop to be allowed, including the
       * dnd-allowed-types attribute. If the item Type is unknown (null), the drop will be allowed.
       */
      function isDropAllowed(itemType) {
        if (listSettings.disabled) return false;
        if (!listSettings.externalSources && !dndState.isDragging) return false;
        if (!listSettings.allowedTypes || itemType === null) return true;
        return itemType && listSettings.allowedTypes.indexOf(itemType) != -1;
      }

      /**
       * Determines which drop effect to use for the given event. In Internet Explorer we have to
       * ignore the effectAllowed field on dataTransfer, since we set a fake value in dragstart.
       * In those cases we rely on dndState to filter effects. Read the design doc for more details:
       * https://github.com/marceljuenemann/angular-drag-and-drop-lists/wiki/Data-Transfer-Design
       */
      function getDropEffect(event, ignoreDataTransfer) {
        var effects = ALL_EFFECTS;
        if (!ignoreDataTransfer) {
          effects = filterEffects(effects, event.dataTransfer.effectAllowed);
        }
        if (dndState.isDragging) {
          effects = filterEffects(effects, dndState.effectAllowed);
        }
        if (attr.dndEffectAllowed) {
          effects = filterEffects(effects, attr.dndEffectAllowed);
        }
        // MacOS automatically filters dataTransfer.effectAllowed depending on the modifier keys,
        // therefore the following modifier keys will only affect other operating systems.
        if (!effects.length) {
          return 'none';
        } else if (event.ctrlKey && effects.indexOf('copy') != -1) {
          return 'copy';
        } else if (event.altKey && effects.indexOf('link') != -1) {
          return 'link';
        } else {
          return effects[0];
        }
      }

      /**
       * Small helper function that cleans up if we aborted a drop.
       */
      function stopDragover() {
        placeholder.remove();
        element.removeClass("dndDragover");
        return true;
      }

      /**
       * Invokes a callback with some interesting parameters and returns the callbacks return value.
       */
      function invokeCallback(expression, event, dropEffect, itemType, index, item) {
        return $parse(expression)(scope, {
          callback: dndState.callback,
          dropEffect: dropEffect,
          event: event,
          external: !dndState.isDragging,
          index: index !== undefined ? index : getPlaceholderIndex(),
          item: item || undefined,
          type: itemType
        });
      }

      /**
       * We use the position of the placeholder node to determine at which position of the array the
       * object needs to be inserted
       */
      function getPlaceholderIndex() {
        return Array.prototype.indexOf.call(listNode.children, placeholderNode);
      }

      /**
       * Tries to find a child element that has the dndPlaceholder class set. If none was found, a
       * new li element is created.
       */
      function getPlaceholderElement() {
        var placeholder;
        angular.forEach(element.children(), function(childNode) {
          var child = angular.element(childNode);
          if (child.hasClass('dndPlaceholder')) {
            placeholder = child;
          }
        });
        return placeholder || angular.element("<li class='dndPlaceholder'></li>");
      }
    };
  }]);

  /**
   * Use the dnd-nodrag attribute inside of dnd-draggable elements to prevent them from starting
   * drag operations. This is especially useful if you want to use input elements inside of
   * dnd-draggable elements or create specific handle elements. Note: This directive does not work
   * in Internet Explorer 9.
   */
  dndLists.directive('dndNodrag', function() {
    return function(scope, element, attr) {
      // Set as draggable so that we can cancel the events explicitly
      element.attr("draggable", "true");

      /**
       * Since the element is draggable, the browser's default operation is to drag it on dragstart.
       * We will prevent that and also stop the event from bubbling up.
       */
      element.on('dragstart', function(event) {
        event = event.originalEvent || event;

        if (!event._dndHandle) {
          // If a child element already reacted to dragstart and set a dataTransfer object, we will
          // allow that. For example, this is the case for user selections inside of input elements.
          if (!(event.dataTransfer.types && event.dataTransfer.types.length)) {
            event.preventDefault();
          }
          event.stopPropagation();
        }
      });

      /**
       * Stop propagation of dragend events, otherwise dnd-moved might be triggered and the element
       * would be removed.
       */
      element.on('dragend', function(event) {
        event = event.originalEvent || event;
        if (!event._dndHandle) {
          event.stopPropagation();
        }
      });
    };
  });

  /**
   * Use the dnd-handle directive within a dnd-nodrag element in order to allow dragging with that
   * element after all. Therefore, by combining dnd-nodrag and dnd-handle you can allow
   * dnd-draggable elements to only be dragged via specific "handle" elements. Note that Internet
   * Explorer will show the handle element as drag image instead of the dnd-draggable element. You
   * can work around this by styling the handle element differently when it is being dragged. Use
   * the CSS selector .dndDragging:not(.dndDraggingSource) [dnd-handle] for that.
   */
  dndLists.directive('dndHandle', function() {
    return function(scope, element, attr) {
      element.attr("draggable", "true");

      element.on('dragstart dragend', function(event) {
        event = event.originalEvent || event;
        event._dndHandle = true;
      });
    };
  });

  /**
   * Filters an array of drop effects using a HTML5 effectAllowed string.
   */
  function filterEffects(effects, effectAllowed) {
    if (effectAllowed == 'all') return effects;
    return effects.filter(function(effect) {
      return effectAllowed.toLowerCase().indexOf(effect) != -1;
    });
  }

  /**
   * For some features we need to maintain global state. This is done here, with these fields:
   * - callback: A callback function set at dragstart that is passed to internal dropzone handlers.
   * - dropEffect: Set in dragstart to "none" and to the actual value in the drop handler. We don't
   *   rely on the dropEffect passed by the browser, since there are various bugs in Chrome and
   *   Safari, and Internet Explorer defaults to copy if effectAllowed is copyMove.
   * - effectAllowed: Set in dragstart based on dnd-effect-allowed. This is needed for IE because
   *   setting effectAllowed on dataTransfer might result in an undesired cursor.
   * - isDragging: True between dragstart and dragend. Falsy for drops from external sources.
   * - itemType: The item type of the dragged element set via dnd-type. This is needed because IE
   *   and Edge don't support custom mime types that we can use to transfer this information.
   */
  var dndState = {};

})(angular.module('dndLists', []));


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moduleName = __webpack_require__(574);

module.exports = moduleName;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = angular.module('ui.utils.masks', [
	__webpack_require__(589),
	__webpack_require__(576),
	__webpack_require__(596),
	__webpack_require__(585)
]).name;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var maskFactory = __webpack_require__(60);

var boletoBancarioMask = new StringMask('00000.00000 00000.000000 00000.000000 0 00000000000000');

module.exports = maskFactory({
	clearValue: function(rawValue) {
		return rawValue.replace(/[^0-9]/g, '').slice(0, 47);
	},
	format: function(cleanValue) {
		if (cleanValue.length === 0) {
			return cleanValue;
		}

		return boletoBancarioMask.apply(cleanValue).replace(/[^0-9]$/, '');
	},
	validations: {
		brBoletoBancario: function(value) {
			return value.length === 47;
		}
	}
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var m = angular.module('ui.utils.masks.br', [
	__webpack_require__(151),
])
.directive('uiBrBoletoBancarioMask', __webpack_require__(575))
.directive('uiBrCepMask', __webpack_require__(578))
.directive('uiBrCnpjMask', __webpack_require__(579))
.directive('uiBrCpfMask', __webpack_require__(581))
.directive('uiBrCpfcnpjMask', __webpack_require__(580))
.directive('uiBrIeMask', __webpack_require__(582))
.directive('uiNfeAccessKeyMask', __webpack_require__(583))
.directive('uiBrCarPlateMask', __webpack_require__(577))
.directive('uiBrPhoneNumber', __webpack_require__(584));

module.exports = m.name;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var maskFactory = __webpack_require__(60);

var carPlateMask = new StringMask('UUU-0000');

module.exports = maskFactory({
	clearValue: function(rawValue) {
		return rawValue.replace(/[^a-zA-Z0-9]/g, '').slice(0, 7);
	},
	format: function(cleanValue) {
		return (carPlateMask.apply(cleanValue) || '').replace(/[^a-zA-Z0-9]$/, '');
	},
	validations: {
		carPlate: function(value) {
			return value.length === 7;
		}
	}
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var maskFactory = __webpack_require__(60);

var cepMask = new StringMask('00000-000');

module.exports = maskFactory({
	clearValue: function(rawValue) {
		return rawValue.toString().replace(/[^0-9]/g, '').slice(0, 8);
	},
	format: function(cleanValue) {
		return (cepMask.apply(cleanValue) || '').replace(/[^0-9]$/, '');
	},
	validations: {
		cep: function(value) {
			return value.length === 8;
		}
	}
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var BrV = __webpack_require__(152);
var maskFactory = __webpack_require__(60);

var cnpjPattern = new StringMask('00.000.000\/0000-00');

module.exports = maskFactory({
	clearValue: function(rawValue) {
		return rawValue.replace(/[^\d]/g, '').slice(0, 14);
	},
	format: function(cleanValue) {
		return (cnpjPattern.apply(cleanValue) || '').trim().replace(/[^0-9]$/, '');
	},
	validations: {
		cnpj: function(value) {
			return BrV.cnpj.validate(value);
		}
	}
});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var BrV = __webpack_require__(152);
var maskFactory = __webpack_require__(60);

var cnpjPattern = new StringMask('00.000.000\/0000-00');
var cpfPattern = new StringMask('000.000.000-00');

module.exports = maskFactory({
	clearValue: function(rawValue) {
		return rawValue.replace(/[^\d]/g, '').slice(0, 14);
	},
	format: function(cleanValue) {
		var formatedValue;

		if (cleanValue.length > 11) {
			formatedValue = cnpjPattern.apply(cleanValue);
		} else {
			formatedValue = cpfPattern.apply(cleanValue) || '';
		}

		return formatedValue.trim().replace(/[^0-9]$/, '');
	},
	validations: {
		cpf: function(value) {
			return value.length > 11 || BrV.cpf.validate(value);
		},
		cnpj: function(value) {
			return value.length <= 11 || BrV.cnpj.validate(value);
		}
	}
});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var BrV = __webpack_require__(152);
var maskFactory = __webpack_require__(60);

var cpfPattern = new StringMask('000.000.000-00');

module.exports = maskFactory({
	clearValue: function(rawValue) {
		return rawValue.replace(/[^\d]/g, '').slice(0, 11);
	},
	format: function(cleanValue) {
		return (cpfPattern.apply(cleanValue) || '').trim().replace(/[^0-9]$/, '');
	},
	validations: {
		cpf: function(value) {
			return BrV.cpf.validate(value);
		}
	}
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var BrV = __webpack_require__(152);

function BrIeMaskDirective($parse) {
	var ieMasks = {
		'AC': [{mask: new StringMask('00.000.000/000-00')}],
		'AL': [{mask: new StringMask('000000000')}],
		'AM': [{mask: new StringMask('00.000.000-0')}],
		'AP': [{mask: new StringMask('000000000')}],
		'BA': [{chars: 8, mask: new StringMask('000000-00')},
			{mask: new StringMask('0000000-00')}],
		'CE': [{mask: new StringMask('00000000-0')}],
		'DF': [{mask: new StringMask('00000000000-00')}],
		'ES': [{mask: new StringMask('00000000-0')}],
		'GO': [{mask: new StringMask('00.000.000-0')}],
		'MA': [{mask: new StringMask('000000000')}],
		'MG': [{mask: new StringMask('000.000.000/0000')}],
		'MS': [{mask: new StringMask('000000000')}],
		'MT': [{mask: new StringMask('0000000000-0')}],
		'PA': [{mask: new StringMask('00-000000-0')}],
		'PB': [{mask: new StringMask('00000000-0')}],
		'PE': [{chars: 9, mask: new StringMask('0000000-00')},
			{mask: new StringMask('00.0.000.0000000-0')}],
		'PI': [{mask: new StringMask('000000000')}],
		'PR': [{mask: new StringMask('000.00000-00')}],
		'RJ': [{mask: new StringMask('00.000.00-0')}],
		'RN': [{chars: 9, mask: new StringMask('00.000.000-0')},
			{mask: new StringMask('00.0.000.000-0')}],
		'RO': [{mask: new StringMask('0000000000000-0')}],
		'RR': [{mask: new StringMask('00000000-0')}],
		'RS': [{mask: new StringMask('000/0000000')}],
		'SC': [{mask: new StringMask('000.000.000')}],
		'SE': [{mask: new StringMask('00000000-0')}],
		'SP': [{mask: new StringMask('000.000.000.000')},
			{mask: new StringMask('-00000000.0/000')}],
		'TO': [{mask: new StringMask('00000000000')}]
	};

	function clearValue(value) {
		if (!value) {
			return value;
		}

		return value.replace(/[^0-9]/g, '');
	}

	function getMask(uf, value) {
		if (!uf || !ieMasks[uf]) {
			return;
		}

		if (uf === 'SP' && /^P/i.test(value)) {
			return ieMasks.SP[1].mask;
		}

		var masks = ieMasks[uf];
		var i = 0;
		while (masks[i].chars && masks[i].chars < clearValue(value).length && i < masks.length - 1) {
			i++;
		}

		return masks[i].mask;
	}

	function applyIEMask(value, uf) {
		var mask = getMask(uf, value);

		if (!mask) {
			return value;
		}

		var processed = mask.process(clearValue(value));
		var formatedValue = processed.result || '';
		formatedValue = formatedValue.trim().replace(/[^0-9]$/, '');

		if (uf === 'SP' && /^p/i.test(value)) {
			return 'P' + formatedValue;
		}

		return formatedValue;
	}

	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ctrl) {
			var state = ($parse(attrs.uiBrIeMask)(scope) || '').toUpperCase();

			function formatter(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}

				return applyIEMask(value, state);
			}

			function parser(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}

				var formatedValue = applyIEMask(value, state);
				var actualValue = clearValue(formatedValue);

				if (ctrl.$viewValue !== formatedValue) {
					ctrl.$setViewValue(formatedValue);
					ctrl.$render();
				}

				if (state && state.toUpperCase() === 'SP' && /^p/i.test(value)) {
					return 'P' + actualValue;
				}

				return actualValue;
			}

			ctrl.$formatters.push(formatter);
			ctrl.$parsers.push(parser);

			ctrl.$validators.ie = function validator(modelValue) {
				return ctrl.$isEmpty(modelValue) || BrV.ie(state).validate(modelValue);
			};

			scope.$watch(attrs.uiBrIeMask, function(newState) {
				state = (newState || '').toUpperCase();

				parser(ctrl.$viewValue);
				ctrl.$validate();
			});
		}
	};
}
BrIeMaskDirective.$inject = ['$parse'];

module.exports = BrIeMaskDirective;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var maskFactory = __webpack_require__(60);

var nfeAccessKeyMask = new StringMask('0000 0000 0000 0000 0000' +
	' 0000 0000 0000 0000 0000 0000');

module.exports = maskFactory({
	clearValue: function(rawValue) {
		return rawValue.replace(/[^0-9]/g, '').slice(0, 44);
	},
	format: function(cleanValue) {
		return (nfeAccessKeyMask.apply(cleanValue) || '').replace(/[^0-9]$/, '');
	},
	validations: {
		nfeAccessKey: function(value) {
			return value.length === 44;
		}
	}
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var maskFactory = __webpack_require__(60);

/**
 * FIXME: all numbers will have 9 digits after 2016.
 * see http://portal.embratel.com.br/embratel/9-digito/
 */
var phoneMask8D = {
		areaCode: new StringMask('(00) 0000-0000'), 	//with area code
		simple: new StringMask('0000-0000') 			//without area code
	}, phoneMask9D = {
		areaCode: new StringMask('(00) 00000-0000'), 	//with area code
		simple: new StringMask('00000-0000') 			//without area code
	}, phoneMask0800 = {
		areaCode: null,									//N/A
		simple: new StringMask('0000-000-0000') 		//N/A, so it's "simple"
	};

module.exports = maskFactory({
	clearValue: function(rawValue) {
		return rawValue.toString().replace(/[^0-9]/g, '').slice(0, 11);
	},
	format: function(cleanValue) {
		var formattedValue;

		if (cleanValue.indexOf('0800') === 0) {
			formattedValue = phoneMask0800.simple.apply(cleanValue);
		} else if (cleanValue.length < 9) {
			formattedValue = phoneMask8D.simple.apply(cleanValue) || '';
		} else if (cleanValue.length < 10) {
			formattedValue = phoneMask9D.simple.apply(cleanValue);
		} else if (cleanValue.length < 11) {
			formattedValue = phoneMask8D.areaCode.apply(cleanValue);
		} else {
			formattedValue = phoneMask9D.areaCode.apply(cleanValue);
		}

		return formattedValue.trim().replace(/[^0-9]$/, '');
	},
	getModelValue: function(formattedValue, originalModelType) {
		var cleanValue = this.clearValue(formattedValue);
		return originalModelType === 'number' ? parseInt(cleanValue) : cleanValue;
	},
	validations: {
		brPhoneNumber: function(value) {
			var valueLength = value && value.toString().length;

			//8- 8D without DD
			//9- 9D without DD
			//10- 9D with DD
			//11- 8D with DD and 0800
			return valueLength >= 8 && valueLength <= 11;
		}
	}
});


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var m = angular.module('ui.utils.masks.ch', [
	__webpack_require__(151),
])
.directive('uiChPhoneNumber', __webpack_require__(586));

module.exports = m.name;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var maskFactory = __webpack_require__(60);

var phoneMask = new StringMask('+00 00 000 00 00');

module.exports = maskFactory({
	clearValue: function(rawValue) {
		return rawValue.toString().replace(/[^0-9]/g, '').slice(0, 11);
	},
	format: function(cleanValue) {
		var formatedValue;

		formatedValue = phoneMask.apply(cleanValue) || '';

		return formatedValue.trim().replace(/[^0-9]$/, '');
	},
	validations: {
		chPhoneNumber: function(value) {
			var valueLength = value && value.toString().length;
			return valueLength === 11;
		}
	}
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var maskFactory = __webpack_require__(60);

var ccSize = 16;

var ccMask = new StringMask('0000 0000 0000 0000');

module.exports = maskFactory({
	clearValue: function(rawValue) {
		return rawValue.toString().replace(/[^0-9]/g, '').slice(0, ccSize);
	},
	format: function(cleanValue) {
		var formatedValue;

		formatedValue = ccMask.apply(cleanValue) || '';

		return formatedValue.trim().replace(/[^0-9]$/, '');
	},
	validations: {
		creditCard: function(value) {
			var valueLength = value && value.toString().length;
			return valueLength === ccSize;
		}
	}
});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(4);
var StringMask = __webpack_require__(38);

function isISODateString(date) {
	return /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}([-+][0-9]{2}:[0-9]{2}|Z)$/
		.test(date.toString());
}

function DateMaskDirective($locale) {
	var dateFormatMapByLocale = {
		'pt-br': 'DD/MM/YYYY',
		'ru': 'DD.MM.YYYY',
	};

	var dateFormat = dateFormatMapByLocale[$locale.id] || 'YYYY-MM-DD';

	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ctrl) {
			attrs.parse = attrs.parse || 'true';

			dateFormat = attrs.uiDateMask || dateFormat;

			var dateMask = new StringMask(dateFormat.replace(/[YMD]/g,'0'));

			function formatter(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}

				var cleanValue = value;
				if (typeof value === 'object' || isISODateString(value)) {
					cleanValue = moment(value).format(dateFormat);
				}

				cleanValue = cleanValue.replace(/[^0-9]/g, '');
				var formatedValue = dateMask.apply(cleanValue) || '';

				return formatedValue.trim().replace(/[^0-9]$/, '');
			}

			ctrl.$formatters.push(formatter);

			ctrl.$parsers.push(function parser(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}

				var formatedValue = formatter(value);

				if (ctrl.$viewValue !== formatedValue) {
					ctrl.$setViewValue(formatedValue);
					ctrl.$render();
				}

				return attrs.parse === 'false'
					? formatedValue
					: moment(formatedValue, dateFormat).toDate();
			});

			ctrl.$validators.date =	function validator(modelValue, viewValue) {
				if (ctrl.$isEmpty(modelValue)) {
					return true;
				}

				return moment(viewValue, dateFormat).isValid() && viewValue.length === dateFormat.length;
			};
		}
	};
}
DateMaskDirective.$inject = ['$locale'];

module.exports = DateMaskDirective;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var m = angular.module('ui.utils.masks.global', [
	__webpack_require__(151),
])
.directive('uiDateMask', __webpack_require__(588))
.directive('uiMoneyMask', __webpack_require__(590))
.directive('uiNumberMask', __webpack_require__(591))
.directive('uiPercentageMask', __webpack_require__(592))
.directive('uiScientificNotationMask', __webpack_require__(593))
.directive('uiTimeMask', __webpack_require__(594))
.directive('uiCreditCard', __webpack_require__(587));

module.exports = m.name;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var validators = __webpack_require__(186);

function MoneyMaskDirective($locale, $parse, PreFormatters) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ctrl) {
			var decimalDelimiter = $locale.NUMBER_FORMATS.DECIMAL_SEP,
				thousandsDelimiter = $locale.NUMBER_FORMATS.GROUP_SEP,
				currencySym = $locale.NUMBER_FORMATS.CURRENCY_SYM,
				symbolSeparation = ' ',
				decimals = $parse(attrs.uiMoneyMask)(scope),
				backspacePressed = false;

			element.bind('keydown keypress', function(event) {
				backspacePressed = event.which === 8;
			});

			function maskFactory(decimals) {
				var decimalsPattern = decimals > 0 ? decimalDelimiter + new Array(decimals + 1).join('0') : '';
				var maskPattern =  '#' + thousandsDelimiter + '##0' + decimalsPattern;
				if (angular.isDefined(attrs.uiCurrencyAfter)) {
					maskPattern += symbolSeparation;
				} else {
					maskPattern =  symbolSeparation + maskPattern;
				}
				return new StringMask(maskPattern, {reverse: true});
			}

			if (angular.isDefined(attrs.uiDecimalDelimiter)) {
				decimalDelimiter = attrs.uiDecimalDelimiter;
			}

			if (angular.isDefined(attrs.uiThousandsDelimiter)) {
				thousandsDelimiter = attrs.uiThousandsDelimiter;
			}

			if (angular.isDefined(attrs.uiHideGroupSep)) {
				thousandsDelimiter = '';
			}

			if (angular.isDefined(attrs.uiHideSpace)) {
				symbolSeparation = '';
			}

			if (angular.isDefined(attrs.currencySymbol)) {
				currencySym = attrs.currencySymbol;
				if (attrs.currencySymbol.length === 0) {
					symbolSeparation = '';
				}
			}

			if (isNaN(decimals)) {
				decimals = 2;
			}
			decimals = parseInt(decimals);
			var moneyMask = maskFactory(decimals);

			function formatter(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}
				var prefix = (angular.isDefined(attrs.uiNegativeNumber) && value < 0) ? '-' : '';
				var valueToFormat = PreFormatters.prepareNumberToFormatter(value, decimals);
				if (angular.isDefined(attrs.uiCurrencyAfter)) {
					return prefix + moneyMask.apply(valueToFormat) + currencySym;
				}
				return prefix + currencySym + moneyMask.apply(valueToFormat);
			}

			function parser(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}

				var actualNumber = value.replace(/[^\d]+/g,''), formatedValue;
				actualNumber = actualNumber.replace(/^[0]+([1-9])/,'$1');
				actualNumber = actualNumber || '0';

				if (backspacePressed && angular.isDefined(attrs.uiCurrencyAfter) && actualNumber !== 0) {
					actualNumber = actualNumber.substring(0, actualNumber.length - 1);
					backspacePressed = false;
				}
				if (angular.isDefined(attrs.uiCurrencyAfter)) {
					formatedValue = moneyMask.apply(actualNumber) + currencySym;
				} else {
					formatedValue = currencySym + moneyMask.apply(actualNumber);
				}

				if (angular.isDefined(attrs.uiNegativeNumber)) {
					var isNegative = (value[0] === '-'),
						needsToInvertSign = (value.slice(-1) === '-');

					//only apply the minus sign if it is negative or(exclusive)
					//needs to be negative and the number is different from zero
					if (needsToInvertSign ^ isNegative && !!actualNumber) {
						actualNumber *= -1;
						formatedValue = '-' + formatedValue;
					}
				}

				if (value !== formatedValue) {
					ctrl.$setViewValue(formatedValue);
					ctrl.$render();
				}

				return formatedValue ? parseInt(formatedValue.replace(/[^\d\-]+/g,''))/Math.pow(10,decimals) : null;
			}

			ctrl.$formatters.push(formatter);
			ctrl.$parsers.push(parser);

			if (attrs.uiMoneyMask) {
				scope.$watch(attrs.uiMoneyMask, function(_decimals) {
					decimals = isNaN(_decimals) ? 2 : _decimals;
					decimals = parseInt(decimals);
					moneyMask = maskFactory(decimals);

					parser(ctrl.$viewValue);
				});
			}

			if (attrs.min) {
				var minVal;

				ctrl.$validators.min = function(modelValue) {
					return validators.minNumber(ctrl, modelValue, minVal);
				};

				scope.$watch(attrs.min, function(value) {
					minVal = value;
					ctrl.$validate();
				});
			}

			if (attrs.max) {
				var maxVal;

				ctrl.$validators.max = function(modelValue) {
					return validators.maxNumber(ctrl, modelValue, maxVal);
				};

				scope.$watch(attrs.max, function(value) {
					maxVal = value;
					ctrl.$validate();
				});
			}
		}
	};
}
MoneyMaskDirective.$inject = ['$locale', '$parse', 'PreFormatters'];

module.exports = MoneyMaskDirective;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var validators = __webpack_require__(186);

function NumberMaskDirective($locale, $parse, PreFormatters, NumberMasks) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ctrl) {
			var decimalDelimiter = $locale.NUMBER_FORMATS.DECIMAL_SEP,
				thousandsDelimiter = $locale.NUMBER_FORMATS.GROUP_SEP,
				decimals = $parse(attrs.uiNumberMask)(scope);

			if (angular.isDefined(attrs.uiHideGroupSep)) {
				thousandsDelimiter = '';
			}

			if (isNaN(decimals)) {
				decimals = 2;
			}

			var viewMask = NumberMasks.viewMask(decimals, decimalDelimiter, thousandsDelimiter),
				modelMask = NumberMasks.modelMask(decimals);

			function parser(value) {
				if (ctrl.$isEmpty(value)) {
					return null;
				}

				var valueToFormat = PreFormatters.clearDelimitersAndLeadingZeros(value) || '0';
				var formatedValue = viewMask.apply(valueToFormat);
				var actualNumber = parseFloat(modelMask.apply(valueToFormat));

				if (angular.isDefined(attrs.uiNegativeNumber)) {
					var isNegative = (value[0] === '-'),
						needsToInvertSign = (value.slice(-1) === '-');

					//only apply the minus sign if it is negative or(exclusive) or the first character
					//needs to be negative and the number is different from zero
					if ((needsToInvertSign ^ isNegative) || value === '-') {
						actualNumber *= -1;
						formatedValue = '-' + ((actualNumber !== 0) ? formatedValue : '');
					}
				}

				if (ctrl.$viewValue !== formatedValue) {
					ctrl.$setViewValue(formatedValue);
					ctrl.$render();
				}

				return actualNumber;
			}

			function formatter(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}

				var prefix = (angular.isDefined(attrs.uiNegativeNumber) && value < 0) ? '-' : '';
				var valueToFormat = PreFormatters.prepareNumberToFormatter(value, decimals);
				return prefix + viewMask.apply(valueToFormat);
			}

			function clearViewValueIfMinusSign() {
				if (ctrl.$viewValue === '-') {
					ctrl.$setViewValue('');
					ctrl.$render();
				}
			}

			element.on('blur', clearViewValueIfMinusSign);

			ctrl.$formatters.push(formatter);
			ctrl.$parsers.push(parser);

			if (attrs.uiNumberMask) {
				scope.$watch(attrs.uiNumberMask, function(_decimals) {
					decimals = isNaN(_decimals) ? 2 : _decimals;
					viewMask = NumberMasks.viewMask(decimals, decimalDelimiter, thousandsDelimiter);
					modelMask = NumberMasks.modelMask(decimals);

					parser(ctrl.$viewValue);
				});
			}

			if (attrs.min) {
				var minVal;

				ctrl.$validators.min = function(modelValue) {
					return validators.minNumber(ctrl, modelValue, minVal);
				};

				scope.$watch(attrs.min, function(value) {
					minVal = value;
					ctrl.$validate();
				});
			}

			if (attrs.max) {
				var maxVal;

				ctrl.$validators.max = function(modelValue) {
					return validators.maxNumber(ctrl, modelValue, maxVal);
				};

				scope.$watch(attrs.max, function(value) {
					maxVal = value;
					ctrl.$validate();
				});
			}
		}
	};
}
NumberMaskDirective.$inject = ['$locale', '$parse', 'PreFormatters', 'NumberMasks'];

module.exports = NumberMaskDirective;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var validators = __webpack_require__(186);

function PercentageMaskDirective($locale, $parse, PreFormatters, NumberMasks) {
	function preparePercentageToFormatter(value, decimals, modelMultiplier) {
		return PreFormatters.clearDelimitersAndLeadingZeros((parseFloat(value)*modelMultiplier).toFixed(decimals));
	}

	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ctrl) {
			var decimalDelimiter = $locale.NUMBER_FORMATS.DECIMAL_SEP,
				thousandsDelimiter = $locale.NUMBER_FORMATS.GROUP_SEP,
				decimals = parseInt(attrs.uiPercentageMask),
				hideSpace = false,
				backspacePressed = false;

			element.bind('keydown keypress', function(event) {
				backspacePressed = event.which === 8;
			});

			var modelValue = {
				multiplier : 100,
				decimalMask: 2
			};

			if (angular.isDefined(attrs.uiHideGroupSep)) {
				thousandsDelimiter = '';
			}

			if (angular.isDefined(attrs.uiHideSpace)) {
				hideSpace = true;
			}

			if (angular.isDefined(attrs.uiPercentageValue)) {
				modelValue.multiplier  = 1;
				modelValue.decimalMask = 0;
			}

			if (isNaN(decimals)) {
				decimals = 2;
			}

			var numberDecimals = decimals + modelValue.decimalMask;
			var viewMask = NumberMasks.viewMask(decimals, decimalDelimiter, thousandsDelimiter),
				modelMask = NumberMasks.modelMask(numberDecimals);

			function formatter(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}

				var valueToFormat = preparePercentageToFormatter(value, decimals, modelValue.multiplier);
				return viewMask.apply(valueToFormat) + (hideSpace ? '%' : ' %');
			}

			function parse(value) {
				if (ctrl.$isEmpty(value)) {
					return null;
				}

				var valueToFormat = PreFormatters.clearDelimitersAndLeadingZeros(value) || '0';
				if (value.length > 1 && value.indexOf('%') === -1) {
					valueToFormat = valueToFormat.slice(0,valueToFormat.length-1);
				}
				if (backspacePressed && value.length === 1 && value !== '%') {
					valueToFormat = '0';
				}
				var percentSign = hideSpace ? '%' : ' %';
				var formatedValue = viewMask.apply(valueToFormat) + percentSign;
				var actualNumber = parseFloat(modelMask.apply(valueToFormat));

				if (ctrl.$viewValue !== formatedValue) {
					ctrl.$setViewValue(formatedValue);
					ctrl.$render();
				}

				return actualNumber;
			}

			ctrl.$formatters.push(formatter);
			ctrl.$parsers.push(parse);

			if (attrs.uiPercentageMask) {
				scope.$watch(attrs.uiPercentageMask, function(_decimals) {
					decimals = isNaN(_decimals) ? 2 : _decimals;

					if (angular.isDefined(attrs.uiPercentageValue)) {
						modelValue.multiplier  = 1;
						modelValue.decimalMask = 0;
					}

					numberDecimals = decimals + modelValue.decimalMask;
					viewMask = NumberMasks.viewMask(decimals, decimalDelimiter, thousandsDelimiter);
					modelMask = NumberMasks.modelMask(numberDecimals);

					parse(ctrl.$viewValue);
				});
			}

			if (attrs.min) {
				var minVal;

				ctrl.$validators.min = function(modelValue) {
					return validators.minNumber(ctrl, modelValue, minVal);
				};

				scope.$watch(attrs.min, function(value) {
					minVal = value;
					ctrl.$validate();
				});
			}

			if (attrs.max) {
				var maxVal;

				ctrl.$validators.max = function(modelValue) {
					return validators.maxNumber(ctrl, modelValue, maxVal);
				};

				scope.$watch(attrs.max, function(value) {
					maxVal = value;
					ctrl.$validate();
				});
			}
		}
	};
}
PercentageMaskDirective.$inject = ['$locale', '$parse', 'PreFormatters', 'NumberMasks'];

module.exports = PercentageMaskDirective;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);

function ScientificNotationMaskDirective($locale, $parse) {
	var decimalDelimiter = $locale.NUMBER_FORMATS.DECIMAL_SEP,
		defaultPrecision = 2;

	function significandMaskBuilder(decimals) {
		var mask = '0';

		if (decimals > 0) {
			mask += decimalDelimiter;
			for (var i = 0; i < decimals; i++) {
				mask += '0';
			}
		}

		return new StringMask(mask, {
			reverse: true
		});
	}

	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ctrl) {
			var decimals = $parse(attrs.uiScientificNotationMask)(scope);

			if (isNaN(decimals)) {
				decimals = defaultPrecision;
			}

			var significandMask = significandMaskBuilder(decimals);

			function splitNumber(value) {
				var stringValue = value.toString(),
					splittedNumber = stringValue.match(/(-?[0-9]*)[\.]?([0-9]*)?[Ee]?([\+-]?[0-9]*)?/);

				return {
					integerPartOfSignificand: splittedNumber[1],
					decimalPartOfSignificand: splittedNumber[2],
					exponent: splittedNumber[3] | 0
				};
			}

			function formatter(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}

				if (typeof value === 'string') {
					value = value.replace(decimalDelimiter, '.');
				} else if (typeof value === 'number') {
					value = value.toExponential(decimals);
				}

				var formattedValue, exponent;
				var splittedNumber = splitNumber(value);

				var integerPartOfSignificand = splittedNumber.integerPartOfSignificand || 0;
				var numberToFormat = integerPartOfSignificand.toString();
				if (angular.isDefined(splittedNumber.decimalPartOfSignificand)) {
					numberToFormat += splittedNumber.decimalPartOfSignificand;
				}

				var needsNormalization =
					(integerPartOfSignificand >= 1 || integerPartOfSignificand <= -1) &&
					(
						(angular.isDefined(splittedNumber.decimalPartOfSignificand) &&
						splittedNumber.decimalPartOfSignificand.length > decimals) ||
						(decimals === 0 && numberToFormat.length >= 2)
					);

				if (needsNormalization) {
					exponent = numberToFormat.slice(decimals + 1, numberToFormat.length);
					numberToFormat = numberToFormat.slice(0, decimals + 1);
				}

				formattedValue = significandMask.apply(numberToFormat);

				if (splittedNumber.exponent !== 0) {
					exponent = splittedNumber.exponent;
				}

				if (angular.isDefined(exponent)) {
					formattedValue += 'e' + exponent;
				}

				return formattedValue;
			}

			function parser(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}

				var viewValue = formatter(value),
					modelValue = parseFloat(viewValue.replace(decimalDelimiter, '.'));

				if (ctrl.$viewValue !== viewValue) {
					ctrl.$setViewValue(viewValue);
					ctrl.$render();
				}

				return modelValue;
			}

			ctrl.$formatters.push(formatter);
			ctrl.$parsers.push(parser);

			ctrl.$validators.max = function validator(value) {
				return ctrl.$isEmpty(value) || value < Number.MAX_VALUE;
			};
		}
	};
}
ScientificNotationMaskDirective.$inject = ['$locale', '$parse'];

module.exports = ScientificNotationMaskDirective;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);

module.exports = function TimeMaskDirective() {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attrs, ctrl) {
			var timeFormat = '00:00:00';

			if (angular.isDefined(attrs.uiTimeMask) && attrs.uiTimeMask === 'short') {
				timeFormat = '00:00';
			}

			var formattedValueLength = timeFormat.length;
			var unformattedValueLength = timeFormat.replace(':', '').length;
			var timeMask = new StringMask(timeFormat);

			function formatter(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}

				var cleanValue = value.replace(/[^0-9]/g, '').slice(0, unformattedValueLength) || '';
				return (timeMask.apply(cleanValue) || '').replace(/[^0-9]$/, '');
			}

			ctrl.$formatters.push(formatter);

			ctrl.$parsers.push(function parser(value) {
				if (ctrl.$isEmpty(value)) {
					return value;
				}

				var viewValue = formatter(value);
				var modelValue = viewValue;

				if (ctrl.$viewValue !== viewValue) {
					ctrl.$setViewValue(viewValue);
					ctrl.$render();
				}

				return modelValue;
			});

			ctrl.$validators.time = function(modelValue) {
				if (ctrl.$isEmpty(modelValue)) {
					return true;
				}

				var splittedValue = modelValue.toString().split(/:/).filter(function(v) {
					return !!v;
				});

				var hours = parseInt(splittedValue[0]),
					minutes = parseInt(splittedValue[1]),
					seconds = parseInt(splittedValue[2] || 0);

				return modelValue.toString().length === formattedValueLength &&
					hours < 24 && minutes < 60 && seconds < 60;
			};
		}
	};
};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StringMask = __webpack_require__(38);
var maskFactory = __webpack_require__(60);

var phoneMaskUS = new StringMask('(000) 000-0000'),
	phoneMaskINTL = new StringMask('+00-00-000-000000');

module.exports = maskFactory({
	clearValue: function(rawValue) {
		return rawValue.toString().replace(/[^0-9]/g, '');
	},
	format: function(cleanValue) {
		var formattedValue;

		if (cleanValue.length < 11) {
			formattedValue = phoneMaskUS.apply(cleanValue) || '';
		} else {
			formattedValue = phoneMaskINTL.apply(cleanValue);
		}

		return formattedValue.trim().replace(/[^0-9]$/, '');
	},
	validations: {
		usPhoneNumber: function(value) {
			return value && value.toString().length > 9;
		}
	}
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var m = angular.module('ui.utils.masks.us', [
	__webpack_require__(151)
])
.directive('uiUsPhoneNumber', __webpack_require__(595));

module.exports = m.name;


/***/ }),
/* 597 */
/***/ (function(module, exports) {

/*! 
 * angular-loading-bar v0.9.0
 * https://chieffancypants.github.io/angular-loading-bar
 * Copyright (c) 2016 Wes Cruver
 * License: MIT
 */
/*
 * angular-loading-bar
 *
 * intercepts XHR requests and creates a loading bar.
 * Based on the excellent nprogress work by rstacruz (more info in readme)
 *
 * (c) 2013 Wes Cruver
 * License: MIT
 */


(function() {

'use strict';

// Alias the loading bar for various backwards compatibilities since the project has matured:
angular.module('angular-loading-bar', ['cfp.loadingBarInterceptor']);
angular.module('chieffancypants.loadingBar', ['cfp.loadingBarInterceptor']);


/**
 * loadingBarInterceptor service
 *
 * Registers itself as an Angular interceptor and listens for XHR requests.
 */
angular.module('cfp.loadingBarInterceptor', ['cfp.loadingBar'])
  .config(['$httpProvider', function ($httpProvider) {

    var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'cfpLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, cfpLoadingBar) {

      /**
       * The total number of requests made
       */
      var reqsTotal = 0;

      /**
       * The number of requests completed (either successfully or not)
       */
      var reqsCompleted = 0;

      /**
       * The amount of time spent fetching before showing the loading bar
       */
      var latencyThreshold = cfpLoadingBar.latencyThreshold;

      /**
       * $timeout handle for latencyThreshold
       */
      var startTimeout;


      /**
       * calls cfpLoadingBar.complete() which removes the
       * loading bar from the DOM.
       */
      function setComplete() {
        $timeout.cancel(startTimeout);
        cfpLoadingBar.complete();
        reqsCompleted = 0;
        reqsTotal = 0;
      }

      /**
       * Determine if the response has already been cached
       * @param  {Object}  config the config option from the request
       * @return {Boolean} retrns true if cached, otherwise false
       */
      function isCached(config) {
        var cache;
        var defaultCache = $cacheFactory.get('$http');
        var defaults = $httpProvider.defaults;

        // Choose the proper cache source. Borrowed from angular: $http service
        if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
            cache = angular.isObject(config.cache) ? config.cache
              : angular.isObject(defaults.cache) ? defaults.cache
              : defaultCache;
        }

        var cached = cache !== undefined ?
          cache.get(config.url) !== undefined : false;

        if (config.cached !== undefined && cached !== config.cached) {
          return config.cached;
        }
        config.cached = cached;
        return cached;
      }


      return {
        'request': function(config) {
          // Check to make sure this request hasn't already been cached and that
          // the requester didn't explicitly ask us to ignore this request:
          if (!config.ignoreLoadingBar && !isCached(config)) {
            $rootScope.$broadcast('cfpLoadingBar:loading', {url: config.url});
            if (reqsTotal === 0) {
              startTimeout = $timeout(function() {
                cfpLoadingBar.start();
              }, latencyThreshold);
            }
            reqsTotal++;
            cfpLoadingBar.set(reqsCompleted / reqsTotal);
          }
          return config;
        },

        'response': function(response) {
          if (!response || !response.config) {
            $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
            return response;
          }

          if (!response.config.ignoreLoadingBar && !isCached(response.config)) {
            reqsCompleted++;
            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: response.config.url, result: response});
            if (reqsCompleted >= reqsTotal) {
              setComplete();
            } else {
              cfpLoadingBar.set(reqsCompleted / reqsTotal);
            }
          }
          return response;
        },

        'responseError': function(rejection) {
          if (!rejection || !rejection.config) {
            $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
            return $q.reject(rejection);
          }

          if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
            reqsCompleted++;
            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: rejection.config.url, result: rejection});
            if (reqsCompleted >= reqsTotal) {
              setComplete();
            } else {
              cfpLoadingBar.set(reqsCompleted / reqsTotal);
            }
          }
          return $q.reject(rejection);
        }
      };
    }];

    $httpProvider.interceptors.push(interceptor);
  }]);


/**
 * Loading Bar
 *
 * This service handles adding and removing the actual element in the DOM.
 * Generally, best practices for DOM manipulation is to take place in a
 * directive, but because the element itself is injected in the DOM only upon
 * XHR requests, and it's likely needed on every view, the best option is to
 * use a service.
 */
angular.module('cfp.loadingBar', [])
  .provider('cfpLoadingBar', function() {

    this.autoIncrement = true;
    this.includeSpinner = true;
    this.includeBar = true;
    this.latencyThreshold = 100;
    this.startSize = 0.02;
    this.parentSelector = 'body';
    this.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
    this.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>';

    this.$get = ['$injector', '$document', '$timeout', '$rootScope', function ($injector, $document, $timeout, $rootScope) {
      var $animate;
      var $parentSelector = this.parentSelector,
        loadingBarContainer = angular.element(this.loadingBarTemplate),
        loadingBar = loadingBarContainer.find('div').eq(0),
        spinner = angular.element(this.spinnerTemplate);

      var incTimeout,
        completeTimeout,
        started = false,
        status = 0;

      var autoIncrement = this.autoIncrement;
      var includeSpinner = this.includeSpinner;
      var includeBar = this.includeBar;
      var startSize = this.startSize;

      /**
       * Inserts the loading bar element into the dom, and sets it to 2%
       */
      function _start() {
        if (!$animate) {
          $animate = $injector.get('$animate');
        }

        $timeout.cancel(completeTimeout);

        // do not continually broadcast the started event:
        if (started) {
          return;
        }

        var document = $document[0];
        var parent = document.querySelector ?
          document.querySelector($parentSelector)
          : $document.find($parentSelector)[0]
        ;

        if (! parent) {
          parent = document.getElementsByTagName('body')[0];
        }

        var $parent = angular.element(parent);
        var $after = parent.lastChild && angular.element(parent.lastChild);

        $rootScope.$broadcast('cfpLoadingBar:started');
        started = true;

        if (includeBar) {
          $animate.enter(loadingBarContainer, $parent, $after);
        }

        if (includeSpinner) {
          $animate.enter(spinner, $parent, loadingBarContainer);
        }

        _set(startSize);
      }

      /**
       * Set the loading bar's width to a certain percent.
       *
       * @param n any value between 0 and 1
       */
      function _set(n) {
        if (!started) {
          return;
        }
        var pct = (n * 100) + '%';
        loadingBar.css('width', pct);
        status = n;

        // increment loadingbar to give the illusion that there is always
        // progress but make sure to cancel the previous timeouts so we don't
        // have multiple incs running at the same time.
        if (autoIncrement) {
          $timeout.cancel(incTimeout);
          incTimeout = $timeout(function() {
            _inc();
          }, 250);
        }
      }

      /**
       * Increments the loading bar by a random amount
       * but slows down as it progresses
       */
      function _inc() {
        if (_status() >= 1) {
          return;
        }

        var rnd = 0;

        // TODO: do this mathmatically instead of through conditions

        var stat = _status();
        if (stat >= 0 && stat < 0.25) {
          // Start out between 3 - 6% increments
          rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
        } else if (stat >= 0.25 && stat < 0.65) {
          // increment between 0 - 3%
          rnd = (Math.random() * 3) / 100;
        } else if (stat >= 0.65 && stat < 0.9) {
          // increment between 0 - 2%
          rnd = (Math.random() * 2) / 100;
        } else if (stat >= 0.9 && stat < 0.99) {
          // finally, increment it .5 %
          rnd = 0.005;
        } else {
          // after 99%, don't increment:
          rnd = 0;
        }

        var pct = _status() + rnd;
        _set(pct);
      }

      function _status() {
        return status;
      }

      function _completeAnimation() {
        status = 0;
        started = false;
      }

      function _complete() {
        if (!$animate) {
          $animate = $injector.get('$animate');
        }

        $rootScope.$broadcast('cfpLoadingBar:completed');
        _set(1);

        $timeout.cancel(completeTimeout);

        // Attempt to aggregate any start/complete calls within 500ms:
        completeTimeout = $timeout(function() {
          var promise = $animate.leave(loadingBarContainer, _completeAnimation);
          if (promise && promise.then) {
            promise.then(_completeAnimation);
          }
          $animate.leave(spinner);
        }, 500);
      }

      return {
        start            : _start,
        set              : _set,
        status           : _status,
        inc              : _inc,
        complete         : _complete,
        autoIncrement    : this.autoIncrement,
        includeSpinner   : this.includeSpinner,
        latencyThreshold : this.latencyThreshold,
        parentSelector   : this.parentSelector,
        startSize        : this.startSize
      };


    }];     //
  });       // wtf javascript. srsly
})();       //


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(597);
module.exports = 'angular-loading-bar';


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment) {/*! Angular Moment Picker - v0.9.7 - http://indrimuska.github.io/angular-moment-picker - (c) 2015 Indri Muska - MIT */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(16);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(2);
	var provider_1 = __webpack_require__(3);
	exports.Provider = provider_1["default"];
	var directive_1 = __webpack_require__(4);
	exports.Directive = directive_1["default"];
	angular
	    .module('moment-picker', [])
	    .provider('momentPicker', [function () { return new provider_1["default"](); }])
	    .directive('momentPicker', [
	    '$timeout', '$sce', '$log', '$window', 'momentPicker',
	    function ($timeout, $sce, $log, $window, momentPicker) {
	        return new directive_1["default"]($timeout, $sce, $log, $window, momentPicker);
	    }
	]);


/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = angular;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(2);
	var Provider = (function () {
	    function Provider() {
	        this.settings = {
	            locale: 'en',
	            format: 'L LTS',
	            minView: 'decade',
	            maxView: 'minute',
	            startView: 'year',
	            validate: true,
	            autoclose: true,
	            today: false,
	            keyboard: false,
	            showHeader: true,
	            leftArrow: '&larr;',
	            rightArrow: '&rarr;',
	            // Decade View
	            yearsFormat: 'YYYY',
	            // Year View
	            monthsFormat: 'MMM',
	            // Month View
	            daysFormat: 'D',
	            // Day View
	            hoursFormat: 'HH:[00]',
	            hoursStart: 0,
	            hoursEnd: 23,
	            // Hour View
	            minutesStep: 5,
	            minutesStart: 0,
	            minutesEnd: 59,
	            // Minute View
	            secondsFormat: 'ss',
	            secondsStep: 1,
	            secondsStart: 0,
	            secondsEnd: 59
	        };
	    }
	    Provider.prototype.options = function (options) {
	        angular.extend(this.settings, options);
	        return angular.copy(this.settings);
	    };
	    Provider.prototype.$get = function () {
	        return this.settings;
	    };
	    return Provider;
	}());
	exports.__esModule = true;
	exports["default"] = Provider;


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(2);
	var moment = __webpack_require__(5);
	var helpers_1 = __webpack_require__(6);
	var views_1 = __webpack_require__(7);
	var utility_1 = __webpack_require__(9);
	var template = __webpack_require__(15);
	var Directive = (function () {
	    function Directive($timeout, $sce, $log, $window, provider) {
	        var _this = this;
	        this.$timeout = $timeout;
	        this.$sce = $sce;
	        this.$log = $log;
	        this.$window = $window;
	        this.provider = provider;
	        this.restrict = 'AE';
	        this.require = '?ngModel';
	        this.transclude = true;
	        this.template = template;
	        this.scope = {
	            value: '=?momentPicker',
	            model: '=?ngModel',
	            locale: '@?',
	            format: '@?',
	            minView: '@?',
	            maxView: '@?',
	            startView: '@?',
	            minDate: '=?',
	            maxDate: '=?',
	            startDate: '=?',
	            disabled: '=?disable',
	            validate: '=?',
	            autoclose: '=?',
	            isOpen: '=?',
	            today: '=?',
	            keyboard: '=?',
	            showHeader: '=?',
	            additions: '=?',
	            change: '&?',
	            selectable: '&?'
	        };
	        this.link = function ($scope, $element, $attrs, $ctrl, $transclude) {
	            $transclude(function ($transElement) {
	                // one-way binding attributes
	                angular.forEach([
	                    'locale', 'format', 'minView', 'maxView', 'startView', 'validate', 'autoclose', 'today', 'keyboard', 'showHeader',
	                    'leftArrow', 'rightArrow', 'additions'
	                ], function (attr) {
	                    if (!angular.isDefined($scope[attr]))
	                        $scope[attr] = _this.provider[attr];
	                    if (!angular.isDefined($attrs[attr]))
	                        $attrs[attr] = $scope[attr];
	                });
	                // check if ngModel has been set
	                if (!$attrs['ngModel'])
	                    $ctrl = {}; // tslint:disable-line:no-any
	                // limits
	                $scope.limits = {
	                    minDate: utility_1.toMoment($scope.minDate, $scope.format, $scope.locale),
	                    maxDate: utility_1.toMoment($scope.maxDate, $scope.format, $scope.locale),
	                    isAfterOrEqualMin: function (value, precision) {
	                        return !angular.isDefined($scope.limits.minDate) || value.isAfter($scope.limits.minDate, precision) || value.isSame($scope.limits.minDate, precision);
	                    },
	                    isBeforeOrEqualMax: function (value, precision) {
	                        return !angular.isDefined($scope.limits.maxDate) || value.isBefore($scope.limits.maxDate, precision) || value.isSame($scope.limits.maxDate, precision);
	                    },
	                    isSelectable: function (value, precision) {
	                        var selectable = true;
	                        try {
	                            if (angular.isFunction($scope.selectable))
	                                selectable = $scope.selectable({ date: value, type: precision });
	                        }
	                        catch (e) {
	                            _this.$log.error(e);
	                        }
	                        return $scope.limits.isAfterOrEqualMin(value, precision) && $scope.limits.isBeforeOrEqualMax(value, precision) && selectable;
	                    },
	                    checkValue: function () {
	                        if (!utility_1.isValidMoment($ctrl.$modelValue) || !$scope.validate)
	                            return;
	                        if (!$scope.limits.isAfterOrEqualMin($ctrl.$modelValue))
	                            utility_1.setValue($scope.limits.minDate, $scope, $ctrl, $attrs);
	                        if (!$scope.limits.isBeforeOrEqualMax($ctrl.$modelValue))
	                            utility_1.setValue($scope.limits.maxDate, $scope, $ctrl, $attrs);
	                    },
	                    checkView: function () {
	                        if (!angular.isDefined($scope.view.moment))
	                            $scope.view.moment = moment().locale($scope.locale);
	                        if (!$scope.limits.isAfterOrEqualMin($scope.view.moment))
	                            $scope.view.moment = $scope.limits.minDate.clone();
	                        if (!$scope.limits.isBeforeOrEqualMax($scope.view.moment))
	                            $scope.view.moment = $scope.limits.maxDate.clone();
	                        $scope.view.update();
	                        $scope.view.render();
	                    }
	                };
	                $scope.views = {
	                    all: ['decade', 'year', 'month', 'day', 'hour', 'minute'],
	                    precisions: { decade: 'year', year: 'month', month: 'date', day: 'hour', hour: 'minute', minute: 'second' },
	                    // for each view, `$scope.views.formats` object contains the available moment formats
	                    // formats present in more views are used to perform min/max view detection (i.e. 'LTS', 'LT', ...)
	                    formats: {
	                        decade: 'Y{1,2}(?!Y)|YYYY|[Ll]{1,4}(?!T)',
	                        /* formats: Y,YY,YYYY,L,LL,LLL,LLLL,l,ll,lll,llll */
	                        year: 'M{1,4}(?![Mo])|Mo|Q',
	                        /* formats: M,MM,MMM,MMM,Mo,Q */
	                        month: '[Dd]{1,4}(?![Ddo])|DDDo|[Dd]o|[Ww]{1,2}(?![Wwo])|[Ww]o|[Ee]|L{1,2}(?!T)|l{1,2}',
	                        /* formats: D,DD,DDD,DDDD,d,dd,ddd,dddd,DDDo,Do,do,W,WW,w,ww,Wo,wo,E,e,L,LL,l,ll */
	                        day: '[Hh]{1,2}|LTS?',
	                        /* formats: H,HH,h,hh,LT,LTS */
	                        hour: 'm{1,2}|[Ll]{3,4}|LT(?!S)',
	                        /* formats: m,mm,LLL,LLLL,lll,llll,LT */
	                        minute: 's{1,2}|S{1,}|X|LTS'
	                    },
	                    detectMinMax: function () {
	                        if (!$scope.format)
	                            return;
	                        var minView, maxView;
	                        angular.forEach($scope.views.formats, function (formats, view) {
	                            var regexp = new RegExp('(' + formats + ')(?![^\[]*\])', 'g');
	                            if (!$scope.format.match(regexp))
	                                return;
	                            if (!angular.isDefined(minView))
	                                minView = view;
	                            maxView = view;
	                        });
	                        if (!angular.isDefined(minView))
	                            minView = 0;
	                        else
	                            minView = Math.max(0, $scope.views.all.indexOf(minView));
	                        if (!angular.isDefined(maxView))
	                            maxView = $scope.views.all.length - 1;
	                        else
	                            maxView = Math.min($scope.views.all.length - 1, $scope.views.all.indexOf(maxView));
	                        if (minView > $scope.views.all.indexOf($scope.minView))
	                            $scope.minView = $scope.views.all[minView];
	                        if (maxView < $scope.views.all.indexOf($scope.maxView))
	                            $scope.maxView = $scope.views.all[maxView];
	                    },
	                    // specific views
	                    decade: new views_1.DecadeView($scope, $ctrl, _this.provider),
	                    year: new views_1.YearView($scope, $ctrl, _this.provider),
	                    month: new views_1.MonthView($scope, $ctrl, _this.provider),
	                    day: new views_1.DayView($scope, $ctrl, _this.provider),
	                    hour: new views_1.HourView($scope, $ctrl, _this.provider),
	                    minute: new views_1.MinuteView($scope, $ctrl, _this.provider)
	                };
	                $scope.view = {
	                    moment: undefined,
	                    value: undefined,
	                    isOpen: false,
	                    selected: $scope.startView,
	                    update: function () { $scope.view.value = utility_1.momentToValue($scope.view.moment, $scope.format); },
	                    toggle: function () { $scope.view.isOpen ? $scope.view.close() : $scope.view.open(); },
	                    open: function () {
	                        if ($scope.disabled || $scope.view.isOpen)
	                            return;
	                        $scope.isOpen = true;
	                        $scope.view.isOpen = true;
	                        _this.$timeout($scope.view.position, 0, false);
	                    },
	                    close: function () {
	                        if (!$scope.view.isOpen)
	                            return;
	                        $scope.isOpen = false;
	                        $scope.view.isOpen = false;
	                        $scope.view.selected = $scope.startView;
	                    },
	                    position: function () {
	                        if (!$scope.view.isOpen)
	                            return;
	                        $scope.picker.removeClass('top').removeClass('left');
	                        var container = $scope.container[0], offset = helpers_1.getOffset(container), top = offset.top - _this.$window.pageYOffset, left = offset.left - _this.$window.pageXOffset, winWidth = _this.$window.innerWidth, winHeight = _this.$window.innerHeight;
	                        if (top + _this.$window.pageYOffset - container.offsetHeight > 0 && top > winHeight / 2)
	                            $scope.picker.addClass('top');
	                        if (left + container.offsetWidth > winWidth)
	                            $scope.picker.addClass('left');
	                    },
	                    keydown: function (e) {
	                        var view = $scope.views[$scope.view.selected], precision = $scope.views.precisions[$scope.view.selected].replace('date', 'day'), singleUnit = _this.provider[precision + 'sStep'] || 1, operation = [utility_1.KEYS.up, utility_1.KEYS.left].indexOf(e.keyCode) >= 0 ? 'subtract' : 'add', highlight = function (vertical) {
	                            var unitMultiplier = vertical ? view.perLine : 1, nextDate = $scope.view.moment.clone()[operation](singleUnit * unitMultiplier, precision);
	                            if ($scope.limits.isSelectable(nextDate, precision)) {
	                                $scope.view.moment = nextDate;
	                                $scope.view.update();
	                                $scope.view.render();
	                            }
	                        };
	                        switch (e.keyCode) {
	                            case utility_1.KEYS.up:
	                            case utility_1.KEYS.down:
	                                e.preventDefault();
	                                if (!$scope.view.isOpen)
	                                    $scope.view.open();
	                                else
	                                    highlight(true);
	                                break;
	                            case utility_1.KEYS.left:
	                            case utility_1.KEYS.right:
	                                if (!$scope.view.isOpen)
	                                    break;
	                                e.preventDefault();
	                                highlight();
	                                break;
	                            case utility_1.KEYS.enter:
	                                if (!$scope.view.isOpen)
	                                    break;
	                                $scope.view.change(precision);
	                                e.preventDefault();
	                                break;
	                            case utility_1.KEYS.escape:
	                                $scope.view.toggle();
	                                break;
	                        }
	                    },
	                    // utility
	                    unit: function () { return $scope.view.selected == 'decade' ? 10 : 1; },
	                    precision: function () { return $scope.view.selected.replace('decade', 'year'); },
	                    // header
	                    title: '',
	                    previous: {
	                        label: _this.$sce.trustAsHtml($scope.leftArrow),
	                        selectable: true,
	                        set: function () {
	                            if ($scope.view.previous.selectable) {
	                                $scope.view.moment.subtract($scope.view.unit(), $scope.view.precision());
	                                $scope.view.update();
	                                $scope.view.render();
	                            }
	                        }
	                    },
	                    next: {
	                        selectable: true,
	                        label: _this.$sce.trustAsHtml($scope.rightArrow),
	                        set: function () {
	                            if ($scope.view.next.selectable) {
	                                $scope.view.moment.add($scope.view.unit(), $scope.view.precision());
	                                $scope.view.update();
	                                $scope.view.render();
	                            }
	                        }
	                    },
	                    setParentView: function () { $scope.view.change($scope.views.all[Math.max(0, $scope.views.all.indexOf($scope.view.selected) - 1)]); },
	                    // body
	                    render: function () {
	                        var momentPrevious = $scope.view.moment.clone().startOf($scope.view.precision()).subtract($scope.view.unit(), $scope.view.precision()), momentNext = $scope.view.moment.clone().endOf($scope.view.precision()).add($scope.view.unit(), $scope.view.precision());
	                        $scope.view.previous.selectable = $scope.limits.isAfterOrEqualMin(momentPrevious, $scope.view.precision());
	                        $scope.view.previous.label = _this.$sce.trustAsHtml($scope.view.previous.selectable ? $scope.leftArrow : '&nbsp;');
	                        $scope.view.next.selectable = $scope.limits.isBeforeOrEqualMax(momentNext, $scope.view.precision());
	                        $scope.view.next.label = _this.$sce.trustAsHtml($scope.view.next.selectable ? $scope.rightArrow : '&nbsp;');
	                        $scope.view.title = $scope.views[$scope.view.selected].render();
	                    },
	                    change: function (view) {
	                        var nextView = $scope.views.all.indexOf(view), minView = $scope.views.all.indexOf($scope.minView), maxView = $scope.views.all.indexOf($scope.maxView);
	                        if (nextView < 0 || nextView > maxView) {
	                            utility_1.setValue($scope.view.moment, $scope, $ctrl, $attrs);
	                            $scope.view.update();
	                            if ($attrs['ngModel'])
	                                $ctrl.$commitViewValue();
	                            if ($scope.autoclose)
	                                _this.$timeout($scope.view.close);
	                        }
	                        else if (nextView >= minView)
	                            $scope.view.selected = view;
	                    }
	                };
	                // creation
	                $scope.picker = angular.element($element[0].querySelectorAll('.moment-picker'));
	                $element.after($scope.picker);
	                $scope.contents = angular.element($scope.picker[0].querySelectorAll('.moment-picker-contents'));
	                $scope.container = angular.element($scope.picker[0].querySelectorAll('.moment-picker-container'));
	                $scope.contents.append($element.append($transElement));
	                $scope.input = $scope.contents[0].tagName.toLowerCase() != 'input' && $scope.contents[0].querySelectorAll('input').length > 0
	                    ? angular.element($scope.contents[0].querySelectorAll('input'))
	                    : angular.element($scope.contents[0]);
	                $scope.input.addClass('moment-picker-input').attr('tabindex', 0);
	                // initialization
	                $scope.views.detectMinMax();
	                $scope.limits.checkView();
	                // model controller is initialized after linking function
	                _this.$timeout(function () {
	                    if ($attrs['ngModel'])
	                        $ctrl.$commitViewValue();
	                    // view initialization
	                    if ($scope.startDate)
	                        $scope.view.moment = utility_1.toMoment($scope.startDate, $scope.format, $scope.locale);
	                    else if (utility_1.isValidMoment($ctrl.$modelValue))
	                        $scope.view.moment = $ctrl.$modelValue.clone();
	                    $scope.view.update();
	                    $scope.view.render();
	                });
	                // model <-> view conversion
	                if ($attrs['ngModel']) {
	                    $ctrl.$parsers.push(function (viewValue) { return utility_1.updateMoment($ctrl.$modelValue, utility_1.valueToMoment(viewValue, $scope), $scope) || true; });
	                    $ctrl.$formatters.push(function (modelValue) { return utility_1.momentToValue(modelValue, $scope.format) || ''; });
	                    $ctrl.$viewChangeListeners.push(function () { if ($attrs['ngModel'] != $attrs['momentPicker'])
	                        $scope.value = $ctrl.$viewValue; });
	                    $ctrl.$validators.minDate = function (value) { return $scope.validate || !utility_1.isValidMoment(value) || $scope.limits.isAfterOrEqualMin(value); };
	                    $ctrl.$validators.maxDate = function (value) { return $scope.validate || !utility_1.isValidMoment(value) || $scope.limits.isBeforeOrEqualMax(value); };
	                }
	                // properties listeners
	                if ($attrs['ngModel'] != $attrs['momentPicker'])
	                    $scope.$watch('value', function (newValue, oldValue) {
	                        if (newValue !== oldValue)
	                            utility_1.setValue(newValue, $scope, $ctrl, $attrs);
	                    });
	                $scope.$watch(function () { return utility_1.momentToValue($ctrl.$modelValue, $scope.format); }, function (newViewValue, oldViewValue) {
	                    if (newViewValue == oldViewValue)
	                        return;
	                    var newModelValue = utility_1.valueToMoment(newViewValue, $scope);
	                    utility_1.setValue(newModelValue, $scope, $ctrl, $attrs);
	                    $scope.limits.checkValue();
	                    $scope.view.moment = (newModelValue || moment().locale($scope.locale)).clone();
	                    $scope.view.update();
	                    $scope.view.render();
	                    if (angular.isFunction($scope.change)) {
	                        var oldModelValue_1 = utility_1.valueToMoment(oldViewValue, $scope);
	                        $scope.$evalAsync(function () { return $scope.change({ newValue: newModelValue, oldValue: oldModelValue_1 }); });
	                    }
	                });
	                $scope.$watch(function () { return $ctrl.$modelValue && $ctrl.$modelValue.valueOf(); }, function () {
	                    var viewMoment = (utility_1.isValidMoment($ctrl.$modelValue) ? $ctrl.$modelValue : moment().locale($scope.locale)).clone();
	                    if (!viewMoment.isSame($scope.view.moment)) {
	                        $scope.view.moment = viewMoment;
	                        $scope.view.update();
	                        $scope.view.render();
	                    }
	                });
	                $scope.$watch('view.selected', function () { return $scope.view.render(); });
	                $scope.$watchGroup(['minView', 'maxView'], function () {
	                    // auto-detect minView/maxView
	                    $scope.views.detectMinMax();
	                    // limit startView
	                    $scope.startView = $scope.views.all[Math.max(Math.min($scope.views.all.indexOf($scope.startView), $scope.views.all.indexOf($scope.maxView)), $scope.views.all.indexOf($scope.minView))];
	                    $scope.view.selected = $scope.startView;
	                });
	                $scope.$watchGroup([
	                    function () { return utility_1.toValue($scope.minDate, $scope.format, $scope.locale); },
	                    function () { return utility_1.toValue($scope.maxDate, $scope.format, $scope.locale); }
	                ], function () {
	                    angular.forEach(['minDate', 'maxDate'], function (field) {
	                        $scope.limits[field] = utility_1.toMoment($scope[field], $scope.format, $scope.locale);
	                    });
	                    $scope.limits.checkValue();
	                    $scope.limits.checkView();
	                    $scope.view.render();
	                });
	                $attrs.$observe('locale', function (locale) { return $scope.locale = locale; });
	                $scope.$watch('locale', function (locale, previous) {
	                    if (!angular.isDefined(previous) || locale == previous)
	                        return;
	                    if (utility_1.isValidMoment($ctrl.$modelValue))
	                        utility_1.setValue($ctrl.$modelValue.locale(locale), $scope, $ctrl, $attrs);
	                    if (utility_1.isValidMoment($scope.view.moment))
	                        $scope.view.moment = $scope.view.moment.locale(locale);
	                    if (utility_1.isValidMoment($scope.limits.minDate))
	                        $scope.limits.minDate = $scope.limits.minDate.locale(locale);
	                    if (utility_1.isValidMoment($scope.limits.maxDate))
	                        $scope.limits.maxDate = $scope.limits.maxDate.locale(locale);
	                    $scope.view.render();
	                });
	                $scope.$watch('validate', $scope.limits.checkValue);
	                $scope.$watch('isOpen', function (isOpen) {
	                    if (angular.isDefined(isOpen) && isOpen != $scope.view.isOpen)
	                        $scope.view.toggle();
	                });
	                // event listeners
	                var focusInput = function (e) {
	                    if (e)
	                        e.preventDefault();
	                    $scope.input[0].focus();
	                };
	                $scope.input
	                    .on('focus click', function () { return $scope.$evalAsync($scope.view.open); })
	                    .on('blur', function () { return $scope.$evalAsync($scope.view.close); })
	                    .on('keydown', function (e) { return $scope.keyboard && $scope.$evalAsync(function () { return $scope.view.keydown(e); }); });
	                $scope.contents.on('mousedown', function () { return focusInput(); });
	                $scope.container.on('mousedown', function (e) { return focusInput(e); });
	                angular.element(_this.$window).on('resize scroll', $scope.view.position);
	            });
	        };
	    }
	    return Directive;
	}());
	exports.__esModule = true;
	exports["default"] = Directive;


/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = moment;

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Offset getter method from jQuery: https://github.com/jquery/jquery/blob/3.1.1/src/offset.js#L78
	 */
	exports.getOffset = function (element) {
	    if (!element)
	        return;
	    if (!element.getClientRects().length)
	        return { top: 0, left: 0 };
	    // https://github.com/jquery/jquery/blob/3.1.1/src/core.js#L220
	    var isWindow = function (obj) { return obj != null && obj === obj.window; };
	    var getWindow = function (elem) { return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView; }; // tslint:disable-line:no-any
	    var rect = element.getBoundingClientRect();
	    if (!rect.width && !rect.height)
	        return rect;
	    var doc = element.ownerDocument;
	    var win = getWindow(doc);
	    var docElem = doc.documentElement;
	    return {
	        top: rect.top + win.pageYOffset - docElem.clientTop,
	        left: rect.left + win.pageXOffset - docElem.clientLeft
	    };
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var decadeView_1 = __webpack_require__(8);
	exports.DecadeView = decadeView_1["default"];
	var yearView_1 = __webpack_require__(10);
	exports.YearView = yearView_1["default"];
	var monthView_1 = __webpack_require__(11);
	exports.MonthView = monthView_1["default"];
	var dayView_1 = __webpack_require__(12);
	exports.DayView = dayView_1["default"];
	var hourView_1 = __webpack_require__(13);
	exports.HourView = hourView_1["default"];
	var minuteView_1 = __webpack_require__(14);
	exports.MinuteView = minuteView_1["default"];


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utility_1 = __webpack_require__(9);
	var DecadeView = (function () {
	    function DecadeView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = 4;
	        this.rows = {};
	    }
	    DecadeView.prototype.render = function () {
	        var year = this.$scope.view.moment.clone(), firstYear = Math.floor(year.year() / 10) * 10 - 1;
	        this.rows = {};
	        year.year(firstYear);
	        for (var y = 0; y < 12; y++) {
	            var index = Math.floor(y / this.perLine), selectable = this.$scope.limits.isSelectable(year, 'year');
	            if (!this.rows[index])
	                this.rows[index] = [];
	            this.rows[index].push({
	                index: year.year(),
	                label: year.format(this.provider.yearsFormat),
	                year: year.year(),
	                "class": [
	                    this.$scope.keyboard && year.isSame(this.$scope.view.moment, 'year') ? 'highlighted' : '',
	                    !selectable || [0, 11].indexOf(y) >= 0 ? 'disabled' : utility_1.isValidMoment(this.$ctrl.$modelValue) && year.isSame(this.$ctrl.$modelValue, 'year') ? 'selected' : ''
	                ].join(' ').trim(),
	                selectable: selectable
	            });
	            year.add(1, 'years');
	        }
	        // return title
	        return [year.subtract(2, 'years').format('YYYY'), year.subtract(9, 'years').format('YYYY')].reverse().join(' - ');
	    };
	    DecadeView.prototype.set = function (year) {
	        if (!year.selectable)
	            return;
	        this.$scope.view.moment.year(year.year);
	        this.$scope.view.update();
	        this.$scope.view.change('year');
	    };
	    return DecadeView;
	}());
	exports.__esModule = true;
	exports["default"] = DecadeView;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(2);
	var moment = __webpack_require__(5);
	exports.KEYS = { up: 38, down: 40, left: 37, right: 39, escape: 27, enter: 13 };
	exports.isValidMoment = function (value) {
	    return moment.isMoment(value) && value.isValid();
	};
	exports.toValue = function (date, format, locale) {
	    var momentDate = date;
	    if (!exports.isValidMoment(date))
	        momentDate = exports.toMoment(date, format, locale);
	    return exports.momentToValue(momentDate, format);
	};
	exports.toMoment = function (date, format, locale) {
	    var momentDate = moment(date, format, locale);
	    if (!exports.isValidMoment(momentDate))
	        momentDate = undefined;
	    return momentDate;
	};
	exports.momentToValue = function (momentObject, format) {
	    if (!exports.isValidMoment(momentObject))
	        return undefined;
	    return !format ? momentObject.valueOf() : momentObject.format(format);
	};
	exports.valueToMoment = function (formattedValue, $scope) {
	    var momentValue;
	    if (!formattedValue)
	        return momentValue;
	    if (!$scope.format)
	        momentValue = moment(formattedValue);
	    else
	        momentValue = moment(formattedValue, $scope.format, $scope.locale);
	    if ($scope.model) {
	        // set value for each view precision (from Decade View to minView)
	        var views = $scope.views.all.slice(0, $scope.views.all.indexOf($scope.minView));
	        angular.forEach(views, function (view) {
	            var precision = $scope.views.precisions[view];
	            momentValue[precision]($scope.model[precision]());
	        });
	    }
	    return momentValue;
	};
	exports.setValue = function (value, $scope, $ctrl, $attrs) {
	    var modelValue = exports.isValidMoment(value) ? value.clone() : exports.valueToMoment(value, $scope), viewValue = exports.momentToValue(modelValue, $scope.format);
	    exports.updateMoment($scope.model, modelValue, $scope);
	    exports.updateMoment($ctrl.$modelValue, modelValue, $scope);
	    if ($attrs['ngModel'] != $attrs['momentPicker'])
	        $scope.value = viewValue;
	    if ($attrs['ngModel']) {
	        $ctrl.$setViewValue(viewValue);
	        $ctrl.$render(); // render input value
	    }
	};
	exports.updateMoment = function (model, value, $scope) {
	    if (!exports.isValidMoment(model) || !value)
	        model = value;
	    else {
	        if (!model.isSame(value)) {
	            // set value for each view precision (from Decade View to maxView)
	            var views = $scope.views.all.slice(0, $scope.views.all.indexOf($scope.maxView) + 1);
	            angular.forEach(views, function (view) {
	                var precision = $scope.views.precisions[view];
	                model[precision](value[precision]());
	            });
	        }
	    }
	    return model;
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(5);
	var utility_1 = __webpack_require__(9);
	var YearView = (function () {
	    function YearView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = 4;
	        this.rows = {};
	    }
	    YearView.prototype.render = function () {
	        var _this = this;
	        var month = this.$scope.view.moment.clone().startOf('year'), months = moment.monthsShort();
	        this.rows = {};
	        months.forEach(function (label, i) {
	            var index = Math.floor(i / _this.perLine), selectable = _this.$scope.limits.isSelectable(month, 'month');
	            if (!_this.rows[index])
	                _this.rows[index] = [];
	            _this.rows[index].push({
	                index: month.month(),
	                label: month.format(_this.provider.monthsFormat),
	                year: month.year(),
	                month: month.month(),
	                "class": [
	                    _this.$scope.keyboard && month.isSame(_this.$scope.view.moment, 'month') ? 'highlighted' : '',
	                    !selectable ? 'disabled' : utility_1.isValidMoment(_this.$ctrl.$modelValue) && month.isSame(_this.$ctrl.$modelValue, 'month') ? 'selected' : ''
	                ].join(' ').trim(),
	                selectable: selectable
	            });
	            month.add(1, 'months');
	        });
	        // return title
	        return this.$scope.view.moment.format('YYYY');
	    };
	    YearView.prototype.set = function (month) {
	        if (!month.selectable)
	            return;
	        this.$scope.view.moment.year(month.year).month(month.month);
	        this.$scope.view.update();
	        this.$scope.view.change('month');
	    };
	    return YearView;
	}());
	exports.__esModule = true;
	exports["default"] = YearView;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(2);
	var moment = __webpack_require__(5);
	var utility_1 = __webpack_require__(9);
	var MonthView = (function () {
	    function MonthView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = moment.weekdays().length;
	        this.rows = [];
	    }
	    MonthView.prototype.render = function () {
	        var _this = this;
	        var month = this.$scope.view.moment.month(), day = this.$scope.view.moment.clone().startOf('month').startOf('week').hour(12), rows = {}, firstWeek = day.week(), lastWeek = firstWeek + 5;
	        this.rows = [];
	        for (var week = firstWeek; week <= lastWeek; week++)
	            rows[week] = Array.apply(null, Array(this.perLine)).map(function () {
	                var selectable = _this.$scope.limits.isSelectable(day, 'day');
	                var date = {
	                    index: day.date(),
	                    label: day.format(_this.provider.daysFormat),
	                    year: day.year(),
	                    month: day.month(),
	                    date: day.date(),
	                    "class": [
	                        _this.$scope.keyboard && day.isSame(_this.$scope.view.moment, 'day') ? 'highlighted' : '',
	                        !!_this.$scope.today && day.isSame(new Date(), 'day') ? 'today' : '',
	                        !selectable || day.month() != month ? 'disabled' : utility_1.isValidMoment(_this.$ctrl.$modelValue) && day.isSame(_this.$ctrl.$modelValue, 'day') ? 'selected' : ''
	                    ].join(' ').trim(),
	                    selectable: selectable
	                };
	                day.add(1, 'days');
	                return date;
	            });
	        // object to array - see https://github.com/indrimuska/angular-moment-picker/issues/9
	        angular.forEach(rows, function (row) { return _this.rows.push(row); });
	        // render headers
	        this.headers = moment.weekdays().map(function (d, i) { return moment().locale(_this.$scope.locale).startOf('week').add(i, 'day').format('dd'); });
	        // return title
	        return this.$scope.view.moment.format('MMMM YYYY');
	    };
	    MonthView.prototype.set = function (day) {
	        if (!day.selectable)
	            return;
	        this.$scope.view.moment.year(day.year).month(day.month).date(day.date);
	        this.$scope.view.update();
	        this.$scope.view.change('day');
	    };
	    return MonthView;
	}());
	exports.__esModule = true;
	exports["default"] = MonthView;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var utility_1 = __webpack_require__(9);
	var DayView = (function () {
	    function DayView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = 4;
	        this.rows = {};
	    }
	    DayView.prototype.render = function () {
	        var hour = this.$scope.view.moment.clone().startOf('day').hour(this.provider.hoursStart);
	        this.rows = {};
	        for (var h = 0; h <= this.provider.hoursEnd - this.provider.hoursStart; h++) {
	            var index = Math.floor(h / this.perLine), selectable = this.$scope.limits.isSelectable(hour, 'hour');
	            if (!this.rows[index])
	                this.rows[index] = [];
	            this.rows[index].push({
	                index: h,
	                label: hour.format(this.provider.hoursFormat),
	                year: hour.year(),
	                month: hour.month(),
	                date: hour.date(),
	                hour: hour.hour(),
	                "class": [
	                    this.$scope.keyboard && hour.isSame(this.$scope.view.moment, 'hour') ? 'highlighted' : '',
	                    !selectable ? 'disabled' : utility_1.isValidMoment(this.$ctrl.$modelValue) && hour.isSame(this.$ctrl.$modelValue, 'hour') ? 'selected' : ''
	                ].join(' ').trim(),
	                selectable: selectable
	            });
	            hour.add(1, 'hours');
	        }
	        // return title
	        return this.$scope.view.moment.format('LL');
	    };
	    DayView.prototype.set = function (hour) {
	        if (!hour.selectable)
	            return;
	        this.$scope.view.moment.year(hour.year).month(hour.month).date(hour.date).hour(hour.hour);
	        this.$scope.view.update();
	        this.$scope.view.change('hour');
	    };
	    return DayView;
	}());
	exports.__esModule = true;
	exports["default"] = DayView;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(2);
	var moment = __webpack_require__(5);
	var utility_1 = __webpack_require__(9);
	var HourView = (function () {
	    function HourView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = 4;
	        this.rows = {};
	    }
	    HourView.prototype.render = function () {
	        var i = 0, minute = this.$scope.view.moment.clone().startOf('hour').minute(this.provider.minutesStart), minutesFormat = this.provider.minutesFormat || moment.localeData(this.$scope.locale).longDateFormat('LT').replace(/[aA]/, '').trim();
	        this.rows = {};
	        for (var m = 0; m <= this.provider.minutesEnd - this.provider.minutesStart; m += this.provider.minutesStep) {
	            var index = Math.floor(i / this.perLine), selectable = this.$scope.limits.isSelectable(minute, 'minute');
	            if (!this.rows[index])
	                this.rows[index] = [];
	            this.rows[index].push({
	                index: minute.minute(),
	                label: minute.format(minutesFormat),
	                year: minute.year(),
	                month: minute.month(),
	                date: minute.date(),
	                hour: minute.hour(),
	                minute: minute.minute(),
	                "class": [
	                    this.$scope.keyboard && minute.isSame(this.$scope.view.moment, 'minute') ? 'highlighted' : '',
	                    !selectable ? 'disabled' : utility_1.isValidMoment(this.$ctrl.$modelValue) && minute.isSame(this.$ctrl.$modelValue, 'minute') ? 'selected' : ''
	                ].join(' ').trim(),
	                selectable: selectable
	            });
	            i++;
	            minute.add(this.provider.minutesStep, 'minutes');
	        }
	        if (this.$scope.keyboard)
	            this.highlightClosest();
	        // return title
	        return this.$scope.view.moment.clone().startOf('hour').format('lll');
	    };
	    HourView.prototype.set = function (minute) {
	        if (!minute.selectable)
	            return;
	        this.$scope.view.moment.year(minute.year).month(minute.month).date(minute.date).hour(minute.hour).minute(minute.minute);
	        this.$scope.view.update();
	        this.$scope.view.change('minute');
	    };
	    HourView.prototype.highlightClosest = function () {
	        var _this = this;
	        var minutes = [], minute;
	        angular.forEach(this.rows, function (row) {
	            angular.forEach(row, function (value) {
	                if (Math.abs(value.minute - _this.$scope.view.moment.minute()) < _this.provider.minutesStep)
	                    minutes.push(value);
	            });
	        });
	        minute = minutes.sort(function (value1, value2) {
	            return Math.abs(value1.minute - _this.$scope.view.moment.minute()) > Math.abs(value2.minute - _this.$scope.view.moment.minute()) ? 1 : 0;
	        })[0];
	        if (!minute || minute.minute - this.$scope.view.moment.minute() == 0)
	            return;
	        this.$scope.view.moment.year(minute.year).month(minute.month).date(minute.date).hour(minute.hour).minute(minute.minute);
	        this.$scope.view.update();
	        if (minute.selectable)
	            minute["class"] = (minute["class"] + ' highlighted').trim();
	    };
	    return HourView;
	}());
	exports.__esModule = true;
	exports["default"] = HourView;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(2);
	var utility_1 = __webpack_require__(9);
	var MinuteView = (function () {
	    function MinuteView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = 6;
	        this.rows = {};
	    }
	    MinuteView.prototype.render = function () {
	        var i = 0, second = this.$scope.view.moment.clone().startOf('minute').second(this.provider.secondsStart);
	        this.rows = {};
	        for (var s = 0; s <= this.provider.secondsEnd - this.provider.secondsStart; s += this.provider.secondsStep) {
	            var index = Math.floor(i / this.perLine), selectable = this.$scope.limits.isSelectable(second, 'second');
	            if (!this.rows[index])
	                this.rows[index] = [];
	            this.rows[index].push({
	                index: second.second(),
	                label: second.format(this.provider.secondsFormat),
	                year: second.year(),
	                month: second.month(),
	                date: second.date(),
	                hour: second.hour(),
	                minute: second.minute(),
	                second: second.second(),
	                "class": [
	                    this.$scope.keyboard && second.isSame(this.$scope.view.moment, 'second') ? 'highlighted' : '',
	                    !selectable ? 'disabled' : utility_1.isValidMoment(this.$ctrl.$modelValue) && second.isSame(this.$ctrl.$modelValue, 'second') ? 'selected' : ''
	                ].join(' ').trim(),
	                selectable: selectable
	            });
	            i++;
	            second.add(this.provider.secondsStep, 'seconds');
	        }
	        if (this.$scope.keyboard)
	            this.highlightClosest();
	        // return title
	        return this.$scope.view.moment.clone().startOf('minute').format('lll');
	    };
	    MinuteView.prototype.set = function (second) {
	        if (!second.selectable)
	            return;
	        this.$scope.view.moment.year(second.year).month(second.month).date(second.date).hour(second.hour).minute(second.minute).second(second.second);
	        this.$scope.view.update();
	        this.$scope.view.change();
	    };
	    MinuteView.prototype.highlightClosest = function () {
	        var _this = this;
	        var seconds = [], second;
	        angular.forEach(this.rows, function (row) {
	            angular.forEach(row, function (value) {
	                if (Math.abs(value.second - _this.$scope.view.moment.second()) < _this.provider.secondsStep)
	                    seconds.push(value);
	            });
	        });
	        second = seconds.sort(function (value1, value2) {
	            return Math.abs(value1.second - _this.$scope.view.moment.second()) > Math.abs(value2.second - _this.$scope.view.moment.second()) ? 1 : 0;
	        })[0];
	        if (!second || second.second - this.$scope.view.moment.second() == 0)
	            return;
	        this.$scope.view.moment.year(second.year).month(second.month).date(second.date).hour(second.hour).minute(second.minute).second(second.second);
	        this.$scope.view.update();
	        if (second.selectable)
	            second["class"] = (second["class"] + ' highlighted').trim();
	    };
	    return MinuteView;
	}());
	exports.__esModule = true;
	exports["default"] = MinuteView;


/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = "<div class=moment-picker> <span class=moment-picker-contents></span> <div class=\"moment-picker-container {{view.selected}}-view\" ng-show=\"view.isOpen && !disabled\" ng-class=\"{'moment-picker-disabled': disabled, 'open': view.isOpen}\"> <div ng-if=additions.top ng-include=additions.top></div> <table class=header-view ng-if=showHeader> <thead> <tr> <th ng-class=\"{disabled: !view.previous.selectable}\" ng-bind-html=view.previous.label ng-click=view.previous.set()></th> <th ng-bind=view.title ng-click=view.setParentView()></th> <th ng-class=\"{disabled: !view.next.selectable}\" ng-bind-html=view.next.label ng-click=view.next.set()></th> </tr> </thead> </table> <div class=moment-picker-specific-views> <table> <thead ng-if=views[view.selected].headers> <tr> <th ng-repeat=\"header in views[view.selected].headers\" ng-bind=header></th> </tr> </thead> <tbody> <tr ng-repeat=\"row in views[view.selected].rows\"> <td ng-repeat=\"item in row track by item.index\" ng-class=item.class ng-bind=item.label ng-click=views[view.selected].set(item)></td> </tr> </tbody> </table> </div> <div ng-if=additions.bottom ng-include=additions.bottom></div> </div> </div>";

/***/ },
/* 16 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
/******/ ]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 600 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.7.7
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');
var bind;
var extend;
var forEach;
var isArray;
var isDefined;
var lowercase;
var noop;
var nodeContains;
var htmlParser;
var htmlSanitizeWriter;

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The whitelist for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link $compileProvider}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */


/**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
function $SanitizeProvider() {
  var hasBeenInstantiated = false;
  var svgEnabled = false;

  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    hasBeenInstantiated = true;
    if (svgEnabled) {
      extend(validElements, svgElements);
    }
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];


  /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
  this.enableSvg = function(enableSvg) {
    if (isDefined(enableSvg)) {
      svgEnabled = enableSvg;
      return this;
    } else {
      return svgEnabled;
    }
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidElements
   * @kind function
   *
   * @description
   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
   * and are not stripped off during sanitization. You can extend the following lists of elements:
   *
   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
   *   elements. HTML elements considered safe will not be removed during sanitization. All other
   *   elements will be stripped off.
   *
   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
   *   "void elements" (similar to HTML
   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
   *   elements have no end tag and cannot have content.
   *
   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
   *   `$sanitize`.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the elements you add.
   * </div>
   *
   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
   *   more of the following properties:
   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     HTML elements.
   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     void HTML elements; i.e. elements that do not have an end tag.
   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
   *     elements. The list of SVG elements is only taken into account if SVG is
   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
   *
   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
   *
   * @return {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidElements = function(elements) {
    if (!hasBeenInstantiated) {
      if (isArray(elements)) {
        elements = {htmlElements: elements};
      }

      addElementsTo(svgElements, elements.svgElements);
      addElementsTo(voidElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlElements);
    }

    return this;
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidAttrs
   * @kind function
   *
   * @description
   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
   * not stripped off during sanitization.
   *
   * **Note**:
   * The new attributes will not be treated as URI attributes, which means their values will not be
   * sanitized as URIs using `$compileProvider`'s
   * {@link ng.$compileProvider#aHrefSanitizationWhitelist aHrefSanitizationWhitelist} and
   * {@link ng.$compileProvider#imgSrcSanitizationWhitelist imgSrcSanitizationWhitelist}.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the attributes you add.
   * </div>
   *
   * @param {Array<String>} attrs - A list of valid attributes.
   *
   * @returns {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidAttrs = function(attrs) {
    if (!hasBeenInstantiated) {
      extend(validAttrs, arrayToMap(attrs, true));
    }
    return this;
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Private stuff
  //////////////////////////////////////////////////////////////////////////////////////////////////

  bind = angular.bind;
  extend = angular.extend;
  forEach = angular.forEach;
  isArray = angular.isArray;
  isDefined = angular.isDefined;
  lowercase = angular.$$lowercase;
  noop = angular.noop;

  htmlParser = htmlParserImpl;
  htmlSanitizeWriter = htmlSanitizeWriterImpl;

  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
    // eslint-disable-next-line no-bitwise
    return !!(this.compareDocumentPosition(arg) & 16);
  };

  // Regular Expressions for parsing tags and attributes
  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;


  // Good source of info about elements and attributes
  // http://dev.w3.org/html5/spec/Overview.html#semantics
  // http://simon.html5.org/html-elements

  // Safe Void Elements - HTML5
  // http://dev.w3.org/html5/spec/Overview.html#void-elements
  var voidElements = stringToMap('area,br,col,hr,img,wbr');

  // Elements that you can, intentionally, leave open (and which close themselves)
  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
      optionalEndTagInlineElements = stringToMap('rp,rt'),
      optionalEndTagElements = extend({},
                                              optionalEndTagInlineElements,
                                              optionalEndTagBlockElements);

  // Safe Block Elements - HTML5
  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));

  // Inline Elements - HTML5
  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));

  // SVG Elements
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
  // They can potentially allow for arbitrary javascript to be executed. See #11290
  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
          'radialGradient,rect,stop,svg,switch,text,title,tspan');

  // Blocked Elements (will be stripped)
  var blockedElements = stringToMap('script,style');

  var validElements = extend({},
                                     voidElements,
                                     blockElements,
                                     inlineElements,
                                     optionalEndTagElements);

  //Attributes that have href and hence need to be sanitized
  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');

  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
      'valign,value,vspace,width');

  // SVG attributes (without "id" and "name" attributes)
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

  var validAttrs = extend({},
                                  uriAttrs,
                                  svgAttrs,
                                  htmlAttrs);

  function stringToMap(str, lowercaseKeys) {
    return arrayToMap(str.split(','), lowercaseKeys);
  }

  function arrayToMap(items, lowercaseKeys) {
    var obj = {}, i;
    for (i = 0; i < items.length; i++) {
      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
    }
    return obj;
  }

  function addElementsTo(elementsMap, newElements) {
    if (newElements && newElements.length) {
      extend(elementsMap, arrayToMap(newElements));
    }
  }

  /**
   * Create an inert document that contains the dirty HTML that needs sanitizing
   * Depending upon browser support we use one of three strategies for doing this.
   * Support: Safari 10.x -> XHR strategy
   * Support: Firefox -> DomParser strategy
   */
  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
    var inertDocument;
    if (document && document.implementation) {
      inertDocument = document.implementation.createHTMLDocument('inert');
    } else {
      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
    }
    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');

    // Check for the Safari 10.1 bug - which allows JS to run inside the SVG G element
    inertBodyElement.innerHTML = '<svg><g onload="this.parentNode.remove()"></g></svg>';
    if (!inertBodyElement.querySelector('svg')) {
      return getInertBodyElement_XHR;
    } else {
      // Check for the Firefox bug - which prevents the inner img JS from being sanitized
      inertBodyElement.innerHTML = '<svg><p><style><img src="</style><img src=x onerror=alert(1)//">';
      if (inertBodyElement.querySelector('svg img')) {
        return getInertBodyElement_DOMParser;
      } else {
        return getInertBodyElement_InertDocument;
      }
    }

    function getInertBodyElement_XHR(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
      html = '<remove></remove>' + html;
      try {
        html = encodeURI(html);
      } catch (e) {
        return undefined;
      }
      var xhr = new window.XMLHttpRequest();
      xhr.responseType = 'document';
      xhr.open('GET', 'data:text/html;charset=utf-8,' + html, false);
      xhr.send(null);
      var body = xhr.response.body;
      body.firstChild.remove();
      return body;
    }

    function getInertBodyElement_DOMParser(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
      html = '<remove></remove>' + html;
      try {
        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
        body.firstChild.remove();
        return body;
      } catch (e) {
        return undefined;
      }
    }

    function getInertBodyElement_InertDocument(html) {
      inertBodyElement.innerHTML = html;

      // Support: IE 9-11 only
      // strip custom-namespaced attributes on IE<=11
      if (document.documentMode) {
        stripCustomNsAttrs(inertBodyElement);
      }

      return inertBodyElement;
    }
  })(window, window.document);

  /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
  function htmlParserImpl(html, handler) {
    if (html === null || html === undefined) {
      html = '';
    } else if (typeof html !== 'string') {
      html = '' + html;
    }

    var inertBodyElement = getInertBodyElement(html);
    if (!inertBodyElement) return '';

    //mXSS protection
    var mXSSAttempts = 5;
    do {
      if (mXSSAttempts === 0) {
        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
      }
      mXSSAttempts--;

      // trigger mXSS if it is going to happen by reading and writing the innerHTML
      html = inertBodyElement.innerHTML;
      inertBodyElement = getInertBodyElement(html);
    } while (html !== inertBodyElement.innerHTML);

    var node = inertBodyElement.firstChild;
    while (node) {
      switch (node.nodeType) {
        case 1: // ELEMENT_NODE
          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
          break;
        case 3: // TEXT NODE
          handler.chars(node.textContent);
          break;
      }

      var nextNode;
      if (!(nextNode = node.firstChild)) {
        if (node.nodeType === 1) {
          handler.end(node.nodeName.toLowerCase());
        }
        nextNode = getNonDescendant('nextSibling', node);
        if (!nextNode) {
          while (nextNode == null) {
            node = getNonDescendant('parentNode', node);
            if (node === inertBodyElement) break;
            nextNode = getNonDescendant('nextSibling', node);
            if (node.nodeType === 1) {
              handler.end(node.nodeName.toLowerCase());
            }
          }
        }
      }
      node = nextNode;
    }

    while ((node = inertBodyElement.firstChild)) {
      inertBodyElement.removeChild(node);
    }
  }

  function attrToMap(attrs) {
    var map = {};
    for (var i = 0, ii = attrs.length; i < ii; i++) {
      var attr = attrs[i];
      map[attr.name] = attr.value;
    }
    return map;
  }


  /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
  function encodeEntities(value) {
    return value.
      replace(/&/g, '&amp;').
      replace(SURROGATE_PAIR_REGEXP, function(value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
      }).
      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
  }

  /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
  function htmlSanitizeWriterImpl(buf, uriValidator) {
    var ignoreCurrentElement = false;
    var out = bind(buf, buf.push);
    return {
      start: function(tag, attrs) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && blockedElements[tag]) {
          ignoreCurrentElement = tag;
        }
        if (!ignoreCurrentElement && validElements[tag] === true) {
          out('<');
          out(tag);
          forEach(attrs, function(value, key) {
            var lkey = lowercase(key);
            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
            if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
              out(' ');
              out(key);
              out('="');
              out(encodeEntities(value));
              out('"');
            }
          });
          out('>');
        }
      },
      end: function(tag) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
          out('</');
          out(tag);
          out('>');
        }
        // eslint-disable-next-line eqeqeq
        if (tag == ignoreCurrentElement) {
          ignoreCurrentElement = false;
        }
      },
      chars: function(chars) {
        if (!ignoreCurrentElement) {
          out(encodeEntities(chars));
        }
      }
    };
  }


  /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
  function stripCustomNsAttrs(node) {
    while (node) {
      if (node.nodeType === window.Node.ELEMENT_NODE) {
        var attrs = node.attributes;
        for (var i = 0, l = attrs.length; i < l; i++) {
          var attrNode = attrs[i];
          var attrName = attrNode.name.toLowerCase();
          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
            node.removeAttributeNode(attrNode);
            i--;
            l--;
          }
        }
      }

      var nextNode = node.firstChild;
      if (nextNode) {
        stripCustomNsAttrs(nextNode);
      }

      node = getNonDescendant('nextSibling', node);
    }
  }

  function getNonDescendant(propName, node) {
    // An element is clobbered if its `propName` property points to one of its descendants
    var nextNode = node[propName];
    if (nextNode && nodeContains.call(node, nextNode)) {
      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
    }
    return nextNode;
  }
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, noop);
  writer.chars(chars);
  return buf.join('');
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', [])
  .provider('$sanitize', $SanitizeProvider)
  .info({ angularVersion: '1.7.7' });

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  var linkyMinErr = angular.$$minErr('linky');
  var isDefined = angular.isDefined;
  var isFunction = angular.isFunction;
  var isObject = angular.isObject;
  var isString = angular.isString;

  return function(text, target, attributes) {
    if (text == null || text === '') return text;
    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

    var attributesFn =
      isFunction(attributes) ? attributes :
      isObject(attributes) ? function getAttributesObject() {return attributes;} :
      function getEmptyAttributesObject() {return {};};

    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      var key, linkAttributes = attributesFn(url);
      html.push('<a ');

      for (key in linkAttributes) {
        html.push(key + '="' + linkAttributes[key] + '" ');
      }

      if (isDefined(target) && !('target' in linkAttributes)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(600);
module.exports = 'ngSanitize';


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, humanizeDuration) {/**
 * angular-timer - v1.3.5 - 2017-03-09 2:18 PM
 * https://github.com/siddii/angular-timer
 *
 * Copyright (c) 2017 Adrian Wardell
 * Licensed MIT <https://github.com/siddii/angular-timer/blob/master/LICENSE.txt>
 */
var timerModule = angular.module('timer', [])
  .directive('timer', ['$compile', function ($compile) {
    return  {
      restrict: 'EA',
      replace: false,
      scope: {
        interval: '=interval',
        startTimeAttr: '=startTime',
        endTimeAttr: '=endTime',
        countdownattr: '=countdown',
        finishCallback: '&finishCallback',
        autoStart: '&autoStart',
        language: '@?',
        fallback: '@?',
        maxTimeUnit: '=',
        seconds: '=?',
        minutes: '=?',
        hours: '=?',
        days: '=?',
        months: '=?',
        years: '=?',
        secondsS: '=?',
        minutesS: '=?',
        hoursS: '=?',
        daysS: '=?',
        monthsS: '=?',
        yearsS: '=?'
      },
      controller: ['$scope', '$element', '$attrs', '$timeout', 'I18nService', '$interpolate', 'progressBarService', function ($scope, $element, $attrs, $timeout, I18nService, $interpolate, progressBarService) {

        // Checking for trim function since IE8 doesn't have it
        // If not a function, create tirm with RegEx to mimic native trim
        if (typeof String.prototype.trim !== 'function') {
          String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/g, '');
          };
        }

        //angular 1.2 doesn't support attributes ending in "-start", so we're
        //supporting both "autostart" and "auto-start" as a solution for
        //backward and forward compatibility.
        $scope.autoStart = $attrs.autoStart || $attrs.autostart;


        $scope.language = $scope.language || 'en';
        $scope.fallback = $scope.fallback || 'en';

        //allow to change the language of the directive while already launched
        $scope.$watch('language', function(newVal, oldVal) {
          if(newVal !== undefined) {
            i18nService.init(newVal, $scope.fallback);
          }
        });

        //init momentJS i18n, default english
        var i18nService = new I18nService();
        i18nService.init($scope.language, $scope.fallback);

        //progress bar
        $scope.displayProgressBar = 0;
        $scope.displayProgressActive = 'active'; //Bootstrap active effect for progress bar

        if ($element.html().trim().length === 0) {
          $element.append($compile('<span>' + $interpolate.startSymbol() + 'millis' + $interpolate.endSymbol() + '</span>')($scope));
        } else {
          $element.append($compile($element.contents())($scope));
        }

        $scope.startTime = null;
        $scope.endTime = null;
        $scope.timeoutId = null;
        $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) >= 0 ? parseInt($scope.countdownattr, 10) : undefined;
        $scope.isRunning = false;

        $scope.$on('timer-start', function () {
          $scope.start();
        });

        $scope.$on('timer-resume', function () {
          $scope.resume();
        });

        $scope.$on('timer-stop', function () {
          $scope.stop();
        });

        $scope.$on('timer-clear', function () {
          $scope.clear();
        });

        $scope.$on('timer-reset', function () {
          $scope.reset();
        });

        $scope.$on('timer-set-countdown', function (e, countdown) {
          $scope.countdown = countdown;
        });

        function resetTimeout() {
          if ($scope.timeoutId) {
            clearTimeout($scope.timeoutId);
          }
        }

        $scope.$watch('startTimeAttr', function(newValue, oldValue) {
          if (newValue !== oldValue && $scope.isRunning) {
            $scope.start();
          }
        });

        $scope.$watch('endTimeAttr', function(newValue, oldValue) {
          if (newValue !== oldValue && $scope.isRunning) {
            $scope.start();
          }
        });

        $scope.start = function () {
          $scope.startTime = $scope.startTimeAttr ? moment($scope.startTimeAttr) : moment();
          $scope.endTime = $scope.endTimeAttr ? moment($scope.endTimeAttr) : null;
          if (!angular.isNumber($scope.countdown)) {
            $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) > 0 ? parseInt($scope.countdownattr, 10) : undefined;
          }
          resetTimeout();
          tick();
          $scope.isRunning = true;
          $scope.$emit('timer-started', {
            timeoutId: $scope.timeoutId,
            millis: $scope.millis,
            seconds: $scope.seconds,
            minutes: $scope.minutes,
            hours: $scope.hours,
            days: $scope.days
          });
        };

        $scope.resume = function () {
          resetTimeout();
          if ($scope.countdownattr) {
            $scope.countdown += 1;
          }
          $scope.startTime = moment().diff((moment($scope.stoppedTime).diff(moment($scope.startTime))));
          tick();
          $scope.isRunning = true;
          $scope.$emit('timer-started', {
            timeoutId: $scope.timeoutId,
            millis: $scope.millis,
            seconds: $scope.seconds,
            minutes: $scope.minutes,
            hours: $scope.hours,
            days: $scope.days
          });
        };

        $scope.stop = $scope.pause = function () {
          var timeoutId = $scope.timeoutId;
          $scope.clear();
          $scope.$emit('timer-stopped', {
            timeoutId: timeoutId,
            millis: $scope.millis,
            seconds: $scope.seconds,
            minutes: $scope.minutes,
            hours: $scope.hours,
            days: $scope.days
          });
        };

        $scope.clear = function () {
          // same as stop but without the event being triggered
          $scope.stoppedTime = moment();
          resetTimeout();
          $scope.timeoutId = null;
          $scope.isRunning = false;
        };

        $scope.reset = function () {
          $scope.startTime = $scope.startTimeAttr ? moment($scope.startTimeAttr) : moment();
          $scope.endTime = $scope.endTimeAttr ? moment($scope.endTimeAttr) : null;
          $scope.countdown = angular.isNumber($scope.countdownattr) && parseInt($scope.countdownattr, 10) > 0 ? parseInt($scope.countdownattr, 10) : undefined;
          resetTimeout();
          tick();
          $scope.isRunning = false;
          $scope.clear();
          $scope.$emit('timer-reset', {
            timeoutId: timeoutId,
            millis: $scope.millis,
            seconds: $scope.seconds,
            minutes: $scope.minutes,
            hours: $scope.hours,
            days: $scope.days
          });
        };

        $element.bind('$destroy', function () {
          resetTimeout();
          $scope.isRunning = false;
        });


        function calculateTimeUnits() {
          var timeUnits = {}; //will contains time with units

          if ($attrs.startTime !== undefined){
            $scope.millis = moment().diff(moment($scope.startTimeAttr));
          }

          timeUnits = i18nService.getTimeUnits($scope.millis);

          // compute time values based on maxTimeUnit specification
          if (!$scope.maxTimeUnit || $scope.maxTimeUnit === 'day') {
            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
            $scope.days = Math.floor((($scope.millis / (3600000)) / 24));
            $scope.months = 0;
            $scope.years = 0;
          } else if ($scope.maxTimeUnit === 'second') {
            $scope.seconds = Math.floor($scope.millis / 1000);
            $scope.minutes = 0;
            $scope.hours = 0;
            $scope.days = 0;
            $scope.months = 0;
            $scope.years = 0;
          } else if ($scope.maxTimeUnit === 'minute') {
            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
            $scope.minutes = Math.floor($scope.millis / 60000);
            $scope.hours = 0;
            $scope.days = 0;
            $scope.months = 0;
            $scope.years = 0;
          } else if ($scope.maxTimeUnit === 'hour') {
            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
            $scope.hours = Math.floor($scope.millis / 3600000);
            $scope.days = 0;
            $scope.months = 0;
            $scope.years = 0;
          } else if ($scope.maxTimeUnit === 'month') {
            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
            $scope.days = Math.floor((($scope.millis / (3600000)) / 24) % 30);
            $scope.months = Math.floor((($scope.millis / (3600000)) / 24) / 30);
            $scope.years = 0;
          } else if ($scope.maxTimeUnit === 'year') {
            $scope.seconds = Math.floor(($scope.millis / 1000) % 60);
            $scope.minutes = Math.floor((($scope.millis / (60000)) % 60));
            $scope.hours = Math.floor((($scope.millis / (3600000)) % 24));
            $scope.days = Math.floor((($scope.millis / (3600000)) / 24) % 30);
            $scope.months = Math.floor((($scope.millis / (3600000)) / 24 / 30) % 12);
            $scope.years = Math.floor(($scope.millis / (3600000)) / 24 / 365);
          }
          // plural - singular unit decision (old syntax, for backwards compatibility and English only, could be deprecated!)
          $scope.secondsS = ($scope.seconds === 1) ? '' : 's';
          $scope.minutesS = ($scope.minutes === 1) ? '' : 's';
          $scope.hoursS = ($scope.hours === 1) ? '' : 's';
          $scope.daysS = ($scope.days === 1)? '' : 's';
          $scope.monthsS = ($scope.months === 1)? '' : 's';
          $scope.yearsS = ($scope.years === 1)? '' : 's';


          // new plural-singular unit decision functions (for custom units and multilingual support)
          $scope.secondUnit = timeUnits.seconds;
          $scope.minuteUnit = timeUnits.minutes;
          $scope.hourUnit = timeUnits.hours;
          $scope.dayUnit = timeUnits.days;
          $scope.monthUnit = timeUnits.months;
          $scope.yearUnit = timeUnits.years;

          //add leading zero if number is smaller than 10
          $scope.sseconds = $scope.seconds < 10 ? '0' + $scope.seconds : $scope.seconds;
          $scope.mminutes = $scope.minutes < 10 ? '0' + $scope.minutes : $scope.minutes;
          $scope.hhours = $scope.hours < 10 ? '0' + $scope.hours : $scope.hours;
          $scope.ddays = $scope.days < 10 ? '0' + $scope.days : $scope.days;
          $scope.mmonths = $scope.months < 10 ? '0' + $scope.months : $scope.months;
          $scope.yyears = $scope.years < 10 ? '0' + $scope.years : $scope.years;

        }

        //determine initial values of time units and add AddSeconds functionality
        if ($scope.countdownattr) {
          $scope.millis = $scope.countdownattr * 1000;

          $scope.addCDSeconds = function (extraSeconds) {
            $scope.countdown += extraSeconds;
            if (!$scope.isRunning) {
              $scope.start();
            }
          };

          $scope.$on('timer-add-cd-seconds', function (e, extraSeconds) {
             $scope.addCDSeconds(extraSeconds);
          });

          $scope.$on('timer-set-countdown-seconds', function (e, countdownSeconds) {
            if (!$scope.isRunning) {
              $scope.clear();
            }

            $scope.countdown = countdownSeconds;
            $scope.millis = countdownSeconds * 1000;
            calculateTimeUnits();
          });
        } else {
          $scope.millis = 0;
        }
        calculateTimeUnits();

        var tick = function tick() {
          var typeTimer = null; // countdown or endTimeAttr
          $scope.millis = moment().diff($scope.startTime);
          var adjustment = $scope.millis % 1000;

          if ($scope.endTimeAttr) {
            typeTimer = $scope.endTimeAttr;
            $scope.millis = moment($scope.endTime).diff(moment());
            adjustment = $scope.interval - $scope.millis % 1000;
          }

          if ($scope.countdownattr) {
            typeTimer = $scope.countdownattr;
            $scope.millis = $scope.countdown * 1000;
          }

          if ($scope.millis < 0) {
            $scope.stop();
            $scope.millis = 0;
            calculateTimeUnits();
            if($scope.finishCallback) {
              $scope.$eval($scope.finishCallback);
            }
            return;
          }
          calculateTimeUnits();

          //We are not using $timeout for a reason. Please read here - https://github.com/siddii/angular-timer/pull/5
          $scope.timeoutId = setTimeout(function () {
              tick();
              // since you choose not to use $timeout, at least preserve angular cycle two way data binding
              // by calling $scope.$apply() instead of $scope.$digest()
              $scope.$apply();
          }, $scope.interval - adjustment);

          $scope.$emit('timer-tick', {
            timeoutId: $scope.timeoutId,
            millis: $scope.millis,
            seconds: $scope.seconds,
            minutes: $scope.minutes,
            hours: $scope.hours,
            days: $scope.days
          });

          if ($scope.countdown > 0) {
            $scope.countdown--;
          }
          else if ($scope.countdown <= 0) {
            $scope.stop();
            if($scope.finishCallback) {
              $scope.$eval($scope.finishCallback);
            }
          }

          if(typeTimer !== null){
            //calculate progress bar
            $scope.progressBar = progressBarService.calculateProgressBar($scope.startTime, $scope.millis, $scope.endTime, $scope.countdownattr);

            if($scope.progressBar === 100){
              $scope.displayProgressActive = ''; //No more Bootstrap active effect
            }
          }
        };

        if ($scope.autoStart === undefined || $scope.autoStart === true) {
          $scope.start();
        }
      }]
    };
  }])
  .directive('timerControls', function() {
    return {
      restrict: 'EA',
      scope: true,
      controller: ['$scope', function($scope) {
        $scope.timerStatus = "reset";
        $scope.$on('timer-started', function() {
          $scope.timerStatus = "started";
        });
        $scope.$on('timer-stopped', function() {
          $scope.timerStatus = "stopped";
        });
        $scope.$on('timer-reset', function() {
          $scope.timerStatus = "reset";
        });
        $scope.timerStart = function() {
          $scope.$broadcast('timer-start');
        };
        $scope.timerStop = function() {
          $scope.$broadcast('timer-stop');
        };
        $scope.timerResume = function() {
          $scope.$broadcast('timer-resume');
        };
        $scope.timerToggle = function() {
          switch ($scope.timerStatus) {
            case "started":
              $scope.timerStop();
              break;
            case "stopped":
              $scope.timerResume();
              break;
            case "reset":
              $scope.timerStart();
              break;
          }
        };
        $scope.timerAddCDSeconds = function(extraSeconds) {
          $scope.$broadcast('timer-add-cd-seconds', extraSeconds);
        };
      }]
    };
  });

/* commonjs package manager support (eg componentjs) */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
  module.exports = timerModule;
}

var app = angular.module('timer');

app.factory('I18nService', function() {

    var I18nService = function() {};

    I18nService.prototype.language = 'en';
    I18nService.prototype.fallback = 'en';
    I18nService.prototype.timeHumanizer = {};

    I18nService.prototype.init = function init(lang, fallback) {
        var supported_languages = humanizeDuration.getSupportedLanguages();

        this.fallback = (fallback !== undefined) ? fallback : 'en';
        if (supported_languages.indexOf(fallback) === -1) {
            this.fallback = 'en';
        }

        this.language = lang;
        if (supported_languages.indexOf(lang) === -1) {
            this.language = this.fallback;
        }

        // It should be handle by the user's application itself, and not inside the directive
        // moment init
        // moment.locale(this.language);

        //human duration init, using it because momentjs does not allow accurate time (
        // momentJS: a few moment ago, human duration : 4 seconds ago
        this.timeHumanizer = humanizeDuration.humanizer({
            language: this.language,
            halfUnit:false
        });
    };

    /**
     * get time with units from momentJS i18n
     * @param {int} millis
     * @returns {{millis: string, seconds: string, minutes: string, hours: string, days: string, months: string, years: string}}
     */
    I18nService.prototype.getTimeUnits = function getTimeUnits(millis) {
        var diffFromAlarm = Math.round(millis/1000) * 1000; //time in milliseconds, get rid of the last 3 ms value to avoid 2.12 seconds display

        var time = {};

        if (typeof this.timeHumanizer != 'undefined'){
            time = {
                'millis' : this.timeHumanizer(diffFromAlarm, { units: ["ms"] }),
                'seconds' : this.timeHumanizer(diffFromAlarm, { units: ["s"] }),
                'minutes' : this.timeHumanizer(diffFromAlarm, { units: ["m", "s"] }) ,
                'hours' : this.timeHumanizer(diffFromAlarm, { units: ["h", "m", "s"] }) ,
                'days' : this.timeHumanizer(diffFromAlarm, { units: ["d", "h", "m", "s"] }) ,
                'months' : this.timeHumanizer(diffFromAlarm, { units: ["mo", "d", "h", "m", "s"] }) ,
                'years' : this.timeHumanizer(diffFromAlarm, { units: ["y", "mo", "d", "h", "m", "s"] })
            };
        }
        else {
            console.error('i18nService has not been initialized. You must call i18nService.init("en") for example');
        }

        return time;
    };

    return I18nService;
});

var app = angular.module('timer');

app.factory('progressBarService', function() {

  var ProgressBarService = function() {};

  /**
   * calculate the remaining time in a progress bar in percentage
   * @param {momentjs} startValue in seconds
   * @param {integer} currentCountdown, where are we in the countdown
   * @param {integer} remainingTime, remaining milliseconds
   * @param {integer} endTime, end time, can be undefined
   * @param {integer} coutdown, original coutdown value, can be undefined
   *
   * joke : https://www.youtube.com/watch?v=gENVB6tjq_M
   * @return {float} 0 --> 100
   */
  ProgressBarService.prototype.calculateProgressBar = function calculateProgressBar(startValue, remainingTime, endTimeAttr, coutdown) {
    var displayProgressBar = 0,
      endTimeValue,
      initialCountdown;

    remainingTime = remainingTime / 1000; //seconds


    if(endTimeAttr !== null){
      endTimeValue = moment(endTimeAttr);
      initialCountdown = endTimeValue.diff(startValue, 'seconds');
      displayProgressBar = remainingTime * 100 / initialCountdown;
    }
    else {
      displayProgressBar = remainingTime * 100 / coutdown;
    }

    displayProgressBar = 100 - displayProgressBar; //To have 0 to 100 and not 100 to 0
    displayProgressBar = Math.round(displayProgressBar * 10) / 10; //learn more why : http://stackoverflow.com/questions/588004/is-floating-point-math-broken

    if(displayProgressBar > 100){ //security
      displayProgressBar = 100;
    }

    return displayProgressBar;
  };

  return new ProgressBarService();
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(1537)))

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * angular-translate - v2.15.2 - 2017-06-22
 * 
 * Copyright (c) 2017 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return (factory());
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

$translateStaticFilesLoader.$inject = ['$q', '$http'];
angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateStaticFilesLoader
 * @requires $q
 * @requires $http
 *
 * @description
 * Creates a loading function for a typical static file url pattern:
 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
 * the response of these urls must be an object of key-value pairs.
 *
 * @param {object} options Options object, which gets prefix, suffix, key, and fileMap
 */
.factory('$translateStaticFilesLoader', $translateStaticFilesLoader);

function $translateStaticFilesLoader($q, $http) {

  'use strict';

  return function (options) {

    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
    }

    if (!options.files) {
      options.files = [{
        prefix: options.prefix,
        suffix: options.suffix
      }];
    }

    var load = function (file) {
      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
      }

      var fileUrl = [
        file.prefix,
        options.key,
        file.suffix
      ].join('');

      if (angular.isObject(options.fileMap) && options.fileMap[fileUrl]) {
        fileUrl = options.fileMap[fileUrl];
      }

      return $http(angular.extend({
        url: fileUrl,
        method: 'GET'
      }, options.$http))
        .then(function(result) {
          return result.data;
        }, function () {
          return $q.reject(options.key);
        });
    };

    var promises = [],
        length = options.files.length;

    for (var i = 0; i < length; i++) {
      promises.push(load({
        prefix: options.files[i].prefix,
        key: options.key,
        suffix: options.files[i].suffix
      }));
    }

    return $q.all(promises)
      .then(function (data) {
        var length = data.length,
            mergedData = {};

        for (var i = 0; i < length; i++) {
          for (var key in data[i]) {
            mergedData[key] = data[i][key];
          }
        }

        return mergedData;
      });
  };
}

$translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
return 'pascalprecht.translate';

}));


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return (factory());
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

/**
 * @ngdoc overview
 * @name pascalprecht.translate
 *
 * @description
 * The main module which holds everything together.
 */
runTranslate.$inject = ['$translate'];
$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
translateAttrDirective.$inject = ['$translate', '$rootScope'];
translateCloakDirective.$inject = ['$translate', '$rootScope'];
translateFilterFactory.$inject = ['$parse', '$translate'];
$translationCache.$inject = ['$cacheFactory'];
angular.module('pascalprecht.translate', ['ng'])
  .run(runTranslate);

function runTranslate($translate) {

  'use strict';

  var key = $translate.storageKey(),
    storage = $translate.storage();

  var fallbackFromIncorrectStorageValue = function () {
    var preferred = $translate.preferredLanguage();
    if (angular.isString(preferred)) {
      $translate.use(preferred);
      // $translate.use() will also remember the language.
      // So, we don't need to call storage.put() here.
    } else {
      storage.put(key, $translate.use());
    }
  };

  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

  if (storage) {
    if (!storage.get(key)) {
      fallbackFromIncorrectStorageValue();
    } else {
      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
    }
  } else if (angular.isString($translate.preferredLanguage())) {
    $translate.use($translate.preferredLanguage());
  }
}

runTranslate.displayName = 'runTranslate';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateSanitizationProvider
 *
 * @description
 *
 * Configurations for $translateSanitization
 */
angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

function $translateSanitizationProvider () {

  'use strict';

  var $sanitize,
      $sce,
      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
      hasConfiguredStrategy = false,
      hasShownNoStrategyConfiguredWarning = false,
      strategies;

  /**
   * Definition of a sanitization strategy function
   * @callback StrategyFunction
   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
   * @return {string|object}
   */

  /**
   * @ngdoc property
   * @name strategies
   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Following strategies are built-in:
   * <dl>
   *   <dt>sanitize</dt>
   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
   *   <dt>escape</dt>
   *   <dd>Escapes HTML in the translation</dd>
   *   <dt>sanitizeParameters</dt>
   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
   *   <dt>escapeParameters</dt>
   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
   *   <dt>escaped</dt>
   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
   * </dl>
   *
   */

  strategies = {
    sanitize: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlSanitizeValue(value);
      }
      return value;
    },
    escape: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlEscapeValue(value);
      }
      return value;
    },
    sanitizeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlSanitizeValue);
      }
      return value;
    },
    escapeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlEscapeValue);
      }
      return value;
    },
    sce: function (value, mode, context) {
      if (mode === 'text') {
        value = htmlTrustValue(value);
      } else if (mode === 'params') {
        if (context !== 'filter') {
          // do html escape in filter context #1101
          value = mapInterpolationParameters(value, htmlEscapeValue);
        }
      }
      return value;
    },
    sceParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlTrustValue);
      }
      return value;
    }
  };
  // Support legacy strategy name 'escaped' for backwards compatibility.
  // TODO should be removed in 3.0
  strategies.escaped = strategies.escapeParameters;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Adds a sanitization strategy to the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @param {StrategyFunction} strategyFunction - strategy function
   * @returns {object} this
   */
  this.addStrategy = function (strategyName, strategyFunction) {
    strategies[strategyName] = strategyFunction;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Removes a sanitization strategy from the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @returns {object} this
   */
  this.removeStrategy = function (strategyName) {
    delete strategies[strategyName];
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
   *
   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
   * @returns {object} this
   */
  this.useStrategy = function (strategy) {
    hasConfiguredStrategy = true;
    currentStrategy = strategy;
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateSanitization
   * @requires $injector
   * @requires $log
   *
   * @description
   * Sanitizes interpolation parameters and translated texts.
   *
   */
  this.$get = ['$injector', '$log', function ($injector, $log) {

    var cachedStrategyMap = {};

    var applyStrategies = function (value, mode, context, selectedStrategies) {
      angular.forEach(selectedStrategies, function (selectedStrategy) {
        if (angular.isFunction(selectedStrategy)) {
          value = selectedStrategy(value, mode, context);
        } else if (angular.isFunction(strategies[selectedStrategy])) {
          value = strategies[selectedStrategy](value, mode, context);
        } else if (angular.isString(strategies[selectedStrategy])) {
          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
            try {
              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
            } catch (e) {
              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
            }
          }
          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
        } else {
          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
        }
      });
      return value;
    };

    // TODO: should be removed in 3.0
    var showNoStrategyConfiguredWarning = function () {
      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
        hasShownNoStrategyConfiguredWarning = true;
      }
    };

    if ($injector.has('$sanitize')) {
      $sanitize = $injector.get('$sanitize');
    }
    if ($injector.has('$sce')) {
      $sce = $injector.get('$sce');
    }

    return {
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#useStrategy
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
       *
       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
       */
      useStrategy: (function (self) {
        return function (strategy) {
          self.useStrategy(strategy);
        };
      })(this),

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#sanitize
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Sanitizes a value.
       *
       * @param {string|object} value The value which should be sanitized.
       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
       * @param {string} [context] The context of this call: filter, service. Default is service
       * @returns {string|object} sanitized value
       */
      sanitize: function (value, mode, strategy, context) {
        if (!currentStrategy) {
          showNoStrategyConfiguredWarning();
        }

        if (!strategy && strategy !== null) {
          strategy = currentStrategy;
        }

        if (!strategy) {
          return value;
        }

        if (!context) {
          context = 'service';
        }

        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
        return applyStrategies(value, mode, context, selectedStrategies);
      }
    };
  }];

  var htmlEscapeValue = function (value) {
    var element = angular.element('<div></div>');
    element.text(value); // not chainable, see #1044
    return element.html();
  };

  var htmlSanitizeValue = function (value) {
    if (!$sanitize) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
    }
    return $sanitize(value);
  };

  var htmlTrustValue = function (value) {
    if (!$sce) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
    }
    return $sce.trustAsHtml(value);
  };

  var mapInterpolationParameters = function (value, iteratee, stack) {
    if (angular.isDate(value)) {
      return value;
    } else if (angular.isObject(value)) {
      var result = angular.isArray(value) ? [] : {};

      if (!stack) {
        stack = [];
      } else {
        if (stack.indexOf(value) > -1) {
          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
        }
      }

      stack.push(value);
      angular.forEach(value, function (propertyValue, propertyKey) {

        /* Skipping function properties. */
        if (angular.isFunction(propertyValue)) {
          return;
        }

        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
      });
      stack.splice(-1, 1); // remove last

      return result;
    } else if (angular.isNumber(value)) {
      return value;
    } else if (value === true || value === false) {
      return value;
    } else if (!angular.isUndefined(value) && value !== null) {
      return iteratee(value);
    } else {
      return value;
    }
  };
}

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateProvider
 * @description
 *
 * $translateProvider allows developers to register translation-tables, asynchronous loaders
 * and similar to configure translation behavior directly inside of a module.
 *
 */
angular.module('pascalprecht.translate')
  .constant('pascalprechtTranslateOverrider', {})
  .provider('$translate', $translate);

function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

  'use strict';

  var $translationTable = {},
    $preferredLanguage,
    $availableLanguageKeys = [],
    $languageKeyAliases,
    $fallbackLanguage,
    $fallbackWasString,
    $uses,
    $nextLang,
    $storageFactory,
    $storageKey = $STORAGE_KEY,
    $storagePrefix,
    $missingTranslationHandlerFactory,
    $interpolationFactory,
    $interpolatorFactories = [],
    $loaderFactory,
    $cloakClassName = 'translate-cloak',
    $loaderOptions,
    $notFoundIndicatorLeft,
    $notFoundIndicatorRight,
    $postCompilingEnabled = false,
    $forceAsyncReloadEnabled = false,
    $nestedObjectDelimeter = '.',
    $isReady = false,
    $keepContent = false,
    loaderCache,
    directivePriority = 0,
    statefulFilter = true,
    postProcessFn,
    uniformLanguageTagResolver = 'default',
    languageTagResolver = {
      'default' : function (tag) {
        return (tag || '').split('-').join('_');
      },
      java : function (tag) {
        var temp = (tag || '').split('-').join('_');
        var parts = temp.split('_');
        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
      },
      bcp47 : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');

        switch (parts.length) {
          case 1: // language only
            parts[0] = parts[0].toLowerCase();
            break;
          case 2: // language-script or language-region
            parts[0] = parts[0].toLowerCase();
            if (parts[1].length === 4) { // parts[1] is script
              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            } else { // parts[1] is region
              parts[1] = parts[1].toUpperCase();
            }
            break;
          case 3: // language-script-region
            parts[0] = parts[0].toLowerCase();
            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            parts[2] = parts[2].toUpperCase();
            break;
          default:
            return temp;
        }

        return parts.join('-');
      },
      'iso639-1' : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');
        return parts[0].toLowerCase();
      }
    };

  var version = '2.18.1';

  // tries to determine the browsers language
  var getFirstBrowserLanguage = function () {

    // internal purpose only
    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
      return pascalprechtTranslateOverrider.getLocale();
    }

    var nav = $windowProvider.$get().navigator,
      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
      i,
      language;

    // support for HTML 5.1 "navigator.languages"
    if (angular.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language;
        }
      }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language;
      }
    }

    return null;
  };
  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

  // tries to determine the browsers locale
  var getLocale = function () {
    var locale = getFirstBrowserLanguage() || '';
    if (languageTagResolver[uniformLanguageTagResolver]) {
      locale = languageTagResolver[uniformLanguageTagResolver](locale);
    }
    return locale;
  };
  getLocale.displayName = 'angular-translate/service: getLocale';

  /**
   * @name indexOf
   * @private
   *
   * @description
   * indexOf polyfill. Kinda sorta.
   *
   * @param {array} array Array to search in.
   * @param {string} searchElement Element to search for.
   *
   * @returns {int} Index of search element.
   */
  var indexOf = function (array, searchElement) {
    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === searchElement) {
        return i;
      }
    }
    return -1;
  };

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function () {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  var negotiateLocale = function (preferred) {
    if (!preferred) {
      return;
    }

    var avail = [],
      locale = lowercase(preferred),
      i = 0,
      n = $availableLanguageKeys.length;

    for (; i < n; i++) {
      avail.push(lowercase($availableLanguageKeys[i]));
    }

    // Check for an exact match in our list of available keys
    i = indexOf(avail, locale);
    if (i > -1) {
      return $availableLanguageKeys[i];
    }

    if ($languageKeyAliases) {
      var alias;
      for (var langKeyAlias in $languageKeyAliases) {
        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
          var hasWildcardKey = false;
          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
            lowercase(langKeyAlias) === lowercase(preferred);

          if (langKeyAlias.slice(-1) === '*') {
            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
          }
          if (hasExactKey || hasWildcardKey) {
            alias = $languageKeyAliases[langKeyAlias];
            if (indexOf(avail, lowercase(alias)) > -1) {
              return alias;
            }
          }
        }
      }
    }

    // Check for a language code without region
    var parts = preferred.split('_');

    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
      return parts[0];
    }

    // If everything fails, return undefined.
    return;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translations
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a new translation table for specific language key.
   *
   * To register a translation table for specific language, pass a defined language
   * key as first parameter.
   *
   * <pre>
   *  // register translation table for language: 'de_DE'
   *  $translateProvider.translations('de_DE', {
   *    'GREETING': 'Hallo Welt!'
   *  });
   *
   *  // register another one
   *  $translateProvider.translations('en_US', {
   *    'GREETING': 'Hello world!'
   *  });
   * </pre>
   *
   * When registering multiple translation tables for for the same language key,
   * the actual translation table gets extended. This allows you to define module
   * specific translation which only get added, once a specific module is loaded in
   * your app.
   *
   * Invoking this method with no arguments returns the translation table which was
   * registered with no language key. Invoking it with a language key returns the
   * related translation table.
   *
   * @param {string} langKey A language key.
   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
   *
   */
  var translations = function (langKey, translationTable) {

    if (!langKey && !translationTable) {
      return $translationTable;
    }

    if (langKey && !translationTable) {
      if (angular.isString(langKey)) {
        return $translationTable[langKey];
      }
    } else {
      if (!angular.isObject($translationTable[langKey])) {
        $translationTable[langKey] = {};
      }
      angular.extend($translationTable[langKey], flatObject(translationTable));
    }
    return this;
  };

  this.translations = translations;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#cloakClassName
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the class name for `translate-cloak` directive.
   * Default class name is `translate-cloak`.
   *
   * @param {string} name translate-cloak class name
   */
  this.cloakClassName = function (name) {
    if (!name) {
      return $cloakClassName;
    }
    $cloakClassName = name;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the delimiter for namespaced translations.
   * Default delimiter is `.`.
   *
   * @param {string} delimiter namespace separator
   */
  this.nestedObjectDelimeter = function (delimiter) {
    if (!delimiter) {
      return $nestedObjectDelimeter;
    }
    $nestedObjectDelimeter = delimiter;
    return this;
  };

  /**
   * @name flatObject
   * @private
   *
   * @description
   * Flats an object. This function is used to flatten given translation data with
   * namespaces, so they are later accessible via dot notation.
   */
  var flatObject = function (data, path, result, prevKey) {
    var key, keyWithPath, keyWithShortPath, val;

    if (!path) {
      path = [];
    }
    if (!result) {
      result = {};
    }
    for (key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) {
        continue;
      }
      val = data[key];
      if (angular.isObject(val)) {
        flatObject(val, path.concat(key), result, key);
      } else {
        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
        if (path.length && key === prevKey) {
          // Create shortcut path (foo.bar == foo.bar.bar)
          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
          // Link it to original path
          result[keyWithShortPath] = '@:' + keyWithPath;
        }
        result[keyWithPath] = val;
      }
    }
    return result;
  };
  flatObject.displayName = 'flatObject';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#addInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Adds interpolation services to angular-translate, so it can manage them.
   *
   * @param {object} factory Interpolation service factory
   */
  this.addInterpolation = function (factory) {
    $interpolatorFactories.push(factory);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use interpolation functionality of messageformat.js.
   * This is useful when having high level pluralization and gender selection.
   */
  this.useMessageFormatInterpolation = function () {
    return this.useInterpolation('$translateMessageFormatInterpolation');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which interpolation style to use as default, application-wide.
   * Simply pass a factory/service name. The interpolation service has to implement
   * the correct interface.
   *
   * @param {string} factory Interpolation service name.
   */
  this.useInterpolation = function (factory) {
    $interpolationFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Simply sets a sanitation strategy type.
   *
   * @param {string} value Strategy type.
   */
  this.useSanitizeValueStrategy = function (value) {
    $translateSanitizationProvider.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#preferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use for translation
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **prefer**.
   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
   *
   * @param {string} langKey A language key.
   */
  this.preferredLanguage = function (langKey) {
    if (langKey) {
      setupPreferredLanguage(langKey);
      return this;
    }
    return $preferredLanguage;
  };
  var setupPreferredLanguage = function (langKey) {
    if (langKey) {
      $preferredLanguage = langKey;
    }
    return $preferredLanguage;
  };
  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found. E.g. when
   * setting the indicator as 'X' and one tries to translate a translation id
   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
   *
   * Internally this methods sets a left indicator and a right indicator using
   * `$translateProvider.translationNotFoundIndicatorLeft()` and
   * `$translateProvider.translationNotFoundIndicatorRight()`.
   *
   * **Note**: These methods automatically add a whitespace between the indicators
   * and the translation id.
   *
   * @param {string} indicator An indicator, could be any string.
   */
  this.translationNotFoundIndicator = function (indicator) {
    this.translationNotFoundIndicatorLeft(indicator);
    this.translationNotFoundIndicatorRight(indicator);
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found left to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorLeft = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorLeft;
    }
    $notFoundIndicatorLeft = indicator;
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found right to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorRight = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorRight;
    }
    $notFoundIndicatorRight = indicator;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use when missing translations
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **fallback**.
   *
   * @param {string||array} langKey A language key.
   *
   */
  this.fallbackLanguage = function (langKey) {
    fallbackStack(langKey);
    return this;
  };

  var fallbackStack = function (langKey) {
    if (langKey) {
      if (angular.isString(langKey)) {
        $fallbackWasString = true;
        $fallbackLanguage = [langKey];
      } else if (angular.isArray(langKey)) {
        $fallbackWasString = false;
        $fallbackLanguage = langKey;
      }
      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
        $fallbackLanguage.push($preferredLanguage);
      }

      return this;
    } else {
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#use
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Set which translation table to use for translation by given language key. When
   * trying to 'use' a language which isn't provided, it'll throw an error.
   *
   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
   * does the job too.
   *
   * @param {string} langKey A language key.
   */
  this.use = function (langKey) {
    if (langKey) {
      if (!$translationTable[langKey] && (!$loaderFactory)) {
        // only throw an error, when not loading translation data asynchronously
        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
      }
      $uses = langKey;
      return this;
    }
    return $uses;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
   *
   * @returns {string} the current client/browser language key
   */
  this.resolveClientLocale = function () {
    return getLocale();
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storageKey
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which key must represent the choosed language by a user in the storage.
   *
   * @param {string} key A key for the storage.
   */
  var storageKey = function (key) {
    if (!key) {
      if ($storagePrefix) {
        return $storagePrefix + $storageKey;
      }
      return $storageKey;
    }
    $storageKey = key;
    return this;
  };

  this.storageKey = storageKey;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useUrlLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
   *
   * @param {string} url Url
   * @param {Object=} options Optional configuration object
   */
  this.useUrlLoader = function (url, options) {
    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
   *
   * @param {Object=} options Optional configuration object
   */
  this.useStaticFilesLoader = function (options) {
    return this.useLoader('$translateStaticFilesLoader', options);
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use any other service as loader.
   *
   * @param {string} loaderFactory Factory name to use
   * @param {Object=} options Optional configuration object
   */
  this.useLoader = function (loaderFactory, options) {
    $loaderFactory = loaderFactory;
    $loaderOptions = options || {};
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLocalStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
   *
   */
  this.useLocalStorage = function () {
    return this.useStorage('$translateLocalStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useCookieStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
   */
  this.useCookieStorage = function () {
    return this.useStorage('$translateCookieStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use custom service as storage layer.
   */
  this.useStorage = function (storageFactory) {
    $storageFactory = storageFactory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storagePrefix
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets prefix for storage key.
   *
   * @param {string} prefix Storage key prefix
   */
  this.storagePrefix = function (prefix) {
    if (!prefix) {
      return prefix;
    }
    $storagePrefix = prefix;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use built-in log handler when trying to translate
   * a translation Id which doesn't exist.
   *
   * This is actually a shortcut method for `useMissingTranslationHandler()`.
   *
   */
  this.useMissingTranslationHandlerLog = function () {
    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Expects a factory name which later gets instantiated with `$injector`.
   * This method can be used to tell angular-translate to use a custom
   * missingTranslationHandler. Just build a factory which returns a function
   * and expects a translation id as argument.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.useMissingTranslationHandler('customHandler');
   *  });
   *
   *  app.factory('customHandler', function (dep1, dep2) {
   *    return function (translationId) {
   *      // something with translationId and dep1 and dep2
   *    };
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.useMissingTranslationHandler = function (factory) {
    $missingTranslationHandlerFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#usePostCompiling
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If post compiling is enabled, all translated values will be processed
   * again with AngularJS' $compile.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.usePostCompiling(true);
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.usePostCompiling = function (value) {
    $postCompilingEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If force async reload is enabled, async loader will always be called
   * even if $translationTable already contains the language key, adding
   * possible new entries to the $translationTable.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.forceAsyncReload(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.forceAsyncReload = function (value) {
    $forceAsyncReloadEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which language tag should be used as a result when determining
   * the current browser language.
   *
   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
   *
   * <pre>
   * $translateProvider
   *   .uniformLanguageTag('bcp47')
   *   .determinePreferredLanguage()
   * </pre>
   *
   * The resolver currently supports:
   * * default
   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_us
   * * java
   *     like default, but the second part will be always in uppercase
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_US
   * * BCP 47 (RFC 4646 & 4647)
   *     EN => en
   *     en-US => en-US
   *     en_US => en-US
   *     en-us => en-US
   *     sr-latn => sr-Latn
   *     sr-latn-rs => sr-Latn-RS
   *
   * See also:
   * * http://en.wikipedia.org/wiki/IETF_language_tag
   * * http://www.w3.org/International/core/langtags/
   * * http://tools.ietf.org/html/bcp47
   *
   * @param {string|object} options - options (or standard)
   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
   */
  this.uniformLanguageTag = function (options) {

    if (!options) {
      options = {};
    } else if (angular.isString(options)) {
      options = {
        standard : options
      };
    }

    uniformLanguageTagResolver = options.standard;

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to try to determine on its own which language key
   * to set as preferred language. When `fn` is given, angular-translate uses it
   * to determine a language key, otherwise it uses the built-in `getLocale()`
   * method.
   *
   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
   * `[lang]` depending on what the browser provides.
   *
   * Use this method at your own risk, since not all browsers return a valid
   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
   *
   * @param {Function=} fn Function to determine a browser's locale
   */
  this.determinePreferredLanguage = function (fn) {

    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();

    if (!$availableLanguageKeys.length) {
      $preferredLanguage = locale;
    } else {
      $preferredLanguage = negotiateLocale(locale) || locale;
    }

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a set of language keys the app will work with. Use this method in
   * combination with
   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
   * When available languages keys are registered, angular-translate
   * tries to find the best fitting language key depending on the browsers locale,
   * considering your language key convention.
   *
   * @param {object} languageKeys Array of language keys the your app will use
   * @param {object=} aliases Alias map.
   */
  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
    if (languageKeys) {
      $availableLanguageKeys = languageKeys;
      if (aliases) {
        $languageKeyAliases = aliases;
      }
      return this;
    }
    return $availableLanguageKeys;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoaderCache
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a cache for internal $http based loaders.
   * {@link pascalprecht.translate.$translationCache $translationCache}.
   * When false the cache will be disabled (default). When true or undefined
   * the cache will be a default (see $cacheFactory). When an object it will
   * be treat as a cache object itself: the usage is $http({cache: cache})
   *
   * @param {object} cache boolean, string or cache-object
   */
  this.useLoaderCache = function (cache) {
    if (cache === false) {
      // disable cache
      loaderCache = undefined;
    } else if (cache === true) {
      // enable cache using AJS defaults
      loaderCache = true;
    } else if (typeof(cache) === 'undefined') {
      // enable cache using default
      loaderCache = '$translationCache';
    } else if (cache) {
      // enable cache using given one (see $cacheFactory)
      loaderCache = cache;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#directivePriority
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets the default priority of the translate directive. The standard value is `0`.
   * Calling this function without an argument will return the current value.
   *
   * @param {number} priority for the translate-directive
   */
  this.directivePriority = function (priority) {
    if (priority === undefined) {
      // getter
      return directivePriority;
    } else {
      // setter with chaining
      directivePriority = priority;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#statefulFilter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
   * have to explicit define this behavior.
   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
   * meaning being stateful.
   * Calling this function without an argument will return the current value.
   *
   * @param {boolean} state - defines the state of the filter
   */
  this.statefulFilter = function (state) {
    if (state === undefined) {
      // getter
      return statefulFilter;
    } else {
      // setter with chaining
      statefulFilter = state;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#postProcess
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * The post processor will be intercept right after the translation result. It can modify the result.
   *
   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
   */
  this.postProcess = function (fn) {
    if (fn) {
      postProcessFn = fn;
    } else {
      postProcessFn = undefined;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#keepContent
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If keepContent is set to true than translate directive will always use innerHTML
   * as a default translation
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.keepContent(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.keepContent = function (value) {
    $keepContent = !(!value);
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translate
   * @requires $interpolate
   * @requires $log
   * @requires $rootScope
   * @requires $q
   *
   * @description
   * The `$translate` service is the actual core of angular-translate. It expects a translation id
   * and optional interpolate parameters to translate contents.
   *
   * <pre>
   *  $translate('HEADLINE_TEXT').then(function (translation) {
   *    $scope.translatedText = translation;
   *  });
   * </pre>
   *
   * @param {string|array} translationId A token which represents a translation id
   *                                     This can be optionally an array of translation ids which
   *                                     results that the function returns an object where each key
   *                                     is the translation id and the value the translation.
   * @param {object=} [interpolateParams={}] An object hash for dynamic values
   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
   *                                        as default text in case it is not found in any configured language
   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
   * @returns {object} promise
   */
  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {

    var Storage,
      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
      pendingLoader = false,
      interpolatorHashMap = {},
      langPromises = {},
      fallbackIndex,
      startFallbackIteration;

    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
      if (!$uses && $preferredLanguage) {
        $uses = $preferredLanguage;
      }
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        // Inspired by Q.allSettled by Kris Kowal
        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
        // This transforms all promises regardless resolved or rejected
        var translateAll = function (translationIds) {
          var results = {}; // storing the actual results
          var promises = []; // promises to wait for
          // Wraps the promise a) being always resolved and b) storing the link id->value
          var translate = function (translationId) {
            var deferred = $q.defer();
            var regardless = function (value) {
              results[translationId] = value;
              deferred.resolve([translationId, value]);
            };
            // we don't care whether the promise was resolved or rejected; just store the values
            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
            return deferred.promise;
          };
          for (var i = 0, c = translationIds.length; i < c; i++) {
            promises.push(translate(translationIds[i]));
          }
          // wait for all (including storing to results)
          return $q.all(promises).then(function () {
            // return the results
            return results;
          });
        };
        return translateAll(translationId);
      }

      var deferred = $q.defer();

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var promiseToWaitFor = (function () {
        var promise = langPromises[uses] || langPromises[$preferredLanguage];

        fallbackIndex = 0;

        if ($storageFactory && !promise) {
          // looks like there's no pending promise for $preferredLanguage or
          // $uses. Maybe there's one pending for a language that comes from
          // storage.
          var langKey = Storage.get($storageKey);
          promise = langPromises[langKey];

          if ($fallbackLanguage && $fallbackLanguage.length) {
            var index = indexOf($fallbackLanguage, langKey);
            // maybe the language from storage is also defined as fallback language
            // we increase the fallback language index to not search in that language
            // as fallback, since it's probably the first used language
            // in that case the index starts after the first element
            fallbackIndex = (index === 0) ? 1 : 0;

            // but we can make sure to ALWAYS fallback to preferred language at least
            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
              $fallbackLanguage.push($preferredLanguage);
            }
          }
        }
        return promise;
      }());

      if (!promiseToWaitFor) {
        // no promise to wait for? okay. Then there's no loader registered
        // nor is a one pending for language that comes from storage.
        // We can just translate.
        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
      } else {
        var promiseResolved = function () {
          // $uses may have changed while waiting
          if (!forceLanguage) {
            uses = $uses;
          }
          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
        };
        promiseResolved.displayName = 'promiseResolved';

        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
      }
      return deferred.promise;
    };

    /**
     * @name applyNotFoundIndicators
     * @private
     *
     * @description
     * Applies not fount indicators to given translation id, if needed.
     * This function gets only executed, if a translation id doesn't exist,
     * which is why a translation id is expected as argument.
     *
     * @param {string} translationId Translation id.
     * @returns {string} Same as given translation id but applied with not found
     * indicators.
     */
    var applyNotFoundIndicators = function (translationId) {
      // applying notFoundIndicators
      if ($notFoundIndicatorLeft) {
        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
      }
      if ($notFoundIndicatorRight) {
        translationId = [translationId, $notFoundIndicatorRight].join(' ');
      }
      return translationId;
    };

    /**
     * @name useLanguage
     * @private
     *
     * @description
     * Makes actual use of a language by setting a given language key as used
     * language and informs registered interpolators to also use the given
     * key as locale.
     *
     * @param {string} key Locale key.
     */
    var useLanguage = function (key) {
      $uses = key;

      // make sure to store new language key before triggering success event
      if ($storageFactory) {
        Storage.put($translate.storageKey(), $uses);
      }

      $rootScope.$emit('$translateChangeSuccess', {language : key});

      // inform default interpolator
      defaultInterpolator.setLocale($uses);

      var eachInterpolator = function (interpolator, id) {
        interpolatorHashMap[id].setLocale($uses);
      };
      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

      // inform all others too!
      angular.forEach(interpolatorHashMap, eachInterpolator);
      $rootScope.$emit('$translateChangeEnd', {language : key});
    };

    /**
     * @name loadAsync
     * @private
     *
     * @description
     * Kicks off registered async loader using `$injector` and applies existing
     * loader options. When resolved, it updates translation tables accordingly
     * or rejects with given language key.
     *
     * @param {string} key Language key.
     * @return {Promise} A promise.
     */
    var loadAsync = function (key) {
      if (!key) {
        throw 'No language key specified for loading.';
      }

      var deferred = $q.defer();

      $rootScope.$emit('$translateLoadingStart', {language : key});
      pendingLoader = true;

      var cache = loaderCache;
      if (typeof(cache) === 'string') {
        // getting on-demand instance of loader
        cache = $injector.get(cache);
      }

      var loaderOptions = angular.extend({}, $loaderOptions, {
        key : key,
        $http : angular.extend({}, {
          cache : cache
        }, $loaderOptions.$http)
      });

      var onLoaderSuccess = function (data) {
        var translationTable = {};
        $rootScope.$emit('$translateLoadingSuccess', {language : key});

        if (angular.isArray(data)) {
          angular.forEach(data, function (table) {
            angular.extend(translationTable, flatObject(table));
          });
        } else {
          angular.extend(translationTable, flatObject(data));
        }
        pendingLoader = false;
        deferred.resolve({
          key : key,
          table : translationTable
        });
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderSuccess.displayName = 'onLoaderSuccess';

      var onLoaderError = function (key) {
        $rootScope.$emit('$translateLoadingError', {language : key});
        deferred.reject(key);
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderError.displayName = 'onLoaderError';

      $injector.get($loaderFactory)(loaderOptions)
        .then(onLoaderSuccess, onLoaderError);

      return deferred.promise;
    };

    if ($storageFactory) {
      Storage = $injector.get($storageFactory);

      if (!Storage.get || !Storage.put) {
        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
      }
    }

    // if we have additional interpolations that were added via
    // $translateProvider.addInterpolation(), we have to map'em
    if ($interpolatorFactories.length) {
      var eachInterpolationFactory = function (interpolatorFactory) {
        var interpolator = $injector.get(interpolatorFactory);
        // setting initial locale for each interpolation service
        interpolator.setLocale($preferredLanguage || $uses);
        // make'em recognizable through id
        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
      };
      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

      angular.forEach($interpolatorFactories, eachInterpolationFactory);
    }

    /**
     * @name getTranslationTable
     * @private
     *
     * @description
     * Returns a promise that resolves to the translation table
     * or is rejected if an error occurred.
     *
     * @param langKey
     * @returns {Q.promise}
     */
    var getTranslationTable = function (langKey) {
      var deferred = $q.defer();
      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
        deferred.resolve($translationTable[langKey]);
      } else if (langPromises[langKey]) {
        var onResolve = function (data) {
          translations(data.key, data.table);
          deferred.resolve(data.table);
        };
        onResolve.displayName = 'translationTableResolver';
        langPromises[langKey].then(onResolve, deferred.reject);
      } else {
        deferred.reject();
      }
      return deferred.promise;
    };

    /**
     * @name getFallbackTranslation
     * @private
     *
     * @description
     * Returns a promise that will resolve to the translation
     * or be rejected if no translation was found for the language.
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {Q.promise}
     */
    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var deferred = $q.defer();

      var onResolve = function (translationTable) {
        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
          Interpolator.setLocale(langKey);
          var translation = translationTable[translationId];
          if (translation.substr(0, 2) === '@:') {
            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
              .then(deferred.resolve, deferred.reject);
          } else {
            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);

            deferred.resolve(interpolatedValue);

          }
          Interpolator.setLocale($uses);
        } else {
          deferred.reject();
        }
      };
      onResolve.displayName = 'fallbackTranslationResolver';

      getTranslationTable(langKey).then(onResolve, deferred.reject);

      return deferred.promise;
    };

    /**
     * @name getFallbackTranslationInstant
     * @private
     *
     * @description
     * Returns a translation
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns {string} translation
     */
    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result, translationTable = $translationTable[langKey];

      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
        Interpolator.setLocale(langKey);
        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
        // workaround for TrustedValueHolderType
        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
          var result2 = result.$$unwrapTrustedValue();
          if (result2.substr(0, 2) === '@:') {
            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
          }
        } else if (result.substr(0, 2) === '@:') {
          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
        }
        Interpolator.setLocale($uses);
      }

      return result;
    };


    /**
     * @name translateByHandler
     * @private
     *
     * Translate by missing translation handler.
     *
     * @param translationId
     * @param interpolateParams
     * @param defaultTranslationText
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
     * absent
     */
    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
      // If we have a handler factory - we might also call it here to determine if it provides
      // a default text for a translationid that can't be found anywhere in our tables
      if ($missingTranslationHandlerFactory) {
        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
      } else {
        return translationId;
      }
    };

    /**
     * @name resolveForFallbackLanguage
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise that will resolve to the translation.
     */
    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      var deferred = $q.defer();

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
          function (data) {
            deferred.resolve(data);
          },
          function () {
            // Look in the next fallback language for a translation.
            // It delays the resolving by passing another promise to resolve.
            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
          }
        );
      } else {
        // No translation found in any fallback language
        // if a default translation text is set in the directive, then return this as a result
        if (defaultTranslationText) {
          deferred.resolve(defaultTranslationText);
        } else {
          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);

          // if no default translation is set and an error handler is defined, send it to the handler
          // and then return the result if it isn't undefined
          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
            deferred.resolve(missingTranslationHandlerTranslation);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    /**
     * @name resolveForFallbackLanguageInstant
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {string} translation
     */
    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result;

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
        if (!result && result !== '') {
          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
        }
      }
      return result;
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise, that resolves to the translation.
     */
    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {String} translation
     */
    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
    };

    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {

      var deferred = $q.defer();

      var table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {

          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
            .then(deferred.resolve, deferred.reject);
        } else {
          //
          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
          deferred.resolve(resolvedTranslation);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
            .then(function (translation) {
              deferred.resolve(translation);
            }, function (_translationId) {
              deferred.reject(applyNotFoundIndicators(_translationId));
            });
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.resolve(missingTranslationHandlerTranslation);
          }
        } else {
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {

      var result, table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = defaultInterpolator;

      // if the interpolation id exists use custom interpolator
      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
        Interpolator = interpolatorHashMap[interpolationId];
      }

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {
          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
        } else {
          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackIndex = 0;
          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          result = missingTranslationHandlerTranslation;
        } else {
          result = applyNotFoundIndicators(translationId);
        }
      }

      return result;
    };

    var clearNextLangAndPromise = function (key) {
      if ($nextLang === key) {
        $nextLang = undefined;
      }
      langPromises[key] = undefined;
    };

    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
      var fn = postProcessFn;

      if (fn) {

        if (typeof(fn) === 'string') {
          // getting on-demand instance
          fn = $injector.get(fn);
        }
        if (fn) {
          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
        }
      }

      return resolvedTranslation;
    };

    var loadTranslationsIfMissing = function (key) {
      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          return translation;
        });
      }
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#preferredLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the preferred language.
     *
     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
     *
     * @return {string} preferred language key
     */
    $translate.preferredLanguage = function (langKey) {
      if (langKey) {
        setupPreferredLanguage(langKey);
      }
      return $preferredLanguage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#cloakClassName
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured class name for `translate-cloak` directive.
     *
     * @return {string} cloakClassName
     */
    $translate.cloakClassName = function () {
      return $cloakClassName;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured delimiter for nested namespaces.
     *
     * @return {string} nestedObjectDelimeter
     */
    $translate.nestedObjectDelimeter = function () {
      return $nestedObjectDelimeter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#fallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the fallback languages or sets a new fallback stack.
     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
     *
     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
     *
     * @return {string||array} fallback language key
     */
    $translate.fallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        fallbackStack(langKey);

        // as we might have an async loader initiated and a new translation language might have been defined
        // we need to add the promise to the stack also. So - iterate.
        if ($loaderFactory) {
          if ($fallbackLanguage && $fallbackLanguage.length) {
            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
              if (!langPromises[$fallbackLanguage[i]]) {
                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
              }
            }
          }
        }
        $translate.use($translate.use());
      }
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#useFallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Sets the first key of the fallback language stack to be used for translation.
     * Therefore all languages in the fallback array BEFORE this key will be skipped!
     *
     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
     * get back to the whole stack
     */
    $translate.useFallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        if (!langKey) {
          startFallbackIteration = 0;
        } else {
          var langKeyPosition = indexOf($fallbackLanguage, langKey);
          if (langKeyPosition > -1) {
            startFallbackIteration = langKeyPosition;
          }
        }

      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#proposedLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key of language that is currently loaded asynchronously.
     *
     * @return {string} language key
     */
    $translate.proposedLanguage = function () {
      return $nextLang;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns registered storage.
     *
     * @return {object} Storage
     */
    $translate.storage = function () {
      return Storage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#negotiateLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a language key based on available languages and language aliases. If a
     * language key cannot be resolved, returns undefined.
     *
     * If no or a falsy key is given, returns undefined.
     *
     * @param {string} [key] Language key
     * @return {string|undefined} Language key or undefined if no language key is found.
     */
    $translate.negotiateLocale = negotiateLocale;

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#use
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Tells angular-translate which language to use by given language key. This method is
     * used to change language at runtime. It also takes care of storing the language
     * key in a configured store to let your app remember the choosed language.
     *
     * When trying to 'use' a language which isn't available it tries to load it
     * asynchronously with registered loaders.
     *
     * Returns promise object with loaded language file data or string of the currently used language.
     *
     * If no or a falsy key is given it returns the currently used language key.
     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
     * @example
     * $translate.use("en_US").then(function(data){
       *   $scope.text = $translate("HELLO");
       * });
     *
     * @param {string=} key Language key
     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
     */
    $translate.use = function (key) {
      if (!key) {
        return $uses;
      }

      var deferred = $q.defer();
      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"

      $rootScope.$emit('$translateChangeStart', {language : key});

      // Try to get the aliased language key
      var aliasedKey = negotiateLocale(key);
      // Ensure only registered language keys will be loaded
      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
        return $q.reject(key);
      }

      if (aliasedKey) {
        key = aliasedKey;
      }

      // if there isn't a translation table for the language we've requested,
      // we load it asynchronously
      $nextLang = key;
      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          deferred.resolve(translation.key);
          if ($nextLang === key) {
            useLanguage(translation.key);
          }
          return translation;
        }, function (key) {
          $rootScope.$emit('$translateChangeError', {language : key});
          deferred.reject(key);
          $rootScope.$emit('$translateChangeEnd', {language : key});
          return $q.reject(key);
        });
        langPromises[key]['finally'](function () {
          clearNextLangAndPromise(key);
        })['catch'](angular.noop); // we don't care about errors (clearing)
      } else if (langPromises[key]) {
        // we are already loading this asynchronously
        // resolve our new deferred when the old langPromise is resolved
        langPromises[key].then(function (translation) {
          if ($nextLang === translation.key) {
            useLanguage(translation.key);
          }
          deferred.resolve(translation.key);
          return translation;
        }, function (key) {
          // find first available fallback language if that request has failed
          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
          } else {
            return deferred.reject(key);
          }
        });
      } else {
        deferred.resolve(key);
        useLanguage(key);
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#resolveClientLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
     *
     * @returns {string} the current client/browser language key
     */
    $translate.resolveClientLocale = function () {
      return getLocale();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storageKey
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the key for the storage.
     *
     * @return {string} storage key
     */
    $translate.storageKey = function () {
      return storageKey();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether post compiling is enabled or not
     *
     * @return {bool} storage key
     */
    $translate.isPostCompilingEnabled = function () {
      return $postCompilingEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether force async reload is enabled or not
     *
     * @return {boolean} forceAsyncReload value
     */
    $translate.isForceAsyncReloadEnabled = function () {
      return $forceAsyncReloadEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isKeepContent
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether keepContent or not
     *
     * @return {boolean} keepContent value
     */
    $translate.isKeepContent = function () {
      return $keepContent;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#refresh
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
     * the module will drop all existent translation tables and load new version of those which
     * are currently in use.
     *
     * Refresh means that the module will drop target translation table and try to load it again.
     *
     * In case there are no loaders registered the refresh() method will throw an Error.
     *
     * If the module is able to refresh translation tables refresh() method will broadcast
     * $translateRefreshStart and $translateRefreshEnd events.
     *
     * @example
     * // this will drop all currently existent translation tables and reload those which are
     * // currently in use
     * $translate.refresh();
     * // this will refresh a translation table for the en_US language
     * $translate.refresh('en_US');
     *
     * @param {string} langKey A language key of the table, which has to be refreshed
     *
     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
     * process is finished successfully, and reject if not.
     */
    $translate.refresh = function (langKey) {
      if (!$loaderFactory) {
        throw new Error('Couldn\'t refresh translation table, no loader registered!');
      }

      $rootScope.$emit('$translateRefreshStart', {language : langKey});

      var deferred = $q.defer(), updatedLanguages = {};

      //private helper
      function loadNewData(languageKey) {
        var promise = loadAsync(languageKey);
        //update the load promise cache for this language
        langPromises[languageKey] = promise;
        //register a data handler for the promise
        promise.then(function (data) {
            //clear the cache for this language
            $translationTable[languageKey] = {};
            //add the new data for this language
            translations(languageKey, data.table);
            //track that we updated this language
            updatedLanguages[languageKey] = true;
          },
          //handle rejection to appease the $q validation
          angular.noop);
        return promise;
      }

      //set up post-processing
      deferred.promise.then(
        function () {
          for (var key in $translationTable) {
            if ($translationTable.hasOwnProperty(key)) {
              //delete cache entries that were not updated
              if (!(key in updatedLanguages)) {
                delete $translationTable[key];
              }
            }
          }
          if ($uses) {
            useLanguage($uses);
          }
        },
        //handle rejection to appease the $q validation
        angular.noop
      )['finally'](
        function () {
          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
        }
      );

      if (!langKey) {
        // if there's no language key specified we refresh ALL THE THINGS!
        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
        if ($uses && languagesToReload.indexOf($uses) === -1) {
          languagesToReload.push($uses);
        }
        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);

      } else if ($translationTable[langKey]) {
        //just refresh the specified language cache
        loadNewData(langKey).then(deferred.resolve, deferred.reject);

      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#instant
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a translation instantly from the internal state of loaded translation. All rules
     * regarding the current language, the preferred language of even fallback languages will be
     * used except any promise handling. If a language was not found, an asynchronous loading
     * will be invoked in the background.
     *
     * @param {string|array} translationId A token which represents a translation id
     *                                     This can be optionally an array of translation ids which
     *                                     results that the function's promise returns an object where
     *                                     each key is the translation id and the value the translation.
     * @param {object=} [interpolateParams={}] Params
     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
     *
     * @return {string|object} translation
     */
    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {

      // we don't want to re-negotiate $uses
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Detect undefined and null values to shorten the execution and prevent exceptions
      if (translationId === null || angular.isUndefined(translationId)) {
        return translationId;
      }

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        var results = {};
        for (var i = 0, c = translationId.length; i < c; i++) {
          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
        }
        return results;
      }

      // We discarded unacceptable values. So we just need to verify if translationId is empty String
      if (angular.isString(translationId) && translationId.length < 1) {
        return translationId;
      }

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var result, possibleLangKeys = [];
      if ($preferredLanguage) {
        possibleLangKeys.push($preferredLanguage);
      }
      if (uses) {
        possibleLangKeys.push(uses);
      }
      if ($fallbackLanguage && $fallbackLanguage.length) {
        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
      }
      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
        var possibleLangKey = possibleLangKeys[j];
        if ($translationTable[possibleLangKey]) {
          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
          }
        }
        if (typeof result !== 'undefined') {
          break;
        }
      }

      if (!result && result !== '') {
        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
          result = applyNotFoundIndicators(translationId);
        } else {
          // Return translation of default interpolator if not found anything.
          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);

          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          var missingTranslationHandlerTranslation;
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
          }

          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
            result = missingTranslationHandlerTranslation;
          }
        }
      }

      return result;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#versionInfo
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the current version information for the angular-translate library
     *
     * @return {string} angular-translate version
     */
    $translate.versionInfo = function () {
      return version;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#loaderCache
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the defined loaderCache.
     *
     * @return {boolean|string|object} current value of loaderCache
     */
    $translate.loaderCache = function () {
      return loaderCache;
    };

    // internal purpose only
    $translate.directivePriority = function () {
      return directivePriority;
    };

    // internal purpose only
    $translate.statefulFilter = function () {
      return statefulFilter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
     *
     * @return {boolean} current value of ready
     */
    $translate.isReady = function () {
      return $isReady;
    };

    var $onReadyDeferred = $q.defer();
    $onReadyDeferred.promise.then(function () {
      $isReady = true;
    });

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#onReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
     *
     * @param {Function=} fn Function to invoke when service is ready
     * @return {object} Promise resolved when service is ready
     */
    $translate.onReady = function (fn) {
      var deferred = $q.defer();
      if (angular.isFunction(fn)) {
        deferred.promise.then(fn);
      }
      if ($isReady) {
        deferred.resolve();
      } else {
        $onReadyDeferred.promise.then(deferred.resolve);
      }
      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This function simply returns the registered language keys being defined before in the config phase
     * With this, an application can use the array to provide a language selection dropdown or similar
     * without any additional effort
     *
     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
     */
    $translate.getAvailableLanguageKeys = function () {
      if ($availableLanguageKeys.length > 0) {
        return $availableLanguageKeys;
      }
      return null;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getTranslationTable
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns translation table by the given language key.
     *
     * Unless a language is provided it returns a translation table of the current one.
     * Note: If translation dictionary is currently downloading or in progress
     * it will return null.
     *
     * @param {string} langKey A token which represents a translation id
     *
     * @return {object} a copy of angular-translate $translationTable
     */
    $translate.getTranslationTable = function (langKey) {
      langKey = langKey || $translate.use();
      if (langKey && $translationTable[langKey]) {
        return angular.copy($translationTable[langKey]);
      }
      return null;
    };

    // Whenever $translateReady is being fired, this will ensure the state of $isReady
    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
      $onReadyDeferred.resolve();
      globalOnReadyListener(); // one time only
      globalOnReadyListener = null;
    });
    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
      $onReadyDeferred.resolve();
      globalOnChangeListener(); // one time only
      globalOnChangeListener = null;
    });

    if ($loaderFactory) {

      // If at least one async loader is defined and there are no
      // (default) translations available we should try to load them.
      if (angular.equals($translationTable, {})) {
        if ($translate.use()) {
          $translate.use($translate.use());
        }
      }

      // Also, if there are any fallback language registered, we start
      // loading them asynchronously as soon as we can.
      if ($fallbackLanguage && $fallbackLanguage.length) {
        var processAsyncResult = function (translation) {
          translations(translation.key, translation.table);
          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
          return translation;
        };
        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
          var fallbackLanguageId = $fallbackLanguage[i];
          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
          }
        }
      }
    } else {
      $rootScope.$emit('$translateReady', {language : $translate.use()});
    }

    return $translate;
  }];
}

$translate.displayName = 'displayName';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateDefaultInterpolation
 * @requires $interpolate
 *
 * @description
 * Uses angular's `$interpolate` services to interpolate strings against some values.
 *
 * Be aware to configure a proper sanitization strategy.
 *
 * See also:
 * * {@link pascalprecht.translate.$translateSanitization}
 *
 * @return {object} $translateDefaultInterpolation Interpolator service
 */
angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

function $translateDefaultInterpolation ($interpolate, $translateSanitization) {

  'use strict';

  var $translateInterpolator = {},
      $locale,
      $identifier = 'default';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Sets current locale (this is currently not use in this interpolation).
   *
   * @param {string} locale Language key or locale.
   */
  $translateInterpolator.setLocale = function (locale) {
    $locale = locale;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Returns an identifier for this interpolation service.
   *
   * @returns {string} $identifier
   */
  $translateInterpolator.getInterpolationIdentifier = function () {
    return $identifier;
  };

  /**
   * @deprecated will be removed in 3.0
   * @see {@link pascalprecht.translate.$translateSanitization}
   */
  $translateInterpolator.useSanitizeValueStrategy = function (value) {
    $translateSanitization.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Interpolates given value agains given interpolate params using angulars
   * `$interpolate` service.
   *
   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
   *
   * @param {string} value translation
   * @param {object} [interpolationParams={}] interpolation params
   * @param {string} [context=undefined] current context (filter, directive, service)
   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
   * @param {string} translationId current translationId
   *
   * @returns {string} interpolated string
   */
  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
    interpolationParams = interpolationParams || {};
    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);

    var interpolatedText;
    if (angular.isNumber(value)) {
      // numbers are safe
      interpolatedText = '' + value;
    } else if (angular.isString(value)) {
      // strings must be interpolated (that's the job here)
      interpolatedText = $interpolate(value)(interpolationParams);
      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
    } else {
      // neither a number or a string, cant interpolate => empty string
      interpolatedText = '';
    }

    return interpolatedText;
  };

  return $translateInterpolator;
}

$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate
 * @requires $interpolate,
 * @requires $compile,
 * @requires $parse,
 * @requires $rootScope
 * @restrict AE
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses $translate service to translate the translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate Translation id which could be either string or interpolated string.
 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
 * @param {string=} translate-default will be used unless translation was successful
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre translate="TRANSLATION_ID"></pre>
        <pre translate>TRANSLATION_ID</pre>
        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
        <pre translate="{{translationId}}"></pre>
        <pre translate>{{translationId}}</pre>
        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.attr('title')).toBe('Hello there!');

          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
        });
      });
    </file>
   </example>
 */
.directive('translate', translateDirective);
function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {

  'use strict';

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function() {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  return {
    restrict: 'AE',
    scope: true,
    priority: $translate.directivePriority(),
    compile: function (tElement, tAttr) {

      var translateValuesExist = (tAttr.translateValues) ?
        tAttr.translateValues : undefined;

      var translateInterpolation = (tAttr.translateInterpolation) ?
        tAttr.translateInterpolation : undefined;

      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
        tAttr.translateSanitizeStrategy : undefined;

      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

      return function linkFn(scope, iElement, iAttr) {

        scope.interpolateParams = {};
        scope.preText = '';
        scope.postText = '';
        scope.translateNamespace = getTranslateNamespace(scope);
        var translationIds = {};

        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
          // initial setup
          if (iAttr.translateValues) {
            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
          }
          // initially fetch all attributes if existing and fill the params
          if (translateValueExist) {
            for (var attr in tAttr) {
              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
                interpolateParams[attributeName] = tAttr[attr];
              }
            }
          }
        };

        // Ensures any change of the attribute "translate" containing the id will
        // be re-stored to the scope's "translationId".
        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
        var observeElementTranslation = function (translationId) {

          // Remove any old watcher
          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
            observeElementTranslation._unwatchOld();
            observeElementTranslation._unwatchOld = undefined;
          }

          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
            var iElementText = trim.apply(iElement.text());

            // Resolve translation id by inner html if required
            var interpolateMatches = iElementText.match(interpolateRegExp);
            // Interpolate translation id if required
            if (angular.isArray(interpolateMatches)) {
              scope.preText = interpolateMatches[1];
              scope.postText = interpolateMatches[3];
              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
              var watcherMatches = iElementText.match(watcherRegExp);
              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                  translationIds.translate = newValue;
                  updateTranslations();
                });
              }
            } else {
              // do not assigne the translation id if it is empty.
              translationIds.translate = !iElementText ? undefined : iElementText;
            }
          } else {
            translationIds.translate = translationId;
          }
          updateTranslations();
        };

        var observeAttributeTranslation = function (translateAttr) {
          iAttr.$observe(translateAttr, function (translationId) {
            translationIds[translateAttr] = translationId;
            updateTranslations();
          });
        };

        // initial setup with values
        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

        var firstAttributeChangedEvent = true;
        iAttr.$observe('translate', function (translationId) {
          if (typeof translationId === 'undefined') {
            // case of element "<translate>xyz</translate>"
            observeElementTranslation('');
          } else {
            // case of regular attribute
            if (translationId !== '' || !firstAttributeChangedEvent) {
              translationIds.translate = translationId;
              updateTranslations();
            }
          }
          firstAttributeChangedEvent = false;
        });

        for (var translateAttr in iAttr) {
          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
            observeAttributeTranslation(translateAttr);
          }
        }

        iAttr.$observe('translateDefault', function (value) {
          scope.defaultText = value;
          updateTranslations();
        });

        if (translateSanitizeStrategyExist) {
          iAttr.$observe('translateSanitizeStrategy', function (value) {
            scope.sanitizeStrategy = $parse(value)(scope.$parent);
            updateTranslations();
          });
        }

        if (translateValuesExist) {
          iAttr.$observe('translateValues', function (interpolateParams) {
            if (interpolateParams) {
              scope.$parent.$watch(function () {
                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
              });
            }
          });
        }

        if (translateValueExist) {
          var observeValueAttribute = function (attrName) {
            iAttr.$observe(attrName, function (value) {
              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
              scope.interpolateParams[attributeName] = value;
            });
          };
          for (var attr in iAttr) {
            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
              observeValueAttribute(attr);
            }
          }
        }

        // Master update function
        var updateTranslations = function () {
          for (var key in translationIds) {
            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
            }
          }
        };

        // Put translation processing function outside loop
        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
          if (translationId) {
            // if translation id starts with '.' and translateNamespace given, prepend namespace
            if (translateNamespace && translationId.charAt(0) === '.') {
              translationId = translateNamespace + translationId;
            }

            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
              .then(function (translation) {
                applyTranslation(translation, scope, true, translateAttr);
              }, function (translationId) {
                applyTranslation(translationId, scope, false, translateAttr);
              });
          } else {
            // as an empty string cannot be translated, we can solve this using successful=false
            applyTranslation(translationId, scope, false, translateAttr);
          }
        };

        var applyTranslation = function (value, scope, successful, translateAttr) {
          if (!successful) {
            if (typeof scope.defaultText !== 'undefined') {
              value = scope.defaultText;
            }
          }
          if (translateAttr === 'translate') {
            // default translate into innerHTML
            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
              iElement.empty().append(scope.preText + value + scope.postText);
            }
            var globallyEnabled = $translate.isPostCompilingEnabled();
            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
              $compile(iElement.contents())(scope);
            }
          } else {
            // translate attribute
            var attributeName = iAttr.$attr[translateAttr];
            if (attributeName.substr(0, 5) === 'data-') {
              // ensure html5 data prefix is stripped
              attributeName = attributeName.substr(5);
            }
            attributeName = attributeName.substr(15);
            iElement.attr(attributeName, value);
          }
        };

        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
          scope.$watch('interpolateParams', updateTranslations, true);
        }

        // Replaced watcher on translateLanguage with event listener
        scope.$on('translateLanguageChanged', updateTranslations);

        // Ensures the text will be refreshed after the current language was changed
        // w/ $translate.use(...)
        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

        // ensure translation will be looked up at least one
        if (iElement.text().length) {
          if (iAttr.translate) {
            observeElementTranslation(iAttr.translate);
          } else {
            observeElementTranslation('');
          }
        } else if (iAttr.translate) {
          // ensure attribute will be not skipped
          observeElementTranslation(iAttr.translate);
        }
        updateTranslations();
        scope.$on('$destroy', unbind);
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return getTranslateNamespace(scope.$parent);
  }
}

translateDirective.displayName = 'translateDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate-attr
 * @restrict A
 *
 * @description
 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
 * Internally it uses `translate` service to translate translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
          $rootScope.$digest();
          expect(element.attr('placeholder)).toBe('Hello there!');
          expect(element.attr('title)).toBe('The following value is dynamic: 5');
        });
      });
    </file>
   </example>
 */
.directive('translateAttr', translateAttrDirective);
function translateAttrDirective($translate, $rootScope) {

  'use strict';

  return {
    restrict: 'A',
    priority: $translate.directivePriority(),
    link: function linkFn(scope, element, attr) {

      var translateAttr,
          translateValues,
          translateSanitizeStrategy,
          previousAttributes = {};

      // Main update translations function
      var updateTranslations = function () {
        angular.forEach(translateAttr, function (translationId, attributeName) {
          if (!translationId) {
            return;
          }
          previousAttributes[attributeName] = true;

          // if translation id starts with '.' and translateNamespace given, prepend namespace
          if (scope.translateNamespace && translationId.charAt(0) === '.') {
            translationId = scope.translateNamespace + translationId;
          }
          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
            .then(function (translation) {
              element.attr(attributeName, translation);
            }, function (translationId) {
              element.attr(attributeName, translationId);
            });
        });

        // Removing unused attributes that were previously used
        angular.forEach(previousAttributes, function (flag, attributeName) {
          if (!translateAttr[attributeName]) {
            element.removeAttr(attributeName);
            delete previousAttributes[attributeName];
          }
        });
      };

      // Watch for attribute changes
      watchAttribute(
        scope,
        attr.translateAttr,
        function (newValue) { translateAttr = newValue; },
        updateTranslations
      );
      // Watch for value changes
      watchAttribute(
        scope,
        attr.translateValues,
        function (newValue) { translateValues = newValue; },
        updateTranslations
      );
      // Watch for sanitize strategy changes
      watchAttribute(
        scope,
        attr.translateSanitizeStrategy,
        function (newValue) { translateSanitizeStrategy = newValue; },
        updateTranslations
      );

      if (attr.translateValues) {
        scope.$watch(attr.translateValues, updateTranslations, true);
      }

      // Replaced watcher on translateLanguage with event listener
      scope.$on('translateLanguageChanged', updateTranslations);

      // Ensures the text will be refreshed after the current language was changed
      // w/ $translate.use(...)
      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

      updateTranslations();
      scope.$on('$destroy', unbind);
    }
  };
}

function watchAttribute(scope, attribute, valueCallback, changeCallback) {
  'use strict';
  if (!attribute) {
    return;
  }
  if (attribute.substr(0, 2) === '::') {
    attribute = attribute.substr(2);
  } else {
    scope.$watch(attribute, function(newValue) {
      valueCallback(newValue);
      changeCallback();
    }, true);
  }
  valueCallback(scope.$eval(attribute));
}

translateAttrDirective.displayName = 'translateAttrDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateCloak
 * @requires $translate
 * @restrict A
 *
 * $description
 * Adds a `translate-cloak` class name to the given element where this directive
 * is applied initially and removes it, once a loader has finished loading.
 *
 * This directive can be used to prevent initial flickering when loading translation
 * data asynchronously.
 *
 * The class name is defined in
 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
 *
 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
 *                                  or hiding the cloak. Basically it relies on the translation
 *                                  resolve.
 */
.directive('translateCloak', translateCloakDirective);

function translateCloakDirective($translate, $rootScope) {

  'use strict';

  return {
    compile : function (tElement) {
      var applyCloak = function (element) {
          element.addClass($translate.cloakClassName());
        },
        removeCloak = function (element) {
          element.removeClass($translate.cloakClassName());
        };
      applyCloak(tElement);

      return function linkFn(scope, iElement, iAttr) {
        //Create bound functions that incorporate the active DOM element.
        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
        if (iAttr.translateCloak && iAttr.translateCloak.length) {
          // Register a watcher for the defined translation allowing a fine tuned cloak
          iAttr.$observe('translateCloak', function (translationId) {
            $translate(translationId).then(iRemoveCloak, iApplyCloak);
          });
          $rootScope.$on('$translateChangeSuccess', function () {
            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
          });
        } else {
          $translate.onReady(iRemoveCloak);
        }
      };
    }
  };
}

translateCloakDirective.displayName = 'translateCloakDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateNamespace
 * @restrict A
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses `translate` filter to translate translation id. It is possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate namespace name which could be either string or interpolated string.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div translate-namespace="CONTENT">

        <div>
            <h1 translate>.HEADERS.TITLE</h1>
            <h1 translate>.HEADERS.WELCOME</h1>
        </div>

        <div translate-namespace=".HEADERS">
            <h1 translate>.TITLE</h1>
            <h1 translate>.WELCOME</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'CONTENT': {
            'HEADERS': {
                TITLE: 'Title'
            }
          },
          'CONTENT.HEADERS.WELCOME': 'Welcome'
        }).preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateNamespace', translateNamespaceDirective);

function translateNamespaceDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return {
        pre: function (scope, iElement, iAttrs) {
          scope.translateNamespace = _getTranslateNamespace(scope);

          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
            scope.translateNamespace += iAttrs.translateNamespace;
          } else {
            scope.translateNamespace = iAttrs.translateNamespace;
          }
        }
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function _getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return _getTranslateNamespace(scope.$parent);
  }
}

translateNamespaceDirective.displayName = 'translateNamespaceDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateLanguage
 * @restrict A
 *
 * @description
 * Forces the language to the directives in the underlying scope.
 *
 * @param {string=} translate language that will be negotiated.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div>

        <div>
            <h1 translate>HELLO</h1>
        </div>

        <div translate-language="de">
            <h1 translate>HELLO</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider
          .translations('en',{
            'HELLO': 'Hello world!'
          })
          .translations('de',{
            'HELLO': 'Hallo Welt!'
          })
          .preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateLanguage', translateLanguageDirective);

function translateLanguageDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return function linkFn(scope, iElement, iAttrs) {

        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
          scope.translateLanguage = newTranslateLanguage;
        });

        scope.$watch('translateLanguage', function(){
          scope.$broadcast('translateLanguageChanged');
        });
      };
    }
  };
}

translateLanguageDirective.displayName = 'translateLanguageDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc filter
 * @name pascalprecht.translate.filter:translate
 * @requires $parse
 * @requires pascalprecht.translate.$translate
 * @function
 *
 * @description
 * Uses `$translate` service to translate contents. Accepts interpolate parameters
 * to pass dynamized values though translation.
 *
 * @param {string} translationId A translation id to be translated.
 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
 *
 * @returns {string} Translated text.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
        <pre>{{ translationId | translate }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en', {
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}'
        });
        $translateProvider.preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
   </example>
 */
.filter('translate', translateFilterFactory);

function translateFilterFactory($parse, $translate) {

  'use strict';

  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
    if (!angular.isObject(interpolateParams)) {
      var ctx = this || {
        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
        };
      interpolateParams = $parse(interpolateParams)(ctx);
    }

    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
  };

  if ($translate.statefulFilter()) {
    translateFilter.$stateful = true;
  }

  return translateFilter;
}

translateFilterFactory.displayName = 'translateFilterFactory';

angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translationCache
 * @requires $cacheFactory
 *
 * @description
 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
 * can load translation tables directly into the cache by consuming the
 * `$translationCache` service directly.
 *
 * @return {object} $cacheFactory object.
 */
  .factory('$translationCache', $translationCache);

function $translationCache($cacheFactory) {

  'use strict';

  return $cacheFactory('translations');
}

$translationCache.displayName = '$translationCache';
return 'pascalprecht.translate';

}));


/***/ }),
/* 605 */
/***/ (function(module, exports) {

angular.module('ui.bootstrap.datetimepicker', ["ui.bootstrap.dateparser", "ui.bootstrap.datepicker", "ui.bootstrap.timepicker"])
  .directive('datepickerPopup', function () {
    return {
      restrict: 'EAC',
      require: 'ngModel',
      link: function (scope, element, attr, controller) {
        //remove the default formatter from the input directive to prevent conflict
        controller.$formatters.shift();
      }
    }
  })
  .directive('datetimepicker', [
    function () {

      function versionCheck(){
        return (angular.version.major === 1 && (angular.version.minor > 4 || (angular.version.minor === 4 && angular.version.dot >= 4)));
      }

      if (!versionCheck()) {
        return {
          restrict: 'EA',
          template: "<div class=\"alert alert-danger\">Angular 1.4.4 or above is required for datetimepicker to work correctly</div>"
        };
      }
      return {
        restrict: 'EA',
        require: 'ngModel',
        scope: {
          ngModel: '=',
          ngChange: '&',
          dayFormat: "=",
          monthFormat: "=",
          yearFormat: "=",
          minTime: "=",
          maxTime: "=",
          dayHeaderFormat: "=",
          dayTitleFormat: "=",
          monthTitleFormat: "=",
          yearRange: "=",
          showButtonBar: "=",
          dateOptions: "=?",
          dateDisabled: "&",
          dateNgClick: "&",
          dateNgFocus: "&",
          hourStep: "=",
          dateOpened: "=",
          minuteStep: "=",
          showMeridian: "=",
          meredians: "=",
          mousewheel: "=",
          readonlyTime: "=",
          readonlyDate: "=",
          disabledDate: "=",
          hiddenTime: "=",
          hiddenDate: "=",
          datepickerTemplateUrl: "@",
          datepickerPopupTemplateUrl: "@",
          timepickerTemplateUrl: "@"
        },
        template: function (elem, attrs) {
          function dashCase(name) {
            return name.replace(/[A-Z]/g, function (letter, pos) {
              return (pos ? '-' : '') + letter.toLowerCase();
            });
          }

          function createAttr(innerAttr, dateTimeAttrOpt) {
            var dateTimeAttr = angular.isDefined(dateTimeAttrOpt) ? dateTimeAttrOpt : innerAttr;
            if (attrs[dateTimeAttr]) {
              return dashCase(innerAttr) + "=\"" + dateTimeAttr + "\" ";
            } else {
              return '';
            }
          }

          function createFuncAttr(innerAttr, funcArgs, dateTimeAttrOpt, defaultImpl) {
            var dateTimeAttr = angular.isDefined(dateTimeAttrOpt) ? dateTimeAttrOpt : innerAttr;
            if (attrs[dateTimeAttr]) {
              return dashCase(innerAttr) + "=\"" + dateTimeAttr + "({" + funcArgs + "})\" ";
            } else {
              return angular.isDefined(defaultImpl) ? dashCase(innerAttr) + "=\"" + defaultImpl + "\"" : "";
            }
          }

          function createEvalAttr(innerAttr, dateTimeAttrOpt) {
            var dateTimeAttr = angular.isDefined(dateTimeAttrOpt) ? dateTimeAttrOpt : innerAttr;
            if (attrs[dateTimeAttr]) {
              return dashCase(innerAttr) + "=\"" + attrs[dateTimeAttr] + "\" ";
            } else {
              return dashCase(innerAttr) + " ";
            }
          }

          function createAttrConcat(previousAttrs, attr) {
            return previousAttrs + createAttr.apply(null, attr)
          }

          var dateTmpl = "<div class=\"datetimepicker-wrapper\">" +
            "<input class=\"form-control\" type=\"text\" " +
            "name=\"datepicker\"" +
            "ng-change=\"date_change($event)\" " +
            "is-open=\"innerDateOpened\" " +
            "datepicker-options=\"dateOptions\" " +
            "uib-datepicker-popup=\"{{dateFormat}}\"" +
            "ng-model=\"ngModel\" " + [
              ["dayFormat"],
              ["monthFormat"],
              ["yearFormat"],
              ["dayHeaderFormat"],
              ["dayTitleFormat"],
              ["monthTitleFormat"],
              ["yearRange"],
              ["showButtonBar"],
              ["ngHide", "hiddenDate"],
              ["ngReadonly", "readonlyDate"],
              ["ngDisabled", "disabledDate"]
            ].reduce(createAttrConcat, '') +
            createFuncAttr("ngClick",
              "$event: $event, opened: opened",
              "dateNgClick",
              "open($event)") +
            createFuncAttr("ngFocus",
              "$event: $event, opened: opened",
              "dateNgFocus",
              "open($event)") +
            createEvalAttr("currentText", "currentText") +
            createEvalAttr("datepickerTemplateUrl", "datepickerTemplateUrl") +
            createEvalAttr("datepickerPopupTemplateUrl", "datepickerPopupTemplateUrl") +
            createEvalAttr("clearText", "clearText") +
            createEvalAttr("datepickerAppendToBody", "datepickerAppendToBody") +
            createEvalAttr("closeText", "closeText") +
            createEvalAttr("placeholder", "placeholder") +
            "/>\n" +
            "</div>\n";
          var timeTmpl = "<div class=\"datetimepicker-wrapper\" name=\"timepicker\" ng-model=\"time\" ng-change=\"time_change()\" style=\"display:inline-block\">\n" +
            "<div uib-timepicker min=\"minDate\" max=\"maxDate\" " + [
              ["hourStep"],
              ["minuteStep"],
              ["showMeridian"],
              ["meredians"],
              ["mousewheel"],
              ["ngHide", "hiddenTime"],
              ["ngDisabled", "readonlyTime"]
            ].reduce(createAttrConcat, '') +
            createEvalAttr("showSpinners", "showSpinners") +
            createEvalAttr("templateUrl", "timepickerTemplateUrl") +
            "></div>\n" +
            "</div>";
          // form is isolated so the directive is registered as one component in the parent form (not date and time)
          var tmpl = "<ng-form name=\"datetimepickerForm\" isolate-form>" + dateTmpl + timeTmpl + "</ng-form>";
          return tmpl;
        },
        controller: ['$scope', '$attrs',
          function ($scope, $attrs) {
            $scope.date_change = function () {
              // If we changed the date only, set the time (h,m) on it.
              // This is important in case the previous date was null.
              // This solves the issue when the user set a date and time, cleared the date, and chose another date,
              // and then, the time was cleared too - which is unexpected
              var time = $scope.time;
              if ($scope.ngModel && $scope.time) { // if ngModel is null, that's because the user cleared the date field
                $scope.ngModel.setHours(time.getHours(), time.getMinutes(), 0, 0);
                $scope.ngModel = new Date($scope.ngModel); // By default, ngModel watches the model by reference, not value. This is important to know when binding inputs to models that are objects (e.g. Date) (from: https://docs.angularjs.org/api/ng/directive/ngModel)
              }
            };
            $scope.time_change = function () {
              if ($scope.ngModel && $scope.time) {
                $scope.ngModel.setHours($scope.time.getHours(), $scope.time.getMinutes(), 0, 0);
                $scope.ngModel = new Date($scope.ngModel); // By default, ngModel watches the model by reference, not value. This is important to know when binding inputs to models that are objects (e.g. Date) (from: https://docs.angularjs.org/api/ng/directive/ngModel)
              }  // else the time is invalid, keep the current Date value in datepicker
            };
            $scope.open = function ($event) {
              $event.preventDefault();
              $event.stopPropagation();
              $scope.innerDateOpened = true;
            };
            $attrs.$observe('dateFormat', function(newDateFormat, oldValue) {
              $scope.dateFormat = newDateFormat;
            });
            $scope.dateOptions = angular.isDefined($scope.dateOptions) ? $scope.dateOptions : {};
            $scope.dateOptions.dateDisabled = $scope.dateDisabled;
          }
        ],
        link: function (scope, element, attrs, ctrl) {
          var updateMinTime = function() {
            if (!scope.ngModel) {
              return;
            }
            if (scope.minTime) {
              scope.minDate = new Date(scope.ngModel.getFullYear(),
                                       scope.ngModel.getMonth(),
                                       scope.ngModel.getDate(),
                                       scope.minTime.getHours(),
                                       scope.minTime.getMinutes(),
                                       0);
              if (scope.dateOptions.minDate && scope.dateOptions.minDate > scope.minDate) {
                scope.minDate = scope.dateOptions.minDate;
              }
            } else {
              scope.minDate = scope.dateOptions.minDate;
            }
          };
          var updateMaxTime = function() {
            if (!scope.ngModel) {
              return;
            }
            if (scope.maxTime) {
              scope.maxDate = new Date(scope.ngModel.getFullYear(),
                                       scope.ngModel.getMonth(),
                                       scope.ngModel.getDate(),
                                       scope.maxTime.getHours(),
                                       scope.maxTime.getMinutes(),
                                       0);
              if (scope.dateOptions.maxDate && scope.dateOptions.maxDate < scope.maxDate) {
                scope.maxDate = scope.dateOptions.maxDate;
              }
            } else {
              scope.maxDate = scope.dateOptions.maxDate;
            }
          };

          var firstTimeAssign = true;

          scope.$watch(function () {
            return scope.ngModel;
          }, function (newTime) {
            if (scope.ngModel && !(scope.ngModel instanceof Date)) {
                // convert from ISO format to Date
                scope.ngModel = new Date(scope.ngModel);
            }

            var timeElement = element[0].querySelector('[name=timepicker]');

            // if a time element is focused, updating its model will cause hours/minutes to be formatted by padding with leading zeros
            if (timeElement && !timeElement.contains(document.activeElement)) {

              if (newTime === null || newTime === '') { // if the newTime is not defined
                if (firstTimeAssign) { // if it's the first time we assign the time value
                  // create a new default time where the hours, minutes, seconds and milliseconds are set to 0.
                  newTime = new Date();
                  newTime.setHours(0, 0, 0, 0);
                } else { // clear the time
                  scope.time = null;
                  if (scope.ngChange) scope.$eval(scope.ngChange);
                  return;
                }
              }
              // Update timepicker (watch on ng-model in timepicker does not use object equality),
              // also if the ngModel was not a Date, convert it to date
              newTime = new Date(newTime);

              if (isNaN(newTime.getTime()) === false) {
                scope.time = newTime; // change the time in timepicker
                if (firstTimeAssign) {
                  firstTimeAssign = false;
                }
              }
            }
            updateMinTime();
            updateMaxTime();
            if (scope.ngChange) {
              scope.$eval(scope.ngChange);
            }
          }, true);

          scope.$watch(function () {
            return scope.datetimepickerForm && Object.keys(scope.datetimepickerForm.$error);
          }, function (errors) {
            if (angular.isUndefined(errors)) {
              return;
            }
            Object.keys(ctrl.$error).forEach(function (error) {
              ctrl.$setValidity(error, true);
            });
            errors.forEach(function (error) {
              ctrl.$setValidity(error, false);
            });
          }, true);

          scope.$watch(function () {
            return scope.datetimepickerForm && (scope.datetimepickerForm.timepicker.$touched || scope.datetimepickerForm.datepicker.$touched);
          }, function (touched) {
            if (touched) {
              ctrl.$setTouched();
            }
          });

          scope.$watch(function () {
            return scope.datetimepickerForm && scope.datetimepickerForm.$dirty;
          }, function (dirty) {
            if (dirty) {
              ctrl.$setDirty();
            }
          });

          scope.$watch('dateOpened', function (value) {
            scope.innerDateOpened = value;
          });
          scope.$watch('innerDateOpened', function (value) {
            if (angular.isDefined(scope.dateOpened)) {
              scope.dateOpened = value;
            }
          });
          scope.$watch('dateOptions.minDate', function (value) {
            updateMinTime();
          });
          scope.$watch('timeMin', function (value) {
            updateMinTime();
          });
          scope.$watch('dateOptions.maxDate', function (value) {
            updateMaxTime();
          });
          scope.$watch('timeMax', function (value) {
            updateMaxTime();
          });
        }
      }
    }
  ]).directive('isolateForm', [function () {
  return {
    restrict: 'A',
    require: '?form',
    link: function (scope, element, attrs, formController) {
      if (!formController) {
        return;
      }   
     
      // Remove this form from parent controller
      formController.$$parentForm.$removeControl(formController)
      if (!formController.$$parentForm) {
        return; 
      } 
      var _handler = formController.$setValidity;
      formController.$setValidity = function (validationErrorKey, isValid, cntrl) {
          _handler.call(formController, validationErrorKey, isValid, cntrl);
          formController.$$parentForm.$setValidity(validationErrorKey, true, this);
      }
    }
  };
}]);


/***/ }),
/* 606 */
/***/ (function(module, exports) {

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 2.5.0 - 2017-01-28
 * License: MIT
 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.tabindex","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.multiMap","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
    return {
      link: function(scope, element, attrs) {
        var expandingExpr = $parse(attrs.expanding),
          expandedExpr = $parse(attrs.expanded),
          collapsingExpr = $parse(attrs.collapsing),
          collapsedExpr = $parse(attrs.collapsed),
          horizontal = false,
          css = {},
          cssTo = {};

        init();

        function init() {
          horizontal = !!('horizontal' in attrs);
          if (horizontal) {
            css = {
              width: ''
            };
            cssTo = {width: '0'};
          } else {
            css = {
              height: ''
            };
            cssTo = {height: '0'};
          }
          if (!scope.$eval(attrs.uibCollapse)) {
            element.addClass('in')
              .addClass('collapse')
              .attr('aria-expanded', true)
              .attr('aria-hidden', false)
              .css(css);
          }
        }

        function getScrollFromElement(element) {
          if (horizontal) {
            return {width: element.scrollWidth + 'px'};
          }
          return {height: element.scrollHeight + 'px'};
        }

        function expand() {
          if (element.hasClass('collapse') && element.hasClass('in')) {
            return;
          }

          $q.resolve(expandingExpr(scope))
            .then(function() {
              element.removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', true)
                .attr('aria-hidden', false);

              if ($animateCss) {
                $animateCss(element, {
                  addClass: 'in',
                  easing: 'ease',
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).start()['finally'](expandDone);
              } else {
                $animate.addClass(element, 'in', {
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).then(expandDone);
              }
            }, angular.noop);
        }

        function expandDone() {
          element.removeClass('collapsing')
            .addClass('collapse')
            .css(css);
          expandedExpr(scope);
        }

        function collapse() {
          if (!element.hasClass('collapse') && !element.hasClass('in')) {
            return collapseDone();
          }

          $q.resolve(collapsingExpr(scope))
            .then(function() {
              element
              // IMPORTANT: The width must be set before adding "collapsing" class.
              // Otherwise, the browser attempts to animate from width 0 (in
              // collapsing class) to the given width here.
                .css(getScrollFromElement(element[0]))
                // initially all panel collapse have the collapse class, this removal
                // prevents the animation from jumping to collapsed state
                .removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', false)
                .attr('aria-hidden', true);

              if ($animateCss) {
                $animateCss(element, {
                  removeClass: 'in',
                  to: cssTo
                }).start()['finally'](collapseDone);
              } else {
                $animate.removeClass(element, 'in', {
                  to: cssTo
                }).then(collapseDone);
              }
            }, angular.noop);
        }

        function collapseDone() {
          element.css(cssTo); // Required so that collapse works when animation is disabled
          element.removeClass('collapsing')
            .addClass('collapse');
          collapsedExpr(scope);
        }

        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.tabindex', [])

.directive('uibTabindexToggle', function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      attrs.$observe('disabled', function(disabled) {
        attrs.$set('tabindex', disabled ? -1 : null);
      });
    }
  };
});

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])

.constant('uibAccordionConfig', {
  closeOthers: true
})

.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function(openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ?
      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function(group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function(groupScope) {
    var that = this;
    this.groups.push(groupScope);

    groupScope.$on('$destroy', function(event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function(group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('uibAccordion', function() {
  return {
    controller: 'UibAccordionController',
    controllerAs: 'accordion',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
    }
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('uibAccordionGroup', function() {
  return {
    require: '^uibAccordion',         // We need this directive to be inside an accordion
    transclude: true,              // It transcludes the contents of the directive into the template
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
    },
    scope: {
      heading: '@',               // Interpolate the heading attribute onto this scope
      panelClass: '@?',           // Ditto with panelClass
      isOpen: '=?',
      isDisabled: '=?'
    },
    controller: function() {
      this.setHeading = function(element) {
        this.heading = element;
      };
    },
    link: function(scope, element, attrs, accordionCtrl) {
      element.addClass('panel');
      accordionCtrl.addGroup(scope);

      scope.openClass = attrs.openClass || 'panel-open';
      scope.panelClass = attrs.panelClass || 'panel-default';
      scope.$watch('isOpen', function(value) {
        element.toggleClass(scope.openClass, !!value);
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });

      scope.toggleOpen = function($event) {
        if (!scope.isDisabled) {
          if (!$event || $event.which === 32) {
            scope.isOpen = !scope.isOpen;
          }
        }
      };

      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
      scope.headingId = id + '-tab';
      scope.panelId = id + '-panel';
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
.directive('uibAccordionHeading', function() {
  return {
    transclude: true,   // Grab the contents to be used as the heading
    template: '',       // In effect remove this element!
    replace: true,
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
.directive('uibAccordionTransclude', function() {
  return {
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, controller) {
      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
        if (heading) {
          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
          elem.html('');
          elem.append(heading);
        }
      });
    }
  };

  function getHeaderSelectors() {
      return 'uib-accordion-header,' +
          'data-uib-accordion-header,' +
          'x-uib-accordion-header,' +
          'uib\\:accordion-header,' +
          '[uib-accordion-header],' +
          '[data-uib-accordion-header],' +
          '[x-uib-accordion-header]';
  }
});

angular.module('ui.bootstrap.alert', [])

.controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function($scope, $element, $attrs, $interpolate, $timeout) {
  $scope.closeable = !!$attrs.close;
  $element.addClass('alert');
  $attrs.$set('role', 'alert');
  if ($scope.closeable) {
    $element.addClass('alert-dismissible');
  }

  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

  if (dismissOnTimeout) {
    $timeout(function() {
      $scope.close();
    }, parseInt(dismissOnTimeout, 10));
  }
}])

.directive('uibAlert', function() {
  return {
    controller: 'UibAlertController',
    controllerAs: 'alert',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/alert/alert.html';
    },
    transclude: true,
    scope: {
      close: '&'
    }
  };
});

angular.module('ui.bootstrap.buttons', [])

.constant('uibButtonConfig', {
  activeClass: 'active',
  toggleEvent: 'click'
})

.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
  this.activeClass = buttonConfig.activeClass || 'active';
  this.toggleEvent = buttonConfig.toggleEvent || 'click';
}])

.directive('uibBtnRadio', ['$parse', function($parse) {
  return {
    require: ['uibBtnRadio', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'buttons',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      var uncheckableExpr = $parse(attrs.uibUncheckable);

      element.find('input').css({display: 'none'});

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        var isActive = element.hasClass(buttonsCtrl.activeClass);

        if (!isActive || angular.isDefined(attrs.uncheckable)) {
          scope.$apply(function() {
            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
            ngModelCtrl.$render();
          });
        }
      });

      if (attrs.uibUncheckable) {
        scope.$watch(uncheckableExpr, function(uncheckable) {
          attrs.$set('uncheckable', uncheckable ? '' : undefined);
        });
      }
    }
  };
}])

.directive('uibBtnCheckbox', function() {
  return {
    require: ['uibBtnCheckbox', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'button',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      element.find('input').css({display: 'none'});

      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }

      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }

      function getCheckboxValue(attribute, defaultValue) {
        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
      }

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        scope.$apply(function() {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
    }
  };
});

angular.module('ui.bootstrap.carousel', [])

.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    SLIDE_DIRECTION = 'uib-slideDirection',
    currentIndex = $scope.active,
    currentInterval, isPlaying;

  var destroyed = false;
  $element.addClass('carousel');

  self.addSlide = function(slide, element) {
    slides.push({
      slide: slide,
      element: element
    });
    slides.sort(function(a, b) {
      return +a.slide.index - +b.slide.index;
    });
    //if this is the first slide or the slide is set to active, select it
    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition = null;
      }

      currentIndex = slide.index;
      $scope.active = slide.index;
      setActive(currentIndex);
      self.select(slides[findSlideIndex(slide)]);
      if (slides.length === 1) {
        $scope.play();
      }
    }
  };

  self.getCurrentIndex = function() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide.index === currentIndex) {
        return i;
      }
    }
  };

  self.next = $scope.next = function() {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;

    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'next');
  };

  self.prev = $scope.prev = function() {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

    if ($scope.noWrap() && newIndex === slides.length - 1) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'prev');
  };

  self.removeSlide = function(slide) {
    var index = findSlideIndex(slide);

    //get the index of the slide inside the carousel
    slides.splice(index, 1);
    if (slides.length > 0 && currentIndex === index) {
      if (index >= slides.length) {
        currentIndex = slides.length - 1;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[slides.length - 1]);
      } else {
        currentIndex = index;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
      $scope.active = currentIndex;
    }

    //clean the active value when no more slide
    if (slides.length === 0) {
      currentIndex = null;
      $scope.active = null;
    }
  };

  /* direction: "prev" or "next" */
  self.select = $scope.select = function(nextSlide, direction) {
    var nextIndex = findSlideIndex(nextSlide.slide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide.slide.index !== currentIndex &&
      !$scope.$currentTransition) {
      goNext(nextSlide.slide, nextIndex, direction);
    }
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function(slide) {
    return +slide.slide.index;
  };

  $scope.isActive = function(slide) {
    return $scope.active === slide.slide.index;
  };

  $scope.isPrevDisabled = function() {
    return $scope.active === 0 && $scope.noWrap();
  };

  $scope.isNextDisabled = function() {
    return $scope.active === slides.length - 1 && $scope.noWrap();
  };

  $scope.pause = function() {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };

  $element.on('mouseenter', $scope.pause);
  $element.on('mouseleave', $scope.play);

  $scope.$on('$destroy', function() {
    destroyed = true;
    resetTimer();
  });

  $scope.$watch('noTransition', function(noTransition) {
    $animate.enabled($element, !noTransition);
  });

  $scope.$watch('interval', restartTimer);

  $scope.$watchCollection('slides', resetTransition);

  $scope.$watch('active', function(index) {
    if (angular.isNumber(index) && currentIndex !== index) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].slide.index === index) {
          index = i;
          break;
        }
      }

      var slide = slides[index];
      if (slide) {
        setActive(index);
        self.select(slides[index]);
        currentIndex = index;
      }
    }
  });

  function getSlideByIndex(index) {
    for (var i = 0, l = slides.length; i < l; ++i) {
      if (slides[i].index === index) {
        return slides[i];
      }
    }
  }

  function setActive(index) {
    for (var i = 0; i < slides.length; i++) {
      slides[i].slide.active = i === index;
    }
  }

  function goNext(slide, index, direction) {
    if (destroyed) {
      return;
    }

    angular.extend(slide, {direction: direction});
    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
    if ($animate.enabled($element) && !$scope.$currentTransition &&
      slides[index].element && self.slides.length > 1) {
      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
      var currentIdx = self.getCurrentIndex();

      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
      }

      $scope.$currentTransition = true;
      $animate.on('addClass', slides[index].element, function(element, phase) {
        if (phase === 'close') {
          $scope.$currentTransition = null;
          $animate.off('addClass', element);
        }
      });
    }

    $scope.active = slide.index;
    currentIndex = slide.index;
    setActive(index);

    //every time you change slides, reset the timer
    restartTimer();
  }

  function findSlideIndex(slide) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide === slide) {
        return i;
      }
    }
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function resetTransition(slides) {
    if (!slides.length) {
      $scope.$currentTransition = null;
    }
  }

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }
}])

.directive('uibCarousel', function() {
  return {
    transclude: true,
    controller: 'UibCarouselController',
    controllerAs: 'carousel',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
    },
    scope: {
      active: '=',
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&'
    }
  };
})

.directive('uibSlide', ['$animate', function($animate) {
  return {
    require: '^uibCarousel',
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/slide.html';
    },
    scope: {
      actual: '=?',
      index: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      element.addClass('item');
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function(active) {
        $animate[active ? 'addClass' : 'removeClass'](element, 'active');
      });
    }
  };
}])

.animation('.item', ['$animateCss',
function($animateCss) {
  var SLIDE_DIRECTION = 'uib-slideDirection';

  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }

  return {
    beforeAddClass: function(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element,
          directionClass + ' ' + direction, done);
        element.addClass(direction);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function (element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    }
  };
}]);

angular.module('ui.bootstrap.dateparser', [])

.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function($log, $locale, dateFilter, orderByFilter, filterFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  var localeId;
  var formatCodeToRegex;

  this.init = function() {
    localeId = $locale.id;

    this.parsers = {};
    this.formatters = {};

    formatCodeToRegex = [
      {
        key: 'yyyy',
        regex: '\\d{4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yyyy');
        }
      },
      {
        key: 'yy',
        regex: '\\d{2}',
        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yy');
        }
      },
      {
        key: 'y',
        regex: '\\d{1,4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'y');
        }
      },
      {
        key: 'M!',
        regex: '0?[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) {
          var value = date.getMonth();
          if (/^[0-9]$/.test(value)) {
            return dateFilter(date, 'MM');
          }

          return dateFilter(date, 'M');
        }
      },
      {
        key: 'MMMM',
        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMMM'); }
      },
      {
        key: 'MMM',
        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMM'); }
      },
      {
        key: 'MM',
        regex: '0[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'MM'); }
      },
      {
        key: 'M',
        regex: '[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'M'); }
      },
      {
        key: 'd!',
        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) {
          var value = date.getDate();
          if (/^[1-9]$/.test(value)) {
            return dateFilter(date, 'dd');
          }

          return dateFilter(date, 'd');
        }
      },
      {
        key: 'dd',
        regex: '[0-2][0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'dd'); }
      },
      {
        key: 'd',
        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'd'); }
      },
      {
        key: 'EEEE',
        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEEE'); }
      },
      {
        key: 'EEE',
        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEE'); }
      },
      {
        key: 'HH',
        regex: '(?:0|1)[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'HH'); }
      },
      {
        key: 'hh',
        regex: '0[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'hh'); }
      },
      {
        key: 'H',
        regex: '1?[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'H'); }
      },
      {
        key: 'h',
        regex: '[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'h'); }
      },
      {
        key: 'mm',
        regex: '[0-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'mm'); }
      },
      {
        key: 'm',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'm'); }
      },
      {
        key: 'sss',
        regex: '[0-9][0-9][0-9]',
        apply: function(value) { this.milliseconds = +value; },
        formatter: function(date) { return dateFilter(date, 'sss'); }
      },
      {
        key: 'ss',
        regex: '[0-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 'ss'); }
      },
      {
        key: 's',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 's'); }
      },
      {
        key: 'a',
        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
        apply: function(value) {
          if (this.hours === 12) {
            this.hours = 0;
          }

          if (value === 'PM') {
            this.hours += 12;
          }
        },
        formatter: function(date) { return dateFilter(date, 'a'); }
      },
      {
        key: 'Z',
        regex: '[+-]\\d{4}',
        apply: function(value) {
          var matches = value.match(/([+-])(\d{2})(\d{2})/),
            sign = matches[1],
            hours = matches[2],
            minutes = matches[3];
          this.hours += toInt(sign + hours);
          this.minutes += toInt(sign + minutes);
        },
        formatter: function(date) {
          return dateFilter(date, 'Z');
        }
      },
      {
        key: 'ww',
        regex: '[0-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'ww'); }
      },
      {
        key: 'w',
        regex: '[0-9]|[1-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'w'); }
      },
      {
        key: 'GGGG',
        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
        formatter: function(date) { return dateFilter(date, 'GGGG'); }
      },
      {
        key: 'GGG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GGG'); }
      },
      {
        key: 'GG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GG'); }
      },
      {
        key: 'G',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'G'); }
      }
    ];

    if (angular.version.major >= 1 && angular.version.minor > 4) {
      formatCodeToRegex.push({
        key: 'LLLL',
        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'LLLL'); }
      });
    }
  };

  this.init();

  function getFormatCodeToRegex(key) {
    return filterFilter(formatCodeToRegex, {key: key}, true)[0];
  }

  this.getParser = function (key) {
    var f = getFormatCodeToRegex(key);
    return f && f.apply || null;
  };

  this.overrideParser = function (key, parser) {
    var f = getFormatCodeToRegex(key);
    if (f && angular.isFunction(parser)) {
      this.parsers = {};
      f.apply = parser;
    }
  }.bind(this);

  function createParser(format) {
    var map = [], regex = format.split('');

    // check for literal values
    var quoteIndex = format.indexOf('\'');
    if (quoteIndex > -1) {
      var inLiteral = false;
      format = format.split('');
      for (var i = quoteIndex; i < format.length; i++) {
        if (inLiteral) {
          if (format[i] === '\'') {
            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
              format[i+1] = '$';
              regex[i+1] = '';
            } else { // end of literal
              regex[i] = '';
              inLiteral = false;
            }
          }
          format[i] = '$';
        } else {
          if (format[i] === '\'') { // start of literal
            format[i] = '$';
            regex[i] = '';
            inLiteral = true;
          }
        }
      }

      format = format.join('');
    }

    angular.forEach(formatCodeToRegex, function(data) {
      var index = format.indexOf(data.key);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({
          index: index,
          key: data.key,
          apply: data.apply,
          matcher: data.regex
        });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  function createFormatter(format) {
    var formatters = [];
    var i = 0;
    var formatter, literalIdx;
    while (i < format.length) {
      if (angular.isNumber(literalIdx)) {
        if (format.charAt(i) === '\'') {
          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
            formatters.push(constructLiteralFormatter(format, literalIdx, i));
            literalIdx = null;
          }
        } else if (i === format.length) {
          while (literalIdx < format.length) {
            formatter = constructFormatterFromIdx(format, literalIdx);
            formatters.push(formatter);
            literalIdx = formatter.endIdx;
          }
        }

        i++;
        continue;
      }

      if (format.charAt(i) === '\'') {
        literalIdx = i;
        i++;
        continue;
      }

      formatter = constructFormatterFromIdx(format, i);

      formatters.push(formatter.parser);
      i = formatter.endIdx;
    }

    return formatters;
  }

  function constructLiteralFormatter(format, literalIdx, endIdx) {
    return function() {
      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
    };
  }

  function constructFormatterFromIdx(format, i) {
    var currentPosStr = format.substr(i);
    for (var j = 0; j < formatCodeToRegex.length; j++) {
      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
        var data = formatCodeToRegex[j];
        return {
          endIdx: i + data.key.length,
          parser: data.formatter
        };
      }
    }

    return {
      endIdx: i + 1,
      parser: function() {
        return currentPosStr.charAt(0);
      }
    };
  }

  this.filter = function(date, format) {
    if (!angular.isDate(date) || isNaN(date) || !format) {
      return '';
    }

    format = $locale.DATETIME_FORMATS[format] || format;

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.formatters[format]) {
      this.formatters[format] = createFormatter(format);
    }

    var formatters = this.formatters[format];

    return formatters.reduce(function(str, formatter) {
      return str + formatter(date);
    }, '');
  };

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format, 'apply');
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex),
        tzOffset = false;
    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i - 1];
        if (mapper.matcher === 'Z') {
          tzOffset = true;
        }

        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
        Date.prototype.setFullYear;
      var timesetter = tzOffset ? Date.prototype.setUTCHours :
        Date.prototype.setHours;

      if (isValid(fields.year, fields.month, fields.date)) {
        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
          dt = new Date(baseDate);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours, fields.minutes,
            fields.seconds, fields.milliseconds);
        } else {
          dt = new Date(0);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
            fields.seconds || 0, fields.milliseconds || 0);
        }
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }

  function toInt(str) {
    return parseInt(str, 10);
  }

  this.toTimezone = toTimezone;
  this.fromTimezone = fromTimezone;
  this.timezoneToOffset = timezoneToOffset;
  this.addDateMinutes = addDateMinutes;
  this.convertTimezoneToLocal = convertTimezoneToLocal;

  function toTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
  }

  function fromTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
  }

  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
  function timezoneToOffset(timezone, fallback) {
    timezone = timezone.replace(/:/g, '');
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }

  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
  }
}]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
.directive('uibIsClass', [
         '$animate',
function ($animate) {
  //                    11111111          22222222
  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
  //                    11111111           22222222
  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

  var dataPerTracked = {};

  return {
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      var linkedScopes = [];
      var instances = [];
      var expToData = {};
      var lastActivated = null;
      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
      var onExp = onExpMatches[2];
      var expsStr = onExpMatches[1];
      var exps = expsStr.split(',');

      return linkFn;

      function linkFn(scope, element, attrs) {
        linkedScopes.push(scope);
        instances.push({
          scope: scope,
          element: element
        });

        exps.forEach(function(exp, k) {
          addForExp(exp, scope);
        });

        scope.$on('$destroy', removeScope);
      }

      function addForExp(exp, scope) {
        var matches = exp.match(IS_REGEXP);
        var clazz = scope.$eval(matches[1]);
        var compareWithExp = matches[2];
        var data = expToData[exp];
        if (!data) {
          var watchFn = function(compareWithVal) {
            var newActivated = null;
            instances.some(function(instance) {
              var thisVal = instance.scope.$eval(onExp);
              if (thisVal === compareWithVal) {
                newActivated = instance;
                return true;
              }
            });
            if (data.lastActivated !== newActivated) {
              if (data.lastActivated) {
                $animate.removeClass(data.lastActivated.element, clazz);
              }
              if (newActivated) {
                $animate.addClass(newActivated.element, clazz);
              }
              data.lastActivated = newActivated;
            }
          };
          expToData[exp] = data = {
            lastActivated: null,
            scope: scope,
            watchFn: watchFn,
            compareWithExp: compareWithExp,
            watcher: scope.$watch(compareWithExp, watchFn)
          };
        }
        data.watchFn(scope.$eval(compareWithExp));
      }

      function removeScope(e) {
        var removedScope = e.targetScope;
        var index = linkedScopes.indexOf(removedScope);
        linkedScopes.splice(index, 1);
        instances.splice(index, 1);
        if (linkedScopes.length) {
          var newWatchScope = linkedScopes[0];
          angular.forEach(expToData, function(data) {
            if (data.scope === removedScope) {
              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
              data.scope = newWatchScope;
            }
          });
        } else {
          expToData = {};
        }
      }
    }
  };
}]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])

.value('$datepickerSuppressError', false)

.value('$datepickerLiteralWarning', true)

.constant('uibDatepickerConfig', {
  datepickerMode: 'day',
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  maxDate: null,
  maxMode: 'year',
  minDate: null,
  minMode: 'day',
  monthColumns: 3,
  ngModelOptions: {},
  shortcutPropagation: false,
  showWeeks: true,
  yearColumns: 5,
  yearRows: 4
})

.controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
  function($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
      ngModelOptions = {},
      watchListeners = [];

  $element.addClass('uib-datepicker');
  $attrs.$set('role', 'application');

  if (!$scope.datepickerOptions) {
    $scope.datepickerOptions = {};
  }

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  [
    'customClass',
    'dateDisabled',
    'datepickerMode',
    'formatDay',
    'formatDayHeader',
    'formatDayTitle',
    'formatMonth',
    'formatMonthTitle',
    'formatYear',
    'maxDate',
    'maxMode',
    'minDate',
    'minMode',
    'monthColumns',
    'showWeeks',
    'shortcutPropagation',
    'startingDay',
    'yearColumns',
    'yearRows'
  ].forEach(function(key) {
    switch (key) {
      case 'customClass':
      case 'dateDisabled':
        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
        break;
      case 'datepickerMode':
        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
        break;
      case 'formatDay':
      case 'formatDayHeader':
      case 'formatDayTitle':
      case 'formatMonth':
      case 'formatMonthTitle':
      case 'formatYear':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
          datepickerConfig[key];
        break;
      case 'monthColumns':
      case 'showWeeks':
      case 'shortcutPropagation':
      case 'yearColumns':
      case 'yearRows':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $scope.datepickerOptions[key] : datepickerConfig[key];
        break;
      case 'startingDay':
        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
          self.startingDay = $scope.datepickerOptions.startingDay;
        } else if (angular.isNumber(datepickerConfig.startingDay)) {
          self.startingDay = datepickerConfig.startingDay;
        } else {
          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
        }

        break;
      case 'maxDate':
      case 'minDate':
        $scope.$watch('datepickerOptions.' + key, function(value) {
          if (value) {
            if (angular.isDate(value)) {
              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
            } else {
              if ($datepickerLiteralWarning) {
                $log.warn('Literal date support has been deprecated, please switch to date object usage');
              }

              self[key] = new Date(dateFilter(value, 'medium'));
            }
          } else {
            self[key] = datepickerConfig[key] ?
              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
              null;
          }

          self.refreshView();
        });

        break;
      case 'maxMode':
      case 'minMode':
        if ($scope.datepickerOptions[key]) {
          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
              $scope.datepickerMode = self[key];
              $scope.datepickerOptions.datepickerMode = self[key];
            }
          });
        } else {
          self[key] = $scope[key] = datepickerConfig[key] || null;
        }

        break;
    }
  });

  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if (angular.isDefined($attrs.ngDisabled)) {
    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
      $scope.disabled = disabled;
      self.refreshView();
    }));
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelOptions = extractOptions(ngModelCtrl);

    if ($scope.datepickerOptions.initDate) {
      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
      $scope.$watch('datepickerOptions.initDate', function(initDate) {
        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
          self.refreshView();
        }
      });
    } else {
      self.activeDate = new Date();
    }

    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
    this.activeDate = !isNaN(date) ?
      dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
      dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      $scope.selectedDt = null;
      this._refreshView();
      if ($scope.activeDt) {
        $scope.activeDateId = $scope.activeDt.uid;
      }

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setValidity('dateDisabled', !date ||
        this.element && !this.isDisabled(date));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
    var today = new Date();
    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
    var time = this.compare(date, today);
    var dt = {
      date: date,
      label: dateParser.filter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      past: time < 0,
      current: time === 0,
      future: time > 0,
      customClass: this.customClass(date) || null
    };

    if (model && this.compare(date, model) === 0) {
      $scope.selectedDt = dt;
    }

    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
      $scope.activeDt = dt;
    }

    return dt;
  };

  this.isDisabled = function(date) {
    return $scope.disabled ||
      this.minDate && this.compare(date, this.minDate) < 0 ||
      this.maxDate && this.compare(date, this.maxDate) > 0 ||
      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

      $scope.$emit('uib:datepicker.mode');
    }

    $scope.$broadcast('uib:datepicker.focus');
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
      $scope.datepickerMode === self.minMode && direction === -1) {
      return;
    }

    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

    $scope.$emit('uib:datepicker.mode');
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('uib:datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };

  $element.on('keydown', function(evt) {
    $scope.$apply(function() {
      $scope.keydown(evt);
    });
  });

  $scope.$on('$destroy', function() {
    //Clear all watch listeners on destroy
    while (watchListeners.length) {
      watchListeners.shift()();
    }
  });

  function setMode(mode) {
    $scope.datepickerMode = mode;
    $scope.datepickerOptions.datepickerMode = mode;
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = ngModelCtrl.$options ||
        $scope.datepickerOptions.ngModelOptions ||
        datepickerConfig.ngModelOptions ||
        {};

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
      var timezone = ngModelCtrl.$options.getOption('timezone') ||
        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);

      // values passed to createChild override existing values
      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
        .createChild($scope.datepickerOptions.ngModelOptions)
        .createChild(ngModelCtrl.$options) // highest precedence
        .createChild({timezone: timezone}); // to keep from squashing a non-null value
    }

    return ngModelOptions;
  }
}])

.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  this.step = { months: 1 };
  this.element = $element;
  function getDaysInMonth(year, month) {
    return month === 1 && year % 4 === 0 &&
      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
  }

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    scope.showWeeks = ctrl.showWeeks;
    ctrl.refreshView();
  };

  this.getDates = function(startDate, n) {
    var dates = new Array(n), current = new Date(startDate), i = 0, date;
    while (i < n) {
      date = new Date(current);
      dates[i++] = date;
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  this._refreshView = function() {
    var year = this.activeDate.getFullYear(),
      month = this.activeDate.getMonth(),
      firstDayOfMonth = new Date(this.activeDate);

    firstDayOfMonth.setFullYear(year, month, 1);

    var difference = this.startingDay - firstDayOfMonth.getDay(),
      numDisplayedFromPreviousMonth = difference > 0 ?
        7 - difference : - difference,
      firstDate = new Date(firstDayOfMonth);

    if (numDisplayedFromPreviousMonth > 0) {
      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
    }

    // 42 is the number of days on a six-week calendar
    var days = this.getDates(firstDate, 42);
    for (var i = 0; i < 42; i ++) {
      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
        secondary: days[i].getMonth() !== month,
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.labels = new Array(7);
    for (var j = 0; j < 7; j++) {
      scope.labels[j] = {
        abbr: dateFilter(days[j].date, this.formatDayHeader),
        full: dateFilter(days[j].date, 'EEEE')
      };
    }

    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
    scope.rows = this.split(days, 7);

    if (scope.showWeeks) {
      scope.weekNumbers = [];
      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
          numWeeks = scope.rows.length;
      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
        scope.weekNumbers.push(
          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
      }
    }
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  function getISO8601WeekNumber(date) {
    var checkDate = new Date(date);
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
    var time = checkDate.getTime();
    checkDate.setMonth(0); // Compare with Jan 1
    checkDate.setDate(1);
    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
  }

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getDate();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 7;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 7;
    } else if (key === 'pageup' || key === 'pagedown') {
      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setMonth(month, 1);
      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
    } else if (key === 'home') {
      date = 1;
    } else if (key === 'end') {
      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
    }
    this.activeDate.setDate(date);
  };
}])

.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  this.step = { years: 1 };
  this.element = $element;

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    ctrl.refreshView();
  };

  this._refreshView = function() {
    var months = new Array(12),
        year = this.activeDate.getFullYear(),
        date;

    for (var i = 0; i < 12; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(year, i, 1);
      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
    scope.rows = this.split(months, this.monthColumns);
    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getMonth();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - this.monthColumns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + this.monthColumns;
    } else if (key === 'pageup' || key === 'pagedown') {
      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setFullYear(year);
    } else if (key === 'home') {
      date = 0;
    } else if (key === 'end') {
      date = 11;
    }
    this.activeDate.setMonth(date);
  };
}])

.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var columns, range;
  this.element = $element;

  function getStartingYear(year) {
    return parseInt((year - 1) / range, 10) * range + 1;
  }

  this.yearpickerInit = function() {
    columns = this.yearColumns;
    range = this.yearRows * columns;
    this.step = { years: range };
  };

  this._refreshView = function() {
    var years = new Array(range), date;

    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(start + i, 0, 1);
      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = [years[0].label, years[range - 1].label].join(' - ');
    scope.rows = this.split(years, columns);
    scope.columns = columns;
  };

  this.compare = function(date1, date2) {
    return date1.getFullYear() - date2.getFullYear();
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getFullYear();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - columns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + columns;
    } else if (key === 'pageup' || key === 'pagedown') {
      date += (key === 'pageup' ? - 1 : 1) * range;
    } else if (key === 'home') {
      date = getStartingYear(this.activeDate.getFullYear());
    } else if (key === 'end') {
      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
    }
    this.activeDate.setFullYear(date);
  };
}])

.directive('uibDatepicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
    },
    scope: {
      datepickerOptions: '=?'
    },
    require: ['uibDatepicker', '^ngModel'],
    restrict: 'A',
    controller: 'UibDatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('uibDaypicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/day.html';
    },
    require: ['^uibDatepicker', 'uibDaypicker'],
    restrict: 'A',
    controller: 'UibDaypickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        daypickerCtrl = ctrls[1];

      daypickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibMonthpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/month.html';
    },
    require: ['^uibDatepicker', 'uibMonthpicker'],
    restrict: 'A',
    controller: 'UibMonthpickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        monthpickerCtrl = ctrls[1];

      monthpickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibYearpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/year.html';
    },
    require: ['^uibDatepicker', 'uibYearpicker'],
    restrict: 'A',
    controller: 'UibYearpickerController',
    link: function(scope, element, attrs, ctrls) {
      var ctrl = ctrls[0];
      angular.extend(ctrl, ctrls[1]);
      ctrl.yearpickerInit();

      ctrl.refreshView();
    }
  };
});

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
    /**
     * Used by scrollbarWidth() function to cache scrollbar's width.
     * Do not access this variable directly, use scrollbarWidth() instead.
     */
    var SCROLLBAR_WIDTH;
    /**
     * scrollbar on body and html element in IE and Edge overlay
     * content and should be considered 0 width.
     */
    var BODY_SCROLLBAR_WIDTH;
    var OVERFLOW_REGEX = {
      normal: /(auto|scroll)/,
      hidden: /(auto|scroll|hidden)/
    };
    var PLACEMENT_REGEX = {
      auto: /\s?auto?\s?/i,
      primary: /^(top|bottom|left|right)$/,
      secondary: /^(top|bottom|left|right|center)$/,
      vertical: /^(top|bottom)$/
    };
    var BODY_REGEX = /(HTML|BODY)/;

    return {

      /**
       * Provides a raw DOM element from a jQuery/jQLite element.
       *
       * @param {element} elem - The element to convert.
       *
       * @returns {element} A HTML element.
       */
      getRawNode: function(elem) {
        return elem.nodeName ? elem : elem[0] || elem;
      },

      /**
       * Provides a parsed number for a style property.  Strips
       * units and casts invalid numbers to 0.
       *
       * @param {string} value - The style value to parse.
       *
       * @returns {number} A valid number.
       */
      parseStyle: function(value) {
        value = parseFloat(value);
        return isFinite(value) ? value : 0;
      },

      /**
       * Provides the closest positioned ancestor.
       *
       * @param {element} element - The element to get the offest parent for.
       *
       * @returns {element} The closest positioned ancestor.
       */
      offsetParent: function(elem) {
        elem = this.getRawNode(elem);

        var offsetParent = elem.offsetParent || $document[0].documentElement;

        function isStaticPositioned(el) {
          return ($window.getComputedStyle(el).position || 'static') === 'static';
        }

        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || $document[0].documentElement;
      },

      /**
       * Provides the scrollbar width, concept from TWBS measureScrollbar()
       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
       * In IE and Edge, scollbar on body and html element overlay and should
       * return a width of 0.
       *
       * @returns {number} The width of the browser scollbar.
       */
      scrollbarWidth: function(isBody) {
        if (isBody) {
          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
            var bodyElem = $document.find('body');
            bodyElem.addClass('uib-position-body-scrollbar-measure');
            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
            bodyElem.removeClass('uib-position-body-scrollbar-measure');
          }
          return BODY_SCROLLBAR_WIDTH;
        }

        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
          $document.find('body').append(scrollElem);
          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
          scrollElem.remove();
        }

        return SCROLLBAR_WIDTH;
      },

      /**
       * Provides the padding required on an element to replace the scrollbar.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
       *     <li>**widthOverflow**: whether the the width is overflowing</li>
       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
       *     <li>**heightOverflow**: whether the the height is overflowing</li>
       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
       *   </ul>
       */
      scrollbarPadding: function(elem) {
        elem = this.getRawNode(elem);

        var elemStyle = $window.getComputedStyle(elem);
        var paddingRight = this.parseStyle(elemStyle.paddingRight);
        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
        var scrollParent = this.scrollParent(elem, false, true);
        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));

        return {
          scrollbarWidth: scrollbarWidth,
          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
          right: paddingRight + scrollbarWidth,
          originalRight: paddingRight,
          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
          bottom: paddingBottom + scrollbarWidth,
          originalBottom: paddingBottom
         };
      },

      /**
       * Checks to see if the element is scrollable.
       *
       * @param {element} elem - The element to check.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       *
       * @returns {boolean} Whether the element is scrollable.
       */
      isScrollable: function(elem, includeHidden) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var elemStyle = $window.getComputedStyle(elem);
        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
      },

      /**
       * Provides the closest scrollable ancestor.
       * A port of the jQuery UI scrollParent method:
       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
       *
       * @param {element} elem - The element to find the scroll parent of.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       * @param {boolean=} [includeSelf=false] - Should the element being passed be
       * included in the scrollable llokup.
       *
       * @returns {element} A HTML element.
       */
      scrollParent: function(elem, includeHidden, includeSelf) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var documentEl = $document[0].documentElement;
        var elemStyle = $window.getComputedStyle(elem);
        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
          return elem;
        }
        var excludeStatic = elemStyle.position === 'absolute';
        var scrollParent = elem.parentElement || documentEl;

        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
          return documentEl;
        }

        while (scrollParent.parentElement && scrollParent !== documentEl) {
          var spStyle = $window.getComputedStyle(scrollParent);
          if (excludeStatic && spStyle.position !== 'static') {
            excludeStatic = false;
          }

          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
            break;
          }
          scrollParent = scrollParent.parentElement;
        }

        return scrollParent;
      },

      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/ - distance to closest positioned
       * ancestor.  Does not account for margins by default like jQuery position.
       *
       * @param {element} elem - The element to caclulate the position on.
       * @param {boolean=} [includeMargins=false] - Should margins be accounted
       * for, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of offset parent</li>
       *     <li>**left**: distance to left edge of offset parent</li>
       *   </ul>
       */
      position: function(elem, includeMagins) {
        elem = this.getRawNode(elem);

        var elemOffset = this.offset(elem);
        if (includeMagins) {
          var elemStyle = $window.getComputedStyle(elem);
          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
        }
        var parent = this.offsetParent(elem);
        var parentOffset = {top: 0, left: 0};

        if (parent !== $document[0].documentElement) {
          parentOffset = this.offset(parent);
          parentOffset.top += parent.clientTop - parent.scrollTop;
          parentOffset.left += parent.clientLeft - parent.scrollLeft;
        }

        return {
          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
          top: Math.round(elemOffset.top - parentOffset.top),
          left: Math.round(elemOffset.left - parentOffset.left)
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/ - distance to viewport.  Does
       * not account for borders, margins, or padding on the body
       * element.
       *
       * @param {element} elem - The element to calculate the offset on.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of viewport</li>
       *     <li>**right**: distance to bottom edge of viewport</li>
       *   </ul>
       */
      offset: function(elem) {
        elem = this.getRawNode(elem);

        var elemBCR = elem.getBoundingClientRect();
        return {
          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
        };
      },

      /**
       * Provides offset distance to the closest scrollable ancestor
       * or viewport.  Accounts for border and scrollbar width.
       *
       * Right and bottom dimensions represent the distance to the
       * respective edge of the viewport element.  If the element
       * edge extends beyond the viewport, a negative value will be
       * reported.
       *
       * @param {element} elem - The element to get the viewport offset for.
       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
       * of the first scrollable element, default is false.
       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
       * be accounted for, default is true.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: distance to the top content edge of viewport element</li>
       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
       *     <li>**left**: distance to the left content edge of viewport element</li>
       *     <li>**right**: distance to the right content edge of viewport element</li>
       *   </ul>
       */
      viewportOffset: function(elem, useDocument, includePadding) {
        elem = this.getRawNode(elem);
        includePadding = includePadding !== false ? true : false;

        var elemBCR = elem.getBoundingClientRect();
        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};

        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
        var offsetParentBCR = offsetParent.getBoundingClientRect();

        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
        if (offsetParent === $document[0].documentElement) {
          offsetBCR.top += $window.pageYOffset;
          offsetBCR.left += $window.pageXOffset;
        }
        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

        if (includePadding) {
          var offsetParentStyle = $window.getComputedStyle(offsetParent);
          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
        }

        return {
          top: Math.round(elemBCR.top - offsetBCR.top),
          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
          left: Math.round(elemBCR.left - offsetBCR.left),
          right: Math.round(offsetBCR.right - elemBCR.right)
        };
      },

      /**
       * Provides an array of placement values parsed from a placement string.
       * Along with the 'auto' indicator, supported placement strings are:
       *   <ul>
       *     <li>top: element on top, horizontally centered on host element.</li>
       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
       *     <li>left: element on left, vertically centered on host element.</li>
       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
       *     <li>right: element on right, vertically centered on host element.</li>
       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
       *   </ul>
       * A placement string with an 'auto' indicator is expected to be
       * space separated from the placement, i.e: 'auto bottom-left'  If
       * the primary and secondary placement values do not match 'top,
       * bottom, left, right' then 'top' will be the primary placement and
       * 'center' will be the secondary placement.  If 'auto' is passed, true
       * will be returned as the 3rd value of the array.
       *
       * @param {string} placement - The placement string to parse.
       *
       * @returns {array} An array with the following values
       * <ul>
       *   <li>**[0]**: The primary placement.</li>
       *   <li>**[1]**: The secondary placement.</li>
       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
       * </ul>
       */
      parsePlacement: function(placement) {
        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
        if (autoPlace) {
          placement = placement.replace(PLACEMENT_REGEX.auto, '');
        }

        placement = placement.split('-');

        placement[0] = placement[0] || 'top';
        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
          placement[0] = 'top';
        }

        placement[1] = placement[1] || 'center';
        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
          placement[1] = 'center';
        }

        if (autoPlace) {
          placement[2] = true;
        } else {
          placement[2] = false;
        }

        return placement;
      },

      /**
       * Provides coordinates for an element to be positioned relative to
       * another element.  Passing 'auto' as part of the placement parameter
       * will enable smart placement - where the element fits. i.e:
       * 'auto left-top' will check to see if there is enough space to the left
       * of the hostElem to fit the targetElem, if not place right (same for secondary
       * top placement).  Available space is calculated using the viewportOffset
       * function.
       *
       * @param {element} hostElem - The element to position against.
       * @param {element} targetElem - The element to position.
       * @param {string=} [placement=top] - The placement for the targetElem,
       *   default is 'top'. 'center' is assumed as secondary placement for
       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
       *   <ul>
       *     <li>top</li>
       *     <li>top-right</li>
       *     <li>top-left</li>
       *     <li>bottom</li>
       *     <li>bottom-left</li>
       *     <li>bottom-right</li>
       *     <li>left</li>
       *     <li>left-top</li>
       *     <li>left-bottom</li>
       *     <li>right</li>
       *     <li>right-top</li>
       *     <li>right-bottom</li>
       *   </ul>
       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
       *   be calculated from the body element, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: Value for targetElem top.</li>
       *     <li>**left**: Value for targetElem left.</li>
       *     <li>**placement**: The resolved placement.</li>
       *   </ul>
       */
      positionElements: function(hostElem, targetElem, placement, appendToBody) {
        hostElem = this.getRawNode(hostElem);
        targetElem = this.getRawNode(targetElem);

        // need to read from prop to support tests.
        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

        placement = this.parsePlacement(placement);

        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
        var targetElemPos = {top: 0, left: 0, placement: ''};

        if (placement[2]) {
          var viewportOffset = this.viewportOffset(hostElem, appendToBody);

          var targetElemStyle = $window.getComputedStyle(targetElem);
          var adjustedSize = {
            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
          };

          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                         placement[0];

          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                         placement[1];

          if (placement[1] === 'center') {
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                placement[1] = 'left';
              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                placement[1] = 'right';
              }
            } else {
              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                placement[1] = 'top';
              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                placement[1] = 'bottom';
              }
            }
          }
        }

        switch (placement[0]) {
          case 'top':
            targetElemPos.top = hostElemPos.top - targetHeight;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left - targetWidth;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width;
            break;
        }

        switch (placement[1]) {
          case 'top':
            targetElemPos.top = hostElemPos.top;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
            break;
          case 'center':
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
            } else {
              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
            }
            break;
        }

        targetElemPos.top = Math.round(targetElemPos.top);
        targetElemPos.left = Math.round(targetElemPos.left);
        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

        return targetElemPos;
      },

      /**
       * Provides a way to adjust the top positioning after first
       * render to correctly align element to top after content
       * rendering causes resized element height
       *
       * @param {array} placementClasses - The array of strings of classes
       * element should have.
       * @param {object} containerPosition - The object with container
       * position information
       * @param {number} initialHeight - The initial height for the elem.
       * @param {number} currentHeight - The current height for the elem.
       */
      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
          return {
            top: containerPosition.top - currentHeight + 'px'
          };
        }
      },

      /**
       * Provides a way for positioning tooltip & dropdown
       * arrows when using placement options beyond the standard
       * left, right, top, or bottom.
       *
       * @param {element} elem - The tooltip/dropdown element.
       * @param {string} placement - The placement for the elem.
       */
      positionArrow: function(elem, placement) {
        elem = this.getRawNode(elem);

        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
        if (!innerElem) {
          return;
        }

        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
        if (!arrowElem) {
          return;
        }

        var arrowCss = {
          top: '',
          bottom: '',
          left: '',
          right: ''
        };

        placement = this.parsePlacement(placement);
        if (placement[1] === 'center') {
          // no adjustment necessary - just reset styles
          angular.element(arrowElem).css(arrowCss);
          return;
        }

        var borderProp = 'border-' + placement[0] + '-width';
        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

        var borderRadiusProp = 'border-';
        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
          borderRadiusProp += placement[0] + '-' + placement[1];
        } else {
          borderRadiusProp += placement[1] + '-' + placement[0];
        }
        borderRadiusProp += '-radius';
        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

        switch (placement[0]) {
          case 'top':
            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'bottom':
            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'left':
            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'right':
            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
            break;
        }

        arrowCss[placement[1]] = borderRadius;

        angular.element(arrowElem).css(arrowCss);
      }
    };
  }]);

angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])

.value('$datepickerPopupLiteralWarning', true)

.constant('uibDatepickerPopupConfig', {
  altInputFormats: [],
  appendToBody: false,
  clearText: 'Clear',
  closeOnDateSelection: true,
  closeText: 'Done',
  currentText: 'Today',
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  onOpenFocus: true,
  showButtonBar: true,
  placement: 'auto bottom-left'
})

.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
  var cache = {},
    isHtml5DateInput = false;
  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];

  this.init = function(_ngModel_) {
    ngModel = _ngModel_;
    ngModelOptions = extractOptions(ngModel);
    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
      $scope.$parent.$eval($attrs.closeOnDateSelection) :
      datepickerPopupConfig.closeOnDateSelection;
    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
      datepickerPopupConfig.appendToBody;
    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
      $attrs.datepickerPopupTemplateUrl :
      datepickerPopupConfig.datepickerPopupTemplateUrl;
    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
      $scope.$parent.$eval($attrs.altInputFormats) :
      datepickerPopupConfig.altInputFormats;

    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
      $scope.$parent.$eval($attrs.showButtonBar) :
      datepickerPopupConfig.showButtonBar;

    if (datepickerPopupConfig.html5Types[$attrs.type]) {
      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
      isHtml5DateInput = true;
    } else {
      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
        // Invalidate the $modelValue to ensure that formatters re-run
        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
        if (newDateFormat !== dateFormat) {
          dateFormat = newDateFormat;
          ngModel.$modelValue = null;

          if (!dateFormat) {
            throw new Error('uibDatepickerPopup must have a date format specified.');
          }
        }
      });
    }

    if (!dateFormat) {
      throw new Error('uibDatepickerPopup must have a date format specified.');
    }

    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
      throw new Error('HTML5 date input types do not support custom formats.');
    }

    // popup element used to display calendar
    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');

    popupEl.attr({
      'ng-model': 'date',
      'ng-change': 'dateSelection(date)',
      'template-url': datepickerPopupTemplateUrl
    });

    // datepicker element
    datepickerEl = angular.element(popupEl.children()[0]);
    datepickerEl.attr('template-url', datepickerTemplateUrl);

    if (!$scope.datepickerOptions) {
      $scope.datepickerOptions = {};
    }

    if (isHtml5DateInput) {
      if ($attrs.type === 'month') {
        $scope.datepickerOptions.datepickerMode = 'month';
        $scope.datepickerOptions.minMode = 'month';
      }
    }

    datepickerEl.attr('datepicker-options', 'datepickerOptions');

    if (!isHtml5DateInput) {
      // Internal API to maintain the correct ng-invalid-[key] class
      ngModel.$$parserName = 'date';
      ngModel.$validators.date = validator;
      ngModel.$parsers.unshift(parseDate);
      ngModel.$formatters.push(function(value) {
        if (ngModel.$isEmpty(value)) {
          $scope.date = value;
          return value;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }

        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));

        return dateParser.filter($scope.date, dateFormat);
      });
    } else {
      ngModel.$formatters.push(function(value) {
        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
        return value;
      });
    }

    // Detect changes in the view from the text box
    ngModel.$viewChangeListeners.push(function() {
      $scope.date = parseDateString(ngModel.$viewValue);
    });

    $element.on('keydown', inputKeydownBind);

    $popup = $compile(popupEl)($scope);
    // Prevent jQuery cache memory leak (template is now redundant after linking)
    popupEl.remove();

    if (appendToBody) {
      $document.find('body').append($popup);
    } else {
      $element.after($popup);
    }

    $scope.$on('$destroy', function() {
      if ($scope.isOpen === true) {
        if (!$rootScope.$$phase) {
          $scope.$apply(function() {
            $scope.isOpen = false;
          });
        }
      }

      $popup.remove();
      $element.off('keydown', inputKeydownBind);
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);

      //Clear all watch listeners on destroy
      while (watchListeners.length) {
        watchListeners.shift()();
      }
    });
  };

  $scope.getText = function(key) {
    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
  };

  $scope.isDisabled = function(date) {
    if (date === 'today') {
      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
    }

    var dates = {};
    angular.forEach(['minDate', 'maxDate'], function(key) {
      if (!$scope.datepickerOptions[key]) {
        dates[key] = null;
      } else if (angular.isDate($scope.datepickerOptions[key])) {
        dates[key] = new Date($scope.datepickerOptions[key]);
      } else {
        if ($datepickerPopupLiteralWarning) {
          $log.warn('Literal date support has been deprecated, please switch to date object usage');
        }

        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
      }
    });

    return $scope.datepickerOptions &&
      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
  };

  $scope.compare = function(date1, date2) {
    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  };

  // Inner change
  $scope.dateSelection = function(dt) {
    $scope.date = dt;
    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
    $element.val(date);
    ngModel.$setViewValue(date);

    if (closeOnDateSelection) {
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.keydown = function(evt) {
    if (evt.which === 27) {
      evt.stopPropagation();
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.select = function(date, evt) {
    evt.stopPropagation();

    if (date === 'today') {
      var today = new Date();
      if (angular.isDate($scope.date)) {
        date = new Date($scope.date);
        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      } else {
        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
        date.setHours(0, 0, 0, 0);
      }
    }
    $scope.dateSelection(date);
  };

  $scope.close = function(evt) {
    evt.stopPropagation();

    $scope.isOpen = false;
    $element[0].focus();
  };

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if ($attrs.ngDisabled) {
    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
      $scope.disabled = disabled;
    }));
  }

  $scope.$watch('isOpen', function(value) {
    if (value) {
      if (!$scope.disabled) {
        $timeout(function() {
          positionPopup();

          if (onOpenFocus) {
            $scope.$broadcast('uib:datepicker.focus');
          }

          $document.on('click', documentClickBind);

          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
          if (appendToBody || $position.parsePlacement(placement)[2]) {
            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
            if (scrollParentEl) {
              scrollParentEl.on('scroll', positionPopup);
            }
          } else {
            scrollParentEl = null;
          }

          angular.element($window).on('resize', positionPopup);
        }, 0, false);
      } else {
        $scope.isOpen = false;
      }
    } else {
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);
    }
  });

  function cameltoDash(string) {
    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
  }

  function parseDateString(viewValue) {
    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
    if (isNaN(date)) {
      for (var i = 0; i < altInputFormats.length; i++) {
        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
        if (!isNaN(date)) {
          return date;
        }
      }
    }
    return date;
  }

  function parseDate(viewValue) {
    if (angular.isNumber(viewValue)) {
      // presumably timestamp to date object
      viewValue = new Date(viewValue);
    }

    if (!viewValue) {
      return null;
    }

    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
      return viewValue;
    }

    if (angular.isString(viewValue)) {
      var date = parseDateString(viewValue);
      if (!isNaN(date)) {
        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
      }
    }

    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
  }

  function validator(modelValue, viewValue) {
    var value = modelValue || viewValue;

    if (!$attrs.ngRequired && !value) {
      return true;
    }

    if (angular.isNumber(value)) {
      value = new Date(value);
    }

    if (!value) {
      return true;
    }

    if (angular.isDate(value) && !isNaN(value)) {
      return true;
    }

    if (angular.isString(value)) {
      return !isNaN(parseDateString(value));
    }

    return false;
  }

  function documentClickBind(event) {
    if (!$scope.isOpen && $scope.disabled) {
      return;
    }

    var popup = $popup[0];
    var dpContainsTarget = $element[0].contains(event.target);
    // The popup node may not be an element node
    // In some browsers (IE) only element nodes have the 'contains' function
    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
    }
  }

  function inputKeydownBind(evt) {
    if (evt.which === 27 && $scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
      $element[0].focus();
    } else if (evt.which === 40 && !$scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = true;
      });
    }
  }

  function positionPopup() {
    if ($scope.isOpen) {
      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
      var position = $position.positionElements($element, dpElement, placement, appendToBody);
      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
      if (dpElement.hasClass('uib-position-measure')) {
        dpElement.removeClass('uib-position-measure');
      }
    }
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
        ngModelCtrl.$options :
        {
          timezone: null
        };

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      ngModelOptions = ngModelCtrl.$options;
    }

    return ngModelOptions;
  }

  $scope.$on('uib:datepicker.mode', function() {
    $timeout(positionPopup, 0, false);
  });
}])

.directive('uibDatepickerPopup', function() {
  return {
    require: ['ngModel', 'uibDatepickerPopup'],
    controller: 'UibDatepickerPopupController',
    scope: {
      datepickerOptions: '=?',
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@'
    },
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0],
        ctrl = ctrls[1];

      ctrl.init(ngModel);
    }
  };
})

.directive('uibDatepickerPopupWrap', function() {
  return {
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
    }
  };
});

angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */
  .factory('$$debounce', ['$timeout', function($timeout) {
    return function(callback, debounceTime) {
      var timeoutPromise;

      return function() {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }

        timeoutPromise = $timeout(function() {
          callback.apply(self, args);
        }, debounceTime);
      };
    };
  }]);

angular.module('ui.bootstrap.multiMap', [])
/**
 * A helper, internal data structure that stores all references attached to key
 */
  .factory('$$multiMap', function() {
    return {
      createNew: function() {
        var map = {};

        return {
          entries: function() {
            return Object.keys(map).map(function(key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function(key) {
            return map[key];
          },
          hasKey: function(key) {
            return !!map[key];
          },
          keys: function() {
            return Object.keys(map);
          },
          put: function(key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function(key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  });

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])

.constant('uibDropdownConfig', {
  appendToOpenClass: 'uib-dropdown-open',
  openClass: 'open'
})

.service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function($document, $rootScope, $$multiMap) {
  var openScope = null;
  var openedContainers = $$multiMap.createNew();

  this.isOnlyOpen = function(dropdownScope, appendTo) {
    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (openDropdown) {
        return openedDropdowns.length === 1;
      }
    }

    return false;
  };

  this.open = function(dropdownScope, element, appendTo) {
    if (!openScope) {
      $document.on('click', closeDropdown);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openedScopes = openedDropdowns.map(function(dropdown) {
        return dropdown.scope;
      });
      if (openedScopes.indexOf(dropdownScope) === -1) {
        openedContainers.put(appendTo, {
          scope: dropdownScope
        });
      }
    } else {
      openedContainers.put(appendTo, {
        scope: dropdownScope
      });
    }
  };

  this.close = function(dropdownScope, element, appendTo) {
    if (openScope === dropdownScope) {
      $document.off('click', closeDropdown);
      $document.off('keydown', this.keybindFilter);
      openScope = null;
    }

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var dropdownToClose = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (dropdownToClose) {
        openedContainers.remove(appendTo, dropdownToClose);
      }
    }
  };

  var closeDropdown = function(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope || !openScope.isOpen) { return; }

    if (evt && openScope.getAutoClose() === 'disabled') { return; }

    if (evt && evt.which === 3) { return; }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' &&
      dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.focusToggleElement();
    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  this.keybindFilter = function(evt) {
    if (!openScope) {
      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    var toggleElement = openScope.getToggleElement();
    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
    if (evt.which === 27) {
      evt.stopPropagation();
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}])

.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
    scope = $scope.$new(), // create a child scope so we are not polluting original one
    templateScope,
    appendToOpenClass = dropdownConfig.appendToOpenClass,
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
    keynavEnabled = false,
    selectedOption = null,
    body = $document.find('body');

  $element.addClass('dropdown');

  this.init = function() {
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function(value) {
        scope.isOpen = !!value;
      });
    }

    keynavEnabled = angular.isDefined($attrs.keyboardNav);
  };

  this.toggle = function(open) {
    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
    if (angular.isFunction(setIsOpen)) {
      setIsOpen(scope, scope.isOpen);
    }

    return scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function() {
    return scope.isOpen;
  };

  scope.getToggleElement = function() {
    return self.toggleElement;
  };

  scope.getAutoClose = function() {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function() {
    return $element;
  };

  scope.isKeynavEnabled = function() {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function(keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
      angular.element(self.dropdownMenu).find('a') :
      $element.find('ul').eq(0).find('a');

    switch (keyCode) {
      case 40: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = 0;
        } else {
          self.selectedOption = self.selectedOption === elems.length - 1 ?
            self.selectedOption :
            self.selectedOption + 1;
        }
        break;
      }
      case 38: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = elems.length - 1;
        } else {
          self.selectedOption = self.selectedOption === 0 ?
            0 : self.selectedOption - 1;
        }
        break;
      }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function() {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function() {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  function removeDropdownMenu() {
    $element.append(self.dropdownMenu);
  }

  scope.$watch('isOpen', function(isOpen, wasOpen) {
    var appendTo = null,
      appendToBody = false;

    if (angular.isDefined($attrs.dropdownAppendTo)) {
      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
      if (appendToEl) {
        appendTo = angular.element(appendToEl);
      }
    }

    if (angular.isDefined($attrs.dropdownAppendToBody)) {
      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
      if (appendToBodyValue !== false) {
        appendToBody = true;
      }
    }

    if (appendToBody && !appendTo) {
      appendTo = body;
    }

    if (appendTo && self.dropdownMenu) {
      if (isOpen) {
        appendTo.append(self.dropdownMenu);
        $element.on('$destroy', removeDropdownMenu);
      } else {
        $element.off('$destroy', removeDropdownMenu);
        removeDropdownMenu();
      }
    }

    if (appendTo && self.dropdownMenu) {
      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
        css,
        rightalign,
        scrollbarPadding,
        scrollbarWidth = 0;

      css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        scrollbarPadding = $position.scrollbarPadding(appendTo);

        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
          scrollbarWidth = scrollbarPadding.scrollbarWidth;
        }

        css.right = window.innerWidth - scrollbarWidth -
          (pos.left + $element.prop('offsetWidth')) + 'px';
      }

      // Need to adjust our positioning to be relative to the appendTo container
      // if it's not the body element
      if (!appendToBody) {
        var appendOffset = $position.offset(appendTo);

        css.top = pos.top - appendOffset.top + 'px';

        if (!rightalign) {
          css.left = pos.left - appendOffset.left + 'px';
        } else {
          css.right = window.innerWidth -
            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
        }
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendTo ? appendTo : $element;
    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);

    if (hasOpenClass === !isOpen) {
      var toggleClass;
      if (appendTo) {
        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
      } else {
        toggleClass = isOpen ? 'addClass' : 'removeClass';
      }
      $animate[toggleClass](openContainer, dropdownOpenClass).then(function() {
        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
          toggleInvoker($scope, { open: !!isOpen });
        }
      });
    }

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
            $document.on('keydown', uibDropdownService.keybindFilter);
          });
        });
      } else {
        $document.on('keydown', uibDropdownService.keybindFilter);
      }

      scope.focusToggleElement();
      uibDropdownService.open(scope, $element, appendTo);
    } else {
      uibDropdownService.close(scope, $element, appendTo);
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });
}])

.directive('uibDropdown', function() {
  return {
    controller: 'UibDropdownController',
    link: function(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init();
    }
  };
})

.directive('uibDropdownMenu', function() {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }

      element.addClass('dropdown-menu');

      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }

      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
})

.directive('uibDropdownToggle', function() {
  return {
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function() {
            dropdownCtrl.toggle();
          });
        }
      };

      element.on('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function() {
        element.off('click', toggleDropdown);
      });
    }
  };
});

angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function() {
    return {
      createNew: function() {
        var stack = [];

        return {
          add: function(key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function(key) {
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function() {
            return stack[stack.length - 1];
          },
          remove: function(key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function() {
            return stack.pop();
          },
          length: function() {
            return stack.length;
          }
        };
      }
    };
  });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */
  .provider('$uibResolve', function() {
    var resolve = this;
    this.resolver = null;

    this.setResolver = function(resolver) {
      this.resolver = resolver;
    };

    this.$get = ['$injector', '$q', function($injector, $q) {
      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
      return {
        resolve: function(invocables, locals, parent, self) {
          if (resolver) {
            return resolver.resolve(invocables, locals, parent, self);
          }

          var promises = [];

          angular.forEach(invocables, function(value) {
            if (angular.isFunction(value) || angular.isArray(value)) {
              promises.push($q.resolve($injector.invoke(value)));
            } else if (angular.isString(value)) {
              promises.push($q.resolve($injector.get(value)));
            } else {
              promises.push($q.resolve(value));
            }
          });

          return $q.all(promises).then(function(resolves) {
            var resolveObj = {};
            var resolveIter = 0;
            angular.forEach(invocables, function(value, key) {
              resolveObj[key] = resolves[resolveIter++];
            });

            return resolveObj;
          });
        }
      };
    }];
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
  function($animate, $injector, $modalStack) {
    return {
      restrict: 'A',
      compile: function(tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      if (attrs.modalInClass) {
        $animate.addClass(element, attrs.modalInClass);

        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
          var done = setIsAsync();
          if (scope.modalOptions.animation) {
            $animate.removeClass(element, attrs.modalInClass).then(done);
          } else {
            done();
          }
        });
      }
    }
  }])

  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
  function($modalStack, $q, $animateCss, $document) {
    return {
      scope: {
        index: '@'
      },
      restrict: 'A',
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'uib/template/modal/window.html';
      },
      link: function(scope, element, attrs) {
        element.addClass(attrs.windowTopClass || '');
        scope.size = attrs.size;

        scope.close = function(evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop &&
            modal.value.backdrop !== 'static' &&
            evt.target === evt.currentTarget) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // moved from template to fix issue #2280
        element.on('click', scope.close);

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is rendered.
        var modalRenderDeferObj = $q.defer();
        // Resolve render promise post-digest
        scope.$$postDigest(function() {
          modalRenderDeferObj.resolve();
        });

        modalRenderDeferObj.promise.then(function() {
          var animationPromise = null;

          if (attrs.modalInClass) {
            animationPromise = $animateCss(element, {
              addClass: attrs.modalInClass
            }).start();

            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
              var done = setIsAsync();
              $animateCss(element, {
                removeClass: attrs.modalInClass
              }).start().then(done);
            });
          }


          $q.when(animationPromise).then(function() {
            // Notify {@link $modalStack} that modal is rendered.
            var modal = $modalStack.getTop();
            if (modal) {
              $modalStack.modalRendered(modal.key);
            }

            /**
             * If something within the freshly-opened modal already has focus (perhaps via a
             * directive that causes focus) then there's no need to try to focus anything.
             */
            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
              var inputWithAutofocus = element[0].querySelector('[autofocus]');
              /**
               * Auto-focusing of a freshly-opened modal element causes any child elements
               * with the autofocus attribute to lose focus. This is an issue on touch
               * based devices which will show and then hide the onscreen keyboard.
               * Attempts to refocus the autofocus element via JavaScript will not reopen
               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
               * the modal element if the modal does not contain an autofocus element.
               */
              if (inputWithAutofocus) {
                inputWithAutofocus.focus();
              } else {
                element[0].focus();
              }
            }
          });
        });
      }
    };
  }])

  .directive('uibModalAnimationClass', function() {
    return {
      compile: function(tElement, tAttrs) {
        if (tAttrs.modalAnimation) {
          tElement.addClass(tAttrs.uibModalAnimationClass);
        }
      }
    };
  })

  .directive('uibModalTransclude', ['$animate', function($animate) {
    return {
      link: function(scope, element, attrs, controller, transclude) {
        transclude(scope.$parent, function(clone) {
          element.empty();
          $animate.enter(clone, element);
        });
      }
    };
  }])

  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };
      var topModalIndex = 0;
      var previousTopOpenedModal = null;
      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';

      //Modal focus behavior
      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
      var scrollbarPadding;
      var SNAKE_CASE_REGEXP = /[A-Z]/g;

      // TODO: extract into common dependency with tooltip
      function snake_case(name) {
        var separator = '-';
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
          return (pos ? separator : '') + letter.toLowerCase();
        });
      }

      function isVisible(element) {
        return !!(element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length);
      }

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }

        // If any backdrop exist, ensure that it's index is always
        // right below the top modal
        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
          topBackdropIndex = topModalIndex;
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var modalWindow = openedWindows.get(modalInstance).value;
        var appendToElement = modalWindow.appendTo;

        //clean up the stack
        openedWindows.remove(modalInstance);
        previousTopOpenedModal = openedWindows.top();
        if (previousTopOpenedModal) {
          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
        }

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
            if (scrollbarPadding.originalRight) {
              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
            } else {
              appendToElement.css({paddingRight: ''});
            }
            scrollbarPadding = null;
          }
          toggleTopWindowClass(true);
        }, modalWindow.closedDeferred);
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else if (appendToElement.focus) {
          appendToElement.focus();
        }
      }

      // Add or remove "windowTopClass" from the top window in the stack
      function toggleTopWindowClass(toggleSwitch) {
        var modalWindow;

        if (openedWindows.length() > 0) {
          modalWindow = openedWindows.top().value;
          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
        }
      }

      function checkRemoveBackdrop() {
        //remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
          var backdropScopeRef = backdropScope;
          removeAfterAnimate(backdropDomEl, backdropScope, function() {
            backdropScopeRef = null;
          });
          backdropDomEl = undefined;
          backdropScope = undefined;
        }
      }

      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function() {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          $animate.leave(domEl).then(function() {
            if (done) {
              done();
            }

            domEl.remove();
            if (closedDeferred) {
              closedDeferred.resolve();
            }
          });

          scope.$destroy();
        }
      }

      $document.on('keydown', keydownListener);

      $rootScope.$on('$destroy', function() {
        $document.off('keydown', keydownListener);
      });

      function keydownListener(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal) {
          switch (evt.which) {
            case 27: {
              if (modal.value.keyboard) {
                evt.preventDefault();
                $rootScope.$apply(function() {
                  $modalStack.dismiss(modal.key, 'escape key press');
                });
              }
              break;
            }
            case 9: {
              var list = $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                  focusChanged = $modalStack.focusLastFocusableElement(list);
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt, list)) {
                  focusChanged = $modalStack.focusFirstFocusableElement(list);
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }

              break;
            }
          }
        }
      }

      $modalStack.open = function(modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        toggleTopWindowClass(false);

        // Store the current top first, to determine what index we ought to use
        // for the current top modal
        previousTopOpenedModal = openedWindows.top();

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          closedDeferred: modal.closedDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass,
          windowTopClass: modal.windowTopClass,
          animation: modal.animation,
          appendTo: modal.appendTo
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var appendToElement = modal.appendTo,
            currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.modalOptions = modal;
          backdropScope.index = currBackdropIndex;
          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
          backdropDomEl.attr({
            'class': 'modal-backdrop',
            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
            'uib-modal-animation-class': 'fade',
            'modal-in-class': 'in'
          });
          if (modal.backdropClass) {
            backdropDomEl.addClass(modal.backdropClass);
          }

          if (modal.animation) {
            backdropDomEl.attr('modal-animation', 'true');
          }
          $compile(backdropDomEl)(backdropScope);
          $animate.enter(backdropDomEl, appendToElement);
          if ($uibPosition.isScrollable(appendToElement)) {
            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
            }
          }
        }

        var content;
        if (modal.component) {
          content = document.createElement(snake_case(modal.component.name));
          content = angular.element(content);
          content.attr({
            resolve: '$resolve',
            'modal-instance': '$uibModalInstance',
            close: '$close($value)',
            dismiss: '$dismiss($value)'
          });
        } else {
          content = modal.content;
        }

        // Set the top modal index based on the index of the previous top modal
        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
        angularDomEl.attr({
          'class': 'modal',
          'template-url': modal.windowTemplateUrl,
          'window-top-class': modal.windowTopClass,
          'role': 'dialog',
          'aria-labelledby': modal.ariaLabelledBy,
          'aria-describedby': modal.ariaDescribedBy,
          'size': modal.size,
          'index': topModalIndex,
          'animate': 'animate',
          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
          'tabindex': -1,
          'uib-modal-animation-class': 'fade',
          'modal-in-class': 'in'
        }).append(content);
        if (modal.windowClass) {
          angularDomEl.addClass(modal.windowClass);
        }

        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        appendToElement.addClass(modalBodyClass);
        if (modal.scope) {
          // we need to explicitly add the modal index to the modal scope
          // because it is needed by ngStyle to compute the zIndex property.
          modal.scope.$$topModalIndex = topModalIndex;
        }
        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

        openedWindows.top().value.modalDomEl = angularDomEl;
        openedWindows.top().value.modalOpener = modalOpener;

        applyAriaHidden(angularDomEl);

        function applyAriaHidden(el) {
          if (!el || el[0].tagName === 'BODY') {
            return;
          }

          getSiblings(el).forEach(function(sibling) {
            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);

            if (!ariaHiddenCount) {
              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
            }

            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
            sibling.setAttribute('aria-hidden', 'true');
          });

          return applyAriaHidden(el.parent());

          function getSiblings(el) {
            var children = el.parent() ? el.parent().children() : [];

            return Array.prototype.filter.call(children, function(child) {
              return child !== el[0];
            });
          }
        }
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      function unhideBackgroundElements() {
        Array.prototype.forEach.call(
          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
          function(hiddenEl) {
            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
              newHiddenCount = ariaHiddenCount - 1;
            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);

            if (!newHiddenCount) {
              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
              hiddenEl.removeAttribute('aria-hidden');
            }
          }
        );
      }

      $modalStack.close = function(modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }

        return !modalWindow;
      };

      $modalStack.dismiss = function(modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function(reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function() {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function(modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function(list) {
        if (list.length > 0) {
          list[0].focus();
          return true;
        }
        return false;
      };

      $modalStack.focusLastFocusableElement = function(list) {
        if (list.length > 0) {
          list[list.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isModalFocused = function(evt, modalWindow) {
        if (evt && modalWindow) {
          var modalDomEl = modalWindow.value.modalDomEl;
          if (modalDomEl && modalDomEl.length) {
            return (evt.target || evt.srcElement) === modalDomEl[0];
          }
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[list.length - 1];
        }
        return false;
      };

      $modalStack.loadFocusElementList = function(modalWindow) {
        if (modalWindow) {
          var modalDomE1 = modalWindow.value.modalDomEl;
          if (modalDomE1 && modalDomE1.length) {
            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
            return elements ?
              Array.prototype.filter.call(elements, function(element) {
                return isVisible(element);
              }) : elements;
          }
        }
      };

      return $modalStack;
    }])

  .provider('$uibModal', function() {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ?
                options.templateUrl() : options.templateUrl);
          }

          var promiseChain = null;
          $modal.getPromiseChain = function() {
            return promiseChain;
          };

          $modal.open = function(modalOptions) {
            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalClosedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              closed: modalClosedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};
            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

            if (!modalOptions.appendTo.length) {
              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
            }

            //verify options
            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of component or template or templateUrl options is required.');
            }

            var templateAndResolvePromise;
            if (modalOptions.component) {
              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
            } else {
              templateAndResolvePromise =
                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
            }

            function resolveWithTemplate() {
              return templateAndResolvePromise;
            }

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(resolveWithTemplate, resolveWithTemplate)
              .then(function resolveSuccess(tplAndVars) {
                var providedScope = modalOptions.scope || $rootScope;

                var modalScope = providedScope.$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function() {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var modal = {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  closedDeferred: modalClosedDeferred,
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowTopClass: modalOptions.windowTopClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  ariaLabelledBy: modalOptions.ariaLabelledBy,
                  ariaDescribedBy: modalOptions.ariaDescribedBy,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass,
                  appendTo: modalOptions.appendTo
                };

                var component = {};
                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                if (modalOptions.component) {
                  constructLocals(component, false, true, false);
                  component.name = modalOptions.component;
                  modal.component = component;
                } else if (modalOptions.controller) {
                  constructLocals(ctrlLocals, true, false, true);

                  // the third param will make the controller instantiate later,private api
                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                  if (modalOptions.controllerAs && modalOptions.bindToController) {
                    ctrlInstance = ctrlInstantiate.instance;
                    ctrlInstance.$close = modalScope.$close;
                    ctrlInstance.$dismiss = modalScope.$dismiss;
                    angular.extend(ctrlInstance, {
                      $resolve: ctrlLocals.$scope.$resolve
                    }, providedScope);
                  }

                  ctrlInstance = ctrlInstantiate();

                  if (angular.isFunction(ctrlInstance.$onInit)) {
                    ctrlInstance.$onInit();
                  }
                }

                if (!modalOptions.component) {
                  modal.content = tplAndVars[0];
                }

                $modalStack.open(modalInstance, modal);
                modalOpenedDeferred.resolve(true);

                function constructLocals(obj, template, instanceOnScope, injectable) {
                  obj.$scope = modalScope;
                  obj.$scope.$resolve = {};
                  if (instanceOnScope) {
                    obj.$scope.$uibModalInstance = modalInstance;
                  } else {
                    obj.$uibModalInstance = modalInstance;
                  }

                  var resolves = template ? tplAndVars[1] : tplAndVars;
                  angular.forEach(resolves, function(value, key) {
                    if (injectable) {
                      obj[key] = value;
                    }

                    obj.$scope.$resolve[key] = value;
                  });
                }
            }, function resolveError(reason) {
              modalOpenedDeferred.reject(reason);
              modalResultDeferred.reject(reason);
            })['finally'](function() {
              if (promiseChain === samePromise) {
                promiseChain = null;
              }
            });

            return modalInstance;
          };

          return $modal;
        }
      ]
    };

    return $modalProvider;
  });

angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */
.factory('uibPaging', ['$parse', function($parse) {
  return {
    create: function(ctrl, $scope, $attrs) {
      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
      ctrl._watchers = [];

      ctrl.init = function(ngModelCtrl, config) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ctrl.config = config;

        ngModelCtrl.$render = function() {
          ctrl.render();
        };

        if ($attrs.itemsPerPage) {
          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
            ctrl.itemsPerPage = parseInt(value, 10);
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }));
        } else {
          ctrl.itemsPerPage = config.itemsPerPage;
        }

        $scope.$watch('totalItems', function(newTotal, oldTotal) {
          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }
        });
      };

      ctrl.calculateTotalPages = function() {
        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
        return Math.max(totalPages || 0, 1);
      };

      ctrl.render = function() {
        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
      };

      $scope.selectPage = function(page, evt) {
        if (evt) {
          evt.preventDefault();
        }

        var clickAllowed = !$scope.ngDisabled || !evt;
        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
          if (evt && evt.target) {
            evt.target.blur();
          }
          ctrl.ngModelCtrl.$setViewValue(page);
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.getText = function(key) {
        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
      };

      $scope.noPrevious = function() {
        return $scope.page === 1;
      };

      $scope.noNext = function() {
        return $scope.page === $scope.totalPages;
      };

      ctrl.updatePage = function() {
        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

        if ($scope.page > $scope.totalPages) {
          $scope.selectPage($scope.totalPages);
        } else {
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.$on('$destroy', function() {
        while (ctrl._watchers.length) {
          ctrl._watchers.shift()();
        }
      });
    }
  };
}]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])

.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

  uibPaging.create(this, $scope, $attrs);
}])

.constant('uibPagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
})

.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
  return {
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@',
      ngDisabled: '='
    },
    require: ['uibPager', '?ngModel'],
    restrict: 'A',
    controller: 'UibPagerController',
    controllerAs: 'pager',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pager/pager.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pager');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
    }
  };
}]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
  var ctrl = this;
  // Setup configuration parameters
  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
  $attrs.$set('role', 'menu');

  uibPaging.create(this, $scope, $attrs);

  if ($attrs.maxSize) {
    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
      maxSize = parseInt(value, 10);
      ctrl.render();
    }));
  }

  // Create page object used in template
  function makePage(number, text, isActive) {
    return {
      number: number,
      text: text,
      active: isActive
    };
  }

  function getPages(currentPage, totalPages) {
    var pages = [];

    // Default page limits
    var startPage = 1, endPage = totalPages;
    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

    // recompute if maxSize
    if (isMaxSized) {
      if (rotate) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
        endPage = startPage + maxSize - 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - maxSize + 1;
        }
      } else {
        // Visible pages are paginated with maxSize
        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

        // Adjust last page if limit is exceeded
        endPage = Math.min(startPage + maxSize - 1, totalPages);
      }
    }

    // Add page number links
    for (var number = startPage; number <= endPage; number++) {
      var page = makePage(number, pageLabel(number), number === currentPage);
      pages.push(page);
    }

    // Add links to move between page sets
    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
      if (startPage > 1) {
        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
        var previousPageSet = makePage(startPage - 1, '...', false);
        pages.unshift(previousPageSet);
      }
        if (boundaryLinkNumbers) {
          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
            var secondPageLink = makePage(2, '2', false);
            pages.unshift(secondPageLink);
          }
          //add the first page
          var firstPageLink = makePage(1, '1', false);
          pages.unshift(firstPageLink);
        }
      }

      if (endPage < totalPages) {
        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
        var nextPageSet = makePage(endPage + 1, '...', false);
        pages.push(nextPageSet);
      }
        if (boundaryLinkNumbers) {
          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
            pages.push(secondToLastPageLink);
          }
          //add the last page
          var lastPageLink = makePage(totalPages, totalPages, false);
          pages.push(lastPageLink);
        }
      }
    }
    return pages;
  }

  var originalRender = this.render;
  this.render = function() {
    originalRender();
    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
      $scope.pages = getPages($scope.page, $scope.totalPages);
    }
  };
}])

.constant('uibPaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  boundaryLinkNumbers: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true,
  forceEllipses: false
})

.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
  return {
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled:'='
    },
    require: ['uibPagination', '?ngModel'],
    restrict: 'A',
    controller: 'UibPaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pagination');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
    }
  };
}]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
.provider('$uibTooltip', function() {
  // The default options tooltip and popover.
  var defaultOptions = {
    placement: 'top',
    placementClassPrefix: '',
    animation: true,
    popupDelay: 0,
    popupCloseDelay: 0,
    useContentExp: false
  };

  // Default hide triggers for each show trigger
  var triggerMap = {
    'mouseenter': 'mouseleave',
    'click': 'click',
    'outsideClick': 'outsideClick',
    'focus': 'blur',
    'none': ''
  };

  // The options specified to the provider globally.
  var globalOptions = {};

  /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
	this.options = function(value) {
		angular.extend(globalOptions, value);
	};

  /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
   */
  this.setTriggers = function setTriggers(triggers) {
    angular.extend(triggerMap, triggers);
  };

  /**
   * This is a helper function for translating camel-case to snake_case.
   */
  function snake_case(name) {
    var regexp = /[A-Z]/g;
    var separator = '-';
    return name.replace(regexp, function(letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
    var openedTooltips = $$stackedMap.createNew();
    $document.on('keyup', keypressListener);

    $rootScope.$on('$destroy', function() {
      $document.off('keyup', keypressListener);
    });

    function keypressListener(e) {
      if (e.which === 27) {
        var last = openedTooltips.top();
        if (last) {
          last.value.close();
          last = null;
        }
      }
    }

    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
      options = angular.extend({}, defaultOptions, globalOptions, options);

      /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
      function getTriggers(trigger) {
        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
        var hide = show.map(function(trigger) {
          return triggerMap[trigger] || trigger;
        });
        return {
          show: show,
          hide: hide
        };
      }

      var directiveName = snake_case(ttType);

      var startSym = $interpolate.startSymbol();
      var endSym = $interpolate.endSymbol();
      var template =
        '<div '+ directiveName + '-popup ' +
          'uib-title="' + startSym + 'title' + endSym + '" ' +
          (options.useContentExp ?
            'content-exp="contentExp()" ' :
            'content="' + startSym + 'content' + endSym + '" ') +
          'origin-scope="origScope" ' +
          'class="uib-position-measure ' + prefix + '" ' +
          'tooltip-animation-class="fade"' +
          'uib-tooltip-classes ' +
          'ng-class="{ in: isOpen }" ' +
          '>' +
        '</div>';

      return {
        compile: function(tElem, tAttrs) {
          var tooltipLinker = $compile(template);

          return function link(scope, element, attrs, tooltipCtrl) {
            var tooltip;
            var tooltipLinkedScope;
            var transitionTimeout;
            var showTimeout;
            var hideTimeout;
            var positionTimeout;
            var adjustmentTimeout;
            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
            var triggers = getTriggers(undefined);
            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
            var ttScope = scope.$new(true);
            var repositionScheduled = false;
            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
            var observers = [];
            var lastPlacement;

            var positionTooltip = function() {
              // check if tooltip exists and is not empty
              if (!tooltip || !tooltip.html()) { return; }

              if (!positionTimeout) {
                positionTimeout = $timeout(function() {
                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
                  var placementClasses = ttPosition.placement.split('-');

                  if (!tooltip.hasClass(placementClasses[0])) {
                    tooltip.removeClass(lastPlacement.split('-')[0]);
                    tooltip.addClass(placementClasses[0]);
                  }

                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                  }

                  adjustmentTimeout = $timeout(function() {
                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
                    if (adjustment) {
                      tooltip.css(adjustment);
                    }
                    adjustmentTimeout = null;
                  }, 0, false);

                  // first time through tt element will have the
                  // uib-position-measure class or if the placement
                  // has changed we need to position the arrow.
                  if (tooltip.hasClass('uib-position-measure')) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                    tooltip.removeClass('uib-position-measure');
                  } else if (lastPlacement !== ttPosition.placement) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                  }
                  lastPlacement = ttPosition.placement;

                  positionTimeout = null;
                }, 0, false);
              }
            };

            // Set up the correct scope to allow transclusion later
            ttScope.origScope = scope;

            // By default, the tooltip is not open.
            // TODO add ability to start tooltip opened
            ttScope.isOpen = false;

            function toggleTooltipBind() {
              if (!ttScope.isOpen) {
                showTooltipBind();
              } else {
                hideTooltipBind();
              }
            }

            // Show the tooltip with delay if specified, otherwise show it immediately
            function showTooltipBind() {
              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                return;
              }

              cancelHide();
              prepareTooltip();

              if (ttScope.popupDelay) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                if (!showTimeout) {
                  showTimeout = $timeout(show, ttScope.popupDelay, false);
                }
              } else {
                show();
              }
            }

            function hideTooltipBind() {
              cancelShow();

              if (ttScope.popupCloseDelay) {
                if (!hideTimeout) {
                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                }
              } else {
                hide();
              }
            }

            // Show the tooltip popup element.
            function show() {
              cancelShow();
              cancelHide();

              // Don't show empty tooltips.
              if (!ttScope.content) {
                return angular.noop;
              }

              createTooltip();

              // And show the tooltip.
              ttScope.$evalAsync(function() {
                ttScope.isOpen = true;
                assignIsOpen(true);
                positionTooltip();
              });
            }

            function cancelShow() {
              if (showTimeout) {
                $timeout.cancel(showTimeout);
                showTimeout = null;
              }

              if (positionTimeout) {
                $timeout.cancel(positionTimeout);
                positionTimeout = null;
              }
            }

            // Hide the tooltip popup element.
            function hide() {
              if (!ttScope) {
                return;
              }

              // First things first: we don't show it anymore.
              ttScope.$evalAsync(function() {
                if (ttScope) {
                  ttScope.isOpen = false;
                  assignIsOpen(false);
                  // And now we remove it from the DOM. However, if we have animation, we
                  // need to wait for it to expire beforehand.
                  // FIXME: this is a placeholder for a port of the transitions library.
                  // The fade transition in TWBS is 150ms.
                  if (ttScope.animation) {
                    if (!transitionTimeout) {
                      transitionTimeout = $timeout(removeTooltip, 150, false);
                    }
                  } else {
                    removeTooltip();
                  }
                }
              });
            }

            function cancelHide() {
              if (hideTimeout) {
                $timeout.cancel(hideTimeout);
                hideTimeout = null;
              }

              if (transitionTimeout) {
                $timeout.cancel(transitionTimeout);
                transitionTimeout = null;
              }
            }

            function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
              if (tooltip) {
                return;
              }

              tooltipLinkedScope = ttScope.$new();
              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                if (appendToBody) {
                  $document.find('body').append(tooltip);
                } else {
                  element.after(tooltip);
                }
              });

              openedTooltips.add(ttScope, {
                close: hide
              });

              prepObservers();
            }

            function removeTooltip() {
              cancelShow();
              cancelHide();
              unregisterObservers();

              if (tooltip) {
                tooltip.remove();
                
                tooltip = null;
                if (adjustmentTimeout) {
                  $timeout.cancel(adjustmentTimeout);
                }
              }

              openedTooltips.remove(ttScope);
              
              if (tooltipLinkedScope) {
                tooltipLinkedScope.$destroy();
                tooltipLinkedScope = null;
              }
            }

            /**
             * Set the initial scope values. Once
             * the tooltip is created, the observers
             * will be added to keep things in sync.
             */
            function prepareTooltip() {
              ttScope.title = attrs[prefix + 'Title'];
              if (contentParse) {
                ttScope.content = contentParse(scope);
              } else {
                ttScope.content = attrs[ttType];
              }

              ttScope.popupClass = attrs[prefix + 'Class'];
              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
              var placement = $position.parsePlacement(ttScope.placement);
              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
            }

            function assignIsOpen(isOpen) {
              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                isOpenParse.assign(scope, isOpen);
              }
            }

            ttScope.contentExp = function() {
              return ttScope.content;
            };

            /**
             * Observe the relevant attributes.
             */
            attrs.$observe('disabled', function(val) {
              if (val) {
                cancelShow();
              }

              if (val && ttScope.isOpen) {
                hide();
              }
            });

            if (isOpenParse) {
              scope.$watch(isOpenParse, function(val) {
                if (ttScope && !val === ttScope.isOpen) {
                  toggleTooltipBind();
                }
              });
            }

            function prepObservers() {
              observers.length = 0;

              if (contentParse) {
                observers.push(
                  scope.$watch(contentParse, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    }
                  })
                );

                observers.push(
                  tooltipLinkedScope.$watch(function() {
                    if (!repositionScheduled) {
                      repositionScheduled = true;
                      tooltipLinkedScope.$$postDigest(function() {
                        repositionScheduled = false;
                        if (ttScope && ttScope.isOpen) {
                          positionTooltip();
                        }
                      });
                    }
                  })
                );
              } else {
                observers.push(
                  attrs.$observe(ttType, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    } else {
                      positionTooltip();
                    }
                  })
                );
              }

              observers.push(
                attrs.$observe(prefix + 'Title', function(val) {
                  ttScope.title = val;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );

              observers.push(
                attrs.$observe(prefix + 'Placement', function(val) {
                  ttScope.placement = val ? val : options.placement;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );
            }

            function unregisterObservers() {
              if (observers.length) {
                angular.forEach(observers, function(observer) {
                  observer();
                });
                observers.length = 0;
              }
            }

            // hide tooltips/popovers for outsideClick trigger
            function bodyHideTooltipBind(e) {
              if (!ttScope || !ttScope.isOpen || !tooltip) {
                return;
              }
              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                hideTooltipBind();
              }
            }

            // KeyboardEvent handler to hide the tooltip on Escape key press
            function hideOnEscapeKey(e) {
              if (e.which === 27) {
                hideTooltipBind();
              }
            }

            var unregisterTriggers = function() {
              triggers.show.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  element.off('click', toggleTooltipBind);
                } else {
                  element.off(trigger, showTooltipBind);
                  element.off(trigger, toggleTooltipBind);
                }
                element.off('keypress', hideOnEscapeKey);
              });
              triggers.hide.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  $document.off('click', bodyHideTooltipBind);
                } else {
                  element.off(trigger, hideTooltipBind);
                }
              });
            };

            function prepTriggers() {
              var showTriggers = [], hideTriggers = [];
              var val = scope.$eval(attrs[prefix + 'Trigger']);
              unregisterTriggers();

              if (angular.isObject(val)) {
                Object.keys(val).forEach(function(key) {
                  showTriggers.push(key);
                  hideTriggers.push(val[key]);
                });
                triggers = {
                  show: showTriggers,
                  hide: hideTriggers
                };
              } else {
                triggers = getTriggers(val);
              }

              if (triggers.show !== 'none') {
                triggers.show.forEach(function(trigger, idx) {
                  if (trigger === 'outsideClick') {
                    element.on('click', toggleTooltipBind);
                    $document.on('click', bodyHideTooltipBind);
                  } else if (trigger === triggers.hide[idx]) {
                    element.on(trigger, toggleTooltipBind);
                  } else if (trigger) {
                    element.on(trigger, showTooltipBind);
                    element.on(triggers.hide[idx], hideTooltipBind);
                  }
                  element.on('keypress', hideOnEscapeKey);
                });
              }
            }

            prepTriggers();

            var animation = scope.$eval(attrs[prefix + 'Animation']);
            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

            var appendToBodyVal;
            var appendKey = prefix + 'AppendToBody';
            if (appendKey in attrs && attrs[appendKey] === undefined) {
              appendToBodyVal = true;
            } else {
              appendToBodyVal = scope.$eval(attrs[appendKey]);
            }

            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              unregisterTriggers();
              removeTooltip();
              ttScope = null;
            });
          };
        }
      };
    };
  }];
})

// This is mostly ngInclude code but with a custom scope
.directive('uibTooltipTemplateTransclude', [
         '$animate', '$sce', '$compile', '$templateRequest',
function ($animate, $sce, $compile, $templateRequest) {
  return {
    link: function(scope, elem, attrs) {
      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

      var changeCounter = 0,
        currentScope,
        previousElement,
        currentElement;

      var cleanupLastIncludeContent = function() {
        if (previousElement) {
          previousElement.remove();
          previousElement = null;
        }

        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }

        if (currentElement) {
          $animate.leave(currentElement).then(function() {
            previousElement = null;
          });
          previousElement = currentElement;
          currentElement = null;
        }
      };

      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
        var thisChangeId = ++changeCounter;

        if (src) {
          //set the 2nd param to true to ignore the template request error so that the inner
          //contents and scope can be cleaned up.
          $templateRequest(src, true).then(function(response) {
            if (thisChangeId !== changeCounter) { return; }
            var newScope = origScope.$new();
            var template = response;

            var clone = $compile(template)(newScope, function(clone) {
              cleanupLastIncludeContent();
              $animate.enter(clone, elem);
            });

            currentScope = newScope;
            currentElement = clone;

            currentScope.$emit('$includeContentLoaded', src);
          }, function() {
            if (thisChangeId === changeCounter) {
              cleanupLastIncludeContent();
              scope.$emit('$includeContentError', src);
            }
          });
          scope.$emit('$includeContentRequested', src);
        } else {
          cleanupLastIncludeContent();
        }
      });

      scope.$on('$destroy', cleanupLastIncludeContent);
    }
  };
}])

/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */
.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      // need to set the primary position so the
      // arrow has space during position measure.
      // tooltip.positionTooltip()
      if (scope.placement) {
        // // There are no top-left etc... classes
        // // in TWBS, so we need the primary position.
        var position = $uibPosition.parsePlacement(scope.placement);
        element.addClass(position[0]);
      }

      if (scope.popupClass) {
        element.addClass(scope.popupClass);
      }

      if (scope.animation) {
        element.addClass(attrs.tooltipAnimationClass);
      }
    }
  };
}])

.directive('uibTooltipPopup', function() {
  return {
    restrict: 'A',
    scope: { content: '@' },
    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
  };
})

.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
}])

.directive('uibTooltipTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
  };
})

.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}])

.directive('uibTooltipHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
  };
})

.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

.directive('uibPopoverTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/popover/popover-template.html'
  };
})

.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', uibTitle: '@' },
    templateUrl: 'uib/template/popover/popover-html.html'
  };
})

.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverPopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', content: '@' },
    templateUrl: 'uib/template/popover/popover.html'
  };
})

.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopover', 'popover', 'click');
}]);

angular.module('ui.bootstrap.progressbar', [])

.constant('uibProgressConfig', {
  animate: true,
  max: 100
})

.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
  var self = this,
      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

  this.bars = [];
  $scope.max = getMaxOrDefault();

  this.addBar = function(bar, element, attrs) {
    if (!animate) {
      element.css({'transition': 'none'});
    }

    this.bars.push(bar);

    bar.max = getMaxOrDefault();
    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

    bar.$watch('value', function(value) {
      bar.recalculatePercentage();
    });

    bar.recalculatePercentage = function() {
      var totalPercentage = self.bars.reduce(function(total, bar) {
        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
        return total + bar.percent;
      }, 0);

      if (totalPercentage > 100) {
        bar.percent -= totalPercentage - 100;
      }
    };

    bar.$on('$destroy', function() {
      element = null;
      self.removeBar(bar);
    });
  };

  this.removeBar = function(bar) {
    this.bars.splice(this.bars.indexOf(bar), 1);
    this.bars.forEach(function (bar) {
      bar.recalculatePercentage();
    });
  };

  //$attrs.$observe('maxParam', function(maxParam) {
  $scope.$watch('maxParam', function(maxParam) {
    self.bars.forEach(function(bar) {
      bar.max = getMaxOrDefault();
      bar.recalculatePercentage();
    });
  });

  function getMaxOrDefault () {
    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
  }
}])

.directive('uibProgress', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    require: 'uibProgress',
    scope: {
      maxParam: '=?max'
    },
    templateUrl: 'uib/template/progressbar/progress.html'
  };
})

.directive('uibBar', function() {
  return {
    replace: true,
    transclude: true,
    require: '^uibProgress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/bar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, element, attrs);
    }
  };
})

.directive('uibProgressbar', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    scope: {
      value: '=',
      maxParam: '=?max',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/progressbar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
    }
  };
});

angular.module('ui.bootstrap.rating', [])

.constant('uibRatingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null,
  enableReset: true,
  titles: ['one', 'two', 'three', 'four', 'five']
})

.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
  var ngModelCtrl = { $setViewValue: angular.noop },
    self = this;

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.push(function(value) {
      if (angular.isNumber(value) && value << 0 !== value) {
        value = Math.round(value);
      }

      return value;
    });

    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    this.enableReset = angular.isDefined($attrs.enableReset) ?
      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
      tmpTitles : ratingConfig.titles;

    var ratingStates = angular.isDefined($attrs.ratingStates) ?
      $scope.$parent.$eval($attrs.ratingStates) :
      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };

  this.buildTemplateObjects = function(states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
    }
    return states;
  };

  this.getTitle = function(index) {
    if (index >= this.titles.length) {
      return index + 1;
    }

    return this.titles[index];
  };

  $scope.rate = function(value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
      ngModelCtrl.$setViewValue(newViewValue);
      ngModelCtrl.$render();
    }
  };

  $scope.enter = function(value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({value: value});
  };

  $scope.reset = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };

  $scope.onKeydown = function(evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };

  this.render = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.title = self.getTitle($scope.value - 1);
  };
}])

.directive('uibRating', function() {
  return {
    require: ['uibRating', 'ngModel'],
    restrict: 'A',
    scope: {
      readonly: '=?readOnly',
      onHover: '&',
      onLeave: '&'
    },
    controller: 'UibRatingController',
    templateUrl: 'uib/template/rating/rating.html',
    link: function(scope, element, attrs, ctrls) {
      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      ratingCtrl.init(ngModelCtrl);
    }
  };
});

angular.module('ui.bootstrap.tabs', [])

.controller('UibTabsetController', ['$scope', function ($scope) {
  var ctrl = this,
    oldIndex;
  ctrl.tabs = [];

  ctrl.select = function(index, evt) {
    if (!destroyed) {
      var previousIndex = findTabIndex(oldIndex);
      var previousSelected = ctrl.tabs[previousIndex];
      if (previousSelected) {
        previousSelected.tab.onDeselect({
          $event: evt,
          $selectedIndex: index
        });
        if (evt && evt.isDefaultPrevented()) {
          return;
        }
        previousSelected.tab.active = false;
      }

      var selected = ctrl.tabs[index];
      if (selected) {
        selected.tab.onSelect({
          $event: evt
        });
        selected.tab.active = true;
        ctrl.active = selected.index;
        oldIndex = selected.index;
      } else if (!selected && angular.isDefined(oldIndex)) {
        ctrl.active = null;
        oldIndex = null;
      }
    }
  };

  ctrl.addTab = function addTab(tab) {
    ctrl.tabs.push({
      tab: tab,
      index: tab.index
    });
    ctrl.tabs.sort(function(t1, t2) {
      if (t1.index > t2.index) {
        return 1;
      }

      if (t1.index < t2.index) {
        return -1;
      }

      return 0;
    });

    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
      var newActiveIndex = findTabIndex(tab.index);
      ctrl.select(newActiveIndex);
    }
  };

  ctrl.removeTab = function removeTab(tab) {
    var index;
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].tab === tab) {
        index = i;
        break;
      }
    }

    if (ctrl.tabs[index].index === ctrl.active) {
      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
        index - 1 : index + 1 % ctrl.tabs.length;
      ctrl.select(newActiveTabIndex);
    }

    ctrl.tabs.splice(index, 1);
  };

  $scope.$watch('tabset.active', function(val) {
    if (angular.isDefined(val) && val !== oldIndex) {
      ctrl.select(findTabIndex(val));
    }
  });

  var destroyed;
  $scope.$on('$destroy', function() {
    destroyed = true;
  });

  function findTabIndex(index) {
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].index === index) {
        return i;
      }
    }
  }
}])

.directive('uibTabset', function() {
  return {
    transclude: true,
    replace: true,
    scope: {},
    bindToController: {
      active: '=?',
      type: '@'
    },
    controller: 'UibTabsetController',
    controllerAs: 'tabset',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
    },
    link: function(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ?
        scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ?
        scope.$parent.$eval(attrs.justified) : false;
    }
  };
})

.directive('uibTab', ['$parse', function($parse) {
  return {
    require: '^uibTabset',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tab.html';
    },
    transclude: true,
    scope: {
      heading: '@',
      index: '=?',
      classes: '@?',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
                          //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function() {
      //Empty controller so other directives can require being 'under' a tab
    },
    controllerAs: 'tab',
    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function(value) {
          scope.disabled = !! value;
        });
      }

      if (angular.isUndefined(attrs.index)) {
        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
        } else {
          scope.index = 0;
        }
      }

      if (angular.isUndefined(attrs.classes)) {
        scope.classes = '';
      }

      scope.select = function(evt) {
        if (!scope.disabled) {
          var index;
          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
            if (tabsetCtrl.tabs[i].tab === scope) {
              index = i;
              break;
            }
          }

          tabsetCtrl.select(index, evt);
        }
      };

      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function() {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}])

.directive('uibTabHeadingTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTab',
    link: function(scope, elm) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
})

.directive('uibTabContentTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTabset',
    link: function(scope, elm, attrs) {
      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function(contents) {
        angular.forEach(contents, function(node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };

  function isTabHeading(node) {
    return node.tagName && (
      node.hasAttribute('uib-tab-heading') ||
      node.hasAttribute('data-uib-tab-heading') ||
      node.hasAttribute('x-uib-tab-heading') ||
      node.tagName.toLowerCase() === 'uib-tab-heading' ||
      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'uib:tab-heading'
    );
  }
});

angular.module('ui.bootstrap.timepicker', [])

.constant('uibTimepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: true,
  showSeconds: false,
  meridians: null,
  readonlyInput: false,
  mousewheel: true,
  arrowkeys: true,
  showSpinners: true,
  templateUrl: 'uib/template/timepicker/timepicker.html'
})

.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
  var selected = new Date(),
    watchers = [],
    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
  $element.removeAttr('tabindex');

  this.init = function(ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.unshift(function(modelValue) {
      return modelValue ? new Date(modelValue) : null;
    });

    var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1),
        secondsInputEl = inputs.eq(2);

    hoursModelCtrl = hoursInputEl.controller('ngModel');
    minutesModelCtrl = minutesInputEl.controller('ngModel');
    secondsModelCtrl = secondsInputEl.controller('ngModel');

    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
    if (arrowkeys) {
      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
  };

  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
      hourStep = +value;
    }));
  }

  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
      minuteStep = +value;
    }));
  }

  var min;
  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
    var dt = new Date(value);
    min = isNaN(dt) ? undefined : dt;
  }));

  var max;
  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
    var dt = new Date(value);
    max = isNaN(dt) ? undefined : dt;
  }));

  var disabled = false;
  if ($attrs.ngDisabled) {
    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
      disabled = value;
    }));
  }

  $scope.noIncrementHours = function() {
    var incrementedSelected = addMinutes(selected, hourStep * 60);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementHours = function() {
    var decrementedSelected = addMinutes(selected, -hourStep * 60);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementMinutes = function() {
    var incrementedSelected = addMinutes(selected, minuteStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementMinutes = function() {
    var decrementedSelected = addMinutes(selected, -minuteStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementSeconds = function() {
    var incrementedSelected = addSeconds(selected, secondStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementSeconds = function() {
    var decrementedSelected = addSeconds(selected, -secondStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noToggleMeridian = function() {
    if (selected.getHours() < 12) {
      return disabled || addMinutes(selected, 12 * 60) > max;
    }

    return disabled || addMinutes(selected, -12 * 60) < min;
  };

  var secondStep = timepickerConfig.secondStep;
  if ($attrs.secondStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
      secondStep = +value;
    }));
  }

  $scope.showSeconds = timepickerConfig.showSeconds;
  if ($attrs.showSeconds) {
    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
      $scope.showSeconds = !!value;
    }));
  }

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
      $scope.showMeridian = !!value;

      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    }));
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = +$scope.hours;
    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
      hours >= 0 && hours < 24;
    if (!valid || $scope.hours === '') {
      return undefined;
    }

    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }

  function getMinutesFromTemplate() {
    var minutes = +$scope.minutes;
    var valid = minutes >= 0 && minutes < 60;
    if (!valid || $scope.minutes === '') {
      return undefined;
    }
    return minutes;
  }

  function getSecondsFromTemplate() {
    var seconds = +$scope.seconds;
    return seconds >= 0 && seconds < 60 ? seconds : undefined;
  }

  function pad(value, noPad) {
    if (value === null) {
      return '';
    }

    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
      '0' + value : value.toString();
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    var isScrollingUp = function(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      return e.detail || delta > 0;
    };

    hoursInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      }
      e.preventDefault();
    });

    minutesInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      }
      e.preventDefault();
    });

     secondsInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
      }
      e.preventDefault();
    });
  };

  // Respond on up/down arrowkeys
  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    hoursInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementHours();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementHours();
          $scope.$apply();
        }
      }
    });

    minutesInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementMinutes();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementMinutes();
          $scope.$apply();
        }
      }
    });

    secondsInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementSeconds();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementSeconds();
          $scope.$apply();
        }
      }
    });
  };

  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      $scope.updateSeconds = angular.noop;
      return;
    }

    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
        if (hoursModelCtrl) {
          hoursModelCtrl.$setValidity('hours', false);
        }
      }

      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
        if (minutesModelCtrl) {
          minutesModelCtrl.$setValidity('minutes', false);
        }
      }

      if (angular.isDefined(invalidSeconds)) {
        $scope.invalidSeconds = invalidSeconds;
        if (secondsModelCtrl) {
          secondsModelCtrl.$setValidity('seconds', false);
        }
      }
    };

    $scope.updateHours = function() {
      var hours = getHoursFromTemplate(),
        minutes = getMinutesFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(true);
        } else {
          refresh('h');
        }
      } else {
        invalidate(true);
      }
    };

    hoursInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.hours === null || $scope.hours === '') {
        invalidate(true);
      } else if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function() {
          $scope.hours = pad($scope.hours, !padHours);
        });
      }
    });

    $scope.updateMinutes = function() {
      var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(undefined, true);
        } else {
          refresh('m');
        }
      } else {
        invalidate(undefined, true);
      }
    };

    minutesInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.minutes === null) {
        invalidate(undefined, true);
      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function() {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });

    $scope.updateSeconds = function() {
      var seconds = getSecondsFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(seconds)) {
        selected.setSeconds(seconds);
        refresh('s');
      } else {
        invalidate(undefined, undefined, true);
      }
    };

    secondsInputEl.on('blur', function(e) {
      if (modelIsEmpty()) {
        makeValid();
      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
        $scope.$apply( function() {
          $scope.seconds = pad($scope.seconds);
        });
      }
    });

  };

  this.render = function() {
    var date = ngModelCtrl.$viewValue;

    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }

      if (selected < min || selected > max) {
        ngModelCtrl.$setValidity('time', false);
        $scope.invalidHours = true;
        $scope.invalidMinutes = true;
      } else {
        makeValid();
      }
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }

  function makeValid() {
    if (hoursModelCtrl) {
      hoursModelCtrl.$setValidity('hours', true);
    }

    if (minutesModelCtrl) {
      minutesModelCtrl.$setValidity('minutes', true);
    }

    if (secondsModelCtrl) {
      secondsModelCtrl.$setValidity('seconds', true);
    }

    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
    $scope.invalidSeconds = false;
  }

  function updateTemplate(keyboardChange) {
    if (!ngModelCtrl.$modelValue) {
      $scope.hours = null;
      $scope.minutes = null;
      $scope.seconds = null;
      $scope.meridian = meridians[0];
    } else {
      var hours = selected.getHours(),
        minutes = selected.getMinutes(),
        seconds = selected.getSeconds();

      if ($scope.showMeridian) {
        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
      }

      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
      if (keyboardChange !== 'm') {
        $scope.minutes = pad(minutes);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

      if (keyboardChange !== 's') {
        $scope.seconds = pad(seconds);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
    }
  }

  function addSecondsToSelected(seconds) {
    selected = addSeconds(selected, seconds);
    refresh();
  }

  function addMinutes(selected, minutes) {
    return addSeconds(selected, minutes*60);
  }

  function addSeconds(date, seconds) {
    var dt = new Date(date.getTime() + seconds * 1000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
    return newDate;
  }

  function modelIsEmpty() {
    return ($scope.hours === null || $scope.hours === '') &&
      ($scope.minutes === null || $scope.minutes === '') &&
      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
  }

  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

  $scope.incrementHours = function() {
    if (!$scope.noIncrementHours()) {
      addSecondsToSelected(hourStep * 60 * 60);
    }
  };

  $scope.decrementHours = function() {
    if (!$scope.noDecrementHours()) {
      addSecondsToSelected(-hourStep * 60 * 60);
    }
  };

  $scope.incrementMinutes = function() {
    if (!$scope.noIncrementMinutes()) {
      addSecondsToSelected(minuteStep * 60);
    }
  };

  $scope.decrementMinutes = function() {
    if (!$scope.noDecrementMinutes()) {
      addSecondsToSelected(-minuteStep * 60);
    }
  };

  $scope.incrementSeconds = function() {
    if (!$scope.noIncrementSeconds()) {
      addSecondsToSelected(secondStep);
    }
  };

  $scope.decrementSeconds = function() {
    if (!$scope.noDecrementSeconds()) {
      addSecondsToSelected(-secondStep);
    }
  };

  $scope.toggleMeridian = function() {
    var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

    if (!$scope.noToggleMeridian()) {
      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
      } else {
        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
      }
    }
  };

  $scope.blur = function() {
    ngModelCtrl.$setTouched();
  };

  $scope.$on('$destroy', function() {
    while (watchers.length) {
      watchers.shift()();
    }
  });
}])

.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
  return {
    require: ['uibTimepicker', '?^ngModel'],
    restrict: 'A',
    controller: 'UibTimepickerController',
    controllerAs: 'timepicker',
    scope: {},
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
    },
    link: function(scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
}]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory('uibTypeaheadParser', ['$parse', function($parse) {
    //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
    return {
      parse: function(input) {
        var match = input.match(TYPEAHEAD_REGEXP);
        if (!match) {
          throw new Error(
            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
              ' but got "' + input + '".');
        }

        return {
          itemName: match[3],
          source: $parse(match[4]),
          viewMapper: $parse(match[2] || match[1]),
          modelMapper: $parse(match[1])
        };
      }
    };
  }])

  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
    var HOT_KEYS = [9, 13, 27, 38, 40];
    var eventDebounceTime = 200;
    var modelCtrl, ngModelOptions;
    //SUPPORTED ATTRIBUTES (OPTIONS)

    //minimal no of characters that needs to be entered before typeahead kicks-in
    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
    if (!minLength && minLength !== 0) {
      minLength = 1;
    }

    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
        minLength = !newVal && newVal !== 0 ? 1 : newVal;
    });

    //minimal wait time after last character typed before typeahead kicks-in
    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

    //should it restrict model values to the ones selected from the popup only?
    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
      isEditable = newVal !== false;
    });

    //binding to a variable that indicates if matches are being retrieved asynchronously
    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

    //a function to determine if an event should cause selection
    var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
      var evt = vals.$event;
      return evt.which === 13 || evt.which === 9;
    };

    //a callback executed when a match is selected
    var onSelectCallback = $parse(attrs.typeaheadOnSelect);

    //should it select highlighted popup value when losing focus?
    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

    //binding to a variable that indicates if there were no results after the query is completed
    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

    var appendTo = attrs.typeaheadAppendTo ?
      originalScope.$eval(attrs.typeaheadAppendTo) : null;

    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

    //If input matches an item of the list exactly, select it automatically
    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

    //binding to a variable that indicates if dropdown is open
    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

    //INTERNAL VARIABLES

    //model setter executed upon match selection
    var parsedModel = $parse(attrs.ngModel);
    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
    var $setModelValue = function(scope, newValue) {
      if (angular.isFunction(parsedModel(originalScope)) &&
        ngModelOptions.getOption('getterSetter')) {
        return invokeModelSetter(scope, {$$$p: newValue});
      }

      return parsedModel.assign(scope, newValue);
    };

    //expressions used by typeahead
    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

    var hasFocus;

    //Used to avoid bug in iOS webview where iOS keyboard does not fire
    //mousedown & mouseup events
    //Issue #3699
    var selected;

    //create a child scope for the typeahead directive so we are not polluting original scope
    //with typeahead-specific data (matches, query etc.)
    var scope = originalScope.$new();
    var offDestroy = originalScope.$on('$destroy', function() {
      scope.$destroy();
    });
    scope.$on('$destroy', offDestroy);

    // WAI-ARIA
    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
    element.attr({
      'aria-autocomplete': 'list',
      'aria-expanded': false,
      'aria-owns': popupId
    });

    var inputsContainer, hintInputElem;
    //add read-only input to show hint
    if (showHint) {
      inputsContainer = angular.element('<div></div>');
      inputsContainer.css('position', 'relative');
      element.after(inputsContainer);
      hintInputElem = element.clone();
      hintInputElem.attr('placeholder', '');
      hintInputElem.attr('tabindex', '-1');
      hintInputElem.val('');
      hintInputElem.css({
        'position': 'absolute',
        'top': '0px',
        'left': '0px',
        'border-color': 'transparent',
        'box-shadow': 'none',
        'opacity': 1,
        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
        'color': '#999'
      });
      element.css({
        'position': 'relative',
        'vertical-align': 'top',
        'background-color': 'transparent'
      });

      if (hintInputElem.attr('id')) {
        hintInputElem.removeAttr('id'); // remove duplicate id if present.
      }
      inputsContainer.append(hintInputElem);
      hintInputElem.after(element);
    }

    //pop-up element used to display matches
    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
    popUpEl.attr({
      id: popupId,
      matches: 'matches',
      active: 'activeIdx',
      select: 'select(activeIdx, evt)',
      'move-in-progress': 'moveInProgress',
      query: 'query',
      position: 'position',
      'assign-is-open': 'assignIsOpen(isOpen)',
      debounce: 'debounceUpdate'
    });
    //custom item template
    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
    }

    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
    }

    var resetHint = function() {
      if (showHint) {
        hintInputElem.val('');
      }
    };

    var resetMatches = function() {
      scope.matches = [];
      scope.activeIdx = -1;
      element.attr('aria-expanded', false);
      resetHint();
    };

    var getMatchId = function(index) {
      return popupId + '-option-' + index;
    };

    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
    // This attribute is added or removed automatically when the `activeIdx` changes.
    scope.$watch('activeIdx', function(index) {
      if (index < 0) {
        element.removeAttr('aria-activedescendant');
      } else {
        element.attr('aria-activedescendant', getMatchId(index));
      }
    });

    var inputIsExactMatch = function(inputValue, index) {
      if (scope.matches.length > index && inputValue) {
        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
      }

      return false;
    };

    var getMatchesAsync = function(inputValue, evt) {
      var locals = {$viewValue: inputValue};
      isLoadingSetter(originalScope, true);
      isNoResultsSetter(originalScope, false);
      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
        //it might happen that several async queries were in progress if a user were typing fast
        //but we are interested only in responses that correspond to the current view value
        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
        if (onCurrentRequest && hasFocus) {
          if (matches && matches.length > 0) {
            scope.activeIdx = focusFirst ? 0 : -1;
            isNoResultsSetter(originalScope, false);
            scope.matches.length = 0;

            //transform labels
            for (var i = 0; i < matches.length; i++) {
              locals[parserResult.itemName] = matches[i];
              scope.matches.push({
                id: getMatchId(i),
                label: parserResult.viewMapper(scope, locals),
                model: matches[i]
              });
            }

            scope.query = inputValue;
            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
            //due to other elements being rendered
            recalculatePosition();

            element.attr('aria-expanded', true);

            //Select the single remaining option if user input matches
            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(0, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(0, evt);
              }
            }

            if (showHint) {
              var firstLabel = scope.matches[0].label;
              if (angular.isString(inputValue) &&
                inputValue.length > 0 &&
                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
              } else {
                hintInputElem.val('');
              }
            }
          } else {
            resetMatches();
            isNoResultsSetter(originalScope, true);
          }
        }
        if (onCurrentRequest) {
          isLoadingSetter(originalScope, false);
        }
      }, function() {
        resetMatches();
        isLoadingSetter(originalScope, false);
        isNoResultsSetter(originalScope, true);
      });
    };

    // bind events only if appendToBody params exist - performance feature
    if (appendToBody) {
      angular.element($window).on('resize', fireRecalculating);
      $document.find('body').on('scroll', fireRecalculating);
    }

    // Declare the debounced function outside recalculating for
    // proper debouncing
    var debouncedRecalculate = $$debounce(function() {
      // if popup is visible
      if (scope.matches.length) {
        recalculatePosition();
      }

      scope.moveInProgress = false;
    }, eventDebounceTime);

    // Default progress type
    scope.moveInProgress = false;

    function fireRecalculating() {
      if (!scope.moveInProgress) {
        scope.moveInProgress = true;
        scope.$digest();
      }

      debouncedRecalculate();
    }

    // recalculate actual position and set new values to scope
    // after digest loop is popup in right position
    function recalculatePosition() {
      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
      scope.position.top += element.prop('offsetHeight');
    }

    //we need to propagate user's query so we can higlight matches
    scope.query = undefined;

    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
    var timeoutPromise;

    var scheduleSearchWithTimeout = function(inputValue) {
      timeoutPromise = $timeout(function() {
        getMatchesAsync(inputValue);
      }, waitTime);
    };

    var cancelPreviousTimeout = function() {
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }
    };

    resetMatches();

    scope.assignIsOpen = function (isOpen) {
      isOpenSetter(originalScope, isOpen);
    };

    scope.select = function(activeIdx, evt) {
      //called from within the $digest() cycle
      var locals = {};
      var model, item;

      selected = true;
      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
      model = parserResult.modelMapper(originalScope, locals);
      $setModelValue(originalScope, model);
      modelCtrl.$setValidity('editable', true);
      modelCtrl.$setValidity('parse', true);

      onSelectCallback(originalScope, {
        $item: item,
        $model: model,
        $label: parserResult.viewMapper(originalScope, locals),
        $event: evt
      });

      resetMatches();

      //return focus to the input element if a match was selected via a mouse click event
      // use timeout to avoid $rootScope:inprog error
      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
        $timeout(function() { element[0].focus(); }, 0, false);
      }
    };

    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
    element.on('keydown', function(evt) {
      //typeahead is open and an "interesting" key was pressed
      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
        return;
      }

      var shouldSelect = isSelectEvent(originalScope, {$event: evt});

      /**
       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
       * or
       * shift + tab is pressed to bring focus to the previous element
       * then clear the results
       */
      if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
        resetMatches();
        scope.$digest();
        return;
      }

      evt.preventDefault();
      var target;
      switch (evt.which) {
        case 27: // escape
          evt.stopPropagation();

          resetMatches();
          originalScope.$digest();
          break;
        case 38: // up arrow
          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        case 40: // down arrow
          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        default:
          if (shouldSelect) {
            scope.$apply(function() {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(scope.activeIdx, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(scope.activeIdx, evt);
              }
            });
          }
      }
    });

    element.on('focus', function (evt) {
      hasFocus = true;
      if (minLength === 0 && !modelCtrl.$viewValue) {
        $timeout(function() {
          getMatchesAsync(modelCtrl.$viewValue, evt);
        }, 0);
      }
    });

    element.on('blur', function(evt) {
      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
        selected = true;
        scope.$apply(function() {
          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
            $$debounce(function() {
              scope.select(scope.activeIdx, evt);
            }, scope.debounceUpdate.blur);
          } else {
            scope.select(scope.activeIdx, evt);
          }
        });
      }
      if (!isEditable && modelCtrl.$error.editable) {
        modelCtrl.$setViewValue();
        scope.$apply(function() {
          // Reset validity as we are clearing
          modelCtrl.$setValidity('editable', true);
          modelCtrl.$setValidity('parse', true);
        });
        element.val('');
      }
      hasFocus = false;
      selected = false;
    });

    // Keep reference to click handler to unbind it.
    var dismissClickHandler = function(evt) {
      // Issue #3973
      // Firefox treats right click as a click on document
      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
        resetMatches();
        if (!$rootScope.$$phase) {
          originalScope.$digest();
        }
      }
    };

    $document.on('click', dismissClickHandler);

    originalScope.$on('$destroy', function() {
      $document.off('click', dismissClickHandler);
      if (appendToBody || appendTo) {
        $popup.remove();
      }

      if (appendToBody) {
        angular.element($window).off('resize', fireRecalculating);
        $document.find('body').off('scroll', fireRecalculating);
      }
      // Prevent jQuery cache memory leak
      popUpEl.remove();

      if (showHint) {
          inputsContainer.remove();
      }
    });

    var $popup = $compile(popUpEl)(scope);

    if (appendToBody) {
      $document.find('body').append($popup);
    } else if (appendTo) {
      angular.element(appendTo).eq(0).append($popup);
    } else {
      element.after($popup);
    }

    this.init = function(_modelCtrl) {
      modelCtrl = _modelCtrl;
      ngModelOptions = extractOptions(modelCtrl);

      scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);

      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
      modelCtrl.$parsers.unshift(function(inputValue) {
        hasFocus = true;

        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
          if (waitTime > 0) {
            cancelPreviousTimeout();
            scheduleSearchWithTimeout(inputValue);
          } else {
            getMatchesAsync(inputValue);
          }
        } else {
          isLoadingSetter(originalScope, false);
          cancelPreviousTimeout();
          resetMatches();
        }

        if (isEditable) {
          return inputValue;
        }

        if (!inputValue) {
          // Reset in case user had typed something previously.
          modelCtrl.$setValidity('editable', true);
          return null;
        }

        modelCtrl.$setValidity('editable', false);
        return undefined;
      });

      modelCtrl.$formatters.push(function(modelValue) {
        var candidateViewValue, emptyViewValue;
        var locals = {};

        // The validity may be set to false via $parsers (see above) if
        // the model is restricted to selected values. If the model
        // is set manually it is considered to be valid.
        if (!isEditable) {
          modelCtrl.$setValidity('editable', true);
        }

        if (inputFormatter) {
          locals.$model = modelValue;
          return inputFormatter(originalScope, locals);
        }

        //it might happen that we don't have enough info to properly render input value
        //we need to check for this situation and simply return model value if we can't apply custom formatting
        locals[parserResult.itemName] = modelValue;
        candidateViewValue = parserResult.viewMapper(originalScope, locals);
        locals[parserResult.itemName] = undefined;
        emptyViewValue = parserResult.viewMapper(originalScope, locals);

        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
      });
    };

    function extractOptions(ngModelCtrl) {
      var ngModelOptions;

      if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
        // guarantee a value
        ngModelOptions = ngModelCtrl.$options || {};

        // mimic 1.6+ api
        ngModelOptions.getOption = function (key) {
          return ngModelOptions[key];
        };
      } else { // in angular >=1.6 $options is always present
        ngModelOptions = ngModelCtrl.$options;
      }

      return ngModelOptions;
    }
  }])

  .directive('uibTypeahead', function() {
    return {
      controller: 'UibTypeaheadController',
      require: ['ngModel', 'uibTypeahead'],
      link: function(originalScope, element, attrs, ctrls) {
        ctrls[1].init(ctrls[0]);
      }
    };
  })

  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
    return {
      scope: {
        matches: '=',
        query: '=',
        active: '=',
        position: '&',
        moveInProgress: '=',
        select: '&',
        assignIsOpen: '&',
        debounce: '&'
      },
      replace: true,
      templateUrl: function(element, attrs) {
        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
      },
      link: function(scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function() {
          var isDropdownOpen = scope.matches.length > 0;
          scope.assignIsOpen({ isOpen: isDropdownOpen });
          return isDropdownOpen;
        };

        scope.isActive = function(matchIdx) {
          return scope.active === matchIdx;
        };

        scope.selectActive = function(matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function(activeIdx, evt) {
          var debounce = scope.debounce();
          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
            $$debounce(function() {
              scope.select({activeIdx: activeIdx, evt: evt});
            }, angular.isNumber(debounce) ? debounce : debounce['default']);
          } else {
            scope.select({activeIdx: activeIdx, evt: evt});
          }
        };
      }
    };
  }])

  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
    return {
      scope: {
        index: '=',
        match: '=',
        query: '='
      },
      link: function(scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
        $templateRequest(tplUrl).then(function(tplContent) {
          var tplEl = angular.element(tplContent.trim());
          element.replaceWith(tplEl);
          $compile(tplEl)(scope);
        });
      }
    };
  }])

  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function(matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/accordion/accordion-group.html",
    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
    "  <h4 class=\"panel-title\">\n" +
    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "  </h4>\n" +
    "</div>\n" +
    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
    "  <div class=\"panel-body\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/accordion/accordion.html",
    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/alert/alert.html",
    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
    "  <span aria-hidden=\"true\">&times;</span>\n" +
    "  <span class=\"sr-only\">Close</span>\n" +
    "</button>\n" +
    "<div ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/carousel/carousel.html",
    "<div class=\"carousel-inner\" ng-transclude></div>\n" +
    "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
    "  <span class=\"sr-only\">previous</span>\n" +
    "</a>\n" +
    "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
    "  <span class=\"sr-only\">next</span>\n" +
    "</a>\n" +
    "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
    "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
    "  </li>\n" +
    "</ol>\n" +
    "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/carousel/slide.html",
    "<div class=\"text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\">\n" +
    "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
    "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
    "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepickerPopup/popup.html",
    "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "  <li ng-transclude></li>\n" +
    "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "    <span class=\"btn-group pull-left\">\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "    </span>\n" +
    "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/modal/window.html",
    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
    "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/pager/pager.html",
    "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/pagination/pagination.html",
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\"\n" +
    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover-html.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover-template.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\"\n" +
    "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/bar.html",
    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/progressbar.html",
    "<div class=\"progress\">\n" +
    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/rating/rating.html",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
    "</span>\n" +
    "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tabs/tab.html",
    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\"\n" +
    "         ng-repeat=\"tab in tabset.tabs\"\n" +
    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
    "         uib-tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/timepicker/timepicker.html",
    "<table class=\"uib-timepicker\">\n" +
    "  <tbody>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
    "    </tr>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-match.html",
    "<a href\n" +
    "   tabindex=\"-1\"\n" +
    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);
angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(606);

module.exports = 'ui.bootstrap';


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(moment, $) {/*
*  AngularJs Fullcalendar Wrapper for the JQuery FullCalendar
*  API @ http://arshaw.com/fullcalendar/
*
*  Angular Calendar Directive that takes in the [eventSources] nested array object as the ng-model and watches it deeply changes.
*       Can also take in multiple event urls as a source object(s) and feed the events per view.
*       The calendar will watch any eventSource array and update itself when a change is made.
*
*/

angular.module('ui.calendar', [])
  .constant('uiCalendarConfig', {calendars: {}})
  .controller('uiCalendarCtrl', ['$scope', 
                                 '$locale', function(
                                  $scope, 
                                  $locale){

      var sources = $scope.eventSources,
          extraEventSignature = $scope.calendarWatchEvent ? $scope.calendarWatchEvent : angular.noop,

          wrapFunctionWithScopeApply = function(functionToWrap){
              return function(){
                  // This may happen outside of angular context, so create one if outside.

                  if ($scope.$root.$$phase) {
                      return functionToWrap.apply(this, arguments);
                  } else {
                      var args = arguments;
                      var self = this;
                      return $scope.$root.$apply(function(){
                          return functionToWrap.apply(self, args);
                      });
                  }
              };
          };

      var eventSerialId = 1;
      // @return {String} fingerprint of the event object and its properties
      this.eventFingerprint = function(e) {
        if (!e._id) {
          e._id = eventSerialId++;
        }
        
        var extraSignature = extraEventSignature({event: e}) || '';
        var start = moment.isMoment(e.start) ? e.start.unix() : (e.start ? moment(e.start).unix() : '');
        var end =   moment.isMoment(e.end)   ? e.end.unix()   : (e.end   ? moment(e.end).unix()   : '');
        
        // This extracts all the information we need from the event. http://jsperf.com/angular-calendar-events-fingerprint/3
        return "" + e._id + (e.id || '') + (e.title || '') + (e.url || '') + start + end +
          (e.allDay || '') + (e.className || '') + extraSignature;
      };

      var sourceSerialId = 1, sourceEventsSerialId = 1;
      // @return {String} fingerprint of the source object and its events array
      this.sourceFingerprint = function(source) {
          var fp = '' + (source.__id || (source.__id = sourceSerialId++)),
              events = angular.isObject(source) && source.events;
          if (events) {
              fp = fp + '-' + (events.__id || (events.__id = sourceEventsSerialId++));
          }
          return fp;
      };

      // @return {Array} all events from all sources
      this.allEvents = function() {
        // do sources.map(&:events).flatten(), but we don't have flatten
        var arraySources = [];
        for (var i = 0, srcLen = sources.length; i < srcLen; i++) {
          var source = sources[i];
          if (angular.isArray(source)) {
            // event source as array
            arraySources.push(source);
          } else if(angular.isObject(source) && angular.isArray(source.events)){
            // event source as object, ie extended form
            var extEvent = {};
            for(var key in source){
              if(key !== '_id' && key !== 'events'){
                 extEvent[key] = source[key];
              }
            }
            for(var eI = 0;eI < source.events.length;eI++){
              angular.extend(source.events[eI],extEvent);
            }
            arraySources.push(source.events);
          }
        }
        return Array.prototype.concat.apply([], arraySources);
      };

      // Track changes in array of objects by assigning id tokens to each element and watching the scope for changes in the tokens
      // @param {Array|Function} arraySource array of objects to watch
      // @param tokenFn {Function} that returns the token for a given object
      // @return {Object}
      //  subscribe: function(scope, function(newTokens, oldTokens))
      //    called when source has changed. return false to prevent individual callbacks from firing
      //  onAdded/Removed/Changed:
      //    when set to a callback, called each item where a respective change is detected
      this.changeWatcher = function(arraySource, tokenFn) {
        var self;
        var getTokens = function() {
          var array = angular.isFunction(arraySource) ? arraySource() : arraySource;
          var result = [], token, el;
          for (var i = 0, n = array.length; i < n; i++) {
            el = array[i];
            token = tokenFn(el);
            map[token] = el;
            result.push(token);
          }
          return result;
        };

        // @param {Array} a
        // @param {Array} b
        // @return {Array} elements in that are in a but not in b
        // @example
        //  subtractAsSets([6, 100, 4, 5], [4, 5, 7]) // [6, 100]
        var subtractAsSets = function(a, b) {
          var result = [], inB = {}, i, n;
          for (i = 0, n = b.length; i < n; i++) {
            inB[b[i]] = true;
          }
          for (i = 0, n = a.length; i < n; i++) {
            if (!inB[a[i]]) {
              result.push(a[i]);
            }
          }
          return result;
        };

        // Map objects to tokens and vice-versa
        var map = {};

        // Compare newTokens to oldTokens and call onAdded, onRemoved, and onChanged handlers for each affected event respectively.
        var applyChanges = function(newTokens, oldTokens) {
          var i, n, el, token;
          var replacedTokens = {};
          var removedTokens = subtractAsSets(oldTokens, newTokens);
          for (i = 0, n = removedTokens.length; i < n; i++) {
            var removedToken = removedTokens[i];
            el = map[removedToken];
            delete map[removedToken];
            var newToken = tokenFn(el);
            // if the element wasn't removed but simply got a new token, its old token will be different from the current one
            if (newToken === removedToken) {
              self.onRemoved(el);
            } else {
              replacedTokens[newToken] = removedToken;
              self.onChanged(el);
            }
          }

          var addedTokens = subtractAsSets(newTokens, oldTokens);
          for (i = 0, n = addedTokens.length; i < n; i++) {
            token = addedTokens[i];
            el = map[token];
            if (!replacedTokens[token]) {
              self.onAdded(el);
            }
          }
        };
        return self = {
          subscribe: function(scope, onArrayChanged) {
            scope.$watch(getTokens, function(newTokens, oldTokens) {
              var notify = !(onArrayChanged && onArrayChanged(newTokens, oldTokens) === false);
              if (notify) {
                applyChanges(newTokens, oldTokens);
              }
            }, true);
          },
          onAdded: angular.noop,
          onChanged: angular.noop,
          onRemoved: angular.noop
        };
      };

      this.getFullCalendarConfig = function(calendarSettings, uiCalendarConfig){
          var config = {};

          angular.extend(config, uiCalendarConfig);
          angular.extend(config, calendarSettings);

          angular.forEach(config, function(value,key){
            if (typeof value === 'function'){
              config[key] = wrapFunctionWithScopeApply(config[key]);
            }
          });

          return config;
      };

    this.getLocaleConfig = function(fullCalendarConfig) {
      if (!fullCalendarConfig.lang || fullCalendarConfig.useNgLocale) {
        // Configure to use locale names by default
        var tValues = function(data) {
          // convert {0: "Jan", 1: "Feb", ...} to ["Jan", "Feb", ...]
          var r, k;
          r = [];
          for (k in data) {
            r[k] = data[k];
          }
          return r;
        };
        var dtf = $locale.DATETIME_FORMATS;
        return {
          monthNames: tValues(dtf.MONTH),
          monthNamesShort: tValues(dtf.SHORTMONTH),
          dayNames: tValues(dtf.DAY),
          dayNamesShort: tValues(dtf.SHORTDAY)
        };
      }
      return {};
    };
  }])
  .directive('uiCalendar', ['uiCalendarConfig', function(uiCalendarConfig) {
    return {
      restrict: 'A',
      scope: {eventSources:'=ngModel',calendarWatchEvent: '&'},
      controller: 'uiCalendarCtrl',
      link: function(scope, elm, attrs, controller) {

        var sources = scope.eventSources,
            sourcesChanged = false,
            calendar,
            eventSourcesWatcher = controller.changeWatcher(sources, controller.sourceFingerprint),
            eventsWatcher = controller.changeWatcher(controller.allEvents, controller.eventFingerprint),
            options = null;

        function getOptions(){
          var calendarSettings = attrs.uiCalendar ? scope.$parent.$eval(attrs.uiCalendar) : {},
              fullCalendarConfig;

          fullCalendarConfig = controller.getFullCalendarConfig(calendarSettings, uiCalendarConfig);

          var localeFullCalendarConfig = controller.getLocaleConfig(fullCalendarConfig);
          angular.extend(localeFullCalendarConfig, fullCalendarConfig);
          options = { eventSources: sources };
          angular.extend(options, localeFullCalendarConfig);
          //remove calendars from options
          options.calendars = null;

          var options2 = {};
          for(var o in options){
            if(o !== 'eventSources'){
              options2[o] = options[o];
            }
          }
          return JSON.stringify(options2);
        }

        scope.destroyCalendar = function(){
          if(calendar && calendar.fullCalendar){
            calendar.fullCalendar('destroy');
          }
          if(attrs.calendar) {
            calendar = uiCalendarConfig.calendars[attrs.calendar] = $(elm).html('');
          } else {
            calendar = $(elm).html('');
          }
        };

        scope.initCalendar = function(){
          if (!calendar) {
            calendar = angular.element(elm).html('');
          }
          calendar.fullCalendar(options);
          if(attrs.calendar) {
            uiCalendarConfig.calendars[attrs.calendar] = calendar;
          }          
        };
        scope.$on('$destroy', function() {
          scope.destroyCalendar();
        });

        eventSourcesWatcher.onAdded = function(source) {
          if (calendar && calendar.fullCalendar) {
            calendar.fullCalendar(options);
            if (attrs.calendar) {
                uiCalendarConfig.calendars[attrs.calendar] = calendar;
            }
            calendar.fullCalendar('addEventSource', source);
            sourcesChanged = true;
          }
        };

        eventSourcesWatcher.onRemoved = function(source) {
          if (calendar && calendar.fullCalendar) {
            calendar.fullCalendar('removeEventSource', source);
            sourcesChanged = true;
          }
        };

        eventSourcesWatcher.onChanged = function() {
          if (calendar && calendar.fullCalendar) {
            calendar.fullCalendar('refetchEvents');
            sourcesChanged = true;
          }

        };

        eventsWatcher.onAdded = function(event) {
          if (calendar && calendar.fullCalendar) {
            calendar.fullCalendar('renderEvent', event, (event.stick ? true : false));
          }
        };

        eventsWatcher.onRemoved = function(event) {
          if (calendar && calendar.fullCalendar) {
            calendar.fullCalendar('removeEvents', event._id);
          }
        };

        eventsWatcher.onChanged = function(event) {
          if (calendar && calendar.fullCalendar) {
            var clientEvents = calendar.fullCalendar('clientEvents', event._id);
            for (var i = 0; i < clientEvents.length; i++) {
              var clientEvent = clientEvents[i];
              clientEvent = angular.extend(clientEvent, event);
              calendar.fullCalendar('updateEvent', clientEvent);
            }
          }
        };

        eventSourcesWatcher.subscribe(scope);
        eventsWatcher.subscribe(scope, function() {
          if (sourcesChanged === true) {
            sourcesChanged = false;
            // return false to prevent onAdded/Removed/Changed handlers from firing in this case
            return false;
          }
        });

        scope.$watch(getOptions, function(newValue, oldValue) {
          if(newValue !== oldValue) {
            scope.destroyCalendar();
            scope.initCalendar();
          } else if((newValue && angular.isUndefined(calendar))) {
            scope.initCalendar();
          }
        });
      }
    };
}]);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(59)))

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * # Angular 1 Directives
 *
 * These are the directives included in UI-Router for Angular 1.
 * These directives are used in templates to create viewports and link/navigate to states.
 *
 * @ng1api
 * @preferred
 * @module directives
 */ /** for typedoc */
var angular_1 = __webpack_require__(111);
var core_1 = __webpack_require__(52);
/** @hidden */
function parseStateRef(ref) {
    var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/), parsed;
    if (paramsOnly)
        ref = '(' + paramsOnly[1] + ')';
    parsed = ref.replace(/\n/g, " ").match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
    if (!parsed || parsed.length !== 4)
        throw new Error("Invalid state ref '" + ref + "'");
    return { state: parsed[1] || null, paramExpr: parsed[3] || null };
}
/** @hidden */
function stateContext(el) {
    var $uiView = el.parent().inheritedData('$uiView');
    var path = core_1.parse('$cfg.path')($uiView);
    return path ? core_1.tail(path).state.name : undefined;
}
/** @hidden */
function processedDef($state, $element, def) {
    var uiState = def.uiState || $state.current.name;
    var uiStateOpts = core_1.extend(defaultOpts($element, $state), def.uiStateOpts || {});
    var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
    return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
}
/** @hidden */
function getTypeInfo(el) {
    // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
    var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
    var isForm = el[0].nodeName === "FORM";
    return {
        attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
        isAnchor: el.prop("tagName").toUpperCase() === "A",
        clickable: !isForm
    };
}
/** @hidden */
function clickHook(el, $state, $timeout, type, getDef) {
    return function (e) {
        var button = e.which || e.button, target = getDef();
        if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
            // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
            var transition = $timeout(function () {
                $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
            });
            e.preventDefault();
            // if the state has no URL, ignore one preventDefault from the <a> directive.
            var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1 : 0;
            e.preventDefault = function () {
                if (ignorePreventDefaultCount-- <= 0)
                    $timeout.cancel(transition);
            };
        }
    };
}
/** @hidden */
function defaultOpts(el, $state) {
    return {
        relative: stateContext(el) || $state.$current,
        inherit: true,
        source: "sref"
    };
}
/** @hidden */
function bindEvents(element, scope, hookFn, uiStateOpts) {
    var events;
    if (uiStateOpts) {
        events = uiStateOpts.events;
    }
    if (!core_1.isArray(events)) {
        events = ['click'];
    }
    var on = element.on ? 'on' : 'bind';
    for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
        var event_1 = events_1[_i];
        element[on](event_1, hookFn);
    }
    scope.$on('$destroy', function () {
        var off = element.off ? 'off' : 'unbind';
        for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
            var event_2 = events_2[_i];
            element[off](event_2, hookFn);
        }
    });
}
/**
 * `ui-sref`: A directive for linking to a state
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * ### Linked State
 * The attribute value of the `ui-sref` is the name of the state to link to.
 *
 * #### Example:
 * This will activate the `home` state when the link is clicked.
 * ```html
 * <a ui-sref="home">Home</a>
 * ```
 *
 * ### Relative Links
 * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
 * You just need to be aware that the path is relative to the state that *created* the link.
 * This allows a state to create a relative `ui-sref` which always targets the same destination.
 *
 * #### Example:
 * Both these links are relative to the parent state, even when a child state is currently active.
 * ```html
 * <a ui-sref=".child1">child 1 state</a>
 * <a ui-sref=".child2">child 2 state</a>
 * ```
 *
 * This link activates the parent state.
 * ```html
 * <a ui-sref="^">Return</a>
 * ```
 *
 * ### hrefs
 * If the linked state has a URL, the directive will automatically generate and
 * update the `href` attribute (using the [[StateService.href]]  method).
 *
 * #### Example:
 * Assuming the `users` state has a url of `/users/`
 * ```html
 * <a ui-sref="users" href="/users/">Users</a>
 * ```
 *
 * ### Parameter Values
 * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
 * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
 * The content inside the parentheses is an expression, evaluated to the parameter values.
 *
 * #### Example:
 * This example renders a list of links to users.
 * The state's `userId` parameter value comes from each user's `user.id` property.
 * ```html
 * <li ng-repeat="user in users">
 *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
 * </li>
 * ```
 *
 * Note:
 * The parameter values expression is `$watch`ed for updates.
 *
 * ### Transition Options
 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
 * Options are restricted to `location`, `inherit`, and `reload`.
 *
 * #### Example:
 * ```html
 * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
 * ```
 *
 * ### Other DOM Events
 *
 * You can also customize which DOM events to respond to (instead of `click`) by
 * providing an `events` array in the `ui-sref-opts` attribute.
 *
 * #### Example:
 * ```html
 * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
 * ```
 *
 * ### Highlighting the active link
 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
 *
 * ### Examples
 * If you have the following template:
 *
 * ```html
 * <a ui-sref="home">Home</a>
 * <a ui-sref="about">About</a>
 * <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * ```
 *
 * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
 *
 * ```html
 * <a href="#/home" ui-sref="home">Home</a>
 * <a href="#/about" ui-sref="about">About</a>
 * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * ```
 *
 * ### Notes
 *
 * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
 * #### Example:
 * Sets the `lang` parameter to `en` and remains on the same state.
 *
 * ```html
 * <a ui-sref="{ lang: 'en' }">English</a>
 * ```
 *
 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
 *
 * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
 * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
 */
var uiSref;
uiSref = ['$uiRouter', '$timeout',
    function $StateRefDirective($uiRouter, $timeout) {
        var $state = $uiRouter.stateService;
        return {
            restrict: 'A',
            require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
            link: function (scope, element, attrs, uiSrefActive) {
                var type = getTypeInfo(element);
                var active = uiSrefActive[1] || uiSrefActive[0];
                var unlinkInfoFn = null;
                var hookFn;
                var rawDef = {};
                var getDef = function () { return processedDef($state, element, rawDef); };
                var ref = parseStateRef(attrs.uiSref);
                rawDef.uiState = ref.state;
                rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
                function update() {
                    var def = getDef();
                    if (unlinkInfoFn)
                        unlinkInfoFn();
                    if (active)
                        unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                    if (def.href != null)
                        attrs.$set(type.attr, def.href);
                }
                if (ref.paramExpr) {
                    scope.$watch(ref.paramExpr, function (val) {
                        rawDef.uiStateParams = core_1.extend({}, val);
                        update();
                    }, true);
                    rawDef.uiStateParams = core_1.extend({}, scope.$eval(ref.paramExpr));
                }
                update();
                scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
                scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
                if (!type.clickable)
                    return;
                hookFn = clickHook(element, $state, $timeout, type, getDef);
                bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
            }
        };
    }];
/**
 * `ui-state`: A fully dynamic directive for linking to a state
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * ### Linked State
 * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
 * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
 *
 * #### Example:
 * Create a list of links.
 * ```html
 * <li ng-repeat="link in navlinks">
 *   <a ui-state="link.state">{{ link.displayName }}</a>
 * </li>
 * ```
 *
 * ### Relative Links
 * If the expression evaluates to a relative path, it is processed like [[uiSref]].
 * You just need to be aware that the path is relative to the state that *created* the link.
 * This allows a state to create relative `ui-state` which always targets the same destination.
 *
 * ### hrefs
 * If the linked state has a URL, the directive will automatically generate and
 * update the `href` attribute (using the [[StateService.href]]  method).
 *
 * ### Parameter Values
 * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
 * Param values should be provided using the `ui-state-params` attribute.
 * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
 *
 * #### Example:
 * This example renders a list of links with param values.
 * The state's `userId` parameter value comes from each user's `user.id` property.
 * ```html
 * <li ng-repeat="link in navlinks">
 *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
 * </li>
 * ```
 *
 * ### Transition Options
 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
 * Options are restricted to `location`, `inherit`, and `reload`.
 * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
 *
 * #### Example:
 * ```html
 * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
 * ```
 *
 * ### Other DOM Events
 *
 * You can also customize which DOM events to respond to (instead of `click`) by
 * providing an `events` array in the `ui-state-opts` attribute.
 *
 * #### Example:
 * ```html
 * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
 * ```
 *
 * ### Highlighting the active link
 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
 *
 * ### Notes
 *
 * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
 *   However, it might be simpler to use [[uiSref]] parameter-only links.
 *
 * #### Example:
 * Sets the `lang` parameter to `en` and remains on the same state.
 *
 * ```html
 * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
 * ```
 *
 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
 * ```
 */
var uiState;
uiState = ['$uiRouter', '$timeout',
    function $StateRefDynamicDirective($uiRouter, $timeout) {
        var $state = $uiRouter.stateService;
        return {
            restrict: 'A',
            require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
            link: function (scope, element, attrs, uiSrefActive) {
                var type = getTypeInfo(element);
                var active = uiSrefActive[1] || uiSrefActive[0];
                var unlinkInfoFn = null;
                var hookFn;
                var rawDef = {};
                var getDef = function () { return processedDef($state, element, rawDef); };
                var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
                var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return (acc[attr] = core_1.noop, acc); }, {});
                function update() {
                    var def = getDef();
                    if (unlinkInfoFn)
                        unlinkInfoFn();
                    if (active)
                        unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                    if (def.href != null)
                        attrs.$set(type.attr, def.href);
                }
                inputAttrs.forEach(function (field) {
                    rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
                    attrs.$observe(field, function (expr) {
                        watchDeregFns[field]();
                        watchDeregFns[field] = scope.$watch(expr, function (newval) {
                            rawDef[field] = newval;
                            update();
                        }, true);
                    });
                });
                update();
                scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
                scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
                if (!type.clickable)
                    return;
                hookFn = clickHook(element, $state, $timeout, type, getDef);
                bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
            }
        };
    }];
/**
 * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
 *
 * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
 * related directive's state is active (and remove them when it is inactive).
 *
 * The primary use-case is to highlight the active link in navigation menus,
 * distinguishing it from the inactive menu items.
 *
 * ### Linking to a `ui-sref` or `ui-state`
 * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
 * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
 *
 * ### Matching
 *
 * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
 * This is a "fuzzy match" which uses [[StateService.includes]].
 *
 * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
 * This is an "exact match" which uses [[StateService.is]].
 *
 * ### Parameter values
 * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
 * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
 *
 * #### Example:
 * ```html
 * <li ng-repeat="user in users" ui-sref-active="active">
 *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
 * </li>
 * ```
 *
 * ### Examples
 *
 * Given the following template:
 * #### Example:
 * ```html
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * ```
 *
 * When the app state is `app.user` (or any child state),
 * and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 *
 * ```html
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * ```
 *
 * ### Glob mode
 *
 * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
 * The objects keys represent active class names and values represent the respective state names/globs.
 * `ui-sref-active` will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * #### Example:
 * Given the following template, with "admin" being an abstract state:
 * ```html
 * <div ui-sref-active="{'active': 'admin.**'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * ```
 *
 * When the current state is "admin.roles" the "active" class will be applied to both the <div> and <a> elements.
 * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
 *
 * ### Notes:
 *
 * - The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
 */
var uiSrefActive;
uiSrefActive = ['$state', '$stateParams', '$interpolate', '$uiRouter',
    function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
        return {
            restrict: "A",
            controller: ['$scope', '$element', '$attrs',
                function ($scope, $element, $attrs) {
                    var states = [], activeEqClass, uiSrefActive;
                    // There probably isn't much point in $observing this
                    // uiSrefActive and uiSrefActiveEq share the same directive object with some
                    // slight difference in logic routing
                    activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
                    try {
                        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
                    }
                    catch (e) {
                        // Do nothing. uiSrefActive is not a valid expression.
                        // Fall back to using $interpolate below
                    }
                    uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
                    if (core_1.isObject(uiSrefActive)) {
                        core_1.forEach(uiSrefActive, function (stateOrName, activeClass) {
                            if (core_1.isString(stateOrName)) {
                                var ref = parseStateRef(stateOrName);
                                addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
                            }
                        });
                    }
                    // Allow uiSref to communicate with uiSrefActive[Equals]
                    this.$$addStateInfo = function (newState, newParams) {
                        // we already got an explicit state provided by ui-sref-active, so we
                        // shadow the one that comes from ui-sref
                        if (core_1.isObject(uiSrefActive) && states.length > 0) {
                            return;
                        }
                        var deregister = addState(newState, newParams, uiSrefActive);
                        update();
                        return deregister;
                    };
                    function updateAfterTransition(trans) {
                        trans.promise.then(update);
                    }
                    $scope.$on('$stateChangeSuccess', update);
                    $scope.$on('$destroy', $uiRouter.transitionService.onStart({}, updateAfterTransition));
                    if ($uiRouter.globals.transition) {
                        updateAfterTransition($uiRouter.globals.transition);
                    }
                    function addState(stateName, stateParams, activeClass) {
                        var state = $state.get(stateName, stateContext($element));
                        var stateInfo = {
                            state: state || { name: stateName },
                            params: stateParams,
                            activeClass: activeClass
                        };
                        states.push(stateInfo);
                        return function removeState() {
                            core_1.removeFrom(states)(stateInfo);
                        };
                    }
                    // Update route state
                    function update() {
                        var splitClasses = function (str) {
                            return str.split(/\s/).filter(core_1.identity);
                        };
                        var getClasses = function (stateList) {
                            return stateList.map(function (x) { return x.activeClass; }).map(splitClasses).reduce(core_1.unnestR, []);
                        };
                        var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(core_1.uniqR, []);
                        var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
                        var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
                        var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
                        var addClasses = fuzzyClasses.concat(exactClasses).reduce(core_1.uniqR, []);
                        var removeClasses = allClasses.filter(function (cls) { return !core_1.inArray(addClasses, cls); });
                        $scope.$evalAsync(function () {
                            addClasses.forEach(function (className) { return $element.addClass(className); });
                            removeClasses.forEach(function (className) { return $element.removeClass(className); });
                        });
                    }
                    update();
                }]
        };
    }];
angular_1.ng.module('ui.router.state')
    .directive('uiSref', uiSref)
    .directive('uiSrefActive', uiSrefActive)
    .directive('uiSrefActiveEq', uiSrefActive)
    .directive('uiState', uiState);
//# sourceMappingURL=stateDirectives.js.map

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ng1api
 * @module directives
 */ /** for typedoc */
var angular_1 = __webpack_require__(111);
var angular_2 = __webpack_require__(12);
var core_1 = __webpack_require__(52);
var views_1 = __webpack_require__(188);
var services_1 = __webpack_require__(187);
exports.uiView = ['$view', '$animate', '$uiViewScroll', '$interpolate', '$q',
    function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
        function getRenderer(attrs, scope) {
            return {
                enter: function (element, target, cb) {
                    if (angular_1.ng.version.minor > 2) {
                        $animate.enter(element, null, target).then(cb);
                    }
                    else {
                        $animate.enter(element, null, target, cb);
                    }
                },
                leave: function (element, cb) {
                    if (angular_1.ng.version.minor > 2) {
                        $animate.leave(element).then(cb);
                    }
                    else {
                        $animate.leave(element, cb);
                    }
                }
            };
        }
        function configsEqual(config1, config2) {
            return config1 === config2;
        }
        var rootData = {
            $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
            $uiView: {}
        };
        var directive = {
            count: 0,
            restrict: 'ECA',
            terminal: true,
            priority: 400,
            transclude: 'element',
            compile: function (tElement, tAttrs, $transclude) {
                return function (scope, $element, attrs) {
                    var previousEl, currentEl, currentScope, unregister, onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(attrs, scope), viewConfig = undefined, inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
                    var activeUIView = {
                        $type: 'ng1',
                        id: directive.count++,
                        name: name,
                        fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + "." + name : name,
                        config: null,
                        configUpdated: configUpdatedCallback,
                        get creationContext() {
                            var fromParentTagConfig = core_1.parse('$cfg.viewDecl.$context')(inherited);
                            // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
                            // See https://github.com/angular-ui/ui-router/issues/3355
                            var fromParentTag = core_1.parse('$uiView.creationContext')(inherited);
                            return fromParentTagConfig || fromParentTag;
                        }
                    };
                    core_1.trace.traceUIViewEvent("Linking", activeUIView);
                    function configUpdatedCallback(config) {
                        if (config && !(config instanceof views_1.Ng1ViewConfig))
                            return;
                        if (configsEqual(viewConfig, config))
                            return;
                        core_1.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
                        viewConfig = config;
                        updateView(config);
                    }
                    $element.data('$uiView', { $uiView: activeUIView });
                    updateView();
                    unregister = $view.registerUIView(activeUIView);
                    scope.$on("$destroy", function () {
                        core_1.trace.traceUIViewEvent("Destroying/Unregistering", activeUIView);
                        unregister();
                    });
                    function cleanupLastView() {
                        if (previousEl) {
                            core_1.trace.traceUIViewEvent("Removing (previous) el", previousEl.data('$uiView'));
                            previousEl.remove();
                            previousEl = null;
                        }
                        if (currentScope) {
                            core_1.trace.traceUIViewEvent("Destroying scope", activeUIView);
                            currentScope.$destroy();
                            currentScope = null;
                        }
                        if (currentEl) {
                            var _viewData_1 = currentEl.data('$uiViewAnim');
                            core_1.trace.traceUIViewEvent("Animate out", _viewData_1);
                            renderer.leave(currentEl, function () {
                                _viewData_1.$$animLeave.resolve();
                                previousEl = null;
                            });
                            previousEl = currentEl;
                            currentEl = null;
                        }
                    }
                    function updateView(config) {
                        var newScope = scope.$new();
                        var animEnter = $q.defer(), animLeave = $q.defer();
                        var $uiViewData = {
                            $cfg: config,
                            $uiView: activeUIView,
                        };
                        var $uiViewAnim = {
                            $animEnter: animEnter.promise,
                            $animLeave: animLeave.promise,
                            $$animLeave: animLeave
                        };
                        /**
                         * @ngdoc event
                         * @name ui.router.state.directive:ui-view#$viewContentLoading
                         * @eventOf ui.router.state.directive:ui-view
                         * @eventType emits on ui-view directive scope
                         * @description
                         *
                         * Fired once the view **begins loading**, *before* the DOM is rendered.
                         *
                         * @param {Object} event Event object.
                         * @param {string} viewName Name of the view.
                         */
                        newScope.$emit('$viewContentLoading', name);
                        var cloned = $transclude(newScope, function (clone) {
                            clone.data('$uiViewAnim', $uiViewAnim);
                            clone.data('$uiView', $uiViewData);
                            renderer.enter(clone, $element, function onUIViewEnter() {
                                animEnter.resolve();
                                if (currentScope)
                                    currentScope.$emit('$viewContentAnimationEnded');
                                if (core_1.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                                    $uiViewScroll(clone);
                                }
                            });
                            cleanupLastView();
                        });
                        currentEl = cloned;
                        currentScope = newScope;
                        /**
                         * @ngdoc event
                         * @name ui.router.state.directive:ui-view#$viewContentLoaded
                         * @eventOf ui.router.state.directive:ui-view
                         * @eventType emits on ui-view directive scope
                         * @description           *
                         * Fired once the view is **loaded**, *after* the DOM is rendered.
                         *
                         * @param {Object} event Event object.
                         */
                        currentScope.$emit('$viewContentLoaded', config || viewConfig);
                        currentScope.$eval(onloadExp);
                    }
                };
            }
        };
        return directive;
    }];
$ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q', '$timeout'];
/** @hidden */
function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q, $timeout) {
    var getControllerAs = core_1.parse('viewDecl.controllerAs');
    var getResolveAs = core_1.parse('viewDecl.resolveAs');
    return {
        restrict: 'ECA',
        priority: -400,
        compile: function (tElement) {
            var initial = tElement.html();
            tElement.empty();
            return function (scope, $element) {
                var data = $element.data('$uiView');
                if (!data) {
                    $element.html(initial);
                    $compile($element.contents())(scope);
                    return;
                }
                var cfg = data.$cfg || { viewDecl: {}, getTemplate: angular_2.noop };
                var resolveCtx = cfg.path && new core_1.ResolveContext(cfg.path);
                $element.html(cfg.getTemplate($element, resolveCtx) || initial);
                core_1.trace.traceUIViewFill(data.$uiView, $element.html());
                var link = $compile($element.contents());
                var controller = cfg.controller;
                var controllerAs = getControllerAs(cfg);
                var resolveAs = getResolveAs(cfg);
                var locals = resolveCtx && services_1.getLocals(resolveCtx);
                scope[resolveAs] = locals;
                if (controller) {
                    var controllerInstance = $controller(controller, core_1.extend({}, locals, { $scope: scope, $element: $element }));
                    if (controllerAs) {
                        scope[controllerAs] = controllerInstance;
                        scope[controllerAs][resolveAs] = locals;
                    }
                    // TODO: Use $view service as a central point for registering component-level hooks
                    // Then, when a component is created, tell the $view service, so it can invoke hooks
                    // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
                    // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
                    $element.data('$ngControllerController', controllerInstance);
                    $element.children().data('$ngControllerController', controllerInstance);
                    registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
                }
                // Wait for the component to appear in the DOM
                if (core_1.isString(cfg.viewDecl.component)) {
                    var cmp_1 = cfg.viewDecl.component;
                    var kebobName = core_1.kebobString(cmp_1);
                    var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", "i");
                    var getComponentController = function () {
                        var directiveEl = [].slice.call($element[0].children)
                            .filter(function (el) { return el && el.tagName && tagRegexp_1.exec(el.tagName); });
                        return directiveEl && angular_1.ng.element(directiveEl).data("$" + cmp_1 + "Controller");
                    };
                    var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
                        if (!ctrlInstance)
                            return;
                        registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
                        deregisterWatch_1();
                    });
                }
                link(scope);
            };
        }
    };
}
/** @hidden */
var hasComponentImpl = typeof angular_1.ng.module('ui.router')['component'] === 'function';
/** @hidden incrementing id */
var _uiCanExitId = 0;
/** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
    // Call $onInit() ASAP
    if (core_1.isFunction(controllerInstance.$onInit) && !(cfg.viewDecl.component && hasComponentImpl)) {
        controllerInstance.$onInit();
    }
    var viewState = core_1.tail(cfg.path).state.self;
    var hookOptions = { bind: controllerInstance };
    // Add component-level hook for onParamsChange
    if (core_1.isFunction(controllerInstance.uiOnParamsChanged)) {
        var resolveContext = new core_1.ResolveContext(cfg.path);
        var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
        // Fire callback on any successful transition
        var paramsUpdated = function ($transition$) {
            // Exit early if the $transition$ is the same as the view was created within.
            // Exit early if the $transition$ will exit the state the view is for.
            if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
                return;
            var toParams = $transition$.params("to");
            var fromParams = $transition$.params("from");
            var toSchema = $transition$.treeChanges().to.map(function (node) { return node.paramSchema; }).reduce(core_1.unnestR, []);
            var fromSchema = $transition$.treeChanges().from.map(function (node) { return node.paramSchema; }).reduce(core_1.unnestR, []);
            // Find the to params that have different values than the from params
            var changedToParams = toSchema.filter(function (param) {
                var idx = fromSchema.indexOf(param);
                return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
            });
            // Only trigger callback if a to param has changed or is new
            if (changedToParams.length) {
                var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
                // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
                var newValues = core_1.filter(toParams, function (val, key) { return changedKeys_1.indexOf(key) !== -1; });
                controllerInstance.uiOnParamsChanged(newValues, $transition$);
            }
        };
        $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
    }
    // Add component-level hook for uiCanExit
    if (core_1.isFunction(controllerInstance.uiCanExit)) {
        var id_1 = _uiCanExitId++;
        var cacheProp_1 = '_uiCanExitIds';
        // Returns true if a redirect transition already answered truthy
        var prevTruthyAnswer_1 = function (trans) {
            return !!trans && (trans[cacheProp_1] && trans[cacheProp_1][id_1] === true || prevTruthyAnswer_1(trans.redirectedFrom()));
        };
        // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
        var wrappedHook = function (trans) {
            var promise, ids = trans[cacheProp_1] = trans[cacheProp_1] || {};
            if (!prevTruthyAnswer_1(trans)) {
                promise = $q.when(controllerInstance.uiCanExit(trans));
                promise.then(function (val) { return ids[id_1] = (val !== false); });
            }
            return promise;
        };
        var criteria = { exiting: viewState.name };
        $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
    }
}
angular_1.ng.module('ui.router.state').directive('uiView', exports.uiView);
angular_1.ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
//# sourceMappingURL=viewDirective.js.map

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * # Angular 1 injectable services
 *
 * This is a list of the objects which can be injected using angular's injector.
 *
 * There are three different kind of injectable objects:
 *
 * ## **Provider** objects
 * #### injectable into a `.config()` block during configtime
 *
 * - [[$uiRouterProvider]]: The UI-Router instance
 * - [[$stateProvider]]: State registration
 * - [[$transitionsProvider]]: Transition hooks
 * - [[$urlServiceProvider]]: All URL related public APIs
 *
 * - [[$uiViewScrollProvider]]: Disable ui-router view scrolling
 * - [[$urlRouterProvider]]: (deprecated) Url matching rules
 * - [[$urlMatcherFactoryProvider]]: (deprecated) Url parsing config
 *
 * ## **Service** objects
 * #### injectable globally during runtime
 *
 * - [[$uiRouter]]: The UI-Router instance
 * - [[$trace]]: Enable transition trace/debug
 * - [[$transitions]]: Transition hooks
 * - [[$state]]: Imperative state related APIs
 * - [[$stateRegistry]]: State registration
 * - [[$urlService]]: All URL related public APIs
 * - [[$uiRouterGlobals]]: Global variables
 * - [[$uiViewScroll]]: Scroll an element into view
 *
 * - [[$stateParams]]: (deprecated) Global state param values
 * - [[$urlRouter]]: (deprecated) URL synchronization
 * - [[$urlMatcherFactory]]: (deprecated) URL parsing config
 *
 * ## **Per-Transition** objects
 *
 * - These kind of objects are injectable into:
 *   - Resolves ([[Ng1StateDeclaration.resolve]]),
 *   - Transition Hooks ([[TransitionService.onStart]], etc),
 *   - Routed Controllers ([[Ng1ViewDeclaration.controller]])
 *
 * #### Different instances are injected based on the [[Transition]]
 *
 * - [[$transition$]]: The current Transition object
 * - [[$stateParams]]: State param values for pending Transition (deprecated)
 * - Any resolve data defined using [[Ng1StateDeclaration.resolve]]
 *
 * @ng1api
 * @preferred
 * @module injectables
 */ /** */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The current (or pending) State Parameters
 *
 * An injectable global **Service Object** which holds the state parameters for the latest **SUCCESSFUL** transition.
 *
 * The values are not updated until *after* a `Transition` successfully completes.
 *
 * **Also:** an injectable **Per-Transition Object** object which holds the pending state parameters for the pending `Transition` currently running.
 *
 * ### Deprecation warning:
 *
 * The value injected for `$stateParams` is different depending on where it is injected.
 *
 * - When injected into an angular service, the object injected is the global **Service Object** with the parameter values for the latest successful `Transition`.
 * - When injected into transition hooks, resolves, or view controllers, the object is the **Per-Transition Object** with the parameter values for the running `Transition`.
 *
 * Because of these confusing details, this service is deprecated.
 *
 * ### Instead of using the global `$stateParams` service object,
 * inject [[$uiRouterGlobals]] and use [[UIRouterGlobals.params]]
 *
 * ```js
 * MyService.$inject = ['$uiRouterGlobals'];
 * function MyService($uiRouterGlobals) {
 *   return {
 *     paramValues: function () {
 *       return $uiRouterGlobals.params;
 *     }
 *   }
 * }
 * ```
 *
 * ### Instead of using the per-transition `$stateParams` object,
 * inject the current `Transition` (as [[$transition$]]) and use [[Transition.params]]
 *
 * ```js
 * MyController.$inject = ['$transition$'];
 * function MyController($transition$) {
 *   var username = $transition$.params().username;
 *   // .. do something with username
 * }
 * ```
 *
 * ---
 *
 * This object can be injected into other services.
 *
 * #### Deprecated Example:
 * ```js
 * SomeService.$inject = ['$http', '$stateParams'];
 * function SomeService($http, $stateParams) {
 *   return {
 *     getUser: function() {
 *       return $http.get('/api/users/' + $stateParams.username);
 *     }
 *   }
 * };
 * angular.service('SomeService', SomeService);
 * ```
 * @deprecated
 */
var $stateParams;
/**
 * Global UI-Router variables
 *
 * The router global state as a **Service Object** (injectable during runtime).
 *
 * This object contains globals such as the current state and current parameter values.
 */
var $uiRouterGlobals;
/**
 * The UI-Router instance
 *
 * The [[UIRouter]] singleton (the router instance) as a **Service Object** (injectable during runtime).
 *
 * This object is the UI-Router singleton instance, created by angular dependency injection during application bootstrap.
 * It has references to the other UI-Router services
 *
 * #### Note: This object is also exposed as [[$uiRouterProvider]] for injection during angular config time.
 */
var $uiRouter;
/**
 * The UI-Router instance
 *
 * The [[UIRouter]] singleton (the router instance) as a **Provider Object** (injectable during config phase).
 *
 * This object is the UI-Router singleton instance, created by angular dependency injection during application bootstrap.
 * It has references to the other UI-Router services
 *
 * #### Note: This object is also exposed as [[$uiRouter]] for injection during runtime.
 */
var $uiRouterProvider;
/**
 * Transition debug/tracing
 *
 * The [[Trace]] singleton as a **Service Object** (injectable during runtime).
 *
 * Enables or disables Transition tracing which can help to debug issues.
 */
var $trace;
/**
 * The Transition Service
 *
 * The [[TransitionService]] singleton as a **Service Object** (injectable during runtime).
 *
 * This angular service exposes the [[TransitionService]] singleton, which is primarily
 * used to register global transition hooks.
 *
 * #### Note: This object is also exposed as [[$transitionsProvider]] for injection during the config phase.
 */
var $transitions;
/**
 * The Transition Service
 *
 * The [[TransitionService]] singleton as a **Provider Object** (injectable during config phase)
 *
 * This angular service exposes the [[TransitionService]] singleton, which is primarily
 * used to register global transition hooks.
 *
 * #### Note: This object is also exposed as [[$transitions]] for injection during runtime.
 */
var $transitionsProvider;
/**
 * The current [[Transition]] object
 *
 * The current [[Transition]] object as a **Per-Transition Object** (injectable into Resolve, Hooks, Controllers)
 *
 * This object returns information about the current transition, including:
 *
 * - To/from states
 * - To/from parameters
 * - Transition options
 * - States being entered, exited, and retained
 * - Resolve data
 * - A Promise for the transition
 * - Any transition failure information
 * - An injector for both Service and Per-Transition Objects
 */
var $transition$;
/**
 * The State Service
 *
 * The [[StateService]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service used to manage and query information on registered states.
 * It exposes state related APIs including:
 *
 * - Start a [[Transition]]
 * - Imperatively lazy load states
 * - Check if a state is currently active
 * - Look up states by name
 * - Build URLs for a state+parameters
 * - Configure the global Transition error handler
 *
 * This angular service exposes the [[StateService]] singleton.
 */
var $state;
/**
 * The State Registry
 *
 * The [[StateRegistry]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service is used to register/deregister states.
 * It has state registration related APIs including:
 *
 * - Register/deregister states
 * - Listen for state registration/deregistration
 * - Get states by name
 * - Add state decorators (to customize the state creation process)
 *
 * #### Note: This object is also exposed as [[$stateRegistryProvider]] for injection during the config phase.
 */
var $stateRegistry;
/**
 * The State Registry
 *
 * The [[StateRegistry]] singleton as a **Provider Object** (injectable during config time).
 *
 * This service is used to register/deregister states.
 * It has state registration related APIs including:
 *
 * - Register/deregister states
 * - Listen for state registration/deregistration
 * - Get states by name
 * - Add state decorators (to customize the state creation process)
 *
 * #### Note: This object is also exposed as [[$stateRegistry]] for injection during runtime.
 */
var $stateRegistryProvider;
/**
 * The View Scroll provider
 *
 * The [[UIViewScrollProvider]] as a **Provider Object** (injectable during config time).
 *
 * This angular service exposes the [[UIViewScrollProvider]] singleton and is
 * used to disable UI-Router's scroll behavior.
 */
var $uiViewScrollProvider;
/**
 * The View Scroll function
 *
 * The View Scroll function as a **Service Object** (injectable during runtime).
 *
 * This is a function that scrolls an element into view.
 * The element is scrolled after a `$timeout` so the DOM has time to refresh.
 *
 * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
 * this can be enabled by calling [[UIViewScrollProvider.useAnchorScroll]].
 *
 * Note: this function is used by the [[directives.uiView]] when the `autoscroll` expression evaluates to true.
 */
var $uiViewScroll;
/**
 * The StateProvider
 *
 * An angular1-only [[StateProvider]] as a **Provider Object** (injectable during config time).
 *
 * This angular service exposes the [[StateProvider]] singleton.
 *
 * The `StateProvider` is primarily used to register states or add custom state decorators.
 *
 * ##### Note: This provider is a ng1 vestige.
 * It is a passthrough to [[$stateRegistry]] and [[$state]].
 */
var $stateProvider;
/**
 * The URL Service Provider
 *
 * The [[UrlService]] singleton as a **Provider Object** (injectable during the angular config phase).
 *
 * A service used to configure and interact with the URL.
 * It has URL related APIs including:
 *
 * - register custom Parameter types `UrlService.config.type` ([[UrlConfigApi.type]])
 * - add URL rules: `UrlService.rules.when` ([[UrlRulesApi.when]])
 * - configure behavior when no url matches: `UrlService.rules.otherwise` ([[UrlRulesApi.otherwise]])
 * - delay initial URL synchronization [[UrlService.deferIntercept]].
 * - get or set the current url: [[UrlService.url]]
 *
 * ##### Note: This service can also be injected during runtime as [[$urlService]].
 */
var $urlServiceProvider;
/**
 * The URL Service
 *
 * The [[UrlService]] singleton as a **Service Object** (injectable during runtime).
 *
 * Note: This service can also be injected during the config phase as [[$urlServiceProvider]].
 *
 * Used to configure the URL.
 * It has URL related APIs including:
 *
 * - register custom Parameter types `UrlService.config.type` ([[UrlConfigApi.type]])
 * - add URL rules: `UrlService.rules.when` ([[UrlRulesApi.when]])
 * - configure behavior when no url matches: `UrlService.rules.otherwise` ([[UrlRulesApi.otherwise]])
 * - delay initial URL synchronization [[UrlService.deferIntercept]].
 * - get or set the current url: [[UrlService.url]]
 *
 * ##### Note: This service can also be injected during the config phase as [[$urlServiceProvider]].
 */
var $urlService;
/**
 * The URL Router Provider
 *
 * ### Deprecation warning: This object is now considered internal. Use [[$urlServiceProvider]] instead.
 *
 * The [[UrlRouter]] singleton as a **Provider Object** (injectable during config time).
 *
 * #### Note: This object is also exposed as [[$urlRouter]] for injection during runtime.
 *
 * @deprecated
 */
var $urlRouterProvider;
/**
 * The Url Router
 *
 * ### Deprecation warning: This object is now considered internal. Use [[$urlService]] instead.
 *
 * The [[UrlRouter]] singleton as a **Service Object** (injectable during runtime).
 *
 * #### Note: This object is also exposed as [[$urlRouterProvider]] for injection during angular config time.
 *
 * @deprecated
 */
var $urlRouter;
/**
 * The URL Matcher Factory
 *
 * ### Deprecation warning: This object is now considered internal. Use [[$urlService]] instead.
 *
 * The [[UrlMatcherFactory]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service is used to set url mapping options, define custom parameter types, and create [[UrlMatcher]] objects.
 *
 * #### Note: This object is also exposed as [[$urlMatcherFactoryProvider]] for injection during angular config time.
 *
 * @deprecated
 */
var $urlMatcherFactory;
/**
 * The URL Matcher Factory
 *
 * ### Deprecation warning: This object is now considered internal. Use [[$urlService]] instead.
 *
 * The [[UrlMatcherFactory]] singleton as a **Provider Object** (injectable during config time).
 *
 * This service is used to set url mapping options, define custom parameter types, and create [[UrlMatcher]] objects.
 *
 * #### Note: This object is also exposed as [[$urlMatcherFactory]] for injection during runtime.
 *
 * @deprecated
 */
var $urlMatcherFactoryProvider;
//# sourceMappingURL=injectables.js.map

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(52);
/**
 * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
 */
var Ng1LocationServices = (function () {
    function Ng1LocationServices($locationProvider) {
        // .onChange() registry
        this._urlListeners = [];
        this.$locationProvider = $locationProvider;
        var _lp = core_1.val($locationProvider);
        core_1.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
    }
    Ng1LocationServices.prototype.dispose = function () { };
    Ng1LocationServices.prototype.onChange = function (callback) {
        var _this = this;
        this._urlListeners.push(callback);
        return function () { return core_1.removeFrom(_this._urlListeners)(callback); };
    };
    Ng1LocationServices.prototype.html5Mode = function () {
        var html5Mode = this.$locationProvider.html5Mode();
        html5Mode = core_1.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
        return html5Mode && this.$sniffer.history;
    };
    Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
        if (replace === void 0) { replace = false; }
        if (newUrl)
            this.$location.url(newUrl);
        if (replace)
            this.$location.replace();
        if (state)
            this.$location.state(state);
        return this.$location.url();
    };
    Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser) {
        var _this = this;
        this.$location = $location;
        this.$sniffer = $sniffer;
        // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
        $rootScope.$on("$locationChangeSuccess", function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
        var _loc = core_1.val($location);
        var _browser = core_1.val($browser);
        // Bind these LocationService functions to $location
        core_1.createProxyFunctions(_loc, this, _loc, ["replace", "path", "search", "hash"]);
        // Bind these LocationConfig functions to $location
        core_1.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
        // Bind these LocationConfig functions to $browser
        core_1.createProxyFunctions(_browser, this, _browser, ['baseHref']);
    };
    /**
     * Applys ng1-specific path parameter encoding
     *
     * The Angular 1 `$location` service is a bit weird.
     * It doesn't allow slashes to be encoded/decoded bi-directionally.
     *
     * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
     *
     * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
     *
     * @param router
     */
    Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
        var pathType = router.urlMatcherFactory.type('path');
        pathType.encode = function (val) {
            return val != null ? val.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : val;
        };
        pathType.decode = function (val) {
            return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : val;
        };
    };
    return Ng1LocationServices;
}());
exports.Ng1LocationServices = Ng1LocationServices;
//# sourceMappingURL=locationServices.js.map

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module ng1 */ /** for typedoc */
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __webpack_require__(111);
/**
 * `isState` Filter: truthy if the current state is the parameter
 *
 * Translates to [[StateService.is]] `$state.is("stateName")`.
 *
 * #### Example:
 * ```html
 * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
 * ```
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
    var isFilter = function (state, params, options) {
        return $state.is(state, params, options);
    };
    isFilter.$stateful = true;
    return isFilter;
}
exports.$IsStateFilter = $IsStateFilter;
/**
 * `includedByState` Filter: truthy if the current state includes the parameter
 *
 * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
 *
 * #### Example:
 * ```html
 * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
 * ```
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
    var includesFilter = function (state, params, options) {
        return $state.includes(state, params, options);
    };
    includesFilter.$stateful = true;
    return includesFilter;
}
exports.$IncludedByStateFilter = $IncludedByStateFilter;
angular_1.ng.module('ui.router.state')
    .filter('isState', $IsStateFilter)
    .filter('includedByState', $IncludedByStateFilter);
//# sourceMappingURL=stateFilters.js.map

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module ng1 */ /** */
var core_1 = __webpack_require__(52);
var services_1 = __webpack_require__(187);
/**
 * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
 * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
 *
 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
 * ensures that those hooks are injectable for @uirouter/angularjs (ng1).
 */
exports.getStateHookBuilder = function (hookName) {
    return function stateHookBuilder(state, parentFn) {
        var hook = state[hookName];
        var pathname = hookName === 'onExit' ? 'from' : 'to';
        function decoratedNg1Hook(trans, state) {
            var resolveContext = new core_1.ResolveContext(trans.treeChanges(pathname));
            var locals = core_1.extend(services_1.getLocals(resolveContext), { $state$: state, $transition$: trans });
            return core_1.services.$injector.invoke(hook, this, locals);
        }
        return hook ? decoratedNg1Hook : undefined;
    };
};
//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module view */
/** for typedoc */
var angular_1 = __webpack_require__(111);
var core_1 = __webpack_require__(52);
/**
 * Service which manages loading of templates from a ViewConfig.
 */
var TemplateFactory = (function () {
    function TemplateFactory() {
        var _this = this;
        /** @hidden */ this._useHttp = angular_1.ng.version.minor < 3;
        /** @hidden */ this.$get = ['$http', '$templateCache', '$injector', function ($http, $templateCache, $injector) {
                _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
                _this.$http = $http;
                _this.$templateCache = $templateCache;
                return _this;
            }];
    }
    /** @hidden */
    TemplateFactory.prototype.useHttpService = function (value) {
        this._useHttp = value;
    };
    ;
    /**
     * Creates a template from a configuration object.
     *
     * @param config Configuration object for which to load a template.
     * The following properties are search in the specified order, and the first one
     * that is defined is used to create the template:
     *
     * @param params  Parameters to pass to the template function.
     * @param context The resolve context associated with the template's view
     *
     * @return {string|object}  The template html as a string, or a promise for
     * that string,or `null` if no template is configured.
     */
    TemplateFactory.prototype.fromConfig = function (config, params, context) {
        var defaultTemplate = "<ui-view></ui-view>";
        var asTemplate = function (result) { return core_1.services.$q.when(result).then(function (str) { return ({ template: str }); }); };
        var asComponent = function (result) { return core_1.services.$q.when(result).then(function (str) { return ({ component: str }); }); };
        return (core_1.isDefined(config.template) ? asTemplate(this.fromString(config.template, params)) :
            core_1.isDefined(config.templateUrl) ? asTemplate(this.fromUrl(config.templateUrl, params)) :
                core_1.isDefined(config.templateProvider) ? asTemplate(this.fromProvider(config.templateProvider, params, context)) :
                    core_1.isDefined(config.component) ? asComponent(config.component) :
                        core_1.isDefined(config.componentProvider) ? asComponent(this.fromComponentProvider(config.componentProvider, params, context)) :
                            asTemplate(defaultTemplate));
    };
    ;
    /**
     * Creates a template from a string or a function returning a string.
     *
     * @param template html template as a string or function that returns an html template as a string.
     * @param params Parameters to pass to the template function.
     *
     * @return {string|object} The template html as a string, or a promise for that
     * string.
     */
    TemplateFactory.prototype.fromString = function (template, params) {
        return core_1.isFunction(template) ? template(params) : template;
    };
    ;
    /**
     * Loads a template from the a URL via `$http` and `$templateCache`.
     *
     * @param {string|Function} url url of the template to load, or a function
     * that returns a url.
     * @param {Object} params Parameters to pass to the url function.
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */
    TemplateFactory.prototype.fromUrl = function (url, params) {
        if (core_1.isFunction(url))
            url = url(params);
        if (url == null)
            return null;
        if (this._useHttp) {
            return this.$http.get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
                .then(function (response) {
                return response.data;
            });
        }
        return this.$templateRequest(url);
    };
    ;
    /**
     * Creates a template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */
    TemplateFactory.prototype.fromProvider = function (provider, params, context) {
        var deps = core_1.services.$injector.annotate(provider);
        var providerFn = core_1.isArray(provider) ? core_1.tail(provider) : provider;
        var resolvable = new core_1.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    ;
    /**
     * Creates a component's template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */
    TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
        var deps = core_1.services.$injector.annotate(provider);
        var providerFn = core_1.isArray(provider) ? core_1.tail(provider) : provider;
        var resolvable = new core_1.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    ;
    /**
     * Creates a template from a component's name
     *
     * This implements route-to-component.
     * It works by retrieving the component (directive) metadata from the injector.
     * It analyses the component's bindings, then constructs a template that instantiates the component.
     * The template wires input and output bindings to resolves or from the parent component.
     *
     * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
     * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
     * @param component {string} Component's name in camel case.
     * @param bindings An object defining the component's bindings: {foo: '<'}
     * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */
    TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
        bindings = bindings || {};
        // Bind once prefix
        var prefix = angular_1.ng.version.minor >= 3 ? "::" : "";
        // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
        var kebob = function (camelCase) {
            var kebobed = core_1.kebobString(camelCase);
            return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
        };
        var attributeTpl = function (input) {
            var name = input.name, type = input.type;
            var attrName = kebob(name);
            // If the ui-view has an attribute which matches a binding on the routed component
            // then pass that attribute through to the routed component template.
            // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
            if (uiView.attr(attrName) && !bindings[name])
                return attrName + "='" + uiView.attr(attrName) + "'";
            var resolveName = bindings[name] || name;
            // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
            // some-attr="{{ ::$resolve.someResolveName }}"
            if (type === '@')
                return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
            // Wire "&" callbacks to resolves that return a callback function
            // Get the result of the resolve (should be a function) and annotate it to get its arguments.
            // some-attr="$resolve.someResolveResultName(foo, bar)"
            if (type === '&') {
                var res = context.getResolvable(resolveName);
                var fn = res && res.data;
                var args = fn && core_1.services.$injector.annotate(fn) || [];
                // account for array style injection, i.e., ['foo', function(foo) {}]
                var arrayIdxStr = core_1.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
                return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(",") + ")'";
            }
            // some-attr="::$resolve.someResolveName"
            return attrName + "='" + prefix + "$resolve." + resolveName + "'";
        };
        var attrs = getComponentBindings(component).map(attributeTpl).join(" ");
        var kebobName = kebob(component);
        return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
    };
    ;
    return TemplateFactory;
}());
exports.TemplateFactory = TemplateFactory;
// Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
function getComponentBindings(name) {
    var cmpDefs = core_1.services.$injector.get(name + "Directive"); // could be multiple
    if (!cmpDefs || !cmpDefs.length)
        throw new Error("Unable to find component named '" + name + "'");
    return cmpDefs.map(getBindings).reduce(core_1.unnestR, []);
}
// Given a directive definition, find its object input attributes
// Use different properties, depending on the type of directive (component, bindToController, normal)
var getBindings = function (def) {
    if (core_1.isObject(def.bindToController))
        return scopeBindings(def.bindToController);
    return scopeBindings(def.scope);
};
// for ng 1.2 style, process the scope: { input: "=foo" }
// for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
var scopeBindings = function (bindingsObj) { return Object.keys(bindingsObj || {})
    .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
    .filter(function (tuple) { return core_1.isDefined(tuple) && core_1.isArray(tuple[1]); })
    .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); }); };
//# sourceMappingURL=templateFactory.js.map

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** @module ng1 */ /** */
var angular_1 = __webpack_require__(111);
/** @hidden */
function $ViewScrollProvider() {
    var useAnchorScroll = false;
    this.useAnchorScroll = function () {
        useAnchorScroll = true;
    };
    this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
            if (useAnchorScroll) {
                return $anchorScroll;
            }
            return function ($element) {
                return $timeout(function () {
                    $element[0].scrollIntoView();
                }, 0, false);
            };
        }];
}
angular_1.ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
//# sourceMappingURL=viewScroll.js.map

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
 * @license AngularJS v1.7.3
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window) {'use strict';

/* exported
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth
*/

var minErrConfig = {
  objectMaxDepth: 5,
  urlErrorParamsEnabled: true
};

/**
 * @ngdoc function
 * @name angular.errorHandlingConfig
 * @module ng
 * @kind function
 *
 * @description
 * Configure several aspects of error handling in AngularJS if used as a setter or return the
 * current configuration if used as a getter. The following options are supported:
 *
 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
 *
 * Omitted or undefined options will leave the corresponding configuration values unchanged.
 *
 * @param {Object=} config - The configuration object. May only contain the options that need to be
 *     updated. Supported keys:
 *
 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
 *   non-positive or non-numeric value, removes the max depth limit.
 *   Default: 5
 *
 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies wether the generated error url will
 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
 *   generated error url is very long.
 *
 *   Default: true. When used without argument, it returns the current value.
 */
function errorHandlingConfig(config) {
  if (isObject(config)) {
    if (isDefined(config.objectMaxDepth)) {
      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
    }
    if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
      minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
    }
  } else {
    return minErrConfig;
  }
}

/**
 * @private
 * @param {Number} maxDepth
 * @return {boolean}
 */
function isValidObjectMaxDepth(maxDepth) {
  return isNumber(maxDepth) && maxDepth > 0;
}


/**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * AngularJS. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace') . Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */

function minErr(module, ErrorConstructor) {
  ErrorConstructor = ErrorConstructor || Error;

  var url = 'https://errors.angularjs.org/1.7.3/';
  var regex = url.replace('.', '\\.') + '[\\s\\S]*';
  var errRegExp = new RegExp(regex, 'g');

  return function() {
    var code = arguments[0],
      template = arguments[1],
      message = '[' + (module ? module + ':' : '') + code + '] ',
      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
        return toDebugString(arg, minErrConfig.objectMaxDepth);
      }),
      paramPrefix, i;

    // A minErr message has two parts: the message itself and the url that contains the
    // encoded message.
    // The message's parameters can contain other error messages which also include error urls.
    // To prevent the messages from getting too long, we strip the error urls from the parameters.

    message += template.replace(/\{\d+\}/g, function(match) {
      var index = +match.slice(1, -1);

      if (index < templateArgs.length) {
        return templateArgs[index].replace(errRegExp, '');
      }

      return match;
    });

    message += '\n' + url + (module ? module + '/' : '') + code;

    if (minErrConfig.urlErrorParamsEnabled) {
      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
      }
    }

    return new ErrorConstructor(message);
  };
}

/* We need to tell ESLint what variables are being exported */
/* exported
  angular,
  msie,
  jqLite,
  jQuery,
  slice,
  splice,
  push,
  toString,
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth,
  ngMinErr,
  angularModule,
  uid,
  REGEX_STRING_REGEXP,
  VALIDITY_STATE_PROPERTY,

  lowercase,
  uppercase,
  nodeName_,
  isArrayLike,
  forEach,
  forEachSorted,
  reverseParams,
  nextUid,
  setHashKey,
  extend,
  toInt,
  inherit,
  merge,
  noop,
  identity,
  valueFn,
  isUndefined,
  isDefined,
  isObject,
  isBlankObject,
  isString,
  isNumber,
  isNumberNaN,
  isDate,
  isError,
  isArray,
  isFunction,
  isRegExp,
  isWindow,
  isScope,
  isFile,
  isFormData,
  isBlob,
  isBoolean,
  isPromiseLike,
  trim,
  escapeForRegexp,
  isElement,
  makeMap,
  includes,
  arrayRemove,
  copy,
  simpleCompare,
  equals,
  csp,
  jq,
  concat,
  sliceArgs,
  bind,
  toJsonReplacer,
  toJson,
  fromJson,
  convertTimezoneToLocal,
  timezoneToOffset,
  addDateMinutes,
  startingTag,
  tryDecodeURIComponent,
  parseKeyValue,
  toKeyValue,
  encodeUriSegment,
  encodeUriQuery,
  angularInit,
  bootstrap,
  getTestability,
  snake_case,
  bindJQuery,
  assertArg,
  assertArgFn,
  assertNotHasOwnProperty,
  getter,
  getBlockNodes,
  hasOwnProperty,
  createMap,
  stringify,

  NODE_TYPE_ELEMENT,
  NODE_TYPE_ATTRIBUTE,
  NODE_TYPE_TEXT,
  NODE_TYPE_COMMENT,
  NODE_TYPE_DOCUMENT,
  NODE_TYPE_DOCUMENT_FRAGMENT
*/

////////////////////////////////////

/**
 * @ngdoc module
 * @name ng
 * @module ng
 * @installation
 * @description
 *
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 */

var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

// The name of a form control's ValidityState property.
// This is used so that it's possible for internal tests to create mock ValidityStates.
var VALIDITY_STATE_PROPERTY = 'validity';


var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * @private
 *
 * @description Converts the specified string to lowercase.
 * @param {string} string String to be converted to lowercase.
 * @returns {string} Lowercased string.
 */
var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};

/**
 * @private
 *
 * @description Converts the specified string to uppercase.
 * @param {string} string String to be converted to uppercase.
 * @returns {string} Uppercased string.
 */
var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};


var
    msie,             // holds major version number for IE, or NaN if UA is not IE.
    jqLite,           // delay binding since jQuery could be loaded after us.
    jQuery,           // delay binding
    slice             = [].slice,
    splice            = [].splice,
    push              = [].push,
    toString          = Object.prototype.toString,
    getPrototypeOf    = Object.getPrototypeOf,
    ngMinErr          = minErr('ng'),

    /** @name angular */
    angular           = window.angular || (window.angular = {}),
    angularModule,
    uid               = 0;

// Support: IE 9-11 only
/**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */
msie = window.document.documentMode;


/**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */
function isArrayLike(obj) {

  // `null`, `undefined` and `window` are not array-like
  if (obj == null || isWindow(obj)) return false;

  // arrays, strings and jQuery/jqLite objects are array like
  // * jqLite is either the jQuery or jqLite constructor function
  // * we have to check the existence of jqLite first as this method is called
  //   via the forEach method when constructing the jqLite object in the first place
  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;

  // Support: iOS 8.2 (not reproducible in simulator)
  // "length" in obj used to prevent JIT error (gh-11508)
  var length = 'length' in Object(obj) && obj.length;

  // NodeList objects (with `item` method) and
  // other objects with suitable length characteristics are array-like
  return isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');

}

/**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */

function forEach(obj, iterator, context) {
  var key, length;
  if (obj) {
    if (isFunction(obj)) {
      for (key in obj) {
        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (isArray(obj) || isArrayLike(obj)) {
      var isPrimitive = typeof obj !== 'object';
      for (key = 0, length = obj.length; key < length; key++) {
        if (isPrimitive || key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
    } else if (isBlankObject(obj)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in obj) {
        iterator.call(context, obj[key], key, obj);
      }
    } else if (typeof obj.hasOwnProperty === 'function') {
      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
      for (key in obj) {
        if (obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else {
      // Slow path for objects which do not have a method `hasOwnProperty`
      for (key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    }
  }
  return obj;
}

function forEachSorted(obj, iterator, context) {
  var keys = Object.keys(obj).sort();
  for (var i = 0; i < keys.length; i++) {
    iterator.call(context, obj[keys[i]], keys[i]);
  }
  return keys;
}


/**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */
function reverseParams(iteratorFn) {
  return function(value, key) {iteratorFn(key, value);};
}

/**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */
function nextUid() {
  return ++uid;
}


/**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */
function setHashKey(obj, h) {
  if (h) {
    obj.$$hashKey = h;
  } else {
    delete obj.$$hashKey;
  }
}


function baseExtend(dst, objs, deep) {
  var h = dst.$$hashKey;

  for (var i = 0, ii = objs.length; i < ii; ++i) {
    var obj = objs[i];
    if (!isObject(obj) && !isFunction(obj)) continue;
    var keys = Object.keys(obj);
    for (var j = 0, jj = keys.length; j < jj; j++) {
      var key = keys[j];
      var src = obj[key];

      if (deep && isObject(src)) {
        if (isDate(src)) {
          dst[key] = new Date(src.valueOf());
        } else if (isRegExp(src)) {
          dst[key] = new RegExp(src);
        } else if (src.nodeName) {
          dst[key] = src.cloneNode(true);
        } else if (isElement(src)) {
          dst[key] = src.clone();
        } else {
          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
          baseExtend(dst[key], [src], true);
        }
      } else {
        dst[key] = src;
      }
    }
  }

  setHashKey(dst, h);
  return dst;
}

/**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */
function extend(dst) {
  return baseExtend(dst, slice.call(arguments, 1), false);
}


/**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @deprecated
* sinceVersion="1.6.5"
* This function is deprecated, but will not be removed in the 1.x lifecycle.
* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
* supported by this function. We suggest
* using [lodash's merge()](https://lodash.com/docs/4.17.4#merge) instead.
*
* @knownIssue
* This is a list of (known) object types that are not handled correctly by this function:
* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
* - AngularJS {@link $rootScope.Scope scopes};
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/
function merge(dst) {
  return baseExtend(dst, slice.call(arguments, 1), true);
}



function toInt(str) {
  return parseInt(str, 10);
}

var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
  // eslint-disable-next-line no-self-compare
  return num !== num;
};


function inherit(parent, extra) {
  return extend(Object.create(parent), extra);
}

/**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */
function noop() {}
noop.$inject = [];


/**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
   function transformer(transformationFn, value) {
     return (transformationFn || angular.identity)(value);
   };

   // E.g.
   function getResult(fn, input) {
     return (fn || angular.identity)(input);
   };

   getResult(function(n) { return n * 2; }, 21);   // returns 42
   getResult(null, 21);                            // returns 21
   getResult(undefined, 21);                       // returns 21
   ```
 *
 * @param {*} value to be returned.
 * @returns {*} the value passed in.
 */
function identity($) {return $;}
identity.$inject = [];


function valueFn(value) {return function valueRef() {return value;};}

function hasCustomToString(obj) {
  return isFunction(obj.toString) && obj.toString !== toString;
}


/**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
function isUndefined(value) {return typeof value === 'undefined';}


/**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */
function isDefined(value) {return typeof value !== 'undefined';}


/**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
function isObject(value) {
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}


/**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */
function isBlankObject(value) {
  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
}


/**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
function isString(value) {return typeof value === 'string';}


/**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */
function isNumber(value) {return typeof value === 'number';}


/**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */
function isDate(value) {
  return toString.call(value) === '[object Date]';
}


/**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */
function isArray(arr) {
  return Array.isArray(arr) || arr instanceof Array;
}

/**
 * @description
 * Determines if a reference is an `Error`.
 * Loosely based on https://www.npmjs.com/package/iserror
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Error`.
 */
function isError(value) {
  var tag = toString.call(value);
  switch (tag) {
    case '[object Error]': return true;
    case '[object Exception]': return true;
    case '[object DOMException]': return true;
    default: return value instanceof Error;
  }
}

/**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */
function isFunction(value) {return typeof value === 'function';}


/**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */
function isRegExp(value) {
  return toString.call(value) === '[object RegExp]';
}


/**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */
function isWindow(obj) {
  return obj && obj.window === obj;
}


function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}


function isFile(obj) {
  return toString.call(obj) === '[object File]';
}


function isFormData(obj) {
  return toString.call(obj) === '[object FormData]';
}


function isBlob(obj) {
  return toString.call(obj) === '[object Blob]';
}


function isBoolean(value) {
  return typeof value === 'boolean';
}


function isPromiseLike(obj) {
  return obj && isFunction(obj.then);
}


var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
function isTypedArray(value) {
  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
}

function isArrayBuffer(obj) {
  return toString.call(obj) === '[object ArrayBuffer]';
}


var trim = function(value) {
  return isString(value) ? value.trim() : value;
};

// Copied from:
// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
// Prereq: s is a string.
var escapeForRegexp = function(s) {
  return s
    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
    // eslint-disable-next-line no-control-regex
    .replace(/\x08/g, '\\x08');
};


/**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */
function isElement(node) {
  return !!(node &&
    (node.nodeName  // We are a direct element.
    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
}

/**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */
function makeMap(str) {
  var obj = {}, items = str.split(','), i;
  for (i = 0; i < items.length; i++) {
    obj[items[i]] = true;
  }
  return obj;
}


function nodeName_(element) {
  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

function includes(array, obj) {
  return Array.prototype.indexOf.call(array, obj) !== -1;
}

function arrayRemove(array, value) {
  var index = array.indexOf(value);
  if (index >= 0) {
    array.splice(index, 1);
  }
  return index;
}

/**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array.
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to `destination` an exception will be thrown.
 *
 * <br />
 * <div class="alert alert-warning">
 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
 *   and on `destination`) will be ignored.
 * </div>
 *
 * @param {*} source The source that will be used to make a copy.
 *                   Can be any type, including primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If
 *     provided, must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
  <example module="copyExample" name="angular-copy">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate class="simple-form">
          <label>Name: <input type="text" ng-model="user.name" /></label><br />
          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
          <button ng-click="reset()">RESET</button>
          <button ng-click="update(user)">SAVE</button>
        </form>
        <pre>form = {{user | json}}</pre>
        <pre>leader = {{leader | json}}</pre>
      </div>
    </file>
    <file name="script.js">
      // Module: copyExample
      angular.
        module('copyExample', []).
        controller('ExampleController', ['$scope', function($scope) {
          $scope.leader = {};

          $scope.reset = function() {
            // Example with 1 argument
            $scope.user = angular.copy($scope.leader);
          };

          $scope.update = function(user) {
            // Example with 2 arguments
            angular.copy(user, $scope.leader);
          };

          $scope.reset();
        }]);
    </file>
  </example>
 */
function copy(source, destination, maxDepth) {
  var stackSource = [];
  var stackDest = [];
  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;

  if (destination) {
    if (isTypedArray(destination) || isArrayBuffer(destination)) {
      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
    }
    if (source === destination) {
      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
    }

    // Empty the destination object
    if (isArray(destination)) {
      destination.length = 0;
    } else {
      forEach(destination, function(value, key) {
        if (key !== '$$hashKey') {
          delete destination[key];
        }
      });
    }

    stackSource.push(source);
    stackDest.push(destination);
    return copyRecurse(source, destination, maxDepth);
  }

  return copyElement(source, maxDepth);

  function copyRecurse(source, destination, maxDepth) {
    maxDepth--;
    if (maxDepth < 0) {
      return '...';
    }
    var h = destination.$$hashKey;
    var key;
    if (isArray(source)) {
      for (var i = 0, ii = source.length; i < ii; i++) {
        destination.push(copyElement(source[i], maxDepth));
      }
    } else if (isBlankObject(source)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in source) {
        destination[key] = copyElement(source[key], maxDepth);
      }
    } else if (source && typeof source.hasOwnProperty === 'function') {
      // Slow path, which must rely on hasOwnProperty
      for (key in source) {
        if (source.hasOwnProperty(key)) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      }
    } else {
      // Slowest path --- hasOwnProperty can't be called as a method
      for (key in source) {
        if (hasOwnProperty.call(source, key)) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      }
    }
    setHashKey(destination, h);
    return destination;
  }

  function copyElement(source, maxDepth) {
    // Simple values
    if (!isObject(source)) {
      return source;
    }

    // Already copied values
    var index = stackSource.indexOf(source);
    if (index !== -1) {
      return stackDest[index];
    }

    if (isWindow(source) || isScope(source)) {
      throw ngMinErr('cpws',
        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
    }

    var needsRecurse = false;
    var destination = copyType(source);

    if (destination === undefined) {
      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
      needsRecurse = true;
    }

    stackSource.push(source);
    stackDest.push(destination);

    return needsRecurse
      ? copyRecurse(source, destination, maxDepth)
      : destination;
  }

  function copyType(source) {
    switch (toString.call(source)) {
      case '[object Int8Array]':
      case '[object Int16Array]':
      case '[object Int32Array]':
      case '[object Float32Array]':
      case '[object Float64Array]':
      case '[object Uint8Array]':
      case '[object Uint8ClampedArray]':
      case '[object Uint16Array]':
      case '[object Uint32Array]':
        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);

      case '[object ArrayBuffer]':
        // Support: IE10
        if (!source.slice) {
          // If we're in this case we know the environment supports ArrayBuffer
          /* eslint-disable no-undef */
          var copied = new ArrayBuffer(source.byteLength);
          new Uint8Array(copied).set(new Uint8Array(source));
          /* eslint-enable */
          return copied;
        }
        return source.slice(0);

      case '[object Boolean]':
      case '[object Number]':
      case '[object String]':
      case '[object Date]':
        return new source.constructor(source.valueOf());

      case '[object RegExp]':
        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
        re.lastIndex = source.lastIndex;
        return re;

      case '[object Blob]':
        return new source.constructor([source], {type: source.type});
    }

    if (isFunction(source.cloneNode)) {
      return source.cloneNode(true);
    }
  }
}


// eslint-disable-next-line no-self-compare
function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }


/**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 *
 * @example
   <example module="equalsExample" name="equalsExample">
     <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate>
          <h3>User 1</h3>
          Name: <input type="text" ng-model="user1.name">
          Age: <input type="number" ng-model="user1.age">

          <h3>User 2</h3>
          Name: <input type="text" ng-model="user2.name">
          Age: <input type="number" ng-model="user2.age">

          <div>
            <br/>
            <input type="button" value="Compare" ng-click="compare()">
          </div>
          User 1: <pre>{{user1 | json}}</pre>
          User 2: <pre>{{user2 | json}}</pre>
          Equal: <pre>{{result}}</pre>
        </form>
      </div>
    </file>
    <file name="script.js">
        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
          $scope.user1 = {};
          $scope.user2 = {};
          $scope.compare = function() {
            $scope.result = angular.equals($scope.user1, $scope.user2);
          };
        }]);
    </file>
  </example>
 */
function equals(o1, o2) {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  // eslint-disable-next-line no-self-compare
  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
  if (t1 === t2 && t1 === 'object') {
    if (isArray(o1)) {
      if (!isArray(o2)) return false;
      if ((length = o1.length) === o2.length) {
        for (key = 0; key < length; key++) {
          if (!equals(o1[key], o2[key])) return false;
        }
        return true;
      }
    } else if (isDate(o1)) {
      if (!isDate(o2)) return false;
      return simpleCompare(o1.getTime(), o2.getTime());
    } else if (isRegExp(o1)) {
      if (!isRegExp(o2)) return false;
      return o1.toString() === o2.toString();
    } else {
      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
      keySet = createMap();
      for (key in o1) {
        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
        if (!equals(o1[key], o2[key])) return false;
        keySet[key] = true;
      }
      for (key in o2) {
        if (!(key in keySet) &&
            key.charAt(0) !== '$' &&
            isDefined(o2[key]) &&
            !isFunction(o2[key])) return false;
      }
      return true;
    }
  }
  return false;
}

var csp = function() {
  if (!isDefined(csp.rules)) {


    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
                    window.document.querySelector('[data-ng-csp]'));

    if (ngCspElement) {
      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
                    ngCspElement.getAttribute('data-ng-csp');
      csp.rules = {
        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
      };
    } else {
      csp.rules = {
        noUnsafeEval: noUnsafeEval(),
        noInlineStyle: false
      };
    }
  }

  return csp.rules;

  function noUnsafeEval() {
    try {
      // eslint-disable-next-line no-new, no-new-func
      new Function('');
      return false;
    } catch (e) {
      return true;
    }
  }
};

/**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */
var jq = function() {
  if (isDefined(jq.name_)) return jq.name_;
  var el;
  var i, ii = ngAttrPrefixes.length, prefix, name;
  for (i = 0; i < ii; ++i) {
    prefix = ngAttrPrefixes[i];
    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
    if (el) {
      name = el.getAttribute(prefix + 'jq');
      break;
    }
  }

  return (jq.name_ = name);
};

function concat(array1, array2, index) {
  return array1.concat(slice.call(array2, index));
}

function sliceArgs(args, startIndex) {
  return slice.call(args, startIndex || 0);
}


/**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */
function bind(self, fn) {
  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
  if (isFunction(fn) && !(fn instanceof RegExp)) {
    return curryArgs.length
      ? function() {
          return arguments.length
            ? fn.apply(self, concat(curryArgs, arguments, 0))
            : fn.apply(self, curryArgs);
        }
      : function() {
          return arguments.length
            ? fn.apply(self, arguments)
            : fn.call(self);
        };
  } else {
    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
    return fn;
  }
}


function toJsonReplacer(key, value) {
  var val = value;

  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
    val = undefined;
  } else if (isWindow(value)) {
    val = '$WINDOW';
  } else if (value &&  window.document === value) {
    val = '$DOCUMENT';
  } else if (isScope(value)) {
    val = '$SCOPE';
  }

  return val;
}


/**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since AngularJS uses this notation internally.
 *
 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 * @knownIssue
 *
 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
 * `Date.prototype.toJSON` method as follows:
 *
 * ```
 * var _DatetoJSON = Date.prototype.toJSON;
 * Date.prototype.toJSON = function() {
 *   try {
 *     return _DatetoJSON.call(this);
 *   } catch(e) {
 *     if (e instanceof RangeError) {
 *       return null;
 *     }
 *     throw e;
 *   }
 * };
 * ```
 *
 * See https://github.com/angular/angular.js/pull/14221 for more information.
 */
function toJson(obj, pretty) {
  if (isUndefined(obj)) return undefined;
  if (!isNumber(pretty)) {
    pretty = pretty ? 2 : null;
  }
  return JSON.stringify(obj, toJsonReplacer, pretty);
}


/**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */
function fromJson(json) {
  return isString(json)
      ? JSON.parse(json)
      : json;
}


var ALL_COLONS = /:/g;
function timezoneToOffset(timezone, fallback) {
  // Support: IE 9-11 only, Edge 13-15+
  // IE/Edge do not "understand" colon (`:`) in timezone
  timezone = timezone.replace(ALL_COLONS, '');
  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
}


function addDateMinutes(date, minutes) {
  date = new Date(date.getTime());
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}


function convertTimezoneToLocal(date, timezone, reverse) {
  reverse = reverse ? -1 : 1;
  var dateTimezoneOffset = date.getTimezoneOffset();
  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
}


/**
 * @returns {string} Returns the string representation of the element.
 */
function startingTag(element) {
  element = jqLite(element).clone().empty();
  var elemHtml = jqLite('<div></div>').append(element).html();
  try {
    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
        elemHtml.
          match(/^(<[^>]+>)/)[1].
          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
  } catch (e) {
    return lowercase(elemHtml);
  }

}


/////////////////////////////////////////////////

/**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */
function tryDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    // Ignore any invalid uri component.
  }
}


/**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */
function parseKeyValue(/**string*/keyValue) {
  var obj = {};
  forEach((keyValue || '').split('&'), function(keyValue) {
    var splitPoint, key, val;
    if (keyValue) {
      key = keyValue = keyValue.replace(/\+/g,'%20');
      splitPoint = keyValue.indexOf('=');
      if (splitPoint !== -1) {
        key = keyValue.substring(0, splitPoint);
        val = keyValue.substring(splitPoint + 1);
      }
      key = tryDecodeURIComponent(key);
      if (isDefined(key)) {
        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
        if (!hasOwnProperty.call(obj, key)) {
          obj[key] = val;
        } else if (isArray(obj[key])) {
          obj[key].push(val);
        } else {
          obj[key] = [obj[key],val];
        }
      }
    }
  });
  return obj;
}

function toKeyValue(obj) {
  var parts = [];
  forEach(obj, function(value, key) {
    if (isArray(value)) {
      forEach(value, function(arrayValue) {
        parts.push(encodeUriQuery(key, true) +
                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
      });
    } else {
    parts.push(encodeUriQuery(key, true) +
               (value === true ? '' : '=' + encodeUriQuery(value, true)));
    }
  });
  return parts.length ? parts.join('&') : '';
}


/**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriSegment(val) {
  return encodeUriQuery(val, true).
             replace(/%26/gi, '&').
             replace(/%3D/gi, '=').
             replace(/%2B/gi, '+');
}


/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query         = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

function getNgAttribute(element, ngAttr) {
  var attr, i, ii = ngAttrPrefixes.length;
  for (i = 0; i < ii; ++i) {
    attr = ngAttrPrefixes[i] + ngAttr;
    if (isString(attr = element.getAttribute(attr))) {
      return attr;
    }
  }
  return null;
}

function allowAutoBootstrap(document) {
  var script = document.currentScript;

  if (!script) {
    // Support: IE 9-11 only
    // IE does not have `document.currentScript`
    return true;
  }

  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
    return false;
  }

  var attributes = script.attributes;
  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];

  return srcs.every(function(src) {
    if (!src) {
      return true;
    }
    if (!src.value) {
      return false;
    }

    var link = document.createElement('a');
    link.href = src.value;

    if (document.location.origin === link.origin) {
      // Same-origin resources are always allowed, even for non-whitelisted schemes.
      return true;
    }
    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
    // content security policy in web pages and other browser extensions.
    switch (link.protocol) {
      case 'http:':
      case 'https:':
      case 'ftp:':
      case 'blob:':
      case 'file:':
      case 'data:':
        return true;
      default:
        return false;
    }
  });
}

// Cached as it has to run during loading so that document.currentScript is available.
var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);

/**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * There are a few things to keep in mind when using `ngApp`:
 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 *   found in the document will be used to define the root element to auto-bootstrap as an
 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
 *   {@link angular.bootstrap} instead.
 * - AngularJS applications cannot be nested within each other.
 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
 *   {@link ngRoute.ngView `ngView`}.
 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 *   causing animations to stop working and making the injector inaccessible from outside the app.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * @example
 *
 * ### Simple Usage
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo" name="ng-app">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * @example
 *
 * ### With `ngStrictDi`
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true" name="strict-di">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = 'World';
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */
function angularInit(element, bootstrap) {
  var appElement,
      module,
      config = {};

  // The element `element` has priority over any other element.
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';

    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
      appElement = element;
      module = element.getAttribute(name);
    }
  });
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';
    var candidate;

    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
      appElement = candidate;
      module = candidate.getAttribute(name);
    }
  });
  if (appElement) {
    if (!isAutoBootstrapAllowed) {
      try {
        window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
          'an extension, document.location.href does not match.');
      } catch (e) {
        // Support: Safari 11 w/ Webdriver
        // The console.error will throw and make the test fail
      }
      return;
    }
    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
    bootstrap(appElement, module ? [module] : [], config);
  }
}

/**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up AngularJS application.
 *
 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
 *
 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of AngularJS try to work on the DOM.
 *
 * <div class="alert alert-warning">
 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 * causing animations to stop working and making the injector inaccessible from outside the app.
 * </div>
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */
function bootstrap(element, modules, config) {
  if (!isObject(config)) config = {};
  var defaultConfig = {
    strictDi: false
  };
  config = extend(defaultConfig, config);
  var doBootstrap = function() {
    element = jqLite(element);

    if (element.injector()) {
      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
      throw ngMinErr(
          'btstrpd',
          'App already bootstrapped with this element \'{0}\'',
          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
    }

    modules = modules || [];
    modules.unshift(['$provide', function($provide) {
      $provide.value('$rootElement', element);
    }]);

    if (config.debugInfoEnabled) {
      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
      modules.push(['$compileProvider', function($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
      }]);
    }

    modules.unshift('ng');
    var injector = createInjector(modules, config.strictDi);
    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
       function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function() {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]
    );
    return injector;
  };

  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
    config.debugInfoEnabled = true;
    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
  }

  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
    return doBootstrap();
  }

  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
  angular.resumeBootstrap = function(extraModules) {
    forEach(extraModules, function(module) {
      modules.push(module);
    });
    return doBootstrap();
  };

  if (isFunction(angular.resumeDeferredBootstrap)) {
    angular.resumeDeferredBootstrap();
  }
}

/**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */
function reloadWithDebugInfo() {
  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
  window.location.reload();
}

/**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of AngularJS on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 */
function getTestability(rootElement) {
  var injector = angular.element(rootElement).injector();
  if (!injector) {
    throw ngMinErr('test',
      'no injector found for element argument to getTestability');
  }
  return injector.get('$$testability');
}

var SNAKE_CASE_REGEXP = /[A-Z]/g;
function snake_case(name, separator) {
  separator = separator || '_';
  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
    return (pos ? separator : '') + letter.toLowerCase();
  });
}

var bindJQueryFired = false;
function bindJQuery() {
  var originalCleanData;

  if (bindJQueryFired) {
    return;
  }

  // bind to jQuery if present;
  var jqName = jq();
  jQuery = isUndefined(jqName) ? __webpack_provided_window_dot_jQuery :   // use jQuery (if present)
           !jqName             ? undefined     :   // use jqLite
                                 window[jqName];   // use jQuery specified by `ngJq`

  // Use jQuery if it exists with proper functionality, otherwise default to us.
  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
  // versions. It will not work for sure with jQuery <1.7, though.
  if (jQuery && jQuery.fn.on) {
    jqLite = jQuery;
    extend(jQuery.fn, {
      scope: JQLitePrototype.scope,
      isolateScope: JQLitePrototype.isolateScope,
      controller: /** @type {?} */ (JQLitePrototype).controller,
      injector: JQLitePrototype.injector,
      inheritedData: JQLitePrototype.inheritedData
    });
  } else {
    jqLite = JQLite;
  }

  // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
  // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
  // the $destroy event on all removed nodes.
  originalCleanData = jqLite.cleanData;
  jqLite.cleanData = function(elems) {
    var events;
    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
      events = (jqLite._data(elem) || {}).events;
      if (events && events.$destroy) {
        jqLite(elem).triggerHandler('$destroy');
      }
    }
    originalCleanData(elems);
  };

  angular.element = jqLite;

  // Prevent double-proxying.
  bindJQueryFired = true;
}

/**
 * throw error if the argument is falsy.
 */
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function assertArgFn(arg, name, acceptArrayAnnotation) {
  if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
  }

  assertArg(isFunction(arg), name, 'not a function, got ' +
      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
  return arg;
}

/**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */
function assertNotHasOwnProperty(name, context) {
  if (name === 'hasOwnProperty') {
    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
  }
}

/**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */
//TODO(misko): this function needs to be removed
function getter(obj, path, bindFnToScope) {
  if (!path) return obj;
  var keys = path.split('.');
  var key;
  var lastInstance = obj;
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    key = keys[i];
    if (obj) {
      obj = (lastInstance = obj)[key];
    }
  }
  if (!bindFnToScope && isFunction(obj)) {
    return bind(lastInstance, obj);
  }
  return obj;
}

/**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {Array} the inputted object or a jqLite collection containing the nodes
 */
function getBlockNodes(nodes) {
  // TODO(perf): update `nodes` instead of creating a new object?
  var node = nodes[0];
  var endNode = nodes[nodes.length - 1];
  var blockNodes;

  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
    if (blockNodes || nodes[i] !== node) {
      if (!blockNodes) {
        blockNodes = jqLite(slice.call(nodes, 0, i));
      }
      blockNodes.push(node);
    }
  }

  return blockNodes || nodes;
}


/**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */
function createMap() {
  return Object.create(null);
}

function stringify(value) {
  if (value == null) { // null || undefined
    return '';
  }
  switch (typeof value) {
    case 'string':
      break;
    case 'number':
      value = '' + value;
      break;
    default:
      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
        value = value.toString();
      } else {
        value = toJson(value);
      }
  }

  return value;
}

var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_ATTRIBUTE = 2;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_COMMENT = 8;
var NODE_TYPE_DOCUMENT = 9;
var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

/**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring AngularJS {@link angular.module modules}.
 */

function setupModuleLoader(window) {

  var $injectorMinErr = minErr('$injector');
  var ngMinErr = minErr('ng');

  function ensure(obj, name, factory) {
    return obj[name] || (obj[name] = factory());
  }

  var angular = ensure(window, 'angular', Object);

  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
  angular.$$minErr = angular.$$minErr || minErr;

  return ensure(angular, 'module', function() {
    /** @type {Object.<string, angular.Module>} */
    var modules = {};

    /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
     * modules.
     * All modules (AngularJS core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * Passing one argument retrieves an existing {@link angular.Module},
     * whereas passing more than one argument creates a new {@link angular.Module}
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {angular.Module} new module with the {@link angular.Module} api.
     */
    return function module(name, requires, configFn) {

      var info = {};

      var assertNotHasOwnProperty = function(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
        }
      };

      assertNotHasOwnProperty(name, 'module');
      if (requires && modules.hasOwnProperty(name)) {
        modules[name] = null;
      }
      return ensure(modules, name, function() {
        if (!requires) {
          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
             'the module name or forgot to load it. If registering a module ensure that you ' +
             'specify the dependencies as the second argument.', name);
        }

        /** @type {!Array.<Array.<*>>} */
        var invokeQueue = [];

        /** @type {!Array.<Function>} */
        var configBlocks = [];

        /** @type {!Array.<Function>} */
        var runBlocks = [];

        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

        /** @type {angular.Module} */
        var moduleInstance = {
          // Private state
          _invokeQueue: invokeQueue,
          _configBlocks: configBlocks,
          _runBlocks: runBlocks,

          /**
           * @ngdoc method
           * @name angular.Module#info
           * @module ng
           *
           * @param {Object=} info Information about the module
           * @returns {Object|Module} The current info object for this module if called as a getter,
           *                          or `this` if called as a setter.
           *
           * @description
           * Read and write custom information about this module.
           * For example you could put the version of the module in here.
           *
           * ```js
           * angular.module('myModule', []).info({ version: '1.0.0' });
           * ```
           *
           * The version could then be read back out by accessing the module elsewhere:
           *
           * ```
           * var version = angular.module('myModule').info().version;
           * ```
           *
           * You can also retrieve this information during runtime via the
           * {@link $injector#modules `$injector.modules`} property:
           *
           * ```js
           * var version = $injector.modules['myModule'].info().version;
           * ```
           */
          info: function(value) {
            if (isDefined(value)) {
              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
              info = value;
              return this;
            }
            return info;
          },

          /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */
          requires: requires,

          /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */
          name: name,


          /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */
          provider: invokeLaterAndSetModuleName('$provide', 'provider'),

          /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */
          factory: invokeLaterAndSetModuleName('$provide', 'factory'),

          /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */
          service: invokeLaterAndSetModuleName('$provide', 'service'),

          /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */
          value: invokeLater('$provide', 'value'),

          /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constants are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */
          constant: invokeLater('$provide', 'constant', 'unshift'),

           /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} name The name of the service to decorate.
           * @param {Function} decorFn This function will be invoked when the service needs to be
           *                           instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */
          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),

          /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */
          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */
          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */
          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */
          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),

          /**
           * @ngdoc method
           * @name angular.Module#component
           * @module ng
           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
           *    or an object map of components where the keys are the names and the values are the component definition objects.
           * @param {Object} options Component definition object (a simplified
           *    {@link ng.$compile#directive-definition-object directive definition object})
           *
           * @description
           * See {@link ng.$compileProvider#component $compileProvider.component()}.
           */
          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),

          /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to configure services by injecting their
           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
           * {@link ngRoute.$routeProvider $routeProvider}.
           *
           * Note that you can only inject {@link angular.Module#provider `providers`} and
           * {@link angular.Module#constant `constants`} into this function.
           *
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */
          config: config,

          /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */
          run: function(block) {
            runBlocks.push(block);
            return this;
          }
        };

        if (configFn) {
          config(configFn);
        }

        return moduleInstance;

        /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */
        function invokeLater(provider, method, insertMethod, queue) {
          if (!queue) queue = invokeQueue;
          return function() {
            queue[insertMethod || 'push']([provider, method, arguments]);
            return moduleInstance;
          };
        }

        /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */
        function invokeLaterAndSetModuleName(provider, method, queue) {
          if (!queue) queue = invokeQueue;
          return function(recipeName, factoryFunction) {
            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
            queue.push([provider, method, arguments]);
            return moduleInstance;
          };
        }
      });
    };
  });

}

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* exported toDebugString */

function serializeObject(obj, maxDepth) {
  var seen = [];

  // There is no direct way to stringify object until reaching a specific depth
  // and a very deep object can cause a performance issue, so we copy the object
  // based on this specific depth and then stringify it.
  if (isValidObjectMaxDepth(maxDepth)) {
    // This file is also included in `angular-loader`, so `copy()` might not always be available in
    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
    obj = angular.copy(obj, null, maxDepth);
  }
  return JSON.stringify(obj, function(key, val) {
    val = toJsonReplacer(key, val);
    if (isObject(val)) {

      if (seen.indexOf(val) >= 0) return '...';

      seen.push(val);
    }
    return val;
  });
}

function toDebugString(obj, maxDepth) {
  if (typeof obj === 'function') {
    return obj.toString().replace(/ \{[\s\S]*$/, '');
  } else if (isUndefined(obj)) {
    return 'undefined';
  } else if (typeof obj !== 'string') {
    return serializeObject(obj, maxDepth);
  }
  return obj;
}

/* global angularModule: true,
  version: true,

  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  inputDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRefDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $CoreAnimateCssProvider,
  $$CoreAnimateJsProvider,
  $$CoreAnimateQueueProvider,
  $$AnimateRunnerFactoryProvider,
  $$AnimateAsyncRunFactoryProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DateProvider,
  $DocumentProvider,
  $$IsDocumentHiddenProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $$ForceReflowProvider,
  $InterpolateProvider,
  $$IntervalFactoryProvider,
  $IntervalProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $xhrFactoryProvider,
  $jsonpCallbacksProvider,
  $LocationProvider,
  $LogProvider,
  $$MapProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $$TaskTrackerFactoryProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/


/**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version.
 *
 * This object has the following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */
var version = {
  // These placeholder strings will be replaced by grunt's `build` task.
  // They need to be double- or single-quoted.
  full: '1.7.3',
  major: 1,
  minor: 7,
  dot: 3,
  codeName: 'eventful-proposal'
};


function publishExternalAPI(angular) {
  extend(angular, {
    'errorHandlingConfig': errorHandlingConfig,
    'bootstrap': bootstrap,
    'copy': copy,
    'extend': extend,
    'merge': merge,
    'equals': equals,
    'element': jqLite,
    'forEach': forEach,
    'injector': createInjector,
    'noop': noop,
    'bind': bind,
    'toJson': toJson,
    'fromJson': fromJson,
    'identity': identity,
    'isUndefined': isUndefined,
    'isDefined': isDefined,
    'isString': isString,
    'isFunction': isFunction,
    'isObject': isObject,
    'isNumber': isNumber,
    'isElement': isElement,
    'isArray': isArray,
    'version': version,
    'isDate': isDate,
    'callbacks': {$$counter: 0},
    'getTestability': getTestability,
    'reloadWithDebugInfo': reloadWithDebugInfo,
    '$$minErr': minErr,
    '$$csp': csp,
    '$$encodeUriSegment': encodeUriSegment,
    '$$encodeUriQuery': encodeUriQuery,
    '$$lowercase': lowercase,
    '$$stringify': stringify,
    '$$uppercase': uppercase
  });

  angularModule = setupModuleLoader(window);

  angularModule('ng', ['ngLocale'], ['$provide',
    function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).
        directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRef: ngRefDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
        }).
        directive({
          ngInclude: ngIncludeFillContentDirective
        }).
        directive(ngAttributeAliasDirectives).
        directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $animateCss: $CoreAnimateCssProvider,
        $$animateJs: $$CoreAnimateJsProvider,
        $$animateQueue: $$CoreAnimateQueueProvider,
        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $$isDocumentHidden: $$IsDocumentHiddenProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $$forceReflow: $$ForceReflowProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $$intervalFactory: $$IntervalFactoryProvider,
        $http: $HttpProvider,
        $httpParamSerializer: $HttpParamSerializerProvider,
        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
        $httpBackend: $HttpBackendProvider,
        $xhrFactory: $xhrFactoryProvider,
        $jsonpCallbacks: $jsonpCallbacksProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$jqLite: $$jqLiteProvider,
        $$Map: $$MapProvider,
        $$cookieReader: $$CookieReaderProvider
      });
    }
  ])
  .info({ angularVersion: '1.7.3' });
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* global
  JQLitePrototype: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true
*/

//////////////////////////////////
//JQLite
//////////////////////////////////

/**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
 *
 * jqLite is a tiny, API-compatible subset of jQuery that allows
 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
 * commonly needed functionality with the goal of having a very small footprint.
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
 * specific version of jQuery if multiple versions exist on the page.
 *
 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
 *
 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
 *
 * ## AngularJS's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * ## jQuery/jqLite Extras
 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
 * https://github.com/angular/angular.js/issues/14251 for more information.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */

JQLite.expando = 'ng339';

var jqCache = JQLite.cache = {},
    jqId = 1;

/*
 * !!! This is an undocumented "private" function !!!
 */
JQLite._data = function(node) {
  //jQuery always returns an object on cache miss
  return this.cache[node[this.expando]] || {};
};

function jqNextId() { return ++jqId; }


var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
var MS_HACK_REGEXP = /^-ms-/;
var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
var jqLiteMinErr = minErr('jqLite');

/**
 * Converts kebab-case to camelCase.
 * There is also a special case for the ms prefix starting with a lowercase letter.
 * @param name Name to normalize
 */
function cssKebabToCamel(name) {
    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
}

function fnCamelCaseReplace(all, letter) {
  return letter.toUpperCase();
}

/**
 * Converts kebab-case to camelCase.
 * @param name Name to normalize
 */
function kebabToCamel(name) {
  return name
    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
var HTML_REGEXP = /<|&#?\w+;/;
var TAG_NAME_REGEXP = /<([\w:-]+)/;
var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

var wrapMap = {
  'option': [1, '<select multiple="multiple">', '</select>'],

  'thead': [1, '<table>', '</table>'],
  'col': [2, '<table><colgroup>', '</colgroup></table>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],
  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
  '_default': [0, '', '']
};

wrapMap.optgroup = wrapMap.option;
wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function jqLiteIsTextNode(html) {
  return !HTML_REGEXP.test(html);
}

function jqLiteAcceptsData(node) {
  // The window object can accept data but has no nodeType
  // Otherwise we are only interested in elements (1) and documents (9)
  var nodeType = node.nodeType;
  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
}

function jqLiteHasData(node) {
  for (var key in jqCache[node.ng339]) {
    return true;
  }
  return false;
}

function jqLiteBuildFragment(html, context) {
  var tmp, tag, wrap,
      fragment = context.createDocumentFragment(),
      nodes = [], i;

  if (jqLiteIsTextNode(html)) {
    // Convert non-html into a text node
    nodes.push(context.createTextNode(html));
  } else {
    // Convert html into DOM nodes
    tmp = fragment.appendChild(context.createElement('div'));
    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
    wrap = wrapMap[tag] || wrapMap._default;
    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];

    // Descend through wrappers to the right content
    i = wrap[0];
    while (i--) {
      tmp = tmp.lastChild;
    }

    nodes = concat(nodes, tmp.childNodes);

    tmp = fragment.firstChild;
    tmp.textContent = '';
  }

  // Remove wrapper from fragment
  fragment.textContent = '';
  fragment.innerHTML = ''; // Clear inner HTML
  forEach(nodes, function(node) {
    fragment.appendChild(node);
  });

  return fragment;
}

function jqLiteParseHTML(html, context) {
  context = context || window.document;
  var parsed;

  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
    return [context.createElement(parsed[1])];
  }

  if ((parsed = jqLiteBuildFragment(html, context))) {
    return parsed.childNodes;
  }

  return [];
}

function jqLiteWrapNode(node, wrapper) {
  var parent = node.parentNode;

  if (parent) {
    parent.replaceChild(wrapper, node);
  }

  wrapper.appendChild(node);
}


// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
  // eslint-disable-next-line no-bitwise
  return !!(this.compareDocumentPosition(arg) & 16);
};

/////////////////////////////////////////////
function JQLite(element) {
  if (element instanceof JQLite) {
    return element;
  }

  var argIsString;

  if (isString(element)) {
    element = trim(element);
    argIsString = true;
  }
  if (!(this instanceof JQLite)) {
    if (argIsString && element.charAt(0) !== '<') {
      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
    }
    return new JQLite(element);
  }

  if (argIsString) {
    jqLiteAddNodes(this, jqLiteParseHTML(element));
  } else if (isFunction(element)) {
    jqLiteReady(element);
  } else {
    jqLiteAddNodes(this, element);
  }
}

function jqLiteClone(element) {
  return element.cloneNode(true);
}

function jqLiteDealoc(element, onlyDescendants) {
  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);

  if (element.querySelectorAll) {
    jqLite.cleanData(element.querySelectorAll('*'));
  }
}

function isEmptyObject(obj) {
  var name;

  for (name in obj) {
    return false;
  }
  return true;
}

function removeIfEmptyData(element) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  var events = expandoStore && expandoStore.events;
  var data = expandoStore && expandoStore.data;

  if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
    delete jqCache[expandoId];
    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
  }
}

function jqLiteOff(element, type, fn, unsupported) {
  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

  var expandoStore = jqLiteExpandoStore(element);
  var events = expandoStore && expandoStore.events;
  var handle = expandoStore && expandoStore.handle;

  if (!handle) return; //no listeners registered

  if (!type) {
    for (type in events) {
      if (type !== '$destroy') {
        element.removeEventListener(type, handle);
      }
      delete events[type];
    }
  } else {

    var removeHandler = function(type) {
      var listenerFns = events[type];
      if (isDefined(fn)) {
        arrayRemove(listenerFns || [], fn);
      }
      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
        element.removeEventListener(type, handle);
        delete events[type];
      }
    };

    forEach(type.split(' '), function(type) {
      removeHandler(type);
      if (MOUSE_EVENT_MAP[type]) {
        removeHandler(MOUSE_EVENT_MAP[type]);
      }
    });
  }

  removeIfEmptyData(element);
}

function jqLiteRemoveData(element, name) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  if (expandoStore) {
    if (name) {
      delete expandoStore.data[name];
    } else {
      expandoStore.data = {};
    }

    removeIfEmptyData(element);
  }
}


function jqLiteExpandoStore(element, createIfNecessary) {
  var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];

  if (createIfNecessary && !expandoStore) {
    element.ng339 = expandoId = jqNextId();
    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
  }

  return expandoStore;
}


function jqLiteData(element, key, value) {
  if (jqLiteAcceptsData(element)) {
    var prop;

    var isSimpleSetter = isDefined(value);
    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
    var massGetter = !key;
    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
    var data = expandoStore && expandoStore.data;

    if (isSimpleSetter) { // data('key', value)
      data[kebabToCamel(key)] = value;
    } else {
      if (massGetter) {  // data()
        return data;
      } else {
        if (isSimpleGetter) { // data('key')
          // don't force creation of expandoStore if it doesn't exist yet
          return data && data[kebabToCamel(key)];
        } else { // mass-setter: data({key1: val1, key2: val2})
          for (prop in key) {
            data[kebabToCamel(prop)] = key[prop];
          }
        }
      }
    }
  }
}

function jqLiteHasClass(element, selector) {
  if (!element.getAttribute) return false;
  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
      indexOf(' ' + selector + ' ') > -1);
}

function jqLiteRemoveClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');
    var newClasses = existingClasses;

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
    });

    if (newClasses !== existingClasses) {
      element.setAttribute('class', trim(newClasses));
    }
  }
}

function jqLiteAddClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');
    var newClasses = existingClasses;

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
        newClasses += cssClass + ' ';
      }
    });

    if (newClasses !== existingClasses) {
      element.setAttribute('class', trim(newClasses));
    }
  }
}


function jqLiteAddNodes(root, elements) {
  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

  if (elements) {

    // if a Node (the most common case)
    if (elements.nodeType) {
      root[root.length++] = elements;
    } else {
      var length = elements.length;

      // if an Array or NodeList and not a Window
      if (typeof length === 'number' && elements.window !== elements) {
        if (length) {
          for (var i = 0; i < length; i++) {
            root[root.length++] = elements[i];
          }
        }
      } else {
        root[root.length++] = elements;
      }
    }
  }
}


function jqLiteController(element, name) {
  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
}

function jqLiteInheritedData(element, name, value) {
  // if element is the document object work with the html element instead
  // this makes $(document).scope() possible
  if (element.nodeType === NODE_TYPE_DOCUMENT) {
    element = element.documentElement;
  }
  var names = isArray(name) ? name : [name];

  while (element) {
    for (var i = 0, ii = names.length; i < ii; i++) {
      if (isDefined(value = jqLite.data(element, names[i]))) return value;
    }

    // If dealing with a document fragment node with a host element, and no parent, use the host
    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
    // to lookup parent controllers.
    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
  }
}

function jqLiteEmpty(element) {
  jqLiteDealoc(element, true);
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

function jqLiteRemove(element, keepData) {
  if (!keepData) jqLiteDealoc(element);
  var parent = element.parentNode;
  if (parent) parent.removeChild(element);
}


function jqLiteDocumentLoaded(action, win) {
  win = win || window;
  if (win.document.readyState === 'complete') {
    // Force the action to be run async for consistent behavior
    // from the action's point of view
    // i.e. it will definitely not be in a $apply
    win.setTimeout(action);
  } else {
    // No need to unbind this handler as load is only ever called once
    jqLite(win).on('load', action);
  }
}

function jqLiteReady(fn) {
  function trigger() {
    window.document.removeEventListener('DOMContentLoaded', trigger);
    window.removeEventListener('load', trigger);
    fn();
  }

  // check if document is already loaded
  if (window.document.readyState === 'complete') {
    window.setTimeout(fn);
  } else {
    // We can not use jqLite since we are not done loading and jQuery could be loaded later.

    // Works for modern browsers and IE9
    window.document.addEventListener('DOMContentLoaded', trigger);

    // Fallback to window.onload for others
    window.addEventListener('load', trigger);
  }
}

//////////////////////////////////////////
// Functions which are declared directly.
//////////////////////////////////////////
var JQLitePrototype = JQLite.prototype = {
  ready: jqLiteReady,
  toString: function() {
    var value = [];
    forEach(this, function(e) { value.push('' + e);});
    return '[' + value.join(', ') + ']';
  },

  eq: function(index) {
      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
  },

  length: 0,
  push: push,
  sort: [].sort,
  splice: [].splice
};

//////////////////////////////////////////
// Functions iterating getter/setters.
// these functions return self on setter and
// value on get.
//////////////////////////////////////////
var BOOLEAN_ATTR = {};
forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
  BOOLEAN_ATTR[lowercase(value)] = value;
});
var BOOLEAN_ELEMENTS = {};
forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
  BOOLEAN_ELEMENTS[value] = true;
});
var ALIASED_ATTR = {
  'ngMinlength': 'minlength',
  'ngMaxlength': 'maxlength',
  'ngMin': 'min',
  'ngMax': 'max',
  'ngPattern': 'pattern',
  'ngStep': 'step'
};

function getBooleanAttrName(element, name) {
  // check dom last since we will most likely fail on name
  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

  // booleanAttr is here twice to minimize DOM access
  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
}

function getAliasedAttrName(name) {
  return ALIASED_ATTR[name];
}

forEach({
  data: jqLiteData,
  removeData: jqLiteRemoveData,
  hasData: jqLiteHasData,
  cleanData: function jqLiteCleanData(nodes) {
    for (var i = 0, ii = nodes.length; i < ii; i++) {
      jqLiteRemoveData(nodes[i]);
      jqLiteOff(nodes[i]);
    }
  }
}, function(fn, name) {
  JQLite[name] = fn;
});

forEach({
  data: jqLiteData,
  inheritedData: jqLiteInheritedData,

  scope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
  },

  isolateScope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
  },

  controller: jqLiteController,

  injector: function(element) {
    return jqLiteInheritedData(element, '$injector');
  },

  removeAttr: function(element, name) {
    element.removeAttribute(name);
  },

  hasClass: jqLiteHasClass,

  css: function(element, name, value) {
    name = cssKebabToCamel(name);

    if (isDefined(value)) {
      element.style[name] = value;
    } else {
      return element.style[name];
    }
  },

  attr: function(element, name, value) {
    var ret;
    var nodeType = element.nodeType;
    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
      !element.getAttribute) {
      return;
    }

    var lowercasedName = lowercase(name);
    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];

    if (isDefined(value)) {
      // setter

      if (value === null || (value === false && isBooleanAttr)) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
      }
    } else {
      // getter

      ret = element.getAttribute(name);

      if (isBooleanAttr && ret !== null) {
        ret = lowercasedName;
      }
      // Normalize non-existing attributes to undefined (as jQuery).
      return ret === null ? undefined : ret;
    }
  },

  prop: function(element, name, value) {
    if (isDefined(value)) {
      element[name] = value;
    } else {
      return element[name];
    }
  },

  text: (function() {
    getText.$dv = '';
    return getText;

    function getText(element, value) {
      if (isUndefined(value)) {
        var nodeType = element.nodeType;
        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
      }
      element.textContent = value;
    }
  })(),

  val: function(element, value) {
    if (isUndefined(value)) {
      if (element.multiple && nodeName_(element) === 'select') {
        var result = [];
        forEach(element.options, function(option) {
          if (option.selected) {
            result.push(option.value || option.text);
          }
        });
        return result;
      }
      return element.value;
    }
    element.value = value;
  },

  html: function(element, value) {
    if (isUndefined(value)) {
      return element.innerHTML;
    }
    jqLiteDealoc(element, true);
    element.innerHTML = value;
  },

  empty: jqLiteEmpty
}, function(fn, name) {
  /**
   * Properties: writes return selection, reads return first value
   */
  JQLite.prototype[name] = function(arg1, arg2) {
    var i, key;
    var nodeCount = this.length;

    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
    // in a way that survives minification.
    // jqLiteEmpty takes no arguments but is a setter.
    if (fn !== jqLiteEmpty &&
        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
      if (isObject(arg1)) {

        // we are a write, but the object properties are the key/values
        for (i = 0; i < nodeCount; i++) {
          if (fn === jqLiteData) {
            // data() takes the whole object in jQuery
            fn(this[i], arg1);
          } else {
            for (key in arg1) {
              fn(this[i], key, arg1[key]);
            }
          }
        }
        // return self for chaining
        return this;
      } else {
        // we are a read, so read the first child.
        // TODO: do we still need this?
        var value = fn.$dv;
        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
        for (var j = 0; j < jj; j++) {
          var nodeValue = fn(this[j], arg1, arg2);
          value = value ? value + nodeValue : nodeValue;
        }
        return value;
      }
    } else {
      // we are a write, so apply to all children
      for (i = 0; i < nodeCount; i++) {
        fn(this[i], arg1, arg2);
      }
      // return self for chaining
      return this;
    }
  };
});

function createEventHandler(element, events) {
  var eventHandler = function(event, type) {
    // jQuery specific api
    event.isDefaultPrevented = function() {
      return event.defaultPrevented;
    };

    var eventFns = events[type || event.type];
    var eventFnsLength = eventFns ? eventFns.length : 0;

    if (!eventFnsLength) return;

    if (isUndefined(event.immediatePropagationStopped)) {
      var originalStopImmediatePropagation = event.stopImmediatePropagation;
      event.stopImmediatePropagation = function() {
        event.immediatePropagationStopped = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }

        if (originalStopImmediatePropagation) {
          originalStopImmediatePropagation.call(event);
        }
      };
    }

    event.isImmediatePropagationStopped = function() {
      return event.immediatePropagationStopped === true;
    };

    // Some events have special handlers that wrap the real handler
    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

    // Copy event handlers in case event handlers array is modified during execution.
    if ((eventFnsLength > 1)) {
      eventFns = shallowCopy(eventFns);
    }

    for (var i = 0; i < eventFnsLength; i++) {
      if (!event.isImmediatePropagationStopped()) {
        handlerWrapper(element, event, eventFns[i]);
      }
    }
  };

  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
  //       events on `element`
  eventHandler.elem = element;
  return eventHandler;
}

function defaultHandlerWrapper(element, event, handler) {
  handler.call(element, event);
}

function specialMouseHandlerWrapper(target, event, handler) {
  // Refer to jQuery's implementation of mouseenter & mouseleave
  // Read about mouseenter and mouseleave:
  // http://www.quirksmode.org/js/events_mouse.html#link8
  var related = event.relatedTarget;
  // For mousenter/leave call the handler if related is outside the target.
  // NB: No relatedTarget if the mouse left/entered the browser window
  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
    handler.call(target, event);
  }
}

//////////////////////////////////////////
// Functions iterating traversal.
// These functions chain results into a single
// selector.
//////////////////////////////////////////
forEach({
  removeData: jqLiteRemoveData,

  on: function jqLiteOn(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

    // Do not add event handlers to non-elements because they will not be cleaned up.
    if (!jqLiteAcceptsData(element)) {
      return;
    }

    var expandoStore = jqLiteExpandoStore(element, true);
    var events = expandoStore.events;
    var handle = expandoStore.handle;

    if (!handle) {
      handle = expandoStore.handle = createEventHandler(element, events);
    }

    // http://jsperf.com/string-indexof-vs-split
    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
    var i = types.length;

    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
      var eventFns = events[type];

      if (!eventFns) {
        eventFns = events[type] = [];
        eventFns.specialHandlerWrapper = specialHandlerWrapper;
        if (type !== '$destroy' && !noEventListener) {
          element.addEventListener(type, handle);
        }
      }

      eventFns.push(fn);
    };

    while (i--) {
      type = types[i];
      if (MOUSE_EVENT_MAP[type]) {
        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
        addHandler(type, undefined, true);
      } else {
        addHandler(type);
      }
    }
  },

  off: jqLiteOff,

  one: function(element, type, fn) {
    element = jqLite(element);

    //add the listener twice so that when it is called
    //you can remove the original function and still be
    //able to call element.off(ev, fn) normally
    element.on(type, function onFn() {
      element.off(type, fn);
      element.off(type, onFn);
    });
    element.on(type, fn);
  },

  replaceWith: function(element, replaceNode) {
    var index, parent = element.parentNode;
    jqLiteDealoc(element);
    forEach(new JQLite(replaceNode), function(node) {
      if (index) {
        parent.insertBefore(node, index.nextSibling);
      } else {
        parent.replaceChild(node, element);
      }
      index = node;
    });
  },

  children: function(element) {
    var children = [];
    forEach(element.childNodes, function(element) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        children.push(element);
      }
    });
    return children;
  },

  contents: function(element) {
    return element.contentDocument || element.childNodes || [];
  },

  append: function(element, node) {
    var nodeType = element.nodeType;
    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

    node = new JQLite(node);

    for (var i = 0, ii = node.length; i < ii; i++) {
      var child = node[i];
      element.appendChild(child);
    }
  },

  prepend: function(element, node) {
    if (element.nodeType === NODE_TYPE_ELEMENT) {
      var index = element.firstChild;
      forEach(new JQLite(node), function(child) {
        element.insertBefore(child, index);
      });
    }
  },

  wrap: function(element, wrapNode) {
    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
  },

  remove: jqLiteRemove,

  detach: function(element) {
    jqLiteRemove(element, true);
  },

  after: function(element, newElement) {
    var index = element, parent = element.parentNode;

    if (parent) {
      newElement = new JQLite(newElement);

      for (var i = 0, ii = newElement.length; i < ii; i++) {
        var node = newElement[i];
        parent.insertBefore(node, index.nextSibling);
        index = node;
      }
    }
  },

  addClass: jqLiteAddClass,
  removeClass: jqLiteRemoveClass,

  toggleClass: function(element, selector, condition) {
    if (selector) {
      forEach(selector.split(' '), function(className) {
        var classCondition = condition;
        if (isUndefined(classCondition)) {
          classCondition = !jqLiteHasClass(element, className);
        }
        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
      });
    }
  },

  parent: function(element) {
    var parent = element.parentNode;
    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
  },

  next: function(element) {
    return element.nextElementSibling;
  },

  find: function(element, selector) {
    if (element.getElementsByTagName) {
      return element.getElementsByTagName(selector);
    } else {
      return [];
    }
  },

  clone: jqLiteClone,

  triggerHandler: function(element, event, extraParameters) {

    var dummyEvent, eventFnsCopy, handlerArgs;
    var eventName = event.type || event;
    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var eventFns = events && events[eventName];

    if (eventFns) {
      // Create a dummy event to pass to the handlers
      dummyEvent = {
        preventDefault: function() { this.defaultPrevented = true; },
        isDefaultPrevented: function() { return this.defaultPrevented === true; },
        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
        stopPropagation: noop,
        type: eventName,
        target: element
      };

      // If a custom event was provided then extend our dummy event with it
      if (event.type) {
        dummyEvent = extend(dummyEvent, event);
      }

      // Copy event handlers in case event handlers array is modified during execution.
      eventFnsCopy = shallowCopy(eventFns);
      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

      forEach(eventFnsCopy, function(fn) {
        if (!dummyEvent.isImmediatePropagationStopped()) {
          fn.apply(element, handlerArgs);
        }
      });
    }
  }
}, function(fn, name) {
  /**
   * chaining functions
   */
  JQLite.prototype[name] = function(arg1, arg2, arg3) {
    var value;

    for (var i = 0, ii = this.length; i < ii; i++) {
      if (isUndefined(value)) {
        value = fn(this[i], arg1, arg2, arg3);
        if (isDefined(value)) {
          // any function which returns a value needs to be wrapped
          value = jqLite(value);
        }
      } else {
        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
      }
    }
    return isDefined(value) ? value : this;
  };
});

// bind legacy bind/unbind to on/off
JQLite.prototype.bind = JQLite.prototype.on;
JQLite.prototype.unbind = JQLite.prototype.off;


// Provider for private $$jqLite service
/** @this */
function $$jqLiteProvider() {
  this.$get = function $$jqLite() {
    return extend(JQLite, {
      hasClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteHasClass(node, classes);
      },
      addClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteAddClass(node, classes);
      },
      removeClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteRemoveClass(node, classes);
      }
    });
  };
}

/**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */
function hashKey(obj, nextUidFn) {
  var key = obj && obj.$$hashKey;

  if (key) {
    if (typeof key === 'function') {
      key = obj.$$hashKey();
    }
    return key;
  }

  var objType = typeof obj;
  if (objType === 'function' || (objType === 'object' && obj !== null)) {
    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
  } else {
    key = objType + ':' + obj;
  }

  return key;
}

// A minimal ES2015 Map implementation.
// Should be bug/feature equivalent to the native implementations of supported browsers
// (for the features required in Angular).
// See https://kangax.github.io/compat-table/es6/#test-Map
var nanKey = Object.create(null);
function NgMapShim() {
  this._keys = [];
  this._values = [];
  this._lastKey = NaN;
  this._lastIndex = -1;
}
NgMapShim.prototype = {
  _idx: function(key) {
    if (key !== this._lastKey) {
      this._lastKey = key;
      this._lastIndex = this._keys.indexOf(key);
    }
    return this._lastIndex;
  },
  _transformKey: function(key) {
    return isNumberNaN(key) ? nanKey : key;
  },
  get: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx !== -1) {
      return this._values[idx];
    }
  },
  has: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    return idx !== -1;
  },
  set: function(key, value) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx === -1) {
      idx = this._lastIndex = this._keys.length;
    }
    this._keys[idx] = key;
    this._values[idx] = value;

    // Support: IE11
    // Do not `return this` to simulate the partial IE11 implementation
  },
  delete: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx === -1) {
      return false;
    }
    this._keys.splice(idx, 1);
    this._values.splice(idx, 1);
    this._lastKey = NaN;
    this._lastIndex = -1;
    return true;
  }
};

// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
// implementations get more stable, we can reconsider switching to `window.Map` (when available).
var NgMap = NgMapShim;

var $$MapProvider = [/** @this */function() {
  this.$get = [function() {
    return NgMap;
  }];
}];

/**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running AngularJS app
 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */


/**
 * @ngdoc module
 * @name auto
 * @installation
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */

var ARROW_ARG = /^([^(]+?)=>/;
var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var $injectorMinErr = minErr('$injector');

function stringifyFn(fn) {
  return Function.prototype.toString.call(fn);
}

function extractArgs(fn) {
  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
  return args;
}

function anonFn(fn) {
  // For anonymous functions, showing at the very least the function signature can help in
  // debugging.
  var args = extractArgs(fn);
  if (args) {
    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
  }
  return 'fn';
}

function annotate(fn, strictDi, name) {
  var $inject,
      argDecl,
      last;

  if (typeof fn === 'function') {
    if (!($inject = fn.$inject)) {
      $inject = [];
      if (fn.length) {
        if (strictDi) {
          if (!isString(name) || !name) {
            name = fn.name || anonFn(fn);
          }
          throw $injectorMinErr('strictdi',
            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
        }
        argDecl = extractArgs(fn);
        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
          arg.replace(FN_ARG, function(all, underscore, name) {
            $inject.push(name);
          });
        });
      }
      fn.$inject = $inject;
    }
  } else if (isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], 'fn');
    $inject = fn.slice(0, last);
  } else {
    assertArgFn(fn, 'fn', true);
  }
  return $inject;
}

///////////////////////////////////////

/**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * ## Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ### Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ### `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ### Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */

/**
 * @ngdoc property
 * @name $injector#modules
 * @type {Object}
 * @description
 * A hash containing all the modules that have been loaded into the
 * $injector.
 *
 * You can use this property to find out information about a module via the
 * {@link angular.Module#info `myModule.info(...)`} method.
 *
 * For example:
 *
 * ```
 * var info = $injector.modules['ngAnimate'].info();
 * ```
 *
 * **Do not use this property to attempt to modify the modules after the application
 * has been bootstrapped.**
 */


/**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */

/**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */

/**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */

/**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */

/**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * #### Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * #### The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * #### The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */
/**
 * @ngdoc method
 * @name $injector#loadNewModules
 *
 * @description
 *
 * **This is a dangerous API, which you use at your own risk!**
 *
 * Add the specified modules to the current injector.
 *
 * This method will add each of the injectables to the injector and execute all of the config and run
 * blocks for each module passed to the method.
 *
 * If a module has already been loaded into the injector then it will not be loaded again.
 *
 * * The application developer is responsible for loading the code containing the modules; and for
 * ensuring that lazy scripts are not downloaded and executed more often that desired.
 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
 * * Modules cannot be unloaded.
 *
 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
 * into the injector, which may indicate whether the script has been executed already.
 *
 * @example
 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
 *
 * ```javascript
 * app.factory('loadModule', function($injector) {
 *   return function loadModule(moduleName, bundleUrl) {
 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
 *   };
 * })
 * ```
 *
 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 */


/**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
 *      will be able to modify or replace the implementation of another service.
 *
 * See the individual methods for more information and examples.
 */

/**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * It is possible to inject other providers into the provider function,
 * but the injected provider must have been defined before the one that requires it.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */

/**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is a factory
 * function that returns an instance instantiated by the injector from the service constructor
 * function.
 *
 * Internally it looks a bit like this:
 *
 * ```
 * {
 *   $get: function() {
 *     return $injector.instantiate(constructor);
 *   }
 * }
 * ```
 *
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function. This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**. That also means it is not possible to inject other services into a value service.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
 * possible to inject other services into a constant.
 *
 * But unlike {@link auto.$provide#value value}, a constant can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
 * intercepts the creation of a service, allowing it to override or modify the behavior of the
 * service. The return value of the decorator function may be the original service, or a new service
 * that replaces (or wraps and delegates to) the original service.
 *
 * You can find out more about using decorators in the {@link guide/decorators} guide.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    provided and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */


function createInjector(modulesToLoad, strictDi) {
  strictDi = (strictDi === true);
  var INSTANTIATING = {},
      providerSuffix = 'Provider',
      path = [],
      loadedModules = new NgMap(),
      providerCache = {
        $provide: {
            provider: supportObject(provider),
            factory: supportObject(factory),
            service: supportObject(service),
            value: supportObject(value),
            constant: supportObject(constant),
            decorator: decorator
          }
      },
      providerInjector = (providerCache.$injector =
          createInternalInjector(providerCache, function(serviceName, caller) {
            if (angular.isString(caller)) {
              path.push(caller);
            }
            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
          })),
      instanceCache = {},
      protoInstanceInjector =
          createInternalInjector(instanceCache, function(serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(
                provider.$get, provider, undefined, serviceName);
          }),
      instanceInjector = protoInstanceInjector;

  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
  instanceInjector.modules = providerInjector.modules = createMap();
  var runBlocks = loadModules(modulesToLoad);
  instanceInjector = protoInstanceInjector.get('$injector');
  instanceInjector.strictDi = strictDi;
  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });

  instanceInjector.loadNewModules = function(mods) {
    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
  };


  return instanceInjector;

  ////////////////////////////////////
  // $provider
  ////////////////////////////////////

  function supportObject(delegate) {
    return function(key, value) {
      if (isObject(key)) {
        forEach(key, reverseParams(delegate));
      } else {
        return delegate(key, value);
      }
    };
  }

  function provider(name, provider_) {
    assertNotHasOwnProperty(name, 'service');
    if (isFunction(provider_) || isArray(provider_)) {
      provider_ = providerInjector.instantiate(provider_);
    }
    if (!provider_.$get) {
      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
    }
    return (providerCache[name + providerSuffix] = provider_);
  }

  function enforceReturnValue(name, factory) {
    return /** @this */ function enforcedReturnValue() {
      var result = instanceInjector.invoke(factory, this);
      if (isUndefined(result)) {
        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
      }
      return result;
    };
  }

  function factory(name, factoryFn, enforce) {
    return provider(name, {
      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
    });
  }

  function service(name, constructor) {
    return factory(name, ['$injector', function($injector) {
      return $injector.instantiate(constructor);
    }]);
  }

  function value(name, val) { return factory(name, valueFn(val), false); }

  function constant(name, value) {
    assertNotHasOwnProperty(name, 'constant');
    providerCache[name] = value;
    instanceCache[name] = value;
  }

  function decorator(serviceName, decorFn) {
    var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;

    origProvider.$get = function() {
      var origInstance = instanceInjector.invoke(orig$get, origProvider);
      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
    };
  }

  ////////////////////////////////////
  // Module Loading
  ////////////////////////////////////
  function loadModules(modulesToLoad) {
    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
    var runBlocks = [], moduleFn;
    forEach(modulesToLoad, function(module) {
      if (loadedModules.get(module)) return;
      loadedModules.set(module, true);

      function runInvokeQueue(queue) {
        var i, ii;
        for (i = 0, ii = queue.length; i < ii; i++) {
          var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);

          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
        }
      }

      try {
        if (isString(module)) {
          moduleFn = angularModule(module);
          instanceInjector.modules[module] = moduleFn;
          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
          runInvokeQueue(moduleFn._invokeQueue);
          runInvokeQueue(moduleFn._configBlocks);
        } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else {
          assertArgFn(module, 'module');
        }
      } catch (e) {
        if (isArray(module)) {
          module = module[module.length - 1];
        }
        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
          // Safari & FF's stack traces don't contain error.message content
          // unlike those of Chrome and IE
          // So if stack doesn't contain message, we create a new string that contains both.
          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
          // eslint-disable-next-line no-ex-assign
          e = e.message + '\n' + e.stack;
        }
        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
                  module, e.stack || e.message || e);
      }
    });
    return runBlocks;
  }

  ////////////////////////////////////
  // internal Injector
  ////////////////////////////////////

  function createInternalInjector(cache, factory) {

    function getService(serviceName, caller) {
      if (cache.hasOwnProperty(serviceName)) {
        if (cache[serviceName] === INSTANTIATING) {
          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
                    serviceName + ' <- ' + path.join(' <- '));
        }
        return cache[serviceName];
      } else {
        try {
          path.unshift(serviceName);
          cache[serviceName] = INSTANTIATING;
          cache[serviceName] = factory(serviceName, caller);
          return cache[serviceName];
        } catch (err) {
          if (cache[serviceName] === INSTANTIATING) {
            delete cache[serviceName];
          }
          throw err;
        } finally {
          path.shift();
        }
      }
    }


    function injectionArgs(fn, locals, serviceName) {
      var args = [],
          $inject = createInjector.$$annotate(fn, strictDi, serviceName);

      for (var i = 0, length = $inject.length; i < length; i++) {
        var key = $inject[i];
        if (typeof key !== 'string') {
          throw $injectorMinErr('itkn',
                  'Incorrect injection token! Expected service name as string, got {0}', key);
        }
        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
                                                         getService(key, serviceName));
      }
      return args;
    }

    function isClass(func) {
      // Support: IE 9-11 only
      // IE 9-11 do not support classes and IE9 leaks with the code below.
      if (msie || typeof func !== 'function') {
        return false;
      }
      var result = func.$$ngIsClass;
      if (!isBoolean(result)) {
        result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
      }
      return result;
    }

    function invoke(fn, self, locals, serviceName) {
      if (typeof locals === 'string') {
        serviceName = locals;
        locals = null;
      }

      var args = injectionArgs(fn, locals, serviceName);
      if (isArray(fn)) {
        fn = fn[fn.length - 1];
      }

      if (!isClass(fn)) {
        // http://jsperf.com/angularjs-invoke-apply-vs-switch
        // #5388
        return fn.apply(self, args);
      } else {
        args.unshift(null);
        return new (Function.prototype.bind.apply(fn, args))();
      }
    }


    function instantiate(Type, locals, serviceName) {
      // Check if Type is annotated and use just the given function at n-1 as parameter
      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
      var args = injectionArgs(Type, locals, serviceName);
      // Empty object at position 0 is ignored for invocation with `new`, but required.
      args.unshift(null);
      return new (Function.prototype.bind.apply(ctor, args))();
    }


    return {
      invoke: invoke,
      instantiate: instantiate,
      get: getService,
      annotate: createInjector.$$annotate,
      has: function(name) {
        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
      }
    };
  }
}

createInjector.$$annotate = annotate;

/**
 * @ngdoc provider
 * @name $anchorScrollProvider
 * @this
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */
function $AnchorScrollProvider() {

  var autoScrollingEnabled = true;

  /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */
  this.disableAutoScrolling = function() {
    autoScrollingEnabled = false;
  };

  /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample" name="anchor-scroll">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */
  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
    var document = $window.document;

    // Helper function to get first anchor from a NodeList
    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
    //  and working in all supported browsers.)
    function getFirstAnchor(list) {
      var result = null;
      Array.prototype.some.call(list, function(element) {
        if (nodeName_(element) === 'a') {
          result = element;
          return true;
        }
      });
      return result;
    }

    function getYOffset() {

      var offset = scroll.yOffset;

      if (isFunction(offset)) {
        offset = offset();
      } else if (isElement(offset)) {
        var elem = offset[0];
        var style = $window.getComputedStyle(elem);
        if (style.position !== 'fixed') {
          offset = 0;
        } else {
          offset = elem.getBoundingClientRect().bottom;
        }
      } else if (!isNumber(offset)) {
        offset = 0;
      }

      return offset;
    }

    function scrollTo(elem) {
      if (elem) {
        elem.scrollIntoView();

        var offset = getYOffset();

        if (offset) {
          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
          // top of the viewport.
          //
          // IF the number of pixels from the top of `elem` to the end of the page's content is less
          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
          // way down the page.
          //
          // This is often the case for elements near the bottom of the page.
          //
          // In such cases we do not need to scroll the whole `offset` up, just the difference between
          // the top of the element and the offset, which is enough to align the top of `elem` at the
          // desired position.
          var elemTop = elem.getBoundingClientRect().top;
          $window.scrollBy(0, elemTop - offset);
        }
      } else {
        $window.scrollTo(0, 0);
      }
    }

    function scroll(hash) {
      // Allow numeric hashes
      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
      var elm;

      // empty hash, scroll to the top of the page
      if (!hash) scrollTo(null);

      // element with given id
      else if ((elm = document.getElementById(hash))) scrollTo(elm);

      // first anchor with given name :-D
      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

      // no element and hash === 'top', scroll to the top of the page
      else if (hash === 'top') scrollTo(null);
    }

    // does not scroll when user clicks on anchor link that is currently on
    // (no url change, no $location.hash() change), browser native does scroll
    if (autoScrollingEnabled) {
      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
        function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;

          jqLiteDocumentLoaded(function() {
            $rootScope.$evalAsync(scroll);
          });
        });
    }

    return scroll;
  }];
}

var $animateMinErr = minErr('$animate');
var ELEMENT_NODE = 1;
var NG_ANIMATE_CLASSNAME = 'ng-animate';

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function extractElementNode(element) {
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function splitClasses(classes) {
  if (isString(classes)) {
    classes = classes.split(' ');
  }

  // Use createMap() to prevent class assumptions involving property names in
  // Object.prototype
  var obj = createMap();
  forEach(classes, function(klass) {
    // sometimes the split leaves empty string values
    // incase extra spaces were applied to the options
    if (klass.length) {
      obj[klass] = true;
    }
  });
  return obj;
}

// if any other type of options value besides an Object value is
// passed into the $animate.method() animation then this helper code
// will be run which will ignore it. While this patch is not the
// greatest solution to this, a lot of existing plugins depend on
// $animate to either call the callback (< 1.2) or return a promise
// that can be changed. This helper function ensures that the options
// are wiped clean incase a callback function is provided.
function prepareAnimateOptions(options) {
  return isObject(options)
      ? options
      : {};
}

var $$CoreAnimateJsProvider = /** @this */ function() {
  this.$get = noop;
};

// this is prefixed with Core since it conflicts with
// the animateQueueProvider defined in ngAnimate/animateQueue.js
var $$CoreAnimateQueueProvider = /** @this */ function() {
  var postDigestQueue = new NgMap();
  var postDigestElements = [];

  this.$get = ['$$AnimateRunner', '$rootScope',
       function($$AnimateRunner,   $rootScope) {
    return {
      enabled: noop,
      on: noop,
      off: noop,
      pin: noop,

      push: function(element, event, options, domOperation) {
        if (domOperation) {
          domOperation();
        }

        options = options || {};
        if (options.from) {
          element.css(options.from);
        }
        if (options.to) {
          element.css(options.to);
        }

        if (options.addClass || options.removeClass) {
          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
        }

        var runner = new $$AnimateRunner();

        // since there are no animations to run the runner needs to be
        // notified that the animation call is complete.
        runner.complete();
        return runner;
      }
    };


    function updateData(data, classes, value) {
      var changed = false;
      if (classes) {
        classes = isString(classes) ? classes.split(' ') :
                  isArray(classes) ? classes : [];
        forEach(classes, function(className) {
          if (className) {
            changed = true;
            data[className] = value;
          }
        });
      }
      return changed;
    }

    function handleCSSClassChanges() {
      forEach(postDigestElements, function(element) {
        var data = postDigestQueue.get(element);
        if (data) {
          var existing = splitClasses(element.attr('class'));
          var toAdd = '';
          var toRemove = '';
          forEach(data, function(status, className) {
            var hasClass = !!existing[className];
            if (status !== hasClass) {
              if (status) {
                toAdd += (toAdd.length ? ' ' : '') + className;
              } else {
                toRemove += (toRemove.length ? ' ' : '') + className;
              }
            }
          });

          forEach(element, function(elm) {
            if (toAdd) {
              jqLiteAddClass(elm, toAdd);
            }
            if (toRemove) {
              jqLiteRemoveClass(elm, toRemove);
            }
          });
          postDigestQueue.delete(element);
        }
      });
      postDigestElements.length = 0;
    }


    function addRemoveClassesPostDigest(element, add, remove) {
      var data = postDigestQueue.get(element) || {};

      var classesAdded = updateData(data, add, true);
      var classesRemoved = updateData(data, remove, false);

      if (classesAdded || classesRemoved) {

        postDigestQueue.set(element, data);
        postDigestElements.push(element);

        if (postDigestElements.length === 1) {
          $rootScope.$$postDigest(handleCSSClassChanges);
        }
      }
    }
  }];
};

/**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */
var $AnimateProvider = ['$provide', /** @this */ function($provide) {
  var provider = this;
  var classNameFilter = null;
  var customFilter = null;

  this.$$registeredAnimations = Object.create(null);

   /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */
  this.register = function(name, factory) {
    if (name && name.charAt(0) !== '.') {
      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
    }

    var key = name + '-animation';
    provider.$$registeredAnimations[name.substr(1)] = key;
    $provide.factory(key, factory);
  };

  /**
   * @ngdoc method
   * @name $animateProvider#customFilter
   *
   * @description
   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
   * determine if an animation is allowed or not. When no filter is specified (the default), no
   * animation will be blocked. Setting the `customFilter` value will only allow animations for
   * which the filter function's return value is truthy.
   *
   * This allows to easily create arbitrarily complex rules for filtering animations, such as
   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
   * Filtering animations can also boost performance for low-powered devices, as well as
   * applications containing a lot of structural operations.
   *
   * <div class="alert alert-success">
   *   **Best Practice:**
   *   Keep the filtering function as lean as possible, because it will be called for each DOM
   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
   *   directives that support animations.
   *   Performing computationally expensive or time-consuming operations on each call of the
   *   filtering function can make your animations sluggish.
   * </div>
   *
   * **Note:** If present, `customFilter` will be checked before
   * {@link $animateProvider#classNameFilter classNameFilter}.
   *
   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
   *   If a falsy value is returned, no animation will be performed. The function will be called
   *   with the following arguments:
   *   - **node** `{DOMElement}` - The DOM element to be animated.
   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
   *     etc).
   *   - **options** `{Object}` - A collection of options/styles used for the animation.
   * @return {Function} The current filter function or `null` if there is none set.
   */
  this.customFilter = function(filterFn) {
    if (arguments.length === 1) {
      customFilter = isFunction(filterFn) ? filterFn : null;
    }

    return customFilter;
  };

  /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   *
   * **Note:** If present, `classNameFilter` will be checked after
   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
   * false, `classNameFilter` will not be checked.
   *
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */
  this.classNameFilter = function(expression) {
    if (arguments.length === 1) {
      classNameFilter = (expression instanceof RegExp) ? expression : null;
      if (classNameFilter) {
        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
        if (reservedRegex.test(classNameFilter.toString())) {
          classNameFilter = null;
          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
        }
      }
    }
    return classNameFilter;
  };

  this.$get = ['$$animateQueue', function($$animateQueue) {
    function domInsert(element, parentElement, afterElement) {
      // if for some reason the previous element was removed
      // from the dom sometime before this code runs then let's
      // just stick to using the parent element as the anchor
      if (afterElement) {
        var afterNode = extractElementNode(afterElement);
        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
          afterElement = null;
        }
      }
      if (afterElement) {
        afterElement.after(element);
      } else {
        parentElement.prepend(element);
      }
    }

    /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */
    return {
      // we don't call it directly since non-existant arguments may
      // be interpreted as null within the sub enabled function

      /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * <div class="alert alert-warning">
       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
       * However, there are two exceptions:
       *
       * <ul>
       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
       *   the `setClass` event, but if it either removes or adds classes,
       *   it will fire `animate` instead.</li>
       * </ul>
       *
       * </div>
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered.
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       * * `data` - an object with these properties:
       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
       *
       * Note that the callback does not trigger a scope digest. Wrap your call into a
       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
       */
      on: $$animateQueue.on,

      /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove listeners for all animation events from the container element
       * $animate.off(container);
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `callback` that is set
       * // to listen for `enter` on the given `container` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
       * addClass, removeClass, etc...), or the container element. If it is the element, all other
       * arguments are ignored.
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */
      off: $$animateQueue.off,

      /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */
      pin: $$animateQueue.pin,

      /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */
      enabled: $$animateQueue.enabled,

      /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation and applies the end state of the animation.
       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
       * adding the element to the DOM.
       *
       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
       *
       * @example
        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
          <file name="app.js">
            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
              templateUrl: 'template.html',
              controller: function($element, $animate) {
                this.runner = null;

                this.addClass = function() {
                  this.runner = $animate.addClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.removeClass = function() {
                  this.runner = $animate.removeClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.cancel = function() {
                  $animate.cancel(this.runner);
                };
              }
            });
          </file>
          <file name="template.html">
            <p>
              <button id="add" ng-click="$ctrl.addClass()">Add</button>
              <button ng-click="$ctrl.removeClass()">Remove</button>
              <br>
              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
              <br>
              <div id="target">CSS-Animated Text</div>
            </p>
          </file>
          <file name="index.html">
            <cancel-example></cancel-example>
          </file>
          <file name="style.css">
            .red-add, .red-remove {
              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
            }

            .red,
            .red-add.red-add-active {
              color: #FF0000;
              font-size: 40px;
            }

            .red-remove.red-remove-active {
              font-size: 10px;
              color: black;
            }

          </file>
        </example>
       */
      cancel: function(runner) {
        if (runner.cancel) {
          runner.cancel();
        }
      },

      /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      enter: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
      },

      /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      move: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
      },

      /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      leave: function(element, options) {
        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
          element.remove();
        });
      },

      /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} animationRunner the animation runner
       */
      addClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addclass, className);
        return $$animateQueue.push(element, 'addClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      removeClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.removeClass = mergeClasses(options.removeClass, className);
        return $$animateQueue.push(element, 'removeClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      setClass: function(element, add, remove, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addClass, add);
        options.removeClass = mergeClasses(options.removeClass, remove);
        return $$animateQueue.push(element, 'setClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
       * style in `to`, the style in `from` is applied immediately, and no animation is run.
       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
       * method (or as part of the `options` parameter):
       *
       * ```js
       * ngModule.animation('.my-inline-animation', function() {
       *   return {
       *     animate : function(element, from, to, done, options) {
       *       //animation
       *       done();
       *     }
       *   }
       * });
       * ```
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be applied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      animate: function(element, from, to, className, options) {
        options = prepareAnimateOptions(options);
        options.from = options.from ? extend(options.from, from) : from;
        options.to   = options.to   ? extend(options.to, to)     : to;

        className = className || 'ng-inline-animate';
        options.tempClasses = mergeClasses(options.tempClasses, className);
        return $$animateQueue.push(element, 'animate', options);
      }
    };
  }];
}];

var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
  this.$get = ['$$rAF', function($$rAF) {
    var waitQueue = [];

    function waitForTick(fn) {
      waitQueue.push(fn);
      if (waitQueue.length > 1) return;
      $$rAF(function() {
        for (var i = 0; i < waitQueue.length; i++) {
          waitQueue[i]();
        }
        waitQueue = [];
      });
    }

    return function() {
      var passed = false;
      waitForTick(function() {
        passed = true;
      });
      return function(callback) {
        if (passed) {
          callback();
        } else {
          waitForTick(callback);
        }
      };
    };
  }];
};

var $$AnimateRunnerFactoryProvider = /** @this */ function() {
  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {

    var INITIAL_STATE = 0;
    var DONE_PENDING_STATE = 1;
    var DONE_COMPLETE_STATE = 2;

    AnimateRunner.chain = function(chain, callback) {
      var index = 0;

      next();
      function next() {
        if (index === chain.length) {
          callback(true);
          return;
        }

        chain[index](function(response) {
          if (response === false) {
            callback(false);
            return;
          }
          index++;
          next();
        });
      }
    };

    AnimateRunner.all = function(runners, callback) {
      var count = 0;
      var status = true;
      forEach(runners, function(runner) {
        runner.done(onProgress);
      });

      function onProgress(response) {
        status = status && response;
        if (++count === runners.length) {
          callback(status);
        }
      }
    };

    function AnimateRunner(host) {
      this.setHost(host);

      var rafTick = $$animateAsyncRun();
      var timeoutTick = function(fn) {
        $timeout(fn, 0, false);
      };

      this._doneCallbacks = [];
      this._tick = function(fn) {
        if ($$isDocumentHidden()) {
          timeoutTick(fn);
        } else {
          rafTick(fn);
        }
      };
      this._state = 0;
    }

    AnimateRunner.prototype = {
      setHost: function(host) {
        this.host = host || {};
      },

      done: function(fn) {
        if (this._state === DONE_COMPLETE_STATE) {
          fn();
        } else {
          this._doneCallbacks.push(fn);
        }
      },

      progress: noop,

      getPromise: function() {
        if (!this.promise) {
          var self = this;
          this.promise = $q(function(resolve, reject) {
            self.done(function(status) {
              if (status === false) {
                reject();
              } else {
                resolve();
              }
            });
          });
        }
        return this.promise;
      },

      then: function(resolveHandler, rejectHandler) {
        return this.getPromise().then(resolveHandler, rejectHandler);
      },

      'catch': function(handler) {
        return this.getPromise()['catch'](handler);
      },

      'finally': function(handler) {
        return this.getPromise()['finally'](handler);
      },

      pause: function() {
        if (this.host.pause) {
          this.host.pause();
        }
      },

      resume: function() {
        if (this.host.resume) {
          this.host.resume();
        }
      },

      end: function() {
        if (this.host.end) {
          this.host.end();
        }
        this._resolve(true);
      },

      cancel: function() {
        if (this.host.cancel) {
          this.host.cancel();
        }
        this._resolve(false);
      },

      complete: function(response) {
        var self = this;
        if (self._state === INITIAL_STATE) {
          self._state = DONE_PENDING_STATE;
          self._tick(function() {
            self._resolve(response);
          });
        }
      },

      _resolve: function(response) {
        if (this._state !== DONE_COMPLETE_STATE) {
          forEach(this._doneCallbacks, function(fn) {
            fn(response);
          });
          this._doneCallbacks.length = 0;
          this._state = DONE_COMPLETE_STATE;
        }
      }
    };

    return AnimateRunner;
  }];
};

/* exported $CoreAnimateCssProvider */

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 * @this
 *
 * @description
 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
 * then the `$animateCss` service will actually perform animations.
 *
 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
 */
var $CoreAnimateCssProvider = function() {
  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {

    return function(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = copy(options);
      }

      // there is no point in applying the styles since
      // there is no animation that goes on at all in
      // this version of $animateCss.
      if (options.cleanupStyles) {
        options.from = options.to = null;
      }

      if (options.from) {
        element.css(options.from);
        options.from = null;
      }

      var closed, runner = new $$AnimateRunner();
      return {
        start: run,
        end: run
      };

      function run() {
        $$rAF(function() {
          applyAnimationContents();
          if (!closed) {
            runner.complete();
          }
          closed = true;
        });
        return runner;
      }

      function applyAnimationContents() {
        if (options.addClass) {
          element.addClass(options.addClass);
          options.addClass = null;
        }
        if (options.removeClass) {
          element.removeClass(options.removeClass);
          options.removeClass = null;
        }
        if (options.to) {
          element.css(options.to);
          options.to = null;
        }
      }
    };
  }];
};

/* global getHash: true, stripHash: false */

function getHash(url) {
  var index = url.indexOf('#');
  return index === -1 ? '' : url.substr(index);
}

function trimEmptyHash(url) {
  return url.replace(/#$/, '');
}

/**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */
/**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */
function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
  var self = this,
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {},
      taskTracker = $$taskTrackerFactory($log);

  self.isMock = false;

  //////////////////////////////////////////////////////////////
  // Task-tracking API
  //////////////////////////////////////////////////////////////

  // TODO(vojta): remove this temporary api
  self.$$completeOutstandingRequest = taskTracker.completeTask;
  self.$$incOutstandingRequestCount = taskTracker.incTaskCount;

  // TODO(vojta): prefix this method with $$ ?
  self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;

  //////////////////////////////////////////////////////////////
  // URL API
  //////////////////////////////////////////////////////////////

  var cachedState, lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find('base'),
      pendingLocation = null,
      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
        try {
          return history.state;
        } catch (e) {
          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
        }
      };

  cacheState();

  /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of `location.href` (with a
   * trailing `#` stripped of if the hash is empty).
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
   * `location.href`/`location.replace` is used.
   * Returns its own instance to allow chaining.
   *
   * NOTE: this api is intended for use only by the `$location` service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state State object to use with `pushState`/`replaceState`
   */
  self.url = function(url, replace, state) {
    // In modern browsers `history.state` is `null` by default; treating it separately
    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
    if (isUndefined(state)) {
      state = null;
    }

    // Android Browser BFCache causes location, history reference to become stale.
    if (location !== window.location) location = window.location;
    if (history !== window.history) history = window.history;

    // setter
    if (url) {
      var sameState = lastHistoryState === state;

      // Don't change anything if previous and current URLs and states match. This also prevents
      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
      // See https://github.com/angular/angular.js/commit/ffb2701
      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
        return self;
      }
      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
      lastBrowserUrl = url;
      lastHistoryState = state;
      // Don't use history API if only the hash changed
      // due to a bug in IE10/IE11 which leads
      // to not firing a `hashchange` nor `popstate` event
      // in some cases (see #9143).
      if ($sniffer.history && (!sameBase || !sameState)) {
        history[replace ? 'replaceState' : 'pushState'](state, '', url);
        cacheState();
      } else {
        if (!sameBase) {
          pendingLocation = url;
        }
        if (replace) {
          location.replace(url);
        } else if (!sameBase) {
          location.href = url;
        } else {
          location.hash = getHash(url);
        }
        if (location.href !== url) {
          pendingLocation = url;
        }
      }
      if (pendingLocation) {
        pendingLocation = url;
      }
      return self;
    // getter
    } else {
      // - pendingLocation is needed as browsers don't allow to read out
      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
      //   https://openradar.appspot.com/22186109).
      return trimEmptyHash(pendingLocation || location.href);
    }
  };

  /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */
  self.state = function() {
    return cachedState;
  };

  var urlChangeListeners = [],
      urlChangeInit = false;

  function cacheStateAndFireUrlChange() {
    pendingLocation = null;
    fireStateOrUrlChange();
  }

  // This variable should be used *only* inside the cacheState function.
  var lastCachedState = null;
  function cacheState() {
    // This should be the only place in $browser where `history.state` is read.
    cachedState = getCurrentState();
    cachedState = isUndefined(cachedState) ? null : cachedState;

    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
    if (equals(cachedState, lastCachedState)) {
      cachedState = lastCachedState;
    }

    lastCachedState = cachedState;
    lastHistoryState = cachedState;
  }

  function fireStateOrUrlChange() {
    var prevLastHistoryState = lastHistoryState;
    cacheState();

    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
      return;
    }

    lastBrowserUrl = self.url();
    lastHistoryState = cachedState;
    forEach(urlChangeListeners, function(listener) {
      listener(self.url(), cachedState);
    });
  }

  /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of AngularJS:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */
  self.onUrlChange = function(callback) {
    // TODO(vojta): refactor to use node's syntax for events
    if (!urlChangeInit) {
      // We listen on both (hashchange/popstate) when available, as some browsers don't
      // fire popstate when user changes the address bar and don't fire hashchange when url
      // changed by push/replaceState

      // html5 history api - popstate event
      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
      // hashchange event
      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

      urlChangeInit = true;
    }

    urlChangeListeners.push(callback);
    return callback;
  };

  /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */
  self.$$applicationDestroyed = function() {
    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
  };

  /**
   * Checks whether the url has changed outside of AngularJS.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */
  self.$$checkUrlChange = fireStateOrUrlChange;

  //////////////////////////////////////////////////////////////
  // Misc API
  //////////////////////////////////////////////////////////////

  /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */
  self.baseHref = function() {
    var href = baseElement.attr('href');
    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
  };

  /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */
  self.defer = function(fn, delay, taskType) {
    var timeoutId;

    delay = delay || 0;
    taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;

    taskTracker.incTaskCount(taskType);
    timeoutId = setTimeout(function() {
      delete pendingDeferIds[timeoutId];
      taskTracker.completeTask(fn, taskType);
    }, delay);
    pendingDeferIds[timeoutId] = taskType;

    return timeoutId;
  };


  /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */
  self.defer.cancel = function(deferId) {
    if (pendingDeferIds.hasOwnProperty(deferId)) {
      var taskType = pendingDeferIds[deferId];
      delete pendingDeferIds[deferId];
      clearTimeout(deferId);
      taskTracker.completeTask(noop, taskType);
      return true;
    }
    return false;
  };

}

/** @this */
function $BrowserProvider() {
  this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory',
       function($window,   $log,   $sniffer,   $document,   $$taskTrackerFactory) {
    return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
  }];
}

/**
 * @ngdoc service
 * @name $cacheFactory
 * @this
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp" name="cache-factory">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if (angular.isUndefined($scope.cache.get(key))) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */
function $CacheFactoryProvider() {

  this.$get = function() {
    var caches = {};

    function cacheFactory(cacheId, options) {
      if (cacheId in caches) {
        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
      }

      var size = 0,
          stats = extend({}, options, {id: cacheId}),
          data = createMap(),
          capacity = (options && options.capacity) || Number.MAX_VALUE,
          lruHash = createMap(),
          freshEnd = null,
          staleEnd = null;

      /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
       * directive to cache templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */
      return (caches[cacheId] = {

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */
        put: function(key, value) {
          if (isUndefined(value)) return;
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});

            refresh(lruEntry);
          }

          if (!(key in data)) size++;
          data[key] = value;

          if (size > capacity) {
            this.remove(staleEnd.key);
          }

          return value;
        },

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */
        get: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            refresh(lruEntry);
          }

          return data[key];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */
        remove: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
            link(lruEntry.n,lruEntry.p);

            delete lruHash[key];
          }

          if (!(key in data)) return;

          delete data[key];
          size--;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */
        removeAll: function() {
          data = createMap();
          size = 0;
          lruHash = createMap();
          freshEnd = staleEnd = null;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */
        destroy: function() {
          data = null;
          stats = null;
          lruHash = null;
          delete caches[cacheId];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */
        info: function() {
          return extend({}, stats, {size: size});
        }
      });


      /**
       * makes the `entry` the freshEnd of the LRU linked list
       */
      function refresh(entry) {
        if (entry !== freshEnd) {
          if (!staleEnd) {
            staleEnd = entry;
          } else if (staleEnd === entry) {
            staleEnd = entry.n;
          }

          link(entry.n, entry.p);
          link(entry, freshEnd);
          freshEnd = entry;
          freshEnd.n = null;
        }
      }


      /**
       * bidirectionally links two entries of the LRU linked list
       */
      function link(nextEntry, prevEntry) {
        if (nextEntry !== prevEntry) {
          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
        }
      }
    }


  /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */
    cacheFactory.info = function() {
      var info = {};
      forEach(caches, function(cache, cacheId) {
        info[cacheId] = cache.info();
      });
      return info;
    };


  /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */
    cacheFactory.get = function(cacheId) {
      return caches[cacheId];
    };


    return cacheFactory;
  };
}

/**
 * @ngdoc service
 * @name $templateCache
 * @this
 *
 * @description
 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
 * {@link ng.$cacheFactory $cacheFactory}.
 *
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
 * or by consuming the `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
 * element with {@link ngApp} attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your component:
 * ```js
 * myApp.component('myComponent', {
 *    templateUrl: 'templateId.html'
 * });
 * ```
 *
 * or get it via the `$templateCache` service:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 */
function $TemplateCacheProvider() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('templates');
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables like document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */


/**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
 * that defines the directive properties, or just the `postLink` function (all other properties will have
 * the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       {@link $compile#-priority- priority}: 0,
 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       {@link $compile#-transclude- transclude}: false,
 *       {@link $compile#-restrict- restrict}: 'A',
 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
 *       {@link $compile#-scope- scope}: false,
 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
 *       {@link $compile#-bindtocontroller- bindToController}: false,
 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       {@link $compile#-multielement- multiElement}: false,
 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
 *         return {
 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // {@link $compile#-link- link}: {
 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 * ### Life-cycle hooks
 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
 * directive:
 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
 *   this element). This is a good place to put initialization code for your controller.
 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
 *   also be called when your bindings are initialized.
 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
 *   changes. Any actions that you wish to take in response to the changes that you detect must be
 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
 *   components will have their `$onDestroy()` hook called before child components.
 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
 *   suspended until that occurs.
 *
 * #### Comparison with life-cycle hooks in the new Angular
 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
 *
 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
 *   In Angular you can only define hooks on the prototype of the Component class.
 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
 *   `ngDoCheck` in Angular.
 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
 *   propagated throughout the application.
 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
 *   error or do nothing depending upon the state of `enableProdMode()`.
 *
 * #### Life-cycle hook examples
 *
 * This example shows how you can check for mutations to a Date object even though the identity of the object
 * has not changed.
 *
 * <example name="doCheckDateExample" module="do-check-module">
 *   <file name="app.js">
 *     angular.module('do-check-module', [])
 *       .component('app', {
 *         template:
 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
 *           'Date: {{ $ctrl.date }}' +
 *           '<test date="$ctrl.date"></test>',
 *         controller: function() {
 *           this.date = new Date();
 *           this.month = this.date.getMonth();
 *           this.updateDate = function() {
 *             this.date.setMonth(this.month);
 *           };
 *         }
 *       })
 *       .component('test', {
 *         bindings: { date: '<' },
 *         template:
 *           '<pre>{{ $ctrl.log | json }}</pre>',
 *         controller: function() {
 *           var previousValue;
 *           this.log = [];
 *           this.$doCheck = function() {
 *             var currentValue = this.date && this.date.valueOf();
 *             if (previousValue !== currentValue) {
 *               this.log.push('doCheck: date mutated: ' + this.date);
 *               previousValue = currentValue;
 *             }
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="index.html">
 *     <app></app>
 *   </file>
 * </example>
 *
 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
 * arrays or objects can have a negative impact on your application performance)
 *
 * <example name="doCheckArrayExample" module="do-check-module">
 *   <file name="index.html">
 *     <div ng-init="items = []">
 *       <button ng-click="items.push(items.length)">Add Item</button>
 *       <button ng-click="items = []">Reset Items</button>
 *       <pre>{{ items }}</pre>
 *       <test items="items"></test>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *      angular.module('do-check-module', [])
 *        .component('test', {
 *          bindings: { items: '<' },
 *          template:
 *            '<pre>{{ $ctrl.log | json }}</pre>',
 *          controller: function() {
 *            this.log = [];
 *
 *            this.$doCheck = function() {
 *              if (this.items_ref !== this.items) {
 *                this.log.push('doCheck: items changed');
 *                this.items_ref = this.items;
 *              }
 *              if (!angular.equals(this.items_clone, this.items)) {
 *                this.log.push('doCheck: items mutated');
 *                this.items_clone = angular.copy(this.items);
 *              }
 *            };
 *          }
 *        });
 *   </file>
 * </example>
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioral (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * The scope property can be `false`, `true`, or an object:
 *
 * * **`false` (default):** No scope will be created for the directive. The directive will use its
 * parent's scope.
 *
 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
 * the directive's element. If multiple directives on the same element request a new scope,
 * only one new scope is created.
 *
 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
 * The 'isolate' scope differs from normal scope in that it does not prototypically
 * inherit from its parent scope. This is useful when creating reusable components, which should not
 * accidentally read or modify data in the parent scope. Note that an isolate scope
 * directive without a `template` or `templateUrl` will not apply the isolate scope
 * to its children elements.
 *
 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
 * directive's element. These local properties are useful for aliasing values for templates. The keys in
 * the object hash map to the name of the property on the isolate scope; the values define how the property
 * is bound to the parent scope, via matching attributes on the directive's element:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
 *   attribute name is assumed to be the same as the local name. Given `<my-component
 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
 *   the directive's scope property `localName` will reflect the interpolated value of `hello
 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
 *   scope. The `name` is read from the parent scope (not the directive's scope).
 *
 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
 *   isn't  optional and doesn't exist, an exception
 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
 *   to the local value, since it will be impossible to sync them back to the parent scope.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   However, if an object literal or an array literal is passed as the binding expression, the
 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
 *   `$watchCollection`}: use `=*` or `=*attr`
 *
  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name.
 *
 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
 *   two caveats:
 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
 *     sets the same value. That means if your bound value is an object, changes to its properties
 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
 *     to the value has changed. In most cases, this should not be of concern, but can be important
 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
 *     If you now change a property of the object in your parent scope, the change will not be
 *     propagated to the isolated scope, because the identity of the object on the parent scope
 *     has not changed. Instead you must assign a new object.
 *
 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
 *   back to the parent. However, it does not make this completely impossible.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   It's also possible to watch the evaluated value shallowly with
 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
 *   via an expression to the parent scope. This can be done by passing a map of local variable names
 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
 *
 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
 * The marker must come after the mode and before the attribute name.
 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
 * This is useful to refine the interface directives provide.
 * One subtle difference between optional and non-optional happens **when the binding attribute is not
 * set**:
 * - the binding is optional: the property will not be defined
 * - the binding is not optional: the property is defined
 *
 * ```js
 *app.directive('testDir', function() {
    return {
      scope: {
        notoptional: '=',
        optional: '=?',
      },
      bindToController: true,
      controller: function() {
        this.$onInit = function() {
          console.log(this.hasOwnProperty('notoptional')) // true
          console.log(this.hasOwnProperty('optional')) // false
        }
      }
    }
  })
 *```
 *
 *
 * ##### Combining directives with different scope defintions
 *
 * In general it's possible to apply more than one directive to one element, but there might be limitations
 * depending on the type of scope required by the directives. The following points will help explain these limitations.
 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
 *
 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
 * * **child scope** + **no scope** =>  Both directives will share one single child scope
 * * **child scope** + **child scope** =>  Both directives will share one single child scope
 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
 * its parent's scope
 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
 * be applied to the same element.
 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
 * cannot be applied to the same element.
 *
 *
 * #### `bindToController`
 * This property is used to bind scope properties directly to the controller. It can be either
 * `true` or an object hash with the same format as the `scope` property.
 *
 * When an isolate scope is used for a directive (see above), `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope.
 *
 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
 * properties. You can access these bindings once they have been initialized by providing a controller method called
 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
 * initialized.
 *
 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
 * scope (useful for component directives).
 *
 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
 *
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and can be accessed by other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
 *    * `scope`: (optional) override the scope.
 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
 *    * `futureParentElement` (optional):
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkingFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
 *      then the default transclusion is provided.
 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` property can be a string, an array or an object:
 * * a **string** containing the name of the directive to pass to the linking function
 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
 * linking function will be an array of controllers in the same order as the names in the `require` property
 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
 * controllers.
 *
 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
 * have been constructed but before `$onInit` is called.
 * If the name of the required controller is the same as the local name (the key), the name can be
 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
 * See the {@link $compileProvider#component} helper for an example of how this can be used.
 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
 * raised (unless no link function is specified and the required controllers are not being bound to the directive
 * controller, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. This is especially
 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace`
 * <div class="alert alert-danger">
 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
 * </div>
 *
 * Specifies what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and
 * stack overflow errors.
 *
 * This can be avoided by manually using $compile in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude` parameter of directive controllers,
 *     see {@link ng.$compile#-controller- the controller section for details}.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element, the entire element or multiple parts of the element contents:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
 *
 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
 *
 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
 *
 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
 *
 * If the element selector is prefixed with a `?` then that slot is optional.
 *
 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
 *
 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
 * injectable into the directive's controller.
 *
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
   ```
   - $rootScope
     - isolate
       - transclusion
   ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
   ```
   - $rootScope
     - transclusion
   - isolate
   ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
 *   to the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample" name="compile">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // configure new 'compile' directive by passing a directive
        // factory function. The factory function injects the '$compile'
        $compileProvider.directive('compile', function($compile) {
          // directive factory creates a link function
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                 // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'AngularJS';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello AngularJS'.
       expect(output.getText()).toBe('Hello AngularJS');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('AngularJS!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to a hash with the key `instance`, which maps to the controller instance;
 *        if given, it will make the controllers available to directives on the compileNode:
 *        ```
 *        {
 *          parent: {
 *            instance: parentControllerInstance
 *          }
 *        }
 *        ```
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non html
 *        elements (e.g. SVG elements). See also the directive.controller property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to $digest which typically is done by
 * AngularJS automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = $compile('<p>{{total}}</p>')(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone via the cloneAttachFn:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>'),
 *         scope = ....;
 *
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       //attach the clone to DOM document at the right place
 *     });
 *
 *     //now we have reference to the cloned DOM via `clonedElement`
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
 *
 * @knownIssue
 *
 * ### Double Compilation
 *
   Double compilation occurs when an already compiled part of the DOM gets
   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
   section on double compilation} for an in-depth explanation and ways to avoid it.

 * @knownIssue

   ### Issues with `replace: true`
 *
 * <div class="alert alert-danger">
 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
 * </div>
 *
 * #### Attribute values are not merged
 *
 * When a `replace` directive encounters the same attribute on the original and the replace node,
 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
 * the `style` attribute.
 * ```html
 * Original Node: <span class="original" style="color: red;"></span>
 * Replace Template: <span class="replaced" style="background: blue;"></span>
 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
 * ```
 *
 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
 *
 * ```html
 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
 * ```
 *
 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
 *
 * #### Directives are not deduplicated before compilation
 *
 * When the original node and the replace template declare the same directive(s), they will be
 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
 * does not deduplicate them. In many cases, this is not noticable, but e.g. {@link ngModel} will
 * attach `$formatters` and `$parsers` twice.
 *
 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
 *
 * #### `transclude: element` in the replace template root can have unexpected effects
 *
 * When the replace template has a directive at the root node that uses
 * {@link $compile#-transclude- `transclude: element`}, e.g.
 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
 * See the following issues:
 *
 * - Incorrect scope on replaced element:
 * [#9837](https://github.com/angular/angular.js/issues/9837)
 * - Different DOM between `template` and `templateUrl`:
 * [#10612](https://github.com/angular/angular.js/issues/14326)
 *
 */

/**
 * @ngdoc directive
 * @name ngProp
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-prop-propname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "propName"):
 *
 *
 * ```html
 * <ANY ng-prop-prop_name="expression">
 * </ANY>
 * ```
 *
 *
 * @description
 * The `ngProp` directive binds an expression to a DOM element property.
 * `ngProp` allows writing to arbitrary properties by including
 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
 * the `value` property.
 *
 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
 *
 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
 * custom elements.
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
 * example, and for binding HTML {@link ngBindHtml} should be used.
 *
 * ## Security
 *
 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
 * malicious code.
 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
 * This means vulnerable properties require their content to be "trusted", based on the
 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
 * this property are trusted as a `RESOURCE_URL`.
 *
 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
 *
 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
 *
 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
 * the {@link $sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist()}
 * and {@link $sceDelegateProvider#resourceUrlBlacklist resourceUrlBlacklist()}.
 *
 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
 *
 * ### HTML Sanitization
 *
 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
 * content.
 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
 * potentially dangerous HTML, e.g. strip non-whitelisted tags and attributes when binding to
 * `innerHTML`.
 *
 * @example
 * ### Binding to different contexts
 *
 * <example name="ngProp" module="exampleNgProp">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         Binding to a property without security context:
 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerText</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... so that actually dangerous content cannot be executed:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Binding to innerHTML with ngSanitize
 *
 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', ['ngSanitize'])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         "Safe" content will be sanitized ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... as will dangerous content:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 */

/** @ngdoc directive
 * @name ngOn
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-on-eventname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "eventName"):
 *
 *
 * ```html
 * <ANY ng-on-event_name="expression">
 * </ANY>
 * ```
 *
 * @description
 * The `ngOn` directive adds an event listener to a DOM element via
 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
 * fired.
 * `ngOn` allows adding listeners for arbitrary events by including
 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
 * when the `drop` event is fired.
 *
 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
 * standards.
 *
 * Another use-case for `ngOn` is listening to
 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
 * fired by
 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `myEvent` must be written as `ng-on-my_event="expression"`.
 *
 * @example
 * ### Bind to built-in DOM events
 *
 * <example name="ngOn" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.clickCount = 0;
 *           this.mouseoverCount = 0;
 *
 *           this.loadingState = 0;
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
 *       <button
 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
 *       clickCount: {{$ctrl.clickCount}}<br>
 *       mouseover: {{$ctrl.mouseoverCount}}
 *
 *       <hr>
 *
 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
 *       <div ng-switch="$ctrl.loadingState">
 *         <span ng-switch-when="0">Image is loading</span>
 *         <span ng-switch-when="-1">Image load error</span>
 *         <span ng-switch-when="1">Image loaded successfully</span>
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Bind to custom DOM events
 *
 * <example name="ngOnCustom" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.eventLog = '';
 *
 *           this.listener = function($event) {
 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
 *           };
 *         }
 *       })
 *       .component('childComponent', {
 *         templateUrl: 'child.html',
 *         controller: function($element) {
 *           this.fireEvent = function() {
 *             var event = new CustomEvent('customtype', { detail: new Date()});
 *
 *             $element[0].dispatchEvent(event);
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
 *     <span>Event log: {{$ctrl.eventLog}}</span>
 *   </file>
 *   <file name="child.html">
      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 */

var $compileMinErr = minErr('$compile');

function UNINITIALIZED_VALUE() {}
var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

/**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */
$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
/** @this */
function $CompileProvider($provide, $$sanitizeUriProvider) {
  var hasDirectives = {},
      Suffix = 'Directive',
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
  // The assumption is that future DOM event attribute names will begin with
  // 'on' and be composed of only English letters.
  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
  var bindingCache = createMap();

  function parseIsolateBindings(scope, directiveName, isController) {
    var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;

    var bindings = createMap();

    forEach(scope, function(definition, scopeName) {
      definition = definition.trim();

      if (definition in bindingCache) {
        bindings[scopeName] = bindingCache[definition];
        return;
      }
      var match = definition.match(LOCAL_REGEXP);

      if (!match) {
        throw $compileMinErr('iscp',
            'Invalid {3} for directive \'{0}\'.' +
            ' Definition: {... {1}: \'{2}\' ...}',
            directiveName, scopeName, definition,
            (isController ? 'controller bindings definition' :
            'isolate scope definition'));
      }

      bindings[scopeName] = {
        mode: match[1][0],
        collection: match[2] === '*',
        optional: match[3] === '?',
        attrName: match[4] || scopeName
      };
      if (match[4]) {
        bindingCache[definition] = bindings[scopeName];
      }
    });

    return bindings;
  }

  function parseDirectiveBindings(directive, directiveName) {
    var bindings = {
      isolateScope: null,
      bindToController: null
    };
    if (isObject(directive.scope)) {
      if (directive.bindToController === true) {
        bindings.bindToController = parseIsolateBindings(directive.scope,
                                                         directiveName, true);
        bindings.isolateScope = {};
      } else {
        bindings.isolateScope = parseIsolateBindings(directive.scope,
                                                     directiveName, false);
      }
    }
    if (isObject(directive.bindToController)) {
      bindings.bindToController =
          parseIsolateBindings(directive.bindToController, directiveName, true);
    }
    if (bindings.bindToController && !directive.controller) {
      // There is no controller
      throw $compileMinErr('noctrl',
            'Cannot bind to controller without directive \'{0}\'s controller.',
            directiveName);
    }
    return bindings;
  }

  function assertValidDirectiveName(name) {
    var letter = name.charAt(0);
    if (!letter || letter !== lowercase(letter)) {
      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
    }
    if (name !== name.trim()) {
      throw $compileMinErr('baddir',
            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
            name);
    }
  }

  function getDirectiveRequire(directive) {
    var require = directive.require || (directive.controller && directive.name);

    if (!isArray(require) && isObject(require)) {
      forEach(require, function(value, key) {
        var match = value.match(REQUIRE_PREFIX_REGEXP);
        var name = value.substring(match[0].length);
        if (!name) require[key] = match[0] + key;
      });
    }

    return require;
  }

  function getDirectiveRestrict(restrict, name) {
    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
      throw $compileMinErr('badrestrict',
          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
          restrict,
          name);
    }

    return restrict || 'EA';
  }

  /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
   *    names and the values are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */
  this.directive = function registerDirective(name, directiveFactory) {
    assertArg(name, 'name');
    assertNotHasOwnProperty(name, 'directive');
    if (isString(name)) {
      assertValidDirectiveName(name);
      assertArg(directiveFactory, 'directiveFactory');
      if (!hasDirectives.hasOwnProperty(name)) {
        hasDirectives[name] = [];
        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
          function($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function(directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = { compile: valueFn(directive) };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = getDirectiveRequire(directive);
                directive.restrict = getDirectiveRestrict(directive.restrict, name);
                directive.$$moduleName = directiveFactory.$$moduleName;
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
      }
      hasDirectives[name].push(directiveFactory);
    } else {
      forEach(name, reverseParams(registerDirective));
    }
    return this;
  };

  /**
   * @ngdoc method
   * @name $compileProvider#component
   * @module ng
   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
   *    or an object map of components where the keys are the names and the values are the component definition objects.
   * @param {Object} options Component definition object (a simplified
   *    {@link ng.$compile#directive-definition-object directive definition object}),
   *    with the following properties (all optional):
   *
   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
   *      registered controller} if passed as a string. An empty `noop` function by default.
   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *      If not present, this will default to be `$ctrl`.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used as the contents of this component.
   *      Empty string by default.
   *
   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used  as the contents of this component.
   *
   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
   *      Component properties are always bound to the component controller and not to the scope.
   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
   *      Disabled by default.
   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
   *      this component's controller. The object keys specify the property names under which the required
   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
   *    - `$...` – additional properties to attach to the directive factory function and the controller
   *      constructor function. (This is used by the component router to annotate)
   *
   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
   * @description
   * Register a **component definition** with the compiler. This is a shorthand for registering a special
   * type of directive, which represents a self-contained UI component in your application. Such components
   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
   *
   * Component definitions are very simple and do not require as much configuration as defining general
   * directives. Component definitions usually consist only of a template and a controller backing it.
   *
   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
   * `bindToController`. They always have **isolate scope** and are restricted to elements.
   *
   * Here are a few examples of how you would usually define components:
   *
   * ```js
   *   var myMod = angular.module(...);
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     controller: function() {
   *       this.name = 'shahar';
   *     }
   *   });
   *
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     bindings: {name: '@'}
   *   });
   *
   *   myMod.component('myComp', {
   *     templateUrl: 'views/my-comp.html',
   *     controller: 'MyCtrl',
   *     controllerAs: 'ctrl',
   *     bindings: {name: '@'}
   *   });
   *
   * ```
   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
   *
   * <br />
   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
   */
  this.component = function registerComponent(name, options) {
    if (!isString(name)) {
      forEach(name, reverseParams(bind(this, registerComponent)));
      return this;
    }

    var controller = options.controller || function() {};

    function factory($injector) {
      function makeInjectable(fn) {
        if (isFunction(fn) || isArray(fn)) {
          return /** @this */ function(tElement, tAttrs) {
            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
          };
        } else {
          return fn;
        }
      }

      var template = (!options.template && !options.templateUrl ? '' : options.template);
      var ddo = {
        controller: controller,
        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
        template: makeInjectable(template),
        templateUrl: makeInjectable(options.templateUrl),
        transclude: options.transclude,
        scope: {},
        bindToController: options.bindings || {},
        restrict: 'E',
        require: options.require
      };

      // Copy annotations (starting with $) over to the DDO
      forEach(options, function(val, key) {
        if (key.charAt(0) === '$') ddo[key] = val;
      });

      return ddo;
    }

    // TODO(pete) remove the following `forEach` before we release 1.6.0
    // The component-router@0.2.0 looks for the annotations on the controller constructor
    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
    // it from 1.5.x yet.

    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
    // These could be used by libraries such as the new component router
    forEach(options, function(val, key) {
      if (key.charAt(0) === '$') {
        factory[key] = val;
        // Don't try to copy over annotations to named controller
        if (isFunction(controller)) controller[key] = val;
      }
    });

    factory.$inject = ['$injector'];

    return this.directive(name, factory);
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
    }
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `ng-scope` and `ng-isolated-scope` CSS classes
   * * `$binding` data property containing an array of the binding expressions
   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
   *   the element's scope.
   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
   *   E.g. `<!-- ngIf: shouldShow() -->`.
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */
  var debugInfoEnabled = true;
  this.debugInfoEnabled = function(enabled) {
    if (isDefined(enabled)) {
      debugInfoEnabled = enabled;
      return this;
    }
    return debugInfoEnabled;
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#strictComponentBindingsEnabled
   *
   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
   * otherwise return the current strictComponentBindingsEnabled state.
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable / disable the strict component bindings check. If enabled, the
   * compiler will enforce that all scope / controller bindings of a
   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
   * that are not set as optional with `?`, must be provided when the directive is instantiated.
   * If not provided, the compiler will throw the
   * {@link error/$compile/missingattr $compile:missingattr error}.
   *
   * The default value is false.
   */
  var strictComponentBindingsEnabled = false;
  this.strictComponentBindingsEnabled = function(enabled) {
    if (isDefined(enabled)) {
      strictComponentBindingsEnabled = enabled;
      return this;
    }
    return strictComponentBindingsEnabled;
  };

  var TTL = 10;
  /**
   * @ngdoc method
   * @name $compileProvider#onChangesTtl
   * @description
   *
   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
   * in several iterations of calls to these hooks. However if an application needs more than the default 10
   * iterations to stabilize then you should investigate what is causing the model to continuously change during
   * the `$onChanges` hook execution.
   *
   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
   *
   * @param {number} limit The number of `$onChanges` hook iterations.
   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
   */
  this.onChangesTtl = function(value) {
    if (arguments.length) {
      TTL = value;
      return this;
    }
    return TTL;
  };

  var commentDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#commentDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on comments should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on comments for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check comments when looking for directives.
   * This should however only be used if you are sure that no comment directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.commentDirectivesEnabled = function(value) {
    if (arguments.length) {
      commentDirectivesEnabledConfig = value;
      return this;
    }
    return commentDirectivesEnabledConfig;
  };


  var cssClassDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#cssClassDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on element classes should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on element classes for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check element classes when looking for directives.
   * This should however only be used if you are sure that no class directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.cssClassDirectivesEnabled = function(value) {
    if (arguments.length) {
      cssClassDirectivesEnabledConfig = value;
      return this;
    }
    return cssClassDirectivesEnabledConfig;
  };


  /**
   * The security context of DOM Properties.
   * @private
   */
  var PROP_CONTEXTS = createMap();

  /**
   * @ngdoc method
   * @name $compileProvider#addPropertySecurityContext
   * @description
   *
   * Defines the security context for DOM properties bound by ng-prop-*.
   *
   * @param {string} elementName The element name or '*' to match any element.
   * @param {string} propertyName The DOM property name.
   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
   * @returns {object} `this` for chaining
   */
  this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
    var key = (elementName.toLowerCase() + '|' + propertyName.toLowerCase());

    if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
      throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
    }

    PROP_CONTEXTS[key] = ctx;
    return this;
  };

  /* Default property contexts.
   *
   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
   * Changing:
   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
   * - STYLE => CSS
   * - various URL => MEDIA_URL
   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
   */
  (function registerNativePropertyContexts() {
    function registerContext(ctx, values) {
      forEach(values, function(v) { PROP_CONTEXTS[v.toLowerCase()] = ctx; });
    }

    registerContext(SCE_CONTEXTS.HTML, [
      'iframe|srcdoc',
      '*|innerHTML',
      '*|outerHTML'
    ]);
    registerContext(SCE_CONTEXTS.CSS, ['*|style']);
    registerContext(SCE_CONTEXTS.URL, [
      'area|href',       'area|ping',
      'a|href',          'a|ping',
      'blockquote|cite',
      'body|background',
      'del|cite',
      'input|src',
      'ins|cite',
      'q|cite'
    ]);
    registerContext(SCE_CONTEXTS.MEDIA_URL, [
      'audio|src',
      'img|src',    'img|srcset',
      'source|src', 'source|srcset',
      'track|src',
      'video|src',  'video|poster'
    ]);
    registerContext(SCE_CONTEXTS.RESOURCE_URL, [
      '*|formAction',
      'applet|code',      'applet|codebase',
      'base|href',
      'embed|src',
      'frame|src',
      'form|action',
      'head|profile',
      'html|manifest',
      'iframe|src',
      'link|href',
      'media|src',
      'object|codebase',  'object|data',
      'script|src'
    ]);
  })();


  this.$get = [
            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
            '$controller', '$rootScope', '$sce', '$animate',
    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
             $controller,   $rootScope,   $sce,   $animate) {

    var SIMPLE_ATTR_NAME = /^\w/;
    var specialAttrHolder = window.document.createElement('div');


    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;


    var onChangesTtl = TTL;
    // The onChanges hooks should all be run together in a single digest
    // When changes occur, the call to trigger their hooks will be added to this queue
    var onChangesQueue;

    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
    function flushOnChangesQueue() {
      try {
        if (!(--onChangesTtl)) {
          // We have hit the TTL limit so reset everything
          onChangesQueue = undefined;
          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
        }
        // We must run this hook in an apply since the $$postDigest runs outside apply
        $rootScope.$apply(function() {
          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
            try {
              onChangesQueue[i]();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          // Reset the queue to trigger a new schedule next time there is a change
          onChangesQueue = undefined;
        });
      } finally {
        onChangesTtl++;
      }
    }


    function sanitizeSrcset(value, invokeType) {
      if (!value) {
        return value;
      }
      if (!isString(value)) {
        throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
      }

      // Such values are a bit too complex to handle automatically inside $sce.
      // Instead, we sanitize each of the URIs individually, which works, even dynamically.

      // It's not possible to work around this using `$sce.trustAsMediaUrl`.
      // If you want to programmatically set explicitly trusted unsafe URLs, you should use
      // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
      // `ng-bind-html` directive.

      var result = '';

      // first check if there are spaces because it's not the same pattern
      var trimmedSrcset = trim(value);
      //                (   999x   ,|   999w   ,|   ,|,   )
      var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
      var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

      // split srcset into tuple of uri and descriptor except for the last item
      var rawUris = trimmedSrcset.split(pattern);

      // for each tuples
      var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
      for (var i = 0; i < nbrUrisWith2parts; i++) {
        var innerIdx = i * 2;
        // sanitize the uri
        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
        // add the descriptor
        result += ' ' + trim(rawUris[innerIdx + 1]);
      }

      // split the last item into uri and descriptor
      var lastTuple = trim(rawUris[i * 2]).split(/\s/);

      // sanitize the last uri
      result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));

      // and add the last descriptor if any
      if (lastTuple.length === 2) {
        result += (' ' + trim(lastTuple[1]));
      }
      return result;
    }


    function Attributes(element, attributesToCopy) {
      if (attributesToCopy) {
        var keys = Object.keys(attributesToCopy);
        var i, l, key;

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          this[key] = attributesToCopy[key];
        }
      } else {
        this.$attr = {};
      }

      this.$$element = element;
    }

    Attributes.prototype = {
      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */
      $normalize: directiveNormalize,


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */
      $addClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.addClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */
      $removeClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.removeClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */
      $updateClass: function(newClasses, oldClasses) {
        var toAdd = tokenDifference(newClasses, oldClasses);
        if (toAdd && toAdd.length) {
          $animate.addClass(this.$$element, toAdd);
        }

        var toRemove = tokenDifference(oldClasses, newClasses);
        if (toRemove && toRemove.length) {
          $animate.removeClass(this.$$element, toRemove);
        }
      },

      /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */
      $set: function(key, value, writeAttr, attrName) {
        // TODO: decide whether or not to throw an error if "class"
        // is set through this function since it may cause $updateClass to
        // become unstable.

        var node = this.$$element[0],
            booleanKey = getBooleanAttrName(node, key),
            aliasedKey = getAliasedAttrName(key),
            observer = key,
            nodeName;

        if (booleanKey) {
          this.$$element.prop(key, value);
          attrName = booleanKey;
        } else if (aliasedKey) {
          this[aliasedKey] = value;
          observer = aliasedKey;
        }

        this[key] = value;

        // translate normalized key to actual key
        if (attrName) {
          this.$attr[key] = attrName;
        } else {
          attrName = this.$attr[key];
          if (!attrName) {
            this.$attr[key] = attrName = snake_case(key, '-');
          }
        }

        nodeName = nodeName_(this.$$element);

        // Sanitize img[srcset] values.
        if (nodeName === 'img' && key === 'srcset') {
          this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
        }

        if (writeAttr !== false) {
          if (value === null || isUndefined(value)) {
            this.$$element.removeAttr(attrName);
          } else {
            if (SIMPLE_ATTR_NAME.test(attrName)) {
              this.$$element.attr(attrName, value);
            } else {
              setSpecialAttr(this.$$element[0], attrName, value);
            }
          }
        }

        // fire observers
        var $$observers = this.$$observers;
        if ($$observers) {
          forEach($$observers[observer], function(fn) {
            try {
              fn(value);
            } catch (e) {
              $exceptionHandler(e);
            }
          });
        }
      },


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
       *        guide} for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */
      $observe: function(key, fn) {
        var attrs = this,
            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
            listeners = ($$observers[key] || ($$observers[key] = []));

        listeners.push(fn);
        $rootScope.$evalAsync(function() {
          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
            // no one registered attribute interpolation function, so lets call it manually
            fn(attrs[key]);
          }
        });

        return function() {
          arrayRemove(listeners, fn);
        };
      }
    };

    function setSpecialAttr(element, attrName, value) {
      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
      // so we have to jump through some hoops to get such an attribute
      // https://github.com/angular/angular.js/pull/13318
      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
      var attributes = specialAttrHolder.firstChild.attributes;
      var attribute = attributes[0];
      // We have to remove the attribute from its container element before we can add it to the destination element
      attributes.removeNamedItem(attribute.name);
      attribute.value = value;
      element.attributes.setNamedItem(attribute);
    }

    function safeAddClass($element, className) {
      try {
        $element.addClass(className);
      } catch (e) {
        // ignore, since it means that we are trying to set class on
        // SVG element, where class name is read-only.
      }
    }


    var startSymbol = $interpolate.startSymbol(),
        endSymbol = $interpolate.endSymbol(),
        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
            ? identity
            : function denormalizeTemplate(template) {
              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        },
        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;

    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
      var bindings = $element.data('$binding') || [];

      if (isArray(binding)) {
        bindings = bindings.concat(binding);
      } else {
        bindings.push(binding);
      }

      $element.data('$binding', bindings);
    } : noop;

    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
      safeAddClass($element, 'ng-binding');
    } : noop;

    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
      $element.data(dataName, scope);
    } : noop;

    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
    } : noop;

    compile.$$createComment = function(directiveName, comment) {
      var content = '';
      if (debugInfoEnabled) {
        content = ' ' + (directiveName || '') + ': ';
        if (comment) content += comment + ' ';
      }
      return window.document.createComment(content);
    };

    return compile;

    //================================

    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
                        previousCompileContext) {
      if (!($compileNodes instanceof jqLite)) {
        // jquery always rewraps, whereas we need to preserve the original selector so that we can
        // modify it.
        $compileNodes = jqLite($compileNodes);
      }
      var compositeLinkFn =
              compileNodes($compileNodes, transcludeFn, $compileNodes,
                           maxPriority, ignoreDirective, previousCompileContext);
      compile.$$addScopeClass($compileNodes);
      var namespace = null;
      return function publicLinkFn(scope, cloneConnectFn, options) {
        if (!$compileNodes) {
          throw $compileMinErr('multilink', 'This element has already been linked.');
        }
        assertArg(scope, 'scope');

        if (previousCompileContext && previousCompileContext.needsNewScope) {
          // A parent directive did a replace and a directive on this element asked
          // for transclusion, which caused us to lose a layer of element on which
          // we could hold the new transclusion scope, so we will create it manually
          // here.
          scope = scope.$parent.$new();
        }

        options = options || {};
        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
          transcludeControllers = options.transcludeControllers,
          futureParentElement = options.futureParentElement;

        // When `parentBoundTranscludeFn` is passed, it is a
        // `controllersBoundTransclude` function (it was previously passed
        // as `transclude` to directive.link) so we must unwrap it to get
        // its `boundTranscludeFn`
        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
        }

        if (!namespace) {
          namespace = detectNamespaceForChildElements(futureParentElement);
        }
        var $linkNode;
        if (namespace !== 'html') {
          // When using a directive with replace:true and templateUrl the $compileNodes
          // (or a child element inside of them)
          // might change, so we need to recreate the namespace adapted compileNodes
          // for call to the link function.
          // Note: This will already clone the nodes...
          $linkNode = jqLite(
            wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html())
          );
        } else if (cloneConnectFn) {
          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
          // and sometimes changes the structure of the DOM.
          $linkNode = JQLitePrototype.clone.call($compileNodes);
        } else {
          $linkNode = $compileNodes;
        }

        if (transcludeControllers) {
          for (var controllerName in transcludeControllers) {
            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
          }
        }

        compile.$$addScopeInfo($linkNode, scope);

        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);

        if (!cloneConnectFn) {
          $compileNodes = compositeLinkFn = null;
        }
        return $linkNode;
      };
    }

    function detectNamespaceForChildElements(parentElement) {
      // TODO: Make this detect MathML as well...
      var node = parentElement && parentElement[0];
      if (!node) {
        return 'html';
      } else {
        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
      }
    }

    /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */
    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
                            previousCompileContext) {
      var linkFns = [],
          // `nodeList` can be either an element's `.childNodes` (live NodeList)
          // or a jqLite/jQuery collection or an array
          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;


      for (var i = 0; i < nodeList.length; i++) {
        attrs = new Attributes();

        // Support: IE 11 only
        // Workaround for #11781 and #14924
        if (msie === 11) {
          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
        }

        // We must always refer to `nodeList[i]` hereafter,
        // since the nodes can be replaced underneath us.
        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
                                        ignoreDirective);

        nodeLinkFn = (directives.length)
            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
                                      null, [], [], previousCompileContext)
            : null;

        if (nodeLinkFn && nodeLinkFn.scope) {
          compile.$$addScopeClass(attrs.$$element);
        }

        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
                      !(childNodes = nodeList[i].childNodes) ||
                      !childNodes.length)
            ? null
            : compileNodes(childNodes,
                 nodeLinkFn ? (
                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
                     && nodeLinkFn.transclude) : transcludeFn);

        if (nodeLinkFn || childLinkFn) {
          linkFns.push(i, nodeLinkFn, childLinkFn);
          linkFnFound = true;
          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
        }

        //use the previous context only for the first element in the virtual group
        previousCompileContext = null;
      }

      // return a linking function if we have found anything, null otherwise
      return linkFnFound ? compositeLinkFn : null;

      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
        var stableNodeList;


        if (nodeLinkFnFound) {
          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
          // offsets don't get screwed up
          var nodeListLength = nodeList.length;
          stableNodeList = new Array(nodeListLength);

          // create a sparse array by only copying the elements which have a linkFn
          for (i = 0; i < linkFns.length; i += 3) {
            idx = linkFns[i];
            stableNodeList[idx] = nodeList[idx];
          }
        } else {
          stableNodeList = nodeList;
        }

        for (i = 0, ii = linkFns.length; i < ii;) {
          node = stableNodeList[linkFns[i++]];
          nodeLinkFn = linkFns[i++];
          childLinkFn = linkFns[i++];

          if (nodeLinkFn) {
            if (nodeLinkFn.scope) {
              childScope = scope.$new();
              compile.$$addScopeInfo(jqLite(node), childScope);
            } else {
              childScope = scope;
            }

            if (nodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(
                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);

            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
              childBoundTranscludeFn = parentBoundTranscludeFn;

            } else if (!parentBoundTranscludeFn && transcludeFn) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);

            } else {
              childBoundTranscludeFn = null;
            }

            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);

          } else if (childLinkFn) {
            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
          }
        }
      }
    }

    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
      var node = nodeList[idx];
      var parent = node.parentNode;
      var sibling;

      if (node.nodeType !== NODE_TYPE_TEXT) {
        return;
      }

      while (true) {
        sibling = parent ? node.nextSibling : nodeList[idx + 1];
        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
          break;
        }

        node.nodeValue = node.nodeValue + sibling.nodeValue;

        if (sibling.parentNode) {
          sibling.parentNode.removeChild(sibling);
        }
        if (notLiveList && sibling === nodeList[idx + 1]) {
          nodeList.splice(idx + 1, 1);
        }
      }
    }

    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

        if (!transcludedScope) {
          transcludedScope = scope.$new(false, containingScope);
          transcludedScope.$$transcluded = true;
        }

        return transcludeFn(transcludedScope, cloneFn, {
          parentBoundTranscludeFn: previousBoundTranscludeFn,
          transcludeControllers: controllers,
          futureParentElement: futureParentElement
        });
      }

      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
      // so that they are available inside the `controllersBoundTransclude` function
      var boundSlots = boundTranscludeFn.$$slots = createMap();
      for (var slotName in transcludeFn.$$slots) {
        if (transcludeFn.$$slots[slotName]) {
          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
        } else {
          boundSlots[slotName] = null;
        }
      }

      return boundTranscludeFn;
    }

    /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */
    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      var nodeType = node.nodeType,
          attrsMap = attrs.$attr,
          match,
          nodeName,
          className;

      switch (nodeType) {
        case NODE_TYPE_ELEMENT: /* Element */

          nodeName = nodeName_(node);

          // use the node name: <directive>
          addDirective(directives,
              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);

          // iterate over the attributes
          for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes,
                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
            var attrStartName = false;
            var attrEndName = false;

            var isNgAttr = false, isNgProp = false, isNgEvent = false;
            var multiElementMatch;

            attr = nAttrs[j];
            name = attr.name;
            value = attr.value;

            nName = directiveNormalize(name.toLowerCase());

            // Support ng-attr-*, ng-prop-* and ng-on-*
            if ((ngPrefixMatch = nName.match(NG_PREFIX_BINDING))) {
              isNgAttr = ngPrefixMatch[1] === 'Attr';
              isNgProp = ngPrefixMatch[1] === 'Prop';
              isNgEvent = ngPrefixMatch[1] === 'On';

              // Normalize the non-prefixed name
              name = name.replace(PREFIX_REGEXP, '')
                .toLowerCase()
                .substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
                  return letter.toUpperCase();
                });

            // Support *-start / *-end multi element directives
            } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
              attrStartName = name;
              attrEndName = name.substr(0, name.length - 5) + 'end';
              name = name.substr(0, name.length - 6);
            }

            if (isNgProp || isNgEvent) {
              attrs[nName] = value;
              attrsMap[nName] = attr.name;

              if (isNgProp) {
                addPropertyDirective(node, directives, nName, name);
              } else {
                addEventDirective(directives, nName, name);
              }
            } else {
              // Update nName for cases where a prefix was removed
              // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
              nName = directiveNormalize(name.toLowerCase());
              attrsMap[nName] = name;

              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                attrs[nName] = value;
                if (getBooleanAttrName(node, nName)) {
                  attrs[nName] = true; // presence means true
                }
              }

              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
                            attrEndName);
            }
          }

          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
            // Hidden input elements can have strange behaviour when navigating back to the page
            // This tells the browser not to try to cache and reinstate previous values
            node.setAttribute('autocomplete', 'off');
          }

          // use class as directive
          if (!cssClassDirectivesEnabled) break;
          className = node.className;
          if (isObject(className)) {
              // Maybe SVGAnimatedString
              className = className.animVal;
          }
          if (isString(className) && className !== '') {
            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
              nName = directiveNormalize(match[2]);
              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[3]);
              }
              className = className.substr(match.index + match[0].length);
            }
          }
          break;
        case NODE_TYPE_TEXT: /* Text Node */
          addTextInterpolateDirective(directives, node.nodeValue);
          break;
        case NODE_TYPE_COMMENT: /* Comment */
          if (!commentDirectivesEnabled) break;
          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
          break;
      }

      directives.sort(byPriority);
      return directives;
    }

    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      // function created because of performance, try/catch disables
      // the optimization of the whole function #14848
      try {
        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
        if (match) {
          var nName = directiveNormalize(match[1]);
          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
            attrs[nName] = trim(match[2]);
          }
        }
      } catch (e) {
        // turns out that under some circumstances IE9 throws errors when one attempts to read
        // comment's node value.
        // Just ignore it and continue. (Can't seem to reproduce in test case.)
      }
    }

    /**
     * Given a node with a directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */
    function groupScan(node, attrStart, attrEnd) {
      var nodes = [];
      var depth = 0;
      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
        do {
          if (!node) {
            throw $compileMinErr('uterdir',
                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
                      attrStart, attrEnd);
          }
          if (node.nodeType === NODE_TYPE_ELEMENT) {
            if (node.hasAttribute(attrStart)) depth++;
            if (node.hasAttribute(attrEnd)) depth--;
          }
          nodes.push(node);
          node = node.nextSibling;
        } while (depth > 0);
      } else {
        nodes.push(node);
      }

      return jqLite(nodes);
    }

    /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */
    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
        element = groupScan(element[0], attrStart, attrEnd);
        return linkFn(scope, element, attrs, controllers, transcludeFn);
      };
    }

    /**
     * A function generator that is used to support both eager and lazy compilation
     * linking function.
     * @param eager
     * @param $compileNodes
     * @param transcludeFn
     * @param maxPriority
     * @param ignoreDirective
     * @param previousCompileContext
     * @returns {Function}
     */
    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
      var compiled;

      if (eager) {
        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
      }
      return /** @this */ function lazyCompilation() {
        if (!compiled) {
          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

          // Null out all of these references in order to make them eligible for garbage collection
          // since this is a potentially long lived closure
          $compileNodes = transcludeFn = previousCompileContext = null;
        }
        return compiled.apply(this, arguments);
      };
    }

    /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */
    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
                                   previousCompileContext) {
      previousCompileContext = previousCompileContext || {};

      var terminalPriority = -Number.MAX_VALUE,
          newScopeDirective = previousCompileContext.newScopeDirective,
          controllerDirectives = previousCompileContext.controllerDirectives,
          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
          templateDirective = previousCompileContext.templateDirective,
          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
          hasTranscludeDirective = false,
          hasTemplate = false,
          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
          $compileNode = templateAttrs.$$element = jqLite(compileNode),
          directive,
          directiveName,
          $template,
          replaceDirective = originalReplaceDirective,
          childTranscludeFn = transcludeFn,
          linkFn,
          didScanForMultipleTransclusion = false,
          mightHaveMultipleTransclusionError = false,
          directiveValue;

      // executes all directives on the current element
      for (var i = 0, ii = directives.length; i < ii; i++) {
        directive = directives[i];
        var attrStart = directive.$$start;
        var attrEnd = directive.$$end;

        // collect multiblock sections
        if (attrStart) {
          $compileNode = groupScan(compileNode, attrStart, attrEnd);
        }
        $template = undefined;

        if (terminalPriority > directive.priority) {
          break; // prevent further processing of directives
        }

        directiveValue = directive.scope;

        if (directiveValue) {

          // skip the check for directives with async templates, we'll check the derived sync
          // directive when the template arrives
          if (!directive.templateUrl) {
            if (isObject(directiveValue)) {
              // This directive is trying to add an isolated scope.
              // Check that there is no scope of any kind already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
                                directive, $compileNode);
              newIsolateScopeDirective = directive;
            } else {
              // This directive is trying to add a child scope.
              // Check that there is no isolated scope already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
                                $compileNode);
            }
          }

          newScopeDirective = newScopeDirective || directive;
        }

        directiveName = directive.name;

        // If we encounter a condition that can result in transclusion on the directive,
        // then scan ahead in the remaining directives for others that may cause a multiple
        // transclusion error to be thrown during the compilation process.  If a matching directive
        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
        // compile the `transclude` function rather than doing it lazily in order to throw
        // exceptions at the correct time
        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
            || (directive.transclude && !directive.$$tlb))) {
                var candidateDirective;

                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
                        mightHaveMultipleTransclusionError = true;
                        break;
                    }
                }

                didScanForMultipleTransclusion = true;
        }

        if (!directive.templateUrl && directive.controller) {
          controllerDirectives = controllerDirectives || createMap();
          assertNoDuplicate('\'' + directiveName + '\' controller',
              controllerDirectives[directiveName], directive, $compileNode);
          controllerDirectives[directiveName] = directive;
        }

        directiveValue = directive.transclude;

        if (directiveValue) {
          hasTranscludeDirective = true;

          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
          // This option should only be used by directives that know how to safely handle element transclusion,
          // where the transcluded nodes are added or replaced after linking.
          if (!directive.$$tlb) {
            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
            nonTlbTranscludeDirective = directive;
          }

          if (directiveValue === 'element') {
            hasElementTranscludeDirective = true;
            terminalPriority = directive.priority;
            $template = $compileNode;
            $compileNode = templateAttrs.$$element =
                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
            compileNode = $compileNode[0];
            replaceWith(jqCollection, sliceArgs($template), compileNode);

            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
                                        replaceDirective && replaceDirective.name, {
                                          // Don't pass in:
                                          // - controllerDirectives - otherwise we'll create duplicates controllers
                                          // - newIsolateScopeDirective or templateDirective - combining templates with
                                          //   element transclusion doesn't make sense.
                                          //
                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                          // on the same element more than once.
                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                        });
          } else {

            var slots = createMap();

            if (!isObject(directiveValue)) {
              $template = jqLite(jqLiteClone(compileNode)).contents();
            } else {

              // We have transclusion slots,
              // collect them up, compile them and store their transclusion functions
              $template = window.document.createDocumentFragment();

              var slotMap = createMap();
              var filledSlots = createMap();

              // Parse the element selectors
              forEach(directiveValue, function(elementSelector, slotName) {
                // If an element selector starts with a ? then it is optional
                var optional = (elementSelector.charAt(0) === '?');
                elementSelector = optional ? elementSelector.substring(1) : elementSelector;

                slotMap[elementSelector] = slotName;

                // We explicitly assign `null` since this implies that a slot was defined but not filled.
                // Later when calling boundTransclusion functions with a slot name we only error if the
                // slot is `undefined`
                slots[slotName] = null;

                // filledSlots contains `true` for all slots that are either optional or have been
                // filled. This is used to check that we have not missed any required slots
                filledSlots[slotName] = optional;
              });

              // Add the matching elements into their slot
              forEach($compileNode.contents(), function(node) {
                var slotName = slotMap[directiveNormalize(nodeName_(node))];
                if (slotName) {
                  filledSlots[slotName] = true;
                  slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
                  slots[slotName].appendChild(node);
                } else {
                  $template.appendChild(node);
                }
              });

              // Check for required slots that were not filled
              forEach(filledSlots, function(filled, slotName) {
                if (!filled) {
                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                }
              });

              for (var slotName in slots) {
                if (slots[slotName]) {
                  // Only define a transclusion function if the slot was filled
                  var slotCompileNodes = jqLite(slots[slotName].childNodes);
                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
                }
              }

              $template = jqLite($template.childNodes);
            }

            $compileNode.empty(); // clear contents
            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
            childTranscludeFn.$$slots = slots;
          }
        }

        if (directive.template) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          directiveValue = (isFunction(directive.template))
              ? directive.template($compileNode, templateAttrs)
              : directive.template;

          directiveValue = denormalizeTemplate(directiveValue);

          if (directive.replace) {
            replaceDirective = directive;
            if (jqLiteIsTextNode(directiveValue)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  directiveName, '');
            }

            replaceWith(jqCollection, $compileNode, compileNode);

            var newTemplateAttrs = {$attr: {}};

            // combine directives from the original node and from the template:
            // - take the array of directives for this element
            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
            // - collect directives from the template and sort them by priority
            // - combine directives as: processed + template + unprocessed
            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

            if (newIsolateScopeDirective || newScopeDirective) {
              // The original directive caused the current element to be replaced but this element
              // also needs to have a new scope, so we need to tell the template directives
              // that they would need to get their scope from further up, if they require transclusion
              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
            }
            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

            ii = directives.length;
          } else {
            $compileNode.html(directiveValue);
          }
        }

        if (directive.templateUrl) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          if (directive.replace) {
            replaceDirective = directive;
          }

          // eslint-disable-next-line no-func-assign
          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                controllerDirectives: controllerDirectives,
                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
                newIsolateScopeDirective: newIsolateScopeDirective,
                templateDirective: templateDirective,
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
          ii = directives.length;
        } else if (directive.compile) {
          try {
            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
            var context = directive.$$originalDirective || directive;
            if (isFunction(linkFn)) {
              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
            } else if (linkFn) {
              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
            }
          } catch (e) {
            $exceptionHandler(e, startingTag($compileNode));
          }
        }

        if (directive.terminal) {
          nodeLinkFn.terminal = true;
          terminalPriority = Math.max(terminalPriority, directive.priority);
        }

      }

      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
      nodeLinkFn.templateOnThisElement = hasTemplate;
      nodeLinkFn.transclude = childTranscludeFn;

      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
      return nodeLinkFn;

      ////////////////////

      function addLinkFns(pre, post, attrStart, attrEnd) {
        if (pre) {
          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
          pre.require = directive.require;
          pre.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
          }
          preLinkFns.push(pre);
        }
        if (post) {
          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
          post.require = directive.require;
          post.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            post = cloneAndAnnotateFn(post, {isolateScope: true});
          }
          postLinkFns.push(post);
        }
      }

      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
            attrs, scopeBindingInfo;

        if (compileNode === linkNode) {
          attrs = templateAttrs;
          $element = templateAttrs.$$element;
        } else {
          $element = jqLite(linkNode);
          attrs = new Attributes($element, templateAttrs);
        }

        controllerScope = scope;
        if (newIsolateScopeDirective) {
          isolateScope = scope.$new(true);
        } else if (newScopeDirective) {
          controllerScope = scope.$parent;
        }

        if (boundTranscludeFn) {
          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
          transcludeFn = controllersBoundTransclude;
          transcludeFn.$$boundTransclude = boundTranscludeFn;
          // expose the slots on the `$transclude` function
          transcludeFn.isSlotFilled = function(slotName) {
            return !!boundTranscludeFn.$$slots[slotName];
          };
        }

        if (controllerDirectives) {
          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
        }

        if (newIsolateScopeDirective) {
          // Initialize isolate scope bindings for new isolate scope directive.
          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
              templateDirective === newIsolateScopeDirective.$$originalDirective)));
          compile.$$addScopeClass($element, true);
          isolateScope.$$isolateBindings =
              newIsolateScopeDirective.$$isolateBindings;
          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
                                        isolateScope.$$isolateBindings,
                                        newIsolateScopeDirective);
          if (scopeBindingInfo.removeWatches) {
            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
          }
        }

        // Initialize bindToController bindings
        for (var name in elementControllers) {
          var controllerDirective = controllerDirectives[name];
          var controller = elementControllers[name];
          var bindings = controllerDirective.$$bindings.bindToController;

          controller.instance = controller();
          $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
          controller.bindingInfo =
            initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
          }

        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
        forEach(controllerDirectives, function(controllerDirective, name) {
          var require = controllerDirective.require;
          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
          }
        });

        // Handle the init and destroy lifecycle hooks on all controllers that have them
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$onChanges)) {
            try {
              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$onInit)) {
            try {
              controllerInstance.$onInit();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$doCheck)) {
            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
            controllerInstance.$doCheck();
          }
          if (isFunction(controllerInstance.$onDestroy)) {
            controllerScope.$on('$destroy', function callOnDestroyHook() {
              controllerInstance.$onDestroy();
            });
          }
        });

        // PRELINKING
        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
          linkFn = preLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // RECURSION
        // We only pass the isolate scope, if the isolate directive has a template,
        // otherwise the child elements do not belong to the isolate directive.
        var scopeToChild = scope;
        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
          scopeToChild = isolateScope;
        }
        if (childLinkFn) {
          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
        }

        // POSTLINKING
        for (i = postLinkFns.length - 1; i >= 0; i--) {
          linkFn = postLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // Trigger $postLink lifecycle hooks
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$postLink)) {
            controllerInstance.$postLink();
          }
        });

        // This is the function that is injected as `$transclude`.
        // Note: all arguments are optional!
        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
          var transcludeControllers;
          // No scope passed in:
          if (!isScope(scope)) {
            slotName = futureParentElement;
            futureParentElement = cloneAttachFn;
            cloneAttachFn = scope;
            scope = undefined;
          }

          if (hasElementTranscludeDirective) {
            transcludeControllers = elementControllers;
          }
          if (!futureParentElement) {
            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
          }
          if (slotName) {
            // slotTranscludeFn can be one of three things:
            //  * a transclude function - a filled slot
            //  * `null` - an optional slot that was not filled
            //  * `undefined` - a slot that was not declared (i.e. invalid)
            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
            if (slotTranscludeFn) {
              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
            } else if (isUndefined(slotTranscludeFn)) {
              throw $compileMinErr('noslot',
               'No parent directive that requires a transclusion with slot name "{0}". ' +
               'Element: {1}',
               slotName, startingTag($element));
            }
          } else {
            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
          }
        }
      }
    }

    function getControllers(directiveName, require, $element, elementControllers) {
      var value;

      if (isString(require)) {
        var match = require.match(REQUIRE_PREFIX_REGEXP);
        var name = require.substring(match[0].length);
        var inheritType = match[1] || match[3];
        var optional = match[2] === '?';

        //If only parents then start at the parent element
        if (inheritType === '^^') {
          $element = $element.parent();
        //Otherwise attempt getting the controller from elementControllers in case
        //the element is transcluded (and has no data) and to avoid .data if possible
        } else {
          value = elementControllers && elementControllers[name];
          value = value && value.instance;
        }

        if (!value) {
          var dataName = '$' + name + 'Controller';

          if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
            // inheritedData() uses the documentElement when it finds the document, so we would
            // require from the element itself.
            value = null;
          } else {
            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
          }
        }

        if (!value && !optional) {
          throw $compileMinErr('ctreq',
              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
              name, directiveName);
        }
      } else if (isArray(require)) {
        value = [];
        for (var i = 0, ii = require.length; i < ii; i++) {
          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
        }
      } else if (isObject(require)) {
        value = {};
        forEach(require, function(controller, property) {
          value[property] = getControllers(directiveName, controller, $element, elementControllers);
        });
      }

      return value || null;
    }

    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
      var elementControllers = createMap();
      for (var controllerKey in controllerDirectives) {
        var directive = controllerDirectives[controllerKey];
        var locals = {
          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
          $element: $element,
          $attrs: attrs,
          $transclude: transcludeFn
        };

        var controller = directive.controller;
        if (controller === '@') {
          controller = attrs[directive.name];
        }

        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

        // For directives with element transclusion the element is a comment.
        // In this case .data will not attach any data.
        // Instead, we save the controllers for the element in a local hash and attach to .data
        // later, once we have the actual element.
        elementControllers[directive.name] = controllerInstance;
        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
      }
      return elementControllers;
    }

    // Depending upon the context in which a directive finds itself it might need to have a new isolated
    // or child scope created. For instance:
    // * if the directive has been pulled into a template because another directive with a higher priority
    // asked for element transclusion
    // * if the directive itself asks for transclusion but it is at the root of a template and the original
    // element was replaced. See https://github.com/angular/angular.js/issues/12936
    function markDirectiveScope(directives, isolateScope, newScope) {
      for (var j = 0, jj = directives.length; j < jj; j++) {
        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
      }
    }

    /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */
    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
                          endAttrName) {
      if (name === ignoreDirective) return null;
      var match = null;
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
               directive.restrict.indexOf(location) !== -1) {
            if (startAttrName) {
              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
            }
            if (!directive.$$bindings) {
              var bindings = directive.$$bindings =
                  parseDirectiveBindings(directive, directive.name);
              if (isObject(bindings.isolateScope)) {
                directive.$$isolateBindings = bindings.isolateScope;
              }
            }
            tDirectives.push(directive);
            match = directive;
          }
        }
      }
      return match;
    }


    /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */
    function directiveIsMultiElement(name) {
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if (directive.multiElement) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */
    function mergeTemplateAttributes(dst, src) {
      var srcAttr = src.$attr,
          dstAttr = dst.$attr;

      // reapply the old attributes to the new element
      forEach(dst, function(value, key) {
        if (key.charAt(0) !== '$') {
          if (src[key] && src[key] !== value) {
            if (value.length) {
              value += (key === 'style' ? ';' : ' ') + src[key];
            } else {
              value = src[key];
            }
          }
          dst.$set(key, value, true, srcAttr[key]);
        }
      });

      // copy the new attributes on the old attrs object
      forEach(src, function(value, key) {
        // Check if we already set this attribute in the loop above.
        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
        // have an attribute like "has-own-property" or "data-has-own-property", etc.
        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
          dst[key] = value;

          if (key !== 'class' && key !== 'style') {
            dstAttr[key] = srcAttr[key];
          }
        }
      });
    }


    function compileTemplateUrl(directives, $compileNode, tAttrs,
        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
      var linkQueue = [],
          afterTemplateNodeLinkFn,
          afterTemplateChildLinkFn,
          beforeTemplateCompileNode = $compileNode[0],
          origAsyncDirective = directives.shift(),
          derivedSyncDirective = inherit(origAsyncDirective, {
            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
          }),
          templateUrl = (isFunction(origAsyncDirective.templateUrl))
              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
              : origAsyncDirective.templateUrl,
          templateNamespace = origAsyncDirective.templateNamespace;

      $compileNode.empty();

      $templateRequest(templateUrl)
        .then(function(content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

          content = denormalizeTemplate(content);

          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  origAsyncDirective.name, templateUrl);
            }

            tempTemplateAttrs = {$attr: {}};
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

            if (isObject(origAsyncDirective.scope)) {
              // the original directive that caused the template to be loaded async required
              // an isolate scope
              markDirectiveScope(templateDirectives, true);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }

          directives.unshift(derivedSyncDirective);

          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
              previousCompileContext);
          forEach($rootElement, function(node, i) {
            if (node === compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

          while (linkQueue.length) {
            var scope = linkQueue.shift(),
                beforeTemplateLinkNode = linkQueue.shift(),
                linkRootElement = linkQueue.shift(),
                boundTranscludeFn = linkQueue.shift(),
                linkNode = $compileNode[0];

            if (scope.$$destroyed) continue;

            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;

              if (!(previousCompileContext.hasElementTranscludeDirective &&
                  origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
              childBoundTranscludeFn);
          }
          linkQueue = null;
        }).catch(function(error) {
          if (isError(error)) {
            $exceptionHandler(error);
          }
        });

      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
        var childBoundTranscludeFn = boundTranscludeFn;
        if (scope.$$destroyed) return;
        if (linkQueue) {
          linkQueue.push(scope,
                         node,
                         rootElement,
                         childBoundTranscludeFn);
        } else {
          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
          }
          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
        }
      };
    }


    /**
     * Sorting function for bound directives.
     */
    function byPriority(a, b) {
      var diff = b.priority - a.priority;
      if (diff !== 0) return diff;
      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
      return a.index - b.index;
    }

    function assertNoDuplicate(what, previousDirective, directive, element) {

      function wrapModuleNameIfDefined(moduleName) {
        return moduleName ?
          (' (module: ' + moduleName + ')') :
          '';
      }

      if (previousDirective) {
        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
      }
    }


    function addTextInterpolateDirective(directives, text) {
      var interpolateFn = $interpolate(text, true);
      if (interpolateFn) {
        directives.push({
          priority: 0,
          compile: function textInterpolateCompileFn(templateNode) {
            var templateNodeParent = templateNode.parent(),
                hasCompileParent = !!templateNodeParent.length;

            // When transcluding a template that has bindings in the root
            // we don't have a parent and thus need to add the class during linking fn.
            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

            return function textInterpolateLinkFn(scope, node) {
              var parent = node.parent();
              if (!hasCompileParent) compile.$$addBindingClass(parent);
              compile.$$addBindingInfo(parent, interpolateFn.expressions);
              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                node[0].nodeValue = value;
              });
            };
          }
        });
      }
    }


    function wrapTemplate(type, template) {
      type = lowercase(type || 'html');
      switch (type) {
      case 'svg':
      case 'math':
        var wrapper = window.document.createElement('div');
        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
        return wrapper.childNodes[0].childNodes;
      default:
        return template;
      }
    }


    function getTrustedAttrContext(nodeName, attrNormalizedName) {
      if (attrNormalizedName === 'srcdoc') {
        return $sce.HTML;
      }
      // All nodes with src attributes require a RESOURCE_URL value, except for
      // img and various html5 media nodes, which require the MEDIA_URL context.
      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
        if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
          return $sce.RESOURCE_URL;
        }
        return $sce.MEDIA_URL;
      } else if (attrNormalizedName === 'xlinkHref') {
        // Some xlink:href are okay, most aren't
        if (nodeName === 'image') return $sce.MEDIA_URL;
        if (nodeName === 'a') return $sce.URL;
        return $sce.RESOURCE_URL;
      } else if (
          // Formaction
          (nodeName === 'form' && attrNormalizedName === 'action') ||
          // If relative URLs can go where they are not expected to, then
          // all sorts of trust issues can arise.
          (nodeName === 'base' && attrNormalizedName === 'href') ||
          // links can be stylesheets or imports, which can run script in the current origin
          (nodeName === 'link' && attrNormalizedName === 'href')
      ) {
        return $sce.RESOURCE_URL;
      } else if (nodeName === 'a' && (attrNormalizedName === 'href' ||
                                 attrNormalizedName === 'ngHref')) {
        return $sce.URL;
      }
    }

    function getTrustedPropContext(nodeName, propNormalizedName) {
      var prop = propNormalizedName.toLowerCase();
      return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
    }

    function sanitizeSrcsetPropertyValue(value) {
      return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
    }
    function addPropertyDirective(node, directives, attrName, propName) {
      if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
        throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
      }

      var nodeName = nodeName_(node);
      var trustedContext = getTrustedPropContext(nodeName, propName);

      var sanitizer = identity;
      // Sanitize img[srcset] + source[srcset] values.
      if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
        sanitizer = sanitizeSrcsetPropertyValue;
      } else if (trustedContext) {
        sanitizer = $sce.getTrusted.bind($sce, trustedContext);
      }

      directives.push({
        priority: 100,
        compile: function ngPropCompileFn(_, attr) {
          var ngPropGetter = $parse(attr[attrName]);
          var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
            // Unwrap the value to compare the actual inner safe value, not the wrapper object.
            return $sce.valueOf(val);
          });

          return {
            pre: function ngPropPreLinkFn(scope, $element) {
              function applyPropValue() {
                var propValue = ngPropGetter(scope);
                $element.prop(propName, sanitizer(propValue));
              }

              applyPropValue();
              scope.$watch(ngPropWatch, applyPropValue);
            }
          };
        }
      });
    }

    function addEventDirective(directives, attrName, eventName) {
      directives.push(
        createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false)
      );
    }

    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
      var nodeName = nodeName_(node);
      var trustedContext = getTrustedAttrContext(nodeName, name);
      var mustHaveExpression = !isNgAttr;
      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;

      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);

      // no interpolation found -> ignore
      if (!interpolateFn) return;

      if (name === 'multiple' && nodeName === 'select') {
        throw $compileMinErr('selmulti',
            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
            startingTag(node));
      }

      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
        throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
      }

      directives.push({
        priority: 100,
        compile: function() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));

                // If the attribute has changed since last $interpolate()ed
                var newValue = attr[name];
                if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                  value = newValue;
                }

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);

                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).
                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                    //special case for class attribute addition + removal
                    //so that class changes can tap into the animation
                    //hooks provided by the $animate service. Be sure to
                    //skip animations when the first digest occurs (when
                    //both the new and the old values are the same) since
                    //the CSS classes are the non-interpolated values
                    if (name === 'class' && newValue !== oldValue) {
                      attr.$updateClass(newValue, oldValue);
                    } else {
                      attr.$set(name, newValue);
                    }
                  });
              }
            };
          }
      });
    }


    /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */
    function replaceWith($rootElement, elementsToRemove, newNode) {
      var firstElementToRemove = elementsToRemove[0],
          removeCount = elementsToRemove.length,
          parent = firstElementToRemove.parentNode,
          i, ii;

      if ($rootElement) {
        for (i = 0, ii = $rootElement.length; i < ii; i++) {
          if ($rootElement[i] === firstElementToRemove) {
            $rootElement[i++] = newNode;
            for (var j = i, j2 = j + removeCount - 1,
                     jj = $rootElement.length;
                 j < jj; j++, j2++) {
              if (j2 < jj) {
                $rootElement[j] = $rootElement[j2];
              } else {
                delete $rootElement[j];
              }
            }
            $rootElement.length -= removeCount - 1;

            // If the replaced element is also the jQuery .context then replace it
            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
            // http://api.jquery.com/context/
            if ($rootElement.context === firstElementToRemove) {
              $rootElement.context = newNode;
            }
            break;
          }
        }
      }

      if (parent) {
        parent.replaceChild(newNode, firstElementToRemove);
      }

      // Append all the `elementsToRemove` to a fragment. This will...
      // - remove them from the DOM
      // - allow them to still be traversed with .nextSibling
      // - allow a single fragment.qSA to fetch all elements being removed
      var fragment = window.document.createDocumentFragment();
      for (i = 0; i < removeCount; i++) {
        fragment.appendChild(elementsToRemove[i]);
      }

      if (jqLite.hasData(firstElementToRemove)) {
        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
        // data here because there's no public interface in jQuery to do that and copying over
        // event listeners (which is the main use of private data) wouldn't work anyway.
        jqLite.data(newNode, jqLite.data(firstElementToRemove));

        // Remove $destroy event listeners from `firstElementToRemove`
        jqLite(firstElementToRemove).off('$destroy');
      }

      // Cleanup any data/listeners on the elements and children.
      // This includes invoking the $destroy event on any elements with listeners.
      jqLite.cleanData(fragment.querySelectorAll('*'));

      // Update the jqLite collection to only contain the `newNode`
      for (i = 1; i < removeCount; i++) {
        delete elementsToRemove[i];
      }
      elementsToRemove[0] = newNode;
      elementsToRemove.length = 1;
    }


    function cloneAndAnnotateFn(fn, annotation) {
      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
    }


    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
      try {
        linkFn(scope, $element, attrs, controllers, transcludeFn);
      } catch (e) {
        $exceptionHandler(e, startingTag($element));
      }
    }

    function strictBindingsCheck(attrName, directiveName) {
      if (strictComponentBindingsEnabled) {
        throw $compileMinErr('missingattr',
          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
          attrName, directiveName);
      }
    }

    // Set up $watches for isolate scope and controller bindings.
    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
      var removeWatchCollection = [];
      var initialChanges = {};
      var changes;

      forEach(bindings, function initializeBinding(definition, scopeName) {
        var attrName = definition.attrName,
        optional = definition.optional,
        mode = definition.mode, // @, =, <, or &
        lastValue,
        parentGet, parentSet, compare, removeWatch;

        switch (mode) {

          case '@':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              strictBindingsCheck(attrName, directive.name);
              destination[scopeName] = attrs[attrName] = undefined;

            }
            removeWatch = attrs.$observe(attrName, function(value) {
              if (isString(value) || isBoolean(value)) {
                var oldValue = destination[scopeName];
                recordChanges(scopeName, value, oldValue);
                destination[scopeName] = value;
              }
            });
            attrs.$$observers[attrName].$$scope = scope;
            lastValue = attrs[attrName];
            if (isString(lastValue)) {
              // If the attribute has been provided then we trigger an interpolation to ensure
              // the value is there for use in the link fn
              destination[scopeName] = $interpolate(lastValue)(scope);
            } else if (isBoolean(lastValue)) {
              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
              // the value to boolean rather than a string, so we special case this situation
              destination[scopeName] = lastValue;
            }
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
            removeWatchCollection.push(removeWatch);
            break;

          case '=':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              strictBindingsCheck(attrName, directive.name);
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            if (parentGet.literal) {
              compare = equals;
            } else {
              compare = simpleCompare;
            }
            parentSet = parentGet.assign || function() {
              // reset the change, or we will throw this exception on every $digest
              lastValue = destination[scopeName] = parentGet(scope);
              throw $compileMinErr('nonassign',
                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
                  attrs[attrName], attrName, directive.name);
            };
            lastValue = destination[scopeName] = parentGet(scope);
            var parentValueWatch = function parentValueWatch(parentValue) {
              if (!compare(parentValue, destination[scopeName])) {
                // we are out of sync and need to copy
                if (!compare(parentValue, lastValue)) {
                  // parent changed and it has precedence
                  destination[scopeName] = parentValue;
                } else {
                  // if the parent can be assigned then do so
                  parentSet(scope, parentValue = destination[scopeName]);
                }
              }
              lastValue = parentValue;
              return lastValue;
            };
            parentValueWatch.$stateful = true;
            if (definition.collection) {
              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
            } else {
              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
            }
            removeWatchCollection.push(removeWatch);
            break;

          case '<':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              strictBindingsCheck(attrName, directive.name);
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            var isLiteral = parentGet.literal;

            var initialValue = destination[scopeName] = parentGet(scope);
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);

            removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
              if (oldValue === newValue) {
                if (oldValue === initialValue || (isLiteral && equals(oldValue, initialValue))) {
                  return;
                }
                oldValue = initialValue;
              }
              recordChanges(scopeName, newValue, oldValue);
              destination[scopeName] = newValue;
            });

            removeWatchCollection.push(removeWatch);
            break;

          case '&':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              strictBindingsCheck(attrName, directive.name);
            }
            // Don't assign Object.prototype method to scope
            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

            // Don't assign noop to destination if expression is not valid
            if (parentGet === noop && optional) break;

            destination[scopeName] = function(locals) {
              return parentGet(scope, locals);
            };
            break;
        }
      });

      function recordChanges(key, currentValue, previousValue) {
        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
          // If we have not already scheduled the top level onChangesQueue handler then do so now
          if (!onChangesQueue) {
            scope.$$postDigest(flushOnChangesQueue);
            onChangesQueue = [];
          }
          // If we have not already queued a trigger of onChanges for this controller then do so now
          if (!changes) {
            changes = {};
            onChangesQueue.push(triggerOnChangesHook);
          }
          // If the has been a change on this property already then we need to reuse the previous value
          if (changes[key]) {
            previousValue = changes[key].previousValue;
          }
          // Store this change
          changes[key] = new SimpleChange(previousValue, currentValue);
        }
      }

      function triggerOnChangesHook() {
        destination.$onChanges(changes);
        // Now clear the changes so that we schedule onChanges when more changes arrive
        changes = undefined;
      }

      return {
        initialChanges: initialChanges,
        removeWatches: removeWatchCollection.length && function removeWatches() {
          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
            removeWatchCollection[i]();
          }
        }
      };
    }
  }];
}

function SimpleChange(previous, current) {
  this.previousValue = previous;
  this.currentValue = current;
}
SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };


var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;

/**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */
function directiveNormalize(name) {
  return name
    .replace(PREFIX_REGEXP, '')
    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    });
}

/**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in AngularJS:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */

/**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */


/**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */



/**
 * Closure compiler type information
 */

function nodesetLinkingFn(
  /* angular.Scope */ scope,
  /* NodeList */ nodeList,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function directiveLinkingFn(
  /* nodesetLinkingFn */ nodesetLinkingFn,
  /* angular.Scope */ scope,
  /* Node */ node,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function tokenDifference(str1, str2) {
  var values = '',
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);

  outer:
  for (var i = 0; i < tokens1.length; i++) {
    var token = tokens1[i];
    for (var j = 0; j < tokens2.length; j++) {
      if (token === tokens2[j]) continue outer;
    }
    values += (values.length > 0 ? ' ' : '') + token;
  }
  return values;
}

function removeComments(jqNodes) {
  jqNodes = jqLite(jqNodes);
  var i = jqNodes.length;

  if (i <= 1) {
    return jqNodes;
  }

  while (i--) {
    var node = jqNodes[i];
    if (node.nodeType === NODE_TYPE_COMMENT ||
       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
         splice.call(jqNodes, i, 1);
    }
  }
  return jqNodes;
}

var $controllerMinErr = minErr('$controller');


var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
function identifierForController(controller, ident) {
  if (ident && isString(ident)) return ident;
  if (isString(controller)) {
    var match = CNTRL_REG.exec(controller);
    if (match) return match[3];
  }
}


/**
 * @ngdoc provider
 * @name $controllerProvider
 * @this
 *
 * @description
 * The {@link ng.$controller $controller service} is used by AngularJS to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */
function $ControllerProvider() {
  var controllers = {};

  /**
   * @ngdoc method
   * @name $controllerProvider#has
   * @param {string} name Controller name to check.
   */
  this.has = function(name) {
    return controllers.hasOwnProperty(name);
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */
  this.register = function(name, constructor) {
    assertNotHasOwnProperty(name, 'controller');
    if (isObject(name)) {
      extend(controllers, name);
    } else {
      controllers[name] = constructor;
    }
  };

  this.$get = ['$injector', function($injector) {

    /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */
    return function $controller(expression, locals, later, ident) {
      // PRIVATE API:
      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
      //                     If true, $controller will allocate the object with the correct
      //                     prototype chain, but will not invoke the controller until a returned
      //                     callback is invoked.
      //   param `ident` --- An optional label which overrides the label parsed from the controller
      //                     expression, if any.
      var instance, match, constructor, identifier;
      later = later === true;
      if (ident && isString(ident)) {
        identifier = ident;
      }

      if (isString(expression)) {
        match = expression.match(CNTRL_REG);
        if (!match) {
          throw $controllerMinErr('ctrlfmt',
            'Badly formed controller string \'{0}\'. ' +
            'Must match `__name__ as __id__` or `__name__`.', expression);
        }
        constructor = match[1];
        identifier = identifier || match[3];
        expression = controllers.hasOwnProperty(constructor)
            ? controllers[constructor]
            : getter(locals.$scope, constructor, true);

        if (!expression) {
          throw $controllerMinErr('ctrlreg',
            'The controller with the name \'{0}\' is not registered.', constructor);
        }

        assertArgFn(expression, constructor, true);
      }

      if (later) {
        // Instantiate controller later:
        // This machinery is used to create an instance of the object before calling the
        // controller's constructor itself.
        //
        // This allows properties to be added to the controller before the constructor is
        // invoked. Primarily, this is used for isolate scope bindings in $compile.
        //
        // This feature is not intended for use by applications, and is thus not documented
        // publicly.
        // Object creation: http://jsperf.com/create-constructor/2
        var controllerPrototype = (isArray(expression) ?
          expression[expression.length - 1] : expression).prototype;
        instance = Object.create(controllerPrototype || null);

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        return extend(function $controllerInit() {
          var result = $injector.invoke(expression, instance, locals, constructor);
          if (result !== instance && (isObject(result) || isFunction(result))) {
            instance = result;
            if (identifier) {
              // If result changed, re-assign controllerAs value to scope.
              addIdentifier(locals, identifier, instance, constructor || expression.name);
            }
          }
          return instance;
        }, {
          instance: instance,
          identifier: identifier
        });
      }

      instance = $injector.instantiate(expression, locals, constructor);

      if (identifier) {
        addIdentifier(locals, identifier, instance, constructor || expression.name);
      }

      return instance;
    };

    function addIdentifier(locals, identifier, instance, name) {
      if (!(locals && isObject(locals.$scope))) {
        throw minErr('$controller')('noscp',
          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
          name, identifier);
      }

      locals.$scope[identifier] = instance;
    }
  }];
}

/**
 * @ngdoc service
 * @name $document
 * @requires $window
 * @this
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample" name="document">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */
function $DocumentProvider() {
  this.$get = ['$window', function(window) {
    return jqLite(window.document);
  }];
}


/**
 * @private
 * @this
 * Listens for document visibility change and makes the current status accessible.
 */
function $$IsDocumentHiddenProvider() {
  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
    var doc = $document[0];
    var hidden = doc && doc.hidden;

    $document.on('visibilitychange', changeListener);

    $rootScope.$on('$destroy', function() {
      $document.off('visibilitychange', changeListener);
    });

    function changeListener() {
      hidden = doc.hidden;
    }

    return function() {
      return hidden;
    };
  }];
}

/**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 * @this
 *
 * @description
 * Any uncaught exception in AngularJS expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
 * of `$log.error()`.
 *
 * ```js
 *   angular.
 *     module('exceptionOverwrite', []).
 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
 *       return function myExceptionHandler(exception, cause) {
 *         logErrorsToBackend(exception, cause);
 *         $log.warn(exception, cause);
 *       };
 *     }]);
 * ```
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause Optional information about the context in which
 *       the error was thrown.
 *
 */
function $ExceptionHandlerProvider() {
  this.$get = ['$log', function($log) {
    return function(exception, cause) {
      $log.error.apply($log, arguments);
    };
  }];
}

var $$ForceReflowProvider = /** @this */ function() {
  this.$get = ['$document', function($document) {
    return function(domNode) {
      //the line below will force the browser to perform a repaint so
      //that all the animated elements within the animation frame will
      //be properly updated and drawn on screen. This is required to
      //ensure that the preparation animation is properly flushed so that
      //the active state picks up from there. DO NOT REMOVE THIS LINE.
      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
      if (domNode) {
        if (!domNode.nodeType && domNode instanceof jqLite) {
          domNode = domNode[0];
        }
      } else {
        domNode = $document[0].body;
      }
      return domNode.offsetWidth + 1;
    };
  }];
};

var APPLICATION_JSON = 'application/json';
var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
var JSON_START = /^\[|^\{(?!\{)/;
var JSON_ENDS = {
  '[': /]$/,
  '{': /}$/
};
var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
var $httpMinErr = minErr('$http');

function serializeValue(v) {
  if (isObject(v)) {
    return isDate(v) ? v.toISOString() : toJson(v);
  }
  return v;
}


/** @this */
function $HttpParamSerializerProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   */

  this.$get = function() {
    return function ngParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      forEachSorted(params, function(value, key) {
        if (value === null || isUndefined(value) || isFunction(value)) return;
        if (isArray(value)) {
          forEach(value, function(v) {
            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
          });
        } else {
          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
        }
      });

      return parts.join('&');
    };
  };
}

/** @this */
function $HttpParamSerializerJQLikeProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   *
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   */
  this.$get = function() {
    return function jQueryLikeParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      serialize(params, '', true);
      return parts.join('&');

      function serialize(toSerialize, prefix, topLevel) {
        if (isArray(toSerialize)) {
          forEach(toSerialize, function(value, index) {
            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
          });
        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
          forEachSorted(toSerialize, function(value, key) {
            serialize(value, prefix +
                (topLevel ? '' : '[') +
                key +
                (topLevel ? '' : ']'));
          });
        } else {
          if (isFunction(toSerialize)) {
            toSerialize = toSerialize();
          }
          parts.push(encodeUriQuery(prefix) + '=' +
              (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
        }
      }
    };
  };
}

function defaultHttpResponseTransform(data, headers) {
  if (isString(data)) {
    // Strip json vulnerability protection prefix and trim whitespace
    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

    if (tempData) {
      var contentType = headers('Content-Type');
      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);

      if (hasJsonContentType || isJsonLike(tempData)) {
        try {
          data = fromJson(tempData);
        } catch (e) {
          if (!hasJsonContentType) {
            return data;
          }
          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
          'Parse error: "{1}"', data, e);
        }
      }
    }
  }

  return data;
}

function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
}

/**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */
function parseHeaders(headers) {
  var parsed = createMap(), i;

  function fillInParsed(key, val) {
    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  }

  if (isString(headers)) {
    forEach(headers.split('\n'), function(line) {
      i = line.indexOf(':');
      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
    });
  } else if (isObject(headers)) {
    forEach(headers, function(headerVal, headerKey) {
      fillInParsed(lowercase(headerKey), trim(headerVal));
    });
  }

  return parsed;
}


/**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */
function headersGetter(headers) {
  var headersObj;

  return function(name) {
    if (!headersObj) headersObj =  parseHeaders(headers);

    if (name) {
      var value = headersObj[lowercase(name)];
      if (value === undefined) {
        value = null;
      }
      return value;
    }

    return headersObj;
  };
}


/**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */
function transformData(data, headers, status, fns) {
  if (isFunction(fns)) {
    return fns(data, headers, status);
  }

  forEach(fns, function(fn) {
    data = fn(data, headers, status);
  });

  return data;
}


function isSuccess(status) {
  return 200 <= status && status < 300;
}


/**
 * @ngdoc provider
 * @name $httpProvider
 * @this
 *
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 */
function $HttpProvider() {
  /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
   * by default. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   * - **`defaults.transformRequest`** -
   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
   * An array of functions (or a single function) which are applied to the request data.
   * By default, this is an array with one request transformation function:
   *
   *   - If the `data` property of the request configuration object contains an object, serialize it
   *     into JSON format.
   *
   * - **`defaults.transformResponse`** -
   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
   * An array of functions (or a single function) which are applied to the response data. By default,
   * this is an array which applies one response transformation function that does two things:
   *
   *  - If XSRF prefix is detected, strip it
   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *    deserialize it using a JSON parser.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   */
  var defaults = this.defaults = {
    // transform incoming response data
    transformResponse: [defaultHttpResponseTransform],

    // transform outgoing request data
    transformRequest: [function(d) {
      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
    }],

    // default headers
    headers: {
      common: {
        'Accept': 'application/json, text/plain, */*'
      },
      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
    },

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    paramSerializer: '$httpParamSerializer',

    jsonpCallbackParam: 'callback'
  };

  var useApplyAsync = false;
  /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   */
  this.useApplyAsync = function(value) {
    if (isDefined(value)) {
      useApplyAsync = !!value;
      return this;
    }
    return useApplyAsync;
  };

  /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   */
  var interceptorFactories = this.interceptors = [];

  /**
   * @ngdoc property
   * @name $httpProvider#xsrfWhitelistedOrigins
   * @description
   *
   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
   * XSRF.
   *
   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
   * Examples: `http://example.com`, `https://api.example.com:9876`
   *
   * <div class="alert alert-warning">
   *   It is not possible to whitelist specific URLs/paths. The `path`, `query` and `fragment` parts
   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
   *   `https://foo.com/` will include the XSRF token.
   * </div>
   *
   * @example
   *
   * ```js
   * // App served from `https://example.com/`.
   * angular.
   *   module('xsrfWhitelistedOriginsExample', []).
   *   config(['$httpProvider', function($httpProvider) {
   *     $httpProvider.xsrfWhitelistedOrigins.push('https://api.example.com');
   *   }]).
   *   run(['$http', function($http) {
   *     // The XSRF token will be sent.
   *     $http.get('https://api.example.com/preferences').then(...);
   *
   *     // The XSRF token will NOT be sent.
   *     $http.get('https://stats.example.com/activity').then(...);
   *   }]);
   * ```
   */
  var xsrfWhitelistedOrigins = this.xsrfWhitelistedOrigins = [];

  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {

    var defaultCache = $cacheFactory('$http');

    /**
     * Make sure that default param serializer is exposed as a function
     */
    defaults.paramSerializer = isString(defaults.paramSerializer) ?
      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

    /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */
    var reversedInterceptors = [];

    forEach(interceptorFactories, function(interceptorFactory) {
      reversedInterceptors.unshift(isString(interceptorFactory)
          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
    });

    /**
     * A function to check request URLs against a list of allowed origins.
     */
    var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfWhitelistedOrigins);

    /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core AngularJS service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
     * resolved (request success) or rejected (request failure) with a
     * {@link ng.$http#$http-returns response} object.
     *
     * ```js
     *   // Simple GET request example:
     *   $http({
     *     method: 'GET',
     *     url: '/someUrl'
     *   }).then(function successCallback(response) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }, function errorCallback(response) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
     * last argument.
     *
     * ```js
     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).then(function(){...}, function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * <div class="alert alert-warning">
     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
     * function will be reflected on the scope and in any templates where the object is data-bound.
     * To prevent this, transform functions should have no side-effects.
     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
     * </div>
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * AngularJS provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
     * an array with one function that does the following:
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
     * an array with one function that does the following:
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *      deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish to override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
     * set the config.cache value or the default cache value to TRUE or to a cache object (created
     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
     * precedence over the default cache value.
     *
     * In order to:
     *   * cache all responses - set the default cache value to TRUE or to a cache object
     *   * cache a specific response - set config.cache value to TRUE or to a cache object
     *
     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
     * then the default `$cacheFactory("$http")` object is used.
     *
     * The default cache value can be set by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
     *
     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
     * the relevant cache object. The next time the same request is made, the response is returned
     * from the cache without sending a request to the server.
     *
     * Take note that:
     *
     *   * Only GET and JSONP requests are cached.
     *   * The cache key is the request URL including search parameters; headers are not considered.
     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
     *   * If multiple identical requests are made using the same cache, which is not yet populated,
     *     one request will be made to the server and remaining requests will return the same response.
     *   * A cache-control header on the response does not affect if or how responses are cached.
     *
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * AngularJS will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * AngularJS will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
     * which the attacker can trick an authenticated user into unknowingly executing actions on your
     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
     * the cookie, your server can be assured that the XHR came from JavaScript running on your
     * domain.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
     * sure that only JavaScript running on your domain could have sent the request. The token must
     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
     * want to, you can whitelist additional origins to also receive the XSRF token, by adding them
     * to {@link ng.$httpProvider#xsrfWhitelistedOrigins xsrfWhitelistedOrigins}. This might be
     * useful, for example, if your application, served from `example.com`, needs to access your API
     * at `api.example.com`.
     * See {@link ng.$httpProvider#xsrfWhitelistedOrigins $httpProvider.xsrfWhitelistedOrigins} for
     * more details.
     *
     * <div class="alert alert-danger">
     *   **Warning**<br />
     *   Only whitelist origins that you have control over and make sure you understand the
     *   implications of doing so.
     * </div>
     *
     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
     * `$http.defaults` at run-time, or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple AngularJS apps share the
     * same domain or subdomain, we recommend that each application uses a unique cookie name.
     *
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
     *      See {@link $http#caching $http Caching} for more information.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *
     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
     *
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
     *
     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
     *   or rejected (request failure) with a response object.
     *
     *   The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with
     *     the transform functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used
     *     to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
     *     (`complete`, `error`, `timeout` or `abort`).
     *
     *
     *   A response status code between 200 and 299 is considered a success status
     *   and will result in the success callback being called. Any response status
     *   code outside of that range is considered an error status and will result
     *   in the error callback being called.
     *   Also, status codes less than -1 are normalized to zero. -1 usually means
     *   the request was aborted, e.g. using a `config.timeout`. More information
     *   about the status might be available in the `xhrStatus` property.
     *
     *   Note that if the response is a redirect, XMLHttpRequest will transparently
     *   follow it, meaning that the outcome (success or error) will be determined
     *   by the final response status code.
     *
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample" name="http-service">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
      // We must whitelist the JSONP endpoint that we are using to show that we trust it
      $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'https://angularjs.org/**'
      ]);
    }])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            then(function(response) {
              $scope.status = response.status;
              $scope.data = response.data;
            }, function(response) {
              $scope.data = response.data || 'Request failed';
              $scope.status = response.status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */
    function $http(requestConfig) {

      if (!isObject(requestConfig)) {
        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
      }

      if (!isString($sce.valueOf(requestConfig.url))) {
        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
      }

      var config = extend({
        method: 'get',
        transformRequest: defaults.transformRequest,
        transformResponse: defaults.transformResponse,
        paramSerializer: defaults.paramSerializer,
        jsonpCallbackParam: defaults.jsonpCallbackParam
      }, requestConfig);

      config.headers = mergeHeaders(requestConfig);
      config.method = uppercase(config.method);
      config.paramSerializer = isString(config.paramSerializer) ?
          $injector.get(config.paramSerializer) : config.paramSerializer;

      $browser.$$incOutstandingRequestCount('$http');

      var requestInterceptors = [];
      var responseInterceptors = [];
      var promise = $q.resolve(config);

      // apply interceptors
      forEach(reversedInterceptors, function(interceptor) {
        if (interceptor.request || interceptor.requestError) {
          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
        }
        if (interceptor.response || interceptor.responseError) {
          responseInterceptors.push(interceptor.response, interceptor.responseError);
        }
      });

      promise = chainInterceptors(promise, requestInterceptors);
      promise = promise.then(serverRequest);
      promise = chainInterceptors(promise, responseInterceptors);
      promise = promise.finally(completeOutstandingRequest);

      return promise;


      function chainInterceptors(promise, interceptors) {
        for (var i = 0, ii = interceptors.length; i < ii;) {
          var thenFn = interceptors[i++];
          var rejectFn = interceptors[i++];

          promise = promise.then(thenFn, rejectFn);
        }

        interceptors.length = 0;

        return promise;
      }

      function completeOutstandingRequest() {
        $browser.$$completeOutstandingRequest(noop, '$http');
      }

      function executeHeaderFns(headers, config) {
        var headerContent, processedHeaders = {};

        forEach(headers, function(headerFn, header) {
          if (isFunction(headerFn)) {
            headerContent = headerFn(config);
            if (headerContent != null) {
              processedHeaders[header] = headerContent;
            }
          } else {
            processedHeaders[header] = headerFn;
          }
        });

        return processedHeaders;
      }

      function mergeHeaders(config) {
        var defHeaders = defaults.headers,
            reqHeaders = extend({}, config.headers),
            defHeaderName, lowercaseDefHeaderName, reqHeaderName;

        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
        defaultHeadersIteration:
        for (defHeaderName in defHeaders) {
          lowercaseDefHeaderName = lowercase(defHeaderName);

          for (reqHeaderName in reqHeaders) {
            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
              continue defaultHeadersIteration;
            }
          }

          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
        }

        // execute if header value is a function for merged headers
        return executeHeaderFns(reqHeaders, shallowCopy(config));
      }

      function serverRequest(config) {
        var headers = config.headers;
        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

        // strip content-type if data is undefined
        if (isUndefined(reqData)) {
          forEach(headers, function(value, header) {
            if (lowercase(header) === 'content-type') {
              delete headers[header];
            }
          });
        }

        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
          config.withCredentials = defaults.withCredentials;
        }

        // send request
        return sendReq(config, reqData).then(transformResponse, transformResponse);
      }

      function transformResponse(response) {
        // make a copy since the response must be cacheable
        var resp = extend({}, response);
        resp.data = transformData(response.data, response.headers, response.status,
                                  config.transformResponse);
        return (isSuccess(response.status))
          ? resp
          : $q.reject(resp);
      }
    }

    $http.pendingRequests = [];

    /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     *
     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
     * the url must be declared, via {@link $sce} as a trusted resource URL.
     * You can trust a URL by adding it to the whitelist via
     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
     *
     * You should avoid generating the URL for the JSONP request from user provided data.
     * Provide additional query parameters via `params` property of the `config` parameter, rather than
     * modifying the URL itself.
     *
     * JSONP requests must specify a callback to be used in the response from the server. This callback
     * is passed as a query parameter in the request. You must specify the name of this parameter by
     * setting the `jsonpCallbackParam` property on the request config object.
     *
     * ```
     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
     * ```
     *
     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
     * Initially this is set to `'callback'`.
     *
     * <div class="alert alert-danger">
     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
     * parameter value should go.
     * </div>
     *
     * If you would like to customise where and how the callbacks are stored then try overriding
     * or decorating the {@link $jsonpCallbacks} service.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */
    createShortMethods('get', 'delete', 'head', 'jsonp');

    /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

     /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
      * See {@link ng.$http#$http-returns `$http()` return value}.
      */
    createShortMethodsWithData('post', 'put', 'patch');

        /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */
    $http.defaults = defaults;


    return $http;


    function createShortMethods(names) {
      forEach(arguments, function(name) {
        $http[name] = function(url, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url
          }));
        };
      });
    }


    function createShortMethodsWithData(name) {
      forEach(arguments, function(name) {
        $http[name] = function(url, data, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url,
            data: data
          }));
        };
      });
    }


    /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */
    function sendReq(config, reqData) {
      var deferred = $q.defer(),
          promise = deferred.promise,
          cache,
          cachedResp,
          reqHeaders = config.headers,
          isJsonp = lowercase(config.method) === 'jsonp',
          url = config.url;

      if (isJsonp) {
        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
        url = $sce.getTrustedResourceUrl(url);
      } else if (!isString(url)) {
        // If it is not a string then the URL must be a $sce trusted object
        url = $sce.valueOf(url);
      }

      url = buildUrl(url, config.paramSerializer(config.params));

      if (isJsonp) {
        // Check the url and add the JSONP callback placeholder
        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
      }

      $http.pendingRequests.push(config);
      promise.then(removePendingReq, removePendingReq);

      if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
        cache = isObject(config.cache) ? config.cache
            : isObject(/** @type {?} */ (defaults).cache)
              ? /** @type {?} */ (defaults).cache
              : defaultCache;
      }

      if (cache) {
        cachedResp = cache.get(url);
        if (isDefined(cachedResp)) {
          if (isPromiseLike(cachedResp)) {
            // cached request has already been sent, but there is no response yet
            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
          } else {
            // serving from cache
            if (isArray(cachedResp)) {
              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
            } else {
              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
            }
          }
        } else {
          // put the promise for the non-transformed response into cache as a placeholder
          cache.put(url, promise);
        }
      }


      // if we won't have the response in cache, set the xsrf headers and
      // send the request to the backend
      if (isUndefined(cachedResp)) {
        var xsrfValue = urlIsAllowedOrigin(config.url)
            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
            : undefined;
        if (xsrfValue) {
          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
        }

        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
            config.withCredentials, config.responseType,
            createApplyHandlers(config.eventHandlers),
            createApplyHandlers(config.uploadEventHandlers));
      }

      return promise;

      function createApplyHandlers(eventHandlers) {
        if (eventHandlers) {
          var applyHandlers = {};
          forEach(eventHandlers, function(eventHandler, key) {
            applyHandlers[key] = function(event) {
              if (useApplyAsync) {
                $rootScope.$applyAsync(callEventHandler);
              } else if ($rootScope.$$phase) {
                callEventHandler();
              } else {
                $rootScope.$apply(callEventHandler);
              }

              function callEventHandler() {
                eventHandler(event);
              }
            };
          });
          return applyHandlers;
        }
      }


      /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */
      function done(status, response, headersString, statusText, xhrStatus) {
        if (cache) {
          if (isSuccess(status)) {
            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
          } else {
            // remove promise from the cache
            cache.remove(url);
          }
        }

        function resolveHttpPromise() {
          resolvePromise(response, status, headersString, statusText, xhrStatus);
        }

        if (useApplyAsync) {
          $rootScope.$applyAsync(resolveHttpPromise);
        } else {
          resolveHttpPromise();
          if (!$rootScope.$$phase) $rootScope.$apply();
        }
      }


      /**
       * Resolves the raw $http promise.
       */
      function resolvePromise(response, status, headers, statusText, xhrStatus) {
        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
        status = status >= -1 ? status : 0;

        (isSuccess(status) ? deferred.resolve : deferred.reject)({
          data: response,
          status: status,
          headers: headersGetter(headers),
          config: config,
          statusText: statusText,
          xhrStatus: xhrStatus
        });
      }

      function resolvePromiseWithResult(result) {
        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
      }

      function removePendingReq() {
        var idx = $http.pendingRequests.indexOf(config);
        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
      }
    }


    function buildUrl(url, serializedParams) {
      if (serializedParams.length > 0) {
        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
      }
      return url;
    }

    function sanitizeJsonpCallbackParam(url, cbKey) {
      var parts = url.split('?');
      if (parts.length > 2) {
        // Throw if the url contains more than one `?` query indicator
        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
      }
      var params = parseKeyValue(parts[1]);
      forEach(params, function(value, key) {
        if (value === 'JSON_CALLBACK') {
          // Throw if the url already contains a reference to JSON_CALLBACK
          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
        }
        if (key === cbKey) {
          // Throw if the callback param was already provided
          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
        }
      });

      // Add in the JSON_CALLBACK callback param value
      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';

      return url;
    }
  }];
}

/**
 * @ngdoc service
 * @name $xhrFactory
 * @this
 *
 * @description
 * Factory function used to create XMLHttpRequest objects.
 *
 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
 *
 * ```
 * angular.module('myApp', [])
 * .factory('$xhrFactory', function() {
 *   return function createXhr(method, url) {
 *     return new window.XMLHttpRequest({mozSystem: true});
 *   };
 * });
 * ```
 *
 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
 * @param {string} url URL of the request.
 */
function $xhrFactoryProvider() {
  this.$get = function() {
    return function createXhr() {
      return new window.XMLHttpRequest();
    };
  };
}

/**
 * @ngdoc service
 * @name $httpBackend
 * @requires $jsonpCallbacks
 * @requires $document
 * @requires $xhrFactory
 * @this
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */
function $HttpBackendProvider() {
  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
  }];
}

function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
  // TODO(vojta): fix the signature
  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
    url = url || $browser.url();

    if (lowercase(method) === 'jsonp') {
      var callbackPath = callbacks.createCallback(url);
      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
        var response = (status === 200) && callbacks.getResponse(callbackPath);
        completeRequest(callback, status, response, '', text, 'complete');
        callbacks.removeCallback(callbackPath);
      });
    } else {

      var xhr = createXhr(method, url);
      var abortedByTimeout = false;

      xhr.open(method, url, true);
      forEach(headers, function(value, key) {
        if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
        }
      });

      xhr.onload = function requestLoaded() {
        var statusText = xhr.statusText || '';

        // responseText is the old-school way of retrieving response (supported by IE9)
        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
        var response = ('response' in xhr) ? xhr.response : xhr.responseText;

        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
        var status = xhr.status === 1223 ? 204 : xhr.status;

        // fix status code when it is 0 (0 status is undocumented).
        // Occurs when accessing file resources or on Android 4.1 stock browser
        // while retrieving files from application cache.
        if (status === 0) {
          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
        }

        completeRequest(callback,
            status,
            response,
            xhr.getAllResponseHeaders(),
            statusText,
            'complete');
      };

      var requestError = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '', 'error');
      };

      var requestAborted = function() {
        completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
      };

      var requestTimeout = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '', 'timeout');
      };

      xhr.onerror = requestError;
      xhr.ontimeout = requestTimeout;
      xhr.onabort = requestAborted;

      forEach(eventHandlers, function(value, key) {
        xhr.addEventListener(key, value);
      });

      forEach(uploadEventHandlers, function(value, key) {
        xhr.upload.addEventListener(key, value);
      });

      if (withCredentials) {
        xhr.withCredentials = true;
      }

      if (responseType) {
        try {
          xhr.responseType = responseType;
        } catch (e) {
          // WebKit added support for the json responseType value on 09/03/2013
          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
          // known to throw when setting the value "json" as the response type. Other older
          // browsers implementing the responseType
          //
          // The json response type can be ignored if not supported, because JSON payloads are
          // parsed on the client-side regardless.
          if (responseType !== 'json') {
            throw e;
          }
        }
      }

      xhr.send(isUndefined(post) ? null : post);
    }

    // Since we are using xhr.abort() when a request times out, we have to set a flag that
    // indicates to requestAborted if the request timed out or was aborted.
    //
    // http.timeout = numerical timeout   timeout
    // http.timeout = $timeout            timeout
    // http.timeout = promise             abort
    // xhr.abort()                        abort (The xhr object is normally inaccessible, but
    //                                    can be exposed with the xhrFactory)
    if (timeout > 0) {
      var timeoutId = $browserDefer(function() {
        timeoutRequest('timeout');
      }, timeout);
    } else if (isPromiseLike(timeout)) {
      timeout.then(function() {
        timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
      });
    }

    function timeoutRequest(reason) {
      abortedByTimeout = reason === 'timeout';
      if (jsonpDone) {
        jsonpDone();
      }
      if (xhr) {
        xhr.abort();
      }
    }

    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
      // cancel timeout and subsequent timeout promise resolution
      if (isDefined(timeoutId)) {
        $browserDefer.cancel(timeoutId);
      }
      jsonpDone = xhr = null;

      callback(status, response, headersString, statusText, xhrStatus);
    }
  };

  function jsonpReq(url, callbackPath, done) {
    url = url.replace('JSON_CALLBACK', callbackPath);
    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
    // - fetches local scripts via XHR and evals them
    // - adds and immediately removes script elements from the document
    var script = rawDocument.createElement('script'), callback = null;
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;

    callback = function(event) {
      script.removeEventListener('load', callback);
      script.removeEventListener('error', callback);
      rawDocument.body.removeChild(script);
      script = null;
      var status = -1;
      var text = 'unknown';

      if (event) {
        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
          event = { type: 'error' };
        }
        text = event.type;
        status = event.type === 'error' ? 404 : 200;
      }

      if (done) {
        done(status, text);
      }
    };

    script.addEventListener('load', callback);
    script.addEventListener('error', callback);
    rawDocument.body.appendChild(script);
    return callback;
  }
}

var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
$interpolateMinErr.throwNoconcat = function(text) {
  throw $interpolateMinErr('noconcat',
      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
      'interpolations that concatenate multiple expressions when a trusted value is ' +
      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
};

$interpolateMinErr.interr = function(text, err) {
  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
};

/**
 * @ngdoc provider
 * @name $interpolateProvider
 * @this
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * <div class="alert alert-danger">
 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
 * template within a Python Jinja template (or any other template language). Mixing templating
 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
 * security bugs!
 * </div>
 *
 * @example
<example name="custom-interpolation-markup" module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */
function $InterpolateProvider() {
  var startSymbol = '{{';
  var endSymbol = '}}';

  /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.startSymbol = function(value) {
    if (value) {
      startSymbol = value;
      return this;
    }
    return startSymbol;
  };

  /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.endSymbol = function(value) {
    if (value) {
      endSymbol = value;
      return this;
    }
    return endSymbol;
  };


  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
    var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

    function escape(ch) {
      return '\\\\\\' + ch;
    }

    function unescapeText(text) {
      return text.replace(escapedStartRegexp, startSymbol).
        replace(escapedEndRegexp, endSymbol);
    }

    // TODO: this is the same as the constantWatchDelegate in parse.js
    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
        unwatch();
        return constantInterp(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'AngularJS';
     *   expect(exp(context)).toEqual('Hello AngularJS!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * #### Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example name="interpolation">
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @knownIssue
     * It is currently not possible for an interpolated expression to contain the interpolation end
     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
     *
     * @knownIssue
     * All directives and components must use the standard `{{` `}}` interpolation symbols
     * in their templates. If you change the application interpolation symbols the {@link $compile}
     * service will attempt to denormalize the standard symbols to the custom symbols.
     * The denormalization process is not clever enough to know not to replace instances of the standard
     * symbols where they would not normally be treated as interpolation symbols. For example in the following
     * code snippet the closing braces of the literal object will get incorrectly denormalized:
     *
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"}}">
     * ```
     *
     * The workaround is to ensure that such instances are separated by whitespace:
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"} }">
     * ```
     *
     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */
    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
      var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;

      // Provide a quick exit and simplified result function for text with no interpolation
      if (!text.length || text.indexOf(startSymbol) === -1) {
        if (mustHaveExpression && !contextAllowsConcatenation) return;

        var unescapedText = unescapeText(text);
        if (contextAllowsConcatenation) {
          unescapedText = $sce.getTrusted(trustedContext, unescapedText);
        }
        var constantInterp = valueFn(unescapedText);
        constantInterp.exp = text;
        constantInterp.expressions = [];
        constantInterp.$$watchDelegate = constantWatchDelegate;

        return constantInterp;
      }

      allOrNothing = !!allOrNothing;
      var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns,
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [],
          singleExpression;


      while (index < textLength) {
        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
          if (index !== startIndex) {
            concat.push(unescapeText(text.substring(index, startIndex)));
          }
          exp = text.substring(startIndex + startSymbolLength, endIndex);
          expressions.push(exp);
          index = endIndex + endSymbolLength;
          expressionPositions.push(concat.length);
          concat.push(''); // Placeholder that will get replaced with the evaluated expression.
        } else {
          // we did not find an interpolation, so we have to add the remainder to the separators array
          if (index !== textLength) {
            concat.push(unescapeText(text.substring(index)));
          }
          break;
        }
      }

      singleExpression = concat.length === 1 && expressionPositions.length === 1;
      // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
      // objects rather than simple strings
      // (we don't modify the expression if the input consists of only a single trusted input)
      var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
      parseFns = expressions.map(function(exp) { return $parse(exp, interceptor); });

      // Concatenating expressions makes it hard to reason about whether some combination of
      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
      // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
      // we ensure that the value that's used is assigned or constructed by some JS code somewhere
      // that is more testable or make it obvious that you bound the value to some user controlled
      // value.  This helps reduce the load when auditing for XSS issues.

      // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
      // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
      // or on the overall concatenated string (losing trusted types used in the mix, by design).
      // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
      // only used in srcdoc attributes, this would not be very useful.

      if (!mustHaveExpression || expressions.length) {
        var compute = function(values) {
          for (var i = 0, ii = expressions.length; i < ii; i++) {
            if (allOrNothing && isUndefined(values[i])) return;
            concat[expressionPositions[i]] = values[i];
          }

          if (contextAllowsConcatenation) {
            // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
          } else if (trustedContext && concat.length > 1) {
            // This context does not allow more than one part, e.g. expr + string or exp + exp.
            $interpolateMinErr.throwNoconcat(text);
          }
          // In an unprivileged context or only one part: just concatenate and return.
          return concat.join('');
        };

        return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }

          }, {
          // all of these properties are undocumented for now
          exp: text, //just for compatibility with regular watchers created via $watch
          expressions: expressions,
          $$watchDelegate: function(scope, listener) {
            var lastValue;
            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
              var currValue = compute(values);
              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
              lastValue = currValue;
            });
          }
        });
      }

      function parseStringifyInterceptor(value) {
        try {
          // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
          // parts of a full URL. We don't care about losing the trustedness here.
          // In non-concatenable contexts, where there is only one expression, this interceptor is
          // not applied to the expression.
          value = (trustedContext && !contextAllowsConcatenation) ?
                    $sce.getTrusted(trustedContext, value) :
                    $sce.valueOf(value);
          return allOrNothing && !isDefined(value) ? value : stringify(value);
        } catch (err) {
          $exceptionHandler($interpolateMinErr.interr(text, err));
        }
      }
    }


    /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */
    $interpolate.startSymbol = function() {
      return startSymbol;
    };


    /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */
    $interpolate.endSymbol = function() {
      return endSymbol;
    };

    return $interpolate;
  }];
}

var $intervalMinErr = minErr('$interval');

/** @this */
function $IntervalProvider() {
  this.$get = ['$$intervalFactory', '$window',
       function($$intervalFactory,   $window) {
    var intervals = {};
    var setIntervalFn = function(tick, delay, deferred) {
      var id = $window.setInterval(tick, delay);
      intervals[id] = deferred;
      return id;
    };
    var clearIntervalFn = function(id) {
      $window.clearInterval(id);
      delete intervals[id];
    };

    /**
     * @ngdoc service
     * @name $interval
     *
     * @description
     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
     * milliseconds.
     *
     * The return value of registering an interval function is a promise. This promise will be
     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
     * run indefinitely if `count` is not defined. The value of the notification will be the
     * number of iterations that have run.
     * To cancel an interval, call `$interval.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
     * time.
     *
     * <div class="alert alert-warning">
     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
     * with them.  In particular they are not automatically destroyed when a controller's scope or a
     * directive's element are destroyed.
     * You should take this into consideration and make sure to always cancel the interval at the
     * appropriate moment.  See the example below for more details on how and when to do this.
     * </div>
     *
     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
     *   are passed (see below), the function is called with the current iteration count.
     * @param {number} delay Number of milliseconds between each function call.
     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
     *   indefinitely.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
     *
     * @example
     * <example module="intervalExample" name="interval-service">
     * <file name="index.html">
     *   <script>
     *     angular.module('intervalExample', [])
     *       .controller('ExampleController', ['$scope', '$interval',
     *         function($scope, $interval) {
     *           $scope.format = 'M/d/yy h:mm:ss a';
     *           $scope.blood_1 = 100;
     *           $scope.blood_2 = 120;
     *
     *           var stop;
     *           $scope.fight = function() {
     *             // Don't start a new fight if we are already fighting
     *             if ( angular.isDefined(stop) ) return;
     *
     *             stop = $interval(function() {
     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
     *                 $scope.blood_1 = $scope.blood_1 - 3;
     *                 $scope.blood_2 = $scope.blood_2 - 4;
     *               } else {
     *                 $scope.stopFight();
     *               }
     *             }, 100);
     *           };
     *
     *           $scope.stopFight = function() {
     *             if (angular.isDefined(stop)) {
     *               $interval.cancel(stop);
     *               stop = undefined;
     *             }
     *           };
     *
     *           $scope.resetFight = function() {
     *             $scope.blood_1 = 100;
     *             $scope.blood_2 = 120;
     *           };
     *
     *           $scope.$on('$destroy', function() {
     *             // Make sure that the interval is destroyed too
     *             $scope.stopFight();
     *           });
     *         }])
     *       // Register the 'myCurrentTime' directive factory method.
     *       // We inject $interval and dateFilter service since the factory method is DI.
     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
     *         function($interval, dateFilter) {
     *           // return the directive link function. (compile function not needed)
     *           return function(scope, element, attrs) {
     *             var format,  // date format
     *                 stopTime; // so that we can cancel the time updates
     *
     *             // used to update the UI
     *             function updateTime() {
     *               element.text(dateFilter(new Date(), format));
     *             }
     *
     *             // watch the expression, and update the UI on change.
     *             scope.$watch(attrs.myCurrentTime, function(value) {
     *               format = value;
     *               updateTime();
     *             });
     *
     *             stopTime = $interval(updateTime, 1000);
     *
     *             // listen on DOM destroy (removal) event, and cancel the next UI update
     *             // to prevent updating time after the DOM element was removed.
     *             element.on('$destroy', function() {
     *               $interval.cancel(stopTime);
     *             });
     *           }
     *         }]);
     *   </script>
     *
     *   <div>
     *     <div ng-controller="ExampleController">
     *       <label>Date format: <input ng-model="format"></label> <hr/>
     *       Current time is: <span my-current-time="format"></span>
     *       <hr/>
     *       Blood 1 : <font color='red'>{{blood_1}}</font>
     *       Blood 2 : <font color='red'>{{blood_2}}</font>
     *       <button type="button" data-ng-click="fight()">Fight</button>
     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
     *     </div>
     *   </div>
     *
     * </file>
     * </example>
     */
    var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);

    /**
     * @ngdoc method
     * @name $interval#cancel
     *
     * @description
     * Cancels a task associated with the `promise`.
     *
     * @param {Promise=} promise returned by the `$interval` function.
     * @returns {boolean} Returns `true` if the task was successfully canceled.
     */
    interval.cancel = function(promise) {
      if (!promise) return false;

      if (!promise.hasOwnProperty('$$intervalId')) {
        throw $intervalMinErr('badprom',
            '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
      }

      if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;

      var id = promise.$$intervalId;
      var deferred = intervals[id];

      // Interval cancels should not report an unhandled promise.
      markQExceptionHandled(deferred.promise);
      deferred.reject('canceled');
      clearIntervalFn(id);

      return true;
    };

    return interval;
  }];
}

/** @this */
function $$IntervalFactoryProvider() {
  this.$get = ['$browser', '$q', '$$q', '$rootScope',
       function($browser,   $q,   $$q,   $rootScope) {
    return function intervalFactory(setIntervalFn, clearIntervalFn) {
      return function intervalFn(fn, delay, count, invokeApply) {
        var hasParams = arguments.length > 4,
            args = hasParams ? sliceArgs(arguments, 4) : [],
            iteration = 0,
            skipApply = isDefined(invokeApply) && !invokeApply,
            deferred = (skipApply ? $$q : $q).defer(),
            promise = deferred.promise;

        count = isDefined(count) ? count : 0;

        function callback() {
          if (!hasParams) {
            fn(iteration);
          } else {
            fn.apply(null, args);
          }
        }

        function tick() {
          if (skipApply) {
            $browser.defer(callback);
          } else {
            $rootScope.$evalAsync(callback);
          }
          deferred.notify(iteration++);

          if (count > 0 && iteration >= count) {
            deferred.resolve(iteration);
            clearIntervalFn(promise.$$intervalId);
          }

          if (!skipApply) $rootScope.$apply();
        }

        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);

        return promise;
      };
    };
  }];
}

/**
 * @ngdoc service
 * @name $jsonpCallbacks
 * @requires $window
 * @description
 * This service handles the lifecycle of callbacks to handle JSONP requests.
 * Override this service if you wish to customise where the callbacks are stored and
 * how they vary compared to the requested url.
 */
var $jsonpCallbacksProvider = /** @this */ function() {
  this.$get = function() {
    var callbacks = angular.callbacks;
    var callbackMap = {};

    function createCallback(callbackId) {
      var callback = function(data) {
        callback.data = data;
        callback.called = true;
      };
      callback.id = callbackId;
      return callback;
    }

    return {
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#createCallback
       * @param {string} url the url of the JSONP request
       * @returns {string} the callback path to send to the server as part of the JSONP request
       * @description
       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
       */
      createCallback: function(url) {
        var callbackId = '_' + (callbacks.$$counter++).toString(36);
        var callbackPath = 'angular.callbacks.' + callbackId;
        var callback = createCallback(callbackId);
        callbackMap[callbackPath] = callbacks[callbackId] = callback;
        return callbackPath;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#wasCalled
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
       * @description
       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
       * callback that was passed in the request.
       */
      wasCalled: function(callbackPath) {
        return callbackMap[callbackPath].called;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#getResponse
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {*} the data received from the response via the registered callback
       * @description
       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
       * in the JSONP response.
       */
      getResponse: function(callbackPath) {
        return callbackMap[callbackPath].data;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#removeCallback
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @description
       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
       * completed or timed-out.
       */
      removeCallback: function(callbackPath) {
        var callback = callbackMap[callbackPath];
        delete callbacks[callback.id];
        delete callbackMap[callbackPath];
      }
    };
  };
};

/**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various AngularJS components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */

/* global stripHash: true */

var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
var $locationMinErr = minErr('$location');


/**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
function encodePath(path) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    // decode forward slashes to prevent them from being double encoded
    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
  }

  return segments.join('/');
}

function decodePath(path, html5Mode) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    segments[i] = decodeURIComponent(segments[i]);
    if (html5Mode) {
      // encode forward slashes to prevent them from being mistaken for path separators
      segments[i] = segments[i].replace(/\//g, '%2F');
    }
  }

  return segments.join('/');
}

function normalizePath(pathValue, searchValue, hashValue) {
  var search = toKeyValue(searchValue),
    hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
    path = encodePath(pathValue);

  return path + (search ? '?' + search : '') + hash;
}

function parseAbsoluteUrl(absoluteUrl, locationObj) {
  var parsedUrl = urlResolve(absoluteUrl);

  locationObj.$$protocol = parsedUrl.protocol;
  locationObj.$$host = parsedUrl.hostname;
  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
}

var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
function parseAppUrl(url, locationObj, html5Mode) {

  if (DOUBLE_SLASH_REGEX.test(url)) {
    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
  }

  var prefixed = (url.charAt(0) !== '/');
  if (prefixed) {
    url = '/' + url;
  }
  var match = urlResolve(url);
  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
  locationObj.$$path = decodePath(path, html5Mode);
  locationObj.$$search = parseKeyValue(match.search);
  locationObj.$$hash = decodeURIComponent(match.hash);

  // make sure path starts with '/';
  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
    locationObj.$$path = '/' + locationObj.$$path;
  }
}

function startsWith(str, search) {
  return str.slice(0, search.length) === search;
}

/**
 *
 * @param {string} base
 * @param {string} url
 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
 *                   the expected string.
 */
function stripBaseUrl(base, url) {
  if (startsWith(url, base)) {
    return url.substr(base.length);
  }
}

function stripHash(url) {
  var index = url.indexOf('#');
  return index === -1 ? url : url.substr(0, index);
}

function stripFile(url) {
  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
}

/* return the server only (scheme://host:port) */
function serverBase(url) {
  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
}


/**
 * LocationHtml5Url represents a URL
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} basePrefix URL path prefix
 */
function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
  this.$$html5 = true;
  basePrefix = basePrefix || '';
  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given HTML5 (regular) URL string into properties
   * @param {string} url HTML5 URL
   * @private
   */
  this.$$parse = function(url) {
    var pathUrl = stripBaseUrl(appBaseNoFile, url);
    if (!isString(pathUrl)) {
      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
          appBaseNoFile);
    }

    parseAppUrl(pathUrl, this, true);

    if (!this.$$path) {
      this.$$path = '/';
    }

    this.$$compose();
  };

  this.$$normalizeUrl = function(url) {
    return appBaseNoFile + url.substr(1); // first char is always '/'
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }
    var appUrl, prevAppUrl;
    var rewrittenUrl;


    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
      prevAppUrl = appUrl;
      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
      } else {
        rewrittenUrl = appBase + prevAppUrl;
      }
    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBaseNoFile + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {

  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given hashbang URL into properties
   * @param {string} url Hashbang URL
   * @private
   */
  this.$$parse = function(url) {
    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
    var withoutHashUrl;

    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {

      // The rest of the URL starts with a hash so we have
      // got either a hashbang path or a plain hash fragment
      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
      if (isUndefined(withoutHashUrl)) {
        // There was no hashbang prefix so we just have a hash fragment
        withoutHashUrl = withoutBaseUrl;
      }

    } else {
      // There was no hashbang path nor hash fragment:
      // If we are in HTML5 mode we use what is left as the path;
      // Otherwise we ignore what is left
      if (this.$$html5) {
        withoutHashUrl = withoutBaseUrl;
      } else {
        withoutHashUrl = '';
        if (isUndefined(withoutBaseUrl)) {
          appBase = url;
          /** @type {?} */ (this).replace();
        }
      }
    }

    parseAppUrl(withoutHashUrl, this, false);

    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

    this.$$compose();

    /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of AngularJS, we're always using pathnames that
     * do not include drive names for routing.
     */
    function removeWindowsDriveName(path, url, base) {
      /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */
      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

      var firstPathSegmentMatch;

      //Get the relative path from the input URL.
      if (startsWith(url, base)) {
        url = url.replace(base, '');
      }

      // The input URL intentionally contains a first path segment that ends with a colon.
      if (windowsFilePathExp.exec(url)) {
        return path;
      }

      firstPathSegmentMatch = windowsFilePathExp.exec(path);
      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
    }
  };

  this.$$normalizeUrl = function(url) {
    return appBase + (url ? hashPrefix + url : '');
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (stripHash(appBase) === stripHash(url)) {
      this.$$parse(url);
      return true;
    }
    return false;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
  this.$$html5 = true;
  LocationHashbangUrl.apply(this, arguments);

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }

    var rewrittenUrl;
    var appUrl;

    if (appBase === stripHash(url)) {
      rewrittenUrl = url;
    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBase + hashPrefix + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };

  this.$$normalizeUrl = function(url) {
    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
    return appBase + hashPrefix + url;
  };
}


var locationPrototype = {

  /**
   * Ensure absolute URL is initialized.
   * @private
   */
  $$absUrl:'',

  /**
   * Are we in html5 mode?
   * @private
   */
  $$html5: false,

  /**
   * Has any change been replacing?
   * @private
   */
  $$replace: false,

  /**
   * Compose url and update `url` and `absUrl` property
   * @private
   */
  $$compose: function() {
    this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
    this.$$absUrl = this.$$normalizeUrl(this.$$url);
    this.$$urlUpdatedByLocation = true;
  },

  /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full URL representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full URL
   */
  absUrl: locationGetter('$$absUrl'),

  /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */
  url: function(url) {
    if (isUndefined(url)) {
      return this.$$url;
    }

    var match = PATH_MATCH.exec(url);
    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
    if (match[2] || match[1] || url === '') this.search(match[3] || '');
    this.hash(match[5] || '');

    return this;
  },

  /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current URL
   */
  protocol: locationGetter('$$protocol'),

  /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current URL.
   *
   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current URL.
   */
  host: locationGetter('$$host'),

  /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */
  port: locationGetter('$$port'),

  /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current URL when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
   */
  path: locationGetterSetter('$$path', function(path) {
    path = path !== null ? path.toString() : '';
    return path.charAt(0) === '/' ? path : '/' + path;
  }),

  /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current URL when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the URL.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */
  search: function(search, paramValue) {
    switch (arguments.length) {
      case 0:
        return this.$$search;
      case 1:
        if (isString(search) || isNumber(search)) {
          search = search.toString();
          this.$$search = parseKeyValue(search);
        } else if (isObject(search)) {
          search = copy(search, {});
          // remove object undefined or null properties
          forEach(search, function(value, key) {
            if (value == null) delete search[key];
          });

          this.$$search = search;
        } else {
          throw $locationMinErr('isrcharg',
              'The first argument of the `$location#search()` call must be a string or an object.');
        }
        break;
      default:
        if (isUndefined(paramValue) || paramValue === null) {
          delete this.$$search[search];
        } else {
          this.$$search[search] = paramValue;
        }
    }

    this.$$compose();
    return this;
  },

  /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Returns the hash fragment when called without any parameters.
   *
   * Changes the hash fragment when called with a parameter and returns `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */
  hash: locationGetterSetter('$$hash', function(hash) {
    return hash !== null ? hash.toString() : '';
  }),

  /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during the current `$digest` will replace the current history
   * record, instead of adding a new one.
   */
  replace: function() {
    this.$$replace = true;
    return this;
  }
};

forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
  Location.prototype = Object.create(locationPrototype);

  /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */
  Location.prototype.state = function(state) {
    if (!arguments.length) {
      return this.$$state;
    }

    if (Location !== LocationHtml5Url || !this.$$html5) {
      throw $locationMinErr('nostate', 'History API state support is available only ' +
        'in HTML5 mode and only in browsers supporting HTML5 History API');
    }
    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
    // but we're changing the $$state reference to $browser.state() during the $digest
    // so the modification window is narrow.
    this.$$state = isUndefined(state) ? null : state;
    this.$$urlUpdatedByLocation = true;

    return this;
  };
});


function locationGetter(property) {
  return /** @this */ function() {
    return this[property];
  };
}


function locationGetterSetter(property, preprocess) {
  return /** @this */ function(value) {
    if (isUndefined(value)) {
      return this[property];
    }

    this[property] = preprocess(value);
    this.$$compose();

    return this;
  };
}


/**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */

/**
 * @ngdoc provider
 * @name $locationProvider
 * @this
 *
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */
function $LocationProvider() {
  var hashPrefix = '!',
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

  /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * The default value for the prefix is `'!'`.
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.hashPrefix = function(prefix) {
    if (isDefined(prefix)) {
      hashPrefix = prefix;
      return this;
    } else {
      return hashPrefix;
    }
  };

  /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
   *     only happen on links with an attribute that matches the given string. For example, if set
   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
   *     here, so `'internalLink'` will **not** match `'internal-link'`.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */
  this.html5Mode = function(mode) {
    if (isBoolean(mode)) {
      html5Mode.enabled = mode;
      return this;
    } else if (isObject(mode)) {

      if (isBoolean(mode.enabled)) {
        html5Mode.enabled = mode.enabled;
      }

      if (isBoolean(mode.requireBase)) {
        html5Mode.requireBase = mode.requireBase;
      }

      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
        html5Mode.rewriteLinks = mode.rewriteLinks;
      }

      return this;
    } else {
      return html5Mode;
    }
  };

  /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
      function($rootScope, $browser, $sniffer, $rootElement, $window) {
    var $location,
        LocationMode,
        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
        initialUrl = $browser.url(),
        appBase;

    if (html5Mode.enabled) {
      if (!baseHref && html5Mode.requireBase) {
        throw $locationMinErr('nobase',
          '$location in HTML5 mode requires a <base> tag to be present!');
      }
      appBase = serverBase(initialUrl) + (baseHref || '/');
      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
    } else {
      appBase = stripHash(initialUrl);
      LocationMode = LocationHashbangUrl;
    }
    var appBaseNoFile = stripFile(appBase);

    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
    $location.$$parseLinkUrl(initialUrl, initialUrl);

    $location.$$state = $browser.state();

    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

    // Determine if two URLs are equal despite potentially having different encoding/normalizing
    //  such as $location.absUrl() vs $browser.url()
    // See https://github.com/angular/angular.js/issues/16592
    function urlsEqual(a, b) {
      return a === b || urlResolve(a).href === urlResolve(b).href;
    }

    function setBrowserUrlWithFallback(url, replace, state) {
      var oldUrl = $location.url();
      var oldState = $location.$$state;
      try {
        $browser.url(url, replace, state);

        // Make sure $location.state() returns referentially identical (not just deeply equal)
        // state object; this makes possible quick checking if the state changed in the digest
        // loop. Checking deep equality would be too expensive.
        $location.$$state = $browser.state();
      } catch (e) {
        // Restore old values if pushState fails
        $location.url(oldUrl);
        $location.$$state = oldState;

        throw e;
      }
    }

    $rootElement.on('click', function(event) {
      var rewriteLinks = html5Mode.rewriteLinks;
      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
      // currently we open nice url link and redirect then

      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;

      var elm = jqLite(event.target);

      // traverse the DOM up to find first A tag
      while (nodeName_(elm[0]) !== 'a') {
        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
      }

      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;

      var absHref = elm.prop('href');
      // get the actual href attribute - see
      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
      var relHref = elm.attr('href') || elm.attr('xlink:href');

      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
        // an animation.
        absHref = urlResolve(absHref.animVal).href;
      }

      // Ignore when url is started with javascript: or mailto:
      if (IGNORE_URI_REGEXP.test(absHref)) return;

      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
        if ($location.$$parseLinkUrl(absHref, relHref)) {
          // We do a preventDefault for all urls that are part of the AngularJS application,
          // in html5mode and also without, so that we are able to abort navigation without
          // getting double entries in the location history.
          event.preventDefault();
          // update location manually
          if ($location.absUrl() !== $browser.url()) {
            $rootScope.$apply();
          }
        }
      }
    });


    // rewrite hashbang url <> html5 url
    if ($location.absUrl() !== initialUrl) {
      $browser.url($location.absUrl(), true);
    }

    var initializing = true;

    // update $location when $browser url changes
    $browser.onUrlChange(function(newUrl, newState) {

      if (!startsWith(newUrl, appBaseNoFile)) {
        // If we are navigating outside of the app then force a reload
        $window.location.href = newUrl;
        return;
      }

      $rootScope.$evalAsync(function() {
        var oldUrl = $location.absUrl();
        var oldState = $location.$$state;
        var defaultPrevented;
        $location.$$parse(newUrl);
        $location.$$state = newState;

        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
            newState, oldState).defaultPrevented;

        // if the location was changed by a `$locationChangeStart` handler then stop
        // processing this location change
        if ($location.absUrl() !== newUrl) return;

        if (defaultPrevented) {
          $location.$$parse(oldUrl);
          $location.$$state = oldState;
          setBrowserUrlWithFallback(oldUrl, false, oldState);
        } else {
          initializing = false;
          afterLocationChange(oldUrl, oldState);
        }
      });
      if (!$rootScope.$$phase) $rootScope.$digest();
    });

    // update browser
    $rootScope.$watch(function $locationWatch() {
      if (initializing || $location.$$urlUpdatedByLocation) {
        $location.$$urlUpdatedByLocation = false;

        var oldUrl = $browser.url();
        var newUrl = $location.absUrl();
        var oldState = $browser.state();
        var currentReplace = $location.$$replace;
        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) ||
          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);

        if (initializing || urlOrStateChanged) {
          initializing = false;

          $rootScope.$evalAsync(function() {
            var newUrl = $location.absUrl();
            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
                $location.$$state, oldState).defaultPrevented;

            // if the location was changed by a `$locationChangeStart` handler then stop
            // processing this location change
            if ($location.absUrl() !== newUrl) return;

            if (defaultPrevented) {
              $location.$$parse(oldUrl);
              $location.$$state = oldState;
            } else {
              if (urlOrStateChanged) {
                setBrowserUrlWithFallback(newUrl, currentReplace,
                                          oldState === $location.$$state ? null : $location.$$state);
              }
              afterLocationChange(oldUrl, oldState);
            }
          });
        }
      }

      $location.$$replace = false;

      // we don't need to return anything because $evalAsync will make the digest loop dirty when
      // there is a change
    });

    return $location;

    function afterLocationChange(oldUrl, oldState) {
      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
        $location.$$state, oldState);
    }
}];
}

/**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * To reveal the location of the calls to `$log` in the JavaScript console,
 * you can "blackbox" the AngularJS source in your browser:
 *
 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
 *
 * Note: Not all browsers support blackboxing.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample" name="log-service">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */

/**
 * @ngdoc provider
 * @name $logProvider
 * @this
 *
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */
function $LogProvider() {
  var debug = true,
      self = this;

  /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.debugEnabled = function(flag) {
    if (isDefined(flag)) {
      debug = flag;
      return this;
    } else {
      return debug;
    }
  };

  this.$get = ['$window', function($window) {
    // Support: IE 9-11, Edge 12-14+
    // IE/Edge display errors in such a way that it requires the user to click in 4 places
    // to see the stack trace. There is no way to feature-detect it so there's a chance
    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
    // break apps. Other browsers display errors in a sensible way and some of them map stack
    // traces along source maps if available so it makes sense to let browsers display it
    // as they want.
    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);

    return {
      /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */
      log: consoleLog('log'),

      /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */
      info: consoleLog('info'),

      /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */
      warn: consoleLog('warn'),

      /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */
      error: consoleLog('error'),

      /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */
      debug: (function() {
        var fn = consoleLog('debug');

        return function() {
          if (debug) {
            fn.apply(self, arguments);
          }
        };
      })()
    };

    function formatError(arg) {
      if (isError(arg)) {
        if (arg.stack && formatStackTrace) {
          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
              ? 'Error: ' + arg.message + '\n' + arg.stack
              : arg.stack;
        } else if (arg.sourceURL) {
          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
        }
      }
      return arg;
    }

    function consoleLog(type) {
      var console = $window.console || {},
          logFn = console[type] || console.log || noop;

      return function() {
        var args = [];
        forEach(arguments, function(arg) {
          args.push(formatError(arg));
        });
        // Support: IE 9 only
        // console methods don't inherit from Function.prototype in IE 9 so we can't
        // call `logFn.apply(console, args)` directly.
        return Function.prototype.apply.call(logFn, console, args);
      };
    }
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $parseMinErr = minErr('$parse');

var objectValueOf = {}.constructor.prototype.valueOf;

// Sandboxing AngularJS Expressions
// ------------------------------
// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
// various means such as obtaining a reference to native JS functions like the Function constructor.
//
// As an example, consider the following AngularJS expression:
//
//   {}.toString.constructor('alert("evil JS code")')
//
// It is important to realize that if you create an expression from a string that contains user provided
// content then it is possible that your application contains a security vulnerability to an XSS style attack.
//
// See https://docs.angularjs.org/guide/security


function getStringValue(name) {
  // Property names must be strings. This means that non-string objects cannot be used
  // as keys in an object. Any non-string object, including a number, is typecasted
  // into a string via the toString method.
  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
  //
  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
  // to a string. It's not always possible. If `name` is an object and its `toString` method is
  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
  //
  // TypeError: Cannot convert object to primitive value
  //
  // For performance reasons, we don't catch this error here and allow it to propagate up the call
  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
  // such a 'broken' object as a key.
  return name + '';
}


var OPERATORS = createMap();
forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};


/////////////////////////////////////////


/**
 * @constructor
 */
var Lexer = function Lexer(options) {
  this.options = options;
};

Lexer.prototype = {
  constructor: Lexer,

  lex: function(text) {
    this.text = text;
    this.index = 0;
    this.tokens = [];

    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      if (ch === '"' || ch === '\'') {
        this.readString(ch);
      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
        this.readNumber();
      } else if (this.isIdentifierStart(this.peekMultichar())) {
        this.readIdent();
      } else if (this.is(ch, '(){}[].,;:?')) {
        this.tokens.push({index: this.index, text: ch});
        this.index++;
      } else if (this.isWhitespace(ch)) {
        this.index++;
      } else {
        var ch2 = ch + this.peek();
        var ch3 = ch2 + this.peek(2);
        var op1 = OPERATORS[ch];
        var op2 = OPERATORS[ch2];
        var op3 = OPERATORS[ch3];
        if (op1 || op2 || op3) {
          var token = op3 ? ch3 : (op2 ? ch2 : ch);
          this.tokens.push({index: this.index, text: token, operator: true});
          this.index += token.length;
        } else {
          this.throwError('Unexpected next character ', this.index, this.index + 1);
        }
      }
    }
    return this.tokens;
  },

  is: function(ch, chars) {
    return chars.indexOf(ch) !== -1;
  },

  peek: function(i) {
    var num = i || 1;
    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
  },

  isNumber: function(ch) {
    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
  },

  isWhitespace: function(ch) {
    // IE treats non-breaking space as \u00A0
    return (ch === ' ' || ch === '\r' || ch === '\t' ||
            ch === '\n' || ch === '\v' || ch === '\u00A0');
  },

  isIdentifierStart: function(ch) {
    return this.options.isIdentifierStart ?
        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
        this.isValidIdentifierStart(ch);
  },

  isValidIdentifierStart: function(ch) {
    return ('a' <= ch && ch <= 'z' ||
            'A' <= ch && ch <= 'Z' ||
            '_' === ch || ch === '$');
  },

  isIdentifierContinue: function(ch) {
    return this.options.isIdentifierContinue ?
        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
        this.isValidIdentifierContinue(ch);
  },

  isValidIdentifierContinue: function(ch, cp) {
    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
  },

  codePointAt: function(ch) {
    if (ch.length === 1) return ch.charCodeAt(0);
    // eslint-disable-next-line no-bitwise
    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
  },

  peekMultichar: function() {
    var ch = this.text.charAt(this.index);
    var peek = this.peek();
    if (!peek) {
      return ch;
    }
    var cp1 = ch.charCodeAt(0);
    var cp2 = peek.charCodeAt(0);
    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
      return ch + peek;
    }
    return ch;
  },

  isExpOperator: function(ch) {
    return (ch === '-' || ch === '+' || this.isNumber(ch));
  },

  throwError: function(error, start, end) {
    end = end || this.index;
    var colStr = (isDefined(start)
            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
            : ' ' + end);
    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
        error, colStr, this.text);
  },

  readNumber: function() {
    var number = '';
    var start = this.index;
    while (this.index < this.text.length) {
      var ch = lowercase(this.text.charAt(this.index));
      if (ch === '.' || this.isNumber(ch)) {
        number += ch;
      } else {
        var peekCh = this.peek();
        if (ch === 'e' && this.isExpOperator(peekCh)) {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            peekCh && this.isNumber(peekCh) &&
            number.charAt(number.length - 1) === 'e') {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            (!peekCh || !this.isNumber(peekCh)) &&
            number.charAt(number.length - 1) === 'e') {
          this.throwError('Invalid exponent');
        } else {
          break;
        }
      }
      this.index++;
    }
    this.tokens.push({
      index: start,
      text: number,
      constant: true,
      value: Number(number)
    });
  },

  readIdent: function() {
    var start = this.index;
    this.index += this.peekMultichar().length;
    while (this.index < this.text.length) {
      var ch = this.peekMultichar();
      if (!this.isIdentifierContinue(ch)) {
        break;
      }
      this.index += ch.length;
    }
    this.tokens.push({
      index: start,
      text: this.text.slice(start, this.index),
      identifier: true
    });
  },

  readString: function(quote) {
    var start = this.index;
    this.index++;
    var string = '';
    var rawString = quote;
    var escape = false;
    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      rawString += ch;
      if (escape) {
        if (ch === 'u') {
          var hex = this.text.substring(this.index + 1, this.index + 5);
          if (!hex.match(/[\da-f]{4}/i)) {
            this.throwError('Invalid unicode escape [\\u' + hex + ']');
          }
          this.index += 4;
          string += String.fromCharCode(parseInt(hex, 16));
        } else {
          var rep = ESCAPE[ch];
          string = string + (rep || ch);
        }
        escape = false;
      } else if (ch === '\\') {
        escape = true;
      } else if (ch === quote) {
        this.index++;
        this.tokens.push({
          index: start,
          text: rawString,
          constant: true,
          value: string
        });
        return;
      } else {
        string += ch;
      }
      this.index++;
    }
    this.throwError('Unterminated quote', start);
  }
};

var AST = function AST(lexer, options) {
  this.lexer = lexer;
  this.options = options;
};

AST.Program = 'Program';
AST.ExpressionStatement = 'ExpressionStatement';
AST.AssignmentExpression = 'AssignmentExpression';
AST.ConditionalExpression = 'ConditionalExpression';
AST.LogicalExpression = 'LogicalExpression';
AST.BinaryExpression = 'BinaryExpression';
AST.UnaryExpression = 'UnaryExpression';
AST.CallExpression = 'CallExpression';
AST.MemberExpression = 'MemberExpression';
AST.Identifier = 'Identifier';
AST.Literal = 'Literal';
AST.ArrayExpression = 'ArrayExpression';
AST.Property = 'Property';
AST.ObjectExpression = 'ObjectExpression';
AST.ThisExpression = 'ThisExpression';
AST.LocalsExpression = 'LocalsExpression';

// Internal use only
AST.NGValueParameter = 'NGValueParameter';

AST.prototype = {
  ast: function(text) {
    this.text = text;
    this.tokens = this.lexer.lex(text);

    var value = this.program();

    if (this.tokens.length !== 0) {
      this.throwError('is an unexpected token', this.tokens[0]);
    }

    return value;
  },

  program: function() {
    var body = [];
    while (true) {
      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
        body.push(this.expressionStatement());
      if (!this.expect(';')) {
        return { type: AST.Program, body: body};
      }
    }
  },

  expressionStatement: function() {
    return { type: AST.ExpressionStatement, expression: this.filterChain() };
  },

  filterChain: function() {
    var left = this.expression();
    while (this.expect('|')) {
      left = this.filter(left);
    }
    return left;
  },

  expression: function() {
    return this.assignment();
  },

  assignment: function() {
    var result = this.ternary();
    if (this.expect('=')) {
      if (!isAssignable(result)) {
        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
      }

      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
    }
    return result;
  },

  ternary: function() {
    var test = this.logicalOR();
    var alternate;
    var consequent;
    if (this.expect('?')) {
      alternate = this.expression();
      if (this.consume(':')) {
        consequent = this.expression();
        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
      }
    }
    return test;
  },

  logicalOR: function() {
    var left = this.logicalAND();
    while (this.expect('||')) {
      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
    }
    return left;
  },

  logicalAND: function() {
    var left = this.equality();
    while (this.expect('&&')) {
      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
    }
    return left;
  },

  equality: function() {
    var left = this.relational();
    var token;
    while ((token = this.expect('==','!=','===','!=='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
    }
    return left;
  },

  relational: function() {
    var left = this.additive();
    var token;
    while ((token = this.expect('<', '>', '<=', '>='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
    }
    return left;
  },

  additive: function() {
    var left = this.multiplicative();
    var token;
    while ((token = this.expect('+','-'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
    }
    return left;
  },

  multiplicative: function() {
    var left = this.unary();
    var token;
    while ((token = this.expect('*','/','%'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
    }
    return left;
  },

  unary: function() {
    var token;
    if ((token = this.expect('+', '-', '!'))) {
      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
    } else {
      return this.primary();
    }
  },

  primary: function() {
    var primary;
    if (this.expect('(')) {
      primary = this.filterChain();
      this.consume(')');
    } else if (this.expect('[')) {
      primary = this.arrayDeclaration();
    } else if (this.expect('{')) {
      primary = this.object();
    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
      primary = copy(this.selfReferential[this.consume().text]);
    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
    } else if (this.peek().identifier) {
      primary = this.identifier();
    } else if (this.peek().constant) {
      primary = this.constant();
    } else {
      this.throwError('not a primary expression', this.peek());
    }

    var next;
    while ((next = this.expect('(', '[', '.'))) {
      if (next.text === '(') {
        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
        this.consume(')');
      } else if (next.text === '[') {
        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
        this.consume(']');
      } else if (next.text === '.') {
        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
      } else {
        this.throwError('IMPOSSIBLE');
      }
    }
    return primary;
  },

  filter: function(baseExpression) {
    var args = [baseExpression];
    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};

    while (this.expect(':')) {
      args.push(this.expression());
    }

    return result;
  },

  parseArguments: function() {
    var args = [];
    if (this.peekToken().text !== ')') {
      do {
        args.push(this.filterChain());
      } while (this.expect(','));
    }
    return args;
  },

  identifier: function() {
    var token = this.consume();
    if (!token.identifier) {
      this.throwError('is not a valid identifier', token);
    }
    return { type: AST.Identifier, name: token.text };
  },

  constant: function() {
    // TODO check that it is a constant
    return { type: AST.Literal, value: this.consume().value };
  },

  arrayDeclaration: function() {
    var elements = [];
    if (this.peekToken().text !== ']') {
      do {
        if (this.peek(']')) {
          // Support trailing commas per ES5.1.
          break;
        }
        elements.push(this.expression());
      } while (this.expect(','));
    }
    this.consume(']');

    return { type: AST.ArrayExpression, elements: elements };
  },

  object: function() {
    var properties = [], property;
    if (this.peekToken().text !== '}') {
      do {
        if (this.peek('}')) {
          // Support trailing commas per ES5.1.
          break;
        }
        property = {type: AST.Property, kind: 'init'};
        if (this.peek().constant) {
          property.key = this.constant();
          property.computed = false;
          this.consume(':');
          property.value = this.expression();
        } else if (this.peek().identifier) {
          property.key = this.identifier();
          property.computed = false;
          if (this.peek(':')) {
            this.consume(':');
            property.value = this.expression();
          } else {
            property.value = property.key;
          }
        } else if (this.peek('[')) {
          this.consume('[');
          property.key = this.expression();
          this.consume(']');
          property.computed = true;
          this.consume(':');
          property.value = this.expression();
        } else {
          this.throwError('invalid key', this.peek());
        }
        properties.push(property);
      } while (this.expect(','));
    }
    this.consume('}');

    return {type: AST.ObjectExpression, properties: properties };
  },

  throwError: function(msg, token) {
    throw $parseMinErr('syntax',
        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
  },

  consume: function(e1) {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }

    var token = this.expect(e1);
    if (!token) {
      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
    }
    return token;
  },

  peekToken: function() {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }
    return this.tokens[0];
  },

  peek: function(e1, e2, e3, e4) {
    return this.peekAhead(0, e1, e2, e3, e4);
  },

  peekAhead: function(i, e1, e2, e3, e4) {
    if (this.tokens.length > i) {
      var token = this.tokens[i];
      var t = token.text;
      if (t === e1 || t === e2 || t === e3 || t === e4 ||
          (!e1 && !e2 && !e3 && !e4)) {
        return token;
      }
    }
    return false;
  },

  expect: function(e1, e2, e3, e4) {
    var token = this.peek(e1, e2, e3, e4);
    if (token) {
      this.tokens.shift();
      return token;
    }
    return false;
  },

  selfReferential: {
    'this': {type: AST.ThisExpression },
    '$locals': {type: AST.LocalsExpression }
  }
};

function ifDefined(v, d) {
  return typeof v !== 'undefined' ? v : d;
}

function plusFn(l, r) {
  if (typeof l === 'undefined') return r;
  if (typeof r === 'undefined') return l;
  return l + r;
}

function isStateless($filter, filterName) {
  var fn = $filter(filterName);
  return !fn.$stateful;
}

var PURITY_ABSOLUTE = 1;
var PURITY_RELATIVE = 2;

// Detect nodes which could depend on non-shallow state of objects
function isPure(node, parentIsPure) {
  switch (node.type) {
    // Computed members might invoke a stateful toString()
    case AST.MemberExpression:
      if (node.computed) {
        return false;
      }
      break;

    // Unary always convert to primative
    case AST.UnaryExpression:
      return PURITY_ABSOLUTE;

    // The binary + operator can invoke a stateful toString().
    case AST.BinaryExpression:
      return node.operator !== '+' ? PURITY_ABSOLUTE : false;

    // Functions / filters probably read state from within objects
    case AST.CallExpression:
      return false;
  }

  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
}

function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
  var allConstants;
  var argsToWatch;
  var isStatelessFilter;

  var astIsPure = ast.isPure = isPure(ast, parentIsPure);

  switch (ast.type) {
  case AST.Program:
    allConstants = true;
    forEach(ast.body, function(expr) {
      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
      allConstants = allConstants && expr.expression.constant;
    });
    ast.constant = allConstants;
    break;
  case AST.Literal:
    ast.constant = true;
    ast.toWatch = [];
    break;
  case AST.UnaryExpression:
    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
    ast.constant = ast.argument.constant;
    ast.toWatch = ast.argument.toWatch;
    break;
  case AST.BinaryExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
    break;
  case AST.LogicalExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.ConditionalExpression:
    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.Identifier:
    ast.constant = false;
    ast.toWatch = [ast];
    break;
  case AST.MemberExpression:
    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
    if (ast.computed) {
      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
    }
    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.CallExpression:
    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
    allConstants = isStatelessFilter;
    argsToWatch = [];
    forEach(ast.arguments, function(expr) {
      findConstantAndWatchExpressions(expr, $filter, astIsPure);
      allConstants = allConstants && expr.constant;
      argsToWatch.push.apply(argsToWatch, expr.toWatch);
    });
    ast.constant = allConstants;
    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
    break;
  case AST.AssignmentExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = [ast];
    break;
  case AST.ArrayExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.elements, function(expr) {
      findConstantAndWatchExpressions(expr, $filter, astIsPure);
      allConstants = allConstants && expr.constant;
      argsToWatch.push.apply(argsToWatch, expr.toWatch);
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ObjectExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.properties, function(property) {
      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
      allConstants = allConstants && property.value.constant;
      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
      if (property.computed) {
        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
        allConstants = allConstants && property.key.constant;
        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ThisExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  case AST.LocalsExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  }
}

function getInputs(body) {
  if (body.length !== 1) return;
  var lastExpression = body[0].expression;
  var candidate = lastExpression.toWatch;
  if (candidate.length !== 1) return candidate;
  return candidate[0] !== lastExpression ? candidate : undefined;
}

function isAssignable(ast) {
  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
}

function assignableAST(ast) {
  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
  }
}

function isLiteral(ast) {
  return ast.body.length === 0 ||
      ast.body.length === 1 && (
      ast.body[0].expression.type === AST.Literal ||
      ast.body[0].expression.type === AST.ArrayExpression ||
      ast.body[0].expression.type === AST.ObjectExpression);
}

function isConstant(ast) {
  return ast.constant;
}

function ASTCompiler($filter) {
  this.$filter = $filter;
}

ASTCompiler.prototype = {
  compile: function(ast) {
    var self = this;
    this.state = {
      nextId: 0,
      filters: {},
      fn: {vars: [], body: [], own: {}},
      assign: {vars: [], body: [], own: {}},
      inputs: []
    };
    findConstantAndWatchExpressions(ast, self.$filter);
    var extra = '';
    var assignable;
    this.stage = 'assign';
    if ((assignable = assignableAST(ast))) {
      this.state.computing = 'assign';
      var result = this.nextId();
      this.recurse(assignable, result);
      this.return_(result);
      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
    }
    var toWatch = getInputs(ast.body);
    self.stage = 'inputs';
    forEach(toWatch, function(watch, key) {
      var fnKey = 'fn' + key;
      self.state[fnKey] = {vars: [], body: [], own: {}};
      self.state.computing = fnKey;
      var intoId = self.nextId();
      self.recurse(watch, intoId);
      self.return_(intoId);
      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
      watch.watchId = key;
    });
    this.state.computing = 'fn';
    this.stage = 'main';
    this.recurse(ast);
    var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      '"' + this.USE + ' ' + this.STRICT + '";\n' +
      this.filterPrefix() +
      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
      extra +
      this.watchFns() +
      'return fn;';

    // eslint-disable-next-line no-new-func
    var fn = (new Function('$filter',
        'getStringValue',
        'ifDefined',
        'plus',
        fnString))(
          this.$filter,
          getStringValue,
          ifDefined,
          plusFn);
    this.state = this.stage = undefined;
    return fn;
  },

  USE: 'use',

  STRICT: 'strict',

  watchFns: function() {
    var result = [];
    var inputs = this.state.inputs;
    var self = this;
    forEach(inputs, function(input) {
      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
      if (input.isPure) {
        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
      }
    });
    if (inputs.length) {
      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
    }
    return result.join('');
  },

  generateFunction: function(name, params) {
    return 'function(' + params + '){' +
        this.varsPrefix(name) +
        this.body(name) +
        '};';
  },

  filterPrefix: function() {
    var parts = [];
    var self = this;
    forEach(this.state.filters, function(id, filter) {
      parts.push(id + '=$filter(' + self.escape(filter) + ')');
    });
    if (parts.length) return 'var ' + parts.join(',') + ';';
    return '';
  },

  varsPrefix: function(section) {
    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
  },

  body: function(section) {
    return this.state[section].body.join('');
  },

  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var left, right, self = this, args, expression, computed;
    recursionFn = recursionFn || noop;
    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
      intoId = intoId || this.nextId();
      this.if_('i',
        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
      );
      return;
    }
    switch (ast.type) {
    case AST.Program:
      forEach(ast.body, function(expression, pos) {
        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
        if (pos !== ast.body.length - 1) {
          self.current().body.push(right, ';');
        } else {
          self.return_(right);
        }
      });
      break;
    case AST.Literal:
      expression = this.escape(ast.value);
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.UnaryExpression:
      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.BinaryExpression:
      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
      if (ast.operator === '+') {
        expression = this.plus(left, right);
      } else if (ast.operator === '-') {
        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
      } else {
        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
      }
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.LogicalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.left, intoId);
      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
      recursionFn(intoId);
      break;
    case AST.ConditionalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.test, intoId);
      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
      recursionFn(intoId);
      break;
    case AST.Identifier:
      intoId = intoId || this.nextId();
      if (nameId) {
        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
        nameId.computed = false;
        nameId.name = ast.name;
      }
      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
        function() {
          self.if_(self.stage === 'inputs' || 's', function() {
            if (create && create !== 1) {
              self.if_(
                self.isNull(self.nonComputedMember('s', ast.name)),
                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
            }
            self.assign(intoId, self.nonComputedMember('s', ast.name));
          });
        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
        );
      recursionFn(intoId);
      break;
    case AST.MemberExpression:
      left = nameId && (nameId.context = this.nextId()) || this.nextId();
      intoId = intoId || this.nextId();
      self.recurse(ast.object, left, undefined, function() {
        self.if_(self.notNull(left), function() {
          if (ast.computed) {
            right = self.nextId();
            self.recurse(ast.property, right);
            self.getStringValue(right);
            if (create && create !== 1) {
              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
            }
            expression = self.computedMember(left, right);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = true;
              nameId.name = right;
            }
          } else {
            if (create && create !== 1) {
              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
            }
            expression = self.nonComputedMember(left, ast.property.name);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = false;
              nameId.name = ast.property.name;
            }
          }
        }, function() {
          self.assign(intoId, 'undefined');
        });
        recursionFn(intoId);
      }, !!create);
      break;
    case AST.CallExpression:
      intoId = intoId || this.nextId();
      if (ast.filter) {
        right = self.filter(ast.callee.name);
        args = [];
        forEach(ast.arguments, function(expr) {
          var argument = self.nextId();
          self.recurse(expr, argument);
          args.push(argument);
        });
        expression = right + '(' + args.join(',') + ')';
        self.assign(intoId, expression);
        recursionFn(intoId);
      } else {
        right = self.nextId();
        left = {};
        args = [];
        self.recurse(ast.callee, right, left, function() {
          self.if_(self.notNull(right), function() {
            forEach(ast.arguments, function(expr) {
              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                args.push(argument);
              });
            });
            if (left.name) {
              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
            } else {
              expression = right + '(' + args.join(',') + ')';
            }
            self.assign(intoId, expression);
          }, function() {
            self.assign(intoId, 'undefined');
          });
          recursionFn(intoId);
        });
      }
      break;
    case AST.AssignmentExpression:
      right = this.nextId();
      left = {};
      this.recurse(ast.left, undefined, left, function() {
        self.if_(self.notNull(left.context), function() {
          self.recurse(ast.right, right);
          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
          self.assign(intoId, expression);
          recursionFn(intoId || expression);
        });
      }, 1);
      break;
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
          args.push(argument);
        });
      });
      expression = '[' + args.join(',') + ']';
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.ObjectExpression:
      args = [];
      computed = false;
      forEach(ast.properties, function(property) {
        if (property.computed) {
          computed = true;
        }
      });
      if (computed) {
        intoId = intoId || this.nextId();
        this.assign(intoId, '{}');
        forEach(ast.properties, function(property) {
          if (property.computed) {
            left = self.nextId();
            self.recurse(property.key, left);
          } else {
            left = property.key.type === AST.Identifier ?
                       property.key.name :
                       ('' + property.key.value);
          }
          right = self.nextId();
          self.recurse(property.value, right);
          self.assign(self.member(intoId, left, property.computed), right);
        });
      } else {
        forEach(ast.properties, function(property) {
          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
            args.push(self.escape(
                property.key.type === AST.Identifier ? property.key.name :
                  ('' + property.key.value)) +
                ':' + expr);
          });
        });
        expression = '{' + args.join(',') + '}';
        this.assign(intoId, expression);
      }
      recursionFn(intoId || expression);
      break;
    case AST.ThisExpression:
      this.assign(intoId, 's');
      recursionFn(intoId || 's');
      break;
    case AST.LocalsExpression:
      this.assign(intoId, 'l');
      recursionFn(intoId || 'l');
      break;
    case AST.NGValueParameter:
      this.assign(intoId, 'v');
      recursionFn(intoId || 'v');
      break;
    }
  },

  getHasOwnProperty: function(element, property) {
    var key = element + '.' + property;
    var own = this.current().own;
    if (!own.hasOwnProperty(key)) {
      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
    }
    return own[key];
  },

  assign: function(id, value) {
    if (!id) return;
    this.current().body.push(id, '=', value, ';');
    return id;
  },

  filter: function(filterName) {
    if (!this.state.filters.hasOwnProperty(filterName)) {
      this.state.filters[filterName] = this.nextId(true);
    }
    return this.state.filters[filterName];
  },

  ifDefined: function(id, defaultValue) {
    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
  },

  plus: function(left, right) {
    return 'plus(' + left + ',' + right + ')';
  },

  return_: function(id) {
    this.current().body.push('return ', id, ';');
  },

  if_: function(test, alternate, consequent) {
    if (test === true) {
      alternate();
    } else {
      var body = this.current().body;
      body.push('if(', test, '){');
      alternate();
      body.push('}');
      if (consequent) {
        body.push('else{');
        consequent();
        body.push('}');
      }
    }
  },

  not: function(expression) {
    return '!(' + expression + ')';
  },

  isNull: function(expression) {
    return expression + '==null';
  },

  notNull: function(expression) {
    return expression + '!=null';
  },

  nonComputedMember: function(left, right) {
    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
    if (SAFE_IDENTIFIER.test(right)) {
      return left + '.' + right;
    } else {
      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
    }
  },

  computedMember: function(left, right) {
    return left + '[' + right + ']';
  },

  member: function(left, right, computed) {
    if (computed) return this.computedMember(left, right);
    return this.nonComputedMember(left, right);
  },

  getStringValue: function(item) {
    this.assign(item, 'getStringValue(' + item + ')');
  },

  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var self = this;
    return function() {
      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
    };
  },

  lazyAssign: function(id, value) {
    var self = this;
    return function() {
      self.assign(id, value);
    };
  },

  stringEscapeRegex: /[^ a-zA-Z0-9]/g,

  stringEscapeFn: function(c) {
    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
  },

  escape: function(value) {
    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
    if (isNumber(value)) return value.toString();
    if (value === true) return 'true';
    if (value === false) return 'false';
    if (value === null) return 'null';
    if (typeof value === 'undefined') return 'undefined';

    throw $parseMinErr('esc', 'IMPOSSIBLE');
  },

  nextId: function(skip, init) {
    var id = 'v' + (this.state.nextId++);
    if (!skip) {
      this.current().vars.push(id + (init ? '=' + init : ''));
    }
    return id;
  },

  current: function() {
    return this.state[this.state.computing];
  }
};


function ASTInterpreter($filter) {
  this.$filter = $filter;
}

ASTInterpreter.prototype = {
  compile: function(ast) {
    var self = this;
    findConstantAndWatchExpressions(ast, self.$filter);
    var assignable;
    var assign;
    if ((assignable = assignableAST(ast))) {
      assign = this.recurse(assignable);
    }
    var toWatch = getInputs(ast.body);
    var inputs;
    if (toWatch) {
      inputs = [];
      forEach(toWatch, function(watch, key) {
        var input = self.recurse(watch);
        input.isPure = watch.isPure;
        watch.input = input;
        inputs.push(input);
        watch.watchId = key;
      });
    }
    var expressions = [];
    forEach(ast.body, function(expression) {
      expressions.push(self.recurse(expression.expression));
    });
    var fn = ast.body.length === 0 ? noop :
             ast.body.length === 1 ? expressions[0] :
             function(scope, locals) {
               var lastValue;
               forEach(expressions, function(exp) {
                 lastValue = exp(scope, locals);
               });
               return lastValue;
             };
    if (assign) {
      fn.assign = function(scope, value, locals) {
        return assign(scope, locals, value);
      };
    }
    if (inputs) {
      fn.inputs = inputs;
    }
    return fn;
  },

  recurse: function(ast, context, create) {
    var left, right, self = this, args;
    if (ast.input) {
      return this.inputs(ast.input, ast.watchId);
    }
    switch (ast.type) {
    case AST.Literal:
      return this.value(ast.value, context);
    case AST.UnaryExpression:
      right = this.recurse(ast.argument);
      return this['unary' + ast.operator](right, context);
    case AST.BinaryExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.LogicalExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.ConditionalExpression:
      return this['ternary?:'](
        this.recurse(ast.test),
        this.recurse(ast.alternate),
        this.recurse(ast.consequent),
        context
      );
    case AST.Identifier:
      return self.identifier(ast.name, context, create);
    case AST.MemberExpression:
      left = this.recurse(ast.object, false, !!create);
      if (!ast.computed) {
        right = ast.property.name;
      }
      if (ast.computed) right = this.recurse(ast.property);
      return ast.computed ?
        this.computedMember(left, right, context, create) :
        this.nonComputedMember(left, right, context, create);
    case AST.CallExpression:
      args = [];
      forEach(ast.arguments, function(expr) {
        args.push(self.recurse(expr));
      });
      if (ast.filter) right = this.$filter(ast.callee.name);
      if (!ast.filter) right = this.recurse(ast.callee, true);
      return ast.filter ?
        function(scope, locals, assign, inputs) {
          var values = [];
          for (var i = 0; i < args.length; ++i) {
            values.push(args[i](scope, locals, assign, inputs));
          }
          var value = right.apply(undefined, values, inputs);
          return context ? {context: undefined, name: undefined, value: value} : value;
        } :
        function(scope, locals, assign, inputs) {
          var rhs = right(scope, locals, assign, inputs);
          var value;
          if (rhs.value != null) {
            var values = [];
            for (var i = 0; i < args.length; ++i) {
              values.push(args[i](scope, locals, assign, inputs));
            }
            value = rhs.value.apply(rhs.context, values);
          }
          return context ? {value: value} : value;
        };
    case AST.AssignmentExpression:
      left = this.recurse(ast.left, true, 1);
      right = this.recurse(ast.right);
      return function(scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        lhs.context[lhs.name] = rhs;
        return context ? {value: rhs} : rhs;
      };
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        args.push(self.recurse(expr));
      });
      return function(scope, locals, assign, inputs) {
        var value = [];
        for (var i = 0; i < args.length; ++i) {
          value.push(args[i](scope, locals, assign, inputs));
        }
        return context ? {value: value} : value;
      };
    case AST.ObjectExpression:
      args = [];
      forEach(ast.properties, function(property) {
        if (property.computed) {
          args.push({key: self.recurse(property.key),
                     computed: true,
                     value: self.recurse(property.value)
          });
        } else {
          args.push({key: property.key.type === AST.Identifier ?
                          property.key.name :
                          ('' + property.key.value),
                     computed: false,
                     value: self.recurse(property.value)
          });
        }
      });
      return function(scope, locals, assign, inputs) {
        var value = {};
        for (var i = 0; i < args.length; ++i) {
          if (args[i].computed) {
            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
          } else {
            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
          }
        }
        return context ? {value: value} : value;
      };
    case AST.ThisExpression:
      return function(scope) {
        return context ? {value: scope} : scope;
      };
    case AST.LocalsExpression:
      return function(scope, locals) {
        return context ? {value: locals} : locals;
      };
    case AST.NGValueParameter:
      return function(scope, locals, assign) {
        return context ? {value: assign} : assign;
      };
    }
  },

  'unary+': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = +arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary-': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = -arg;
      } else {
        arg = -0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary!': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = !argument(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary+': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = plusFn(lhs, rhs);
      return context ? {value: arg} : arg;
    };
  },
  'binary-': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
      return context ? {value: arg} : arg;
    };
  },
  'binary*': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary/': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary%': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary===': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary&&': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary||': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'ternary?:': function(test, alternate, consequent, context) {
    return function(scope, locals, assign, inputs) {
      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  value: function(value, context) {
    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
  },
  identifier: function(name, context, create) {
    return function(scope, locals, assign, inputs) {
      var base = locals && (name in locals) ? locals : scope;
      if (create && create !== 1 && base && base[name] == null) {
        base[name] = {};
      }
      var value = base ? base[name] : undefined;
      if (context) {
        return {context: base, name: name, value: value};
      } else {
        return value;
      }
    };
  },
  computedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs;
      var value;
      if (lhs != null) {
        rhs = right(scope, locals, assign, inputs);
        rhs = getStringValue(rhs);
        if (create && create !== 1) {
          if (lhs && !(lhs[rhs])) {
            lhs[rhs] = {};
          }
        }
        value = lhs[rhs];
      }
      if (context) {
        return {context: lhs, name: rhs, value: value};
      } else {
        return value;
      }
    };
  },
  nonComputedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      if (create && create !== 1) {
        if (lhs && lhs[right] == null) {
          lhs[right] = {};
        }
      }
      var value = lhs != null ? lhs[right] : undefined;
      if (context) {
        return {context: lhs, name: right, value: value};
      } else {
        return value;
      }
    };
  },
  inputs: function(input, watchId) {
    return function(scope, value, locals, inputs) {
      if (inputs) return inputs[watchId];
      return input(scope, value, locals);
    };
  }
};

/**
 * @constructor
 */
function Parser(lexer, $filter, options) {
  this.ast = new AST(lexer, options);
  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
                                   new ASTCompiler($filter);
}

Parser.prototype = {
  constructor: Parser,

  parse: function(text) {
    var ast = this.getAst(text);
    var fn = this.astCompiler.compile(ast.ast);
    fn.literal = isLiteral(ast.ast);
    fn.constant = isConstant(ast.ast);
    fn.oneTime = ast.oneTime;
    return fn;
  },

  getAst: function(exp) {
    var oneTime = false;
    exp = exp.trim();

    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
      oneTime = true;
      exp = exp.substring(2);
    }
    return {
      ast: this.ast.ast(exp),
      oneTime: oneTime
    };
  }
};

function getValueOf(value) {
  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
}

///////////////////////////////////

/**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts AngularJS {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'AngularJS'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('AngularJS');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */


/**
 * @ngdoc provider
 * @name $parseProvider
 * @this
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */
function $ParseProvider() {
  var cache = createMap();
  var literals = {
    'true': true,
    'false': false,
    'null': null,
    'undefined': undefined
  };
  var identStart, identContinue;

  /**
   * @ngdoc method
   * @name $parseProvider#addLiteral
   * @description
   *
   * Configure $parse service to add literal values that will be present as literal at expressions.
   *
   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
   *
   **/
  this.addLiteral = function(literalName, literalValue) {
    literals[literalName] = literalValue;
  };

 /**
  * @ngdoc method
  * @name $parseProvider#setIdentifierFns
  *
  * @description
  *
  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
  * `identifierStart` will get called to know if a given character is a valid character to be the
  * first character for an identifier. The function `identifierContinue` will get called to know if
  * a given character is a valid character to be a follow-up identifier character. The functions
  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
  * mind that the `string` parameter can be two characters long depending on the character
  * representation. It is expected for the function to return `true` or `false`, whether that
  * character is allowed or not.
  *
  * Since this function will be called extensively, keep the implementation of these functions fast,
  * as the performance of these functions have a direct impact on the expressions parsing speed.
  *
  * @param {function=} identifierStart The function that will decide whether the given character is
  *   a valid identifier start character.
  * @param {function=} identifierContinue The function that will decide whether the given character is
  *   a valid identifier continue character.
  */
  this.setIdentifierFns = function(identifierStart, identifierContinue) {
    identStart = identifierStart;
    identContinue = identifierContinue;
    return this;
  };

  this.$get = ['$filter', function($filter) {
    var noUnsafeEval = csp().noUnsafeEval;
    var $parseOptions = {
          csp: noUnsafeEval,
          literals: copy(literals),
          isIdentifierStart: isFunction(identStart) && identStart,
          isIdentifierContinue: isFunction(identContinue) && identContinue
        };
    $parse.$$getAst = $$getAst;
    return $parse;

    function $parse(exp, interceptorFn) {
      var parsedExpression, cacheKey;

      switch (typeof exp) {
        case 'string':
          exp = exp.trim();
          cacheKey = exp;

          parsedExpression = cache[cacheKey];

          if (!parsedExpression) {
            var lexer = new Lexer($parseOptions);
            var parser = new Parser(lexer, $filter, $parseOptions);
            parsedExpression = parser.parse(exp);

            cache[cacheKey] = addWatchDelegate(parsedExpression);
          }
          return addInterceptor(parsedExpression, interceptorFn);

        case 'function':
          return addInterceptor(exp, interceptorFn);

        default:
          return addInterceptor(noop, interceptorFn);
      }
    }

    function $$getAst(exp) {
      var lexer = new Lexer($parseOptions);
      var parser = new Parser(lexer, $filter, $parseOptions);
      return parser.getAst(exp).ast;
    }

    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {

      if (newValue == null || oldValueOfValue == null) { // null/undefined
        return newValue === oldValueOfValue;
      }

      if (typeof newValue === 'object') {

        // attempt to convert the value to a primitive type
        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
        //             be cheaply dirty-checked
        newValue = getValueOf(newValue);

        if (typeof newValue === 'object' && !compareObjectIdentity) {
          // objects/arrays are not supported - deep-watching them would be too expensive
          return false;
        }

        // fall-through to the primitive equality check
      }

      //Primitive or NaN
      // eslint-disable-next-line no-self-compare
      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
    }

    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var inputExpressions = parsedExpression.inputs;
      var lastResult;

      if (inputExpressions.length === 1) {
        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
        inputExpressions = inputExpressions[0];
        return scope.$watch(function expressionInputWatch(scope) {
          var newInputValue = inputExpressions(scope);
          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
            oldInputValueOf = newInputValue && getValueOf(newInputValue);
          }
          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }

      var oldInputValueOfValues = [];
      var oldInputValues = [];
      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
        oldInputValues[i] = null;
      }

      return scope.$watch(function expressionInputsWatch(scope) {
        var changed = false;

        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          var newInputValue = inputExpressions[i](scope);
          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
            oldInputValues[i] = newInputValue;
            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
          }
        }

        if (changed) {
          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
        }

        return lastResult;
      }, listener, objectEquality, prettyPrintExpression);
    }

    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
      var unwatch, lastValue;

      var exp = parsedExpression.$$intercepted || parsedExpression;
      var post = parsedExpression.$$interceptor || identity;

      var useInputs = parsedExpression.inputs && !exp.inputs;

      // Propogate the literal/inputs/constant attributes
      // ... but not oneTime since we are handling it
      oneTimeWatch.literal = parsedExpression.literal;
      oneTimeWatch.constant = parsedExpression.constant;
      oneTimeWatch.inputs = parsedExpression.inputs;

      // Allow other delegates to run on this wrapped expression
      addWatchDelegate(oneTimeWatch);

      unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);

      return unwatch;

      function unwatchIfDone() {
        if (isDone(lastValue)) {
          unwatch();
        }
      }

      function oneTimeWatch(scope, locals, assign, inputs) {
        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
        if (isDone(lastValue)) {
          scope.$$postDigest(unwatchIfDone);
        }
        return post(lastValue);
      }
    }

    function isAllDefined(value) {
      var allDefined = true;
      forEach(value, function(val) {
        if (!isDefined(val)) allDefined = false;
      });
      return allDefined;
    }

    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch = scope.$watch(function constantWatch(scope) {
        unwatch();
        return parsedExpression(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    function addWatchDelegate(parsedExpression) {
      if (parsedExpression.constant) {
        parsedExpression.$$watchDelegate = constantWatchDelegate;
      } else if (parsedExpression.oneTime) {
        parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
      } else if (parsedExpression.inputs) {
        parsedExpression.$$watchDelegate = inputsWatchDelegate;
      }

      return parsedExpression;
    }

    function chainInterceptors(first, second) {
      function chainedInterceptor(value) {
        return second(first(value));
      }
      chainedInterceptor.$stateful = first.$stateful || second.$stateful;
      chainedInterceptor.$$pure = first.$$pure && second.$$pure;

      return chainedInterceptor;
    }

    function addInterceptor(parsedExpression, interceptorFn) {
      if (!interceptorFn) return parsedExpression;

      // Extract any existing interceptors out of the parsedExpression
      // to ensure the original parsedExpression is always the $$intercepted
      if (parsedExpression.$$interceptor) {
        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
        parsedExpression = parsedExpression.$$intercepted;
      }

      var useInputs = false;

      var fn = function interceptedExpression(scope, locals, assign, inputs) {
        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
        return interceptorFn(value);
      };

      // Maintain references to the interceptor/intercepted
      fn.$$intercepted = parsedExpression;
      fn.$$interceptor = interceptorFn;

      // Propogate the literal/oneTime/constant attributes
      fn.literal = parsedExpression.literal;
      fn.oneTime = parsedExpression.oneTime;
      fn.constant = parsedExpression.constant;

      // Treat the interceptor like filters.
      // If it is not $stateful then only watch its inputs.
      // If the expression itself has no inputs then use the full expression as an input.
      if (!interceptorFn.$stateful) {
        useInputs = !parsedExpression.inputs;
        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];

        if (!interceptorFn.$$pure) {
          fn.inputs = fn.inputs.map(function(e) {
              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
              // non-pure interceptor function.
              if (e.isPure === PURITY_RELATIVE) {
                return function depurifier(s) { return e(s); };
              }
              return e;
            });
        }
      }

      return addWatchDelegate(fn);
    }
  }];
}

/**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
 *
 * ## $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * ## The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * ## The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
 *   arguments are optional.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * ## Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * ## Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 * ## Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */
/**
 * @ngdoc provider
 * @name $qProvider
 * @this
 *
 * @description
 */
function $QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
    return qFactory(function(callback) {
      $rootScope.$evalAsync(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  /**
   * @ngdoc method
   * @name $qProvider#errorOnUnhandledRejections
   * @kind function
   *
   * @description
   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
   * This feature is enabled by default.
   *
   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
   *    chaining otherwise.
   */
  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/** @this */
function $$QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
    return qFactory(function(callback) {
      $browser.defer(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
 *     promises rejections.
 * @returns {object} Promise manager.
 */
function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
  var $qMinErr = minErr('$q', TypeError);
  var queueSize = 0;
  var checkQueue = [];

  /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */
  function defer() {
    return new Deferred();
  }

  function Deferred() {
    var promise = this.promise = new Promise();
    //Non prototype methods necessary to support unbound execution :/
    this.resolve = function(val) { resolvePromise(promise, val); };
    this.reject = function(reason) { rejectPromise(promise, reason); };
    this.notify = function(progress) { notifyPromise(promise, progress); };
  }


  function Promise() {
    this.$$state = { status: 0 };
  }

  extend(Promise.prototype, {
    then: function(onFulfilled, onRejected, progressBack) {
      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
        return this;
      }
      var result = new Promise();

      this.$$state.pending = this.$$state.pending || [];
      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

      return result;
    },

    'catch': function(callback) {
      return this.then(null, callback);
    },

    'finally': function(callback, progressBack) {
      return this.then(function(value) {
        return handleCallback(value, resolve, callback);
      }, function(error) {
        return handleCallback(error, reject, callback);
      }, progressBack);
    }
  });

  function processQueue(state) {
    var fn, promise, pending;

    pending = state.pending;
    state.processScheduled = false;
    state.pending = undefined;
    try {
      for (var i = 0, ii = pending.length; i < ii; ++i) {
        markQStateExceptionHandled(state);
        promise = pending[i][0];
        fn = pending[i][state.status];
        try {
          if (isFunction(fn)) {
            resolvePromise(promise, fn(state.value));
          } else if (state.status === 1) {
            resolvePromise(promise, state.value);
          } else {
            rejectPromise(promise, state.value);
          }
        } catch (e) {
          rejectPromise(promise, e);
          // This error is explicitly marked for being passed to the $exceptionHandler
          if (e && e.$$passToExceptionHandler === true) {
            exceptionHandler(e);
          }
        }
      }
    } finally {
      --queueSize;
      if (errorOnUnhandledRejections && queueSize === 0) {
        nextTick(processChecks);
      }
    }
  }

  function processChecks() {
    // eslint-disable-next-line no-unmodified-loop-condition
    while (!queueSize && checkQueue.length) {
      var toCheck = checkQueue.shift();
      if (!isStateExceptionHandled(toCheck)) {
        markQStateExceptionHandled(toCheck);
        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
        if (isError(toCheck.value)) {
          exceptionHandler(toCheck.value, errorMessage);
        } else {
          exceptionHandler(errorMessage);
        }
      }
    }
  }

  function scheduleProcessQueue(state) {
    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
      if (queueSize === 0 && checkQueue.length === 0) {
        nextTick(processChecks);
      }
      checkQueue.push(state);
    }
    if (state.processScheduled || !state.pending) return;
    state.processScheduled = true;
    ++queueSize;
    nextTick(function() { processQueue(state); });
  }

  function resolvePromise(promise, val) {
    if (promise.$$state.status) return;
    if (val === promise) {
      $$reject(promise, $qMinErr(
        'qcycle',
        'Expected promise to be resolved with value other than itself \'{0}\'',
        val));
    } else {
      $$resolve(promise, val);
    }

  }

  function $$resolve(promise, val) {
    var then;
    var done = false;
    try {
      if (isObject(val) || isFunction(val)) then = val.then;
      if (isFunction(then)) {
        promise.$$state.status = -1;
        then.call(val, doResolve, doReject, doNotify);
      } else {
        promise.$$state.value = val;
        promise.$$state.status = 1;
        scheduleProcessQueue(promise.$$state);
      }
    } catch (e) {
      doReject(e);
    }

    function doResolve(val) {
      if (done) return;
      done = true;
      $$resolve(promise, val);
    }
    function doReject(val) {
      if (done) return;
      done = true;
      $$reject(promise, val);
    }
    function doNotify(progress) {
      notifyPromise(promise, progress);
    }
  }

  function rejectPromise(promise, reason) {
    if (promise.$$state.status) return;
    $$reject(promise, reason);
  }

  function $$reject(promise, reason) {
    promise.$$state.value = reason;
    promise.$$state.status = 2;
    scheduleProcessQueue(promise.$$state);
  }

  function notifyPromise(promise, progress) {
    var callbacks = promise.$$state.pending;

    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
      nextTick(function() {
        var callback, result;
        for (var i = 0, ii = callbacks.length; i < ii; i++) {
          result = callbacks[i][0];
          callback = callbacks[i][3];
          try {
            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
          } catch (e) {
            exceptionHandler(e);
          }
        }
      });
    }
  }

  /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */
  function reject(reason) {
    var result = new Promise();
    rejectPromise(result, reason);
    return result;
  }

  function handleCallback(value, resolver, callback) {
    var callbackOutput = null;
    try {
      if (isFunction(callback)) callbackOutput = callback();
    } catch (e) {
      return reject(e);
    }
    if (isPromiseLike(callbackOutput)) {
      return callbackOutput.then(function() {
        return resolver(value);
      }, reject);
    } else {
      return resolver(value);
    }
  }

  /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */


  function when(value, callback, errback, progressBack) {
    var result = new Promise();
    resolvePromise(result, value);
    return result.then(callback, errback, progressBack);
  }

  /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */
  var resolve = when;

  /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */

  function all(promises) {
    var result = new Promise(),
        counter = 0,
        results = isArray(promises) ? [] : {};

    forEach(promises, function(promise, key) {
      counter++;
      when(promise).then(function(value) {
        results[key] = value;
        if (!(--counter)) resolvePromise(result, results);
      }, function(reason) {
        rejectPromise(result, reason);
      });
    });

    if (counter === 0) {
      resolvePromise(result, results);
    }

    return result;
  }

  /**
   * @ngdoc method
   * @name $q#race
   * @kind function
   *
   * @description
   * Returns a promise that resolves or rejects as soon as one of those promises
   * resolves or rejects, with the value or reason from that promise.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
   * resolves or rejects, with the value or reason from that promise.
   */

  function race(promises) {
    var deferred = defer();

    forEach(promises, function(promise) {
      when(promise).then(deferred.resolve, deferred.reject);
    });

    return deferred.promise;
  }

  function $Q(resolver) {
    if (!isFunction(resolver)) {
      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
    }

    var promise = new Promise();

    function resolveFn(value) {
      resolvePromise(promise, value);
    }

    function rejectFn(reason) {
      rejectPromise(promise, reason);
    }

    resolver(resolveFn, rejectFn);

    return promise;
  }

  // Let's make the instanceof operator work for promises, so that
  // `new $q(fn) instanceof $q` would evaluate to true.
  $Q.prototype = Promise.prototype;

  $Q.defer = defer;
  $Q.reject = reject;
  $Q.when = when;
  $Q.resolve = resolve;
  $Q.all = all;
  $Q.race = race;

  return $Q;
}

function isStateExceptionHandled(state) {
  return !!state.pur;
}
function markQStateExceptionHandled(state) {
  state.pur = true;
}
function markQExceptionHandled(q) {
  markQStateExceptionHandled(q.$$state);
}

/** @this */
function $$RAFProvider() { //rAF
  this.$get = ['$window', '$timeout', function($window, $timeout) {
    var requestAnimationFrame = $window.requestAnimationFrame ||
                                $window.webkitRequestAnimationFrame;

    var cancelAnimationFrame = $window.cancelAnimationFrame ||
                               $window.webkitCancelAnimationFrame ||
                               $window.webkitCancelRequestAnimationFrame;

    var rafSupported = !!requestAnimationFrame;
    var raf = rafSupported
      ? function(fn) {
          var id = requestAnimationFrame(fn);
          return function() {
            cancelAnimationFrame(id);
          };
        }
      : function(fn) {
          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
          return function() {
            $timeout.cancel(timer);
          };
        };

    raf.supported = rafSupported;

    return raf;
  }];
}

/**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - This means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
 *
 * There are fewer watches than observers. This is why you don't want the observer to be implemented
 * in the same way as watch. Watch requires return of the initialization function which is expensive
 * to construct.
 */


/**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */

/**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */


/**
 * @ngdoc service
 * @name $rootScope
 * @this
 *
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */
function $RootScopeProvider() {
  var TTL = 10;
  var $rootScopeMinErr = minErr('$rootScope');
  var lastDirtyWatch = null;
  var applyAsyncId = null;

  this.digestTtl = function(value) {
    if (arguments.length) {
      TTL = value;
    }
    return TTL;
  };

  function createChildScopeClass(parent) {
    function ChildScope() {
      this.$$watchers = this.$$nextSibling =
          this.$$childHead = this.$$childTail = null;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$id = nextUid();
      this.$$ChildScope = null;
      this.$$suspended = false;
    }
    ChildScope.prototype = parent;
    return ChildScope;
  }

  this.$get = ['$exceptionHandler', '$parse', '$browser',
      function($exceptionHandler, $parse, $browser) {

    function destroyChildScope($event) {
        $event.currentScope.$$destroyed = true;
    }

    function cleanUpScope($scope) {

      // Support: IE 9 only
      if (msie === 9) {
        // There is a memory leak in IE9 if all child scopes are not disconnected
        // completely when a scope is destroyed. So this code will recurse up through
        // all this scopes children
        //
        // See issue https://github.com/angular/angular.js/issues/10706
        if ($scope.$$childHead) {
          cleanUpScope($scope.$$childHead);
        }
        if ($scope.$$nextSibling) {
          cleanUpScope($scope.$$nextSibling);
        }
      }

      // The code below works around IE9 and V8's memory leaks
      //
      // See:
      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
    }

    /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
     * an in-depth introduction and usage examples.
     *
     *
     * ## Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */
    function Scope() {
      this.$id = nextUid();
      this.$$phase = this.$parent = this.$$watchers =
                     this.$$nextSibling = this.$$prevSibling =
                     this.$$childHead = this.$$childTail = null;
      this.$root = this;
      this.$$destroyed = false;
      this.$$suspended = false;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$$isolateBindings = null;
    }

    /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */

     /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

    Scope.prototype = {
      constructor: Scope,
      /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */
      $new: function(isolate, parent) {
        var child;

        parent = parent || this;

        if (isolate) {
          child = new Scope();
          child.$root = this.$root;
        } else {
          // Only create a child scope class if somebody asks for one,
          // but cache it to allow the VM to optimize lookups.
          if (!this.$$ChildScope) {
            this.$$ChildScope = createChildScopeClass(this);
          }
          child = new this.$$ChildScope();
        }
        child.$parent = parent;
        child.$$prevSibling = parent.$$childTail;
        if (parent.$$childHead) {
          parent.$$childTail.$$nextSibling = child;
          parent.$$childTail = child;
        } else {
          parent.$$childHead = parent.$$childTail = child;
        }

        // When the new scope is not isolated or we inherit from `this`, and
        // the parent scope is destroyed, the property `$$destroyed` is inherited
        // prototypically. In all other cases, this property needs to be set
        // when the parent scope is destroyed.
        // The listener needs to be added after the parent is set
        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);

        return child;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
       *   its value when executed multiple times with the same input because it may be executed multiple
       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - This should not be used to watch for changes in objects that are (or contain)
       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Be prepared for
       * multiple calls to your `watchExpression` because it will execute multiple times in a
       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * @example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
        var get = $parse(watchExp);
        var fn = isFunction(listener) ? listener : noop;

        if (get.$$watchDelegate) {
          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
        }
        var scope = this,
            array = scope.$$watchers,
            watcher = {
              fn: fn,
              last: initWatchVal,
              get: get,
              exp: prettyPrintExpression || watchExp,
              eq: !!objectEquality
            };

        lastDirtyWatch = null;

        if (!array) {
          array = scope.$$watchers = [];
          array.$$digestWatchIndex = -1;
        }
        // we use unshift since we use a while loop in $digest for speed.
        // the while loop reads in reverse order.
        array.unshift(watcher);
        array.$$digestWatchIndex++;
        incrementWatchersCount(this, 1);

        return function deregisterWatch() {
          var index = arrayRemove(array, watcher);
          if (index >= 0) {
            incrementWatchersCount(scope, -1);
            if (index < array.$$digestWatchIndex) {
              array.$$digestWatchIndex--;
            }
          }
          lastDirtyWatch = null;
        };
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
       *   values are examined for changes on every call to `$digest`.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */
      $watchGroup: function(watchExpressions, listener) {
        var oldValues = new Array(watchExpressions.length);
        var newValues = new Array(watchExpressions.length);
        var deregisterFns = [];
        var self = this;
        var changeReactionScheduled = false;
        var firstRun = true;

        if (!watchExpressions.length) {
          // No expressions means we call the listener ASAP
          var shouldCall = true;
          self.$evalAsync(function() {
            if (shouldCall) listener(newValues, newValues, self);
          });
          return function deregisterWatchGroup() {
            shouldCall = false;
          };
        }

        if (watchExpressions.length === 1) {
          // Special case size of one
          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
            newValues[0] = value;
            oldValues[0] = oldValue;
            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
          });
        }

        forEach(watchExpressions, function(expr, i) {
          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
            newValues[i] = value;
            if (!changeReactionScheduled) {
              changeReactionScheduled = true;
              self.$evalAsync(watchGroupAction);
            }
          });
          deregisterFns.push(unwatchFn);
        });

        function watchGroupAction() {
          changeReactionScheduled = false;

          try {
            if (firstRun) {
              firstRun = false;
              listener(newValues, newValues, self);
            } else {
              listener(newValues, oldValues, self);
            }
          } finally {
            for (var i = 0; i < watchExpressions.length; i++) {
              oldValues[i] = newValues[i];
            }
          }
        }

        return function deregisterWatchGroup() {
          while (deregisterFns.length) {
            deregisterFns.shift()();
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * @example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */
      $watchCollection: function(obj, listener) {
        // Mark the interceptor as
        // ... $$pure when literal since the instance will change when any input changes
        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
        // ... $stateful when non-literal since we must read the state of the collection
        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;

        var self = this;
        // the current value, updated on each dirty-check run
        var newValue;
        // a shallow copy of the newValue from the last dirty-check run,
        // updated to match newValue during dirty-check run
        var oldValue;
        // a shallow copy of the newValue from when the last change happened
        var veryOldValue;
        // only track veryOldValue if the listener is asking for it
        var trackVeryOldValue = (listener.length > 1);
        var changeDetected = 0;
        var changeDetector = $parse(obj, $watchCollectionInterceptor);
        var internalArray = [];
        var internalObject = {};
        var initRun = true;
        var oldLength = 0;

        function $watchCollectionInterceptor(_value) {
          newValue = _value;
          var newLength, key, bothNaN, newItem, oldItem;

          // If the new value is undefined, then return undefined as the watch may be a one-time watch
          if (isUndefined(newValue)) return;

          if (!isObject(newValue)) { // if primitive
            if (oldValue !== newValue) {
              oldValue = newValue;
              changeDetected++;
            }
          } else if (isArrayLike(newValue)) {
            if (oldValue !== internalArray) {
              // we are transitioning from something which was not an array into array.
              oldValue = internalArray;
              oldLength = oldValue.length = 0;
              changeDetected++;
            }

            newLength = newValue.length;

            if (oldLength !== newLength) {
              // if lengths do not match we need to trigger change notification
              changeDetected++;
              oldValue.length = oldLength = newLength;
            }
            // copy the items to oldValue and look for changes.
            for (var i = 0; i < newLength; i++) {
              oldItem = oldValue[i];
              newItem = newValue[i];

              // eslint-disable-next-line no-self-compare
              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
              if (!bothNaN && (oldItem !== newItem)) {
                changeDetected++;
                oldValue[i] = newItem;
              }
            }
          } else {
            if (oldValue !== internalObject) {
              // we are transitioning from something which was not an object into object.
              oldValue = internalObject = {};
              oldLength = 0;
              changeDetected++;
            }
            // copy the items to oldValue and look for changes.
            newLength = 0;
            for (key in newValue) {
              if (hasOwnProperty.call(newValue, key)) {
                newLength++;
                newItem = newValue[key];
                oldItem = oldValue[key];

                if (key in oldValue) {
                  // eslint-disable-next-line no-self-compare
                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                  if (!bothNaN && (oldItem !== newItem)) {
                    changeDetected++;
                    oldValue[key] = newItem;
                  }
                } else {
                  oldLength++;
                  oldValue[key] = newItem;
                  changeDetected++;
                }
              }
            }
            if (oldLength > newLength) {
              // we used to have more keys, need to find them and destroy them.
              changeDetected++;
              for (key in oldValue) {
                if (!hasOwnProperty.call(newValue, key)) {
                  oldLength--;
                  delete oldValue[key];
                }
              }
            }
          }
          return changeDetected;
        }

        function $watchCollectionAction() {
          if (initRun) {
            initRun = false;
            listener(newValue, newValue, self);
          } else {
            listener(newValue, veryOldValue, self);
          }

          // make a copy for the next time a collection is changed
          if (trackVeryOldValue) {
            if (!isObject(newValue)) {
              //primitive
              veryOldValue = newValue;
            } else if (isArrayLike(newValue)) {
              veryOldValue = new Array(newValue.length);
              for (var i = 0; i < newValue.length; i++) {
                veryOldValue[i] = newValue[i];
              }
            } else { // if object
              veryOldValue = {};
              for (var key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  veryOldValue[key] = newValue[key];
                }
              }
            }
          }
        }

        return this.$watch(changeDetector, $watchCollectionAction);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * @example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */
      $digest: function() {
        var watch, value, last, fn, get,
            watchers,
            dirty, ttl = TTL,
            next, current, target = asyncQueue.length ? $rootScope : this,
            watchLog = [],
            logIdx, asyncTask;

        beginPhase('$digest');
        // Check for changes to browser url that happened in sync before the call to $digest
        $browser.$$checkUrlChange();

        if (this === $rootScope && applyAsyncId !== null) {
          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
          $browser.defer.cancel(applyAsyncId);
          flushApplyAsync();
        }

        lastDirtyWatch = null;

        do { // "while dirty" loop
          dirty = false;
          current = target;

          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
          // lead to a '$digest already in progress' error.
          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
            try {
              asyncTask = asyncQueue[asyncQueuePosition];
              fn = asyncTask.fn;
              fn(asyncTask.scope, asyncTask.locals);
            } catch (e) {
              $exceptionHandler(e);
            }
            lastDirtyWatch = null;
          }
          asyncQueue.length = 0;

          traverseScopesLoop:
          do { // "traverse the scopes" loop
            if ((watchers = !current.$$suspended && current.$$watchers)) {
              // process our watches
              watchers.$$digestWatchIndex = watchers.length;
              while (watchers.$$digestWatchIndex--) {
                try {
                  watch = watchers[watchers.$$digestWatchIndex];
                  // Most common watches are on primitives, in which case we can short
                  // circuit it with === operator, only when === fails do we use .equals
                  if (watch) {
                    get = watch.get;
                    if ((value = get(current)) !== (last = watch.last) &&
                        !(watch.eq
                            ? equals(value, last)
                            : (isNumberNaN(value) && isNumberNaN(last)))) {
                      dirty = true;
                      lastDirtyWatch = watch;
                      watch.last = watch.eq ? copy(value, null) : value;
                      fn = watch.fn;
                      fn(value, ((last === initWatchVal) ? value : last), current);
                      if (ttl < 5) {
                        logIdx = 4 - ttl;
                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
                        watchLog[logIdx].push({
                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                          newVal: value,
                          oldVal: last
                        });
                      }
                    } else if (watch === lastDirtyWatch) {
                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                      // have already been tested.
                      dirty = false;
                      break traverseScopesLoop;
                    }
                  }
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $broadcast
            // (though it differs due to having the extra check for $$suspended and does not
            // check $$listenerCount)
            if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
                (current !== target && current.$$nextSibling)))) {
              while (current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          } while ((current = next));

          // `break traverseScopesLoop;` takes us to here

          if ((dirty || asyncQueue.length) && !(ttl--)) {
            clearPhase();
            throw $rootScopeMinErr('infdig',
                '{0} $digest() iterations reached. Aborting!\n' +
                'Watchers fired in the last 5 iterations: {1}',
                TTL, watchLog);
          }

        } while (dirty || asyncQueue.length);

        clearPhase();

        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
        while (postDigestQueuePosition < postDigestQueue.length) {
          try {
            postDigestQueue[postDigestQueuePosition++]();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
        postDigestQueue.length = postDigestQueuePosition = 0;

        // Check for changes to browser url that happened during the $digest
        // (for which no event is fired; e.g. via `history.pushState()`)
        $browser.$$checkUrlChange();
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$suspend
       * @kind function
       *
       * @description
       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
       *
       * This can be used to optimize your application when you know that running those watchers
       * is redundant.
       *
       * **Warning**
       *
       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
       * Only use this approach if you are confident that you know what you are doing and have
       * ample tests to ensure that bindings get updated as you expect.
       *
       * Some of the things to consider are:
       *
       * * Any external event on a directive/component will not trigger a digest while the hosting
       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
       * * Transcluded content exists on a scope that inherits from outside a directive but exists
       *   as a child of the directive's containing scope. If the containing scope is suspended the
       *   transcluded scope will also be suspended, even if the scope from which the transcluded
       *   scope inherits is not suspended.
       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
       *    * A call to `$suspend()` on an already suspended scope is a no-op.
       *    * A call to `$resume()` on a non-suspended scope is a no-op.
       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
       *      longer be suspended. This could result in the other directive believing a scope to be
       *      suspended when it is not.
       * * If a parent scope is suspended then all its descendants will be also excluded from future
       *   digests whether or not they have been suspended themselves. Note that this also applies to
       *   isolate child scopes.
       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
       *   for that scope and its descendants. When digesting we only check whether the current scope is
       *   locally suspended, rather than checking whether it has a suspended ancestor.
       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
       *   included in future digests until all its ancestors have been resumed.
       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
       *   initiated by a component that lives on a suspended scope.
       */
      $suspend: function() {
        this.$$suspended = true;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$isSuspended
       * @kind function
       *
       * @description
       * Call this method to determine if this scope has been explicitly suspended. It will not
       * tell you whether an ancestor has been suspended.
       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
       * for example, you must check all its ancestors:
       *
       * ```
       * function isExcludedFromDigest(scope) {
       *   while(scope) {
       *     if (scope.$isSuspended()) return true;
       *     scope = scope.$parent;
       *   }
       *   return false;
       * ```
       *
       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
       * even if `$isSuspended()` returns false.
       *
       * @returns true if the current scope has been suspended.
       */
      $isSuspended: function() {
        return this.$$suspended;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$resume
       * @kind function
       *
       * @description
       * Resume watchers of this scope subtree in case it was suspended.
       *
       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
       */
      $resume: function() {
        this.$$suspended = false;
      },

      /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */
      $destroy: function() {
        // We can't destroy a scope that has been already destroyed.
        if (this.$$destroyed) return;
        var parent = this.$parent;

        this.$broadcast('$destroy');
        this.$$destroyed = true;

        if (this === $rootScope) {
          //Remove handlers attached to window when $rootScope is removed
          $browser.$$applicationDestroyed();
        }

        incrementWatchersCount(this, -this.$$watchersCount);
        for (var eventName in this.$$listenerCount) {
          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
        }

        // sever all the references to parent scopes (after this cleanup, the current scope should
        // not be retained by any of our references and should be eligible for garbage collection)
        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

        // Disable listeners, watchers and apply/digest methods
        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
        this.$$listeners = {};

        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
        this.$$nextSibling = null;
        cleanUpScope(this);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
       * expressions.
       *
       * @example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */
      $eval: function(expr, locals) {
        return $parse(expr)(this, locals);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */
      $evalAsync: function(expr, locals) {
        // if we are outside of an $digest loop and this is the first time we are scheduling async
        // task also schedule async auto-flush
        if (!$rootScope.$$phase && !asyncQueue.length) {
          $browser.defer(function() {
            if (asyncQueue.length) {
              $rootScope.$digest();
            }
          }, null, '$evalAsync');
        }

        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
      },

      $$postDigest: function(fn) {
        postDigestQueue.push(fn);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the AngularJS framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * **Life cycle: Pseudo-Code of `$apply()`**
       *
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */
      $apply: function(expr) {
        try {
          beginPhase('$apply');
          try {
            return this.$eval(expr);
          } finally {
            clearPhase();
          }
        } catch (e) {
          $exceptionHandler(e);
        } finally {
          try {
            $rootScope.$digest();
          } catch (e) {
            $exceptionHandler(e);
            // eslint-disable-next-line no-unsafe-finally
            throw e;
          }
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */
      $applyAsync: function(expr) {
        var scope = this;
        if (expr) {
          applyAsyncQueue.push($applyAsyncExpression);
        }
        expr = $parse(expr);
        scheduleApplyAsync();

        function $applyAsyncExpression() {
          scope.$eval(expr);
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $on: function(name, listener) {
        var namedListeners = this.$$listeners[name];
        if (!namedListeners) {
          this.$$listeners[name] = namedListeners = [];
        }
        namedListeners.push(listener);

        var current = this;
        do {
          if (!current.$$listenerCount[name]) {
            current.$$listenerCount[name] = 0;
          }
          current.$$listenerCount[name]++;
        } while ((current = current.$parent));

        var self = this;
        return function() {
          var indexOfListener = namedListeners.indexOf(listener);
          if (indexOfListener !== -1) {
            // Use delete in the hope of the browser deallocating the memory for the array entry,
            // while not shifting the array indexes of other listeners.
            // See issue https://github.com/angular/angular.js/issues/16135
            delete namedListeners[indexOfListener];
            decrementListenerCount(self, 1, name);
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */
      $emit: function(name, args) {
        var empty = [],
            namedListeners,
            scope = this,
            stopPropagation = false,
            event = {
              name: name,
              targetScope: scope,
              stopPropagation: function() {stopPropagation = true;},
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            },
            listenerArgs = concat([event], arguments, 1),
            i, length;

        do {
          namedListeners = scope.$$listeners[name] || empty;
          event.currentScope = scope;
          for (i = 0, length = namedListeners.length; i < length; i++) {

            // if listeners were deregistered, defragment the array
            if (!namedListeners[i]) {
              namedListeners.splice(i, 1);
              i--;
              length--;
              continue;
            }
            try {
              //allow all listeners attached to the current scope to run
              namedListeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          //if any listener on the current scope stops propagation, prevent bubbling
          if (stopPropagation) {
            break;
          }
          //traverse upwards
          scope = scope.$parent;
        } while (scope);

        event.currentScope = null;

        return event;
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */
      $broadcast: function(name, args) {
        var target = this,
            current = target,
            next = target,
            event = {
              name: name,
              targetScope: target,
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            };

        if (!target.$$listenerCount[name]) return event;

        var listenerArgs = concat([event], arguments, 1),
            listeners, i, length;

        //down while you can, then up and next sibling or up and next sibling until back at root
        while ((current = next)) {
          event.currentScope = current;
          listeners = current.$$listeners[name] || [];
          for (i = 0, length = listeners.length; i < length; i++) {
            // if listeners were deregistered, defragment the array
            if (!listeners[i]) {
              listeners.splice(i, 1);
              i--;
              length--;
              continue;
            }

            try {
              listeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }

          // Insanity Warning: scope depth-first traversal
          // yes, this code is a bit crazy, but it works and we have tests to prove it!
          // this piece should be kept in sync with the traversal in $digest
          // (though it differs due to having the extra check for $$listenerCount and
          // does not check $$suspended)
          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
              (current !== target && current.$$nextSibling)))) {
            while (current !== target && !(next = current.$$nextSibling)) {
              current = current.$parent;
            }
          }
        }

        event.currentScope = null;
        return event;
      }
    };

    var $rootScope = new Scope();

    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
    var asyncQueue = $rootScope.$$asyncQueue = [];
    var postDigestQueue = $rootScope.$$postDigestQueue = [];
    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

    var postDigestQueuePosition = 0;

    return $rootScope;


    function beginPhase(phase) {
      if ($rootScope.$$phase) {
        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
      }

      $rootScope.$$phase = phase;
    }

    function clearPhase() {
      $rootScope.$$phase = null;
    }

    function incrementWatchersCount(current, count) {
      do {
        current.$$watchersCount += count;
      } while ((current = current.$parent));
    }

    function decrementListenerCount(current, count, name) {
      do {
        current.$$listenerCount[name] -= count;

        if (current.$$listenerCount[name] === 0) {
          delete current.$$listenerCount[name];
        }
      } while ((current = current.$parent));
    }

    /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */
    function initWatchVal() {}

    function flushApplyAsync() {
      while (applyAsyncQueue.length) {
        try {
          applyAsyncQueue.shift()();
        } catch (e) {
          $exceptionHandler(e);
        }
      }
      applyAsyncId = null;
    }

    function scheduleApplyAsync() {
      if (applyAsyncId === null) {
        applyAsyncId = $browser.defer(function() {
          $rootScope.$apply(flushApplyAsync);
        }, null, '$applyAsync');
      }
    }
  }];
}

/**
 * @ngdoc service
 * @name $rootElement
 *
 * @description
 * The root element of AngularJS application. This is either the element where {@link
 * ng.directive:ngApp ngApp} was declared or the element passed into
 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
 * location where the application's {@link auto.$injector $injector} service gets
 * published, and can be retrieved using `$rootElement.injector()`.
 */


// the implementation is in angular.bootstrap

/**
 * @this
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */
function $$SanitizeUriProvider() {

  var aHrefSanitizationWhitelist = /^\s*(https?|s?ftp|mailto|tel|file):/,
    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
   *
   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
   *
   * If the URL matches the `aHrefSanitizationWhitelist` regular expression, it is returned unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      aHrefSanitizationWhitelist = regexp;
      return this;
    }
    return aHrefSanitizationWhitelist;
  };


  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
   *
   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
   * the potentially malicious URL.
   *
   * If the URL matches the `aImgSanitizationWhitelist` regular expression, it is returned unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      imgSrcSanitizationWhitelist = regexp;
      return this;
    }
    return imgSrcSanitizationWhitelist;
  };

  this.$get = function() {
    return function sanitizeUri(uri, isMediaUrl) {
      // if (!uri) return uri;
      var regex = isMediaUrl ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
      var normalizedVal = urlResolve(uri && uri.trim()).href;
      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
        return 'unsafe:' + normalizedVal;
      }
      return uri;
    };
  };
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* exported $SceProvider, $SceDelegateProvider */

var $sceMinErr = minErr('$sce');

var SCE_CONTEXTS = {
  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
  HTML: 'html',

  // Style statements or stylesheets. Currently unused in AngularJS.
  CSS: 'css',

  // An URL used in a context where it refers to the source of media, which are not expected to be run
  // as scripts, such as an image, audio, video, etc.
  MEDIA_URL: 'mediaUrl',

  // An URL used in a context where it does not refer to a resource that loads code.
  // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
  URL: 'url',

  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
  // code. (e.g. ng-include, script src binding, templateUrl)
  // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
  RESOURCE_URL: 'resourceUrl',

  // Script. Currently unused in AngularJS.
  JS: 'js'
};

// Helper functions follow.

var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;

function snakeToCamel(name) {
  return name
    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

function adjustMatcher(matcher) {
  if (matcher === 'self') {
    return matcher;
  } else if (isString(matcher)) {
    // Strings match exactly except for 2 wildcards - '*' and '**'.
    // '*' matches any character except those from the set ':/.?&'.
    // '**' matches any character (like .* in a RegExp).
    // More than 2 *'s raises an error as it's ill defined.
    if (matcher.indexOf('***') > -1) {
      throw $sceMinErr('iwcard',
          'Illegal sequence *** in string matcher.  String: {0}', matcher);
    }
    matcher = escapeForRegexp(matcher).
                  replace(/\\\*\\\*/g, '.*').
                  replace(/\\\*/g, '[^:/.?&;]*');
    return new RegExp('^' + matcher + '$');
  } else if (isRegExp(matcher)) {
    // The only other type of matcher allowed is a Regexp.
    // Match entire URL / disallow partial matches.
    // Flags are reset (i.e. no global, ignoreCase or multiline)
    return new RegExp('^' + matcher.source + '$');
  } else {
    throw $sceMinErr('imatcher',
        'Matchers may only be "self", string patterns or RegExp objects');
  }
}


function adjustMatchers(matchers) {
  var adjustedMatchers = [];
  if (isDefined(matchers)) {
    forEach(matchers, function(matcher) {
      adjustedMatchers.push(adjustMatcher(matcher));
    });
  }
  return adjustedMatchers;
}


/**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * For an overview of this service and the functionnality it provides in AngularJS, see the main
 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
 * SCE works in their application, which shouldn't be needed in most cases.
 *
 * <div class="alert alert-danger">
 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
 * changes to this service will also influence users, so be extra careful and document your changes.
 * </div>
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 */

/**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @this
 *
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
 *
 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
 * places that use the `$sce.RESOURCE_URL` context). See
 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
 * and
 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
 *
 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.resourceUrlWhitelist([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
 *    $sceDelegateProvider.resourceUrlBlacklist([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 * Note that an empty whitelist will block every resource URL from being loaded, and will require
 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
 * requested by {@link ng.$templateRequest $templateRequest} that are present in
 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
 * for instance attacker-controlled `ng-includes`.
 */

function $SceDelegateProvider() {
  this.SCE_CONTEXTS = SCE_CONTEXTS;

  // Resource URLs can also be trusted by policy.
  var resourceUrlWhitelist = ['self'],
      resourceUrlBlacklist = [];

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   * @return {Array} The currently set whitelist array.
   *
   * @description
   * Sets/Gets the whitelist of trusted resource URLs.
   *
   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
   * same origin resource requests.
   *
   * <div class="alert alert-warning">
   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
   * with other apps! It is a good idea to limit it to only your application's directory.
   * </div>
   */
  this.resourceUrlWhitelist = function(value) {
    if (arguments.length) {
      resourceUrlWhitelist = adjustMatchers(value);
    }
    return resourceUrlWhitelist;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.</p><p>
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.</p><p>
   *     The typical usage for the blacklist is to **block
   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *     these would otherwise be trusted but actually return content from the redirected domain.
   *     </p><p>
   *     Finally, **the blacklist overrides the whitelist** and has the final say.
   *
   * @return {Array} The currently set blacklist array.
   *
   * @description
   * Sets/Gets the blacklist of trusted resource URLs.
   *
   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
   * is no blacklist.)
   */

  this.resourceUrlBlacklist = function(value) {
    if (arguments.length) {
      resourceUrlBlacklist = adjustMatchers(value);
    }
    return resourceUrlBlacklist;
  };

  this.$get = ['$injector', '$$sanitizeUri', function($injector, $$sanitizeUri) {

    var htmlSanitizer = function htmlSanitizer(html) {
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    };

    if ($injector.has('$sanitize')) {
      htmlSanitizer = $injector.get('$sanitize');
    }


    function matchUrl(matcher, parsedUrl) {
      if (matcher === 'self') {
        return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
      } else {
        // definitely a regex.  See adjustMatchers()
        return !!matcher.exec(parsedUrl.href);
      }
    }

    function isResourceUrlAllowedByPolicy(url) {
      var parsedUrl = urlResolve(url.toString());
      var i, n, allowed = false;
      // Ensure that at least one item from the whitelist allows this url.
      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
          allowed = true;
          break;
        }
      }
      if (allowed) {
        // Ensure that no item from the blacklist blocked this url.
        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
            allowed = false;
            break;
          }
        }
      }
      return allowed;
    }

    function generateHolderType(Base) {
      var holderType = function TrustedValueHolderType(trustedValue) {
        this.$$unwrapTrustedValue = function() {
          return trustedValue;
        };
      };
      if (Base) {
        holderType.prototype = new Base();
      }
      holderType.prototype.valueOf = function sceValueOf() {
        return this.$$unwrapTrustedValue();
      };
      holderType.prototype.toString = function sceToString() {
        return this.$$unwrapTrustedValue().toString();
      };
      return holderType;
    }

    var trustedValueHolderBase = generateHolderType(),
        byType = {};

    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

    /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns a trusted representation of the parameter for the specified context. This trusted
     * object will later on be used as-is, without any security check, by bindings or directives
     * that require this security context.
     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
     * security risk.
     *
     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
     * escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that should be considered trusted.
     * @return {*} A trusted representation of value, that can be used in the given context.
     */
    function trustAs(type, trustedValue) {
      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (!Constructor) {
        throw $sceMinErr('icontext',
            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
            type, trustedValue);
      }
      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
        return trustedValue;
      }
      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
      // mutable objects, we ensure here that the value passed in is actually a string.
      if (typeof trustedValue !== 'string') {
        throw $sceMinErr('itype',
            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
            type);
      }
      return new Constructor(trustedValue);
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *     call or anything else.
     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */
    function valueOf(maybeTrusted) {
      if (maybeTrusted instanceof trustedValueHolderBase) {
        return maybeTrusted.$$unwrapTrustedValue();
      } else {
        return maybeTrusted;
      }
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Given an object and a security context in which to assign it, returns a value that's safe to
     * use in this context, which was represented by the parameter. To do so, this function either
     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
     * the context and sanitizer availablility.
     *
     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#resourceUrlWhitelist
     * `$sceDelegateProvider.resourceUrlWhitelist`} and {@link ng.$sceDelegateProvider#resourceUrlBlacklist
     * `$sceDelegateProvider.resourceUrlBlacklist`} accepts that resource.
     *
     * This function will throw if the safe type isn't appropriate for this context, or if the
     * value given cannot be accepted in the context (which might be caused by sanitization not
     * being available, or the value not being recognized as safe).
     *
     * <div class="alert alert-danger">
     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
     * (XSS) vulnerability in your application.
     * </div>
     *
     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */
    function getTrusted(type, maybeTrusted) {
      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
        return maybeTrusted;
      }
      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
      // as-is.
      if (constructor && maybeTrusted instanceof constructor) {
        return maybeTrusted.$$unwrapTrustedValue();
      }

      // If maybeTrusted is a trusted class instance but not of the correct trusted type
      // then unwrap it and allow it to pass through to the rest of the checks
      if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
        maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
      }

      // If we get here, then we will either sanitize the value or throw an exception.
      if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
        // we attempt to sanitize non-resource URLs
        return $$sanitizeUri(maybeTrusted, type === SCE_CONTEXTS.MEDIA_URL);
      } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
          return maybeTrusted;
        } else {
          throw $sceMinErr('insecurl',
              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
              maybeTrusted.toString());
        }
      } else if (type === SCE_CONTEXTS.HTML) {
        // htmlSanitizer throws its own error when no sanitizer is available.
        return htmlSanitizer(maybeTrusted);
      }
      // Default error when the $sce service has no way to make the input safe.
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    }

    return { trustAs: trustAs,
             getTrusted: getTrusted,
             valueOf: valueOf };
  }];
}


/**
 * @ngdoc provider
 * @name $sceProvider
 * @this
 *
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */

/**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * ## Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * ### Overview
 *
 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
 * can be sanitized, but template URLs cannot, for instance.
 *
 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
 * render the input as-is, you will need to mark it as trusted for that context before attempting
 * to bind it.
 *
 * As of version 1.2, AngularJS ships with SCE enabled by default.
 *
 * ### In practice
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
 * controlled input creates security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
 * any similar validation process, unless there's a good reason to trust the given value in this
 * context.  That trust is formalized with a function call. This means that as a developer, you
 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
 * you just need to ensure the values you mark as trusted indeed are safe - because they were
 * received from your server, sanitized by your library, etc. You can organize your codebase to
 * help with this - perhaps allowing only the files in a specific directory to do this.
 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
 * becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * build the trusted versions of your values.
 *
 * ### How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
 * a way to enforce the required security context in your data sink. Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
 * when binding without directives, AngularJS will understand the context of your bindings
 * automatically.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ### Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, AngularJS only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ### This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
 * when binding untrusted values to `$sce.HTML` context.
 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
 * your application.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ### What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider#resourceUrlWhitelist()} and {@link $sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider#resourceUrlBlacklist()} can be used to restrict trusted origins for `RESOURCE_URL` |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
 *
 *
 * <div class="alert alert-warning">
 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
 *
 * **As of 1.7.0, this is no longer the case.**
 *
 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
 * service evaluates the expressions.
 * </div>
 *
 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
 * functions aren't useful yet. This might evolve.
 *
 * ### Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
 *      in a whitelist.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  E.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ### Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function AppController($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
 *           self.userComments = response.data;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
 * you are writing a library, you will cause security bugs applications using it.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects or libraries.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */

function $SceProvider() {
  var enabled = true;

  /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
   * @return {boolean} True if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */
  this.enabled = function(value) {
    if (arguments.length) {
      enabled = !!value;
    }
    return enabled;
  };


  /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way. In some future, we may not use
   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
   * be aware of this detail.
   */

  this.$get = ['$parse', '$sceDelegate', function(
                $parse,   $sceDelegate) {
    // Support: IE 9-11 only
    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
    // the "expression(javascript expression)" syntax which is insecure.
    if (enabled && msie < 8) {
      throw $sceMinErr('iequirks',
        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
    }

    var sce = shallowCopy(SCE_CONTEXTS);

    /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */
    sce.isEnabled = function() {
      return enabled;
    };
    sce.trustAs = $sceDelegate.trustAs;
    sce.getTrusted = $sceDelegate.getTrusted;
    sce.valueOf = $sceDelegate.valueOf;

    if (!enabled) {
      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
      sce.valueOf = identity;
    }

    /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */
    sce.parseAs = function sceParseAs(type, expr) {
      var parsed = $parse(expr);
      if (parsed.literal && parsed.constant) {
        return parsed;
      } else {
        return $parse(expr, function(value) {
          return sce.getTrusted(type, value);
        });
      }
    };

    /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
     * wrapped object that represents your value, and the trust you have in its safety for the given
     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that that should be considered trusted.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in the context you specified.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.HTML` context (like `ng-bind-html`).
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsCss
     *
     * @description
     * Shorthand method.  `$sce.trustAsCss(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant
     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
     *     almost no reasons to use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
     *     to use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
     *     bindings, ...)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.JS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
     *     use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes any input, and either returns a value that's safe to use in the specified context,
     * or throws an exception. This function is aware of trusted values created by the `trustAs`
     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
     * safe value (e.g., no sanitization is available or possible.)
     *
     * @param {string} type The context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    // Shorthand delegations.
    var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;

    forEach(SCE_CONTEXTS, function(enumValue, name) {
      var lName = lowercase(name);
      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
        return parse(enumValue, expr);
      };
      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
        return getTrusted(enumValue, value);
      };
      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
        return trustAs(enumValue, value);
      };
    });

    return sce;
  }];
}

/* exported $SnifferProvider */

/**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 * @this
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */
function $SnifferProvider() {
  this.$get = ['$window', '$document', function($window, $document) {
    var eventSupport = {},
        // Chrome Packaged Apps are not allowed to access `history.pushState`.
        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
        // (see https://developer.chrome.com/apps/manifest/sandbox).
        // (NW.js apps have access to Chrome APIs, but do support `history`.)
        isNw = $window.nw && $window.nw.process,
        isChromePackagedApp =
            !isNw &&
            $window.chrome &&
            ($window.chrome.app && $window.chrome.app.runtime ||
                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
        android =
          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false;

    if (bodyStyle) {
      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
      // Mentioned browsers need a -webkit- prefix for transitions & animations.
      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
    }


    return {
      // Android has history.pushState, but it does not update location correctly
      // so let's not use the history API at all.
      // http://code.google.com/p/android/issues/detail?id=17471
      // https://github.com/angular/angular.js/issues/904

      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
      // so let's not use the history API also
      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
      hasEvent: function(event) {
        // Support: IE 9-11 only
        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
        // it. In particular the event is not fired when backspace or delete key are pressed or
        // when cut operation is performed.
        // IE10+ implements 'input' event but it erroneously fires under various situations,
        // e.g. when placeholder changes, or a form is focused.
        if (event === 'input' && msie) return false;

        if (isUndefined(eventSupport[event])) {
          var divElm = document.createElement('div');
          eventSupport[event] = 'on' + event in divElm;
        }

        return eventSupport[event];
      },
      csp: csp(),
      transitions: transitions,
      animations: animations,
      android: android
    };
  }];
}

/**
 * ! This is a private undocumented service !
 *
 * @name $$taskTrackerFactory
 * @description
 * A function to create `TaskTracker` instances.
 *
 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
 * parties when all pending tasks (or tasks of a specific type) have been completed.
 *
 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
 *     execution.
 *
 * @this
 */
function $$TaskTrackerFactoryProvider() {
  this.$get = valueFn(function(log) { return new TaskTracker(log); });
}

function TaskTracker(log) {
  var self = this;
  var taskCounts = {};
  var taskCallbacks = [];

  var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
  var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';

  /**
   * Execute the specified function and decrement the appropriate `taskCounts` counter.
   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
   *
   * @param {Function} fn - The function to execute.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
   */
  self.completeTask = completeTask;

  /**
   * Increase the task count for the specified task type (or the default task type if non is
   * specified).
   *
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
   */
  self.incTaskCount = incTaskCount;

  /**
   * Execute the specified callback when all pending tasks have been completed.
   *
   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
   * the tasks that will be waited for to a specific type, by passing a `taskType`.
   *
   * @param {function} callback - The function to call when there are no pending tasks.
   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
   */
  self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;

  function completeTask(fn, taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;

    try {
      fn();
    } finally {
      decTaskCount(taskType);

      var countForType = taskCounts[taskType];
      var countForAll = taskCounts[ALL_TASKS_TYPE];

      // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
      if (!countForAll || !countForType) {
        var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
        var nextCb;

        while ((nextCb = getNextCallback(taskType))) {
          try {
            nextCb();
          } catch (e) {
            log.error(e);
          }
        }
      }
    }
  }

  function decTaskCount(taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;
    if (taskCounts[taskType]) {
      taskCounts[taskType]--;
      taskCounts[ALL_TASKS_TYPE]--;
    }
  }

  function getLastCallback() {
    var cbInfo = taskCallbacks.pop();
    return cbInfo && cbInfo.cb;
  }

  function getLastCallbackForType(taskType) {
    for (var i = taskCallbacks.length - 1; i >= 0; --i) {
      var cbInfo = taskCallbacks[i];
      if (cbInfo.type === taskType) {
        taskCallbacks.splice(i, 1);
        return cbInfo.cb;
      }
    }
  }

  function incTaskCount(taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;
    taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
    taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
  }

  function notifyWhenNoPendingTasks(callback, taskType) {
    taskType = taskType || ALL_TASKS_TYPE;
    if (!taskCounts[taskType]) {
      callback();
    } else {
      taskCallbacks.push({type: taskType, cb: callback});
    }
  }
}

var $templateRequestMinErr = minErr('$templateRequest');

/**
 * @ngdoc provider
 * @name $templateRequestProvider
 * @this
 *
 * @description
 * Used to configure the options passed to the {@link $http} service when making a template request.
 *
 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
 * requesting a template.
 */
function $TemplateRequestProvider() {

  var httpOptions;

  /**
   * @ngdoc method
   * @name $templateRequestProvider#httpOptions
   * @description
   * The options to be passed to the {@link $http} service when making the request.
   * You can use this to override options such as the "Accept" header for template requests.
   *
   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
   * options if not overridden here.
   *
   * @param {string=} value new value for the {@link $http} options.
   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
   */
  this.httpOptions = function(val) {
    if (val) {
      httpOptions = val;
      return this;
    }
    return httpOptions;
  };

  /**
   * @ngdoc service
   * @name $templateRequest
   *
   * @description
   * The `$templateRequest` service runs security checks then downloads the provided template using
   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
   * when `tpl` is of type string and `$templateCache` has the matching entry.
   *
   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
   * can configure this via {@link $templateRequestProvider#httpOptions}.
   *
   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
   * as {@link ngInclude} to download and cache templates.
   *
   * 3rd party modules should use `$templateRequest` if their services or directives are loading
   * templates.
   *
   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
   *
   * @return {Promise} a promise for the HTTP response data of the given URL.
   *
   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
   */
  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
    function($exceptionHandler, $templateCache, $http, $q, $sce) {

      function handleRequestFn(tpl, ignoreRequestError) {
        handleRequestFn.totalPendingRequests++;

        // We consider the template cache holds only trusted templates, so
        // there's no need to go through whitelisting again for keys that already
        // are included in there. This also makes AngularJS accept any script
        // directive, no matter its name. However, we still need to unwrap trusted
        // types.
        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
          tpl = $sce.getTrustedResourceUrl(tpl);
        }

        var transformResponse = $http.defaults && $http.defaults.transformResponse;

        if (isArray(transformResponse)) {
          transformResponse = transformResponse.filter(function(transformer) {
            return transformer !== defaultHttpResponseTransform;
          });
        } else if (transformResponse === defaultHttpResponseTransform) {
          transformResponse = null;
        }

        return $http.get(tpl, extend({
            cache: $templateCache,
            transformResponse: transformResponse
          }, httpOptions))
          .finally(function() {
            handleRequestFn.totalPendingRequests--;
          })
          .then(function(response) {
            return $templateCache.put(tpl, response.data);
          }, handleError);

        function handleError(resp) {
          if (!ignoreRequestError) {
            resp = $templateRequestMinErr('tpload',
                'Failed to load template: {0} (HTTP status: {1} {2})',
                tpl, resp.status, resp.statusText);

            $exceptionHandler(resp);
          }

          return $q.reject(resp);
        }
      }

      handleRequestFn.totalPendingRequests = 0;

      return handleRequestFn;
    }
  ];
}

/** @this */
function $$TestabilityProvider() {
  this.$get = ['$rootScope', '$browser', '$location',
       function($rootScope,   $browser,   $location) {

    /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */
    var testability = {};

    /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */
    testability.findBindings = function(element, expression, opt_exactMatch) {
      var bindings = element.getElementsByClassName('ng-binding');
      var matches = [];
      forEach(bindings, function(binding) {
        var dataBinding = angular.element(binding).data('$binding');
        if (dataBinding) {
          forEach(dataBinding, function(bindingName) {
            if (opt_exactMatch) {
              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
              if (matcher.test(bindingName)) {
                matches.push(binding);
              }
            } else {
              if (bindingName.indexOf(expression) !== -1) {
                matches.push(binding);
              }
            }
          });
        }
      });
      return matches;
    };

    /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */
    testability.findModels = function(element, expression, opt_exactMatch) {
      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
      for (var p = 0; p < prefixes.length; ++p) {
        var attributeEquals = opt_exactMatch ? '=' : '*=';
        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
        var elements = element.querySelectorAll(selector);
        if (elements.length) {
          return elements;
        }
      }
    };

    /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */
    testability.getLocation = function() {
      return $location.url();
    };

    /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */
    testability.setLocation = function(url) {
      if (url !== $location.url()) {
        $location.url(url);
        $rootScope.$digest();
      }
    };

    /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when all pending tasks are completed.
     *
     * Types of tasks waited for include:
     * - Pending timeouts (via {@link $timeout}).
     * - Pending HTTP requests (via {@link $http}).
     * - In-progress route transitions (via {@link $route}).
     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
     *
     * @param {function} callback
     */
    testability.whenStable = function(callback) {
      $browser.notifyWhenNoOutstandingRequests(callback);
    };

    return testability;
  }];
}

var $timeoutMinErr = minErr('$timeout');

/** @this */
function $TimeoutProvider() {
  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {

    var deferreds = {};


    /**
     * @ngdoc service
     * @name $timeout
     *
     * @description
     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
     * block and delegates any exceptions to
     * {@link ng.$exceptionHandler $exceptionHandler} service.
     *
     * The return value of calling `$timeout` is a promise, which will be resolved when
     * the delay has passed and the timeout function, if provided, is executed.
     *
     * To cancel a timeout request, call `$timeout.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
     * synchronously flush the queue of deferred functions.
     *
     * If you only want a promise that will be resolved after some specified delay
     * then you can call `$timeout` without the `fn` function.
     *
     * @param {function()=} fn A function, whose execution should be delayed.
     * @param {number=} [delay=0] Delay in milliseconds.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
     *   will be resolved with the return value of the `fn` function.
     *
     */
    function timeout(fn, delay, invokeApply) {
      if (!isFunction(fn)) {
        invokeApply = delay;
        delay = fn;
        fn = noop;
      }

      var args = sliceArgs(arguments, 3),
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise,
          timeoutId;

      timeoutId = $browser.defer(function() {
        try {
          deferred.resolve(fn.apply(null, args));
        } catch (e) {
          deferred.reject(e);
          $exceptionHandler(e);
        } finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (!skipApply) $rootScope.$apply();
      }, delay, '$timeout');

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }


    /**
     * @ngdoc method
     * @name $timeout#cancel
     *
     * @description
     * Cancels a task associated with the `promise`. As a result of this, the promise will be
     * resolved with a rejection.
     *
     * @param {Promise=} promise Promise returned by the `$timeout` function.
     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
     *   canceled.
     */
    timeout.cancel = function(promise) {
      if (!promise) return false;

      if (!promise.hasOwnProperty('$$timeoutId')) {
        throw $timeoutMinErr('badprom',
            '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
      }

      if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;

      var id = promise.$$timeoutId;
      var deferred = deferreds[id];

      // Timeout cancels should not report an unhandled promise.
      markQExceptionHandled(deferred.promise);
      deferred.reject('canceled');
      delete deferreds[id];

      return $browser.defer.cancel(id);
    };

    return timeout;
  }];
}

// NOTE:  The usage of window and document instead of $window and $document here is
// deliberate.  This service depends on the specific behavior of anchor nodes created by the
// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
// doesn't know about mocked locations and resolves URLs to the real document - which is
// exactly the behavior needed here.  There is little value is mocking these out for this
// service.
var urlParsingNode = window.document.createElement('a');
var originUrl = urlResolve(window.location.href);
var baseUrlParsingNode;


/**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+ etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
 *     unchanged.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description                                                            |
 *   |---------------|------------------------------------------------------------------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol without the trailing colon                                |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol                                 |
 *   | hostname      | The hostname                                                           |
 *   | port          | The port, without ":"                                                  |
 *   | pathname      | The pathname, beginning with "/"                                       |
 *
 */
function urlResolve(url) {
  if (!isString(url)) return url;

  var href = url;

  // Support: IE 9-11 only
  if (msie) {
    // Normalize before parse.  Refer Implementation Notes on why this is
    // done in two steps on IE.
    urlParsingNode.setAttribute('href', href);
    href = urlParsingNode.href;
  }

  urlParsingNode.setAttribute('href', href);

  return {
    href: urlParsingNode.href,
    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
    host: urlParsingNode.host,
    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
    hostname: urlParsingNode.hostname,
    port: urlParsingNode.port,
    pathname: (urlParsingNode.pathname.charAt(0) === '/')
      ? urlParsingNode.pathname
      : '/' + urlParsingNode.pathname
  };
}

/**
 * Parse a request URL and determine whether this is a same-origin request as the application
 * document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */
function urlIsSameOrigin(requestUrl) {
  return urlsAreSameOrigin(requestUrl, originUrl);
}

/**
 * Parse a request URL and determine whether it is same-origin as the current document base URL.
 *
 * Note: The base URL is usually the same as the document location (`location.href`) but can
 * be overriden by using the `<base>` tag.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the URL is same-origin as the document base URL.
 */
function urlIsSameOriginAsBaseUrl(requestUrl) {
  return urlsAreSameOrigin(requestUrl, getBaseUrl());
}

/**
 * Create a function that can check a URL's origin against a list of allowed/whitelisted origins.
 * The current location's origin is implicitly trusted.
 *
 * @param {string[]} whitelistedOriginUrls - A list of URLs (strings), whose origins are trusted.
 *
 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
 *     whether it is of an allowed origin.
 */
function urlIsAllowedOriginFactory(whitelistedOriginUrls) {
  var parsedAllowedOriginUrls = [originUrl].concat(whitelistedOriginUrls.map(urlResolve));

  /**
   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
   * based on a list of whitelisted-origin URLs. The current location's origin is implicitly
   * trusted.
   *
   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
   *     resolved or a parsed URL object).
   *
   * @returns {boolean} - Whether the specified URL is of an allowed origin.
   */
  return function urlIsAllowedOrigin(requestUrl) {
    var parsedUrl = urlResolve(requestUrl);
    return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
  };
}

/**
 * Determine if two URLs share the same origin.
 *
 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
 *     a dictionary object returned by `urlResolve()`.
 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
 *     of a dictionary object returned by `urlResolve()`.
 *
 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
 */
function urlsAreSameOrigin(url1, url2) {
  url1 = urlResolve(url1);
  url2 = urlResolve(url2);

  return (url1.protocol === url2.protocol &&
          url1.host === url2.host);
}

/**
 * Returns the current document base URL.
 * @returns {string}
 */
function getBaseUrl() {
  if (window.document.baseURI) {
    return window.document.baseURI;
  }

  // `document.baseURI` is available everywhere except IE
  if (!baseUrlParsingNode) {
    baseUrlParsingNode = window.document.createElement('a');
    baseUrlParsingNode.href = '.';

    // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
    // suitable here because we need to track changes to the base URL.
    baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
  }
  return baseUrlParsingNode.href;
}

/**
 * @ngdoc service
 * @name $window
 * @this
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In AngularJS we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample" name="window-service">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */
function $WindowProvider() {
  this.$get = valueFn(window);
}

/**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */
function $$CookieReader($document) {
  var rawDocument = $document[0] || {};
  var lastCookies = {};
  var lastCookieString = '';

  function safeGetCookie(rawDocument) {
    try {
      return rawDocument.cookie || '';
    } catch (e) {
      return '';
    }
  }

  function safeDecodeURIComponent(str) {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  }

  return function() {
    var cookieArray, cookie, i, index, name;
    var currentCookieString = safeGetCookie(rawDocument);

    if (currentCookieString !== lastCookieString) {
      lastCookieString = currentCookieString;
      cookieArray = lastCookieString.split('; ');
      lastCookies = {};

      for (i = 0; i < cookieArray.length; i++) {
        cookie = cookieArray[i];
        index = cookie.indexOf('=');
        if (index > 0) { //ignore nameless cookies
          name = safeDecodeURIComponent(cookie.substring(0, index));
          // the first value that is seen for a cookie is the most
          // specific one.  values for the same cookie name that
          // follow are for less specific paths.
          if (isUndefined(lastCookies[name])) {
            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
          }
        }
      }
    }
    return lastCookies;
  };
}

$$CookieReader.$inject = ['$document'];

/** @this */
function $$CookieReaderProvider() {
  this.$get = $$CookieReader;
}

/* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */

/**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how AngularJS filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the AngularJS Developer Guide.
 */

/**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * They can be used in view templates, controllers or services. AngularJS comes
 * with a collection of [built-in filters](api/ng/filter), but it is easy to
 * define your own as well.
 *
 * The general syntax in templates is as follows:
 *
 * ```html
 * {{ expression [| filter_name[:parameter_value] ... ] }}
 * ```
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */
$FilterProvider.$inject = ['$provide'];
/** @this */
function $FilterProvider($provide) {
  var suffix = 'Filter';

  /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */
  function register(name, factory) {
    if (isObject(name)) {
      var filters = {};
      forEach(name, function(filter, key) {
        filters[key] = register(key, filter);
      });
      return filters;
    } else {
      return $provide.factory(name + suffix, factory);
    }
  }
  this.register = register;

  this.$get = ['$injector', function($injector) {
    return function(name) {
      return $injector.get(name + suffix);
    };
  }];

  ////////////////////////////////////////

  /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false
  */

  register('currency', currencyFilter);
  register('date', dateFilter);
  register('filter', filterFilter);
  register('json', jsonFilter);
  register('limitTo', limitToFilter);
  register('lowercase', lowercaseFilter);
  register('number', numberFilter);
  register('orderBy', orderByFilter);
  register('uppercase', uppercaseFilter);
}

/**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * <div class="alert alert-info">
 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
 * </div>
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
 *     against any property of the object or its nested object properties. That's equivalent to the
 *     simple substring match with a `string` as described above. The special property name can be
 *     overwritten, using the `anyPropertyKey` parameter.
 *     The predicate can be negated by prefixing the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
 *     determining if values retrieved using `expression` (when it is not a function) should be
 *     considered a match based on the expected value (from the filter expression) and actual
 *     value (from the object in the array).
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false`: A short hand for a function which will look for a substring match in a case
 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
 *
 *
 *   Defaults to `false`.
 *
 * @param {string} [anyPropertyKey] The special property name that matches against any property.
 *     By default `$`.
 *
 * @example
   <example name="filter-filter">
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */

function filterFilter() {
  return function(array, expression, comparator, anyPropertyKey) {
    if (!isArrayLike(array)) {
      if (array == null) {
        return array;
      } else {
        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
      }
    }

    anyPropertyKey = anyPropertyKey || '$';
    var expressionType = getTypeForFilter(expression);
    var predicateFn;
    var matchAgainstAnyProp;

    switch (expressionType) {
      case 'function':
        predicateFn = expression;
        break;
      case 'boolean':
      case 'null':
      case 'number':
      case 'string':
        matchAgainstAnyProp = true;
        // falls through
      case 'object':
        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        break;
      default:
        return array;
    }

    return Array.prototype.filter.call(array, predicateFn);
  };
}

// Helper functions for `filterFilter`
function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
  var predicateFn;

  if (comparator === true) {
    comparator = equals;
  } else if (!isFunction(comparator)) {
    comparator = function(actual, expected) {
      if (isUndefined(actual)) {
        // No substring matching against `undefined`
        return false;
      }
      if ((actual === null) || (expected === null)) {
        // No substring matching against `null`; only match against `null`
        return actual === expected;
      }
      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
        // Should not compare primitives against objects, unless they have custom `toString` method
        return false;
      }

      actual = lowercase('' + actual);
      expected = lowercase('' + expected);
      return actual.indexOf(expected) !== -1;
    };
  }

  predicateFn = function(item) {
    if (shouldMatchPrimitives && !isObject(item)) {
      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
    }
    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
  };

  return predicateFn;
}

function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
  var actualType = getTypeForFilter(actual);
  var expectedType = getTypeForFilter(expected);

  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
  } else if (isArray(actual)) {
    // In case `actual` is an array, consider it a match
    // if ANY of it's items matches `expected`
    return actual.some(function(item) {
      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
    });
  }

  switch (actualType) {
    case 'object':
      var key;
      if (matchAgainstAnyProp) {
        for (key in actual) {
          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
          // See: https://github.com/angular/angular.js/issues/15644
          if (key.charAt && (key.charAt(0) !== '$') &&
              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
            return true;
          }
        }
        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
      } else if (expectedType === 'object') {
        for (key in expected) {
          var expectedVal = expected[key];
          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
            continue;
          }

          var matchAnyProperty = key === anyPropertyKey;
          var actualVal = matchAnyProperty ? actual : actual[key];
          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
            return false;
          }
        }
        return true;
      } else {
        return comparator(actual, expected);
      }
    case 'function':
      return false;
    default:
      return comparator(actual, expected);
  }
}

// Used for easily differentiating between `null` and actual `object`
function getTypeForFilter(val) {
  return (val === null) ? 'null' : typeof val;
}

var MAX_DIGITS = 22;
var DECIMAL_SEP = '.';
var ZERO_CHAR = '0';

/**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample" name="currency-filter">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser === 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
       });
     </file>
   </example>
 */
currencyFilter.$inject = ['$locale'];
function currencyFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(amount, currencySymbol, fractionSize) {
    if (isUndefined(currencySymbol)) {
      currencySymbol = formats.CURRENCY_SYM;
    }

    if (isUndefined(fractionSize)) {
      fractionSize = formats.PATTERNS[1].maxFrac;
    }

    // If the currency symbol is empty, trim whitespace around the symbol
    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;

    // if null or undefined pass it through
    return (amount == null)
        ? amount
        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
            replace(currencySymbolRe, currencySymbol);
  };
}

/**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
 *                   include "," group separators after each third digit).
 *
 * @example
   <example module="numberFilterExample" name="number-filter">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */
numberFilter.$inject = ['$locale'];
function numberFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(number, fractionSize) {

    // if null or undefined pass it through
    return (number == null)
        ? number
        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
                       fractionSize);
  };
}

/**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */
function parse(numStr) {
  var exponent = 0, digits, numberOfIntegerDigits;
  var i, j, zeros;

  // Decimal point?
  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
    numStr = numStr.replace(DECIMAL_SEP, '');
  }

  // Exponential form?
  if ((i = numStr.search(/e/i)) > 0) {
    // Work out the exponent.
    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
    numberOfIntegerDigits += +numStr.slice(i + 1);
    numStr = numStr.substring(0, i);
  } else if (numberOfIntegerDigits < 0) {
    // There was no decimal point or exponent so it is an integer.
    numberOfIntegerDigits = numStr.length;
  }

  // Count the number of leading zeros.
  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }

  if (i === (zeros = numStr.length)) {
    // The digits are all zero.
    digits = [0];
    numberOfIntegerDigits = 1;
  } else {
    // Count the number of trailing zeros
    zeros--;
    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;

    // Trailing zeros are insignificant so ignore them
    numberOfIntegerDigits -= i;
    digits = [];
    // Convert string to array of digits without leading/trailing zeros.
    for (j = 0; i <= zeros; i++, j++) {
      digits[j] = +numStr.charAt(i);
    }
  }

  // If the number overflows the maximum allowed digits then use an exponent.
  if (numberOfIntegerDigits > MAX_DIGITS) {
    digits = digits.splice(0, MAX_DIGITS - 1);
    exponent = numberOfIntegerDigits - 1;
    numberOfIntegerDigits = 1;
  }

  return { d: digits, e: exponent, i: numberOfIntegerDigits };
}

/**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */
function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];

    if (roundAt > 0) {
      // Drop fractional digits beyond `roundAt`
      digits.splice(Math.max(parsedNumber.i, roundAt));

      // Set non-fractional digits beyond `roundAt` to 0
      for (var j = roundAt; j < digits.length; j++) {
        digits[j] = 0;
      }
    } else {
      // We rounded to zero so reset the parsedNumber
      fractionLen = Math.max(0, fractionLen);
      parsedNumber.i = 1;
      digits.length = Math.max(1, roundAt = fractionSize + 1);
      digits[0] = 0;
      for (var i = 1; i < roundAt; i++) digits[i] = 0;
    }

    if (digit >= 5) {
      if (roundAt - 1 < 0) {
        for (var k = 0; k > roundAt; k--) {
          digits.unshift(0);
          parsedNumber.i++;
        }
        digits.unshift(1);
        parsedNumber.i++;
      } else {
        digits[roundAt - 1]++;
      }
    }

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);


    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function(carry, d, i, digits) {
      d = d + carry;
      digits[i] = d % 10;
      return Math.floor(d / 10);
    }, 0);
    if (carry) {
      digits.unshift(carry);
      parsedNumber.i++;
    }
}

/**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */
function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {

  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';

  var isInfinity = !isFinite(number);
  var isZero = false;
  var numStr = Math.abs(number) + '',
      formattedText = '',
      parsedNumber;

  if (isInfinity) {
    formattedText = '\u221e';
  } else {
    parsedNumber = parse(numStr);

    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

    var digits = parsedNumber.d;
    var integerLen = parsedNumber.i;
    var exponent = parsedNumber.e;
    var decimals = [];
    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);

    // pad zeros for small numbers
    while (integerLen < 0) {
      digits.unshift(0);
      integerLen++;
    }

    // extract decimals digits
    if (integerLen > 0) {
      decimals = digits.splice(integerLen, digits.length);
    } else {
      decimals = digits;
      digits = [0];
    }

    // format the integer digits with grouping separators
    var groups = [];
    if (digits.length >= pattern.lgSize) {
      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
    }
    while (digits.length > pattern.gSize) {
      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
    }
    if (digits.length) {
      groups.unshift(digits.join(''));
    }
    formattedText = groups.join(groupSep);

    // append the decimal digits
    if (decimals.length) {
      formattedText += decimalSep + decimals.join('');
    }

    if (exponent) {
      formattedText += 'e+' + exponent;
    }
  }
  if (number < 0 && !isZero) {
    return pattern.negPre + formattedText + pattern.negSuf;
  } else {
    return pattern.posPre + formattedText + pattern.posSuf;
  }
}

function padNumber(num, digits, trim, negWrap) {
  var neg = '';
  if (num < 0 || (negWrap && num <= 0)) {
    if (negWrap) {
      num = -num + 1;
    } else {
      num = -num;
      neg = '-';
    }
  }
  num = '' + num;
  while (num.length < digits) num = ZERO_CHAR + num;
  if (trim) {
    num = num.substr(num.length - digits);
  }
  return neg + num;
}


function dateGetter(name, size, offset, trim, negWrap) {
  offset = offset || 0;
  return function(date) {
    var value = date['get' + name]();
    if (offset > 0 || value > -offset) {
      value += offset;
    }
    if (value === 0 && offset === -12) value = 12;
    return padNumber(value, size, trim, negWrap);
  };
}

function dateStrGetter(name, shortForm, standAlone) {
  return function(date, formats) {
    var value = date['get' + name]();
    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
    var get = uppercase(propPrefix + name);

    return formats[get][value];
  };
}

function timeZoneGetter(date, formats, offset) {
  var zone = -1 * offset;
  var paddedZone = (zone >= 0) ? '+' : '';

  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
                padNumber(Math.abs(zone % 60), 2);

  return paddedZone;
}

function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
}

function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
      // 4 = index of Thursday
      datetime.getDate() + (4 - datetime.getDay()));
}

function weekGetter(size) {
   return function(date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
         thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
   };
}

function ampmGetter(date, formats) {
  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
}

function eraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
}

function longEraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
}

var DATE_FORMATS = {
  yyyy: dateGetter('FullYear', 4, 0, false, true),
    yy: dateGetter('FullYear', 2, 0, true, true),
     y: dateGetter('FullYear', 1, 0, false, true),
  MMMM: dateStrGetter('Month'),
   MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
     M: dateGetter('Month', 1, 1),
  LLLL: dateStrGetter('Month', false, true),
    dd: dateGetter('Date', 2),
     d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
     H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
     h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
     m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
     s: dateGetter('Seconds', 1),
     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
   sss: dateGetter('Milliseconds', 3),
  EEEE: dateStrGetter('Day'),
   EEE: dateStrGetter('Day', true),
     a: ampmGetter,
     Z: timeZoneGetter,
    ww: weekGetter(2),
     w: weekGetter(1),
     G: eraGetter,
     GG: eraGetter,
     GGG: eraGetter,
     GGGG: longEraGetter
};

var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
    NUMBER_STRING = /^-?\d+$/;

/**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'LLLL'`: Stand-alone month in year (January-December)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 *   Any other characters in the `format` string will be output as-is.
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example name="filter-date">
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */
dateFilter.$inject = ['$locale'];
function dateFilter($locale) {


  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
                     // 1        2       3         4          5          6          7          8  9     10      11
  function jsonStringToDate(string) {
    var match;
    if ((match = string.match(R_ISO8601_STR))) {
      var date = new Date(0),
          tzHour = 0,
          tzMin  = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;

      if (match[9]) {
        tzHour = toInt(match[9] + match[10]);
        tzMin = toInt(match[9] + match[11]);
      }
      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
      var h = toInt(match[4] || 0) - tzHour;
      var m = toInt(match[5] || 0) - tzMin;
      var s = toInt(match[6] || 0);
      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
      timeSetter.call(date, h, m, s, ms);
      return date;
    }
    return string;
  }


  return function(date, format, timezone) {
    var text = '',
        parts = [],
        fn, match;

    format = format || 'mediumDate';
    format = $locale.DATETIME_FORMATS[format] || format;
    if (isString(date)) {
      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
    }

    if (isNumber(date)) {
      date = new Date(date);
    }

    if (!isDate(date) || !isFinite(date.getTime())) {
      return date;
    }

    while (format) {
      match = DATE_FORMATS_SPLIT.exec(format);
      if (match) {
        parts = concat(parts, match, 1);
        format = parts.pop();
      } else {
        parts.push(format);
        format = null;
      }
    }

    var dateTimezoneOffset = date.getTimezoneOffset();
    if (timezone) {
      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
      date = convertTimezoneToLocal(date, timezone, true);
    }
    forEach(parts, function(value) {
      fn = DATE_FORMATS[value];
      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
    });

    return text;
  };
}


/**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example name="filter-json">
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */
function jsonFilter() {
  return function(object, spacing) {
    if (isUndefined(spacing)) {
        spacing = 2;
    }
    return toJson(object, spacing);
  };
}


/**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 *
 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
 *
 * @see angular.lowercase
 */
var lowercaseFilter = valueFn(lowercase);


/**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @example
   <example module="uppercaseFilterExample" name="filter-uppercase">
     <file name="index.html">
       <script>
         angular.module('uppercaseFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.title = 'This is a title';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <!-- This title should be formatted normally -->
         <h1>{{title}}</h1>
         <!-- This title should be capitalized -->
         <h1>{{title | uppercase}}</h1>
       </div>
     </file>
   </example>
 */
var uppercaseFilter = valueFn(uppercase);

/**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements are
 * taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
 * it is converted to a string.
 *
 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
 *     less than `limit` elements.
 *
 * @example
   <example module="limitToExample" name="limit-to-filter">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/
function limitToFilter() {
  return function(input, limit, begin) {
    if (Math.abs(Number(limit)) === Infinity) {
      limit = Number(limit);
    } else {
      limit = toInt(limit);
    }
    if (isNumberNaN(limit)) return input;

    if (isNumber(input)) input = input.toString();
    if (!isArrayLike(input)) return input;

    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;

    if (limit >= 0) {
      return sliceFn(input, begin, begin + limit);
    } else {
      if (begin === 0) {
        return sliceFn(input, limit, input.length);
      } else {
        return sliceFn(input, Math.max(0, begin + limit), begin);
      }
    }
  };
}

function sliceFn(input, begin, end) {
  if (isString(input)) return input.slice(begin, end);

  return slice.call(input, begin, end);
}

/**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
 * function based on the values computed using the `expression` predicate.
 *
 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
 * `[{id: 'bar'}, {id: 'foo'}]`.
 *
 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
 * String, etc).
 *
 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
 * for the preceding one. The `expression` is evaluated against each item and the output is used
 * for comparing with other items.
 *
 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
 * ascending order.
 *
 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
 * strings alphabetically).
 *
 * ### Under the hood
 *
 * Ordering the specified `collection` happens in two phases:
 *
 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
 *    through a predicate that extracts the value of the `label` property, would be transformed to:
 *    ```
 *    {
 *      value: 'foo',
 *      type: 'string',
 *      index: ...
 *    }
 *    ```
 *    **Note:** `null` values use `'null'` as their type.
 * 2. The comparator function is used to sort the items, based on the derived values, types and
 *    indices.
 *
 * If you use a custom comparator, it will be called with pairs of objects of the form
 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
 * second, or `1` otherwise.
 *
 * In order to ensure that the sorting will be deterministic across platforms, if none of the
 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
 * dummy predicate that returns the item's index as `value`.
 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
 *
 * If a custom comparator still can't distinguish between two items, then they will be sorted based
 * on their index using the built-in comparator.
 *
 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
 * it to the comparator. The following rules govern the conversion:
 *
 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
 *    used instead.<br />
 *    (If the object has a `valueOf()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
 *    returns a primitive, its return value will be used instead.<br />
 *    (If the object has a `toString()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 3. No conversion; the object itself is used.
 *
 * ### The default comparator
 *
 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
 * using their index in the original collection, sorts values of different types by type and puts
 * `undefined` and `null` values at the end of the sorted list.
 *
 * More specifically, it follows these steps to determine the relative order of items:
 *
 * 1. If the compared values are of different types:
 *    - If one of the values is undefined, consider it "greater than" the other.
 *    - Else if one of the values is null, consider it "greater than" the other.
 *    - Else compare the types themselves alphabetically.
 * 2. If both values are of type `string`, compare them alphabetically in a case- and
 *    locale-insensitive way.
 * 3. If both values are objects, compare their indices instead.
 * 4. Otherwise, return:
 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
 *    -  `1`, otherwise.
 *
 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
 *           saved as numbers and not strings.
 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
 *           any other value (with undefined "greater than" null). This effectively means that `null`
 *           and `undefined` values end up at the end of a list sorted in ascending order.
 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
 *
 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
 *    predicates) to be used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `Function`: A getter function. This function will be called with each item as argument and
 *      the return value will be used for sorting.
 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
 *      result will be used for sorting. For example, use `'label'` to sort by a property called
 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
 *      property.<br />
 *      (The result of a constant expression is interpreted as a property name to be used for
 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
 *      property called `special name`.)<br />
 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
 *      relative order of two items, the next predicate is used as a tie-breaker.
 *
 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse - If `true`, reverse the sorting order.
 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
 *    value pairs. If omitted, the built-in comparator will be used.
 *
 * @returns {Array} - The sorted array.
 *
 *
 * @example
 * ### Ordering a table with `ngRepeat`
 *
 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
 * it defaults to the built-in comparator.
 *
   <example name="orderBy-static" module="orderByExample1">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <table class="friends">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample1', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var names = element.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by age in reverse order', function() {
         expect(names.get(0).getText()).toBe('Adam');
         expect(names.get(1).getText()).toBe('Julie');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('John');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Changing parameters dynamically
 *
 * All parameters can be changed dynamically. The next example shows how you can make the columns of
 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
 *
   <example name="orderBy-dynamic" module="orderByExample2">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample2', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = friends;

           $scope.sortBy = function(propertyName) {
             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using `orderBy` inside a controller
 *
 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
 *
   <example name="orderBy-call-manually" module="orderByExample3">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="sortBy(null)">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample3', [])
         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);

           $scope.sortBy = function(propertyName) {
             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                 ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using a custom comparator
 *
 * If you have very specific requirements about the way items are sorted, you can pass your own
 * comparator function. For example, you might need to compare some strings in a locale-sensitive
 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
 * argument - passing `false` retains the default sorting order, i.e. ascending.)
 *
   <example name="orderBy-custom-comparator" module="orderByExample4">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <div class="friends-container custom-comparator">
           <h3>Locale-sensitive Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
         <div class="friends-container default-comparator">
           <h3>Default Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample4', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   favoriteLetter: 'Ä'},
             {name: 'Mary',   favoriteLetter: 'Ü'},
             {name: 'Mike',   favoriteLetter: 'Ö'},
             {name: 'Adam',   favoriteLetter: 'H'},
             {name: 'Julie',  favoriteLetter: 'Z'}
           ];

           $scope.localeSensitiveComparator = function(v1, v2) {
             // If we don't get strings, just compare by index
             if (v1.type !== 'string' || v2.type !== 'string') {
               return (v1.index < v2.index) ? -1 : 1;
             }

             // Compare strings alphabetically, taking locale into account
             return v1.value.localeCompare(v2.value);
           };
         }]);
     </file>
     <file name="style.css">
       .friends-container {
         display: inline-block;
         margin: 0 30px;
       }

       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var container = element(by.css('.custom-comparator'));
       var names = container.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
         expect(names.get(0).getText()).toBe('John');
         expect(names.get(1).getText()).toBe('Adam');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('Julie');
       });
     </file>
   </example>
 *
 */
orderByFilter.$inject = ['$parse'];
function orderByFilter($parse) {
  return function(array, sortPredicate, reverseOrder, compareFn) {

    if (array == null) return array;
    if (!isArrayLike(array)) {
      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
    }

    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
    if (sortPredicate.length === 0) { sortPredicate = ['+']; }

    var predicates = processPredicates(sortPredicate);

    var descending = reverseOrder ? -1 : 1;

    // Define the `compare()` function. Use a default comparator if none is specified.
    var compare = isFunction(compareFn) ? compareFn : defaultCompare;

    // The next three lines are a version of a Swartzian Transform idiom from Perl
    // (sometimes called the Decorate-Sort-Undecorate idiom)
    // See https://en.wikipedia.org/wiki/Schwartzian_transform
    var compareValues = Array.prototype.map.call(array, getComparisonObject);
    compareValues.sort(doComparison);
    array = compareValues.map(function(item) { return item.value; });

    return array;

    function getComparisonObject(value, index) {
      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
      // This will be used to keep the sort stable when none of the input predicates can
      // distinguish between two elements.
      return {
        value: value,
        tieBreaker: {value: index, type: 'number', index: index},
        predicateValues: predicates.map(function(predicate) {
          return getPredicateValue(predicate.get(value), index);
        })
      };
    }

    function doComparison(v1, v2) {
      for (var i = 0, ii = predicates.length; i < ii; i++) {
        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
        if (result) {
          return result * predicates[i].descending * descending;
        }
      }

      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
    }
  };

  function processPredicates(sortPredicates) {
    return sortPredicates.map(function(predicate) {
      var descending = 1, get = identity;

      if (isFunction(predicate)) {
        get = predicate;
      } else if (isString(predicate)) {
        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
          descending = predicate.charAt(0) === '-' ? -1 : 1;
          predicate = predicate.substring(1);
        }
        if (predicate !== '') {
          get = $parse(predicate);
          if (get.constant) {
            var key = get();
            get = function(value) { return value[key]; };
          }
        }
      }
      return {get: get, descending: descending};
    });
  }

  function isPrimitive(value) {
    switch (typeof value) {
      case 'number': /* falls through */
      case 'boolean': /* falls through */
      case 'string':
        return true;
      default:
        return false;
    }
  }

  function objectValue(value) {
    // If `valueOf` is a valid function use that
    if (isFunction(value.valueOf)) {
      value = value.valueOf();
      if (isPrimitive(value)) return value;
    }
    // If `toString` is a valid function and not the one from `Object.prototype` use that
    if (hasCustomToString(value)) {
      value = value.toString();
      if (isPrimitive(value)) return value;
    }

    return value;
  }

  function getPredicateValue(value, index) {
    var type = typeof value;
    if (value === null) {
      type = 'null';
    } else if (type === 'object') {
      value = objectValue(value);
    }
    return {value: value, type: type, index: index};
  }

  function defaultCompare(v1, v2) {
    var result = 0;
    var type1 = v1.type;
    var type2 = v2.type;

    if (type1 === type2) {
      var value1 = v1.value;
      var value2 = v2.value;

      if (type1 === 'string') {
        // Compare strings case-insensitively
        value1 = value1.toLowerCase();
        value2 = value2.toLowerCase();
      } else if (type1 === 'object') {
        // For basic objects, use the position of the object
        // in the collection instead of the value
        if (isObject(value1)) value1 = v1.index;
        if (isObject(value2)) value2 = v2.index;
      }

      if (value1 !== value2) {
        result = value1 < value2 ? -1 : 1;
      }
    } else {
      result = (type1 === 'undefined') ? 1 :
        (type2 === 'undefined') ? -1 :
        (type1 === 'null') ? 1 :
        (type2 === 'null') ? -1 :
        (type1 < type2) ? -1 : 1;
    }

    return result;
  }
}

function ngDirective(directive) {
  if (isFunction(directive)) {
    directive = {
      link: directive
    };
  }
  directive.restrict = directive.restrict || 'AC';
  return valueFn(directive);
}

/**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html a tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
 */
var htmlAnchorDirective = valueFn({
  restrict: 'E',
  compile: function(element, attr) {
    if (!attr.href && !attr.xlinkHref) {
      return function(scope, element) {
        // If the linked element is not an anchor tag anymore, do nothing
        if (element[0].nodeName.toLowerCase() !== 'a') return;

        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
                   'xlink:href' : 'href';
        element.on('click', function(event) {
          // if we have no href url, then don't navigate anywhere.
          if (!element.attr(href)) {
            event.preventDefault();
          }
        });
      };
    }
  }
});

/**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * AngularJS has a chance to replace the `{{hash}}` markup with its
 * value. Until AngularJS replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example name="ng-href">
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element (typically a form control,
 * e.g. `input`, `button`, `select` etc.) if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-disabled">
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
 *
 * Note that this directive should not be used together with {@link ngModel `ngModel`},
 * as this can lead to unexpected behavior.
 *
 * A special directive is necessary because we cannot use interpolation inside the `checked`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-checked">
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
          element(by.model('leader')).click();
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then the `checked` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
 *
 * A special directive is necessary because we cannot use interpolation inside the `readonly`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-readonly">
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `selected`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * <div class="alert alert-warning">
 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
 *   selected options.
 * </div>
 *
 * @example
    <example name="ng-selected">
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */

/**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `open`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * ## A note about browser compatibility
 *
 * Internet Explorer and Edge do not support the `details` element, it is
 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
 *
 * @example
     <example name="ng-open">
       <file name="index.html">
         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>List</summary>
            <ul>
              <li>Apple</li>
              <li>Orange</li>
              <li>Durian</li>
            </ul>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */

var ngAttributeAliasDirectives = {};

// boolean attrs are evaluated
forEach(BOOLEAN_ATTR, function(propName, attrName) {
  // binding to multiple is not supported
  if (propName === 'multiple') return;

  function defaultLinkFn(scope, element, attr) {
    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
      attr.$set(attrName, !!value);
    });
  }

  var normalized = directiveNormalize('ng-' + attrName);
  var linkFn = defaultLinkFn;

  if (propName === 'checked') {
    linkFn = function(scope, element, attr) {
      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
      if (attr.ngModel !== attr[normalized]) {
        defaultLinkFn(scope, element, attr);
      }
    };
  }

  ngAttributeAliasDirectives[normalized] = function() {
    return {
      restrict: 'A',
      priority: 100,
      link: linkFn
    };
  };
});

// aliased input attrs are evaluated
forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
  ngAttributeAliasDirectives[ngAttr] = function() {
    return {
      priority: 100,
      link: function(scope, element, attr) {
        //special case ngPattern when a literal regular expression value
        //is used as the expression (this way we don't have to watch anything).
        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
          if (match) {
            attr.$set('ngPattern', new RegExp(match[1], match[2]));
            return;
          }
        }

        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
          attr.$set(ngAttr, value);
        });
      }
    };
  };
});

// ng-src, ng-srcset, ng-href are interpolated
forEach(['src', 'srcset', 'href'], function(attrName) {
  var normalized = directiveNormalize('ng-' + attrName);
  ngAttributeAliasDirectives[normalized] = function() {
    return {
      priority: 99, // it needs to run after the attributes are interpolated
      link: function(scope, element, attr) {
        var propName = attrName,
            name = attrName;

        if (attrName === 'href' &&
            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
          name = 'xlinkHref';
          attr.$attr[name] = 'xlink:href';
          propName = null;
        }

        attr.$observe(normalized, function(value) {
          if (!value) {
            if (attrName === 'href') {
              attr.$set(name, null);
            }
            return;
          }

          attr.$set(name, value);

          // Support: IE 9-11 only
          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
          // to set the property as well to achieve the desired effect.
          // We use attr[attrName] value since $set might have sanitized the url.
          if (msie && propName) element.prop(propName, attr[name]);
        });
      }
    };
  };
});

/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
 */
var nullFormCtrl = {
  $addControl: noop,
  $getControls: valueFn([]),
  $$renameControl: nullFormRenameControl,
  $removeControl: noop,
  $setValidity: noop,
  $setDirty: noop,
  $setPristine: noop,
  $setSubmitted: noop,
  $$setSubmitted: noop
},
PENDING_CLASS = 'ng-pending',
SUBMITTED_CLASS = 'ng-submitted';

function nullFormRenameControl(control, name) {
  control.$name = name;
}

/**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $pending An object hash, containing references to controls or forms with
 *  pending validators, where:
 *
 *  - keys are validations tokens (error names).
 *  - values are arrays of controls or forms that have a pending validator for the given error name.
 *
 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
 *
 * @property {Object} $error An object hash, containing references to controls or forms with failing
 *  validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for the given error name.
 *
 *  Built-in validation tokens:
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */
//asks for $scope to fool the BC controller module
FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
function FormController($element, $attrs, $scope, $animate, $interpolate) {
  this.$$controls = [];

  // init state
  this.$error = {};
  this.$$success = {};
  this.$pending = undefined;
  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
  this.$dirty = false;
  this.$pristine = true;
  this.$valid = true;
  this.$invalid = false;
  this.$submitted = false;
  this.$$parentForm = nullFormCtrl;

  this.$$element = $element;
  this.$$animate = $animate;

  setupValidity(this);
}

FormController.prototype = {
  /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */
  $rollbackViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$rollbackViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$commitViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$addControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Register a control with the form. Input elements using ngModelController do this automatically
   * when they are linked.
   *
   * Note that the current state of the control will not be reflected on the new parent form. This
   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
   * state.
   *
   * However, if the method is used programmatically, for example by adding dynamically created controls,
   * or controls that have been previously removed without destroying their corresponding DOM element,
   * it's the developers responsibility to make sure the current state propagates to the parent form.
   *
   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
   */
  $addControl: function(control) {
    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
    // and not added to the scope.  Now we throw an error.
    assertNotHasOwnProperty(control.$name, 'input');
    this.$$controls.push(control);

    if (control.$name) {
      this[control.$name] = control;
    }

    control.$$parentForm = this;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$getControls
   * @returns {Array} the controls that are currently part of this form
   *
   * @description
   * This method returns a **shallow copy** of the controls that are currently part of this form.
   * The controls can be instances of {@link form.FormController `FormController`}
   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
   * If you need access to the controls of child-forms, you have to call `$getControls()`
   * recursively on them.
   * This can be used for example to iterate over all controls to validate them.
   *
   * The controls can be accessed normally, but adding to, or removing controls from the array has
   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
   * Likewise, adding a control to, or removing a control from the form is not reflected
   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
   * you need access to the controls.
   */
  $getControls: function() {
    return shallowCopy(this.$$controls);
  },

  // Private API: rename a form control
  $$renameControl: function(control, newName) {
    var oldName = control.$name;

    if (this[oldName] === control) {
      delete this[oldName];
    }
    this[newName] = control;
    control.$name = newName;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   *
   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
   * different from case to case. For example, removing the only `$dirty` control from a form may or
   * may not mean that the form is still `$dirty`.
   */
  $removeControl: function(control) {
    if (control.$name && this[control.$name] === control) {
      delete this[control.$name];
    }
    forEach(this.$pending, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$error, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$$success, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);

    arrayRemove(this.$$controls, control);
    control.$$parentForm = nullFormCtrl;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */
  $setDirty: function() {
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$dirty = true;
    this.$pristine = false;
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
   * state to false.
   *
   * This method will also propagate to all the controls contained in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */
  $setPristine: function() {
    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
    this.$dirty = false;
    this.$pristine = true;
    this.$submitted = false;
    forEach(this.$$controls, function(control) {
      control.$setPristine();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */
  $setUntouched: function() {
    forEach(this.$$controls, function(control) {
      control.$setUntouched();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
   * parent forms of the form.
   */
  $setSubmitted: function() {
    var rootForm = this;
    while (rootForm.$$parentForm && (rootForm.$$parentForm !== nullFormCtrl)) {
      rootForm = rootForm.$$parentForm;
    }
    rootForm.$$setSubmitted();
  },

  $$setSubmitted: function() {
    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
    this.$submitted = true;
    forEach(this.$$controls, function(control) {
      if (control.$$setSubmitted) {
        control.$$setSubmitted();
      }
    });
  }
};

/**
 * @ngdoc method
 * @name form.FormController#$setValidity
 *
 * @description
 * Change the validity state of the form, and notify the parent form (if any).
 *
 * Application developers will rarely need to call this method directly. It is used internally, by
 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
 * control's validity state to the parent `FormController`.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
 *        class name. Example: `myError` will result in `ng-valid-my-error` and
 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
 *        `$asyncValidators` do not run because any of the `$validators` failed.
 * @param {NgModelController | FormController} controller - The controller whose validity state is
 *        triggering the change.
 */
addSetValidityMethod({
  clazz: FormController,
  set: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      object[property] = [controller];
    } else {
      var index = list.indexOf(controller);
      if (index === -1) {
        list.push(controller);
      }
    }
  },
  unset: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      return;
    }
    arrayRemove(list, controller);
    if (list.length === 0) {
      delete object[property];
    }
  }
});

/**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Helper directive that makes it possible to create control groups inside a
 * {@link ng.directive:form `form`} directive.
 * These "child forms" can be used, for example, to determine the validity of a sub-group of
 * controls.
 *
 * <div class="alert alert-danger">
 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
 * you cannot send data to the server with `ngForm`, or integrate it with
 * {@link ng.directive:ngSubmit `ngSubmit`}.
 * </div>
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
 *                              be published into the related scope, under this name.
 *
 */

 /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * ## Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
 * of controls needs to be determined.
 *
 * ## CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pending` is set if the form is pending.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * ## Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side AngularJS applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * @animations
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */
var formDirectiveFactory = function(isNgForm) {
  return ['$timeout', '$parse', function($timeout, $parse) {
    var formDirective = {
      name: 'form',
      restrict: isNgForm ? 'EAC' : 'E',
      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
      controller: FormController,
      compile: function ngFormCompile(formElement, attr) {
        // Setup initial state of the control
        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);

        return {
          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
            var controller = ctrls[0];

            // if `action` attr is not present on the form, prevent the default action (submission)
            if (!('action' in attr)) {
              // we can't use jq events because if a form is destroyed during submission the default
              // action is not prevented. see #1238
              //
              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
              // page reload if the form was destroyed by submission of the form via a click handler
              // on a button in the form. Looks like an IE9 specific bug.
              var handleFormSubmission = function(event) {
                scope.$apply(function() {
                  controller.$commitViewValue();
                  controller.$setSubmitted();
                });

                event.preventDefault();
              };

              formElement[0].addEventListener('submit', handleFormSubmission);

              // unregister the preventDefault listener so that we don't not leak memory but in a
              // way that will achieve the prevention of the default action.
              formElement.on('$destroy', function() {
                $timeout(function() {
                  formElement[0].removeEventListener('submit', handleFormSubmission);
                }, 0, false);
              });
            }

            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
            parentFormCtrl.$addControl(controller);

            var setter = nameAttr ? getSetter(controller.$name) : noop;

            if (nameAttr) {
              setter(scope, controller);
              attr.$observe(nameAttr, function(newValue) {
                if (controller.$name === newValue) return;
                setter(scope, undefined);
                controller.$$parentForm.$$renameControl(controller, newValue);
                setter = getSetter(controller.$name);
                setter(scope, controller);
              });
            }
            formElement.on('$destroy', function() {
              controller.$$parentForm.$removeControl(controller);
              setter(scope, undefined);
              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
            });
          }
        };
      }
    };

    return formDirective;

    function getSetter(expression) {
      if (expression === '') {
        //create an assignable expression, so forms with an empty name can be renamed later
        return $parse('this[""]').assign;
      }
      return $parse(expression).assign || noop;
    }
  }];
};

var formDirective = formDirectiveFactory();
var ngFormDirective = formDirectiveFactory(true);



// helper methods
function setupValidity(instance) {
  instance.$$classCache = {};
  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
}
function addSetValidityMethod(context) {
  var clazz = context.clazz,
      set = context.set,
      unset = context.unset;

  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
    if (isUndefined(state)) {
      createAndSet(this, '$pending', validationErrorKey, controller);
    } else {
      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
    }
    if (!isBoolean(state)) {
      unset(this.$error, validationErrorKey, controller);
      unset(this.$$success, validationErrorKey, controller);
    } else {
      if (state) {
        unset(this.$error, validationErrorKey, controller);
        set(this.$$success, validationErrorKey, controller);
      } else {
        set(this.$error, validationErrorKey, controller);
        unset(this.$$success, validationErrorKey, controller);
      }
    }
    if (this.$pending) {
      cachedToggleClass(this, PENDING_CLASS, true);
      this.$valid = this.$invalid = undefined;
      toggleValidationCss(this, '', null);
    } else {
      cachedToggleClass(this, PENDING_CLASS, false);
      this.$valid = isObjectEmpty(this.$error);
      this.$invalid = !this.$valid;
      toggleValidationCss(this, '', this.$valid);
    }

    // re-read the state as the set/unset methods could have
    // combined state in this.$error[validationError] (used for forms),
    // where setting/unsetting only increments/decrements the value,
    // and does not replace it.
    var combinedState;
    if (this.$pending && this.$pending[validationErrorKey]) {
      combinedState = undefined;
    } else if (this.$error[validationErrorKey]) {
      combinedState = false;
    } else if (this.$$success[validationErrorKey]) {
      combinedState = true;
    } else {
      combinedState = null;
    }

    toggleValidationCss(this, validationErrorKey, combinedState);
    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
  };

  function createAndSet(ctrl, name, value, controller) {
    if (!ctrl[name]) {
      ctrl[name] = {};
    }
    set(ctrl[name], value, controller);
  }

  function unsetAndCleanup(ctrl, name, value, controller) {
    if (ctrl[name]) {
      unset(ctrl[name], value, controller);
    }
    if (isObjectEmpty(ctrl[name])) {
      ctrl[name] = undefined;
    }
  }

  function cachedToggleClass(ctrl, className, switchValue) {
    if (switchValue && !ctrl.$$classCache[className]) {
      ctrl.$$animate.addClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = true;
    } else if (!switchValue && ctrl.$$classCache[className]) {
      ctrl.$$animate.removeClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = false;
    }
  }

  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
  }
}

function isObjectEmpty(obj) {
  if (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
  }
  return true;
}

/* global
  VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  ngModelMinErr: false
*/

// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
// Note: We are being more lenient, because browsers are too.
//   1. Scheme
//   2. Slashes
//   3. Username
//   4. Password
//   5. Hostname
//   6. Port
//   7. Path
//   8. Query
//   9. Fragment
//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
// eslint-disable-next-line max-len
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
var PARTIAL_VALIDATION_TYPES = createMap();
forEach('date,datetime-local,month,time,week'.split(','), function(type) {
  PARTIAL_VALIDATION_TYPES[type] = true;
});

var inputType = {

  /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <code>text = {{example.text}}</code><br/>
           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'text': textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
  'date': createDateInputType('date', DATE_REGEXP,
         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
         'yyyy-MM-dd'),

   /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * The format of the displayed time can be adjusted with the
    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
    * and `timeStripZeroSeconds`.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `min` will also add native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `max` will also add native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
      'yyyy-MM-ddTHH:mm:ss.sss'),

  /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
   * this is the timezone of the browser.
   *
   * The format of the displayed time can be adjusted with the
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
   * and `timeStripZeroSeconds`.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'time': createDateInputType('time', TIME_REGEXP,
      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
     'HH:mm:ss.sss'),

   /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
    *   native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
    *   native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

  /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.

   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'month': createDateInputType('month', MONTH_REGEXP,
     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
     'yyyy-MM'),

  /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise AngularJS will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   *
   *
   * @knownIssue
   *
   * ### HTML5 constraint validation and `allowInvalid`
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   * @knownIssue
   *
   * ### Large numbers and `step` validation
   *
   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
   * point for both implementations.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *    Can be interpolated.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *    Can be interpolated.
   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
   *    Can be interpolated.
   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'number': numberInputType,


  /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'url': urlInputType,


  /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'email': emailInputType,


  /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * **Note:**<br>
   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
   * value of their `name` attribute to determine the property under which their
   * {@link ngModel.NgModelController NgModelController} will be published on the parent
   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
   * published on the parent `FormController` under that name. The rest of the controllers will
   * continue to work as expected, but you won't be able to access them as properties on the parent
   * `FormController`.
   *
   * <div class="alert alert-info">
   *   <p>
   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
   *     that the browser can manage their state (checked/unchecked) based on the state of other
   *     inputs in the same group.
   *   </p>
   *   <p>
   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
   *     value of the underlying model data.
   *   </p>
   * </div>
   *
   * <div class="alert alert-success">
   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
   *   unique name.
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string} value The value to which the `ngModel` expression should be set when selected.
   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
   *    is selected. Should be used instead of the `value` attribute if you need
   *    a non-string `ngModel` (`boolean`, `array`, ...).
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var inputs = element.all(by.model('color.name'));
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            inputs.get(0).click();
            expect(color.getText()).toContain('red');

            inputs.get(1).click();
            expect(color.getText()).toContain('green');
          });
        </file>
      </example>
   */
  'radio': radioInputType,

  /**
   * @ngdoc input
   * @name input[range]
   *
   * @description
   * Native range input with validation and transformation.
   *
   * The model for the range input must always be a `Number`.
   *
   * IE9 and other browsers that do not support the `range` type fall back
   * to a text input without any default values for `min`, `max` and `step`. Model binding,
   * validation and number parsing are nevertheless supported.
   *
   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
   * in a way that never allows the input to hold an invalid value. That means:
   * - any non-numerical value is set to `(max + min) / 2`.
   * - any numerical value that is less than the current min val, or greater than the current max val
   * is set to the min / max val respectively.
   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
   * is used.
   *
   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
   * for more info.
   *
   * This has the following consequences for AngularJS:
   *
   * Since the element value should always reflect the current model value, a range input
   * will set the bound ngModel expression to the value that the browser has set for the
   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
   *
   * That means the model for range will immediately be set to `50` after `ngModel` has been
   * initialized. It also means a range input can never have the required error.
   *
   * This does not only affect changes to the model value, but also to the values of the `min`,
   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
   * the input value, AngularJS will also update the model value.
   *
   * Automatic value adjustment also means that a range input element can never have the `required`,
   * `min`, or `max` errors.
   *
   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
   * when the step value changes dynamically - they do not adjust the element value correctly, but
   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
   * error on the input, and set the model to `undefined`.
   *
   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
   *
   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
   *                  than `min`. Can be interpolated.
   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
   *                  Can be interpolated.
   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
   *                  Can be interpolated.
   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
   *                      to user interaction with the input element.
   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
   *
   * @example
      <example name="range-input-directive" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">

            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   * ## Range Input with ngMin & ngMax attributes

   * @example
      <example name="range-input-directive-ng" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">
            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   */
  'range': rangeInputType,

  /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */
  'checkbox': checkboxInputType,

  'hidden': noop,
  'button': noop,
  'submit': noop,
  'reset': noop,
  'file': noop
};

function stringBasedInputType(ctrl) {
  ctrl.$formatters.push(function(value) {
    return ctrl.$isEmpty(value) ? value : value.toString();
  });
}

function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);
}

function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  var type = lowercase(element[0].type);

  // In composition mode, users are still inputting intermediate text buffer,
  // hold the listener until composition is done.
  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
  if (!$sniffer.android) {
    var composing = false;

    element.on('compositionstart', function() {
      composing = true;
    });

    // Support: IE9+
    element.on('compositionupdate', function(ev) {
      // End composition when ev.data is empty string on 'compositionupdate' event.
      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
      // instead of 'compositionend'.
      if (isUndefined(ev.data) || ev.data === '') {
        composing = false;
      }
    });

    element.on('compositionend', function() {
      composing = false;
      listener();
    });
  }

  var timeout;

  var listener = function(ev) {
    if (timeout) {
      $browser.defer.cancel(timeout);
      timeout = null;
    }
    if (composing) return;
    var value = element.val(),
        event = ev && ev.type;

    // By default we will trim the value
    // If the attribute ng-trim exists we will avoid trimming
    // If input type is 'password', the value is never trimmed
    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
      value = trim(value);
    }

    // If a control is suffering from bad input (due to native validators), browsers discard its
    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
    // control's value is the same empty value twice in a row.
    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
      ctrl.$setViewValue(value, event);
    }
  };

  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
  // input event on backspace, delete or cut
  if ($sniffer.hasEvent('input')) {
    element.on('input', listener);
  } else {
    var deferListener = function(ev, input, origValue) {
      if (!timeout) {
        timeout = $browser.defer(function() {
          timeout = null;
          if (!input || input.value !== origValue) {
            listener(ev);
          }
        });
      }
    };

    element.on('keydown', /** @this */ function(event) {
      var key = event.keyCode;

      // ignore
      //    command            modifiers                   arrows
      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;

      deferListener(event, this, this.value);
    });

    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
    if ($sniffer.hasEvent('paste')) {
      element.on('paste cut drop', deferListener);
    }
  }

  // if user paste into input using mouse on older browser
  // or form autocomplete on newer browser, we need "change" event to catch it
  element.on('change', listener);

  // Some native input types (date-family) have the ability to change validity without
  // firing any input/change events.
  // For these event types, when native validators are present and the browser supports the type,
  // check for validity changes on various DOM events.
  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
      if (!timeout) {
        var validity = this[VALIDITY_STATE_PROPERTY];
        var origBadInput = validity.badInput;
        var origTypeMismatch = validity.typeMismatch;
        timeout = $browser.defer(function() {
          timeout = null;
          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
            listener(ev);
          }
        });
      }
    });
  }

  ctrl.$render = function() {
    // Workaround for Firefox validation #12102.
    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
    if (element.val() !== value) {
      element.val(value);
    }
  };
}

function weekParser(isoWeek, existingDate) {
  if (isDate(isoWeek)) {
    return isoWeek;
  }

  if (isString(isoWeek)) {
    WEEK_REGEXP.lastIndex = 0;
    var parts = WEEK_REGEXP.exec(isoWeek);
    if (parts) {
      var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;

      if (existingDate) {
        hours = existingDate.getHours();
        minutes = existingDate.getMinutes();
        seconds = existingDate.getSeconds();
        milliseconds = existingDate.getMilliseconds();
      }

      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
    }
  }

  return NaN;
}

function createDateParser(regexp, mapping) {
  return function(iso, previousDate) {
    var parts, map;

    if (isDate(iso)) {
      return iso;
    }

    if (isString(iso)) {
      // When a date is JSON'ified to wraps itself inside of an extra
      // set of double quotes. This makes the date parsing code unable
      // to match the date string and parse it as a date.
      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
        iso = iso.substring(1, iso.length - 1);
      }
      if (ISO_DATE_REGEXP.test(iso)) {
        return new Date(iso);
      }
      regexp.lastIndex = 0;
      parts = regexp.exec(iso);

      if (parts) {
        parts.shift();
        if (previousDate) {
          map = {
            yyyy: previousDate.getFullYear(),
            MM: previousDate.getMonth() + 1,
            dd: previousDate.getDate(),
            HH: previousDate.getHours(),
            mm: previousDate.getMinutes(),
            ss: previousDate.getSeconds(),
            sss: previousDate.getMilliseconds() / 1000
          };
        } else {
          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
        }

        forEach(parts, function(part, index) {
          if (index < mapping.length) {
            map[mapping[index]] = +part;
          }
        });

        var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
        if (map.yyyy < 100) {
          // In the constructor, 2-digit years map to 1900-1999.
          // Use `setFullYear()` to set the correct year.
          date.setFullYear(map.yyyy);
        }

        return date;
      }
    }

    return NaN;
  };
}

function createDateInputType(type, regexp, parseDate, format) {
  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
    badInputChecker(scope, element, attr, ctrl, type);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

    var isTimeType = type === 'time' || type === 'datetimelocal';
    var previousDate;
    var previousTimezone;

    ctrl.$parsers.push(function(value) {
      if (ctrl.$isEmpty(value)) return null;

      if (regexp.test(value)) {
        // Note: We cannot read ctrl.$modelValue, as there might be a different
        // parser/formatter in the processing chain so that the model
        // contains some different data format!
        return parseDateAndConvertTimeZoneToLocal(value, previousDate);
      }
      ctrl.$$parserName = type;
      return undefined;
    });

    ctrl.$formatters.push(function(value) {
      if (value && !isDate(value)) {
        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
      }
      if (isValidDate(value)) {
        previousDate = value;
        var timezone = ctrl.$options.getOption('timezone');

        if (timezone) {
          previousTimezone = timezone;
          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
        }

        return formatter(value, timezone);
      } else {
        previousDate = null;
        previousTimezone = null;
        return '';
      }
    });

    if (isDefined(attr.min) || attr.ngMin) {
      var minVal;
      ctrl.$validators.min = function(value) {
        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
      };
      attr.$observe('min', function(val) {
        minVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      var maxVal;
      ctrl.$validators.max = function(value) {
        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
      };
      attr.$observe('max', function(val) {
        maxVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    function isValidDate(value) {
      // Invalid Date: getTime() returns NaN
      return value && !(value.getTime && value.getTime() !== value.getTime());
    }

    function parseObservedDateValue(val) {
      return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
    }

    function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
      var timezone = ctrl.$options.getOption('timezone');

      if (previousTimezone && previousTimezone !== timezone) {
        // If the timezone has changed, adjust the previousDate to the default timezone
        // so that the new date is converted with the correct timezone offset
        previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
      }

      var parsedDate = parseDate(value, previousDate);

      if (!isNaN(parsedDate) && timezone) {
        parsedDate = convertTimezoneToLocal(parsedDate, timezone);
      }
      return parsedDate;
    }

    function formatter(value, timezone) {
      var targetFormat = format;

      if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
        targetFormat = format
          .replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat'))
          .replace(/:$/, '');
      }

      var formatted =  $filter('date')(value, targetFormat, timezone);

      if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
        formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
      }

      return formatted;
    }
  };
}

function badInputChecker(scope, element, attr, ctrl, parserName) {
  var node = element[0];
  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
  if (nativeValidation) {
    ctrl.$parsers.push(function(value) {
      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
      if (validity.badInput || validity.typeMismatch) {
        ctrl.$$parserName = parserName;
        return undefined;
      }

      return value;
    });
  }
}

function numberFormatterParser(ctrl) {
  ctrl.$parsers.push(function(value) {
    if (ctrl.$isEmpty(value))      return null;
    if (NUMBER_REGEXP.test(value)) return parseFloat(value);

    ctrl.$$parserName = 'number';
    return undefined;
  });

  ctrl.$formatters.push(function(value) {
    if (!ctrl.$isEmpty(value)) {
      if (!isNumber(value)) {
        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
      }
      value = value.toString();
    }
    return value;
  });
}

function parseNumberAttrVal(val) {
  if (isDefined(val) && !isNumber(val)) {
    val = parseFloat(val);
  }
  return !isNumberNaN(val) ? val : undefined;
}

function isNumberInteger(num) {
  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
  // (minus the assumption that `num` is a number)

  // eslint-disable-next-line no-bitwise
  return (num | 0) === num;
}

function countDecimals(num) {
  var numString = num.toString();
  var decimalSymbolIndex = numString.indexOf('.');

  if (decimalSymbolIndex === -1) {
    if (-1 < num && num < 1) {
      // It may be in the exponential notation format (`1e-X`)
      var match = /e-(\d+)$/.exec(numString);

      if (match) {
        return Number(match[1]);
      }
    }

    return 0;
  }

  return numString.length - decimalSymbolIndex - 1;
}

function isValidForStep(viewValue, stepBase, step) {
  // At this point `stepBase` and `step` are expected to be non-NaN values
  // and `viewValue` is expected to be a valid stringified number.
  var value = Number(viewValue);

  var isNonIntegerValue = !isNumberInteger(value);
  var isNonIntegerStepBase = !isNumberInteger(stepBase);
  var isNonIntegerStep = !isNumberInteger(step);

  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;

    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
    var multiplier = Math.pow(10, decimalCount);

    value = value * multiplier;
    stepBase = stepBase * multiplier;
    step = step * multiplier;

    if (isNonIntegerValue) value = Math.round(value);
    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
    if (isNonIntegerStep) step = Math.round(step);
  }

  return (value - stepBase) % step === 0;
}

function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl, 'number');
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var minVal;
  var maxVal;

  if (isDefined(attr.min) || attr.ngMin) {
    ctrl.$validators.min = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
    };

    attr.$observe('min', function(val) {
      minVal = parseNumberAttrVal(val);
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }

  if (isDefined(attr.max) || attr.ngMax) {
    ctrl.$validators.max = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
    };

    attr.$observe('max', function(val) {
      maxVal = parseNumberAttrVal(val);
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }

  if (isDefined(attr.step) || attr.ngStep) {
    var stepVal;
    ctrl.$validators.step = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
             isValidForStep(viewValue, minVal || 0, stepVal);
    };

    attr.$observe('step', function(val) {
      stepVal = parseNumberAttrVal(val);
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }
}

function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl, 'range');
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
      minVal = supportsRange ? 0 : undefined,
      maxVal = supportsRange ? 100 : undefined,
      stepVal = supportsRange ? 1 : undefined,
      validity = element[0].validity,
      hasMinAttr = isDefined(attr.min),
      hasMaxAttr = isDefined(attr.max),
      hasStepAttr = isDefined(attr.step);

  var originalRender = ctrl.$render;

  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
    //Browsers that implement range will set these values automatically, but reading the adjusted values after
    //$render would cause the min / max validators to be applied with the wrong value
    function rangeRender() {
      originalRender();
      ctrl.$setViewValue(element.val());
    } :
    originalRender;

  if (hasMinAttr) {
    ctrl.$validators.min = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMinValidator() { return true; } :
      // non-support browsers validate the min val
      function minValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
      };

    setInitialValueAndObserver('min', minChange);
  }

  if (hasMaxAttr) {
    ctrl.$validators.max = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMaxValidator() { return true; } :
      // non-support browsers validate the max val
      function maxValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
      };

    setInitialValueAndObserver('max', maxChange);
  }

  if (hasStepAttr) {
    ctrl.$validators.step = supportsRange ?
      function nativeStepValidator() {
        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
        // input element value to a valid value). It's possible that other browsers set the stepMismatch
        // validity error instead, so we can at least report an error in that case.
        return !validity.stepMismatch;
      } :
      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
      function stepValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
               isValidForStep(viewValue, minVal || 0, stepVal);
      };

    setInitialValueAndObserver('step', stepChange);
  }

  function setInitialValueAndObserver(htmlAttrName, changeFn) {
    // interpolated attributes set the attribute value only after a digest, but we need the
    // attribute value when the input is first rendered, so that the browser can adjust the
    // input value based on the min/max value
    element.attr(htmlAttrName, attr[htmlAttrName]);
    attr.$observe(htmlAttrName, changeFn);
  }

  function minChange(val) {
    minVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
      if (minVal > elVal) {
        elVal = minVal;
        element.val(elVal);
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function maxChange(val) {
    maxVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
      if (maxVal < elVal) {
        element.val(maxVal);
        // IE11 and Chrome don't set the value to the minVal when max < min
        elVal = maxVal < minVal ? minVal : maxVal;
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function stepChange(val) {
    stepVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
    if (supportsRange && ctrl.$viewValue !== element.val()) {
      ctrl.$setViewValue(element.val());
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }
}

function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$validators.url = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
  };
}

function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$validators.email = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
  };
}

function radioInputType(scope, element, attr, ctrl) {
  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
  // make the name unique, if not defined
  if (isUndefined(attr.name)) {
    element.attr('name', nextUid());
  }

  var listener = function(ev) {
    var value;
    if (element[0].checked) {
      value = attr.value;
      if (doTrim) {
        value = trim(value);
      }
      ctrl.$setViewValue(value, ev && ev.type);
    }
  };

  element.on('change', listener);

  ctrl.$render = function() {
    var value = attr.value;
    if (doTrim) {
      value = trim(value);
    }
    element[0].checked = (value === ctrl.$viewValue);
  };

  attr.$observe('value', ctrl.$render);
}

function parseConstantExpr($parse, context, name, expression, fallback) {
  var parseFn;
  if (isDefined(expression)) {
    parseFn = $parse(expression);
    if (!parseFn.constant) {
      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                                   '`{1}`.', name, expression);
    }
    return parseFn(context);
  }
  return fallback;
}

function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

  var listener = function(ev) {
    ctrl.$setViewValue(element[0].checked, ev && ev.type);
  };

  element.on('change', listener);

  ctrl.$render = function() {
    element[0].checked = ctrl.$viewValue;
  };

  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
  // it to a boolean.
  ctrl.$isEmpty = function(value) {
    return value === false;
  };

  ctrl.$formatters.push(function(value) {
    return equals(value, trueValue);
  });

  ctrl.$parsers.push(function(value) {
    return value ? trueValue : falseValue;
  });
}


/**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *
 * @knownIssue
 *
 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
 * insert the placeholder value as the textarea's content. If the placeholder value contains
 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
 * the value of the by-then-removed text node. This doesn't affect the functionality of the
 * textarea, but can be undesirable.
 *
 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
 * find more details on `ngAttr` in the
 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
 * Developer Guide.
 */


/**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */
var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
    function($browser, $sniffer, $filter, $parse) {
  return {
    restrict: 'E',
    require: ['?ngModel'],
    link: {
      pre: function(scope, element, attr, ctrls) {
        if (ctrls[0]) {
          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
                                                              $browser, $filter, $parse);
        }
      }
    }
  };
}];



var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
/**
 * @ngdoc directive
 * @name ngValue
 * @restrict A
 * @priority 100
 *
 * @description
 * Binds the given expression to the value of the element.
 *
 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
 * {@link select `select`} parent element) is set to the bound value. It is especially useful
 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * It can also be used to achieve one-way binding of a given expression to an input element
 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
 *
 * @element ANY
 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
 * and `value` property of the element.
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */
var ngValueDirective = function() {
  /**
   *  inputs use the value attribute as their default value if the value property is not set.
   *  Once the value property has been set (by adding input), it will not react to changes to
   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
   *  makes it possible to use ngValue as a sort of one-way bind.
   */
  function updateElementValue(element, attr, value) {
    // Support: IE9 only
    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
    element.prop('value', propValue);
    attr.$set('value', value);
  }

  return {
    restrict: 'A',
    priority: 100,
    compile: function(tpl, tplAttr) {
      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
        return function ngValueConstantLink(scope, elm, attr) {
          var value = scope.$eval(attr.ngValue);
          updateElementValue(elm, attr, value);
        };
      } else {
        return function ngValueLink(scope, elm, attr) {
          scope.$watch(attr.ngValue, function valueWatchAction(value) {
            updateElementValue(elm, attr, value);
          });
        };
      }
    }
  };
};

/**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample" name="ng-bind">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */
var ngBindDirective = ['$compile', function($compile) {
  return {
    restrict: 'AC',
    compile: function ngBindCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBind);
        element = element[0];
        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
          element.textContent = stringify(value);
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample" name="ng-bind-template">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */
var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
  return {
    compile: function ngBindTemplateCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindTemplateLink(scope, element, attr) {
        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
        $compile.$$addBindingInfo(element, interpolateFn.expressions);
        element = element[0];
        attr.$observe('ngBindTemplate', function(value) {
          element.textContent = isUndefined(value) ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */
var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
  return {
    restrict: 'A',
    compile: function ngBindHtmlCompile(tElement, tAttrs) {
      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
        return $sce.valueOf(val);
      });
      $compile.$$addBindingClass(tElement);

      return function ngBindHtmlLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBindHtml);

        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
          var value = ngBindHtmlGetter(scope);
          element.html($sce.getTrustedHtml(value) || '');
        });
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngChange
 * @restrict A
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element ANY
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */
var ngChangeDirective = valueFn({
  restrict: 'A',
  require: 'ngModel',
  link: function(scope, element, attr, ctrl) {
    ctrl.$viewChangeListeners.push(function() {
      scope.$eval(attr.ngChange);
    });
  }
});

/* exported
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective
*/

function classDirective(name, selector) {
  name = 'ngClass' + name;
  var indexWatchExpression;

  return ['$parse', function($parse) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        var classCounts = element.data('$classCounts');
        var oldModulo = true;
        var oldClassString;

        if (!classCounts) {
          // Use createMap() to prevent class assumptions involving property
          // names in Object.prototype
          classCounts = createMap();
          element.data('$classCounts', classCounts);
        }

        if (name !== 'ngClass') {
          if (!indexWatchExpression) {
            indexWatchExpression = $parse('$index', function moduloTwo($index) {
              // eslint-disable-next-line no-bitwise
              return $index & 1;
            });
          }

          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
        }

        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);

        function addClasses(classString) {
          classString = digestClassCounts(split(classString), 1);
          attr.$addClass(classString);
        }

        function removeClasses(classString) {
          classString = digestClassCounts(split(classString), -1);
          attr.$removeClass(classString);
        }

        function updateClasses(oldClassString, newClassString) {
          var oldClassArray = split(oldClassString);
          var newClassArray = split(newClassString);

          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
          var toAddArray = arrayDifference(newClassArray, oldClassArray);

          var toRemoveString = digestClassCounts(toRemoveArray, -1);
          var toAddString = digestClassCounts(toAddArray, 1);

          attr.$addClass(toAddString);
          attr.$removeClass(toRemoveString);
        }

        function digestClassCounts(classArray, count) {
          var classesToUpdate = [];

          forEach(classArray, function(className) {
            if (count > 0 || classCounts[className]) {
              classCounts[className] = (classCounts[className] || 0) + count;
              if (classCounts[className] === +(count > 0)) {
                classesToUpdate.push(className);
              }
            }
          });

          return classesToUpdate.join(' ');
        }

        function ngClassIndexWatchAction(newModulo) {
          // This watch-action should run before the `ngClassWatchAction()`, thus it
          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
          // `ngClassWatchAction()` will update the classes.
          if (newModulo === selector) {
            addClasses(oldClassString);
          } else {
            removeClasses(oldClassString);
          }

          oldModulo = newModulo;
        }

        function ngClassWatchAction(newClassString) {
          if (oldModulo === selector) {
            updateClasses(oldClassString, newClassString);
          }

          oldClassString = newClassString;
        }
      }
    };
  }];

  // Helpers
  function arrayDifference(tokens1, tokens2) {
    if (!tokens1 || !tokens1.length) return [];
    if (!tokens2 || !tokens2.length) return tokens1;

    var values = [];

    outer:
    for (var i = 0; i < tokens1.length; i++) {
      var token = tokens1[i];
      for (var j = 0; j < tokens2.length; j++) {
        if (token === tokens2[j]) continue outer;
      }
      values.push(token);
    }

    return values;
  }

  function split(classString) {
    return classString && classString.split(' ');
  }

  function toClassString(classValue) {
    var classString = classValue;

    if (isArray(classValue)) {
      classString = classValue.map(toClassString).join(' ');
    } else if (isObject(classValue)) {
      classString = Object.keys(classValue).
        filter(function(key) { return classValue[key]; }).
        join(' ');
    }

    return classString;
  }
}

/**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 * @element ANY
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
 * attribute, when using the `ngClass` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
 *
 * ### ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 *
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example
 * ### Basic
   <example name="ng-class">
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   @example
   ### Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>
 */
var ngClassDirective = classDirective('', true);

/**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-odd">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassOdd`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-odd="'odd'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .odd {
         background: rgba(255, 255, 0, 0.25);
       }

       .odd-add, .odd-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add odd class to odd entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);

         button.click();

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
       });
     </file>
   </example>
 */
var ngClassOddDirective = classDirective('Odd', 0);

/**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-even">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassEven`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-even="'even'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .even {
         background: rgba(255, 255, 0, 0.25);
       }

       .even-add, .even-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add even class to even entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);

         button.click();

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassEvenDirective = classDirective('Even', 1);

/**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example name="ng-cloak">
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */
var ngCloakDirective = ngDirective({
  compile: function(element, attr) {
    attr.$set('ngCloak', undefined);
    element.removeClass('ng-cloak');
  }
});

/**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the AngularJS community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = 'John Smith';
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'}
 *      ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = 'John Smith';
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'}
 *     ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */
var ngControllerDirective = [function() {
  return {
    restrict: 'A',
    scope: true,
    controller: '@',
    priority: 500
  };
}];

/**
 * @ngdoc directive
 * @name ngCsp
 *
 * @restrict A
 * @element ANY
 * @description
 *
 * AngularJS has some features that can conflict with certain restrictions that are applied when using
 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
 *
 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
 * features.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 *
 * The following default rules in CSP affect AngularJS:
 *
 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
 * weaken the protections offered by CSP.)
 *
 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
 * it is generally not recommended as it would weaken the protections offered by CSP.)
 *
 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
 * CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on an element of the HTML document that appears before the `<script>` tag that loads
 * the `angular.js` file.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * You can specify which of the CSP related AngularJS features should be deactivated by providing
 * a value for the `ng-csp` attribute. The options are as follows:
 *
 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
 *
 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
 *
 * You can use these values in the following combinations:
 *
 *
 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
 *
 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
 *
 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
 * styles nor use eval, which is the same as an empty: ng-csp.
 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
 *
 * @example
 *
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```

  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
  <example name="example.csp" module="cspExample" ng-csp="true">
    <file name="index.html">
      <div ng-controller="MainController as ctrl">
        <div>
          <button ng-click="ctrl.inc()" id="inc">Increment</button>
          <span id="counter">
            {{ctrl.counter}}
          </span>
        </div>

        <div>
          <button ng-click="ctrl.evil()" id="evil">Evil</button>
          <span id="evilError">
            {{ctrl.evilError}}
          </span>
        </div>
      </div>
    </file>
    <file name="script.js">
       angular.module('cspExample', [])
         .controller('MainController', function MainController() {
            this.counter = 0;
            this.inc = function() {
              this.counter++;
            };
            this.evil = function() {
              try {
                eval('1+2'); // eslint-disable-line no-eval
              } catch (e) {
                this.evilError = e.message;
              }
            };
          });
    </file>
    <file name="protractor.js" type="protractor">
      var util, webdriver;

      var incBtn = element(by.id('inc'));
      var counter = element(by.id('counter'));
      var evilBtn = element(by.id('evil'));
      var evilError = element(by.id('evilError'));

      function getAndClearSevereErrors() {
        return browser.manage().logs().get('browser').then(function(browserLog) {
          return browserLog.filter(function(logEntry) {
            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
          });
        });
      }

      function clearErrors() {
        getAndClearSevereErrors();
      }

      function expectNoErrors() {
        getAndClearSevereErrors().then(function(filteredLog) {
          expect(filteredLog.length).toEqual(0);
          if (filteredLog.length) {
            console.log('browser console errors: ' + util.inspect(filteredLog));
          }
        });
      }

      function expectError(regex) {
        getAndClearSevereErrors().then(function(filteredLog) {
          var found = false;
          filteredLog.forEach(function(log) {
            if (log.message.match(regex)) {
              found = true;
            }
          });
          if (!found) {
            throw new Error('expected an error that matches ' + regex);
          }
        });
      }

      beforeEach(function() {
        util = require('util');
        webdriver = require('selenium-webdriver');
      });

      // For now, we only test on Chrome,
      // as Safari does not load the page with Protractor's injected scripts,
      // and Firefox webdriver always disables content security policy (#6358)
      if (browser.params.browser !== 'chrome') {
        return;
      }

      it('should not report errors when the page is loaded', function() {
        // clear errors so we are not dependent on previous tests
        clearErrors();
        // Need to reload the page as the page is already loaded when
        // we come here
        browser.driver.getCurrentUrl().then(function(url) {
          browser.get(url);
        });
        expectNoErrors();
      });

      it('should evaluate expressions', function() {
        expect(counter.getText()).toEqual('0');
        incBtn.click();
        expect(counter.getText()).toEqual('1');
        expectNoErrors();
      });

      it('should throw and report an error when using "eval"', function() {
        evilBtn.click();
        expect(evilError.getText()).toMatch(/Content Security Policy/);
        expectError(/Content Security Policy/);
      });
    </file>
  </example>
  */

// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
// fn that looks for the `ng-csp` attribute anywhere in the current doc.

/**
 * @ngdoc directive
 * @name ngClick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-click">
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */
/*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * AngularJS expressions and are compiled and executed within the current scope.
 */
var ngEventDirectives = {};

// For events that might fire synchronously during DOM manipulation
// we need to execute their event handlers asynchronously using $evalAsync,
// so that they are not executed in an inconsistent state.
var forceAsyncEvents = {
  'blur': true,
  'focus': true
};
forEach(
  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
  function(eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function($parse, $rootScope, $exceptionHandler) {
      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
    }];
  }
);

function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
  return {
    restrict: 'A',
    compile: function($element, attr) {
      // NOTE:
      // We expose the powerful `$event` object on the scope that provides access to the Window,
      // etc. This is OK, because expressions are not sandboxed any more (and the expression
      // sandbox was never meant to be a security feature anyway).
      var fn = $parse(attr[directiveName]);
      return function ngEventHandler(scope, element) {
        element.on(eventName, function(event) {
          var callback = function() {
            fn(scope, {$event: event});
          };

          if (!$rootScope.$$phase) {
            scope.$apply(callback);
          } else if (forceAsync) {
            scope.$evalAsync(callback);
          } else {
            try {
              callback();
            } catch (error) {
              $exceptionHandler(error);
            }
          }
        });
      };
    }
  };
}

/**
 * @ngdoc directive
 * @name ngDblclick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example name="ng-dblclick">
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousedown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousedown">
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseup">
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngMouseover
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseover">
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseenter
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseenter">
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseleave
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseleave">
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousemove
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousemove">
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeydown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keydown">
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeyup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keyup">
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeypress
 * @restrict A
 * @element ANY
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keypress">
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngSubmit
 * @restrict A
 * @element form
 * @priority 0
 *
 * @description
 * Enables binding AngularJS expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample" name="ng-submit">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngFocus
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngBlur
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngCopy
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-copy">
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngCut
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-cut">
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngPaste
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-paste">
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 * @multiElement
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */
var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function(clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).done(function(response) {
                if (response !== false) previousElements = null;
              });
              block = null;
            }
          }
        });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 * @scope
 * @priority -400
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to AngularJS's {@link
 * ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
 *
 * The enter and leave animation occur concurrently.
 *
 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *                  <div class="alert alert-warning">
 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
 *                  a function with the name on the window element, which will usually throw a
 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
 *                  different form that {@link guide/directive#normalization matches} `onload`.
 *                  </div>
   *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [{ name: 'template1.html', url: 'template1.html'},
             { name: 'template2.html', url: 'template2.html'}];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */
var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
                  function($templateRequest,   $anchorScroll,   $animate) {
  return {
    restrict: 'ECA',
    priority: 400,
    terminal: true,
    transclude: 'element',
    controller: angular.noop,
    compile: function(element, attr) {
      var srcExp = attr.ngInclude || attr.src,
          onloadExp = attr.onload || '',
          autoScrollExp = attr.autoscroll;

      return function(scope, $element, $attr, ctrl, $transclude) {
        var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

        var cleanupLastIncludeContent = function() {
          if (previousElement) {
            previousElement.remove();
            previousElement = null;
          }
          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            $animate.leave(currentElement).done(function(response) {
              if (response !== false) previousElement = null;
            });
            previousElement = currentElement;
            currentElement = null;
          }
        };

        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
          var afterAnimation = function(response) {
            if (response !== false && isDefined(autoScrollExp) &&
              (!autoScrollExp || scope.$eval(autoScrollExp))) {
                $anchorScroll();
            }
          };
          var thisChangeId = ++changeCounter;

          if (src) {
            //set the 2nd param to true to ignore the template request error so that the inner
            //contents and scope can be cleaned up.
            $templateRequest(src, true).then(function(response) {
              if (scope.$$destroyed) return;

              if (thisChangeId !== changeCounter) return;
              var newScope = scope.$new();
              ctrl.template = response;

              // Note: This will also link all children of ng-include that were contained in the original
              // html. If that content contains controllers, ... they could pollute/change the scope.
              // However, using ng-include on an element with additional content does not make sense...
              // Note: We can't remove them in the cloneAttchFn of $transclude as that
              // function is called before linking the content, which would apply child
              // directives to non existing elements.
              var clone = $transclude(newScope, function(clone) {
                cleanupLastIncludeContent();
                $animate.enter(clone, null, $element).done(afterAnimation);
              });

              currentScope = newScope;
              currentElement = clone;

              currentScope.$emit('$includeContentLoaded', src);
              scope.$eval(onloadExp);
            }, function() {
              if (scope.$$destroyed) return;

              if (thisChangeId === changeCounter) {
                cleanupLastIncludeContent();
                scope.$emit('$includeContentError', src);
              }
            });
            scope.$emit('$includeContentRequested', src);
          } else {
            cleanupLastIncludeContent();
            ctrl.template = null;
          }
        });
      };
    }
  };
}];

// This directive is called during the $transclude call of the first `ngInclude` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngInclude
// is called.
var ngIncludeFillContentDirective = ['$compile',
  function($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function(scope, $element, $attr, ctrl) {
        if (toString.call($element[0]).match(/SVG/)) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
              function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, {futureParentElement: $element});
          return;
        }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

/**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 * @priority 450
 * @element ANY
 *
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * This directive can be abused to add unnecessary amounts of logic into your templates.
 * There are only a few appropriate uses of `ngInit`:
 * <ul>
 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
 *     as seen in the demo below.</li>
 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
 *   <li>injecting data via server side scripting.</li>
 * </ul>
 *
 * Besides these few cases, you should use {@link guide/component Components} or
 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
 * sure you have parentheses to ensure correct operator precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = ($index | toString)"></div>`
 * </pre>
 * </div>
 *
 * @example
   <example module="initExample" name="ng-init">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */
var ngInitDirective = ngDirective({
  priority: 450,
  compile: function() {
    return {
      pre: function(scope, element, attrs) {
        scope.$eval(attrs.ngInit);
      }
    };
  }
});

/**
 * @ngdoc directive
 * @name ngList
 * @restrict A
 * @priority 100
 *
 * @param {string=} ngList optional delimiter that should be used to split the value.
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * @example
 * ### Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * @example
 * ### Splitting on newline
 *
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 */
var ngListDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    require: 'ngModel',
    link: function(scope, element, attr, ctrl) {
      var ngList = attr.ngList || ', ';
      var trimValues = attr.ngTrim !== 'false';
      var separator = trimValues ? trim(ngList) : ngList;

      var parse = function(viewValue) {
        // If the viewValue is invalid (say required but empty) it will be `undefined`
        if (isUndefined(viewValue)) return;

        var list = [];

        if (viewValue) {
          forEach(viewValue.split(separator), function(value) {
            if (value) list.push(trimValues ? trim(value) : value);
          });
        }

        return list;
      };

      ctrl.$parsers.push(parse);
      ctrl.$formatters.push(function(value) {
        if (isArray(value)) {
          return value.join(ngList);
        }

        return undefined;
      });

      // Override the standard $isEmpty because an empty array means the input is empty.
      ctrl.$isEmpty = function(value) {
        return !value || !value.length;
      };
    }
  };
};

/* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
  PENDING_CLASS: true,
  addSetValidityMethod: true,
  setupValidity: true,
  defaultModelOptions: false
*/


var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty',
    UNTOUCHED_CLASS = 'ng-untouched',
    TOUCHED_CLASS = 'ng-touched',
    EMPTY_CLASS = 'ng-empty',
    NOT_EMPTY_CLASS = 'ng-not-empty';

var ngModelMinErr = minErr('ngModel');

/**
 * @ngdoc type
 * @name ngModel.NgModelController
 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
 * is set.
 *
 * @property {*} $modelValue The value in the model that the control is bound to.
 *
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
    `$viewValue`} from the DOM, usually via user input.
    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.

  The functions are called in array order, each passing
    its return value through to the next. The last return value is forwarded to the
    {@link ngModel.NgModelController#$validators `$validators`} collection.

  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
    `$viewValue`}.

  Returning `undefined` from a parser means a parse error occurred. In that case,
    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
    is set to `true`. The parse error is stored in `ngModel.$error.parse`.

  This simple example shows a parser that would convert text input value to lowercase:
 * ```js
 * function parse(value) {
 *   if (value) {
 *     return value.toLowerCase();
 *   }
 * }
 * ngModelController.$parsers.push(parse);
 * ```

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
    value of the control is changed by user interaction.

  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
    `$modelValue`} for display in the control.

  The functions are called in reverse array order, each passing the value through to the
    next. The last return value is used as the actual DOM value.

  This simple example shows a formatter that would convert the model value to uppercase:

 * ```js
 * function format(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(format);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
 *     It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * AngularJS provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if (attrs.stripBr && html === '<br>') {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */
NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
  this.$viewValue = Number.NaN;
  this.$modelValue = Number.NaN;
  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
  this.$validators = {};
  this.$asyncValidators = {};
  this.$parsers = [];
  this.$formatters = [];
  this.$viewChangeListeners = [];
  this.$untouched = true;
  this.$touched = false;
  this.$pristine = true;
  this.$dirty = false;
  this.$valid = true;
  this.$invalid = false;
  this.$error = {}; // keep invalid keys here
  this.$$success = {}; // keep valid keys here
  this.$pending = undefined; // keep pending keys here
  this.$name = $interpolate($attr.name || '', false)($scope);
  this.$$parentForm = nullFormCtrl;
  this.$options = defaultModelOptions;
  this.$$updateEvents = '';
  // Attach the correct context to the event handler function for updateOn
  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);

  this.$$parsedNgModel = $parse($attr.ngModel);
  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
  this.$$ngModelGet = this.$$parsedNgModel;
  this.$$ngModelSet = this.$$parsedNgModelAssign;
  this.$$pendingDebounce = null;
  this.$$parserValid = undefined;
  this.$$parserName = 'parse';

  this.$$currentValidationRunId = 0;

  this.$$scope = $scope;
  this.$$rootScope = $scope.$root;
  this.$$attr = $attr;
  this.$$element = $element;
  this.$$animate = $animate;
  this.$$timeout = $timeout;
  this.$$parse = $parse;
  this.$$q = $q;
  this.$$exceptionHandler = $exceptionHandler;

  setupValidity(this);
  setupModelWatcher(this);
}

NgModelController.prototype = {
  $$initGetterSetters: function() {
    if (this.$options.getOption('getterSetter')) {
      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');

      this.$$ngModelGet = function($scope) {
        var modelValue = this.$$parsedNgModel($scope);
        if (isFunction(modelValue)) {
          modelValue = invokeModelGetter($scope);
        }
        return modelValue;
      };
      this.$$ngModelSet = function($scope, newValue) {
        if (isFunction(this.$$parsedNgModel($scope))) {
          invokeModelSetter($scope, {$$$p: newValue});
        } else {
          this.$$parsedNgModelAssign($scope, newValue);
        }
      };
    } else if (!this.$$parsedNgModel.assign) {
      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
          this.$$attr.ngModel, startingTag(this.$$element));
    }
  },


  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */
  $render: noop,

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */
  $isEmpty: function(value) {
    // eslint-disable-next-line no-self-compare
    return isUndefined(value) || value === '' || value === null || value !== value;
  },

  $$updateEmptyClasses: function(value) {
    if (this.$isEmpty(value)) {
      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
    } else {
      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */
  $setPristine: function() {
    this.$dirty = false;
    this.$pristine = true;
    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */
  $setDirty: function() {
    this.$dirty = true;
    this.$pristine = false;
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */
  $setUntouched: function() {
    this.$touched = false;
    this.$untouched = true;
    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */
  $setTouched: function() {
    this.$touched = true;
    this.$untouched = false;
    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
   * sync with the ngModel's `$modelValue`.
   *
   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
   * and reset the input to the last committed view value.
   *
   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * @example
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.model = {value1: '', value2: ''};
   *
   *       $scope.setEmpty = function(e, value, rollback) {
   *         if (e.keyCode === 27) {
   *           e.preventDefault();
   *           if (rollback) {
   *             $scope.myForm[value].$rollbackViewValue();
   *           }
   *           $scope.model[value] = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
   *       empty them. Follow these steps and observe the difference:</p>
   *       <ol>
   *         <li>Type something in the input. You will see that the model is not yet updated</li>
   *         <li>Press the Escape key.
   *           <ol>
   *             <li> In the first example, nothing happens, because the model is already '', and no
   *             update is detected. If you blur the input, the model will be set to the current view.
   *             </li>
   *             <li> In the second example, the pending update is cancelled, and the input is set back
   *             to the last committed view value (''). Blurring the input does nothing.
   *             </li>
   *           </ol>
   *         </li>
   *       </ol>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <div>
   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
   *                  ng-keydown="setEmpty($event, 'value1')">
   *           value1: "{{ model.value1 }}"
   *         </div>
   *
   *         <div>
   *           <p id="inputDescription2">With $rollbackViewValue():</p>
   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
   *                  ng-keydown="setEmpty($event, 'value2', true)">
   *           value2: "{{ model.value2 }}"
   *         </div>
   *       </form>
   *     </div>
   *   </file>
       <file name="style.css">
          div {
            display: table-cell;
          }
          div:nth-child(1) {
            padding-right: 30px;
          }

        </file>
   * </example>
   */
  $rollbackViewValue: function() {
    this.$$timeout.cancel(this.$$pendingDebounce);
    this.$viewValue = this.$$lastCommittedViewValue;
    this.$render();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */
  $validate: function() {
    // ignore $validate before model is initialized
    if (isNumberNaN(this.$modelValue)) {
      return;
    }

    var viewValue = this.$$lastCommittedViewValue;
    // Note: we use the $$rawModelValue as $modelValue might have been
    // set to undefined during a view -> model update that found validation
    // errors. We can't parse the view here, since that could change
    // the model although neither viewValue nor the model on the scope changed
    var modelValue = this.$$rawModelValue;

    var prevValid = this.$valid;
    var prevModelValue = this.$modelValue;

    var allowInvalid = this.$options.getOption('allowInvalid');

    var that = this;
    this.$$runValidators(modelValue, viewValue, function(allValid) {
      // If there was no change in validity, don't update the model
      // This prevents changing an invalid modelValue to undefined
      if (!allowInvalid && prevValid !== allValid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;

        if (that.$modelValue !== prevModelValue) {
          that.$$writeModelToScope();
        }
      }
    });
  },

  $$runValidators: function(modelValue, viewValue, doneCallback) {
    this.$$currentValidationRunId++;
    var localValidationRunId = this.$$currentValidationRunId;
    var that = this;

    // check parser error
    if (!processParseErrors()) {
      validationDone(false);
      return;
    }
    if (!processSyncValidators()) {
      validationDone(false);
      return;
    }
    processAsyncValidators();

    function processParseErrors() {
      var errorKey = that.$$parserName;

      if (isUndefined(that.$$parserValid)) {
        setValidity(errorKey, null);
      } else {
        if (!that.$$parserValid) {
          forEach(that.$validators, function(v, name) {
            setValidity(name, null);
          });
          forEach(that.$asyncValidators, function(v, name) {
            setValidity(name, null);
          });
        }

        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
        setValidity(errorKey, that.$$parserValid);
        return that.$$parserValid;
      }
      return true;
    }

    function processSyncValidators() {
      var syncValidatorsValid = true;
      forEach(that.$validators, function(validator, name) {
        var result = Boolean(validator(modelValue, viewValue));
        syncValidatorsValid = syncValidatorsValid && result;
        setValidity(name, result);
      });
      if (!syncValidatorsValid) {
        forEach(that.$asyncValidators, function(v, name) {
          setValidity(name, null);
        });
        return false;
      }
      return true;
    }

    function processAsyncValidators() {
      var validatorPromises = [];
      var allValid = true;
      forEach(that.$asyncValidators, function(validator, name) {
        var promise = validator(modelValue, viewValue);
        if (!isPromiseLike(promise)) {
          throw ngModelMinErr('nopromise',
            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
        }
        setValidity(name, undefined);
        validatorPromises.push(promise.then(function() {
          setValidity(name, true);
        }, function() {
          allValid = false;
          setValidity(name, false);
        }));
      });
      if (!validatorPromises.length) {
        validationDone(true);
      } else {
        that.$$q.all(validatorPromises).then(function() {
          validationDone(allValid);
        }, noop);
      }
    }

    function setValidity(name, isValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {
        that.$setValidity(name, isValid);
      }
    }

    function validationDone(allValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {

        doneCallback(allValid);
      }
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    var viewValue = this.$viewValue;

    this.$$timeout.cancel(this.$$pendingDebounce);

    // If the view value has not changed then we should just exit, except in the case where there is
    // a native validator on the element. In this case the validation state may have changed even though
    // the viewValue has stayed empty.
    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
      return;
    }
    this.$$updateEmptyClasses(viewValue);
    this.$$lastCommittedViewValue = viewValue;

    // change to dirty
    if (this.$pristine) {
      this.$setDirty();
    }
    this.$$parseAndValidate();
  },

  $$parseAndValidate: function() {
    var viewValue = this.$$lastCommittedViewValue;
    var modelValue = viewValue;
    var that = this;

    this.$$parserValid = isUndefined(modelValue) ? undefined : true;

    // Reset any previous parse error
    this.$setValidity(this.$$parserName, null);
    this.$$parserName = 'parse';

    if (this.$$parserValid) {
      for (var i = 0; i < this.$parsers.length; i++) {
        modelValue = this.$parsers[i](modelValue);
        if (isUndefined(modelValue)) {
          this.$$parserValid = false;
          break;
        }
      }
    }
    if (isNumberNaN(this.$modelValue)) {
      // this.$modelValue has not been touched yet...
      this.$modelValue = this.$$ngModelGet(this.$$scope);
    }
    var prevModelValue = this.$modelValue;
    var allowInvalid = this.$options.getOption('allowInvalid');
    this.$$rawModelValue = modelValue;

    if (allowInvalid) {
      this.$modelValue = modelValue;
      writeToModelIfNeeded();
    }

    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
    // This can happen if e.g. $setViewValue is called from inside a parser
    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
      if (!allowInvalid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;
        writeToModelIfNeeded();
      }
    });

    function writeToModelIfNeeded() {
      if (that.$modelValue !== prevModelValue) {
        that.$$writeModelToScope();
      }
    }
  },

  $$writeModelToScope: function() {
    this.$$ngModelSet(this.$$scope, this.$modelValue);
    forEach(this.$viewChangeListeners, function(listener) {
      try {
        listener();
      } catch (e) {
        // eslint-disable-next-line no-invalid-this
        this.$$exceptionHandler(e);
      }
    }, this);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when a control wants to change the view value; typically,
   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
   * directive calls it when the value of the input changes and {@link ng.directive:select select}
   * calls it when an option is selected.
   *
   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
   * `$asyncValidators` are called and the value is applied to `$modelValue`.
   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
   * all the registered change listeners, in the `$viewChangeListeners` list are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
   * is specified, once the timer runs out.
   *
   * When used with standard inputs, the view value will always be a string (which is in some cases
   * parsed into another type, such as a `Date` object for `input[date]`.)
   * However, custom controls might also pass objects to this method. In this case, we should make
   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
   * perform a deep watch of objects, it only looks for a change of identity. If you only change
   * the property of the object then ngModel will not realize that the object has changed and
   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
   * not change properties of the copy once it has been passed to `$setViewValue`.
   * Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * <div class="alert alert-info">
   * In any case, the value passed to the method should always reflect the current value
   * of the control. For example, if you are calling `$setViewValue` for an input element,
   * you should pass the input DOM value. Otherwise, the control and the scope model become
   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
   * the control's DOM value in any way. If we want to change the control's DOM value
   * programmatically, we should update the `ngModel` scope expression. Its new value will be
   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
   * to update the DOM, and finally call `$validate` on it.
   * </div>
   *
   * @param {*} value value from the view.
   * @param {string} trigger Event that triggered the update.
   */
  $setViewValue: function(value, trigger) {
    this.$viewValue = value;
    if (this.$options.getOption('updateOnDefault')) {
      this.$$debounceViewValueCommit(trigger);
    }
  },

  $$debounceViewValueCommit: function(trigger) {
    var debounceDelay = this.$options.getOption('debounce');

    if (isNumber(debounceDelay[trigger])) {
      debounceDelay = debounceDelay[trigger];
    } else if (isNumber(debounceDelay['default']) &&
      this.$options.getOption('updateOn').indexOf(trigger) === -1
    ) {
      debounceDelay = debounceDelay['default'];
    } else if (isNumber(debounceDelay['*'])) {
      debounceDelay = debounceDelay['*'];
    }

    this.$$timeout.cancel(this.$$pendingDebounce);
    var that = this;
    if (debounceDelay > 0) { // this fails if debounceDelay is an object
      this.$$pendingDebounce = this.$$timeout(function() {
        that.$commitViewValue();
      }, debounceDelay);
    } else if (this.$$rootScope.$$phase) {
      this.$commitViewValue();
    } else {
      this.$$scope.$apply(function() {
        that.$commitViewValue();
      });
    }
  },

  /**
   * @ngdoc method
   *
   * @name ngModel.NgModelController#$overrideModelOptions
   *
   * @description
   *
   * Override the current model options settings programmatically.
   *
   * The previous `ModelOptions` value will not be modified. Instead, a
   * new `ModelOptions` object will inherit from the previous one overriding
   * or inheriting settings that are defined in the given parameter.
   *
   * See {@link ngModelOptions} for information about what options can be specified
   * and how model option inheritance works.
   *
   * <div class="alert alert-warning">
   * **Note:** this function only affects the options set on the `ngModelController`,
   * and not the options on the {@link ngModelOptions} directive from which they might have been
   * obtained initially.
   * </div>
   *
   * <div class="alert alert-danger">
   * **Note:** it is not possible to override the `getterSetter` option.
   * </div>
   *
   * @param {Object} options a hash of settings to override the previous options
   *
   */
  $overrideModelOptions: function(options) {
    this.$options = this.$options.createChild(options);
    this.$$setUpdateOnEvents();
  },

  /**
   * @ngdoc method
   *
   * @name  ngModel.NgModelController#$processModelValue

   * @description
   *
   * Runs the model -> view pipeline on the current
   * {@link ngModel.NgModelController#$modelValue $modelValue}.
   *
   * The following actions are performed by this method:
   *
   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
   * - the `ng-empty` or `ng-not-empty` class is set on the element
   * - if the `$viewValue` has changed:
   *   - {@link ngModel.NgModelController#$render $render} is called on the control
   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
   *   the validation status is set.
   *
   * This method is called by ngModel internally when the bound scope value changes.
   * Application developers usually do not have to call this function themselves.
   *
   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
   * formatted and the `$modelValue` must be run through the `$formatters` again.
   *
   * @example
   * Consider a text input with an autocomplete list (for fruit), where the items are
   * objects with a name and an id.
   * A user enters `ap` and then selects `Apricot` from the list.
   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
   * but the rendered value will still be `ap`.
   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
   * pipeline again, which formats the object to the string `Apricot`,
   * then updates the `$viewValue`, and finally renders it in the DOM.
   *
   * <example module="inputExample" name="ng-model-process">
     <file name="index.html">
      <div ng-controller="inputController" style="display: flex;">
        <div style="margin-right: 30px;">
          Search Fruit:
          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
        </div>
        <div>
          Model:<br>
          <pre>{{selectedFruit | json}}</pre>
        </div>
      </div>
     </file>
     <file name="app.js">
      angular.module('inputExample', [])
        .controller('inputController', function($scope) {
          $scope.items = [
            {name: 'Apricot', id: 443},
            {name: 'Clementine', id: 972},
            {name: 'Durian', id: 169},
            {name: 'Jackfruit', id: 982},
            {name: 'Strawberry', id: 863}
          ];
        })
        .component('basicAutocomplete', {
          bindings: {
            items: '<',
            onSelect: '&'
          },
          templateUrl: 'autocomplete.html',
          controller: function($element, $scope) {
            var that = this;
            var ngModel;

            that.$postLink = function() {
              ngModel = $element.find('input').controller('ngModel');

              ngModel.$formatters.push(function(value) {
                return (value && value.name) || value;
              });

              ngModel.$parsers.push(function(value) {
                var match = value;
                for (var i = 0; i < that.items.length; i++) {
                  if (that.items[i].name === value) {
                    match = that.items[i];
                    break;
                  }
                }

                return match;
              });
            };

            that.selectItem = function(item) {
              ngModel.$setViewValue(item);
              ngModel.$processModelValue();
              that.onSelect({item: item});
            };
          }
        });
     </file>
     <file name="autocomplete.html">
       <div>
         <input type="search" ng-model="$ctrl.searchTerm" />
         <ul>
           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
           </li>
         </ul>
       </div>
     </file>
   * </example>
   *
   */
  $processModelValue: function() {
    var viewValue = this.$$format();

    if (this.$viewValue !== viewValue) {
      this.$$updateEmptyClasses(viewValue);
      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
      this.$render();
      // It is possible that model and view value have been updated during render
      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
    }
  },

  /**
   * This method is called internally to run the $formatters on the $modelValue
   */
  $$format: function() {
    var formatters = this.$formatters,
        idx = formatters.length;

    var viewValue = this.$modelValue;
    while (idx--) {
      viewValue = formatters[idx](viewValue);
    }

    return viewValue;
  },

  /**
   * This method is called internally when the bound scope value changes.
   */
  $$setModelValue: function(modelValue) {
    this.$modelValue = this.$$rawModelValue = modelValue;
    this.$$parserValid = undefined;
    this.$processModelValue();
  },

  $$setUpdateOnEvents: function() {
    if (this.$$updateEvents) {
      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
    }

    this.$$updateEvents = this.$options.getOption('updateOn');
    if (this.$$updateEvents) {
      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
    }
  },

  $$updateEventHandler: function(ev) {
    this.$$debounceViewValueCommit(ev && ev.type);
  }
};

function setupModelWatcher(ctrl) {
  // model -> value
  // Note: we cannot use a normal scope.$watch as we want to detect the following:
  // 1. scope value is 'a'
  // 2. user enters 'b'
  // 3. ng-change kicks in and reverts scope value to 'a'
  //    -> scope value did not change since the last digest as
  //       ng-change executes in apply phase
  // 4. view should be changed back to 'a'
  ctrl.$$scope.$watch(function ngModelWatch(scope) {
    var modelValue = ctrl.$$ngModelGet(scope);

    // if scope model value and ngModel value are out of sync
    // This cannot be moved to the action function, because it would not catch the
    // case where the model is changed in the ngChange function or the model setter
    if (modelValue !== ctrl.$modelValue &&
      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
      // eslint-disable-next-line no-self-compare
      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
    ) {
      ctrl.$$setModelValue(modelValue);
    }

    return modelValue;
  });
}

/**
 * @ngdoc method
 * @name ngModel.NgModelController#$setValidity
 *
 * @description
 * Change the validity state, and notify the form.
 *
 * This method can be called within $parsers/$formatters or a custom validation implementation.
 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
 */
addSetValidityMethod({
  clazz: NgModelController,
  set: function(object, property) {
    object[property] = true;
  },
  unset: function(object, property) {
    delete object[property];
  }
});


/**
 * @ngdoc directive
 * @name ngModel
 * @restrict A
 * @priority 1
 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
 *
 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
 *
 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
 * if the select is given the `multiple` attribute.
 *
 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
 * not trigger a re-rendering of the model.
 *
 * ## CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
 *     by the {@link ngModel.NgModelController#$isEmpty} method
 *  - `ng-not-empty`: the view contains a non-empty value
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * @animations
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * ### Basic Usage
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * @example
 * ### Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */
var ngModelDirective = ['$rootScope', function($rootScope) {
  return {
    restrict: 'A',
    require: ['ngModel', '^?form', '^?ngModelOptions'],
    controller: NgModelController,
    // Prelink needs to run before any input directive
    // so that we can set the NgModelOptions in NgModelController
    // before anyone else uses it.
    priority: 1,
    compile: function ngModelCompile(element) {
      // Setup initial state of the control
      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

      return {
        pre: function ngModelPreLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
              optionsCtrl = ctrls[2];

          if (optionsCtrl) {
            modelCtrl.$options = optionsCtrl.$options;
          }

          modelCtrl.$$initGetterSetters();

          // notify others, especially parent forms
          formCtrl.$addControl(modelCtrl);

          attr.$observe('name', function(newValue) {
            if (modelCtrl.$name !== newValue) {
              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
            }
          });

          scope.$on('$destroy', function() {
            modelCtrl.$$parentForm.$removeControl(modelCtrl);
          });
        },
        post: function ngModelPostLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0];
          modelCtrl.$$setUpdateOnEvents();

          function setTouched() {
            modelCtrl.$setTouched();
          }

          element.on('blur', function() {
            if (modelCtrl.$touched) return;

            if ($rootScope.$$phase) {
              scope.$evalAsync(setTouched);
            } else {
              scope.$apply(setTouched);
            }
          });
        }
      };
    }
  };
}];

/* exported defaultModelOptions */
var defaultModelOptions;
var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

/**
 * @ngdoc type
 * @name ModelOptions
 * @description
 * A container for the options set by the {@link ngModelOptions} directive
 */
function ModelOptions(options) {
  this.$$options = options;
}

ModelOptions.prototype = {

  /**
   * @ngdoc method
   * @name ModelOptions#getOption
   * @param {string} name the name of the option to retrieve
   * @returns {*} the value of the option
   * @description
   * Returns the value of the given option
   */
  getOption: function(name) {
    return this.$$options[name];
  },

  /**
   * @ngdoc method
   * @name ModelOptions#createChild
   * @param {Object} options a hash of options for the new child that will override the parent's options
   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
   */
  createChild: function(options) {
    var inheritAll = false;

    // make a shallow copy
    options = extend({}, options);

    // Inherit options from the parent if specified by the value `"$inherit"`
    forEach(options, /** @this */ function(option, key) {
      if (option === '$inherit') {
        if (key === '*') {
          inheritAll = true;
        } else {
          options[key] = this.$$options[key];
          // `updateOn` is special so we must also inherit the `updateOnDefault` option
          if (key === 'updateOn') {
            options.updateOnDefault = this.$$options.updateOnDefault;
          }
        }
      } else {
        if (key === 'updateOn') {
          // If the `updateOn` property contains the `default` event then we have to remove
          // it from the event list and set the `updateOnDefault` flag.
          options.updateOnDefault = false;
          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
            options.updateOnDefault = true;
            return ' ';
          }));
        }
      }
    }, this);

    if (inheritAll) {
      // We have a property of the form: `"*": "$inherit"`
      delete options['*'];
      defaults(options, this.$$options);
    }

    // Finally add in any missing defaults
    defaults(options, defaultModelOptions.$$options);

    return new ModelOptions(options);
  }
};


defaultModelOptions = new ModelOptions({
  updateOn: '',
  updateOnDefault: true,
  debounce: 0,
  getterSetter: false,
  allowInvalid: false,
  timezone: null
});


/**
 * @ngdoc directive
 * @name ngModelOptions
 * @restrict A
 * @priority 10
 *
 * @description
 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
 * directives will use the options of their nearest `ngModelOptions` ancestor.
 *
 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
 *
 * ## Inheriting Options
 *
 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
 * directive by giving it the value of `"$inherit"`.
 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
 * will be used.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
 * ```
 *
 * Notice that the `debounce` setting was not inherited and used the default value instead.
 *
 * You can specify that all undefined settings are automatically inherited from an ancestor by
 * including a property with key of `"*"` and value of `"$inherit"`.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
 * ```
 *
 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
 *
 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
 *
 *
 * ## Triggering and debouncing model updates
 *
 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
 * a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ### Overriding immediate updates
 *
 * The following example shows how to override immediate updates. Changes on the inputs within the
 * form will update the model only when the control loses focus (blur event). If `escape` key is
 * pressed while the input field is focused, the value is reset to the value in the current model.
 *
 * <example name="ngModelOptions-directive-blur" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ updateOn: 'blur' }"
 *                  ng-keyup="cancel($event)" />
 *         </label><br />
 *         <label>
 *           Other data:
 *           <input type="text" ng-model="user.data" />
 *         </label><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say', data: '' };
 *
 *         $scope.cancel = function(e) {
 *           if (e.keyCode === 27) {
 *             $scope.userForm.userName.$rollbackViewValue();
 *           }
 *         };
 *       }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var model = element(by.binding('user.name'));
 *     var input = element(by.model('user.name'));
 *     var other = element(by.model('user.data'));
 *
 *     it('should allow custom events', function() {
 *       input.sendKeys(' hello');
 *       input.click();
 *       expect(model.getText()).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say hello');
 *     });
 *
 *     it('should $rollbackViewValue when model changes', function() {
 *       input.sendKeys(' hello');
 *       expect(input.getAttribute('value')).toEqual('say hello');
 *       input.sendKeys(protractor.Key.ESCAPE);
 *       expect(input.getAttribute('value')).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say');
 *     });
 *   </file>
 * </example>
 *
 * ### Debouncing updates
 *
 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
 *
 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         Name:
 *         <input type="text" name="userName"
 *                ng-model="user.name"
 *                ng-model-options="{ debounce: 1000 }" />
 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say' };
 *       }]);
 *   </file>
 * </example>
 *
 * ### Default events, extra triggers, and catch-all debounce values
 *
 * This example shows the relationship between "default" update events and
 * additional `updateOn` triggers.
 *
 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
 * in `updateOn` is considered a "default" event, since different control types have different
 * default events.
 *
 * The control in this example updates by "default", "click", and "blur", with different `debounce`
 * values. You can see that "click" doesn't have an individual `debounce` value -
 * therefore it uses the `*` debounce value.
 *
 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
 * it is considered a "default" event and will update the
 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
 *
 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
 *
  <example name="ngModelOptions-advanced" module="optionsExample">
    <file name="index.html">
       <model-update-demo></model-update-demo>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .component('modelUpdateDemo', {
          templateUrl: 'template.html',
          controller: function() {
            this.name = 'Chinua';

            this.options = {
              updateOn: 'default blur click',
              debounce: {
                default: 2000,
                blur: 0,
                '*': 1000
              }
            };

            this.updateEvents = function() {
              var eventList = this.options.updateOn.split(' ');
              eventList.push('*');
              var events = {};

              for (var i = 0; i < eventList.length; i++) {
                events[eventList[i]] = this.options.debounce[eventList[i]];
              }

              this.events = events;
            };

            this.updateOptions = function() {
              var options = angular.extend(this.options, {
                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
                debounce: this.events
              });

              this.form.input.$overrideModelOptions(options);
            };

            // Initialize the event form
            this.updateEvents();
          }
        });
    </file>
    <file name="template.html">
      <form name="$ctrl.form">
        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
      </form>
      Model: <tt>{{$ctrl.name}}</tt>
      <hr>
      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>

      <hr>
      <form ng-submit="$ctrl.updateOptions()">
        <b>updateOn</b><br>
        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">

        <table>
          <tr>
            <th>Option</th>
            <th>Debounce value</th>
          </tr>
          <tr ng-repeat="(key, value) in $ctrl.events">
            <td>{{key}}</td>
            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
          </tr>
        </table>

        <br>
        <input type="submit" value="Update options">
      </form>
    </file>
  </example>
 *
 *
 * ## Model updates and validation
 *
 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
 * the model will still be updated even if the value is invalid.
 *
 *
 * ## Connecting to the scope
 *
 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
 * on the scope refers to a "getter/setter" function rather than the value itself.
 *
 * The following example shows how to bind to getter/setters:
 *
 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ getterSetter: true }" />
 *         </label>
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('getterSetterExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         var _name = 'Brian';
 *         $scope.user = {
 *           name: function(newName) {
 *             return angular.isDefined(newName) ? (_name = newName) : _name;
 *           }
 *         };
 *       }]);
 *   </file>
 * </example>
 *
 *
 * ## Programmatically changing options
 *
 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
 * watched for changes. However, it is possible to override the options on a single
 * {@link ngModel.NgModelController} instance with
 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
 * See also the example for
 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
 * Default events, extra triggers, and catch-all debounce values}.
 *
 *
 * ## Specifying timezones
 *
 * You can specify the timezone that date/time input directives expect by providing its name in the
 * `timezone` property.
 *
 *
 * ## Formatting the value of `time` and `datetime-local`
 *
 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
 * that is displayed in the control. Note that browsers may apply their own formatting
 * in the user interface.
 *
   <example name="ngModelOptions-time-format" module="timeExample">
     <file name="index.html">
       <time-example></time-example>
     </file>
     <file name="script.js">
        angular.module('timeExample', [])
          .component('timeExample', {
            templateUrl: 'timeExample.html',
            controller: function() {
              this.time = new Date(1970, 0, 1, 14, 57, 0);

              this.options = {
                timeSecondsFormat: 'ss',
                timeStripZeroSeconds: true
              };

              this.optionChange = function() {
                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
                this.time = new Date(this.time);
              };
            }
          });
     </file>
     <file name="timeExample.html">
       <form name="$ctrl.timeForm">
         <strong>Default</strong>:
         <input type="time" ng-model="$ctrl.time" step="any" /><br>
         <strong>With options</strong>:
         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
         <br>

         Options:<br>
         <code>timeSecondsFormat</code>:
         <input
           type="text"
           ng-model="$ctrl.options.timeSecondsFormat"
           ng-change="$ctrl.optionChange()">
         <br>
         <code>timeStripZeroSeconds</code>:
         <input
           type="checkbox"
           ng-model="$ctrl.options.timeStripZeroSeconds"
           ng-change="$ctrl.optionChange()">
        </form>
      </file>
 *  </example>
 *
 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
 *   and its descendents.
 *
 * **General options**:
 *
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging to the control. These are the events that are bound to
 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
 *
 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
 *     since different control types use different default events.
 *
 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
 *     Triggering and debouncing model updates}.
 *
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur',
 *       debounce: { 'default': 500, 'blur': 0 }
 *     }"
 *     ```
 *     You can use the `*` key to specify a debounce value that applies to all events that are not
 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur mouseup',
 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
 *     }"
 *     ```
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
 *     `ngModel` as getters/setters.
 *
 *
 *  **Input-type specific options**:
 *
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *     Note that changing the timezone will have no effect on the current date, and is only applied after
 *     the next input / model change.
 *
 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
 *     milliseconds. The option follows the format string of {@link date date filter}.
 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
 *     seconds and milliseconds.
 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
 *     part of the time string, and may show the value differently in the user interface.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
 *     after `timeSecondsFormat`.
 *     This option can be used to make the formatting consistent over different browsers, as some
 *     browsers with support for `time` will natively hide the milliseconds and
 *     seconds if they are zero, but others won't, and browsers that don't implement these input
 *     types will always show the full string.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 */
var ngModelOptionsDirective = function() {
  NgModelOptionsController.$inject = ['$attrs', '$scope'];
  function NgModelOptionsController($attrs, $scope) {
    this.$$attrs = $attrs;
    this.$$scope = $scope;
  }
  NgModelOptionsController.prototype = {
    $onInit: function() {
      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);

      this.$options = parentOptions.createChild(modelOptionsDefinition);
    }
  };

  return {
    restrict: 'A',
    // ngModelOptions needs to run before ngModel and input directives
    priority: 10,
    require: {parentCtrl: '?^^ngModelOptions'},
    bindToController: true,
    controller: NgModelOptionsController
  };
};


// shallow copy over values from `src` that are not already specified on `dst`
function defaults(dst, src) {
  forEach(src, function(value, key) {
    if (!isDefined(dst[key])) {
      dst[key] = value;
    }
  });
}

/**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 * @element ANY
 *
 * @description
 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
 * DOM element, including directives on the element itself that have a lower priority than
 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
 * that displays snippets of code, for instance.
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
  <example name="ng-non-bindable">
    <file name="index.html">
      <div>Normal: {{1 + 2}}</div>
      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
    </file>
    <file name="protractor.js" type="protractor">
     it('should check ng-non-bindable', function() {
       expect(element(by.binding('1 + 2')).getText()).toContain('3');
       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
     });
    </file>
  </example>
 */
var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

/* exported ngOptionsDirective */

/* global jqLiteRemove */

var ngOptionsMinErr = minErr('ngOptions');

/**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding the select to a model that is an object or a collection.
 *
 * One issue occurs if you want to preselect an option. For example, if you set
 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
 * because the objects are not identical. So by default, you should always reference the item in your collection
 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
 *
 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
 * of the item not by reference, but by the result of the `track by` expression. For example, if your
 * collection items have an id property, you would `track by item.id`.
 *
 * A different issue with objects or collections is that ngModel won't detect if an object property or
 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
 * has not changed identity, but only a property on the object or an item in the collection changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper than the first level inside the
 * object/collection will not trigger a re-rendering.
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
 * </div>
 *
 * Given this array of items on the $scope:
 *
 * ```js
 * $scope.items = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 * ```
 *
 * This will work:
 *
 * ```html
 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0];
 * ```
 *
 * but this will not work:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0].subItem;
 * ```
 *
 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
 * `items` array. Because the selected option has been set programmatically in the controller, the
 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {comprehension_expression} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 * @example
    <example module="selectExample" name="select">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>



          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */

/* eslint-disable max-len */
//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
                        // 1: value expression (valueFn)
                        // 2: label expression (displayFn)
                        // 3: group by expression (groupByFn)
                        // 4: disable when expression (disableWhenFn)
                        // 5: array item variable name
                        // 6: object item key variable name
                        // 7: object item value variable name
                        // 8: collection expression
                        // 9: track by expression
/* eslint-enable */


var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {

  function parseOptionsExpression(optionsExp, selectElement, scope) {

    var match = optionsExp.match(NG_OPTIONS_REGEXP);
    if (!(match)) {
      throw ngOptionsMinErr('iexp',
        'Expected expression in form of ' +
        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
        ' but got \'{0}\'. Element: {1}',
        optionsExp, startingTag(selectElement));
    }

    // Extract the parts from the ngOptions expression

    // The variable name for the value of the item in the collection
    var valueName = match[5] || match[7];
    // The variable name for the key of the item in the collection
    var keyName = match[6];

    // An expression that generates the viewValue for an option if there is a label expression
    var selectAs = / as /.test(match[0]) && match[1];
    // An expression that is used to track the id of each object in the options collection
    var trackBy = match[9];
    // An expression that generates the viewValue for an option if there is no label expression
    var valueFn = $parse(match[2] ? match[1] : valueName);
    var selectAsFn = selectAs && $parse(selectAs);
    var viewValueFn = selectAsFn || valueFn;
    var trackByFn = trackBy && $parse(trackBy);

    // Get the value by which we are going to track the option
    // if we have a trackFn then use that (passing scope and locals)
    // otherwise just hash the given viewValue
    var getTrackByValueFn = trackBy ?
                              function(value, locals) { return trackByFn(scope, locals); } :
                              function getHashOfValue(value) { return hashKey(value); };
    var getTrackByValue = function(value, key) {
      return getTrackByValueFn(value, getLocals(value, key));
    };

    var displayFn = $parse(match[2] || match[1]);
    var groupByFn = $parse(match[3] || '');
    var disableWhenFn = $parse(match[4] || '');
    var valuesFn = $parse(match[8]);

    var locals = {};
    var getLocals = keyName ? function(value, key) {
      locals[keyName] = key;
      locals[valueName] = value;
      return locals;
    } : function(value) {
      locals[valueName] = value;
      return locals;
    };


    function Option(selectValue, viewValue, label, group, disabled) {
      this.selectValue = selectValue;
      this.viewValue = viewValue;
      this.label = label;
      this.group = group;
      this.disabled = disabled;
    }

    function getOptionValuesKeys(optionValues) {
      var optionValuesKeys;

      if (!keyName && isArrayLike(optionValues)) {
        optionValuesKeys = optionValues;
      } else {
        // if object, extract keys, in enumeration order, unsorted
        optionValuesKeys = [];
        for (var itemKey in optionValues) {
          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
            optionValuesKeys.push(itemKey);
          }
        }
      }
      return optionValuesKeys;
    }

    return {
      trackBy: trackBy,
      getTrackByValue: getTrackByValue,
      getWatchables: $parse(valuesFn, function(optionValues) {
        // Create a collection of things that we would like to watch (watchedArray)
        // so that they can all be watched using a single $watchCollection
        // that only runs the handler once if anything changes
        var watchedArray = [];
        optionValues = optionValues || [];

        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;
        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];

          var locals = getLocals(value, key);
          var selectValue = getTrackByValueFn(value, locals);
          watchedArray.push(selectValue);

          // Only need to watch the displayFn if there is a specific label expression
          if (match[2] || match[1]) {
            var label = displayFn(scope, locals);
            watchedArray.push(label);
          }

          // Only need to watch the disableWhenFn if there is a specific disable expression
          if (match[4]) {
            var disableWhen = disableWhenFn(scope, locals);
            watchedArray.push(disableWhen);
          }
        }
        return watchedArray;
      }),

      getOptions: function() {

        var optionItems = [];
        var selectValueMap = {};

        // The option values were already computed in the `getWatchables` fn,
        // which must have been called to trigger `getOptions`
        var optionValues = valuesFn(scope) || [];
        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;

        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];
          var locals = getLocals(value, key);
          var viewValue = viewValueFn(scope, locals);
          var selectValue = getTrackByValueFn(viewValue, locals);
          var label = displayFn(scope, locals);
          var group = groupByFn(scope, locals);
          var disabled = disableWhenFn(scope, locals);
          var optionItem = new Option(selectValue, viewValue, label, group, disabled);

          optionItems.push(optionItem);
          selectValueMap[selectValue] = optionItem;
        }

        return {
          items: optionItems,
          selectValueMap: selectValueMap,
          getOptionFromViewValue: function(value) {
            return selectValueMap[getTrackByValue(value)];
          },
          getViewValueFromOption: function(option) {
            // If the viewValue could be an object that may be mutated by the application,
            // we need to make a copy and not return the reference to the value on the option.
            return trackBy ? copy(option.viewValue) : option.viewValue;
          }
        };
      }
    };
  }


  // Support: IE 9 only
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  var optionTemplate = window.document.createElement('option'),
      optGroupTemplate = window.document.createElement('optgroup');

    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          selectCtrl.hasEmptyOption = true;
          selectCtrl.emptyOption = children.eq(i);
          break;
        }
      }

      // The empty option will be compiled and rendered before we first generate the options
      selectElement.empty();

      var providedEmptyOption = !!selectCtrl.emptyOption;

      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val('?');

      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
      // This stores the newly created options before they are appended to the select.
      // Since the contents are removed from the fragment when it is appended,
      // we only need to create it once.
      var listFragment = $document[0].createDocumentFragment();

      // Overwrite the implementation. ngOptions doesn't use hashes
      selectCtrl.generateUnknownOptionValue = function(val) {
        return '?';
      };

      // Update the controller methods for multiple selectable options
      if (!multiple) {

        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
          var option = options.getOptionFromViewValue(value);

          // Make sure to remove the selected attribute from the previously selected option
          // Otherwise, screen readers might get confused
          if (selectedOption) selectedOption.removeAttribute('selected');

          if (option) {
            // Don't update the option when it is already selected.
            // For example, the browser will select the first option by default. In that case,
            // most properties are set automatically - except the `selected` attribute, which we
            // set always

            if (selectElement[0].value !== option.selectValue) {
              selectCtrl.removeUnknownOption();

              selectElement[0].value = option.selectValue;
              option.element.selected = true;
            }

            option.element.setAttribute('selected', 'selected');
          } else {
            selectCtrl.selectUnknownOrEmptyOption(value);
          }
        };

        selectCtrl.readValue = function readNgOptionsValue() {

          var selectedOption = options.selectValueMap[selectElement.val()];

          if (selectedOption && !selectedOption.disabled) {
            selectCtrl.unselectEmptyOption();
            selectCtrl.removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        // FIXME: When a user selects an option, this watch will fire needlessly
        if (ngOptions.trackBy) {
          scope.$watch(
            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
            function() { ngModelCtrl.$render(); }
          );
        }

      } else {

        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];

          options.items.forEach(function(option) {
            if (option.element.selected && !includes(selectedOptions, option)) {
              option.element.selected = false;
            }
          });
        };


        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
              selections = [];

          forEach(selectedValues, function(value) {
            var option = options.selectValueMap[value];
            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
          });

          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {

          scope.$watchCollection(function() {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function(value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function() {
            ngModelCtrl.$render();
          });

        }
      }

      if (providedEmptyOption) {

        // compile the element since there might be bindings in it
        $compile(selectCtrl.emptyOption)(scope);

        selectElement.prepend(selectCtrl.emptyOption);

        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
          // This means the empty option has currently no actual DOM node, probably because
          // it has been modified by a transclusion directive.
          selectCtrl.hasEmptyOption = false;

          // Redefine the registerOption function, which will catch
          // options that are added by ngIf etc. (rendering of the node is async because of
          // lazy transclusion)
          selectCtrl.registerOption = function(optionScope, optionEl) {
            if (optionEl.val() === '') {
              selectCtrl.hasEmptyOption = true;
              selectCtrl.emptyOption = optionEl;
              selectCtrl.emptyOption.removeClass('ng-scope');
              // This ensures the new empty option is selected if previously no option was selected
              ngModelCtrl.$render();

              optionEl.on('$destroy', function() {
                var needsRerender = selectCtrl.$isEmptyOptionSelected();

                selectCtrl.hasEmptyOption = false;
                selectCtrl.emptyOption = undefined;

                if (needsRerender) ngModelCtrl.$render();
              });
            }
          };

        } else {
          // remove the class, which is added automatically because we recompile the element and it
          // becomes the compilation root
          selectCtrl.emptyOption.removeClass('ng-scope');
        }

      }

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //

      function addOptionElement(option, parent) {
        var optionElement = optionTemplate.cloneNode(false);
        parent.appendChild(optionElement);
        updateOptionElement(option, optionElement);
      }

      function getAndUpdateSelectedOption(viewValue) {
        var option = options.getOptionFromViewValue(viewValue);
        var element = option && option.element;

        if (element && !element.selected) element.selected = true;

        return option;
      }

      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        // Support: IE 11 only, Edge 12-13 only
        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
        // selects in certain circumstances when multiple selects are next to each other and display
        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
        // See https://github.com/angular/angular.js/issues/11314 for more info.
        // This is unfortunately untestable with unit / e2e tests
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
        element.value = option.selectValue;
      }

      function updateOptions() {
        var previousValue = options && selectCtrl.readValue();

        // We must remove all current options, but cannot simply set innerHTML = null
        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
        // must preserve.
        // Instead, iterate over the current option elements and remove them or their optgroup
        // parents
        if (options) {

          for (var i = options.items.length - 1; i >= 0; i--) {
            var option = options.items[i];
            if (isDefined(option.group)) {
              jqLiteRemove(option.element.parentNode);
            } else {
              jqLiteRemove(option.element);
            }
          }
        }

        options = ngOptions.getOptions();

        var groupElementMap = {};

        options.items.forEach(function addOption(option) {
          var groupElement;

          if (isDefined(option.group)) {

            // This option is to live in a group
            // See if we have already created this group
            groupElement = groupElementMap[option.group];

            if (!groupElement) {

              groupElement = optGroupTemplate.cloneNode(false);
              listFragment.appendChild(groupElement);

              // Update the label on the group element
              // "null" is special cased because of Safari
              groupElement.label = option.group === null ? 'null' : option.group;

              // Store it for use later
              groupElementMap[option.group] = groupElement;
            }

            addOptionElement(option, groupElement);

          } else {

            // This option is not in a group
            addOptionElement(option, listFragment);
          }
        });

        selectElement[0].appendChild(listFragment);

        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          var isNotPrimitive = ngOptions.trackBy || multiple;
          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }
      }
  }

  return {
    restrict: 'A',
    terminal: true,
    require: ['select', 'ngModel'],
    link: {
      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
        // Deactivate the SelectController.register method to prevent
        // option directives from accidentally registering themselves
        // (and unwanted $destroy handlers etc.)
        ctrls[0].registerOption = noop;
      },
      post: ngOptionsPostLink
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * ## Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in AngularJS's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * ## Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * AngularJS expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * ## Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample" name="ng-pluralize">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */
var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
  var BRACE = /{}/g,
      IS_WHEN = /^when(Minus)?(.+)$/;

  return {
    link: function(scope, element, attr) {
      var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
          watchRemover = angular.noop,
          lastCount;

      forEach(attr, function(expression, attributeName) {
        var tmpMatch = IS_WHEN.exec(attributeName);
        if (tmpMatch) {
          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
          whens[whenKey] = element.attr(attr.$attr[attributeName]);
        }
      });
      forEach(whens, function(expression, key) {
        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));

      });

      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
        var count = parseFloat(newVal);
        var countIsNaN = isNumberNaN(count);

        if (!countIsNaN && !(count in whens)) {
          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
          // Otherwise, check it against pluralization rules in $locale service.
          count = $locale.pluralCat(count - offset);
        }

        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
        // In JS `NaN !== NaN`, so we have to explicitly check.
        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
          watchRemover();
          var whenExpFn = whensExpFns[count];
          if (isUndefined(whenExpFn)) {
            if (newVal != null) {
              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
            }
            watchRemover = noop;
            updateElementText();
          } else {
            watchRemover = scope.$watch(whenExpFn, updateElementText);
          }
          lastCount = count;
        }
      });

      function updateElementText(newText) {
        element.text(newText || '');
      }
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRef
 * @restrict A
 *
 * @description
 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
 * element to the scope.
 *
 * If the element with `ngRef` is destroyed `null` is assigned to the property.
 *
 * Note that if you want to assign from a child into the parent scope, you must initialize the
 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
 * {@link ngRepeat}. See the second example below.
 *
 *
 * @element ANY
 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
 *                       controller or jqlite-wrapped DOM element will be bound.
 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
 *                            or the special string `$element`. If a name is provided, `ngRef` will
 *                            assign the matching controller. If `$element` is provided, the element
 *                            itself is assigned (even if a controller is available).
 *
 *
 * @example
 * ### Simple toggle
 * This example shows how the controller of the component toggle
 * is reused in the template through the scope to use its logic.
 * <example name="ng-ref-component" module="myApp">
 *   <file name="index.html">
 *     <my-toggle ng-ref="myToggle"></my-toggle>
 *     <button ng-click="myToggle.toggle()">Toggle</button>
 *     <div ng-show="myToggle.isOpen()">
 *       You are using a component in the same template to show it.
 *     </div>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myToggle', {
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should publish the toggle into the scope', function() {
 *        var toggle = element(by.buttonText('Toggle'));
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
 *        toggle.click();
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### ngRef inside scopes
 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
 * because the target property has not been initialized on the `myRoot` component controller.
 *
 * <example name="ng-ref-scopes" module="myApp">
 *   <file name="index.html">
 *     <my-root></my-root>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myRoot', {
 *       templateUrl: 'root.html',
 *       controller: function() {
 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
 *       }
 *     })
 *     .component('myToggle', {
 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
 *       transclude: true,
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     })
 *     .component('myWrapper', {
 *       transclude: true,
 *       template: '<strong>myWrapper</strong>' +
 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
 *     });
 *   </file>
 *   <file name="root.html">
 *     <strong>myRoot</strong>
 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     <div><em>wrappers assigned to root</em><br>
 *     <div ng-repeat="wrapper in $ctrl.wrappers">
 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
 *     </div>
 *
 *     <ul>
 *       <li ng-repeat="(index, value) in [1,2,3]">
 *         <strong>ngRepeat</strong>
 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
 *       </li>
 *     </ul>
 *
 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
 *       assigned to the child scope created by ngIf.
 *     </div>
 *     <div ng-if="true">
          <strong>ngIf</strong>
 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     </div>
 *   </file>
 *   <file name="styles.css">
 *     ul {
 *       list-style: none;
 *       padding-left: 0;
 *     }
 *
 *     li[ng-repeat] {
 *       background: lightgreen;
 *       padding: 8px;
 *       margin: 8px;
 *     }
 *
 *     [ng-if] {
 *       background: lightgrey;
 *       padding: 8px;
 *     }
 *
 *     my-root {
 *       background: lightgoldenrodyellow;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-wrapper {
 *       background: lightsalmon;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-toggle {
 *       background: lightblue;
 *       padding: 8px;
 *       display: block;
 *     }
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      var OuterToggle = function() {
 *        this.toggle = function() {
 *          element(by.buttonText('Outer Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
 *        };
 *      };
 *      var NgRepeatToggle = function(i) {
 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
 *        this.toggle = function() {
 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
 *        };
 *        this.isOpen = function() {
 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *      var NgRepeatToggles = function() {
 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
 *        this.forEach = function(fn) {
 *          toggles.forEach(fn);
 *        };
 *        this.isOuterOpen = function(i) {
 *          return toggles[i - 1].isOuterOpen();
 *        };
 *      };
 *      var NgIfToggle = function() {
 *        var parent = element(by.css('[ng-if]'));
 *        this.toggle = function() {
 *          element(by.buttonText('ngIf Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return by.binding('ngIfToggle.isOpen() | json').getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *
 *      it('should toggle the outer toggle', function() {
 *        var outerToggle = new OuterToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle all outer toggles', function() {
 *        var outerToggle = new OuterToggle();
 *        var repeatToggles = new NgRepeatToggles();
 *        var ifToggle = new NgIfToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle each repeat iteration separately', function() {
 *        var repeatToggles = new NgRepeatToggles();
 *
 *        repeatToggles.forEach(function(repeatToggle) {
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *          repeatToggle.toggle();
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        });
 *      });
 *   </file>
 * </example>
 *
 */

var ngRefMinErr = minErr('ngRef');

var ngRefDirective = ['$parse', function($parse) {
  return {
    priority: -1, // Needed for compatibility with element transclusion on the same element
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      // Get the expected controller name, converts <data-some-thing> into "someThing"
      var controllerName = directiveNormalize(nodeName_(tElement));

      // Get the expression for value binding
      var getter = $parse(tAttrs.ngRef);
      var setter = getter.assign || function() {
        throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
      };

      return function(scope, element, attrs) {
        var refValue;

        if (attrs.hasOwnProperty('ngRefRead')) {
          if (attrs.ngRefRead === '$element') {
            refValue = element;
          } else {
            refValue = element.data('$' + attrs.ngRefRead + 'Controller');

            if (!refValue) {
              throw ngRefMinErr(
                'noctrl',
                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
                attrs.ngRefRead,
                tAttrs.ngRef
              );
            }
          }
        } else {
          refValue = element.data('$' + controllerName + 'Controller');
        }

        refValue = refValue || element;

        setter(scope, refValue);

        // when the element is removed, remove it (nullify it)
        element.on('$destroy', function() {
          // only remove it if value has not changed,
          // because animations (and other procedures) may duplicate elements
          if (getter(scope) === refValue) {
            setter(scope, null);
          }
        });
      };
    }
  };
}];

/* exported ngRepeatDirective */

/**
 * @ngdoc directive
 * @name ngRepeat
 * @multiElement
 * @restrict A
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * <div class="alert alert-info">
 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 *   This may be useful when, for instance, nesting ngRepeats.
 * </div>
 *
 *
 * ## Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * However, there are a few limitations compared to array iteration:
 *
 * - The JavaScript specification does not define the order of keys
 *   returned for an object, so AngularJS relies on the order returned by the browser
 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
 *   and reinstated. See the
 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
 *
 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
 *
 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
 *   objects, and will throw an error if used with one.
 *
 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * ## Tracking and Duplicates
 *
 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * To minimize creation of DOM elements, `ngRepeat` uses a function
 * to "keep track" of all items in the collection and their corresponding DOM elements.
 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
 * already have DOM elements, and will not re-render them.
 *
 * All different types of tracking functions, their syntax, and and their support for duplicate
 * items in collections can be found in the
 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
 *
 * <div class="alert alert-success">
 * **Best Practice:** If you are working with objects that have a unique identifier property, you
 * should track by this identifier instead of the object instance,
 * e.g. `item in items track by item.id`.
 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
 * it has already rendered, even if the JavaScript objects in the collection have been substituted
 * for new ones. For large collections, this significantly improves rendering performance.
 * </div>
 *
 * ### Effects of DOM Element re-use
 *
 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
 * automatically update any active bindings on the template. However, other
 * functionality will not be updated, because the element is not re-created:
 *
 * - Directives are not re-compiled
 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
 * updated if they have stabilized.
 *
 * The above affects all kinds of element re-use due to tracking, but may be especially visible
 * when tracking by `$index` due to the way ngRepeat re-uses elements.
 *
 * The following example shows the effects of different actions with tracking:

  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        var friends = [
          {name:'John', age:25},
          {name:'Mary', age:40},
          {name:'Peter', age:85}
        ];

        $scope.removeFirst = function() {
          $scope.friends.shift();
        };

        $scope.updateAge = function() {
          $scope.friends.forEach(function(el) {
            el.age = el.age + 5;
          });
        };

        $scope.copy = function() {
          $scope.friends = angular.copy($scope.friends);
        };

        $scope.reset = function() {
          $scope.friends = angular.copy(friends);
        };

        $scope.reset();
      });
    </file>
    <file name="index.html">
      <div ng-controller="repeatController">
        <ol>
          <li>When you click "Update Age", only the first list updates the age, because all others have
          a one-time binding on the age property. If you then click "Copy", the current friend list
          is copied, and now the second list updates the age, because the identity of the collection items
          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
          items are already known according to their tracking functions.
          </li>
          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
          DOM element for the new first collection item, and so on. Since the age property is one-time
          bound, the value remains from the collection item which was previously at this index.
          </li>
        </ol>

        <button ng-click="removeFirst()">Remove First</button>
        <button ng-click="updateAge()">Update Age</button>
        <button ng-click="copy()">Copy</button>
        <br><button ng-click="reset()">Reset List</button>
        <br>
        <code>track by $id(friend)</code> (default):
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{friend.age}} years old.
          </li>
        </ul>
        <code>track by $id(friend)</code> (default), with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by friend.name</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
            {{friend.name}}  is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by $index</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
      </div>
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
  </example>

 *
 * ## Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
 *
 * See the example below for defining CSS animations with ngRepeat.
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
 *     This implies that the DOM elements will be associated by item identity in the collection.
 *
 *     The built-in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the collection by identity. Moving the same object would move
 *     the DOM element in the same way in the DOM.
 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
 *
 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
 *     id, for example with a function, or using a property on the collection items.
 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
 *     equivalent as long as their `id` property is same.
 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
 *
 *     *$index*: This special property tracks the collection items by their index, and
 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
 *     be used for a performance improvement if no unique identfier is available and the identity of
 *     the collection items cannot be easily computed. It also allows duplicates.
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
 *       more info.
 *     </div>
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
 *       `item in items | filter:searchText as results  track by item.id`
 *     </div>
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat
 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
 *
 * @example
 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
 * results by name or by age. New (entering) and removed (leaving) items are animated.
  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="repeatController">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length === 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        $scope.friends = [
          {name:'John', age:25, gender:'boy'},
          {name:'Jessie', age:30, gender:'girl'},
          {name:'Johanna', age:28, gender:'girl'},
          {name:'Joy', age:15, gender:'girl'},
          {name:'Mary', age:28, gender:'girl'},
          {name:'Peter', age:95, gender:'boy'},
          {name:'Sebastian', age:50, gender:'boy'},
          {name:'Erika', age:27, gender:'girl'},
          {name:'Patrick', age:40, gender:'boy'},
          {name:'Samantha', age:60, gender:'girl'}
        ];
      });
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */
var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
  var NG_REMOVED = '$$NG_REMOVED';
  var ngRepeatMinErr = minErr('ngRepeat');

  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
    scope[valueIdentifier] = value;
    if (keyIdentifier) scope[keyIdentifier] = key;
    scope.$index = index;
    scope.$first = (index === 0);
    scope.$last = (index === (arrayLength - 1));
    scope.$middle = !(scope.$first || scope.$last);
    // eslint-disable-next-line no-bitwise
    scope.$odd = !(scope.$even = (index & 1) === 0);
  };

  var getBlockStart = function(block) {
    return block.clone[0];
  };

  var getBlockEnd = function(block) {
    return block.clone[block.clone.length - 1];
  };


  return {
    restrict: 'A',
    multiElement: true,
    transclude: 'element',
    priority: 1000,
    terminal: true,
    $$tlb: true,
    compile: function ngRepeatCompile($element, $attr) {
      var expression = $attr.ngRepeat;
      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);

      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      if (!match) {
        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
            expression);
      }

      var lhs = match[1];
      var rhs = match[2];
      var aliasAs = match[3];
      var trackByExp = match[4];

      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);

      if (!match) {
        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
            lhs);
      }
      var valueIdentifier = match[3] || match[1];
      var keyIdentifier = match[2];

      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
          aliasAs);
      }

      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
      var hashFnLocals = {$id: hashKey};

      if (trackByExp) {
        trackByExpGetter = $parse(trackByExp);
      } else {
        trackByIdArrayFn = function(key, value) {
          return hashKey(value);
        };
        trackByIdObjFn = function(key) {
          return key;
        };
      }

      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

        if (trackByExpGetter) {
          trackByIdExpFn = function(key, value, index) {
            // assign key, value, and $index to the locals so that they can be used in hash functions
            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
            hashFnLocals[valueIdentifier] = value;
            hashFnLocals.$index = index;
            return trackByExpGetter($scope, hashFnLocals);
          };
        }

        // Store a list of elements from previous run. This is a hash where key is the item from the
        // iterator, and the value is objects with following properties.
        //   - scope: bound scope
        //   - clone: previous element.
        //   - index: position
        //
        // We are using no-proto object so that we don't need to guard against inherited props via
        // hasOwnProperty.
        var lastBlockMap = createMap();

        //watch props
        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
          var index, length,
              previousNode = $element[0],     // node that cloned nodes should be inserted after
                                              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key, value, // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block,       // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;

          if (aliasAs) {
            $scope[aliasAs] = collection;
          }

          if (isArrayLike(collection)) {
            collectionKeys = collection;
            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
          } else {
            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
            // if object, extract keys, in enumeration order, unsorted
            collectionKeys = [];
            for (var itemKey in collection) {
              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                collectionKeys.push(itemKey);
              }
            }
          }

          collectionLength = collectionKeys.length;
          nextBlockOrder = new Array(collectionLength);

          // locate existing items
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            trackById = trackByIdFn(key, value, index);
            if (lastBlockMap[trackById]) {
              // found previously seen block
              block = lastBlockMap[trackById];
              delete lastBlockMap[trackById];
              nextBlockMap[trackById] = block;
              nextBlockOrder[index] = block;
            } else if (nextBlockMap[trackById]) {
              // if collision detected. restore lastBlockMap and throw an error
              forEach(nextBlockOrder, function(block) {
                if (block && block.scope) lastBlockMap[block.id] = block;
              });
              throw ngRepeatMinErr('dupes',
                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
                  expression, trackById, value);
            } else {
              // new never before seen block
              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
              nextBlockMap[trackById] = true;
            }
          }

          // remove leftover items
          for (var blockKey in lastBlockMap) {
            block = lastBlockMap[blockKey];
            elementsToRemove = getBlockNodes(block.clone);
            $animate.leave(elementsToRemove);
            if (elementsToRemove[0].parentNode) {
              // if the element was not removed yet because of pending animation, mark it as deleted
              // so that we can ignore it later
              for (index = 0, length = elementsToRemove.length; index < length; index++) {
                elementsToRemove[index][NG_REMOVED] = true;
              }
            }
            block.scope.$destroy();
          }

          // we are not using forEach for perf reasons (trying to avoid #call)
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            block = nextBlockOrder[index];

            if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element

              nextNode = previousNode;

              // skip nodes that are already pending removal via leave animation
              do {
                nextNode = nextNode.nextSibling;
              } while (nextNode && nextNode[NG_REMOVED]);

              if (getBlockStart(block) !== nextNode) {
                // existing item which got moved
                $animate.move(getBlockNodes(block.clone), null, previousNode);
              }
              previousNode = getBlockEnd(block);
              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
            } else {
              // new item which we don't know about
              $transclude(function ngRepeatTransclude(clone, scope) {
                block.scope = scope;
                // http://jsperf.com/clone-vs-createcomment
                var endNode = ngRepeatEndComment.cloneNode(false);
                clone[clone.length++] = endNode;

                $animate.enter(clone, null, previousNode);
                previousNode = endNode;
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block.clone = clone;
                nextBlockMap[block.id] = block;
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              });
            }
          }
          lastBlockMap = nextBlockMap;
        });
      };
    }
  };
}];

var NG_HIDE_CLASS = 'ng-hide';
var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
/**
 * @ngdoc directive
 * @name ngShow
 * @multiElement
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
 * the `ngShow` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override anything in CSS and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                        |
 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is shown/hidden respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element animate-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element funky-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngShow to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */
var ngShowDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
        // we're adding a temporary, animation-specific class for ng-hide since this way
        // we can control when the element is actually displayed on screen without having
        // to have a global/greedy CSS selector that breaks when other animations are run.
        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngHide
 * @multiElement
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
 * the `ngHide` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                     |
 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is hidden/shown respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element animate-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element funky-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngHide to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */
var ngHideDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
        // The comment inside of the ngShowDirective explains why we add and
        // remove a temporary class for the show/hide animation
        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
 * attribute, when using the `ngStyle` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example name="ng-style">
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
       });
     </file>
   </example>
 */
var ngStyleDirective = ngDirective(function(scope, element, attr) {
  scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
    if (oldStyles && (newStyles !== oldStyles)) {
      forEach(oldStyles, function(val, style) { element.css(style, '');});
    }
    if (newStyles) element.css(newStyles);
  });
});

/**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed. It is possible to associate multiple values to
 *   the same `ngSwitchWhen` by defining the optional attribute
 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
 *   if any of the `ngSwitch` evaluates to any of these tokens.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'options', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should change to settings via "options"', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(3).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */
var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    require: 'ngSwitch',

    // asks for $scope to fool the BC controller module
    controller: ['$scope', function NgSwitchController() {
     this.cases = {};
    }],
    link: function(scope, element, attr, ngSwitchController) {
      var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];

      var spliceFactory = function(array, index) {
          return function(response) {
            if (response !== false) array.splice(index, 1);
          };
      };

      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
        var i, ii;

        // Start with the last, in case the array is modified during the loop
        while (previousLeaveAnimations.length) {
          $animate.cancel(previousLeaveAnimations.pop());
        }

        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
          var selected = getBlockNodes(selectedElements[i].clone);
          selectedScopes[i].$destroy();
          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
          runner.done(spliceFactory(previousLeaveAnimations, i));
        }

        selectedElements.length = 0;
        selectedScopes.length = 0;

        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
          forEach(selectedTranscludes, function(selectedTransclude) {
            selectedTransclude.transclude(function(caseElement, selectedScope) {
              selectedScopes.push(selectedScope);
              var anchor = selectedTransclude.element;
              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
              var block = { clone: caseElement };

              selectedElements.push(block);
              $animate.enter(caseElement, anchor.parent(), anchor);
            });
          });
        }
      });
    }
  };
}];

var ngSwitchWhenDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attrs, ctrl, $transclude) {

    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
      // Filter duplicate cases
      function(element, index, array) { return array[index - 1] !== element; }
    );

    forEach(cases, function(whenCase) {
      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
    });
  }
});

var ngSwitchDefaultDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attr, ctrl, $transclude) {
    ctrl.cases['?'] = (ctrl.cases['?'] || []);
    ctrl.cases['?'].push({ transclude: $transclude, element: element });
   }
});

/**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
 *
 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
 * content of this element will be removed before the transcluded content is inserted.
 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
 * content in the case that no transcluded content is provided.
 *
 * @element ANY
 *
 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
 *                                               or its value is the same as the name of the attribute then the default slot is used.
 *
 * @example
 * ### Basic transclusion
 * This example demonstrates basic transclusion of content into a component directive.
 * <example name="simpleTranscludeExample" module="transcludeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('transcludeExample', [])
 *        .directive('pane', function(){
 *           return {
 *             restrict: 'E',
 *             transclude: true,
 *             scope: { title:'@' },
 *             template: '<div style="border: 1px solid black;">' +
 *                         '<div style="background-color: gray">{{title}}</div>' +
 *                         '<ng-transclude></ng-transclude>' +
 *                       '</div>'
 *           };
 *       })
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.title = 'Lorem Ipsum';
 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *       }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input ng-model="title" aria-label="title"> <br/>
 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *       <pane title="{{title}}"><span>{{text}}</span></pane>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### Transclude fallback content
 * This example shows how to use `NgTransclude` with fallback content, that
 * is displayed if no transcluded content is provided.
 *
 * <example module="transcludeFallbackContentExample" name="ng-transclude">
 * <file name="index.html">
 * <script>
 * angular.module('transcludeFallbackContentExample', [])
 * .directive('myButton', function(){
 *             return {
 *               restrict: 'E',
 *               transclude: true,
 *               scope: true,
 *               template: '<button style="cursor: pointer;">' +
 *                           '<ng-transclude>' +
 *                             '<b style="color: red;">Button1</b>' +
 *                           '</ng-transclude>' +
 *                         '</button>'
 *             };
 *         });
 * </script>
 * <!-- fallback button content -->
 * <my-button id="fallback"></my-button>
 * <!-- modified button content -->
 * <my-button id="modified">
 *   <i style="color: green;">Button2</i>
 * </my-button>
 * </file>
 * <file name="protractor.js" type="protractor">
 * it('should have different transclude element content', function() {
 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
 *          expect(element(by.id('modified')).getText()).toBe('Button2');
 *        });
 * </file>
 * </example>
 *
 * @example
 * ### Multi-slot transclusion
 * This example demonstrates using multi-slot transclusion in a component directive.
 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
 *   <file name="index.html">
 *    <style>
 *      .title, .footer {
 *        background-color: gray
 *      }
 *    </style>
 *    <div ng-controller="ExampleController">
 *      <input ng-model="title" aria-label="title"> <br/>
 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *      <pane>
 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
 *        <pane-body><p>{{text}}</p></pane-body>
 *      </pane>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('multiSlotTranscludeExample', [])
 *     .directive('pane', function() {
 *        return {
 *          restrict: 'E',
 *          transclude: {
 *            'title': '?paneTitle',
 *            'body': 'paneBody',
 *            'footer': '?paneFooter'
 *          },
 *          template: '<div style="border: 1px solid black;">' +
 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
 *                      '<div ng-transclude="body"></div>' +
 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
 *                    '</div>'
 *        };
 *    })
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.title = 'Lorem Ipsum';
 *      $scope.link = 'https://google.com';
 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *    }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded the title and the body', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
 *      });
 *   </file>
 * </example>
 */
var ngTranscludeMinErr = minErr('ngTransclude');
var ngTranscludeDirective = ['$compile', function($compile) {
  return {
    restrict: 'EAC',
    compile: function ngTranscludeCompile(tElement) {

      // Remove and cache any original content to act as a fallback
      var fallbackLinkFn = $compile(tElement.contents());
      tElement.empty();

      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {

        if (!$transclude) {
          throw ngTranscludeMinErr('orphan',
          'Illegal use of ngTransclude directive in the template! ' +
          'No parent directive that requires a transclusion found. ' +
          'Element: {0}',
          startingTag($element));
        }


        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
          $attrs.ngTransclude = '';
        }
        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

        // If the slot is required and no transclusion content is provided then this call will throw an error
        $transclude(ngTranscludeCloneAttachFn, null, slotName);

        // If the slot is optional and no transclusion content is provided then use the fallback content
        if (slotName && !$transclude.isSlotFilled(slotName)) {
          useFallbackContent();
        }

        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
          if (clone.length && notWhitespace(clone)) {
            $element.append(clone);
          } else {
            useFallbackContent();
            // There is nothing linked against the transcluded scope since no content was available,
            // so it should be safe to clean up the generated scope.
            transcludedScope.$destroy();
          }
        }

        function useFallbackContent() {
          // Since this is the fallback content rather than the transcluded content,
          // we link against the scope of this directive rather than the transcluded scope
          fallbackLinkFn($scope, function(clone) {
            $element.append(clone);
          });
        }

        function notWhitespace(nodes) {
          for (var i = 0, ii = nodes.length; i < ii; i++) {
            var node = nodes[i];
            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
              return true;
            }
          }
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example  name="script-tag">
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */
var scriptDirective = ['$templateCache', function($templateCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function(element, attr) {
      if (attr.type === 'text/ng-template') {
        var templateUrl = attr.id,
            text = element[0].text;

        $templateCache.put(templateUrl, text);
      }
    }
  };
}];

/* exported selectDirective, optionDirective */

var noopNgModelController = { $setViewValue: noop, $render: noop };

function setOptionSelectedStatus(optionEl, value) {
  optionEl.prop('selected', value);
  /**
   * When unselecting an option, setting the property to null / false should be enough
   * However, screenreaders might react to the selected attribute instead, see
   * https://github.com/angular/angular.js/issues/14419
   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
   * or null
   */
  optionEl.attr('selected', value);
}

/**
 * @ngdoc type
 * @name  select.SelectController
 *
 * @description
 * The controller for the {@link ng.select select} directive. The controller exposes
 * a few utility methods that can be used to augment the behavior of a regular or an
 * {@link ng.ngOptions ngOptions} select element.
 *
 * @example
 * ### Set a custom error when the unknown option is selected
 *
 * This example sets a custom error "unknownValue" on the ngModelController
 * when the select element's unknown option is selected, i.e. when the model is set to a value
 * that is not matched by any option.
 *
 * <example name="select-unknown-value-error" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Single select: </label><br>
 *     <select name="testSelect" ng-model="selected" unknown-value-error>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
 *       Error: The current model doesn't match any option</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueError', function() {
 *     return {
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
 *           if (selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return true;
 *         };
 *       }
 *
 *     };
 *   });
 * </file>
 *</example>
 *
 *
 * @example
 * ### Set the "required" error when the unknown option is selected.
 *
 * By default, the "required" error on the ngModelController is only set on a required select
 * when the empty option is selected. This example adds a custom directive that also sets the
 * error when the unknown option is selected.
 *
 * <example name="select-unknown-value-required" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Select: </label><br>
 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueRequired', function() {
 *     return {
 *       priority: 1, // This directive must run after the required directive has added its validator
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
 *
 *         ngModelCtrl.$validators.required = function() {
 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return originalRequiredValidator.apply(this, arguments);
 *         };
 *       }
 *     };
 *   });
 * </file>
 * <file name="protractor.js" type="protractor">
 *  it('should show the error message when the unknown option is selected', function() {

      var error = element(by.className('error'));

      expect(error.getText()).toBe('Error: Please select a value');

      element(by.cssContainingText('option', 'Option 1')).click();

      expect(error.isPresent()).toBe(false);

      element(by.tagName('button')).click();

      expect(error.getText()).toBe('Error: Please select a value');
    });
 * </file>
 *</example>
 *
 *
 */
var SelectController =
        ['$element', '$scope', /** @this */ function($element, $scope) {

  var self = this,
      optionsMap = new NgMap();

  self.selectValueMap = {}; // Keys are the hashed values, values the original values

  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
  self.ngModelCtrl = noopNgModelController;
  self.multiple = false;

  // The "unknown" option is one that is prepended to the list if the viewValue
  // does not match any of the options. When it is rendered the value of the unknown
  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
  //
  // Support: IE 9 only
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  self.unknownOption = jqLite(window.document.createElement('option'));

  // The empty option is an option with the value '' that the application developer can
  // provide inside the select. It is always selectable and indicates that a "null" selection has
  // been made by the user.
  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
  // the empty option is selected.
  // If the model is set to a different unmatched value, the unknown option is rendered and
  // selected, i.e both are present, because a "null" selection and an unknown value are different.
  self.hasEmptyOption = false;
  self.emptyOption = undefined;

  self.renderUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    $element.prepend(self.unknownOption);
    setOptionSelectedStatus(self.unknownOption, true);
    $element.val(unknownVal);
  };

  self.updateUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    setOptionSelectedStatus(self.unknownOption, true);
    $element.val(unknownVal);
  };

  self.generateUnknownOptionValue = function(val) {
    return '? ' + hashKey(val) + ' ?';
  };

  self.removeUnknownOption = function() {
    if (self.unknownOption.parent()) self.unknownOption.remove();
  };

  self.selectEmptyOption = function() {
    if (self.emptyOption) {
      $element.val('');
      setOptionSelectedStatus(self.emptyOption, true);
    }
  };

  self.unselectEmptyOption = function() {
    if (self.hasEmptyOption) {
      setOptionSelectedStatus(self.emptyOption, false);
    }
  };

  $scope.$on('$destroy', function() {
    // disable unknown option so that we don't do work when the whole select is being destroyed
    self.renderUnknownOption = noop;
  });

  // Read the value of the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.readValue = function readSingleValue() {
    var val = $element.val();
    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;

    if (self.hasOption(realVal)) {
      return realVal;
    }

    return null;
  };


  // Write the value to the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.writeValue = function writeSingleValue(value) {
    // Make sure to remove the selected attribute from the previously selected option
    // Otherwise, screen readers might get confused
    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);

    if (self.hasOption(value)) {
      self.removeUnknownOption();

      var hashedVal = hashKey(value);
      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);

      // Set selected attribute and property on selected option for screen readers
      var selectedOption = $element[0].options[$element[0].selectedIndex];
      setOptionSelectedStatus(jqLite(selectedOption), true);
    } else {
      self.selectUnknownOrEmptyOption(value);
    }
  };


  // Tell the select control that an option, with the given value, has been added
  self.addOption = function(value, element) {
    // Skip comment nodes, as they only pollute the `optionsMap`
    if (element[0].nodeType === NODE_TYPE_COMMENT) return;

    assertNotHasOwnProperty(value, '"option value"');
    if (value === '') {
      self.hasEmptyOption = true;
      self.emptyOption = element;
    }
    var count = optionsMap.get(value) || 0;
    optionsMap.set(value, count + 1);
    // Only render at the end of a digest. This improves render performance when many options
    // are added during a digest and ensures all relevant options are correctly marked as selected
    scheduleRender();
  };

  // Tell the select control that an option, with the given value, has been removed
  self.removeOption = function(value) {
    var count = optionsMap.get(value);
    if (count) {
      if (count === 1) {
        optionsMap.delete(value);
        if (value === '') {
          self.hasEmptyOption = false;
          self.emptyOption = undefined;
        }
      } else {
        optionsMap.set(value, count - 1);
      }
    }
  };

  // Check whether the select control has an option matching the given value
  self.hasOption = function(value) {
    return !!optionsMap.get(value);
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$hasEmptyOption
   *
   * @description
   *
   * Returns `true` if the select element currently has an empty option
   * element, i.e. an option that signifies that the select is empty / the selection is null.
   *
   */
  self.$hasEmptyOption = function() {
    return self.hasEmptyOption;
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$isUnknownOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element's unknown option is selected. The unknown option is added
   * and automatically selected whenever the select model doesn't match any option.
   *
   */
  self.$isUnknownOptionSelected = function() {
    // Presence of the unknown option means it is selected
    return $element[0].options[0] === self.unknownOption[0];
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$isEmptyOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element has an empty option and this empty option is currently
   * selected. Returns `false` if the select element has no empty option or it is not selected.
   *
   */
  self.$isEmptyOptionSelected = function() {
    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
  };

  self.selectUnknownOrEmptyOption = function(value) {
    if (value == null && self.emptyOption) {
      self.removeUnknownOption();
      self.selectEmptyOption();
    } else if (self.unknownOption.parent().length) {
      self.updateUnknownOption(value);
    } else {
      self.renderUnknownOption(value);
    }
  };

  var renderScheduled = false;
  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    $scope.$$postDigest(function() {
      renderScheduled = false;
      self.ngModelCtrl.$render();
    });
  }

  var updateScheduled = false;
  function scheduleViewValueUpdate(renderAfter) {
    if (updateScheduled) return;

    updateScheduled = true;

    $scope.$$postDigest(function() {
      if ($scope.$$destroyed) return;

      updateScheduled = false;
      self.ngModelCtrl.$setViewValue(self.readValue());
      if (renderAfter) self.ngModelCtrl.$render();
    });
  }


  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {

    if (optionAttrs.$attr.ngValue) {
      // The value attribute is set by ngValue
      var oldVal, hashedVal = NaN;
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(hashedVal)) {
          self.removeOption(oldVal);
          delete self.selectValueMap[hashedVal];
          removal = true;
        }

        hashedVal = hashKey(newVal);
        oldVal = newVal;
        self.selectValueMap[hashedVal] = newVal;
        self.addOption(newVal, optionElement);
        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
        // from firing a second time. Other $observers on value will also get the result of the
        // ngValue expression, not the hashed value
        optionElement.attr('value', hashedVal);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }

      });
    } else if (interpolateValueFn) {
      // The value attribute is interpolated
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
        // This method is overwritten in ngOptions and has side-effects!
        self.readValue();

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(oldVal)) {
          self.removeOption(oldVal);
          removal = true;
        }
        oldVal = newVal;
        self.addOption(newVal, optionElement);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else if (interpolateTextFn) {
      // The text content is interpolated
      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
        optionAttrs.$set('value', newVal);
        var previouslySelected = optionElement.prop('selected');
        if (oldVal !== newVal) {
          self.removeOption(oldVal);
        }
        self.addOption(newVal, optionElement);

        if (oldVal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else {
      // The value attribute is static
      self.addOption(optionAttrs.value, optionElement);
    }


    optionAttrs.$observe('disabled', function(newVal) {

      // Since model updates will also select disabled options (like ngOptions),
      // we only have to handle options becoming disabled, not enabled

      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
        if (self.multiple) {
          scheduleViewValueUpdate(true);
        } else {
          self.ngModelCtrl.$setViewValue(null);
          self.ngModelCtrl.$render();
        }
      }
    });

    optionElement.on('$destroy', function() {
      var currentValue = self.readValue();
      var removeValue = optionAttrs.value;

      self.removeOption(removeValue);
      scheduleRender();

      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
          currentValue === removeValue
      ) {
        // When multiple (selected) options are destroyed at the same time, we don't want
        // to run a model update for each of them. Instead, run a single update in the $$postDigest
        scheduleViewValueUpdate(true);
      }
    });
  };
}];

/**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `select` element with AngularJS data-binding.
 *
 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
 * between the scope and the `<select>` control (including setting default values).
 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
 * {@link ngOptions `ngOptions`} directives.
 *
 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
 * to the model identified by the `ngModel` directive. With static or repeated options, this is
 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
 * Value and textContent can be interpolated.
 *
 * The {@link select.SelectController select controller} exposes utility functions that can be used
 * to manipulate the select's behavior.
 *
 * ## Matching model and option values
 *
 * In general, the match between the model and an option is evaluated by strictly comparing the model
 * value against the value of the available options.
 *
 * If you are setting the option value with the option's `value` attribute, or textContent, the
 * value will always be a `string` which means that the model value must also be a string.
 * Otherwise the `select` directive cannot match them correctly.
 *
 * To bind the model to a non-string value, you can use one of the following strategies:
 * - the {@link ng.ngOptions `ngOptions`} directive
 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
 * - model $parsers / $formatters to convert the string value
 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
 *
 * If the viewValue of `ngModel` does not match any of the options, then the control
 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Choosing between `ngRepeat` and `ngOptions`
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * Specifically, select with repeated options slows down significantly starting at 2000 options in
 * Chrome and Internet Explorer / Edge.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
 *     bound to the model as an array.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds required attribute and required validation constraint to
 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
 * when you want to data-bind to the required attribute.
 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
 *    interaction with the select element.
 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
 * set on the model on selection. See {@link ngOptions `ngOptions`}.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 *
 * @knownIssue
 *
 * In Firefox, the select model is only updated when the select element is blurred. For example,
 * when switching between options with the keyboard, the select model is only set to the
 * currently selected option when the select is blurred, e.g via tab key or clicking the mouse
 * outside the select.
 *
 * This is due to an ambiguity in the select element specification. See the
 * [issue on the Firefox bug tracker](https://bugzilla.mozilla.org/show_bug.cgi?id=126379)
 * for more information, and this
 * [Github comment for a workaround](https://github.com/angular/angular.js/issues/9134#issuecomment-130800488)
 *
 * @example
 * ### Simple `select` elements with static options
 *
 * <example name="static-select" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="singleSelect"> Single select: </label><br>
 *     <select name="singleSelect" ng-model="data.singleSelect">
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *
 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *     <tt>singleSelect = {{data.singleSelect}}</tt>
 *
 *     <hr>
 *     <label for="multipleSelect"> Multiple select: </label><br>
 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *       <option value="option-3">Option 3</option>
 *     </select><br>
 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       singleSelect: null,
 *       multipleSelect: [],
 *       option1: 'option-1'
 *      };
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.data.singleSelect = 'nonsense';
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngRepeat` to generate `select` options
 * <example name="select-ngrepeat" module="ngrepeatSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="repeatSelect"> Repeat select: </label>
 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <tt>model = {{data.model}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngrepeatSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngValue` to bind the model to an array of objects
 * <example name="select-ngvalue" module="ngvalueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="ngvalueselect"> ngvalue select: </label>
 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <pre>model = {{data.model | json}}</pre><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngvalueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
           {value: 'myString', name: 'string'},
           {value: 1, name: 'integer'},
           {value: true, name: 'boolean'},
           {value: null, name: 'null'},
           {value: {prop: 'value'}, name: 'object'},
           {value: ['a'], name: 'array'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `select` with `ngOptions` and setting a default value
 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
 *
 * <example name="select-with-default-values" module="defaultValueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="mySelect">Make a choice:</label>
 *     <select name="mySelect" id="mySelect"
 *       ng-options="option.name for option in data.availableOptions track by option.id"
 *       ng-model="data.selectedOption"></select>
 *   </form>
 *   <hr>
 *   <tt>option = {{data.selectedOption}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('defaultValueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
 *       };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */
var selectDirective = function() {

  return {
    restrict: 'E',
    require: ['select', '?ngModel'],
    controller: SelectController,
    priority: 1,
    link: {
      pre: selectPreLink,
      post: selectPostLink
    }
  };

  function selectPreLink(scope, element, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];

      // if ngModel is not defined, we don't need to do anything but set the registerOption
      // function to noop, so options don't get added internally
      if (!ngModelCtrl) {
        selectCtrl.registerOption = noop;
        return;
      }


      selectCtrl.ngModelCtrl = ngModelCtrl;

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function() {
        selectCtrl.removeUnknownOption();
        scope.$apply(function() {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {
        selectCtrl.multiple = true;

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find('option'), function(option) {
            if (option.selected && !option.disabled) {
              var val = option.value;
              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          forEach(element.find('option'), function(option) {
            var shouldBeSelected = !!value && (includes(value, option.value) ||
                                               includes(value, selectCtrl.selectValueMap[option.value]));
            var currentlySelected = option.selected;

            // Support: IE 9-11 only, Edge 12-15+
            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
            // will de-select already selected options if "selected" on those options was set
            // more than once (i.e. when the options were already selected)
            // So we only modify the selected property if necessary.
            // Note: this behavior cannot be replicated via unit tests because it only shows in the
            // actual user interface.
            if (shouldBeSelected !== currentlySelected) {
              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
            }

          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView, lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };

      }
    }

    function selectPostLink(scope, element, attrs, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`.
      // This must be done in the postLink fn to prevent $render to be called before
      // all nodes have been linked correctly.
      ngModelCtrl.$render = function() {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };
    }
};


// The option directive is purely designed to communicate the existence (or lack of)
// of dynamically created (and destroyed) option elements to their containing select
// directive via its controller.
var optionDirective = ['$interpolate', function($interpolate) {
  return {
    restrict: 'E',
    priority: 100,
    compile: function(element, attr) {
      var interpolateValueFn, interpolateTextFn;

      if (isDefined(attr.ngValue)) {
        // Will be handled by registerOption
      } else if (isDefined(attr.value)) {
        // If the value attribute is defined, check if it contains an interpolation
        interpolateValueFn = $interpolate(attr.value, true);
      } else {
        // If the value attribute is not defined then we fall back to the
        // text content of the option element, which may be interpolated
        interpolateTextFn = $interpolate(element.text(), true);
        if (!interpolateTextFn) {
          attr.$set('value', element.text());
        }
      }

      return function(scope, element, attr) {
        // This is an optimization over using ^^ since we don't want to have to search
        // all the way to the root of the DOM for every single option element
        var selectCtrlName = '$selectController',
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) ||
              parent.parent().data(selectCtrlName); // in case we are in optgroup

        if (selectCtrl) {
          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRequired
 * @restrict A
 *
 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
 *                                `required` attribute to the element and adds the `required`
 *                                {@link ngModel.NgModelController#$validators `validator`}.
 *
 * @description
 *
 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
 * applied to custom controls.
 *
 * The directive sets the `required` attribute on the element if the AngularJS expression inside
 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
 * for more info.
 *
 * The validator will set the `required` error key to true if the `required` attribute is set and
 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
 *
 * @example
 * <example name="ngRequiredDirective" module="ngRequiredExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngRequiredExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.required = true;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="required">Toggle required: </label>
 *         <input type="checkbox" ng-model="required" id="required" />
 *         <br>
 *         <label for="input">This input must be filled if `required` is true: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
 *         <hr>
 *         required error set? = <code>{{form.input.$error.required}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var required = element(by.binding('form.input.$error.required'));
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should set the required error', function() {
         expect(required.getText()).toContain('true');

         input.sendKeys('123');
         expect(required.getText()).not.toContain('true');
         expect(model.getText()).toContain('123');
       });
 *   </file>
 * </example>
 */
var requiredDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;
      attr.required = true; // force truthy in case we are on non input element

      ctrl.$validators.required = function(modelValue, viewValue) {
        return !attr.required || !ctrl.$isEmpty(viewValue);
      };

      attr.$observe('required', function() {
        ctrl.$validate();
      });
    }
  };
};

/**
 * @ngdoc directive
 * @name ngPattern
 * @restrict A
 *
 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
 *                                      more details.
 *
 * @description
 *
 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
 * - the value is an AngularJS expression:
 *   - If the expression evaluates to a RegExp object, then this is used directly.
 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
 *
 * <div class="alert alert-info">
 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 * start at the index of the last search's match, thus not taking the whole input value into
 * account.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
 *     not available.
 *   </li>
 *   <li>
 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngPatternDirective" module="ngPatternExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngPatternExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.regex = '\\d+';
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="regex">Set a pattern (regex string): </label>
 *         <input type="text" ng-model="regex" id="regex" />
 *         <br>
 *         <label for="input">This input is restricted by the current pattern: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default pattern', function() {
         input.sendKeys('aaa');
         expect(model.getText()).not.toContain('aaa');

         input.clear().then(function() {
           input.sendKeys('123');
           expect(model.getText()).toContain('123');
         });
       });
 *   </file>
 * </example>
 */
var patternDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var regexp, patternExp = attr.ngPattern || attr.pattern;
      attr.$observe('pattern', function(regex) {
        if (isString(regex) && regex.length > 0) {
          regex = new RegExp('^' + regex + '$');
        }

        if (regex && !regex.test) {
          throw minErr('ngPattern')('noregexp',
            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
            regex, startingTag(elm));
        }

        regexp = regex || undefined;
        ctrl.$validate();
      });

      ctrl.$validators.pattern = function(modelValue, viewValue) {
        // HTML5 pattern constraint validates the input value, so we validate the viewValue
        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
      };
    }
  };
};

/**
 * @ngdoc directive
 * @name ngMaxlength
 * @restrict A
 *
 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `maxlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is longer than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMaxlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMaxlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.maxlength = 5;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="maxlength">Set a maxlength: </label>
 *         <input type="number" ng-model="maxlength" id="maxlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current maxlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default maxlength', function() {
         input.sendKeys('abcdef');
         expect(model.getText()).not.toContain('abcdef');

         input.clear().then(function() {
           input.sendKeys('abcde');
           expect(model.getText()).toContain('abcde');
         });
       });
 *   </file>
 * </example>
 */
var maxlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var maxlength = -1;
      attr.$observe('maxlength', function(value) {
        var intVal = toInt(value);
        maxlength = isNumberNaN(intVal) ? -1 : intVal;
        ctrl.$validate();
      });
      ctrl.$validators.maxlength = function(modelValue, viewValue) {
        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
      };
    }
  };
};

/**
 * @ngdoc directive
 * @name ngMinlength
 * @restrict A
 *
 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `minlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMinlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMinlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.minlength = 3;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="minlength">Set a minlength: </label>
 *         <input type="number" ng-model="minlength" id="minlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current minlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default minlength', function() {
         input.sendKeys('ab');
         expect(model.getText()).not.toContain('ab');

         input.sendKeys('abc');
         expect(model.getText()).toContain('abc');
       });
 *   </file>
 * </example>
 */
var minlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var minlength = 0;
      attr.$observe('minlength', function(value) {
        minlength = toInt(value) || 0;
        ctrl.$validate();
      });
      ctrl.$validators.minlength = function(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
      };
    }
  };
};

if (window.angular.bootstrap) {
  // AngularJS is already loaded, so we can return here...
  if (window.console) {
    console.log('WARNING: Tried to load AngularJS more than once.');
  }
  return;
}

// try to bind to jquery now so that one can write jqLite(fn)
// but we will rebind on bootstrap again.
bindJQuery();

publishExternalAPI(angular);

angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "ERANAMES": [
      "Before Christ",
      "Anno Domini"
    ],
    "ERAS": [
      "BC",
      "AD"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "SHORTDAY": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "SHORTMONTH": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "STANDALONEMONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, MMMM d, y",
    "longDate": "MMMM d, y",
    "medium": "MMM d, y h:mm:ss a",
    "mediumDate": "MMM d, y",
    "mediumTime": "h:mm:ss a",
    "short": "M/d/yy h:mm a",
    "shortDate": "M/d/yy",
    "shortTime": "h:mm a"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "$",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "en-us",
  "localeID": "en_US",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

  jqLite(function() {
    angularInit(window.document, bootstrap);
  });

})(window);

!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(658), __esModule: true };

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(661), __esModule: true };

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(663), __esModule: true };

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(665), __esModule: true };

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(669), __esModule: true };

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(672), __esModule: true };

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(676), __esModule: true };

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(677), __esModule: true };

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(630);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(629);


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
* @version: 2.1.23
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2016 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
* @website: https://www.improvely.com/
*/
// Follow the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
(function (root, factory) {
    if (true) {
        // AMD. Make globaly available as well
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4), __webpack_require__(59)], __WEBPACK_AMD_DEFINE_RESULT__ = function (moment, jquery) {
            return (root.daterangepicker = factory(moment, jquery));
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        // Node / Browserify
        //isomorphic issue
        var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
        if (!jQuery) {
            jQuery = require('jquery');
            if (!jQuery.fn) jQuery.fn = {};
        }
        module.exports = factory(require('moment'), jQuery);
    } else {
        // Browser globals
        root.daterangepicker = factory(root.moment, root.jQuery);
    }
}(this, function(moment, $) {
    var DateRangePicker = function(element, options, cb) {

        //default settings for options
        this.parentEl = 'body';
        this.element = $(element);
        this.startDate = moment().startOf('day');
        this.endDate = moment().endOf('day');
        this.minDate = false;
        this.maxDate = false;
        this.dateLimit = false;
        this.autoApply = false;
        this.singleDatePicker = false;
        this.showDropdowns = false;
        this.showWeekNumbers = false;
        this.showISOWeekNumbers = false;
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this.linkedCalendars = true;
        this.autoUpdateInput = true;
        this.alwaysShowCalendars = false;
        this.ranges = {};

        this.opens = 'right';
        if (this.element.hasClass('pull-right'))
            this.opens = 'left';

        this.drops = 'down';
        if (this.element.hasClass('dropup'))
            this.drops = 'up';

        this.buttonClasses = 'btn btn-sm';
        this.applyClass = 'btn-success';
        this.cancelClass = 'btn-default';

        this.locale = {
            direction: 'ltr',
            format: 'MM/DD/YYYY',
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        };

        this.callback = function() { };

        //some state information
        this.isShowing = false;
        this.leftCalendar = {};
        this.rightCalendar = {};

        //custom options from user
        if (typeof options !== 'object' || options === null)
            options = {};

        //allow setting options with data attributes
        //data-api options will be overwritten with custom javascript options
        options = $.extend(this.element.data(), options);

        //html template for the picker UI
        if (typeof options.template !== 'string' && !(options.template instanceof $))
            options.template = '<div class="daterangepicker dropdown-menu">' +
                '<div class="calendar left">' +
                    '<div class="daterangepicker_input">' +
                      '<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
                      '<div class="calendar-time">' +
                        '<div></div>' +
                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
                      '</div>' +
                    '</div>' +
                    '<div class="calendar-table"></div>' +
                '</div>' +
                '<div class="calendar right">' +
                    '<div class="daterangepicker_input">' +
                      '<input class="input-mini form-control" type="text" name="daterangepicker_end" value="" />' +
                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
                      '<div class="calendar-time">' +
                        '<div></div>' +
                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
                      '</div>' +
                    '</div>' +
                    '<div class="calendar-table"></div>' +
                '</div>' +
                '<div class="ranges">' +
                    '<div class="range_inputs">' +
                        '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
                        '<button class="cancelBtn" type="button"></button>' +
                    '</div>' +
                '</div>' +
            '</div>';

        this.parentEl = (options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
        this.container = $(options.template).appendTo(this.parentEl);

        //
        // handle all the possible options overriding defaults
        //

        if (typeof options.locale === 'object') {

            if (typeof options.locale.direction === 'string')
                this.locale.direction = options.locale.direction;

            if (typeof options.locale.format === 'string')
                this.locale.format = options.locale.format;

            if (typeof options.locale.separator === 'string')
                this.locale.separator = options.locale.separator;

            if (typeof options.locale.daysOfWeek === 'object')
                this.locale.daysOfWeek = options.locale.daysOfWeek.slice();

            if (typeof options.locale.monthNames === 'object')
              this.locale.monthNames = options.locale.monthNames.slice();

            if (typeof options.locale.firstDay === 'number')
              this.locale.firstDay = options.locale.firstDay;

            if (typeof options.locale.applyLabel === 'string')
              this.locale.applyLabel = options.locale.applyLabel;

            if (typeof options.locale.cancelLabel === 'string')
              this.locale.cancelLabel = options.locale.cancelLabel;

            if (typeof options.locale.weekLabel === 'string')
              this.locale.weekLabel = options.locale.weekLabel;

            if (typeof options.locale.customRangeLabel === 'string')
              this.locale.customRangeLabel = options.locale.customRangeLabel;

        }
        this.container.addClass(this.locale.direction);

        if (typeof options.startDate === 'string')
            this.startDate = moment(options.startDate, this.locale.format);

        if (typeof options.endDate === 'string')
            this.endDate = moment(options.endDate, this.locale.format);

        if (typeof options.minDate === 'string')
            this.minDate = moment(options.minDate, this.locale.format);

        if (typeof options.maxDate === 'string')
            this.maxDate = moment(options.maxDate, this.locale.format);

        if (typeof options.startDate === 'object')
            this.startDate = moment(options.startDate);

        if (typeof options.endDate === 'object')
            this.endDate = moment(options.endDate);

        if (typeof options.minDate === 'object')
            this.minDate = moment(options.minDate);

        if (typeof options.maxDate === 'object')
            this.maxDate = moment(options.maxDate);

        // sanity check for bad options
        if (this.minDate && this.startDate.isBefore(this.minDate))
            this.startDate = this.minDate.clone();

        // sanity check for bad options
        if (this.maxDate && this.endDate.isAfter(this.maxDate))
            this.endDate = this.maxDate.clone();

        if (typeof options.applyClass === 'string')
            this.applyClass = options.applyClass;

        if (typeof options.cancelClass === 'string')
            this.cancelClass = options.cancelClass;

        if (typeof options.dateLimit === 'object')
            this.dateLimit = options.dateLimit;

        if (typeof options.opens === 'string')
            this.opens = options.opens;

        if (typeof options.drops === 'string')
            this.drops = options.drops;

        if (typeof options.showWeekNumbers === 'boolean')
            this.showWeekNumbers = options.showWeekNumbers;

        if (typeof options.showISOWeekNumbers === 'boolean')
            this.showISOWeekNumbers = options.showISOWeekNumbers;

        if (typeof options.buttonClasses === 'string')
            this.buttonClasses = options.buttonClasses;

        if (typeof options.buttonClasses === 'object')
            this.buttonClasses = options.buttonClasses.join(' ');

        if (typeof options.showDropdowns === 'boolean')
            this.showDropdowns = options.showDropdowns;

        if (typeof options.singleDatePicker === 'boolean') {
            this.singleDatePicker = options.singleDatePicker;
            if (this.singleDatePicker)
                this.endDate = this.startDate.clone();
        }

        if (typeof options.timePicker === 'boolean')
            this.timePicker = options.timePicker;

        if (typeof options.timePickerSeconds === 'boolean')
            this.timePickerSeconds = options.timePickerSeconds;

        if (typeof options.timePickerIncrement === 'number')
            this.timePickerIncrement = options.timePickerIncrement;

        if (typeof options.timePicker24Hour === 'boolean')
            this.timePicker24Hour = options.timePicker24Hour;

        if (typeof options.autoApply === 'boolean')
            this.autoApply = options.autoApply;

        if (typeof options.autoUpdateInput === 'boolean')
            this.autoUpdateInput = options.autoUpdateInput;

        if (typeof options.linkedCalendars === 'boolean')
            this.linkedCalendars = options.linkedCalendars;

        if (typeof options.isInvalidDate === 'function')
            this.isInvalidDate = options.isInvalidDate;

        if (typeof options.isCustomDate === 'function')
            this.isCustomDate = options.isCustomDate;

        if (typeof options.alwaysShowCalendars === 'boolean')
            this.alwaysShowCalendars = options.alwaysShowCalendars;

        // update day names order to firstDay
        if (this.locale.firstDay != 0) {
            var iterator = this.locale.firstDay;
            while (iterator > 0) {
                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
                iterator--;
            }
        }

        var start, end, range;

        //if no start/end dates set, check if an input element contains initial values
        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
            if ($(this.element).is('input[type=text]')) {
                var val = $(this.element).val(),
                    split = val.split(this.locale.separator);

                start = end = null;

                if (split.length == 2) {
                    start = moment(split[0], this.locale.format);
                    end = moment(split[1], this.locale.format);
                } else if (this.singleDatePicker && val !== "") {
                    start = moment(val, this.locale.format);
                    end = moment(val, this.locale.format);
                }
                if (start !== null && end !== null) {
                    this.setStartDate(start);
                    this.setEndDate(end);
                }
            }
        }

        if (typeof options.ranges === 'object') {
            for (range in options.ranges) {

                if (typeof options.ranges[range][0] === 'string')
                    start = moment(options.ranges[range][0], this.locale.format);
                else
                    start = moment(options.ranges[range][0]);

                if (typeof options.ranges[range][1] === 'string')
                    end = moment(options.ranges[range][1], this.locale.format);
                else
                    end = moment(options.ranges[range][1]);

                // If the start or end date exceed those allowed by the minDate or dateLimit
                // options, shorten the range to the allowable period.
                if (this.minDate && start.isBefore(this.minDate))
                    start = this.minDate.clone();

                var maxDate = this.maxDate;
                if (this.dateLimit && maxDate && start.clone().add(this.dateLimit).isAfter(maxDate))
                    maxDate = start.clone().add(this.dateLimit);
                if (maxDate && end.isAfter(maxDate))
                    end = maxDate.clone();

                // If the end of the range is before the minimum or the start of the range is
                // after the maximum, don't display this range option at all.
                if ((this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day')) 
                  || (maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')))
                    continue;

                //Support unicode chars in the range names.
                var elem = document.createElement('textarea');
                elem.innerHTML = range;
                var rangeHtml = elem.value;

                this.ranges[rangeHtml] = [start, end];
            }

            var list = '<ul>';
            for (range in this.ranges) {
                list += '<li data-range-key="' + range + '">' + range + '</li>';
            }
            list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
            list += '</ul>';
            this.container.find('.ranges').prepend(list);
        }

        if (typeof cb === 'function') {
            this.callback = cb;
        }

        if (!this.timePicker) {
            this.startDate = this.startDate.startOf('day');
            this.endDate = this.endDate.endOf('day');
            this.container.find('.calendar-time').hide();
        }

        //can't be used together for now
        if (this.timePicker && this.autoApply)
            this.autoApply = false;

        if (this.autoApply && typeof options.ranges !== 'object') {
            this.container.find('.ranges').hide();
        } else if (this.autoApply) {
            this.container.find('.applyBtn, .cancelBtn').addClass('hide');
        }

        if (this.singleDatePicker) {
            this.container.addClass('single');
            this.container.find('.calendar.left').addClass('single');
            this.container.find('.calendar.left').show();
            this.container.find('.calendar.right').hide();
            this.container.find('.daterangepicker_input input, .daterangepicker_input > i').hide();
            if (this.timePicker) {
                this.container.find('.ranges ul').hide();
            } else {
                this.container.find('.ranges').hide();
            }
        }

        if ((typeof options.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
            this.container.addClass('show-calendar');
        }

        this.container.addClass('opens' + this.opens);

        //swap the position of the predefined ranges if opens right
        if (typeof options.ranges !== 'undefined' && this.opens == 'right') {
            this.container.find('.ranges').prependTo( this.container.find('.calendar.left').parent() );
        }

        //apply CSS classes and labels to buttons
        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
        if (this.applyClass.length)
            this.container.find('.applyBtn').addClass(this.applyClass);
        if (this.cancelClass.length)
            this.container.find('.cancelBtn').addClass(this.cancelClass);
        this.container.find('.applyBtn').html(this.locale.applyLabel);
        this.container.find('.cancelBtn').html(this.locale.cancelLabel);

        //
        // event listeners
        //

        this.container.find('.calendar')
            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
            .on('click.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
            .on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this))
            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this))
            .on('click.daterangepicker', '.daterangepicker_input input', $.proxy(this.showCalendars, this))
            .on('focus.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsFocused, this))
            .on('blur.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsBlurred, this))
            .on('change.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsChanged, this));

        this.container.find('.ranges')
            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))
            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))
            .on('mouseenter.daterangepicker', 'li', $.proxy(this.hoverRange, this))
            .on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));

        if (this.element.is('input') || this.element.is('button')) {
            this.element.on({
                'click.daterangepicker': $.proxy(this.show, this),
                'focus.daterangepicker': $.proxy(this.show, this),
                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
                'keydown.daterangepicker': $.proxy(this.keydown, this)
            });
        } else {
            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
        }

        //
        // if attached to a text input, set the initial value
        //

        if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
            this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            this.element.trigger('change');
        } else if (this.element.is('input') && this.autoUpdateInput) {
            this.element.val(this.startDate.format(this.locale.format));
            this.element.trigger('change');
        }

    };

    DateRangePicker.prototype = {

        constructor: DateRangePicker,

        setStartDate: function(startDate) {
            if (typeof startDate === 'string')
                this.startDate = moment(startDate, this.locale.format);

            if (typeof startDate === 'object')
                this.startDate = moment(startDate);

            if (!this.timePicker)
                this.startDate = this.startDate.startOf('day');

            if (this.timePicker && this.timePickerIncrement)
                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

            if (this.minDate && this.startDate.isBefore(this.minDate)) {
                this.startDate = this.minDate;
                if (this.timePicker && this.timePickerIncrement)
                    this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }

            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
                this.startDate = this.maxDate;
                if (this.timePicker && this.timePickerIncrement)
                    this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }

            if (!this.isShowing)
                this.updateElement();

            this.updateMonthsInView();
        },

        setEndDate: function(endDate) {
            if (typeof endDate === 'string')
                this.endDate = moment(endDate, this.locale.format);

            if (typeof endDate === 'object')
                this.endDate = moment(endDate);

            if (!this.timePicker)
                this.endDate = this.endDate.endOf('day');

            if (this.timePicker && this.timePickerIncrement)
                this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

            if (this.endDate.isBefore(this.startDate))
                this.endDate = this.startDate.clone();

            if (this.maxDate && this.endDate.isAfter(this.maxDate))
                this.endDate = this.maxDate;

            if (this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate))
                this.endDate = this.startDate.clone().add(this.dateLimit);

            this.previousRightTime = this.endDate.clone();

            if (!this.isShowing)
                this.updateElement();

            this.updateMonthsInView();
        },

        isInvalidDate: function() {
            return false;
        },

        isCustomDate: function() {
            return false;
        },

        updateView: function() {
            if (this.timePicker) {
                this.renderTimePicker('left');
                this.renderTimePicker('right');
                if (!this.endDate) {
                    this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
                } else {
                    this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
                }
            }
            if (this.endDate) {
                this.container.find('input[name="daterangepicker_end"]').removeClass('active');
                this.container.find('input[name="daterangepicker_start"]').addClass('active');
            } else {
                this.container.find('input[name="daterangepicker_end"]').addClass('active');
                this.container.find('input[name="daterangepicker_start"]').removeClass('active');
            }
            this.updateMonthsInView();
            this.updateCalendars();
            this.updateFormInputs();
        },

        updateMonthsInView: function() {
            if (this.endDate) {

                //if both dates are visible already, do nothing
                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
                    (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                    &&
                    (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                    ) {
                    return;
                }

                this.leftCalendar.month = this.startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
                    this.rightCalendar.month = this.endDate.clone().date(2);
                } else {
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }

            } else {
                if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
                    this.leftCalendar.month = this.startDate.clone().date(2);
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }
            }
            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
              this.rightCalendar.month = this.maxDate.clone().date(2);
              this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
            }
        },

        updateCalendars: function() {

            if (this.timePicker) {
                var hour, minute, second;
                if (this.endDate) {
                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                } else {
                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                }
                this.leftCalendar.month.hour(hour).minute(minute).second(second);
                this.rightCalendar.month.hour(hour).minute(minute).second(second);
            }

            this.renderCalendar('left');
            this.renderCalendar('right');

            //highlight any predefined range matching the current start and end dates
            this.container.find('.ranges li').removeClass('active');
            if (this.endDate == null) return;

            this.calculateChosenLabel();
        },

        renderCalendar: function(side) {

            //
            // Build the matrix of dates that will populate the calendar
            //

            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
            var month = calendar.month.month();
            var year = calendar.month.year();
            var hour = calendar.month.hour();
            var minute = calendar.month.minute();
            var second = calendar.month.second();
            var daysInMonth = moment([year, month]).daysInMonth();
            var firstDay = moment([year, month, 1]);
            var lastDay = moment([year, month, daysInMonth]);
            var lastMonth = moment(firstDay).subtract(1, 'month').month();
            var lastYear = moment(firstDay).subtract(1, 'month').year();
            var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
            var dayOfWeek = firstDay.day();

            //initialize a 6 rows x 7 columns array for the calendar
            var calendar = [];
            calendar.firstDay = firstDay;
            calendar.lastDay = lastDay;

            for (var i = 0; i < 6; i++) {
                calendar[i] = [];
            }

            //populate the calendar with date objects
            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
            if (startDay > daysInLastMonth)
                startDay -= 7;

            if (dayOfWeek == this.locale.firstDay)
                startDay = daysInLastMonth - 6;

            var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);

            var col, row;
            for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
                if (i > 0 && col % 7 === 0) {
                    col = 0;
                    row++;
                }
                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
                curDate.hour(12);

                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
                    calendar[row][col] = this.minDate.clone();
                }

                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
                    calendar[row][col] = this.maxDate.clone();
                }

            }

            //make the calendar object available to hoverDate/clickDate
            if (side == 'left') {
                this.leftCalendar.calendar = calendar;
            } else {
                this.rightCalendar.calendar = calendar;
            }

            //
            // Display the calendar
            //

            var minDate = side == 'left' ? this.minDate : this.startDate;
            var maxDate = this.maxDate;
            var selected = side == 'left' ? this.startDate : this.endDate;
            var arrow = this.locale.direction == 'ltr' ? {left: 'chevron-left', right: 'chevron-right'} : {left: 'chevron-right', right: 'chevron-left'};

            var html = '<table class="table-condensed">';
            html += '<thead>';
            html += '<tr>';

            // add empty cell for week number
            if (this.showWeekNumbers || this.showISOWeekNumbers)
                html += '<th></th>';

            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
                html += '<th class="prev available"><i class="fa fa-' + arrow.left + ' glyphicon glyphicon-' + arrow.left + '"></i></th>';
            } else {
                html += '<th></th>';
            }

            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");

            if (this.showDropdowns) {
                var currentMonth = calendar[1][1].month();
                var currentYear = calendar[1][1].year();
                var maxYear = (maxDate && maxDate.year()) || (currentYear + 5);
                var minYear = (minDate && minDate.year()) || (currentYear - 50);
                var inMinYear = currentYear == minYear;
                var inMaxYear = currentYear == maxYear;

                var monthHtml = '<select class="monthselect">';
                for (var m = 0; m < 12; m++) {
                    if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
                        monthHtml += "<option value='" + m + "'" +
                            (m === currentMonth ? " selected='selected'" : "") +
                            ">" + this.locale.monthNames[m] + "</option>";
                    } else {
                        monthHtml += "<option value='" + m + "'" +
                            (m === currentMonth ? " selected='selected'" : "") +
                            " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
                    }
                }
                monthHtml += "</select>";

                var yearHtml = '<select class="yearselect">';
                for (var y = minYear; y <= maxYear; y++) {
                    yearHtml += '<option value="' + y + '"' +
                        (y === currentYear ? ' selected="selected"' : '') +
                        '>' + y + '</option>';
                }
                yearHtml += '</select>';

                dateHtml = monthHtml + yearHtml;
            }

            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
                html += '<th class="next available"><i class="fa fa-' + arrow.right + ' glyphicon glyphicon-' + arrow.right + '"></i></th>';
            } else {
                html += '<th></th>';
            }

            html += '</tr>';
            html += '<tr>';

            // add week number label
            if (this.showWeekNumbers || this.showISOWeekNumbers)
                html += '<th class="week">' + this.locale.weekLabel + '</th>';

            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
                html += '<th>' + dayOfWeek + '</th>';
            });

            html += '</tr>';
            html += '</thead>';
            html += '<tbody>';

            //adjust maxDate to reflect the dateLimit setting in order to
            //grey out end dates beyond the dateLimit
            if (this.endDate == null && this.dateLimit) {
                var maxLimit = this.startDate.clone().add(this.dateLimit).endOf('day');
                if (!maxDate || maxLimit.isBefore(maxDate)) {
                    maxDate = maxLimit;
                }
            }

            for (var row = 0; row < 6; row++) {
                html += '<tr>';

                // add week number
                if (this.showWeekNumbers)
                    html += '<td class="week">' + calendar[row][0].week() + '</td>';
                else if (this.showISOWeekNumbers)
                    html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';

                for (var col = 0; col < 7; col++) {

                    var classes = [];

                    //highlight today's date
                    if (calendar[row][col].isSame(new Date(), "day"))
                        classes.push('today');

                    //highlight weekends
                    if (calendar[row][col].isoWeekday() > 5)
                        classes.push('weekend');

                    //grey out the dates in other months displayed at beginning and end of this calendar
                    if (calendar[row][col].month() != calendar[1][1].month())
                        classes.push('off');

                    //don't allow selection of dates before the minimum date
                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
                        classes.push('off', 'disabled');

                    //don't allow selection of dates after the maximum date
                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
                        classes.push('off', 'disabled');

                    //don't allow selection of date if a custom function decides it's invalid
                    if (this.isInvalidDate(calendar[row][col]))
                        classes.push('off', 'disabled');

                    //highlight the currently selected start date
                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
                        classes.push('active', 'start-date');

                    //highlight the currently selected end date
                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
                        classes.push('active', 'end-date');

                    //highlight dates in-between the selected dates
                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
                        classes.push('in-range');

                    //apply custom classes for this date
                    var isCustom = this.isCustomDate(calendar[row][col]);
                    if (isCustom !== false) {
                        if (typeof isCustom === 'string')
                            classes.push(isCustom);
                        else
                            Array.prototype.push.apply(classes, isCustom);
                    }

                    var cname = '', disabled = false;
                    for (var i = 0; i < classes.length; i++) {
                        cname += classes[i] + ' ';
                        if (classes[i] == 'disabled')
                            disabled = true;
                    }
                    if (!disabled)
                        cname += 'available';

                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';

                }
                html += '</tr>';
            }

            html += '</tbody>';
            html += '</table>';

            this.container.find('.calendar.' + side + ' .calendar-table').html(html);

        },

        renderTimePicker: function(side) {

            // Don't bother updating the time picker if it's currently disabled
            // because an end date hasn't been clicked yet
            if (side == 'right' && !this.endDate) return;

            var html, selected, minDate, maxDate = this.maxDate;

            if (this.dateLimit && (!this.maxDate || this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate)))
                maxDate = this.startDate.clone().add(this.dateLimit);

            if (side == 'left') {
                selected = this.startDate.clone();
                minDate = this.minDate;
            } else if (side == 'right') {
                selected = this.endDate.clone();
                minDate = this.startDate;

                //Preserve the time already selected
                var timeSelector = this.container.find('.calendar.right .calendar-time div');
                if (!this.endDate && timeSelector.html() != '') {

                    selected.hour(timeSelector.find('.hourselect option:selected').val() || selected.hour());
                    selected.minute(timeSelector.find('.minuteselect option:selected').val() || selected.minute());
                    selected.second(timeSelector.find('.secondselect option:selected').val() || selected.second());

                    if (!this.timePicker24Hour) {
                        var ampm = timeSelector.find('.ampmselect option:selected').val();
                        if (ampm === 'PM' && selected.hour() < 12)
                            selected.hour(selected.hour() + 12);
                        if (ampm === 'AM' && selected.hour() === 12)
                            selected.hour(0);
                    }

                }

                if (selected.isBefore(this.startDate))
                    selected = this.startDate.clone();

                if (maxDate && selected.isAfter(maxDate))
                    selected = maxDate.clone();

            }

            //
            // hours
            //

            html = '<select class="hourselect">';

            var start = this.timePicker24Hour ? 0 : 1;
            var end = this.timePicker24Hour ? 23 : 12;

            for (var i = start; i <= end; i++) {
                var i_in_24 = i;
                if (!this.timePicker24Hour)
                    i_in_24 = selected.hour() >= 12 ? (i == 12 ? 12 : i + 12) : (i == 12 ? 0 : i);

                var time = selected.clone().hour(i_in_24);
                var disabled = false;
                if (minDate && time.minute(59).isBefore(minDate))
                    disabled = true;
                if (maxDate && time.minute(0).isAfter(maxDate))
                    disabled = true;

                if (i_in_24 == selected.hour() && !disabled) {
                    html += '<option value="' + i + '" selected="selected">' + i + '</option>';
                } else if (disabled) {
                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
                } else {
                    html += '<option value="' + i + '">' + i + '</option>';
                }
            }

            html += '</select> ';

            //
            // minutes
            //

            html += ': <select class="minuteselect">';

            for (var i = 0; i < 60; i += this.timePickerIncrement) {
                var padded = i < 10 ? '0' + i : i;
                var time = selected.clone().minute(i);

                var disabled = false;
                if (minDate && time.second(59).isBefore(minDate))
                    disabled = true;
                if (maxDate && time.second(0).isAfter(maxDate))
                    disabled = true;

                if (selected.minute() == i && !disabled) {
                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                } else if (disabled) {
                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                } else {
                    html += '<option value="' + i + '">' + padded + '</option>';
                }
            }

            html += '</select> ';

            //
            // seconds
            //

            if (this.timePickerSeconds) {
                html += ': <select class="secondselect">';

                for (var i = 0; i < 60; i++) {
                    var padded = i < 10 ? '0' + i : i;
                    var time = selected.clone().second(i);

                    var disabled = false;
                    if (minDate && time.isBefore(minDate))
                        disabled = true;
                    if (maxDate && time.isAfter(maxDate))
                        disabled = true;

                    if (selected.second() == i && !disabled) {
                        html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                    } else if (disabled) {
                        html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                    } else {
                        html += '<option value="' + i + '">' + padded + '</option>';
                    }
                }

                html += '</select> ';
            }

            //
            // AM/PM
            //

            if (!this.timePicker24Hour) {
                html += '<select class="ampmselect">';

                var am_html = '';
                var pm_html = '';

                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
                    am_html = ' disabled="disabled" class="disabled"';

                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
                    pm_html = ' disabled="disabled" class="disabled"';

                if (selected.hour() >= 12) {
                    html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
                } else {
                    html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
                }

                html += '</select>';
            }

            this.container.find('.calendar.' + side + ' .calendar-time div').html(html);

        },

        updateFormInputs: function() {

            //ignore mouse movements while an above-calendar text input has focus
            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
                return;

            this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.locale.format));
            if (this.endDate)
                this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.locale.format));

            if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
                this.container.find('button.applyBtn').removeAttr('disabled');
            } else {
                this.container.find('button.applyBtn').attr('disabled', 'disabled');
            }

        },

        move: function() {
            var parentOffset = { top: 0, left: 0 },
                containerTop;
            var parentRightEdge = $(window).width();
            if (!this.parentEl.is('body')) {
                parentOffset = {
                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
                };
                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
            }

            if (this.drops == 'up')
                containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
            else
                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
            this.container[this.drops == 'up' ? 'addClass' : 'removeClass']('dropup');

            if (this.opens == 'left') {
                this.container.css({
                    top: containerTop,
                    right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
                    left: 'auto'
                });
                if (this.container.offset().left < 0) {
                    this.container.css({
                        right: 'auto',
                        left: 9
                    });
                }
            } else if (this.opens == 'center') {
                this.container.css({
                    top: containerTop,
                    left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
                            - this.container.outerWidth() / 2,
                    right: 'auto'
                });
                if (this.container.offset().left < 0) {
                    this.container.css({
                        right: 'auto',
                        left: 9
                    });
                }
            } else {
                this.container.css({
                    top: containerTop,
                    left: this.element.offset().left - parentOffset.left,
                    right: 'auto'
                });
                if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
                    this.container.css({
                        left: 'auto',
                        right: 0
                    });
                }
            }
        },

        show: function(e) {
            if (this.isShowing) return;

            // Create a click proxy that is private to this instance of datepicker, for unbinding
            this._outsideClickProxy = $.proxy(function(e) { this.outsideClick(e); }, this);

            // Bind global datepicker mousedown for hiding and
            $(document)
              .on('mousedown.daterangepicker', this._outsideClickProxy)
              // also support mobile devices
              .on('touchend.daterangepicker', this._outsideClickProxy)
              // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
              .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
              // and also close when focus changes to outside the picker (eg. tabbing between controls)
              .on('focusin.daterangepicker', this._outsideClickProxy);

            // Reposition the picker if the window is resized while it's open
            $(window).on('resize.daterangepicker', $.proxy(function(e) { this.move(e); }, this));

            this.oldStartDate = this.startDate.clone();
            this.oldEndDate = this.endDate.clone();
            this.previousRightTime = this.endDate.clone();

            this.updateView();
            this.container.show();
            this.move();
            this.element.trigger('show.daterangepicker', this);
            this.isShowing = true;
        },

        hide: function(e) {
            if (!this.isShowing) return;

            //incomplete date selection, revert to last values
            if (!this.endDate) {
                this.startDate = this.oldStartDate.clone();
                this.endDate = this.oldEndDate.clone();
            }

            //if a new date range was selected, invoke the user callback function
            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
                this.callback(this.startDate, this.endDate, this.chosenLabel);

            //if picker is attached to a text input, update it
            this.updateElement();

            $(document).off('.daterangepicker');
            $(window).off('.daterangepicker');
            this.container.hide();
            this.element.trigger('hide.daterangepicker', this);
            this.isShowing = false;
        },

        toggle: function(e) {
            if (this.isShowing) {
                this.hide();
            } else {
                this.show();
            }
        },

        outsideClick: function(e) {
            var target = $(e.target);
            // if the page is clicked anywhere except within the daterangerpicker/button
            // itself then call this.hide()
            if (
                // ie modal dialog fix
                e.type == "focusin" ||
                target.closest(this.element).length ||
                target.closest(this.container).length ||
                target.closest('.calendar-table').length
                ) return;
            this.hide();
        },

        showCalendars: function() {
            this.container.addClass('show-calendar');
            this.move();
            this.element.trigger('showCalendar.daterangepicker', this);
        },

        hideCalendars: function() {
            this.container.removeClass('show-calendar');
            this.element.trigger('hideCalendar.daterangepicker', this);
        },

        hoverRange: function(e) {

            //ignore mouse movements while an above-calendar text input has focus
            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
                return;

            var label = e.target.getAttribute('data-range-key');

            if (label == this.locale.customRangeLabel) {
                this.updateView();
            } else {
                var dates = this.ranges[label];
                this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.locale.format));
                this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.locale.format));
            }

        },

        clickRange: function(e) {
            var label = e.target.getAttribute('data-range-key');
            this.chosenLabel = label;
            if (label == this.locale.customRangeLabel) {
                this.showCalendars();
            } else {
                var dates = this.ranges[label];
                this.startDate = dates[0];
                this.endDate = dates[1];

                if (!this.timePicker) {
                    this.startDate.startOf('day');
                    this.endDate.endOf('day');
                }

                if (!this.alwaysShowCalendars)
                    this.hideCalendars();
                this.clickApply();
            }
        },

        clickPrev: function(e) {
            var cal = $(e.target).parents('.calendar');
            if (cal.hasClass('left')) {
                this.leftCalendar.month.subtract(1, 'month');
                if (this.linkedCalendars)
                    this.rightCalendar.month.subtract(1, 'month');
            } else {
                this.rightCalendar.month.subtract(1, 'month');
            }
            this.updateCalendars();
        },

        clickNext: function(e) {
            var cal = $(e.target).parents('.calendar');
            if (cal.hasClass('left')) {
                this.leftCalendar.month.add(1, 'month');
            } else {
                this.rightCalendar.month.add(1, 'month');
                if (this.linkedCalendars)
                    this.leftCalendar.month.add(1, 'month');
            }
            this.updateCalendars();
        },

        hoverDate: function(e) {

            //ignore mouse movements while an above-calendar text input has focus
            //if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
            //    return;

            //ignore dates that can't be selected
            if (!$(e.target).hasClass('available')) return;

            //have the text inputs above calendars reflect the date being hovered over
            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

            if (this.endDate && !this.container.find('input[name=daterangepicker_start]').is(":focus")) {
                this.container.find('input[name=daterangepicker_start]').val(date.format(this.locale.format));
            } else if (!this.endDate && !this.container.find('input[name=daterangepicker_end]').is(":focus")) {
                this.container.find('input[name=daterangepicker_end]').val(date.format(this.locale.format));
            }

            //highlight the dates between the start date and the date being hovered as a potential end date
            var leftCalendar = this.leftCalendar;
            var rightCalendar = this.rightCalendar;
            var startDate = this.startDate;
            if (!this.endDate) {
                this.container.find('.calendar td').each(function(index, el) {

                    //skip week numbers, only look at dates
                    if ($(el).hasClass('week')) return;

                    var title = $(el).attr('data-title');
                    var row = title.substr(1, 1);
                    var col = title.substr(3, 1);
                    var cal = $(el).parents('.calendar');
                    var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];

                    if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
                        $(el).addClass('in-range');
                    } else {
                        $(el).removeClass('in-range');
                    }

                });
            }

        },

        clickDate: function(e) {

            if (!$(e.target).hasClass('available')) return;

            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

            //
            // this function needs to do a few things:
            // * alternate between selecting a start and end date for the range,
            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
            // * if autoapply is enabled, and an end date was chosen, apply the selection
            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
            //

            if (this.endDate || date.isBefore(this.startDate, 'day')) { //picking start
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.endDate = null;
                this.setStartDate(date.clone());
            } else if (!this.endDate && date.isBefore(this.startDate)) {
                //special case: clicking the same date for start/end,
                //but the time of the end date is before the start date
                this.setEndDate(this.startDate.clone());
            } else { // picking end
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.setEndDate(date.clone());
                if (this.autoApply) {
                  this.calculateChosenLabel();
                  this.clickApply();
                }
            }

            if (this.singleDatePicker) {
                this.setEndDate(this.startDate);
                if (!this.timePicker)
                    this.clickApply();
            }

            this.updateView();

        },

        calculateChosenLabel: function() {
          var customRange = true;
          var i = 0;
          for (var range in this.ranges) {
              if (this.timePicker) {
                  if (this.startDate.isSame(this.ranges[range][0]) && this.endDate.isSame(this.ranges[range][1])) {
                      customRange = false;
                      this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
                      break;
                  }
              } else {
                  //ignore times when comparing dates if time picker is not enabled
                  if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
                      customRange = false;
                      this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
                      break;
                  }
              }
              i++;
          }
          if (customRange) {
              this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
              this.showCalendars();
          }
        },

        clickApply: function(e) {
            this.hide();
            this.element.trigger('apply.daterangepicker', this);
        },

        clickCancel: function(e) {
            this.startDate = this.oldStartDate;
            this.endDate = this.oldEndDate;
            this.hide();
            this.element.trigger('cancel.daterangepicker', this);
        },

        monthOrYearChanged: function(e) {
            var isLeft = $(e.target).closest('.calendar').hasClass('left'),
                leftOrRight = isLeft ? 'left' : 'right',
                cal = this.container.find('.calendar.'+leftOrRight);

            // Month must be Number for new moment versions
            var month = parseInt(cal.find('.monthselect').val(), 10);
            var year = cal.find('.yearselect').val();

            if (!isLeft) {
                if (year < this.startDate.year() || (year == this.startDate.year() && month < this.startDate.month())) {
                    month = this.startDate.month();
                    year = this.startDate.year();
                }
            }

            if (this.minDate) {
                if (year < this.minDate.year() || (year == this.minDate.year() && month < this.minDate.month())) {
                    month = this.minDate.month();
                    year = this.minDate.year();
                }
            }

            if (this.maxDate) {
                if (year > this.maxDate.year() || (year == this.maxDate.year() && month > this.maxDate.month())) {
                    month = this.maxDate.month();
                    year = this.maxDate.year();
                }
            }

            if (isLeft) {
                this.leftCalendar.month.month(month).year(year);
                if (this.linkedCalendars)
                    this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
            } else {
                this.rightCalendar.month.month(month).year(year);
                if (this.linkedCalendars)
                    this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
            }
            this.updateCalendars();
        },

        timeChanged: function(e) {

            var cal = $(e.target).closest('.calendar'),
                isLeft = cal.hasClass('left');

            var hour = parseInt(cal.find('.hourselect').val(), 10);
            var minute = parseInt(cal.find('.minuteselect').val(), 10);
            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;

            if (!this.timePicker24Hour) {
                var ampm = cal.find('.ampmselect').val();
                if (ampm === 'PM' && hour < 12)
                    hour += 12;
                if (ampm === 'AM' && hour === 12)
                    hour = 0;
            }

            if (isLeft) {
                var start = this.startDate.clone();
                start.hour(hour);
                start.minute(minute);
                start.second(second);
                this.setStartDate(start);
                if (this.singleDatePicker) {
                    this.endDate = this.startDate.clone();
                } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
                    this.setEndDate(start.clone());
                }
            } else if (this.endDate) {
                var end = this.endDate.clone();
                end.hour(hour);
                end.minute(minute);
                end.second(second);
                this.setEndDate(end);
            }

            //update the calendars so all clickable dates reflect the new time component
            this.updateCalendars();

            //update the form inputs above the calendars with the new time
            this.updateFormInputs();

            //re-render the time pickers because changing one selection can affect what's enabled in another
            this.renderTimePicker('left');
            this.renderTimePicker('right');

        },

        formInputsChanged: function(e) {
            var isRight = $(e.target).closest('.calendar').hasClass('right');
            var start = moment(this.container.find('input[name="daterangepicker_start"]').val(), this.locale.format);
            var end = moment(this.container.find('input[name="daterangepicker_end"]').val(), this.locale.format);

            if (start.isValid() && end.isValid()) {

                if (isRight && end.isBefore(start))
                    start = end.clone();

                this.setStartDate(start);
                this.setEndDate(end);

                if (isRight) {
                    this.container.find('input[name="daterangepicker_start"]').val(this.startDate.format(this.locale.format));
                } else {
                    this.container.find('input[name="daterangepicker_end"]').val(this.endDate.format(this.locale.format));
                }

            }

            this.updateView();
        },

        formInputsFocused: function(e) {

            // Highlight the focused input
            this.container.find('input[name="daterangepicker_start"], input[name="daterangepicker_end"]').removeClass('active');
            $(e.target).addClass('active');

            // Set the state such that if the user goes back to using a mouse, 
            // the calendars are aware we're selecting the end of the range, not
            // the start. This allows someone to edit the end of a date range without
            // re-selecting the beginning, by clicking on the end date input then
            // using the calendar.
            var isRight = $(e.target).closest('.calendar').hasClass('right');
            if (isRight) {
                this.endDate = null;
                this.setStartDate(this.startDate.clone());
                this.updateView();
            }

        },

        formInputsBlurred: function(e) {

            // this function has one purpose right now: if you tab from the first
            // text input to the second in the UI, the endDate is nulled so that
            // you can click another, but if you tab out without clicking anything
            // or changing the input value, the old endDate should be retained

            if (!this.endDate) {
                var val = this.container.find('input[name="daterangepicker_end"]').val();
                var end = moment(val, this.locale.format);
                if (end.isValid()) {
                    this.setEndDate(end);
                    this.updateView();
                }
            }

        },

        elementChanged: function() {
            if (!this.element.is('input')) return;
            if (!this.element.val().length) return;
            if (this.element.val().length < this.locale.format.length) return;

            var dateString = this.element.val().split(this.locale.separator),
                start = null,
                end = null;

            if (dateString.length === 2) {
                start = moment(dateString[0], this.locale.format);
                end = moment(dateString[1], this.locale.format);
            }

            if (this.singleDatePicker || start === null || end === null) {
                start = moment(this.element.val(), this.locale.format);
                end = start;
            }

            if (!start.isValid() || !end.isValid()) return;

            this.setStartDate(start);
            this.setEndDate(end);
            this.updateView();
        },

        keydown: function(e) {
            //hide on tab or enter
            if ((e.keyCode === 9) || (e.keyCode === 13)) {
                this.hide();
            }
        },

        updateElement: function() {
            if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
                this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
                this.element.trigger('change');
            } else if (this.element.is('input') && this.autoUpdateInput) {
                this.element.val(this.startDate.format(this.locale.format));
                this.element.trigger('change');
            }
        },

        remove: function() {
            this.container.remove();
            this.element.off('.daterangepicker');
            this.element.removeData();
        }

    };

    $.fn.daterangepicker = function(options, callback) {
        this.each(function() {
            var el = $(this);
            if (el.data('daterangepicker'))
                el.data('daterangepicker').remove();
            el.data('daterangepicker', new DateRangePicker(el, options, callback));
        });
        return this;
    };

    return DateRangePicker;

}));


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports.css = __webpack_require__ (2912);
module.exports.js = __webpack_require__ (635);


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__ (648);
__webpack_require__ (638);
__webpack_require__ (639);
__webpack_require__ (640);
__webpack_require__ (641);
__webpack_require__ (642);
__webpack_require__ (643);
__webpack_require__ (647);
__webpack_require__ (644);
__webpack_require__ (645);
__webpack_require__ (646);
__webpack_require__ (637);


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

// eslint-disable-next-line import/no-webpack-loader-syntax
module.exports = __webpack_require__(634);


/***/ }),
/* 637 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.7'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);


/***/ }),
/* 638 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.7'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector === '#' ? [] : selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);


/***/ }),
/* 639 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);


/***/ }),
/* 640 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.7'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.7'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);


/***/ }),
/* 642 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.7'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);


/***/ }),
/* 643 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);


/***/ }),
/* 644 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);


/***/ }),
/* 645 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.7'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);


/***/ }),
/* 646 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.7'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);


/***/ }),
/* 647 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);


/***/ }),
/* 648 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
  * bootstrap-switch - Turn checkboxes and radio buttons into toggle switches.
  *
  * @version v3.3.3
  * @homepage http://www.bootstrap-switch.org
  * @author Mattia Larentis <mattia@larentis.eu> (http://larentis.eu)
  * @license Apache-2.0
  */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function ($, window) {
  var BootstrapSwitch = function () {
    function BootstrapSwitch(element) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, BootstrapSwitch);

      this.$element = $(element);
      this.options = $.extend({}, $.fn.bootstrapSwitch.defaults, this._getElementOptions(), options);
      this.prevOptions = {};
      this.$wrapper = $('<div>', {
        class: function _class() {
          var classes = [];
          classes.push(_this.options.state ? 'on' : 'off');
          if (_this.options.size) {
            classes.push(_this.options.size);
          }
          if (_this.options.disabled) {
            classes.push('disabled');
          }
          if (_this.options.readonly) {
            classes.push('readonly');
          }
          if (_this.options.indeterminate) {
            classes.push('indeterminate');
          }
          if (_this.options.inverse) {
            classes.push('inverse');
          }
          if (_this.$element.attr('id')) {
            classes.push('id-' + _this.$element.attr('id'));
          }
          return classes.map(_this._getClass.bind(_this)).concat([_this.options.baseClass], _this._getClasses(_this.options.wrapperClass)).join(' ');
        }
      });
      this.$container = $('<div>', { class: this._getClass('container') });
      this.$on = $('<span>', {
        html: this.options.onText,
        class: this._getClass('handle-on') + ' ' + this._getClass(this.options.onColor)
      });
      this.$off = $('<span>', {
        html: this.options.offText,
        class: this._getClass('handle-off') + ' ' + this._getClass(this.options.offColor)
      });
      this.$label = $('<span>', {
        html: this.options.labelText,
        class: this._getClass('label')
      });

      this.$element.on('init.bootstrapSwitch', this.options.onInit.bind(this, element));
      this.$element.on('switchChange.bootstrapSwitch', function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (_this.options.onSwitchChange.apply(element, args) === false) {
          if (_this.$element.is(':radio')) {
            $('[name="' + _this.$element.attr('name') + '"]').trigger('previousState.bootstrapSwitch', true);
          } else {
            _this.$element.trigger('previousState.bootstrapSwitch', true);
          }
        }
      });

      this.$container = this.$element.wrap(this.$container).parent();
      this.$wrapper = this.$container.wrap(this.$wrapper).parent();
      this.$element.before(this.options.inverse ? this.$off : this.$on).before(this.$label).before(this.options.inverse ? this.$on : this.$off);

      if (this.options.indeterminate) {
        this.$element.prop('indeterminate', true);
      }

      this._init();
      this._elementHandlers();
      this._handleHandlers();
      this._labelHandlers();
      this._formHandler();
      this._externalLabelHandler();
      this.$element.trigger('init.bootstrapSwitch', this.options.state);
    }

    _createClass(BootstrapSwitch, [{
      key: 'setPrevOptions',
      value: function setPrevOptions() {
        this.prevOptions = Object.assign({}, this.options);
      }
    }, {
      key: 'state',
      value: function state(value, skip) {
        if (typeof value === 'undefined') {
          return this.options.state;
        }
        if (this.options.disabled || this.options.readonly || this.options.state && !this.options.radioAllOff && this.$element.is(':radio')) {
          return this.$element;
        }
        if (this.$element.is(':radio')) {
          $('[name="' + this.$element.attr('name') + '"]').trigger('setPreviousOptions.bootstrapSwitch');
        } else {
          this.$element.trigger('setPreviousOptions.bootstrapSwitch');
        }
        if (this.options.indeterminate) {
          this.indeterminate(false);
        }
        this.$element.prop('checked', Boolean(value)).trigger('change.bootstrapSwitch', skip);
        return this.$element;
      }
    }, {
      key: 'toggleState',
      value: function toggleState(skip) {
        if (this.options.disabled || this.options.readonly) {
          return this.$element;
        }
        if (this.options.indeterminate) {
          this.indeterminate(false);
          return this.state(true);
        } else {
          return this.$element.prop('checked', !this.options.state).trigger('change.bootstrapSwitch', skip);
        }
      }
    }, {
      key: 'size',
      value: function size(value) {
        if (typeof value === 'undefined') {
          return this.options.size;
        }
        if (this.options.size != null) {
          this.$wrapper.removeClass(this._getClass(this.options.size));
        }
        if (value) {
          this.$wrapper.addClass(this._getClass(value));
        }
        this._width();
        this._containerPosition();
        this.options.size = value;
        return this.$element;
      }
    }, {
      key: 'animate',
      value: function animate(value) {
        if (typeof value === 'undefined') {
          return this.options.animate;
        }
        if (this.options.animate === Boolean(value)) {
          return this.$element;
        }
        return this.toggleAnimate();
      }
    }, {
      key: 'toggleAnimate',
      value: function toggleAnimate() {
        this.options.animate = !this.options.animate;
        this.$wrapper.toggleClass(this._getClass('animate'));
        return this.$element;
      }
    }, {
      key: 'disabled',
      value: function disabled(value) {
        if (typeof value === 'undefined') {
          return this.options.disabled;
        }
        if (this.options.disabled === Boolean(value)) {
          return this.$element;
        }
        return this.toggleDisabled();
      }
    }, {
      key: 'toggleDisabled',
      value: function toggleDisabled() {
        this.options.disabled = !this.options.disabled;
        this.$element.prop('disabled', this.options.disabled);
        this.$wrapper.toggleClass(this._getClass('disabled'));
        return this.$element;
      }
    }, {
      key: 'readonly',
      value: function readonly(value) {
        if (typeof value === 'undefined') {
          return this.options.readonly;
        }
        if (this.options.readonly === Boolean(value)) {
          return this.$element;
        }
        return this.toggleReadonly();
      }
    }, {
      key: 'toggleReadonly',
      value: function toggleReadonly() {
        this.options.readonly = !this.options.readonly;
        this.$element.prop('readonly', this.options.readonly);
        this.$wrapper.toggleClass(this._getClass('readonly'));
        return this.$element;
      }
    }, {
      key: 'indeterminate',
      value: function indeterminate(value) {
        if (typeof value === 'undefined') {
          return this.options.indeterminate;
        }
        if (this.options.indeterminate === Boolean(value)) {
          return this.$element;
        }
        return this.toggleIndeterminate();
      }
    }, {
      key: 'toggleIndeterminate',
      value: function toggleIndeterminate() {
        this.options.indeterminate = !this.options.indeterminate;
        this.$element.prop('indeterminate', this.options.indeterminate);
        this.$wrapper.toggleClass(this._getClass('indeterminate'));
        this._containerPosition();
        return this.$element;
      }
    }, {
      key: 'inverse',
      value: function inverse(value) {
        if (typeof value === 'undefined') {
          return this.options.inverse;
        }
        if (this.options.inverse === Boolean(value)) {
          return this.$element;
        }
        return this.toggleInverse();
      }
    }, {
      key: 'toggleInverse',
      value: function toggleInverse() {
        this.$wrapper.toggleClass(this._getClass('inverse'));
        var $on = this.$on.clone(true);
        var $off = this.$off.clone(true);
        this.$on.replaceWith($off);
        this.$off.replaceWith($on);
        this.$on = $off;
        this.$off = $on;
        this.options.inverse = !this.options.inverse;
        return this.$element;
      }
    }, {
      key: 'onColor',
      value: function onColor(value) {
        if (typeof value === 'undefined') {
          return this.options.onColor;
        }
        if (this.options.onColor) {
          this.$on.removeClass(this._getClass(this.options.onColor));
        }
        this.$on.addClass(this._getClass(value));
        this.options.onColor = value;
        return this.$element;
      }
    }, {
      key: 'offColor',
      value: function offColor(value) {
        if (typeof value === 'undefined') {
          return this.options.offColor;
        }
        if (this.options.offColor) {
          this.$off.removeClass(this._getClass(this.options.offColor));
        }
        this.$off.addClass(this._getClass(value));
        this.options.offColor = value;
        return this.$element;
      }
    }, {
      key: 'onText',
      value: function onText(value) {
        if (typeof value === 'undefined') {
          return this.options.onText;
        }
        this.$on.html(value);
        this._width();
        this._containerPosition();
        this.options.onText = value;
        return this.$element;
      }
    }, {
      key: 'offText',
      value: function offText(value) {
        if (typeof value === 'undefined') {
          return this.options.offText;
        }
        this.$off.html(value);
        this._width();
        this._containerPosition();
        this.options.offText = value;
        return this.$element;
      }
    }, {
      key: 'labelText',
      value: function labelText(value) {
        if (typeof value === 'undefined') {
          return this.options.labelText;
        }
        this.$label.html(value);
        this._width();
        this.options.labelText = value;
        return this.$element;
      }
    }, {
      key: 'handleWidth',
      value: function handleWidth(value) {
        if (typeof value === 'undefined') {
          return this.options.handleWidth;
        }
        this.options.handleWidth = value;
        this._width();
        this._containerPosition();
        return this.$element;
      }
    }, {
      key: 'labelWidth',
      value: function labelWidth(value) {
        if (typeof value === 'undefined') {
          return this.options.labelWidth;
        }
        this.options.labelWidth = value;
        this._width();
        this._containerPosition();
        return this.$element;
      }
    }, {
      key: 'baseClass',
      value: function baseClass(value) {
        return this.options.baseClass;
      }
    }, {
      key: 'wrapperClass',
      value: function wrapperClass(value) {
        if (typeof value === 'undefined') {
          return this.options.wrapperClass;
        }
        if (!value) {
          value = $.fn.bootstrapSwitch.defaults.wrapperClass;
        }
        this.$wrapper.removeClass(this._getClasses(this.options.wrapperClass).join(' '));
        this.$wrapper.addClass(this._getClasses(value).join(' '));
        this.options.wrapperClass = value;
        return this.$element;
      }
    }, {
      key: 'radioAllOff',
      value: function radioAllOff(value) {
        if (typeof value === 'undefined') {
          return this.options.radioAllOff;
        }
        var val = Boolean(value);
        if (this.options.radioAllOff === val) {
          return this.$element;
        }
        this.options.radioAllOff = val;
        return this.$element;
      }
    }, {
      key: 'onInit',
      value: function onInit(value) {
        if (typeof value === 'undefined') {
          return this.options.onInit;
        }
        if (!value) {
          value = $.fn.bootstrapSwitch.defaults.onInit;
        }
        this.options.onInit = value;
        return this.$element;
      }
    }, {
      key: 'onSwitchChange',
      value: function onSwitchChange(value) {
        if (typeof value === 'undefined') {
          return this.options.onSwitchChange;
        }
        if (!value) {
          value = $.fn.bootstrapSwitch.defaults.onSwitchChange;
        }
        this.options.onSwitchChange = value;
        return this.$element;
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        var $form = this.$element.closest('form');
        if ($form.length) {
          $form.off('reset.bootstrapSwitch').removeData('bootstrap-switch');
        }
        this.$container.children().not(this.$element).remove();
        this.$element.unwrap().unwrap().off('.bootstrapSwitch').removeData('bootstrap-switch');
        return this.$element;
      }
    }, {
      key: '_getElementOptions',
      value: function _getElementOptions() {
        return {
          state: this.$element.is(':checked'),
          size: this.$element.data('size'),
          animate: this.$element.data('animate'),
          disabled: this.$element.is(':disabled'),
          readonly: this.$element.is('[readonly]'),
          indeterminate: this.$element.data('indeterminate'),
          inverse: this.$element.data('inverse'),
          radioAllOff: this.$element.data('radio-all-off'),
          onColor: this.$element.data('on-color'),
          offColor: this.$element.data('off-color'),
          onText: this.$element.data('on-text'),
          offText: this.$element.data('off-text'),
          labelText: this.$element.data('label-text'),
          handleWidth: this.$element.data('handle-width'),
          labelWidth: this.$element.data('label-width'),
          baseClass: this.$element.data('base-class'),
          wrapperClass: this.$element.data('wrapper-class')
        };
      }
    }, {
      key: '_width',
      value: function _width() {
        var _this2 = this;

        var $handles = this.$on.add(this.$off).add(this.$label).css('width', '');
        var handleWidth = void 0;
        if (this.options.handleWidth === 'auto') {
          handleWidth = Math.round(Math.max(this.$on.width(), this.$off.width()));
        } else {
          handleWidth = this.options.handleWidth;
        }
        $handles.width(handleWidth);
        this.$label.width(function (index, width) {
          if (_this2.options.labelWidth !== 'auto') {
            return _this2.options.labelWidth;
          }
          if (width < handleWidth) {
            return handleWidth;
          }
          return width;
        });
        this._handleWidth = this.$on.outerWidth();
        this._labelWidth = this.$label.outerWidth();
        this.$container.width(this._handleWidth * 2 + this._labelWidth);
        return this.$wrapper.width(this._handleWidth + this._labelWidth);
      }
    }, {
      key: '_containerPosition',
      value: function _containerPosition() {
        var _this3 = this;

        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.state;
        var callback = arguments[1];

        this.$container.css('margin-left', function () {
          var values = [0, '-' + _this3._handleWidth + 'px'];
          if (_this3.options.indeterminate) {
            return '-' + _this3._handleWidth / 2 + 'px';
          }
          if (state) {
            if (_this3.options.inverse) {
              return values[1];
            } else {
              return values[0];
            }
          } else {
            if (_this3.options.inverse) {
              return values[0];
            } else {
              return values[1];
            }
          }
        });
      }
    }, {
      key: '_init',
      value: function _init() {
        var _this4 = this;

        var init = function init() {
          _this4.setPrevOptions();
          _this4._width();
          _this4._containerPosition();
          setTimeout(function () {
            if (_this4.options.animate) {
              return _this4.$wrapper.addClass(_this4._getClass('animate'));
            }
          }, 50);
        };
        if (this.$wrapper.is(':visible')) {
          init();
          return;
        }
        var initInterval = window.setInterval(function () {
          if (_this4.$wrapper.is(':visible')) {
            init();
            return window.clearInterval(initInterval);
          }
        }, 50);
      }
    }, {
      key: '_elementHandlers',
      value: function _elementHandlers() {
        var _this5 = this;

        return this.$element.on({
          'setPreviousOptions.bootstrapSwitch': this.setPrevOptions.bind(this),

          'previousState.bootstrapSwitch': function previousStateBootstrapSwitch() {
            _this5.options = _this5.prevOptions;
            if (_this5.options.indeterminate) {
              _this5.$wrapper.addClass(_this5._getClass('indeterminate'));
            }
            _this5.$element.prop('checked', _this5.options.state).trigger('change.bootstrapSwitch', true);
          },

          'change.bootstrapSwitch': function changeBootstrapSwitch(event, skip) {
            event.preventDefault();
            event.stopImmediatePropagation();
            var state = _this5.$element.is(':checked');
            _this5._containerPosition(state);
            if (state === _this5.options.state) {
              return;
            }
            _this5.options.state = state;
            _this5.$wrapper.toggleClass(_this5._getClass('off')).toggleClass(_this5._getClass('on'));
            if (!skip) {
              if (_this5.$element.is(':radio')) {
                $('[name="' + _this5.$element.attr('name') + '"]').not(_this5.$element).prop('checked', false).trigger('change.bootstrapSwitch', true);
              }
              _this5.$element.trigger('switchChange.bootstrapSwitch', [state]);
            }
          },

          'focus.bootstrapSwitch': function focusBootstrapSwitch(event) {
            event.preventDefault();
            _this5.$wrapper.addClass(_this5._getClass('focused'));
          },

          'blur.bootstrapSwitch': function blurBootstrapSwitch(event) {
            event.preventDefault();
            _this5.$wrapper.removeClass(_this5._getClass('focused'));
          },

          'keydown.bootstrapSwitch': function keydownBootstrapSwitch(event) {
            if (!event.which || _this5.options.disabled || _this5.options.readonly) {
              return;
            }
            if (event.which === 37 || event.which === 39) {
              event.preventDefault();
              event.stopImmediatePropagation();
              _this5.state(event.which === 39);
            }
          }
        });
      }
    }, {
      key: '_handleHandlers',
      value: function _handleHandlers() {
        var _this6 = this;

        this.$on.on('click.bootstrapSwitch', function (event) {
          event.preventDefault();
          event.stopPropagation();
          _this6.state(false);
          return _this6.$element.trigger('focus.bootstrapSwitch');
        });
        return this.$off.on('click.bootstrapSwitch', function (event) {
          event.preventDefault();
          event.stopPropagation();
          _this6.state(true);
          return _this6.$element.trigger('focus.bootstrapSwitch');
        });
      }
    }, {
      key: '_labelHandlers',
      value: function _labelHandlers() {
        var _this7 = this;

        var handlers = {
          click: function click(event) {
            event.stopPropagation();
          },


          'mousedown.bootstrapSwitch touchstart.bootstrapSwitch': function mousedownBootstrapSwitchTouchstartBootstrapSwitch(event) {
            if (_this7._dragStart || _this7.options.disabled || _this7.options.readonly) {
              return;
            }
            event.preventDefault();
            event.stopPropagation();
            _this7._dragStart = (event.pageX || event.originalEvent.touches[0].pageX) - parseInt(_this7.$container.css('margin-left'), 10);
            if (_this7.options.animate) {
              _this7.$wrapper.removeClass(_this7._getClass('animate'));
            }
            _this7.$element.trigger('focus.bootstrapSwitch');
          },

          'mousemove.bootstrapSwitch touchmove.bootstrapSwitch': function mousemoveBootstrapSwitchTouchmoveBootstrapSwitch(event) {
            if (_this7._dragStart == null) {
              return;
            }
            var difference = (event.pageX || event.originalEvent.touches[0].pageX) - _this7._dragStart;
            event.preventDefault();
            if (difference < -_this7._handleWidth || difference > 0) {
              return;
            }
            _this7._dragEnd = difference;
            _this7.$container.css('margin-left', _this7._dragEnd + 'px');
          },

          'mouseup.bootstrapSwitch touchend.bootstrapSwitch': function mouseupBootstrapSwitchTouchendBootstrapSwitch(event) {
            if (!_this7._dragStart) {
              return;
            }
            event.preventDefault();
            if (_this7.options.animate) {
              _this7.$wrapper.addClass(_this7._getClass('animate'));
            }
            if (_this7._dragEnd) {
              var state = _this7._dragEnd > -(_this7._handleWidth / 2);
              _this7._dragEnd = false;
              _this7.state(_this7.options.inverse ? !state : state);
            } else {
              _this7.state(!_this7.options.state);
            }
            _this7._dragStart = false;
          },

          'mouseleave.bootstrapSwitch': function mouseleaveBootstrapSwitch() {
            _this7.$label.trigger('mouseup.bootstrapSwitch');
          }
        };
        this.$label.on(handlers);
      }
    }, {
      key: '_externalLabelHandler',
      value: function _externalLabelHandler() {
        var _this8 = this;

        var $externalLabel = this.$element.closest('label');
        $externalLabel.on('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (event.target === $externalLabel[0]) {
            _this8.toggleState();
          }
        });
      }
    }, {
      key: '_formHandler',
      value: function _formHandler() {
        var $form = this.$element.closest('form');
        if ($form.data('bootstrap-switch')) {
          return;
        }
        $form.on('reset.bootstrapSwitch', function () {
          window.setTimeout(function () {
            $form.find('input').filter(function () {
              return $(this).data('bootstrap-switch');
            }).each(function () {
              return $(this).bootstrapSwitch('state', this.checked);
            });
          }, 1);
        }).data('bootstrap-switch', true);
      }
    }, {
      key: '_getClass',
      value: function _getClass(name) {
        return this.options.baseClass + '-' + name;
      }
    }, {
      key: '_getClasses',
      value: function _getClasses(classes) {
        if (!$.isArray(classes)) {
          return [this._getClass(classes)];
        }
        return classes.map(this._getClass.bind(this));
      }
    }]);

    return BootstrapSwitch;
  }();

  $.fn.bootstrapSwitch = function (option) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var ret = this;
    this.each(function () {
      var $this = $(this);
      var data = $this.data('bootstrap-switch');
      if (!data) {
        data = new BootstrapSwitch(this, option);
        $this.data('bootstrap-switch', data);
      }
      if (typeof option === 'string') {
        ret = data[option].apply(data, args);
      }
    });
    return ret;
  };
  $.fn.bootstrapSwitch.Constructor = BootstrapSwitch;
  $.fn.bootstrapSwitch.defaults = {
    state: true,
    size: null,
    animate: true,
    disabled: false,
    readonly: false,
    indeterminate: false,
    inverse: false,
    radioAllOff: false,
    onColor: 'primary',
    offColor: 'default',
    onText: 'ON',
    offText: 'OFF',
    labelText: '&nbsp',
    handleWidth: 'auto',
    labelWidth: 'auto',
    baseClass: 'bootstrap-switch',
    wrapperClass: 'wrapper',
    onInit: function onInit() {},
    onSwitchChange: function onSwitchChange() {}
  };
})(__webpack_provided_window_dot_jQuery, window);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.bar=n():(t.britecharts=t.britecharts||{},t.britecharts.bar=n())}(window,(function(){return function(t){var n={};function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:r})},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.t=function(t,n){if(1&n&&(t=e(t)),8&n)return t;if(4&n&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(e.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&n&&"string"!=typeof t)for(var i in t)e.d(r,i,function(n){return t[n]}.bind(null,i));return r},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.p="",e(e.s=94)}([function(t,n,e){"use strict";e.d(n,"a",(function(){return o}));var r=new Date,i=new Date;function o(t,n,e,u){function a(n){return t(n=0===arguments.length?new Date:new Date(+n)),n}return a.floor=function(n){return t(n=new Date(+n)),n},a.ceil=function(e){return t(e=new Date(e-1)),n(e,1),t(e),e},a.round=function(t){var n=a(t),e=a.ceil(t);return t-n<e-t?n:e},a.offset=function(t,e){return n(t=new Date(+t),null==e?1:Math.floor(e)),t},a.range=function(e,r,i){var o,u=[];if(e=a.ceil(e),i=null==i?1:Math.floor(i),!(e<r&&i>0))return u;do{u.push(o=new Date(+e)),n(e,i),t(e)}while(o<e&&e<r);return u},a.filter=function(e){return o((function(n){if(n>=n)for(;t(n),!e(n);)n.setTime(n-1)}),(function(t,r){if(t>=t)if(r<0)for(;++r<=0;)for(;n(t,-1),!e(t););else for(;--r>=0;)for(;n(t,1),!e(t););}))},e&&(a.count=function(n,o){return r.setTime(+n),i.setTime(+o),t(r),t(i),Math.floor(e(r,i))},a.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?a.filter(u?function(n){return u(n)%t==0}:function(n){return a.count(0,n)%t==0}):a:null}),a}},function(t,n,e){"use strict";e.d(n,"d",(function(){return r})),e.d(n,"c",(function(){return i})),e.d(n,"b",(function(){return o})),e.d(n,"a",(function(){return u})),e.d(n,"e",(function(){return a}));var r=1e3,i=6e4,o=36e5,u=864e5,a=6048e5},function(t,n,e){"use strict";e.r(n);var r=function(t,n){return t<n?-1:t>n?1:t>=n?0:NaN},i=function(t){var n;return 1===t.length&&(n=t,t=function(t,e){return r(n(t),e)}),{left:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var o=r+i>>>1;t(n[o],e)<0?r=o+1:i=o}return r},right:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var o=r+i>>>1;t(n[o],e)>0?i=o:r=o+1}return r}}};var o=i(r),u=o.right,a=o.left,c=u,s=function(t,n){null==n&&(n=l);for(var e=0,r=t.length-1,i=t[0],o=new Array(r<0?0:r);e<r;)o[e]=n(i,i=t[++e]);return o};function l(t,n){return[t,n]}var f=function(t,n,e){var r,i,o,u,a=t.length,c=n.length,s=new Array(a*c);for(null==e&&(e=l),r=o=0;r<a;++r)for(u=t[r],i=0;i<c;++i,++o)s[o]=e(u,n[i]);return s},h=function(t,n){return n<t?-1:n>t?1:n>=t?0:NaN},d=function(t){return null===t?NaN:+t},p=function(t,n){var e,r,i=t.length,o=0,u=-1,a=0,c=0;if(null==n)for(;++u<i;)isNaN(e=d(t[u]))||(c+=(r=e-a)*(e-(a+=r/++o)));else for(;++u<i;)isNaN(e=d(n(t[u],u,t)))||(c+=(r=e-a)*(e-(a+=r/++o)));if(o>1)return c/(o-1)},_=function(t,n){var e=p(t,n);return e?Math.sqrt(e):e},g=function(t,n){var e,r,i,o=t.length,u=-1;if(null==n){for(;++u<o;)if(null!=(e=t[u])&&e>=e)for(r=i=e;++u<o;)null!=(e=t[u])&&(r>e&&(r=e),i<e&&(i=e))}else for(;++u<o;)if(null!=(e=n(t[u],u,t))&&e>=e)for(r=i=e;++u<o;)null!=(e=n(t[u],u,t))&&(r>e&&(r=e),i<e&&(i=e));return[r,i]},y=Array.prototype,v=y.slice,m=y.map,x=function(t){return function(){return t}},b=function(t){return t},w=function(t,n,e){t=+t,n=+n,e=(i=arguments.length)<2?(n=t,t=0,1):i<3?1:+e;for(var r=-1,i=0|Math.max(0,Math.ceil((n-t)/e)),o=new Array(i);++r<i;)o[r]=t+r*e;return o},M=Math.sqrt(50),T=Math.sqrt(10),O=Math.sqrt(2),A=function(t,n,e){var r,i,o,u,a=-1;if(e=+e,(t=+t)===(n=+n)&&e>0)return[t];if((r=n<t)&&(i=t,t=n,n=i),0===(u=k(t,n,e))||!isFinite(u))return[];if(u>0)for(t=Math.ceil(t/u),n=Math.floor(n/u),o=new Array(i=Math.ceil(n-t+1));++a<i;)o[a]=(t+a)*u;else for(t=Math.floor(t*u),n=Math.ceil(n*u),o=new Array(i=Math.ceil(t-n+1));++a<i;)o[a]=(t-a)/u;return r&&o.reverse(),o};function k(t,n,e){var r=(n-t)/Math.max(0,e),i=Math.floor(Math.log(r)/Math.LN10),o=r/Math.pow(10,i);return i>=0?(o>=M?10:o>=T?5:o>=O?2:1)*Math.pow(10,i):-Math.pow(10,-i)/(o>=M?10:o>=T?5:o>=O?2:1)}function C(t,n,e){var r=Math.abs(n-t)/Math.max(0,e),i=Math.pow(10,Math.floor(Math.log(r)/Math.LN10)),o=r/i;return o>=M?i*=10:o>=T?i*=5:o>=O&&(i*=2),n<t?-i:i}var S=function(t){return Math.ceil(Math.log(t.length)/Math.LN2)+1},N=function(){var t=b,n=g,e=S;function r(r){var i,o,u=r.length,a=new Array(u);for(i=0;i<u;++i)a[i]=t(r[i],i,r);var s=n(a),l=s[0],f=s[1],h=e(a,l,f);Array.isArray(h)||(h=C(l,f,h),h=w(Math.ceil(l/h)*h,f,h));for(var d=h.length;h[0]<=l;)h.shift(),--d;for(;h[d-1]>f;)h.pop(),--d;var p,_=new Array(d+1);for(i=0;i<=d;++i)(p=_[i]=[]).x0=i>0?h[i-1]:l,p.x1=i<d?h[i]:f;for(i=0;i<u;++i)l<=(o=a[i])&&o<=f&&_[c(h,o,0,d)].push(r[i]);return _}return r.value=function(n){return arguments.length?(t="function"==typeof n?n:x(n),r):t},r.domain=function(t){return arguments.length?(n="function"==typeof t?t:x([t[0],t[1]]),r):n},r.thresholds=function(t){return arguments.length?(e="function"==typeof t?t:Array.isArray(t)?x(v.call(t)):x(t),r):e},r},E=function(t,n,e){if(null==e&&(e=d),r=t.length){if((n=+n)<=0||r<2)return+e(t[0],0,t);if(n>=1)return+e(t[r-1],r-1,t);var r,i=(r-1)*n,o=Math.floor(i),u=+e(t[o],o,t);return u+(+e(t[o+1],o+1,t)-u)*(i-o)}},j=function(t,n,e){return t=m.call(t,d).sort(r),Math.ceil((e-n)/(2*(E(t,.75)-E(t,.25))*Math.pow(t.length,-1/3)))},D=function(t,n,e){return Math.ceil((e-n)/(3.5*_(t)*Math.pow(t.length,-1/3)))},F=function(t,n){var e,r,i=t.length,o=-1;if(null==n){for(;++o<i;)if(null!=(e=t[o])&&e>=e)for(r=e;++o<i;)null!=(e=t[o])&&e>r&&(r=e)}else for(;++o<i;)if(null!=(e=n(t[o],o,t))&&e>=e)for(r=e;++o<i;)null!=(e=n(t[o],o,t))&&e>r&&(r=e);return r},P=function(t,n){var e,r=t.length,i=r,o=-1,u=0;if(null==n)for(;++o<r;)isNaN(e=d(t[o]))?--i:u+=e;else for(;++o<r;)isNaN(e=d(n(t[o],o,t)))?--i:u+=e;if(i)return u/i},L=function(t,n){var e,i=t.length,o=-1,u=[];if(null==n)for(;++o<i;)isNaN(e=d(t[o]))||u.push(e);else for(;++o<i;)isNaN(e=d(n(t[o],o,t)))||u.push(e);return E(u.sort(r),.5)},I=function(t){for(var n,e,r,i=t.length,o=-1,u=0;++o<i;)u+=t[o].length;for(e=new Array(u);--i>=0;)for(n=(r=t[i]).length;--n>=0;)e[--u]=r[n];return e},U=function(t,n){var e,r,i=t.length,o=-1;if(null==n){for(;++o<i;)if(null!=(e=t[o])&&e>=e)for(r=e;++o<i;)null!=(e=t[o])&&r>e&&(r=e)}else for(;++o<i;)if(null!=(e=n(t[o],o,t))&&e>=e)for(r=e;++o<i;)null!=(e=n(t[o],o,t))&&r>e&&(r=e);return r},R=function(t,n){for(var e=n.length,r=new Array(e);e--;)r[e]=t[n[e]];return r},B=function(t,n){if(e=t.length){var e,i,o=0,u=0,a=t[u];for(null==n&&(n=r);++o<e;)(n(i=t[o],a)<0||0!==n(a,a))&&(a=i,u=o);return 0===n(a,a)?u:void 0}},H=function(t,n,e){for(var r,i,o=(null==e?t.length:e)-(n=null==n?0:+n);o;)i=Math.random()*o--|0,r=t[o+n],t[o+n]=t[i+n],t[i+n]=r;return t},q=function(t,n){var e,r=t.length,i=-1,o=0;if(null==n)for(;++i<r;)(e=+t[i])&&(o+=e);else for(;++i<r;)(e=+n(t[i],i,t))&&(o+=e);return o},Y=function(t){if(!(i=t.length))return[];for(var n=-1,e=U(t,z),r=new Array(e);++n<e;)for(var i,o=-1,u=r[n]=new Array(i);++o<i;)u[o]=t[o][n];return r};function z(t){return t.length}var G=function(){return Y(arguments)};e.d(n,"bisect",(function(){return c})),e.d(n,"bisectRight",(function(){return u})),e.d(n,"bisectLeft",(function(){return a})),e.d(n,"ascending",(function(){return r})),e.d(n,"bisector",(function(){return i})),e.d(n,"cross",(function(){return f})),e.d(n,"descending",(function(){return h})),e.d(n,"deviation",(function(){return _})),e.d(n,"extent",(function(){return g})),e.d(n,"histogram",(function(){return N})),e.d(n,"thresholdFreedmanDiaconis",(function(){return j})),e.d(n,"thresholdScott",(function(){return D})),e.d(n,"thresholdSturges",(function(){return S})),e.d(n,"max",(function(){return F})),e.d(n,"mean",(function(){return P})),e.d(n,"median",(function(){return L})),e.d(n,"merge",(function(){return I})),e.d(n,"min",(function(){return U})),e.d(n,"pairs",(function(){return s})),e.d(n,"permute",(function(){return R})),e.d(n,"quantile",(function(){return E})),e.d(n,"range",(function(){return w})),e.d(n,"scan",(function(){return B})),e.d(n,"shuffle",(function(){return H})),e.d(n,"sum",(function(){return q})),e.d(n,"ticks",(function(){return A})),e.d(n,"tickIncrement",(function(){return k})),e.d(n,"tickStep",(function(){return C})),e.d(n,"transpose",(function(){return Y})),e.d(n,"variance",(function(){return p})),e.d(n,"zip",(function(){return G}))},function(t,n,e){"use strict";e.d(n,"g",(function(){return u})),e.d(n,"c",(function(){return a})),e.d(n,"k",(function(){return c})),e.d(n,"m",(function(){return s})),e.d(n,"i",(function(){return l})),e.d(n,"a",(function(){return f})),e.d(n,"e",(function(){return h})),e.d(n,"h",(function(){return d})),e.d(n,"d",(function(){return p})),e.d(n,"l",(function(){return _})),e.d(n,"n",(function(){return g})),e.d(n,"j",(function(){return y})),e.d(n,"b",(function(){return v})),e.d(n,"f",(function(){return m}));var r=e(0),i=e(1);function o(t){return Object(r.a)((function(n){n.setDate(n.getDate()-(n.getDay()+7-t)%7),n.setHours(0,0,0,0)}),(function(t,n){t.setDate(t.getDate()+7*n)}),(function(t,n){return(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*i.c)/i.e}))}var u=o(0),a=o(1),c=o(2),s=o(3),l=o(4),f=o(5),h=o(6),d=u.range,p=a.range,_=c.range,g=s.range,y=l.range,v=f.range,m=h.range},function(t,n,e){"use strict";e.d(n,"g",(function(){return u})),e.d(n,"c",(function(){return a})),e.d(n,"k",(function(){return c})),e.d(n,"m",(function(){return s})),e.d(n,"i",(function(){return l})),e.d(n,"a",(function(){return f})),e.d(n,"e",(function(){return h})),e.d(n,"h",(function(){return d})),e.d(n,"d",(function(){return p})),e.d(n,"l",(function(){return _})),e.d(n,"n",(function(){return g})),e.d(n,"j",(function(){return y})),e.d(n,"b",(function(){return v})),e.d(n,"f",(function(){return m}));var r=e(0),i=e(1);function o(t){return Object(r.a)((function(n){n.setUTCDate(n.getUTCDate()-(n.getUTCDay()+7-t)%7),n.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCDate(t.getUTCDate()+7*n)}),(function(t,n){return(n-t)/i.e}))}var u=o(0),a=o(1),c=o(2),s=o(3),l=o(4),f=o(5),h=o(6),d=u.range,p=a.range,_=c.range,g=s.range,y=l.range,v=f.range,m=h.range},function(t,n,e){"use strict";n.a=function(t,n){return t=+t,n=+n,function(e){return t*(1-e)+n*e}}},function(t,n,e){"use strict";e.r(n);var r=e(12),i=e(32),o=function(t){return Object(i.a)(Object(r.a)(t).call(document.documentElement))},u=0;function a(){return new c}function c(){this._="@"+(++u).toString(36)}c.prototype=a.prototype={constructor:c,get:function(t){for(var n=this._;!(n in t);)if(!(t=t.parentNode))return;return t[n]},set:function(t,n){return t[this._]=n},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}};var s=e(34),l=e(59),f=e(20),h=e(14),d=e(13),p=e(9),_=function(t){return"string"==typeof t?new p.a([document.querySelectorAll(t)],[document.documentElement]):new p.a([null==t?[]:t],p.c)},g=e(19),y=e(33),v=e(35),m=e(60),x=e(22),b=function(t,n){null==n&&(n=Object(x.a)().touches);for(var e=0,r=n?n.length:0,i=new Array(r);e<r;++e)i[e]=Object(d.a)(t,n[e]);return i},w=e(21),M=e(17);e.d(n,"create",(function(){return o})),e.d(n,"creator",(function(){return r.a})),e.d(n,"local",(function(){return a})),e.d(n,"matcher",(function(){return s.a})),e.d(n,"mouse",(function(){return l.a})),e.d(n,"namespace",(function(){return f.a})),e.d(n,"namespaces",(function(){return h.a})),e.d(n,"clientPoint",(function(){return d.a})),e.d(n,"select",(function(){return i.a})),e.d(n,"selectAll",(function(){return _})),e.d(n,"selection",(function(){return p.b})),e.d(n,"selector",(function(){return g.a})),e.d(n,"selectorAll",(function(){return y.a})),e.d(n,"style",(function(){return v.b})),e.d(n,"touch",(function(){return m.a})),e.d(n,"touches",(function(){return b})),e.d(n,"window",(function(){return w.a})),e.d(n,"event",(function(){return M.c})),e.d(n,"customEvent",(function(){return M.a}))},function(t,n,e){"use strict";e.d(n,"a",(function(){return i})),e.d(n,"d",(function(){return o})),e.d(n,"c",(function(){return u})),e.d(n,"e",(function(){return x})),e.d(n,"h",(function(){return M})),e.d(n,"g",(function(){return T})),e.d(n,"b",(function(){return O})),e.d(n,"f",(function(){return E}));var r=e(11);function i(){}var o=.7,u=1/o,a="\\s*([+-]?\\d+)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",s="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",l=/^#([0-9a-f]{3,8})$/,f=new RegExp("^rgb\\("+[a,a,a]+"\\)$"),h=new RegExp("^rgb\\("+[s,s,s]+"\\)$"),d=new RegExp("^rgba\\("+[a,a,a,c]+"\\)$"),p=new RegExp("^rgba\\("+[s,s,s,c]+"\\)$"),_=new RegExp("^hsl\\("+[c,s,s]+"\\)$"),g=new RegExp("^hsla\\("+[c,s,s,c]+"\\)$"),y={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};function v(){return this.rgb().formatHex()}function m(){return this.rgb().formatRgb()}function x(t){var n,e;return t=(t+"").trim().toLowerCase(),(n=l.exec(t))?(e=n[1].length,n=parseInt(n[1],16),6===e?b(n):3===e?new O(n>>8&15|n>>4&240,n>>4&15|240&n,(15&n)<<4|15&n,1):8===e?new O(n>>24&255,n>>16&255,n>>8&255,(255&n)/255):4===e?new O(n>>12&15|n>>8&240,n>>8&15|n>>4&240,n>>4&15|240&n,((15&n)<<4|15&n)/255):null):(n=f.exec(t))?new O(n[1],n[2],n[3],1):(n=h.exec(t))?new O(255*n[1]/100,255*n[2]/100,255*n[3]/100,1):(n=d.exec(t))?w(n[1],n[2],n[3],n[4]):(n=p.exec(t))?w(255*n[1]/100,255*n[2]/100,255*n[3]/100,n[4]):(n=_.exec(t))?S(n[1],n[2]/100,n[3]/100,1):(n=g.exec(t))?S(n[1],n[2]/100,n[3]/100,n[4]):y.hasOwnProperty(t)?b(y[t]):"transparent"===t?new O(NaN,NaN,NaN,0):null}function b(t){return new O(t>>16&255,t>>8&255,255&t,1)}function w(t,n,e,r){return r<=0&&(t=n=e=NaN),new O(t,n,e,r)}function M(t){return t instanceof i||(t=x(t)),t?new O((t=t.rgb()).r,t.g,t.b,t.opacity):new O}function T(t,n,e,r){return 1===arguments.length?M(t):new O(t,n,e,null==r?1:r)}function O(t,n,e,r){this.r=+t,this.g=+n,this.b=+e,this.opacity=+r}function A(){return"#"+C(this.r)+C(this.g)+C(this.b)}function k(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}function C(t){return((t=Math.max(0,Math.min(255,Math.round(t)||0)))<16?"0":"")+t.toString(16)}function S(t,n,e,r){return r<=0?t=n=e=NaN:e<=0||e>=1?t=n=NaN:n<=0&&(t=NaN),new j(t,n,e,r)}function N(t){if(t instanceof j)return new j(t.h,t.s,t.l,t.opacity);if(t instanceof i||(t=x(t)),!t)return new j;if(t instanceof j)return t;var n=(t=t.rgb()).r/255,e=t.g/255,r=t.b/255,o=Math.min(n,e,r),u=Math.max(n,e,r),a=NaN,c=u-o,s=(u+o)/2;return c?(a=n===u?(e-r)/c+6*(e<r):e===u?(r-n)/c+2:(n-e)/c+4,c/=s<.5?u+o:2-u-o,a*=60):c=s>0&&s<1?0:a,new j(a,c,s,t.opacity)}function E(t,n,e,r){return 1===arguments.length?N(t):new j(t,n,e,null==r?1:r)}function j(t,n,e,r){this.h=+t,this.s=+n,this.l=+e,this.opacity=+r}function D(t,n,e){return 255*(t<60?n+(e-n)*t/60:t<180?e:t<240?n+(e-n)*(240-t)/60:n)}Object(r.a)(i,x,{copy:function(t){return Object.assign(new this.constructor,this,t)},displayable:function(){return this.rgb().displayable()},hex:v,formatHex:v,formatHsl:function(){return N(this).formatHsl()},formatRgb:m,toString:m}),Object(r.a)(O,T,Object(r.b)(i,{brighter:function(t){return t=null==t?u:Math.pow(u,t),new O(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?o:Math.pow(o,t),new O(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return-.5<=this.r&&this.r<255.5&&-.5<=this.g&&this.g<255.5&&-.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1},hex:A,formatHex:A,formatRgb:k,toString:k})),Object(r.a)(j,E,Object(r.b)(i,{brighter:function(t){return t=null==t?u:Math.pow(u,t),new j(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?o:Math.pow(o,t),new j(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),n=isNaN(t)||isNaN(this.s)?0:this.s,e=this.l,r=e+(e<.5?e:1-e)*n,i=2*e-r;return new O(D(t>=240?t-240:t+120,i,r),D(t,i,r),D(t<120?t+240:t-120,i,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1},formatHsl:function(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"hsl(":"hsla(")+(this.h||0)+", "+100*(this.s||0)+"%, "+100*(this.l||0)+"%"+(1===t?")":", "+t+")")}}))},function(t,n,e){"use strict";var r=e(18);n.a=function(t){return(t=Object(r.a)(Math.abs(t)))?t[1]:NaN}},function(t,n,e){"use strict";var r=e(19),i=e(33),o=e(34),u=function(t){return new Array(t.length)};function a(t,n){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=n}a.prototype={constructor:a,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,n){return this._parent.insertBefore(t,n)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}};function c(t,n,e,r,i,o){for(var u,c=0,s=n.length,l=o.length;c<l;++c)(u=n[c])?(u.__data__=o[c],r[c]=u):e[c]=new a(t,o[c]);for(;c<s;++c)(u=n[c])&&(i[c]=u)}function s(t,n,e,r,i,o,u){var c,s,l,f={},h=n.length,d=o.length,p=new Array(h);for(c=0;c<h;++c)(s=n[c])&&(p[c]=l="$"+u.call(s,s.__data__,c,n),l in f?i[c]=s:f[l]=s);for(c=0;c<d;++c)(s=f[l="$"+u.call(t,o[c],c,o)])?(r[c]=s,s.__data__=o[c],f[l]=null):e[c]=new a(t,o[c]);for(c=0;c<h;++c)(s=n[c])&&f[p[c]]===s&&(i[c]=s)}function l(t,n){return t<n?-1:t>n?1:t>=n?0:NaN}var f=e(20);function h(t){return function(){this.removeAttribute(t)}}function d(t){return function(){this.removeAttributeNS(t.space,t.local)}}function p(t,n){return function(){this.setAttribute(t,n)}}function _(t,n){return function(){this.setAttributeNS(t.space,t.local,n)}}function g(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttribute(t):this.setAttribute(t,e)}}function y(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,e)}}var v=e(35);function m(t){return function(){delete this[t]}}function x(t,n){return function(){this[t]=n}}function b(t,n){return function(){var e=n.apply(this,arguments);null==e?delete this[t]:this[t]=e}}function w(t){return t.trim().split(/^|\s+/)}function M(t){return t.classList||new T(t)}function T(t){this._node=t,this._names=w(t.getAttribute("class")||"")}function O(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.add(n[r])}function A(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.remove(n[r])}function k(t){return function(){O(this,t)}}function C(t){return function(){A(this,t)}}function S(t,n){return function(){(n.apply(this,arguments)?O:A)(this,t)}}T.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var n=this._names.indexOf(t);n>=0&&(this._names.splice(n,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}};function N(){this.textContent=""}function E(t){return function(){this.textContent=t}}function j(t){return function(){var n=t.apply(this,arguments);this.textContent=null==n?"":n}}function D(){this.innerHTML=""}function F(t){return function(){this.innerHTML=t}}function P(t){return function(){var n=t.apply(this,arguments);this.innerHTML=null==n?"":n}}function L(){this.nextSibling&&this.parentNode.appendChild(this)}function I(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}var U=e(12);function R(){return null}function B(){var t=this.parentNode;t&&t.removeChild(this)}function H(){var t=this.cloneNode(!1),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}function q(){var t=this.cloneNode(!0),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}var Y=e(17),z=e(21);function G(t,n,e){var r=Object(z.a)(t),i=r.CustomEvent;"function"==typeof i?i=new i(n,e):(i=r.document.createEvent("Event"),e?(i.initEvent(n,e.bubbles,e.cancelable),i.detail=e.detail):i.initEvent(n,!1,!1)),t.dispatchEvent(i)}function V(t,n){return function(){return G(this,t,n)}}function X(t,n){return function(){return G(this,t,n.apply(this,arguments))}}e.d(n,"c",(function(){return W})),e.d(n,"a",(function(){return $}));var W=[null];function $(t,n){this._groups=t,this._parents=n}function Z(){return new $([[document.documentElement]],W)}$.prototype=Z.prototype={constructor:$,select:function(t){"function"!=typeof t&&(t=Object(r.a)(t));for(var n=this._groups,e=n.length,i=new Array(e),o=0;o<e;++o)for(var u,a,c=n[o],s=c.length,l=i[o]=new Array(s),f=0;f<s;++f)(u=c[f])&&(a=t.call(u,u.__data__,f,c))&&("__data__"in u&&(a.__data__=u.__data__),l[f]=a);return new $(i,this._parents)},selectAll:function(t){"function"!=typeof t&&(t=Object(i.a)(t));for(var n=this._groups,e=n.length,r=[],o=[],u=0;u<e;++u)for(var a,c=n[u],s=c.length,l=0;l<s;++l)(a=c[l])&&(r.push(t.call(a,a.__data__,l,c)),o.push(a));return new $(r,o)},filter:function(t){"function"!=typeof t&&(t=Object(o.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var u,a=n[i],c=a.length,s=r[i]=[],l=0;l<c;++l)(u=a[l])&&t.call(u,u.__data__,l,a)&&s.push(u);return new $(r,this._parents)},data:function(t,n){if(!t)return g=new Array(this.size()),h=-1,this.each((function(t){g[++h]=t})),g;var e,r=n?s:c,i=this._parents,o=this._groups;"function"!=typeof t&&(e=t,t=function(){return e});for(var u=o.length,a=new Array(u),l=new Array(u),f=new Array(u),h=0;h<u;++h){var d=i[h],p=o[h],_=p.length,g=t.call(d,d&&d.__data__,h,i),y=g.length,v=l[h]=new Array(y),m=a[h]=new Array(y);r(d,p,v,m,f[h]=new Array(_),g,n);for(var x,b,w=0,M=0;w<y;++w)if(x=v[w]){for(w>=M&&(M=w+1);!(b=m[M])&&++M<y;);x._next=b||null}}return(a=new $(a,i))._enter=l,a._exit=f,a},enter:function(){return new $(this._enter||this._groups.map(u),this._parents)},exit:function(){return new $(this._exit||this._groups.map(u),this._parents)},join:function(t,n,e){var r=this.enter(),i=this,o=this.exit();return r="function"==typeof t?t(r):r.append(t+""),null!=n&&(i=n(i)),null==e?o.remove():e(o),r&&i?r.merge(i).order():i},merge:function(t){for(var n=this._groups,e=t._groups,r=n.length,i=e.length,o=Math.min(r,i),u=new Array(r),a=0;a<o;++a)for(var c,s=n[a],l=e[a],f=s.length,h=u[a]=new Array(f),d=0;d<f;++d)(c=s[d]||l[d])&&(h[d]=c);for(;a<r;++a)u[a]=n[a];return new $(u,this._parents)},order:function(){for(var t=this._groups,n=-1,e=t.length;++n<e;)for(var r,i=t[n],o=i.length-1,u=i[o];--o>=0;)(r=i[o])&&(u&&4^r.compareDocumentPosition(u)&&u.parentNode.insertBefore(r,u),u=r);return this},sort:function(t){function n(n,e){return n&&e?t(n.__data__,e.__data__):!n-!e}t||(t=l);for(var e=this._groups,r=e.length,i=new Array(r),o=0;o<r;++o){for(var u,a=e[o],c=a.length,s=i[o]=new Array(c),f=0;f<c;++f)(u=a[f])&&(s[f]=u);s.sort(n)}return new $(i,this._parents).order()},call:function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this},nodes:function(){var t=new Array(this.size()),n=-1;return this.each((function(){t[++n]=this})),t},node:function(){for(var t=this._groups,n=0,e=t.length;n<e;++n)for(var r=t[n],i=0,o=r.length;i<o;++i){var u=r[i];if(u)return u}return null},size:function(){var t=0;return this.each((function(){++t})),t},empty:function(){return!this.node()},each:function(t){for(var n=this._groups,e=0,r=n.length;e<r;++e)for(var i,o=n[e],u=0,a=o.length;u<a;++u)(i=o[u])&&t.call(i,i.__data__,u,o);return this},attr:function(t,n){var e=Object(f.a)(t);if(arguments.length<2){var r=this.node();return e.local?r.getAttributeNS(e.space,e.local):r.getAttribute(e)}return this.each((null==n?e.local?d:h:"function"==typeof n?e.local?y:g:e.local?_:p)(e,n))},style:v.a,property:function(t,n){return arguments.length>1?this.each((null==n?m:"function"==typeof n?b:x)(t,n)):this.node()[t]},classed:function(t,n){var e=w(t+"");if(arguments.length<2){for(var r=M(this.node()),i=-1,o=e.length;++i<o;)if(!r.contains(e[i]))return!1;return!0}return this.each(("function"==typeof n?S:n?k:C)(e,n))},text:function(t){return arguments.length?this.each(null==t?N:("function"==typeof t?j:E)(t)):this.node().textContent},html:function(t){return arguments.length?this.each(null==t?D:("function"==typeof t?P:F)(t)):this.node().innerHTML},raise:function(){return this.each(L)},lower:function(){return this.each(I)},append:function(t){var n="function"==typeof t?t:Object(U.a)(t);return this.select((function(){return this.appendChild(n.apply(this,arguments))}))},insert:function(t,n){var e="function"==typeof t?t:Object(U.a)(t),i=null==n?R:"function"==typeof n?n:Object(r.a)(n);return this.select((function(){return this.insertBefore(e.apply(this,arguments),i.apply(this,arguments)||null)}))},remove:function(){return this.each(B)},clone:function(t){return this.select(t?q:H)},datum:function(t){return arguments.length?this.property("__data__",t):this.node().__data__},on:Y.b,dispatch:function(t,n){return this.each(("function"==typeof n?X:V)(t,n))}};n.b=Z},function(t,n,e){"use strict";e.d(n,"c",(function(){return o})),e.d(n,"b",(function(){return u})),e.d(n,"a",(function(){return a}));var r=e(23);function i(t,n){return function(e){return t+e*n}}function o(t,n){var e=n-t;return e?i(t,e>180||e<-180?e-360*Math.round(e/360):e):Object(r.a)(isNaN(t)?n:t)}function u(t){return 1==(t=+t)?a:function(n,e){return e-n?function(t,n,e){return t=Math.pow(t,e),n=Math.pow(n,e)-t,e=1/e,function(r){return Math.pow(t+r*n,e)}}(n,e,t):Object(r.a)(isNaN(n)?e:n)}}function a(t,n){var e=n-t;return e?i(t,e):Object(r.a)(isNaN(t)?n:t)}},function(t,n,e){"use strict";function r(t,n){var e=Object.create(t.prototype);for(var r in n)e[r]=n[r];return e}e.d(n,"b",(function(){return r})),n.a=function(t,n,e){t.prototype=n.prototype=e,e.constructor=t}},function(t,n,e){"use strict";var r=e(20),i=e(14);function o(t){return function(){var n=this.ownerDocument,e=this.namespaceURI;return e===i.b&&n.documentElement.namespaceURI===i.b?n.createElement(t):n.createElementNS(e,t)}}function u(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}n.a=function(t){var n=Object(r.a)(t);return(n.local?u:o)(n)}},function(t,n,e){"use strict";n.a=function(t,n){var e=t.ownerSVGElement||t;if(e.createSVGPoint){var r=e.createSVGPoint();return r.x=n.clientX,r.y=n.clientY,[(r=r.matrixTransform(t.getScreenCTM().inverse())).x,r.y]}var i=t.getBoundingClientRect();return[n.clientX-i.left-t.clientLeft,n.clientY-i.top-t.clientTop]}},function(t,n,e){"use strict";e.d(n,"b",(function(){return r}));var r="http://www.w3.org/1999/xhtml";n.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setMonth(0,1),t.setHours(0,0,0,0)}),(function(t,n){t.setFullYear(t.getFullYear()+n)}),(function(t,n){return n.getFullYear()-t.getFullYear()}),(function(t){return t.getFullYear()}));i.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)((function(n){n.setFullYear(Math.floor(n.getFullYear()/t)*t),n.setMonth(0,1),n.setHours(0,0,0,0)}),(function(n,e){n.setFullYear(n.getFullYear()+e*t)})):null},n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCFullYear(t.getUTCFullYear()+n)}),(function(t,n){return n.getUTCFullYear()-t.getUTCFullYear()}),(function(t){return t.getUTCFullYear()}));i.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)((function(n){n.setUTCFullYear(Math.floor(n.getUTCFullYear()/t)*t),n.setUTCMonth(0,1),n.setUTCHours(0,0,0,0)}),(function(n,e){n.setUTCFullYear(n.getUTCFullYear()+e*t)})):null},n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"c",(function(){return i})),e.d(n,"a",(function(){return l}));var r={},i=null;"undefined"!=typeof document&&("onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"}));function o(t,n,e){return t=u(t,n,e),function(n){var e=n.relatedTarget;e&&(e===this||8&e.compareDocumentPosition(this))||t.call(this,n)}}function u(t,n,e){return function(r){var o=i;i=r;try{t.call(this,this.__data__,n,e)}finally{i=o}}}function a(t){return t.trim().split(/^|\s+/).map((function(t){var n="",e=t.indexOf(".");return e>=0&&(n=t.slice(e+1),t=t.slice(0,e)),{type:t,name:n}}))}function c(t){return function(){var n=this.__on;if(n){for(var e,r=0,i=-1,o=n.length;r<o;++r)e=n[r],t.type&&e.type!==t.type||e.name!==t.name?n[++i]=e:this.removeEventListener(e.type,e.listener,e.capture);++i?n.length=i:delete this.__on}}}function s(t,n,e){var i=r.hasOwnProperty(t.type)?o:u;return function(r,o,u){var a,c=this.__on,s=i(n,o,u);if(c)for(var l=0,f=c.length;l<f;++l)if((a=c[l]).type===t.type&&a.name===t.name)return this.removeEventListener(a.type,a.listener,a.capture),this.addEventListener(a.type,a.listener=s,a.capture=e),void(a.value=n);this.addEventListener(t.type,s,e),a={type:t.type,name:t.name,value:n,listener:s,capture:e},c?c.push(a):this.__on=[a]}}function l(t,n,e,r){var o=i;t.sourceEvent=i,i=t;try{return n.apply(e,r)}finally{i=o}}n.b=function(t,n,e){var r,i,o=a(t+""),u=o.length;if(!(arguments.length<2)){for(l=n?s:c,null==e&&(e=!1),r=0;r<u;++r)this.each(l(o[r],n,e));return this}var l=this.node().__on;if(l)for(var f,h=0,d=l.length;h<d;++h)for(r=0,f=l[h];r<u;++r)if((i=o[r]).type===f.type&&i.name===f.name)return f.value}},function(t,n,e){"use strict";n.a=function(t,n){if((e=(t=n?t.toExponential(n-1):t.toExponential()).indexOf("e"))<0)return null;var e,r=t.slice(0,e);return[r.length>1?r[0]+r.slice(2):r,+t.slice(e+1)]}},function(t,n,e){"use strict";function r(){}n.a=function(t){return null==t?r:function(){return this.querySelector(t)}}},function(t,n,e){"use strict";var r=e(14);n.a=function(t){var n=t+="",e=n.indexOf(":");return e>=0&&"xmlns"!==(n=t.slice(0,e))&&(t=t.slice(e+1)),r.a.hasOwnProperty(n)?{space:r.a[n],local:t}:t}},function(t,n,e){"use strict";n.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,n,e){"use strict";var r=e(17);n.a=function(){for(var t,n=r.c;t=n.sourceEvent;)n=t;return n}},function(t,n,e){"use strict";n.a=function(t){return function(){return t}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"a",(function(){return o}));var r=/^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;function i(t){if(!(n=r.exec(t)))throw new Error("invalid format: "+t);var n;return new o({fill:n[1],align:n[2],sign:n[3],symbol:n[4],zero:n[5],width:n[6],comma:n[7],precision:n[8]&&n[8].slice(1),trim:n[9],type:n[10]})}function o(t){this.fill=void 0===t.fill?" ":t.fill+"",this.align=void 0===t.align?">":t.align+"",this.sign=void 0===t.sign?"-":t.sign+"",this.symbol=void 0===t.symbol?"":t.symbol+"",this.zero=!!t.zero,this.width=void 0===t.width?void 0:+t.width,this.comma=!!t.comma,this.precision=void 0===t.precision?void 0:+t.precision,this.trim=!!t.trim,this.type=void 0===t.type?"":t.type+""}i.prototype=o.prototype,o.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(void 0===this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(void 0===this.precision?"":"."+Math.max(0,0|this.precision))+(this.trim?"~":"")+this.type}},function(t,n,e){"use strict";function r(t){return ArrayBuffer.isView(t)&&!(t instanceof DataView)}e.d(n,"b",(function(){return r})),n.a=function(t,n){n||(n=[]);var e,r=t?Math.min(n.length,t.length):0,i=n.slice();return function(o){for(e=0;e<r;++e)i[e]=t[e]*(1-o)+n[e]*o;return i}}},function(t,n,e){"use strict";function r(t,n,e,r,i){var o=t*t,u=o*t;return((1-3*t+3*o-u)*n+(4-6*o+3*u)*e+(1+3*t+3*o-3*u)*r+u*i)/6}e.d(n,"a",(function(){return r})),n.b=function(t){var n=t.length-1;return function(e){var i=e<=0?e=0:e>=1?(e=1,n-1):Math.floor(e*n),o=t[i],u=t[i+1],a=i>0?t[i-1]:2*o-u,c=i<n-1?t[i+2]:2*u-o;return r((e-i/n)*n,a,o,u,c)}}},function(t,n,e){"use strict";e.d(n,"a",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setHours(0,0,0,0)}),(function(t,n){t.setDate(t.getDate()+n)}),(function(t,n){return(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*i.c)/i.a}),(function(t){return t.getDate()-1}));n.b=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCDate(t.getUTCDate()+n)}),(function(t,n){return(n-t)/i.a}),(function(t){return t.getUTCDate()-1}));n.a=o;var u=o.range},function(t,n,e){"use strict";function r(t){return t*t*t}function i(t){return--t*t*t+1}function o(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.d(n,"a",(function(){return r})),e.d(n,"c",(function(){return i})),e.d(n,"b",(function(){return o}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds())}),(function(t,n){t.setTime(+t+n*i.d)}),(function(t,n){return(n-t)/i.d}),(function(t){return t.getUTCSeconds()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(){}),(function(t,n){t.setTime(+t+n)}),(function(t,n){return n-t}));i.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?Object(r.a)((function(n){n.setTime(Math.floor(n/t)*t)}),(function(n,e){n.setTime(+n+e*t)}),(function(n,e){return(e-n)/t})):i:null},n.a=i;var o=i.range},function(t,n,e){"use strict";var r=e(9);n.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,n,e){"use strict";function r(){return[]}n.a=function(t){return null==t?r:function(){return this.querySelectorAll(t)}}},function(t,n,e){"use strict";n.a=function(t){return function(){return this.matches(t)}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return a}));var r=e(21);function i(t){return function(){this.style.removeProperty(t)}}function o(t,n,e){return function(){this.style.setProperty(t,n,e)}}function u(t,n,e){return function(){var r=n.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,e)}}function a(t,n){return t.style.getPropertyValue(n)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(n)}n.a=function(t,n,e){return arguments.length>1?this.each((null==n?i:"function"==typeof n?u:o)(t,n,null==e?"":e)):a(this.node(),t)}},function(t,n,e){"use strict";var r=e(7),i=e(39),o=e(57),u=e(56),a=e(5),c=e(58),s=e(55),l=e(23),f=e(25);n.a=function(t,n){var e,h=typeof n;return null==n||"boolean"===h?Object(l.a)(n):("number"===h?a.a:"string"===h?(e=Object(r.e)(n))?(n=e,i.a):s.a:n instanceof r.e?i.a:n instanceof Date?u.a:Object(f.b)(n)?f.a:Array.isArray(n)?o.b:"function"!=typeof n.valueOf&&"function"!=typeof n.toString||isNaN(n)?c.a:a.a)(t,n)}},function(t,n,e){"use strict";var r,i=e(8),o=e(24),u=e(18),a=function(t,n){var e=Object(u.a)(t,n);if(!e)return t+"";var r=e[0],i=e[1];return i<0?"0."+new Array(-i).join("0")+r:r.length>i+1?r.slice(0,i+1)+"."+r.slice(i+1):r+new Array(i-r.length+2).join("0")},c={"%":function(t,n){return(100*t).toFixed(n)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,n){return t.toExponential(n)},f:function(t,n){return t.toFixed(n)},g:function(t,n){return t.toPrecision(n)},o:function(t){return Math.round(t).toString(8)},p:function(t,n){return a(100*t,n)},r:a,s:function(t,n){var e=Object(u.a)(t,n);if(!e)return t+"";var i=e[0],o=e[1],a=o-(r=3*Math.max(-8,Math.min(8,Math.floor(o/3))))+1,c=i.length;return a===c?i:a>c?i+new Array(a-c+1).join("0"):a>0?i.slice(0,a)+"."+i.slice(a):"0."+new Array(1-a).join("0")+Object(u.a)(t,Math.max(0,n+a-1))[0]},X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}},s=function(t){return t},l=Array.prototype.map,f=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];n.a=function(t){var n,e,u=void 0===t.grouping||void 0===t.thousands?s:(n=l.call(t.grouping,Number),e=t.thousands+"",function(t,r){for(var i=t.length,o=[],u=0,a=n[0],c=0;i>0&&a>0&&(c+a+1>r&&(a=Math.max(1,r-c)),o.push(t.substring(i-=a,i+a)),!((c+=a+1)>r));)a=n[u=(u+1)%n.length];return o.reverse().join(e)}),a=void 0===t.currency?"":t.currency[0]+"",h=void 0===t.currency?"":t.currency[1]+"",d=void 0===t.decimal?".":t.decimal+"",p=void 0===t.numerals?s:function(t){return function(n){return n.replace(/[0-9]/g,(function(n){return t[+n]}))}}(l.call(t.numerals,String)),_=void 0===t.percent?"%":t.percent+"",g=void 0===t.minus?"-":t.minus+"",y=void 0===t.nan?"NaN":t.nan+"";function v(t){var n=(t=Object(o.b)(t)).fill,e=t.align,i=t.sign,s=t.symbol,l=t.zero,v=t.width,m=t.comma,x=t.precision,b=t.trim,w=t.type;"n"===w?(m=!0,w="g"):c[w]||(void 0===x&&(x=12),b=!0,w="g"),(l||"0"===n&&"="===e)&&(l=!0,n="0",e="=");var M="$"===s?a:"#"===s&&/[boxX]/.test(w)?"0"+w.toLowerCase():"",T="$"===s?h:/[%p]/.test(w)?_:"",O=c[w],A=/[defgprs%]/.test(w);function k(t){var o,a,c,s=M,h=T;if("c"===w)h=O(t)+h,t="";else{var _=(t=+t)<0;if(t=isNaN(t)?y:O(Math.abs(t),x),b&&(t=function(t){t:for(var n,e=t.length,r=1,i=-1;r<e;++r)switch(t[r]){case".":i=n=r;break;case"0":0===i&&(i=r),n=r;break;default:if(!+t[r])break t;i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}(t)),_&&0==+t&&(_=!1),s=(_?"("===i?i:g:"-"===i||"("===i?"":i)+s,h=("s"===w?f[8+r/3]:"")+h+(_&&"("===i?")":""),A)for(o=-1,a=t.length;++o<a;)if(48>(c=t.charCodeAt(o))||c>57){h=(46===c?d+t.slice(o+1):t.slice(o))+h,t=t.slice(0,o);break}}m&&!l&&(t=u(t,1/0));var k=s.length+t.length+h.length,C=k<v?new Array(v-k+1).join(n):"";switch(m&&l&&(t=u(C+t,C.length?v-h.length:1/0),C=""),e){case"<":t=s+t+h+C;break;case"=":t=s+C+t+h;break;case"^":t=C.slice(0,k=C.length>>1)+s+t+h+C.slice(k);break;default:t=C+s+t+h}return p(t)}return x=void 0===x?6:/[gprs]/.test(w)?Math.max(1,Math.min(21,x)):Math.max(0,Math.min(20,x)),k.toString=function(){return t+""},k}return{format:v,formatPrefix:function(t,n){var e=v(((t=Object(o.b)(t)).type="f",t)),r=3*Math.max(-8,Math.min(8,Math.floor(Object(i.a)(n)/3))),u=Math.pow(10,-r),a=f[8+r/3];return function(t){return e(u*t)+a}}}}},function(t,n,e){"use strict";e.r(n);var r=e(0);e.d(n,"timeInterval",(function(){return r.a}));var i=e(31);e.d(n,"timeMillisecond",(function(){return i.a})),e.d(n,"timeMilliseconds",(function(){return i.b})),e.d(n,"utcMillisecond",(function(){return i.a})),e.d(n,"utcMilliseconds",(function(){return i.b}));var o=e(30);e.d(n,"timeSecond",(function(){return o.a})),e.d(n,"timeSeconds",(function(){return o.b})),e.d(n,"utcSecond",(function(){return o.a})),e.d(n,"utcSeconds",(function(){return o.b}));var u=e(49);e.d(n,"timeMinute",(function(){return u.a})),e.d(n,"timeMinutes",(function(){return u.b}));var a=e(48);e.d(n,"timeHour",(function(){return a.a})),e.d(n,"timeHours",(function(){return a.b}));var c=e(27);e.d(n,"timeDay",(function(){return c.b})),e.d(n,"timeDays",(function(){return c.a}));var s=e(3);e.d(n,"timeWeek",(function(){return s.g})),e.d(n,"timeWeeks",(function(){return s.h})),e.d(n,"timeSunday",(function(){return s.g})),e.d(n,"timeSundays",(function(){return s.h})),e.d(n,"timeMonday",(function(){return s.c})),e.d(n,"timeMondays",(function(){return s.d})),e.d(n,"timeTuesday",(function(){return s.k})),e.d(n,"timeTuesdays",(function(){return s.l})),e.d(n,"timeWednesday",(function(){return s.m})),e.d(n,"timeWednesdays",(function(){return s.n})),e.d(n,"timeThursday",(function(){return s.i})),e.d(n,"timeThursdays",(function(){return s.j})),e.d(n,"timeFriday",(function(){return s.a})),e.d(n,"timeFridays",(function(){return s.b})),e.d(n,"timeSaturday",(function(){return s.e})),e.d(n,"timeSaturdays",(function(){return s.f}));var l=e(47);e.d(n,"timeMonth",(function(){return l.a})),e.d(n,"timeMonths",(function(){return l.b}));var f=e(15);e.d(n,"timeYear",(function(){return f.a})),e.d(n,"timeYears",(function(){return f.b}));var h=e(52);e.d(n,"utcMinute",(function(){return h.a})),e.d(n,"utcMinutes",(function(){return h.b}));var d=e(51);e.d(n,"utcHour",(function(){return d.a})),e.d(n,"utcHours",(function(){return d.b}));var p=e(28);e.d(n,"utcDay",(function(){return p.a})),e.d(n,"utcDays",(function(){return p.b}));var _=e(4);e.d(n,"utcWeek",(function(){return _.g})),e.d(n,"utcWeeks",(function(){return _.h})),e.d(n,"utcSunday",(function(){return _.g})),e.d(n,"utcSundays",(function(){return _.h})),e.d(n,"utcMonday",(function(){return _.c})),e.d(n,"utcMondays",(function(){return _.d})),e.d(n,"utcTuesday",(function(){return _.k})),e.d(n,"utcTuesdays",(function(){return _.l})),e.d(n,"utcWednesday",(function(){return _.m})),e.d(n,"utcWednesdays",(function(){return _.n})),e.d(n,"utcThursday",(function(){return _.i})),e.d(n,"utcThursdays",(function(){return _.j})),e.d(n,"utcFriday",(function(){return _.a})),e.d(n,"utcFridays",(function(){return _.b})),e.d(n,"utcSaturday",(function(){return _.e})),e.d(n,"utcSaturdays",(function(){return _.f}));var g=e(50);e.d(n,"utcMonth",(function(){return g.a})),e.d(n,"utcMonths",(function(){return g.b}));var y=e(16);e.d(n,"utcYear",(function(){return y.a})),e.d(n,"utcYears",(function(){return y.b}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return c})),e.d(n,"c",(function(){return s}));var r=e(7),i=e(26),o=e(53),u=e(10);function a(t){return function(n){var e,i,o=n.length,u=new Array(o),a=new Array(o),c=new Array(o);for(e=0;e<o;++e)i=Object(r.g)(n[e]),u[e]=i.r||0,a[e]=i.g||0,c[e]=i.b||0;return u=t(u),a=t(a),c=t(c),i.opacity=1,function(t){return i.r=u(t),i.g=a(t),i.b=c(t),i+""}}}n.a=function t(n){var e=Object(u.b)(n);function i(t,n){var i=e((t=Object(r.g)(t)).r,(n=Object(r.g)(n)).r),o=e(t.g,n.g),a=e(t.b,n.b),c=Object(u.a)(t.opacity,n.opacity);return function(n){return t.r=i(n),t.g=o(n),t.b=a(n),t.opacity=c(n),t+""}}return i.gamma=t,i}(1);var c=a(i.b),s=a(o.a)},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"c",(function(){return o})),e.d(n,"a",(function(){return a}));var r,i,o,u=e(37);function a(t){return r=Object(u.a)(t),i=r.format,o=r.formatPrefix,r}a({decimal:".",thousands:",",grouping:[3],currency:["$",""],minus:"-"})},,,function(t,n,e){"use strict";e.r(n);var r=e(7);e.d(n,"color",(function(){return r.e})),e.d(n,"rgb",(function(){return r.g})),e.d(n,"hsl",(function(){return r.f}));var i=e(82);e.d(n,"lab",(function(){return i.a})),e.d(n,"hcl",(function(){return i.c})),e.d(n,"lch",(function(){return i.d})),e.d(n,"gray",(function(){return i.b}));var o=e(86);e.d(n,"cubehelix",(function(){return o.a}))},function(t,n,e){"use strict";e.r(n);var r=e(40);e.d(n,"formatDefaultLocale",(function(){return r.a})),e.d(n,"format",(function(){return r.b})),e.d(n,"formatPrefix",(function(){return r.c}));var i=e(37);e.d(n,"formatLocale",(function(){return i.a}));var o=e(24);e.d(n,"formatSpecifier",(function(){return o.b})),e.d(n,"FormatSpecifier",(function(){return o.a}));var u=e(61);e.d(n,"precisionFixed",(function(){return u.a}));var a=e(62);e.d(n,"precisionPrefix",(function(){return a.a}));var c=e(63);e.d(n,"precisionRound",(function(){return c.a}))},function(t,n,e){"use strict";e.r(n);function r(){}function i(t,n){var e=new r;if(t instanceof r)t.each((function(t,n){e.set(n,t)}));else if(Array.isArray(t)){var i,o=-1,u=t.length;if(null==n)for(;++o<u;)e.set(o,t[o]);else for(;++o<u;)e.set(n(i=t[o],o,t),i)}else if(t)for(var a in t)e.set(a,t[a]);return e}r.prototype=i.prototype={constructor:r,has:function(t){return"$"+t in this},get:function(t){return this["$"+t]},set:function(t,n){return this["$"+t]=n,this},remove:function(t){var n="$"+t;return n in this&&delete this[n]},clear:function(){for(var t in this)"$"===t[0]&&delete this[t]},keys:function(){var t=[];for(var n in this)"$"===n[0]&&t.push(n.slice(1));return t},values:function(){var t=[];for(var n in this)"$"===n[0]&&t.push(this[n]);return t},entries:function(){var t=[];for(var n in this)"$"===n[0]&&t.push({key:n.slice(1),value:this[n]});return t},size:function(){var t=0;for(var n in this)"$"===n[0]&&++t;return t},empty:function(){for(var t in this)if("$"===t[0])return!1;return!0},each:function(t){for(var n in this)"$"===n[0]&&t(this[n],n.slice(1),this)}};var o=i,u=function(){var t,n,e,r=[],i=[];function u(e,i,a,c){if(i>=r.length)return null!=t&&e.sort(t),null!=n?n(e):e;for(var s,l,f,h=-1,d=e.length,p=r[i++],_=o(),g=a();++h<d;)(f=_.get(s=p(l=e[h])+""))?f.push(l):_.set(s,[l]);return _.each((function(t,n){c(g,n,u(t,i,a,c))})),g}return e={object:function(t){return u(t,0,a,c)},map:function(t){return u(t,0,s,l)},entries:function(t){return function t(e,o){if(++o>r.length)return e;var u,a=i[o-1];return null!=n&&o>=r.length?u=e.entries():(u=[],e.each((function(n,e){u.push({key:e,values:t(n,o)})}))),null!=a?u.sort((function(t,n){return a(t.key,n.key)})):u}(u(t,0,s,l),0)},key:function(t){return r.push(t),e},sortKeys:function(t){return i[r.length-1]=t,e},sortValues:function(n){return t=n,e},rollup:function(t){return n=t,e}}};function a(){return{}}function c(t,n,e){t[n]=e}function s(){return o()}function l(t,n,e){t.set(n,e)}function f(){}var h=o.prototype;function d(t,n){var e=new f;if(t instanceof f)t.each((function(t){e.add(t)}));else if(t){var r=-1,i=t.length;if(null==n)for(;++r<i;)e.add(t[r]);else for(;++r<i;)e.add(n(t[r],r,t))}return e}f.prototype=d.prototype={constructor:f,has:h.has,add:function(t){return this["$"+(t+="")]=t,this},remove:h.remove,clear:h.clear,values:h.keys,size:h.size,empty:h.empty,each:h.each};var p=d,_=function(t){var n=[];for(var e in t)n.push(e);return n},g=function(t){var n=[];for(var e in t)n.push(t[e]);return n},y=function(t){var n=[];for(var e in t)n.push({key:e,value:t[e]});return n};e.d(n,"nest",(function(){return u})),e.d(n,"set",(function(){return p})),e.d(n,"map",(function(){return o})),e.d(n,"keys",(function(){return _})),e.d(n,"values",(function(){return g})),e.d(n,"entries",(function(){return y}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"c",(function(){return o})),e.d(n,"d",(function(){return u})),e.d(n,"e",(function(){return a})),e.d(n,"a",(function(){return s}));var r,i,o,u,a,c=e(54);function s(t){return r=Object(c.a)(t),i=r.format,o=r.parse,u=r.utcFormat,a=r.utcParse,r}s({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setDate(1),t.setHours(0,0,0,0)}),(function(t,n){t.setMonth(t.getMonth()+n)}),(function(t,n){return n.getMonth()-t.getMonth()+12*(n.getFullYear()-t.getFullYear())}),(function(t){return t.getMonth()}));n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds()-t.getSeconds()*i.d-t.getMinutes()*i.c)}),(function(t,n){t.setTime(+t+n*i.b)}),(function(t,n){return(n-t)/i.b}),(function(t){return t.getHours()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds()-t.getSeconds()*i.d)}),(function(t,n){t.setTime(+t+n*i.c)}),(function(t,n){return(n-t)/i.c}),(function(t){return t.getMinutes()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setUTCDate(1),t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCMonth(t.getUTCMonth()+n)}),(function(t,n){return n.getUTCMonth()-t.getUTCMonth()+12*(n.getUTCFullYear()-t.getUTCFullYear())}),(function(t){return t.getUTCMonth()}));n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCMinutes(0,0,0)}),(function(t,n){t.setTime(+t+n*i.b)}),(function(t,n){return(n-t)/i.b}),(function(t){return t.getUTCHours()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCSeconds(0,0)}),(function(t,n){t.setTime(+t+n*i.c)}),(function(t,n){return(n-t)/i.c}),(function(t){return t.getUTCMinutes()}));n.a=o;var u=o.range},function(t,n,e){"use strict";var r=e(26);n.a=function(t){var n=t.length;return function(e){var i=Math.floor(((e%=1)<0?++e:e)*n),o=t[(i+n-1)%n],u=t[i%n],a=t[(i+1)%n],c=t[(i+2)%n];return Object(r.a)((e-i/n)*n,o,u,a,c)}}},function(t,n,e){"use strict";e.d(n,"a",(function(){return h}));var r=e(4),i=e(28),o=e(3),u=e(27),a=e(15),c=e(16);function s(t){if(0<=t.y&&t.y<100){var n=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return n.setFullYear(t.y),n}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function l(t){if(0<=t.y&&t.y<100){var n=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return n.setUTCFullYear(t.y),n}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function f(t,n,e){return{y:t,m:n,d:e,H:0,M:0,S:0,L:0}}function h(t){var n=t.dateTime,e=t.date,a=t.time,c=t.periods,h=t.days,p=t.shortDays,_=t.months,g=t.shortMonths,y=m(c),v=x(c),Tt=m(h),Ot=x(h),At=m(p),kt=x(p),Ct=m(_),St=x(_),Nt=m(g),Et=x(g),jt={a:function(t){return p[t.getDay()]},A:function(t){return h[t.getDay()]},b:function(t){return g[t.getMonth()]},B:function(t){return _[t.getMonth()]},c:null,d:H,e:H,f:V,H:q,I:Y,j:z,L:G,m:X,M:W,p:function(t){return c[+(t.getHours()>=12)]},q:function(t){return 1+~~(t.getMonth()/3)},Q:wt,s:Mt,S:$,u:Z,U:Q,V:J,w:K,W:tt,x:null,X:null,y:nt,Y:et,Z:rt,"%":bt},Dt={a:function(t){return p[t.getUTCDay()]},A:function(t){return h[t.getUTCDay()]},b:function(t){return g[t.getUTCMonth()]},B:function(t){return _[t.getUTCMonth()]},c:null,d:it,e:it,f:st,H:ot,I:ut,j:at,L:ct,m:lt,M:ft,p:function(t){return c[+(t.getUTCHours()>=12)]},q:function(t){return 1+~~(t.getUTCMonth()/3)},Q:wt,s:Mt,S:ht,u:dt,U:pt,V:_t,w:gt,W:yt,x:null,X:null,y:vt,Y:mt,Z:xt,"%":bt},Ft={a:function(t,n,e){var r=At.exec(n.slice(e));return r?(t.w=kt[r[0].toLowerCase()],e+r[0].length):-1},A:function(t,n,e){var r=Tt.exec(n.slice(e));return r?(t.w=Ot[r[0].toLowerCase()],e+r[0].length):-1},b:function(t,n,e){var r=Nt.exec(n.slice(e));return r?(t.m=Et[r[0].toLowerCase()],e+r[0].length):-1},B:function(t,n,e){var r=Ct.exec(n.slice(e));return r?(t.m=St[r[0].toLowerCase()],e+r[0].length):-1},c:function(t,e,r){return It(t,n,e,r)},d:E,e:E,f:I,H:D,I:D,j:j,L:L,m:N,M:F,p:function(t,n,e){var r=y.exec(n.slice(e));return r?(t.p=v[r[0].toLowerCase()],e+r[0].length):-1},q:S,Q:R,s:B,S:P,u:w,U:M,V:T,w:b,W:O,x:function(t,n,r){return It(t,e,n,r)},X:function(t,n,e){return It(t,a,n,e)},y:k,Y:A,Z:C,"%":U};function Pt(t,n){return function(e){var r,i,o,u=[],a=-1,c=0,s=t.length;for(e instanceof Date||(e=new Date(+e));++a<s;)37===t.charCodeAt(a)&&(u.push(t.slice(c,a)),null!=(i=d[r=t.charAt(++a)])?r=t.charAt(++a):i="e"===r?" ":"0",(o=n[r])&&(r=o(e,i)),u.push(r),c=a+1);return u.push(t.slice(c,a)),u.join("")}}function Lt(t,n){return function(e){var a,c,h=f(1900,void 0,1);if(It(h,t,e+="",0)!=e.length)return null;if("Q"in h)return new Date(h.Q);if("s"in h)return new Date(1e3*h.s+("L"in h?h.L:0));if(!n||"Z"in h||(h.Z=0),"p"in h&&(h.H=h.H%12+12*h.p),void 0===h.m&&(h.m="q"in h?h.q:0),"V"in h){if(h.V<1||h.V>53)return null;"w"in h||(h.w=1),"Z"in h?(c=(a=l(f(h.y,0,1))).getUTCDay(),a=c>4||0===c?r.c.ceil(a):Object(r.c)(a),a=i.a.offset(a,7*(h.V-1)),h.y=a.getUTCFullYear(),h.m=a.getUTCMonth(),h.d=a.getUTCDate()+(h.w+6)%7):(c=(a=s(f(h.y,0,1))).getDay(),a=c>4||0===c?o.c.ceil(a):Object(o.c)(a),a=u.b.offset(a,7*(h.V-1)),h.y=a.getFullYear(),h.m=a.getMonth(),h.d=a.getDate()+(h.w+6)%7)}else("W"in h||"U"in h)&&("w"in h||(h.w="u"in h?h.u%7:"W"in h?1:0),c="Z"in h?l(f(h.y,0,1)).getUTCDay():s(f(h.y,0,1)).getDay(),h.m=0,h.d="W"in h?(h.w+6)%7+7*h.W-(c+5)%7:h.w+7*h.U-(c+6)%7);return"Z"in h?(h.H+=h.Z/100|0,h.M+=h.Z%100,l(h)):s(h)}}function It(t,n,e,r){for(var i,o,u=0,a=n.length,c=e.length;u<a;){if(r>=c)return-1;if(37===(i=n.charCodeAt(u++))){if(i=n.charAt(u++),!(o=Ft[i in d?n.charAt(u++):i])||(r=o(t,e,r))<0)return-1}else if(i!=e.charCodeAt(r++))return-1}return r}return(jt.x=Pt(e,jt),jt.X=Pt(a,jt),jt.c=Pt(n,jt),Dt.x=Pt(e,Dt),Dt.X=Pt(a,Dt),Dt.c=Pt(n,Dt),{format:function(t){var n=Pt(t+="",jt);return n.toString=function(){return t},n},parse:function(t){var n=Lt(t+="",!1);return n.toString=function(){return t},n},utcFormat:function(t){var n=Pt(t+="",Dt);return n.toString=function(){return t},n},utcParse:function(t){var n=Lt(t+="",!0);return n.toString=function(){return t},n}})}var d={"-":"",_:" ",0:"0"},p=/^\s*\d+/,_=/^%/,g=/[\\^$*+?|[\]().{}]/g;function y(t,n,e){var r=t<0?"-":"",i=(r?-t:t)+"",o=i.length;return r+(o<e?new Array(e-o+1).join(n)+i:i)}function v(t){return t.replace(g,"\\$&")}function m(t){return new RegExp("^(?:"+t.map(v).join("|")+")","i")}function x(t){for(var n={},e=-1,r=t.length;++e<r;)n[t[e].toLowerCase()]=e;return n}function b(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.w=+r[0],e+r[0].length):-1}function w(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.u=+r[0],e+r[0].length):-1}function M(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.U=+r[0],e+r[0].length):-1}function T(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.V=+r[0],e+r[0].length):-1}function O(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.W=+r[0],e+r[0].length):-1}function A(t,n,e){var r=p.exec(n.slice(e,e+4));return r?(t.y=+r[0],e+r[0].length):-1}function k(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),e+r[0].length):-1}function C(t,n,e){var r=/^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(n.slice(e,e+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),e+r[0].length):-1}function S(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.q=3*r[0]-3,e+r[0].length):-1}function N(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.m=r[0]-1,e+r[0].length):-1}function E(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.d=+r[0],e+r[0].length):-1}function j(t,n,e){var r=p.exec(n.slice(e,e+3));return r?(t.m=0,t.d=+r[0],e+r[0].length):-1}function D(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.H=+r[0],e+r[0].length):-1}function F(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.M=+r[0],e+r[0].length):-1}function P(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.S=+r[0],e+r[0].length):-1}function L(t,n,e){var r=p.exec(n.slice(e,e+3));return r?(t.L=+r[0],e+r[0].length):-1}function I(t,n,e){var r=p.exec(n.slice(e,e+6));return r?(t.L=Math.floor(r[0]/1e3),e+r[0].length):-1}function U(t,n,e){var r=_.exec(n.slice(e,e+1));return r?e+r[0].length:-1}function R(t,n,e){var r=p.exec(n.slice(e));return r?(t.Q=+r[0],e+r[0].length):-1}function B(t,n,e){var r=p.exec(n.slice(e));return r?(t.s=+r[0],e+r[0].length):-1}function H(t,n){return y(t.getDate(),n,2)}function q(t,n){return y(t.getHours(),n,2)}function Y(t,n){return y(t.getHours()%12||12,n,2)}function z(t,n){return y(1+u.b.count(Object(a.a)(t),t),n,3)}function G(t,n){return y(t.getMilliseconds(),n,3)}function V(t,n){return G(t,n)+"000"}function X(t,n){return y(t.getMonth()+1,n,2)}function W(t,n){return y(t.getMinutes(),n,2)}function $(t,n){return y(t.getSeconds(),n,2)}function Z(t){var n=t.getDay();return 0===n?7:n}function Q(t,n){return y(o.g.count(Object(a.a)(t)-1,t),n,2)}function J(t,n){var e=t.getDay();return t=e>=4||0===e?Object(o.i)(t):o.i.ceil(t),y(o.i.count(Object(a.a)(t),t)+(4===Object(a.a)(t).getDay()),n,2)}function K(t){return t.getDay()}function tt(t,n){return y(o.c.count(Object(a.a)(t)-1,t),n,2)}function nt(t,n){return y(t.getFullYear()%100,n,2)}function et(t,n){return y(t.getFullYear()%1e4,n,4)}function rt(t){var n=t.getTimezoneOffset();return(n>0?"-":(n*=-1,"+"))+y(n/60|0,"0",2)+y(n%60,"0",2)}function it(t,n){return y(t.getUTCDate(),n,2)}function ot(t,n){return y(t.getUTCHours(),n,2)}function ut(t,n){return y(t.getUTCHours()%12||12,n,2)}function at(t,n){return y(1+i.a.count(Object(c.a)(t),t),n,3)}function ct(t,n){return y(t.getUTCMilliseconds(),n,3)}function st(t,n){return ct(t,n)+"000"}function lt(t,n){return y(t.getUTCMonth()+1,n,2)}function ft(t,n){return y(t.getUTCMinutes(),n,2)}function ht(t,n){return y(t.getUTCSeconds(),n,2)}function dt(t){var n=t.getUTCDay();return 0===n?7:n}function pt(t,n){return y(r.g.count(Object(c.a)(t)-1,t),n,2)}function _t(t,n){var e=t.getUTCDay();return t=e>=4||0===e?Object(r.i)(t):r.i.ceil(t),y(r.i.count(Object(c.a)(t),t)+(4===Object(c.a)(t).getUTCDay()),n,2)}function gt(t){return t.getUTCDay()}function yt(t,n){return y(r.c.count(Object(c.a)(t)-1,t),n,2)}function vt(t,n){return y(t.getUTCFullYear()%100,n,2)}function mt(t,n){return y(t.getUTCFullYear()%1e4,n,4)}function xt(){return"+0000"}function bt(){return"%"}function wt(t){return+t}function Mt(t){return Math.floor(+t/1e3)}},function(t,n,e){"use strict";var r=e(5),i=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,o=new RegExp(i.source,"g");n.a=function(t,n){var e,u,a,c=i.lastIndex=o.lastIndex=0,s=-1,l=[],f=[];for(t+="",n+="";(e=i.exec(t))&&(u=o.exec(n));)(a=u.index)>c&&(a=n.slice(c,a),l[s]?l[s]+=a:l[++s]=a),(e=e[0])===(u=u[0])?l[s]?l[s]+=u:l[++s]=u:(l[++s]=null,f.push({i:s,x:Object(r.a)(e,u)})),c=o.lastIndex;return c<n.length&&(a=n.slice(c),l[s]?l[s]+=a:l[++s]=a),l.length<2?f[0]?function(t){return function(n){return t(n)+""}}(f[0].x):function(t){return function(){return t}}(n):(n=f.length,function(t){for(var e,r=0;r<n;++r)l[(e=f[r]).i]=e.x(t);return l.join("")})}},function(t,n,e){"use strict";n.a=function(t,n){var e=new Date;return t=+t,n=+n,function(r){return e.setTime(t*(1-r)+n*r),e}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(36),i=e(25);function o(t,n){var e,i=n?n.length:0,o=t?Math.min(i,t.length):0,u=new Array(o),a=new Array(i);for(e=0;e<o;++e)u[e]=Object(r.a)(t[e],n[e]);for(;e<i;++e)a[e]=n[e];return function(t){for(e=0;e<o;++e)a[e]=u[e](t);return a}}n.a=function(t,n){return(Object(i.b)(n)?i.a:o)(t,n)}},function(t,n,e){"use strict";var r=e(36);n.a=function(t,n){var e,i={},o={};for(e in null!==t&&"object"==typeof t||(t={}),null!==n&&"object"==typeof n||(n={}),n)e in t?i[e]=Object(r.a)(t[e],n[e]):o[e]=n[e];return function(t){for(e in i)o[e]=i[e](t);return o}}},function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t){var n=Object(r.a)();return n.changedTouches&&(n=n.changedTouches[0]),Object(i.a)(t,n)}},function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t,n,e){arguments.length<3&&(e=n,n=Object(r.a)().changedTouches);for(var o,u=0,a=n?n.length:0;u<a;++u)if((o=n[u]).identifier===e)return Object(i.a)(t,o);return null}},function(t,n,e){"use strict";var r=e(8);n.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(n)/3)))-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return t=Math.abs(t),n=Math.abs(n)-t,Math.max(0,Object(r.a)(n)-Object(r.a)(t))+1}},function(t,n,e){"use strict";function r(t){return+t}function i(t){return t*t}function o(t){return t*(2-t)}function u(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.r(n);var a=e(29),c=function t(n){function e(t){return Math.pow(t,n)}return n=+n,e.exponent=t,e}(3),s=function t(n){function e(t){return 1-Math.pow(1-t,n)}return n=+n,e.exponent=t,e}(3),l=function t(n){function e(t){return((t*=2)<=1?Math.pow(t,n):2-Math.pow(2-t,n))/2}return n=+n,e.exponent=t,e}(3),f=Math.PI,h=f/2;function d(t){return 1-Math.cos(t*h)}function p(t){return Math.sin(t*h)}function _(t){return(1-Math.cos(f*t))/2}function g(t){return Math.pow(2,10*t-10)}function y(t){return 1-Math.pow(2,-10*t)}function v(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}function m(t){return 1-Math.sqrt(1-t*t)}function x(t){return Math.sqrt(1- --t*t)}function b(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}var w=7.5625;function M(t){return 1-T(1-t)}function T(t){return(t=+t)<4/11?w*t*t:t<8/11?w*(t-=6/11)*t+.75:t<10/11?w*(t-=9/11)*t+.9375:w*(t-=21/22)*t+63/64}function O(t){return((t*=2)<=1?1-T(1-t):T(t-1)+1)/2}var A=function t(n){function e(t){return t*t*((n+1)*t-n)}return n=+n,e.overshoot=t,e}(1.70158),k=function t(n){function e(t){return--t*t*((n+1)*t+n)+1}return n=+n,e.overshoot=t,e}(1.70158),C=function t(n){function e(t){return((t*=2)<1?t*t*((n+1)*t-n):(t-=2)*t*((n+1)*t+n)+2)/2}return n=+n,e.overshoot=t,e}(1.70158),S=2*Math.PI,N=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=S);function i(t){return n*Math.pow(2,10*--t)*Math.sin((r-t)/e)}return i.amplitude=function(n){return t(n,e*S)},i.period=function(e){return t(n,e)},i}(1,.3),E=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=S);function i(t){return 1-n*Math.pow(2,-10*(t=+t))*Math.sin((t+r)/e)}return i.amplitude=function(n){return t(n,e*S)},i.period=function(e){return t(n,e)},i}(1,.3),j=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=S);function i(t){return((t=2*t-1)<0?n*Math.pow(2,10*t)*Math.sin((r-t)/e):2-n*Math.pow(2,-10*t)*Math.sin((r+t)/e))/2}return i.amplitude=function(n){return t(n,e*S)},i.period=function(e){return t(n,e)},i}(1,.3);e.d(n,"easeLinear",(function(){return r})),e.d(n,"easeQuad",(function(){return u})),e.d(n,"easeQuadIn",(function(){return i})),e.d(n,"easeQuadOut",(function(){return o})),e.d(n,"easeQuadInOut",(function(){return u})),e.d(n,"easeCubic",(function(){return a.b})),e.d(n,"easeCubicIn",(function(){return a.a})),e.d(n,"easeCubicOut",(function(){return a.c})),e.d(n,"easeCubicInOut",(function(){return a.b})),e.d(n,"easePoly",(function(){return l})),e.d(n,"easePolyIn",(function(){return c})),e.d(n,"easePolyOut",(function(){return s})),e.d(n,"easePolyInOut",(function(){return l})),e.d(n,"easeSin",(function(){return _})),e.d(n,"easeSinIn",(function(){return d})),e.d(n,"easeSinOut",(function(){return p})),e.d(n,"easeSinInOut",(function(){return _})),e.d(n,"easeExp",(function(){return v})),e.d(n,"easeExpIn",(function(){return g})),e.d(n,"easeExpOut",(function(){return y})),e.d(n,"easeExpInOut",(function(){return v})),e.d(n,"easeCircle",(function(){return b})),e.d(n,"easeCircleIn",(function(){return m})),e.d(n,"easeCircleOut",(function(){return x})),e.d(n,"easeCircleInOut",(function(){return b})),e.d(n,"easeBounce",(function(){return T})),e.d(n,"easeBounceIn",(function(){return M})),e.d(n,"easeBounceOut",(function(){return T})),e.d(n,"easeBounceInOut",(function(){return O})),e.d(n,"easeBack",(function(){return C})),e.d(n,"easeBackIn",(function(){return A})),e.d(n,"easeBackOut",(function(){return k})),e.d(n,"easeBackInOut",(function(){return C})),e.d(n,"easeElastic",(function(){return E})),e.d(n,"easeElasticIn",(function(){return N})),e.d(n,"easeElasticOut",(function(){return E})),e.d(n,"easeElasticInOut",(function(){return j}))},function(t,n,e){"use strict";var r;void 0===(r=function(){return{colorSchemas:{britecharts:["#6aedc7","#39c2c9","#ffce00","#ffa71a","#f866b9","#998ce3"],grey:["#F8F8FA","#EFF2F5","#D2D6DF","#C3C6CF","#ADB0B6","#666A73","#45494E","#363A43","#282C35"],orange:["#fcc870","#ffa71a","#fb8825","#f6682f","#db5a2c","#bf4c28","#a43b1c","#892a10","#f9e9c5"],blueGreen:["#ccf7f6","#70e4e0","#00d8d2","#00acaf","#007f8c","#005e66","#003c3f","#002d2f","#0d2223"],teal:["#ccfffe","#94f7f4","#00fff8","#1de1e1","#39c2c9","#2e9a9d","#227270","#1a5957","#133f3e"],green:["#edfff7","#d7ffef","#c0ffe7","#95f5d7","#6aedc7","#59c3a3","#479980","#34816a","#206953"],yellow:["#f9f2b3","#fbe986","#fce05a","#fed72d","#ffce00","#fcc11c","#f9b438","#eda629","#e09819"],pink:["#fdd1ea","#fb9cd2","#f866b9","#fc40b6","#ff1ab3","#e3239d","#c62c86","#a62073","#85135f"],purple:["#ddd6fc","#bbb1f0","#998ce3","#8e6bc1","#824a9e","#77337f","#6b1c60","#591650","#470f3f"],red:["#ffd8d4","#ffb5b0","#ff938c","#ff766c","#ff584c","#f04b42","#e03d38","#be2e29","#9c1e19"]},colorSchemasHuman:{britecharts:"Britecharts Default",grey:"Britecharts Grey",orange:"Orange",blueGreen:"Blue",teal:"Light Blue",green:"Green",yellow:"Yellow",pink:"Pink",purple:"Purple",red:"Red"},colorGradients:{greenBlue:["#39C7EA","#4CDCBA"],orangePink:["#FBC670","#F766B8"],bluePurple:["#3DC3C9","#824a9e"]},colorGradientsHuman:{greenBlue:"Green to Blue",orangePink:"Orange to Pink",bluePurple:"Blue to Purple"},singleColors:{aloeGreen:["#7bdcc0"],greenColor:["#6aedc7"],blueColor:["#39c2c9"],yellowColor:["#ffce00"],orangeColor:["#ffa71a"],pinkColor:["#f866b9"],purpleColor:["#998ce3"]},singleColorsHuman:{aloeGreen:"Aloe Green",greenColor:"Green",blueColor:"Blue",yellowColor:"Yellow",orangeColor:"Orange",pinkColor:"Pink",purpleColor:"Purple"}}}.call(n,e,n,t))||(t.exports=r)},,function(t,n,e){"use strict";e.d(n,"a",(function(){return r})),e.d(n,"b",(function(){return i}));var r=Math.PI/180,i=180/Math.PI},function(t,n,e){"use strict";e.r(n);var r=e(69);e.d(n,"dispatch",(function(){return r.a}))},function(t,n,e){"use strict";var r={value:function(){}};function i(){for(var t,n=0,e=arguments.length,r={};n<e;++n){if(!(t=arguments[n]+"")||t in r||/[\s.]/.test(t))throw new Error("illegal type: "+t);r[t]=[]}return new o(r)}function o(t){this._=t}function u(t,n){return t.trim().split(/^|\s+/).map((function(t){var e="",r=t.indexOf(".");if(r>=0&&(e=t.slice(r+1),t=t.slice(0,r)),t&&!n.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:e}}))}function a(t,n){for(var e,r=0,i=t.length;r<i;++r)if((e=t[r]).name===n)return e.value}function c(t,n,e){for(var i=0,o=t.length;i<o;++i)if(t[i].name===n){t[i]=r,t=t.slice(0,i).concat(t.slice(i+1));break}return null!=e&&t.push({name:n,value:e}),t}o.prototype=i.prototype={constructor:o,on:function(t,n){var e,r=this._,i=u(t+"",r),o=-1,s=i.length;if(!(arguments.length<2)){if(null!=n&&"function"!=typeof n)throw new Error("invalid callback: "+n);for(;++o<s;)if(e=(t=i[o]).type)r[e]=c(r[e],t.name,n);else if(null==n)for(e in r)r[e]=c(r[e],t.name,null);return this}for(;++o<s;)if((e=(t=i[o]).type)&&(e=a(r[e],t.name)))return e},copy:function(){var t={},n=this._;for(var e in n)t[e]=n[e].slice();return new o(t)},call:function(t,n){if((e=arguments.length-2)>0)for(var e,r,i=new Array(e),o=0;o<e;++o)i[o]=arguments[o+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(o=0,e=(r=this._[t]).length;o<e;++o)r[o].value.apply(n,i)},apply:function(t,n,e){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],i=0,o=r.length;i<o;++i)r[i].value.apply(n,e)}},n.a=i},function(t,n,e){"use strict";var r;void 0===(r=function(){var t=e(71),n=e(38);return{axisTimeCombinations:{MINUTE_HOUR:"minute-hour",HOUR_DAY:"hour-daymonth",DAY_MONTH:"day-month",MONTH_YEAR:"month-year",CUSTOM:"custom"},curveMap:{linear:t.curveLinear,basis:t.curveBasis,cardinal:t.curveCardinal,catmullRom:t.curveCatmullRom,monotoneX:t.curveMonotoneX,monotoneY:t.curveMonotoneY,natural:t.curveNatural,step:t.curveStep,stepAfter:t.curveStepAfter,stepBefore:t.curveStepBefore},emptyDonutData:[{quantity:1,percentage:100}],hoursHuman:["00h","01h","02h","03h","04h","05h","06h","07h","08h","09h","10h","11h","12h","13h","14h","15h","16h","17h","18h","19h","20h","21h","22h","23h"],timeBenchmarks:{ONE_AND_A_HALF_YEARS:47304e6,ONE_YEAR:31536000365,ONE_DAY:86400001},lineGradientId:"lineGradientId",timeIntervals:{timeMillisecond:n.timeMillisecond,utcMillisecond:n.utcMillisecond,timeSecond:n.timeSecond,utcSecond:n.utcSecond,timeMinute:n.timeMinute,utcMinute:n.utcMinute,timeHour:n.timeHour,utcHour:n.utcHour,timeDay:n.timeDay,utcDay:n.utcDay,timeWeek:n.timeWeek,utcWeek:n.utcWeek,timeSunday:n.timeSunday,utcSunday:n.utcSunday,timeMonday:n.timeMonday,utcMonday:n.utcMonday,timeTuesday:n.timeTuesday,utcTuesday:n.utcTuesday,timeWednesday:n.timeWednesday,utcWednesday:n.utcWednesday,timeThursday:n.timeThursday,utcThursday:n.utcThursday,timeFriday:n.timeFriday,utcFriday:n.utcFriday,timeSaturday:n.timeSaturday,utcSaturday:n.utcSaturday,timeMonth:n.timeMonth,utcMonth:n.utcMonth,timeYear:n.timeYear,utcYear:n.utcYear},FORMAT_LOCALE_URL:"https://cdn.jsdelivr.net/npm/d3-format/locale"}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";e.r(n);var r=Math.PI,i=2*r,o=i-1e-6;function u(){this._x0=this._y0=this._x1=this._y1=null,this._=""}function a(){return new u}u.prototype=a.prototype={constructor:u,moveTo:function(t,n){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+n)},closePath:function(){null!==this._x1&&(this._x1=this._x0,this._y1=this._y0,this._+="Z")},lineTo:function(t,n){this._+="L"+(this._x1=+t)+","+(this._y1=+n)},quadraticCurveTo:function(t,n,e,r){this._+="Q"+ +t+","+ +n+","+(this._x1=+e)+","+(this._y1=+r)},bezierCurveTo:function(t,n,e,r,i,o){this._+="C"+ +t+","+ +n+","+ +e+","+ +r+","+(this._x1=+i)+","+(this._y1=+o)},arcTo:function(t,n,e,i,o){t=+t,n=+n,e=+e,i=+i,o=+o;var u=this._x1,a=this._y1,c=e-t,s=i-n,l=u-t,f=a-n,h=l*l+f*f;if(o<0)throw new Error("negative radius: "+o);if(null===this._x1)this._+="M"+(this._x1=t)+","+(this._y1=n);else if(h>1e-6)if(Math.abs(f*c-s*l)>1e-6&&o){var d=e-u,p=i-a,_=c*c+s*s,g=d*d+p*p,y=Math.sqrt(_),v=Math.sqrt(h),m=o*Math.tan((r-Math.acos((_+h-g)/(2*y*v)))/2),x=m/v,b=m/y;Math.abs(x-1)>1e-6&&(this._+="L"+(t+x*l)+","+(n+x*f)),this._+="A"+o+","+o+",0,0,"+ +(f*d>l*p)+","+(this._x1=t+b*c)+","+(this._y1=n+b*s)}else this._+="L"+(this._x1=t)+","+(this._y1=n);else;},arc:function(t,n,e,u,a,c){t=+t,n=+n,c=!!c;var s=(e=+e)*Math.cos(u),l=e*Math.sin(u),f=t+s,h=n+l,d=1^c,p=c?u-a:a-u;if(e<0)throw new Error("negative radius: "+e);null===this._x1?this._+="M"+f+","+h:(Math.abs(this._x1-f)>1e-6||Math.abs(this._y1-h)>1e-6)&&(this._+="L"+f+","+h),e&&(p<0&&(p=p%i+i),p>o?this._+="A"+e+","+e+",0,1,"+d+","+(t-s)+","+(n-l)+"A"+e+","+e+",0,1,"+d+","+(this._x1=f)+","+(this._y1=h):p>1e-6&&(this._+="A"+e+","+e+",0,"+ +(p>=r)+","+d+","+(this._x1=t+e*Math.cos(a))+","+(this._y1=n+e*Math.sin(a))))},rect:function(t,n,e,r){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+n)+"h"+ +e+"v"+ +r+"h"+-e+"Z"},toString:function(){return this._}};var c=a,s=function(t){return function(){return t}},l=Math.abs,f=Math.atan2,h=Math.cos,d=Math.max,p=Math.min,_=Math.sin,g=Math.sqrt,y=Math.PI,v=y/2,m=2*y;function x(t){return t>1?0:t<-1?y:Math.acos(t)}function b(t){return t>=1?v:t<=-1?-v:Math.asin(t)}function w(t){return t.innerRadius}function M(t){return t.outerRadius}function T(t){return t.startAngle}function O(t){return t.endAngle}function A(t){return t&&t.padAngle}function k(t,n,e,r,i,o,u,a){var c=e-t,s=r-n,l=u-i,f=a-o,h=f*c-l*s;if(!(h*h<1e-12))return[t+(h=(l*(n-o)-f*(t-i))/h)*c,n+h*s]}function C(t,n,e,r,i,o,u){var a=t-e,c=n-r,s=(u?o:-o)/g(a*a+c*c),l=s*c,f=-s*a,h=t+l,p=n+f,_=e+l,y=r+f,v=(h+_)/2,m=(p+y)/2,x=_-h,b=y-p,w=x*x+b*b,M=i-o,T=h*y-_*p,O=(b<0?-1:1)*g(d(0,M*M*w-T*T)),A=(T*b-x*O)/w,k=(-T*x-b*O)/w,C=(T*b+x*O)/w,S=(-T*x+b*O)/w,N=A-v,E=k-m,j=C-v,D=S-m;return N*N+E*E>j*j+D*D&&(A=C,k=S),{cx:A,cy:k,x01:-l,y01:-f,x11:A*(i/M-1),y11:k*(i/M-1)}}var S=function(){var t=w,n=M,e=s(0),r=null,i=T,o=O,u=A,a=null;function d(){var s,d,w=+t.apply(this,arguments),M=+n.apply(this,arguments),T=i.apply(this,arguments)-v,O=o.apply(this,arguments)-v,A=l(O-T),S=O>T;if(a||(a=s=c()),M<w&&(d=M,M=w,w=d),M>1e-12)if(A>m-1e-12)a.moveTo(M*h(T),M*_(T)),a.arc(0,0,M,T,O,!S),w>1e-12&&(a.moveTo(w*h(O),w*_(O)),a.arc(0,0,w,O,T,S));else{var N,E,j=T,D=O,F=T,P=O,L=A,I=A,U=u.apply(this,arguments)/2,R=U>1e-12&&(r?+r.apply(this,arguments):g(w*w+M*M)),B=p(l(M-w)/2,+e.apply(this,arguments)),H=B,q=B;if(R>1e-12){var Y=b(R/w*_(U)),z=b(R/M*_(U));(L-=2*Y)>1e-12?(F+=Y*=S?1:-1,P-=Y):(L=0,F=P=(T+O)/2),(I-=2*z)>1e-12?(j+=z*=S?1:-1,D-=z):(I=0,j=D=(T+O)/2)}var G=M*h(j),V=M*_(j),X=w*h(P),W=w*_(P);if(B>1e-12){var $,Z=M*h(D),Q=M*_(D),J=w*h(F),K=w*_(F);if(A<y&&($=k(G,V,J,K,Z,Q,X,W))){var tt=G-$[0],nt=V-$[1],et=Z-$[0],rt=Q-$[1],it=1/_(x((tt*et+nt*rt)/(g(tt*tt+nt*nt)*g(et*et+rt*rt)))/2),ot=g($[0]*$[0]+$[1]*$[1]);H=p(B,(w-ot)/(it-1)),q=p(B,(M-ot)/(it+1))}}I>1e-12?q>1e-12?(N=C(J,K,G,V,M,q,S),E=C(Z,Q,X,W,M,q,S),a.moveTo(N.cx+N.x01,N.cy+N.y01),q<B?a.arc(N.cx,N.cy,q,f(N.y01,N.x01),f(E.y01,E.x01),!S):(a.arc(N.cx,N.cy,q,f(N.y01,N.x01),f(N.y11,N.x11),!S),a.arc(0,0,M,f(N.cy+N.y11,N.cx+N.x11),f(E.cy+E.y11,E.cx+E.x11),!S),a.arc(E.cx,E.cy,q,f(E.y11,E.x11),f(E.y01,E.x01),!S))):(a.moveTo(G,V),a.arc(0,0,M,j,D,!S)):a.moveTo(G,V),w>1e-12&&L>1e-12?H>1e-12?(N=C(X,W,Z,Q,w,-H,S),E=C(G,V,J,K,w,-H,S),a.lineTo(N.cx+N.x01,N.cy+N.y01),H<B?a.arc(N.cx,N.cy,H,f(N.y01,N.x01),f(E.y01,E.x01),!S):(a.arc(N.cx,N.cy,H,f(N.y01,N.x01),f(N.y11,N.x11),!S),a.arc(0,0,w,f(N.cy+N.y11,N.cx+N.x11),f(E.cy+E.y11,E.cx+E.x11),S),a.arc(E.cx,E.cy,H,f(E.y11,E.x11),f(E.y01,E.x01),!S))):a.arc(0,0,w,P,F,S):a.lineTo(X,W)}else a.moveTo(0,0);if(a.closePath(),s)return a=null,s+""||null}return d.centroid=function(){var e=(+t.apply(this,arguments)+ +n.apply(this,arguments))/2,r=(+i.apply(this,arguments)+ +o.apply(this,arguments))/2-y/2;return[h(r)*e,_(r)*e]},d.innerRadius=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),d):t},d.outerRadius=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),d):n},d.cornerRadius=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),d):e},d.padRadius=function(t){return arguments.length?(r=null==t?null:"function"==typeof t?t:s(+t),d):r},d.startAngle=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),d):i},d.endAngle=function(t){return arguments.length?(o="function"==typeof t?t:s(+t),d):o},d.padAngle=function(t){return arguments.length?(u="function"==typeof t?t:s(+t),d):u},d.context=function(t){return arguments.length?(a=null==t?null:t,d):a},d};function N(t){this._context=t}N.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._point=0},lineEnd:function(){(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;default:this._context.lineTo(t,n)}}};var E=function(t){return new N(t)};function j(t){return t[0]}function D(t){return t[1]}var F=function(){var t=j,n=D,e=s(!0),r=null,i=E,o=null;function u(u){var a,s,l,f=u.length,h=!1;for(null==r&&(o=i(l=c())),a=0;a<=f;++a)!(a<f&&e(s=u[a],a,u))===h&&((h=!h)?o.lineStart():o.lineEnd()),h&&o.point(+t(s,a,u),+n(s,a,u));if(l)return o=null,l+""||null}return u.x=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),u):t},u.y=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),u):n},u.defined=function(t){return arguments.length?(e="function"==typeof t?t:s(!!t),u):e},u.curve=function(t){return arguments.length?(i=t,null!=r&&(o=i(r)),u):i},u.context=function(t){return arguments.length?(null==t?r=o=null:o=i(r=t),u):r},u},P=function(){var t=j,n=null,e=s(0),r=D,i=s(!0),o=null,u=E,a=null;function l(s){var l,f,h,d,p,_=s.length,g=!1,y=new Array(_),v=new Array(_);for(null==o&&(a=u(p=c())),l=0;l<=_;++l){if(!(l<_&&i(d=s[l],l,s))===g)if(g=!g)f=l,a.areaStart(),a.lineStart();else{for(a.lineEnd(),a.lineStart(),h=l-1;h>=f;--h)a.point(y[h],v[h]);a.lineEnd(),a.areaEnd()}g&&(y[l]=+t(d,l,s),v[l]=+e(d,l,s),a.point(n?+n(d,l,s):y[l],r?+r(d,l,s):v[l]))}if(p)return a=null,p+""||null}function f(){return F().defined(i).curve(u).context(o)}return l.x=function(e){return arguments.length?(t="function"==typeof e?e:s(+e),n=null,l):t},l.x0=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),l):t},l.x1=function(t){return arguments.length?(n=null==t?null:"function"==typeof t?t:s(+t),l):n},l.y=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),r=null,l):e},l.y0=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),l):e},l.y1=function(t){return arguments.length?(r=null==t?null:"function"==typeof t?t:s(+t),l):r},l.lineX0=l.lineY0=function(){return f().x(t).y(e)},l.lineY1=function(){return f().x(t).y(r)},l.lineX1=function(){return f().x(n).y(e)},l.defined=function(t){return arguments.length?(i="function"==typeof t?t:s(!!t),l):i},l.curve=function(t){return arguments.length?(u=t,null!=o&&(a=u(o)),l):u},l.context=function(t){return arguments.length?(null==t?o=a=null:a=u(o=t),l):o},l},L=function(t,n){return n<t?-1:n>t?1:n>=t?0:NaN},I=function(t){return t},U=function(){var t=I,n=L,e=null,r=s(0),i=s(m),o=s(0);function u(u){var a,c,s,l,f,h=u.length,d=0,p=new Array(h),_=new Array(h),g=+r.apply(this,arguments),y=Math.min(m,Math.max(-m,i.apply(this,arguments)-g)),v=Math.min(Math.abs(y)/h,o.apply(this,arguments)),x=v*(y<0?-1:1);for(a=0;a<h;++a)(f=_[p[a]=a]=+t(u[a],a,u))>0&&(d+=f);for(null!=n?p.sort((function(t,e){return n(_[t],_[e])})):null!=e&&p.sort((function(t,n){return e(u[t],u[n])})),a=0,s=d?(y-h*x)/d:0;a<h;++a,g=l)c=p[a],l=g+((f=_[c])>0?f*s:0)+x,_[c]={data:u[c],index:a,value:f,startAngle:g,endAngle:l,padAngle:v};return _}return u.value=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),u):t},u.sortValues=function(t){return arguments.length?(n=t,e=null,u):n},u.sort=function(t){return arguments.length?(e=t,n=null,u):e},u.startAngle=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),u):r},u.endAngle=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),u):i},u.padAngle=function(t){return arguments.length?(o="function"==typeof t?t:s(+t),u):o},u},R=H(E);function B(t){this._curve=t}function H(t){function n(n){return new B(t(n))}return n._curve=t,n}function q(t){var n=t.curve;return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t.curve=function(t){return arguments.length?n(H(t)):n()._curve},t}B.prototype={areaStart:function(){this._curve.areaStart()},areaEnd:function(){this._curve.areaEnd()},lineStart:function(){this._curve.lineStart()},lineEnd:function(){this._curve.lineEnd()},point:function(t,n){this._curve.point(n*Math.sin(t),n*-Math.cos(t))}};var Y=function(){return q(F().curve(R))},z=function(){var t=P().curve(R),n=t.curve,e=t.lineX0,r=t.lineX1,i=t.lineY0,o=t.lineY1;return t.angle=t.x,delete t.x,t.startAngle=t.x0,delete t.x0,t.endAngle=t.x1,delete t.x1,t.radius=t.y,delete t.y,t.innerRadius=t.y0,delete t.y0,t.outerRadius=t.y1,delete t.y1,t.lineStartAngle=function(){return q(e())},delete t.lineX0,t.lineEndAngle=function(){return q(r())},delete t.lineX1,t.lineInnerRadius=function(){return q(i())},delete t.lineY0,t.lineOuterRadius=function(){return q(o())},delete t.lineY1,t.curve=function(t){return arguments.length?n(H(t)):n()._curve},t},G=function(t,n){return[(n=+n)*Math.cos(t-=Math.PI/2),n*Math.sin(t)]},V=Array.prototype.slice;function X(t){return t.source}function W(t){return t.target}function $(t){var n=X,e=W,r=j,i=D,o=null;function u(){var u,a=V.call(arguments),s=n.apply(this,a),l=e.apply(this,a);if(o||(o=u=c()),t(o,+r.apply(this,(a[0]=s,a)),+i.apply(this,a),+r.apply(this,(a[0]=l,a)),+i.apply(this,a)),u)return o=null,u+""||null}return u.source=function(t){return arguments.length?(n=t,u):n},u.target=function(t){return arguments.length?(e=t,u):e},u.x=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),u):r},u.y=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),u):i},u.context=function(t){return arguments.length?(o=null==t?null:t,u):o},u}function Z(t,n,e,r,i){t.moveTo(n,e),t.bezierCurveTo(n=(n+r)/2,e,n,i,r,i)}function Q(t,n,e,r,i){t.moveTo(n,e),t.bezierCurveTo(n,e=(e+i)/2,r,e,r,i)}function J(t,n,e,r,i){var o=G(n,e),u=G(n,e=(e+i)/2),a=G(r,e),c=G(r,i);t.moveTo(o[0],o[1]),t.bezierCurveTo(u[0],u[1],a[0],a[1],c[0],c[1])}function K(){return $(Z)}function tt(){return $(Q)}function nt(){var t=$(J);return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t}var et={draw:function(t,n){var e=Math.sqrt(n/y);t.moveTo(e,0),t.arc(0,0,e,0,m)}},rt={draw:function(t,n){var e=Math.sqrt(n/5)/2;t.moveTo(-3*e,-e),t.lineTo(-e,-e),t.lineTo(-e,-3*e),t.lineTo(e,-3*e),t.lineTo(e,-e),t.lineTo(3*e,-e),t.lineTo(3*e,e),t.lineTo(e,e),t.lineTo(e,3*e),t.lineTo(-e,3*e),t.lineTo(-e,e),t.lineTo(-3*e,e),t.closePath()}},it=Math.sqrt(1/3),ot=2*it,ut={draw:function(t,n){var e=Math.sqrt(n/ot),r=e*it;t.moveTo(0,-e),t.lineTo(r,0),t.lineTo(0,e),t.lineTo(-r,0),t.closePath()}},at=Math.sin(y/10)/Math.sin(7*y/10),ct=Math.sin(m/10)*at,st=-Math.cos(m/10)*at,lt={draw:function(t,n){var e=Math.sqrt(.8908130915292852*n),r=ct*e,i=st*e;t.moveTo(0,-e),t.lineTo(r,i);for(var o=1;o<5;++o){var u=m*o/5,a=Math.cos(u),c=Math.sin(u);t.lineTo(c*e,-a*e),t.lineTo(a*r-c*i,c*r+a*i)}t.closePath()}},ft={draw:function(t,n){var e=Math.sqrt(n),r=-e/2;t.rect(r,r,e,e)}},ht=Math.sqrt(3),dt={draw:function(t,n){var e=-Math.sqrt(n/(3*ht));t.moveTo(0,2*e),t.lineTo(-ht*e,-e),t.lineTo(ht*e,-e),t.closePath()}},pt=Math.sqrt(3)/2,_t=1/Math.sqrt(12),gt=3*(_t/2+1),yt={draw:function(t,n){var e=Math.sqrt(n/gt),r=e/2,i=e*_t,o=r,u=e*_t+e,a=-o,c=u;t.moveTo(r,i),t.lineTo(o,u),t.lineTo(a,c),t.lineTo(-.5*r-pt*i,pt*r+-.5*i),t.lineTo(-.5*o-pt*u,pt*o+-.5*u),t.lineTo(-.5*a-pt*c,pt*a+-.5*c),t.lineTo(-.5*r+pt*i,-.5*i-pt*r),t.lineTo(-.5*o+pt*u,-.5*u-pt*o),t.lineTo(-.5*a+pt*c,-.5*c-pt*a),t.closePath()}},vt=[et,rt,ut,ft,lt,dt,yt],mt=function(){var t=s(et),n=s(64),e=null;function r(){var r;if(e||(e=r=c()),t.apply(this,arguments).draw(e,+n.apply(this,arguments)),r)return e=null,r+""||null}return r.type=function(n){return arguments.length?(t="function"==typeof n?n:s(n),r):t},r.size=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),r):n},r.context=function(t){return arguments.length?(e=null==t?null:t,r):e},r},xt=function(){};function bt(t,n,e){t._context.bezierCurveTo((2*t._x0+t._x1)/3,(2*t._y0+t._y1)/3,(t._x0+2*t._x1)/3,(t._y0+2*t._y1)/3,(t._x0+4*t._x1+n)/6,(t._y0+4*t._y1+e)/6)}function wt(t){this._context=t}wt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){switch(this._point){case 3:bt(this,this._x1,this._y1);case 2:this._context.lineTo(this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3,this._context.lineTo((5*this._x0+this._x1)/6,(5*this._y0+this._y1)/6);default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var Mt=function(t){return new wt(t)};function Tt(t){this._context=t}Tt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._y0=this._y1=this._y2=this._y3=this._y4=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x2,this._y2),this._context.closePath();break;case 2:this._context.moveTo((this._x2+2*this._x3)/3,(this._y2+2*this._y3)/3),this._context.lineTo((this._x3+2*this._x2)/3,(this._y3+2*this._y2)/3),this._context.closePath();break;case 3:this.point(this._x2,this._y2),this.point(this._x3,this._y3),this.point(this._x4,this._y4)}},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._x2=t,this._y2=n;break;case 1:this._point=2,this._x3=t,this._y3=n;break;case 2:this._point=3,this._x4=t,this._y4=n,this._context.moveTo((this._x0+4*this._x1+t)/6,(this._y0+4*this._y1+n)/6);break;default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var Ot=function(t){return new Tt(t)};function At(t){this._context=t}At.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3;var e=(this._x0+4*this._x1+t)/6,r=(this._y0+4*this._y1+n)/6;this._line?this._context.lineTo(e,r):this._context.moveTo(e,r);break;case 3:this._point=4;default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var kt=function(t){return new At(t)};function Ct(t,n){this._basis=new wt(t),this._beta=n}Ct.prototype={lineStart:function(){this._x=[],this._y=[],this._basis.lineStart()},lineEnd:function(){var t=this._x,n=this._y,e=t.length-1;if(e>0)for(var r,i=t[0],o=n[0],u=t[e]-i,a=n[e]-o,c=-1;++c<=e;)r=c/e,this._basis.point(this._beta*t[c]+(1-this._beta)*(i+r*u),this._beta*n[c]+(1-this._beta)*(o+r*a));this._x=this._y=null,this._basis.lineEnd()},point:function(t,n){this._x.push(+t),this._y.push(+n)}};var St=function t(n){function e(t){return 1===n?new wt(t):new Ct(t,n)}return e.beta=function(n){return t(+n)},e}(.85);function Nt(t,n,e){t._context.bezierCurveTo(t._x1+t._k*(t._x2-t._x0),t._y1+t._k*(t._y2-t._y0),t._x2+t._k*(t._x1-n),t._y2+t._k*(t._y1-e),t._x2,t._y2)}function Et(t,n){this._context=t,this._k=(1-n)/6}Et.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:Nt(this,this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2,this._x1=t,this._y1=n;break;case 2:this._point=3;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var jt=function t(n){function e(t){return new Et(t,n)}return e.tension=function(n){return t(+n)},e}(0);function Dt(t,n){this._context=t,this._k=(1-n)/6}Dt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._x3=t,this._y3=n;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=n);break;case 2:this._point=3,this._x5=t,this._y5=n;break;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Ft=function t(n){function e(t){return new Dt(t,n)}return e.tension=function(n){return t(+n)},e}(0);function Pt(t,n){this._context=t,this._k=(1-n)/6}Pt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Lt=function t(n){function e(t){return new Pt(t,n)}return e.tension=function(n){return t(+n)},e}(0);function It(t,n,e){var r=t._x1,i=t._y1,o=t._x2,u=t._y2;if(t._l01_a>1e-12){var a=2*t._l01_2a+3*t._l01_a*t._l12_a+t._l12_2a,c=3*t._l01_a*(t._l01_a+t._l12_a);r=(r*a-t._x0*t._l12_2a+t._x2*t._l01_2a)/c,i=(i*a-t._y0*t._l12_2a+t._y2*t._l01_2a)/c}if(t._l23_a>1e-12){var s=2*t._l23_2a+3*t._l23_a*t._l12_a+t._l12_2a,l=3*t._l23_a*(t._l23_a+t._l12_a);o=(o*s+t._x1*t._l23_2a-n*t._l12_2a)/l,u=(u*s+t._y1*t._l23_2a-e*t._l12_2a)/l}t._context.bezierCurveTo(r,i,o,u,t._x2,t._y2)}function Ut(t,n){this._context=t,this._alpha=n}Ut.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:this.point(this._x2,this._y2)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Rt=function t(n){function e(t){return n?new Ut(t,n):new Et(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function Bt(t,n){this._context=t,this._alpha=n}Bt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._x3=t,this._y3=n;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=n);break;case 2:this._point=3,this._x5=t,this._y5=n;break;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Ht=function t(n){function e(t){return n?new Bt(t,n):new Dt(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function qt(t,n){this._context=t,this._alpha=n}qt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Yt=function t(n){function e(t){return n?new qt(t,n):new Pt(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function zt(t){this._context=t}zt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._point=0},lineEnd:function(){this._point&&this._context.closePath()},point:function(t,n){t=+t,n=+n,this._point?this._context.lineTo(t,n):(this._point=1,this._context.moveTo(t,n))}};var Gt=function(t){return new zt(t)};function Vt(t){return t<0?-1:1}function Xt(t,n,e){var r=t._x1-t._x0,i=n-t._x1,o=(t._y1-t._y0)/(r||i<0&&-0),u=(e-t._y1)/(i||r<0&&-0),a=(o*i+u*r)/(r+i);return(Vt(o)+Vt(u))*Math.min(Math.abs(o),Math.abs(u),.5*Math.abs(a))||0}function Wt(t,n){var e=t._x1-t._x0;return e?(3*(t._y1-t._y0)/e-n)/2:n}function $t(t,n,e){var r=t._x0,i=t._y0,o=t._x1,u=t._y1,a=(o-r)/3;t._context.bezierCurveTo(r+a,i+a*n,o-a,u-a*e,o,u)}function Zt(t){this._context=t}function Qt(t){this._context=new Jt(t)}function Jt(t){this._context=t}function Kt(t){return new Zt(t)}function tn(t){return new Qt(t)}function nn(t){this._context=t}function en(t){var n,e,r=t.length-1,i=new Array(r),o=new Array(r),u=new Array(r);for(i[0]=0,o[0]=2,u[0]=t[0]+2*t[1],n=1;n<r-1;++n)i[n]=1,o[n]=4,u[n]=4*t[n]+2*t[n+1];for(i[r-1]=2,o[r-1]=7,u[r-1]=8*t[r-1]+t[r],n=1;n<r;++n)e=i[n]/o[n-1],o[n]-=e,u[n]-=e*u[n-1];for(i[r-1]=u[r-1]/o[r-1],n=r-2;n>=0;--n)i[n]=(u[n]-i[n+1])/o[n];for(o[r-1]=(t[r]+i[r-1])/2,n=0;n<r-1;++n)o[n]=2*t[n+1]-i[n+1];return[i,o]}Zt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=this._t0=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x1,this._y1);break;case 3:$t(this,this._t0,Wt(this,this._t0))}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){var e=NaN;if(n=+n,(t=+t)!==this._x1||n!==this._y1){switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3,$t(this,Wt(this,e=Xt(this,t,n)),e);break;default:$t(this,this._t0,e=Xt(this,t,n))}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n,this._t0=e}}},(Qt.prototype=Object.create(Zt.prototype)).point=function(t,n){Zt.prototype.point.call(this,n,t)},Jt.prototype={moveTo:function(t,n){this._context.moveTo(n,t)},closePath:function(){this._context.closePath()},lineTo:function(t,n){this._context.lineTo(n,t)},bezierCurveTo:function(t,n,e,r,i,o){this._context.bezierCurveTo(n,t,r,e,o,i)}},nn.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=[],this._y=[]},lineEnd:function(){var t=this._x,n=this._y,e=t.length;if(e)if(this._line?this._context.lineTo(t[0],n[0]):this._context.moveTo(t[0],n[0]),2===e)this._context.lineTo(t[1],n[1]);else for(var r=en(t),i=en(n),o=0,u=1;u<e;++o,++u)this._context.bezierCurveTo(r[0][o],i[0][o],r[1][o],i[1][o],t[u],n[u]);(this._line||0!==this._line&&1===e)&&this._context.closePath(),this._line=1-this._line,this._x=this._y=null},point:function(t,n){this._x.push(+t),this._y.push(+n)}};var rn=function(t){return new nn(t)};function on(t,n){this._context=t,this._t=n}on.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=this._y=NaN,this._point=0},lineEnd:function(){0<this._t&&this._t<1&&2===this._point&&this._context.lineTo(this._x,this._y),(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line>=0&&(this._t=1-this._t,this._line=1-this._line)},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;default:if(this._t<=0)this._context.lineTo(this._x,n),this._context.lineTo(t,n);else{var e=this._x*(1-this._t)+t*this._t;this._context.lineTo(e,this._y),this._context.lineTo(e,n)}}this._x=t,this._y=n}};var un=function(t){return new on(t,.5)};function an(t){return new on(t,0)}function cn(t){return new on(t,1)}var sn=function(t,n){if((i=t.length)>1)for(var e,r,i,o=1,u=t[n[0]],a=u.length;o<i;++o)for(r=u,u=t[n[o]],e=0;e<a;++e)u[e][1]+=u[e][0]=isNaN(r[e][1])?r[e][0]:r[e][1]},ln=function(t){for(var n=t.length,e=new Array(n);--n>=0;)e[n]=n;return e};function fn(t,n){return t[n]}var hn=function(){var t=s([]),n=ln,e=sn,r=fn;function i(i){var o,u,a=t.apply(this,arguments),c=i.length,s=a.length,l=new Array(s);for(o=0;o<s;++o){for(var f,h=a[o],d=l[o]=new Array(c),p=0;p<c;++p)d[p]=f=[0,+r(i[p],h,p,i)],f.data=i[p];d.key=h}for(o=0,u=n(l);o<s;++o)l[u[o]].index=o;return e(l,u),l}return i.keys=function(n){return arguments.length?(t="function"==typeof n?n:s(V.call(n)),i):t},i.value=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),i):r},i.order=function(t){return arguments.length?(n=null==t?ln:"function"==typeof t?t:s(V.call(t)),i):n},i.offset=function(t){return arguments.length?(e=null==t?sn:t,i):e},i},dn=function(t,n){if((r=t.length)>0){for(var e,r,i,o=0,u=t[0].length;o<u;++o){for(i=e=0;e<r;++e)i+=t[e][o][1]||0;if(i)for(e=0;e<r;++e)t[e][o][1]/=i}sn(t,n)}},pn=function(t,n){if((a=t.length)>0)for(var e,r,i,o,u,a,c=0,s=t[n[0]].length;c<s;++c)for(o=u=0,e=0;e<a;++e)(i=(r=t[n[e]][c])[1]-r[0])>0?(r[0]=o,r[1]=o+=i):i<0?(r[1]=u,r[0]=u+=i):(r[0]=0,r[1]=i)},_n=function(t,n){if((e=t.length)>0){for(var e,r=0,i=t[n[0]],o=i.length;r<o;++r){for(var u=0,a=0;u<e;++u)a+=t[u][r][1]||0;i[r][1]+=i[r][0]=-a/2}sn(t,n)}},gn=function(t,n){if((i=t.length)>0&&(r=(e=t[n[0]]).length)>0){for(var e,r,i,o=0,u=1;u<r;++u){for(var a=0,c=0,s=0;a<i;++a){for(var l=t[n[a]],f=l[u][1]||0,h=(f-(l[u-1][1]||0))/2,d=0;d<a;++d){var p=t[n[d]];h+=(p[u][1]||0)-(p[u-1][1]||0)}c+=f,s+=h*f}e[u-1][1]+=e[u-1][0]=o,c&&(o-=s/c)}e[u-1][1]+=e[u-1][0]=o,sn(t,n)}},yn=function(t){var n=t.map(vn);return ln(t).sort((function(t,e){return n[t]-n[e]}))};function vn(t){for(var n,e=-1,r=0,i=t.length,o=-1/0;++e<i;)(n=+t[e][1])>o&&(o=n,r=e);return r}var mn=function(t){var n=t.map(xn);return ln(t).sort((function(t,e){return n[t]-n[e]}))};function xn(t){for(var n,e=0,r=-1,i=t.length;++r<i;)(n=+t[r][1])&&(e+=n);return e}var bn=function(t){return mn(t).reverse()},wn=function(t){var n,e,r=t.length,i=t.map(xn),o=yn(t),u=0,a=0,c=[],s=[];for(n=0;n<r;++n)e=o[n],u<a?(u+=i[e],c.push(e)):(a+=i[e],s.push(e));return s.reverse().concat(c)},Mn=function(t){return ln(t).reverse()};e.d(n,"arc",(function(){return S})),e.d(n,"area",(function(){return P})),e.d(n,"line",(function(){return F})),e.d(n,"pie",(function(){return U})),e.d(n,"areaRadial",(function(){return z})),e.d(n,"radialArea",(function(){return z})),e.d(n,"lineRadial",(function(){return Y})),e.d(n,"radialLine",(function(){return Y})),e.d(n,"pointRadial",(function(){return G})),e.d(n,"linkHorizontal",(function(){return K})),e.d(n,"linkVertical",(function(){return tt})),e.d(n,"linkRadial",(function(){return nt})),e.d(n,"symbol",(function(){return mt})),e.d(n,"symbols",(function(){return vt})),e.d(n,"symbolCircle",(function(){return et})),e.d(n,"symbolCross",(function(){return rt})),e.d(n,"symbolDiamond",(function(){return ut})),e.d(n,"symbolSquare",(function(){return ft})),e.d(n,"symbolStar",(function(){return lt})),e.d(n,"symbolTriangle",(function(){return dt})),e.d(n,"symbolWye",(function(){return yt})),e.d(n,"curveBasisClosed",(function(){return Ot})),e.d(n,"curveBasisOpen",(function(){return kt})),e.d(n,"curveBasis",(function(){return Mt})),e.d(n,"curveBundle",(function(){return St})),e.d(n,"curveCardinalClosed",(function(){return Ft})),e.d(n,"curveCardinalOpen",(function(){return Lt})),e.d(n,"curveCardinal",(function(){return jt})),e.d(n,"curveCatmullRomClosed",(function(){return Ht})),e.d(n,"curveCatmullRomOpen",(function(){return Yt})),e.d(n,"curveCatmullRom",(function(){return Rt})),e.d(n,"curveLinearClosed",(function(){return Gt})),e.d(n,"curveLinear",(function(){return E})),e.d(n,"curveMonotoneX",(function(){return Kt})),e.d(n,"curveMonotoneY",(function(){return tn})),e.d(n,"curveNatural",(function(){return rn})),e.d(n,"curveStep",(function(){return un})),e.d(n,"curveStepAfter",(function(){return cn})),e.d(n,"curveStepBefore",(function(){return an})),e.d(n,"stack",(function(){return hn})),e.d(n,"stackOffsetExpand",(function(){return dn})),e.d(n,"stackOffsetDiverging",(function(){return pn})),e.d(n,"stackOffsetNone",(function(){return sn})),e.d(n,"stackOffsetSilhouette",(function(){return _n})),e.d(n,"stackOffsetWiggle",(function(){return gn})),e.d(n,"stackOrderAppearance",(function(){return yn})),e.d(n,"stackOrderAscending",(function(){return mn})),e.d(n,"stackOrderDescending",(function(){return bn})),e.d(n,"stackOrderInsideOut",(function(){return wn})),e.d(n,"stackOrderNone",(function(){return ln})),e.d(n,"stackOrderReverse",(function(){return Mn}))},function(t,n,e){"use strict";e.r(n);var r,i,o=e(9),u=e(69),a=0,c=0,s=0,l=0,f=0,h=0,d="object"==typeof performance&&performance.now?performance:Date,p="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};function _(){return f||(p(g),f=d.now()+h)}function g(){f=0}function y(){this._call=this._time=this._next=null}function v(t,n,e){var r=new y;return r.restart(t,n,e),r}function m(){f=(l=d.now())+h,a=c=0;try{!function(){_(),++a;for(var t,n=r;n;)(t=f-n._time)>=0&&n._call.call(null,t),n=n._next;--a}()}finally{a=0,function(){var t,n,e=r,o=1/0;for(;e;)e._call?(o>e._time&&(o=e._time),t=e,e=e._next):(n=e._next,e._next=null,e=t?t._next=n:r=n);i=t,b(o)}(),f=0}}function x(){var t=d.now(),n=t-l;n>1e3&&(h-=n,l=t)}function b(t){a||(c&&(c=clearTimeout(c)),t-f>24?(t<1/0&&(c=setTimeout(m,t-d.now()-h)),s&&(s=clearInterval(s))):(s||(l=d.now(),s=setInterval(x,1e3)),a=1,p(m)))}y.prototype=v.prototype={constructor:y,restart:function(t,n,e){if("function"!=typeof t)throw new TypeError("callback is not a function");e=(null==e?_():+e)+(null==n?0:+n),this._next||i===this||(i?i._next=this:r=this,i=this),this._call=t,this._time=e,b()},stop:function(){this._call&&(this._call=null,this._time=1/0,b())}};var w=function(t,n,e){var r=new y;return n=null==n?0:+n,r.restart((function(e){r.stop(),t(e+n)}),n,e),r},M=Object(u.a)("start","end","cancel","interrupt"),T=[],O=function(t,n,e,r,i,o){var u=t.__transition;if(u){if(e in u)return}else t.__transition={};!function(t,n,e){var r,i=t.__transition;function o(c){var s,l,f,h;if(1!==e.state)return a();for(s in i)if((h=i[s]).name===e.name){if(3===h.state)return w(o);4===h.state?(h.state=6,h.timer.stop(),h.on.call("interrupt",t,t.__data__,h.index,h.group),delete i[s]):+s<n&&(h.state=6,h.timer.stop(),h.on.call("cancel",t,t.__data__,h.index,h.group),delete i[s])}if(w((function(){3===e.state&&(e.state=4,e.timer.restart(u,e.delay,e.time),u(c))})),e.state=2,e.on.call("start",t,t.__data__,e.index,e.group),2===e.state){for(e.state=3,r=new Array(f=e.tween.length),s=0,l=-1;s<f;++s)(h=e.tween[s].value.call(t,t.__data__,e.index,e.group))&&(r[++l]=h);r.length=l+1}}function u(n){for(var i=n<e.duration?e.ease.call(null,n/e.duration):(e.timer.restart(a),e.state=5,1),o=-1,u=r.length;++o<u;)r[o].call(t,i);5===e.state&&(e.on.call("end",t,t.__data__,e.index,e.group),a())}function a(){for(var r in e.state=6,e.timer.stop(),delete i[n],i)return;delete t.__transition}i[n]=e,e.timer=v((function(t){e.state=1,e.timer.restart(o,e.delay,e.time),e.delay<=t&&o(t-e.delay)}),0,e.time)}(t,e,{name:n,index:r,group:i,on:M,tween:T,time:o.time,delay:o.delay,duration:o.duration,ease:o.ease,timer:null,state:0})};function A(t,n){var e=C(t,n);if(e.state>0)throw new Error("too late; already scheduled");return e}function k(t,n){var e=C(t,n);if(e.state>3)throw new Error("too late; already running");return e}function C(t,n){var e=t.__transition;if(!e||!(e=e[n]))throw new Error("transition not found");return e}var S=function(t,n){var e,r,i,o=t.__transition,u=!0;if(o){for(i in n=null==n?null:n+"",o)(e=o[i]).name===n?(r=e.state>2&&e.state<5,e.state=6,e.timer.stop(),e.on.call(r?"interrupt":"cancel",t,t.__data__,e.index,e.group),delete o[i]):u=!1;u&&delete t.__transition}},N=e(74),E=e(20);function j(t,n){var e,r;return function(){var i=k(this,t),o=i.tween;if(o!==e)for(var u=0,a=(r=e=o).length;u<a;++u)if(r[u].name===n){(r=r.slice()).splice(u,1);break}i.tween=r}}function D(t,n,e){var r,i;if("function"!=typeof e)throw new Error;return function(){var o=k(this,t),u=o.tween;if(u!==r){i=(r=u).slice();for(var a={name:n,value:e},c=0,s=i.length;c<s;++c)if(i[c].name===n){i[c]=a;break}c===s&&i.push(a)}o.tween=i}}function F(t,n,e){var r=t._id;return t.each((function(){var t=k(this,r);(t.value||(t.value={}))[n]=e.apply(this,arguments)})),function(t){return C(t,r).value[n]}}var P=e(7),L=e(5),I=e(39),U=e(55),R=function(t,n){var e;return("number"==typeof n?L.a:n instanceof P.e?I.a:(e=Object(P.e)(n))?(n=e,I.a):U.a)(t,n)};function B(t){return function(){this.removeAttribute(t)}}function H(t){return function(){this.removeAttributeNS(t.space,t.local)}}function q(t,n,e){var r,i,o=e+"";return function(){var u=this.getAttribute(t);return u===o?null:u===r?i:i=n(r=u,e)}}function Y(t,n,e){var r,i,o=e+"";return function(){var u=this.getAttributeNS(t.space,t.local);return u===o?null:u===r?i:i=n(r=u,e)}}function z(t,n,e){var r,i,o;return function(){var u,a,c=e(this);if(null!=c)return(u=this.getAttribute(t))===(a=c+"")?null:u===r&&a===i?o:(i=a,o=n(r=u,c));this.removeAttribute(t)}}function G(t,n,e){var r,i,o;return function(){var u,a,c=e(this);if(null!=c)return(u=this.getAttributeNS(t.space,t.local))===(a=c+"")?null:u===r&&a===i?o:(i=a,o=n(r=u,c));this.removeAttributeNS(t.space,t.local)}}function V(t,n){return function(e){this.setAttribute(t,n.call(this,e))}}function X(t,n){return function(e){this.setAttributeNS(t.space,t.local,n.call(this,e))}}function W(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&X(t,i)),e}return i._value=n,i}function $(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&V(t,i)),e}return i._value=n,i}function Z(t,n){return function(){A(this,t).delay=+n.apply(this,arguments)}}function Q(t,n){return n=+n,function(){A(this,t).delay=n}}function J(t,n){return function(){k(this,t).duration=+n.apply(this,arguments)}}function K(t,n){return n=+n,function(){k(this,t).duration=n}}function tt(t,n){if("function"!=typeof n)throw new Error;return function(){k(this,t).ease=n}}var nt=e(34);function et(t,n,e){var r,i,o=function(t){return(t+"").trim().split(/^|\s+/).every((function(t){var n=t.indexOf(".");return n>=0&&(t=t.slice(0,n)),!t||"start"===t}))}(n)?A:k;return function(){var u=o(this,t),a=u.on;a!==r&&(i=(r=a).copy()).on(n,e),u.on=i}}var rt=e(19),it=e(33),ot=o.b.prototype.constructor,ut=e(35);function at(t){return function(){this.style.removeProperty(t)}}function ct(t,n,e){return function(r){this.style.setProperty(t,n.call(this,r),e)}}function st(t,n,e){var r,i;function o(){var o=n.apply(this,arguments);return o!==i&&(r=(i=o)&&ct(t,o,e)),r}return o._value=n,o}function lt(t){return function(n){this.textContent=t.call(this,n)}}function ft(t){var n,e;function r(){var r=t.apply(this,arguments);return r!==e&&(n=(e=r)&&lt(r)),n}return r._value=t,r}var ht=0;function dt(t,n,e,r){this._groups=t,this._parents=n,this._name=e,this._id=r}function pt(t){return Object(o.b)().transition(t)}function _t(){return++ht}var gt=o.b.prototype;dt.prototype=pt.prototype={constructor:dt,select:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(rt.a)(t));for(var r=this._groups,i=r.length,o=new Array(i),u=0;u<i;++u)for(var a,c,s=r[u],l=s.length,f=o[u]=new Array(l),h=0;h<l;++h)(a=s[h])&&(c=t.call(a,a.__data__,h,s))&&("__data__"in a&&(c.__data__=a.__data__),f[h]=c,O(f[h],n,e,h,f,C(a,e)));return new dt(o,this._parents,n,e)},selectAll:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(it.a)(t));for(var r=this._groups,i=r.length,o=[],u=[],a=0;a<i;++a)for(var c,s=r[a],l=s.length,f=0;f<l;++f)if(c=s[f]){for(var h,d=t.call(c,c.__data__,f,s),p=C(c,e),_=0,g=d.length;_<g;++_)(h=d[_])&&O(h,n,e,_,d,p);o.push(d),u.push(c)}return new dt(o,u,n,e)},filter:function(t){"function"!=typeof t&&(t=Object(nt.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o,u=n[i],a=u.length,c=r[i]=[],s=0;s<a;++s)(o=u[s])&&t.call(o,o.__data__,s,u)&&c.push(o);return new dt(r,this._parents,this._name,this._id)},merge:function(t){if(t._id!==this._id)throw new Error;for(var n=this._groups,e=t._groups,r=n.length,i=e.length,o=Math.min(r,i),u=new Array(r),a=0;a<o;++a)for(var c,s=n[a],l=e[a],f=s.length,h=u[a]=new Array(f),d=0;d<f;++d)(c=s[d]||l[d])&&(h[d]=c);for(;a<r;++a)u[a]=n[a];return new dt(u,this._parents,this._name,this._id)},selection:function(){return new ot(this._groups,this._parents)},transition:function(){for(var t=this._name,n=this._id,e=_t(),r=this._groups,i=r.length,o=0;o<i;++o)for(var u,a=r[o],c=a.length,s=0;s<c;++s)if(u=a[s]){var l=C(u,n);O(u,t,e,s,a,{time:l.time+l.delay+l.duration,delay:0,duration:l.duration,ease:l.ease})}return new dt(r,this._parents,t,e)},call:gt.call,nodes:gt.nodes,node:gt.node,size:gt.size,empty:gt.empty,each:gt.each,on:function(t,n){var e=this._id;return arguments.length<2?C(this.node(),e).on.on(t):this.each(et(e,t,n))},attr:function(t,n){var e=Object(E.a)(t),r="transform"===e?N.b:R;return this.attrTween(t,"function"==typeof n?(e.local?G:z)(e,r,F(this,"attr."+t,n)):null==n?(e.local?H:B)(e):(e.local?Y:q)(e,r,n))},attrTween:function(t,n){var e="attr."+t;if(arguments.length<2)return(e=this.tween(e))&&e._value;if(null==n)return this.tween(e,null);if("function"!=typeof n)throw new Error;var r=Object(E.a)(t);return this.tween(e,(r.local?W:$)(r,n))},style:function(t,n,e){var r="transform"==(t+="")?N.a:R;return null==n?this.styleTween(t,function(t,n){var e,r,i;return function(){var o=Object(ut.b)(this,t),u=(this.style.removeProperty(t),Object(ut.b)(this,t));return o===u?null:o===e&&u===r?i:i=n(e=o,r=u)}}(t,r)).on("end.style."+t,at(t)):"function"==typeof n?this.styleTween(t,function(t,n,e){var r,i,o;return function(){var u=Object(ut.b)(this,t),a=e(this),c=a+"";return null==a&&(this.style.removeProperty(t),c=a=Object(ut.b)(this,t)),u===c?null:u===r&&c===i?o:(i=c,o=n(r=u,a))}}(t,r,F(this,"style."+t,n))).each(function(t,n){var e,r,i,o,u="style."+n,a="end."+u;return function(){var c=k(this,t),s=c.on,l=null==c.value[u]?o||(o=at(n)):void 0;s===e&&i===l||(r=(e=s).copy()).on(a,i=l),c.on=r}}(this._id,t)):this.styleTween(t,function(t,n,e){var r,i,o=e+"";return function(){var u=Object(ut.b)(this,t);return u===o?null:u===r?i:i=n(r=u,e)}}(t,r,n),e).on("end.style."+t,null)},styleTween:function(t,n,e){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==n)return this.tween(r,null);if("function"!=typeof n)throw new Error;return this.tween(r,st(t,n,null==e?"":e))},text:function(t){return this.tween("text","function"==typeof t?function(t){return function(){var n=t(this);this.textContent=null==n?"":n}}(F(this,"text",t)):function(t){return function(){this.textContent=t}}(null==t?"":t+""))},textTween:function(t){var n="text";if(arguments.length<1)return(n=this.tween(n))&&n._value;if(null==t)return this.tween(n,null);if("function"!=typeof t)throw new Error;return this.tween(n,ft(t))},remove:function(){return this.on("end.remove",(t=this._id,function(){var n=this.parentNode;for(var e in this.__transition)if(+e!==t)return;n&&n.removeChild(this)}));var t},tween:function(t,n){var e=this._id;if(t+="",arguments.length<2){for(var r,i=C(this.node(),e).tween,o=0,u=i.length;o<u;++o)if((r=i[o]).name===t)return r.value;return null}return this.each((null==n?j:D)(e,t,n))},delay:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?Z:Q)(n,t)):C(this.node(),n).delay},duration:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?J:K)(n,t)):C(this.node(),n).duration},ease:function(t){var n=this._id;return arguments.length?this.each(tt(n,t)):C(this.node(),n).ease},end:function(){var t,n,e=this,r=e._id,i=e.size();return new Promise((function(o,u){var a={value:u},c={value:function(){0==--i&&o()}};e.each((function(){var e=k(this,r),i=e.on;i!==t&&((n=(t=i).copy())._.cancel.push(a),n._.interrupt.push(a),n._.end.push(c)),e.on=n}))}))}};var yt={time:null,delay:0,duration:250,ease:e(29).b};function vt(t,n){for(var e;!(e=t.__transition)||!(e=e[n]);)if(!(t=t.parentNode))return yt.time=_(),yt;return e}o.b.prototype.interrupt=function(t){return this.each((function(){S(this,t)}))},o.b.prototype.transition=function(t){var n,e;t instanceof dt?(n=t._id,t=t._name):(n=_t(),(e=yt).time=_(),t=null==t?null:t+"");for(var r=this._groups,i=r.length,o=0;o<i;++o)for(var u,a=r[o],c=a.length,s=0;s<c;++s)(u=a[s])&&O(u,t,n,s,a,e||vt(u,n));return new dt(r,this._parents,t,n)};var mt=[null],xt=function(t,n){var e,r,i=t.__transition;if(i)for(r in n=null==n?null:n+"",i)if((e=i[r]).state>1&&e.name===n)return new dt([[t]],mt,n,+r);return null};e.d(n,"transition",(function(){return pt})),e.d(n,"active",(function(){return xt})),e.d(n,"interrupt",(function(){return S}))},,function(t,n,e){"use strict";var r,i,o,u,a=e(5),c=180/Math.PI,s={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1},l=function(t,n,e,r,i,o){var u,a,s;return(u=Math.sqrt(t*t+n*n))&&(t/=u,n/=u),(s=t*e+n*r)&&(e-=t*s,r-=n*s),(a=Math.sqrt(e*e+r*r))&&(e/=a,r/=a,s/=a),t*r<n*e&&(t=-t,n=-n,s=-s,u=-u),{translateX:i,translateY:o,rotate:Math.atan2(n,t)*c,skewX:Math.atan(s)*c,scaleX:u,scaleY:a}};function f(t,n,e,r){function i(t){return t.length?t.pop()+" ":""}return function(o,u){var c=[],s=[];return o=t(o),u=t(u),function(t,r,i,o,u,c){if(t!==i||r!==o){var s=u.push("translate(",null,n,null,e);c.push({i:s-4,x:Object(a.a)(t,i)},{i:s-2,x:Object(a.a)(r,o)})}else(i||o)&&u.push("translate("+i+n+o+e)}(o.translateX,o.translateY,u.translateX,u.translateY,c,s),function(t,n,e,o){t!==n?(t-n>180?n+=360:n-t>180&&(t+=360),o.push({i:e.push(i(e)+"rotate(",null,r)-2,x:Object(a.a)(t,n)})):n&&e.push(i(e)+"rotate("+n+r)}(o.rotate,u.rotate,c,s),function(t,n,e,o){t!==n?o.push({i:e.push(i(e)+"skewX(",null,r)-2,x:Object(a.a)(t,n)}):n&&e.push(i(e)+"skewX("+n+r)}(o.skewX,u.skewX,c,s),function(t,n,e,r,o,u){if(t!==e||n!==r){var c=o.push(i(o)+"scale(",null,",",null,")");u.push({i:c-4,x:Object(a.a)(t,e)},{i:c-2,x:Object(a.a)(n,r)})}else 1===e&&1===r||o.push(i(o)+"scale("+e+","+r+")")}(o.scaleX,o.scaleY,u.scaleX,u.scaleY,c,s),o=u=null,function(t){for(var n,e=-1,r=s.length;++e<r;)c[(n=s[e]).i]=n.x(t);return c.join("")}}}e.d(n,"a",(function(){return h})),e.d(n,"b",(function(){return d}));var h=f((function(t){return"none"===t?s:(r||(r=document.createElement("DIV"),i=document.documentElement,o=document.defaultView),r.style.transform=t,t=o.getComputedStyle(i.appendChild(r),null).getPropertyValue("transform"),i.removeChild(r),t=t.slice(7,-1).split(","),l(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}),"px, ","px)","deg)"),d=f((function(t){return null==t?s:(u||(u=document.createElementNS("http://www.w3.org/2000/svg","g")),u.setAttribute("transform",t),(t=u.transform.baseVal.consolidate())?(t=t.matrix,l(t.a,t.b,t.c,t.d,t.e,t.f)):s)}),", ",")",")")},function(t,n,e){"use strict";e.r(n);var r=e(2);function i(t,n){switch(arguments.length){case 0:break;case 1:this.range(t);break;default:this.range(n).domain(t)}return this}function o(t,n){switch(arguments.length){case 0:break;case 1:this.interpolator(t);break;default:this.interpolator(n).domain(t)}return this}var u=e(45),a=Array.prototype,c=a.map,s=a.slice,l={name:"implicit"};function f(){var t=Object(u.map)(),n=[],e=[],r=l;function o(i){var o=i+"",u=t.get(o);if(!u){if(r!==l)return r;t.set(o,u=n.push(i))}return e[(u-1)%e.length]}return o.domain=function(e){if(!arguments.length)return n.slice();n=[],t=Object(u.map)();for(var r,i,a=-1,c=e.length;++a<c;)t.has(i=(r=e[a])+"")||t.set(i,n.push(r));return o},o.range=function(t){return arguments.length?(e=s.call(t),o):e.slice()},o.unknown=function(t){return arguments.length?(r=t,o):r},o.copy=function(){return f(n,e).unknown(r)},i.apply(o,arguments),o}function h(){var t,n,e=f().unknown(void 0),o=e.domain,u=e.range,a=[0,1],c=!1,s=0,l=0,d=.5;function p(){var e=o().length,i=a[1]<a[0],f=a[i-0],h=a[1-i];t=(h-f)/Math.max(1,e-s+2*l),c&&(t=Math.floor(t)),f+=(h-f-t*(e-s))*d,n=t*(1-s),c&&(f=Math.round(f),n=Math.round(n));var p=Object(r.range)(e).map((function(n){return f+t*n}));return u(i?p.reverse():p)}return delete e.unknown,e.domain=function(t){return arguments.length?(o(t),p()):o()},e.range=function(t){return arguments.length?(a=[+t[0],+t[1]],p()):a.slice()},e.rangeRound=function(t){return a=[+t[0],+t[1]],c=!0,p()},e.bandwidth=function(){return n},e.step=function(){return t},e.round=function(t){return arguments.length?(c=!!t,p()):c},e.padding=function(t){return arguments.length?(s=Math.min(1,l=+t),p()):s},e.paddingInner=function(t){return arguments.length?(s=Math.min(1,t),p()):s},e.paddingOuter=function(t){return arguments.length?(l=+t,p()):l},e.align=function(t){return arguments.length?(d=Math.max(0,Math.min(1,t)),p()):d},e.copy=function(){return h(o(),a).round(c).paddingInner(s).paddingOuter(l).align(d)},i.apply(p(),arguments)}function d(t){var n=t.copy;return t.padding=t.paddingOuter,delete t.paddingInner,delete t.paddingOuter,t.copy=function(){return d(n())},t}function p(){return d(h.apply(null,arguments).paddingInner(1))}var _=e(36),g=e(5),y=e(81),v=function(t){return+t},m=[0,1];function x(t){return t}function b(t,n){return(n-=t=+t)?function(e){return(e-t)/n}:(e=isNaN(n)?NaN:.5,function(){return e});var e}function w(t){var n,e=t[0],r=t[t.length-1];return e>r&&(n=e,e=r,r=n),function(t){return Math.max(e,Math.min(r,t))}}function M(t,n,e){var r=t[0],i=t[1],o=n[0],u=n[1];return i<r?(r=b(i,r),o=e(u,o)):(r=b(r,i),o=e(o,u)),function(t){return o(r(t))}}function T(t,n,e){var i=Math.min(t.length,n.length)-1,o=new Array(i),u=new Array(i),a=-1;for(t[i]<t[0]&&(t=t.slice().reverse(),n=n.slice().reverse());++a<i;)o[a]=b(t[a],t[a+1]),u[a]=e(n[a],n[a+1]);return function(n){var e=Object(r.bisect)(t,n,1,i)-1;return u[e](o[e](n))}}function O(t,n){return n.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown())}function A(){var t,n,e,r,i,o,u=m,a=m,l=_.a,f=x;function h(){return r=Math.min(u.length,a.length)>2?T:M,i=o=null,d}function d(n){return isNaN(n=+n)?e:(i||(i=r(u.map(t),a,l)))(t(f(n)))}return d.invert=function(e){return f(n((o||(o=r(a,u.map(t),g.a)))(e)))},d.domain=function(t){return arguments.length?(u=c.call(t,v),f===x||(f=w(u)),h()):u.slice()},d.range=function(t){return arguments.length?(a=s.call(t),h()):a.slice()},d.rangeRound=function(t){return a=s.call(t),l=y.a,h()},d.clamp=function(t){return arguments.length?(f=t?w(u):x,d):f!==x},d.interpolate=function(t){return arguments.length?(l=t,h()):l},d.unknown=function(t){return arguments.length?(e=t,d):e},function(e,r){return t=e,n=r,h()}}function k(t,n){return A()(t,n)}var C=e(24),S=e(62),N=e(40),E=e(63),j=e(61),D=function(t,n,e,i){var o,u=Object(r.tickStep)(t,n,e);switch((i=Object(C.b)(null==i?",f":i)).type){case"s":var a=Math.max(Math.abs(t),Math.abs(n));return null!=i.precision||isNaN(o=Object(S.a)(u,a))||(i.precision=o),Object(N.c)(i,a);case"":case"e":case"g":case"p":case"r":null!=i.precision||isNaN(o=Object(E.a)(u,Math.max(Math.abs(t),Math.abs(n))))||(i.precision=o-("e"===i.type));break;case"f":case"%":null!=i.precision||isNaN(o=Object(j.a)(u))||(i.precision=o-2*("%"===i.type))}return Object(N.b)(i)};function F(t){var n=t.domain;return t.ticks=function(t){var e=n();return Object(r.ticks)(e[0],e[e.length-1],null==t?10:t)},t.tickFormat=function(t,e){var r=n();return D(r[0],r[r.length-1],null==t?10:t,e)},t.nice=function(e){null==e&&(e=10);var i,o=n(),u=0,a=o.length-1,c=o[u],s=o[a];return s<c&&(i=c,c=s,s=i,i=u,u=a,a=i),(i=Object(r.tickIncrement)(c,s,e))>0?(c=Math.floor(c/i)*i,s=Math.ceil(s/i)*i,i=Object(r.tickIncrement)(c,s,e)):i<0&&(c=Math.ceil(c*i)/i,s=Math.floor(s*i)/i,i=Object(r.tickIncrement)(c,s,e)),i>0?(o[u]=Math.floor(c/i)*i,o[a]=Math.ceil(s/i)*i,n(o)):i<0&&(o[u]=Math.ceil(c*i)/i,o[a]=Math.floor(s*i)/i,n(o)),t},t}function P(){var t=k(x,x);return t.copy=function(){return O(t,P())},i.apply(t,arguments),F(t)}function L(t){var n;function e(t){return isNaN(t=+t)?n:t}return e.invert=e,e.domain=e.range=function(n){return arguments.length?(t=c.call(n,v),e):t.slice()},e.unknown=function(t){return arguments.length?(n=t,e):n},e.copy=function(){return L(t).unknown(n)},t=arguments.length?c.call(t,v):[0,1],F(e)}var I=function(t,n){var e,r=0,i=(t=t.slice()).length-1,o=t[r],u=t[i];return u<o&&(e=r,r=i,i=e,e=o,o=u,u=e),t[r]=n.floor(o),t[i]=n.ceil(u),t};function U(t){return Math.log(t)}function R(t){return Math.exp(t)}function B(t){return-Math.log(-t)}function H(t){return-Math.exp(-t)}function q(t){return isFinite(t)?+("1e"+t):t<0?0:t}function Y(t){return function(n){return-t(-n)}}function z(t){var n,e,i=t(U,R),o=i.domain,u=10;function a(){return n=function(t){return t===Math.E?Math.log:10===t&&Math.log10||2===t&&Math.log2||(t=Math.log(t),function(n){return Math.log(n)/t})}(u),e=function(t){return 10===t?q:t===Math.E?Math.exp:function(n){return Math.pow(t,n)}}(u),o()[0]<0?(n=Y(n),e=Y(e),t(B,H)):t(U,R),i}return i.base=function(t){return arguments.length?(u=+t,a()):u},i.domain=function(t){return arguments.length?(o(t),a()):o()},i.ticks=function(t){var i,a=o(),c=a[0],s=a[a.length-1];(i=s<c)&&(d=c,c=s,s=d);var l,f,h,d=n(c),p=n(s),_=null==t?10:+t,g=[];if(!(u%1)&&p-d<_){if(d=Math.round(d)-1,p=Math.round(p)+1,c>0){for(;d<p;++d)for(f=1,l=e(d);f<u;++f)if(!((h=l*f)<c)){if(h>s)break;g.push(h)}}else for(;d<p;++d)for(f=u-1,l=e(d);f>=1;--f)if(!((h=l*f)<c)){if(h>s)break;g.push(h)}}else g=Object(r.ticks)(d,p,Math.min(p-d,_)).map(e);return i?g.reverse():g},i.tickFormat=function(t,r){if(null==r&&(r=10===u?".0e":","),"function"!=typeof r&&(r=Object(N.b)(r)),t===1/0)return r;null==t&&(t=10);var o=Math.max(1,u*t/i.ticks().length);return function(t){var i=t/e(Math.round(n(t)));return i*u<u-.5&&(i*=u),i<=o?r(t):""}},i.nice=function(){return o(I(o(),{floor:function(t){return e(Math.floor(n(t)))},ceil:function(t){return e(Math.ceil(n(t)))}}))},i}function G(){var t=z(A()).domain([1,10]);return t.copy=function(){return O(t,G()).base(t.base())},i.apply(t,arguments),t}function V(t){return function(n){return Math.sign(n)*Math.log1p(Math.abs(n/t))}}function X(t){return function(n){return Math.sign(n)*Math.expm1(Math.abs(n))*t}}function W(t){var n=1,e=t(V(n),X(n));return e.constant=function(e){return arguments.length?t(V(n=+e),X(n)):n},F(e)}function $(){var t=W(A());return t.copy=function(){return O(t,$()).constant(t.constant())},i.apply(t,arguments)}function Z(t){return function(n){return n<0?-Math.pow(-n,t):Math.pow(n,t)}}function Q(t){return t<0?-Math.sqrt(-t):Math.sqrt(t)}function J(t){return t<0?-t*t:t*t}function K(t){var n=t(x,x),e=1;function r(){return 1===e?t(x,x):.5===e?t(Q,J):t(Z(e),Z(1/e))}return n.exponent=function(t){return arguments.length?(e=+t,r()):e},F(n)}function tt(){var t=K(A());return t.copy=function(){return O(t,tt()).exponent(t.exponent())},i.apply(t,arguments),t}function nt(){return tt.apply(null,arguments).exponent(.5)}function et(){var t,n=[],e=[],o=[];function u(){var t=0,i=Math.max(1,e.length);for(o=new Array(i-1);++t<i;)o[t-1]=Object(r.quantile)(n,t/i);return a}function a(n){return isNaN(n=+n)?t:e[Object(r.bisect)(o,n)]}return a.invertExtent=function(t){var r=e.indexOf(t);return r<0?[NaN,NaN]:[r>0?o[r-1]:n[0],r<o.length?o[r]:n[n.length-1]]},a.domain=function(t){if(!arguments.length)return n.slice();n=[];for(var e,i=0,o=t.length;i<o;++i)null==(e=t[i])||isNaN(e=+e)||n.push(e);return n.sort(r.ascending),u()},a.range=function(t){return arguments.length?(e=s.call(t),u()):e.slice()},a.unknown=function(n){return arguments.length?(t=n,a):t},a.quantiles=function(){return o.slice()},a.copy=function(){return et().domain(n).range(e).unknown(t)},i.apply(a,arguments)}function rt(){var t,n=0,e=1,o=1,u=[.5],a=[0,1];function c(n){return n<=n?a[Object(r.bisect)(u,n,0,o)]:t}function l(){var t=-1;for(u=new Array(o);++t<o;)u[t]=((t+1)*e-(t-o)*n)/(o+1);return c}return c.domain=function(t){return arguments.length?(n=+t[0],e=+t[1],l()):[n,e]},c.range=function(t){return arguments.length?(o=(a=s.call(t)).length-1,l()):a.slice()},c.invertExtent=function(t){var r=a.indexOf(t);return r<0?[NaN,NaN]:r<1?[n,u[0]]:r>=o?[u[o-1],e]:[u[r-1],u[r]]},c.unknown=function(n){return arguments.length?(t=n,c):c},c.thresholds=function(){return u.slice()},c.copy=function(){return rt().domain([n,e]).range(a).unknown(t)},i.apply(F(c),arguments)}function it(){var t,n=[.5],e=[0,1],o=1;function u(i){return i<=i?e[Object(r.bisect)(n,i,0,o)]:t}return u.domain=function(t){return arguments.length?(n=s.call(t),o=Math.min(n.length,e.length-1),u):n.slice()},u.range=function(t){return arguments.length?(e=s.call(t),o=Math.min(n.length,e.length-1),u):e.slice()},u.invertExtent=function(t){var r=e.indexOf(t);return[n[r-1],n[r]]},u.unknown=function(n){return arguments.length?(t=n,u):t},u.copy=function(){return it().domain(n).range(e).unknown(t)},i.apply(u,arguments)}var ot=e(15),ut=e(47),at=e(3),ct=e(27),st=e(48),lt=e(49),ft=e(30),ht=e(31),dt=e(46);function pt(t){return new Date(t)}function _t(t){return t instanceof Date?+t:+new Date(+t)}function gt(t,n,e,i,o,u,a,s,l){var f=k(x,x),h=f.invert,d=f.domain,p=l(".%L"),_=l(":%S"),g=l("%I:%M"),y=l("%I %p"),v=l("%a %d"),m=l("%b %d"),b=l("%B"),w=l("%Y"),M=[[a,1,1e3],[a,5,5e3],[a,15,15e3],[a,30,3e4],[u,1,6e4],[u,5,3e5],[u,15,9e5],[u,30,18e5],[o,1,36e5],[o,3,108e5],[o,6,216e5],[o,12,432e5],[i,1,864e5],[i,2,1728e5],[e,1,6048e5],[n,1,2592e6],[n,3,7776e6],[t,1,31536e6]];function T(r){return(a(r)<r?p:u(r)<r?_:o(r)<r?g:i(r)<r?y:n(r)<r?e(r)<r?v:m:t(r)<r?b:w)(r)}function A(n,e,i,o){if(null==n&&(n=10),"number"==typeof n){var u=Math.abs(i-e)/n,a=Object(r.bisector)((function(t){return t[2]})).right(M,u);a===M.length?(o=Object(r.tickStep)(e/31536e6,i/31536e6,n),n=t):a?(o=(a=M[u/M[a-1][2]<M[a][2]/u?a-1:a])[1],n=a[0]):(o=Math.max(Object(r.tickStep)(e,i,n),1),n=s)}return null==o?n:n.every(o)}return f.invert=function(t){return new Date(h(t))},f.domain=function(t){return arguments.length?d(c.call(t,_t)):d().map(pt)},f.ticks=function(t,n){var e,r=d(),i=r[0],o=r[r.length-1],u=o<i;return u&&(e=i,i=o,o=e),e=(e=A(t,i,o,n))?e.range(i,o+1):[],u?e.reverse():e},f.tickFormat=function(t,n){return null==n?T:l(n)},f.nice=function(t,n){var e=d();return(t=A(t,e[0],e[e.length-1],n))?d(I(e,t)):f},f.copy=function(){return O(f,gt(t,n,e,i,o,u,a,s,l))},f}var yt=function(){return i.apply(gt(ot.a,ut.a,at.g,ct.b,st.a,lt.a,ft.a,ht.a,dt.b).domain([new Date(2e3,0,1),new Date(2e3,0,2)]),arguments)},vt=e(16),mt=e(50),xt=e(4),bt=e(28),wt=e(51),Mt=e(52),Tt=function(){return i.apply(gt(vt.a,mt.a,xt.g,bt.a,wt.a,Mt.a,ft.a,ht.a,dt.d).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)]),arguments)};function Ot(){var t,n,e,r,i,o=0,u=1,a=x,c=!1;function s(n){return isNaN(n=+n)?i:a(0===e?.5:(n=(r(n)-t)*e,c?Math.max(0,Math.min(1,n)):n))}return s.domain=function(i){return arguments.length?(t=r(o=+i[0]),n=r(u=+i[1]),e=t===n?0:1/(n-t),s):[o,u]},s.clamp=function(t){return arguments.length?(c=!!t,s):c},s.interpolator=function(t){return arguments.length?(a=t,s):a},s.unknown=function(t){return arguments.length?(i=t,s):i},function(i){return r=i,t=i(o),n=i(u),e=t===n?0:1/(n-t),s}}function At(t,n){return n.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown())}function kt(){var t=F(Ot()(x));return t.copy=function(){return At(t,kt())},o.apply(t,arguments)}function Ct(){var t=z(Ot()).domain([1,10]);return t.copy=function(){return At(t,Ct()).base(t.base())},o.apply(t,arguments)}function St(){var t=W(Ot());return t.copy=function(){return At(t,St()).constant(t.constant())},o.apply(t,arguments)}function Nt(){var t=K(Ot());return t.copy=function(){return At(t,Nt()).exponent(t.exponent())},o.apply(t,arguments)}function Et(){return Nt.apply(null,arguments).exponent(.5)}function jt(){var t=[],n=x;function e(e){if(!isNaN(e=+e))return n((Object(r.bisect)(t,e)-1)/(t.length-1))}return e.domain=function(n){if(!arguments.length)return t.slice();t=[];for(var i,o=0,u=n.length;o<u;++o)null==(i=n[o])||isNaN(i=+i)||t.push(i);return t.sort(r.ascending),e},e.interpolator=function(t){return arguments.length?(n=t,e):n},e.copy=function(){return jt(n).domain(t)},o.apply(e,arguments)}function Dt(){var t,n,e,r,i,o,u,a=0,c=.5,s=1,l=x,f=!1;function h(t){return isNaN(t=+t)?u:(t=.5+((t=+o(t))-n)*(t<n?r:i),l(f?Math.max(0,Math.min(1,t)):t))}return h.domain=function(u){return arguments.length?(t=o(a=+u[0]),n=o(c=+u[1]),e=o(s=+u[2]),r=t===n?0:.5/(n-t),i=n===e?0:.5/(e-n),h):[a,c,s]},h.clamp=function(t){return arguments.length?(f=!!t,h):f},h.interpolator=function(t){return arguments.length?(l=t,h):l},h.unknown=function(t){return arguments.length?(u=t,h):u},function(u){return o=u,t=u(a),n=u(c),e=u(s),r=t===n?0:.5/(n-t),i=n===e?0:.5/(e-n),h}}function Ft(){var t=F(Dt()(x));return t.copy=function(){return At(t,Ft())},o.apply(t,arguments)}function Pt(){var t=z(Dt()).domain([.1,1,10]);return t.copy=function(){return At(t,Pt()).base(t.base())},o.apply(t,arguments)}function Lt(){var t=W(Dt());return t.copy=function(){return At(t,Lt()).constant(t.constant())},o.apply(t,arguments)}function It(){var t=K(Dt());return t.copy=function(){return At(t,It()).exponent(t.exponent())},o.apply(t,arguments)}function Ut(){return It.apply(null,arguments).exponent(.5)}e.d(n,"scaleBand",(function(){return h})),e.d(n,"scalePoint",(function(){return p})),e.d(n,"scaleIdentity",(function(){return L})),e.d(n,"scaleLinear",(function(){return P})),e.d(n,"scaleLog",(function(){return G})),e.d(n,"scaleSymlog",(function(){return $})),e.d(n,"scaleOrdinal",(function(){return f})),e.d(n,"scaleImplicit",(function(){return l})),e.d(n,"scalePow",(function(){return tt})),e.d(n,"scaleSqrt",(function(){return nt})),e.d(n,"scaleQuantile",(function(){return et})),e.d(n,"scaleQuantize",(function(){return rt})),e.d(n,"scaleThreshold",(function(){return it})),e.d(n,"scaleTime",(function(){return yt})),e.d(n,"scaleUtc",(function(){return Tt})),e.d(n,"scaleSequential",(function(){return kt})),e.d(n,"scaleSequentialLog",(function(){return Ct})),e.d(n,"scaleSequentialPow",(function(){return Nt})),e.d(n,"scaleSequentialSqrt",(function(){return Et})),e.d(n,"scaleSequentialSymlog",(function(){return St})),e.d(n,"scaleSequentialQuantile",(function(){return jt})),e.d(n,"scaleDiverging",(function(){return Ft})),e.d(n,"scaleDivergingLog",(function(){return Pt})),e.d(n,"scaleDivergingPow",(function(){return It})),e.d(n,"scaleDivergingSqrt",(function(){return Ut})),e.d(n,"scaleDivergingSymlog",(function(){return Lt})),e.d(n,"tickFormat",(function(){return D}))},function(t,n,e){"use strict";var r;void 0===(r=function(t){var n=e(65).colorSchemas,r=(e(70),e(77)),i="undefined"!=typeof window,o=navigator.msSaveOrOpenBlob,u=i&&window.btoa;u||(u=e(78).encode);var a={styleClass:"britechartStyle",defaultFilename:"britechart.png",chartBackground:"white",imageSourceBase:"data:image/svg+xml;base64,",titleFontSize:"15px",titleFontFamily:"'Benton Sans', sans-serif",titleTopOffset:15,get styleBackgroundString(){return"<style>svg{background:"+this.chartBackground+";}</style>"}};function c(t,n){if(t){t.attr("version",1.1).attr("xmlns","http://www.w3.org/2000/svg");var e=r.initializeSerializer()(t.node());return e=function(t){if(navigator.userAgent.search("FireFox")>-1)return t.replace(/url.*&quot;\)/,'url(&quot;linearGradient[id*="-gradient-"]&quot;);');return t}(e),e=function(t){return t.replace(">",">"+a.styleBackgroundString)}(e=h.call(this,e,n,parseInt(t.attr("width"),10)))}}function s(t){var n=new Image;return n.src=""+a.imageSourceBase+u(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g,(function(t,n){return String.fromCharCode("0x"+n)}))),n}function l(t,n){return n.getContext("2d").drawImage(t,0,0),n}function f(t,n,e){e.preventDefault(),function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:a.defaultFilename,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"image/png",r=t.toDataURL(e),i=document.createElement("a");i.href=r,i.download=n,document.body.appendChild(i),i.click(),document.body.removeChild(i)}(l(this,t),n)}function h(t,e,r){if(!e||!r)return t;var i=n.grey;return t=t.replace(/<g/,'<text x="'+this.margin().left+'" y="'+a.titleTopOffset+'" font-family="'+a.titleFontFamily+'" font-size="'+a.titleFontSize+'" fill="'+i[6]+'"> '+e+" </text><g ")}return{exportChart:function(t,n,e){if(o)return console.error("Sorry, this feature is not available for IE. If you require this to work, check this issue https://github.com/britecharts/britecharts/pull/652"),!1;var r,i,u,a=s(c.call(this,t,e));a.onload=f.bind(a,(r=this.width(),i=this.height(),(u=document.createElement("canvas")).height=i,u.width=r,u),n)},convertSvgToHtml:c,createImage:s,drawImageOnCanvas:l}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";var r,i,o;t.exports=(r={BASE:!0,HEAD:!0,HTML:!0,META:!0,NOFRAME:!0,NOSCRIPT:!0,PARAM:!0,SCRIPT:!0,STYLE:!0,TITLE:!0},i=["A","ABBR","ADDRESS","AREA","ARTICLE","ASIDE","AUDIO","B","BASE","BDI","BDO","BLOCKQUOTE","BODY","BR","BUTTON","CANVAS","CAPTION","CENTER","CITE","CODE","COL","COLGROUP","COMMAND","DATALIST","DD","DEL","DETAILS","DFN","DIV","DL","DT","EM","EMBED","FIELDSET","FIGCAPTION","FIGURE","FONT","FOOTER","FORM","H1","H2","H3","H4","H5","H6","HEAD","HEADER","HGROUP","HR","HTML","I","IFRAME","IMG","INPUT","INS","KBD","LABEL","LEGEND","LI","LINK","MAP","MARK","MATH","MENU","META","METER","NAV","NOBR","NOSCRIPT","OBJECT","OL","OPTION","OPTGROUP","OUTPUT","P","PARAM","PRE","PROGRESS","Q","RP","RT","RUBY","S","SAMP","SCRIPT","SECTION","SELECT","SMALL","SOURCE","SPAN","STRONG","STYLE","SUB","SUMMARY","SUP","SVG","TABLE","TBODY","TD","TEXTAREA","TFOOT","TH","THEAD","TIME","TITLE","TR","TRACK","U","UL","VAR","VIDEO","WBR"],o=function(t){var n={},e=document.body.appendChild(document.createElement(t)),r=window.getComputedStyle(e);return[].forEach.call(r,(function(t){n[t]=r[t]})),document.body.removeChild(e),n},{initializeSerializer:function(){var t={};return[].forEach.call(i,(function(n){r[n]||(t[n]=o(n))})),function(n){var e,i=[],u=void 0,a=void 0,c=void 0;if(n&&n.nodeType===Node.ELEMENT_NODE)return i=[],u=n.querySelectorAll("*"),[].forEach.call(u,(function(n,e){var u;r[n.tagName]||(a=window.getComputedStyle(n),u=(u=n.tagName).toUpperCase(),t[u]||(t[u]=o(u)),c=t[u],i[e]=n.style.cssText,[].forEach.call(a,(function(t){a[t]!==c[t]&&(n.style[t]=a[t])})))})),e=n.outerHTML,u=[].map.call(u,(function(t,n){return t.style.cssText=i[n],t})),e}}})},function(t,n,e){(function(t,r){var i;/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */!function(o){var u=n,a=(t&&t.exports,"object"==typeof r&&r);a.global!==a&&a.window;var c=function(t){this.message=t};(c.prototype=new Error).name="InvalidCharacterError";var s=function(t){throw new c(t)},l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",f=/[\t\n\f\r ]/g,h={encode:function(t){t=String(t),/[^\0-\xFF]/.test(t)&&s("The string to be encoded contains characters outside of the Latin1 range.");for(var n,e,r,i,o=t.length%3,u="",a=-1,c=t.length-o;++a<c;)n=t.charCodeAt(a)<<16,e=t.charCodeAt(++a)<<8,r=t.charCodeAt(++a),u+=l.charAt((i=n+e+r)>>18&63)+l.charAt(i>>12&63)+l.charAt(i>>6&63)+l.charAt(63&i);return 2==o?(n=t.charCodeAt(a)<<8,e=t.charCodeAt(++a),u+=l.charAt((i=n+e)>>10)+l.charAt(i>>4&63)+l.charAt(i<<2&63)+"="):1==o&&(i=t.charCodeAt(a),u+=l.charAt(i>>2)+l.charAt(i<<4&63)+"=="),u},decode:function(t){var n=(t=String(t).replace(f,"")).length;n%4==0&&(n=(t=t.replace(/==?$/,"")).length),(n%4==1||/[^+a-zA-Z0-9/]/.test(t))&&s("Invalid character: the string to be decoded is not correctly encoded.");for(var e,r,i=0,o="",u=-1;++u<n;)r=l.indexOf(t.charAt(u)),e=i%4?64*e+r:r,i++%4&&(o+=String.fromCharCode(255&e>>(-2*i&6)));return o},version:"0.1.0"};void 0===(i=function(){return h}.call(n,e,n,t))||(t.exports=i)}()}).call(this,e(79)(t),e(80))},function(t,n){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,n){var e;e=function(){return this}();try{e=e||new Function("return this")()}catch(t){"object"==typeof window&&(e=window)}t.exports=e},function(t,n,e){"use strict";n.a=function(t,n){return t=+t,n=+n,function(e){return Math.round(t*(1-e)+n*e)}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return s})),e.d(n,"a",(function(){return l})),e.d(n,"d",(function(){return y})),e.d(n,"c",(function(){return v}));var r=e(11),i=e(7),o=e(67),u=6/29,a=3*u*u;function c(t){if(t instanceof f)return new f(t.l,t.a,t.b,t.opacity);if(t instanceof m)return x(t);t instanceof i.b||(t=Object(i.h)(t));var n,e,r=_(t.r),o=_(t.g),u=_(t.b),a=h((.2225045*r+.7168786*o+.0606169*u)/1);return r===o&&o===u?n=e=a:(n=h((.4360747*r+.3850649*o+.1430804*u)/.96422),e=h((.0139322*r+.0971045*o+.7141733*u)/.82521)),new f(116*a-16,500*(n-a),200*(a-e),t.opacity)}function s(t,n){return new f(t,0,0,null==n?1:n)}function l(t,n,e,r){return 1===arguments.length?c(t):new f(t,n,e,null==r?1:r)}function f(t,n,e,r){this.l=+t,this.a=+n,this.b=+e,this.opacity=+r}function h(t){return t>.008856451679035631?Math.pow(t,1/3):t/a+4/29}function d(t){return t>u?t*t*t:a*(t-4/29)}function p(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function _(t){return(t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function g(t){if(t instanceof m)return new m(t.h,t.c,t.l,t.opacity);if(t instanceof f||(t=c(t)),0===t.a&&0===t.b)return new m(NaN,0<t.l&&t.l<100?0:NaN,t.l,t.opacity);var n=Math.atan2(t.b,t.a)*o.b;return new m(n<0?n+360:n,Math.sqrt(t.a*t.a+t.b*t.b),t.l,t.opacity)}function y(t,n,e,r){return 1===arguments.length?g(t):new m(e,n,t,null==r?1:r)}function v(t,n,e,r){return 1===arguments.length?g(t):new m(t,n,e,null==r?1:r)}function m(t,n,e,r){this.h=+t,this.c=+n,this.l=+e,this.opacity=+r}function x(t){if(isNaN(t.h))return new f(t.l,0,0,t.opacity);var n=t.h*o.a;return new f(t.l,Math.cos(n)*t.c,Math.sin(n)*t.c,t.opacity)}Object(r.a)(f,l,Object(r.b)(i.a,{brighter:function(t){return new f(this.l+18*(null==t?1:t),this.a,this.b,this.opacity)},darker:function(t){return new f(this.l-18*(null==t?1:t),this.a,this.b,this.opacity)},rgb:function(){var t=(this.l+16)/116,n=isNaN(this.a)?t:t+this.a/500,e=isNaN(this.b)?t:t-this.b/200;return n=.96422*d(n),t=1*d(t),e=.82521*d(e),new i.b(p(3.1338561*n-1.6168667*t-.4906146*e),p(-.9787684*n+1.9161415*t+.033454*e),p(.0719453*n-.2289914*t+1.4052427*e),this.opacity)}})),Object(r.a)(m,v,Object(r.b)(i.a,{brighter:function(t){return new m(this.h,this.c,this.l+18*(null==t?1:t),this.opacity)},darker:function(t){return new m(this.h,this.c,this.l-18*(null==t?1:t),this.opacity)},rgb:function(){return x(this).rgb()}}))},function(t,n,e){"use strict";var r;void 0===(r=function(){return{bar:'\n            <svg class="load-state bar-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 711 325">\n              \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(0 29)">\n                        <g stroke="#EFF2F5" stroke-dasharray="4 4">\n                            <path d="M.400592911 200.302477L710.674315 200.302477M.400592884 131.172748L710.674315 131.172748M.324410282 64.2071321L710.621499 64.2071321M.291004517.563888874L709.82431.563888889"/>\n                        </g>\n                        <g fill="#D2D6DF" transform="translate(63.08 11)">\n                            <polygon points="-.08 176 23.92 176 23.92 255 -.08 255"/>\n                            <polygon points="50.829 147 74.829 147 74.829 255 50.829 255"/>\n                            <polygon points="254.465 0 278.465 0 278.465 255 254.465 255"/>\n                            <polygon points="458.102 169 482.102 169 482.102 255 458.102 255"/>\n                            <polygon points="152.647 82 176.647 82 176.647 255 152.647 255"/>\n                            <polygon points="356.283 66 380.283 66 380.283 255 356.283 255"/>\n                            <polygon points="559.92 229 583.92 229 583.92 255 559.92 255"/>\n                            <polygon points="101.738 115 125.738 115 125.738 255 101.738 255"/>\n                            <polygon points="305.374 42 329.374 42 329.374 255 305.374 255"/>\n                            <polygon points="509.011 201 533.011 201 533.011 255 509.011 255"/>\n                            <polygon points="203.556 19 227.556 19 227.556 255 203.556 255"/>\n                            <polygon points="407.192 115 431.192 115 431.192 255 407.192 255"/>\n                        </g>\n                    </g>\n                    <polygon fill="#D2D6DF" fill-rule="nonzero" points="0 295 711 295 711 294 0 294"/>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',donut:'\n            <svg class="load-state donut-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 376 331">\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(116 107)">\n                        <circle cx="72" cy="72" r="72" stroke="#EFF2F5" stroke-linecap="round" stroke-width="9.6"/>\n                        <path stroke="#D2D6DF" stroke-width="19.2" d="M126.153559,119.524055 C137.264629,106.845712 144,90.2321371 144,72.0444604 C144,32.2554036 111.764502,0 72,0"/>\n                        <circle cx="72" cy="72" r="67.2" fill="#FFF"/>\n                    </g>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',line:'\n            <svg\n                class="load-state line-load-state"\n                xmlns="http://www.w3.org/2000/svg"\n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path\n                    id="chart-bg"\n                    class="chart-bg"\n                    style="stroke:#C3C6CF;"\n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n                <polyline\n                    id="chart-line"\n                    class="chart-line"\n                    style="stroke:#C3C6CF;stroke-width:4;fill:none;"\n                    points="8.8,175.8 62.4,237.7 116.1,184.7 169.7,175.8 223.3,57 277,176.8 330.6,176.8 384.3,122.5 437.9,176.8 491.6,176.8 545.2,218.4 598.8,122.5 652.5,184.7 706.1,135.1 "\n                />\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',stackedArea:'\n            <svg\n                class="load-state stacked-area-load-state"\n                xmlns="http://www.w3.org/2000/svg"\n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path\n                    id="chart-bg"\n                    class="chart-bg"\n                    style="stroke:#C3C6CF;"\n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n                <g transform="translate(20 50)">\n                    <path\n                        id="chart-area"\n                        strokeLinecap="square"\n                        d="M0.34233103,0.593688165 L709.977885,0.593688189"\n                        transform="translate(.01 227.976)"\n                    />\n                    <path fill="#C3C6CF" d="M0.528124801,224.014648 L0.528124801,177.734375 L53.3834796,177.734375 C71.5390789,177.734375 86.8277373,168.972754 101.240241,151.662202 C112.578335,138.044258 121.139826,123.110227 136.974507,91.596773 C137.343842,90.8617404 139.300293,86.9654028 139.856735,85.8583549 C155.041692,55.6476711 163.354313,41.0906306 174.319873,27.7179171 C188.951312,9.87459412 204.885845,0.5 223.830634,0.5 C242.123071,0.5 257.291724,8.27027858 270.907992,23.1359289 C281.228683,34.4036118 289.135925,47.1272372 302.542017,72.085092 C303.275893,73.4513345 306.289669,79.0766612 307.063369,80.5168656 C321.41025,107.222876 330.088083,120.97663 341.470704,132.92446 C355.88994,148.05969 371.908861,155.792969 391.654853,155.792969 C412.142049,155.792969 428.763593,152.325614 442.880698,145.765582 C454.197328,140.506893 463.373931,133.679865 473.786035,123.626931 C476.528659,120.978915 486.44777,110.911455 488.791866,108.6483 C502.907223,95.0203436 514.194325,88.9355469 530.135322,88.9355469 C546.532652,88.9355469 559.505909,97.338499 575.973261,115.41103 C579.723508,119.526837 593.103621,135.086814 592.915496,134.871799 C605.09738,148.794859 614.368835,157.635549 625.072091,164.58539 C638.386599,173.230769 652.701021,177.734375 669.279853,177.734375 L673.779853,177.734375 L673.779853,224.014648 L0.528124801,224.014648 Z" />\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        '}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";e.r(n);var r=Array.prototype.slice,i=function(t){return t};function o(t){return"translate("+(t+.5)+",0)"}function u(t){return"translate(0,"+(t+.5)+")"}function a(t){return function(n){return+t(n)}}function c(t){var n=Math.max(0,t.bandwidth()-1)/2;return t.round()&&(n=Math.round(n)),function(e){return+t(e)+n}}function s(){return!this.__axis}function l(t,n){var e=[],l=null,f=null,h=6,d=6,p=3,_=1===t||4===t?-1:1,g=4===t||2===t?"x":"y",y=1===t||3===t?o:u;function v(r){var o=null==l?n.ticks?n.ticks.apply(n,e):n.domain():l,u=null==f?n.tickFormat?n.tickFormat.apply(n,e):i:f,v=Math.max(h,0)+p,m=n.range(),x=+m[0]+.5,b=+m[m.length-1]+.5,w=(n.bandwidth?c:a)(n.copy()),M=r.selection?r.selection():r,T=M.selectAll(".domain").data([null]),O=M.selectAll(".tick").data(o,n).order(),A=O.exit(),k=O.enter().append("g").attr("class","tick"),C=O.select("line"),S=O.select("text");T=T.merge(T.enter().insert("path",".tick").attr("class","domain").attr("stroke","currentColor")),O=O.merge(k),C=C.merge(k.append("line").attr("stroke","currentColor").attr(g+"2",_*h)),S=S.merge(k.append("text").attr("fill","currentColor").attr(g,_*v).attr("dy",1===t?"0em":3===t?"0.71em":"0.32em")),r!==M&&(T=T.transition(r),O=O.transition(r),C=C.transition(r),S=S.transition(r),A=A.transition(r).attr("opacity",1e-6).attr("transform",(function(t){return isFinite(t=w(t))?y(t):this.getAttribute("transform")})),k.attr("opacity",1e-6).attr("transform",(function(t){var n=this.parentNode.__axis;return y(n&&isFinite(n=n(t))?n:w(t))}))),A.remove(),T.attr("d",4===t||2==t?d?"M"+_*d+","+x+"H0.5V"+b+"H"+_*d:"M0.5,"+x+"V"+b:d?"M"+x+","+_*d+"V0.5H"+b+"V"+_*d:"M"+x+",0.5H"+b),O.attr("opacity",1).attr("transform",(function(t){return y(w(t))})),C.attr(g+"2",_*h),S.attr(g,_*v).text(u),M.filter(s).attr("fill","none").attr("font-size",10).attr("font-family","sans-serif").attr("text-anchor",2===t?"start":4===t?"end":"middle"),M.each((function(){this.__axis=w}))}return v.scale=function(t){return arguments.length?(n=t,v):n},v.ticks=function(){return e=r.call(arguments),v},v.tickArguments=function(t){return arguments.length?(e=null==t?[]:r.call(t),v):e.slice()},v.tickValues=function(t){return arguments.length?(l=null==t?null:r.call(t),v):l&&l.slice()},v.tickFormat=function(t){return arguments.length?(f=t,v):f},v.tickSize=function(t){return arguments.length?(h=d=+t,v):h},v.tickSizeInner=function(t){return arguments.length?(h=+t,v):h},v.tickSizeOuter=function(t){return arguments.length?(d=+t,v):d},v.tickPadding=function(t){return arguments.length?(p=+t,v):p},v}function f(t){return l(1,t)}function h(t){return l(2,t)}function d(t){return l(3,t)}function p(t){return l(4,t)}e.d(n,"axisTop",(function(){return f})),e.d(n,"axisRight",(function(){return h})),e.d(n,"axisBottom",(function(){return d})),e.d(n,"axisLeft",(function(){return p}))},function(t,n,e){"use strict";var r;void 0===(r=function(t){var n=e(44),r=e(2),i=0,o={small:{limit:10,format:n.format("")},medium:{limit:1e3,format:n.format("")},large:{limit:null,format:n.format(".2s")}},u={small:{limit:10,format:n.format(".3f")},medium:{limit:100,format:n.format(".1f")},large:{limit:null,format:n.format(".2s")}},a=function(t,n){var e="large";return t<n.small.limit?e="small":t<n.medium.limit&&(e="medium"),e};return{calculatePercent:function(t,e,r){var i=e?t/e*100:0;return n.format(r)(i)},calcLinearRegression:function(t){var n=t.length,e=0,i=0,o=0,u=0;t.forEach((function(t){e+=t.x,i+=t.y,o+=t.x*t.y,u+=t.x*t.x}));var a=n*u-e*e,c=(i*u-e*o)/a,s=(n*o-e*i)/a,l=r.min(t,(function(t){return t.x})),f=r.max(t,(function(t){return t.x}));return{x1:l,y1:s*n+c,x2:f,y2:s*f+c}},isInteger:function(t){return t%1==0},formatDecimalValue:function(t){var n=a(t,u);return(0,u[n].format)(t)},formatIntegerValue:function(t){var n=a(t,o);return(0,o[n].format)(t)},uniqueId:function(t){var n=++i;return t.toString()+"-"+n}}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";e.d(n,"a",(function(){return _}));var r=e(11),i=e(7),o=e(67),u=-.14861,a=1.78277,c=-.29227,s=-.90649,l=1.97294,f=l*s,h=l*a,d=a*c-s*u;function p(t){if(t instanceof g)return new g(t.h,t.s,t.l,t.opacity);t instanceof i.b||(t=Object(i.h)(t));var n=t.r/255,e=t.g/255,r=t.b/255,u=(d*r+f*n-h*e)/(d+f-h),a=r-u,p=(l*(e-u)-c*a)/s,_=Math.sqrt(p*p+a*a)/(l*u*(1-u)),y=_?Math.atan2(p,a)*o.b-120:NaN;return new g(y<0?y+360:y,_,u,t.opacity)}function _(t,n,e,r){return 1===arguments.length?p(t):new g(t,n,e,null==r?1:r)}function g(t,n,e,r){this.h=+t,this.s=+n,this.l=+e,this.opacity=+r}Object(r.a)(g,_,Object(r.b)(i.a,{brighter:function(t){return t=null==t?i.c:Math.pow(i.c,t),new g(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?i.d:Math.pow(i.d,t),new g(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=isNaN(this.h)?0:(this.h+120)*o.a,n=+this.l,e=isNaN(this.s)?0:this.s*n*(1-n),r=Math.cos(t),f=Math.sin(t);return new i.b(255*(n+e*(u*r+a*f)),255*(n+e*(c*r+s*f)),255*(n+e*(l*r)),this.opacity)}}))},function(t,n,e){"use strict";var r;void 0===(r=function(t){var n=e(6),r=1.2,i=10,o=.9,u=.6,a="value",c="label",s=function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:12,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"Arial",r=document.createElement("canvas"),i=r.getContext("2d");return i.font=n+"px "+e,i.measureText(t).width};return{getTextWidth:s,wrapText:function(t,e,s,l){var f=n.select(l),h=f.text().split(/\s+/).reverse(),d=void 0,p=[],_=0,g=r*o,y=f.attr("y"),v=parseFloat(f.attr("dy")),m=e*u,x=f.text(null).append("tspan").attr("x",t).attr("y",y-5).attr("dy",v+"em").classed(a,!0).style("font-size",e+"px");for(x.text(h.pop()),x=f.append("tspan").classed(c,!0).attr("x",t).attr("y",y+i).attr("dy",++_*g+v+"em").style("font-size",m+"px");d=h.pop();)p.push(d),x.text(p.join(" ")),x.node()&&x.node().getComputedTextLength()>s-50&&(p.pop(),x.text(p.join(" ")),p=[d],x=f.append("tspan").classed(c,!0).attr("x",t).attr("y",y+i).attr("dy",++_*g+v+"em").text(d).style("font-size",m+"px"))},wrapTextWithEllipses:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2;t.each((function(){var o,u,a,c,s,l,f;for(o=(t=n.select(this)).text().split(/\s+/).reverse(),a=[],c=0,1.2,s=t.attr("y"),l=parseFloat(t.attr("dy")),f=t.text(null).append("tspan").attr("x",r).attr("y",s).attr("dy",l+"em");u=o.pop();)if(a.push(u),f.text(a.join(" ")),f.node()&&f.node().getComputedTextLength()>e){if(a.pop(),f.text(a.join(" ")),!(c<i-1)){a.push("..."),f.text(a.join(" "));break}a=[u],f=t.append("tspan").attr("x",r).attr("y",s).attr("dy",1.2*++c+l+"em").text(u),t.classed("adjust-upwards",!0)}}))},getApproximateNumberOfLines:function(t,n,e){var r=t.split(/\s+/).reverse(),i=[],o=1,u=!0,a=!1,c=void 0;try{for(var l,f=r[Symbol.iterator]();!(u=(l=f.next()).done);u=!0){var h=l.value;i.push(h),s(i.join(" "),n,"Karla, sans-serif")>e&&(i.pop(),i=[h],++o)}}catch(t){a=!0,c=t}finally{try{!u&&f.return&&f.return()}finally{if(a)throw c}}return o}}}.call(n,e,n,t))||(t.exports=r)},,function(t,n,e){"use strict";var r,i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};void 0===(r=function(t){var n=e(44).formatDefaultLocale,r=["decimal","thousands","grouping","currency"];return{setDefaultLocale:function(t){if(function(t){return"object"==(void 0===t?"undefined":i(t))&&r.every((function(n){return t.hasOwnProperty(n)}))}(t))return n(t);throw new Error("Please pass in a valid locale object definition")}}}.call(n,e,n,t))||(t.exports=r)},,,,,function(t,n,e){"use strict";var r,i=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r])}return t};void 0===(r=function(t){var n=e(2),r=e(64),o=e(84),u=e(43),a=e(68),c=e(44),s=e(75),l=e(6),f=(e(72),e(87)),h=e(76).exportChart,d=e(65),p=e(83).bar,_=e(85).uniqueId,g=e(89).setDefaultLocale;return function(){var t={top:20,right:20,bottom:30,left:40},e=960,y=500,v=p,m=void 0,x=void 0,b=void 0,w=void 0,M=void 0,T=void 0,O=d.singleColors.aloeGreen,A=void 0,k=void 0,C=null,S=void 0,N=_("bar-gradient"),E=5,j=5,D=1,F=",f",P=!1,L=7,I=",f",U=12,R=.1,B=void 0,H=void 0,q=0,Y=0,z=10,G=!1,V=void 0,X=!0,W=!1,$=r.easeQuadInOut,Z=function(t,n){return 70*n},Q=function(t){return t.attr("fill",(function(t){var n=t.name;return u.color(C?C[1]:k(n)).darker()}))},J=void 0,K="value",tt="name",nt=void 0,et=null,rt=null,it=30,ot=null,ut=null,at=-30,ct=!0,st=null,lt=c,ft=a.dispatch("customMouseOver","customMouseOut","customMouseMove","customClick"),ht=function(t){return t.name},dt=function(t){return t.value},pt=function(t){var n=t.value;return M(n)+L},_t=function(t){var n=t.name;return T(n)+T.bandwidth()/2+U*(3/8)},gt=function(t){var n=t.name;return M(n)},yt=function(t){var n=t.value;return T(n)-L};function vt(r){st&&(lt=g(st)),r.each((function(r){b=e-t.left-t.right-1.2*z,w=y-t.top-t.bottom;var i,u=function(t){var n=t.data,e=t.dataZeroed;J&&(n.sort(J),e.sort(J));return{data:n,dataZeroed:e}}(function(t){var n=t.reduce((function(t,n){return n.value=+n[K],n.name=String(n[tt]),[].concat(function(t){if(Array.isArray(t)){for(var n=0,e=Array(t.length);n<t.length;n++)e[n]=t[n];return e}return Array.from(t)}(t),[n])}),[]),e=n.map((function(t){return{value:0,name:String(t[tt])}}));return{data:n,dataZeroed:e}}(r));m=u.data,x=u.dataZeroed,function(){var t=function(){var t=new Set(m.map(dt));if(1===t.size&&t.has(0))return D;return Math.min(D*n.max(m,dt))}();G?(M=s.scaleLinear().domain([0,t]).rangeRound([0,b]),T=s.scaleBand().domain(m.map(ht)).rangeRound([w,0]).padding(R)):(M=s.scaleBand().domain(m.map(ht)).rangeRound([0,b]).padding(R),T=s.scaleLinear().domain([0,t]).rangeRound([w,0]));A=ct?m.map((function(t){return t})).reverse().map((function(t,n){return{name:t.name,color:O[n%O.length]}})):m.map((function(t){return t})).map((function(t,n){return{name:t.name,color:O[n%O.length]}}));k=function(t){return A.filter((function(n){return n.name===t}))[0].color}}(),function(t){G?(B=o.axisBottom(M).ticks(j,t.format(F)).tickSizeInner([-w]),H=o.axisLeft(T)):(B=o.axisBottom(M),H=o.axisLeft(T).ticks(E,t.format(F)))}(lt),function(n){V||(V=l.select(n).append("svg").classed("britechart bar-chart",!0),function(){var n=V.append("g").classed("container-group",!0).attr("transform","translate("+(t.left+z)+", "+t.top+")");n.append("g").classed("grid-lines-group",!0),n.append("g").classed("chart-group",!0),n.append("g").classed("x-axis-group axis",!0).append("g").classed("x-axis-label",!0),n.append("g").attr("transform","translate("+-1*z+", 0)").classed("y-axis-group axis",!0).append("g").classed("y-axis-label",!0),n.append("g").classed("metadata-group",!0)}());V.attr("width",e).attr("height",y)}(this),!S&&C&&(S=V.select(".metadata-group").append("linearGradient").attr("id",N).attr("x1","0%").attr("y1","0%").attr("x2","100%").attr("y2","100%").attr("gradientUnits","userSpaceOnUse").selectAll("stop").data([{offset:"0%",color:C[0]},{offset:"50%",color:C[1]}]).enter().append("stop").attr("offset",(function(t){return t.offset})).attr("stop-color",(function(t){return t.color}))),V.select(".grid-lines-group").selectAll("line").remove(),G?(V.select(".grid-lines-group").selectAll("line.vertical-grid-line").data(M.ticks(j).slice(1)).enter().append("line").attr("class","vertical-grid-line").attr("y1",q).attr("y2",w).attr("x1",(function(t){return M(t)})).attr("x2",(function(t){return M(t)})),V.select(".grid-lines-group").selectAll("line.extended-y-line").data([0]).enter().append("line").attr("class","extended-y-line").attr("y1",Y).attr("y2",w).attr("x1",0).attr("x2",0)):(V.select(".grid-lines-group").selectAll("line.horizontal-grid-line").data(T.ticks(E).slice(1)).enter().append("line").attr("class","horizontal-grid-line").attr("x1",q).attr("x2",b).attr("y1",(function(t){return T(t)})).attr("y2",(function(t){return T(t)})),V.select(".grid-lines-group").selectAll("line.extended-x-line").data([0]).enter().append("line").attr("class","extended-x-line").attr("x1",q).attr("x2",b).attr("y1",w).attr("y2",w)),V.select(".x-axis-group.axis").attr("transform","translate(0, "+w+")").call(B),V.select(".y-axis-group.axis").call(H),V.selectAll(".y-axis-group .tick text").call(xt,t.left-z),ut&&(ot&&ot.remove(),ot=V.select(".y-axis-label").append("text").classed("y-axis-label-text",!0).attr("x",-w/2).attr("y",at).attr("text-anchor","middle").attr("transform","rotate(270 0 0)").text(ut)),rt&&(et&&et.remove(),et=V.select(".x-axis-label").append("text").attr("y",it).attr("text-anchor","middle").classed("x-axis-label-text",!0).attr("x",b/2).text(rt)),i=void 0,W?(i=V.select(".chart-group").selectAll(".bar").data(x),G?bt(i):wt(i),i=V.select(".chart-group").selectAll(".bar").data(m),G?function(t){t.enter().append("rect").classed("bar",!0).attr("x",0).attr("y",w).attr("height",T.bandwidth()).attr("width",(function(t){var n=t.value;return M(n)})).on("mouseover",(function(t,n,e){Mt(this,t,e,b,w)})).on("mousemove",(function(t){Tt(this,t,b,w)})).on("mouseout",(function(t,n,e){Ot(this,t,e,b,w)})).on("click",(function(t){At(this,t,b,w)})),t.attr("x",0).attr("y",(function(t){var n=t.name;return T(n)})).attr("height",T.bandwidth()).attr("fill",(function(t){return mt(t.name)})).transition().duration(800).delay(Z).ease($).attr("width",(function(t){var n=t.value;return M(n)}))}(i):function(t){t.enter().append("rect").classed("bar",!0).attr("x",b).attr("y",(function(t){var n=t.value;return T(n)})).attr("width",M.bandwidth()).attr("height",(function(t){var n=t.value;return w-T(n)})).on("mouseover",(function(t,n,e){Mt(this,t,e,b,w)})).on("mousemove",(function(t){Tt(this,t,b,w)})).on("mouseout",(function(t,n,e){Ot(this,t,e,b,w)})).on("click",(function(t){At(this,t,b,w)})).merge(t).attr("x",(function(t){var n=t.name;return M(n)})).attr("width",M.bandwidth()).attr("fill",(function(t){return mt(t.name)})).transition().duration(800).delay(Z).ease($).attr("y",(function(t){var n=t.value;return T(n)})).attr("height",(function(t){var n=t.value;return w-T(n)}))}(i),i.exit().transition().style("opacity",0).remove()):(i=V.select(".chart-group").selectAll(".bar").data(m),G?bt(i):wt(i),i.exit().remove()),P&&function(t){var n=G?pt:gt,e=G?_t:yt;nt&&V.selectAll(".percentage-label-group").remove();(nt=V.select(".metadata-group").append("g").classed("percentage-label-group",!0).selectAll("text").data(m.reverse()).enter().append("text")).classed("percentage-label",!0).attr("x",n).attr("y",e).text((function(n){var e=n.value;return t.format(I)(e)})).attr("font-size",U+"px")}(lt)}))}function mt(t){return C?"url(#"+N+")":k(t)}function xt(t,n){f.wrapTextWithEllipses(t,n,0,1)}function bt(t){t.enter().append("rect").classed("bar",!0).attr("y",w).attr("x",0).attr("height",T.bandwidth()).attr("width",(function(t){var n=t.value;return M(n)})).on("mouseover",(function(t,n,e){Mt(this,t,e,b,w)})).on("mousemove",(function(t){Tt(this,t,b,w)})).on("mouseout",(function(t,n,e){Ot(this,t,e,b,w)})).on("click",(function(t){At(this,t,b,w)})).merge(t).attr("x",0).attr("y",(function(t){var n=t.name;return T(n)})).attr("height",T.bandwidth()).attr("width",(function(t){var n=t.value;return M(n)})).attr("fill",(function(t){return mt(t.name)}))}function wt(t){t.enter().append("rect").classed("bar",!0).attr("x",b).attr("y",(function(t){var n=t.value;return T(n)})).attr("width",M.bandwidth()).attr("height",(function(t){var n=t.value;return w-T(n)})).on("mouseover",(function(t,n,e){Mt(this,t,e,b,w)})).on("mousemove",(function(t){Tt(this,t,b,w)})).on("mouseout",(function(t,n,e){Ot(this,t,e,b,w)})).on("click",(function(t){At(this,t,b,w)})).merge(t).attr("x",(function(t){var n=t.name;return M(n)})).attr("y",(function(t){var n=t.value;return T(n)})).attr("width",M.bandwidth()).attr("height",(function(t){var n=t.value;return w-T(n)})).attr("fill",(function(t){return mt(t.name)}))}function Mt(t,n,e,r,i){ft.call("customMouseOver",t,n,l.mouse(t),[r,i]),Q=Q||function(){},X?Q(l.select(t)):e.forEach((function(n){n!==t&&Q(l.select(n))}))}function Tt(t,n,e,r){ft.call("customMouseMove",t,n,l.mouse(t),[e,r])}function Ot(t,n,e,r,i){ft.call("customMouseOut",t,n,l.mouse(t),[r,i]),e.forEach((function(t){l.select(t).attr("fill",(function(t){return mt(t.name)}))}))}function At(t,n,e,r){ft.call("customClick",t,n,l.mouse(t),[e,r])}return vt.chartGradient=function(t){return arguments.length?(C=t,this):C},vt.betweenBarsPadding=function(t){return arguments.length?(R=t,this):R},vt.colorSchema=function(t){return arguments.length?(O=t,this):O},vt.enableLabels=function(t){return arguments.length?(P=t,this):P},vt.exportChart=function(t,n){h.call(vt,V,t,n)},vt.hasPercentage=function(t){return arguments.length?(F=t?"%":",f",this):"%"===F},vt.hasSingleBarHighlight=function(t){return arguments.length?(X=t,this):X},vt.height=function(t){return arguments.length?(y=t,this):y},vt.highlightBarFunction=function(t){return arguments.length?(Q=t,this):Q},vt.isAnimated=function(t){return arguments.length?(W=t,this):W},vt.isHorizontal=function(t){return arguments.length?(G=t,this):G},vt.labelsMargin=function(t){return arguments.length?(L=t,this):L},vt.labelsNumberFormat=function(t){return arguments.length?(I=t,this):I},vt.labelsSize=function(t){return arguments.length?(U=t,this):U},vt.loadingState=function(t){return arguments.length?(v=t,this):v},vt.margin=function(n){return arguments.length?(t=i({},t,n),this):t},vt.nameLabel=function(t){return arguments.length?(tt=t,this):tt},vt.numberFormat=function(t){return arguments.length?(F=t,this):F},vt.on=function(){var t=ft.on.apply(ft,arguments);return t===ft?vt:t},vt.percentageAxisToMaxRatio=function(t){return arguments.length?(D=t,this):D},vt.shouldReverseColorList=function(t){return arguments.length?(ct=t,this):ct},vt.orderingFunction=function(t){return arguments.length?(J=t,this):J},vt.valueLabel=function(t){return arguments.length?(K=t,this):K},vt.width=function(t){return arguments.length?(e=t,this):e},vt.xAxisLabel=function(t){return arguments.length?(rt=t,this):rt},vt.xAxisLabelOffset=function(t){return arguments.length?(it=t,this):it},vt.xTicks=function(t){return arguments.length?(j=t,this):j},vt.yAxisLabel=function(t){return arguments.length?(ut=t,this):ut},vt.yAxisLabelOffset=function(t){return arguments.length?(at=t,this):at},vt.yAxisPaddingBetweenChart=function(t){return arguments.length?(z=t,this):z},vt.yTicks=function(t){return arguments.length?(E=t,this):E},vt.locale=function(t){return arguments.length?(st=t,this):st},vt}}.call(n,e,n,t))||(t.exports=r)}])}));
//# sourceMappingURL=bar.min.js.map

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.donut=n():(t.britecharts=t.britecharts||{},t.britecharts.donut=n())}(window,(function(){return function(t){var n={};function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:r})},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.t=function(t,n){if(1&n&&(t=e(t)),8&n)return t;if(4&n&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(e.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&n&&"string"!=typeof t)for(var i in t)e.d(r,i,function(n){return t[n]}.bind(null,i));return r},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.p="",e(e.s=97)}([function(t,n,e){"use strict";e.d(n,"a",(function(){return o}));var r=new Date,i=new Date;function o(t,n,e,u){function a(n){return t(n=0===arguments.length?new Date:new Date(+n)),n}return a.floor=function(n){return t(n=new Date(+n)),n},a.ceil=function(e){return t(e=new Date(e-1)),n(e,1),t(e),e},a.round=function(t){var n=a(t),e=a.ceil(t);return t-n<e-t?n:e},a.offset=function(t,e){return n(t=new Date(+t),null==e?1:Math.floor(e)),t},a.range=function(e,r,i){var o,u=[];if(e=a.ceil(e),i=null==i?1:Math.floor(i),!(e<r&&i>0))return u;do{u.push(o=new Date(+e)),n(e,i),t(e)}while(o<e&&e<r);return u},a.filter=function(e){return o((function(n){if(n>=n)for(;t(n),!e(n);)n.setTime(n-1)}),(function(t,r){if(t>=t)if(r<0)for(;++r<=0;)for(;n(t,-1),!e(t););else for(;--r>=0;)for(;n(t,1),!e(t););}))},e&&(a.count=function(n,o){return r.setTime(+n),i.setTime(+o),t(r),t(i),Math.floor(e(r,i))},a.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?a.filter(u?function(n){return u(n)%t==0}:function(n){return a.count(0,n)%t==0}):a:null}),a}},function(t,n,e){"use strict";e.d(n,"d",(function(){return r})),e.d(n,"c",(function(){return i})),e.d(n,"b",(function(){return o})),e.d(n,"a",(function(){return u})),e.d(n,"e",(function(){return a}));var r=1e3,i=6e4,o=36e5,u=864e5,a=6048e5},function(t,n,e){"use strict";e.r(n);var r=function(t,n){return t<n?-1:t>n?1:t>=n?0:NaN},i=function(t){var n;return 1===t.length&&(n=t,t=function(t,e){return r(n(t),e)}),{left:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var o=r+i>>>1;t(n[o],e)<0?r=o+1:i=o}return r},right:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var o=r+i>>>1;t(n[o],e)>0?i=o:r=o+1}return r}}};var o=i(r),u=o.right,a=o.left,c=u,s=function(t,n){null==n&&(n=f);for(var e=0,r=t.length-1,i=t[0],o=new Array(r<0?0:r);e<r;)o[e]=n(i,i=t[++e]);return o};function f(t,n){return[t,n]}var l=function(t,n,e){var r,i,o,u,a=t.length,c=n.length,s=new Array(a*c);for(null==e&&(e=f),r=o=0;r<a;++r)for(u=t[r],i=0;i<c;++i,++o)s[o]=e(u,n[i]);return s},h=function(t,n){return n<t?-1:n>t?1:n>=t?0:NaN},d=function(t){return null===t?NaN:+t},p=function(t,n){var e,r,i=t.length,o=0,u=-1,a=0,c=0;if(null==n)for(;++u<i;)isNaN(e=d(t[u]))||(c+=(r=e-a)*(e-(a+=r/++o)));else for(;++u<i;)isNaN(e=d(n(t[u],u,t)))||(c+=(r=e-a)*(e-(a+=r/++o)));if(o>1)return c/(o-1)},_=function(t,n){var e=p(t,n);return e?Math.sqrt(e):e},y=function(t,n){var e,r,i,o=t.length,u=-1;if(null==n){for(;++u<o;)if(null!=(e=t[u])&&e>=e)for(r=i=e;++u<o;)null!=(e=t[u])&&(r>e&&(r=e),i<e&&(i=e))}else for(;++u<o;)if(null!=(e=n(t[u],u,t))&&e>=e)for(r=i=e;++u<o;)null!=(e=n(t[u],u,t))&&(r>e&&(r=e),i<e&&(i=e));return[r,i]},g=Array.prototype,v=g.slice,m=g.map,x=function(t){return function(){return t}},b=function(t){return t},w=function(t,n,e){t=+t,n=+n,e=(i=arguments.length)<2?(n=t,t=0,1):i<3?1:+e;for(var r=-1,i=0|Math.max(0,Math.ceil((n-t)/e)),o=new Array(i);++r<i;)o[r]=t+r*e;return o},M=Math.sqrt(50),T=Math.sqrt(10),O=Math.sqrt(2),A=function(t,n,e){var r,i,o,u,a=-1;if(e=+e,(t=+t)===(n=+n)&&e>0)return[t];if((r=n<t)&&(i=t,t=n,n=i),0===(u=C(t,n,e))||!isFinite(u))return[];if(u>0)for(t=Math.ceil(t/u),n=Math.floor(n/u),o=new Array(i=Math.ceil(n-t+1));++a<i;)o[a]=(t+a)*u;else for(t=Math.floor(t*u),n=Math.ceil(n*u),o=new Array(i=Math.ceil(t-n+1));++a<i;)o[a]=(t-a)/u;return r&&o.reverse(),o};function C(t,n,e){var r=(n-t)/Math.max(0,e),i=Math.floor(Math.log(r)/Math.LN10),o=r/Math.pow(10,i);return i>=0?(o>=M?10:o>=T?5:o>=O?2:1)*Math.pow(10,i):-Math.pow(10,-i)/(o>=M?10:o>=T?5:o>=O?2:1)}function S(t,n,e){var r=Math.abs(n-t)/Math.max(0,e),i=Math.pow(10,Math.floor(Math.log(r)/Math.LN10)),o=r/i;return o>=M?i*=10:o>=T?i*=5:o>=O&&(i*=2),n<t?-i:i}var k=function(t){return Math.ceil(Math.log(t.length)/Math.LN2)+1},N=function(){var t=b,n=y,e=k;function r(r){var i,o,u=r.length,a=new Array(u);for(i=0;i<u;++i)a[i]=t(r[i],i,r);var s=n(a),f=s[0],l=s[1],h=e(a,f,l);Array.isArray(h)||(h=S(f,l,h),h=w(Math.ceil(f/h)*h,l,h));for(var d=h.length;h[0]<=f;)h.shift(),--d;for(;h[d-1]>l;)h.pop(),--d;var p,_=new Array(d+1);for(i=0;i<=d;++i)(p=_[i]=[]).x0=i>0?h[i-1]:f,p.x1=i<d?h[i]:l;for(i=0;i<u;++i)f<=(o=a[i])&&o<=l&&_[c(h,o,0,d)].push(r[i]);return _}return r.value=function(n){return arguments.length?(t="function"==typeof n?n:x(n),r):t},r.domain=function(t){return arguments.length?(n="function"==typeof t?t:x([t[0],t[1]]),r):n},r.thresholds=function(t){return arguments.length?(e="function"==typeof t?t:Array.isArray(t)?x(v.call(t)):x(t),r):e},r},j=function(t,n,e){if(null==e&&(e=d),r=t.length){if((n=+n)<=0||r<2)return+e(t[0],0,t);if(n>=1)return+e(t[r-1],r-1,t);var r,i=(r-1)*n,o=Math.floor(i),u=+e(t[o],o,t);return u+(+e(t[o+1],o+1,t)-u)*(i-o)}},E=function(t,n,e){return t=m.call(t,d).sort(r),Math.ceil((e-n)/(2*(j(t,.75)-j(t,.25))*Math.pow(t.length,-1/3)))},D=function(t,n,e){return Math.ceil((e-n)/(3.5*_(t)*Math.pow(t.length,-1/3)))},F=function(t,n){var e,r,i=t.length,o=-1;if(null==n){for(;++o<i;)if(null!=(e=t[o])&&e>=e)for(r=e;++o<i;)null!=(e=t[o])&&e>r&&(r=e)}else for(;++o<i;)if(null!=(e=n(t[o],o,t))&&e>=e)for(r=e;++o<i;)null!=(e=n(t[o],o,t))&&e>r&&(r=e);return r},P=function(t,n){var e,r=t.length,i=r,o=-1,u=0;if(null==n)for(;++o<r;)isNaN(e=d(t[o]))?--i:u+=e;else for(;++o<r;)isNaN(e=d(n(t[o],o,t)))?--i:u+=e;if(i)return u/i},L=function(t,n){var e,i=t.length,o=-1,u=[];if(null==n)for(;++o<i;)isNaN(e=d(t[o]))||u.push(e);else for(;++o<i;)isNaN(e=d(n(t[o],o,t)))||u.push(e);return j(u.sort(r),.5)},I=function(t){for(var n,e,r,i=t.length,o=-1,u=0;++o<i;)u+=t[o].length;for(e=new Array(u);--i>=0;)for(n=(r=t[i]).length;--n>=0;)e[--u]=r[n];return e},U=function(t,n){var e,r,i=t.length,o=-1;if(null==n){for(;++o<i;)if(null!=(e=t[o])&&e>=e)for(r=e;++o<i;)null!=(e=t[o])&&r>e&&(r=e)}else for(;++o<i;)if(null!=(e=n(t[o],o,t))&&e>=e)for(r=e;++o<i;)null!=(e=n(t[o],o,t))&&r>e&&(r=e);return r},R=function(t,n){for(var e=n.length,r=new Array(e);e--;)r[e]=t[n[e]];return r},q=function(t,n){if(e=t.length){var e,i,o=0,u=0,a=t[u];for(null==n&&(n=r);++o<e;)(n(i=t[o],a)<0||0!==n(a,a))&&(a=i,u=o);return 0===n(a,a)?u:void 0}},H=function(t,n,e){for(var r,i,o=(null==e?t.length:e)-(n=null==n?0:+n);o;)i=Math.random()*o--|0,r=t[o+n],t[o+n]=t[i+n],t[i+n]=r;return t},B=function(t,n){var e,r=t.length,i=-1,o=0;if(null==n)for(;++i<r;)(e=+t[i])&&(o+=e);else for(;++i<r;)(e=+n(t[i],i,t))&&(o+=e);return o},Y=function(t){if(!(i=t.length))return[];for(var n=-1,e=U(t,z),r=new Array(e);++n<e;)for(var i,o=-1,u=r[n]=new Array(i);++o<i;)u[o]=t[o][n];return r};function z(t){return t.length}var G=function(){return Y(arguments)};e.d(n,"bisect",(function(){return c})),e.d(n,"bisectRight",(function(){return u})),e.d(n,"bisectLeft",(function(){return a})),e.d(n,"ascending",(function(){return r})),e.d(n,"bisector",(function(){return i})),e.d(n,"cross",(function(){return l})),e.d(n,"descending",(function(){return h})),e.d(n,"deviation",(function(){return _})),e.d(n,"extent",(function(){return y})),e.d(n,"histogram",(function(){return N})),e.d(n,"thresholdFreedmanDiaconis",(function(){return E})),e.d(n,"thresholdScott",(function(){return D})),e.d(n,"thresholdSturges",(function(){return k})),e.d(n,"max",(function(){return F})),e.d(n,"mean",(function(){return P})),e.d(n,"median",(function(){return L})),e.d(n,"merge",(function(){return I})),e.d(n,"min",(function(){return U})),e.d(n,"pairs",(function(){return s})),e.d(n,"permute",(function(){return R})),e.d(n,"quantile",(function(){return j})),e.d(n,"range",(function(){return w})),e.d(n,"scan",(function(){return q})),e.d(n,"shuffle",(function(){return H})),e.d(n,"sum",(function(){return B})),e.d(n,"ticks",(function(){return A})),e.d(n,"tickIncrement",(function(){return C})),e.d(n,"tickStep",(function(){return S})),e.d(n,"transpose",(function(){return Y})),e.d(n,"variance",(function(){return p})),e.d(n,"zip",(function(){return G}))},function(t,n,e){"use strict";e.d(n,"g",(function(){return u})),e.d(n,"c",(function(){return a})),e.d(n,"k",(function(){return c})),e.d(n,"m",(function(){return s})),e.d(n,"i",(function(){return f})),e.d(n,"a",(function(){return l})),e.d(n,"e",(function(){return h})),e.d(n,"h",(function(){return d})),e.d(n,"d",(function(){return p})),e.d(n,"l",(function(){return _})),e.d(n,"n",(function(){return y})),e.d(n,"j",(function(){return g})),e.d(n,"b",(function(){return v})),e.d(n,"f",(function(){return m}));var r=e(0),i=e(1);function o(t){return Object(r.a)((function(n){n.setDate(n.getDate()-(n.getDay()+7-t)%7),n.setHours(0,0,0,0)}),(function(t,n){t.setDate(t.getDate()+7*n)}),(function(t,n){return(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*i.c)/i.e}))}var u=o(0),a=o(1),c=o(2),s=o(3),f=o(4),l=o(5),h=o(6),d=u.range,p=a.range,_=c.range,y=s.range,g=f.range,v=l.range,m=h.range},function(t,n,e){"use strict";e.d(n,"g",(function(){return u})),e.d(n,"c",(function(){return a})),e.d(n,"k",(function(){return c})),e.d(n,"m",(function(){return s})),e.d(n,"i",(function(){return f})),e.d(n,"a",(function(){return l})),e.d(n,"e",(function(){return h})),e.d(n,"h",(function(){return d})),e.d(n,"d",(function(){return p})),e.d(n,"l",(function(){return _})),e.d(n,"n",(function(){return y})),e.d(n,"j",(function(){return g})),e.d(n,"b",(function(){return v})),e.d(n,"f",(function(){return m}));var r=e(0),i=e(1);function o(t){return Object(r.a)((function(n){n.setUTCDate(n.getUTCDate()-(n.getUTCDay()+7-t)%7),n.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCDate(t.getUTCDate()+7*n)}),(function(t,n){return(n-t)/i.e}))}var u=o(0),a=o(1),c=o(2),s=o(3),f=o(4),l=o(5),h=o(6),d=u.range,p=a.range,_=c.range,y=s.range,g=f.range,v=l.range,m=h.range},function(t,n,e){"use strict";n.a=function(t,n){return t=+t,n=+n,function(e){return t*(1-e)+n*e}}},function(t,n,e){"use strict";e.r(n);var r=e(12),i=e(32),o=function(t){return Object(i.a)(Object(r.a)(t).call(document.documentElement))},u=0;function a(){return new c}function c(){this._="@"+(++u).toString(36)}c.prototype=a.prototype={constructor:c,get:function(t){for(var n=this._;!(n in t);)if(!(t=t.parentNode))return;return t[n]},set:function(t,n){return t[this._]=n},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}};var s=e(34),f=e(59),l=e(20),h=e(14),d=e(13),p=e(9),_=function(t){return"string"==typeof t?new p.a([document.querySelectorAll(t)],[document.documentElement]):new p.a([null==t?[]:t],p.c)},y=e(19),g=e(33),v=e(35),m=e(60),x=e(22),b=function(t,n){null==n&&(n=Object(x.a)().touches);for(var e=0,r=n?n.length:0,i=new Array(r);e<r;++e)i[e]=Object(d.a)(t,n[e]);return i},w=e(21),M=e(17);e.d(n,"create",(function(){return o})),e.d(n,"creator",(function(){return r.a})),e.d(n,"local",(function(){return a})),e.d(n,"matcher",(function(){return s.a})),e.d(n,"mouse",(function(){return f.a})),e.d(n,"namespace",(function(){return l.a})),e.d(n,"namespaces",(function(){return h.a})),e.d(n,"clientPoint",(function(){return d.a})),e.d(n,"select",(function(){return i.a})),e.d(n,"selectAll",(function(){return _})),e.d(n,"selection",(function(){return p.b})),e.d(n,"selector",(function(){return y.a})),e.d(n,"selectorAll",(function(){return g.a})),e.d(n,"style",(function(){return v.b})),e.d(n,"touch",(function(){return m.a})),e.d(n,"touches",(function(){return b})),e.d(n,"window",(function(){return w.a})),e.d(n,"event",(function(){return M.c})),e.d(n,"customEvent",(function(){return M.a}))},function(t,n,e){"use strict";e.d(n,"a",(function(){return i})),e.d(n,"d",(function(){return o})),e.d(n,"c",(function(){return u})),e.d(n,"e",(function(){return x})),e.d(n,"h",(function(){return M})),e.d(n,"g",(function(){return T})),e.d(n,"b",(function(){return O})),e.d(n,"f",(function(){return j}));var r=e(11);function i(){}var o=.7,u=1/o,a="\\s*([+-]?\\d+)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",s="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",f=/^#([0-9a-f]{3,8})$/,l=new RegExp("^rgb\\("+[a,a,a]+"\\)$"),h=new RegExp("^rgb\\("+[s,s,s]+"\\)$"),d=new RegExp("^rgba\\("+[a,a,a,c]+"\\)$"),p=new RegExp("^rgba\\("+[s,s,s,c]+"\\)$"),_=new RegExp("^hsl\\("+[c,s,s]+"\\)$"),y=new RegExp("^hsla\\("+[c,s,s,c]+"\\)$"),g={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};function v(){return this.rgb().formatHex()}function m(){return this.rgb().formatRgb()}function x(t){var n,e;return t=(t+"").trim().toLowerCase(),(n=f.exec(t))?(e=n[1].length,n=parseInt(n[1],16),6===e?b(n):3===e?new O(n>>8&15|n>>4&240,n>>4&15|240&n,(15&n)<<4|15&n,1):8===e?new O(n>>24&255,n>>16&255,n>>8&255,(255&n)/255):4===e?new O(n>>12&15|n>>8&240,n>>8&15|n>>4&240,n>>4&15|240&n,((15&n)<<4|15&n)/255):null):(n=l.exec(t))?new O(n[1],n[2],n[3],1):(n=h.exec(t))?new O(255*n[1]/100,255*n[2]/100,255*n[3]/100,1):(n=d.exec(t))?w(n[1],n[2],n[3],n[4]):(n=p.exec(t))?w(255*n[1]/100,255*n[2]/100,255*n[3]/100,n[4]):(n=_.exec(t))?k(n[1],n[2]/100,n[3]/100,1):(n=y.exec(t))?k(n[1],n[2]/100,n[3]/100,n[4]):g.hasOwnProperty(t)?b(g[t]):"transparent"===t?new O(NaN,NaN,NaN,0):null}function b(t){return new O(t>>16&255,t>>8&255,255&t,1)}function w(t,n,e,r){return r<=0&&(t=n=e=NaN),new O(t,n,e,r)}function M(t){return t instanceof i||(t=x(t)),t?new O((t=t.rgb()).r,t.g,t.b,t.opacity):new O}function T(t,n,e,r){return 1===arguments.length?M(t):new O(t,n,e,null==r?1:r)}function O(t,n,e,r){this.r=+t,this.g=+n,this.b=+e,this.opacity=+r}function A(){return"#"+S(this.r)+S(this.g)+S(this.b)}function C(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}function S(t){return((t=Math.max(0,Math.min(255,Math.round(t)||0)))<16?"0":"")+t.toString(16)}function k(t,n,e,r){return r<=0?t=n=e=NaN:e<=0||e>=1?t=n=NaN:n<=0&&(t=NaN),new E(t,n,e,r)}function N(t){if(t instanceof E)return new E(t.h,t.s,t.l,t.opacity);if(t instanceof i||(t=x(t)),!t)return new E;if(t instanceof E)return t;var n=(t=t.rgb()).r/255,e=t.g/255,r=t.b/255,o=Math.min(n,e,r),u=Math.max(n,e,r),a=NaN,c=u-o,s=(u+o)/2;return c?(a=n===u?(e-r)/c+6*(e<r):e===u?(r-n)/c+2:(n-e)/c+4,c/=s<.5?u+o:2-u-o,a*=60):c=s>0&&s<1?0:a,new E(a,c,s,t.opacity)}function j(t,n,e,r){return 1===arguments.length?N(t):new E(t,n,e,null==r?1:r)}function E(t,n,e,r){this.h=+t,this.s=+n,this.l=+e,this.opacity=+r}function D(t,n,e){return 255*(t<60?n+(e-n)*t/60:t<180?e:t<240?n+(e-n)*(240-t)/60:n)}Object(r.a)(i,x,{copy:function(t){return Object.assign(new this.constructor,this,t)},displayable:function(){return this.rgb().displayable()},hex:v,formatHex:v,formatHsl:function(){return N(this).formatHsl()},formatRgb:m,toString:m}),Object(r.a)(O,T,Object(r.b)(i,{brighter:function(t){return t=null==t?u:Math.pow(u,t),new O(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?o:Math.pow(o,t),new O(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return-.5<=this.r&&this.r<255.5&&-.5<=this.g&&this.g<255.5&&-.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1},hex:A,formatHex:A,formatRgb:C,toString:C})),Object(r.a)(E,j,Object(r.b)(i,{brighter:function(t){return t=null==t?u:Math.pow(u,t),new E(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?o:Math.pow(o,t),new E(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),n=isNaN(t)||isNaN(this.s)?0:this.s,e=this.l,r=e+(e<.5?e:1-e)*n,i=2*e-r;return new O(D(t>=240?t-240:t+120,i,r),D(t,i,r),D(t<120?t+240:t-120,i,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1},formatHsl:function(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"hsl(":"hsla(")+(this.h||0)+", "+100*(this.s||0)+"%, "+100*(this.l||0)+"%"+(1===t?")":", "+t+")")}}))},function(t,n,e){"use strict";var r=e(18);n.a=function(t){return(t=Object(r.a)(Math.abs(t)))?t[1]:NaN}},function(t,n,e){"use strict";var r=e(19),i=e(33),o=e(34),u=function(t){return new Array(t.length)};function a(t,n){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=n}a.prototype={constructor:a,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,n){return this._parent.insertBefore(t,n)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}};function c(t,n,e,r,i,o){for(var u,c=0,s=n.length,f=o.length;c<f;++c)(u=n[c])?(u.__data__=o[c],r[c]=u):e[c]=new a(t,o[c]);for(;c<s;++c)(u=n[c])&&(i[c]=u)}function s(t,n,e,r,i,o,u){var c,s,f,l={},h=n.length,d=o.length,p=new Array(h);for(c=0;c<h;++c)(s=n[c])&&(p[c]=f="$"+u.call(s,s.__data__,c,n),f in l?i[c]=s:l[f]=s);for(c=0;c<d;++c)(s=l[f="$"+u.call(t,o[c],c,o)])?(r[c]=s,s.__data__=o[c],l[f]=null):e[c]=new a(t,o[c]);for(c=0;c<h;++c)(s=n[c])&&l[p[c]]===s&&(i[c]=s)}function f(t,n){return t<n?-1:t>n?1:t>=n?0:NaN}var l=e(20);function h(t){return function(){this.removeAttribute(t)}}function d(t){return function(){this.removeAttributeNS(t.space,t.local)}}function p(t,n){return function(){this.setAttribute(t,n)}}function _(t,n){return function(){this.setAttributeNS(t.space,t.local,n)}}function y(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttribute(t):this.setAttribute(t,e)}}function g(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,e)}}var v=e(35);function m(t){return function(){delete this[t]}}function x(t,n){return function(){this[t]=n}}function b(t,n){return function(){var e=n.apply(this,arguments);null==e?delete this[t]:this[t]=e}}function w(t){return t.trim().split(/^|\s+/)}function M(t){return t.classList||new T(t)}function T(t){this._node=t,this._names=w(t.getAttribute("class")||"")}function O(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.add(n[r])}function A(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.remove(n[r])}function C(t){return function(){O(this,t)}}function S(t){return function(){A(this,t)}}function k(t,n){return function(){(n.apply(this,arguments)?O:A)(this,t)}}T.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var n=this._names.indexOf(t);n>=0&&(this._names.splice(n,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}};function N(){this.textContent=""}function j(t){return function(){this.textContent=t}}function E(t){return function(){var n=t.apply(this,arguments);this.textContent=null==n?"":n}}function D(){this.innerHTML=""}function F(t){return function(){this.innerHTML=t}}function P(t){return function(){var n=t.apply(this,arguments);this.innerHTML=null==n?"":n}}function L(){this.nextSibling&&this.parentNode.appendChild(this)}function I(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}var U=e(12);function R(){return null}function q(){var t=this.parentNode;t&&t.removeChild(this)}function H(){var t=this.cloneNode(!1),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}function B(){var t=this.cloneNode(!0),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}var Y=e(17),z=e(21);function G(t,n,e){var r=Object(z.a)(t),i=r.CustomEvent;"function"==typeof i?i=new i(n,e):(i=r.document.createEvent("Event"),e?(i.initEvent(n,e.bubbles,e.cancelable),i.detail=e.detail):i.initEvent(n,!1,!1)),t.dispatchEvent(i)}function X(t,n){return function(){return G(this,t,n)}}function V(t,n){return function(){return G(this,t,n.apply(this,arguments))}}e.d(n,"c",(function(){return W})),e.d(n,"a",(function(){return $}));var W=[null];function $(t,n){this._groups=t,this._parents=n}function Z(){return new $([[document.documentElement]],W)}$.prototype=Z.prototype={constructor:$,select:function(t){"function"!=typeof t&&(t=Object(r.a)(t));for(var n=this._groups,e=n.length,i=new Array(e),o=0;o<e;++o)for(var u,a,c=n[o],s=c.length,f=i[o]=new Array(s),l=0;l<s;++l)(u=c[l])&&(a=t.call(u,u.__data__,l,c))&&("__data__"in u&&(a.__data__=u.__data__),f[l]=a);return new $(i,this._parents)},selectAll:function(t){"function"!=typeof t&&(t=Object(i.a)(t));for(var n=this._groups,e=n.length,r=[],o=[],u=0;u<e;++u)for(var a,c=n[u],s=c.length,f=0;f<s;++f)(a=c[f])&&(r.push(t.call(a,a.__data__,f,c)),o.push(a));return new $(r,o)},filter:function(t){"function"!=typeof t&&(t=Object(o.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var u,a=n[i],c=a.length,s=r[i]=[],f=0;f<c;++f)(u=a[f])&&t.call(u,u.__data__,f,a)&&s.push(u);return new $(r,this._parents)},data:function(t,n){if(!t)return y=new Array(this.size()),h=-1,this.each((function(t){y[++h]=t})),y;var e,r=n?s:c,i=this._parents,o=this._groups;"function"!=typeof t&&(e=t,t=function(){return e});for(var u=o.length,a=new Array(u),f=new Array(u),l=new Array(u),h=0;h<u;++h){var d=i[h],p=o[h],_=p.length,y=t.call(d,d&&d.__data__,h,i),g=y.length,v=f[h]=new Array(g),m=a[h]=new Array(g);r(d,p,v,m,l[h]=new Array(_),y,n);for(var x,b,w=0,M=0;w<g;++w)if(x=v[w]){for(w>=M&&(M=w+1);!(b=m[M])&&++M<g;);x._next=b||null}}return(a=new $(a,i))._enter=f,a._exit=l,a},enter:function(){return new $(this._enter||this._groups.map(u),this._parents)},exit:function(){return new $(this._exit||this._groups.map(u),this._parents)},join:function(t,n,e){var r=this.enter(),i=this,o=this.exit();return r="function"==typeof t?t(r):r.append(t+""),null!=n&&(i=n(i)),null==e?o.remove():e(o),r&&i?r.merge(i).order():i},merge:function(t){for(var n=this._groups,e=t._groups,r=n.length,i=e.length,o=Math.min(r,i),u=new Array(r),a=0;a<o;++a)for(var c,s=n[a],f=e[a],l=s.length,h=u[a]=new Array(l),d=0;d<l;++d)(c=s[d]||f[d])&&(h[d]=c);for(;a<r;++a)u[a]=n[a];return new $(u,this._parents)},order:function(){for(var t=this._groups,n=-1,e=t.length;++n<e;)for(var r,i=t[n],o=i.length-1,u=i[o];--o>=0;)(r=i[o])&&(u&&4^r.compareDocumentPosition(u)&&u.parentNode.insertBefore(r,u),u=r);return this},sort:function(t){function n(n,e){return n&&e?t(n.__data__,e.__data__):!n-!e}t||(t=f);for(var e=this._groups,r=e.length,i=new Array(r),o=0;o<r;++o){for(var u,a=e[o],c=a.length,s=i[o]=new Array(c),l=0;l<c;++l)(u=a[l])&&(s[l]=u);s.sort(n)}return new $(i,this._parents).order()},call:function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this},nodes:function(){var t=new Array(this.size()),n=-1;return this.each((function(){t[++n]=this})),t},node:function(){for(var t=this._groups,n=0,e=t.length;n<e;++n)for(var r=t[n],i=0,o=r.length;i<o;++i){var u=r[i];if(u)return u}return null},size:function(){var t=0;return this.each((function(){++t})),t},empty:function(){return!this.node()},each:function(t){for(var n=this._groups,e=0,r=n.length;e<r;++e)for(var i,o=n[e],u=0,a=o.length;u<a;++u)(i=o[u])&&t.call(i,i.__data__,u,o);return this},attr:function(t,n){var e=Object(l.a)(t);if(arguments.length<2){var r=this.node();return e.local?r.getAttributeNS(e.space,e.local):r.getAttribute(e)}return this.each((null==n?e.local?d:h:"function"==typeof n?e.local?g:y:e.local?_:p)(e,n))},style:v.a,property:function(t,n){return arguments.length>1?this.each((null==n?m:"function"==typeof n?b:x)(t,n)):this.node()[t]},classed:function(t,n){var e=w(t+"");if(arguments.length<2){for(var r=M(this.node()),i=-1,o=e.length;++i<o;)if(!r.contains(e[i]))return!1;return!0}return this.each(("function"==typeof n?k:n?C:S)(e,n))},text:function(t){return arguments.length?this.each(null==t?N:("function"==typeof t?E:j)(t)):this.node().textContent},html:function(t){return arguments.length?this.each(null==t?D:("function"==typeof t?P:F)(t)):this.node().innerHTML},raise:function(){return this.each(L)},lower:function(){return this.each(I)},append:function(t){var n="function"==typeof t?t:Object(U.a)(t);return this.select((function(){return this.appendChild(n.apply(this,arguments))}))},insert:function(t,n){var e="function"==typeof t?t:Object(U.a)(t),i=null==n?R:"function"==typeof n?n:Object(r.a)(n);return this.select((function(){return this.insertBefore(e.apply(this,arguments),i.apply(this,arguments)||null)}))},remove:function(){return this.each(q)},clone:function(t){return this.select(t?B:H)},datum:function(t){return arguments.length?this.property("__data__",t):this.node().__data__},on:Y.b,dispatch:function(t,n){return this.each(("function"==typeof n?V:X)(t,n))}};n.b=Z},function(t,n,e){"use strict";e.d(n,"c",(function(){return o})),e.d(n,"b",(function(){return u})),e.d(n,"a",(function(){return a}));var r=e(23);function i(t,n){return function(e){return t+e*n}}function o(t,n){var e=n-t;return e?i(t,e>180||e<-180?e-360*Math.round(e/360):e):Object(r.a)(isNaN(t)?n:t)}function u(t){return 1==(t=+t)?a:function(n,e){return e-n?function(t,n,e){return t=Math.pow(t,e),n=Math.pow(n,e)-t,e=1/e,function(r){return Math.pow(t+r*n,e)}}(n,e,t):Object(r.a)(isNaN(n)?e:n)}}function a(t,n){var e=n-t;return e?i(t,e):Object(r.a)(isNaN(t)?n:t)}},function(t,n,e){"use strict";function r(t,n){var e=Object.create(t.prototype);for(var r in n)e[r]=n[r];return e}e.d(n,"b",(function(){return r})),n.a=function(t,n,e){t.prototype=n.prototype=e,e.constructor=t}},function(t,n,e){"use strict";var r=e(20),i=e(14);function o(t){return function(){var n=this.ownerDocument,e=this.namespaceURI;return e===i.b&&n.documentElement.namespaceURI===i.b?n.createElement(t):n.createElementNS(e,t)}}function u(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}n.a=function(t){var n=Object(r.a)(t);return(n.local?u:o)(n)}},function(t,n,e){"use strict";n.a=function(t,n){var e=t.ownerSVGElement||t;if(e.createSVGPoint){var r=e.createSVGPoint();return r.x=n.clientX,r.y=n.clientY,[(r=r.matrixTransform(t.getScreenCTM().inverse())).x,r.y]}var i=t.getBoundingClientRect();return[n.clientX-i.left-t.clientLeft,n.clientY-i.top-t.clientTop]}},function(t,n,e){"use strict";e.d(n,"b",(function(){return r}));var r="http://www.w3.org/1999/xhtml";n.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setMonth(0,1),t.setHours(0,0,0,0)}),(function(t,n){t.setFullYear(t.getFullYear()+n)}),(function(t,n){return n.getFullYear()-t.getFullYear()}),(function(t){return t.getFullYear()}));i.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)((function(n){n.setFullYear(Math.floor(n.getFullYear()/t)*t),n.setMonth(0,1),n.setHours(0,0,0,0)}),(function(n,e){n.setFullYear(n.getFullYear()+e*t)})):null},n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCFullYear(t.getUTCFullYear()+n)}),(function(t,n){return n.getUTCFullYear()-t.getUTCFullYear()}),(function(t){return t.getUTCFullYear()}));i.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)((function(n){n.setUTCFullYear(Math.floor(n.getUTCFullYear()/t)*t),n.setUTCMonth(0,1),n.setUTCHours(0,0,0,0)}),(function(n,e){n.setUTCFullYear(n.getUTCFullYear()+e*t)})):null},n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"c",(function(){return i})),e.d(n,"a",(function(){return f}));var r={},i=null;"undefined"!=typeof document&&("onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"}));function o(t,n,e){return t=u(t,n,e),function(n){var e=n.relatedTarget;e&&(e===this||8&e.compareDocumentPosition(this))||t.call(this,n)}}function u(t,n,e){return function(r){var o=i;i=r;try{t.call(this,this.__data__,n,e)}finally{i=o}}}function a(t){return t.trim().split(/^|\s+/).map((function(t){var n="",e=t.indexOf(".");return e>=0&&(n=t.slice(e+1),t=t.slice(0,e)),{type:t,name:n}}))}function c(t){return function(){var n=this.__on;if(n){for(var e,r=0,i=-1,o=n.length;r<o;++r)e=n[r],t.type&&e.type!==t.type||e.name!==t.name?n[++i]=e:this.removeEventListener(e.type,e.listener,e.capture);++i?n.length=i:delete this.__on}}}function s(t,n,e){var i=r.hasOwnProperty(t.type)?o:u;return function(r,o,u){var a,c=this.__on,s=i(n,o,u);if(c)for(var f=0,l=c.length;f<l;++f)if((a=c[f]).type===t.type&&a.name===t.name)return this.removeEventListener(a.type,a.listener,a.capture),this.addEventListener(a.type,a.listener=s,a.capture=e),void(a.value=n);this.addEventListener(t.type,s,e),a={type:t.type,name:t.name,value:n,listener:s,capture:e},c?c.push(a):this.__on=[a]}}function f(t,n,e,r){var o=i;t.sourceEvent=i,i=t;try{return n.apply(e,r)}finally{i=o}}n.b=function(t,n,e){var r,i,o=a(t+""),u=o.length;if(!(arguments.length<2)){for(f=n?s:c,null==e&&(e=!1),r=0;r<u;++r)this.each(f(o[r],n,e));return this}var f=this.node().__on;if(f)for(var l,h=0,d=f.length;h<d;++h)for(r=0,l=f[h];r<u;++r)if((i=o[r]).type===l.type&&i.name===l.name)return l.value}},function(t,n,e){"use strict";n.a=function(t,n){if((e=(t=n?t.toExponential(n-1):t.toExponential()).indexOf("e"))<0)return null;var e,r=t.slice(0,e);return[r.length>1?r[0]+r.slice(2):r,+t.slice(e+1)]}},function(t,n,e){"use strict";function r(){}n.a=function(t){return null==t?r:function(){return this.querySelector(t)}}},function(t,n,e){"use strict";var r=e(14);n.a=function(t){var n=t+="",e=n.indexOf(":");return e>=0&&"xmlns"!==(n=t.slice(0,e))&&(t=t.slice(e+1)),r.a.hasOwnProperty(n)?{space:r.a[n],local:t}:t}},function(t,n,e){"use strict";n.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,n,e){"use strict";var r=e(17);n.a=function(){for(var t,n=r.c;t=n.sourceEvent;)n=t;return n}},function(t,n,e){"use strict";n.a=function(t){return function(){return t}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"a",(function(){return o}));var r=/^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;function i(t){if(!(n=r.exec(t)))throw new Error("invalid format: "+t);var n;return new o({fill:n[1],align:n[2],sign:n[3],symbol:n[4],zero:n[5],width:n[6],comma:n[7],precision:n[8]&&n[8].slice(1),trim:n[9],type:n[10]})}function o(t){this.fill=void 0===t.fill?" ":t.fill+"",this.align=void 0===t.align?">":t.align+"",this.sign=void 0===t.sign?"-":t.sign+"",this.symbol=void 0===t.symbol?"":t.symbol+"",this.zero=!!t.zero,this.width=void 0===t.width?void 0:+t.width,this.comma=!!t.comma,this.precision=void 0===t.precision?void 0:+t.precision,this.trim=!!t.trim,this.type=void 0===t.type?"":t.type+""}i.prototype=o.prototype,o.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(void 0===this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(void 0===this.precision?"":"."+Math.max(0,0|this.precision))+(this.trim?"~":"")+this.type}},function(t,n,e){"use strict";function r(t){return ArrayBuffer.isView(t)&&!(t instanceof DataView)}e.d(n,"b",(function(){return r})),n.a=function(t,n){n||(n=[]);var e,r=t?Math.min(n.length,t.length):0,i=n.slice();return function(o){for(e=0;e<r;++e)i[e]=t[e]*(1-o)+n[e]*o;return i}}},function(t,n,e){"use strict";function r(t,n,e,r,i){var o=t*t,u=o*t;return((1-3*t+3*o-u)*n+(4-6*o+3*u)*e+(1+3*t+3*o-3*u)*r+u*i)/6}e.d(n,"a",(function(){return r})),n.b=function(t){var n=t.length-1;return function(e){var i=e<=0?e=0:e>=1?(e=1,n-1):Math.floor(e*n),o=t[i],u=t[i+1],a=i>0?t[i-1]:2*o-u,c=i<n-1?t[i+2]:2*u-o;return r((e-i/n)*n,a,o,u,c)}}},function(t,n,e){"use strict";e.d(n,"a",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setHours(0,0,0,0)}),(function(t,n){t.setDate(t.getDate()+n)}),(function(t,n){return(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*i.c)/i.a}),(function(t){return t.getDate()-1}));n.b=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCDate(t.getUTCDate()+n)}),(function(t,n){return(n-t)/i.a}),(function(t){return t.getUTCDate()-1}));n.a=o;var u=o.range},function(t,n,e){"use strict";function r(t){return t*t*t}function i(t){return--t*t*t+1}function o(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.d(n,"a",(function(){return r})),e.d(n,"c",(function(){return i})),e.d(n,"b",(function(){return o}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds())}),(function(t,n){t.setTime(+t+n*i.d)}),(function(t,n){return(n-t)/i.d}),(function(t){return t.getUTCSeconds()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(){}),(function(t,n){t.setTime(+t+n)}),(function(t,n){return n-t}));i.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?Object(r.a)((function(n){n.setTime(Math.floor(n/t)*t)}),(function(n,e){n.setTime(+n+e*t)}),(function(n,e){return(e-n)/t})):i:null},n.a=i;var o=i.range},function(t,n,e){"use strict";var r=e(9);n.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,n,e){"use strict";function r(){return[]}n.a=function(t){return null==t?r:function(){return this.querySelectorAll(t)}}},function(t,n,e){"use strict";n.a=function(t){return function(){return this.matches(t)}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return a}));var r=e(21);function i(t){return function(){this.style.removeProperty(t)}}function o(t,n,e){return function(){this.style.setProperty(t,n,e)}}function u(t,n,e){return function(){var r=n.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,e)}}function a(t,n){return t.style.getPropertyValue(n)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(n)}n.a=function(t,n,e){return arguments.length>1?this.each((null==n?i:"function"==typeof n?u:o)(t,n,null==e?"":e)):a(this.node(),t)}},function(t,n,e){"use strict";var r=e(7),i=e(39),o=e(57),u=e(56),a=e(5),c=e(58),s=e(55),f=e(23),l=e(25);n.a=function(t,n){var e,h=typeof n;return null==n||"boolean"===h?Object(f.a)(n):("number"===h?a.a:"string"===h?(e=Object(r.e)(n))?(n=e,i.a):s.a:n instanceof r.e?i.a:n instanceof Date?u.a:Object(l.b)(n)?l.a:Array.isArray(n)?o.b:"function"!=typeof n.valueOf&&"function"!=typeof n.toString||isNaN(n)?c.a:a.a)(t,n)}},function(t,n,e){"use strict";var r,i=e(8),o=e(24),u=e(18),a=function(t,n){var e=Object(u.a)(t,n);if(!e)return t+"";var r=e[0],i=e[1];return i<0?"0."+new Array(-i).join("0")+r:r.length>i+1?r.slice(0,i+1)+"."+r.slice(i+1):r+new Array(i-r.length+2).join("0")},c={"%":function(t,n){return(100*t).toFixed(n)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,n){return t.toExponential(n)},f:function(t,n){return t.toFixed(n)},g:function(t,n){return t.toPrecision(n)},o:function(t){return Math.round(t).toString(8)},p:function(t,n){return a(100*t,n)},r:a,s:function(t,n){var e=Object(u.a)(t,n);if(!e)return t+"";var i=e[0],o=e[1],a=o-(r=3*Math.max(-8,Math.min(8,Math.floor(o/3))))+1,c=i.length;return a===c?i:a>c?i+new Array(a-c+1).join("0"):a>0?i.slice(0,a)+"."+i.slice(a):"0."+new Array(1-a).join("0")+Object(u.a)(t,Math.max(0,n+a-1))[0]},X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}},s=function(t){return t},f=Array.prototype.map,l=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];n.a=function(t){var n,e,u=void 0===t.grouping||void 0===t.thousands?s:(n=f.call(t.grouping,Number),e=t.thousands+"",function(t,r){for(var i=t.length,o=[],u=0,a=n[0],c=0;i>0&&a>0&&(c+a+1>r&&(a=Math.max(1,r-c)),o.push(t.substring(i-=a,i+a)),!((c+=a+1)>r));)a=n[u=(u+1)%n.length];return o.reverse().join(e)}),a=void 0===t.currency?"":t.currency[0]+"",h=void 0===t.currency?"":t.currency[1]+"",d=void 0===t.decimal?".":t.decimal+"",p=void 0===t.numerals?s:function(t){return function(n){return n.replace(/[0-9]/g,(function(n){return t[+n]}))}}(f.call(t.numerals,String)),_=void 0===t.percent?"%":t.percent+"",y=void 0===t.minus?"-":t.minus+"",g=void 0===t.nan?"NaN":t.nan+"";function v(t){var n=(t=Object(o.b)(t)).fill,e=t.align,i=t.sign,s=t.symbol,f=t.zero,v=t.width,m=t.comma,x=t.precision,b=t.trim,w=t.type;"n"===w?(m=!0,w="g"):c[w]||(void 0===x&&(x=12),b=!0,w="g"),(f||"0"===n&&"="===e)&&(f=!0,n="0",e="=");var M="$"===s?a:"#"===s&&/[boxX]/.test(w)?"0"+w.toLowerCase():"",T="$"===s?h:/[%p]/.test(w)?_:"",O=c[w],A=/[defgprs%]/.test(w);function C(t){var o,a,c,s=M,h=T;if("c"===w)h=O(t)+h,t="";else{var _=(t=+t)<0;if(t=isNaN(t)?g:O(Math.abs(t),x),b&&(t=function(t){t:for(var n,e=t.length,r=1,i=-1;r<e;++r)switch(t[r]){case".":i=n=r;break;case"0":0===i&&(i=r),n=r;break;default:if(!+t[r])break t;i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}(t)),_&&0==+t&&(_=!1),s=(_?"("===i?i:y:"-"===i||"("===i?"":i)+s,h=("s"===w?l[8+r/3]:"")+h+(_&&"("===i?")":""),A)for(o=-1,a=t.length;++o<a;)if(48>(c=t.charCodeAt(o))||c>57){h=(46===c?d+t.slice(o+1):t.slice(o))+h,t=t.slice(0,o);break}}m&&!f&&(t=u(t,1/0));var C=s.length+t.length+h.length,S=C<v?new Array(v-C+1).join(n):"";switch(m&&f&&(t=u(S+t,S.length?v-h.length:1/0),S=""),e){case"<":t=s+t+h+S;break;case"=":t=s+S+t+h;break;case"^":t=S.slice(0,C=S.length>>1)+s+t+h+S.slice(C);break;default:t=S+s+t+h}return p(t)}return x=void 0===x?6:/[gprs]/.test(w)?Math.max(1,Math.min(21,x)):Math.max(0,Math.min(20,x)),C.toString=function(){return t+""},C}return{format:v,formatPrefix:function(t,n){var e=v(((t=Object(o.b)(t)).type="f",t)),r=3*Math.max(-8,Math.min(8,Math.floor(Object(i.a)(n)/3))),u=Math.pow(10,-r),a=l[8+r/3];return function(t){return e(u*t)+a}}}}},function(t,n,e){"use strict";e.r(n);var r=e(0);e.d(n,"timeInterval",(function(){return r.a}));var i=e(31);e.d(n,"timeMillisecond",(function(){return i.a})),e.d(n,"timeMilliseconds",(function(){return i.b})),e.d(n,"utcMillisecond",(function(){return i.a})),e.d(n,"utcMilliseconds",(function(){return i.b}));var o=e(30);e.d(n,"timeSecond",(function(){return o.a})),e.d(n,"timeSeconds",(function(){return o.b})),e.d(n,"utcSecond",(function(){return o.a})),e.d(n,"utcSeconds",(function(){return o.b}));var u=e(49);e.d(n,"timeMinute",(function(){return u.a})),e.d(n,"timeMinutes",(function(){return u.b}));var a=e(48);e.d(n,"timeHour",(function(){return a.a})),e.d(n,"timeHours",(function(){return a.b}));var c=e(27);e.d(n,"timeDay",(function(){return c.b})),e.d(n,"timeDays",(function(){return c.a}));var s=e(3);e.d(n,"timeWeek",(function(){return s.g})),e.d(n,"timeWeeks",(function(){return s.h})),e.d(n,"timeSunday",(function(){return s.g})),e.d(n,"timeSundays",(function(){return s.h})),e.d(n,"timeMonday",(function(){return s.c})),e.d(n,"timeMondays",(function(){return s.d})),e.d(n,"timeTuesday",(function(){return s.k})),e.d(n,"timeTuesdays",(function(){return s.l})),e.d(n,"timeWednesday",(function(){return s.m})),e.d(n,"timeWednesdays",(function(){return s.n})),e.d(n,"timeThursday",(function(){return s.i})),e.d(n,"timeThursdays",(function(){return s.j})),e.d(n,"timeFriday",(function(){return s.a})),e.d(n,"timeFridays",(function(){return s.b})),e.d(n,"timeSaturday",(function(){return s.e})),e.d(n,"timeSaturdays",(function(){return s.f}));var f=e(47);e.d(n,"timeMonth",(function(){return f.a})),e.d(n,"timeMonths",(function(){return f.b}));var l=e(15);e.d(n,"timeYear",(function(){return l.a})),e.d(n,"timeYears",(function(){return l.b}));var h=e(52);e.d(n,"utcMinute",(function(){return h.a})),e.d(n,"utcMinutes",(function(){return h.b}));var d=e(51);e.d(n,"utcHour",(function(){return d.a})),e.d(n,"utcHours",(function(){return d.b}));var p=e(28);e.d(n,"utcDay",(function(){return p.a})),e.d(n,"utcDays",(function(){return p.b}));var _=e(4);e.d(n,"utcWeek",(function(){return _.g})),e.d(n,"utcWeeks",(function(){return _.h})),e.d(n,"utcSunday",(function(){return _.g})),e.d(n,"utcSundays",(function(){return _.h})),e.d(n,"utcMonday",(function(){return _.c})),e.d(n,"utcMondays",(function(){return _.d})),e.d(n,"utcTuesday",(function(){return _.k})),e.d(n,"utcTuesdays",(function(){return _.l})),e.d(n,"utcWednesday",(function(){return _.m})),e.d(n,"utcWednesdays",(function(){return _.n})),e.d(n,"utcThursday",(function(){return _.i})),e.d(n,"utcThursdays",(function(){return _.j})),e.d(n,"utcFriday",(function(){return _.a})),e.d(n,"utcFridays",(function(){return _.b})),e.d(n,"utcSaturday",(function(){return _.e})),e.d(n,"utcSaturdays",(function(){return _.f}));var y=e(50);e.d(n,"utcMonth",(function(){return y.a})),e.d(n,"utcMonths",(function(){return y.b}));var g=e(16);e.d(n,"utcYear",(function(){return g.a})),e.d(n,"utcYears",(function(){return g.b}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return c})),e.d(n,"c",(function(){return s}));var r=e(7),i=e(26),o=e(53),u=e(10);function a(t){return function(n){var e,i,o=n.length,u=new Array(o),a=new Array(o),c=new Array(o);for(e=0;e<o;++e)i=Object(r.g)(n[e]),u[e]=i.r||0,a[e]=i.g||0,c[e]=i.b||0;return u=t(u),a=t(a),c=t(c),i.opacity=1,function(t){return i.r=u(t),i.g=a(t),i.b=c(t),i+""}}}n.a=function t(n){var e=Object(u.b)(n);function i(t,n){var i=e((t=Object(r.g)(t)).r,(n=Object(r.g)(n)).r),o=e(t.g,n.g),a=e(t.b,n.b),c=Object(u.a)(t.opacity,n.opacity);return function(n){return t.r=i(n),t.g=o(n),t.b=a(n),t.opacity=c(n),t+""}}return i.gamma=t,i}(1);var c=a(i.b),s=a(o.a)},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"c",(function(){return o})),e.d(n,"a",(function(){return a}));var r,i,o,u=e(37);function a(t){return r=Object(u.a)(t),i=r.format,o=r.formatPrefix,r}a({decimal:".",thousands:",",grouping:[3],currency:["$",""],minus:"-"})},function(t,n,e){"use strict";e.r(n);var r=e(36),i=e(57),o=e(26),u=e(53),a=e(56),c=function(t){var n=t.length;return function(e){return t[Math.max(0,Math.min(n-1,Math.floor(e*n)))]}},s=e(10),f=function(t,n){var e=Object(s.c)(+t,+n);return function(t){var n=e(t);return n-360*Math.floor(n/360)}},l=e(5),h=e(25),d=e(58),p=e(81),_=e(55),y=e(74),g=Math.SQRT2;function v(t){return((t=Math.exp(t))+1/t)/2}var m=function(t,n){var e,r,i=t[0],o=t[1],u=t[2],a=n[0],c=n[1],s=n[2],f=a-i,l=c-o,h=f*f+l*l;if(h<1e-12)r=Math.log(s/u)/g,e=function(t){return[i+t*f,o+t*l,u*Math.exp(g*t*r)]};else{var d=Math.sqrt(h),p=(s*s-u*u+4*h)/(2*u*2*d),_=(s*s-u*u-4*h)/(2*s*2*d),y=Math.log(Math.sqrt(p*p+1)-p),m=Math.log(Math.sqrt(_*_+1)-_);r=(m-y)/g,e=function(t){var n,e=t*r,a=v(y),c=u/(2*d)*(a*(n=g*e+y,((n=Math.exp(2*n))-1)/(n+1))-function(t){return((t=Math.exp(t))-1/t)/2}(y));return[i+c*f,o+c*l,u*a/v(g*e+y)]}}return e.duration=1e3*r,e},x=e(39),b=e(7);function w(t){return function(n,e){var r=t((n=Object(b.f)(n)).h,(e=Object(b.f)(e)).h),i=Object(s.a)(n.s,e.s),o=Object(s.a)(n.l,e.l),u=Object(s.a)(n.opacity,e.opacity);return function(t){return n.h=r(t),n.s=i(t),n.l=o(t),n.opacity=u(t),n+""}}}var M=w(s.c),T=w(s.a),O=e(82);function A(t,n){var e=Object(s.a)((t=Object(O.a)(t)).l,(n=Object(O.a)(n)).l),r=Object(s.a)(t.a,n.a),i=Object(s.a)(t.b,n.b),o=Object(s.a)(t.opacity,n.opacity);return function(n){return t.l=e(n),t.a=r(n),t.b=i(n),t.opacity=o(n),t+""}}function C(t){return function(n,e){var r=t((n=Object(O.c)(n)).h,(e=Object(O.c)(e)).h),i=Object(s.a)(n.c,e.c),o=Object(s.a)(n.l,e.l),u=Object(s.a)(n.opacity,e.opacity);return function(t){return n.h=r(t),n.c=i(t),n.l=o(t),n.opacity=u(t),n+""}}}var S=C(s.c),k=C(s.a),N=e(86);function j(t){return function n(e){function r(n,r){var i=t((n=Object(N.a)(n)).h,(r=Object(N.a)(r)).h),o=Object(s.a)(n.s,r.s),u=Object(s.a)(n.l,r.l),a=Object(s.a)(n.opacity,r.opacity);return function(t){return n.h=i(t),n.s=o(t),n.l=u(Math.pow(t,e)),n.opacity=a(t),n+""}}return e=+e,r.gamma=n,r}(1)}var E=j(s.c),D=j(s.a);function F(t,n){for(var e=0,r=n.length-1,i=n[0],o=new Array(r<0?0:r);e<r;)o[e]=t(i,i=n[++e]);return function(t){var n=Math.max(0,Math.min(r-1,Math.floor(t*=r)));return o[n](t-n)}}var P=function(t,n){for(var e=new Array(n),r=0;r<n;++r)e[r]=t(r/(n-1));return e};e.d(n,"interpolate",(function(){return r.a})),e.d(n,"interpolateArray",(function(){return i.a})),e.d(n,"interpolateBasis",(function(){return o.b})),e.d(n,"interpolateBasisClosed",(function(){return u.a})),e.d(n,"interpolateDate",(function(){return a.a})),e.d(n,"interpolateDiscrete",(function(){return c})),e.d(n,"interpolateHue",(function(){return f})),e.d(n,"interpolateNumber",(function(){return l.a})),e.d(n,"interpolateNumberArray",(function(){return h.a})),e.d(n,"interpolateObject",(function(){return d.a})),e.d(n,"interpolateRound",(function(){return p.a})),e.d(n,"interpolateString",(function(){return _.a})),e.d(n,"interpolateTransformCss",(function(){return y.a})),e.d(n,"interpolateTransformSvg",(function(){return y.b})),e.d(n,"interpolateZoom",(function(){return m})),e.d(n,"interpolateRgb",(function(){return x.a})),e.d(n,"interpolateRgbBasis",(function(){return x.b})),e.d(n,"interpolateRgbBasisClosed",(function(){return x.c})),e.d(n,"interpolateHsl",(function(){return M})),e.d(n,"interpolateHslLong",(function(){return T})),e.d(n,"interpolateLab",(function(){return A})),e.d(n,"interpolateHcl",(function(){return S})),e.d(n,"interpolateHclLong",(function(){return k})),e.d(n,"interpolateCubehelix",(function(){return E})),e.d(n,"interpolateCubehelixLong",(function(){return D})),e.d(n,"piecewise",(function(){return F})),e.d(n,"quantize",(function(){return P}))},,,function(t,n,e){"use strict";e.r(n);var r=e(40);e.d(n,"formatDefaultLocale",(function(){return r.a})),e.d(n,"format",(function(){return r.b})),e.d(n,"formatPrefix",(function(){return r.c}));var i=e(37);e.d(n,"formatLocale",(function(){return i.a}));var o=e(24);e.d(n,"formatSpecifier",(function(){return o.b})),e.d(n,"FormatSpecifier",(function(){return o.a}));var u=e(61);e.d(n,"precisionFixed",(function(){return u.a}));var a=e(62);e.d(n,"precisionPrefix",(function(){return a.a}));var c=e(63);e.d(n,"precisionRound",(function(){return c.a}))},function(t,n,e){"use strict";e.r(n);function r(){}function i(t,n){var e=new r;if(t instanceof r)t.each((function(t,n){e.set(n,t)}));else if(Array.isArray(t)){var i,o=-1,u=t.length;if(null==n)for(;++o<u;)e.set(o,t[o]);else for(;++o<u;)e.set(n(i=t[o],o,t),i)}else if(t)for(var a in t)e.set(a,t[a]);return e}r.prototype=i.prototype={constructor:r,has:function(t){return"$"+t in this},get:function(t){return this["$"+t]},set:function(t,n){return this["$"+t]=n,this},remove:function(t){var n="$"+t;return n in this&&delete this[n]},clear:function(){for(var t in this)"$"===t[0]&&delete this[t]},keys:function(){var t=[];for(var n in this)"$"===n[0]&&t.push(n.slice(1));return t},values:function(){var t=[];for(var n in this)"$"===n[0]&&t.push(this[n]);return t},entries:function(){var t=[];for(var n in this)"$"===n[0]&&t.push({key:n.slice(1),value:this[n]});return t},size:function(){var t=0;for(var n in this)"$"===n[0]&&++t;return t},empty:function(){for(var t in this)if("$"===t[0])return!1;return!0},each:function(t){for(var n in this)"$"===n[0]&&t(this[n],n.slice(1),this)}};var o=i,u=function(){var t,n,e,r=[],i=[];function u(e,i,a,c){if(i>=r.length)return null!=t&&e.sort(t),null!=n?n(e):e;for(var s,f,l,h=-1,d=e.length,p=r[i++],_=o(),y=a();++h<d;)(l=_.get(s=p(f=e[h])+""))?l.push(f):_.set(s,[f]);return _.each((function(t,n){c(y,n,u(t,i,a,c))})),y}return e={object:function(t){return u(t,0,a,c)},map:function(t){return u(t,0,s,f)},entries:function(t){return function t(e,o){if(++o>r.length)return e;var u,a=i[o-1];return null!=n&&o>=r.length?u=e.entries():(u=[],e.each((function(n,e){u.push({key:e,values:t(n,o)})}))),null!=a?u.sort((function(t,n){return a(t.key,n.key)})):u}(u(t,0,s,f),0)},key:function(t){return r.push(t),e},sortKeys:function(t){return i[r.length-1]=t,e},sortValues:function(n){return t=n,e},rollup:function(t){return n=t,e}}};function a(){return{}}function c(t,n,e){t[n]=e}function s(){return o()}function f(t,n,e){t.set(n,e)}function l(){}var h=o.prototype;function d(t,n){var e=new l;if(t instanceof l)t.each((function(t){e.add(t)}));else if(t){var r=-1,i=t.length;if(null==n)for(;++r<i;)e.add(t[r]);else for(;++r<i;)e.add(n(t[r],r,t))}return e}l.prototype=d.prototype={constructor:l,has:h.has,add:function(t){return this["$"+(t+="")]=t,this},remove:h.remove,clear:h.clear,values:h.keys,size:h.size,empty:h.empty,each:h.each};var p=d,_=function(t){var n=[];for(var e in t)n.push(e);return n},y=function(t){var n=[];for(var e in t)n.push(t[e]);return n},g=function(t){var n=[];for(var e in t)n.push({key:e,value:t[e]});return n};e.d(n,"nest",(function(){return u})),e.d(n,"set",(function(){return p})),e.d(n,"map",(function(){return o})),e.d(n,"keys",(function(){return _})),e.d(n,"values",(function(){return y})),e.d(n,"entries",(function(){return g}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"c",(function(){return o})),e.d(n,"d",(function(){return u})),e.d(n,"e",(function(){return a})),e.d(n,"a",(function(){return s}));var r,i,o,u,a,c=e(54);function s(t){return r=Object(c.a)(t),i=r.format,o=r.parse,u=r.utcFormat,a=r.utcParse,r}s({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setDate(1),t.setHours(0,0,0,0)}),(function(t,n){t.setMonth(t.getMonth()+n)}),(function(t,n){return n.getMonth()-t.getMonth()+12*(n.getFullYear()-t.getFullYear())}),(function(t){return t.getMonth()}));n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds()-t.getSeconds()*i.d-t.getMinutes()*i.c)}),(function(t,n){t.setTime(+t+n*i.b)}),(function(t,n){return(n-t)/i.b}),(function(t){return t.getHours()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds()-t.getSeconds()*i.d)}),(function(t,n){t.setTime(+t+n*i.c)}),(function(t,n){return(n-t)/i.c}),(function(t){return t.getMinutes()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setUTCDate(1),t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCMonth(t.getUTCMonth()+n)}),(function(t,n){return n.getUTCMonth()-t.getUTCMonth()+12*(n.getUTCFullYear()-t.getUTCFullYear())}),(function(t){return t.getUTCMonth()}));n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCMinutes(0,0,0)}),(function(t,n){t.setTime(+t+n*i.b)}),(function(t,n){return(n-t)/i.b}),(function(t){return t.getUTCHours()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCSeconds(0,0)}),(function(t,n){t.setTime(+t+n*i.c)}),(function(t,n){return(n-t)/i.c}),(function(t){return t.getUTCMinutes()}));n.a=o;var u=o.range},function(t,n,e){"use strict";var r=e(26);n.a=function(t){var n=t.length;return function(e){var i=Math.floor(((e%=1)<0?++e:e)*n),o=t[(i+n-1)%n],u=t[i%n],a=t[(i+1)%n],c=t[(i+2)%n];return Object(r.a)((e-i/n)*n,o,u,a,c)}}},function(t,n,e){"use strict";e.d(n,"a",(function(){return h}));var r=e(4),i=e(28),o=e(3),u=e(27),a=e(15),c=e(16);function s(t){if(0<=t.y&&t.y<100){var n=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return n.setFullYear(t.y),n}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function f(t){if(0<=t.y&&t.y<100){var n=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return n.setUTCFullYear(t.y),n}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function l(t,n,e){return{y:t,m:n,d:e,H:0,M:0,S:0,L:0}}function h(t){var n=t.dateTime,e=t.date,a=t.time,c=t.periods,h=t.days,p=t.shortDays,_=t.months,y=t.shortMonths,g=m(c),v=x(c),Tt=m(h),Ot=x(h),At=m(p),Ct=x(p),St=m(_),kt=x(_),Nt=m(y),jt=x(y),Et={a:function(t){return p[t.getDay()]},A:function(t){return h[t.getDay()]},b:function(t){return y[t.getMonth()]},B:function(t){return _[t.getMonth()]},c:null,d:H,e:H,f:X,H:B,I:Y,j:z,L:G,m:V,M:W,p:function(t){return c[+(t.getHours()>=12)]},q:function(t){return 1+~~(t.getMonth()/3)},Q:wt,s:Mt,S:$,u:Z,U:Q,V:J,w:K,W:tt,x:null,X:null,y:nt,Y:et,Z:rt,"%":bt},Dt={a:function(t){return p[t.getUTCDay()]},A:function(t){return h[t.getUTCDay()]},b:function(t){return y[t.getUTCMonth()]},B:function(t){return _[t.getUTCMonth()]},c:null,d:it,e:it,f:st,H:ot,I:ut,j:at,L:ct,m:ft,M:lt,p:function(t){return c[+(t.getUTCHours()>=12)]},q:function(t){return 1+~~(t.getUTCMonth()/3)},Q:wt,s:Mt,S:ht,u:dt,U:pt,V:_t,w:yt,W:gt,x:null,X:null,y:vt,Y:mt,Z:xt,"%":bt},Ft={a:function(t,n,e){var r=At.exec(n.slice(e));return r?(t.w=Ct[r[0].toLowerCase()],e+r[0].length):-1},A:function(t,n,e){var r=Tt.exec(n.slice(e));return r?(t.w=Ot[r[0].toLowerCase()],e+r[0].length):-1},b:function(t,n,e){var r=Nt.exec(n.slice(e));return r?(t.m=jt[r[0].toLowerCase()],e+r[0].length):-1},B:function(t,n,e){var r=St.exec(n.slice(e));return r?(t.m=kt[r[0].toLowerCase()],e+r[0].length):-1},c:function(t,e,r){return It(t,n,e,r)},d:j,e:j,f:I,H:D,I:D,j:E,L:L,m:N,M:F,p:function(t,n,e){var r=g.exec(n.slice(e));return r?(t.p=v[r[0].toLowerCase()],e+r[0].length):-1},q:k,Q:R,s:q,S:P,u:w,U:M,V:T,w:b,W:O,x:function(t,n,r){return It(t,e,n,r)},X:function(t,n,e){return It(t,a,n,e)},y:C,Y:A,Z:S,"%":U};function Pt(t,n){return function(e){var r,i,o,u=[],a=-1,c=0,s=t.length;for(e instanceof Date||(e=new Date(+e));++a<s;)37===t.charCodeAt(a)&&(u.push(t.slice(c,a)),null!=(i=d[r=t.charAt(++a)])?r=t.charAt(++a):i="e"===r?" ":"0",(o=n[r])&&(r=o(e,i)),u.push(r),c=a+1);return u.push(t.slice(c,a)),u.join("")}}function Lt(t,n){return function(e){var a,c,h=l(1900,void 0,1);if(It(h,t,e+="",0)!=e.length)return null;if("Q"in h)return new Date(h.Q);if("s"in h)return new Date(1e3*h.s+("L"in h?h.L:0));if(!n||"Z"in h||(h.Z=0),"p"in h&&(h.H=h.H%12+12*h.p),void 0===h.m&&(h.m="q"in h?h.q:0),"V"in h){if(h.V<1||h.V>53)return null;"w"in h||(h.w=1),"Z"in h?(c=(a=f(l(h.y,0,1))).getUTCDay(),a=c>4||0===c?r.c.ceil(a):Object(r.c)(a),a=i.a.offset(a,7*(h.V-1)),h.y=a.getUTCFullYear(),h.m=a.getUTCMonth(),h.d=a.getUTCDate()+(h.w+6)%7):(c=(a=s(l(h.y,0,1))).getDay(),a=c>4||0===c?o.c.ceil(a):Object(o.c)(a),a=u.b.offset(a,7*(h.V-1)),h.y=a.getFullYear(),h.m=a.getMonth(),h.d=a.getDate()+(h.w+6)%7)}else("W"in h||"U"in h)&&("w"in h||(h.w="u"in h?h.u%7:"W"in h?1:0),c="Z"in h?f(l(h.y,0,1)).getUTCDay():s(l(h.y,0,1)).getDay(),h.m=0,h.d="W"in h?(h.w+6)%7+7*h.W-(c+5)%7:h.w+7*h.U-(c+6)%7);return"Z"in h?(h.H+=h.Z/100|0,h.M+=h.Z%100,f(h)):s(h)}}function It(t,n,e,r){for(var i,o,u=0,a=n.length,c=e.length;u<a;){if(r>=c)return-1;if(37===(i=n.charCodeAt(u++))){if(i=n.charAt(u++),!(o=Ft[i in d?n.charAt(u++):i])||(r=o(t,e,r))<0)return-1}else if(i!=e.charCodeAt(r++))return-1}return r}return(Et.x=Pt(e,Et),Et.X=Pt(a,Et),Et.c=Pt(n,Et),Dt.x=Pt(e,Dt),Dt.X=Pt(a,Dt),Dt.c=Pt(n,Dt),{format:function(t){var n=Pt(t+="",Et);return n.toString=function(){return t},n},parse:function(t){var n=Lt(t+="",!1);return n.toString=function(){return t},n},utcFormat:function(t){var n=Pt(t+="",Dt);return n.toString=function(){return t},n},utcParse:function(t){var n=Lt(t+="",!0);return n.toString=function(){return t},n}})}var d={"-":"",_:" ",0:"0"},p=/^\s*\d+/,_=/^%/,y=/[\\^$*+?|[\]().{}]/g;function g(t,n,e){var r=t<0?"-":"",i=(r?-t:t)+"",o=i.length;return r+(o<e?new Array(e-o+1).join(n)+i:i)}function v(t){return t.replace(y,"\\$&")}function m(t){return new RegExp("^(?:"+t.map(v).join("|")+")","i")}function x(t){for(var n={},e=-1,r=t.length;++e<r;)n[t[e].toLowerCase()]=e;return n}function b(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.w=+r[0],e+r[0].length):-1}function w(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.u=+r[0],e+r[0].length):-1}function M(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.U=+r[0],e+r[0].length):-1}function T(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.V=+r[0],e+r[0].length):-1}function O(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.W=+r[0],e+r[0].length):-1}function A(t,n,e){var r=p.exec(n.slice(e,e+4));return r?(t.y=+r[0],e+r[0].length):-1}function C(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),e+r[0].length):-1}function S(t,n,e){var r=/^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(n.slice(e,e+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),e+r[0].length):-1}function k(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.q=3*r[0]-3,e+r[0].length):-1}function N(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.m=r[0]-1,e+r[0].length):-1}function j(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.d=+r[0],e+r[0].length):-1}function E(t,n,e){var r=p.exec(n.slice(e,e+3));return r?(t.m=0,t.d=+r[0],e+r[0].length):-1}function D(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.H=+r[0],e+r[0].length):-1}function F(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.M=+r[0],e+r[0].length):-1}function P(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.S=+r[0],e+r[0].length):-1}function L(t,n,e){var r=p.exec(n.slice(e,e+3));return r?(t.L=+r[0],e+r[0].length):-1}function I(t,n,e){var r=p.exec(n.slice(e,e+6));return r?(t.L=Math.floor(r[0]/1e3),e+r[0].length):-1}function U(t,n,e){var r=_.exec(n.slice(e,e+1));return r?e+r[0].length:-1}function R(t,n,e){var r=p.exec(n.slice(e));return r?(t.Q=+r[0],e+r[0].length):-1}function q(t,n,e){var r=p.exec(n.slice(e));return r?(t.s=+r[0],e+r[0].length):-1}function H(t,n){return g(t.getDate(),n,2)}function B(t,n){return g(t.getHours(),n,2)}function Y(t,n){return g(t.getHours()%12||12,n,2)}function z(t,n){return g(1+u.b.count(Object(a.a)(t),t),n,3)}function G(t,n){return g(t.getMilliseconds(),n,3)}function X(t,n){return G(t,n)+"000"}function V(t,n){return g(t.getMonth()+1,n,2)}function W(t,n){return g(t.getMinutes(),n,2)}function $(t,n){return g(t.getSeconds(),n,2)}function Z(t){var n=t.getDay();return 0===n?7:n}function Q(t,n){return g(o.g.count(Object(a.a)(t)-1,t),n,2)}function J(t,n){var e=t.getDay();return t=e>=4||0===e?Object(o.i)(t):o.i.ceil(t),g(o.i.count(Object(a.a)(t),t)+(4===Object(a.a)(t).getDay()),n,2)}function K(t){return t.getDay()}function tt(t,n){return g(o.c.count(Object(a.a)(t)-1,t),n,2)}function nt(t,n){return g(t.getFullYear()%100,n,2)}function et(t,n){return g(t.getFullYear()%1e4,n,4)}function rt(t){var n=t.getTimezoneOffset();return(n>0?"-":(n*=-1,"+"))+g(n/60|0,"0",2)+g(n%60,"0",2)}function it(t,n){return g(t.getUTCDate(),n,2)}function ot(t,n){return g(t.getUTCHours(),n,2)}function ut(t,n){return g(t.getUTCHours()%12||12,n,2)}function at(t,n){return g(1+i.a.count(Object(c.a)(t),t),n,3)}function ct(t,n){return g(t.getUTCMilliseconds(),n,3)}function st(t,n){return ct(t,n)+"000"}function ft(t,n){return g(t.getUTCMonth()+1,n,2)}function lt(t,n){return g(t.getUTCMinutes(),n,2)}function ht(t,n){return g(t.getUTCSeconds(),n,2)}function dt(t){var n=t.getUTCDay();return 0===n?7:n}function pt(t,n){return g(r.g.count(Object(c.a)(t)-1,t),n,2)}function _t(t,n){var e=t.getUTCDay();return t=e>=4||0===e?Object(r.i)(t):r.i.ceil(t),g(r.i.count(Object(c.a)(t),t)+(4===Object(c.a)(t).getUTCDay()),n,2)}function yt(t){return t.getUTCDay()}function gt(t,n){return g(r.c.count(Object(c.a)(t)-1,t),n,2)}function vt(t,n){return g(t.getUTCFullYear()%100,n,2)}function mt(t,n){return g(t.getUTCFullYear()%1e4,n,4)}function xt(){return"+0000"}function bt(){return"%"}function wt(t){return+t}function Mt(t){return Math.floor(+t/1e3)}},function(t,n,e){"use strict";var r=e(5),i=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,o=new RegExp(i.source,"g");n.a=function(t,n){var e,u,a,c=i.lastIndex=o.lastIndex=0,s=-1,f=[],l=[];for(t+="",n+="";(e=i.exec(t))&&(u=o.exec(n));)(a=u.index)>c&&(a=n.slice(c,a),f[s]?f[s]+=a:f[++s]=a),(e=e[0])===(u=u[0])?f[s]?f[s]+=u:f[++s]=u:(f[++s]=null,l.push({i:s,x:Object(r.a)(e,u)})),c=o.lastIndex;return c<n.length&&(a=n.slice(c),f[s]?f[s]+=a:f[++s]=a),f.length<2?l[0]?function(t){return function(n){return t(n)+""}}(l[0].x):function(t){return function(){return t}}(n):(n=l.length,function(t){for(var e,r=0;r<n;++r)f[(e=l[r]).i]=e.x(t);return f.join("")})}},function(t,n,e){"use strict";n.a=function(t,n){var e=new Date;return t=+t,n=+n,function(r){return e.setTime(t*(1-r)+n*r),e}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(36),i=e(25);function o(t,n){var e,i=n?n.length:0,o=t?Math.min(i,t.length):0,u=new Array(o),a=new Array(i);for(e=0;e<o;++e)u[e]=Object(r.a)(t[e],n[e]);for(;e<i;++e)a[e]=n[e];return function(t){for(e=0;e<o;++e)a[e]=u[e](t);return a}}n.a=function(t,n){return(Object(i.b)(n)?i.a:o)(t,n)}},function(t,n,e){"use strict";var r=e(36);n.a=function(t,n){var e,i={},o={};for(e in null!==t&&"object"==typeof t||(t={}),null!==n&&"object"==typeof n||(n={}),n)e in t?i[e]=Object(r.a)(t[e],n[e]):o[e]=n[e];return function(t){for(e in i)o[e]=i[e](t);return o}}},function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t){var n=Object(r.a)();return n.changedTouches&&(n=n.changedTouches[0]),Object(i.a)(t,n)}},function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t,n,e){arguments.length<3&&(e=n,n=Object(r.a)().changedTouches);for(var o,u=0,a=n?n.length:0;u<a;++u)if((o=n[u]).identifier===e)return Object(i.a)(t,o);return null}},function(t,n,e){"use strict";var r=e(8);n.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(n)/3)))-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return t=Math.abs(t),n=Math.abs(n)-t,Math.max(0,Object(r.a)(n)-Object(r.a)(t))+1}},function(t,n,e){"use strict";function r(t){return+t}function i(t){return t*t}function o(t){return t*(2-t)}function u(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.r(n);var a=e(29),c=function t(n){function e(t){return Math.pow(t,n)}return n=+n,e.exponent=t,e}(3),s=function t(n){function e(t){return 1-Math.pow(1-t,n)}return n=+n,e.exponent=t,e}(3),f=function t(n){function e(t){return((t*=2)<=1?Math.pow(t,n):2-Math.pow(2-t,n))/2}return n=+n,e.exponent=t,e}(3),l=Math.PI,h=l/2;function d(t){return 1-Math.cos(t*h)}function p(t){return Math.sin(t*h)}function _(t){return(1-Math.cos(l*t))/2}function y(t){return Math.pow(2,10*t-10)}function g(t){return 1-Math.pow(2,-10*t)}function v(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}function m(t){return 1-Math.sqrt(1-t*t)}function x(t){return Math.sqrt(1- --t*t)}function b(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}var w=7.5625;function M(t){return 1-T(1-t)}function T(t){return(t=+t)<4/11?w*t*t:t<8/11?w*(t-=6/11)*t+.75:t<10/11?w*(t-=9/11)*t+.9375:w*(t-=21/22)*t+63/64}function O(t){return((t*=2)<=1?1-T(1-t):T(t-1)+1)/2}var A=function t(n){function e(t){return t*t*((n+1)*t-n)}return n=+n,e.overshoot=t,e}(1.70158),C=function t(n){function e(t){return--t*t*((n+1)*t+n)+1}return n=+n,e.overshoot=t,e}(1.70158),S=function t(n){function e(t){return((t*=2)<1?t*t*((n+1)*t-n):(t-=2)*t*((n+1)*t+n)+2)/2}return n=+n,e.overshoot=t,e}(1.70158),k=2*Math.PI,N=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=k);function i(t){return n*Math.pow(2,10*--t)*Math.sin((r-t)/e)}return i.amplitude=function(n){return t(n,e*k)},i.period=function(e){return t(n,e)},i}(1,.3),j=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=k);function i(t){return 1-n*Math.pow(2,-10*(t=+t))*Math.sin((t+r)/e)}return i.amplitude=function(n){return t(n,e*k)},i.period=function(e){return t(n,e)},i}(1,.3),E=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=k);function i(t){return((t=2*t-1)<0?n*Math.pow(2,10*t)*Math.sin((r-t)/e):2-n*Math.pow(2,-10*t)*Math.sin((r+t)/e))/2}return i.amplitude=function(n){return t(n,e*k)},i.period=function(e){return t(n,e)},i}(1,.3);e.d(n,"easeLinear",(function(){return r})),e.d(n,"easeQuad",(function(){return u})),e.d(n,"easeQuadIn",(function(){return i})),e.d(n,"easeQuadOut",(function(){return o})),e.d(n,"easeQuadInOut",(function(){return u})),e.d(n,"easeCubic",(function(){return a.b})),e.d(n,"easeCubicIn",(function(){return a.a})),e.d(n,"easeCubicOut",(function(){return a.c})),e.d(n,"easeCubicInOut",(function(){return a.b})),e.d(n,"easePoly",(function(){return f})),e.d(n,"easePolyIn",(function(){return c})),e.d(n,"easePolyOut",(function(){return s})),e.d(n,"easePolyInOut",(function(){return f})),e.d(n,"easeSin",(function(){return _})),e.d(n,"easeSinIn",(function(){return d})),e.d(n,"easeSinOut",(function(){return p})),e.d(n,"easeSinInOut",(function(){return _})),e.d(n,"easeExp",(function(){return v})),e.d(n,"easeExpIn",(function(){return y})),e.d(n,"easeExpOut",(function(){return g})),e.d(n,"easeExpInOut",(function(){return v})),e.d(n,"easeCircle",(function(){return b})),e.d(n,"easeCircleIn",(function(){return m})),e.d(n,"easeCircleOut",(function(){return x})),e.d(n,"easeCircleInOut",(function(){return b})),e.d(n,"easeBounce",(function(){return T})),e.d(n,"easeBounceIn",(function(){return M})),e.d(n,"easeBounceOut",(function(){return T})),e.d(n,"easeBounceInOut",(function(){return O})),e.d(n,"easeBack",(function(){return S})),e.d(n,"easeBackIn",(function(){return A})),e.d(n,"easeBackOut",(function(){return C})),e.d(n,"easeBackInOut",(function(){return S})),e.d(n,"easeElastic",(function(){return j})),e.d(n,"easeElasticIn",(function(){return N})),e.d(n,"easeElasticOut",(function(){return j})),e.d(n,"easeElasticInOut",(function(){return E}))},function(t,n,e){"use strict";var r;void 0===(r=function(){return{colorSchemas:{britecharts:["#6aedc7","#39c2c9","#ffce00","#ffa71a","#f866b9","#998ce3"],grey:["#F8F8FA","#EFF2F5","#D2D6DF","#C3C6CF","#ADB0B6","#666A73","#45494E","#363A43","#282C35"],orange:["#fcc870","#ffa71a","#fb8825","#f6682f","#db5a2c","#bf4c28","#a43b1c","#892a10","#f9e9c5"],blueGreen:["#ccf7f6","#70e4e0","#00d8d2","#00acaf","#007f8c","#005e66","#003c3f","#002d2f","#0d2223"],teal:["#ccfffe","#94f7f4","#00fff8","#1de1e1","#39c2c9","#2e9a9d","#227270","#1a5957","#133f3e"],green:["#edfff7","#d7ffef","#c0ffe7","#95f5d7","#6aedc7","#59c3a3","#479980","#34816a","#206953"],yellow:["#f9f2b3","#fbe986","#fce05a","#fed72d","#ffce00","#fcc11c","#f9b438","#eda629","#e09819"],pink:["#fdd1ea","#fb9cd2","#f866b9","#fc40b6","#ff1ab3","#e3239d","#c62c86","#a62073","#85135f"],purple:["#ddd6fc","#bbb1f0","#998ce3","#8e6bc1","#824a9e","#77337f","#6b1c60","#591650","#470f3f"],red:["#ffd8d4","#ffb5b0","#ff938c","#ff766c","#ff584c","#f04b42","#e03d38","#be2e29","#9c1e19"]},colorSchemasHuman:{britecharts:"Britecharts Default",grey:"Britecharts Grey",orange:"Orange",blueGreen:"Blue",teal:"Light Blue",green:"Green",yellow:"Yellow",pink:"Pink",purple:"Purple",red:"Red"},colorGradients:{greenBlue:["#39C7EA","#4CDCBA"],orangePink:["#FBC670","#F766B8"],bluePurple:["#3DC3C9","#824a9e"]},colorGradientsHuman:{greenBlue:"Green to Blue",orangePink:"Orange to Pink",bluePurple:"Blue to Purple"},singleColors:{aloeGreen:["#7bdcc0"],greenColor:["#6aedc7"],blueColor:["#39c2c9"],yellowColor:["#ffce00"],orangeColor:["#ffa71a"],pinkColor:["#f866b9"],purpleColor:["#998ce3"]},singleColorsHuman:{aloeGreen:"Aloe Green",greenColor:"Green",blueColor:"Blue",yellowColor:"Yellow",orangeColor:"Orange",pinkColor:"Pink",purpleColor:"Purple"}}}.call(n,e,n,t))||(t.exports=r)},,function(t,n,e){"use strict";e.d(n,"a",(function(){return r})),e.d(n,"b",(function(){return i}));var r=Math.PI/180,i=180/Math.PI},function(t,n,e){"use strict";e.r(n);var r=e(69);e.d(n,"dispatch",(function(){return r.a}))},function(t,n,e){"use strict";var r={value:function(){}};function i(){for(var t,n=0,e=arguments.length,r={};n<e;++n){if(!(t=arguments[n]+"")||t in r||/[\s.]/.test(t))throw new Error("illegal type: "+t);r[t]=[]}return new o(r)}function o(t){this._=t}function u(t,n){return t.trim().split(/^|\s+/).map((function(t){var e="",r=t.indexOf(".");if(r>=0&&(e=t.slice(r+1),t=t.slice(0,r)),t&&!n.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:e}}))}function a(t,n){for(var e,r=0,i=t.length;r<i;++r)if((e=t[r]).name===n)return e.value}function c(t,n,e){for(var i=0,o=t.length;i<o;++i)if(t[i].name===n){t[i]=r,t=t.slice(0,i).concat(t.slice(i+1));break}return null!=e&&t.push({name:n,value:e}),t}o.prototype=i.prototype={constructor:o,on:function(t,n){var e,r=this._,i=u(t+"",r),o=-1,s=i.length;if(!(arguments.length<2)){if(null!=n&&"function"!=typeof n)throw new Error("invalid callback: "+n);for(;++o<s;)if(e=(t=i[o]).type)r[e]=c(r[e],t.name,n);else if(null==n)for(e in r)r[e]=c(r[e],t.name,null);return this}for(;++o<s;)if((e=(t=i[o]).type)&&(e=a(r[e],t.name)))return e},copy:function(){var t={},n=this._;for(var e in n)t[e]=n[e].slice();return new o(t)},call:function(t,n){if((e=arguments.length-2)>0)for(var e,r,i=new Array(e),o=0;o<e;++o)i[o]=arguments[o+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(o=0,e=(r=this._[t]).length;o<e;++o)r[o].value.apply(n,i)},apply:function(t,n,e){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],i=0,o=r.length;i<o;++i)r[i].value.apply(n,e)}},n.a=i},function(t,n,e){"use strict";var r;void 0===(r=function(){var t=e(71),n=e(38);return{axisTimeCombinations:{MINUTE_HOUR:"minute-hour",HOUR_DAY:"hour-daymonth",DAY_MONTH:"day-month",MONTH_YEAR:"month-year",CUSTOM:"custom"},curveMap:{linear:t.curveLinear,basis:t.curveBasis,cardinal:t.curveCardinal,catmullRom:t.curveCatmullRom,monotoneX:t.curveMonotoneX,monotoneY:t.curveMonotoneY,natural:t.curveNatural,step:t.curveStep,stepAfter:t.curveStepAfter,stepBefore:t.curveStepBefore},emptyDonutData:[{quantity:1,percentage:100}],hoursHuman:["00h","01h","02h","03h","04h","05h","06h","07h","08h","09h","10h","11h","12h","13h","14h","15h","16h","17h","18h","19h","20h","21h","22h","23h"],timeBenchmarks:{ONE_AND_A_HALF_YEARS:47304e6,ONE_YEAR:31536000365,ONE_DAY:86400001},lineGradientId:"lineGradientId",timeIntervals:{timeMillisecond:n.timeMillisecond,utcMillisecond:n.utcMillisecond,timeSecond:n.timeSecond,utcSecond:n.utcSecond,timeMinute:n.timeMinute,utcMinute:n.utcMinute,timeHour:n.timeHour,utcHour:n.utcHour,timeDay:n.timeDay,utcDay:n.utcDay,timeWeek:n.timeWeek,utcWeek:n.utcWeek,timeSunday:n.timeSunday,utcSunday:n.utcSunday,timeMonday:n.timeMonday,utcMonday:n.utcMonday,timeTuesday:n.timeTuesday,utcTuesday:n.utcTuesday,timeWednesday:n.timeWednesday,utcWednesday:n.utcWednesday,timeThursday:n.timeThursday,utcThursday:n.utcThursday,timeFriday:n.timeFriday,utcFriday:n.utcFriday,timeSaturday:n.timeSaturday,utcSaturday:n.utcSaturday,timeMonth:n.timeMonth,utcMonth:n.utcMonth,timeYear:n.timeYear,utcYear:n.utcYear},FORMAT_LOCALE_URL:"https://cdn.jsdelivr.net/npm/d3-format/locale"}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";e.r(n);var r=Math.PI,i=2*r,o=i-1e-6;function u(){this._x0=this._y0=this._x1=this._y1=null,this._=""}function a(){return new u}u.prototype=a.prototype={constructor:u,moveTo:function(t,n){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+n)},closePath:function(){null!==this._x1&&(this._x1=this._x0,this._y1=this._y0,this._+="Z")},lineTo:function(t,n){this._+="L"+(this._x1=+t)+","+(this._y1=+n)},quadraticCurveTo:function(t,n,e,r){this._+="Q"+ +t+","+ +n+","+(this._x1=+e)+","+(this._y1=+r)},bezierCurveTo:function(t,n,e,r,i,o){this._+="C"+ +t+","+ +n+","+ +e+","+ +r+","+(this._x1=+i)+","+(this._y1=+o)},arcTo:function(t,n,e,i,o){t=+t,n=+n,e=+e,i=+i,o=+o;var u=this._x1,a=this._y1,c=e-t,s=i-n,f=u-t,l=a-n,h=f*f+l*l;if(o<0)throw new Error("negative radius: "+o);if(null===this._x1)this._+="M"+(this._x1=t)+","+(this._y1=n);else if(h>1e-6)if(Math.abs(l*c-s*f)>1e-6&&o){var d=e-u,p=i-a,_=c*c+s*s,y=d*d+p*p,g=Math.sqrt(_),v=Math.sqrt(h),m=o*Math.tan((r-Math.acos((_+h-y)/(2*g*v)))/2),x=m/v,b=m/g;Math.abs(x-1)>1e-6&&(this._+="L"+(t+x*f)+","+(n+x*l)),this._+="A"+o+","+o+",0,0,"+ +(l*d>f*p)+","+(this._x1=t+b*c)+","+(this._y1=n+b*s)}else this._+="L"+(this._x1=t)+","+(this._y1=n);else;},arc:function(t,n,e,u,a,c){t=+t,n=+n,c=!!c;var s=(e=+e)*Math.cos(u),f=e*Math.sin(u),l=t+s,h=n+f,d=1^c,p=c?u-a:a-u;if(e<0)throw new Error("negative radius: "+e);null===this._x1?this._+="M"+l+","+h:(Math.abs(this._x1-l)>1e-6||Math.abs(this._y1-h)>1e-6)&&(this._+="L"+l+","+h),e&&(p<0&&(p=p%i+i),p>o?this._+="A"+e+","+e+",0,1,"+d+","+(t-s)+","+(n-f)+"A"+e+","+e+",0,1,"+d+","+(this._x1=l)+","+(this._y1=h):p>1e-6&&(this._+="A"+e+","+e+",0,"+ +(p>=r)+","+d+","+(this._x1=t+e*Math.cos(a))+","+(this._y1=n+e*Math.sin(a))))},rect:function(t,n,e,r){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+n)+"h"+ +e+"v"+ +r+"h"+-e+"Z"},toString:function(){return this._}};var c=a,s=function(t){return function(){return t}},f=Math.abs,l=Math.atan2,h=Math.cos,d=Math.max,p=Math.min,_=Math.sin,y=Math.sqrt,g=Math.PI,v=g/2,m=2*g;function x(t){return t>1?0:t<-1?g:Math.acos(t)}function b(t){return t>=1?v:t<=-1?-v:Math.asin(t)}function w(t){return t.innerRadius}function M(t){return t.outerRadius}function T(t){return t.startAngle}function O(t){return t.endAngle}function A(t){return t&&t.padAngle}function C(t,n,e,r,i,o,u,a){var c=e-t,s=r-n,f=u-i,l=a-o,h=l*c-f*s;if(!(h*h<1e-12))return[t+(h=(f*(n-o)-l*(t-i))/h)*c,n+h*s]}function S(t,n,e,r,i,o,u){var a=t-e,c=n-r,s=(u?o:-o)/y(a*a+c*c),f=s*c,l=-s*a,h=t+f,p=n+l,_=e+f,g=r+l,v=(h+_)/2,m=(p+g)/2,x=_-h,b=g-p,w=x*x+b*b,M=i-o,T=h*g-_*p,O=(b<0?-1:1)*y(d(0,M*M*w-T*T)),A=(T*b-x*O)/w,C=(-T*x-b*O)/w,S=(T*b+x*O)/w,k=(-T*x+b*O)/w,N=A-v,j=C-m,E=S-v,D=k-m;return N*N+j*j>E*E+D*D&&(A=S,C=k),{cx:A,cy:C,x01:-f,y01:-l,x11:A*(i/M-1),y11:C*(i/M-1)}}var k=function(){var t=w,n=M,e=s(0),r=null,i=T,o=O,u=A,a=null;function d(){var s,d,w=+t.apply(this,arguments),M=+n.apply(this,arguments),T=i.apply(this,arguments)-v,O=o.apply(this,arguments)-v,A=f(O-T),k=O>T;if(a||(a=s=c()),M<w&&(d=M,M=w,w=d),M>1e-12)if(A>m-1e-12)a.moveTo(M*h(T),M*_(T)),a.arc(0,0,M,T,O,!k),w>1e-12&&(a.moveTo(w*h(O),w*_(O)),a.arc(0,0,w,O,T,k));else{var N,j,E=T,D=O,F=T,P=O,L=A,I=A,U=u.apply(this,arguments)/2,R=U>1e-12&&(r?+r.apply(this,arguments):y(w*w+M*M)),q=p(f(M-w)/2,+e.apply(this,arguments)),H=q,B=q;if(R>1e-12){var Y=b(R/w*_(U)),z=b(R/M*_(U));(L-=2*Y)>1e-12?(F+=Y*=k?1:-1,P-=Y):(L=0,F=P=(T+O)/2),(I-=2*z)>1e-12?(E+=z*=k?1:-1,D-=z):(I=0,E=D=(T+O)/2)}var G=M*h(E),X=M*_(E),V=w*h(P),W=w*_(P);if(q>1e-12){var $,Z=M*h(D),Q=M*_(D),J=w*h(F),K=w*_(F);if(A<g&&($=C(G,X,J,K,Z,Q,V,W))){var tt=G-$[0],nt=X-$[1],et=Z-$[0],rt=Q-$[1],it=1/_(x((tt*et+nt*rt)/(y(tt*tt+nt*nt)*y(et*et+rt*rt)))/2),ot=y($[0]*$[0]+$[1]*$[1]);H=p(q,(w-ot)/(it-1)),B=p(q,(M-ot)/(it+1))}}I>1e-12?B>1e-12?(N=S(J,K,G,X,M,B,k),j=S(Z,Q,V,W,M,B,k),a.moveTo(N.cx+N.x01,N.cy+N.y01),B<q?a.arc(N.cx,N.cy,B,l(N.y01,N.x01),l(j.y01,j.x01),!k):(a.arc(N.cx,N.cy,B,l(N.y01,N.x01),l(N.y11,N.x11),!k),a.arc(0,0,M,l(N.cy+N.y11,N.cx+N.x11),l(j.cy+j.y11,j.cx+j.x11),!k),a.arc(j.cx,j.cy,B,l(j.y11,j.x11),l(j.y01,j.x01),!k))):(a.moveTo(G,X),a.arc(0,0,M,E,D,!k)):a.moveTo(G,X),w>1e-12&&L>1e-12?H>1e-12?(N=S(V,W,Z,Q,w,-H,k),j=S(G,X,J,K,w,-H,k),a.lineTo(N.cx+N.x01,N.cy+N.y01),H<q?a.arc(N.cx,N.cy,H,l(N.y01,N.x01),l(j.y01,j.x01),!k):(a.arc(N.cx,N.cy,H,l(N.y01,N.x01),l(N.y11,N.x11),!k),a.arc(0,0,w,l(N.cy+N.y11,N.cx+N.x11),l(j.cy+j.y11,j.cx+j.x11),k),a.arc(j.cx,j.cy,H,l(j.y11,j.x11),l(j.y01,j.x01),!k))):a.arc(0,0,w,P,F,k):a.lineTo(V,W)}else a.moveTo(0,0);if(a.closePath(),s)return a=null,s+""||null}return d.centroid=function(){var e=(+t.apply(this,arguments)+ +n.apply(this,arguments))/2,r=(+i.apply(this,arguments)+ +o.apply(this,arguments))/2-g/2;return[h(r)*e,_(r)*e]},d.innerRadius=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),d):t},d.outerRadius=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),d):n},d.cornerRadius=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),d):e},d.padRadius=function(t){return arguments.length?(r=null==t?null:"function"==typeof t?t:s(+t),d):r},d.startAngle=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),d):i},d.endAngle=function(t){return arguments.length?(o="function"==typeof t?t:s(+t),d):o},d.padAngle=function(t){return arguments.length?(u="function"==typeof t?t:s(+t),d):u},d.context=function(t){return arguments.length?(a=null==t?null:t,d):a},d};function N(t){this._context=t}N.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._point=0},lineEnd:function(){(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;default:this._context.lineTo(t,n)}}};var j=function(t){return new N(t)};function E(t){return t[0]}function D(t){return t[1]}var F=function(){var t=E,n=D,e=s(!0),r=null,i=j,o=null;function u(u){var a,s,f,l=u.length,h=!1;for(null==r&&(o=i(f=c())),a=0;a<=l;++a)!(a<l&&e(s=u[a],a,u))===h&&((h=!h)?o.lineStart():o.lineEnd()),h&&o.point(+t(s,a,u),+n(s,a,u));if(f)return o=null,f+""||null}return u.x=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),u):t},u.y=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),u):n},u.defined=function(t){return arguments.length?(e="function"==typeof t?t:s(!!t),u):e},u.curve=function(t){return arguments.length?(i=t,null!=r&&(o=i(r)),u):i},u.context=function(t){return arguments.length?(null==t?r=o=null:o=i(r=t),u):r},u},P=function(){var t=E,n=null,e=s(0),r=D,i=s(!0),o=null,u=j,a=null;function f(s){var f,l,h,d,p,_=s.length,y=!1,g=new Array(_),v=new Array(_);for(null==o&&(a=u(p=c())),f=0;f<=_;++f){if(!(f<_&&i(d=s[f],f,s))===y)if(y=!y)l=f,a.areaStart(),a.lineStart();else{for(a.lineEnd(),a.lineStart(),h=f-1;h>=l;--h)a.point(g[h],v[h]);a.lineEnd(),a.areaEnd()}y&&(g[f]=+t(d,f,s),v[f]=+e(d,f,s),a.point(n?+n(d,f,s):g[f],r?+r(d,f,s):v[f]))}if(p)return a=null,p+""||null}function l(){return F().defined(i).curve(u).context(o)}return f.x=function(e){return arguments.length?(t="function"==typeof e?e:s(+e),n=null,f):t},f.x0=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),f):t},f.x1=function(t){return arguments.length?(n=null==t?null:"function"==typeof t?t:s(+t),f):n},f.y=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),r=null,f):e},f.y0=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),f):e},f.y1=function(t){return arguments.length?(r=null==t?null:"function"==typeof t?t:s(+t),f):r},f.lineX0=f.lineY0=function(){return l().x(t).y(e)},f.lineY1=function(){return l().x(t).y(r)},f.lineX1=function(){return l().x(n).y(e)},f.defined=function(t){return arguments.length?(i="function"==typeof t?t:s(!!t),f):i},f.curve=function(t){return arguments.length?(u=t,null!=o&&(a=u(o)),f):u},f.context=function(t){return arguments.length?(null==t?o=a=null:a=u(o=t),f):o},f},L=function(t,n){return n<t?-1:n>t?1:n>=t?0:NaN},I=function(t){return t},U=function(){var t=I,n=L,e=null,r=s(0),i=s(m),o=s(0);function u(u){var a,c,s,f,l,h=u.length,d=0,p=new Array(h),_=new Array(h),y=+r.apply(this,arguments),g=Math.min(m,Math.max(-m,i.apply(this,arguments)-y)),v=Math.min(Math.abs(g)/h,o.apply(this,arguments)),x=v*(g<0?-1:1);for(a=0;a<h;++a)(l=_[p[a]=a]=+t(u[a],a,u))>0&&(d+=l);for(null!=n?p.sort((function(t,e){return n(_[t],_[e])})):null!=e&&p.sort((function(t,n){return e(u[t],u[n])})),a=0,s=d?(g-h*x)/d:0;a<h;++a,y=f)c=p[a],f=y+((l=_[c])>0?l*s:0)+x,_[c]={data:u[c],index:a,value:l,startAngle:y,endAngle:f,padAngle:v};return _}return u.value=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),u):t},u.sortValues=function(t){return arguments.length?(n=t,e=null,u):n},u.sort=function(t){return arguments.length?(e=t,n=null,u):e},u.startAngle=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),u):r},u.endAngle=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),u):i},u.padAngle=function(t){return arguments.length?(o="function"==typeof t?t:s(+t),u):o},u},R=H(j);function q(t){this._curve=t}function H(t){function n(n){return new q(t(n))}return n._curve=t,n}function B(t){var n=t.curve;return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t.curve=function(t){return arguments.length?n(H(t)):n()._curve},t}q.prototype={areaStart:function(){this._curve.areaStart()},areaEnd:function(){this._curve.areaEnd()},lineStart:function(){this._curve.lineStart()},lineEnd:function(){this._curve.lineEnd()},point:function(t,n){this._curve.point(n*Math.sin(t),n*-Math.cos(t))}};var Y=function(){return B(F().curve(R))},z=function(){var t=P().curve(R),n=t.curve,e=t.lineX0,r=t.lineX1,i=t.lineY0,o=t.lineY1;return t.angle=t.x,delete t.x,t.startAngle=t.x0,delete t.x0,t.endAngle=t.x1,delete t.x1,t.radius=t.y,delete t.y,t.innerRadius=t.y0,delete t.y0,t.outerRadius=t.y1,delete t.y1,t.lineStartAngle=function(){return B(e())},delete t.lineX0,t.lineEndAngle=function(){return B(r())},delete t.lineX1,t.lineInnerRadius=function(){return B(i())},delete t.lineY0,t.lineOuterRadius=function(){return B(o())},delete t.lineY1,t.curve=function(t){return arguments.length?n(H(t)):n()._curve},t},G=function(t,n){return[(n=+n)*Math.cos(t-=Math.PI/2),n*Math.sin(t)]},X=Array.prototype.slice;function V(t){return t.source}function W(t){return t.target}function $(t){var n=V,e=W,r=E,i=D,o=null;function u(){var u,a=X.call(arguments),s=n.apply(this,a),f=e.apply(this,a);if(o||(o=u=c()),t(o,+r.apply(this,(a[0]=s,a)),+i.apply(this,a),+r.apply(this,(a[0]=f,a)),+i.apply(this,a)),u)return o=null,u+""||null}return u.source=function(t){return arguments.length?(n=t,u):n},u.target=function(t){return arguments.length?(e=t,u):e},u.x=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),u):r},u.y=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),u):i},u.context=function(t){return arguments.length?(o=null==t?null:t,u):o},u}function Z(t,n,e,r,i){t.moveTo(n,e),t.bezierCurveTo(n=(n+r)/2,e,n,i,r,i)}function Q(t,n,e,r,i){t.moveTo(n,e),t.bezierCurveTo(n,e=(e+i)/2,r,e,r,i)}function J(t,n,e,r,i){var o=G(n,e),u=G(n,e=(e+i)/2),a=G(r,e),c=G(r,i);t.moveTo(o[0],o[1]),t.bezierCurveTo(u[0],u[1],a[0],a[1],c[0],c[1])}function K(){return $(Z)}function tt(){return $(Q)}function nt(){var t=$(J);return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t}var et={draw:function(t,n){var e=Math.sqrt(n/g);t.moveTo(e,0),t.arc(0,0,e,0,m)}},rt={draw:function(t,n){var e=Math.sqrt(n/5)/2;t.moveTo(-3*e,-e),t.lineTo(-e,-e),t.lineTo(-e,-3*e),t.lineTo(e,-3*e),t.lineTo(e,-e),t.lineTo(3*e,-e),t.lineTo(3*e,e),t.lineTo(e,e),t.lineTo(e,3*e),t.lineTo(-e,3*e),t.lineTo(-e,e),t.lineTo(-3*e,e),t.closePath()}},it=Math.sqrt(1/3),ot=2*it,ut={draw:function(t,n){var e=Math.sqrt(n/ot),r=e*it;t.moveTo(0,-e),t.lineTo(r,0),t.lineTo(0,e),t.lineTo(-r,0),t.closePath()}},at=Math.sin(g/10)/Math.sin(7*g/10),ct=Math.sin(m/10)*at,st=-Math.cos(m/10)*at,ft={draw:function(t,n){var e=Math.sqrt(.8908130915292852*n),r=ct*e,i=st*e;t.moveTo(0,-e),t.lineTo(r,i);for(var o=1;o<5;++o){var u=m*o/5,a=Math.cos(u),c=Math.sin(u);t.lineTo(c*e,-a*e),t.lineTo(a*r-c*i,c*r+a*i)}t.closePath()}},lt={draw:function(t,n){var e=Math.sqrt(n),r=-e/2;t.rect(r,r,e,e)}},ht=Math.sqrt(3),dt={draw:function(t,n){var e=-Math.sqrt(n/(3*ht));t.moveTo(0,2*e),t.lineTo(-ht*e,-e),t.lineTo(ht*e,-e),t.closePath()}},pt=Math.sqrt(3)/2,_t=1/Math.sqrt(12),yt=3*(_t/2+1),gt={draw:function(t,n){var e=Math.sqrt(n/yt),r=e/2,i=e*_t,o=r,u=e*_t+e,a=-o,c=u;t.moveTo(r,i),t.lineTo(o,u),t.lineTo(a,c),t.lineTo(-.5*r-pt*i,pt*r+-.5*i),t.lineTo(-.5*o-pt*u,pt*o+-.5*u),t.lineTo(-.5*a-pt*c,pt*a+-.5*c),t.lineTo(-.5*r+pt*i,-.5*i-pt*r),t.lineTo(-.5*o+pt*u,-.5*u-pt*o),t.lineTo(-.5*a+pt*c,-.5*c-pt*a),t.closePath()}},vt=[et,rt,ut,lt,ft,dt,gt],mt=function(){var t=s(et),n=s(64),e=null;function r(){var r;if(e||(e=r=c()),t.apply(this,arguments).draw(e,+n.apply(this,arguments)),r)return e=null,r+""||null}return r.type=function(n){return arguments.length?(t="function"==typeof n?n:s(n),r):t},r.size=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),r):n},r.context=function(t){return arguments.length?(e=null==t?null:t,r):e},r},xt=function(){};function bt(t,n,e){t._context.bezierCurveTo((2*t._x0+t._x1)/3,(2*t._y0+t._y1)/3,(t._x0+2*t._x1)/3,(t._y0+2*t._y1)/3,(t._x0+4*t._x1+n)/6,(t._y0+4*t._y1+e)/6)}function wt(t){this._context=t}wt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){switch(this._point){case 3:bt(this,this._x1,this._y1);case 2:this._context.lineTo(this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3,this._context.lineTo((5*this._x0+this._x1)/6,(5*this._y0+this._y1)/6);default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var Mt=function(t){return new wt(t)};function Tt(t){this._context=t}Tt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._y0=this._y1=this._y2=this._y3=this._y4=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x2,this._y2),this._context.closePath();break;case 2:this._context.moveTo((this._x2+2*this._x3)/3,(this._y2+2*this._y3)/3),this._context.lineTo((this._x3+2*this._x2)/3,(this._y3+2*this._y2)/3),this._context.closePath();break;case 3:this.point(this._x2,this._y2),this.point(this._x3,this._y3),this.point(this._x4,this._y4)}},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._x2=t,this._y2=n;break;case 1:this._point=2,this._x3=t,this._y3=n;break;case 2:this._point=3,this._x4=t,this._y4=n,this._context.moveTo((this._x0+4*this._x1+t)/6,(this._y0+4*this._y1+n)/6);break;default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var Ot=function(t){return new Tt(t)};function At(t){this._context=t}At.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3;var e=(this._x0+4*this._x1+t)/6,r=(this._y0+4*this._y1+n)/6;this._line?this._context.lineTo(e,r):this._context.moveTo(e,r);break;case 3:this._point=4;default:bt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var Ct=function(t){return new At(t)};function St(t,n){this._basis=new wt(t),this._beta=n}St.prototype={lineStart:function(){this._x=[],this._y=[],this._basis.lineStart()},lineEnd:function(){var t=this._x,n=this._y,e=t.length-1;if(e>0)for(var r,i=t[0],o=n[0],u=t[e]-i,a=n[e]-o,c=-1;++c<=e;)r=c/e,this._basis.point(this._beta*t[c]+(1-this._beta)*(i+r*u),this._beta*n[c]+(1-this._beta)*(o+r*a));this._x=this._y=null,this._basis.lineEnd()},point:function(t,n){this._x.push(+t),this._y.push(+n)}};var kt=function t(n){function e(t){return 1===n?new wt(t):new St(t,n)}return e.beta=function(n){return t(+n)},e}(.85);function Nt(t,n,e){t._context.bezierCurveTo(t._x1+t._k*(t._x2-t._x0),t._y1+t._k*(t._y2-t._y0),t._x2+t._k*(t._x1-n),t._y2+t._k*(t._y1-e),t._x2,t._y2)}function jt(t,n){this._context=t,this._k=(1-n)/6}jt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:Nt(this,this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2,this._x1=t,this._y1=n;break;case 2:this._point=3;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Et=function t(n){function e(t){return new jt(t,n)}return e.tension=function(n){return t(+n)},e}(0);function Dt(t,n){this._context=t,this._k=(1-n)/6}Dt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._x3=t,this._y3=n;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=n);break;case 2:this._point=3,this._x5=t,this._y5=n;break;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Ft=function t(n){function e(t){return new Dt(t,n)}return e.tension=function(n){return t(+n)},e}(0);function Pt(t,n){this._context=t,this._k=(1-n)/6}Pt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Lt=function t(n){function e(t){return new Pt(t,n)}return e.tension=function(n){return t(+n)},e}(0);function It(t,n,e){var r=t._x1,i=t._y1,o=t._x2,u=t._y2;if(t._l01_a>1e-12){var a=2*t._l01_2a+3*t._l01_a*t._l12_a+t._l12_2a,c=3*t._l01_a*(t._l01_a+t._l12_a);r=(r*a-t._x0*t._l12_2a+t._x2*t._l01_2a)/c,i=(i*a-t._y0*t._l12_2a+t._y2*t._l01_2a)/c}if(t._l23_a>1e-12){var s=2*t._l23_2a+3*t._l23_a*t._l12_a+t._l12_2a,f=3*t._l23_a*(t._l23_a+t._l12_a);o=(o*s+t._x1*t._l23_2a-n*t._l12_2a)/f,u=(u*s+t._y1*t._l23_2a-e*t._l12_2a)/f}t._context.bezierCurveTo(r,i,o,u,t._x2,t._y2)}function Ut(t,n){this._context=t,this._alpha=n}Ut.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:this.point(this._x2,this._y2)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Rt=function t(n){function e(t){return n?new Ut(t,n):new jt(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function qt(t,n){this._context=t,this._alpha=n}qt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._x3=t,this._y3=n;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=n);break;case 2:this._point=3,this._x5=t,this._y5=n;break;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Ht=function t(n){function e(t){return n?new qt(t,n):new Dt(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function Bt(t,n){this._context=t,this._alpha=n}Bt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Yt=function t(n){function e(t){return n?new Bt(t,n):new Pt(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function zt(t){this._context=t}zt.prototype={areaStart:xt,areaEnd:xt,lineStart:function(){this._point=0},lineEnd:function(){this._point&&this._context.closePath()},point:function(t,n){t=+t,n=+n,this._point?this._context.lineTo(t,n):(this._point=1,this._context.moveTo(t,n))}};var Gt=function(t){return new zt(t)};function Xt(t){return t<0?-1:1}function Vt(t,n,e){var r=t._x1-t._x0,i=n-t._x1,o=(t._y1-t._y0)/(r||i<0&&-0),u=(e-t._y1)/(i||r<0&&-0),a=(o*i+u*r)/(r+i);return(Xt(o)+Xt(u))*Math.min(Math.abs(o),Math.abs(u),.5*Math.abs(a))||0}function Wt(t,n){var e=t._x1-t._x0;return e?(3*(t._y1-t._y0)/e-n)/2:n}function $t(t,n,e){var r=t._x0,i=t._y0,o=t._x1,u=t._y1,a=(o-r)/3;t._context.bezierCurveTo(r+a,i+a*n,o-a,u-a*e,o,u)}function Zt(t){this._context=t}function Qt(t){this._context=new Jt(t)}function Jt(t){this._context=t}function Kt(t){return new Zt(t)}function tn(t){return new Qt(t)}function nn(t){this._context=t}function en(t){var n,e,r=t.length-1,i=new Array(r),o=new Array(r),u=new Array(r);for(i[0]=0,o[0]=2,u[0]=t[0]+2*t[1],n=1;n<r-1;++n)i[n]=1,o[n]=4,u[n]=4*t[n]+2*t[n+1];for(i[r-1]=2,o[r-1]=7,u[r-1]=8*t[r-1]+t[r],n=1;n<r;++n)e=i[n]/o[n-1],o[n]-=e,u[n]-=e*u[n-1];for(i[r-1]=u[r-1]/o[r-1],n=r-2;n>=0;--n)i[n]=(u[n]-i[n+1])/o[n];for(o[r-1]=(t[r]+i[r-1])/2,n=0;n<r-1;++n)o[n]=2*t[n+1]-i[n+1];return[i,o]}Zt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=this._t0=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x1,this._y1);break;case 3:$t(this,this._t0,Wt(this,this._t0))}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){var e=NaN;if(n=+n,(t=+t)!==this._x1||n!==this._y1){switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3,$t(this,Wt(this,e=Vt(this,t,n)),e);break;default:$t(this,this._t0,e=Vt(this,t,n))}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n,this._t0=e}}},(Qt.prototype=Object.create(Zt.prototype)).point=function(t,n){Zt.prototype.point.call(this,n,t)},Jt.prototype={moveTo:function(t,n){this._context.moveTo(n,t)},closePath:function(){this._context.closePath()},lineTo:function(t,n){this._context.lineTo(n,t)},bezierCurveTo:function(t,n,e,r,i,o){this._context.bezierCurveTo(n,t,r,e,o,i)}},nn.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=[],this._y=[]},lineEnd:function(){var t=this._x,n=this._y,e=t.length;if(e)if(this._line?this._context.lineTo(t[0],n[0]):this._context.moveTo(t[0],n[0]),2===e)this._context.lineTo(t[1],n[1]);else for(var r=en(t),i=en(n),o=0,u=1;u<e;++o,++u)this._context.bezierCurveTo(r[0][o],i[0][o],r[1][o],i[1][o],t[u],n[u]);(this._line||0!==this._line&&1===e)&&this._context.closePath(),this._line=1-this._line,this._x=this._y=null},point:function(t,n){this._x.push(+t),this._y.push(+n)}};var rn=function(t){return new nn(t)};function on(t,n){this._context=t,this._t=n}on.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=this._y=NaN,this._point=0},lineEnd:function(){0<this._t&&this._t<1&&2===this._point&&this._context.lineTo(this._x,this._y),(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line>=0&&(this._t=1-this._t,this._line=1-this._line)},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;default:if(this._t<=0)this._context.lineTo(this._x,n),this._context.lineTo(t,n);else{var e=this._x*(1-this._t)+t*this._t;this._context.lineTo(e,this._y),this._context.lineTo(e,n)}}this._x=t,this._y=n}};var un=function(t){return new on(t,.5)};function an(t){return new on(t,0)}function cn(t){return new on(t,1)}var sn=function(t,n){if((i=t.length)>1)for(var e,r,i,o=1,u=t[n[0]],a=u.length;o<i;++o)for(r=u,u=t[n[o]],e=0;e<a;++e)u[e][1]+=u[e][0]=isNaN(r[e][1])?r[e][0]:r[e][1]},fn=function(t){for(var n=t.length,e=new Array(n);--n>=0;)e[n]=n;return e};function ln(t,n){return t[n]}var hn=function(){var t=s([]),n=fn,e=sn,r=ln;function i(i){var o,u,a=t.apply(this,arguments),c=i.length,s=a.length,f=new Array(s);for(o=0;o<s;++o){for(var l,h=a[o],d=f[o]=new Array(c),p=0;p<c;++p)d[p]=l=[0,+r(i[p],h,p,i)],l.data=i[p];d.key=h}for(o=0,u=n(f);o<s;++o)f[u[o]].index=o;return e(f,u),f}return i.keys=function(n){return arguments.length?(t="function"==typeof n?n:s(X.call(n)),i):t},i.value=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),i):r},i.order=function(t){return arguments.length?(n=null==t?fn:"function"==typeof t?t:s(X.call(t)),i):n},i.offset=function(t){return arguments.length?(e=null==t?sn:t,i):e},i},dn=function(t,n){if((r=t.length)>0){for(var e,r,i,o=0,u=t[0].length;o<u;++o){for(i=e=0;e<r;++e)i+=t[e][o][1]||0;if(i)for(e=0;e<r;++e)t[e][o][1]/=i}sn(t,n)}},pn=function(t,n){if((a=t.length)>0)for(var e,r,i,o,u,a,c=0,s=t[n[0]].length;c<s;++c)for(o=u=0,e=0;e<a;++e)(i=(r=t[n[e]][c])[1]-r[0])>0?(r[0]=o,r[1]=o+=i):i<0?(r[1]=u,r[0]=u+=i):(r[0]=0,r[1]=i)},_n=function(t,n){if((e=t.length)>0){for(var e,r=0,i=t[n[0]],o=i.length;r<o;++r){for(var u=0,a=0;u<e;++u)a+=t[u][r][1]||0;i[r][1]+=i[r][0]=-a/2}sn(t,n)}},yn=function(t,n){if((i=t.length)>0&&(r=(e=t[n[0]]).length)>0){for(var e,r,i,o=0,u=1;u<r;++u){for(var a=0,c=0,s=0;a<i;++a){for(var f=t[n[a]],l=f[u][1]||0,h=(l-(f[u-1][1]||0))/2,d=0;d<a;++d){var p=t[n[d]];h+=(p[u][1]||0)-(p[u-1][1]||0)}c+=l,s+=h*l}e[u-1][1]+=e[u-1][0]=o,c&&(o-=s/c)}e[u-1][1]+=e[u-1][0]=o,sn(t,n)}},gn=function(t){var n=t.map(vn);return fn(t).sort((function(t,e){return n[t]-n[e]}))};function vn(t){for(var n,e=-1,r=0,i=t.length,o=-1/0;++e<i;)(n=+t[e][1])>o&&(o=n,r=e);return r}var mn=function(t){var n=t.map(xn);return fn(t).sort((function(t,e){return n[t]-n[e]}))};function xn(t){for(var n,e=0,r=-1,i=t.length;++r<i;)(n=+t[r][1])&&(e+=n);return e}var bn=function(t){return mn(t).reverse()},wn=function(t){var n,e,r=t.length,i=t.map(xn),o=gn(t),u=0,a=0,c=[],s=[];for(n=0;n<r;++n)e=o[n],u<a?(u+=i[e],c.push(e)):(a+=i[e],s.push(e));return s.reverse().concat(c)},Mn=function(t){return fn(t).reverse()};e.d(n,"arc",(function(){return k})),e.d(n,"area",(function(){return P})),e.d(n,"line",(function(){return F})),e.d(n,"pie",(function(){return U})),e.d(n,"areaRadial",(function(){return z})),e.d(n,"radialArea",(function(){return z})),e.d(n,"lineRadial",(function(){return Y})),e.d(n,"radialLine",(function(){return Y})),e.d(n,"pointRadial",(function(){return G})),e.d(n,"linkHorizontal",(function(){return K})),e.d(n,"linkVertical",(function(){return tt})),e.d(n,"linkRadial",(function(){return nt})),e.d(n,"symbol",(function(){return mt})),e.d(n,"symbols",(function(){return vt})),e.d(n,"symbolCircle",(function(){return et})),e.d(n,"symbolCross",(function(){return rt})),e.d(n,"symbolDiamond",(function(){return ut})),e.d(n,"symbolSquare",(function(){return lt})),e.d(n,"symbolStar",(function(){return ft})),e.d(n,"symbolTriangle",(function(){return dt})),e.d(n,"symbolWye",(function(){return gt})),e.d(n,"curveBasisClosed",(function(){return Ot})),e.d(n,"curveBasisOpen",(function(){return Ct})),e.d(n,"curveBasis",(function(){return Mt})),e.d(n,"curveBundle",(function(){return kt})),e.d(n,"curveCardinalClosed",(function(){return Ft})),e.d(n,"curveCardinalOpen",(function(){return Lt})),e.d(n,"curveCardinal",(function(){return Et})),e.d(n,"curveCatmullRomClosed",(function(){return Ht})),e.d(n,"curveCatmullRomOpen",(function(){return Yt})),e.d(n,"curveCatmullRom",(function(){return Rt})),e.d(n,"curveLinearClosed",(function(){return Gt})),e.d(n,"curveLinear",(function(){return j})),e.d(n,"curveMonotoneX",(function(){return Kt})),e.d(n,"curveMonotoneY",(function(){return tn})),e.d(n,"curveNatural",(function(){return rn})),e.d(n,"curveStep",(function(){return un})),e.d(n,"curveStepAfter",(function(){return cn})),e.d(n,"curveStepBefore",(function(){return an})),e.d(n,"stack",(function(){return hn})),e.d(n,"stackOffsetExpand",(function(){return dn})),e.d(n,"stackOffsetDiverging",(function(){return pn})),e.d(n,"stackOffsetNone",(function(){return sn})),e.d(n,"stackOffsetSilhouette",(function(){return _n})),e.d(n,"stackOffsetWiggle",(function(){return yn})),e.d(n,"stackOrderAppearance",(function(){return gn})),e.d(n,"stackOrderAscending",(function(){return mn})),e.d(n,"stackOrderDescending",(function(){return bn})),e.d(n,"stackOrderInsideOut",(function(){return wn})),e.d(n,"stackOrderNone",(function(){return fn})),e.d(n,"stackOrderReverse",(function(){return Mn}))},function(t,n,e){"use strict";e.r(n);var r,i,o=e(9),u=e(69),a=0,c=0,s=0,f=0,l=0,h=0,d="object"==typeof performance&&performance.now?performance:Date,p="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};function _(){return l||(p(y),l=d.now()+h)}function y(){l=0}function g(){this._call=this._time=this._next=null}function v(t,n,e){var r=new g;return r.restart(t,n,e),r}function m(){l=(f=d.now())+h,a=c=0;try{!function(){_(),++a;for(var t,n=r;n;)(t=l-n._time)>=0&&n._call.call(null,t),n=n._next;--a}()}finally{a=0,function(){var t,n,e=r,o=1/0;for(;e;)e._call?(o>e._time&&(o=e._time),t=e,e=e._next):(n=e._next,e._next=null,e=t?t._next=n:r=n);i=t,b(o)}(),l=0}}function x(){var t=d.now(),n=t-f;n>1e3&&(h-=n,f=t)}function b(t){a||(c&&(c=clearTimeout(c)),t-l>24?(t<1/0&&(c=setTimeout(m,t-d.now()-h)),s&&(s=clearInterval(s))):(s||(f=d.now(),s=setInterval(x,1e3)),a=1,p(m)))}g.prototype=v.prototype={constructor:g,restart:function(t,n,e){if("function"!=typeof t)throw new TypeError("callback is not a function");e=(null==e?_():+e)+(null==n?0:+n),this._next||i===this||(i?i._next=this:r=this,i=this),this._call=t,this._time=e,b()},stop:function(){this._call&&(this._call=null,this._time=1/0,b())}};var w=function(t,n,e){var r=new g;return n=null==n?0:+n,r.restart((function(e){r.stop(),t(e+n)}),n,e),r},M=Object(u.a)("start","end","cancel","interrupt"),T=[],O=function(t,n,e,r,i,o){var u=t.__transition;if(u){if(e in u)return}else t.__transition={};!function(t,n,e){var r,i=t.__transition;function o(c){var s,f,l,h;if(1!==e.state)return a();for(s in i)if((h=i[s]).name===e.name){if(3===h.state)return w(o);4===h.state?(h.state=6,h.timer.stop(),h.on.call("interrupt",t,t.__data__,h.index,h.group),delete i[s]):+s<n&&(h.state=6,h.timer.stop(),h.on.call("cancel",t,t.__data__,h.index,h.group),delete i[s])}if(w((function(){3===e.state&&(e.state=4,e.timer.restart(u,e.delay,e.time),u(c))})),e.state=2,e.on.call("start",t,t.__data__,e.index,e.group),2===e.state){for(e.state=3,r=new Array(l=e.tween.length),s=0,f=-1;s<l;++s)(h=e.tween[s].value.call(t,t.__data__,e.index,e.group))&&(r[++f]=h);r.length=f+1}}function u(n){for(var i=n<e.duration?e.ease.call(null,n/e.duration):(e.timer.restart(a),e.state=5,1),o=-1,u=r.length;++o<u;)r[o].call(t,i);5===e.state&&(e.on.call("end",t,t.__data__,e.index,e.group),a())}function a(){for(var r in e.state=6,e.timer.stop(),delete i[n],i)return;delete t.__transition}i[n]=e,e.timer=v((function(t){e.state=1,e.timer.restart(o,e.delay,e.time),e.delay<=t&&o(t-e.delay)}),0,e.time)}(t,e,{name:n,index:r,group:i,on:M,tween:T,time:o.time,delay:o.delay,duration:o.duration,ease:o.ease,timer:null,state:0})};function A(t,n){var e=S(t,n);if(e.state>0)throw new Error("too late; already scheduled");return e}function C(t,n){var e=S(t,n);if(e.state>3)throw new Error("too late; already running");return e}function S(t,n){var e=t.__transition;if(!e||!(e=e[n]))throw new Error("transition not found");return e}var k=function(t,n){var e,r,i,o=t.__transition,u=!0;if(o){for(i in n=null==n?null:n+"",o)(e=o[i]).name===n?(r=e.state>2&&e.state<5,e.state=6,e.timer.stop(),e.on.call(r?"interrupt":"cancel",t,t.__data__,e.index,e.group),delete o[i]):u=!1;u&&delete t.__transition}},N=e(74),j=e(20);function E(t,n){var e,r;return function(){var i=C(this,t),o=i.tween;if(o!==e)for(var u=0,a=(r=e=o).length;u<a;++u)if(r[u].name===n){(r=r.slice()).splice(u,1);break}i.tween=r}}function D(t,n,e){var r,i;if("function"!=typeof e)throw new Error;return function(){var o=C(this,t),u=o.tween;if(u!==r){i=(r=u).slice();for(var a={name:n,value:e},c=0,s=i.length;c<s;++c)if(i[c].name===n){i[c]=a;break}c===s&&i.push(a)}o.tween=i}}function F(t,n,e){var r=t._id;return t.each((function(){var t=C(this,r);(t.value||(t.value={}))[n]=e.apply(this,arguments)})),function(t){return S(t,r).value[n]}}var P=e(7),L=e(5),I=e(39),U=e(55),R=function(t,n){var e;return("number"==typeof n?L.a:n instanceof P.e?I.a:(e=Object(P.e)(n))?(n=e,I.a):U.a)(t,n)};function q(t){return function(){this.removeAttribute(t)}}function H(t){return function(){this.removeAttributeNS(t.space,t.local)}}function B(t,n,e){var r,i,o=e+"";return function(){var u=this.getAttribute(t);return u===o?null:u===r?i:i=n(r=u,e)}}function Y(t,n,e){var r,i,o=e+"";return function(){var u=this.getAttributeNS(t.space,t.local);return u===o?null:u===r?i:i=n(r=u,e)}}function z(t,n,e){var r,i,o;return function(){var u,a,c=e(this);if(null!=c)return(u=this.getAttribute(t))===(a=c+"")?null:u===r&&a===i?o:(i=a,o=n(r=u,c));this.removeAttribute(t)}}function G(t,n,e){var r,i,o;return function(){var u,a,c=e(this);if(null!=c)return(u=this.getAttributeNS(t.space,t.local))===(a=c+"")?null:u===r&&a===i?o:(i=a,o=n(r=u,c));this.removeAttributeNS(t.space,t.local)}}function X(t,n){return function(e){this.setAttribute(t,n.call(this,e))}}function V(t,n){return function(e){this.setAttributeNS(t.space,t.local,n.call(this,e))}}function W(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&V(t,i)),e}return i._value=n,i}function $(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&X(t,i)),e}return i._value=n,i}function Z(t,n){return function(){A(this,t).delay=+n.apply(this,arguments)}}function Q(t,n){return n=+n,function(){A(this,t).delay=n}}function J(t,n){return function(){C(this,t).duration=+n.apply(this,arguments)}}function K(t,n){return n=+n,function(){C(this,t).duration=n}}function tt(t,n){if("function"!=typeof n)throw new Error;return function(){C(this,t).ease=n}}var nt=e(34);function et(t,n,e){var r,i,o=function(t){return(t+"").trim().split(/^|\s+/).every((function(t){var n=t.indexOf(".");return n>=0&&(t=t.slice(0,n)),!t||"start"===t}))}(n)?A:C;return function(){var u=o(this,t),a=u.on;a!==r&&(i=(r=a).copy()).on(n,e),u.on=i}}var rt=e(19),it=e(33),ot=o.b.prototype.constructor,ut=e(35);function at(t){return function(){this.style.removeProperty(t)}}function ct(t,n,e){return function(r){this.style.setProperty(t,n.call(this,r),e)}}function st(t,n,e){var r,i;function o(){var o=n.apply(this,arguments);return o!==i&&(r=(i=o)&&ct(t,o,e)),r}return o._value=n,o}function ft(t){return function(n){this.textContent=t.call(this,n)}}function lt(t){var n,e;function r(){var r=t.apply(this,arguments);return r!==e&&(n=(e=r)&&ft(r)),n}return r._value=t,r}var ht=0;function dt(t,n,e,r){this._groups=t,this._parents=n,this._name=e,this._id=r}function pt(t){return Object(o.b)().transition(t)}function _t(){return++ht}var yt=o.b.prototype;dt.prototype=pt.prototype={constructor:dt,select:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(rt.a)(t));for(var r=this._groups,i=r.length,o=new Array(i),u=0;u<i;++u)for(var a,c,s=r[u],f=s.length,l=o[u]=new Array(f),h=0;h<f;++h)(a=s[h])&&(c=t.call(a,a.__data__,h,s))&&("__data__"in a&&(c.__data__=a.__data__),l[h]=c,O(l[h],n,e,h,l,S(a,e)));return new dt(o,this._parents,n,e)},selectAll:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(it.a)(t));for(var r=this._groups,i=r.length,o=[],u=[],a=0;a<i;++a)for(var c,s=r[a],f=s.length,l=0;l<f;++l)if(c=s[l]){for(var h,d=t.call(c,c.__data__,l,s),p=S(c,e),_=0,y=d.length;_<y;++_)(h=d[_])&&O(h,n,e,_,d,p);o.push(d),u.push(c)}return new dt(o,u,n,e)},filter:function(t){"function"!=typeof t&&(t=Object(nt.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o,u=n[i],a=u.length,c=r[i]=[],s=0;s<a;++s)(o=u[s])&&t.call(o,o.__data__,s,u)&&c.push(o);return new dt(r,this._parents,this._name,this._id)},merge:function(t){if(t._id!==this._id)throw new Error;for(var n=this._groups,e=t._groups,r=n.length,i=e.length,o=Math.min(r,i),u=new Array(r),a=0;a<o;++a)for(var c,s=n[a],f=e[a],l=s.length,h=u[a]=new Array(l),d=0;d<l;++d)(c=s[d]||f[d])&&(h[d]=c);for(;a<r;++a)u[a]=n[a];return new dt(u,this._parents,this._name,this._id)},selection:function(){return new ot(this._groups,this._parents)},transition:function(){for(var t=this._name,n=this._id,e=_t(),r=this._groups,i=r.length,o=0;o<i;++o)for(var u,a=r[o],c=a.length,s=0;s<c;++s)if(u=a[s]){var f=S(u,n);O(u,t,e,s,a,{time:f.time+f.delay+f.duration,delay:0,duration:f.duration,ease:f.ease})}return new dt(r,this._parents,t,e)},call:yt.call,nodes:yt.nodes,node:yt.node,size:yt.size,empty:yt.empty,each:yt.each,on:function(t,n){var e=this._id;return arguments.length<2?S(this.node(),e).on.on(t):this.each(et(e,t,n))},attr:function(t,n){var e=Object(j.a)(t),r="transform"===e?N.b:R;return this.attrTween(t,"function"==typeof n?(e.local?G:z)(e,r,F(this,"attr."+t,n)):null==n?(e.local?H:q)(e):(e.local?Y:B)(e,r,n))},attrTween:function(t,n){var e="attr."+t;if(arguments.length<2)return(e=this.tween(e))&&e._value;if(null==n)return this.tween(e,null);if("function"!=typeof n)throw new Error;var r=Object(j.a)(t);return this.tween(e,(r.local?W:$)(r,n))},style:function(t,n,e){var r="transform"==(t+="")?N.a:R;return null==n?this.styleTween(t,function(t,n){var e,r,i;return function(){var o=Object(ut.b)(this,t),u=(this.style.removeProperty(t),Object(ut.b)(this,t));return o===u?null:o===e&&u===r?i:i=n(e=o,r=u)}}(t,r)).on("end.style."+t,at(t)):"function"==typeof n?this.styleTween(t,function(t,n,e){var r,i,o;return function(){var u=Object(ut.b)(this,t),a=e(this),c=a+"";return null==a&&(this.style.removeProperty(t),c=a=Object(ut.b)(this,t)),u===c?null:u===r&&c===i?o:(i=c,o=n(r=u,a))}}(t,r,F(this,"style."+t,n))).each(function(t,n){var e,r,i,o,u="style."+n,a="end."+u;return function(){var c=C(this,t),s=c.on,f=null==c.value[u]?o||(o=at(n)):void 0;s===e&&i===f||(r=(e=s).copy()).on(a,i=f),c.on=r}}(this._id,t)):this.styleTween(t,function(t,n,e){var r,i,o=e+"";return function(){var u=Object(ut.b)(this,t);return u===o?null:u===r?i:i=n(r=u,e)}}(t,r,n),e).on("end.style."+t,null)},styleTween:function(t,n,e){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==n)return this.tween(r,null);if("function"!=typeof n)throw new Error;return this.tween(r,st(t,n,null==e?"":e))},text:function(t){return this.tween("text","function"==typeof t?function(t){return function(){var n=t(this);this.textContent=null==n?"":n}}(F(this,"text",t)):function(t){return function(){this.textContent=t}}(null==t?"":t+""))},textTween:function(t){var n="text";if(arguments.length<1)return(n=this.tween(n))&&n._value;if(null==t)return this.tween(n,null);if("function"!=typeof t)throw new Error;return this.tween(n,lt(t))},remove:function(){return this.on("end.remove",(t=this._id,function(){var n=this.parentNode;for(var e in this.__transition)if(+e!==t)return;n&&n.removeChild(this)}));var t},tween:function(t,n){var e=this._id;if(t+="",arguments.length<2){for(var r,i=S(this.node(),e).tween,o=0,u=i.length;o<u;++o)if((r=i[o]).name===t)return r.value;return null}return this.each((null==n?E:D)(e,t,n))},delay:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?Z:Q)(n,t)):S(this.node(),n).delay},duration:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?J:K)(n,t)):S(this.node(),n).duration},ease:function(t){var n=this._id;return arguments.length?this.each(tt(n,t)):S(this.node(),n).ease},end:function(){var t,n,e=this,r=e._id,i=e.size();return new Promise((function(o,u){var a={value:u},c={value:function(){0==--i&&o()}};e.each((function(){var e=C(this,r),i=e.on;i!==t&&((n=(t=i).copy())._.cancel.push(a),n._.interrupt.push(a),n._.end.push(c)),e.on=n}))}))}};var gt={time:null,delay:0,duration:250,ease:e(29).b};function vt(t,n){for(var e;!(e=t.__transition)||!(e=e[n]);)if(!(t=t.parentNode))return gt.time=_(),gt;return e}o.b.prototype.interrupt=function(t){return this.each((function(){k(this,t)}))},o.b.prototype.transition=function(t){var n,e;t instanceof dt?(n=t._id,t=t._name):(n=_t(),(e=gt).time=_(),t=null==t?null:t+"");for(var r=this._groups,i=r.length,o=0;o<i;++o)for(var u,a=r[o],c=a.length,s=0;s<c;++s)(u=a[s])&&O(u,t,n,s,a,e||vt(u,n));return new dt(r,this._parents,t,n)};var mt=[null],xt=function(t,n){var e,r,i=t.__transition;if(i)for(r in n=null==n?null:n+"",i)if((e=i[r]).state>1&&e.name===n)return new dt([[t]],mt,n,+r);return null};e.d(n,"transition",(function(){return pt})),e.d(n,"active",(function(){return xt})),e.d(n,"interrupt",(function(){return k}))},,function(t,n,e){"use strict";var r,i,o,u,a=e(5),c=180/Math.PI,s={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1},f=function(t,n,e,r,i,o){var u,a,s;return(u=Math.sqrt(t*t+n*n))&&(t/=u,n/=u),(s=t*e+n*r)&&(e-=t*s,r-=n*s),(a=Math.sqrt(e*e+r*r))&&(e/=a,r/=a,s/=a),t*r<n*e&&(t=-t,n=-n,s=-s,u=-u),{translateX:i,translateY:o,rotate:Math.atan2(n,t)*c,skewX:Math.atan(s)*c,scaleX:u,scaleY:a}};function l(t,n,e,r){function i(t){return t.length?t.pop()+" ":""}return function(o,u){var c=[],s=[];return o=t(o),u=t(u),function(t,r,i,o,u,c){if(t!==i||r!==o){var s=u.push("translate(",null,n,null,e);c.push({i:s-4,x:Object(a.a)(t,i)},{i:s-2,x:Object(a.a)(r,o)})}else(i||o)&&u.push("translate("+i+n+o+e)}(o.translateX,o.translateY,u.translateX,u.translateY,c,s),function(t,n,e,o){t!==n?(t-n>180?n+=360:n-t>180&&(t+=360),o.push({i:e.push(i(e)+"rotate(",null,r)-2,x:Object(a.a)(t,n)})):n&&e.push(i(e)+"rotate("+n+r)}(o.rotate,u.rotate,c,s),function(t,n,e,o){t!==n?o.push({i:e.push(i(e)+"skewX(",null,r)-2,x:Object(a.a)(t,n)}):n&&e.push(i(e)+"skewX("+n+r)}(o.skewX,u.skewX,c,s),function(t,n,e,r,o,u){if(t!==e||n!==r){var c=o.push(i(o)+"scale(",null,",",null,")");u.push({i:c-4,x:Object(a.a)(t,e)},{i:c-2,x:Object(a.a)(n,r)})}else 1===e&&1===r||o.push(i(o)+"scale("+e+","+r+")")}(o.scaleX,o.scaleY,u.scaleX,u.scaleY,c,s),o=u=null,function(t){for(var n,e=-1,r=s.length;++e<r;)c[(n=s[e]).i]=n.x(t);return c.join("")}}}e.d(n,"a",(function(){return h})),e.d(n,"b",(function(){return d}));var h=l((function(t){return"none"===t?s:(r||(r=document.createElement("DIV"),i=document.documentElement,o=document.defaultView),r.style.transform=t,t=o.getComputedStyle(i.appendChild(r),null).getPropertyValue("transform"),i.removeChild(r),t=t.slice(7,-1).split(","),f(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}),"px, ","px)","deg)"),d=l((function(t){return null==t?s:(u||(u=document.createElementNS("http://www.w3.org/2000/svg","g")),u.setAttribute("transform",t),(t=u.transform.baseVal.consolidate())?(t=t.matrix,f(t.a,t.b,t.c,t.d,t.e,t.f)):s)}),", ",")",")")},function(t,n,e){"use strict";e.r(n);var r=e(2);function i(t,n){switch(arguments.length){case 0:break;case 1:this.range(t);break;default:this.range(n).domain(t)}return this}function o(t,n){switch(arguments.length){case 0:break;case 1:this.interpolator(t);break;default:this.interpolator(n).domain(t)}return this}var u=e(45),a=Array.prototype,c=a.map,s=a.slice,f={name:"implicit"};function l(){var t=Object(u.map)(),n=[],e=[],r=f;function o(i){var o=i+"",u=t.get(o);if(!u){if(r!==f)return r;t.set(o,u=n.push(i))}return e[(u-1)%e.length]}return o.domain=function(e){if(!arguments.length)return n.slice();n=[],t=Object(u.map)();for(var r,i,a=-1,c=e.length;++a<c;)t.has(i=(r=e[a])+"")||t.set(i,n.push(r));return o},o.range=function(t){return arguments.length?(e=s.call(t),o):e.slice()},o.unknown=function(t){return arguments.length?(r=t,o):r},o.copy=function(){return l(n,e).unknown(r)},i.apply(o,arguments),o}function h(){var t,n,e=l().unknown(void 0),o=e.domain,u=e.range,a=[0,1],c=!1,s=0,f=0,d=.5;function p(){var e=o().length,i=a[1]<a[0],l=a[i-0],h=a[1-i];t=(h-l)/Math.max(1,e-s+2*f),c&&(t=Math.floor(t)),l+=(h-l-t*(e-s))*d,n=t*(1-s),c&&(l=Math.round(l),n=Math.round(n));var p=Object(r.range)(e).map((function(n){return l+t*n}));return u(i?p.reverse():p)}return delete e.unknown,e.domain=function(t){return arguments.length?(o(t),p()):o()},e.range=function(t){return arguments.length?(a=[+t[0],+t[1]],p()):a.slice()},e.rangeRound=function(t){return a=[+t[0],+t[1]],c=!0,p()},e.bandwidth=function(){return n},e.step=function(){return t},e.round=function(t){return arguments.length?(c=!!t,p()):c},e.padding=function(t){return arguments.length?(s=Math.min(1,f=+t),p()):s},e.paddingInner=function(t){return arguments.length?(s=Math.min(1,t),p()):s},e.paddingOuter=function(t){return arguments.length?(f=+t,p()):f},e.align=function(t){return arguments.length?(d=Math.max(0,Math.min(1,t)),p()):d},e.copy=function(){return h(o(),a).round(c).paddingInner(s).paddingOuter(f).align(d)},i.apply(p(),arguments)}function d(t){var n=t.copy;return t.padding=t.paddingOuter,delete t.paddingInner,delete t.paddingOuter,t.copy=function(){return d(n())},t}function p(){return d(h.apply(null,arguments).paddingInner(1))}var _=e(36),y=e(5),g=e(81),v=function(t){return+t},m=[0,1];function x(t){return t}function b(t,n){return(n-=t=+t)?function(e){return(e-t)/n}:(e=isNaN(n)?NaN:.5,function(){return e});var e}function w(t){var n,e=t[0],r=t[t.length-1];return e>r&&(n=e,e=r,r=n),function(t){return Math.max(e,Math.min(r,t))}}function M(t,n,e){var r=t[0],i=t[1],o=n[0],u=n[1];return i<r?(r=b(i,r),o=e(u,o)):(r=b(r,i),o=e(o,u)),function(t){return o(r(t))}}function T(t,n,e){var i=Math.min(t.length,n.length)-1,o=new Array(i),u=new Array(i),a=-1;for(t[i]<t[0]&&(t=t.slice().reverse(),n=n.slice().reverse());++a<i;)o[a]=b(t[a],t[a+1]),u[a]=e(n[a],n[a+1]);return function(n){var e=Object(r.bisect)(t,n,1,i)-1;return u[e](o[e](n))}}function O(t,n){return n.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown())}function A(){var t,n,e,r,i,o,u=m,a=m,f=_.a,l=x;function h(){return r=Math.min(u.length,a.length)>2?T:M,i=o=null,d}function d(n){return isNaN(n=+n)?e:(i||(i=r(u.map(t),a,f)))(t(l(n)))}return d.invert=function(e){return l(n((o||(o=r(a,u.map(t),y.a)))(e)))},d.domain=function(t){return arguments.length?(u=c.call(t,v),l===x||(l=w(u)),h()):u.slice()},d.range=function(t){return arguments.length?(a=s.call(t),h()):a.slice()},d.rangeRound=function(t){return a=s.call(t),f=g.a,h()},d.clamp=function(t){return arguments.length?(l=t?w(u):x,d):l!==x},d.interpolate=function(t){return arguments.length?(f=t,h()):f},d.unknown=function(t){return arguments.length?(e=t,d):e},function(e,r){return t=e,n=r,h()}}function C(t,n){return A()(t,n)}var S=e(24),k=e(62),N=e(40),j=e(63),E=e(61),D=function(t,n,e,i){var o,u=Object(r.tickStep)(t,n,e);switch((i=Object(S.b)(null==i?",f":i)).type){case"s":var a=Math.max(Math.abs(t),Math.abs(n));return null!=i.precision||isNaN(o=Object(k.a)(u,a))||(i.precision=o),Object(N.c)(i,a);case"":case"e":case"g":case"p":case"r":null!=i.precision||isNaN(o=Object(j.a)(u,Math.max(Math.abs(t),Math.abs(n))))||(i.precision=o-("e"===i.type));break;case"f":case"%":null!=i.precision||isNaN(o=Object(E.a)(u))||(i.precision=o-2*("%"===i.type))}return Object(N.b)(i)};function F(t){var n=t.domain;return t.ticks=function(t){var e=n();return Object(r.ticks)(e[0],e[e.length-1],null==t?10:t)},t.tickFormat=function(t,e){var r=n();return D(r[0],r[r.length-1],null==t?10:t,e)},t.nice=function(e){null==e&&(e=10);var i,o=n(),u=0,a=o.length-1,c=o[u],s=o[a];return s<c&&(i=c,c=s,s=i,i=u,u=a,a=i),(i=Object(r.tickIncrement)(c,s,e))>0?(c=Math.floor(c/i)*i,s=Math.ceil(s/i)*i,i=Object(r.tickIncrement)(c,s,e)):i<0&&(c=Math.ceil(c*i)/i,s=Math.floor(s*i)/i,i=Object(r.tickIncrement)(c,s,e)),i>0?(o[u]=Math.floor(c/i)*i,o[a]=Math.ceil(s/i)*i,n(o)):i<0&&(o[u]=Math.ceil(c*i)/i,o[a]=Math.floor(s*i)/i,n(o)),t},t}function P(){var t=C(x,x);return t.copy=function(){return O(t,P())},i.apply(t,arguments),F(t)}function L(t){var n;function e(t){return isNaN(t=+t)?n:t}return e.invert=e,e.domain=e.range=function(n){return arguments.length?(t=c.call(n,v),e):t.slice()},e.unknown=function(t){return arguments.length?(n=t,e):n},e.copy=function(){return L(t).unknown(n)},t=arguments.length?c.call(t,v):[0,1],F(e)}var I=function(t,n){var e,r=0,i=(t=t.slice()).length-1,o=t[r],u=t[i];return u<o&&(e=r,r=i,i=e,e=o,o=u,u=e),t[r]=n.floor(o),t[i]=n.ceil(u),t};function U(t){return Math.log(t)}function R(t){return Math.exp(t)}function q(t){return-Math.log(-t)}function H(t){return-Math.exp(-t)}function B(t){return isFinite(t)?+("1e"+t):t<0?0:t}function Y(t){return function(n){return-t(-n)}}function z(t){var n,e,i=t(U,R),o=i.domain,u=10;function a(){return n=function(t){return t===Math.E?Math.log:10===t&&Math.log10||2===t&&Math.log2||(t=Math.log(t),function(n){return Math.log(n)/t})}(u),e=function(t){return 10===t?B:t===Math.E?Math.exp:function(n){return Math.pow(t,n)}}(u),o()[0]<0?(n=Y(n),e=Y(e),t(q,H)):t(U,R),i}return i.base=function(t){return arguments.length?(u=+t,a()):u},i.domain=function(t){return arguments.length?(o(t),a()):o()},i.ticks=function(t){var i,a=o(),c=a[0],s=a[a.length-1];(i=s<c)&&(d=c,c=s,s=d);var f,l,h,d=n(c),p=n(s),_=null==t?10:+t,y=[];if(!(u%1)&&p-d<_){if(d=Math.round(d)-1,p=Math.round(p)+1,c>0){for(;d<p;++d)for(l=1,f=e(d);l<u;++l)if(!((h=f*l)<c)){if(h>s)break;y.push(h)}}else for(;d<p;++d)for(l=u-1,f=e(d);l>=1;--l)if(!((h=f*l)<c)){if(h>s)break;y.push(h)}}else y=Object(r.ticks)(d,p,Math.min(p-d,_)).map(e);return i?y.reverse():y},i.tickFormat=function(t,r){if(null==r&&(r=10===u?".0e":","),"function"!=typeof r&&(r=Object(N.b)(r)),t===1/0)return r;null==t&&(t=10);var o=Math.max(1,u*t/i.ticks().length);return function(t){var i=t/e(Math.round(n(t)));return i*u<u-.5&&(i*=u),i<=o?r(t):""}},i.nice=function(){return o(I(o(),{floor:function(t){return e(Math.floor(n(t)))},ceil:function(t){return e(Math.ceil(n(t)))}}))},i}function G(){var t=z(A()).domain([1,10]);return t.copy=function(){return O(t,G()).base(t.base())},i.apply(t,arguments),t}function X(t){return function(n){return Math.sign(n)*Math.log1p(Math.abs(n/t))}}function V(t){return function(n){return Math.sign(n)*Math.expm1(Math.abs(n))*t}}function W(t){var n=1,e=t(X(n),V(n));return e.constant=function(e){return arguments.length?t(X(n=+e),V(n)):n},F(e)}function $(){var t=W(A());return t.copy=function(){return O(t,$()).constant(t.constant())},i.apply(t,arguments)}function Z(t){return function(n){return n<0?-Math.pow(-n,t):Math.pow(n,t)}}function Q(t){return t<0?-Math.sqrt(-t):Math.sqrt(t)}function J(t){return t<0?-t*t:t*t}function K(t){var n=t(x,x),e=1;function r(){return 1===e?t(x,x):.5===e?t(Q,J):t(Z(e),Z(1/e))}return n.exponent=function(t){return arguments.length?(e=+t,r()):e},F(n)}function tt(){var t=K(A());return t.copy=function(){return O(t,tt()).exponent(t.exponent())},i.apply(t,arguments),t}function nt(){return tt.apply(null,arguments).exponent(.5)}function et(){var t,n=[],e=[],o=[];function u(){var t=0,i=Math.max(1,e.length);for(o=new Array(i-1);++t<i;)o[t-1]=Object(r.quantile)(n,t/i);return a}function a(n){return isNaN(n=+n)?t:e[Object(r.bisect)(o,n)]}return a.invertExtent=function(t){var r=e.indexOf(t);return r<0?[NaN,NaN]:[r>0?o[r-1]:n[0],r<o.length?o[r]:n[n.length-1]]},a.domain=function(t){if(!arguments.length)return n.slice();n=[];for(var e,i=0,o=t.length;i<o;++i)null==(e=t[i])||isNaN(e=+e)||n.push(e);return n.sort(r.ascending),u()},a.range=function(t){return arguments.length?(e=s.call(t),u()):e.slice()},a.unknown=function(n){return arguments.length?(t=n,a):t},a.quantiles=function(){return o.slice()},a.copy=function(){return et().domain(n).range(e).unknown(t)},i.apply(a,arguments)}function rt(){var t,n=0,e=1,o=1,u=[.5],a=[0,1];function c(n){return n<=n?a[Object(r.bisect)(u,n,0,o)]:t}function f(){var t=-1;for(u=new Array(o);++t<o;)u[t]=((t+1)*e-(t-o)*n)/(o+1);return c}return c.domain=function(t){return arguments.length?(n=+t[0],e=+t[1],f()):[n,e]},c.range=function(t){return arguments.length?(o=(a=s.call(t)).length-1,f()):a.slice()},c.invertExtent=function(t){var r=a.indexOf(t);return r<0?[NaN,NaN]:r<1?[n,u[0]]:r>=o?[u[o-1],e]:[u[r-1],u[r]]},c.unknown=function(n){return arguments.length?(t=n,c):c},c.thresholds=function(){return u.slice()},c.copy=function(){return rt().domain([n,e]).range(a).unknown(t)},i.apply(F(c),arguments)}function it(){var t,n=[.5],e=[0,1],o=1;function u(i){return i<=i?e[Object(r.bisect)(n,i,0,o)]:t}return u.domain=function(t){return arguments.length?(n=s.call(t),o=Math.min(n.length,e.length-1),u):n.slice()},u.range=function(t){return arguments.length?(e=s.call(t),o=Math.min(n.length,e.length-1),u):e.slice()},u.invertExtent=function(t){var r=e.indexOf(t);return[n[r-1],n[r]]},u.unknown=function(n){return arguments.length?(t=n,u):t},u.copy=function(){return it().domain(n).range(e).unknown(t)},i.apply(u,arguments)}var ot=e(15),ut=e(47),at=e(3),ct=e(27),st=e(48),ft=e(49),lt=e(30),ht=e(31),dt=e(46);function pt(t){return new Date(t)}function _t(t){return t instanceof Date?+t:+new Date(+t)}function yt(t,n,e,i,o,u,a,s,f){var l=C(x,x),h=l.invert,d=l.domain,p=f(".%L"),_=f(":%S"),y=f("%I:%M"),g=f("%I %p"),v=f("%a %d"),m=f("%b %d"),b=f("%B"),w=f("%Y"),M=[[a,1,1e3],[a,5,5e3],[a,15,15e3],[a,30,3e4],[u,1,6e4],[u,5,3e5],[u,15,9e5],[u,30,18e5],[o,1,36e5],[o,3,108e5],[o,6,216e5],[o,12,432e5],[i,1,864e5],[i,2,1728e5],[e,1,6048e5],[n,1,2592e6],[n,3,7776e6],[t,1,31536e6]];function T(r){return(a(r)<r?p:u(r)<r?_:o(r)<r?y:i(r)<r?g:n(r)<r?e(r)<r?v:m:t(r)<r?b:w)(r)}function A(n,e,i,o){if(null==n&&(n=10),"number"==typeof n){var u=Math.abs(i-e)/n,a=Object(r.bisector)((function(t){return t[2]})).right(M,u);a===M.length?(o=Object(r.tickStep)(e/31536e6,i/31536e6,n),n=t):a?(o=(a=M[u/M[a-1][2]<M[a][2]/u?a-1:a])[1],n=a[0]):(o=Math.max(Object(r.tickStep)(e,i,n),1),n=s)}return null==o?n:n.every(o)}return l.invert=function(t){return new Date(h(t))},l.domain=function(t){return arguments.length?d(c.call(t,_t)):d().map(pt)},l.ticks=function(t,n){var e,r=d(),i=r[0],o=r[r.length-1],u=o<i;return u&&(e=i,i=o,o=e),e=(e=A(t,i,o,n))?e.range(i,o+1):[],u?e.reverse():e},l.tickFormat=function(t,n){return null==n?T:f(n)},l.nice=function(t,n){var e=d();return(t=A(t,e[0],e[e.length-1],n))?d(I(e,t)):l},l.copy=function(){return O(l,yt(t,n,e,i,o,u,a,s,f))},l}var gt=function(){return i.apply(yt(ot.a,ut.a,at.g,ct.b,st.a,ft.a,lt.a,ht.a,dt.b).domain([new Date(2e3,0,1),new Date(2e3,0,2)]),arguments)},vt=e(16),mt=e(50),xt=e(4),bt=e(28),wt=e(51),Mt=e(52),Tt=function(){return i.apply(yt(vt.a,mt.a,xt.g,bt.a,wt.a,Mt.a,lt.a,ht.a,dt.d).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)]),arguments)};function Ot(){var t,n,e,r,i,o=0,u=1,a=x,c=!1;function s(n){return isNaN(n=+n)?i:a(0===e?.5:(n=(r(n)-t)*e,c?Math.max(0,Math.min(1,n)):n))}return s.domain=function(i){return arguments.length?(t=r(o=+i[0]),n=r(u=+i[1]),e=t===n?0:1/(n-t),s):[o,u]},s.clamp=function(t){return arguments.length?(c=!!t,s):c},s.interpolator=function(t){return arguments.length?(a=t,s):a},s.unknown=function(t){return arguments.length?(i=t,s):i},function(i){return r=i,t=i(o),n=i(u),e=t===n?0:1/(n-t),s}}function At(t,n){return n.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown())}function Ct(){var t=F(Ot()(x));return t.copy=function(){return At(t,Ct())},o.apply(t,arguments)}function St(){var t=z(Ot()).domain([1,10]);return t.copy=function(){return At(t,St()).base(t.base())},o.apply(t,arguments)}function kt(){var t=W(Ot());return t.copy=function(){return At(t,kt()).constant(t.constant())},o.apply(t,arguments)}function Nt(){var t=K(Ot());return t.copy=function(){return At(t,Nt()).exponent(t.exponent())},o.apply(t,arguments)}function jt(){return Nt.apply(null,arguments).exponent(.5)}function Et(){var t=[],n=x;function e(e){if(!isNaN(e=+e))return n((Object(r.bisect)(t,e)-1)/(t.length-1))}return e.domain=function(n){if(!arguments.length)return t.slice();t=[];for(var i,o=0,u=n.length;o<u;++o)null==(i=n[o])||isNaN(i=+i)||t.push(i);return t.sort(r.ascending),e},e.interpolator=function(t){return arguments.length?(n=t,e):n},e.copy=function(){return Et(n).domain(t)},o.apply(e,arguments)}function Dt(){var t,n,e,r,i,o,u,a=0,c=.5,s=1,f=x,l=!1;function h(t){return isNaN(t=+t)?u:(t=.5+((t=+o(t))-n)*(t<n?r:i),f(l?Math.max(0,Math.min(1,t)):t))}return h.domain=function(u){return arguments.length?(t=o(a=+u[0]),n=o(c=+u[1]),e=o(s=+u[2]),r=t===n?0:.5/(n-t),i=n===e?0:.5/(e-n),h):[a,c,s]},h.clamp=function(t){return arguments.length?(l=!!t,h):l},h.interpolator=function(t){return arguments.length?(f=t,h):f},h.unknown=function(t){return arguments.length?(u=t,h):u},function(u){return o=u,t=u(a),n=u(c),e=u(s),r=t===n?0:.5/(n-t),i=n===e?0:.5/(e-n),h}}function Ft(){var t=F(Dt()(x));return t.copy=function(){return At(t,Ft())},o.apply(t,arguments)}function Pt(){var t=z(Dt()).domain([.1,1,10]);return t.copy=function(){return At(t,Pt()).base(t.base())},o.apply(t,arguments)}function Lt(){var t=W(Dt());return t.copy=function(){return At(t,Lt()).constant(t.constant())},o.apply(t,arguments)}function It(){var t=K(Dt());return t.copy=function(){return At(t,It()).exponent(t.exponent())},o.apply(t,arguments)}function Ut(){return It.apply(null,arguments).exponent(.5)}e.d(n,"scaleBand",(function(){return h})),e.d(n,"scalePoint",(function(){return p})),e.d(n,"scaleIdentity",(function(){return L})),e.d(n,"scaleLinear",(function(){return P})),e.d(n,"scaleLog",(function(){return G})),e.d(n,"scaleSymlog",(function(){return $})),e.d(n,"scaleOrdinal",(function(){return l})),e.d(n,"scaleImplicit",(function(){return f})),e.d(n,"scalePow",(function(){return tt})),e.d(n,"scaleSqrt",(function(){return nt})),e.d(n,"scaleQuantile",(function(){return et})),e.d(n,"scaleQuantize",(function(){return rt})),e.d(n,"scaleThreshold",(function(){return it})),e.d(n,"scaleTime",(function(){return gt})),e.d(n,"scaleUtc",(function(){return Tt})),e.d(n,"scaleSequential",(function(){return Ct})),e.d(n,"scaleSequentialLog",(function(){return St})),e.d(n,"scaleSequentialPow",(function(){return Nt})),e.d(n,"scaleSequentialSqrt",(function(){return jt})),e.d(n,"scaleSequentialSymlog",(function(){return kt})),e.d(n,"scaleSequentialQuantile",(function(){return Et})),e.d(n,"scaleDiverging",(function(){return Ft})),e.d(n,"scaleDivergingLog",(function(){return Pt})),e.d(n,"scaleDivergingPow",(function(){return It})),e.d(n,"scaleDivergingSqrt",(function(){return Ut})),e.d(n,"scaleDivergingSymlog",(function(){return Lt})),e.d(n,"tickFormat",(function(){return D}))},function(t,n,e){"use strict";var r;void 0===(r=function(t){var n=e(65).colorSchemas,r=(e(70),e(77)),i="undefined"!=typeof window,o=navigator.msSaveOrOpenBlob,u=i&&window.btoa;u||(u=e(78).encode);var a={styleClass:"britechartStyle",defaultFilename:"britechart.png",chartBackground:"white",imageSourceBase:"data:image/svg+xml;base64,",titleFontSize:"15px",titleFontFamily:"'Benton Sans', sans-serif",titleTopOffset:15,get styleBackgroundString(){return"<style>svg{background:"+this.chartBackground+";}</style>"}};function c(t,n){if(t){t.attr("version",1.1).attr("xmlns","http://www.w3.org/2000/svg");var e=r.initializeSerializer()(t.node());return e=function(t){if(navigator.userAgent.search("FireFox")>-1)return t.replace(/url.*&quot;\)/,'url(&quot;linearGradient[id*="-gradient-"]&quot;);');return t}(e),e=function(t){return t.replace(">",">"+a.styleBackgroundString)}(e=h.call(this,e,n,parseInt(t.attr("width"),10)))}}function s(t){var n=new Image;return n.src=""+a.imageSourceBase+u(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g,(function(t,n){return String.fromCharCode("0x"+n)}))),n}function f(t,n){return n.getContext("2d").drawImage(t,0,0),n}function l(t,n,e){e.preventDefault(),function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:a.defaultFilename,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"image/png",r=t.toDataURL(e),i=document.createElement("a");i.href=r,i.download=n,document.body.appendChild(i),i.click(),document.body.removeChild(i)}(f(this,t),n)}function h(t,e,r){if(!e||!r)return t;var i=n.grey;return t=t.replace(/<g/,'<text x="'+this.margin().left+'" y="'+a.titleTopOffset+'" font-family="'+a.titleFontFamily+'" font-size="'+a.titleFontSize+'" fill="'+i[6]+'"> '+e+" </text><g ")}return{exportChart:function(t,n,e){if(o)return console.error("Sorry, this feature is not available for IE. If you require this to work, check this issue https://github.com/britecharts/britecharts/pull/652"),!1;var r,i,u,a=s(c.call(this,t,e));a.onload=l.bind(a,(r=this.width(),i=this.height(),(u=document.createElement("canvas")).height=i,u.width=r,u),n)},convertSvgToHtml:c,createImage:s,drawImageOnCanvas:f}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";var r,i,o;t.exports=(r={BASE:!0,HEAD:!0,HTML:!0,META:!0,NOFRAME:!0,NOSCRIPT:!0,PARAM:!0,SCRIPT:!0,STYLE:!0,TITLE:!0},i=["A","ABBR","ADDRESS","AREA","ARTICLE","ASIDE","AUDIO","B","BASE","BDI","BDO","BLOCKQUOTE","BODY","BR","BUTTON","CANVAS","CAPTION","CENTER","CITE","CODE","COL","COLGROUP","COMMAND","DATALIST","DD","DEL","DETAILS","DFN","DIV","DL","DT","EM","EMBED","FIELDSET","FIGCAPTION","FIGURE","FONT","FOOTER","FORM","H1","H2","H3","H4","H5","H6","HEAD","HEADER","HGROUP","HR","HTML","I","IFRAME","IMG","INPUT","INS","KBD","LABEL","LEGEND","LI","LINK","MAP","MARK","MATH","MENU","META","METER","NAV","NOBR","NOSCRIPT","OBJECT","OL","OPTION","OPTGROUP","OUTPUT","P","PARAM","PRE","PROGRESS","Q","RP","RT","RUBY","S","SAMP","SCRIPT","SECTION","SELECT","SMALL","SOURCE","SPAN","STRONG","STYLE","SUB","SUMMARY","SUP","SVG","TABLE","TBODY","TD","TEXTAREA","TFOOT","TH","THEAD","TIME","TITLE","TR","TRACK","U","UL","VAR","VIDEO","WBR"],o=function(t){var n={},e=document.body.appendChild(document.createElement(t)),r=window.getComputedStyle(e);return[].forEach.call(r,(function(t){n[t]=r[t]})),document.body.removeChild(e),n},{initializeSerializer:function(){var t={};return[].forEach.call(i,(function(n){r[n]||(t[n]=o(n))})),function(n){var e,i=[],u=void 0,a=void 0,c=void 0;if(n&&n.nodeType===Node.ELEMENT_NODE)return i=[],u=n.querySelectorAll("*"),[].forEach.call(u,(function(n,e){var u;r[n.tagName]||(a=window.getComputedStyle(n),u=(u=n.tagName).toUpperCase(),t[u]||(t[u]=o(u)),c=t[u],i[e]=n.style.cssText,[].forEach.call(a,(function(t){a[t]!==c[t]&&(n.style[t]=a[t])})))})),e=n.outerHTML,u=[].map.call(u,(function(t,n){return t.style.cssText=i[n],t})),e}}})},function(t,n,e){(function(t,r){var i;/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */!function(o){var u=n,a=(t&&t.exports,"object"==typeof r&&r);a.global!==a&&a.window;var c=function(t){this.message=t};(c.prototype=new Error).name="InvalidCharacterError";var s=function(t){throw new c(t)},f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=/[\t\n\f\r ]/g,h={encode:function(t){t=String(t),/[^\0-\xFF]/.test(t)&&s("The string to be encoded contains characters outside of the Latin1 range.");for(var n,e,r,i,o=t.length%3,u="",a=-1,c=t.length-o;++a<c;)n=t.charCodeAt(a)<<16,e=t.charCodeAt(++a)<<8,r=t.charCodeAt(++a),u+=f.charAt((i=n+e+r)>>18&63)+f.charAt(i>>12&63)+f.charAt(i>>6&63)+f.charAt(63&i);return 2==o?(n=t.charCodeAt(a)<<8,e=t.charCodeAt(++a),u+=f.charAt((i=n+e)>>10)+f.charAt(i>>4&63)+f.charAt(i<<2&63)+"="):1==o&&(i=t.charCodeAt(a),u+=f.charAt(i>>2)+f.charAt(i<<4&63)+"=="),u},decode:function(t){var n=(t=String(t).replace(l,"")).length;n%4==0&&(n=(t=t.replace(/==?$/,"")).length),(n%4==1||/[^+a-zA-Z0-9/]/.test(t))&&s("Invalid character: the string to be decoded is not correctly encoded.");for(var e,r,i=0,o="",u=-1;++u<n;)r=f.indexOf(t.charAt(u)),e=i%4?64*e+r:r,i++%4&&(o+=String.fromCharCode(255&e>>(-2*i&6)));return o},version:"0.1.0"};void 0===(i=function(){return h}.call(n,e,n,t))||(t.exports=i)}()}).call(this,e(79)(t),e(80))},function(t,n){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,n){var e;e=function(){return this}();try{e=e||new Function("return this")()}catch(t){"object"==typeof window&&(e=window)}t.exports=e},function(t,n,e){"use strict";n.a=function(t,n){return t=+t,n=+n,function(e){return Math.round(t*(1-e)+n*e)}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return s})),e.d(n,"a",(function(){return f})),e.d(n,"d",(function(){return g})),e.d(n,"c",(function(){return v}));var r=e(11),i=e(7),o=e(67),u=6/29,a=3*u*u;function c(t){if(t instanceof l)return new l(t.l,t.a,t.b,t.opacity);if(t instanceof m)return x(t);t instanceof i.b||(t=Object(i.h)(t));var n,e,r=_(t.r),o=_(t.g),u=_(t.b),a=h((.2225045*r+.7168786*o+.0606169*u)/1);return r===o&&o===u?n=e=a:(n=h((.4360747*r+.3850649*o+.1430804*u)/.96422),e=h((.0139322*r+.0971045*o+.7141733*u)/.82521)),new l(116*a-16,500*(n-a),200*(a-e),t.opacity)}function s(t,n){return new l(t,0,0,null==n?1:n)}function f(t,n,e,r){return 1===arguments.length?c(t):new l(t,n,e,null==r?1:r)}function l(t,n,e,r){this.l=+t,this.a=+n,this.b=+e,this.opacity=+r}function h(t){return t>.008856451679035631?Math.pow(t,1/3):t/a+4/29}function d(t){return t>u?t*t*t:a*(t-4/29)}function p(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function _(t){return(t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function y(t){if(t instanceof m)return new m(t.h,t.c,t.l,t.opacity);if(t instanceof l||(t=c(t)),0===t.a&&0===t.b)return new m(NaN,0<t.l&&t.l<100?0:NaN,t.l,t.opacity);var n=Math.atan2(t.b,t.a)*o.b;return new m(n<0?n+360:n,Math.sqrt(t.a*t.a+t.b*t.b),t.l,t.opacity)}function g(t,n,e,r){return 1===arguments.length?y(t):new m(e,n,t,null==r?1:r)}function v(t,n,e,r){return 1===arguments.length?y(t):new m(t,n,e,null==r?1:r)}function m(t,n,e,r){this.h=+t,this.c=+n,this.l=+e,this.opacity=+r}function x(t){if(isNaN(t.h))return new l(t.l,0,0,t.opacity);var n=t.h*o.a;return new l(t.l,Math.cos(n)*t.c,Math.sin(n)*t.c,t.opacity)}Object(r.a)(l,f,Object(r.b)(i.a,{brighter:function(t){return new l(this.l+18*(null==t?1:t),this.a,this.b,this.opacity)},darker:function(t){return new l(this.l-18*(null==t?1:t),this.a,this.b,this.opacity)},rgb:function(){var t=(this.l+16)/116,n=isNaN(this.a)?t:t+this.a/500,e=isNaN(this.b)?t:t-this.b/200;return n=.96422*d(n),t=1*d(t),e=.82521*d(e),new i.b(p(3.1338561*n-1.6168667*t-.4906146*e),p(-.9787684*n+1.9161415*t+.033454*e),p(.0719453*n-.2289914*t+1.4052427*e),this.opacity)}})),Object(r.a)(m,v,Object(r.b)(i.a,{brighter:function(t){return new m(this.h,this.c,this.l+18*(null==t?1:t),this.opacity)},darker:function(t){return new m(this.h,this.c,this.l-18*(null==t?1:t),this.opacity)},rgb:function(){return x(this).rgb()}}))},function(t,n,e){"use strict";var r;void 0===(r=function(){return{bar:'\n            <svg class="load-state bar-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 711 325">\n              \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(0 29)">\n                        <g stroke="#EFF2F5" stroke-dasharray="4 4">\n                            <path d="M.400592911 200.302477L710.674315 200.302477M.400592884 131.172748L710.674315 131.172748M.324410282 64.2071321L710.621499 64.2071321M.291004517.563888874L709.82431.563888889"/>\n                        </g>\n                        <g fill="#D2D6DF" transform="translate(63.08 11)">\n                            <polygon points="-.08 176 23.92 176 23.92 255 -.08 255"/>\n                            <polygon points="50.829 147 74.829 147 74.829 255 50.829 255"/>\n                            <polygon points="254.465 0 278.465 0 278.465 255 254.465 255"/>\n                            <polygon points="458.102 169 482.102 169 482.102 255 458.102 255"/>\n                            <polygon points="152.647 82 176.647 82 176.647 255 152.647 255"/>\n                            <polygon points="356.283 66 380.283 66 380.283 255 356.283 255"/>\n                            <polygon points="559.92 229 583.92 229 583.92 255 559.92 255"/>\n                            <polygon points="101.738 115 125.738 115 125.738 255 101.738 255"/>\n                            <polygon points="305.374 42 329.374 42 329.374 255 305.374 255"/>\n                            <polygon points="509.011 201 533.011 201 533.011 255 509.011 255"/>\n                            <polygon points="203.556 19 227.556 19 227.556 255 203.556 255"/>\n                            <polygon points="407.192 115 431.192 115 431.192 255 407.192 255"/>\n                        </g>\n                    </g>\n                    <polygon fill="#D2D6DF" fill-rule="nonzero" points="0 295 711 295 711 294 0 294"/>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',donut:'\n            <svg class="load-state donut-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 376 331">\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(116 107)">\n                        <circle cx="72" cy="72" r="72" stroke="#EFF2F5" stroke-linecap="round" stroke-width="9.6"/>\n                        <path stroke="#D2D6DF" stroke-width="19.2" d="M126.153559,119.524055 C137.264629,106.845712 144,90.2321371 144,72.0444604 C144,32.2554036 111.764502,0 72,0"/>\n                        <circle cx="72" cy="72" r="67.2" fill="#FFF"/>\n                    </g>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',line:'\n            <svg\n                class="load-state line-load-state"\n                xmlns="http://www.w3.org/2000/svg"\n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path\n                    id="chart-bg"\n                    class="chart-bg"\n                    style="stroke:#C3C6CF;"\n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n                <polyline\n                    id="chart-line"\n                    class="chart-line"\n                    style="stroke:#C3C6CF;stroke-width:4;fill:none;"\n                    points="8.8,175.8 62.4,237.7 116.1,184.7 169.7,175.8 223.3,57 277,176.8 330.6,176.8 384.3,122.5 437.9,176.8 491.6,176.8 545.2,218.4 598.8,122.5 652.5,184.7 706.1,135.1 "\n                />\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',stackedArea:'\n            <svg\n                class="load-state stacked-area-load-state"\n                xmlns="http://www.w3.org/2000/svg"\n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path\n                    id="chart-bg"\n                    class="chart-bg"\n                    style="stroke:#C3C6CF;"\n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n                <g transform="translate(20 50)">\n                    <path\n                        id="chart-area"\n                        strokeLinecap="square"\n                        d="M0.34233103,0.593688165 L709.977885,0.593688189"\n                        transform="translate(.01 227.976)"\n                    />\n                    <path fill="#C3C6CF" d="M0.528124801,224.014648 L0.528124801,177.734375 L53.3834796,177.734375 C71.5390789,177.734375 86.8277373,168.972754 101.240241,151.662202 C112.578335,138.044258 121.139826,123.110227 136.974507,91.596773 C137.343842,90.8617404 139.300293,86.9654028 139.856735,85.8583549 C155.041692,55.6476711 163.354313,41.0906306 174.319873,27.7179171 C188.951312,9.87459412 204.885845,0.5 223.830634,0.5 C242.123071,0.5 257.291724,8.27027858 270.907992,23.1359289 C281.228683,34.4036118 289.135925,47.1272372 302.542017,72.085092 C303.275893,73.4513345 306.289669,79.0766612 307.063369,80.5168656 C321.41025,107.222876 330.088083,120.97663 341.470704,132.92446 C355.88994,148.05969 371.908861,155.792969 391.654853,155.792969 C412.142049,155.792969 428.763593,152.325614 442.880698,145.765582 C454.197328,140.506893 463.373931,133.679865 473.786035,123.626931 C476.528659,120.978915 486.44777,110.911455 488.791866,108.6483 C502.907223,95.0203436 514.194325,88.9355469 530.135322,88.9355469 C546.532652,88.9355469 559.505909,97.338499 575.973261,115.41103 C579.723508,119.526837 593.103621,135.086814 592.915496,134.871799 C605.09738,148.794859 614.368835,157.635549 625.072091,164.58539 C638.386599,173.230769 652.701021,177.734375 669.279853,177.734375 L673.779853,177.734375 L673.779853,224.014648 L0.528124801,224.014648 Z" />\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        '}}.call(n,e,n,t))||(t.exports=r)},,function(t,n,e){"use strict";var r;void 0===(r=function(t){var n=e(44),r=e(2),i=0,o={small:{limit:10,format:n.format("")},medium:{limit:1e3,format:n.format("")},large:{limit:null,format:n.format(".2s")}},u={small:{limit:10,format:n.format(".3f")},medium:{limit:100,format:n.format(".1f")},large:{limit:null,format:n.format(".2s")}},a=function(t,n){var e="large";return t<n.small.limit?e="small":t<n.medium.limit&&(e="medium"),e};return{calculatePercent:function(t,e,r){var i=e?t/e*100:0;return n.format(r)(i)},calcLinearRegression:function(t){var n=t.length,e=0,i=0,o=0,u=0;t.forEach((function(t){e+=t.x,i+=t.y,o+=t.x*t.y,u+=t.x*t.x}));var a=n*u-e*e,c=(i*u-e*o)/a,s=(n*o-e*i)/a,f=r.min(t,(function(t){return t.x})),l=r.max(t,(function(t){return t.x}));return{x1:f,y1:s*n+c,x2:l,y2:s*l+c}},isInteger:function(t){return t%1==0},formatDecimalValue:function(t){var n=a(t,u);return(0,u[n].format)(t)},formatIntegerValue:function(t){var n=a(t,o);return(0,o[n].format)(t)},uniqueId:function(t){var n=++i;return t.toString()+"-"+n}}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";e.d(n,"a",(function(){return _}));var r=e(11),i=e(7),o=e(67),u=-.14861,a=1.78277,c=-.29227,s=-.90649,f=1.97294,l=f*s,h=f*a,d=a*c-s*u;function p(t){if(t instanceof y)return new y(t.h,t.s,t.l,t.opacity);t instanceof i.b||(t=Object(i.h)(t));var n=t.r/255,e=t.g/255,r=t.b/255,u=(d*r+l*n-h*e)/(d+l-h),a=r-u,p=(f*(e-u)-c*a)/s,_=Math.sqrt(p*p+a*a)/(f*u*(1-u)),g=_?Math.atan2(p,a)*o.b-120:NaN;return new y(g<0?g+360:g,_,u,t.opacity)}function _(t,n,e,r){return 1===arguments.length?p(t):new y(t,n,e,null==r?1:r)}function y(t,n,e,r){this.h=+t,this.s=+n,this.l=+e,this.opacity=+r}Object(r.a)(y,_,Object(r.b)(i.a,{brighter:function(t){return t=null==t?i.c:Math.pow(i.c,t),new y(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?i.d:Math.pow(i.d,t),new y(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=isNaN(this.h)?0:(this.h+120)*o.a,n=+this.l,e=isNaN(this.s)?0:this.s*n*(1-n),r=Math.cos(t),l=Math.sin(t);return new i.b(255*(n+e*(u*r+a*l)),255*(n+e*(c*r+s*l)),255*(n+e*(f*r)),this.opacity)}}))},function(t,n,e){"use strict";var r;void 0===(r=function(t){var n=e(6),r=1.2,i=10,o=.9,u=.6,a="value",c="label",s=function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:12,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"Arial",r=document.createElement("canvas"),i=r.getContext("2d");return i.font=n+"px "+e,i.measureText(t).width};return{getTextWidth:s,wrapText:function(t,e,s,f){var l=n.select(f),h=l.text().split(/\s+/).reverse(),d=void 0,p=[],_=0,y=r*o,g=l.attr("y"),v=parseFloat(l.attr("dy")),m=e*u,x=l.text(null).append("tspan").attr("x",t).attr("y",g-5).attr("dy",v+"em").classed(a,!0).style("font-size",e+"px");for(x.text(h.pop()),x=l.append("tspan").classed(c,!0).attr("x",t).attr("y",g+i).attr("dy",++_*y+v+"em").style("font-size",m+"px");d=h.pop();)p.push(d),x.text(p.join(" ")),x.node()&&x.node().getComputedTextLength()>s-50&&(p.pop(),x.text(p.join(" ")),p=[d],x=l.append("tspan").classed(c,!0).attr("x",t).attr("y",g+i).attr("dy",++_*y+v+"em").text(d).style("font-size",m+"px"))},wrapTextWithEllipses:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2;t.each((function(){var o,u,a,c,s,f,l;for(o=(t=n.select(this)).text().split(/\s+/).reverse(),a=[],c=0,1.2,s=t.attr("y"),f=parseFloat(t.attr("dy")),l=t.text(null).append("tspan").attr("x",r).attr("y",s).attr("dy",f+"em");u=o.pop();)if(a.push(u),l.text(a.join(" ")),l.node()&&l.node().getComputedTextLength()>e){if(a.pop(),l.text(a.join(" ")),!(c<i-1)){a.push("..."),l.text(a.join(" "));break}a=[u],l=t.append("tspan").attr("x",r).attr("y",s).attr("dy",1.2*++c+f+"em").text(u),t.classed("adjust-upwards",!0)}}))},getApproximateNumberOfLines:function(t,n,e){var r=t.split(/\s+/).reverse(),i=[],o=1,u=!0,a=!1,c=void 0;try{for(var f,l=r[Symbol.iterator]();!(u=(f=l.next()).done);u=!0){var h=f.value;i.push(h),s(i.join(" "),n,"Karla, sans-serif")>e&&(i.pop(),i=[h],++o)}}catch(t){a=!0,c=t}finally{try{!u&&l.return&&l.return()}finally{if(a)throw c}}return o}}}.call(n,e,n,t))||(t.exports=r)},,,,,,,,,,function(t,n,e){"use strict";var r,i=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r])}return t};void 0===(r=function(t){var n=e(68),r=e(64),o=(e(44),e(41)),u=e(75),a=e(71),c=e(6),s=(e(72),e(76).exportChart),f=e(87),l=e(65),h=e(85).calculatePercent,d=e(70).emptyDonutData,p=e(83).donut;return function(){var t={top:0,right:0,bottom:0,left:0},e=300,_=300,y=p,g=r.easeCubicInOut,v=12,m=void 0,x=void 0,b=void 0,w=140,M=45.5,T=w+M,O=void 0,A=void 0,C=void 0,S=void 0,k=!1,N=!1,j=void 0,E=void 0,D=!1,F=!0,P=!1,L=null,I={emptySliceColor:"#EFF2F5",showEmptySlice:!1},U=".1f",R=void 0,q=void 0,H=l.colorSchemas.britecharts,B=function(t){return t.percentage+"% "+t.name},Y=function(t){this._current=t},z=function(t){t.outerRadius=w-v},G=function(t,n){return n.quantity-t.quantity},X=function(t){return t.quantity},V=function(t){var n=t.data;return q(n.name)},W=n.dispatch("customMouseOver","customMouseOut","customMouseMove","customClick");function $(n){n.each((function(n){x=e-t.left-t.right,b=_-t.top-t.bottom,m=function(t){var n=t.reduce((function(t,n){return void 0===n.quantity||null===n.quantity?t:(n.quantity=+n.quantity,n.name=String(n.name),n.percentage=n.percentage||null,[].concat(function(t){if(Array.isArray(t)){for(var n=0,e=Array(t.length);n<t.length;n++)e[n]=t[n];return e}return Array.from(t)}(t),[n]))}),[]),e=function(t){return t.reduce((function(t,n){return n.quantity+t}),0)}(n);0===e&&I.showEmptySlice&&(N=!0);return n.map((function(t){return t.percentage=String(t.percentage||h(t.quantity,e,U)),t}))}(n),O=a.pie().padAngle(0).value(X).sort(G),H&&(q=u.scaleOrdinal().range(H)),A=a.arc().innerRadius(M).padRadius(w),function(t){S||(S=c.select(t).append("svg").classed("britechart donut-chart",!0),function(){var t=S.append("g").classed("container-group",!0);t.append("g").classed("chart-group",!0),t.append("g").classed("legend-group",!0)}());S.select(".container-group").attr("transform","translate("+e/2+", "+_/2+")"),S.attr("width",e).attr("height",_)}(this),function(){C&&S.selectAll("g.arc").remove();var t=(C=S.select(".chart-group").selectAll("g.arc").data(O(m))).enter().append("g").each(Y).each(z).classed("arc",!0).append("path");k?t.merge(C).attr("fill",V).on("mouseover",(function(t){J(this,t,x,b)})).on("mousemove",(function(t){K(this,t,x,b)})).on("mouseout",(function(t){tt(this,t,x,b)})).on("click",(function(t){nt(this,t,x,b)})).transition().ease(g).duration(1200).attrTween("d",rt):t.merge(C).attr("fill",V).attr("d",A).on("mouseover",(function(t){J(this,t,x,b)})).on("mousemove",(function(t){K(this,t,x,b)})).on("mouseout",(function(t){tt(this,t,x,b)})).on("click",(function(t){nt(this,t,x,b)}));C.exit().remove()}(),S.select(".legend-group").append("text").attr("class","donut-text"),j&&(E=S.selectAll(".chart-group .arc path").select(Q).node())&&(Z(E.__data__),et(E,w,1200)),N&&I.showEmptySlice&&function(){C&&S.selectAll("g.arc").remove();(C=S.select(".chart-group").selectAll("g.arc").data(O(d))).enter().append("g").each(Y).each(z).classed("arc",!0).append("path").merge(C).attr("fill",I.emptySliceColor).attr("d",A).transition().ease(g).duration(1200).attrTween("d",rt),C.exit().remove()}()}))}function Z(t){t.data&&(S.select(".donut-text").text((function(){return B(t.data)})).attr("dy",".2em").attr("text-anchor","middle"),S.select(".donut-text").call(it,T))}function Q(t){if(t.data.id===j)return this}function J(t,n,e,r){Z(n),W.call("customMouseOver",t,n,c.mouse(t),[e,r]),F&&(L&&t!==L&&et(L,w-v,150),E&&t!==E&&et(E,w-v),et(t,w))}function K(t,n,e,r){W.call("customMouseMove",t,n,c.mouse(t),[e,r])}function tt(t,n,e,r){S.select(".donut-text").text(""),E&&D&&!P&&(Z(E.__data__),et(E,w)),(t!==E||!D&&t===E)&&et(t,w-v,150),P&&(Z(t.__data__),et(t,w),L=t),W.call("customMouseOut",t,n,c.mouse(t),[e,r])}function nt(t,n,e,r){W.call("customClick",t,n,c.mouse(t),[e,r])}function et(t,n){var e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;c.select(t).transition().delay(e).attrTween("d",(function(t){var e=o.interpolate(t.outerRadius,n);return function(n){return t.outerRadius=e(n),A(t)}}))}function rt(t){var n=void 0;return t.innerRadius=0,n=o.interpolate({startAngle:0,endAngle:0},t),function(t){return A(n(t))}}function it(t,n){var e=w/5;f.wrapText.call(null,0,e,n,t.node())}return $.centeredTextFunction=function(t){return arguments.length?(B=t,this):B},$.colorSchema=function(t){return arguments.length?(H=t,this):H},$.emptyDataConfig=function(t){return arguments.length?(I=t,this):I},$.exportChart=function(t,n){s.call($,S,t,n)},$.externalRadius=function(t){return arguments.length?(w=t,this):w},$.hasHoverAnimation=function(t){return arguments.length?(F=t,this):F},$.hasFixedHighlightedSlice=function(t){return arguments.length?(D=t,this):D},$.hasLastHoverSliceHighlighted=function(t){return arguments.length?(P=t,this):P},$.height=function(t){return arguments.length?(_=t,this):_},$.highlightSliceById=function(t){return arguments.length?(j=t,this):j},$.internalRadius=function(t){return arguments.length?(M=t,this):M},$.isAnimated=function(t){return arguments.length?(k=t,this):k},$.loadingState=function(t){return arguments.length?(y=t,this):y},$.margin=function(n){return arguments.length?(t=i({},t,n),this):t},$.numberFormat=function(t){return arguments.length?(R=t,this):R},$.on=function(){var t=W.on.apply(W,arguments);return t===W?$:t},$.orderingFunction=function(t){return arguments.length?(G=t,this):G},$.percentageFormat=function(t){return arguments.length?(U=t,this):U},$.radiusHoverOffset=function(t){return arguments.length?(v=t,this):v},$.width=function(t){return arguments.length?(e=t,this):e},$}}.call(n,e,n,t))||(t.exports=r)}])}));
//# sourceMappingURL=donut.min.js.map

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

!function(n,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.legend=t():(n.britecharts=n.britecharts||{},n.britecharts.legend=t())}(window,(function(){return function(n){var t={};function e(r){if(t[r])return t[r].exports;var i=t[r]={i:r,l:!1,exports:{}};return n[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}return e.m=n,e.c=t,e.d=function(n,t,r){e.o(n,t)||Object.defineProperty(n,t,{enumerable:!0,get:r})},e.r=function(n){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(n,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(n,"__esModule",{value:!0})},e.t=function(n,t){if(1&t&&(n=e(n)),8&t)return n;if(4&t&&"object"==typeof n&&n&&n.__esModule)return n;var r=Object.create(null);if(e.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:n}),2&t&&"string"!=typeof n)for(var i in n)e.d(r,i,function(t){return n[t]}.bind(null,i));return r},e.n=function(n){var t=n&&n.__esModule?function(){return n.default}:function(){return n};return e.d(t,"a",t),t},e.o=function(n,t){return Object.prototype.hasOwnProperty.call(n,t)},e.p="",e(e.s=100)}([function(n,t,e){"use strict";e.d(t,"a",(function(){return u}));var r=new Date,i=new Date;function u(n,t,e,o){function a(t){return n(t=0===arguments.length?new Date:new Date(+t)),t}return a.floor=function(t){return n(t=new Date(+t)),t},a.ceil=function(e){return n(e=new Date(e-1)),t(e,1),n(e),e},a.round=function(n){var t=a(n),e=a.ceil(n);return n-t<e-n?t:e},a.offset=function(n,e){return t(n=new Date(+n),null==e?1:Math.floor(e)),n},a.range=function(e,r,i){var u,o=[];if(e=a.ceil(e),i=null==i?1:Math.floor(i),!(e<r&&i>0))return o;do{o.push(u=new Date(+e)),t(e,i),n(e)}while(u<e&&e<r);return o},a.filter=function(e){return u((function(t){if(t>=t)for(;n(t),!e(t);)t.setTime(t-1)}),(function(n,r){if(n>=n)if(r<0)for(;++r<=0;)for(;t(n,-1),!e(n););else for(;--r>=0;)for(;t(n,1),!e(n););}))},e&&(a.count=function(t,u){return r.setTime(+t),i.setTime(+u),n(r),n(i),Math.floor(e(r,i))},a.every=function(n){return n=Math.floor(n),isFinite(n)&&n>0?n>1?a.filter(o?function(t){return o(t)%n==0}:function(t){return a.count(0,t)%n==0}):a:null}),a}},function(n,t,e){"use strict";e.d(t,"d",(function(){return r})),e.d(t,"c",(function(){return i})),e.d(t,"b",(function(){return u})),e.d(t,"a",(function(){return o})),e.d(t,"e",(function(){return a}));var r=1e3,i=6e4,u=36e5,o=864e5,a=6048e5},function(n,t,e){"use strict";e.r(t);var r=function(n,t){return n<t?-1:n>t?1:n>=t?0:NaN},i=function(n){var t;return 1===n.length&&(t=n,n=function(n,e){return r(t(n),e)}),{left:function(t,e,r,i){for(null==r&&(r=0),null==i&&(i=t.length);r<i;){var u=r+i>>>1;n(t[u],e)<0?r=u+1:i=u}return r},right:function(t,e,r,i){for(null==r&&(r=0),null==i&&(i=t.length);r<i;){var u=r+i>>>1;n(t[u],e)>0?i=u:r=u+1}return r}}};var u=i(r),o=u.right,a=u.left,c=o,l=function(n,t){null==t&&(t=f);for(var e=0,r=n.length-1,i=n[0],u=new Array(r<0?0:r);e<r;)u[e]=t(i,i=n[++e]);return u};function f(n,t){return[n,t]}var s=function(n,t,e){var r,i,u,o,a=n.length,c=t.length,l=new Array(a*c);for(null==e&&(e=f),r=u=0;r<a;++r)for(o=n[r],i=0;i<c;++i,++u)l[u]=e(o,t[i]);return l},h=function(n,t){return t<n?-1:t>n?1:t>=n?0:NaN},d=function(n){return null===n?NaN:+n},g=function(n,t){var e,r,i=n.length,u=0,o=-1,a=0,c=0;if(null==t)for(;++o<i;)isNaN(e=d(n[o]))||(c+=(r=e-a)*(e-(a+=r/++u)));else for(;++o<i;)isNaN(e=d(t(n[o],o,n)))||(c+=(r=e-a)*(e-(a+=r/++u)));if(u>1)return c/(u-1)},p=function(n,t){var e=g(n,t);return e?Math.sqrt(e):e},v=function(n,t){var e,r,i,u=n.length,o=-1;if(null==t){for(;++o<u;)if(null!=(e=n[o])&&e>=e)for(r=i=e;++o<u;)null!=(e=n[o])&&(r>e&&(r=e),i<e&&(i=e))}else for(;++o<u;)if(null!=(e=t(n[o],o,n))&&e>=e)for(r=i=e;++o<u;)null!=(e=t(n[o],o,n))&&(r>e&&(r=e),i<e&&(i=e));return[r,i]},y=Array.prototype,m=y.slice,b=y.map,w=function(n){return function(){return n}},_=function(n){return n},x=function(n,t,e){n=+n,t=+t,e=(i=arguments.length)<2?(t=n,n=0,1):i<3?1:+e;for(var r=-1,i=0|Math.max(0,Math.ceil((t-n)/e)),u=new Array(i);++r<i;)u[r]=n+r*e;return u},M=Math.sqrt(50),O=Math.sqrt(10),j=Math.sqrt(2),A=function(n,t,e){var r,i,u,o,a=-1;if(e=+e,(n=+n)===(t=+t)&&e>0)return[n];if((r=t<n)&&(i=n,n=t,t=i),0===(o=k(n,t,e))||!isFinite(o))return[];if(o>0)for(n=Math.ceil(n/o),t=Math.floor(t/o),u=new Array(i=Math.ceil(t-n+1));++a<i;)u[a]=(n+a)*o;else for(n=Math.floor(n*o),t=Math.ceil(t*o),u=new Array(i=Math.ceil(n-t+1));++a<i;)u[a]=(n-a)/o;return r&&u.reverse(),u};function k(n,t,e){var r=(t-n)/Math.max(0,e),i=Math.floor(Math.log(r)/Math.LN10),u=r/Math.pow(10,i);return i>=0?(u>=M?10:u>=O?5:u>=j?2:1)*Math.pow(10,i):-Math.pow(10,-i)/(u>=M?10:u>=O?5:u>=j?2:1)}function C(n,t,e){var r=Math.abs(t-n)/Math.max(0,e),i=Math.pow(10,Math.floor(Math.log(r)/Math.LN10)),u=r/i;return u>=M?i*=10:u>=O?i*=5:u>=j&&(i*=2),t<n?-i:i}var N=function(n){return Math.ceil(Math.log(n.length)/Math.LN2)+1},T=function(){var n=_,t=v,e=N;function r(r){var i,u,o=r.length,a=new Array(o);for(i=0;i<o;++i)a[i]=n(r[i],i,r);var l=t(a),f=l[0],s=l[1],h=e(a,f,s);Array.isArray(h)||(h=C(f,s,h),h=x(Math.ceil(f/h)*h,s,h));for(var d=h.length;h[0]<=f;)h.shift(),--d;for(;h[d-1]>s;)h.pop(),--d;var g,p=new Array(d+1);for(i=0;i<=d;++i)(g=p[i]=[]).x0=i>0?h[i-1]:f,g.x1=i<d?h[i]:s;for(i=0;i<o;++i)f<=(u=a[i])&&u<=s&&p[c(h,u,0,d)].push(r[i]);return p}return r.value=function(t){return arguments.length?(n="function"==typeof t?t:w(t),r):n},r.domain=function(n){return arguments.length?(t="function"==typeof n?n:w([n[0],n[1]]),r):t},r.thresholds=function(n){return arguments.length?(e="function"==typeof n?n:Array.isArray(n)?w(m.call(n)):w(n),r):e},r},S=function(n,t,e){if(null==e&&(e=d),r=n.length){if((t=+t)<=0||r<2)return+e(n[0],0,n);if(t>=1)return+e(n[r-1],r-1,n);var r,i=(r-1)*t,u=Math.floor(i),o=+e(n[u],u,n);return o+(+e(n[u+1],u+1,n)-o)*(i-u)}},D=function(n,t,e){return n=b.call(n,d).sort(r),Math.ceil((e-t)/(2*(S(n,.75)-S(n,.25))*Math.pow(n.length,-1/3)))},U=function(n,t,e){return Math.ceil((e-t)/(3.5*p(n)*Math.pow(n.length,-1/3)))},E=function(n,t){var e,r,i=n.length,u=-1;if(null==t){for(;++u<i;)if(null!=(e=n[u])&&e>=e)for(r=e;++u<i;)null!=(e=n[u])&&e>r&&(r=e)}else for(;++u<i;)if(null!=(e=t(n[u],u,n))&&e>=e)for(r=e;++u<i;)null!=(e=t(n[u],u,n))&&e>r&&(r=e);return r},F=function(n,t){var e,r=n.length,i=r,u=-1,o=0;if(null==t)for(;++u<r;)isNaN(e=d(n[u]))?--i:o+=e;else for(;++u<r;)isNaN(e=d(t(n[u],u,n)))?--i:o+=e;if(i)return o/i},P=function(n,t){var e,i=n.length,u=-1,o=[];if(null==t)for(;++u<i;)isNaN(e=d(n[u]))||o.push(e);else for(;++u<i;)isNaN(e=d(t(n[u],u,n)))||o.push(e);return S(o.sort(r),.5)},q=function(n){for(var t,e,r,i=n.length,u=-1,o=0;++u<i;)o+=n[u].length;for(e=new Array(o);--i>=0;)for(t=(r=n[i]).length;--t>=0;)e[--o]=r[t];return e},Y=function(n,t){var e,r,i=n.length,u=-1;if(null==t){for(;++u<i;)if(null!=(e=n[u])&&e>=e)for(r=e;++u<i;)null!=(e=n[u])&&r>e&&(r=e)}else for(;++u<i;)if(null!=(e=t(n[u],u,n))&&e>=e)for(r=e;++u<i;)null!=(e=t(n[u],u,n))&&r>e&&(r=e);return r},L=function(n,t){for(var e=t.length,r=new Array(e);e--;)r[e]=n[t[e]];return r},H=function(n,t){if(e=n.length){var e,i,u=0,o=0,a=n[o];for(null==t&&(t=r);++u<e;)(t(i=n[u],a)<0||0!==t(a,a))&&(a=i,o=u);return 0===t(a,a)?o:void 0}},z=function(n,t,e){for(var r,i,u=(null==e?n.length:e)-(t=null==t?0:+t);u;)i=Math.random()*u--|0,r=n[u+t],n[u+t]=n[i+t],n[i+t]=r;return n},B=function(n,t){var e,r=n.length,i=-1,u=0;if(null==t)for(;++i<r;)(e=+n[i])&&(u+=e);else for(;++i<r;)(e=+t(n[i],i,n))&&(u+=e);return u},I=function(n){if(!(i=n.length))return[];for(var t=-1,e=Y(n,$),r=new Array(e);++t<e;)for(var i,u=-1,o=r[t]=new Array(i);++u<i;)o[u]=n[u][t];return r};function $(n){return n.length}var R=function(){return I(arguments)};e.d(t,"bisect",(function(){return c})),e.d(t,"bisectRight",(function(){return o})),e.d(t,"bisectLeft",(function(){return a})),e.d(t,"ascending",(function(){return r})),e.d(t,"bisector",(function(){return i})),e.d(t,"cross",(function(){return s})),e.d(t,"descending",(function(){return h})),e.d(t,"deviation",(function(){return p})),e.d(t,"extent",(function(){return v})),e.d(t,"histogram",(function(){return T})),e.d(t,"thresholdFreedmanDiaconis",(function(){return D})),e.d(t,"thresholdScott",(function(){return U})),e.d(t,"thresholdSturges",(function(){return N})),e.d(t,"max",(function(){return E})),e.d(t,"mean",(function(){return F})),e.d(t,"median",(function(){return P})),e.d(t,"merge",(function(){return q})),e.d(t,"min",(function(){return Y})),e.d(t,"pairs",(function(){return l})),e.d(t,"permute",(function(){return L})),e.d(t,"quantile",(function(){return S})),e.d(t,"range",(function(){return x})),e.d(t,"scan",(function(){return H})),e.d(t,"shuffle",(function(){return z})),e.d(t,"sum",(function(){return B})),e.d(t,"ticks",(function(){return A})),e.d(t,"tickIncrement",(function(){return k})),e.d(t,"tickStep",(function(){return C})),e.d(t,"transpose",(function(){return I})),e.d(t,"variance",(function(){return g})),e.d(t,"zip",(function(){return R}))},function(n,t,e){"use strict";e.d(t,"g",(function(){return o})),e.d(t,"c",(function(){return a})),e.d(t,"k",(function(){return c})),e.d(t,"m",(function(){return l})),e.d(t,"i",(function(){return f})),e.d(t,"a",(function(){return s})),e.d(t,"e",(function(){return h})),e.d(t,"h",(function(){return d})),e.d(t,"d",(function(){return g})),e.d(t,"l",(function(){return p})),e.d(t,"n",(function(){return v})),e.d(t,"j",(function(){return y})),e.d(t,"b",(function(){return m})),e.d(t,"f",(function(){return b}));var r=e(0),i=e(1);function u(n){return Object(r.a)((function(t){t.setDate(t.getDate()-(t.getDay()+7-n)%7),t.setHours(0,0,0,0)}),(function(n,t){n.setDate(n.getDate()+7*t)}),(function(n,t){return(t-n-(t.getTimezoneOffset()-n.getTimezoneOffset())*i.c)/i.e}))}var o=u(0),a=u(1),c=u(2),l=u(3),f=u(4),s=u(5),h=u(6),d=o.range,g=a.range,p=c.range,v=l.range,y=f.range,m=s.range,b=h.range},function(n,t,e){"use strict";e.d(t,"g",(function(){return o})),e.d(t,"c",(function(){return a})),e.d(t,"k",(function(){return c})),e.d(t,"m",(function(){return l})),e.d(t,"i",(function(){return f})),e.d(t,"a",(function(){return s})),e.d(t,"e",(function(){return h})),e.d(t,"h",(function(){return d})),e.d(t,"d",(function(){return g})),e.d(t,"l",(function(){return p})),e.d(t,"n",(function(){return v})),e.d(t,"j",(function(){return y})),e.d(t,"b",(function(){return m})),e.d(t,"f",(function(){return b}));var r=e(0),i=e(1);function u(n){return Object(r.a)((function(t){t.setUTCDate(t.getUTCDate()-(t.getUTCDay()+7-n)%7),t.setUTCHours(0,0,0,0)}),(function(n,t){n.setUTCDate(n.getUTCDate()+7*t)}),(function(n,t){return(t-n)/i.e}))}var o=u(0),a=u(1),c=u(2),l=u(3),f=u(4),s=u(5),h=u(6),d=o.range,g=a.range,p=c.range,v=l.range,y=f.range,m=s.range,b=h.range},function(n,t,e){"use strict";t.a=function(n,t){return n=+n,t=+t,function(e){return n*(1-e)+t*e}}},function(n,t,e){"use strict";e.r(t);var r=e(12),i=e(32),u=function(n){return Object(i.a)(Object(r.a)(n).call(document.documentElement))},o=0;function a(){return new c}function c(){this._="@"+(++o).toString(36)}c.prototype=a.prototype={constructor:c,get:function(n){for(var t=this._;!(t in n);)if(!(n=n.parentNode))return;return n[t]},set:function(n,t){return n[this._]=t},remove:function(n){return this._ in n&&delete n[this._]},toString:function(){return this._}};var l=e(34),f=e(59),s=e(20),h=e(14),d=e(13),g=e(9),p=function(n){return"string"==typeof n?new g.a([document.querySelectorAll(n)],[document.documentElement]):new g.a([null==n?[]:n],g.c)},v=e(19),y=e(33),m=e(35),b=e(60),w=e(22),_=function(n,t){null==t&&(t=Object(w.a)().touches);for(var e=0,r=t?t.length:0,i=new Array(r);e<r;++e)i[e]=Object(d.a)(n,t[e]);return i},x=e(21),M=e(17);e.d(t,"create",(function(){return u})),e.d(t,"creator",(function(){return r.a})),e.d(t,"local",(function(){return a})),e.d(t,"matcher",(function(){return l.a})),e.d(t,"mouse",(function(){return f.a})),e.d(t,"namespace",(function(){return s.a})),e.d(t,"namespaces",(function(){return h.a})),e.d(t,"clientPoint",(function(){return d.a})),e.d(t,"select",(function(){return i.a})),e.d(t,"selectAll",(function(){return p})),e.d(t,"selection",(function(){return g.b})),e.d(t,"selector",(function(){return v.a})),e.d(t,"selectorAll",(function(){return y.a})),e.d(t,"style",(function(){return m.b})),e.d(t,"touch",(function(){return b.a})),e.d(t,"touches",(function(){return _})),e.d(t,"window",(function(){return x.a})),e.d(t,"event",(function(){return M.c})),e.d(t,"customEvent",(function(){return M.a}))},function(n,t,e){"use strict";e.d(t,"a",(function(){return i})),e.d(t,"d",(function(){return u})),e.d(t,"c",(function(){return o})),e.d(t,"e",(function(){return w})),e.d(t,"h",(function(){return M})),e.d(t,"g",(function(){return O})),e.d(t,"b",(function(){return j})),e.d(t,"f",(function(){return S}));var r=e(11);function i(){}var u=.7,o=1/u,a="\\s*([+-]?\\d+)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",l="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",f=/^#([0-9a-f]{3,8})$/,s=new RegExp("^rgb\\("+[a,a,a]+"\\)$"),h=new RegExp("^rgb\\("+[l,l,l]+"\\)$"),d=new RegExp("^rgba\\("+[a,a,a,c]+"\\)$"),g=new RegExp("^rgba\\("+[l,l,l,c]+"\\)$"),p=new RegExp("^hsl\\("+[c,l,l]+"\\)$"),v=new RegExp("^hsla\\("+[c,l,l,c]+"\\)$"),y={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};function m(){return this.rgb().formatHex()}function b(){return this.rgb().formatRgb()}function w(n){var t,e;return n=(n+"").trim().toLowerCase(),(t=f.exec(n))?(e=t[1].length,t=parseInt(t[1],16),6===e?_(t):3===e?new j(t>>8&15|t>>4&240,t>>4&15|240&t,(15&t)<<4|15&t,1):8===e?new j(t>>24&255,t>>16&255,t>>8&255,(255&t)/255):4===e?new j(t>>12&15|t>>8&240,t>>8&15|t>>4&240,t>>4&15|240&t,((15&t)<<4|15&t)/255):null):(t=s.exec(n))?new j(t[1],t[2],t[3],1):(t=h.exec(n))?new j(255*t[1]/100,255*t[2]/100,255*t[3]/100,1):(t=d.exec(n))?x(t[1],t[2],t[3],t[4]):(t=g.exec(n))?x(255*t[1]/100,255*t[2]/100,255*t[3]/100,t[4]):(t=p.exec(n))?N(t[1],t[2]/100,t[3]/100,1):(t=v.exec(n))?N(t[1],t[2]/100,t[3]/100,t[4]):y.hasOwnProperty(n)?_(y[n]):"transparent"===n?new j(NaN,NaN,NaN,0):null}function _(n){return new j(n>>16&255,n>>8&255,255&n,1)}function x(n,t,e,r){return r<=0&&(n=t=e=NaN),new j(n,t,e,r)}function M(n){return n instanceof i||(n=w(n)),n?new j((n=n.rgb()).r,n.g,n.b,n.opacity):new j}function O(n,t,e,r){return 1===arguments.length?M(n):new j(n,t,e,null==r?1:r)}function j(n,t,e,r){this.r=+n,this.g=+t,this.b=+e,this.opacity=+r}function A(){return"#"+C(this.r)+C(this.g)+C(this.b)}function k(){var n=this.opacity;return(1===(n=isNaN(n)?1:Math.max(0,Math.min(1,n)))?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===n?")":", "+n+")")}function C(n){return((n=Math.max(0,Math.min(255,Math.round(n)||0)))<16?"0":"")+n.toString(16)}function N(n,t,e,r){return r<=0?n=t=e=NaN:e<=0||e>=1?n=t=NaN:t<=0&&(n=NaN),new D(n,t,e,r)}function T(n){if(n instanceof D)return new D(n.h,n.s,n.l,n.opacity);if(n instanceof i||(n=w(n)),!n)return new D;if(n instanceof D)return n;var t=(n=n.rgb()).r/255,e=n.g/255,r=n.b/255,u=Math.min(t,e,r),o=Math.max(t,e,r),a=NaN,c=o-u,l=(o+u)/2;return c?(a=t===o?(e-r)/c+6*(e<r):e===o?(r-t)/c+2:(t-e)/c+4,c/=l<.5?o+u:2-o-u,a*=60):c=l>0&&l<1?0:a,new D(a,c,l,n.opacity)}function S(n,t,e,r){return 1===arguments.length?T(n):new D(n,t,e,null==r?1:r)}function D(n,t,e,r){this.h=+n,this.s=+t,this.l=+e,this.opacity=+r}function U(n,t,e){return 255*(n<60?t+(e-t)*n/60:n<180?e:n<240?t+(e-t)*(240-n)/60:t)}Object(r.a)(i,w,{copy:function(n){return Object.assign(new this.constructor,this,n)},displayable:function(){return this.rgb().displayable()},hex:m,formatHex:m,formatHsl:function(){return T(this).formatHsl()},formatRgb:b,toString:b}),Object(r.a)(j,O,Object(r.b)(i,{brighter:function(n){return n=null==n?o:Math.pow(o,n),new j(this.r*n,this.g*n,this.b*n,this.opacity)},darker:function(n){return n=null==n?u:Math.pow(u,n),new j(this.r*n,this.g*n,this.b*n,this.opacity)},rgb:function(){return this},displayable:function(){return-.5<=this.r&&this.r<255.5&&-.5<=this.g&&this.g<255.5&&-.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1},hex:A,formatHex:A,formatRgb:k,toString:k})),Object(r.a)(D,S,Object(r.b)(i,{brighter:function(n){return n=null==n?o:Math.pow(o,n),new D(this.h,this.s,this.l*n,this.opacity)},darker:function(n){return n=null==n?u:Math.pow(u,n),new D(this.h,this.s,this.l*n,this.opacity)},rgb:function(){var n=this.h%360+360*(this.h<0),t=isNaN(n)||isNaN(this.s)?0:this.s,e=this.l,r=e+(e<.5?e:1-e)*t,i=2*e-r;return new j(U(n>=240?n-240:n+120,i,r),U(n,i,r),U(n<120?n+240:n-120,i,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1},formatHsl:function(){var n=this.opacity;return(1===(n=isNaN(n)?1:Math.max(0,Math.min(1,n)))?"hsl(":"hsla(")+(this.h||0)+", "+100*(this.s||0)+"%, "+100*(this.l||0)+"%"+(1===n?")":", "+n+")")}}))},function(n,t,e){"use strict";var r=e(18);t.a=function(n){return(n=Object(r.a)(Math.abs(n)))?n[1]:NaN}},function(n,t,e){"use strict";var r=e(19),i=e(33),u=e(34),o=function(n){return new Array(n.length)};function a(n,t){this.ownerDocument=n.ownerDocument,this.namespaceURI=n.namespaceURI,this._next=null,this._parent=n,this.__data__=t}a.prototype={constructor:a,appendChild:function(n){return this._parent.insertBefore(n,this._next)},insertBefore:function(n,t){return this._parent.insertBefore(n,t)},querySelector:function(n){return this._parent.querySelector(n)},querySelectorAll:function(n){return this._parent.querySelectorAll(n)}};function c(n,t,e,r,i,u){for(var o,c=0,l=t.length,f=u.length;c<f;++c)(o=t[c])?(o.__data__=u[c],r[c]=o):e[c]=new a(n,u[c]);for(;c<l;++c)(o=t[c])&&(i[c]=o)}function l(n,t,e,r,i,u,o){var c,l,f,s={},h=t.length,d=u.length,g=new Array(h);for(c=0;c<h;++c)(l=t[c])&&(g[c]=f="$"+o.call(l,l.__data__,c,t),f in s?i[c]=l:s[f]=l);for(c=0;c<d;++c)(l=s[f="$"+o.call(n,u[c],c,u)])?(r[c]=l,l.__data__=u[c],s[f]=null):e[c]=new a(n,u[c]);for(c=0;c<h;++c)(l=t[c])&&s[g[c]]===l&&(i[c]=l)}function f(n,t){return n<t?-1:n>t?1:n>=t?0:NaN}var s=e(20);function h(n){return function(){this.removeAttribute(n)}}function d(n){return function(){this.removeAttributeNS(n.space,n.local)}}function g(n,t){return function(){this.setAttribute(n,t)}}function p(n,t){return function(){this.setAttributeNS(n.space,n.local,t)}}function v(n,t){return function(){var e=t.apply(this,arguments);null==e?this.removeAttribute(n):this.setAttribute(n,e)}}function y(n,t){return function(){var e=t.apply(this,arguments);null==e?this.removeAttributeNS(n.space,n.local):this.setAttributeNS(n.space,n.local,e)}}var m=e(35);function b(n){return function(){delete this[n]}}function w(n,t){return function(){this[n]=t}}function _(n,t){return function(){var e=t.apply(this,arguments);null==e?delete this[n]:this[n]=e}}function x(n){return n.trim().split(/^|\s+/)}function M(n){return n.classList||new O(n)}function O(n){this._node=n,this._names=x(n.getAttribute("class")||"")}function j(n,t){for(var e=M(n),r=-1,i=t.length;++r<i;)e.add(t[r])}function A(n,t){for(var e=M(n),r=-1,i=t.length;++r<i;)e.remove(t[r])}function k(n){return function(){j(this,n)}}function C(n){return function(){A(this,n)}}function N(n,t){return function(){(t.apply(this,arguments)?j:A)(this,n)}}O.prototype={add:function(n){this._names.indexOf(n)<0&&(this._names.push(n),this._node.setAttribute("class",this._names.join(" ")))},remove:function(n){var t=this._names.indexOf(n);t>=0&&(this._names.splice(t,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(n){return this._names.indexOf(n)>=0}};function T(){this.textContent=""}function S(n){return function(){this.textContent=n}}function D(n){return function(){var t=n.apply(this,arguments);this.textContent=null==t?"":t}}function U(){this.innerHTML=""}function E(n){return function(){this.innerHTML=n}}function F(n){return function(){var t=n.apply(this,arguments);this.innerHTML=null==t?"":t}}function P(){this.nextSibling&&this.parentNode.appendChild(this)}function q(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}var Y=e(12);function L(){return null}function H(){var n=this.parentNode;n&&n.removeChild(this)}function z(){var n=this.cloneNode(!1),t=this.parentNode;return t?t.insertBefore(n,this.nextSibling):n}function B(){var n=this.cloneNode(!0),t=this.parentNode;return t?t.insertBefore(n,this.nextSibling):n}var I=e(17),$=e(21);function R(n,t,e){var r=Object($.a)(n),i=r.CustomEvent;"function"==typeof i?i=new i(t,e):(i=r.document.createEvent("Event"),e?(i.initEvent(t,e.bubbles,e.cancelable),i.detail=e.detail):i.initEvent(t,!1,!1)),n.dispatchEvent(i)}function X(n,t){return function(){return R(this,n,t)}}function V(n,t){return function(){return R(this,n,t.apply(this,arguments))}}e.d(t,"c",(function(){return G})),e.d(t,"a",(function(){return W}));var G=[null];function W(n,t){this._groups=n,this._parents=t}function Z(){return new W([[document.documentElement]],G)}W.prototype=Z.prototype={constructor:W,select:function(n){"function"!=typeof n&&(n=Object(r.a)(n));for(var t=this._groups,e=t.length,i=new Array(e),u=0;u<e;++u)for(var o,a,c=t[u],l=c.length,f=i[u]=new Array(l),s=0;s<l;++s)(o=c[s])&&(a=n.call(o,o.__data__,s,c))&&("__data__"in o&&(a.__data__=o.__data__),f[s]=a);return new W(i,this._parents)},selectAll:function(n){"function"!=typeof n&&(n=Object(i.a)(n));for(var t=this._groups,e=t.length,r=[],u=[],o=0;o<e;++o)for(var a,c=t[o],l=c.length,f=0;f<l;++f)(a=c[f])&&(r.push(n.call(a,a.__data__,f,c)),u.push(a));return new W(r,u)},filter:function(n){"function"!=typeof n&&(n=Object(u.a)(n));for(var t=this._groups,e=t.length,r=new Array(e),i=0;i<e;++i)for(var o,a=t[i],c=a.length,l=r[i]=[],f=0;f<c;++f)(o=a[f])&&n.call(o,o.__data__,f,a)&&l.push(o);return new W(r,this._parents)},data:function(n,t){if(!n)return v=new Array(this.size()),h=-1,this.each((function(n){v[++h]=n})),v;var e,r=t?l:c,i=this._parents,u=this._groups;"function"!=typeof n&&(e=n,n=function(){return e});for(var o=u.length,a=new Array(o),f=new Array(o),s=new Array(o),h=0;h<o;++h){var d=i[h],g=u[h],p=g.length,v=n.call(d,d&&d.__data__,h,i),y=v.length,m=f[h]=new Array(y),b=a[h]=new Array(y);r(d,g,m,b,s[h]=new Array(p),v,t);for(var w,_,x=0,M=0;x<y;++x)if(w=m[x]){for(x>=M&&(M=x+1);!(_=b[M])&&++M<y;);w._next=_||null}}return(a=new W(a,i))._enter=f,a._exit=s,a},enter:function(){return new W(this._enter||this._groups.map(o),this._parents)},exit:function(){return new W(this._exit||this._groups.map(o),this._parents)},join:function(n,t,e){var r=this.enter(),i=this,u=this.exit();return r="function"==typeof n?n(r):r.append(n+""),null!=t&&(i=t(i)),null==e?u.remove():e(u),r&&i?r.merge(i).order():i},merge:function(n){for(var t=this._groups,e=n._groups,r=t.length,i=e.length,u=Math.min(r,i),o=new Array(r),a=0;a<u;++a)for(var c,l=t[a],f=e[a],s=l.length,h=o[a]=new Array(s),d=0;d<s;++d)(c=l[d]||f[d])&&(h[d]=c);for(;a<r;++a)o[a]=t[a];return new W(o,this._parents)},order:function(){for(var n=this._groups,t=-1,e=n.length;++t<e;)for(var r,i=n[t],u=i.length-1,o=i[u];--u>=0;)(r=i[u])&&(o&&4^r.compareDocumentPosition(o)&&o.parentNode.insertBefore(r,o),o=r);return this},sort:function(n){function t(t,e){return t&&e?n(t.__data__,e.__data__):!t-!e}n||(n=f);for(var e=this._groups,r=e.length,i=new Array(r),u=0;u<r;++u){for(var o,a=e[u],c=a.length,l=i[u]=new Array(c),s=0;s<c;++s)(o=a[s])&&(l[s]=o);l.sort(t)}return new W(i,this._parents).order()},call:function(){var n=arguments[0];return arguments[0]=this,n.apply(null,arguments),this},nodes:function(){var n=new Array(this.size()),t=-1;return this.each((function(){n[++t]=this})),n},node:function(){for(var n=this._groups,t=0,e=n.length;t<e;++t)for(var r=n[t],i=0,u=r.length;i<u;++i){var o=r[i];if(o)return o}return null},size:function(){var n=0;return this.each((function(){++n})),n},empty:function(){return!this.node()},each:function(n){for(var t=this._groups,e=0,r=t.length;e<r;++e)for(var i,u=t[e],o=0,a=u.length;o<a;++o)(i=u[o])&&n.call(i,i.__data__,o,u);return this},attr:function(n,t){var e=Object(s.a)(n);if(arguments.length<2){var r=this.node();return e.local?r.getAttributeNS(e.space,e.local):r.getAttribute(e)}return this.each((null==t?e.local?d:h:"function"==typeof t?e.local?y:v:e.local?p:g)(e,t))},style:m.a,property:function(n,t){return arguments.length>1?this.each((null==t?b:"function"==typeof t?_:w)(n,t)):this.node()[n]},classed:function(n,t){var e=x(n+"");if(arguments.length<2){for(var r=M(this.node()),i=-1,u=e.length;++i<u;)if(!r.contains(e[i]))return!1;return!0}return this.each(("function"==typeof t?N:t?k:C)(e,t))},text:function(n){return arguments.length?this.each(null==n?T:("function"==typeof n?D:S)(n)):this.node().textContent},html:function(n){return arguments.length?this.each(null==n?U:("function"==typeof n?F:E)(n)):this.node().innerHTML},raise:function(){return this.each(P)},lower:function(){return this.each(q)},append:function(n){var t="function"==typeof n?n:Object(Y.a)(n);return this.select((function(){return this.appendChild(t.apply(this,arguments))}))},insert:function(n,t){var e="function"==typeof n?n:Object(Y.a)(n),i=null==t?L:"function"==typeof t?t:Object(r.a)(t);return this.select((function(){return this.insertBefore(e.apply(this,arguments),i.apply(this,arguments)||null)}))},remove:function(){return this.each(H)},clone:function(n){return this.select(n?B:z)},datum:function(n){return arguments.length?this.property("__data__",n):this.node().__data__},on:I.b,dispatch:function(n,t){return this.each(("function"==typeof t?V:X)(n,t))}};t.b=Z},function(n,t,e){"use strict";e.d(t,"c",(function(){return u})),e.d(t,"b",(function(){return o})),e.d(t,"a",(function(){return a}));var r=e(23);function i(n,t){return function(e){return n+e*t}}function u(n,t){var e=t-n;return e?i(n,e>180||e<-180?e-360*Math.round(e/360):e):Object(r.a)(isNaN(n)?t:n)}function o(n){return 1==(n=+n)?a:function(t,e){return e-t?function(n,t,e){return n=Math.pow(n,e),t=Math.pow(t,e)-n,e=1/e,function(r){return Math.pow(n+r*t,e)}}(t,e,n):Object(r.a)(isNaN(t)?e:t)}}function a(n,t){var e=t-n;return e?i(n,e):Object(r.a)(isNaN(n)?t:n)}},function(n,t,e){"use strict";function r(n,t){var e=Object.create(n.prototype);for(var r in t)e[r]=t[r];return e}e.d(t,"b",(function(){return r})),t.a=function(n,t,e){n.prototype=t.prototype=e,e.constructor=n}},function(n,t,e){"use strict";var r=e(20),i=e(14);function u(n){return function(){var t=this.ownerDocument,e=this.namespaceURI;return e===i.b&&t.documentElement.namespaceURI===i.b?t.createElement(n):t.createElementNS(e,n)}}function o(n){return function(){return this.ownerDocument.createElementNS(n.space,n.local)}}t.a=function(n){var t=Object(r.a)(n);return(t.local?o:u)(t)}},function(n,t,e){"use strict";t.a=function(n,t){var e=n.ownerSVGElement||n;if(e.createSVGPoint){var r=e.createSVGPoint();return r.x=t.clientX,r.y=t.clientY,[(r=r.matrixTransform(n.getScreenCTM().inverse())).x,r.y]}var i=n.getBoundingClientRect();return[t.clientX-i.left-n.clientLeft,t.clientY-i.top-n.clientTop]}},function(n,t,e){"use strict";e.d(t,"b",(function(){return r}));var r="http://www.w3.org/1999/xhtml";t.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(n,t,e){"use strict";e.d(t,"b",(function(){return u}));var r=e(0),i=Object(r.a)((function(n){n.setMonth(0,1),n.setHours(0,0,0,0)}),(function(n,t){n.setFullYear(n.getFullYear()+t)}),(function(n,t){return t.getFullYear()-n.getFullYear()}),(function(n){return n.getFullYear()}));i.every=function(n){return isFinite(n=Math.floor(n))&&n>0?Object(r.a)((function(t){t.setFullYear(Math.floor(t.getFullYear()/n)*n),t.setMonth(0,1),t.setHours(0,0,0,0)}),(function(t,e){t.setFullYear(t.getFullYear()+e*n)})):null},t.a=i;var u=i.range},function(n,t,e){"use strict";e.d(t,"b",(function(){return u}));var r=e(0),i=Object(r.a)((function(n){n.setUTCMonth(0,1),n.setUTCHours(0,0,0,0)}),(function(n,t){n.setUTCFullYear(n.getUTCFullYear()+t)}),(function(n,t){return t.getUTCFullYear()-n.getUTCFullYear()}),(function(n){return n.getUTCFullYear()}));i.every=function(n){return isFinite(n=Math.floor(n))&&n>0?Object(r.a)((function(t){t.setUTCFullYear(Math.floor(t.getUTCFullYear()/n)*n),t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)}),(function(t,e){t.setUTCFullYear(t.getUTCFullYear()+e*n)})):null},t.a=i;var u=i.range},function(n,t,e){"use strict";e.d(t,"c",(function(){return i})),e.d(t,"a",(function(){return f}));var r={},i=null;"undefined"!=typeof document&&("onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"}));function u(n,t,e){return n=o(n,t,e),function(t){var e=t.relatedTarget;e&&(e===this||8&e.compareDocumentPosition(this))||n.call(this,t)}}function o(n,t,e){return function(r){var u=i;i=r;try{n.call(this,this.__data__,t,e)}finally{i=u}}}function a(n){return n.trim().split(/^|\s+/).map((function(n){var t="",e=n.indexOf(".");return e>=0&&(t=n.slice(e+1),n=n.slice(0,e)),{type:n,name:t}}))}function c(n){return function(){var t=this.__on;if(t){for(var e,r=0,i=-1,u=t.length;r<u;++r)e=t[r],n.type&&e.type!==n.type||e.name!==n.name?t[++i]=e:this.removeEventListener(e.type,e.listener,e.capture);++i?t.length=i:delete this.__on}}}function l(n,t,e){var i=r.hasOwnProperty(n.type)?u:o;return function(r,u,o){var a,c=this.__on,l=i(t,u,o);if(c)for(var f=0,s=c.length;f<s;++f)if((a=c[f]).type===n.type&&a.name===n.name)return this.removeEventListener(a.type,a.listener,a.capture),this.addEventListener(a.type,a.listener=l,a.capture=e),void(a.value=t);this.addEventListener(n.type,l,e),a={type:n.type,name:n.name,value:t,listener:l,capture:e},c?c.push(a):this.__on=[a]}}function f(n,t,e,r){var u=i;n.sourceEvent=i,i=n;try{return t.apply(e,r)}finally{i=u}}t.b=function(n,t,e){var r,i,u=a(n+""),o=u.length;if(!(arguments.length<2)){for(f=t?l:c,null==e&&(e=!1),r=0;r<o;++r)this.each(f(u[r],t,e));return this}var f=this.node().__on;if(f)for(var s,h=0,d=f.length;h<d;++h)for(r=0,s=f[h];r<o;++r)if((i=u[r]).type===s.type&&i.name===s.name)return s.value}},function(n,t,e){"use strict";t.a=function(n,t){if((e=(n=t?n.toExponential(t-1):n.toExponential()).indexOf("e"))<0)return null;var e,r=n.slice(0,e);return[r.length>1?r[0]+r.slice(2):r,+n.slice(e+1)]}},function(n,t,e){"use strict";function r(){}t.a=function(n){return null==n?r:function(){return this.querySelector(n)}}},function(n,t,e){"use strict";var r=e(14);t.a=function(n){var t=n+="",e=t.indexOf(":");return e>=0&&"xmlns"!==(t=n.slice(0,e))&&(n=n.slice(e+1)),r.a.hasOwnProperty(t)?{space:r.a[t],local:n}:n}},function(n,t,e){"use strict";t.a=function(n){return n.ownerDocument&&n.ownerDocument.defaultView||n.document&&n||n.defaultView}},function(n,t,e){"use strict";var r=e(17);t.a=function(){for(var n,t=r.c;n=t.sourceEvent;)t=n;return t}},function(n,t,e){"use strict";t.a=function(n){return function(){return n}}},function(n,t,e){"use strict";e.d(t,"b",(function(){return i})),e.d(t,"a",(function(){return u}));var r=/^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;function i(n){if(!(t=r.exec(n)))throw new Error("invalid format: "+n);var t;return new u({fill:t[1],align:t[2],sign:t[3],symbol:t[4],zero:t[5],width:t[6],comma:t[7],precision:t[8]&&t[8].slice(1),trim:t[9],type:t[10]})}function u(n){this.fill=void 0===n.fill?" ":n.fill+"",this.align=void 0===n.align?">":n.align+"",this.sign=void 0===n.sign?"-":n.sign+"",this.symbol=void 0===n.symbol?"":n.symbol+"",this.zero=!!n.zero,this.width=void 0===n.width?void 0:+n.width,this.comma=!!n.comma,this.precision=void 0===n.precision?void 0:+n.precision,this.trim=!!n.trim,this.type=void 0===n.type?"":n.type+""}i.prototype=u.prototype,u.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(void 0===this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(void 0===this.precision?"":"."+Math.max(0,0|this.precision))+(this.trim?"~":"")+this.type}},function(n,t,e){"use strict";function r(n){return ArrayBuffer.isView(n)&&!(n instanceof DataView)}e.d(t,"b",(function(){return r})),t.a=function(n,t){t||(t=[]);var e,r=n?Math.min(t.length,n.length):0,i=t.slice();return function(u){for(e=0;e<r;++e)i[e]=n[e]*(1-u)+t[e]*u;return i}}},function(n,t,e){"use strict";function r(n,t,e,r,i){var u=n*n,o=u*n;return((1-3*n+3*u-o)*t+(4-6*u+3*o)*e+(1+3*n+3*u-3*o)*r+o*i)/6}e.d(t,"a",(function(){return r})),t.b=function(n){var t=n.length-1;return function(e){var i=e<=0?e=0:e>=1?(e=1,t-1):Math.floor(e*t),u=n[i],o=n[i+1],a=i>0?n[i-1]:2*u-o,c=i<t-1?n[i+2]:2*o-u;return r((e-i/t)*t,a,u,o,c)}}},function(n,t,e){"use strict";e.d(t,"a",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(n){n.setHours(0,0,0,0)}),(function(n,t){n.setDate(n.getDate()+t)}),(function(n,t){return(t-n-(t.getTimezoneOffset()-n.getTimezoneOffset())*i.c)/i.a}),(function(n){return n.getDate()-1}));t.b=u;var o=u.range},function(n,t,e){"use strict";e.d(t,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(n){n.setUTCHours(0,0,0,0)}),(function(n,t){n.setUTCDate(n.getUTCDate()+t)}),(function(n,t){return(t-n)/i.a}),(function(n){return n.getUTCDate()-1}));t.a=u;var o=u.range},function(n,t,e){"use strict";function r(n){return n*n*n}function i(n){return--n*n*n+1}function u(n){return((n*=2)<=1?n*n*n:(n-=2)*n*n+2)/2}e.d(t,"a",(function(){return r})),e.d(t,"c",(function(){return i})),e.d(t,"b",(function(){return u}))},function(n,t,e){"use strict";e.d(t,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(n){n.setTime(n-n.getMilliseconds())}),(function(n,t){n.setTime(+n+t*i.d)}),(function(n,t){return(t-n)/i.d}),(function(n){return n.getUTCSeconds()}));t.a=u;var o=u.range},function(n,t,e){"use strict";e.d(t,"b",(function(){return u}));var r=e(0),i=Object(r.a)((function(){}),(function(n,t){n.setTime(+n+t)}),(function(n,t){return t-n}));i.every=function(n){return n=Math.floor(n),isFinite(n)&&n>0?n>1?Object(r.a)((function(t){t.setTime(Math.floor(t/n)*n)}),(function(t,e){t.setTime(+t+e*n)}),(function(t,e){return(e-t)/n})):i:null},t.a=i;var u=i.range},function(n,t,e){"use strict";var r=e(9);t.a=function(n){return"string"==typeof n?new r.a([[document.querySelector(n)]],[document.documentElement]):new r.a([[n]],r.c)}},function(n,t,e){"use strict";function r(){return[]}t.a=function(n){return null==n?r:function(){return this.querySelectorAll(n)}}},function(n,t,e){"use strict";t.a=function(n){return function(){return this.matches(n)}}},function(n,t,e){"use strict";e.d(t,"b",(function(){return a}));var r=e(21);function i(n){return function(){this.style.removeProperty(n)}}function u(n,t,e){return function(){this.style.setProperty(n,t,e)}}function o(n,t,e){return function(){var r=t.apply(this,arguments);null==r?this.style.removeProperty(n):this.style.setProperty(n,r,e)}}function a(n,t){return n.style.getPropertyValue(t)||Object(r.a)(n).getComputedStyle(n,null).getPropertyValue(t)}t.a=function(n,t,e){return arguments.length>1?this.each((null==t?i:"function"==typeof t?o:u)(n,t,null==e?"":e)):a(this.node(),n)}},function(n,t,e){"use strict";var r=e(7),i=e(39),u=e(57),o=e(56),a=e(5),c=e(58),l=e(55),f=e(23),s=e(25);t.a=function(n,t){var e,h=typeof t;return null==t||"boolean"===h?Object(f.a)(t):("number"===h?a.a:"string"===h?(e=Object(r.e)(t))?(t=e,i.a):l.a:t instanceof r.e?i.a:t instanceof Date?o.a:Object(s.b)(t)?s.a:Array.isArray(t)?u.b:"function"!=typeof t.valueOf&&"function"!=typeof t.toString||isNaN(t)?c.a:a.a)(n,t)}},function(n,t,e){"use strict";var r,i=e(8),u=e(24),o=e(18),a=function(n,t){var e=Object(o.a)(n,t);if(!e)return n+"";var r=e[0],i=e[1];return i<0?"0."+new Array(-i).join("0")+r:r.length>i+1?r.slice(0,i+1)+"."+r.slice(i+1):r+new Array(i-r.length+2).join("0")},c={"%":function(n,t){return(100*n).toFixed(t)},b:function(n){return Math.round(n).toString(2)},c:function(n){return n+""},d:function(n){return Math.round(n).toString(10)},e:function(n,t){return n.toExponential(t)},f:function(n,t){return n.toFixed(t)},g:function(n,t){return n.toPrecision(t)},o:function(n){return Math.round(n).toString(8)},p:function(n,t){return a(100*n,t)},r:a,s:function(n,t){var e=Object(o.a)(n,t);if(!e)return n+"";var i=e[0],u=e[1],a=u-(r=3*Math.max(-8,Math.min(8,Math.floor(u/3))))+1,c=i.length;return a===c?i:a>c?i+new Array(a-c+1).join("0"):a>0?i.slice(0,a)+"."+i.slice(a):"0."+new Array(1-a).join("0")+Object(o.a)(n,Math.max(0,t+a-1))[0]},X:function(n){return Math.round(n).toString(16).toUpperCase()},x:function(n){return Math.round(n).toString(16)}},l=function(n){return n},f=Array.prototype.map,s=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];t.a=function(n){var t,e,o=void 0===n.grouping||void 0===n.thousands?l:(t=f.call(n.grouping,Number),e=n.thousands+"",function(n,r){for(var i=n.length,u=[],o=0,a=t[0],c=0;i>0&&a>0&&(c+a+1>r&&(a=Math.max(1,r-c)),u.push(n.substring(i-=a,i+a)),!((c+=a+1)>r));)a=t[o=(o+1)%t.length];return u.reverse().join(e)}),a=void 0===n.currency?"":n.currency[0]+"",h=void 0===n.currency?"":n.currency[1]+"",d=void 0===n.decimal?".":n.decimal+"",g=void 0===n.numerals?l:function(n){return function(t){return t.replace(/[0-9]/g,(function(t){return n[+t]}))}}(f.call(n.numerals,String)),p=void 0===n.percent?"%":n.percent+"",v=void 0===n.minus?"-":n.minus+"",y=void 0===n.nan?"NaN":n.nan+"";function m(n){var t=(n=Object(u.b)(n)).fill,e=n.align,i=n.sign,l=n.symbol,f=n.zero,m=n.width,b=n.comma,w=n.precision,_=n.trim,x=n.type;"n"===x?(b=!0,x="g"):c[x]||(void 0===w&&(w=12),_=!0,x="g"),(f||"0"===t&&"="===e)&&(f=!0,t="0",e="=");var M="$"===l?a:"#"===l&&/[boxX]/.test(x)?"0"+x.toLowerCase():"",O="$"===l?h:/[%p]/.test(x)?p:"",j=c[x],A=/[defgprs%]/.test(x);function k(n){var u,a,c,l=M,h=O;if("c"===x)h=j(n)+h,n="";else{var p=(n=+n)<0;if(n=isNaN(n)?y:j(Math.abs(n),w),_&&(n=function(n){n:for(var t,e=n.length,r=1,i=-1;r<e;++r)switch(n[r]){case".":i=t=r;break;case"0":0===i&&(i=r),t=r;break;default:if(!+n[r])break n;i>0&&(i=0)}return i>0?n.slice(0,i)+n.slice(t+1):n}(n)),p&&0==+n&&(p=!1),l=(p?"("===i?i:v:"-"===i||"("===i?"":i)+l,h=("s"===x?s[8+r/3]:"")+h+(p&&"("===i?")":""),A)for(u=-1,a=n.length;++u<a;)if(48>(c=n.charCodeAt(u))||c>57){h=(46===c?d+n.slice(u+1):n.slice(u))+h,n=n.slice(0,u);break}}b&&!f&&(n=o(n,1/0));var k=l.length+n.length+h.length,C=k<m?new Array(m-k+1).join(t):"";switch(b&&f&&(n=o(C+n,C.length?m-h.length:1/0),C=""),e){case"<":n=l+n+h+C;break;case"=":n=l+C+n+h;break;case"^":n=C.slice(0,k=C.length>>1)+l+n+h+C.slice(k);break;default:n=C+l+n+h}return g(n)}return w=void 0===w?6:/[gprs]/.test(x)?Math.max(1,Math.min(21,w)):Math.max(0,Math.min(20,w)),k.toString=function(){return n+""},k}return{format:m,formatPrefix:function(n,t){var e=m(((n=Object(u.b)(n)).type="f",n)),r=3*Math.max(-8,Math.min(8,Math.floor(Object(i.a)(t)/3))),o=Math.pow(10,-r),a=s[8+r/3];return function(n){return e(o*n)+a}}}}},,function(n,t,e){"use strict";e.d(t,"b",(function(){return c})),e.d(t,"c",(function(){return l}));var r=e(7),i=e(26),u=e(53),o=e(10);function a(n){return function(t){var e,i,u=t.length,o=new Array(u),a=new Array(u),c=new Array(u);for(e=0;e<u;++e)i=Object(r.g)(t[e]),o[e]=i.r||0,a[e]=i.g||0,c[e]=i.b||0;return o=n(o),a=n(a),c=n(c),i.opacity=1,function(n){return i.r=o(n),i.g=a(n),i.b=c(n),i+""}}}t.a=function n(t){var e=Object(o.b)(t);function i(n,t){var i=e((n=Object(r.g)(n)).r,(t=Object(r.g)(t)).r),u=e(n.g,t.g),a=e(n.b,t.b),c=Object(o.a)(n.opacity,t.opacity);return function(t){return n.r=i(t),n.g=u(t),n.b=a(t),n.opacity=c(t),n+""}}return i.gamma=n,i}(1);var c=a(i.b),l=a(u.a)},function(n,t,e){"use strict";e.d(t,"b",(function(){return i})),e.d(t,"c",(function(){return u})),e.d(t,"a",(function(){return a}));var r,i,u,o=e(37);function a(n){return r=Object(o.a)(n),i=r.format,u=r.formatPrefix,r}a({decimal:".",thousands:",",grouping:[3],currency:["$",""],minus:"-"})},,,,function(n,t,e){"use strict";e.r(t);var r=e(40);e.d(t,"formatDefaultLocale",(function(){return r.a})),e.d(t,"format",(function(){return r.b})),e.d(t,"formatPrefix",(function(){return r.c}));var i=e(37);e.d(t,"formatLocale",(function(){return i.a}));var u=e(24);e.d(t,"formatSpecifier",(function(){return u.b})),e.d(t,"FormatSpecifier",(function(){return u.a}));var o=e(61);e.d(t,"precisionFixed",(function(){return o.a}));var a=e(62);e.d(t,"precisionPrefix",(function(){return a.a}));var c=e(63);e.d(t,"precisionRound",(function(){return c.a}))},function(n,t,e){"use strict";e.r(t);function r(){}function i(n,t){var e=new r;if(n instanceof r)n.each((function(n,t){e.set(t,n)}));else if(Array.isArray(n)){var i,u=-1,o=n.length;if(null==t)for(;++u<o;)e.set(u,n[u]);else for(;++u<o;)e.set(t(i=n[u],u,n),i)}else if(n)for(var a in n)e.set(a,n[a]);return e}r.prototype=i.prototype={constructor:r,has:function(n){return"$"+n in this},get:function(n){return this["$"+n]},set:function(n,t){return this["$"+n]=t,this},remove:function(n){var t="$"+n;return t in this&&delete this[t]},clear:function(){for(var n in this)"$"===n[0]&&delete this[n]},keys:function(){var n=[];for(var t in this)"$"===t[0]&&n.push(t.slice(1));return n},values:function(){var n=[];for(var t in this)"$"===t[0]&&n.push(this[t]);return n},entries:function(){var n=[];for(var t in this)"$"===t[0]&&n.push({key:t.slice(1),value:this[t]});return n},size:function(){var n=0;for(var t in this)"$"===t[0]&&++n;return n},empty:function(){for(var n in this)if("$"===n[0])return!1;return!0},each:function(n){for(var t in this)"$"===t[0]&&n(this[t],t.slice(1),this)}};var u=i,o=function(){var n,t,e,r=[],i=[];function o(e,i,a,c){if(i>=r.length)return null!=n&&e.sort(n),null!=t?t(e):e;for(var l,f,s,h=-1,d=e.length,g=r[i++],p=u(),v=a();++h<d;)(s=p.get(l=g(f=e[h])+""))?s.push(f):p.set(l,[f]);return p.each((function(n,t){c(v,t,o(n,i,a,c))})),v}return e={object:function(n){return o(n,0,a,c)},map:function(n){return o(n,0,l,f)},entries:function(n){return function n(e,u){if(++u>r.length)return e;var o,a=i[u-1];return null!=t&&u>=r.length?o=e.entries():(o=[],e.each((function(t,e){o.push({key:e,values:n(t,u)})}))),null!=a?o.sort((function(n,t){return a(n.key,t.key)})):o}(o(n,0,l,f),0)},key:function(n){return r.push(n),e},sortKeys:function(n){return i[r.length-1]=n,e},sortValues:function(t){return n=t,e},rollup:function(n){return t=n,e}}};function a(){return{}}function c(n,t,e){n[t]=e}function l(){return u()}function f(n,t,e){n.set(t,e)}function s(){}var h=u.prototype;function d(n,t){var e=new s;if(n instanceof s)n.each((function(n){e.add(n)}));else if(n){var r=-1,i=n.length;if(null==t)for(;++r<i;)e.add(n[r]);else for(;++r<i;)e.add(t(n[r],r,n))}return e}s.prototype=d.prototype={constructor:s,has:h.has,add:function(n){return this["$"+(n+="")]=n,this},remove:h.remove,clear:h.clear,values:h.keys,size:h.size,empty:h.empty,each:h.each};var g=d,p=function(n){var t=[];for(var e in n)t.push(e);return t},v=function(n){var t=[];for(var e in n)t.push(n[e]);return t},y=function(n){var t=[];for(var e in n)t.push({key:e,value:n[e]});return t};e.d(t,"nest",(function(){return o})),e.d(t,"set",(function(){return g})),e.d(t,"map",(function(){return u})),e.d(t,"keys",(function(){return p})),e.d(t,"values",(function(){return v})),e.d(t,"entries",(function(){return y}))},function(n,t,e){"use strict";e.d(t,"b",(function(){return i})),e.d(t,"c",(function(){return u})),e.d(t,"d",(function(){return o})),e.d(t,"e",(function(){return a})),e.d(t,"a",(function(){return l}));var r,i,u,o,a,c=e(54);function l(n){return r=Object(c.a)(n),i=r.format,u=r.parse,o=r.utcFormat,a=r.utcParse,r}l({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(n,t,e){"use strict";e.d(t,"b",(function(){return u}));var r=e(0),i=Object(r.a)((function(n){n.setDate(1),n.setHours(0,0,0,0)}),(function(n,t){n.setMonth(n.getMonth()+t)}),(function(n,t){return t.getMonth()-n.getMonth()+12*(t.getFullYear()-n.getFullYear())}),(function(n){return n.getMonth()}));t.a=i;var u=i.range},function(n,t,e){"use strict";e.d(t,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(n){n.setTime(n-n.getMilliseconds()-n.getSeconds()*i.d-n.getMinutes()*i.c)}),(function(n,t){n.setTime(+n+t*i.b)}),(function(n,t){return(t-n)/i.b}),(function(n){return n.getHours()}));t.a=u;var o=u.range},function(n,t,e){"use strict";e.d(t,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(n){n.setTime(n-n.getMilliseconds()-n.getSeconds()*i.d)}),(function(n,t){n.setTime(+n+t*i.c)}),(function(n,t){return(t-n)/i.c}),(function(n){return n.getMinutes()}));t.a=u;var o=u.range},function(n,t,e){"use strict";e.d(t,"b",(function(){return u}));var r=e(0),i=Object(r.a)((function(n){n.setUTCDate(1),n.setUTCHours(0,0,0,0)}),(function(n,t){n.setUTCMonth(n.getUTCMonth()+t)}),(function(n,t){return t.getUTCMonth()-n.getUTCMonth()+12*(t.getUTCFullYear()-n.getUTCFullYear())}),(function(n){return n.getUTCMonth()}));t.a=i;var u=i.range},function(n,t,e){"use strict";e.d(t,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(n){n.setUTCMinutes(0,0,0)}),(function(n,t){n.setTime(+n+t*i.b)}),(function(n,t){return(t-n)/i.b}),(function(n){return n.getUTCHours()}));t.a=u;var o=u.range},function(n,t,e){"use strict";e.d(t,"b",(function(){return o}));var r=e(0),i=e(1),u=Object(r.a)((function(n){n.setUTCSeconds(0,0)}),(function(n,t){n.setTime(+n+t*i.c)}),(function(n,t){return(t-n)/i.c}),(function(n){return n.getUTCMinutes()}));t.a=u;var o=u.range},function(n,t,e){"use strict";var r=e(26);t.a=function(n){var t=n.length;return function(e){var i=Math.floor(((e%=1)<0?++e:e)*t),u=n[(i+t-1)%t],o=n[i%t],a=n[(i+1)%t],c=n[(i+2)%t];return Object(r.a)((e-i/t)*t,u,o,a,c)}}},function(n,t,e){"use strict";e.d(t,"a",(function(){return h}));var r=e(4),i=e(28),u=e(3),o=e(27),a=e(15),c=e(16);function l(n){if(0<=n.y&&n.y<100){var t=new Date(-1,n.m,n.d,n.H,n.M,n.S,n.L);return t.setFullYear(n.y),t}return new Date(n.y,n.m,n.d,n.H,n.M,n.S,n.L)}function f(n){if(0<=n.y&&n.y<100){var t=new Date(Date.UTC(-1,n.m,n.d,n.H,n.M,n.S,n.L));return t.setUTCFullYear(n.y),t}return new Date(Date.UTC(n.y,n.m,n.d,n.H,n.M,n.S,n.L))}function s(n,t,e){return{y:n,m:t,d:e,H:0,M:0,S:0,L:0}}function h(n){var t=n.dateTime,e=n.date,a=n.time,c=n.periods,h=n.days,g=n.shortDays,p=n.months,v=n.shortMonths,y=b(c),m=w(c),jn=b(h),An=w(h),kn=b(g),Cn=w(g),Nn=b(p),Tn=w(p),Sn=b(v),Dn=w(v),Un={a:function(n){return g[n.getDay()]},A:function(n){return h[n.getDay()]},b:function(n){return v[n.getMonth()]},B:function(n){return p[n.getMonth()]},c:null,d:z,e:z,f:X,H:B,I:I,j:$,L:R,m:V,M:G,p:function(n){return c[+(n.getHours()>=12)]},q:function(n){return 1+~~(n.getMonth()/3)},Q:Mn,s:On,S:W,u:Z,U:Q,V:J,w:K,W:nn,x:null,X:null,y:tn,Y:en,Z:rn,"%":xn},En={a:function(n){return g[n.getUTCDay()]},A:function(n){return h[n.getUTCDay()]},b:function(n){return v[n.getUTCMonth()]},B:function(n){return p[n.getUTCMonth()]},c:null,d:un,e:un,f:fn,H:on,I:an,j:cn,L:ln,m:sn,M:hn,p:function(n){return c[+(n.getUTCHours()>=12)]},q:function(n){return 1+~~(n.getUTCMonth()/3)},Q:Mn,s:On,S:dn,u:gn,U:pn,V:vn,w:yn,W:mn,x:null,X:null,y:bn,Y:wn,Z:_n,"%":xn},Fn={a:function(n,t,e){var r=kn.exec(t.slice(e));return r?(n.w=Cn[r[0].toLowerCase()],e+r[0].length):-1},A:function(n,t,e){var r=jn.exec(t.slice(e));return r?(n.w=An[r[0].toLowerCase()],e+r[0].length):-1},b:function(n,t,e){var r=Sn.exec(t.slice(e));return r?(n.m=Dn[r[0].toLowerCase()],e+r[0].length):-1},B:function(n,t,e){var r=Nn.exec(t.slice(e));return r?(n.m=Tn[r[0].toLowerCase()],e+r[0].length):-1},c:function(n,e,r){return Yn(n,t,e,r)},d:S,e:S,f:q,H:U,I:U,j:D,L:P,m:T,M:E,p:function(n,t,e){var r=y.exec(t.slice(e));return r?(n.p=m[r[0].toLowerCase()],e+r[0].length):-1},q:N,Q:L,s:H,S:F,u:x,U:M,V:O,w:_,W:j,x:function(n,t,r){return Yn(n,e,t,r)},X:function(n,t,e){return Yn(n,a,t,e)},y:k,Y:A,Z:C,"%":Y};function Pn(n,t){return function(e){var r,i,u,o=[],a=-1,c=0,l=n.length;for(e instanceof Date||(e=new Date(+e));++a<l;)37===n.charCodeAt(a)&&(o.push(n.slice(c,a)),null!=(i=d[r=n.charAt(++a)])?r=n.charAt(++a):i="e"===r?" ":"0",(u=t[r])&&(r=u(e,i)),o.push(r),c=a+1);return o.push(n.slice(c,a)),o.join("")}}function qn(n,t){return function(e){var a,c,h=s(1900,void 0,1);if(Yn(h,n,e+="",0)!=e.length)return null;if("Q"in h)return new Date(h.Q);if("s"in h)return new Date(1e3*h.s+("L"in h?h.L:0));if(!t||"Z"in h||(h.Z=0),"p"in h&&(h.H=h.H%12+12*h.p),void 0===h.m&&(h.m="q"in h?h.q:0),"V"in h){if(h.V<1||h.V>53)return null;"w"in h||(h.w=1),"Z"in h?(c=(a=f(s(h.y,0,1))).getUTCDay(),a=c>4||0===c?r.c.ceil(a):Object(r.c)(a),a=i.a.offset(a,7*(h.V-1)),h.y=a.getUTCFullYear(),h.m=a.getUTCMonth(),h.d=a.getUTCDate()+(h.w+6)%7):(c=(a=l(s(h.y,0,1))).getDay(),a=c>4||0===c?u.c.ceil(a):Object(u.c)(a),a=o.b.offset(a,7*(h.V-1)),h.y=a.getFullYear(),h.m=a.getMonth(),h.d=a.getDate()+(h.w+6)%7)}else("W"in h||"U"in h)&&("w"in h||(h.w="u"in h?h.u%7:"W"in h?1:0),c="Z"in h?f(s(h.y,0,1)).getUTCDay():l(s(h.y,0,1)).getDay(),h.m=0,h.d="W"in h?(h.w+6)%7+7*h.W-(c+5)%7:h.w+7*h.U-(c+6)%7);return"Z"in h?(h.H+=h.Z/100|0,h.M+=h.Z%100,f(h)):l(h)}}function Yn(n,t,e,r){for(var i,u,o=0,a=t.length,c=e.length;o<a;){if(r>=c)return-1;if(37===(i=t.charCodeAt(o++))){if(i=t.charAt(o++),!(u=Fn[i in d?t.charAt(o++):i])||(r=u(n,e,r))<0)return-1}else if(i!=e.charCodeAt(r++))return-1}return r}return(Un.x=Pn(e,Un),Un.X=Pn(a,Un),Un.c=Pn(t,Un),En.x=Pn(e,En),En.X=Pn(a,En),En.c=Pn(t,En),{format:function(n){var t=Pn(n+="",Un);return t.toString=function(){return n},t},parse:function(n){var t=qn(n+="",!1);return t.toString=function(){return n},t},utcFormat:function(n){var t=Pn(n+="",En);return t.toString=function(){return n},t},utcParse:function(n){var t=qn(n+="",!0);return t.toString=function(){return n},t}})}var d={"-":"",_:" ",0:"0"},g=/^\s*\d+/,p=/^%/,v=/[\\^$*+?|[\]().{}]/g;function y(n,t,e){var r=n<0?"-":"",i=(r?-n:n)+"",u=i.length;return r+(u<e?new Array(e-u+1).join(t)+i:i)}function m(n){return n.replace(v,"\\$&")}function b(n){return new RegExp("^(?:"+n.map(m).join("|")+")","i")}function w(n){for(var t={},e=-1,r=n.length;++e<r;)t[n[e].toLowerCase()]=e;return t}function _(n,t,e){var r=g.exec(t.slice(e,e+1));return r?(n.w=+r[0],e+r[0].length):-1}function x(n,t,e){var r=g.exec(t.slice(e,e+1));return r?(n.u=+r[0],e+r[0].length):-1}function M(n,t,e){var r=g.exec(t.slice(e,e+2));return r?(n.U=+r[0],e+r[0].length):-1}function O(n,t,e){var r=g.exec(t.slice(e,e+2));return r?(n.V=+r[0],e+r[0].length):-1}function j(n,t,e){var r=g.exec(t.slice(e,e+2));return r?(n.W=+r[0],e+r[0].length):-1}function A(n,t,e){var r=g.exec(t.slice(e,e+4));return r?(n.y=+r[0],e+r[0].length):-1}function k(n,t,e){var r=g.exec(t.slice(e,e+2));return r?(n.y=+r[0]+(+r[0]>68?1900:2e3),e+r[0].length):-1}function C(n,t,e){var r=/^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(e,e+6));return r?(n.Z=r[1]?0:-(r[2]+(r[3]||"00")),e+r[0].length):-1}function N(n,t,e){var r=g.exec(t.slice(e,e+1));return r?(n.q=3*r[0]-3,e+r[0].length):-1}function T(n,t,e){var r=g.exec(t.slice(e,e+2));return r?(n.m=r[0]-1,e+r[0].length):-1}function S(n,t,e){var r=g.exec(t.slice(e,e+2));return r?(n.d=+r[0],e+r[0].length):-1}function D(n,t,e){var r=g.exec(t.slice(e,e+3));return r?(n.m=0,n.d=+r[0],e+r[0].length):-1}function U(n,t,e){var r=g.exec(t.slice(e,e+2));return r?(n.H=+r[0],e+r[0].length):-1}function E(n,t,e){var r=g.exec(t.slice(e,e+2));return r?(n.M=+r[0],e+r[0].length):-1}function F(n,t,e){var r=g.exec(t.slice(e,e+2));return r?(n.S=+r[0],e+r[0].length):-1}function P(n,t,e){var r=g.exec(t.slice(e,e+3));return r?(n.L=+r[0],e+r[0].length):-1}function q(n,t,e){var r=g.exec(t.slice(e,e+6));return r?(n.L=Math.floor(r[0]/1e3),e+r[0].length):-1}function Y(n,t,e){var r=p.exec(t.slice(e,e+1));return r?e+r[0].length:-1}function L(n,t,e){var r=g.exec(t.slice(e));return r?(n.Q=+r[0],e+r[0].length):-1}function H(n,t,e){var r=g.exec(t.slice(e));return r?(n.s=+r[0],e+r[0].length):-1}function z(n,t){return y(n.getDate(),t,2)}function B(n,t){return y(n.getHours(),t,2)}function I(n,t){return y(n.getHours()%12||12,t,2)}function $(n,t){return y(1+o.b.count(Object(a.a)(n),n),t,3)}function R(n,t){return y(n.getMilliseconds(),t,3)}function X(n,t){return R(n,t)+"000"}function V(n,t){return y(n.getMonth()+1,t,2)}function G(n,t){return y(n.getMinutes(),t,2)}function W(n,t){return y(n.getSeconds(),t,2)}function Z(n){var t=n.getDay();return 0===t?7:t}function Q(n,t){return y(u.g.count(Object(a.a)(n)-1,n),t,2)}function J(n,t){var e=n.getDay();return n=e>=4||0===e?Object(u.i)(n):u.i.ceil(n),y(u.i.count(Object(a.a)(n),n)+(4===Object(a.a)(n).getDay()),t,2)}function K(n){return n.getDay()}function nn(n,t){return y(u.c.count(Object(a.a)(n)-1,n),t,2)}function tn(n,t){return y(n.getFullYear()%100,t,2)}function en(n,t){return y(n.getFullYear()%1e4,t,4)}function rn(n){var t=n.getTimezoneOffset();return(t>0?"-":(t*=-1,"+"))+y(t/60|0,"0",2)+y(t%60,"0",2)}function un(n,t){return y(n.getUTCDate(),t,2)}function on(n,t){return y(n.getUTCHours(),t,2)}function an(n,t){return y(n.getUTCHours()%12||12,t,2)}function cn(n,t){return y(1+i.a.count(Object(c.a)(n),n),t,3)}function ln(n,t){return y(n.getUTCMilliseconds(),t,3)}function fn(n,t){return ln(n,t)+"000"}function sn(n,t){return y(n.getUTCMonth()+1,t,2)}function hn(n,t){return y(n.getUTCMinutes(),t,2)}function dn(n,t){return y(n.getUTCSeconds(),t,2)}function gn(n){var t=n.getUTCDay();return 0===t?7:t}function pn(n,t){return y(r.g.count(Object(c.a)(n)-1,n),t,2)}function vn(n,t){var e=n.getUTCDay();return n=e>=4||0===e?Object(r.i)(n):r.i.ceil(n),y(r.i.count(Object(c.a)(n),n)+(4===Object(c.a)(n).getUTCDay()),t,2)}function yn(n){return n.getUTCDay()}function mn(n,t){return y(r.c.count(Object(c.a)(n)-1,n),t,2)}function bn(n,t){return y(n.getUTCFullYear()%100,t,2)}function wn(n,t){return y(n.getUTCFullYear()%1e4,t,4)}function _n(){return"+0000"}function xn(){return"%"}function Mn(n){return+n}function On(n){return Math.floor(+n/1e3)}},function(n,t,e){"use strict";var r=e(5),i=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,u=new RegExp(i.source,"g");t.a=function(n,t){var e,o,a,c=i.lastIndex=u.lastIndex=0,l=-1,f=[],s=[];for(n+="",t+="";(e=i.exec(n))&&(o=u.exec(t));)(a=o.index)>c&&(a=t.slice(c,a),f[l]?f[l]+=a:f[++l]=a),(e=e[0])===(o=o[0])?f[l]?f[l]+=o:f[++l]=o:(f[++l]=null,s.push({i:l,x:Object(r.a)(e,o)})),c=u.lastIndex;return c<t.length&&(a=t.slice(c),f[l]?f[l]+=a:f[++l]=a),f.length<2?s[0]?function(n){return function(t){return n(t)+""}}(s[0].x):function(n){return function(){return n}}(t):(t=s.length,function(n){for(var e,r=0;r<t;++r)f[(e=s[r]).i]=e.x(n);return f.join("")})}},function(n,t,e){"use strict";t.a=function(n,t){var e=new Date;return n=+n,t=+t,function(r){return e.setTime(n*(1-r)+t*r),e}}},function(n,t,e){"use strict";e.d(t,"b",(function(){return u}));var r=e(36),i=e(25);function u(n,t){var e,i=t?t.length:0,u=n?Math.min(i,n.length):0,o=new Array(u),a=new Array(i);for(e=0;e<u;++e)o[e]=Object(r.a)(n[e],t[e]);for(;e<i;++e)a[e]=t[e];return function(n){for(e=0;e<u;++e)a[e]=o[e](n);return a}}t.a=function(n,t){return(Object(i.b)(t)?i.a:u)(n,t)}},function(n,t,e){"use strict";var r=e(36);t.a=function(n,t){var e,i={},u={};for(e in null!==n&&"object"==typeof n||(n={}),null!==t&&"object"==typeof t||(t={}),t)e in n?i[e]=Object(r.a)(n[e],t[e]):u[e]=t[e];return function(n){for(e in i)u[e]=i[e](n);return u}}},function(n,t,e){"use strict";var r=e(22),i=e(13);t.a=function(n){var t=Object(r.a)();return t.changedTouches&&(t=t.changedTouches[0]),Object(i.a)(n,t)}},function(n,t,e){"use strict";var r=e(22),i=e(13);t.a=function(n,t,e){arguments.length<3&&(e=t,t=Object(r.a)().changedTouches);for(var u,o=0,a=t?t.length:0;o<a;++o)if((u=t[o]).identifier===e)return Object(i.a)(n,u);return null}},function(n,t,e){"use strict";var r=e(8);t.a=function(n){return Math.max(0,-Object(r.a)(Math.abs(n)))}},function(n,t,e){"use strict";var r=e(8);t.a=function(n,t){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(t)/3)))-Object(r.a)(Math.abs(n)))}},function(n,t,e){"use strict";var r=e(8);t.a=function(n,t){return n=Math.abs(n),t=Math.abs(t)-n,Math.max(0,Object(r.a)(t)-Object(r.a)(n))+1}},,function(n,t,e){"use strict";var r;void 0===(r=function(){return{colorSchemas:{britecharts:["#6aedc7","#39c2c9","#ffce00","#ffa71a","#f866b9","#998ce3"],grey:["#F8F8FA","#EFF2F5","#D2D6DF","#C3C6CF","#ADB0B6","#666A73","#45494E","#363A43","#282C35"],orange:["#fcc870","#ffa71a","#fb8825","#f6682f","#db5a2c","#bf4c28","#a43b1c","#892a10","#f9e9c5"],blueGreen:["#ccf7f6","#70e4e0","#00d8d2","#00acaf","#007f8c","#005e66","#003c3f","#002d2f","#0d2223"],teal:["#ccfffe","#94f7f4","#00fff8","#1de1e1","#39c2c9","#2e9a9d","#227270","#1a5957","#133f3e"],green:["#edfff7","#d7ffef","#c0ffe7","#95f5d7","#6aedc7","#59c3a3","#479980","#34816a","#206953"],yellow:["#f9f2b3","#fbe986","#fce05a","#fed72d","#ffce00","#fcc11c","#f9b438","#eda629","#e09819"],pink:["#fdd1ea","#fb9cd2","#f866b9","#fc40b6","#ff1ab3","#e3239d","#c62c86","#a62073","#85135f"],purple:["#ddd6fc","#bbb1f0","#998ce3","#8e6bc1","#824a9e","#77337f","#6b1c60","#591650","#470f3f"],red:["#ffd8d4","#ffb5b0","#ff938c","#ff766c","#ff584c","#f04b42","#e03d38","#be2e29","#9c1e19"]},colorSchemasHuman:{britecharts:"Britecharts Default",grey:"Britecharts Grey",orange:"Orange",blueGreen:"Blue",teal:"Light Blue",green:"Green",yellow:"Yellow",pink:"Pink",purple:"Purple",red:"Red"},colorGradients:{greenBlue:["#39C7EA","#4CDCBA"],orangePink:["#FBC670","#F766B8"],bluePurple:["#3DC3C9","#824a9e"]},colorGradientsHuman:{greenBlue:"Green to Blue",orangePink:"Orange to Pink",bluePurple:"Blue to Purple"},singleColors:{aloeGreen:["#7bdcc0"],greenColor:["#6aedc7"],blueColor:["#39c2c9"],yellowColor:["#ffce00"],orangeColor:["#ffa71a"],pinkColor:["#f866b9"],purpleColor:["#998ce3"]},singleColorsHuman:{aloeGreen:"Aloe Green",greenColor:"Green",blueColor:"Blue",yellowColor:"Yellow",orangeColor:"Orange",pinkColor:"Pink",purpleColor:"Purple"}}}.call(t,e,t,n))||(n.exports=r)},,,,function(n,t,e){"use strict";var r={value:function(){}};function i(){for(var n,t=0,e=arguments.length,r={};t<e;++t){if(!(n=arguments[t]+"")||n in r||/[\s.]/.test(n))throw new Error("illegal type: "+n);r[n]=[]}return new u(r)}function u(n){this._=n}function o(n,t){return n.trim().split(/^|\s+/).map((function(n){var e="",r=n.indexOf(".");if(r>=0&&(e=n.slice(r+1),n=n.slice(0,r)),n&&!t.hasOwnProperty(n))throw new Error("unknown type: "+n);return{type:n,name:e}}))}function a(n,t){for(var e,r=0,i=n.length;r<i;++r)if((e=n[r]).name===t)return e.value}function c(n,t,e){for(var i=0,u=n.length;i<u;++i)if(n[i].name===t){n[i]=r,n=n.slice(0,i).concat(n.slice(i+1));break}return null!=e&&n.push({name:t,value:e}),n}u.prototype=i.prototype={constructor:u,on:function(n,t){var e,r=this._,i=o(n+"",r),u=-1,l=i.length;if(!(arguments.length<2)){if(null!=t&&"function"!=typeof t)throw new Error("invalid callback: "+t);for(;++u<l;)if(e=(n=i[u]).type)r[e]=c(r[e],n.name,t);else if(null==t)for(e in r)r[e]=c(r[e],n.name,null);return this}for(;++u<l;)if((e=(n=i[u]).type)&&(e=a(r[e],n.name)))return e},copy:function(){var n={},t=this._;for(var e in t)n[e]=t[e].slice();return new u(n)},call:function(n,t){if((e=arguments.length-2)>0)for(var e,r,i=new Array(e),u=0;u<e;++u)i[u]=arguments[u+2];if(!this._.hasOwnProperty(n))throw new Error("unknown type: "+n);for(u=0,e=(r=this._[n]).length;u<e;++u)r[u].value.apply(t,i)},apply:function(n,t,e){if(!this._.hasOwnProperty(n))throw new Error("unknown type: "+n);for(var r=this._[n],i=0,u=r.length;i<u;++i)r[i].value.apply(t,e)}},t.a=i},,,function(n,t,e){"use strict";e.r(t);var r,i,u=e(9),o=e(69),a=0,c=0,l=0,f=0,s=0,h=0,d="object"==typeof performance&&performance.now?performance:Date,g="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(n){setTimeout(n,17)};function p(){return s||(g(v),s=d.now()+h)}function v(){s=0}function y(){this._call=this._time=this._next=null}function m(n,t,e){var r=new y;return r.restart(n,t,e),r}function b(){s=(f=d.now())+h,a=c=0;try{!function(){p(),++a;for(var n,t=r;t;)(n=s-t._time)>=0&&t._call.call(null,n),t=t._next;--a}()}finally{a=0,function(){var n,t,e=r,u=1/0;for(;e;)e._call?(u>e._time&&(u=e._time),n=e,e=e._next):(t=e._next,e._next=null,e=n?n._next=t:r=t);i=n,_(u)}(),s=0}}function w(){var n=d.now(),t=n-f;t>1e3&&(h-=t,f=n)}function _(n){a||(c&&(c=clearTimeout(c)),n-s>24?(n<1/0&&(c=setTimeout(b,n-d.now()-h)),l&&(l=clearInterval(l))):(l||(f=d.now(),l=setInterval(w,1e3)),a=1,g(b)))}y.prototype=m.prototype={constructor:y,restart:function(n,t,e){if("function"!=typeof n)throw new TypeError("callback is not a function");e=(null==e?p():+e)+(null==t?0:+t),this._next||i===this||(i?i._next=this:r=this,i=this),this._call=n,this._time=e,_()},stop:function(){this._call&&(this._call=null,this._time=1/0,_())}};var x=function(n,t,e){var r=new y;return t=null==t?0:+t,r.restart((function(e){r.stop(),n(e+t)}),t,e),r},M=Object(o.a)("start","end","cancel","interrupt"),O=[],j=function(n,t,e,r,i,u){var o=n.__transition;if(o){if(e in o)return}else n.__transition={};!function(n,t,e){var r,i=n.__transition;function u(c){var l,f,s,h;if(1!==e.state)return a();for(l in i)if((h=i[l]).name===e.name){if(3===h.state)return x(u);4===h.state?(h.state=6,h.timer.stop(),h.on.call("interrupt",n,n.__data__,h.index,h.group),delete i[l]):+l<t&&(h.state=6,h.timer.stop(),h.on.call("cancel",n,n.__data__,h.index,h.group),delete i[l])}if(x((function(){3===e.state&&(e.state=4,e.timer.restart(o,e.delay,e.time),o(c))})),e.state=2,e.on.call("start",n,n.__data__,e.index,e.group),2===e.state){for(e.state=3,r=new Array(s=e.tween.length),l=0,f=-1;l<s;++l)(h=e.tween[l].value.call(n,n.__data__,e.index,e.group))&&(r[++f]=h);r.length=f+1}}function o(t){for(var i=t<e.duration?e.ease.call(null,t/e.duration):(e.timer.restart(a),e.state=5,1),u=-1,o=r.length;++u<o;)r[u].call(n,i);5===e.state&&(e.on.call("end",n,n.__data__,e.index,e.group),a())}function a(){for(var r in e.state=6,e.timer.stop(),delete i[t],i)return;delete n.__transition}i[t]=e,e.timer=m((function(n){e.state=1,e.timer.restart(u,e.delay,e.time),e.delay<=n&&u(n-e.delay)}),0,e.time)}(n,e,{name:t,index:r,group:i,on:M,tween:O,time:u.time,delay:u.delay,duration:u.duration,ease:u.ease,timer:null,state:0})};function A(n,t){var e=C(n,t);if(e.state>0)throw new Error("too late; already scheduled");return e}function k(n,t){var e=C(n,t);if(e.state>3)throw new Error("too late; already running");return e}function C(n,t){var e=n.__transition;if(!e||!(e=e[t]))throw new Error("transition not found");return e}var N=function(n,t){var e,r,i,u=n.__transition,o=!0;if(u){for(i in t=null==t?null:t+"",u)(e=u[i]).name===t?(r=e.state>2&&e.state<5,e.state=6,e.timer.stop(),e.on.call(r?"interrupt":"cancel",n,n.__data__,e.index,e.group),delete u[i]):o=!1;o&&delete n.__transition}},T=e(74),S=e(20);function D(n,t){var e,r;return function(){var i=k(this,n),u=i.tween;if(u!==e)for(var o=0,a=(r=e=u).length;o<a;++o)if(r[o].name===t){(r=r.slice()).splice(o,1);break}i.tween=r}}function U(n,t,e){var r,i;if("function"!=typeof e)throw new Error;return function(){var u=k(this,n),o=u.tween;if(o!==r){i=(r=o).slice();for(var a={name:t,value:e},c=0,l=i.length;c<l;++c)if(i[c].name===t){i[c]=a;break}c===l&&i.push(a)}u.tween=i}}function E(n,t,e){var r=n._id;return n.each((function(){var n=k(this,r);(n.value||(n.value={}))[t]=e.apply(this,arguments)})),function(n){return C(n,r).value[t]}}var F=e(7),P=e(5),q=e(39),Y=e(55),L=function(n,t){var e;return("number"==typeof t?P.a:t instanceof F.e?q.a:(e=Object(F.e)(t))?(t=e,q.a):Y.a)(n,t)};function H(n){return function(){this.removeAttribute(n)}}function z(n){return function(){this.removeAttributeNS(n.space,n.local)}}function B(n,t,e){var r,i,u=e+"";return function(){var o=this.getAttribute(n);return o===u?null:o===r?i:i=t(r=o,e)}}function I(n,t,e){var r,i,u=e+"";return function(){var o=this.getAttributeNS(n.space,n.local);return o===u?null:o===r?i:i=t(r=o,e)}}function $(n,t,e){var r,i,u;return function(){var o,a,c=e(this);if(null!=c)return(o=this.getAttribute(n))===(a=c+"")?null:o===r&&a===i?u:(i=a,u=t(r=o,c));this.removeAttribute(n)}}function R(n,t,e){var r,i,u;return function(){var o,a,c=e(this);if(null!=c)return(o=this.getAttributeNS(n.space,n.local))===(a=c+"")?null:o===r&&a===i?u:(i=a,u=t(r=o,c));this.removeAttributeNS(n.space,n.local)}}function X(n,t){return function(e){this.setAttribute(n,t.call(this,e))}}function V(n,t){return function(e){this.setAttributeNS(n.space,n.local,t.call(this,e))}}function G(n,t){var e,r;function i(){var i=t.apply(this,arguments);return i!==r&&(e=(r=i)&&V(n,i)),e}return i._value=t,i}function W(n,t){var e,r;function i(){var i=t.apply(this,arguments);return i!==r&&(e=(r=i)&&X(n,i)),e}return i._value=t,i}function Z(n,t){return function(){A(this,n).delay=+t.apply(this,arguments)}}function Q(n,t){return t=+t,function(){A(this,n).delay=t}}function J(n,t){return function(){k(this,n).duration=+t.apply(this,arguments)}}function K(n,t){return t=+t,function(){k(this,n).duration=t}}function nn(n,t){if("function"!=typeof t)throw new Error;return function(){k(this,n).ease=t}}var tn=e(34);function en(n,t,e){var r,i,u=function(n){return(n+"").trim().split(/^|\s+/).every((function(n){var t=n.indexOf(".");return t>=0&&(n=n.slice(0,t)),!n||"start"===n}))}(t)?A:k;return function(){var o=u(this,n),a=o.on;a!==r&&(i=(r=a).copy()).on(t,e),o.on=i}}var rn=e(19),un=e(33),on=u.b.prototype.constructor,an=e(35);function cn(n){return function(){this.style.removeProperty(n)}}function ln(n,t,e){return function(r){this.style.setProperty(n,t.call(this,r),e)}}function fn(n,t,e){var r,i;function u(){var u=t.apply(this,arguments);return u!==i&&(r=(i=u)&&ln(n,u,e)),r}return u._value=t,u}function sn(n){return function(t){this.textContent=n.call(this,t)}}function hn(n){var t,e;function r(){var r=n.apply(this,arguments);return r!==e&&(t=(e=r)&&sn(r)),t}return r._value=n,r}var dn=0;function gn(n,t,e,r){this._groups=n,this._parents=t,this._name=e,this._id=r}function pn(n){return Object(u.b)().transition(n)}function vn(){return++dn}var yn=u.b.prototype;gn.prototype=pn.prototype={constructor:gn,select:function(n){var t=this._name,e=this._id;"function"!=typeof n&&(n=Object(rn.a)(n));for(var r=this._groups,i=r.length,u=new Array(i),o=0;o<i;++o)for(var a,c,l=r[o],f=l.length,s=u[o]=new Array(f),h=0;h<f;++h)(a=l[h])&&(c=n.call(a,a.__data__,h,l))&&("__data__"in a&&(c.__data__=a.__data__),s[h]=c,j(s[h],t,e,h,s,C(a,e)));return new gn(u,this._parents,t,e)},selectAll:function(n){var t=this._name,e=this._id;"function"!=typeof n&&(n=Object(un.a)(n));for(var r=this._groups,i=r.length,u=[],o=[],a=0;a<i;++a)for(var c,l=r[a],f=l.length,s=0;s<f;++s)if(c=l[s]){for(var h,d=n.call(c,c.__data__,s,l),g=C(c,e),p=0,v=d.length;p<v;++p)(h=d[p])&&j(h,t,e,p,d,g);u.push(d),o.push(c)}return new gn(u,o,t,e)},filter:function(n){"function"!=typeof n&&(n=Object(tn.a)(n));for(var t=this._groups,e=t.length,r=new Array(e),i=0;i<e;++i)for(var u,o=t[i],a=o.length,c=r[i]=[],l=0;l<a;++l)(u=o[l])&&n.call(u,u.__data__,l,o)&&c.push(u);return new gn(r,this._parents,this._name,this._id)},merge:function(n){if(n._id!==this._id)throw new Error;for(var t=this._groups,e=n._groups,r=t.length,i=e.length,u=Math.min(r,i),o=new Array(r),a=0;a<u;++a)for(var c,l=t[a],f=e[a],s=l.length,h=o[a]=new Array(s),d=0;d<s;++d)(c=l[d]||f[d])&&(h[d]=c);for(;a<r;++a)o[a]=t[a];return new gn(o,this._parents,this._name,this._id)},selection:function(){return new on(this._groups,this._parents)},transition:function(){for(var n=this._name,t=this._id,e=vn(),r=this._groups,i=r.length,u=0;u<i;++u)for(var o,a=r[u],c=a.length,l=0;l<c;++l)if(o=a[l]){var f=C(o,t);j(o,n,e,l,a,{time:f.time+f.delay+f.duration,delay:0,duration:f.duration,ease:f.ease})}return new gn(r,this._parents,n,e)},call:yn.call,nodes:yn.nodes,node:yn.node,size:yn.size,empty:yn.empty,each:yn.each,on:function(n,t){var e=this._id;return arguments.length<2?C(this.node(),e).on.on(n):this.each(en(e,n,t))},attr:function(n,t){var e=Object(S.a)(n),r="transform"===e?T.b:L;return this.attrTween(n,"function"==typeof t?(e.local?R:$)(e,r,E(this,"attr."+n,t)):null==t?(e.local?z:H)(e):(e.local?I:B)(e,r,t))},attrTween:function(n,t){var e="attr."+n;if(arguments.length<2)return(e=this.tween(e))&&e._value;if(null==t)return this.tween(e,null);if("function"!=typeof t)throw new Error;var r=Object(S.a)(n);return this.tween(e,(r.local?G:W)(r,t))},style:function(n,t,e){var r="transform"==(n+="")?T.a:L;return null==t?this.styleTween(n,function(n,t){var e,r,i;return function(){var u=Object(an.b)(this,n),o=(this.style.removeProperty(n),Object(an.b)(this,n));return u===o?null:u===e&&o===r?i:i=t(e=u,r=o)}}(n,r)).on("end.style."+n,cn(n)):"function"==typeof t?this.styleTween(n,function(n,t,e){var r,i,u;return function(){var o=Object(an.b)(this,n),a=e(this),c=a+"";return null==a&&(this.style.removeProperty(n),c=a=Object(an.b)(this,n)),o===c?null:o===r&&c===i?u:(i=c,u=t(r=o,a))}}(n,r,E(this,"style."+n,t))).each(function(n,t){var e,r,i,u,o="style."+t,a="end."+o;return function(){var c=k(this,n),l=c.on,f=null==c.value[o]?u||(u=cn(t)):void 0;l===e&&i===f||(r=(e=l).copy()).on(a,i=f),c.on=r}}(this._id,n)):this.styleTween(n,function(n,t,e){var r,i,u=e+"";return function(){var o=Object(an.b)(this,n);return o===u?null:o===r?i:i=t(r=o,e)}}(n,r,t),e).on("end.style."+n,null)},styleTween:function(n,t,e){var r="style."+(n+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==t)return this.tween(r,null);if("function"!=typeof t)throw new Error;return this.tween(r,fn(n,t,null==e?"":e))},text:function(n){return this.tween("text","function"==typeof n?function(n){return function(){var t=n(this);this.textContent=null==t?"":t}}(E(this,"text",n)):function(n){return function(){this.textContent=n}}(null==n?"":n+""))},textTween:function(n){var t="text";if(arguments.length<1)return(t=this.tween(t))&&t._value;if(null==n)return this.tween(t,null);if("function"!=typeof n)throw new Error;return this.tween(t,hn(n))},remove:function(){return this.on("end.remove",(n=this._id,function(){var t=this.parentNode;for(var e in this.__transition)if(+e!==n)return;t&&t.removeChild(this)}));var n},tween:function(n,t){var e=this._id;if(n+="",arguments.length<2){for(var r,i=C(this.node(),e).tween,u=0,o=i.length;u<o;++u)if((r=i[u]).name===n)return r.value;return null}return this.each((null==t?D:U)(e,n,t))},delay:function(n){var t=this._id;return arguments.length?this.each(("function"==typeof n?Z:Q)(t,n)):C(this.node(),t).delay},duration:function(n){var t=this._id;return arguments.length?this.each(("function"==typeof n?J:K)(t,n)):C(this.node(),t).duration},ease:function(n){var t=this._id;return arguments.length?this.each(nn(t,n)):C(this.node(),t).ease},end:function(){var n,t,e=this,r=e._id,i=e.size();return new Promise((function(u,o){var a={value:o},c={value:function(){0==--i&&u()}};e.each((function(){var e=k(this,r),i=e.on;i!==n&&((t=(n=i).copy())._.cancel.push(a),t._.interrupt.push(a),t._.end.push(c)),e.on=t}))}))}};var mn={time:null,delay:0,duration:250,ease:e(29).b};function bn(n,t){for(var e;!(e=n.__transition)||!(e=e[t]);)if(!(n=n.parentNode))return mn.time=p(),mn;return e}u.b.prototype.interrupt=function(n){return this.each((function(){N(this,n)}))},u.b.prototype.transition=function(n){var t,e;n instanceof gn?(t=n._id,n=n._name):(t=vn(),(e=mn).time=p(),n=null==n?null:n+"");for(var r=this._groups,i=r.length,u=0;u<i;++u)for(var o,a=r[u],c=a.length,l=0;l<c;++l)(o=a[l])&&j(o,n,t,l,a,e||bn(o,t));return new gn(r,this._parents,n,t)};var wn=[null],_n=function(n,t){var e,r,i=n.__transition;if(i)for(r in t=null==t?null:t+"",i)if((e=i[r]).state>1&&e.name===t)return new gn([[n]],wn,t,+r);return null};e.d(t,"transition",(function(){return pn})),e.d(t,"active",(function(){return _n})),e.d(t,"interrupt",(function(){return N}))},,function(n,t,e){"use strict";var r,i,u,o,a=e(5),c=180/Math.PI,l={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1},f=function(n,t,e,r,i,u){var o,a,l;return(o=Math.sqrt(n*n+t*t))&&(n/=o,t/=o),(l=n*e+t*r)&&(e-=n*l,r-=t*l),(a=Math.sqrt(e*e+r*r))&&(e/=a,r/=a,l/=a),n*r<t*e&&(n=-n,t=-t,l=-l,o=-o),{translateX:i,translateY:u,rotate:Math.atan2(t,n)*c,skewX:Math.atan(l)*c,scaleX:o,scaleY:a}};function s(n,t,e,r){function i(n){return n.length?n.pop()+" ":""}return function(u,o){var c=[],l=[];return u=n(u),o=n(o),function(n,r,i,u,o,c){if(n!==i||r!==u){var l=o.push("translate(",null,t,null,e);c.push({i:l-4,x:Object(a.a)(n,i)},{i:l-2,x:Object(a.a)(r,u)})}else(i||u)&&o.push("translate("+i+t+u+e)}(u.translateX,u.translateY,o.translateX,o.translateY,c,l),function(n,t,e,u){n!==t?(n-t>180?t+=360:t-n>180&&(n+=360),u.push({i:e.push(i(e)+"rotate(",null,r)-2,x:Object(a.a)(n,t)})):t&&e.push(i(e)+"rotate("+t+r)}(u.rotate,o.rotate,c,l),function(n,t,e,u){n!==t?u.push({i:e.push(i(e)+"skewX(",null,r)-2,x:Object(a.a)(n,t)}):t&&e.push(i(e)+"skewX("+t+r)}(u.skewX,o.skewX,c,l),function(n,t,e,r,u,o){if(n!==e||t!==r){var c=u.push(i(u)+"scale(",null,",",null,")");o.push({i:c-4,x:Object(a.a)(n,e)},{i:c-2,x:Object(a.a)(t,r)})}else 1===e&&1===r||u.push(i(u)+"scale("+e+","+r+")")}(u.scaleX,u.scaleY,o.scaleX,o.scaleY,c,l),u=o=null,function(n){for(var t,e=-1,r=l.length;++e<r;)c[(t=l[e]).i]=t.x(n);return c.join("")}}}e.d(t,"a",(function(){return h})),e.d(t,"b",(function(){return d}));var h=s((function(n){return"none"===n?l:(r||(r=document.createElement("DIV"),i=document.documentElement,u=document.defaultView),r.style.transform=n,n=u.getComputedStyle(i.appendChild(r),null).getPropertyValue("transform"),i.removeChild(r),n=n.slice(7,-1).split(","),f(+n[0],+n[1],+n[2],+n[3],+n[4],+n[5]))}),"px, ","px)","deg)"),d=s((function(n){return null==n?l:(o||(o=document.createElementNS("http://www.w3.org/2000/svg","g")),o.setAttribute("transform",n),(n=o.transform.baseVal.consolidate())?(n=n.matrix,f(n.a,n.b,n.c,n.d,n.e,n.f)):l)}),", ",")",")")},function(n,t,e){"use strict";e.r(t);var r=e(2);function i(n,t){switch(arguments.length){case 0:break;case 1:this.range(n);break;default:this.range(t).domain(n)}return this}function u(n,t){switch(arguments.length){case 0:break;case 1:this.interpolator(n);break;default:this.interpolator(t).domain(n)}return this}var o=e(45),a=Array.prototype,c=a.map,l=a.slice,f={name:"implicit"};function s(){var n=Object(o.map)(),t=[],e=[],r=f;function u(i){var u=i+"",o=n.get(u);if(!o){if(r!==f)return r;n.set(u,o=t.push(i))}return e[(o-1)%e.length]}return u.domain=function(e){if(!arguments.length)return t.slice();t=[],n=Object(o.map)();for(var r,i,a=-1,c=e.length;++a<c;)n.has(i=(r=e[a])+"")||n.set(i,t.push(r));return u},u.range=function(n){return arguments.length?(e=l.call(n),u):e.slice()},u.unknown=function(n){return arguments.length?(r=n,u):r},u.copy=function(){return s(t,e).unknown(r)},i.apply(u,arguments),u}function h(){var n,t,e=s().unknown(void 0),u=e.domain,o=e.range,a=[0,1],c=!1,l=0,f=0,d=.5;function g(){var e=u().length,i=a[1]<a[0],s=a[i-0],h=a[1-i];n=(h-s)/Math.max(1,e-l+2*f),c&&(n=Math.floor(n)),s+=(h-s-n*(e-l))*d,t=n*(1-l),c&&(s=Math.round(s),t=Math.round(t));var g=Object(r.range)(e).map((function(t){return s+n*t}));return o(i?g.reverse():g)}return delete e.unknown,e.domain=function(n){return arguments.length?(u(n),g()):u()},e.range=function(n){return arguments.length?(a=[+n[0],+n[1]],g()):a.slice()},e.rangeRound=function(n){return a=[+n[0],+n[1]],c=!0,g()},e.bandwidth=function(){return t},e.step=function(){return n},e.round=function(n){return arguments.length?(c=!!n,g()):c},e.padding=function(n){return arguments.length?(l=Math.min(1,f=+n),g()):l},e.paddingInner=function(n){return arguments.length?(l=Math.min(1,n),g()):l},e.paddingOuter=function(n){return arguments.length?(f=+n,g()):f},e.align=function(n){return arguments.length?(d=Math.max(0,Math.min(1,n)),g()):d},e.copy=function(){return h(u(),a).round(c).paddingInner(l).paddingOuter(f).align(d)},i.apply(g(),arguments)}function d(n){var t=n.copy;return n.padding=n.paddingOuter,delete n.paddingInner,delete n.paddingOuter,n.copy=function(){return d(t())},n}function g(){return d(h.apply(null,arguments).paddingInner(1))}var p=e(36),v=e(5),y=e(81),m=function(n){return+n},b=[0,1];function w(n){return n}function _(n,t){return(t-=n=+n)?function(e){return(e-n)/t}:(e=isNaN(t)?NaN:.5,function(){return e});var e}function x(n){var t,e=n[0],r=n[n.length-1];return e>r&&(t=e,e=r,r=t),function(n){return Math.max(e,Math.min(r,n))}}function M(n,t,e){var r=n[0],i=n[1],u=t[0],o=t[1];return i<r?(r=_(i,r),u=e(o,u)):(r=_(r,i),u=e(u,o)),function(n){return u(r(n))}}function O(n,t,e){var i=Math.min(n.length,t.length)-1,u=new Array(i),o=new Array(i),a=-1;for(n[i]<n[0]&&(n=n.slice().reverse(),t=t.slice().reverse());++a<i;)u[a]=_(n[a],n[a+1]),o[a]=e(t[a],t[a+1]);return function(t){var e=Object(r.bisect)(n,t,1,i)-1;return o[e](u[e](t))}}function j(n,t){return t.domain(n.domain()).range(n.range()).interpolate(n.interpolate()).clamp(n.clamp()).unknown(n.unknown())}function A(){var n,t,e,r,i,u,o=b,a=b,f=p.a,s=w;function h(){return r=Math.min(o.length,a.length)>2?O:M,i=u=null,d}function d(t){return isNaN(t=+t)?e:(i||(i=r(o.map(n),a,f)))(n(s(t)))}return d.invert=function(e){return s(t((u||(u=r(a,o.map(n),v.a)))(e)))},d.domain=function(n){return arguments.length?(o=c.call(n,m),s===w||(s=x(o)),h()):o.slice()},d.range=function(n){return arguments.length?(a=l.call(n),h()):a.slice()},d.rangeRound=function(n){return a=l.call(n),f=y.a,h()},d.clamp=function(n){return arguments.length?(s=n?x(o):w,d):s!==w},d.interpolate=function(n){return arguments.length?(f=n,h()):f},d.unknown=function(n){return arguments.length?(e=n,d):e},function(e,r){return n=e,t=r,h()}}function k(n,t){return A()(n,t)}var C=e(24),N=e(62),T=e(40),S=e(63),D=e(61),U=function(n,t,e,i){var u,o=Object(r.tickStep)(n,t,e);switch((i=Object(C.b)(null==i?",f":i)).type){case"s":var a=Math.max(Math.abs(n),Math.abs(t));return null!=i.precision||isNaN(u=Object(N.a)(o,a))||(i.precision=u),Object(T.c)(i,a);case"":case"e":case"g":case"p":case"r":null!=i.precision||isNaN(u=Object(S.a)(o,Math.max(Math.abs(n),Math.abs(t))))||(i.precision=u-("e"===i.type));break;case"f":case"%":null!=i.precision||isNaN(u=Object(D.a)(o))||(i.precision=u-2*("%"===i.type))}return Object(T.b)(i)};function E(n){var t=n.domain;return n.ticks=function(n){var e=t();return Object(r.ticks)(e[0],e[e.length-1],null==n?10:n)},n.tickFormat=function(n,e){var r=t();return U(r[0],r[r.length-1],null==n?10:n,e)},n.nice=function(e){null==e&&(e=10);var i,u=t(),o=0,a=u.length-1,c=u[o],l=u[a];return l<c&&(i=c,c=l,l=i,i=o,o=a,a=i),(i=Object(r.tickIncrement)(c,l,e))>0?(c=Math.floor(c/i)*i,l=Math.ceil(l/i)*i,i=Object(r.tickIncrement)(c,l,e)):i<0&&(c=Math.ceil(c*i)/i,l=Math.floor(l*i)/i,i=Object(r.tickIncrement)(c,l,e)),i>0?(u[o]=Math.floor(c/i)*i,u[a]=Math.ceil(l/i)*i,t(u)):i<0&&(u[o]=Math.ceil(c*i)/i,u[a]=Math.floor(l*i)/i,t(u)),n},n}function F(){var n=k(w,w);return n.copy=function(){return j(n,F())},i.apply(n,arguments),E(n)}function P(n){var t;function e(n){return isNaN(n=+n)?t:n}return e.invert=e,e.domain=e.range=function(t){return arguments.length?(n=c.call(t,m),e):n.slice()},e.unknown=function(n){return arguments.length?(t=n,e):t},e.copy=function(){return P(n).unknown(t)},n=arguments.length?c.call(n,m):[0,1],E(e)}var q=function(n,t){var e,r=0,i=(n=n.slice()).length-1,u=n[r],o=n[i];return o<u&&(e=r,r=i,i=e,e=u,u=o,o=e),n[r]=t.floor(u),n[i]=t.ceil(o),n};function Y(n){return Math.log(n)}function L(n){return Math.exp(n)}function H(n){return-Math.log(-n)}function z(n){return-Math.exp(-n)}function B(n){return isFinite(n)?+("1e"+n):n<0?0:n}function I(n){return function(t){return-n(-t)}}function $(n){var t,e,i=n(Y,L),u=i.domain,o=10;function a(){return t=function(n){return n===Math.E?Math.log:10===n&&Math.log10||2===n&&Math.log2||(n=Math.log(n),function(t){return Math.log(t)/n})}(o),e=function(n){return 10===n?B:n===Math.E?Math.exp:function(t){return Math.pow(n,t)}}(o),u()[0]<0?(t=I(t),e=I(e),n(H,z)):n(Y,L),i}return i.base=function(n){return arguments.length?(o=+n,a()):o},i.domain=function(n){return arguments.length?(u(n),a()):u()},i.ticks=function(n){var i,a=u(),c=a[0],l=a[a.length-1];(i=l<c)&&(d=c,c=l,l=d);var f,s,h,d=t(c),g=t(l),p=null==n?10:+n,v=[];if(!(o%1)&&g-d<p){if(d=Math.round(d)-1,g=Math.round(g)+1,c>0){for(;d<g;++d)for(s=1,f=e(d);s<o;++s)if(!((h=f*s)<c)){if(h>l)break;v.push(h)}}else for(;d<g;++d)for(s=o-1,f=e(d);s>=1;--s)if(!((h=f*s)<c)){if(h>l)break;v.push(h)}}else v=Object(r.ticks)(d,g,Math.min(g-d,p)).map(e);return i?v.reverse():v},i.tickFormat=function(n,r){if(null==r&&(r=10===o?".0e":","),"function"!=typeof r&&(r=Object(T.b)(r)),n===1/0)return r;null==n&&(n=10);var u=Math.max(1,o*n/i.ticks().length);return function(n){var i=n/e(Math.round(t(n)));return i*o<o-.5&&(i*=o),i<=u?r(n):""}},i.nice=function(){return u(q(u(),{floor:function(n){return e(Math.floor(t(n)))},ceil:function(n){return e(Math.ceil(t(n)))}}))},i}function R(){var n=$(A()).domain([1,10]);return n.copy=function(){return j(n,R()).base(n.base())},i.apply(n,arguments),n}function X(n){return function(t){return Math.sign(t)*Math.log1p(Math.abs(t/n))}}function V(n){return function(t){return Math.sign(t)*Math.expm1(Math.abs(t))*n}}function G(n){var t=1,e=n(X(t),V(t));return e.constant=function(e){return arguments.length?n(X(t=+e),V(t)):t},E(e)}function W(){var n=G(A());return n.copy=function(){return j(n,W()).constant(n.constant())},i.apply(n,arguments)}function Z(n){return function(t){return t<0?-Math.pow(-t,n):Math.pow(t,n)}}function Q(n){return n<0?-Math.sqrt(-n):Math.sqrt(n)}function J(n){return n<0?-n*n:n*n}function K(n){var t=n(w,w),e=1;function r(){return 1===e?n(w,w):.5===e?n(Q,J):n(Z(e),Z(1/e))}return t.exponent=function(n){return arguments.length?(e=+n,r()):e},E(t)}function nn(){var n=K(A());return n.copy=function(){return j(n,nn()).exponent(n.exponent())},i.apply(n,arguments),n}function tn(){return nn.apply(null,arguments).exponent(.5)}function en(){var n,t=[],e=[],u=[];function o(){var n=0,i=Math.max(1,e.length);for(u=new Array(i-1);++n<i;)u[n-1]=Object(r.quantile)(t,n/i);return a}function a(t){return isNaN(t=+t)?n:e[Object(r.bisect)(u,t)]}return a.invertExtent=function(n){var r=e.indexOf(n);return r<0?[NaN,NaN]:[r>0?u[r-1]:t[0],r<u.length?u[r]:t[t.length-1]]},a.domain=function(n){if(!arguments.length)return t.slice();t=[];for(var e,i=0,u=n.length;i<u;++i)null==(e=n[i])||isNaN(e=+e)||t.push(e);return t.sort(r.ascending),o()},a.range=function(n){return arguments.length?(e=l.call(n),o()):e.slice()},a.unknown=function(t){return arguments.length?(n=t,a):n},a.quantiles=function(){return u.slice()},a.copy=function(){return en().domain(t).range(e).unknown(n)},i.apply(a,arguments)}function rn(){var n,t=0,e=1,u=1,o=[.5],a=[0,1];function c(t){return t<=t?a[Object(r.bisect)(o,t,0,u)]:n}function f(){var n=-1;for(o=new Array(u);++n<u;)o[n]=((n+1)*e-(n-u)*t)/(u+1);return c}return c.domain=function(n){return arguments.length?(t=+n[0],e=+n[1],f()):[t,e]},c.range=function(n){return arguments.length?(u=(a=l.call(n)).length-1,f()):a.slice()},c.invertExtent=function(n){var r=a.indexOf(n);return r<0?[NaN,NaN]:r<1?[t,o[0]]:r>=u?[o[u-1],e]:[o[r-1],o[r]]},c.unknown=function(t){return arguments.length?(n=t,c):c},c.thresholds=function(){return o.slice()},c.copy=function(){return rn().domain([t,e]).range(a).unknown(n)},i.apply(E(c),arguments)}function un(){var n,t=[.5],e=[0,1],u=1;function o(i){return i<=i?e[Object(r.bisect)(t,i,0,u)]:n}return o.domain=function(n){return arguments.length?(t=l.call(n),u=Math.min(t.length,e.length-1),o):t.slice()},o.range=function(n){return arguments.length?(e=l.call(n),u=Math.min(t.length,e.length-1),o):e.slice()},o.invertExtent=function(n){var r=e.indexOf(n);return[t[r-1],t[r]]},o.unknown=function(t){return arguments.length?(n=t,o):n},o.copy=function(){return un().domain(t).range(e).unknown(n)},i.apply(o,arguments)}var on=e(15),an=e(47),cn=e(3),ln=e(27),fn=e(48),sn=e(49),hn=e(30),dn=e(31),gn=e(46);function pn(n){return new Date(n)}function vn(n){return n instanceof Date?+n:+new Date(+n)}function yn(n,t,e,i,u,o,a,l,f){var s=k(w,w),h=s.invert,d=s.domain,g=f(".%L"),p=f(":%S"),v=f("%I:%M"),y=f("%I %p"),m=f("%a %d"),b=f("%b %d"),_=f("%B"),x=f("%Y"),M=[[a,1,1e3],[a,5,5e3],[a,15,15e3],[a,30,3e4],[o,1,6e4],[o,5,3e5],[o,15,9e5],[o,30,18e5],[u,1,36e5],[u,3,108e5],[u,6,216e5],[u,12,432e5],[i,1,864e5],[i,2,1728e5],[e,1,6048e5],[t,1,2592e6],[t,3,7776e6],[n,1,31536e6]];function O(r){return(a(r)<r?g:o(r)<r?p:u(r)<r?v:i(r)<r?y:t(r)<r?e(r)<r?m:b:n(r)<r?_:x)(r)}function A(t,e,i,u){if(null==t&&(t=10),"number"==typeof t){var o=Math.abs(i-e)/t,a=Object(r.bisector)((function(n){return n[2]})).right(M,o);a===M.length?(u=Object(r.tickStep)(e/31536e6,i/31536e6,t),t=n):a?(u=(a=M[o/M[a-1][2]<M[a][2]/o?a-1:a])[1],t=a[0]):(u=Math.max(Object(r.tickStep)(e,i,t),1),t=l)}return null==u?t:t.every(u)}return s.invert=function(n){return new Date(h(n))},s.domain=function(n){return arguments.length?d(c.call(n,vn)):d().map(pn)},s.ticks=function(n,t){var e,r=d(),i=r[0],u=r[r.length-1],o=u<i;return o&&(e=i,i=u,u=e),e=(e=A(n,i,u,t))?e.range(i,u+1):[],o?e.reverse():e},s.tickFormat=function(n,t){return null==t?O:f(t)},s.nice=function(n,t){var e=d();return(n=A(n,e[0],e[e.length-1],t))?d(q(e,n)):s},s.copy=function(){return j(s,yn(n,t,e,i,u,o,a,l,f))},s}var mn=function(){return i.apply(yn(on.a,an.a,cn.g,ln.b,fn.a,sn.a,hn.a,dn.a,gn.b).domain([new Date(2e3,0,1),new Date(2e3,0,2)]),arguments)},bn=e(16),wn=e(50),_n=e(4),xn=e(28),Mn=e(51),On=e(52),jn=function(){return i.apply(yn(bn.a,wn.a,_n.g,xn.a,Mn.a,On.a,hn.a,dn.a,gn.d).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)]),arguments)};function An(){var n,t,e,r,i,u=0,o=1,a=w,c=!1;function l(t){return isNaN(t=+t)?i:a(0===e?.5:(t=(r(t)-n)*e,c?Math.max(0,Math.min(1,t)):t))}return l.domain=function(i){return arguments.length?(n=r(u=+i[0]),t=r(o=+i[1]),e=n===t?0:1/(t-n),l):[u,o]},l.clamp=function(n){return arguments.length?(c=!!n,l):c},l.interpolator=function(n){return arguments.length?(a=n,l):a},l.unknown=function(n){return arguments.length?(i=n,l):i},function(i){return r=i,n=i(u),t=i(o),e=n===t?0:1/(t-n),l}}function kn(n,t){return t.domain(n.domain()).interpolator(n.interpolator()).clamp(n.clamp()).unknown(n.unknown())}function Cn(){var n=E(An()(w));return n.copy=function(){return kn(n,Cn())},u.apply(n,arguments)}function Nn(){var n=$(An()).domain([1,10]);return n.copy=function(){return kn(n,Nn()).base(n.base())},u.apply(n,arguments)}function Tn(){var n=G(An());return n.copy=function(){return kn(n,Tn()).constant(n.constant())},u.apply(n,arguments)}function Sn(){var n=K(An());return n.copy=function(){return kn(n,Sn()).exponent(n.exponent())},u.apply(n,arguments)}function Dn(){return Sn.apply(null,arguments).exponent(.5)}function Un(){var n=[],t=w;function e(e){if(!isNaN(e=+e))return t((Object(r.bisect)(n,e)-1)/(n.length-1))}return e.domain=function(t){if(!arguments.length)return n.slice();n=[];for(var i,u=0,o=t.length;u<o;++u)null==(i=t[u])||isNaN(i=+i)||n.push(i);return n.sort(r.ascending),e},e.interpolator=function(n){return arguments.length?(t=n,e):t},e.copy=function(){return Un(t).domain(n)},u.apply(e,arguments)}function En(){var n,t,e,r,i,u,o,a=0,c=.5,l=1,f=w,s=!1;function h(n){return isNaN(n=+n)?o:(n=.5+((n=+u(n))-t)*(n<t?r:i),f(s?Math.max(0,Math.min(1,n)):n))}return h.domain=function(o){return arguments.length?(n=u(a=+o[0]),t=u(c=+o[1]),e=u(l=+o[2]),r=n===t?0:.5/(t-n),i=t===e?0:.5/(e-t),h):[a,c,l]},h.clamp=function(n){return arguments.length?(s=!!n,h):s},h.interpolator=function(n){return arguments.length?(f=n,h):f},h.unknown=function(n){return arguments.length?(o=n,h):o},function(o){return u=o,n=o(a),t=o(c),e=o(l),r=n===t?0:.5/(t-n),i=t===e?0:.5/(e-t),h}}function Fn(){var n=E(En()(w));return n.copy=function(){return kn(n,Fn())},u.apply(n,arguments)}function Pn(){var n=$(En()).domain([.1,1,10]);return n.copy=function(){return kn(n,Pn()).base(n.base())},u.apply(n,arguments)}function qn(){var n=G(En());return n.copy=function(){return kn(n,qn()).constant(n.constant())},u.apply(n,arguments)}function Yn(){var n=K(En());return n.copy=function(){return kn(n,Yn()).exponent(n.exponent())},u.apply(n,arguments)}function Ln(){return Yn.apply(null,arguments).exponent(.5)}e.d(t,"scaleBand",(function(){return h})),e.d(t,"scalePoint",(function(){return g})),e.d(t,"scaleIdentity",(function(){return P})),e.d(t,"scaleLinear",(function(){return F})),e.d(t,"scaleLog",(function(){return R})),e.d(t,"scaleSymlog",(function(){return W})),e.d(t,"scaleOrdinal",(function(){return s})),e.d(t,"scaleImplicit",(function(){return f})),e.d(t,"scalePow",(function(){return nn})),e.d(t,"scaleSqrt",(function(){return tn})),e.d(t,"scaleQuantile",(function(){return en})),e.d(t,"scaleQuantize",(function(){return rn})),e.d(t,"scaleThreshold",(function(){return un})),e.d(t,"scaleTime",(function(){return mn})),e.d(t,"scaleUtc",(function(){return jn})),e.d(t,"scaleSequential",(function(){return Cn})),e.d(t,"scaleSequentialLog",(function(){return Nn})),e.d(t,"scaleSequentialPow",(function(){return Sn})),e.d(t,"scaleSequentialSqrt",(function(){return Dn})),e.d(t,"scaleSequentialSymlog",(function(){return Tn})),e.d(t,"scaleSequentialQuantile",(function(){return Un})),e.d(t,"scaleDiverging",(function(){return Fn})),e.d(t,"scaleDivergingLog",(function(){return Pn})),e.d(t,"scaleDivergingPow",(function(){return Yn})),e.d(t,"scaleDivergingSqrt",(function(){return Ln})),e.d(t,"scaleDivergingSymlog",(function(){return qn})),e.d(t,"tickFormat",(function(){return U}))},,,,,,function(n,t,e){"use strict";t.a=function(n,t){return n=+n,t=+t,function(e){return Math.round(n*(1-e)+t*e)}}},,,,,,function(n,t,e){"use strict";var r;void 0===(r=function(n){var t=e(6),r=1.2,i=10,u=.9,o=.6,a="value",c="label",l=function(n){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:12,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"Arial",r=document.createElement("canvas"),i=r.getContext("2d");return i.font=t+"px "+e,i.measureText(n).width};return{getTextWidth:l,wrapText:function(n,e,l,f){var s=t.select(f),h=s.text().split(/\s+/).reverse(),d=void 0,g=[],p=0,v=r*u,y=s.attr("y"),m=parseFloat(s.attr("dy")),b=e*o,w=s.text(null).append("tspan").attr("x",n).attr("y",y-5).attr("dy",m+"em").classed(a,!0).style("font-size",e+"px");for(w.text(h.pop()),w=s.append("tspan").classed(c,!0).attr("x",n).attr("y",y+i).attr("dy",++p*v+m+"em").style("font-size",b+"px");d=h.pop();)g.push(d),w.text(g.join(" ")),w.node()&&w.node().getComputedTextLength()>l-50&&(g.pop(),w.text(g.join(" ")),g=[d],w=s.append("tspan").classed(c,!0).attr("x",n).attr("y",y+i).attr("dy",++p*v+m+"em").text(d).style("font-size",b+"px"))},wrapTextWithEllipses:function(n,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2;n.each((function(){var u,o,a,c,l,f,s;for(u=(n=t.select(this)).text().split(/\s+/).reverse(),a=[],c=0,1.2,l=n.attr("y"),f=parseFloat(n.attr("dy")),s=n.text(null).append("tspan").attr("x",r).attr("y",l).attr("dy",f+"em");o=u.pop();)if(a.push(o),s.text(a.join(" ")),s.node()&&s.node().getComputedTextLength()>e){if(a.pop(),s.text(a.join(" ")),!(c<i-1)){a.push("..."),s.text(a.join(" "));break}a=[o],s=n.append("tspan").attr("x",r).attr("y",l).attr("dy",1.2*++c+f+"em").text(o),n.classed("adjust-upwards",!0)}}))},getApproximateNumberOfLines:function(n,t,e){var r=n.split(/\s+/).reverse(),i=[],u=1,o=!0,a=!1,c=void 0;try{for(var f,s=r[Symbol.iterator]();!(o=(f=s.next()).done);o=!0){var h=f.value;i.push(h),l(i.join(" "),t,"Karla, sans-serif")>e&&(i.pop(),i=[h],++u)}}catch(n){a=!0,c=n}finally{try{!o&&s.return&&s.return()}finally{if(a)throw c}}return u}}}.call(t,e,t,n))||(n.exports=r)},,,,,,,,,,,,,function(n,t,e){"use strict";var r,i=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r])}return n};void 0===(r=function(n){var t=e(44),r=e(75),u=e(6),o=(e(72),e(87)),a=e(65);return function(){var n={top:5,right:5,bottom:5,left:5},e=320,c=180,l=16,f=1.5,s="s",h="",d=!1,g=null,p=!0,v=void 0,y=a.colorSchemas.britecharts,m=function(n){return n.id},b=function(n){return n.name},w=function(n){var e=n.quantity;return t.format(s)(e)+h},_=function(n){var t=n.name;return v(t)},x=function(n){var t=n.quantity;return"number"==typeof t||"string"==typeof t},M=void 0,O=void 0,j=void 0,A=void 0,k=void 0;function C(t){t.each((function(t){var i,a,f,s,h,C,D,U,E,F;O=e-n.left-n.right,j=c-n.top-n.bottom,A=function(n){return p=n.filter(x).length===n.length,n.reduce((function(n,t){return void 0!==t.quantity&&null!==t.quantity&&(t.quantity=+t.quantity),t.name=String(t.name),t.id=+t.id,[].concat(function(n){if(Array.isArray(n)){for(var t=0,e=Array(n.length);t<n.length;t++)e[t]=n[t];return e}return Array.from(n)}(n),[t])}),[])}(t),v=r.scaleOrdinal().range(y),function(t){k||(k=u.select(t).append("svg").classed("britechart britechart-legend",!0)).append("g").classed("legend-container-group",!0).attr("transform","translate("+n.left+","+n.top+")").append("g").classed("legend-group",!0);k.attr("width",e).attr("height",c)}(this),d?(F=l,k.select(".legend-group").selectAll("g").remove(),k.select(".legend-group").append("g").classed("legend-line",!0),(M=k.select(".legend-line").selectAll("g.legend-entry").data(A)).enter().append("g").classed("legend-entry",!0).attr("data-item",m).attr("transform",(function(n){var t=n.name,e=F,r=j/2,i=o.getTextWidth(t,12);return F+=l+2*S()+i,"translate("+e+","+r+")"})).merge(M).append("circle").classed("legend-circle",!0).attr("cx",l/2).attr("cy",-5).attr("r",l/2).style("fill",_).style("stroke-width",1),k.select(".legend-group").selectAll("g.legend-entry").append("text").classed("legend-entry-name",!0).text(b).attr("x",S()).style("font-size","12px").style("letter-spacing","0.5px"),k.select(".legend-group").selectAll("g.legend-entry").exit().transition().style("opacity",0).remove(),E=k.select(".legend-line").node().getBoundingClientRect().width+l,O-E<=0&&(i=k.selectAll(".legend-entry"),a=i.size(),f=j/2*1.7,s=k.select(".legend-group").append("g").classed("legend-line",!0).attr("transform","translate(0, "+f+")"),(h=i.filter(":nth-child("+a+")")).attr("transform","translate("+l+",0)"),s.append((function(){return h.node()}))),C=k.select("g.legend-container-group").node().getBoundingClientRect().width+S(),U=(D=e-C)/2,D>0&&k.select("g.legend-container-group").attr("transform","translate("+U+",0)")):function(){k.select(".legend-group").selectAll("g").remove(),(M=k.select(".legend-group").selectAll("g.legend-line").data(A)).enter().append("g").classed("legend-line",!0).append("g").classed("legend-entry",!0).attr("data-item",m).attr("transform",(function(n,t){return"translate("+(l+S())+","+(t+1)*(j/(A.length+1))+")"})).merge(M).append("circle").classed("legend-circle",!0).attr("cx",l/2).attr("cy",-5).attr("r",l/2).style("fill",_).style("stroke-width",1),k.select(".legend-group").selectAll("g.legend-line").selectAll("g.legend-entry").append("text").classed("legend-entry-name",!0).text(b).attr("x",S()).style("font-size","12px").style("letter-spacing","0.5px"),p?k.select(".legend-group").selectAll("g.legend-line").selectAll("g.legend-entry").append("text").classed("legend-entry-value",!0).text(w).attr("x",O-40).style("font-size","12px").style("letter-spacing","0.8px").style("text-anchor","end").style("startOffset","100%"):function(){var n=k.select("g.legend-container-group").node().getBoundingClientRect().width,t=e-n,r=t/2-n/2;t>0&&k.select("g.legend-container-group").attr("transform","translate("+r+",0)")}();k.select(".legend-group").selectAll("g.legend-line").exit().transition().style("opacity",0).remove()}(),g&&(N(),T(g))}))}function N(){k.select(".legend-group").selectAll("g.legend-entry").classed("is-faded",!1)}function T(n){var t=k.select('[data-item="'+n+'"]');t.nodes().length&&(k.select(".legend-group").selectAll("g.legend-entry").classed("is-faded",!0),t.classed("is-faded",!1))}function S(){return f*l}return C.clearHighlight=function(){N()},C.colorSchema=function(n){return arguments.length?(y=n,this):y},C.height=function(n){return arguments.length?(c=n,this):c},C.highlight=function(n){N(),T(n)},C.highlightEntryById=function(n){return arguments.length?(g=n,this):g},C.isHorizontal=function(n){return arguments.length?(d=n,this):d},C.margin=function(t){return arguments.length?(n=i({},n,t),this):n},C.marginRatio=function(n){return arguments.length?(f=n,this):f},C.markerSize=function(n){return arguments.length?(l=n,this):l},C.numberFormat=function(n){return arguments.length?(s=n,this):s},C.unit=function(n){return arguments.length?(h=n,this):h},C.width=function(n){return arguments.length?(e=n,this):e},C}}.call(t,e,t,n))||(n.exports=r)}])}));
//# sourceMappingURL=legend.min.js.map

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.miniTooltip=n():(t.britecharts=t.britecharts||{},t.britecharts.miniTooltip=n())}(window,(function(){return function(t){var n={};function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:r})},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.t=function(t,n){if(1&n&&(t=e(t)),8&n)return t;if(4&n&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(e.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&n&&"string"!=typeof t)for(var i in t)e.d(r,i,function(n){return t[n]}.bind(null,i));return r},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.p="",e(e.s=102)}([,,function(t,n,e){"use strict";e.r(n);var r=function(t,n){return t<n?-1:t>n?1:t>=n?0:NaN},i=function(t){var n;return 1===t.length&&(n=t,t=function(t,e){return r(n(t),e)}),{left:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var u=r+i>>>1;t(n[u],e)<0?r=u+1:i=u}return r},right:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var u=r+i>>>1;t(n[u],e)>0?i=u:r=u+1}return r}}};var u=i(r),o=u.right,a=u.left,c=o,s=function(t,n){null==n&&(n=l);for(var e=0,r=t.length-1,i=t[0],u=new Array(r<0?0:r);e<r;)u[e]=n(i,i=t[++e]);return u};function l(t,n){return[t,n]}var f=function(t,n,e){var r,i,u,o,a=t.length,c=n.length,s=new Array(a*c);for(null==e&&(e=l),r=u=0;r<a;++r)for(o=t[r],i=0;i<c;++i,++u)s[u]=e(o,n[i]);return s},h=function(t,n){return n<t?-1:n>t?1:n>=t?0:NaN},d=function(t){return null===t?NaN:+t},p=function(t,n){var e,r,i=t.length,u=0,o=-1,a=0,c=0;if(null==n)for(;++o<i;)isNaN(e=d(t[o]))||(c+=(r=e-a)*(e-(a+=r/++u)));else for(;++o<i;)isNaN(e=d(n(t[o],o,t)))||(c+=(r=e-a)*(e-(a+=r/++u)));if(u>1)return c/(u-1)},v=function(t,n){var e=p(t,n);return e?Math.sqrt(e):e},g=function(t,n){var e,r,i,u=t.length,o=-1;if(null==n){for(;++o<u;)if(null!=(e=t[o])&&e>=e)for(r=i=e;++o<u;)null!=(e=t[o])&&(r>e&&(r=e),i<e&&(i=e))}else for(;++o<u;)if(null!=(e=n(t[o],o,t))&&e>=e)for(r=i=e;++o<u;)null!=(e=n(t[o],o,t))&&(r>e&&(r=e),i<e&&(i=e));return[r,i]},y=Array.prototype,m=y.slice,w=y.map,b=function(t){return function(){return t}},_=function(t){return t},x=function(t,n,e){t=+t,n=+n,e=(i=arguments.length)<2?(n=t,t=0,1):i<3?1:+e;for(var r=-1,i=0|Math.max(0,Math.ceil((n-t)/e)),u=new Array(i);++r<i;)u[r]=t+r*e;return u},M=Math.sqrt(50),O=Math.sqrt(10),j=Math.sqrt(2),A=function(t,n,e){var r,i,u,o,a=-1;if(e=+e,(t=+t)===(n=+n)&&e>0)return[t];if((r=n<t)&&(i=t,t=n,n=i),0===(o=N(t,n,e))||!isFinite(o))return[];if(o>0)for(t=Math.ceil(t/o),n=Math.floor(n/o),u=new Array(i=Math.ceil(n-t+1));++a<i;)u[a]=(t+a)*o;else for(t=Math.floor(t*o),n=Math.ceil(n*o),u=new Array(i=Math.ceil(t-n+1));++a<i;)u[a]=(t-a)/o;return r&&u.reverse(),u};function N(t,n,e){var r=(n-t)/Math.max(0,e),i=Math.floor(Math.log(r)/Math.LN10),u=r/Math.pow(10,i);return i>=0?(u>=M?10:u>=O?5:u>=j?2:1)*Math.pow(10,i):-Math.pow(10,-i)/(u>=M?10:u>=O?5:u>=j?2:1)}function k(t,n,e){var r=Math.abs(n-t)/Math.max(0,e),i=Math.pow(10,Math.floor(Math.log(r)/Math.LN10)),u=r/i;return u>=M?i*=10:u>=O?i*=5:u>=j&&(i*=2),n<t?-i:i}var E=function(t){return Math.ceil(Math.log(t.length)/Math.LN2)+1},S=function(){var t=_,n=g,e=E;function r(r){var i,u,o=r.length,a=new Array(o);for(i=0;i<o;++i)a[i]=t(r[i],i,r);var s=n(a),l=s[0],f=s[1],h=e(a,l,f);Array.isArray(h)||(h=k(l,f,h),h=x(Math.ceil(l/h)*h,f,h));for(var d=h.length;h[0]<=l;)h.shift(),--d;for(;h[d-1]>f;)h.pop(),--d;var p,v=new Array(d+1);for(i=0;i<=d;++i)(p=v[i]=[]).x0=i>0?h[i-1]:l,p.x1=i<d?h[i]:f;for(i=0;i<o;++i)l<=(u=a[i])&&u<=f&&v[c(h,u,0,d)].push(r[i]);return v}return r.value=function(n){return arguments.length?(t="function"==typeof n?n:b(n),r):t},r.domain=function(t){return arguments.length?(n="function"==typeof t?t:b([t[0],t[1]]),r):n},r.thresholds=function(t){return arguments.length?(e="function"==typeof t?t:Array.isArray(t)?b(m.call(t)):b(t),r):e},r},P=function(t,n,e){if(null==e&&(e=d),r=t.length){if((n=+n)<=0||r<2)return+e(t[0],0,t);if(n>=1)return+e(t[r-1],r-1,t);var r,i=(r-1)*n,u=Math.floor(i),o=+e(t[u],u,t);return o+(+e(t[u+1],u+1,t)-o)*(i-u)}},I=function(t,n,e){return t=w.call(t,d).sort(r),Math.ceil((e-n)/(2*(P(t,.75)-P(t,.25))*Math.pow(t.length,-1/3)))},C=function(t,n,e){return Math.ceil((e-n)/(3.5*v(t)*Math.pow(t.length,-1/3)))},q=function(t,n){var e,r,i=t.length,u=-1;if(null==n){for(;++u<i;)if(null!=(e=t[u])&&e>=e)for(r=e;++u<i;)null!=(e=t[u])&&e>r&&(r=e)}else for(;++u<i;)if(null!=(e=n(t[u],u,t))&&e>=e)for(r=e;++u<i;)null!=(e=n(t[u],u,t))&&e>r&&(r=e);return r},T=function(t,n){var e,r=t.length,i=r,u=-1,o=0;if(null==n)for(;++u<r;)isNaN(e=d(t[u]))?--i:o+=e;else for(;++u<r;)isNaN(e=d(n(t[u],u,t)))?--i:o+=e;if(i)return o/i},L=function(t,n){var e,i=t.length,u=-1,o=[];if(null==n)for(;++u<i;)isNaN(e=d(t[u]))||o.push(e);else for(;++u<i;)isNaN(e=d(n(t[u],u,t)))||o.push(e);return P(o.sort(r),.5)},B=function(t){for(var n,e,r,i=t.length,u=-1,o=0;++u<i;)o+=t[u].length;for(e=new Array(o);--i>=0;)for(n=(r=t[i]).length;--n>=0;)e[--o]=r[n];return e},X=function(t,n){var e,r,i=t.length,u=-1;if(null==n){for(;++u<i;)if(null!=(e=t[u])&&e>=e)for(r=e;++u<i;)null!=(e=t[u])&&r>e&&(r=e)}else for(;++u<i;)if(null!=(e=n(t[u],u,t))&&e>=e)for(r=e;++u<i;)null!=(e=n(t[u],u,t))&&r>e&&(r=e);return r},z=function(t,n){for(var e=n.length,r=new Array(e);e--;)r[e]=t[n[e]];return r},F=function(t,n){if(e=t.length){var e,i,u=0,o=0,a=t[o];for(null==n&&(n=r);++u<e;)(n(i=t[u],a)<0||0!==n(a,a))&&(a=i,o=u);return 0===n(a,a)?o:void 0}},R=function(t,n,e){for(var r,i,u=(null==e?t.length:e)-(n=null==n?0:+n);u;)i=Math.random()*u--|0,r=t[u+n],t[u+n]=t[i+n],t[i+n]=r;return t},D=function(t,n){var e,r=t.length,i=-1,u=0;if(null==n)for(;++i<r;)(e=+t[i])&&(u+=e);else for(;++i<r;)(e=+n(t[i],i,t))&&(u+=e);return u},$=function(t){if(!(i=t.length))return[];for(var n=-1,e=X(t,V),r=new Array(e);++n<e;)for(var i,u=-1,o=r[n]=new Array(i);++u<i;)o[u]=t[u][n];return r};function V(t){return t.length}var Y=function(){return $(arguments)};e.d(n,"bisect",(function(){return c})),e.d(n,"bisectRight",(function(){return o})),e.d(n,"bisectLeft",(function(){return a})),e.d(n,"ascending",(function(){return r})),e.d(n,"bisector",(function(){return i})),e.d(n,"cross",(function(){return f})),e.d(n,"descending",(function(){return h})),e.d(n,"deviation",(function(){return v})),e.d(n,"extent",(function(){return g})),e.d(n,"histogram",(function(){return S})),e.d(n,"thresholdFreedmanDiaconis",(function(){return I})),e.d(n,"thresholdScott",(function(){return C})),e.d(n,"thresholdSturges",(function(){return E})),e.d(n,"max",(function(){return q})),e.d(n,"mean",(function(){return T})),e.d(n,"median",(function(){return L})),e.d(n,"merge",(function(){return B})),e.d(n,"min",(function(){return X})),e.d(n,"pairs",(function(){return s})),e.d(n,"permute",(function(){return z})),e.d(n,"quantile",(function(){return P})),e.d(n,"range",(function(){return x})),e.d(n,"scan",(function(){return F})),e.d(n,"shuffle",(function(){return R})),e.d(n,"sum",(function(){return D})),e.d(n,"ticks",(function(){return A})),e.d(n,"tickIncrement",(function(){return N})),e.d(n,"tickStep",(function(){return k})),e.d(n,"transpose",(function(){return $})),e.d(n,"variance",(function(){return p})),e.d(n,"zip",(function(){return Y}))},,,function(t,n,e){"use strict";n.a=function(t,n){return t=+t,n=+n,function(e){return t*(1-e)+n*e}}},function(t,n,e){"use strict";e.r(n);var r=e(12),i=e(32),u=function(t){return Object(i.a)(Object(r.a)(t).call(document.documentElement))},o=0;function a(){return new c}function c(){this._="@"+(++o).toString(36)}c.prototype=a.prototype={constructor:c,get:function(t){for(var n=this._;!(n in t);)if(!(t=t.parentNode))return;return t[n]},set:function(t,n){return t[this._]=n},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}};var s=e(34),l=e(59),f=e(20),h=e(14),d=e(13),p=e(9),v=function(t){return"string"==typeof t?new p.a([document.querySelectorAll(t)],[document.documentElement]):new p.a([null==t?[]:t],p.c)},g=e(19),y=e(33),m=e(35),w=e(60),b=e(22),_=function(t,n){null==n&&(n=Object(b.a)().touches);for(var e=0,r=n?n.length:0,i=new Array(r);e<r;++e)i[e]=Object(d.a)(t,n[e]);return i},x=e(21),M=e(17);e.d(n,"create",(function(){return u})),e.d(n,"creator",(function(){return r.a})),e.d(n,"local",(function(){return a})),e.d(n,"matcher",(function(){return s.a})),e.d(n,"mouse",(function(){return l.a})),e.d(n,"namespace",(function(){return f.a})),e.d(n,"namespaces",(function(){return h.a})),e.d(n,"clientPoint",(function(){return d.a})),e.d(n,"select",(function(){return i.a})),e.d(n,"selectAll",(function(){return v})),e.d(n,"selection",(function(){return p.b})),e.d(n,"selector",(function(){return g.a})),e.d(n,"selectorAll",(function(){return y.a})),e.d(n,"style",(function(){return m.b})),e.d(n,"touch",(function(){return w.a})),e.d(n,"touches",(function(){return _})),e.d(n,"window",(function(){return x.a})),e.d(n,"event",(function(){return M.c})),e.d(n,"customEvent",(function(){return M.a}))},function(t,n,e){"use strict";e.d(n,"a",(function(){return i})),e.d(n,"d",(function(){return u})),e.d(n,"c",(function(){return o})),e.d(n,"e",(function(){return b})),e.d(n,"h",(function(){return M})),e.d(n,"g",(function(){return O})),e.d(n,"b",(function(){return j})),e.d(n,"f",(function(){return P}));var r=e(11);function i(){}var u=.7,o=1/u,a="\\s*([+-]?\\d+)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",s="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",l=/^#([0-9a-f]{3,8})$/,f=new RegExp("^rgb\\("+[a,a,a]+"\\)$"),h=new RegExp("^rgb\\("+[s,s,s]+"\\)$"),d=new RegExp("^rgba\\("+[a,a,a,c]+"\\)$"),p=new RegExp("^rgba\\("+[s,s,s,c]+"\\)$"),v=new RegExp("^hsl\\("+[c,s,s]+"\\)$"),g=new RegExp("^hsla\\("+[c,s,s,c]+"\\)$"),y={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};function m(){return this.rgb().formatHex()}function w(){return this.rgb().formatRgb()}function b(t){var n,e;return t=(t+"").trim().toLowerCase(),(n=l.exec(t))?(e=n[1].length,n=parseInt(n[1],16),6===e?_(n):3===e?new j(n>>8&15|n>>4&240,n>>4&15|240&n,(15&n)<<4|15&n,1):8===e?new j(n>>24&255,n>>16&255,n>>8&255,(255&n)/255):4===e?new j(n>>12&15|n>>8&240,n>>8&15|n>>4&240,n>>4&15|240&n,((15&n)<<4|15&n)/255):null):(n=f.exec(t))?new j(n[1],n[2],n[3],1):(n=h.exec(t))?new j(255*n[1]/100,255*n[2]/100,255*n[3]/100,1):(n=d.exec(t))?x(n[1],n[2],n[3],n[4]):(n=p.exec(t))?x(255*n[1]/100,255*n[2]/100,255*n[3]/100,n[4]):(n=v.exec(t))?E(n[1],n[2]/100,n[3]/100,1):(n=g.exec(t))?E(n[1],n[2]/100,n[3]/100,n[4]):y.hasOwnProperty(t)?_(y[t]):"transparent"===t?new j(NaN,NaN,NaN,0):null}function _(t){return new j(t>>16&255,t>>8&255,255&t,1)}function x(t,n,e,r){return r<=0&&(t=n=e=NaN),new j(t,n,e,r)}function M(t){return t instanceof i||(t=b(t)),t?new j((t=t.rgb()).r,t.g,t.b,t.opacity):new j}function O(t,n,e,r){return 1===arguments.length?M(t):new j(t,n,e,null==r?1:r)}function j(t,n,e,r){this.r=+t,this.g=+n,this.b=+e,this.opacity=+r}function A(){return"#"+k(this.r)+k(this.g)+k(this.b)}function N(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}function k(t){return((t=Math.max(0,Math.min(255,Math.round(t)||0)))<16?"0":"")+t.toString(16)}function E(t,n,e,r){return r<=0?t=n=e=NaN:e<=0||e>=1?t=n=NaN:n<=0&&(t=NaN),new I(t,n,e,r)}function S(t){if(t instanceof I)return new I(t.h,t.s,t.l,t.opacity);if(t instanceof i||(t=b(t)),!t)return new I;if(t instanceof I)return t;var n=(t=t.rgb()).r/255,e=t.g/255,r=t.b/255,u=Math.min(n,e,r),o=Math.max(n,e,r),a=NaN,c=o-u,s=(o+u)/2;return c?(a=n===o?(e-r)/c+6*(e<r):e===o?(r-n)/c+2:(n-e)/c+4,c/=s<.5?o+u:2-o-u,a*=60):c=s>0&&s<1?0:a,new I(a,c,s,t.opacity)}function P(t,n,e,r){return 1===arguments.length?S(t):new I(t,n,e,null==r?1:r)}function I(t,n,e,r){this.h=+t,this.s=+n,this.l=+e,this.opacity=+r}function C(t,n,e){return 255*(t<60?n+(e-n)*t/60:t<180?e:t<240?n+(e-n)*(240-t)/60:n)}Object(r.a)(i,b,{copy:function(t){return Object.assign(new this.constructor,this,t)},displayable:function(){return this.rgb().displayable()},hex:m,formatHex:m,formatHsl:function(){return S(this).formatHsl()},formatRgb:w,toString:w}),Object(r.a)(j,O,Object(r.b)(i,{brighter:function(t){return t=null==t?o:Math.pow(o,t),new j(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?u:Math.pow(u,t),new j(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return-.5<=this.r&&this.r<255.5&&-.5<=this.g&&this.g<255.5&&-.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1},hex:A,formatHex:A,formatRgb:N,toString:N})),Object(r.a)(I,P,Object(r.b)(i,{brighter:function(t){return t=null==t?o:Math.pow(o,t),new I(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?u:Math.pow(u,t),new I(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),n=isNaN(t)||isNaN(this.s)?0:this.s,e=this.l,r=e+(e<.5?e:1-e)*n,i=2*e-r;return new j(C(t>=240?t-240:t+120,i,r),C(t,i,r),C(t<120?t+240:t-120,i,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1},formatHsl:function(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"hsl(":"hsla(")+(this.h||0)+", "+100*(this.s||0)+"%, "+100*(this.l||0)+"%"+(1===t?")":", "+t+")")}}))},function(t,n,e){"use strict";var r=e(18);n.a=function(t){return(t=Object(r.a)(Math.abs(t)))?t[1]:NaN}},function(t,n,e){"use strict";var r=e(19),i=e(33),u=e(34),o=function(t){return new Array(t.length)};function a(t,n){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=n}a.prototype={constructor:a,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,n){return this._parent.insertBefore(t,n)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}};function c(t,n,e,r,i,u){for(var o,c=0,s=n.length,l=u.length;c<l;++c)(o=n[c])?(o.__data__=u[c],r[c]=o):e[c]=new a(t,u[c]);for(;c<s;++c)(o=n[c])&&(i[c]=o)}function s(t,n,e,r,i,u,o){var c,s,l,f={},h=n.length,d=u.length,p=new Array(h);for(c=0;c<h;++c)(s=n[c])&&(p[c]=l="$"+o.call(s,s.__data__,c,n),l in f?i[c]=s:f[l]=s);for(c=0;c<d;++c)(s=f[l="$"+o.call(t,u[c],c,u)])?(r[c]=s,s.__data__=u[c],f[l]=null):e[c]=new a(t,u[c]);for(c=0;c<h;++c)(s=n[c])&&f[p[c]]===s&&(i[c]=s)}function l(t,n){return t<n?-1:t>n?1:t>=n?0:NaN}var f=e(20);function h(t){return function(){this.removeAttribute(t)}}function d(t){return function(){this.removeAttributeNS(t.space,t.local)}}function p(t,n){return function(){this.setAttribute(t,n)}}function v(t,n){return function(){this.setAttributeNS(t.space,t.local,n)}}function g(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttribute(t):this.setAttribute(t,e)}}function y(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,e)}}var m=e(35);function w(t){return function(){delete this[t]}}function b(t,n){return function(){this[t]=n}}function _(t,n){return function(){var e=n.apply(this,arguments);null==e?delete this[t]:this[t]=e}}function x(t){return t.trim().split(/^|\s+/)}function M(t){return t.classList||new O(t)}function O(t){this._node=t,this._names=x(t.getAttribute("class")||"")}function j(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.add(n[r])}function A(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.remove(n[r])}function N(t){return function(){j(this,t)}}function k(t){return function(){A(this,t)}}function E(t,n){return function(){(n.apply(this,arguments)?j:A)(this,t)}}O.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var n=this._names.indexOf(t);n>=0&&(this._names.splice(n,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}};function S(){this.textContent=""}function P(t){return function(){this.textContent=t}}function I(t){return function(){var n=t.apply(this,arguments);this.textContent=null==n?"":n}}function C(){this.innerHTML=""}function q(t){return function(){this.innerHTML=t}}function T(t){return function(){var n=t.apply(this,arguments);this.innerHTML=null==n?"":n}}function L(){this.nextSibling&&this.parentNode.appendChild(this)}function B(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}var X=e(12);function z(){return null}function F(){var t=this.parentNode;t&&t.removeChild(this)}function R(){var t=this.cloneNode(!1),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}function D(){var t=this.cloneNode(!0),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}var $=e(17),V=e(21);function Y(t,n,e){var r=Object(V.a)(t),i=r.CustomEvent;"function"==typeof i?i=new i(n,e):(i=r.document.createEvent("Event"),e?(i.initEvent(n,e.bubbles,e.cancelable),i.detail=e.detail):i.initEvent(n,!1,!1)),t.dispatchEvent(i)}function H(t,n){return function(){return Y(this,t,n)}}function Q(t,n){return function(){return Y(this,t,n.apply(this,arguments))}}e.d(n,"c",(function(){return U})),e.d(n,"a",(function(){return G}));var U=[null];function G(t,n){this._groups=t,this._parents=n}function Z(){return new G([[document.documentElement]],U)}G.prototype=Z.prototype={constructor:G,select:function(t){"function"!=typeof t&&(t=Object(r.a)(t));for(var n=this._groups,e=n.length,i=new Array(e),u=0;u<e;++u)for(var o,a,c=n[u],s=c.length,l=i[u]=new Array(s),f=0;f<s;++f)(o=c[f])&&(a=t.call(o,o.__data__,f,c))&&("__data__"in o&&(a.__data__=o.__data__),l[f]=a);return new G(i,this._parents)},selectAll:function(t){"function"!=typeof t&&(t=Object(i.a)(t));for(var n=this._groups,e=n.length,r=[],u=[],o=0;o<e;++o)for(var a,c=n[o],s=c.length,l=0;l<s;++l)(a=c[l])&&(r.push(t.call(a,a.__data__,l,c)),u.push(a));return new G(r,u)},filter:function(t){"function"!=typeof t&&(t=Object(u.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o,a=n[i],c=a.length,s=r[i]=[],l=0;l<c;++l)(o=a[l])&&t.call(o,o.__data__,l,a)&&s.push(o);return new G(r,this._parents)},data:function(t,n){if(!t)return g=new Array(this.size()),h=-1,this.each((function(t){g[++h]=t})),g;var e,r=n?s:c,i=this._parents,u=this._groups;"function"!=typeof t&&(e=t,t=function(){return e});for(var o=u.length,a=new Array(o),l=new Array(o),f=new Array(o),h=0;h<o;++h){var d=i[h],p=u[h],v=p.length,g=t.call(d,d&&d.__data__,h,i),y=g.length,m=l[h]=new Array(y),w=a[h]=new Array(y);r(d,p,m,w,f[h]=new Array(v),g,n);for(var b,_,x=0,M=0;x<y;++x)if(b=m[x]){for(x>=M&&(M=x+1);!(_=w[M])&&++M<y;);b._next=_||null}}return(a=new G(a,i))._enter=l,a._exit=f,a},enter:function(){return new G(this._enter||this._groups.map(o),this._parents)},exit:function(){return new G(this._exit||this._groups.map(o),this._parents)},join:function(t,n,e){var r=this.enter(),i=this,u=this.exit();return r="function"==typeof t?t(r):r.append(t+""),null!=n&&(i=n(i)),null==e?u.remove():e(u),r&&i?r.merge(i).order():i},merge:function(t){for(var n=this._groups,e=t._groups,r=n.length,i=e.length,u=Math.min(r,i),o=new Array(r),a=0;a<u;++a)for(var c,s=n[a],l=e[a],f=s.length,h=o[a]=new Array(f),d=0;d<f;++d)(c=s[d]||l[d])&&(h[d]=c);for(;a<r;++a)o[a]=n[a];return new G(o,this._parents)},order:function(){for(var t=this._groups,n=-1,e=t.length;++n<e;)for(var r,i=t[n],u=i.length-1,o=i[u];--u>=0;)(r=i[u])&&(o&&4^r.compareDocumentPosition(o)&&o.parentNode.insertBefore(r,o),o=r);return this},sort:function(t){function n(n,e){return n&&e?t(n.__data__,e.__data__):!n-!e}t||(t=l);for(var e=this._groups,r=e.length,i=new Array(r),u=0;u<r;++u){for(var o,a=e[u],c=a.length,s=i[u]=new Array(c),f=0;f<c;++f)(o=a[f])&&(s[f]=o);s.sort(n)}return new G(i,this._parents).order()},call:function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this},nodes:function(){var t=new Array(this.size()),n=-1;return this.each((function(){t[++n]=this})),t},node:function(){for(var t=this._groups,n=0,e=t.length;n<e;++n)for(var r=t[n],i=0,u=r.length;i<u;++i){var o=r[i];if(o)return o}return null},size:function(){var t=0;return this.each((function(){++t})),t},empty:function(){return!this.node()},each:function(t){for(var n=this._groups,e=0,r=n.length;e<r;++e)for(var i,u=n[e],o=0,a=u.length;o<a;++o)(i=u[o])&&t.call(i,i.__data__,o,u);return this},attr:function(t,n){var e=Object(f.a)(t);if(arguments.length<2){var r=this.node();return e.local?r.getAttributeNS(e.space,e.local):r.getAttribute(e)}return this.each((null==n?e.local?d:h:"function"==typeof n?e.local?y:g:e.local?v:p)(e,n))},style:m.a,property:function(t,n){return arguments.length>1?this.each((null==n?w:"function"==typeof n?_:b)(t,n)):this.node()[t]},classed:function(t,n){var e=x(t+"");if(arguments.length<2){for(var r=M(this.node()),i=-1,u=e.length;++i<u;)if(!r.contains(e[i]))return!1;return!0}return this.each(("function"==typeof n?E:n?N:k)(e,n))},text:function(t){return arguments.length?this.each(null==t?S:("function"==typeof t?I:P)(t)):this.node().textContent},html:function(t){return arguments.length?this.each(null==t?C:("function"==typeof t?T:q)(t)):this.node().innerHTML},raise:function(){return this.each(L)},lower:function(){return this.each(B)},append:function(t){var n="function"==typeof t?t:Object(X.a)(t);return this.select((function(){return this.appendChild(n.apply(this,arguments))}))},insert:function(t,n){var e="function"==typeof t?t:Object(X.a)(t),i=null==n?z:"function"==typeof n?n:Object(r.a)(n);return this.select((function(){return this.insertBefore(e.apply(this,arguments),i.apply(this,arguments)||null)}))},remove:function(){return this.each(F)},clone:function(t){return this.select(t?D:R)},datum:function(t){return arguments.length?this.property("__data__",t):this.node().__data__},on:$.b,dispatch:function(t,n){return this.each(("function"==typeof n?Q:H)(t,n))}};n.b=Z},function(t,n,e){"use strict";e.d(n,"c",(function(){return u})),e.d(n,"b",(function(){return o})),e.d(n,"a",(function(){return a}));var r=e(23);function i(t,n){return function(e){return t+e*n}}function u(t,n){var e=n-t;return e?i(t,e>180||e<-180?e-360*Math.round(e/360):e):Object(r.a)(isNaN(t)?n:t)}function o(t){return 1==(t=+t)?a:function(n,e){return e-n?function(t,n,e){return t=Math.pow(t,e),n=Math.pow(n,e)-t,e=1/e,function(r){return Math.pow(t+r*n,e)}}(n,e,t):Object(r.a)(isNaN(n)?e:n)}}function a(t,n){var e=n-t;return e?i(t,e):Object(r.a)(isNaN(t)?n:t)}},function(t,n,e){"use strict";function r(t,n){var e=Object.create(t.prototype);for(var r in n)e[r]=n[r];return e}e.d(n,"b",(function(){return r})),n.a=function(t,n,e){t.prototype=n.prototype=e,e.constructor=t}},function(t,n,e){"use strict";var r=e(20),i=e(14);function u(t){return function(){var n=this.ownerDocument,e=this.namespaceURI;return e===i.b&&n.documentElement.namespaceURI===i.b?n.createElement(t):n.createElementNS(e,t)}}function o(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}n.a=function(t){var n=Object(r.a)(t);return(n.local?o:u)(n)}},function(t,n,e){"use strict";n.a=function(t,n){var e=t.ownerSVGElement||t;if(e.createSVGPoint){var r=e.createSVGPoint();return r.x=n.clientX,r.y=n.clientY,[(r=r.matrixTransform(t.getScreenCTM().inverse())).x,r.y]}var i=t.getBoundingClientRect();return[n.clientX-i.left-t.clientLeft,n.clientY-i.top-t.clientTop]}},function(t,n,e){"use strict";e.d(n,"b",(function(){return r}));var r="http://www.w3.org/1999/xhtml";n.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},,,function(t,n,e){"use strict";e.d(n,"c",(function(){return i})),e.d(n,"a",(function(){return l}));var r={},i=null;"undefined"!=typeof document&&("onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"}));function u(t,n,e){return t=o(t,n,e),function(n){var e=n.relatedTarget;e&&(e===this||8&e.compareDocumentPosition(this))||t.call(this,n)}}function o(t,n,e){return function(r){var u=i;i=r;try{t.call(this,this.__data__,n,e)}finally{i=u}}}function a(t){return t.trim().split(/^|\s+/).map((function(t){var n="",e=t.indexOf(".");return e>=0&&(n=t.slice(e+1),t=t.slice(0,e)),{type:t,name:n}}))}function c(t){return function(){var n=this.__on;if(n){for(var e,r=0,i=-1,u=n.length;r<u;++r)e=n[r],t.type&&e.type!==t.type||e.name!==t.name?n[++i]=e:this.removeEventListener(e.type,e.listener,e.capture);++i?n.length=i:delete this.__on}}}function s(t,n,e){var i=r.hasOwnProperty(t.type)?u:o;return function(r,u,o){var a,c=this.__on,s=i(n,u,o);if(c)for(var l=0,f=c.length;l<f;++l)if((a=c[l]).type===t.type&&a.name===t.name)return this.removeEventListener(a.type,a.listener,a.capture),this.addEventListener(a.type,a.listener=s,a.capture=e),void(a.value=n);this.addEventListener(t.type,s,e),a={type:t.type,name:t.name,value:n,listener:s,capture:e},c?c.push(a):this.__on=[a]}}function l(t,n,e,r){var u=i;t.sourceEvent=i,i=t;try{return n.apply(e,r)}finally{i=u}}n.b=function(t,n,e){var r,i,u=a(t+""),o=u.length;if(!(arguments.length<2)){for(l=n?s:c,null==e&&(e=!1),r=0;r<o;++r)this.each(l(u[r],n,e));return this}var l=this.node().__on;if(l)for(var f,h=0,d=l.length;h<d;++h)for(r=0,f=l[h];r<o;++r)if((i=u[r]).type===f.type&&i.name===f.name)return f.value}},function(t,n,e){"use strict";n.a=function(t,n){if((e=(t=n?t.toExponential(n-1):t.toExponential()).indexOf("e"))<0)return null;var e,r=t.slice(0,e);return[r.length>1?r[0]+r.slice(2):r,+t.slice(e+1)]}},function(t,n,e){"use strict";function r(){}n.a=function(t){return null==t?r:function(){return this.querySelector(t)}}},function(t,n,e){"use strict";var r=e(14);n.a=function(t){var n=t+="",e=n.indexOf(":");return e>=0&&"xmlns"!==(n=t.slice(0,e))&&(t=t.slice(e+1)),r.a.hasOwnProperty(n)?{space:r.a[n],local:t}:t}},function(t,n,e){"use strict";n.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,n,e){"use strict";var r=e(17);n.a=function(){for(var t,n=r.c;t=n.sourceEvent;)n=t;return n}},function(t,n,e){"use strict";n.a=function(t){return function(){return t}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"a",(function(){return u}));var r=/^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;function i(t){if(!(n=r.exec(t)))throw new Error("invalid format: "+t);var n;return new u({fill:n[1],align:n[2],sign:n[3],symbol:n[4],zero:n[5],width:n[6],comma:n[7],precision:n[8]&&n[8].slice(1),trim:n[9],type:n[10]})}function u(t){this.fill=void 0===t.fill?" ":t.fill+"",this.align=void 0===t.align?">":t.align+"",this.sign=void 0===t.sign?"-":t.sign+"",this.symbol=void 0===t.symbol?"":t.symbol+"",this.zero=!!t.zero,this.width=void 0===t.width?void 0:+t.width,this.comma=!!t.comma,this.precision=void 0===t.precision?void 0:+t.precision,this.trim=!!t.trim,this.type=void 0===t.type?"":t.type+""}i.prototype=u.prototype,u.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(void 0===this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(void 0===this.precision?"":"."+Math.max(0,0|this.precision))+(this.trim?"~":"")+this.type}},,function(t,n,e){"use strict";function r(t,n,e,r,i){var u=t*t,o=u*t;return((1-3*t+3*u-o)*n+(4-6*u+3*o)*e+(1+3*t+3*u-3*o)*r+o*i)/6}e.d(n,"a",(function(){return r})),n.b=function(t){var n=t.length-1;return function(e){var i=e<=0?e=0:e>=1?(e=1,n-1):Math.floor(e*n),u=t[i],o=t[i+1],a=i>0?t[i-1]:2*u-o,c=i<n-1?t[i+2]:2*o-u;return r((e-i/n)*n,a,u,o,c)}}},,,function(t,n,e){"use strict";function r(t){return t*t*t}function i(t){return--t*t*t+1}function u(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.d(n,"a",(function(){return r})),e.d(n,"c",(function(){return i})),e.d(n,"b",(function(){return u}))},,,function(t,n,e){"use strict";var r=e(9);n.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,n,e){"use strict";function r(){return[]}n.a=function(t){return null==t?r:function(){return this.querySelectorAll(t)}}},function(t,n,e){"use strict";n.a=function(t){return function(){return this.matches(t)}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return a}));var r=e(21);function i(t){return function(){this.style.removeProperty(t)}}function u(t,n,e){return function(){this.style.setProperty(t,n,e)}}function o(t,n,e){return function(){var r=n.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,e)}}function a(t,n){return t.style.getPropertyValue(n)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(n)}n.a=function(t,n,e){return arguments.length>1?this.each((null==n?i:"function"==typeof n?o:u)(t,n,null==e?"":e)):a(this.node(),t)}},,function(t,n,e){"use strict";var r,i=e(8),u=e(24),o=e(18),a=function(t,n){var e=Object(o.a)(t,n);if(!e)return t+"";var r=e[0],i=e[1];return i<0?"0."+new Array(-i).join("0")+r:r.length>i+1?r.slice(0,i+1)+"."+r.slice(i+1):r+new Array(i-r.length+2).join("0")},c={"%":function(t,n){return(100*t).toFixed(n)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,n){return t.toExponential(n)},f:function(t,n){return t.toFixed(n)},g:function(t,n){return t.toPrecision(n)},o:function(t){return Math.round(t).toString(8)},p:function(t,n){return a(100*t,n)},r:a,s:function(t,n){var e=Object(o.a)(t,n);if(!e)return t+"";var i=e[0],u=e[1],a=u-(r=3*Math.max(-8,Math.min(8,Math.floor(u/3))))+1,c=i.length;return a===c?i:a>c?i+new Array(a-c+1).join("0"):a>0?i.slice(0,a)+"."+i.slice(a):"0."+new Array(1-a).join("0")+Object(o.a)(t,Math.max(0,n+a-1))[0]},X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}},s=function(t){return t},l=Array.prototype.map,f=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];n.a=function(t){var n,e,o=void 0===t.grouping||void 0===t.thousands?s:(n=l.call(t.grouping,Number),e=t.thousands+"",function(t,r){for(var i=t.length,u=[],o=0,a=n[0],c=0;i>0&&a>0&&(c+a+1>r&&(a=Math.max(1,r-c)),u.push(t.substring(i-=a,i+a)),!((c+=a+1)>r));)a=n[o=(o+1)%n.length];return u.reverse().join(e)}),a=void 0===t.currency?"":t.currency[0]+"",h=void 0===t.currency?"":t.currency[1]+"",d=void 0===t.decimal?".":t.decimal+"",p=void 0===t.numerals?s:function(t){return function(n){return n.replace(/[0-9]/g,(function(n){return t[+n]}))}}(l.call(t.numerals,String)),v=void 0===t.percent?"%":t.percent+"",g=void 0===t.minus?"-":t.minus+"",y=void 0===t.nan?"NaN":t.nan+"";function m(t){var n=(t=Object(u.b)(t)).fill,e=t.align,i=t.sign,s=t.symbol,l=t.zero,m=t.width,w=t.comma,b=t.precision,_=t.trim,x=t.type;"n"===x?(w=!0,x="g"):c[x]||(void 0===b&&(b=12),_=!0,x="g"),(l||"0"===n&&"="===e)&&(l=!0,n="0",e="=");var M="$"===s?a:"#"===s&&/[boxX]/.test(x)?"0"+x.toLowerCase():"",O="$"===s?h:/[%p]/.test(x)?v:"",j=c[x],A=/[defgprs%]/.test(x);function N(t){var u,a,c,s=M,h=O;if("c"===x)h=j(t)+h,t="";else{var v=(t=+t)<0;if(t=isNaN(t)?y:j(Math.abs(t),b),_&&(t=function(t){t:for(var n,e=t.length,r=1,i=-1;r<e;++r)switch(t[r]){case".":i=n=r;break;case"0":0===i&&(i=r),n=r;break;default:if(!+t[r])break t;i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}(t)),v&&0==+t&&(v=!1),s=(v?"("===i?i:g:"-"===i||"("===i?"":i)+s,h=("s"===x?f[8+r/3]:"")+h+(v&&"("===i?")":""),A)for(u=-1,a=t.length;++u<a;)if(48>(c=t.charCodeAt(u))||c>57){h=(46===c?d+t.slice(u+1):t.slice(u))+h,t=t.slice(0,u);break}}w&&!l&&(t=o(t,1/0));var N=s.length+t.length+h.length,k=N<m?new Array(m-N+1).join(n):"";switch(w&&l&&(t=o(k+t,k.length?m-h.length:1/0),k=""),e){case"<":t=s+t+h+k;break;case"=":t=s+k+t+h;break;case"^":t=k.slice(0,N=k.length>>1)+s+t+h+k.slice(N);break;default:t=k+s+t+h}return p(t)}return b=void 0===b?6:/[gprs]/.test(x)?Math.max(1,Math.min(21,b)):Math.max(0,Math.min(20,b)),N.toString=function(){return t+""},N}return{format:m,formatPrefix:function(t,n){var e=m(((t=Object(u.b)(t)).type="f",t)),r=3*Math.max(-8,Math.min(8,Math.floor(Object(i.a)(n)/3))),o=Math.pow(10,-r),a=f[8+r/3];return function(t){return e(o*t)+a}}}}},,function(t,n,e){"use strict";e.d(n,"b",(function(){return c})),e.d(n,"c",(function(){return s}));var r=e(7),i=e(26),u=e(53),o=e(10);function a(t){return function(n){var e,i,u=n.length,o=new Array(u),a=new Array(u),c=new Array(u);for(e=0;e<u;++e)i=Object(r.g)(n[e]),o[e]=i.r||0,a[e]=i.g||0,c[e]=i.b||0;return o=t(o),a=t(a),c=t(c),i.opacity=1,function(t){return i.r=o(t),i.g=a(t),i.b=c(t),i+""}}}n.a=function t(n){var e=Object(o.b)(n);function i(t,n){var i=e((t=Object(r.g)(t)).r,(n=Object(r.g)(n)).r),u=e(t.g,n.g),a=e(t.b,n.b),c=Object(o.a)(t.opacity,n.opacity);return function(n){return t.r=i(n),t.g=u(n),t.b=a(n),t.opacity=c(n),t+""}}return i.gamma=t,i}(1);var c=a(i.b),s=a(u.a)},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"c",(function(){return u})),e.d(n,"a",(function(){return a}));var r,i,u,o=e(37);function a(t){return r=Object(o.a)(t),i=r.format,u=r.formatPrefix,r}a({decimal:".",thousands:",",grouping:[3],currency:["$",""],minus:"-"})},,,,function(t,n,e){"use strict";e.r(n);var r=e(40);e.d(n,"formatDefaultLocale",(function(){return r.a})),e.d(n,"format",(function(){return r.b})),e.d(n,"formatPrefix",(function(){return r.c}));var i=e(37);e.d(n,"formatLocale",(function(){return i.a}));var u=e(24);e.d(n,"formatSpecifier",(function(){return u.b})),e.d(n,"FormatSpecifier",(function(){return u.a}));var o=e(61);e.d(n,"precisionFixed",(function(){return o.a}));var a=e(62);e.d(n,"precisionPrefix",(function(){return a.a}));var c=e(63);e.d(n,"precisionRound",(function(){return c.a}))},,,,,,,,,function(t,n,e){"use strict";var r=e(26);n.a=function(t){var n=t.length;return function(e){var i=Math.floor(((e%=1)<0?++e:e)*n),u=t[(i+n-1)%n],o=t[i%n],a=t[(i+1)%n],c=t[(i+2)%n];return Object(r.a)((e-i/n)*n,u,o,a,c)}}},,function(t,n,e){"use strict";var r=e(5),i=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,u=new RegExp(i.source,"g");n.a=function(t,n){var e,o,a,c=i.lastIndex=u.lastIndex=0,s=-1,l=[],f=[];for(t+="",n+="";(e=i.exec(t))&&(o=u.exec(n));)(a=o.index)>c&&(a=n.slice(c,a),l[s]?l[s]+=a:l[++s]=a),(e=e[0])===(o=o[0])?l[s]?l[s]+=o:l[++s]=o:(l[++s]=null,f.push({i:s,x:Object(r.a)(e,o)})),c=u.lastIndex;return c<n.length&&(a=n.slice(c),l[s]?l[s]+=a:l[++s]=a),l.length<2?f[0]?function(t){return function(n){return t(n)+""}}(f[0].x):function(t){return function(){return t}}(n):(n=f.length,function(t){for(var e,r=0;r<n;++r)l[(e=f[r]).i]=e.x(t);return l.join("")})}},,,,function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t){var n=Object(r.a)();return n.changedTouches&&(n=n.changedTouches[0]),Object(i.a)(t,n)}},function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t,n,e){arguments.length<3&&(e=n,n=Object(r.a)().changedTouches);for(var u,o=0,a=n?n.length:0;o<a;++o)if((u=n[o]).identifier===e)return Object(i.a)(t,u);return null}},function(t,n,e){"use strict";var r=e(8);n.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(n)/3)))-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return t=Math.abs(t),n=Math.abs(n)-t,Math.max(0,Object(r.a)(n)-Object(r.a)(t))+1}},function(t,n,e){"use strict";function r(t){return+t}function i(t){return t*t}function u(t){return t*(2-t)}function o(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.r(n);var a=e(29),c=function t(n){function e(t){return Math.pow(t,n)}return n=+n,e.exponent=t,e}(3),s=function t(n){function e(t){return 1-Math.pow(1-t,n)}return n=+n,e.exponent=t,e}(3),l=function t(n){function e(t){return((t*=2)<=1?Math.pow(t,n):2-Math.pow(2-t,n))/2}return n=+n,e.exponent=t,e}(3),f=Math.PI,h=f/2;function d(t){return 1-Math.cos(t*h)}function p(t){return Math.sin(t*h)}function v(t){return(1-Math.cos(f*t))/2}function g(t){return Math.pow(2,10*t-10)}function y(t){return 1-Math.pow(2,-10*t)}function m(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}function w(t){return 1-Math.sqrt(1-t*t)}function b(t){return Math.sqrt(1- --t*t)}function _(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}var x=7.5625;function M(t){return 1-O(1-t)}function O(t){return(t=+t)<4/11?x*t*t:t<8/11?x*(t-=6/11)*t+.75:t<10/11?x*(t-=9/11)*t+.9375:x*(t-=21/22)*t+63/64}function j(t){return((t*=2)<=1?1-O(1-t):O(t-1)+1)/2}var A=function t(n){function e(t){return t*t*((n+1)*t-n)}return n=+n,e.overshoot=t,e}(1.70158),N=function t(n){function e(t){return--t*t*((n+1)*t+n)+1}return n=+n,e.overshoot=t,e}(1.70158),k=function t(n){function e(t){return((t*=2)<1?t*t*((n+1)*t-n):(t-=2)*t*((n+1)*t+n)+2)/2}return n=+n,e.overshoot=t,e}(1.70158),E=2*Math.PI,S=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=E);function i(t){return n*Math.pow(2,10*--t)*Math.sin((r-t)/e)}return i.amplitude=function(n){return t(n,e*E)},i.period=function(e){return t(n,e)},i}(1,.3),P=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=E);function i(t){return 1-n*Math.pow(2,-10*(t=+t))*Math.sin((t+r)/e)}return i.amplitude=function(n){return t(n,e*E)},i.period=function(e){return t(n,e)},i}(1,.3),I=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=E);function i(t){return((t=2*t-1)<0?n*Math.pow(2,10*t)*Math.sin((r-t)/e):2-n*Math.pow(2,-10*t)*Math.sin((r+t)/e))/2}return i.amplitude=function(n){return t(n,e*E)},i.period=function(e){return t(n,e)},i}(1,.3);e.d(n,"easeLinear",(function(){return r})),e.d(n,"easeQuad",(function(){return o})),e.d(n,"easeQuadIn",(function(){return i})),e.d(n,"easeQuadOut",(function(){return u})),e.d(n,"easeQuadInOut",(function(){return o})),e.d(n,"easeCubic",(function(){return a.b})),e.d(n,"easeCubicIn",(function(){return a.a})),e.d(n,"easeCubicOut",(function(){return a.c})),e.d(n,"easeCubicInOut",(function(){return a.b})),e.d(n,"easePoly",(function(){return l})),e.d(n,"easePolyIn",(function(){return c})),e.d(n,"easePolyOut",(function(){return s})),e.d(n,"easePolyInOut",(function(){return l})),e.d(n,"easeSin",(function(){return v})),e.d(n,"easeSinIn",(function(){return d})),e.d(n,"easeSinOut",(function(){return p})),e.d(n,"easeSinInOut",(function(){return v})),e.d(n,"easeExp",(function(){return m})),e.d(n,"easeExpIn",(function(){return g})),e.d(n,"easeExpOut",(function(){return y})),e.d(n,"easeExpInOut",(function(){return m})),e.d(n,"easeCircle",(function(){return _})),e.d(n,"easeCircleIn",(function(){return w})),e.d(n,"easeCircleOut",(function(){return b})),e.d(n,"easeCircleInOut",(function(){return _})),e.d(n,"easeBounce",(function(){return O})),e.d(n,"easeBounceIn",(function(){return M})),e.d(n,"easeBounceOut",(function(){return O})),e.d(n,"easeBounceInOut",(function(){return j})),e.d(n,"easeBack",(function(){return k})),e.d(n,"easeBackIn",(function(){return A})),e.d(n,"easeBackOut",(function(){return N})),e.d(n,"easeBackInOut",(function(){return k})),e.d(n,"easeElastic",(function(){return P})),e.d(n,"easeElasticIn",(function(){return S})),e.d(n,"easeElasticOut",(function(){return P})),e.d(n,"easeElasticInOut",(function(){return I}))},,,,,function(t,n,e){"use strict";var r={value:function(){}};function i(){for(var t,n=0,e=arguments.length,r={};n<e;++n){if(!(t=arguments[n]+"")||t in r||/[\s.]/.test(t))throw new Error("illegal type: "+t);r[t]=[]}return new u(r)}function u(t){this._=t}function o(t,n){return t.trim().split(/^|\s+/).map((function(t){var e="",r=t.indexOf(".");if(r>=0&&(e=t.slice(r+1),t=t.slice(0,r)),t&&!n.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:e}}))}function a(t,n){for(var e,r=0,i=t.length;r<i;++r)if((e=t[r]).name===n)return e.value}function c(t,n,e){for(var i=0,u=t.length;i<u;++i)if(t[i].name===n){t[i]=r,t=t.slice(0,i).concat(t.slice(i+1));break}return null!=e&&t.push({name:n,value:e}),t}u.prototype=i.prototype={constructor:u,on:function(t,n){var e,r=this._,i=o(t+"",r),u=-1,s=i.length;if(!(arguments.length<2)){if(null!=n&&"function"!=typeof n)throw new Error("invalid callback: "+n);for(;++u<s;)if(e=(t=i[u]).type)r[e]=c(r[e],t.name,n);else if(null==n)for(e in r)r[e]=c(r[e],t.name,null);return this}for(;++u<s;)if((e=(t=i[u]).type)&&(e=a(r[e],t.name)))return e},copy:function(){var t={},n=this._;for(var e in n)t[e]=n[e].slice();return new u(t)},call:function(t,n){if((e=arguments.length-2)>0)for(var e,r,i=new Array(e),u=0;u<e;++u)i[u]=arguments[u+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(u=0,e=(r=this._[t]).length;u<e;++u)r[u].value.apply(n,i)},apply:function(t,n,e){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],i=0,u=r.length;i<u;++i)r[i].value.apply(n,e)}},n.a=i},,,function(t,n,e){"use strict";e.r(n);var r,i,u=e(9),o=e(69),a=0,c=0,s=0,l=0,f=0,h=0,d="object"==typeof performance&&performance.now?performance:Date,p="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};function v(){return f||(p(g),f=d.now()+h)}function g(){f=0}function y(){this._call=this._time=this._next=null}function m(t,n,e){var r=new y;return r.restart(t,n,e),r}function w(){f=(l=d.now())+h,a=c=0;try{!function(){v(),++a;for(var t,n=r;n;)(t=f-n._time)>=0&&n._call.call(null,t),n=n._next;--a}()}finally{a=0,function(){var t,n,e=r,u=1/0;for(;e;)e._call?(u>e._time&&(u=e._time),t=e,e=e._next):(n=e._next,e._next=null,e=t?t._next=n:r=n);i=t,_(u)}(),f=0}}function b(){var t=d.now(),n=t-l;n>1e3&&(h-=n,l=t)}function _(t){a||(c&&(c=clearTimeout(c)),t-f>24?(t<1/0&&(c=setTimeout(w,t-d.now()-h)),s&&(s=clearInterval(s))):(s||(l=d.now(),s=setInterval(b,1e3)),a=1,p(w)))}y.prototype=m.prototype={constructor:y,restart:function(t,n,e){if("function"!=typeof t)throw new TypeError("callback is not a function");e=(null==e?v():+e)+(null==n?0:+n),this._next||i===this||(i?i._next=this:r=this,i=this),this._call=t,this._time=e,_()},stop:function(){this._call&&(this._call=null,this._time=1/0,_())}};var x=function(t,n,e){var r=new y;return n=null==n?0:+n,r.restart((function(e){r.stop(),t(e+n)}),n,e),r},M=Object(o.a)("start","end","cancel","interrupt"),O=[],j=function(t,n,e,r,i,u){var o=t.__transition;if(o){if(e in o)return}else t.__transition={};!function(t,n,e){var r,i=t.__transition;function u(c){var s,l,f,h;if(1!==e.state)return a();for(s in i)if((h=i[s]).name===e.name){if(3===h.state)return x(u);4===h.state?(h.state=6,h.timer.stop(),h.on.call("interrupt",t,t.__data__,h.index,h.group),delete i[s]):+s<n&&(h.state=6,h.timer.stop(),h.on.call("cancel",t,t.__data__,h.index,h.group),delete i[s])}if(x((function(){3===e.state&&(e.state=4,e.timer.restart(o,e.delay,e.time),o(c))})),e.state=2,e.on.call("start",t,t.__data__,e.index,e.group),2===e.state){for(e.state=3,r=new Array(f=e.tween.length),s=0,l=-1;s<f;++s)(h=e.tween[s].value.call(t,t.__data__,e.index,e.group))&&(r[++l]=h);r.length=l+1}}function o(n){for(var i=n<e.duration?e.ease.call(null,n/e.duration):(e.timer.restart(a),e.state=5,1),u=-1,o=r.length;++u<o;)r[u].call(t,i);5===e.state&&(e.on.call("end",t,t.__data__,e.index,e.group),a())}function a(){for(var r in e.state=6,e.timer.stop(),delete i[n],i)return;delete t.__transition}i[n]=e,e.timer=m((function(t){e.state=1,e.timer.restart(u,e.delay,e.time),e.delay<=t&&u(t-e.delay)}),0,e.time)}(t,e,{name:n,index:r,group:i,on:M,tween:O,time:u.time,delay:u.delay,duration:u.duration,ease:u.ease,timer:null,state:0})};function A(t,n){var e=k(t,n);if(e.state>0)throw new Error("too late; already scheduled");return e}function N(t,n){var e=k(t,n);if(e.state>3)throw new Error("too late; already running");return e}function k(t,n){var e=t.__transition;if(!e||!(e=e[n]))throw new Error("transition not found");return e}var E=function(t,n){var e,r,i,u=t.__transition,o=!0;if(u){for(i in n=null==n?null:n+"",u)(e=u[i]).name===n?(r=e.state>2&&e.state<5,e.state=6,e.timer.stop(),e.on.call(r?"interrupt":"cancel",t,t.__data__,e.index,e.group),delete u[i]):o=!1;o&&delete t.__transition}},S=e(74),P=e(20);function I(t,n){var e,r;return function(){var i=N(this,t),u=i.tween;if(u!==e)for(var o=0,a=(r=e=u).length;o<a;++o)if(r[o].name===n){(r=r.slice()).splice(o,1);break}i.tween=r}}function C(t,n,e){var r,i;if("function"!=typeof e)throw new Error;return function(){var u=N(this,t),o=u.tween;if(o!==r){i=(r=o).slice();for(var a={name:n,value:e},c=0,s=i.length;c<s;++c)if(i[c].name===n){i[c]=a;break}c===s&&i.push(a)}u.tween=i}}function q(t,n,e){var r=t._id;return t.each((function(){var t=N(this,r);(t.value||(t.value={}))[n]=e.apply(this,arguments)})),function(t){return k(t,r).value[n]}}var T=e(7),L=e(5),B=e(39),X=e(55),z=function(t,n){var e;return("number"==typeof n?L.a:n instanceof T.e?B.a:(e=Object(T.e)(n))?(n=e,B.a):X.a)(t,n)};function F(t){return function(){this.removeAttribute(t)}}function R(t){return function(){this.removeAttributeNS(t.space,t.local)}}function D(t,n,e){var r,i,u=e+"";return function(){var o=this.getAttribute(t);return o===u?null:o===r?i:i=n(r=o,e)}}function $(t,n,e){var r,i,u=e+"";return function(){var o=this.getAttributeNS(t.space,t.local);return o===u?null:o===r?i:i=n(r=o,e)}}function V(t,n,e){var r,i,u;return function(){var o,a,c=e(this);if(null!=c)return(o=this.getAttribute(t))===(a=c+"")?null:o===r&&a===i?u:(i=a,u=n(r=o,c));this.removeAttribute(t)}}function Y(t,n,e){var r,i,u;return function(){var o,a,c=e(this);if(null!=c)return(o=this.getAttributeNS(t.space,t.local))===(a=c+"")?null:o===r&&a===i?u:(i=a,u=n(r=o,c));this.removeAttributeNS(t.space,t.local)}}function H(t,n){return function(e){this.setAttribute(t,n.call(this,e))}}function Q(t,n){return function(e){this.setAttributeNS(t.space,t.local,n.call(this,e))}}function U(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&Q(t,i)),e}return i._value=n,i}function G(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&H(t,i)),e}return i._value=n,i}function Z(t,n){return function(){A(this,t).delay=+n.apply(this,arguments)}}function J(t,n){return n=+n,function(){A(this,t).delay=n}}function K(t,n){return function(){N(this,t).duration=+n.apply(this,arguments)}}function W(t,n){return n=+n,function(){N(this,t).duration=n}}function tt(t,n){if("function"!=typeof n)throw new Error;return function(){N(this,t).ease=n}}var nt=e(34);function et(t,n,e){var r,i,u=function(t){return(t+"").trim().split(/^|\s+/).every((function(t){var n=t.indexOf(".");return n>=0&&(t=t.slice(0,n)),!t||"start"===t}))}(n)?A:N;return function(){var o=u(this,t),a=o.on;a!==r&&(i=(r=a).copy()).on(n,e),o.on=i}}var rt=e(19),it=e(33),ut=u.b.prototype.constructor,ot=e(35);function at(t){return function(){this.style.removeProperty(t)}}function ct(t,n,e){return function(r){this.style.setProperty(t,n.call(this,r),e)}}function st(t,n,e){var r,i;function u(){var u=n.apply(this,arguments);return u!==i&&(r=(i=u)&&ct(t,u,e)),r}return u._value=n,u}function lt(t){return function(n){this.textContent=t.call(this,n)}}function ft(t){var n,e;function r(){var r=t.apply(this,arguments);return r!==e&&(n=(e=r)&&lt(r)),n}return r._value=t,r}var ht=0;function dt(t,n,e,r){this._groups=t,this._parents=n,this._name=e,this._id=r}function pt(t){return Object(u.b)().transition(t)}function vt(){return++ht}var gt=u.b.prototype;dt.prototype=pt.prototype={constructor:dt,select:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(rt.a)(t));for(var r=this._groups,i=r.length,u=new Array(i),o=0;o<i;++o)for(var a,c,s=r[o],l=s.length,f=u[o]=new Array(l),h=0;h<l;++h)(a=s[h])&&(c=t.call(a,a.__data__,h,s))&&("__data__"in a&&(c.__data__=a.__data__),f[h]=c,j(f[h],n,e,h,f,k(a,e)));return new dt(u,this._parents,n,e)},selectAll:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(it.a)(t));for(var r=this._groups,i=r.length,u=[],o=[],a=0;a<i;++a)for(var c,s=r[a],l=s.length,f=0;f<l;++f)if(c=s[f]){for(var h,d=t.call(c,c.__data__,f,s),p=k(c,e),v=0,g=d.length;v<g;++v)(h=d[v])&&j(h,n,e,v,d,p);u.push(d),o.push(c)}return new dt(u,o,n,e)},filter:function(t){"function"!=typeof t&&(t=Object(nt.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var u,o=n[i],a=o.length,c=r[i]=[],s=0;s<a;++s)(u=o[s])&&t.call(u,u.__data__,s,o)&&c.push(u);return new dt(r,this._parents,this._name,this._id)},merge:function(t){if(t._id!==this._id)throw new Error;for(var n=this._groups,e=t._groups,r=n.length,i=e.length,u=Math.min(r,i),o=new Array(r),a=0;a<u;++a)for(var c,s=n[a],l=e[a],f=s.length,h=o[a]=new Array(f),d=0;d<f;++d)(c=s[d]||l[d])&&(h[d]=c);for(;a<r;++a)o[a]=n[a];return new dt(o,this._parents,this._name,this._id)},selection:function(){return new ut(this._groups,this._parents)},transition:function(){for(var t=this._name,n=this._id,e=vt(),r=this._groups,i=r.length,u=0;u<i;++u)for(var o,a=r[u],c=a.length,s=0;s<c;++s)if(o=a[s]){var l=k(o,n);j(o,t,e,s,a,{time:l.time+l.delay+l.duration,delay:0,duration:l.duration,ease:l.ease})}return new dt(r,this._parents,t,e)},call:gt.call,nodes:gt.nodes,node:gt.node,size:gt.size,empty:gt.empty,each:gt.each,on:function(t,n){var e=this._id;return arguments.length<2?k(this.node(),e).on.on(t):this.each(et(e,t,n))},attr:function(t,n){var e=Object(P.a)(t),r="transform"===e?S.b:z;return this.attrTween(t,"function"==typeof n?(e.local?Y:V)(e,r,q(this,"attr."+t,n)):null==n?(e.local?R:F)(e):(e.local?$:D)(e,r,n))},attrTween:function(t,n){var e="attr."+t;if(arguments.length<2)return(e=this.tween(e))&&e._value;if(null==n)return this.tween(e,null);if("function"!=typeof n)throw new Error;var r=Object(P.a)(t);return this.tween(e,(r.local?U:G)(r,n))},style:function(t,n,e){var r="transform"==(t+="")?S.a:z;return null==n?this.styleTween(t,function(t,n){var e,r,i;return function(){var u=Object(ot.b)(this,t),o=(this.style.removeProperty(t),Object(ot.b)(this,t));return u===o?null:u===e&&o===r?i:i=n(e=u,r=o)}}(t,r)).on("end.style."+t,at(t)):"function"==typeof n?this.styleTween(t,function(t,n,e){var r,i,u;return function(){var o=Object(ot.b)(this,t),a=e(this),c=a+"";return null==a&&(this.style.removeProperty(t),c=a=Object(ot.b)(this,t)),o===c?null:o===r&&c===i?u:(i=c,u=n(r=o,a))}}(t,r,q(this,"style."+t,n))).each(function(t,n){var e,r,i,u,o="style."+n,a="end."+o;return function(){var c=N(this,t),s=c.on,l=null==c.value[o]?u||(u=at(n)):void 0;s===e&&i===l||(r=(e=s).copy()).on(a,i=l),c.on=r}}(this._id,t)):this.styleTween(t,function(t,n,e){var r,i,u=e+"";return function(){var o=Object(ot.b)(this,t);return o===u?null:o===r?i:i=n(r=o,e)}}(t,r,n),e).on("end.style."+t,null)},styleTween:function(t,n,e){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==n)return this.tween(r,null);if("function"!=typeof n)throw new Error;return this.tween(r,st(t,n,null==e?"":e))},text:function(t){return this.tween("text","function"==typeof t?function(t){return function(){var n=t(this);this.textContent=null==n?"":n}}(q(this,"text",t)):function(t){return function(){this.textContent=t}}(null==t?"":t+""))},textTween:function(t){var n="text";if(arguments.length<1)return(n=this.tween(n))&&n._value;if(null==t)return this.tween(n,null);if("function"!=typeof t)throw new Error;return this.tween(n,ft(t))},remove:function(){return this.on("end.remove",(t=this._id,function(){var n=this.parentNode;for(var e in this.__transition)if(+e!==t)return;n&&n.removeChild(this)}));var t},tween:function(t,n){var e=this._id;if(t+="",arguments.length<2){for(var r,i=k(this.node(),e).tween,u=0,o=i.length;u<o;++u)if((r=i[u]).name===t)return r.value;return null}return this.each((null==n?I:C)(e,t,n))},delay:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?Z:J)(n,t)):k(this.node(),n).delay},duration:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?K:W)(n,t)):k(this.node(),n).duration},ease:function(t){var n=this._id;return arguments.length?this.each(tt(n,t)):k(this.node(),n).ease},end:function(){var t,n,e=this,r=e._id,i=e.size();return new Promise((function(u,o){var a={value:o},c={value:function(){0==--i&&u()}};e.each((function(){var e=N(this,r),i=e.on;i!==t&&((n=(t=i).copy())._.cancel.push(a),n._.interrupt.push(a),n._.end.push(c)),e.on=n}))}))}};var yt={time:null,delay:0,duration:250,ease:e(29).b};function mt(t,n){for(var e;!(e=t.__transition)||!(e=e[n]);)if(!(t=t.parentNode))return yt.time=v(),yt;return e}u.b.prototype.interrupt=function(t){return this.each((function(){E(this,t)}))},u.b.prototype.transition=function(t){var n,e;t instanceof dt?(n=t._id,t=t._name):(n=vt(),(e=yt).time=v(),t=null==t?null:t+"");for(var r=this._groups,i=r.length,u=0;u<i;++u)for(var o,a=r[u],c=a.length,s=0;s<c;++s)(o=a[s])&&j(o,t,n,s,a,e||mt(o,n));return new dt(r,this._parents,t,n)};var wt=[null],bt=function(t,n){var e,r,i=t.__transition;if(i)for(r in n=null==n?null:n+"",i)if((e=i[r]).state>1&&e.name===n)return new dt([[t]],wt,n,+r);return null};e.d(n,"transition",(function(){return pt})),e.d(n,"active",(function(){return bt})),e.d(n,"interrupt",(function(){return E}))},,function(t,n,e){"use strict";var r,i,u,o,a=e(5),c=180/Math.PI,s={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1},l=function(t,n,e,r,i,u){var o,a,s;return(o=Math.sqrt(t*t+n*n))&&(t/=o,n/=o),(s=t*e+n*r)&&(e-=t*s,r-=n*s),(a=Math.sqrt(e*e+r*r))&&(e/=a,r/=a,s/=a),t*r<n*e&&(t=-t,n=-n,s=-s,o=-o),{translateX:i,translateY:u,rotate:Math.atan2(n,t)*c,skewX:Math.atan(s)*c,scaleX:o,scaleY:a}};function f(t,n,e,r){function i(t){return t.length?t.pop()+" ":""}return function(u,o){var c=[],s=[];return u=t(u),o=t(o),function(t,r,i,u,o,c){if(t!==i||r!==u){var s=o.push("translate(",null,n,null,e);c.push({i:s-4,x:Object(a.a)(t,i)},{i:s-2,x:Object(a.a)(r,u)})}else(i||u)&&o.push("translate("+i+n+u+e)}(u.translateX,u.translateY,o.translateX,o.translateY,c,s),function(t,n,e,u){t!==n?(t-n>180?n+=360:n-t>180&&(t+=360),u.push({i:e.push(i(e)+"rotate(",null,r)-2,x:Object(a.a)(t,n)})):n&&e.push(i(e)+"rotate("+n+r)}(u.rotate,o.rotate,c,s),function(t,n,e,u){t!==n?u.push({i:e.push(i(e)+"skewX(",null,r)-2,x:Object(a.a)(t,n)}):n&&e.push(i(e)+"skewX("+n+r)}(u.skewX,o.skewX,c,s),function(t,n,e,r,u,o){if(t!==e||n!==r){var c=u.push(i(u)+"scale(",null,",",null,")");o.push({i:c-4,x:Object(a.a)(t,e)},{i:c-2,x:Object(a.a)(n,r)})}else 1===e&&1===r||u.push(i(u)+"scale("+e+","+r+")")}(u.scaleX,u.scaleY,o.scaleX,o.scaleY,c,s),u=o=null,function(t){for(var n,e=-1,r=s.length;++e<r;)c[(n=s[e]).i]=n.x(t);return c.join("")}}}e.d(n,"a",(function(){return h})),e.d(n,"b",(function(){return d}));var h=f((function(t){return"none"===t?s:(r||(r=document.createElement("DIV"),i=document.documentElement,u=document.defaultView),r.style.transform=t,t=u.getComputedStyle(i.appendChild(r),null).getPropertyValue("transform"),i.removeChild(r),t=t.slice(7,-1).split(","),l(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}),"px, ","px)","deg)"),d=f((function(t){return null==t?s:(o||(o=document.createElementNS("http://www.w3.org/2000/svg","g")),o.setAttribute("transform",t),(t=o.transform.baseVal.consolidate())?(t=t.matrix,l(t.a,t.b,t.c,t.d,t.e,t.f)):s)}),", ",")",")")},,,,,,,,,,,,,,,,,,,,,,,,,,,,function(t,n,e){"use strict";var r,i=function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,n){var e=[],r=!0,i=!1,u=void 0;try{for(var o,a=t[Symbol.iterator]();!(r=(o=a.next()).done)&&(e.push(o.value),!n||e.length!==n);r=!0);}catch(t){i=!0,u=t}finally{try{!r&&a.return&&a.return()}finally{if(i)throw u}}return e}(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")};void 0===(r=function(t){var n=e(2),r=e(64),u=e(44),o=e(6);e(72);return function(){var t=12,e=12,a=12,c=12,s="",l="value",f="name",h=r.easeQuadInOut,d=void 0,p=void 0,v=0,g=20,y=".2f",m=function(t){return u.format(y)(t)},w=void 0,b=void 0,_=void 0;function x(n){n.each((function(){w=100-c-e,b=100-t-a,function(n){_||(_=o.select(n).append("g").classed("britechart britechart-mini-tooltip",!0)).append("g").classed("tooltip-container-group",!0).attr("transform","translate( "+c+", "+t+")").append("g").classed("tooltip-group",!0);_.transition().attr("width",100).attr("height",100),x.hide()}(this),p=_.selectAll(".tooltip-group").append("g").classed("tooltip-text select-disable",!0),d=p.append("rect").classed("tooltip-background",!0).attr("width",100).attr("height",100).attr("rx",1).attr("ry",1).attr("y",-t).attr("x",-c).style("fill","#FFFFFF").style("stroke","#D2D6DF").style("stroke-width",1).style("pointer-events","none").style("opacity",.9)}))}function M(){for(var t=arguments.length,e=Array(t),r=0;r<t;r++)e[r]=arguments[r];var i=e.filter((function(t){return!!t})).map((function(t){return t.node().getBBox().width}));return n.max(i)}function O(n,r){var u=i(n,2),o=u[0],s=u[1],l=i(r,2),f=l[0],h=l[1];return[function(t,n){return t-c-e-w-n>0}(f,o)?o+g:o-w-g-e,function(n,e){return n-t-a-b-e>0}(h,s)?s+v:s-b-v-a]}function j(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=t[l]||"",e=t[f]||"",r=21,i=31.86,u="1em",o=0,a=void 0,c=void 0,h=void 0;p.selectAll("text").remove(),s&&(h=p.append("text").classed("mini-tooltip-title",!0).attr("dy",u).attr("y",0).style("fill","#666a73").style("font-size",14).text(s),o=r+o),e&&(c=p.append("text").classed("mini-tooltip-name",!0).attr("dy",u).attr("y",o||0).style("fill","#666a73").style("font-size",14).text(e),o=r+o),n&&(a=p.append("text").classed("mini-tooltip-value",!0).attr("dy",u).attr("y",o||0).style("fill","#45494E").style("font-size",27).style("font-weight",200).text(m(n)),o=i+o),w=M(c,h,a),b=o}function A(n,r,u){var o,s,l,f;j(n),o=O(r,u),s=i(o,2),l=s[0],f=s[1],_.transition().duration(200).ease(h).style("opacity",1).attr("height",b+t+a).attr("width",w+c+e).attr("transform","translate("+l+","+f+")"),d.attr("height",b+t+a).attr("width",w+c+e)}return x.hide=function(){return _.style("visibility","hidden"),this},x.nameLabel=function(t){return arguments.length?(f=t,this):f},x.numberFormat=function(t){return arguments.length?(y=t,this):y},x.valueFormatter=function(t){return arguments.length?(m=t,this):m},x.show=function(){var t;return j(t),_.style("visibility","visible").style("opacity",0),this},x.title=function(t){return arguments.length?(s=t,this):s},x.update=function(t,n,e){return A(t,n,e),this},x.valueLabel=function(t){return arguments.length?(l=t,this):l},x}}.call(n,e,n,t))||(t.exports=r)}])}));
//# sourceMappingURL=miniTooltip.min.js.map

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.stackedBar=n():(t.britecharts=t.britecharts||{},t.britecharts.stackedBar=n())}(window,(function(){return function(t){var n={};function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{enumerable:!0,get:r})},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.t=function(t,n){if(1&n&&(t=e(t)),8&n)return t;if(4&n&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(e.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&n&&"string"!=typeof t)for(var i in t)e.d(r,i,function(n){return t[n]}.bind(null,i));return r},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.p="",e(e.s=106)}([function(t,n,e){"use strict";e.d(n,"a",(function(){return o}));var r=new Date,i=new Date;function o(t,n,e,u){function a(n){return t(n=0===arguments.length?new Date:new Date(+n)),n}return a.floor=function(n){return t(n=new Date(+n)),n},a.ceil=function(e){return t(e=new Date(e-1)),n(e,1),t(e),e},a.round=function(t){var n=a(t),e=a.ceil(t);return t-n<e-t?n:e},a.offset=function(t,e){return n(t=new Date(+t),null==e?1:Math.floor(e)),t},a.range=function(e,r,i){var o,u=[];if(e=a.ceil(e),i=null==i?1:Math.floor(i),!(e<r&&i>0))return u;do{u.push(o=new Date(+e)),n(e,i),t(e)}while(o<e&&e<r);return u},a.filter=function(e){return o((function(n){if(n>=n)for(;t(n),!e(n);)n.setTime(n-1)}),(function(t,r){if(t>=t)if(r<0)for(;++r<=0;)for(;n(t,-1),!e(t););else for(;--r>=0;)for(;n(t,1),!e(t););}))},e&&(a.count=function(n,o){return r.setTime(+n),i.setTime(+o),t(r),t(i),Math.floor(e(r,i))},a.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?a.filter(u?function(n){return u(n)%t==0}:function(n){return a.count(0,n)%t==0}):a:null}),a}},function(t,n,e){"use strict";e.d(n,"d",(function(){return r})),e.d(n,"c",(function(){return i})),e.d(n,"b",(function(){return o})),e.d(n,"a",(function(){return u})),e.d(n,"e",(function(){return a}));var r=1e3,i=6e4,o=36e5,u=864e5,a=6048e5},function(t,n,e){"use strict";e.r(n);var r=function(t,n){return t<n?-1:t>n?1:t>=n?0:NaN},i=function(t){var n;return 1===t.length&&(n=t,t=function(t,e){return r(n(t),e)}),{left:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var o=r+i>>>1;t(n[o],e)<0?r=o+1:i=o}return r},right:function(n,e,r,i){for(null==r&&(r=0),null==i&&(i=n.length);r<i;){var o=r+i>>>1;t(n[o],e)>0?i=o:r=o+1}return r}}};var o=i(r),u=o.right,a=o.left,c=u,s=function(t,n){null==n&&(n=l);for(var e=0,r=t.length-1,i=t[0],o=new Array(r<0?0:r);e<r;)o[e]=n(i,i=t[++e]);return o};function l(t,n){return[t,n]}var f=function(t,n,e){var r,i,o,u,a=t.length,c=n.length,s=new Array(a*c);for(null==e&&(e=l),r=o=0;r<a;++r)for(u=t[r],i=0;i<c;++i,++o)s[o]=e(u,n[i]);return s},h=function(t,n){return n<t?-1:n>t?1:n>=t?0:NaN},d=function(t){return null===t?NaN:+t},p=function(t,n){var e,r,i=t.length,o=0,u=-1,a=0,c=0;if(null==n)for(;++u<i;)isNaN(e=d(t[u]))||(c+=(r=e-a)*(e-(a+=r/++o)));else for(;++u<i;)isNaN(e=d(n(t[u],u,t)))||(c+=(r=e-a)*(e-(a+=r/++o)));if(o>1)return c/(o-1)},y=function(t,n){var e=p(t,n);return e?Math.sqrt(e):e},_=function(t,n){var e,r,i,o=t.length,u=-1;if(null==n){for(;++u<o;)if(null!=(e=t[u])&&e>=e)for(r=i=e;++u<o;)null!=(e=t[u])&&(r>e&&(r=e),i<e&&(i=e))}else for(;++u<o;)if(null!=(e=n(t[u],u,t))&&e>=e)for(r=i=e;++u<o;)null!=(e=n(t[u],u,t))&&(r>e&&(r=e),i<e&&(i=e));return[r,i]},g=Array.prototype,v=g.slice,m=g.map,b=function(t){return function(){return t}},x=function(t){return t},w=function(t,n,e){t=+t,n=+n,e=(i=arguments.length)<2?(n=t,t=0,1):i<3?1:+e;for(var r=-1,i=0|Math.max(0,Math.ceil((n-t)/e)),o=new Array(i);++r<i;)o[r]=t+r*e;return o},M=Math.sqrt(50),T=Math.sqrt(10),O=Math.sqrt(2),k=function(t,n,e){var r,i,o,u,a=-1;if(e=+e,(t=+t)===(n=+n)&&e>0)return[t];if((r=n<t)&&(i=t,t=n,n=i),0===(u=A(t,n,e))||!isFinite(u))return[];if(u>0)for(t=Math.ceil(t/u),n=Math.floor(n/u),o=new Array(i=Math.ceil(n-t+1));++a<i;)o[a]=(t+a)*u;else for(t=Math.floor(t*u),n=Math.ceil(n*u),o=new Array(i=Math.ceil(t-n+1));++a<i;)o[a]=(t-a)/u;return r&&o.reverse(),o};function A(t,n,e){var r=(n-t)/Math.max(0,e),i=Math.floor(Math.log(r)/Math.LN10),o=r/Math.pow(10,i);return i>=0?(o>=M?10:o>=T?5:o>=O?2:1)*Math.pow(10,i):-Math.pow(10,-i)/(o>=M?10:o>=T?5:o>=O?2:1)}function C(t,n,e){var r=Math.abs(n-t)/Math.max(0,e),i=Math.pow(10,Math.floor(Math.log(r)/Math.LN10)),o=r/i;return o>=M?i*=10:o>=T?i*=5:o>=O&&(i*=2),n<t?-i:i}var S=function(t){return Math.ceil(Math.log(t.length)/Math.LN2)+1},N=function(){var t=x,n=_,e=S;function r(r){var i,o,u=r.length,a=new Array(u);for(i=0;i<u;++i)a[i]=t(r[i],i,r);var s=n(a),l=s[0],f=s[1],h=e(a,l,f);Array.isArray(h)||(h=C(l,f,h),h=w(Math.ceil(l/h)*h,f,h));for(var d=h.length;h[0]<=l;)h.shift(),--d;for(;h[d-1]>f;)h.pop(),--d;var p,y=new Array(d+1);for(i=0;i<=d;++i)(p=y[i]=[]).x0=i>0?h[i-1]:l,p.x1=i<d?h[i]:f;for(i=0;i<u;++i)l<=(o=a[i])&&o<=f&&y[c(h,o,0,d)].push(r[i]);return y}return r.value=function(n){return arguments.length?(t="function"==typeof n?n:b(n),r):t},r.domain=function(t){return arguments.length?(n="function"==typeof t?t:b([t[0],t[1]]),r):n},r.thresholds=function(t){return arguments.length?(e="function"==typeof t?t:Array.isArray(t)?b(v.call(t)):b(t),r):e},r},j=function(t,n,e){if(null==e&&(e=d),r=t.length){if((n=+n)<=0||r<2)return+e(t[0],0,t);if(n>=1)return+e(t[r-1],r-1,t);var r,i=(r-1)*n,o=Math.floor(i),u=+e(t[o],o,t);return u+(+e(t[o+1],o+1,t)-u)*(i-o)}},E=function(t,n,e){return t=m.call(t,d).sort(r),Math.ceil((e-n)/(2*(j(t,.75)-j(t,.25))*Math.pow(t.length,-1/3)))},D=function(t,n,e){return Math.ceil((e-n)/(3.5*y(t)*Math.pow(t.length,-1/3)))},F=function(t,n){var e,r,i=t.length,o=-1;if(null==n){for(;++o<i;)if(null!=(e=t[o])&&e>=e)for(r=e;++o<i;)null!=(e=t[o])&&e>r&&(r=e)}else for(;++o<i;)if(null!=(e=n(t[o],o,t))&&e>=e)for(r=e;++o<i;)null!=(e=n(t[o],o,t))&&e>r&&(r=e);return r},P=function(t,n){var e,r=t.length,i=r,o=-1,u=0;if(null==n)for(;++o<r;)isNaN(e=d(t[o]))?--i:u+=e;else for(;++o<r;)isNaN(e=d(n(t[o],o,t)))?--i:u+=e;if(i)return u/i},L=function(t,n){var e,i=t.length,o=-1,u=[];if(null==n)for(;++o<i;)isNaN(e=d(t[o]))||u.push(e);else for(;++o<i;)isNaN(e=d(n(t[o],o,t)))||u.push(e);return j(u.sort(r),.5)},I=function(t){for(var n,e,r,i=t.length,o=-1,u=0;++o<i;)u+=t[o].length;for(e=new Array(u);--i>=0;)for(n=(r=t[i]).length;--n>=0;)e[--u]=r[n];return e},U=function(t,n){var e,r,i=t.length,o=-1;if(null==n){for(;++o<i;)if(null!=(e=t[o])&&e>=e)for(r=e;++o<i;)null!=(e=t[o])&&r>e&&(r=e)}else for(;++o<i;)if(null!=(e=n(t[o],o,t))&&e>=e)for(r=e;++o<i;)null!=(e=n(t[o],o,t))&&r>e&&(r=e);return r},R=function(t,n){for(var e=n.length,r=new Array(e);e--;)r[e]=t[n[e]];return r},B=function(t,n){if(e=t.length){var e,i,o=0,u=0,a=t[u];for(null==n&&(n=r);++o<e;)(n(i=t[o],a)<0||0!==n(a,a))&&(a=i,u=o);return 0===n(a,a)?u:void 0}},H=function(t,n,e){for(var r,i,o=(null==e?t.length:e)-(n=null==n?0:+n);o;)i=Math.random()*o--|0,r=t[o+n],t[o+n]=t[i+n],t[i+n]=r;return t},q=function(t,n){var e,r=t.length,i=-1,o=0;if(null==n)for(;++i<r;)(e=+t[i])&&(o+=e);else for(;++i<r;)(e=+n(t[i],i,t))&&(o+=e);return o},Y=function(t){if(!(i=t.length))return[];for(var n=-1,e=U(t,z),r=new Array(e);++n<e;)for(var i,o=-1,u=r[n]=new Array(i);++o<i;)u[o]=t[o][n];return r};function z(t){return t.length}var G=function(){return Y(arguments)};e.d(n,"bisect",(function(){return c})),e.d(n,"bisectRight",(function(){return u})),e.d(n,"bisectLeft",(function(){return a})),e.d(n,"ascending",(function(){return r})),e.d(n,"bisector",(function(){return i})),e.d(n,"cross",(function(){return f})),e.d(n,"descending",(function(){return h})),e.d(n,"deviation",(function(){return y})),e.d(n,"extent",(function(){return _})),e.d(n,"histogram",(function(){return N})),e.d(n,"thresholdFreedmanDiaconis",(function(){return E})),e.d(n,"thresholdScott",(function(){return D})),e.d(n,"thresholdSturges",(function(){return S})),e.d(n,"max",(function(){return F})),e.d(n,"mean",(function(){return P})),e.d(n,"median",(function(){return L})),e.d(n,"merge",(function(){return I})),e.d(n,"min",(function(){return U})),e.d(n,"pairs",(function(){return s})),e.d(n,"permute",(function(){return R})),e.d(n,"quantile",(function(){return j})),e.d(n,"range",(function(){return w})),e.d(n,"scan",(function(){return B})),e.d(n,"shuffle",(function(){return H})),e.d(n,"sum",(function(){return q})),e.d(n,"ticks",(function(){return k})),e.d(n,"tickIncrement",(function(){return A})),e.d(n,"tickStep",(function(){return C})),e.d(n,"transpose",(function(){return Y})),e.d(n,"variance",(function(){return p})),e.d(n,"zip",(function(){return G}))},function(t,n,e){"use strict";e.d(n,"g",(function(){return u})),e.d(n,"c",(function(){return a})),e.d(n,"k",(function(){return c})),e.d(n,"m",(function(){return s})),e.d(n,"i",(function(){return l})),e.d(n,"a",(function(){return f})),e.d(n,"e",(function(){return h})),e.d(n,"h",(function(){return d})),e.d(n,"d",(function(){return p})),e.d(n,"l",(function(){return y})),e.d(n,"n",(function(){return _})),e.d(n,"j",(function(){return g})),e.d(n,"b",(function(){return v})),e.d(n,"f",(function(){return m}));var r=e(0),i=e(1);function o(t){return Object(r.a)((function(n){n.setDate(n.getDate()-(n.getDay()+7-t)%7),n.setHours(0,0,0,0)}),(function(t,n){t.setDate(t.getDate()+7*n)}),(function(t,n){return(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*i.c)/i.e}))}var u=o(0),a=o(1),c=o(2),s=o(3),l=o(4),f=o(5),h=o(6),d=u.range,p=a.range,y=c.range,_=s.range,g=l.range,v=f.range,m=h.range},function(t,n,e){"use strict";e.d(n,"g",(function(){return u})),e.d(n,"c",(function(){return a})),e.d(n,"k",(function(){return c})),e.d(n,"m",(function(){return s})),e.d(n,"i",(function(){return l})),e.d(n,"a",(function(){return f})),e.d(n,"e",(function(){return h})),e.d(n,"h",(function(){return d})),e.d(n,"d",(function(){return p})),e.d(n,"l",(function(){return y})),e.d(n,"n",(function(){return _})),e.d(n,"j",(function(){return g})),e.d(n,"b",(function(){return v})),e.d(n,"f",(function(){return m}));var r=e(0),i=e(1);function o(t){return Object(r.a)((function(n){n.setUTCDate(n.getUTCDate()-(n.getUTCDay()+7-t)%7),n.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCDate(t.getUTCDate()+7*n)}),(function(t,n){return(n-t)/i.e}))}var u=o(0),a=o(1),c=o(2),s=o(3),l=o(4),f=o(5),h=o(6),d=u.range,p=a.range,y=c.range,_=s.range,g=l.range,v=f.range,m=h.range},function(t,n,e){"use strict";n.a=function(t,n){return t=+t,n=+n,function(e){return t*(1-e)+n*e}}},function(t,n,e){"use strict";e.r(n);var r=e(12),i=e(32),o=function(t){return Object(i.a)(Object(r.a)(t).call(document.documentElement))},u=0;function a(){return new c}function c(){this._="@"+(++u).toString(36)}c.prototype=a.prototype={constructor:c,get:function(t){for(var n=this._;!(n in t);)if(!(t=t.parentNode))return;return t[n]},set:function(t,n){return t[this._]=n},remove:function(t){return this._ in t&&delete t[this._]},toString:function(){return this._}};var s=e(34),l=e(59),f=e(20),h=e(14),d=e(13),p=e(9),y=function(t){return"string"==typeof t?new p.a([document.querySelectorAll(t)],[document.documentElement]):new p.a([null==t?[]:t],p.c)},_=e(19),g=e(33),v=e(35),m=e(60),b=e(22),x=function(t,n){null==n&&(n=Object(b.a)().touches);for(var e=0,r=n?n.length:0,i=new Array(r);e<r;++e)i[e]=Object(d.a)(t,n[e]);return i},w=e(21),M=e(17);e.d(n,"create",(function(){return o})),e.d(n,"creator",(function(){return r.a})),e.d(n,"local",(function(){return a})),e.d(n,"matcher",(function(){return s.a})),e.d(n,"mouse",(function(){return l.a})),e.d(n,"namespace",(function(){return f.a})),e.d(n,"namespaces",(function(){return h.a})),e.d(n,"clientPoint",(function(){return d.a})),e.d(n,"select",(function(){return i.a})),e.d(n,"selectAll",(function(){return y})),e.d(n,"selection",(function(){return p.b})),e.d(n,"selector",(function(){return _.a})),e.d(n,"selectorAll",(function(){return g.a})),e.d(n,"style",(function(){return v.b})),e.d(n,"touch",(function(){return m.a})),e.d(n,"touches",(function(){return x})),e.d(n,"window",(function(){return w.a})),e.d(n,"event",(function(){return M.c})),e.d(n,"customEvent",(function(){return M.a}))},function(t,n,e){"use strict";e.d(n,"a",(function(){return i})),e.d(n,"d",(function(){return o})),e.d(n,"c",(function(){return u})),e.d(n,"e",(function(){return b})),e.d(n,"h",(function(){return M})),e.d(n,"g",(function(){return T})),e.d(n,"b",(function(){return O})),e.d(n,"f",(function(){return j}));var r=e(11);function i(){}var o=.7,u=1/o,a="\\s*([+-]?\\d+)\\s*",c="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",s="\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",l=/^#([0-9a-f]{3,8})$/,f=new RegExp("^rgb\\("+[a,a,a]+"\\)$"),h=new RegExp("^rgb\\("+[s,s,s]+"\\)$"),d=new RegExp("^rgba\\("+[a,a,a,c]+"\\)$"),p=new RegExp("^rgba\\("+[s,s,s,c]+"\\)$"),y=new RegExp("^hsl\\("+[c,s,s]+"\\)$"),_=new RegExp("^hsla\\("+[c,s,s,c]+"\\)$"),g={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};function v(){return this.rgb().formatHex()}function m(){return this.rgb().formatRgb()}function b(t){var n,e;return t=(t+"").trim().toLowerCase(),(n=l.exec(t))?(e=n[1].length,n=parseInt(n[1],16),6===e?x(n):3===e?new O(n>>8&15|n>>4&240,n>>4&15|240&n,(15&n)<<4|15&n,1):8===e?new O(n>>24&255,n>>16&255,n>>8&255,(255&n)/255):4===e?new O(n>>12&15|n>>8&240,n>>8&15|n>>4&240,n>>4&15|240&n,((15&n)<<4|15&n)/255):null):(n=f.exec(t))?new O(n[1],n[2],n[3],1):(n=h.exec(t))?new O(255*n[1]/100,255*n[2]/100,255*n[3]/100,1):(n=d.exec(t))?w(n[1],n[2],n[3],n[4]):(n=p.exec(t))?w(255*n[1]/100,255*n[2]/100,255*n[3]/100,n[4]):(n=y.exec(t))?S(n[1],n[2]/100,n[3]/100,1):(n=_.exec(t))?S(n[1],n[2]/100,n[3]/100,n[4]):g.hasOwnProperty(t)?x(g[t]):"transparent"===t?new O(NaN,NaN,NaN,0):null}function x(t){return new O(t>>16&255,t>>8&255,255&t,1)}function w(t,n,e,r){return r<=0&&(t=n=e=NaN),new O(t,n,e,r)}function M(t){return t instanceof i||(t=b(t)),t?new O((t=t.rgb()).r,t.g,t.b,t.opacity):new O}function T(t,n,e,r){return 1===arguments.length?M(t):new O(t,n,e,null==r?1:r)}function O(t,n,e,r){this.r=+t,this.g=+n,this.b=+e,this.opacity=+r}function k(){return"#"+C(this.r)+C(this.g)+C(this.b)}function A(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"rgb(":"rgba(")+Math.max(0,Math.min(255,Math.round(this.r)||0))+", "+Math.max(0,Math.min(255,Math.round(this.g)||0))+", "+Math.max(0,Math.min(255,Math.round(this.b)||0))+(1===t?")":", "+t+")")}function C(t){return((t=Math.max(0,Math.min(255,Math.round(t)||0)))<16?"0":"")+t.toString(16)}function S(t,n,e,r){return r<=0?t=n=e=NaN:e<=0||e>=1?t=n=NaN:n<=0&&(t=NaN),new E(t,n,e,r)}function N(t){if(t instanceof E)return new E(t.h,t.s,t.l,t.opacity);if(t instanceof i||(t=b(t)),!t)return new E;if(t instanceof E)return t;var n=(t=t.rgb()).r/255,e=t.g/255,r=t.b/255,o=Math.min(n,e,r),u=Math.max(n,e,r),a=NaN,c=u-o,s=(u+o)/2;return c?(a=n===u?(e-r)/c+6*(e<r):e===u?(r-n)/c+2:(n-e)/c+4,c/=s<.5?u+o:2-u-o,a*=60):c=s>0&&s<1?0:a,new E(a,c,s,t.opacity)}function j(t,n,e,r){return 1===arguments.length?N(t):new E(t,n,e,null==r?1:r)}function E(t,n,e,r){this.h=+t,this.s=+n,this.l=+e,this.opacity=+r}function D(t,n,e){return 255*(t<60?n+(e-n)*t/60:t<180?e:t<240?n+(e-n)*(240-t)/60:n)}Object(r.a)(i,b,{copy:function(t){return Object.assign(new this.constructor,this,t)},displayable:function(){return this.rgb().displayable()},hex:v,formatHex:v,formatHsl:function(){return N(this).formatHsl()},formatRgb:m,toString:m}),Object(r.a)(O,T,Object(r.b)(i,{brighter:function(t){return t=null==t?u:Math.pow(u,t),new O(this.r*t,this.g*t,this.b*t,this.opacity)},darker:function(t){return t=null==t?o:Math.pow(o,t),new O(this.r*t,this.g*t,this.b*t,this.opacity)},rgb:function(){return this},displayable:function(){return-.5<=this.r&&this.r<255.5&&-.5<=this.g&&this.g<255.5&&-.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1},hex:k,formatHex:k,formatRgb:A,toString:A})),Object(r.a)(E,j,Object(r.b)(i,{brighter:function(t){return t=null==t?u:Math.pow(u,t),new E(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?o:Math.pow(o,t),new E(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=this.h%360+360*(this.h<0),n=isNaN(t)||isNaN(this.s)?0:this.s,e=this.l,r=e+(e<.5?e:1-e)*n,i=2*e-r;return new O(D(t>=240?t-240:t+120,i,r),D(t,i,r),D(t<120?t+240:t-120,i,r),this.opacity)},displayable:function(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1},formatHsl:function(){var t=this.opacity;return(1===(t=isNaN(t)?1:Math.max(0,Math.min(1,t)))?"hsl(":"hsla(")+(this.h||0)+", "+100*(this.s||0)+"%, "+100*(this.l||0)+"%"+(1===t?")":", "+t+")")}}))},function(t,n,e){"use strict";var r=e(18);n.a=function(t){return(t=Object(r.a)(Math.abs(t)))?t[1]:NaN}},function(t,n,e){"use strict";var r=e(19),i=e(33),o=e(34),u=function(t){return new Array(t.length)};function a(t,n){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=n}a.prototype={constructor:a,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,n){return this._parent.insertBefore(t,n)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}};function c(t,n,e,r,i,o){for(var u,c=0,s=n.length,l=o.length;c<l;++c)(u=n[c])?(u.__data__=o[c],r[c]=u):e[c]=new a(t,o[c]);for(;c<s;++c)(u=n[c])&&(i[c]=u)}function s(t,n,e,r,i,o,u){var c,s,l,f={},h=n.length,d=o.length,p=new Array(h);for(c=0;c<h;++c)(s=n[c])&&(p[c]=l="$"+u.call(s,s.__data__,c,n),l in f?i[c]=s:f[l]=s);for(c=0;c<d;++c)(s=f[l="$"+u.call(t,o[c],c,o)])?(r[c]=s,s.__data__=o[c],f[l]=null):e[c]=new a(t,o[c]);for(c=0;c<h;++c)(s=n[c])&&f[p[c]]===s&&(i[c]=s)}function l(t,n){return t<n?-1:t>n?1:t>=n?0:NaN}var f=e(20);function h(t){return function(){this.removeAttribute(t)}}function d(t){return function(){this.removeAttributeNS(t.space,t.local)}}function p(t,n){return function(){this.setAttribute(t,n)}}function y(t,n){return function(){this.setAttributeNS(t.space,t.local,n)}}function _(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttribute(t):this.setAttribute(t,e)}}function g(t,n){return function(){var e=n.apply(this,arguments);null==e?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,e)}}var v=e(35);function m(t){return function(){delete this[t]}}function b(t,n){return function(){this[t]=n}}function x(t,n){return function(){var e=n.apply(this,arguments);null==e?delete this[t]:this[t]=e}}function w(t){return t.trim().split(/^|\s+/)}function M(t){return t.classList||new T(t)}function T(t){this._node=t,this._names=w(t.getAttribute("class")||"")}function O(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.add(n[r])}function k(t,n){for(var e=M(t),r=-1,i=n.length;++r<i;)e.remove(n[r])}function A(t){return function(){O(this,t)}}function C(t){return function(){k(this,t)}}function S(t,n){return function(){(n.apply(this,arguments)?O:k)(this,t)}}T.prototype={add:function(t){this._names.indexOf(t)<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var n=this._names.indexOf(t);n>=0&&(this._names.splice(n,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}};function N(){this.textContent=""}function j(t){return function(){this.textContent=t}}function E(t){return function(){var n=t.apply(this,arguments);this.textContent=null==n?"":n}}function D(){this.innerHTML=""}function F(t){return function(){this.innerHTML=t}}function P(t){return function(){var n=t.apply(this,arguments);this.innerHTML=null==n?"":n}}function L(){this.nextSibling&&this.parentNode.appendChild(this)}function I(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}var U=e(12);function R(){return null}function B(){var t=this.parentNode;t&&t.removeChild(this)}function H(){var t=this.cloneNode(!1),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}function q(){var t=this.cloneNode(!0),n=this.parentNode;return n?n.insertBefore(t,this.nextSibling):t}var Y=e(17),z=e(21);function G(t,n,e){var r=Object(z.a)(t),i=r.CustomEvent;"function"==typeof i?i=new i(n,e):(i=r.document.createEvent("Event"),e?(i.initEvent(n,e.bubbles,e.cancelable),i.detail=e.detail):i.initEvent(n,!1,!1)),t.dispatchEvent(i)}function V(t,n){return function(){return G(this,t,n)}}function X(t,n){return function(){return G(this,t,n.apply(this,arguments))}}e.d(n,"c",(function(){return W})),e.d(n,"a",(function(){return $}));var W=[null];function $(t,n){this._groups=t,this._parents=n}function Q(){return new $([[document.documentElement]],W)}$.prototype=Q.prototype={constructor:$,select:function(t){"function"!=typeof t&&(t=Object(r.a)(t));for(var n=this._groups,e=n.length,i=new Array(e),o=0;o<e;++o)for(var u,a,c=n[o],s=c.length,l=i[o]=new Array(s),f=0;f<s;++f)(u=c[f])&&(a=t.call(u,u.__data__,f,c))&&("__data__"in u&&(a.__data__=u.__data__),l[f]=a);return new $(i,this._parents)},selectAll:function(t){"function"!=typeof t&&(t=Object(i.a)(t));for(var n=this._groups,e=n.length,r=[],o=[],u=0;u<e;++u)for(var a,c=n[u],s=c.length,l=0;l<s;++l)(a=c[l])&&(r.push(t.call(a,a.__data__,l,c)),o.push(a));return new $(r,o)},filter:function(t){"function"!=typeof t&&(t=Object(o.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var u,a=n[i],c=a.length,s=r[i]=[],l=0;l<c;++l)(u=a[l])&&t.call(u,u.__data__,l,a)&&s.push(u);return new $(r,this._parents)},data:function(t,n){if(!t)return _=new Array(this.size()),h=-1,this.each((function(t){_[++h]=t})),_;var e,r=n?s:c,i=this._parents,o=this._groups;"function"!=typeof t&&(e=t,t=function(){return e});for(var u=o.length,a=new Array(u),l=new Array(u),f=new Array(u),h=0;h<u;++h){var d=i[h],p=o[h],y=p.length,_=t.call(d,d&&d.__data__,h,i),g=_.length,v=l[h]=new Array(g),m=a[h]=new Array(g);r(d,p,v,m,f[h]=new Array(y),_,n);for(var b,x,w=0,M=0;w<g;++w)if(b=v[w]){for(w>=M&&(M=w+1);!(x=m[M])&&++M<g;);b._next=x||null}}return(a=new $(a,i))._enter=l,a._exit=f,a},enter:function(){return new $(this._enter||this._groups.map(u),this._parents)},exit:function(){return new $(this._exit||this._groups.map(u),this._parents)},join:function(t,n,e){var r=this.enter(),i=this,o=this.exit();return r="function"==typeof t?t(r):r.append(t+""),null!=n&&(i=n(i)),null==e?o.remove():e(o),r&&i?r.merge(i).order():i},merge:function(t){for(var n=this._groups,e=t._groups,r=n.length,i=e.length,o=Math.min(r,i),u=new Array(r),a=0;a<o;++a)for(var c,s=n[a],l=e[a],f=s.length,h=u[a]=new Array(f),d=0;d<f;++d)(c=s[d]||l[d])&&(h[d]=c);for(;a<r;++a)u[a]=n[a];return new $(u,this._parents)},order:function(){for(var t=this._groups,n=-1,e=t.length;++n<e;)for(var r,i=t[n],o=i.length-1,u=i[o];--o>=0;)(r=i[o])&&(u&&4^r.compareDocumentPosition(u)&&u.parentNode.insertBefore(r,u),u=r);return this},sort:function(t){function n(n,e){return n&&e?t(n.__data__,e.__data__):!n-!e}t||(t=l);for(var e=this._groups,r=e.length,i=new Array(r),o=0;o<r;++o){for(var u,a=e[o],c=a.length,s=i[o]=new Array(c),f=0;f<c;++f)(u=a[f])&&(s[f]=u);s.sort(n)}return new $(i,this._parents).order()},call:function(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this},nodes:function(){var t=new Array(this.size()),n=-1;return this.each((function(){t[++n]=this})),t},node:function(){for(var t=this._groups,n=0,e=t.length;n<e;++n)for(var r=t[n],i=0,o=r.length;i<o;++i){var u=r[i];if(u)return u}return null},size:function(){var t=0;return this.each((function(){++t})),t},empty:function(){return!this.node()},each:function(t){for(var n=this._groups,e=0,r=n.length;e<r;++e)for(var i,o=n[e],u=0,a=o.length;u<a;++u)(i=o[u])&&t.call(i,i.__data__,u,o);return this},attr:function(t,n){var e=Object(f.a)(t);if(arguments.length<2){var r=this.node();return e.local?r.getAttributeNS(e.space,e.local):r.getAttribute(e)}return this.each((null==n?e.local?d:h:"function"==typeof n?e.local?g:_:e.local?y:p)(e,n))},style:v.a,property:function(t,n){return arguments.length>1?this.each((null==n?m:"function"==typeof n?x:b)(t,n)):this.node()[t]},classed:function(t,n){var e=w(t+"");if(arguments.length<2){for(var r=M(this.node()),i=-1,o=e.length;++i<o;)if(!r.contains(e[i]))return!1;return!0}return this.each(("function"==typeof n?S:n?A:C)(e,n))},text:function(t){return arguments.length?this.each(null==t?N:("function"==typeof t?E:j)(t)):this.node().textContent},html:function(t){return arguments.length?this.each(null==t?D:("function"==typeof t?P:F)(t)):this.node().innerHTML},raise:function(){return this.each(L)},lower:function(){return this.each(I)},append:function(t){var n="function"==typeof t?t:Object(U.a)(t);return this.select((function(){return this.appendChild(n.apply(this,arguments))}))},insert:function(t,n){var e="function"==typeof t?t:Object(U.a)(t),i=null==n?R:"function"==typeof n?n:Object(r.a)(n);return this.select((function(){return this.insertBefore(e.apply(this,arguments),i.apply(this,arguments)||null)}))},remove:function(){return this.each(B)},clone:function(t){return this.select(t?q:H)},datum:function(t){return arguments.length?this.property("__data__",t):this.node().__data__},on:Y.b,dispatch:function(t,n){return this.each(("function"==typeof n?X:V)(t,n))}};n.b=Q},function(t,n,e){"use strict";e.d(n,"c",(function(){return o})),e.d(n,"b",(function(){return u})),e.d(n,"a",(function(){return a}));var r=e(23);function i(t,n){return function(e){return t+e*n}}function o(t,n){var e=n-t;return e?i(t,e>180||e<-180?e-360*Math.round(e/360):e):Object(r.a)(isNaN(t)?n:t)}function u(t){return 1==(t=+t)?a:function(n,e){return e-n?function(t,n,e){return t=Math.pow(t,e),n=Math.pow(n,e)-t,e=1/e,function(r){return Math.pow(t+r*n,e)}}(n,e,t):Object(r.a)(isNaN(n)?e:n)}}function a(t,n){var e=n-t;return e?i(t,e):Object(r.a)(isNaN(t)?n:t)}},function(t,n,e){"use strict";function r(t,n){var e=Object.create(t.prototype);for(var r in n)e[r]=n[r];return e}e.d(n,"b",(function(){return r})),n.a=function(t,n,e){t.prototype=n.prototype=e,e.constructor=t}},function(t,n,e){"use strict";var r=e(20),i=e(14);function o(t){return function(){var n=this.ownerDocument,e=this.namespaceURI;return e===i.b&&n.documentElement.namespaceURI===i.b?n.createElement(t):n.createElementNS(e,t)}}function u(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}n.a=function(t){var n=Object(r.a)(t);return(n.local?u:o)(n)}},function(t,n,e){"use strict";n.a=function(t,n){var e=t.ownerSVGElement||t;if(e.createSVGPoint){var r=e.createSVGPoint();return r.x=n.clientX,r.y=n.clientY,[(r=r.matrixTransform(t.getScreenCTM().inverse())).x,r.y]}var i=t.getBoundingClientRect();return[n.clientX-i.left-t.clientLeft,n.clientY-i.top-t.clientTop]}},function(t,n,e){"use strict";e.d(n,"b",(function(){return r}));var r="http://www.w3.org/1999/xhtml";n.a={svg:"http://www.w3.org/2000/svg",xhtml:r,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"}},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setMonth(0,1),t.setHours(0,0,0,0)}),(function(t,n){t.setFullYear(t.getFullYear()+n)}),(function(t,n){return n.getFullYear()-t.getFullYear()}),(function(t){return t.getFullYear()}));i.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)((function(n){n.setFullYear(Math.floor(n.getFullYear()/t)*t),n.setMonth(0,1),n.setHours(0,0,0,0)}),(function(n,e){n.setFullYear(n.getFullYear()+e*t)})):null},n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCFullYear(t.getUTCFullYear()+n)}),(function(t,n){return n.getUTCFullYear()-t.getUTCFullYear()}),(function(t){return t.getUTCFullYear()}));i.every=function(t){return isFinite(t=Math.floor(t))&&t>0?Object(r.a)((function(n){n.setUTCFullYear(Math.floor(n.getUTCFullYear()/t)*t),n.setUTCMonth(0,1),n.setUTCHours(0,0,0,0)}),(function(n,e){n.setUTCFullYear(n.getUTCFullYear()+e*t)})):null},n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"c",(function(){return i})),e.d(n,"a",(function(){return l}));var r={},i=null;"undefined"!=typeof document&&("onmouseenter"in document.documentElement||(r={mouseenter:"mouseover",mouseleave:"mouseout"}));function o(t,n,e){return t=u(t,n,e),function(n){var e=n.relatedTarget;e&&(e===this||8&e.compareDocumentPosition(this))||t.call(this,n)}}function u(t,n,e){return function(r){var o=i;i=r;try{t.call(this,this.__data__,n,e)}finally{i=o}}}function a(t){return t.trim().split(/^|\s+/).map((function(t){var n="",e=t.indexOf(".");return e>=0&&(n=t.slice(e+1),t=t.slice(0,e)),{type:t,name:n}}))}function c(t){return function(){var n=this.__on;if(n){for(var e,r=0,i=-1,o=n.length;r<o;++r)e=n[r],t.type&&e.type!==t.type||e.name!==t.name?n[++i]=e:this.removeEventListener(e.type,e.listener,e.capture);++i?n.length=i:delete this.__on}}}function s(t,n,e){var i=r.hasOwnProperty(t.type)?o:u;return function(r,o,u){var a,c=this.__on,s=i(n,o,u);if(c)for(var l=0,f=c.length;l<f;++l)if((a=c[l]).type===t.type&&a.name===t.name)return this.removeEventListener(a.type,a.listener,a.capture),this.addEventListener(a.type,a.listener=s,a.capture=e),void(a.value=n);this.addEventListener(t.type,s,e),a={type:t.type,name:t.name,value:n,listener:s,capture:e},c?c.push(a):this.__on=[a]}}function l(t,n,e,r){var o=i;t.sourceEvent=i,i=t;try{return n.apply(e,r)}finally{i=o}}n.b=function(t,n,e){var r,i,o=a(t+""),u=o.length;if(!(arguments.length<2)){for(l=n?s:c,null==e&&(e=!1),r=0;r<u;++r)this.each(l(o[r],n,e));return this}var l=this.node().__on;if(l)for(var f,h=0,d=l.length;h<d;++h)for(r=0,f=l[h];r<u;++r)if((i=o[r]).type===f.type&&i.name===f.name)return f.value}},function(t,n,e){"use strict";n.a=function(t,n){if((e=(t=n?t.toExponential(n-1):t.toExponential()).indexOf("e"))<0)return null;var e,r=t.slice(0,e);return[r.length>1?r[0]+r.slice(2):r,+t.slice(e+1)]}},function(t,n,e){"use strict";function r(){}n.a=function(t){return null==t?r:function(){return this.querySelector(t)}}},function(t,n,e){"use strict";var r=e(14);n.a=function(t){var n=t+="",e=n.indexOf(":");return e>=0&&"xmlns"!==(n=t.slice(0,e))&&(t=t.slice(e+1)),r.a.hasOwnProperty(n)?{space:r.a[n],local:t}:t}},function(t,n,e){"use strict";n.a=function(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}},function(t,n,e){"use strict";var r=e(17);n.a=function(){for(var t,n=r.c;t=n.sourceEvent;)n=t;return n}},function(t,n,e){"use strict";n.a=function(t){return function(){return t}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"a",(function(){return o}));var r=/^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;function i(t){if(!(n=r.exec(t)))throw new Error("invalid format: "+t);var n;return new o({fill:n[1],align:n[2],sign:n[3],symbol:n[4],zero:n[5],width:n[6],comma:n[7],precision:n[8]&&n[8].slice(1),trim:n[9],type:n[10]})}function o(t){this.fill=void 0===t.fill?" ":t.fill+"",this.align=void 0===t.align?">":t.align+"",this.sign=void 0===t.sign?"-":t.sign+"",this.symbol=void 0===t.symbol?"":t.symbol+"",this.zero=!!t.zero,this.width=void 0===t.width?void 0:+t.width,this.comma=!!t.comma,this.precision=void 0===t.precision?void 0:+t.precision,this.trim=!!t.trim,this.type=void 0===t.type?"":t.type+""}i.prototype=o.prototype,o.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(void 0===this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(void 0===this.precision?"":"."+Math.max(0,0|this.precision))+(this.trim?"~":"")+this.type}},function(t,n,e){"use strict";function r(t){return ArrayBuffer.isView(t)&&!(t instanceof DataView)}e.d(n,"b",(function(){return r})),n.a=function(t,n){n||(n=[]);var e,r=t?Math.min(n.length,t.length):0,i=n.slice();return function(o){for(e=0;e<r;++e)i[e]=t[e]*(1-o)+n[e]*o;return i}}},function(t,n,e){"use strict";function r(t,n,e,r,i){var o=t*t,u=o*t;return((1-3*t+3*o-u)*n+(4-6*o+3*u)*e+(1+3*t+3*o-3*u)*r+u*i)/6}e.d(n,"a",(function(){return r})),n.b=function(t){var n=t.length-1;return function(e){var i=e<=0?e=0:e>=1?(e=1,n-1):Math.floor(e*n),o=t[i],u=t[i+1],a=i>0?t[i-1]:2*o-u,c=i<n-1?t[i+2]:2*u-o;return r((e-i/n)*n,a,o,u,c)}}},function(t,n,e){"use strict";e.d(n,"a",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setHours(0,0,0,0)}),(function(t,n){t.setDate(t.getDate()+n)}),(function(t,n){return(n-t-(n.getTimezoneOffset()-t.getTimezoneOffset())*i.c)/i.a}),(function(t){return t.getDate()-1}));n.b=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCDate(t.getUTCDate()+n)}),(function(t,n){return(n-t)/i.a}),(function(t){return t.getUTCDate()-1}));n.a=o;var u=o.range},function(t,n,e){"use strict";function r(t){return t*t*t}function i(t){return--t*t*t+1}function o(t){return((t*=2)<=1?t*t*t:(t-=2)*t*t+2)/2}e.d(n,"a",(function(){return r})),e.d(n,"c",(function(){return i})),e.d(n,"b",(function(){return o}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds())}),(function(t,n){t.setTime(+t+n*i.d)}),(function(t,n){return(n-t)/i.d}),(function(t){return t.getUTCSeconds()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(){}),(function(t,n){t.setTime(+t+n)}),(function(t,n){return n-t}));i.every=function(t){return t=Math.floor(t),isFinite(t)&&t>0?t>1?Object(r.a)((function(n){n.setTime(Math.floor(n/t)*t)}),(function(n,e){n.setTime(+n+e*t)}),(function(n,e){return(e-n)/t})):i:null},n.a=i;var o=i.range},function(t,n,e){"use strict";var r=e(9);n.a=function(t){return"string"==typeof t?new r.a([[document.querySelector(t)]],[document.documentElement]):new r.a([[t]],r.c)}},function(t,n,e){"use strict";function r(){return[]}n.a=function(t){return null==t?r:function(){return this.querySelectorAll(t)}}},function(t,n,e){"use strict";n.a=function(t){return function(){return this.matches(t)}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return a}));var r=e(21);function i(t){return function(){this.style.removeProperty(t)}}function o(t,n,e){return function(){this.style.setProperty(t,n,e)}}function u(t,n,e){return function(){var r=n.apply(this,arguments);null==r?this.style.removeProperty(t):this.style.setProperty(t,r,e)}}function a(t,n){return t.style.getPropertyValue(n)||Object(r.a)(t).getComputedStyle(t,null).getPropertyValue(n)}n.a=function(t,n,e){return arguments.length>1?this.each((null==n?i:"function"==typeof n?u:o)(t,n,null==e?"":e)):a(this.node(),t)}},function(t,n,e){"use strict";var r=e(7),i=e(39),o=e(57),u=e(56),a=e(5),c=e(58),s=e(55),l=e(23),f=e(25);n.a=function(t,n){var e,h=typeof n;return null==n||"boolean"===h?Object(l.a)(n):("number"===h?a.a:"string"===h?(e=Object(r.e)(n))?(n=e,i.a):s.a:n instanceof r.e?i.a:n instanceof Date?u.a:Object(f.b)(n)?f.a:Array.isArray(n)?o.b:"function"!=typeof n.valueOf&&"function"!=typeof n.toString||isNaN(n)?c.a:a.a)(t,n)}},function(t,n,e){"use strict";var r,i=e(8),o=e(24),u=e(18),a=function(t,n){var e=Object(u.a)(t,n);if(!e)return t+"";var r=e[0],i=e[1];return i<0?"0."+new Array(-i).join("0")+r:r.length>i+1?r.slice(0,i+1)+"."+r.slice(i+1):r+new Array(i-r.length+2).join("0")},c={"%":function(t,n){return(100*t).toFixed(n)},b:function(t){return Math.round(t).toString(2)},c:function(t){return t+""},d:function(t){return Math.round(t).toString(10)},e:function(t,n){return t.toExponential(n)},f:function(t,n){return t.toFixed(n)},g:function(t,n){return t.toPrecision(n)},o:function(t){return Math.round(t).toString(8)},p:function(t,n){return a(100*t,n)},r:a,s:function(t,n){var e=Object(u.a)(t,n);if(!e)return t+"";var i=e[0],o=e[1],a=o-(r=3*Math.max(-8,Math.min(8,Math.floor(o/3))))+1,c=i.length;return a===c?i:a>c?i+new Array(a-c+1).join("0"):a>0?i.slice(0,a)+"."+i.slice(a):"0."+new Array(1-a).join("0")+Object(u.a)(t,Math.max(0,n+a-1))[0]},X:function(t){return Math.round(t).toString(16).toUpperCase()},x:function(t){return Math.round(t).toString(16)}},s=function(t){return t},l=Array.prototype.map,f=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];n.a=function(t){var n,e,u=void 0===t.grouping||void 0===t.thousands?s:(n=l.call(t.grouping,Number),e=t.thousands+"",function(t,r){for(var i=t.length,o=[],u=0,a=n[0],c=0;i>0&&a>0&&(c+a+1>r&&(a=Math.max(1,r-c)),o.push(t.substring(i-=a,i+a)),!((c+=a+1)>r));)a=n[u=(u+1)%n.length];return o.reverse().join(e)}),a=void 0===t.currency?"":t.currency[0]+"",h=void 0===t.currency?"":t.currency[1]+"",d=void 0===t.decimal?".":t.decimal+"",p=void 0===t.numerals?s:function(t){return function(n){return n.replace(/[0-9]/g,(function(n){return t[+n]}))}}(l.call(t.numerals,String)),y=void 0===t.percent?"%":t.percent+"",_=void 0===t.minus?"-":t.minus+"",g=void 0===t.nan?"NaN":t.nan+"";function v(t){var n=(t=Object(o.b)(t)).fill,e=t.align,i=t.sign,s=t.symbol,l=t.zero,v=t.width,m=t.comma,b=t.precision,x=t.trim,w=t.type;"n"===w?(m=!0,w="g"):c[w]||(void 0===b&&(b=12),x=!0,w="g"),(l||"0"===n&&"="===e)&&(l=!0,n="0",e="=");var M="$"===s?a:"#"===s&&/[boxX]/.test(w)?"0"+w.toLowerCase():"",T="$"===s?h:/[%p]/.test(w)?y:"",O=c[w],k=/[defgprs%]/.test(w);function A(t){var o,a,c,s=M,h=T;if("c"===w)h=O(t)+h,t="";else{var y=(t=+t)<0;if(t=isNaN(t)?g:O(Math.abs(t),b),x&&(t=function(t){t:for(var n,e=t.length,r=1,i=-1;r<e;++r)switch(t[r]){case".":i=n=r;break;case"0":0===i&&(i=r),n=r;break;default:if(!+t[r])break t;i>0&&(i=0)}return i>0?t.slice(0,i)+t.slice(n+1):t}(t)),y&&0==+t&&(y=!1),s=(y?"("===i?i:_:"-"===i||"("===i?"":i)+s,h=("s"===w?f[8+r/3]:"")+h+(y&&"("===i?")":""),k)for(o=-1,a=t.length;++o<a;)if(48>(c=t.charCodeAt(o))||c>57){h=(46===c?d+t.slice(o+1):t.slice(o))+h,t=t.slice(0,o);break}}m&&!l&&(t=u(t,1/0));var A=s.length+t.length+h.length,C=A<v?new Array(v-A+1).join(n):"";switch(m&&l&&(t=u(C+t,C.length?v-h.length:1/0),C=""),e){case"<":t=s+t+h+C;break;case"=":t=s+C+t+h;break;case"^":t=C.slice(0,A=C.length>>1)+s+t+h+C.slice(A);break;default:t=C+s+t+h}return p(t)}return b=void 0===b?6:/[gprs]/.test(w)?Math.max(1,Math.min(21,b)):Math.max(0,Math.min(20,b)),A.toString=function(){return t+""},A}return{format:v,formatPrefix:function(t,n){var e=v(((t=Object(o.b)(t)).type="f",t)),r=3*Math.max(-8,Math.min(8,Math.floor(Object(i.a)(n)/3))),u=Math.pow(10,-r),a=f[8+r/3];return function(t){return e(u*t)+a}}}}},function(t,n,e){"use strict";e.r(n);var r=e(0);e.d(n,"timeInterval",(function(){return r.a}));var i=e(31);e.d(n,"timeMillisecond",(function(){return i.a})),e.d(n,"timeMilliseconds",(function(){return i.b})),e.d(n,"utcMillisecond",(function(){return i.a})),e.d(n,"utcMilliseconds",(function(){return i.b}));var o=e(30);e.d(n,"timeSecond",(function(){return o.a})),e.d(n,"timeSeconds",(function(){return o.b})),e.d(n,"utcSecond",(function(){return o.a})),e.d(n,"utcSeconds",(function(){return o.b}));var u=e(49);e.d(n,"timeMinute",(function(){return u.a})),e.d(n,"timeMinutes",(function(){return u.b}));var a=e(48);e.d(n,"timeHour",(function(){return a.a})),e.d(n,"timeHours",(function(){return a.b}));var c=e(27);e.d(n,"timeDay",(function(){return c.b})),e.d(n,"timeDays",(function(){return c.a}));var s=e(3);e.d(n,"timeWeek",(function(){return s.g})),e.d(n,"timeWeeks",(function(){return s.h})),e.d(n,"timeSunday",(function(){return s.g})),e.d(n,"timeSundays",(function(){return s.h})),e.d(n,"timeMonday",(function(){return s.c})),e.d(n,"timeMondays",(function(){return s.d})),e.d(n,"timeTuesday",(function(){return s.k})),e.d(n,"timeTuesdays",(function(){return s.l})),e.d(n,"timeWednesday",(function(){return s.m})),e.d(n,"timeWednesdays",(function(){return s.n})),e.d(n,"timeThursday",(function(){return s.i})),e.d(n,"timeThursdays",(function(){return s.j})),e.d(n,"timeFriday",(function(){return s.a})),e.d(n,"timeFridays",(function(){return s.b})),e.d(n,"timeSaturday",(function(){return s.e})),e.d(n,"timeSaturdays",(function(){return s.f}));var l=e(47);e.d(n,"timeMonth",(function(){return l.a})),e.d(n,"timeMonths",(function(){return l.b}));var f=e(15);e.d(n,"timeYear",(function(){return f.a})),e.d(n,"timeYears",(function(){return f.b}));var h=e(52);e.d(n,"utcMinute",(function(){return h.a})),e.d(n,"utcMinutes",(function(){return h.b}));var d=e(51);e.d(n,"utcHour",(function(){return d.a})),e.d(n,"utcHours",(function(){return d.b}));var p=e(28);e.d(n,"utcDay",(function(){return p.a})),e.d(n,"utcDays",(function(){return p.b}));var y=e(4);e.d(n,"utcWeek",(function(){return y.g})),e.d(n,"utcWeeks",(function(){return y.h})),e.d(n,"utcSunday",(function(){return y.g})),e.d(n,"utcSundays",(function(){return y.h})),e.d(n,"utcMonday",(function(){return y.c})),e.d(n,"utcMondays",(function(){return y.d})),e.d(n,"utcTuesday",(function(){return y.k})),e.d(n,"utcTuesdays",(function(){return y.l})),e.d(n,"utcWednesday",(function(){return y.m})),e.d(n,"utcWednesdays",(function(){return y.n})),e.d(n,"utcThursday",(function(){return y.i})),e.d(n,"utcThursdays",(function(){return y.j})),e.d(n,"utcFriday",(function(){return y.a})),e.d(n,"utcFridays",(function(){return y.b})),e.d(n,"utcSaturday",(function(){return y.e})),e.d(n,"utcSaturdays",(function(){return y.f}));var _=e(50);e.d(n,"utcMonth",(function(){return _.a})),e.d(n,"utcMonths",(function(){return _.b}));var g=e(16);e.d(n,"utcYear",(function(){return g.a})),e.d(n,"utcYears",(function(){return g.b}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return c})),e.d(n,"c",(function(){return s}));var r=e(7),i=e(26),o=e(53),u=e(10);function a(t){return function(n){var e,i,o=n.length,u=new Array(o),a=new Array(o),c=new Array(o);for(e=0;e<o;++e)i=Object(r.g)(n[e]),u[e]=i.r||0,a[e]=i.g||0,c[e]=i.b||0;return u=t(u),a=t(a),c=t(c),i.opacity=1,function(t){return i.r=u(t),i.g=a(t),i.b=c(t),i+""}}}n.a=function t(n){var e=Object(u.b)(n);function i(t,n){var i=e((t=Object(r.g)(t)).r,(n=Object(r.g)(n)).r),o=e(t.g,n.g),a=e(t.b,n.b),c=Object(u.a)(t.opacity,n.opacity);return function(n){return t.r=i(n),t.g=o(n),t.b=a(n),t.opacity=c(n),t+""}}return i.gamma=t,i}(1);var c=a(i.b),s=a(o.a)},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"c",(function(){return o})),e.d(n,"a",(function(){return a}));var r,i,o,u=e(37);function a(t){return r=Object(u.a)(t),i=r.format,o=r.formatPrefix,r}a({decimal:".",thousands:",",grouping:[3],currency:["$",""],minus:"-"})},function(t,n,e){"use strict";e.r(n);var r=e(36),i=e(57),o=e(26),u=e(53),a=e(56),c=function(t){var n=t.length;return function(e){return t[Math.max(0,Math.min(n-1,Math.floor(e*n)))]}},s=e(10),l=function(t,n){var e=Object(s.c)(+t,+n);return function(t){var n=e(t);return n-360*Math.floor(n/360)}},f=e(5),h=e(25),d=e(58),p=e(81),y=e(55),_=e(74),g=Math.SQRT2;function v(t){return((t=Math.exp(t))+1/t)/2}var m=function(t,n){var e,r,i=t[0],o=t[1],u=t[2],a=n[0],c=n[1],s=n[2],l=a-i,f=c-o,h=l*l+f*f;if(h<1e-12)r=Math.log(s/u)/g,e=function(t){return[i+t*l,o+t*f,u*Math.exp(g*t*r)]};else{var d=Math.sqrt(h),p=(s*s-u*u+4*h)/(2*u*2*d),y=(s*s-u*u-4*h)/(2*s*2*d),_=Math.log(Math.sqrt(p*p+1)-p),m=Math.log(Math.sqrt(y*y+1)-y);r=(m-_)/g,e=function(t){var n,e=t*r,a=v(_),c=u/(2*d)*(a*(n=g*e+_,((n=Math.exp(2*n))-1)/(n+1))-function(t){return((t=Math.exp(t))-1/t)/2}(_));return[i+c*l,o+c*f,u*a/v(g*e+_)]}}return e.duration=1e3*r,e},b=e(39),x=e(7);function w(t){return function(n,e){var r=t((n=Object(x.f)(n)).h,(e=Object(x.f)(e)).h),i=Object(s.a)(n.s,e.s),o=Object(s.a)(n.l,e.l),u=Object(s.a)(n.opacity,e.opacity);return function(t){return n.h=r(t),n.s=i(t),n.l=o(t),n.opacity=u(t),n+""}}}var M=w(s.c),T=w(s.a),O=e(82);function k(t,n){var e=Object(s.a)((t=Object(O.a)(t)).l,(n=Object(O.a)(n)).l),r=Object(s.a)(t.a,n.a),i=Object(s.a)(t.b,n.b),o=Object(s.a)(t.opacity,n.opacity);return function(n){return t.l=e(n),t.a=r(n),t.b=i(n),t.opacity=o(n),t+""}}function A(t){return function(n,e){var r=t((n=Object(O.c)(n)).h,(e=Object(O.c)(e)).h),i=Object(s.a)(n.c,e.c),o=Object(s.a)(n.l,e.l),u=Object(s.a)(n.opacity,e.opacity);return function(t){return n.h=r(t),n.c=i(t),n.l=o(t),n.opacity=u(t),n+""}}}var C=A(s.c),S=A(s.a),N=e(86);function j(t){return function n(e){function r(n,r){var i=t((n=Object(N.a)(n)).h,(r=Object(N.a)(r)).h),o=Object(s.a)(n.s,r.s),u=Object(s.a)(n.l,r.l),a=Object(s.a)(n.opacity,r.opacity);return function(t){return n.h=i(t),n.s=o(t),n.l=u(Math.pow(t,e)),n.opacity=a(t),n+""}}return e=+e,r.gamma=n,r}(1)}var E=j(s.c),D=j(s.a);function F(t,n){for(var e=0,r=n.length-1,i=n[0],o=new Array(r<0?0:r);e<r;)o[e]=t(i,i=n[++e]);return function(t){var n=Math.max(0,Math.min(r-1,Math.floor(t*=r)));return o[n](t-n)}}var P=function(t,n){for(var e=new Array(n),r=0;r<n;++r)e[r]=t(r/(n-1));return e};e.d(n,"interpolate",(function(){return r.a})),e.d(n,"interpolateArray",(function(){return i.a})),e.d(n,"interpolateBasis",(function(){return o.b})),e.d(n,"interpolateBasisClosed",(function(){return u.a})),e.d(n,"interpolateDate",(function(){return a.a})),e.d(n,"interpolateDiscrete",(function(){return c})),e.d(n,"interpolateHue",(function(){return l})),e.d(n,"interpolateNumber",(function(){return f.a})),e.d(n,"interpolateNumberArray",(function(){return h.a})),e.d(n,"interpolateObject",(function(){return d.a})),e.d(n,"interpolateRound",(function(){return p.a})),e.d(n,"interpolateString",(function(){return y.a})),e.d(n,"interpolateTransformCss",(function(){return _.a})),e.d(n,"interpolateTransformSvg",(function(){return _.b})),e.d(n,"interpolateZoom",(function(){return m})),e.d(n,"interpolateRgb",(function(){return b.a})),e.d(n,"interpolateRgbBasis",(function(){return b.b})),e.d(n,"interpolateRgbBasisClosed",(function(){return b.c})),e.d(n,"interpolateHsl",(function(){return M})),e.d(n,"interpolateHslLong",(function(){return T})),e.d(n,"interpolateLab",(function(){return k})),e.d(n,"interpolateHcl",(function(){return C})),e.d(n,"interpolateHclLong",(function(){return S})),e.d(n,"interpolateCubehelix",(function(){return E})),e.d(n,"interpolateCubehelixLong",(function(){return D})),e.d(n,"piecewise",(function(){return F})),e.d(n,"quantize",(function(){return P}))},,function(t,n,e){"use strict";e.r(n);var r=e(7);e.d(n,"color",(function(){return r.e})),e.d(n,"rgb",(function(){return r.g})),e.d(n,"hsl",(function(){return r.f}));var i=e(82);e.d(n,"lab",(function(){return i.a})),e.d(n,"hcl",(function(){return i.c})),e.d(n,"lch",(function(){return i.d})),e.d(n,"gray",(function(){return i.b}));var o=e(86);e.d(n,"cubehelix",(function(){return o.a}))},,function(t,n,e){"use strict";e.r(n);function r(){}function i(t,n){var e=new r;if(t instanceof r)t.each((function(t,n){e.set(n,t)}));else if(Array.isArray(t)){var i,o=-1,u=t.length;if(null==n)for(;++o<u;)e.set(o,t[o]);else for(;++o<u;)e.set(n(i=t[o],o,t),i)}else if(t)for(var a in t)e.set(a,t[a]);return e}r.prototype=i.prototype={constructor:r,has:function(t){return"$"+t in this},get:function(t){return this["$"+t]},set:function(t,n){return this["$"+t]=n,this},remove:function(t){var n="$"+t;return n in this&&delete this[n]},clear:function(){for(var t in this)"$"===t[0]&&delete this[t]},keys:function(){var t=[];for(var n in this)"$"===n[0]&&t.push(n.slice(1));return t},values:function(){var t=[];for(var n in this)"$"===n[0]&&t.push(this[n]);return t},entries:function(){var t=[];for(var n in this)"$"===n[0]&&t.push({key:n.slice(1),value:this[n]});return t},size:function(){var t=0;for(var n in this)"$"===n[0]&&++t;return t},empty:function(){for(var t in this)if("$"===t[0])return!1;return!0},each:function(t){for(var n in this)"$"===n[0]&&t(this[n],n.slice(1),this)}};var o=i,u=function(){var t,n,e,r=[],i=[];function u(e,i,a,c){if(i>=r.length)return null!=t&&e.sort(t),null!=n?n(e):e;for(var s,l,f,h=-1,d=e.length,p=r[i++],y=o(),_=a();++h<d;)(f=y.get(s=p(l=e[h])+""))?f.push(l):y.set(s,[l]);return y.each((function(t,n){c(_,n,u(t,i,a,c))})),_}return e={object:function(t){return u(t,0,a,c)},map:function(t){return u(t,0,s,l)},entries:function(t){return function t(e,o){if(++o>r.length)return e;var u,a=i[o-1];return null!=n&&o>=r.length?u=e.entries():(u=[],e.each((function(n,e){u.push({key:e,values:t(n,o)})}))),null!=a?u.sort((function(t,n){return a(t.key,n.key)})):u}(u(t,0,s,l),0)},key:function(t){return r.push(t),e},sortKeys:function(t){return i[r.length-1]=t,e},sortValues:function(n){return t=n,e},rollup:function(t){return n=t,e}}};function a(){return{}}function c(t,n,e){t[n]=e}function s(){return o()}function l(t,n,e){t.set(n,e)}function f(){}var h=o.prototype;function d(t,n){var e=new f;if(t instanceof f)t.each((function(t){e.add(t)}));else if(t){var r=-1,i=t.length;if(null==n)for(;++r<i;)e.add(t[r]);else for(;++r<i;)e.add(n(t[r],r,t))}return e}f.prototype=d.prototype={constructor:f,has:h.has,add:function(t){return this["$"+(t+="")]=t,this},remove:h.remove,clear:h.clear,values:h.keys,size:h.size,empty:h.empty,each:h.each};var p=d,y=function(t){var n=[];for(var e in t)n.push(e);return n},_=function(t){var n=[];for(var e in t)n.push(t[e]);return n},g=function(t){var n=[];for(var e in t)n.push({key:e,value:t[e]});return n};e.d(n,"nest",(function(){return u})),e.d(n,"set",(function(){return p})),e.d(n,"map",(function(){return o})),e.d(n,"keys",(function(){return y})),e.d(n,"values",(function(){return _})),e.d(n,"entries",(function(){return g}))},function(t,n,e){"use strict";e.d(n,"b",(function(){return i})),e.d(n,"c",(function(){return o})),e.d(n,"d",(function(){return u})),e.d(n,"e",(function(){return a})),e.d(n,"a",(function(){return s}));var r,i,o,u,a,c=e(54);function s(t){return r=Object(c.a)(t),i=r.format,o=r.parse,u=r.utcFormat,a=r.utcParse,r}s({dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]})},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setDate(1),t.setHours(0,0,0,0)}),(function(t,n){t.setMonth(t.getMonth()+n)}),(function(t,n){return n.getMonth()-t.getMonth()+12*(n.getFullYear()-t.getFullYear())}),(function(t){return t.getMonth()}));n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds()-t.getSeconds()*i.d-t.getMinutes()*i.c)}),(function(t,n){t.setTime(+t+n*i.b)}),(function(t,n){return(n-t)/i.b}),(function(t){return t.getHours()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setTime(t-t.getMilliseconds()-t.getSeconds()*i.d)}),(function(t,n){t.setTime(+t+n*i.c)}),(function(t,n){return(n-t)/i.c}),(function(t){return t.getMinutes()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(0),i=Object(r.a)((function(t){t.setUTCDate(1),t.setUTCHours(0,0,0,0)}),(function(t,n){t.setUTCMonth(t.getUTCMonth()+n)}),(function(t,n){return n.getUTCMonth()-t.getUTCMonth()+12*(n.getUTCFullYear()-t.getUTCFullYear())}),(function(t){return t.getUTCMonth()}));n.a=i;var o=i.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCMinutes(0,0,0)}),(function(t,n){t.setTime(+t+n*i.b)}),(function(t,n){return(n-t)/i.b}),(function(t){return t.getUTCHours()}));n.a=o;var u=o.range},function(t,n,e){"use strict";e.d(n,"b",(function(){return u}));var r=e(0),i=e(1),o=Object(r.a)((function(t){t.setUTCSeconds(0,0)}),(function(t,n){t.setTime(+t+n*i.c)}),(function(t,n){return(n-t)/i.c}),(function(t){return t.getUTCMinutes()}));n.a=o;var u=o.range},function(t,n,e){"use strict";var r=e(26);n.a=function(t){var n=t.length;return function(e){var i=Math.floor(((e%=1)<0?++e:e)*n),o=t[(i+n-1)%n],u=t[i%n],a=t[(i+1)%n],c=t[(i+2)%n];return Object(r.a)((e-i/n)*n,o,u,a,c)}}},function(t,n,e){"use strict";e.d(n,"a",(function(){return h}));var r=e(4),i=e(28),o=e(3),u=e(27),a=e(15),c=e(16);function s(t){if(0<=t.y&&t.y<100){var n=new Date(-1,t.m,t.d,t.H,t.M,t.S,t.L);return n.setFullYear(t.y),n}return new Date(t.y,t.m,t.d,t.H,t.M,t.S,t.L)}function l(t){if(0<=t.y&&t.y<100){var n=new Date(Date.UTC(-1,t.m,t.d,t.H,t.M,t.S,t.L));return n.setUTCFullYear(t.y),n}return new Date(Date.UTC(t.y,t.m,t.d,t.H,t.M,t.S,t.L))}function f(t,n,e){return{y:t,m:n,d:e,H:0,M:0,S:0,L:0}}function h(t){var n=t.dateTime,e=t.date,a=t.time,c=t.periods,h=t.days,p=t.shortDays,y=t.months,_=t.shortMonths,g=m(c),v=b(c),Tt=m(h),Ot=b(h),kt=m(p),At=b(p),Ct=m(y),St=b(y),Nt=m(_),jt=b(_),Et={a:function(t){return p[t.getDay()]},A:function(t){return h[t.getDay()]},b:function(t){return _[t.getMonth()]},B:function(t){return y[t.getMonth()]},c:null,d:H,e:H,f:V,H:q,I:Y,j:z,L:G,m:X,M:W,p:function(t){return c[+(t.getHours()>=12)]},q:function(t){return 1+~~(t.getMonth()/3)},Q:wt,s:Mt,S:$,u:Q,U:Z,V:J,w:K,W:tt,x:null,X:null,y:nt,Y:et,Z:rt,"%":xt},Dt={a:function(t){return p[t.getUTCDay()]},A:function(t){return h[t.getUTCDay()]},b:function(t){return _[t.getUTCMonth()]},B:function(t){return y[t.getUTCMonth()]},c:null,d:it,e:it,f:st,H:ot,I:ut,j:at,L:ct,m:lt,M:ft,p:function(t){return c[+(t.getUTCHours()>=12)]},q:function(t){return 1+~~(t.getUTCMonth()/3)},Q:wt,s:Mt,S:ht,u:dt,U:pt,V:yt,w:_t,W:gt,x:null,X:null,y:vt,Y:mt,Z:bt,"%":xt},Ft={a:function(t,n,e){var r=kt.exec(n.slice(e));return r?(t.w=At[r[0].toLowerCase()],e+r[0].length):-1},A:function(t,n,e){var r=Tt.exec(n.slice(e));return r?(t.w=Ot[r[0].toLowerCase()],e+r[0].length):-1},b:function(t,n,e){var r=Nt.exec(n.slice(e));return r?(t.m=jt[r[0].toLowerCase()],e+r[0].length):-1},B:function(t,n,e){var r=Ct.exec(n.slice(e));return r?(t.m=St[r[0].toLowerCase()],e+r[0].length):-1},c:function(t,e,r){return It(t,n,e,r)},d:j,e:j,f:I,H:D,I:D,j:E,L:L,m:N,M:F,p:function(t,n,e){var r=g.exec(n.slice(e));return r?(t.p=v[r[0].toLowerCase()],e+r[0].length):-1},q:S,Q:R,s:B,S:P,u:w,U:M,V:T,w:x,W:O,x:function(t,n,r){return It(t,e,n,r)},X:function(t,n,e){return It(t,a,n,e)},y:A,Y:k,Z:C,"%":U};function Pt(t,n){return function(e){var r,i,o,u=[],a=-1,c=0,s=t.length;for(e instanceof Date||(e=new Date(+e));++a<s;)37===t.charCodeAt(a)&&(u.push(t.slice(c,a)),null!=(i=d[r=t.charAt(++a)])?r=t.charAt(++a):i="e"===r?" ":"0",(o=n[r])&&(r=o(e,i)),u.push(r),c=a+1);return u.push(t.slice(c,a)),u.join("")}}function Lt(t,n){return function(e){var a,c,h=f(1900,void 0,1);if(It(h,t,e+="",0)!=e.length)return null;if("Q"in h)return new Date(h.Q);if("s"in h)return new Date(1e3*h.s+("L"in h?h.L:0));if(!n||"Z"in h||(h.Z=0),"p"in h&&(h.H=h.H%12+12*h.p),void 0===h.m&&(h.m="q"in h?h.q:0),"V"in h){if(h.V<1||h.V>53)return null;"w"in h||(h.w=1),"Z"in h?(c=(a=l(f(h.y,0,1))).getUTCDay(),a=c>4||0===c?r.c.ceil(a):Object(r.c)(a),a=i.a.offset(a,7*(h.V-1)),h.y=a.getUTCFullYear(),h.m=a.getUTCMonth(),h.d=a.getUTCDate()+(h.w+6)%7):(c=(a=s(f(h.y,0,1))).getDay(),a=c>4||0===c?o.c.ceil(a):Object(o.c)(a),a=u.b.offset(a,7*(h.V-1)),h.y=a.getFullYear(),h.m=a.getMonth(),h.d=a.getDate()+(h.w+6)%7)}else("W"in h||"U"in h)&&("w"in h||(h.w="u"in h?h.u%7:"W"in h?1:0),c="Z"in h?l(f(h.y,0,1)).getUTCDay():s(f(h.y,0,1)).getDay(),h.m=0,h.d="W"in h?(h.w+6)%7+7*h.W-(c+5)%7:h.w+7*h.U-(c+6)%7);return"Z"in h?(h.H+=h.Z/100|0,h.M+=h.Z%100,l(h)):s(h)}}function It(t,n,e,r){for(var i,o,u=0,a=n.length,c=e.length;u<a;){if(r>=c)return-1;if(37===(i=n.charCodeAt(u++))){if(i=n.charAt(u++),!(o=Ft[i in d?n.charAt(u++):i])||(r=o(t,e,r))<0)return-1}else if(i!=e.charCodeAt(r++))return-1}return r}return(Et.x=Pt(e,Et),Et.X=Pt(a,Et),Et.c=Pt(n,Et),Dt.x=Pt(e,Dt),Dt.X=Pt(a,Dt),Dt.c=Pt(n,Dt),{format:function(t){var n=Pt(t+="",Et);return n.toString=function(){return t},n},parse:function(t){var n=Lt(t+="",!1);return n.toString=function(){return t},n},utcFormat:function(t){var n=Pt(t+="",Dt);return n.toString=function(){return t},n},utcParse:function(t){var n=Lt(t+="",!0);return n.toString=function(){return t},n}})}var d={"-":"",_:" ",0:"0"},p=/^\s*\d+/,y=/^%/,_=/[\\^$*+?|[\]().{}]/g;function g(t,n,e){var r=t<0?"-":"",i=(r?-t:t)+"",o=i.length;return r+(o<e?new Array(e-o+1).join(n)+i:i)}function v(t){return t.replace(_,"\\$&")}function m(t){return new RegExp("^(?:"+t.map(v).join("|")+")","i")}function b(t){for(var n={},e=-1,r=t.length;++e<r;)n[t[e].toLowerCase()]=e;return n}function x(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.w=+r[0],e+r[0].length):-1}function w(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.u=+r[0],e+r[0].length):-1}function M(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.U=+r[0],e+r[0].length):-1}function T(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.V=+r[0],e+r[0].length):-1}function O(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.W=+r[0],e+r[0].length):-1}function k(t,n,e){var r=p.exec(n.slice(e,e+4));return r?(t.y=+r[0],e+r[0].length):-1}function A(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.y=+r[0]+(+r[0]>68?1900:2e3),e+r[0].length):-1}function C(t,n,e){var r=/^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(n.slice(e,e+6));return r?(t.Z=r[1]?0:-(r[2]+(r[3]||"00")),e+r[0].length):-1}function S(t,n,e){var r=p.exec(n.slice(e,e+1));return r?(t.q=3*r[0]-3,e+r[0].length):-1}function N(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.m=r[0]-1,e+r[0].length):-1}function j(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.d=+r[0],e+r[0].length):-1}function E(t,n,e){var r=p.exec(n.slice(e,e+3));return r?(t.m=0,t.d=+r[0],e+r[0].length):-1}function D(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.H=+r[0],e+r[0].length):-1}function F(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.M=+r[0],e+r[0].length):-1}function P(t,n,e){var r=p.exec(n.slice(e,e+2));return r?(t.S=+r[0],e+r[0].length):-1}function L(t,n,e){var r=p.exec(n.slice(e,e+3));return r?(t.L=+r[0],e+r[0].length):-1}function I(t,n,e){var r=p.exec(n.slice(e,e+6));return r?(t.L=Math.floor(r[0]/1e3),e+r[0].length):-1}function U(t,n,e){var r=y.exec(n.slice(e,e+1));return r?e+r[0].length:-1}function R(t,n,e){var r=p.exec(n.slice(e));return r?(t.Q=+r[0],e+r[0].length):-1}function B(t,n,e){var r=p.exec(n.slice(e));return r?(t.s=+r[0],e+r[0].length):-1}function H(t,n){return g(t.getDate(),n,2)}function q(t,n){return g(t.getHours(),n,2)}function Y(t,n){return g(t.getHours()%12||12,n,2)}function z(t,n){return g(1+u.b.count(Object(a.a)(t),t),n,3)}function G(t,n){return g(t.getMilliseconds(),n,3)}function V(t,n){return G(t,n)+"000"}function X(t,n){return g(t.getMonth()+1,n,2)}function W(t,n){return g(t.getMinutes(),n,2)}function $(t,n){return g(t.getSeconds(),n,2)}function Q(t){var n=t.getDay();return 0===n?7:n}function Z(t,n){return g(o.g.count(Object(a.a)(t)-1,t),n,2)}function J(t,n){var e=t.getDay();return t=e>=4||0===e?Object(o.i)(t):o.i.ceil(t),g(o.i.count(Object(a.a)(t),t)+(4===Object(a.a)(t).getDay()),n,2)}function K(t){return t.getDay()}function tt(t,n){return g(o.c.count(Object(a.a)(t)-1,t),n,2)}function nt(t,n){return g(t.getFullYear()%100,n,2)}function et(t,n){return g(t.getFullYear()%1e4,n,4)}function rt(t){var n=t.getTimezoneOffset();return(n>0?"-":(n*=-1,"+"))+g(n/60|0,"0",2)+g(n%60,"0",2)}function it(t,n){return g(t.getUTCDate(),n,2)}function ot(t,n){return g(t.getUTCHours(),n,2)}function ut(t,n){return g(t.getUTCHours()%12||12,n,2)}function at(t,n){return g(1+i.a.count(Object(c.a)(t),t),n,3)}function ct(t,n){return g(t.getUTCMilliseconds(),n,3)}function st(t,n){return ct(t,n)+"000"}function lt(t,n){return g(t.getUTCMonth()+1,n,2)}function ft(t,n){return g(t.getUTCMinutes(),n,2)}function ht(t,n){return g(t.getUTCSeconds(),n,2)}function dt(t){var n=t.getUTCDay();return 0===n?7:n}function pt(t,n){return g(r.g.count(Object(c.a)(t)-1,t),n,2)}function yt(t,n){var e=t.getUTCDay();return t=e>=4||0===e?Object(r.i)(t):r.i.ceil(t),g(r.i.count(Object(c.a)(t),t)+(4===Object(c.a)(t).getUTCDay()),n,2)}function _t(t){return t.getUTCDay()}function gt(t,n){return g(r.c.count(Object(c.a)(t)-1,t),n,2)}function vt(t,n){return g(t.getUTCFullYear()%100,n,2)}function mt(t,n){return g(t.getUTCFullYear()%1e4,n,4)}function bt(){return"+0000"}function xt(){return"%"}function wt(t){return+t}function Mt(t){return Math.floor(+t/1e3)}},function(t,n,e){"use strict";var r=e(5),i=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,o=new RegExp(i.source,"g");n.a=function(t,n){var e,u,a,c=i.lastIndex=o.lastIndex=0,s=-1,l=[],f=[];for(t+="",n+="";(e=i.exec(t))&&(u=o.exec(n));)(a=u.index)>c&&(a=n.slice(c,a),l[s]?l[s]+=a:l[++s]=a),(e=e[0])===(u=u[0])?l[s]?l[s]+=u:l[++s]=u:(l[++s]=null,f.push({i:s,x:Object(r.a)(e,u)})),c=o.lastIndex;return c<n.length&&(a=n.slice(c),l[s]?l[s]+=a:l[++s]=a),l.length<2?f[0]?function(t){return function(n){return t(n)+""}}(f[0].x):function(t){return function(){return t}}(n):(n=f.length,function(t){for(var e,r=0;r<n;++r)l[(e=f[r]).i]=e.x(t);return l.join("")})}},function(t,n,e){"use strict";n.a=function(t,n){var e=new Date;return t=+t,n=+n,function(r){return e.setTime(t*(1-r)+n*r),e}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return o}));var r=e(36),i=e(25);function o(t,n){var e,i=n?n.length:0,o=t?Math.min(i,t.length):0,u=new Array(o),a=new Array(i);for(e=0;e<o;++e)u[e]=Object(r.a)(t[e],n[e]);for(;e<i;++e)a[e]=n[e];return function(t){for(e=0;e<o;++e)a[e]=u[e](t);return a}}n.a=function(t,n){return(Object(i.b)(n)?i.a:o)(t,n)}},function(t,n,e){"use strict";var r=e(36);n.a=function(t,n){var e,i={},o={};for(e in null!==t&&"object"==typeof t||(t={}),null!==n&&"object"==typeof n||(n={}),n)e in t?i[e]=Object(r.a)(t[e],n[e]):o[e]=n[e];return function(t){for(e in i)o[e]=i[e](t);return o}}},function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t){var n=Object(r.a)();return n.changedTouches&&(n=n.changedTouches[0]),Object(i.a)(t,n)}},function(t,n,e){"use strict";var r=e(22),i=e(13);n.a=function(t,n,e){arguments.length<3&&(e=n,n=Object(r.a)().changedTouches);for(var o,u=0,a=n?n.length:0;u<a;++u)if((o=n[u]).identifier===e)return Object(i.a)(t,o);return null}},function(t,n,e){"use strict";var r=e(8);n.a=function(t){return Math.max(0,-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(Object(r.a)(n)/3)))-Object(r.a)(Math.abs(t)))}},function(t,n,e){"use strict";var r=e(8);n.a=function(t,n){return t=Math.abs(t),n=Math.abs(n)-t,Math.max(0,Object(r.a)(n)-Object(r.a)(t))+1}},function(t,n,e){"use strict";function r(t){return+t}function i(t){return t*t}function o(t){return t*(2-t)}function u(t){return((t*=2)<=1?t*t:--t*(2-t)+1)/2}e.r(n);var a=e(29),c=function t(n){function e(t){return Math.pow(t,n)}return n=+n,e.exponent=t,e}(3),s=function t(n){function e(t){return 1-Math.pow(1-t,n)}return n=+n,e.exponent=t,e}(3),l=function t(n){function e(t){return((t*=2)<=1?Math.pow(t,n):2-Math.pow(2-t,n))/2}return n=+n,e.exponent=t,e}(3),f=Math.PI,h=f/2;function d(t){return 1-Math.cos(t*h)}function p(t){return Math.sin(t*h)}function y(t){return(1-Math.cos(f*t))/2}function _(t){return Math.pow(2,10*t-10)}function g(t){return 1-Math.pow(2,-10*t)}function v(t){return((t*=2)<=1?Math.pow(2,10*t-10):2-Math.pow(2,10-10*t))/2}function m(t){return 1-Math.sqrt(1-t*t)}function b(t){return Math.sqrt(1- --t*t)}function x(t){return((t*=2)<=1?1-Math.sqrt(1-t*t):Math.sqrt(1-(t-=2)*t)+1)/2}var w=7.5625;function M(t){return 1-T(1-t)}function T(t){return(t=+t)<4/11?w*t*t:t<8/11?w*(t-=6/11)*t+.75:t<10/11?w*(t-=9/11)*t+.9375:w*(t-=21/22)*t+63/64}function O(t){return((t*=2)<=1?1-T(1-t):T(t-1)+1)/2}var k=function t(n){function e(t){return t*t*((n+1)*t-n)}return n=+n,e.overshoot=t,e}(1.70158),A=function t(n){function e(t){return--t*t*((n+1)*t+n)+1}return n=+n,e.overshoot=t,e}(1.70158),C=function t(n){function e(t){return((t*=2)<1?t*t*((n+1)*t-n):(t-=2)*t*((n+1)*t+n)+2)/2}return n=+n,e.overshoot=t,e}(1.70158),S=2*Math.PI,N=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=S);function i(t){return n*Math.pow(2,10*--t)*Math.sin((r-t)/e)}return i.amplitude=function(n){return t(n,e*S)},i.period=function(e){return t(n,e)},i}(1,.3),j=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=S);function i(t){return 1-n*Math.pow(2,-10*(t=+t))*Math.sin((t+r)/e)}return i.amplitude=function(n){return t(n,e*S)},i.period=function(e){return t(n,e)},i}(1,.3),E=function t(n,e){var r=Math.asin(1/(n=Math.max(1,n)))*(e/=S);function i(t){return((t=2*t-1)<0?n*Math.pow(2,10*t)*Math.sin((r-t)/e):2-n*Math.pow(2,-10*t)*Math.sin((r+t)/e))/2}return i.amplitude=function(n){return t(n,e*S)},i.period=function(e){return t(n,e)},i}(1,.3);e.d(n,"easeLinear",(function(){return r})),e.d(n,"easeQuad",(function(){return u})),e.d(n,"easeQuadIn",(function(){return i})),e.d(n,"easeQuadOut",(function(){return o})),e.d(n,"easeQuadInOut",(function(){return u})),e.d(n,"easeCubic",(function(){return a.b})),e.d(n,"easeCubicIn",(function(){return a.a})),e.d(n,"easeCubicOut",(function(){return a.c})),e.d(n,"easeCubicInOut",(function(){return a.b})),e.d(n,"easePoly",(function(){return l})),e.d(n,"easePolyIn",(function(){return c})),e.d(n,"easePolyOut",(function(){return s})),e.d(n,"easePolyInOut",(function(){return l})),e.d(n,"easeSin",(function(){return y})),e.d(n,"easeSinIn",(function(){return d})),e.d(n,"easeSinOut",(function(){return p})),e.d(n,"easeSinInOut",(function(){return y})),e.d(n,"easeExp",(function(){return v})),e.d(n,"easeExpIn",(function(){return _})),e.d(n,"easeExpOut",(function(){return g})),e.d(n,"easeExpInOut",(function(){return v})),e.d(n,"easeCircle",(function(){return x})),e.d(n,"easeCircleIn",(function(){return m})),e.d(n,"easeCircleOut",(function(){return b})),e.d(n,"easeCircleInOut",(function(){return x})),e.d(n,"easeBounce",(function(){return T})),e.d(n,"easeBounceIn",(function(){return M})),e.d(n,"easeBounceOut",(function(){return T})),e.d(n,"easeBounceInOut",(function(){return O})),e.d(n,"easeBack",(function(){return C})),e.d(n,"easeBackIn",(function(){return k})),e.d(n,"easeBackOut",(function(){return A})),e.d(n,"easeBackInOut",(function(){return C})),e.d(n,"easeElastic",(function(){return j})),e.d(n,"easeElasticIn",(function(){return N})),e.d(n,"easeElasticOut",(function(){return j})),e.d(n,"easeElasticInOut",(function(){return E}))},function(t,n,e){"use strict";var r;void 0===(r=function(){return{colorSchemas:{britecharts:["#6aedc7","#39c2c9","#ffce00","#ffa71a","#f866b9","#998ce3"],grey:["#F8F8FA","#EFF2F5","#D2D6DF","#C3C6CF","#ADB0B6","#666A73","#45494E","#363A43","#282C35"],orange:["#fcc870","#ffa71a","#fb8825","#f6682f","#db5a2c","#bf4c28","#a43b1c","#892a10","#f9e9c5"],blueGreen:["#ccf7f6","#70e4e0","#00d8d2","#00acaf","#007f8c","#005e66","#003c3f","#002d2f","#0d2223"],teal:["#ccfffe","#94f7f4","#00fff8","#1de1e1","#39c2c9","#2e9a9d","#227270","#1a5957","#133f3e"],green:["#edfff7","#d7ffef","#c0ffe7","#95f5d7","#6aedc7","#59c3a3","#479980","#34816a","#206953"],yellow:["#f9f2b3","#fbe986","#fce05a","#fed72d","#ffce00","#fcc11c","#f9b438","#eda629","#e09819"],pink:["#fdd1ea","#fb9cd2","#f866b9","#fc40b6","#ff1ab3","#e3239d","#c62c86","#a62073","#85135f"],purple:["#ddd6fc","#bbb1f0","#998ce3","#8e6bc1","#824a9e","#77337f","#6b1c60","#591650","#470f3f"],red:["#ffd8d4","#ffb5b0","#ff938c","#ff766c","#ff584c","#f04b42","#e03d38","#be2e29","#9c1e19"]},colorSchemasHuman:{britecharts:"Britecharts Default",grey:"Britecharts Grey",orange:"Orange",blueGreen:"Blue",teal:"Light Blue",green:"Green",yellow:"Yellow",pink:"Pink",purple:"Purple",red:"Red"},colorGradients:{greenBlue:["#39C7EA","#4CDCBA"],orangePink:["#FBC670","#F766B8"],bluePurple:["#3DC3C9","#824a9e"]},colorGradientsHuman:{greenBlue:"Green to Blue",orangePink:"Orange to Pink",bluePurple:"Blue to Purple"},singleColors:{aloeGreen:["#7bdcc0"],greenColor:["#6aedc7"],blueColor:["#39c2c9"],yellowColor:["#ffce00"],orangeColor:["#ffa71a"],pinkColor:["#f866b9"],purpleColor:["#998ce3"]},singleColorsHuman:{aloeGreen:"Aloe Green",greenColor:"Green",blueColor:"Blue",yellowColor:"Yellow",orangeColor:"Orange",pinkColor:"Pink",purpleColor:"Purple"}}}.call(n,e,n,t))||(t.exports=r)},,function(t,n,e){"use strict";e.d(n,"a",(function(){return r})),e.d(n,"b",(function(){return i}));var r=Math.PI/180,i=180/Math.PI},function(t,n,e){"use strict";e.r(n);var r=e(69);e.d(n,"dispatch",(function(){return r.a}))},function(t,n,e){"use strict";var r={value:function(){}};function i(){for(var t,n=0,e=arguments.length,r={};n<e;++n){if(!(t=arguments[n]+"")||t in r||/[\s.]/.test(t))throw new Error("illegal type: "+t);r[t]=[]}return new o(r)}function o(t){this._=t}function u(t,n){return t.trim().split(/^|\s+/).map((function(t){var e="",r=t.indexOf(".");if(r>=0&&(e=t.slice(r+1),t=t.slice(0,r)),t&&!n.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:e}}))}function a(t,n){for(var e,r=0,i=t.length;r<i;++r)if((e=t[r]).name===n)return e.value}function c(t,n,e){for(var i=0,o=t.length;i<o;++i)if(t[i].name===n){t[i]=r,t=t.slice(0,i).concat(t.slice(i+1));break}return null!=e&&t.push({name:n,value:e}),t}o.prototype=i.prototype={constructor:o,on:function(t,n){var e,r=this._,i=u(t+"",r),o=-1,s=i.length;if(!(arguments.length<2)){if(null!=n&&"function"!=typeof n)throw new Error("invalid callback: "+n);for(;++o<s;)if(e=(t=i[o]).type)r[e]=c(r[e],t.name,n);else if(null==n)for(e in r)r[e]=c(r[e],t.name,null);return this}for(;++o<s;)if((e=(t=i[o]).type)&&(e=a(r[e],t.name)))return e},copy:function(){var t={},n=this._;for(var e in n)t[e]=n[e].slice();return new o(t)},call:function(t,n){if((e=arguments.length-2)>0)for(var e,r,i=new Array(e),o=0;o<e;++o)i[o]=arguments[o+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(o=0,e=(r=this._[t]).length;o<e;++o)r[o].value.apply(n,i)},apply:function(t,n,e){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var r=this._[t],i=0,o=r.length;i<o;++i)r[i].value.apply(n,e)}},n.a=i},function(t,n,e){"use strict";var r;void 0===(r=function(){var t=e(71),n=e(38);return{axisTimeCombinations:{MINUTE_HOUR:"minute-hour",HOUR_DAY:"hour-daymonth",DAY_MONTH:"day-month",MONTH_YEAR:"month-year",CUSTOM:"custom"},curveMap:{linear:t.curveLinear,basis:t.curveBasis,cardinal:t.curveCardinal,catmullRom:t.curveCatmullRom,monotoneX:t.curveMonotoneX,monotoneY:t.curveMonotoneY,natural:t.curveNatural,step:t.curveStep,stepAfter:t.curveStepAfter,stepBefore:t.curveStepBefore},emptyDonutData:[{quantity:1,percentage:100}],hoursHuman:["00h","01h","02h","03h","04h","05h","06h","07h","08h","09h","10h","11h","12h","13h","14h","15h","16h","17h","18h","19h","20h","21h","22h","23h"],timeBenchmarks:{ONE_AND_A_HALF_YEARS:47304e6,ONE_YEAR:31536000365,ONE_DAY:86400001},lineGradientId:"lineGradientId",timeIntervals:{timeMillisecond:n.timeMillisecond,utcMillisecond:n.utcMillisecond,timeSecond:n.timeSecond,utcSecond:n.utcSecond,timeMinute:n.timeMinute,utcMinute:n.utcMinute,timeHour:n.timeHour,utcHour:n.utcHour,timeDay:n.timeDay,utcDay:n.utcDay,timeWeek:n.timeWeek,utcWeek:n.utcWeek,timeSunday:n.timeSunday,utcSunday:n.utcSunday,timeMonday:n.timeMonday,utcMonday:n.utcMonday,timeTuesday:n.timeTuesday,utcTuesday:n.utcTuesday,timeWednesday:n.timeWednesday,utcWednesday:n.utcWednesday,timeThursday:n.timeThursday,utcThursday:n.utcThursday,timeFriday:n.timeFriday,utcFriday:n.utcFriday,timeSaturday:n.timeSaturday,utcSaturday:n.utcSaturday,timeMonth:n.timeMonth,utcMonth:n.utcMonth,timeYear:n.timeYear,utcYear:n.utcYear},FORMAT_LOCALE_URL:"https://cdn.jsdelivr.net/npm/d3-format/locale"}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";e.r(n);var r=Math.PI,i=2*r,o=i-1e-6;function u(){this._x0=this._y0=this._x1=this._y1=null,this._=""}function a(){return new u}u.prototype=a.prototype={constructor:u,moveTo:function(t,n){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+n)},closePath:function(){null!==this._x1&&(this._x1=this._x0,this._y1=this._y0,this._+="Z")},lineTo:function(t,n){this._+="L"+(this._x1=+t)+","+(this._y1=+n)},quadraticCurveTo:function(t,n,e,r){this._+="Q"+ +t+","+ +n+","+(this._x1=+e)+","+(this._y1=+r)},bezierCurveTo:function(t,n,e,r,i,o){this._+="C"+ +t+","+ +n+","+ +e+","+ +r+","+(this._x1=+i)+","+(this._y1=+o)},arcTo:function(t,n,e,i,o){t=+t,n=+n,e=+e,i=+i,o=+o;var u=this._x1,a=this._y1,c=e-t,s=i-n,l=u-t,f=a-n,h=l*l+f*f;if(o<0)throw new Error("negative radius: "+o);if(null===this._x1)this._+="M"+(this._x1=t)+","+(this._y1=n);else if(h>1e-6)if(Math.abs(f*c-s*l)>1e-6&&o){var d=e-u,p=i-a,y=c*c+s*s,_=d*d+p*p,g=Math.sqrt(y),v=Math.sqrt(h),m=o*Math.tan((r-Math.acos((y+h-_)/(2*g*v)))/2),b=m/v,x=m/g;Math.abs(b-1)>1e-6&&(this._+="L"+(t+b*l)+","+(n+b*f)),this._+="A"+o+","+o+",0,0,"+ +(f*d>l*p)+","+(this._x1=t+x*c)+","+(this._y1=n+x*s)}else this._+="L"+(this._x1=t)+","+(this._y1=n);else;},arc:function(t,n,e,u,a,c){t=+t,n=+n,c=!!c;var s=(e=+e)*Math.cos(u),l=e*Math.sin(u),f=t+s,h=n+l,d=1^c,p=c?u-a:a-u;if(e<0)throw new Error("negative radius: "+e);null===this._x1?this._+="M"+f+","+h:(Math.abs(this._x1-f)>1e-6||Math.abs(this._y1-h)>1e-6)&&(this._+="L"+f+","+h),e&&(p<0&&(p=p%i+i),p>o?this._+="A"+e+","+e+",0,1,"+d+","+(t-s)+","+(n-l)+"A"+e+","+e+",0,1,"+d+","+(this._x1=f)+","+(this._y1=h):p>1e-6&&(this._+="A"+e+","+e+",0,"+ +(p>=r)+","+d+","+(this._x1=t+e*Math.cos(a))+","+(this._y1=n+e*Math.sin(a))))},rect:function(t,n,e,r){this._+="M"+(this._x0=this._x1=+t)+","+(this._y0=this._y1=+n)+"h"+ +e+"v"+ +r+"h"+-e+"Z"},toString:function(){return this._}};var c=a,s=function(t){return function(){return t}},l=Math.abs,f=Math.atan2,h=Math.cos,d=Math.max,p=Math.min,y=Math.sin,_=Math.sqrt,g=Math.PI,v=g/2,m=2*g;function b(t){return t>1?0:t<-1?g:Math.acos(t)}function x(t){return t>=1?v:t<=-1?-v:Math.asin(t)}function w(t){return t.innerRadius}function M(t){return t.outerRadius}function T(t){return t.startAngle}function O(t){return t.endAngle}function k(t){return t&&t.padAngle}function A(t,n,e,r,i,o,u,a){var c=e-t,s=r-n,l=u-i,f=a-o,h=f*c-l*s;if(!(h*h<1e-12))return[t+(h=(l*(n-o)-f*(t-i))/h)*c,n+h*s]}function C(t,n,e,r,i,o,u){var a=t-e,c=n-r,s=(u?o:-o)/_(a*a+c*c),l=s*c,f=-s*a,h=t+l,p=n+f,y=e+l,g=r+f,v=(h+y)/2,m=(p+g)/2,b=y-h,x=g-p,w=b*b+x*x,M=i-o,T=h*g-y*p,O=(x<0?-1:1)*_(d(0,M*M*w-T*T)),k=(T*x-b*O)/w,A=(-T*b-x*O)/w,C=(T*x+b*O)/w,S=(-T*b+x*O)/w,N=k-v,j=A-m,E=C-v,D=S-m;return N*N+j*j>E*E+D*D&&(k=C,A=S),{cx:k,cy:A,x01:-l,y01:-f,x11:k*(i/M-1),y11:A*(i/M-1)}}var S=function(){var t=w,n=M,e=s(0),r=null,i=T,o=O,u=k,a=null;function d(){var s,d,w=+t.apply(this,arguments),M=+n.apply(this,arguments),T=i.apply(this,arguments)-v,O=o.apply(this,arguments)-v,k=l(O-T),S=O>T;if(a||(a=s=c()),M<w&&(d=M,M=w,w=d),M>1e-12)if(k>m-1e-12)a.moveTo(M*h(T),M*y(T)),a.arc(0,0,M,T,O,!S),w>1e-12&&(a.moveTo(w*h(O),w*y(O)),a.arc(0,0,w,O,T,S));else{var N,j,E=T,D=O,F=T,P=O,L=k,I=k,U=u.apply(this,arguments)/2,R=U>1e-12&&(r?+r.apply(this,arguments):_(w*w+M*M)),B=p(l(M-w)/2,+e.apply(this,arguments)),H=B,q=B;if(R>1e-12){var Y=x(R/w*y(U)),z=x(R/M*y(U));(L-=2*Y)>1e-12?(F+=Y*=S?1:-1,P-=Y):(L=0,F=P=(T+O)/2),(I-=2*z)>1e-12?(E+=z*=S?1:-1,D-=z):(I=0,E=D=(T+O)/2)}var G=M*h(E),V=M*y(E),X=w*h(P),W=w*y(P);if(B>1e-12){var $,Q=M*h(D),Z=M*y(D),J=w*h(F),K=w*y(F);if(k<g&&($=A(G,V,J,K,Q,Z,X,W))){var tt=G-$[0],nt=V-$[1],et=Q-$[0],rt=Z-$[1],it=1/y(b((tt*et+nt*rt)/(_(tt*tt+nt*nt)*_(et*et+rt*rt)))/2),ot=_($[0]*$[0]+$[1]*$[1]);H=p(B,(w-ot)/(it-1)),q=p(B,(M-ot)/(it+1))}}I>1e-12?q>1e-12?(N=C(J,K,G,V,M,q,S),j=C(Q,Z,X,W,M,q,S),a.moveTo(N.cx+N.x01,N.cy+N.y01),q<B?a.arc(N.cx,N.cy,q,f(N.y01,N.x01),f(j.y01,j.x01),!S):(a.arc(N.cx,N.cy,q,f(N.y01,N.x01),f(N.y11,N.x11),!S),a.arc(0,0,M,f(N.cy+N.y11,N.cx+N.x11),f(j.cy+j.y11,j.cx+j.x11),!S),a.arc(j.cx,j.cy,q,f(j.y11,j.x11),f(j.y01,j.x01),!S))):(a.moveTo(G,V),a.arc(0,0,M,E,D,!S)):a.moveTo(G,V),w>1e-12&&L>1e-12?H>1e-12?(N=C(X,W,Q,Z,w,-H,S),j=C(G,V,J,K,w,-H,S),a.lineTo(N.cx+N.x01,N.cy+N.y01),H<B?a.arc(N.cx,N.cy,H,f(N.y01,N.x01),f(j.y01,j.x01),!S):(a.arc(N.cx,N.cy,H,f(N.y01,N.x01),f(N.y11,N.x11),!S),a.arc(0,0,w,f(N.cy+N.y11,N.cx+N.x11),f(j.cy+j.y11,j.cx+j.x11),S),a.arc(j.cx,j.cy,H,f(j.y11,j.x11),f(j.y01,j.x01),!S))):a.arc(0,0,w,P,F,S):a.lineTo(X,W)}else a.moveTo(0,0);if(a.closePath(),s)return a=null,s+""||null}return d.centroid=function(){var e=(+t.apply(this,arguments)+ +n.apply(this,arguments))/2,r=(+i.apply(this,arguments)+ +o.apply(this,arguments))/2-g/2;return[h(r)*e,y(r)*e]},d.innerRadius=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),d):t},d.outerRadius=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),d):n},d.cornerRadius=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),d):e},d.padRadius=function(t){return arguments.length?(r=null==t?null:"function"==typeof t?t:s(+t),d):r},d.startAngle=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),d):i},d.endAngle=function(t){return arguments.length?(o="function"==typeof t?t:s(+t),d):o},d.padAngle=function(t){return arguments.length?(u="function"==typeof t?t:s(+t),d):u},d.context=function(t){return arguments.length?(a=null==t?null:t,d):a},d};function N(t){this._context=t}N.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._point=0},lineEnd:function(){(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;default:this._context.lineTo(t,n)}}};var j=function(t){return new N(t)};function E(t){return t[0]}function D(t){return t[1]}var F=function(){var t=E,n=D,e=s(!0),r=null,i=j,o=null;function u(u){var a,s,l,f=u.length,h=!1;for(null==r&&(o=i(l=c())),a=0;a<=f;++a)!(a<f&&e(s=u[a],a,u))===h&&((h=!h)?o.lineStart():o.lineEnd()),h&&o.point(+t(s,a,u),+n(s,a,u));if(l)return o=null,l+""||null}return u.x=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),u):t},u.y=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),u):n},u.defined=function(t){return arguments.length?(e="function"==typeof t?t:s(!!t),u):e},u.curve=function(t){return arguments.length?(i=t,null!=r&&(o=i(r)),u):i},u.context=function(t){return arguments.length?(null==t?r=o=null:o=i(r=t),u):r},u},P=function(){var t=E,n=null,e=s(0),r=D,i=s(!0),o=null,u=j,a=null;function l(s){var l,f,h,d,p,y=s.length,_=!1,g=new Array(y),v=new Array(y);for(null==o&&(a=u(p=c())),l=0;l<=y;++l){if(!(l<y&&i(d=s[l],l,s))===_)if(_=!_)f=l,a.areaStart(),a.lineStart();else{for(a.lineEnd(),a.lineStart(),h=l-1;h>=f;--h)a.point(g[h],v[h]);a.lineEnd(),a.areaEnd()}_&&(g[l]=+t(d,l,s),v[l]=+e(d,l,s),a.point(n?+n(d,l,s):g[l],r?+r(d,l,s):v[l]))}if(p)return a=null,p+""||null}function f(){return F().defined(i).curve(u).context(o)}return l.x=function(e){return arguments.length?(t="function"==typeof e?e:s(+e),n=null,l):t},l.x0=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),l):t},l.x1=function(t){return arguments.length?(n=null==t?null:"function"==typeof t?t:s(+t),l):n},l.y=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),r=null,l):e},l.y0=function(t){return arguments.length?(e="function"==typeof t?t:s(+t),l):e},l.y1=function(t){return arguments.length?(r=null==t?null:"function"==typeof t?t:s(+t),l):r},l.lineX0=l.lineY0=function(){return f().x(t).y(e)},l.lineY1=function(){return f().x(t).y(r)},l.lineX1=function(){return f().x(n).y(e)},l.defined=function(t){return arguments.length?(i="function"==typeof t?t:s(!!t),l):i},l.curve=function(t){return arguments.length?(u=t,null!=o&&(a=u(o)),l):u},l.context=function(t){return arguments.length?(null==t?o=a=null:a=u(o=t),l):o},l},L=function(t,n){return n<t?-1:n>t?1:n>=t?0:NaN},I=function(t){return t},U=function(){var t=I,n=L,e=null,r=s(0),i=s(m),o=s(0);function u(u){var a,c,s,l,f,h=u.length,d=0,p=new Array(h),y=new Array(h),_=+r.apply(this,arguments),g=Math.min(m,Math.max(-m,i.apply(this,arguments)-_)),v=Math.min(Math.abs(g)/h,o.apply(this,arguments)),b=v*(g<0?-1:1);for(a=0;a<h;++a)(f=y[p[a]=a]=+t(u[a],a,u))>0&&(d+=f);for(null!=n?p.sort((function(t,e){return n(y[t],y[e])})):null!=e&&p.sort((function(t,n){return e(u[t],u[n])})),a=0,s=d?(g-h*b)/d:0;a<h;++a,_=l)c=p[a],l=_+((f=y[c])>0?f*s:0)+b,y[c]={data:u[c],index:a,value:f,startAngle:_,endAngle:l,padAngle:v};return y}return u.value=function(n){return arguments.length?(t="function"==typeof n?n:s(+n),u):t},u.sortValues=function(t){return arguments.length?(n=t,e=null,u):n},u.sort=function(t){return arguments.length?(e=t,n=null,u):e},u.startAngle=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),u):r},u.endAngle=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),u):i},u.padAngle=function(t){return arguments.length?(o="function"==typeof t?t:s(+t),u):o},u},R=H(j);function B(t){this._curve=t}function H(t){function n(n){return new B(t(n))}return n._curve=t,n}function q(t){var n=t.curve;return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t.curve=function(t){return arguments.length?n(H(t)):n()._curve},t}B.prototype={areaStart:function(){this._curve.areaStart()},areaEnd:function(){this._curve.areaEnd()},lineStart:function(){this._curve.lineStart()},lineEnd:function(){this._curve.lineEnd()},point:function(t,n){this._curve.point(n*Math.sin(t),n*-Math.cos(t))}};var Y=function(){return q(F().curve(R))},z=function(){var t=P().curve(R),n=t.curve,e=t.lineX0,r=t.lineX1,i=t.lineY0,o=t.lineY1;return t.angle=t.x,delete t.x,t.startAngle=t.x0,delete t.x0,t.endAngle=t.x1,delete t.x1,t.radius=t.y,delete t.y,t.innerRadius=t.y0,delete t.y0,t.outerRadius=t.y1,delete t.y1,t.lineStartAngle=function(){return q(e())},delete t.lineX0,t.lineEndAngle=function(){return q(r())},delete t.lineX1,t.lineInnerRadius=function(){return q(i())},delete t.lineY0,t.lineOuterRadius=function(){return q(o())},delete t.lineY1,t.curve=function(t){return arguments.length?n(H(t)):n()._curve},t},G=function(t,n){return[(n=+n)*Math.cos(t-=Math.PI/2),n*Math.sin(t)]},V=Array.prototype.slice;function X(t){return t.source}function W(t){return t.target}function $(t){var n=X,e=W,r=E,i=D,o=null;function u(){var u,a=V.call(arguments),s=n.apply(this,a),l=e.apply(this,a);if(o||(o=u=c()),t(o,+r.apply(this,(a[0]=s,a)),+i.apply(this,a),+r.apply(this,(a[0]=l,a)),+i.apply(this,a)),u)return o=null,u+""||null}return u.source=function(t){return arguments.length?(n=t,u):n},u.target=function(t){return arguments.length?(e=t,u):e},u.x=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),u):r},u.y=function(t){return arguments.length?(i="function"==typeof t?t:s(+t),u):i},u.context=function(t){return arguments.length?(o=null==t?null:t,u):o},u}function Q(t,n,e,r,i){t.moveTo(n,e),t.bezierCurveTo(n=(n+r)/2,e,n,i,r,i)}function Z(t,n,e,r,i){t.moveTo(n,e),t.bezierCurveTo(n,e=(e+i)/2,r,e,r,i)}function J(t,n,e,r,i){var o=G(n,e),u=G(n,e=(e+i)/2),a=G(r,e),c=G(r,i);t.moveTo(o[0],o[1]),t.bezierCurveTo(u[0],u[1],a[0],a[1],c[0],c[1])}function K(){return $(Q)}function tt(){return $(Z)}function nt(){var t=$(J);return t.angle=t.x,delete t.x,t.radius=t.y,delete t.y,t}var et={draw:function(t,n){var e=Math.sqrt(n/g);t.moveTo(e,0),t.arc(0,0,e,0,m)}},rt={draw:function(t,n){var e=Math.sqrt(n/5)/2;t.moveTo(-3*e,-e),t.lineTo(-e,-e),t.lineTo(-e,-3*e),t.lineTo(e,-3*e),t.lineTo(e,-e),t.lineTo(3*e,-e),t.lineTo(3*e,e),t.lineTo(e,e),t.lineTo(e,3*e),t.lineTo(-e,3*e),t.lineTo(-e,e),t.lineTo(-3*e,e),t.closePath()}},it=Math.sqrt(1/3),ot=2*it,ut={draw:function(t,n){var e=Math.sqrt(n/ot),r=e*it;t.moveTo(0,-e),t.lineTo(r,0),t.lineTo(0,e),t.lineTo(-r,0),t.closePath()}},at=Math.sin(g/10)/Math.sin(7*g/10),ct=Math.sin(m/10)*at,st=-Math.cos(m/10)*at,lt={draw:function(t,n){var e=Math.sqrt(.8908130915292852*n),r=ct*e,i=st*e;t.moveTo(0,-e),t.lineTo(r,i);for(var o=1;o<5;++o){var u=m*o/5,a=Math.cos(u),c=Math.sin(u);t.lineTo(c*e,-a*e),t.lineTo(a*r-c*i,c*r+a*i)}t.closePath()}},ft={draw:function(t,n){var e=Math.sqrt(n),r=-e/2;t.rect(r,r,e,e)}},ht=Math.sqrt(3),dt={draw:function(t,n){var e=-Math.sqrt(n/(3*ht));t.moveTo(0,2*e),t.lineTo(-ht*e,-e),t.lineTo(ht*e,-e),t.closePath()}},pt=Math.sqrt(3)/2,yt=1/Math.sqrt(12),_t=3*(yt/2+1),gt={draw:function(t,n){var e=Math.sqrt(n/_t),r=e/2,i=e*yt,o=r,u=e*yt+e,a=-o,c=u;t.moveTo(r,i),t.lineTo(o,u),t.lineTo(a,c),t.lineTo(-.5*r-pt*i,pt*r+-.5*i),t.lineTo(-.5*o-pt*u,pt*o+-.5*u),t.lineTo(-.5*a-pt*c,pt*a+-.5*c),t.lineTo(-.5*r+pt*i,-.5*i-pt*r),t.lineTo(-.5*o+pt*u,-.5*u-pt*o),t.lineTo(-.5*a+pt*c,-.5*c-pt*a),t.closePath()}},vt=[et,rt,ut,ft,lt,dt,gt],mt=function(){var t=s(et),n=s(64),e=null;function r(){var r;if(e||(e=r=c()),t.apply(this,arguments).draw(e,+n.apply(this,arguments)),r)return e=null,r+""||null}return r.type=function(n){return arguments.length?(t="function"==typeof n?n:s(n),r):t},r.size=function(t){return arguments.length?(n="function"==typeof t?t:s(+t),r):n},r.context=function(t){return arguments.length?(e=null==t?null:t,r):e},r},bt=function(){};function xt(t,n,e){t._context.bezierCurveTo((2*t._x0+t._x1)/3,(2*t._y0+t._y1)/3,(t._x0+2*t._x1)/3,(t._y0+2*t._y1)/3,(t._x0+4*t._x1+n)/6,(t._y0+4*t._y1+e)/6)}function wt(t){this._context=t}wt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){switch(this._point){case 3:xt(this,this._x1,this._y1);case 2:this._context.lineTo(this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3,this._context.lineTo((5*this._x0+this._x1)/6,(5*this._y0+this._y1)/6);default:xt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var Mt=function(t){return new wt(t)};function Tt(t){this._context=t}Tt.prototype={areaStart:bt,areaEnd:bt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._y0=this._y1=this._y2=this._y3=this._y4=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x2,this._y2),this._context.closePath();break;case 2:this._context.moveTo((this._x2+2*this._x3)/3,(this._y2+2*this._y3)/3),this._context.lineTo((this._x3+2*this._x2)/3,(this._y3+2*this._y2)/3),this._context.closePath();break;case 3:this.point(this._x2,this._y2),this.point(this._x3,this._y3),this.point(this._x4,this._y4)}},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._x2=t,this._y2=n;break;case 1:this._point=2,this._x3=t,this._y3=n;break;case 2:this._point=3,this._x4=t,this._y4=n,this._context.moveTo((this._x0+4*this._x1+t)/6,(this._y0+4*this._y1+n)/6);break;default:xt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var Ot=function(t){return new Tt(t)};function kt(t){this._context=t}kt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3;var e=(this._x0+4*this._x1+t)/6,r=(this._y0+4*this._y1+n)/6;this._line?this._context.lineTo(e,r):this._context.moveTo(e,r);break;case 3:this._point=4;default:xt(this,t,n)}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n}};var At=function(t){return new kt(t)};function Ct(t,n){this._basis=new wt(t),this._beta=n}Ct.prototype={lineStart:function(){this._x=[],this._y=[],this._basis.lineStart()},lineEnd:function(){var t=this._x,n=this._y,e=t.length-1;if(e>0)for(var r,i=t[0],o=n[0],u=t[e]-i,a=n[e]-o,c=-1;++c<=e;)r=c/e,this._basis.point(this._beta*t[c]+(1-this._beta)*(i+r*u),this._beta*n[c]+(1-this._beta)*(o+r*a));this._x=this._y=null,this._basis.lineEnd()},point:function(t,n){this._x.push(+t),this._y.push(+n)}};var St=function t(n){function e(t){return 1===n?new wt(t):new Ct(t,n)}return e.beta=function(n){return t(+n)},e}(.85);function Nt(t,n,e){t._context.bezierCurveTo(t._x1+t._k*(t._x2-t._x0),t._y1+t._k*(t._y2-t._y0),t._x2+t._k*(t._x1-n),t._y2+t._k*(t._y1-e),t._x2,t._y2)}function jt(t,n){this._context=t,this._k=(1-n)/6}jt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:Nt(this,this._x1,this._y1)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2,this._x1=t,this._y1=n;break;case 2:this._point=3;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Et=function t(n){function e(t){return new jt(t,n)}return e.tension=function(n){return t(+n)},e}(0);function Dt(t,n){this._context=t,this._k=(1-n)/6}Dt.prototype={areaStart:bt,areaEnd:bt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._x3=t,this._y3=n;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=n);break;case 2:this._point=3,this._x5=t,this._y5=n;break;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Ft=function t(n){function e(t){return new Dt(t,n)}return e.tension=function(n){return t(+n)},e}(0);function Pt(t,n){this._context=t,this._k=(1-n)/6}Pt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:Nt(this,t,n)}this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Lt=function t(n){function e(t){return new Pt(t,n)}return e.tension=function(n){return t(+n)},e}(0);function It(t,n,e){var r=t._x1,i=t._y1,o=t._x2,u=t._y2;if(t._l01_a>1e-12){var a=2*t._l01_2a+3*t._l01_a*t._l12_a+t._l12_2a,c=3*t._l01_a*(t._l01_a+t._l12_a);r=(r*a-t._x0*t._l12_2a+t._x2*t._l01_2a)/c,i=(i*a-t._y0*t._l12_2a+t._y2*t._l01_2a)/c}if(t._l23_a>1e-12){var s=2*t._l23_2a+3*t._l23_a*t._l12_a+t._l12_2a,l=3*t._l23_a*(t._l23_a+t._l12_a);o=(o*s+t._x1*t._l23_2a-n*t._l12_2a)/l,u=(u*s+t._y1*t._l23_2a-e*t._l12_2a)/l}t._context.bezierCurveTo(r,i,o,u,t._x2,t._y2)}function Ut(t,n){this._context=t,this._alpha=n}Ut.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x2,this._y2);break;case 3:this.point(this._x2,this._y2)}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Rt=function t(n){function e(t){return n?new Ut(t,n):new jt(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function Bt(t,n){this._context=t,this._alpha=n}Bt.prototype={areaStart:bt,areaEnd:bt,lineStart:function(){this._x0=this._x1=this._x2=this._x3=this._x4=this._x5=this._y0=this._y1=this._y2=this._y3=this._y4=this._y5=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){switch(this._point){case 1:this._context.moveTo(this._x3,this._y3),this._context.closePath();break;case 2:this._context.lineTo(this._x3,this._y3),this._context.closePath();break;case 3:this.point(this._x3,this._y3),this.point(this._x4,this._y4),this.point(this._x5,this._y5)}},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1,this._x3=t,this._y3=n;break;case 1:this._point=2,this._context.moveTo(this._x4=t,this._y4=n);break;case 2:this._point=3,this._x5=t,this._y5=n;break;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Ht=function t(n){function e(t){return n?new Bt(t,n):new Dt(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function qt(t,n){this._context=t,this._alpha=n}qt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._x2=this._y0=this._y1=this._y2=NaN,this._l01_a=this._l12_a=this._l23_a=this._l01_2a=this._l12_2a=this._l23_2a=this._point=0},lineEnd:function(){(this._line||0!==this._line&&3===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){if(t=+t,n=+n,this._point){var e=this._x2-t,r=this._y2-n;this._l23_a=Math.sqrt(this._l23_2a=Math.pow(e*e+r*r,this._alpha))}switch(this._point){case 0:this._point=1;break;case 1:this._point=2;break;case 2:this._point=3,this._line?this._context.lineTo(this._x2,this._y2):this._context.moveTo(this._x2,this._y2);break;case 3:this._point=4;default:It(this,t,n)}this._l01_a=this._l12_a,this._l12_a=this._l23_a,this._l01_2a=this._l12_2a,this._l12_2a=this._l23_2a,this._x0=this._x1,this._x1=this._x2,this._x2=t,this._y0=this._y1,this._y1=this._y2,this._y2=n}};var Yt=function t(n){function e(t){return n?new qt(t,n):new Pt(t,0)}return e.alpha=function(n){return t(+n)},e}(.5);function zt(t){this._context=t}zt.prototype={areaStart:bt,areaEnd:bt,lineStart:function(){this._point=0},lineEnd:function(){this._point&&this._context.closePath()},point:function(t,n){t=+t,n=+n,this._point?this._context.lineTo(t,n):(this._point=1,this._context.moveTo(t,n))}};var Gt=function(t){return new zt(t)};function Vt(t){return t<0?-1:1}function Xt(t,n,e){var r=t._x1-t._x0,i=n-t._x1,o=(t._y1-t._y0)/(r||i<0&&-0),u=(e-t._y1)/(i||r<0&&-0),a=(o*i+u*r)/(r+i);return(Vt(o)+Vt(u))*Math.min(Math.abs(o),Math.abs(u),.5*Math.abs(a))||0}function Wt(t,n){var e=t._x1-t._x0;return e?(3*(t._y1-t._y0)/e-n)/2:n}function $t(t,n,e){var r=t._x0,i=t._y0,o=t._x1,u=t._y1,a=(o-r)/3;t._context.bezierCurveTo(r+a,i+a*n,o-a,u-a*e,o,u)}function Qt(t){this._context=t}function Zt(t){this._context=new Jt(t)}function Jt(t){this._context=t}function Kt(t){return new Qt(t)}function tn(t){return new Zt(t)}function nn(t){this._context=t}function en(t){var n,e,r=t.length-1,i=new Array(r),o=new Array(r),u=new Array(r);for(i[0]=0,o[0]=2,u[0]=t[0]+2*t[1],n=1;n<r-1;++n)i[n]=1,o[n]=4,u[n]=4*t[n]+2*t[n+1];for(i[r-1]=2,o[r-1]=7,u[r-1]=8*t[r-1]+t[r],n=1;n<r;++n)e=i[n]/o[n-1],o[n]-=e,u[n]-=e*u[n-1];for(i[r-1]=u[r-1]/o[r-1],n=r-2;n>=0;--n)i[n]=(u[n]-i[n+1])/o[n];for(o[r-1]=(t[r]+i[r-1])/2,n=0;n<r-1;++n)o[n]=2*t[n+1]-i[n+1];return[i,o]}Qt.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x0=this._x1=this._y0=this._y1=this._t0=NaN,this._point=0},lineEnd:function(){switch(this._point){case 2:this._context.lineTo(this._x1,this._y1);break;case 3:$t(this,this._t0,Wt(this,this._t0))}(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line=1-this._line},point:function(t,n){var e=NaN;if(n=+n,(t=+t)!==this._x1||n!==this._y1){switch(this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;break;case 2:this._point=3,$t(this,Wt(this,e=Xt(this,t,n)),e);break;default:$t(this,this._t0,e=Xt(this,t,n))}this._x0=this._x1,this._x1=t,this._y0=this._y1,this._y1=n,this._t0=e}}},(Zt.prototype=Object.create(Qt.prototype)).point=function(t,n){Qt.prototype.point.call(this,n,t)},Jt.prototype={moveTo:function(t,n){this._context.moveTo(n,t)},closePath:function(){this._context.closePath()},lineTo:function(t,n){this._context.lineTo(n,t)},bezierCurveTo:function(t,n,e,r,i,o){this._context.bezierCurveTo(n,t,r,e,o,i)}},nn.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=[],this._y=[]},lineEnd:function(){var t=this._x,n=this._y,e=t.length;if(e)if(this._line?this._context.lineTo(t[0],n[0]):this._context.moveTo(t[0],n[0]),2===e)this._context.lineTo(t[1],n[1]);else for(var r=en(t),i=en(n),o=0,u=1;u<e;++o,++u)this._context.bezierCurveTo(r[0][o],i[0][o],r[1][o],i[1][o],t[u],n[u]);(this._line||0!==this._line&&1===e)&&this._context.closePath(),this._line=1-this._line,this._x=this._y=null},point:function(t,n){this._x.push(+t),this._y.push(+n)}};var rn=function(t){return new nn(t)};function on(t,n){this._context=t,this._t=n}on.prototype={areaStart:function(){this._line=0},areaEnd:function(){this._line=NaN},lineStart:function(){this._x=this._y=NaN,this._point=0},lineEnd:function(){0<this._t&&this._t<1&&2===this._point&&this._context.lineTo(this._x,this._y),(this._line||0!==this._line&&1===this._point)&&this._context.closePath(),this._line>=0&&(this._t=1-this._t,this._line=1-this._line)},point:function(t,n){switch(t=+t,n=+n,this._point){case 0:this._point=1,this._line?this._context.lineTo(t,n):this._context.moveTo(t,n);break;case 1:this._point=2;default:if(this._t<=0)this._context.lineTo(this._x,n),this._context.lineTo(t,n);else{var e=this._x*(1-this._t)+t*this._t;this._context.lineTo(e,this._y),this._context.lineTo(e,n)}}this._x=t,this._y=n}};var un=function(t){return new on(t,.5)};function an(t){return new on(t,0)}function cn(t){return new on(t,1)}var sn=function(t,n){if((i=t.length)>1)for(var e,r,i,o=1,u=t[n[0]],a=u.length;o<i;++o)for(r=u,u=t[n[o]],e=0;e<a;++e)u[e][1]+=u[e][0]=isNaN(r[e][1])?r[e][0]:r[e][1]},ln=function(t){for(var n=t.length,e=new Array(n);--n>=0;)e[n]=n;return e};function fn(t,n){return t[n]}var hn=function(){var t=s([]),n=ln,e=sn,r=fn;function i(i){var o,u,a=t.apply(this,arguments),c=i.length,s=a.length,l=new Array(s);for(o=0;o<s;++o){for(var f,h=a[o],d=l[o]=new Array(c),p=0;p<c;++p)d[p]=f=[0,+r(i[p],h,p,i)],f.data=i[p];d.key=h}for(o=0,u=n(l);o<s;++o)l[u[o]].index=o;return e(l,u),l}return i.keys=function(n){return arguments.length?(t="function"==typeof n?n:s(V.call(n)),i):t},i.value=function(t){return arguments.length?(r="function"==typeof t?t:s(+t),i):r},i.order=function(t){return arguments.length?(n=null==t?ln:"function"==typeof t?t:s(V.call(t)),i):n},i.offset=function(t){return arguments.length?(e=null==t?sn:t,i):e},i},dn=function(t,n){if((r=t.length)>0){for(var e,r,i,o=0,u=t[0].length;o<u;++o){for(i=e=0;e<r;++e)i+=t[e][o][1]||0;if(i)for(e=0;e<r;++e)t[e][o][1]/=i}sn(t,n)}},pn=function(t,n){if((a=t.length)>0)for(var e,r,i,o,u,a,c=0,s=t[n[0]].length;c<s;++c)for(o=u=0,e=0;e<a;++e)(i=(r=t[n[e]][c])[1]-r[0])>0?(r[0]=o,r[1]=o+=i):i<0?(r[1]=u,r[0]=u+=i):(r[0]=0,r[1]=i)},yn=function(t,n){if((e=t.length)>0){for(var e,r=0,i=t[n[0]],o=i.length;r<o;++r){for(var u=0,a=0;u<e;++u)a+=t[u][r][1]||0;i[r][1]+=i[r][0]=-a/2}sn(t,n)}},_n=function(t,n){if((i=t.length)>0&&(r=(e=t[n[0]]).length)>0){for(var e,r,i,o=0,u=1;u<r;++u){for(var a=0,c=0,s=0;a<i;++a){for(var l=t[n[a]],f=l[u][1]||0,h=(f-(l[u-1][1]||0))/2,d=0;d<a;++d){var p=t[n[d]];h+=(p[u][1]||0)-(p[u-1][1]||0)}c+=f,s+=h*f}e[u-1][1]+=e[u-1][0]=o,c&&(o-=s/c)}e[u-1][1]+=e[u-1][0]=o,sn(t,n)}},gn=function(t){var n=t.map(vn);return ln(t).sort((function(t,e){return n[t]-n[e]}))};function vn(t){for(var n,e=-1,r=0,i=t.length,o=-1/0;++e<i;)(n=+t[e][1])>o&&(o=n,r=e);return r}var mn=function(t){var n=t.map(bn);return ln(t).sort((function(t,e){return n[t]-n[e]}))};function bn(t){for(var n,e=0,r=-1,i=t.length;++r<i;)(n=+t[r][1])&&(e+=n);return e}var xn=function(t){return mn(t).reverse()},wn=function(t){var n,e,r=t.length,i=t.map(bn),o=gn(t),u=0,a=0,c=[],s=[];for(n=0;n<r;++n)e=o[n],u<a?(u+=i[e],c.push(e)):(a+=i[e],s.push(e));return s.reverse().concat(c)},Mn=function(t){return ln(t).reverse()};e.d(n,"arc",(function(){return S})),e.d(n,"area",(function(){return P})),e.d(n,"line",(function(){return F})),e.d(n,"pie",(function(){return U})),e.d(n,"areaRadial",(function(){return z})),e.d(n,"radialArea",(function(){return z})),e.d(n,"lineRadial",(function(){return Y})),e.d(n,"radialLine",(function(){return Y})),e.d(n,"pointRadial",(function(){return G})),e.d(n,"linkHorizontal",(function(){return K})),e.d(n,"linkVertical",(function(){return tt})),e.d(n,"linkRadial",(function(){return nt})),e.d(n,"symbol",(function(){return mt})),e.d(n,"symbols",(function(){return vt})),e.d(n,"symbolCircle",(function(){return et})),e.d(n,"symbolCross",(function(){return rt})),e.d(n,"symbolDiamond",(function(){return ut})),e.d(n,"symbolSquare",(function(){return ft})),e.d(n,"symbolStar",(function(){return lt})),e.d(n,"symbolTriangle",(function(){return dt})),e.d(n,"symbolWye",(function(){return gt})),e.d(n,"curveBasisClosed",(function(){return Ot})),e.d(n,"curveBasisOpen",(function(){return At})),e.d(n,"curveBasis",(function(){return Mt})),e.d(n,"curveBundle",(function(){return St})),e.d(n,"curveCardinalClosed",(function(){return Ft})),e.d(n,"curveCardinalOpen",(function(){return Lt})),e.d(n,"curveCardinal",(function(){return Et})),e.d(n,"curveCatmullRomClosed",(function(){return Ht})),e.d(n,"curveCatmullRomOpen",(function(){return Yt})),e.d(n,"curveCatmullRom",(function(){return Rt})),e.d(n,"curveLinearClosed",(function(){return Gt})),e.d(n,"curveLinear",(function(){return j})),e.d(n,"curveMonotoneX",(function(){return Kt})),e.d(n,"curveMonotoneY",(function(){return tn})),e.d(n,"curveNatural",(function(){return rn})),e.d(n,"curveStep",(function(){return un})),e.d(n,"curveStepAfter",(function(){return cn})),e.d(n,"curveStepBefore",(function(){return an})),e.d(n,"stack",(function(){return hn})),e.d(n,"stackOffsetExpand",(function(){return dn})),e.d(n,"stackOffsetDiverging",(function(){return pn})),e.d(n,"stackOffsetNone",(function(){return sn})),e.d(n,"stackOffsetSilhouette",(function(){return yn})),e.d(n,"stackOffsetWiggle",(function(){return _n})),e.d(n,"stackOrderAppearance",(function(){return gn})),e.d(n,"stackOrderAscending",(function(){return mn})),e.d(n,"stackOrderDescending",(function(){return xn})),e.d(n,"stackOrderInsideOut",(function(){return wn})),e.d(n,"stackOrderNone",(function(){return ln})),e.d(n,"stackOrderReverse",(function(){return Mn}))},function(t,n,e){"use strict";e.r(n);var r,i,o=e(9),u=e(69),a=0,c=0,s=0,l=0,f=0,h=0,d="object"==typeof performance&&performance.now?performance:Date,p="object"==typeof window&&window.requestAnimationFrame?window.requestAnimationFrame.bind(window):function(t){setTimeout(t,17)};function y(){return f||(p(_),f=d.now()+h)}function _(){f=0}function g(){this._call=this._time=this._next=null}function v(t,n,e){var r=new g;return r.restart(t,n,e),r}function m(){f=(l=d.now())+h,a=c=0;try{!function(){y(),++a;for(var t,n=r;n;)(t=f-n._time)>=0&&n._call.call(null,t),n=n._next;--a}()}finally{a=0,function(){var t,n,e=r,o=1/0;for(;e;)e._call?(o>e._time&&(o=e._time),t=e,e=e._next):(n=e._next,e._next=null,e=t?t._next=n:r=n);i=t,x(o)}(),f=0}}function b(){var t=d.now(),n=t-l;n>1e3&&(h-=n,l=t)}function x(t){a||(c&&(c=clearTimeout(c)),t-f>24?(t<1/0&&(c=setTimeout(m,t-d.now()-h)),s&&(s=clearInterval(s))):(s||(l=d.now(),s=setInterval(b,1e3)),a=1,p(m)))}g.prototype=v.prototype={constructor:g,restart:function(t,n,e){if("function"!=typeof t)throw new TypeError("callback is not a function");e=(null==e?y():+e)+(null==n?0:+n),this._next||i===this||(i?i._next=this:r=this,i=this),this._call=t,this._time=e,x()},stop:function(){this._call&&(this._call=null,this._time=1/0,x())}};var w=function(t,n,e){var r=new g;return n=null==n?0:+n,r.restart((function(e){r.stop(),t(e+n)}),n,e),r},M=Object(u.a)("start","end","cancel","interrupt"),T=[],O=function(t,n,e,r,i,o){var u=t.__transition;if(u){if(e in u)return}else t.__transition={};!function(t,n,e){var r,i=t.__transition;function o(c){var s,l,f,h;if(1!==e.state)return a();for(s in i)if((h=i[s]).name===e.name){if(3===h.state)return w(o);4===h.state?(h.state=6,h.timer.stop(),h.on.call("interrupt",t,t.__data__,h.index,h.group),delete i[s]):+s<n&&(h.state=6,h.timer.stop(),h.on.call("cancel",t,t.__data__,h.index,h.group),delete i[s])}if(w((function(){3===e.state&&(e.state=4,e.timer.restart(u,e.delay,e.time),u(c))})),e.state=2,e.on.call("start",t,t.__data__,e.index,e.group),2===e.state){for(e.state=3,r=new Array(f=e.tween.length),s=0,l=-1;s<f;++s)(h=e.tween[s].value.call(t,t.__data__,e.index,e.group))&&(r[++l]=h);r.length=l+1}}function u(n){for(var i=n<e.duration?e.ease.call(null,n/e.duration):(e.timer.restart(a),e.state=5,1),o=-1,u=r.length;++o<u;)r[o].call(t,i);5===e.state&&(e.on.call("end",t,t.__data__,e.index,e.group),a())}function a(){for(var r in e.state=6,e.timer.stop(),delete i[n],i)return;delete t.__transition}i[n]=e,e.timer=v((function(t){e.state=1,e.timer.restart(o,e.delay,e.time),e.delay<=t&&o(t-e.delay)}),0,e.time)}(t,e,{name:n,index:r,group:i,on:M,tween:T,time:o.time,delay:o.delay,duration:o.duration,ease:o.ease,timer:null,state:0})};function k(t,n){var e=C(t,n);if(e.state>0)throw new Error("too late; already scheduled");return e}function A(t,n){var e=C(t,n);if(e.state>3)throw new Error("too late; already running");return e}function C(t,n){var e=t.__transition;if(!e||!(e=e[n]))throw new Error("transition not found");return e}var S=function(t,n){var e,r,i,o=t.__transition,u=!0;if(o){for(i in n=null==n?null:n+"",o)(e=o[i]).name===n?(r=e.state>2&&e.state<5,e.state=6,e.timer.stop(),e.on.call(r?"interrupt":"cancel",t,t.__data__,e.index,e.group),delete o[i]):u=!1;u&&delete t.__transition}},N=e(74),j=e(20);function E(t,n){var e,r;return function(){var i=A(this,t),o=i.tween;if(o!==e)for(var u=0,a=(r=e=o).length;u<a;++u)if(r[u].name===n){(r=r.slice()).splice(u,1);break}i.tween=r}}function D(t,n,e){var r,i;if("function"!=typeof e)throw new Error;return function(){var o=A(this,t),u=o.tween;if(u!==r){i=(r=u).slice();for(var a={name:n,value:e},c=0,s=i.length;c<s;++c)if(i[c].name===n){i[c]=a;break}c===s&&i.push(a)}o.tween=i}}function F(t,n,e){var r=t._id;return t.each((function(){var t=A(this,r);(t.value||(t.value={}))[n]=e.apply(this,arguments)})),function(t){return C(t,r).value[n]}}var P=e(7),L=e(5),I=e(39),U=e(55),R=function(t,n){var e;return("number"==typeof n?L.a:n instanceof P.e?I.a:(e=Object(P.e)(n))?(n=e,I.a):U.a)(t,n)};function B(t){return function(){this.removeAttribute(t)}}function H(t){return function(){this.removeAttributeNS(t.space,t.local)}}function q(t,n,e){var r,i,o=e+"";return function(){var u=this.getAttribute(t);return u===o?null:u===r?i:i=n(r=u,e)}}function Y(t,n,e){var r,i,o=e+"";return function(){var u=this.getAttributeNS(t.space,t.local);return u===o?null:u===r?i:i=n(r=u,e)}}function z(t,n,e){var r,i,o;return function(){var u,a,c=e(this);if(null!=c)return(u=this.getAttribute(t))===(a=c+"")?null:u===r&&a===i?o:(i=a,o=n(r=u,c));this.removeAttribute(t)}}function G(t,n,e){var r,i,o;return function(){var u,a,c=e(this);if(null!=c)return(u=this.getAttributeNS(t.space,t.local))===(a=c+"")?null:u===r&&a===i?o:(i=a,o=n(r=u,c));this.removeAttributeNS(t.space,t.local)}}function V(t,n){return function(e){this.setAttribute(t,n.call(this,e))}}function X(t,n){return function(e){this.setAttributeNS(t.space,t.local,n.call(this,e))}}function W(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&X(t,i)),e}return i._value=n,i}function $(t,n){var e,r;function i(){var i=n.apply(this,arguments);return i!==r&&(e=(r=i)&&V(t,i)),e}return i._value=n,i}function Q(t,n){return function(){k(this,t).delay=+n.apply(this,arguments)}}function Z(t,n){return n=+n,function(){k(this,t).delay=n}}function J(t,n){return function(){A(this,t).duration=+n.apply(this,arguments)}}function K(t,n){return n=+n,function(){A(this,t).duration=n}}function tt(t,n){if("function"!=typeof n)throw new Error;return function(){A(this,t).ease=n}}var nt=e(34);function et(t,n,e){var r,i,o=function(t){return(t+"").trim().split(/^|\s+/).every((function(t){var n=t.indexOf(".");return n>=0&&(t=t.slice(0,n)),!t||"start"===t}))}(n)?k:A;return function(){var u=o(this,t),a=u.on;a!==r&&(i=(r=a).copy()).on(n,e),u.on=i}}var rt=e(19),it=e(33),ot=o.b.prototype.constructor,ut=e(35);function at(t){return function(){this.style.removeProperty(t)}}function ct(t,n,e){return function(r){this.style.setProperty(t,n.call(this,r),e)}}function st(t,n,e){var r,i;function o(){var o=n.apply(this,arguments);return o!==i&&(r=(i=o)&&ct(t,o,e)),r}return o._value=n,o}function lt(t){return function(n){this.textContent=t.call(this,n)}}function ft(t){var n,e;function r(){var r=t.apply(this,arguments);return r!==e&&(n=(e=r)&&lt(r)),n}return r._value=t,r}var ht=0;function dt(t,n,e,r){this._groups=t,this._parents=n,this._name=e,this._id=r}function pt(t){return Object(o.b)().transition(t)}function yt(){return++ht}var _t=o.b.prototype;dt.prototype=pt.prototype={constructor:dt,select:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(rt.a)(t));for(var r=this._groups,i=r.length,o=new Array(i),u=0;u<i;++u)for(var a,c,s=r[u],l=s.length,f=o[u]=new Array(l),h=0;h<l;++h)(a=s[h])&&(c=t.call(a,a.__data__,h,s))&&("__data__"in a&&(c.__data__=a.__data__),f[h]=c,O(f[h],n,e,h,f,C(a,e)));return new dt(o,this._parents,n,e)},selectAll:function(t){var n=this._name,e=this._id;"function"!=typeof t&&(t=Object(it.a)(t));for(var r=this._groups,i=r.length,o=[],u=[],a=0;a<i;++a)for(var c,s=r[a],l=s.length,f=0;f<l;++f)if(c=s[f]){for(var h,d=t.call(c,c.__data__,f,s),p=C(c,e),y=0,_=d.length;y<_;++y)(h=d[y])&&O(h,n,e,y,d,p);o.push(d),u.push(c)}return new dt(o,u,n,e)},filter:function(t){"function"!=typeof t&&(t=Object(nt.a)(t));for(var n=this._groups,e=n.length,r=new Array(e),i=0;i<e;++i)for(var o,u=n[i],a=u.length,c=r[i]=[],s=0;s<a;++s)(o=u[s])&&t.call(o,o.__data__,s,u)&&c.push(o);return new dt(r,this._parents,this._name,this._id)},merge:function(t){if(t._id!==this._id)throw new Error;for(var n=this._groups,e=t._groups,r=n.length,i=e.length,o=Math.min(r,i),u=new Array(r),a=0;a<o;++a)for(var c,s=n[a],l=e[a],f=s.length,h=u[a]=new Array(f),d=0;d<f;++d)(c=s[d]||l[d])&&(h[d]=c);for(;a<r;++a)u[a]=n[a];return new dt(u,this._parents,this._name,this._id)},selection:function(){return new ot(this._groups,this._parents)},transition:function(){for(var t=this._name,n=this._id,e=yt(),r=this._groups,i=r.length,o=0;o<i;++o)for(var u,a=r[o],c=a.length,s=0;s<c;++s)if(u=a[s]){var l=C(u,n);O(u,t,e,s,a,{time:l.time+l.delay+l.duration,delay:0,duration:l.duration,ease:l.ease})}return new dt(r,this._parents,t,e)},call:_t.call,nodes:_t.nodes,node:_t.node,size:_t.size,empty:_t.empty,each:_t.each,on:function(t,n){var e=this._id;return arguments.length<2?C(this.node(),e).on.on(t):this.each(et(e,t,n))},attr:function(t,n){var e=Object(j.a)(t),r="transform"===e?N.b:R;return this.attrTween(t,"function"==typeof n?(e.local?G:z)(e,r,F(this,"attr."+t,n)):null==n?(e.local?H:B)(e):(e.local?Y:q)(e,r,n))},attrTween:function(t,n){var e="attr."+t;if(arguments.length<2)return(e=this.tween(e))&&e._value;if(null==n)return this.tween(e,null);if("function"!=typeof n)throw new Error;var r=Object(j.a)(t);return this.tween(e,(r.local?W:$)(r,n))},style:function(t,n,e){var r="transform"==(t+="")?N.a:R;return null==n?this.styleTween(t,function(t,n){var e,r,i;return function(){var o=Object(ut.b)(this,t),u=(this.style.removeProperty(t),Object(ut.b)(this,t));return o===u?null:o===e&&u===r?i:i=n(e=o,r=u)}}(t,r)).on("end.style."+t,at(t)):"function"==typeof n?this.styleTween(t,function(t,n,e){var r,i,o;return function(){var u=Object(ut.b)(this,t),a=e(this),c=a+"";return null==a&&(this.style.removeProperty(t),c=a=Object(ut.b)(this,t)),u===c?null:u===r&&c===i?o:(i=c,o=n(r=u,a))}}(t,r,F(this,"style."+t,n))).each(function(t,n){var e,r,i,o,u="style."+n,a="end."+u;return function(){var c=A(this,t),s=c.on,l=null==c.value[u]?o||(o=at(n)):void 0;s===e&&i===l||(r=(e=s).copy()).on(a,i=l),c.on=r}}(this._id,t)):this.styleTween(t,function(t,n,e){var r,i,o=e+"";return function(){var u=Object(ut.b)(this,t);return u===o?null:u===r?i:i=n(r=u,e)}}(t,r,n),e).on("end.style."+t,null)},styleTween:function(t,n,e){var r="style."+(t+="");if(arguments.length<2)return(r=this.tween(r))&&r._value;if(null==n)return this.tween(r,null);if("function"!=typeof n)throw new Error;return this.tween(r,st(t,n,null==e?"":e))},text:function(t){return this.tween("text","function"==typeof t?function(t){return function(){var n=t(this);this.textContent=null==n?"":n}}(F(this,"text",t)):function(t){return function(){this.textContent=t}}(null==t?"":t+""))},textTween:function(t){var n="text";if(arguments.length<1)return(n=this.tween(n))&&n._value;if(null==t)return this.tween(n,null);if("function"!=typeof t)throw new Error;return this.tween(n,ft(t))},remove:function(){return this.on("end.remove",(t=this._id,function(){var n=this.parentNode;for(var e in this.__transition)if(+e!==t)return;n&&n.removeChild(this)}));var t},tween:function(t,n){var e=this._id;if(t+="",arguments.length<2){for(var r,i=C(this.node(),e).tween,o=0,u=i.length;o<u;++o)if((r=i[o]).name===t)return r.value;return null}return this.each((null==n?E:D)(e,t,n))},delay:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?Q:Z)(n,t)):C(this.node(),n).delay},duration:function(t){var n=this._id;return arguments.length?this.each(("function"==typeof t?J:K)(n,t)):C(this.node(),n).duration},ease:function(t){var n=this._id;return arguments.length?this.each(tt(n,t)):C(this.node(),n).ease},end:function(){var t,n,e=this,r=e._id,i=e.size();return new Promise((function(o,u){var a={value:u},c={value:function(){0==--i&&o()}};e.each((function(){var e=A(this,r),i=e.on;i!==t&&((n=(t=i).copy())._.cancel.push(a),n._.interrupt.push(a),n._.end.push(c)),e.on=n}))}))}};var gt={time:null,delay:0,duration:250,ease:e(29).b};function vt(t,n){for(var e;!(e=t.__transition)||!(e=e[n]);)if(!(t=t.parentNode))return gt.time=y(),gt;return e}o.b.prototype.interrupt=function(t){return this.each((function(){S(this,t)}))},o.b.prototype.transition=function(t){var n,e;t instanceof dt?(n=t._id,t=t._name):(n=yt(),(e=gt).time=y(),t=null==t?null:t+"");for(var r=this._groups,i=r.length,o=0;o<i;++o)for(var u,a=r[o],c=a.length,s=0;s<c;++s)(u=a[s])&&O(u,t,n,s,a,e||vt(u,n));return new dt(r,this._parents,t,n)};var mt=[null],bt=function(t,n){var e,r,i=t.__transition;if(i)for(r in n=null==n?null:n+"",i)if((e=i[r]).state>1&&e.name===n)return new dt([[t]],mt,n,+r);return null};e.d(n,"transition",(function(){return pt})),e.d(n,"active",(function(){return bt})),e.d(n,"interrupt",(function(){return S}))},,function(t,n,e){"use strict";var r,i,o,u,a=e(5),c=180/Math.PI,s={translateX:0,translateY:0,rotate:0,skewX:0,scaleX:1,scaleY:1},l=function(t,n,e,r,i,o){var u,a,s;return(u=Math.sqrt(t*t+n*n))&&(t/=u,n/=u),(s=t*e+n*r)&&(e-=t*s,r-=n*s),(a=Math.sqrt(e*e+r*r))&&(e/=a,r/=a,s/=a),t*r<n*e&&(t=-t,n=-n,s=-s,u=-u),{translateX:i,translateY:o,rotate:Math.atan2(n,t)*c,skewX:Math.atan(s)*c,scaleX:u,scaleY:a}};function f(t,n,e,r){function i(t){return t.length?t.pop()+" ":""}return function(o,u){var c=[],s=[];return o=t(o),u=t(u),function(t,r,i,o,u,c){if(t!==i||r!==o){var s=u.push("translate(",null,n,null,e);c.push({i:s-4,x:Object(a.a)(t,i)},{i:s-2,x:Object(a.a)(r,o)})}else(i||o)&&u.push("translate("+i+n+o+e)}(o.translateX,o.translateY,u.translateX,u.translateY,c,s),function(t,n,e,o){t!==n?(t-n>180?n+=360:n-t>180&&(t+=360),o.push({i:e.push(i(e)+"rotate(",null,r)-2,x:Object(a.a)(t,n)})):n&&e.push(i(e)+"rotate("+n+r)}(o.rotate,u.rotate,c,s),function(t,n,e,o){t!==n?o.push({i:e.push(i(e)+"skewX(",null,r)-2,x:Object(a.a)(t,n)}):n&&e.push(i(e)+"skewX("+n+r)}(o.skewX,u.skewX,c,s),function(t,n,e,r,o,u){if(t!==e||n!==r){var c=o.push(i(o)+"scale(",null,",",null,")");u.push({i:c-4,x:Object(a.a)(t,e)},{i:c-2,x:Object(a.a)(n,r)})}else 1===e&&1===r||o.push(i(o)+"scale("+e+","+r+")")}(o.scaleX,o.scaleY,u.scaleX,u.scaleY,c,s),o=u=null,function(t){for(var n,e=-1,r=s.length;++e<r;)c[(n=s[e]).i]=n.x(t);return c.join("")}}}e.d(n,"a",(function(){return h})),e.d(n,"b",(function(){return d}));var h=f((function(t){return"none"===t?s:(r||(r=document.createElement("DIV"),i=document.documentElement,o=document.defaultView),r.style.transform=t,t=o.getComputedStyle(i.appendChild(r),null).getPropertyValue("transform"),i.removeChild(r),t=t.slice(7,-1).split(","),l(+t[0],+t[1],+t[2],+t[3],+t[4],+t[5]))}),"px, ","px)","deg)"),d=f((function(t){return null==t?s:(u||(u=document.createElementNS("http://www.w3.org/2000/svg","g")),u.setAttribute("transform",t),(t=u.transform.baseVal.consolidate())?(t=t.matrix,l(t.a,t.b,t.c,t.d,t.e,t.f)):s)}),", ",")",")")},function(t,n,e){"use strict";e.r(n);var r=e(2);function i(t,n){switch(arguments.length){case 0:break;case 1:this.range(t);break;default:this.range(n).domain(t)}return this}function o(t,n){switch(arguments.length){case 0:break;case 1:this.interpolator(t);break;default:this.interpolator(n).domain(t)}return this}var u=e(45),a=Array.prototype,c=a.map,s=a.slice,l={name:"implicit"};function f(){var t=Object(u.map)(),n=[],e=[],r=l;function o(i){var o=i+"",u=t.get(o);if(!u){if(r!==l)return r;t.set(o,u=n.push(i))}return e[(u-1)%e.length]}return o.domain=function(e){if(!arguments.length)return n.slice();n=[],t=Object(u.map)();for(var r,i,a=-1,c=e.length;++a<c;)t.has(i=(r=e[a])+"")||t.set(i,n.push(r));return o},o.range=function(t){return arguments.length?(e=s.call(t),o):e.slice()},o.unknown=function(t){return arguments.length?(r=t,o):r},o.copy=function(){return f(n,e).unknown(r)},i.apply(o,arguments),o}function h(){var t,n,e=f().unknown(void 0),o=e.domain,u=e.range,a=[0,1],c=!1,s=0,l=0,d=.5;function p(){var e=o().length,i=a[1]<a[0],f=a[i-0],h=a[1-i];t=(h-f)/Math.max(1,e-s+2*l),c&&(t=Math.floor(t)),f+=(h-f-t*(e-s))*d,n=t*(1-s),c&&(f=Math.round(f),n=Math.round(n));var p=Object(r.range)(e).map((function(n){return f+t*n}));return u(i?p.reverse():p)}return delete e.unknown,e.domain=function(t){return arguments.length?(o(t),p()):o()},e.range=function(t){return arguments.length?(a=[+t[0],+t[1]],p()):a.slice()},e.rangeRound=function(t){return a=[+t[0],+t[1]],c=!0,p()},e.bandwidth=function(){return n},e.step=function(){return t},e.round=function(t){return arguments.length?(c=!!t,p()):c},e.padding=function(t){return arguments.length?(s=Math.min(1,l=+t),p()):s},e.paddingInner=function(t){return arguments.length?(s=Math.min(1,t),p()):s},e.paddingOuter=function(t){return arguments.length?(l=+t,p()):l},e.align=function(t){return arguments.length?(d=Math.max(0,Math.min(1,t)),p()):d},e.copy=function(){return h(o(),a).round(c).paddingInner(s).paddingOuter(l).align(d)},i.apply(p(),arguments)}function d(t){var n=t.copy;return t.padding=t.paddingOuter,delete t.paddingInner,delete t.paddingOuter,t.copy=function(){return d(n())},t}function p(){return d(h.apply(null,arguments).paddingInner(1))}var y=e(36),_=e(5),g=e(81),v=function(t){return+t},m=[0,1];function b(t){return t}function x(t,n){return(n-=t=+t)?function(e){return(e-t)/n}:(e=isNaN(n)?NaN:.5,function(){return e});var e}function w(t){var n,e=t[0],r=t[t.length-1];return e>r&&(n=e,e=r,r=n),function(t){return Math.max(e,Math.min(r,t))}}function M(t,n,e){var r=t[0],i=t[1],o=n[0],u=n[1];return i<r?(r=x(i,r),o=e(u,o)):(r=x(r,i),o=e(o,u)),function(t){return o(r(t))}}function T(t,n,e){var i=Math.min(t.length,n.length)-1,o=new Array(i),u=new Array(i),a=-1;for(t[i]<t[0]&&(t=t.slice().reverse(),n=n.slice().reverse());++a<i;)o[a]=x(t[a],t[a+1]),u[a]=e(n[a],n[a+1]);return function(n){var e=Object(r.bisect)(t,n,1,i)-1;return u[e](o[e](n))}}function O(t,n){return n.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown())}function k(){var t,n,e,r,i,o,u=m,a=m,l=y.a,f=b;function h(){return r=Math.min(u.length,a.length)>2?T:M,i=o=null,d}function d(n){return isNaN(n=+n)?e:(i||(i=r(u.map(t),a,l)))(t(f(n)))}return d.invert=function(e){return f(n((o||(o=r(a,u.map(t),_.a)))(e)))},d.domain=function(t){return arguments.length?(u=c.call(t,v),f===b||(f=w(u)),h()):u.slice()},d.range=function(t){return arguments.length?(a=s.call(t),h()):a.slice()},d.rangeRound=function(t){return a=s.call(t),l=g.a,h()},d.clamp=function(t){return arguments.length?(f=t?w(u):b,d):f!==b},d.interpolate=function(t){return arguments.length?(l=t,h()):l},d.unknown=function(t){return arguments.length?(e=t,d):e},function(e,r){return t=e,n=r,h()}}function A(t,n){return k()(t,n)}var C=e(24),S=e(62),N=e(40),j=e(63),E=e(61),D=function(t,n,e,i){var o,u=Object(r.tickStep)(t,n,e);switch((i=Object(C.b)(null==i?",f":i)).type){case"s":var a=Math.max(Math.abs(t),Math.abs(n));return null!=i.precision||isNaN(o=Object(S.a)(u,a))||(i.precision=o),Object(N.c)(i,a);case"":case"e":case"g":case"p":case"r":null!=i.precision||isNaN(o=Object(j.a)(u,Math.max(Math.abs(t),Math.abs(n))))||(i.precision=o-("e"===i.type));break;case"f":case"%":null!=i.precision||isNaN(o=Object(E.a)(u))||(i.precision=o-2*("%"===i.type))}return Object(N.b)(i)};function F(t){var n=t.domain;return t.ticks=function(t){var e=n();return Object(r.ticks)(e[0],e[e.length-1],null==t?10:t)},t.tickFormat=function(t,e){var r=n();return D(r[0],r[r.length-1],null==t?10:t,e)},t.nice=function(e){null==e&&(e=10);var i,o=n(),u=0,a=o.length-1,c=o[u],s=o[a];return s<c&&(i=c,c=s,s=i,i=u,u=a,a=i),(i=Object(r.tickIncrement)(c,s,e))>0?(c=Math.floor(c/i)*i,s=Math.ceil(s/i)*i,i=Object(r.tickIncrement)(c,s,e)):i<0&&(c=Math.ceil(c*i)/i,s=Math.floor(s*i)/i,i=Object(r.tickIncrement)(c,s,e)),i>0?(o[u]=Math.floor(c/i)*i,o[a]=Math.ceil(s/i)*i,n(o)):i<0&&(o[u]=Math.ceil(c*i)/i,o[a]=Math.floor(s*i)/i,n(o)),t},t}function P(){var t=A(b,b);return t.copy=function(){return O(t,P())},i.apply(t,arguments),F(t)}function L(t){var n;function e(t){return isNaN(t=+t)?n:t}return e.invert=e,e.domain=e.range=function(n){return arguments.length?(t=c.call(n,v),e):t.slice()},e.unknown=function(t){return arguments.length?(n=t,e):n},e.copy=function(){return L(t).unknown(n)},t=arguments.length?c.call(t,v):[0,1],F(e)}var I=function(t,n){var e,r=0,i=(t=t.slice()).length-1,o=t[r],u=t[i];return u<o&&(e=r,r=i,i=e,e=o,o=u,u=e),t[r]=n.floor(o),t[i]=n.ceil(u),t};function U(t){return Math.log(t)}function R(t){return Math.exp(t)}function B(t){return-Math.log(-t)}function H(t){return-Math.exp(-t)}function q(t){return isFinite(t)?+("1e"+t):t<0?0:t}function Y(t){return function(n){return-t(-n)}}function z(t){var n,e,i=t(U,R),o=i.domain,u=10;function a(){return n=function(t){return t===Math.E?Math.log:10===t&&Math.log10||2===t&&Math.log2||(t=Math.log(t),function(n){return Math.log(n)/t})}(u),e=function(t){return 10===t?q:t===Math.E?Math.exp:function(n){return Math.pow(t,n)}}(u),o()[0]<0?(n=Y(n),e=Y(e),t(B,H)):t(U,R),i}return i.base=function(t){return arguments.length?(u=+t,a()):u},i.domain=function(t){return arguments.length?(o(t),a()):o()},i.ticks=function(t){var i,a=o(),c=a[0],s=a[a.length-1];(i=s<c)&&(d=c,c=s,s=d);var l,f,h,d=n(c),p=n(s),y=null==t?10:+t,_=[];if(!(u%1)&&p-d<y){if(d=Math.round(d)-1,p=Math.round(p)+1,c>0){for(;d<p;++d)for(f=1,l=e(d);f<u;++f)if(!((h=l*f)<c)){if(h>s)break;_.push(h)}}else for(;d<p;++d)for(f=u-1,l=e(d);f>=1;--f)if(!((h=l*f)<c)){if(h>s)break;_.push(h)}}else _=Object(r.ticks)(d,p,Math.min(p-d,y)).map(e);return i?_.reverse():_},i.tickFormat=function(t,r){if(null==r&&(r=10===u?".0e":","),"function"!=typeof r&&(r=Object(N.b)(r)),t===1/0)return r;null==t&&(t=10);var o=Math.max(1,u*t/i.ticks().length);return function(t){var i=t/e(Math.round(n(t)));return i*u<u-.5&&(i*=u),i<=o?r(t):""}},i.nice=function(){return o(I(o(),{floor:function(t){return e(Math.floor(n(t)))},ceil:function(t){return e(Math.ceil(n(t)))}}))},i}function G(){var t=z(k()).domain([1,10]);return t.copy=function(){return O(t,G()).base(t.base())},i.apply(t,arguments),t}function V(t){return function(n){return Math.sign(n)*Math.log1p(Math.abs(n/t))}}function X(t){return function(n){return Math.sign(n)*Math.expm1(Math.abs(n))*t}}function W(t){var n=1,e=t(V(n),X(n));return e.constant=function(e){return arguments.length?t(V(n=+e),X(n)):n},F(e)}function $(){var t=W(k());return t.copy=function(){return O(t,$()).constant(t.constant())},i.apply(t,arguments)}function Q(t){return function(n){return n<0?-Math.pow(-n,t):Math.pow(n,t)}}function Z(t){return t<0?-Math.sqrt(-t):Math.sqrt(t)}function J(t){return t<0?-t*t:t*t}function K(t){var n=t(b,b),e=1;function r(){return 1===e?t(b,b):.5===e?t(Z,J):t(Q(e),Q(1/e))}return n.exponent=function(t){return arguments.length?(e=+t,r()):e},F(n)}function tt(){var t=K(k());return t.copy=function(){return O(t,tt()).exponent(t.exponent())},i.apply(t,arguments),t}function nt(){return tt.apply(null,arguments).exponent(.5)}function et(){var t,n=[],e=[],o=[];function u(){var t=0,i=Math.max(1,e.length);for(o=new Array(i-1);++t<i;)o[t-1]=Object(r.quantile)(n,t/i);return a}function a(n){return isNaN(n=+n)?t:e[Object(r.bisect)(o,n)]}return a.invertExtent=function(t){var r=e.indexOf(t);return r<0?[NaN,NaN]:[r>0?o[r-1]:n[0],r<o.length?o[r]:n[n.length-1]]},a.domain=function(t){if(!arguments.length)return n.slice();n=[];for(var e,i=0,o=t.length;i<o;++i)null==(e=t[i])||isNaN(e=+e)||n.push(e);return n.sort(r.ascending),u()},a.range=function(t){return arguments.length?(e=s.call(t),u()):e.slice()},a.unknown=function(n){return arguments.length?(t=n,a):t},a.quantiles=function(){return o.slice()},a.copy=function(){return et().domain(n).range(e).unknown(t)},i.apply(a,arguments)}function rt(){var t,n=0,e=1,o=1,u=[.5],a=[0,1];function c(n){return n<=n?a[Object(r.bisect)(u,n,0,o)]:t}function l(){var t=-1;for(u=new Array(o);++t<o;)u[t]=((t+1)*e-(t-o)*n)/(o+1);return c}return c.domain=function(t){return arguments.length?(n=+t[0],e=+t[1],l()):[n,e]},c.range=function(t){return arguments.length?(o=(a=s.call(t)).length-1,l()):a.slice()},c.invertExtent=function(t){var r=a.indexOf(t);return r<0?[NaN,NaN]:r<1?[n,u[0]]:r>=o?[u[o-1],e]:[u[r-1],u[r]]},c.unknown=function(n){return arguments.length?(t=n,c):c},c.thresholds=function(){return u.slice()},c.copy=function(){return rt().domain([n,e]).range(a).unknown(t)},i.apply(F(c),arguments)}function it(){var t,n=[.5],e=[0,1],o=1;function u(i){return i<=i?e[Object(r.bisect)(n,i,0,o)]:t}return u.domain=function(t){return arguments.length?(n=s.call(t),o=Math.min(n.length,e.length-1),u):n.slice()},u.range=function(t){return arguments.length?(e=s.call(t),o=Math.min(n.length,e.length-1),u):e.slice()},u.invertExtent=function(t){var r=e.indexOf(t);return[n[r-1],n[r]]},u.unknown=function(n){return arguments.length?(t=n,u):t},u.copy=function(){return it().domain(n).range(e).unknown(t)},i.apply(u,arguments)}var ot=e(15),ut=e(47),at=e(3),ct=e(27),st=e(48),lt=e(49),ft=e(30),ht=e(31),dt=e(46);function pt(t){return new Date(t)}function yt(t){return t instanceof Date?+t:+new Date(+t)}function _t(t,n,e,i,o,u,a,s,l){var f=A(b,b),h=f.invert,d=f.domain,p=l(".%L"),y=l(":%S"),_=l("%I:%M"),g=l("%I %p"),v=l("%a %d"),m=l("%b %d"),x=l("%B"),w=l("%Y"),M=[[a,1,1e3],[a,5,5e3],[a,15,15e3],[a,30,3e4],[u,1,6e4],[u,5,3e5],[u,15,9e5],[u,30,18e5],[o,1,36e5],[o,3,108e5],[o,6,216e5],[o,12,432e5],[i,1,864e5],[i,2,1728e5],[e,1,6048e5],[n,1,2592e6],[n,3,7776e6],[t,1,31536e6]];function T(r){return(a(r)<r?p:u(r)<r?y:o(r)<r?_:i(r)<r?g:n(r)<r?e(r)<r?v:m:t(r)<r?x:w)(r)}function k(n,e,i,o){if(null==n&&(n=10),"number"==typeof n){var u=Math.abs(i-e)/n,a=Object(r.bisector)((function(t){return t[2]})).right(M,u);a===M.length?(o=Object(r.tickStep)(e/31536e6,i/31536e6,n),n=t):a?(o=(a=M[u/M[a-1][2]<M[a][2]/u?a-1:a])[1],n=a[0]):(o=Math.max(Object(r.tickStep)(e,i,n),1),n=s)}return null==o?n:n.every(o)}return f.invert=function(t){return new Date(h(t))},f.domain=function(t){return arguments.length?d(c.call(t,yt)):d().map(pt)},f.ticks=function(t,n){var e,r=d(),i=r[0],o=r[r.length-1],u=o<i;return u&&(e=i,i=o,o=e),e=(e=k(t,i,o,n))?e.range(i,o+1):[],u?e.reverse():e},f.tickFormat=function(t,n){return null==n?T:l(n)},f.nice=function(t,n){var e=d();return(t=k(t,e[0],e[e.length-1],n))?d(I(e,t)):f},f.copy=function(){return O(f,_t(t,n,e,i,o,u,a,s,l))},f}var gt=function(){return i.apply(_t(ot.a,ut.a,at.g,ct.b,st.a,lt.a,ft.a,ht.a,dt.b).domain([new Date(2e3,0,1),new Date(2e3,0,2)]),arguments)},vt=e(16),mt=e(50),bt=e(4),xt=e(28),wt=e(51),Mt=e(52),Tt=function(){return i.apply(_t(vt.a,mt.a,bt.g,xt.a,wt.a,Mt.a,ft.a,ht.a,dt.d).domain([Date.UTC(2e3,0,1),Date.UTC(2e3,0,2)]),arguments)};function Ot(){var t,n,e,r,i,o=0,u=1,a=b,c=!1;function s(n){return isNaN(n=+n)?i:a(0===e?.5:(n=(r(n)-t)*e,c?Math.max(0,Math.min(1,n)):n))}return s.domain=function(i){return arguments.length?(t=r(o=+i[0]),n=r(u=+i[1]),e=t===n?0:1/(n-t),s):[o,u]},s.clamp=function(t){return arguments.length?(c=!!t,s):c},s.interpolator=function(t){return arguments.length?(a=t,s):a},s.unknown=function(t){return arguments.length?(i=t,s):i},function(i){return r=i,t=i(o),n=i(u),e=t===n?0:1/(n-t),s}}function kt(t,n){return n.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown())}function At(){var t=F(Ot()(b));return t.copy=function(){return kt(t,At())},o.apply(t,arguments)}function Ct(){var t=z(Ot()).domain([1,10]);return t.copy=function(){return kt(t,Ct()).base(t.base())},o.apply(t,arguments)}function St(){var t=W(Ot());return t.copy=function(){return kt(t,St()).constant(t.constant())},o.apply(t,arguments)}function Nt(){var t=K(Ot());return t.copy=function(){return kt(t,Nt()).exponent(t.exponent())},o.apply(t,arguments)}function jt(){return Nt.apply(null,arguments).exponent(.5)}function Et(){var t=[],n=b;function e(e){if(!isNaN(e=+e))return n((Object(r.bisect)(t,e)-1)/(t.length-1))}return e.domain=function(n){if(!arguments.length)return t.slice();t=[];for(var i,o=0,u=n.length;o<u;++o)null==(i=n[o])||isNaN(i=+i)||t.push(i);return t.sort(r.ascending),e},e.interpolator=function(t){return arguments.length?(n=t,e):n},e.copy=function(){return Et(n).domain(t)},o.apply(e,arguments)}function Dt(){var t,n,e,r,i,o,u,a=0,c=.5,s=1,l=b,f=!1;function h(t){return isNaN(t=+t)?u:(t=.5+((t=+o(t))-n)*(t<n?r:i),l(f?Math.max(0,Math.min(1,t)):t))}return h.domain=function(u){return arguments.length?(t=o(a=+u[0]),n=o(c=+u[1]),e=o(s=+u[2]),r=t===n?0:.5/(n-t),i=n===e?0:.5/(e-n),h):[a,c,s]},h.clamp=function(t){return arguments.length?(f=!!t,h):f},h.interpolator=function(t){return arguments.length?(l=t,h):l},h.unknown=function(t){return arguments.length?(u=t,h):u},function(u){return o=u,t=u(a),n=u(c),e=u(s),r=t===n?0:.5/(n-t),i=n===e?0:.5/(e-n),h}}function Ft(){var t=F(Dt()(b));return t.copy=function(){return kt(t,Ft())},o.apply(t,arguments)}function Pt(){var t=z(Dt()).domain([.1,1,10]);return t.copy=function(){return kt(t,Pt()).base(t.base())},o.apply(t,arguments)}function Lt(){var t=W(Dt());return t.copy=function(){return kt(t,Lt()).constant(t.constant())},o.apply(t,arguments)}function It(){var t=K(Dt());return t.copy=function(){return kt(t,It()).exponent(t.exponent())},o.apply(t,arguments)}function Ut(){return It.apply(null,arguments).exponent(.5)}e.d(n,"scaleBand",(function(){return h})),e.d(n,"scalePoint",(function(){return p})),e.d(n,"scaleIdentity",(function(){return L})),e.d(n,"scaleLinear",(function(){return P})),e.d(n,"scaleLog",(function(){return G})),e.d(n,"scaleSymlog",(function(){return $})),e.d(n,"scaleOrdinal",(function(){return f})),e.d(n,"scaleImplicit",(function(){return l})),e.d(n,"scalePow",(function(){return tt})),e.d(n,"scaleSqrt",(function(){return nt})),e.d(n,"scaleQuantile",(function(){return et})),e.d(n,"scaleQuantize",(function(){return rt})),e.d(n,"scaleThreshold",(function(){return it})),e.d(n,"scaleTime",(function(){return gt})),e.d(n,"scaleUtc",(function(){return Tt})),e.d(n,"scaleSequential",(function(){return At})),e.d(n,"scaleSequentialLog",(function(){return Ct})),e.d(n,"scaleSequentialPow",(function(){return Nt})),e.d(n,"scaleSequentialSqrt",(function(){return jt})),e.d(n,"scaleSequentialSymlog",(function(){return St})),e.d(n,"scaleSequentialQuantile",(function(){return Et})),e.d(n,"scaleDiverging",(function(){return Ft})),e.d(n,"scaleDivergingLog",(function(){return Pt})),e.d(n,"scaleDivergingPow",(function(){return It})),e.d(n,"scaleDivergingSqrt",(function(){return Ut})),e.d(n,"scaleDivergingSymlog",(function(){return Lt})),e.d(n,"tickFormat",(function(){return D}))},function(t,n,e){"use strict";var r;void 0===(r=function(t){var n=e(65).colorSchemas,r=(e(70),e(77)),i="undefined"!=typeof window,o=navigator.msSaveOrOpenBlob,u=i&&window.btoa;u||(u=e(78).encode);var a={styleClass:"britechartStyle",defaultFilename:"britechart.png",chartBackground:"white",imageSourceBase:"data:image/svg+xml;base64,",titleFontSize:"15px",titleFontFamily:"'Benton Sans', sans-serif",titleTopOffset:15,get styleBackgroundString(){return"<style>svg{background:"+this.chartBackground+";}</style>"}};function c(t,n){if(t){t.attr("version",1.1).attr("xmlns","http://www.w3.org/2000/svg");var e=r.initializeSerializer()(t.node());return e=function(t){if(navigator.userAgent.search("FireFox")>-1)return t.replace(/url.*&quot;\)/,'url(&quot;linearGradient[id*="-gradient-"]&quot;);');return t}(e),e=function(t){return t.replace(">",">"+a.styleBackgroundString)}(e=h.call(this,e,n,parseInt(t.attr("width"),10)))}}function s(t){var n=new Image;return n.src=""+a.imageSourceBase+u(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g,(function(t,n){return String.fromCharCode("0x"+n)}))),n}function l(t,n){return n.getContext("2d").drawImage(t,0,0),n}function f(t,n,e){e.preventDefault(),function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:a.defaultFilename,e=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"image/png",r=t.toDataURL(e),i=document.createElement("a");i.href=r,i.download=n,document.body.appendChild(i),i.click(),document.body.removeChild(i)}(l(this,t),n)}function h(t,e,r){if(!e||!r)return t;var i=n.grey;return t=t.replace(/<g/,'<text x="'+this.margin().left+'" y="'+a.titleTopOffset+'" font-family="'+a.titleFontFamily+'" font-size="'+a.titleFontSize+'" fill="'+i[6]+'"> '+e+" </text><g ")}return{exportChart:function(t,n,e){if(o)return console.error("Sorry, this feature is not available for IE. If you require this to work, check this issue https://github.com/britecharts/britecharts/pull/652"),!1;var r,i,u,a=s(c.call(this,t,e));a.onload=f.bind(a,(r=this.width(),i=this.height(),(u=document.createElement("canvas")).height=i,u.width=r,u),n)},convertSvgToHtml:c,createImage:s,drawImageOnCanvas:l}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";var r,i,o;t.exports=(r={BASE:!0,HEAD:!0,HTML:!0,META:!0,NOFRAME:!0,NOSCRIPT:!0,PARAM:!0,SCRIPT:!0,STYLE:!0,TITLE:!0},i=["A","ABBR","ADDRESS","AREA","ARTICLE","ASIDE","AUDIO","B","BASE","BDI","BDO","BLOCKQUOTE","BODY","BR","BUTTON","CANVAS","CAPTION","CENTER","CITE","CODE","COL","COLGROUP","COMMAND","DATALIST","DD","DEL","DETAILS","DFN","DIV","DL","DT","EM","EMBED","FIELDSET","FIGCAPTION","FIGURE","FONT","FOOTER","FORM","H1","H2","H3","H4","H5","H6","HEAD","HEADER","HGROUP","HR","HTML","I","IFRAME","IMG","INPUT","INS","KBD","LABEL","LEGEND","LI","LINK","MAP","MARK","MATH","MENU","META","METER","NAV","NOBR","NOSCRIPT","OBJECT","OL","OPTION","OPTGROUP","OUTPUT","P","PARAM","PRE","PROGRESS","Q","RP","RT","RUBY","S","SAMP","SCRIPT","SECTION","SELECT","SMALL","SOURCE","SPAN","STRONG","STYLE","SUB","SUMMARY","SUP","SVG","TABLE","TBODY","TD","TEXTAREA","TFOOT","TH","THEAD","TIME","TITLE","TR","TRACK","U","UL","VAR","VIDEO","WBR"],o=function(t){var n={},e=document.body.appendChild(document.createElement(t)),r=window.getComputedStyle(e);return[].forEach.call(r,(function(t){n[t]=r[t]})),document.body.removeChild(e),n},{initializeSerializer:function(){var t={};return[].forEach.call(i,(function(n){r[n]||(t[n]=o(n))})),function(n){var e,i=[],u=void 0,a=void 0,c=void 0;if(n&&n.nodeType===Node.ELEMENT_NODE)return i=[],u=n.querySelectorAll("*"),[].forEach.call(u,(function(n,e){var u;r[n.tagName]||(a=window.getComputedStyle(n),u=(u=n.tagName).toUpperCase(),t[u]||(t[u]=o(u)),c=t[u],i[e]=n.style.cssText,[].forEach.call(a,(function(t){a[t]!==c[t]&&(n.style[t]=a[t])})))})),e=n.outerHTML,u=[].map.call(u,(function(t,n){return t.style.cssText=i[n],t})),e}}})},function(t,n,e){(function(t,r){var i;/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */!function(o){var u=n,a=(t&&t.exports,"object"==typeof r&&r);a.global!==a&&a.window;var c=function(t){this.message=t};(c.prototype=new Error).name="InvalidCharacterError";var s=function(t){throw new c(t)},l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",f=/[\t\n\f\r ]/g,h={encode:function(t){t=String(t),/[^\0-\xFF]/.test(t)&&s("The string to be encoded contains characters outside of the Latin1 range.");for(var n,e,r,i,o=t.length%3,u="",a=-1,c=t.length-o;++a<c;)n=t.charCodeAt(a)<<16,e=t.charCodeAt(++a)<<8,r=t.charCodeAt(++a),u+=l.charAt((i=n+e+r)>>18&63)+l.charAt(i>>12&63)+l.charAt(i>>6&63)+l.charAt(63&i);return 2==o?(n=t.charCodeAt(a)<<8,e=t.charCodeAt(++a),u+=l.charAt((i=n+e)>>10)+l.charAt(i>>4&63)+l.charAt(i<<2&63)+"="):1==o&&(i=t.charCodeAt(a),u+=l.charAt(i>>2)+l.charAt(i<<4&63)+"=="),u},decode:function(t){var n=(t=String(t).replace(f,"")).length;n%4==0&&(n=(t=t.replace(/==?$/,"")).length),(n%4==1||/[^+a-zA-Z0-9/]/.test(t))&&s("Invalid character: the string to be decoded is not correctly encoded.");for(var e,r,i=0,o="",u=-1;++u<n;)r=l.indexOf(t.charAt(u)),e=i%4?64*e+r:r,i++%4&&(o+=String.fromCharCode(255&e>>(-2*i&6)));return o},version:"0.1.0"};void 0===(i=function(){return h}.call(n,e,n,t))||(t.exports=i)}()}).call(this,e(79)(t),e(80))},function(t,n){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,n){var e;e=function(){return this}();try{e=e||new Function("return this")()}catch(t){"object"==typeof window&&(e=window)}t.exports=e},function(t,n,e){"use strict";n.a=function(t,n){return t=+t,n=+n,function(e){return Math.round(t*(1-e)+n*e)}}},function(t,n,e){"use strict";e.d(n,"b",(function(){return s})),e.d(n,"a",(function(){return l})),e.d(n,"d",(function(){return g})),e.d(n,"c",(function(){return v}));var r=e(11),i=e(7),o=e(67),u=6/29,a=3*u*u;function c(t){if(t instanceof f)return new f(t.l,t.a,t.b,t.opacity);if(t instanceof m)return b(t);t instanceof i.b||(t=Object(i.h)(t));var n,e,r=y(t.r),o=y(t.g),u=y(t.b),a=h((.2225045*r+.7168786*o+.0606169*u)/1);return r===o&&o===u?n=e=a:(n=h((.4360747*r+.3850649*o+.1430804*u)/.96422),e=h((.0139322*r+.0971045*o+.7141733*u)/.82521)),new f(116*a-16,500*(n-a),200*(a-e),t.opacity)}function s(t,n){return new f(t,0,0,null==n?1:n)}function l(t,n,e,r){return 1===arguments.length?c(t):new f(t,n,e,null==r?1:r)}function f(t,n,e,r){this.l=+t,this.a=+n,this.b=+e,this.opacity=+r}function h(t){return t>.008856451679035631?Math.pow(t,1/3):t/a+4/29}function d(t){return t>u?t*t*t:a*(t-4/29)}function p(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function y(t){return(t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function _(t){if(t instanceof m)return new m(t.h,t.c,t.l,t.opacity);if(t instanceof f||(t=c(t)),0===t.a&&0===t.b)return new m(NaN,0<t.l&&t.l<100?0:NaN,t.l,t.opacity);var n=Math.atan2(t.b,t.a)*o.b;return new m(n<0?n+360:n,Math.sqrt(t.a*t.a+t.b*t.b),t.l,t.opacity)}function g(t,n,e,r){return 1===arguments.length?_(t):new m(e,n,t,null==r?1:r)}function v(t,n,e,r){return 1===arguments.length?_(t):new m(t,n,e,null==r?1:r)}function m(t,n,e,r){this.h=+t,this.c=+n,this.l=+e,this.opacity=+r}function b(t){if(isNaN(t.h))return new f(t.l,0,0,t.opacity);var n=t.h*o.a;return new f(t.l,Math.cos(n)*t.c,Math.sin(n)*t.c,t.opacity)}Object(r.a)(f,l,Object(r.b)(i.a,{brighter:function(t){return new f(this.l+18*(null==t?1:t),this.a,this.b,this.opacity)},darker:function(t){return new f(this.l-18*(null==t?1:t),this.a,this.b,this.opacity)},rgb:function(){var t=(this.l+16)/116,n=isNaN(this.a)?t:t+this.a/500,e=isNaN(this.b)?t:t-this.b/200;return n=.96422*d(n),t=1*d(t),e=.82521*d(e),new i.b(p(3.1338561*n-1.6168667*t-.4906146*e),p(-.9787684*n+1.9161415*t+.033454*e),p(.0719453*n-.2289914*t+1.4052427*e),this.opacity)}})),Object(r.a)(m,v,Object(r.b)(i.a,{brighter:function(t){return new m(this.h,this.c,this.l+18*(null==t?1:t),this.opacity)},darker:function(t){return new m(this.h,this.c,this.l-18*(null==t?1:t),this.opacity)},rgb:function(){return b(this).rgb()}}))},function(t,n,e){"use strict";var r;void 0===(r=function(){return{bar:'\n            <svg class="load-state bar-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 711 325">\n              \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(0 29)">\n                        <g stroke="#EFF2F5" stroke-dasharray="4 4">\n                            <path d="M.400592911 200.302477L710.674315 200.302477M.400592884 131.172748L710.674315 131.172748M.324410282 64.2071321L710.621499 64.2071321M.291004517.563888874L709.82431.563888889"/>\n                        </g>\n                        <g fill="#D2D6DF" transform="translate(63.08 11)">\n                            <polygon points="-.08 176 23.92 176 23.92 255 -.08 255"/>\n                            <polygon points="50.829 147 74.829 147 74.829 255 50.829 255"/>\n                            <polygon points="254.465 0 278.465 0 278.465 255 254.465 255"/>\n                            <polygon points="458.102 169 482.102 169 482.102 255 458.102 255"/>\n                            <polygon points="152.647 82 176.647 82 176.647 255 152.647 255"/>\n                            <polygon points="356.283 66 380.283 66 380.283 255 356.283 255"/>\n                            <polygon points="559.92 229 583.92 229 583.92 255 559.92 255"/>\n                            <polygon points="101.738 115 125.738 115 125.738 255 101.738 255"/>\n                            <polygon points="305.374 42 329.374 42 329.374 255 305.374 255"/>\n                            <polygon points="509.011 201 533.011 201 533.011 255 509.011 255"/>\n                            <polygon points="203.556 19 227.556 19 227.556 255 203.556 255"/>\n                            <polygon points="407.192 115 431.192 115 431.192 255 407.192 255"/>\n                        </g>\n                    </g>\n                    <polygon fill="#D2D6DF" fill-rule="nonzero" points="0 295 711 295 711 294 0 294"/>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',donut:'\n            <svg class="load-state donut-load-state" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 376 331">\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <g fill="none" fill-rule="evenodd">\n                    <g transform="translate(116 107)">\n                        <circle cx="72" cy="72" r="72" stroke="#EFF2F5" stroke-linecap="round" stroke-width="9.6"/>\n                        <path stroke="#D2D6DF" stroke-width="19.2" d="M126.153559,119.524055 C137.264629,106.845712 144,90.2321371 144,72.0444604 C144,32.2554036 111.764502,0 72,0"/>\n                        <circle cx="72" cy="72" r="67.2" fill="#FFF"/>\n                    </g>\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',line:'\n            <svg\n                class="load-state line-load-state"\n                xmlns="http://www.w3.org/2000/svg"\n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path\n                    id="chart-bg"\n                    class="chart-bg"\n                    style="stroke:#C3C6CF;"\n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n                <polyline\n                    id="chart-line"\n                    class="chart-line"\n                    style="stroke:#C3C6CF;stroke-width:4;fill:none;"\n                    points="8.8,175.8 62.4,237.7 116.1,184.7 169.7,175.8 223.3,57 277,176.8 330.6,176.8 384.3,122.5 437.9,176.8 491.6,176.8 545.2,218.4 598.8,122.5 652.5,184.7 706.1,135.1 "\n                />\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        ',stackedArea:'\n            <svg\n                class="load-state stacked-area-load-state"\n                xmlns="http://www.w3.org/2000/svg"\n                viewBox="0 0 711 325"\n            >\n                \n            <defs>\n                <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%" >\n                    <stop offset="0" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="33.33%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="50%" stop-color="#ffffff" stop-opacity="0" />\n                    <stop offset="66.66%" stop-color="#ffffff" stop-opacity="0.8" />\n                    <stop offset="100%" stop-color="#ffffff" stop-opacity="0.8" />\n                </linearGradient>\n            </defs>\n        \n                <path\n                    id="chart-bg"\n                    class="chart-bg"\n                    style="stroke:#C3C6CF;"\n                    d="M3.4,216.5h707.3 M3.4,160.5h707.3 M3.3,103.5h707.3 M3.3,48.5h707.6 M0.4,276.6H710H0.4z"\n                />\n                <g transform="translate(20 50)">\n                    <path\n                        id="chart-area"\n                        strokeLinecap="square"\n                        d="M0.34233103,0.593688165 L709.977885,0.593688189"\n                        transform="translate(.01 227.976)"\n                    />\n                    <path fill="#C3C6CF" d="M0.528124801,224.014648 L0.528124801,177.734375 L53.3834796,177.734375 C71.5390789,177.734375 86.8277373,168.972754 101.240241,151.662202 C112.578335,138.044258 121.139826,123.110227 136.974507,91.596773 C137.343842,90.8617404 139.300293,86.9654028 139.856735,85.8583549 C155.041692,55.6476711 163.354313,41.0906306 174.319873,27.7179171 C188.951312,9.87459412 204.885845,0.5 223.830634,0.5 C242.123071,0.5 257.291724,8.27027858 270.907992,23.1359289 C281.228683,34.4036118 289.135925,47.1272372 302.542017,72.085092 C303.275893,73.4513345 306.289669,79.0766612 307.063369,80.5168656 C321.41025,107.222876 330.088083,120.97663 341.470704,132.92446 C355.88994,148.05969 371.908861,155.792969 391.654853,155.792969 C412.142049,155.792969 428.763593,152.325614 442.880698,145.765582 C454.197328,140.506893 463.373931,133.679865 473.786035,123.626931 C476.528659,120.978915 486.44777,110.911455 488.791866,108.6483 C502.907223,95.0203436 514.194325,88.9355469 530.135322,88.9355469 C546.532652,88.9355469 559.505909,97.338499 575.973261,115.41103 C579.723508,119.526837 593.103621,135.086814 592.915496,134.871799 C605.09738,148.794859 614.368835,157.635549 625.072091,164.58539 C638.386599,173.230769 652.701021,177.734375 669.279853,177.734375 L673.779853,177.734375 L673.779853,224.014648 L0.528124801,224.014648 Z" />\n                </g>\n                <rect class="chart-filter" fill="url(#lgrad)" x="-100%" y="0" width="300%" height="100%"></rect>\n            </svg>\n        '}}.call(n,e,n,t))||(t.exports=r)},function(t,n,e){"use strict";e.r(n);var r=Array.prototype.slice,i=function(t){return t};function o(t){return"translate("+(t+.5)+",0)"}function u(t){return"translate(0,"+(t+.5)+")"}function a(t){return function(n){return+t(n)}}function c(t){var n=Math.max(0,t.bandwidth()-1)/2;return t.round()&&(n=Math.round(n)),function(e){return+t(e)+n}}function s(){return!this.__axis}function l(t,n){var e=[],l=null,f=null,h=6,d=6,p=3,y=1===t||4===t?-1:1,_=4===t||2===t?"x":"y",g=1===t||3===t?o:u;function v(r){var o=null==l?n.ticks?n.ticks.apply(n,e):n.domain():l,u=null==f?n.tickFormat?n.tickFormat.apply(n,e):i:f,v=Math.max(h,0)+p,m=n.range(),b=+m[0]+.5,x=+m[m.length-1]+.5,w=(n.bandwidth?c:a)(n.copy()),M=r.selection?r.selection():r,T=M.selectAll(".domain").data([null]),O=M.selectAll(".tick").data(o,n).order(),k=O.exit(),A=O.enter().append("g").attr("class","tick"),C=O.select("line"),S=O.select("text");T=T.merge(T.enter().insert("path",".tick").attr("class","domain").attr("stroke","currentColor")),O=O.merge(A),C=C.merge(A.append("line").attr("stroke","currentColor").attr(_+"2",y*h)),S=S.merge(A.append("text").attr("fill","currentColor").attr(_,y*v).attr("dy",1===t?"0em":3===t?"0.71em":"0.32em")),r!==M&&(T=T.transition(r),O=O.transition(r),C=C.transition(r),S=S.transition(r),k=k.transition(r).attr("opacity",1e-6).attr("transform",(function(t){return isFinite(t=w(t))?g(t):this.getAttribute("transform")})),A.attr("opacity",1e-6).attr("transform",(function(t){var n=this.parentNode.__axis;return g(n&&isFinite(n=n(t))?n:w(t))}))),k.remove(),T.attr("d",4===t||2==t?d?"M"+y*d+","+b+"H0.5V"+x+"H"+y*d:"M0.5,"+b+"V"+x:d?"M"+b+","+y*d+"V0.5H"+x+"V"+y*d:"M"+b+",0.5H"+x),O.attr("opacity",1).attr("transform",(function(t){return g(w(t))})),C.attr(_+"2",y*h),S.attr(_,y*v).text(u),M.filter(s).attr("fill","none").attr("font-size",10).attr("font-family","sans-serif").attr("text-anchor",2===t?"start":4===t?"end":"middle"),M.each((function(){this.__axis=w}))}return v.scale=function(t){return arguments.length?(n=t,v):n},v.ticks=function(){return e=r.call(arguments),v},v.tickArguments=function(t){return arguments.length?(e=null==t?[]:r.call(t),v):e.slice()},v.tickValues=function(t){return arguments.length?(l=null==t?null:r.call(t),v):l&&l.slice()},v.tickFormat=function(t){return arguments.length?(f=t,v):f},v.tickSize=function(t){return arguments.length?(h=d=+t,v):h},v.tickSizeInner=function(t){return arguments.length?(h=+t,v):h},v.tickSizeOuter=function(t){return arguments.length?(d=+t,v):d},v.tickPadding=function(t){return arguments.length?(p=+t,v):p},v}function f(t){return l(1,t)}function h(t){return l(2,t)}function d(t){return l(3,t)}function p(t){return l(4,t)}e.d(n,"axisTop",(function(){return f})),e.d(n,"axisRight",(function(){return h})),e.d(n,"axisBottom",(function(){return d})),e.d(n,"axisLeft",(function(){return p}))},,function(t,n,e){"use strict";e.d(n,"a",(function(){return y}));var r=e(11),i=e(7),o=e(67),u=-.14861,a=1.78277,c=-.29227,s=-.90649,l=1.97294,f=l*s,h=l*a,d=a*c-s*u;function p(t){if(t instanceof _)return new _(t.h,t.s,t.l,t.opacity);t instanceof i.b||(t=Object(i.h)(t));var n=t.r/255,e=t.g/255,r=t.b/255,u=(d*r+f*n-h*e)/(d+f-h),a=r-u,p=(l*(e-u)-c*a)/s,y=Math.sqrt(p*p+a*a)/(l*u*(1-u)),g=y?Math.atan2(p,a)*o.b-120:NaN;return new _(g<0?g+360:g,y,u,t.opacity)}function y(t,n,e,r){return 1===arguments.length?p(t):new _(t,n,e,null==r?1:r)}function _(t,n,e,r){this.h=+t,this.s=+n,this.l=+e,this.opacity=+r}Object(r.a)(_,y,Object(r.b)(i.a,{brighter:function(t){return t=null==t?i.c:Math.pow(i.c,t),new _(this.h,this.s,this.l*t,this.opacity)},darker:function(t){return t=null==t?i.d:Math.pow(i.d,t),new _(this.h,this.s,this.l*t,this.opacity)},rgb:function(){var t=isNaN(this.h)?0:(this.h+120)*o.a,n=+this.l,e=isNaN(this.s)?0:this.s*n*(1-n),r=Math.cos(t),f=Math.sin(t);return new i.b(255*(n+e*(u*r+a*f)),255*(n+e*(c*r+s*f)),255*(n+e*(l*r)),this.opacity)}}))},,,,,function(t,n){var e=/^(?:0|[1-9]\d*)$/;function r(t,n,e){switch(e.length){case 0:return t.call(n);case 1:return t.call(n,e[0]);case 2:return t.call(n,e[0],e[1]);case 3:return t.call(n,e[0],e[1],e[2])}return t.apply(n,e)}var i,o,u=Object.prototype,a=u.hasOwnProperty,c=u.toString,s=u.propertyIsEnumerable,l=(i=Object.keys,o=Object,function(t){return i(o(t))}),f=Math.max,h=!s.call({valueOf:1},"valueOf");function d(t,n){var e=v(t)||function(t){return function(t){return function(t){return!!t&&"object"==typeof t}(t)&&m(t)}(t)&&a.call(t,"callee")&&(!s.call(t,"callee")||"[object Arguments]"==c.call(t))}(t)?function(t,n){for(var e=-1,r=Array(t);++e<t;)r[e]=n(e);return r}(t.length,String):[],r=e.length,i=!!r;for(var o in t)!n&&!a.call(t,o)||i&&("length"==o||y(o,r))||e.push(o);return e}function p(t,n,e){var r=t[n];a.call(t,n)&&g(r,e)&&(void 0!==e||n in t)||(t[n]=e)}function y(t,n){return!!(n=null==n?9007199254740991:n)&&("number"==typeof t||e.test(t))&&t>-1&&t%1==0&&t<n}function _(t){var n=t&&t.constructor;return t===("function"==typeof n&&n.prototype||u)}function g(t,n){return t===n||t!=t&&n!=n}var v=Array.isArray;function m(t){return null!=t&&function(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=9007199254740991}(t.length)&&!function(t){var n=b(t)?c.call(t):"";return"[object Function]"==n||"[object GeneratorFunction]"==n}(t)}function b(t){var n=typeof t;return!!t&&("object"==n||"function"==n)}var x,w=(x=function(t,n){if(h||_(n)||m(n))!function(t,n,e,r){e||(e={});for(var i=-1,o=n.length;++i<o;){var u=n[i],a=r?r(e[u],t[u],u,e,t):void 0;p(e,u,void 0===a?t[u]:a)}}(n,function(t){return m(t)?d(t):function(t){if(!_(t))return l(t);var n=[];for(var e in Object(t))a.call(t,e)&&"constructor"!=e&&n.push(e);return n}(t)}(n),t);else for(var e in n)a.call(n,e)&&p(t,e,n[e])},function(t,n){return n=f(void 0===n?t.length-1:n,0),function(){for(var e=arguments,i=-1,o=f(e.length-n,0),u=Array(o);++i<o;)u[i]=e[n+i];i=-1;for(var a=Array(n+1);++i<n;)a[i]=e[i];return a[n]=u,r(t,this,a)}}((function(t,n){var e=-1,r=n.length,i=r>1?n[r-1]:void 0,o=r>2?n[2]:void 0;for(i=x.length>3&&"function"==typeof i?(r--,i):void 0,o&&function(t,n,e){if(!b(e))return!1;var r=typeof n;return!!("number"==r?m(e)&&y(n,e.length):"string"==r&&n in e)&&g(e[n],t)}(n[0],n[1],o)&&(i=r<3?void 0:i,r=1),t=Object(t);++e<r;){var u=n[e];u&&x(t,u,e,i)}return t})));t.exports=w},,,,,,,,,,,,,,,function(t,n,e){"use strict";var r,i=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r])}return t},o=function(t,n){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,n){var e=[],r=!0,i=!1,o=void 0;try{for(var u,a=t[Symbol.iterator]();!(r=(u=a.next()).done)&&(e.push(u.value),!n||e.length!==n);r=!0);}catch(t){i=!0,o=t}finally{try{!r&&a.return&&a.return()}finally{if(i)throw o}}return e}(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")};void 0===(r=function(t){var n=e(2),r=e(84),u=e(43),a=e(45),c=e(68),s=e(64),l=e(41),f=e(75),h=e(71),d=e(6),p=e(91),y=(e(72),e(76).exportChart),_=e(65),g=e(83).bar;return function(){var t={top:40,right:30,bottom:60,left:70},e=960,v=500,m=g,b=void 0,x=void 0,w=void 0,M=void 0,T=null,O=.1,k=void 0,A=5,C=5,S=1,N=_.colorSchemas.britecharts,j=void 0,E=void 0,D=void 0,F=s.easeQuadInOut,P=!1,L=void 0,I=void 0,U=void 0,R=void 0,B=void 0,H=void 0,q=void 0,Y=!1,z=480,G=void 0,V=void 0,X=-60,W=0,$=0,Q=void 0,Z=null,J="name",K="value",tt="stack",nt=",f",et=function(t){return t[J]},rt=function(t){return t[tt]},it=function(t){return isNaN(t)||t<0?0:t},ot=!1,ut=c.dispatch("customMouseOver","customMouseOut","customMouseMove","customClick");function at(i){i.each((function(i){var u,c;I=e-t.left-t.right,U=v-t.top-t.bottom,function(t){H=function(t){return t.filter((function(t,n,e){return e.indexOf(t)==n}))}(t.map((function(t){return t.stack}))),Y&&(H=H.reverse());B=a.nest().key(et).rollup((function(t){var n={};return t.forEach((function(t){t&&t[tt]&&(n[t[tt]]=function(t){return t[K]}(t))})),n.values=t,n})).entries(t).map((function(t){return p({},{total:n.sum(n.permute(t.value,H)),key:t.key},t.value)}))}(R=i.reduce((function(t,n){return n.value=+n[K],n.stack=n[tt],n.topicName=rt(n),n.name=n[J],[].concat(function(t){if(Array.isArray(t)){for(var n=0,e=Array(t.length);n<t.length;n++)e[n]=t[n];return e}return Array.from(t)}(t),[n])}),[])),function(){var t=(e=new Set(B.map((function(t){return t.total}))),1===e.size&&e.has(0)?1:n.max(B.map((function(t){return t.total}))));var e;P?(b=f.scaleLinear().domain([0,t]).rangeRound([0,I-1]),w=f.scaleBand().domain(R.map(et)).rangeRound([U,0]).padding(O)):(b=f.scaleBand().domain(R.map(et)).rangeRound([0,I]).padding(O),w=f.scaleLinear().domain([0,t]).rangeRound([U,0]).nice());j=f.scaleOrdinal().range(N).domain(R.map(rt)),E=j.domain(R.map(rt)).domain().reduce((function(t,n){return t[n]=j(n),t}),{})}(),u=h.stack().keys(H),c=B.map((function(t){var n={};return H.forEach((function(e){n[e]=t[e]})),p({},t,n)})),D=u(c),function(n){L||(L=d.select(n).append("svg").classed("britechart stacked-bar",!0),function(){var n=L.append("g").classed("container-group",!0).attr("transform","translate("+t.left+","+t.top+")");n.append("g").classed("x-axis-group",!0).append("g").classed("x axis",!0),n.selectAll(".x-axis-group").append("g").classed("month-axis",!0),n.append("g").classed("y-axis-group axis",!0),n.append("g").classed("grid-lines-group",!0),n.append("g").classed("chart-group",!0),n.append("g").classed("y-axis-label",!0),n.append("g").classed("metadata-group",!0)}());L.attr("width",e).attr("height",v)}(this),function(){var t=P?b:w;L.select(".grid-lines-group").selectAll("line").remove(),("horizontal"===Z||"full"===Z)&&L.select(".grid-lines-group").selectAll("line.horizontal-grid-line").data(t.ticks(A).slice(1)).enter().append("line").attr("class","horizontal-grid-line").attr("x1",1-W).attr("x2",I).attr("y1",(function(t){return w(t)})).attr("y2",(function(t){return w(t)}));"vertical"!==Z&&"full"!==Z||L.select(".grid-lines-group").selectAll("line.vertical-grid-line").data(t.ticks(C).slice(1)).enter().append("line").attr("class","vertical-grid-line").attr("y1",0).attr("y2",U).attr("x1",(function(t){return b(t)})).attr("x2",(function(t){return b(t)}));P?L.select(".grid-lines-group").selectAll("line.extended-y-line").data([0]).enter().append("line").attr("class","extended-y-line").attr("y1",$).attr("y2",U).attr("x1",0).attr("x2",0):L.select(".grid-lines-group").selectAll("line.extended-x-line").data([0]).enter().append("line").attr("class","extended-x-line").attr("x1",W).attr("x2",I).attr("y1",U).attr("y2",U)}(),P?(x=r.axisBottom(b).ticks(C,nt),M=r.axisLeft(w)):(x=r.axisBottom(b),M=r.axisLeft(w).ticks(A,nt)),function(){P?(L.select(".x-axis-group .axis.x").attr("transform","translate( 0, "+U+" )").call(x),L.select(".y-axis-group.axis").attr("transform","translate( "+-W+", 0)").call(M)):(L.select(".x-axis-group .axis.x").attr("transform","translate( 0, "+U+" )").call(x),L.select(".y-axis-group.axis").attr("transform","translate( "+-W+", 0)").call(M).call(ct));G&&(V&&L.selectAll(".y-axis-label-text").remove(),V=L.select(".y-axis-label").append("text").classed("y-axis-label-text",!0).attr("x",-U/2).attr("y",X).attr("text-anchor","middle").attr("transform","rotate(270 0 0)").text(G))}(),function(){q&&L.selectAll(".layer").remove();var t=L.select(".chart-group").selectAll(".layer");Q=n.range(20,20*(D[0].length+1),20),P?(e=t.data(D),r=(q=e.enter().append("g").attr("fill",(function(t){var n=t.key;return E[n]})).classed("layer",!0)).selectAll(".bar").data((function(t){return st(t)})).enter().append("rect").classed("bar",!0).attr("x",(function(t){return b(t[0])})).attr("y",(function(t){return w(t.data.key)})).attr("height",w.bandwidth()),ot?r.style("opacity",.24).transition().delay((function(t,n){return Q[n]})).duration(1e3).ease(F).tween("attr.width",yt):r.attr("width",(function(t){return b(t[1]-t[0])}))):function(t){var n=t.data(D),e=(q=n.enter().append("g").attr("fill",(function(t){var n=t.key;return E[n]})).classed("layer",!0)).selectAll(".bar").data((function(t){return st(t)})).enter().append("rect").classed("bar",!0).attr("x",(function(t){return b(t.data.key)})).attr("y",(function(t){return w(t[1])})).attr("width",b.bandwidth);ot?e.style("opacity",.24).transition().delay((function(t,n){return Q[n]})).duration(1e3).ease(F).tween("attr.height",_t):e.attr("height",(function(t){return w(t[0])-w(t[1])}))}(t);var e,r;t.exit().transition().style("opacity",0).remove()}(),function(){e>z&&L.on("mouseover",(function(t){!function(t,n){ut.call("customMouseOver",t,n,d.mouse(t))}(this,t)})).on("mouseout",(function(t){!function(t,n){L.select(".metadata-group").attr("transform","translate(9999, 0)"),ut.call("customMouseOut",t,n,d.mouse(t))}(this,t)})).on("mousemove",(function(n){var e,r,i,u,a,c,s,l,f,h;r=lt(e=this),i=o(r,2),u=i[0],a=i[1],c=P?ht(a):ft(u),s=void 0,l=void 0,c&&(P?(s=u-t.left,l=w(c.key)+w.bandwidth()/2):(s=b(c.key)+t.left,l=a-t.bottom),f=s,h=l,L.select(".metadata-group").attr("transform","translate("+f+","+h+")"),ut.call("customMouseMove",e,c,E,s,l))})).on("click",(function(t){var n,e,r,i,u,a;e=lt(n=this),r=o(e,2),i=r[0],u=r[1],a=P?ht(u):ft(i),ut.call("customClick",n,a,d.mouse(n))}));L.selectAll(".bar").on("mouseover",dt).on("mouseout",pt)}()}))}function ct(t){t.selectAll(".tick text").attr("transform","translate(-20, -8)")}function st(t){return t.map((function(t){for(var n=0;n<t.length;n++)t[n]=it(t[n]);return t}))}function lt(t){return d.mouse(t)}function ft(n){var e=n-t.left;return B.find((function(t){var n=t.key,r=b(n),i=r+b.bandwidth();return e>=r&&e<i}))}function ht(n){var e=n-t.top;return B.find((function(t){var n=t.key,r=w(n),i=r+w.bandwidth();return e>=r&&e<i}))}function dt(){var t=this;d.select(this).attr("fill",(function(){return u.color(d.select(t.parentNode).attr("fill")).darker()}))}function pt(){var t=this;d.select(this).attr("fill",(function(){return d.select(t.parentNode).attr("fill")}))}function yt(t){var n=d.select(this),e=l.interpolateRound(0,b(t[1]-t[0])),r=l.interpolateNumber(0,1);return function(t){n.attr("width",e(t)).style("opacity",r(t))}}function _t(t){var n=w(t[0])-w(t[1]),e=d.select(this),r=l.interpolateRound(0,it(n)),i=l.interpolateNumber(0,1);return function(t){e.attr("height",r(t)).style("opacity",i(t))}}return at.aspectRatio=function(t){return arguments.length?(T=t,this):T},at.betweenBarsPadding=function(t){return arguments.length?(O=t,this):O},at.colorSchema=function(t){return arguments.length?(N=t,this):N},at.exportChart=function(t,n){y.call(at,L,t,n)},at.grid=function(t){return arguments.length?(Z=t,this):Z},at.hasPercentage=function(t){return arguments.length?(nt=t?"%":",f",this):"%"===nt},at.height=function(t){return arguments.length?(T&&(e=Math.ceil(t/T)),v=t,this):v},at.isHorizontal=function(t){return arguments.length?(P=t,this):P},at.hasReversedStacks=function(t){return arguments.length?(Y=t,this):Y},at.isAnimated=function(t){return arguments.length?(ot=t,this):ot},at.locale=function(t){return arguments.length?(k=t,this):k},at.margin=function(n){return arguments.length?(t=i({},t,n),this):t},at.nameLabel=function(t){return arguments.length?(J=t,this):J},at.xTicks=function(t){return arguments.length?(C=t,this):C},at.yTicks=function(t){return arguments.length?(A=t,this):A},at.loadingState=function(t){return arguments.length?(m=t,this):m},at.on=function(){var t=ut.on.apply(ut,arguments);return t===ut?at:t},at.percentageAxisToMaxRatio=function(t){return arguments.length?(S=t,this):S},at.stackLabel=function(t){return arguments.length?(tt=t,this):tt},at.tooltipThreshold=function(t){return arguments.length?(z=t,this):z},at.valueLabel=function(t){return arguments.length?(K=t,this):K},at.valueLabelFormat=function(t){return arguments.length?(nt=t,this):nt},at.width=function(t){return arguments.length?(T&&(v=Math.ceil(t*T)),e=t,this):e},at.yAxisLabel=function(t){return arguments.length?(G=t,this):G},at.yAxisLabelOffset=function(t){return arguments.length?(X=t,this):X},at}}.call(n,e,n,t))||(t.exports=r)}])}));
//# sourceMappingURL=stackedBar.min.js.map

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(733);
module.exports = __webpack_require__(63).RegExp.escape;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(94);
__webpack_require__(698);
module.exports = __webpack_require__(22).Array.from;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(114);
__webpack_require__(94);
module.exports = __webpack_require__(696);


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(114);
__webpack_require__(94);
module.exports = __webpack_require__(697);


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(22);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(159);
__webpack_require__(94);
__webpack_require__(114);
__webpack_require__(700);
__webpack_require__(717);
__webpack_require__(716);
__webpack_require__(715);
module.exports = __webpack_require__(22).Map;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(701);
module.exports = __webpack_require__(22).Math.log10;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(702);
module.exports = __webpack_require__(22).Number.isFinite;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(703);
module.exports = __webpack_require__(22).Number.isNaN;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(704);
module.exports = __webpack_require__(22).Object.assign;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(705);
var $Object = __webpack_require__(22).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(706);
var $Object = __webpack_require__(22).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(718);
module.exports = __webpack_require__(22).Object.entries;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(707);
module.exports = __webpack_require__(22).Object.freeze;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(708);
var $Object = __webpack_require__(22).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(709);
module.exports = __webpack_require__(22).Object.getPrototypeOf;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(710);
module.exports = __webpack_require__(22).Object.keys;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(711);
module.exports = __webpack_require__(22).Object.setPrototypeOf;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(719);
module.exports = __webpack_require__(22).Object.values;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(159);
__webpack_require__(94);
__webpack_require__(114);
__webpack_require__(712);
__webpack_require__(720);
__webpack_require__(721);
module.exports = __webpack_require__(22).Promise;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(159);
__webpack_require__(94);
__webpack_require__(114);
__webpack_require__(713);
__webpack_require__(724);
__webpack_require__(723);
__webpack_require__(722);
module.exports = __webpack_require__(22).Set;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(714);
__webpack_require__(159);
__webpack_require__(725);
__webpack_require__(726);
module.exports = __webpack_require__(22).Symbol;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(94);
__webpack_require__(114);
module.exports = __webpack_require__(206).f('iterator');


/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(128);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(85);
var toLength = __webpack_require__(157);
var toAbsoluteIndex = __webpack_require__(694);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(77);
var IObject = __webpack_require__(194);
var toObject = __webpack_require__(93);
var toLength = __webpack_require__(157);
var asc = __webpack_require__(683);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);
var isArray = __webpack_require__(325);
var SPECIES = __webpack_require__(42)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(682);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(61);
var createDesc = __webpack_require__(131);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(113);
var gOPS = __webpack_require__(198);
var pIE = __webpack_require__(130);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 686 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(155);
var descriptor = __webpack_require__(131);
var setToStringTag = __webpack_require__(132);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(84)(IteratorPrototype, __webpack_require__(42)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(39);
var macrotask = __webpack_require__(340).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(127)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(53);
var getKeys = __webpack_require__(113);
var gOPS = __webpack_require__(198);
var pIE = __webpack_require__(130);
var toObject = __webpack_require__(93);
var IObject = __webpack_require__(194);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(91)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(61);
var anObject = __webpack_require__(70);
var getKeys = __webpack_require__(113);

module.exports = __webpack_require__(53) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(85);
var gOPN = __webpack_require__(329).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(54);
var anObject = __webpack_require__(70);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(77)(Function.call, __webpack_require__(197).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(202);
var defined = __webpack_require__(191);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(202);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(39);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(70);
var get = __webpack_require__(207);
module.exports = __webpack_require__(22).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(153);
var ITERATOR = __webpack_require__(42)('iterator');
var Iterators = __webpack_require__(112);
module.exports = __webpack_require__(22).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(77);
var $export = __webpack_require__(30);
var toObject = __webpack_require__(93);
var call = __webpack_require__(326);
var isArrayIter = __webpack_require__(324);
var toLength = __webpack_require__(157);
var createProperty = __webpack_require__(684);
var getIterFn = __webpack_require__(207);

$export($export.S + $export.F * !__webpack_require__(327)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(678);
var step = __webpack_require__(328);
var Iterators = __webpack_require__(112);
var toIObject = __webpack_require__(85);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(195)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(319);
var validate = __webpack_require__(204);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(321)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(30);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(30);
var _isFinite = __webpack_require__(39).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(30);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(30);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(689) });


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(30);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(155) });


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(30);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(53), 'Object', { defineProperty: __webpack_require__(61).f });


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(54);
var meta = __webpack_require__(154).onFreeze;

__webpack_require__(156)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(85);
var $getOwnPropertyDescriptor = __webpack_require__(197).f;

__webpack_require__(156)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(93);
var $getPrototypeOf = __webpack_require__(330);

__webpack_require__(156)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(93);
var $keys = __webpack_require__(113);

__webpack_require__(156)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(30);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(692).set });


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(129);
var global = __webpack_require__(39);
var ctx = __webpack_require__(77);
var classof = __webpack_require__(153);
var $export = __webpack_require__(30);
var isObject = __webpack_require__(54);
var aFunction = __webpack_require__(126);
var anInstance = __webpack_require__(190);
var forOf = __webpack_require__(128);
var speciesConstructor = __webpack_require__(339);
var task = __webpack_require__(340).set;
var microtask = __webpack_require__(688)();
var newPromiseCapabilityModule = __webpack_require__(196);
var perform = __webpack_require__(333);
var userAgent = __webpack_require__(695);
var promiseResolve = __webpack_require__(334);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(42)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(199)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(132)($Promise, PROMISE);
__webpack_require__(338)(PROMISE);
Wrapper = __webpack_require__(22)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(327)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(319);
var validate = __webpack_require__(204);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(321)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(39);
var has = __webpack_require__(92);
var DESCRIPTORS = __webpack_require__(53);
var $export = __webpack_require__(30);
var redefine = __webpack_require__(335);
var META = __webpack_require__(154).KEY;
var $fails = __webpack_require__(91);
var shared = __webpack_require__(201);
var setToStringTag = __webpack_require__(132);
var uid = __webpack_require__(158);
var wks = __webpack_require__(42);
var wksExt = __webpack_require__(206);
var wksDefine = __webpack_require__(205);
var enumKeys = __webpack_require__(685);
var isArray = __webpack_require__(325);
var anObject = __webpack_require__(70);
var isObject = __webpack_require__(54);
var toObject = __webpack_require__(93);
var toIObject = __webpack_require__(85);
var toPrimitive = __webpack_require__(203);
var createDesc = __webpack_require__(131);
var _create = __webpack_require__(155);
var gOPNExt = __webpack_require__(691);
var $GOPD = __webpack_require__(197);
var $GOPS = __webpack_require__(198);
var $DP = __webpack_require__(61);
var $keys = __webpack_require__(113);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(329).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(130).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(129)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(84)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(336)('Map');


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(337)('Map');


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(30);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(320)('Map') });


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(30);
var $entries = __webpack_require__(332)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(30);
var $values = __webpack_require__(332)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(30);
var core = __webpack_require__(22);
var global = __webpack_require__(39);
var speciesConstructor = __webpack_require__(339);
var promiseResolve = __webpack_require__(334);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(30);
var newPromiseCapability = __webpack_require__(196);
var perform = __webpack_require__(333);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(336)('Set');


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(337)('Set');


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(30);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(320)('Set') });


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(205)('asyncIterator');


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(205)('observable');


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var isArray = __webpack_require__(163);
var SPECIES = __webpack_require__(25)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(17);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(74);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(99);
var gOPS = __webpack_require__(167);
var pIE = __webpack_require__(135);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(136)('native-function-to-string', Function.toString);


/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(9);
var $re = __webpack_require__(732)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(9);

$export($export.P, 'Array', { copyWithin: __webpack_require__(342) });

__webpack_require__(86)('copyWithin');


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $every = __webpack_require__(71)(4);

$export($export.P + $export.F * !__webpack_require__(65)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(9);

$export($export.P, 'Array', { fill: __webpack_require__(209) });

__webpack_require__(86)('fill');


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $filter = __webpack_require__(71)(2);

$export($export.P + $export.F * !__webpack_require__(65)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(9);
var $find = __webpack_require__(71)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(86)(KEY);


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(9);
var $find = __webpack_require__(71)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(86)(KEY);


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $forEach = __webpack_require__(71)(0);
var STRICT = __webpack_require__(65)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(64);
var $export = __webpack_require__(9);
var toObject = __webpack_require__(33);
var call = __webpack_require__(353);
var isArrayIter = __webpack_require__(217);
var toLength = __webpack_require__(27);
var createProperty = __webpack_require__(211);
var getIterFn = __webpack_require__(233);

$export($export.S + $export.F * !__webpack_require__(165)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $indexOf = __webpack_require__(160)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(65)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(9);

$export($export.S, 'Array', { isArray: __webpack_require__(163) });


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(9);
var toIObject = __webpack_require__(58);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(134) != Object || !__webpack_require__(65)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toIObject = __webpack_require__(58);
var toInteger = __webpack_require__(66);
var toLength = __webpack_require__(27);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(65)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $map = __webpack_require__(71)(1);

$export($export.P + $export.F * !__webpack_require__(65)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var createProperty = __webpack_require__(211);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(17)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $reduce = __webpack_require__(344);

$export($export.P + $export.F * !__webpack_require__(65)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $reduce = __webpack_require__(344);

$export($export.P + $export.F * !__webpack_require__(65)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var html = __webpack_require__(215);
var cof = __webpack_require__(62);
var toAbsoluteIndex = __webpack_require__(103);
var toLength = __webpack_require__(27);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(17)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $some = __webpack_require__(71)(3);

$export($export.P + $export.F * !__webpack_require__(65)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var aFunction = __webpack_require__(43);
var toObject = __webpack_require__(33);
var fails = __webpack_require__(17);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(65)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(102)('Array');


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(9);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(9);
var toISOString = __webpack_require__(728);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(74);

$export($export.P + $export.F * __webpack_require__(17)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(25)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(47)(proto, TO_PRIMITIVE, __webpack_require__(729));


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(48)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(9);

$export($export.P, 'Function', { bind: __webpack_require__(345) });


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(20);
var getPrototypeOf = __webpack_require__(57);
var HAS_INSTANCE = __webpack_require__(25)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(31).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(31).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(29) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(9);
var log1p = __webpack_require__(356);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(9);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(9);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(9);
var sign = __webpack_require__(221);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(9);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(9);
var $expm1 = __webpack_require__(220);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', { fround: __webpack_require__(355) });


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(9);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(9);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(17)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', { log1p: __webpack_require__(356) });


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', { sign: __webpack_require__(221) });


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(9);
var expm1 = __webpack_require__(220);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(17)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(9);
var expm1 = __webpack_require__(220);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(16);
var has = __webpack_require__(55);
var cof = __webpack_require__(62);
var inheritIfRequired = __webpack_require__(216);
var toPrimitive = __webpack_require__(74);
var fails = __webpack_require__(17);
var gOPN = __webpack_require__(98).f;
var gOPD = __webpack_require__(56).f;
var dP = __webpack_require__(31).f;
var $trim = __webpack_require__(118).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(97)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(29) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(48)(global, NUMBER, $Number);
}


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(9);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(9);
var _isFinite = __webpack_require__(16).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(9);

$export($export.S, 'Number', { isInteger: __webpack_require__(352) });


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(9);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(9);
var isInteger = __webpack_require__(352);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(9);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(9);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $parseFloat = __webpack_require__(364);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $parseInt = __webpack_require__(365);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toInteger = __webpack_require__(66);
var aNumberValue = __webpack_require__(341);
var repeat = __webpack_require__(228);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(17)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $fails = __webpack_require__(17);
var aNumberValue = __webpack_require__(341);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(9);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(358) });


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(97) });


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(29), 'Object', { defineProperties: __webpack_require__(359) });


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(29), 'Object', { defineProperty: __webpack_require__(31).f });


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(88).onFreeze;

__webpack_require__(73)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(58);
var $getOwnPropertyDescriptor = __webpack_require__(56).f;

__webpack_require__(73)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(73)('getOwnPropertyNames', function () {
  return __webpack_require__(360).f;
});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(33);
var $getPrototypeOf = __webpack_require__(57);

__webpack_require__(73)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(20);

__webpack_require__(73)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(20);

__webpack_require__(73)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(20);

__webpack_require__(73)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(9);
$export($export.S, 'Object', { is: __webpack_require__(368) });


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(33);
var $keys = __webpack_require__(99);

__webpack_require__(73)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(88).onFreeze;

__webpack_require__(73)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(88).onFreeze;

__webpack_require__(73)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(9);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(225).set });


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(115);
var test = {};
test[__webpack_require__(25)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(48)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $parseFloat = __webpack_require__(364);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $parseInt = __webpack_require__(365);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(87);
var global = __webpack_require__(16);
var ctx = __webpack_require__(64);
var classof = __webpack_require__(115);
var $export = __webpack_require__(9);
var isObject = __webpack_require__(20);
var aFunction = __webpack_require__(43);
var anInstance = __webpack_require__(95);
var forOf = __webpack_require__(96);
var speciesConstructor = __webpack_require__(137);
var task = __webpack_require__(230).set;
var microtask = __webpack_require__(222)();
var newPromiseCapabilityModule = __webpack_require__(223);
var perform = __webpack_require__(366);
var userAgent = __webpack_require__(173);
var promiseResolve = __webpack_require__(367);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(25)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(101)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(117)($Promise, PROMISE);
__webpack_require__(102)(PROMISE);
Wrapper = __webpack_require__(63)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(165)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(9);
var aFunction = __webpack_require__(43);
var anObject = __webpack_require__(11);
var rApply = (__webpack_require__(16).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(17)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(9);
var create = __webpack_require__(97);
var aFunction = __webpack_require__(43);
var anObject = __webpack_require__(11);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(17);
var bind = __webpack_require__(345);
var rConstruct = (__webpack_require__(16).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(31);
var $export = __webpack_require__(9);
var anObject = __webpack_require__(11);
var toPrimitive = __webpack_require__(74);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(17)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(9);
var gOPD = __webpack_require__(56).f;
var anObject = __webpack_require__(11);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(9);
var anObject = __webpack_require__(11);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(218)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(56);
var $export = __webpack_require__(9);
var anObject = __webpack_require__(11);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(9);
var getProto = __webpack_require__(57);
var anObject = __webpack_require__(11);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(56);
var getPrototypeOf = __webpack_require__(57);
var has = __webpack_require__(55);
var $export = __webpack_require__(9);
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(11);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(9);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(9);
var anObject = __webpack_require__(11);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(9);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(363) });


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(9);
var anObject = __webpack_require__(11);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(9);
var setProto = __webpack_require__(225);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(31);
var gOPD = __webpack_require__(56);
var getPrototypeOf = __webpack_require__(57);
var has = __webpack_require__(55);
var $export = __webpack_require__(9);
var createDesc = __webpack_require__(100);
var anObject = __webpack_require__(11);
var isObject = __webpack_require__(20);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(16);
var inheritIfRequired = __webpack_require__(216);
var dP = __webpack_require__(31).f;
var gOPN = __webpack_require__(98).f;
var isRegExp = __webpack_require__(164);
var $flags = __webpack_require__(133);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(29) && (!CORRECT_NEW || __webpack_require__(17)(function () {
  re2[__webpack_require__(25)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(48)(global, 'RegExp', $RegExp);
}

__webpack_require__(102)('RegExp');


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(11);
var toLength = __webpack_require__(27);
var advanceStringIndex = __webpack_require__(208);
var regExpExec = __webpack_require__(168);

// @@match logic
__webpack_require__(162)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(11);
var toObject = __webpack_require__(33);
var toLength = __webpack_require__(27);
var toInteger = __webpack_require__(66);
var advanceStringIndex = __webpack_require__(208);
var regExpExec = __webpack_require__(168);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(162)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(11);
var sameValue = __webpack_require__(368);
var regExpExec = __webpack_require__(168);

// @@search logic
__webpack_require__(162)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(164);
var anObject = __webpack_require__(11);
var speciesConstructor = __webpack_require__(137);
var advanceStringIndex = __webpack_require__(208);
var toLength = __webpack_require__(27);
var callRegExpExec = __webpack_require__(168);
var regexpExec = __webpack_require__(224);
var fails = __webpack_require__(17);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(162)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(374);
var anObject = __webpack_require__(11);
var $flags = __webpack_require__(133);
var DESCRIPTORS = __webpack_require__(29);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(48)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(17)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(49)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(49)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(49)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(49)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $at = __webpack_require__(171)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(9);
var toLength = __webpack_require__(27);
var context = __webpack_require__(227);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(214)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(49)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(49)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(49)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(103);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(9);
var context = __webpack_require__(227);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(214)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(49)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(171)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(219)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(49)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var toIObject = __webpack_require__(58);
var toLength = __webpack_require__(27);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(228)
});


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(49)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(9);
var toLength = __webpack_require__(27);
var context = __webpack_require__(227);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(214)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(49)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(49)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(49)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(118)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(16);
var has = __webpack_require__(55);
var DESCRIPTORS = __webpack_require__(29);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(48);
var META = __webpack_require__(88).KEY;
var $fails = __webpack_require__(17);
var shared = __webpack_require__(136);
var setToStringTag = __webpack_require__(117);
var uid = __webpack_require__(104);
var wks = __webpack_require__(25);
var wksExt = __webpack_require__(371);
var wksDefine = __webpack_require__(232);
var enumKeys = __webpack_require__(730);
var isArray = __webpack_require__(163);
var anObject = __webpack_require__(11);
var isObject = __webpack_require__(20);
var toObject = __webpack_require__(33);
var toIObject = __webpack_require__(58);
var toPrimitive = __webpack_require__(74);
var createDesc = __webpack_require__(100);
var _create = __webpack_require__(97);
var gOPNExt = __webpack_require__(360);
var $GOPD = __webpack_require__(56);
var $GOPS = __webpack_require__(167);
var $DP = __webpack_require__(31);
var $keys = __webpack_require__(99);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(98).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(135).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(87)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(47)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $typed = __webpack_require__(172);
var buffer = __webpack_require__(231);
var anObject = __webpack_require__(11);
var toAbsoluteIndex = __webpack_require__(103);
var toLength = __webpack_require__(27);
var isObject = __webpack_require__(20);
var ArrayBuffer = __webpack_require__(16).ArrayBuffer;
var speciesConstructor = __webpack_require__(137);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(17)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(102)(ARRAY_BUFFER);


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
$export($export.G + $export.W + $export.F * !__webpack_require__(172).ABV, {
  DataView: __webpack_require__(231).DataView
});


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(348);
var validate = __webpack_require__(105);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(161)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(9);
var flattenIntoArray = __webpack_require__(349);
var toObject = __webpack_require__(33);
var toLength = __webpack_require__(27);
var aFunction = __webpack_require__(43);
var arraySpeciesCreate = __webpack_require__(210);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(86)('flatMap');


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(9);
var flattenIntoArray = __webpack_require__(349);
var toObject = __webpack_require__(33);
var toLength = __webpack_require__(27);
var toInteger = __webpack_require__(66);
var arraySpeciesCreate = __webpack_require__(210);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(86)('flatten');


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(9);
var $includes = __webpack_require__(160)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(86)('includes');


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(9);
var microtask = __webpack_require__(222)();
var process = __webpack_require__(16).process;
var isNode = __webpack_require__(62)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(9);
var cof = __webpack_require__(62);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(9);

$export($export.G, { global: __webpack_require__(16) });


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(169)('Map');


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(170)('Map');


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(9);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(347)('Map') });


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);
var scale = __webpack_require__(357);
var fround = __webpack_require__(355);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);

$export($export.S, 'Math', { scale: __webpack_require__(357) });


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(9);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toObject = __webpack_require__(33);
var aFunction = __webpack_require__(43);
var $defineProperty = __webpack_require__(31);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(29) && $export($export.P + __webpack_require__(166), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toObject = __webpack_require__(33);
var aFunction = __webpack_require__(43);
var $defineProperty = __webpack_require__(31);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(29) && $export($export.P + __webpack_require__(166), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(9);
var $entries = __webpack_require__(362)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(9);
var ownKeys = __webpack_require__(363);
var toIObject = __webpack_require__(58);
var gOPD = __webpack_require__(56);
var createProperty = __webpack_require__(211);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(74);
var getPrototypeOf = __webpack_require__(57);
var getOwnPropertyDescriptor = __webpack_require__(56).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(29) && $export($export.P + __webpack_require__(166), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(74);
var getPrototypeOf = __webpack_require__(57);
var getOwnPropertyDescriptor = __webpack_require__(56).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(29) && $export($export.P + __webpack_require__(166), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(9);
var $values = __webpack_require__(362)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(9);
var global = __webpack_require__(16);
var core = __webpack_require__(63);
var microtask = __webpack_require__(222)();
var OBSERVABLE = __webpack_require__(25)('observable');
var aFunction = __webpack_require__(43);
var anObject = __webpack_require__(11);
var anInstance = __webpack_require__(95);
var redefineAll = __webpack_require__(101);
var hide = __webpack_require__(47);
var forOf = __webpack_require__(96);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(102)('Observable');


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(9);
var core = __webpack_require__(63);
var global = __webpack_require__(16);
var speciesConstructor = __webpack_require__(137);
var promiseResolve = __webpack_require__(367);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(9);
var newPromiseCapability = __webpack_require__(223);
var perform = __webpack_require__(366);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(78);
var anObject = __webpack_require__(11);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(78);
var anObject = __webpack_require__(11);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(375);
var from = __webpack_require__(343);
var metadata = __webpack_require__(78);
var anObject = __webpack_require__(11);
var getPrototypeOf = __webpack_require__(57);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(78);
var anObject = __webpack_require__(11);
var getPrototypeOf = __webpack_require__(57);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(78);
var anObject = __webpack_require__(11);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(78);
var anObject = __webpack_require__(11);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(78);
var anObject = __webpack_require__(11);
var getPrototypeOf = __webpack_require__(57);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(78);
var anObject = __webpack_require__(11);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(78);
var anObject = __webpack_require__(11);
var aFunction = __webpack_require__(43);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(169)('Set');


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(170)('Set');


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(9);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(347)('Set') });


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(9);
var $at = __webpack_require__(171)(true);
var $fails = __webpack_require__(17);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(9);
var defined = __webpack_require__(72);
var toLength = __webpack_require__(27);
var isRegExp = __webpack_require__(164);
var getFlags = __webpack_require__(133);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(218)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(9);
var $pad = __webpack_require__(369);
var userAgent = __webpack_require__(173);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(9);
var $pad = __webpack_require__(369);
var userAgent = __webpack_require__(173);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(118)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(118)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(232)('asyncIterator');


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(232)('observable');


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(9);

$export($export.S, 'System', { global: __webpack_require__(16) });


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(169)('WeakMap');


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(170)('WeakMap');


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(169)('WeakSet');


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(170)('WeakSet');


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(234);
var getKeys = __webpack_require__(99);
var redefine = __webpack_require__(48);
var global = __webpack_require__(16);
var hide = __webpack_require__(47);
var Iterators = __webpack_require__(116);
var wks = __webpack_require__(25);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $task = __webpack_require__(230);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(16);
var $export = __webpack_require__(9);
var userAgent = __webpack_require__(173);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(853);
__webpack_require__(792);
__webpack_require__(794);
__webpack_require__(793);
__webpack_require__(796);
__webpack_require__(798);
__webpack_require__(803);
__webpack_require__(797);
__webpack_require__(795);
__webpack_require__(805);
__webpack_require__(804);
__webpack_require__(800);
__webpack_require__(801);
__webpack_require__(799);
__webpack_require__(791);
__webpack_require__(802);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(759);
__webpack_require__(761);
__webpack_require__(760);
__webpack_require__(809);
__webpack_require__(808);
__webpack_require__(779);
__webpack_require__(789);
__webpack_require__(790);
__webpack_require__(780);
__webpack_require__(781);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(784);
__webpack_require__(785);
__webpack_require__(786);
__webpack_require__(787);
__webpack_require__(788);
__webpack_require__(762);
__webpack_require__(763);
__webpack_require__(764);
__webpack_require__(765);
__webpack_require__(766);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(769);
__webpack_require__(770);
__webpack_require__(771);
__webpack_require__(772);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(775);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(840);
__webpack_require__(845);
__webpack_require__(852);
__webpack_require__(843);
__webpack_require__(835);
__webpack_require__(836);
__webpack_require__(841);
__webpack_require__(846);
__webpack_require__(848);
__webpack_require__(831);
__webpack_require__(832);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(839);
__webpack_require__(842);
__webpack_require__(844);
__webpack_require__(847);
__webpack_require__(849);
__webpack_require__(850);
__webpack_require__(851);
__webpack_require__(754);
__webpack_require__(756);
__webpack_require__(755);
__webpack_require__(758);
__webpack_require__(757);
__webpack_require__(743);
__webpack_require__(741);
__webpack_require__(747);
__webpack_require__(744);
__webpack_require__(750);
__webpack_require__(752);
__webpack_require__(740);
__webpack_require__(746);
__webpack_require__(737);
__webpack_require__(751);
__webpack_require__(735);
__webpack_require__(749);
__webpack_require__(748);
__webpack_require__(742);
__webpack_require__(745);
__webpack_require__(734);
__webpack_require__(736);
__webpack_require__(739);
__webpack_require__(738);
__webpack_require__(753);
__webpack_require__(234);
__webpack_require__(825);
__webpack_require__(373);
__webpack_require__(830);
__webpack_require__(374);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(829);
__webpack_require__(810);
__webpack_require__(372);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(865);
__webpack_require__(854);
__webpack_require__(855);
__webpack_require__(860);
__webpack_require__(863);
__webpack_require__(864);
__webpack_require__(858);
__webpack_require__(861);
__webpack_require__(859);
__webpack_require__(862);
__webpack_require__(856);
__webpack_require__(857);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
__webpack_require__(815);
__webpack_require__(818);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(821);
__webpack_require__(822);
__webpack_require__(824);
__webpack_require__(823);
__webpack_require__(868);
__webpack_require__(866);
__webpack_require__(867);
__webpack_require__(909);
__webpack_require__(912);
__webpack_require__(911);
__webpack_require__(913);
__webpack_require__(914);
__webpack_require__(910);
__webpack_require__(915);
__webpack_require__(916);
__webpack_require__(890);
__webpack_require__(893);
__webpack_require__(889);
__webpack_require__(887);
__webpack_require__(888);
__webpack_require__(891);
__webpack_require__(892);
__webpack_require__(874);
__webpack_require__(908);
__webpack_require__(873);
__webpack_require__(907);
__webpack_require__(919);
__webpack_require__(921);
__webpack_require__(872);
__webpack_require__(906);
__webpack_require__(918);
__webpack_require__(920);
__webpack_require__(871);
__webpack_require__(917);
__webpack_require__(870);
__webpack_require__(875);
__webpack_require__(876);
__webpack_require__(877);
__webpack_require__(878);
__webpack_require__(879);
__webpack_require__(881);
__webpack_require__(880);
__webpack_require__(882);
__webpack_require__(883);
__webpack_require__(884);
__webpack_require__(886);
__webpack_require__(885);
__webpack_require__(895);
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(898);
__webpack_require__(900);
__webpack_require__(899);
__webpack_require__(902);
__webpack_require__(901);
__webpack_require__(903);
__webpack_require__(904);
__webpack_require__(905);
__webpack_require__(869);
__webpack_require__(894);
__webpack_require__(924);
__webpack_require__(923);
__webpack_require__(922);
module.exports = __webpack_require__(63);


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "/* Marker setup */\n.awesome-number-marker {\n  background: url(" + __webpack_require__(1530) + ") no-repeat 0 0;\n  width: 35px;\n  height: 46px;\n  position:absolute;\n  left:0;\n  top:0;\n  display: block;\n  text-align: center;\n}\n\n.awesome-number-marker i {\n  color: #333;\n  margin-top: 10px;\n  display: inline-block;\n  font-size: 14px;\n}\n\n.awesome-number-marker .icon-white {\n  color: #fff;\n}\n\n/* Colors */\n.awesome-number-marker-icon-red {\n  background-position: 0 0;\n}\n\n.awesome-number-marker-icon-darkred {\n  background-position: -180px 0;\n}\n\n.awesome-number-marker-icon-lightred {\n  background-position: -360px 0;\n}\n\n.awesome-number-marker-icon-orange {\n  background-position: -36px 0;\n}\n\n.awesome-number-marker-icon-beige {\n  background-position: -396px 0;\n}\n\n.awesome-number-marker-icon-green {\n  background-position: -72px 0;\n}\n\n.awesome-number-marker-icon-darkgreen {\n  background-position: -252px 0;\n}\n\n.awesome-number-marker-icon-lightgreen {\n  background-position: -432px 0;\n}\n\n.awesome-number-marker-icon-blue {\n  background-position: -108px 0;\n}\n\n.awesome-number-marker-icon-darkblue {\n  background-position: -216px 0;\n}\n\n.awesome-number-marker-icon-lightblue {\n  background-position: -468px 0;\n}\n\n.awesome-number-marker-icon-purple {\n  background-position: -144px 0;\n}\n\n.awesome-number-marker-icon-darkpurple {\n  background-position: -288px 0;\n}\n\n.awesome-number-marker-icon-pink {\n  background-position: -504px 0;\n}\n\n.awesome-number-marker-icon-cadetblue {\n  background-position: -324px 0;\n}\n\n.awesome-number-marker-icon-white {\n  background-position: -574px 0;\n}\n\n.awesome-number-marker-icon-gray {\n  background-position: -648px 0;\n}\n\n.awesome-number-marker-icon-lightgray {\n  background-position: -612px 0;\n}\n\n.awesome-number-marker-icon-black {\n  background-position: -682px 0;\n}", ""]);

// exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "#loading-bar,#loading-bar-spinner{pointer-events:none;-webkit-pointer-events:none;-webkit-transition:350ms linear all;-moz-transition:350ms linear all;-o-transition:350ms linear all;transition:350ms linear all}#loading-bar-spinner.ng-enter,#loading-bar-spinner.ng-leave.ng-leave-active,#loading-bar.ng-enter,#loading-bar.ng-leave.ng-leave-active{opacity:0}#loading-bar-spinner.ng-enter.ng-enter-active,#loading-bar-spinner.ng-leave,#loading-bar.ng-enter.ng-enter-active,#loading-bar.ng-leave{opacity:1}#loading-bar .bar{-webkit-transition:width 350ms;-moz-transition:width 350ms;-o-transition:width 350ms;transition:width 350ms;background:#29d;position:fixed;z-index:10002;top:0;left:0;width:100%;height:2px;border-bottom-right-radius:1px;border-top-right-radius:1px}#loading-bar .peg{position:absolute;width:70px;right:0;top:0;height:2px;opacity:.45;-moz-box-shadow:#29d 1px 0 6px 1px;-ms-box-shadow:#29d 1px 0 6px 1px;-webkit-box-shadow:#29d 1px 0 6px 1px;box-shadow:#29d 1px 0 6px 1px;-moz-border-radius:100%;-webkit-border-radius:100%;border-radius:100%}#loading-bar-spinner{display:block;position:fixed;z-index:10002;top:10px;left:10px}#loading-bar-spinner .spinner-icon{width:14px;height:14px;border:2px solid transparent;border-top-color:#29d;border-left-color:#29d;border-radius:50%;-webkit-animation:loading-bar-spinner 400ms linear infinite;-moz-animation:loading-bar-spinner 400ms linear infinite;-ms-animation:loading-bar-spinner 400ms linear infinite;-o-animation:loading-bar-spinner 400ms linear infinite;animation:loading-bar-spinner 400ms linear infinite}@-webkit-keyframes loading-bar-spinner{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-moz-keyframes loading-bar-spinner{0%{-moz-transform:rotate(0);transform:rotate(0)}100%{-moz-transform:rotate(360deg);transform:rotate(360deg)}}@-o-keyframes loading-bar-spinner{0%{-o-transform:rotate(0);transform:rotate(0)}100%{-o-transform:rotate(360deg);transform:rotate(360deg)}}@-ms-keyframes loading-bar-spinner{0%{-ms-transform:rotate(0);transform:rotate(0)}100%{-ms-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes loading-bar-spinner{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}", ""]);

// exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "/*! Angular Moment Picker - v0.9.7 - http://indrimuska.github.io/angular-moment-picker - (c) 2015 Indri Muska - MIT */\n.moment-picker{position:relative;display:block}.moment-picker .moment-picker-input{cursor:pointer}.moment-picker .moment-picker-container{color:#404040;min-width:15em;background:#fff;padding:4px;border:1px solid #f0f3f4;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;top:100%;margin-top:4px;margin-left:-.5em;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.075);-moz-box-shadow:0 2px 4px rgba(0,0,0,.075);box-shadow:0 2px 4px rgba(0,0,0,.075);z-index:5}.moment-picker .moment-picker-container:after,.moment-picker .moment-picker-container:before{content:\"\";display:block;width:0;height:0;border:8px solid transparent;border-top:none;position:absolute;top:-9px;left:15px}.moment-picker .moment-picker-container:before{border-bottom-color:#f0f3f4;border-width:9px}.moment-picker .moment-picker-container:after{border-bottom-color:#fff;margin-top:1px;margin-left:1px}.moment-picker.top .moment-picker-container{top:auto;bottom:100%;margin-top:auto;margin-bottom:4px}.moment-picker.top .moment-picker-container:after,.moment-picker.top .moment-picker-container:before{border:8px solid transparent;border-bottom:none;top:auto;bottom:-9px}.moment-picker.top .moment-picker-container:before{border-top-color:#f0f3f4;border-width:9px}.moment-picker.top .moment-picker-container:after{border-top-color:#fff;margin-top:auto;margin-bottom:1px}.moment-picker.left .moment-picker-container{right:0;margin-left:auto;margin-right:-.5em}.moment-picker.left .moment-picker-container:after,.moment-picker.left .moment-picker-container:before{left:auto;right:15px}.moment-picker.left .moment-picker-container:after{margin-left:auto;margin-right:1px}.moment-picker table{border-collapse:collapse;border-spacing:0;min-width:100%;table-layout:fixed}.moment-picker th{font-weight:700}.moment-picker th:first-child,.moment-picker th:last-child{width:2em}.moment-picker td,.moment-picker th{padding:0;text-align:center;min-width:2em;height:2em;text-shadow:0 1px 0 hsla(0,0%,100%,.9);cursor:pointer;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.moment-picker td:hover,.moment-picker th:hover{background-color:#fafbfb;background-image:-webkit-gradient(linear,left top,left bottom,from(#f0f3f4),to(#fafbfb));background-image:-webkit-linear-gradient(#f0f3f4,#fafbfb);background-image:-moz-linear-gradient(#f0f3f4,#fafbfb);background-image:-o-linear-gradient(#f0f3f4,#fafbfb);background-image:linear-gradient(#f0f3f4,#fafbfb)}.moment-picker td.disabled,.moment-picker td.disabled:hover,.moment-picker th.disabled,.moment-picker th.disabled:hover{color:#abbbc7;background:none;cursor:default}.moment-picker td.today{background:#e4eef5;color:#404040;text-shadow:0 1px 0 hsla(0,0%,100%,.9)}.moment-picker td.selected{color:#fff;text-shadow:0 -1px 0 rgba(0,0,0,.3);border-color:#3ca0dd;background-color:#45b1e8;background-image:-webkit-gradient(linear,left top,left bottom,from(#45b1e8),to(#3097de));background-image:-webkit-linear-gradient(#45b1e8,#3097de);background-image:-moz-linear-gradient(#45b1e8,#3097de);background-image:-o-linear-gradient(#45b1e8,#3097de);background-image:linear-gradient(#45b1e8,#3097de)}.moment-picker td.highlighted{background-image:-webkit-radial-gradient(transparent,rgba(0,0,0,.15));background-image:-moz-radial-gradient(transparent,rgba(0,0,0,.15));background-image:-o-radial-gradient(transparent,rgba(0,0,0,.15));background-image:radial-gradient(transparent,rgba(0,0,0,.15))}.moment-picker .decade-view td,.moment-picker .year-view td{height:3.4em}.moment-picker .month-view .moment-picker-specific-views th{background:none;cursor:default}.moment-picker .month-view td{width:1.42857143em}.moment-picker .day-view td,.moment-picker .hour-view td{height:2.33333333em}.moment-picker .minute-view td{height:1.8em}", ""]);

// exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".datetimepicker-wrapper {\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.datetimepicker-wrapper > input {\n  margin-bottom: 0 !important;\n  width: 130px;\n}\n\n.datetimepicker-wrapper [ng-model=hours], \n.datetimepicker-wrapper [ng-model=minutes] {\n  width: 46px !important;\n}\n", ""]);

// exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".daterangepicker {\r\n  position: absolute;\r\n  color: inherit;\r\n  background: #fff;\r\n  border-radius: 4px;\r\n  width: 278px;\r\n  padding: 4px;\r\n  margin-top: 1px;\r\n  top: 100px;\r\n  left: 20px;\r\n  /* Calendars */ }\r\n  .daterangepicker:before, .daterangepicker:after {\r\n    position: absolute;\r\n    display: inline-block;\r\n    border-bottom-color: rgba(0, 0, 0, 0.2);\r\n    content: ''; }\r\n  .daterangepicker:before {\r\n    top: -7px;\r\n    border-right: 7px solid transparent;\r\n    border-left: 7px solid transparent;\r\n    border-bottom: 7px solid #ccc; }\r\n  .daterangepicker:after {\r\n    top: -6px;\r\n    border-right: 6px solid transparent;\r\n    border-bottom: 6px solid #fff;\r\n    border-left: 6px solid transparent; }\r\n  .daterangepicker.opensleft:before {\r\n    right: 9px; }\r\n  .daterangepicker.opensleft:after {\r\n    right: 10px; }\r\n  .daterangepicker.openscenter:before {\r\n    left: 0;\r\n    right: 0;\r\n    width: 0;\r\n    margin-left: auto;\r\n    margin-right: auto; }\r\n  .daterangepicker.openscenter:after {\r\n    left: 0;\r\n    right: 0;\r\n    width: 0;\r\n    margin-left: auto;\r\n    margin-right: auto; }\r\n  .daterangepicker.opensright:before {\r\n    left: 9px; }\r\n  .daterangepicker.opensright:after {\r\n    left: 10px; }\r\n  .daterangepicker.dropup {\r\n    margin-top: -5px; }\r\n    .daterangepicker.dropup:before {\r\n      top: initial;\r\n      bottom: -7px;\r\n      border-bottom: initial;\r\n      border-top: 7px solid #ccc; }\r\n    .daterangepicker.dropup:after {\r\n      top: initial;\r\n      bottom: -6px;\r\n      border-bottom: initial;\r\n      border-top: 6px solid #fff; }\r\n  .daterangepicker.dropdown-menu {\r\n    max-width: none;\r\n    z-index: 3001; }\r\n  .daterangepicker.single .ranges, .daterangepicker.single .calendar {\r\n    float: none; }\r\n  .daterangepicker.show-calendar .calendar {\r\n    display: block; }\r\n  .daterangepicker .calendar {\r\n    display: none;\r\n    max-width: 270px;\r\n    margin: 4px; }\r\n    .daterangepicker .calendar.single .calendar-table {\r\n      border: none; }\r\n    .daterangepicker .calendar th, .daterangepicker .calendar td {\r\n      white-space: nowrap;\r\n      text-align: center;\r\n      min-width: 32px; }\r\n  .daterangepicker .calendar-table {\r\n    border: 1px solid #fff;\r\n    padding: 4px;\r\n    border-radius: 4px;\r\n    background: #fff; }\r\n  .daterangepicker table {\r\n    width: 100%;\r\n    margin: 0; }\r\n  .daterangepicker td, .daterangepicker th {\r\n    text-align: center;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-radius: 4px;\r\n    border: 1px solid transparent;\r\n    white-space: nowrap;\r\n    cursor: pointer; }\r\n    .daterangepicker td.available:hover, .daterangepicker th.available:hover {\r\n      background-color: #eee;\r\n      border-color: transparent;\r\n      color: inherit; }\r\n    .daterangepicker td.week, .daterangepicker th.week {\r\n      font-size: 80%;\r\n      color: #ccc; }\r\n  .daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {\r\n    background-color: #fff;\r\n    border-color: transparent;\r\n    color: #999; }\r\n  .daterangepicker td.in-range {\r\n    background-color: #ebf4f8;\r\n    border-color: transparent;\r\n    color: #000;\r\n    border-radius: 0; }\r\n  .daterangepicker td.start-date {\r\n    border-radius: 4px 0 0 4px; }\r\n  .daterangepicker td.end-date {\r\n    border-radius: 0 4px 4px 0; }\r\n  .daterangepicker td.start-date.end-date {\r\n    border-radius: 4px; }\r\n  .daterangepicker td.active, .daterangepicker td.active:hover {\r\n    background-color: #357ebd;\r\n    border-color: transparent;\r\n    color: #fff; }\r\n  .daterangepicker th.month {\r\n    width: auto; }\r\n  .daterangepicker td.disabled, .daterangepicker option.disabled {\r\n    color: #999;\r\n    cursor: not-allowed;\r\n    text-decoration: line-through; }\r\n  .daterangepicker select.monthselect, .daterangepicker select.yearselect {\r\n    font-size: 12px;\r\n    padding: 1px;\r\n    height: auto;\r\n    margin: 0;\r\n    cursor: default; }\r\n  .daterangepicker select.monthselect {\r\n    margin-right: 2%;\r\n    width: 56%; }\r\n  .daterangepicker select.yearselect {\r\n    width: 40%; }\r\n  .daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect {\r\n    width: 50px;\r\n    margin-bottom: 0; }\r\n  .daterangepicker .input-mini {\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    color: #555;\r\n    height: 30px;\r\n    line-height: 30px;\r\n    display: block;\r\n    vertical-align: middle;\r\n    margin: 0 0 5px 0;\r\n    padding: 0 6px 0 28px;\r\n    width: 100%; }\r\n    .daterangepicker .input-mini.active {\r\n      border: 1px solid #08c;\r\n      border-radius: 4px; }\r\n  .daterangepicker .daterangepicker_input {\r\n    position: relative; }\r\n    .daterangepicker .daterangepicker_input i {\r\n      position: absolute;\r\n      left: 8px;\r\n      top: 8px; }\r\n  .daterangepicker.rtl .input-mini {\r\n    padding-right: 28px;\r\n    padding-left: 6px; }\r\n  .daterangepicker.rtl .daterangepicker_input i {\r\n    left: auto;\r\n    right: 8px; }\r\n  .daterangepicker .calendar-time {\r\n    text-align: center;\r\n    margin: 5px auto;\r\n    line-height: 30px;\r\n    position: relative;\r\n    padding-left: 28px; }\r\n    .daterangepicker .calendar-time select.disabled {\r\n      color: #ccc;\r\n      cursor: not-allowed; }\r\n\r\n.ranges {\r\n  font-size: 11px;\r\n  float: none;\r\n  margin: 4px;\r\n  text-align: left; }\r\n  .ranges ul {\r\n    list-style: none;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    width: 100%; }\r\n  .ranges li {\r\n    font-size: 13px;\r\n    background: #f5f5f5;\r\n    border: 1px solid #f5f5f5;\r\n    border-radius: 4px;\r\n    color: #08c;\r\n    padding: 3px 12px;\r\n    margin-bottom: 8px;\r\n    cursor: pointer; }\r\n    .ranges li:hover {\r\n      background: #08c;\r\n      border: 1px solid #08c;\r\n      color: #fff; }\r\n    .ranges li.active {\r\n      background: #08c;\r\n      border: 1px solid #08c;\r\n      color: #fff; }\r\n\r\n/*  Larger Screen Styling */\r\n@media (min-width: 564px) {\r\n  .daterangepicker {\r\n    width: auto; }\r\n    .daterangepicker .ranges ul {\r\n      width: 160px; }\r\n    .daterangepicker.single .ranges ul {\r\n      width: 100%; }\r\n    .daterangepicker.single .calendar.left {\r\n      clear: none; }\r\n    .daterangepicker.single.ltr .ranges, .daterangepicker.single.ltr .calendar {\r\n      float: left; }\r\n    .daterangepicker.single.rtl .ranges, .daterangepicker.single.rtl .calendar {\r\n      float: right; }\r\n    .daterangepicker.ltr {\r\n      direction: ltr;\r\n      text-align: left; }\r\n      .daterangepicker.ltr .calendar.left {\r\n        clear: left;\r\n        margin-right: 0; }\r\n        .daterangepicker.ltr .calendar.left .calendar-table {\r\n          border-right: none;\r\n          border-top-right-radius: 0;\r\n          border-bottom-right-radius: 0; }\r\n      .daterangepicker.ltr .calendar.right {\r\n        margin-left: 0; }\r\n        .daterangepicker.ltr .calendar.right .calendar-table {\r\n          border-left: none;\r\n          border-top-left-radius: 0;\r\n          border-bottom-left-radius: 0; }\r\n      .daterangepicker.ltr .left .daterangepicker_input {\r\n        padding-right: 12px; }\r\n      .daterangepicker.ltr .calendar.left .calendar-table {\r\n        padding-right: 12px; }\r\n      .daterangepicker.ltr .ranges, .daterangepicker.ltr .calendar {\r\n        float: left; }\r\n    .daterangepicker.rtl {\r\n      direction: rtl;\r\n      text-align: right; }\r\n      .daterangepicker.rtl .calendar.left {\r\n        clear: right;\r\n        margin-left: 0; }\r\n        .daterangepicker.rtl .calendar.left .calendar-table {\r\n          border-left: none;\r\n          border-top-left-radius: 0;\r\n          border-bottom-left-radius: 0; }\r\n      .daterangepicker.rtl .calendar.right {\r\n        margin-right: 0; }\r\n        .daterangepicker.rtl .calendar.right .calendar-table {\r\n          border-right: none;\r\n          border-top-right-radius: 0;\r\n          border-bottom-right-radius: 0; }\r\n      .daterangepicker.rtl .left .daterangepicker_input {\r\n        padding-left: 12px; }\r\n      .daterangepicker.rtl .calendar.left .calendar-table {\r\n        padding-left: 12px; }\r\n      .daterangepicker.rtl .ranges, .daterangepicker.rtl .calendar {\r\n        text-align: right;\r\n        float: right; } }\r\n@media (min-width: 730px) {\r\n  .daterangepicker .ranges {\r\n    width: auto; }\r\n  .daterangepicker.ltr .ranges {\r\n    float: left; }\r\n  .daterangepicker.rtl .ranges {\r\n    float: right; }\r\n  .daterangepicker .calendar.left {\r\n    clear: none !important; } }\r\n", ""]);

// exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@font-face{font-family:Karla,sans-serif;src:url(https://fonts.googleapis.com/css?family=Karla) format(\"opentype\");font-weight:300}.britechart{font-family:Karla,sans-serif;-webkit-font-smoothing:antialiased}.select-disable{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.bar-load-state .chart-filter,.donut-load-state .chart-filter,.line-load-state .chart-filter,.stacked-area-load-state .chart-filter{will-change:transform;animation:swipe 1.5s linear infinite forwards}@keyframes swipe{from{transform:translateX(-100%)}to{transform:translateX(100%)}}.horizontal-grid-line,.vertical-grid-line{fill:none;shape-rendering:crispEdges;stroke:#eff2f5;stroke-width:1;stroke-dasharray:4,4}.horizontal-grid-line--highlighted{stroke:#45494e;stroke-dasharray:2,2}.extended-x-line,.extended-y-line{fill:none;shape-rendering:crispEdges;stroke:#d2d6df;stroke-width:1}.tick line{fill:none;stroke:#adb0b6;stroke-width:1;shape-rendering:crispEdges}.tick text{font-size:1rem;fill:#666a73;padding:12px}.x-axis-label,.y-axis-label{font-size:1rem;fill:#adb0b6}.vertical-marker-container .vertical-marker{stroke:#d2d6df;stroke-width:1;fill:none}.vertical-marker-container .data-point-highlighter{fill:#fff;stroke-width:2}.tooltip-background{fill:rgba(255,255,255,.97);stroke:#d2d6df;stroke-width:1;border-radius:2px}.britechart-legend .legend-entry.is-faded .legend-circle,.britechart-legend .legend-entry.is-faded .legend-entry-name,.britechart-legend .legend-entry.is-faded .legend-entry-value{opacity:.97;transition:opacity .2s ease-out;-moz-transition:opacity .2s ease-out;-webkit-transition:opacity .2s ease-out}.britechart-legend .legend-entry.is-faded .legend-circle,.britechart-legend .legend-entry.is-faded .legend-entry-name,.britechart-legend .legend-entry.is-faded .legend-entry-value{opacity:.2}.bar-chart .bar{shape-rendering:crispEdges}.bar-chart .y-axis-group .tick text{font-size:14px}.bar-chart .axis path{display:none}.bar-chart .tick line{display:none}.bar-chart .adjust-upwards{transform:translate(0,-10px)}.bar-chart .percentage-label{fill:#666a73}.line-chart .data-point-mark{fill:#fff}.line-chart .topic .line{stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.line-chart .x.axis path,.line-chart .y.axis path{display:none}.line-chart .month-axis path{display:none}.line-chart .custom-line{shape-rendering:crispEdges;stroke-width:1}.line-chart .custom-line-annotation{font-size:.75rem;line-height:.75rem;fill:#666a73}.line-chart .masking-rectangle{fill:#fff}.scatter-plot .y-axis-group .tick line{display:none}.scatter-plot .y-axis-group .axis path{display:none}.scatter-plot .x.axis path{display:none}.scatter-plot .data-point-highlighter{stroke-width:1.2}.sparkline{stroke:#adb0b6;stroke-width:1;stroke-linecap:round;stroke-linejoin:round}.sparkline .line{stroke-width:2}.sparkline .sparkline-circle{fill:#ff584c;stroke-width:0;display:none}.sparkline .sparkline-area{stroke:none}.stacked-area .dot{display:none}.stacked-area .y-axis-group path{display:none}.stacked-area .x-axis-group path{display:none}.stacked-area .area-outline{shape-rendering:geometricPrecision;stroke-width:1.2}.stacked-area .data-point-highlighter{stroke-width:1.2}.stacked-area .empty-data-line{stroke-width:2px;stroke-linecap:round}.stacked-bar .x-axis-group path,.stacked-bar .y-axis-group path{display:none}.stacked-bar .y-axis-group .tick text{font-size:14px}.stacked-bar .tick line{display:none}.grouped-bar .x-axis-group path,.grouped-bar .y-axis-group path{display:none}.grouped-bar .y-axis-group .tick text{font-size:14px}.grouped-bar .tick line{display:none}.step-chart .step{fill:#8fdad8;stroke-width:0;shape-rendering:crispEdges}.step-chart .step:hover{fill:#39c2c9}.step-chart .axis path{display:none}.step-chart .tick line{display:none}.brush-chart .brush-area{fill:#eff2f5}.brush-chart rect.brush-rect.selection{fill-opacity:.08;stroke-linejoin:round}.brush-chart rect.brush-rect.handle{fill:#00d8d2;width:.2rem}.brush-chart .axis path{display:none}.bullet-chart .marker-line{shape-rendering:crispEdges}.bullet-chart .axis-group path{display:none}.bullet-chart .bullet-title{font-size:16px}", ""]);

// exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "/*!\n * FullCalendar v3.8.2\n * Docs & License: https://fullcalendar.io/\n * (c) 2018 Adam Shaw\n */\n.fc {\n  direction: ltr;\n  text-align: left; }\n\n.fc-rtl {\n  text-align: right; }\n\nbody .fc {\n  /* extra precedence to overcome jqui */\n  font-size: 1em; }\n\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n.fc-highlight {\n  /* when user is selecting cells */\n  background: #bce8f1;\n  opacity: .3; }\n\n.fc-bgevent {\n  /* default look for background events */\n  background: #8fdf82;\n  opacity: .3; }\n\n.fc-nonbusiness {\n  /* default look for non-business-hours areas */\n  /* will inherit .fc-bgevent's styles */\n  background: #d7d7d7; }\n\n/* Buttons (styled <button> tags, normalized to work cross-browser)\n--------------------------------------------------------------------------------------------------*/\n.fc button {\n  /* force height to include the border and padding */\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  /* dimensions */\n  margin: 0;\n  height: 2.1em;\n  padding: 0 .6em;\n  /* text & cursor */\n  font-size: 1em;\n  /* normalize */\n  white-space: nowrap;\n  cursor: pointer; }\n\n/* Firefox has an annoying inner border */\n.fc button::-moz-focus-inner {\n  margin: 0;\n  padding: 0; }\n\n.fc-state-default {\n  /* non-theme */\n  border: 1px solid; }\n\n.fc-state-default.fc-corner-left {\n  /* non-theme */\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px; }\n\n.fc-state-default.fc-corner-right {\n  /* non-theme */\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px; }\n\n/* icons in buttons */\n.fc button .fc-icon {\n  /* non-theme */\n  position: relative;\n  top: -0.05em;\n  /* seems to be a good adjustment across browsers */\n  margin: 0 .2em;\n  vertical-align: middle; }\n\n/*\n  button states\n  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)\n*/\n.fc-state-default {\n  background-color: #f5f5f5;\n  background-image: -moz-linear-gradient(top, #ffffff, #e6e6e6);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#ffffff), to(#e6e6e6));\n  background-image: -webkit-linear-gradient(top, #ffffff, #e6e6e6);\n  background-image: -o-linear-gradient(top, #ffffff, #e6e6e6);\n  background-image: linear-gradient(to bottom, #ffffff, #e6e6e6);\n  background-repeat: repeat-x;\n  border-color: #e6e6e6 #e6e6e6 #bfbfbf;\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  color: #333;\n  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05); }\n\n.fc-state-hover,\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n  color: #333333;\n  background-color: #e6e6e6; }\n\n.fc-state-hover {\n  color: #333333;\n  text-decoration: none;\n  background-position: 0 -15px;\n  -webkit-transition: background-position 0.1s linear;\n  -moz-transition: background-position 0.1s linear;\n  -o-transition: background-position 0.1s linear;\n  transition: background-position 0.1s linear; }\n\n.fc-state-down,\n.fc-state-active {\n  background-color: #cccccc;\n  background-image: none;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05); }\n\n.fc-state-disabled {\n  cursor: default;\n  background-image: none;\n  opacity: 0.65;\n  box-shadow: none; }\n\n/* Buttons Groups\n--------------------------------------------------------------------------------------------------*/\n.fc-button-group {\n  display: inline-block; }\n\n/*\nevery button that is not first in a button group should scootch over one pixel and cover the\nprevious button's border...\n*/\n.fc .fc-button-group > * {\n  /* extra precedence b/c buttons have margin set to zero */\n  float: left;\n  margin: 0 0 0 -1px; }\n\n.fc .fc-button-group > :first-child {\n  /* same */\n  margin-left: 0; }\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-popover {\n  position: absolute;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15); }\n\n.fc-popover .fc-header {\n  /* TODO: be more consistent with fc-head/fc-body */\n  padding: 2px 4px; }\n\n.fc-popover .fc-header .fc-title {\n  margin: 0 2px; }\n\n.fc-popover .fc-header .fc-close {\n  cursor: pointer; }\n\n.fc-ltr .fc-popover .fc-header .fc-title,\n.fc-rtl .fc-popover .fc-header .fc-close {\n  float: left; }\n\n.fc-rtl .fc-popover .fc-header .fc-title,\n.fc-ltr .fc-popover .fc-header .fc-close {\n  float: right; }\n\n/* Misc Reusable Components\n--------------------------------------------------------------------------------------------------*/\n.fc-divider {\n  border-style: solid;\n  border-width: 1px; }\n\nhr.fc-divider {\n  height: 0;\n  margin: 0;\n  padding: 0 0 2px;\n  /* height is unreliable across browsers, so use padding */\n  border-width: 1px 0; }\n\n.fc-clear {\n  clear: both; }\n\n.fc-bg,\n.fc-bgevent-skeleton,\n.fc-highlight-skeleton,\n.fc-helper-skeleton {\n  /* these element should always cling to top-left/right corners */\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0; }\n\n.fc-bg {\n  bottom: 0;\n  /* strech bg to bottom edge */ }\n\n.fc-bg table {\n  height: 100%;\n  /* strech bg to bottom edge */ }\n\n/* Tables\n--------------------------------------------------------------------------------------------------*/\n.fc table {\n  width: 100%;\n  box-sizing: border-box;\n  /* fix scrollbar issue in firefox */\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n  font-size: 1em;\n  /* normalize cross-browser */ }\n\n.fc th {\n  text-align: center; }\n\n.fc th,\n.fc td {\n  border-style: solid;\n  border-width: 1px;\n  padding: 0;\n  vertical-align: top; }\n\n.fc td.fc-today {\n  border-style: double;\n  /* overcome neighboring borders */ }\n\n/* Internal Nav Links\n--------------------------------------------------------------------------------------------------*/\na[data-goto] {\n  cursor: pointer; }\n\na[data-goto]:hover {\n  text-decoration: underline; }\n\n/* Fake Table Rows\n--------------------------------------------------------------------------------------------------*/\n.fc .fc-row {\n  /* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */\n  /* no visible border by default. but make available if need be (scrollbar width compensation) */\n  border-style: solid;\n  border-width: 0; }\n\n.fc-row table {\n  /* don't put left/right border on anything within a fake row.\n     the outer tbody will worry about this */\n  border-left: 0 hidden transparent;\n  border-right: 0 hidden transparent;\n  /* no bottom borders on rows */\n  border-bottom: 0 hidden transparent; }\n\n.fc-row:first-child table {\n  border-top: 0 hidden transparent;\n  /* no top border on first row */ }\n\n/* Day Row (used within the header and the DayGrid)\n--------------------------------------------------------------------------------------------------*/\n.fc-row {\n  position: relative; }\n\n.fc-row .fc-bg {\n  z-index: 1; }\n\n/* highlighting cells & background event skeleton */\n.fc-row .fc-bgevent-skeleton,\n.fc-row .fc-highlight-skeleton {\n  bottom: 0;\n  /* stretch skeleton to bottom of row */ }\n\n.fc-row .fc-bgevent-skeleton table,\n.fc-row .fc-highlight-skeleton table {\n  height: 100%;\n  /* stretch skeleton to bottom of row */ }\n\n.fc-row .fc-highlight-skeleton td,\n.fc-row .fc-bgevent-skeleton td {\n  border-color: transparent; }\n\n.fc-row .fc-bgevent-skeleton {\n  z-index: 2; }\n\n.fc-row .fc-highlight-skeleton {\n  z-index: 3; }\n\n/*\nrow content (which contains day/week numbers and events) as well as \"helper\" (which contains\ntemporary rendered events).\n*/\n.fc-row .fc-content-skeleton {\n  position: relative;\n  z-index: 4;\n  padding-bottom: 2px;\n  /* matches the space above the events */ }\n\n.fc-row .fc-helper-skeleton {\n  z-index: 5; }\n\n.fc .fc-row .fc-content-skeleton table,\n.fc .fc-row .fc-content-skeleton td,\n.fc .fc-row .fc-helper-skeleton td {\n  /* see-through to the background below */\n  /* extra precedence to prevent theme-provided backgrounds */\n  background: none;\n  /* in case <td>s are globally styled */\n  border-color: transparent; }\n\n.fc-row .fc-content-skeleton td,\n.fc-row .fc-helper-skeleton td {\n  /* don't put a border between events and/or the day number */\n  border-bottom: 0; }\n\n.fc-row .fc-content-skeleton tbody td,\n.fc-row .fc-helper-skeleton tbody td {\n  /* don't put a border between event cells */\n  border-top: 0; }\n\n/* Scrolling Container\n--------------------------------------------------------------------------------------------------*/\n.fc-scroller {\n  -webkit-overflow-scrolling: touch; }\n\n/* TODO: move to agenda/basic */\n.fc-scroller > .fc-day-grid,\n.fc-scroller > .fc-time-grid {\n  position: relative;\n  /* re-scope all positions */\n  width: 100%;\n  /* hack to force re-sizing this inner element when scrollbars appear/disappear */ }\n\n/* Global Event Styles\n--------------------------------------------------------------------------------------------------*/\n.fc-event {\n  position: relative;\n  /* for resize handle and other inner positioning */\n  display: block;\n  /* make the <a> tag block */\n  font-size: .85em;\n  line-height: 1.3;\n  border-radius: 3px;\n  border: 1px solid #3a87ad;\n  /* default BORDER color */ }\n\n.fc-event,\n.fc-event-dot {\n  background-color: #3a87ad;\n  /* default BACKGROUND color */ }\n\n.fc-event,\n.fc-event:hover {\n  color: #fff;\n  /* default TEXT color */\n  text-decoration: none;\n  /* if <a> has an href */ }\n\n.fc-event[href],\n.fc-event.fc-draggable {\n  cursor: pointer;\n  /* give events with links and draggable events a hand mouse pointer */ }\n\n.fc-not-allowed,\n.fc-not-allowed .fc-event {\n  /* to override an event's custom cursor */\n  cursor: not-allowed; }\n\n.fc-event .fc-bg {\n  /* the generic .fc-bg already does position */\n  z-index: 1;\n  background: #fff;\n  opacity: .25; }\n\n.fc-event .fc-content {\n  position: relative;\n  z-index: 2; }\n\n/* resizer (cursor AND touch devices) */\n.fc-event .fc-resizer {\n  position: absolute;\n  z-index: 4; }\n\n/* resizer (touch devices) */\n.fc-event .fc-resizer {\n  display: none; }\n\n.fc-event.fc-allow-mouse-resize .fc-resizer,\n.fc-event.fc-selected .fc-resizer {\n  /* only show when hovering or selected (with touch) */\n  display: block; }\n\n/* hit area */\n.fc-event.fc-selected .fc-resizer:before {\n  /* 40x40 touch area */\n  content: \"\";\n  position: absolute;\n  z-index: 9999;\n  /* user of this util can scope within a lower z-index */\n  top: 50%;\n  left: 50%;\n  width: 40px;\n  height: 40px;\n  margin-left: -20px;\n  margin-top: -20px; }\n\n/* Event Selection (only for touch devices)\n--------------------------------------------------------------------------------------------------*/\n.fc-event.fc-selected {\n  z-index: 9999 !important;\n  /* overcomes inline z-index */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); }\n\n.fc-event.fc-selected.fc-dragging {\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3); }\n\n/* Horizontal Events\n--------------------------------------------------------------------------------------------------*/\n/* bigger touch area when selected */\n.fc-h-event.fc-selected:before {\n  content: \"\";\n  position: absolute;\n  z-index: 3;\n  /* below resizers */\n  top: -10px;\n  bottom: -10px;\n  left: 0;\n  right: 0; }\n\n/* events that are continuing to/from another week. kill rounded corners and butt up against edge */\n.fc-ltr .fc-h-event.fc-not-start,\n.fc-rtl .fc-h-event.fc-not-end {\n  margin-left: 0;\n  border-left-width: 0;\n  padding-left: 1px;\n  /* replace the border with padding */\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.fc-ltr .fc-h-event.fc-not-end,\n.fc-rtl .fc-h-event.fc-not-start {\n  margin-right: 0;\n  border-right-width: 0;\n  padding-right: 1px;\n  /* replace the border with padding */\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n\n/* resizer (cursor AND touch devices) */\n/* left resizer  */\n.fc-ltr .fc-h-event .fc-start-resizer,\n.fc-rtl .fc-h-event .fc-end-resizer {\n  cursor: w-resize;\n  left: -1px;\n  /* overcome border */ }\n\n/* right resizer */\n.fc-ltr .fc-h-event .fc-end-resizer,\n.fc-rtl .fc-h-event .fc-start-resizer {\n  cursor: e-resize;\n  right: -1px;\n  /* overcome border */ }\n\n/* resizer (mouse devices) */\n.fc-h-event.fc-allow-mouse-resize .fc-resizer {\n  width: 7px;\n  top: -1px;\n  /* overcome top border */\n  bottom: -1px;\n  /* overcome bottom border */ }\n\n/* resizer (touch devices) */\n.fc-h-event.fc-selected .fc-resizer {\n  /* 8x8 little dot */\n  border-radius: 4px;\n  border-width: 1px;\n  width: 6px;\n  height: 6px;\n  border-style: solid;\n  border-color: inherit;\n  background: #fff;\n  /* vertically center */\n  top: 50%;\n  margin-top: -4px; }\n\n/* left resizer  */\n.fc-ltr .fc-h-event.fc-selected .fc-start-resizer,\n.fc-rtl .fc-h-event.fc-selected .fc-end-resizer {\n  margin-left: -4px;\n  /* centers the 8x8 dot on the left edge */ }\n\n/* right resizer */\n.fc-ltr .fc-h-event.fc-selected .fc-end-resizer,\n.fc-rtl .fc-h-event.fc-selected .fc-start-resizer {\n  margin-right: -4px;\n  /* centers the 8x8 dot on the right edge */ }\n\n/* DayGrid events\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-day-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n.fc-day-grid-event {\n  margin: 1px 2px 0;\n  /* spacing between events and edges */\n  padding: 0 1px; }\n\ntr:first-child > td > .fc-day-grid-event {\n  margin-top: 2px;\n  /* a little bit more space before the first event */ }\n\n.fc-day-grid-event.fc-selected:after {\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n  /* same z-index as fc-bg, behind text */\n  /* overcome the borders */\n  top: -1px;\n  right: -1px;\n  bottom: -1px;\n  left: -1px;\n  /* darkening effect */\n  background: #000;\n  opacity: .25; }\n\n.fc-day-grid-event .fc-content {\n  /* force events to be one-line tall */\n  white-space: nowrap;\n  overflow: hidden; }\n\n.fc-day-grid-event .fc-time {\n  font-weight: bold; }\n\n/* resizer (cursor devices) */\n/* left resizer  */\n.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer,\n.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer {\n  margin-left: -2px;\n  /* to the day cell's edge */ }\n\n/* right resizer */\n.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer,\n.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer {\n  margin-right: -2px;\n  /* to the day cell's edge */ }\n\n/* Event Limiting\n--------------------------------------------------------------------------------------------------*/\n/* \"more\" link that represents hidden events */\na.fc-more {\n  margin: 1px 3px;\n  font-size: .85em;\n  cursor: pointer;\n  text-decoration: none; }\n\na.fc-more:hover {\n  text-decoration: underline; }\n\n.fc-limited {\n  /* rows and cells that are hidden because of a \"more\" link */\n  display: none; }\n\n/* popover that appears when \"more\" link is clicked */\n.fc-day-grid .fc-row {\n  z-index: 1;\n  /* make the \"more\" popover one higher than this */ }\n\n.fc-more-popover {\n  z-index: 2;\n  width: 220px; }\n\n.fc-more-popover .fc-event-container {\n  padding: 10px; }\n\n/* Now Indicator\n--------------------------------------------------------------------------------------------------*/\n.fc-now-indicator {\n  position: absolute;\n  border: 0 solid red; }\n\n/* Utilities\n--------------------------------------------------------------------------------------------------*/\n.fc-unselectable {\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent; }\n\n/*\nTODO: more distinction between this file and common.css\n*/\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-content,\n.fc-unthemed .fc-popover,\n.fc-unthemed .fc-list-view,\n.fc-unthemed .fc-list-heading td {\n  border-color: #ddd; }\n\n.fc-unthemed .fc-popover {\n  background-color: #fff; }\n\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-popover .fc-header,\n.fc-unthemed .fc-list-heading td {\n  background: #eee; }\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n  color: #666; }\n\n.fc-unthemed td.fc-today {\n  background: #fcf8e3; }\n\n.fc-unthemed .fc-disabled-day {\n  background: #d7d7d7;\n  opacity: .3; }\n\n/* Icons (inline elements with styled text that mock arrow icons)\n--------------------------------------------------------------------------------------------------*/\n.fc-icon {\n  display: inline-block;\n  height: 1em;\n  line-height: 1em;\n  font-size: 1em;\n  text-align: center;\n  overflow: hidden;\n  font-family: \"Courier New\", Courier, monospace;\n  /* don't allow browser text-selection */\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n/*\nAcceptable font-family overrides for individual icons:\n  \"Arial\", sans-serif\n  \"Times New Roman\", serif\n\nNOTE: use percentage font sizes or else old IE chokes\n*/\n.fc-icon:after {\n  position: relative; }\n\n.fc-icon-left-single-arrow:after {\n  content: \"\\2039\";\n  font-weight: bold;\n  font-size: 200%;\n  top: -7%; }\n\n.fc-icon-right-single-arrow:after {\n  content: \"\\203A\";\n  font-weight: bold;\n  font-size: 200%;\n  top: -7%; }\n\n.fc-icon-left-double-arrow:after {\n  content: \"\\AB\";\n  font-size: 160%;\n  top: -7%; }\n\n.fc-icon-right-double-arrow:after {\n  content: \"\\BB\";\n  font-size: 160%;\n  top: -7%; }\n\n.fc-icon-left-triangle:after {\n  content: \"\\25C4\";\n  font-size: 125%;\n  top: 3%; }\n\n.fc-icon-right-triangle:after {\n  content: \"\\25BA\";\n  font-size: 125%;\n  top: 3%; }\n\n.fc-icon-down-triangle:after {\n  content: \"\\25BC\";\n  font-size: 125%;\n  top: 2%; }\n\n.fc-icon-x:after {\n  content: \"\\D7\";\n  font-size: 200%;\n  top: 6%; }\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-unthemed .fc-popover {\n  border-width: 1px;\n  border-style: solid; }\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n  font-size: .9em;\n  margin-top: 2px; }\n\n/* List View\n--------------------------------------------------------------------------------------------------*/\n.fc-unthemed .fc-list-item:hover td {\n  background-color: #f5f5f5; }\n\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n.ui-widget .fc-disabled-day {\n  background-image: none; }\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-popover > .ui-widget-header + .ui-widget-content {\n  border-top: 0;\n  /* where they meet, let the header have the border */ }\n\n/* Global Event Styles\n--------------------------------------------------------------------------------------------------*/\n.ui-widget .fc-event {\n  /* overpower jqui's styles on <a> tags. TODO: more DRY */\n  color: #fff;\n  /* default TEXT color */\n  text-decoration: none;\n  /* if <a> has an href */\n  /* undo ui-widget-header bold */\n  font-weight: normal; }\n\n/* TimeGrid axis running down the side (for both the all-day area and the slot area)\n--------------------------------------------------------------------------------------------------*/\n.ui-widget td.fc-axis {\n  font-weight: normal;\n  /* overcome bold */ }\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-slats .ui-widget-content {\n  background: none;\n  /* see through to fc-bg */ }\n\n.fc.fc-bootstrap3 a {\n  text-decoration: none; }\n\n.fc.fc-bootstrap3 a[data-goto]:hover {\n  text-decoration: underline; }\n\n.fc-bootstrap3 hr.fc-divider {\n  border-color: inherit; }\n\n.fc-bootstrap3 .fc-today.alert {\n  border-radius: 0; }\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n.fc-bootstrap3 .fc-popover .panel-body {\n  padding: 0;\n  /* undo built-in padding */ }\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n.fc-bootstrap3 .fc-time-grid .fc-slats table {\n  /* some themes have background color. see through to slats */\n  background: none; }\n\n/* Toolbar\n--------------------------------------------------------------------------------------------------*/\n.fc-toolbar {\n  text-align: center; }\n\n.fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1em; }\n\n.fc-toolbar.fc-footer-toolbar {\n  margin-top: 1em; }\n\n.fc-toolbar .fc-left {\n  float: left; }\n\n.fc-toolbar .fc-right {\n  float: right; }\n\n.fc-toolbar .fc-center {\n  display: inline-block; }\n\n/* the things within each left/right/center section */\n.fc .fc-toolbar > * > * {\n  /* extra precedence to override button border margins */\n  float: left;\n  margin-left: .75em; }\n\n/* the first thing within each left/center/right section */\n.fc .fc-toolbar > * > :first-child {\n  /* extra precedence to override button border margins */\n  margin-left: 0; }\n\n/* title text */\n.fc-toolbar h2 {\n  margin: 0; }\n\n/* button layering (for border precedence) */\n.fc-toolbar button {\n  position: relative; }\n\n.fc-toolbar .fc-state-hover,\n.fc-toolbar .ui-state-hover {\n  z-index: 2; }\n\n.fc-toolbar .fc-state-down {\n  z-index: 3; }\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active {\n  z-index: 4; }\n\n.fc-toolbar button:focus {\n  z-index: 5; }\n\n/* View Structure\n--------------------------------------------------------------------------------------------------*/\n/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */\n/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */\n.fc-view-container *,\n.fc-view-container *:before,\n.fc-view-container *:after {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box; }\n\n.fc-view,\n.fc-view > table {\n  /* so dragged elements can be above the view's main element */\n  position: relative;\n  z-index: 1; }\n\n/* BasicView\n--------------------------------------------------------------------------------------------------*/\n/* day row structure */\n.fc-basicWeek-view .fc-content-skeleton,\n.fc-basicDay-view .fc-content-skeleton {\n  /* there may be week numbers in these views, so no padding-top */\n  padding-bottom: 1em;\n  /* ensure a space at bottom of cell for user selecting/clicking */ }\n\n.fc-basic-view .fc-body .fc-row {\n  min-height: 4em;\n  /* ensure that all rows are at least this tall */ }\n\n/* a \"rigid\" row will take up a constant amount of height because content-skeleton is absolute */\n.fc-row.fc-rigid {\n  overflow: hidden; }\n\n.fc-row.fc-rigid .fc-content-skeleton {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0; }\n\n/* week and day number styling */\n.fc-day-top.fc-other-month {\n  opacity: 0.3; }\n\n.fc-basic-view .fc-week-number,\n.fc-basic-view .fc-day-number {\n  padding: 2px; }\n\n.fc-basic-view th.fc-week-number,\n.fc-basic-view th.fc-day-number {\n  padding: 0 2px;\n  /* column headers can't have as much v space */ }\n\n.fc-ltr .fc-basic-view .fc-day-top .fc-day-number {\n  float: right; }\n\n.fc-rtl .fc-basic-view .fc-day-top .fc-day-number {\n  float: left; }\n\n.fc-ltr .fc-basic-view .fc-day-top .fc-week-number {\n  float: left;\n  border-radius: 0 0 3px 0; }\n\n.fc-rtl .fc-basic-view .fc-day-top .fc-week-number {\n  float: right;\n  border-radius: 0 0 0 3px; }\n\n.fc-basic-view .fc-day-top .fc-week-number {\n  min-width: 1.5em;\n  text-align: center;\n  background-color: #f2f2f2;\n  color: #808080; }\n\n/* when week/day number have own column */\n.fc-basic-view td.fc-week-number {\n  text-align: center; }\n\n.fc-basic-view td.fc-week-number > * {\n  /* work around the way we do column resizing and ensure a minimum width */\n  display: inline-block;\n  min-width: 1.25em; }\n\n/* AgendaView all-day area\n--------------------------------------------------------------------------------------------------*/\n.fc-agenda-view .fc-day-grid {\n  position: relative;\n  z-index: 2;\n  /* so the \"more..\" popover will be over the time grid */ }\n\n.fc-agenda-view .fc-day-grid .fc-row {\n  min-height: 3em;\n  /* all-day section will never get shorter than this */ }\n\n.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {\n  padding-bottom: 1em;\n  /* give space underneath events for clicking/selecting days */ }\n\n/* TimeGrid axis running down the side (for both the all-day area and the slot area)\n--------------------------------------------------------------------------------------------------*/\n.fc .fc-axis {\n  /* .fc to overcome default cell styles */\n  vertical-align: middle;\n  padding: 0 4px;\n  white-space: nowrap; }\n\n.fc-ltr .fc-axis {\n  text-align: right; }\n\n.fc-rtl .fc-axis {\n  text-align: left; }\n\n/* TimeGrid Structure\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid-container,\n.fc-time-grid {\n  /* so slats/bg/content/etc positions get scoped within here */\n  position: relative;\n  z-index: 1; }\n\n.fc-time-grid {\n  min-height: 100%;\n  /* so if height setting is 'auto', .fc-bg stretches to fill height */ }\n\n.fc-time-grid table {\n  /* don't put outer borders on slats/bg/content/etc */\n  border: 0 hidden transparent; }\n\n.fc-time-grid > .fc-bg {\n  z-index: 1; }\n\n.fc-time-grid .fc-slats,\n.fc-time-grid > hr {\n  /* the <hr> AgendaView injects when grid is shorter than scroller */\n  position: relative;\n  z-index: 2; }\n\n.fc-time-grid .fc-content-col {\n  position: relative;\n  /* because now-indicator lives directly inside */ }\n\n.fc-time-grid .fc-content-skeleton {\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  right: 0; }\n\n/* divs within a cell within the fc-content-skeleton */\n.fc-time-grid .fc-business-container {\n  position: relative;\n  z-index: 1; }\n\n.fc-time-grid .fc-bgevent-container {\n  position: relative;\n  z-index: 2; }\n\n.fc-time-grid .fc-highlight-container {\n  position: relative;\n  z-index: 3; }\n\n.fc-time-grid .fc-event-container {\n  position: relative;\n  z-index: 4; }\n\n.fc-time-grid .fc-now-indicator-line {\n  z-index: 5; }\n\n.fc-time-grid .fc-helper-container {\n  /* also is fc-event-container */\n  position: relative;\n  z-index: 6; }\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-slats td {\n  height: 1.5em;\n  border-bottom: 0;\n  /* each cell is responsible for its top border */ }\n\n.fc-time-grid .fc-slats .fc-minor td {\n  border-top-style: dotted; }\n\n/* TimeGrid Highlighting Slots\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-highlight-container {\n  /* a div within a cell within the fc-highlight-skeleton */\n  position: relative;\n  /* scopes the left/right of the fc-highlight to be in the column */ }\n\n.fc-time-grid .fc-highlight {\n  position: absolute;\n  left: 0;\n  right: 0;\n  /* top and bottom will be in by JS */ }\n\n/* TimeGrid Event Containment\n--------------------------------------------------------------------------------------------------*/\n.fc-ltr .fc-time-grid .fc-event-container {\n  /* space on the sides of events for LTR (default) */\n  margin: 0 2.5% 0 2px; }\n\n.fc-rtl .fc-time-grid .fc-event-container {\n  /* space on the sides of events for RTL */\n  margin: 0 2px 0 2.5%; }\n\n.fc-time-grid .fc-event,\n.fc-time-grid .fc-bgevent {\n  position: absolute;\n  z-index: 1;\n  /* scope inner z-index's */ }\n\n.fc-time-grid .fc-bgevent {\n  /* background events always span full width */\n  left: 0;\n  right: 0; }\n\n/* Generic Vertical Event\n--------------------------------------------------------------------------------------------------*/\n.fc-v-event.fc-not-start {\n  /* events that are continuing from another day */\n  /* replace space made by the top border with padding */\n  border-top-width: 0;\n  padding-top: 1px;\n  /* remove top rounded corners */\n  border-top-left-radius: 0;\n  border-top-right-radius: 0; }\n\n.fc-v-event.fc-not-end {\n  /* replace space made by the top border with padding */\n  border-bottom-width: 0;\n  padding-bottom: 1px;\n  /* remove bottom rounded corners */\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0; }\n\n/* TimeGrid Event Styling\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-time-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n.fc-time-grid-event {\n  overflow: hidden;\n  /* don't let the bg flow over rounded corners */ }\n\n.fc-time-grid-event.fc-selected {\n  /* need to allow touch resizers to extend outside event's bounding box */\n  /* common fc-selected styles hide the fc-bg, so don't need this anyway */\n  overflow: visible; }\n\n.fc-time-grid-event.fc-selected .fc-bg {\n  display: none;\n  /* hide semi-white background, to appear darker */ }\n\n.fc-time-grid-event .fc-content {\n  overflow: hidden;\n  /* for when .fc-selected */ }\n\n.fc-time-grid-event .fc-time,\n.fc-time-grid-event .fc-title {\n  padding: 0 1px; }\n\n.fc-time-grid-event .fc-time {\n  font-size: .85em;\n  white-space: nowrap; }\n\n/* short mode, where time and title are on the same line */\n.fc-time-grid-event.fc-short .fc-content {\n  /* don't wrap to second line (now that contents will be inline) */\n  white-space: nowrap; }\n\n.fc-time-grid-event.fc-short .fc-time,\n.fc-time-grid-event.fc-short .fc-title {\n  /* put the time and title on the same line */\n  display: inline-block;\n  vertical-align: top; }\n\n.fc-time-grid-event.fc-short .fc-time span {\n  display: none;\n  /* don't display the full time text... */ }\n\n.fc-time-grid-event.fc-short .fc-time:before {\n  content: attr(data-start);\n  /* ...instead, display only the start time */ }\n\n.fc-time-grid-event.fc-short .fc-time:after {\n  content: \"\\A0-\\A0\";\n  /* seperate with a dash, wrapped in nbsp's */ }\n\n.fc-time-grid-event.fc-short .fc-title {\n  font-size: .85em;\n  /* make the title text the same size as the time */\n  padding: 0;\n  /* undo padding from above */ }\n\n/* resizer (cursor device) */\n.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer {\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 8px;\n  overflow: hidden;\n  line-height: 8px;\n  font-size: 11px;\n  font-family: monospace;\n  text-align: center;\n  cursor: s-resize; }\n\n.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer:after {\n  content: \"=\"; }\n\n/* resizer (touch device) */\n.fc-time-grid-event.fc-selected .fc-resizer {\n  /* 10x10 dot */\n  border-radius: 5px;\n  border-width: 1px;\n  width: 8px;\n  height: 8px;\n  border-style: solid;\n  border-color: inherit;\n  background: #fff;\n  /* horizontally center */\n  left: 50%;\n  margin-left: -5px;\n  /* center on the bottom edge */\n  bottom: -5px; }\n\n/* Now Indicator\n--------------------------------------------------------------------------------------------------*/\n.fc-time-grid .fc-now-indicator-line {\n  border-top-width: 1px;\n  left: 0;\n  right: 0; }\n\n/* arrow on axis */\n.fc-time-grid .fc-now-indicator-arrow {\n  margin-top: -5px;\n  /* vertically center on top coordinate */ }\n\n.fc-ltr .fc-time-grid .fc-now-indicator-arrow {\n  left: 0;\n  /* triangle pointing right... */\n  border-width: 5px 0 5px 6px;\n  border-top-color: transparent;\n  border-bottom-color: transparent; }\n\n.fc-rtl .fc-time-grid .fc-now-indicator-arrow {\n  right: 0;\n  /* triangle pointing left... */\n  border-width: 5px 6px 5px 0;\n  border-top-color: transparent;\n  border-bottom-color: transparent; }\n\n/* List View\n--------------------------------------------------------------------------------------------------*/\n/* possibly reusable */\n.fc-event-dot {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 5px; }\n\n/* view wrapper */\n.fc-rtl .fc-list-view {\n  direction: rtl;\n  /* unlike core views, leverage browser RTL */ }\n\n.fc-list-view {\n  border-width: 1px;\n  border-style: solid; }\n\n/* table resets */\n.fc .fc-list-table {\n  table-layout: auto;\n  /* for shrinkwrapping cell content */ }\n\n.fc-list-table td {\n  border-width: 1px 0 0;\n  padding: 8px 14px; }\n\n.fc-list-table tr:first-child td {\n  border-top-width: 0; }\n\n/* day headings with the list */\n.fc-list-heading {\n  border-bottom-width: 1px; }\n\n.fc-list-heading td {\n  font-weight: bold; }\n\n.fc-ltr .fc-list-heading-main {\n  float: left; }\n\n.fc-ltr .fc-list-heading-alt {\n  float: right; }\n\n.fc-rtl .fc-list-heading-main {\n  float: right; }\n\n.fc-rtl .fc-list-heading-alt {\n  float: left; }\n\n/* event list items */\n.fc-list-item.fc-has-url {\n  cursor: pointer;\n  /* whole row will be clickable */ }\n\n.fc-list-item-marker,\n.fc-list-item-time {\n  white-space: nowrap;\n  width: 1px; }\n\n/* make the dot closer to the event title */\n.fc-ltr .fc-list-item-marker {\n  padding-right: 0; }\n\n.fc-rtl .fc-list-item-marker {\n  padding-left: 0; }\n\n.fc-list-item-title a {\n  /* every event title cell has an <a> tag */\n  text-decoration: none;\n  color: inherit; }\n\n.fc-list-item-title a[href]:hover {\n  /* hover effect only on titles with hrefs */\n  text-decoration: underline; }\n\n/* message when no events */\n.fc-list-empty-wrap2 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\n.fc-list-empty-wrap1 {\n  width: 100%;\n  height: 100%;\n  display: table; }\n\n.fc-list-empty {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center; }\n\n.fc-unthemed .fc-list-empty {\n  /* theme will provide own background */\n  background-color: #eee; }\n", ""]);

// exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "/* \r\n * Don't modify things marked with ! - unless you know what you're doing\r\n */\r\n\r\n/* ! vertical layout */\r\n.multiSelect .vertical {\r\n    float: none;        \r\n}\r\n\r\n/* ! horizontal layout */\r\n.multiSelect .horizontal:not(.multiSelectGroup) {\r\n    float: left;\r\n}\r\n\r\n/* ! create a \"row\" */\r\n.multiSelect .line {\r\n    padding:  2px 0px 4px 0px;\r\n    max-height: 30px;   \r\n    overflow: hidden;\r\n    box-sizing: content-box;\r\n}\r\n\r\n/* ! create a \"column\" */\r\n.multiSelect .acol {\r\n    display: inline-block;    \r\n    min-width: 12px;\r\n}\r\n\r\n/* ! */\r\n.multiSelect .inlineBlock {\r\n    display: inline-block;\r\n}\r\n\r\n/* the multiselect button */\r\n.multiSelect > button {\r\n    display: inline-block;\r\n    position: relative;\r\n    text-align: center;    \r\n    cursor: pointer;\r\n    border: 1px solid #c6c6c6;    \r\n    padding: 1px 8px 1px 8px;    \r\n    font-size: 14px;\r\n    min-height : 38px !important;\r\n    border-radius: 4px;\r\n    color: #555;   \r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    -o-user-select: none;\r\n    user-select: none; \r\n    white-space:normal;\r\n    background-color: #fff;\r\n    background-image: linear-gradient(#fff, #f7f7f7);      \r\n}\r\n\r\n/* button: hover */\r\n.multiSelect > button:hover {    \r\n    background-image: linear-gradient(#fff, #e9e9e9);    \r\n}\r\n\r\n/* button: disabled */\r\n.multiSelect > button:disabled {\r\n    background-image: linear-gradient(#fff, #fff);      \r\n    border: 1px solid #ddd;    \r\n    color: #999;\r\n}\r\n\r\n/* button: clicked */\r\n.multiSelect .buttonClicked {\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15) inset, 0 1px 2px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n/* labels on the button */\r\n.multiSelect .buttonLabel {\r\n    display: inline-block;\r\n    padding: 5px 0px 5px 0px; \r\n}\r\n\r\n/* downward pointing arrow */\r\n.multiSelect .caret {\r\n    display: inline-block;\r\n    width: 0;\r\n    height: 0;\r\n    margin: 0px 0px 1px 12px  !important;    \r\n    vertical-align: middle;\r\n    border-top: 4px solid #333;\r\n    border-right: 4px solid transparent;\r\n    border-left: 4px solid transparent;\r\n    border-bottom: 0 dotted; \r\n}\r\n\r\n/* the main checkboxes and helper layer */\r\n.multiSelect .checkboxLayer {\r\n    background-color: #fff;\r\n    position: absolute;\r\n    z-index: 999;\r\n    border: 1px solid rgba(0, 0, 0, 0.15);\r\n    border-radius: 4px;\r\n    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\r\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);    \r\n    min-width:278px;\r\n    display: none !important;    \r\n}\r\n\r\n/* container of helper elements */\r\n.multiSelect .helperContainer {\r\n    border-bottom: 1px solid #ddd;\r\n    padding: 8px 8px 0px 8px;    \r\n}\r\n\r\n/* helper buttons (select all, none, reset); */\r\n.multiSelect .helperButton {\r\n    display: inline;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    border: 1px solid #ccc;\r\n    height: 26px;\r\n    font-size: 13px;\r\n    border-radius: 2px;\r\n    color: #666;    \r\n    background-color: #f1f1f1;\r\n    line-height: 1.6;\r\n    margin: 0px 0px 8px 0px;\r\n}\r\n\r\n.multiSelect .helperButton.reset{\r\n    float: right;\r\n}\r\n\r\n.multiSelect .helperButton:not( .reset ) {\r\n    margin-right: 4px;    \r\n}\r\n\r\n/* clear button */\r\n.multiSelect .clearButton {\r\n    position: absolute;\r\n    display: inline;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    border: 1px solid #ccc;\r\n    height: 22px;\r\n    width: 22px;\r\n    font-size: 13px;\r\n    border-radius: 2px;\r\n    color: #666;    \r\n    background-color: #f1f1f1;\r\n    line-height: 1.4;\r\n    right : 2px;\r\n    top: 4px;\r\n}\r\n\r\n/* filter */\r\n.multiSelect .inputFilter {\r\n    border-radius: 2px; \r\n    border: 1px solid #ccc;\r\n    height: 26px;\r\n    font-size: 14px;\r\n    width:100%;    \r\n    padding-left:7px;\r\n    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */\r\n    -moz-box-sizing: border-box;    /* Firefox, other Gecko */\r\n    box-sizing: border-box;         /* Opera/IE 8+ */    \r\n    color: #888;\r\n    margin: 0px 0px 8px 0px;\r\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n}\r\n\r\n/* helper elements on hover & focus */\r\n.multiSelect .clearButton:hover,\r\n.multiSelect .helperButton:hover {\r\n    border: 1px solid #ccc;\r\n    color: #999;    \r\n    background-color: #f4f4f4;    \r\n}\r\n.multiSelect .helperButton:disabled {\r\n    color: #ccc;    \r\n    border: 1px solid #ddd;\r\n}\r\n\r\n.multiSelect .clearButton:focus,\r\n.multiSelect .helperButton:focus,\r\n.multiSelect .inputFilter:focus {\r\n    border: 1px solid #66AFE9 !important;\r\n    outline: 0;\r\n    -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,.065), 0 0 5px rgba(102, 175, 233, .6) !important;\r\n            box-shadow: inset 0 0 1px rgba(0,0,0,.065), 0 0 5px rgba(102, 175, 233, .6) !important;\r\n}\r\n\r\n/* container of multi select items */\r\n.multiSelect .checkBoxContainer {\r\n    display: block;\r\n    padding: 8px;   \r\n    overflow: hidden;\r\n}\r\n\r\n/* ! to show / hide the checkbox layer above */\r\n.multiSelect .show {\r\n    display: block !important;\r\n}\r\n\r\n/* item labels */\r\n.multiSelect .multiSelectItem {\r\n    display: block;\r\n    padding: 3px;\r\n    color: #444;       \r\n    white-space: nowrap;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    -o-user-select: none;\r\n    user-select: none;      \r\n    border: 1px solid transparent;\r\n    position: relative;\r\n    min-width:278px;    \r\n    min-height: 32px;    \r\n}\r\n\r\n/* Styling on selected items */\r\n.multiSelect .multiSelectItem:not(.multiSelectGroup).selected\r\n{\r\n    background-image: linear-gradient( #e9e9e9, #f1f1f1 );    \r\n    color: #555;        \r\n    cursor: pointer;        \r\n    border-top: 1px solid #e4e4e4;\r\n    border-left: 1px solid #e4e4e4;    \r\n    border-right: 1px solid #d9d9d9;            \r\n}\r\n\r\n.multiSelect .multiSelectItem .acol label {\r\n    display: inline-block;\r\n    padding-right: 30px;    \r\n    margin: 0px;\r\n    font-weight: normal;    \r\n    line-height: normal;\r\n}\r\n\r\n/* item labels focus on mouse hover */\r\n.multiSelect .multiSelectItem:hover, \r\n.multiSelect .multiSelectGroup:hover {\r\n    background-image: linear-gradient( #c1c1c1, #999 ) !important;    \r\n    color: #fff !important;    \r\n    cursor: pointer;        \r\n    border: 1px solid #ccc !important;\r\n}\r\n\r\n/* item labels focus using keyboard */\r\n.multiSelect .multiSelectFocus { \r\n    background-image: linear-gradient( #c1c1c1, #999 ) !important;    \r\n    color: #fff !important;    \r\n    cursor: pointer;        \r\n    border: 1px solid #ccc !important;\r\n}\r\n\r\n/* change mouse pointer into the pointing finger */\r\n.multiSelect .multiSelectItem span:hover, \r\n.multiSelect .multiSelectGroup span:hover\r\n{    \r\n    cursor: pointer;  \r\n}\r\n\r\n/* ! group labels */\r\n.multiSelect .multiSelectGroup {    \r\n    display: block;\r\n    clear: both;\r\n}\r\n\r\n/* right-align the tick mark (&#10004;) */\r\n.multiSelect .tickMark {\r\n    display:inline-block; \r\n    position: absolute; \r\n    right: 10px; \r\n    top: 7px;\r\n    font-size: 10px;          \r\n}\r\n\r\n/* hide the original HTML checkbox away */\r\n.multiSelect .checkbox {    \r\n    color: #ddd !important;    \r\n    position: absolute;\r\n    left: -9999px;\r\n    cursor: pointer;    \r\n}\r\n\r\n/* checkboxes currently disabled */\r\n.multiSelect .disabled, \r\n.multiSelect .disabled:hover,\r\n.multiSelect .disabled label input:hover ~ span {\r\n    color: #c4c4c4 !important;\r\n    cursor: not-allowed !important;\r\n}\r\n\r\n/* If you use images in button / checkbox label, you might want to change the image style here. */\r\n.multiSelect img {\r\n    vertical-align: middle;\r\n    margin-bottom:0px;\r\n    max-height: 22px;\r\n    max-width:22px;\r\n}\r\n", ""]);

// exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "/* required styles */\r\n\r\n.leaflet-pane,\r\n.leaflet-tile,\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow,\r\n.leaflet-tile-container,\r\n.leaflet-pane > svg,\r\n.leaflet-pane > canvas,\r\n.leaflet-zoom-box,\r\n.leaflet-image-layer,\r\n.leaflet-layer {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\t}\r\n.leaflet-container {\r\n\toverflow: hidden;\r\n\t}\r\n.leaflet-tile,\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow {\r\n\t-webkit-user-select: none;\r\n\t   -moz-user-select: none;\r\n\t        user-select: none;\r\n\t  -webkit-user-drag: none;\r\n\t}\r\n/* Safari renders non-retina tile on retina better with this, but Chrome is worse */\r\n.leaflet-safari .leaflet-tile {\r\n\timage-rendering: -webkit-optimize-contrast;\r\n\t}\r\n/* hack that prevents hw layers \"stretching\" when loading new tiles */\r\n.leaflet-safari .leaflet-tile-container {\r\n\twidth: 1600px;\r\n\theight: 1600px;\r\n\t-webkit-transform-origin: 0 0;\r\n\t}\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow {\r\n\tdisplay: block;\r\n\t}\r\n/* .leaflet-container svg: reset svg max-width decleration shipped in Joomla! (joomla.org) 3.x */\r\n/* .leaflet-container img: map is broken in FF if you have max-width: 100% on tiles */\r\n.leaflet-container .leaflet-overlay-pane svg,\r\n.leaflet-container .leaflet-marker-pane img,\r\n.leaflet-container .leaflet-shadow-pane img,\r\n.leaflet-container .leaflet-tile-pane img,\r\n.leaflet-container img.leaflet-image-layer {\r\n\tmax-width: none !important;\r\n\tmax-height: none !important;\r\n\t}\r\n\r\n.leaflet-container.leaflet-touch-zoom {\r\n\t-ms-touch-action: pan-x pan-y;\r\n\ttouch-action: pan-x pan-y;\r\n\t}\r\n.leaflet-container.leaflet-touch-drag {\r\n\t-ms-touch-action: pinch-zoom;\r\n\t/* Fallback for FF which doesn't support pinch-zoom */\r\n\ttouch-action: none;\r\n\ttouch-action: pinch-zoom;\r\n}\r\n.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {\r\n\t-ms-touch-action: none;\r\n\ttouch-action: none;\r\n}\r\n.leaflet-container {\r\n\t-webkit-tap-highlight-color: transparent;\r\n}\r\n.leaflet-container a {\r\n\t-webkit-tap-highlight-color: rgba(51, 181, 229, 0.4);\r\n}\r\n.leaflet-tile {\r\n\tfilter: inherit;\r\n\tvisibility: hidden;\r\n\t}\r\n.leaflet-tile-loaded {\r\n\tvisibility: inherit;\r\n\t}\r\n.leaflet-zoom-box {\r\n\twidth: 0;\r\n\theight: 0;\r\n\t-moz-box-sizing: border-box;\r\n\t     box-sizing: border-box;\r\n\tz-index: 800;\r\n\t}\r\n/* workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=888319 */\r\n.leaflet-overlay-pane svg {\r\n\t-moz-user-select: none;\r\n\t}\r\n\r\n.leaflet-pane         { z-index: 400; }\r\n\r\n.leaflet-tile-pane    { z-index: 200; }\r\n.leaflet-overlay-pane { z-index: 400; }\r\n.leaflet-shadow-pane  { z-index: 500; }\r\n.leaflet-marker-pane  { z-index: 600; }\r\n.leaflet-tooltip-pane   { z-index: 650; }\r\n.leaflet-popup-pane   { z-index: 700; }\r\n\r\n.leaflet-map-pane canvas { z-index: 100; }\r\n.leaflet-map-pane svg    { z-index: 200; }\r\n\r\n.leaflet-vml-shape {\r\n\twidth: 1px;\r\n\theight: 1px;\r\n\t}\r\n.lvml {\r\n\tbehavior: url(#default#VML);\r\n\tdisplay: inline-block;\r\n\tposition: absolute;\r\n\t}\r\n\r\n\r\n/* control positioning */\r\n\r\n.leaflet-control {\r\n\tposition: relative;\r\n\tz-index: 800;\r\n\tpointer-events: visiblePainted; /* IE 9-10 doesn't have auto */\r\n\tpointer-events: auto;\r\n\t}\r\n.leaflet-top,\r\n.leaflet-bottom {\r\n\tposition: absolute;\r\n\tz-index: 1000;\r\n\tpointer-events: none;\r\n\t}\r\n.leaflet-top {\r\n\ttop: 0;\r\n\t}\r\n.leaflet-right {\r\n\tright: 0;\r\n\t}\r\n.leaflet-bottom {\r\n\tbottom: 0;\r\n\t}\r\n.leaflet-left {\r\n\tleft: 0;\r\n\t}\r\n.leaflet-control {\r\n\tfloat: left;\r\n\tclear: both;\r\n\t}\r\n.leaflet-right .leaflet-control {\r\n\tfloat: right;\r\n\t}\r\n.leaflet-top .leaflet-control {\r\n\tmargin-top: 10px;\r\n\t}\r\n.leaflet-bottom .leaflet-control {\r\n\tmargin-bottom: 10px;\r\n\t}\r\n.leaflet-left .leaflet-control {\r\n\tmargin-left: 10px;\r\n\t}\r\n.leaflet-right .leaflet-control {\r\n\tmargin-right: 10px;\r\n\t}\r\n\r\n\r\n/* zoom and fade animations */\r\n\r\n.leaflet-fade-anim .leaflet-tile {\r\n\twill-change: opacity;\r\n\t}\r\n.leaflet-fade-anim .leaflet-popup {\r\n\topacity: 0;\r\n\t-webkit-transition: opacity 0.2s linear;\r\n\t   -moz-transition: opacity 0.2s linear;\r\n\t     -o-transition: opacity 0.2s linear;\r\n\t        transition: opacity 0.2s linear;\r\n\t}\r\n.leaflet-fade-anim .leaflet-map-pane .leaflet-popup {\r\n\topacity: 1;\r\n\t}\r\n.leaflet-zoom-animated {\r\n\t-webkit-transform-origin: 0 0;\r\n\t    -ms-transform-origin: 0 0;\r\n\t        transform-origin: 0 0;\r\n\t}\r\n.leaflet-zoom-anim .leaflet-zoom-animated {\r\n\twill-change: transform;\r\n\t}\r\n.leaflet-zoom-anim .leaflet-zoom-animated {\r\n\t-webkit-transition: -webkit-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t   -moz-transition:    -moz-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t     -o-transition:      -o-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t        transition:         transform 0.25s cubic-bezier(0,0,0.25,1);\r\n\t}\r\n.leaflet-zoom-anim .leaflet-tile,\r\n.leaflet-pan-anim .leaflet-tile {\r\n\t-webkit-transition: none;\r\n\t   -moz-transition: none;\r\n\t     -o-transition: none;\r\n\t        transition: none;\r\n\t}\r\n\r\n.leaflet-zoom-anim .leaflet-zoom-hide {\r\n\tvisibility: hidden;\r\n\t}\r\n\r\n\r\n/* cursors */\r\n\r\n.leaflet-interactive {\r\n\tcursor: pointer;\r\n\t}\r\n.leaflet-grab {\r\n\tcursor: -webkit-grab;\r\n\tcursor:    -moz-grab;\r\n\t}\r\n.leaflet-crosshair,\r\n.leaflet-crosshair .leaflet-interactive {\r\n\tcursor: crosshair;\r\n\t}\r\n.leaflet-popup-pane,\r\n.leaflet-control {\r\n\tcursor: auto;\r\n\t}\r\n.leaflet-dragging .leaflet-grab,\r\n.leaflet-dragging .leaflet-grab .leaflet-interactive,\r\n.leaflet-dragging .leaflet-marker-draggable {\r\n\tcursor: move;\r\n\tcursor: -webkit-grabbing;\r\n\tcursor:    -moz-grabbing;\r\n\t}\r\n\r\n/* marker & overlays interactivity */\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow,\r\n.leaflet-image-layer,\r\n.leaflet-pane > svg path,\r\n.leaflet-tile-container {\r\n\tpointer-events: none;\r\n\t}\r\n\r\n.leaflet-marker-icon.leaflet-interactive,\r\n.leaflet-image-layer.leaflet-interactive,\r\n.leaflet-pane > svg path.leaflet-interactive {\r\n\tpointer-events: visiblePainted; /* IE 9-10 doesn't have auto */\r\n\tpointer-events: auto;\r\n\t}\r\n\r\n/* visual tweaks */\r\n\r\n.leaflet-container {\r\n\tbackground: #ddd;\r\n\toutline: 0;\r\n\t}\r\n.leaflet-container a {\r\n\tcolor: #0078A8;\r\n\t}\r\n.leaflet-container a.leaflet-active {\r\n\toutline: 2px solid orange;\r\n\t}\r\n.leaflet-zoom-box {\r\n\tborder: 2px dotted #38f;\r\n\tbackground: rgba(255,255,255,0.5);\r\n\t}\r\n\r\n\r\n/* general typography */\r\n.leaflet-container {\r\n\tfont: 12px/1.5 \"Helvetica Neue\", Arial, Helvetica, sans-serif;\r\n\t}\r\n\r\n\r\n/* general toolbar styles */\r\n\r\n.leaflet-bar {\r\n\tbox-shadow: 0 1px 5px rgba(0,0,0,0.65);\r\n\tborder-radius: 4px;\r\n\t}\r\n.leaflet-bar a,\r\n.leaflet-bar a:hover {\r\n\tbackground-color: #fff;\r\n\tborder-bottom: 1px solid #ccc;\r\n\twidth: 26px;\r\n\theight: 26px;\r\n\tline-height: 26px;\r\n\tdisplay: block;\r\n\ttext-align: center;\r\n\ttext-decoration: none;\r\n\tcolor: black;\r\n\t}\r\n.leaflet-bar a,\r\n.leaflet-control-layers-toggle {\r\n\tbackground-position: 50% 50%;\r\n\tbackground-repeat: no-repeat;\r\n\tdisplay: block;\r\n\t}\r\n.leaflet-bar a:hover {\r\n\tbackground-color: #f4f4f4;\r\n\t}\r\n.leaflet-bar a:first-child {\r\n\tborder-top-left-radius: 4px;\r\n\tborder-top-right-radius: 4px;\r\n\t}\r\n.leaflet-bar a:last-child {\r\n\tborder-bottom-left-radius: 4px;\r\n\tborder-bottom-right-radius: 4px;\r\n\tborder-bottom: none;\r\n\t}\r\n.leaflet-bar a.leaflet-disabled {\r\n\tcursor: default;\r\n\tbackground-color: #f4f4f4;\r\n\tcolor: #bbb;\r\n\t}\r\n\r\n.leaflet-touch .leaflet-bar a {\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tline-height: 30px;\r\n\t}\r\n.leaflet-touch .leaflet-bar a:first-child {\r\n\tborder-top-left-radius: 2px;\r\n\tborder-top-right-radius: 2px;\r\n\t}\r\n.leaflet-touch .leaflet-bar a:last-child {\r\n\tborder-bottom-left-radius: 2px;\r\n\tborder-bottom-right-radius: 2px;\r\n\t}\r\n\r\n/* zoom control */\r\n\r\n.leaflet-control-zoom-in,\r\n.leaflet-control-zoom-out {\r\n\tfont: bold 18px 'Lucida Console', Monaco, monospace;\r\n\ttext-indent: 1px;\r\n\t}\r\n\r\n.leaflet-touch .leaflet-control-zoom-in, .leaflet-touch .leaflet-control-zoom-out  {\r\n\tfont-size: 22px;\r\n\t}\r\n\r\n\r\n/* layers control */\r\n\r\n.leaflet-control-layers {\r\n\tbox-shadow: 0 1px 5px rgba(0,0,0,0.4);\r\n\tbackground: #fff;\r\n\tborder-radius: 5px;\r\n\t}\r\n.leaflet-control-layers-toggle {\r\n\tbackground-image: url(" + __webpack_require__(1532) + ");\r\n\twidth: 36px;\r\n\theight: 36px;\r\n\t}\r\n.leaflet-retina .leaflet-control-layers-toggle {\r\n\tbackground-image: url(" + __webpack_require__(1531) + ");\r\n\tbackground-size: 26px 26px;\r\n\t}\r\n.leaflet-touch .leaflet-control-layers-toggle {\r\n\twidth: 44px;\r\n\theight: 44px;\r\n\t}\r\n.leaflet-control-layers .leaflet-control-layers-list,\r\n.leaflet-control-layers-expanded .leaflet-control-layers-toggle {\r\n\tdisplay: none;\r\n\t}\r\n.leaflet-control-layers-expanded .leaflet-control-layers-list {\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\t}\r\n.leaflet-control-layers-expanded {\r\n\tpadding: 6px 10px 6px 6px;\r\n\tcolor: #333;\r\n\tbackground: #fff;\r\n\t}\r\n.leaflet-control-layers-scrollbar {\r\n\toverflow-y: scroll;\r\n\toverflow-x: hidden;\r\n\tpadding-right: 5px;\r\n\t}\r\n.leaflet-control-layers-selector {\r\n\tmargin-top: 2px;\r\n\tposition: relative;\r\n\ttop: 1px;\r\n\t}\r\n.leaflet-control-layers label {\r\n\tdisplay: block;\r\n\t}\r\n.leaflet-control-layers-separator {\r\n\theight: 0;\r\n\tborder-top: 1px solid #ddd;\r\n\tmargin: 5px -10px 5px -6px;\r\n\t}\r\n\r\n/* Default icon URLs */\r\n.leaflet-default-icon-path {\r\n\tbackground-image: url(" + __webpack_require__(1533) + ");\r\n\t}\r\n\r\n\r\n/* attribution and scale controls */\r\n\r\n.leaflet-container .leaflet-control-attribution {\r\n\tbackground: #fff;\r\n\tbackground: rgba(255, 255, 255, 0.7);\r\n\tmargin: 0;\r\n\t}\r\n.leaflet-control-attribution,\r\n.leaflet-control-scale-line {\r\n\tpadding: 0 5px;\r\n\tcolor: #333;\r\n\t}\r\n.leaflet-control-attribution a {\r\n\ttext-decoration: none;\r\n\t}\r\n.leaflet-control-attribution a:hover {\r\n\ttext-decoration: underline;\r\n\t}\r\n.leaflet-container .leaflet-control-attribution,\r\n.leaflet-container .leaflet-control-scale {\r\n\tfont-size: 11px;\r\n\t}\r\n.leaflet-left .leaflet-control-scale {\r\n\tmargin-left: 5px;\r\n\t}\r\n.leaflet-bottom .leaflet-control-scale {\r\n\tmargin-bottom: 5px;\r\n\t}\r\n.leaflet-control-scale-line {\r\n\tborder: 2px solid #777;\r\n\tborder-top: none;\r\n\tline-height: 1.1;\r\n\tpadding: 2px 5px 1px;\r\n\tfont-size: 11px;\r\n\twhite-space: nowrap;\r\n\toverflow: hidden;\r\n\t-moz-box-sizing: border-box;\r\n\t     box-sizing: border-box;\r\n\r\n\tbackground: #fff;\r\n\tbackground: rgba(255, 255, 255, 0.5);\r\n\t}\r\n.leaflet-control-scale-line:not(:first-child) {\r\n\tborder-top: 2px solid #777;\r\n\tborder-bottom: none;\r\n\tmargin-top: -2px;\r\n\t}\r\n.leaflet-control-scale-line:not(:first-child):not(:last-child) {\r\n\tborder-bottom: 2px solid #777;\r\n\t}\r\n\r\n.leaflet-touch .leaflet-control-attribution,\r\n.leaflet-touch .leaflet-control-layers,\r\n.leaflet-touch .leaflet-bar {\r\n\tbox-shadow: none;\r\n\t}\r\n.leaflet-touch .leaflet-control-layers,\r\n.leaflet-touch .leaflet-bar {\r\n\tborder: 2px solid rgba(0,0,0,0.2);\r\n\tbackground-clip: padding-box;\r\n\t}\r\n\r\n\r\n/* popup */\r\n\r\n.leaflet-popup {\r\n\tposition: absolute;\r\n\ttext-align: center;\r\n\tmargin-bottom: 20px;\r\n\t}\r\n.leaflet-popup-content-wrapper {\r\n\tpadding: 1px;\r\n\ttext-align: left;\r\n\tborder-radius: 12px;\r\n\t}\r\n.leaflet-popup-content {\r\n\tmargin: 13px 19px;\r\n\tline-height: 1.4;\r\n\t}\r\n.leaflet-popup-content p {\r\n\tmargin: 18px 0;\r\n\t}\r\n.leaflet-popup-tip-container {\r\n\twidth: 40px;\r\n\theight: 20px;\r\n\tposition: absolute;\r\n\tleft: 50%;\r\n\tmargin-left: -20px;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\t}\r\n.leaflet-popup-tip {\r\n\twidth: 17px;\r\n\theight: 17px;\r\n\tpadding: 1px;\r\n\r\n\tmargin: -10px auto 0;\r\n\r\n\t-webkit-transform: rotate(45deg);\r\n\t   -moz-transform: rotate(45deg);\r\n\t    -ms-transform: rotate(45deg);\r\n\t     -o-transform: rotate(45deg);\r\n\t        transform: rotate(45deg);\r\n\t}\r\n.leaflet-popup-content-wrapper,\r\n.leaflet-popup-tip {\r\n\tbackground: white;\r\n\tcolor: #333;\r\n\tbox-shadow: 0 3px 14px rgba(0,0,0,0.4);\r\n\t}\r\n.leaflet-container a.leaflet-popup-close-button {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tpadding: 4px 4px 0 0;\r\n\tborder: none;\r\n\ttext-align: center;\r\n\twidth: 18px;\r\n\theight: 14px;\r\n\tfont: 16px/14px Tahoma, Verdana, sans-serif;\r\n\tcolor: #c3c3c3;\r\n\ttext-decoration: none;\r\n\tfont-weight: bold;\r\n\tbackground: transparent;\r\n\t}\r\n.leaflet-container a.leaflet-popup-close-button:hover {\r\n\tcolor: #999;\r\n\t}\r\n.leaflet-popup-scrolled {\r\n\toverflow: auto;\r\n\tborder-bottom: 1px solid #ddd;\r\n\tborder-top: 1px solid #ddd;\r\n\t}\r\n\r\n.leaflet-oldie .leaflet-popup-content-wrapper {\r\n\tzoom: 1;\r\n\t}\r\n.leaflet-oldie .leaflet-popup-tip {\r\n\twidth: 24px;\r\n\tmargin: 0 auto;\r\n\r\n\t-ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)\";\r\n\tfilter: progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678);\r\n\t}\r\n.leaflet-oldie .leaflet-popup-tip-container {\r\n\tmargin-top: -1px;\r\n\t}\r\n\r\n.leaflet-oldie .leaflet-control-zoom,\r\n.leaflet-oldie .leaflet-control-layers,\r\n.leaflet-oldie .leaflet-popup-content-wrapper,\r\n.leaflet-oldie .leaflet-popup-tip {\r\n\tborder: 1px solid #999;\r\n\t}\r\n\r\n\r\n/* div icon */\r\n\r\n.leaflet-div-icon {\r\n\tbackground: #fff;\r\n\tborder: 1px solid #666;\r\n\t}\r\n\r\n\r\n/* Tooltip */\r\n/* Base styles for the element that has a tooltip */\r\n.leaflet-tooltip {\r\n\tposition: absolute;\r\n\tpadding: 6px;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #fff;\r\n\tborder-radius: 3px;\r\n\tcolor: #222;\r\n\twhite-space: nowrap;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none;\r\n\tpointer-events: none;\r\n\tbox-shadow: 0 1px 3px rgba(0,0,0,0.4);\r\n\t}\r\n.leaflet-tooltip.leaflet-clickable {\r\n\tcursor: pointer;\r\n\tpointer-events: auto;\r\n\t}\r\n.leaflet-tooltip-top:before,\r\n.leaflet-tooltip-bottom:before,\r\n.leaflet-tooltip-left:before,\r\n.leaflet-tooltip-right:before {\r\n\tposition: absolute;\r\n\tpointer-events: none;\r\n\tborder: 6px solid transparent;\r\n\tbackground: transparent;\r\n\tcontent: \"\";\r\n\t}\r\n\r\n/* Directions */\r\n\r\n.leaflet-tooltip-bottom {\r\n\tmargin-top: 6px;\r\n}\r\n.leaflet-tooltip-top {\r\n\tmargin-top: -6px;\r\n}\r\n.leaflet-tooltip-bottom:before,\r\n.leaflet-tooltip-top:before {\r\n\tleft: 50%;\r\n\tmargin-left: -6px;\r\n\t}\r\n.leaflet-tooltip-top:before {\r\n\tbottom: 0;\r\n\tmargin-bottom: -12px;\r\n\tborder-top-color: #fff;\r\n\t}\r\n.leaflet-tooltip-bottom:before {\r\n\ttop: 0;\r\n\tmargin-top: -12px;\r\n\tmargin-left: -6px;\r\n\tborder-bottom-color: #fff;\r\n\t}\r\n.leaflet-tooltip-left {\r\n\tmargin-left: -6px;\r\n}\r\n.leaflet-tooltip-right {\r\n\tmargin-left: 6px;\r\n}\r\n.leaflet-tooltip-left:before,\r\n.leaflet-tooltip-right:before {\r\n\ttop: 50%;\r\n\tmargin-top: -6px;\r\n\t}\r\n.leaflet-tooltip-left:before {\r\n\tright: 0;\r\n\tmargin-right: -12px;\r\n\tborder-left-color: #fff;\r\n\t}\r\n.leaflet-tooltip-right:before {\r\n\tleft: 0;\r\n\tmargin-left: -12px;\r\n\tborder-right-color: #fff;\r\n\t}\r\n", ""]);

// exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "/*!\n * ngToast v2.0.0 (http://tameraydin.github.io/ngToast)\n * Copyright 2016 Tamer Aydin (http://tamerayd.in)\n * Licensed under MIT (http://tameraydin.mit-license.org/)\n */\n\n.ng-toast{position:fixed;z-index:1080;width:100%;height:0;margin-top:20px;text-align:center}.ng-toast.ng-toast--top,.ng-toast.ng-toast--top .ng-toast__list{top:0;bottom:auto}.ng-toast.ng-toast--top.ng-toast--center .ng-toast__list{position:static}.ng-toast.ng-toast--bottom,.ng-toast.ng-toast--bottom .ng-toast__list{top:auto;bottom:0}.ng-toast.ng-toast--bottom.ng-toast--center .ng-toast__list{pointer-events:none}.ng-toast.ng-toast--bottom.ng-toast--center .ng-toast__message .alert{pointer-events:auto}.ng-toast.ng-toast--right .ng-toast__list{left:auto;right:0;margin-right:20px}.ng-toast.ng-toast--right .ng-toast__message{text-align:right}.ng-toast.ng-toast--left .ng-toast__list{right:auto;left:0;margin-left:20px}.ng-toast.ng-toast--left .ng-toast__message{text-align:left}.ng-toast .ng-toast__list{display:inline-block;position:absolute;right:0;left:0;margin:0 auto;padding:0;list-style:none}.ng-toast .ng-toast__message{display:block;width:100%;text-align:center}.ng-toast .ng-toast__message .alert{display:inline-block}.ng-toast .ng-toast__message__count{display:inline-block;margin:0 15px 0 5px}", ""]);

// exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */\n\n/**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in\n *    IE on Windows Phone and in iOS.\n */\n\n/* Document\n   ========================================================================== */\n\nhtml {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\narticle,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in IE.\n */\n\nfigcaption,\nfigure,\nmain { /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */\n\na:active,\na:hover {\n  outline-width: 0;\n}\n\n/**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\n\nb,\nstrong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio,\nvideo {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\nhtml [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * 1. Add the correct display in IE 9-.\n * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n */\n\ndetails, /* 1 */\nmenu {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Scripting\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\ncanvas {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in IE.\n */\n\ntemplate {\n  display: none;\n}\n\n/* Hidden\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10-.\n */\n\n[hidden] {\n  display: none;\n}\n", ""]);

// exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */\n\nhtml {\n  font-family: sans-serif;\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline;\n}\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n[hidden],\ntemplate {\n  display: none;\n}\n\na {\n  background-color: transparent;\n}\n\na:active,\na:hover {\n  outline: 0;\n}\n\nabbr[title] {\n  border-bottom: 1px dotted;\n}\n\nb,\nstrong {\n  font-weight: bold;\n}\n\ndfn {\n  font-style: italic;\n}\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\nmark {\n  background: #ff0;\n  color: #000;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nimg {\n  border: 0;\n}\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\nfigure {\n  margin: 1em 40px;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n}\n\npre {\n  overflow: auto;\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nbutton,\nhtml input[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\ninput {\n  line-height: normal;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  box-sizing: content-box;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\nlegend {\n  border: 0;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n}\n\noptgroup {\n  font-weight: bold;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ntd,\nth {\n  padding: 0;\n}\n\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */\n\n@media print {\n  *,\n  *:before,\n  *:after {\n    background: transparent !important;\n    color: #000 !important;\n    box-shadow: none !important;\n    text-shadow: none !important;\n  }\n\n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n\n  a[href]:after {\n    content: \" (\" attr(href) \")\";\n  }\n\n  abbr[title]:after {\n    content: \" (\" attr(title) \")\";\n  }\n\n  a[href^=\"#\"]:after,\n  a[href^=\"javascript:\"]:after {\n    content: \"\";\n  }\n\n  pre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n  }\n\n  thead {\n    display: table-header-group;\n  }\n\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n\n  img {\n    max-width: 100% !important;\n  }\n\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n\n  .navbar {\n    display: none;\n  }\n\n  .btn > .caret,\n  .dropup > .btn > .caret {\n    border-top-color: #000 !important;\n  }\n\n  .label {\n    border: 1px solid #000;\n  }\n\n  .table {\n    border-collapse: collapse !important;\n  }\n\n  .table td,\n  .table th {\n    background-color: #fff !important;\n  }\n\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ddd !important;\n  }\n}\n\n@font-face {\n  font-family: 'Glyphicons Halflings';\n  src: url(" + __webpack_require__(386) + ");\n  src: url(" + __webpack_require__(386) + ") format(\"embedded-opentype\"), url(" + __webpack_require__(3169) + ") format(\"woff2\"), url(" + __webpack_require__(3168) + ") format(\"woff\"), url(" + __webpack_require__(1232) + ") format(\"truetype\"), url(" + __webpack_require__(1231) + ") format(\"svg\");\n}\n\n.glyphicon {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  font-family: 'Glyphicons Halflings';\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.glyphicon-asterisk:before {\n  content: \"*\";\n}\n\n.glyphicon-plus:before {\n  content: \"+\";\n}\n\n.glyphicon-euro:before,\n.glyphicon-eur:before {\n  content: \"\\20AC\";\n}\n\n.glyphicon-minus:before {\n  content: \"\\2212\";\n}\n\n.glyphicon-cloud:before {\n  content: \"\\2601\";\n}\n\n.glyphicon-envelope:before {\n  content: \"\\2709\";\n}\n\n.glyphicon-pencil:before {\n  content: \"\\270F\";\n}\n\n.glyphicon-glass:before {\n  content: \"\\E001\";\n}\n\n.glyphicon-music:before {\n  content: \"\\E002\";\n}\n\n.glyphicon-search:before {\n  content: \"\\E003\";\n}\n\n.glyphicon-heart:before {\n  content: \"\\E005\";\n}\n\n.glyphicon-star:before {\n  content: \"\\E006\";\n}\n\n.glyphicon-star-empty:before {\n  content: \"\\E007\";\n}\n\n.glyphicon-user:before {\n  content: \"\\E008\";\n}\n\n.glyphicon-film:before {\n  content: \"\\E009\";\n}\n\n.glyphicon-th-large:before {\n  content: \"\\E010\";\n}\n\n.glyphicon-th:before {\n  content: \"\\E011\";\n}\n\n.glyphicon-th-list:before {\n  content: \"\\E012\";\n}\n\n.glyphicon-ok:before {\n  content: \"\\E013\";\n}\n\n.glyphicon-remove:before {\n  content: \"\\E014\";\n}\n\n.glyphicon-zoom-in:before {\n  content: \"\\E015\";\n}\n\n.glyphicon-zoom-out:before {\n  content: \"\\E016\";\n}\n\n.glyphicon-off:before {\n  content: \"\\E017\";\n}\n\n.glyphicon-signal:before {\n  content: \"\\E018\";\n}\n\n.glyphicon-cog:before {\n  content: \"\\E019\";\n}\n\n.glyphicon-trash:before {\n  content: \"\\E020\";\n}\n\n.glyphicon-home:before {\n  content: \"\\E021\";\n}\n\n.glyphicon-file:before {\n  content: \"\\E022\";\n}\n\n.glyphicon-time:before {\n  content: \"\\E023\";\n}\n\n.glyphicon-road:before {\n  content: \"\\E024\";\n}\n\n.glyphicon-download-alt:before {\n  content: \"\\E025\";\n}\n\n.glyphicon-download:before {\n  content: \"\\E026\";\n}\n\n.glyphicon-upload:before {\n  content: \"\\E027\";\n}\n\n.glyphicon-inbox:before {\n  content: \"\\E028\";\n}\n\n.glyphicon-play-circle:before {\n  content: \"\\E029\";\n}\n\n.glyphicon-repeat:before {\n  content: \"\\E030\";\n}\n\n.glyphicon-refresh:before {\n  content: \"\\E031\";\n}\n\n.glyphicon-list-alt:before {\n  content: \"\\E032\";\n}\n\n.glyphicon-lock:before {\n  content: \"\\E033\";\n}\n\n.glyphicon-flag:before {\n  content: \"\\E034\";\n}\n\n.glyphicon-headphones:before {\n  content: \"\\E035\";\n}\n\n.glyphicon-volume-off:before {\n  content: \"\\E036\";\n}\n\n.glyphicon-volume-down:before {\n  content: \"\\E037\";\n}\n\n.glyphicon-volume-up:before {\n  content: \"\\E038\";\n}\n\n.glyphicon-qrcode:before {\n  content: \"\\E039\";\n}\n\n.glyphicon-barcode:before {\n  content: \"\\E040\";\n}\n\n.glyphicon-tag:before {\n  content: \"\\E041\";\n}\n\n.glyphicon-tags:before {\n  content: \"\\E042\";\n}\n\n.glyphicon-book:before {\n  content: \"\\E043\";\n}\n\n.glyphicon-bookmark:before {\n  content: \"\\E044\";\n}\n\n.glyphicon-print:before {\n  content: \"\\E045\";\n}\n\n.glyphicon-camera:before {\n  content: \"\\E046\";\n}\n\n.glyphicon-font:before {\n  content: \"\\E047\";\n}\n\n.glyphicon-bold:before {\n  content: \"\\E048\";\n}\n\n.glyphicon-italic:before {\n  content: \"\\E049\";\n}\n\n.glyphicon-text-height:before {\n  content: \"\\E050\";\n}\n\n.glyphicon-text-width:before {\n  content: \"\\E051\";\n}\n\n.glyphicon-align-left:before {\n  content: \"\\E052\";\n}\n\n.glyphicon-align-center:before {\n  content: \"\\E053\";\n}\n\n.glyphicon-align-right:before {\n  content: \"\\E054\";\n}\n\n.glyphicon-align-justify:before {\n  content: \"\\E055\";\n}\n\n.glyphicon-list:before {\n  content: \"\\E056\";\n}\n\n.glyphicon-indent-left:before {\n  content: \"\\E057\";\n}\n\n.glyphicon-indent-right:before {\n  content: \"\\E058\";\n}\n\n.glyphicon-facetime-video:before {\n  content: \"\\E059\";\n}\n\n.glyphicon-picture:before {\n  content: \"\\E060\";\n}\n\n.glyphicon-map-marker:before {\n  content: \"\\E062\";\n}\n\n.glyphicon-adjust:before {\n  content: \"\\E063\";\n}\n\n.glyphicon-tint:before {\n  content: \"\\E064\";\n}\n\n.glyphicon-edit:before {\n  content: \"\\E065\";\n}\n\n.glyphicon-share:before {\n  content: \"\\E066\";\n}\n\n.glyphicon-check:before {\n  content: \"\\E067\";\n}\n\n.glyphicon-move:before {\n  content: \"\\E068\";\n}\n\n.glyphicon-step-backward:before {\n  content: \"\\E069\";\n}\n\n.glyphicon-fast-backward:before {\n  content: \"\\E070\";\n}\n\n.glyphicon-backward:before {\n  content: \"\\E071\";\n}\n\n.glyphicon-play:before {\n  content: \"\\E072\";\n}\n\n.glyphicon-pause:before {\n  content: \"\\E073\";\n}\n\n.glyphicon-stop:before {\n  content: \"\\E074\";\n}\n\n.glyphicon-forward:before {\n  content: \"\\E075\";\n}\n\n.glyphicon-fast-forward:before {\n  content: \"\\E076\";\n}\n\n.glyphicon-step-forward:before {\n  content: \"\\E077\";\n}\n\n.glyphicon-eject:before {\n  content: \"\\E078\";\n}\n\n.glyphicon-chevron-left:before {\n  content: \"\\E079\";\n}\n\n.glyphicon-chevron-right:before {\n  content: \"\\E080\";\n}\n\n.glyphicon-plus-sign:before {\n  content: \"\\E081\";\n}\n\n.glyphicon-minus-sign:before {\n  content: \"\\E082\";\n}\n\n.glyphicon-remove-sign:before {\n  content: \"\\E083\";\n}\n\n.glyphicon-ok-sign:before {\n  content: \"\\E084\";\n}\n\n.glyphicon-question-sign:before {\n  content: \"\\E085\";\n}\n\n.glyphicon-info-sign:before {\n  content: \"\\E086\";\n}\n\n.glyphicon-screenshot:before {\n  content: \"\\E087\";\n}\n\n.glyphicon-remove-circle:before {\n  content: \"\\E088\";\n}\n\n.glyphicon-ok-circle:before {\n  content: \"\\E089\";\n}\n\n.glyphicon-ban-circle:before {\n  content: \"\\E090\";\n}\n\n.glyphicon-arrow-left:before {\n  content: \"\\E091\";\n}\n\n.glyphicon-arrow-right:before {\n  content: \"\\E092\";\n}\n\n.glyphicon-arrow-up:before {\n  content: \"\\E093\";\n}\n\n.glyphicon-arrow-down:before {\n  content: \"\\E094\";\n}\n\n.glyphicon-share-alt:before {\n  content: \"\\E095\";\n}\n\n.glyphicon-resize-full:before {\n  content: \"\\E096\";\n}\n\n.glyphicon-resize-small:before {\n  content: \"\\E097\";\n}\n\n.glyphicon-exclamation-sign:before {\n  content: \"\\E101\";\n}\n\n.glyphicon-gift:before {\n  content: \"\\E102\";\n}\n\n.glyphicon-leaf:before {\n  content: \"\\E103\";\n}\n\n.glyphicon-fire:before {\n  content: \"\\E104\";\n}\n\n.glyphicon-eye-open:before {\n  content: \"\\E105\";\n}\n\n.glyphicon-eye-close:before {\n  content: \"\\E106\";\n}\n\n.glyphicon-warning-sign:before {\n  content: \"\\E107\";\n}\n\n.glyphicon-plane:before {\n  content: \"\\E108\";\n}\n\n.glyphicon-calendar:before {\n  content: \"\\E109\";\n}\n\n.glyphicon-random:before {\n  content: \"\\E110\";\n}\n\n.glyphicon-comment:before {\n  content: \"\\E111\";\n}\n\n.glyphicon-magnet:before {\n  content: \"\\E112\";\n}\n\n.glyphicon-chevron-up:before {\n  content: \"\\E113\";\n}\n\n.glyphicon-chevron-down:before {\n  content: \"\\E114\";\n}\n\n.glyphicon-retweet:before {\n  content: \"\\E115\";\n}\n\n.glyphicon-shopping-cart:before {\n  content: \"\\E116\";\n}\n\n.glyphicon-folder-close:before {\n  content: \"\\E117\";\n}\n\n.glyphicon-folder-open:before {\n  content: \"\\E118\";\n}\n\n.glyphicon-resize-vertical:before {\n  content: \"\\E119\";\n}\n\n.glyphicon-resize-horizontal:before {\n  content: \"\\E120\";\n}\n\n.glyphicon-hdd:before {\n  content: \"\\E121\";\n}\n\n.glyphicon-bullhorn:before {\n  content: \"\\E122\";\n}\n\n.glyphicon-bell:before {\n  content: \"\\E123\";\n}\n\n.glyphicon-certificate:before {\n  content: \"\\E124\";\n}\n\n.glyphicon-thumbs-up:before {\n  content: \"\\E125\";\n}\n\n.glyphicon-thumbs-down:before {\n  content: \"\\E126\";\n}\n\n.glyphicon-hand-right:before {\n  content: \"\\E127\";\n}\n\n.glyphicon-hand-left:before {\n  content: \"\\E128\";\n}\n\n.glyphicon-hand-up:before {\n  content: \"\\E129\";\n}\n\n.glyphicon-hand-down:before {\n  content: \"\\E130\";\n}\n\n.glyphicon-circle-arrow-right:before {\n  content: \"\\E131\";\n}\n\n.glyphicon-circle-arrow-left:before {\n  content: \"\\E132\";\n}\n\n.glyphicon-circle-arrow-up:before {\n  content: \"\\E133\";\n}\n\n.glyphicon-circle-arrow-down:before {\n  content: \"\\E134\";\n}\n\n.glyphicon-globe:before {\n  content: \"\\E135\";\n}\n\n.glyphicon-wrench:before {\n  content: \"\\E136\";\n}\n\n.glyphicon-tasks:before {\n  content: \"\\E137\";\n}\n\n.glyphicon-filter:before {\n  content: \"\\E138\";\n}\n\n.glyphicon-briefcase:before {\n  content: \"\\E139\";\n}\n\n.glyphicon-fullscreen:before {\n  content: \"\\E140\";\n}\n\n.glyphicon-dashboard:before {\n  content: \"\\E141\";\n}\n\n.glyphicon-paperclip:before {\n  content: \"\\E142\";\n}\n\n.glyphicon-heart-empty:before {\n  content: \"\\E143\";\n}\n\n.glyphicon-link:before {\n  content: \"\\E144\";\n}\n\n.glyphicon-phone:before {\n  content: \"\\E145\";\n}\n\n.glyphicon-pushpin:before {\n  content: \"\\E146\";\n}\n\n.glyphicon-usd:before {\n  content: \"\\E148\";\n}\n\n.glyphicon-gbp:before {\n  content: \"\\E149\";\n}\n\n.glyphicon-sort:before {\n  content: \"\\E150\";\n}\n\n.glyphicon-sort-by-alphabet:before {\n  content: \"\\E151\";\n}\n\n.glyphicon-sort-by-alphabet-alt:before {\n  content: \"\\E152\";\n}\n\n.glyphicon-sort-by-order:before {\n  content: \"\\E153\";\n}\n\n.glyphicon-sort-by-order-alt:before {\n  content: \"\\E154\";\n}\n\n.glyphicon-sort-by-attributes:before {\n  content: \"\\E155\";\n}\n\n.glyphicon-sort-by-attributes-alt:before {\n  content: \"\\E156\";\n}\n\n.glyphicon-unchecked:before {\n  content: \"\\E157\";\n}\n\n.glyphicon-expand:before {\n  content: \"\\E158\";\n}\n\n.glyphicon-collapse-down:before {\n  content: \"\\E159\";\n}\n\n.glyphicon-collapse-up:before {\n  content: \"\\E160\";\n}\n\n.glyphicon-log-in:before {\n  content: \"\\E161\";\n}\n\n.glyphicon-flash:before {\n  content: \"\\E162\";\n}\n\n.glyphicon-log-out:before {\n  content: \"\\E163\";\n}\n\n.glyphicon-new-window:before {\n  content: \"\\E164\";\n}\n\n.glyphicon-record:before {\n  content: \"\\E165\";\n}\n\n.glyphicon-save:before {\n  content: \"\\E166\";\n}\n\n.glyphicon-open:before {\n  content: \"\\E167\";\n}\n\n.glyphicon-saved:before {\n  content: \"\\E168\";\n}\n\n.glyphicon-import:before {\n  content: \"\\E169\";\n}\n\n.glyphicon-export:before {\n  content: \"\\E170\";\n}\n\n.glyphicon-send:before {\n  content: \"\\E171\";\n}\n\n.glyphicon-floppy-disk:before {\n  content: \"\\E172\";\n}\n\n.glyphicon-floppy-saved:before {\n  content: \"\\E173\";\n}\n\n.glyphicon-floppy-remove:before {\n  content: \"\\E174\";\n}\n\n.glyphicon-floppy-save:before {\n  content: \"\\E175\";\n}\n\n.glyphicon-floppy-open:before {\n  content: \"\\E176\";\n}\n\n.glyphicon-credit-card:before {\n  content: \"\\E177\";\n}\n\n.glyphicon-transfer:before {\n  content: \"\\E178\";\n}\n\n.glyphicon-cutlery:before {\n  content: \"\\E179\";\n}\n\n.glyphicon-header:before {\n  content: \"\\E180\";\n}\n\n.glyphicon-compressed:before {\n  content: \"\\E181\";\n}\n\n.glyphicon-earphone:before {\n  content: \"\\E182\";\n}\n\n.glyphicon-phone-alt:before {\n  content: \"\\E183\";\n}\n\n.glyphicon-tower:before {\n  content: \"\\E184\";\n}\n\n.glyphicon-stats:before {\n  content: \"\\E185\";\n}\n\n.glyphicon-sd-video:before {\n  content: \"\\E186\";\n}\n\n.glyphicon-hd-video:before {\n  content: \"\\E187\";\n}\n\n.glyphicon-subtitles:before {\n  content: \"\\E188\";\n}\n\n.glyphicon-sound-stereo:before {\n  content: \"\\E189\";\n}\n\n.glyphicon-sound-dolby:before {\n  content: \"\\E190\";\n}\n\n.glyphicon-sound-5-1:before {\n  content: \"\\E191\";\n}\n\n.glyphicon-sound-6-1:before {\n  content: \"\\E192\";\n}\n\n.glyphicon-sound-7-1:before {\n  content: \"\\E193\";\n}\n\n.glyphicon-copyright-mark:before {\n  content: \"\\E194\";\n}\n\n.glyphicon-registration-mark:before {\n  content: \"\\E195\";\n}\n\n.glyphicon-cloud-download:before {\n  content: \"\\E197\";\n}\n\n.glyphicon-cloud-upload:before {\n  content: \"\\E198\";\n}\n\n.glyphicon-tree-conifer:before {\n  content: \"\\E199\";\n}\n\n.glyphicon-tree-deciduous:before {\n  content: \"\\E200\";\n}\n\n.glyphicon-cd:before {\n  content: \"\\E201\";\n}\n\n.glyphicon-save-file:before {\n  content: \"\\E202\";\n}\n\n.glyphicon-open-file:before {\n  content: \"\\E203\";\n}\n\n.glyphicon-level-up:before {\n  content: \"\\E204\";\n}\n\n.glyphicon-copy:before {\n  content: \"\\E205\";\n}\n\n.glyphicon-paste:before {\n  content: \"\\E206\";\n}\n\n.glyphicon-alert:before {\n  content: \"\\E209\";\n}\n\n.glyphicon-equalizer:before {\n  content: \"\\E210\";\n}\n\n.glyphicon-king:before {\n  content: \"\\E211\";\n}\n\n.glyphicon-queen:before {\n  content: \"\\E212\";\n}\n\n.glyphicon-pawn:before {\n  content: \"\\E213\";\n}\n\n.glyphicon-bishop:before {\n  content: \"\\E214\";\n}\n\n.glyphicon-knight:before {\n  content: \"\\E215\";\n}\n\n.glyphicon-baby-formula:before {\n  content: \"\\E216\";\n}\n\n.glyphicon-tent:before {\n  content: \"\\26FA\";\n}\n\n.glyphicon-blackboard:before {\n  content: \"\\E218\";\n}\n\n.glyphicon-bed:before {\n  content: \"\\E219\";\n}\n\n.glyphicon-apple:before {\n  content: \"\\F8FF\";\n}\n\n.glyphicon-erase:before {\n  content: \"\\E221\";\n}\n\n.glyphicon-hourglass:before {\n  content: \"\\231B\";\n}\n\n.glyphicon-lamp:before {\n  content: \"\\E223\";\n}\n\n.glyphicon-duplicate:before {\n  content: \"\\E224\";\n}\n\n.glyphicon-piggy-bank:before {\n  content: \"\\E225\";\n}\n\n.glyphicon-scissors:before {\n  content: \"\\E226\";\n}\n\n.glyphicon-bitcoin:before {\n  content: \"\\E227\";\n}\n\n.glyphicon-btc:before {\n  content: \"\\E227\";\n}\n\n.glyphicon-xbt:before {\n  content: \"\\E227\";\n}\n\n.glyphicon-yen:before {\n  content: \"\\A5\";\n}\n\n.glyphicon-jpy:before {\n  content: \"\\A5\";\n}\n\n.glyphicon-ruble:before {\n  content: \"\\20BD\";\n}\n\n.glyphicon-rub:before {\n  content: \"\\20BD\";\n}\n\n.glyphicon-scale:before {\n  content: \"\\E230\";\n}\n\n.glyphicon-ice-lolly:before {\n  content: \"\\E231\";\n}\n\n.glyphicon-ice-lolly-tasted:before {\n  content: \"\\E232\";\n}\n\n.glyphicon-education:before {\n  content: \"\\E233\";\n}\n\n.glyphicon-option-horizontal:before {\n  content: \"\\E234\";\n}\n\n.glyphicon-option-vertical:before {\n  content: \"\\E235\";\n}\n\n.glyphicon-menu-hamburger:before {\n  content: \"\\E236\";\n}\n\n.glyphicon-modal-window:before {\n  content: \"\\E237\";\n}\n\n.glyphicon-oil:before {\n  content: \"\\E238\";\n}\n\n.glyphicon-grain:before {\n  content: \"\\E239\";\n}\n\n.glyphicon-sunglasses:before {\n  content: \"\\E240\";\n}\n\n.glyphicon-text-size:before {\n  content: \"\\E241\";\n}\n\n.glyphicon-text-color:before {\n  content: \"\\E242\";\n}\n\n.glyphicon-text-background:before {\n  content: \"\\E243\";\n}\n\n.glyphicon-object-align-top:before {\n  content: \"\\E244\";\n}\n\n.glyphicon-object-align-bottom:before {\n  content: \"\\E245\";\n}\n\n.glyphicon-object-align-horizontal:before {\n  content: \"\\E246\";\n}\n\n.glyphicon-object-align-left:before {\n  content: \"\\E247\";\n}\n\n.glyphicon-object-align-vertical:before {\n  content: \"\\E248\";\n}\n\n.glyphicon-object-align-right:before {\n  content: \"\\E249\";\n}\n\n.glyphicon-triangle-right:before {\n  content: \"\\E250\";\n}\n\n.glyphicon-triangle-left:before {\n  content: \"\\E251\";\n}\n\n.glyphicon-triangle-bottom:before {\n  content: \"\\E252\";\n}\n\n.glyphicon-triangle-top:before {\n  content: \"\\E253\";\n}\n\n.glyphicon-console:before {\n  content: \"\\E254\";\n}\n\n.glyphicon-superscript:before {\n  content: \"\\E255\";\n}\n\n.glyphicon-subscript:before {\n  content: \"\\E256\";\n}\n\n.glyphicon-menu-left:before {\n  content: \"\\E257\";\n}\n\n.glyphicon-menu-right:before {\n  content: \"\\E258\";\n}\n\n.glyphicon-menu-down:before {\n  content: \"\\E259\";\n}\n\n.glyphicon-menu-up:before {\n  content: \"\\E260\";\n}\n\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\nhtml {\n  font-size: 10px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nbody {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #333333;\n  background-color: #fff;\n}\n\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n\na:hover,\na:focus {\n  color: #23527c;\n  text-decoration: underline;\n}\n\na:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n\nfigure {\n  margin: 0;\n}\n\nimg {\n  vertical-align: middle;\n}\n\n.img-responsive {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n.img-rounded {\n  border-radius: 6px;\n}\n\n.img-thumbnail {\n  padding: 4px;\n  line-height: 1.42857;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  -webkit-transition: all 0.2s ease-in-out;\n  -o-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n}\n\n.img-circle {\n  border-radius: 50%;\n}\n\nhr {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 1px solid #eeeeee;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\n\nh1 small,\nh1 .small,\nh2 small,\nh2 .small,\nh3 small,\nh3 .small,\nh4 small,\nh4 .small,\nh5 small,\nh5 .small,\nh6 small,\nh6 .small,\n.h1 small,\n.h1 .small,\n.h2 small,\n.h2 .small,\n.h3 small,\n.h3 .small,\n.h4 small,\n.h4 .small,\n.h5 small,\n.h5 .small,\n.h6 small,\n.h6 .small {\n  font-weight: normal;\n  line-height: 1;\n  color: #777777;\n}\n\nh1,\n.h1,\nh2,\n.h2,\nh3,\n.h3 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\nh1 small,\nh1 .small,\n.h1 small,\n.h1 .small,\nh2 small,\nh2 .small,\n.h2 small,\n.h2 .small,\nh3 small,\nh3 .small,\n.h3 small,\n.h3 .small {\n  font-size: 65%;\n}\n\nh4,\n.h4,\nh5,\n.h5,\nh6,\n.h6 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\nh4 small,\nh4 .small,\n.h4 small,\n.h4 .small,\nh5 small,\nh5 .small,\n.h5 small,\n.h5 .small,\nh6 small,\nh6 .small,\n.h6 small,\n.h6 .small {\n  font-size: 75%;\n}\n\nh1,\n.h1 {\n  font-size: 36px;\n}\n\nh2,\n.h2 {\n  font-size: 30px;\n}\n\nh3,\n.h3 {\n  font-size: 24px;\n}\n\nh4,\n.h4 {\n  font-size: 18px;\n}\n\nh5,\n.h5 {\n  font-size: 14px;\n}\n\nh6,\n.h6 {\n  font-size: 12px;\n}\n\np {\n  margin: 0 0 10px;\n}\n\n.lead {\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 1.4;\n}\n\n@media (min-width: 768px) {\n  .lead {\n    font-size: 21px;\n  }\n}\n\nsmall,\n.small {\n  font-size: 85%;\n}\n\nmark,\n.mark {\n  background-color: #fcf8e3;\n  padding: .2em;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-justify {\n  text-align: justify;\n}\n\n.text-nowrap {\n  white-space: nowrap;\n}\n\n.text-lowercase {\n  text-transform: lowercase;\n}\n\n.text-uppercase,\n.initialism {\n  text-transform: uppercase;\n}\n\n.text-capitalize {\n  text-transform: capitalize;\n}\n\n.text-muted {\n  color: #777777;\n}\n\n.text-primary {\n  color: #337ab7;\n}\n\na.text-primary:hover,\na.text-primary:focus {\n  color: #286090;\n}\n\n.text-success {\n  color: #3c763d;\n}\n\na.text-success:hover,\na.text-success:focus {\n  color: #2b542c;\n}\n\n.text-info {\n  color: #31708f;\n}\n\na.text-info:hover,\na.text-info:focus {\n  color: #245269;\n}\n\n.text-warning {\n  color: #8a6d3b;\n}\n\na.text-warning:hover,\na.text-warning:focus {\n  color: #66512c;\n}\n\n.text-danger {\n  color: #a94442;\n}\n\na.text-danger:hover,\na.text-danger:focus {\n  color: #843534;\n}\n\n.bg-primary {\n  color: #fff;\n}\n\n.bg-primary {\n  background-color: #337ab7;\n}\n\na.bg-primary:hover,\na.bg-primary:focus {\n  background-color: #286090;\n}\n\n.bg-success {\n  background-color: #dff0d8;\n}\n\na.bg-success:hover,\na.bg-success:focus {\n  background-color: #c1e2b3;\n}\n\n.bg-info {\n  background-color: #d9edf7;\n}\n\na.bg-info:hover,\na.bg-info:focus {\n  background-color: #afd9ee;\n}\n\n.bg-warning {\n  background-color: #fcf8e3;\n}\n\na.bg-warning:hover,\na.bg-warning:focus {\n  background-color: #f7ecb5;\n}\n\n.bg-danger {\n  background-color: #f2dede;\n}\n\na.bg-danger:hover,\na.bg-danger:focus {\n  background-color: #e4b9b9;\n}\n\n.page-header {\n  padding-bottom: 9px;\n  margin: 40px 0 20px;\n  border-bottom: 1px solid #eeeeee;\n}\n\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n\nul ul,\nul ol,\nol ul,\nol ol {\n  margin-bottom: 0;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n  margin-left: -5px;\n}\n\n.list-inline > li {\n  display: inline-block;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\ndl {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\ndt,\ndd {\n  line-height: 1.42857;\n}\n\ndt {\n  font-weight: bold;\n}\n\ndd {\n  margin-left: 0;\n}\n\n.dl-horizontal dd:before,\n.dl-horizontal dd:after {\n  content: \" \";\n  display: table;\n}\n\n.dl-horizontal dd:after {\n  clear: both;\n}\n\n@media (min-width: 768px) {\n  .dl-horizontal dt {\n    float: left;\n    width: 160px;\n    clear: left;\n    text-align: right;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .dl-horizontal dd {\n    margin-left: 180px;\n  }\n}\n\nabbr[title],\nabbr[data-original-title] {\n  cursor: help;\n  border-bottom: 1px dotted #777777;\n}\n\n.initialism {\n  font-size: 90%;\n}\n\nblockquote {\n  padding: 10px 20px;\n  margin: 0 0 20px;\n  font-size: 17.5px;\n  border-left: 5px solid #eeeeee;\n}\n\nblockquote p:last-child,\nblockquote ul:last-child,\nblockquote ol:last-child {\n  margin-bottom: 0;\n}\n\nblockquote footer,\nblockquote small,\nblockquote .small {\n  display: block;\n  font-size: 80%;\n  line-height: 1.42857;\n  color: #777777;\n}\n\nblockquote footer:before,\nblockquote small:before,\nblockquote .small:before {\n  content: '\\2014   \\A0';\n}\n\n.blockquote-reverse,\nblockquote.pull-right {\n  padding-right: 15px;\n  padding-left: 0;\n  border-right: 5px solid #eeeeee;\n  border-left: 0;\n  text-align: right;\n}\n\n.blockquote-reverse footer:before,\n.blockquote-reverse small:before,\n.blockquote-reverse .small:before,\nblockquote.pull-right footer:before,\nblockquote.pull-right small:before,\nblockquote.pull-right .small:before {\n  content: '';\n}\n\n.blockquote-reverse footer:after,\n.blockquote-reverse small:after,\n.blockquote-reverse .small:after,\nblockquote.pull-right footer:after,\nblockquote.pull-right small:after,\nblockquote.pull-right .small:after {\n  content: '\\A0   \\2014';\n}\n\naddress {\n  margin-bottom: 20px;\n  font-style: normal;\n  line-height: 1.42857;\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\ncode {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #c7254e;\n  background-color: #f9f2f4;\n  border-radius: 4px;\n}\n\nkbd {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: #fff;\n  background-color: #333;\n  border-radius: 3px;\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: bold;\n  box-shadow: none;\n}\n\npre {\n  display: block;\n  padding: 9.5px;\n  margin: 0 0 10px;\n  font-size: 13px;\n  line-height: 1.42857;\n  word-break: break-all;\n  word-wrap: break-word;\n  color: #333333;\n  background-color: #f5f5f5;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\npre code {\n  padding: 0;\n  font-size: inherit;\n  color: inherit;\n  white-space: pre-wrap;\n  background-color: transparent;\n  border-radius: 0;\n}\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n\n.container {\n  margin-right: auto;\n  margin-left: auto;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.container:before,\n.container:after {\n  content: \" \";\n  display: table;\n}\n\n.container:after {\n  clear: both;\n}\n\n@media (min-width: 768px) {\n  .container {\n    width: 750px;\n  }\n}\n\n@media (min-width: 992px) {\n  .container {\n    width: 970px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .container {\n    width: 1170px;\n  }\n}\n\n.container-fluid {\n  margin-right: auto;\n  margin-left: auto;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.container-fluid:before,\n.container-fluid:after {\n  content: \" \";\n  display: table;\n}\n\n.container-fluid:after {\n  clear: both;\n}\n\n.row {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n\n.row:before,\n.row:after {\n  content: \" \";\n  display: table;\n}\n\n.row:after {\n  clear: both;\n}\n\n.col-xs-1,\n.col-sm-1,\n.col-md-1,\n.col-lg-1,\n.col-xs-2,\n.col-sm-2,\n.col-md-2,\n.col-lg-2,\n.col-xs-3,\n.col-sm-3,\n.col-md-3,\n.col-lg-3,\n.col-xs-4,\n.col-sm-4,\n.col-md-4,\n.col-lg-4,\n.col-xs-5,\n.col-sm-5,\n.col-md-5,\n.col-lg-5,\n.col-xs-6,\n.col-sm-6,\n.col-md-6,\n.col-lg-6,\n.col-xs-7,\n.col-sm-7,\n.col-md-7,\n.col-lg-7,\n.col-xs-8,\n.col-sm-8,\n.col-md-8,\n.col-lg-8,\n.col-xs-9,\n.col-sm-9,\n.col-md-9,\n.col-lg-9,\n.col-xs-10,\n.col-sm-10,\n.col-md-10,\n.col-lg-10,\n.col-xs-11,\n.col-sm-11,\n.col-md-11,\n.col-lg-11,\n.col-xs-12,\n.col-sm-12,\n.col-md-12,\n.col-lg-12 {\n  position: relative;\n  min-height: 1px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.col-xs-1,\n.col-xs-2,\n.col-xs-3,\n.col-xs-4,\n.col-xs-5,\n.col-xs-6,\n.col-xs-7,\n.col-xs-8,\n.col-xs-9,\n.col-xs-10,\n.col-xs-11,\n.col-xs-12 {\n  float: left;\n}\n\n.col-xs-1 {\n  width: 8.33333%;\n}\n\n.col-xs-2 {\n  width: 16.66667%;\n}\n\n.col-xs-3 {\n  width: 25%;\n}\n\n.col-xs-4 {\n  width: 33.33333%;\n}\n\n.col-xs-5 {\n  width: 41.66667%;\n}\n\n.col-xs-6 {\n  width: 50%;\n}\n\n.col-xs-7 {\n  width: 58.33333%;\n}\n\n.col-xs-8 {\n  width: 66.66667%;\n}\n\n.col-xs-9 {\n  width: 75%;\n}\n\n.col-xs-10 {\n  width: 83.33333%;\n}\n\n.col-xs-11 {\n  width: 91.66667%;\n}\n\n.col-xs-12 {\n  width: 100%;\n}\n\n.col-xs-pull-0 {\n  right: auto;\n}\n\n.col-xs-pull-1 {\n  right: 8.33333%;\n}\n\n.col-xs-pull-2 {\n  right: 16.66667%;\n}\n\n.col-xs-pull-3 {\n  right: 25%;\n}\n\n.col-xs-pull-4 {\n  right: 33.33333%;\n}\n\n.col-xs-pull-5 {\n  right: 41.66667%;\n}\n\n.col-xs-pull-6 {\n  right: 50%;\n}\n\n.col-xs-pull-7 {\n  right: 58.33333%;\n}\n\n.col-xs-pull-8 {\n  right: 66.66667%;\n}\n\n.col-xs-pull-9 {\n  right: 75%;\n}\n\n.col-xs-pull-10 {\n  right: 83.33333%;\n}\n\n.col-xs-pull-11 {\n  right: 91.66667%;\n}\n\n.col-xs-pull-12 {\n  right: 100%;\n}\n\n.col-xs-push-0 {\n  left: auto;\n}\n\n.col-xs-push-1 {\n  left: 8.33333%;\n}\n\n.col-xs-push-2 {\n  left: 16.66667%;\n}\n\n.col-xs-push-3 {\n  left: 25%;\n}\n\n.col-xs-push-4 {\n  left: 33.33333%;\n}\n\n.col-xs-push-5 {\n  left: 41.66667%;\n}\n\n.col-xs-push-6 {\n  left: 50%;\n}\n\n.col-xs-push-7 {\n  left: 58.33333%;\n}\n\n.col-xs-push-8 {\n  left: 66.66667%;\n}\n\n.col-xs-push-9 {\n  left: 75%;\n}\n\n.col-xs-push-10 {\n  left: 83.33333%;\n}\n\n.col-xs-push-11 {\n  left: 91.66667%;\n}\n\n.col-xs-push-12 {\n  left: 100%;\n}\n\n.col-xs-offset-0 {\n  margin-left: 0%;\n}\n\n.col-xs-offset-1 {\n  margin-left: 8.33333%;\n}\n\n.col-xs-offset-2 {\n  margin-left: 16.66667%;\n}\n\n.col-xs-offset-3 {\n  margin-left: 25%;\n}\n\n.col-xs-offset-4 {\n  margin-left: 33.33333%;\n}\n\n.col-xs-offset-5 {\n  margin-left: 41.66667%;\n}\n\n.col-xs-offset-6 {\n  margin-left: 50%;\n}\n\n.col-xs-offset-7 {\n  margin-left: 58.33333%;\n}\n\n.col-xs-offset-8 {\n  margin-left: 66.66667%;\n}\n\n.col-xs-offset-9 {\n  margin-left: 75%;\n}\n\n.col-xs-offset-10 {\n  margin-left: 83.33333%;\n}\n\n.col-xs-offset-11 {\n  margin-left: 91.66667%;\n}\n\n.col-xs-offset-12 {\n  margin-left: 100%;\n}\n\n@media (min-width: 768px) {\n  .col-sm-1,\n  .col-sm-2,\n  .col-sm-3,\n  .col-sm-4,\n  .col-sm-5,\n  .col-sm-6,\n  .col-sm-7,\n  .col-sm-8,\n  .col-sm-9,\n  .col-sm-10,\n  .col-sm-11,\n  .col-sm-12 {\n    float: left;\n  }\n\n  .col-sm-1 {\n    width: 8.33333%;\n  }\n\n  .col-sm-2 {\n    width: 16.66667%;\n  }\n\n  .col-sm-3 {\n    width: 25%;\n  }\n\n  .col-sm-4 {\n    width: 33.33333%;\n  }\n\n  .col-sm-5 {\n    width: 41.66667%;\n  }\n\n  .col-sm-6 {\n    width: 50%;\n  }\n\n  .col-sm-7 {\n    width: 58.33333%;\n  }\n\n  .col-sm-8 {\n    width: 66.66667%;\n  }\n\n  .col-sm-9 {\n    width: 75%;\n  }\n\n  .col-sm-10 {\n    width: 83.33333%;\n  }\n\n  .col-sm-11 {\n    width: 91.66667%;\n  }\n\n  .col-sm-12 {\n    width: 100%;\n  }\n\n  .col-sm-pull-0 {\n    right: auto;\n  }\n\n  .col-sm-pull-1 {\n    right: 8.33333%;\n  }\n\n  .col-sm-pull-2 {\n    right: 16.66667%;\n  }\n\n  .col-sm-pull-3 {\n    right: 25%;\n  }\n\n  .col-sm-pull-4 {\n    right: 33.33333%;\n  }\n\n  .col-sm-pull-5 {\n    right: 41.66667%;\n  }\n\n  .col-sm-pull-6 {\n    right: 50%;\n  }\n\n  .col-sm-pull-7 {\n    right: 58.33333%;\n  }\n\n  .col-sm-pull-8 {\n    right: 66.66667%;\n  }\n\n  .col-sm-pull-9 {\n    right: 75%;\n  }\n\n  .col-sm-pull-10 {\n    right: 83.33333%;\n  }\n\n  .col-sm-pull-11 {\n    right: 91.66667%;\n  }\n\n  .col-sm-pull-12 {\n    right: 100%;\n  }\n\n  .col-sm-push-0 {\n    left: auto;\n  }\n\n  .col-sm-push-1 {\n    left: 8.33333%;\n  }\n\n  .col-sm-push-2 {\n    left: 16.66667%;\n  }\n\n  .col-sm-push-3 {\n    left: 25%;\n  }\n\n  .col-sm-push-4 {\n    left: 33.33333%;\n  }\n\n  .col-sm-push-5 {\n    left: 41.66667%;\n  }\n\n  .col-sm-push-6 {\n    left: 50%;\n  }\n\n  .col-sm-push-7 {\n    left: 58.33333%;\n  }\n\n  .col-sm-push-8 {\n    left: 66.66667%;\n  }\n\n  .col-sm-push-9 {\n    left: 75%;\n  }\n\n  .col-sm-push-10 {\n    left: 83.33333%;\n  }\n\n  .col-sm-push-11 {\n    left: 91.66667%;\n  }\n\n  .col-sm-push-12 {\n    left: 100%;\n  }\n\n  .col-sm-offset-0 {\n    margin-left: 0%;\n  }\n\n  .col-sm-offset-1 {\n    margin-left: 8.33333%;\n  }\n\n  .col-sm-offset-2 {\n    margin-left: 16.66667%;\n  }\n\n  .col-sm-offset-3 {\n    margin-left: 25%;\n  }\n\n  .col-sm-offset-4 {\n    margin-left: 33.33333%;\n  }\n\n  .col-sm-offset-5 {\n    margin-left: 41.66667%;\n  }\n\n  .col-sm-offset-6 {\n    margin-left: 50%;\n  }\n\n  .col-sm-offset-7 {\n    margin-left: 58.33333%;\n  }\n\n  .col-sm-offset-8 {\n    margin-left: 66.66667%;\n  }\n\n  .col-sm-offset-9 {\n    margin-left: 75%;\n  }\n\n  .col-sm-offset-10 {\n    margin-left: 83.33333%;\n  }\n\n  .col-sm-offset-11 {\n    margin-left: 91.66667%;\n  }\n\n  .col-sm-offset-12 {\n    margin-left: 100%;\n  }\n}\n\n@media (min-width: 992px) {\n  .col-md-1,\n  .col-md-2,\n  .col-md-3,\n  .col-md-4,\n  .col-md-5,\n  .col-md-6,\n  .col-md-7,\n  .col-md-8,\n  .col-md-9,\n  .col-md-10,\n  .col-md-11,\n  .col-md-12 {\n    float: left;\n  }\n\n  .col-md-1 {\n    width: 8.33333%;\n  }\n\n  .col-md-2 {\n    width: 16.66667%;\n  }\n\n  .col-md-3 {\n    width: 25%;\n  }\n\n  .col-md-4 {\n    width: 33.33333%;\n  }\n\n  .col-md-5 {\n    width: 41.66667%;\n  }\n\n  .col-md-6 {\n    width: 50%;\n  }\n\n  .col-md-7 {\n    width: 58.33333%;\n  }\n\n  .col-md-8 {\n    width: 66.66667%;\n  }\n\n  .col-md-9 {\n    width: 75%;\n  }\n\n  .col-md-10 {\n    width: 83.33333%;\n  }\n\n  .col-md-11 {\n    width: 91.66667%;\n  }\n\n  .col-md-12 {\n    width: 100%;\n  }\n\n  .col-md-pull-0 {\n    right: auto;\n  }\n\n  .col-md-pull-1 {\n    right: 8.33333%;\n  }\n\n  .col-md-pull-2 {\n    right: 16.66667%;\n  }\n\n  .col-md-pull-3 {\n    right: 25%;\n  }\n\n  .col-md-pull-4 {\n    right: 33.33333%;\n  }\n\n  .col-md-pull-5 {\n    right: 41.66667%;\n  }\n\n  .col-md-pull-6 {\n    right: 50%;\n  }\n\n  .col-md-pull-7 {\n    right: 58.33333%;\n  }\n\n  .col-md-pull-8 {\n    right: 66.66667%;\n  }\n\n  .col-md-pull-9 {\n    right: 75%;\n  }\n\n  .col-md-pull-10 {\n    right: 83.33333%;\n  }\n\n  .col-md-pull-11 {\n    right: 91.66667%;\n  }\n\n  .col-md-pull-12 {\n    right: 100%;\n  }\n\n  .col-md-push-0 {\n    left: auto;\n  }\n\n  .col-md-push-1 {\n    left: 8.33333%;\n  }\n\n  .col-md-push-2 {\n    left: 16.66667%;\n  }\n\n  .col-md-push-3 {\n    left: 25%;\n  }\n\n  .col-md-push-4 {\n    left: 33.33333%;\n  }\n\n  .col-md-push-5 {\n    left: 41.66667%;\n  }\n\n  .col-md-push-6 {\n    left: 50%;\n  }\n\n  .col-md-push-7 {\n    left: 58.33333%;\n  }\n\n  .col-md-push-8 {\n    left: 66.66667%;\n  }\n\n  .col-md-push-9 {\n    left: 75%;\n  }\n\n  .col-md-push-10 {\n    left: 83.33333%;\n  }\n\n  .col-md-push-11 {\n    left: 91.66667%;\n  }\n\n  .col-md-push-12 {\n    left: 100%;\n  }\n\n  .col-md-offset-0 {\n    margin-left: 0%;\n  }\n\n  .col-md-offset-1 {\n    margin-left: 8.33333%;\n  }\n\n  .col-md-offset-2 {\n    margin-left: 16.66667%;\n  }\n\n  .col-md-offset-3 {\n    margin-left: 25%;\n  }\n\n  .col-md-offset-4 {\n    margin-left: 33.33333%;\n  }\n\n  .col-md-offset-5 {\n    margin-left: 41.66667%;\n  }\n\n  .col-md-offset-6 {\n    margin-left: 50%;\n  }\n\n  .col-md-offset-7 {\n    margin-left: 58.33333%;\n  }\n\n  .col-md-offset-8 {\n    margin-left: 66.66667%;\n  }\n\n  .col-md-offset-9 {\n    margin-left: 75%;\n  }\n\n  .col-md-offset-10 {\n    margin-left: 83.33333%;\n  }\n\n  .col-md-offset-11 {\n    margin-left: 91.66667%;\n  }\n\n  .col-md-offset-12 {\n    margin-left: 100%;\n  }\n}\n\n@media (min-width: 1200px) {\n  .col-lg-1,\n  .col-lg-2,\n  .col-lg-3,\n  .col-lg-4,\n  .col-lg-5,\n  .col-lg-6,\n  .col-lg-7,\n  .col-lg-8,\n  .col-lg-9,\n  .col-lg-10,\n  .col-lg-11,\n  .col-lg-12 {\n    float: left;\n  }\n\n  .col-lg-1 {\n    width: 8.33333%;\n  }\n\n  .col-lg-2 {\n    width: 16.66667%;\n  }\n\n  .col-lg-3 {\n    width: 25%;\n  }\n\n  .col-lg-4 {\n    width: 33.33333%;\n  }\n\n  .col-lg-5 {\n    width: 41.66667%;\n  }\n\n  .col-lg-6 {\n    width: 50%;\n  }\n\n  .col-lg-7 {\n    width: 58.33333%;\n  }\n\n  .col-lg-8 {\n    width: 66.66667%;\n  }\n\n  .col-lg-9 {\n    width: 75%;\n  }\n\n  .col-lg-10 {\n    width: 83.33333%;\n  }\n\n  .col-lg-11 {\n    width: 91.66667%;\n  }\n\n  .col-lg-12 {\n    width: 100%;\n  }\n\n  .col-lg-pull-0 {\n    right: auto;\n  }\n\n  .col-lg-pull-1 {\n    right: 8.33333%;\n  }\n\n  .col-lg-pull-2 {\n    right: 16.66667%;\n  }\n\n  .col-lg-pull-3 {\n    right: 25%;\n  }\n\n  .col-lg-pull-4 {\n    right: 33.33333%;\n  }\n\n  .col-lg-pull-5 {\n    right: 41.66667%;\n  }\n\n  .col-lg-pull-6 {\n    right: 50%;\n  }\n\n  .col-lg-pull-7 {\n    right: 58.33333%;\n  }\n\n  .col-lg-pull-8 {\n    right: 66.66667%;\n  }\n\n  .col-lg-pull-9 {\n    right: 75%;\n  }\n\n  .col-lg-pull-10 {\n    right: 83.33333%;\n  }\n\n  .col-lg-pull-11 {\n    right: 91.66667%;\n  }\n\n  .col-lg-pull-12 {\n    right: 100%;\n  }\n\n  .col-lg-push-0 {\n    left: auto;\n  }\n\n  .col-lg-push-1 {\n    left: 8.33333%;\n  }\n\n  .col-lg-push-2 {\n    left: 16.66667%;\n  }\n\n  .col-lg-push-3 {\n    left: 25%;\n  }\n\n  .col-lg-push-4 {\n    left: 33.33333%;\n  }\n\n  .col-lg-push-5 {\n    left: 41.66667%;\n  }\n\n  .col-lg-push-6 {\n    left: 50%;\n  }\n\n  .col-lg-push-7 {\n    left: 58.33333%;\n  }\n\n  .col-lg-push-8 {\n    left: 66.66667%;\n  }\n\n  .col-lg-push-9 {\n    left: 75%;\n  }\n\n  .col-lg-push-10 {\n    left: 83.33333%;\n  }\n\n  .col-lg-push-11 {\n    left: 91.66667%;\n  }\n\n  .col-lg-push-12 {\n    left: 100%;\n  }\n\n  .col-lg-offset-0 {\n    margin-left: 0%;\n  }\n\n  .col-lg-offset-1 {\n    margin-left: 8.33333%;\n  }\n\n  .col-lg-offset-2 {\n    margin-left: 16.66667%;\n  }\n\n  .col-lg-offset-3 {\n    margin-left: 25%;\n  }\n\n  .col-lg-offset-4 {\n    margin-left: 33.33333%;\n  }\n\n  .col-lg-offset-5 {\n    margin-left: 41.66667%;\n  }\n\n  .col-lg-offset-6 {\n    margin-left: 50%;\n  }\n\n  .col-lg-offset-7 {\n    margin-left: 58.33333%;\n  }\n\n  .col-lg-offset-8 {\n    margin-left: 66.66667%;\n  }\n\n  .col-lg-offset-9 {\n    margin-left: 75%;\n  }\n\n  .col-lg-offset-10 {\n    margin-left: 83.33333%;\n  }\n\n  .col-lg-offset-11 {\n    margin-left: 91.66667%;\n  }\n\n  .col-lg-offset-12 {\n    margin-left: 100%;\n  }\n}\n\ntable {\n  background-color: transparent;\n}\n\ncaption {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: #777777;\n  text-align: left;\n}\n\nth {\n  text-align: left;\n}\n\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px;\n}\n\n.table > thead > tr > th,\n.table > thead > tr > td,\n.table > tbody > tr > th,\n.table > tbody > tr > td,\n.table > tfoot > tr > th,\n.table > tfoot > tr > td {\n  padding: 8px;\n  line-height: 1.42857;\n  vertical-align: top;\n  border-top: 1px solid #ddd;\n}\n\n.table > thead > tr > th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #ddd;\n}\n\n.table > caption + thead > tr:first-child > th,\n.table > caption + thead > tr:first-child > td,\n.table > colgroup + thead > tr:first-child > th,\n.table > colgroup + thead > tr:first-child > td,\n.table > thead:first-child > tr:first-child > th,\n.table > thead:first-child > tr:first-child > td {\n  border-top: 0;\n}\n\n.table > tbody + tbody {\n  border-top: 2px solid #ddd;\n}\n\n.table .table {\n  background-color: #fff;\n}\n\n.table-condensed > thead > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > tbody > tr > th,\n.table-condensed > tbody > tr > td,\n.table-condensed > tfoot > tr > th,\n.table-condensed > tfoot > tr > td {\n  padding: 5px;\n}\n\n.table-bordered {\n  border: 1px solid #ddd;\n}\n\n.table-bordered > thead > tr > th,\n.table-bordered > thead > tr > td,\n.table-bordered > tbody > tr > th,\n.table-bordered > tbody > tr > td,\n.table-bordered > tfoot > tr > th,\n.table-bordered > tfoot > tr > td {\n  border: 1px solid #ddd;\n}\n\n.table-bordered > thead > tr > th,\n.table-bordered > thead > tr > td {\n  border-bottom-width: 2px;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) {\n  background-color: #f9f9f9;\n}\n\n.table-hover > tbody > tr:hover {\n  background-color: #f5f5f5;\n}\n\ntable col[class*=\"col-\"] {\n  position: static;\n  float: none;\n  display: table-column;\n}\n\ntable td[class*=\"col-\"],\ntable th[class*=\"col-\"] {\n  position: static;\n  float: none;\n  display: table-cell;\n}\n\n.table > thead > tr > td.active,\n.table > thead > tr > th.active,\n.table > thead > tr.active > td,\n.table > thead > tr.active > th,\n.table > tbody > tr > td.active,\n.table > tbody > tr > th.active,\n.table > tbody > tr.active > td,\n.table > tbody > tr.active > th,\n.table > tfoot > tr > td.active,\n.table > tfoot > tr > th.active,\n.table > tfoot > tr.active > td,\n.table > tfoot > tr.active > th {\n  background-color: #f5f5f5;\n}\n\n.table-hover > tbody > tr > td.active:hover,\n.table-hover > tbody > tr > th.active:hover,\n.table-hover > tbody > tr.active:hover > td,\n.table-hover > tbody > tr:hover > .active,\n.table-hover > tbody > tr.active:hover > th {\n  background-color: #e8e8e8;\n}\n\n.table > thead > tr > td.success,\n.table > thead > tr > th.success,\n.table > thead > tr.success > td,\n.table > thead > tr.success > th,\n.table > tbody > tr > td.success,\n.table > tbody > tr > th.success,\n.table > tbody > tr.success > td,\n.table > tbody > tr.success > th,\n.table > tfoot > tr > td.success,\n.table > tfoot > tr > th.success,\n.table > tfoot > tr.success > td,\n.table > tfoot > tr.success > th {\n  background-color: #dff0d8;\n}\n\n.table-hover > tbody > tr > td.success:hover,\n.table-hover > tbody > tr > th.success:hover,\n.table-hover > tbody > tr.success:hover > td,\n.table-hover > tbody > tr:hover > .success,\n.table-hover > tbody > tr.success:hover > th {\n  background-color: #d0e9c6;\n}\n\n.table > thead > tr > td.info,\n.table > thead > tr > th.info,\n.table > thead > tr.info > td,\n.table > thead > tr.info > th,\n.table > tbody > tr > td.info,\n.table > tbody > tr > th.info,\n.table > tbody > tr.info > td,\n.table > tbody > tr.info > th,\n.table > tfoot > tr > td.info,\n.table > tfoot > tr > th.info,\n.table > tfoot > tr.info > td,\n.table > tfoot > tr.info > th {\n  background-color: #d9edf7;\n}\n\n.table-hover > tbody > tr > td.info:hover,\n.table-hover > tbody > tr > th.info:hover,\n.table-hover > tbody > tr.info:hover > td,\n.table-hover > tbody > tr:hover > .info,\n.table-hover > tbody > tr.info:hover > th {\n  background-color: #c4e3f3;\n}\n\n.table > thead > tr > td.warning,\n.table > thead > tr > th.warning,\n.table > thead > tr.warning > td,\n.table > thead > tr.warning > th,\n.table > tbody > tr > td.warning,\n.table > tbody > tr > th.warning,\n.table > tbody > tr.warning > td,\n.table > tbody > tr.warning > th,\n.table > tfoot > tr > td.warning,\n.table > tfoot > tr > th.warning,\n.table > tfoot > tr.warning > td,\n.table > tfoot > tr.warning > th {\n  background-color: #fcf8e3;\n}\n\n.table-hover > tbody > tr > td.warning:hover,\n.table-hover > tbody > tr > th.warning:hover,\n.table-hover > tbody > tr.warning:hover > td,\n.table-hover > tbody > tr:hover > .warning,\n.table-hover > tbody > tr.warning:hover > th {\n  background-color: #faf2cc;\n}\n\n.table > thead > tr > td.danger,\n.table > thead > tr > th.danger,\n.table > thead > tr.danger > td,\n.table > thead > tr.danger > th,\n.table > tbody > tr > td.danger,\n.table > tbody > tr > th.danger,\n.table > tbody > tr.danger > td,\n.table > tbody > tr.danger > th,\n.table > tfoot > tr > td.danger,\n.table > tfoot > tr > th.danger,\n.table > tfoot > tr.danger > td,\n.table > tfoot > tr.danger > th {\n  background-color: #f2dede;\n}\n\n.table-hover > tbody > tr > td.danger:hover,\n.table-hover > tbody > tr > th.danger:hover,\n.table-hover > tbody > tr.danger:hover > td,\n.table-hover > tbody > tr:hover > .danger,\n.table-hover > tbody > tr.danger:hover > th {\n  background-color: #ebcccc;\n}\n\n.table-responsive {\n  overflow-x: auto;\n  min-height: 0.01%;\n}\n\n@media screen and (max-width: 767px) {\n  .table-responsive {\n    width: 100%;\n    margin-bottom: 15px;\n    overflow-y: hidden;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: 1px solid #ddd;\n  }\n\n  .table-responsive > .table {\n    margin-bottom: 0;\n  }\n\n  .table-responsive > .table > thead > tr > th,\n  .table-responsive > .table > thead > tr > td,\n  .table-responsive > .table > tbody > tr > th,\n  .table-responsive > .table > tbody > tr > td,\n  .table-responsive > .table > tfoot > tr > th,\n  .table-responsive > .table > tfoot > tr > td {\n    white-space: nowrap;\n  }\n\n  .table-responsive > .table-bordered {\n    border: 0;\n  }\n\n  .table-responsive > .table-bordered > thead > tr > th:first-child,\n  .table-responsive > .table-bordered > thead > tr > td:first-child,\n  .table-responsive > .table-bordered > tbody > tr > th:first-child,\n  .table-responsive > .table-bordered > tbody > tr > td:first-child,\n  .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n  .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n    border-left: 0;\n  }\n\n  .table-responsive > .table-bordered > thead > tr > th:last-child,\n  .table-responsive > .table-bordered > thead > tr > td:last-child,\n  .table-responsive > .table-bordered > tbody > tr > th:last-child,\n  .table-responsive > .table-bordered > tbody > tr > td:last-child,\n  .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n  .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n    border-right: 0;\n  }\n\n  .table-responsive > .table-bordered > tbody > tr:last-child > th,\n  .table-responsive > .table-bordered > tbody > tr:last-child > td,\n  .table-responsive > .table-bordered > tfoot > tr:last-child > th,\n  .table-responsive > .table-bordered > tfoot > tr:last-child > td {\n    border-bottom: 0;\n  }\n}\n\nfieldset {\n  padding: 0;\n  margin: 0;\n  border: 0;\n  min-width: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 20px;\n  font-size: 21px;\n  line-height: inherit;\n  color: #333333;\n  border: 0;\n  border-bottom: 1px solid #e5e5e5;\n}\n\nlabel {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\ninput[type=\"search\"] {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9;\n  line-height: normal;\n}\n\ninput[type=\"file\"] {\n  display: block;\n}\n\ninput[type=\"range\"] {\n  display: block;\n  width: 100%;\n}\n\nselect[multiple],\nselect[size] {\n  height: auto;\n}\n\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n\noutput {\n  display: block;\n  padding-top: 7px;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #555555;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #555555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n\n.form-control:focus {\n  border-color: #66afe9;\n  outline: 0;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n\n.form-control::-moz-placeholder {\n  color: #999;\n  opacity: 1;\n}\n\n.form-control:-ms-input-placeholder {\n  color: #999;\n}\n\n.form-control::-webkit-input-placeholder {\n  color: #999;\n}\n\n.form-control::-ms-expand {\n  border: 0;\n  background-color: transparent;\n}\n\n.form-control[disabled],\n.form-control[readonly],\nfieldset[disabled] .form-control {\n  background-color: #eeeeee;\n  opacity: 1;\n}\n\n.form-control[disabled],\nfieldset[disabled] .form-control {\n  cursor: not-allowed;\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\ninput[type=\"search\"] {\n  -webkit-appearance: none;\n}\n\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  input[type=\"date\"].form-control,\n  input[type=\"time\"].form-control,\n  input[type=\"datetime-local\"].form-control,\n  input[type=\"month\"].form-control {\n    line-height: 34px;\n  }\n\n  input[type=\"date\"].input-sm,\n  .input-group-sm > input.form-control[type=\"date\"],\n  .input-group-sm > input.input-group-addon[type=\"date\"],\n  .input-group-sm > .input-group-btn > input.btn[type=\"date\"],\n  .input-group-sm input[type=\"date\"],\n  input[type=\"time\"].input-sm,\n  .input-group-sm > input.form-control[type=\"time\"],\n  .input-group-sm > input.input-group-addon[type=\"time\"],\n  .input-group-sm > .input-group-btn > input.btn[type=\"time\"],\n  .input-group-sm\n  input[type=\"time\"],\n  input[type=\"datetime-local\"].input-sm,\n  .input-group-sm > input.form-control[type=\"datetime-local\"],\n  .input-group-sm > input.input-group-addon[type=\"datetime-local\"],\n  .input-group-sm > .input-group-btn > input.btn[type=\"datetime-local\"],\n  .input-group-sm\n  input[type=\"datetime-local\"],\n  input[type=\"month\"].input-sm,\n  .input-group-sm > input.form-control[type=\"month\"],\n  .input-group-sm > input.input-group-addon[type=\"month\"],\n  .input-group-sm > .input-group-btn > input.btn[type=\"month\"],\n  .input-group-sm\n  input[type=\"month\"] {\n    line-height: 30px;\n  }\n\n  input[type=\"date\"].input-lg,\n  .input-group-lg > input.form-control[type=\"date\"],\n  .input-group-lg > input.input-group-addon[type=\"date\"],\n  .input-group-lg > .input-group-btn > input.btn[type=\"date\"],\n  .input-group-lg input[type=\"date\"],\n  input[type=\"time\"].input-lg,\n  .input-group-lg > input.form-control[type=\"time\"],\n  .input-group-lg > input.input-group-addon[type=\"time\"],\n  .input-group-lg > .input-group-btn > input.btn[type=\"time\"],\n  .input-group-lg\n  input[type=\"time\"],\n  input[type=\"datetime-local\"].input-lg,\n  .input-group-lg > input.form-control[type=\"datetime-local\"],\n  .input-group-lg > input.input-group-addon[type=\"datetime-local\"],\n  .input-group-lg > .input-group-btn > input.btn[type=\"datetime-local\"],\n  .input-group-lg\n  input[type=\"datetime-local\"],\n  input[type=\"month\"].input-lg,\n  .input-group-lg > input.form-control[type=\"month\"],\n  .input-group-lg > input.input-group-addon[type=\"month\"],\n  .input-group-lg > .input-group-btn > input.btn[type=\"month\"],\n  .input-group-lg\n  input[type=\"month\"] {\n    line-height: 46px;\n  }\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.radio,\n.checkbox {\n  position: relative;\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.radio label,\n.checkbox label {\n  min-height: 20px;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: normal;\n  cursor: pointer;\n}\n\n.radio input[type=\"radio\"],\n.radio-inline input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"],\n.checkbox-inline input[type=\"checkbox\"] {\n  position: absolute;\n  margin-left: -20px;\n  margin-top: 4px \\9;\n}\n\n.radio + .radio,\n.checkbox + .checkbox {\n  margin-top: -5px;\n}\n\n.radio-inline,\n.checkbox-inline {\n  position: relative;\n  display: inline-block;\n  padding-left: 20px;\n  margin-bottom: 0;\n  vertical-align: middle;\n  font-weight: normal;\n  cursor: pointer;\n}\n\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n  margin-left: 10px;\n}\n\ninput[type=\"radio\"][disabled],\ninput[type=\"radio\"].disabled,\nfieldset[disabled] input[type=\"radio\"],\ninput[type=\"checkbox\"][disabled],\ninput[type=\"checkbox\"].disabled,\nfieldset[disabled]\ninput[type=\"checkbox\"] {\n  cursor: not-allowed;\n}\n\n.radio-inline.disabled,\nfieldset[disabled] .radio-inline,\n.checkbox-inline.disabled,\nfieldset[disabled]\n.checkbox-inline {\n  cursor: not-allowed;\n}\n\n.radio.disabled label,\nfieldset[disabled] .radio label,\n.checkbox.disabled label,\nfieldset[disabled]\n.checkbox label {\n  cursor: not-allowed;\n}\n\n.form-control-static {\n  padding-top: 7px;\n  padding-bottom: 7px;\n  margin-bottom: 0;\n  min-height: 34px;\n}\n\n.form-control-static.input-lg,\n.input-group-lg > .form-control-static.form-control,\n.input-group-lg > .form-control-static.input-group-addon,\n.input-group-lg > .input-group-btn > .form-control-static.btn,\n.form-control-static.input-sm,\n.input-group-sm > .form-control-static.form-control,\n.input-group-sm > .form-control-static.input-group-addon,\n.input-group-sm > .input-group-btn > .form-control-static.btn {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.input-sm,\n.input-group-sm > .form-control,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .btn {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n\nselect.input-sm,\n.input-group-sm > select.form-control,\n.input-group-sm > select.input-group-addon,\n.input-group-sm > .input-group-btn > select.btn {\n  height: 30px;\n  line-height: 30px;\n}\n\ntextarea.input-sm,\n.input-group-sm > textarea.form-control,\n.input-group-sm > textarea.input-group-addon,\n.input-group-sm > .input-group-btn > textarea.btn,\nselect[multiple].input-sm,\n.input-group-sm > select.form-control[multiple],\n.input-group-sm > select.input-group-addon[multiple],\n.input-group-sm > .input-group-btn > select.btn[multiple] {\n  height: auto;\n}\n\n.form-group-sm .form-control {\n  height: 30px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n\n.form-group-sm select.form-control {\n  height: 30px;\n  line-height: 30px;\n}\n\n.form-group-sm textarea.form-control,\n.form-group-sm select[multiple].form-control {\n  height: auto;\n}\n\n.form-group-sm .form-control-static {\n  height: 30px;\n  min-height: 32px;\n  padding: 6px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.input-lg,\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n  border-radius: 6px;\n}\n\nselect.input-lg,\n.input-group-lg > select.form-control,\n.input-group-lg > select.input-group-addon,\n.input-group-lg > .input-group-btn > select.btn {\n  height: 46px;\n  line-height: 46px;\n}\n\ntextarea.input-lg,\n.input-group-lg > textarea.form-control,\n.input-group-lg > textarea.input-group-addon,\n.input-group-lg > .input-group-btn > textarea.btn,\nselect[multiple].input-lg,\n.input-group-lg > select.form-control[multiple],\n.input-group-lg > select.input-group-addon[multiple],\n.input-group-lg > .input-group-btn > select.btn[multiple] {\n  height: auto;\n}\n\n.form-group-lg .form-control {\n  height: 46px;\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n  border-radius: 6px;\n}\n\n.form-group-lg select.form-control {\n  height: 46px;\n  line-height: 46px;\n}\n\n.form-group-lg textarea.form-control,\n.form-group-lg select[multiple].form-control {\n  height: auto;\n}\n\n.form-group-lg .form-control-static {\n  height: 46px;\n  min-height: 38px;\n  padding: 11px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n}\n\n.has-feedback {\n  position: relative;\n}\n\n.has-feedback .form-control {\n  padding-right: 42.5px;\n}\n\n.form-control-feedback {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  display: block;\n  width: 34px;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  pointer-events: none;\n}\n\n.input-lg + .form-control-feedback,\n.input-group-lg > .form-control + .form-control-feedback,\n.input-group-lg > .input-group-addon + .form-control-feedback,\n.input-group-lg > .input-group-btn > .btn + .form-control-feedback,\n.input-group-lg + .form-control-feedback,\n.form-group-lg .form-control + .form-control-feedback {\n  width: 46px;\n  height: 46px;\n  line-height: 46px;\n}\n\n.input-sm + .form-control-feedback,\n.input-group-sm > .form-control + .form-control-feedback,\n.input-group-sm > .input-group-addon + .form-control-feedback,\n.input-group-sm > .input-group-btn > .btn + .form-control-feedback,\n.input-group-sm + .form-control-feedback,\n.form-group-sm .form-control + .form-control-feedback {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n}\n\n.has-success .help-block,\n.has-success .control-label,\n.has-success .radio,\n.has-success .checkbox,\n.has-success .radio-inline,\n.has-success .checkbox-inline,\n.has-success.radio label,\n.has-success.checkbox label,\n.has-success.radio-inline label,\n.has-success.checkbox-inline label {\n  color: #3c763d;\n}\n\n.has-success .form-control {\n  border-color: #3c763d;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n\n.has-success .form-control:focus {\n  border-color: #2b542c;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;\n}\n\n.has-success .input-group-addon {\n  color: #3c763d;\n  border-color: #3c763d;\n  background-color: #dff0d8;\n}\n\n.has-success .form-control-feedback {\n  color: #3c763d;\n}\n\n.has-warning .help-block,\n.has-warning .control-label,\n.has-warning .radio,\n.has-warning .checkbox,\n.has-warning .radio-inline,\n.has-warning .checkbox-inline,\n.has-warning.radio label,\n.has-warning.checkbox label,\n.has-warning.radio-inline label,\n.has-warning.checkbox-inline label {\n  color: #8a6d3b;\n}\n\n.has-warning .form-control {\n  border-color: #8a6d3b;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n\n.has-warning .form-control:focus {\n  border-color: #66512c;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;\n}\n\n.has-warning .input-group-addon {\n  color: #8a6d3b;\n  border-color: #8a6d3b;\n  background-color: #fcf8e3;\n}\n\n.has-warning .form-control-feedback {\n  color: #8a6d3b;\n}\n\n.has-error .help-block,\n.has-error .control-label,\n.has-error .radio,\n.has-error .checkbox,\n.has-error .radio-inline,\n.has-error .checkbox-inline,\n.has-error.radio label,\n.has-error.checkbox label,\n.has-error.radio-inline label,\n.has-error.checkbox-inline label {\n  color: #a94442;\n}\n\n.has-error .form-control {\n  border-color: #a94442;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n\n.has-error .form-control:focus {\n  border-color: #843534;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;\n}\n\n.has-error .input-group-addon {\n  color: #a94442;\n  border-color: #a94442;\n  background-color: #f2dede;\n}\n\n.has-error .form-control-feedback {\n  color: #a94442;\n}\n\n.has-feedback label ~ .form-control-feedback {\n  top: 25px;\n}\n\n.has-feedback label.sr-only ~ .form-control-feedback {\n  top: 0;\n}\n\n.help-block {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #737373;\n}\n\n@media (min-width: 768px) {\n  .form-inline .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n\n  .form-inline .form-control-static {\n    display: inline-block;\n  }\n\n  .form-inline .input-group {\n    display: inline-table;\n    vertical-align: middle;\n  }\n\n  .form-inline .input-group .input-group-addon,\n  .form-inline .input-group .input-group-btn,\n  .form-inline .input-group .form-control {\n    width: auto;\n  }\n\n  .form-inline .input-group > .form-control {\n    width: 100%;\n  }\n\n  .form-inline .control-label {\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n\n  .form-inline .radio,\n  .form-inline .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n\n  .form-inline .radio label,\n  .form-inline .checkbox label {\n    padding-left: 0;\n  }\n\n  .form-inline .radio input[type=\"radio\"],\n  .form-inline .checkbox input[type=\"checkbox\"] {\n    position: relative;\n    margin-left: 0;\n  }\n\n  .form-inline .has-feedback .form-control-feedback {\n    top: 0;\n  }\n}\n\n.form-horizontal .radio,\n.form-horizontal .checkbox,\n.form-horizontal .radio-inline,\n.form-horizontal .checkbox-inline {\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-top: 7px;\n}\n\n.form-horizontal .radio,\n.form-horizontal .checkbox {\n  min-height: 27px;\n}\n\n.form-horizontal .form-group {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n\n.form-horizontal .form-group:before,\n.form-horizontal .form-group:after {\n  content: \" \";\n  display: table;\n}\n\n.form-horizontal .form-group:after {\n  clear: both;\n}\n\n@media (min-width: 768px) {\n  .form-horizontal .control-label {\n    text-align: right;\n    margin-bottom: 0;\n    padding-top: 7px;\n  }\n}\n\n.form-horizontal .has-feedback .form-control-feedback {\n  right: 15px;\n}\n\n@media (min-width: 768px) {\n  .form-horizontal .form-group-lg .control-label {\n    padding-top: 11px;\n    font-size: 18px;\n  }\n}\n\n@media (min-width: 768px) {\n  .form-horizontal .form-group-sm .control-label {\n    padding-top: 6px;\n    font-size: 12px;\n  }\n}\n\n.btn {\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: normal;\n  text-align: center;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857;\n  border-radius: 4px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.btn:focus,\n.btn.focus,\n.btn:active:focus,\n.btn:active.focus,\n.btn.active:focus,\n.btn.active.focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n\n.btn:hover,\n.btn:focus,\n.btn.focus {\n  color: #333;\n  text-decoration: none;\n}\n\n.btn:active,\n.btn.active {\n  outline: 0;\n  background-image: none;\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n\n.btn.disabled,\n.btn[disabled],\nfieldset[disabled] .btn {\n  cursor: not-allowed;\n  opacity: 0.65;\n  filter: alpha(opacity=65);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\na.btn.disabled,\nfieldset[disabled] a.btn {\n  pointer-events: none;\n}\n\n.btn-default {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n\n.btn-default:focus,\n.btn-default.focus {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #8c8c8c;\n}\n\n.btn-default:hover {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n\n.btn-default:active,\n.btn-default.active,\n.open > .btn-default.dropdown-toggle {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n\n.btn-default:active:hover,\n.btn-default:active:focus,\n.btn-default:active.focus,\n.btn-default.active:hover,\n.btn-default.active:focus,\n.btn-default.active.focus,\n.open > .btn-default.dropdown-toggle:hover,\n.open > .btn-default.dropdown-toggle:focus,\n.open > .btn-default.dropdown-toggle.focus {\n  color: #333;\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n\n.btn-default:active,\n.btn-default.active,\n.open > .btn-default.dropdown-toggle {\n  background-image: none;\n}\n\n.btn-default.disabled:hover,\n.btn-default.disabled:focus,\n.btn-default.disabled.focus,\n.btn-default[disabled]:hover,\n.btn-default[disabled]:focus,\n.btn-default[disabled].focus,\nfieldset[disabled] .btn-default:hover,\nfieldset[disabled] .btn-default:focus,\nfieldset[disabled] .btn-default.focus {\n  background-color: #fff;\n  border-color: #ccc;\n}\n\n.btn-default .badge {\n  color: #fff;\n  background-color: #333;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n\n.btn-primary:focus,\n.btn-primary.focus {\n  color: #fff;\n  background-color: #286090;\n  border-color: #122b40;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n\n.btn-primary:active,\n.btn-primary.active,\n.open > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n\n.btn-primary:active:hover,\n.btn-primary:active:focus,\n.btn-primary:active.focus,\n.btn-primary.active:hover,\n.btn-primary.active:focus,\n.btn-primary.active.focus,\n.open > .btn-primary.dropdown-toggle:hover,\n.open > .btn-primary.dropdown-toggle:focus,\n.open > .btn-primary.dropdown-toggle.focus {\n  color: #fff;\n  background-color: #204d74;\n  border-color: #122b40;\n}\n\n.btn-primary:active,\n.btn-primary.active,\n.open > .btn-primary.dropdown-toggle {\n  background-image: none;\n}\n\n.btn-primary.disabled:hover,\n.btn-primary.disabled:focus,\n.btn-primary.disabled.focus,\n.btn-primary[disabled]:hover,\n.btn-primary[disabled]:focus,\n.btn-primary[disabled].focus,\nfieldset[disabled] .btn-primary:hover,\nfieldset[disabled] .btn-primary:focus,\nfieldset[disabled] .btn-primary.focus {\n  background-color: #337ab7;\n  border-color: #2e6da4;\n}\n\n.btn-primary .badge {\n  color: #337ab7;\n  background-color: #fff;\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n\n.btn-success:focus,\n.btn-success.focus {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #255625;\n}\n\n.btn-success:hover {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #398439;\n}\n\n.btn-success:active,\n.btn-success.active,\n.open > .btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: #449d44;\n  border-color: #398439;\n}\n\n.btn-success:active:hover,\n.btn-success:active:focus,\n.btn-success:active.focus,\n.btn-success.active:hover,\n.btn-success.active:focus,\n.btn-success.active.focus,\n.open > .btn-success.dropdown-toggle:hover,\n.open > .btn-success.dropdown-toggle:focus,\n.open > .btn-success.dropdown-toggle.focus {\n  color: #fff;\n  background-color: #398439;\n  border-color: #255625;\n}\n\n.btn-success:active,\n.btn-success.active,\n.open > .btn-success.dropdown-toggle {\n  background-image: none;\n}\n\n.btn-success.disabled:hover,\n.btn-success.disabled:focus,\n.btn-success.disabled.focus,\n.btn-success[disabled]:hover,\n.btn-success[disabled]:focus,\n.btn-success[disabled].focus,\nfieldset[disabled] .btn-success:hover,\nfieldset[disabled] .btn-success:focus,\nfieldset[disabled] .btn-success.focus {\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n\n.btn-success .badge {\n  color: #5cb85c;\n  background-color: #fff;\n}\n\n.btn-info {\n  color: #fff;\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n\n.btn-info:focus,\n.btn-info.focus {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #1b6d85;\n}\n\n.btn-info:hover {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #269abc;\n}\n\n.btn-info:active,\n.btn-info.active,\n.open > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: #31b0d5;\n  border-color: #269abc;\n}\n\n.btn-info:active:hover,\n.btn-info:active:focus,\n.btn-info:active.focus,\n.btn-info.active:hover,\n.btn-info.active:focus,\n.btn-info.active.focus,\n.open > .btn-info.dropdown-toggle:hover,\n.open > .btn-info.dropdown-toggle:focus,\n.open > .btn-info.dropdown-toggle.focus {\n  color: #fff;\n  background-color: #269abc;\n  border-color: #1b6d85;\n}\n\n.btn-info:active,\n.btn-info.active,\n.open > .btn-info.dropdown-toggle {\n  background-image: none;\n}\n\n.btn-info.disabled:hover,\n.btn-info.disabled:focus,\n.btn-info.disabled.focus,\n.btn-info[disabled]:hover,\n.btn-info[disabled]:focus,\n.btn-info[disabled].focus,\nfieldset[disabled] .btn-info:hover,\nfieldset[disabled] .btn-info:focus,\nfieldset[disabled] .btn-info.focus {\n  background-color: #5bc0de;\n  border-color: #46b8da;\n}\n\n.btn-info .badge {\n  color: #5bc0de;\n  background-color: #fff;\n}\n\n.btn-warning {\n  color: #fff;\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n\n.btn-warning:focus,\n.btn-warning.focus {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #985f0d;\n}\n\n.btn-warning:hover {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #d58512;\n}\n\n.btn-warning:active,\n.btn-warning.active,\n.open > .btn-warning.dropdown-toggle {\n  color: #fff;\n  background-color: #ec971f;\n  border-color: #d58512;\n}\n\n.btn-warning:active:hover,\n.btn-warning:active:focus,\n.btn-warning:active.focus,\n.btn-warning.active:hover,\n.btn-warning.active:focus,\n.btn-warning.active.focus,\n.open > .btn-warning.dropdown-toggle:hover,\n.open > .btn-warning.dropdown-toggle:focus,\n.open > .btn-warning.dropdown-toggle.focus {\n  color: #fff;\n  background-color: #d58512;\n  border-color: #985f0d;\n}\n\n.btn-warning:active,\n.btn-warning.active,\n.open > .btn-warning.dropdown-toggle {\n  background-image: none;\n}\n\n.btn-warning.disabled:hover,\n.btn-warning.disabled:focus,\n.btn-warning.disabled.focus,\n.btn-warning[disabled]:hover,\n.btn-warning[disabled]:focus,\n.btn-warning[disabled].focus,\nfieldset[disabled] .btn-warning:hover,\nfieldset[disabled] .btn-warning:focus,\nfieldset[disabled] .btn-warning.focus {\n  background-color: #f0ad4e;\n  border-color: #eea236;\n}\n\n.btn-warning .badge {\n  color: #f0ad4e;\n  background-color: #fff;\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n\n.btn-danger:focus,\n.btn-danger.focus {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #761c19;\n}\n\n.btn-danger:hover {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #ac2925;\n}\n\n.btn-danger:active,\n.btn-danger.active,\n.open > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #c9302c;\n  border-color: #ac2925;\n}\n\n.btn-danger:active:hover,\n.btn-danger:active:focus,\n.btn-danger:active.focus,\n.btn-danger.active:hover,\n.btn-danger.active:focus,\n.btn-danger.active.focus,\n.open > .btn-danger.dropdown-toggle:hover,\n.open > .btn-danger.dropdown-toggle:focus,\n.open > .btn-danger.dropdown-toggle.focus {\n  color: #fff;\n  background-color: #ac2925;\n  border-color: #761c19;\n}\n\n.btn-danger:active,\n.btn-danger.active,\n.open > .btn-danger.dropdown-toggle {\n  background-image: none;\n}\n\n.btn-danger.disabled:hover,\n.btn-danger.disabled:focus,\n.btn-danger.disabled.focus,\n.btn-danger[disabled]:hover,\n.btn-danger[disabled]:focus,\n.btn-danger[disabled].focus,\nfieldset[disabled] .btn-danger:hover,\nfieldset[disabled] .btn-danger:focus,\nfieldset[disabled] .btn-danger.focus {\n  background-color: #d9534f;\n  border-color: #d43f3a;\n}\n\n.btn-danger .badge {\n  color: #d9534f;\n  background-color: #fff;\n}\n\n.btn-link {\n  color: #337ab7;\n  font-weight: normal;\n  border-radius: 0;\n}\n\n.btn-link,\n.btn-link:active,\n.btn-link.active,\n.btn-link[disabled],\nfieldset[disabled] .btn-link {\n  background-color: transparent;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.btn-link,\n.btn-link:hover,\n.btn-link:focus,\n.btn-link:active {\n  border-color: transparent;\n}\n\n.btn-link:hover,\n.btn-link:focus {\n  color: #23527c;\n  text-decoration: underline;\n  background-color: transparent;\n}\n\n.btn-link[disabled]:hover,\n.btn-link[disabled]:focus,\nfieldset[disabled] .btn-link:hover,\nfieldset[disabled] .btn-link:focus {\n  color: #777777;\n  text-decoration: none;\n}\n\n.btn-lg,\n.btn-group-lg > .btn {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n  border-radius: 6px;\n}\n\n.btn-sm,\n.btn-group-sm > .btn {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n\n.btn-xs,\n.btn-group-xs > .btn {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n\n.btn-block + .btn-block {\n  margin-top: 5px;\n}\n\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%;\n}\n\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  -o-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n\n.fade.in {\n  opacity: 1;\n}\n\n.collapse {\n  display: none;\n}\n\n.collapse.in {\n  display: block;\n}\n\ntr.collapse.in {\n  display: table-row;\n}\n\ntbody.collapse.in {\n  display: table-row-group;\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  -webkit-transition-property: height, visibility;\n  transition-property: height, visibility;\n  -webkit-transition-duration: 0.35s;\n  transition-duration: 0.35s;\n  -webkit-transition-timing-function: ease;\n  transition-timing-function: ease;\n}\n\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px dashed;\n  border-top: 4px solid \\9;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n\n.dropup,\n.dropdown {\n  position: relative;\n}\n\n.dropdown-toggle:focus {\n  outline: 0;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  list-style: none;\n  font-size: 14px;\n  text-align: left;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n}\n\n.dropdown-menu.pull-right {\n  right: 0;\n  left: auto;\n}\n\n.dropdown-menu .divider {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n\n.dropdown-menu > li > a {\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  font-weight: normal;\n  line-height: 1.42857;\n  color: #333333;\n  white-space: nowrap;\n}\n\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus {\n  text-decoration: none;\n  color: #262626;\n  background-color: #f5f5f5;\n}\n\n.dropdown-menu > .active > a,\n.dropdown-menu > .active > a:hover,\n.dropdown-menu > .active > a:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  background-color: #337ab7;\n}\n\n.dropdown-menu > .disabled > a,\n.dropdown-menu > .disabled > a:hover,\n.dropdown-menu > .disabled > a:focus {\n  color: #777777;\n}\n\n.dropdown-menu > .disabled > a:hover,\n.dropdown-menu > .disabled > a:focus {\n  text-decoration: none;\n  background-color: transparent;\n  background-image: none;\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);\n  cursor: not-allowed;\n}\n\n.open > .dropdown-menu {\n  display: block;\n}\n\n.open > a {\n  outline: 0;\n}\n\n.dropdown-menu-right {\n  left: auto;\n  right: 0;\n}\n\n.dropdown-menu-left {\n  left: 0;\n  right: auto;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 3px 20px;\n  font-size: 12px;\n  line-height: 1.42857;\n  color: #777777;\n  white-space: nowrap;\n}\n\n.dropdown-backdrop {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  z-index: 990;\n}\n\n.pull-right > .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n\n.dropup .caret,\n.navbar-fixed-bottom .dropdown .caret {\n  border-top: 0;\n  border-bottom: 4px dashed;\n  border-bottom: 4px solid \\9;\n  content: \"\";\n}\n\n.dropup .dropdown-menu,\n.navbar-fixed-bottom .dropdown .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 2px;\n}\n\n@media (min-width: 768px) {\n  .navbar-right .dropdown-menu {\n    right: 0;\n    left: auto;\n  }\n\n  .navbar-right .dropdown-menu-left {\n    left: 0;\n    right: auto;\n  }\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  float: left;\n}\n\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 2;\n}\n\n.btn-group .btn + .btn,\n.btn-group .btn + .btn-group,\n.btn-group .btn-group + .btn,\n.btn-group .btn-group + .btn-group {\n  margin-left: -1px;\n}\n\n.btn-toolbar {\n  margin-left: -5px;\n}\n\n.btn-toolbar:before,\n.btn-toolbar:after {\n  content: \" \";\n  display: table;\n}\n\n.btn-toolbar:after {\n  clear: both;\n}\n\n.btn-toolbar .btn,\n.btn-toolbar .btn-group,\n.btn-toolbar .input-group {\n  float: left;\n}\n\n.btn-toolbar > .btn,\n.btn-toolbar > .btn-group,\n.btn-toolbar > .input-group {\n  margin-left: 5px;\n}\n\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n\n.btn-group > .btn:first-child {\n  margin-left: 0;\n}\n\n.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.btn-group > .btn:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n\n.btn-group > .btn-group {\n  float: left;\n}\n\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n\n.btn-group > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n\n.btn-group .dropdown-toggle:active,\n.btn-group.open .dropdown-toggle {\n  outline: 0;\n}\n\n.btn-group > .btn + .dropdown-toggle {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.btn-group > .btn-lg + .dropdown-toggle,\n.btn-group-lg.btn-group > .btn + .dropdown-toggle {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.btn-group.open .dropdown-toggle {\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n\n.btn-group.open .dropdown-toggle.btn-link {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.btn .caret {\n  margin-left: 0;\n}\n\n.btn-lg .caret,\n.btn-group-lg > .btn .caret {\n  border-width: 5px 5px 0;\n  border-bottom-width: 0;\n}\n\n.dropup .btn-lg .caret,\n.dropup .btn-group-lg > .btn .caret {\n  border-width: 0 5px 5px;\n}\n\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group,\n.btn-group-vertical > .btn-group > .btn {\n  display: block;\n  float: none;\n  width: 100%;\n  max-width: 100%;\n}\n\n.btn-group-vertical > .btn-group:before,\n.btn-group-vertical > .btn-group:after {\n  content: \" \";\n  display: table;\n}\n\n.btn-group-vertical > .btn-group:after {\n  clear: both;\n}\n\n.btn-group-vertical > .btn-group > .btn {\n  float: none;\n}\n\n.btn-group-vertical > .btn + .btn,\n.btn-group-vertical > .btn + .btn-group,\n.btn-group-vertical > .btn-group + .btn,\n.btn-group-vertical > .btn-group + .btn-group {\n  margin-top: -1px;\n  margin-left: 0;\n}\n\n.btn-group-vertical > .btn:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n\n.btn-group-vertical > .btn:first-child:not(:last-child) {\n  border-top-right-radius: 4px;\n  border-top-left-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.btn-group-vertical > .btn:last-child:not(:first-child) {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child,\n.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n\n.btn-group-justified {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n}\n\n.btn-group-justified > .btn,\n.btn-group-justified > .btn-group {\n  float: none;\n  display: table-cell;\n  width: 1%;\n}\n\n.btn-group-justified > .btn-group .btn {\n  width: 100%;\n}\n\n.btn-group-justified > .btn-group .dropdown-menu {\n  left: auto;\n}\n\n[data-toggle=\"buttons\"] > .btn input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn input[type=\"checkbox\"],\n[data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"radio\"],\n[data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"checkbox\"] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n}\n\n.input-group[class*=\"col-\"] {\n  float: none;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.input-group .form-control {\n  position: relative;\n  z-index: 2;\n  float: left;\n  width: 100%;\n  margin-bottom: 0;\n}\n\n.input-group .form-control:focus {\n  z-index: 3;\n}\n\n.input-group-addon,\n.input-group-btn,\n.input-group .form-control {\n  display: table-cell;\n}\n\n.input-group-addon:not(:first-child):not(:last-child),\n.input-group-btn:not(:first-child):not(:last-child),\n.input-group .form-control:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n\n.input-group-addon,\n.input-group-btn {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.input-group-addon {\n  padding: 6px 12px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1;\n  color: #555555;\n  text-align: center;\n  background-color: #eeeeee;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.input-group-addon.input-sm,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .input-group-addon.btn {\n  padding: 5px 10px;\n  font-size: 12px;\n  border-radius: 3px;\n}\n\n.input-group-addon.input-lg,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .input-group-addon.btn {\n  padding: 10px 16px;\n  font-size: 18px;\n  border-radius: 6px;\n}\n\n.input-group-addon input[type=\"radio\"],\n.input-group-addon input[type=\"checkbox\"] {\n  margin-top: 0;\n}\n\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .btn-group > .btn,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group-btn:last-child > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.input-group-addon:first-child {\n  border-right: 0;\n}\n\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .btn-group > .btn,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child),\n.input-group-btn:first-child > .btn-group:not(:first-child) > .btn {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n\n.input-group-addon:last-child {\n  border-left: 0;\n}\n\n.input-group-btn {\n  position: relative;\n  font-size: 0;\n  white-space: nowrap;\n}\n\n.input-group-btn > .btn {\n  position: relative;\n}\n\n.input-group-btn > .btn + .btn {\n  margin-left: -1px;\n}\n\n.input-group-btn > .btn:hover,\n.input-group-btn > .btn:focus,\n.input-group-btn > .btn:active {\n  z-index: 2;\n}\n\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .btn-group {\n  margin-right: -1px;\n}\n\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .btn-group {\n  z-index: 2;\n  margin-left: -1px;\n}\n\n.nav {\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none;\n}\n\n.nav:before,\n.nav:after {\n  content: \" \";\n  display: table;\n}\n\n.nav:after {\n  clear: both;\n}\n\n.nav > li {\n  position: relative;\n  display: block;\n}\n\n.nav > li > a {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n}\n\n.nav > li > a:hover,\n.nav > li > a:focus {\n  text-decoration: none;\n  background-color: #eeeeee;\n}\n\n.nav > li.disabled > a {\n  color: #777777;\n}\n\n.nav > li.disabled > a:hover,\n.nav > li.disabled > a:focus {\n  color: #777777;\n  text-decoration: none;\n  background-color: transparent;\n  cursor: not-allowed;\n}\n\n.nav .open > a,\n.nav .open > a:hover,\n.nav .open > a:focus {\n  background-color: #eeeeee;\n  border-color: #337ab7;\n}\n\n.nav .nav-divider {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n\n.nav > li > a > img {\n  max-width: none;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #ddd;\n}\n\n.nav-tabs > li {\n  float: left;\n  margin-bottom: -1px;\n}\n\n.nav-tabs > li > a {\n  margin-right: 2px;\n  line-height: 1.42857;\n  border: 1px solid transparent;\n  border-radius: 4px 4px 0 0;\n}\n\n.nav-tabs > li > a:hover {\n  border-color: #eeeeee #eeeeee #ddd;\n}\n\n.nav-tabs > li.active > a,\n.nav-tabs > li.active > a:hover,\n.nav-tabs > li.active > a:focus {\n  color: #555555;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-bottom-color: transparent;\n  cursor: default;\n}\n\n.nav-pills > li {\n  float: left;\n}\n\n.nav-pills > li > a {\n  border-radius: 4px;\n}\n\n.nav-pills > li + li {\n  margin-left: 2px;\n}\n\n.nav-pills > li.active > a,\n.nav-pills > li.active > a:hover,\n.nav-pills > li.active > a:focus {\n  color: #fff;\n  background-color: #337ab7;\n}\n\n.nav-stacked > li {\n  float: none;\n}\n\n.nav-stacked > li + li {\n  margin-top: 2px;\n  margin-left: 0;\n}\n\n.nav-justified,\n.nav-tabs.nav-justified {\n  width: 100%;\n}\n\n.nav-justified > li,\n.nav-tabs.nav-justified > li {\n  float: none;\n}\n\n.nav-justified > li > a,\n.nav-tabs.nav-justified > li > a {\n  text-align: center;\n  margin-bottom: 5px;\n}\n\n.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n\n@media (min-width: 768px) {\n  .nav-justified > li,\n  .nav-tabs.nav-justified > li {\n    display: table-cell;\n    width: 1%;\n  }\n\n  .nav-justified > li > a,\n  .nav-tabs.nav-justified > li > a {\n    margin-bottom: 0;\n  }\n}\n\n.nav-tabs-justified,\n.nav-tabs.nav-justified {\n  border-bottom: 0;\n}\n\n.nav-tabs-justified > li > a,\n.nav-tabs.nav-justified > li > a {\n  margin-right: 0;\n  border-radius: 4px;\n}\n\n.nav-tabs-justified > .active > a,\n.nav-tabs.nav-justified > .active > a,\n.nav-tabs-justified > .active > a:hover,\n.nav-tabs.nav-justified > .active > a:hover,\n.nav-tabs-justified > .active > a:focus,\n.nav-tabs.nav-justified > .active > a:focus {\n  border: 1px solid #ddd;\n}\n\n@media (min-width: 768px) {\n  .nav-tabs-justified > li > a,\n  .nav-tabs.nav-justified > li > a {\n    border-bottom: 1px solid #ddd;\n    border-radius: 4px 4px 0 0;\n  }\n\n  .nav-tabs-justified > .active > a,\n  .nav-tabs.nav-justified > .active > a,\n  .nav-tabs-justified > .active > a:hover,\n  .nav-tabs.nav-justified > .active > a:hover,\n  .nav-tabs-justified > .active > a:focus,\n  .nav-tabs.nav-justified > .active > a:focus {\n    border-bottom-color: #fff;\n  }\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n\n.tab-content > .active {\n  display: block;\n}\n\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n\n.navbar {\n  position: relative;\n  min-height: 50px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n}\n\n.navbar:before,\n.navbar:after {\n  content: \" \";\n  display: table;\n}\n\n.navbar:after {\n  clear: both;\n}\n\n@media (min-width: 768px) {\n  .navbar {\n    border-radius: 4px;\n  }\n}\n\n.navbar-header:before,\n.navbar-header:after {\n  content: \" \";\n  display: table;\n}\n\n.navbar-header:after {\n  clear: both;\n}\n\n@media (min-width: 768px) {\n  .navbar-header {\n    float: left;\n  }\n}\n\n.navbar-collapse {\n  overflow-x: visible;\n  padding-right: 15px;\n  padding-left: 15px;\n  border-top: 1px solid transparent;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  -webkit-overflow-scrolling: touch;\n}\n\n.navbar-collapse:before,\n.navbar-collapse:after {\n  content: \" \";\n  display: table;\n}\n\n.navbar-collapse:after {\n  clear: both;\n}\n\n.navbar-collapse.in {\n  overflow-y: auto;\n}\n\n@media (min-width: 768px) {\n  .navbar-collapse {\n    width: auto;\n    border-top: 0;\n    box-shadow: none;\n  }\n\n  .navbar-collapse.collapse {\n    display: block !important;\n    height: auto !important;\n    padding-bottom: 0;\n    overflow: visible !important;\n  }\n\n  .navbar-collapse.in {\n    overflow-y: visible;\n  }\n\n  .navbar-fixed-top .navbar-collapse,\n  .navbar-static-top .navbar-collapse,\n  .navbar-fixed-bottom .navbar-collapse {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n.navbar-fixed-top .navbar-collapse,\n.navbar-fixed-bottom .navbar-collapse {\n  max-height: 340px;\n}\n\n@media (max-device-width: 480px) and (orientation: landscape) {\n  .navbar-fixed-top .navbar-collapse,\n  .navbar-fixed-bottom .navbar-collapse {\n    max-height: 200px;\n  }\n}\n\n.container > .navbar-header,\n.container > .navbar-collapse,\n.container-fluid > .navbar-header,\n.container-fluid > .navbar-collapse {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n@media (min-width: 768px) {\n  .container > .navbar-header,\n  .container > .navbar-collapse,\n  .container-fluid > .navbar-header,\n  .container-fluid > .navbar-collapse {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n\n.navbar-static-top {\n  z-index: 1000;\n  border-width: 0 0 1px;\n}\n\n@media (min-width: 768px) {\n  .navbar-static-top {\n    border-radius: 0;\n  }\n}\n\n.navbar-fixed-top,\n.navbar-fixed-bottom {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n@media (min-width: 768px) {\n  .navbar-fixed-top,\n  .navbar-fixed-bottom {\n    border-radius: 0;\n  }\n}\n\n.navbar-fixed-top {\n  top: 0;\n  border-width: 0 0 1px;\n}\n\n.navbar-fixed-bottom {\n  bottom: 0;\n  margin-bottom: 0;\n  border-width: 1px 0 0;\n}\n\n.navbar-brand {\n  float: left;\n  padding: 15px 15px;\n  font-size: 18px;\n  line-height: 20px;\n  height: 50px;\n}\n\n.navbar-brand:hover,\n.navbar-brand:focus {\n  text-decoration: none;\n}\n\n.navbar-brand > img {\n  display: block;\n}\n\n@media (min-width: 768px) {\n  .navbar > .container .navbar-brand,\n  .navbar > .container-fluid .navbar-brand {\n    margin-left: -15px;\n  }\n}\n\n.navbar-toggle {\n  position: relative;\n  float: right;\n  margin-right: 15px;\n  padding: 9px 10px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  background-color: transparent;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n\n.navbar-toggle:focus {\n  outline: 0;\n}\n\n.navbar-toggle .icon-bar {\n  display: block;\n  width: 22px;\n  height: 2px;\n  border-radius: 1px;\n}\n\n.navbar-toggle .icon-bar + .icon-bar {\n  margin-top: 4px;\n}\n\n@media (min-width: 768px) {\n  .navbar-toggle {\n    display: none;\n  }\n}\n\n.navbar-nav {\n  margin: 7.5px -15px;\n}\n\n.navbar-nav > li > a {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  line-height: 20px;\n}\n\n@media (max-width: 767px) {\n  .navbar-nav .open .dropdown-menu {\n    position: static;\n    float: none;\n    width: auto;\n    margin-top: 0;\n    background-color: transparent;\n    border: 0;\n    box-shadow: none;\n  }\n\n  .navbar-nav .open .dropdown-menu > li > a,\n  .navbar-nav .open .dropdown-menu .dropdown-header {\n    padding: 5px 15px 5px 25px;\n  }\n\n  .navbar-nav .open .dropdown-menu > li > a {\n    line-height: 20px;\n  }\n\n  .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-nav .open .dropdown-menu > li > a:focus {\n    background-image: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-nav {\n    float: left;\n    margin: 0;\n  }\n\n  .navbar-nav > li {\n    float: left;\n  }\n\n  .navbar-nav > li > a {\n    padding-top: 15px;\n    padding-bottom: 15px;\n  }\n}\n\n.navbar-form {\n  margin-left: -15px;\n  margin-right: -15px;\n  padding: 10px 15px;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n@media (min-width: 768px) {\n  .navbar-form .form-group {\n    display: inline-block;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n\n  .navbar-form .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n\n  .navbar-form .form-control-static {\n    display: inline-block;\n  }\n\n  .navbar-form .input-group {\n    display: inline-table;\n    vertical-align: middle;\n  }\n\n  .navbar-form .input-group .input-group-addon,\n  .navbar-form .input-group .input-group-btn,\n  .navbar-form .input-group .form-control {\n    width: auto;\n  }\n\n  .navbar-form .input-group > .form-control {\n    width: 100%;\n  }\n\n  .navbar-form .control-label {\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n\n  .navbar-form .radio,\n  .navbar-form .checkbox {\n    display: inline-block;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: middle;\n  }\n\n  .navbar-form .radio label,\n  .navbar-form .checkbox label {\n    padding-left: 0;\n  }\n\n  .navbar-form .radio input[type=\"radio\"],\n  .navbar-form .checkbox input[type=\"checkbox\"] {\n    position: relative;\n    margin-left: 0;\n  }\n\n  .navbar-form .has-feedback .form-control-feedback {\n    top: 0;\n  }\n}\n\n@media (max-width: 767px) {\n  .navbar-form .form-group {\n    margin-bottom: 5px;\n  }\n\n  .navbar-form .form-group:last-child {\n    margin-bottom: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-form {\n    width: auto;\n    border: 0;\n    margin-left: 0;\n    margin-right: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n}\n\n.navbar-nav > li > .dropdown-menu {\n  margin-top: 0;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n\n.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {\n  margin-bottom: 0;\n  border-top-right-radius: 4px;\n  border-top-left-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.navbar-btn {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.navbar-btn.btn-sm,\n.btn-group-sm > .navbar-btn.btn {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.navbar-btn.btn-xs,\n.btn-group-xs > .navbar-btn.btn {\n  margin-top: 14px;\n  margin-bottom: 14px;\n}\n\n.navbar-text {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n@media (min-width: 768px) {\n  .navbar-text {\n    float: left;\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-left {\n    float: left !important;\n  }\n\n  .navbar-right {\n    float: right !important;\n    margin-right: -15px;\n  }\n\n  .navbar-right ~ .navbar-right {\n    margin-right: 0;\n  }\n}\n\n.navbar-default {\n  background-color: #f8f8f8;\n  border-color: #e7e7e7;\n}\n\n.navbar-default .navbar-brand {\n  color: #777;\n}\n\n.navbar-default .navbar-brand:hover,\n.navbar-default .navbar-brand:focus {\n  color: #5e5e5e;\n  background-color: transparent;\n}\n\n.navbar-default .navbar-text {\n  color: #777;\n}\n\n.navbar-default .navbar-nav > li > a {\n  color: #777;\n}\n\n.navbar-default .navbar-nav > li > a:hover,\n.navbar-default .navbar-nav > li > a:focus {\n  color: #333;\n  background-color: transparent;\n}\n\n.navbar-default .navbar-nav > .active > a,\n.navbar-default .navbar-nav > .active > a:hover,\n.navbar-default .navbar-nav > .active > a:focus {\n  color: #555;\n  background-color: #e7e7e7;\n}\n\n.navbar-default .navbar-nav > .disabled > a,\n.navbar-default .navbar-nav > .disabled > a:hover,\n.navbar-default .navbar-nav > .disabled > a:focus {\n  color: #ccc;\n  background-color: transparent;\n}\n\n.navbar-default .navbar-toggle {\n  border-color: #ddd;\n}\n\n.navbar-default .navbar-toggle:hover,\n.navbar-default .navbar-toggle:focus {\n  background-color: #ddd;\n}\n\n.navbar-default .navbar-toggle .icon-bar {\n  background-color: #888;\n}\n\n.navbar-default .navbar-collapse,\n.navbar-default .navbar-form {\n  border-color: #e7e7e7;\n}\n\n.navbar-default .navbar-nav > .open > a,\n.navbar-default .navbar-nav > .open > a:hover,\n.navbar-default .navbar-nav > .open > a:focus {\n  background-color: #e7e7e7;\n  color: #555;\n}\n\n@media (max-width: 767px) {\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a {\n    color: #777;\n  }\n\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {\n    color: #333;\n    background-color: transparent;\n  }\n\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {\n    color: #555;\n    background-color: #e7e7e7;\n  }\n\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a,\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover,\n  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n    color: #ccc;\n    background-color: transparent;\n  }\n}\n\n.navbar-default .navbar-link {\n  color: #777;\n}\n\n.navbar-default .navbar-link:hover {\n  color: #333;\n}\n\n.navbar-default .btn-link {\n  color: #777;\n}\n\n.navbar-default .btn-link:hover,\n.navbar-default .btn-link:focus {\n  color: #333;\n}\n\n.navbar-default .btn-link[disabled]:hover,\n.navbar-default .btn-link[disabled]:focus,\nfieldset[disabled] .navbar-default .btn-link:hover,\nfieldset[disabled] .navbar-default .btn-link:focus {\n  color: #ccc;\n}\n\n.navbar-inverse {\n  background-color: #222;\n  border-color: #090909;\n}\n\n.navbar-inverse .navbar-brand {\n  color: #9d9d9d;\n}\n\n.navbar-inverse .navbar-brand:hover,\n.navbar-inverse .navbar-brand:focus {\n  color: #fff;\n  background-color: transparent;\n}\n\n.navbar-inverse .navbar-text {\n  color: #9d9d9d;\n}\n\n.navbar-inverse .navbar-nav > li > a {\n  color: #9d9d9d;\n}\n\n.navbar-inverse .navbar-nav > li > a:hover,\n.navbar-inverse .navbar-nav > li > a:focus {\n  color: #fff;\n  background-color: transparent;\n}\n\n.navbar-inverse .navbar-nav > .active > a,\n.navbar-inverse .navbar-nav > .active > a:hover,\n.navbar-inverse .navbar-nav > .active > a:focus {\n  color: #fff;\n  background-color: #090909;\n}\n\n.navbar-inverse .navbar-nav > .disabled > a,\n.navbar-inverse .navbar-nav > .disabled > a:hover,\n.navbar-inverse .navbar-nav > .disabled > a:focus {\n  color: #444;\n  background-color: transparent;\n}\n\n.navbar-inverse .navbar-toggle {\n  border-color: #333;\n}\n\n.navbar-inverse .navbar-toggle:hover,\n.navbar-inverse .navbar-toggle:focus {\n  background-color: #333;\n}\n\n.navbar-inverse .navbar-toggle .icon-bar {\n  background-color: #fff;\n}\n\n.navbar-inverse .navbar-collapse,\n.navbar-inverse .navbar-form {\n  border-color: #101010;\n}\n\n.navbar-inverse .navbar-nav > .open > a,\n.navbar-inverse .navbar-nav > .open > a:hover,\n.navbar-inverse .navbar-nav > .open > a:focus {\n  background-color: #090909;\n  color: #fff;\n}\n\n@media (max-width: 767px) {\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {\n    border-color: #090909;\n  }\n\n  .navbar-inverse .navbar-nav .open .dropdown-menu .divider {\n    background-color: #090909;\n  }\n\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {\n    color: #9d9d9d;\n  }\n\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {\n    color: #fff;\n    background-color: transparent;\n  }\n\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {\n    color: #fff;\n    background-color: #090909;\n  }\n\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover,\n  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n    color: #444;\n    background-color: transparent;\n  }\n}\n\n.navbar-inverse .navbar-link {\n  color: #9d9d9d;\n}\n\n.navbar-inverse .navbar-link:hover {\n  color: #fff;\n}\n\n.navbar-inverse .btn-link {\n  color: #9d9d9d;\n}\n\n.navbar-inverse .btn-link:hover,\n.navbar-inverse .btn-link:focus {\n  color: #fff;\n}\n\n.navbar-inverse .btn-link[disabled]:hover,\n.navbar-inverse .btn-link[disabled]:focus,\nfieldset[disabled] .navbar-inverse .btn-link:hover,\nfieldset[disabled] .navbar-inverse .btn-link:focus {\n  color: #444;\n}\n\n.breadcrumb {\n  padding: 8px 15px;\n  margin-bottom: 20px;\n  list-style: none;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.breadcrumb > li {\n  display: inline-block;\n}\n\n.breadcrumb > li + li:before {\n  content: \"/\\A0\";\n  padding: 0 5px;\n  color: #ccc;\n}\n\n.breadcrumb > .active {\n  color: #777777;\n}\n\n.pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: 20px 0;\n  border-radius: 4px;\n}\n\n.pagination > li {\n  display: inline;\n}\n\n.pagination > li > a,\n.pagination > li > span {\n  position: relative;\n  float: left;\n  padding: 6px 12px;\n  line-height: 1.42857;\n  text-decoration: none;\n  color: #337ab7;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  margin-left: -1px;\n}\n\n.pagination > li:first-child > a,\n.pagination > li:first-child > span {\n  margin-left: 0;\n  border-bottom-left-radius: 4px;\n  border-top-left-radius: 4px;\n}\n\n.pagination > li:last-child > a,\n.pagination > li:last-child > span {\n  border-bottom-right-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.pagination > li > a:hover,\n.pagination > li > a:focus,\n.pagination > li > span:hover,\n.pagination > li > span:focus {\n  z-index: 2;\n  color: #23527c;\n  background-color: #eeeeee;\n  border-color: #ddd;\n}\n\n.pagination > .active > a,\n.pagination > .active > a:hover,\n.pagination > .active > a:focus,\n.pagination > .active > span,\n.pagination > .active > span:hover,\n.pagination > .active > span:focus {\n  z-index: 3;\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n  cursor: default;\n}\n\n.pagination > .disabled > span,\n.pagination > .disabled > span:hover,\n.pagination > .disabled > span:focus,\n.pagination > .disabled > a,\n.pagination > .disabled > a:hover,\n.pagination > .disabled > a:focus {\n  color: #777777;\n  background-color: #fff;\n  border-color: #ddd;\n  cursor: not-allowed;\n}\n\n.pagination-lg > li > a,\n.pagination-lg > li > span {\n  padding: 10px 16px;\n  font-size: 18px;\n  line-height: 1.33333;\n}\n\n.pagination-lg > li:first-child > a,\n.pagination-lg > li:first-child > span {\n  border-bottom-left-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.pagination-lg > li:last-child > a,\n.pagination-lg > li:last-child > span {\n  border-bottom-right-radius: 6px;\n  border-top-right-radius: 6px;\n}\n\n.pagination-sm > li > a,\n.pagination-sm > li > span {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.pagination-sm > li:first-child > a,\n.pagination-sm > li:first-child > span {\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.pagination-sm > li:last-child > a,\n.pagination-sm > li:last-child > span {\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.pager {\n  padding-left: 0;\n  margin: 20px 0;\n  list-style: none;\n  text-align: center;\n}\n\n.pager:before,\n.pager:after {\n  content: \" \";\n  display: table;\n}\n\n.pager:after {\n  clear: both;\n}\n\n.pager li {\n  display: inline;\n}\n\n.pager li > a,\n.pager li > span {\n  display: inline-block;\n  padding: 5px 14px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 15px;\n}\n\n.pager li > a:hover,\n.pager li > a:focus {\n  text-decoration: none;\n  background-color: #eeeeee;\n}\n\n.pager .next > a,\n.pager .next > span {\n  float: right;\n}\n\n.pager .previous > a,\n.pager .previous > span {\n  float: left;\n}\n\n.pager .disabled > a,\n.pager .disabled > a:hover,\n.pager .disabled > a:focus,\n.pager .disabled > span {\n  color: #777777;\n  background-color: #fff;\n  cursor: not-allowed;\n}\n\n.label {\n  display: inline;\n  padding: .2em .6em .3em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25em;\n}\n\n.label:empty {\n  display: none;\n}\n\n.btn .label {\n  position: relative;\n  top: -1px;\n}\n\na.label:hover,\na.label:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.label-default {\n  background-color: #777777;\n}\n\n.label-default[href]:hover,\n.label-default[href]:focus {\n  background-color: #5e5e5e;\n}\n\n.label-primary {\n  background-color: #337ab7;\n}\n\n.label-primary[href]:hover,\n.label-primary[href]:focus {\n  background-color: #286090;\n}\n\n.label-success {\n  background-color: #5cb85c;\n}\n\n.label-success[href]:hover,\n.label-success[href]:focus {\n  background-color: #449d44;\n}\n\n.label-info {\n  background-color: #5bc0de;\n}\n\n.label-info[href]:hover,\n.label-info[href]:focus {\n  background-color: #31b0d5;\n}\n\n.label-warning {\n  background-color: #f0ad4e;\n}\n\n.label-warning[href]:hover,\n.label-warning[href]:focus {\n  background-color: #ec971f;\n}\n\n.label-danger {\n  background-color: #d9534f;\n}\n\n.label-danger[href]:hover,\n.label-danger[href]:focus {\n  background-color: #c9302c;\n}\n\n.badge {\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #fff;\n  line-height: 1;\n  vertical-align: middle;\n  white-space: nowrap;\n  text-align: center;\n  background-color: #777777;\n  border-radius: 10px;\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.btn-xs .badge,\n.btn-group-xs > .btn .badge,\n.btn-group-xs > .btn .badge {\n  top: 0;\n  padding: 1px 5px;\n}\n\n.list-group-item.active > .badge,\n.nav-pills > .active > a > .badge {\n  color: #337ab7;\n  background-color: #fff;\n}\n\n.list-group-item > .badge {\n  float: right;\n}\n\n.list-group-item > .badge + .badge {\n  margin-right: 5px;\n}\n\n.nav-pills > li > a > .badge {\n  margin-left: 3px;\n}\n\na.badge:hover,\na.badge:focus {\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.jumbotron {\n  padding-top: 30px;\n  padding-bottom: 30px;\n  margin-bottom: 30px;\n  color: inherit;\n  background-color: #eeeeee;\n}\n\n.jumbotron h1,\n.jumbotron .h1 {\n  color: inherit;\n}\n\n.jumbotron p {\n  margin-bottom: 15px;\n  font-size: 21px;\n  font-weight: 200;\n}\n\n.jumbotron > hr {\n  border-top-color: #d5d5d5;\n}\n\n.container .jumbotron,\n.container-fluid .jumbotron {\n  border-radius: 6px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.jumbotron .container {\n  max-width: 100%;\n}\n\n@media screen and (min-width: 768px) {\n  .jumbotron {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n\n  .container .jumbotron,\n  .container-fluid .jumbotron {\n    padding-left: 60px;\n    padding-right: 60px;\n  }\n\n  .jumbotron h1,\n  .jumbotron .h1 {\n    font-size: 63px;\n  }\n}\n\n.thumbnail {\n  display: block;\n  padding: 4px;\n  margin-bottom: 20px;\n  line-height: 1.42857;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  -webkit-transition: border 0.2s ease-in-out;\n  -o-transition: border 0.2s ease-in-out;\n  transition: border 0.2s ease-in-out;\n}\n\n.thumbnail > img,\n.thumbnail a > img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.thumbnail .caption {\n  padding: 9px;\n  color: #333333;\n}\n\na.thumbnail:hover,\na.thumbnail:focus,\na.thumbnail.active {\n  border-color: #337ab7;\n}\n\n.alert {\n  padding: 15px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n\n.alert h4 {\n  margin-top: 0;\n  color: inherit;\n}\n\n.alert .alert-link {\n  font-weight: bold;\n}\n\n.alert > p,\n.alert > ul {\n  margin-bottom: 0;\n}\n\n.alert > p + p {\n  margin-top: 5px;\n}\n\n.alert-dismissable,\n.alert-dismissible {\n  padding-right: 35px;\n}\n\n.alert-dismissable .close,\n.alert-dismissible .close {\n  position: relative;\n  top: -2px;\n  right: -21px;\n  color: inherit;\n}\n\n.alert-success {\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n  color: #3c763d;\n}\n\n.alert-success hr {\n  border-top-color: #c9e2b3;\n}\n\n.alert-success .alert-link {\n  color: #2b542c;\n}\n\n.alert-info {\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n  color: #31708f;\n}\n\n.alert-info hr {\n  border-top-color: #a6e1ec;\n}\n\n.alert-info .alert-link {\n  color: #245269;\n}\n\n.alert-warning {\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n  color: #8a6d3b;\n}\n\n.alert-warning hr {\n  border-top-color: #f7e1b5;\n}\n\n.alert-warning .alert-link {\n  color: #66512c;\n}\n\n.alert-danger {\n  background-color: #f2dede;\n  border-color: #ebccd1;\n  color: #a94442;\n}\n\n.alert-danger hr {\n  border-top-color: #e4b9c0;\n}\n\n.alert-danger .alert-link {\n  color: #843534;\n}\n\n@-webkit-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n\n  to {\n    background-position: 0 0;\n  }\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n\n  to {\n    background-position: 0 0;\n  }\n}\n\n.progress {\n  overflow: hidden;\n  height: 20px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.progress-bar {\n  float: left;\n  width: 0%;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  background-color: #337ab7;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  -webkit-transition: width 0.6s ease;\n  -o-transition: width 0.6s ease;\n  transition: width 0.6s ease;\n}\n\n.progress-striped .progress-bar,\n.progress-bar-striped {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 40px 40px;\n}\n\n.progress.active .progress-bar,\n.progress-bar.active {\n  -webkit-animation: progress-bar-stripes 2s linear infinite;\n  -o-animation: progress-bar-stripes 2s linear infinite;\n  animation: progress-bar-stripes 2s linear infinite;\n}\n\n.progress-bar-success {\n  background-color: #5cb85c;\n}\n\n.progress-striped .progress-bar-success {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n\n.progress-bar-info {\n  background-color: #5bc0de;\n}\n\n.progress-striped .progress-bar-info {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n\n.progress-bar-warning {\n  background-color: #f0ad4e;\n}\n\n.progress-striped .progress-bar-warning {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n\n.progress-bar-danger {\n  background-color: #d9534f;\n}\n\n.progress-striped .progress-bar-danger {\n  background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n}\n\n.media {\n  margin-top: 15px;\n}\n\n.media:first-child {\n  margin-top: 0;\n}\n\n.media,\n.media-body {\n  zoom: 1;\n  overflow: hidden;\n}\n\n.media-body {\n  width: 10000px;\n}\n\n.media-object {\n  display: block;\n}\n\n.media-object.img-thumbnail {\n  max-width: none;\n}\n\n.media-right,\n.media > .pull-right {\n  padding-left: 10px;\n}\n\n.media-left,\n.media > .pull-left {\n  padding-right: 10px;\n}\n\n.media-left,\n.media-right,\n.media-body {\n  display: table-cell;\n  vertical-align: top;\n}\n\n.media-middle {\n  vertical-align: middle;\n}\n\n.media-bottom {\n  vertical-align: bottom;\n}\n\n.media-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n\n.media-list {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-group {\n  margin-bottom: 20px;\n  padding-left: 0;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n\n.list-group-item:first-child {\n  border-top-right-radius: 4px;\n  border-top-left-radius: 4px;\n}\n\n.list-group-item:last-child {\n  margin-bottom: 0;\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\na.list-group-item,\nbutton.list-group-item {\n  color: #555;\n}\n\na.list-group-item .list-group-item-heading,\nbutton.list-group-item .list-group-item-heading {\n  color: #333;\n}\n\na.list-group-item:hover,\na.list-group-item:focus,\nbutton.list-group-item:hover,\nbutton.list-group-item:focus {\n  text-decoration: none;\n  color: #555;\n  background-color: #f5f5f5;\n}\n\nbutton.list-group-item {\n  width: 100%;\n  text-align: left;\n}\n\n.list-group-item.disabled,\n.list-group-item.disabled:hover,\n.list-group-item.disabled:focus {\n  background-color: #eeeeee;\n  color: #777777;\n  cursor: not-allowed;\n}\n\n.list-group-item.disabled .list-group-item-heading,\n.list-group-item.disabled:hover .list-group-item-heading,\n.list-group-item.disabled:focus .list-group-item-heading {\n  color: inherit;\n}\n\n.list-group-item.disabled .list-group-item-text,\n.list-group-item.disabled:hover .list-group-item-text,\n.list-group-item.disabled:focus .list-group-item-text {\n  color: #777777;\n}\n\n.list-group-item.active,\n.list-group-item.active:hover,\n.list-group-item.active:focus {\n  z-index: 2;\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n\n.list-group-item.active .list-group-item-heading,\n.list-group-item.active .list-group-item-heading > small,\n.list-group-item.active .list-group-item-heading > .small,\n.list-group-item.active:hover .list-group-item-heading,\n.list-group-item.active:hover .list-group-item-heading > small,\n.list-group-item.active:hover .list-group-item-heading > .small,\n.list-group-item.active:focus .list-group-item-heading,\n.list-group-item.active:focus .list-group-item-heading > small,\n.list-group-item.active:focus .list-group-item-heading > .small {\n  color: inherit;\n}\n\n.list-group-item.active .list-group-item-text,\n.list-group-item.active:hover .list-group-item-text,\n.list-group-item.active:focus .list-group-item-text {\n  color: #c7ddef;\n}\n\n.list-group-item-success {\n  color: #3c763d;\n  background-color: #dff0d8;\n}\n\na.list-group-item-success,\nbutton.list-group-item-success {\n  color: #3c763d;\n}\n\na.list-group-item-success .list-group-item-heading,\nbutton.list-group-item-success .list-group-item-heading {\n  color: inherit;\n}\n\na.list-group-item-success:hover,\na.list-group-item-success:focus,\nbutton.list-group-item-success:hover,\nbutton.list-group-item-success:focus {\n  color: #3c763d;\n  background-color: #d0e9c6;\n}\n\na.list-group-item-success.active,\na.list-group-item-success.active:hover,\na.list-group-item-success.active:focus,\nbutton.list-group-item-success.active,\nbutton.list-group-item-success.active:hover,\nbutton.list-group-item-success.active:focus {\n  color: #fff;\n  background-color: #3c763d;\n  border-color: #3c763d;\n}\n\n.list-group-item-info {\n  color: #31708f;\n  background-color: #d9edf7;\n}\n\na.list-group-item-info,\nbutton.list-group-item-info {\n  color: #31708f;\n}\n\na.list-group-item-info .list-group-item-heading,\nbutton.list-group-item-info .list-group-item-heading {\n  color: inherit;\n}\n\na.list-group-item-info:hover,\na.list-group-item-info:focus,\nbutton.list-group-item-info:hover,\nbutton.list-group-item-info:focus {\n  color: #31708f;\n  background-color: #c4e3f3;\n}\n\na.list-group-item-info.active,\na.list-group-item-info.active:hover,\na.list-group-item-info.active:focus,\nbutton.list-group-item-info.active,\nbutton.list-group-item-info.active:hover,\nbutton.list-group-item-info.active:focus {\n  color: #fff;\n  background-color: #31708f;\n  border-color: #31708f;\n}\n\n.list-group-item-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n}\n\na.list-group-item-warning,\nbutton.list-group-item-warning {\n  color: #8a6d3b;\n}\n\na.list-group-item-warning .list-group-item-heading,\nbutton.list-group-item-warning .list-group-item-heading {\n  color: inherit;\n}\n\na.list-group-item-warning:hover,\na.list-group-item-warning:focus,\nbutton.list-group-item-warning:hover,\nbutton.list-group-item-warning:focus {\n  color: #8a6d3b;\n  background-color: #faf2cc;\n}\n\na.list-group-item-warning.active,\na.list-group-item-warning.active:hover,\na.list-group-item-warning.active:focus,\nbutton.list-group-item-warning.active,\nbutton.list-group-item-warning.active:hover,\nbutton.list-group-item-warning.active:focus {\n  color: #fff;\n  background-color: #8a6d3b;\n  border-color: #8a6d3b;\n}\n\n.list-group-item-danger {\n  color: #a94442;\n  background-color: #f2dede;\n}\n\na.list-group-item-danger,\nbutton.list-group-item-danger {\n  color: #a94442;\n}\n\na.list-group-item-danger .list-group-item-heading,\nbutton.list-group-item-danger .list-group-item-heading {\n  color: inherit;\n}\n\na.list-group-item-danger:hover,\na.list-group-item-danger:focus,\nbutton.list-group-item-danger:hover,\nbutton.list-group-item-danger:focus {\n  color: #a94442;\n  background-color: #ebcccc;\n}\n\na.list-group-item-danger.active,\na.list-group-item-danger.active:hover,\na.list-group-item-danger.active:focus,\nbutton.list-group-item-danger.active,\nbutton.list-group-item-danger.active:hover,\nbutton.list-group-item-danger.active:focus {\n  color: #fff;\n  background-color: #a94442;\n  border-color: #a94442;\n}\n\n.list-group-item-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n\n.list-group-item-text {\n  margin-bottom: 0;\n  line-height: 1.3;\n}\n\n.panel {\n  margin-bottom: 20px;\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n\n.panel-body {\n  padding: 15px;\n}\n\n.panel-body:before,\n.panel-body:after {\n  content: \" \";\n  display: table;\n}\n\n.panel-body:after {\n  clear: both;\n}\n\n.panel-heading {\n  padding: 10px 15px;\n  border-bottom: 1px solid transparent;\n  border-top-right-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.panel-heading > .dropdown .dropdown-toggle {\n  color: inherit;\n}\n\n.panel-title {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 16px;\n  color: inherit;\n}\n\n.panel-title > a,\n.panel-title > small,\n.panel-title > .small,\n.panel-title > small > a,\n.panel-title > .small > a {\n  color: inherit;\n}\n\n.panel-footer {\n  padding: 10px 15px;\n  background-color: #f5f5f5;\n  border-top: 1px solid #ddd;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n\n.panel > .list-group,\n.panel > .panel-collapse > .list-group {\n  margin-bottom: 0;\n}\n\n.panel > .list-group .list-group-item,\n.panel > .panel-collapse > .list-group .list-group-item {\n  border-width: 1px 0;\n  border-radius: 0;\n}\n\n.panel > .list-group:first-child .list-group-item:first-child,\n.panel > .panel-collapse > .list-group:first-child .list-group-item:first-child {\n  border-top: 0;\n  border-top-right-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.panel > .list-group:last-child .list-group-item:last-child,\n.panel > .panel-collapse > .list-group:last-child .list-group-item:last-child {\n  border-bottom: 0;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n\n.panel > .panel-heading + .panel-collapse > .list-group .list-group-item:first-child {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n\n.panel-heading + .list-group .list-group-item:first-child {\n  border-top-width: 0;\n}\n\n.list-group + .panel-footer {\n  border-top-width: 0;\n}\n\n.panel > .table,\n.panel > .table-responsive > .table,\n.panel > .panel-collapse > .table {\n  margin-bottom: 0;\n}\n\n.panel > .table caption,\n.panel > .table-responsive > .table caption,\n.panel > .panel-collapse > .table caption {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.panel > .table:first-child,\n.panel > .table-responsive:first-child > .table:first-child {\n  border-top-right-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.panel > .table:first-child > thead:first-child > tr:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.panel > .table:first-child > thead:first-child > tr:first-child td:first-child,\n.panel > .table:first-child > thead:first-child > tr:first-child th:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child th:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child {\n  border-top-left-radius: 3px;\n}\n\n.panel > .table:first-child > thead:first-child > tr:first-child td:last-child,\n.panel > .table:first-child > thead:first-child > tr:first-child th:last-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n.panel > .table:first-child > tbody:first-child > tr:first-child th:last-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,\n.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child {\n  border-top-right-radius: 3px;\n}\n\n.panel > .table:last-child,\n.panel > .table-responsive:last-child > .table:last-child {\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n\n.panel > .table:last-child > tbody:last-child > tr:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child {\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n\n.panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n.panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child {\n  border-bottom-left-radius: 3px;\n}\n\n.panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n.panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n.panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child {\n  border-bottom-right-radius: 3px;\n}\n\n.panel > .panel-body + .table,\n.panel > .panel-body + .table-responsive,\n.panel > .table + .panel-body,\n.panel > .table-responsive + .panel-body {\n  border-top: 1px solid #ddd;\n}\n\n.panel > .table > tbody:first-child > tr:first-child th,\n.panel > .table > tbody:first-child > tr:first-child td {\n  border-top: 0;\n}\n\n.panel > .table-bordered,\n.panel > .table-responsive > .table-bordered {\n  border: 0;\n}\n\n.panel > .table-bordered > thead > tr > th:first-child,\n.panel > .table-bordered > thead > tr > td:first-child,\n.panel > .table-bordered > tbody > tr > th:first-child,\n.panel > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-bordered > tfoot > tr > th:first-child,\n.panel > .table-bordered > tfoot > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > thead > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n  border-left: 0;\n}\n\n.panel > .table-bordered > thead > tr > th:last-child,\n.panel > .table-bordered > thead > tr > td:last-child,\n.panel > .table-bordered > tbody > tr > th:last-child,\n.panel > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-bordered > tfoot > tr > th:last-child,\n.panel > .table-bordered > tfoot > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > thead > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > thead > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n.panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n  border-right: 0;\n}\n\n.panel > .table-bordered > thead > tr:first-child > td,\n.panel > .table-bordered > thead > tr:first-child > th,\n.panel > .table-bordered > tbody > tr:first-child > td,\n.panel > .table-bordered > tbody > tr:first-child > th,\n.panel > .table-responsive > .table-bordered > thead > tr:first-child > td,\n.panel > .table-responsive > .table-bordered > thead > tr:first-child > th,\n.panel > .table-responsive > .table-bordered > tbody > tr:first-child > td,\n.panel > .table-responsive > .table-bordered > tbody > tr:first-child > th {\n  border-bottom: 0;\n}\n\n.panel > .table-bordered > tbody > tr:last-child > td,\n.panel > .table-bordered > tbody > tr:last-child > th,\n.panel > .table-bordered > tfoot > tr:last-child > td,\n.panel > .table-bordered > tfoot > tr:last-child > th,\n.panel > .table-responsive > .table-bordered > tbody > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > tbody > tr:last-child > th,\n.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td,\n.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th {\n  border-bottom: 0;\n}\n\n.panel > .table-responsive {\n  border: 0;\n  margin-bottom: 0;\n}\n\n.panel-group {\n  margin-bottom: 20px;\n}\n\n.panel-group .panel {\n  margin-bottom: 0;\n  border-radius: 4px;\n}\n\n.panel-group .panel + .panel {\n  margin-top: 5px;\n}\n\n.panel-group .panel-heading {\n  border-bottom: 0;\n}\n\n.panel-group .panel-heading + .panel-collapse > .panel-body,\n.panel-group .panel-heading + .panel-collapse > .list-group {\n  border-top: 1px solid #ddd;\n}\n\n.panel-group .panel-footer {\n  border-top: 0;\n}\n\n.panel-group .panel-footer + .panel-collapse .panel-body {\n  border-bottom: 1px solid #ddd;\n}\n\n.panel-default {\n  border-color: #ddd;\n}\n\n.panel-default > .panel-heading {\n  color: #333333;\n  background-color: #f5f5f5;\n  border-color: #ddd;\n}\n\n.panel-default > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #ddd;\n}\n\n.panel-default > .panel-heading .badge {\n  color: #f5f5f5;\n  background-color: #333333;\n}\n\n.panel-default > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #ddd;\n}\n\n.panel-primary {\n  border-color: #337ab7;\n}\n\n.panel-primary > .panel-heading {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n\n.panel-primary > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #337ab7;\n}\n\n.panel-primary > .panel-heading .badge {\n  color: #337ab7;\n  background-color: #fff;\n}\n\n.panel-primary > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #337ab7;\n}\n\n.panel-success {\n  border-color: #d6e9c6;\n}\n\n.panel-success > .panel-heading {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n}\n\n.panel-success > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #d6e9c6;\n}\n\n.panel-success > .panel-heading .badge {\n  color: #dff0d8;\n  background-color: #3c763d;\n}\n\n.panel-success > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #d6e9c6;\n}\n\n.panel-info {\n  border-color: #bce8f1;\n}\n\n.panel-info > .panel-heading {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n\n.panel-info > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #bce8f1;\n}\n\n.panel-info > .panel-heading .badge {\n  color: #d9edf7;\n  background-color: #31708f;\n}\n\n.panel-info > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #bce8f1;\n}\n\n.panel-warning {\n  border-color: #faebcc;\n}\n\n.panel-warning > .panel-heading {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n}\n\n.panel-warning > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #faebcc;\n}\n\n.panel-warning > .panel-heading .badge {\n  color: #fcf8e3;\n  background-color: #8a6d3b;\n}\n\n.panel-warning > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #faebcc;\n}\n\n.panel-danger {\n  border-color: #ebccd1;\n}\n\n.panel-danger > .panel-heading {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n}\n\n.panel-danger > .panel-heading + .panel-collapse > .panel-body {\n  border-top-color: #ebccd1;\n}\n\n.panel-danger > .panel-heading .badge {\n  color: #f2dede;\n  background-color: #a94442;\n}\n\n.panel-danger > .panel-footer + .panel-collapse > .panel-body {\n  border-bottom-color: #ebccd1;\n}\n\n.well {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n\n.well blockquote {\n  border-color: #ddd;\n  border-color: rgba(0, 0, 0, 0.15);\n}\n\n.well-lg {\n  padding: 24px;\n  border-radius: 6px;\n}\n\n.well-sm {\n  padding: 9px;\n  border-radius: 3px;\n}\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  border: 0;\n}\n\n.embed-responsive-16by9 {\n  padding-bottom: 56.25%;\n}\n\n.embed-responsive-4by3 {\n  padding-bottom: 75%;\n}\n\n.close {\n  float: right;\n  font-size: 21px;\n  font-weight: bold;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: 0.2;\n  filter: alpha(opacity=20);\n}\n\n.close:hover,\n.close:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n}\n\nbutton.close {\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none;\n}\n\n.modal-open {\n  overflow: hidden;\n}\n\n.modal {\n  display: none;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n\n.modal.fade .modal-dialog {\n  -webkit-transform: translate(0, -25%);\n  -ms-transform: translate(0, -25%);\n  -o-transform: translate(0, -25%);\n  transform: translate(0, -25%);\n  -webkit-transition: -webkit-transform 0.3s ease-out;\n  -moz-transition: -moz-transform 0.3s ease-out;\n  -o-transition: -o-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n}\n\n.modal.in .modal-dialog {\n  -webkit-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  -o-transform: translate(0, 0);\n  transform: translate(0, 0);\n}\n\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n\n.modal-content {\n  position: relative;\n  background-color: #fff;\n  border: 1px solid #999;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n  background-clip: padding-box;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n}\n\n.modal-backdrop.fade {\n  opacity: 0;\n  filter: alpha(opacity=0);\n}\n\n.modal-backdrop.in {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n}\n\n.modal-header {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.modal-header:before,\n.modal-header:after {\n  content: \" \";\n  display: table;\n}\n\n.modal-header:after {\n  clear: both;\n}\n\n.modal-header .close {\n  margin-top: -2px;\n}\n\n.modal-title {\n  margin: 0;\n  line-height: 1.42857;\n}\n\n.modal-body {\n  position: relative;\n  padding: 15px;\n}\n\n.modal-footer {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5;\n}\n\n.modal-footer:before,\n.modal-footer:after {\n  content: \" \";\n  display: table;\n}\n\n.modal-footer:after {\n  clear: both;\n}\n\n.modal-footer .btn + .btn {\n  margin-left: 5px;\n  margin-bottom: 0;\n}\n\n.modal-footer .btn-group .btn + .btn {\n  margin-left: -1px;\n}\n\n.modal-footer .btn-block + .btn-block {\n  margin-left: 0;\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n@media (min-width: 768px) {\n  .modal-dialog {\n    width: 600px;\n    margin: 30px auto;\n  }\n\n  .modal-content {\n    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n  }\n\n  .modal-sm {\n    width: 300px;\n  }\n}\n\n@media (min-width: 992px) {\n  .modal-lg {\n    width: 900px;\n  }\n}\n\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: normal;\n  line-break: auto;\n  line-height: 1.42857;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  white-space: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  font-size: 12px;\n  opacity: 0;\n  filter: alpha(opacity=0);\n}\n\n.tooltip.in {\n  opacity: 0.9;\n  filter: alpha(opacity=90);\n}\n\n.tooltip.top {\n  margin-top: -3px;\n  padding: 5px 0;\n}\n\n.tooltip.right {\n  margin-left: 3px;\n  padding: 0 5px;\n}\n\n.tooltip.bottom {\n  margin-top: 3px;\n  padding: 5px 0;\n}\n\n.tooltip.left {\n  margin-left: -3px;\n  padding: 0 5px;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 4px;\n}\n\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.tooltip.top .tooltip-arrow {\n  bottom: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n\n.tooltip.top-left .tooltip-arrow {\n  bottom: 0;\n  right: 5px;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n\n.tooltip.top-right .tooltip-arrow {\n  bottom: 0;\n  left: 5px;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000;\n}\n\n.tooltip.right .tooltip-arrow {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000;\n}\n\n.tooltip.left .tooltip-arrow {\n  top: 50%;\n  right: 0;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #000;\n}\n\n.tooltip.bottom .tooltip-arrow {\n  top: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n\n.tooltip.bottom-left .tooltip-arrow {\n  top: 0;\n  right: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n\n.tooltip.bottom-right .tooltip-arrow {\n  top: 0;\n  left: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: none;\n  max-width: 276px;\n  padding: 1px;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: normal;\n  line-break: auto;\n  line-height: 1.42857;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  white-space: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  font-size: 14px;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n}\n\n.popover.top {\n  margin-top: -10px;\n}\n\n.popover.right {\n  margin-left: 10px;\n}\n\n.popover.bottom {\n  margin-top: 10px;\n}\n\n.popover.left {\n  margin-left: -10px;\n}\n\n.popover-title {\n  margin: 0;\n  padding: 8px 14px;\n  font-size: 14px;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-radius: 5px 5px 0 0;\n}\n\n.popover-content {\n  padding: 9px 14px;\n}\n\n.popover > .arrow,\n.popover > .arrow:after {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.popover > .arrow {\n  border-width: 11px;\n}\n\n.popover > .arrow:after {\n  border-width: 10px;\n  content: \"\";\n}\n\n.popover.top > .arrow {\n  left: 50%;\n  margin-left: -11px;\n  border-bottom-width: 0;\n  border-top-color: #999999;\n  border-top-color: rgba(0, 0, 0, 0.25);\n  bottom: -11px;\n}\n\n.popover.top > .arrow:after {\n  content: \" \";\n  bottom: 1px;\n  margin-left: -10px;\n  border-bottom-width: 0;\n  border-top-color: #fff;\n}\n\n.popover.right > .arrow {\n  top: 50%;\n  left: -11px;\n  margin-top: -11px;\n  border-left-width: 0;\n  border-right-color: #999999;\n  border-right-color: rgba(0, 0, 0, 0.25);\n}\n\n.popover.right > .arrow:after {\n  content: \" \";\n  left: 1px;\n  bottom: -10px;\n  border-left-width: 0;\n  border-right-color: #fff;\n}\n\n.popover.bottom > .arrow {\n  left: 50%;\n  margin-left: -11px;\n  border-top-width: 0;\n  border-bottom-color: #999999;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n  top: -11px;\n}\n\n.popover.bottom > .arrow:after {\n  content: \" \";\n  top: 1px;\n  margin-left: -10px;\n  border-top-width: 0;\n  border-bottom-color: #fff;\n}\n\n.popover.left > .arrow {\n  top: 50%;\n  right: -11px;\n  margin-top: -11px;\n  border-right-width: 0;\n  border-left-color: #999999;\n  border-left-color: rgba(0, 0, 0, 0.25);\n}\n\n.popover.left > .arrow:after {\n  content: \" \";\n  right: 1px;\n  border-right-width: 0;\n  border-left-color: #fff;\n  bottom: -10px;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel-inner {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n\n.carousel-inner > .item {\n  display: none;\n  position: relative;\n  -webkit-transition: 0.6s ease-in-out left;\n  -o-transition: 0.6s ease-in-out left;\n  transition: 0.6s ease-in-out left;\n}\n\n.carousel-inner > .item > img,\n.carousel-inner > .item > a > img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  line-height: 1;\n}\n\n@media all and (transform-3d), (-webkit-transform-3d) {\n  .carousel-inner > .item {\n    -webkit-transition: -webkit-transform 0.6s ease-in-out;\n    -moz-transition: -moz-transform 0.6s ease-in-out;\n    -o-transition: -o-transform 0.6s ease-in-out;\n    transition: transform 0.6s ease-in-out;\n    -webkit-backface-visibility: hidden;\n    -moz-backface-visibility: hidden;\n    backface-visibility: hidden;\n    -webkit-perspective: 1000px;\n    -moz-perspective: 1000px;\n    perspective: 1000px;\n  }\n\n  .carousel-inner > .item.next,\n  .carousel-inner > .item.active.right {\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n    left: 0;\n  }\n\n  .carousel-inner > .item.prev,\n  .carousel-inner > .item.active.left {\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n    left: 0;\n  }\n\n  .carousel-inner > .item.next.left,\n  .carousel-inner > .item.prev.right,\n  .carousel-inner > .item.active {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n    left: 0;\n  }\n}\n\n.carousel-inner > .active,\n.carousel-inner > .next,\n.carousel-inner > .prev {\n  display: block;\n}\n\n.carousel-inner > .active {\n  left: 0;\n}\n\n.carousel-inner > .next,\n.carousel-inner > .prev {\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.carousel-inner > .next {\n  left: 100%;\n}\n\n.carousel-inner > .prev {\n  left: -100%;\n}\n\n.carousel-inner > .next.left,\n.carousel-inner > .prev.right {\n  left: 0;\n}\n\n.carousel-inner > .active.left {\n  left: -100%;\n}\n\n.carousel-inner > .active.right {\n  left: 100%;\n}\n\n.carousel-control {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 15%;\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  font-size: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.carousel-control.left {\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);\n}\n\n.carousel-control.right {\n  left: auto;\n  right: 0;\n  background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n  background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);\n}\n\n.carousel-control:hover,\n.carousel-control:focus {\n  outline: 0;\n  color: #fff;\n  text-decoration: none;\n  opacity: 0.9;\n  filter: alpha(opacity=90);\n}\n\n.carousel-control .icon-prev,\n.carousel-control .icon-next,\n.carousel-control .glyphicon-chevron-left,\n.carousel-control .glyphicon-chevron-right {\n  position: absolute;\n  top: 50%;\n  margin-top: -10px;\n  z-index: 5;\n  display: inline-block;\n}\n\n.carousel-control .icon-prev,\n.carousel-control .glyphicon-chevron-left {\n  left: 50%;\n  margin-left: -10px;\n}\n\n.carousel-control .icon-next,\n.carousel-control .glyphicon-chevron-right {\n  right: 50%;\n  margin-right: -10px;\n}\n\n.carousel-control .icon-prev,\n.carousel-control .icon-next {\n  width: 20px;\n  height: 20px;\n  line-height: 1;\n  font-family: serif;\n}\n\n.carousel-control .icon-prev:before {\n  content: '\\2039';\n}\n\n.carousel-control .icon-next:before {\n  content: '\\203A';\n}\n\n.carousel-indicators {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  margin-left: -30%;\n  padding-left: 0;\n  list-style: none;\n  text-align: center;\n}\n\n.carousel-indicators li {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin: 1px;\n  text-indent: -999px;\n  border: 1px solid #fff;\n  border-radius: 10px;\n  cursor: pointer;\n  background-color: #000 \\9;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.carousel-indicators .active {\n  margin: 0;\n  width: 12px;\n  height: 12px;\n  background-color: #fff;\n}\n\n.carousel-caption {\n  position: absolute;\n  left: 15%;\n  right: 15%;\n  bottom: 20px;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n}\n\n.carousel-caption .btn {\n  text-shadow: none;\n}\n\n@media screen and (min-width: 768px) {\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-prev,\n  .carousel-control .icon-next {\n    width: 30px;\n    height: 30px;\n    margin-top: -10px;\n    font-size: 30px;\n  }\n\n  .carousel-control .glyphicon-chevron-left,\n  .carousel-control .icon-prev {\n    margin-left: -10px;\n  }\n\n  .carousel-control .glyphicon-chevron-right,\n  .carousel-control .icon-next {\n    margin-right: -10px;\n  }\n\n  .carousel-caption {\n    left: 20%;\n    right: 20%;\n    padding-bottom: 30px;\n  }\n\n  .carousel-indicators {\n    bottom: 20px;\n  }\n}\n\n.clearfix:before,\n.clearfix:after {\n  content: \" \";\n  display: table;\n}\n\n.clearfix:after {\n  clear: both;\n}\n\n.center-block {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.pull-right {\n  float: right !important;\n}\n\n.pull-left {\n  float: left !important;\n}\n\n.hide {\n  display: none !important;\n}\n\n.show {\n  display: block !important;\n}\n\n.invisible {\n  visibility: hidden;\n}\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.hidden {\n  display: none !important;\n}\n\n.affix {\n  position: fixed;\n}\n\n@-ms-viewport {\n  width: device-width;\n}\n\n.visible-xs {\n  display: none !important;\n}\n\n.visible-sm {\n  display: none !important;\n}\n\n.visible-md {\n  display: none !important;\n}\n\n.visible-lg {\n  display: none !important;\n}\n\n.visible-xs-block,\n.visible-xs-inline,\n.visible-xs-inline-block,\n.visible-sm-block,\n.visible-sm-inline,\n.visible-sm-inline-block,\n.visible-md-block,\n.visible-md-inline,\n.visible-md-inline-block,\n.visible-lg-block,\n.visible-lg-inline,\n.visible-lg-inline-block {\n  display: none !important;\n}\n\n@media (max-width: 767px) {\n  .visible-xs {\n    display: block !important;\n  }\n\n  table.visible-xs {\n    display: table !important;\n  }\n\n  tr.visible-xs {\n    display: table-row !important;\n  }\n\n  th.visible-xs,\n  td.visible-xs {\n    display: table-cell !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .visible-xs-block {\n    display: block !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .visible-xs-inline {\n    display: inline !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .visible-xs-inline-block {\n    display: inline-block !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm {\n    display: block !important;\n  }\n\n  table.visible-sm {\n    display: table !important;\n  }\n\n  tr.visible-sm {\n    display: table-row !important;\n  }\n\n  th.visible-sm,\n  td.visible-sm {\n    display: table-cell !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-block {\n    display: block !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline {\n    display: inline !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .visible-sm-inline-block {\n    display: inline-block !important;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md {\n    display: block !important;\n  }\n\n  table.visible-md {\n    display: table !important;\n  }\n\n  tr.visible-md {\n    display: table-row !important;\n  }\n\n  th.visible-md,\n  td.visible-md {\n    display: table-cell !important;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-block {\n    display: block !important;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline {\n    display: inline !important;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .visible-md-inline-block {\n    display: inline-block !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .visible-lg {\n    display: block !important;\n  }\n\n  table.visible-lg {\n    display: table !important;\n  }\n\n  tr.visible-lg {\n    display: table-row !important;\n  }\n\n  th.visible-lg,\n  td.visible-lg {\n    display: table-cell !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .visible-lg-block {\n    display: block !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .visible-lg-inline {\n    display: inline !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .visible-lg-inline-block {\n    display: inline-block !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .hidden-xs {\n    display: none !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .hidden-sm {\n    display: none !important;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hidden-md {\n    display: none !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .hidden-lg {\n    display: none !important;\n  }\n}\n\n.visible-print {\n  display: none !important;\n}\n\n@media print {\n  .visible-print {\n    display: block !important;\n  }\n\n  table.visible-print {\n    display: table !important;\n  }\n\n  tr.visible-print {\n    display: table-row !important;\n  }\n\n  th.visible-print,\n  td.visible-print {\n    display: table-cell !important;\n  }\n}\n\n.visible-print-block {\n  display: none !important;\n}\n\n@media print {\n  .visible-print-block {\n    display: block !important;\n  }\n}\n\n.visible-print-inline {\n  display: none !important;\n}\n\n@media print {\n  .visible-print-inline {\n    display: inline !important;\n  }\n}\n\n.visible-print-inline-block {\n  display: none !important;\n}\n\n@media print {\n  .visible-print-inline-block {\n    display: inline-block !important;\n  }\n}\n\n@media print {\n  .hidden-print {\n    display: none !important;\n  }\n}\n\n", ""]);

// exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  body {\n    width: 1070px;\n    margin: 0 auto !important; }\n  .route-sheet .route-number {\n    width: 30px; }\n  .route-sheet .route-coins {\n    width: 150px; }\n  .route-sheet .route-dates {\n    width: 50px; }\n  .route-sheet .route-total {\n    width: 50px; }\n  .page-break {\n    display: block;\n    page-break-after: always; } }\n\n@page print-landscape {\n  size: landscape;\n  margin: 1cm; }\n\n.print-landscape {\n  page: print-landscape; }\n", ""]);

// exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports
exports.push([module.i, "@import url(//fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.i, "body {\n  height: 100%;\n  font: 62.5% 'Roboto', sans-serif; }\n\n.cst-padding {\n  padding: 10px 0 10px 0; }\n\n.margin-top-20 {\n  margin-top: 20; }\n\n.coin-total-font-size {\n  font-size: 16px; }\n\n.info-font-style {\n  font-size: 20px;\n  padding-left: 10px; }\n\n.remove-bottom-margin {\n  margin-bottom: 0px !important; }\n\n.delivery-date-border {\n  border-color: #BEEBBE !important; }\n\n.password-icon {\n  top: 33px;\n  position: absolute !important;\n  margin-right: 30px;\n  right: 0;\n  cursor: pointer; }\n\n.uib-date-picker-section .uib-datepicker-popup {\n  top: auto !important;\n  left: 15px !important;\n  position: fixed; }\n\n.border-radius-05 {\n  border-radius: 5px !important; }\n\n.wrap-text {\n  word-wrap: break-word;\n  word-break: break-all; }\n\n.customer-billing-status .label {\n  margin-bottom: 0px !important; }\n\n.documents-count-badge {\n  border-radius: 4px !important;\n  background-color: white !important;\n  font-size: 13px !important;\n  color: steelblue !important; }\n\n.customer-surcharge-list {\n  padding-left: 15px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start; }\n\n.customer-surcharge-item {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-end;\n  margin: 0 15px 16px 0; }\n  .customer-surcharge-item.col-sm-3 {\n    margin: 0 0 16px 0;\n    padding: 0; }\n  .customer-surcharge-item.customer-surcharge-item-open {\n    flex: 0 0 100%;\n    max-width: 100%;\n    margin: 0 0 16px 0; }\n    .customer-surcharge-item.customer-surcharge-item-open .customer-surcharge-item-fields {\n      flex: 1 1 auto; }\n\n.customer-surcharge-item-fields {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  margin-left: 12px;\n  row-gap: 12px; }\n  .customer-surcharge-item-fields .customer-surcharge-field {\n    flex: 1 1 160px;\n    min-width: 140px; }\n    .customer-surcharge-item-fields .customer-surcharge-field:first-child {\n      flex: 0 0 90px;\n      min-width: 90px; }\n\n.customer-surcharge-field {\n  display: flex;\n  flex-direction: column;\n  margin-right: 12px;\n  min-height: 56px; }\n  .customer-surcharge-field label {\n    font-weight: bold;\n    margin-bottom: 6px;\n    white-space: nowrap; }\n  .customer-surcharge-field input {\n    width: 75px; }\n  .customer-surcharge-field select {\n    width: 100%;\n    max-width: 350px; }\n  .customer-surcharge-field .multi-select {\n    width: 100%;\n    max-width: 350px;\n    position: relative; }\n  .customer-surcharge-field .contract-location-multi-select-dd .multiSelect .checkboxLayer {\n    max-height: 240px !important;\n    overflow-y: auto !important;\n    left: auto !important;\n    right: 0 !important; }\n  .customer-surcharge-field .contract-location-multi-select-dd .multiSelect > button {\n    min-height: 34px !important;\n    height: 34px;\n    background-image: none !important;\n    white-space: nowrap !important;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .customer-surcharge-field .contract-location-multi-select-dd.valid-multi-select-value .multiSelect > button {\n    background-color: #DFF5DF !important;\n    border-color: #BEEBBE !important; }\n  .customer-surcharge-field .contract-location-multi-select-dd.invalid-multi-select-value .multiSelect > button {\n    background-color: #F9E3E3 !important;\n    border-color: #F4C6C6 !important; }\n  .customer-surcharge-field .contract-location-multi-select-dd .multiSelect > button .buttonLabel {\n    display: inline-block;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    vertical-align: middle; }\n\n.glyphicon.fast-right-spinner {\n  -webkit-animation: glyphicon-spin-r 1s infinite linear;\n  animation: glyphicon-spin-r 1s infinite linear; }\n\nbody {\n  max-width: 1280px;\n  margin: 0 auto !important; }\n\nthead td {\n  font-weight: bold; }\n\ntd {\n  vertical-align: middle !important; }\n\n.pagination {\n  margin: 0px 0px !important; }\n\n@media print {\n  tr.page-break {\n    display: block;\n    page-break-before: always; } }\n\n@-webkit-keyframes glyphicon-spin-r {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg); } }\n\n@keyframes glyphicon-spin-r {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg); } }\n\n@-webkit-keyframes glyphicon-spin-l {\n  0% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg); }\n  100% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); } }\n\n@keyframes glyphicon-spin-l {\n  0% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg); }\n  100% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); } }\n\n.form-validate .ng-invalid {\n  background-color: #F9E3E3;\n  border-color: #F4C6C6; }\n  .form-validate .ng-invalid .ui-select-toggle {\n    background-color: #F9E3E3;\n    border-color: #F4C6C6; }\n  .form-validate .ng-invalid .ui-select-container.ng-valid,\n  .form-validate .ng-invalid .ui-select-container.ng-invalid {\n    background-color: transparent; }\n\n.form-validate .ng-valid {\n  background-color: #DFF5DF;\n  border-color: #BEEBBE; }\n  .form-validate .ng-valid .ui-select-toggle {\n    background-color: #DFF5DF;\n    border-color: #BEEBBE; }\n\n.form-validate .switch-success.ats-switch {\n  background-color: #fff;\n  border-color: #ccc; }\n\n#inline .datetimepicker-input .datetimepicker-wrapper {\n  position: relative;\n  top: 9px; }\n\n.datetimepicker-input ng-form[name=\"datetimepickerForm\"], datetimepicker {\n  background: transparent !important; }\n\n.datetimepicker-input .datetimepicker-wrapper {\n  width: 100%; }\n  .datetimepicker-input .datetimepicker-wrapper input[name=\"datepicker\"] {\n    width: 100%; }\n\ndiv.all-toggle-button {\n  margin-top: 12px; }\n\n.ng-toast.ng-toast--right > ul.ng-toast__list {\n  margin-right: 165px; }\n\n.disabled {\n  pointer-events: none !important; }\n\n.autoDetect {\n  float: right;\n  margin: 6px 0px; }\n\n.padding-left-17 {\n  padding-left: 17px; }\n", ""]);

// exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".connection-status-container {\n  position: fixed;\n  right: 20px;\n  top: 20px;\n  z-index: 1001; }\n", ""]);

// exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".denom-icon-wrapper {\n  position: relative;\n  display: inline-block;\n  cursor: pointer; }\n\n.denom-icon-sm {\n  width: 35px;\n  height: auto; }\n\n.denom-icon-popover-window {\n  z-index: 99999 !important;\n  pointer-events: none; }\n  .denom-icon-popover-window .popover-content {\n    padding: 8px;\n    background: #fff;\n    border-radius: 10px;\n    text-align: center; }\n  .denom-icon-popover-window.popover {\n    border-radius: 10px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n    border: 1px solid #ddd; }\n\n.denom-icon-lg {\n  width: 80px;\n  height: auto;\n  display: block;\n  margin: 0 auto; }\n\n.denom-icon-label {\n  font-size: 12px;\n  font-weight: bold;\n  color: #333;\n  margin-top: 4px; }\n", ""]);

// exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".file-upload-directive-style .fileUpload {\n  position: relative;\n  overflow: hidden; }\n\n.file-upload-directive-style .fileUpload input.upload {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0; }\n\n.file-upload-directive-style .upload-btn {\n  font-size: 14px;\n  font-weight: normal;\n  border: 1px solid transparent; }\n", ""]);

// exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "ul.dropdown-menu {\n  z-index: 9999; }\n  ul.dropdown-menu li {\n    cursor: pointer; }\n\na.branch-link {\n  color: #4077B6 !important;\n  text-decoration: underline; }\n\na.branch-active {\n  background-color: #e7f2fd; }\n\n@media (min-width: 768px) {\n  .navbar-nav.navbar-center {\n    position: absolute;\n    left: 50%;\n    top: 11px;\n    font-size: 1.9rem;\n    transform: translatex(-50%); } }\n\n.navbar-custom {\n  border-radius: 0 0 5px 5px !important;\n  border-top: none !important;\n  box-shadow: 0px 0px 5px 0px; }\n\n.navbar-app-name {\n  font-weight: bold !important;\n  color: #5C6BC0 !important;\n  text-decoration: none !important; }\n\n.navbar-default {\n  box-shadow: 0 0 5px 0;\n  border-radius: 0px 0px 5px 5px; }\n\n@media (max-width: 767px) {\n  .left-nav-section .open .dropdown-menu {\n    position: absolute !important;\n    float: none;\n    width: auto;\n    margin-top: 0;\n    background-color: #fff !important;\n    border: 0;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175) !important; } }\n\n.text-color-red {\n  color: #dc3545; }\n\n.text-color-green {\n  color: #28a745; }\n\n.alert-icon-width {\n  width: 22px; }\n\n.alert-icon-section {\n  position: absolute;\n  top: 9px;\n  font-size: 1.9rem;\n  transform: translatex(-35%);\n  z-index: 999; }\n\n.navbar-branch-list {\n  max-height: 450px;\n  overflow-y: auto;\n  cursor: pointer; }\n\n.navbar-branch-list-scroll-section * {\n  scrollbar-width: thin;\n  scrollbar-color: darkgrey #ddd; }\n\n.navbar-branch-list-scroll-section *::-webkit-scrollbar {\n  width: 10px; }\n\n.navbar-branch-list-scroll-section *::-webkit-scrollbar-track {\n  background: #ddd; }\n\n.navbar-branch-list-scroll-section *::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  border-radius: 20px;\n  border: 3px solid #ddd; }\n", ""]);

// exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".paginated-search-and-select-dd .pagination-text {\n  margin: 5px 5px 5px 10px; }\n\n.paginated-search-and-select-dd .div-disabled {\n  pointer-events: none;\n  opacity: 0.5;\n  background: #CCC; }\n\n.paginated-search-and-select-dd .well {\n  padding: 5px !important;\n  border-radius: 0 0 5px 5px;\n  border-top: none; }\n\n.paginated-search-and-select-dd .list-group {\n  max-height: 240px;\n  overflow: auto;\n  margin-bottom: 0;\n  border-radius: 0; }\n\n.paginated-search-and-select-dd .caption {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  display: block;\n  position: absolute;\n  margin: 0 10px;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  line-height: 30px; }\n\n.paginated-search-and-select-dd .select-btn-section {\n  padding-right: 31px;\n  margin: 3px 0px 0px 0px; }\n\n.paginated-search-and-select-dd .list-group-item.active,\n.paginated-search-and-select-dd .list-group-item.active:hover,\n.paginated-search-and-select-dd .list-group-item.active:focus {\n  z-index: 2;\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #fff !important; }\n", ""]);

// exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".nomargin {\n  margin: 0px !important; }\n\n.nopadding {\n  padding: 0px !important; }\n\nsmall {\n  font-size: 70%; }\n\n.header i {\n  position: absolute;\n  height: 10px;\n  top: 50%;\n  right: 5px;\n  margin-top: -2px; }\n\n.searchandselect {\n  cursor: pointer;\n  position: relative;\n  width: 100%;\n  border: 1px solid #e6e8ea;\n  border-radius: 4px; }\n\n.searchandselect .header {\n  height: 33px;\n  padding: 7px 15px;\n  z-index: 1; }\n\n.searchandselect .search {\n  padding: 5px;\n  display: none;\n  z-index: 1; }\n\n.searchandselect .dropdownone {\n  border: 1px solid #e6e8ea;\n  left: 0;\n  list-style: outside none none;\n  position: absolute;\n  right: 0;\n  top: 100%;\n  margin: 0;\n  padding: 0;\n  display: none;\n  z-index: 2; }\n\n.searchandselect.active .search {\n  display: inherit; }\n\n.searchandselect.active .dropdownone {\n  display: inherit;\n  background-color: white; }\n\n.searchandselect.is-highlighted {\n  background-color: blanchedalmond !important;\n  border: 1px solid #fac08c !important; }\n\n.searchandselect.is-highlighted .header {\n  background-color: transparent !important; }\n\n.searchandselect .dropdownone li {\n  top: 0;\n  padding: 6px 10px; }\n\n.searchandselect .dropdownone li i {\n  color: inherit;\n  margin-right: 5px;\n  vertical-align: middle;\n  float: right; }\n\n.searchandselect .dropdownone li small {\n  margin-right: 10px; }\n\n.disabled-state {\n  opacity: 1;\n  background-color: #eeeeee !important;\n  pointer-events: none !important; }\n\n.dropdownTwo {\n  overflow-y: auto;\n  min-height: 250px; }\n\n.disabled-state * {\n  cursor: not-allowed; }\n\n.word-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.margin-top2 {\n  margin-top: 2px; }\n\n.width-per95 {\n  width: 95%; }\n\n.option:hover {\n  background-color: #f5f5f5; }\n\n.row-active, .row-active.highlight-row {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  background-color: #428bca; }\n\n.dd-width {\n  width: 370px; }\n\n.selected-text-width {\n  width: 94% !important; }\n\n.highlight-row {\n  background-color: #f5f5f5; }\n\n.inner-item {\n  background-color: white;\n  overflow: auto;\n  overflow-y: auto;\n  max-height: 260px; }\n\n.search-select-dd-width {\n  width: 200px !important; }\n", ""]);

// exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".total-fontSize {\n  font-size: 24px; }\n\n.common-line-height {\n  line-height: 30px; }\n\n.target-time-picker ng-form[name=\"datetimepickerForm\"] {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: nowrap;\n  max-width: 100%; }\n\n.target-time-picker .datetimepicker-wrapper {\n  display: inline-block !important;\n  width: auto;\n  flex: 0 0 auto;\n  max-width: 100%; }\n\n.target-time-picker .datetimepicker-wrapper > input[name=\"datepicker\"] {\n  width: 100%; }\n\n.target-time-picker .datetimepicker-wrapper:first-child {\n  flex: 1 1 auto;\n  min-width: 0; }\n\n.target-time-picker .datetimepicker-wrapper[name=\"timepicker\"] {\n  width: 112px;\n  flex: 0 0 112px; }\n\n.target-time-picker .datetimepicker-wrapper[name=\"timepicker\"] .uib-timepicker {\n  width: 100%; }\n\n.target-time-picker .datetimepicker-wrapper[name=\"timepicker\"] .uib-timepicker td.form-group.uib-time {\n  padding-left: 0;\n  padding-right: 0; }\n\n.target-time-picker .datetimepicker-wrapper[name=\"timepicker\"] .uib-timepicker .uib-time input {\n  width: 38px !important;\n  min-width: 38px;\n  padding-left: 4px;\n  padding-right: 4px; }\n\n.target-time-picker .datetimepicker-wrapper[name=\"timepicker\"] .uib-timepicker .uib-time.am-pm .btn {\n  min-width: 38px;\n  padding-left: 8px;\n  padding-right: 8px; }\n\n.target-time-picker.invalid-multi-select-value .datetimepicker-wrapper > input[name=\"datepicker\"],\n.target-time-picker.invalid-multi-select-value .datetimepicker-wrapper[name=\"timepicker\"] .uib-timepicker .uib-time input {\n  background-color: #F9E3E3 !important;\n  border-color: #F4C6C6 !important; }\n\n.target-time-picker.valid-multi-select-value .datetimepicker-wrapper > input[name=\"datepicker\"],\n.target-time-picker.valid-multi-select-value .datetimepicker-wrapper[name=\"timepicker\"] .uib-timepicker .uib-time input {\n  background-color: #DFF5DF !important;\n  border-color: #BEEBBE !important; }\n\n.service-zone-container {\n  height: auto;\n  min-height: 48px;\n  padding-top: 10px;\n  padding-bottom: 4px;\n  padding-left: 10px;\n  padding-right: 10px;\n  background-color: #fff;\n  cursor: not-allowed;\n  border: 1px solid #ccc;\n  border-radius: 4px; }\n\n.service-zone-tag {\n  display: inline-block;\n  background-color: #0b506d;\n  color: white;\n  border-radius: 4px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  padding: 4px 8px;\n  font-weight: normal;\n  font-size: 12px;\n  border: 1px solid #153e52; }\n\n.model-title {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px; }\n\n#release-hold-map {\n  height: 250px;\n  width: 100%; }\n\n.padding-14 {\n  padding: 14px; }\n\n.border-order-packing {\n  border: 1px solid #d8d6d6; }\n\n.div-pack {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  border-bottom: 1px solid #d8d6d6; }\n\n.pack-padding {\n  padding: 7px; }\n\n.img-width {\n  width: 30px; }\n\n.margin0 {\n  margin-left: 0px !important;\n  margin-right: 0px !important; }\n\n.pack-small-box {\n  border: 1px solid #d8d6d6;\n  width: 29%;\n  float: left;\n  margin: 13px; }\n\n.pack-residual-box {\n  border: 1px solid #d8d6d6;\n  width: 28%;\n  float: left;\n  margin: 13px; }\n\n.padding6 {\n  padding: 6px; }\n\n.pack-value {\n  margin: 8px; }\n\n.route-right-vertical-line {\n  border-right: 1px solid #e5e5e5; }\n\n.route-left-vertical-line {\n  border-left: 1px solid #e5e5e5; }\n\n.margin-top-5 {\n  margin-top: 5px; }\n\n.atm-receipt-size {\n  width: 600px;\n  padding: 5px; }\n\n.card-margin {\n  margin: 10px 10px !important;\n  min-width: 14%;\n  float: left;\n  text-align: center; }\n\n.img_paddding {\n  padding: 5px; }\n\n@media (min-width: 320px) and (max-width: 450px) {\n  .card-margin {\n    width: 27.5% !important; } }\n\n@media (min-width: 450px) and (max-width: 768px) {\n  .card-margin {\n    width: 27.5% !important; } }\n\ntable .nowrap th {\n  white-space: nowrap; }\n\n.padding-left-right {\n  padding: 0px 5px 0px 5px; }\n\n.margin-10 {\n  margin-top: 10px; }\n\n.padding-left-right {\n  padding-right: 3px !important;\n  padding-left: 3px !important; }\n\n.remove-bottom-margin {\n  margin-bottom: 0px !important; }\n\n.edit-icon-size {\n  font-size: 13px; }\n\n.force-close-edit-btn {\n  border: none !important;\n  background: none !important; }\n\n.auto-optimize-route {\n  padding: 10px !important; }\n\n.route-stop-lbl {\n  margin-top: 5px !important;\n  padding-left: 0px !important; }\n\n.btn-pointer {\n  cursor: pointer !important; }\n\n.remove-bottom-margin-10 {\n  margin-bottom: -10px; }\n\n.locid-width-150 {\n  min-width: 150px !important; }\n\n.loc-status-width-100 {\n  min-width: 100px !important; }\n\n.date-time-width-17 {\n  width: 17%; }\n\n.icon-height-60 {\n  height: 60px; }\n\n.auto-open-locks {\n  position: relative;\n  padding: 12px;\n  padding-top: 0px;\n  padding-bottom: 0px; }\n\n.vault-date-column-width {\n  width: 17%; }\n\n.table-row-width-50 {\n  width: 50%; }\n\n.action-codes-dd .multiSelect > button {\n  display: inline-block; }\n\n.action-codes-dd .multiSelect .show {\n  display: block !important;\n  right: 5% !important; }\n\n.action-codes-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 220px !important;\n  overflow-y: auto !important;\n  min-width: 305px; }\n\nhr.remove-margin {\n  margin-top: 0px !important; }\n\n.dd-height-30 {\n  height: 30px !important; }\n\n.pending-count-customer-dd .multiSelect > button {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  text-align: left;\n  position: relative;\n  cursor: pointer;\n  border: 1px solid #BEEBBE;\n  padding: 0 8px;\n  font-size: 14px;\n  height: 30px !important;\n  min-height: 30px !important;\n  border-radius: 4px;\n  color: #555;\n  white-space: nowrap;\n  background-color: #DFF5DF;\n  background-image: none; }\n\n.pending-count-customer-dd .multiSelect .buttonLabel {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 0 !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.pending-count-customer-dd .multiSelect .caret {\n  flex: 0 0 auto;\n  margin: 0 0 0 8px !important; }\n\n.pending-count-customer-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 220px !important;\n  overflow-y: auto !important;\n  min-width: 220px;\n  text-align: left !important; }\n\n.pending-count-customer-dd .multiSelect .show {\n  display: block !important; }\n\n.disable-stop-transfer {\n  cursor: not-allowed !important;\n  background-color: #efefef !important; }\n\n.modal-header-text-align {\n  display: flex;\n  justify-content: inherit; }\n\n.save-location-later-tbl-section .table {\n  margin-bottom: 10px !important; }\n\n.invalid-field-section {\n  background-color: #F9E3E3 !important;\n  border-color: #F4C6C6 !important; }\n\n.margin-bottom-14 {\n  margin-bottom: 14px !important; }\n\n.checkbox-inline-bold-label {\n  font-weight: bold !important; }\n\n.remaining_residuals_table .datetimepicker-wrapper {\n  display: block !important; }\n\n.remaining_residuals_table .scroll-tab {\n  max-height: 450px;\n  overflow-y: auto; }\n\n.common-date-picker-section .datetimepicker-wrapper {\n  display: block !important; }\n\n.service-ticket-resolve-image-border {\n  border: 1px solid #ddd; }\n\n.service-ticket-resolve-image-section {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.action-code-dd-min-width .checkboxLayer {\n  min-width: 412px !important; }\n\n.upcoming-routes-container {\n  padding: 10px 0px 10px 10px; }\n\n.upcoming-routes-heading {\n  font-weight: bold; }\n\n.upcoming-routes-px-4 {\n  padding: 0px 10px; }\n\n.upcoming-routes-title {\n  font-weight: bold; }\n\n.modal-padding-0-16 {\n  padding: 0px 16px !important; }\n\n.margin-left-02 {\n  margin-left: 2% !important; }\n\n.navbar-form {\n  display: flex;\n  justify-content: end;\n  flex-wrap: wrap;\n  width: 100%;\n  gap: 10px; }\n\n.navbar-collapse {\n  width: 100% !important;\n  padding-right: 0px !important; }\n\n.denomination-key-section {\n  font-size: 18px !important;\n  padding: 10px;\n  text-align: left; }\n\n.padding-20 {\n  padding: 20px !important; }\n\n.icon-height-50 {\n  height: 50px !important; }\n\n.padding-15 {\n  padding: 15px; }\n\n.edit-schedule-route-section .datetimepicker-input .datetimepicker-wrapper input[type=\"text\"] {\n  background-color: #eeeeee !important; }\n\n.immidiate-delivery-icon {\n  width: 21px;\n  height: 21px;\n  background-color: #F0B04D;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: bold;\n  border-radius: 4px;\n  padding-top: 2px;\n  font-family: Arial, sans-serif; }\n\n.immidiate-delivery-row-color {\n  background: antiquewhite !important; }\n\n.margin-left-05 {\n  margin-left: 5px; }\n\n.email-dropdown .dropdown-menu {\n  padding: 15px;\n  min-width: 350px;\n  right: 0;\n  left: auto; }\n\n.email-dropdown .email-tags {\n  margin-top: 5px;\n  min-height: 32px;\n  max-height: 100px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 5px; }\n  .email-dropdown .email-tags .email-tag {\n    display: inline-block;\n    background: #f0f0f0;\n    border: 1px solid #ddd;\n    border-radius: 3px;\n    padding: 2px 5px;\n    margin: 2px; }\n    .email-dropdown .email-tags .email-tag .glyphicon-remove {\n      margin-left: 5px;\n      font-size: 10px;\n      cursor: pointer; }\n      .email-dropdown .email-tags .email-tag .glyphicon-remove:hover {\n        color: #d9534f; }\n\n.email-dropdown .email-input {\n  margin-bottom: 10px;\n  width: 100%; }\n\n.email-dropdown .email-actions {\n  margin-top: 10px; }\n  .email-dropdown .email-actions .btn {\n    width: 100%;\n    margin-bottom: 5px; }\n\n.fast-right-spinner {\n  -webkit-animation: spin 1s infinite linear;\n  animation: spin 1s infinite linear; }\n\n.crimson-color {\n  color: crimson; }\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n\n.dvb-credit-amount-color {\n  background-color: #DFF5DF; }\n\n.dvb-debit-amount-color {\n  background-color: #F5DFDF; }\n\n.modal-top-offset .modal-dialog {\n  margin-top: 80px !important; }\n\n.billing-review-container {\n  display: flex !important;\n  align-items: center !important;\n  gap: 10px !important; }\n  .billing-review-container label {\n    margin-bottom: 0px !important;\n    font-weight: bold; }\n\n.btn-add-picture {\n  background-color: #337ab7 !important;\n  /* Blue background */\n  border: 1px solid #2e6da4 !important;\n  /* Blue border */\n  color: #ffffff !important;\n  /* White text */\n  font-weight: bold !important;\n  border-radius: 4px !important;\n  padding: 6px 12px !important;\n  cursor: pointer; }\n  .btn-add-picture:hover {\n    background-color: #1c6cb3 !important;\n    /* Darker blue hover */\n    border-color: #2e6da4 !important; }\n\n.add-picture-container {\n  display: flex;\n  align-items: center;\n  gap: 8px; }\n  .add-picture-container input-file {\n    display: inline-block; }\n    .add-picture-container input-file .file-upload-directive-style {\n      width: auto !important;\n      float: none !important;\n      display: inline-block !important;\n      padding-right: 0 !important;\n      padding-left: 0 !important; }\n  .add-picture-container .btn-preview-pictures {\n    display: inline-flex !important;\n    align-items: center !important; }\n    .add-picture-container .btn-preview-pictures .preview-pictures-count {\n      color: #000000 !important; }\n\n.preview-pictures-row {\n  margin-left: -5px;\n  margin-right: -5px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start; }\n\n.preview-pictures-col {\n  margin-bottom: 20px;\n  padding-left: 5px;\n  padding-right: 5px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start; }\n\n.preview-pictures-img-container {\n  position: relative;\n  display: inline-block;\n  max-width: 100%; }\n\n.preview-pictures-img {\n  max-width: 100%;\n  height: auto;\n  max-height: 160px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 4px;\n  display: block;\n  margin: 0 auto; }\n\n.preview-pictures-remove-btn {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  background: #d9534f;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  line-height: 20px;\n  text-align: center;\n  padding: 0;\n  font-size: 12px;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  font-weight: bold;\n  z-index: 10; }\n  .preview-pictures-remove-btn:hover {\n    background: #c9302c; }\n\n.preview-pictures-filename {\n  margin-top: 5px;\n  font-size: 11px;\n  color: #666;\n  word-break: break-all;\n  max-width: 90%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap; }\n", ""]);

// exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".time-picker-input table.uib-timepicker {\n  background: white; }\n\n.time-picker-input .dropdown-menu {\n  min-width: 0; }\n\n.time-picker-input span.time-picker-value.ng-invalid {\n  background: #F9E3E3;\n  border: 1px solid #F4C6C6; }\n\n.time-picker-input span.time-picker-value.ng-valid {\n  background: #DFF5DF;\n  border-color: #BEEBBE; }\n\n.horizontal-padding-10 {\n  padding: 0px 10px; }\n\n.hide-hours-column table.uib-timepicker tbody tr td:nth-child(1),\n.hide-hours-column table.uib-timepicker tbody tr td:nth-child(2) {\n  display: none !important; }\n", ""]);

// exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".modal_body {\n  position: relative; }\n  .modal_body .submit_buttons {\n    position: absolute;\n    left: 30%;\n    margin-top: 15px; }\n", ""]);

// exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".font-size-16 {\n  font-size: 16px; }\n\n.image-height-50 {\n  height: 50px; }\n\n.atm-codes-location {\n  font-size: 16px;\n  margin-bottom: 2px; }\n\n.atm-edit-height {\n  position: absolute;\n  right: 10px;\n  height: 20px; }\n\n.text-align-right {\n  text-align: right; }\n\n.atm-code-box {\n  width: 100px !important;\n  text-align: center; }\n\n.display-inline-block {\n  display: inline-block; }\n\n.margin-top-05 {\n  margin-top: 5px; }\n\n.msg-font-size {\n  font-size: 15px; }\n\n.atm-code-info-section {\n  display: flex;\n  justify-content: space-between;\n  gap: 5px; }\n\n.atm-codes-date-picker-section .datetimepicker-wrapper {\n  display: block !important; }\n", ""]);

// exports


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n.margin-bottom-10 {\n  margin-bottom: 10px; }\n\n.font-size-20 {\n  font-size: 20px; }\n\n.font-size-15 {\n  font-size: 15px; }\n\n.action-width {\n  width: 25%; }\n\n.color-gray {\n  background: #eeeeee; }\n\n.text-total-color {\n  color: black; }\n\n.bag-color {\n  color: red; }\n\n.total-bag-font {\n  font-size: 20px; }\n\n.flex-center {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.w-80 {\n  width: 80%; }\n\n.d-block {\n  display: block; }\n\n.denom-totals tbody.scroll-content {\n  display: block;\n  max-height: 350px;\n  overflow-y: scroll; }\n\n.denom-totals tbody.scroll-content::-webkit-scrollbar {\n  width: 0px; }\n\n.denom-totals tbody.scroll-content::-webkit-scrollbar-button {\n  display: none; }\n\n.denom-totals tbody.scroll-content::-webkit-scrollbar-track-piece {\n  background: #eee; }\n\n.denom-totals tbody.scroll-content::-webkit-scrollbar-thumb {\n  background: #ccc; }\n\n.denom-totals ​\ntbody.scroll-content:hover::-webkit-scrollbar-thumb {\n  background: #888; }\n\n.denom-totals ​\nthead, .denom-totals tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed; }\n\n.denomination-width {\n  width: 69px; }\n\n.col-width-6 {\n  width: 6%; }\n\n.text-box-radius-right {\n  border-radius: 0px 4px 4px 0px !important; }\n\n.text-box-radius-left {\n  border-radius: 4px 0px 0px 4px !important; }\n\n.col-width-150 {\n  width: 151px;\n  padding: 2px !important; }\n\n.table-padding-2 td {\n  padding: 2px !important; }\n\n.btn-link-color-black {\n  color: #333333; }\n\n.denomination-total-row {\n  border: 4px solid #ccc !important; }\n\n.blank-row-size {\n  font-size: 8px; }\n\n.variance-background {\n  background: #f9e3e2 !important; }\n\n.margin-right-05 {\n  margin-right: 05px; }\n\n.denoms-table {\n  width: 500px !important; }\n\n.toggle-buttons {\n  margin: 20px 0px; }\n\n.atm-count-table {\n  width: 400px;\n  border-collapse: collapse;\n  font-family: Arial, sans-serif; }\n  .atm-count-table thead {\n    border: 1px solid #ddd; }\n  .atm-count-table th, .atm-count-table td {\n    padding: 12px;\n    text-align: left;\n    border: 1px solid #ddd; }\n  .atm-count-table th {\n    background-color: #f2f2f2;\n    font-weight: bold; }\n  .atm-count-table .receipt-cell {\n    text-align: center; }\n  .atm-count-table .amount-input {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #f4c6c6;\n    background-color: #f9e3e3;\n    color: #b94a48;\n    border-radius: 4px;\n    text-align: right; }\n    .atm-count-table .amount-input:focus {\n      outline: none;\n      border-color: #f2a2a2; }\n  .atm-count-table .total-variance {\n    text-align: right;\n    padding: 8px;\n    border-radius: 4px; }\n  .atm-count-table .face-value {\n    text-align: center; }\n\n.denoms-coins-table {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  align-items: flex-start; }\n\n.input-group-responsive {\n  display: flex;\n  gap: 5px;\n  align-items: center; }\n  .input-group-responsive .input-count {\n    flex: 1;\n    min-width: 60px; }\n  .input-group-responsive .input-value {\n    width: 90px;\n    min-width: 70px;\n    text-align: center; }\n\n.total-input-wrapper {\n  display: flex;\n  justify-content: flex-end; }\n  .total-input-wrapper .total-value-input {\n    width: 90px;\n    min-width: 70px;\n    text-align: center; }\n\n.denom-section {\n  min-width: 300px;\n  max-width: 400px; }\n\n@media (max-width: 1080px) {\n  .denoms-coins-table {\n    flex-wrap: wrap;\n    justify-content: start; } }\n\n@media (max-width: 768px) {\n  .denoms-coins-table {\n    flex-direction: column;\n    align-items: center; }\n  .input-group-responsive .input-value {\n    width: 80px;\n    min-width: 60px; }\n  .total-input-wrapper .total-value-input {\n    width: 80px;\n    min-width: 60px; }\n  .denom-section {\n    min-width: 280px;\n    max-width: 350px; } }\n\n@media (max-width: 480px) {\n  .input-group-responsive {\n    gap: 3px; }\n    .input-group-responsive .input-count {\n      min-width: 50px; }\n    .input-group-responsive .input-value {\n      width: 70px;\n      min-width: 50px; }\n  .total-input-wrapper .total-value-input {\n    width: 70px;\n    min-width: 50px; }\n  .denom-section {\n    min-width: 260px;\n    max-width: 300px; } }\n\n.col-width-14 {\n  width: 14% !important; }\n\n.col-width-09 {\n  width: 9% !important; }\n\n.col-width-08 {\n  width: 8% !important; }\n\n.col-width-07 {\n  width: 8% !important; }\n\n.col-width-05 {\n  width: 5% !important; }\n\n.atm_error.form-control.ng-invalid {\n  border-color: #f4a4a4;\n  border-width: 2px; }\n\n.min-width-10 {\n  min-width: 10% !important; }\n\n.atm-residual-amount-col .form-control {\n  padding: 6px 6px !important; }\n\n.invalid-prior-load-amount {\n  background-color: #F9E3E3 !important;\n  border-color: #F4C6C6 !important; }\n\n.atm-count-prior-load-toggle-container .edit-mode-input {\n  display: none; }\n\n.atm-count-prior-load-toggle-container .view-mode-label {\n  display: block; }\n\n.atm-count-prior-load-toggle-container.is-editing .edit-mode-input {\n  display: block; }\n\n.atm-count-prior-load-toggle-container.is-editing .view-mode-label {\n  display: none; }\n\n.fixed-height-group {\n  height: 34px; }\n\n.actual-load-exceeds-request-load {\n  border-color: #f4a4a4 !important;\n  border-width: 2px !important; }\n\n.atm-count-unfit-notes {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  margin-top: 10px; }\n\n.atm-count-unfit-notes.has-unfit .atm-count-unfit {\n  flex: 0 0 32%;\n  max-width: 32%; }\n\n.atm-count-unfit-notes.has-unfit .atm-count-unfit table {\n  max-width: 100%; }\n\n.atm-count-unfit-notes.has-unfit .atm-count-notes {\n  flex: 1;\n  max-width: none;\n  margin: 0;\n  padding: 0; }\n\n.atm-count-unfit-notes:not(.has-unfit) {\n  display: block; }\n\n.atm-count-notes {\n  max-width: 640px;\n  margin: 15px auto 0;\n  padding: 0 15px;\n  float: none; }\n", ""]);

// exports


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .print-margin-top-30 {\n    margin-top: 30px !important; }\n  .print-margin-top-10 {\n    margin-top: 10px !important; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; } }\n\n@media screen {\n  .no-html {\n    visibility: hidden; } }\n", ""]);

// exports


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".text-align-center {\n  text-align: center; }\n\n.text-align-right {\n  text-align: right; }\n\n.text-align-left {\n  text-align: left; }\n\n.bag-count {\n  margin-right: 10px;\n  font-size: 60px;\n  min-width: 30px; }\n\n.padding-zero {\n  padding: 0px !important; }\n\n.margin-top-20 {\n  margin-top: 20px; }\n\n.margin-top-40 {\n  margin-top: 40px; }\n\n.font-size-70 {\n  font-size: 70px; }\n\n.font-size-50 {\n  font-size: 50px; }\n\n.font-size-25 {\n  font-size: 25px; }\n\n.font-size-20 {\n  font-size: 20px; }\n\n.font-size-17 {\n  font-size: 17px; }\n\n.bagCount {\n  font-size: 35px; }\n\n.bagout-input-height {\n  height: 36px !important; }\n\n.bagout-right-arrow {\n  position: absolute;\n  color: #5cb85c;\n  font-size: 30px;\n  width: 5% !important; }\n\n.bag-seal-info {\n  width: 100%;\n  height: 140px; }\n  .bag-seal-info .card:hover {\n    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25), 0 2px 3px rgba(0, 0, 0, 0.22); }\n\n.font-size-30 {\n  font-size: 30px; }\n\n.last-scanned-tracking-Id {\n  margin-bottom: 0px;\n  width: 31% !important;\n  margin-left: 12px;\n  height: 34px;\n  padding: 6px;\n  border: 1px solid transparent;\n  border-radius: 4px; }\n\n.scan-img {\n  width: 6%;\n  margin-top: -1px; }\n\n.bagout-scan-error {\n  margin-bottom: 0px;\n  border: 1px solid transparent;\n  border-radius: 4px; }\n\n.last-scanned-id {\n  margin-bottom: 0px;\n  height: 25px;\n  padding: 2px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  margin-top: 5px; }\n\n.bag-included-icon {\n  height: 55px;\n  text-align: right;\n  margin-top: -20px;\n  margin-left: -55px;\n  margin-bottom: -20px; }\n\n@media (min-width: 320px) and (max-width: 768px) {\n  .bagout-right-arrow {\n    position: absolute;\n    color: #5cb85c;\n    font-size: 30px;\n    width: auto !important; } }\n", ""]);

// exports


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .print-header-margin {\n    margin-top: 10px; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; } }\n\n.show-only-in-print {\n  display: none; }\n\n@media screen {\n  .no-html {\n    visibility: hidden; } }\n\n.textPos {\n  text-align: right;\n  padding-right: 50px; }\n\n.textPoss {\n  text-align: left;\n  margin-top: 5px; }\n\n.bagout-details {\n  text-align: left;\n  margin-top: 15px; }\n\n.totalBag {\n  text-align: left; }\n\n.fntSize {\n  font-size: 22px; }\n\n.txtSize {\n  font-size: 22px;\n  text-align: right; }\n\n.bagSealPos {\n  text-align: center; }\n\n.signPos {\n  text-align: left;\n  padding-left: 15px; }\n\n.bagout-contents {\n  float: left;\n  font-size: 17px; }\n\n.lineColor {\n  opacity: 0.3; }\n\n.lblPos {\n  margin-bottom: -0px; }\n\n.lblPoss {\n  margin-bottom: -0.5px; }\n\n.dvOnePos {\n  margin-top: -20px;\n  width: 97.2%; }\n\n.dvFourPos {\n  margin-top: 100px;\n  width: 96%; }\n\n.divFivePos {\n  width: 45%;\n  text-align: center;\n  float: left; }\n\n.dvSixPos {\n  text-align: right;\n  width: 55%;\n  float: right; }\n\n.dtPos {\n  margin-left: 10px; }\n\n.errLblPos {\n  margin-top: 5px;\n  width: 47%; }\n\n.pad-20 {\n  padding: 20px; }\n", ""]);

// exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".settings-batch-loader {\n  margin-top: 12px;\n  font-size: 20px; }\n", ""]);

// exports


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".ordering-profile-header-section {\n  display: flex;\n  gap: 10px; }\n\n.order-profile-data-section {\n  display: flex;\n  justify-content: space-between; }\n\n.bfs-toggle-section {\n  gap: 6.5rem; }\n\n.bfs-create-d-flex {\n  display: flex;\n  flex-wrap: wrap; }\n\n.bfs-ach-model-section .bfs-ach-toggle-width {\n  width: auto;\n  min-width: 100px; }\n\n.bfs-ach-model-section .bfs-ach-field-width {\n  width: 200px; }\n\n.bfs-ach-model-section .bfs-ach-email-width {\n  width: 350px; }\n\n.bfs-ach-model-section .bfs-ach-toggle-row.bfs-ach-all-off .bfs-ach-toggle-group {\n  flex: 1 0 auto; }\n\n.funding-source-line-section {\n  margin-top: 0px !important;\n  margin-bottom: 8px !important; }\n\n.bfs-denom-card-section {\n  margin: 10px 10px !important;\n  float: left;\n  text-align: center; }\n\n.lead-time-toggle-row {\n  gap: 1.5rem; }\n\n.lead-time-toggle-field {\n  flex: 1 1 0;\n  max-width: 33.33%; }\n\n.lead-time-control {\n  min-height: 34px;\n  display: flex;\n  align-items: center; }\n\n.lead-time-cutoff-field time-picker {\n  display: block;\n  height: 34px;\n  width: 100%; }\n\n.bfs-exp-residual-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px; }\n  .bfs-exp-residual-toggle label {\n    margin: 0; }\n\n.bfs-denom-card-section .bfs-exp-residual-input {\n  width: 0;\n  min-width: 100%;\n  height: 22px;\n  padding: 1px 2px;\n  font-size: 13px;\n  line-height: 18px;\n  border-radius: 3px;\n  box-shadow: none;\n  text-align: center; }\n  .bfs-denom-card-section .bfs-exp-residual-input::placeholder {\n    font-size: 10px; }\n  .bfs-denom-card-section .bfs-exp-residual-input.ng-invalid {\n    background-color: #f9e0dc;\n    border-color: #d9534f; }\n  .bfs-denom-card-section .bfs-exp-residual-input.ng-valid {\n    background-color: #dff0d8;\n    border-color: #5cb85c; }\n", ""]);

// exports


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".label-border-info {\n  border: 1px solid #86c386;\n  padding: 3px;\n  margin-bottom: 1px; }\n\n.custome-width-15 {\n  width: 15%; }\n\n.gap-5 {\n  gap: 5px; }\n\n.textbox-custom {\n  width: 80px !important;\n  height: 30px !important; }\n\n.align-items-end {\n  align-items: end; }\n\n@media (max-width: 967px) {\n  .custome-width-15 {\n    width: auto; } }\n\n.funding-source-holiday-badge-color {\n  color: white !important; }\n\n.lead-time-toggle-row {\n  gap: 1.5rem; }\n\n.lead-time-toggle-field {\n  flex: 1 1 0;\n  max-width: 33.33%; }\n\n.lead-time-control {\n  min-height: 34px;\n  display: flex;\n  align-items: center; }\n\n.lead-time-cutoff-field time-picker {\n  display: block;\n  height: 34px;\n  width: 100%; }\n\n.bfs-ach-model-section .bfs-ach-toggle-width {\n  width: auto;\n  min-width: 100px; }\n\n.bfs-ach-model-section .bfs-ach-field-width {\n  width: 200px; }\n\n.bfs-ach-model-section .bfs-ach-email-width {\n  width: 350px; }\n\n.bfs-ach-model-section .bfs-ach-toggle-row.bfs-ach-all-off .bfs-ach-toggle-group {\n  flex: 1 0 auto; }\n", ""]);

// exports


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; } }\n\n.mt-20 {\n  margin-top: 20px; }\n\n.branch-mgmt-badge .badge {\n  display: inline !important; }\n", ""]);

// exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "/* Styles for Average Daily Vault Balance */\n", ""]);

// exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".itemPos {\n  margin-top: 40px; }\n\n.errMsg {\n  margin-top: 20px; }\n\n.width-auto {\n  width: auto !important; }\n\n.unset-pad {\n  padding-right: unset !important; }\n\n@media (min-width: 767px) and (max-width: 1025px) {\n  .font-12 {\n    font-size: 12px; }\n  .font-15 {\n    font-size: 15px !important; } }\n\n.bagout-err-margin-20 {\n  margin-top: 20px !important; }\n\n.bagout-history-dt-picker-section .form-control {\n  height: 45px !important; }\n\n.bagout-history-dd-section .searchandselect .header {\n  height: 43px !important;\n  padding: 13px 15px !important;\n  z-index: 1; }\n\n.bagout-history-btn-section {\n  display: flex;\n  justify-content: end;\n  gap: 5px; }\n", ""]);

// exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .branch-mgmt-bagout-css-section .hide-in-print {\n    display: none !important; }\n  .branch-mgmt-bagout-css-section .show-only-in-print {\n    display: block !important; }\n  .branch-mgmt-bagout-css-section .print-header-margin {\n    margin-top: 10px; }\n  .branch-mgmt-bagout-css-section .bagout-print-align-section {\n    text-align: left;\n    margin-top: 50px; }\n  .branch-mgmt-bagout-css-section .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .branch-mgmt-bagout-css-section .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .branch-mgmt-bagout-css-section .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .branch-mgmt-bagout-css-section .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .branch-mgmt-bagout-css-section .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .branch-mgmt-bagout-css-section .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .branch-mgmt-bagout-css-section .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .branch-mgmt-bagout-css-section .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .branch-mgmt-bagout-css-section .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .branch-mgmt-bagout-css-section .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .branch-mgmt-bagout-css-section .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .branch-mgmt-bagout-css-section .col-print-12 {\n    width: 100% !important;\n    float: left !important; } }\n\n.branch-mgmt-bagout-css-section .companyLogo {\n  margin-top: 10px;\n  text-align: center; }\n\n.branch-mgmt-bagout-css-section .bagout-spinner-section {\n  margin-top: 20px;\n  font-size: 70px; }\n\n.branch-mgmt-bagout-css-section .bagout-main-section {\n  text-align: left;\n  margin-top: 20px; }\n\n.branch-mgmt-bagout-css-section .bagout-company-logo-section {\n  height: 85px; }\n", ""]);

// exports


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".check-box-col-width {\n  width: 3%; }\n\n.badge-fixed {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  border-radius: 3px !important; }\n\n.billing-approval-box {\n  height: 80px;\n  border: 1px solid #eee;\n  margin-bottom: 1rem;\n  border-radius: 3px !important;\n  padding: 30px; }\n\n.billing-approval-box-flex {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  justify-content: center;\n  color: #ffffff;\n  font-size: 15px;\n  font-family: system-ui; }\n\n.billing-approval-badge .badge {\n  background-color: #777777 !important; }\n\n.remove-bottom-border {\n  border-bottom: none; }\n\n.bg-color-grey {\n  background-color: #f9f9f9 !important; }\n\n.billing-approval-tab-section {\n  border-bottom: none !important; }\n\n.approved-tab-color {\n  background-color: #70AD47 !important; }\n\n.pending-tab-color {\n  background-color: #FFC000 !important; }\n\n.unassigned-tab-color {\n  background-color: #ED7D31 !important; }\n\n.rejected-tab-color {\n  background-color: #e33434d9 !important; }\n\n.billing-review-tab-color {\n  background-color: #33b7ae !important; }\n\n.billing-no-activity-tab-color {\n  background-color: #999 !important; }\n\n.margin-bottom-25 {\n  margin-bottom: 25px !important; }\n\n.billing-approval-col-w-9 {\n  width: 9%; }\n\n.billing-approval-col-w-8 {\n  width: 8%; }\n\n.billing-approval-col-w-12 {\n  width: 12%; }\n\n.billing-rate-input-section .form-control {\n  height: 25px !important; }\n\n.billing-category-dd-padding .form-control {\n  padding: 3px 10px; }\n\n.selected-tab-section {\n  color: #333 !important;\n  border-color: #adadad !important;\n  border: 1px solid; }\n\n.display-contents {\n  display: contents !important; }\n\n.col-width-08 {\n  width: 8%; }\n\n.billing-records-table-pad-4 > thead > tr > th {\n  padding: 4px !important; }\n\n.billing-records-table-pad-4 > tbody > tr > th {\n  padding: 4px !important; }\n\n.count-badge-fixed {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  border-radius: 10px !important; }\n\n.expand-btn-section .btn-xs,\n.expand-btn-section .btn-group-xs > .btn {\n  padding: 1px 4px;\n  font-size: 9px;\n  line-height: 1.5;\n  border-radius: 4px; }\n\n.expand-btn-margin-bottom-03 {\n  margin-bottom: 3px !important; }\n\n.pre-billing-events-history-section {\n  background-color: aliceblue !important; }\n\n.error-msg-padding {\n  padding: 6px !important; }\n\n.customer-not-assigned-padding {\n  padding: 3px !important; }\n\n.billing-approval-status-section {\n  display: flex;\n  justify-content: center;\n  gap: 10px; }\n\n.billing-approval-status-border-radius {\n  border-radius: 10px !important; }\n\n.current-bucket-border-color {\n  border: 2px solid !important;\n  color: slategray !important;\n  box-shadow: 0 3px 10px -3px #36454F; }\n\n.manual-billing-records-color {\n  background: #e6fae5 !important; }\n\n.surcharge-tooltip-trigger {\n  cursor: pointer;\n  white-space: nowrap; }\n  .surcharge-tooltip-trigger .surcharge-tooltip-icon {\n    margin-left: 4px;\n    font-size: 12px;\n    color: #337ab7; }\n\n.tooltip.surcharge-tooltip,\n.tooltip.surcharge-tooltip.in {\n  opacity: 1 !important; }\n  .tooltip.surcharge-tooltip .tooltip-inner,\n  .tooltip.surcharge-tooltip.in .tooltip-inner {\n    max-width: none;\n    min-width: 300px;\n    padding: 0;\n    color: #333;\n    text-align: left;\n    background-color: #fff;\n    border: 1px solid #31708f;\n    border-radius: 3px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25); }\n  .tooltip.surcharge-tooltip.top .tooltip-arrow,\n  .tooltip.surcharge-tooltip.in.top .tooltip-arrow {\n    border-top-color: #31708f; }\n  .tooltip.surcharge-tooltip table,\n  .tooltip.surcharge-tooltip.in table {\n    margin-bottom: 0;\n    background-color: #fff; }\n  .tooltip.surcharge-tooltip th, .tooltip.surcharge-tooltip td,\n  .tooltip.surcharge-tooltip.in th,\n  .tooltip.surcharge-tooltip.in td {\n    padding: 6px 10px;\n    white-space: nowrap;\n    background-color: #fff;\n    border-color: #bce8f1 !important; }\n  .tooltip.surcharge-tooltip thead th,\n  .tooltip.surcharge-tooltip.in thead th {\n    color: #fff;\n    background-color: #31708f; }\n  .tooltip.surcharge-tooltip tfoot th,\n  .tooltip.surcharge-tooltip.in tfoot th {\n    color: #31708f;\n    background-color: #d9edf7; }\n\n.billing-approval-page table table > thead > tr > th,\n.billing-approval-page table table > tbody > tr > td {\n  padding-left: 3px !important;\n  padding-right: 3px !important; }\n\n.billing-approval-page table table th {\n  vertical-align: middle !important; }\n\n.billing-approval-page table table .billing-approval-col-w-12,\n.billing-approval-page table table .billing-approval-col-w-9,\n.billing-approval-page table table .item-date-width-10 {\n  width: auto; }\n\n.billing-log-link {\n  display: inline-block;\n  padding: 2px 6px;\n  font-size: 15px; }\n  .billing-log-link:hover, .billing-log-link:focus {\n    text-decoration: none; }\n\n.billing-approval-page .table > thead > tr > th.projected-surcharge-col,\n.billing-approval-page .table > tbody > tr > td.projected-surcharge-col {\n  background-color: #fcf8e3; }\n\n.total-pending-info {\n  margin-left: 3px;\n  font-size: 12px;\n  color: #337ab7;\n  cursor: pointer; }\n", ""]);

// exports


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".bin-manifest-page {\n  padding: 30px;\n  text-align: center; }\n", ""]);

// exports


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".branch-performance-card {\n  width: 98%;\n  height: auto; }\n\n.card-section {\n  font-family: verdana;\n  background: #fff;\n  border-radius: 5px;\n  display: inline-block;\n  margin: 1rem;\n  position: relative;\n  display: block;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24);\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  border: 1px solid rgba(0, 40, 100, 0.12); }\n\n.branch-performance-card:hover {\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25), 0 2px 3px rgba(0, 0, 0, 0.22); }\n\n.card-body {\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  margin: 0;\n  padding: 1.5rem 1.5rem;\n  position: relative; }\n\n.card-style {\n  width: 104%;\n  margin-left: -16px; }\n\n.card-footer {\n  position: absolute;\n  bottom: 10px;\n  width: 100%;\n  padding-top: 10px;\n  border-top: 1px solid #e0e0e0; }\n\n.card-block {\n  font-size: 1.3em;\n  position: relative;\n  margin: 0;\n  padding: 1em;\n  border: none;\n  box-shadow: none; }\n\n.currency-style {\n  width: 25px; }\n\n.refresh-icon {\n  font-size: 50px;\n  margin-top: 10px; }\n\n.pad-left-10 {\n  padding-left: 10px !important; }\n\n.dd-margin-top-05 {\n  margin-top: 5px; }\n", ""]);

// exports


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".btn-default.btn-on.active {\n  background-color: #5BB75B;\n  color: white; }\n\n.btn-default.btn-off.active {\n  background-color: #5BB75B;\n  color: white; }\n\n.margin-18 {\n  margin: 18px 0px 0px 0px; }\n\n.right-vertical-line {\n  border-right: 2px solid #EEEEEE; }\n\n.minWidth100 {\n  min-width: 100px; }\n\n.minWidth150 {\n  min-width: 150px; }\n", ""]);

// exports


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".undo-icon-height-19 {\n  height: 19px; }\n", ""]);

// exports


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".funding-source-dd-height {\n  height: 34px; }\n\n.cash-deliveries-section {\n  display: flex;\n  justify-content: center; }\n\n.w-100 {\n  min-width: 100%; }\n\n.delivery-date-width {\n  width: 10% !important; }\n\n.vault-date-width {\n  width: 9% !important; }\n\n.table-pad-4 td {\n  padding: 4px !important; }\n\n.col-w-05 {\n  width: 5%; }\n\n.remove-btn-grp-color {\n  color: #333 !important;\n  background-color: #fff !important;\n  border-color: #ccc !important; }\n\n.pickup-time-section {\n  word-break: break-all;\n  width: 18%; }\n\n.table-label-font-section {\n  font-size: 1.35rem; }\n\n.cash-delivery-date-picker-w-18 {\n  width: 18%; }\n\n.cash-transaction-filter-section {\n  align-items: center !important;\n  justify-content: center !important;\n  width: 100%; }\n\n.cash-transaction-line-section {\n  margin-top: 15px !important;\n  margin-bottom: 5px !important; }\n\n.right-pad-07 {\n  padding-right: 7px; }\n\n.left-pad-07 {\n  padding-left: 7px; }\n", ""]);

// exports


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".contact-request-page-css .multi-select-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 350px !important;\n  overflow-y: auto !important;\n  width: 100% !important; }\n", ""]);

// exports


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".cash-variances-search-section {\n  display: flex;\n  justify-content: center; }\n\n.cash-variances-line-section {\n  margin-top: 10px !important;\n  margin-bottom: 5px !important; }\n\n.variance-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  flex-wrap: nowrap;\n  overflow: visible; }\n\n.variance-actions .btn-link {\n  padding: 0;\n  margin: 0; }\n\n.variance-actions .btn-xs.btn-primary {\n  margin: 0; }\n", ""]);

// exports


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .print-header-margin {\n    margin-top: 10px; }\n  .bagout-print-align-section {\n    text-align: left;\n    margin-top: 50px; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; } }\n\n.report-header-section {\n  justify-content: flex-start;\n  display: flex; }\n\n.customer-report-info-section {\n  display: flex;\n  justify-content: end;\n  gap: 10px; }\n", ""]);

// exports


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".font-size-30 {\n  font-size: 30px; }\n\n.balance-sheet-img-width {\n  width: 50px; }\n\n.total-liability {\n  font-size: 20px;\n  padding: 5px; }\n\n.daily-balance-sheet-card {\n  width: 100%;\n  height: 230px; }\n\n.balance-sheet-arrow {\n  position: absolute;\n  right: -30px;\n  top: 95px;\n  color: #5cb85c;\n  font-size: 30px; }\n\n.balance-sheet-card-offset {\n  margin-left: 12.33333%; }\n\n.balance-sheet-card {\n  font-family: verdana;\n  background: #fff;\n  border-radius: 5px;\n  display: inline-block;\n  margin: 1rem;\n  position: relative;\n  display: block;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24);\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  border: 1px solid rgba(0, 40, 100, 0.12); }\n\n.card:hover {\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25), 0 2px 3px rgba(0, 0, 0, 0.22); }\n\n.card-body {\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  margin: 0;\n  padding: 1.5rem 1.5rem;\n  position: relative; }\n\n.card-style {\n  width: 104%;\n  margin-left: -16px; }\n\n.lbl-font-size-15 {\n  font-size: 15px;\n  word-break: break-word; }\n\n.card-footer {\n  position: absolute;\n  bottom: 10px;\n  width: 100%;\n  padding-top: 10px;\n  border-top: 1px solid #e0e0e0; }\n\n.card-block {\n  font-size: 1em;\n  position: relative;\n  margin: 0;\n  padding: 1em;\n  border: none;\n  box-shadow: none; }\n\n.currency-style {\n  width: 25px; }\n\n.info-icon {\n  color: green;\n  font-size: 18px;\n  margin-right: 10px;\n  margin-top: 4.5px; }\n\n.info-icon:hover {\n  cursor: pointer; }\n\n.remove-bottom-padding {\n  padding-bottom: 0px; }\n\n.remove-top-padding {\n  padding-top: 0px; }\n\n.dvb-tiles-border-color {\n  border-style: solid;\n  border-color: #FFD300;\n  border-width: 0.3rem;\n  border-radius: 5px; }\n", ""]);

// exports


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-offset-1 {\n    margin-left: 12.33% !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-offset-2 {\n    margin-left: 24.66% !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-offset-3 {\n    margin-left: 36.99% !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-offset-4 {\n    margin-left: 49.32% !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-offset-5 {\n    margin-left: 61.65% !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-offset-6 {\n    margin-left: 73.98% !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-offset-7 {\n    margin-left: 86.31% !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-offset-8 {\n    margin-left: 98.64% !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-offset-9 {\n    margin-left: 110.97% !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-offset-10 {\n    margin-left: 123.3% !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-offset-11 {\n    margin-left: 135.63% !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; }\n  .col-print-offset-12 {\n    margin-left: 147.96% !important; } }\n\n.show-only-in-print {\n  display: none; }\n\n@media screen {\n  .no-html {\n    visibility: hidden; } }\n\n.dvb-print-tiles-section {\n  display: block !important; }\n\n.dvb-print-font-size-20 {\n  font-size: 20px;\n  word-break: break-word; }\n\n.dvb-print-font-size-30 {\n  font-size: 30px;\n  word-break: break-word; }\n", ""]);

// exports


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".daily-balance-sheet-report-print {\n  background: #fff;\n  color: #000;\n  font-family: Helvetica, Arial, sans-serif;\n  padding: 20px;\n  font-size: 10pt;\n  line-height: 1.4; }\n  .daily-balance-sheet-report-print .margin-top-80 {\n    margin-top: 80px; }\n  .daily-balance-sheet-report-print .header-section {\n    margin-bottom: 2px; }\n  .daily-balance-sheet-report-print .header-line {\n    font-size: 14pt;\n    font-weight: bold;\n    margin-bottom: 2px; }\n  .daily-balance-sheet-report-print .section-title {\n    font-size: 14pt;\n    font-weight: bold;\n    margin-top: 15px;\n    margin-bottom: 9px; }\n  .daily-balance-sheet-report-print .category-title {\n    font-size: 13pt;\n    font-weight: bold;\n    margin-top: 15px;\n    margin-bottom: 5px; }\n  .daily-balance-sheet-report-print .report-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 15px; }\n    .daily-balance-sheet-report-print .report-table th,\n    .daily-balance-sheet-report-print .report-table td {\n      border: none;\n      padding: 2px 2px;\n      font-size: 11pt;\n      vertical-align: middle; }\n    .daily-balance-sheet-report-print .report-table th {\n      font-weight: bold;\n      border-top: none;\n      border-bottom: 2px solid #000; }\n    .daily-balance-sheet-report-print .report-table td {\n      border-bottom: 2px solid #d3d3d3; }\n  .daily-balance-sheet-report-print .transaction-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 15px;\n    border: 1px solid #ccc;\n    /* Outer border */ }\n    .daily-balance-sheet-report-print .transaction-table th,\n    .daily-balance-sheet-report-print .transaction-table td {\n      border: 1px solid #cccccc !important;\n      /* Cell borders */\n      padding: 4px !important;\n      font-size: 11pt !important;\n      vertical-align: top !important; }\n    .daily-balance-sheet-report-print .transaction-table th {\n      font-weight: bold;\n      font-size: 11pt;\n      background-color: #f2f2f2 !important;\n      -webkit-print-color-adjust: exact;\n      print-color-adjust: exact;\n      border-bottom: 1px solid #cccccc;\n      padding: 4px; }\n    .daily-balance-sheet-report-print .transaction-table .header-bg {\n      background-color: #f2f2f2 !important;\n      -webkit-print-color-adjust: exact;\n      print-color-adjust: exact; }\n    .daily-balance-sheet-report-print .transaction-table .fixed-cols {\n      width: 75%;\n      border-right: 1px solid #cccccc;\n      padding: 6px; }\n      .daily-balance-sheet-report-print .transaction-table .fixed-cols .info-block {\n        line-height: 1.5; }\n        .daily-balance-sheet-report-print .transaction-table .fixed-cols .info-block .total-box {\n          font-size: 11pt;\n          border: 1.5px solid #aaaaaa;\n          display: inline-block;\n          padding: 2px 6px;\n          margin-top: 4px; }\n    .daily-balance-sheet-report-print .transaction-table .denom-cols {\n      width: 25%;\n      padding: 0; }\n      .daily-balance-sheet-report-print .transaction-table .denom-cols .denom-row-header {\n        display: flex;\n        justify-content: space-between; }\n        .daily-balance-sheet-report-print .transaction-table .denom-cols .denom-row-header .denom-col-left {\n          width: 50%;\n          padding: 4px 3px;\n          font-size: 11pt; }\n        .daily-balance-sheet-report-print .transaction-table .denom-cols .denom-row-header .denom-col-right {\n          width: 50%;\n          text-align: right;\n          padding: 4px 3px;\n          font-size: 11pt; }\n      .daily-balance-sheet-report-print .transaction-table .denom-cols .denom-list {\n        padding: 0; }\n        .daily-balance-sheet-report-print .transaction-table .denom-cols .denom-list .denom-row {\n          display: flex;\n          justify-content: space-between; }\n          .daily-balance-sheet-report-print .transaction-table .denom-cols .denom-list .denom-row:last-child {\n            border-bottom: none; }\n          .daily-balance-sheet-report-print .transaction-table .denom-cols .denom-list .denom-row .denom-col-left {\n            width: 50%;\n            font-weight: bold;\n            padding: 4px 3px; }\n          .daily-balance-sheet-report-print .transaction-table .denom-cols .denom-list .denom-row .denom-col-right {\n            width: 50%;\n            text-align: right;\n            padding: 4px 3px; }\n  .daily-balance-sheet-report-print .totals-grid {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    column-gap: 15px;\n    row-gap: 10px;\n    font-size: 10pt;\n    padding: 5px 0;\n    margin-bottom: 10px; }\n    .daily-balance-sheet-report-print .totals-grid .total-item {\n      width: auto; }\n  .daily-balance-sheet-report-print .info-block {\n    padding: 0px 3px; }\n    .daily-balance-sheet-report-print .info-block div {\n      margin-bottom: 2px; }\n    .daily-balance-sheet-report-print .info-block .total-box {\n      margin-top: 4px;\n      font-size: 11pt; }\n  .daily-balance-sheet-report-print .text-left {\n    text-align: left; }\n\n@media print {\n  body {\n    background: #fff !important; }\n  .daily-balance-sheet-report-print {\n    padding: 0;\n    /* Ensure background colors are printed */ }\n    .daily-balance-sheet-report-print .page-break-before-always {\n      page-break-before: always; }\n    .daily-balance-sheet-report-print .page-break-before {\n      page-break-before: always; }\n    .daily-balance-sheet-report-print * {\n      -webkit-print-color-adjust: exact !important;\n      print-color-adjust: exact !important; }\n  /* Hide unneeded app elements */\n  #header,\n  .sidebar,\n  .navbar,\n  .footer,\n  .btn,\n  .breadcrumb {\n    display: none !important; } }\n", ""]);

// exports


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".table-padding-4 td {\n  padding: 4px !important; }\n\n.contents-no-wrap {\n  white-space: nowrap; }\n\n.deleted-width-10 {\n  width: 10% !important; }\n\n.remove-height {\n  height: 0; }\n", ""]);

// exports


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".action-col-w-13 {\n  width: 13%; }\n\n.variance-col-width-10 {\n  width: 10%; }\n\n.remove-group-btn-color {\n  color: #333 !important;\n  background-color: #fff !important;\n  border-color: #ccc !important; }\n\n.variance-bg-color {\n  background-color: #ff000024; }\n\n.authorized-residual-btn-section {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px; }\n\n.deposit-table-view thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: #969696;\n  color: #fff;\n  font-size: 14px; }\n\n.autorize-view-header {\n  background-color: #969696;\n  color: #fff;\n  font-size: 14px; }\n\n.branch-mgmt-final-residual-count-commit .denom-width {\n  width: 20%; }\n\n.denom-position-final-residual-count-commit {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  flex-wrap: wrap;\n  gap: 15px 2%;\n  padding: 10px 15px !important; }\n", ""]);

// exports


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".import-file-view-section .hr-line {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important; }\n", ""]);

// exports


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "table.cell-width-200 td {\n  min-width: 200px; }\n\ntd.min-width-110 {\n  min-width: 110px !important; }\n\n.min-width-1 {\n  min-width: 1px !important; }\n\n.min-width-2 {\n  min-width: 2px !important; }\n\n.min-width-3 {\n  min-width: 3px !important; }\n\n.min-width-4 {\n  min-width: 4px !important; }\n\n.min-width-5 {\n  min-width: 5px !important; }\n\n.min-width-6 {\n  min-width: 6px !important; }\n\n.min-width-7 {\n  min-width: 7px !important; }\n\n.min-width-8 {\n  min-width: 8px !important; }\n\n.min-width-9 {\n  min-width: 9px !important; }\n\n.min-width-10 {\n  min-width: 10px !important; }\n\n.min-width-11 {\n  min-width: 11px !important; }\n\n.min-width-12 {\n  min-width: 12px !important; }\n\n.min-width-13 {\n  min-width: 13px !important; }\n\n.min-width-14 {\n  min-width: 14px !important; }\n\n.min-width-15 {\n  min-width: 15px !important; }\n\n.min-width-16 {\n  min-width: 16px !important; }\n\n.min-width-17 {\n  min-width: 17px !important; }\n\n.min-width-18 {\n  min-width: 18px !important; }\n\n.min-width-19 {\n  min-width: 19px !important; }\n\n.min-width-20 {\n  min-width: 20px !important; }\n\n.min-width-21 {\n  min-width: 21px !important; }\n\n.min-width-22 {\n  min-width: 22px !important; }\n\n.min-width-23 {\n  min-width: 23px !important; }\n\n.min-width-24 {\n  min-width: 24px !important; }\n\n.min-width-25 {\n  min-width: 25px !important; }\n\n.min-width-26 {\n  min-width: 26px !important; }\n\n.min-width-27 {\n  min-width: 27px !important; }\n\n.min-width-28 {\n  min-width: 28px !important; }\n\n.min-width-29 {\n  min-width: 29px !important; }\n\n.min-width-30 {\n  min-width: 30px !important; }\n\n.min-width-31 {\n  min-width: 31px !important; }\n\n.min-width-32 {\n  min-width: 32px !important; }\n\n.min-width-33 {\n  min-width: 33px !important; }\n\n.min-width-34 {\n  min-width: 34px !important; }\n\n.min-width-35 {\n  min-width: 35px !important; }\n\n.min-width-36 {\n  min-width: 36px !important; }\n\n.min-width-37 {\n  min-width: 37px !important; }\n\n.min-width-38 {\n  min-width: 38px !important; }\n\n.min-width-39 {\n  min-width: 39px !important; }\n\n.min-width-40 {\n  min-width: 40px !important; }\n\n.min-width-41 {\n  min-width: 41px !important; }\n\n.min-width-42 {\n  min-width: 42px !important; }\n\n.min-width-43 {\n  min-width: 43px !important; }\n\n.min-width-44 {\n  min-width: 44px !important; }\n\n.min-width-45 {\n  min-width: 45px !important; }\n\n.min-width-46 {\n  min-width: 46px !important; }\n\n.min-width-47 {\n  min-width: 47px !important; }\n\n.min-width-48 {\n  min-width: 48px !important; }\n\n.min-width-49 {\n  min-width: 49px !important; }\n\n.min-width-50 {\n  min-width: 50px !important; }\n\n.min-width-51 {\n  min-width: 51px !important; }\n\n.min-width-52 {\n  min-width: 52px !important; }\n\n.min-width-53 {\n  min-width: 53px !important; }\n\n.min-width-54 {\n  min-width: 54px !important; }\n\n.min-width-55 {\n  min-width: 55px !important; }\n\n.min-width-56 {\n  min-width: 56px !important; }\n\n.min-width-57 {\n  min-width: 57px !important; }\n\n.min-width-58 {\n  min-width: 58px !important; }\n\n.min-width-59 {\n  min-width: 59px !important; }\n\n.min-width-60 {\n  min-width: 60px !important; }\n\n.min-width-61 {\n  min-width: 61px !important; }\n\n.min-width-62 {\n  min-width: 62px !important; }\n\n.min-width-63 {\n  min-width: 63px !important; }\n\n.min-width-64 {\n  min-width: 64px !important; }\n\n.min-width-65 {\n  min-width: 65px !important; }\n\n.min-width-66 {\n  min-width: 66px !important; }\n\n.min-width-67 {\n  min-width: 67px !important; }\n\n.min-width-68 {\n  min-width: 68px !important; }\n\n.min-width-69 {\n  min-width: 69px !important; }\n\n.min-width-70 {\n  min-width: 70px !important; }\n\n.min-width-71 {\n  min-width: 71px !important; }\n\n.min-width-72 {\n  min-width: 72px !important; }\n\n.min-width-73 {\n  min-width: 73px !important; }\n\n.min-width-74 {\n  min-width: 74px !important; }\n\n.min-width-75 {\n  min-width: 75px !important; }\n\n.min-width-76 {\n  min-width: 76px !important; }\n\n.min-width-77 {\n  min-width: 77px !important; }\n\n.min-width-78 {\n  min-width: 78px !important; }\n\n.min-width-79 {\n  min-width: 79px !important; }\n\n.min-width-80 {\n  min-width: 80px !important; }\n\n.min-width-81 {\n  min-width: 81px !important; }\n\n.min-width-82 {\n  min-width: 82px !important; }\n\n.min-width-83 {\n  min-width: 83px !important; }\n\n.min-width-84 {\n  min-width: 84px !important; }\n\n.min-width-85 {\n  min-width: 85px !important; }\n\n.min-width-86 {\n  min-width: 86px !important; }\n\n.min-width-87 {\n  min-width: 87px !important; }\n\n.min-width-88 {\n  min-width: 88px !important; }\n\n.min-width-89 {\n  min-width: 89px !important; }\n\n.min-width-90 {\n  min-width: 90px !important; }\n\n.min-width-91 {\n  min-width: 91px !important; }\n\n.min-width-92 {\n  min-width: 92px !important; }\n\n.min-width-93 {\n  min-width: 93px !important; }\n\n.min-width-94 {\n  min-width: 94px !important; }\n\n.min-width-95 {\n  min-width: 95px !important; }\n\n.min-width-96 {\n  min-width: 96px !important; }\n\n.min-width-97 {\n  min-width: 97px !important; }\n\n.min-width-98 {\n  min-width: 98px !important; }\n\n.min-width-99 {\n  min-width: 99px !important; }\n\n.min-width-100 {\n  min-width: 100px !important; }\n\n.min-width-101 {\n  min-width: 101px !important; }\n\n.min-width-102 {\n  min-width: 102px !important; }\n\n.min-width-103 {\n  min-width: 103px !important; }\n\n.min-width-104 {\n  min-width: 104px !important; }\n\n.min-width-105 {\n  min-width: 105px !important; }\n\n.min-width-106 {\n  min-width: 106px !important; }\n\n.min-width-107 {\n  min-width: 107px !important; }\n\n.min-width-108 {\n  min-width: 108px !important; }\n\n.min-width-109 {\n  min-width: 109px !important; }\n\n.min-width-110 {\n  min-width: 110px !important; }\n\n.min-width-111 {\n  min-width: 111px !important; }\n\n.min-width-112 {\n  min-width: 112px !important; }\n\n.min-width-113 {\n  min-width: 113px !important; }\n\n.min-width-114 {\n  min-width: 114px !important; }\n\n.min-width-115 {\n  min-width: 115px !important; }\n\n.min-width-116 {\n  min-width: 116px !important; }\n\n.min-width-117 {\n  min-width: 117px !important; }\n\n.min-width-118 {\n  min-width: 118px !important; }\n\n.min-width-119 {\n  min-width: 119px !important; }\n\n.min-width-120 {\n  min-width: 120px !important; }\n\n.min-width-121 {\n  min-width: 121px !important; }\n\n.min-width-122 {\n  min-width: 122px !important; }\n\n.min-width-123 {\n  min-width: 123px !important; }\n\n.min-width-124 {\n  min-width: 124px !important; }\n\n.min-width-125 {\n  min-width: 125px !important; }\n\n.min-width-126 {\n  min-width: 126px !important; }\n\n.min-width-127 {\n  min-width: 127px !important; }\n\n.min-width-128 {\n  min-width: 128px !important; }\n\n.min-width-129 {\n  min-width: 129px !important; }\n\n.min-width-130 {\n  min-width: 130px !important; }\n\n.min-width-131 {\n  min-width: 131px !important; }\n\n.min-width-132 {\n  min-width: 132px !important; }\n\n.min-width-133 {\n  min-width: 133px !important; }\n\n.min-width-134 {\n  min-width: 134px !important; }\n\n.min-width-135 {\n  min-width: 135px !important; }\n\n.min-width-136 {\n  min-width: 136px !important; }\n\n.min-width-137 {\n  min-width: 137px !important; }\n\n.min-width-138 {\n  min-width: 138px !important; }\n\n.min-width-139 {\n  min-width: 139px !important; }\n\n.min-width-140 {\n  min-width: 140px !important; }\n\n.min-width-141 {\n  min-width: 141px !important; }\n\n.min-width-142 {\n  min-width: 142px !important; }\n\n.min-width-143 {\n  min-width: 143px !important; }\n\n.min-width-144 {\n  min-width: 144px !important; }\n\n.min-width-145 {\n  min-width: 145px !important; }\n\n.min-width-146 {\n  min-width: 146px !important; }\n\n.min-width-147 {\n  min-width: 147px !important; }\n\n.min-width-148 {\n  min-width: 148px !important; }\n\n.min-width-149 {\n  min-width: 149px !important; }\n\n.min-width-150 {\n  min-width: 150px !important; }\n\n.min-width-151 {\n  min-width: 151px !important; }\n\n.min-width-152 {\n  min-width: 152px !important; }\n\n.min-width-153 {\n  min-width: 153px !important; }\n\n.min-width-154 {\n  min-width: 154px !important; }\n\n.min-width-155 {\n  min-width: 155px !important; }\n\n.min-width-156 {\n  min-width: 156px !important; }\n\n.min-width-157 {\n  min-width: 157px !important; }\n\n.min-width-158 {\n  min-width: 158px !important; }\n\n.min-width-159 {\n  min-width: 159px !important; }\n\n.min-width-160 {\n  min-width: 160px !important; }\n\n.min-width-161 {\n  min-width: 161px !important; }\n\n.min-width-162 {\n  min-width: 162px !important; }\n\n.min-width-163 {\n  min-width: 163px !important; }\n\n.min-width-164 {\n  min-width: 164px !important; }\n\n.min-width-165 {\n  min-width: 165px !important; }\n\n.min-width-166 {\n  min-width: 166px !important; }\n\n.min-width-167 {\n  min-width: 167px !important; }\n\n.min-width-168 {\n  min-width: 168px !important; }\n\n.min-width-169 {\n  min-width: 169px !important; }\n\n.min-width-170 {\n  min-width: 170px !important; }\n\n.min-width-171 {\n  min-width: 171px !important; }\n\n.min-width-172 {\n  min-width: 172px !important; }\n\n.min-width-173 {\n  min-width: 173px !important; }\n\n.min-width-174 {\n  min-width: 174px !important; }\n\n.min-width-175 {\n  min-width: 175px !important; }\n\n.min-width-176 {\n  min-width: 176px !important; }\n\n.min-width-177 {\n  min-width: 177px !important; }\n\n.min-width-178 {\n  min-width: 178px !important; }\n\n.min-width-179 {\n  min-width: 179px !important; }\n\n.min-width-180 {\n  min-width: 180px !important; }\n\n.min-width-181 {\n  min-width: 181px !important; }\n\n.min-width-182 {\n  min-width: 182px !important; }\n\n.min-width-183 {\n  min-width: 183px !important; }\n\n.min-width-184 {\n  min-width: 184px !important; }\n\n.min-width-185 {\n  min-width: 185px !important; }\n\n.min-width-186 {\n  min-width: 186px !important; }\n\n.min-width-187 {\n  min-width: 187px !important; }\n\n.min-width-188 {\n  min-width: 188px !important; }\n\n.min-width-189 {\n  min-width: 189px !important; }\n\n.min-width-190 {\n  min-width: 190px !important; }\n\n.min-width-191 {\n  min-width: 191px !important; }\n\n.min-width-192 {\n  min-width: 192px !important; }\n\n.min-width-193 {\n  min-width: 193px !important; }\n\n.min-width-194 {\n  min-width: 194px !important; }\n\n.min-width-195 {\n  min-width: 195px !important; }\n\n.min-width-196 {\n  min-width: 196px !important; }\n\n.min-width-197 {\n  min-width: 197px !important; }\n\n.min-width-198 {\n  min-width: 198px !important; }\n\n.min-width-199 {\n  min-width: 199px !important; }\n\n.min-width-200 {\n  min-width: 200px !important; }\n\n.release-switch {\n  position: absolute;\n  bottom: 0;\n  right: 0; }\n\n.icon-position {\n  text-align: center; }\n\n.width-auto {\n  width: auto !important; }\n\n.remove-white-space {\n  white-space: nowrap; }\n\n.sortorder {\n  color: #c2c2c2 !important; }\n\n.sortorder.active {\n  color: #000000 !important; }\n\n.sortorder:after {\n  content: '\\25B2'; }\n\n.sortorder.active.reverse:after {\n  content: '\\25BC'; }\n\n.remove-left-pad {\n  padding-left: 0px !important; }\n\n.td-vertical-align {\n  vertical-align: top !important; }\n\n.table-pad-3 td {\n  padding: 3px !important; }\n\n.tanker-width {\n  width: 75px; }\n\n.hold-date-width {\n  width: 90px; }\n\n.undo-icon-height-20 {\n  height: 20px; }\n\n.item-hold-margin-top-20 {\n  margin-top: 20px !important; }\n\n.item-hold-pagination-margin-bottom {\n  margin-bottom: 20px !important; }\n\n.item-hold-map-container #hold-map {\n  height: 400px;\n  width: 100%;\n  margin-bottom: 26px; }\n\n.item-hold-map-container .leaf-map {\n  height: 400px; }\n", ""]);

// exports


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; } }\n\n.show-only-in-print {\n  display: none; }\n\ntable.cell-width-200 td {\n  min-width: 120px; }\n\ntd.min-width-39 {\n  min-width: 39px !important; }\n\ntd.min-width-50 {\n  min-width: 100px !important; }\n\ntd.min-width-40 {\n  min-width: 80px !important; }\n\n.item-date-width-10 {\n  width: 10%; }\n\n.undo-icon {\n  height: 20px;\n  margin-top: -5px;\n  padding: 0; }\n\n.mb-1 {\n  margin-bottom: 1rem; }\n\n.w-70 {\n  width: 58.33% !important; }\n\n.margin-auto {\n  display: flex;\n  justify-content: center; }\n\n.right-btn-section {\n  display: flex;\n  justify-content: flex-end; }\n\n.mr-1 {\n  margin-right: 5px; }\n\n.font-19 {\n  font-size: 19px !important; }\n\n.item-transaction-align-center {\n  align-items: center;\n  display: flex;\n  justify-content: space-between; }\n\n@media (min-width: 767px) and (max-width: 1024px) {\n  .font-15 {\n    font-size: 15px !important; }\n  .mob-w-100 {\n    width: 100% !important; }\n  .ml-1-5 {\n    margin-left: 1.5rem !important; }\n  .mr-1-1 {\n    margin-right: 1.1rem !important; } }\n\n@media (min-width: 1100px) and (max-width: 1440px) {\n  .font-19 {\n    font-size: 18px !important; } }\n\n.items-err-lbl-margin-top {\n  margin-top: 10px !important; }\n\n.wd-09 {\n  width: 9% !important; }\n\n.item-history-btn-section {\n  padding: 5px 6px !important;\n  font-size: 1.24rem !important;\n  line-height: 1.5 !important;\n  border-radius: 3px !important;\n  margin-bottom: 5px !important;\n  float: right; }\n\n.d-flex-end {\n  display: flex;\n  justify-content: flex-end; }\n\n.text-input-section {\n  width: 70%;\n  display: flex;\n  justify-content: center; }\n\n.item-status-tracking-id-search {\n  margin: auto;\n  text-align: center;\n  display: contents;\n  width: 100%; }\n\n.item-status-timezone-dd-section {\n  display: flex;\n  justify-content: end; }\n\n.no-wrap-table-header {\n  white-space: nowrap !important; }\n\nbutton.glyphicon-button {\n  background: none !important;\n  border: none !important;\n  padding: 0 !important;\n  box-shadow: none !important;\n  outline: none !important;\n  color: inherit; }\n\n.deposit-count-bg-color {\n  background-clip: padding-box !important;\n  background-color: antiquewhite !important; }\n\n.right-pad-10 {\n  padding-right: 10px !important; }\n\n.left-aligned-flex {\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n  flex-wrap: wrap; }\n  .left-aligned-flex .item-history-btn-section {\n    float: none !important; }\n", ""]);

// exports


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".print-stop-receipt-section .table-row-height {\n  height: 5rem; }\n", ""]);

// exports


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".sortorder {\n  color: #c2c2c2  !important; }\n\n.sortorder.active {\n  color: #000000 !important; }\n\n.sortorder:after {\n  content: '\\25B2'; }\n\n.sortorder.active.reverse:after {\n  content: '\\25BC'; }\n\n.date-time-width {\n  width: 15% !important; }\n\n.location-hold-dd-section .multi-select span.multiSelect button#multi-select-button {\n  width: 100%;\n  text-align: left;\n  min-height: 45px !important; }\n", ""]);

// exports


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; }\n  .logo-width {\n    width: 10% !important;\n    height: 80px !important;\n    padding-right: 0px !important; } }\n\n.show-only-in-print {\n  display: none; }\n\ntable.cell-width-200 td {\n  min-width: 140px; }\n\ntd.min-width-39 {\n  min-width: 39px !important; }\n\n.table-pad-7 td {\n  padding: 7px !important; }\n\n.tableSize {\n  width: 100%;\n  margin-bottom: 20px;\n  margin-left: -80px; }\n\n.printButton {\n  margin-right: 30px;\n  margin-top: 6px; }\n\n.dvOnePos {\n  margin-top: -20px;\n  margin-top: -55px;\n  width: 96%; }\n\n.dvTwoPos {\n  width: 76%;\n  margin-left: -75px;\n  text-align: center;\n  float: left; }\n\n.dvThreePos {\n  text-align: right;\n  width: 24%;\n  float: right; }\n\n.nav-center {\n  text-align: center; }\n  .nav-center ul.nav {\n    display: inline-block; }\n    .nav-center ul.nav li {\n      display: inline a;\n        display-float: left; }\n\n.nav-bar-active {\n  border: 1px solid #ddd !important;\n  border-bottom: 0px !important;\n  border-radius: 5px 5px 0px 0px !important;\n  padding: 10px !important; }\n\n.service-date-width {\n  width: 87px; }\n\n.stop-date-time-width {\n  width: 50px; }\n\n.receipt-btn-position {\n  display: flex; }\n\n.denom-icon {\n  width: 25px; }\n\n.order-type-width {\n  width: 10%; }\n\n.export-btn-pad-5 {\n  padding-right: 5px; }\n\n.emergency-icon {\n  width: 21%; }\n\n.history-link-btn {\n  color: #337ab7;\n  cursor: pointer; }\n\n.history-link-btn:hover {\n  text-decoration: underline; }\n\n@media (min-width: 767px) and (max-width: 1025px) {\n  .font-12 {\n    font-size: 12px; } }\n\n.service-history-tbl .table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 5px; }\n\n.variance-alert-icon {\n  margin-bottom: 5px;\n  margin-left: 5px;\n  width: 15%; }\n\n.tz-list-dd-height {\n  height: 43px !important; }\n\n.service-history-search-section {\n  width: 74%;\n  display: flex;\n  justify-content: center; }\n\n.location-search-pad-10 {\n  padding-right: 10px; }\n\n.padding-03 {\n  padding: 3px !important; }\n\n.paperclip-icon-width {\n  width: 10% !important; }\n", ""]);

// exports


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".service-history-lbl {\n  margin-top: 23px;\n  margin-left: 10px !important; }\n\n.service-history-print-title-section {\n  display: flex;\n  gap: 20px; }\n", ""]);

// exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".lock-open-error-filter-section {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 15px; }\n\n.lock-open-error-filter-dd-w-100 {\n  width: 100%; }\n\n.lock-open-error-branch-search-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 350px !important;\n  overflow-y: auto !important; }\n", ""]);

// exports


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".remove-padding {\n  padding: 0px !important; }\n\n.location-font-size {\n  font-size: 15px; }\n\n.created-date-width {\n  width: 105px; }\n\n.table-margin-top-10 {\n  margin-top: 10px; }\n", ""]);

// exports


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n.margin-top-40 {\n  margin-top: 40px; }\n\n.order-total-height {\n  height: 40px; }\n\n.residual-denom-width {\n  width: 67px; }\n\n.residual-shps-record {\n  word-break: break-word; }\n\n.shp-width-230 {\n  width: 230px; }\n\n.residual-records tbody.scroll-content {\n  display: block;\n  max-height: 350px;\n  overflow-y: scroll; }\n\n.residual-records tbody.scroll-content::-webkit-scrollbar-button {\n  display: none; }\n\n.residual-records tbody.scroll-content::-webkit-scrollbar-track-piece {\n  background: #eee; }\n\n.residual-records tbody.scroll-content::-webkit-scrollbar-thumb {\n  background: #ccc; }\n\n.residual-records ​\ntbody.scroll-content:hover::-webkit-scrollbar-thumb {\n  background: #888; }\n\n.residual-records ​\nthead, .residual-records tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed; }\n\n.order-date-width {\n  width: 105px; }\n\n.shp-denom-width {\n  width: 66px; }\n\n.completed-shp-width {\n  width: 108px; }\n\n.funding-source-dd-height {\n  height: 34px; }\n\n.tab-btn-width {\n  width: 120px; }\n\n.from-loc-col-width {\n  width: 15%; }\n\n.col-width-15 {\n  width: 15%; }\n\n.order-history-center-section {\n  display: flex;\n  justify-content: center; }\n\n.w-100 {\n  min-width: 100%; }\n\n.order-d-flex {\n  display: flex;\n  justify-content: center; }\n\n.order-w-46 {\n  width: 46%; }\n\n@media (min-width: 767px) and (max-width: 1023px) {\n  .tab-btn-width {\n    width: 112px; }\n  .w-60 {\n    width: 60%; } }\n\n@media (min-width: 1024px) and (max-width: 1099px) {\n  .tab-btn-width {\n    width: 112px; }\n  .w-60 {\n    width: 45%; } }\n\n.orders-section {\n  margin-bottom: 20px; }\n\n.order-section-header {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important; }\n\n.orders-no-data-container {\n  padding-left: 0px !important;\n  padding-right: 0px !important; }\n", ""]);

// exports


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".orders-print-container {\n  padding: 10px;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  color: #333; }\n\n.orders-print-title {\n  color: #2e7d32;\n  border-bottom: 2px solid #2e7d32;\n  padding-bottom: 8px;\n  margin-bottom: 5px; }\n\n.orders-print-meta {\n  margin-bottom: 15px;\n  font-size: 14px;\n  color: #555; }\n\n.print-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  font-size: 10px; }\n  .print-table th, .print-table td {\n    border: 1px solid #ddd;\n    padding: 5px 3px;\n    text-align: center;\n    vertical-align: middle;\n    word-break: break-word; }\n  .print-table th {\n    background-color: #f1f8e9;\n    color: #2e7d32;\n    font-weight: bold; }\n  .print-table .status-text {\n    color: #d32f2f; }\n\n.print-completed-denom {\n  width: 60px !important; }\n\n.print-denom-fixed {\n  width: 100px !important; }\n\n.print-completed-orderno {\n  width: 50px !important; }\n\n.print-completed-date {\n  width: 65px !important; }\n\n.print-completed-status {\n  width: 80px !important; }\n\n.print-completed-tracking {\n  width: 90px !important; }\n\n.print-completed-loc {\n  width: 55px !important; }\n\n.print-completed-amount {\n  width: 70px !important; }\n\n.print-completed-requested-amount {\n  width: 80px !important; }\n\n.print-completed-user {\n  width: 65px !important; }\n\n.print-completed-serial {\n  width: 45px !important; }\n\n.completed-print-table {\n  table-layout: fixed !important;\n  width: 100% !important; }\n  .completed-print-table th, .completed-print-table td {\n    word-break: break-word !important;\n    white-space: normal !important;\n    text-align: center; }\n", ""]);

// exports


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".physical-cash-card-margin {\n  margin: 10px 10px !important;\n  width: 10%;\n  text-align: center; }\n\n.physical-cash-denom-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center; }\n\n.physical-cash-count-label {\n  margin-bottom: 0px !important;\n  margin-left: 2%; }\n\n.physical-cash-count-button {\n  margin-left: 14%; }\n\n.info-section-color {\n  background-color: #e8e8e8 !important; }\n\n.font-size-18 {\n  font-size: 18px !important; }\n\n.remove-border .form-control {\n  border: 0px solid #ccc !important; }\n\n.lbl-height-section {\n  line-height: 1.38 !important; }\n\n.denom-img-width {\n  width: 45px; }\n\n.physical-cash-card-body {\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  margin: 0;\n  padding: 3.5rem 3.5rem;\n  position: relative; }\n\n.physical-cash-datetimepicker-section .disabled input {\n  background-color: #eeeeee;\n  border-color: #eeeeee !important; }\n\n.dd-padding-left-05 {\n  padding-left: 5px !important; }\n\n.funding-source-font-color {\n  color: #484848 !important; }\n\n.check-icon-section {\n  top: 3px !important;\n  padding-right: 3px !important; }\n\n.finished-by-section {\n  font-size: 15px;\n  color: olivedrab; }\n\n.bg-color-red {\n  background: #f9e3e2 !important;\n  border: #f9e3e2 !important; }\n\n.physical-cash-datetimepicker-section div.datetimepicker-wrapper {\n  display: block !important; }\n\n.margin-top-03 {\n  margin-top: 3px !important; }\n\n.physical-cash-print-btn-pad .btn {\n  padding: 4px 12px !important; }\n\n.cursor-not-allowed-section {\n  pointer-events: none !important;\n  cursor: not-allowed !important; }\n\n.balance-exceed-error {\n  display: flex;\n  justify-content: center; }\n  .balance-exceed-error .alert {\n    padding: 10px !important; }\n\n.no-variance-icon-section {\n  color: green;\n  font-size: 20px; }\n\n.variance-icon-section {\n  background: bisque !important; }\n\n.approved-by-section {\n  color: darkorange !important; }\n\n.cash-count-btn-section {\n  display: flex;\n  gap: 12px !important; }\n\n.btn-gap-20 {\n  gap: 20px; }\n", ""]);

// exports


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .physical-cash-count-print-css-section .hide-in-print {\n    display: none !important; }\n  .physical-cash-count-print-css-section .show-only-in-print {\n    display: block !important; }\n  .physical-cash-count-print-css-section .print-header-margin {\n    margin-top: 10px; }\n  .physical-cash-count-print-css-section .bagout-print-align-section {\n    text-align: left;\n    margin-top: 50px; }\n  .physical-cash-count-print-css-section .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .physical-cash-count-print-css-section .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .physical-cash-count-print-css-section .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .physical-cash-count-print-css-section .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .physical-cash-count-print-css-section .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .physical-cash-count-print-css-section .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .physical-cash-count-print-css-section .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .physical-cash-count-print-css-section .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .physical-cash-count-print-css-section .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .physical-cash-count-print-css-section .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .physical-cash-count-print-css-section .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .physical-cash-count-print-css-section .col-print-12 {\n    width: 100% !important;\n    float: left !important; } }\n", ""]);

// exports


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".restore-route-assignment-css-section .restore-all-btn {\n  padding: 10px 16px !important;\n  font-size: 16px !important;\n  line-height: 1.33333 !important;\n  border-radius: 6px !important; }\n\n.restore-route-assignment-css-section .badge {\n  border-radius: 4px !important;\n  background-color: #5cb85c !important;\n  font-size: 14px !important; }\n", ""]);

// exports


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".label-style {\n  font-size: 16px;\n  color: black;\n  font-weight: bold; }\n\n.margin-left-80 {\n  margin-left: 80px; }\n", ""]);

// exports


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n.route-date-picker .datetimepicker-wrapper {\n  margin-top: 20px; }\n\n.textPosition {\n  margin-top: -15px; }\n\n.width-auto {\n  width: auto !important; }\n\n.date-col-width-15 {\n  width: 15%; }\n\n.tran-type-width {\n  width: 20%; }\n\n.tran-comments {\n  width: 220px; }\n\n.route-deviation tbody.scroll-content {\n  display: block;\n  max-height: 300px;\n  overflow-y: scroll; }\n\n.route-deviation tbody.scroll-content::-webkit-scrollbar {\n  width: 10px; }\n\n.route-deviation tbody.scroll-content::-webkit-scrollbar-button {\n  display: none; }\n\n.route-deviation tbody.scroll-content::-webkit-scrollbar-track-piece {\n  background: #eee; }\n\n.route-deviation tbody.scroll-content::-webkit-scrollbar-thumb {\n  background: #ccc; }\n\n.route-deviation ​\ntbody.scroll-content:hover::-webkit-scrollbar-thumb {\n  background: #888; }\n\n.route-deviation ​\nthead, .route-deviation tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed; }\n\n.margin-left-55 {\n  margin-left: 55px; }\n\n.ml-1_2 {\n  margin-left: 1.2rem !important; }\n\n.tab-w-150 {\n  width: 150px; }\n\n.tab-w-209 {\n  width: 209px; }\n\n@media (min-width: 766px) and (max-width: 1023px) {\n  .ml-xs-0 {\n    margin-left: 0px !important; }\n  .ml-1_2 {\n    margin-left: 1.2rem !important; }\n  .tran-comments {\n    width: 159.5px !important; }\n  .tab-w-150 {\n    width: 111px !important; }\n  .tab-w-209 {\n    width: 152px !important; } }\n\n@media (min-width: 1024px) and (max-width: 1100px) {\n  .ml-xs-0 {\n    margin-left: 0px !important; }\n  .tran-comments {\n    width: 211px !important; }\n  .tab-w-150 {\n    width: 144px !important; }\n  .tab-w-209 {\n    width: 203px !important; } }\n\n.routes-progress-bar-height {\n  height: 37px !important; }\n\n.route-stats-lbl-section {\n  float: left;\n  margin-top: 5px; }\n\n.route-timer-section {\n  font-size: large;\n  margin-top: 8px;\n  color: #333;\n  padding-left: 5px; }\n\n.route-stops-bar-section {\n  margin-top: 8px;\n  font-size: 17px; }\n\n.margin-right-15 {\n  padding-right: 15px; }\n\n.radio-btn-height {\n  height: 20px; }\n\n.progress-bar-margin-bottom-05 {\n  margin-bottom: 5px !important; }\n\n.delivered-shp-amount-color {\n  color: green !important; }\n\n.pending-shp-amount-color {\n  color: #2d78b9 !important; }\n\n.short-load-shp-amount-color {\n  color: orange !important; }\n\n.not-delivered-amount-color {\n  color: #e06603 !important; }\n\n.hold-shp-amount-color {\n  color: #f0ad4e !important; }\n\n.font-weight-400 {\n  font-weight: 400 !important; }\n\n.delivery-pickup-btn-section {\n  margin-top: 7px;\n  height: 2.2rem; }\n\n.margin-top-04 {\n  margin-top: 4px; }\n\n.margin-left-50 {\n  margin-left: 50px; }\n\n.loc-type-w {\n  width: 35px; }\n\n.loc-type-section {\n  padding: 3px;\n  font-size: 16px; }\n\n.next-stop-color {\n  background-color: #ffd78d !important; }\n\n.routes-shipment-section .panel-body {\n  padding: 0px !important;\n  max-height: 380px;\n  overflow: auto; }\n\n.w-85 {\n  width: 85%; }\n\n.routes-margin-auto {\n  margin: auto; }\n\n.mt-4R {\n  margin-top: 4rem; }\n\n.mt-7R {\n  margin-top: 7rem; }\n\n.transaction-comment-section {\n  margin-bottom: 3px !important;\n  margin-left: 5px; }\n\n.table-pad-5 td {\n  padding: 5px !important; }\n\n.routes-font-size {\n  font-size: 1.44rem; }\n\n.img-rotation-270 {\n  transform: rotate(270deg); }\n\n.img-rotation-90 {\n  transform: rotate(90deg); }\n\n.progress-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 50px; }\n\n.left-label-section {\n  margin-right: 1.5rem;\n  width: 7.5%; }\n\n.progress-bar-color {\n  width: 70%;\n  margin-right: 1.5rem; }\n\n.progress-bar-color .progress {\n  margin-bottom: 0px !important; }\n\n.count-value {\n  width: 8%;\n  display: flex; }\n\n.mr-5 {\n  margin-right: 5px; }\n\n.font-size-route-15 {\n  font-size: 1.4rem !important; }\n\n.progress-row .label {\n  padding: .3em .5em 0.3em; }\n\n.grp-btn-height-18 {\n  height: 18px;\n  padding: 0px 5px !important;\n  font-size: 11px !important; }\n\n.font-size-route-13 {\n  font-size: 1.35rem !important; }\n\n.branch-mgmt-dd-or-search-section {\n  margin: auto;\n  width: 80%; }\n\n.cant-top-route-status-bucket-color {\n  background-color: #c80000 !important; }\n\n.cant-stop-amount-color {\n  color: #c80000 !important; }\n\n.hold-amount-color {\n  background-color: #f0ad4e !important; }\n\n.shipment-transaction-btn-color {\n  background-color: orange !important; }\n\n.shipment-transaction-badge .badge {\n  padding: 4px 8px;\n  border-radius: 6px;\n  margin-left: 2px;\n  margin-bottom: 1px; }\n\n.right-pad-10 {\n  padding-right: 10px; }\n\n.duplicate-stop-alert-icon {\n  width: 20px; }\n\n.route-status-btn-section {\n  justify-content: end;\n  display: flex;\n  gap: 5px; }\n\n.pad-left-10-block {\n  display: block;\n  padding-left: 10px; }\n\n.child-denom-section {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 3px;\n  padding-top: 3px;\n  padding-left: 2px;\n  font-size: small;\n  line-height: 1.6; }\n\n.child-denom-label {\n  flex: 0 0 auto;\n  white-space: nowrap;\n  color: #000;\n  font-weight: 600;\n  min-width: 36px;\n  line-height: 30px; }\n\n.child-denom-list {\n  flex: 1 1 auto; }\n\n.child-denom-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n  margin: 0 16px 8px 0; }\n\n.child-denom-item denom-icon {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  line-height: 1; }\n\n.child-denom-text {\n  font-size: 13px; }\n", ""]);

// exports


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".stops-scheduling .scroll-view {\n  max-height: 300px;\n  min-height: 300px;\n  overflow-y: scroll; }\n\n.stops-scheduling .add-records-section {\n  display: flex;\n  align-items: center;\n  margin-top: 5px; }\n\n.stops-scheduling .add-record-header-section {\n  display: flex;\n  justify-content: end;\n  gap: 10px; }\n\n.stops-scheduling .margin-top-48 {\n  margin-top: 48px; }\n\n.stops-scheduling .daily-schedule-input .form-control {\n  display: inline-table;\n  width: 15%;\n  height: 30px; }\n\n.stops-scheduling .the-month-btn-padding {\n  padding: 4px 3px !important; }\n\n.stops-scheduling .the-month-padding .form-control {\n  height: 30px; }\n\n.stops-scheduling .daily-schedule-section-border {\n  border: 0.1rem groove;\n  padding: 7px; }\n\n.stops-scheduling .monthly-schedule-line-section {\n  margin-top: 5px !important;\n  margin-bottom: 5px !important; }\n\n.stops-scheduling .of-every-text-section {\n  padding-right: 5px;\n  margin-top: 5px; }\n\n.stops-scheduling .months-text-section {\n  padding-left: 5px;\n  margin-top: 5px; }\n\n.stops-scheduling .scheduled-pattern-weeks-dd {\n  display: flex;\n  justify-content: right;\n  gap: 10px; }\n  .stops-scheduling .scheduled-pattern-weeks-dd .form-control {\n    width: 25% !important;\n    height: 20px !important; }\n\n.stops-scheduling .scheduled-week-btn-section .btn {\n  padding: 6px 3px !important; }\n\n.stops-scheduling .schedule-weeks-input .form-control {\n  display: inline-table;\n  width: 30%;\n  height: 20px; }\n\n.stops-scheduling .list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 0px !important;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid #ddd; }\n\n.stops-scheduling .pending-stops-list-section {\n  display: flex;\n  justify-content: center; }\n", ""]);

// exports


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .pagebreak {\n    page-break-after: always;\n    clear: both; } }\n", ""]);

// exports


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".tblPos {\n  margin-top: 40px; }\n\n.min-width-140 {\n  min-width: 140px !important; }\n\n.width-auto {\n  width: auto !important; }\n\n.badge-current-contents {\n  background-color: #286090 !important;\n  color: #fff !important; }\n", ""]);

// exports


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".btn-default.btn-on.active {\n  background-color: #5BB75B;\n  color: white; }\n\n.btn-default.btn-off.active {\n  background-color: #5BB75B;\n  color: white; }\n\n.bypass-code-date-section {\n  min-width: 15%; }\n\n.minWidth150 {\n  min-width: 150px; }\n\n.margin-bottom-30 {\n  margin-bottom: 30px; }\n\n.bypass-code-section {\n  font-size: 37px;\n  color: #70ad46; }\n\n.bypass-code-title-section {\n  color: black;\n  font-weight: bold; }\n\n.bypass-code-view-section {\n  margin-top: 100px;\n  padding-left: 100px !important; }\n", ""]);

// exports


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".div-main-border {\n  width: 99%;\n  border: 1px solid #e4e4e4; }\n\n.div-add-cash {\n  width: 99%;\n  border: 0px; }\n\n.padding5 {\n  padding: 5px !important; }\n\n.padding8 {\n  padding: 8px !important; }\n\n.padding12 {\n  padding: 12px !important; }\n\n.margin-dd-20 {\n  margin-left: -20px; }\n\n.remove-button {\n  display: inherit;\n  margin: -4%;\n  margin-top: 60px; }\n\n.box2 {\n  border-left: 1px solid #e4e4e4;\n  border-right: 1px solid #e4e4e4;\n  min-height: 140px !important;\n  padding: 12px; }\n\n.box3 {\n  border-left: 1px solid #e4e4e4;\n  min-height: 140px !important;\n  padding: 12px; }\n\n.box2-main-div {\n  border: 1px solid #e4e4e4;\n  padding: 5px 5px 5px 5px !important;\n  display: flex !important;\n  width: 30% !important;\n  margin-right: 1%; }\n\n.ng-duplicate {\n  border: 1px solid red !important; }\n\n.no-padding {\n  padding: 0px !important; }\n\n.img-currency {\n  width: 22px; }\n\n.bulk-cash-currency-trigger {\n  text-decoration: none !important;\n  color: inherit !important;\n  cursor: pointer; }\n  .bulk-cash-currency-trigger:hover, .bulk-cash-currency-trigger:focus {\n    text-decoration: none !important;\n    color: inherit !important; }\n\n.bulk-cash-currency-symbol {\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  min-width: 22px;\n  padding: 2px 6px; }\n\n.bulk-cash-popover-currency-symbol {\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  min-width: 1.5em;\n  padding: 2px 6px; }\n\n.box2-DD {\n  padding: 0px !important;\n  margin-left: 8px; }\n\n.box2-remove-div {\n  padding: 5px !important;\n  width: 14% !important; }\n\n.btn-icon {\n  padding: 4px 7px; }\n\n.btn-disabled {\n  background-color: #808080 !important;\n  border-color: #808080 !important;\n  color: white; }\n\n.requireAmount {\n  font-size: 15px !important;\n  margin-top: 12px; }\n\n.commit {\n  margin-top: 12px !important; }\n\n.no-padding-right {\n  padding-right: 0 !important; }\n\n.no-padding-left {\n  padding-left: 0 !important; }\n\n.margin-top-6 {\n  margin-top: 6px !important; }\n\n.margin-top-10 {\n  margin-top: 10px !important; }\n\n.dateRange {\n  width: 15% !important;\n  float: right !important; }\n\n.all-line-height {\n  line-height: 2.3 !important; }\n\n.color-gray {\n  color: gray; }\n\n.margin5 {\n  margin-right: 5px !important;\n  margin-bottom: 5px !important; }\n\n.z-index0 {\n  z-index: 0 !important; }\n\n.pointer {\n  cursor: pointer; }\n\n.color-red {\n  background: #f9e3e2 !important;\n  border: #f9e3e2 !important; }\n\n.color-green {\n  background: #dff5df !important;\n  border: #dff5df !important; }\n\n.dd-z-index {\n  z-index: 999; }\n\n.debit-credit-icon-width {\n  width: 25%; }\n\n.minus-icon-style {\n  font-size: 22px !important;\n  color: #337ab7; }\n\n.bulk-cash-received-amount {\n  word-break: break-all; }\n\n.weekly-history-box {\n  display: inline-block; }\n\n.space-10 {\n  margin-left: 10px !important; }\n\n.denomination-position {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  flex-wrap: wrap;\n  padding-left: 90px !important; }\n\n.remaining-amt-lbl {\n  padding-right: 10px;\n  font-size: 18px;\n  margin-top: 3px; }\n\n.date-ranger-picker-width {\n  width: 28% !important; }\n\n.bulk-cash-denom-dd .multiSelect .checkboxLayer {\n  background-color: #fff;\n  position: absolute;\n  z-index: 999;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  min-width: 278px;\n  display: none !important;\n  text-align: left !important; }\n\n.bulk-cash-denom-dd .multiSelect > button {\n  display: inline-block;\n  position: relative;\n  text-align: center;\n  cursor: pointer;\n  border: 1px solid #c6c6c6;\n  padding: 1px 8px 1px 8px;\n  font-size: 14px;\n  min-height: 38px !important;\n  border-radius: 4px;\n  color: #555;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  white-space: normal;\n  background-color: #fff;\n  background-image: linear-gradient(#fff, #f7f7f7); }\n\n.bulk-cash-denom-dd .multiSelect .show {\n  display: block !important;\n  right: 0 !important; }\n\n.tracking-id-input-height {\n  height: 37px !important; }\n\n.toggle-margin-top-03 {\n  margin-top: 3px; }\n\n.margin-top-19 {\n  margin-top: 19px; }\n\n.denom-error-tooltip-section {\n  margin-left: 5px;\n  margin-top: 7px; }\n\n.start-balance-bg-color {\n  background-color: #fcdcd3; }\n\n.bulk-cash-refresh-icon-section {\n  font-size: 19px;\n  margin-left: 7px; }\n\n.denom-width {\n  width: 25%;\n  margin: 8px 0px; }\n\n.denom-history-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 5px; }\n\n.denom-history-item {\n  width: 48%;\n  min-width: 100px; }\n\n.denom-history-input-group {\n  display: flex !important;\n  width: 100% !important; }\n\n.denom-history-icon {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 40px !important;\n  flex-shrink: 0; }\n\n.denom-history-amount {\n  display: flex !important;\n  align-items: center;\n  justify-content: flex-end;\n  flex-grow: 1 !important;\n  width: auto !important; }\n", ""]);

// exports


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .print-bulk-cash .input-group {\n    display: table !important;\n    width: 100% !important;\n    border-collapse: separate !important; }\n  .print-bulk-cash .input-group-addon,\n  .print-bulk-cash .form-control {\n    display: table-cell !important;\n    vertical-align: middle !important;\n    float: none !important;\n    margin: 0 !important; }\n  .print-bulk-cash .input-group-addon {\n    width: 1% !important;\n    white-space: nowrap !important; }\n  .print-bulk-cash .form-control {\n    width: 100% !important; } }\n\n.print-bulk-cash .font-size-16 {\n  font-size: 17px; }\n\n.print-bulk-cash .balance-amount-wrap {\n  display: inline-block;\n  width: 100%;\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: break-word; }\n\n.print-bulk-cash .history-table-fixed {\n  table-layout: fixed;\n  width: 100%; }\n\n.print-bulk-cash .table-responsive {\n  overflow: visible !important; }\n\n.print-bulk-cash .img-currency {\n  width: 28px !important; }\n", ""]);

// exports


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".margin-right-10 {\n  margin-right: 10px; }\n\n.align-center-vertically {\n  display: flex;\n  display: -ms-flexbox;\n  align-items: center; }\n", ""]);

// exports


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".display-none {\n  display: none; }\n\nbutton > span.error-button-icon {\n  top: 2px;\n  font-size: 15px; }\n\nbutton > span.badge.error-button-badge {\n  padding: 2px 7px !important; }\n\n.margin-right-30 {\n  margin-right: 30px; }\n\n.row.is-flex {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap; }\n\n.row.is-flex > [class*='col-'] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column; }\n\n.padding-left-10 {\n  padding-left: 10px; }\n\n.img-120 {\n  height: 120px;\n  width: 120px; }\n\n.img-80 {\n  height: 80px;\n  width: 80px; }\n\n.fnt-size-25 {\n  font-size: 25px; }\n\n.itemsFontSize {\n  font-size: 22px; }\n\n@media (min-width: 768px) {\n  .fivecolumns .span2 {\n    width: 18.297872340425532%;\n    *width: 18.2234042553191494%;\n    margin-right: 15px; } }\n\n@media (min-width: 1200px) {\n  .fivecolumns .span2 {\n    width: 17.9487179487179488%;\n    *width: 17.87424986361156592%;\n    margin-right: 15px; } }\n\n@media (min-width: 768px) and (max-width: 979px) {\n  .fivecolumns .span2 {\n    width: 17.79005524861878448%;\n    *width: 17.7155871635124022%;\n    margin-right: 15px; } }\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .checkin-overlay-toast {\n    height: 50vh !important; } }\n\n.check-in-destination {\n  max-height: 220px;\n  overflow-y: auto; }\n\n.checkin-item-count {\n  text-decoration: none !important; }\n\n.checkin-refresh-btn-section {\n  display: flex;\n  justify-content: end; }\n\n.checkin-overlay-toast {\n  z-index: 9999;\n  height: 60vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 100%;\n  background: #bdffb26b;\n  border-radius: 5px; }\n\ninput[type=\"text\"].highlight-amount {\n  background-color: #f2dede;\n  color: black; }\n\n.manifest-modal-body {\n  display: flex;\n  justify-content: space-around; }\n\n#shipperSelection .header {\n  height: 31px;\n  padding: 5px 12px; }\n\n#shipperSelection .search {\n  padding: 4px; }\n\n#shipperSelection .dropdownone li {\n  padding: 4px 8px;\n  line-height: 1.2;\n  min-height: 28px; }\n\n#shipperSelection .dropdownTwo {\n  min-height: 220px; }\n\n#shipperSelection .inner-item {\n  max-height: 220px; }\n", ""]);

// exports


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".margin-zero {\n  margin: 0 !important; }\n\n.margin-vertical-5 {\n  margin-top: 5px;\n  margin-bottom: 5px; }\n\n.location-address {\n  margin-top: 5px;\n  margin-bottom: 0px; }\n\n.coin-container {\n  position: relative; }\n  .coin-container .coin-total {\n    position: absolute;\n    bottom: 0px;\n    right: 10px; }\n\n@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .checkin_print .fs-print-12 {\n    font-size: 20px !important; }\n  .checkin_print .fs-print-40 strong, .checkin_print .fs-print-40 {\n    font-size: 28px !important; }\n  .checkin_print .print-page {\n    page-break-after: always;\n    /* Forces the first page to break */ }\n  .checkin_print .second-page {\n    page-break-before: always;\n    /* Ensures the second page starts on a new page */ }\n  .print-margin-top-05 {\n    margin-top: 5px !important; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; } }\n\n.show-only-in-print {\n  display: none; }\n\n@media screen {\n  .no-html {\n    visibility: hidden; } }\n\n.text-align-left {\n  text-align: left; }\n\n.txtSize {\n  font-size: 22px;\n  text-align: right; }\n\n.padding-left-50 {\n  text-align: left;\n  padding-left: 50px; }\n\n.lineColor {\n  opacity: 0.3; }\n\n.margin-bottom-0 {\n  margin-bottom: -0px; }\n\n.content-position {\n  margin-bottom: -0.5px; }\n\n.checkin-verify {\n  margin-top: 100px;\n  width: 96%; }\n\n.checkin-promise {\n  width: 45%;\n  text-align: center;\n  float: left; }\n\n.manifest-content {\n  text-align: right;\n  width: 55%;\n  float: right; }\n\n.errLblPos {\n  margin-top: 5px;\n  width: 47%; }\n\n.margin-top-20 {\n  margin-top: 20px; }\n\n.margin-top-40 {\n  margin-top: 40px; }\n\n.margin-left-10 {\n  margin-left: 10px; }\n\n.print-logo-height-80 {\n  height: 80px; }\n\n.font-size-50 {\n  font-size: 50px; }\n", ""]);

// exports


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".itemsFontSize {\n  font-size: 22px; }\n\n.fnt-size-25 {\n  font-size: 25px; }\n\n@media (min-width: 768px) {\n  .fivecolumns .span2 {\n    width: 19.5%;\n    margin-right: 5px; } }\n\n@media (min-width: 1200px) {\n  .fivecolumns .span2 {\n    width: 19.5%;\n    margin-right: 5px; } }\n\n@media (min-width: 768px) and (max-width: 979px) {\n  .fivecolumns .span2 {\n    width: 19%;\n    margin-right: 5px; } }\n\n.checkout-item-count {\n  text-decoration: none !important; }\n\n.checkout-manifest-btn {\n  margin-left: 30px; }\n\n.font-size-15 {\n  font-size: 15px; }\n\n.route-file-padding {\n  padding-left: 30px !important; }\n\n.btn-margin-top-10 {\n  margin-top: 10px; }\n\n.font-size-22 {\n  font-size: 22px; }\n\n.txt-margin-right-25 {\n  margin-right: 25px; }\n\n.lbl-grey-color {\n  color: #8f8b8b; }\n\n.margin-top-05 {\n  margin-top: 5px !important; }\n\n.checkout-tanker-search-section {\n  width: 96% !important; }\n\n.checkout-scan-section {\n  display: flex;\n  margin-top: 10px; }\n\n.text-padding-05 {\n  padding: 5px; }\n\n.padding-10 {\n  padding: 10px; }\n\n.font-size-100 {\n  font-size: 100px; }\n\n.string-break {\n  word-wrap: break-word; }\n\n.routeDetailConfiguration {\n  width: 200px; }\n\n.truck-field-custom {\n  background-color: blanchedalmond !important;\n  border: 1px solid #fac08c !important;\n  color: #000 !important; }\n", ""]);

// exports


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".margin-zero {\n  margin: 0 !important; }\n\n.margin-vertical-5 {\n  margin-top: 5px;\n  margin-bottom: 5px; }\n\n.location-address {\n  margin-top: 5px;\n  margin-bottom: 0px; }\n\n.coin-container {\n  position: relative; }\n  .coin-container .coin-total {\n    position: absolute;\n    bottom: 0px;\n    right: 10px; }\n\n@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; } }\n\n.show-only-in-print {\n  display: none; }\n\n@media screen {\n  .no-html {\n    visibility: hidden; } }\n\n.text-align-left {\n  text-align: left; }\n\n.txtSize {\n  font-size: 22px;\n  text-align: right; }\n\n.padding-left-50 {\n  text-align: left;\n  padding-left: 50px; }\n\n.lineColor {\n  opacity: 0.3; }\n\n.margin-bottom-0 {\n  margin-bottom: -0px; }\n\n.content-position {\n  margin-bottom: -0.5px; }\n\n.checkout-verify {\n  margin-top: 100px;\n  width: 96%; }\n\n.checkout-promise {\n  width: 45%;\n  text-align: center;\n  float: left; }\n\n.manifest-content {\n  text-align: right;\n  width: 55%;\n  float: right; }\n\n.errLblPos {\n  margin-top: 5px;\n  width: 47%; }\n\n.margin-top-20 {\n  margin-top: 20px; }\n\n.margin-top-40 {\n  margin-top: 40px; }\n\n.margin-left-10 {\n  margin-left: 10px; }\n\n.hold-icon-size {\n  width: 16px !important; }\n", ""]);

// exports


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".branch-coin-pull-report hr.remove-bottom-margin {\n  margin-bottom: 0px !important; }\n\n.branch-coin-pull-report .logo-section {\n  padding-right: 5px;\n  height: 30px; }\n", ""]);

// exports


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".align-end-horizontally {\n  display: flex;\n  display: -ms-flexbox;\n  justify-content: flex-end; }\n\ntd.bordered-cell {\n  border: 1px solid #cecece !important; }\n\ntd.borderless-cell {\n  border: 0px !important; }\n\n.dark-background {\n  background: #eee; }\n", ""]);

// exports


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".region-routing-style-section {\n  /* ================================================================== */\n  /* Toolbar actions menu\n\t/* ================================================================== */\n  /* ================================================================== */\n  /* Draw toolbar\n\t/* ================================================================== */\n  /* ================================================================== */\n  /* Edit toolbar\n\t/* ================================================================== */\n  /* ================================================================== */\n  /* Drawing styles\n\t/* ================================================================== */\n  /* ================================================================== */\n  /* Edit styles\n\t/* ================================================================== */\n  /* ================================================================== */\n  /* Old IE styles\n\t/* ================================================================== */ }\n  .region-routing-style-section .region-routing-toggle {\n    text-align: end;\n    margin-top: 10px; }\n  .region-routing-style-section .leaflet-draw-section {\n    position: relative; }\n  .region-routing-style-section .leaflet-draw-toolbar {\n    margin-top: 12px; }\n  .region-routing-style-section .leaflet-draw-toolbar-top {\n    margin-top: 0; }\n  .region-routing-style-section .leaflet-draw-toolbar-notop a:first-child {\n    border-top-right-radius: 0; }\n  .region-routing-style-section .leaflet-draw-toolbar-nobottom a:last-child {\n    border-bottom-right-radius: 0; }\n  .region-routing-style-section .leaflet-draw-toolbar a {\n    background-image: url(" + __webpack_require__(106) + ");\n    background-image: linear-gradient(transparent, transparent), url(" + __webpack_require__(106) + ");\n    background-repeat: no-repeat;\n    background-size: 300px 30px;\n    background-clip: padding-box; }\n  .region-routing-style-section .leaflet-retina .leaflet-draw-toolbar a {\n    background-image: url(" + __webpack_require__(257) + ");\n    background-image: linear-gradient(transparent, transparent), url(" + __webpack_require__(106) + "); }\n  .region-routing-style-section .leaflet-draw a {\n    display: block;\n    text-align: center;\n    text-decoration: none; }\n  .region-routing-style-section .leaflet-draw a .sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0; }\n  .region-routing-style-section .leaflet-draw-actions {\n    display: none;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    position: absolute;\n    left: 26px;\n    /* leaflet-draw-toolbar.left + leaflet-draw-toolbar.width */\n    top: 0;\n    white-space: nowrap; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-actions {\n    left: 32px; }\n  .region-routing-style-section .leaflet-right .leaflet-draw-actions {\n    right: 26px;\n    left: auto; }\n  .region-routing-style-section .leaflet-touch .leaflet-right .leaflet-draw-actions {\n    right: 32px;\n    left: auto; }\n  .region-routing-style-section .leaflet-draw-actions li {\n    display: inline-block; }\n  .region-routing-style-section .leaflet-draw-actions li:first-child a {\n    border-left: none; }\n  .region-routing-style-section .leaflet-draw-actions li:last-child a {\n    -webkit-border-radius: 0 4px 4px 0;\n    border-radius: 0 4px 4px 0; }\n  .region-routing-style-section .leaflet-right .leaflet-draw-actions li:last-child a {\n    -webkit-border-radius: 0;\n    border-radius: 0; }\n  .region-routing-style-section .leaflet-right .leaflet-draw-actions li:first-child a {\n    -webkit-border-radius: 4px 0 0 4px;\n    border-radius: 4px 0 0 4px; }\n  .region-routing-style-section .leaflet-draw-actions a {\n    background-color: #919187;\n    border-left: 1px solid #AAA;\n    color: #FFF;\n    font: 11px/19px \"Helvetica Neue\", Arial, Helvetica, sans-serif;\n    line-height: 28px;\n    text-decoration: none;\n    padding-left: 10px;\n    padding-right: 10px;\n    height: 28px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-actions a {\n    font-size: 12px;\n    line-height: 30px;\n    height: 30px; }\n  .region-routing-style-section .leaflet-draw-actions-bottom {\n    margin-top: 0; }\n  .region-routing-style-section .leaflet-draw-actions-top {\n    margin-top: 1px; }\n  .region-routing-style-section .leaflet-draw-actions-top a,\n  .region-routing-style-section .leaflet-draw-actions-bottom a {\n    height: 27px;\n    line-height: 27px; }\n  .region-routing-style-section .leaflet-draw-actions a:hover {\n    background-color: #A0A098; }\n  .region-routing-style-section .leaflet-draw-actions-top.leaflet-draw-actions-bottom a {\n    height: 26px;\n    line-height: 26px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-polyline {\n    background-position: -2px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-polyline {\n    background-position: 0 -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-polygon {\n    background-position: -31px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-polygon {\n    background-position: -29px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-rectangle {\n    background-position: -62px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-rectangle {\n    background-position: -60px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-circle {\n    background-position: -92px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-circle {\n    background-position: -90px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-marker {\n    background-position: -122px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-marker {\n    background-position: -120px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-circlemarker {\n    background-position: -273px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-circlemarker {\n    background-position: -271px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-edit-edit {\n    background-position: -152px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-edit {\n    background-position: -150px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-edit-remove {\n    background-position: -182px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-remove {\n    background-position: -180px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-edit-edit.leaflet-disabled {\n    background-position: -212px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-edit.leaflet-disabled {\n    background-position: -210px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-edit-remove.leaflet-disabled {\n    background-position: -242px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-remove.leaflet-disabled {\n    background-position: -240px -2px; }\n  .region-routing-style-section .leaflet-mouse-marker {\n    background-color: #fff;\n    cursor: crosshair; }\n  .region-routing-style-section .leaflet-draw-tooltip {\n    background: #363636;\n    background: rgba(0, 0, 0, 0.5);\n    border: 1px solid transparent;\n    -webkit-border-radius: 4px;\n    border-radius: 4px;\n    color: #fff;\n    font: 12px/18px \"Helvetica Neue\", Arial, Helvetica, sans-serif;\n    margin-left: 20px;\n    margin-top: -21px;\n    padding: 4px 8px;\n    position: absolute;\n    visibility: hidden;\n    white-space: nowrap;\n    z-index: 6; }\n  .region-routing-style-section .leaflet-draw-tooltip:before {\n    border-right: 6px solid black;\n    border-right-color: rgba(0, 0, 0, 0.5);\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    content: \"\";\n    position: absolute;\n    top: 7px;\n    left: -7px; }\n  .region-routing-style-section .leaflet-error-draw-tooltip {\n    background-color: #F2DEDE;\n    border: 1px solid #E6B6BD;\n    color: #B94A48; }\n  .region-routing-style-section .leaflet-error-draw-tooltip:before {\n    border-right-color: #E6B6BD; }\n  .region-routing-style-section .leaflet-draw-tooltip-single {\n    margin-top: -12px; }\n  .region-routing-style-section .leaflet-draw-tooltip-subtext {\n    color: #f8d5e4; }\n  .region-routing-style-section .leaflet-draw-guide-dash {\n    font-size: 1%;\n    opacity: 0.6;\n    position: absolute;\n    width: 5px;\n    height: 5px; }\n  .region-routing-style-section .leaflet-edit-marker-selected {\n    background-color: rgba(254, 87, 161, 0.1);\n    border: 4px dashed rgba(254, 87, 161, 0.6);\n    -webkit-border-radius: 4px;\n    border-radius: 4px;\n    box-sizing: content-box; }\n  .region-routing-style-section .leaflet-edit-move {\n    cursor: move; }\n  .region-routing-style-section .leaflet-edit-resize {\n    cursor: pointer; }\n  .region-routing-style-section .leaflet-oldie .leaflet-draw-toolbar {\n    border: 1px solid #999; }\n  .region-routing-style-section .pagination {\n    display: block !important; }\n", ""]);

// exports


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".region-routing-style-section {\n  /* ================================================================== */\n  /* Toolbar actions menu\n\t/* ================================================================== */\n  /* ================================================================== */\n  /* Draw toolbar\n\t/* ================================================================== */\n  /* ================================================================== */\n  /* Edit toolbar\n\t/* ================================================================== */\n  /* ================================================================== */\n  /* Drawing styles\n\t/* ================================================================== */\n  /* ================================================================== */\n  /* Edit styles\n\t/* ================================================================== */\n  /* ================================================================== */\n  /* Old IE styles\n\t/* ================================================================== */ }\n  .region-routing-style-section .region-routing-toggle {\n    text-align: end;\n    margin-top: 10px; }\n  .region-routing-style-section .leaflet-draw-section {\n    position: relative; }\n  .region-routing-style-section .leaflet-draw-toolbar {\n    margin-top: 12px; }\n  .region-routing-style-section .leaflet-draw-toolbar-top {\n    margin-top: 0; }\n  .region-routing-style-section .leaflet-draw-toolbar-notop a:first-child {\n    border-top-right-radius: 0; }\n  .region-routing-style-section .leaflet-draw-toolbar-nobottom a:last-child {\n    border-bottom-right-radius: 0; }\n  .region-routing-style-section .leaflet-draw-toolbar a {\n    background-image: url(" + __webpack_require__(106) + ");\n    background-image: linear-gradient(transparent, transparent), url(" + __webpack_require__(106) + ");\n    background-repeat: no-repeat;\n    background-size: 300px 30px;\n    background-clip: padding-box; }\n  .region-routing-style-section .leaflet-retina .leaflet-draw-toolbar a {\n    background-image: url(" + __webpack_require__(257) + ");\n    background-image: linear-gradient(transparent, transparent), url(" + __webpack_require__(106) + "); }\n  .region-routing-style-section .leaflet-draw a {\n    display: block;\n    text-align: center;\n    text-decoration: none; }\n  .region-routing-style-section .leaflet-draw a .sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0; }\n  .region-routing-style-section .leaflet-draw-actions {\n    display: none;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    position: absolute;\n    left: 26px;\n    /* leaflet-draw-toolbar.left + leaflet-draw-toolbar.width */\n    top: 0;\n    white-space: nowrap; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-actions {\n    left: 32px; }\n  .region-routing-style-section .leaflet-right .leaflet-draw-actions {\n    right: 26px;\n    left: auto; }\n  .region-routing-style-section .leaflet-touch .leaflet-right .leaflet-draw-actions {\n    right: 32px;\n    left: auto; }\n  .region-routing-style-section .leaflet-draw-actions li {\n    display: inline-block; }\n  .region-routing-style-section .leaflet-draw-actions li:first-child a {\n    border-left: none; }\n  .region-routing-style-section .leaflet-draw-actions li:last-child a {\n    -webkit-border-radius: 0 4px 4px 0;\n    border-radius: 0 4px 4px 0; }\n  .region-routing-style-section .leaflet-right .leaflet-draw-actions li:last-child a {\n    -webkit-border-radius: 0;\n    border-radius: 0; }\n  .region-routing-style-section .leaflet-right .leaflet-draw-actions li:first-child a {\n    -webkit-border-radius: 4px 0 0 4px;\n    border-radius: 4px 0 0 4px; }\n  .region-routing-style-section .leaflet-draw-actions a {\n    background-color: #919187;\n    border-left: 1px solid #AAA;\n    color: #FFF;\n    font: 11px/19px \"Helvetica Neue\", Arial, Helvetica, sans-serif;\n    line-height: 28px;\n    text-decoration: none;\n    padding-left: 10px;\n    padding-right: 10px;\n    height: 28px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-actions a {\n    font-size: 12px;\n    line-height: 30px;\n    height: 30px; }\n  .region-routing-style-section .leaflet-draw-actions-bottom {\n    margin-top: 0; }\n  .region-routing-style-section .leaflet-draw-actions-top {\n    margin-top: 1px; }\n  .region-routing-style-section .leaflet-draw-actions-top a,\n  .region-routing-style-section .leaflet-draw-actions-bottom a {\n    height: 27px;\n    line-height: 27px; }\n  .region-routing-style-section .leaflet-draw-actions a:hover {\n    background-color: #A0A098; }\n  .region-routing-style-section .leaflet-draw-actions-top.leaflet-draw-actions-bottom a {\n    height: 26px;\n    line-height: 26px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-polyline {\n    background-position: -2px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-polyline {\n    background-position: 0 -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-polygon {\n    background-position: -31px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-polygon {\n    background-position: -29px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-rectangle {\n    background-position: -62px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-rectangle {\n    background-position: -60px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-circle {\n    background-position: -92px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-circle {\n    background-position: -90px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-marker {\n    background-position: -122px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-marker {\n    background-position: -120px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-draw-circlemarker {\n    background-position: -273px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-circlemarker {\n    background-position: -271px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-edit-edit {\n    background-position: -152px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-edit {\n    background-position: -150px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-edit-remove {\n    background-position: -182px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-remove {\n    background-position: -180px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-edit-edit.leaflet-disabled {\n    background-position: -212px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-edit.leaflet-disabled {\n    background-position: -210px -1px; }\n  .region-routing-style-section .leaflet-draw-toolbar .leaflet-draw-edit-remove.leaflet-disabled {\n    background-position: -242px -2px; }\n  .region-routing-style-section .leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-remove.leaflet-disabled {\n    background-position: -240px -2px; }\n  .region-routing-style-section .leaflet-mouse-marker {\n    background-color: #fff;\n    cursor: crosshair; }\n  .region-routing-style-section .leaflet-draw-tooltip {\n    background: #363636;\n    background: rgba(0, 0, 0, 0.5);\n    border: 1px solid transparent;\n    -webkit-border-radius: 4px;\n    border-radius: 4px;\n    color: #fff;\n    font: 12px/18px \"Helvetica Neue\", Arial, Helvetica, sans-serif;\n    margin-left: 20px;\n    margin-top: -21px;\n    padding: 4px 8px;\n    position: absolute;\n    visibility: hidden;\n    white-space: nowrap;\n    z-index: 6; }\n  .region-routing-style-section .leaflet-draw-tooltip:before {\n    border-right: 6px solid black;\n    border-right-color: rgba(0, 0, 0, 0.5);\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    content: \"\";\n    position: absolute;\n    top: 7px;\n    left: -7px; }\n  .region-routing-style-section .leaflet-error-draw-tooltip {\n    background-color: #F2DEDE;\n    border: 1px solid #E6B6BD;\n    color: #B94A48; }\n  .region-routing-style-section .leaflet-error-draw-tooltip:before {\n    border-right-color: #E6B6BD; }\n  .region-routing-style-section .leaflet-draw-tooltip-single {\n    margin-top: -12px; }\n  .region-routing-style-section .leaflet-draw-tooltip-subtext {\n    color: #f8d5e4; }\n  .region-routing-style-section .leaflet-draw-guide-dash {\n    font-size: 1%;\n    opacity: 0.6;\n    position: absolute;\n    width: 5px;\n    height: 5px; }\n  .region-routing-style-section .leaflet-edit-marker-selected {\n    background-color: rgba(254, 87, 161, 0.1);\n    border: 4px dashed rgba(254, 87, 161, 0.6);\n    -webkit-border-radius: 4px;\n    border-radius: 4px;\n    box-sizing: content-box; }\n  .region-routing-style-section .leaflet-edit-move {\n    cursor: move; }\n  .region-routing-style-section .leaflet-edit-resize {\n    cursor: pointer; }\n  .region-routing-style-section .leaflet-oldie .leaflet-draw-toolbar {\n    border: 1px solid #999; }\n  .region-routing-style-section .pagination {\n    display: block !important; }\n  .region-routing-style-section .location-zone-alert-section .alert {\n    padding: 10px !important; }\n  .region-routing-style-section .day-of-the-week-section .btn {\n    padding: 6px 3px !important; }\n  .region-routing-style-section .zone-header-title {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    min-height: 30px; }\n  .region-routing-style-section .zone-rule-action {\n    text-align: center;\n    padding-top: 2px; }\n    .region-routing-style-section .zone-rule-action .btn {\n      font-size: 14px; }\n    .region-routing-style-section .zone-rule-action .btn .badge {\n      margin-left: 4px; }\n  .region-routing-style-section .zone-rule-assignment-section {\n    padding: 10px;\n    border-bottom: 0;\n    background: #fff; }\n  .region-routing-style-section .zone-rule-rows-scroll {\n    max-height: 560px;\n    overflow-y: auto;\n    overflow-x: hidden; }\n    .region-routing-style-section .zone-rule-rows-scroll.zone-rule-rows-scroll-editing {\n      padding-bottom: 270px; }\n  .region-routing-style-section .zone-rule-load-more-sentinel {\n    height: 1px; }\n  .region-routing-style-section .zone-rule-assignment-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 10px 12px;\n    border: 1px solid #bebebe;\n    background: #fff;\n    margin-bottom: 10px;\n    cursor: move; }\n  .region-routing-style-section .zone-rule-fields select,\n  .region-routing-style-section .zone-rule-fields .searchandselect .header,\n  .region-routing-style-section .zone-rule-fields .multi-select {\n    cursor: pointer; }\n  .region-routing-style-section .zone-rule-assignment-row:last-child {\n    margin-bottom: 0; }\n  .region-routing-style-section .zone-rule-priority {\n    width: 28px;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 26px;\n    text-align: center;\n    color: #222; }\n  .region-routing-style-section .zone-rule-drag-handle {\n    width: 18px;\n    padding-top: 4px;\n    color: #777;\n    cursor: move;\n    text-align: center;\n    line-height: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .region-routing-style-section .zone-rule-fields {\n    display: grid;\n    grid-template-columns: minmax(220px, 1.4fr) repeat(3, minmax(140px, 1fr));\n    gap: 8px 10px;\n    flex: 1; }\n  .region-routing-style-section .zone-rule-field {\n    min-width: 0; }\n    .region-routing-style-section .zone-rule-field.disabled button#zone-makes-select,\n    .region-routing-style-section .zone-rule-field.disabled button#zone-actions-select,\n    .region-routing-style-section .zone-rule-field.disabled button#zone-customers-select,\n    .region-routing-style-section .zone-rule-field.disabled button#zone-action-priorities-select {\n      background-color: #eee !important;\n      background-image: none !important;\n      border-color: #ccc !important;\n      cursor: not-allowed !important;\n      opacity: 1 !important;\n      color: #777 !important; }\n    .region-routing-style-section .zone-rule-field.has-error-select .searchandselect {\n      border-color: #a94442 !important;\n      background-color: #f2dede !important; }\n      .region-routing-style-section .zone-rule-field.has-error-select .searchandselect .header {\n        background-color: #f2dede !important;\n        border-color: #a94442 !important; }\n    .region-routing-style-section .zone-rule-field .ui-select-container {\n      width: 100% !important; }\n      .region-routing-style-section .zone-rule-field .ui-select-container .ui-select-match {\n        outline: none !important; }\n      .region-routing-style-section .zone-rule-field .ui-select-container .ui-select-toggle {\n        height: 30px;\n        padding: 4px 10px;\n        font-size: 12px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        background-color: #fff;\n        border-color: #ccc;\n        border-radius: 4px; }\n        .region-routing-style-section .zone-rule-field .ui-select-container .ui-select-toggle:disabled, .region-routing-style-section .zone-rule-field .ui-select-container .ui-select-toggle.disabled {\n          background-color: #eee !important;\n          cursor: not-allowed; }\n      .region-routing-style-section .zone-rule-field .ui-select-container .ui-select-match-text {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        width: 100%;\n        display: block;\n        text-align: left;\n        padding-right: 12px; }\n      .region-routing-style-section .zone-rule-field .ui-select-container .ui-select-placeholder {\n        color: #999; }\n      .region-routing-style-section .zone-rule-field .ui-select-container .btn-default.active {\n        box-shadow: none; }\n      .region-routing-style-section .zone-rule-field .ui-select-container .ui-select-choices {\n        font-size: 12px;\n        min-width: 250px; }\n      .region-routing-style-section .zone-rule-field .ui-select-container .ui-select-search {\n        height: 30px;\n        font-size: 12px; }\n    .region-routing-style-section .zone-rule-field .form-control {\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden; }\n      .region-routing-style-section .zone-rule-field .form-control:disabled {\n        background-color: #eee !important;\n        cursor: not-allowed; }\n    .region-routing-style-section .zone-rule-field .searchandselect {\n      height: 30px;\n      font-size: 12px;\n      border-color: #ccc; }\n      .region-routing-style-section .zone-rule-field .searchandselect .header {\n        height: 28px;\n        padding: 4px 10px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between; }\n        .region-routing-style-section .zone-rule-field .searchandselect .header.selected-text-width {\n          width: 100% !important; }\n        .region-routing-style-section .zone-rule-field .searchandselect .header .caption {\n          line-height: 20px;\n          position: static;\n          margin: 0; }\n        .region-routing-style-section .zone-rule-field .searchandselect .header i.caret {\n          position: static;\n          margin: 0; }\n      .region-routing-style-section .zone-rule-field .searchandselect.disabled-state {\n        background-color: #eee !important;\n        cursor: not-allowed;\n        border-color: #ccc; }\n      .region-routing-style-section .zone-rule-field .searchandselect .dropdownone {\n        font-size: 12px;\n        z-index: 1070;\n        top: 100%;\n        bottom: auto;\n        margin-top: 2px;\n        margin-bottom: 0; }\n        .region-routing-style-section .zone-rule-field .searchandselect .dropdownone li {\n          padding: 6px 10px;\n          line-height: 1.2;\n          min-height: 28px; }\n        .region-routing-style-section .zone-rule-field .searchandselect .dropdownone .inner-item {\n          max-height: 220px; }\n        .region-routing-style-section .zone-rule-field .searchandselect .dropdownone .search {\n          padding: 5px; }\n          .region-routing-style-section .zone-rule-field .searchandselect .dropdownone .search input {\n            height: 28px;\n            font-size: 12px; }\n    .region-routing-style-section .zone-rule-field .multi-select .multiSelect {\n      display: block !important;\n      width: 100% !important;\n      position: relative; }\n      .region-routing-style-section .zone-rule-field .multi-select .multiSelect > button {\n        position: relative;\n        height: 30px !important;\n        min-height: 30px !important;\n        max-height: 30px !important;\n        padding: 4px 24px 4px 10px !important;\n        font-size: 12px !important;\n        line-height: 20px !important;\n        background-color: #DFF5DF !important;\n        background-image: none !important;\n        border: 1px solid #BEEBBE !important;\n        border-radius: 4px !important;\n        width: 100% !important;\n        text-align: left !important;\n        box-shadow: none !important;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        color: #555; }\n        .region-routing-style-section .zone-rule-field .multi-select .multiSelect > button:disabled {\n          background-color: #eee !important;\n          cursor: not-allowed;\n          opacity: 1;\n          color: #777; }\n        .region-routing-style-section .zone-rule-field .multi-select .multiSelect > button .buttonLabel {\n          padding: 0 !important;\n          line-height: 20px !important;\n          vertical-align: top; }\n        .region-routing-style-section .zone-rule-field .multi-select .multiSelect > button .caret {\n          position: absolute !important;\n          right: 10px !important;\n          top: 50% !important;\n          margin: -2px 0 0 0 !important; }\n      .region-routing-style-section .zone-rule-field .multi-select .multiSelect .checkboxLayer {\n        z-index: 1070;\n        min-width: 200px;\n        font-size: 12px;\n        top: 100% !important;\n        bottom: auto !important;\n        margin-top: 4px !important;\n        margin-bottom: 0 !important;\n        left: auto !important;\n        right: 0 !important; }\n        .region-routing-style-section .zone-rule-field .multi-select .multiSelect .checkboxLayer .helperContainer {\n          padding: 4px 6px; }\n        .region-routing-style-section .zone-rule-field .multi-select .multiSelect .checkboxLayer .checkBoxContainer {\n          max-height: 200px;\n          overflow-y: auto;\n          overflow-x: hidden;\n          padding: 4px 0; }\n        .region-routing-style-section .zone-rule-field .multi-select .multiSelect .checkboxLayer .inputFilter {\n          height: 28px !important;\n          font-size: 12px !important;\n          padding: 4px 8px !important; }\n        .region-routing-style-section .zone-rule-field .multi-select .multiSelect .checkboxLayer .multiSelectItem {\n          font-size: 12px;\n          padding: 5px 10px; }\n        .region-routing-style-section .zone-rule-field .multi-select .multiSelect .checkboxLayer .helperButton {\n          font-size: 11px;\n          height: 26px;\n          padding: 3px 6px;\n          line-height: 20px; }\n  .region-routing-style-section .zone-rule-display-value {\n    min-height: 30px;\n    padding: 4px 10px;\n    border: 1px solid #d9d9d9;\n    border-radius: 4px;\n    background: #fafafa;\n    font-size: 13px;\n    line-height: 20px;\n    word-break: break-word; }\n  .region-routing-style-section .zone-rule-field-assignee {\n    grid-column: 1; }\n  .region-routing-style-section .zone-rule-field-offset {\n    visibility: hidden;\n    pointer-events: none; }\n  .region-routing-style-section .zone-rule-row-actions {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    padding-top: 1px; }\n  .region-routing-style-section .zone-rule-row-actions .btn {\n    min-width: 24px;\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    line-height: 22px;\n    font-weight: 700;\n    border-radius: 4px; }\n  .region-routing-style-section .zone-rule-assignment-section .zone-rule-row-actions .btn-default {\n    line-height: 20px; }\n  .region-routing-style-section .zone-rule-modal-backdrop {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.45);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    z-index: 1050; }\n  .region-routing-style-section .zone-rule-modal {\n    width: 100%;\n    max-width: 1400px;\n    max-height: calc(100vh - 40px);\n    background: #fff;\n    border-radius: 4px;\n    overflow: hidden;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    z-index: 1060; }\n  .region-routing-style-section .zone-rule-modal-header,\n  .region-routing-style-section .zone-rule-modal-footer {\n    padding: 15px 20px;\n    border-bottom: 1px solid #e5e5e5; }\n  .region-routing-style-section .zone-rule-modal-footer {\n    border-top: 1px solid #e5e5e5;\n    border-bottom: 0;\n    text-align: right; }\n  .region-routing-style-section .zone-rule-modal-title {\n    margin: 0;\n    display: inline-block; }\n  .region-routing-style-section .zone-rule-modal-body {\n    padding: 20px;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: visible;\n    position: relative;\n    z-index: 1; }\n  .region-routing-style-section .zone-rule-assignment-row,\n  .region-routing-style-section .zone-rule-fields,\n  .region-routing-style-section .zone-rule-field {\n    overflow: visible; }\n  .region-routing-style-section .zone-rule-field .ui-select-container,\n  .region-routing-style-section .zone-rule-field .ui-select-bootstrap,\n  .region-routing-style-section .zone-rule-field .ui-select-match {\n    position: relative;\n    z-index: 2; }\n  .region-routing-style-section .zone-rule-field .ui-select-choices,\n  .region-routing-style-section .zone-rule-field .ui-select-bootstrap > .ui-select-choices {\n    z-index: 1070; }\n  .region-routing-style-section .zone-rule-modal-body .form-control.input-sm {\n    font-size: 12px;\n    height: 30px;\n    line-height: 1.42857143; }\n    .region-routing-style-section .zone-rule-modal-body .form-control.input-sm.ng-valid {\n      background-color: #DFF5DF;\n      border-color: #BEEBBE; }\n  .region-routing-style-section .zone-rule-modal-zone {\n    margin-bottom: 15px;\n    font-size: 14px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center; }\n  .region-routing-style-section .modal-row {\n    background: #fff;\n    cursor: move; }\n  .region-routing-style-section .zone-rule-row-dragging {\n    opacity: 0.65; }\n  .region-routing-style-section .zone-rule-row-drop-target {\n    border-color: #337ab7;\n    box-shadow: inset 0 0 0 1px #337ab7; }\n  .region-routing-style-section .zone-rule-row-drag-disabled {\n    cursor: not-allowed; }\n  @media (max-width: 991px) {\n    .region-routing-style-section .zone-rule-action {\n      margin-bottom: 8px; }\n    .region-routing-style-section .zone-rule-assignment-row {\n      flex-direction: column; }\n    .region-routing-style-section .zone-rule-priority {\n      width: auto;\n      text-align: left;\n      line-height: 1; }\n    .region-routing-style-section .zone-rule-drag-handle {\n      width: auto;\n      padding-top: 0; }\n    .region-routing-style-section .zone-rule-fields {\n      grid-template-columns: repeat(2, minmax(140px, 1fr)); }\n    .region-routing-style-section .zone-rule-field-assignee,\n    .region-routing-style-section .zone-rule-field-offset {\n      grid-column: auto; }\n    .region-routing-style-section .zone-rule-row-actions {\n      flex-direction: row; } }\n  @media (max-width: 575px) {\n    .region-routing-style-section .zone-rule-fields {\n      grid-template-columns: 1fr; } }\n  .region-routing-style-section button#zone-makes-select,\n  .region-routing-style-section button#zone-actions-select {\n    background: #DFF5DF !important;\n    background-image: none !important;\n    border: 1px solid #BEEBBE !important;\n    height: 30px !important;\n    min-height: 30px !important;\n    max-height: 30px !important;\n    padding: 0 10px !important;\n    font-size: 12px !important;\n    text-align: left !important;\n    display: flex !important;\n    align-items: center !important;\n    width: 100% !important;\n    box-shadow: none !important;\n    overflow: hidden;\n    white-space: nowrap;\n    color: #555;\n    border-radius: 4px !important; }\n    .region-routing-style-section button#zone-makes-select:disabled, .region-routing-style-section button#zone-makes-select.disabled,\n    .region-routing-style-section button#zone-actions-select:disabled,\n    .region-routing-style-section button#zone-actions-select.disabled {\n      background-color: #eee !important;\n      background-image: none !important;\n      border-color: #ccc !important;\n      cursor: not-allowed !important;\n      opacity: 1 !important;\n      color: #777 !important; }\n  .region-routing-style-section button#zone-makes-select .buttonLabel,\n  .region-routing-style-section button#zone-actions-select .buttonLabel {\n    padding: 0 !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n    min-width: 0; }\n", ""]);

// exports


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n.margin-top-40 {\n  margin-top: 40px; }\n\n.margin-top-20-imp {\n  margin-top: 20px !important; }\n\n.margin-top-10-imp {\n  margin-top: 10px !important; }\n\n.btn-atm-deposit {\n  position: absolute;\n  right: 24px;\n  top: 8px; }\n\n.col-width-20 {\n  width: 20%; }\n\n.denomination-input-box {\n  padding: 3px !important;\n  display: flex !important;\n  width: 30% !important;\n  margin-right: 1%; }\n\n.add-denom-btn {\n  margin-top: 12px !important; }\n\n.denom-btn {\n  margin-left: 5px !important; }\n\n.col-width-10 {\n  width: 10%; }\n\n.margin-right-15 {\n  margin-right: 15px !important;\n  margin-bottom: 5px !important; }\n\n.invalid-amount {\n  background: #f9e3e2 !important;\n  border-color: #F4C6C6 !important; }\n\n.valid-amount {\n  background: #dff5df !important; }\n\n.form-deposit-pack-offset {\n  margin: auto;\n  width: 35%; }\n\n.remove-bottom-margin-5 {\n  margin-bottom: -5px; }\n\ndiv.col-sm-8 .disabled input {\n  background-color: lightgray; }\n\n.load-date-lbl {\n  font-size: larger;\n  font-weight: 900; }\n\n.deposit-limit-warning {\n  color: red;\n  float: left;\n  top: auto !important;\n  left: -10px;\n  position: absolute !important;\n  margin-top: 8px; }\n\n.carrier-bg-color-grey {\n  background-color: #eeeeee; }\n\n.amount-font-23 {\n  font-size: 23px; }\n\n.amount-margin-top-1 {\n  margin-top: 1px; }\n\n.common-width-15 {\n  width: 15%; }\n\n.denom-box-width {\n  width: 150px !important; }\n\ntbody.collapse.in {\n  display: table-row-group; }\n\n.common-width-35 {\n  width: 35% !important; }\n\n.table-pad-5 td {\n  padding: 5px !important; }\n\n.margin-top-25 {\n  margin-top: 25px !important; }\n\n.actions-width-20 {\n  width: 20%; }\n\n.emergency-denom-box {\n  background-color: red;\n  display: inline-block;\n  width: 100px;\n  height: 100px; }\n\n.w-18 {\n  width: auto;\n  min-width: 12%;\n  display: inline-block;\n  margin: 5px;\n  text-align: center;\n  /* margin: auto; */\n  vertical-align: middle;\n  min-height: 130px;\n  padding: 7px; }\n\n.deposit_packing_data_box {\n  margin: auto;\n  text-align: center; }\n\n.deposit_packing_data_box .input-group {\n  position: relative;\n  display: table;\n  border-collapse: separate;\n  width: 100% !important; }\n\n.deposit_packing_data_box .denom-icon-size {\n  width: 35px; }\n\n.denom-amount-font-size {\n  font-size: 20px; }\n\n.deposit-pack-btn-gap {\n  margin-left: 5px !important; }\n\n.v-align-top {\n  vertical-align: top !important; }\n\n.cursor-pointer {\n  cursor: pointer; }\n\n.pending-residual-records tbody.scroll-content {\n  display: block;\n  max-height: 380px;\n  overflow-y: auto; }\n\n.pending-residual-records tbody.scroll-content::-webkit-scrollbar-button {\n  display: none; }\n\n.pending-residual-records tbody.scroll-content::-webkit-scrollbar-track-piece {\n  background: #eee; }\n\n.pending-residual-records tbody.scroll-content::-webkit-scrollbar-thumb {\n  background: #ccc; }\n\n.pending-residual-records ​\ntbody.scroll-content:hover::-webkit-scrollbar-thumb {\n  background: #888; }\n\n.pending-residual-records ​\nthead, .pending-residual-records tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed; }\n\n.residual-lbl-width {\n  width: 20.1%; }\n\n.w-52p {\n  width: 52px; }\n\n.datepicker-center-section {\n  width: 25%;\n  text-align: center;\n  display: flex;\n  margin: auto; }\n\n.datepicker-top-margin {\n  top: 1rem; }\n\n.pack-msg {\n  margin-top: 10px;\n  padding-left: 0px !important; }\n\n.deposit-denom-dd .multiSelect .checkboxLayer {\n  background-color: #fff;\n  position: absolute;\n  z-index: 999;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  min-width: 278px;\n  display: none !important;\n  text-align: left !important;\n  max-height: 400px;\n  overflow-y: auto; }\n\n.deposit-denom-dd .multiSelect > button {\n  display: inline-block;\n  position: relative;\n  text-align: center;\n  cursor: pointer;\n  border: 1px solid #c6c6c6;\n  padding: 1px 8px 1px 8px;\n  font-size: 14px;\n  min-height: 38px !important;\n  border-radius: 4px;\n  color: #555;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  white-space: normal;\n  background-color: #fff;\n  background-image: linear-gradient(#fff, #f7f7f7); }\n\n.deposit-denom-dd .multiSelect .show {\n  display: block !important;\n  left: 17%; }\n\n.denomination-box-width {\n  padding: 4px !important;\n  width: 14% !important; }\n\n.add-btn-margin-7 {\n  margin-top: 7px; }\n\n.deposit-center-date {\n  display: flex;\n  justify-content: center;\n  width: 100%; }\n\n@media (min-width: 767px) and (max-width: 1024px) {\n  .residual-lbl-width {\n    width: auto !important; }\n  .w-52p {\n    width: 52px; }\n  .deposit-denom-dd .multiSelect .show {\n    display: block !important;\n    left: -16% !important; } }\n\n.deposit-packing-btn-group-section {\n  display: flex !important; }\n\n.deposit-pack-date-picker .datetimepicker-wrapper {\n  display: block !important; }\n\n.delivery-location-search .dropdownone {\n  padding-bottom: 10px; }\n\n.duplicate-tracking-id {\n  background-color: #F9E3E3 !important;\n  border-color: #F4C6C6 !important; }\n", ""]);

// exports


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; } }\n\n.show-only-in-print {\n  display: none; }\n\n@media screen {\n  .no-html {\n    visibility: hidden; } }\n\n.deposit-date-align {\n  text-align: left; }\n\n.deposit-text-align-left {\n  text-align: left; }\n\n.data-font-size {\n  font-size: 22px; }\n\n.deposit-content {\n  text-align: left;\n  padding-left: 50px; }\n\n.lineColor {\n  opacity: 0.3; }\n\n.full-name {\n  margin-bottom: 0px; }\n\n.lable-position {\n  margin-bottom: -0.5px; }\n\n.main-div {\n  margin-top: 100px;\n  width: 96%; }\n\n.deposit-authorization {\n  width: 45%;\n  text-align: center;\n  float: left; }\n\n.deposit-context {\n  text-align: right;\n  width: 55%;\n  float: right; }\n\n.deposit-authorization-date {\n  margin-left: 10px; }\n\n.authorization-context {\n  margin-top: 123px; }\n", ""]);

// exports


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".forgot-form-ui .page-title {\n  text-align: center;\n  padding: 15px 0px 0 0px;\n  font-weight: 800;\n  font-size: 20px; }\n\n.forgot-form-ui .forgot_form {\n  width: 400px;\n  margin: auto;\n  padding-top: 1rem; }\n", ""]);

// exports


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".multi-select span.multiSelect button#multi-select-button {\n  width: 100%;\n  text-align: left;\n  min-height: 34px !important; }\n  .multi-select span.multiSelect button#multi-select-button span.caret {\n    position: absolute;\n    right: 10px;\n    top: 15px; }\n\n.multi-select.disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n  pointer-events: none; }\n\n.invalid-multi-select-value button#multi-select-button {\n  background: #F9E3E3;\n  border: 1px solid #F4C6C6; }\n\n.valid-multi-select-value button#multi-select-button {\n  background: #DFF5DF;\n  border-color: #BEEBBE; }\n", ""]);

// exports


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".card {\n  font-family: verdana;\n  background: #fff;\n  border-radius: 5px;\n  display: inline-block;\n  margin: 1rem;\n  position: relative;\n  display: block;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24);\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  border: 1px solid rgba(0, 40, 100, 0.12);\n  margin-left: -5px;\n  margin-right: -5px; }\n\n.card:hover {\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25), 0 2px 3px rgba(0, 0, 0, 0.22); }\n\n.card-body {\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  margin: 0;\n  padding: 1.5rem 1.5rem;\n  position: relative; }\n\n.text-center {\n  text-align: center !important; }\n\n.p-3 {\n  padding: 0.75rem !important; }\n\n.m-0 {\n  margin: 0 !important; }\n\n.text-muted {\n  color: #9aa0ac !important; }\n\n.mb-4 {\n  margin-top: 5px;\n  font-size: 15px;\n  font-family: verdana !important; }\n\n.card-body .h1 {\n  font-size: 30px;\n  font-family: verdana !important; }\n\n.text-right {\n  text-align: right !important; }\n\n.entry-type {\n  margin: 20px 10px 10px 0; }\n\n.recent-activity-block {\n  margin: 10px; }\n\n.cursor-pointer {\n  cursor: pointer; }\n\n.table-wrap {\n  max-height: 180px;\n  overflow-y: auto; }\n\n.panel-box {\n  border: 1px solid #ddd;\n  border-radius: 4px; }\n\n.panel-box .panel {\n  border: none; }\n\n.panel-default > .panel-heading.cust-panel-color {\n  background-color: #ffffff;\n  border: none; }\n\n.cust-panel-color .panel-title {\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 400; }\n\n.panel-title a:hover, a:focus {\n  text-decoration: none;\n  outline: none;\n  outline-offset: 0; }\n\n.dashboard-grp-btn {\n  margin-top: 20px;\n  margin-bottom: 10px; }\n\n.dashboard-title {\n  display: inline-flex; }\n\n.dashboard-title .btn-group {\n  margin-left: 10px; }\n\n.badge-right {\n  float: right; }\n\n.card-body .badge-success {\n  color: #28a745; }\n\n.card-body .badge-danger {\n  color: #dc3545; }\n\n.day-badge.row {\n  margin: 0; }\n\n.day-badge.card-body {\n  padding: 5px 10px 0; }\n\n.m-0 .glyphicon {\n  font-size: 12px; }\n\n.calenderIcon {\n  font-size: 22px !important;\n  color: #337ab7;\n  cursor: pointer; }\n\n.div-calender {\n  margin-top: 6px !important;\n  margin-left: 6px !important; }\n\n.remove-top-margin {\n  margin-top: 0px !important; }\n\n.no-padding {\n  padding: 0; }\n\n.remove-tbl-padding {\n  padding: 0 !important;\n  margin: 0 !important; }\n\n.remove-left-padding {\n  padding-left: 0px !important; }\n\n.remove-right-padding {\n  padding-right: 0px !important; }\n\n.margin-left-right--10px {\n  margin-left: -10px;\n  margin-right: -10px; }\n\n@media (min-width: 320px) and (max-width: 768px) {\n  .home-date-state-section h3 {\n    font-size: 19px !important; }\n  h3 {\n    font-size: 19px !important; } }\n", ""]);

// exports


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".items-list-view-section .deleted {\n  color: #d9534f; }\n\n.items-list-view-section .available {\n  color: green; }\n\n.items-list-view-section .lost {\n  color: red; }\n\n.items-list-view-section .checked-out {\n  color: slategrey; }\n\n.items-list-view-section .hold {\n  color: darkorange; }\n\n.items-list-view-section .filter-section {\n  display: flex;\n  justify-content: end;\n  gap: 15px; }\n  .items-list-view-section .filter-section .input-lg,\n  .items-list-view-section .filter-section .input-group-lg > .form-control,\n  .items-list-view-section .filter-section .input-group-lg > .input-group-addon,\n  .items-list-view-section .filter-section .input-group-lg > .input-group-btn > .btn {\n    height: 39px;\n    padding: 9px 16px;\n    font-size: 18px;\n    line-height: 1;\n    border-radius: 6px; }\n\n.items-list-view-section .search-box-width {\n  width: 83%;\n  margin-top: 3px; }\n\n.items-list-view-section .status-count-section .btn-lg,\n.items-list-view-section .status-count-section .btn-group-lg > .btn {\n  padding: 8px 16px;\n  font-size: 16px;\n  line-height: 1.33333;\n  border-radius: 6px; }\n\n.items-list-view-section .logistic-item-line-section {\n  margin-top: 10px !important;\n  margin-bottom: 0px !important; }\n\n.items-list-view-section .available-item-badge {\n  background-color: #70ad47 !important;\n  font-size: 13px !important; }\n\n.items-list-view-section .assigned-item-badge {\n  background-color: cadetblue !important;\n  color: #fff !important; }\n\n.items-list-view-section .checked-out-item-badge {\n  background-color: darkgrey !important;\n  color: #fff !important; }\n\n.items-list-view-section .hold-item-badge {\n  background-color: #eea236 !important;\n  color: #fff !important; }\n\n.items-list-view-section .lost-item-badge {\n  background-color: #d43f3a !important;\n  color: #fff !important; }\n", ""]);

// exports


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".settings-item-section .item-view-branch-dd .multiSelect .checkboxLayer {\n  width: 91%;\n  max-height: 350px !important;\n  overflow-y: auto !important; }\n\n.settings-item-section .item-view-branch-dd .multiSelect .show {\n  display: block !important; }\n", ""]);

// exports


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".item-history-spinner-section {\n  margin-top: 20px;\n  font-size: 70px;\n  text-align: center; }\n\n.print-logistic-item-header-section {\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n", ""]);

// exports


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".display-flex {\n  display: flex !important;\n  display: -ms-flexbox !important;\n  display: -webkit-flex !important; }\n\n.margin-right-10 {\n  margin-right: 10px; }\n\n.align-center-vertically {\n  display: flex;\n  display: -ms-flexbox;\n  align-items: center; }\n\n.location-header-part {\n  display: flex;\n  justify-content: space-between; }\n\n.location-tittle {\n  width: 15%; }\n\n.location-search {\n  width: 20%;\n  float: left;\n  margin-right: 5px; }\n\n.location-btn-group {\n  width: 12%;\n  float: left; }\n\n.loc-search {\n  width: 23%;\n  float: left;\n  margin-right: 5px; }\n\n.loc-btn-export {\n  width: 10%;\n  float: left; }\n\n.location-section {\n  display: flex;\n  justify-content: flex-end; }\n\n.location-history-tbl-header-color {\n  background: #ffffff; }\n\n.location-history-badge {\n  border-radius: 4px !important;\n  background-color: #5cb85c !important;\n  font-size: 13px !important; }\n\n.location-change-history .list-group-item {\n  padding: 8px 12px !important; }\n\n.location-history-alert-section .alert {\n  padding: 10px !important; }\n\n.location-history-remove-bottom-pad {\n  padding-bottom: 0px !important; }\n\n.location-history-pagination-section .pagination {\n  display: block !important; }\n\n.future-location-changes-bg-color {\n  background-color: antiquewhite; }\n\n.future-location-changes-badge {\n  border-radius: 4px !important;\n  background-color: sandybrown !important;\n  font-size: 13px !important; }\n\n.location-filter-section {\n  justify-content: center;\n  display: flex;\n  gap: 5px;\n  margin-bottom: 7px; }\n\n.active-location-badge {\n  border-radius: 4px !important;\n  background-color: #5cb85c !important;\n  font-size: 14px !important; }\n\n.in-active-location-badge {\n  border-radius: 4px !important;\n  background-color: #d9534f !important;\n  font-size: 14px !important; }\n\n.pad-right-04 {\n  padding-right: 4px; }\n", ""]);

// exports


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".extra_space {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: bold;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden; }\n\n.required-datetimepicker div.datetimepicker-wrapper > input {\n  background-color: #F9E3E3;\n  border-color: #F4C6C6; }\n\ntd.blank-cell {\n  background-color: white !important;\n  border: none !important; }\n\ntable.weekend-table {\n  border-bottom: 1px solid transparent;\n  border-right: 1px solid transparent; }\n\ntable.weekdays-table {\n  margin-bottom: 0px; }\n\nhr.margin-15 {\n  margin: 15px 0px; }\n\n.location-branch-dd .multiSelect .checkboxLayer {\n  max-height: 350px !important;\n  overflow-y: auto !important; }\n\n.location-route-assignment-section .searchandselect .header {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: auto;\n  white-space: normal;\n  word-break: break-all; }\n\n.location-branch-dd .multiSelect .show {\n  display: block !important;\n  right: 15px !important; }\n\n.location-toggle-section {\n  display: flex; }\n\n.optional-control-section {\n  display: flex;\n  gap: 55px; }\n\n.route-like-regular-toggle-width {\n  width: 16%; }\n\n.col-width-07 {\n  width: 7%; }\n\n.btn.btn-sm.btn-info.uib-datepicker-current {\n  display: none !important; }\n\n.btn.btn-sm.btn-danger.uib-clear {\n  border-radius: 3px !important; }\n\n.recurring-stop-section .w-95 {\n  width: 95px !important; }\n\n.recurring-stop-section .w-12 {\n  width: 12%; }\n\n.recurring-stop-section .header-section {\n  margin-top: 15px;\n  font-size: 17px; }\n\n.recurring-stop-section .loc-schedule {\n  display: flex; }\n\n.location-clone-form .searchandselect .dropdownone {\n  z-index: 1010; }\n\n.location-clone-form .location-clone-source-details .panel-body {\n  padding: 10px !important; }\n  .location-clone-form .location-clone-source-details .panel-body p {\n    margin-bottom: 8px;\n    word-break: break-word; }\n\n.location-clone-form .location-clone-options .panel-body {\n  padding: 10px !important; }\n  .location-clone-form .location-clone-options .panel-body .checkbox {\n    margin-bottom: 12px; }\n\n.location-clone-form .location-clone-table {\n  margin-top: 15px; }\n  .location-clone-form .location-clone-table .table th {\n    background-color: #f5f5f5;\n    font-weight: bold; }\n  .location-clone-form .location-clone-table .table td {\n    vertical-align: middle; }\n  .location-clone-form .location-clone-table .table .form-control {\n    margin-bottom: 5px; }\n  .location-clone-form .location-clone-table .table .text-danger {\n    display: block;\n    font-size: 11px;\n    margin-top: 2px; }\n\n.location-clone-form .location-clone-branch-select .multi-select {\n  min-width: 200px; }\n\n.location-clone-form .location-clone-branch-select .multiSelect .checkboxLayer {\n  max-height: 350px !important;\n  overflow-y: auto !important; }\n", ""]);

// exports


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "li.display-flex {\n  display: flex;\n  display: -ms-flexbox; }\n\nul.location-sequence {\n  list-style-type: none; }\n\nli.dndPlaceholder {\n  background: #eee;\n  height: 50px; }\n\n.dt {\n  padding: 8px; }\n\n.div-table {\n  width: 99%;\n  max-width: 99%;\n  display: table;\n  margin-top: 5px; }\n\n.div-tr {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  border-bottom-width: 2px; }\n\n.div-td {\n  border-left: 1px solid #ddd;\n  padding-left: 0px !important;\n  padding-right: 0px !important; }\n\n.border-right {\n  border-right: 1px solid #ddd; }\n\n.border-bottom {\n  border-bottom: 1px solid #ddd; }\n\n.new-btn {\n  float: right;\n  margin: 4px 12px; }\n\n.col-width-18 {\n  width: 18% !important; }\n\n.col-width-32 {\n  width: 32% !important; }\n", ""]);

// exports


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".extra_space {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: bold;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden; }\n\n.required-datetimepicker div.datetimepicker-wrapper > input {\n  background-color: #F9E3E3;\n  border-color: #F4C6C6; }\n\ntd.blank-cell {\n  background-color: white !important;\n  border: none !important; }\n\ntable.weekend-table {\n  border-bottom: 1px solid transparent;\n  border-right: 1px solid transparent; }\n\ntable.weekdays-table {\n  margin-bottom: 0px; }\n\nhr.margin-15 {\n  margin: 15px 0px; }\n\n.location-branch-dd .multiSelect .checkboxLayer,\n.location-atmmake-dd .multiSelect .checkboxLayer {\n  max-height: 250px !important;\n  overflow-y: auto !important; }\n\n.location-zone-section .multiSelect .checkboxLayer {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  width: 96% !important; }\n\n.valid-multi-select-value button#location-zone-multi-select {\n  background: #DFF5DF !important;\n  border-color: #BEEBBE !important; }\n\n.location-route-assignment-section .searchandselect .header {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: auto;\n  white-space: normal;\n  word-break: break-all; }\n\n.location-branch-dd .multiSelect .show {\n  display: block !important;\n  right: 15px !important; }\n\n.location-toggle-section {\n  display: flex; }\n\n.optional-control-section {\n  display: flex;\n  gap: 55px; }\n\n.route-like-regular-toggle-width {\n  width: 16%; }\n\n.col-width-07 {\n  width: 7%; }\n\n.btn.btn-sm.btn-info.uib-datepicker-current {\n  display: none !important; }\n\n.btn.btn-sm.btn-danger.uib-clear {\n  border-radius: 3px !important; }\n\n.recurring-stop-section .w-95 {\n  width: 95px !important; }\n\n.recurring-stop-section .w-12 {\n  width: 12%; }\n\n.recurring-stop-section .header-section {\n  margin-top: 15px;\n  font-size: 17px; }\n\n.recurring-stop-section .loc-schedule {\n  display: flex; }\n\n.location-create-form .searchandselect .dropdownone {\n  z-index: 1010; }\n\n.location-denom .valid-multi-select-value .multiSelect .checkBoxContainer {\n  overflow-y: auto;\n  max-height: 200px;\n  overflow-x: hidden; }\n\n.location-receipts-section {\n  display: flex;\n  justify-content: space-between; }\n\n.location-create-form .toggle-grid-container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px; }\n\n.location-create-form .toggle-grid-container .width-85, .location-create-form .toggle-grid-container .time-picker-input {\n  width: 85% !important; }\n", ""]);

// exports


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "div.dummy-form-control {\n  padding: 0px;\n  border: none;\n  box-shadow: none; }\n\n.location-err-width {\n  width: 99%; }\n\n.location-schedule-section .w-95 {\n  width: 95px !important; }\n\n.location-schedule-section .w-12 {\n  width: 12%; }\n\n.location-schedule-section .header-section {\n  margin-top: 15px;\n  font-size: 17px; }\n\n.location-schedule-section .loc-schedule {\n  display: flex; }\n\n.btn.btn-sm.btn-info.uib-datepicker-current {\n  display: none !important; }\n\n.btn.btn-sm.btn-danger.uib-clear {\n  border-radius: 3px !important; }\n\n.scheduled-location-alert {\n  color: red;\n  float: left;\n  top: auto !important;\n  left: -23px;\n  position: absolute !important;\n  margin-top: 16px; }\n\n.location-edit-form .searchandselect .dropdownone {\n  z-index: 1010; }\n\n.w-03 {\n  width: 3%; }\n\n.recurring-stop-expand-btn {\n  padding-top: 15px; }\n\n.recurring-stop-table-bordered .table-bordered {\n  border: 3px solid #ddd !important; }\n\n.location-denom-icon-size {\n  width: 27px; }\n\n.weekdays-label {\n  text-align: center;\n  padding: 10px !important; }\n\n.location-denom .valid-multi-select-value .multiSelect .checkBoxContainer, .location-denom .valid-multi-select-value .multiSelect .checkboxLayer, .location-atmmake-dd .valid-multi-select-value .multiSelect .checkBoxContainer, .location-atmmake-dd .valid-multi-select-value .multiSelect .checkboxLayer {\n  overflow-y: auto;\n  max-height: 200px;\n  overflow-x: hidden; }\n\n.location-zone-section .multiSelect .checkboxLayer {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  width: 96% !important; }\n\n.location-edit-form .toggle-grid-container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px; }\n\n.location-edit-form .toggle-grid-container .width-85, .location-edit-form .toggle-grid-container .time-picker-input {\n  width: 85% !important; }\n\n.valid-multi-select-value button#multi-select-make {\n  background: #DFF5DF;\n  border-color: #BEEBBE; }\n\n.valid-multi-select-value button#location-zone-multi-select {\n  background: #DFF5DF;\n  border-color: #BEEBBE; }\n", ""]);

// exports


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".display-flex {\n  display: flex !important;\n  display: -ms-flexbox !important;\n  display: -webkit-flex !important; }\n\n.margin-right-10 {\n  margin-right: 10px; }\n\n.align-center-vertically {\n  display: flex;\n  display: -ms-flexbox;\n  align-items: center; }\n", ""]);

// exports


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .print-location-barcodes .hide-in-print {\n    display: none !important; }\n  .print-location-barcodes .show-only-in-print {\n    display: block !important; }\n  .print-location-barcodes .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .print-location-barcodes .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .print-location-barcodes .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .print-location-barcodes .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .print-location-barcodes .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .print-location-barcodes .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .print-location-barcodes .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .print-location-barcodes .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .print-location-barcodes .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .print-location-barcodes .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .print-location-barcodes .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .print-location-barcodes .col-print-12 {\n    width: 100% !important;\n    float: left !important; }\n  .print-location-barcodes .pagebreak {\n    page-break-after: always;\n    clear: both; } }\n\n.print-location-barcodes .show-only-in-print {\n  display: none; }\n\n@media screen {\n  .print-location-barcodes .no-html {\n    visibility: hidden; } }\n\n.print-location-barcodes .location-barcodes .barcode {\n  height: 90px;\n  padding-left: 0px;\n  justify-content: center;\n  align-items: center; }\n\n.print-location-barcodes .location-barcode-print-section {\n  text-align: center;\n  justify-content: center;\n  display: inline-table; }\n\n.print-location-barcodes .location-details-section {\n  font: 16px monospace;\n  margin-top: -7px; }\n", ""]);

// exports


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".panel-body {\n  padding: 5px !important; }\n\n.remove-pad-bottom {\n  margin-bottom: 0px !important; }\n\n.panel-box {\n  border: 1px solid #ddd;\n  border-radius: 4px; }\n\n.panel-box .panel {\n  border: none; }\n\n.panel-default > .panel-heading.cust-panel-color {\n  background-color: #ffffff;\n  border: none; }\n\n.panel-title {\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 400; }\n\n.panel-title a:hover, a:focus {\n  text-decoration: none;\n  outline: none;\n  outline-offset: 0; }\n\n.date-picker-margin {\n  margin-bottom: 5px;\n  margin-top: 5px; }\n\n.message-color {\n  color: blue; }\n\n.log-warning {\n  background-color: #ffe8e8 !important; }\n\n.log_style_container .wrap-text {\n  word-break: break-word; }\n", ""]);

// exports


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".align-center-horizontally {\n  display: flex;\n  justify-content: center; }\n\n.align-center {\n  display: flex;\n  display: -ms-flexbox;\n  justify-content: center;\n  align-items: center; }\n\n.login-form {\n  top: 33rem; }\n\n.login_form {\n  width: 400px;\n  margin: auto;\n  padding-top: 2rem; }\n  .login_form .password_policy_criteria_message_padding {\n    padding: 8px !important; }\n\n.download_app h3 {\n  font-weight: 600;\n  font-size: 22px; }\n\n.download_img img {\n  width: 25%;\n  opacity: 0.9;\n  margin: auto; }\n\n.crs-pointer {\n  cursor: pointer; }\n\n.password-warning-section {\n  margin-left: 22px;\n  margin-bottom: 2px; }\n\n.password-warning-section-margin-bottom-10 {\n  margin-bottom: 10px !important; }\n", ""]);

// exports


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".align-items-center {\n  align-items: center; }\n\n.gap-10 {\n  gap: 10px; }\n\n.cash-scheduled .master-cash-search {\n  float: left;\n  margin-right: 5px; }\n\n.cash-scheduled #calendar-view {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px; }\n\n.cash-scheduled .btn-new {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  float: left; }\n\n.cash-scheduled .master-cash-btn-group {\n  float: left; }\n\n.cash-scheduled .master-cash-section {\n  display: flex;\n  justify-content: flex-end; }\n\n.cash-scheduled .calendar-filter {\n  display: inline-block;\n  vertical-align: middle;\n  margin-bottom: 10px; }\n\n.cash-scheduled .calendar-table td {\n  vertical-align: top !important; }\n\n.cash-scheduled .calender-start {\n  position: relative; }\n\n.cash-scheduled .header_cal {\n  display: flex;\n  justify-content: space-between;\n  height: 35px;\n  background: #6e7cc9;\n  color: white;\n  align-items: center;\n  padding-left: 10px;\n  padding-right: 10px; }\n\n.cash-scheduled .p-0 {\n  padding: 0; }\n\n.cash-scheduled .header_cal i {\n  cursor: pointer; }\n\n.cash-scheduled .header_cal > span {\n  width: 100%;\n  font-weight: bold;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  text-align: center;\n  color: inherit; }\n\n.cash-scheduled .today {\n  background: #DEEBF7; }\n\n.cash-scheduled .selected-day,\n.cash-scheduled .selected-day:hover {\n  background: #DEEBF7; }\n\n.cash-scheduled .day-name {\n  color: #000000;\n  font-weight: bold;\n  text-align: center; }\n\n.cash-scheduled .denom-list {\n  padding: 0px; }\n\n.cash-scheduled .denom-list div {\n  border-color: darkgray;\n  border-radius: 2px; }\n\n.cash-scheduled .square {\n  height: 10px;\n  width: 10px; }\n\n.cash-scheduled .justify-content-space-evenly {\n  justify-content: space-evenly; }\n\n.cash-scheduled .shipment-details-section {\n  gap: 10px;\n  background-color: darkgray;\n  min-width: fit-content;\n  width: 100%;\n  padding-left: 5px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  color: #fff; }\n\n.cash-scheduled .disabled-link {\n  pointer-events: none;\n  cursor: not-allowed; }\n\n.cash-scheduled .status-border {\n  border-color: #ccc; }\n\n.cash-scheduled .shipment-details-section.denom-scheduled,\n.cash-scheduled .square.forecasted {\n  background-color: #ffc308 !important; }\n\n.cash-scheduled .status-border-scheduled {\n  border-color: #ffc308 !important; }\n\n.cash-scheduled .shipment-details-section.denom-ordered,\n.cash-scheduled .square.ordered {\n  background-color: #5b9bd5 !important; }\n\n.cash-scheduled .status-border-ordered {\n  border-color: #5b9bd5 !important; }\n\n.cash-scheduled .shipment-details-section.packed,\n.cash-scheduled .square.packed {\n  background-color: #70ad47 !important; }\n\n.cash-scheduled .status-border-in-progress {\n  border-color: #70ad47 !important; }\n\n.cash-scheduled .shipment-details-section.crved,\n.cash-scheduled .square.crved {\n  background-color: #e48400 !important; }\n\n.cash-scheduled .shipment-details-section.pending-pack,\n.cash-scheduled .square.pending-pack {\n  background-color: #6e7cc9 !important; }\n\n.cash-scheduled .shipment-details-section.completed,\n.cash-scheduled .square.completed {\n  background-color: darkgray !important; }\n\n.cash-scheduled .shipment-details-section.hold,\n.cash-scheduled .square.hold {\n  background-color: orange !important; }\n\n.cash-scheduled .shipment-details-section.pending,\n.cash-scheduled .square.pending {\n  background-color: #FFD700 !important; }\n\n.cash-scheduled .shipment-details-section.cancelled,\n.cash-scheduled .square.cancelled {\n  background-color: #d9534f !important; }\n\n.cash-scheduled .shipment-details-section.scheduled,\n.cash-scheduled .square.scheduled {\n  background-color: mediumpurple !important; }\n\n.cash-scheduled .scheduled-filter-button {\n  background-color: mediumpurple !important;\n  color: #fff; }\n\n.cash-scheduled .tab-filter-button {\n  background-color: #6e7cc9 !important;\n  color: #fff; }\n\n.cash-scheduled .all-filter-button {\n  background-color: #156082 !important;\n  color: #fff; }\n\n.cash-scheduled .table-tracking {\n  font-weight: normal;\n  color: #fff; }\n\n.cash-scheduled .status-border-crved {\n  border-color: #e48400 !important; }\n\n.cash-scheduled .info-legend div {\n  padding-left: 5px; }\n\n.cash-scheduled .selected-date-panel {\n  position: absolute;\n  right: 0;\n  top: 0;\n  background: #FBFBFB;\n  width: calc(100% - 70%);\n  box-shadow: 0 5px 15px 0 #CFCFCF;\n  display: flex; }\n\n.cash-scheduled .selected-date-panel .panel-header {\n  height: 45px;\n  font-size: 18px;\n  font-weight: 800;\n  color: #fff;\n  padding: 10px; }\n\n.cash-scheduled .selected-date-panel .panel-body {\n  height: auto; }\n\n.cash-scheduled .selected-date-panel .denom-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 5px; }\n\n.cash-scheduled .flex-end {\n  justify-content: flex-end; }\n\n.cash-scheduled .edit-denom-controls {\n  display: flex; }\n\n.cash-scheduled .edit-denom .input-group-addon {\n  flex: 0 0 auto;\n  width: auto !important;\n  padding: 6px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid;\n  border-radius: 4px 0 0 4px !important; }\n\n.cash-scheduled .edit-denom input.form-control {\n  flex: 1 1 auto;\n  height: auto !important;\n  text-align: center;\n  border: 1px solid;\n  border-radius: 0 4px 4px 0 !important;\n  color: #555555; }\n\n.cash-scheduled .edit-denom {\n  display: flex;\n  flex-direction: column; }\n\n.cash-scheduled .edit-input-denom {\n  padding-right: 30px;\n  /* Prevent text overlap with the button */ }\n\n.cash-scheduled .form-control-edit {\n  text-align: center;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: 14px;\n  line-height: 1.42857;\n  color: #555555;\n  height: 34px;\n  padding: 6px 15px;\n  width: 100%;\n  cursor: not-allowed;\n  background-color: #eeeeee !important;\n  border-color: #beebbe; }\n\n.cash-scheduled .edit-turn-off-button {\n  position: absolute;\n  right: 5px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 50%;\n  height: 24px;\n  width: 24px;\n  font-size: 10px;\n  padding: 0;\n  z-index: 10;\n  /* Ensure the button is above the input field */ }\n\n.cash-scheduled .form-denom-list {\n  display: flex;\n  gap: 6px; }\n\n.cash-scheduled .form-denom-list .input-group-addon {\n  padding: 6px 12px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1;\n  color: #555555;\n  text-align: center;\n  background-color: #eeeeee;\n  border: 1px solid #ccc;\n  border-radius: 5px; }\n\n.cash-scheduled .list-group-margin-bottom {\n  margin-bottom: 5px !important; }\n\n.cash-scheduled .cash-filter-list {\n  display: grid;\n  grid: 50px / 24.5% 24.5% 24.5% 24.5%; }\n\n.cash-scheduled .set-grid {\n  grid: auto / auto auto auto; }\n\n.cash-scheduled .margin-bottom-03 {\n  margin-bottom: 3px; }\n\n.cash-scheduled ._margin-top-10 {\n  margin-top: 10px; }\n\n.cash-scheduled .scroll-view {\n  max-height: 250px;\n  overflow-y: auto;\n  cursor: pointer; }\n\n.cash-scheduled .bold-text {\n  font-weight: bold; }\n\n.cash-scheduled .date-badge {\n  border-radius: 4px !important;\n  background-color: #A0A0A0 !important;\n  font-size: 13px !important; }\n\n.cash-scheduled .total-orders-badge {\n  background-color: #70ad47 !important;\n  font-size: 13px !important; }\n\n.cash-scheduled .no-orders-badge {\n  background-color: #A0A0A0 !important;\n  font-size: 13px !important; }\n\n.cash-scheduled .order-view-branch-dd .multiSelect .checkboxLayer {\n  width: 24%;\n  max-height: 350px !important;\n  overflow-y: auto !important; }\n\n.cash-scheduled .order-view-branch-dd .multiSelect .show {\n  display: block !important; }\n\n.cash-scheduled .delivery-tracking-id-section {\n  border: 1px solid;\n  padding-left: 7px;\n  border-radius: 4px;\n  border-color: #beebbe;\n  background-color: #dff5df; }\n\n.cash-scheduled .remove-underline:hover {\n  text-decoration: none; }\n\n.cash-scheduled .icon-width-40 {\n  width: 40%; }\n\n.cash-scheduled .icon-width-50 {\n  width: 50%; }\n\n.cash-scheduled .icon-list-section {\n  display: flex;\n  gap: 10px; }\n\n.cash-scheduled .section-block {\n  display: block !important; }\n\n.cash-scheduled .packed-shipment-header-section {\n  background-color: #70ad47 !important;\n  border: 1px solid #70ad47 !important; }\n\n.cash-scheduled .pending-pack-shipment-header-section {\n  background-color: #6e7cc9 !important;\n  border: 1px solid #6e7cc9 !important; }\n\n.cash-scheduled .completed-shipment-header-section {\n  background-color: darkgray !important;\n  border: 1px solid darkgray !important; }\n\n.cash-scheduled .hold-shipment-header-section {\n  background-color: orange !important;\n  border: 1px solid orange !important; }\n\n.cash-scheduled .crved-shipment-header-section {\n  background-color: #e48400 !important;\n  border: 1px solid #e48400 !important; }\n\n.cash-scheduled .pending-shipment-header-section {\n  background-color: #FFD700 !important;\n  border: 1px solid #FFD700 !important; }\n\n.cash-scheduled .cancelled-shipment-header-section {\n  background-color: #d9534f !important;\n  border: 1px solid #d9534f !important; }\n\n.cash-scheduled .scheduled-shipment-header-section {\n  background-color: mediumpurple !important;\n  border: 1px solid mediumpurple !important; }\n\n.cash-scheduled .packed-shipment-header-section {\n  background-color: #70ad47 !important;\n  border: 1px solid #70ad47 !important; }\n\n.cash-scheduled .packed-shipment-table-section {\n  background-color: #70ad47 !important;\n  color: #fff;\n  font-weight: 500; }\n\n.cash-scheduled .pending-pack-shipment-table-section {\n  background-color: #6e7cc9 !important;\n  color: #fff;\n  font-weight: 500; }\n\n.cash-scheduled .completed-shipment-table-section {\n  background-color: darkgray !important;\n  color: #fff;\n  font-weight: 500; }\n\n.cash-scheduled .hold-shipment-table-section {\n  background-color: orange !important;\n  color: #fff;\n  font-weight: 500; }\n\n.cash-scheduled .hold-route-dropdown .searchandselect {\n  background-color: orange !important;\n  border-color: orange !important; }\n\n.cash-scheduled .hold-route-dropdown .searchandselect .header,\n.cash-scheduled .hold-route-dropdown select.form-control,\n.cash-scheduled .hold-route-dropdown input.form-control {\n  background-color: orange !important;\n  color: #fff !important;\n  font-weight: 500;\n  border-color: orange !important; }\n  .cash-scheduled .hold-route-dropdown .searchandselect .header option,\n  .cash-scheduled .hold-route-dropdown select.form-control option,\n  .cash-scheduled .hold-route-dropdown input.form-control option {\n    background-color: #fff !important;\n    color: #555 !important;\n    font-weight: normal; }\n\n.cash-scheduled .crved-shipment-table-section {\n  background-color: #e48400 !important;\n  color: #fff;\n  font-weight: 500; }\n\n.cash-scheduled .disable-div {\n  pointer-events: none;\n  cursor: not-allowed; }\n\n.cash-scheduled .pending-shipment-table-section {\n  background-color: #FFD700 !important;\n  color: #fff;\n  font-weight: 500; }\n\n.cash-scheduled .scheduled-shipment-table-section {\n  background-color: mediumpurple !important;\n  color: #fff;\n  font-weight: 500; }\n\n.cash-scheduled .multi-denom-edit {\n  width: 50%;\n  padding-right: 5px !important; }\n\n.cash-scheduled .denom-edit-w-100 {\n  width: 100% !important;\n  padding-right: 2px !important; }\n\n.cash-scheduled .single-denom-edit {\n  width: 50%;\n  padding-left: 5px !important; }\n\n.cash-scheduled .table-denoms {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  padding: 2px 4px; }\n\n.cash-scheduled .table-view {\n  max-height: 650px;\n  overflow-y: auto;\n  position: relative; }\n\n.cash-scheduled .table-view table {\n  width: 100%; }\n\n.cash-scheduled .table-view thead {\n  position: sticky;\n  top: -1px;\n  z-index: 1;\n  background-color: #fff;\n  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1); }\n\n.cash-scheduled .table-view tbody {\n  width: 100%; }\n\n.cash-scheduled .table-view tbody td, .cash-scheduled .table-view thead th {\n  width: 100%; }\n\n.cash-scheduled .table-view th {\n  padding: 10; }\n\n.cash-scheduled .table-view th, .cash-scheduled .table-view td {\n  text-align: center;\n  padding: 8px; }\n\n.cash-scheduled .table-view .table-header {\n  background-color: #156082;\n  color: #fff; }\n\n.cash-scheduled .create-order-view-date-picker-section .datetimepicker-wrapper {\n  display: block !important; }\n\n.cash-scheduled .panel-width-45 {\n  width: 45% !important; }\n\n.cash-scheduled .order-create-tab-section {\n  display: flex;\n  justify-content: end;\n  bottom: 5px; }\n\n.cash-scheduled .edit-order-view-date-picker-section .datetimepicker-wrapper {\n  display: block !important; }\n\n.cash-scheduled .width-23 {\n  width: 23%; }\n\n.cash-scheduled .scheduled-btn-color {\n  color: #fff;\n  background-color: #6e7cc9;\n  border-color: #6e7cc9; }\n\n.cash-scheduled .remove-btn-grp-color {\n  color: #333 !important;\n  background-color: #fff !important;\n  border-color: #ccc !important; }\n\n.cash-scheduled .master-cash-denom-alert-section .alert {\n  padding: 10px !important;\n  margin-bottom: 10px !important; }\n\n.cash-scheduled .master-cash-line-section {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important; }\n\n.cash-scheduled .scheduled-pattern-weeks-dd {\n  display: flex;\n  justify-content: right;\n  gap: 10px; }\n  .cash-scheduled .scheduled-pattern-weeks-dd .form-control {\n    width: 25% !important;\n    height: 20px !important; }\n\n.cash-scheduled .scheduled-week-btn-section .btn {\n  padding: 6px 3px !important; }\n\n.cash-scheduled .schedule-weeks-input .form-control {\n  display: inline-table;\n  width: 30%;\n  height: 20px; }\n\n.cash-scheduled .padding-right-05 {\n  padding-right: 5px; }\n\n.cash-scheduled .disabled-state {\n  opacity: 1;\n  background-color: #eeeeee !important; }\n\n.cash-scheduled .disabled-state-cursor:hover {\n  cursor: not-allowed; }\n\n.cash-scheduled .margin-bottom-07 {\n  margin-bottom: 7px !important; }\n\n.cash-scheduled .daily-schedule-input .form-control {\n  display: inline-table;\n  width: 15%;\n  height: 30px; }\n\n.cash-scheduled .the-month-btn-padding {\n  padding: 4px 3px !important; }\n\n.cash-scheduled .the-month-padding .form-control {\n  height: 30px; }\n\n.cash-scheduled .daily-schedule-section-border {\n  border: 0.1rem groove;\n  padding: 7px; }\n\n.cash-scheduled .monthly-schedule-line-section {\n  margin-top: 5px !important;\n  margin-bottom: 5px !important; }\n\n.cash-scheduled .of-every-text-section {\n  padding-right: 5px;\n  margin-top: 5px; }\n\n.cash-scheduled .months-text-section {\n  padding-left: 5px;\n  margin-top: 5px; }\n\n.cash-scheduled .ec-icon {\n  width: 20px;\n  margin-top: 1px; }\n\n.cash-scheduled ._word-break {\n  word-break: break-word;\n  word-wrap: break-word; }\n\n.cash-scheduled * {\n  scrollbar-width: thin;\n  scrollbar-color: darkgrey #ddd; }\n\n.cash-scheduled *::-webkit-scrollbar {\n  width: 10px; }\n\n.cash-scheduled *::-webkit-scrollbar-track {\n  background: #ddd; }\n\n.cash-scheduled *::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  border-radius: 20px;\n  border: 3px solid #ddd; }\n\n.cash-scheduled .multi-denomination-box-border {\n  border: 1px solid lightgray;\n  padding: 5px; }\n\n.cash-scheduled .single-denomination-box-border {\n  border: 1px solid lightgray;\n  padding: 5px; }\n", ""]);

// exports


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".currency-pick-report-container {\n  padding: 10px;\n  background-color: #fff; }\n  .currency-pick-report-container .order-history-center-section {\n    background-color: white;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #eee;\n    margin-bottom: 20px; }\n  .currency-pick-report-container .table-wrapper {\n    display: flex;\n    position: relative;\n    overflow: hidden;\n    border: 1px solid #ddd; }\n  .currency-pick-report-container .fixed-column {\n    flex-shrink: 0;\n    z-index: 2;\n    background-color: #fff;\n    border-right: none; }\n    .currency-pick-report-container .fixed-column table {\n      margin-bottom: 0; }\n    .currency-pick-report-container .fixed-column th,\n    .currency-pick-report-container .fixed-column td {\n      min-width: 180px !important;\n      width: 180px !important; }\n  .currency-pick-report-container .scrollable-columns {\n    overflow-x: auto;\n    overflow-y: hidden;\n    flex-grow: 1; }\n    .currency-pick-report-container .scrollable-columns table {\n      margin-bottom: 0; }\n  .currency-pick-report-container .currency-pick-table {\n    border-collapse: separate;\n    border-spacing: 1px;\n    border: none;\n    width: 100%; }\n    .currency-pick-report-container .currency-pick-table thead tr th {\n      background-color: #e2efda;\n      font-weight: 600;\n      font-size: 16px;\n      text-align: center;\n      border: none;\n      vertical-align: middle; }\n      .currency-pick-report-container .currency-pick-table thead tr th .denom-label {\n        font-size: 12px;\n        text-transform: uppercase;\n        letter-spacing: 0.5px; }\n      .currency-pick-report-container .currency-pick-table thead tr th .denom-value {\n        font-size: 18px;\n        margin-top: 2px; }\n    .currency-pick-report-container .currency-pick-table tbody tr:nth-child(odd) td {\n      background-color: #ccd2d8; }\n    .currency-pick-report-container .currency-pick-table tbody tr:nth-child(even) td {\n      background-color: #e7eaed; }\n    .currency-pick-report-container .currency-pick-table tbody tr td {\n      border: none;\n      vertical-align: middle;\n      color: #000;\n      min-width: 140px;\n      padding: 10px 8px;\n      height: 60px; }\n      .currency-pick-report-container .currency-pick-table tbody tr td.category-name {\n        font-weight: 600;\n        font-size: 14px;\n        text-align: center;\n        color: #333; }\n        .currency-pick-report-container .currency-pick-table tbody tr td.category-name .denom-info {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 10px; }\n          .currency-pick-report-container .currency-pick-table tbody tr td.category-name .denom-info .denom-image {\n            flex-shrink: 0; }\n          .currency-pick-report-container .currency-pick-table tbody tr td.category-name .denom-info .denom-id {\n            font-weight: 600;\n            font-size: 16px; }\n      .currency-pick-report-container .currency-pick-table tbody tr td .qty {\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 1; }\n      .currency-pick-report-container .currency-pick-table tbody tr td .amt {\n        font-size: 14px;\n        color: #444;\n        margin-top: 2px; }\n      .currency-pick-report-container .currency-pick-table tbody tr td.total-amount {\n        font-size: 16px;\n        font-weight: 600;\n        color: #000; }\n    .currency-pick-report-container .currency-pick-table tbody tr.grand-total-row td {\n      font-weight: bold;\n      font-size: 16px;\n      font-weight: 600; }\n\n.margin-top-20 {\n  margin-top: 20px; }\n", ""]);

// exports


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .print-header-margin {\n    margin-top: 10px; } }\n\n.show-only-in-print {\n  display: none; }\n\n.print-currency-pick-report-container {\n  padding: 20px; }\n  .print-currency-pick-report-container .print-logo-height-65 {\n    height: 65px; }\n  .print-currency-pick-report-container .header-section {\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n    align-items: center;\n    margin-bottom: 20px; }\n    .print-currency-pick-report-container .header-section .print-logo-height-65 {\n      height: 64px; }\n    .print-currency-pick-report-container .header-section .title {\n      font-size: 20px;\n      font-weight: bold;\n      justify-self: start; }\n    .print-currency-pick-report-container .header-section .logo-container {\n      justify-self: center;\n      text-align: center; }\n  .print-currency-pick-report-container .currency-pick-table {\n    border-collapse: collapse;\n    border: 1px solid #ddd;\n    width: 100%; }\n    .print-currency-pick-report-container .currency-pick-table thead tr th {\n      border: 1px solid #ddd;\n      font-weight: 600;\n      font-size: 16px;\n      text-align: center;\n      vertical-align: middle;\n      background-color: #f9f9f9;\n      -webkit-print-color-adjust: exact;\n      print-color-adjust: exact; }\n      .print-currency-pick-report-container .currency-pick-table thead tr th .denom-label {\n        font-size: 12px;\n        text-transform: uppercase;\n        letter-spacing: 0.5px; }\n      .print-currency-pick-report-container .currency-pick-table thead tr th .denom-value {\n        font-size: 16px;\n        margin-top: 2px; }\n    .print-currency-pick-report-container .currency-pick-table tbody tr td {\n      border: 1px solid #ddd;\n      vertical-align: middle;\n      color: #000;\n      min-width: 140px;\n      padding: 10px 8px; }\n      .print-currency-pick-report-container .currency-pick-table tbody tr td.category-name {\n        font-weight: 600;\n        font-size: 14px;\n        text-align: center;\n        color: #333; }\n        .print-currency-pick-report-container .currency-pick-table tbody tr td.category-name .denom-info {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 10px; }\n          .print-currency-pick-report-container .currency-pick-table tbody tr td.category-name .denom-info .denom-image {\n            flex-shrink: 0; }\n      .print-currency-pick-report-container .currency-pick-table tbody tr td .qty {\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 1; }\n      .print-currency-pick-report-container .currency-pick-table tbody tr td .amt {\n        font-size: 14px;\n        color: #444;\n        margin-top: 2px; }\n      .print-currency-pick-report-container .currency-pick-table tbody tr td.total-amount {\n        font-size: 16px;\n        font-weight: 600;\n        color: #000; }\n    .print-currency-pick-report-container .currency-pick-table tbody tr.grand-total-row td {\n      font-weight: bold;\n      font-size: 16px;\n      font-weight: 600; }\n  .print-currency-pick-report-container .signature-section .table-responsive {\n    overflow-x: visible !important; }\n  .print-currency-pick-report-container .signature-section .signature-wrapper {\n    display: block;\n    width: 100%; }\n  .print-currency-pick-report-container .signature-section .signature-row {\n    display: flex;\n    align-items: flex-end;\n    margin-bottom: 40px;\n    margin-left: auto;\n    width: 40%; }\n    @media print {\n      .print-currency-pick-report-container .signature-section .signature-row {\n        width: 48% !important; } }\n    .print-currency-pick-report-container .signature-section .signature-row .sig-label {\n      font-size: 16px;\n      color: #000;\n      margin-right: 10px;\n      white-space: nowrap;\n      min-width: 100px;\n      text-align: left;\n      margin-top: 5px;\n      font-weight: 400; }\n    .print-currency-pick-report-container .signature-section .signature-row .sig-line {\n      flex-grow: 1;\n      border-bottom: 1px solid #454546;\n      height: 1px; }\n  @media print {\n    .print-currency-pick-report-container .currency-pick-table th,\n    .print-currency-pick-report-container .category-name,\n    .print-currency-pick-report-container .total-row,\n    .print-currency-pick-report-container .grand-total-row td {\n      -webkit-print-color-adjust: exact;\n      print-color-adjust: exact; } }\n", ""]);

// exports


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".btn-return {\n  color: #fff;\n  background-color: #ed7d31;\n  border-color: #ed7d31; }\n\n.text-amount {\n  padding: 5px;\n  font-size: 19px;\n  font-weight: 500; }\n\n.div-margin-top {\n  margin-top: 1% !important; }\n\n.sort {\n  float: right;\n  top: 2px !important; }\n\n.padding-18 {\n  padding: 18px !important; }\n\n.arrow-up {\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 10px solid grey;\n  position: relative;\n  margin-top: 2px; }\n\n.arrow-down {\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 10px solid grey;\n  position: relative;\n  margin-top: 2px; }\n\n.denom-position {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  flex-wrap: wrap; }\n\n.denom-width {\n  width: 25%;\n  margin: 8px auto; }\n\n.padding-left-60 {\n  padding-left: 60px; }\n\n.order-packing-font-35 {\n  font-size: 35px; }\n\n.location-comment-color {\n  color: blue; }\n\n.icon-height-19 {\n  height: 19px; }\n\n.bulk-cash-link-btn {\n  cursor: pointer; }\n\n.bulk-cash-link-btn:hover {\n  text-decoration: none; }\n\n.order-auto-center-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; }\n\n.btn-group-section {\n  display: flex;\n  justify-content: center; }\n\n.justify-content-flex-end {\n  justify-content: flex-end; }\n\n.order-pack-btn-margin-bottom {\n  margin-bottom: 3px !important; }\n\n.print-pre-pack-checkbox-w {\n  width: 1%; }\n\n.order-pack-datetimepicker-section div.datetimepicker-wrapper {\n  display: block !important; }\n\n.order-pack-route-seq-color {\n  color: #337ab7; }\n\n.ledger-short-fall-btn-margin {\n  margin-bottom: 5px !important; }\n\n.bg-yellow {\n  background-color: rgba(255, 255, 0, 0.548) !important; }\n\n.bg-orange {\n  background-color: rgba(255, 166, 0, 0.5) !important; }\n\n.total-balance {\n  font-weight: bold;\n  font-size: 1.2em; }\n\n.border-black {\n  border-color: rgba(0, 0, 0, 0.24) !important; }\n\n.denom-container {\n  display: flex;\n  /* Ensures the badges are aligned in a row */\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 4px; }\n\n.denom-badge {\n  display: flex;\n  align-items: center;\n  border: 1px solid #ccc;\n  /* Light gray border */\n  border-radius: 3px;\n  background-color: #fff;\n  /* White background */\n  justify-content: center;\n  /* Center the content within the badge */\n  padding: 2px 3px; }\n\n.denom-image {\n  width: 20px;\n  /* Fixed width for the image */\n  height: auto;\n  /* Maintain aspect ratio */\n  margin-right: 4px;\n  /* Space between the image and text */ }\n\n.denom-amount {\n  font-size: 14px;\n  /* Size of the text */\n  color: #333;\n  /* Dark text color for better readability */ }\n\n.center-table {\n  display: flex;\n  justify-content: center; }\n\n.bags-container {\n  display: flex;\n  flex-direction: column;\n  padding-left: 5px; }\n", ""]);

// exports


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .barcode-page {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 21cm;\n    height: 38cm !important;\n    margin: auto; }\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; }\n  .pagebreak {\n    page-break-after: always;\n    clear: both; } }\n\n.show-only-in-print {\n  display: none; }\n\n@media screen {\n  .no-html {\n    visibility: hidden; } }\n\n.order-packing-labels .barcode {\n  height: 125px;\n  padding-left: 0px;\n  justify-content: center;\n  align-items: center; }\n\n.print-company-title-section {\n  font-weight: 500;\n  padding-left: 5px; }\n\n.barcode-print-section {\n  /* height: 277px; */\n  text-align: center;\n  justify-content: center;\n  display: inline-table; }\n\n.border-top-01 {\n  border-top: 1px solid; }\n\n.margin-top-15 {\n  margin-top: 15px; }\n\n.font-size-14 {\n  font-size: 14px; }\n", ""]);

// exports


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; }\n  .pagebreak {\n    page-break-after: always !important;\n    clear: both !important; }\n  .print-margin-bottom-05 {\n    margin-bottom: 5px !important; } }\n\n.show-only-in-print {\n  display: none; }\n\n@media screen {\n  .no-html {\n    visibility: hidden; } }\n\n.remove-border-top {\n  border-top: hidden !important; }\n", ""]);

// exports


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".print-packing-slip-container {\n  padding: 18px;\n  background-color: white; }\n  .print-packing-slip-container .header-section {\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n    align-items: center;\n    margin-bottom: 20px; }\n    .print-packing-slip-container .header-section .print-logo-height-65 {\n      height: 64px; }\n    .print-packing-slip-container .header-section .title {\n      font-size: 20px;\n      font-weight: bold;\n      justify-self: start; }\n    .print-packing-slip-container .header-section .logo-container {\n      justify-self: center;\n      text-align: center; }\n    .print-packing-slip-container .header-section .order-no-container {\n      justify-self: end;\n      font-size: 20px;\n      font-weight: bold;\n      margin-top: 10px; }\n    .print-packing-slip-container .header-section .print-btn-container {\n      justify-self: end; }\n  .print-packing-slip-container .route-info-section {\n    font-size: 18px;\n    margin-bottom: 15px; }\n  .print-packing-slip-container .table-section .table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px; }\n    .print-packing-slip-container .table-section .table th.blue-header {\n      background-color: #156082;\n      color: white;\n      padding: 10px;\n      text-align: left; }\n      .print-packing-slip-container .table-section .table th.blue-header:nth-child(1) {\n        width: 25%; }\n      .print-packing-slip-container .table-section .table th.blue-header:nth-child(2) {\n        width: 25%; }\n      .print-packing-slip-container .table-section .table th.blue-header:nth-child(3) {\n        width: 25%; }\n      .print-packing-slip-container .table-section .table th.blue-header:nth-child(4) {\n        width: 25%; }\n    .print-packing-slip-container .table-section .table td {\n      padding: 10px;\n      border: 1px solid #ffffff;\n      background-color: #e6e9ec;\n      font-size: 14px; }\n  @media print {\n    .print-packing-slip-container .print-btn-container {\n      display: none; }\n    .print-packing-slip-container .print-packing-slip-container {\n      padding: 0; } }\n", ""]);

// exports


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".reporting-css-section .reporting-branch-dd .multiSelect .show {\n  display: block !important; }\n\n.reporting-css-section .reporting-branch-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  width: 200px !important; }\n", ""]);

// exports


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".info-btn-width {\n  width: 15%; }\n\n.delete-btn-width {\n  width: 7%; }\n", ""]);

// exports


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".margin-zero {\n  margin: 0 !important; }\n\n.margin-vertical-5 {\n  margin-top: 5px;\n  margin-bottom: 5px; }\n\n.location-address {\n  margin-top: 5px;\n  margin-bottom: 0px; }\n\n.coin-container {\n  position: relative; }\n  .coin-container .coin-total {\n    position: absolute;\n    bottom: 0px;\n    right: 10px; }\n\n.route_table_view {\n  float: left;\n  position: relative;\n  padding: 5px;\n  width: 60%; }\n\n.trackingId-border {\n  border-right: 1px solid #ccc; }\n", ""]);

// exports


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; } }\n\n.show-only-in-print {\n  display: none; }\n\n.coin-icon {\n  background-repeat: no-repeat;\n  background-size: 20px auto;\n  background-position: center; }\n\n.coin-icon-01B,\n.coin-icon-01L,\n.coin-icon-01H {\n  background-image: url(" + __webpack_require__(139) + "); }\n\n.coin-icon-05B,\n.coin-icon-05L,\n.coin-icon-05H {\n  background-image: url(" + __webpack_require__(142) + "); }\n\n.coin-icon-10B,\n.coin-icon-10L,\n.coin-icon-10H {\n  background-image: url(" + __webpack_require__(140) + "); }\n\n.coin-icon-25B,\n.coin-icon-25L,\n.coin-icon-25H {\n  background-image: url(" + __webpack_require__(141) + "); }\n\n.coin-icon-50B,\n.coin-icon-50L,\n.coin-icon-50H {\n  background-image: url(" + __webpack_require__(143) + "); }\n\n.custom-icon {\n  width: 30px; }\n\n.route-num {\n  float: left;\n  padding: 7px;\n  border-right: 1px solid lightgray;\n  border-bottom: 1px solid lightgray;\n  font-weight: bold; }\n\n.route-table tr, .route-table td {\n  border: 1px solid lightgray;\n  border-bottom: transparent; }\n\ntable.no-borders,\ntr.no-borders,\ntd.no-borders {\n  border: none; }\n\n.route-header-table tr,\n.route-header-table td {\n  border: 1px solid gray;\n  border-bottom: transparent;\n  padding: 5px; }\n\n.vertical-align-top {\n  vertical-align: top !important; }\n\n.route-status {\n  float: right;\n  border-top: 1px solid gray;\n  padding: 2px 4px;\n  border-left: 1px solid gray; }\n\n.text-center {\n  text-align: center; }\n\n.coin-table tr,\n.coin-table td {\n  border: none !important; }\n\n.coin-table tr {\n  padding-right: 5px; }\n\n#inline {\n  display: inline-block; }\n\n.barcode {\n  height: 70px;\n  padding-left: 20px; }\n\n.route-sheet .route-number {\n  width: 30px; }\n\n.route-sheet .route-coins {\n  width: 150px; }\n\n.route-sheet .route-dates {\n  width: 50px; }\n\n.route-sheet .route-total {\n  width: 50px; }\n\n.route-sheet-div {\n  width: 1041px; }\n  .route-sheet-div .route-col {\n    float: left;\n    border: 1px solid lightgray;\n    height: 70px; }\n\n.tracking-id-column {\n  float: left;\n  padding: 5px;\n  height: 70px;\n  border-left: 1px solid lightgray;\n  border-bottom: 1px solid lightgray; }\n\n.height-120 .route-col {\n  height: 120px !important; }\n\n.height-120 .tracking-id-column {\n  height: 90px !important; }\n\n.height-160 .route-col {\n  height: 160px !important; }\n\n.height-160 .tracking-id-column {\n  height: 120px !important; }\n\n.padding-left-5 {\n  padding-left: 5px; }\n\n.ui-select-container {\n  position: relative;\n  top: -1px; }\n\nspan.ui-select-match-text {\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\ndiv.invalid span.ui-select-toggle {\n  background-color: #F9E3E3 !important;\n  border-color: #F4C6C6 !important; }\n\ndiv.valid span.ui-select-toggle {\n  background-color: #DFF5DF !important;\n  border-color: #BEEBBE !important; }\n", ""]);

// exports


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".cursor-pointer {\n  cursor: pointer; }\n\n.header-row {\n  background: #A5A5A5; }\n\n.header-row:hover {\n  background: #A5A5A5 !important; }\n\n.header-row td, .header-row th {\n  color: white; }\n\n.text-decoration-none {\n  text-decoration: none !important; }\n\n.align-parent-bottom {\n  display: flex;\n  align-items: flex-end; }\n\n.margin-top-25 {\n  margin-top: 25px; }\n\n.margin-bottom-5 {\n  margin-bottom: 5px !important; }\n\n.remove-pad {\n  padding: 0 !important;\n  margin: 0 !important; }\n\n.checked-in-route {\n  padding-left: 5px;\n  font-size: 15px;\n  color: #398439; }\n\n.form-checbox input[type=\"checkbox\"] {\n  display: none; }\n\n.form-checbox input[type=\"checkbox\"] + .btn-checkbox-group > label span {\n  width: 20px; }\n\n.form-checbox input[type=\"checkbox\"] + .btn-checkbox-group > label span:first-child {\n  display: none; }\n\n.form-checbox input[type=\"checkbox\"] + .btn-checkbox-group > label span:last-child {\n  display: inline-block; }\n\n.form-checbox input[type=\"checkbox\"]:checked + .btn-checkbox-group > label span:first-child {\n  display: inline-block; }\n\n.form-checbox input[type=\"checkbox\"]:checked + .btn-checkbox-group > label span:last-child {\n  display: none; }\n\n.stop-transfer-msg {\n  margin-bottom: 0px !important;\n  color: #d25277; }\n\n.last-released-route {\n  border-top: 1px solid #d2d2d2;\n  margin: 5px !important; }\n\n.item-hold-icon {\n  width: 20px !important; }\n\n.routeControl-lastReleased-width {\n  min-width: 170px !important;\n  max-width: 150px !important; }\n\n.table-pad-4 td {\n  padding: 4px !important; }\n\n.v-align-top {\n  vertical-align: top !important; }\n\n.label-padding-top-08 {\n  padding-top: 8px !important; }\n\n.route-relese-error {\n  min-width: 170px !important;\n  max-width: 270px !important; }\n\n.shipment-count-bg-color {\n  background-color: #2d78b9 !important; }\n\n.grey-icon-style {\n  height: 18px !important;\n  width: 18px !important;\n  margin-bottom: 3px !important; }\n\n.orange-icon-style {\n  width: 20px !important;\n  margin-bottom: 1px !important; }\n\n.total-shipments-badge .btn .badge {\n  position: relative;\n  top: -2px; }\n\n.remove-right-pad {\n  padding-right: 0px !important; }\n\n@media (min-width: 768px) and (max-width: 800px) {\n  .btn {\n    font-size: 11px !important;\n    margin-bottom: 3px !important; } }\n\n.btn-group .dropdown-menu {\n  min-width: 200px; }\n  .btn-group .dropdown-menu > li > a {\n    padding: 5px 15px; }\n    .btn-group .dropdown-menu > li > a:hover {\n      background-color: #f5f5f5; }\n\n.btn-group .input-group .form-control {\n  height: 34px;\n  border-right: 0; }\n\n.btn-group .input-group .btn {\n  height: 34px;\n  border-left: 0; }\n  .btn-group .input-group .btn.dropdown-toggle::after {\n    margin-left: 5px; }\n\n.transfer-icon-style {\n  width: 22px !important;\n  margin-bottom: 2px !important; }\n\n.route-settings-popover {\n  min-width: 250px;\n  padding: 5px; }\n  .route-settings-popover .setting-label {\n    font-size: 10px;\n    color: #666;\n    margin-bottom: 0px;\n    white-space: nowrap; }\n  .route-settings-popover .setting-value {\n    font-size: 13px;\n    color: #337ab7; }\n  .route-settings-popover .border-right {\n    border-right: 1px solid #eee; }\n  .route-settings-popover .border-top {\n    border-top: 1px solid #eee; }\n  .route-settings-popover .padding-top-5 {\n    padding-top: 5px; }\n  .route-settings-popover .margin-top-5 {\n    margin-top: 5px; }\n\n.route-ert {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 3px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  font-size: 12px;\n  line-height: 1;\n  color: #555; }\n  .route-ert .ert-item,\n  .route-ert .errt-item {\n    display: inline-flex;\n    align-items: center;\n    white-space: nowrap;\n    margin-right: 0;\n    font-weight: normal; }\n    .route-ert .ert-item .glyphicon,\n    .route-ert .errt-item .glyphicon {\n      position: static;\n      top: auto;\n      margin-right: 4px;\n      font-size: 12px;\n      line-height: 1;\n      color: #555; }\n    .route-ert .ert-item .label-text,\n    .route-ert .errt-item .label-text {\n      margin-right: 4px;\n      font-weight: bolder;\n      color: #555; }\n    .route-ert .ert-item .value-text,\n    .route-ert .errt-item .value-text {\n      font-weight: normal;\n      color: #555; }\n", ""]);

// exports


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".dd-z-index {\n  z-index: 999; }\n\n.completed-date-width {\n  width: 16%; }\n\n.btn-margin-top-25 {\n  margin-top: 25px; }\n\n.btn-height-33 {\n  height: 33px; }\n\n.rp-margin-top-10 {\n  margin-top: 10px; }\n\n.remove-margin-top {\n  margin-top: -23px; }\n\n.route-details-style {\n  padding: 20px;\n  font-size: 15px; }\n\n.no-mb-form .form-group {\n  margin-bottom: 0px; }\n\n.route-link-btn {\n  cursor: pointer; }\n\n.route-link-btn:hover {\n  text-decoration: underline; }\n\n.shipment-hold-badge-color {\n  background: orange !important; }\n\n.location-position {\n  text-align: left; }\n\n.progress-bar-value {\n  margin-top: 5px;\n  font-size: 16px;\n  white-space: nowrap; }\n\n.seq-col-width {\n  width: 6%; }\n\n.order-col-width {\n  width: 7%; }\n\n.status-col-width {\n  width: 8%; }\n\n.mh-45 {\n  min-height: 35px !important; }\n\n.loader_center {\n  width: 100%;\n  margin: auto;\n  display: flow-root; }\n\n@media (min-width: 767px) and (max-width: 880px) {\n  .mh-45 {\n    min-height: 45px !important; }\n  .route_progress_table .table {\n    font-size: 13px !important; }\n  .route_progress_table .d-th-8 {\n    width: 8% !important; }\n  .route_progress_table .d-th-9 {\n    width: 9% !important; }\n  .route_progress_table .d-th-18 {\n    width: 18% !important; } }\n\n@media (min-width: 1020px) and (max-width: 1100px) {\n  .mh-45 {\n    min-height: 45px !important; }\n  .route_progress_table .table {\n    font-size: 13px !important; }\n  .route_progress_table .d-th-8 {\n    width: 8% !important; }\n  .route_progress_table .d-th-9 {\n    width: 9% !important; }\n  .route_progress_table .d-th-18 {\n    width: 18% !important; } }\n\n.partial-status-color {\n  color: #c46210; }\n\n.transaction-count-bg-color {\n  background-color: #5cb85c !important; }\n\n.transaction-count-badge .badge {\n  padding: 4px 7px;\n  border-radius: 6px;\n  margin-left: 2px;\n  margin-bottom: 1px; }\n\n.direction-icon {\n  width: 22px; }\n\n.shipment-delivered-count-bg-color {\n  background-color: #5cb85c !important; }\n\n.shipment-pickup-count-bg-color {\n  background-color: #ec971f !important; }\n\n.ert-erm-container {\n  display: flex;\n  align-items: center;\n  background-color: #f9f9f9;\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 10px;\n  gap: 30px;\n  justify-content: space-between; }\n  .ert-erm-container .ert-erm-item {\n    display: flex;\n    align-items: flex-start;\n    font-size: 14px; }\n    .ert-erm-container .ert-erm-item i {\n      margin-right: 8px;\n      color: #555;\n      font-size: 16px;\n      top: 2px; }\n    .ert-erm-container .ert-erm-item button.btn-primary i {\n      color: #ffffff; }\n    .ert-erm-container .ert-erm-item i.glyphicon-refresh {\n      margin-right: 0; }\n    .ert-erm-container .ert-erm-item .label-text {\n      font-weight: bold;\n      margin-right: 5px;\n      color: #333; }\n    .ert-erm-container .ert-erm-item .value-text {\n      color: #000;\n      font-weight: 500; }\n", ""]);

// exports


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".route-stats #map {\n  height: calc(100vh - 75px); }\n\n.route-stats .map-padd {\n  padding: 0 5px; }\n\n.route-stats .route-list {\n  height: calc(100vh - 80px);\n  overflow-y: auto;\n  padding-left: 10px;\n  margin-left: 0; }\n\n.route-stats .timeline {\n  position: relative;\n  border-color: rgba(160, 175, 185, 0.5);\n  padding: 0;\n  margin: 0; }\n\n.route-stats .tl-item {\n  border-radius: 3px;\n  position: relative;\n  display: -ms-flexbox;\n  display: grid;\n  grid-template-columns: 0.2fr 1fr;\n  cursor: pointer; }\n\n.route-stats .tl-item:hover .tl-dot:before {\n  border-color: #448bff;\n  box-shadow: 0 0 0 4px rgba(68, 139, 255, 0.2); }\n\n.route-stats .tl-item:hover .tl-content {\n  background: #f7f1f1; }\n\n.route-stats .tl-item > * {\n  padding: 5px 5px; }\n\n.route-stats .tl-item:last-child .tl-dot:after {\n  display: none; }\n\n.route-stats .tl-item.active .tl-dot:before {\n  border-color: #448bff;\n  box-shadow: 0 0 0 4px rgba(68, 139, 255, 0.2); }\n\n.route-stats .tl-item:last-child .tl-dot:after {\n  display: none; }\n\n.route-stats .tl-item.active .tl-dot:before {\n  border-color: #448bff;\n  box-shadow: 0 0 0 4px rgba(68, 139, 255, 0.2); }\n\n.route-stats .tl-dot {\n  position: relative;\n  border-color: rgba(160, 175, 185, 0.4); }\n\n.route-stats .tl-dot:after,\n.route-stats .tl-dot:before {\n  content: '';\n  position: absolute;\n  border-color: inherit;\n  border-width: 2px;\n  border-style: solid;\n  border-radius: 50%;\n  width: 10px;\n  height: 10px;\n  top: 15px;\n  left: 50%;\n  transform: translateX(-50%); }\n\n.route-stats .tl-dot:after {\n  width: 0;\n  height: auto;\n  top: 25px;\n  bottom: -15px;\n  border-right-width: 0;\n  border-top-width: 0;\n  border-bottom-width: 0;\n  border-radius: 0; }\n\n.route-stats .tl-item.active .tl-dot:before {\n  border-color: #448bff;\n  box-shadow: 0 0 0 4px rgba(68, 139, 255, 0.2); }\n\n.route-stats .tl-dot {\n  position: relative;\n  border-color: rgba(160, 175, 185, 0.4); }\n\n.route-stats .tl-dot:after {\n  content: '';\n  position: absolute;\n  border-color: inherit;\n  border-width: 2px;\n  border-style: dashed;\n  border-radius: 50%;\n  width: 10px;\n  height: 10px;\n  top: 15px;\n  left: 50%;\n  transform: translateX(-50%); }\n\n.route-stats .tl-dot:after {\n  width: 0;\n  height: auto;\n  top: 25px;\n  bottom: -15px;\n  border-right-width: 0;\n  border-top-width: 0;\n  border-bottom-width: 0;\n  border-radius: 0; }\n\n.route-stats .tl-content p:last-child {\n  margin-bottom: 0; }\n\n.route-stats .location-shipment-info-panel {\n  height: 100%;\n  width: 0;\n  position: unset;\n  z-index: 1;\n  top: 70px;\n  right: 0;\n  box-shadow: 1px 3px 6px rgba(14, 12, 12, 0.3);\n  overflow-x: hidden;\n  transition: 0.5s;\n  padding: 0; }\n\n.route-stats .panel-head-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 5px;\n  border-bottom: 1px solid #a9a8a8;\n  padding: 5px 10px; }\n\n.route-stats .history .tl-item {\n  display: flex;\n  align-items: baseline;\n  gap: 10px; }\n\n.route-stats .location-title {\n  font-weight: bold; }\n\n.route-stats .gap-10 {\n  gap: 10px; }\n\n.route-stats .content-scroll {\n  height: calc(100vh - 135px);\n  overflow-y: auto;\n  padding: 5px 10px; }\n\n.route-stats .shipment-details {\n  border-bottom: 1px dashed #ccc;\n  margin-bottom: 3px; }\n\n.route-stats .dot {\n  font-weight: 600; }\n\n.route-stats .title-tracking-id {\n  font-weight: bold;\n  margin-bottom: 5px;\n  padding-left: 5px; }\n\n.route-stats .panel-heading {\n  cursor: pointer; }\n\n.route-stats .font-weight-600 {\n  font-weight: 600;\n  color: #555; }\n\n.route-stats .section-header {\n  background-color: #dcdcdc;\n  padding: 10px; }\n\n.route-stats .section-content,\n.route-stats .trans-history {\n  padding: 8px 8px; }\n\n.route-stats .panel {\n  margin-bottom: 2px;\n  padding: 5px; }\n\n.route-stats .route-list,\n.route-stats .route-list .panel-heading {\n  list-style: none;\n  cursor: pointer;\n  padding: 0 5px;\n  margin-bottom: 2px;\n  border: none; }\n\n.route-stats .route-list-item:hover,\n.route-stats .route-list-item.active {\n  background: #f7f1f1; }\n\n.route-stats .history-section .line {\n  display: block;\n  margin-bottom: 10px; }\n\n.route-stats .history-section .line p {\n  text-align: center;\n  border-bottom: 1px solid #ccc;\n  position: relative; }\n\n.route-stats .history-section .line p span {\n  background-color: white;\n  position: relative;\n  top: 10px;\n  padding: 0 10px; }\n\n.route-stats .left-route-section {\n  width: 300px; }\n\n.route-stats .right-map-section {\n  width: auto;\n  padding: 0 5px; }\n\n.route-stats .location-activity-section {\n  padding: 8px 8px !important; }\n\n.route-stats .hold-status-color {\n  color: orange !important; }\n\n.route-stats .unassigned-status-color {\n  color: red !important; }\n\n.route-stats .assigned-status-color {\n  color: #2d78b9 !important; }\n\n.route-stats .complete-status-color {\n  color: green !important; }\n\n.route-stats .accepted-status-color {\n  color: #718123 !important; }\n\n.route-stats .on-route-status-color {\n  color: #426776 !important; }\n\n.route-stats .on-site-status-color {\n  color: #ff8fe9 !important; }\n\n.route-stats .cancelled-status-color {\n  color: #a3a3a3 !important; }\n\n#scroll-effect::-webkit-scrollbar-track,\n#scroll-effect-sidebar::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);\n  background-color: #F5F5F5; }\n\n#scroll-effect::-webkit-scrollbar,\n#scroll-effect-sidebar::-webkit-scrollbar {\n  width: 5px;\n  background-color: #F5F5F5; }\n\n#scroll-effect::-webkit-scrollbar-thumb,\n#scroll-effect-sidebar::-webkit-scrollbar-thumb {\n  background-color: #5c6bc0;\n  border: 2px solid #5c6bc0; }\n", ""]);

// exports


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".align-center-horizontally {\n  display: flex;\n  display: -ms-flexbox;\n  justify-content: center; }\n\n.margin-left-20 {\n  margin-left: 20px !important; }\n\n.margin-top-5 {\n  margin-top: 5px !important; }\n\n.text-size-15 {\n  font-size: 15px; }\n\n.margin-top-20-datepicker {\n  margin-top: -20px !important; }\n\n.bold-font {\n  font-weight: bold; }\n", ""]);

// exports


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".margin-right-10 {\n  margin-right: 10px; }\n\n.align-center-vertically {\n  display: flex;\n  display: -ms-flexbox;\n  align-items: center; }\n\n.icon-padding-05 {\n  padding: 5px; }\n\n.branch-margin-top {\n  margin-top: -9px; }\n\n.span-border-right {\n  border-right: solid 2px;\n  padding-right: 5px; }\n\n.route-history-badge {\n  border-radius: 4px !important;\n  background-color: #5cb85c !important;\n  font-size: 13px !important;\n  padding-left: 0px; }\n\n.route-display-section .list-group-item {\n  padding: 8px 12px !important; }\n\n.route-history-alert-section .alert {\n  padding: 10px !important; }\n\n.route-history-pagination-section .pagination {\n  display: block !important; }\n\n.span-border-left {\n  border-left: solid 2px;\n  padding-left: 5px; }\n", ""]);

// exports


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "li.display-flex {\n  display: flex;\n  display: -ms-flexbox; }\n\nul.location-sequence {\n  list-style-type: none; }\n\nli.dndPlaceholder {\n  background: #eee;\n  height: 50px; }\n\n.leaf-map {\n  height: 500px; }\n\n.inactive-location {\n  color: gray; }\n\n.list-highlight {\n  background-color: #dff5df !important; }\n\n.remove-z-index {\n  z-index: 0; }\n\n.display-none-td-cell {\n  border: none !important;\n  background-color: white !important; }\n\n.route-tanker-assignment-section .searchandselect .header {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: auto;\n  white-space: normal; }\n\n.toggle-grid-container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 15px; }\n\n.toggle-grid-container .width-85, .toggle-grid-container .time-picker-input {\n  width: 85% !important; }\n\n.pickup-manifest-recipient-email-container .form-control {\n  padding: 5px 5px; }\n\n.route-day-line-section {\n  margin-top: 5px !important;\n  margin-bottom: 5px !important; }\n\n.no-spinner::-webkit-outer-spin-button,\n.no-spinner::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0; }\n\n.no-spinner[type=number] {\n  -moz-appearance: textfield;\n  appearance: textfield; }\n", ""]);

// exports


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".w-60 {\n  list-style: none;\n  padding: 0;\n  margin: 0; }\n\n.d-a-flex {\n  display: flex;\n  align-items: center; }\n\n.d-flex {\n  display: flex; }\n\n.response-no-input {\n  width: 50px !important;\n  margin-right: 10px; }\n\n.ml-5 {\n  margin-left: 5px; }\n\n.orange-thres-hold .input-group-btn .btn {\n  background-color: orange;\n  border-color: orange; }\n\n.orange-thres-hold .input-group-btn .btn:hover {\n  background-color: orange;\n  border-color: orange; }\n\n.yellow-thres-hold .input-group-btn .btn {\n  background-color: #ffd300;\n  border-color: #ffd300; }\n\n.yellow-thres-hold .input-group-btn .btn:hover {\n  background-color: #ffd300;\n  border-color: #ffd300; }\n\n.blue-thres-hold .input-group-btn .btn {\n  background-color: #337ab7;\n  border-color: #337ab7; }\n\n.blue-thres-hold .input-group-btn .btn:hover {\n  background-color: #337ab7;\n  border-color: #337ab7; }\n\n.toggle-width-20 {\n  width: 20% !important; }\n\n.threshold-error {\n  width: 96%;\n  margin-top: 10px; }\n\n.time-picker-width .dropdown-menu {\n  min-width: 125px !important; }\n\n.root-cause-container {\n  margin-top: 8px; }\n", ""]);

// exports


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".atm-make-status-toggle {\n  margin-left: 10px;\n  margin-right: 10px; }\n\n.atm-makes-table th,\n.atm-makes-table td {\n  vertical-align: middle !important; }\n\n.atm-make-name-cell {\n  min-width: 220px; }\n\n.atm-make-status-cell {\n  min-width: 150px;\n  text-align: center; }\n\n.atm-make-status-text {\n  font-weight: 600;\n  margin-bottom: 6px; }\n", ""]);

// exports


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".service-checklist-style-section .hr-line {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important; }\n\n.service-checklist-style-section .text-input-section {\n  width: 90px !important;\n  margin-left: 10px;\n  margin-right: 10px; }\n\n.service-checklist-style-section .sort-order-input {\n  width: 50px !important; }\n\n.service-checklist-style-section .remove-right-margin {\n  margin-right: 0px; }\n", ""]);

// exports


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".map-z-index {\n  z-index: 000; }\n\n.tbl-header-color {\n  background-color: #E6E6E6; }\n\n.badge-bg-color {\n  background-color: #3f81ba !important; }\n\n.expand-panel-width {\n  width: 1% !important; }\n\n.remove-bottom-pad {\n  margin-bottom: 0px !important; }\n\n.expand-btn-style {\n  padding: 3px !important;\n  text-align: center; }\n\n.inner-tbl-margin-bottom {\n  margin-bottom: 8px !important; }\n\n.service-location-width {\n  max-width: 190px; }\n\n.open-time-color {\n  color: #2d72ad; }\n\n.action-btn-position {\n  text-align: center;\n  white-space: nowrap; }\n\n.bucket-icon-width {\n  width: 20px; }\n\n.hold-bucket-color {\n  background-color: orange !important; }\n\n.unassigned-bucket-color {\n  background-color: red !important; }\n\n.assigned-bucket-color {\n  background-color: #2d78b9 !important; }\n\n.complete-bucket-color {\n  background-color: green !important; }\n\n.accepted-bucket-color {\n  background-color: #718123 !important; }\n\n.on-route-bucket-color {\n  background-color: #426776 !important; }\n\n.on-site-bucket-color {\n  background-color: #ff8fe9 !important; }\n\n.pending-checkout-bucket-color {\n  background-color: purple !important; }\n\n.cant-completed-bucket-color {\n  background-color: #e06603 !important; }\n\n.cancelled-bucket-color {\n  background-color: #a3a3a3 !important; }\n\n.pending-assign-bucket-color {\n  background-color: #593869 !important; }\n\n.padding-bottom-50 {\n  padding-bottom: 50px !important; }\n\n.pending-messenger-accept-bucket-color {\n  background-color: purple !important; }\n\n.unaccepted-bucket-color {\n  background-color: #9f3437 !important; }\n\n.log-details-width-35 {\n  width: 35%; }\n\n.user-branch-search-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 350px !important;\n  overflow-y: auto !important;\n  min-width: 96%; }\n\n.tools-d-flex-end {\n  display: flex;\n  justify-content: flex-end; }\n\n.panel-title-center {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 16px;\n  color: inherit;\n  display: flex;\n  align-items: center; }\n\n.ticket-daterange-picker {\n  font-size: 14px !important;\n  height: 25px !important;\n  width: 185px !important;\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n  margin-right: 10px !important; }\n\n.no-data-margin-10 {\n  margin: 10px !important;\n  width: 98%; }\n\n.bucket-search {\n  background-color: #fff !important;\n  border: 1px solid #ccc !important;\n  height: 45px !important;\n  font-size: 17px !important; }\n\n.threshold-badge {\n  border-radius: inherit !important;\n  color: #000000 !important;\n  background-color: #ffffff !important;\n  border: black !important;\n  margin-left: -5px;\n  margin-bottom: 1px;\n  height: 14px;\n  padding: 2px 6px !important; }\n\n.thres-hold-yellow {\n  background-color: #ffd300; }\n\n.thres-hold-red {\n  background-color: #ff4100f0 !important; }\n\n.thres-hold-orange {\n  background-color: #ff9400 !important; }\n\n.last-updated-time {\n  margin-top: 28px;\n  font-size: 18px; }\n\n.justify-space-between {\n  justify-content: space-between; }\n\n.service-tickets-btn-row {\n  align-items: center; }\n  .service-tickets-btn-row > ._form-group {\n    margin-right: 10px; }\n  .service-tickets-btn-row > .setting-switch-section {\n    margin-right: 0; }\n\n@media (min-width: 767px) and (max-width: 880px) {\n  .setting-switch-section .bootstrap-switch {\n    width: 95px !important; }\n  .setting-switch-section .bootstrap-switch-label {\n    width: 0px !important; }\n  .last-updated-time {\n    margin-top: 28px;\n    font-size: 16px !important; }\n  .panel-title {\n    font-size: 13px !important; } }\n\n@media (min-width: 900px) and (max-width: 1100px) {\n  .last-updated-time {\n    margin-top: 28px;\n    font-size: 17px !important; } }\n\n.ex-lbl-section {\n  background-color: #5cb85c;\n  border: 1px solid;\n  border-radius: 4px;\n  color: aliceblue;\n  font-size: 12px;\n  height: 20px;\n  width: 25px;\n  text-align: center;\n  font-weight: 500; }\n\n.action-code-w-150 {\n  max-width: 150px; }\n\n.encounter-id-w-90 {\n  width: 90px; }\n\n.priority-alert-row td {\n  background-color: #fff4f2; }\n\n.priority-48hr-row td {\n  background-color: rgba(255, 193, 7, 0.14); }\n\n.priority-72hr-row td {\n  background-color: rgba(121, 16, 153, 0.08); }\n\n.ticket-priority-meta {\n  margin-top: 4px; }\n\n.ticket-priority-pill {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 12px;\n  background-color: #e8eef5;\n  color: #29465f;\n  font-size: 11px;\n  font-weight: 600; }\n\n.ticket-priority-pill-alert {\n  background-color: #eb3137;\n  color: #fff; }\n\n.ticket-priority-pill-48hr {\n  background-color: rgba(255, 193, 7, 0.7);\n  color: #000; }\n\n.ticket-priority-pill-72hr {\n  background-color: rgba(121, 16, 153, 0.6);\n  color: #fff; }\n\n.ticket-priority-subtext {\n  margin-top: 4px;\n  font-size: 11px;\n  line-height: 1.3;\n  color: #5f6b77; }\n\n.ticket-priority-overdue {\n  color: #c9302c;\n  font-weight: 600; }\n\n.txt-color-white {\n  color: #eeeeee; }\n\n.forced-txt-white {\n  color: #ffffff !important; }\n\n.width-85 {\n  width: 85px; }\n\n.history-details-section {\n  width: 330px; }\n", ""]);

// exports


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "ul.nav.nav-tabs li {\n  cursor: pointer; }\n\nul.nav.nav-tabs li.active {\n  pointer-events: none; }\n\nul.nav.nav-pills li {\n  cursor: pointer; }\n", ""]);

// exports


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .show-only-in-print {\n    display: block !important; }\n  .print-margin-top-20 {\n    margin-top: 20px !important; }\n  .print-margin-bottom-20 {\n    margin-bottom: 20px !important; }\n  .remove-print-margin {\n    margin-top: 0px !important; }\n  .barcode-print-page {\n    width: calc(100% / 3 * 3);\n    height: fit-content;\n    display: flex;\n    flex-wrap: wrap; }\n  .barcode-row {\n    width: calc(100% / 3);\n    display: 150px;\n    margin-top: 25px; }\n  .complete-barcode-print-page {\n    width: calc(100% / 3 * 3);\n    height: fit-content;\n    display: flex;\n    flex-wrap: wrap; }\n  .complete-barcode-row {\n    width: calc(100% / 3);\n    display: 150px;\n    margin-top: 25px; }\n  .complete-pre-print-tracking-id-location {\n    font: 11px monospace;\n    margin-top: -7px; }\n  .pre-print-tracking-id-location {\n    font: 11px monospace;\n    margin-top: -7px; }\n  .col-print-1 {\n    width: 8% !important;\n    float: left !important; }\n  .col-print-2 {\n    width: 17% !important;\n    float: left !important; }\n  .col-print-3 {\n    width: 25% !important;\n    float: left !important; }\n  .col-print-4 {\n    width: 33% !important;\n    float: left !important; }\n  .col-print-5 {\n    width: 42% !important;\n    float: left !important; }\n  .col-print-6 {\n    width: 50% !important;\n    float: left !important; }\n  .col-print-7 {\n    width: 58% !important;\n    float: left !important; }\n  .col-print-8 {\n    width: 67% !important;\n    float: left !important; }\n  .col-print-9 {\n    width: 75% !important;\n    float: left !important; }\n  .col-print-10 {\n    width: 83% !important;\n    float: left !important; }\n  .col-print-11 {\n    width: 92% !important;\n    float: left !important; }\n  .col-print-12 {\n    width: 100% !important;\n    float: left !important; }\n  .pagebreak {\n    page-break-after: always;\n    clear: both; } }\n\n.shipment-info {\n  position: absolute !important;\n  bottom: 0; }\n\n.margin-top-30 {\n  margin-top: 30px; }\n\n.margin-bottom-50 {\n  margin-bottom: 50px; }\n\n.tracking-id-labels .barcode {\n  height: 95px;\n  padding-left: 0px;\n  justify-content: center;\n  align-items: center; }\n\n.barcode-print-page {\n  width: 100%;\n  height: fit-content;\n  /* Or a specific height */\n  display: flex;\n  flex-wrap: wrap; }\n\n.barcode-row {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 35px; }\n\n.barcode-column {\n  width: calc(100% / 3);\n  /* Adjust to fit 3 columns */\n  height: 150px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly; }\n\n.complete-barcode-print-page {\n  width: 100%;\n  height: fit-content;\n  /* Or a specific height */\n  display: flex;\n  flex-wrap: wrap; }\n\n.complete-barcode-row {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 35px; }\n\n.complete-barcode-column {\n  width: calc(100% / 3);\n  /* Adjust to fit 3 columns */\n  height: 150px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly; }\n\n.complete-pre-print-tracking-id-location {\n  font: 11px monospace;\n  margin-top: -7px; }\n\n.complete-tracking-id-labels .barcode {\n  height: 95px;\n  padding-left: 0px;\n  justify-content: center;\n  align-items: center; }\n\n.pre-print-tracking-id-location {\n  font: 11px monospace;\n  margin-top: -7px; }\n\n.print-delivery-date-font-size {\n  font-size: 13px; }\n", ""]);

// exports


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n.margin-bottom-20 {\n  margin-bottom: 20px; }\n\n.border-bottom-2 {\n  border-bottom: 2px solid #DDDDDD; }\n\n.margin-bottom-10 {\n  margin-bottom: 10px !important; }\n\n.batch-shipment tbody.scroll-content {\n  display: block;\n  height: 300px;\n  max-height: 350px;\n  overflow-y: scroll; }\n\n.batch-shipment tbody.scroll-content::-webkit-scrollbar {\n  width: 10px; }\n\n.batch-shipment tbody.scroll-content::-webkit-scrollbar-button {\n  display: none; }\n\n.batch-shipment tbody.scroll-content::-webkit-scrollbar-track-piece {\n  background: #eee; }\n\n.batch-shipment tbody.scroll-content::-webkit-scrollbar-thumb {\n  background: #ccc; }\n\n.batch-shipment ​\ntbody.scroll-content:hover::-webkit-scrollbar-thumb {\n  background: #888; }\n\n.batch-shipment ​\nthead, .batch-shipment tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed; }\n\n.wrap-text {\n  word-wrap: break-word; }\n\n.coin-entry {\n  width: 35px;\n  padding: 2px !important; }\n  .coin-entry input[type='number'] {\n    -moz-appearance: textfield; }\n  .coin-entry input::-webkit-outer-spin-button,\n  .coin-entry input::-webkit-inner-spin-button {\n    -webkit-appearance: none; }\n\n.coin-entry input {\n  padding: 2px;\n  text-align: center; }\n\n.col-width-80 {\n  width: 80px;\n  padding: 2px !important; }\n\n.col-width-50 {\n  width: 50px;\n  padding: 2px !important; }\n\n.padding-horizontal-29 {\n  padding: 0 29px !important; }\n\n.col-width-100 {\n  width: 100px;\n  padding: 2px !important; }\n\n.col-width-110 {\n  width: 110px;\n  padding: 2px !important; }\n\n.col-width-60 {\n  width: 60px;\n  padding: 2px !important; }\n\n.text-center {\n  text-align: center; }\n\n.width-415 div.modal-content {\n  width: 415px; }\n\n.popover-z-index-auto {\n  z-index: 2 !important; }\n\n.padding-20-10 {\n  padding: 20px 10px !important; }\n\n@media (max-width: 767px) {\n  .from-location {\n    width: 100% !important; } }\n\n@media (min-width: 768px) {\n  .from-location {\n    max-width: 20% !important; } }\n\n@media (max-width: 767px) {\n  div.action-buttons {\n    width: 100% !important; }\n    div.action-buttons div.btn-group {\n      width: 100%; }\n      div.action-buttons div.btn-group button {\n        width: 25%; } }\n\n@media (min-width: 768px) {\n  div.action-buttons {\n    width: 30% !important; }\n    div.action-buttons div.btn-group {\n      float: right; } }\n\n.btn-group.buttongroup {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; }\n\n.margin-bottom-5 {\n  margin-bottom: 5px; }\n\n.shipment-batch-top-section {\n  display: flex;\n  justify-content: space-between; }\n\n.shipment-batch-col-width-20 {\n  width: 20px;\n  padding: 2px !important; }\n\n.shipment-batch-col-width-25 {\n  width: 25px;\n  padding: 2px !important; }\n\n.shipment-batch-col-width-80 {\n  width: 80px;\n  padding: 2px !important; }\n\n.shipment-batch-col-width-70 {\n  width: 105px;\n  padding: 2px !important; }\n\n.shipment-batch-col-width-150 {\n  width: 150px;\n  padding: 2px !important; }\n\n.shipment-batch-col-width-75 {\n  width: 75px;\n  padding: 2px !important; }\n\n.shipment-batch-col-width-65 {\n  width: 65px;\n  padding: 2px !important; }\n\n.shipment-batch-col-width-100 {\n  width: 100px;\n  padding: 2px !important; }\n\n.shipment-batch-col-width-140 {\n  width: 140px;\n  padding: 2px !important; }\n\n.shipment-batch-line-section {\n  margin-top: 5px !important;\n  margin-bottom: 10px !important; }\n\n.margin-bottom-06 {\n  margin-bottom: 6px !important; }\n\n.margin-top-06 {\n  margin-top: 6px !important; }\n\n.shipment-batch-assignment-section .searchandselect .header {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: auto;\n  white-space: normal;\n  word-break: break-all; }\n\n.shipment-route-assignment-section input[type=\"text\"] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: auto;\n  white-space: normal;\n  word-break: break-all; }\n\n.from-location .valid-multi-select-value .multiSelect .checkBoxContainer {\n  overflow-y: auto;\n  max-height: 200px;\n  overflow-x: hidden; }\n\n.batch-controls-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px; }\n\n.amount-toggle-wrapper {\n  display: flex;\n  align-items: center; }\n  .amount-toggle-wrapper label {\n    margin-right: 10px;\n    margin-bottom: 0; }\n", ""]);

// exports


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".margin-top-01 {\n  margin-top: 1px; }\n\n.margin-top-06 {\n  margin-top: 6px !important; }\n", ""]);

// exports


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".txt-input-height-25 {\n  height: 25px !important; }\n\n.customer-history-bg {\n  background: #8fc4e8; }\n\n.text-color-white {\n  color: white; }\n\n.customer-cu-history .list-group-item {\n  padding: 8px 14px !important; }\n\n.customer-cu-history-badge {\n  border-radius: 4px !important;\n  background-color: #228B22 !important;\n  font-size: 13px !important; }\n\n.table-margin-bottom-0 {\n  margin-bottom: 0px !important; }\n\n.table-margin-bottom-09 {\n  margin-bottom: -9px !important; }\n\n.customer-cu-history-bg {\n  background: #93C572; }\n\n.history-badge-section {\n  padding: 4px; }\n", ""]);

// exports


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".billing-rules-border {\n  border: 1px solid;\n  border-color: lightgrey; }\n\n.billing-threshold-input-section {\n  padding: 0px 3px !important; }\n\n.billing-rules-margin-top-10 {\n  margin-top: 10px !important; }\n\n.remove-billing-rules-btn-section {\n  top: 22px; }\n\n.customer-contract-margin-bottom-50 {\n  margin-bottom: 50px !important; }\n\n.billing-rules-status {\n  text-align: right;\n  margin-top: -1px !important; }\n\n.billing-rules-status-label {\n  font-size: 16px !important; }\n  .billing-rules-status-label .label {\n    border-radius: 0px !important; }\n\n.pad-right-02 {\n  padding-right: 2px !important; }\n\n.billing-type-value-section {\n  display: flex;\n  justify-content: center; }\n\n.customer-contract-location-multi-select-dd .multiSelect .checkboxLayer {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  width: 25% !important; }\n\n.customer-contract-location-multi-select-dd .multiSelect .show {\n  display: block !important;\n  right: 15px !important; }\n\n.contract-customer-dd .dropdownone {\n  position: relative !important; }\n\n.contract-type-dd .dropdownone {\n  position: relative !important; }\n", ""]);

// exports


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".contract-edit-style-section .form-border-top {\n  border-top: 1px solid #ccc; }\n\n.contract-edit-style-section .contract-location-multi-select-dd .multiSelect .checkboxLayer {\n  max-height: 300px !important;\n  overflow-y: auto !important; }\n\n.contract-edit-style-section .contract-location-multi-select-dd .multiSelect .show {\n  display: block !important;\n  right: 15px !important; }\n\n.contract-edit-style-section .dndDragging {\n  background-color: #BEEBBE; }\n\n.contract-edit-style-section .navbar-form {\n  display: flex;\n  justify-content: end;\n  flex-wrap: wrap;\n  width: 100%;\n  gap: 10px; }\n\n.contract-edit-style-section .navbar-collapse {\n  width: 100% !important;\n  padding-right: 0px !important; }\n\n.contract-edit-style-section .cus-height {\n  min-height: 550px; }\n\n.contract-edit-style-section .spinner_design {\n  font-size: 30px;\n  padding: 10px 0;\n  text-align: center; }\n\n.contract-edit-style-section form.ng-valid {\n  background-color: transparent !important; }\n\n.contract-edit-style-section .navbar-form .form-control {\n  background-color: transparent !important;\n  border: 1px solid #ccc; }\n\n.contract-edit-style-section .wrap-text {\n  word-break: break-word; }\n", ""]);

// exports


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media print {\n  @page {} }\n\n.extra-details-container {\n  max-width: 400px;\n  word-break: break-word;\n  white-space: wrap; }\n\n.margin-top-30 {\n  margin-top: 30px; }\n", ""]);

// exports


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".txt-input-height-25 {\n  height: 25px !important; }\n\n.customer-location-history-badge {\n  border-radius: 4px !important;\n  background-color: #3289c0 !important;\n  font-size: 13px !important; }\n\n.customer-location-history-bg {\n  background: #8fc4e8; }\n\n.text-color-white {\n  color: white; }\n\n.customer-change-history .list-group-item {\n  padding: 8px 14px !important; }\n\n.customer-contract-history-badge {\n  border-radius: 4px !important;\n  background-color: #228B22 !important;\n  font-size: 13px !important; }\n\n.table-margin-bottom-0 {\n  margin-bottom: 0px !important; }\n\n.table-margin-bottom-09 {\n  margin-bottom: -9px !important; }\n\n.customer-contract-history-bg {\n  background: #93C572; }\n\n.customer-export-location {\n  background-color: #3289c0 !important;\n  color: #fff; }\n\n.customer-location-suspended-history-badge {\n  border-radius: 4px !important;\n  background-color: #a94442 !important;\n  font-size: 13px !important; }\n\n.customer-search-and-export-section {\n  display: flex;\n  justify-content: end;\n  gap: 5px; }\n\n.customer-search-box-height {\n  height: 32px; }\n", ""]);

// exports


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".wrap-text {\n  word-wrap: break-word;\n  word-break: break-all; }\n\n.customer-billing-status .label {\n  margin-bottom: 0px !important; }\n\n.documents-count-badge {\n  border-radius: 4px !important;\n  background-color: white !important;\n  font-size: 13px !important;\n  color: steelblue !important; }\n\n.customer-surcharge-list {\n  padding-left: 15px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start; }\n\n.customer-surcharge-item {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-end;\n  margin: 0 15px 16px 0; }\n  .customer-surcharge-item.col-sm-3 {\n    margin: 0 0 16px 0;\n    padding: 0; }\n  .customer-surcharge-item.customer-surcharge-item-open {\n    flex: 0 0 100%;\n    max-width: 100%;\n    margin: 0 0 16px 0; }\n    .customer-surcharge-item.customer-surcharge-item-open .customer-surcharge-item-fields {\n      flex: 1 1 auto; }\n\n.customer-surcharge-item-fields {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  margin-left: 12px;\n  row-gap: 12px; }\n  .customer-surcharge-item-fields .customer-surcharge-field {\n    flex: 1 1 160px;\n    min-width: 140px; }\n    .customer-surcharge-item-fields .customer-surcharge-field:first-child {\n      flex: 0 0 90px;\n      min-width: 90px; }\n\n.customer-surcharge-field {\n  display: flex;\n  flex-direction: column;\n  margin-right: 12px;\n  min-height: 56px; }\n  .customer-surcharge-field label {\n    font-weight: bold;\n    margin-bottom: 6px;\n    white-space: nowrap; }\n  .customer-surcharge-field input {\n    width: 75px; }\n  .customer-surcharge-field select {\n    width: 100%;\n    max-width: 350px; }\n  .customer-surcharge-field .multi-select {\n    width: 100%;\n    max-width: 350px;\n    position: relative; }\n  .customer-surcharge-field .contract-location-multi-select-dd .multiSelect .checkboxLayer {\n    max-height: 240px !important;\n    overflow-y: auto !important;\n    left: auto !important;\n    right: 0 !important; }\n  .customer-surcharge-field .contract-location-multi-select-dd .multiSelect > button {\n    min-height: 34px !important;\n    height: 34px;\n    background-image: none !important;\n    white-space: nowrap !important;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .customer-surcharge-field .contract-location-multi-select-dd.valid-multi-select-value .multiSelect > button {\n    background-color: #DFF5DF !important;\n    border-color: #BEEBBE !important; }\n  .customer-surcharge-field .contract-location-multi-select-dd.invalid-multi-select-value .multiSelect > button {\n    background-color: #F9E3E3 !important;\n    border-color: #F4C6C6 !important; }\n  .customer-surcharge-field .contract-location-multi-select-dd .multiSelect > button .buttonLabel {\n    display: inline-block;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    vertical-align: middle; }\n", ""]);

// exports


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "table.table.borderless td, table.table.borderless th {\n  border: none; }\n\n.all-documents-count-badge {\n  border-radius: 4px !important;\n  background-color: aliceblue !important;\n  font-size: 13px !important;\n  color: seagreen !important; }\n\n.customer-surcharge-list {\n  padding-left: 15px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  width: '100%' !important; }\n\n.customer-surcharge-item {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-end;\n  margin: 0 15px 0px 0; }\n  .customer-surcharge-item.col-sm-3 {\n    padding: 0; }\n  .customer-surcharge-item.customer-surcharge-item-open {\n    flex: 0 0 100%;\n    max-width: 100%;\n    margin-bottom: 16px; }\n    .customer-surcharge-item.customer-surcharge-item-open .customer-surcharge-item-fields {\n      flex: 1 1 auto; }\n\n.customer-surcharge-item-fields {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  margin-left: 12px;\n  row-gap: 12px; }\n  .customer-surcharge-item-fields .customer-surcharge-field {\n    flex: 1 1 160px;\n    min-width: 140px; }\n    .customer-surcharge-item-fields .customer-surcharge-field:first-child {\n      flex: 0 0 90px;\n      min-width: 90px; }\n\n.customer-surcharge-field {\n  display: flex;\n  flex-direction: column;\n  margin-right: 12px;\n  min-height: 56px; }\n  .customer-surcharge-field label {\n    font-weight: bold;\n    margin-bottom: 6px;\n    white-space: nowrap; }\n  .customer-surcharge-field input {\n    width: 75px; }\n  .customer-surcharge-field select {\n    width: 100%;\n    max-width: 350px; }\n  .customer-surcharge-field .multi-select {\n    width: 100%;\n    max-width: 350px;\n    position: relative; }\n  .customer-surcharge-field .contract-location-multi-select-dd .multiSelect .checkboxLayer {\n    max-height: 240px !important;\n    overflow-y: auto !important;\n    left: auto !important;\n    right: 0 !important; }\n  .customer-surcharge-field .contract-location-multi-select-dd .multiSelect > button {\n    min-height: 34px !important;\n    height: 34px;\n    background-image: none !important;\n    white-space: nowrap !important;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .customer-surcharge-field .contract-location-multi-select-dd.valid-multi-select-value .multiSelect > button {\n    background-color: #DFF5DF !important;\n    border-color: #BEEBBE !important; }\n  .customer-surcharge-field .contract-location-multi-select-dd.invalid-multi-select-value .multiSelect > button {\n    background-color: #F9E3E3 !important;\n    border-color: #F4C6C6 !important; }\n  .customer-surcharge-field .contract-location-multi-select-dd .multiSelect > button .buttonLabel {\n    display: inline-block;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    vertical-align: middle; }\n\n.surcharge-history-filter {\n  margin-bottom: 10px; }\n\n.surcharge-history-nowrap {\n  white-space: nowrap; }\n\n.surcharge-history-changed {\n  font-weight: bold; }\n\n.surcharge-history-button {\n  margin-left: 10px;\n  vertical-align: middle; }\n", ""]);

// exports


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".fuel-surcharge .badge-success {\n  background-color: #28a745 !important; }\n\n.fuel-surcharge .badge-danger {\n  color: #dc3545; }\n\n.fuel-surcharge .badge-info {\n  background-color: #3289c0 !important; }\n\n.fuel-surcharge .fuel-surcharge-list-group {\n  margin-bottom: 10px !important; }\n\n.fuel-surcharge .fuel-surcharge-list {\n  padding: 6px 15px !important; }\n\n.fuel-surcharge .fuel-surcharge-pagination-section .pagination {\n  display: block !important; }\n", ""]);

// exports


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".fuel-surcharge-branch-dd .multiSelect .checkboxLayer {\n  max-height: 350px !important;\n  overflow-y: auto !important; }\n", ""]);

// exports


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".mb-0 {\n  margin-bottom: 10px !important; }\n", ""]);

// exports


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".form-header-title label {\n  font-weight: 700;\n  font-size: 16px; }\n", ""]);

// exports


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".fuel_surcharge .font-size-16 {\n  font-size: 16px; }\n\n.fuel_surcharge .image-height-50 {\n  height: 50px; }\n\n.fuel_surcharge .atm-codes-location {\n  font-size: 16px;\n  margin-bottom: 2px; }\n\n.fuel_surcharge .atm-edit-height {\n  position: absolute;\n  right: 10px;\n  height: 20px; }\n\n.fuel_surcharge .text-align-right {\n  text-align: right; }\n\n.fuel_surcharge .atm-code-box {\n  width: 100px !important;\n  text-align: center; }\n\n.fuel_surcharge .display-inline-block {\n  display: inline-block; }\n\n.fuel_surcharge .margin-top-05 {\n  margin-top: 5px; }\n\n.fuel_surcharge .msg-font-size {\n  font-size: 15px; }\n\n.fuel_surcharge .badge-custome-success {\n  background-color: #5CB85C !important; }\n\n.fuel_surcharge .alert-pad-10 {\n  padding: 10px !important; }\n", ""]);

// exports


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".currency-all .panel {\n  margin-bottom: 20px; }\n\n.currency-all .table-responsive {\n  margin-top: 20px; }\n\n.currency-all .btn-sm {\n  margin-right: 5px; }\n", ""]);

// exports


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".denomination-create-form-style .denom-ui-section {\n  display: flex;\n  justify-content: space-between; }\n", ""]);

// exports


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".face-value-ledger-note {\n  padding: 8px 12px;\n  margin-bottom: 15px;\n  font-size: 14px; }\n  .face-value-ledger-note .glyphicon-info-sign {\n    margin-right: 4px; }\n", ""]);

// exports


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".environment-config-section .fuel-rate-status-section {\n  background: none !important; }\n", ""]);

// exports


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".environment-config .otc-password-icon {\n  top: 17px;\n  position: absolute !important;\n  margin-right: 17px;\n  right: 0;\n  cursor: pointer; }\n\n.environment-config .otc-anywhere-section {\n  display: flex; }\n\n.environment-config .w-95 {\n  width: 95px !important; }\n\n.environment-config .w-12 {\n  width: 12%; }\n\n.environment-config .header-section {\n  margin-top: 15px;\n  font-size: 17px; }\n", ""]);

// exports


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".remove-pad-left {\n  padding-left: 0px !important; }\n\n.remove-pad-right {\n  padding-right: 0px !important; }\n\n.message-type-badge-color {\n  background-color: green !important;\n  margin-bottom: 4px !important; }\n\n.message-type-panel .panel-heading {\n  padding: 8px 14px !important; }\n\n.language-message-type-pagination {\n  padding: 5px 5px; }\n\n.language-message-list-group {\n  padding: 5px 5px !important; }\n  .language-message-list-group .list-group-item {\n    padding: 6px 15px !important; }\n\n.language-message-filter-section {\n  padding-left: 5px !important;\n  padding-right: 5px !important; }\n\n.msg-title-section {\n  margin-top: 16px;\n  margin-left: 5px; }\n\n.language-message-pagination-section .pagination {\n  display: inline-block;\n  margin-left: 5px !important; }\n", ""]);

// exports


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".duplicate-msg-badge {\n  margin-top: 2px;\n  margin-left: 3px;\n  font-size: 14px !important; }\n\n.duplicate-language-message-list-group .list-group-item {\n  padding: 2px 15px !important; }\n\n.duplicate-msg-tooltip {\n  top: 3px !important;\n  margin-left: 2px; }\n", ""]);

// exports


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".app-font-size-15 {\n  font-size: 15px; }\n", ""]);

// exports


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".multiSelect .caret {\n  width: 0 !important;\n  height: 0 !important;\n  margin: 0px 0px 1px 12px !important;\n  vertical-align: middle !important;\n  border-top: 4px solid #333 !important;\n  border-right: 4px solid transparent !important;\n  border-left: 4px solid transparent !important;\n  border-bottom: 0 dotted !important;\n  position: absolute !important;\n  right: 8px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important; }\n\n.multiSelect > button {\n  width: 100% !important;\n  text-align: left !important; }\n\n.valid-create-service-location-types .multiSelect > button {\n  background: #DFF5DF;\n  border-color: #BEEBBE; }\n\n.valid-create-service-location-types .multiSelect > button:hover {\n  background: #DFF5DF;\n  background-image: none;\n  border-color: #BEEBBE; }\n", ""]);

// exports


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "div.col-sm-4 .disabled input {\n  background-color: #eeeeee; }\n\n.edit-setp-title-section {\n  font-family: inherit;\n  font-weight: 500;\n  color: inherit;\n  font-size: 18px; }\n\n.multiSelect .caret {\n  width: 0 !important;\n  height: 0 !important;\n  margin: 0px 0px 1px 12px !important;\n  vertical-align: middle !important;\n  border-top: 4px solid #333 !important;\n  border-right: 4px solid transparent !important;\n  border-left: 4px solid transparent !important;\n  border-bottom: 0 dotted !important;\n  position: absolute !important;\n  right: 8px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important; }\n\n.multiSelect > button {\n  width: 100% !important;\n  text-align: left !important; }\n\n.valid-service-location-types .multiSelect > button {\n  background: #DFF5DF;\n  border-color: #BEEBBE; }\n\n.valid-service-location-types .multiSelect > button:hover {\n  background: #DFF5DF;\n  background-image: none;\n  border-color: #BEEBBE; }\n", ""]);

// exports


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media (min-width: 767px) and (max-width: 1024px) {\n  .font-12 {\n    font-size: 12px !important; } }\n", ""]);

// exports


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".user-permission-all-section .list-group {\n  margin-bottom: 10px !important;\n  padding-left: 0; }\n\n.user-permission-all-section .panel-group {\n  margin-bottom: 10px !important; }\n\n.user-permission-all-section .table-bordered > tbody > tr > td {\n  vertical-align: none !important;\n  border-top: 1px solid #ddd !important;\n  border: none  !important; }\n\n.user-permission-all-section .error-msg-section {\n  margin: 8px;\n  padding: 8px; }\n", ""]);

// exports


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".user-stats-btn-section {\n  float: left;\n  padding: 9px 15px; }\n", ""]);

// exports


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".lock-width-30 {\n  width: 30% !important; }\n\n.toggles-style {\n  align-items: center !important;\n  justify-content: space-between !important;\n  width: 100%; }\n  .toggles-style label {\n    font-weight: bold; }\n\n.branch-funding-src-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 400px !important;\n  overflow-y: auto !important;\n  width: 100% !important; }\n\n.user-multi-select-dd .multiSelect .checkboxLayer {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  width: 320px !important; }\n\n.user-multi-select-dd .multiSelect .show {\n  display: block !important;\n  right: 15px !important; }\n\n.user-branch-multi-select-dd .multiSelect .checkboxLayer {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  width: 97% !important; }\n\n.user-branch-multi-select-dd .multiSelect .show {\n  display: block !important;\n  right: 15px !important; }\n\n.user-service-zone-multi-select-dd .multiSelect .checkboxLayer {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  width: 749px !important;\n  min-width: 320px !important; }\n\n.user-service-zone-multi-select-dd .multiSelect .show {\n  display: block !important;\n  right: 15px !important; }\n\n.user-service-zone-multi-select-dd .valid-multi-select-value button#user-service-zone-multi-select {\n  background: #DFF5DF !important;\n  border-color: #BEEBBE !important; }\n\n.user-service-zone-multi-select-dd .invalid-multi-select-value button#user-service-zone-multi-select {\n  background: #F9E3E3 !important;\n  border-color: #F4C6C6 !important; }\n\n.user-atmmake-dd .multiSelect .checkboxLayer {\n  max-height: 400px !important;\n  overflow-y: auto !important; }\n\n.toggle-field-container label {\n  font-weight: bold;\n  display: block;\n  min-height: 20px;\n  margin-bottom: 5px;\n  white-space: nowrap; }\n\n.toggles-row {\n  display: flex;\n  flex-wrap: wrap; }\n  .toggles-row::before, .toggles-row::after {\n    display: none !important; }\n\n.justify-content-between-add {\n  justify-content: space-between; }\n", ""]);

// exports


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".user-edit-header {\n  border-bottom: 1px solid #eeeeee !important;\n  margin-bottom: 7px !important;\n  min-height: 5rem; }\n\n.btn-margin-top-24 {\n  margin-top: 24px; }\n\n.margin-top-02 {\n  margin-top: 2px; }\n\n.toggles-style {\n  align-items: center !important;\n  justify-content: space-between !important;\n  width: 100%; }\n  .toggles-style label {\n    font-weight: bold; }\n\n.extra-section-css .multi-select span.multiSelect button#multi-select-button {\n  width: 100% !important; }\n\n.user-multi-select-dd .multiSelect .checkboxLayer {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  width: 300px !important; }\n\n.user-multi-select-dd .multiSelect .show {\n  display: block !important;\n  right: 15px !important; }\n\n.user-branch-multi-select-dd .multiSelect .checkboxLayer {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  width: 97% !important; }\n\n.user-branch-multi-select-dd .multiSelect .show {\n  display: block !important;\n  right: 15px !important; }\n\n.user-service-zone-multi-select-dd .multiSelect .checkboxLayer {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  width: 96% !important; }\n\n.user-service-zone-multi-select-dd .multiSelect .show {\n  display: block !important;\n  right: 15px !important; }\n\n.user-service-zone-multi-select-dd .valid-multi-select-value button#user-service-zone-multi-select {\n  background: #DFF5DF !important;\n  border-color: #BEEBBE !important; }\n\n.user-service-zone-multi-select-dd .invalid-multi-select-value button#user-service-zone-multi-select {\n  background: #F9E3E3 !important;\n  border-color: #F4C6C6 !important; }\n\n.edit-branch-funding-src-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 400px !important;\n  overflow-y: auto !important;\n  width: 97% !important; }\n\n.user-atmmake-dd .multiSelect .checkboxLayer {\n  max-height: 400px !important;\n  overflow-y: auto !important; }\n\n.toggle-field-container label {\n  font-weight: bold;\n  display: block;\n  min-height: 20px;\n  margin-bottom: 5px;\n  white-space: nowrap; }\n\n.toggles-row {\n  display: flex;\n  flex-wrap: wrap; }\n  .toggles-row::before, .toggles-row::after {\n    display: none !important; }\n\n.justify-content-between-add {\n  justify-content: space-between; }\n", ""]);

// exports


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".default-redirect-checkbox {\n  margin-right: 5px;\n  margin-top: 0 !important;\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer; }\n\n.permission-item-container {\n  display: flex;\n  align-items: center;\n  gap: 5px; }\n", ""]);

// exports


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".resetBtn {\n  margin-top: 5px; }\n\n.remove-link-btn-pad {\n  padding: 0px !important; }\n\n.searchBox-bg-color {\n  background-color: #ededed !important; }\n\n.vault-close-search-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 350px !important;\n  overflow-y: auto !important;\n  width: 20% !important; }\n", ""]);

// exports


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".vault-operations-search-section {\n  display: flex;\n  justify-content: center; }\n\n.vault-operations-line-section {\n  margin-top: 10px !important;\n  margin-bottom: 5px !important; }\n\n.vault-operations-badge-section {\n  border-radius: 4px !important;\n  background-color: #5cb85c !important;\n  font-size: 13px !important; }\n\n.col-w-13 {\n  width: 13%; }\n\n.col-w-09 {\n  width: 9%; }\n\n.col-w-10 {\n  width: 10%; }\n\n.margin-bottom-40 {\n  margin-bottom: 40px; }\n\n.vault-date-col-width {\n  width: 7%; }\n\n.vault-operation-date-picker-w-23 {\n  width: 23%; }\n\n.vault-operation-branch-dd .multiSelect .checkboxLayer {\n  max-height: 350px !important;\n  overflow-y: auto !important; }\n\n.vault-operation-branch-dd .multiSelect .show {\n  display: block !important; }\n\n.undo-delivery-icon .btn-xs {\n  padding: 0px 1px !important; }\n", ""]);

// exports


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".align-center-horizontally {\n  display: flex;\n  justify-content: center; }\n\n.align-center {\n  display: flex;\n  display: -ms-flexbox;\n  justify-content: center;\n  align-items: center; }\n\n.login-form {\n  top: 33rem; }\n\n.login_form {\n  width: 400px;\n  margin: auto;\n  padding-top: 2rem; }\n\n.download_app h3 {\n  font-weight: 600;\n  font-size: 22px; }\n\n.download_img img {\n  width: 25%;\n  opacity: 0.9;\n  margin: auto; }\n\n.crs-pointer {\n  cursor: pointer; }\n\n.password-warning-section {\n  margin-left: 22px;\n  margin-bottom: 2px; }\n\n.password-warning-section-margin-bottom-10 {\n  margin-bottom: 10px !important; }\n\n.success-message-section {\n  color: green;\n  font-weight: bold;\n  text-align: center; }\n\n.error-message-section {\n  color: red;\n  font-weight: bold;\n  text-align: center; }\n", ""]);

// exports


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "/*!\n * ui-select\n * http://github.com/angular-ui/ui-select\n * Version: 0.19.8 - 2017-04-18T05:43:43.881Z\n * License: MIT\n */.ui-select-highlight{font-weight:700}.ui-select-offscreen{clip:rect(0 0 0 0)!important;width:1px!important;height:1px!important;border:0!important;margin:0!important;padding:0!important;overflow:hidden!important;position:absolute!important;outline:0!important;left:0!important;top:0!important}.selectize-control.single>.selectize-input>input,.selectize-control>.selectize-dropdown{width:100%}.ui-select-choices-row:hover{background-color:#f5f5f5}.ng-dirty.ng-invalid>a.select2-choice{border-color:#D44950}.select2-result-single{padding-left:0}.select-locked>.ui-select-match-close,.select2-locked>.select2-search-choice-close{display:none}body>.select2-container.open{z-index:9999}.ui-select-container.select2.direction-up .ui-select-match,.ui-select-container[theme=select2].direction-up .ui-select-match{border-radius:0 0 4px 4px}.ui-select-container.select2.direction-up .ui-select-dropdown,.ui-select-container[theme=select2].direction-up .ui-select-dropdown{border-radius:4px 4px 0 0;border-top-width:1px;border-top-style:solid;box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-4px}.ui-select-container.select2.direction-up .ui-select-dropdown .select2-search,.ui-select-container[theme=select2].direction-up .ui-select-dropdown .select2-search{margin-top:4px}.ui-select-container.select2.direction-up.select2-dropdown-open .ui-select-match,.ui-select-container[theme=select2].direction-up.select2-dropdown-open .ui-select-match{border-bottom-color:#5897fb}.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden,.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden input{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.selectize-input.selectize-focus{border-color:#007FBB!important}.selectize-control.multi>.selectize-input>input{margin:0!important}.ng-dirty.ng-invalid>div.selectize-input{border-color:#D44950}.ui-select-container[theme=selectize].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-2px}.ui-select-container[theme=selectize] input.ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0;width:0}.btn-default-focus{color:#333;background-color:#EBEBEB;border-color:#ADADAD;text-decoration:none;outline:-webkit-focus-ring-color auto 5px;outline-offset:-2px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.ui-select-bootstrap .ui-select-toggle{position:relative}.ui-select-bootstrap .ui-select-toggle>.caret{position:absolute;height:10px;top:50%;right:10px;margin-top:-2px}.input-group>.ui-select-bootstrap.dropdown{position:static}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control{border-radius:4px 0 0 4px}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control.direction-up{border-radius:4px 0 0 4px!important}.ui-select-bootstrap .ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.ui-select-bootstrap>.ui-select-match>.btn{text-align:left!important}.ui-select-bootstrap>.ui-select-match>.caret{position:absolute;top:45%;right:15px}.ui-select-bootstrap>.ui-select-choices,.ui-select-bootstrap>.ui-select-no-choice{width:100%;height:auto;max-height:200px;overflow-x:hidden;margin-top:-1px}body>.ui-select-bootstrap.open{z-index:1000}.ui-select-multiple.ui-select-bootstrap{height:auto;padding:3px 3px 0}.ui-select-multiple.ui-select-bootstrap input.ui-select-search{background-color:transparent!important;border:none;outline:0;height:1.666666em;margin-bottom:3px}.ui-select-multiple.ui-select-bootstrap .ui-select-match .close{font-size:1.6em;line-height:.75}.ui-select-multiple.ui-select-bootstrap .ui-select-match-item{outline:0;margin:0 3px 3px 0}.ui-select-multiple .ui-select-match-item{position:relative}.ui-select-multiple .ui-select-match-item.dropping .ui-select-match-close{pointer-events:none}.ui-select-multiple:hover .ui-select-match-item.dropping-before:before{content:\"\";position:absolute;top:0;right:100%;height:100%;margin-right:2px;border-left:1px solid #428bca}.ui-select-multiple:hover .ui-select-match-item.dropping-after:after{content:\"\";position:absolute;top:0;left:100%;height:100%;margin-left:2px;border-right:1px solid #428bca}.ui-select-bootstrap .ui-select-choices-row>span{cursor:pointer;display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.ui-select-bootstrap .ui-select-choices-row>span:focus,.ui-select-bootstrap .ui-select-choices-row>span:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.ui-select-bootstrap .ui-select-choices-row.active>span{color:#fff;text-decoration:none;outline:0;background-color:#428bca}.ui-select-bootstrap .ui-select-choices-row.active.disabled>span,.ui-select-bootstrap .ui-select-choices-row.disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.ui-select-match.ng-hide-add,.ui-select-search.ng-hide-add{display:none!important}.ui-select-bootstrap.ng-dirty.ng-invalid>button.btn.ui-select-match{border-color:#D44950}.ui-select-container[theme=bootstrap].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25)}.ui-select-bootstrap .ui-select-match-text{width:100%;padding-right:1em}.ui-select-bootstrap .ui-select-match-text span{display:inline-block;width:100%;overflow:hidden}.ui-select-bootstrap .ui-select-toggle>a.btn{position:absolute;height:10px;right:10px;margin-top:-2px}.ui-select-refreshing.glyphicon{position:absolute;right:0;padding:8px 27px}@-webkit-keyframes ui-select-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes ui-select-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.ui-select-spin{-webkit-animation:ui-select-spin 2s infinite linear;animation:ui-select-spin 2s infinite linear}.ui-select-refreshing.ng-animate{-webkit-animation:none 0s}\n", ""]);

// exports


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__select__ = __webpack_require__(379);



/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__select__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name).call(document.documentElement));
});


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = local;
var nextId = 0;

function local() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};


/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(175);



/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])();
  if (event.changedTouches) event = event.changedTouches[0];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, event);
});


/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection_index__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = (function(selector) {
  return typeof selector === "string"
      ? new __WEBPACK_IMPORTED_MODULE_0__selection_index__["b" /* Selection */]([document.querySelectorAll(selector)], [document.documentElement])
      : new __WEBPACK_IMPORTED_MODULE_0__selection_index__["b" /* Selection */]([selector == null ? [] : selector], __WEBPACK_IMPORTED_MODULE_0__selection_index__["c" /* root */]);
});


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(174);


/* harmony default export */ __webpack_exports__["a"] = (function(name) {
  var create = typeof name === "function" ? name : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
});


/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__namespace__ = __webpack_require__(235);


function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var fullname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__namespace__["a" /* default */])(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
});


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
});


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
});


/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function selection_cloneShallow() {
  return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
}

function selection_cloneDeep() {
  return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
}

/* harmony default export */ __webpack_exports__["a"] = (function(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
});


/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enter__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(1196);




var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["b" /* EnterNode */](parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new __WEBPACK_IMPORTED_MODULE_1__enter__["b" /* EnterNode */](parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new __WEBPACK_IMPORTED_MODULE_0__index__["b" /* Selection */](update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
});


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
});


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window__ = __webpack_require__(240);


function dispatchEvent(node, type, params) {
  var window = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__window__["a" /* default */])(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
});


/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
});


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  return !this.node();
});


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sparse__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(67);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new __WEBPACK_IMPORTED_MODULE_1__index__["b" /* Selection */](this._exit || this._groups.map(__WEBPACK_IMPORTED_MODULE_0__sparse__["a" /* default */]), this._parents);
});


/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher__ = __webpack_require__(378);



/* harmony default export */ __webpack_exports__["a"] = (function(match) {
  if (typeof match !== "function") match = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__matcher__["a" /* default */])(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["b" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
});


/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(238);



function constantNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, before) {
  var create = typeof name === "function" ? name : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(name),
      select = before == null ? constantNull : typeof before === "function" ? before : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
});


/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(lower);
});


/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = (function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["b" /* Selection */](merges, this._parents);
});


/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
});


/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
});


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
});


/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
});


/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(raise);
});


/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.each(remove);
});


/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selector__ = __webpack_require__(238);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selector__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["b" /* Selection */](subgroups, this._parents);
});


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectorAll__ = __webpack_require__(383);



/* harmony default export */ __webpack_exports__["a"] = (function(select) {
  if (typeof select !== "function") select = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__selectorAll__["a" /* default */])(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["b" /* Selection */](subgroups, parents);
});


/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
});


/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (!compare) compare = ascending;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new __WEBPACK_IMPORTED_MODULE_0__index__["b" /* Selection */](sortgroups, this._parents).order();
});

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
});


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(175);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touch);
    }
  }

  return null;
});


/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sourceEvent__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(175);



/* harmony default export */ __webpack_exports__["a"] = (function(node, touches) {
  if (touches == null) touches = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sourceEvent__["a" /* default */])().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__point__["a" /* default */])(node, touches[i]);
  }

  return points;
});


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fd5728f2cf777b06b966d05c0c823dc9.svg";

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "89889688147bd7575d6327160d64e760.svg";

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/favicons/android-chrome-192x192.png";

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/favicons/apple-touch-icon.png";

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/favicons/browserconfig.xml";

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/favicons/favicon-16x16.png";

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/favicons/favicon-32x32.png";

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/favicons/favicon-96x96.png";

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/favicons/favicon.ico";

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/favicons/manifest.json";

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/favicons/mstile-150x150.png";

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/favicons/safari-pinned-tab.svg";

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/$1.png";

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/$10.png";

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/$100.png";

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/$1HL.png";

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/$20.png";

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/$5.png";

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/$50.png";

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/01.png";

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/01B-route-sheet.png";

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/01B.png";

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/01Box.png";

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/01HL.png";

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/01L-route-sheet.png";

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/01L.png";

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/01R.png";

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/05.png";

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/05B-route-sheet.png";

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/05B.png";

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/05Box.png";

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/05HB.png";

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/05HBox.png";

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/05HL.png";

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/05L-route-sheet.png";

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/05L.png";

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/05R.png";

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1$.png";

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1$B-route-sheet.png";

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1$B.png";

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1$L-route-sheet.png";

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1$L.png";

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1$R.png";

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10.png";

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10B-route-sheet.png";

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10B.png";

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10Box.png";

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10H-route-sheet.png";

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10H.png";

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10HB.png";

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10HBox.png";

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10HL.png";

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10HX.png";

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10L-route-sheet.png";

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10L.png";

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10QL.png";

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/10R.png";

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/1DBox.png";

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/25.png";

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/25B-route-sheet.png";

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/25B.png";

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/25Box.png";

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/25HB.png";

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/25HBox.png";

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/25HL.png";

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/25L-route-sheet.png";

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/25L.png";

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/25R.png";

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/50.png";

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/50B-route-sheet.png";

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/50B.png";

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/50Box.png";

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/50HL.png";

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/50L-route-sheet.png";

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/50L.png";

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/50R.png";

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/5HBox.png";

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BBD10.png";

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BBD100.png";

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BBD2.png";

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BBD20.png";

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BBD5.png";

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BBD50.png";

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BSD1.png";

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BSD10.png";

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BSD100.png";

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BSD20.png";

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BSD5.png";

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BSD50.png";

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BULKCASH.png";

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/BULKDEPOSIT.png";

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/C-grey-icon.png";

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/C-icon.png";

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/C-route-sheet.png";

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/C.png";

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CAD10.png";

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CAD100.png";

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CAD20.png";

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CAD5.png";

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CAD50.png";

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CADUNFIT10.png";

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CADUNFIT100.png";

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CADUNFIT20.png";

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CADUNFIT5.png";

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CADUNFIT50.png";

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CHF10.png";

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CHF100.png";

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CHF1000.png";

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CHF20.png";

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CHF200.png";

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CHF50.png";

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CNY1.png";

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CNY10.png";

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CNY100.png";

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CNY20.png";

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CNY5.png";

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CNY50.png";

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/COD.png";

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/CODPayment.png";

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/ChageOrder.png";

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Coin50C.png";

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/D-Icon.png";

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/DEPOSIT.png";

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Doller.png";

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR.png";

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR001.png";

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR002.png";

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR005.png";

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR010.png";

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR020.png";

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR050.png";

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR1.png";

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR10.png";

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR100.png";

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR2.png";

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR20.png";

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR200.png";

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR5.png";

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR50.png";

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EUR500.png";

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EURO.png";

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EURUNFIT10.png";

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EURUNFIT100.png";

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EURUNFIT20.png";

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EURUNFIT200.png";

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EURUNFIT5.png";

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EURUNFIT50.png";

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/EURUNFIT500.png";

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/GBP10.png";

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/GBP20.png";

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/GBP5.png";

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/GBP50.png";

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/HoldIcon.png";

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMD100.png";

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMD1000.png";

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMD2000.png";

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMD50.png";

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMD500.png";

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMD5000.png";

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDBAG1.png";

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDBAG10.png";

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDBAG20.png";

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDBAG5.png";

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDBOX1.png";

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDBOX10.png";

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDBOX20.png";

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDBOX5.png";

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDC1.png";

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDC10.png";

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDC20.png";

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDC5.png";

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDUNFIT100.png";

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDUNFIT1000.png";

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDUNFIT2000.png";

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDUNFIT50.png";

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDUNFIT500.png";

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JMDUNFIT5000.png";

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JPY1000.png";

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JPY10000.png";

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/JPY500.png";

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/KYD1.png";

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/KYD10.png";

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/KYD100.png";

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/KYD25.png";

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/KYD5.png";

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/KYD50.png";

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/M-route-sheet.png";

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/M.png";

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/MAIL.png";

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/MXD-route-sheet.png";

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/MXD.png";

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/MultiDenomCash.png";

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Order_Type_C_Icon.png";

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Order_Type_I_Icon.png";

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Order_Type_P_Icon.png";

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Order_Type_R_Icon.png";

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Order_Type_S_Icon.png";

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Order_Type_T_Icon.png";

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Order_Type_X_Icon.png";

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/P-icon.png";

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/T-icon.png";

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/TTD1.png";

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/TTD10.png";

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/TTD100.png";

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/TTD20.png";

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/TTD5.png";

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/TTD50.png";

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/UNFIT1.png";

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/UNFIT10.png";

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/UNFIT100.png";

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/UNFIT2.png";

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/UNFIT20.png";

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/UNFIT5.png";

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/UNFIT50.png";

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD.png";

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD001.png";

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD005.png";

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD010.png";

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD025.png";

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD1.png";

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD10.png";

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD100.png";

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD1C.png";

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD2.png";

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD20.png";

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD5.png";

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USD50.png";

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDNEW1.png";

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDNEW10.png";

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDNEW100.png";

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDNEW2.png";

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDNEW20.png";

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDNEW5.png";

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDNEW50.png";

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDUNFIT1.png";

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDUNFIT10.png";

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDUNFIT100.png";

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDUNFIT2.png";

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDUNFIT20.png";

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDUNFIT5.png";

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/USDUNFIT50.png";

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/X-route-sheet.png";

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/X.png";

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/XCD1.png";

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/XCD10.png";

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/XCD100.png";

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/XCD20.png";

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/XCD5.png";

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/XCD50.png";

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/arrow-left-on.png";

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/arrow-left.png";

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/arrow-right-on.png";

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/arrow-right.png";

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/attachment-on.png";

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/attachment.png";

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/badge-on.png";

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/badge.png";

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/bag-load.png";

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/bag-residual.png";

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/bag.png";

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/balendar-on.png";

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/balendar.png";

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/cancel-on.png";

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/cancel.png";

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/checkbox-on.png";

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/checkbox.png";

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-$1-on.png";

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-$1-print.png";

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-$1.png";

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-1-on.png";

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-1.png";

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-10-on.png";

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-10.png";

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-25-on.png";

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-25.png";

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-5-on.png";

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-5.png";

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-50.png";

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-bag.png";

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin-misc.png";

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/coin1C.png";

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/compass-on.png";

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/compass.png";

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/direction.png";

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/map-on.png";

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/map.png";

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/marker-icon.png";

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/marker-shadow.png";

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/new-on.png";

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/notify-Off.png";

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/notify-On.png";

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/pending.png";

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/ranger-logo.jpg";

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/recurring-right.png";

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/red-alert.png";

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/stops-on.png";

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/stopwatch-on.png";

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/stopwatch.png";

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/truck-on.png";

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/markers-soft.png";

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/layers-2x.png";

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/layers.png";

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/marker-icon.png";

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(1535)

module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step (object, prev, currentDepth) {
    currentDepth = currentDepth || 1
    Object.keys(object).forEach(function (key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey (key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1 ||
      opts.object
    ) ? key
      : parsedKey
  }

  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
    return keyA.length - keyB.length
  })

  sortedKeys.forEach(function (key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      if (key1 === '__proto__') {
        return
      }
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 1535 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * FullCalendar v3.8.2
 * Docs & License: https://fullcalendar.io/
 * (c) 2018 Adam Shaw
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(4), __webpack_require__(59));
	else if(typeof define === 'function' && define.amd)
		define(["moment", "jquery"], factory);
	else if(typeof exports === 'object')
		exports["FullCalendar"] = factory(require("moment"), require("jquery"));
	else
		root["FullCalendar"] = factory(root["moment"], root["jQuery"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 236);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

/*
derived from:
https://github.com/Microsoft/tslib/blob/v1.6.0/tslib.js

only include the helpers we need, to keep down filesize
*/
var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p]; };
exports.__extends = function (d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var $ = __webpack_require__(3);
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/
// Given the scrollbar widths of some other container, create borders/margins on rowEls in order to match the left
// and right space that was offset by the scrollbars. A 1-pixel border first, then margin beyond that.
function compensateScroll(rowEls, scrollbarWidths) {
    if (scrollbarWidths.left) {
        rowEls.css({
            'border-left-width': 1,
            'margin-left': scrollbarWidths.left - 1
        });
    }
    if (scrollbarWidths.right) {
        rowEls.css({
            'border-right-width': 1,
            'margin-right': scrollbarWidths.right - 1
        });
    }
}
exports.compensateScroll = compensateScroll;
// Undoes compensateScroll and restores all borders/margins
function uncompensateScroll(rowEls) {
    rowEls.css({
        'margin-left': '',
        'margin-right': '',
        'border-left-width': '',
        'border-right-width': ''
    });
}
exports.uncompensateScroll = uncompensateScroll;
// Make the mouse cursor express that an event is not allowed in the current area
function disableCursor() {
    $('body').addClass('fc-not-allowed');
}
exports.disableCursor = disableCursor;
// Returns the mouse cursor to its original look
function enableCursor() {
    $('body').removeClass('fc-not-allowed');
}
exports.enableCursor = enableCursor;
// Given a total available height to fill, have `els` (essentially child rows) expand to accomodate.
// By default, all elements that are shorter than the recommended height are expanded uniformly, not considering
// any other els that are already too tall. if `shouldRedistribute` is on, it considers these tall rows and
// reduces the available height.
function distributeHeight(els, availableHeight, shouldRedistribute) {
    // *FLOORING NOTE*: we floor in certain places because zoom can give inaccurate floating-point dimensions,
    // and it is better to be shorter than taller, to avoid creating unnecessary scrollbars.
    var minOffset1 = Math.floor(availableHeight / els.length); // for non-last element
    var minOffset2 = Math.floor(availableHeight - minOffset1 * (els.length - 1)); // for last element *FLOORING NOTE*
    var flexEls = []; // elements that are allowed to expand. array of DOM nodes
    var flexOffsets = []; // amount of vertical space it takes up
    var flexHeights = []; // actual css height
    var usedHeight = 0;
    undistributeHeight(els); // give all elements their natural height
    // find elements that are below the recommended height (expandable).
    // important to query for heights in a single first pass (to avoid reflow oscillation).
    els.each(function (i, el) {
        var minOffset = i === els.length - 1 ? minOffset2 : minOffset1;
        var naturalOffset = $(el).outerHeight(true);
        if (naturalOffset < minOffset) {
            flexEls.push(el);
            flexOffsets.push(naturalOffset);
            flexHeights.push($(el).height());
        }
        else {
            // this element stretches past recommended height (non-expandable). mark the space as occupied.
            usedHeight += naturalOffset;
        }
    });
    // readjust the recommended height to only consider the height available to non-maxed-out rows.
    if (shouldRedistribute) {
        availableHeight -= usedHeight;
        minOffset1 = Math.floor(availableHeight / flexEls.length);
        minOffset2 = Math.floor(availableHeight - minOffset1 * (flexEls.length - 1)); // *FLOORING NOTE*
    }
    // assign heights to all expandable elements
    $(flexEls).each(function (i, el) {
        var minOffset = i === flexEls.length - 1 ? minOffset2 : minOffset1;
        var naturalOffset = flexOffsets[i];
        var naturalHeight = flexHeights[i];
        var newHeight = minOffset - (naturalOffset - naturalHeight); // subtract the margin/padding
        if (naturalOffset < minOffset) {
            $(el).height(newHeight);
        }
    });
}
exports.distributeHeight = distributeHeight;
// Undoes distrubuteHeight, restoring all els to their natural height
function undistributeHeight(els) {
    els.height('');
}
exports.undistributeHeight = undistributeHeight;
// Given `els`, a jQuery set of <td> cells, find the cell with the largest natural width and set the widths of all the
// cells to be that width.
// PREREQUISITE: if you want a cell to take up width, it needs to have a single inner element w/ display:inline
function matchCellWidths(els) {
    var maxInnerWidth = 0;
    els.find('> *').each(function (i, innerEl) {
        var innerWidth = $(innerEl).outerWidth();
        if (innerWidth > maxInnerWidth) {
            maxInnerWidth = innerWidth;
        }
    });
    maxInnerWidth++; // sometimes not accurate of width the text needs to stay on one line. insurance
    els.width(maxInnerWidth);
    return maxInnerWidth;
}
exports.matchCellWidths = matchCellWidths;
// Given one element that resides inside another,
// Subtracts the height of the inner element from the outer element.
function subtractInnerElHeight(outerEl, innerEl) {
    var both = outerEl.add(innerEl);
    var diff;
    // effin' IE8/9/10/11 sometimes returns 0 for dimensions. this weird hack was the only thing that worked
    both.css({
        position: 'relative',
        left: -1 // ensure reflow in case the el was already relative. negative is less likely to cause new scroll
    });
    diff = outerEl.outerHeight() - innerEl.outerHeight(); // grab the dimensions
    both.css({ position: '', left: '' }); // undo hack
    return diff;
}
exports.subtractInnerElHeight = subtractInnerElHeight;
/* Element Geom Utilities
----------------------------------------------------------------------------------------------------------------------*/
// borrowed from https://github.com/jquery/jquery-ui/blob/1.11.0/ui/core.js#L51
function getScrollParent(el) {
    var position = el.css('position');
    var scrollParent = el.parents().filter(function () {
        var parent = $(this);
        return (/(auto|scroll)/).test(parent.css('overflow') + parent.css('overflow-y') + parent.css('overflow-x'));
    }).eq(0);
    return position === 'fixed' || !scrollParent.length ? $(el[0].ownerDocument || document) : scrollParent;
}
exports.getScrollParent = getScrollParent;
// Queries the outer bounding area of a jQuery element.
// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
// Origin is optional.
function getOuterRect(el, origin) {
    var offset = el.offset();
    var left = offset.left - (origin ? origin.left : 0);
    var top = offset.top - (origin ? origin.top : 0);
    return {
        left: left,
        right: left + el.outerWidth(),
        top: top,
        bottom: top + el.outerHeight()
    };
}
exports.getOuterRect = getOuterRect;
// Queries the area within the margin/border/scrollbars of a jQuery element. Does not go within the padding.
// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
// Origin is optional.
// WARNING: given element can't have borders
// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
function getClientRect(el, origin) {
    var offset = el.offset();
    var scrollbarWidths = getScrollbarWidths(el);
    var left = offset.left + getCssFloat(el, 'border-left-width') + scrollbarWidths.left - (origin ? origin.left : 0);
    var top = offset.top + getCssFloat(el, 'border-top-width') + scrollbarWidths.top - (origin ? origin.top : 0);
    return {
        left: left,
        right: left + el[0].clientWidth,
        top: top,
        bottom: top + el[0].clientHeight // clientHeight includes padding but NOT scrollbars
    };
}
exports.getClientRect = getClientRect;
// Queries the area within the margin/border/padding of a jQuery element. Assumed not to have scrollbars.
// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
// Origin is optional.
function getContentRect(el, origin) {
    var offset = el.offset(); // just outside of border, margin not included
    var left = offset.left + getCssFloat(el, 'border-left-width') + getCssFloat(el, 'padding-left') -
        (origin ? origin.left : 0);
    var top = offset.top + getCssFloat(el, 'border-top-width') + getCssFloat(el, 'padding-top') -
        (origin ? origin.top : 0);
    return {
        left: left,
        right: left + el.width(),
        top: top,
        bottom: top + el.height()
    };
}
exports.getContentRect = getContentRect;
// Returns the computed left/right/top/bottom scrollbar widths for the given jQuery element.
// WARNING: given element can't have borders (which will cause offsetWidth/offsetHeight to be larger).
// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
function getScrollbarWidths(el) {
    var leftRightWidth = el[0].offsetWidth - el[0].clientWidth;
    var bottomWidth = el[0].offsetHeight - el[0].clientHeight;
    var widths;
    leftRightWidth = sanitizeScrollbarWidth(leftRightWidth);
    bottomWidth = sanitizeScrollbarWidth(bottomWidth);
    widths = { left: 0, right: 0, top: 0, bottom: bottomWidth };
    if (getIsLeftRtlScrollbars() && el.css('direction') === 'rtl') {
        widths.left = leftRightWidth;
    }
    else {
        widths.right = leftRightWidth;
    }
    return widths;
}
exports.getScrollbarWidths = getScrollbarWidths;
// The scrollbar width computations in getScrollbarWidths are sometimes flawed when it comes to
// retina displays, rounding, and IE11. Massage them into a usable value.
function sanitizeScrollbarWidth(width) {
    width = Math.max(0, width); // no negatives
    width = Math.round(width);
    return width;
}
// Logic for determining if, when the element is right-to-left, the scrollbar appears on the left side
var _isLeftRtlScrollbars = null;
function getIsLeftRtlScrollbars() {
    if (_isLeftRtlScrollbars === null) {
        _isLeftRtlScrollbars = computeIsLeftRtlScrollbars();
    }
    return _isLeftRtlScrollbars;
}
function computeIsLeftRtlScrollbars() {
    var el = $('<div><div/></div>')
        .css({
        position: 'absolute',
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: 'scroll',
        direction: 'rtl'
    })
        .appendTo('body');
    var innerEl = el.children();
    var res = innerEl.offset().left > el.offset().left; // is the inner div shifted to accommodate a left scrollbar?
    el.remove();
    return res;
}
// Retrieves a jQuery element's computed CSS value as a floating-point number.
// If the queried value is non-numeric (ex: IE can return "medium" for border width), will just return zero.
function getCssFloat(el, prop) {
    return parseFloat(el.css(prop)) || 0;
}
/* Mouse / Touch Utilities
----------------------------------------------------------------------------------------------------------------------*/
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function isPrimaryMouseButton(ev) {
    return ev.which === 1 && !ev.ctrlKey;
}
exports.isPrimaryMouseButton = isPrimaryMouseButton;
function getEvX(ev) {
    var touches = ev.originalEvent.touches;
    // on mobile FF, pageX for touch events is present, but incorrect,
    // so, look at touch coordinates first.
    if (touches && touches.length) {
        return touches[0].pageX;
    }
    return ev.pageX;
}
exports.getEvX = getEvX;
function getEvY(ev) {
    var touches = ev.originalEvent.touches;
    // on mobile FF, pageX for touch events is present, but incorrect,
    // so, look at touch coordinates first.
    if (touches && touches.length) {
        return touches[0].pageY;
    }
    return ev.pageY;
}
exports.getEvY = getEvY;
function getEvIsTouch(ev) {
    return /^touch/.test(ev.type);
}
exports.getEvIsTouch = getEvIsTouch;
function preventSelection(el) {
    el.addClass('fc-unselectable')
        .on('selectstart', preventDefault);
}
exports.preventSelection = preventSelection;
function allowSelection(el) {
    el.removeClass('fc-unselectable')
        .off('selectstart', preventDefault);
}
exports.allowSelection = allowSelection;
// Stops a mouse/touch event from doing it's native browser action
function preventDefault(ev) {
    ev.preventDefault();
}
exports.preventDefault = preventDefault;
/* General Geometry Utils
----------------------------------------------------------------------------------------------------------------------*/
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function intersectRects(rect1, rect2) {
    var res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) {
        return res;
    }
    return false;
}
exports.intersectRects = intersectRects;
// Returns a new point that will have been moved to reside within the given rectangle
function constrainPoint(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
exports.constrainPoint = constrainPoint;
// Returns a point that is the center of the given rectangle
function getRectCenter(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
exports.getRectCenter = getRectCenter;
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function diffPoints(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
exports.diffPoints = diffPoints;
/* Object Ordering by Field
----------------------------------------------------------------------------------------------------------------------*/
function parseFieldSpecs(input) {
    var specs = [];
    var tokens = [];
    var i;
    var token;
    if (typeof input === 'string') {
        tokens = input.split(/\s*,\s*/);
    }
    else if (typeof input === 'function') {
        tokens = [input];
    }
    else if ($.isArray(input)) {
        tokens = input;
    }
    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        if (typeof token === 'string') {
            specs.push(token.charAt(0) === '-' ?
                { field: token.substring(1), order: -1 } :
                { field: token, order: 1 });
        }
        else if (typeof token === 'function') {
            specs.push({ func: token });
        }
    }
    return specs;
}
exports.parseFieldSpecs = parseFieldSpecs;
function compareByFieldSpecs(obj1, obj2, fieldSpecs, obj1fallback, obj2fallback) {
    var i;
    var cmp;
    for (i = 0; i < fieldSpecs.length; i++) {
        cmp = compareByFieldSpec(obj1, obj2, fieldSpecs[i], obj1fallback, obj2fallback);
        if (cmp) {
            return cmp;
        }
    }
    return 0;
}
exports.compareByFieldSpecs = compareByFieldSpecs;
function compareByFieldSpec(obj1, obj2, fieldSpec, obj1fallback, obj2fallback) {
    if (fieldSpec.func) {
        return fieldSpec.func(obj1, obj2);
    }
    var val1 = obj1[fieldSpec.field];
    var val2 = obj2[fieldSpec.field];
    if (val1 == null && obj1fallback) {
        val1 = obj1fallback[fieldSpec.field];
    }
    if (val2 == null && obj2fallback) {
        val2 = obj2fallback[fieldSpec.field];
    }
    return flexibleCompare(val1, val2) * (fieldSpec.order || 1);
}
exports.compareByFieldSpec = compareByFieldSpec;
function flexibleCompare(a, b) {
    if (!a && !b) {
        return 0;
    }
    if (b == null) {
        return -1;
    }
    if (a == null) {
        return 1;
    }
    if ($.type(a) === 'string' || $.type(b) === 'string') {
        return String(a).localeCompare(String(b));
    }
    return a - b;
}
exports.flexibleCompare = flexibleCompare;
/* Date Utilities
----------------------------------------------------------------------------------------------------------------------*/
exports.dayIDs = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
exports.unitsDesc = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond']; // descending
// Diffs the two moments into a Duration where full-days are recorded first, then the remaining time.
// Moments will have their timezones normalized.
function diffDayTime(a, b) {
    return moment.duration({
        days: a.clone().stripTime().diff(b.clone().stripTime(), 'days'),
        ms: a.time() - b.time() // time-of-day from day start. disregards timezone
    });
}
exports.diffDayTime = diffDayTime;
// Diffs the two moments via their start-of-day (regardless of timezone). Produces whole-day durations.
function diffDay(a, b) {
    return moment.duration({
        days: a.clone().stripTime().diff(b.clone().stripTime(), 'days')
    });
}
exports.diffDay = diffDay;
// Diffs two moments, producing a duration, made of a whole-unit-increment of the given unit. Uses rounding.
function diffByUnit(a, b, unit) {
    return moment.duration(Math.round(a.diff(b, unit, true)), // returnFloat=true
    unit);
}
exports.diffByUnit = diffByUnit;
// Computes the unit name of the largest whole-unit period of time.
// For example, 48 hours will be "days" whereas 49 hours will be "hours".
// Accepts start/end, a range object, or an original duration object.
function computeGreatestUnit(start, end) {
    var i;
    var unit;
    var val;
    for (i = 0; i < exports.unitsDesc.length; i++) {
        unit = exports.unitsDesc[i];
        val = computeRangeAs(unit, start, end);
        if (val >= 1 && isInt(val)) {
            break;
        }
    }
    return unit; // will be "milliseconds" if nothing else matches
}
exports.computeGreatestUnit = computeGreatestUnit;
// like computeGreatestUnit, but has special abilities to interpret the source input for clues
function computeDurationGreatestUnit(duration, durationInput) {
    var unit = computeGreatestUnit(duration);
    // prevent days:7 from being interpreted as a week
    if (unit === 'week' && typeof durationInput === 'object' && durationInput.days) {
        unit = 'day';
    }
    return unit;
}
exports.computeDurationGreatestUnit = computeDurationGreatestUnit;
// Computes the number of units (like "hours") in the given range.
// Range can be a {start,end} object, separate start/end args, or a Duration.
// Results are based on Moment's .as() and .diff() methods, so results can depend on internal handling
// of month-diffing logic (which tends to vary from version to version).
function computeRangeAs(unit, start, end) {
    if (end != null) {
        return end.diff(start, unit, true);
    }
    else if (moment.isDuration(start)) {
        return start.as(unit);
    }
    else {
        return start.end.diff(start.start, unit, true);
    }
}
// Intelligently divides a range (specified by a start/end params) by a duration
function divideRangeByDuration(start, end, dur) {
    var months;
    if (durationHasTime(dur)) {
        return (end - start) / dur;
    }
    months = dur.asMonths();
    if (Math.abs(months) >= 1 && isInt(months)) {
        return end.diff(start, 'months', true) / months;
    }
    return end.diff(start, 'days', true) / dur.asDays();
}
exports.divideRangeByDuration = divideRangeByDuration;
// Intelligently divides one duration by another
function divideDurationByDuration(dur1, dur2) {
    var months1;
    var months2;
    if (durationHasTime(dur1) || durationHasTime(dur2)) {
        return dur1 / dur2;
    }
    months1 = dur1.asMonths();
    months2 = dur2.asMonths();
    if (Math.abs(months1) >= 1 && isInt(months1) &&
        Math.abs(months2) >= 1 && isInt(months2)) {
        return months1 / months2;
    }
    return dur1.asDays() / dur2.asDays();
}
exports.divideDurationByDuration = divideDurationByDuration;
// Intelligently multiplies a duration by a number
function multiplyDuration(dur, n) {
    var months;
    if (durationHasTime(dur)) {
        return moment.duration(dur * n);
    }
    months = dur.asMonths();
    if (Math.abs(months) >= 1 && isInt(months)) {
        return moment.duration({ months: months * n });
    }
    return moment.duration({ days: dur.asDays() * n });
}
exports.multiplyDuration = multiplyDuration;
// Returns a boolean about whether the given duration has any time parts (hours/minutes/seconds/ms)
function durationHasTime(dur) {
    return Boolean(dur.hours() || dur.minutes() || dur.seconds() || dur.milliseconds());
}
exports.durationHasTime = durationHasTime;
function isNativeDate(input) {
    return Object.prototype.toString.call(input) === '[object Date]' || input instanceof Date;
}
exports.isNativeDate = isNativeDate;
// Returns a boolean about whether the given input is a time string, like "06:40:00" or "06:00"
function isTimeString(str) {
    return typeof str === 'string' &&
        /^\d+\:\d+(?:\:\d+\.?(?:\d{3})?)?$/.test(str);
}
exports.isTimeString = isTimeString;
/* Logging and Debug
----------------------------------------------------------------------------------------------------------------------*/
function log() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var console = window.console;
    if (console && console.log) {
        return console.log.apply(console, args);
    }
}
exports.log = log;
function warn() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var console = window.console;
    if (console && console.warn) {
        return console.warn.apply(console, args);
    }
    else {
        return log.apply(null, args);
    }
}
exports.warn = warn;
/* General Utilities
----------------------------------------------------------------------------------------------------------------------*/
var hasOwnPropMethod = {}.hasOwnProperty;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function mergeProps(propObjs, complexProps) {
    var dest = {};
    var i;
    var name;
    var complexObjs;
    var j;
    var val;
    var props;
    if (complexProps) {
        for (i = 0; i < complexProps.length; i++) {
            name = complexProps[i];
            complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for (j = propObjs.length - 1; j >= 0; j--) {
                val = propObjs[j][name];
                if (typeof val === 'object') {
                    complexObjs.unshift(val);
                }
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) {
                dest[name] = mergeProps(complexObjs);
            }
        }
    }
    // copy values into the destination, going from last to first
    for (i = propObjs.length - 1; i >= 0; i--) {
        props = propObjs[i];
        for (name in props) {
            if (!(name in dest)) {
                dest[name] = props[name];
            }
        }
    }
    return dest;
}
exports.mergeProps = mergeProps;
function copyOwnProps(src, dest) {
    for (var name_1 in src) {
        if (hasOwnProp(src, name_1)) {
            dest[name_1] = src[name_1];
        }
    }
}
exports.copyOwnProps = copyOwnProps;
function hasOwnProp(obj, name) {
    return hasOwnPropMethod.call(obj, name);
}
exports.hasOwnProp = hasOwnProp;
function applyAll(functions, thisObj, args) {
    if ($.isFunction(functions)) {
        functions = [functions];
    }
    if (functions) {
        var i = void 0;
        var ret = void 0;
        for (i = 0; i < functions.length; i++) {
            ret = functions[i].apply(thisObj, args) || ret;
        }
        return ret;
    }
}
exports.applyAll = applyAll;
function removeMatching(array, testFunc) {
    var removeCnt = 0;
    var i = 0;
    while (i < array.length) {
        if (testFunc(array[i])) {
            array.splice(i, 1);
            removeCnt++;
        }
        else {
            i++;
        }
    }
    return removeCnt;
}
exports.removeMatching = removeMatching;
function removeExact(array, exactVal) {
    var removeCnt = 0;
    var i = 0;
    while (i < array.length) {
        if (array[i] === exactVal) {
            array.splice(i, 1);
            removeCnt++;
        }
        else {
            i++;
        }
    }
    return removeCnt;
}
exports.removeExact = removeExact;
function isArraysEqual(a0, a1) {
    var len = a0.length;
    var i;
    if (len == null || len !== a1.length) {
        return false;
    }
    for (i = 0; i < len; i++) {
        if (a0[i] !== a1[i]) {
            return false;
        }
    }
    return true;
}
exports.isArraysEqual = isArraysEqual;
function firstDefined() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    for (var i = 0; i < args.length; i++) {
        if (args[i] !== undefined) {
            return args[i];
        }
    }
}
exports.firstDefined = firstDefined;
function htmlEscape(s) {
    return (s + '').replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&#039;')
        .replace(/"/g, '&quot;')
        .replace(/\n/g, '<br />');
}
exports.htmlEscape = htmlEscape;
function stripHtmlEntities(text) {
    return text.replace(/&.*?;/g, '');
}
exports.stripHtmlEntities = stripHtmlEntities;
// Given a hash of CSS properties, returns a string of CSS.
// Uses property names as-is (no camel-case conversion). Will not make statements for null/undefined values.
function cssToStr(cssProps) {
    var statements = [];
    $.each(cssProps, function (name, val) {
        if (val != null) {
            statements.push(name + ':' + val);
        }
    });
    return statements.join(';');
}
exports.cssToStr = cssToStr;
// Given an object hash of HTML attribute names to values,
// generates a string that can be injected between < > in HTML
function attrsToStr(attrs) {
    var parts = [];
    $.each(attrs, function (name, val) {
        if (val != null) {
            parts.push(name + '="' + htmlEscape(val) + '"');
        }
    });
    return parts.join(' ');
}
exports.attrsToStr = attrsToStr;
function capitaliseFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
exports.capitaliseFirstLetter = capitaliseFirstLetter;
function compareNumbers(a, b) {
    return a - b;
}
exports.compareNumbers = compareNumbers;
function isInt(n) {
    return n % 1 === 0;
}
exports.isInt = isInt;
// Returns a method bound to the given object context.
// Just like one of the jQuery.proxy signatures, but without the undesired behavior of treating the same method with
// different contexts as identical when binding/unbinding events.
function proxy(obj, methodName) {
    var method = obj[methodName];
    return function () {
        return method.apply(obj, arguments);
    };
}
exports.proxy = proxy;
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
// https://github.com/jashkenas/underscore/blob/1.6.0/underscore.js#L714
function debounce(func, wait, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timeout;
    var args;
    var context;
    var timestamp;
    var result;
    var later = function () {
        var last = +new Date() - timestamp;
        if (last < wait) {
            timeout = setTimeout(later, wait - last);
        }
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    };
    return function () {
        context = this;
        args = arguments;
        timestamp = +new Date();
        var callNow = immediate && !timeout;
        if (!timeout) {
            timeout = setTimeout(later, wait);
        }
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
}
exports.debounce = debounce;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var moment_ext_1 = __webpack_require__(10);
var UnzonedRange = /** @class */ (function () {
    function UnzonedRange(startInput, endInput) {
        // TODO: move these into footprint.
        // Especially, doesn't make sense for null startMs/endMs.
        this.isStart = true;
        this.isEnd = true;
        if (moment.isMoment(startInput)) {
            startInput = startInput.clone().stripZone();
        }
        if (moment.isMoment(endInput)) {
            endInput = endInput.clone().stripZone();
        }
        if (startInput) {
            this.startMs = startInput.valueOf();
        }
        if (endInput) {
            this.endMs = endInput.valueOf();
        }
    }
    /*
    SIDEEFFECT: will mutate eventRanges.
    Will return a new array result.
    Only works for non-open-ended ranges.
    */
    UnzonedRange.invertRanges = function (ranges, constraintRange) {
        var invertedRanges = [];
        var startMs = constraintRange.startMs; // the end of the previous range. the start of the new range
        var i;
        var dateRange;
        // ranges need to be in order. required for our date-walking algorithm
        ranges.sort(compareUnzonedRanges);
        for (i = 0; i < ranges.length; i++) {
            dateRange = ranges[i];
            // add the span of time before the event (if there is any)
            if (dateRange.startMs > startMs) {
                invertedRanges.push(new UnzonedRange(startMs, dateRange.startMs));
            }
            if (dateRange.endMs > startMs) {
                startMs = dateRange.endMs;
            }
        }
        // add the span of time after the last event (if there is any)
        if (startMs < constraintRange.endMs) {
            invertedRanges.push(new UnzonedRange(startMs, constraintRange.endMs));
        }
        return invertedRanges;
    };
    UnzonedRange.prototype.intersect = function (otherRange) {
        var startMs = this.startMs;
        var endMs = this.endMs;
        var newRange = null;
        if (otherRange.startMs != null) {
            if (startMs == null) {
                startMs = otherRange.startMs;
            }
            else {
                startMs = Math.max(startMs, otherRange.startMs);
            }
        }
        if (otherRange.endMs != null) {
            if (endMs == null) {
                endMs = otherRange.endMs;
            }
            else {
                endMs = Math.min(endMs, otherRange.endMs);
            }
        }
        if (startMs == null || endMs == null || startMs < endMs) {
            newRange = new UnzonedRange(startMs, endMs);
            newRange.isStart = this.isStart && startMs === this.startMs;
            newRange.isEnd = this.isEnd && endMs === this.endMs;
        }
        return newRange;
    };
    UnzonedRange.prototype.intersectsWith = function (otherRange) {
        return (this.endMs == null || otherRange.startMs == null || this.endMs > otherRange.startMs) &&
            (this.startMs == null || otherRange.endMs == null || this.startMs < otherRange.endMs);
    };
    UnzonedRange.prototype.containsRange = function (innerRange) {
        return (this.startMs == null || (innerRange.startMs != null && innerRange.startMs >= this.startMs)) &&
            (this.endMs == null || (innerRange.endMs != null && innerRange.endMs <= this.endMs));
    };
    // `date` can be a moment, a Date, or a millisecond time.
    UnzonedRange.prototype.containsDate = function (date) {
        var ms = date.valueOf();
        return (this.startMs == null || ms >= this.startMs) &&
            (this.endMs == null || ms < this.endMs);
    };
    // If the given date is not within the given range, move it inside.
    // (If it's past the end, make it one millisecond before the end).
    // `date` can be a moment, a Date, or a millisecond time.
    // Returns a MS-time.
    UnzonedRange.prototype.constrainDate = function (date) {
        var ms = date.valueOf();
        if (this.startMs != null && ms < this.startMs) {
            ms = this.startMs;
        }
        if (this.endMs != null && ms >= this.endMs) {
            ms = this.endMs - 1;
        }
        return ms;
    };
    UnzonedRange.prototype.equals = function (otherRange) {
        return this.startMs === otherRange.startMs && this.endMs === otherRange.endMs;
    };
    UnzonedRange.prototype.clone = function () {
        var range = new UnzonedRange(this.startMs, this.endMs);
        range.isStart = this.isStart;
        range.isEnd = this.isEnd;
        return range;
    };
    // Returns an ambig-zoned moment from startMs.
    // BEWARE: returned moment is not localized.
    // Formatting and start-of-week will be default.
    UnzonedRange.prototype.getStart = function () {
        if (this.startMs != null) {
            return moment_ext_1.default.utc(this.startMs).stripZone();
        }
        return null;
    };
    // Returns an ambig-zoned moment from startMs.
    // BEWARE: returned moment is not localized.
    // Formatting and start-of-week will be default.
    UnzonedRange.prototype.getEnd = function () {
        if (this.endMs != null) {
            return moment_ext_1.default.utc(this.endMs).stripZone();
        }
        return null;
    };
    UnzonedRange.prototype.as = function (unit) {
        return moment.utc(this.endMs).diff(moment.utc(this.startMs), unit, true);
    };
    return UnzonedRange;
}());
exports.default = UnzonedRange;
/*
Only works for non-open-ended ranges.
*/
function compareUnzonedRanges(range1, range2) {
    return range1.startMs - range2.startMs; // earlier ranges go first
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var ParsableModelMixin_1 = __webpack_require__(208);
var Class_1 = __webpack_require__(32);
var EventDefParser_1 = __webpack_require__(49);
var EventSource = /** @class */ (function (_super) {
    tslib_1.__extends(EventSource, _super);
    // can we do away with calendar? at least for the abstract?
    // useful for buildEventDef
    function EventSource(calendar) {
        var _this = _super.call(this) || this;
        _this.calendar = calendar;
        _this.className = [];
        _this.uid = String(EventSource.uuid++);
        return _this;
    }
    /*
    rawInput can be any data type!
    */
    EventSource.parse = function (rawInput, calendar) {
        var source = new this(calendar);
        if (typeof rawInput === 'object') {
            if (source.applyProps(rawInput)) {
                return source;
            }
        }
        return false;
    };
    EventSource.normalizeId = function (id) {
        if (id) {
            return String(id);
        }
        return null;
    };
    EventSource.prototype.fetch = function (start, end, timezone) {
        // subclasses must implement. must return a promise.
    };
    EventSource.prototype.removeEventDefsById = function (eventDefId) {
        // optional for subclasses to implement
    };
    EventSource.prototype.removeAllEventDefs = function () {
        // optional for subclasses to implement
    };
    /*
    For compairing/matching
    */
    EventSource.prototype.getPrimitive = function (otherSource) {
        // subclasses must implement
    };
    EventSource.prototype.parseEventDefs = function (rawEventDefs) {
        var i;
        var eventDef;
        var eventDefs = [];
        for (i = 0; i < rawEventDefs.length; i++) {
            eventDef = this.parseEventDef(rawEventDefs[i]);
            if (eventDef) {
                eventDefs.push(eventDef);
            }
        }
        return eventDefs;
    };
    EventSource.prototype.parseEventDef = function (rawInput) {
        var calendarTransform = this.calendar.opt('eventDataTransform');
        var sourceTransform = this.eventDataTransform;
        if (calendarTransform) {
            rawInput = calendarTransform(rawInput, this.calendar);
        }
        if (sourceTransform) {
            rawInput = sourceTransform(rawInput, this.calendar);
        }
        return EventDefParser_1.default.parse(rawInput, this);
    };
    EventSource.prototype.applyManualStandardProps = function (rawProps) {
        if (rawProps.id != null) {
            this.id = EventSource.normalizeId(rawProps.id);
        }
        // TODO: converge with EventDef
        if ($.isArray(rawProps.className)) {
            this.className = rawProps.className;
        }
        else if (typeof rawProps.className === 'string') {
            this.className = rawProps.className.split(/\s+/);
        }
        return true;
    };
    EventSource.uuid = 0;
    EventSource.defineStandardProps = ParsableModelMixin_1.default.defineStandardProps;
    EventSource.copyVerbatimStandardProps = ParsableModelMixin_1.default.copyVerbatimStandardProps;
    return EventSource;
}(Class_1.default));
exports.default = EventSource;
ParsableModelMixin_1.default.mixInto(EventSource);
// Parsing
// ---------------------------------------------------------------------------------------------------------------------
EventSource.defineStandardProps({
    // manually process...
    id: false,
    className: false,
    // automatically transfer...
    color: true,
    backgroundColor: true,
    borderColor: true,
    textColor: true,
    editable: true,
    startEditable: true,
    durationEditable: true,
    rendering: true,
    overlap: true,
    constraint: true,
    allDayDefault: true,
    eventDataTransform: true
});


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/*
Utility methods for easily listening to events on another object,
and more importantly, easily unlistening from them.

USAGE:
  import { default as ListenerMixin, ListenerInterface } from './ListenerMixin'
in class:
  listenTo: ListenerInterface['listenTo']
  stopListeningTo: ListenerInterface['stopListeningTo']
after class:
  ListenerMixin.mixInto(TheClass)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var Mixin_1 = __webpack_require__(14);
var guid = 0;
var ListenerMixin = /** @class */ (function (_super) {
    tslib_1.__extends(ListenerMixin, _super);
    function ListenerMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
    Given an `other` object that has on/off methods, bind the given `callback` to an event by the given name.
    The `callback` will be called with the `this` context of the object that .listenTo is being called on.
    Can be called:
      .listenTo(other, eventName, callback)
    OR
      .listenTo(other, {
        eventName1: callback1,
        eventName2: callback2
      })
    */
    ListenerMixin.prototype.listenTo = function (other, arg, callback) {
        if (typeof arg === 'object') {
            for (var eventName in arg) {
                if (arg.hasOwnProperty(eventName)) {
                    this.listenTo(other, eventName, arg[eventName]);
                }
            }
        }
        else if (typeof arg === 'string') {
            other.on(arg + '.' + this.getListenerNamespace(), // use event namespacing to identify this object
            $.proxy(callback, this) // always use `this` context
            // the usually-undesired jQuery guid behavior doesn't matter,
            // because we always unbind via namespace
            );
        }
    };
    /*
    Causes the current object to stop listening to events on the `other` object.
    `eventName` is optional. If omitted, will stop listening to ALL events on `other`.
    */
    ListenerMixin.prototype.stopListeningTo = function (other, eventName) {
        other.off((eventName || '') + '.' + this.getListenerNamespace());
    };
    /*
    Returns a string, unique to this object, to be used for event namespacing
    */
    ListenerMixin.prototype.getListenerNamespace = function () {
        if (this.listenerId == null) {
            this.listenerId = guid++;
        }
        return '_listener' + this.listenerId;
    };
    return ListenerMixin;
}(Mixin_1.default));
exports.default = ListenerMixin;


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var ambigDateOfMonthRegex = /^\s*\d{4}-\d\d$/;
var ambigTimeOrZoneRegex = /^\s*\d{4}-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?)?$/;
var newMomentProto = moment.fn; // where we will attach our new methods
exports.newMomentProto = newMomentProto;
var oldMomentProto = $.extend({}, newMomentProto); // copy of original moment methods
exports.oldMomentProto = oldMomentProto;
// tell momentjs to transfer these properties upon clone
var momentProperties = moment.momentProperties;
momentProperties.push('_fullCalendar');
momentProperties.push('_ambigTime');
momentProperties.push('_ambigZone');
/*
Call this if you want Moment's original format method to be used
*/
function oldMomentFormat(mom, formatStr) {
    return oldMomentProto.format.call(mom, formatStr); // oldMomentProto defined in moment-ext.js
}
exports.oldMomentFormat = oldMomentFormat;
// Creating
// -------------------------------------------------------------------------------------------------
// Creates a new moment, similar to the vanilla moment(...) constructor, but with
// extra features (ambiguous time, enhanced formatting). When given an existing moment,
// it will function as a clone (and retain the zone of the moment). Anything else will
// result in a moment in the local zone.
var momentExt = function () {
    return makeMoment(arguments);
};
exports.default = momentExt;
// Sames as momentExt, but forces the resulting moment to be in the UTC timezone.
momentExt.utc = function () {
    var mom = makeMoment(arguments, true);
    // Force it into UTC because makeMoment doesn't guarantee it
    // (if given a pre-existing moment for example)
    if (mom.hasTime()) {
        mom.utc();
    }
    return mom;
};
// Same as momentExt, but when given an ISO8601 string, the timezone offset is preserved.
// ISO8601 strings with no timezone offset will become ambiguously zoned.
momentExt.parseZone = function () {
    return makeMoment(arguments, true, true);
};
// Builds an enhanced moment from args. When given an existing moment, it clones. When given a
// native Date, or called with no arguments (the current time), the resulting moment will be local.
// Anything else needs to be "parsed" (a string or an array), and will be affected by:
//    parseAsUTC - if there is no zone information, should we parse the input in UTC?
//    parseZone - if there is zone information, should we force the zone of the moment?
function makeMoment(args, parseAsUTC, parseZone) {
    if (parseAsUTC === void 0) { parseAsUTC = false; }
    if (parseZone === void 0) { parseZone = false; }
    var input = args[0];
    var isSingleString = args.length === 1 && typeof input === 'string';
    var isAmbigTime;
    var isAmbigZone;
    var ambigMatch;
    var mom;
    if (moment.isMoment(input) || util_1.isNativeDate(input) || input === undefined) {
        mom = moment.apply(null, args);
    }
    else {
        isAmbigTime = false;
        isAmbigZone = false;
        if (isSingleString) {
            if (ambigDateOfMonthRegex.test(input)) {
                // accept strings like '2014-05', but convert to the first of the month
                input += '-01';
                args = [input]; // for when we pass it on to moment's constructor
                isAmbigTime = true;
                isAmbigZone = true;
            }
            else if ((ambigMatch = ambigTimeOrZoneRegex.exec(input))) {
                isAmbigTime = !ambigMatch[5]; // no time part?
                isAmbigZone = true;
            }
        }
        else if ($.isArray(input)) {
            // arrays have no timezone information, so assume ambiguous zone
            isAmbigZone = true;
        }
        // otherwise, probably a string with a format
        if (parseAsUTC || isAmbigTime) {
            mom = moment.utc.apply(moment, args);
        }
        else {
            mom = moment.apply(null, args);
        }
        if (isAmbigTime) {
            mom._ambigTime = true;
            mom._ambigZone = true; // ambiguous time always means ambiguous zone
        }
        else if (parseZone) {
            if (isAmbigZone) {
                mom._ambigZone = true;
            }
            else if (isSingleString) {
                mom.utcOffset(input); // if not a valid zone, will assign UTC
            }
        }
    }
    mom._fullCalendar = true; // flag for extended functionality
    return mom;
}
// Week Number
// -------------------------------------------------------------------------------------------------
// Returns the week number, considering the locale's custom week number calcuation
// `weeks` is an alias for `week`
newMomentProto.week = newMomentProto.weeks = function (input) {
    var weekCalc = this._locale._fullCalendar_weekCalc;
    if (input == null && typeof weekCalc === 'function') {
        return weekCalc(this);
    }
    else if (weekCalc === 'ISO') {
        return oldMomentProto.isoWeek.apply(this, arguments); // ISO getter/setter
    }
    return oldMomentProto.week.apply(this, arguments); // local getter/setter
};
// Time-of-day
// -------------------------------------------------------------------------------------------------
// GETTER
// Returns a Duration with the hours/minutes/seconds/ms values of the moment.
// If the moment has an ambiguous time, a duration of 00:00 will be returned.
//
// SETTER
// You can supply a Duration, a Moment, or a Duration-like argument.
// When setting the time, and the moment has an ambiguous time, it then becomes unambiguous.
newMomentProto.time = function (time) {
    // Fallback to the original method (if there is one) if this moment wasn't created via FullCalendar.
    // `time` is a generic enough method name where this precaution is necessary to avoid collisions w/ other plugins.
    if (!this._fullCalendar) {
        return oldMomentProto.time.apply(this, arguments);
    }
    if (time == null) {
        return moment.duration({
            hours: this.hours(),
            minutes: this.minutes(),
            seconds: this.seconds(),
            milliseconds: this.milliseconds()
        });
    }
    else {
        this._ambigTime = false; // mark that the moment now has a time
        if (!moment.isDuration(time) && !moment.isMoment(time)) {
            time = moment.duration(time);
        }
        // The day value should cause overflow (so 24 hours becomes 00:00:00 of next day).
        // Only for Duration times, not Moment times.
        var dayHours = 0;
        if (moment.isDuration(time)) {
            dayHours = Math.floor(time.asDays()) * 24;
        }
        // We need to set the individual fields.
        // Can't use startOf('day') then add duration. In case of DST at start of day.
        return this.hours(dayHours + time.hours())
            .minutes(time.minutes())
            .seconds(time.seconds())
            .milliseconds(time.milliseconds());
    }
};
// Converts the moment to UTC, stripping out its time-of-day and timezone offset,
// but preserving its YMD. A moment with a stripped time will display no time
// nor timezone offset when .format() is called.
newMomentProto.stripTime = function () {
    if (!this._ambigTime) {
        this.utc(true); // keepLocalTime=true (for keeping *date* value)
        // set time to zero
        this.set({
            hours: 0,
            minutes: 0,
            seconds: 0,
            ms: 0
        });
        // Mark the time as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
        // which clears all ambig flags.
        this._ambigTime = true;
        this._ambigZone = true; // if ambiguous time, also ambiguous timezone offset
    }
    return this; // for chaining
};
// Returns if the moment has a non-ambiguous time (boolean)
newMomentProto.hasTime = function () {
    return !this._ambigTime;
};
// Timezone
// -------------------------------------------------------------------------------------------------
// Converts the moment to UTC, stripping out its timezone offset, but preserving its
// YMD and time-of-day. A moment with a stripped timezone offset will display no
// timezone offset when .format() is called.
newMomentProto.stripZone = function () {
    var wasAmbigTime;
    if (!this._ambigZone) {
        wasAmbigTime = this._ambigTime;
        this.utc(true); // keepLocalTime=true (for keeping date and time values)
        // the above call to .utc()/.utcOffset() unfortunately might clear the ambig flags, so restore
        this._ambigTime = wasAmbigTime || false;
        // Mark the zone as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
        // which clears the ambig flags.
        this._ambigZone = true;
    }
    return this; // for chaining
};
// Returns of the moment has a non-ambiguous timezone offset (boolean)
newMomentProto.hasZone = function () {
    return !this._ambigZone;
};
// implicitly marks a zone
newMomentProto.local = function (keepLocalTime) {
    // for when converting from ambiguously-zoned to local,
    // keep the time values when converting from UTC -> local
    oldMomentProto.local.call(this, this._ambigZone || keepLocalTime);
    // ensure non-ambiguous
    // this probably already happened via local() -> utcOffset(), but don't rely on Moment's internals
    this._ambigTime = false;
    this._ambigZone = false;
    return this; // for chaining
};
// implicitly marks a zone
newMomentProto.utc = function (keepLocalTime) {
    oldMomentProto.utc.call(this, keepLocalTime);
    // ensure non-ambiguous
    // this probably already happened via utc() -> utcOffset(), but don't rely on Moment's internals
    this._ambigTime = false;
    this._ambigZone = false;
    return this;
};
// implicitly marks a zone (will probably get called upon .utc() and .local())
newMomentProto.utcOffset = function (tzo) {
    if (tzo != null) {
        // these assignments needs to happen before the original zone method is called.
        // I forget why, something to do with a browser crash.
        this._ambigTime = false;
        this._ambigZone = false;
    }
    return oldMomentProto.utcOffset.apply(this, arguments);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/*
USAGE:
  import { default as EmitterMixin, EmitterInterface } from './EmitterMixin'
in class:
  on: EmitterInterface['on']
  one: EmitterInterface['one']
  off: EmitterInterface['off']
  trigger: EmitterInterface['trigger']
  triggerWith: EmitterInterface['triggerWith']
  hasHandlers: EmitterInterface['hasHandlers']
after class:
  EmitterMixin.mixInto(TheClass)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var Mixin_1 = __webpack_require__(14);
var EmitterMixin = /** @class */ (function (_super) {
    tslib_1.__extends(EmitterMixin, _super);
    function EmitterMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // jQuery-ification via $(this) allows a non-DOM object to have
    // the same event handling capabilities (including namespaces).
    EmitterMixin.prototype.on = function (types, handler) {
        $(this).on(types, this._prepareIntercept(handler));
        return this; // for chaining
    };
    EmitterMixin.prototype.one = function (types, handler) {
        $(this).one(types, this._prepareIntercept(handler));
        return this; // for chaining
    };
    EmitterMixin.prototype._prepareIntercept = function (handler) {
        // handlers are always called with an "event" object as their first param.
        // sneak the `this` context and arguments into the extra parameter object
        // and forward them on to the original handler.
        var intercept = function (ev, extra) {
            return handler.apply(extra.context || this, extra.args || []);
        };
        // mimick jQuery's internal "proxy" system (risky, I know)
        // causing all functions with the same .guid to appear to be the same.
        // https://github.com/jquery/jquery/blob/2.2.4/src/core.js#L448
        // this is needed for calling .off with the original non-intercept handler.
        if (!handler.guid) {
            handler.guid = $.guid++;
        }
        intercept.guid = handler.guid;
        return intercept;
    };
    EmitterMixin.prototype.off = function (types, handler) {
        $(this).off(types, handler);
        return this; // for chaining
    };
    EmitterMixin.prototype.trigger = function (types) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // pass in "extra" info to the intercept
        $(this).triggerHandler(types, { args: args });
        return this; // for chaining
    };
    EmitterMixin.prototype.triggerWith = function (types, context, args) {
        // `triggerHandler` is less reliant on the DOM compared to `trigger`.
        // pass in "extra" info to the intercept.
        $(this).triggerHandler(types, { context: context, args: args });
        return this; // for chaining
    };
    EmitterMixin.prototype.hasHandlers = function (type) {
        var hash = $._data(this, 'events'); // http://blog.jquery.com/2012/08/09/jquery-1-8-released/
        return hash && hash[type] && hash[type].length > 0;
    };
    return EmitterMixin;
}(Mixin_1.default));
exports.default = EmitterMixin;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
/*
Meant to be immutable
*/
var ComponentFootprint = /** @class */ (function () {
    function ComponentFootprint(unzonedRange, isAllDay) {
        this.isAllDay = false; // component can choose to ignore this
        this.unzonedRange = unzonedRange;
        this.isAllDay = isAllDay;
    }
    /*
    Only works for non-open-ended ranges.
    */
    ComponentFootprint.prototype.toLegacy = function (calendar) {
        return {
            start: calendar.msToMoment(this.unzonedRange.startMs, this.isAllDay),
            end: calendar.msToMoment(this.unzonedRange.endMs, this.isAllDay)
        };
    };
    return ComponentFootprint;
}());
exports.default = ComponentFootprint;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var EventDef_1 = __webpack_require__(33);
var EventInstance_1 = __webpack_require__(209);
var EventDateProfile_1 = __webpack_require__(17);
var SingleEventDef = /** @class */ (function (_super) {
    tslib_1.__extends(SingleEventDef, _super);
    function SingleEventDef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
    Will receive start/end params, but will be ignored.
    */
    SingleEventDef.prototype.buildInstances = function () {
        return [this.buildInstance()];
    };
    SingleEventDef.prototype.buildInstance = function () {
        return new EventInstance_1.default(this, // definition
        this.dateProfile);
    };
    SingleEventDef.prototype.isAllDay = function () {
        return this.dateProfile.isAllDay();
    };
    SingleEventDef.prototype.clone = function () {
        var def = _super.prototype.clone.call(this);
        def.dateProfile = this.dateProfile;
        return def;
    };
    SingleEventDef.prototype.rezone = function () {
        var calendar = this.source.calendar;
        var dateProfile = this.dateProfile;
        this.dateProfile = new EventDateProfile_1.default(calendar.moment(dateProfile.start), dateProfile.end ? calendar.moment(dateProfile.end) : null, calendar);
    };
    /*
    NOTE: if super-method fails, should still attempt to apply
    */
    SingleEventDef.prototype.applyManualStandardProps = function (rawProps) {
        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
        var dateProfile = EventDateProfile_1.default.parse(rawProps, this.source); // returns null on failure
        if (dateProfile) {
            this.dateProfile = dateProfile;
            // make sure `date` shows up in the legacy event objects as-is
            if (rawProps.date != null) {
                this.miscProps.date = rawProps.date;
            }
            return superSuccess;
        }
        else {
            return false;
        }
    };
    return SingleEventDef;
}(EventDef_1.default));
exports.default = SingleEventDef;
// Parsing
// ---------------------------------------------------------------------------------------------------------------------
SingleEventDef.defineStandardProps({
    start: false,
    date: false,
    end: false,
    allDay: false
});


/***/ }),
/* 14 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Mixin = /** @class */ (function () {
    function Mixin() {
    }
    Mixin.mixInto = function (destClass) {
        var _this = this;
        Object.getOwnPropertyNames(this.prototype).forEach(function (name) {
            if (!destClass.prototype[name]) {
                destClass.prototype[name] = _this.prototype[name];
            }
        });
    };
    /*
    will override existing methods
    TODO: remove! not used anymore
    */
    Mixin.mixOver = function (destClass) {
        var _this = this;
        Object.getOwnPropertyNames(this.prototype).forEach(function (name) {
            destClass.prototype[name] = _this.prototype[name];
        });
    };
    return Mixin;
}());
exports.default = Mixin;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Interaction = /** @class */ (function () {
    function Interaction(component) {
        this.view = component._getView();
        this.component = component;
    }
    Interaction.prototype.opt = function (name) {
        return this.view.opt(name);
    };
    Interaction.prototype.end = function () {
        // subclasses can implement
    };
    return Interaction;
}());
exports.default = Interaction;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
exports.version = '3.8.2';
// When introducing internal API incompatibilities (where fullcalendar plugins would break),
// the minor version of the calendar should be upped (ex: 2.7.2 -> 2.8.0)
// and the below integer should be incremented.
exports.internalApiVersion = 12;
var util_1 = __webpack_require__(4);
exports.applyAll = util_1.applyAll;
exports.debounce = util_1.debounce;
exports.isInt = util_1.isInt;
exports.htmlEscape = util_1.htmlEscape;
exports.cssToStr = util_1.cssToStr;
exports.proxy = util_1.proxy;
exports.capitaliseFirstLetter = util_1.capitaliseFirstLetter;
exports.getOuterRect = util_1.getOuterRect;
exports.getClientRect = util_1.getClientRect;
exports.getContentRect = util_1.getContentRect;
exports.getScrollbarWidths = util_1.getScrollbarWidths;
exports.preventDefault = util_1.preventDefault;
exports.parseFieldSpecs = util_1.parseFieldSpecs;
exports.compareByFieldSpecs = util_1.compareByFieldSpecs;
exports.compareByFieldSpec = util_1.compareByFieldSpec;
exports.flexibleCompare = util_1.flexibleCompare;
exports.computeGreatestUnit = util_1.computeGreatestUnit;
exports.divideRangeByDuration = util_1.divideRangeByDuration;
exports.divideDurationByDuration = util_1.divideDurationByDuration;
exports.multiplyDuration = util_1.multiplyDuration;
exports.durationHasTime = util_1.durationHasTime;
exports.log = util_1.log;
exports.warn = util_1.warn;
exports.removeExact = util_1.removeExact;
exports.intersectRects = util_1.intersectRects;
var date_formatting_1 = __webpack_require__(47);
exports.formatDate = date_formatting_1.formatDate;
exports.formatRange = date_formatting_1.formatRange;
exports.queryMostGranularFormatUnit = date_formatting_1.queryMostGranularFormatUnit;
var locale_1 = __webpack_require__(30);
exports.datepickerLocale = locale_1.datepickerLocale;
exports.locale = locale_1.locale;
var moment_ext_1 = __webpack_require__(10);
exports.moment = moment_ext_1.default;
var EmitterMixin_1 = __webpack_require__(11);
exports.EmitterMixin = EmitterMixin_1.default;
var ListenerMixin_1 = __webpack_require__(7);
exports.ListenerMixin = ListenerMixin_1.default;
var Model_1 = __webpack_require__(48);
exports.Model = Model_1.default;
var Constraints_1 = __webpack_require__(207);
exports.Constraints = Constraints_1.default;
var UnzonedRange_1 = __webpack_require__(5);
exports.UnzonedRange = UnzonedRange_1.default;
var ComponentFootprint_1 = __webpack_require__(12);
exports.ComponentFootprint = ComponentFootprint_1.default;
var BusinessHourGenerator_1 = __webpack_require__(212);
exports.BusinessHourGenerator = BusinessHourGenerator_1.default;
var EventDef_1 = __webpack_require__(33);
exports.EventDef = EventDef_1.default;
var EventDefMutation_1 = __webpack_require__(36);
exports.EventDefMutation = EventDefMutation_1.default;
var EventSourceParser_1 = __webpack_require__(37);
exports.EventSourceParser = EventSourceParser_1.default;
var EventSource_1 = __webpack_require__(6);
exports.EventSource = EventSource_1.default;
var ThemeRegistry_1 = __webpack_require__(51);
exports.defineThemeSystem = ThemeRegistry_1.defineThemeSystem;
var EventInstanceGroup_1 = __webpack_require__(18);
exports.EventInstanceGroup = EventInstanceGroup_1.default;
var ArrayEventSource_1 = __webpack_require__(52);
exports.ArrayEventSource = ArrayEventSource_1.default;
var FuncEventSource_1 = __webpack_require__(215);
exports.FuncEventSource = FuncEventSource_1.default;
var JsonFeedEventSource_1 = __webpack_require__(216);
exports.JsonFeedEventSource = JsonFeedEventSource_1.default;
var EventFootprint_1 = __webpack_require__(35);
exports.EventFootprint = EventFootprint_1.default;
var Class_1 = __webpack_require__(32);
exports.Class = Class_1.default;
var Mixin_1 = __webpack_require__(14);
exports.Mixin = Mixin_1.default;
var CoordCache_1 = __webpack_require__(53);
exports.CoordCache = CoordCache_1.default;
var DragListener_1 = __webpack_require__(54);
exports.DragListener = DragListener_1.default;
var Promise_1 = __webpack_require__(19);
exports.Promise = Promise_1.default;
var TaskQueue_1 = __webpack_require__(217);
exports.TaskQueue = TaskQueue_1.default;
var RenderQueue_1 = __webpack_require__(218);
exports.RenderQueue = RenderQueue_1.default;
var Scroller_1 = __webpack_require__(39);
exports.Scroller = Scroller_1.default;
var Theme_1 = __webpack_require__(38);
exports.Theme = Theme_1.default;
var DateComponent_1 = __webpack_require__(219);
exports.DateComponent = DateComponent_1.default;
var InteractiveDateComponent_1 = __webpack_require__(40);
exports.InteractiveDateComponent = InteractiveDateComponent_1.default;
var Calendar_1 = __webpack_require__(220);
exports.Calendar = Calendar_1.default;
var View_1 = __webpack_require__(41);
exports.View = View_1.default;
var ViewRegistry_1 = __webpack_require__(21);
exports.defineView = ViewRegistry_1.defineView;
exports.getViewConfig = ViewRegistry_1.getViewConfig;
var DayTableMixin_1 = __webpack_require__(55);
exports.DayTableMixin = DayTableMixin_1.default;
var BusinessHourRenderer_1 = __webpack_require__(56);
exports.BusinessHourRenderer = BusinessHourRenderer_1.default;
var EventRenderer_1 = __webpack_require__(42);
exports.EventRenderer = EventRenderer_1.default;
var FillRenderer_1 = __webpack_require__(57);
exports.FillRenderer = FillRenderer_1.default;
var HelperRenderer_1 = __webpack_require__(58);
exports.HelperRenderer = HelperRenderer_1.default;
var ExternalDropping_1 = __webpack_require__(222);
exports.ExternalDropping = ExternalDropping_1.default;
var EventResizing_1 = __webpack_require__(223);
exports.EventResizing = EventResizing_1.default;
var EventPointing_1 = __webpack_require__(59);
exports.EventPointing = EventPointing_1.default;
var EventDragging_1 = __webpack_require__(224);
exports.EventDragging = EventDragging_1.default;
var DateSelecting_1 = __webpack_require__(225);
exports.DateSelecting = DateSelecting_1.default;
var StandardInteractionsMixin_1 = __webpack_require__(60);
exports.StandardInteractionsMixin = StandardInteractionsMixin_1.default;
var AgendaView_1 = __webpack_require__(226);
exports.AgendaView = AgendaView_1.default;
var TimeGrid_1 = __webpack_require__(227);
exports.TimeGrid = TimeGrid_1.default;
var DayGrid_1 = __webpack_require__(61);
exports.DayGrid = DayGrid_1.default;
var BasicView_1 = __webpack_require__(62);
exports.BasicView = BasicView_1.default;
var MonthView_1 = __webpack_require__(229);
exports.MonthView = MonthView_1.default;
var ListView_1 = __webpack_require__(230);
exports.ListView = ListView_1.default;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var UnzonedRange_1 = __webpack_require__(5);
/*
Meant to be immutable
*/
var EventDateProfile = /** @class */ (function () {
    function EventDateProfile(start, end, calendar) {
        this.start = start;
        this.end = end || null;
        this.unzonedRange = this.buildUnzonedRange(calendar);
    }
    /*
    Needs an EventSource object
    */
    EventDateProfile.parse = function (rawProps, source) {
        var startInput = rawProps.start || rawProps.date;
        var endInput = rawProps.end;
        if (!startInput) {
            return false;
        }
        var calendar = source.calendar;
        var start = calendar.moment(startInput);
        var end = endInput ? calendar.moment(endInput) : null;
        var forcedAllDay = rawProps.allDay;
        var forceEventDuration = calendar.opt('forceEventDuration');
        if (!start.isValid()) {
            return false;
        }
        if (end && (!end.isValid() || !end.isAfter(start))) {
            end = null;
        }
        if (forcedAllDay == null) {
            forcedAllDay = source.allDayDefault;
            if (forcedAllDay == null) {
                forcedAllDay = calendar.opt('allDayDefault');
            }
        }
        if (forcedAllDay === true) {
            start.stripTime();
            if (end) {
                end.stripTime();
            }
        }
        else if (forcedAllDay === false) {
            if (!start.hasTime()) {
                start.time(0);
            }
            if (end && !end.hasTime()) {
                end.time(0);
            }
        }
        if (!end && forceEventDuration) {
            end = calendar.getDefaultEventEnd(!start.hasTime(), start);
        }
        return new EventDateProfile(start, end, calendar);
    };
    EventDateProfile.isStandardProp = function (propName) {
        return propName === 'start' || propName === 'date' || propName === 'end' || propName === 'allDay';
    };
    EventDateProfile.prototype.isAllDay = function () {
        return !(this.start.hasTime() || (this.end && this.end.hasTime()));
    };
    /*
    Needs a Calendar object
    */
    EventDateProfile.prototype.buildUnzonedRange = function (calendar) {
        var startMs = this.start.clone().stripZone().valueOf();
        var endMs = this.getEnd(calendar).stripZone().valueOf();
        return new UnzonedRange_1.default(startMs, endMs);
    };
    /*
    Needs a Calendar object
    */
    EventDateProfile.prototype.getEnd = function (calendar) {
        return this.end ?
            this.end.clone() :
            // derive the end from the start and allDay. compute allDay if necessary
            calendar.getDefaultEventEnd(this.isAllDay(), this.start);
    };
    return EventDateProfile;
}());
exports.default = EventDateProfile;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var UnzonedRange_1 = __webpack_require__(5);
var util_1 = __webpack_require__(34);
var EventRange_1 = __webpack_require__(211);
/*
It's expected that there will be at least one EventInstance,
OR that an explicitEventDef is assigned.
*/
var EventInstanceGroup = /** @class */ (function () {
    function EventInstanceGroup(eventInstances) {
        this.eventInstances = eventInstances || [];
    }
    EventInstanceGroup.prototype.getAllEventRanges = function (constraintRange) {
        if (constraintRange) {
            return this.sliceNormalRenderRanges(constraintRange);
        }
        else {
            return this.eventInstances.map(util_1.eventInstanceToEventRange);
        }
    };
    EventInstanceGroup.prototype.sliceRenderRanges = function (constraintRange) {
        if (this.isInverse()) {
            return this.sliceInverseRenderRanges(constraintRange);
        }
        else {
            return this.sliceNormalRenderRanges(constraintRange);
        }
    };
    EventInstanceGroup.prototype.sliceNormalRenderRanges = function (constraintRange) {
        var eventInstances = this.eventInstances;
        var i;
        var eventInstance;
        var slicedRange;
        var slicedEventRanges = [];
        for (i = 0; i < eventInstances.length; i++) {
            eventInstance = eventInstances[i];
            slicedRange = eventInstance.dateProfile.unzonedRange.intersect(constraintRange);
            if (slicedRange) {
                slicedEventRanges.push(new EventRange_1.default(slicedRange, eventInstance.def, eventInstance));
            }
        }
        return slicedEventRanges;
    };
    EventInstanceGroup.prototype.sliceInverseRenderRanges = function (constraintRange) {
        var unzonedRanges = this.eventInstances.map(util_1.eventInstanceToUnzonedRange);
        var ownerDef = this.getEventDef();
        unzonedRanges = UnzonedRange_1.default.invertRanges(unzonedRanges, constraintRange);
        return unzonedRanges.map(function (unzonedRange) {
            return new EventRange_1.default(unzonedRange, ownerDef); // don't give an EventInstance
        });
    };
    EventInstanceGroup.prototype.isInverse = function () {
        return this.getEventDef().hasInverseRendering();
    };
    EventInstanceGroup.prototype.getEventDef = function () {
        return this.explicitEventDef || this.eventInstances[0].def;
    };
    return EventInstanceGroup;
}());
exports.default = EventInstanceGroup;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var PromiseStub = {
    construct: function (executor) {
        var deferred = $.Deferred();
        var promise = deferred.promise();
        if (typeof executor === 'function') {
            executor(function (val) {
                deferred.resolve(val);
                attachImmediatelyResolvingThen(promise, val);
            }, function () {
                deferred.reject();
                attachImmediatelyRejectingThen(promise);
            });
        }
        return promise;
    },
    resolve: function (val) {
        var deferred = $.Deferred().resolve(val);
        var promise = deferred.promise();
        attachImmediatelyResolvingThen(promise, val);
        return promise;
    },
    reject: function () {
        var deferred = $.Deferred().reject();
        var promise = deferred.promise();
        attachImmediatelyRejectingThen(promise);
        return promise;
    }
};
exports.default = PromiseStub;
function attachImmediatelyResolvingThen(promise, val) {
    promise.then = function (onResolve) {
        if (typeof onResolve === 'function') {
            return PromiseStub.resolve(onResolve(val));
        }
        return promise;
    };
}
function attachImmediatelyRejectingThen(promise) {
    promise.then = function (onResolve, onReject) {
        if (typeof onReject === 'function') {
            onReject();
        }
        return promise;
    };
}


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var exportHooks = __webpack_require__(16);
var EmitterMixin_1 = __webpack_require__(11);
var ListenerMixin_1 = __webpack_require__(7);
exportHooks.touchMouseIgnoreWait = 500;
var globalEmitter = null;
var neededCount = 0;
/*
Listens to document and window-level user-interaction events, like touch events and mouse events,
and fires these events as-is to whoever is observing a GlobalEmitter.
Best when used as a singleton via GlobalEmitter.get()

Normalizes mouse/touch events. For examples:
- ignores the the simulated mouse events that happen after a quick tap: mousemove+mousedown+mouseup+click
- compensates for various buggy scenarios where a touchend does not fire
*/
var GlobalEmitter = /** @class */ (function () {
    function GlobalEmitter() {
        this.isTouching = false;
        this.mouseIgnoreDepth = 0;
    }
    // gets the singleton
    GlobalEmitter.get = function () {
        if (!globalEmitter) {
            globalEmitter = new GlobalEmitter();
            globalEmitter.bind();
        }
        return globalEmitter;
    };
    // called when an object knows it will need a GlobalEmitter in the near future.
    GlobalEmitter.needed = function () {
        GlobalEmitter.get(); // ensures globalEmitter
        neededCount++;
    };
    // called when the object that originally called needed() doesn't need a GlobalEmitter anymore.
    GlobalEmitter.unneeded = function () {
        neededCount--;
        if (!neededCount) {
            globalEmitter.unbind();
            globalEmitter = null;
        }
    };
    GlobalEmitter.prototype.bind = function () {
        var _this = this;
        this.listenTo($(document), {
            touchstart: this.handleTouchStart,
            touchcancel: this.handleTouchCancel,
            touchend: this.handleTouchEnd,
            mousedown: this.handleMouseDown,
            mousemove: this.handleMouseMove,
            mouseup: this.handleMouseUp,
            click: this.handleClick,
            selectstart: this.handleSelectStart,
            contextmenu: this.handleContextMenu
        });
        // because we need to call preventDefault
        // because https://www.chromestatus.com/features/5093566007214080
        // TODO: investigate performance because this is a global handler
        window.addEventListener('touchmove', this.handleTouchMoveProxy = function (ev) {
            _this.handleTouchMove($.Event(ev));
        }, { passive: false } // allows preventDefault()
        );
        // attach a handler to get called when ANY scroll action happens on the page.
        // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
        // http://stackoverflow.com/a/32954565/96342
        window.addEventListener('scroll', this.handleScrollProxy = function (ev) {
            _this.handleScroll($.Event(ev));
        }, true // useCapture
        );
    };
    GlobalEmitter.prototype.unbind = function () {
        this.stopListeningTo($(document));
        window.removeEventListener('touchmove', this.handleTouchMoveProxy);
        window.removeEventListener('scroll', this.handleScrollProxy, true // useCapture
        );
    };
    // Touch Handlers
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.handleTouchStart = function (ev) {
        // if a previous touch interaction never ended with a touchend, then implicitly end it,
        // but since a new touch interaction is about to begin, don't start the mouse ignore period.
        this.stopTouch(ev, true); // skipMouseIgnore=true
        this.isTouching = true;
        this.trigger('touchstart', ev);
    };
    GlobalEmitter.prototype.handleTouchMove = function (ev) {
        if (this.isTouching) {
            this.trigger('touchmove', ev);
        }
    };
    GlobalEmitter.prototype.handleTouchCancel = function (ev) {
        if (this.isTouching) {
            this.trigger('touchcancel', ev);
            // Have touchcancel fire an artificial touchend. That way, handlers won't need to listen to both.
            // If touchend fires later, it won't have any effect b/c isTouching will be false.
            this.stopTouch(ev);
        }
    };
    GlobalEmitter.prototype.handleTouchEnd = function (ev) {
        this.stopTouch(ev);
    };
    // Mouse Handlers
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.handleMouseDown = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('mousedown', ev);
        }
    };
    GlobalEmitter.prototype.handleMouseMove = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('mousemove', ev);
        }
    };
    GlobalEmitter.prototype.handleMouseUp = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('mouseup', ev);
        }
    };
    GlobalEmitter.prototype.handleClick = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('click', ev);
        }
    };
    // Misc Handlers
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.handleSelectStart = function (ev) {
        this.trigger('selectstart', ev);
    };
    GlobalEmitter.prototype.handleContextMenu = function (ev) {
        this.trigger('contextmenu', ev);
    };
    GlobalEmitter.prototype.handleScroll = function (ev) {
        this.trigger('scroll', ev);
    };
    // Utils
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.stopTouch = function (ev, skipMouseIgnore) {
        if (skipMouseIgnore === void 0) { skipMouseIgnore = false; }
        if (this.isTouching) {
            this.isTouching = false;
            this.trigger('touchend', ev);
            if (!skipMouseIgnore) {
                this.startTouchMouseIgnore();
            }
        }
    };
    GlobalEmitter.prototype.startTouchMouseIgnore = function () {
        var _this = this;
        var wait = exportHooks.touchMouseIgnoreWait;
        if (wait) {
            this.mouseIgnoreDepth++;
            setTimeout(function () {
                _this.mouseIgnoreDepth--;
            }, wait);
        }
    };
    GlobalEmitter.prototype.shouldIgnoreMouse = function () {
        return this.isTouching || Boolean(this.mouseIgnoreDepth);
    };
    return GlobalEmitter;
}());
exports.default = GlobalEmitter;
ListenerMixin_1.default.mixInto(GlobalEmitter);
EmitterMixin_1.default.mixInto(GlobalEmitter);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var exportHooks = __webpack_require__(16);
exports.viewHash = {};
exportHooks.views = exports.viewHash;
function defineView(viewName, viewConfig) {
    exports.viewHash[viewName] = viewConfig;
}
exports.defineView = defineView;
function getViewConfig(viewName) {
    return exports.viewHash[viewName];
}
exports.getViewConfig = getViewConfig;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var DragListener_1 = __webpack_require__(54);
/* Tracks mouse movements over a component and raises events about which hit the mouse is over.
------------------------------------------------------------------------------------------------------------------------
options:
- subjectEl
- subjectCenter
*/
var HitDragListener = /** @class */ (function (_super) {
    tslib_1.__extends(HitDragListener, _super);
    function HitDragListener(component, options) {
        var _this = _super.call(this, options) || this;
        _this.component = component;
        return _this;
    }
    // Called when drag listening starts (but a real drag has not necessarily began).
    // ev might be undefined if dragging was started manually.
    HitDragListener.prototype.handleInteractionStart = function (ev) {
        var subjectEl = this.subjectEl;
        var subjectRect;
        var origPoint;
        var point;
        this.component.hitsNeeded();
        this.computeScrollBounds(); // for autoscroll
        if (ev) {
            origPoint = { left: util_1.getEvX(ev), top: util_1.getEvY(ev) };
            point = origPoint;
            // constrain the point to bounds of the element being dragged
            if (subjectEl) {
                subjectRect = util_1.getOuterRect(subjectEl); // used for centering as well
                point = util_1.constrainPoint(point, subjectRect);
            }
            this.origHit = this.queryHit(point.left, point.top);
            // treat the center of the subject as the collision point?
            if (subjectEl && this.options.subjectCenter) {
                // only consider the area the subject overlaps the hit. best for large subjects.
                // TODO: skip this if hit didn't supply left/right/top/bottom
                if (this.origHit) {
                    subjectRect = util_1.intersectRects(this.origHit, subjectRect) ||
                        subjectRect; // in case there is no intersection
                }
                point = util_1.getRectCenter(subjectRect);
            }
            this.coordAdjust = util_1.diffPoints(point, origPoint); // point - origPoint
        }
        else {
            this.origHit = null;
            this.coordAdjust = null;
        }
        // call the super-method. do it after origHit has been computed
        _super.prototype.handleInteractionStart.call(this, ev);
    };
    // Called when the actual drag has started
    HitDragListener.prototype.handleDragStart = function (ev) {
        var hit;
        _super.prototype.handleDragStart.call(this, ev);
        // might be different from this.origHit if the min-distance is large
        hit = this.queryHit(util_1.getEvX(ev), util_1.getEvY(ev));
        // report the initial hit the mouse is over
        // especially important if no min-distance and drag starts immediately
        if (hit) {
            this.handleHitOver(hit);
        }
    };
    // Called when the drag moves
    HitDragListener.prototype.handleDrag = function (dx, dy, ev) {
        var hit;
        _super.prototype.handleDrag.call(this, dx, dy, ev);
        hit = this.queryHit(util_1.getEvX(ev), util_1.getEvY(ev));
        if (!isHitsEqual(hit, this.hit)) {
            if (this.hit) {
                this.handleHitOut();
            }
            if (hit) {
                this.handleHitOver(hit);
            }
        }
    };
    // Called when dragging has been stopped
    HitDragListener.prototype.handleDragEnd = function (ev) {
        this.handleHitDone();
        _super.prototype.handleDragEnd.call(this, ev);
    };
    // Called when a the mouse has just moved over a new hit
    HitDragListener.prototype.handleHitOver = function (hit) {
        var isOrig = isHitsEqual(hit, this.origHit);
        this.hit = hit;
        this.trigger('hitOver', this.hit, isOrig, this.origHit);
    };
    // Called when the mouse has just moved out of a hit
    HitDragListener.prototype.handleHitOut = function () {
        if (this.hit) {
            this.trigger('hitOut', this.hit);
            this.handleHitDone();
            this.hit = null;
        }
    };
    // Called after a hitOut. Also called before a dragStop
    HitDragListener.prototype.handleHitDone = function () {
        if (this.hit) {
            this.trigger('hitDone', this.hit);
        }
    };
    // Called when the interaction ends, whether there was a real drag or not
    HitDragListener.prototype.handleInteractionEnd = function (ev, isCancelled) {
        _super.prototype.handleInteractionEnd.call(this, ev, isCancelled);
        this.origHit = null;
        this.hit = null;
        this.component.hitsNotNeeded();
    };
    // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
    HitDragListener.prototype.handleScrollEnd = function () {
        _super.prototype.handleScrollEnd.call(this);
        // hits' absolute positions will be in new places after a user's scroll.
        // HACK for recomputing.
        if (this.isDragging) {
            this.component.releaseHits();
            this.component.prepareHits();
        }
    };
    // Gets the hit underneath the coordinates for the given mouse event
    HitDragListener.prototype.queryHit = function (left, top) {
        if (this.coordAdjust) {
            left += this.coordAdjust.left;
            top += this.coordAdjust.top;
        }
        return this.component.queryHit(left, top);
    };
    return HitDragListener;
}(DragListener_1.default));
exports.default = HitDragListener;
// Returns `true` if the hits are identically equal. `false` otherwise. Must be from the same component.
// Two null values will be considered equal, as two "out of the component" states are the same.
function isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) {
        return true;
    }
    if (hit0 && hit1) {
        return hit0.component === hit1.component &&
            isHitPropsWithin(hit0, hit1) &&
            isHitPropsWithin(hit1, hit0); // ensures all props are identical
    }
    return false;
}
// Returns true if all of subHit's non-standard properties are within superHit
function isHitPropsWithin(subHit, superHit) {
    for (var propName in subHit) {
        if (!/^(component|left|right|top|bottom)$/.test(propName)) {
            if (subHit[propName] !== superHit[propName]) {
                return false;
            }
        }
    }
    return true;
}


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var exportHooks = __webpack_require__(16);
var options_1 = __webpack_require__(31);
var util_1 = __webpack_require__(4);
exports.localeOptionHash = {};
exportHooks.locales = exports.localeOptionHash;
// NOTE: can't guarantee any of these computations will run because not every locale has datepicker
// configs, so make sure there are English fallbacks for these in the defaults file.
var dpComputableOptions = {
    buttonText: function (dpOptions) {
        return {
            // the translations sometimes wrongly contain HTML entities
            prev: util_1.stripHtmlEntities(dpOptions.prevText),
            next: util_1.stripHtmlEntities(dpOptions.nextText),
            today: util_1.stripHtmlEntities(dpOptions.currentText)
        };
    },
    // Produces format strings like "MMMM YYYY" -> "September 2014"
    monthYearFormat: function (dpOptions) {
        return dpOptions.showMonthAfterYear ?
            'YYYY[' + dpOptions.yearSuffix + '] MMMM' :
            'MMMM YYYY[' + dpOptions.yearSuffix + ']';
    }
};
var momComputableOptions = {
    // Produces format strings like "ddd M/D" -> "Fri 9/15"
    dayOfMonthFormat: function (momOptions, fcOptions) {
        var format = momOptions.longDateFormat('l'); // for the format like "M/D/YYYY"
        // strip the year off the edge, as well as other misc non-whitespace chars
        format = format.replace(/^Y+[^\w\s]*|[^\w\s]*Y+$/g, '');
        if (fcOptions.isRTL) {
            format += ' ddd'; // for RTL, add day-of-week to end
        }
        else {
            format = 'ddd ' + format; // for LTR, add day-of-week to beginning
        }
        return format;
    },
    // Produces format strings like "h:mma" -> "6:00pm"
    mediumTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h(:mm)a" -> "6pm" / "6:30pm"
    smallTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(':mm', '(:mm)')
            .replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h(:mm)t" -> "6p" / "6:30p"
    extraSmallTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(':mm', '(:mm)')
            .replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
            .replace(/\s*a$/i, 't'); // convert to AM/PM/am/pm to lowercase one-letter. remove any spaces beforehand
    },
    // Produces format strings like "ha" / "H" -> "6pm" / "18"
    hourFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(':mm', '')
            .replace(/(\Wmm)$/, '') // like above, but for foreign locales
            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h:mm" -> "6:30" (with no AM/PM)
    noMeridiemTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(/\s*a$/i, ''); // remove trailing AM/PM
    }
};
// options that should be computed off live calendar options (considers override options)
// TODO: best place for this? related to locale?
// TODO: flipping text based on isRTL is a bad idea because the CSS `direction` might want to handle it
var instanceComputableOptions = {
    // Produces format strings for results like "Mo 16"
    smallDayDateFormat: function (options) {
        return options.isRTL ?
            'D dd' :
            'dd D';
    },
    // Produces format strings for results like "Wk 5"
    weekFormat: function (options) {
        return options.isRTL ?
            'w[ ' + options.weekNumberTitle + ']' :
            '[' + options.weekNumberTitle + ' ]w';
    },
    // Produces format strings for results like "Wk5"
    smallWeekFormat: function (options) {
        return options.isRTL ?
            'w[' + options.weekNumberTitle + ']' :
            '[' + options.weekNumberTitle + ']w';
    }
};
// TODO: make these computable properties in optionsManager
function populateInstanceComputableOptions(options) {
    $.each(instanceComputableOptions, function (name, func) {
        if (options[name] == null) {
            options[name] = func(options);
        }
    });
}
exports.populateInstanceComputableOptions = populateInstanceComputableOptions;
// Initialize jQuery UI datepicker translations while using some of the translations
// Will set this as the default locales for datepicker.
function datepickerLocale(localeCode, dpLocaleCode, dpOptions) {
    // get the FullCalendar internal option hash for this locale. create if necessary
    var fcOptions = exports.localeOptionHash[localeCode] || (exports.localeOptionHash[localeCode] = {});
    // transfer some simple options from datepicker to fc
    fcOptions.isRTL = dpOptions.isRTL;
    fcOptions.weekNumberTitle = dpOptions.weekHeader;
    // compute some more complex options from datepicker
    $.each(dpComputableOptions, function (name, func) {
        fcOptions[name] = func(dpOptions);
    });
    var jqDatePicker = $.datepicker;
    // is jQuery UI Datepicker is on the page?
    if (jqDatePicker) {
        // Register the locale data.
        // FullCalendar and MomentJS use locale codes like "pt-br" but Datepicker
        // does it like "pt-BR" or if it doesn't have the locale, maybe just "pt".
        // Make an alias so the locale can be referenced either way.
        jqDatePicker.regional[dpLocaleCode] =
            jqDatePicker.regional[localeCode] = // alias
                dpOptions;
        // Alias 'en' to the default locale data. Do this every time.
        jqDatePicker.regional.en = jqDatePicker.regional[''];
        // Set as Datepicker's global defaults.
        jqDatePicker.setDefaults(dpOptions);
    }
}
exports.datepickerLocale = datepickerLocale;
// Sets FullCalendar-specific translations. Will set the locales as the global default.
function locale(localeCode, newFcOptions) {
    var fcOptions;
    var momOptions;
    // get the FullCalendar internal option hash for this locale. create if necessary
    fcOptions = exports.localeOptionHash[localeCode] || (exports.localeOptionHash[localeCode] = {});
    // provided new options for this locales? merge them in
    if (newFcOptions) {
        fcOptions = exports.localeOptionHash[localeCode] = options_1.mergeOptions([fcOptions, newFcOptions]);
    }
    // compute locale options that weren't defined.
    // always do this. newFcOptions can be undefined when initializing from i18n file,
    // so no way to tell if this is an initialization or a default-setting.
    momOptions = getMomentLocaleData(localeCode); // will fall back to en
    $.each(momComputableOptions, function (name, func) {
        if (fcOptions[name] == null) {
            fcOptions[name] = (func)(momOptions, fcOptions);
        }
    });
    // set it as the default locale for FullCalendar
    options_1.globalDefaults.locale = localeCode;
}
exports.locale = locale;
// Returns moment's internal locale data. If doesn't exist, returns English.
function getMomentLocaleData(localeCode) {
    return moment.localeData(localeCode) || moment.localeData('en');
}
exports.getMomentLocaleData = getMomentLocaleData;
// Initialize English by forcing computation of moment-derived options.
// Also, sets it as the default.
locale('en', options_1.englishDefaults);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(4);
exports.globalDefaults = {
    titleRangeSeparator: ' \u2013 ',
    monthYearFormat: 'MMMM YYYY',
    defaultTimedEventDuration: '02:00:00',
    defaultAllDayEventDuration: { days: 1 },
    forceEventDuration: false,
    nextDayThreshold: '09:00:00',
    // display
    columnHeader: true,
    defaultView: 'month',
    aspectRatio: 1.35,
    header: {
        left: 'title',
        center: '',
        right: 'today prev,next'
    },
    weekends: true,
    weekNumbers: false,
    weekNumberTitle: 'W',
    weekNumberCalculation: 'local',
    // editable: false,
    // nowIndicator: false,
    scrollTime: '06:00:00',
    minTime: '00:00:00',
    maxTime: '24:00:00',
    showNonCurrentDates: true,
    // event ajax
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timezoneParam: 'timezone',
    timezone: false,
    // allDayDefault: undefined,
    // locale
    locale: null,
    isRTL: false,
    buttonText: {
        prev: 'prev',
        next: 'next',
        prevYear: 'prev year',
        nextYear: 'next year',
        year: 'year',
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day'
    },
    // buttonIcons: null,
    allDayText: 'all-day',
    // allows setting a min-height to the event segment to prevent short events overlapping each other
    agendaEventMinHeight: 0,
    // jquery-ui theming
    theme: false,
    // themeButtonIcons: null,
    // eventResizableFromStart: false,
    dragOpacity: .75,
    dragRevertDuration: 500,
    dragScroll: true,
    // selectable: false,
    unselectAuto: true,
    // selectMinDistance: 0,
    dropAccept: '*',
    eventOrder: 'title',
    // eventRenderWait: null,
    eventLimit: false,
    eventLimitText: 'more',
    eventLimitClick: 'popover',
    dayPopoverFormat: 'LL',
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000
};
exports.englishDefaults = {
    dayPopoverFormat: 'dddd, MMMM D'
};
exports.rtlDefaults = {
    header: {
        left: 'next,prev today',
        center: '',
        right: 'title'
    },
    buttonIcons: {
        prev: 'right-single-arrow',
        next: 'left-single-arrow',
        prevYear: 'right-double-arrow',
        nextYear: 'left-double-arrow'
    },
    themeButtonIcons: {
        prev: 'circle-triangle-e',
        next: 'circle-triangle-w',
        nextYear: 'seek-prev',
        prevYear: 'seek-next'
    }
};
var complexOptions = [
    'header',
    'footer',
    'buttonText',
    'buttonIcons',
    'themeButtonIcons'
];
// Merges an array of option objects into a single object
function mergeOptions(optionObjs) {
    return util_1.mergeProps(optionObjs, complexOptions);
}
exports.mergeOptions = mergeOptions;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
// Class that all other classes will inherit from
var Class = /** @class */ (function () {
    function Class() {
    }
    // Called on a class to create a subclass.
    // LIMITATION: cannot provide a constructor!
    Class.extend = function (members) {
        var SubClass = /** @class */ (function (_super) {
            tslib_1.__extends(SubClass, _super);
            function SubClass() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return SubClass;
        }(this));
        util_1.copyOwnProps(members, SubClass.prototype);
        return SubClass;
    };
    // Adds new member variables/methods to the class's prototype.
    // Can be called with another class, or a plain object hash containing new members.
    Class.mixin = function (members) {
        util_1.copyOwnProps(members, this.prototype);
    };
    return Class;
}());
exports.default = Class;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var ParsableModelMixin_1 = __webpack_require__(208);
var EventDef = /** @class */ (function () {
    function EventDef(source) {
        this.source = source;
        this.className = [];
        this.miscProps = {};
    }
    EventDef.parse = function (rawInput, source) {
        var def = new this(source);
        if (def.applyProps(rawInput)) {
            return def;
        }
        return false;
    };
    EventDef.normalizeId = function (id) {
        return String(id);
    };
    EventDef.generateId = function () {
        return '_fc' + (EventDef.uuid++);
    };
    EventDef.prototype.clone = function () {
        var copy = new this.constructor(this.source);
        copy.id = this.id;
        copy.rawId = this.rawId;
        copy.uid = this.uid; // not really unique anymore :(
        EventDef.copyVerbatimStandardProps(this, copy);
        copy.className = this.className.slice(); // copy
        copy.miscProps = $.extend({}, this.miscProps);
        return copy;
    };
    EventDef.prototype.hasInverseRendering = function () {
        return this.getRendering() === 'inverse-background';
    };
    EventDef.prototype.hasBgRendering = function () {
        var rendering = this.getRendering();
        return rendering === 'inverse-background' || rendering === 'background';
    };
    EventDef.prototype.getRendering = function () {
        if (this.rendering != null) {
            return this.rendering;
        }
        return this.source.rendering;
    };
    EventDef.prototype.getConstraint = function () {
        if (this.constraint != null) {
            return this.constraint;
        }
        if (this.source.constraint != null) {
            return this.source.constraint;
        }
        return this.source.calendar.opt('eventConstraint'); // what about View option?
    };
    EventDef.prototype.getOverlap = function () {
        if (this.overlap != null) {
            return this.overlap;
        }
        if (this.source.overlap != null) {
            return this.source.overlap;
        }
        return this.source.calendar.opt('eventOverlap'); // what about View option?
    };
    EventDef.prototype.isStartExplicitlyEditable = function () {
        if (this.startEditable != null) {
            return this.startEditable;
        }
        return this.source.startEditable;
    };
    EventDef.prototype.isDurationExplicitlyEditable = function () {
        if (this.durationEditable != null) {
            return this.durationEditable;
        }
        return this.source.durationEditable;
    };
    EventDef.prototype.isExplicitlyEditable = function () {
        if (this.editable != null) {
            return this.editable;
        }
        return this.source.editable;
    };
    EventDef.prototype.toLegacy = function () {
        var obj = $.extend({}, this.miscProps);
        obj._id = this.uid;
        obj.source = this.source;
        obj.className = this.className.slice(); // copy
        obj.allDay = this.isAllDay();
        if (this.rawId != null) {
            obj.id = this.rawId;
        }
        EventDef.copyVerbatimStandardProps(this, obj);
        return obj;
    };
    EventDef.prototype.applyManualStandardProps = function (rawProps) {
        if (rawProps.id != null) {
            this.id = EventDef.normalizeId((this.rawId = rawProps.id));
        }
        else {
            this.id = EventDef.generateId();
        }
        if (rawProps._id != null) {
            this.uid = String(rawProps._id);
        }
        else {
            this.uid = EventDef.generateId();
        }
        // TODO: converge with EventSource
        if ($.isArray(rawProps.className)) {
            this.className = rawProps.className;
        }
        if (typeof rawProps.className === 'string') {
            this.className = rawProps.className.split(/\s+/);
        }
        return true;
    };
    EventDef.prototype.applyMiscProps = function (rawProps) {
        $.extend(this.miscProps, rawProps);
    };
    EventDef.uuid = 0;
    EventDef.defineStandardProps = ParsableModelMixin_1.default.defineStandardProps;
    EventDef.copyVerbatimStandardProps = ParsableModelMixin_1.default.copyVerbatimStandardProps;
    return EventDef;
}());
exports.default = EventDef;
ParsableModelMixin_1.default.mixInto(EventDef);
EventDef.defineStandardProps({
    // not automatically assigned (`false`)
    _id: false,
    id: false,
    className: false,
    source: false,
    // automatically assigned (`true`)
    title: true,
    url: true,
    rendering: true,
    constraint: true,
    overlap: true,
    editable: true,
    startEditable: true,
    durationEditable: true,
    color: true,
    backgroundColor: true,
    borderColor: true,
    textColor: true
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventRange_1 = __webpack_require__(211);
var EventFootprint_1 = __webpack_require__(35);
var ComponentFootprint_1 = __webpack_require__(12);
function eventDefsToEventInstances(eventDefs, unzonedRange) {
    var eventInstances = [];
    var i;
    for (i = 0; i < eventDefs.length; i++) {
        eventInstances.push.apply(eventInstances, // append
        eventDefs[i].buildInstances(unzonedRange));
    }
    return eventInstances;
}
exports.eventDefsToEventInstances = eventDefsToEventInstances;
function eventInstanceToEventRange(eventInstance) {
    return new EventRange_1.default(eventInstance.dateProfile.unzonedRange, eventInstance.def, eventInstance);
}
exports.eventInstanceToEventRange = eventInstanceToEventRange;
function eventRangeToEventFootprint(eventRange) {
    return new EventFootprint_1.default(new ComponentFootprint_1.default(eventRange.unzonedRange, eventRange.eventDef.isAllDay()), eventRange.eventDef, eventRange.eventInstance // might not exist
    );
}
exports.eventRangeToEventFootprint = eventRangeToEventFootprint;
function eventInstanceToUnzonedRange(eventInstance) {
    return eventInstance.dateProfile.unzonedRange;
}
exports.eventInstanceToUnzonedRange = eventInstanceToUnzonedRange;
function eventFootprintToComponentFootprint(eventFootprint) {
    return eventFootprint.componentFootprint;
}
exports.eventFootprintToComponentFootprint = eventFootprintToComponentFootprint;


/***/ }),
/* 35 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventFootprint = /** @class */ (function () {
    function EventFootprint(componentFootprint, eventDef, eventInstance) {
        this.componentFootprint = componentFootprint;
        this.eventDef = eventDef;
        if (eventInstance) {
            this.eventInstance = eventInstance;
        }
    }
    EventFootprint.prototype.getEventLegacy = function () {
        return (this.eventInstance || this.eventDef).toLegacy();
    };
    return EventFootprint;
}());
exports.default = EventFootprint;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(4);
var EventDateProfile_1 = __webpack_require__(17);
var EventDef_1 = __webpack_require__(33);
var EventDefDateMutation_1 = __webpack_require__(50);
var SingleEventDef_1 = __webpack_require__(13);
var EventDefMutation = /** @class */ (function () {
    function EventDefMutation() {
    }
    EventDefMutation.createFromRawProps = function (eventInstance, rawProps, largeUnit) {
        var eventDef = eventInstance.def;
        var dateProps = {};
        var standardProps = {};
        var miscProps = {};
        var verbatimStandardProps = {};
        var eventDefId = null;
        var className = null;
        var propName;
        var dateProfile;
        var dateMutation;
        var defMutation;
        for (propName in rawProps) {
            if (EventDateProfile_1.default.isStandardProp(propName)) {
                dateProps[propName] = rawProps[propName];
            }
            else if (eventDef.isStandardProp(propName)) {
                standardProps[propName] = rawProps[propName];
            }
            else if (eventDef.miscProps[propName] !== rawProps[propName]) {
                miscProps[propName] = rawProps[propName];
            }
        }
        dateProfile = EventDateProfile_1.default.parse(dateProps, eventDef.source);
        if (dateProfile) {
            dateMutation = EventDefDateMutation_1.default.createFromDiff(eventInstance.dateProfile, dateProfile, largeUnit);
        }
        if (standardProps.id !== eventDef.id) {
            eventDefId = standardProps.id; // only apply if there's a change
        }
        if (!util_1.isArraysEqual(standardProps.className, eventDef.className)) {
            className = standardProps.className; // only apply if there's a change
        }
        EventDef_1.default.copyVerbatimStandardProps(standardProps, // src
        verbatimStandardProps // dest
        );
        defMutation = new EventDefMutation();
        defMutation.eventDefId = eventDefId;
        defMutation.className = className;
        defMutation.verbatimStandardProps = verbatimStandardProps;
        defMutation.miscProps = miscProps;
        if (dateMutation) {
            defMutation.dateMutation = dateMutation;
        }
        return defMutation;
    };
    /*
    eventDef assumed to be a SingleEventDef.
    returns an undo function.
    */
    EventDefMutation.prototype.mutateSingle = function (eventDef) {
        var origDateProfile;
        if (this.dateMutation) {
            origDateProfile = eventDef.dateProfile;
            eventDef.dateProfile = this.dateMutation.buildNewDateProfile(origDateProfile, eventDef.source.calendar);
        }
        // can't undo
        // TODO: more DRY with EventDef::applyManualStandardProps
        if (this.eventDefId != null) {
            eventDef.id = EventDef_1.default.normalizeId((eventDef.rawId = this.eventDefId));
        }
        // can't undo
        // TODO: more DRY with EventDef::applyManualStandardProps
        if (this.className) {
            eventDef.className = this.className;
        }
        // can't undo
        if (this.verbatimStandardProps) {
            SingleEventDef_1.default.copyVerbatimStandardProps(this.verbatimStandardProps, // src
            eventDef // dest
            );
        }
        // can't undo
        if (this.miscProps) {
            eventDef.applyMiscProps(this.miscProps);
        }
        if (origDateProfile) {
            return function () {
                eventDef.dateProfile = origDateProfile;
            };
        }
        else {
            return function () { };
        }
    };
    EventDefMutation.prototype.setDateMutation = function (dateMutation) {
        if (dateMutation && !dateMutation.isEmpty()) {
            this.dateMutation = dateMutation;
        }
        else {
            this.dateMutation = null;
        }
    };
    EventDefMutation.prototype.isEmpty = function () {
        return !this.dateMutation;
    };
    return EventDefMutation;
}());
exports.default = EventDefMutation;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    sourceClasses: [],
    registerClass: function (EventSourceClass) {
        this.sourceClasses.unshift(EventSourceClass); // give highest priority
    },
    parse: function (rawInput, calendar) {
        var sourceClasses = this.sourceClasses;
        var i;
        var eventSource;
        for (i = 0; i < sourceClasses.length; i++) {
            eventSource = sourceClasses[i].parse(rawInput, calendar);
            if (eventSource) {
                return eventSource;
            }
        }
    }
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var Theme = /** @class */ (function () {
    function Theme(optionsManager) {
        this.optionsManager = optionsManager;
        this.processIconOverride();
    }
    Theme.prototype.processIconOverride = function () {
        if (this.iconOverrideOption) {
            this.setIconOverride(this.optionsManager.get(this.iconOverrideOption));
        }
    };
    Theme.prototype.setIconOverride = function (iconOverrideHash) {
        var iconClassesCopy;
        var buttonName;
        if ($.isPlainObject(iconOverrideHash)) {
            iconClassesCopy = $.extend({}, this.iconClasses);
            for (buttonName in iconOverrideHash) {
                iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            }
            this.iconClasses = iconClassesCopy;
        }
        else if (iconOverrideHash === false) {
            this.iconClasses = {};
        }
    };
    Theme.prototype.applyIconOverridePrefix = function (className) {
        var prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) {
            className = prefix + className;
        }
        return className;
    };
    Theme.prototype.getClass = function (key) {
        return this.classes[key] || '';
    };
    Theme.prototype.getIconClass = function (buttonName) {
        var className = this.iconClasses[buttonName];
        if (className) {
            return this.baseIconClass + ' ' + className;
        }
        return '';
    };
    Theme.prototype.getCustomButtonIconClass = function (customButtonProps) {
        var className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) {
                return this.baseIconClass + ' ' + this.applyIconOverridePrefix(className);
            }
        }
        return '';
    };
    return Theme;
}());
exports.default = Theme;
Theme.prototype.classes = {};
Theme.prototype.iconClasses = {};
Theme.prototype.baseIconClass = '';
Theme.prototype.iconOverridePrefix = '';


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Class_1 = __webpack_require__(32);
/*
Embodies a div that has potential scrollbars
*/
var Scroller = /** @class */ (function (_super) {
    tslib_1.__extends(Scroller, _super);
    function Scroller(options) {
        var _this = _super.call(this) || this;
        options = options || {};
        _this.overflowX = options.overflowX || options.overflow || 'auto';
        _this.overflowY = options.overflowY || options.overflow || 'auto';
        return _this;
    }
    Scroller.prototype.render = function () {
        this.el = this.renderEl();
        this.applyOverflow();
    };
    Scroller.prototype.renderEl = function () {
        return (this.scrollEl = $('<div class="fc-scroller"></div>'));
    };
    // sets to natural height, unlocks overflow
    Scroller.prototype.clear = function () {
        this.setHeight('auto');
        this.applyOverflow();
    };
    Scroller.prototype.destroy = function () {
        this.el.remove();
    };
    // Overflow
    // -----------------------------------------------------------------------------------------------------------------
    Scroller.prototype.applyOverflow = function () {
        this.scrollEl.css({
            'overflow-x': this.overflowX,
            'overflow-y': this.overflowY
        });
    };
    // Causes any 'auto' overflow values to resolves to 'scroll' or 'hidden'.
    // Useful for preserving scrollbar widths regardless of future resizes.
    // Can pass in scrollbarWidths for optimization.
    Scroller.prototype.lockOverflow = function (scrollbarWidths) {
        var overflowX = this.overflowX;
        var overflowY = this.overflowY;
        scrollbarWidths = scrollbarWidths || this.getScrollbarWidths();
        if (overflowX === 'auto') {
            overflowX = (scrollbarWidths.top || scrollbarWidths.bottom || // horizontal scrollbars?
                // OR scrolling pane with massless scrollbars?
                this.scrollEl[0].scrollWidth - 1 > this.scrollEl[0].clientWidth) ? 'scroll' : 'hidden';
        }
        if (overflowY === 'auto') {
            overflowY = (scrollbarWidths.left || scrollbarWidths.right || // vertical scrollbars?
                // OR scrolling pane with massless scrollbars?
                this.scrollEl[0].scrollHeight - 1 > this.scrollEl[0].clientHeight) ? 'scroll' : 'hidden';
        }
        this.scrollEl.css({ 'overflow-x': overflowX, 'overflow-y': overflowY });
    };
    // Getters / Setters
    // -----------------------------------------------------------------------------------------------------------------
    Scroller.prototype.setHeight = function (height) {
        this.scrollEl.height(height);
    };
    Scroller.prototype.getScrollTop = function () {
        return this.scrollEl.scrollTop();
    };
    Scroller.prototype.setScrollTop = function (top) {
        this.scrollEl.scrollTop(top);
    };
    Scroller.prototype.getClientWidth = function () {
        return this.scrollEl[0].clientWidth;
    };
    Scroller.prototype.getClientHeight = function () {
        return this.scrollEl[0].clientHeight;
    };
    Scroller.prototype.getScrollbarWidths = function () {
        return util_1.getScrollbarWidths(this.scrollEl);
    };
    return Scroller;
}(Class_1.default));
exports.default = Scroller;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var DateComponent_1 = __webpack_require__(219);
var GlobalEmitter_1 = __webpack_require__(20);
var InteractiveDateComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InteractiveDateComponent, _super);
    function InteractiveDateComponent(_view, _options) {
        var _this = _super.call(this, _view, _options) || this;
        // self-config, overridable by subclasses
        _this.segSelector = '.fc-event-container > *'; // what constitutes an event element?
        if (_this.dateSelectingClass) {
            _this.dateClicking = new _this.dateClickingClass(_this);
        }
        if (_this.dateSelectingClass) {
            _this.dateSelecting = new _this.dateSelectingClass(_this);
        }
        if (_this.eventPointingClass) {
            _this.eventPointing = new _this.eventPointingClass(_this);
        }
        if (_this.eventDraggingClass && _this.eventPointing) {
            _this.eventDragging = new _this.eventDraggingClass(_this, _this.eventPointing);
        }
        if (_this.eventResizingClass && _this.eventPointing) {
            _this.eventResizing = new _this.eventResizingClass(_this, _this.eventPointing);
        }
        if (_this.externalDroppingClass) {
            _this.externalDropping = new _this.externalDroppingClass(_this);
        }
        return _this;
    }
    // Sets the container element that the view should render inside of, does global DOM-related initializations,
    // and renders all the non-date-related content inside.
    InteractiveDateComponent.prototype.setElement = function (el) {
        _super.prototype.setElement.call(this, el);
        if (this.dateClicking) {
            this.dateClicking.bindToEl(el);
        }
        if (this.dateSelecting) {
            this.dateSelecting.bindToEl(el);
        }
        this.bindAllSegHandlersToEl(el);
    };
    InteractiveDateComponent.prototype.removeElement = function () {
        this.endInteractions();
        _super.prototype.removeElement.call(this);
    };
    InteractiveDateComponent.prototype.executeEventUnrender = function () {
        this.endInteractions();
        _super.prototype.executeEventUnrender.call(this);
    };
    InteractiveDateComponent.prototype.bindGlobalHandlers = function () {
        _super.prototype.bindGlobalHandlers.call(this);
        if (this.externalDropping) {
            this.externalDropping.bindToDocument();
        }
    };
    InteractiveDateComponent.prototype.unbindGlobalHandlers = function () {
        _super.prototype.unbindGlobalHandlers.call(this);
        if (this.externalDropping) {
            this.externalDropping.unbindFromDocument();
        }
    };
    InteractiveDateComponent.prototype.bindDateHandlerToEl = function (el, name, handler) {
        var _this = this;
        // attach a handler to the grid's root element.
        // jQuery will take care of unregistering them when removeElement gets called.
        this.el.on(name, function (ev) {
            if (!$(ev.target).is(_this.segSelector + ':not(.fc-helper),' + // directly on an event element
                _this.segSelector + ':not(.fc-helper) *,' + // within an event element
                '.fc-more,' + // a "more.." link
                'a[data-goto]' // a clickable nav link
            )) {
                return handler.call(_this, ev);
            }
        });
    };
    InteractiveDateComponent.prototype.bindAllSegHandlersToEl = function (el) {
        [
            this.eventPointing,
            this.eventDragging,
            this.eventResizing
        ].forEach(function (eventInteraction) {
            if (eventInteraction) {
                eventInteraction.bindToEl(el);
            }
        });
    };
    InteractiveDateComponent.prototype.bindSegHandlerToEl = function (el, name, handler) {
        var _this = this;
        el.on(name, this.segSelector, function (ev) {
            var segEl = $(ev.currentTarget);
            if (!segEl.is('.fc-helper')) {
                var seg = segEl.data('fc-seg'); // grab segment data. put there by View::renderEventsPayload
                if (seg && !_this.shouldIgnoreEventPointing()) {
                    return handler.call(_this, seg, ev); // context will be the Grid
                }
            }
        });
    };
    InteractiveDateComponent.prototype.shouldIgnoreMouse = function () {
        // HACK
        // This will still work even though bindDateHandlerToEl doesn't use GlobalEmitter.
        return GlobalEmitter_1.default.get().shouldIgnoreMouse();
    };
    InteractiveDateComponent.prototype.shouldIgnoreTouch = function () {
        var view = this._getView();
        // On iOS (and Android?) when a new selection is initiated overtop another selection,
        // the touchend never fires because the elements gets removed mid-touch-interaction (my theory).
        // HACK: simply don't allow this to happen.
        // ALSO: prevent selection when an *event* is already raised.
        return view.isSelected || view.selectedEvent;
    };
    InteractiveDateComponent.prototype.shouldIgnoreEventPointing = function () {
        // only call the handlers if there is not a drag/resize in progress
        return (this.eventDragging && this.eventDragging.isDragging) ||
            (this.eventResizing && this.eventResizing.isResizing);
    };
    InteractiveDateComponent.prototype.canStartSelection = function (seg, ev) {
        return util_1.getEvIsTouch(ev) &&
            !this.canStartResize(seg, ev) &&
            (this.isEventDefDraggable(seg.footprint.eventDef) ||
                this.isEventDefResizable(seg.footprint.eventDef));
    };
    InteractiveDateComponent.prototype.canStartDrag = function (seg, ev) {
        return !this.canStartResize(seg, ev) &&
            this.isEventDefDraggable(seg.footprint.eventDef);
    };
    InteractiveDateComponent.prototype.canStartResize = function (seg, ev) {
        var view = this._getView();
        var eventDef = seg.footprint.eventDef;
        return (!util_1.getEvIsTouch(ev) || view.isEventDefSelected(eventDef)) &&
            this.isEventDefResizable(eventDef) &&
            $(ev.target).is('.fc-resizer');
    };
    // Kills all in-progress dragging.
    // Useful for when public API methods that result in re-rendering are invoked during a drag.
    // Also useful for when touch devices misbehave and don't fire their touchend.
    InteractiveDateComponent.prototype.endInteractions = function () {
        [
            this.dateClicking,
            this.dateSelecting,
            this.eventPointing,
            this.eventDragging,
            this.eventResizing
        ].forEach(function (interaction) {
            if (interaction) {
                interaction.end();
            }
        });
    };
    // Event Drag-n-Drop
    // ---------------------------------------------------------------------------------------------------------------
    // Computes if the given event is allowed to be dragged by the user
    InteractiveDateComponent.prototype.isEventDefDraggable = function (eventDef) {
        return this.isEventDefStartEditable(eventDef);
    };
    InteractiveDateComponent.prototype.isEventDefStartEditable = function (eventDef) {
        var isEditable = eventDef.isStartExplicitlyEditable();
        if (isEditable == null) {
            isEditable = this.opt('eventStartEditable');
            if (isEditable == null) {
                isEditable = this.isEventDefGenerallyEditable(eventDef);
            }
        }
        return isEditable;
    };
    InteractiveDateComponent.prototype.isEventDefGenerallyEditable = function (eventDef) {
        var isEditable = eventDef.isExplicitlyEditable();
        if (isEditable == null) {
            isEditable = this.opt('editable');
        }
        return isEditable;
    };
    // Event Resizing
    // ---------------------------------------------------------------------------------------------------------------
    // Computes if the given event is allowed to be resized from its starting edge
    InteractiveDateComponent.prototype.isEventDefResizableFromStart = function (eventDef) {
        return this.opt('eventResizableFromStart') && this.isEventDefResizable(eventDef);
    };
    // Computes if the given event is allowed to be resized from its ending edge
    InteractiveDateComponent.prototype.isEventDefResizableFromEnd = function (eventDef) {
        return this.isEventDefResizable(eventDef);
    };
    // Computes if the given event is allowed to be resized by the user at all
    InteractiveDateComponent.prototype.isEventDefResizable = function (eventDef) {
        var isResizable = eventDef.isDurationExplicitlyEditable();
        if (isResizable == null) {
            isResizable = this.opt('eventDurationEditable');
            if (isResizable == null) {
                isResizable = this.isEventDefGenerallyEditable(eventDef);
            }
        }
        return isResizable;
    };
    // Event Mutation / Constraints
    // ---------------------------------------------------------------------------------------------------------------
    // Diffs the two dates, returning a duration, based on granularity of the grid
    // TODO: port isTimeScale into this system?
    InteractiveDateComponent.prototype.diffDates = function (a, b) {
        if (this.largeUnit) {
            return util_1.diffByUnit(a, b, this.largeUnit);
        }
        else {
            return util_1.diffDayTime(a, b);
        }
    };
    // is it allowed, in relation to the view's validRange?
    // NOTE: very similar to isExternalInstanceGroupAllowed
    InteractiveDateComponent.prototype.isEventInstanceGroupAllowed = function (eventInstanceGroup) {
        var view = this._getView();
        var dateProfile = this.dateProfile;
        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            // TODO: just use getAllEventRanges directly
            if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
                return false;
            }
        }
        return view.calendar.constraints.isEventInstanceGroupAllowed(eventInstanceGroup);
    };
    // NOTE: very similar to isEventInstanceGroupAllowed
    // when it's a completely anonymous external drag, no event.
    InteractiveDateComponent.prototype.isExternalInstanceGroupAllowed = function (eventInstanceGroup) {
        var view = this._getView();
        var dateProfile = this.dateProfile;
        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
                return false;
            }
        }
        for (i = 0; i < eventFootprints.length; i++) {
            // treat it as a selection
            // TODO: pass in eventInstanceGroup instead
            //  because we don't want calendar's constraint system to depend on a component's
            //  determination of footprints.
            if (!view.calendar.constraints.isSelectionFootprintAllowed(eventFootprints[i].componentFootprint)) {
                return false;
            }
        }
        return true;
    };
    return InteractiveDateComponent;
}(DateComponent_1.default));
exports.default = InteractiveDateComponent;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var RenderQueue_1 = __webpack_require__(218);
var DateProfileGenerator_1 = __webpack_require__(221);
var InteractiveDateComponent_1 = __webpack_require__(40);
var GlobalEmitter_1 = __webpack_require__(20);
var UnzonedRange_1 = __webpack_require__(5);
/* An abstract class from which other views inherit from
----------------------------------------------------------------------------------------------------------------------*/
var View = /** @class */ (function (_super) {
    tslib_1.__extends(View, _super);
    function View(calendar, viewSpec) {
        var _this = _super.call(this, null, viewSpec.options) || this;
        _this.batchRenderDepth = 0;
        _this.isSelected = false; // boolean whether a range of time is user-selected or not
        _this.calendar = calendar;
        _this.viewSpec = viewSpec;
        // shortcuts
        _this.type = viewSpec.type;
        // .name is deprecated
        _this.name = _this.type;
        _this.initRenderQueue();
        _this.initHiddenDays();
        _this.dateProfileGenerator = new _this.dateProfileGeneratorClass(_this);
        _this.bindBaseRenderHandlers();
        _this.eventOrderSpecs = util_1.parseFieldSpecs(_this.opt('eventOrder'));
        // legacy
        if (_this['initialize']) {
            _this['initialize']();
        }
        return _this;
    }
    View.prototype._getView = function () {
        return this;
    };
    // Retrieves an option with the given name
    View.prototype.opt = function (name) {
        return this.options[name];
    };
    /* Render Queue
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.initRenderQueue = function () {
        this.renderQueue = new RenderQueue_1.default({
            event: this.opt('eventRenderWait')
        });
        this.renderQueue.on('start', this.onRenderQueueStart.bind(this));
        this.renderQueue.on('stop', this.onRenderQueueStop.bind(this));
        this.on('before:change', this.startBatchRender);
        this.on('change', this.stopBatchRender);
    };
    View.prototype.onRenderQueueStart = function () {
        this.calendar.freezeContentHeight();
        this.addScroll(this.queryScroll());
    };
    View.prototype.onRenderQueueStop = function () {
        if (this.calendar.updateViewSize()) {
            this.popScroll();
        }
        this.calendar.thawContentHeight();
    };
    View.prototype.startBatchRender = function () {
        if (!(this.batchRenderDepth++)) {
            this.renderQueue.pause();
        }
    };
    View.prototype.stopBatchRender = function () {
        if (!(--this.batchRenderDepth)) {
            this.renderQueue.resume();
        }
    };
    View.prototype.requestRender = function (func, namespace, actionType) {
        this.renderQueue.queue(func, namespace, actionType);
    };
    // given func will auto-bind to `this`
    View.prototype.whenSizeUpdated = function (func) {
        if (this.renderQueue.isRunning) {
            this.renderQueue.one('stop', func.bind(this));
        }
        else {
            func.call(this);
        }
    };
    /* Title and Date Formatting
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes what the title at the top of the calendar should be for this view
    View.prototype.computeTitle = function (dateProfile) {
        var unzonedRange;
        // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
        if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) {
            unzonedRange = dateProfile.currentUnzonedRange;
        }
        else {
            unzonedRange = dateProfile.activeUnzonedRange;
        }
        return this.formatRange({
            start: this.calendar.msToMoment(unzonedRange.startMs, dateProfile.isRangeAllDay),
            end: this.calendar.msToMoment(unzonedRange.endMs, dateProfile.isRangeAllDay)
        }, dateProfile.isRangeAllDay, this.opt('titleFormat') || this.computeTitleFormat(dateProfile), this.opt('titleRangeSeparator'));
    };
    // Generates the format string that should be used to generate the title for the current date range.
    // Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
    View.prototype.computeTitleFormat = function (dateProfile) {
        var currentRangeUnit = dateProfile.currentRangeUnit;
        if (currentRangeUnit === 'year') {
            return 'YYYY';
        }
        else if (currentRangeUnit === 'month') {
            return this.opt('monthYearFormat'); // like "September 2014"
        }
        else if (dateProfile.currentUnzonedRange.as('days') > 1) {
            return 'll'; // multi-day range. shorter, like "Sep 9 - 10 2014"
        }
        else {
            return 'LL'; // one day. longer, like "September 9 2014"
        }
    };
    // Date Setting/Unsetting
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.setDate = function (date) {
        var currentDateProfile = this.get('dateProfile');
        var newDateProfile = this.dateProfileGenerator.build(date, undefined, true); // forceToValid=true
        if (!currentDateProfile ||
            !currentDateProfile.activeUnzonedRange.equals(newDateProfile.activeUnzonedRange)) {
            this.set('dateProfile', newDateProfile);
        }
    };
    View.prototype.unsetDate = function () {
        this.unset('dateProfile');
    };
    // Event Data
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.fetchInitialEvents = function (dateProfile) {
        var calendar = this.calendar;
        var forceAllDay = dateProfile.isRangeAllDay && !this.usesMinMaxTime;
        return calendar.requestEvents(calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, forceAllDay), calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, forceAllDay));
    };
    View.prototype.bindEventChanges = function () {
        this.listenTo(this.calendar, 'eventsReset', this.resetEvents); // TODO: make this a real event
    };
    View.prototype.unbindEventChanges = function () {
        this.stopListeningTo(this.calendar, 'eventsReset');
    };
    View.prototype.setEvents = function (eventsPayload) {
        this.set('currentEvents', eventsPayload);
        this.set('hasEvents', true);
    };
    View.prototype.unsetEvents = function () {
        this.unset('currentEvents');
        this.unset('hasEvents');
    };
    View.prototype.resetEvents = function (eventsPayload) {
        this.startBatchRender();
        this.unsetEvents();
        this.setEvents(eventsPayload);
        this.stopBatchRender();
    };
    // Date High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.requestDateRender = function (dateProfile) {
        var _this = this;
        this.requestRender(function () {
            _this.executeDateRender(dateProfile);
        }, 'date', 'init');
    };
    View.prototype.requestDateUnrender = function () {
        var _this = this;
        this.requestRender(function () {
            _this.executeDateUnrender();
        }, 'date', 'destroy');
    };
    // if dateProfile not specified, uses current
    View.prototype.executeDateRender = function (dateProfile) {
        _super.prototype.executeDateRender.call(this, dateProfile);
        if (this['render']) {
            this['render'](); // TODO: deprecate
        }
        this.trigger('datesRendered');
        this.addScroll({ isDateInit: true });
        this.startNowIndicator(); // shouldn't render yet because updateSize will be called soon
    };
    View.prototype.executeDateUnrender = function () {
        this.unselect();
        this.stopNowIndicator();
        this.trigger('before:datesUnrendered');
        if (this['destroy']) {
            this['destroy'](); // TODO: deprecate
        }
        _super.prototype.executeDateUnrender.call(this);
    };
    // "Base" rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.bindBaseRenderHandlers = function () {
        var _this = this;
        this.on('datesRendered', function () {
            _this.whenSizeUpdated(_this.triggerViewRender);
        });
        this.on('before:datesUnrendered', function () {
            _this.triggerViewDestroy();
        });
    };
    View.prototype.triggerViewRender = function () {
        this.publiclyTrigger('viewRender', {
            context: this,
            args: [this, this.el]
        });
    };
    View.prototype.triggerViewDestroy = function () {
        this.publiclyTrigger('viewDestroy', {
            context: this,
            args: [this, this.el]
        });
    };
    // Event High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.requestEventsRender = function (eventsPayload) {
        var _this = this;
        this.requestRender(function () {
            _this.executeEventRender(eventsPayload);
            _this.whenSizeUpdated(_this.triggerAfterEventsRendered);
        }, 'event', 'init');
    };
    View.prototype.requestEventsUnrender = function () {
        var _this = this;
        this.requestRender(function () {
            _this.triggerBeforeEventsDestroyed();
            _this.executeEventUnrender();
        }, 'event', 'destroy');
    };
    // Business Hour High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.requestBusinessHoursRender = function (businessHourGenerator) {
        var _this = this;
        this.requestRender(function () {
            _this.renderBusinessHours(businessHourGenerator);
        }, 'businessHours', 'init');
    };
    View.prototype.requestBusinessHoursUnrender = function () {
        var _this = this;
        this.requestRender(function () {
            _this.unrenderBusinessHours();
        }, 'businessHours', 'destroy');
    };
    // Misc view rendering utils
    // -----------------------------------------------------------------------------------------------------------------
    // Binds DOM handlers to elements that reside outside the view container, such as the document
    View.prototype.bindGlobalHandlers = function () {
        _super.prototype.bindGlobalHandlers.call(this);
        this.listenTo(GlobalEmitter_1.default.get(), {
            touchstart: this.processUnselect,
            mousedown: this.handleDocumentMousedown
        });
    };
    // Unbinds DOM handlers from elements that reside outside the view container
    View.prototype.unbindGlobalHandlers = function () {
        _super.prototype.unbindGlobalHandlers.call(this);
        this.stopListeningTo(GlobalEmitter_1.default.get());
    };
    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    // Immediately render the current time indicator and begins re-rendering it at an interval,
    // which is defined by this.getNowIndicatorUnit().
    // TODO: somehow do this for the current whole day's background too
    View.prototype.startNowIndicator = function () {
        var _this = this;
        var unit;
        var update;
        var delay; // ms wait value
        if (this.opt('nowIndicator')) {
            unit = this.getNowIndicatorUnit();
            if (unit) {
                update = util_1.proxy(this, 'updateNowIndicator'); // bind to `this`
                this.initialNowDate = this.calendar.getNow();
                this.initialNowQueriedMs = new Date().valueOf();
                // wait until the beginning of the next interval
                delay = this.initialNowDate.clone().startOf(unit).add(1, unit).valueOf() - this.initialNowDate.valueOf();
                this.nowIndicatorTimeoutID = setTimeout(function () {
                    _this.nowIndicatorTimeoutID = null;
                    update();
                    delay = +moment.duration(1, unit);
                    delay = Math.max(100, delay); // prevent too frequent
                    _this.nowIndicatorIntervalID = setInterval(update, delay); // update every interval
                }, delay);
            }
            // rendering will be initiated in updateSize
        }
    };
    // rerenders the now indicator, computing the new current time from the amount of time that has passed
    // since the initial getNow call.
    View.prototype.updateNowIndicator = function () {
        if (this.isDatesRendered &&
            this.initialNowDate // activated before?
        ) {
            this.unrenderNowIndicator(); // won't unrender if unnecessary
            this.renderNowIndicator(this.initialNowDate.clone().add(new Date().valueOf() - this.initialNowQueriedMs) // add ms
            );
            this.isNowIndicatorRendered = true;
        }
    };
    // Immediately unrenders the view's current time indicator and stops any re-rendering timers.
    // Won't cause side effects if indicator isn't rendered.
    View.prototype.stopNowIndicator = function () {
        if (this.isNowIndicatorRendered) {
            if (this.nowIndicatorTimeoutID) {
                clearTimeout(this.nowIndicatorTimeoutID);
                this.nowIndicatorTimeoutID = null;
            }
            if (this.nowIndicatorIntervalID) {
                clearInterval(this.nowIndicatorIntervalID);
                this.nowIndicatorIntervalID = null;
            }
            this.unrenderNowIndicator();
            this.isNowIndicatorRendered = false;
        }
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        if (this['setHeight']) {
            this['setHeight'](totalHeight, isAuto);
        }
        else {
            _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        }
        this.updateNowIndicator();
    };
    /* Scroller
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.addScroll = function (scroll) {
        var queuedScroll = this.queuedScroll || (this.queuedScroll = {});
        $.extend(queuedScroll, scroll);
    };
    View.prototype.popScroll = function () {
        this.applyQueuedScroll();
        this.queuedScroll = null;
    };
    View.prototype.applyQueuedScroll = function () {
        if (this.queuedScroll) {
            this.applyScroll(this.queuedScroll);
        }
    };
    View.prototype.queryScroll = function () {
        var scroll = {};
        if (this.isDatesRendered) {
            $.extend(scroll, this.queryDateScroll());
        }
        return scroll;
    };
    View.prototype.applyScroll = function (scroll) {
        if (scroll.isDateInit && this.isDatesRendered) {
            $.extend(scroll, this.computeInitialDateScroll());
        }
        if (this.isDatesRendered) {
            this.applyDateScroll(scroll);
        }
    };
    View.prototype.computeInitialDateScroll = function () {
        return {}; // subclasses must implement
    };
    View.prototype.queryDateScroll = function () {
        return {}; // subclasses must implement
    };
    View.prototype.applyDateScroll = function (scroll) {
        // subclasses must implement
    };
    /* Event Drag-n-Drop
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.reportEventDrop = function (eventInstance, eventMutation, el, ev) {
        var eventManager = this.calendar.eventManager;
        var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation);
        var dateMutation = eventMutation.dateMutation;
        // update the EventInstance, for handlers
        if (dateMutation) {
            eventInstance.dateProfile = dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
        }
        this.triggerEventDrop(eventInstance, 
        // a drop doesn't necessarily mean a date mutation (ex: resource change)
        (dateMutation && dateMutation.dateDelta) || moment.duration(), undoFunc, el, ev);
    };
    // Triggers event-drop handlers that have subscribed via the API
    View.prototype.triggerEventDrop = function (eventInstance, dateDelta, undoFunc, el, ev) {
        this.publiclyTrigger('eventDrop', {
            context: el[0],
            args: [
                eventInstance.toLegacy(),
                dateDelta,
                undoFunc,
                ev,
                {},
                this
            ]
        });
    };
    /* External Element Drag-n-Drop
    ------------------------------------------------------------------------------------------------------------------*/
    // Must be called when an external element, via jQuery UI, has been dropped onto the calendar.
    // `meta` is the parsed data that has been embedded into the dragging event.
    // `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
    View.prototype.reportExternalDrop = function (singleEventDef, isEvent, isSticky, el, ev, ui) {
        if (isEvent) {
            this.calendar.eventManager.addEventDef(singleEventDef, isSticky);
        }
        this.triggerExternalDrop(singleEventDef, isEvent, el, ev, ui);
    };
    // Triggers external-drop handlers that have subscribed via the API
    View.prototype.triggerExternalDrop = function (singleEventDef, isEvent, el, ev, ui) {
        // trigger 'drop' regardless of whether element represents an event
        this.publiclyTrigger('drop', {
            context: el[0],
            args: [
                singleEventDef.dateProfile.start.clone(),
                ev,
                ui,
                this
            ]
        });
        if (isEvent) {
            // signal an external event landed
            this.publiclyTrigger('eventReceive', {
                context: this,
                args: [
                    singleEventDef.buildInstance().toLegacy(),
                    this
                ]
            });
        }
    };
    /* Event Resizing
    ------------------------------------------------------------------------------------------------------------------*/
    // Must be called when an event in the view has been resized to a new length
    View.prototype.reportEventResize = function (eventInstance, eventMutation, el, ev) {
        var eventManager = this.calendar.eventManager;
        var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation);
        // update the EventInstance, for handlers
        eventInstance.dateProfile = eventMutation.dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
        this.triggerEventResize(eventInstance, eventMutation.dateMutation.endDelta, undoFunc, el, ev);
    };
    // Triggers event-resize handlers that have subscribed via the API
    View.prototype.triggerEventResize = function (eventInstance, durationDelta, undoFunc, el, ev) {
        this.publiclyTrigger('eventResize', {
            context: el[0],
            args: [
                eventInstance.toLegacy(),
                durationDelta,
                undoFunc,
                ev,
                {},
                this
            ]
        });
    };
    /* Selection (time range)
    ------------------------------------------------------------------------------------------------------------------*/
    // Selects a date span on the view. `start` and `end` are both Moments.
    // `ev` is the native mouse event that begin the interaction.
    View.prototype.select = function (footprint, ev) {
        this.unselect(ev);
        this.renderSelectionFootprint(footprint);
        this.reportSelection(footprint, ev);
    };
    View.prototype.renderSelectionFootprint = function (footprint) {
        if (this['renderSelection']) {
            this['renderSelection'](footprint.toLegacy(this.calendar));
        }
        else {
            _super.prototype.renderSelectionFootprint.call(this, footprint);
        }
    };
    // Called when a new selection is made. Updates internal state and triggers handlers.
    View.prototype.reportSelection = function (footprint, ev) {
        this.isSelected = true;
        this.triggerSelect(footprint, ev);
    };
    // Triggers handlers to 'select'
    View.prototype.triggerSelect = function (footprint, ev) {
        var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?
        this.publiclyTrigger('select', {
            context: this,
            args: [
                dateProfile.start,
                dateProfile.end,
                ev,
                this
            ]
        });
    };
    // Undoes a selection. updates in the internal state and triggers handlers.
    // `ev` is the native mouse event that began the interaction.
    View.prototype.unselect = function (ev) {
        if (this.isSelected) {
            this.isSelected = false;
            if (this['destroySelection']) {
                this['destroySelection'](); // TODO: deprecate
            }
            this.unrenderSelection();
            this.publiclyTrigger('unselect', {
                context: this,
                args: [ev, this]
            });
        }
    };
    /* Event Selection
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.selectEventInstance = function (eventInstance) {
        if (!this.selectedEventInstance ||
            this.selectedEventInstance !== eventInstance) {
            this.unselectEventInstance();
            this.getEventSegs().forEach(function (seg) {
                if (seg.footprint.eventInstance === eventInstance &&
                    seg.el // necessary?
                ) {
                    seg.el.addClass('fc-selected');
                }
            });
            this.selectedEventInstance = eventInstance;
        }
    };
    View.prototype.unselectEventInstance = function () {
        if (this.selectedEventInstance) {
            this.getEventSegs().forEach(function (seg) {
                if (seg.el) {
                    seg.el.removeClass('fc-selected');
                }
            });
            this.selectedEventInstance = null;
        }
    };
    View.prototype.isEventDefSelected = function (eventDef) {
        // event references might change on refetchEvents(), while selectedEventInstance doesn't,
        // so compare IDs
        return this.selectedEventInstance && this.selectedEventInstance.def.id === eventDef.id;
    };
    /* Mouse / Touch Unselecting (time range & event unselection)
    ------------------------------------------------------------------------------------------------------------------*/
    // TODO: move consistently to down/start or up/end?
    // TODO: don't kill previous selection if touch scrolling
    View.prototype.handleDocumentMousedown = function (ev) {
        if (util_1.isPrimaryMouseButton(ev)) {
            this.processUnselect(ev);
        }
    };
    View.prototype.processUnselect = function (ev) {
        this.processRangeUnselect(ev);
        this.processEventUnselect(ev);
    };
    View.prototype.processRangeUnselect = function (ev) {
        var ignore;
        // is there a time-range selection?
        if (this.isSelected && this.opt('unselectAuto')) {
            // only unselect if the clicked element is not identical to or inside of an 'unselectCancel' element
            ignore = this.opt('unselectCancel');
            if (!ignore || !$(ev.target).closest(ignore).length) {
                this.unselect(ev);
            }
        }
    };
    View.prototype.processEventUnselect = function (ev) {
        if (this.selectedEventInstance) {
            if (!$(ev.target).closest('.fc-selected').length) {
                this.unselectEventInstance();
            }
        }
    };
    /* Triggers
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.triggerBaseRendered = function () {
        this.publiclyTrigger('viewRender', {
            context: this,
            args: [this, this.el]
        });
    };
    View.prototype.triggerBaseUnrendered = function () {
        this.publiclyTrigger('viewDestroy', {
            context: this,
            args: [this, this.el]
        });
    };
    // Triggers handlers to 'dayClick'
    // Span has start/end of the clicked area. Only the start is useful.
    View.prototype.triggerDayClick = function (footprint, dayEl, ev) {
        var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?
        this.publiclyTrigger('dayClick', {
            context: dayEl,
            args: [dateProfile.start, ev, this]
        });
    };
    /* Date Utils
    ------------------------------------------------------------------------------------------------------------------*/
    // For DateComponent::getDayClasses
    View.prototype.isDateInOtherMonth = function (date, dateProfile) {
        return false;
    };
    // Arguments after name will be forwarded to a hypothetical function value
    // WARNING: passed-in arguments will be given to generator functions as-is and can cause side-effects.
    // Always clone your objects if you fear mutation.
    View.prototype.getUnzonedRangeOption = function (name) {
        var val = this.opt(name);
        if (typeof val === 'function') {
            val = val.apply(null, Array.prototype.slice.call(arguments, 1));
        }
        if (val) {
            return this.calendar.parseUnzonedRange(val);
        }
    };
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/
    // Initializes internal variables related to calculating hidden days-of-week
    View.prototype.initHiddenDays = function () {
        var hiddenDays = this.opt('hiddenDays') || []; // array of day-of-week indices that are hidden
        var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        var dayCnt = 0;
        var i;
        if (this.opt('weekends') === false) {
            hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        }
        for (i = 0; i < 7; i++) {
            if (!(isHiddenDayHash[i] = $.inArray(i, hiddenDays) !== -1)) {
                dayCnt++;
            }
        }
        if (!dayCnt) {
            throw new Error('invalid hiddenDays'); // all days were hidden? bad.
        }
        this.isHiddenDayHash = isHiddenDayHash;
    };
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    View.prototype.trimHiddenDays = function (inputUnzonedRange) {
        var start = inputUnzonedRange.getStart();
        var end = inputUnzonedRange.getEnd();
        if (start) {
            start = this.skipHiddenDays(start);
        }
        if (end) {
            end = this.skipHiddenDays(end, -1, true);
        }
        if (start === null || end === null || start < end) {
            return new UnzonedRange_1.default(start, end);
        }
        return null;
    };
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Moment
    View.prototype.isHiddenDay = function (day) {
        if (moment.isMoment(day)) {
            day = day.day();
        }
        return this.isHiddenDayHash[day];
    };
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validUnzonedRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    View.prototype.skipHiddenDays = function (date, inc, isExclusive) {
        if (inc === void 0) { inc = 1; }
        if (isExclusive === void 0) { isExclusive = false; }
        var out = date.clone();
        while (this.isHiddenDayHash[(out.day() + (isExclusive ? inc : 0) + 7) % 7]) {
            out.add(inc, 'days');
        }
        return out;
    };
    return View;
}(InteractiveDateComponent_1.default));
exports.default = View;
View.prototype.usesMinMaxTime = false;
View.prototype.dateProfileGeneratorClass = DateProfileGenerator_1.default;
View.watch('displayingDates', ['isInDom', 'dateProfile'], function (deps) {
    this.requestDateRender(deps.dateProfile);
}, function () {
    this.requestDateUnrender();
});
View.watch('displayingBusinessHours', ['displayingDates', 'businessHourGenerator'], function (deps) {
    this.requestBusinessHoursRender(deps.businessHourGenerator);
}, function () {
    this.requestBusinessHoursUnrender();
});
View.watch('initialEvents', ['dateProfile'], function (deps) {
    return this.fetchInitialEvents(deps.dateProfile);
});
View.watch('bindingEvents', ['initialEvents'], function (deps) {
    this.setEvents(deps.initialEvents);
    this.bindEventChanges();
}, function () {
    this.unbindEventChanges();
    this.unsetEvents();
});
View.watch('displayingEvents', ['displayingDates', 'hasEvents'], function () {
    this.requestEventsRender(this.get('currentEvents'));
}, function () {
    this.requestEventsUnrender();
});
View.watch('title', ['dateProfile'], function (deps) {
    return (this.title = this.computeTitle(deps.dateProfile)); // assign to View for legacy reasons
});
View.watch('legacyDateProps', ['dateProfile'], function (deps) {
    var calendar = this.calendar;
    var dateProfile = deps.dateProfile;
    // DEPRECATED, but we need to keep it updated...
    this.start = calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, dateProfile.isRangeAllDay);
    this.end = calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, dateProfile.isRangeAllDay);
    this.intervalStart = calendar.msToMoment(dateProfile.currentUnzonedRange.startMs, dateProfile.isRangeAllDay);
    this.intervalEnd = calendar.msToMoment(dateProfile.currentUnzonedRange.endMs, dateProfile.isRangeAllDay);
});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var EventRenderer = /** @class */ (function () {
    function EventRenderer(component, fillRenderer) {
        this.view = component._getView();
        this.component = component;
        this.fillRenderer = fillRenderer;
    }
    EventRenderer.prototype.opt = function (name) {
        return this.view.opt(name);
    };
    // Updates values that rely on options and also relate to range
    EventRenderer.prototype.rangeUpdated = function () {
        var displayEventTime;
        var displayEventEnd;
        this.eventTimeFormat =
            this.opt('eventTimeFormat') ||
                this.opt('timeFormat') || // deprecated
                this.computeEventTimeFormat();
        displayEventTime = this.opt('displayEventTime');
        if (displayEventTime == null) {
            displayEventTime = this.computeDisplayEventTime(); // might be based off of range
        }
        displayEventEnd = this.opt('displayEventEnd');
        if (displayEventEnd == null) {
            displayEventEnd = this.computeDisplayEventEnd(); // might be based off of range
        }
        this.displayEventTime = displayEventTime;
        this.displayEventEnd = displayEventEnd;
    };
    EventRenderer.prototype.render = function (eventsPayload) {
        var dateProfile = this.component._getDateProfile();
        var eventDefId;
        var instanceGroup;
        var eventRanges;
        var bgRanges = [];
        var fgRanges = [];
        for (eventDefId in eventsPayload) {
            instanceGroup = eventsPayload[eventDefId];
            eventRanges = instanceGroup.sliceRenderRanges(dateProfile.activeUnzonedRange);
            if (instanceGroup.getEventDef().hasBgRendering()) {
                bgRanges.push.apply(bgRanges, eventRanges);
            }
            else {
                fgRanges.push.apply(fgRanges, eventRanges);
            }
        }
        this.renderBgRanges(bgRanges);
        this.renderFgRanges(fgRanges);
    };
    EventRenderer.prototype.unrender = function () {
        this.unrenderBgRanges();
        this.unrenderFgRanges();
    };
    EventRenderer.prototype.renderFgRanges = function (eventRanges) {
        var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        // render an `.el` on each seg
        // returns a subset of the segs. segs that were actually rendered
        segs = this.renderFgSegEls(segs);
        if (this.renderFgSegs(segs) !== false) {
            this.fgSegs = segs;
        }
    };
    EventRenderer.prototype.unrenderFgRanges = function () {
        this.unrenderFgSegs(this.fgSegs || []);
        this.fgSegs = null;
    };
    EventRenderer.prototype.renderBgRanges = function (eventRanges) {
        var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        if (this.renderBgSegs(segs) !== false) {
            this.bgSegs = segs;
        }
    };
    EventRenderer.prototype.unrenderBgRanges = function () {
        this.unrenderBgSegs();
        this.bgSegs = null;
    };
    EventRenderer.prototype.getSegs = function () {
        return (this.bgSegs || []).concat(this.fgSegs || []);
    };
    // Renders foreground event segments onto the grid
    EventRenderer.prototype.renderFgSegs = function (segs) {
        // subclasses must implement
        // segs already has rendered els, and has been filtered.
        return false; // signal failure if not implemented
    };
    // Unrenders all currently rendered foreground segments
    EventRenderer.prototype.unrenderFgSegs = function (segs) {
        // subclasses must implement
    };
    EventRenderer.prototype.renderBgSegs = function (segs) {
        var _this = this;
        if (this.fillRenderer) {
            this.fillRenderer.renderSegs('bgEvent', segs, {
                getClasses: function (seg) {
                    return _this.getBgClasses(seg.footprint.eventDef);
                },
                getCss: function (seg) {
                    return {
                        'background-color': _this.getBgColor(seg.footprint.eventDef)
                    };
                },
                filterEl: function (seg, el) {
                    return _this.filterEventRenderEl(seg.footprint, el);
                }
            });
        }
        else {
            return false; // signal failure if no fillRenderer
        }
    };
    EventRenderer.prototype.unrenderBgSegs = function () {
        if (this.fillRenderer) {
            this.fillRenderer.unrender('bgEvent');
        }
    };
    // Renders and assigns an `el` property for each foreground event segment.
    // Only returns segments that successfully rendered.
    EventRenderer.prototype.renderFgSegEls = function (segs, disableResizing) {
        var _this = this;
        if (disableResizing === void 0) { disableResizing = false; }
        var hasEventRenderHandlers = this.view.hasPublicHandlers('eventRender');
        var html = '';
        var renderedSegs = [];
        var i;
        if (segs.length) {
            // build a large concatenation of event segment HTML
            for (i = 0; i < segs.length; i++) {
                this.beforeFgSegHtml(segs[i]);
                html += this.fgSegHtml(segs[i], disableResizing);
            }
            // Grab individual elements from the combined HTML string. Use each as the default rendering.
            // Then, compute the 'el' for each segment. An el might be null if the eventRender callback returned false.
            $(html).each(function (i, node) {
                var seg = segs[i];
                var el = $(node);
                if (hasEventRenderHandlers) {
                    el = _this.filterEventRenderEl(seg.footprint, el);
                }
                if (el) {
                    el.data('fc-seg', seg); // used by handlers
                    seg.el = el;
                    renderedSegs.push(seg);
                }
            });
        }
        return renderedSegs;
    };
    EventRenderer.prototype.beforeFgSegHtml = function (seg) {
    };
    // Generates the HTML for the default rendering of a foreground event segment. Used by renderFgSegEls()
    EventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
        // subclasses should implement
    };
    // Generic utility for generating the HTML classNames for an event segment's element
    EventRenderer.prototype.getSegClasses = function (seg, isDraggable, isResizable) {
        var classes = [
            'fc-event',
            seg.isStart ? 'fc-start' : 'fc-not-start',
            seg.isEnd ? 'fc-end' : 'fc-not-end'
        ].concat(this.getClasses(seg.footprint.eventDef));
        if (isDraggable) {
            classes.push('fc-draggable');
        }
        if (isResizable) {
            classes.push('fc-resizable');
        }
        // event is currently selected? attach a className.
        if (this.view.isEventDefSelected(seg.footprint.eventDef)) {
            classes.push('fc-selected');
        }
        return classes;
    };
    // Given an event and the default element used for rendering, returns the element that should actually be used.
    // Basically runs events and elements through the eventRender hook.
    EventRenderer.prototype.filterEventRenderEl = function (eventFootprint, el) {
        var legacy = eventFootprint.getEventLegacy();
        var custom = this.view.publiclyTrigger('eventRender', {
            context: legacy,
            args: [legacy, el, this.view]
        });
        if (custom === false) {
            el = null;
        }
        else if (custom && custom !== true) {
            el = $(custom);
        }
        return el;
    };
    // Compute the text that should be displayed on an event's element.
    // `range` can be the Event object itself, or something range-like, with at least a `start`.
    // If event times are disabled, or the event has no time, will return a blank string.
    // If not specified, formatStr will default to the eventTimeFormat setting,
    // and displayEnd will default to the displayEventEnd setting.
    EventRenderer.prototype.getTimeText = function (eventFootprint, formatStr, displayEnd) {
        return this._getTimeText(eventFootprint.eventInstance.dateProfile.start, eventFootprint.eventInstance.dateProfile.end, eventFootprint.componentFootprint.isAllDay, formatStr, displayEnd);
    };
    EventRenderer.prototype._getTimeText = function (start, end, isAllDay, formatStr, displayEnd) {
        if (formatStr == null) {
            formatStr = this.eventTimeFormat;
        }
        if (displayEnd == null) {
            displayEnd = this.displayEventEnd;
        }
        if (this.displayEventTime && !isAllDay) {
            if (displayEnd && end) {
                return this.view.formatRange({ start: start, end: end }, false, // allDay
                formatStr);
            }
            else {
                return start.format(formatStr);
            }
        }
        return '';
    };
    EventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('smallTimeFormat');
    };
    EventRenderer.prototype.computeDisplayEventTime = function () {
        return true;
    };
    EventRenderer.prototype.computeDisplayEventEnd = function () {
        return true;
    };
    EventRenderer.prototype.getBgClasses = function (eventDef) {
        var classNames = this.getClasses(eventDef);
        classNames.push('fc-bgevent');
        return classNames;
    };
    EventRenderer.prototype.getClasses = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var classNames = [];
        for (i = 0; i < objs.length; i++) {
            classNames.push.apply(// append
            classNames, objs[i].eventClassName || objs[i].className || []);
        }
        return classNames;
    };
    // Utility for generating event skin-related CSS properties
    EventRenderer.prototype.getSkinCss = function (eventDef) {
        return {
            'background-color': this.getBgColor(eventDef),
            'border-color': this.getBorderColor(eventDef),
            color: this.getTextColor(eventDef)
        };
    };
    // Queries for caller-specified color, then falls back to default
    EventRenderer.prototype.getBgColor = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var val;
        for (i = 0; i < objs.length && !val; i++) {
            val = objs[i].eventBackgroundColor || objs[i].eventColor ||
                objs[i].backgroundColor || objs[i].color;
        }
        if (!val) {
            val = this.opt('eventBackgroundColor') || this.opt('eventColor');
        }
        return val;
    };
    // Queries for caller-specified color, then falls back to default
    EventRenderer.prototype.getBorderColor = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var val;
        for (i = 0; i < objs.length && !val; i++) {
            val = objs[i].eventBorderColor || objs[i].eventColor ||
                objs[i].borderColor || objs[i].color;
        }
        if (!val) {
            val = this.opt('eventBorderColor') || this.opt('eventColor');
        }
        return val;
    };
    // Queries for caller-specified color, then falls back to default
    EventRenderer.prototype.getTextColor = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var val;
        for (i = 0; i < objs.length && !val; i++) {
            val = objs[i].eventTextColor ||
                objs[i].textColor;
        }
        if (!val) {
            val = this.opt('eventTextColor');
        }
        return val;
    };
    EventRenderer.prototype.getStylingObjs = function (eventDef) {
        var objs = this.getFallbackStylingObjs(eventDef);
        objs.unshift(eventDef);
        return objs;
    };
    EventRenderer.prototype.getFallbackStylingObjs = function (eventDef) {
        return [eventDef.source];
    };
    EventRenderer.prototype.sortEventSegs = function (segs) {
        segs.sort(util_1.proxy(this, 'compareEventSegs'));
    };
    // A cmp function for determining which segments should take visual priority
    EventRenderer.prototype.compareEventSegs = function (seg1, seg2) {
        var f1 = seg1.footprint;
        var f2 = seg2.footprint;
        var cf1 = f1.componentFootprint;
        var cf2 = f2.componentFootprint;
        var r1 = cf1.unzonedRange;
        var r2 = cf2.unzonedRange;
        return r1.startMs - r2.startMs || // earlier events go first
            (r2.endMs - r2.startMs) - (r1.endMs - r1.startMs) || // tie? longer events go first
            cf2.isAllDay - cf1.isAllDay || // tie? put all-day events first (booleans cast to 0/1)
            util_1.compareByFieldSpecs(f1.eventDef, f2.eventDef, this.view.eventOrderSpecs, f1.eventDef.miscProps, f2.eventDef.miscProps);
    };
    return EventRenderer;
}());
exports.default = EventRenderer;


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment_ext_1 = __webpack_require__(10);
// Plugin
// -------------------------------------------------------------------------------------------------
moment_ext_1.newMomentProto.format = function () {
    if (this._fullCalendar && arguments[0]) {
        return formatDate(this, arguments[0]); // our extended formatting
    }
    if (this._ambigTime) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
    }
    if (this._ambigZone) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
    }
    if (this._fullCalendar) {
        // moment.format() doesn't ensure english, but we want to.
        return moment_ext_1.oldMomentFormat(englishMoment(this));
    }
    return moment_ext_1.oldMomentProto.format.apply(this, arguments);
};
moment_ext_1.newMomentProto.toISOString = function () {
    if (this._ambigTime) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
    }
    if (this._ambigZone) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
    }
    if (this._fullCalendar) {
        // depending on browser, moment might not output english. ensure english.
        // https://github.com/moment/moment/blob/2.18.1/src/lib/moment/format.js#L22
        return moment_ext_1.oldMomentProto.toISOString.apply(englishMoment(this), arguments);
    }
    return moment_ext_1.oldMomentProto.toISOString.apply(this, arguments);
};
function englishMoment(mom) {
    if (mom.locale() !== 'en') {
        return mom.clone().locale('en');
    }
    return mom;
}
// Config
// ---------------------------------------------------------------------------------------------------------------------
/*
Inserted between chunks in the fake ("intermediate") formatting string.
Important that it passes as whitespace (\s) because moment often identifies non-standalone months
via a regexp with an \s.
*/
var PART_SEPARATOR = '\u000b'; // vertical tab
/*
Inserted as the first character of a literal-text chunk to indicate that the literal text is not actually literal text,
but rather, a "special" token that has custom rendering (see specialTokens map).
*/
var SPECIAL_TOKEN_MARKER = '\u001f'; // information separator 1
/*
Inserted at the beginning and end of a span of text that must have non-zero numeric characters.
Handling of these markers is done in a post-processing step at the very end of text rendering.
*/
var MAYBE_MARKER = '\u001e'; // information separator 2
var MAYBE_REGEXP = new RegExp(MAYBE_MARKER + '([^' + MAYBE_MARKER + ']*)' + MAYBE_MARKER, 'g'); // must be global
/*
Addition formatting tokens we want recognized
*/
var specialTokens = {
    t: function (date) {
        return moment_ext_1.oldMomentFormat(date, 'a').charAt(0);
    },
    T: function (date) {
        return moment_ext_1.oldMomentFormat(date, 'A').charAt(0);
    }
};
/*
The first characters of formatting tokens for units that are 1 day or larger.
`value` is for ranking relative size (lower means bigger).
`unit` is a normalized unit, used for comparing moments.
*/
var largeTokenMap = {
    Y: { value: 1, unit: 'year' },
    M: { value: 2, unit: 'month' },
    W: { value: 3, unit: 'week' },
    w: { value: 3, unit: 'week' },
    D: { value: 4, unit: 'day' },
    d: { value: 4, unit: 'day' } // day of week
};
// Single Date Formatting
// ---------------------------------------------------------------------------------------------------------------------
/*
Formats `date` with a Moment formatting string, but allow our non-zero areas and special token
*/
function formatDate(date, formatStr) {
    return renderFakeFormatString(getParsedFormatString(formatStr).fakeFormatString, date);
}
exports.formatDate = formatDate;
// Date Range Formatting
// -------------------------------------------------------------------------------------------------
// TODO: make it work with timezone offset
/*
Using a formatting string meant for a single date, generate a range string, like
"Sep 2 - 9 2013", that intelligently inserts a separator where the dates differ.
If the dates are the same as far as the format string is concerned, just return a single
rendering of one date, without any separator.
*/
function formatRange(date1, date2, formatStr, separator, isRTL) {
    var localeData;
    date1 = moment_ext_1.default.parseZone(date1);
    date2 = moment_ext_1.default.parseZone(date2);
    localeData = date1.localeData();
    // Expand localized format strings, like "LL" -> "MMMM D YYYY".
    // BTW, this is not important for `formatDate` because it is impossible to put custom tokens
    // or non-zero areas in Moment's localized format strings.
    formatStr = localeData.longDateFormat(formatStr) || formatStr;
    return renderParsedFormat(getParsedFormatString(formatStr), date1, date2, separator || ' - ', isRTL);
}
exports.formatRange = formatRange;
/*
Renders a range with an already-parsed format string.
*/
function renderParsedFormat(parsedFormat, date1, date2, separator, isRTL) {
    var sameUnits = parsedFormat.sameUnits;
    var unzonedDate1 = date1.clone().stripZone(); // for same-unit comparisons
    var unzonedDate2 = date2.clone().stripZone(); // "
    var renderedParts1 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date1);
    var renderedParts2 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date2);
    var leftI;
    var leftStr = '';
    var rightI;
    var rightStr = '';
    var middleI;
    var middleStr1 = '';
    var middleStr2 = '';
    var middleStr = '';
    // Start at the leftmost side of the formatting string and continue until you hit a token
    // that is not the same between dates.
    for (leftI = 0; leftI < sameUnits.length && (!sameUnits[leftI] || unzonedDate1.isSame(unzonedDate2, sameUnits[leftI])); leftI++) {
        leftStr += renderedParts1[leftI];
    }
    // Similarly, start at the rightmost side of the formatting string and move left
    for (rightI = sameUnits.length - 1; rightI > leftI && (!sameUnits[rightI] || unzonedDate1.isSame(unzonedDate2, sameUnits[rightI])); rightI--) {
        // If current chunk is on the boundary of unique date-content, and is a special-case
        // date-formatting postfix character, then don't consume it. Consider it unique date-content.
        // TODO: make configurable
        if (rightI - 1 === leftI && renderedParts1[rightI] === '.') {
            break;
        }
        rightStr = renderedParts1[rightI] + rightStr;
    }
    // The area in the middle is different for both of the dates.
    // Collect them distinctly so we can jam them together later.
    for (middleI = leftI; middleI <= rightI; middleI++) {
        middleStr1 += renderedParts1[middleI];
        middleStr2 += renderedParts2[middleI];
    }
    if (middleStr1 || middleStr2) {
        if (isRTL) {
            middleStr = middleStr2 + separator + middleStr1;
        }
        else {
            middleStr = middleStr1 + separator + middleStr2;
        }
    }
    return processMaybeMarkers(leftStr + middleStr + rightStr);
}
// Format String Parsing
// ---------------------------------------------------------------------------------------------------------------------
var parsedFormatStrCache = {};
/*
Returns a parsed format string, leveraging a cache.
*/
function getParsedFormatString(formatStr) {
    return parsedFormatStrCache[formatStr] ||
        (parsedFormatStrCache[formatStr] = parseFormatString(formatStr));
}
/*
Parses a format string into the following:
- fakeFormatString: a momentJS formatting string, littered with special control characters that get post-processed.
- sameUnits: for every part in fakeFormatString, if the part is a token, the value will be a unit string (like "day"),
  that indicates how similar a range's start & end must be in order to share the same formatted text.
  If not a token, then the value is null.
  Always a flat array (not nested liked "chunks").
*/
function parseFormatString(formatStr) {
    var chunks = chunkFormatString(formatStr);
    return {
        fakeFormatString: buildFakeFormatString(chunks),
        sameUnits: buildSameUnits(chunks)
    };
}
/*
Break the formatting string into an array of chunks.
A 'maybe' chunk will have nested chunks.
*/
function chunkFormatString(formatStr) {
    var chunks = [];
    var match;
    // TODO: more descrimination
    // \4 is a backreference to the first character of a multi-character set.
    var chunker = /\[([^\]]*)\]|\(([^\)]*)\)|(LTS|LT|(\w)\4*o?)|([^\w\[\(]+)/g;
    while ((match = chunker.exec(formatStr))) {
        if (match[1]) {
            chunks.push.apply(chunks, // append
            splitStringLiteral(match[1]));
        }
        else if (match[2]) {
            chunks.push({ maybe: chunkFormatString(match[2]) });
        }
        else if (match[3]) {
            chunks.push({ token: match[3] });
        }
        else if (match[5]) {
            chunks.push.apply(chunks, // append
            splitStringLiteral(match[5]));
        }
    }
    return chunks;
}
/*
Potentially splits a literal-text string into multiple parts. For special cases.
*/
function splitStringLiteral(s) {
    if (s === '. ') {
        return ['.', ' ']; // for locales with periods bound to the end of each year/month/date
    }
    else {
        return [s];
    }
}
/*
Given chunks parsed from a real format string, generate a fake (aka "intermediate") format string with special control
characters that will eventually be given to moment for formatting, and then post-processed.
*/
function buildFakeFormatString(chunks) {
    var parts = [];
    var i;
    var chunk;
    for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];
        if (typeof chunk === 'string') {
            parts.push('[' + chunk + ']');
        }
        else if (chunk.token) {
            if (chunk.token in specialTokens) {
                parts.push(SPECIAL_TOKEN_MARKER + // useful during post-processing
                    '[' + chunk.token + ']' // preserve as literal text
                );
            }
            else {
                parts.push(chunk.token); // unprotected text implies a format string
            }
        }
        else if (chunk.maybe) {
            parts.push(MAYBE_MARKER + // useful during post-processing
                buildFakeFormatString(chunk.maybe) +
                MAYBE_MARKER);
        }
    }
    return parts.join(PART_SEPARATOR);
}
/*
Given parsed chunks from a real formatting string, generates an array of unit strings (like "day") that indicate
in which regard two dates must be similar in order to share range formatting text.
The `chunks` can be nested (because of "maybe" chunks), however, the returned array will be flat.
*/
function buildSameUnits(chunks) {
    var units = [];
    var i;
    var chunk;
    var tokenInfo;
    for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];
        if (chunk.token) {
            tokenInfo = largeTokenMap[chunk.token.charAt(0)];
            units.push(tokenInfo ? tokenInfo.unit : 'second'); // default to a very strict same-second
        }
        else if (chunk.maybe) {
            units.push.apply(units, // append
            buildSameUnits(chunk.maybe));
        }
        else {
            units.push(null);
        }
    }
    return units;
}
// Rendering to text
// ---------------------------------------------------------------------------------------------------------------------
/*
Formats a date with a fake format string, post-processes the control characters, then returns.
*/
function renderFakeFormatString(fakeFormatString, date) {
    return processMaybeMarkers(renderFakeFormatStringParts(fakeFormatString, date).join(''));
}
/*
Formats a date into parts that will have been post-processed, EXCEPT for the "maybe" markers.
*/
function renderFakeFormatStringParts(fakeFormatString, date) {
    var parts = [];
    var fakeRender = moment_ext_1.oldMomentFormat(date, fakeFormatString);
    var fakeParts = fakeRender.split(PART_SEPARATOR);
    var i;
    var fakePart;
    for (i = 0; i < fakeParts.length; i++) {
        fakePart = fakeParts[i];
        if (fakePart.charAt(0) === SPECIAL_TOKEN_MARKER) {
            parts.push(
            // the literal string IS the token's name.
            // call special token's registered function.
            specialTokens[fakePart.substring(1)](date));
        }
        else {
            parts.push(fakePart);
        }
    }
    return parts;
}
/*
Accepts an almost-finally-formatted string and processes the "maybe" control characters, returning a new string.
*/
function processMaybeMarkers(s) {
    return s.replace(MAYBE_REGEXP, function (m0, m1) {
        if (m1.match(/[1-9]/)) {
            return m1;
        }
        else {
            return '';
        }
    });
}
// Misc Utils
// -------------------------------------------------------------------------------------------------
/*
Returns a unit string, either 'year', 'month', 'day', or null for the most granular formatting token in the string.
*/
function queryMostGranularFormatUnit(formatStr) {
    var chunks = chunkFormatString(formatStr);
    var i;
    var chunk;
    var candidate;
    var best;
    for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];
        if (chunk.token) {
            candidate = largeTokenMap[chunk.token.charAt(0)];
            if (candidate) {
                if (!best || candidate.value > best.value) {
                    best = candidate;
                }
            }
        }
    }
    if (best) {
        return best.unit;
    }
    return null;
}
exports.queryMostGranularFormatUnit = queryMostGranularFormatUnit;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Class_1 = __webpack_require__(32);
var EmitterMixin_1 = __webpack_require__(11);
var ListenerMixin_1 = __webpack_require__(7);
var Model = /** @class */ (function (_super) {
    tslib_1.__extends(Model, _super);
    function Model() {
        var _this = _super.call(this) || this;
        _this._watchers = {};
        _this._props = {};
        _this.applyGlobalWatchers();
        _this.constructed();
        return _this;
    }
    Model.watch = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // subclasses should make a masked-copy of the superclass's map
        // TODO: write test
        if (!this.prototype.hasOwnProperty('_globalWatchArgs')) {
            this.prototype._globalWatchArgs = Object.create(this.prototype._globalWatchArgs);
        }
        this.prototype._globalWatchArgs[name] = args;
    };
    Model.prototype.constructed = function () {
        // useful for monkeypatching. TODO: BaseClass?
    };
    Model.prototype.applyGlobalWatchers = function () {
        var map = this._globalWatchArgs;
        var name;
        for (name in map) {
            this.watch.apply(this, [name].concat(map[name]));
        }
    };
    Model.prototype.has = function (name) {
        return name in this._props;
    };
    Model.prototype.get = function (name) {
        if (name === undefined) {
            return this._props;
        }
        return this._props[name];
    };
    Model.prototype.set = function (name, val) {
        var newProps;
        if (typeof name === 'string') {
            newProps = {};
            newProps[name] = val === undefined ? null : val;
        }
        else {
            newProps = name;
        }
        this.setProps(newProps);
    };
    Model.prototype.reset = function (newProps) {
        var oldProps = this._props;
        var changeset = {}; // will have undefined's to signal unsets
        var name;
        for (name in oldProps) {
            changeset[name] = undefined;
        }
        for (name in newProps) {
            changeset[name] = newProps[name];
        }
        this.setProps(changeset);
    };
    Model.prototype.unset = function (name) {
        var newProps = {};
        var names;
        var i;
        if (typeof name === 'string') {
            names = [name];
        }
        else {
            names = name;
        }
        for (i = 0; i < names.length; i++) {
            newProps[names[i]] = undefined;
        }
        this.setProps(newProps);
    };
    Model.prototype.setProps = function (newProps) {
        var changedProps = {};
        var changedCnt = 0;
        var name;
        var val;
        for (name in newProps) {
            val = newProps[name];
            // a change in value?
            // if an object, don't check equality, because might have been mutated internally.
            // TODO: eventually enforce immutability.
            if (typeof val === 'object' ||
                val !== this._props[name]) {
                changedProps[name] = val;
                changedCnt++;
            }
        }
        if (changedCnt) {
            this.trigger('before:batchChange', changedProps);
            for (name in changedProps) {
                val = changedProps[name];
                this.trigger('before:change', name, val);
                this.trigger('before:change:' + name, val);
            }
            for (name in changedProps) {
                val = changedProps[name];
                if (val === undefined) {
                    delete this._props[name];
                }
                else {
                    this._props[name] = val;
                }
                this.trigger('change:' + name, val);
                this.trigger('change', name, val);
            }
            this.trigger('batchChange', changedProps);
        }
    };
    Model.prototype.watch = function (name, depList, startFunc, stopFunc) {
        var _this = this;
        this.unwatch(name);
        this._watchers[name] = this._watchDeps(depList, function (deps) {
            var res = startFunc.call(_this, deps);
            if (res && res.then) {
                _this.unset(name); // put in an unset state while resolving
                res.then(function (val) {
                    _this.set(name, val);
                });
            }
            else {
                _this.set(name, res);
            }
        }, function (deps) {
            _this.unset(name);
            if (stopFunc) {
                stopFunc.call(_this, deps);
            }
        });
    };
    Model.prototype.unwatch = function (name) {
        var watcher = this._watchers[name];
        if (watcher) {
            delete this._watchers[name];
            watcher.teardown();
        }
    };
    Model.prototype._watchDeps = function (depList, startFunc, stopFunc) {
        var _this = this;
        var queuedChangeCnt = 0;
        var depCnt = depList.length;
        var satisfyCnt = 0;
        var values = {}; // what's passed as the `deps` arguments
        var bindTuples = []; // array of [ eventName, handlerFunc ] arrays
        var isCallingStop = false;
        var onBeforeDepChange = function (depName, val, isOptional) {
            queuedChangeCnt++;
            if (queuedChangeCnt === 1) {
                if (satisfyCnt === depCnt) {
                    isCallingStop = true;
                    stopFunc(values);
                    isCallingStop = false;
                }
            }
        };
        var onDepChange = function (depName, val, isOptional) {
            if (val === undefined) {
                // required dependency that was previously set?
                if (!isOptional && values[depName] !== undefined) {
                    satisfyCnt--;
                }
                delete values[depName];
            }
            else {
                // required dependency that was previously unset?
                if (!isOptional && values[depName] === undefined) {
                    satisfyCnt++;
                }
                values[depName] = val;
            }
            queuedChangeCnt--;
            if (!queuedChangeCnt) {
                // now finally satisfied or satisfied all along?
                if (satisfyCnt === depCnt) {
                    // if the stopFunc initiated another value change, ignore it.
                    // it will be processed by another change event anyway.
                    if (!isCallingStop) {
                        startFunc(values);
                    }
                }
            }
        };
        // intercept for .on() that remembers handlers
        var bind = function (eventName, handler) {
            _this.on(eventName, handler);
            bindTuples.push([eventName, handler]);
        };
        // listen to dependency changes
        depList.forEach(function (depName) {
            var isOptional = false;
            if (depName.charAt(0) === '?') {
                depName = depName.substring(1);
                isOptional = true;
            }
            bind('before:change:' + depName, function (val) {
                onBeforeDepChange(depName, val, isOptional);
            });
            bind('change:' + depName, function (val) {
                onDepChange(depName, val, isOptional);
            });
        });
        // process current dependency values
        depList.forEach(function (depName) {
            var isOptional = false;
            if (depName.charAt(0) === '?') {
                depName = depName.substring(1);
                isOptional = true;
            }
            if (_this.has(depName)) {
                values[depName] = _this.get(depName);
                satisfyCnt++;
            }
            else if (isOptional) {
                satisfyCnt++;
            }
        });
        // initially satisfied
        if (satisfyCnt === depCnt) {
            startFunc(values);
        }
        return {
            teardown: function () {
                // remove all handlers
                for (var i = 0; i < bindTuples.length; i++) {
                    _this.off(bindTuples[i][0], bindTuples[i][1]);
                }
                bindTuples = null;
                // was satisfied, so call stopFunc
                if (satisfyCnt === depCnt) {
                    stopFunc();
                }
            },
            flash: function () {
                if (satisfyCnt === depCnt) {
                    stopFunc();
                    startFunc(values);
                }
            }
        };
    };
    Model.prototype.flash = function (name) {
        var watcher = this._watchers[name];
        if (watcher) {
            watcher.flash();
        }
    };
    return Model;
}(Class_1.default));
exports.default = Model;
Model.prototype._globalWatchArgs = {}; // mutation protection in Model.watch
EmitterMixin_1.default.mixInto(Model);
ListenerMixin_1.default.mixInto(Model);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var SingleEventDef_1 = __webpack_require__(13);
var RecurringEventDef_1 = __webpack_require__(210);
exports.default = {
    parse: function (eventInput, source) {
        if (util_1.isTimeString(eventInput.start) || moment.isDuration(eventInput.start) ||
            util_1.isTimeString(eventInput.end) || moment.isDuration(eventInput.end)) {
            return RecurringEventDef_1.default.parse(eventInput, source);
        }
        else {
            return SingleEventDef_1.default.parse(eventInput, source);
        }
    }
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(4);
var EventDateProfile_1 = __webpack_require__(17);
var EventDefDateMutation = /** @class */ (function () {
    function EventDefDateMutation() {
        this.clearEnd = false;
        this.forceTimed = false;
        this.forceAllDay = false;
    }
    EventDefDateMutation.createFromDiff = function (dateProfile0, dateProfile1, largeUnit) {
        var clearEnd = dateProfile0.end && !dateProfile1.end;
        var forceTimed = dateProfile0.isAllDay() && !dateProfile1.isAllDay();
        var forceAllDay = !dateProfile0.isAllDay() && dateProfile1.isAllDay();
        var dateDelta;
        var endDiff;
        var endDelta;
        var mutation;
        // subtracts the dates in the appropriate way, returning a duration
        function subtractDates(date1, date0) {
            if (largeUnit) {
                return util_1.diffByUnit(date1, date0, largeUnit); // poorly named
            }
            else if (dateProfile1.isAllDay()) {
                return util_1.diffDay(date1, date0); // poorly named
            }
            else {
                return util_1.diffDayTime(date1, date0); // poorly named
            }
        }
        dateDelta = subtractDates(dateProfile1.start, dateProfile0.start);
        if (dateProfile1.end) {
            // use unzonedRanges because dateProfile0.end might be null
            endDiff = subtractDates(dateProfile1.unzonedRange.getEnd(), dateProfile0.unzonedRange.getEnd());
            endDelta = endDiff.subtract(dateDelta);
        }
        mutation = new EventDefDateMutation();
        mutation.clearEnd = clearEnd;
        mutation.forceTimed = forceTimed;
        mutation.forceAllDay = forceAllDay;
        mutation.setDateDelta(dateDelta);
        mutation.setEndDelta(endDelta);
        return mutation;
    };
    /*
    returns an undo function.
    */
    EventDefDateMutation.prototype.buildNewDateProfile = function (eventDateProfile, calendar) {
        var start = eventDateProfile.start.clone();
        var end = null;
        var shouldRezone = false;
        if (eventDateProfile.end && !this.clearEnd) {
            end = eventDateProfile.end.clone();
        }
        else if (this.endDelta && !end) {
            end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
        }
        if (this.forceTimed) {
            shouldRezone = true;
            if (!start.hasTime()) {
                start.time(0);
            }
            if (end && !end.hasTime()) {
                end.time(0);
            }
        }
        else if (this.forceAllDay) {
            if (start.hasTime()) {
                start.stripTime();
            }
            if (end && end.hasTime()) {
                end.stripTime();
            }
        }
        if (this.dateDelta) {
            shouldRezone = true;
            start.add(this.dateDelta);
            if (end) {
                end.add(this.dateDelta);
            }
        }
        // do this before adding startDelta to start, so we can work off of start
        if (this.endDelta) {
            shouldRezone = true;
            end.add(this.endDelta);
        }
        if (this.startDelta) {
            shouldRezone = true;
            start.add(this.startDelta);
        }
        if (shouldRezone) {
            start = calendar.applyTimezone(start);
            if (end) {
                end = calendar.applyTimezone(end);
            }
        }
        // TODO: okay to access calendar option?
        if (!end && calendar.opt('forceEventDuration')) {
            end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
        }
        return new EventDateProfile_1.default(start, end, calendar);
    };
    EventDefDateMutation.prototype.setDateDelta = function (dateDelta) {
        if (dateDelta && dateDelta.valueOf()) {
            this.dateDelta = dateDelta;
        }
        else {
            this.dateDelta = null;
        }
    };
    EventDefDateMutation.prototype.setStartDelta = function (startDelta) {
        if (startDelta && startDelta.valueOf()) {
            this.startDelta = startDelta;
        }
        else {
            this.startDelta = null;
        }
    };
    EventDefDateMutation.prototype.setEndDelta = function (endDelta) {
        if (endDelta && endDelta.valueOf()) {
            this.endDelta = endDelta;
        }
        else {
            this.endDelta = null;
        }
    };
    EventDefDateMutation.prototype.isEmpty = function () {
        return !this.clearEnd && !this.forceTimed && !this.forceAllDay &&
            !this.dateDelta && !this.startDelta && !this.endDelta;
    };
    return EventDefDateMutation;
}());
exports.default = EventDefDateMutation;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var StandardTheme_1 = __webpack_require__(213);
var JqueryUiTheme_1 = __webpack_require__(214);
var themeClassHash = {};
function defineThemeSystem(themeName, themeClass) {
    themeClassHash[themeName] = themeClass;
}
exports.defineThemeSystem = defineThemeSystem;
function getThemeSystemClass(themeSetting) {
    if (!themeSetting) {
        return StandardTheme_1.default;
    }
    else if (themeSetting === true) {
        return JqueryUiTheme_1.default;
    }
    else {
        return themeClassHash[themeSetting];
    }
}
exports.getThemeSystemClass = getThemeSystemClass;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Promise_1 = __webpack_require__(19);
var EventSource_1 = __webpack_require__(6);
var SingleEventDef_1 = __webpack_require__(13);
var ArrayEventSource = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayEventSource, _super);
    function ArrayEventSource(calendar) {
        var _this = _super.call(this, calendar) || this;
        _this.eventDefs = []; // for if setRawEventDefs is never called
        return _this;
    }
    ArrayEventSource.parse = function (rawInput, calendar) {
        var rawProps;
        // normalize raw input
        if ($.isArray(rawInput.events)) {
            rawProps = rawInput;
        }
        else if ($.isArray(rawInput)) {
            rawProps = { events: rawInput };
        }
        if (rawProps) {
            return EventSource_1.default.parse.call(this, rawProps, calendar);
        }
        return false;
    };
    ArrayEventSource.prototype.setRawEventDefs = function (rawEventDefs) {
        this.rawEventDefs = rawEventDefs;
        this.eventDefs = this.parseEventDefs(rawEventDefs);
    };
    ArrayEventSource.prototype.fetch = function (start, end, timezone) {
        var eventDefs = this.eventDefs;
        var i;
        if (this.currentTimezone != null &&
            this.currentTimezone !== timezone) {
            for (i = 0; i < eventDefs.length; i++) {
                if (eventDefs[i] instanceof SingleEventDef_1.default) {
                    eventDefs[i].rezone();
                }
            }
        }
        this.currentTimezone = timezone;
        return Promise_1.default.resolve(eventDefs);
    };
    ArrayEventSource.prototype.addEventDef = function (eventDef) {
        this.eventDefs.push(eventDef);
    };
    /*
    eventDefId already normalized to a string
    */
    ArrayEventSource.prototype.removeEventDefsById = function (eventDefId) {
        return util_1.removeMatching(this.eventDefs, function (eventDef) {
            return eventDef.id === eventDefId;
        });
    };
    ArrayEventSource.prototype.removeAllEventDefs = function () {
        this.eventDefs = [];
    };
    ArrayEventSource.prototype.getPrimitive = function () {
        return this.rawEventDefs;
    };
    ArrayEventSource.prototype.applyManualStandardProps = function (rawProps) {
        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
        this.setRawEventDefs(rawProps.events);
        return superSuccess;
    };
    return ArrayEventSource;
}(EventSource_1.default));
exports.default = ArrayEventSource;
ArrayEventSource.defineStandardProps({
    events: false // don't automatically transfer
});


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
/*
A cache for the left/right/top/bottom/width/height values for one or more elements.
Works with both offset (from topleft document) and position (from offsetParent).

options:
- els
- isHorizontal
- isVertical
*/
var CoordCache = /** @class */ (function () {
    function CoordCache(options) {
        this.isHorizontal = false; // whether to query for left/right/width
        this.isVertical = false; // whether to query for top/bottom/height
        this.els = $(options.els);
        this.isHorizontal = options.isHorizontal;
        this.isVertical = options.isVertical;
        this.forcedOffsetParentEl = options.offsetParent ? $(options.offsetParent) : null;
    }
    // Queries the els for coordinates and stores them.
    // Call this method before using and of the get* methods below.
    CoordCache.prototype.build = function () {
        var offsetParentEl = this.forcedOffsetParentEl;
        if (!offsetParentEl && this.els.length > 0) {
            offsetParentEl = this.els.eq(0).offsetParent();
        }
        this.origin = offsetParentEl ?
            offsetParentEl.offset() :
            null;
        this.boundingRect = this.queryBoundingRect();
        if (this.isHorizontal) {
            this.buildElHorizontals();
        }
        if (this.isVertical) {
            this.buildElVerticals();
        }
    };
    // Destroys all internal data about coordinates, freeing memory
    CoordCache.prototype.clear = function () {
        this.origin = null;
        this.boundingRect = null;
        this.lefts = null;
        this.rights = null;
        this.tops = null;
        this.bottoms = null;
    };
    // When called, if coord caches aren't built, builds them
    CoordCache.prototype.ensureBuilt = function () {
        if (!this.origin) {
            this.build();
        }
    };
    // Populates the left/right internal coordinate arrays
    CoordCache.prototype.buildElHorizontals = function () {
        var lefts = [];
        var rights = [];
        this.els.each(function (i, node) {
            var el = $(node);
            var left = el.offset().left;
            var width = el.outerWidth();
            lefts.push(left);
            rights.push(left + width);
        });
        this.lefts = lefts;
        this.rights = rights;
    };
    // Populates the top/bottom internal coordinate arrays
    CoordCache.prototype.buildElVerticals = function () {
        var tops = [];
        var bottoms = [];
        this.els.each(function (i, node) {
            var el = $(node);
            var top = el.offset().top;
            var height = el.outerHeight();
            tops.push(top);
            bottoms.push(top + height);
        });
        this.tops = tops;
        this.bottoms = bottoms;
    };
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    CoordCache.prototype.getHorizontalIndex = function (leftOffset) {
        this.ensureBuilt();
        var lefts = this.lefts;
        var rights = this.rights;
        var len = lefts.length;
        var i;
        for (i = 0; i < len; i++) {
            if (leftOffset >= lefts[i] && leftOffset < rights[i]) {
                return i;
            }
        }
    };
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    CoordCache.prototype.getVerticalIndex = function (topOffset) {
        this.ensureBuilt();
        var tops = this.tops;
        var bottoms = this.bottoms;
        var len = tops.length;
        var i;
        for (i = 0; i < len; i++) {
            if (topOffset >= tops[i] && topOffset < bottoms[i]) {
                return i;
            }
        }
    };
    // Gets the left offset (from document left) of the element at the given index
    CoordCache.prototype.getLeftOffset = function (leftIndex) {
        this.ensureBuilt();
        return this.lefts[leftIndex];
    };
    // Gets the left position (from offsetParent left) of the element at the given index
    CoordCache.prototype.getLeftPosition = function (leftIndex) {
        this.ensureBuilt();
        return this.lefts[leftIndex] - this.origin.left;
    };
    // Gets the right offset (from document left) of the element at the given index.
    // This value is NOT relative to the document's right edge, like the CSS concept of "right" would be.
    CoordCache.prototype.getRightOffset = function (leftIndex) {
        this.ensureBuilt();
        return this.rights[leftIndex];
    };
    // Gets the right position (from offsetParent left) of the element at the given index.
    // This value is NOT relative to the offsetParent's right edge, like the CSS concept of "right" would be.
    CoordCache.prototype.getRightPosition = function (leftIndex) {
        this.ensureBuilt();
        return this.rights[leftIndex] - this.origin.left;
    };
    // Gets the width of the element at the given index
    CoordCache.prototype.getWidth = function (leftIndex) {
        this.ensureBuilt();
        return this.rights[leftIndex] - this.lefts[leftIndex];
    };
    // Gets the top offset (from document top) of the element at the given index
    CoordCache.prototype.getTopOffset = function (topIndex) {
        this.ensureBuilt();
        return this.tops[topIndex];
    };
    // Gets the top position (from offsetParent top) of the element at the given position
    CoordCache.prototype.getTopPosition = function (topIndex) {
        this.ensureBuilt();
        return this.tops[topIndex] - this.origin.top;
    };
    // Gets the bottom offset (from the document top) of the element at the given index.
    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
    CoordCache.prototype.getBottomOffset = function (topIndex) {
        this.ensureBuilt();
        return this.bottoms[topIndex];
    };
    // Gets the bottom position (from the offsetParent top) of the element at the given index.
    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
    CoordCache.prototype.getBottomPosition = function (topIndex) {
        this.ensureBuilt();
        return this.bottoms[topIndex] - this.origin.top;
    };
    // Gets the height of the element at the given index
    CoordCache.prototype.getHeight = function (topIndex) {
        this.ensureBuilt();
        return this.bottoms[topIndex] - this.tops[topIndex];
    };
    // Bounding Rect
    // TODO: decouple this from CoordCache
    // Compute and return what the elements' bounding rectangle is, from the user's perspective.
    // Right now, only returns a rectangle if constrained by an overflow:scroll element.
    // Returns null if there are no elements
    CoordCache.prototype.queryBoundingRect = function () {
        var scrollParentEl;
        if (this.els.length > 0) {
            scrollParentEl = util_1.getScrollParent(this.els.eq(0));
            if (!scrollParentEl.is(document)) {
                return util_1.getClientRect(scrollParentEl);
            }
        }
        return null;
    };
    CoordCache.prototype.isPointInBounds = function (leftOffset, topOffset) {
        return this.isLeftInBounds(leftOffset) && this.isTopInBounds(topOffset);
    };
    CoordCache.prototype.isLeftInBounds = function (leftOffset) {
        return !this.boundingRect || (leftOffset >= this.boundingRect.left && leftOffset < this.boundingRect.right);
    };
    CoordCache.prototype.isTopInBounds = function (topOffset) {
        return !this.boundingRect || (topOffset >= this.boundingRect.top && topOffset < this.boundingRect.bottom);
    };
    return CoordCache;
}());
exports.default = CoordCache;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var ListenerMixin_1 = __webpack_require__(7);
var GlobalEmitter_1 = __webpack_require__(20);
/* Tracks a drag's mouse movement, firing various handlers
----------------------------------------------------------------------------------------------------------------------*/
// TODO: use Emitter
var DragListener = /** @class */ (function () {
    function DragListener(options) {
        this.isInteracting = false;
        this.isDistanceSurpassed = false;
        this.isDelayEnded = false;
        this.isDragging = false;
        this.isTouch = false;
        this.isGeneric = false; // initiated by 'dragstart' (jqui)
        this.shouldCancelTouchScroll = true;
        this.scrollAlwaysKills = false;
        this.isAutoScroll = false;
        // defaults
        this.scrollSensitivity = 30; // pixels from edge for scrolling to start
        this.scrollSpeed = 200; // pixels per second, at maximum speed
        this.scrollIntervalMs = 50; // millisecond wait between scroll increment
        this.options = options || {};
    }
    // Interaction (high-level)
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.startInteraction = function (ev, extraOptions) {
        if (extraOptions === void 0) { extraOptions = {}; }
        if (ev.type === 'mousedown') {
            if (GlobalEmitter_1.default.get().shouldIgnoreMouse()) {
                return;
            }
            else if (!util_1.isPrimaryMouseButton(ev)) {
                return;
            }
            else {
                ev.preventDefault(); // prevents native selection in most browsers
            }
        }
        if (!this.isInteracting) {
            // process options
            this.delay = util_1.firstDefined(extraOptions.delay, this.options.delay, 0);
            this.minDistance = util_1.firstDefined(extraOptions.distance, this.options.distance, 0);
            this.subjectEl = this.options.subjectEl;
            util_1.preventSelection($('body'));
            this.isInteracting = true;
            this.isTouch = util_1.getEvIsTouch(ev);
            this.isGeneric = ev.type === 'dragstart';
            this.isDelayEnded = false;
            this.isDistanceSurpassed = false;
            this.originX = util_1.getEvX(ev);
            this.originY = util_1.getEvY(ev);
            this.scrollEl = util_1.getScrollParent($(ev.target));
            this.bindHandlers();
            this.initAutoScroll();
            this.handleInteractionStart(ev);
            this.startDelay(ev);
            if (!this.minDistance) {
                this.handleDistanceSurpassed(ev);
            }
        }
    };
    DragListener.prototype.handleInteractionStart = function (ev) {
        this.trigger('interactionStart', ev);
    };
    DragListener.prototype.endInteraction = function (ev, isCancelled) {
        if (this.isInteracting) {
            this.endDrag(ev);
            if (this.delayTimeoutId) {
                clearTimeout(this.delayTimeoutId);
                this.delayTimeoutId = null;
            }
            this.destroyAutoScroll();
            this.unbindHandlers();
            this.isInteracting = false;
            this.handleInteractionEnd(ev, isCancelled);
            util_1.allowSelection($('body'));
        }
    };
    DragListener.prototype.handleInteractionEnd = function (ev, isCancelled) {
        this.trigger('interactionEnd', ev, isCancelled || false);
    };
    // Binding To DOM
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.bindHandlers = function () {
        // some browsers (Safari in iOS 10) don't allow preventDefault on touch events that are bound after touchstart,
        // so listen to the GlobalEmitter singleton, which is always bound, instead of the document directly.
        var globalEmitter = GlobalEmitter_1.default.get();
        if (this.isGeneric) {
            this.listenTo($(document), {
                drag: this.handleMove,
                dragstop: this.endInteraction
            });
        }
        else if (this.isTouch) {
            this.listenTo(globalEmitter, {
                touchmove: this.handleTouchMove,
                touchend: this.endInteraction,
                scroll: this.handleTouchScroll
            });
        }
        else {
            this.listenTo(globalEmitter, {
                mousemove: this.handleMouseMove,
                mouseup: this.endInteraction
            });
        }
        this.listenTo(globalEmitter, {
            selectstart: util_1.preventDefault,
            contextmenu: util_1.preventDefault // long taps would open menu on Chrome dev tools
        });
    };
    DragListener.prototype.unbindHandlers = function () {
        this.stopListeningTo(GlobalEmitter_1.default.get());
        this.stopListeningTo($(document)); // for isGeneric
    };
    // Drag (high-level)
    // -----------------------------------------------------------------------------------------------------------------
    // extraOptions ignored if drag already started
    DragListener.prototype.startDrag = function (ev, extraOptions) {
        this.startInteraction(ev, extraOptions); // ensure interaction began
        if (!this.isDragging) {
            this.isDragging = true;
            this.handleDragStart(ev);
        }
    };
    DragListener.prototype.handleDragStart = function (ev) {
        this.trigger('dragStart', ev);
    };
    DragListener.prototype.handleMove = function (ev) {
        var dx = util_1.getEvX(ev) - this.originX;
        var dy = util_1.getEvY(ev) - this.originY;
        var minDistance = this.minDistance;
        var distanceSq; // current distance from the origin, squared
        if (!this.isDistanceSurpassed) {
            distanceSq = dx * dx + dy * dy;
            if (distanceSq >= minDistance * minDistance) {
                this.handleDistanceSurpassed(ev);
            }
        }
        if (this.isDragging) {
            this.handleDrag(dx, dy, ev);
        }
    };
    // Called while the mouse is being moved and when we know a legitimate drag is taking place
    DragListener.prototype.handleDrag = function (dx, dy, ev) {
        this.trigger('drag', dx, dy, ev);
        this.updateAutoScroll(ev); // will possibly cause scrolling
    };
    DragListener.prototype.endDrag = function (ev) {
        if (this.isDragging) {
            this.isDragging = false;
            this.handleDragEnd(ev);
        }
    };
    DragListener.prototype.handleDragEnd = function (ev) {
        this.trigger('dragEnd', ev);
    };
    // Delay
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.startDelay = function (initialEv) {
        var _this = this;
        if (this.delay) {
            this.delayTimeoutId = setTimeout(function () {
                _this.handleDelayEnd(initialEv);
            }, this.delay);
        }
        else {
            this.handleDelayEnd(initialEv);
        }
    };
    DragListener.prototype.handleDelayEnd = function (initialEv) {
        this.isDelayEnded = true;
        if (this.isDistanceSurpassed) {
            this.startDrag(initialEv);
        }
    };
    // Distance
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.handleDistanceSurpassed = function (ev) {
        this.isDistanceSurpassed = true;
        if (this.isDelayEnded) {
            this.startDrag(ev);
        }
    };
    // Mouse / Touch
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.handleTouchMove = function (ev) {
        // prevent inertia and touchmove-scrolling while dragging
        if (this.isDragging && this.shouldCancelTouchScroll) {
            ev.preventDefault();
        }
        this.handleMove(ev);
    };
    DragListener.prototype.handleMouseMove = function (ev) {
        this.handleMove(ev);
    };
    // Scrolling (unrelated to auto-scroll)
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.handleTouchScroll = function (ev) {
        // if the drag is being initiated by touch, but a scroll happens before
        // the drag-initiating delay is over, cancel the drag
        if (!this.isDragging || this.scrollAlwaysKills) {
            this.endInteraction(ev, true); // isCancelled=true
        }
    };
    // Utils
    // -----------------------------------------------------------------------------------------------------------------
    // Triggers a callback. Calls a function in the option hash of the same name.
    // Arguments beyond the first `name` are forwarded on.
    DragListener.prototype.trigger = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.options[name]) {
            this.options[name].apply(this, args);
        }
        // makes _methods callable by event name. TODO: kill this
        if (this['_' + name]) {
            this['_' + name].apply(this, args);
        }
    };
    // Auto-scroll
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.initAutoScroll = function () {
        var scrollEl = this.scrollEl;
        this.isAutoScroll =
            this.options.scroll &&
                scrollEl &&
                !scrollEl.is(window) &&
                !scrollEl.is(document);
        if (this.isAutoScroll) {
            // debounce makes sure rapid calls don't happen
            this.listenTo(scrollEl, 'scroll', util_1.debounce(this.handleDebouncedScroll, 100));
        }
    };
    DragListener.prototype.destroyAutoScroll = function () {
        this.endAutoScroll(); // kill any animation loop
        // remove the scroll handler if there is a scrollEl
        if (this.isAutoScroll) {
            this.stopListeningTo(this.scrollEl, 'scroll'); // will probably get removed by unbindHandlers too :(
        }
    };
    // Computes and stores the bounding rectangle of scrollEl
    DragListener.prototype.computeScrollBounds = function () {
        if (this.isAutoScroll) {
            this.scrollBounds = util_1.getOuterRect(this.scrollEl);
            // TODO: use getClientRect in future. but prevents auto scrolling when on top of scrollbars
        }
    };
    // Called when the dragging is in progress and scrolling should be updated
    DragListener.prototype.updateAutoScroll = function (ev) {
        var sensitivity = this.scrollSensitivity;
        var bounds = this.scrollBounds;
        var topCloseness;
        var bottomCloseness;
        var leftCloseness;
        var rightCloseness;
        var topVel = 0;
        var leftVel = 0;
        if (bounds) {
            // compute closeness to edges. valid range is from 0.0 - 1.0
            topCloseness = (sensitivity - (util_1.getEvY(ev) - bounds.top)) / sensitivity;
            bottomCloseness = (sensitivity - (bounds.bottom - util_1.getEvY(ev))) / sensitivity;
            leftCloseness = (sensitivity - (util_1.getEvX(ev) - bounds.left)) / sensitivity;
            rightCloseness = (sensitivity - (bounds.right - util_1.getEvX(ev))) / sensitivity;
            // translate vertical closeness into velocity.
            // mouse must be completely in bounds for velocity to happen.
            if (topCloseness >= 0 && topCloseness <= 1) {
                topVel = topCloseness * this.scrollSpeed * -1; // negative. for scrolling up
            }
            else if (bottomCloseness >= 0 && bottomCloseness <= 1) {
                topVel = bottomCloseness * this.scrollSpeed;
            }
            // translate horizontal closeness into velocity
            if (leftCloseness >= 0 && leftCloseness <= 1) {
                leftVel = leftCloseness * this.scrollSpeed * -1; // negative. for scrolling left
            }
            else if (rightCloseness >= 0 && rightCloseness <= 1) {
                leftVel = rightCloseness * this.scrollSpeed;
            }
        }
        this.setScrollVel(topVel, leftVel);
    };
    // Sets the speed-of-scrolling for the scrollEl
    DragListener.prototype.setScrollVel = function (topVel, leftVel) {
        this.scrollTopVel = topVel;
        this.scrollLeftVel = leftVel;
        this.constrainScrollVel(); // massages into realistic values
        // if there is non-zero velocity, and an animation loop hasn't already started, then START
        if ((this.scrollTopVel || this.scrollLeftVel) && !this.scrollIntervalId) {
            this.scrollIntervalId = setInterval(util_1.proxy(this, 'scrollIntervalFunc'), // scope to `this`
            this.scrollIntervalMs);
        }
    };
    // Forces scrollTopVel and scrollLeftVel to be zero if scrolling has already gone all the way
    DragListener.prototype.constrainScrollVel = function () {
        var el = this.scrollEl;
        if (this.scrollTopVel < 0) {
            if (el.scrollTop() <= 0) {
                this.scrollTopVel = 0;
            }
        }
        else if (this.scrollTopVel > 0) {
            if (el.scrollTop() + el[0].clientHeight >= el[0].scrollHeight) {
                this.scrollTopVel = 0;
            }
        }
        if (this.scrollLeftVel < 0) {
            if (el.scrollLeft() <= 0) {
                this.scrollLeftVel = 0;
            }
        }
        else if (this.scrollLeftVel > 0) {
            if (el.scrollLeft() + el[0].clientWidth >= el[0].scrollWidth) {
                this.scrollLeftVel = 0;
            }
        }
    };
    // This function gets called during every iteration of the scrolling animation loop
    DragListener.prototype.scrollIntervalFunc = function () {
        var el = this.scrollEl;
        var frac = this.scrollIntervalMs / 1000; // considering animation frequency, what the vel should be mult'd by
        // change the value of scrollEl's scroll
        if (this.scrollTopVel) {
            el.scrollTop(el.scrollTop() + this.scrollTopVel * frac);
        }
        if (this.scrollLeftVel) {
            el.scrollLeft(el.scrollLeft() + this.scrollLeftVel * frac);
        }
        this.constrainScrollVel(); // since the scroll values changed, recompute the velocities
        // if scrolled all the way, which causes the vels to be zero, stop the animation loop
        if (!this.scrollTopVel && !this.scrollLeftVel) {
            this.endAutoScroll();
        }
    };
    // Kills any existing scrolling animation loop
    DragListener.prototype.endAutoScroll = function () {
        if (this.scrollIntervalId) {
            clearInterval(this.scrollIntervalId);
            this.scrollIntervalId = null;
            this.handleScrollEnd();
        }
    };
    // Get called when the scrollEl is scrolled (NOTE: this is delayed via debounce)
    DragListener.prototype.handleDebouncedScroll = function () {
        // recompute all coordinates, but *only* if this is *not* part of our scrolling animation
        if (!this.scrollIntervalId) {
            this.handleScrollEnd();
        }
    };
    DragListener.prototype.handleScrollEnd = function () {
        // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
    };
    return DragListener;
}());
exports.default = DragListener;
ListenerMixin_1.default.mixInto(DragListener);


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var Mixin_1 = __webpack_require__(14);
/*
A set of rendering and date-related methods for a visual component comprised of one or more rows of day columns.
Prerequisite: the object being mixed into needs to be a *Grid*
*/
var DayTableMixin = /** @class */ (function (_super) {
    tslib_1.__extends(DayTableMixin, _super);
    function DayTableMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Populates internal variables used for date calculation and rendering
    DayTableMixin.prototype.updateDayTable = function () {
        var t = this;
        var view = t.view;
        var calendar = view.calendar;
        var date = calendar.msToUtcMoment(t.dateProfile.renderUnzonedRange.startMs, true);
        var end = calendar.msToUtcMoment(t.dateProfile.renderUnzonedRange.endMs, true);
        var dayIndex = -1;
        var dayIndices = [];
        var dayDates = [];
        var daysPerRow;
        var firstDay;
        var rowCnt;
        while (date.isBefore(end)) {
            if (view.isHiddenDay(date)) {
                dayIndices.push(dayIndex + 0.5); // mark that it's between indices
            }
            else {
                dayIndex++;
                dayIndices.push(dayIndex);
                dayDates.push(date.clone());
            }
            date.add(1, 'days');
        }
        if (this.breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dayDates[0].day();
            for (daysPerRow = 1; daysPerRow < dayDates.length; daysPerRow++) {
                if (dayDates[daysPerRow].day() === firstDay) {
                    break;
                }
            }
            rowCnt = Math.ceil(dayDates.length / daysPerRow);
        }
        else {
            rowCnt = 1;
            daysPerRow = dayDates.length;
        }
        this.dayDates = dayDates;
        this.dayIndices = dayIndices;
        this.daysPerRow = daysPerRow;
        this.rowCnt = rowCnt;
        this.updateDayTableCols();
    };
    // Computes and assigned the colCnt property and updates any options that may be computed from it
    DayTableMixin.prototype.updateDayTableCols = function () {
        this.colCnt = this.computeColCnt();
        this.colHeadFormat =
            this.opt('columnHeaderFormat') ||
                this.opt('columnFormat') || // deprecated
                this.computeColHeadFormat();
    };
    // Determines how many columns there should be in the table
    DayTableMixin.prototype.computeColCnt = function () {
        return this.daysPerRow;
    };
    // Computes the ambiguously-timed moment for the given cell
    DayTableMixin.prototype.getCellDate = function (row, col) {
        return this.dayDates[this.getCellDayIndex(row, col)].clone();
    };
    // Computes the ambiguously-timed date range for the given cell
    DayTableMixin.prototype.getCellRange = function (row, col) {
        var start = this.getCellDate(row, col);
        var end = start.clone().add(1, 'days');
        return { start: start, end: end };
    };
    // Returns the number of day cells, chronologically, from the first of the grid (0-based)
    DayTableMixin.prototype.getCellDayIndex = function (row, col) {
        return row * this.daysPerRow + this.getColDayIndex(col);
    };
    // Returns the numner of day cells, chronologically, from the first cell in *any given row*
    DayTableMixin.prototype.getColDayIndex = function (col) {
        if (this.isRTL) {
            return this.colCnt - 1 - col;
        }
        else {
            return col;
        }
    };
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    DayTableMixin.prototype.getDateDayIndex = function (date) {
        var dayIndices = this.dayIndices;
        var dayOffset = date.diff(this.dayDates[0], 'days');
        if (dayOffset < 0) {
            return dayIndices[0] - 1;
        }
        else if (dayOffset >= dayIndices.length) {
            return dayIndices[dayIndices.length - 1] + 1;
        }
        else {
            return dayIndices[dayOffset];
        }
    };
    /* Options
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes a default column header formatting string if `colFormat` is not explicitly defined
    DayTableMixin.prototype.computeColHeadFormat = function () {
        // if more than one week row, or if there are a lot of columns with not much space,
        // put just the day numbers will be in each cell
        if (this.rowCnt > 1 || this.colCnt > 10) {
            return 'ddd'; // "Sat"
        }
        else if (this.colCnt > 1) {
            return this.opt('dayOfMonthFormat'); // "Sat 12/10"
        }
        else {
            return 'dddd'; // "Saturday"
        }
    };
    /* Slicing
    ------------------------------------------------------------------------------------------------------------------*/
    // Slices up a date range into a segment for every week-row it intersects with
    DayTableMixin.prototype.sliceRangeByRow = function (unzonedRange) {
        var daysPerRow = this.daysPerRow;
        var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold
        var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
        var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
        var segs = [];
        var row;
        var rowFirst;
        var rowLast; // inclusive day-index range for current row
        var segFirst;
        var segLast; // inclusive day-index range for segment
        for (row = 0; row < this.rowCnt; row++) {
            rowFirst = row * daysPerRow;
            rowLast = rowFirst + daysPerRow - 1;
            // intersect segment's offset range with the row's
            segFirst = Math.max(rangeFirst, rowFirst);
            segLast = Math.min(rangeLast, rowLast);
            // deal with in-between indices
            segFirst = Math.ceil(segFirst); // in-between starts round to next cell
            segLast = Math.floor(segLast); // in-between ends round to prev cell
            if (segFirst <= segLast) {
                segs.push({
                    row: row,
                    // normalize to start of row
                    firstRowDayIndex: segFirst - rowFirst,
                    lastRowDayIndex: segLast - rowFirst,
                    // must be matching integers to be the segment's start/end
                    isStart: segFirst === rangeFirst,
                    isEnd: segLast === rangeLast
                });
            }
        }
        return segs;
    };
    // Slices up a date range into a segment for every day-cell it intersects with.
    // TODO: make more DRY with sliceRangeByRow somehow.
    DayTableMixin.prototype.sliceRangeByDay = function (unzonedRange) {
        var daysPerRow = this.daysPerRow;
        var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold
        var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
        var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
        var segs = [];
        var row;
        var rowFirst;
        var rowLast; // inclusive day-index range for current row
        var i;
        var segFirst;
        var segLast; // inclusive day-index range for segment
        for (row = 0; row < this.rowCnt; row++) {
            rowFirst = row * daysPerRow;
            rowLast = rowFirst + daysPerRow - 1;
            for (i = rowFirst; i <= rowLast; i++) {
                // intersect segment's offset range with the row's
                segFirst = Math.max(rangeFirst, i);
                segLast = Math.min(rangeLast, i);
                // deal with in-between indices
                segFirst = Math.ceil(segFirst); // in-between starts round to next cell
                segLast = Math.floor(segLast); // in-between ends round to prev cell
                if (segFirst <= segLast) {
                    segs.push({
                        row: row,
                        // normalize to start of row
                        firstRowDayIndex: segFirst - rowFirst,
                        lastRowDayIndex: segLast - rowFirst,
                        // must be matching integers to be the segment's start/end
                        isStart: segFirst === rangeFirst,
                        isEnd: segLast === rangeLast
                    });
                }
            }
        }
        return segs;
    };
    /* Header Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayTableMixin.prototype.renderHeadHtml = function () {
        var theme = this.view.calendar.theme;
        return '' +
            '<div class="fc-row ' + theme.getClass('headerRow') + '">' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            '<thead>' +
            this.renderHeadTrHtml() +
            '</thead>' +
            '</table>' +
            '</div>';
    };
    DayTableMixin.prototype.renderHeadIntroHtml = function () {
        return this.renderIntroHtml(); // fall back to generic
    };
    DayTableMixin.prototype.renderHeadTrHtml = function () {
        return '' +
            '<tr>' +
            (this.isRTL ? '' : this.renderHeadIntroHtml()) +
            this.renderHeadDateCellsHtml() +
            (this.isRTL ? this.renderHeadIntroHtml() : '') +
            '</tr>';
    };
    DayTableMixin.prototype.renderHeadDateCellsHtml = function () {
        var htmls = [];
        var col;
        var date;
        for (col = 0; col < this.colCnt; col++) {
            date = this.getCellDate(0, col);
            htmls.push(this.renderHeadDateCellHtml(date));
        }
        return htmls.join('');
    };
    // TODO: when internalApiVersion, accept an object for HTML attributes
    // (colspan should be no different)
    DayTableMixin.prototype.renderHeadDateCellHtml = function (date, colspan, otherAttrs) {
        var t = this;
        var view = t.view;
        var isDateValid = t.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
        var classNames = [
            'fc-day-header',
            view.calendar.theme.getClass('widgetHeader')
        ];
        var innerHtml;
        if (typeof t.opt('columnHeaderHtml') === 'function') {
            innerHtml = t.opt('columnHeaderHtml')(date);
        }
        else if (typeof t.opt('columnHeaderText') === 'function') {
            innerHtml = util_1.htmlEscape(t.opt('columnHeaderText')(date));
        }
        else {
            innerHtml = util_1.htmlEscape(date.format(t.colHeadFormat));
        }
        // if only one row of days, the classNames on the header can represent the specific days beneath
        if (t.rowCnt === 1) {
            classNames = classNames.concat(
            // includes the day-of-week class
            // noThemeHighlight=true (don't highlight the header)
            t.getDayClasses(date, true));
        }
        else {
            classNames.push('fc-' + util_1.dayIDs[date.day()]); // only add the day-of-week class
        }
        return '' +
            '<th class="' + classNames.join(' ') + '"' +
            ((isDateValid && t.rowCnt) === 1 ?
                ' data-date="' + date.format('YYYY-MM-DD') + '"' :
                '') +
            (colspan > 1 ?
                ' colspan="' + colspan + '"' :
                '') +
            (otherAttrs ?
                ' ' + otherAttrs :
                '') +
            '>' +
            (isDateValid ?
                // don't make a link if the heading could represent multiple days, or if there's only one day (forceOff)
                view.buildGotoAnchorHtml({ date: date, forceOff: t.rowCnt > 1 || t.colCnt === 1 }, innerHtml) :
                // if not valid, display text, but no link
                innerHtml) +
            '</th>';
    };
    /* Background Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayTableMixin.prototype.renderBgTrHtml = function (row) {
        return '' +
            '<tr>' +
            (this.isRTL ? '' : this.renderBgIntroHtml(row)) +
            this.renderBgCellsHtml(row) +
            (this.isRTL ? this.renderBgIntroHtml(row) : '') +
            '</tr>';
    };
    DayTableMixin.prototype.renderBgIntroHtml = function (row) {
        return this.renderIntroHtml(); // fall back to generic
    };
    DayTableMixin.prototype.renderBgCellsHtml = function (row) {
        var htmls = [];
        var col;
        var date;
        for (col = 0; col < this.colCnt; col++) {
            date = this.getCellDate(row, col);
            htmls.push(this.renderBgCellHtml(date));
        }
        return htmls.join('');
    };
    DayTableMixin.prototype.renderBgCellHtml = function (date, otherAttrs) {
        var t = this;
        var view = t.view;
        var isDateValid = t.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
        var classes = t.getDayClasses(date);
        classes.unshift('fc-day', view.calendar.theme.getClass('widgetContent'));
        return '<td class="' + classes.join(' ') + '"' +
            (isDateValid ?
                ' data-date="' + date.format('YYYY-MM-DD') + '"' : // if date has a time, won't format it
                '') +
            (otherAttrs ?
                ' ' + otherAttrs :
                '') +
            '></td>';
    };
    /* Generic
    ------------------------------------------------------------------------------------------------------------------*/
    DayTableMixin.prototype.renderIntroHtml = function () {
        // Generates the default HTML intro for any row. User classes should override
    };
    // TODO: a generic method for dealing with <tr>, RTL, intro
    // when increment internalApiVersion
    // wrapTr (scheduler)
    /* Utils
    ------------------------------------------------------------------------------------------------------------------*/
    // Applies the generic "intro" and "outro" HTML to the given cells.
    // Intro means the leftmost cell when the calendar is LTR and the rightmost cell when RTL. Vice-versa for outro.
    DayTableMixin.prototype.bookendCells = function (trEl) {
        var introHtml = this.renderIntroHtml();
        if (introHtml) {
            if (this.isRTL) {
                trEl.append(introHtml);
            }
            else {
                trEl.prepend(introHtml);
            }
        }
    };
    return DayTableMixin;
}(Mixin_1.default));
exports.default = DayTableMixin;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var BusinessHourRenderer = /** @class */ (function () {
    /*
    component implements:
      - eventRangesToEventFootprints
      - eventFootprintsToSegs
    */
    function BusinessHourRenderer(component, fillRenderer) {
        this.component = component;
        this.fillRenderer = fillRenderer;
    }
    BusinessHourRenderer.prototype.render = function (businessHourGenerator) {
        var component = this.component;
        var unzonedRange = component._getDateProfile().activeUnzonedRange;
        var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(component.hasAllDayBusinessHours, unzonedRange);
        var eventFootprints = eventInstanceGroup ?
            component.eventRangesToEventFootprints(eventInstanceGroup.sliceRenderRanges(unzonedRange)) :
            [];
        this.renderEventFootprints(eventFootprints);
    };
    BusinessHourRenderer.prototype.renderEventFootprints = function (eventFootprints) {
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        this.renderSegs(segs);
        this.segs = segs;
    };
    BusinessHourRenderer.prototype.renderSegs = function (segs) {
        if (this.fillRenderer) {
            this.fillRenderer.renderSegs('businessHours', segs, {
                getClasses: function (seg) {
                    return ['fc-nonbusiness', 'fc-bgevent'];
                }
            });
        }
    };
    BusinessHourRenderer.prototype.unrender = function () {
        if (this.fillRenderer) {
            this.fillRenderer.unrender('businessHours');
        }
        this.segs = null;
    };
    BusinessHourRenderer.prototype.getSegs = function () {
        return this.segs || [];
    };
    return BusinessHourRenderer;
}());
exports.default = BusinessHourRenderer;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var FillRenderer = /** @class */ (function () {
    function FillRenderer(component) {
        this.fillSegTag = 'div';
        this.component = component;
        this.elsByFill = {};
    }
    FillRenderer.prototype.renderFootprint = function (type, componentFootprint, props) {
        this.renderSegs(type, this.component.componentFootprintToSegs(componentFootprint), props);
    };
    FillRenderer.prototype.renderSegs = function (type, segs, props) {
        var els;
        segs = this.buildSegEls(type, segs, props); // assignes `.el` to each seg. returns successfully rendered segs
        els = this.attachSegEls(type, segs);
        if (els) {
            this.reportEls(type, els);
        }
        return segs;
    };
    // Unrenders a specific type of fill that is currently rendered on the grid
    FillRenderer.prototype.unrender = function (type) {
        var el = this.elsByFill[type];
        if (el) {
            el.remove();
            delete this.elsByFill[type];
        }
    };
    // Renders and assigns an `el` property for each fill segment. Generic enough to work with different types.
    // Only returns segments that successfully rendered.
    FillRenderer.prototype.buildSegEls = function (type, segs, props) {
        var _this = this;
        var html = '';
        var renderedSegs = [];
        var i;
        if (segs.length) {
            // build a large concatenation of segment HTML
            for (i = 0; i < segs.length; i++) {
                html += this.buildSegHtml(type, segs[i], props);
            }
            // Grab individual elements from the combined HTML string. Use each as the default rendering.
            // Then, compute the 'el' for each segment.
            $(html).each(function (i, node) {
                var seg = segs[i];
                var el = $(node);
                // allow custom filter methods per-type
                if (props.filterEl) {
                    el = props.filterEl(seg, el);
                }
                if (el) {
                    el = $(el); // allow custom filter to return raw DOM node
                    // correct element type? (would be bad if a non-TD were inserted into a table for example)
                    if (el.is(_this.fillSegTag)) {
                        seg.el = el;
                        renderedSegs.push(seg);
                    }
                }
            });
        }
        return renderedSegs;
    };
    // Builds the HTML needed for one fill segment. Generic enough to work with different types.
    FillRenderer.prototype.buildSegHtml = function (type, seg, props) {
        // custom hooks per-type
        var classes = props.getClasses ? props.getClasses(seg) : [];
        var css = util_1.cssToStr(props.getCss ? props.getCss(seg) : {});
        return '<' + this.fillSegTag +
            (classes.length ? ' class="' + classes.join(' ') + '"' : '') +
            (css ? ' style="' + css + '"' : '') +
            ' />';
    };
    // Should return wrapping DOM structure
    FillRenderer.prototype.attachSegEls = function (type, segs) {
        // subclasses must implement
    };
    FillRenderer.prototype.reportEls = function (type, nodes) {
        if (this.elsByFill[type]) {
            this.elsByFill[type] = this.elsByFill[type].add(nodes);
        }
        else {
            this.elsByFill[type] = $(nodes);
        }
    };
    return FillRenderer;
}());
exports.default = FillRenderer;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var SingleEventDef_1 = __webpack_require__(13);
var EventFootprint_1 = __webpack_require__(35);
var EventSource_1 = __webpack_require__(6);
var HelperRenderer = /** @class */ (function () {
    function HelperRenderer(component, eventRenderer) {
        this.view = component._getView();
        this.component = component;
        this.eventRenderer = eventRenderer;
    }
    HelperRenderer.prototype.renderComponentFootprint = function (componentFootprint) {
        this.renderEventFootprints([
            this.fabricateEventFootprint(componentFootprint)
        ]);
    };
    HelperRenderer.prototype.renderEventDraggingFootprints = function (eventFootprints, sourceSeg, isTouch) {
        this.renderEventFootprints(eventFootprints, sourceSeg, 'fc-dragging', isTouch ? null : this.view.opt('dragOpacity'));
    };
    HelperRenderer.prototype.renderEventResizingFootprints = function (eventFootprints, sourceSeg, isTouch) {
        this.renderEventFootprints(eventFootprints, sourceSeg, 'fc-resizing');
    };
    HelperRenderer.prototype.renderEventFootprints = function (eventFootprints, sourceSeg, extraClassNames, opacity) {
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        var classNames = 'fc-helper ' + (extraClassNames || '');
        var i;
        // assigns each seg's el and returns a subset of segs that were rendered
        segs = this.eventRenderer.renderFgSegEls(segs);
        for (i = 0; i < segs.length; i++) {
            segs[i].el.addClass(classNames);
        }
        if (opacity != null) {
            for (i = 0; i < segs.length; i++) {
                segs[i].el.css('opacity', opacity);
            }
        }
        this.helperEls = this.renderSegs(segs, sourceSeg);
    };
    /*
    Must return all mock event elements
    */
    HelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
        // Subclasses must implement
    };
    HelperRenderer.prototype.unrender = function () {
        if (this.helperEls) {
            this.helperEls.remove();
            this.helperEls = null;
        }
    };
    HelperRenderer.prototype.fabricateEventFootprint = function (componentFootprint) {
        var calendar = this.view.calendar;
        var eventDateProfile = calendar.footprintToDateProfile(componentFootprint);
        var dummyEvent = new SingleEventDef_1.default(new EventSource_1.default(calendar));
        var dummyInstance;
        dummyEvent.dateProfile = eventDateProfile;
        dummyInstance = dummyEvent.buildInstance();
        return new EventFootprint_1.default(componentFootprint, dummyEvent, dummyInstance);
    };
    return HelperRenderer;
}());
exports.default = HelperRenderer;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var GlobalEmitter_1 = __webpack_require__(20);
var Interaction_1 = __webpack_require__(15);
var EventPointing = /** @class */ (function (_super) {
    tslib_1.__extends(EventPointing, _super);
    function EventPointing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
    component must implement:
      - publiclyTrigger
    */
    EventPointing.prototype.bindToEl = function (el) {
        var component = this.component;
        component.bindSegHandlerToEl(el, 'click', this.handleClick.bind(this));
        component.bindSegHandlerToEl(el, 'mouseenter', this.handleMouseover.bind(this));
        component.bindSegHandlerToEl(el, 'mouseleave', this.handleMouseout.bind(this));
    };
    EventPointing.prototype.handleClick = function (seg, ev) {
        var res = this.component.publiclyTrigger('eventClick', {
            context: seg.el[0],
            args: [seg.footprint.getEventLegacy(), ev, this.view]
        });
        if (res === false) {
            ev.preventDefault();
        }
    };
    // Updates internal state and triggers handlers for when an event element is moused over
    EventPointing.prototype.handleMouseover = function (seg, ev) {
        if (!GlobalEmitter_1.default.get().shouldIgnoreMouse() &&
            !this.mousedOverSeg) {
            this.mousedOverSeg = seg;
            // TODO: move to EventSelecting's responsibility
            if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
                seg.el.addClass('fc-allow-mouse-resize');
            }
            this.component.publiclyTrigger('eventMouseover', {
                context: seg.el[0],
                args: [seg.footprint.getEventLegacy(), ev, this.view]
            });
        }
    };
    // Updates internal state and triggers handlers for when an event element is moused out.
    // Can be given no arguments, in which case it will mouseout the segment that was previously moused over.
    EventPointing.prototype.handleMouseout = function (seg, ev) {
        if (this.mousedOverSeg) {
            this.mousedOverSeg = null;
            // TODO: move to EventSelecting's responsibility
            if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
                seg.el.removeClass('fc-allow-mouse-resize');
            }
            this.component.publiclyTrigger('eventMouseout', {
                context: seg.el[0],
                args: [
                    seg.footprint.getEventLegacy(),
                    ev || {},
                    this.view
                ]
            });
        }
    };
    EventPointing.prototype.end = function () {
        if (this.mousedOverSeg) {
            this.handleMouseout(this.mousedOverSeg);
        }
    };
    return EventPointing;
}(Interaction_1.default));
exports.default = EventPointing;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Mixin_1 = __webpack_require__(14);
var DateClicking_1 = __webpack_require__(245);
var DateSelecting_1 = __webpack_require__(225);
var EventPointing_1 = __webpack_require__(59);
var EventDragging_1 = __webpack_require__(224);
var EventResizing_1 = __webpack_require__(223);
var ExternalDropping_1 = __webpack_require__(222);
var StandardInteractionsMixin = /** @class */ (function (_super) {
    tslib_1.__extends(StandardInteractionsMixin, _super);
    function StandardInteractionsMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StandardInteractionsMixin;
}(Mixin_1.default));
exports.default = StandardInteractionsMixin;
StandardInteractionsMixin.prototype.dateClickingClass = DateClicking_1.default;
StandardInteractionsMixin.prototype.dateSelectingClass = DateSelecting_1.default;
StandardInteractionsMixin.prototype.eventPointingClass = EventPointing_1.default;
StandardInteractionsMixin.prototype.eventDraggingClass = EventDragging_1.default;
StandardInteractionsMixin.prototype.eventResizingClass = EventResizing_1.default;
StandardInteractionsMixin.prototype.externalDroppingClass = ExternalDropping_1.default;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var CoordCache_1 = __webpack_require__(53);
var Popover_1 = __webpack_require__(249);
var UnzonedRange_1 = __webpack_require__(5);
var ComponentFootprint_1 = __webpack_require__(12);
var EventFootprint_1 = __webpack_require__(35);
var BusinessHourRenderer_1 = __webpack_require__(56);
var StandardInteractionsMixin_1 = __webpack_require__(60);
var InteractiveDateComponent_1 = __webpack_require__(40);
var DayTableMixin_1 = __webpack_require__(55);
var DayGridEventRenderer_1 = __webpack_require__(250);
var DayGridHelperRenderer_1 = __webpack_require__(251);
var DayGridFillRenderer_1 = __webpack_require__(252);
/* A component that renders a grid of whole-days that runs horizontally. There can be multiple rows, one per week.
----------------------------------------------------------------------------------------------------------------------*/
var DayGrid = /** @class */ (function (_super) {
    tslib_1.__extends(DayGrid, _super);
    function DayGrid(view) {
        var _this = _super.call(this, view) || this;
        _this.cellWeekNumbersVisible = false; // display week numbers in day cell?
        _this.bottomCoordPadding = 0; // hack for extending the hit area for the last row of the coordinate grid
        // isRigid determines whether the individual rows should ignore the contents and be a constant height.
        // Relies on the view's colCnt and rowCnt. In the future, this component should probably be self-sufficient.
        _this.isRigid = false;
        _this.hasAllDayBusinessHours = true;
        return _this;
    }
    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
    DayGrid.prototype.componentFootprintToSegs = function (componentFootprint) {
        var segs = this.sliceRangeByRow(componentFootprint.unzonedRange);
        var i;
        var seg;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            if (this.isRTL) {
                seg.leftCol = this.daysPerRow - 1 - seg.lastRowDayIndex;
                seg.rightCol = this.daysPerRow - 1 - seg.firstRowDayIndex;
            }
            else {
                seg.leftCol = seg.firstRowDayIndex;
                seg.rightCol = seg.lastRowDayIndex;
            }
        }
        return segs;
    };
    /* Date Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.renderDates = function (dateProfile) {
        this.dateProfile = dateProfile;
        this.updateDayTable();
        this.renderGrid();
    };
    DayGrid.prototype.unrenderDates = function () {
        this.removeSegPopover();
    };
    // Renders the rows and columns into the component's `this.el`, which should already be assigned.
    DayGrid.prototype.renderGrid = function () {
        var view = this.view;
        var rowCnt = this.rowCnt;
        var colCnt = this.colCnt;
        var html = '';
        var row;
        var col;
        if (this.headContainerEl) {
            this.headContainerEl.html(this.renderHeadHtml());
        }
        for (row = 0; row < rowCnt; row++) {
            html += this.renderDayRowHtml(row, this.isRigid);
        }
        this.el.html(html);
        this.rowEls = this.el.find('.fc-row');
        this.cellEls = this.el.find('.fc-day, .fc-disabled-day');
        this.rowCoordCache = new CoordCache_1.default({
            els: this.rowEls,
            isVertical: true
        });
        this.colCoordCache = new CoordCache_1.default({
            els: this.cellEls.slice(0, this.colCnt),
            isHorizontal: true
        });
        // trigger dayRender with each cell's element
        for (row = 0; row < rowCnt; row++) {
            for (col = 0; col < colCnt; col++) {
                this.publiclyTrigger('dayRender', {
                    context: view,
                    args: [
                        this.getCellDate(row, col),
                        this.getCellEl(row, col),
                        view
                    ]
                });
            }
        }
    };
    // Generates the HTML for a single row, which is a div that wraps a table.
    // `row` is the row number.
    DayGrid.prototype.renderDayRowHtml = function (row, isRigid) {
        var theme = this.view.calendar.theme;
        var classes = ['fc-row', 'fc-week', theme.getClass('dayRow')];
        if (isRigid) {
            classes.push('fc-rigid');
        }
        return '' +
            '<div class="' + classes.join(' ') + '">' +
            '<div class="fc-bg">' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            this.renderBgTrHtml(row) +
            '</table>' +
            '</div>' +
            '<div class="fc-content-skeleton">' +
            '<table>' +
            (this.getIsNumbersVisible() ?
                '<thead>' +
                    this.renderNumberTrHtml(row) +
                    '</thead>' :
                '') +
            '</table>' +
            '</div>' +
            '</div>';
    };
    DayGrid.prototype.getIsNumbersVisible = function () {
        return this.getIsDayNumbersVisible() || this.cellWeekNumbersVisible;
    };
    DayGrid.prototype.getIsDayNumbersVisible = function () {
        return this.rowCnt > 1;
    };
    /* Grid Number Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.renderNumberTrHtml = function (row) {
        return '' +
            '<tr>' +
            (this.isRTL ? '' : this.renderNumberIntroHtml(row)) +
            this.renderNumberCellsHtml(row) +
            (this.isRTL ? this.renderNumberIntroHtml(row) : '') +
            '</tr>';
    };
    DayGrid.prototype.renderNumberIntroHtml = function (row) {
        return this.renderIntroHtml();
    };
    DayGrid.prototype.renderNumberCellsHtml = function (row) {
        var htmls = [];
        var col;
        var date;
        for (col = 0; col < this.colCnt; col++) {
            date = this.getCellDate(row, col);
            htmls.push(this.renderNumberCellHtml(date));
        }
        return htmls.join('');
    };
    // Generates the HTML for the <td>s of the "number" row in the DayGrid's content skeleton.
    // The number row will only exist if either day numbers or week numbers are turned on.
    DayGrid.prototype.renderNumberCellHtml = function (date) {
        var view = this.view;
        var html = '';
        var isDateValid = this.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
        var isDayNumberVisible = this.getIsDayNumbersVisible() && isDateValid;
        var classes;
        var weekCalcFirstDoW;
        if (!isDayNumberVisible && !this.cellWeekNumbersVisible) {
            // no numbers in day cell (week number must be along the side)
            return '<td/>'; //  will create an empty space above events :(
        }
        classes = this.getDayClasses(date);
        classes.unshift('fc-day-top');
        if (this.cellWeekNumbersVisible) {
            // To determine the day of week number change under ISO, we cannot
            // rely on moment.js methods such as firstDayOfWeek() or weekday(),
            // because they rely on the locale's dow (possibly overridden by
            // our firstDay option), which may not be Monday. We cannot change
            // dow, because that would affect the calendar start day as well.
            if (date._locale._fullCalendar_weekCalc === 'ISO') {
                weekCalcFirstDoW = 1; // Monday by ISO 8601 definition
            }
            else {
                weekCalcFirstDoW = date._locale.firstDayOfWeek();
            }
        }
        html += '<td class="' + classes.join(' ') + '"' +
            (isDateValid ?
                ' data-date="' + date.format() + '"' :
                '') +
            '>';
        if (this.cellWeekNumbersVisible && (date.day() === weekCalcFirstDoW)) {
            html += view.buildGotoAnchorHtml({ date: date, type: 'week' }, { 'class': 'fc-week-number' }, date.format('w') // inner HTML
            );
        }
        if (isDayNumberVisible) {
            html += view.buildGotoAnchorHtml(date, { 'class': 'fc-day-number' }, date.format('D') // inner HTML
            );
        }
        html += '</td>';
        return html;
    };
    /* Hit System
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.prepareHits = function () {
        this.colCoordCache.build();
        this.rowCoordCache.build();
        this.rowCoordCache.bottoms[this.rowCnt - 1] += this.bottomCoordPadding; // hack
    };
    DayGrid.prototype.releaseHits = function () {
        this.colCoordCache.clear();
        this.rowCoordCache.clear();
    };
    DayGrid.prototype.queryHit = function (leftOffset, topOffset) {
        if (this.colCoordCache.isLeftInBounds(leftOffset) && this.rowCoordCache.isTopInBounds(topOffset)) {
            var col = this.colCoordCache.getHorizontalIndex(leftOffset);
            var row = this.rowCoordCache.getVerticalIndex(topOffset);
            if (row != null && col != null) {
                return this.getCellHit(row, col);
            }
        }
    };
    DayGrid.prototype.getHitFootprint = function (hit) {
        var range = this.getCellRange(hit.row, hit.col);
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(range.start, range.end), true // all-day?
        );
    };
    DayGrid.prototype.getHitEl = function (hit) {
        return this.getCellEl(hit.row, hit.col);
    };
    /* Cell System
    ------------------------------------------------------------------------------------------------------------------*/
    // FYI: the first column is the leftmost column, regardless of date
    DayGrid.prototype.getCellHit = function (row, col) {
        return {
            row: row,
            col: col,
            component: this,
            left: this.colCoordCache.getLeftOffset(col),
            right: this.colCoordCache.getRightOffset(col),
            top: this.rowCoordCache.getTopOffset(row),
            bottom: this.rowCoordCache.getBottomOffset(row)
        };
    };
    DayGrid.prototype.getCellEl = function (row, col) {
        return this.cellEls.eq(row * this.colCnt + col);
    };
    /* Event Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    // Unrenders all events currently rendered on the grid
    DayGrid.prototype.executeEventUnrender = function () {
        this.removeSegPopover(); // removes the "more.." events popover
        _super.prototype.executeEventUnrender.call(this);
    };
    // Retrieves all rendered segment objects currently rendered on the grid
    DayGrid.prototype.getOwnEventSegs = function () {
        // append the segments from the "more..." popover
        return _super.prototype.getOwnEventSegs.call(this).concat(this.popoverSegs || []);
    };
    /* Event Drag Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event or external element being dragged.
    // `eventLocation` has zoned start and end (optional)
    DayGrid.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            this.renderHighlight(eventFootprints[i].componentFootprint);
        }
        // render drags from OTHER components as helpers
        if (eventFootprints.length && seg && seg.component !== this) {
            this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch);
            return true; // signal helpers rendered
        }
    };
    // Unrenders any visual indication of a hovering event
    DayGrid.prototype.unrenderDrag = function () {
        this.unrenderHighlight();
        this.helperRenderer.unrender();
    };
    /* Event Resize Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being resized
    DayGrid.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            this.renderHighlight(eventFootprints[i].componentFootprint);
        }
        this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
    };
    // Unrenders a visual indication of an event being resized
    DayGrid.prototype.unrenderEventResize = function () {
        this.unrenderHighlight();
        this.helperRenderer.unrender();
    };
    /* More+ Link Popover
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.removeSegPopover = function () {
        if (this.segPopover) {
            this.segPopover.hide(); // in handler, will call segPopover's removeElement
        }
    };
    // Limits the number of "levels" (vertically stacking layers of events) for each row of the grid.
    // `levelLimit` can be false (don't limit), a number, or true (should be computed).
    DayGrid.prototype.limitRows = function (levelLimit) {
        var rowStructs = this.eventRenderer.rowStructs || [];
        var row; // row #
        var rowLevelLimit;
        for (row = 0; row < rowStructs.length; row++) {
            this.unlimitRow(row);
            if (!levelLimit) {
                rowLevelLimit = false;
            }
            else if (typeof levelLimit === 'number') {
                rowLevelLimit = levelLimit;
            }
            else {
                rowLevelLimit = this.computeRowLevelLimit(row);
            }
            if (rowLevelLimit !== false) {
                this.limitRow(row, rowLevelLimit);
            }
        }
    };
    // Computes the number of levels a row will accomodate without going outside its bounds.
    // Assumes the row is "rigid" (maintains a constant height regardless of what is inside).
    // `row` is the row number.
    DayGrid.prototype.computeRowLevelLimit = function (row) {
        var rowEl = this.rowEls.eq(row); // the containing "fake" row div
        var rowHeight = rowEl.height(); // TODO: cache somehow?
        var trEls = this.eventRenderer.rowStructs[row].tbodyEl.children();
        var i;
        var trEl;
        var trHeight;
        function iterInnerHeights(i, childNode) {
            trHeight = Math.max(trHeight, $(childNode).outerHeight());
        }
        // Reveal one level <tr> at a time and stop when we find one out of bounds
        for (i = 0; i < trEls.length; i++) {
            trEl = trEls.eq(i).removeClass('fc-limited'); // reset to original state (reveal)
            // with rowspans>1 and IE8, trEl.outerHeight() would return the height of the largest cell,
            // so instead, find the tallest inner content element.
            trHeight = 0;
            trEl.find('> td > :first-child').each(iterInnerHeights);
            if (trEl.position().top + trHeight > rowHeight) {
                return i;
            }
        }
        return false; // should not limit at all
    };
    // Limits the given grid row to the maximum number of levels and injects "more" links if necessary.
    // `row` is the row number.
    // `levelLimit` is a number for the maximum (inclusive) number of levels allowed.
    DayGrid.prototype.limitRow = function (row, levelLimit) {
        var _this = this;
        var rowStruct = this.eventRenderer.rowStructs[row];
        var moreNodes = []; // array of "more" <a> links and <td> DOM nodes
        var col = 0; // col #, left-to-right (not chronologically)
        var levelSegs; // array of segment objects in the last allowable level, ordered left-to-right
        var cellMatrix; // a matrix (by level, then column) of all <td> jQuery elements in the row
        var limitedNodes; // array of temporarily hidden level <tr> and segment <td> DOM nodes
        var i;
        var seg;
        var segsBelow; // array of segment objects below `seg` in the current `col`
        var totalSegsBelow; // total number of segments below `seg` in any of the columns `seg` occupies
        var colSegsBelow; // array of segment arrays, below seg, one for each column (offset from segs's first column)
        var td;
        var rowspan;
        var segMoreNodes; // array of "more" <td> cells that will stand-in for the current seg's cell
        var j;
        var moreTd;
        var moreWrap;
        var moreLink;
        // Iterates through empty level cells and places "more" links inside if need be
        var emptyCellsUntil = function (endCol) {
            while (col < endCol) {
                segsBelow = _this.getCellSegs(row, col, levelLimit);
                if (segsBelow.length) {
                    td = cellMatrix[levelLimit - 1][col];
                    moreLink = _this.renderMoreLink(row, col, segsBelow);
                    moreWrap = $('<div/>').append(moreLink);
                    td.append(moreWrap);
                    moreNodes.push(moreWrap[0]);
                }
                col++;
            }
        };
        if (levelLimit && levelLimit < rowStruct.segLevels.length) {
            levelSegs = rowStruct.segLevels[levelLimit - 1];
            cellMatrix = rowStruct.cellMatrix;
            limitedNodes = rowStruct.tbodyEl.children().slice(levelLimit) // get level <tr> elements past the limit
                .addClass('fc-limited').get(); // hide elements and get a simple DOM-nodes array
            // iterate though segments in the last allowable level
            for (i = 0; i < levelSegs.length; i++) {
                seg = levelSegs[i];
                emptyCellsUntil(seg.leftCol); // process empty cells before the segment
                // determine *all* segments below `seg` that occupy the same columns
                colSegsBelow = [];
                totalSegsBelow = 0;
                while (col <= seg.rightCol) {
                    segsBelow = this.getCellSegs(row, col, levelLimit);
                    colSegsBelow.push(segsBelow);
                    totalSegsBelow += segsBelow.length;
                    col++;
                }
                if (totalSegsBelow) {
                    td = cellMatrix[levelLimit - 1][seg.leftCol]; // the segment's parent cell
                    rowspan = td.attr('rowspan') || 1;
                    segMoreNodes = [];
                    // make a replacement <td> for each column the segment occupies. will be one for each colspan
                    for (j = 0; j < colSegsBelow.length; j++) {
                        moreTd = $('<td class="fc-more-cell"/>').attr('rowspan', rowspan);
                        segsBelow = colSegsBelow[j];
                        moreLink = this.renderMoreLink(row, seg.leftCol + j, [seg].concat(segsBelow) // count seg as hidden too
                        );
                        moreWrap = $('<div/>').append(moreLink);
                        moreTd.append(moreWrap);
                        segMoreNodes.push(moreTd[0]);
                        moreNodes.push(moreTd[0]);
                    }
                    td.addClass('fc-limited').after($(segMoreNodes)); // hide original <td> and inject replacements
                    limitedNodes.push(td[0]);
                }
            }
            emptyCellsUntil(this.colCnt); // finish off the level
            rowStruct.moreEls = $(moreNodes); // for easy undoing later
            rowStruct.limitedEls = $(limitedNodes); // for easy undoing later
        }
    };
    // Reveals all levels and removes all "more"-related elements for a grid's row.
    // `row` is a row number.
    DayGrid.prototype.unlimitRow = function (row) {
        var rowStruct = this.eventRenderer.rowStructs[row];
        if (rowStruct.moreEls) {
            rowStruct.moreEls.remove();
            rowStruct.moreEls = null;
        }
        if (rowStruct.limitedEls) {
            rowStruct.limitedEls.removeClass('fc-limited');
            rowStruct.limitedEls = null;
        }
    };
    // Renders an <a> element that represents hidden event element for a cell.
    // Responsible for attaching click handler as well.
    DayGrid.prototype.renderMoreLink = function (row, col, hiddenSegs) {
        var _this = this;
        var view = this.view;
        return $('<a class="fc-more"/>')
            .text(this.getMoreLinkText(hiddenSegs.length))
            .on('click', function (ev) {
            var clickOption = _this.opt('eventLimitClick');
            var date = _this.getCellDate(row, col);
            var moreEl = $(ev.currentTarget);
            var dayEl = _this.getCellEl(row, col);
            var allSegs = _this.getCellSegs(row, col);
            // rescope the segments to be within the cell's date
            var reslicedAllSegs = _this.resliceDaySegs(allSegs, date);
            var reslicedHiddenSegs = _this.resliceDaySegs(hiddenSegs, date);
            if (typeof clickOption === 'function') {
                // the returned value can be an atomic option
                clickOption = _this.publiclyTrigger('eventLimitClick', {
                    context: view,
                    args: [
                        {
                            date: date.clone(),
                            dayEl: dayEl,
                            moreEl: moreEl,
                            segs: reslicedAllSegs,
                            hiddenSegs: reslicedHiddenSegs
                        },
                        ev,
                        view
                    ]
                });
            }
            if (clickOption === 'popover') {
                _this.showSegPopover(row, col, moreEl, reslicedAllSegs);
            }
            else if (typeof clickOption === 'string') {
                view.calendar.zoomTo(date, clickOption);
            }
        });
    };
    // Reveals the popover that displays all events within a cell
    DayGrid.prototype.showSegPopover = function (row, col, moreLink, segs) {
        var _this = this;
        var view = this.view;
        var moreWrap = moreLink.parent(); // the <div> wrapper around the <a>
        var topEl; // the element we want to match the top coordinate of
        var options;
        if (this.rowCnt === 1) {
            topEl = view.el; // will cause the popover to cover any sort of header
        }
        else {
            topEl = this.rowEls.eq(row); // will align with top of row
        }
        options = {
            className: 'fc-more-popover ' + view.calendar.theme.getClass('popover'),
            content: this.renderSegPopoverContent(row, col, segs),
            parentEl: view.el,
            top: topEl.offset().top,
            autoHide: true,
            viewportConstrain: this.opt('popoverViewportConstrain'),
            hide: function () {
                // kill everything when the popover is hidden
                // notify events to be removed
                if (_this.popoverSegs) {
                    _this.triggerBeforeEventSegsDestroyed(_this.popoverSegs);
                }
                _this.segPopover.removeElement();
                _this.segPopover = null;
                _this.popoverSegs = null;
            }
        };
        // Determine horizontal coordinate.
        // We use the moreWrap instead of the <td> to avoid border confusion.
        if (this.isRTL) {
            options.right = moreWrap.offset().left + moreWrap.outerWidth() + 1; // +1 to be over cell border
        }
        else {
            options.left = moreWrap.offset().left - 1; // -1 to be over cell border
        }
        this.segPopover = new Popover_1.default(options);
        this.segPopover.show();
        // the popover doesn't live within the grid's container element, and thus won't get the event
        // delegated-handlers for free. attach event-related handlers to the popover.
        this.bindAllSegHandlersToEl(this.segPopover.el);
        this.triggerAfterEventSegsRendered(segs);
    };
    // Builds the inner DOM contents of the segment popover
    DayGrid.prototype.renderSegPopoverContent = function (row, col, segs) {
        var view = this.view;
        var theme = view.calendar.theme;
        var title = this.getCellDate(row, col).format(this.opt('dayPopoverFormat'));
        var content = $('<div class="fc-header ' + theme.getClass('popoverHeader') + '">' +
            '<span class="fc-close ' + theme.getIconClass('close') + '"></span>' +
            '<span class="fc-title">' +
            util_1.htmlEscape(title) +
            '</span>' +
            '<div class="fc-clear"/>' +
            '</div>' +
            '<div class="fc-body ' + theme.getClass('popoverContent') + '">' +
            '<div class="fc-event-container"></div>' +
            '</div>');
        var segContainer = content.find('.fc-event-container');
        var i;
        // render each seg's `el` and only return the visible segs
        segs = this.eventRenderer.renderFgSegEls(segs, true); // disableResizing=true
        this.popoverSegs = segs;
        for (i = 0; i < segs.length; i++) {
            // because segments in the popover are not part of a grid coordinate system, provide a hint to any
            // grids that want to do drag-n-drop about which cell it came from
            this.hitsNeeded();
            segs[i].hit = this.getCellHit(row, col);
            this.hitsNotNeeded();
            segContainer.append(segs[i].el);
        }
        return content;
    };
    // Given the events within an array of segment objects, reslice them to be in a single day
    DayGrid.prototype.resliceDaySegs = function (segs, dayDate) {
        var dayStart = dayDate.clone();
        var dayEnd = dayStart.clone().add(1, 'days');
        var dayRange = new UnzonedRange_1.default(dayStart, dayEnd);
        var newSegs = [];
        var i;
        var seg;
        var slicedRange;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            slicedRange = seg.footprint.componentFootprint.unzonedRange.intersect(dayRange);
            if (slicedRange) {
                newSegs.push($.extend({}, seg, {
                    footprint: new EventFootprint_1.default(new ComponentFootprint_1.default(slicedRange, seg.footprint.componentFootprint.isAllDay), seg.footprint.eventDef, seg.footprint.eventInstance),
                    isStart: seg.isStart && slicedRange.isStart,
                    isEnd: seg.isEnd && slicedRange.isEnd
                }));
            }
        }
        // force an order because eventsToSegs doesn't guarantee one
        // TODO: research if still needed
        this.eventRenderer.sortEventSegs(newSegs);
        return newSegs;
    };
    // Generates the text that should be inside a "more" link, given the number of events it represents
    DayGrid.prototype.getMoreLinkText = function (num) {
        var opt = this.opt('eventLimitText');
        if (typeof opt === 'function') {
            return opt(num);
        }
        else {
            return '+' + num + ' ' + opt;
        }
    };
    // Returns segments within a given cell.
    // If `startLevel` is specified, returns only events including and below that level. Otherwise returns all segs.
    DayGrid.prototype.getCellSegs = function (row, col, startLevel) {
        var segMatrix = this.eventRenderer.rowStructs[row].segMatrix;
        var level = startLevel || 0;
        var segs = [];
        var seg;
        while (level < segMatrix.length) {
            seg = segMatrix[level][col];
            if (seg) {
                segs.push(seg);
            }
            level++;
        }
        return segs;
    };
    return DayGrid;
}(InteractiveDateComponent_1.default));
exports.default = DayGrid;
DayGrid.prototype.eventRendererClass = DayGridEventRenderer_1.default;
DayGrid.prototype.businessHourRendererClass = BusinessHourRenderer_1.default;
DayGrid.prototype.helperRendererClass = DayGridHelperRenderer_1.default;
DayGrid.prototype.fillRendererClass = DayGridFillRenderer_1.default;
StandardInteractionsMixin_1.default.mixInto(DayGrid);
DayTableMixin_1.default.mixInto(DayGrid);


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Scroller_1 = __webpack_require__(39);
var View_1 = __webpack_require__(41);
var BasicViewDateProfileGenerator_1 = __webpack_require__(228);
var DayGrid_1 = __webpack_require__(61);
/* An abstract class for the "basic" views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/
// It is a manager for a DayGrid subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
var BasicView = /** @class */ (function (_super) {
    tslib_1.__extends(BasicView, _super);
    function BasicView(calendar, viewSpec) {
        var _this = _super.call(this, calendar, viewSpec) || this;
        _this.dayGrid = _this.instantiateDayGrid();
        _this.dayGrid.isRigid = _this.hasRigidRows();
        if (_this.opt('weekNumbers')) {
            if (_this.opt('weekNumbersWithinDays')) {
                _this.dayGrid.cellWeekNumbersVisible = true;
                _this.dayGrid.colWeekNumbersVisible = false;
            }
            else {
                _this.dayGrid.cellWeekNumbersVisible = false;
                _this.dayGrid.colWeekNumbersVisible = true;
            }
        }
        _this.addChild(_this.dayGrid);
        _this.scroller = new Scroller_1.default({
            overflowX: 'hidden',
            overflowY: 'auto'
        });
        return _this;
    }
    // Generates the DayGrid object this view needs. Draws from this.dayGridClass
    BasicView.prototype.instantiateDayGrid = function () {
        // generate a subclass on the fly with BasicView-specific behavior
        // TODO: cache this subclass
        var subclass = makeDayGridSubclass(this.dayGridClass);
        return new subclass(this);
    };
    BasicView.prototype.executeDateRender = function (dateProfile) {
        this.dayGrid.breakOnWeeks = /year|month|week/.test(dateProfile.currentRangeUnit);
        _super.prototype.executeDateRender.call(this, dateProfile);
    };
    BasicView.prototype.renderSkeleton = function () {
        var dayGridContainerEl;
        var dayGridEl;
        this.el.addClass('fc-basic-view').html(this.renderSkeletonHtml());
        this.scroller.render();
        dayGridContainerEl = this.scroller.el.addClass('fc-day-grid-container');
        dayGridEl = $('<div class="fc-day-grid" />').appendTo(dayGridContainerEl);
        this.el.find('.fc-body > tr > td').append(dayGridContainerEl);
        this.dayGrid.headContainerEl = this.el.find('.fc-head-container');
        this.dayGrid.setElement(dayGridEl);
    };
    BasicView.prototype.unrenderSkeleton = function () {
        this.dayGrid.removeElement();
        this.scroller.destroy();
    };
    // Builds the HTML skeleton for the view.
    // The day-grid component will render inside of a container defined by this HTML.
    BasicView.prototype.renderSkeletonHtml = function () {
        var theme = this.calendar.theme;
        return '' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            (this.opt('columnHeader') ?
                '<thead class="fc-head">' +
                    '<tr>' +
                    '<td class="fc-head-container ' + theme.getClass('widgetHeader') + '">&nbsp;</td>' +
                    '</tr>' +
                    '</thead>' :
                '') +
            '<tbody class="fc-body">' +
            '<tr>' +
            '<td class="' + theme.getClass('widgetContent') + '"></td>' +
            '</tr>' +
            '</tbody>' +
            '</table>';
    };
    // Generates an HTML attribute string for setting the width of the week number column, if it is known
    BasicView.prototype.weekNumberStyleAttr = function () {
        if (this.weekNumberWidth != null) {
            return 'style="width:' + this.weekNumberWidth + 'px"';
        }
        return '';
    };
    // Determines whether each row should have a constant height
    BasicView.prototype.hasRigidRows = function () {
        var eventLimit = this.opt('eventLimit');
        return eventLimit && typeof eventLimit !== 'number';
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    // Refreshes the horizontal dimensions of the view
    BasicView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        var eventLimit = this.opt('eventLimit');
        var headRowEl = this.dayGrid.headContainerEl.find('.fc-row');
        var scrollerHeight;
        var scrollbarWidths;
        // hack to give the view some height prior to dayGrid's columns being rendered
        // TODO: separate setting height from scroller VS dayGrid.
        if (!this.dayGrid.rowEls) {
            if (!isAuto) {
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            return;
        }
        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        if (this.dayGrid.colWeekNumbersVisible) {
            // Make sure all week number cells running down the side have the same width.
            // Record the width for cells created later.
            this.weekNumberWidth = util_1.matchCellWidths(this.el.find('.fc-week-number'));
        }
        // reset all heights to be natural
        this.scroller.clear();
        util_1.uncompensateScroll(headRowEl);
        this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
        // is the event limit a constant level number?
        if (eventLimit && typeof eventLimit === 'number') {
            this.dayGrid.limitRows(eventLimit); // limit the levels first so the height can redistribute after
        }
        // distribute the height to the rows
        // (totalHeight is a "recommended" value if isAuto)
        scrollerHeight = this.computeScrollerHeight(totalHeight);
        this.setGridHeight(scrollerHeight, isAuto);
        // is the event limit dynamically calculated?
        if (eventLimit && typeof eventLimit !== 'number') {
            this.dayGrid.limitRows(eventLimit); // limit the levels after the grid's row heights have been set
        }
        if (!isAuto) {
            this.scroller.setHeight(scrollerHeight);
            scrollbarWidths = this.scroller.getScrollbarWidths();
            if (scrollbarWidths.left || scrollbarWidths.right) {
                util_1.compensateScroll(headRowEl, scrollbarWidths);
                // doing the scrollbar compensation might have created text overflow which created more height. redo
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            // guarantees the same scrollbar widths
            this.scroller.lockOverflow(scrollbarWidths);
        }
    };
    // given a desired total height of the view, returns what the height of the scroller should be
    BasicView.prototype.computeScrollerHeight = function (totalHeight) {
        return totalHeight -
            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    };
    // Sets the height of just the DayGrid component in this view
    BasicView.prototype.setGridHeight = function (height, isAuto) {
        if (isAuto) {
            util_1.undistributeHeight(this.dayGrid.rowEls); // let the rows be their natural height with no expanding
        }
        else {
            util_1.distributeHeight(this.dayGrid.rowEls, height, true); // true = compensate for height-hogging rows
        }
    };
    /* Scroll
    ------------------------------------------------------------------------------------------------------------------*/
    BasicView.prototype.computeInitialDateScroll = function () {
        return { top: 0 };
    };
    BasicView.prototype.queryDateScroll = function () {
        return { top: this.scroller.getScrollTop() };
    };
    BasicView.prototype.applyDateScroll = function (scroll) {
        if (scroll.top !== undefined) {
            this.scroller.setScrollTop(scroll.top);
        }
    };
    return BasicView;
}(View_1.default));
exports.default = BasicView;
BasicView.prototype.dateProfileGeneratorClass = BasicViewDateProfileGenerator_1.default;
BasicView.prototype.dayGridClass = DayGrid_1.default;
// customize the rendering behavior of BasicView's dayGrid
function makeDayGridSubclass(SuperClass) {
    return /** @class */ (function (_super) {
        tslib_1.__extends(SubClass, _super);
        function SubClass() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.colWeekNumbersVisible = false; // display week numbers along the side?
            return _this;
        }
        // Generates the HTML that will go before the day-of week header cells
        SubClass.prototype.renderHeadIntroHtml = function () {
            var view = this.view;
            if (this.colWeekNumbersVisible) {
                return '' +
                    '<th class="fc-week-number ' + view.calendar.theme.getClass('widgetHeader') + '" ' + view.weekNumberStyleAttr() + '>' +
                    '<span>' + // needed for matchCellWidths
                    util_1.htmlEscape(this.opt('weekNumberTitle')) +
                    '</span>' +
                    '</th>';
            }
            return '';
        };
        // Generates the HTML that will go before content-skeleton cells that display the day/week numbers
        SubClass.prototype.renderNumberIntroHtml = function (row) {
            var view = this.view;
            var weekStart = this.getCellDate(row, 0);
            if (this.colWeekNumbersVisible) {
                return '' +
                    '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '>' +
                    view.buildGotoAnchorHtml(// aside from link, important for matchCellWidths
                    { date: weekStart, type: 'week', forceOff: this.colCnt === 1 }, weekStart.format('w') // inner HTML
                    ) +
                    '</td>';
            }
            return '';
        };
        // Generates the HTML that goes before the day bg cells for each day-row
        SubClass.prototype.renderBgIntroHtml = function () {
            var view = this.view;
            if (this.colWeekNumbersVisible) {
                return '<td class="fc-week-number ' + view.calendar.theme.getClass('widgetContent') + '" ' +
                    view.weekNumberStyleAttr() + '></td>';
            }
            return '';
        };
        // Generates the HTML that goes before every other type of row generated by DayGrid.
        // Affects helper-skeleton and highlight-skeleton rows.
        SubClass.prototype.renderIntroHtml = function () {
            var view = this.view;
            if (this.colWeekNumbersVisible) {
                return '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '></td>';
            }
            return '';
        };
        SubClass.prototype.getIsNumbersVisible = function () {
            return DayGrid_1.default.prototype.getIsNumbersVisible.apply(this, arguments) || this.colWeekNumbersVisible;
        };
        return SubClass;
    }(SuperClass));
}


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var UnzonedRange_1 = __webpack_require__(5);
var ComponentFootprint_1 = __webpack_require__(12);
var EventDefParser_1 = __webpack_require__(49);
var EventSource_1 = __webpack_require__(6);
var util_1 = __webpack_require__(34);
var Constraints = /** @class */ (function () {
    function Constraints(eventManager, _calendar) {
        this.eventManager = eventManager;
        this._calendar = _calendar;
    }
    Constraints.prototype.opt = function (name) {
        return this._calendar.opt(name);
    };
    /*
    determines if eventInstanceGroup is allowed,
    in relation to other EVENTS and business hours.
    */
    Constraints.prototype.isEventInstanceGroupAllowed = function (eventInstanceGroup) {
        var eventDef = eventInstanceGroup.getEventDef();
        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
        var i;
        var peerEventInstances = this.getPeerEventInstances(eventDef);
        var peerEventRanges = peerEventInstances.map(util_1.eventInstanceToEventRange);
        var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
        var constraintVal = eventDef.getConstraint();
        var overlapVal = eventDef.getOverlap();
        var eventAllowFunc = this.opt('eventAllow');
        for (i = 0; i < eventFootprints.length; i++) {
            if (!this.isFootprintAllowed(eventFootprints[i].componentFootprint, peerEventFootprints, constraintVal, overlapVal, eventFootprints[i].eventInstance)) {
                return false;
            }
        }
        if (eventAllowFunc) {
            for (i = 0; i < eventFootprints.length; i++) {
                if (eventAllowFunc(eventFootprints[i].componentFootprint.toLegacy(this._calendar), eventFootprints[i].getEventLegacy()) === false) {
                    return false;
                }
            }
        }
        return true;
    };
    Constraints.prototype.getPeerEventInstances = function (eventDef) {
        return this.eventManager.getEventInstancesWithoutId(eventDef.id);
    };
    Constraints.prototype.isSelectionFootprintAllowed = function (componentFootprint) {
        var peerEventInstances = this.eventManager.getEventInstances();
        var peerEventRanges = peerEventInstances.map(util_1.eventInstanceToEventRange);
        var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
        var selectAllowFunc;
        if (this.isFootprintAllowed(componentFootprint, peerEventFootprints, this.opt('selectConstraint'), this.opt('selectOverlap'))) {
            selectAllowFunc = this.opt('selectAllow');
            if (selectAllowFunc) {
                return selectAllowFunc(componentFootprint.toLegacy(this._calendar)) !== false;
            }
            else {
                return true;
            }
        }
        return false;
    };
    Constraints.prototype.isFootprintAllowed = function (componentFootprint, peerEventFootprints, constraintVal, overlapVal, subjectEventInstance // optional
    ) {
        var constraintFootprints; // ComponentFootprint[]
        var overlapEventFootprints; // EventFootprint[]
        if (constraintVal != null) {
            constraintFootprints = this.constraintValToFootprints(constraintVal, componentFootprint.isAllDay);
            if (!this.isFootprintWithinConstraints(componentFootprint, constraintFootprints)) {
                return false;
            }
        }
        overlapEventFootprints = this.collectOverlapEventFootprints(peerEventFootprints, componentFootprint);
        if (overlapVal === false) {
            if (overlapEventFootprints.length) {
                return false;
            }
        }
        else if (typeof overlapVal === 'function') {
            if (!isOverlapsAllowedByFunc(overlapEventFootprints, overlapVal, subjectEventInstance)) {
                return false;
            }
        }
        if (subjectEventInstance) {
            if (!isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance)) {
                return false;
            }
        }
        return true;
    };
    // Constraint
    // ------------------------------------------------------------------------------------------------
    Constraints.prototype.isFootprintWithinConstraints = function (componentFootprint, constraintFootprints) {
        var i;
        for (i = 0; i < constraintFootprints.length; i++) {
            if (this.footprintContainsFootprint(constraintFootprints[i], componentFootprint)) {
                return true;
            }
        }
        return false;
    };
    Constraints.prototype.constraintValToFootprints = function (constraintVal, isAllDay) {
        var eventInstances;
        if (constraintVal === 'businessHours') {
            return this.buildCurrentBusinessFootprints(isAllDay);
        }
        else if (typeof constraintVal === 'object') {
            eventInstances = this.parseEventDefToInstances(constraintVal); // handles recurring events
            if (!eventInstances) {
                return this.parseFootprints(constraintVal);
            }
            else {
                return this.eventInstancesToFootprints(eventInstances);
            }
        }
        else if (constraintVal != null) {
            eventInstances = this.eventManager.getEventInstancesWithId(constraintVal);
            return this.eventInstancesToFootprints(eventInstances);
        }
    };
    // returns ComponentFootprint[]
    // uses current view's range
    Constraints.prototype.buildCurrentBusinessFootprints = function (isAllDay) {
        var view = this._calendar.view;
        var businessHourGenerator = view.get('businessHourGenerator');
        var unzonedRange = view.dateProfile.activeUnzonedRange;
        var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(isAllDay, unzonedRange);
        if (eventInstanceGroup) {
            return this.eventInstancesToFootprints(eventInstanceGroup.eventInstances);
        }
        else {
            return [];
        }
    };
    // conversion util
    Constraints.prototype.eventInstancesToFootprints = function (eventInstances) {
        var eventRanges = eventInstances.map(util_1.eventInstanceToEventRange);
        var eventFootprints = this.eventRangesToEventFootprints(eventRanges);
        return eventFootprints.map(util_1.eventFootprintToComponentFootprint);
    };
    // Overlap
    // ------------------------------------------------------------------------------------------------
    Constraints.prototype.collectOverlapEventFootprints = function (peerEventFootprints, targetFootprint) {
        var overlapEventFootprints = [];
        var i;
        for (i = 0; i < peerEventFootprints.length; i++) {
            if (this.footprintsIntersect(targetFootprint, peerEventFootprints[i].componentFootprint)) {
                overlapEventFootprints.push(peerEventFootprints[i]);
            }
        }
        return overlapEventFootprints;
    };
    // Conversion: eventDefs -> eventInstances -> eventRanges -> eventFootprints -> componentFootprints
    // ------------------------------------------------------------------------------------------------
    // NOTE: this might seem like repetitive code with the Grid class, however, this code is related to
    // constraints whereas the Grid code is related to rendering. Each approach might want to convert
    // eventRanges -> eventFootprints in a different way. Regardless, there are opportunities to make
    // this more DRY.
    /*
    Returns false on invalid input.
    */
    Constraints.prototype.parseEventDefToInstances = function (eventInput) {
        var eventManager = this.eventManager;
        var eventDef = EventDefParser_1.default.parse(eventInput, new EventSource_1.default(this._calendar));
        if (!eventDef) {
            return false;
        }
        return eventDef.buildInstances(eventManager.currentPeriod.unzonedRange);
    };
    Constraints.prototype.eventRangesToEventFootprints = function (eventRanges) {
        var i;
        var eventFootprints = [];
        for (i = 0; i < eventRanges.length; i++) {
            eventFootprints.push.apply(// footprints
            eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
        }
        return eventFootprints;
    };
    Constraints.prototype.eventRangeToEventFootprints = function (eventRange) {
        return [util_1.eventRangeToEventFootprint(eventRange)];
    };
    /*
    Parses footprints directly.
    Very similar to EventDateProfile::parse :(
    */
    Constraints.prototype.parseFootprints = function (rawInput) {
        var start;
        var end;
        if (rawInput.start) {
            start = this._calendar.moment(rawInput.start);
            if (!start.isValid()) {
                start = null;
            }
        }
        if (rawInput.end) {
            end = this._calendar.moment(rawInput.end);
            if (!end.isValid()) {
                end = null;
            }
        }
        return [
            new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), (start && !start.hasTime()) || (end && !end.hasTime()) // isAllDay
            )
        ];
    };
    // Footprint Utils
    // ----------------------------------------------------------------------------------------
    Constraints.prototype.footprintContainsFootprint = function (outerFootprint, innerFootprint) {
        return outerFootprint.unzonedRange.containsRange(innerFootprint.unzonedRange);
    };
    Constraints.prototype.footprintsIntersect = function (footprint0, footprint1) {
        return footprint0.unzonedRange.intersectsWith(footprint1.unzonedRange);
    };
    return Constraints;
}());
exports.default = Constraints;
// optional subjectEventInstance
function isOverlapsAllowedByFunc(overlapEventFootprints, overlapFunc, subjectEventInstance) {
    var i;
    for (i = 0; i < overlapEventFootprints.length; i++) {
        if (!overlapFunc(overlapEventFootprints[i].eventInstance.toLegacy(), subjectEventInstance ? subjectEventInstance.toLegacy() : null)) {
            return false;
        }
    }
    return true;
}
function isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance) {
    var subjectLegacyInstance = subjectEventInstance.toLegacy();
    var i;
    var overlapEventInstance;
    var overlapEventDef;
    var overlapVal;
    for (i = 0; i < overlapEventFootprints.length; i++) {
        overlapEventInstance = overlapEventFootprints[i].eventInstance;
        overlapEventDef = overlapEventInstance.def;
        // don't need to pass in calendar, because don't want to consider global eventOverlap property,
        // because we already considered that earlier in the process.
        overlapVal = overlapEventDef.getOverlap();
        if (overlapVal === false) {
            return false;
        }
        else if (typeof overlapVal === 'function') {
            if (!overlapVal(overlapEventInstance.toLegacy(), subjectLegacyInstance)) {
                return false;
            }
        }
    }
    return true;
}


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

/*
USAGE:
  import { default as ParsableModelMixin, ParsableModelInterface } from './ParsableModelMixin'
in class:
  applyProps: ParsableModelInterface['applyProps']
  applyManualStandardProps: ParsableModelInterface['applyManualStandardProps']
  applyMiscProps: ParsableModelInterface['applyMiscProps']
  isStandardProp: ParsableModelInterface['isStandardProp']
  static defineStandardProps = ParsableModelMixin.defineStandardProps
  static copyVerbatimStandardProps = ParsableModelMixin.copyVerbatimStandardProps
after class:
  ParsableModelMixin.mixInto(TheClass)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var Mixin_1 = __webpack_require__(14);
var ParsableModelMixin = /** @class */ (function (_super) {
    tslib_1.__extends(ParsableModelMixin, _super);
    function ParsableModelMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParsableModelMixin.defineStandardProps = function (propDefs) {
        var proto = this.prototype;
        if (!proto.hasOwnProperty('standardPropMap')) {
            proto.standardPropMap = Object.create(proto.standardPropMap);
        }
        util_1.copyOwnProps(propDefs, proto.standardPropMap);
    };
    ParsableModelMixin.copyVerbatimStandardProps = function (src, dest) {
        var map = this.prototype.standardPropMap;
        var propName;
        for (propName in map) {
            if (src[propName] != null && // in the src object?
                map[propName] === true // false means "copy verbatim"
            ) {
                dest[propName] = src[propName];
            }
        }
    };
    /*
    Returns true/false for success.
    Meant to be only called ONCE, at object creation.
    */
    ParsableModelMixin.prototype.applyProps = function (rawProps) {
        var standardPropMap = this.standardPropMap;
        var manualProps = {};
        var miscProps = {};
        var propName;
        for (propName in rawProps) {
            if (standardPropMap[propName] === true) {
                this[propName] = rawProps[propName];
            }
            else if (standardPropMap[propName] === false) {
                manualProps[propName] = rawProps[propName];
            }
            else {
                miscProps[propName] = rawProps[propName];
            }
        }
        this.applyMiscProps(miscProps);
        return this.applyManualStandardProps(manualProps);
    };
    /*
    If subclasses override, they must call this supermethod and return the boolean response.
    Meant to be only called ONCE, at object creation.
    */
    ParsableModelMixin.prototype.applyManualStandardProps = function (rawProps) {
        return true;
    };
    /*
    Can be called even after initial object creation.
    */
    ParsableModelMixin.prototype.applyMiscProps = function (rawProps) {
        // subclasses can implement
    };
    /*
    TODO: why is this a method when defineStandardProps is static
    */
    ParsableModelMixin.prototype.isStandardProp = function (propName) {
        return propName in this.standardPropMap;
    };
    return ParsableModelMixin;
}(Mixin_1.default));
exports.default = ParsableModelMixin;
ParsableModelMixin.prototype.standardPropMap = {}; // will be cloned by defineStandardProps


/***/ }),
/* 209 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventInstance = /** @class */ (function () {
    function EventInstance(def, dateProfile) {
        this.def = def;
        this.dateProfile = dateProfile;
    }
    EventInstance.prototype.toLegacy = function () {
        var dateProfile = this.dateProfile;
        var obj = this.def.toLegacy();
        obj.start = dateProfile.start.clone();
        obj.end = dateProfile.end ? dateProfile.end.clone() : null;
        return obj;
    };
    return EventInstance;
}());
exports.default = EventInstance;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var EventDef_1 = __webpack_require__(33);
var EventInstance_1 = __webpack_require__(209);
var EventDateProfile_1 = __webpack_require__(17);
var RecurringEventDef = /** @class */ (function (_super) {
    tslib_1.__extends(RecurringEventDef, _super);
    function RecurringEventDef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecurringEventDef.prototype.isAllDay = function () {
        return !this.startTime && !this.endTime;
    };
    RecurringEventDef.prototype.buildInstances = function (unzonedRange) {
        var calendar = this.source.calendar;
        var unzonedDate = unzonedRange.getStart();
        var unzonedEnd = unzonedRange.getEnd();
        var zonedDayStart;
        var instanceStart;
        var instanceEnd;
        var instances = [];
        while (unzonedDate.isBefore(unzonedEnd)) {
            // if everyday, or this particular day-of-week
            if (!this.dowHash || this.dowHash[unzonedDate.day()]) {
                zonedDayStart = calendar.applyTimezone(unzonedDate);
                instanceStart = zonedDayStart.clone();
                instanceEnd = null;
                if (this.startTime) {
                    instanceStart.time(this.startTime);
                }
                else {
                    instanceStart.stripTime();
                }
                if (this.endTime) {
                    instanceEnd = zonedDayStart.clone().time(this.endTime);
                }
                instances.push(new EventInstance_1.default(this, // definition
                new EventDateProfile_1.default(instanceStart, instanceEnd, calendar)));
            }
            unzonedDate.add(1, 'days');
        }
        return instances;
    };
    RecurringEventDef.prototype.setDow = function (dowNumbers) {
        if (!this.dowHash) {
            this.dowHash = {};
        }
        for (var i = 0; i < dowNumbers.length; i++) {
            this.dowHash[dowNumbers[i]] = true;
        }
    };
    RecurringEventDef.prototype.clone = function () {
        var def = _super.prototype.clone.call(this);
        if (def.startTime) {
            def.startTime = moment.duration(this.startTime);
        }
        if (def.endTime) {
            def.endTime = moment.duration(this.endTime);
        }
        if (this.dowHash) {
            def.dowHash = $.extend({}, this.dowHash);
        }
        return def;
    };
    return RecurringEventDef;
}(EventDef_1.default));
exports.default = RecurringEventDef;
/*
HACK to work with TypeScript mixins
NOTE: if super-method fails, should still attempt to apply
*/
RecurringEventDef.prototype.applyProps = function (rawProps) {
    var superSuccess = EventDef_1.default.prototype.applyProps.call(this, rawProps);
    if (rawProps.start) {
        this.startTime = moment.duration(rawProps.start);
    }
    if (rawProps.end) {
        this.endTime = moment.duration(rawProps.end);
    }
    if (rawProps.dow) {
        this.setDow(rawProps.dow);
    }
    return superSuccess;
};
// Parsing
// ---------------------------------------------------------------------------------------------------------------------
RecurringEventDef.defineStandardProps({
    start: false,
    end: false,
    dow: false
});


/***/ }),
/* 211 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventRange = /** @class */ (function () {
    function EventRange(unzonedRange, eventDef, eventInstance) {
        this.unzonedRange = unzonedRange;
        this.eventDef = eventDef;
        if (eventInstance) {
            this.eventInstance = eventInstance;
        }
    }
    return EventRange;
}());
exports.default = EventRange;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(34);
var EventInstanceGroup_1 = __webpack_require__(18);
var RecurringEventDef_1 = __webpack_require__(210);
var EventSource_1 = __webpack_require__(6);
var BUSINESS_HOUR_EVENT_DEFAULTS = {
    start: '09:00',
    end: '17:00',
    dow: [1, 2, 3, 4, 5],
    rendering: 'inverse-background'
    // classNames are defined in businessHoursSegClasses
};
var BusinessHourGenerator = /** @class */ (function () {
    function BusinessHourGenerator(rawComplexDef, calendar) {
        this.rawComplexDef = rawComplexDef;
        this.calendar = calendar;
    }
    BusinessHourGenerator.prototype.buildEventInstanceGroup = function (isAllDay, unzonedRange) {
        var eventDefs = this.buildEventDefs(isAllDay);
        var eventInstanceGroup;
        if (eventDefs.length) {
            eventInstanceGroup = new EventInstanceGroup_1.default(util_1.eventDefsToEventInstances(eventDefs, unzonedRange));
            // so that inverse-background rendering can happen even when no eventRanges in view
            eventInstanceGroup.explicitEventDef = eventDefs[0];
            return eventInstanceGroup;
        }
    };
    BusinessHourGenerator.prototype.buildEventDefs = function (isAllDay) {
        var rawComplexDef = this.rawComplexDef;
        var rawDefs = [];
        var requireDow = false;
        var i;
        var defs = [];
        if (rawComplexDef === true) {
            rawDefs = [{}]; // will get BUSINESS_HOUR_EVENT_DEFAULTS verbatim
        }
        else if ($.isPlainObject(rawComplexDef)) {
            rawDefs = [rawComplexDef];
        }
        else if ($.isArray(rawComplexDef)) {
            rawDefs = rawComplexDef;
            requireDow = true; // every sub-definition NEEDS a day-of-week
        }
        for (i = 0; i < rawDefs.length; i++) {
            if (!requireDow || rawDefs[i].dow) {
                defs.push(this.buildEventDef(isAllDay, rawDefs[i]));
            }
        }
        return defs;
    };
    BusinessHourGenerator.prototype.buildEventDef = function (isAllDay, rawDef) {
        var fullRawDef = $.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, rawDef);
        if (isAllDay) {
            fullRawDef.start = null;
            fullRawDef.end = null;
        }
        return RecurringEventDef_1.default.parse(fullRawDef, new EventSource_1.default(this.calendar) // dummy source
        );
    };
    return BusinessHourGenerator;
}());
exports.default = BusinessHourGenerator;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Theme_1 = __webpack_require__(38);
var StandardTheme = /** @class */ (function (_super) {
    tslib_1.__extends(StandardTheme, _super);
    function StandardTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StandardTheme;
}(Theme_1.default));
exports.default = StandardTheme;
StandardTheme.prototype.classes = {
    widget: 'fc-unthemed',
    widgetHeader: 'fc-widget-header',
    widgetContent: 'fc-widget-content',
    buttonGroup: 'fc-button-group',
    button: 'fc-button',
    cornerLeft: 'fc-corner-left',
    cornerRight: 'fc-corner-right',
    stateDefault: 'fc-state-default',
    stateActive: 'fc-state-active',
    stateDisabled: 'fc-state-disabled',
    stateHover: 'fc-state-hover',
    stateDown: 'fc-state-down',
    popoverHeader: 'fc-widget-header',
    popoverContent: 'fc-widget-content',
    // day grid
    headerRow: 'fc-widget-header',
    dayRow: 'fc-widget-content',
    // list view
    listView: 'fc-widget-content'
};
StandardTheme.prototype.baseIconClass = 'fc-icon';
StandardTheme.prototype.iconClasses = {
    close: 'fc-icon-x',
    prev: 'fc-icon-left-single-arrow',
    next: 'fc-icon-right-single-arrow',
    prevYear: 'fc-icon-left-double-arrow',
    nextYear: 'fc-icon-right-double-arrow'
};
StandardTheme.prototype.iconOverrideOption = 'buttonIcons';
StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Theme_1 = __webpack_require__(38);
var JqueryUiTheme = /** @class */ (function (_super) {
    tslib_1.__extends(JqueryUiTheme, _super);
    function JqueryUiTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return JqueryUiTheme;
}(Theme_1.default));
exports.default = JqueryUiTheme;
JqueryUiTheme.prototype.classes = {
    widget: 'ui-widget',
    widgetHeader: 'ui-widget-header',
    widgetContent: 'ui-widget-content',
    buttonGroup: 'fc-button-group',
    button: 'ui-button',
    cornerLeft: 'ui-corner-left',
    cornerRight: 'ui-corner-right',
    stateDefault: 'ui-state-default',
    stateActive: 'ui-state-active',
    stateDisabled: 'ui-state-disabled',
    stateHover: 'ui-state-hover',
    stateDown: 'ui-state-down',
    today: 'ui-state-highlight',
    popoverHeader: 'ui-widget-header',
    popoverContent: 'ui-widget-content',
    // day grid
    headerRow: 'ui-widget-header',
    dayRow: 'ui-widget-content',
    // list view
    listView: 'ui-widget-content'
};
JqueryUiTheme.prototype.baseIconClass = 'ui-icon';
JqueryUiTheme.prototype.iconClasses = {
    close: 'ui-icon-closethick',
    prev: 'ui-icon-circle-triangle-w',
    next: 'ui-icon-circle-triangle-e',
    prevYear: 'ui-icon-seek-prev',
    nextYear: 'ui-icon-seek-next'
};
JqueryUiTheme.prototype.iconOverrideOption = 'themeButtonIcons';
JqueryUiTheme.prototype.iconOverrideCustomButtonOption = 'themeIcon';
JqueryUiTheme.prototype.iconOverridePrefix = 'ui-icon-';


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var Promise_1 = __webpack_require__(19);
var EventSource_1 = __webpack_require__(6);
var FuncEventSource = /** @class */ (function (_super) {
    tslib_1.__extends(FuncEventSource, _super);
    function FuncEventSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FuncEventSource.parse = function (rawInput, calendar) {
        var rawProps;
        // normalize raw input
        if ($.isFunction(rawInput.events)) {
            rawProps = rawInput;
        }
        else if ($.isFunction(rawInput)) {
            rawProps = { events: rawInput };
        }
        if (rawProps) {
            return EventSource_1.default.parse.call(this, rawProps, calendar);
        }
        return false;
    };
    FuncEventSource.prototype.fetch = function (start, end, timezone) {
        var _this = this;
        this.calendar.pushLoading();
        return Promise_1.default.construct(function (onResolve) {
            _this.func.call(_this.calendar, start.clone(), end.clone(), timezone, function (rawEventDefs) {
                _this.calendar.popLoading();
                onResolve(_this.parseEventDefs(rawEventDefs));
            });
        });
    };
    FuncEventSource.prototype.getPrimitive = function () {
        return this.func;
    };
    FuncEventSource.prototype.applyManualStandardProps = function (rawProps) {
        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
        this.func = rawProps.events;
        return superSuccess;
    };
    return FuncEventSource;
}(EventSource_1.default));
exports.default = FuncEventSource;
FuncEventSource.defineStandardProps({
    events: false // don't automatically transfer
});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Promise_1 = __webpack_require__(19);
var EventSource_1 = __webpack_require__(6);
var JsonFeedEventSource = /** @class */ (function (_super) {
    tslib_1.__extends(JsonFeedEventSource, _super);
    function JsonFeedEventSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JsonFeedEventSource.parse = function (rawInput, calendar) {
        var rawProps;
        // normalize raw input
        if (typeof rawInput.url === 'string') {
            rawProps = rawInput;
        }
        else if (typeof rawInput === 'string') {
            rawProps = { url: rawInput };
        }
        if (rawProps) {
            return EventSource_1.default.parse.call(this, rawProps, calendar);
        }
        return false;
    };
    JsonFeedEventSource.prototype.fetch = function (start, end, timezone) {
        var _this = this;
        var ajaxSettings = this.ajaxSettings;
        var onSuccess = ajaxSettings.success;
        var onError = ajaxSettings.error;
        var requestParams = this.buildRequestParams(start, end, timezone);
        // todo: eventually handle the promise's then,
        // don't intercept success/error
        // tho will be a breaking API change
        this.calendar.pushLoading();
        return Promise_1.default.construct(function (onResolve, onReject) {
            $.ajax($.extend({}, // destination
            JsonFeedEventSource.AJAX_DEFAULTS, ajaxSettings, {
                url: _this.url,
                data: requestParams,
                success: function (rawEventDefs, status, xhr) {
                    var callbackRes;
                    _this.calendar.popLoading();
                    if (rawEventDefs) {
                        callbackRes = util_1.applyAll(onSuccess, _this, [rawEventDefs, status, xhr]); // redirect `this`
                        if ($.isArray(callbackRes)) {
                            rawEventDefs = callbackRes;
                        }
                        onResolve(_this.parseEventDefs(rawEventDefs));
                    }
                    else {
                        onReject();
                    }
                },
                error: function (xhr, statusText, errorThrown) {
                    _this.calendar.popLoading();
                    util_1.applyAll(onError, _this, [xhr, statusText, errorThrown]); // redirect `this`
                    onReject();
                }
            }));
        });
    };
    JsonFeedEventSource.prototype.buildRequestParams = function (start, end, timezone) {
        var calendar = this.calendar;
        var ajaxSettings = this.ajaxSettings;
        var startParam;
        var endParam;
        var timezoneParam;
        var customRequestParams;
        var params = {};
        startParam = this.startParam;
        if (startParam == null) {
            startParam = calendar.opt('startParam');
        }
        endParam = this.endParam;
        if (endParam == null) {
            endParam = calendar.opt('endParam');
        }
        timezoneParam = this.timezoneParam;
        if (timezoneParam == null) {
            timezoneParam = calendar.opt('timezoneParam');
        }
        // retrieve any outbound GET/POST $.ajax data from the options
        if ($.isFunction(ajaxSettings.data)) {
            // supplied as a function that returns a key/value object
            customRequestParams = ajaxSettings.data();
        }
        else {
            // probably supplied as a straight key/value object
            customRequestParams = ajaxSettings.data || {};
        }
        $.extend(params, customRequestParams);
        params[startParam] = start.format();
        params[endParam] = end.format();
        if (timezone && timezone !== 'local') {
            params[timezoneParam] = timezone;
        }
        return params;
    };
    JsonFeedEventSource.prototype.getPrimitive = function () {
        return this.url;
    };
    JsonFeedEventSource.prototype.applyMiscProps = function (rawProps) {
        this.ajaxSettings = rawProps;
    };
    JsonFeedEventSource.AJAX_DEFAULTS = {
        dataType: 'json',
        cache: false
    };
    return JsonFeedEventSource;
}(EventSource_1.default));
exports.default = JsonFeedEventSource;
JsonFeedEventSource.defineStandardProps({
    // automatically transfer (true)...
    url: true,
    startParam: true,
    endParam: true,
    timezoneParam: true
});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var EmitterMixin_1 = __webpack_require__(11);
var TaskQueue = /** @class */ (function () {
    function TaskQueue() {
        this.q = [];
        this.isPaused = false;
        this.isRunning = false;
    }
    TaskQueue.prototype.queue = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.q.push.apply(this.q, args); // append
        this.tryStart();
    };
    TaskQueue.prototype.pause = function () {
        this.isPaused = true;
    };
    TaskQueue.prototype.resume = function () {
        this.isPaused = false;
        this.tryStart();
    };
    TaskQueue.prototype.getIsIdle = function () {
        return !this.isRunning && !this.isPaused;
    };
    TaskQueue.prototype.tryStart = function () {
        if (!this.isRunning && this.canRunNext()) {
            this.isRunning = true;
            this.trigger('start');
            this.runRemaining();
        }
    };
    TaskQueue.prototype.canRunNext = function () {
        return !this.isPaused && this.q.length;
    };
    TaskQueue.prototype.runRemaining = function () {
        var _this = this;
        var task;
        var res;
        do {
            task = this.q.shift(); // always freshly reference q. might have been reassigned.
            res = this.runTask(task);
            if (res && res.then) {
                res.then(function () {
                    if (_this.canRunNext()) {
                        _this.runRemaining();
                    }
                });
                return; // prevent marking as stopped
            }
        } while (this.canRunNext());
        this.trigger('stop'); // not really a 'stop' ... more of a 'drained'
        this.isRunning = false;
        // if 'stop' handler added more tasks.... TODO: write test for this
        this.tryStart();
    };
    TaskQueue.prototype.runTask = function (task) {
        return task(); // task *is* the function, but subclasses can change the format of a task
    };
    return TaskQueue;
}());
exports.default = TaskQueue;
EmitterMixin_1.default.mixInto(TaskQueue);


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var TaskQueue_1 = __webpack_require__(217);
var RenderQueue = /** @class */ (function (_super) {
    tslib_1.__extends(RenderQueue, _super);
    function RenderQueue(waitsByNamespace) {
        var _this = _super.call(this) || this;
        _this.waitsByNamespace = waitsByNamespace || {};
        return _this;
    }
    RenderQueue.prototype.queue = function (taskFunc, namespace, type) {
        var task = {
            func: taskFunc,
            namespace: namespace,
            type: type
        };
        var waitMs;
        if (namespace) {
            waitMs = this.waitsByNamespace[namespace];
        }
        if (this.waitNamespace) {
            if (namespace === this.waitNamespace && waitMs != null) {
                this.delayWait(waitMs);
            }
            else {
                this.clearWait();
                this.tryStart();
            }
        }
        if (this.compoundTask(task)) {
            if (!this.waitNamespace && waitMs != null) {
                this.startWait(namespace, waitMs);
            }
            else {
                this.tryStart();
            }
        }
    };
    RenderQueue.prototype.startWait = function (namespace, waitMs) {
        this.waitNamespace = namespace;
        this.spawnWait(waitMs);
    };
    RenderQueue.prototype.delayWait = function (waitMs) {
        clearTimeout(this.waitId);
        this.spawnWait(waitMs);
    };
    RenderQueue.prototype.spawnWait = function (waitMs) {
        var _this = this;
        this.waitId = setTimeout(function () {
            _this.waitNamespace = null;
            _this.tryStart();
        }, waitMs);
    };
    RenderQueue.prototype.clearWait = function () {
        if (this.waitNamespace) {
            clearTimeout(this.waitId);
            this.waitId = null;
            this.waitNamespace = null;
        }
    };
    RenderQueue.prototype.canRunNext = function () {
        if (!_super.prototype.canRunNext.call(this)) {
            return false;
        }
        // waiting for a certain namespace to stop receiving tasks?
        if (this.waitNamespace) {
            var q = this.q;
            // if there was a different namespace task in the meantime,
            // that forces all previously-waiting tasks to suddenly execute.
            // TODO: find a way to do this in constant time.
            for (var i = 0; i < q.length; i++) {
                if (q[i].namespace !== this.waitNamespace) {
                    return true; // allow execution
                }
            }
            return false;
        }
        return true;
    };
    RenderQueue.prototype.runTask = function (task) {
        task.func();
    };
    RenderQueue.prototype.compoundTask = function (newTask) {
        var q = this.q;
        var shouldAppend = true;
        var i;
        var task;
        if (newTask.namespace && newTask.type === 'destroy') {
            // remove all init/add/remove ops with same namespace, regardless of order
            for (i = q.length - 1; i >= 0; i--) {
                task = q[i];
                switch (task.type) {
                    case 'init':
                        shouldAppend = false;
                    // the latest destroy is cancelled out by not doing the init
                    /* falls through */
                    case 'add':
                    /* falls through */
                    case 'remove':
                        q.splice(i, 1); // remove task
                }
            }
        }
        if (shouldAppend) {
            q.push(newTask);
        }
        return shouldAppend;
    };
    return RenderQueue;
}(TaskQueue_1.default));
exports.default = RenderQueue;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var moment_ext_1 = __webpack_require__(10);
var date_formatting_1 = __webpack_require__(47);
var Component_1 = __webpack_require__(237);
var util_2 = __webpack_require__(34);
var DateComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DateComponent, _super);
    function DateComponent(_view, _options) {
        var _this = _super.call(this) || this;
        _this.isRTL = false; // frequently accessed options
        _this.hitsNeededDepth = 0; // necessary because multiple callers might need the same hits
        _this.hasAllDayBusinessHours = false; // TODO: unify with largeUnit and isTimeScale?
        _this.isDatesRendered = false;
        // hack to set options prior to the this.opt calls
        if (_view) {
            _this['view'] = _view;
        }
        if (_options) {
            _this['options'] = _options;
        }
        _this.uid = String(DateComponent.guid++);
        _this.childrenByUid = {};
        _this.nextDayThreshold = moment.duration(_this.opt('nextDayThreshold'));
        _this.isRTL = _this.opt('isRTL');
        if (_this.fillRendererClass) {
            _this.fillRenderer = new _this.fillRendererClass(_this);
        }
        if (_this.eventRendererClass) {
            _this.eventRenderer = new _this.eventRendererClass(_this, _this.fillRenderer);
        }
        if (_this.helperRendererClass && _this.eventRenderer) {
            _this.helperRenderer = new _this.helperRendererClass(_this, _this.eventRenderer);
        }
        if (_this.businessHourRendererClass && _this.fillRenderer) {
            _this.businessHourRenderer = new _this.businessHourRendererClass(_this, _this.fillRenderer);
        }
        return _this;
    }
    DateComponent.prototype.addChild = function (child) {
        if (!this.childrenByUid[child.uid]) {
            this.childrenByUid[child.uid] = child;
            return true;
        }
        return false;
    };
    DateComponent.prototype.removeChild = function (child) {
        if (this.childrenByUid[child.uid]) {
            delete this.childrenByUid[child.uid];
            return true;
        }
        return false;
    };
    // TODO: only do if isInDom?
    // TODO: make part of Component, along with children/batch-render system?
    DateComponent.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        this.callChildren('updateSize', arguments);
    };
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.opt = function (name) {
        return this._getView().opt(name); // default implementation
    };
    DateComponent.prototype.publiclyTrigger = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var calendar = this._getCalendar();
        return calendar.publiclyTrigger.apply(calendar, args);
    };
    DateComponent.prototype.hasPublicHandlers = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var calendar = this._getCalendar();
        return calendar.hasPublicHandlers.apply(calendar, args);
    };
    // Date
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.executeDateRender = function (dateProfile) {
        this.dateProfile = dateProfile; // for rendering
        this.renderDates(dateProfile);
        this.isDatesRendered = true;
        this.callChildren('executeDateRender', arguments);
    };
    DateComponent.prototype.executeDateUnrender = function () {
        this.callChildren('executeDateUnrender', arguments);
        this.dateProfile = null;
        this.unrenderDates();
        this.isDatesRendered = false;
    };
    // date-cell content only
    DateComponent.prototype.renderDates = function (dateProfile) {
        // subclasses should implement
    };
    // date-cell content only
    DateComponent.prototype.unrenderDates = function () {
        // subclasses should override
    };
    // Now-Indicator
    // -----------------------------------------------------------------------------------------------------------------
    // Returns a string unit, like 'second' or 'minute' that defined how often the current time indicator
    // should be refreshed. If something falsy is returned, no time indicator is rendered at all.
    DateComponent.prototype.getNowIndicatorUnit = function () {
        // subclasses should implement
    };
    // Renders a current time indicator at the given datetime
    DateComponent.prototype.renderNowIndicator = function (date) {
        this.callChildren('renderNowIndicator', arguments);
    };
    // Undoes the rendering actions from renderNowIndicator
    DateComponent.prototype.unrenderNowIndicator = function () {
        this.callChildren('unrenderNowIndicator', arguments);
    };
    // Business Hours
    // ---------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.renderBusinessHours = function (businessHourGenerator) {
        if (this.businessHourRenderer) {
            this.businessHourRenderer.render(businessHourGenerator);
        }
        this.callChildren('renderBusinessHours', arguments);
    };
    // Unrenders previously-rendered business-hours
    DateComponent.prototype.unrenderBusinessHours = function () {
        this.callChildren('unrenderBusinessHours', arguments);
        if (this.businessHourRenderer) {
            this.businessHourRenderer.unrender();
        }
    };
    // Event Displaying
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.executeEventRender = function (eventsPayload) {
        if (this.eventRenderer) {
            this.eventRenderer.rangeUpdated(); // poorly named now
            this.eventRenderer.render(eventsPayload);
        }
        else if (this['renderEvents']) {
            this['renderEvents'](convertEventsPayloadToLegacyArray(eventsPayload));
        }
        this.callChildren('executeEventRender', arguments);
    };
    DateComponent.prototype.executeEventUnrender = function () {
        this.callChildren('executeEventUnrender', arguments);
        if (this.eventRenderer) {
            this.eventRenderer.unrender();
        }
        else if (this['destroyEvents']) {
            this['destroyEvents']();
        }
    };
    DateComponent.prototype.getBusinessHourSegs = function () {
        var segs = this.getOwnBusinessHourSegs();
        this.iterChildren(function (child) {
            segs.push.apply(segs, child.getBusinessHourSegs());
        });
        return segs;
    };
    DateComponent.prototype.getOwnBusinessHourSegs = function () {
        if (this.businessHourRenderer) {
            return this.businessHourRenderer.getSegs();
        }
        return [];
    };
    DateComponent.prototype.getEventSegs = function () {
        var segs = this.getOwnEventSegs();
        this.iterChildren(function (child) {
            segs.push.apply(segs, child.getEventSegs());
        });
        return segs;
    };
    DateComponent.prototype.getOwnEventSegs = function () {
        if (this.eventRenderer) {
            return this.eventRenderer.getSegs();
        }
        return [];
    };
    // Event Rendering Triggering
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.triggerAfterEventsRendered = function () {
        this.triggerAfterEventSegsRendered(this.getEventSegs());
        this.publiclyTrigger('eventAfterAllRender', {
            context: this,
            args: [this]
        });
    };
    DateComponent.prototype.triggerAfterEventSegsRendered = function (segs) {
        var _this = this;
        // an optimization, because getEventLegacy is expensive
        if (this.hasPublicHandlers('eventAfterRender')) {
            segs.forEach(function (seg) {
                var legacy;
                if (seg.el) {
                    legacy = seg.footprint.getEventLegacy();
                    _this.publiclyTrigger('eventAfterRender', {
                        context: legacy,
                        args: [legacy, seg.el, _this]
                    });
                }
            });
        }
    };
    DateComponent.prototype.triggerBeforeEventsDestroyed = function () {
        this.triggerBeforeEventSegsDestroyed(this.getEventSegs());
    };
    DateComponent.prototype.triggerBeforeEventSegsDestroyed = function (segs) {
        var _this = this;
        if (this.hasPublicHandlers('eventDestroy')) {
            segs.forEach(function (seg) {
                var legacy;
                if (seg.el) {
                    legacy = seg.footprint.getEventLegacy();
                    _this.publiclyTrigger('eventDestroy', {
                        context: legacy,
                        args: [legacy, seg.el, _this]
                    });
                }
            });
        }
    };
    // Event Rendering Utils
    // -----------------------------------------------------------------------------------------------------------------
    // Hides all rendered event segments linked to the given event
    // RECURSIVE with subcomponents
    DateComponent.prototype.showEventsWithId = function (eventDefId) {
        this.getEventSegs().forEach(function (seg) {
            if (seg.footprint.eventDef.id === eventDefId &&
                seg.el // necessary?
            ) {
                seg.el.css('visibility', '');
            }
        });
        this.callChildren('showEventsWithId', arguments);
    };
    // Shows all rendered event segments linked to the given event
    // RECURSIVE with subcomponents
    DateComponent.prototype.hideEventsWithId = function (eventDefId) {
        this.getEventSegs().forEach(function (seg) {
            if (seg.footprint.eventDef.id === eventDefId &&
                seg.el // necessary?
            ) {
                seg.el.css('visibility', 'hidden');
            }
        });
        this.callChildren('hideEventsWithId', arguments);
    };
    // Drag-n-Drop Rendering (for both events and external elements)
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of a event or external-element drag over the given drop zone.
    // If an external-element, seg will be `null`.
    // Must return elements used for any mock events.
    DateComponent.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        var renderedHelper = false;
        this.iterChildren(function (child) {
            if (child.renderDrag(eventFootprints, seg, isTouch)) {
                renderedHelper = true;
            }
        });
        return renderedHelper;
    };
    // Unrenders a visual indication of an event or external-element being dragged.
    DateComponent.prototype.unrenderDrag = function () {
        this.callChildren('unrenderDrag', arguments);
    };
    // Event Resizing
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of an event being resized.
    DateComponent.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        this.callChildren('renderEventResize', arguments);
    };
    // Unrenders a visual indication of an event being resized.
    DateComponent.prototype.unrenderEventResize = function () {
        this.callChildren('unrenderEventResize', arguments);
    };
    // Selection
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of the selection
    // TODO: rename to `renderSelection` after legacy is gone
    DateComponent.prototype.renderSelectionFootprint = function (componentFootprint) {
        this.renderHighlight(componentFootprint);
        this.callChildren('renderSelectionFootprint', arguments);
    };
    // Unrenders a visual indication of selection
    DateComponent.prototype.unrenderSelection = function () {
        this.unrenderHighlight();
        this.callChildren('unrenderSelection', arguments);
    };
    // Highlight
    // ---------------------------------------------------------------------------------------------------------------
    // Renders an emphasis on the given date range. Given a span (unzoned start/end and other misc data)
    DateComponent.prototype.renderHighlight = function (componentFootprint) {
        if (this.fillRenderer) {
            this.fillRenderer.renderFootprint('highlight', componentFootprint, {
                getClasses: function () {
                    return ['fc-highlight'];
                }
            });
        }
        this.callChildren('renderHighlight', arguments);
    };
    // Unrenders the emphasis on a date range
    DateComponent.prototype.unrenderHighlight = function () {
        if (this.fillRenderer) {
            this.fillRenderer.unrender('highlight');
        }
        this.callChildren('unrenderHighlight', arguments);
    };
    // Hit Areas
    // ---------------------------------------------------------------------------------------------------------------
    // just because all DateComponents support this interface
    // doesn't mean they need to have their own internal coord system. they can defer to sub-components.
    DateComponent.prototype.hitsNeeded = function () {
        if (!(this.hitsNeededDepth++)) {
            this.prepareHits();
        }
        this.callChildren('hitsNeeded', arguments);
    };
    DateComponent.prototype.hitsNotNeeded = function () {
        if (this.hitsNeededDepth && !(--this.hitsNeededDepth)) {
            this.releaseHits();
        }
        this.callChildren('hitsNotNeeded', arguments);
    };
    DateComponent.prototype.prepareHits = function () {
        // subclasses can implement
    };
    DateComponent.prototype.releaseHits = function () {
        // subclasses can implement
    };
    // Given coordinates from the topleft of the document, return data about the date-related area underneath.
    // Can return an object with arbitrary properties (although top/right/left/bottom are encouraged).
    // Must have a `grid` property, a reference to this current grid. TODO: avoid this
    // The returned object will be processed by getHitFootprint and getHitEl.
    DateComponent.prototype.queryHit = function (leftOffset, topOffset) {
        var childrenByUid = this.childrenByUid;
        var uid;
        var hit;
        for (uid in childrenByUid) {
            hit = childrenByUid[uid].queryHit(leftOffset, topOffset);
            if (hit) {
                break;
            }
        }
        return hit;
    };
    DateComponent.prototype.getSafeHitFootprint = function (hit) {
        var footprint = this.getHitFootprint(hit);
        if (!this.dateProfile.activeUnzonedRange.containsRange(footprint.unzonedRange)) {
            return null;
        }
        return footprint;
    };
    DateComponent.prototype.getHitFootprint = function (hit) {
        // what about being abstract!?
    };
    // Given position-level information about a date-related area within the grid,
    // should return a jQuery element that best represents it. passed to dayClick callback.
    DateComponent.prototype.getHitEl = function (hit) {
        // what about being abstract!?
    };
    /* Converting eventRange -> eventFootprint
    ------------------------------------------------------------------------------------------------------------------*/
    DateComponent.prototype.eventRangesToEventFootprints = function (eventRanges) {
        var eventFootprints = [];
        var i;
        for (i = 0; i < eventRanges.length; i++) {
            eventFootprints.push.apply(// append
            eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
        }
        return eventFootprints;
    };
    DateComponent.prototype.eventRangeToEventFootprints = function (eventRange) {
        return [util_2.eventRangeToEventFootprint(eventRange)];
    };
    /* Converting componentFootprint/eventFootprint -> segs
    ------------------------------------------------------------------------------------------------------------------*/
    DateComponent.prototype.eventFootprintsToSegs = function (eventFootprints) {
        var segs = [];
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            segs.push.apply(segs, this.eventFootprintToSegs(eventFootprints[i]));
        }
        return segs;
    };
    // Given an event's span (unzoned start/end and other misc data), and the event itself,
    // slices into segments and attaches event-derived properties to them.
    // eventSpan - { start, end, isStart, isEnd, otherthings... }
    DateComponent.prototype.eventFootprintToSegs = function (eventFootprint) {
        var unzonedRange = eventFootprint.componentFootprint.unzonedRange;
        var segs;
        var i;
        var seg;
        segs = this.componentFootprintToSegs(eventFootprint.componentFootprint);
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            if (!unzonedRange.isStart) {
                seg.isStart = false;
            }
            if (!unzonedRange.isEnd) {
                seg.isEnd = false;
            }
            seg.footprint = eventFootprint;
            // TODO: rename to seg.eventFootprint
        }
        return segs;
    };
    DateComponent.prototype.componentFootprintToSegs = function (componentFootprint) {
        return [];
    };
    // Utils
    // ---------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.callChildren = function (methodName, args) {
        this.iterChildren(function (child) {
            child[methodName].apply(child, args);
        });
    };
    DateComponent.prototype.iterChildren = function (func) {
        var childrenByUid = this.childrenByUid;
        var uid;
        for (uid in childrenByUid) {
            func(childrenByUid[uid]);
        }
    };
    DateComponent.prototype._getCalendar = function () {
        var t = this;
        return t.calendar || t.view.calendar;
    };
    DateComponent.prototype._getView = function () {
        return this.view;
    };
    DateComponent.prototype._getDateProfile = function () {
        return this._getView().get('dateProfile');
    };
    // Generates HTML for an anchor to another view into the calendar.
    // Will either generate an <a> tag or a non-clickable <span> tag, depending on enabled settings.
    // `gotoOptions` can either be a moment input, or an object with the form:
    // { date, type, forceOff }
    // `type` is a view-type like "day" or "week". default value is "day".
    // `attrs` and `innerHtml` are use to generate the rest of the HTML tag.
    DateComponent.prototype.buildGotoAnchorHtml = function (gotoOptions, attrs, innerHtml) {
        var date;
        var type;
        var forceOff;
        var finalOptions;
        if ($.isPlainObject(gotoOptions)) {
            date = gotoOptions.date;
            type = gotoOptions.type;
            forceOff = gotoOptions.forceOff;
        }
        else {
            date = gotoOptions; // a single moment input
        }
        date = moment_ext_1.default(date); // if a string, parse it
        finalOptions = {
            date: date.format('YYYY-MM-DD'),
            type: type || 'day'
        };
        if (typeof attrs === 'string') {
            innerHtml = attrs;
            attrs = null;
        }
        attrs = attrs ? ' ' + util_1.attrsToStr(attrs) : ''; // will have a leading space
        innerHtml = innerHtml || '';
        if (!forceOff && this.opt('navLinks')) {
            return '<a' + attrs +
                ' data-goto="' + util_1.htmlEscape(JSON.stringify(finalOptions)) + '">' +
                innerHtml +
                '</a>';
        }
        else {
            return '<span' + attrs + '>' +
                innerHtml +
                '</span>';
        }
    };
    DateComponent.prototype.getAllDayHtml = function () {
        return this.opt('allDayHtml') || util_1.htmlEscape(this.opt('allDayText'));
    };
    // Computes HTML classNames for a single-day element
    DateComponent.prototype.getDayClasses = function (date, noThemeHighlight) {
        var view = this._getView();
        var classes = [];
        var today;
        if (!this.dateProfile.activeUnzonedRange.containsDate(date)) {
            classes.push('fc-disabled-day'); // TODO: jQuery UI theme?
        }
        else {
            classes.push('fc-' + util_1.dayIDs[date.day()]);
            if (view.isDateInOtherMonth(date, this.dateProfile)) {
                classes.push('fc-other-month');
            }
            today = view.calendar.getNow();
            if (date.isSame(today, 'day')) {
                classes.push('fc-today');
                if (noThemeHighlight !== true) {
                    classes.push(view.calendar.theme.getClass('today'));
                }
            }
            else if (date < today) {
                classes.push('fc-past');
            }
            else {
                classes.push('fc-future');
            }
        }
        return classes;
    };
    // Utility for formatting a range. Accepts a range object, formatting string, and optional separator.
    // Displays all-day ranges naturally, with an inclusive end. Takes the current isRTL into account.
    // The timezones of the dates within `range` will be respected.
    DateComponent.prototype.formatRange = function (range, isAllDay, formatStr, separator) {
        var end = range.end;
        if (isAllDay) {
            end = end.clone().subtract(1); // convert to inclusive. last ms of previous day
        }
        return date_formatting_1.formatRange(range.start, end, formatStr, separator, this.isRTL);
    };
    // Compute the number of the give units in the "current" range.
    // Will return a floating-point number. Won't round.
    DateComponent.prototype.currentRangeAs = function (unit) {
        return this._getDateProfile().currentUnzonedRange.as(unit);
    };
    // Returns the date range of the full days the given range visually appears to occupy.
    // Returns a plain object with start/end, NOT an UnzonedRange!
    DateComponent.prototype.computeDayRange = function (unzonedRange) {
        var calendar = this._getCalendar();
        var startDay = calendar.msToUtcMoment(unzonedRange.startMs, true); // the beginning of the day the range starts
        var end = calendar.msToUtcMoment(unzonedRange.endMs);
        var endTimeMS = +end.time(); // # of milliseconds into `endDay`
        var endDay = end.clone().stripTime(); // the beginning of the day the range exclusively ends
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= this.nextDayThreshold) {
            endDay.add(1, 'days');
        }
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay <= startDay) {
            endDay = startDay.clone().add(1, 'days');
        }
        return { start: startDay, end: endDay };
    };
    // Does the given range visually appear to occupy more than one day?
    DateComponent.prototype.isMultiDayRange = function (unzonedRange) {
        var dayRange = this.computeDayRange(unzonedRange);
        return dayRange.end.diff(dayRange.start, 'days') > 1;
    };
    DateComponent.guid = 0; // TODO: better system for this?
    return DateComponent;
}(Component_1.default));
exports.default = DateComponent;
// legacy
function convertEventsPayloadToLegacyArray(eventsPayload) {
    var eventDefId;
    var eventInstances;
    var legacyEvents = [];
    var i;
    for (eventDefId in eventsPayload) {
        eventInstances = eventsPayload[eventDefId].eventInstances;
        for (i = 0; i < eventInstances.length; i++) {
            legacyEvents.push(eventInstances[i].toLegacy());
        }
    }
    return legacyEvents;
}


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var options_1 = __webpack_require__(31);
var Iterator_1 = __webpack_require__(238);
var GlobalEmitter_1 = __webpack_require__(20);
var EmitterMixin_1 = __webpack_require__(11);
var ListenerMixin_1 = __webpack_require__(7);
var Toolbar_1 = __webpack_require__(239);
var OptionsManager_1 = __webpack_require__(240);
var ViewSpecManager_1 = __webpack_require__(241);
var Constraints_1 = __webpack_require__(207);
var locale_1 = __webpack_require__(30);
var moment_ext_1 = __webpack_require__(10);
var UnzonedRange_1 = __webpack_require__(5);
var ComponentFootprint_1 = __webpack_require__(12);
var EventDateProfile_1 = __webpack_require__(17);
var EventManager_1 = __webpack_require__(242);
var BusinessHourGenerator_1 = __webpack_require__(212);
var EventSourceParser_1 = __webpack_require__(37);
var EventDefParser_1 = __webpack_require__(49);
var SingleEventDef_1 = __webpack_require__(13);
var EventDefMutation_1 = __webpack_require__(36);
var EventSource_1 = __webpack_require__(6);
var ThemeRegistry_1 = __webpack_require__(51);
var Calendar = /** @class */ (function () {
    function Calendar(el, overrides) {
        this.loadingLevel = 0; // number of simultaneous loading tasks
        this.ignoreUpdateViewSize = 0;
        this.freezeContentHeightDepth = 0;
        // declare the current calendar instance relies on GlobalEmitter. needed for garbage collection.
        // unneeded() is called in destroy.
        GlobalEmitter_1.default.needed();
        this.el = el;
        this.viewsByType = {};
        this.optionsManager = new OptionsManager_1.default(this, overrides);
        this.viewSpecManager = new ViewSpecManager_1.default(this.optionsManager, this);
        this.initMomentInternals(); // needs to happen after options hash initialized
        this.initCurrentDate();
        this.initEventManager();
        this.constraints = new Constraints_1.default(this.eventManager, this);
        this.constructed();
    }
    Calendar.prototype.constructed = function () {
        // useful for monkeypatching. used?
    };
    Calendar.prototype.getView = function () {
        return this.view;
    };
    Calendar.prototype.publiclyTrigger = function (name, triggerInfo) {
        var optHandler = this.opt(name);
        var context;
        var args;
        if ($.isPlainObject(triggerInfo)) {
            context = triggerInfo.context;
            args = triggerInfo.args;
        }
        else if ($.isArray(triggerInfo)) {
            args = triggerInfo;
        }
        if (context == null) {
            context = this.el[0]; // fallback context
        }
        if (!args) {
            args = [];
        }
        this.triggerWith(name, context, args); // Emitter's method
        if (optHandler) {
            return optHandler.apply(context, args);
        }
    };
    Calendar.prototype.hasPublicHandlers = function (name) {
        return this.hasHandlers(name) ||
            this.opt(name); // handler specified in options
    };
    // Options Public API
    // -----------------------------------------------------------------------------------------------------------------
    // public getter/setter
    Calendar.prototype.option = function (name, value) {
        var newOptionHash;
        if (typeof name === 'string') {
            if (value === undefined) {
                return this.optionsManager.get(name);
            }
            else {
                newOptionHash = {};
                newOptionHash[name] = value;
                this.optionsManager.add(newOptionHash);
            }
        }
        else if (typeof name === 'object') {
            this.optionsManager.add(name);
        }
    };
    // private getter
    Calendar.prototype.opt = function (name) {
        return this.optionsManager.get(name);
    };
    // View
    // -----------------------------------------------------------------------------------------------------------------
    // Given a view name for a custom view or a standard view, creates a ready-to-go View object
    Calendar.prototype.instantiateView = function (viewType) {
        var spec = this.viewSpecManager.getViewSpec(viewType);
        if (!spec) {
            throw new Error("View type \"" + viewType + "\" is not valid");
        }
        return new spec['class'](this, spec);
    };
    // Returns a boolean about whether the view is okay to instantiate at some point
    Calendar.prototype.isValidViewType = function (viewType) {
        return Boolean(this.viewSpecManager.getViewSpec(viewType));
    };
    Calendar.prototype.changeView = function (viewName, dateOrRange) {
        if (dateOrRange) {
            if (dateOrRange.start && dateOrRange.end) {
                this.optionsManager.recordOverrides({
                    visibleRange: dateOrRange
                });
            }
            else {
                this.currentDate = this.moment(dateOrRange).stripZone(); // just like gotoDate
            }
        }
        this.renderView(viewName);
    };
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    Calendar.prototype.zoomTo = function (newDate, viewType) {
        var spec;
        viewType = viewType || 'day'; // day is default zoom
        spec = this.viewSpecManager.getViewSpec(viewType) ||
            this.viewSpecManager.getUnitViewSpec(viewType);
        this.currentDate = newDate.clone();
        this.renderView(spec ? spec.type : null);
    };
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initCurrentDate = function () {
        var defaultDateInput = this.opt('defaultDate');
        // compute the initial ambig-timezone date
        if (defaultDateInput != null) {
            this.currentDate = this.moment(defaultDateInput).stripZone();
        }
        else {
            this.currentDate = this.getNow(); // getNow already returns unzoned
        }
    };
    Calendar.prototype.prev = function () {
        var view = this.view;
        var prevInfo = view.dateProfileGenerator.buildPrev(view.get('dateProfile'));
        if (prevInfo.isValid) {
            this.currentDate = prevInfo.date;
            this.renderView();
        }
    };
    Calendar.prototype.next = function () {
        var view = this.view;
        var nextInfo = view.dateProfileGenerator.buildNext(view.get('dateProfile'));
        if (nextInfo.isValid) {
            this.currentDate = nextInfo.date;
            this.renderView();
        }
    };
    Calendar.prototype.prevYear = function () {
        this.currentDate.add(-1, 'years');
        this.renderView();
    };
    Calendar.prototype.nextYear = function () {
        this.currentDate.add(1, 'years');
        this.renderView();
    };
    Calendar.prototype.today = function () {
        this.currentDate = this.getNow(); // should deny like prev/next?
        this.renderView();
    };
    Calendar.prototype.gotoDate = function (zonedDateInput) {
        this.currentDate = this.moment(zonedDateInput).stripZone();
        this.renderView();
    };
    Calendar.prototype.incrementDate = function (delta) {
        this.currentDate.add(moment.duration(delta));
        this.renderView();
    };
    // for external API
    Calendar.prototype.getDate = function () {
        return this.applyTimezone(this.currentDate); // infuse the calendar's timezone
    };
    // Loading Triggering
    // -----------------------------------------------------------------------------------------------------------------
    // Should be called when any type of async data fetching begins
    Calendar.prototype.pushLoading = function () {
        if (!(this.loadingLevel++)) {
            this.publiclyTrigger('loading', [true, this.view]);
        }
    };
    // Should be called when any type of async data fetching completes
    Calendar.prototype.popLoading = function () {
        if (!(--this.loadingLevel)) {
            this.publiclyTrigger('loading', [false, this.view]);
        }
    };
    // High-level Rendering
    // -----------------------------------------------------------------------------------
    Calendar.prototype.render = function () {
        if (!this.contentEl) {
            this.initialRender();
        }
        else if (this.elementVisible()) {
            // mainly for the public API
            this.calcSize();
            this.updateViewSize();
        }
    };
    Calendar.prototype.initialRender = function () {
        var _this = this;
        var el = this.el;
        el.addClass('fc');
        // event delegation for nav links
        el.on('click.fc', 'a[data-goto]', function (ev) {
            var anchorEl = $(ev.currentTarget);
            var gotoOptions = anchorEl.data('goto'); // will automatically parse JSON
            var date = _this.moment(gotoOptions.date);
            var viewType = gotoOptions.type;
            // property like "navLinkDayClick". might be a string or a function
            var customAction = _this.view.opt('navLink' + util_1.capitaliseFirstLetter(viewType) + 'Click');
            if (typeof customAction === 'function') {
                customAction(date, ev);
            }
            else {
                if (typeof customAction === 'string') {
                    viewType = customAction;
                }
                _this.zoomTo(date, viewType);
            }
        });
        // called immediately, and upon option change
        this.optionsManager.watch('settingTheme', ['?theme', '?themeSystem'], function (opts) {
            var themeClass = ThemeRegistry_1.getThemeSystemClass(opts.themeSystem || opts.theme);
            var theme = new themeClass(_this.optionsManager);
            var widgetClass = theme.getClass('widget');
            _this.theme = theme;
            if (widgetClass) {
                el.addClass(widgetClass);
            }
        }, function () {
            var widgetClass = _this.theme.getClass('widget');
            _this.theme = null;
            if (widgetClass) {
                el.removeClass(widgetClass);
            }
        });
        this.optionsManager.watch('settingBusinessHourGenerator', ['?businessHours'], function (deps) {
            _this.businessHourGenerator = new BusinessHourGenerator_1.default(deps.businessHours, _this);
            if (_this.view) {
                _this.view.set('businessHourGenerator', _this.businessHourGenerator);
            }
        }, function () {
            _this.businessHourGenerator = null;
        });
        // called immediately, and upon option change.
        // HACK: locale often affects isRTL, so we explicitly listen to that too.
        this.optionsManager.watch('applyingDirClasses', ['?isRTL', '?locale'], function (opts) {
            el.toggleClass('fc-ltr', !opts.isRTL);
            el.toggleClass('fc-rtl', opts.isRTL);
        });
        this.contentEl = $("<div class='fc-view-container'/>").prependTo(el);
        this.initToolbars();
        this.renderHeader();
        this.renderFooter();
        this.renderView(this.opt('defaultView'));
        if (this.opt('handleWindowResize')) {
            $(window).resize(this.windowResizeProxy = util_1.debounce(// prevents rapid calls
            this.windowResize.bind(this), this.opt('windowResizeDelay')));
        }
    };
    Calendar.prototype.destroy = function () {
        if (this.view) {
            this.clearView();
        }
        this.toolbarsManager.proxyCall('removeElement');
        this.contentEl.remove();
        this.el.removeClass('fc fc-ltr fc-rtl');
        // removes theme-related root className
        this.optionsManager.unwatch('settingTheme');
        this.optionsManager.unwatch('settingBusinessHourGenerator');
        this.el.off('.fc'); // unbind nav link handlers
        if (this.windowResizeProxy) {
            $(window).unbind('resize', this.windowResizeProxy);
            this.windowResizeProxy = null;
        }
        GlobalEmitter_1.default.unneeded();
    };
    Calendar.prototype.elementVisible = function () {
        return this.el.is(':visible');
    };
    // Render Queue
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.bindViewHandlers = function (view) {
        var _this = this;
        view.watch('titleForCalendar', ['title'], function (deps) {
            if (view === _this.view) {
                _this.setToolbarsTitle(deps.title);
            }
        });
        view.watch('dateProfileForCalendar', ['dateProfile'], function (deps) {
            if (view === _this.view) {
                _this.currentDate = deps.dateProfile.date; // might have been constrained by view dates
                _this.updateToolbarButtons(deps.dateProfile);
            }
        });
    };
    Calendar.prototype.unbindViewHandlers = function (view) {
        view.unwatch('titleForCalendar');
        view.unwatch('dateProfileForCalendar');
    };
    // View Rendering
    // -----------------------------------------------------------------------------------
    // Renders a view because of a date change, view-type change, or for the first time.
    // If not given a viewType, keep the current view but render different dates.
    // Accepts an optional scroll state to restore to.
    Calendar.prototype.renderView = function (viewType) {
        var oldView = this.view;
        var newView;
        this.freezeContentHeight();
        if (oldView && viewType && oldView.type !== viewType) {
            this.clearView();
        }
        // if viewType changed, or the view was never created, create a fresh view
        if (!this.view && viewType) {
            newView = this.view =
                this.viewsByType[viewType] ||
                    (this.viewsByType[viewType] = this.instantiateView(viewType));
            this.bindViewHandlers(newView);
            newView.startBatchRender(); // so that setElement+setDate rendering are joined
            newView.setElement($("<div class='fc-view fc-" + viewType + "-view' />").appendTo(this.contentEl));
            this.toolbarsManager.proxyCall('activateButton', viewType);
        }
        if (this.view) {
            // prevent unnecessary change firing
            if (this.view.get('businessHourGenerator') !== this.businessHourGenerator) {
                this.view.set('businessHourGenerator', this.businessHourGenerator);
            }
            this.view.setDate(this.currentDate);
            if (newView) {
                newView.stopBatchRender();
            }
        }
        this.thawContentHeight();
    };
    // Unrenders the current view and reflects this change in the Header.
    // Unregsiters the `view`, but does not remove from viewByType hash.
    Calendar.prototype.clearView = function () {
        var currentView = this.view;
        this.toolbarsManager.proxyCall('deactivateButton', currentView.type);
        this.unbindViewHandlers(currentView);
        currentView.removeElement();
        currentView.unsetDate(); // so bindViewHandlers doesn't fire with old values next time
        this.view = null;
    };
    // Destroys the view, including the view object. Then, re-instantiates it and renders it.
    // Maintains the same scroll state.
    // TODO: maintain any other user-manipulated state.
    Calendar.prototype.reinitView = function () {
        var oldView = this.view;
        var scroll = oldView.queryScroll(); // wouldn't be so complicated if Calendar owned the scroll
        this.freezeContentHeight();
        this.clearView();
        this.calcSize();
        this.renderView(oldView.type); // needs the type to freshly render
        this.view.applyScroll(scroll);
        this.thawContentHeight();
    };
    // Resizing
    // -----------------------------------------------------------------------------------
    Calendar.prototype.getSuggestedViewHeight = function () {
        if (this.suggestedViewHeight == null) {
            this.calcSize();
        }
        return this.suggestedViewHeight;
    };
    Calendar.prototype.isHeightAuto = function () {
        return this.opt('contentHeight') === 'auto' || this.opt('height') === 'auto';
    };
    Calendar.prototype.updateViewSize = function (isResize) {
        if (isResize === void 0) { isResize = false; }
        var view = this.view;
        var scroll;
        if (!this.ignoreUpdateViewSize && view) {
            if (isResize) {
                this.calcSize();
                scroll = view.queryScroll();
            }
            this.ignoreUpdateViewSize++;
            view.updateSize(this.getSuggestedViewHeight(), this.isHeightAuto(), isResize);
            this.ignoreUpdateViewSize--;
            if (isResize) {
                view.applyScroll(scroll);
            }
            return true; // signal success
        }
    };
    Calendar.prototype.calcSize = function () {
        if (this.elementVisible()) {
            this._calcSize();
        }
    };
    Calendar.prototype._calcSize = function () {
        var contentHeightInput = this.opt('contentHeight');
        var heightInput = this.opt('height');
        if (typeof contentHeightInput === 'number') {
            this.suggestedViewHeight = contentHeightInput;
        }
        else if (typeof contentHeightInput === 'function') {
            this.suggestedViewHeight = contentHeightInput();
        }
        else if (typeof heightInput === 'number') {
            this.suggestedViewHeight = heightInput - this.queryToolbarsHeight();
        }
        else if (typeof heightInput === 'function') {
            this.suggestedViewHeight = heightInput() - this.queryToolbarsHeight();
        }
        else if (heightInput === 'parent') {
            this.suggestedViewHeight = this.el.parent().height() - this.queryToolbarsHeight();
        }
        else {
            this.suggestedViewHeight = Math.round(this.contentEl.width() /
                Math.max(this.opt('aspectRatio'), .5));
        }
    };
    Calendar.prototype.windowResize = function (ev) {
        if (
        // the purpose: so we don't process jqui "resize" events that have bubbled up
        // cast to any because .target, which is Element, can't be compared to window for some reason.
        ev.target === window &&
            this.view &&
            this.view.isDatesRendered) {
            if (this.updateViewSize(true)) {
                this.publiclyTrigger('windowResize', [this.view]);
            }
        }
    };
    /* Height "Freezing"
    -----------------------------------------------------------------------------*/
    Calendar.prototype.freezeContentHeight = function () {
        if (!(this.freezeContentHeightDepth++)) {
            this.forceFreezeContentHeight();
        }
    };
    Calendar.prototype.forceFreezeContentHeight = function () {
        this.contentEl.css({
            width: '100%',
            height: this.contentEl.height(),
            overflow: 'hidden'
        });
    };
    Calendar.prototype.thawContentHeight = function () {
        this.freezeContentHeightDepth--;
        // always bring back to natural height
        this.contentEl.css({
            width: '',
            height: '',
            overflow: ''
        });
        // but if there are future thaws, re-freeze
        if (this.freezeContentHeightDepth) {
            this.forceFreezeContentHeight();
        }
    };
    // Toolbar
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initToolbars = function () {
        this.header = new Toolbar_1.default(this, this.computeHeaderOptions());
        this.footer = new Toolbar_1.default(this, this.computeFooterOptions());
        this.toolbarsManager = new Iterator_1.default([this.header, this.footer]);
    };
    Calendar.prototype.computeHeaderOptions = function () {
        return {
            extraClasses: 'fc-header-toolbar',
            layout: this.opt('header')
        };
    };
    Calendar.prototype.computeFooterOptions = function () {
        return {
            extraClasses: 'fc-footer-toolbar',
            layout: this.opt('footer')
        };
    };
    // can be called repeatedly and Header will rerender
    Calendar.prototype.renderHeader = function () {
        var header = this.header;
        header.setToolbarOptions(this.computeHeaderOptions());
        header.render();
        if (header.el) {
            this.el.prepend(header.el);
        }
    };
    // can be called repeatedly and Footer will rerender
    Calendar.prototype.renderFooter = function () {
        var footer = this.footer;
        footer.setToolbarOptions(this.computeFooterOptions());
        footer.render();
        if (footer.el) {
            this.el.append(footer.el);
        }
    };
    Calendar.prototype.setToolbarsTitle = function (title) {
        this.toolbarsManager.proxyCall('updateTitle', title);
    };
    Calendar.prototype.updateToolbarButtons = function (dateProfile) {
        var now = this.getNow();
        var view = this.view;
        var todayInfo = view.dateProfileGenerator.build(now);
        var prevInfo = view.dateProfileGenerator.buildPrev(view.get('dateProfile'));
        var nextInfo = view.dateProfileGenerator.buildNext(view.get('dateProfile'));
        this.toolbarsManager.proxyCall((todayInfo.isValid && !dateProfile.currentUnzonedRange.containsDate(now)) ?
            'enableButton' :
            'disableButton', 'today');
        this.toolbarsManager.proxyCall(prevInfo.isValid ?
            'enableButton' :
            'disableButton', 'prev');
        this.toolbarsManager.proxyCall(nextInfo.isValid ?
            'enableButton' :
            'disableButton', 'next');
    };
    Calendar.prototype.queryToolbarsHeight = function () {
        return this.toolbarsManager.items.reduce(function (accumulator, toolbar) {
            var toolbarHeight = toolbar.el ? toolbar.el.outerHeight(true) : 0; // includes margin
            return accumulator + toolbarHeight;
        }, 0);
    };
    // Selection
    // -----------------------------------------------------------------------------------------------------------------
    // this public method receives start/end dates in any format, with any timezone
    Calendar.prototype.select = function (zonedStartInput, zonedEndInput) {
        this.view.select(this.buildSelectFootprint.apply(this, arguments));
    };
    Calendar.prototype.unselect = function () {
        if (this.view) {
            this.view.unselect();
        }
    };
    // Given arguments to the select method in the API, returns a span (unzoned start/end and other info)
    Calendar.prototype.buildSelectFootprint = function (zonedStartInput, zonedEndInput) {
        var start = this.moment(zonedStartInput).stripZone();
        var end;
        if (zonedEndInput) {
            end = this.moment(zonedEndInput).stripZone();
        }
        else if (start.hasTime()) {
            end = start.clone().add(this.defaultTimedEventDuration);
        }
        else {
            end = start.clone().add(this.defaultAllDayEventDuration);
        }
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), !start.hasTime());
    };
    // Date Utils
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initMomentInternals = function () {
        var _this = this;
        this.defaultAllDayEventDuration = moment.duration(this.opt('defaultAllDayEventDuration'));
        this.defaultTimedEventDuration = moment.duration(this.opt('defaultTimedEventDuration'));
        // Called immediately, and when any of the options change.
        // Happens before any internal objects rebuild or rerender, because this is very core.
        this.optionsManager.watch('buildingMomentLocale', [
            '?locale', '?monthNames', '?monthNamesShort', '?dayNames', '?dayNamesShort',
            '?firstDay', '?weekNumberCalculation'
        ], function (opts) {
            var weekNumberCalculation = opts.weekNumberCalculation;
            var firstDay = opts.firstDay;
            var _week;
            // normalize
            if (weekNumberCalculation === 'iso') {
                weekNumberCalculation = 'ISO'; // normalize
            }
            var localeData = Object.create(// make a cheap copy
            locale_1.getMomentLocaleData(opts.locale) // will fall back to en
            );
            if (opts.monthNames) {
                localeData._months = opts.monthNames;
            }
            if (opts.monthNamesShort) {
                localeData._monthsShort = opts.monthNamesShort;
            }
            if (opts.dayNames) {
                localeData._weekdays = opts.dayNames;
            }
            if (opts.dayNamesShort) {
                localeData._weekdaysShort = opts.dayNamesShort;
            }
            if (firstDay == null && weekNumberCalculation === 'ISO') {
                firstDay = 1;
            }
            if (firstDay != null) {
                _week = Object.create(localeData._week); // _week: { dow: # }
                _week.dow = firstDay;
                localeData._week = _week;
            }
            if (weekNumberCalculation === 'ISO' ||
                weekNumberCalculation === 'local' ||
                typeof weekNumberCalculation === 'function') {
                localeData._fullCalendar_weekCalc = weekNumberCalculation; // moment-ext will know what to do with it
            }
            _this.localeData = localeData;
            // If the internal current date object already exists, move to new locale.
            // We do NOT need to do this technique for event dates, because this happens when converting to "segments".
            if (_this.currentDate) {
                _this.localizeMoment(_this.currentDate); // sets to localeData
            }
        });
    };
    // Builds a moment using the settings of the current calendar: timezone and locale.
    // Accepts anything the vanilla moment() constructor accepts.
    Calendar.prototype.moment = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var mom;
        if (this.opt('timezone') === 'local') {
            mom = moment_ext_1.default.apply(null, args);
            // Force the moment to be local, because momentExt doesn't guarantee it.
            if (mom.hasTime()) {
                mom.local();
            }
        }
        else if (this.opt('timezone') === 'UTC') {
            mom = moment_ext_1.default.utc.apply(null, args); // process as UTC
        }
        else {
            mom = moment_ext_1.default.parseZone.apply(null, args); // let the input decide the zone
        }
        this.localizeMoment(mom); // TODO
        return mom;
    };
    Calendar.prototype.msToMoment = function (ms, forceAllDay) {
        var mom = moment_ext_1.default.utc(ms); // TODO: optimize by using Date.UTC
        if (forceAllDay) {
            mom.stripTime();
        }
        else {
            mom = this.applyTimezone(mom); // may or may not apply locale
        }
        this.localizeMoment(mom);
        return mom;
    };
    Calendar.prototype.msToUtcMoment = function (ms, forceAllDay) {
        var mom = moment_ext_1.default.utc(ms); // TODO: optimize by using Date.UTC
        if (forceAllDay) {
            mom.stripTime();
        }
        this.localizeMoment(mom);
        return mom;
    };
    // Updates the given moment's locale settings to the current calendar locale settings.
    Calendar.prototype.localizeMoment = function (mom) {
        mom._locale = this.localeData;
    };
    // Returns a boolean about whether or not the calendar knows how to calculate
    // the timezone offset of arbitrary dates in the current timezone.
    Calendar.prototype.getIsAmbigTimezone = function () {
        return this.opt('timezone') !== 'local' && this.opt('timezone') !== 'UTC';
    };
    // Returns a copy of the given date in the current timezone. Has no effect on dates without times.
    Calendar.prototype.applyTimezone = function (date) {
        if (!date.hasTime()) {
            return date.clone();
        }
        var zonedDate = this.moment(date.toArray());
        var timeAdjust = date.time().asMilliseconds() - zonedDate.time().asMilliseconds();
        var adjustedZonedDate;
        // Safari sometimes has problems with this coersion when near DST. Adjust if necessary. (bug #2396)
        if (timeAdjust) {
            adjustedZonedDate = zonedDate.clone().add(timeAdjust); // add milliseconds
            if (date.time().asMilliseconds() - adjustedZonedDate.time().asMilliseconds() === 0) {
                zonedDate = adjustedZonedDate;
            }
        }
        return zonedDate;
    };
    /*
    Assumes the footprint is non-open-ended.
    */
    Calendar.prototype.footprintToDateProfile = function (componentFootprint, ignoreEnd) {
        if (ignoreEnd === void 0) { ignoreEnd = false; }
        var start = moment_ext_1.default.utc(componentFootprint.unzonedRange.startMs);
        var end;
        if (!ignoreEnd) {
            end = moment_ext_1.default.utc(componentFootprint.unzonedRange.endMs);
        }
        if (componentFootprint.isAllDay) {
            start.stripTime();
            if (end) {
                end.stripTime();
            }
        }
        else {
            start = this.applyTimezone(start);
            if (end) {
                end = this.applyTimezone(end);
            }
        }
        return new EventDateProfile_1.default(start, end, this);
    };
    // Returns a moment for the current date, as defined by the client's computer or from the `now` option.
    // Will return an moment with an ambiguous timezone.
    Calendar.prototype.getNow = function () {
        var now = this.opt('now');
        if (typeof now === 'function') {
            now = now();
        }
        return this.moment(now).stripZone();
    };
    // Produces a human-readable string for the given duration.
    // Side-effect: changes the locale of the given duration.
    Calendar.prototype.humanizeDuration = function (duration) {
        return duration.locale(this.opt('locale')).humanize();
    };
    // will return `null` if invalid range
    Calendar.prototype.parseUnzonedRange = function (rangeInput) {
        var start = null;
        var end = null;
        if (rangeInput.start) {
            start = this.moment(rangeInput.start).stripZone();
        }
        if (rangeInput.end) {
            end = this.moment(rangeInput.end).stripZone();
        }
        if (!start && !end) {
            return null;
        }
        if (start && end && end.isBefore(start)) {
            return null;
        }
        return new UnzonedRange_1.default(start, end);
    };
    // Event-Date Utilities
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initEventManager = function () {
        var _this = this;
        var eventManager = new EventManager_1.default(this);
        var rawSources = this.opt('eventSources') || [];
        var singleRawSource = this.opt('events');
        this.eventManager = eventManager;
        if (singleRawSource) {
            rawSources.unshift(singleRawSource);
        }
        eventManager.on('release', function (eventsPayload) {
            _this.trigger('eventsReset', eventsPayload);
        });
        eventManager.freeze();
        rawSources.forEach(function (rawSource) {
            var source = EventSourceParser_1.default.parse(rawSource, _this);
            if (source) {
                eventManager.addSource(source);
            }
        });
        eventManager.thaw();
    };
    Calendar.prototype.requestEvents = function (start, end) {
        return this.eventManager.requestEvents(start, end, this.opt('timezone'), !this.opt('lazyFetching'));
    };
    // Get an event's normalized end date. If not present, calculate it from the defaults.
    Calendar.prototype.getEventEnd = function (event) {
        if (event.end) {
            return event.end.clone();
        }
        else {
            return this.getDefaultEventEnd(event.allDay, event.start);
        }
    };
    // Given an event's allDay status and start date, return what its fallback end date should be.
    // TODO: rename to computeDefaultEventEnd
    Calendar.prototype.getDefaultEventEnd = function (allDay, zonedStart) {
        var end = zonedStart.clone();
        if (allDay) {
            end.stripTime().add(this.defaultAllDayEventDuration);
        }
        else {
            end.add(this.defaultTimedEventDuration);
        }
        if (this.getIsAmbigTimezone()) {
            end.stripZone(); // we don't know what the tzo should be
        }
        return end;
    };
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.rerenderEvents = function () {
        this.view.flash('displayingEvents');
    };
    Calendar.prototype.refetchEvents = function () {
        this.eventManager.refetchAllSources();
    };
    Calendar.prototype.renderEvents = function (eventInputs, isSticky) {
        this.eventManager.freeze();
        for (var i = 0; i < eventInputs.length; i++) {
            this.renderEvent(eventInputs[i], isSticky);
        }
        this.eventManager.thaw();
    };
    Calendar.prototype.renderEvent = function (eventInput, isSticky) {
        if (isSticky === void 0) { isSticky = false; }
        var eventManager = this.eventManager;
        var eventDef = EventDefParser_1.default.parse(eventInput, eventInput.source || eventManager.stickySource);
        if (eventDef) {
            eventManager.addEventDef(eventDef, isSticky);
        }
    };
    // legacyQuery operates on legacy event instance objects
    Calendar.prototype.removeEvents = function (legacyQuery) {
        var eventManager = this.eventManager;
        var legacyInstances = [];
        var idMap = {};
        var eventDef;
        var i;
        if (legacyQuery == null) {
            eventManager.removeAllEventDefs(); // persist=true
        }
        else {
            eventManager.getEventInstances().forEach(function (eventInstance) {
                legacyInstances.push(eventInstance.toLegacy());
            });
            legacyInstances = filterLegacyEventInstances(legacyInstances, legacyQuery);
            // compute unique IDs
            for (i = 0; i < legacyInstances.length; i++) {
                eventDef = this.eventManager.getEventDefByUid(legacyInstances[i]._id);
                idMap[eventDef.id] = true;
            }
            eventManager.freeze();
            for (i in idMap) {
                eventManager.removeEventDefsById(i); // persist=true
            }
            eventManager.thaw();
        }
    };
    // legacyQuery operates on legacy event instance objects
    Calendar.prototype.clientEvents = function (legacyQuery) {
        var legacyEventInstances = [];
        this.eventManager.getEventInstances().forEach(function (eventInstance) {
            legacyEventInstances.push(eventInstance.toLegacy());
        });
        return filterLegacyEventInstances(legacyEventInstances, legacyQuery);
    };
    Calendar.prototype.updateEvents = function (eventPropsArray) {
        this.eventManager.freeze();
        for (var i = 0; i < eventPropsArray.length; i++) {
            this.updateEvent(eventPropsArray[i]);
        }
        this.eventManager.thaw();
    };
    Calendar.prototype.updateEvent = function (eventProps) {
        var eventDef = this.eventManager.getEventDefByUid(eventProps._id);
        var eventInstance;
        var eventDefMutation;
        if (eventDef instanceof SingleEventDef_1.default) {
            eventInstance = eventDef.buildInstance();
            eventDefMutation = EventDefMutation_1.default.createFromRawProps(eventInstance, eventProps, // raw props
            null // largeUnit -- who uses it?
            );
            this.eventManager.mutateEventsWithId(eventDef.id, eventDefMutation); // will release
        }
    };
    // Public Event Sources API
    // ------------------------------------------------------------------------------------
    Calendar.prototype.getEventSources = function () {
        return this.eventManager.otherSources.slice(); // clone
    };
    Calendar.prototype.getEventSourceById = function (id) {
        return this.eventManager.getSourceById(EventSource_1.default.normalizeId(id));
    };
    Calendar.prototype.addEventSource = function (sourceInput) {
        var source = EventSourceParser_1.default.parse(sourceInput, this);
        if (source) {
            this.eventManager.addSource(source);
        }
    };
    Calendar.prototype.removeEventSources = function (sourceMultiQuery) {
        var eventManager = this.eventManager;
        var sources;
        var i;
        if (sourceMultiQuery == null) {
            this.eventManager.removeAllSources();
        }
        else {
            sources = eventManager.multiQuerySources(sourceMultiQuery);
            eventManager.freeze();
            for (i = 0; i < sources.length; i++) {
                eventManager.removeSource(sources[i]);
            }
            eventManager.thaw();
        }
    };
    Calendar.prototype.removeEventSource = function (sourceQuery) {
        var eventManager = this.eventManager;
        var sources = eventManager.querySources(sourceQuery);
        var i;
        eventManager.freeze();
        for (i = 0; i < sources.length; i++) {
            eventManager.removeSource(sources[i]);
        }
        eventManager.thaw();
    };
    Calendar.prototype.refetchEventSources = function (sourceMultiQuery) {
        var eventManager = this.eventManager;
        var sources = eventManager.multiQuerySources(sourceMultiQuery);
        var i;
        eventManager.freeze();
        for (i = 0; i < sources.length; i++) {
            eventManager.refetchSource(sources[i]);
        }
        eventManager.thaw();
    };
    // not for internal use. use options module directly instead.
    Calendar.defaults = options_1.globalDefaults;
    Calendar.englishDefaults = options_1.englishDefaults;
    Calendar.rtlDefaults = options_1.rtlDefaults;
    return Calendar;
}());
exports.default = Calendar;
EmitterMixin_1.default.mixInto(Calendar);
ListenerMixin_1.default.mixInto(Calendar);
function filterLegacyEventInstances(legacyEventInstances, legacyQuery) {
    if (legacyQuery == null) {
        return legacyEventInstances;
    }
    else if ($.isFunction(legacyQuery)) {
        return legacyEventInstances.filter(legacyQuery);
    }
    else {
        legacyQuery += ''; // normalize to string
        return legacyEventInstances.filter(function (legacyEventInstance) {
            // soft comparison because id not be normalized to string
            // tslint:disable-next-line
            return legacyEventInstance.id == legacyQuery ||
                legacyEventInstance._id === legacyQuery; // can specify internal id, but must exactly match
        });
    }
}


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var UnzonedRange_1 = __webpack_require__(5);
var DateProfileGenerator = /** @class */ (function () {
    function DateProfileGenerator(_view) {
        this._view = _view;
    }
    DateProfileGenerator.prototype.opt = function (name) {
        return this._view.opt(name);
    };
    DateProfileGenerator.prototype.trimHiddenDays = function (unzonedRange) {
        return this._view.trimHiddenDays(unzonedRange);
    };
    DateProfileGenerator.prototype.msToUtcMoment = function (ms, forceAllDay) {
        return this._view.calendar.msToUtcMoment(ms, forceAllDay);
    };
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/
    // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    DateProfileGenerator.prototype.buildPrev = function (currentDateProfile) {
        var prevDate = currentDateProfile.date.clone()
            .startOf(currentDateProfile.currentRangeUnit)
            .subtract(currentDateProfile.dateIncrement);
        return this.build(prevDate, -1);
    };
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    DateProfileGenerator.prototype.buildNext = function (currentDateProfile) {
        var nextDate = currentDateProfile.date.clone()
            .startOf(currentDateProfile.currentRangeUnit)
            .add(currentDateProfile.dateIncrement);
        return this.build(nextDate, 1);
    };
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    DateProfileGenerator.prototype.build = function (date, direction, forceToValid) {
        if (forceToValid === void 0) { forceToValid = false; }
        var isDateAllDay = !date.hasTime();
        var validUnzonedRange;
        var minTime = null;
        var maxTime = null;
        var currentInfo;
        var isRangeAllDay;
        var renderUnzonedRange;
        var activeUnzonedRange;
        var isValid;
        validUnzonedRange = this.buildValidRange();
        validUnzonedRange = this.trimHiddenDays(validUnzonedRange);
        if (forceToValid) {
            date = this.msToUtcMoment(validUnzonedRange.constrainDate(date), // returns MS
            isDateAllDay);
        }
        currentInfo = this.buildCurrentRangeInfo(date, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderUnzonedRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.unzonedRange), currentInfo.unit, isRangeAllDay);
        renderUnzonedRange = this.trimHiddenDays(renderUnzonedRange);
        activeUnzonedRange = renderUnzonedRange.clone();
        if (!this.opt('showNonCurrentDates')) {
            activeUnzonedRange = activeUnzonedRange.intersect(currentInfo.unzonedRange);
        }
        minTime = moment.duration(this.opt('minTime'));
        maxTime = moment.duration(this.opt('maxTime'));
        activeUnzonedRange = this.adjustActiveRange(activeUnzonedRange, minTime, maxTime);
        activeUnzonedRange = activeUnzonedRange.intersect(validUnzonedRange); // might return null
        if (activeUnzonedRange) {
            date = this.msToUtcMoment(activeUnzonedRange.constrainDate(date), // returns MS
            isDateAllDay);
        }
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = currentInfo.unzonedRange.intersectsWith(validUnzonedRange);
        return {
            // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validUnzonedRange: validUnzonedRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentUnzonedRange: currentInfo.unzonedRange,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeUnzonedRange: activeUnzonedRange,
            // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderUnzonedRange: renderUnzonedRange,
            // Duration object that denotes the first visible time of any given day
            minTime: minTime,
            // Duration object that denotes the exclusive visible end time of any given day
            maxTime: maxTime,
            isValid: isValid,
            date: date,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration)
            // pass a fallback (might be null) ^
        };
    };
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildValidRange = function () {
        return this._view.getUnzonedRangeOption('validRange', this._view.calendar.getNow()) ||
            new UnzonedRange_1.default(); // completely open-ended
    };
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildCurrentRangeInfo = function (date, direction) {
        var viewSpec = this._view.viewSpec;
        var duration = null;
        var unit = null;
        var unzonedRange = null;
        var dayCount;
        if (viewSpec.duration) {
            duration = viewSpec.duration;
            unit = viewSpec.durationUnit;
            unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        else if ((dayCount = this.opt('dayCount'))) {
            unit = 'day';
            unzonedRange = this.buildRangeFromDayCount(date, direction, dayCount);
        }
        else if ((unzonedRange = this.buildCustomVisibleRange(date))) {
            unit = util_1.computeGreatestUnit(unzonedRange.getStart(), unzonedRange.getEnd());
        }
        else {
            duration = this.getFallbackDuration();
            unit = util_1.computeGreatestUnit(duration);
            unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return { duration: duration, unit: unit, unzonedRange: unzonedRange };
    };
    DateProfileGenerator.prototype.getFallbackDuration = function () {
        return moment.duration({ days: 1 });
    };
    // Returns a new activeUnzonedRange to have time values (un-ambiguate)
    // minTime or maxTime causes the range to expand.
    DateProfileGenerator.prototype.adjustActiveRange = function (unzonedRange, minTime, maxTime) {
        var start = unzonedRange.getStart();
        var end = unzonedRange.getEnd();
        if (this._view.usesMinMaxTime) {
            if (minTime < 0) {
                start.time(0).add(minTime);
            }
            if (maxTime > 24 * 60 * 60 * 1000) {
                end.time(maxTime - (24 * 60 * 60 * 1000));
            }
        }
        return new UnzonedRange_1.default(start, end);
    };
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed computeGreatestUnit value of duration.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildRangeFromDuration = function (date, direction, duration, unit) {
        var alignment = this.opt('dateAlignment');
        var dateIncrementInput;
        var dateIncrementDuration;
        var start;
        var end;
        var res;
        // compute what the alignment should be
        if (!alignment) {
            dateIncrementInput = this.opt('dateIncrement');
            if (dateIncrementInput) {
                dateIncrementDuration = moment.duration(dateIncrementInput);
                // use the smaller of the two units
                if (dateIncrementDuration < duration) {
                    alignment = util_1.computeDurationGreatestUnit(dateIncrementDuration, dateIncrementInput);
                }
                else {
                    alignment = unit;
                }
            }
            else {
                alignment = unit;
            }
        }
        // if the view displays a single day or smaller
        if (duration.as('days') <= 1) {
            if (this._view.isHiddenDay(start)) {
                start = this._view.skipHiddenDays(start, direction);
                start.startOf('day');
            }
        }
        function computeRes() {
            start = date.clone().startOf(alignment);
            end = start.clone().add(duration);
            res = new UnzonedRange_1.default(start, end);
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this._view.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    };
    // Builds the "current" range when a dayCount is specified.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildRangeFromDayCount = function (date, direction, dayCount) {
        var customAlignment = this.opt('dateAlignment');
        var runningCount = 0;
        var start = date.clone();
        var end;
        if (customAlignment) {
            start.startOf(customAlignment);
        }
        start.startOf('day');
        start = this._view.skipHiddenDays(start, direction);
        end = start.clone();
        do {
            end.add(1, 'day');
            if (!this._view.isHiddenDay(end)) {
                runningCount++;
            }
        } while (runningCount < dayCount);
        return new UnzonedRange_1.default(start, end);
    };
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentUnzonedRange and activeUnzonedRange at the same time.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildCustomVisibleRange = function (date) {
        var visibleUnzonedRange = this._view.getUnzonedRangeOption('visibleRange', this._view.calendar.applyTimezone(date) // correct zone. also generates new obj that avoids mutations
        );
        if (visibleUnzonedRange && (visibleUnzonedRange.startMs == null || visibleUnzonedRange.endMs == null)) {
            return null;
        }
        return visibleUnzonedRange;
    };
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
        return currentUnzonedRange.clone();
    };
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    DateProfileGenerator.prototype.buildDateIncrement = function (fallback) {
        var dateIncrementInput = this.opt('dateIncrement');
        var customAlignment;
        if (dateIncrementInput) {
            return moment.duration(dateIncrementInput);
        }
        else if ((customAlignment = this.opt('dateAlignment'))) {
            return moment.duration(1, customAlignment);
        }
        else if (fallback) {
            return fallback;
        }
        else {
            return moment.duration({ days: 1 });
        }
    };
    return DateProfileGenerator;
}());
exports.default = DateProfileGenerator;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var exportHooks = __webpack_require__(16);
var util_1 = __webpack_require__(4);
var moment_ext_1 = __webpack_require__(10);
var ListenerMixin_1 = __webpack_require__(7);
var HitDragListener_1 = __webpack_require__(22);
var SingleEventDef_1 = __webpack_require__(13);
var EventInstanceGroup_1 = __webpack_require__(18);
var EventSource_1 = __webpack_require__(6);
var Interaction_1 = __webpack_require__(15);
var ExternalDropping = /** @class */ (function (_super) {
    tslib_1.__extends(ExternalDropping, _super);
    function ExternalDropping() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDragging = false; // jqui-dragging an external element? boolean
        return _this;
    }
    /*
    component impements:
      - eventRangesToEventFootprints
      - isEventInstanceGroupAllowed
      - isExternalInstanceGroupAllowed
      - renderDrag
      - unrenderDrag
    */
    ExternalDropping.prototype.end = function () {
        if (this.dragListener) {
            this.dragListener.endInteraction();
        }
    };
    ExternalDropping.prototype.bindToDocument = function () {
        this.listenTo($(document), {
            dragstart: this.handleDragStart,
            sortstart: this.handleDragStart // jqui
        });
    };
    ExternalDropping.prototype.unbindFromDocument = function () {
        this.stopListeningTo($(document));
    };
    // Called when a jQuery UI drag is initiated anywhere in the DOM
    ExternalDropping.prototype.handleDragStart = function (ev, ui) {
        var el;
        var accept;
        if (this.opt('droppable')) {
            el = $((ui ? ui.item : null) || ev.target);
            // Test that the dragged element passes the dropAccept selector or filter function.
            // FYI, the default is "*" (matches all)
            accept = this.opt('dropAccept');
            if ($.isFunction(accept) ? accept.call(el[0], el) : el.is(accept)) {
                if (!this.isDragging) {
                    this.listenToExternalDrag(el, ev, ui);
                }
            }
        }
    };
    // Called when a jQuery UI drag starts and it needs to be monitored for dropping
    ExternalDropping.prototype.listenToExternalDrag = function (el, ev, ui) {
        var _this = this;
        var component = this.component;
        var view = this.view;
        var meta = getDraggedElMeta(el); // extra data about event drop, including possible event to create
        var singleEventDef; // a null value signals an unsuccessful drag
        // listener that tracks mouse movement over date-associated pixel regions
        var dragListener = this.dragListener = new HitDragListener_1.default(component, {
            interactionStart: function () {
                _this.isDragging = true;
            },
            hitOver: function (hit) {
                var isAllowed = true;
                var hitFootprint = hit.component.getSafeHitFootprint(hit); // hit might not belong to this grid
                var mutatedEventInstanceGroup;
                if (hitFootprint) {
                    singleEventDef = _this.computeExternalDrop(hitFootprint, meta);
                    if (singleEventDef) {
                        mutatedEventInstanceGroup = new EventInstanceGroup_1.default(singleEventDef.buildInstances());
                        isAllowed = meta.eventProps ? // isEvent?
                            component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup) :
                            component.isExternalInstanceGroupAllowed(mutatedEventInstanceGroup);
                    }
                    else {
                        isAllowed = false;
                    }
                }
                else {
                    isAllowed = false;
                }
                if (!isAllowed) {
                    singleEventDef = null;
                    util_1.disableCursor();
                }
                if (singleEventDef) {
                    component.renderDrag(// called without a seg parameter
                    component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, view.calendar)));
                }
            },
            hitOut: function () {
                singleEventDef = null; // signal unsuccessful
            },
            hitDone: function () {
                util_1.enableCursor();
                component.unrenderDrag();
            },
            interactionEnd: function (ev) {
                if (singleEventDef) {
                    view.reportExternalDrop(singleEventDef, Boolean(meta.eventProps), // isEvent
                    Boolean(meta.stick), // isSticky
                    el, ev, ui);
                }
                _this.isDragging = false;
                _this.dragListener = null;
            }
        });
        dragListener.startDrag(ev); // start listening immediately
    };
    // Given a hit to be dropped upon, and misc data associated with the jqui drag (guaranteed to be a plain object),
    // returns the zoned start/end dates for the event that would result from the hypothetical drop. end might be null.
    // Returning a null value signals an invalid drop hit.
    // DOES NOT consider overlap/constraint.
    // Assumes both footprints are non-open-ended.
    ExternalDropping.prototype.computeExternalDrop = function (componentFootprint, meta) {
        var calendar = this.view.calendar;
        var start = moment_ext_1.default.utc(componentFootprint.unzonedRange.startMs).stripZone();
        var end;
        var eventDef;
        if (componentFootprint.isAllDay) {
            // if dropped on an all-day span, and element's metadata specified a time, set it
            if (meta.startTime) {
                start.time(meta.startTime);
            }
            else {
                start.stripTime();
            }
        }
        if (meta.duration) {
            end = start.clone().add(meta.duration);
        }
        start = calendar.applyTimezone(start);
        if (end) {
            end = calendar.applyTimezone(end);
        }
        eventDef = SingleEventDef_1.default.parse($.extend({}, meta.eventProps, {
            start: start,
            end: end
        }), new EventSource_1.default(calendar));
        return eventDef;
    };
    return ExternalDropping;
}(Interaction_1.default));
exports.default = ExternalDropping;
ListenerMixin_1.default.mixInto(ExternalDropping);
/* External-Dragging-Element Data
----------------------------------------------------------------------------------------------------------------------*/
// Require all HTML5 data-* attributes used by FullCalendar to have this prefix.
// A value of '' will query attributes like data-event. A value of 'fc' will query attributes like data-fc-event.
exportHooks.dataAttrPrefix = '';
// Given a jQuery element that might represent a dragged FullCalendar event, returns an intermediate data structure
// to be used for Event Object creation.
// A defined `.eventProps`, even when empty, indicates that an event should be created.
function getDraggedElMeta(el) {
    var prefix = exportHooks.dataAttrPrefix;
    var eventProps; // properties for creating the event, not related to date/time
    var startTime; // a Duration
    var duration;
    var stick;
    if (prefix) {
        prefix += '-';
    }
    eventProps = el.data(prefix + 'event') || null;
    if (eventProps) {
        if (typeof eventProps === 'object') {
            eventProps = $.extend({}, eventProps); // make a copy
        }
        else {
            eventProps = {};
        }
        // pluck special-cased date/time properties
        startTime = eventProps.start;
        if (startTime == null) {
            startTime = eventProps.time;
        } // accept 'time' as well
        duration = eventProps.duration;
        stick = eventProps.stick;
        delete eventProps.start;
        delete eventProps.time;
        delete eventProps.duration;
        delete eventProps.stick;
    }
    // fallback to standalone attribute values for each of the date/time properties
    if (startTime == null) {
        startTime = el.data(prefix + 'start');
    }
    if (startTime == null) {
        startTime = el.data(prefix + 'time');
    } // accept 'time' as well
    if (duration == null) {
        duration = el.data(prefix + 'duration');
    }
    if (stick == null) {
        stick = el.data(prefix + 'stick');
    }
    // massage into correct data types
    startTime = startTime != null ? moment.duration(startTime) : null;
    duration = duration != null ? moment.duration(duration) : null;
    stick = Boolean(stick);
    return { eventProps: eventProps, startTime: startTime, duration: duration, stick: stick };
}


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var EventDefMutation_1 = __webpack_require__(36);
var EventDefDateMutation_1 = __webpack_require__(50);
var HitDragListener_1 = __webpack_require__(22);
var Interaction_1 = __webpack_require__(15);
var EventResizing = /** @class */ (function (_super) {
    tslib_1.__extends(EventResizing, _super);
    /*
    component impements:
      - bindSegHandlerToEl
      - publiclyTrigger
      - diffDates
      - eventRangesToEventFootprints
      - isEventInstanceGroupAllowed
      - getSafeHitFootprint
    */
    function EventResizing(component, eventPointing) {
        var _this = _super.call(this, component) || this;
        _this.isResizing = false;
        _this.eventPointing = eventPointing;
        return _this;
    }
    EventResizing.prototype.end = function () {
        if (this.dragListener) {
            this.dragListener.endInteraction();
        }
    };
    EventResizing.prototype.bindToEl = function (el) {
        var component = this.component;
        component.bindSegHandlerToEl(el, 'mousedown', this.handleMouseDown.bind(this));
        component.bindSegHandlerToEl(el, 'touchstart', this.handleTouchStart.bind(this));
    };
    EventResizing.prototype.handleMouseDown = function (seg, ev) {
        if (this.component.canStartResize(seg, ev)) {
            this.buildDragListener(seg, $(ev.target).is('.fc-start-resizer'))
                .startInteraction(ev, { distance: 5 });
        }
    };
    EventResizing.prototype.handleTouchStart = function (seg, ev) {
        if (this.component.canStartResize(seg, ev)) {
            this.buildDragListener(seg, $(ev.target).is('.fc-start-resizer'))
                .startInteraction(ev);
        }
    };
    // Creates a listener that tracks the user as they resize an event segment.
    // Generic enough to work with any type of Grid.
    EventResizing.prototype.buildDragListener = function (seg, isStart) {
        var _this = this;
        var component = this.component;
        var view = this.view;
        var calendar = view.calendar;
        var eventManager = calendar.eventManager;
        var el = seg.el;
        var eventDef = seg.footprint.eventDef;
        var eventInstance = seg.footprint.eventInstance;
        var isDragging;
        var resizeMutation; // zoned event date properties. falsy if invalid resize
        // Tracks mouse movement over the *grid's* coordinate map
        var dragListener = this.dragListener = new HitDragListener_1.default(component, {
            scroll: this.opt('dragScroll'),
            subjectEl: el,
            interactionStart: function () {
                isDragging = false;
            },
            dragStart: function (ev) {
                isDragging = true;
                // ensure a mouseout on the manipulated event has been reported
                _this.eventPointing.handleMouseout(seg, ev);
                _this.segResizeStart(seg, ev);
            },
            hitOver: function (hit, isOrig, origHit) {
                var isAllowed = true;
                var origHitFootprint = component.getSafeHitFootprint(origHit);
                var hitFootprint = component.getSafeHitFootprint(hit);
                var mutatedEventInstanceGroup;
                if (origHitFootprint && hitFootprint) {
                    resizeMutation = isStart ?
                        _this.computeEventStartResizeMutation(origHitFootprint, hitFootprint, seg.footprint) :
                        _this.computeEventEndResizeMutation(origHitFootprint, hitFootprint, seg.footprint);
                    if (resizeMutation) {
                        mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, resizeMutation);
                        isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
                    }
                    else {
                        isAllowed = false;
                    }
                }
                else {
                    isAllowed = false;
                }
                if (!isAllowed) {
                    resizeMutation = null;
                    util_1.disableCursor();
                }
                else if (resizeMutation.isEmpty()) {
                    // no change. (FYI, event dates might have zones)
                    resizeMutation = null;
                }
                if (resizeMutation) {
                    view.hideEventsWithId(seg.footprint.eventDef.id);
                    view.renderEventResize(component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg);
                }
            },
            hitOut: function () {
                resizeMutation = null;
            },
            hitDone: function () {
                view.unrenderEventResize(seg);
                view.showEventsWithId(seg.footprint.eventDef.id);
                util_1.enableCursor();
            },
            interactionEnd: function (ev) {
                if (isDragging) {
                    _this.segResizeStop(seg, ev);
                }
                if (resizeMutation) {
                    // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
                    view.reportEventResize(eventInstance, resizeMutation, el, ev);
                }
                _this.dragListener = null;
            }
        });
        return dragListener;
    };
    // Called before event segment resizing starts
    EventResizing.prototype.segResizeStart = function (seg, ev) {
        this.isResizing = true;
        this.component.publiclyTrigger('eventResizeStart', {
            context: seg.el[0],
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // Called after event segment resizing stops
    EventResizing.prototype.segResizeStop = function (seg, ev) {
        this.isResizing = false;
        this.component.publiclyTrigger('eventResizeStop', {
            context: seg.el[0],
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // Returns new date-information for an event segment being resized from its start
    EventResizing.prototype.computeEventStartResizeMutation = function (startFootprint, endFootprint, origEventFootprint) {
        var origRange = origEventFootprint.componentFootprint.unzonedRange;
        var startDelta = this.component.diffDates(endFootprint.unzonedRange.getStart(), startFootprint.unzonedRange.getStart());
        var dateMutation;
        var eventDefMutation;
        if (origRange.getStart().add(startDelta) < origRange.getEnd()) {
            dateMutation = new EventDefDateMutation_1.default();
            dateMutation.setStartDelta(startDelta);
            eventDefMutation = new EventDefMutation_1.default();
            eventDefMutation.setDateMutation(dateMutation);
            return eventDefMutation;
        }
        return false;
    };
    // Returns new date-information for an event segment being resized from its end
    EventResizing.prototype.computeEventEndResizeMutation = function (startFootprint, endFootprint, origEventFootprint) {
        var origRange = origEventFootprint.componentFootprint.unzonedRange;
        var endDelta = this.component.diffDates(endFootprint.unzonedRange.getEnd(), startFootprint.unzonedRange.getEnd());
        var dateMutation;
        var eventDefMutation;
        if (origRange.getEnd().add(endDelta) > origRange.getStart()) {
            dateMutation = new EventDefDateMutation_1.default();
            dateMutation.setEndDelta(endDelta);
            eventDefMutation = new EventDefMutation_1.default();
            eventDefMutation.setDateMutation(dateMutation);
            return eventDefMutation;
        }
        return false;
    };
    return EventResizing;
}(Interaction_1.default));
exports.default = EventResizing;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var EventDefMutation_1 = __webpack_require__(36);
var EventDefDateMutation_1 = __webpack_require__(50);
var DragListener_1 = __webpack_require__(54);
var HitDragListener_1 = __webpack_require__(22);
var MouseFollower_1 = __webpack_require__(244);
var Interaction_1 = __webpack_require__(15);
var EventDragging = /** @class */ (function (_super) {
    tslib_1.__extends(EventDragging, _super);
    /*
    component implements:
      - bindSegHandlerToEl
      - publiclyTrigger
      - diffDates
      - eventRangesToEventFootprints
      - isEventInstanceGroupAllowed
    */
    function EventDragging(component, eventPointing) {
        var _this = _super.call(this, component) || this;
        _this.isDragging = false;
        _this.eventPointing = eventPointing;
        return _this;
    }
    EventDragging.prototype.end = function () {
        if (this.dragListener) {
            this.dragListener.endInteraction();
        }
    };
    EventDragging.prototype.getSelectionDelay = function () {
        var delay = this.opt('eventLongPressDelay');
        if (delay == null) {
            delay = this.opt('longPressDelay'); // fallback
        }
        return delay;
    };
    EventDragging.prototype.bindToEl = function (el) {
        var component = this.component;
        component.bindSegHandlerToEl(el, 'mousedown', this.handleMousedown.bind(this));
        component.bindSegHandlerToEl(el, 'touchstart', this.handleTouchStart.bind(this));
    };
    EventDragging.prototype.handleMousedown = function (seg, ev) {
        if (!this.component.shouldIgnoreMouse() &&
            this.component.canStartDrag(seg, ev)) {
            this.buildDragListener(seg).startInteraction(ev, { distance: 5 });
        }
    };
    EventDragging.prototype.handleTouchStart = function (seg, ev) {
        var component = this.component;
        var settings = {
            delay: this.view.isEventDefSelected(seg.footprint.eventDef) ? // already selected?
                0 : this.getSelectionDelay()
        };
        if (component.canStartDrag(seg, ev)) {
            this.buildDragListener(seg).startInteraction(ev, settings);
        }
        else if (component.canStartSelection(seg, ev)) {
            this.buildSelectListener(seg).startInteraction(ev, settings);
        }
    };
    // seg isn't draggable, but let's use a generic DragListener
    // simply for the delay, so it can be selected.
    // Has side effect of setting/unsetting `dragListener`
    EventDragging.prototype.buildSelectListener = function (seg) {
        var _this = this;
        var view = this.view;
        var eventDef = seg.footprint.eventDef;
        var eventInstance = seg.footprint.eventInstance; // null for inverse-background events
        if (this.dragListener) {
            return this.dragListener;
        }
        var dragListener = this.dragListener = new DragListener_1.default({
            dragStart: function (ev) {
                if (dragListener.isTouch &&
                    !view.isEventDefSelected(eventDef) &&
                    eventInstance) {
                    // if not previously selected, will fire after a delay. then, select the event
                    view.selectEventInstance(eventInstance);
                }
            },
            interactionEnd: function (ev) {
                _this.dragListener = null;
            }
        });
        return dragListener;
    };
    // Builds a listener that will track user-dragging on an event segment.
    // Generic enough to work with any type of Grid.
    // Has side effect of setting/unsetting `dragListener`
    EventDragging.prototype.buildDragListener = function (seg) {
        var _this = this;
        var component = this.component;
        var view = this.view;
        var calendar = view.calendar;
        var eventManager = calendar.eventManager;
        var el = seg.el;
        var eventDef = seg.footprint.eventDef;
        var eventInstance = seg.footprint.eventInstance; // null for inverse-background events
        var isDragging;
        var mouseFollower; // A clone of the original element that will move with the mouse
        var eventDefMutation;
        if (this.dragListener) {
            return this.dragListener;
        }
        // Tracks mouse movement over the *view's* coordinate map. Allows dragging and dropping between subcomponents
        // of the view.
        var dragListener = this.dragListener = new HitDragListener_1.default(view, {
            scroll: this.opt('dragScroll'),
            subjectEl: el,
            subjectCenter: true,
            interactionStart: function (ev) {
                seg.component = component; // for renderDrag
                isDragging = false;
                mouseFollower = new MouseFollower_1.default(seg.el, {
                    additionalClass: 'fc-dragging',
                    parentEl: view.el,
                    opacity: dragListener.isTouch ? null : _this.opt('dragOpacity'),
                    revertDuration: _this.opt('dragRevertDuration'),
                    zIndex: 2 // one above the .fc-view
                });
                mouseFollower.hide(); // don't show until we know this is a real drag
                mouseFollower.start(ev);
            },
            dragStart: function (ev) {
                if (dragListener.isTouch &&
                    !view.isEventDefSelected(eventDef) &&
                    eventInstance) {
                    // if not previously selected, will fire after a delay. then, select the event
                    view.selectEventInstance(eventInstance);
                }
                isDragging = true;
                // ensure a mouseout on the manipulated event has been reported
                _this.eventPointing.handleMouseout(seg, ev);
                _this.segDragStart(seg, ev);
                view.hideEventsWithId(seg.footprint.eventDef.id);
            },
            hitOver: function (hit, isOrig, origHit) {
                var isAllowed = true;
                var origFootprint;
                var footprint;
                var mutatedEventInstanceGroup;
                // starting hit could be forced (DayGrid.limit)
                if (seg.hit) {
                    origHit = seg.hit;
                }
                // hit might not belong to this grid, so query origin grid
                origFootprint = origHit.component.getSafeHitFootprint(origHit);
                footprint = hit.component.getSafeHitFootprint(hit);
                if (origFootprint && footprint) {
                    eventDefMutation = _this.computeEventDropMutation(origFootprint, footprint, eventDef);
                    if (eventDefMutation) {
                        mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, eventDefMutation);
                        isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
                    }
                    else {
                        isAllowed = false;
                    }
                }
                else {
                    isAllowed = false;
                }
                if (!isAllowed) {
                    eventDefMutation = null;
                    util_1.disableCursor();
                }
                // if a valid drop location, have the subclass render a visual indication
                if (eventDefMutation &&
                    view.renderDrag(// truthy if rendered something
                    component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg, dragListener.isTouch)) {
                    mouseFollower.hide(); // if the subclass is already using a mock event "helper", hide our own
                }
                else {
                    mouseFollower.show(); // otherwise, have the helper follow the mouse (no snapping)
                }
                if (isOrig) {
                    // needs to have moved hits to be a valid drop
                    eventDefMutation = null;
                }
            },
            hitOut: function () {
                view.unrenderDrag(seg); // unrender whatever was done in renderDrag
                mouseFollower.show(); // show in case we are moving out of all hits
                eventDefMutation = null;
            },
            hitDone: function () {
                util_1.enableCursor();
            },
            interactionEnd: function (ev) {
                delete seg.component; // prevent side effects
                // do revert animation if hasn't changed. calls a callback when finished (whether animation or not)
                mouseFollower.stop(!eventDefMutation, function () {
                    if (isDragging) {
                        view.unrenderDrag(seg);
                        _this.segDragStop(seg, ev);
                    }
                    view.showEventsWithId(seg.footprint.eventDef.id);
                    if (eventDefMutation) {
                        // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
                        view.reportEventDrop(eventInstance, eventDefMutation, el, ev);
                    }
                });
                _this.dragListener = null;
            }
        });
        return dragListener;
    };
    // Called before event segment dragging starts
    EventDragging.prototype.segDragStart = function (seg, ev) {
        this.isDragging = true;
        this.component.publiclyTrigger('eventDragStart', {
            context: seg.el[0],
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // Called after event segment dragging stops
    EventDragging.prototype.segDragStop = function (seg, ev) {
        this.isDragging = false;
        this.component.publiclyTrigger('eventDragStop', {
            context: seg.el[0],
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // DOES NOT consider overlap/constraint
    EventDragging.prototype.computeEventDropMutation = function (startFootprint, endFootprint, eventDef) {
        var eventDefMutation = new EventDefMutation_1.default();
        eventDefMutation.setDateMutation(this.computeEventDateMutation(startFootprint, endFootprint));
        return eventDefMutation;
    };
    EventDragging.prototype.computeEventDateMutation = function (startFootprint, endFootprint) {
        var date0 = startFootprint.unzonedRange.getStart();
        var date1 = endFootprint.unzonedRange.getStart();
        var clearEnd = false;
        var forceTimed = false;
        var forceAllDay = false;
        var dateDelta;
        var dateMutation;
        if (startFootprint.isAllDay !== endFootprint.isAllDay) {
            clearEnd = true;
            if (endFootprint.isAllDay) {
                forceAllDay = true;
                date0.stripTime();
            }
            else {
                forceTimed = true;
            }
        }
        dateDelta = this.component.diffDates(date1, date0);
        dateMutation = new EventDefDateMutation_1.default();
        dateMutation.clearEnd = clearEnd;
        dateMutation.forceTimed = forceTimed;
        dateMutation.forceAllDay = forceAllDay;
        dateMutation.setDateDelta(dateDelta);
        return dateMutation;
    };
    return EventDragging;
}(Interaction_1.default));
exports.default = EventDragging;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var HitDragListener_1 = __webpack_require__(22);
var ComponentFootprint_1 = __webpack_require__(12);
var UnzonedRange_1 = __webpack_require__(5);
var Interaction_1 = __webpack_require__(15);
var DateSelecting = /** @class */ (function (_super) {
    tslib_1.__extends(DateSelecting, _super);
    /*
    component must implement:
      - bindDateHandlerToEl
      - getSafeHitFootprint
      - renderHighlight
      - unrenderHighlight
    */
    function DateSelecting(component) {
        var _this = _super.call(this, component) || this;
        _this.dragListener = _this.buildDragListener();
        return _this;
    }
    DateSelecting.prototype.end = function () {
        this.dragListener.endInteraction();
    };
    DateSelecting.prototype.getDelay = function () {
        var delay = this.opt('selectLongPressDelay');
        if (delay == null) {
            delay = this.opt('longPressDelay'); // fallback
        }
        return delay;
    };
    DateSelecting.prototype.bindToEl = function (el) {
        var _this = this;
        var component = this.component;
        var dragListener = this.dragListener;
        component.bindDateHandlerToEl(el, 'mousedown', function (ev) {
            if (_this.opt('selectable') && !component.shouldIgnoreMouse()) {
                dragListener.startInteraction(ev, {
                    distance: _this.opt('selectMinDistance')
                });
            }
        });
        component.bindDateHandlerToEl(el, 'touchstart', function (ev) {
            if (_this.opt('selectable') && !component.shouldIgnoreTouch()) {
                dragListener.startInteraction(ev, {
                    delay: _this.getDelay()
                });
            }
        });
        util_1.preventSelection(el);
    };
    // Creates a listener that tracks the user's drag across day elements, for day selecting.
    DateSelecting.prototype.buildDragListener = function () {
        var _this = this;
        var component = this.component;
        var selectionFootprint; // null if invalid selection
        var dragListener = new HitDragListener_1.default(component, {
            scroll: this.opt('dragScroll'),
            interactionStart: function () {
                selectionFootprint = null;
            },
            dragStart: function (ev) {
                _this.view.unselect(ev); // since we could be rendering a new selection, we want to clear any old one
            },
            hitOver: function (hit, isOrig, origHit) {
                var origHitFootprint;
                var hitFootprint;
                if (origHit) {
                    origHitFootprint = component.getSafeHitFootprint(origHit);
                    hitFootprint = component.getSafeHitFootprint(hit);
                    if (origHitFootprint && hitFootprint) {
                        selectionFootprint = _this.computeSelection(origHitFootprint, hitFootprint);
                    }
                    else {
                        selectionFootprint = null;
                    }
                    if (selectionFootprint) {
                        component.renderSelectionFootprint(selectionFootprint);
                    }
                    else if (selectionFootprint === false) {
                        util_1.disableCursor();
                    }
                }
            },
            hitOut: function () {
                selectionFootprint = null;
                component.unrenderSelection();
            },
            hitDone: function () {
                util_1.enableCursor();
            },
            interactionEnd: function (ev, isCancelled) {
                if (!isCancelled && selectionFootprint) {
                    // the selection will already have been rendered. just report it
                    _this.view.reportSelection(selectionFootprint, ev);
                }
            }
        });
        return dragListener;
    };
    // Given the first and last date-spans of a selection, returns another date-span object.
    // Subclasses can override and provide additional data in the span object. Will be passed to renderSelectionFootprint().
    // Will return false if the selection is invalid and this should be indicated to the user.
    // Will return null/undefined if a selection invalid but no error should be reported.
    DateSelecting.prototype.computeSelection = function (footprint0, footprint1) {
        var wholeFootprint = this.computeSelectionFootprint(footprint0, footprint1);
        if (wholeFootprint && !this.isSelectionFootprintAllowed(wholeFootprint)) {
            return false;
        }
        return wholeFootprint;
    };
    // Given two spans, must return the combination of the two.
    // TODO: do this separation of concerns (combining VS validation) for event dnd/resize too.
    // Assumes both footprints are non-open-ended.
    DateSelecting.prototype.computeSelectionFootprint = function (footprint0, footprint1) {
        var ms = [
            footprint0.unzonedRange.startMs,
            footprint0.unzonedRange.endMs,
            footprint1.unzonedRange.startMs,
            footprint1.unzonedRange.endMs
        ];
        ms.sort(util_1.compareNumbers);
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(ms[0], ms[3]), footprint0.isAllDay);
    };
    DateSelecting.prototype.isSelectionFootprintAllowed = function (componentFootprint) {
        return this.component.dateProfile.validUnzonedRange.containsRange(componentFootprint.unzonedRange) &&
            this.view.calendar.constraints.isSelectionFootprintAllowed(componentFootprint);
    };
    return DateSelecting;
}(Interaction_1.default));
exports.default = DateSelecting;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var moment = __webpack_require__(0);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Scroller_1 = __webpack_require__(39);
var View_1 = __webpack_require__(41);
var TimeGrid_1 = __webpack_require__(227);
var DayGrid_1 = __webpack_require__(61);
var AGENDA_ALL_DAY_EVENT_LIMIT = 5;
var agendaTimeGridMethods;
var agendaDayGridMethods;
/* An abstract class for all agenda-related views. Displays one more columns with time slots running vertically.
----------------------------------------------------------------------------------------------------------------------*/
// Is a manager for the TimeGrid subcomponent and possibly the DayGrid subcomponent (if allDaySlot is on).
// Responsible for managing width/height.
var AgendaView = /** @class */ (function (_super) {
    tslib_1.__extends(AgendaView, _super);
    function AgendaView(calendar, viewSpec) {
        var _this = _super.call(this, calendar, viewSpec) || this;
        _this.usesMinMaxTime = true; // indicates that minTime/maxTime affects rendering
        _this.timeGrid = _this.instantiateTimeGrid();
        _this.addChild(_this.timeGrid);
        if (_this.opt('allDaySlot')) {
            _this.dayGrid = _this.instantiateDayGrid(); // the all-day subcomponent of this view
            _this.addChild(_this.dayGrid);
        }
        _this.scroller = new Scroller_1.default({
            overflowX: 'hidden',
            overflowY: 'auto'
        });
        return _this;
    }
    // Instantiates the TimeGrid object this view needs. Draws from this.timeGridClass
    AgendaView.prototype.instantiateTimeGrid = function () {
        var timeGrid = new this.timeGridClass(this);
        util_1.copyOwnProps(agendaTimeGridMethods, timeGrid);
        return timeGrid;
    };
    // Instantiates the DayGrid object this view might need. Draws from this.dayGridClass
    AgendaView.prototype.instantiateDayGrid = function () {
        var dayGrid = new this.dayGridClass(this);
        util_1.copyOwnProps(agendaDayGridMethods, dayGrid);
        return dayGrid;
    };
    /* Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    AgendaView.prototype.renderSkeleton = function () {
        var timeGridWrapEl;
        var timeGridEl;
        this.el.addClass('fc-agenda-view').html(this.renderSkeletonHtml());
        this.scroller.render();
        timeGridWrapEl = this.scroller.el.addClass('fc-time-grid-container');
        timeGridEl = $('<div class="fc-time-grid" />').appendTo(timeGridWrapEl);
        this.el.find('.fc-body > tr > td').append(timeGridWrapEl);
        this.timeGrid.headContainerEl = this.el.find('.fc-head-container');
        this.timeGrid.setElement(timeGridEl);
        if (this.dayGrid) {
            this.dayGrid.setElement(this.el.find('.fc-day-grid'));
            // have the day-grid extend it's coordinate area over the <hr> dividing the two grids
            this.dayGrid.bottomCoordPadding = this.dayGrid.el.next('hr').outerHeight();
        }
    };
    AgendaView.prototype.unrenderSkeleton = function () {
        this.timeGrid.removeElement();
        if (this.dayGrid) {
            this.dayGrid.removeElement();
        }
        this.scroller.destroy();
    };
    // Builds the HTML skeleton for the view.
    // The day-grid and time-grid components will render inside containers defined by this HTML.
    AgendaView.prototype.renderSkeletonHtml = function () {
        var theme = this.calendar.theme;
        return '' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            (this.opt('columnHeader') ?
                '<thead class="fc-head">' +
                    '<tr>' +
                    '<td class="fc-head-container ' + theme.getClass('widgetHeader') + '">&nbsp;</td>' +
                    '</tr>' +
                    '</thead>' :
                '') +
            '<tbody class="fc-body">' +
            '<tr>' +
            '<td class="' + theme.getClass('widgetContent') + '">' +
            (this.dayGrid ?
                '<div class="fc-day-grid"/>' +
                    '<hr class="fc-divider ' + theme.getClass('widgetHeader') + '"/>' :
                '') +
            '</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>';
    };
    // Generates an HTML attribute string for setting the width of the axis, if it is known
    AgendaView.prototype.axisStyleAttr = function () {
        if (this.axisWidth != null) {
            return 'style="width:' + this.axisWidth + 'px"';
        }
        return '';
    };
    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    AgendaView.prototype.getNowIndicatorUnit = function () {
        return this.timeGrid.getNowIndicatorUnit();
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    // Adjusts the vertical dimensions of the view to the specified values
    AgendaView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        var eventLimit;
        var scrollerHeight;
        var scrollbarWidths;
        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        // make all axis cells line up, and record the width so newly created axis cells will have it
        this.axisWidth = util_1.matchCellWidths(this.el.find('.fc-axis'));
        // hack to give the view some height prior to timeGrid's columns being rendered
        // TODO: separate setting height from scroller VS timeGrid.
        if (!this.timeGrid.colEls) {
            if (!isAuto) {
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            return;
        }
        // set of fake row elements that must compensate when scroller has scrollbars
        var noScrollRowEls = this.el.find('.fc-row:not(.fc-scroller *)');
        // reset all dimensions back to the original state
        this.timeGrid.bottomRuleEl.hide(); // .show() will be called later if this <hr> is necessary
        this.scroller.clear(); // sets height to 'auto' and clears overflow
        util_1.uncompensateScroll(noScrollRowEls);
        // limit number of events in the all-day area
        if (this.dayGrid) {
            this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
            eventLimit = this.opt('eventLimit');
            if (eventLimit && typeof eventLimit !== 'number') {
                eventLimit = AGENDA_ALL_DAY_EVENT_LIMIT; // make sure "auto" goes to a real number
            }
            if (eventLimit) {
                this.dayGrid.limitRows(eventLimit);
            }
        }
        if (!isAuto) {
            scrollerHeight = this.computeScrollerHeight(totalHeight);
            this.scroller.setHeight(scrollerHeight);
            scrollbarWidths = this.scroller.getScrollbarWidths();
            if (scrollbarWidths.left || scrollbarWidths.right) {
                // make the all-day and header rows lines up
                util_1.compensateScroll(noScrollRowEls, scrollbarWidths);
                // the scrollbar compensation might have changed text flow, which might affect height, so recalculate
                // and reapply the desired height to the scroller.
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            // guarantees the same scrollbar widths
            this.scroller.lockOverflow(scrollbarWidths);
            // if there's any space below the slats, show the horizontal rule.
            // this won't cause any new overflow, because lockOverflow already called.
            if (this.timeGrid.getTotalSlatHeight() < scrollerHeight) {
                this.timeGrid.bottomRuleEl.show();
            }
        }
    };
    // given a desired total height of the view, returns what the height of the scroller should be
    AgendaView.prototype.computeScrollerHeight = function (totalHeight) {
        return totalHeight -
            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    };
    /* Scroll
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes the initial pre-configured scroll state prior to allowing the user to change it
    AgendaView.prototype.computeInitialDateScroll = function () {
        var scrollTime = moment.duration(this.opt('scrollTime'));
        var top = this.timeGrid.computeTimeTop(scrollTime);
        // zoom can give weird floating-point values. rather scroll a little bit further
        top = Math.ceil(top);
        if (top) {
            top++; // to overcome top border that slots beyond the first have. looks better
        }
        return { top: top };
    };
    AgendaView.prototype.queryDateScroll = function () {
        return { top: this.scroller.getScrollTop() };
    };
    AgendaView.prototype.applyDateScroll = function (scroll) {
        if (scroll.top !== undefined) {
            this.scroller.setScrollTop(scroll.top);
        }
    };
    /* Hit Areas
    ------------------------------------------------------------------------------------------------------------------*/
    // forward all hit-related method calls to the grids (dayGrid might not be defined)
    AgendaView.prototype.getHitFootprint = function (hit) {
        // TODO: hit.component is set as a hack to identify where the hit came from
        return hit.component.getHitFootprint(hit);
    };
    AgendaView.prototype.getHitEl = function (hit) {
        // TODO: hit.component is set as a hack to identify where the hit came from
        return hit.component.getHitEl(hit);
    };
    /* Event Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    AgendaView.prototype.executeEventRender = function (eventsPayload) {
        var dayEventsPayload = {};
        var timedEventsPayload = {};
        var id;
        var eventInstanceGroup;
        // separate the events into all-day and timed
        for (id in eventsPayload) {
            eventInstanceGroup = eventsPayload[id];
            if (eventInstanceGroup.getEventDef().isAllDay()) {
                dayEventsPayload[id] = eventInstanceGroup;
            }
            else {
                timedEventsPayload[id] = eventInstanceGroup;
            }
        }
        this.timeGrid.executeEventRender(timedEventsPayload);
        if (this.dayGrid) {
            this.dayGrid.executeEventRender(dayEventsPayload);
        }
    };
    /* Dragging/Resizing Routing
    ------------------------------------------------------------------------------------------------------------------*/
    // A returned value of `true` signals that a mock "helper" event has been rendered.
    AgendaView.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        var groups = groupEventFootprintsByAllDay(eventFootprints);
        var renderedHelper = false;
        renderedHelper = this.timeGrid.renderDrag(groups.timed, seg, isTouch);
        if (this.dayGrid) {
            renderedHelper = this.dayGrid.renderDrag(groups.allDay, seg, isTouch) || renderedHelper;
        }
        return renderedHelper;
    };
    AgendaView.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        var groups = groupEventFootprintsByAllDay(eventFootprints);
        this.timeGrid.renderEventResize(groups.timed, seg, isTouch);
        if (this.dayGrid) {
            this.dayGrid.renderEventResize(groups.allDay, seg, isTouch);
        }
    };
    /* Selection
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of a selection
    AgendaView.prototype.renderSelectionFootprint = function (componentFootprint) {
        if (!componentFootprint.isAllDay) {
            this.timeGrid.renderSelectionFootprint(componentFootprint);
        }
        else if (this.dayGrid) {
            this.dayGrid.renderSelectionFootprint(componentFootprint);
        }
    };
    return AgendaView;
}(View_1.default));
exports.default = AgendaView;
AgendaView.prototype.timeGridClass = TimeGrid_1.default;
AgendaView.prototype.dayGridClass = DayGrid_1.default;
// Will customize the rendering behavior of the AgendaView's timeGrid
agendaTimeGridMethods = {
    // Generates the HTML that will go before the day-of week header cells
    renderHeadIntroHtml: function () {
        var view = this.view;
        var calendar = view.calendar;
        var weekStart = calendar.msToUtcMoment(this.dateProfile.renderUnzonedRange.startMs, true);
        var weekText;
        if (this.opt('weekNumbers')) {
            weekText = weekStart.format(this.opt('smallWeekFormat'));
            return '' +
                '<th class="fc-axis fc-week-number ' + calendar.theme.getClass('widgetHeader') + '" ' + view.axisStyleAttr() + '>' +
                view.buildGotoAnchorHtml(// aside from link, important for matchCellWidths
                { date: weekStart, type: 'week', forceOff: this.colCnt > 1 }, util_1.htmlEscape(weekText) // inner HTML
                ) +
                '</th>';
        }
        else {
            return '<th class="fc-axis ' + calendar.theme.getClass('widgetHeader') + '" ' + view.axisStyleAttr() + '></th>';
        }
    },
    // Generates the HTML that goes before the bg of the TimeGrid slot area. Long vertical column.
    renderBgIntroHtml: function () {
        var view = this.view;
        return '<td class="fc-axis ' + view.calendar.theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '></td>';
    },
    // Generates the HTML that goes before all other types of cells.
    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
    renderIntroHtml: function () {
        var view = this.view;
        return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
    }
};
// Will customize the rendering behavior of the AgendaView's dayGrid
agendaDayGridMethods = {
    // Generates the HTML that goes before the all-day cells
    renderBgIntroHtml: function () {
        var view = this.view;
        return '' +
            '<td class="fc-axis ' + view.calendar.theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '>' +
            '<span>' + // needed for matchCellWidths
            view.getAllDayHtml() +
            '</span>' +
            '</td>';
    },
    // Generates the HTML that goes before all other types of cells.
    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
    renderIntroHtml: function () {
        var view = this.view;
        return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
    }
};
function groupEventFootprintsByAllDay(eventFootprints) {
    var allDay = [];
    var timed = [];
    var i;
    for (i = 0; i < eventFootprints.length; i++) {
        if (eventFootprints[i].componentFootprint.isAllDay) {
            allDay.push(eventFootprints[i]);
        }
        else {
            timed.push(eventFootprints[i]);
        }
    }
    return { allDay: allDay, timed: timed };
}


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var InteractiveDateComponent_1 = __webpack_require__(40);
var BusinessHourRenderer_1 = __webpack_require__(56);
var StandardInteractionsMixin_1 = __webpack_require__(60);
var DayTableMixin_1 = __webpack_require__(55);
var CoordCache_1 = __webpack_require__(53);
var UnzonedRange_1 = __webpack_require__(5);
var ComponentFootprint_1 = __webpack_require__(12);
var TimeGridEventRenderer_1 = __webpack_require__(246);
var TimeGridHelperRenderer_1 = __webpack_require__(247);
var TimeGridFillRenderer_1 = __webpack_require__(248);
/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/
// We mixin DayTable, even though there is only a single row of days
// potential nice values for the slot-duration and interval-duration
// from largest to smallest
var AGENDA_STOCK_SUB_DURATIONS = [
    { hours: 1 },
    { minutes: 30 },
    { minutes: 15 },
    { seconds: 30 },
    { seconds: 15 }
];
var TimeGrid = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGrid, _super);
    function TimeGrid(view) {
        var _this = _super.call(this, view) || this;
        _this.processOptions();
        return _this;
    }
    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
    TimeGrid.prototype.componentFootprintToSegs = function (componentFootprint) {
        var segs = this.sliceRangeByTimes(componentFootprint.unzonedRange);
        var i;
        for (i = 0; i < segs.length; i++) {
            if (this.isRTL) {
                segs[i].col = this.daysPerRow - 1 - segs[i].dayIndex;
            }
            else {
                segs[i].col = segs[i].dayIndex;
            }
        }
        return segs;
    };
    /* Date Handling
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.sliceRangeByTimes = function (unzonedRange) {
        var segs = [];
        var segRange;
        var dayIndex;
        for (dayIndex = 0; dayIndex < this.daysPerRow; dayIndex++) {
            segRange = unzonedRange.intersect(this.dayRanges[dayIndex]);
            if (segRange) {
                segs.push({
                    startMs: segRange.startMs,
                    endMs: segRange.endMs,
                    isStart: segRange.isStart,
                    isEnd: segRange.isEnd,
                    dayIndex: dayIndex
                });
            }
        }
        return segs;
    };
    /* Options
    ------------------------------------------------------------------------------------------------------------------*/
    // Parses various options into properties of this object
    TimeGrid.prototype.processOptions = function () {
        var slotDuration = this.opt('slotDuration');
        var snapDuration = this.opt('snapDuration');
        var input;
        slotDuration = moment.duration(slotDuration);
        snapDuration = snapDuration ? moment.duration(snapDuration) : slotDuration;
        this.slotDuration = slotDuration;
        this.snapDuration = snapDuration;
        this.snapsPerSlot = slotDuration / snapDuration; // TODO: ensure an integer multiple?
        // might be an array value (for TimelineView).
        // if so, getting the most granular entry (the last one probably).
        input = this.opt('slotLabelFormat');
        if ($.isArray(input)) {
            input = input[input.length - 1];
        }
        this.labelFormat = input ||
            this.opt('smallTimeFormat'); // the computed default
        input = this.opt('slotLabelInterval');
        this.labelInterval = input ?
            moment.duration(input) :
            this.computeLabelInterval(slotDuration);
    };
    // Computes an automatic value for slotLabelInterval
    TimeGrid.prototype.computeLabelInterval = function (slotDuration) {
        var i;
        var labelInterval;
        var slotsPerLabel;
        // find the smallest stock label interval that results in more than one slots-per-label
        for (i = AGENDA_STOCK_SUB_DURATIONS.length - 1; i >= 0; i--) {
            labelInterval = moment.duration(AGENDA_STOCK_SUB_DURATIONS[i]);
            slotsPerLabel = util_1.divideDurationByDuration(labelInterval, slotDuration);
            if (util_1.isInt(slotsPerLabel) && slotsPerLabel > 1) {
                return labelInterval;
            }
        }
        return moment.duration(slotDuration); // fall back. clone
    };
    /* Date Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.renderDates = function (dateProfile) {
        this.dateProfile = dateProfile;
        this.updateDayTable();
        this.renderSlats();
        this.renderColumns();
    };
    TimeGrid.prototype.unrenderDates = function () {
        // this.unrenderSlats(); // don't need this because repeated .html() calls clear
        this.unrenderColumns();
    };
    TimeGrid.prototype.renderSkeleton = function () {
        var theme = this.view.calendar.theme;
        this.el.html('<div class="fc-bg"></div>' +
            '<div class="fc-slats"></div>' +
            '<hr class="fc-divider ' + theme.getClass('widgetHeader') + '" style="display:none" />');
        this.bottomRuleEl = this.el.find('hr');
    };
    TimeGrid.prototype.renderSlats = function () {
        var theme = this.view.calendar.theme;
        this.slatContainerEl = this.el.find('> .fc-slats')
            .html(// avoids needing ::unrenderSlats()
        '<table class="' + theme.getClass('tableGrid') + '">' +
            this.renderSlatRowHtml() +
            '</table>');
        this.slatEls = this.slatContainerEl.find('tr');
        this.slatCoordCache = new CoordCache_1.default({
            els: this.slatEls,
            isVertical: true
        });
    };
    // Generates the HTML for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
    TimeGrid.prototype.renderSlatRowHtml = function () {
        var view = this.view;
        var calendar = view.calendar;
        var theme = calendar.theme;
        var isRTL = this.isRTL;
        var dateProfile = this.dateProfile;
        var html = '';
        var slotTime = moment.duration(+dateProfile.minTime); // wish there was .clone() for durations
        var slotIterator = moment.duration(0);
        var slotDate; // will be on the view's first day, but we only care about its time
        var isLabeled;
        var axisHtml;
        // Calculate the time for each slot
        while (slotTime < dateProfile.maxTime) {
            slotDate = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs).time(slotTime);
            isLabeled = util_1.isInt(util_1.divideDurationByDuration(slotIterator, this.labelInterval));
            axisHtml =
                '<td class="fc-axis fc-time ' + theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '>' +
                    (isLabeled ?
                        '<span>' + // for matchCellWidths
                            util_1.htmlEscape(slotDate.format(this.labelFormat)) +
                            '</span>' :
                        '') +
                    '</td>';
            html +=
                '<tr data-time="' + slotDate.format('HH:mm:ss') + '"' +
                    (isLabeled ? '' : ' class="fc-minor"') +
                    '>' +
                    (!isRTL ? axisHtml : '') +
                    '<td class="' + theme.getClass('widgetContent') + '"/>' +
                    (isRTL ? axisHtml : '') +
                    '</tr>';
            slotTime.add(this.slotDuration);
            slotIterator.add(this.slotDuration);
        }
        return html;
    };
    TimeGrid.prototype.renderColumns = function () {
        var dateProfile = this.dateProfile;
        var theme = this.view.calendar.theme;
        this.dayRanges = this.dayDates.map(function (dayDate) {
            return new UnzonedRange_1.default(dayDate.clone().add(dateProfile.minTime), dayDate.clone().add(dateProfile.maxTime));
        });
        if (this.headContainerEl) {
            this.headContainerEl.html(this.renderHeadHtml());
        }
        this.el.find('> .fc-bg').html('<table class="' + theme.getClass('tableGrid') + '">' +
            this.renderBgTrHtml(0) + // row=0
            '</table>');
        this.colEls = this.el.find('.fc-day, .fc-disabled-day');
        this.colCoordCache = new CoordCache_1.default({
            els: this.colEls,
            isHorizontal: true
        });
        this.renderContentSkeleton();
    };
    TimeGrid.prototype.unrenderColumns = function () {
        this.unrenderContentSkeleton();
    };
    /* Content Skeleton
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders the DOM that the view's content will live in
    TimeGrid.prototype.renderContentSkeleton = function () {
        var cellHtml = '';
        var i;
        var skeletonEl;
        for (i = 0; i < this.colCnt; i++) {
            cellHtml +=
                '<td>' +
                    '<div class="fc-content-col">' +
                    '<div class="fc-event-container fc-helper-container"></div>' +
                    '<div class="fc-event-container"></div>' +
                    '<div class="fc-highlight-container"></div>' +
                    '<div class="fc-bgevent-container"></div>' +
                    '<div class="fc-business-container"></div>' +
                    '</div>' +
                    '</td>';
        }
        skeletonEl = this.contentSkeletonEl = $('<div class="fc-content-skeleton">' +
            '<table>' +
            '<tr>' + cellHtml + '</tr>' +
            '</table>' +
            '</div>');
        this.colContainerEls = skeletonEl.find('.fc-content-col');
        this.helperContainerEls = skeletonEl.find('.fc-helper-container');
        this.fgContainerEls = skeletonEl.find('.fc-event-container:not(.fc-helper-container)');
        this.bgContainerEls = skeletonEl.find('.fc-bgevent-container');
        this.highlightContainerEls = skeletonEl.find('.fc-highlight-container');
        this.businessContainerEls = skeletonEl.find('.fc-business-container');
        this.bookendCells(skeletonEl.find('tr')); // TODO: do this on string level
        this.el.append(skeletonEl);
    };
    TimeGrid.prototype.unrenderContentSkeleton = function () {
        if (this.contentSkeletonEl) {
            this.contentSkeletonEl.remove();
            this.contentSkeletonEl = null;
            this.colContainerEls = null;
            this.helperContainerEls = null;
            this.fgContainerEls = null;
            this.bgContainerEls = null;
            this.highlightContainerEls = null;
            this.businessContainerEls = null;
        }
    };
    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's col
    TimeGrid.prototype.groupSegsByCol = function (segs) {
        var segsByCol = [];
        var i;
        for (i = 0; i < this.colCnt; i++) {
            segsByCol.push([]);
        }
        for (i = 0; i < segs.length; i++) {
            segsByCol[segs[i].col].push(segs[i]);
        }
        return segsByCol;
    };
    // Given segments grouped by column, insert the segments' elements into a parallel array of container
    // elements, each living within a column.
    TimeGrid.prototype.attachSegsByCol = function (segsByCol, containerEls) {
        var col;
        var segs;
        var i;
        for (col = 0; col < this.colCnt; col++) {
            segs = segsByCol[col];
            for (i = 0; i < segs.length; i++) {
                containerEls.eq(col).append(segs[i].el);
            }
        }
    };
    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.getNowIndicatorUnit = function () {
        return 'minute'; // will refresh on the minute
    };
    TimeGrid.prototype.renderNowIndicator = function (date) {
        // HACK: if date columns not ready for some reason (scheduler)
        if (!this.colContainerEls) {
            return;
        }
        // seg system might be overkill, but it handles scenario where line needs to be rendered
        //  more than once because of columns with the same date (resources columns for example)
        var segs = this.componentFootprintToSegs(new ComponentFootprint_1.default(new UnzonedRange_1.default(date, date.valueOf() + 1), // protect against null range
        false // all-day
        ));
        var top = this.computeDateTop(date, date);
        var nodes = [];
        var i;
        // render lines within the columns
        for (i = 0; i < segs.length; i++) {
            nodes.push($('<div class="fc-now-indicator fc-now-indicator-line"></div>')
                .css('top', top)
                .appendTo(this.colContainerEls.eq(segs[i].col))[0]);
        }
        // render an arrow over the axis
        if (segs.length > 0) {
            nodes.push($('<div class="fc-now-indicator fc-now-indicator-arrow"></div>')
                .css('top', top)
                .appendTo(this.el.find('.fc-content-skeleton'))[0]);
        }
        this.nowIndicatorEls = $(nodes);
    };
    TimeGrid.prototype.unrenderNowIndicator = function () {
        if (this.nowIndicatorEls) {
            this.nowIndicatorEls.remove();
            this.nowIndicatorEls = null;
        }
    };
    /* Coordinates
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        this.slatCoordCache.build();
        if (isResize) {
            this.updateSegVerticals([].concat(this.eventRenderer.getSegs(), this.businessSegs || []));
        }
    };
    TimeGrid.prototype.getTotalSlatHeight = function () {
        return this.slatContainerEl.outerHeight();
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // `ms` can be a millisecond UTC time OR a UTC moment.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    TimeGrid.prototype.computeDateTop = function (ms, startOfDayDate) {
        return this.computeTimeTop(moment.duration(ms - startOfDayDate.clone().stripTime()));
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    TimeGrid.prototype.computeTimeTop = function (time) {
        var len = this.slatEls.length;
        var dateProfile = this.dateProfile;
        var slatCoverage = (time - dateProfile.minTime) / this.slotDuration; // floating-point value of # of slots covered
        var slatIndex;
        var slatRemainder;
        // compute a floating-point number for how many slats should be progressed through.
        // from 0 to number of slats (inclusive)
        // constrained because minTime/maxTime might be customized.
        slatCoverage = Math.max(0, slatCoverage);
        slatCoverage = Math.min(len, slatCoverage);
        // an integer index of the furthest whole slat
        // from 0 to number slats (*exclusive*, so len-1)
        slatIndex = Math.floor(slatCoverage);
        slatIndex = Math.min(slatIndex, len - 1);
        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
        // could be 1.0 if slatCoverage is covering *all* the slots
        slatRemainder = slatCoverage - slatIndex;
        return this.slatCoordCache.getTopPosition(slatIndex) +
            this.slatCoordCache.getHeight(slatIndex) * slatRemainder;
    };
    // Refreshes the CSS top/bottom coordinates for each segment element.
    // Works when called after initial render, after a window resize/zoom for example.
    TimeGrid.prototype.updateSegVerticals = function (segs) {
        this.computeSegVerticals(segs);
        this.assignSegVerticals(segs);
    };
    // For each segment in an array, computes and assigns its top and bottom properties
    TimeGrid.prototype.computeSegVerticals = function (segs) {
        var eventMinHeight = this.opt('agendaEventMinHeight');
        var i;
        var seg;
        var dayDate;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            dayDate = this.dayDates[seg.dayIndex];
            seg.top = this.computeDateTop(seg.startMs, dayDate);
            seg.bottom = Math.max(seg.top + eventMinHeight, this.computeDateTop(seg.endMs, dayDate));
        }
    };
    // Given segments that already have their top/bottom properties computed, applies those values to
    // the segments' elements.
    TimeGrid.prototype.assignSegVerticals = function (segs) {
        var i;
        var seg;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            seg.el.css(this.generateSegVerticalCss(seg));
        }
    };
    // Generates an object with CSS properties for the top/bottom coordinates of a segment element
    TimeGrid.prototype.generateSegVerticalCss = function (seg) {
        return {
            top: seg.top,
            bottom: -seg.bottom // flipped because needs to be space beyond bottom edge of event container
        };
    };
    /* Hit System
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.prepareHits = function () {
        this.colCoordCache.build();
        this.slatCoordCache.build();
    };
    TimeGrid.prototype.releaseHits = function () {
        this.colCoordCache.clear();
        // NOTE: don't clear slatCoordCache because we rely on it for computeTimeTop
    };
    TimeGrid.prototype.queryHit = function (leftOffset, topOffset) {
        var snapsPerSlot = this.snapsPerSlot;
        var colCoordCache = this.colCoordCache;
        var slatCoordCache = this.slatCoordCache;
        if (colCoordCache.isLeftInBounds(leftOffset) && slatCoordCache.isTopInBounds(topOffset)) {
            var colIndex = colCoordCache.getHorizontalIndex(leftOffset);
            var slatIndex = slatCoordCache.getVerticalIndex(topOffset);
            if (colIndex != null && slatIndex != null) {
                var slatTop = slatCoordCache.getTopOffset(slatIndex);
                var slatHeight = slatCoordCache.getHeight(slatIndex);
                var partial = (topOffset - slatTop) / slatHeight; // floating point number between 0 and 1
                var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
                var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
                var snapTop = slatTop + (localSnapIndex / snapsPerSlot) * slatHeight;
                var snapBottom = slatTop + ((localSnapIndex + 1) / snapsPerSlot) * slatHeight;
                return {
                    col: colIndex,
                    snap: snapIndex,
                    component: this,
                    left: colCoordCache.getLeftOffset(colIndex),
                    right: colCoordCache.getRightOffset(colIndex),
                    top: snapTop,
                    bottom: snapBottom
                };
            }
        }
    };
    TimeGrid.prototype.getHitFootprint = function (hit) {
        var start = this.getCellDate(0, hit.col); // row=0
        var time = this.computeSnapTime(hit.snap); // pass in the snap-index
        var end;
        start.time(time);
        end = start.clone().add(this.snapDuration);
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), false // all-day?
        );
    };
    // Given a row number of the grid, representing a "snap", returns a time (Duration) from its start-of-day
    TimeGrid.prototype.computeSnapTime = function (snapIndex) {
        return moment.duration(this.dateProfile.minTime + this.snapDuration * snapIndex);
    };
    TimeGrid.prototype.getHitEl = function (hit) {
        return this.colEls.eq(hit.col);
    };
    /* Event Drag Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being dragged over the specified date(s).
    // A returned value of `true` signals that a mock "helper" event has been rendered.
    TimeGrid.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        var i;
        if (seg) {
            if (eventFootprints.length) {
                this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch);
                // signal that a helper has been rendered
                return true;
            }
        }
        else {
            for (i = 0; i < eventFootprints.length; i++) {
                this.renderHighlight(eventFootprints[i].componentFootprint);
            }
        }
    };
    // Unrenders any visual indication of an event being dragged
    TimeGrid.prototype.unrenderDrag = function () {
        this.unrenderHighlight();
        this.helperRenderer.unrender();
    };
    /* Event Resize Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being resized
    TimeGrid.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
    };
    // Unrenders any visual indication of an event being resized
    TimeGrid.prototype.unrenderEventResize = function () {
        this.helperRenderer.unrender();
    };
    /* Selection
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of a selection. Overrides the default, which was to simply render a highlight.
    TimeGrid.prototype.renderSelectionFootprint = function (componentFootprint) {
        if (this.opt('selectHelper')) {
            this.helperRenderer.renderComponentFootprint(componentFootprint);
        }
        else {
            this.renderHighlight(componentFootprint);
        }
    };
    // Unrenders any visual indication of a selection
    TimeGrid.prototype.unrenderSelection = function () {
        this.helperRenderer.unrender();
        this.unrenderHighlight();
    };
    return TimeGrid;
}(InteractiveDateComponent_1.default));
exports.default = TimeGrid;
TimeGrid.prototype.eventRendererClass = TimeGridEventRenderer_1.default;
TimeGrid.prototype.businessHourRendererClass = BusinessHourRenderer_1.default;
TimeGrid.prototype.helperRendererClass = TimeGridHelperRenderer_1.default;
TimeGrid.prototype.fillRendererClass = TimeGridFillRenderer_1.default;
StandardInteractionsMixin_1.default.mixInto(TimeGrid);
DayTableMixin_1.default.mixInto(TimeGrid);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var UnzonedRange_1 = __webpack_require__(5);
var DateProfileGenerator_1 = __webpack_require__(221);
var BasicViewDateProfileGenerator = /** @class */ (function (_super) {
    tslib_1.__extends(BasicViewDateProfileGenerator, _super);
    function BasicViewDateProfileGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Computes the date range that will be rendered.
    BasicViewDateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
        var renderUnzonedRange = _super.prototype.buildRenderRange.call(this, currentUnzonedRange, currentRangeUnit, isRangeAllDay); // an UnzonedRange
        var start = this.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
        var end = this.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay);
        // year and month views should be aligned with weeks. this is already done for week
        if (/^(year|month)$/.test(currentRangeUnit)) {
            start.startOf('week');
            // make end-of-week if not already
            if (end.weekday()) {
                end.add(1, 'week').startOf('week'); // exclusively move backwards
            }
        }
        return new UnzonedRange_1.default(start, end);
    };
    return BasicViewDateProfileGenerator;
}(DateProfileGenerator_1.default));
exports.default = BasicViewDateProfileGenerator;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var moment = __webpack_require__(0);
var util_1 = __webpack_require__(4);
var BasicView_1 = __webpack_require__(62);
var MonthViewDateProfileGenerator_1 = __webpack_require__(253);
/* A month view with day cells running in rows (one-per-week) and columns
----------------------------------------------------------------------------------------------------------------------*/
var MonthView = /** @class */ (function (_super) {
    tslib_1.__extends(MonthView, _super);
    function MonthView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Overrides the default BasicView behavior to have special multi-week auto-height logic
    MonthView.prototype.setGridHeight = function (height, isAuto) {
        // if auto, make the height of each row the height that it would be if there were 6 weeks
        if (isAuto) {
            height *= this.dayGrid.rowCnt / 6;
        }
        util_1.distributeHeight(this.dayGrid.rowEls, height, !isAuto); // if auto, don't compensate for height-hogging rows
    };
    MonthView.prototype.isDateInOtherMonth = function (date, dateProfile) {
        return date.month() !== moment.utc(dateProfile.currentUnzonedRange.startMs).month(); // TODO: optimize
    };
    return MonthView;
}(BasicView_1.default));
exports.default = MonthView;
MonthView.prototype.dateProfileGeneratorClass = MonthViewDateProfileGenerator_1.default;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var UnzonedRange_1 = __webpack_require__(5);
var View_1 = __webpack_require__(41);
var Scroller_1 = __webpack_require__(39);
var ListEventRenderer_1 = __webpack_require__(254);
var ListEventPointing_1 = __webpack_require__(255);
/*
Responsible for the scroller, and forwarding event-related actions into the "grid".
*/
var ListView = /** @class */ (function (_super) {
    tslib_1.__extends(ListView, _super);
    function ListView(calendar, viewSpec) {
        var _this = _super.call(this, calendar, viewSpec) || this;
        _this.segSelector = '.fc-list-item'; // which elements accept event actions
        _this.scroller = new Scroller_1.default({
            overflowX: 'hidden',
            overflowY: 'auto'
        });
        return _this;
    }
    ListView.prototype.renderSkeleton = function () {
        this.el.addClass('fc-list-view ' +
            this.calendar.theme.getClass('listView'));
        this.scroller.render();
        this.scroller.el.appendTo(this.el);
        this.contentEl = this.scroller.scrollEl; // shortcut
    };
    ListView.prototype.unrenderSkeleton = function () {
        this.scroller.destroy(); // will remove the Grid too
    };
    ListView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        this.scroller.setHeight(this.computeScrollerHeight(totalHeight));
    };
    ListView.prototype.computeScrollerHeight = function (totalHeight) {
        return totalHeight -
            util_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    };
    ListView.prototype.renderDates = function (dateProfile) {
        var calendar = this.calendar;
        var dayStart = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs, true);
        var viewEnd = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.endMs, true);
        var dayDates = [];
        var dayRanges = [];
        while (dayStart < viewEnd) {
            dayDates.push(dayStart.clone());
            dayRanges.push(new UnzonedRange_1.default(dayStart, dayStart.clone().add(1, 'day')));
            dayStart.add(1, 'day');
        }
        this.dayDates = dayDates;
        this.dayRanges = dayRanges;
        // all real rendering happens in EventRenderer
    };
    // slices by day
    ListView.prototype.componentFootprintToSegs = function (footprint) {
        var dayRanges = this.dayRanges;
        var dayIndex;
        var segRange;
        var seg;
        var segs = [];
        for (dayIndex = 0; dayIndex < dayRanges.length; dayIndex++) {
            segRange = footprint.unzonedRange.intersect(dayRanges[dayIndex]);
            if (segRange) {
                seg = {
                    startMs: segRange.startMs,
                    endMs: segRange.endMs,
                    isStart: segRange.isStart,
                    isEnd: segRange.isEnd,
                    dayIndex: dayIndex
                };
                segs.push(seg);
                // detect when footprint won't go fully into the next day,
                // and mutate the latest seg to the be the end.
                if (!seg.isEnd && !footprint.isAllDay &&
                    dayIndex + 1 < dayRanges.length &&
                    footprint.unzonedRange.endMs < dayRanges[dayIndex + 1].startMs + this.nextDayThreshold) {
                    seg.endMs = footprint.unzonedRange.endMs;
                    seg.isEnd = true;
                    break;
                }
            }
        }
        return segs;
    };
    ListView.prototype.renderEmptyMessage = function () {
        this.contentEl.html('<div class="fc-list-empty-wrap2">' + // TODO: try less wraps
            '<div class="fc-list-empty-wrap1">' +
            '<div class="fc-list-empty">' +
            util_1.htmlEscape(this.opt('noEventsMessage')) +
            '</div>' +
            '</div>' +
            '</div>');
    };
    // render the event segments in the view
    ListView.prototype.renderSegList = function (allSegs) {
        var segsByDay = this.groupSegsByDay(allSegs); // sparse array
        var dayIndex;
        var daySegs;
        var i;
        var tableEl = $('<table class="fc-list-table ' + this.calendar.theme.getClass('tableList') + '"><tbody/></table>');
        var tbodyEl = tableEl.find('tbody');
        for (dayIndex = 0; dayIndex < segsByDay.length; dayIndex++) {
            daySegs = segsByDay[dayIndex];
            if (daySegs) {
                // append a day header
                tbodyEl.append(this.dayHeaderHtml(this.dayDates[dayIndex]));
                this.eventRenderer.sortEventSegs(daySegs);
                for (i = 0; i < daySegs.length; i++) {
                    tbodyEl.append(daySegs[i].el); // append event row
                }
            }
        }
        this.contentEl.empty().append(tableEl);
    };
    // Returns a sparse array of arrays, segs grouped by their dayIndex
    ListView.prototype.groupSegsByDay = function (segs) {
        var segsByDay = []; // sparse array
        var i;
        var seg;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            (segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = []))
                .push(seg);
        }
        return segsByDay;
    };
    // generates the HTML for the day headers that live amongst the event rows
    ListView.prototype.dayHeaderHtml = function (dayDate) {
        var mainFormat = this.opt('listDayFormat');
        var altFormat = this.opt('listDayAltFormat');
        return '<tr class="fc-list-heading" data-date="' + dayDate.format('YYYY-MM-DD') + '">' +
            '<td class="' + this.calendar.theme.getClass('widgetHeader') + '" colspan="3">' +
            (mainFormat ?
                this.buildGotoAnchorHtml(dayDate, { 'class': 'fc-list-heading-main' }, util_1.htmlEscape(dayDate.format(mainFormat)) // inner HTML
                ) :
                '') +
            (altFormat ?
                this.buildGotoAnchorHtml(dayDate, { 'class': 'fc-list-heading-alt' }, util_1.htmlEscape(dayDate.format(altFormat)) // inner HTML
                ) :
                '') +
            '</td>' +
            '</tr>';
    };
    return ListView;
}(View_1.default));
exports.default = ListView;
ListView.prototype.eventRendererClass = ListEventRenderer_1.default;
ListView.prototype.eventPointingClass = ListEventPointing_1.default;


/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var exportHooks = __webpack_require__(16);
var util_1 = __webpack_require__(4);
var Calendar_1 = __webpack_require__(220);
// for intentional side-effects
__webpack_require__(10);
__webpack_require__(47);
__webpack_require__(256);
__webpack_require__(257);
__webpack_require__(259);
__webpack_require__(260);
__webpack_require__(261);
__webpack_require__(262);
$.fullCalendar = exportHooks;
$.fn.fullCalendar = function (options) {
    var args = Array.prototype.slice.call(arguments, 1); // for a possible method call
    var res = this; // what this function will return (this jQuery object by default)
    this.each(function (i, _element) {
        var element = $(_element);
        var calendar = element.data('fullCalendar'); // get the existing calendar object (if any)
        var singleRes; // the returned value of this single method call
        // a method call
        if (typeof options === 'string') {
            if (options === 'getCalendar') {
                if (!i) {
                    res = calendar;
                }
            }
            else if (options === 'destroy') {
                if (calendar) {
                    calendar.destroy();
                    element.removeData('fullCalendar');
                }
            }
            else if (!calendar) {
                util_1.warn('Attempting to call a FullCalendar method on an element with no calendar.');
            }
            else if ($.isFunction(calendar[options])) {
                singleRes = calendar[options].apply(calendar, args);
                if (!i) {
                    res = singleRes; // record the first method call result
                }
                if (options === 'destroy') {
                    element.removeData('fullCalendar');
                }
            }
            else {
                util_1.warn("'" + options + "' is an unknown FullCalendar method.");
            }
        }
        else if (!calendar) {
            calendar = new Calendar_1.default(element, options);
            element.data('fullCalendar', calendar);
            calendar.render();
        }
    });
    return res;
};
module.exports = exportHooks;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Model_1 = __webpack_require__(48);
var Component = /** @class */ (function (_super) {
    tslib_1.__extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Component.prototype.setElement = function (el) {
        this.el = el;
        this.bindGlobalHandlers();
        this.renderSkeleton();
        this.set('isInDom', true);
    };
    Component.prototype.removeElement = function () {
        this.unset('isInDom');
        this.unrenderSkeleton();
        this.unbindGlobalHandlers();
        this.el.remove();
        // NOTE: don't null-out this.el in case the View was destroyed within an API callback.
        // We don't null-out the View's other jQuery element references upon destroy,
        //  so we shouldn't kill this.el either.
    };
    Component.prototype.bindGlobalHandlers = function () {
        // subclasses can override
    };
    Component.prototype.unbindGlobalHandlers = function () {
        // subclasses can override
    };
    /*
    NOTE: Can't have a `render` method. Read the deprecation notice in View::executeDateRender
    */
    // Renders the basic structure of the view before any content is rendered
    Component.prototype.renderSkeleton = function () {
        // subclasses should implement
    };
    // Unrenders the basic structure of the view
    Component.prototype.unrenderSkeleton = function () {
        // subclasses should implement
    };
    return Component;
}(Model_1.default));
exports.default = Component;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Iterator = /** @class */ (function () {
    function Iterator(items) {
        this.items = items || [];
    }
    /* Calls a method on every item passing the arguments through */
    Iterator.prototype.proxyCall = function (methodName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var results = [];
        this.items.forEach(function (item) {
            results.push(item[methodName].apply(item, args));
        });
        return results;
    };
    return Iterator;
}());
exports.default = Iterator;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
/* Toolbar with buttons and title
----------------------------------------------------------------------------------------------------------------------*/
var Toolbar = /** @class */ (function () {
    function Toolbar(calendar, toolbarOptions) {
        this.el = null; // mirrors local `el`
        this.viewsWithButtons = [];
        this.calendar = calendar;
        this.toolbarOptions = toolbarOptions;
    }
    // method to update toolbar-specific options, not calendar-wide options
    Toolbar.prototype.setToolbarOptions = function (newToolbarOptions) {
        this.toolbarOptions = newToolbarOptions;
    };
    // can be called repeatedly and will rerender
    Toolbar.prototype.render = function () {
        var sections = this.toolbarOptions.layout;
        var el = this.el;
        if (sections) {
            if (!el) {
                el = this.el = $("<div class='fc-toolbar " + this.toolbarOptions.extraClasses + "'/>");
            }
            else {
                el.empty();
            }
            el.append(this.renderSection('left'))
                .append(this.renderSection('right'))
                .append(this.renderSection('center'))
                .append('<div class="fc-clear"/>');
        }
        else {
            this.removeElement();
        }
    };
    Toolbar.prototype.removeElement = function () {
        if (this.el) {
            this.el.remove();
            this.el = null;
        }
    };
    Toolbar.prototype.renderSection = function (position) {
        var _this = this;
        var calendar = this.calendar;
        var theme = calendar.theme;
        var optionsManager = calendar.optionsManager;
        var viewSpecManager = calendar.viewSpecManager;
        var sectionEl = $('<div class="fc-' + position + '"/>');
        var buttonStr = this.toolbarOptions.layout[position];
        var calendarCustomButtons = optionsManager.get('customButtons') || {};
        var calendarButtonTextOverrides = optionsManager.overrides.buttonText || {};
        var calendarButtonText = optionsManager.get('buttonText') || {};
        if (buttonStr) {
            $.each(buttonStr.split(' '), function (i, buttonGroupStr) {
                var groupChildren = $();
                var isOnlyButtons = true;
                var groupEl;
                $.each(buttonGroupStr.split(','), function (j, buttonName) {
                    var customButtonProps;
                    var viewSpec;
                    var buttonClick;
                    var buttonIcon; // only one of these will be set
                    var buttonText; // "
                    var buttonInnerHtml;
                    var buttonClasses;
                    var buttonEl;
                    var buttonAriaAttr;
                    if (buttonName === 'title') {
                        groupChildren = groupChildren.add($('<h2>&nbsp;</h2>')); // we always want it to take up height
                        isOnlyButtons = false;
                    }
                    else {
                        if ((customButtonProps = calendarCustomButtons[buttonName])) {
                            buttonClick = function (ev) {
                                if (customButtonProps.click) {
                                    customButtonProps.click.call(buttonEl[0], ev);
                                }
                            };
                            (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) ||
                                (buttonIcon = theme.getIconClass(buttonName)) ||
                                (buttonText = customButtonProps.text);
                        }
                        else if ((viewSpec = viewSpecManager.getViewSpec(buttonName))) {
                            _this.viewsWithButtons.push(buttonName);
                            buttonClick = function () {
                                calendar.changeView(buttonName);
                            };
                            (buttonText = viewSpec.buttonTextOverride) ||
                                (buttonIcon = theme.getIconClass(buttonName)) ||
                                (buttonText = viewSpec.buttonTextDefault);
                        }
                        else if (calendar[buttonName]) {
                            buttonClick = function () {
                                calendar[buttonName]();
                            };
                            (buttonText = calendarButtonTextOverrides[buttonName]) ||
                                (buttonIcon = theme.getIconClass(buttonName)) ||
                                (buttonText = calendarButtonText[buttonName]);
                            //            ^ everything else is considered default
                        }
                        if (buttonClick) {
                            buttonClasses = [
                                'fc-' + buttonName + '-button',
                                theme.getClass('button'),
                                theme.getClass('stateDefault')
                            ];
                            if (buttonText) {
                                buttonInnerHtml = util_1.htmlEscape(buttonText);
                                buttonAriaAttr = '';
                            }
                            else if (buttonIcon) {
                                buttonInnerHtml = "<span class='" + buttonIcon + "'></span>";
                                buttonAriaAttr = ' aria-label="' + buttonName + '"';
                            }
                            buttonEl = $(// type="button" so that it doesn't submit a form
                            '<button type="button" class="' + buttonClasses.join(' ') + '"' +
                                buttonAriaAttr +
                                '>' + buttonInnerHtml + '</button>')
                                .click(function (ev) {
                                // don't process clicks for disabled buttons
                                if (!buttonEl.hasClass(theme.getClass('stateDisabled'))) {
                                    buttonClick(ev);
                                    // after the click action, if the button becomes the "active" tab, or disabled,
                                    // it should never have a hover class, so remove it now.
                                    if (buttonEl.hasClass(theme.getClass('stateActive')) ||
                                        buttonEl.hasClass(theme.getClass('stateDisabled'))) {
                                        buttonEl.removeClass(theme.getClass('stateHover'));
                                    }
                                }
                            })
                                .mousedown(function () {
                                // the *down* effect (mouse pressed in).
                                // only on buttons that are not the "active" tab, or disabled
                                buttonEl
                                    .not('.' + theme.getClass('stateActive'))
                                    .not('.' + theme.getClass('stateDisabled'))
                                    .addClass(theme.getClass('stateDown'));
                            })
                                .mouseup(function () {
                                // undo the *down* effect
                                buttonEl.removeClass(theme.getClass('stateDown'));
                            })
                                .hover(function () {
                                // the *hover* effect.
                                // only on buttons that are not the "active" tab, or disabled
                                buttonEl
                                    .not('.' + theme.getClass('stateActive'))
                                    .not('.' + theme.getClass('stateDisabled'))
                                    .addClass(theme.getClass('stateHover'));
                            }, function () {
                                // undo the *hover* effect
                                buttonEl
                                    .removeClass(theme.getClass('stateHover'))
                                    .removeClass(theme.getClass('stateDown')); // if mouseleave happens before mouseup
                            });
                            groupChildren = groupChildren.add(buttonEl);
                        }
                    }
                });
                if (isOnlyButtons) {
                    groupChildren
                        .first().addClass(theme.getClass('cornerLeft')).end()
                        .last().addClass(theme.getClass('cornerRight')).end();
                }
                if (groupChildren.length > 1) {
                    groupEl = $('<div/>');
                    if (isOnlyButtons) {
                        groupEl.addClass(theme.getClass('buttonGroup'));
                    }
                    groupEl.append(groupChildren);
                    sectionEl.append(groupEl);
                }
                else {
                    sectionEl.append(groupChildren); // 1 or 0 children
                }
            });
        }
        return sectionEl;
    };
    Toolbar.prototype.updateTitle = function (text) {
        if (this.el) {
            this.el.find('h2').text(text);
        }
    };
    Toolbar.prototype.activateButton = function (buttonName) {
        if (this.el) {
            this.el.find('.fc-' + buttonName + '-button')
                .addClass(this.calendar.theme.getClass('stateActive'));
        }
    };
    Toolbar.prototype.deactivateButton = function (buttonName) {
        if (this.el) {
            this.el.find('.fc-' + buttonName + '-button')
                .removeClass(this.calendar.theme.getClass('stateActive'));
        }
    };
    Toolbar.prototype.disableButton = function (buttonName) {
        if (this.el) {
            this.el.find('.fc-' + buttonName + '-button')
                .prop('disabled', true)
                .addClass(this.calendar.theme.getClass('stateDisabled'));
        }
    };
    Toolbar.prototype.enableButton = function (buttonName) {
        if (this.el) {
            this.el.find('.fc-' + buttonName + '-button')
                .prop('disabled', false)
                .removeClass(this.calendar.theme.getClass('stateDisabled'));
        }
    };
    Toolbar.prototype.getViewsWithButtons = function () {
        return this.viewsWithButtons;
    };
    return Toolbar;
}());
exports.default = Toolbar;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var options_1 = __webpack_require__(31);
var locale_1 = __webpack_require__(30);
var Model_1 = __webpack_require__(48);
var OptionsManager = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsManager, _super);
    function OptionsManager(_calendar, overrides) {
        var _this = _super.call(this) || this;
        _this._calendar = _calendar;
        _this.overrides = $.extend({}, overrides); // make a copy
        _this.dynamicOverrides = {};
        _this.compute();
        return _this;
    }
    OptionsManager.prototype.add = function (newOptionHash) {
        var optionCnt = 0;
        var optionName;
        this.recordOverrides(newOptionHash); // will trigger this model's watchers
        for (optionName in newOptionHash) {
            optionCnt++;
        }
        // special-case handling of single option change.
        // if only one option change, `optionName` will be its name.
        if (optionCnt === 1) {
            if (optionName === 'height' || optionName === 'contentHeight' || optionName === 'aspectRatio') {
                this._calendar.updateViewSize(true); // isResize=true
                return;
            }
            else if (optionName === 'defaultDate') {
                return; // can't change date this way. use gotoDate instead
            }
            else if (optionName === 'businessHours') {
                return; // this model already reacts to this
            }
            else if (/^(event|select)(Overlap|Constraint|Allow)$/.test(optionName)) {
                return; // doesn't affect rendering. only interactions.
            }
            else if (optionName === 'timezone') {
                this._calendar.view.flash('initialEvents');
                return;
            }
        }
        // catch-all. rerender the header and footer and rebuild/rerender the current view
        this._calendar.renderHeader();
        this._calendar.renderFooter();
        // even non-current views will be affected by this option change. do before rerender
        // TODO: detangle
        this._calendar.viewsByType = {};
        this._calendar.reinitView();
    };
    // Computes the flattened options hash for the calendar and assigns to `this.options`.
    // Assumes this.overrides and this.dynamicOverrides have already been initialized.
    OptionsManager.prototype.compute = function () {
        var locale;
        var localeDefaults;
        var isRTL;
        var dirDefaults;
        var rawOptions;
        locale = util_1.firstDefined(// explicit locale option given?
        this.dynamicOverrides.locale, this.overrides.locale);
        localeDefaults = locale_1.localeOptionHash[locale];
        if (!localeDefaults) {
            locale = options_1.globalDefaults.locale;
            localeDefaults = locale_1.localeOptionHash[locale] || {};
        }
        isRTL = util_1.firstDefined(// based on options computed so far, is direction RTL?
        this.dynamicOverrides.isRTL, this.overrides.isRTL, localeDefaults.isRTL, options_1.globalDefaults.isRTL);
        dirDefaults = isRTL ? options_1.rtlDefaults : {};
        this.dirDefaults = dirDefaults;
        this.localeDefaults = localeDefaults;
        rawOptions = options_1.mergeOptions([
            options_1.globalDefaults,
            dirDefaults,
            localeDefaults,
            this.overrides,
            this.dynamicOverrides
        ]);
        locale_1.populateInstanceComputableOptions(rawOptions); // fill in gaps with computed options
        this.reset(rawOptions);
    };
    // stores the new options internally, but does not rerender anything.
    OptionsManager.prototype.recordOverrides = function (newOptionHash) {
        var optionName;
        for (optionName in newOptionHash) {
            this.dynamicOverrides[optionName] = newOptionHash[optionName];
        }
        this._calendar.viewSpecManager.clearCache(); // the dynamic override invalidates the options in this cache, so just clear it
        this.compute(); // this.options needs to be recomputed after the dynamic override
    };
    return OptionsManager;
}(Model_1.default));
exports.default = OptionsManager;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var $ = __webpack_require__(3);
var ViewRegistry_1 = __webpack_require__(21);
var util_1 = __webpack_require__(4);
var options_1 = __webpack_require__(31);
var locale_1 = __webpack_require__(30);
var ViewSpecManager = /** @class */ (function () {
    function ViewSpecManager(optionsManager, _calendar) {
        this.optionsManager = optionsManager;
        this._calendar = _calendar;
        this.clearCache();
    }
    ViewSpecManager.prototype.clearCache = function () {
        this.viewSpecCache = {};
    };
    // Gets information about how to create a view. Will use a cache.
    ViewSpecManager.prototype.getViewSpec = function (viewType) {
        var cache = this.viewSpecCache;
        return cache[viewType] || (cache[viewType] = this.buildViewSpec(viewType));
    };
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    ViewSpecManager.prototype.getUnitViewSpec = function (unit) {
        var viewTypes;
        var i;
        var spec;
        if ($.inArray(unit, util_1.unitsDesc) !== -1) {
            // put views that have buttons first. there will be duplicates, but oh well
            viewTypes = this._calendar.header.getViewsWithButtons(); // TODO: include footer as well?
            $.each(ViewRegistry_1.viewHash, function (viewType) {
                viewTypes.push(viewType);
            });
            for (i = 0; i < viewTypes.length; i++) {
                spec = this.getViewSpec(viewTypes[i]);
                if (spec) {
                    if (spec.singleUnit === unit) {
                        return spec;
                    }
                }
            }
        }
    };
    // Builds an object with information on how to create a given view
    ViewSpecManager.prototype.buildViewSpec = function (requestedViewType) {
        var viewOverrides = this.optionsManager.overrides.views || {};
        var specChain = []; // for the view. lowest to highest priority
        var defaultsChain = []; // for the view. lowest to highest priority
        var overridesChain = []; // for the view. lowest to highest priority
        var viewType = requestedViewType;
        var spec; // for the view
        var overrides; // for the view
        var durationInput;
        var duration;
        var unit;
        // iterate from the specific view definition to a more general one until we hit an actual View class
        while (viewType) {
            spec = ViewRegistry_1.viewHash[viewType];
            overrides = viewOverrides[viewType];
            viewType = null; // clear. might repopulate for another iteration
            if (typeof spec === 'function') {
                spec = { 'class': spec };
            }
            if (spec) {
                specChain.unshift(spec);
                defaultsChain.unshift(spec.defaults || {});
                durationInput = durationInput || spec.duration;
                viewType = viewType || spec.type;
            }
            if (overrides) {
                overridesChain.unshift(overrides); // view-specific option hashes have options at zero-level
                durationInput = durationInput || overrides.duration;
                viewType = viewType || overrides.type;
            }
        }
        spec = util_1.mergeProps(specChain);
        spec.type = requestedViewType;
        if (!spec['class']) {
            return false;
        }
        // fall back to top-level `duration` option
        durationInput = durationInput ||
            this.optionsManager.dynamicOverrides.duration ||
            this.optionsManager.overrides.duration;
        if (durationInput) {
            duration = moment.duration(durationInput);
            if (duration.valueOf()) {
                unit = util_1.computeDurationGreatestUnit(duration, durationInput);
                spec.duration = duration;
                spec.durationUnit = unit;
                // view is a single-unit duration, like "week" or "day"
                // incorporate options for this. lowest priority
                if (duration.as(unit) === 1) {
                    spec.singleUnit = unit;
                    overridesChain.unshift(viewOverrides[unit] || {});
                }
            }
        }
        spec.defaults = options_1.mergeOptions(defaultsChain);
        spec.overrides = options_1.mergeOptions(overridesChain);
        this.buildViewSpecOptions(spec);
        this.buildViewSpecButtonText(spec, requestedViewType);
        return spec;
    };
    // Builds and assigns a view spec's options object from its already-assigned defaults and overrides
    ViewSpecManager.prototype.buildViewSpecOptions = function (spec) {
        var optionsManager = this.optionsManager;
        spec.options = options_1.mergeOptions([
            options_1.globalDefaults,
            spec.defaults,
            optionsManager.dirDefaults,
            optionsManager.localeDefaults,
            optionsManager.overrides,
            spec.overrides,
            optionsManager.dynamicOverrides // dynamically set via setter. highest precedence
        ]);
        locale_1.populateInstanceComputableOptions(spec.options);
    };
    // Computes and assigns a view spec's buttonText-related options
    ViewSpecManager.prototype.buildViewSpecButtonText = function (spec, requestedViewType) {
        var optionsManager = this.optionsManager;
        // given an options object with a possible `buttonText` hash, lookup the buttonText for the
        // requested view, falling back to a generic unit entry like "week" or "day"
        function queryButtonText(options) {
            var buttonText = options.buttonText || {};
            return buttonText[requestedViewType] ||
                // view can decide to look up a certain key
                (spec.buttonTextKey ? buttonText[spec.buttonTextKey] : null) ||
                // a key like "month"
                (spec.singleUnit ? buttonText[spec.singleUnit] : null);
        }
        // highest to lowest priority
        spec.buttonTextOverride =
            queryButtonText(optionsManager.dynamicOverrides) ||
                queryButtonText(optionsManager.overrides) || // constructor-specified buttonText lookup hash takes precedence
                spec.overrides.buttonText; // `buttonText` for view-specific options is a string
        // highest to lowest priority. mirrors buildViewSpecOptions
        spec.buttonTextDefault =
            queryButtonText(optionsManager.localeDefaults) ||
                queryButtonText(optionsManager.dirDefaults) ||
                spec.defaults.buttonText || // a single string. from ViewSubclass.defaults
                queryButtonText(options_1.globalDefaults) ||
                (spec.duration ? this._calendar.humanizeDuration(spec.duration) : null) || // like "3 days"
                requestedViewType; // fall back to given view name
    };
    return ViewSpecManager;
}());
exports.default = ViewSpecManager;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var EventPeriod_1 = __webpack_require__(243);
var ArrayEventSource_1 = __webpack_require__(52);
var EventSource_1 = __webpack_require__(6);
var EventSourceParser_1 = __webpack_require__(37);
var SingleEventDef_1 = __webpack_require__(13);
var EventInstanceGroup_1 = __webpack_require__(18);
var EmitterMixin_1 = __webpack_require__(11);
var ListenerMixin_1 = __webpack_require__(7);
var EventManager = /** @class */ (function () {
    function EventManager(calendar) {
        this.calendar = calendar;
        this.stickySource = new ArrayEventSource_1.default(calendar);
        this.otherSources = [];
    }
    EventManager.prototype.requestEvents = function (start, end, timezone, force) {
        if (force ||
            !this.currentPeriod ||
            !this.currentPeriod.isWithinRange(start, end) ||
            timezone !== this.currentPeriod.timezone) {
            this.setPeriod(// will change this.currentPeriod
            new EventPeriod_1.default(start, end, timezone));
        }
        return this.currentPeriod.whenReleased();
    };
    // Source Adding/Removing
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.addSource = function (eventSource) {
        this.otherSources.push(eventSource);
        if (this.currentPeriod) {
            this.currentPeriod.requestSource(eventSource); // might release
        }
    };
    EventManager.prototype.removeSource = function (doomedSource) {
        util_1.removeExact(this.otherSources, doomedSource);
        if (this.currentPeriod) {
            this.currentPeriod.purgeSource(doomedSource); // might release
        }
    };
    EventManager.prototype.removeAllSources = function () {
        this.otherSources = [];
        if (this.currentPeriod) {
            this.currentPeriod.purgeAllSources(); // might release
        }
    };
    // Source Refetching
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.refetchSource = function (eventSource) {
        var currentPeriod = this.currentPeriod;
        if (currentPeriod) {
            currentPeriod.freeze();
            currentPeriod.purgeSource(eventSource);
            currentPeriod.requestSource(eventSource);
            currentPeriod.thaw();
        }
    };
    EventManager.prototype.refetchAllSources = function () {
        var currentPeriod = this.currentPeriod;
        if (currentPeriod) {
            currentPeriod.freeze();
            currentPeriod.purgeAllSources();
            currentPeriod.requestSources(this.getSources());
            currentPeriod.thaw();
        }
    };
    // Source Querying
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.getSources = function () {
        return [this.stickySource].concat(this.otherSources);
    };
    // like querySources, but accepts multple match criteria (like multiple IDs)
    EventManager.prototype.multiQuerySources = function (matchInputs) {
        // coerce into an array
        if (!matchInputs) {
            matchInputs = [];
        }
        else if (!$.isArray(matchInputs)) {
            matchInputs = [matchInputs];
        }
        var matchingSources = [];
        var i;
        // resolve raw inputs to real event source objects
        for (i = 0; i < matchInputs.length; i++) {
            matchingSources.push.apply(// append
            matchingSources, this.querySources(matchInputs[i]));
        }
        return matchingSources;
    };
    // matchInput can either by a real event source object, an ID, or the function/URL for the source.
    // returns an array of matching source objects.
    EventManager.prototype.querySources = function (matchInput) {
        var sources = this.otherSources;
        var i;
        var source;
        // given a proper event source object
        for (i = 0; i < sources.length; i++) {
            source = sources[i];
            if (source === matchInput) {
                return [source];
            }
        }
        // an ID match
        source = this.getSourceById(EventSource_1.default.normalizeId(matchInput));
        if (source) {
            return [source];
        }
        // parse as an event source
        matchInput = EventSourceParser_1.default.parse(matchInput, this.calendar);
        if (matchInput) {
            return $.grep(sources, function (source) {
                return isSourcesEquivalent(matchInput, source);
            });
        }
    };
    /*
    ID assumed to already be normalized
    */
    EventManager.prototype.getSourceById = function (id) {
        return $.grep(this.otherSources, function (source) {
            return source.id && source.id === id;
        })[0];
    };
    // Event-Period
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.setPeriod = function (eventPeriod) {
        if (this.currentPeriod) {
            this.unbindPeriod(this.currentPeriod);
            this.currentPeriod = null;
        }
        this.currentPeriod = eventPeriod;
        this.bindPeriod(eventPeriod);
        eventPeriod.requestSources(this.getSources());
    };
    EventManager.prototype.bindPeriod = function (eventPeriod) {
        this.listenTo(eventPeriod, 'release', function (eventsPayload) {
            this.trigger('release', eventsPayload);
        });
    };
    EventManager.prototype.unbindPeriod = function (eventPeriod) {
        this.stopListeningTo(eventPeriod);
    };
    // Event Getting/Adding/Removing
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.getEventDefByUid = function (uid) {
        if (this.currentPeriod) {
            return this.currentPeriod.getEventDefByUid(uid);
        }
    };
    EventManager.prototype.addEventDef = function (eventDef, isSticky) {
        if (isSticky) {
            this.stickySource.addEventDef(eventDef);
        }
        if (this.currentPeriod) {
            this.currentPeriod.addEventDef(eventDef); // might release
        }
    };
    EventManager.prototype.removeEventDefsById = function (eventId) {
        this.getSources().forEach(function (eventSource) {
            eventSource.removeEventDefsById(eventId);
        });
        if (this.currentPeriod) {
            this.currentPeriod.removeEventDefsById(eventId); // might release
        }
    };
    EventManager.prototype.removeAllEventDefs = function () {
        this.getSources().forEach(function (eventSource) {
            eventSource.removeAllEventDefs();
        });
        if (this.currentPeriod) {
            this.currentPeriod.removeAllEventDefs();
        }
    };
    // Event Mutating
    // -----------------------------------------------------------------------------------------------------------------
    /*
    Returns an undo function.
    */
    EventManager.prototype.mutateEventsWithId = function (eventDefId, eventDefMutation) {
        var currentPeriod = this.currentPeriod;
        var eventDefs;
        var undoFuncs = [];
        if (currentPeriod) {
            currentPeriod.freeze();
            eventDefs = currentPeriod.getEventDefsById(eventDefId);
            eventDefs.forEach(function (eventDef) {
                // add/remove esp because id might change
                currentPeriod.removeEventDef(eventDef);
                undoFuncs.push(eventDefMutation.mutateSingle(eventDef));
                currentPeriod.addEventDef(eventDef);
            });
            currentPeriod.thaw();
            return function () {
                currentPeriod.freeze();
                for (var i = 0; i < eventDefs.length; i++) {
                    currentPeriod.removeEventDef(eventDefs[i]);
                    undoFuncs[i]();
                    currentPeriod.addEventDef(eventDefs[i]);
                }
                currentPeriod.thaw();
            };
        }
        return function () { };
    };
    /*
    copies and then mutates
    */
    EventManager.prototype.buildMutatedEventInstanceGroup = function (eventDefId, eventDefMutation) {
        var eventDefs = this.getEventDefsById(eventDefId);
        var i;
        var defCopy;
        var allInstances = [];
        for (i = 0; i < eventDefs.length; i++) {
            defCopy = eventDefs[i].clone();
            if (defCopy instanceof SingleEventDef_1.default) {
                eventDefMutation.mutateSingle(defCopy);
                allInstances.push.apply(allInstances, // append
                defCopy.buildInstances());
            }
        }
        return new EventInstanceGroup_1.default(allInstances);
    };
    // Freezing
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.freeze = function () {
        if (this.currentPeriod) {
            this.currentPeriod.freeze();
        }
    };
    EventManager.prototype.thaw = function () {
        if (this.currentPeriod) {
            this.currentPeriod.thaw();
        }
    };
    // methods that simply forward to EventPeriod
    EventManager.prototype.getEventDefsById = function (eventDefId) {
        return this.currentPeriod.getEventDefsById(eventDefId);
    };
    EventManager.prototype.getEventInstances = function () {
        return this.currentPeriod.getEventInstances();
    };
    EventManager.prototype.getEventInstancesWithId = function (eventDefId) {
        return this.currentPeriod.getEventInstancesWithId(eventDefId);
    };
    EventManager.prototype.getEventInstancesWithoutId = function (eventDefId) {
        return this.currentPeriod.getEventInstancesWithoutId(eventDefId);
    };
    return EventManager;
}());
exports.default = EventManager;
EmitterMixin_1.default.mixInto(EventManager);
ListenerMixin_1.default.mixInto(EventManager);
function isSourcesEquivalent(source0, source1) {
    return source0.getPrimitive() === source1.getPrimitive();
}


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var Promise_1 = __webpack_require__(19);
var EmitterMixin_1 = __webpack_require__(11);
var UnzonedRange_1 = __webpack_require__(5);
var EventInstanceGroup_1 = __webpack_require__(18);
var EventPeriod = /** @class */ (function () {
    function EventPeriod(start, end, timezone) {
        this.pendingCnt = 0;
        this.freezeDepth = 0;
        this.stuntedReleaseCnt = 0;
        this.releaseCnt = 0;
        this.start = start;
        this.end = end;
        this.timezone = timezone;
        this.unzonedRange = new UnzonedRange_1.default(start.clone().stripZone(), end.clone().stripZone());
        this.requestsByUid = {};
        this.eventDefsByUid = {};
        this.eventDefsById = {};
        this.eventInstanceGroupsById = {};
    }
    EventPeriod.prototype.isWithinRange = function (start, end) {
        // TODO: use a range util function?
        return !start.isBefore(this.start) && !end.isAfter(this.end);
    };
    // Requesting and Purging
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.requestSources = function (sources) {
        this.freeze();
        for (var i = 0; i < sources.length; i++) {
            this.requestSource(sources[i]);
        }
        this.thaw();
    };
    EventPeriod.prototype.requestSource = function (source) {
        var _this = this;
        var request = { source: source, status: 'pending', eventDefs: null };
        this.requestsByUid[source.uid] = request;
        this.pendingCnt += 1;
        source.fetch(this.start, this.end, this.timezone).then(function (eventDefs) {
            if (request.status !== 'cancelled') {
                request.status = 'completed';
                request.eventDefs = eventDefs;
                _this.addEventDefs(eventDefs);
                _this.pendingCnt--;
                _this.tryRelease();
            }
        }, function () {
            if (request.status !== 'cancelled') {
                request.status = 'failed';
                _this.pendingCnt--;
                _this.tryRelease();
            }
        });
    };
    EventPeriod.prototype.purgeSource = function (source) {
        var request = this.requestsByUid[source.uid];
        if (request) {
            delete this.requestsByUid[source.uid];
            if (request.status === 'pending') {
                request.status = 'cancelled';
                this.pendingCnt--;
                this.tryRelease();
            }
            else if (request.status === 'completed') {
                request.eventDefs.forEach(this.removeEventDef.bind(this));
            }
        }
    };
    EventPeriod.prototype.purgeAllSources = function () {
        var requestsByUid = this.requestsByUid;
        var uid;
        var request;
        var completedCnt = 0;
        for (uid in requestsByUid) {
            request = requestsByUid[uid];
            if (request.status === 'pending') {
                request.status = 'cancelled';
            }
            else if (request.status === 'completed') {
                completedCnt++;
            }
        }
        this.requestsByUid = {};
        this.pendingCnt = 0;
        if (completedCnt) {
            this.removeAllEventDefs(); // might release
        }
    };
    // Event Definitions
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.getEventDefByUid = function (eventDefUid) {
        return this.eventDefsByUid[eventDefUid];
    };
    EventPeriod.prototype.getEventDefsById = function (eventDefId) {
        var a = this.eventDefsById[eventDefId];
        if (a) {
            return a.slice(); // clone
        }
        return [];
    };
    EventPeriod.prototype.addEventDefs = function (eventDefs) {
        for (var i = 0; i < eventDefs.length; i++) {
            this.addEventDef(eventDefs[i]);
        }
    };
    EventPeriod.prototype.addEventDef = function (eventDef) {
        var eventDefsById = this.eventDefsById;
        var eventDefId = eventDef.id;
        var eventDefs = eventDefsById[eventDefId] || (eventDefsById[eventDefId] = []);
        var eventInstances = eventDef.buildInstances(this.unzonedRange);
        var i;
        eventDefs.push(eventDef);
        this.eventDefsByUid[eventDef.uid] = eventDef;
        for (i = 0; i < eventInstances.length; i++) {
            this.addEventInstance(eventInstances[i], eventDefId);
        }
    };
    EventPeriod.prototype.removeEventDefsById = function (eventDefId) {
        var _this = this;
        this.getEventDefsById(eventDefId).forEach(function (eventDef) {
            _this.removeEventDef(eventDef);
        });
    };
    EventPeriod.prototype.removeAllEventDefs = function () {
        var isEmpty = $.isEmptyObject(this.eventDefsByUid);
        this.eventDefsByUid = {};
        this.eventDefsById = {};
        this.eventInstanceGroupsById = {};
        if (!isEmpty) {
            this.tryRelease();
        }
    };
    EventPeriod.prototype.removeEventDef = function (eventDef) {
        var eventDefsById = this.eventDefsById;
        var eventDefs = eventDefsById[eventDef.id];
        delete this.eventDefsByUid[eventDef.uid];
        if (eventDefs) {
            util_1.removeExact(eventDefs, eventDef);
            if (!eventDefs.length) {
                delete eventDefsById[eventDef.id];
            }
            this.removeEventInstancesForDef(eventDef);
        }
    };
    // Event Instances
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.getEventInstances = function () {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var eventInstances = [];
        var id;
        for (id in eventInstanceGroupsById) {
            eventInstances.push.apply(eventInstances, // append
            eventInstanceGroupsById[id].eventInstances);
        }
        return eventInstances;
    };
    EventPeriod.prototype.getEventInstancesWithId = function (eventDefId) {
        var eventInstanceGroup = this.eventInstanceGroupsById[eventDefId];
        if (eventInstanceGroup) {
            return eventInstanceGroup.eventInstances.slice(); // clone
        }
        return [];
    };
    EventPeriod.prototype.getEventInstancesWithoutId = function (eventDefId) {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var matchingInstances = [];
        var id;
        for (id in eventInstanceGroupsById) {
            if (id !== eventDefId) {
                matchingInstances.push.apply(matchingInstances, // append
                eventInstanceGroupsById[id].eventInstances);
            }
        }
        return matchingInstances;
    };
    EventPeriod.prototype.addEventInstance = function (eventInstance, eventDefId) {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var eventInstanceGroup = eventInstanceGroupsById[eventDefId] ||
            (eventInstanceGroupsById[eventDefId] = new EventInstanceGroup_1.default());
        eventInstanceGroup.eventInstances.push(eventInstance);
        this.tryRelease();
    };
    EventPeriod.prototype.removeEventInstancesForDef = function (eventDef) {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var eventInstanceGroup = eventInstanceGroupsById[eventDef.id];
        var removeCnt;
        if (eventInstanceGroup) {
            removeCnt = util_1.removeMatching(eventInstanceGroup.eventInstances, function (currentEventInstance) {
                return currentEventInstance.def === eventDef;
            });
            if (!eventInstanceGroup.eventInstances.length) {
                delete eventInstanceGroupsById[eventDef.id];
            }
            if (removeCnt) {
                this.tryRelease();
            }
        }
    };
    // Releasing and Freezing
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.tryRelease = function () {
        if (!this.pendingCnt) {
            if (!this.freezeDepth) {
                this.release();
            }
            else {
                this.stuntedReleaseCnt++;
            }
        }
    };
    EventPeriod.prototype.release = function () {
        this.releaseCnt++;
        this.trigger('release', this.eventInstanceGroupsById);
    };
    EventPeriod.prototype.whenReleased = function () {
        var _this = this;
        if (this.releaseCnt) {
            return Promise_1.default.resolve(this.eventInstanceGroupsById);
        }
        else {
            return Promise_1.default.construct(function (onResolve) {
                _this.one('release', onResolve);
            });
        }
    };
    EventPeriod.prototype.freeze = function () {
        if (!(this.freezeDepth++)) {
            this.stuntedReleaseCnt = 0;
        }
    };
    EventPeriod.prototype.thaw = function () {
        if (!(--this.freezeDepth) && this.stuntedReleaseCnt && !this.pendingCnt) {
            this.release();
        }
    };
    return EventPeriod;
}());
exports.default = EventPeriod;
EmitterMixin_1.default.mixInto(EventPeriod);


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var ListenerMixin_1 = __webpack_require__(7);
/* Creates a clone of an element and lets it track the mouse as it moves
----------------------------------------------------------------------------------------------------------------------*/
var MouseFollower = /** @class */ (function () {
    function MouseFollower(sourceEl, options) {
        this.isFollowing = false;
        this.isHidden = false;
        this.isAnimating = false; // doing the revert animation?
        this.options = options = options || {};
        this.sourceEl = sourceEl;
        this.parentEl = options.parentEl ? $(options.parentEl) : sourceEl.parent(); // default to sourceEl's parent
    }
    // Causes the element to start following the mouse
    MouseFollower.prototype.start = function (ev) {
        if (!this.isFollowing) {
            this.isFollowing = true;
            this.y0 = util_1.getEvY(ev);
            this.x0 = util_1.getEvX(ev);
            this.topDelta = 0;
            this.leftDelta = 0;
            if (!this.isHidden) {
                this.updatePosition();
            }
            if (util_1.getEvIsTouch(ev)) {
                this.listenTo($(document), 'touchmove', this.handleMove);
            }
            else {
                this.listenTo($(document), 'mousemove', this.handleMove);
            }
        }
    };
    // Causes the element to stop following the mouse. If shouldRevert is true, will animate back to original position.
    // `callback` gets invoked when the animation is complete. If no animation, it is invoked immediately.
    MouseFollower.prototype.stop = function (shouldRevert, callback) {
        var _this = this;
        var revertDuration = this.options.revertDuration;
        var complete = function () {
            _this.isAnimating = false;
            _this.removeElement();
            _this.top0 = _this.left0 = null; // reset state for future updatePosition calls
            if (callback) {
                callback();
            }
        };
        if (this.isFollowing && !this.isAnimating) {
            this.isFollowing = false;
            this.stopListeningTo($(document));
            if (shouldRevert && revertDuration && !this.isHidden) {
                this.isAnimating = true;
                this.el.animate({
                    top: this.top0,
                    left: this.left0
                }, {
                    duration: revertDuration,
                    complete: complete
                });
            }
            else {
                complete();
            }
        }
    };
    // Gets the tracking element. Create it if necessary
    MouseFollower.prototype.getEl = function () {
        var el = this.el;
        if (!el) {
            el = this.el = this.sourceEl.clone()
                .addClass(this.options.additionalClass || '')
                .css({
                position: 'absolute',
                visibility: '',
                display: this.isHidden ? 'none' : '',
                margin: 0,
                right: 'auto',
                bottom: 'auto',
                width: this.sourceEl.width(),
                height: this.sourceEl.height(),
                opacity: this.options.opacity || '',
                zIndex: this.options.zIndex
            });
            // we don't want long taps or any mouse interaction causing selection/menus.
            // would use preventSelection(), but that prevents selectstart, causing problems.
            el.addClass('fc-unselectable');
            el.appendTo(this.parentEl);
        }
        return el;
    };
    // Removes the tracking element if it has already been created
    MouseFollower.prototype.removeElement = function () {
        if (this.el) {
            this.el.remove();
            this.el = null;
        }
    };
    // Update the CSS position of the tracking element
    MouseFollower.prototype.updatePosition = function () {
        var sourceOffset;
        var origin;
        this.getEl(); // ensure this.el
        // make sure origin info was computed
        if (this.top0 == null) {
            sourceOffset = this.sourceEl.offset();
            origin = this.el.offsetParent().offset();
            this.top0 = sourceOffset.top - origin.top;
            this.left0 = sourceOffset.left - origin.left;
        }
        this.el.css({
            top: this.top0 + this.topDelta,
            left: this.left0 + this.leftDelta
        });
    };
    // Gets called when the user moves the mouse
    MouseFollower.prototype.handleMove = function (ev) {
        this.topDelta = util_1.getEvY(ev) - this.y0;
        this.leftDelta = util_1.getEvX(ev) - this.x0;
        if (!this.isHidden) {
            this.updatePosition();
        }
    };
    // Temporarily makes the tracking element invisible. Can be called before following starts
    MouseFollower.prototype.hide = function () {
        if (!this.isHidden) {
            this.isHidden = true;
            if (this.el) {
                this.el.hide();
            }
        }
    };
    // Show the tracking element after it has been temporarily hidden
    MouseFollower.prototype.show = function () {
        if (this.isHidden) {
            this.isHidden = false;
            this.updatePosition();
            this.getEl().show();
        }
    };
    return MouseFollower;
}());
exports.default = MouseFollower;
ListenerMixin_1.default.mixInto(MouseFollower);


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var HitDragListener_1 = __webpack_require__(22);
var Interaction_1 = __webpack_require__(15);
var DateClicking = /** @class */ (function (_super) {
    tslib_1.__extends(DateClicking, _super);
    /*
    component must implement:
      - bindDateHandlerToEl
      - getSafeHitFootprint
      - getHitEl
    */
    function DateClicking(component) {
        var _this = _super.call(this, component) || this;
        _this.dragListener = _this.buildDragListener();
        return _this;
    }
    DateClicking.prototype.end = function () {
        this.dragListener.endInteraction();
    };
    DateClicking.prototype.bindToEl = function (el) {
        var component = this.component;
        var dragListener = this.dragListener;
        component.bindDateHandlerToEl(el, 'mousedown', function (ev) {
            if (!component.shouldIgnoreMouse()) {
                dragListener.startInteraction(ev);
            }
        });
        component.bindDateHandlerToEl(el, 'touchstart', function (ev) {
            if (!component.shouldIgnoreTouch()) {
                dragListener.startInteraction(ev);
            }
        });
    };
    // Creates a listener that tracks the user's drag across day elements, for day clicking.
    DateClicking.prototype.buildDragListener = function () {
        var _this = this;
        var component = this.component;
        var dayClickHit; // null if invalid dayClick
        var dragListener = new HitDragListener_1.default(component, {
            scroll: this.opt('dragScroll'),
            interactionStart: function () {
                dayClickHit = dragListener.origHit;
            },
            hitOver: function (hit, isOrig, origHit) {
                // if user dragged to another cell at any point, it can no longer be a dayClick
                if (!isOrig) {
                    dayClickHit = null;
                }
            },
            hitOut: function () {
                dayClickHit = null;
            },
            interactionEnd: function (ev, isCancelled) {
                var componentFootprint;
                if (!isCancelled && dayClickHit) {
                    componentFootprint = component.getSafeHitFootprint(dayClickHit);
                    if (componentFootprint) {
                        _this.view.triggerDayClick(componentFootprint, component.getHitEl(dayClickHit), ev);
                    }
                }
            }
        });
        // because dragListener won't be called with any time delay, "dragging" will begin immediately,
        // which will kill any touchmoving/scrolling. Prevent this.
        dragListener.shouldCancelTouchScroll = false;
        dragListener.scrollAlwaysKills = true;
        return dragListener;
    };
    return DateClicking;
}(Interaction_1.default));
exports.default = DateClicking;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var EventRenderer_1 = __webpack_require__(42);
/*
Only handles foreground segs.
Does not own rendering. Use for low-level util methods by TimeGrid.
*/
var TimeGridEventRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGridEventRenderer, _super);
    function TimeGridEventRenderer(timeGrid, fillRenderer) {
        var _this = _super.call(this, timeGrid, fillRenderer) || this;
        _this.timeGrid = timeGrid;
        return _this;
    }
    TimeGridEventRenderer.prototype.renderFgSegs = function (segs) {
        this.renderFgSegsIntoContainers(segs, this.timeGrid.fgContainerEls);
    };
    // Given an array of foreground segments, render a DOM element for each, computes position,
    // and attaches to the column inner-container elements.
    TimeGridEventRenderer.prototype.renderFgSegsIntoContainers = function (segs, containerEls) {
        var segsByCol;
        var col;
        segsByCol = this.timeGrid.groupSegsByCol(segs);
        for (col = 0; col < this.timeGrid.colCnt; col++) {
            this.updateFgSegCoords(segsByCol[col]);
        }
        this.timeGrid.attachSegsByCol(segsByCol, containerEls);
    };
    TimeGridEventRenderer.prototype.unrenderFgSegs = function () {
        if (this.fgSegs) {
            this.fgSegs.forEach(function (seg) {
                seg.el.remove();
            });
        }
    };
    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
    TimeGridEventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('noMeridiemTimeFormat'); // like "6:30" (no AM/PM)
    };
    // Computes a default `displayEventEnd` value if one is not expliclty defined
    TimeGridEventRenderer.prototype.computeDisplayEventEnd = function () {
        return true;
    };
    // Renders the HTML for a single event segment's default rendering
    TimeGridEventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
        var view = this.view;
        var calendar = view.calendar;
        var componentFootprint = seg.footprint.componentFootprint;
        var isAllDay = componentFootprint.isAllDay;
        var eventDef = seg.footprint.eventDef;
        var isDraggable = view.isEventDefDraggable(eventDef);
        var isResizableFromStart = !disableResizing && seg.isStart && view.isEventDefResizableFromStart(eventDef);
        var isResizableFromEnd = !disableResizing && seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
        var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
        var skinCss = util_1.cssToStr(this.getSkinCss(eventDef));
        var timeText;
        var fullTimeText; // more verbose time text. for the print stylesheet
        var startTimeText; // just the start time text
        classes.unshift('fc-time-grid-event', 'fc-v-event');
        // if the event appears to span more than one day...
        if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
            // Don't display time text on segments that run entirely through a day.
            // That would appear as midnight-midnight and would look dumb.
            // Otherwise, display the time text for the *segment's* times (like 6pm-midnight or midnight-10am)
            if (seg.isStart || seg.isEnd) {
                var zonedStart = calendar.msToMoment(seg.startMs);
                var zonedEnd = calendar.msToMoment(seg.endMs);
                timeText = this._getTimeText(zonedStart, zonedEnd, isAllDay);
                fullTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, 'LT');
                startTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, null, false); // displayEnd=false
            }
        }
        else {
            // Display the normal time text for the *event's* times
            timeText = this.getTimeText(seg.footprint);
            fullTimeText = this.getTimeText(seg.footprint, 'LT');
            startTimeText = this.getTimeText(seg.footprint, null, false); // displayEnd=false
        }
        return '<a class="' + classes.join(' ') + '"' +
            (eventDef.url ?
                ' href="' + util_1.htmlEscape(eventDef.url) + '"' :
                '') +
            (skinCss ?
                ' style="' + skinCss + '"' :
                '') +
            '>' +
            '<div class="fc-content">' +
            (timeText ?
                '<div class="fc-time"' +
                    ' data-start="' + util_1.htmlEscape(startTimeText) + '"' +
                    ' data-full="' + util_1.htmlEscape(fullTimeText) + '"' +
                    '>' +
                    '<span>' + util_1.htmlEscape(timeText) + '</span>' +
                    '</div>' :
                '') +
            (eventDef.title ?
                '<div class="fc-title">' +
                    util_1.htmlEscape(eventDef.title) +
                    '</div>' :
                '') +
            '</div>' +
            '<div class="fc-bg"/>' +
            /* TODO: write CSS for this
            (isResizableFromStart ?
              '<div class="fc-resizer fc-start-resizer" />' :
              ''
              ) +
            */
            (isResizableFromEnd ?
                '<div class="fc-resizer fc-end-resizer" />' :
                '') +
            '</a>';
    };
    // Given segments that are assumed to all live in the *same column*,
    // compute their verical/horizontal coordinates and assign to their elements.
    TimeGridEventRenderer.prototype.updateFgSegCoords = function (segs) {
        this.timeGrid.computeSegVerticals(segs); // horizontals relies on this
        this.computeFgSegHorizontals(segs); // compute horizontal coordinates, z-index's, and reorder the array
        this.timeGrid.assignSegVerticals(segs);
        this.assignFgSegHorizontals(segs);
    };
    // Given an array of segments that are all in the same column, sets the backwardCoord and forwardCoord on each.
    // NOTE: Also reorders the given array by date!
    TimeGridEventRenderer.prototype.computeFgSegHorizontals = function (segs) {
        var levels;
        var level0;
        var i;
        this.sortEventSegs(segs); // order by certain criteria
        levels = buildSlotSegLevels(segs);
        computeForwardSlotSegs(levels);
        if ((level0 = levels[0])) {
            for (i = 0; i < level0.length; i++) {
                computeSlotSegPressures(level0[i]);
            }
            for (i = 0; i < level0.length; i++) {
                this.computeFgSegForwardBack(level0[i], 0, 0);
            }
        }
    };
    // Calculate seg.forwardCoord and seg.backwardCoord for the segment, where both values range
    // from 0 to 1. If the calendar is left-to-right, the seg.backwardCoord maps to "left" and
    // seg.forwardCoord maps to "right" (via percentage). Vice-versa if the calendar is right-to-left.
    //
    // The segment might be part of a "series", which means consecutive segments with the same pressure
    // who's width is unknown until an edge has been hit. `seriesBackwardPressure` is the number of
    // segments behind this one in the current series, and `seriesBackwardCoord` is the starting
    // coordinate of the first segment in the series.
    TimeGridEventRenderer.prototype.computeFgSegForwardBack = function (seg, seriesBackwardPressure, seriesBackwardCoord) {
        var forwardSegs = seg.forwardSegs;
        var i;
        if (seg.forwardCoord === undefined) {
            if (!forwardSegs.length) {
                // if there are no forward segments, this segment should butt up against the edge
                seg.forwardCoord = 1;
            }
            else {
                // sort highest pressure first
                this.sortForwardSegs(forwardSegs);
                // this segment's forwardCoord will be calculated from the backwardCoord of the
                // highest-pressure forward segment.
                this.computeFgSegForwardBack(forwardSegs[0], seriesBackwardPressure + 1, seriesBackwardCoord);
                seg.forwardCoord = forwardSegs[0].backwardCoord;
            }
            // calculate the backwardCoord from the forwardCoord. consider the series
            seg.backwardCoord = seg.forwardCoord -
                (seg.forwardCoord - seriesBackwardCoord) / // available width for series
                    (seriesBackwardPressure + 1); // # of segments in the series
            // use this segment's coordinates to computed the coordinates of the less-pressurized
            // forward segments
            for (i = 0; i < forwardSegs.length; i++) {
                this.computeFgSegForwardBack(forwardSegs[i], 0, seg.forwardCoord);
            }
        }
    };
    TimeGridEventRenderer.prototype.sortForwardSegs = function (forwardSegs) {
        forwardSegs.sort(util_1.proxy(this, 'compareForwardSegs'));
    };
    // A cmp function for determining which forward segment to rely on more when computing coordinates.
    TimeGridEventRenderer.prototype.compareForwardSegs = function (seg1, seg2) {
        // put higher-pressure first
        return seg2.forwardPressure - seg1.forwardPressure ||
            // put segments that are closer to initial edge first (and favor ones with no coords yet)
            (seg1.backwardCoord || 0) - (seg2.backwardCoord || 0) ||
            // do normal sorting...
            this.compareEventSegs(seg1, seg2);
    };
    // Given foreground event segments that have already had their position coordinates computed,
    // assigns position-related CSS values to their elements.
    TimeGridEventRenderer.prototype.assignFgSegHorizontals = function (segs) {
        var i;
        var seg;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            seg.el.css(this.generateFgSegHorizontalCss(seg));
            // if the height is short, add a className for alternate styling
            if (seg.bottom - seg.top < 30) {
                seg.el.addClass('fc-short');
            }
        }
    };
    // Generates an object with CSS properties/values that should be applied to an event segment element.
    // Contains important positioning-related properties that should be applied to any event element, customized or not.
    TimeGridEventRenderer.prototype.generateFgSegHorizontalCss = function (seg) {
        var shouldOverlap = this.opt('slotEventOverlap');
        var backwardCoord = seg.backwardCoord; // the left side if LTR. the right side if RTL. floating-point
        var forwardCoord = seg.forwardCoord; // the right side if LTR. the left side if RTL. floating-point
        var props = this.timeGrid.generateSegVerticalCss(seg); // get top/bottom first
        var isRTL = this.timeGrid.isRTL;
        var left; // amount of space from left edge, a fraction of the total width
        var right; // amount of space from right edge, a fraction of the total width
        if (shouldOverlap) {
            // double the width, but don't go beyond the maximum forward coordinate (1.0)
            forwardCoord = Math.min(1, backwardCoord + (forwardCoord - backwardCoord) * 2);
        }
        if (isRTL) {
            left = 1 - forwardCoord;
            right = backwardCoord;
        }
        else {
            left = backwardCoord;
            right = 1 - forwardCoord;
        }
        props.zIndex = seg.level + 1; // convert from 0-base to 1-based
        props.left = left * 100 + '%';
        props.right = right * 100 + '%';
        if (shouldOverlap && seg.forwardPressure) {
            // add padding to the edge so that forward stacked events don't cover the resizer's icon
            props[isRTL ? 'marginLeft' : 'marginRight'] = 10 * 2; // 10 is a guesstimate of the icon's width
        }
        return props;
    };
    return TimeGridEventRenderer;
}(EventRenderer_1.default));
exports.default = TimeGridEventRenderer;
// Builds an array of segments "levels". The first level will be the leftmost tier of segments if the calendar is
// left-to-right, or the rightmost if the calendar is right-to-left. Assumes the segments are already ordered by date.
function buildSlotSegLevels(segs) {
    var levels = [];
    var i;
    var seg;
    var j;
    for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        // go through all the levels and stop on the first level where there are no collisions
        for (j = 0; j < levels.length; j++) {
            if (!computeSlotSegCollisions(seg, levels[j]).length) {
                break;
            }
        }
        seg.level = j;
        (levels[j] || (levels[j] = [])).push(seg);
    }
    return levels;
}
// For every segment, figure out the other segments that are in subsequent
// levels that also occupy the same vertical space. Accumulate in seg.forwardSegs
function computeForwardSlotSegs(levels) {
    var i;
    var level;
    var j;
    var seg;
    var k;
    for (i = 0; i < levels.length; i++) {
        level = levels[i];
        for (j = 0; j < level.length; j++) {
            seg = level[j];
            seg.forwardSegs = [];
            for (k = i + 1; k < levels.length; k++) {
                computeSlotSegCollisions(seg, levels[k], seg.forwardSegs);
            }
        }
    }
}
// Figure out which path forward (via seg.forwardSegs) results in the longest path until
// the furthest edge is reached. The number of segments in this path will be seg.forwardPressure
function computeSlotSegPressures(seg) {
    var forwardSegs = seg.forwardSegs;
    var forwardPressure = 0;
    var i;
    var forwardSeg;
    if (seg.forwardPressure === undefined) {
        for (i = 0; i < forwardSegs.length; i++) {
            forwardSeg = forwardSegs[i];
            // figure out the child's maximum forward path
            computeSlotSegPressures(forwardSeg);
            // either use the existing maximum, or use the child's forward pressure
            // plus one (for the forwardSeg itself)
            forwardPressure = Math.max(forwardPressure, 1 + forwardSeg.forwardPressure);
        }
        seg.forwardPressure = forwardPressure;
    }
}
// Find all the segments in `otherSegs` that vertically collide with `seg`.
// Append into an optionally-supplied `results` array and return.
function computeSlotSegCollisions(seg, otherSegs, results) {
    if (results === void 0) { results = []; }
    for (var i = 0; i < otherSegs.length; i++) {
        if (isSlotSegCollision(seg, otherSegs[i])) {
            results.push(otherSegs[i]);
        }
    }
    return results;
}
// Do these segments occupy the same vertical space?
function isSlotSegCollision(seg1, seg2) {
    return seg1.bottom > seg2.top && seg1.top < seg2.bottom;
}


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var HelperRenderer_1 = __webpack_require__(58);
var TimeGridHelperRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGridHelperRenderer, _super);
    function TimeGridHelperRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeGridHelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
        var helperNodes = [];
        var i;
        var seg;
        var sourceEl;
        // TODO: not good to call eventRenderer this way
        this.eventRenderer.renderFgSegsIntoContainers(segs, this.component.helperContainerEls);
        // Try to make the segment that is in the same row as sourceSeg look the same
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            if (sourceSeg && sourceSeg.col === seg.col) {
                sourceEl = sourceSeg.el;
                seg.el.css({
                    left: sourceEl.css('left'),
                    right: sourceEl.css('right'),
                    'margin-left': sourceEl.css('margin-left'),
                    'margin-right': sourceEl.css('margin-right')
                });
            }
            helperNodes.push(seg.el[0]);
        }
        return $(helperNodes); // must return the elements rendered
    };
    return TimeGridHelperRenderer;
}(HelperRenderer_1.default));
exports.default = TimeGridHelperRenderer;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var FillRenderer_1 = __webpack_require__(57);
var TimeGridFillRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGridFillRenderer, _super);
    function TimeGridFillRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeGridFillRenderer.prototype.attachSegEls = function (type, segs) {
        var timeGrid = this.component;
        var containerEls;
        // TODO: more efficient lookup
        if (type === 'bgEvent') {
            containerEls = timeGrid.bgContainerEls;
        }
        else if (type === 'businessHours') {
            containerEls = timeGrid.businessContainerEls;
        }
        else if (type === 'highlight') {
            containerEls = timeGrid.highlightContainerEls;
        }
        timeGrid.updateSegVerticals(segs);
        timeGrid.attachSegsByCol(timeGrid.groupSegsByCol(segs), containerEls);
        return segs.map(function (seg) {
            return seg.el[0];
        });
    };
    return TimeGridFillRenderer;
}(FillRenderer_1.default));
exports.default = TimeGridFillRenderer;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

/* A rectangular panel that is absolutely positioned over other content
------------------------------------------------------------------------------------------------------------------------
Options:
  - className (string)
  - content (HTML string or jQuery element set)
  - parentEl
  - top
  - left
  - right (the x coord of where the right edge should be. not a "CSS" right)
  - autoHide (boolean)
  - show (callback)
  - hide (callback)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var ListenerMixin_1 = __webpack_require__(7);
var Popover = /** @class */ (function () {
    function Popover(options) {
        this.isHidden = true;
        this.margin = 10; // the space required between the popover and the edges of the scroll container
        this.options = options || {};
    }
    // Shows the popover on the specified position. Renders it if not already
    Popover.prototype.show = function () {
        if (this.isHidden) {
            if (!this.el) {
                this.render();
            }
            this.el.show();
            this.position();
            this.isHidden = false;
            this.trigger('show');
        }
    };
    // Hides the popover, through CSS, but does not remove it from the DOM
    Popover.prototype.hide = function () {
        if (!this.isHidden) {
            this.el.hide();
            this.isHidden = true;
            this.trigger('hide');
        }
    };
    // Creates `this.el` and renders content inside of it
    Popover.prototype.render = function () {
        var _this = this;
        var options = this.options;
        this.el = $('<div class="fc-popover"/>')
            .addClass(options.className || '')
            .css({
            // position initially to the top left to avoid creating scrollbars
            top: 0,
            left: 0
        })
            .append(options.content)
            .appendTo(options.parentEl);
        // when a click happens on anything inside with a 'fc-close' className, hide the popover
        this.el.on('click', '.fc-close', function () {
            _this.hide();
        });
        if (options.autoHide) {
            this.listenTo($(document), 'mousedown', this.documentMousedown);
        }
    };
    // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
    Popover.prototype.documentMousedown = function (ev) {
        // only hide the popover if the click happened outside the popover
        if (this.el && !$(ev.target).closest(this.el).length) {
            this.hide();
        }
    };
    // Hides and unregisters any handlers
    Popover.prototype.removeElement = function () {
        this.hide();
        if (this.el) {
            this.el.remove();
            this.el = null;
        }
        this.stopListeningTo($(document), 'mousedown');
    };
    // Positions the popover optimally, using the top/left/right options
    Popover.prototype.position = function () {
        var options = this.options;
        var origin = this.el.offsetParent().offset();
        var width = this.el.outerWidth();
        var height = this.el.outerHeight();
        var windowEl = $(window);
        var viewportEl = util_1.getScrollParent(this.el);
        var viewportTop;
        var viewportLeft;
        var viewportOffset;
        var top; // the "position" (not "offset") values for the popover
        var left; //
        // compute top and left
        top = options.top || 0;
        if (options.left !== undefined) {
            left = options.left;
        }
        else if (options.right !== undefined) {
            left = options.right - width; // derive the left value from the right value
        }
        else {
            left = 0;
        }
        if (viewportEl.is(window) || viewportEl.is(document)) {
            viewportEl = windowEl;
            viewportTop = 0; // the window is always at the top left
            viewportLeft = 0; // (and .offset() won't work if called here)
        }
        else {
            viewportOffset = viewportEl.offset();
            viewportTop = viewportOffset.top;
            viewportLeft = viewportOffset.left;
        }
        // if the window is scrolled, it causes the visible area to be further down
        viewportTop += windowEl.scrollTop();
        viewportLeft += windowEl.scrollLeft();
        // constrain to the view port. if constrained by two edges, give precedence to top/left
        if (options.viewportConstrain !== false) {
            top = Math.min(top, viewportTop + viewportEl.outerHeight() - height - this.margin);
            top = Math.max(top, viewportTop + this.margin);
            left = Math.min(left, viewportLeft + viewportEl.outerWidth() - width - this.margin);
            left = Math.max(left, viewportLeft + this.margin);
        }
        this.el.css({
            top: top - origin.top,
            left: left - origin.left
        });
    };
    // Triggers a callback. Calls a function in the option hash of the same name.
    // Arguments beyond the first `name` are forwarded on.
    // TODO: better code reuse for this. Repeat code
    Popover.prototype.trigger = function (name) {
        if (this.options[name]) {
            this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
        }
    };
    return Popover;
}());
exports.default = Popover;
ListenerMixin_1.default.mixInto(Popover);


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var util_1 = __webpack_require__(4);
var EventRenderer_1 = __webpack_require__(42);
/* Event-rendering methods for the DayGrid class
----------------------------------------------------------------------------------------------------------------------*/
var DayGridEventRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(DayGridEventRenderer, _super);
    function DayGridEventRenderer(dayGrid, fillRenderer) {
        var _this = _super.call(this, dayGrid, fillRenderer) || this;
        _this.dayGrid = dayGrid;
        return _this;
    }
    DayGridEventRenderer.prototype.renderBgRanges = function (eventRanges) {
        // don't render timed background events
        eventRanges = $.grep(eventRanges, function (eventRange) {
            return eventRange.eventDef.isAllDay();
        });
        _super.prototype.renderBgRanges.call(this, eventRanges);
    };
    // Renders the given foreground event segments onto the grid
    DayGridEventRenderer.prototype.renderFgSegs = function (segs) {
        var rowStructs = this.rowStructs = this.renderSegRows(segs);
        // append to each row's content skeleton
        this.dayGrid.rowEls.each(function (i, rowNode) {
            $(rowNode).find('.fc-content-skeleton > table').append(rowStructs[i].tbodyEl);
        });
    };
    // Unrenders all currently rendered foreground event segments
    DayGridEventRenderer.prototype.unrenderFgSegs = function () {
        var rowStructs = this.rowStructs || [];
        var rowStruct;
        while ((rowStruct = rowStructs.pop())) {
            rowStruct.tbodyEl.remove();
        }
        this.rowStructs = null;
    };
    // Uses the given events array to generate <tbody> elements that should be appended to each row's content skeleton.
    // Returns an array of rowStruct objects (see the bottom of `renderSegRow`).
    // PRECONDITION: each segment shoud already have a rendered and assigned `.el`
    DayGridEventRenderer.prototype.renderSegRows = function (segs) {
        var rowStructs = [];
        var segRows;
        var row;
        segRows = this.groupSegRows(segs); // group into nested arrays
        // iterate each row of segment groupings
        for (row = 0; row < segRows.length; row++) {
            rowStructs.push(this.renderSegRow(row, segRows[row]));
        }
        return rowStructs;
    };
    // Given a row # and an array of segments all in the same row, render a <tbody> element, a skeleton that contains
    // the segments. Returns object with a bunch of internal data about how the render was calculated.
    // NOTE: modifies rowSegs
    DayGridEventRenderer.prototype.renderSegRow = function (row, rowSegs) {
        var colCnt = this.dayGrid.colCnt;
        var segLevels = this.buildSegLevels(rowSegs); // group into sub-arrays of levels
        var levelCnt = Math.max(1, segLevels.length); // ensure at least one level
        var tbody = $('<tbody/>');
        var segMatrix = []; // lookup for which segments are rendered into which level+col cells
        var cellMatrix = []; // lookup for all <td> elements of the level+col matrix
        var loneCellMatrix = []; // lookup for <td> elements that only take up a single column
        var i;
        var levelSegs;
        var col;
        var tr;
        var j;
        var seg;
        var td;
        // populates empty cells from the current column (`col`) to `endCol`
        function emptyCellsUntil(endCol) {
            while (col < endCol) {
                // try to grab a cell from the level above and extend its rowspan. otherwise, create a fresh cell
                td = (loneCellMatrix[i - 1] || [])[col];
                if (td) {
                    td.attr('rowspan', parseInt(td.attr('rowspan') || 1, 10) + 1);
                }
                else {
                    td = $('<td/>');
                    tr.append(td);
                }
                cellMatrix[i][col] = td;
                loneCellMatrix[i][col] = td;
                col++;
            }
        }
        for (i = 0; i < levelCnt; i++) {
            levelSegs = segLevels[i];
            col = 0;
            tr = $('<tr/>');
            segMatrix.push([]);
            cellMatrix.push([]);
            loneCellMatrix.push([]);
            // levelCnt might be 1 even though there are no actual levels. protect against this.
            // this single empty row is useful for styling.
            if (levelSegs) {
                for (j = 0; j < levelSegs.length; j++) {
                    seg = levelSegs[j];
                    emptyCellsUntil(seg.leftCol);
                    // create a container that occupies or more columns. append the event element.
                    td = $('<td class="fc-event-container"/>').append(seg.el);
                    if (seg.leftCol !== seg.rightCol) {
                        td.attr('colspan', seg.rightCol - seg.leftCol + 1);
                    }
                    else {
                        loneCellMatrix[i][col] = td;
                    }
                    while (col <= seg.rightCol) {
                        cellMatrix[i][col] = td;
                        segMatrix[i][col] = seg;
                        col++;
                    }
                    tr.append(td);
                }
            }
            emptyCellsUntil(colCnt); // finish off the row
            this.dayGrid.bookendCells(tr);
            tbody.append(tr);
        }
        return {
            row: row,
            tbodyEl: tbody,
            cellMatrix: cellMatrix,
            segMatrix: segMatrix,
            segLevels: segLevels,
            segs: rowSegs
        };
    };
    // Stacks a flat array of segments, which are all assumed to be in the same row, into subarrays of vertical levels.
    // NOTE: modifies segs
    DayGridEventRenderer.prototype.buildSegLevels = function (segs) {
        var levels = [];
        var i;
        var seg;
        var j;
        // Give preference to elements with certain criteria, so they have
        // a chance to be closer to the top.
        this.sortEventSegs(segs);
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            // loop through levels, starting with the topmost, until the segment doesn't collide with other segments
            for (j = 0; j < levels.length; j++) {
                if (!isDaySegCollision(seg, levels[j])) {
                    break;
                }
            }
            // `j` now holds the desired subrow index
            seg.level = j;
            // create new level array if needed and append segment
            (levels[j] || (levels[j] = [])).push(seg);
        }
        // order segments left-to-right. very important if calendar is RTL
        for (j = 0; j < levels.length; j++) {
            levels[j].sort(compareDaySegCols);
        }
        return levels;
    };
    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's row
    DayGridEventRenderer.prototype.groupSegRows = function (segs) {
        var segRows = [];
        var i;
        for (i = 0; i < this.dayGrid.rowCnt; i++) {
            segRows.push([]);
        }
        for (i = 0; i < segs.length; i++) {
            segRows[segs[i].row].push(segs[i]);
        }
        return segRows;
    };
    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
    DayGridEventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('extraSmallTimeFormat'); // like "6p" or "6:30p"
    };
    // Computes a default `displayEventEnd` value if one is not expliclty defined
    DayGridEventRenderer.prototype.computeDisplayEventEnd = function () {
        return this.dayGrid.colCnt === 1; // we'll likely have space if there's only one day
    };
    // Builds the HTML to be used for the default element for an individual segment
    DayGridEventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
        var view = this.view;
        var eventDef = seg.footprint.eventDef;
        var isAllDay = seg.footprint.componentFootprint.isAllDay;
        var isDraggable = view.isEventDefDraggable(eventDef);
        var isResizableFromStart = !disableResizing && isAllDay &&
            seg.isStart && view.isEventDefResizableFromStart(eventDef);
        var isResizableFromEnd = !disableResizing && isAllDay &&
            seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
        var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
        var skinCss = util_1.cssToStr(this.getSkinCss(eventDef));
        var timeHtml = '';
        var timeText;
        var titleHtml;
        classes.unshift('fc-day-grid-event', 'fc-h-event');
        // Only display a timed events time if it is the starting segment
        if (seg.isStart) {
            timeText = this.getTimeText(seg.footprint);
            if (timeText) {
                timeHtml = '<span class="fc-time">' + util_1.htmlEscape(timeText) + '</span>';
            }
        }
        titleHtml =
            '<span class="fc-title">' +
                (util_1.htmlEscape(eventDef.title || '') || '&nbsp;') + // we always want one line of height
                '</span>';
        return '<a class="' + classes.join(' ') + '"' +
            (eventDef.url ?
                ' href="' + util_1.htmlEscape(eventDef.url) + '"' :
                '') +
            (skinCss ?
                ' style="' + skinCss + '"' :
                '') +
            '>' +
            '<div class="fc-content">' +
            (this.dayGrid.isRTL ?
                titleHtml + ' ' + timeHtml : // put a natural space in between
                timeHtml + ' ' + titleHtml //
            ) +
            '</div>' +
            (isResizableFromStart ?
                '<div class="fc-resizer fc-start-resizer" />' :
                '') +
            (isResizableFromEnd ?
                '<div class="fc-resizer fc-end-resizer" />' :
                '') +
            '</a>';
    };
    return DayGridEventRenderer;
}(EventRenderer_1.default));
exports.default = DayGridEventRenderer;
// Computes whether two segments' columns collide. They are assumed to be in the same row.
function isDaySegCollision(seg, otherSegs) {
    var i;
    var otherSeg;
    for (i = 0; i < otherSegs.length; i++) {
        otherSeg = otherSegs[i];
        if (otherSeg.leftCol <= seg.rightCol &&
            otherSeg.rightCol >= seg.leftCol) {
            return true;
        }
    }
    return false;
}
// A cmp function for determining the leftmost event
function compareDaySegCols(a, b) {
    return a.leftCol - b.leftCol;
}


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var HelperRenderer_1 = __webpack_require__(58);
var DayGridHelperRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(DayGridHelperRenderer, _super);
    function DayGridHelperRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Renders a mock "helper" event. `sourceSeg` is the associated internal segment object. It can be null.
    DayGridHelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
        var helperNodes = [];
        var rowStructs;
        // TODO: not good to call eventRenderer this way
        rowStructs = this.eventRenderer.renderSegRows(segs);
        // inject each new event skeleton into each associated row
        this.component.rowEls.each(function (row, rowNode) {
            var rowEl = $(rowNode); // the .fc-row
            var skeletonEl = $('<div class="fc-helper-skeleton"><table/></div>'); // will be absolutely positioned
            var skeletonTopEl;
            var skeletonTop;
            // If there is an original segment, match the top position. Otherwise, put it at the row's top level
            if (sourceSeg && sourceSeg.row === row) {
                skeletonTop = sourceSeg.el.position().top;
            }
            else {
                skeletonTopEl = rowEl.find('.fc-content-skeleton tbody');
                if (!skeletonTopEl.length) {
                    skeletonTopEl = rowEl.find('.fc-content-skeleton table');
                }
                skeletonTop = skeletonTopEl.position().top;
            }
            skeletonEl.css('top', skeletonTop)
                .find('table')
                .append(rowStructs[row].tbodyEl);
            rowEl.append(skeletonEl);
            helperNodes.push(skeletonEl[0]);
        });
        return $(helperNodes); // must return the elements rendered
    };
    return DayGridHelperRenderer;
}(HelperRenderer_1.default));
exports.default = DayGridHelperRenderer;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var FillRenderer_1 = __webpack_require__(57);
var DayGridFillRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(DayGridFillRenderer, _super);
    function DayGridFillRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fillSegTag = 'td'; // override the default tag name
        return _this;
    }
    DayGridFillRenderer.prototype.attachSegEls = function (type, segs) {
        var nodes = [];
        var i;
        var seg;
        var skeletonEl;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            skeletonEl = this.renderFillRow(type, seg);
            this.component.rowEls.eq(seg.row).append(skeletonEl);
            nodes.push(skeletonEl[0]);
        }
        return nodes;
    };
    // Generates the HTML needed for one row of a fill. Requires the seg's el to be rendered.
    DayGridFillRenderer.prototype.renderFillRow = function (type, seg) {
        var colCnt = this.component.colCnt;
        var startCol = seg.leftCol;
        var endCol = seg.rightCol + 1;
        var className;
        var skeletonEl;
        var trEl;
        if (type === 'businessHours') {
            className = 'bgevent';
        }
        else {
            className = type.toLowerCase();
        }
        skeletonEl = $('<div class="fc-' + className + '-skeleton">' +
            '<table><tr/></table>' +
            '</div>');
        trEl = skeletonEl.find('tr');
        if (startCol > 0) {
            trEl.append('<td colspan="' + startCol + '"/>');
        }
        trEl.append(seg.el.attr('colspan', endCol - startCol));
        if (endCol < colCnt) {
            trEl.append('<td colspan="' + (colCnt - endCol) + '"/>');
        }
        this.component.bookendCells(trEl);
        return skeletonEl;
    };
    return DayGridFillRenderer;
}(FillRenderer_1.default));
exports.default = DayGridFillRenderer;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var BasicViewDateProfileGenerator_1 = __webpack_require__(228);
var UnzonedRange_1 = __webpack_require__(5);
var MonthViewDateProfileGenerator = /** @class */ (function (_super) {
    tslib_1.__extends(MonthViewDateProfileGenerator, _super);
    function MonthViewDateProfileGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Computes the date range that will be rendered.
    MonthViewDateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
        var renderUnzonedRange = _super.prototype.buildRenderRange.call(this, currentUnzonedRange, currentRangeUnit, isRangeAllDay);
        var start = this.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
        var end = this.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay);
        var rowCnt;
        // ensure 6 weeks
        if (this.opt('fixedWeekCount')) {
            rowCnt = Math.ceil(// could be partial weeks due to hiddenDays
            end.diff(start, 'weeks', true) // dontRound=true
            );
            end.add(6 - rowCnt, 'weeks');
        }
        return new UnzonedRange_1.default(start, end);
    };
    return MonthViewDateProfileGenerator;
}(BasicViewDateProfileGenerator_1.default));
exports.default = MonthViewDateProfileGenerator;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var util_1 = __webpack_require__(4);
var EventRenderer_1 = __webpack_require__(42);
var ListEventRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(ListEventRenderer, _super);
    function ListEventRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListEventRenderer.prototype.renderFgSegs = function (segs) {
        if (!segs.length) {
            this.component.renderEmptyMessage();
        }
        else {
            this.component.renderSegList(segs);
        }
    };
    // generates the HTML for a single event row
    ListEventRenderer.prototype.fgSegHtml = function (seg) {
        var view = this.view;
        var calendar = view.calendar;
        var theme = calendar.theme;
        var eventFootprint = seg.footprint;
        var eventDef = eventFootprint.eventDef;
        var componentFootprint = eventFootprint.componentFootprint;
        var url = eventDef.url;
        var classes = ['fc-list-item'].concat(this.getClasses(eventDef));
        var bgColor = this.getBgColor(eventDef);
        var timeHtml;
        if (componentFootprint.isAllDay) {
            timeHtml = view.getAllDayHtml();
        }
        else if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
            if (seg.isStart || seg.isEnd) {
                timeHtml = util_1.htmlEscape(this._getTimeText(calendar.msToMoment(seg.startMs), calendar.msToMoment(seg.endMs), componentFootprint.isAllDay));
            }
            else {
                timeHtml = view.getAllDayHtml();
            }
        }
        else {
            // Display the normal time text for the *event's* times
            timeHtml = util_1.htmlEscape(this.getTimeText(eventFootprint));
        }
        if (url) {
            classes.push('fc-has-url');
        }
        return '<tr class="' + classes.join(' ') + '">' +
            (this.displayEventTime ?
                '<td class="fc-list-item-time ' + theme.getClass('widgetContent') + '">' +
                    (timeHtml || '') +
                    '</td>' :
                '') +
            '<td class="fc-list-item-marker ' + theme.getClass('widgetContent') + '">' +
            '<span class="fc-event-dot"' +
            (bgColor ?
                ' style="background-color:' + bgColor + '"' :
                '') +
            '></span>' +
            '</td>' +
            '<td class="fc-list-item-title ' + theme.getClass('widgetContent') + '">' +
            '<a' + (url ? ' href="' + util_1.htmlEscape(url) + '"' : '') + '>' +
            util_1.htmlEscape(eventDef.title || '') +
            '</a>' +
            '</td>' +
            '</tr>';
    };
    // like "4:00am"
    ListEventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('mediumTimeFormat');
    };
    return ListEventRenderer;
}(EventRenderer_1.default));
exports.default = ListEventRenderer;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var $ = __webpack_require__(3);
var EventPointing_1 = __webpack_require__(59);
var ListEventPointing = /** @class */ (function (_super) {
    tslib_1.__extends(ListEventPointing, _super);
    function ListEventPointing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // for events with a url, the whole <tr> should be clickable,
    // but it's impossible to wrap with an <a> tag. simulate this.
    ListEventPointing.prototype.handleClick = function (seg, ev) {
        var url;
        _super.prototype.handleClick.call(this, seg, ev); // might prevent the default action
        // not clicking on or within an <a> with an href
        if (!$(ev.target).closest('a[href]').length) {
            url = seg.footprint.eventDef.url;
            if (url && !ev.isDefaultPrevented()) {
                window.location.href = url; // simulate link click
            }
        }
    };
    return ListEventPointing;
}(EventPointing_1.default));
exports.default = ListEventPointing;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventSourceParser_1 = __webpack_require__(37);
var ArrayEventSource_1 = __webpack_require__(52);
var FuncEventSource_1 = __webpack_require__(215);
var JsonFeedEventSource_1 = __webpack_require__(216);
EventSourceParser_1.default.registerClass(ArrayEventSource_1.default);
EventSourceParser_1.default.registerClass(FuncEventSource_1.default);
EventSourceParser_1.default.registerClass(JsonFeedEventSource_1.default);


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ThemeRegistry_1 = __webpack_require__(51);
var StandardTheme_1 = __webpack_require__(213);
var JqueryUiTheme_1 = __webpack_require__(214);
var BootstrapTheme_1 = __webpack_require__(258);
ThemeRegistry_1.defineThemeSystem('standard', StandardTheme_1.default);
ThemeRegistry_1.defineThemeSystem('jquery-ui', JqueryUiTheme_1.default);
ThemeRegistry_1.defineThemeSystem('bootstrap3', BootstrapTheme_1.default);


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Theme_1 = __webpack_require__(38);
var BootstrapTheme = /** @class */ (function (_super) {
    tslib_1.__extends(BootstrapTheme, _super);
    function BootstrapTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BootstrapTheme;
}(Theme_1.default));
exports.default = BootstrapTheme;
BootstrapTheme.prototype.classes = {
    widget: 'fc-bootstrap3',
    tableGrid: 'table-bordered',
    tableList: 'table table-striped',
    buttonGroup: 'btn-group',
    button: 'btn btn-default',
    stateActive: 'active',
    stateDisabled: 'disabled',
    today: 'alert alert-info',
    popover: 'panel panel-default',
    popoverHeader: 'panel-heading',
    popoverContent: 'panel-body',
    // day grid
    headerRow: 'panel-default',
    dayRow: 'panel-default',
    // list view
    listView: 'panel panel-default'
};
BootstrapTheme.prototype.baseIconClass = 'glyphicon';
BootstrapTheme.prototype.iconClasses = {
    close: 'glyphicon-remove',
    prev: 'glyphicon-chevron-left',
    next: 'glyphicon-chevron-right',
    prevYear: 'glyphicon-backward',
    nextYear: 'glyphicon-forward'
};
BootstrapTheme.prototype.iconOverrideOption = 'bootstrapGlyphicons';
BootstrapTheme.prototype.iconOverrideCustomButtonOption = 'bootstrapGlyphicon';
BootstrapTheme.prototype.iconOverridePrefix = 'glyphicon-';


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ViewRegistry_1 = __webpack_require__(21);
var BasicView_1 = __webpack_require__(62);
var MonthView_1 = __webpack_require__(229);
ViewRegistry_1.defineView('basic', {
    'class': BasicView_1.default
});
ViewRegistry_1.defineView('basicDay', {
    type: 'basic',
    duration: { days: 1 }
});
ViewRegistry_1.defineView('basicWeek', {
    type: 'basic',
    duration: { weeks: 1 }
});
ViewRegistry_1.defineView('month', {
    'class': MonthView_1.default,
    duration: { months: 1 },
    defaults: {
        fixedWeekCount: true
    }
});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ViewRegistry_1 = __webpack_require__(21);
var AgendaView_1 = __webpack_require__(226);
ViewRegistry_1.defineView('agenda', {
    'class': AgendaView_1.default,
    defaults: {
        allDaySlot: true,
        slotDuration: '00:30:00',
        slotEventOverlap: true // a bad name. confused with overlap/constraint system
    }
});
ViewRegistry_1.defineView('agendaDay', {
    type: 'agenda',
    duration: { days: 1 }
});
ViewRegistry_1.defineView('agendaWeek', {
    type: 'agenda',
    duration: { weeks: 1 }
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ViewRegistry_1 = __webpack_require__(21);
var ListView_1 = __webpack_require__(230);
ViewRegistry_1.defineView('list', {
    'class': ListView_1.default,
    buttonTextKey: 'list',
    defaults: {
        buttonText: 'list',
        listDayFormat: 'LL',
        noEventsMessage: 'No events to display'
    }
});
ViewRegistry_1.defineView('listDay', {
    type: 'list',
    duration: { days: 1 },
    defaults: {
        listDayFormat: 'dddd' // day-of-week is all we need. full date is probably in header
    }
});
ViewRegistry_1.defineView('listWeek', {
    type: 'list',
    duration: { weeks: 1 },
    defaults: {
        listDayFormat: 'dddd',
        listDayAltFormat: 'LL'
    }
});
ViewRegistry_1.defineView('listMonth', {
    type: 'list',
    duration: { month: 1 },
    defaults: {
        listDayAltFormat: 'dddd' // day-of-week is nice-to-have
    }
});
ViewRegistry_1.defineView('listYear', {
    type: 'list',
    duration: { year: 1 },
    defaults: {
        listDayAltFormat: 'dddd' // day-of-week is nice-to-have
    }
});


/***/ }),
/* 262 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });


/***/ })
/******/ ]);
});

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// HumanizeDuration.js - https://git.io/j0HgmQ

;(function () {
  // This has to be defined separately because of a bug: we want to alias
  // `gr` and `el` for backwards-compatiblity. In a breaking change, we can
  // remove `gr` entirely.
  // See https://github.com/EvanHahn/HumanizeDuration.js/issues/143 for more.
  var greek = {
    y: function (c) { return c === 1 ? 'χρόνος' : 'χρόνια' },
    mo: function (c) { return c === 1 ? 'μήνας' : 'μήνες' },
    w: function (c) { return c === 1 ? 'εβδομάδα' : 'εβδομάδες' },
    d: function (c) { return c === 1 ? 'μέρα' : 'μέρες' },
    h: function (c) { return c === 1 ? 'ώρα' : 'ώρες' },
    m: function (c) { return c === 1 ? 'λεπτό' : 'λεπτά' },
    s: function (c) { return c === 1 ? 'δευτερόλεπτο' : 'δευτερόλεπτα' },
    ms: function (c) { return c === 1 ? 'χιλιοστό του δευτερολέπτου' : 'χιλιοστά του δευτερολέπτου' },
    decimal: ','
  }

  var languages = {
    ar: {
      y: function (c) { return c === 1 ? 'سنة' : 'سنوات' },
      mo: function (c) { return c === 1 ? 'شهر' : 'أشهر' },
      w: function (c) { return c === 1 ? 'أسبوع' : 'أسابيع' },
      d: function (c) { return c === 1 ? 'يوم' : 'أيام' },
      h: function (c) { return c === 1 ? 'ساعة' : 'ساعات' },
      m: function (c) {
        return ['دقيقة', 'دقائق'][getArabicForm(c)]
      },
      s: function (c) { return c === 1 ? 'ثانية' : 'ثواني' },
      ms: function (c) { return c === 1 ? 'جزء من الثانية' : 'أجزاء من الثانية' },
      decimal: ','
    },
    bg: {
      y: function (c) { return ['години', 'година', 'години'][getSlavicForm(c)] },
      mo: function (c) { return ['месеца', 'месец', 'месеца'][getSlavicForm(c)] },
      w: function (c) { return ['седмици', 'седмица', 'седмици'][getSlavicForm(c)] },
      d: function (c) { return ['дни', 'ден', 'дни'][getSlavicForm(c)] },
      h: function (c) { return ['часа', 'час', 'часа'][getSlavicForm(c)] },
      m: function (c) { return ['минути', 'минута', 'минути'][getSlavicForm(c)] },
      s: function (c) { return ['секунди', 'секунда', 'секунди'][getSlavicForm(c)] },
      ms: function (c) { return ['милисекунди', 'милисекунда', 'милисекунди'][getSlavicForm(c)] },
      decimal: ','
    },
    ca: {
      y: function (c) { return 'any' + (c === 1 ? '' : 's') },
      mo: function (c) { return 'mes' + (c === 1 ? '' : 'os') },
      w: function (c) { return 'setman' + (c === 1 ? 'a' : 'es') },
      d: function (c) { return 'di' + (c === 1 ? 'a' : 'es') },
      h: function (c) { return 'hor' + (c === 1 ? 'a' : 'es') },
      m: function (c) { return 'minut' + (c === 1 ? '' : 's') },
      s: function (c) { return 'segon' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'milisegon' + (c === 1 ? '' : 's') },
      decimal: ','
    },
    cs: {
      y: function (c) { return ['rok', 'roku', 'roky', 'let'][getCzechOrSlovakForm(c)] },
      mo: function (c) { return ['měsíc', 'měsíce', 'měsíce', 'měsíců'][getCzechOrSlovakForm(c)] },
      w: function (c) { return ['týden', 'týdne', 'týdny', 'týdnů'][getCzechOrSlovakForm(c)] },
      d: function (c) { return ['den', 'dne', 'dny', 'dní'][getCzechOrSlovakForm(c)] },
      h: function (c) { return ['hodina', 'hodiny', 'hodiny', 'hodin'][getCzechOrSlovakForm(c)] },
      m: function (c) { return ['minuta', 'minuty', 'minuty', 'minut'][getCzechOrSlovakForm(c)] },
      s: function (c) { return ['sekunda', 'sekundy', 'sekundy', 'sekund'][getCzechOrSlovakForm(c)] },
      ms: function (c) { return ['milisekunda', 'milisekundy', 'milisekundy', 'milisekund'][getCzechOrSlovakForm(c)] },
      decimal: ','
    },
    da: {
      y: 'år',
      mo: function (c) { return 'måned' + (c === 1 ? '' : 'er') },
      w: function (c) { return 'uge' + (c === 1 ? '' : 'r') },
      d: function (c) { return 'dag' + (c === 1 ? '' : 'e') },
      h: function (c) { return 'time' + (c === 1 ? '' : 'r') },
      m: function (c) { return 'minut' + (c === 1 ? '' : 'ter') },
      s: function (c) { return 'sekund' + (c === 1 ? '' : 'er') },
      ms: function (c) { return 'millisekund' + (c === 1 ? '' : 'er') },
      decimal: ','
    },
    de: {
      y: function (c) { return 'Jahr' + (c === 1 ? '' : 'e') },
      mo: function (c) { return 'Monat' + (c === 1 ? '' : 'e') },
      w: function (c) { return 'Woche' + (c === 1 ? '' : 'n') },
      d: function (c) { return 'Tag' + (c === 1 ? '' : 'e') },
      h: function (c) { return 'Stunde' + (c === 1 ? '' : 'n') },
      m: function (c) { return 'Minute' + (c === 1 ? '' : 'n') },
      s: function (c) { return 'Sekunde' + (c === 1 ? '' : 'n') },
      ms: function (c) { return 'Millisekunde' + (c === 1 ? '' : 'n') },
      decimal: ','
    },
    el: greek,
    en: {
      y: function (c) { return 'year' + (c === 1 ? '' : 's') },
      mo: function (c) { return 'month' + (c === 1 ? '' : 's') },
      w: function (c) { return 'week' + (c === 1 ? '' : 's') },
      d: function (c) { return 'day' + (c === 1 ? '' : 's') },
      h: function (c) { return 'hour' + (c === 1 ? '' : 's') },
      m: function (c) { return 'minute' + (c === 1 ? '' : 's') },
      s: function (c) { return 'second' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'millisecond' + (c === 1 ? '' : 's') },
      decimal: '.'
    },
    es: {
      y: function (c) { return 'año' + (c === 1 ? '' : 's') },
      mo: function (c) { return 'mes' + (c === 1 ? '' : 'es') },
      w: function (c) { return 'semana' + (c === 1 ? '' : 's') },
      d: function (c) { return 'día' + (c === 1 ? '' : 's') },
      h: function (c) { return 'hora' + (c === 1 ? '' : 's') },
      m: function (c) { return 'minuto' + (c === 1 ? '' : 's') },
      s: function (c) { return 'segundo' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'milisegundo' + (c === 1 ? '' : 's') },
      decimal: ','
    },
    et: {
      y: function (c) { return 'aasta' + (c === 1 ? '' : 't') },
      mo: function (c) { return 'kuu' + (c === 1 ? '' : 'd') },
      w: function (c) { return 'nädal' + (c === 1 ? '' : 'at') },
      d: function (c) { return 'päev' + (c === 1 ? '' : 'a') },
      h: function (c) { return 'tund' + (c === 1 ? '' : 'i') },
      m: function (c) { return 'minut' + (c === 1 ? '' : 'it') },
      s: function (c) { return 'sekund' + (c === 1 ? '' : 'it') },
      ms: function (c) { return 'millisekund' + (c === 1 ? '' : 'it') },
      decimal: ','
    },
    fa: {
      y: 'سال',
      mo: 'ماه',
      w: 'هفته',
      d: 'روز',
      h: 'ساعت',
      m: 'دقیقه',
      s: 'ثانیه',
      ms: 'میلی ثانیه',
      decimal: '.'
    },
    fi: {
      y: function (c) { return c === 1 ? 'vuosi' : 'vuotta' },
      mo: function (c) { return c === 1 ? 'kuukausi' : 'kuukautta' },
      w: function (c) { return 'viikko' + (c === 1 ? '' : 'a') },
      d: function (c) { return 'päivä' + (c === 1 ? '' : 'ä') },
      h: function (c) { return 'tunti' + (c === 1 ? '' : 'a') },
      m: function (c) { return 'minuutti' + (c === 1 ? '' : 'a') },
      s: function (c) { return 'sekunti' + (c === 1 ? '' : 'a') },
      ms: function (c) { return 'millisekunti' + (c === 1 ? '' : 'a') },
      decimal: ','
    },
    fo: {
      y: 'ár',
      mo: function (c) { return c === 1 ? 'mánaður' : 'mánaðir' },
      w: function (c) { return c === 1 ? 'vika' : 'vikur' },
      d: function (c) { return c === 1 ? 'dagur' : 'dagar' },
      h: function (c) { return c === 1 ? 'tími' : 'tímar' },
      m: function (c) { return c === 1 ? 'minuttur' : 'minuttir' },
      s: 'sekund',
      ms: 'millisekund',
      decimal: ','
    },
    fr: {
      y: function (c) { return 'an' + (c >= 2 ? 's' : '') },
      mo: 'mois',
      w: function (c) { return 'semaine' + (c >= 2 ? 's' : '') },
      d: function (c) { return 'jour' + (c >= 2 ? 's' : '') },
      h: function (c) { return 'heure' + (c >= 2 ? 's' : '') },
      m: function (c) { return 'minute' + (c >= 2 ? 's' : '') },
      s: function (c) { return 'seconde' + (c >= 2 ? 's' : '') },
      ms: function (c) { return 'milliseconde' + (c >= 2 ? 's' : '') },
      decimal: ','
    },
    gr: greek,
    he: {
      y: function (c) { return c === 1 ? 'שנה' : 'שנים' },
      mo: function (c) { return c === 1 ? 'חודש' : 'חודשים' },
      w: function (c) { return c === 1 ? 'שבוע' : 'שבועות' },
      d: function (c) { return c === 1 ? 'יום' : 'ימים' },
      h: function (c) { return c === 1 ? 'שעה' : 'שעות' },
      m: function (c) { return c === 1 ? 'דקה' : 'דקות' },
      s: function (c) { return c === 1 ? 'שניה' : 'שניות' },
      ms: function (c) { return c === 1 ? 'מילישנייה' : 'מילישניות' },
      decimal: '.'
    },
    hr: {
      y: function (c) {
        if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
          return 'godine'
        }
        return 'godina'
      },
      mo: function (c) {
        if (c === 1) {
          return 'mjesec'
        } else if (c === 2 || c === 3 || c === 4) {
          return 'mjeseca'
        }
        return 'mjeseci'
      },
      w: function (c) {
        if (c % 10 === 1 && c !== 11) {
          return 'tjedan'
        }
        return 'tjedna'
      },
      d: function (c) { return c === 1 ? 'dan' : 'dana' },
      h: function (c) {
        if (c === 1) {
          return 'sat'
        } else if (c === 2 || c === 3 || c === 4) {
          return 'sata'
        }
        return 'sati'
      },
      m: function (c) {
        var mod10 = c % 10
        if ((mod10 === 2 || mod10 === 3 || mod10 === 4) && (c < 10 || c > 14)) {
          return 'minute'
        }
        return 'minuta'
      },
      s: function (c) {
        if ((c === 10 || c === 11 || c === 12 || c === 13 || c === 14 || c === 16 || c === 17 || c === 18 || c === 19) || (c % 10 === 5)) {
          return 'sekundi'
        } else if (c % 10 === 1) {
          return 'sekunda'
        } else if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
          return 'sekunde'
        }
        return 'sekundi'
      },
      ms: function (c) {
        if (c === 1) {
          return 'milisekunda'
        } else if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
          return 'milisekunde'
        }
        return 'milisekundi'
      },
      decimal: ','
    },
    hu: {
      y: 'év',
      mo: 'hónap',
      w: 'hét',
      d: 'nap',
      h: 'óra',
      m: 'perc',
      s: 'másodperc',
      ms: 'ezredmásodperc',
      decimal: ','
    },
    id: {
      y: 'tahun',
      mo: 'bulan',
      w: 'minggu',
      d: 'hari',
      h: 'jam',
      m: 'menit',
      s: 'detik',
      ms: 'milidetik',
      decimal: '.'
    },
    is: {
      y: 'ár',
      mo: function (c) { return 'mánuð' + (c === 1 ? 'ur' : 'ir') },
      w: function (c) { return 'vik' + (c === 1 ? 'a' : 'ur') },
      d: function (c) { return 'dag' + (c === 1 ? 'ur' : 'ar') },
      h: function (c) { return 'klukkutím' + (c === 1 ? 'i' : 'ar') },
      m: function (c) { return 'mínút' + (c === 1 ? 'a' : 'ur') },
      s: function (c) { return 'sekúnd' + (c === 1 ? 'a' : 'ur') },
      ms: function (c) { return 'millisekúnd' + (c === 1 ? 'a' : 'ur') },
      decimal: '.'
    },
    it: {
      y: function (c) { return 'ann' + (c === 1 ? 'o' : 'i') },
      mo: function (c) { return 'mes' + (c === 1 ? 'e' : 'i') },
      w: function (c) { return 'settiman' + (c === 1 ? 'a' : 'e') },
      d: function (c) { return 'giorn' + (c === 1 ? 'o' : 'i') },
      h: function (c) { return 'or' + (c === 1 ? 'a' : 'e') },
      m: function (c) { return 'minut' + (c === 1 ? 'o' : 'i') },
      s: function (c) { return 'second' + (c === 1 ? 'o' : 'i') },
      ms: function (c) { return 'millisecond' + (c === 1 ? 'o' : 'i') },
      decimal: ','
    },
    ja: {
      y: '年',
      mo: '月',
      w: '週',
      d: '日',
      h: '時間',
      m: '分',
      s: '秒',
      ms: 'ミリ秒',
      decimal: '.'
    },
    ko: {
      y: '년',
      mo: '개월',
      w: '주일',
      d: '일',
      h: '시간',
      m: '분',
      s: '초',
      ms: '밀리 초',
      decimal: '.'
    },
    lo: {
      y: 'ປີ',
      mo: 'ເດືອນ',
      w: 'ອາທິດ',
      d: 'ມື້',
      h: 'ຊົ່ວໂມງ',
      m: 'ນາທີ',
      s: 'ວິນາທີ',
      ms: 'ມິນລິວິນາທີ',
      decimal: ','
    },
    lt: {
      y: function (c) { return ((c % 10 === 0) || (c % 100 >= 10 && c % 100 <= 20)) ? 'metų' : 'metai' },
      mo: function (c) { return ['mėnuo', 'mėnesiai', 'mėnesių'][getLithuanianForm(c)] },
      w: function (c) { return ['savaitė', 'savaitės', 'savaičių'][getLithuanianForm(c)] },
      d: function (c) { return ['diena', 'dienos', 'dienų'][getLithuanianForm(c)] },
      h: function (c) { return ['valanda', 'valandos', 'valandų'][getLithuanianForm(c)] },
      m: function (c) { return ['minutė', 'minutės', 'minučių'][getLithuanianForm(c)] },
      s: function (c) { return ['sekundė', 'sekundės', 'sekundžių'][getLithuanianForm(c)] },
      ms: function (c) { return ['milisekundė', 'milisekundės', 'milisekundžių'][getLithuanianForm(c)] },
      decimal: ','
    },
    lv: {
      y: function (c) { return ['gads', 'gadi'][getLatvianForm(c)] },
      mo: function (c) { return ['mēnesis', 'mēneši'][getLatvianForm(c)] },
      w: function (c) { return ['nedēļa', 'nedēļas'][getLatvianForm(c)] },
      d: function (c) { return ['diena', 'dienas'][getLatvianForm(c)] },
      h: function (c) { return ['stunda', 'stundas'][getLatvianForm(c)] },
      m: function (c) { return ['minūte', 'minūtes'][getLatvianForm(c)] },
      s: function (c) { return ['sekunde', 'sekundes'][getLatvianForm(c)] },
      ms: function (c) { return ['milisekunde', 'milisekundes'][getLatvianForm(c)] },
      decimal: ','
    },
    ms: {
      y: 'tahun',
      mo: 'bulan',
      w: 'minggu',
      d: 'hari',
      h: 'jam',
      m: 'minit',
      s: 'saat',
      ms: 'milisaat',
      decimal: '.'
    },
    nl: {
      y: 'jaar',
      mo: function (c) { return c === 1 ? 'maand' : 'maanden' },
      w: function (c) { return c === 1 ? 'week' : 'weken' },
      d: function (c) { return c === 1 ? 'dag' : 'dagen' },
      h: 'uur',
      m: function (c) { return c === 1 ? 'minuut' : 'minuten' },
      s: function (c) { return c === 1 ? 'seconde' : 'seconden' },
      ms: function (c) { return c === 1 ? 'milliseconde' : 'milliseconden' },
      decimal: ','
    },
    no: {
      y: 'år',
      mo: function (c) { return 'måned' + (c === 1 ? '' : 'er') },
      w: function (c) { return 'uke' + (c === 1 ? '' : 'r') },
      d: function (c) { return 'dag' + (c === 1 ? '' : 'er') },
      h: function (c) { return 'time' + (c === 1 ? '' : 'r') },
      m: function (c) { return 'minutt' + (c === 1 ? '' : 'er') },
      s: function (c) { return 'sekund' + (c === 1 ? '' : 'er') },
      ms: function (c) { return 'millisekund' + (c === 1 ? '' : 'er') },
      decimal: ','
    },
    pl: {
      y: function (c) { return ['rok', 'roku', 'lata', 'lat'][getPolishForm(c)] },
      mo: function (c) { return ['miesiąc', 'miesiąca', 'miesiące', 'miesięcy'][getPolishForm(c)] },
      w: function (c) { return ['tydzień', 'tygodnia', 'tygodnie', 'tygodni'][getPolishForm(c)] },
      d: function (c) { return ['dzień', 'dnia', 'dni', 'dni'][getPolishForm(c)] },
      h: function (c) { return ['godzina', 'godziny', 'godziny', 'godzin'][getPolishForm(c)] },
      m: function (c) { return ['minuta', 'minuty', 'minuty', 'minut'][getPolishForm(c)] },
      s: function (c) { return ['sekunda', 'sekundy', 'sekundy', 'sekund'][getPolishForm(c)] },
      ms: function (c) { return ['milisekunda', 'milisekundy', 'milisekundy', 'milisekund'][getPolishForm(c)] },
      decimal: ','
    },
    pt: {
      y: function (c) { return 'ano' + (c === 1 ? '' : 's') },
      mo: function (c) { return c === 1 ? 'mês' : 'meses' },
      w: function (c) { return 'semana' + (c === 1 ? '' : 's') },
      d: function (c) { return 'dia' + (c === 1 ? '' : 's') },
      h: function (c) { return 'hora' + (c === 1 ? '' : 's') },
      m: function (c) { return 'minuto' + (c === 1 ? '' : 's') },
      s: function (c) { return 'segundo' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'milissegundo' + (c === 1 ? '' : 's') },
      decimal: ','
    },
    ro: {
      y: function (c) { return c === 1 ? 'an' : 'ani' },
      mo: function (c) { return c === 1 ? 'lună' : 'luni' },
      w: function (c) { return c === 1 ? 'săptămână' : 'săptămâni' },
      d: function (c) { return c === 1 ? 'zi' : 'zile' },
      h: function (c) { return c === 1 ? 'oră' : 'ore' },
      m: function (c) { return c === 1 ? 'minut' : 'minute' },
      s: function (c) { return c === 1 ? 'secundă' : 'secunde' },
      ms: function (c) { return c === 1 ? 'milisecundă' : 'milisecunde' },
      decimal: ','
    },
    ru: {
      y: function (c) { return ['лет', 'год', 'года'][getSlavicForm(c)] },
      mo: function (c) { return ['месяцев', 'месяц', 'месяца'][getSlavicForm(c)] },
      w: function (c) { return ['недель', 'неделя', 'недели'][getSlavicForm(c)] },
      d: function (c) { return ['дней', 'день', 'дня'][getSlavicForm(c)] },
      h: function (c) { return ['часов', 'час', 'часа'][getSlavicForm(c)] },
      m: function (c) { return ['минут', 'минута', 'минуты'][getSlavicForm(c)] },
      s: function (c) { return ['секунд', 'секунда', 'секунды'][getSlavicForm(c)] },
      ms: function (c) { return ['миллисекунд', 'миллисекунда', 'миллисекунды'][getSlavicForm(c)] },
      decimal: ','
    },
    uk: {
      y: function (c) { return ['років', 'рік', 'роки'][getSlavicForm(c)] },
      mo: function (c) { return ['місяців', 'місяць', 'місяці'][getSlavicForm(c)] },
      w: function (c) { return ['тижнів', 'тиждень', 'тижні'][getSlavicForm(c)] },
      d: function (c) { return ['днів', 'день', 'дні'][getSlavicForm(c)] },
      h: function (c) { return ['годин', 'година', 'години'][getSlavicForm(c)] },
      m: function (c) { return ['хвилин', 'хвилина', 'хвилини'][getSlavicForm(c)] },
      s: function (c) { return ['секунд', 'секунда', 'секунди'][getSlavicForm(c)] },
      ms: function (c) { return ['мілісекунд', 'мілісекунда', 'мілісекунди'][getSlavicForm(c)] },
      decimal: ','
    },
    ur: {
      y: 'سال',
      mo: function (c) { return c === 1 ? 'مہینہ' : 'مہینے' },
      w: function (c) { return c === 1 ? 'ہفتہ' : 'ہفتے' },
      d: 'دن',
      h: function (c) { return c === 1 ? 'گھنٹہ' : 'گھنٹے' },
      m: 'منٹ',
      s: 'سیکنڈ',
      ms: 'ملی سیکنڈ',
      decimal: '.'
    },
    sk: {
      y: function (c) { return ['rok', 'roky', 'roky', 'rokov'][getCzechOrSlovakForm(c)] },
      mo: function (c) { return ['mesiac', 'mesiace', 'mesiace', 'mesiacov'][getCzechOrSlovakForm(c)] },
      w: function (c) { return ['týždeň', 'týždne', 'týždne', 'týždňov'][getCzechOrSlovakForm(c)] },
      d: function (c) { return ['deň', 'dni', 'dni', 'dní'][getCzechOrSlovakForm(c)] },
      h: function (c) { return ['hodina', 'hodiny', 'hodiny', 'hodín'][getCzechOrSlovakForm(c)] },
      m: function (c) { return ['minúta', 'minúty', 'minúty', 'minút'][getCzechOrSlovakForm(c)] },
      s: function (c) { return ['sekunda', 'sekundy', 'sekundy', 'sekúnd'][getCzechOrSlovakForm(c)] },
      ms: function (c) { return ['milisekunda', 'milisekundy', 'milisekundy', 'milisekúnd'][getCzechOrSlovakForm(c)] },
      decimal: ','
    },
    sv: {
      y: 'år',
      mo: function (c) { return 'månad' + (c === 1 ? '' : 'er') },
      w: function (c) { return 'veck' + (c === 1 ? 'a' : 'or') },
      d: function (c) { return 'dag' + (c === 1 ? '' : 'ar') },
      h: function (c) { return 'timm' + (c === 1 ? 'e' : 'ar') },
      m: function (c) { return 'minut' + (c === 1 ? '' : 'er') },
      s: function (c) { return 'sekund' + (c === 1 ? '' : 'er') },
      ms: function (c) { return 'millisekund' + (c === 1 ? '' : 'er') },
      decimal: ','
    },
    tr: {
      y: 'yıl',
      mo: 'ay',
      w: 'hafta',
      d: 'gün',
      h: 'saat',
      m: 'dakika',
      s: 'saniye',
      ms: 'milisaniye',
      decimal: ','
    },
    th: {
      y: 'ปี',
      mo: 'เดือน',
      w: 'อาทิตย์',
      d: 'วัน',
      h: 'ชั่วโมง',
      m: 'นาที',
      s: 'วินาที',
      ms: 'มิลลิวินาที',
      decimal: '.'
    },
    vi: {
      y: 'năm',
      mo: 'tháng',
      w: 'tuần',
      d: 'ngày',
      h: 'giờ',
      m: 'phút',
      s: 'giây',
      ms: 'mili giây',
      decimal: ','
    },
    zh_CN: {
      y: '年',
      mo: '个月',
      w: '周',
      d: '天',
      h: '小时',
      m: '分钟',
      s: '秒',
      ms: '毫秒',
      decimal: '.'
    },
    zh_TW: {
      y: '年',
      mo: '個月',
      w: '周',
      d: '天',
      h: '小時',
      m: '分鐘',
      s: '秒',
      ms: '毫秒',
      decimal: '.'
    }
  }

  // You can create a humanizer, which returns a function with default
  // parameters.
  function humanizer (passedOptions) {
    var result = function humanizer (ms, humanizerOptions) {
      var options = extend({}, result, humanizerOptions || {})
      return doHumanization(ms, options)
    }

    return extend(result, {
      language: 'en',
      delimiter: ', ',
      spacer: ' ',
      conjunction: '',
      serialComma: true,
      units: ['y', 'mo', 'w', 'd', 'h', 'm', 's'],
      languages: {},
      round: false,
      unitMeasures: {
        y: 31557600000,
        mo: 2629800000,
        w: 604800000,
        d: 86400000,
        h: 3600000,
        m: 60000,
        s: 1000,
        ms: 1
      }
    }, passedOptions)
  }

  // The main function is just a wrapper around a default humanizer.
  var humanizeDuration = humanizer({})

  // Build dictionary from options
  function getDictionary (options) {
    var languagesFromOptions = [options.language]

    if (has(options, 'fallbacks')) {
      if (isArray(options.fallbacks) && options.fallbacks.length) {
        languagesFromOptions = languagesFromOptions.concat(options.fallbacks)
      } else {
        throw new Error('fallbacks must be an array with at least one element')
      }
    }

    for (var i = 0; i < languagesFromOptions.length; i++) {
      var languageToTry = languagesFromOptions[i]
      if (has(options.languages, languageToTry)) {
        return options.languages[languageToTry]
      } else if (has(languages, languageToTry)) {
        return languages[languageToTry]
      }
    }

    throw new Error('No language found.')
  }

  // doHumanization does the bulk of the work.
  function doHumanization (ms, options) {
    var i, len, piece

    // Make sure we have a positive number.
    // Has the nice sideffect of turning Number objects into primitives.
    ms = Math.abs(ms)

    var dictionary = getDictionary(options)
    var pieces = []

    // Start at the top and keep removing units, bit by bit.
    var unitName, unitMS, unitCount
    for (i = 0, len = options.units.length; i < len; i++) {
      unitName = options.units[i]
      unitMS = options.unitMeasures[unitName]

      // What's the number of full units we can fit?
      if (i + 1 === len) {
        if (has(options, 'maxDecimalPoints')) {
          // We need to use this expValue to avoid rounding functionality of toFixed call
          var expValue = Math.pow(10, options.maxDecimalPoints)
          var unitCountFloat = (ms / unitMS)
          unitCount = parseFloat((Math.floor(expValue * unitCountFloat) / expValue).toFixed(options.maxDecimalPoints))
        } else {
          unitCount = ms / unitMS
        }
      } else {
        unitCount = Math.floor(ms / unitMS)
      }

      // Add the string.
      pieces.push({
        unitCount: unitCount,
        unitName: unitName
      })

      // Remove what we just figured out.
      ms -= unitCount * unitMS
    }

    var firstOccupiedUnitIndex = 0
    for (i = 0; i < pieces.length; i++) {
      if (pieces[i].unitCount) {
        firstOccupiedUnitIndex = i
        break
      }
    }

    if (options.round) {
      var ratioToLargerUnit, previousPiece
      for (i = pieces.length - 1; i >= 0; i--) {
        piece = pieces[i]
        piece.unitCount = Math.round(piece.unitCount)

        if (i === 0) { break }

        previousPiece = pieces[i - 1]

        ratioToLargerUnit = options.unitMeasures[previousPiece.unitName] / options.unitMeasures[piece.unitName]
        if ((piece.unitCount % ratioToLargerUnit) === 0 || (options.largest && ((options.largest - 1) < (i - firstOccupiedUnitIndex)))) {
          previousPiece.unitCount += piece.unitCount / ratioToLargerUnit
          piece.unitCount = 0
        }
      }
    }

    var result = []
    for (i = 0, pieces.length; i < len; i++) {
      piece = pieces[i]
      if (piece.unitCount) {
        result.push(render(piece.unitCount, piece.unitName, dictionary, options))
      }

      if (result.length === options.largest) { break }
    }

    if (result.length) {
      if (!options.conjunction || result.length === 1) {
        return result.join(options.delimiter)
      } else if (result.length === 2) {
        return result.join(options.conjunction)
      } else if (result.length > 2) {
        return result.slice(0, -1).join(options.delimiter) + (options.serialComma ? ',' : '') + options.conjunction + result.slice(-1)
      }
    } else {
      return render(0, options.units[options.units.length - 1], dictionary, options)
    }
  }

  function render (count, type, dictionary, options) {
    var decimal
    if (has(options, 'decimal')) {
      decimal = options.decimal
    } else if (has(dictionary, 'decimal')) {
      decimal = dictionary.decimal
    } else {
      decimal = '.'
    }

    var countStr = count.toString().replace('.', decimal)

    var dictionaryValue = dictionary[type]
    var word
    if (typeof dictionaryValue === 'function') {
      word = dictionaryValue(count)
    } else {
      word = dictionaryValue
    }

    return countStr + options.spacer + word
  }

  function extend (destination) {
    var source
    for (var i = 1; i < arguments.length; i++) {
      source = arguments[i]
      for (var prop in source) {
        if (has(source, prop)) {
          destination[prop] = source[prop]
        }
      }
    }
    return destination
  }

  // Internal helper function for Polish language.
  function getPolishForm (c) {
    if (c === 1) {
      return 0
    } else if (Math.floor(c) !== c) {
      return 1
    } else if (c % 10 >= 2 && c % 10 <= 4 && !(c % 100 > 10 && c % 100 < 20)) {
      return 2
    } else {
      return 3
    }
  }

  // Internal helper function for Russian and Ukranian languages.
  function getSlavicForm (c) {
    if (Math.floor(c) !== c) {
      return 2
    } else if ((c % 100 >= 5 && c % 100 <= 20) || (c % 10 >= 5 && c % 10 <= 9) || c % 10 === 0) {
      return 0
    } else if (c % 10 === 1) {
      return 1
    } else if (c > 1) {
      return 2
    } else {
      return 0
    }
  }

  // Internal helper function for Slovak language.
  function getCzechOrSlovakForm (c) {
    if (c === 1) {
      return 0
    } else if (Math.floor(c) !== c) {
      return 1
    } else if (c % 10 >= 2 && c % 10 <= 4 && c % 100 < 10) {
      return 2
    } else {
      return 3
    }
  }

  // Internal helper function for Lithuanian language.
  function getLithuanianForm (c) {
    if (c === 1 || (c % 10 === 1 && c % 100 > 20)) {
      return 0
    } else if (Math.floor(c) !== c || (c % 10 >= 2 && c % 100 > 20) || (c % 10 >= 2 && c % 100 < 10)) {
      return 1
    } else {
      return 2
    }
  }

  // Internal helper function for Latvian language.
  function getLatvianForm (c) {
    if (c === 1 || (c % 10 === 1 && c % 100 !== 11)) {
      return 0
    } else {
      return 1
    }
  }

  // Internal helper function for Arabic language.
  function getArabicForm (c) {
    if (c <= 2) { return 0 }
    if (c > 2 && c < 11) { return 1 }
    return 0
  }

  // We need to make sure we support browsers that don't have
  // `Array.isArray`, so we define a fallback here.
  var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }

  function has (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key)
  }

  humanizeDuration.getSupportedLanguages = function getSupportedLanguages () {
    var result = []
    for (var language in languages) {
      if (has(languages, language) && language !== 'gr') {
        result.push(language)
      }
    }
    return result
  }

  humanizeDuration.humanizer = humanizer

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return humanizeDuration
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module !== 'undefined' && module.exports) {
    module.exports = humanizeDuration
  } else {
    this.humanizeDuration = humanizeDuration
  }
})(); // eslint-disable-line semi


/***/ }),
/* 1538 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1539 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* 
 * Angular JS Multi Select
 * Creates a dropdown-like button with checkboxes. 
 *
 * Project started on: Tue, 14 Jan 2014 - 5:18:02 PM
 * Current version: 4.0.0
 * 
 * Released under the MIT License
 * --------------------------------------------------------------------------------
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Ignatius Steven (https://github.com/isteven)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy 
 * of this software and associated documentation files (the "Software"), to deal 
 * in the Software without restriction, including without limitation the rights 
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell 
 * copies of the Software, and to permit persons to whom the Software is 
 * furnished to do so, subject to the following conditions: 
 *
 * The above copyright notice and this permission notice shall be included in all 
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, 
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE 
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER 
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE 
 * SOFTWARE.
 * --------------------------------------------------------------------------------
 */



angular.module( 'isteven-multi-select', ['ng'] ).directive( 'istevenMultiSelect' , [ '$sce', '$timeout', '$templateCache', function ( $sce, $timeout, $templateCache ) {
    return {
        restrict: 
            'AE',

        scope: 
        {   
            // models
            inputModel      : '=',
            outputModel     : '=',

            // settings based on attribute
            isDisabled      : '=',

            // callbacks
            onClear         : '&',  
            onClose         : '&',
            onSearchChange  : '&',  
            onItemClick     : '&',            
            onOpen          : '&', 
            onReset         : '&',  
            onSelectAll     : '&',  
            onSelectNone    : '&',  

            // i18n
            translation     : '='   
        },
        
        /* 
         * The rest are attributes. They don't need to be parsed / binded, so we can safely access them by value.
         * - buttonLabel, directiveId, helperElements, itemLabel, maxLabels, orientation, selectionMode, minSearchLength,
         *   tickProperty, disableProperty, groupProperty, searchProperty, maxHeight, outputProperties
         */
                                                         
         templateUrl: 
            'isteven-multi-select.htm',                            

        link: function ( $scope, element, attrs ) {                       

            $scope.backUp           = [];
            $scope.varButtonLabel   = '';               
            $scope.spacingProperty  = '';
            $scope.indexProperty    = '';                        
            $scope.orientationH     = false;
            $scope.orientationV     = true;
            $scope.filteredModel    = [];
            $scope.inputLabel       = { labelFilter: '' };                        
            $scope.tabIndex         = 0;            
            $scope.lang             = {};
            $scope.helperStatus     = {
                all     : true,
                none    : true,
                reset   : true,
                filter  : true
            };

            var 
                prevTabIndex        = 0,
                helperItems         = [],
                helperItemsLength   = 0,
                checkBoxLayer       = '',
                scrolled            = false,
                selectedItems       = [],
                formElements        = [],
                vMinSearchLength    = 0,
                clickedItem         = null                

            // v3.0.0
            // clear button clicked
            $scope.clearClicked = function( e ) {                
                $scope.inputLabel.labelFilter = '';
                $scope.updateFilter();
                $scope.select( 'clear', e );                
            }

            // A little hack so that AngularJS ng-repeat can loop using start and end index like a normal loop
            // http://stackoverflow.com/questions/16824853/way-to-ng-repeat-defined-number-of-times-instead-of-repeating-over-array
            $scope.numberToArray = function( num ) {
                return new Array( num );   
            }

            // Call this function when user type on the filter field
            $scope.searchChanged = function() {                                                
                if ( $scope.inputLabel.labelFilter.length < vMinSearchLength && $scope.inputLabel.labelFilter.length > 0 ) {
                    return false;
                }                
                $scope.updateFilter();
            }

            $scope.updateFilter = function()
            {      
                // we check by looping from end of input-model
                $scope.filteredModel = [];
                var i = 0;

                if ( typeof $scope.inputModel === 'undefined' ) {
                    return false;                   
                }

                for( i = $scope.inputModel.length - 1; i >= 0; i-- ) {

                    // if it's group end, we push it to filteredModel[];
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === false ) {
                        $scope.filteredModel.push( $scope.inputModel[ i ] );
                    }
                    
                    // if it's data 
                    var gotData = false;
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] === 'undefined' ) {                        
                        
                        // If we set the search-key attribute, we use this loop. 
                        if ( typeof attrs.searchProperty !== 'undefined' && attrs.searchProperty !== '' ) {

                            for (var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                    && attrs.searchProperty.indexOf( key ) > -1
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }
                        // if there's no search-key attribute, we use this one. Much better on performance.
                        else {
                            for ( var key in $scope.inputModel[ i ]  ) {
                                if ( 
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }                        
                        }

                        if ( gotData === true ) {    
                            // push
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }

                    // if it's group start
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === true ) {

                        if ( typeof $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] !== 'undefined' 
                                && $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] === false ) {
                            $scope.filteredModel.pop();
                        }
                        else {
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }
                }                

                $scope.filteredModel.reverse();  
                
                $timeout( function() {                    

                    $scope.getFormElements();               
                    
                    // Callback: on filter change                      
                    if ( $scope.inputLabel.labelFilter.length > vMinSearchLength ) {

                        var filterObj = [];

                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' ) {                   
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                                                    
                                    var tempObj = angular.copy( value );
                                    var index = filterObj.push( tempObj );                                
                                    delete filterObj[ index - 1 ][ $scope.indexProperty ];
                                    delete filterObj[ index - 1 ][ $scope.spacingProperty ];      
                                }
                            }
                        });

                        $scope.onSearchChange({ 
                            data: 
                            {
                                keyword: $scope.inputLabel.labelFilter, 
                                result: filterObj 
                            } 
                        });
                    }
                },0);
            };

            // List all the input elements. We need this for our keyboard navigation.
            // This function will be called everytime the filter is updated. 
            // Depending on the size of filtered mode, might not good for performance, but oh well..
            $scope.getFormElements = function() {                                     
                formElements = [];

                var 
                    selectButtons   = [],
                    inputField      = [],
                    checkboxes      = [],
                    clearButton     = [];
                
                // If available, then get select all, select none, and reset buttons
                if ( $scope.helperStatus.all || $scope.helperStatus.none || $scope.helperStatus.reset ) {                                                       
                    selectButtons = element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );                    
                    // If available, then get the search box and the clear button
                    if ( $scope.helperStatus.filter ) {                                            
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'button' );                        
                    }
                }
                else {
                    if ( $scope.helperStatus.filter ) {   
                        // Get helper - search and clear button. 
                        inputField =    element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'input' );                    
                        clearButton =   element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    }
                }
               
                // Get checkboxes
                if ( !$scope.helperStatus.all && !$scope.helperStatus.none && !$scope.helperStatus.reset && !$scope.helperStatus.filter ) {
                    checkboxes = element.children().children().next()[ 0 ].getElementsByTagName( 'input' );
                }
                else {
                    checkboxes = element.children().children().next().children().next()[ 0 ].getElementsByTagName( 'input' );
                }

                // Push them into global array formElements[] 
                for ( var i = 0; i < selectButtons.length ; i++ )   { formElements.push( selectButtons[ i ] );  }
                for ( var i = 0; i < inputField.length ; i++ )      { formElements.push( inputField[ i ] );     }
                for ( var i = 0; i < clearButton.length ; i++ )     { formElements.push( clearButton[ i ] );    }
                for ( var i = 0; i < checkboxes.length ; i++ )      { formElements.push( checkboxes[ i ] );     }                                
            }            

            // check if an item has attrs.groupProperty (be it true or false)
            $scope.isGroupMarker = function( item , type ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === type ) return true; 
                return false;
            }

            $scope.removeGroupEndMarker = function( item ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) return false; 
                return true;
            }                       

            // call this function when an item is clicked
            $scope.syncItems = function( item, e, ng_repeat_index ) {                                      

                e.preventDefault();
                e.stopPropagation();

                // if the directive is globaly disabled, do nothing
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return false;
                }

                // if item is disabled, do nothing
                if ( typeof attrs.isDisabled !== 'undefined' && $scope.isDisabled === true ) {                        
                    return false;
                }                                

                // if end group marker is clicked, do nothing
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) {
                    return false;
                }                

                var index = $scope.filteredModel.indexOf( item );       

                // if the start of group marker is clicked ( only for multiple selection! )
                // how it works:
                // - if, in a group, there are items which are not selected, then they all will be selected
                // - if, in a group, all items are selected, then they all will be de-selected                
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === true ) {                                  

                    // this is only for multiple selection, so if selection mode is single, do nothing
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        return false;
                    }
                    
                    var i,j,k;
                    var startIndex = 0;
                    var endIndex = $scope.filteredModel.length - 1;
                    var tempArr = [];

                    // nest level is to mark the depth of the group.
                    // when you get into a group (start group marker), nestLevel++
                    // when you exit a group (end group marker), nextLevel--
                    var nestLevel = 0;                    

                    // we loop throughout the filtered model (not whole model)
                    for( i = index ; i < $scope.filteredModel.length ; i++) {  

                        // this break will be executed when we're done processing each group
                        if ( nestLevel === 0 && i > index ) 
                        {
                            break;
                        }
                    
                        if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === true ) {
                            
                            // To cater multi level grouping
                            if ( tempArr.length === 0 ) {
                                startIndex = i + 1; 
                            }                            
                            nestLevel = nestLevel + 1;
                        }                                                

                        // if group end
                        else if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === false ) {

                            nestLevel = nestLevel - 1;                            

                            // cek if all are ticked or not                            
                            if ( tempArr.length > 0 && nestLevel === 0 ) {                                

                                var allTicked = true;       

                                endIndex = i;

                                for ( j = 0; j < tempArr.length ; j++ ) {                                
                                    if ( typeof tempArr[ j ][ $scope.tickProperty ] !== 'undefined' &&  tempArr[ j ][ $scope.tickProperty ] === false ) {
                                        allTicked = false;
                                        break;
                                    }
                                }                                                                                    

                                if ( allTicked === true ) {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                        }
                                    }                                
                                }

                                else {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;                                                
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;

                                            }                                            
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
                                            }
                                        }
                                    }                                
                                }                                                                                    
                            }
                        }
            
                        // if data
                        else {                            
                            tempArr.push( $scope.filteredModel[ i ] );                                                                                    
                        }
                    }                                 
                }

                // if an item (not group marker) is clicked
                else {

                    // If it's single selection mode
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        
                        // first, set everything to false
                        for( i=0 ; i < $scope.filteredModel.length ; i++) {                            
                            $scope.filteredModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        for( i=0 ; i < $scope.inputModel.length ; i++) {                            
                            $scope.inputModel[ i ][ $scope.tickProperty ] = false;                            
                        }        
                        
                        // then set the clicked item to true
                        $scope.filteredModel[ index ][ $scope.tickProperty ] = true;                                                                 
                    }   

                    // Multiple
                    else {
                        $scope.filteredModel[ index ][ $scope.tickProperty ]   = !$scope.filteredModel[ index ][ $scope.tickProperty ];
                    }

                    // we refresh input model as well
                    var inputModelIndex = $scope.filteredModel[ index ][ $scope.indexProperty ];                                        
                    $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = $scope.filteredModel[ index ][ $scope.tickProperty ];                    
                }                                  

                // we execute the callback function here
                clickedItem = angular.copy( item );                                                    
                if ( clickedItem !== null ) {                        
                    $timeout( function() {
                        delete clickedItem[ $scope.indexProperty ];
                        delete clickedItem[ $scope.spacingProperty ];      
                        $scope.onItemClick( { data: clickedItem } );
                        clickedItem = null;                    
                    }, 0 );                                                 
                }                                    
                
                $scope.refreshOutputModel();
                $scope.refreshButton();                              

                // We update the index here
                prevTabIndex = $scope.tabIndex;
                $scope.tabIndex = ng_repeat_index + helperItemsLength;
                                
                // Set focus on the hidden checkbox 
                e.target.focus();

                // set & remove CSS style
                $scope.removeFocusStyle( prevTabIndex );
                $scope.setFocusStyle( $scope.tabIndex );

                if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                    // on single selection mode, we then hide the checkbox layer
                    $scope.toggleCheckboxes( e );       
                }
            }     

            // update $scope.outputModel
            $scope.refreshOutputModel = function() {            
                
                $scope.outputModel  = [];
                var 
                    outputProps     = [],
                    tempObj         = {};

                // v4.0.0
                if ( typeof attrs.outputProperties !== 'undefined' ) {                    
                    outputProps = attrs.outputProperties.split(' ');                
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            tempObj         = {};
                            angular.forEach( value, function( value1, key1 ) {                                
                                if ( outputProps.indexOf( key1 ) > -1 ) {                                                                         
                                    tempObj[ key1 ] = value1;                                    
                                }
                            });
                            var index = $scope.outputModel.push( tempObj );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
                else {
                    angular.forEach( $scope.inputModel, function( value, key ) {                    
                        if ( 
                            typeof value !== 'undefined' 
                            && typeof value[ attrs.groupProperty ] === 'undefined' 
                            && value[ $scope.tickProperty ] === true 
                        ) {
                            var temp = angular.copy( value );
                            var index = $scope.outputModel.push( temp );                                                               
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
                        }
                    });         
                }
            }

            // refresh button label
            $scope.refreshButton = function() {

                $scope.varButtonLabel   = '';                
                var ctr                 = 0;                  

                // refresh button label...
                if ( $scope.outputModel.length === 0 ) {
                    // https://github.com/isteven/angular-multi-select/pull/19                    
                    $scope.varButtonLabel = $scope.lang.nothingSelected;
                }
                else {                
                    var tempMaxLabels = $scope.outputModel.length;
                    if ( typeof attrs.maxLabels !== 'undefined' && attrs.maxLabels !== '' ) {
                        tempMaxLabels = attrs.maxLabels;
                    }

                    // if max amount of labels displayed..
                    if ( $scope.outputModel.length > tempMaxLabels ) {
                        $scope.more = true;
                    }
                    else {
                        $scope.more = false;
                    }                
                    
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if ( typeof value !== 'undefined' && value[ attrs.tickProperty ] === true ) {                        
                            if ( ctr < tempMaxLabels ) {                            
                                $scope.varButtonLabel += ( $scope.varButtonLabel.length > 0 ? '</div>, <div class="buttonLabel">' : '<div class="buttonLabel">') + $scope.writeLabel( value, 'buttonLabel' );
                            }
                            ctr++;
                        }
                    });                

                    if ( $scope.more === true ) {
                        // https://github.com/isteven/angular-multi-select/pull/16
                        if (tempMaxLabels > 0) {
                            $scope.varButtonLabel += ', ... ';
                        }
                        $scope.varButtonLabel += '(' + $scope.outputModel.length + ')';                        
                    }
                }
                $scope.varButtonLabel = $sce.trustAsHtml( $scope.varButtonLabel + '<span class="caret"></span>' );                
            }

            // Check if a checkbox is disabled or enabled. It will check the granular control (disableProperty) and global control (isDisabled)
            // Take note that the granular control has higher priority.
            $scope.itemIsDisabled = function( item ) {
                
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
                    return true;
                }
                else {             
                    if ( $scope.isDisabled === true ) {                        
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                
            }

            // A simple function to parse the item label settings. Used on the buttons and checkbox labels.
            $scope.writeLabel = function( item, type ) {
                
                // type is either 'itemLabel' or 'buttonLabel'
                var temp    = attrs[ type ].split( ' ' );                    
                var label   = '';                

                angular.forEach( temp, function( value, key ) {                    
                    item[ value ] && ( label += '&nbsp;' + value.split( '.' ).reduce( function( prev, current ) {
                        return prev[ current ]; 
                    }, item ));        
                });
                
                if ( type.toUpperCase() === 'BUTTONLABEL' ) {                    
                    return label;
                }
                return $sce.trustAsHtml( label );
            }                                

            // UI operations to show/hide checkboxes based on click event..
            $scope.toggleCheckboxes = function( e ) {                                    
                
                // We grab the button
                var clickedEl = element.children()[0];

                // Just to make sure.. had a bug where key events were recorded twice
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );        

                // The idea below was taken from another multi-select directive - https://github.com/amitava82/angular-multiselect 
                // His version is awesome if you need a more simple multi-select approach.                                

                // close
                if ( angular.element( checkBoxLayer ).hasClass( 'show' )) {                         

                    angular.element( checkBoxLayer ).removeClass( 'show' );                    
                    angular.element( clickedEl ).removeClass( 'buttonClicked' );                    
                    angular.element( document ).off( 'click', $scope.externalClickListener );
                    angular.element( document ).off( 'keydown', $scope.keyboardListener );                                    

                    // clear the focused element;
                    $scope.removeFocusStyle( $scope.tabIndex );
                    if ( typeof formElements[ $scope.tabIndex ] !== 'undefined' ) {
                        formElements[ $scope.tabIndex ].blur();
                    }

                    // close callback
                    $timeout( function() {
                        $scope.onClose();
                    }, 0 );

                    // set focus on button again
                    element.children().children()[ 0 ].focus();
                } 
                // open
                else                 
                {    
                    // clear filter
                    $scope.inputLabel.labelFilter = '';                
                    $scope.updateFilter();                                

                    helperItems = [];
                    helperItemsLength = 0;

                    angular.element( checkBoxLayer ).addClass( 'show' );
                    angular.element( clickedEl ).addClass( 'buttonClicked' );       

                    // Attach change event listener on the input filter. 
                    // We need this because ng-change is apparently not an event listener.                    
                    angular.element( document ).on( 'click', $scope.externalClickListener );
                    angular.element( document ).on( 'keydown', $scope.keyboardListener );  

                    // to get the initial tab index, depending on how many helper elements we have. 
                    // priority is to always focus it on the input filter                                                                
                    $scope.getFormElements();
                    $scope.tabIndex = 0;

                    var helperContainer = angular.element( element[ 0 ].querySelector( '.helperContainer' ) )[0];                
                    
                    if ( typeof helperContainer !== 'undefined' ) {
                        for ( var i = 0; i < helperContainer.getElementsByTagName( 'BUTTON' ).length ; i++ ) {
                            helperItems[ i ] = helperContainer.getElementsByTagName( 'BUTTON' )[ i ];
                        }
                        helperItemsLength = helperItems.length + helperContainer.getElementsByTagName( 'INPUT' ).length;
                    }
                    
                    // focus on the filter element on open. 
                    if ( element[ 0 ].querySelector( '.inputFilter' ) ) {                        
                        element[ 0 ].querySelector( '.inputFilter' ).focus();    
                        $scope.tabIndex = $scope.tabIndex + helperItemsLength - 2;
                        // blur button in vain
                        angular.element( element ).children()[ 0 ].blur();
                    }
                    // if there's no filter then just focus on the first checkbox item
                    else {                  
                        if ( !$scope.isDisabled ) {                        
                            $scope.tabIndex = $scope.tabIndex + helperItemsLength;
                            if ( $scope.inputModel.length > 0 ) {
                                formElements[ $scope.tabIndex ].focus();
                                $scope.setFocusStyle( $scope.tabIndex );
                                // blur button in vain
                                angular.element( element ).children()[ 0 ].blur();
                            }                            
                        }
                    }                          

                    // open callback
                    $scope.onOpen();
                }                            
            }
            
            // handle clicks outside the button / multi select layer
            $scope.externalClickListener = function( e ) {                   

                var targetsArr = element.find( e.target.tagName );
                for (var i = 0; i < targetsArr.length; i++) {                                        
                    if ( e.target == targetsArr[i] ) {
                        return;
                    }
                }

                angular.element( checkBoxLayer.previousSibling ).removeClass( 'buttonClicked' );                    
                angular.element( checkBoxLayer ).removeClass( 'show' );
                angular.element( document ).off( 'click', $scope.externalClickListener ); 
                angular.element( document ).off( 'keydown', $scope.keyboardListener );                
                
                // close callback                
                $timeout( function() {
                    $scope.onClose();
                }, 0 );

                // set focus on button again
                element.children().children()[ 0 ].focus();
            }
   
            // select All / select None / reset buttons
            $scope.select = function( type, e ) {

                var helperIndex = helperItems.indexOf( e.target );
                $scope.tabIndex = helperIndex;

                switch( type.toUpperCase() ) {
                    case 'ALL':
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                                
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = true;
                                }
                            }
                        });                            
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                  
                        $scope.onSelectAll();                                                
                        break;
                    case 'NONE':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
                                    value[ $scope.tickProperty ] = false;
                                }
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onSelectNone();                        
                        break;
                    case 'RESET':            
                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
                            if ( typeof value[ attrs.groupProperty ] === 'undefined' && typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
                                var temp = value[ $scope.indexProperty ];                                
                                value[ $scope.tickProperty ] = $scope.backUp[ temp ][ $scope.tickProperty ];
                            }
                        });               
                        $scope.refreshOutputModel();                                    
                        $scope.refreshButton();                                                                          
                        $scope.onReset();                        
                        break;
                    case 'CLEAR':
                        $scope.tabIndex = $scope.tabIndex + 1;
                        $scope.onClear();    
                        break;
                    case 'FILTER':                        
                        $scope.tabIndex = helperItems.length - 1;
                        break;
                    default:                        
                }                                                                                 
            }            

            // just to create a random variable name                
            function genRandomString( length ) {                
                var possible    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                var temp        = '';
                for( var i=0; i < length; i++ ) {
                     temp += possible.charAt( Math.floor( Math.random() * possible.length ));
                }
                return temp;
            }

            // count leading spaces
            $scope.prepareGrouping = function() {
                var spacing     = 0;                                                
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.spacingProperty ] = spacing;                    
                    if ( value[ attrs.groupProperty ] === true ) {
                        spacing+=2;
                    }                    
                    else if ( value[ attrs.groupProperty ] === false ) {
                        spacing-=2;
                    }                 
                });
            }

            // prepare original index
            $scope.prepareIndex = function() {
                var ctr = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.indexProperty ] = ctr;
                    ctr++;
                });
            }

            // navigate using up and down arrow
            $scope.keyboardListener = function( e ) { 
                
                var key = e.keyCode ? e.keyCode : e.which;      
                var isNavigationKey = false;                                                

                // ESC key (close)
                if ( key === 27 ) {
                    e.preventDefault();                   
                    e.stopPropagation();
                    $scope.toggleCheckboxes( e );
                }                    
                
                
                // next element ( tab, down & right key )                    
                else if ( key === 40 || key === 39 || ( !e.shiftKey && key == 9 ) ) {                    
                    
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex++;                         
                    if ( $scope.tabIndex > formElements.length - 1 ) {
                        $scope.tabIndex = 0;
                        prevTabIndex = formElements.length - 1; 
                    }                                                            
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex++;
                        if ( $scope.tabIndex > formElements.length - 1 ) {
                            $scope.tabIndex = 0;                            
                        }                                                                                    
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                    }              
                }
                  
                // prev element ( shift+tab, up & left key )
                else if ( key === 38 || key === 37 || ( e.shiftKey && key == 9 ) ) { 
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex; 
                    $scope.tabIndex--;                              
                    if ( $scope.tabIndex < 0 ) {
                        $scope.tabIndex = formElements.length - 1;
                        prevTabIndex = 0;
                    }                                         
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {                        
                        $scope.tabIndex--;
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }                                            
                        if ( $scope.tabIndex < 0 ) {
                            $scope.tabIndex = formElements.length - 1;
                        }                             
                    }                                                     
                }                    

                if ( isNavigationKey === true ) {                                         
                    
                    e.preventDefault();

                    // set focus on the checkbox                    
                    formElements[ $scope.tabIndex ].focus();    
                    var actEl = document.activeElement;                     
                    
                    if ( actEl.type.toUpperCase() === 'CHECKBOX' ) {                                                   
                        $scope.setFocusStyle( $scope.tabIndex );
                        $scope.removeFocusStyle( prevTabIndex );
                    }                    
                    else {
                        $scope.removeFocusStyle( prevTabIndex );
                        $scope.removeFocusStyle( helperItemsLength );
                        $scope.removeFocusStyle( formElements.length - 1 );
                    } 
                }                

                isNavigationKey = false;
            }

            // set (add) CSS style on selected row
            $scope.setFocusStyle = function( tabIndex ) {                                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().addClass( 'multiSelectFocus' );                        
            }

            // remove CSS style on selected row
            $scope.removeFocusStyle = function( tabIndex ) {                
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().removeClass( 'multiSelectFocus' );
            }

            /*********************
             *********************             
             *
             * 1) Initializations
             *
             *********************
             *********************/

            // attrs to $scope - attrs-$scope - attrs - $scope
            // Copy some properties that will be used on the template. They need to be in the $scope.
            $scope.groupProperty    = attrs.groupProperty;   
            $scope.tickProperty     = attrs.tickProperty;
            $scope.directiveId      = attrs.directiveId;
            
            // Unfortunately I need to add these grouping properties into the input model
            var tempStr = genRandomString( 5 );
            $scope.indexProperty = 'idx_' + tempStr;
            $scope.spacingProperty = 'spc_' + tempStr;         

            // set orientation css            
            if ( typeof attrs.orientation !== 'undefined' ) {

                if ( attrs.orientation.toUpperCase() === 'HORIZONTAL' ) {                    
                    $scope.orientationH = true;
                    $scope.orientationV = false;
                }
                else 
                {
                    $scope.orientationH = false;
                    $scope.orientationV = true;
                }
            }            

            // get elements required for DOM operation
            checkBoxLayer = element.children().children().next()[0];

            // set max-height property if provided
            if ( typeof attrs.maxHeight !== 'undefined' ) {                
                var layer = element.children().children().children()[0];
                angular.element( layer ).attr( "style", "height:" + attrs.maxHeight + "; overflow-y:scroll;" );                                
            }

            // some flags for easier checking            
            for ( var property in $scope.helperStatus ) {
                if ( $scope.helperStatus.hasOwnProperty( property )) {                    
                    if ( 
                        typeof attrs.helperElements !== 'undefined' 
                        && attrs.helperElements.toUpperCase().indexOf( property.toUpperCase() ) === -1 
                    ) {
                        $scope.helperStatus[ property ] = false;
                    }
                }
            }
            if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' )  {
                $scope.helperStatus[ 'all' ] = false;
                $scope.helperStatus[ 'none' ] = false;
            }

            // helper button icons.. I guess you can use html tag here if you want to. 
            $scope.icon        = {};            
            $scope.icon.selectAll  = '&#10003;';    // a tick icon
            $scope.icon.selectNone = '&times;';     // x icon
            $scope.icon.reset      = '&#8630;';     // undo icon            
            // this one is for the selected items
            $scope.icon.tickMark   = '&#10003;';    // a tick icon 

            // configurable button labels                       
            if ( typeof attrs.translation !== 'undefined' ) {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;' + $scope.translation.selectAll );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;' + $scope.translation.selectNone );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;' + $scope.translation.reset );
                $scope.lang.search          = $scope.translation.search;                
                $scope.lang.nothingSelected = $sce.trustAsHtml( $scope.translation.nothingSelected );                
            }
            else {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;Select All' );                
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;Select None' );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;Reset' );
                $scope.lang.search          = 'Search...';
                $scope.lang.nothingSelected = 'None Selected';                
            }
            $scope.icon.tickMark = $sce.trustAsHtml( $scope.icon.tickMark );
                
            // min length of keyword to trigger the filter function
            if ( typeof attrs.MinSearchLength !== 'undefined' && parseInt( attrs.MinSearchLength ) > 0 ) {
                vMinSearchLength = Math.floor( parseInt( attrs.MinSearchLength ) );
            }

            /*******************************************************
             *******************************************************
             *
             * 2) Logic starts here, initiated by watch 1 & watch 2
             *
             *******************************************************
             *******************************************************/
            
            // watch1, for changes in input model property
            // updates multi-select when user select/deselect a single checkbox programatically
            // https://github.com/isteven/angular-multi-select/issues/8            
            $scope.$watch( 'inputModel' , function( newVal ) {                                 
                if ( newVal ) {                            
                    $scope.refreshOutputModel();                                    
                    $scope.refreshButton();                                                  
                }
            }, true );
            
            // watch2 for changes in input model as a whole
            // this on updates the multi-select when a user load a whole new input-model. We also update the $scope.backUp variable
            $scope.$watch( 'inputModel' , function( newVal ) {  
                if ( newVal ) {
                    $scope.backUp = angular.copy( $scope.inputModel );    
                    $scope.updateFilter();
                    $scope.prepareGrouping();
                    $scope.prepareIndex();                                                              
                    $scope.refreshOutputModel();                
                    $scope.refreshButton();                                                                                                                 
                }
            });                        

            // watch for changes in directive state (disabled or enabled)
            $scope.$watch( 'isDisabled' , function( newVal ) {         
                $scope.isDisabled = newVal;                               
            });            
            
            // this is for touch enabled devices. We don't want to hide checkboxes on scroll. 
            var onTouchStart = function( e ) { 
            	$scope.$apply( function() {
            		$scope.scrolled = false;
            	}); 
            };
            angular.element( document ).bind( 'touchstart', onTouchStart);
            var onTouchMove = function( e ) { 
            	$scope.$apply( function() {
            		$scope.scrolled = true;                
            	});
            };
            angular.element( document ).bind( 'touchmove', onTouchMove);            

            // unbind document events to prevent memory leaks
            $scope.$on( '$destroy', function () {
			    angular.element( document ).unbind( 'touchstart', onTouchStart);
            	angular.element( document ).unbind( 'touchmove', onTouchMove);
            });
        }
    }
}]).run( [ '$templateCache' , function( $templateCache ) {
    var template = 
        '<span class="multiSelect inlineBlock">' +
            // main button
            '<button id="{{directiveId}}" type="button"' +                
                'ng-click="toggleCheckboxes( $event ); refreshSelectedItems(); refreshButton(); prepareGrouping; prepareIndex();"' +
                'ng-bind-html="varButtonLabel"' +
                'ng-disabled="disable-button"' +
            '>' +
            '</button>' +
            // overlay layer
            '<div class="checkboxLayer">' +
                // container of the helper elements
                '<div class="helperContainer" ng-if="helperStatus.filter || helperStatus.all || helperStatus.none || helperStatus.reset ">' +
                    // container of the first 3 buttons, select all, none and reset
                    '<div class="line" ng-if="helperStatus.all || helperStatus.none || helperStatus.reset ">' +
                        // select all
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.all"' +
                            'ng-click="select( \'all\', $event );"' +
                            'ng-bind-html="lang.selectAll">' +
                        '</button>'+
                        // select none
                        '<button type="button" class="helperButton"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.none"' +
                            'ng-click="select( \'none\', $event );"' +
                            'ng-bind-html="lang.selectNone">' +
                        '</button>'+
                        // reset
                        '<button type="button" class="helperButton reset"' +
                            'ng-disabled="isDisabled"' + 
                            'ng-if="helperStatus.reset"' +
                            'ng-click="select( \'reset\', $event );"' +
                            'ng-bind-html="lang.reset">'+
                        '</button>' +
                    '</div>' +
                    // the search box
                    '<div class="line" style="position:relative" ng-if="helperStatus.filter">'+
                        // textfield                
                        '<input placeholder="{{lang.search}}" type="text"' +
                            'ng-click="select( \'filter\', $event )" '+
                            'ng-model="inputLabel.labelFilter" '+
                            'ng-change="searchChanged()" class="inputFilter"'+
                            '/>'+
                        // clear button
                        '<button type="button" class="clearButton" ng-click="clearClicked( $event )" >×</button> '+
                    '</div> '+
                '</div> '+
                // selection items
                '<div class="checkBoxContainer">'+
                    '<div '+
                        'ng-repeat="item in filteredModel | filter:removeGroupEndMarker" class="multiSelectItem"'+
                        'ng-class="{selected: item[ tickProperty ], horizontal: orientationH, vertical: orientationV, multiSelectGroup:item[ groupProperty ], disabled:itemIsDisabled( item )}"'+
                        'ng-click="syncItems( item, $event, $index );" '+
                        'ng-mouseleave="removeFocusStyle( tabIndex );"> '+
                        // this is the spacing for grouped items
                        '<div class="acol" ng-if="item[ spacingProperty ] > 0" ng-repeat="i in numberToArray( item[ spacingProperty ] ) track by $index">'+                        
                    '</div>  '+        
                    '<div class="acol">'+
                        '<label>'+                                
                            // input, so that it can accept focus on keyboard click
                            '<input class="checkbox focusable" type="checkbox" '+
                                'ng-disabled="itemIsDisabled( item )" '+
                                'ng-checked="item[ tickProperty ]" '+
                                'ng-click="syncItems( item, $event, $index )" />'+
                            // item label using ng-bind-hteml
                            '<span '+
                                'ng-class="{disabled:itemIsDisabled( item )}" '+
                                'ng-bind-html="writeLabel( item, \'itemLabel\' )">'+
                            '</span>'+
                        '</label>'+
                    '</div>'+
                    // the tick/check mark
                    '<span class="tickMark" ng-if="item[ groupProperty ] !== true && item[ tickProperty ] === true" ng-bind-html="icon.tickMark"></span>'+
                '</div>'+
            '</div>'+
        '</div>'+
    '</span>';
	$templateCache.put( 'isteven-multi-select.htm' , template );
}]); 


/***/ }),
/* 1541 */
/***/ (function(module, exports) {

module.exports = {"type":"FeatureCollection","features":[{"type":"Feature","id":"USA","properties":{"name":"United States of America"},"geometry":{"type":"MultiPolygon","coordinates":[[[[-155.54211,19.08348],[-155.68817,18.91619],[-155.93665,19.05939],[-155.90806,19.33888],[-156.07347,19.70294],[-156.02368,19.81422],[-155.85008,19.97729],[-155.91907,20.17395],[-155.86108,20.26721],[-155.78505,20.2487],[-155.40214,20.07975],[-155.22452,19.99302],[-155.06226,19.8591],[-154.80741,19.50871],[-154.83147,19.45328],[-155.22217,19.23972],[-155.54211,19.08348]]],[[[-156.07926,20.64397],[-156.41445,20.57241],[-156.58673,20.783],[-156.70167,20.8643],[-156.71055,20.92676],[-156.61258,21.01249],[-156.25711,20.91745],[-155.99566,20.76404],[-156.07926,20.64397]]],[[[-156.75824,21.17684],[-156.78933,21.06873],[-157.32521,21.09777],[-157.25027,21.21958],[-156.75824,21.17684]]],[[[-157.65283,21.32217],[-157.70703,21.26442],[-157.7786,21.27729],[-158.12667,21.31244],[-158.2538,21.53919],[-158.29265,21.57912],[-158.0252,21.71696],[-157.94161,21.65272],[-157.65283,21.32217]]],[[[-159.34512,21.982],[-159.46372,21.88299],[-159.80051,22.06533],[-159.74877,22.1382],[-159.5962,22.23618],[-159.36569,22.21494],[-159.34512,21.982]]],[[[-94.81758,49.38905],[-94.64,48.84],[-94.32914,48.67074],[-93.63087,48.60926],[-92.61,48.45],[-91.64,48.14],[-90.83,48.27],[-89.6,48.01],[-89.272917,48.019808],[-88.378114,48.302918],[-87.439793,47.94],[-86.461991,47.553338],[-85.652363,47.220219],[-84.87608,46.900083],[-84.779238,46.637102],[-84.543749,46.538684],[-84.6049,46.4396],[-84.3367,46.40877],[-84.14212,46.512226],[-84.091851,46.275419],[-83.890765,46.116927],[-83.616131,46.116927],[-83.469551,45.994686],[-83.592851,45.816894],[-82.550925,45.347517],[-82.337763,44.44],[-82.137642,43.571088],[-82.43,42.98],[-82.9,42.43],[-83.12,42.08],[-83.142,41.975681],[-83.02981,41.832796],[-82.690089,41.675105],[-82.439278,41.675105],[-81.277747,42.209026],[-80.247448,42.3662],[-78.939362,42.863611],[-78.92,42.965],[-79.01,43.27],[-79.171674,43.466339],[-78.72028,43.625089],[-77.737885,43.629056],[-76.820034,43.628784],[-76.5,44.018459],[-76.375,44.09631],[-75.31821,44.81645],[-74.867,45.00048],[-73.34783,45.00738],[-71.50506,45.0082],[-71.405,45.255],[-71.08482,45.30524],[-70.66,45.46],[-70.305,45.915],[-69.99997,46.69307],[-69.237216,47.447781],[-68.905,47.185],[-68.23444,47.35486],[-67.79046,47.06636],[-67.79134,45.70281],[-67.13741,45.13753],[-66.96466,44.8097],[-68.03252,44.3252],[-69.06,43.98],[-70.11617,43.68405],[-70.645476,43.090238],[-70.81489,42.8653],[-70.825,42.335],[-70.495,41.805],[-70.08,41.78],[-70.185,42.145],[-69.88497,41.92283],[-69.96503,41.63717],[-70.64,41.475],[-71.12039,41.49445],[-71.86,41.32],[-72.295,41.27],[-72.87643,41.22065],[-73.71,40.931102],[-72.24126,41.11948],[-71.945,40.93],[-73.345,40.63],[-73.982,40.628],[-73.952325,40.75075],[-74.25671,40.47351],[-73.96244,40.42763],[-74.17838,39.70926],[-74.90604,38.93954],[-74.98041,39.1964],[-75.20002,39.24845],[-75.52805,39.4985],[-75.32,38.96],[-75.071835,38.782032],[-75.05673,38.40412],[-75.37747,38.01551],[-75.94023,37.21689],[-76.03127,37.2566],[-75.72205,37.93705],[-76.23287,38.319215],[-76.35,39.15],[-76.542725,38.717615],[-76.32933,38.08326],[-76.989998,38.239992],[-76.30162,37.917945],[-76.25874,36.9664],[-75.9718,36.89726],[-75.86804,36.55125],[-75.72749,35.55074],[-76.36318,34.80854],[-77.397635,34.51201],[-78.05496,33.92547],[-78.55435,33.86133],[-79.06067,33.49395],[-79.20357,33.15839],[-80.301325,32.509355],[-80.86498,32.0333],[-81.33629,31.44049],[-81.49042,30.72999],[-81.31371,30.03552],[-80.98,29.18],[-80.535585,28.47213],[-80.53,28.04],[-80.056539,26.88],[-80.088015,26.205765],[-80.13156,25.816775],[-80.38103,25.20616],[-80.68,25.08],[-81.17213,25.20126],[-81.33,25.64],[-81.71,25.87],[-82.24,26.73],[-82.70515,27.49504],[-82.85526,27.88624],[-82.65,28.55],[-82.93,29.1],[-83.70959,29.93656],[-84.1,30.09],[-85.10882,29.63615],[-85.28784,29.68612],[-85.7731,30.15261],[-86.4,30.4],[-87.53036,30.27433],[-88.41782,30.3849],[-89.18049,30.31598],[-89.593831,30.159994],[-89.413735,29.89419],[-89.43,29.48864],[-89.21767,29.29108],[-89.40823,29.15961],[-89.77928,29.30714],[-90.15463,29.11743],[-90.880225,29.148535],[-91.626785,29.677],[-92.49906,29.5523],[-93.22637,29.78375],[-93.84842,29.71363],[-94.69,29.48],[-95.60026,28.73863],[-96.59404,28.30748],[-97.14,27.83],[-97.37,27.38],[-97.38,26.69],[-97.33,26.21],[-97.14,25.87],[-97.53,25.84],[-98.24,26.06],[-99.02,26.37],[-99.3,26.84],[-99.52,27.54],[-100.11,28.11],[-100.45584,28.69612],[-100.9576,29.38071],[-101.6624,29.7793],[-102.48,29.76],[-103.11,28.97],[-103.94,29.27],[-104.45697,29.57196],[-104.70575,30.12173],[-105.03737,30.64402],[-105.63159,31.08383],[-106.1429,31.39995],[-106.50759,31.75452],[-108.24,31.754854],[-108.24194,31.34222],[-109.035,31.34194],[-111.02361,31.33472],[-113.30498,32.03914],[-114.815,32.52528],[-114.72139,32.72083],[-115.99135,32.61239],[-117.12776,32.53534],[-117.295938,33.046225],[-117.944,33.621236],[-118.410602,33.740909],[-118.519895,34.027782],[-119.081,34.078],[-119.438841,34.348477],[-120.36778,34.44711],[-120.62286,34.60855],[-120.74433,35.15686],[-121.71457,36.16153],[-122.54747,37.55176],[-122.51201,37.78339],[-122.95319,38.11371],[-123.7272,38.95166],[-123.86517,39.76699],[-124.39807,40.3132],[-124.17886,41.14202],[-124.2137,41.99964],[-124.53284,42.76599],[-124.14214,43.70838],[-124.020535,44.615895],[-123.89893,45.52341],[-124.079635,46.86475],[-124.39567,47.72017],[-124.68721,48.184433],[-124.566101,48.379715],[-123.12,48.04],[-122.58736,47.096],[-122.34,47.36],[-122.5,48.18],[-122.84,49],[-120,49],[-117.03121,49],[-116.04818,49],[-113,49],[-110.05,49],[-107.05,49],[-104.04826,48.99986],[-100.65,49],[-97.22872,49.0007],[-95.15907,49],[-95.15609,49.38425],[-94.81758,49.38905]]],[[[-153.006314,57.115842],[-154.00509,56.734677],[-154.516403,56.992749],[-154.670993,57.461196],[-153.76278,57.816575],[-153.228729,57.968968],[-152.564791,57.901427],[-152.141147,57.591059],[-153.006314,57.115842]]],[[[-165.579164,59.909987],[-166.19277,59.754441],[-166.848337,59.941406],[-167.455277,60.213069],[-166.467792,60.38417],[-165.67443,60.293607],[-165.579164,59.909987]]],[[[-171.731657,63.782515],[-171.114434,63.592191],[-170.491112,63.694975],[-169.682505,63.431116],[-168.689439,63.297506],[-168.771941,63.188598],[-169.52944,62.976931],[-170.290556,63.194438],[-170.671386,63.375822],[-171.553063,63.317789],[-171.791111,63.405846],[-171.731657,63.782515]]],[[[-155.06779,71.147776],[-154.344165,70.696409],[-153.900006,70.889989],[-152.210006,70.829992],[-152.270002,70.600006],[-150.739992,70.430017],[-149.720003,70.53001],[-147.613362,70.214035],[-145.68999,70.12001],[-144.920011,69.989992],[-143.589446,70.152514],[-142.07251,69.851938],[-140.985988,69.711998],[-140.992499,66.000029],[-140.99777,60.306397],[-140.012998,60.276838],[-139.039,60.000007],[-138.34089,59.56211],[-137.4525,58.905],[-136.47972,59.46389],[-135.47583,59.78778],[-134.945,59.27056],[-134.27111,58.86111],[-133.355549,58.410285],[-132.73042,57.69289],[-131.70781,56.55212],[-130.00778,55.91583],[-129.979994,55.284998],[-130.53611,54.802753],[-131.085818,55.178906],[-131.967211,55.497776],[-132.250011,56.369996],[-133.539181,57.178887],[-134.078063,58.123068],[-135.038211,58.187715],[-136.628062,58.212209],[-137.800006,58.499995],[-139.867787,59.537762],[-140.825274,59.727517],[-142.574444,60.084447],[-143.958881,59.99918],[-145.925557,60.45861],[-147.114374,60.884656],[-148.224306,60.672989],[-148.018066,59.978329],[-148.570823,59.914173],[-149.727858,59.705658],[-150.608243,59.368211],[-151.716393,59.155821],[-151.859433,59.744984],[-151.409719,60.725803],[-150.346941,61.033588],[-150.621111,61.284425],[-151.895839,60.727198],[-152.57833,60.061657],[-154.019172,59.350279],[-153.287511,58.864728],[-154.232492,58.146374],[-155.307491,57.727795],[-156.308335,57.422774],[-156.556097,56.979985],[-158.117217,56.463608],[-158.433321,55.994154],[-159.603327,55.566686],[-160.28972,55.643581],[-161.223048,55.364735],[-162.237766,55.024187],[-163.069447,54.689737],[-164.785569,54.404173],[-164.942226,54.572225],[-163.84834,55.039431],[-162.870001,55.348043],[-161.804175,55.894986],[-160.563605,56.008055],[-160.07056,56.418055],[-158.684443,57.016675],[-158.461097,57.216921],[-157.72277,57.570001],[-157.550274,58.328326],[-157.041675,58.918885],[-158.194731,58.615802],[-158.517218,58.787781],[-159.058606,58.424186],[-159.711667,58.93139],[-159.981289,58.572549],[-160.355271,59.071123],[-161.355003,58.670838],[-161.968894,58.671665],[-162.054987,59.266925],[-161.874171,59.633621],[-162.518059,59.989724],[-163.818341,59.798056],[-164.662218,60.267484],[-165.346388,60.507496],[-165.350832,61.073895],[-166.121379,61.500019],[-165.734452,62.074997],[-164.919179,62.633076],[-164.562508,63.146378],[-163.753332,63.219449],[-163.067224,63.059459],[-162.260555,63.541936],[-161.53445,63.455817],[-160.772507,63.766108],[-160.958335,64.222799],[-161.518068,64.402788],[-160.777778,64.788604],[-161.391926,64.777235],[-162.45305,64.559445],[-162.757786,64.338605],[-163.546394,64.55916],[-164.96083,64.446945],[-166.425288,64.686672],[-166.845004,65.088896],[-168.11056,65.669997],[-166.705271,66.088318],[-164.47471,66.57666],[-163.652512,66.57666],[-163.788602,66.077207],[-161.677774,66.11612],[-162.489715,66.735565],[-163.719717,67.116395],[-164.430991,67.616338],[-165.390287,68.042772],[-166.764441,68.358877],[-166.204707,68.883031],[-164.430811,68.915535],[-163.168614,69.371115],[-162.930566,69.858062],[-161.908897,70.33333],[-160.934797,70.44769],[-159.039176,70.891642],[-158.119723,70.824721],[-156.580825,71.357764],[-155.06779,71.147776]]]]}}]}

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

﻿(function() {

var isRingBbox = function (ring, bbox) {
    if (ring.length !== 4) {
        return false;
    }

    var p, sumX = 0, sumY = 0;

    for (p = 0; p < 4; p++) {
        if ((ring[p].x !== bbox.min.x && ring[p].x !== bbox.max.x) ||
            (ring[p].y !== bbox.min.y && ring[p].y !== bbox.max.y)) {
            return false;
        }

        sumX += ring[p].x;
        sumY += ring[p].y;
        
        //bins[Number(ring[p].x === bbox.min.x) + 2 * Number(ring[p].y === bbox.min.y)] = 1;
    }

    //check that we have all 4 vertex of bbox in our geometry
    return sumX === 2*(bbox.min.x + bbox.max.x) && sumY === 2*(bbox.min.y + bbox.max.y);
};

var ExtendMethods = {
    _toMercGeometry: function(b, isGeoJSON) {
        var res = [];
        var c, r, p,
            mercComponent,
            mercRing,
            coords;

        if (!isGeoJSON) {
            if (!(b[0] instanceof Array)) {
                b = [[b]];
            } else if (!(b[0][0] instanceof Array)) {
                b = [b];
            }
        }

        for (c = 0; c < b.length; c++) {
            mercComponent = [];
            for (r = 0; r < b[c].length; r++) {
                mercRing = [];
                for (p = 0; p < b[c][r].length; p++) {
                    coords = isGeoJSON ? L.latLng(b[c][r][p][1], b[c][r][p][0]) : b[c][r][p];
                    mercRing.push(this._map.project(coords, 0));
                }
                mercComponent.push(mercRing);
            }
            res.push(mercComponent);
        }
        
        return res;
    },
    
    //lazy calculation of layer's boundary in map's projection. Bounding box is also calculated
    _getOriginalMercBoundary: function () {
        if (this._mercBoundary) {
            return this._mercBoundary;
        }

        var compomentBbox;
            
        if (L.Util.isArray(this.options.boundary)) { //Depricated: just array of coordinates
            this._mercBoundary = this._toMercGeometry(this.options.boundary);
        } else { //GeoJSON
            this._mercBoundary = [];
            var processGeoJSONObject = function(obj) {
                if (obj.type === 'GeometryCollection') {
                    obj.geometries.forEach(processGeoJSONObject);
                } else if (obj.type === 'Feature') {
                    processGeoJSONObject(obj.geometry);
                } else if (obj.type === 'FeatureCollection') {
                    obj.features.forEach(processGeoJSONObject);
                } else if (obj.type === 'Polygon') {
                    this._mercBoundary = this._mercBoundary.concat(this._toMercGeometry([obj.coordinates], true));
                } else if (obj.type === 'MultiPolygon') {
                    this._mercBoundary = this._mercBoundary.concat(this._toMercGeometry(obj.coordinates, true));
                }
            }.bind(this);
            processGeoJSONObject(this.options.boundary);
        }
        
        this._mercBbox = new L.Bounds();
        for (var c = 0; c < this._mercBoundary.length; c++) {
            compomentBbox = new L.Bounds(this._mercBoundary[c][0]);
            this._mercBbox.extend(compomentBbox.min);
            this._mercBbox.extend(compomentBbox.max);
        }

        return this._mercBoundary;
    },

    _getClippedGeometry: function(geom, bounds) {
        var clippedGeom = [],
            clippedComponent,
            clippedExternalRing,
            clippedHoleRing,
            iC, iR;
            
        for (iC = 0; iC < geom.length; iC++) {
            clippedComponent = [];
            clippedExternalRing = L.PolyUtil.clipPolygon(geom[iC][0], bounds);
            if (clippedExternalRing.length === 0) {
                continue;
            }

            clippedComponent.push(clippedExternalRing);

            for (iR = 1; iR < geom[iC].length; iR++) {
                clippedHoleRing = L.PolyUtil.clipPolygon(geom[iC][iR], bounds);
                if (clippedHoleRing.length > 0) {
                    clippedComponent.push(clippedHoleRing);
                }
            }
            clippedGeom.push(clippedComponent);
        }
        
        if (clippedGeom.length === 0) { //we are outside of all multipolygon components
            return {isOut: true};
        }

        for (iC = 0; iC < clippedGeom.length; iC++) {
            if (isRingBbox(clippedGeom[iC][0], bounds)) {
                //inside exterior rings and no holes
                if (clippedGeom[iC].length === 1) {
                    return {isIn: true};
                }
            } else { //intersects exterior ring
                return {geometry: clippedGeom};
            }

            for (iR = 1; iR < clippedGeom[iC].length; iR++) {
                //inside exterior ring, but have intersection with a hole
                if (!isRingBbox(clippedGeom[iC][iR], bounds)) {
                    return {geometry: clippedGeom};
                }
            }
        }

        //we are inside all holes in geometry
        return {isOut: true};
    },

    // Calculates intersection of original boundary geometry and tile boundary.
    // Uses quadtree as cache to speed-up intersection.
    // Return 
    //   {isOut: true} if no intersection,  
    //   {isIn: true} if tile is fully inside layer's boundary
    //   {geometry: <LatLng[][][]>} otherwise
    _getTileGeometry: function (x, y, z, skipIntersectionCheck) {
        if ( !this.options.boundary) {
            return {isIn: true};
        }
    
        var cacheID = x + ":" + y + ":" + z,
            zCoeff = Math.pow(2, z),
            parentState,
            cache = this._boundaryCache;

        if (cache[cacheID]) {
            return cache[cacheID];
        }

        var mercBoundary = this._getOriginalMercBoundary(),
            ts = this.options.tileSize,
            tileBbox = new L.Bounds(new L.Point(x * ts / zCoeff, y * ts / zCoeff), new L.Point((x + 1) * ts / zCoeff, (y + 1) * ts / zCoeff));

        //fast check intersection
        if (!skipIntersectionCheck && !tileBbox.intersects(this._mercBbox)) {
            return {isOut: true};
        }

        if (z === 0) {
            cache[cacheID] = {geometry: mercBoundary};
            return cache[cacheID];
        }

        parentState = this._getTileGeometry(Math.floor(x / 2), Math.floor(y / 2), z - 1, true);

        if (parentState.isOut || parentState.isIn) {
            return parentState;
        }
        
        cache[cacheID] = this._getClippedGeometry(parentState.geometry, tileBbox);
        return cache[cacheID];
    },

    _drawTileInternal: function (canvas, tilePoint, url, callback) {
        var zoom = this._getZoomForUrl(),
            state = this._getTileGeometry(tilePoint.x, tilePoint.y, zoom);

        if (state.isOut) {
            callback();
            return;
        }

        var ts = this.options.tileSize,
            tileX = ts * tilePoint.x,
            tileY = ts * tilePoint.y,
            zCoeff = Math.pow(2, zoom),
            ctx = canvas.getContext('2d'),
            imageObj = new Image(),
            _this = this;
            
        var setPattern = function () {
            var c, r, p,
                pattern,
                geom;

            if (!state.isIn) {
                geom = state.geometry;
                ctx.beginPath();

                for (c = 0; c < geom.length; c++) {
                    for (r = 0; r < geom[c].length; r++) {
                        if (geom[c][r].length === 0) {
                            continue;
                        }

                        ctx.moveTo(geom[c][r][0].x * zCoeff - tileX, geom[c][r][0].y * zCoeff - tileY);
                        for (p = 1; p < geom[c][r].length; p++) {
                            ctx.lineTo(geom[c][r][p].x * zCoeff - tileX, geom[c][r][p].y * zCoeff - tileY);
                        }
                    }
                }
                ctx.clip();
            }

            pattern = ctx.createPattern(imageObj, "repeat");
            ctx.beginPath();
            ctx.rect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = pattern;
            ctx.fill();
            callback();
        };
        
        if (this.options.crossOrigin) {
            imageObj.crossOrigin = '';
        }
        
        imageObj.onload = function () {
            //TODO: implement correct image loading cancelation
            canvas.complete = true; //HACK: emulate HTMLImageElement property to make happy L.TileLayer
            setTimeout(setPattern, 0); //IE9 bug - black tiles appear randomly if call setPattern() without timeout
        }
        
        imageObj.src = url;
    },
    
    onAdd: function(map) {
        (L.TileLayer.Canvas || L.TileLayer).prototype.onAdd.call(this, map);
        
        if (this.options.trackAttribution) {
            map.on('moveend', this._updateAttribution, this);
            this._updateAttribution();
        }
    },
    
    onRemove: function(map) {
        (L.TileLayer.Canvas || L.TileLayer).prototype.onRemove.call(this, map);
        
        if (this.options.trackAttribution) {
            map.off('moveend', this._updateAttribution, this);
            if (!this._attributionRemoved) {
                var attribution = L.TileLayer.BoundaryCanvas.prototype.getAttribution.call(this);
                map.attributionControl.removeAttribution(attribution);
            }
        }
    },
    
    _updateAttribution: function() {
        var geom = this._getOriginalMercBoundary(),
            mapBounds = this._map.getBounds(),
            mercBounds = L.bounds(this._map.project(mapBounds.getSouthWest(), 0), this._map.project(mapBounds.getNorthEast(), 0)),
            state = this._getClippedGeometry(geom, mercBounds);
        
        if (this._attributionRemoved !== !!state.isOut) {
            var attribution = L.TileLayer.BoundaryCanvas.prototype.getAttribution.call(this);
            this._map.attributionControl[state.isOut ? 'removeAttribution' : 'addAttribution'](attribution);
            this._attributionRemoved = !!state.isOut;
        }
    }
};

if (L.version >= '0.8') {
    L.TileLayer.BoundaryCanvas = L.TileLayer.extend({
        options: {
            // all rings of boundary should be without self-intersections or intersections with other rings
            // zero-winding fill algorithm is used in canvas, so holes should have opposite direction to exterior ring
            // boundary can be
            // LatLng[] - simple polygon
            // LatLng[][] - polygon with holes
            // LatLng[][][] - multipolygon
            boundary: null
        },
        includes: ExtendMethods,
        initialize: function(url, options) {
            L.TileLayer.prototype.initialize.call(this, url, options);
            this._boundaryCache = {}; //cache index "x:y:z"
            this._mercBoundary = null;
            this._mercBbox = null;
            
            if (this.options.trackAttribution) {
                this._attributionRemoved = true;
                this.getAttribution = null;
            }
        },
        createTile: function(coords, done){
            var tile = document.createElement('canvas'),
                url = this.getTileUrl(coords);
            tile.width = tile.height = this.options.tileSize;
            this._drawTileInternal(tile, coords, url, L.bind(done, null, null, tile));

            return tile;
        }
    })
} else {
    L.TileLayer.BoundaryCanvas = L.TileLayer.Canvas.extend({
        options: {
            // all rings of boundary should be without self-intersections or intersections with other rings
            // zero-winding fill algorithm is used in canvas, so holes should have opposite direction to exterior ring
            // boundary can be
            // LatLng[] - simple polygon
            // LatLng[][] - polygon with holes
            // LatLng[][][] - multipolygon
            boundary: null
        },
        includes: ExtendMethods,
        initialize: function (url, options) {
            L.Util.setOptions(this, options);
            L.Util.setOptions(this, {async: true}); //image loading is always async
            this._url = url;
            this._boundaryCache = {}; //cache index "x:y:z"
            this._mercBoundary = null;
            this._mercBbox = null;
            
            if (this.options.trackAttribution) {
                this._attributionRemoved = true;
                this.getAttribution = null;
            }
        },
        
        drawTile: function(canvas, tilePoint) {
            var adjustedTilePoint = L.extend({}, tilePoint),
                url;

            this._adjustTilePoint(adjustedTilePoint);
            url = this.getTileUrl(adjustedTilePoint);
            this._drawTileInternal(canvas, tilePoint, url, L.bind(this.tileDrawn, this, canvas));

            //Leaflet v0.7.x bugfix (L.Tile.Canvas doesn't support maxNativeZoom option)
            if (this._getTileSize() !== this.options.tileSize) {
                canvas.style.width = canvas.style.height = this._getTileSize() + 'px';
            }
        }
    });
}

L.TileLayer.boundaryCanvas = function (url, options) {
    return new L.TileLayer.BoundaryCanvas(url, options);
};

L.TileLayer.BoundaryCanvas.createFromLayer = function (layer, options) {
    if(layer instanceof L.TileLayer){
        return new L.TileLayer.BoundaryCanvas(layer._url, L.extend({}, layer.options, options));
    }

    console.warn('Your tileLayer doesn\' instanceof L.TileLayer');
    return layer;
};

})();


/***/ }),
/* 1543 */
/***/ (function(module, exports) {

/*
 Leaflet.draw 1.0.4, a plugin that adds drawing and editing tools to Leaflet powered maps.
 (c) 2012-2017, Jacob Toye, Jon West, Smartrak, Leaflet

 https://github.com/Leaflet/Leaflet.draw
 http://leafletjs.com
 */
!function(t,e,i){function o(t,e){for(;(t=t.parentElement)&&!t.classList.contains(e););return t}L.drawVersion="1.0.4",L.Draw={},L.drawLocal={draw:{toolbar:{actions:{title:"Cancel drawing",text:"Cancel"},finish:{title:"Finish drawing",text:"Finish"},undo:{title:"Delete last point drawn",text:"Delete last point"},buttons:{polyline:"Draw a polyline",polygon:"Draw a polygon",rectangle:"Draw a rectangle",circle:"Draw a circle",marker:"Draw a marker",circlemarker:"Draw a circlemarker"}},handlers:{circle:{tooltip:{start:"Click and drag to draw circle."},radius:"Radius"},circlemarker:{tooltip:{start:"Click map to place circle marker."}},marker:{tooltip:{start:"Click map to place marker."}},polygon:{tooltip:{start:"Click to start drawing shape.",cont:"Click to continue drawing shape.",end:"Click first point to close this shape."}},polyline:{error:"<strong>Error:</strong> shape edges cannot cross!",tooltip:{start:"Click to start drawing line.",cont:"Click to continue drawing line.",end:"Click last point to finish line."}},rectangle:{tooltip:{start:"Click and drag to draw rectangle."}},simpleshape:{tooltip:{end:"Release mouse to finish drawing."}}}},edit:{toolbar:{actions:{save:{title:"Save changes",text:"Save"},cancel:{title:"Cancel editing, discards all changes",text:"Cancel"},clearAll:{title:"Clear all layers",text:"Clear All"}},buttons:{edit:"Edit layers",editDisabled:"No layers to edit",remove:"Delete layers",removeDisabled:"No layers to delete"}},handlers:{edit:{tooltip:{text:"Drag handles or markers to edit features.",subtext:"Click cancel to undo changes."}},remove:{tooltip:{text:"Click on a feature to remove."}}}}},L.Draw.Event={},L.Draw.Event.CREATED="draw:created",L.Draw.Event.EDITED="draw:edited",L.Draw.Event.DELETED="draw:deleted",L.Draw.Event.DRAWSTART="draw:drawstart",L.Draw.Event.DRAWSTOP="draw:drawstop",L.Draw.Event.DRAWVERTEX="draw:drawvertex",L.Draw.Event.EDITSTART="draw:editstart",L.Draw.Event.EDITMOVE="draw:editmove",L.Draw.Event.EDITRESIZE="draw:editresize",L.Draw.Event.EDITVERTEX="draw:editvertex",L.Draw.Event.EDITSTOP="draw:editstop",L.Draw.Event.DELETESTART="draw:deletestart",L.Draw.Event.DELETESTOP="draw:deletestop",L.Draw.Event.TOOLBAROPENED="draw:toolbaropened",L.Draw.Event.TOOLBARCLOSED="draw:toolbarclosed",L.Draw.Event.MARKERCONTEXT="draw:markercontext",L.Draw=L.Draw||{},L.Draw.Feature=L.Handler.extend({initialize:function(t,e){this._map=t,this._container=t._container,this._overlayPane=t._panes.overlayPane,this._popupPane=t._panes.popupPane,e&&e.shapeOptions&&(e.shapeOptions=L.Util.extend({},this.options.shapeOptions,e.shapeOptions)),L.setOptions(this,e);var i=L.version.split(".");1===parseInt(i[0],10)&&parseInt(i[1],10)>=2?L.Draw.Feature.include(L.Evented.prototype):L.Draw.Feature.include(L.Mixin.Events)},enable:function(){this._enabled||(L.Handler.prototype.enable.call(this),this.fire("enabled",{handler:this.type}),this._map.fire(L.Draw.Event.DRAWSTART,{layerType:this.type}))},disable:function(){this._enabled&&(L.Handler.prototype.disable.call(this),this._map.fire(L.Draw.Event.DRAWSTOP,{layerType:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(L.DomUtil.disableTextSelection(),t.getContainer().focus(),this._tooltip=new L.Draw.Tooltip(this._map),L.DomEvent.on(this._container,"keyup",this._cancelDrawing,this))},removeHooks:function(){this._map&&(L.DomUtil.enableTextSelection(),this._tooltip.dispose(),this._tooltip=null,L.DomEvent.off(this._container,"keyup",this._cancelDrawing,this))},setOptions:function(t){L.setOptions(this,t)},_fireCreatedEvent:function(t){this._map.fire(L.Draw.Event.CREATED,{layer:t,layerType:this.type})},_cancelDrawing:function(t){27===t.keyCode&&(this._map.fire("draw:canceled",{layerType:this.type}),this.disable())}}),L.Draw.Polyline=L.Draw.Feature.extend({statics:{TYPE:"polyline"},Poly:L.Polyline,options:{allowIntersection:!0,repeatMode:!1,drawError:{color:"#b00b00",timeout:2500},icon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon"}),touchIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"}),guidelineDistance:20,maxGuideLineLength:4e3,shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!1,clickable:!0},metric:!0,feet:!0,nautic:!1,showLength:!0,zIndexOffset:2e3,factor:1,maxPoints:0},initialize:function(t,e){L.Browser.touch&&(this.options.icon=this.options.touchIcon),this.options.drawError.message=L.drawLocal.draw.handlers.polyline.error,e&&e.drawError&&(e.drawError=L.Util.extend({},this.options.drawError,e.drawError)),this.type=L.Draw.Polyline.TYPE,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._markers=[],this._markerGroup=new L.LayerGroup,this._map.addLayer(this._markerGroup),this._poly=new L.Polyline([],this.options.shapeOptions),this._tooltip.updateContent(this._getTooltipText()),this._mouseMarker||(this._mouseMarker=L.marker(this._map.getCenter(),{icon:L.divIcon({className:"leaflet-mouse-marker",iconAnchor:[20,20],iconSize:[40,40]}),opacity:0,zIndexOffset:this.options.zIndexOffset})),this._mouseMarker.on("mouseout",this._onMouseOut,this).on("mousemove",this._onMouseMove,this).on("mousedown",this._onMouseDown,this).on("mouseup",this._onMouseUp,this).addTo(this._map),this._map.on("mouseup",this._onMouseUp,this).on("mousemove",this._onMouseMove,this).on("zoomlevelschange",this._onZoomEnd,this).on("touchstart",this._onTouch,this).on("zoomend",this._onZoomEnd,this))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._clearHideErrorTimeout(),this._cleanUpShape(),this._map.removeLayer(this._markerGroup),delete this._markerGroup,delete this._markers,this._map.removeLayer(this._poly),delete this._poly,this._mouseMarker.off("mousedown",this._onMouseDown,this).off("mouseout",this._onMouseOut,this).off("mouseup",this._onMouseUp,this).off("mousemove",this._onMouseMove,this),this._map.removeLayer(this._mouseMarker),delete this._mouseMarker,this._clearGuides(),this._map.off("mouseup",this._onMouseUp,this).off("mousemove",this._onMouseMove,this).off("zoomlevelschange",this._onZoomEnd,this).off("zoomend",this._onZoomEnd,this).off("touchstart",this._onTouch,this).off("click",this._onTouch,this)},deleteLastVertex:function(){if(!(this._markers.length<=1)){var t=this._markers.pop(),e=this._poly,i=e.getLatLngs(),o=i.splice(-1,1)[0];this._poly.setLatLngs(i),this._markerGroup.removeLayer(t),e.getLatLngs().length<2&&this._map.removeLayer(e),this._vertexChanged(o,!1)}},addVertex:function(t){if(this._markers.length>=2&&!this.options.allowIntersection&&this._poly.newLatLngIntersects(t))return void this._showErrorTooltip();this._errorShown&&this._hideErrorTooltip(),this._markers.push(this._createMarker(t)),this._poly.addLatLng(t),2===this._poly.getLatLngs().length&&this._map.addLayer(this._poly),this._vertexChanged(t,!0)},completeShape:function(){this._markers.length<=1||!this._shapeIsValid()||(this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable())},_finishShape:function(){var t=this._poly._defaultShape?this._poly._defaultShape():this._poly.getLatLngs(),e=this._poly.newLatLngIntersects(t[t.length-1]);if(!this.options.allowIntersection&&e||!this._shapeIsValid())return void this._showErrorTooltip();this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable()},_shapeIsValid:function(){return!0},_onZoomEnd:function(){null!==this._markers&&this._updateGuide()},_onMouseMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent),i=this._map.layerPointToLatLng(e);this._currentLatLng=i,this._updateTooltip(i),this._updateGuide(e),this._mouseMarker.setLatLng(i),L.DomEvent.preventDefault(t.originalEvent)},_vertexChanged:function(t,e){this._map.fire(L.Draw.Event.DRAWVERTEX,{layers:this._markerGroup}),this._updateFinishHandler(),this._updateRunningMeasure(t,e),this._clearGuides(),this._updateTooltip()},_onMouseDown:function(t){if(!this._clickHandled&&!this._touchHandled&&!this._disableMarkers){this._onMouseMove(t),this._clickHandled=!0,this._disableNewMarkers();var e=t.originalEvent,i=e.clientX,o=e.clientY;this._startPoint.call(this,i,o)}},_startPoint:function(t,e){this._mouseDownOrigin=L.point(t,e)},_onMouseUp:function(t){var e=t.originalEvent,i=e.clientX,o=e.clientY;this._endPoint.call(this,i,o,t),this._clickHandled=null},_endPoint:function(e,i,o){if(this._mouseDownOrigin){var a=L.point(e,i).distanceTo(this._mouseDownOrigin),n=this._calculateFinishDistance(o.latlng);this.options.maxPoints>1&&this.options.maxPoints==this._markers.length+1?(this.addVertex(o.latlng),this._finishShape()):n<10&&L.Browser.touch?this._finishShape():Math.abs(a)<9*(t.devicePixelRatio||1)&&this.addVertex(o.latlng),this._enableNewMarkers()}this._mouseDownOrigin=null},_onTouch:function(t){var e,i,o=t.originalEvent;!o.touches||!o.touches[0]||this._clickHandled||this._touchHandled||this._disableMarkers||(e=o.touches[0].clientX,i=o.touches[0].clientY,this._disableNewMarkers(),this._touchHandled=!0,this._startPoint.call(this,e,i),this._endPoint.call(this,e,i,t),this._touchHandled=null),this._clickHandled=null},_onMouseOut:function(){this._tooltip&&this._tooltip._onMouseOut.call(this._tooltip)},_calculateFinishDistance:function(t){var e;if(this._markers.length>0){var i;if(this.type===L.Draw.Polyline.TYPE)i=this._markers[this._markers.length-1];else{if(this.type!==L.Draw.Polygon.TYPE)return 1/0;i=this._markers[0]}var o=this._map.latLngToContainerPoint(i.getLatLng()),a=new L.Marker(t,{icon:this.options.icon,zIndexOffset:2*this.options.zIndexOffset}),n=this._map.latLngToContainerPoint(a.getLatLng());e=o.distanceTo(n)}else e=1/0;return e},_updateFinishHandler:function(){var t=this._markers.length;t>1&&this._markers[t-1].on("click",this._finishShape,this),t>2&&this._markers[t-2].off("click",this._finishShape,this)},_createMarker:function(t){var e=new L.Marker(t,{icon:this.options.icon,zIndexOffset:2*this.options.zIndexOffset});return this._markerGroup.addLayer(e),e},_updateGuide:function(t){var e=this._markers?this._markers.length:0;e>0&&(t=t||this._map.latLngToLayerPoint(this._currentLatLng),this._clearGuides(),this._drawGuide(this._map.latLngToLayerPoint(this._markers[e-1].getLatLng()),t))},_updateTooltip:function(t){var e=this._getTooltipText();t&&this._tooltip.updatePosition(t),this._errorShown||this._tooltip.updateContent(e)},_drawGuide:function(t,e){var i,o,a,n=Math.floor(Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))),s=this.options.guidelineDistance,r=this.options.maxGuideLineLength,l=n>r?n-r:s;for(this._guidesContainer||(this._guidesContainer=L.DomUtil.create("div","leaflet-draw-guides",this._overlayPane));l<n;l+=this.options.guidelineDistance)i=l/n,o={x:Math.floor(t.x*(1-i)+i*e.x),y:Math.floor(t.y*(1-i)+i*e.y)},a=L.DomUtil.create("div","leaflet-draw-guide-dash",this._guidesContainer),a.style.backgroundColor=this._errorShown?this.options.drawError.color:this.options.shapeOptions.color,L.DomUtil.setPosition(a,o)},_updateGuideColor:function(t){if(this._guidesContainer)for(var e=0,i=this._guidesContainer.childNodes.length;e<i;e++)this._guidesContainer.childNodes[e].style.backgroundColor=t},_clearGuides:function(){if(this._guidesContainer)for(;this._guidesContainer.firstChild;)this._guidesContainer.removeChild(this._guidesContainer.firstChild)},_getTooltipText:function(){var t,e,i=this.options.showLength;return 0===this._markers.length?t={text:L.drawLocal.draw.handlers.polyline.tooltip.start}:(e=i?this._getMeasurementString():"",t=1===this._markers.length?{text:L.drawLocal.draw.handlers.polyline.tooltip.cont,subtext:e}:{text:L.drawLocal.draw.handlers.polyline.tooltip.end,subtext:e}),t},_updateRunningMeasure:function(t,e){var i,o,a=this._markers.length;1===this._markers.length?this._measurementRunningTotal=0:(i=a-(e?2:1),o=L.GeometryUtil.isVersion07x()?t.distanceTo(this._markers[i].getLatLng())*(this.options.factor||1):this._map.distance(t,this._markers[i].getLatLng())*(this.options.factor||1),this._measurementRunningTotal+=o*(e?1:-1))},_getMeasurementString:function(){var t,e=this._currentLatLng,i=this._markers[this._markers.length-1].getLatLng();return t=L.GeometryUtil.isVersion07x()?i&&e&&e.distanceTo?this._measurementRunningTotal+e.distanceTo(i)*(this.options.factor||1):this._measurementRunningTotal||0:i&&e?this._measurementRunningTotal+this._map.distance(e,i)*(this.options.factor||1):this._measurementRunningTotal||0,L.GeometryUtil.readableDistance(t,this.options.metric,this.options.feet,this.options.nautic,this.options.precision)},_showErrorTooltip:function(){this._errorShown=!0,this._tooltip.showAsError().updateContent({text:this.options.drawError.message}),this._updateGuideColor(this.options.drawError.color),this._poly.setStyle({color:this.options.drawError.color}),this._clearHideErrorTimeout(),this._hideErrorTimeout=setTimeout(L.Util.bind(this._hideErrorTooltip,this),this.options.drawError.timeout)},_hideErrorTooltip:function(){this._errorShown=!1,this._clearHideErrorTimeout(),this._tooltip.removeError().updateContent(this._getTooltipText()),this._updateGuideColor(this.options.shapeOptions.color),this._poly.setStyle({color:this.options.shapeOptions.color})},_clearHideErrorTimeout:function(){this._hideErrorTimeout&&(clearTimeout(this._hideErrorTimeout),this._hideErrorTimeout=null)},_disableNewMarkers:function(){this._disableMarkers=!0},_enableNewMarkers:function(){setTimeout(function(){this._disableMarkers=!1}.bind(this),50)},_cleanUpShape:function(){this._markers.length>1&&this._markers[this._markers.length-1].off("click",this._finishShape,this)},_fireCreatedEvent:function(){var t=new this.Poly(this._poly.getLatLngs(),this.options.shapeOptions);L.Draw.Feature.prototype._fireCreatedEvent.call(this,t)}}),L.Draw.Polygon=L.Draw.Polyline.extend({statics:{TYPE:"polygon"},Poly:L.Polygon,options:{showArea:!1,showLength:!1,shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0},metric:!0,feet:!0,nautic:!1,precision:{}},initialize:function(t,e){L.Draw.Polyline.prototype.initialize.call(this,t,e),this.type=L.Draw.Polygon.TYPE},_updateFinishHandler:function(){var t=this._markers.length;1===t&&this._markers[0].on("click",this._finishShape,this),t>2&&(this._markers[t-1].on("dblclick",this._finishShape,this),t>3&&this._markers[t-2].off("dblclick",this._finishShape,this))},_getTooltipText:function(){var t,e;return 0===this._markers.length?t=L.drawLocal.draw.handlers.polygon.tooltip.start:this._markers.length<3?(t=L.drawLocal.draw.handlers.polygon.tooltip.cont,e=this._getMeasurementString()):(t=L.drawLocal.draw.handlers.polygon.tooltip.end,e=this._getMeasurementString()),{text:t,subtext:e}},_getMeasurementString:function(){var t=this._area,e="";return t||this.options.showLength?(this.options.showLength&&(e=L.Draw.Polyline.prototype._getMeasurementString.call(this)),t&&(e+="<br>"+L.GeometryUtil.readableArea(t,this.options.metric,this.options.precision)),e):null},_shapeIsValid:function(){return this._markers.length>=3},_vertexChanged:function(t,e){var i;!this.options.allowIntersection&&this.options.showArea&&(i=this._poly.getLatLngs(),this._area=L.GeometryUtil.geodesicArea(i)),L.Draw.Polyline.prototype._vertexChanged.call(this,t,e)},_cleanUpShape:function(){var t=this._markers.length;t>0&&(this._markers[0].off("click",this._finishShape,this),t>2&&this._markers[t-1].off("dblclick",this._finishShape,this))}}),L.SimpleShape={},L.Draw.SimpleShape=L.Draw.Feature.extend({options:{repeatMode:!1},initialize:function(t,e){this._endLabelText=L.drawLocal.draw.handlers.simpleshape.tooltip.end,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._mapDraggable=this._map.dragging.enabled(),this._mapDraggable&&this._map.dragging.disable(),this._container.style.cursor="crosshair",this._tooltip.updateContent({text:this._initialLabelText}),this._map.on("mousedown",this._onMouseDown,this).on("mousemove",this._onMouseMove,this).on("touchstart",this._onMouseDown,this).on("touchmove",this._onMouseMove,this),e.addEventListener("touchstart",L.DomEvent.preventDefault,{passive:!1}))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._map&&(this._mapDraggable&&this._map.dragging.enable(),this._container.style.cursor="",this._map.off("mousedown",this._onMouseDown,this).off("mousemove",this._onMouseMove,this).off("touchstart",this._onMouseDown,this).off("touchmove",this._onMouseMove,this),L.DomEvent.off(e,"mouseup",this._onMouseUp,this),L.DomEvent.off(e,"touchend",this._onMouseUp,this),e.removeEventListener("touchstart",L.DomEvent.preventDefault),this._shape&&(this._map.removeLayer(this._shape),delete this._shape)),this._isDrawing=!1},_getTooltipText:function(){return{text:this._endLabelText}},_onMouseDown:function(t){this._isDrawing=!0,this._startLatLng=t.latlng,L.DomEvent.on(e,"mouseup",this._onMouseUp,this).on(e,"touchend",this._onMouseUp,this).preventDefault(t.originalEvent)},_onMouseMove:function(t){var e=t.latlng;this._tooltip.updatePosition(e),this._isDrawing&&(this._tooltip.updateContent(this._getTooltipText()),this._drawShape(e))},_onMouseUp:function(){this._shape&&this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable()}}),L.Draw.Rectangle=L.Draw.SimpleShape.extend({statics:{TYPE:"rectangle"},options:{shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0},showArea:!0,metric:!0},initialize:function(t,e){this.type=L.Draw.Rectangle.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.rectangle.tooltip.start,L.Draw.SimpleShape.prototype.initialize.call(this,t,e)},disable:function(){this._enabled&&(this._isCurrentlyTwoClickDrawing=!1,L.Draw.SimpleShape.prototype.disable.call(this))},_onMouseUp:function(t){if(!this._shape&&!this._isCurrentlyTwoClickDrawing)return void(this._isCurrentlyTwoClickDrawing=!0);this._isCurrentlyTwoClickDrawing&&!o(t.target,"leaflet-pane")||L.Draw.SimpleShape.prototype._onMouseUp.call(this)},_drawShape:function(t){this._shape?this._shape.setBounds(new L.LatLngBounds(this._startLatLng,t)):(this._shape=new L.Rectangle(new L.LatLngBounds(this._startLatLng,t),this.options.shapeOptions),this._map.addLayer(this._shape))},_fireCreatedEvent:function(){var t=new L.Rectangle(this._shape.getBounds(),this.options.shapeOptions);L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this,t)},_getTooltipText:function(){var t,e,i,o=L.Draw.SimpleShape.prototype._getTooltipText.call(this),a=this._shape,n=this.options.showArea;return a&&(t=this._shape._defaultShape?this._shape._defaultShape():this._shape.getLatLngs(),e=L.GeometryUtil.geodesicArea(t),i=n?L.GeometryUtil.readableArea(e,this.options.metric):""),{text:o.text,subtext:i}}}),L.Draw.Marker=L.Draw.Feature.extend({statics:{TYPE:"marker"},options:{icon:new L.Icon.Default,repeatMode:!1,zIndexOffset:2e3},initialize:function(t,e){this.type=L.Draw.Marker.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.marker.tooltip.start,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._tooltip.updateContent({text:this._initialLabelText}),this._mouseMarker||(this._mouseMarker=L.marker(this._map.getCenter(),{icon:L.divIcon({className:"leaflet-mouse-marker",iconAnchor:[20,20],iconSize:[40,40]}),opacity:0,zIndexOffset:this.options.zIndexOffset})),this._mouseMarker.on("click",this._onClick,this).addTo(this._map),this._map.on("mousemove",this._onMouseMove,this),this._map.on("click",this._onTouch,this))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._map&&(this._map.off("click",this._onClick,this).off("click",this._onTouch,this),this._marker&&(this._marker.off("click",this._onClick,this),this._map.removeLayer(this._marker),delete this._marker),this._mouseMarker.off("click",this._onClick,this),this._map.removeLayer(this._mouseMarker),delete this._mouseMarker,this._map.off("mousemove",this._onMouseMove,this))},_onMouseMove:function(t){var e=t.latlng;this._tooltip.updatePosition(e),this._mouseMarker.setLatLng(e),this._marker?(e=this._mouseMarker.getLatLng(),this._marker.setLatLng(e)):(this._marker=this._createMarker(e),this._marker.on("click",this._onClick,this),this._map.on("click",this._onClick,this).addLayer(this._marker))},_createMarker:function(t){return new L.Marker(t,{icon:this.options.icon,zIndexOffset:this.options.zIndexOffset})},_onClick:function(){this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable()},_onTouch:function(t){this._onMouseMove(t),this._onClick()},_fireCreatedEvent:function(){var t=new L.Marker.Touch(this._marker.getLatLng(),{icon:this.options.icon});L.Draw.Feature.prototype._fireCreatedEvent.call(this,t)}}),L.Draw.CircleMarker=L.Draw.Marker.extend({statics:{TYPE:"circlemarker"},options:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0,zIndexOffset:2e3},initialize:function(t,e){this.type=L.Draw.CircleMarker.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.circlemarker.tooltip.start,L.Draw.Feature.prototype.initialize.call(this,t,e)},_fireCreatedEvent:function(){var t=new L.CircleMarker(this._marker.getLatLng(),this.options);L.Draw.Feature.prototype._fireCreatedEvent.call(this,t)},_createMarker:function(t){return new L.CircleMarker(t,this.options)}}),L.Draw.Circle=L.Draw.SimpleShape.extend({statics:{TYPE:"circle"},options:{shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0},showRadius:!0,metric:!0,feet:!0,nautic:!1},initialize:function(t,e){this.type=L.Draw.Circle.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.circle.tooltip.start,L.Draw.SimpleShape.prototype.initialize.call(this,t,e)},_drawShape:function(t){if(L.GeometryUtil.isVersion07x())var e=this._startLatLng.distanceTo(t);else var e=this._map.distance(this._startLatLng,t);this._shape?this._shape.setRadius(e):(this._shape=new L.Circle(this._startLatLng,e,this.options.shapeOptions),this._map.addLayer(this._shape))},_fireCreatedEvent:function(){var t=new L.Circle(this._startLatLng,this._shape.getRadius(),this.options.shapeOptions);L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this,t)},_onMouseMove:function(t){var e,i=t.latlng,o=this.options.showRadius,a=this.options.metric;if(this._tooltip.updatePosition(i),this._isDrawing){this._drawShape(i),e=this._shape.getRadius().toFixed(1);var n="";o&&(n=L.drawLocal.draw.handlers.circle.radius+": "+L.GeometryUtil.readableDistance(e,a,this.options.feet,this.options.nautic)),this._tooltip.updateContent({text:this._endLabelText,subtext:n})}}}),L.Edit=L.Edit||{},L.Edit.Marker=L.Handler.extend({initialize:function(t,e){this._marker=t,L.setOptions(this,e)},addHooks:function(){var t=this._marker;t.dragging.enable(),t.on("dragend",this._onDragEnd,t),this._toggleMarkerHighlight()},removeHooks:function(){var t=this._marker;t.dragging.disable(),t.off("dragend",this._onDragEnd,t),this._toggleMarkerHighlight()},_onDragEnd:function(t){var e=t.target;e.edited=!0,this._map.fire(L.Draw.Event.EDITMOVE,{layer:e})},_toggleMarkerHighlight:function(){var t=this._marker._icon;t&&(t.style.display="none",L.DomUtil.hasClass(t,"leaflet-edit-marker-selected")?(L.DomUtil.removeClass(t,"leaflet-edit-marker-selected"),this._offsetMarker(t,-4)):(L.DomUtil.addClass(t,"leaflet-edit-marker-selected"),this._offsetMarker(t,4)),t.style.display="")},_offsetMarker:function(t,e){var i=parseInt(t.style.marginTop,10)-e,o=parseInt(t.style.marginLeft,10)-e;t.style.marginTop=i+"px",t.style.marginLeft=o+"px"}}),L.Marker.addInitHook(function(){L.Edit.Marker&&(this.editing=new L.Edit.Marker(this),this.options.editable&&this.editing.enable())}),L.Edit=L.Edit||{},L.Edit.Poly=L.Handler.extend({initialize:function(t){this.latlngs=[t._latlngs],t._holes&&(this.latlngs=this.latlngs.concat(t._holes)),this._poly=t,this._poly.on("revert-edited",this._updateLatLngs,this)},_defaultShape:function(){return L.Polyline._flat?L.Polyline._flat(this._poly._latlngs)?this._poly._latlngs:this._poly._latlngs[0]:this._poly._latlngs},_eachVertexHandler:function(t){for(var e=0;e<this._verticesHandlers.length;e++)t(this._verticesHandlers[e])},addHooks:function(){this._initHandlers(),this._eachVertexHandler(function(t){t.addHooks()})},removeHooks:function(){this._eachVertexHandler(function(t){t.removeHooks()})},updateMarkers:function(){this._eachVertexHandler(function(t){t.updateMarkers()})},_initHandlers:function(){this._verticesHandlers=[];for(var t=0;t<this.latlngs.length;t++)this._verticesHandlers.push(new L.Edit.PolyVerticesEdit(this._poly,this.latlngs[t],this._poly.options.poly))},_updateLatLngs:function(t){this.latlngs=[t.layer._latlngs],t.layer._holes&&(this.latlngs=this.latlngs.concat(t.layer._holes))}}),L.Edit.PolyVerticesEdit=L.Handler.extend({options:{icon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon"}),touchIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"}),drawError:{color:"#b00b00",timeout:1e3}},initialize:function(t,e,i){L.Browser.touch&&(this.options.icon=this.options.touchIcon),this._poly=t,i&&i.drawError&&(i.drawError=L.Util.extend({},this.options.drawError,i.drawError)),this._latlngs=e,L.setOptions(this,i)},_defaultShape:function(){return L.Polyline._flat?L.Polyline._flat(this._latlngs)?this._latlngs:this._latlngs[0]:this._latlngs},addHooks:function(){var t=this._poly,e=t._path;t instanceof L.Polygon||(t.options.fill=!1,t.options.editing&&(t.options.editing.fill=!1)),e&&t.options.editing&&t.options.editing.className&&(t.options.original.className&&t.options.original.className.split(" ").forEach(function(t){L.DomUtil.removeClass(e,t)}),t.options.editing.className.split(" ").forEach(function(t){L.DomUtil.addClass(e,t)})),t.setStyle(t.options.editing),this._poly._map&&(this._map=this._poly._map,this._markerGroup||this._initMarkers(),this._poly._map.addLayer(this._markerGroup))},removeHooks:function(){var t=this._poly,e=t._path;e&&t.options.editing&&t.options.editing.className&&(t.options.editing.className.split(" ").forEach(function(t){L.DomUtil.removeClass(e,t)}),t.options.original.className&&t.options.original.className.split(" ").forEach(function(t){L.DomUtil.addClass(e,t)})),t.setStyle(t.options.original),t._map&&(t._map.removeLayer(this._markerGroup),delete this._markerGroup,delete this._markers)},updateMarkers:function(){this._markerGroup.clearLayers(),this._initMarkers()},_initMarkers:function(){this._markerGroup||(this._markerGroup=new L.LayerGroup),this._markers=[];var t,e,i,o,a=this._defaultShape();for(t=0,i=a.length;t<i;t++)o=this._createMarker(a[t],t),o.on("click",this._onMarkerClick,this),o.on("contextmenu",this._onContextMenu,this),this._markers.push(o);var n,s;for(t=0,e=i-1;t<i;e=t++)(0!==t||L.Polygon&&this._poly instanceof L.Polygon)&&(n=this._markers[e],s=this._markers[t],this._createMiddleMarker(n,s),this._updatePrevNext(n,s))},_createMarker:function(t,e){var i=new L.Marker.Touch(t,{draggable:!0,icon:this.options.icon});return i._origLatLng=t,i._index=e,i.on("dragstart",this._onMarkerDragStart,this).on("drag",this._onMarkerDrag,this).on("dragend",this._fireEdit,this).on("touchmove",this._onTouchMove,this).on("touchend",this._fireEdit,this).on("MSPointerMove",this._onTouchMove,this).on("MSPointerUp",this._fireEdit,this),this._markerGroup.addLayer(i),i},_onMarkerDragStart:function(){this._poly.fire("editstart")},_spliceLatLngs:function(){var t=this._defaultShape(),e=[].splice.apply(t,arguments);return this._poly._convertLatLngs(t,!0),this._poly.redraw(),e},_removeMarker:function(t){var e=t._index;this._markerGroup.removeLayer(t),this._markers.splice(e,1),this._spliceLatLngs(e,1),this._updateIndexes(e,-1),t.off("dragstart",this._onMarkerDragStart,this).off("drag",this._onMarkerDrag,this).off("dragend",this._fireEdit,this).off("touchmove",this._onMarkerDrag,this).off("touchend",this._fireEdit,this).off("click",this._onMarkerClick,this).off("MSPointerMove",this._onTouchMove,this).off("MSPointerUp",this._fireEdit,this)},_fireEdit:function(){this._poly.edited=!0,this._poly.fire("edit"),this._poly._map.fire(L.Draw.Event.EDITVERTEX,{layers:this._markerGroup,poly:this._poly})},_onMarkerDrag:function(t){var e=t.target,i=this._poly,o=L.LatLngUtil.cloneLatLng(e._origLatLng);if(L.extend(e._origLatLng,e._latlng),i.options.poly){var a=i._map._editTooltip;if(!i.options.poly.allowIntersection&&i.intersects()){L.extend(e._origLatLng,o),e.setLatLng(o);var n=i.options.color;i.setStyle({color:this.options.drawError.color}),a&&a.updateContent({text:L.drawLocal.draw.handlers.polyline.error}),setTimeout(function(){i.setStyle({color:n}),a&&a.updateContent({text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext})},1e3)}}e._middleLeft&&e._middleLeft.setLatLng(this._getMiddleLatLng(e._prev,e)),e._middleRight&&e._middleRight.setLatLng(this._getMiddleLatLng(e,e._next)),this._poly._bounds._southWest=L.latLng(1/0,1/0),this._poly._bounds._northEast=L.latLng(-1/0,-1/0);var s=this._poly.getLatLngs();this._poly._convertLatLngs(s,!0),this._poly.redraw(),this._poly.fire("editdrag")},_onMarkerClick:function(t){var e=L.Polygon&&this._poly instanceof L.Polygon?4:3,i=t.target;this._defaultShape().length<e||(this._removeMarker(i),this._updatePrevNext(i._prev,i._next),i._middleLeft&&this._markerGroup.removeLayer(i._middleLeft),i._middleRight&&this._markerGroup.removeLayer(i._middleRight),i._prev&&i._next?this._createMiddleMarker(i._prev,i._next):i._prev?i._next||(i._prev._middleRight=null):i._next._middleLeft=null,this._fireEdit())},_onContextMenu:function(t){var e=t.target;this._poly;this._poly._map.fire(L.Draw.Event.MARKERCONTEXT,{marker:e,layers:this._markerGroup,poly:this._poly}),L.DomEvent.stopPropagation},_onTouchMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]),i=this._map.layerPointToLatLng(e),o=t.target;L.extend(o._origLatLng,i),o._middleLeft&&o._middleLeft.setLatLng(this._getMiddleLatLng(o._prev,o)),o._middleRight&&o._middleRight.setLatLng(this._getMiddleLatLng(o,o._next)),this._poly.redraw(),this.updateMarkers()},_updateIndexes:function(t,e){this._markerGroup.eachLayer(function(i){i._index>t&&(i._index+=e)})},_createMiddleMarker:function(t,e){var i,o,a,n=this._getMiddleLatLng(t,e),s=this._createMarker(n);s.setOpacity(.6),t._middleRight=e._middleLeft=s,o=function(){s.off("touchmove",o,this);var a=e._index;s._index=a,s.off("click",i,this).on("click",this._onMarkerClick,this),n.lat=s.getLatLng().lat,n.lng=s.getLatLng().lng,this._spliceLatLngs(a,0,n),this._markers.splice(a,0,s),s.setOpacity(1),this._updateIndexes(a,1),e._index++,this._updatePrevNext(t,s),this._updatePrevNext(s,e),this._poly.fire("editstart")},a=function(){s.off("dragstart",o,this),s.off("dragend",a,this),s.off("touchmove",o,this),this._createMiddleMarker(t,s),this._createMiddleMarker(s,e)},i=function(){o.call(this),a.call(this),this._fireEdit()},s.on("click",i,this).on("dragstart",o,this).on("dragend",a,this).on("touchmove",o,this),this._markerGroup.addLayer(s)},_updatePrevNext:function(t,e){t&&(t._next=e),e&&(e._prev=t)},_getMiddleLatLng:function(t,e){var i=this._poly._map,o=i.project(t.getLatLng()),a=i.project(e.getLatLng());return i.unproject(o._add(a)._divideBy(2))}}),L.Polyline.addInitHook(function(){this.editing||(L.Edit.Poly&&(this.editing=new L.Edit.Poly(this),this.options.editable&&this.editing.enable()),this.on("add",function(){this.editing&&this.editing.enabled()&&this.editing.addHooks()}),this.on("remove",function(){this.editing&&this.editing.enabled()&&this.editing.removeHooks()}))}),L.Edit=L.Edit||{},L.Edit.SimpleShape=L.Handler.extend({options:{moveIcon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-move"}),resizeIcon:new L.DivIcon({iconSize:new L.Point(8,8),
className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-resize"}),touchMoveIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-move leaflet-touch-icon"}),touchResizeIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-resize leaflet-touch-icon"})},initialize:function(t,e){L.Browser.touch&&(this.options.moveIcon=this.options.touchMoveIcon,this.options.resizeIcon=this.options.touchResizeIcon),this._shape=t,L.Util.setOptions(this,e)},addHooks:function(){var t=this._shape;this._shape._map&&(this._map=this._shape._map,t.setStyle(t.options.editing),t._map&&(this._map=t._map,this._markerGroup||this._initMarkers(),this._map.addLayer(this._markerGroup)))},removeHooks:function(){var t=this._shape;if(t.setStyle(t.options.original),t._map){this._unbindMarker(this._moveMarker);for(var e=0,i=this._resizeMarkers.length;e<i;e++)this._unbindMarker(this._resizeMarkers[e]);this._resizeMarkers=null,this._map.removeLayer(this._markerGroup),delete this._markerGroup}this._map=null},updateMarkers:function(){this._markerGroup.clearLayers(),this._initMarkers()},_initMarkers:function(){this._markerGroup||(this._markerGroup=new L.LayerGroup),this._createMoveMarker(),this._createResizeMarker()},_createMoveMarker:function(){},_createResizeMarker:function(){},_createMarker:function(t,e){var i=new L.Marker.Touch(t,{draggable:!0,icon:e,zIndexOffset:10});return this._bindMarker(i),this._markerGroup.addLayer(i),i},_bindMarker:function(t){t.on("dragstart",this._onMarkerDragStart,this).on("drag",this._onMarkerDrag,this).on("dragend",this._onMarkerDragEnd,this).on("touchstart",this._onTouchStart,this).on("touchmove",this._onTouchMove,this).on("MSPointerMove",this._onTouchMove,this).on("touchend",this._onTouchEnd,this).on("MSPointerUp",this._onTouchEnd,this)},_unbindMarker:function(t){t.off("dragstart",this._onMarkerDragStart,this).off("drag",this._onMarkerDrag,this).off("dragend",this._onMarkerDragEnd,this).off("touchstart",this._onTouchStart,this).off("touchmove",this._onTouchMove,this).off("MSPointerMove",this._onTouchMove,this).off("touchend",this._onTouchEnd,this).off("MSPointerUp",this._onTouchEnd,this)},_onMarkerDragStart:function(t){t.target.setOpacity(0),this._shape.fire("editstart")},_fireEdit:function(){this._shape.edited=!0,this._shape.fire("edit")},_onMarkerDrag:function(t){var e=t.target,i=e.getLatLng();e===this._moveMarker?this._move(i):this._resize(i),this._shape.redraw(),this._shape.fire("editdrag")},_onMarkerDragEnd:function(t){t.target.setOpacity(1),this._fireEdit()},_onTouchStart:function(t){if(L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this,t),"function"==typeof this._getCorners){var e=this._getCorners(),i=t.target,o=i._cornerIndex;i.setOpacity(0),this._oppositeCorner=e[(o+2)%4],this._toggleCornerMarkers(0,o)}this._shape.fire("editstart")},_onTouchMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]),i=this._map.layerPointToLatLng(e);return t.target===this._moveMarker?this._move(i):this._resize(i),this._shape.redraw(),!1},_onTouchEnd:function(t){t.target.setOpacity(1),this.updateMarkers(),this._fireEdit()},_move:function(){},_resize:function(){}}),L.Edit=L.Edit||{},L.Edit.Rectangle=L.Edit.SimpleShape.extend({_createMoveMarker:function(){var t=this._shape.getBounds(),e=t.getCenter();this._moveMarker=this._createMarker(e,this.options.moveIcon)},_createResizeMarker:function(){var t=this._getCorners();this._resizeMarkers=[];for(var e=0,i=t.length;e<i;e++)this._resizeMarkers.push(this._createMarker(t[e],this.options.resizeIcon)),this._resizeMarkers[e]._cornerIndex=e},_onMarkerDragStart:function(t){L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this,t);var e=this._getCorners(),i=t.target,o=i._cornerIndex;this._oppositeCorner=e[(o+2)%4],this._toggleCornerMarkers(0,o)},_onMarkerDragEnd:function(t){var e,i,o=t.target;o===this._moveMarker&&(e=this._shape.getBounds(),i=e.getCenter(),o.setLatLng(i)),this._toggleCornerMarkers(1),this._repositionCornerMarkers(),L.Edit.SimpleShape.prototype._onMarkerDragEnd.call(this,t)},_move:function(t){for(var e,i=this._shape._defaultShape?this._shape._defaultShape():this._shape.getLatLngs(),o=this._shape.getBounds(),a=o.getCenter(),n=[],s=0,r=i.length;s<r;s++)e=[i[s].lat-a.lat,i[s].lng-a.lng],n.push([t.lat+e[0],t.lng+e[1]]);this._shape.setLatLngs(n),this._repositionCornerMarkers(),this._map.fire(L.Draw.Event.EDITMOVE,{layer:this._shape})},_resize:function(t){var e;this._shape.setBounds(L.latLngBounds(t,this._oppositeCorner)),e=this._shape.getBounds(),this._moveMarker.setLatLng(e.getCenter()),this._map.fire(L.Draw.Event.EDITRESIZE,{layer:this._shape})},_getCorners:function(){var t=this._shape.getBounds();return[t.getNorthWest(),t.getNorthEast(),t.getSouthEast(),t.getSouthWest()]},_toggleCornerMarkers:function(t){for(var e=0,i=this._resizeMarkers.length;e<i;e++)this._resizeMarkers[e].setOpacity(t)},_repositionCornerMarkers:function(){for(var t=this._getCorners(),e=0,i=this._resizeMarkers.length;e<i;e++)this._resizeMarkers[e].setLatLng(t[e])}}),L.Rectangle.addInitHook(function(){L.Edit.Rectangle&&(this.editing=new L.Edit.Rectangle(this),this.options.editable&&this.editing.enable())}),L.Edit=L.Edit||{},L.Edit.CircleMarker=L.Edit.SimpleShape.extend({_createMoveMarker:function(){var t=this._shape.getLatLng();this._moveMarker=this._createMarker(t,this.options.moveIcon)},_createResizeMarker:function(){this._resizeMarkers=[]},_move:function(t){if(this._resizeMarkers.length){var e=this._getResizeMarkerPoint(t);this._resizeMarkers[0].setLatLng(e)}this._shape.setLatLng(t),this._map.fire(L.Draw.Event.EDITMOVE,{layer:this._shape})}}),L.CircleMarker.addInitHook(function(){L.Edit.CircleMarker&&(this.editing=new L.Edit.CircleMarker(this),this.options.editable&&this.editing.enable()),this.on("add",function(){this.editing&&this.editing.enabled()&&this.editing.addHooks()}),this.on("remove",function(){this.editing&&this.editing.enabled()&&this.editing.removeHooks()})}),L.Edit=L.Edit||{},L.Edit.Circle=L.Edit.CircleMarker.extend({_createResizeMarker:function(){var t=this._shape.getLatLng(),e=this._getResizeMarkerPoint(t);this._resizeMarkers=[],this._resizeMarkers.push(this._createMarker(e,this.options.resizeIcon))},_getResizeMarkerPoint:function(t){var e=this._shape._radius*Math.cos(Math.PI/4),i=this._map.project(t);return this._map.unproject([i.x+e,i.y-e])},_resize:function(t){var e=this._moveMarker.getLatLng();L.GeometryUtil.isVersion07x()?radius=e.distanceTo(t):radius=this._map.distance(e,t),this._shape.setRadius(radius),this._map.editTooltip&&this._map._editTooltip.updateContent({text:L.drawLocal.edit.handlers.edit.tooltip.subtext+"<br />"+L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.draw.handlers.circle.radius+": "+L.GeometryUtil.readableDistance(radius,!0,this.options.feet,this.options.nautic)}),this._shape.setRadius(radius),this._map.fire(L.Draw.Event.EDITRESIZE,{layer:this._shape})}}),L.Circle.addInitHook(function(){L.Edit.Circle&&(this.editing=new L.Edit.Circle(this),this.options.editable&&this.editing.enable())}),L.Map.mergeOptions({touchExtend:!0}),L.Map.TouchExtend=L.Handler.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane},addHooks:function(){L.DomEvent.on(this._container,"touchstart",this._onTouchStart,this),L.DomEvent.on(this._container,"touchend",this._onTouchEnd,this),L.DomEvent.on(this._container,"touchmove",this._onTouchMove,this),this._detectIE()?(L.DomEvent.on(this._container,"MSPointerDown",this._onTouchStart,this),L.DomEvent.on(this._container,"MSPointerUp",this._onTouchEnd,this),L.DomEvent.on(this._container,"MSPointerMove",this._onTouchMove,this),L.DomEvent.on(this._container,"MSPointerCancel",this._onTouchCancel,this)):(L.DomEvent.on(this._container,"touchcancel",this._onTouchCancel,this),L.DomEvent.on(this._container,"touchleave",this._onTouchLeave,this))},removeHooks:function(){L.DomEvent.off(this._container,"touchstart",this._onTouchStart,this),L.DomEvent.off(this._container,"touchend",this._onTouchEnd,this),L.DomEvent.off(this._container,"touchmove",this._onTouchMove,this),this._detectIE()?(L.DomEvent.off(this._container,"MSPointerDown",this._onTouchStart,this),L.DomEvent.off(this._container,"MSPointerUp",this._onTouchEnd,this),L.DomEvent.off(this._container,"MSPointerMove",this._onTouchMove,this),L.DomEvent.off(this._container,"MSPointerCancel",this._onTouchCancel,this)):(L.DomEvent.off(this._container,"touchcancel",this._onTouchCancel,this),L.DomEvent.off(this._container,"touchleave",this._onTouchLeave,this))},_touchEvent:function(t,e){var i={};if(void 0!==t.touches){if(!t.touches.length)return;i=t.touches[0]}else{if("touch"!==t.pointerType)return;if(i=t,!this._filterClick(t))return}var o=this._map.mouseEventToContainerPoint(i),a=this._map.mouseEventToLayerPoint(i),n=this._map.layerPointToLatLng(a);this._map.fire(e,{latlng:n,layerPoint:a,containerPoint:o,pageX:i.pageX,pageY:i.pageY,originalEvent:t})},_filterClick:function(t){var e=t.timeStamp||t.originalEvent.timeStamp,i=L.DomEvent._lastClick&&e-L.DomEvent._lastClick;return i&&i>100&&i<500||t.target._simulatedClick&&!t._simulated?(L.DomEvent.stop(t),!1):(L.DomEvent._lastClick=e,!0)},_onTouchStart:function(t){if(this._map._loaded){this._touchEvent(t,"touchstart")}},_onTouchEnd:function(t){if(this._map._loaded){this._touchEvent(t,"touchend")}},_onTouchCancel:function(t){if(this._map._loaded){var e="touchcancel";this._detectIE()&&(e="pointercancel"),this._touchEvent(t,e)}},_onTouchLeave:function(t){if(this._map._loaded){this._touchEvent(t,"touchleave")}},_onTouchMove:function(t){if(this._map._loaded){this._touchEvent(t,"touchmove")}},_detectIE:function(){var e=t.navigator.userAgent,i=e.indexOf("MSIE ");if(i>0)return parseInt(e.substring(i+5,e.indexOf(".",i)),10);if(e.indexOf("Trident/")>0){var o=e.indexOf("rv:");return parseInt(e.substring(o+3,e.indexOf(".",o)),10)}var a=e.indexOf("Edge/");return a>0&&parseInt(e.substring(a+5,e.indexOf(".",a)),10)}}),L.Map.addInitHook("addHandler","touchExtend",L.Map.TouchExtend),L.Marker.Touch=L.Marker.extend({_initInteraction:function(){return this.addInteractiveTarget?L.Marker.prototype._initInteraction.apply(this):this._initInteractionLegacy()},_initInteractionLegacy:function(){if(this.options.clickable){var t=this._icon,e=["dblclick","mousedown","mouseover","mouseout","contextmenu","touchstart","touchend","touchmove"];this._detectIE?e.concat(["MSPointerDown","MSPointerUp","MSPointerMove","MSPointerCancel"]):e.concat(["touchcancel"]),L.DomUtil.addClass(t,"leaflet-clickable"),L.DomEvent.on(t,"click",this._onMouseClick,this),L.DomEvent.on(t,"keypress",this._onKeyPress,this);for(var i=0;i<e.length;i++)L.DomEvent.on(t,e[i],this._fireMouseEvent,this);L.Handler.MarkerDrag&&(this.dragging=new L.Handler.MarkerDrag(this),this.options.draggable&&this.dragging.enable())}},_detectIE:function(){var e=t.navigator.userAgent,i=e.indexOf("MSIE ");if(i>0)return parseInt(e.substring(i+5,e.indexOf(".",i)),10);if(e.indexOf("Trident/")>0){var o=e.indexOf("rv:");return parseInt(e.substring(o+3,e.indexOf(".",o)),10)}var a=e.indexOf("Edge/");return a>0&&parseInt(e.substring(a+5,e.indexOf(".",a)),10)}}),L.LatLngUtil={cloneLatLngs:function(t){for(var e=[],i=0,o=t.length;i<o;i++)Array.isArray(t[i])?e.push(L.LatLngUtil.cloneLatLngs(t[i])):e.push(this.cloneLatLng(t[i]));return e},cloneLatLng:function(t){return L.latLng(t.lat,t.lng)}},function(){var t={km:2,ha:2,m:0,mi:2,ac:2,yd:0,ft:0,nm:2};L.GeometryUtil=L.extend(L.GeometryUtil||{},{geodesicArea:function(t){var e,i,o=t.length,a=0,n=Math.PI/180;if(o>2){for(var s=0;s<o;s++)e=t[s],i=t[(s+1)%o],a+=(i.lng-e.lng)*n*(2+Math.sin(e.lat*n)+Math.sin(i.lat*n));a=6378137*a*6378137/2}return Math.abs(a)},formattedNumber:function(t,e){var i=parseFloat(t).toFixed(e),o=L.drawLocal.format&&L.drawLocal.format.numeric,a=o&&o.delimiters,n=a&&a.thousands,s=a&&a.decimal;if(n||s){var r=i.split(".");i=n?r[0].replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1"+n):r[0],s=s||".",r.length>1&&(i=i+s+r[1])}return i},readableArea:function(e,i,o){var a,n,o=L.Util.extend({},t,o);return i?(n=["ha","m"],type=typeof i,"string"===type?n=[i]:"boolean"!==type&&(n=i),a=e>=1e6&&-1!==n.indexOf("km")?L.GeometryUtil.formattedNumber(1e-6*e,o.km)+" km²":e>=1e4&&-1!==n.indexOf("ha")?L.GeometryUtil.formattedNumber(1e-4*e,o.ha)+" ha":L.GeometryUtil.formattedNumber(e,o.m)+" m²"):(e/=.836127,a=e>=3097600?L.GeometryUtil.formattedNumber(e/3097600,o.mi)+" mi²":e>=4840?L.GeometryUtil.formattedNumber(e/4840,o.ac)+" acres":L.GeometryUtil.formattedNumber(e,o.yd)+" yd²"),a},readableDistance:function(e,i,o,a,n){var s,n=L.Util.extend({},t,n);switch(i?"string"==typeof i?i:"metric":o?"feet":a?"nauticalMile":"yards"){case"metric":s=e>1e3?L.GeometryUtil.formattedNumber(e/1e3,n.km)+" km":L.GeometryUtil.formattedNumber(e,n.m)+" m";break;case"feet":e*=3.28083,s=L.GeometryUtil.formattedNumber(e,n.ft)+" ft";break;case"nauticalMile":e*=.53996,s=L.GeometryUtil.formattedNumber(e/1e3,n.nm)+" nm";break;case"yards":default:e*=1.09361,s=e>1760?L.GeometryUtil.formattedNumber(e/1760,n.mi)+" miles":L.GeometryUtil.formattedNumber(e,n.yd)+" yd"}return s},isVersion07x:function(){var t=L.version.split(".");return 0===parseInt(t[0],10)&&7===parseInt(t[1],10)}})}(),L.Util.extend(L.LineUtil,{segmentsIntersect:function(t,e,i,o){return this._checkCounterclockwise(t,i,o)!==this._checkCounterclockwise(e,i,o)&&this._checkCounterclockwise(t,e,i)!==this._checkCounterclockwise(t,e,o)},_checkCounterclockwise:function(t,e,i){return(i.y-t.y)*(e.x-t.x)>(e.y-t.y)*(i.x-t.x)}}),L.Polyline.include({intersects:function(){var t,e,i,o=this._getProjectedPoints(),a=o?o.length:0;if(this._tooFewPointsForIntersection())return!1;for(t=a-1;t>=3;t--)if(e=o[t-1],i=o[t],this._lineSegmentsIntersectsRange(e,i,t-2))return!0;return!1},newLatLngIntersects:function(t,e){return!!this._map&&this.newPointIntersects(this._map.latLngToLayerPoint(t),e)},newPointIntersects:function(t,e){var i=this._getProjectedPoints(),o=i?i.length:0,a=i?i[o-1]:null,n=o-2;return!this._tooFewPointsForIntersection(1)&&this._lineSegmentsIntersectsRange(a,t,n,e?1:0)},_tooFewPointsForIntersection:function(t){var e=this._getProjectedPoints(),i=e?e.length:0;return i+=t||0,!e||i<=3},_lineSegmentsIntersectsRange:function(t,e,i,o){var a,n,s=this._getProjectedPoints();o=o||0;for(var r=i;r>o;r--)if(a=s[r-1],n=s[r],L.LineUtil.segmentsIntersect(t,e,a,n))return!0;return!1},_getProjectedPoints:function(){if(!this._defaultShape)return this._originalPoints;for(var t=[],e=this._defaultShape(),i=0;i<e.length;i++)t.push(this._map.latLngToLayerPoint(e[i]));return t}}),L.Polygon.include({intersects:function(){var t,e,i,o,a=this._getProjectedPoints();return!this._tooFewPointsForIntersection()&&(!!L.Polyline.prototype.intersects.call(this)||(t=a.length,e=a[0],i=a[t-1],o=t-2,this._lineSegmentsIntersectsRange(i,e,o,1)))}}),L.Control.Draw=L.Control.extend({options:{position:"topleft",draw:{},edit:!1},initialize:function(t){if(L.version<"0.7")throw new Error("Leaflet.draw 0.2.3+ requires Leaflet 0.7.0+. Download latest from https://github.com/Leaflet/Leaflet/");L.Control.prototype.initialize.call(this,t);var e;this._toolbars={},L.DrawToolbar&&this.options.draw&&(e=new L.DrawToolbar(this.options.draw),this._toolbars[L.DrawToolbar.TYPE]=e,this._toolbars[L.DrawToolbar.TYPE].on("enable",this._toolbarEnabled,this)),L.EditToolbar&&this.options.edit&&(e=new L.EditToolbar(this.options.edit),this._toolbars[L.EditToolbar.TYPE]=e,this._toolbars[L.EditToolbar.TYPE].on("enable",this._toolbarEnabled,this)),L.toolbar=this},onAdd:function(t){var e,i=L.DomUtil.create("div","leaflet-draw"),o=!1;for(var a in this._toolbars)this._toolbars.hasOwnProperty(a)&&(e=this._toolbars[a].addToolbar(t))&&(o||(L.DomUtil.hasClass(e,"leaflet-draw-toolbar-top")||L.DomUtil.addClass(e.childNodes[0],"leaflet-draw-toolbar-top"),o=!0),i.appendChild(e));return i},onRemove:function(){for(var t in this._toolbars)this._toolbars.hasOwnProperty(t)&&this._toolbars[t].removeToolbar()},setDrawingOptions:function(t){for(var e in this._toolbars)this._toolbars[e]instanceof L.DrawToolbar&&this._toolbars[e].setOptions(t)},_toolbarEnabled:function(t){var e=t.target;for(var i in this._toolbars)this._toolbars[i]!==e&&this._toolbars[i].disable()}}),L.Map.mergeOptions({drawControlTooltips:!0,drawControl:!1}),L.Map.addInitHook(function(){this.options.drawControl&&(this.drawControl=new L.Control.Draw,this.addControl(this.drawControl))}),L.Toolbar=L.Class.extend({initialize:function(t){L.setOptions(this,t),this._modes={},this._actionButtons=[],this._activeMode=null;var e=L.version.split(".");1===parseInt(e[0],10)&&parseInt(e[1],10)>=2?L.Toolbar.include(L.Evented.prototype):L.Toolbar.include(L.Mixin.Events)},enabled:function(){return null!==this._activeMode},disable:function(){this.enabled()&&this._activeMode.handler.disable()},addToolbar:function(t){var e,i=L.DomUtil.create("div","leaflet-draw-section"),o=0,a=this._toolbarClass||"",n=this.getModeHandlers(t);for(this._toolbarContainer=L.DomUtil.create("div","leaflet-draw-toolbar leaflet-bar"),this._map=t,e=0;e<n.length;e++)n[e].enabled&&this._initModeHandler(n[e].handler,this._toolbarContainer,o++,a,n[e].title);if(o)return this._lastButtonIndex=--o,this._actionsContainer=L.DomUtil.create("ul","leaflet-draw-actions"),i.appendChild(this._toolbarContainer),i.appendChild(this._actionsContainer),i},removeToolbar:function(){for(var t in this._modes)this._modes.hasOwnProperty(t)&&(this._disposeButton(this._modes[t].button,this._modes[t].handler.enable,this._modes[t].handler),this._modes[t].handler.disable(),this._modes[t].handler.off("enabled",this._handlerActivated,this).off("disabled",this._handlerDeactivated,this));this._modes={};for(var e=0,i=this._actionButtons.length;e<i;e++)this._disposeButton(this._actionButtons[e].button,this._actionButtons[e].callback,this);this._actionButtons=[],this._actionsContainer=null},_initModeHandler:function(t,e,i,o,a){var n=t.type;this._modes[n]={},this._modes[n].handler=t,this._modes[n].button=this._createButton({type:n,title:a,className:o+"-"+n,container:e,callback:this._modes[n].handler.enable,context:this._modes[n].handler}),this._modes[n].buttonIndex=i,this._modes[n].handler.on("enabled",this._handlerActivated,this).on("disabled",this._handlerDeactivated,this)},_detectIOS:function(){return/iPad|iPhone|iPod/.test(navigator.userAgent)&&!t.MSStream},_createButton:function(t){var e=L.DomUtil.create("a",t.className||"",t.container),i=L.DomUtil.create("span","sr-only",t.container);e.href="#",e.appendChild(i),t.title&&(e.title=t.title,i.innerHTML=t.title),t.text&&(e.innerHTML=t.text,i.innerHTML=t.text);var o=this._detectIOS()?"touchstart":"click";return L.DomEvent.on(e,"click",L.DomEvent.stopPropagation).on(e,"mousedown",L.DomEvent.stopPropagation).on(e,"dblclick",L.DomEvent.stopPropagation).on(e,"touchstart",L.DomEvent.stopPropagation).on(e,"click",L.DomEvent.preventDefault).on(e,o,t.callback,t.context),e},_disposeButton:function(t,e){var i=this._detectIOS()?"touchstart":"click";L.DomEvent.off(t,"click",L.DomEvent.stopPropagation).off(t,"mousedown",L.DomEvent.stopPropagation).off(t,"dblclick",L.DomEvent.stopPropagation).off(t,"touchstart",L.DomEvent.stopPropagation).off(t,"click",L.DomEvent.preventDefault).off(t,i,e)},_handlerActivated:function(t){this.disable(),this._activeMode=this._modes[t.handler],L.DomUtil.addClass(this._activeMode.button,"leaflet-draw-toolbar-button-enabled"),this._showActionsToolbar(),this.fire("enable")},_handlerDeactivated:function(){this._hideActionsToolbar(),L.DomUtil.removeClass(this._activeMode.button,"leaflet-draw-toolbar-button-enabled"),this._activeMode=null,this.fire("disable")},_createActions:function(t){var e,i,o,a,n=this._actionsContainer,s=this.getActions(t),r=s.length;for(i=0,o=this._actionButtons.length;i<o;i++)this._disposeButton(this._actionButtons[i].button,this._actionButtons[i].callback);for(this._actionButtons=[];n.firstChild;)n.removeChild(n.firstChild);for(var l=0;l<r;l++)"enabled"in s[l]&&!s[l].enabled||(e=L.DomUtil.create("li","",n),a=this._createButton({title:s[l].title,text:s[l].text,container:e,callback:s[l].callback,context:s[l].context}),this._actionButtons.push({button:a,callback:s[l].callback}))},_showActionsToolbar:function(){var t=this._activeMode.buttonIndex,e=this._lastButtonIndex,i=this._activeMode.button.offsetTop-1;this._createActions(this._activeMode.handler),this._actionsContainer.style.top=i+"px",0===t&&(L.DomUtil.addClass(this._toolbarContainer,"leaflet-draw-toolbar-notop"),L.DomUtil.addClass(this._actionsContainer,"leaflet-draw-actions-top")),t===e&&(L.DomUtil.addClass(this._toolbarContainer,"leaflet-draw-toolbar-nobottom"),L.DomUtil.addClass(this._actionsContainer,"leaflet-draw-actions-bottom")),this._actionsContainer.style.display="block",this._map.fire(L.Draw.Event.TOOLBAROPENED)},_hideActionsToolbar:function(){this._actionsContainer.style.display="none",L.DomUtil.removeClass(this._toolbarContainer,"leaflet-draw-toolbar-notop"),L.DomUtil.removeClass(this._toolbarContainer,"leaflet-draw-toolbar-nobottom"),L.DomUtil.removeClass(this._actionsContainer,"leaflet-draw-actions-top"),L.DomUtil.removeClass(this._actionsContainer,"leaflet-draw-actions-bottom"),this._map.fire(L.Draw.Event.TOOLBARCLOSED)}}),L.Draw=L.Draw||{},L.Draw.Tooltip=L.Class.extend({initialize:function(t){this._map=t,this._popupPane=t._panes.popupPane,this._visible=!1,this._container=t.options.drawControlTooltips?L.DomUtil.create("div","leaflet-draw-tooltip",this._popupPane):null,this._singleLineLabel=!1,this._map.on("mouseout",this._onMouseOut,this)},dispose:function(){this._map.off("mouseout",this._onMouseOut,this),this._container&&(this._popupPane.removeChild(this._container),this._container=null)},updateContent:function(t){return this._container?(t.subtext=t.subtext||"",0!==t.subtext.length||this._singleLineLabel?t.subtext.length>0&&this._singleLineLabel&&(L.DomUtil.removeClass(this._container,"leaflet-draw-tooltip-single"),this._singleLineLabel=!1):(L.DomUtil.addClass(this._container,"leaflet-draw-tooltip-single"),this._singleLineLabel=!0),this._container.innerHTML=(t.subtext.length>0?'<span class="leaflet-draw-tooltip-subtext">'+t.subtext+"</span><br />":"")+"<span>"+t.text+"</span>",t.text||t.subtext?(this._visible=!0,this._container.style.visibility="inherit"):(this._visible=!1,this._container.style.visibility="hidden"),this):this},updatePosition:function(t){var e=this._map.latLngToLayerPoint(t),i=this._container;return this._container&&(this._visible&&(i.style.visibility="inherit"),L.DomUtil.setPosition(i,e)),this},showAsError:function(){return this._container&&L.DomUtil.addClass(this._container,"leaflet-error-draw-tooltip"),this},removeError:function(){return this._container&&L.DomUtil.removeClass(this._container,"leaflet-error-draw-tooltip"),this},_onMouseOut:function(){this._container&&(this._container.style.visibility="hidden")}}),L.DrawToolbar=L.Toolbar.extend({statics:{TYPE:"draw"},options:{polyline:{},polygon:{},rectangle:{},circle:{},marker:{},circlemarker:{}},initialize:function(t){for(var e in this.options)this.options.hasOwnProperty(e)&&t[e]&&(t[e]=L.extend({},this.options[e],t[e]));this._toolbarClass="leaflet-draw-draw",L.Toolbar.prototype.initialize.call(this,t)},getModeHandlers:function(t){return[{enabled:this.options.polyline,handler:new L.Draw.Polyline(t,this.options.polyline),title:L.drawLocal.draw.toolbar.buttons.polyline},{enabled:this.options.polygon,handler:new L.Draw.Polygon(t,this.options.polygon),title:L.drawLocal.draw.toolbar.buttons.polygon},{enabled:this.options.rectangle,handler:new L.Draw.Rectangle(t,this.options.rectangle),title:L.drawLocal.draw.toolbar.buttons.rectangle},{enabled:this.options.circle,handler:new L.Draw.Circle(t,this.options.circle),title:L.drawLocal.draw.toolbar.buttons.circle},{enabled:this.options.marker,handler:new L.Draw.Marker(t,this.options.marker),title:L.drawLocal.draw.toolbar.buttons.marker},{enabled:this.options.circlemarker,handler:new L.Draw.CircleMarker(t,this.options.circlemarker),title:L.drawLocal.draw.toolbar.buttons.circlemarker}]},getActions:function(t){return[{enabled:t.completeShape,title:L.drawLocal.draw.toolbar.finish.title,text:L.drawLocal.draw.toolbar.finish.text,callback:t.completeShape,context:t},{enabled:t.deleteLastVertex,title:L.drawLocal.draw.toolbar.undo.title,text:L.drawLocal.draw.toolbar.undo.text,callback:t.deleteLastVertex,context:t},{title:L.drawLocal.draw.toolbar.actions.title,text:L.drawLocal.draw.toolbar.actions.text,callback:this.disable,context:this}]},setOptions:function(t){L.setOptions(this,t);for(var e in this._modes)this._modes.hasOwnProperty(e)&&t.hasOwnProperty(e)&&this._modes[e].handler.setOptions(t[e])}}),L.EditToolbar=L.Toolbar.extend({statics:{TYPE:"edit"},options:{edit:{selectedPathOptions:{dashArray:"10, 10",fill:!0,fillColor:"#fe57a1",fillOpacity:.1,maintainColor:!1}},remove:{},poly:null,featureGroup:null},initialize:function(t){t.edit&&(void 0===t.edit.selectedPathOptions&&(t.edit.selectedPathOptions=this.options.edit.selectedPathOptions),t.edit.selectedPathOptions=L.extend({},this.options.edit.selectedPathOptions,t.edit.selectedPathOptions)),t.remove&&(t.remove=L.extend({},this.options.remove,t.remove)),t.poly&&(t.poly=L.extend({},this.options.poly,t.poly)),this._toolbarClass="leaflet-draw-edit",L.Toolbar.prototype.initialize.call(this,t),this._selectedFeatureCount=0},getModeHandlers:function(t){var e=this.options.featureGroup;return[{enabled:this.options.edit,handler:new L.EditToolbar.Edit(t,{featureGroup:e,selectedPathOptions:this.options.edit.selectedPathOptions,poly:this.options.poly}),title:L.drawLocal.edit.toolbar.buttons.edit},{enabled:this.options.remove,handler:new L.EditToolbar.Delete(t,{featureGroup:e}),title:L.drawLocal.edit.toolbar.buttons.remove}]},getActions:function(t){var e=[{title:L.drawLocal.edit.toolbar.actions.save.title,text:L.drawLocal.edit.toolbar.actions.save.text,callback:this._save,context:this},{title:L.drawLocal.edit.toolbar.actions.cancel.title,text:L.drawLocal.edit.toolbar.actions.cancel.text,callback:this.disable,context:this}];return t.removeAllLayers&&e.push({title:L.drawLocal.edit.toolbar.actions.clearAll.title,text:L.drawLocal.edit.toolbar.actions.clearAll.text,callback:this._clearAllLayers,context:this}),e},addToolbar:function(t){var e=L.Toolbar.prototype.addToolbar.call(this,t);return this._checkDisabled(),this.options.featureGroup.on("layeradd layerremove",this._checkDisabled,this),e},removeToolbar:function(){this.options.featureGroup.off("layeradd layerremove",this._checkDisabled,this),L.Toolbar.prototype.removeToolbar.call(this)},disable:function(){this.enabled()&&(this._activeMode.handler.revertLayers(),L.Toolbar.prototype.disable.call(this))},_save:function(){this._activeMode.handler.save(),this._activeMode&&this._activeMode.handler.disable()},_clearAllLayers:function(){this._activeMode.handler.removeAllLayers(),this._activeMode&&this._activeMode.handler.disable()},_checkDisabled:function(){var t,e=this.options.featureGroup,i=0!==e.getLayers().length;this.options.edit&&(t=this._modes[L.EditToolbar.Edit.TYPE].button,i?L.DomUtil.removeClass(t,"leaflet-disabled"):L.DomUtil.addClass(t,"leaflet-disabled"),t.setAttribute("title",i?L.drawLocal.edit.toolbar.buttons.edit:L.drawLocal.edit.toolbar.buttons.editDisabled)),this.options.remove&&(t=this._modes[L.EditToolbar.Delete.TYPE].button,i?L.DomUtil.removeClass(t,"leaflet-disabled"):L.DomUtil.addClass(t,"leaflet-disabled"),t.setAttribute("title",i?L.drawLocal.edit.toolbar.buttons.remove:L.drawLocal.edit.toolbar.buttons.removeDisabled))}}),L.EditToolbar.Edit=L.Handler.extend({statics:{TYPE:"edit"},initialize:function(t,e){if(L.Handler.prototype.initialize.call(this,t),L.setOptions(this,e),this._featureGroup=e.featureGroup,!(this._featureGroup instanceof L.FeatureGroup))throw new Error("options.featureGroup must be a L.FeatureGroup");this._uneditedLayerProps={},this.type=L.EditToolbar.Edit.TYPE;var i=L.version.split(".");1===parseInt(i[0],10)&&parseInt(i[1],10)>=2?L.EditToolbar.Edit.include(L.Evented.prototype):L.EditToolbar.Edit.include(L.Mixin.Events)},enable:function(){!this._enabled&&this._hasAvailableLayers()&&(this.fire("enabled",{handler:this.type}),this._map.fire(L.Draw.Event.EDITSTART,{handler:this.type}),L.Handler.prototype.enable.call(this),this._featureGroup.on("layeradd",this._enableLayerEdit,this).on("layerremove",this._disableLayerEdit,this))},disable:function(){this._enabled&&(this._featureGroup.off("layeradd",this._enableLayerEdit,this).off("layerremove",this._disableLayerEdit,this),L.Handler.prototype.disable.call(this),this._map.fire(L.Draw.Event.EDITSTOP,{handler:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(t.getContainer().focus(),this._featureGroup.eachLayer(this._enableLayerEdit,this),this._tooltip=new L.Draw.Tooltip(this._map),this._tooltip.updateContent({text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext}),t._editTooltip=this._tooltip,this._updateTooltip(),this._map.on("mousemove",this._onMouseMove,this).on("touchmove",this._onMouseMove,this).on("MSPointerMove",this._onMouseMove,this).on(L.Draw.Event.EDITVERTEX,this._updateTooltip,this))},removeHooks:function(){this._map&&(this._featureGroup.eachLayer(this._disableLayerEdit,this),this._uneditedLayerProps={},this._tooltip.dispose(),this._tooltip=null,this._map.off("mousemove",this._onMouseMove,this).off("touchmove",this._onMouseMove,this).off("MSPointerMove",this._onMouseMove,this).off(L.Draw.Event.EDITVERTEX,this._updateTooltip,this))},revertLayers:function(){this._featureGroup.eachLayer(function(t){this._revertLayer(t)},this)},save:function(){var t=new L.LayerGroup;this._featureGroup.eachLayer(function(e){e.edited&&(t.addLayer(e),e.edited=!1)}),this._map.fire(L.Draw.Event.EDITED,{layers:t})},_backupLayer:function(t){var e=L.Util.stamp(t);this._uneditedLayerProps[e]||(t instanceof L.Polyline||t instanceof L.Polygon||t instanceof L.Rectangle?this._uneditedLayerProps[e]={latlngs:L.LatLngUtil.cloneLatLngs(t.getLatLngs())}:t instanceof L.Circle?this._uneditedLayerProps[e]={latlng:L.LatLngUtil.cloneLatLng(t.getLatLng()),radius:t.getRadius()}:(t instanceof L.Marker||t instanceof L.CircleMarker)&&(this._uneditedLayerProps[e]={latlng:L.LatLngUtil.cloneLatLng(t.getLatLng())}))},_getTooltipText:function(){return{text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext}},_updateTooltip:function(){this._tooltip.updateContent(this._getTooltipText())},_revertLayer:function(t){var e=L.Util.stamp(t);t.edited=!1,this._uneditedLayerProps.hasOwnProperty(e)&&(t instanceof L.Polyline||t instanceof L.Polygon||t instanceof L.Rectangle?t.setLatLngs(this._uneditedLayerProps[e].latlngs):t instanceof L.Circle?(t.setLatLng(this._uneditedLayerProps[e].latlng),t.setRadius(this._uneditedLayerProps[e].radius)):(t instanceof L.Marker||t instanceof L.CircleMarker)&&t.setLatLng(this._uneditedLayerProps[e].latlng),t.fire("revert-edited",{layer:t}))},_enableLayerEdit:function(t){var e,i,o=t.layer||t.target||t;this._backupLayer(o),this.options.poly&&(i=L.Util.extend({},this.options.poly),o.options.poly=i),this.options.selectedPathOptions&&(e=L.Util.extend({},this.options.selectedPathOptions),e.maintainColor&&(e.color=o.options.color,e.fillColor=o.options.fillColor),o.options.original=L.extend({},o.options),o.options.editing=e),o instanceof L.Marker?(o.editing&&o.editing.enable(),o.dragging.enable(),o.on("dragend",this._onMarkerDragEnd).on("touchmove",this._onTouchMove,this).on("MSPointerMove",this._onTouchMove,this).on("touchend",this._onMarkerDragEnd,this).on("MSPointerUp",this._onMarkerDragEnd,this)):o.editing.enable()},_disableLayerEdit:function(t){var e=t.layer||t.target||t;e.edited=!1,e.editing&&e.editing.disable(),delete e.options.editing,delete e.options.original,
this._selectedPathOptions&&(e instanceof L.Marker?this._toggleMarkerHighlight(e):(e.setStyle(e.options.previousOptions),delete e.options.previousOptions)),e instanceof L.Marker?(e.dragging.disable(),e.off("dragend",this._onMarkerDragEnd,this).off("touchmove",this._onTouchMove,this).off("MSPointerMove",this._onTouchMove,this).off("touchend",this._onMarkerDragEnd,this).off("MSPointerUp",this._onMarkerDragEnd,this)):e.editing.disable()},_onMouseMove:function(t){this._tooltip.updatePosition(t.latlng)},_onMarkerDragEnd:function(t){var e=t.target;e.edited=!0,this._map.fire(L.Draw.Event.EDITMOVE,{layer:e})},_onTouchMove:function(t){var e=t.originalEvent.changedTouches[0],i=this._map.mouseEventToLayerPoint(e),o=this._map.layerPointToLatLng(i);t.target.setLatLng(o)},_hasAvailableLayers:function(){return 0!==this._featureGroup.getLayers().length}}),L.EditToolbar.Delete=L.Handler.extend({statics:{TYPE:"remove"},initialize:function(t,e){if(L.Handler.prototype.initialize.call(this,t),L.Util.setOptions(this,e),this._deletableLayers=this.options.featureGroup,!(this._deletableLayers instanceof L.FeatureGroup))throw new Error("options.featureGroup must be a L.FeatureGroup");this.type=L.EditToolbar.Delete.TYPE;var i=L.version.split(".");1===parseInt(i[0],10)&&parseInt(i[1],10)>=2?L.EditToolbar.Delete.include(L.Evented.prototype):L.EditToolbar.Delete.include(L.Mixin.Events)},enable:function(){!this._enabled&&this._hasAvailableLayers()&&(this.fire("enabled",{handler:this.type}),this._map.fire(L.Draw.Event.DELETESTART,{handler:this.type}),L.Handler.prototype.enable.call(this),this._deletableLayers.on("layeradd",this._enableLayerDelete,this).on("layerremove",this._disableLayerDelete,this))},disable:function(){this._enabled&&(this._deletableLayers.off("layeradd",this._enableLayerDelete,this).off("layerremove",this._disableLayerDelete,this),L.Handler.prototype.disable.call(this),this._map.fire(L.Draw.Event.DELETESTOP,{handler:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(t.getContainer().focus(),this._deletableLayers.eachLayer(this._enableLayerDelete,this),this._deletedLayers=new L.LayerGroup,this._tooltip=new L.Draw.Tooltip(this._map),this._tooltip.updateContent({text:L.drawLocal.edit.handlers.remove.tooltip.text}),this._map.on("mousemove",this._onMouseMove,this))},removeHooks:function(){this._map&&(this._deletableLayers.eachLayer(this._disableLayerDelete,this),this._deletedLayers=null,this._tooltip.dispose(),this._tooltip=null,this._map.off("mousemove",this._onMouseMove,this))},revertLayers:function(){this._deletedLayers.eachLayer(function(t){this._deletableLayers.addLayer(t),t.fire("revert-deleted",{layer:t})},this)},save:function(){this._map.fire(L.Draw.Event.DELETED,{layers:this._deletedLayers})},removeAllLayers:function(){this._deletableLayers.eachLayer(function(t){this._removeLayer({layer:t})},this),this.save()},_enableLayerDelete:function(t){(t.layer||t.target||t).on("click",this._removeLayer,this)},_disableLayerDelete:function(t){var e=t.layer||t.target||t;e.off("click",this._removeLayer,this),this._deletedLayers.removeLayer(e)},_removeLayer:function(t){var e=t.layer||t.target||t;this._deletableLayers.removeLayer(e),this._deletedLayers.addLayer(e),e.fire("deleted")},_onMouseMove:function(t){this._tooltip.updatePosition(t.latlng)},_hasAvailableLayers:function(){return 0!==this._deletableLayers.getLayers().length}})}(window,document);

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

/* @preserve
 * Leaflet 1.3.3, a JS library for interactive maps. http://leafletjs.com
 * (c) 2010-2018 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
!function(t,i){ true?i(exports):"function"==typeof define&&define.amd?define(["exports"],i):i(t.L={})}(this,function(t){"use strict";function i(t){var i,e,n,o;for(e=1,n=arguments.length;e<n;e++){o=arguments[e];for(i in o)t[i]=o[i]}return t}function e(t,i){var e=Array.prototype.slice;if(t.bind)return t.bind.apply(t,e.call(arguments,1));var n=e.call(arguments,2);return function(){return t.apply(i,n.length?n.concat(e.call(arguments)):arguments)}}function n(t){return t._leaflet_id=t._leaflet_id||++ei,t._leaflet_id}function o(t,i,e){var n,o,s,r;return r=function(){n=!1,o&&(s.apply(e,o),o=!1)},s=function(){n?o=arguments:(t.apply(e,arguments),setTimeout(r,i),n=!0)}}function s(t,i,e){var n=i[1],o=i[0],s=n-o;return t===n&&e?t:((t-o)%s+s)%s+o}function r(){return!1}function a(t,i){var e=Math.pow(10,void 0===i?6:i);return Math.round(t*e)/e}function h(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}function u(t){return h(t).split(/\s+/)}function l(t,i){t.hasOwnProperty("options")||(t.options=t.options?ii(t.options):{});for(var e in i)t.options[e]=i[e];return t.options}function c(t,i,e){var n=[];for(var o in t)n.push(encodeURIComponent(e?o.toUpperCase():o)+"="+encodeURIComponent(t[o]));return(i&&-1!==i.indexOf("?")?"&":"?")+n.join("&")}function _(t,i){return t.replace(ni,function(t,e){var n=i[e];if(void 0===n)throw new Error("No value provided for variable "+t);return"function"==typeof n&&(n=n(i)),n})}function d(t,i){for(var e=0;e<t.length;e++)if(t[e]===i)return e;return-1}function p(t){return window["webkit"+t]||window["moz"+t]||window["ms"+t]}function m(t){var i=+new Date,e=Math.max(0,16-(i-ri));return ri=i+e,window.setTimeout(t,e)}function f(t,i,n){if(!n||ai!==m)return ai.call(window,e(t,i));t.call(i)}function g(t){t&&hi.call(window,t)}function v(){}function y(t){if("undefined"!=typeof L&&L&&L.Mixin){t=oi(t)?t:[t];for(var i=0;i<t.length;i++)t[i]===L.Mixin.Events&&console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.",(new Error).stack)}}function x(t,i,e){this.x=e?Math.round(t):t,this.y=e?Math.round(i):i}function w(t,i,e){return t instanceof x?t:oi(t)?new x(t[0],t[1]):void 0===t||null===t?t:"object"==typeof t&&"x"in t&&"y"in t?new x(t.x,t.y):new x(t,i,e)}function P(t,i){if(t)for(var e=i?[t,i]:t,n=0,o=e.length;n<o;n++)this.extend(e[n])}function b(t,i){return!t||t instanceof P?t:new P(t,i)}function T(t,i){if(t)for(var e=i?[t,i]:t,n=0,o=e.length;n<o;n++)this.extend(e[n])}function z(t,i){return t instanceof T?t:new T(t,i)}function M(t,i,e){if(isNaN(t)||isNaN(i))throw new Error("Invalid LatLng object: ("+t+", "+i+")");this.lat=+t,this.lng=+i,void 0!==e&&(this.alt=+e)}function C(t,i,e){return t instanceof M?t:oi(t)&&"object"!=typeof t[0]?3===t.length?new M(t[0],t[1],t[2]):2===t.length?new M(t[0],t[1]):null:void 0===t||null===t?t:"object"==typeof t&&"lat"in t?new M(t.lat,"lng"in t?t.lng:t.lon,t.alt):void 0===i?null:new M(t,i,e)}function S(t,i,e,n){if(oi(t))return this._a=t[0],this._b=t[1],this._c=t[2],void(this._d=t[3]);this._a=t,this._b=i,this._c=e,this._d=n}function Z(t,i,e,n){return new S(t,i,e,n)}function E(t){return document.createElementNS("http://www.w3.org/2000/svg",t)}function k(t,i){var e,n,o,s,r,a,h="";for(e=0,o=t.length;e<o;e++){for(n=0,s=(r=t[e]).length;n<s;n++)a=r[n],h+=(n?"L":"M")+a.x+" "+a.y;h+=i?Ji?"z":"x":""}return h||"M0 0"}function A(t){return navigator.userAgent.toLowerCase().indexOf(t)>=0}function B(t,i,e,n){return"touchstart"===i?O(t,e,n):"touchmove"===i?W(t,e,n):"touchend"===i&&H(t,e,n),this}function I(t,i,e){var n=t["_leaflet_"+i+e];return"touchstart"===i?t.removeEventListener(te,n,!1):"touchmove"===i?t.removeEventListener(ie,n,!1):"touchend"===i&&(t.removeEventListener(ee,n,!1),t.removeEventListener(ne,n,!1)),this}function O(t,i,n){var o=e(function(t){if("mouse"!==t.pointerType&&t.MSPOINTER_TYPE_MOUSE&&t.pointerType!==t.MSPOINTER_TYPE_MOUSE){if(!(oe.indexOf(t.target.tagName)<0))return;Pt(t)}j(t,i)});t["_leaflet_touchstart"+n]=o,t.addEventListener(te,o,!1),re||(document.documentElement.addEventListener(te,R,!0),document.documentElement.addEventListener(ie,N,!0),document.documentElement.addEventListener(ee,D,!0),document.documentElement.addEventListener(ne,D,!0),re=!0)}function R(t){se[t.pointerId]=t,ae++}function N(t){se[t.pointerId]&&(se[t.pointerId]=t)}function D(t){delete se[t.pointerId],ae--}function j(t,i){t.touches=[];for(var e in se)t.touches.push(se[e]);t.changedTouches=[t],i(t)}function W(t,i,e){var n=function(t){(t.pointerType!==t.MSPOINTER_TYPE_MOUSE&&"mouse"!==t.pointerType||0!==t.buttons)&&j(t,i)};t["_leaflet_touchmove"+e]=n,t.addEventListener(ie,n,!1)}function H(t,i,e){var n=function(t){j(t,i)};t["_leaflet_touchend"+e]=n,t.addEventListener(ee,n,!1),t.addEventListener(ne,n,!1)}function F(t,i,e){function n(t){var i;if(Vi){if(!bi||"mouse"===t.pointerType)return;i=ae}else i=t.touches.length;if(!(i>1)){var e=Date.now(),n=e-(s||e);r=t.touches?t.touches[0]:t,a=n>0&&n<=h,s=e}}function o(t){if(a&&!r.cancelBubble){if(Vi){if(!bi||"mouse"===t.pointerType)return;var e,n,o={};for(n in r)e=r[n],o[n]=e&&e.bind?e.bind(r):e;r=o}r.type="dblclick",i(r),s=null}}var s,r,a=!1,h=250;return t[le+he+e]=n,t[le+ue+e]=o,t[le+"dblclick"+e]=i,t.addEventListener(he,n,!1),t.addEventListener(ue,o,!1),t.addEventListener("dblclick",i,!1),this}function U(t,i){var e=t[le+he+i],n=t[le+ue+i],o=t[le+"dblclick"+i];return t.removeEventListener(he,e,!1),t.removeEventListener(ue,n,!1),bi||t.removeEventListener("dblclick",o,!1),this}function V(t){return"string"==typeof t?document.getElementById(t):t}function q(t,i){var e=t.style[i]||t.currentStyle&&t.currentStyle[i];if((!e||"auto"===e)&&document.defaultView){var n=document.defaultView.getComputedStyle(t,null);e=n?n[i]:null}return"auto"===e?null:e}function G(t,i,e){var n=document.createElement(t);return n.className=i||"",e&&e.appendChild(n),n}function K(t){var i=t.parentNode;i&&i.removeChild(t)}function Y(t){for(;t.firstChild;)t.removeChild(t.firstChild)}function X(t){var i=t.parentNode;i.lastChild!==t&&i.appendChild(t)}function J(t){var i=t.parentNode;i.firstChild!==t&&i.insertBefore(t,i.firstChild)}function $(t,i){if(void 0!==t.classList)return t.classList.contains(i);var e=et(t);return e.length>0&&new RegExp("(^|\\s)"+i+"(\\s|$)").test(e)}function Q(t,i){if(void 0!==t.classList)for(var e=u(i),n=0,o=e.length;n<o;n++)t.classList.add(e[n]);else if(!$(t,i)){var s=et(t);it(t,(s?s+" ":"")+i)}}function tt(t,i){void 0!==t.classList?t.classList.remove(i):it(t,h((" "+et(t)+" ").replace(" "+i+" "," ")))}function it(t,i){void 0===t.className.baseVal?t.className=i:t.className.baseVal=i}function et(t){return void 0===t.className.baseVal?t.className:t.className.baseVal}function nt(t,i){"opacity"in t.style?t.style.opacity=i:"filter"in t.style&&ot(t,i)}function ot(t,i){var e=!1,n="DXImageTransform.Microsoft.Alpha";try{e=t.filters.item(n)}catch(t){if(1===i)return}i=Math.round(100*i),e?(e.Enabled=100!==i,e.Opacity=i):t.style.filter+=" progid:"+n+"(opacity="+i+")"}function st(t){for(var i=document.documentElement.style,e=0;e<t.length;e++)if(t[e]in i)return t[e];return!1}function rt(t,i,e){var n=i||new x(0,0);t.style[ce]=(Ri?"translate("+n.x+"px,"+n.y+"px)":"translate3d("+n.x+"px,"+n.y+"px,0)")+(e?" scale("+e+")":"")}function at(t,i){t._leaflet_pos=i,ji?rt(t,i):(t.style.left=i.x+"px",t.style.top=i.y+"px")}function ht(t){return t._leaflet_pos||new x(0,0)}function ut(){mt(window,"dragstart",Pt)}function lt(){ft(window,"dragstart",Pt)}function ct(t){for(;-1===t.tabIndex;)t=t.parentNode;t.style&&(_t(),me=t,fe=t.style.outline,t.style.outline="none",mt(window,"keydown",_t))}function _t(){me&&(me.style.outline=fe,me=void 0,fe=void 0,ft(window,"keydown",_t))}function dt(t){do{t=t.parentNode}while(!(t.offsetWidth&&t.offsetHeight||t===document.body));return t}function pt(t){var i=t.getBoundingClientRect();return{x:i.width/t.offsetWidth||1,y:i.height/t.offsetHeight||1,boundingClientRect:i}}function mt(t,i,e,n){if("object"==typeof i)for(var o in i)gt(t,o,i[o],e);else for(var s=0,r=(i=u(i)).length;s<r;s++)gt(t,i[s],e,n);return this}function ft(t,i,e,n){if("object"==typeof i)for(var o in i)vt(t,o,i[o],e);else if(i)for(var s=0,r=(i=u(i)).length;s<r;s++)vt(t,i[s],e,n);else{for(var a in t[ye])vt(t,a,t[ye][a]);delete t[ye]}return this}function gt(t,i,e,o){var s=i+n(e)+(o?"_"+n(o):"");if(t[ye]&&t[ye][s])return this;var r=function(i){return e.call(o||t,i||window.event)},a=r;Vi&&0===i.indexOf("touch")?B(t,i,r,s):!qi||"dblclick"!==i||!F||Vi&&Ei?"addEventListener"in t?"mousewheel"===i?t.addEventListener("onwheel"in t?"wheel":"mousewheel",r,!1):"mouseenter"===i||"mouseleave"===i?(r=function(i){i=i||window.event,Ct(t,i)&&a(i)},t.addEventListener("mouseenter"===i?"mouseover":"mouseout",r,!1)):("click"===i&&zi&&(r=function(t){St(t,a)}),t.addEventListener(i,r,!1)):"attachEvent"in t&&t.attachEvent("on"+i,r):F(t,r,s),t[ye]=t[ye]||{},t[ye][s]=r}function vt(t,i,e,o){var s=i+n(e)+(o?"_"+n(o):""),r=t[ye]&&t[ye][s];if(!r)return this;Vi&&0===i.indexOf("touch")?I(t,i,s):!qi||"dblclick"!==i||!U||Vi&&Ei?"removeEventListener"in t?"mousewheel"===i?t.removeEventListener("onwheel"in t?"wheel":"mousewheel",r,!1):t.removeEventListener("mouseenter"===i?"mouseover":"mouseleave"===i?"mouseout":i,r,!1):"detachEvent"in t&&t.detachEvent("on"+i,r):U(t,s),t[ye][s]=null}function yt(t){return t.stopPropagation?t.stopPropagation():t.originalEvent?t.originalEvent._stopped=!0:t.cancelBubble=!0,Mt(t),this}function xt(t){return gt(t,"mousewheel",yt),this}function wt(t){return mt(t,"mousedown touchstart dblclick",yt),gt(t,"click",zt),this}function Pt(t){return t.preventDefault?t.preventDefault():t.returnValue=!1,this}function Lt(t){return Pt(t),yt(t),this}function bt(t,i){if(!i)return new x(t.clientX,t.clientY);var e=pt(i),n=e.boundingClientRect;return new x((t.clientX-n.left)/e.x-i.clientLeft,(t.clientY-n.top)/e.y-i.clientTop)}function Tt(t){return bi?t.wheelDeltaY/2:t.deltaY&&0===t.deltaMode?-t.deltaY/xe:t.deltaY&&1===t.deltaMode?20*-t.deltaY:t.deltaY&&2===t.deltaMode?60*-t.deltaY:t.deltaX||t.deltaZ?0:t.wheelDelta?(t.wheelDeltaY||t.wheelDelta)/2:t.detail&&Math.abs(t.detail)<32765?20*-t.detail:t.detail?t.detail/-32765*60:0}function zt(t){we[t.type]=!0}function Mt(t){var i=we[t.type];return we[t.type]=!1,i}function Ct(t,i){var e=i.relatedTarget;if(!e)return!0;try{for(;e&&e!==t;)e=e.parentNode}catch(t){return!1}return e!==t}function St(t,i){var e=t.timeStamp||t.originalEvent&&t.originalEvent.timeStamp,n=ge&&e-ge;n&&n>100&&n<500||t.target._simulatedClick&&!t._simulated?Lt(t):(ge=e,i(t))}function Zt(t,i){if(!i||!t.length)return t.slice();var e=i*i;return t=Bt(t,e),t=kt(t,e)}function Et(t,i,e){return Math.sqrt(Dt(t,i,e,!0))}function kt(t,i){var e=t.length,n=new(typeof Uint8Array!=void 0+""?Uint8Array:Array)(e);n[0]=n[e-1]=1,At(t,n,i,0,e-1);var o,s=[];for(o=0;o<e;o++)n[o]&&s.push(t[o]);return s}function At(t,i,e,n,o){var s,r,a,h=0;for(r=n+1;r<=o-1;r++)(a=Dt(t[r],t[n],t[o],!0))>h&&(s=r,h=a);h>e&&(i[s]=1,At(t,i,e,n,s),At(t,i,e,s,o))}function Bt(t,i){for(var e=[t[0]],n=1,o=0,s=t.length;n<s;n++)Nt(t[n],t[o])>i&&(e.push(t[n]),o=n);return o<s-1&&e.push(t[s-1]),e}function It(t,i,e,n,o){var s,r,a,h=n?ke:Rt(t,e),u=Rt(i,e);for(ke=u;;){if(!(h|u))return[t,i];if(h&u)return!1;a=Rt(r=Ot(t,i,s=h||u,e,o),e),s===h?(t=r,h=a):(i=r,u=a)}}function Ot(t,i,e,n,o){var s,r,a=i.x-t.x,h=i.y-t.y,u=n.min,l=n.max;return 8&e?(s=t.x+a*(l.y-t.y)/h,r=l.y):4&e?(s=t.x+a*(u.y-t.y)/h,r=u.y):2&e?(s=l.x,r=t.y+h*(l.x-t.x)/a):1&e&&(s=u.x,r=t.y+h*(u.x-t.x)/a),new x(s,r,o)}function Rt(t,i){var e=0;return t.x<i.min.x?e|=1:t.x>i.max.x&&(e|=2),t.y<i.min.y?e|=4:t.y>i.max.y&&(e|=8),e}function Nt(t,i){var e=i.x-t.x,n=i.y-t.y;return e*e+n*n}function Dt(t,i,e,n){var o,s=i.x,r=i.y,a=e.x-s,h=e.y-r,u=a*a+h*h;return u>0&&((o=((t.x-s)*a+(t.y-r)*h)/u)>1?(s=e.x,r=e.y):o>0&&(s+=a*o,r+=h*o)),a=t.x-s,h=t.y-r,n?a*a+h*h:new x(s,r)}function jt(t){return!oi(t[0])||"object"!=typeof t[0][0]&&void 0!==t[0][0]}function Wt(t){return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."),jt(t)}function Ht(t,i,e){var n,o,s,r,a,h,u,l,c,_=[1,4,2,8];for(o=0,u=t.length;o<u;o++)t[o]._code=Rt(t[o],i);for(r=0;r<4;r++){for(l=_[r],n=[],o=0,s=(u=t.length)-1;o<u;s=o++)a=t[o],h=t[s],a._code&l?h._code&l||((c=Ot(h,a,l,i,e))._code=Rt(c,i),n.push(c)):(h._code&l&&((c=Ot(h,a,l,i,e))._code=Rt(c,i),n.push(c)),n.push(a));t=n}return t}function Ft(t,i){var e,n,o,s,r="Feature"===t.type?t.geometry:t,a=r?r.coordinates:null,h=[],u=i&&i.pointToLayer,l=i&&i.coordsToLatLng||Ut;if(!a&&!r)return null;switch(r.type){case"Point":return e=l(a),u?u(t,e):new $e(e);case"MultiPoint":for(o=0,s=a.length;o<s;o++)e=l(a[o]),h.push(u?u(t,e):new $e(e));return new Ke(h);case"LineString":case"MultiLineString":return n=Vt(a,"LineString"===r.type?0:1,l),new nn(n,i);case"Polygon":case"MultiPolygon":return n=Vt(a,"Polygon"===r.type?1:2,l),new on(n,i);case"GeometryCollection":for(o=0,s=r.geometries.length;o<s;o++){var c=Ft({geometry:r.geometries[o],type:"Feature",properties:t.properties},i);c&&h.push(c)}return new Ke(h);default:throw new Error("Invalid GeoJSON object.")}}function Ut(t){return new M(t[1],t[0],t[2])}function Vt(t,i,e){for(var n,o=[],s=0,r=t.length;s<r;s++)n=i?Vt(t[s],i-1,e):(e||Ut)(t[s]),o.push(n);return o}function qt(t,i){return i="number"==typeof i?i:6,void 0!==t.alt?[a(t.lng,i),a(t.lat,i),a(t.alt,i)]:[a(t.lng,i),a(t.lat,i)]}function Gt(t,i,e,n){for(var o=[],s=0,r=t.length;s<r;s++)o.push(i?Gt(t[s],i-1,e,n):qt(t[s],n));return!i&&e&&o.push(o[0]),o}function Kt(t,e){return t.feature?i({},t.feature,{geometry:e}):Yt(e)}function Yt(t){return"Feature"===t.type||"FeatureCollection"===t.type?t:{type:"Feature",properties:{},geometry:t}}function Xt(t,i){return new sn(t,i)}function Jt(t,i){return new mn(t,i)}function $t(t){return Xi?new vn(t):null}function Qt(t){return Ji||$i?new Pn(t):null}var ti=Object.freeze;Object.freeze=function(t){return t};var ii=Object.create||function(){function t(){}return function(i){return t.prototype=i,new t}}(),ei=0,ni=/\{ *([\w_-]+) *\}/g,oi=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)},si="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=",ri=0,ai=window.requestAnimationFrame||p("RequestAnimationFrame")||m,hi=window.cancelAnimationFrame||p("CancelAnimationFrame")||p("CancelRequestAnimationFrame")||function(t){window.clearTimeout(t)},ui=(Object.freeze||Object)({freeze:ti,extend:i,create:ii,bind:e,lastId:ei,stamp:n,throttle:o,wrapNum:s,falseFn:r,formatNum:a,trim:h,splitWords:u,setOptions:l,getParamString:c,template:_,isArray:oi,indexOf:d,emptyImageUrl:si,requestFn:ai,cancelFn:hi,requestAnimFrame:f,cancelAnimFrame:g});v.extend=function(t){var e=function(){this.initialize&&this.initialize.apply(this,arguments),this.callInitHooks()},n=e.__super__=this.prototype,o=ii(n);o.constructor=e,e.prototype=o;for(var s in this)this.hasOwnProperty(s)&&"prototype"!==s&&"__super__"!==s&&(e[s]=this[s]);return t.statics&&(i(e,t.statics),delete t.statics),t.includes&&(y(t.includes),i.apply(null,[o].concat(t.includes)),delete t.includes),o.options&&(t.options=i(ii(o.options),t.options)),i(o,t),o._initHooks=[],o.callInitHooks=function(){if(!this._initHooksCalled){n.callInitHooks&&n.callInitHooks.call(this),this._initHooksCalled=!0;for(var t=0,i=o._initHooks.length;t<i;t++)o._initHooks[t].call(this)}},e},v.include=function(t){return i(this.prototype,t),this},v.mergeOptions=function(t){return i(this.prototype.options,t),this},v.addInitHook=function(t){var i=Array.prototype.slice.call(arguments,1),e="function"==typeof t?t:function(){this[t].apply(this,i)};return this.prototype._initHooks=this.prototype._initHooks||[],this.prototype._initHooks.push(e),this};var li={on:function(t,i,e){if("object"==typeof t)for(var n in t)this._on(n,t[n],i);else for(var o=0,s=(t=u(t)).length;o<s;o++)this._on(t[o],i,e);return this},off:function(t,i,e){if(t)if("object"==typeof t)for(var n in t)this._off(n,t[n],i);else for(var o=0,s=(t=u(t)).length;o<s;o++)this._off(t[o],i,e);else delete this._events;return this},_on:function(t,i,e){this._events=this._events||{};var n=this._events[t];n||(n=[],this._events[t]=n),e===this&&(e=void 0);for(var o={fn:i,ctx:e},s=n,r=0,a=s.length;r<a;r++)if(s[r].fn===i&&s[r].ctx===e)return;s.push(o)},_off:function(t,i,e){var n,o,s;if(this._events&&(n=this._events[t]))if(i){if(e===this&&(e=void 0),n)for(o=0,s=n.length;o<s;o++){var a=n[o];if(a.ctx===e&&a.fn===i)return a.fn=r,this._firingCount&&(this._events[t]=n=n.slice()),void n.splice(o,1)}}else{for(o=0,s=n.length;o<s;o++)n[o].fn=r;delete this._events[t]}},fire:function(t,e,n){if(!this.listens(t,n))return this;var o=i({},e,{type:t,target:this,sourceTarget:e&&e.sourceTarget||this});if(this._events){var s=this._events[t];if(s){this._firingCount=this._firingCount+1||1;for(var r=0,a=s.length;r<a;r++){var h=s[r];h.fn.call(h.ctx||this,o)}this._firingCount--}}return n&&this._propagateEvent(o),this},listens:function(t,i){var e=this._events&&this._events[t];if(e&&e.length)return!0;if(i)for(var n in this._eventParents)if(this._eventParents[n].listens(t,i))return!0;return!1},once:function(t,i,n){if("object"==typeof t){for(var o in t)this.once(o,t[o],i);return this}var s=e(function(){this.off(t,i,n).off(t,s,n)},this);return this.on(t,i,n).on(t,s,n)},addEventParent:function(t){return this._eventParents=this._eventParents||{},this._eventParents[n(t)]=t,this},removeEventParent:function(t){return this._eventParents&&delete this._eventParents[n(t)],this},_propagateEvent:function(t){for(var e in this._eventParents)this._eventParents[e].fire(t.type,i({layer:t.target,propagatedFrom:t.target},t),!0)}};li.addEventListener=li.on,li.removeEventListener=li.clearAllEventListeners=li.off,li.addOneTimeEventListener=li.once,li.fireEvent=li.fire,li.hasEventListeners=li.listens;var ci=v.extend(li),_i=Math.trunc||function(t){return t>0?Math.floor(t):Math.ceil(t)};x.prototype={clone:function(){return new x(this.x,this.y)},add:function(t){return this.clone()._add(w(t))},_add:function(t){return this.x+=t.x,this.y+=t.y,this},subtract:function(t){return this.clone()._subtract(w(t))},_subtract:function(t){return this.x-=t.x,this.y-=t.y,this},divideBy:function(t){return this.clone()._divideBy(t)},_divideBy:function(t){return this.x/=t,this.y/=t,this},multiplyBy:function(t){return this.clone()._multiplyBy(t)},_multiplyBy:function(t){return this.x*=t,this.y*=t,this},scaleBy:function(t){return new x(this.x*t.x,this.y*t.y)},unscaleBy:function(t){return new x(this.x/t.x,this.y/t.y)},round:function(){return this.clone()._round()},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this},floor:function(){return this.clone()._floor()},_floor:function(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this},ceil:function(){return this.clone()._ceil()},_ceil:function(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this},trunc:function(){return this.clone()._trunc()},_trunc:function(){return this.x=_i(this.x),this.y=_i(this.y),this},distanceTo:function(t){var i=(t=w(t)).x-this.x,e=t.y-this.y;return Math.sqrt(i*i+e*e)},equals:function(t){return(t=w(t)).x===this.x&&t.y===this.y},contains:function(t){return t=w(t),Math.abs(t.x)<=Math.abs(this.x)&&Math.abs(t.y)<=Math.abs(this.y)},toString:function(){return"Point("+a(this.x)+", "+a(this.y)+")"}},P.prototype={extend:function(t){return t=w(t),this.min||this.max?(this.min.x=Math.min(t.x,this.min.x),this.max.x=Math.max(t.x,this.max.x),this.min.y=Math.min(t.y,this.min.y),this.max.y=Math.max(t.y,this.max.y)):(this.min=t.clone(),this.max=t.clone()),this},getCenter:function(t){return new x((this.min.x+this.max.x)/2,(this.min.y+this.max.y)/2,t)},getBottomLeft:function(){return new x(this.min.x,this.max.y)},getTopRight:function(){return new x(this.max.x,this.min.y)},getTopLeft:function(){return this.min},getBottomRight:function(){return this.max},getSize:function(){return this.max.subtract(this.min)},contains:function(t){var i,e;return(t="number"==typeof t[0]||t instanceof x?w(t):b(t))instanceof P?(i=t.min,e=t.max):i=e=t,i.x>=this.min.x&&e.x<=this.max.x&&i.y>=this.min.y&&e.y<=this.max.y},intersects:function(t){t=b(t);var i=this.min,e=this.max,n=t.min,o=t.max,s=o.x>=i.x&&n.x<=e.x,r=o.y>=i.y&&n.y<=e.y;return s&&r},overlaps:function(t){t=b(t);var i=this.min,e=this.max,n=t.min,o=t.max,s=o.x>i.x&&n.x<e.x,r=o.y>i.y&&n.y<e.y;return s&&r},isValid:function(){return!(!this.min||!this.max)}},T.prototype={extend:function(t){var i,e,n=this._southWest,o=this._northEast;if(t instanceof M)i=t,e=t;else{if(!(t instanceof T))return t?this.extend(C(t)||z(t)):this;if(i=t._southWest,e=t._northEast,!i||!e)return this}return n||o?(n.lat=Math.min(i.lat,n.lat),n.lng=Math.min(i.lng,n.lng),o.lat=Math.max(e.lat,o.lat),o.lng=Math.max(e.lng,o.lng)):(this._southWest=new M(i.lat,i.lng),this._northEast=new M(e.lat,e.lng)),this},pad:function(t){var i=this._southWest,e=this._northEast,n=Math.abs(i.lat-e.lat)*t,o=Math.abs(i.lng-e.lng)*t;return new T(new M(i.lat-n,i.lng-o),new M(e.lat+n,e.lng+o))},getCenter:function(){return new M((this._southWest.lat+this._northEast.lat)/2,(this._southWest.lng+this._northEast.lng)/2)},getSouthWest:function(){return this._southWest},getNorthEast:function(){return this._northEast},getNorthWest:function(){return new M(this.getNorth(),this.getWest())},getSouthEast:function(){return new M(this.getSouth(),this.getEast())},getWest:function(){return this._southWest.lng},getSouth:function(){return this._southWest.lat},getEast:function(){return this._northEast.lng},getNorth:function(){return this._northEast.lat},contains:function(t){t="number"==typeof t[0]||t instanceof M||"lat"in t?C(t):z(t);var i,e,n=this._southWest,o=this._northEast;return t instanceof T?(i=t.getSouthWest(),e=t.getNorthEast()):i=e=t,i.lat>=n.lat&&e.lat<=o.lat&&i.lng>=n.lng&&e.lng<=o.lng},intersects:function(t){t=z(t);var i=this._southWest,e=this._northEast,n=t.getSouthWest(),o=t.getNorthEast(),s=o.lat>=i.lat&&n.lat<=e.lat,r=o.lng>=i.lng&&n.lng<=e.lng;return s&&r},overlaps:function(t){t=z(t);var i=this._southWest,e=this._northEast,n=t.getSouthWest(),o=t.getNorthEast(),s=o.lat>i.lat&&n.lat<e.lat,r=o.lng>i.lng&&n.lng<e.lng;return s&&r},toBBoxString:function(){return[this.getWest(),this.getSouth(),this.getEast(),this.getNorth()].join(",")},equals:function(t,i){return!!t&&(t=z(t),this._southWest.equals(t.getSouthWest(),i)&&this._northEast.equals(t.getNorthEast(),i))},isValid:function(){return!(!this._southWest||!this._northEast)}},M.prototype={equals:function(t,i){return!!t&&(t=C(t),Math.max(Math.abs(this.lat-t.lat),Math.abs(this.lng-t.lng))<=(void 0===i?1e-9:i))},toString:function(t){return"LatLng("+a(this.lat,t)+", "+a(this.lng,t)+")"},distanceTo:function(t){return pi.distance(this,C(t))},wrap:function(){return pi.wrapLatLng(this)},toBounds:function(t){var i=180*t/40075017,e=i/Math.cos(Math.PI/180*this.lat);return z([this.lat-i,this.lng-e],[this.lat+i,this.lng+e])},clone:function(){return new M(this.lat,this.lng,this.alt)}};var di={latLngToPoint:function(t,i){var e=this.projection.project(t),n=this.scale(i);return this.transformation._transform(e,n)},pointToLatLng:function(t,i){var e=this.scale(i),n=this.transformation.untransform(t,e);return this.projection.unproject(n)},project:function(t){return this.projection.project(t)},unproject:function(t){return this.projection.unproject(t)},scale:function(t){return 256*Math.pow(2,t)},zoom:function(t){return Math.log(t/256)/Math.LN2},getProjectedBounds:function(t){if(this.infinite)return null;var i=this.projection.bounds,e=this.scale(t);return new P(this.transformation.transform(i.min,e),this.transformation.transform(i.max,e))},infinite:!1,wrapLatLng:function(t){var i=this.wrapLng?s(t.lng,this.wrapLng,!0):t.lng;return new M(this.wrapLat?s(t.lat,this.wrapLat,!0):t.lat,i,t.alt)},wrapLatLngBounds:function(t){var i=t.getCenter(),e=this.wrapLatLng(i),n=i.lat-e.lat,o=i.lng-e.lng;if(0===n&&0===o)return t;var s=t.getSouthWest(),r=t.getNorthEast();return new T(new M(s.lat-n,s.lng-o),new M(r.lat-n,r.lng-o))}},pi=i({},di,{wrapLng:[-180,180],R:6371e3,distance:function(t,i){var e=Math.PI/180,n=t.lat*e,o=i.lat*e,s=Math.sin((i.lat-t.lat)*e/2),r=Math.sin((i.lng-t.lng)*e/2),a=s*s+Math.cos(n)*Math.cos(o)*r*r,h=2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));return this.R*h}}),mi={R:6378137,MAX_LATITUDE:85.0511287798,project:function(t){var i=Math.PI/180,e=this.MAX_LATITUDE,n=Math.max(Math.min(e,t.lat),-e),o=Math.sin(n*i);return new x(this.R*t.lng*i,this.R*Math.log((1+o)/(1-o))/2)},unproject:function(t){var i=180/Math.PI;return new M((2*Math.atan(Math.exp(t.y/this.R))-Math.PI/2)*i,t.x*i/this.R)},bounds:function(){var t=6378137*Math.PI;return new P([-t,-t],[t,t])}()};S.prototype={transform:function(t,i){return this._transform(t.clone(),i)},_transform:function(t,i){return i=i||1,t.x=i*(this._a*t.x+this._b),t.y=i*(this._c*t.y+this._d),t},untransform:function(t,i){return i=i||1,new x((t.x/i-this._b)/this._a,(t.y/i-this._d)/this._c)}};var fi,gi,vi,yi=i({},pi,{code:"EPSG:3857",projection:mi,transformation:function(){var t=.5/(Math.PI*mi.R);return Z(t,.5,-t,.5)}()}),xi=i({},yi,{code:"EPSG:900913"}),wi=document.documentElement.style,Pi="ActiveXObject"in window,Li=Pi&&!document.addEventListener,bi="msLaunchUri"in navigator&&!("documentMode"in document),Ti=A("webkit"),zi=A("android"),Mi=A("android 2")||A("android 3"),Ci=parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1],10),Si=zi&&A("Google")&&Ci<537&&!("AudioNode"in window),Zi=!!window.opera,Ei=A("chrome"),ki=A("gecko")&&!Ti&&!Zi&&!Pi,Ai=!Ei&&A("safari"),Bi=A("phantom"),Ii="OTransition"in wi,Oi=0===navigator.platform.indexOf("Win"),Ri=Pi&&"transition"in wi,Ni="WebKitCSSMatrix"in window&&"m11"in new window.WebKitCSSMatrix&&!Mi,Di="MozPerspective"in wi,ji=!window.L_DISABLE_3D&&(Ri||Ni||Di)&&!Ii&&!Bi,Wi="undefined"!=typeof orientation||A("mobile"),Hi=Wi&&Ti,Fi=Wi&&Ni,Ui=!window.PointerEvent&&window.MSPointerEvent,Vi=!(!window.PointerEvent&&!Ui),qi=!window.L_NO_TOUCH&&(Vi||"ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch),Gi=Wi&&Zi,Ki=Wi&&ki,Yi=(window.devicePixelRatio||window.screen.deviceXDPI/window.screen.logicalXDPI)>1,Xi=!!document.createElement("canvas").getContext,Ji=!(!document.createElementNS||!E("svg").createSVGRect),$i=!Ji&&function(){try{var t=document.createElement("div");t.innerHTML='<v:shape adj="1"/>';var i=t.firstChild;return i.style.behavior="url(#default#VML)",i&&"object"==typeof i.adj}catch(t){return!1}}(),Qi=(Object.freeze||Object)({ie:Pi,ielt9:Li,edge:bi,webkit:Ti,android:zi,android23:Mi,androidStock:Si,opera:Zi,chrome:Ei,gecko:ki,safari:Ai,phantom:Bi,opera12:Ii,win:Oi,ie3d:Ri,webkit3d:Ni,gecko3d:Di,any3d:ji,mobile:Wi,mobileWebkit:Hi,mobileWebkit3d:Fi,msPointer:Ui,pointer:Vi,touch:qi,mobileOpera:Gi,mobileGecko:Ki,retina:Yi,canvas:Xi,svg:Ji,vml:$i}),te=Ui?"MSPointerDown":"pointerdown",ie=Ui?"MSPointerMove":"pointermove",ee=Ui?"MSPointerUp":"pointerup",ne=Ui?"MSPointerCancel":"pointercancel",oe=["INPUT","SELECT","OPTION"],se={},re=!1,ae=0,he=Ui?"MSPointerDown":Vi?"pointerdown":"touchstart",ue=Ui?"MSPointerUp":Vi?"pointerup":"touchend",le="_leaflet_",ce=st(["transform","WebkitTransform","OTransform","MozTransform","msTransform"]),_e=st(["webkitTransition","transition","OTransition","MozTransition","msTransition"]),de="webkitTransition"===_e||"OTransition"===_e?_e+"End":"transitionend";if("onselectstart"in document)fi=function(){mt(window,"selectstart",Pt)},gi=function(){ft(window,"selectstart",Pt)};else{var pe=st(["userSelect","WebkitUserSelect","OUserSelect","MozUserSelect","msUserSelect"]);fi=function(){if(pe){var t=document.documentElement.style;vi=t[pe],t[pe]="none"}},gi=function(){pe&&(document.documentElement.style[pe]=vi,vi=void 0)}}var me,fe,ge,ve=(Object.freeze||Object)({TRANSFORM:ce,TRANSITION:_e,TRANSITION_END:de,get:V,getStyle:q,create:G,remove:K,empty:Y,toFront:X,toBack:J,hasClass:$,addClass:Q,removeClass:tt,setClass:it,getClass:et,setOpacity:nt,testProp:st,setTransform:rt,setPosition:at,getPosition:ht,disableTextSelection:fi,enableTextSelection:gi,disableImageDrag:ut,enableImageDrag:lt,preventOutline:ct,restoreOutline:_t,getSizedParentNode:dt,getScale:pt}),ye="_leaflet_events",xe=Oi&&Ei?2*window.devicePixelRatio:ki?window.devicePixelRatio:1,we={},Pe=(Object.freeze||Object)({on:mt,off:ft,stopPropagation:yt,disableScrollPropagation:xt,disableClickPropagation:wt,preventDefault:Pt,stop:Lt,getMousePosition:bt,getWheelDelta:Tt,fakeStop:zt,skipped:Mt,isExternalTarget:Ct,addListener:mt,removeListener:ft}),Le=ci.extend({run:function(t,i,e,n){this.stop(),this._el=t,this._inProgress=!0,this._duration=e||.25,this._easeOutPower=1/Math.max(n||.5,.2),this._startPos=ht(t),this._offset=i.subtract(this._startPos),this._startTime=+new Date,this.fire("start"),this._animate()},stop:function(){this._inProgress&&(this._step(!0),this._complete())},_animate:function(){this._animId=f(this._animate,this),this._step()},_step:function(t){var i=+new Date-this._startTime,e=1e3*this._duration;i<e?this._runFrame(this._easeOut(i/e),t):(this._runFrame(1),this._complete())},_runFrame:function(t,i){var e=this._startPos.add(this._offset.multiplyBy(t));i&&e._round(),at(this._el,e),this.fire("step")},_complete:function(){g(this._animId),this._inProgress=!1,this.fire("end")},_easeOut:function(t){return 1-Math.pow(1-t,this._easeOutPower)}}),be=ci.extend({options:{crs:yi,center:void 0,zoom:void 0,minZoom:void 0,maxZoom:void 0,layers:[],maxBounds:void 0,renderer:void 0,zoomAnimation:!0,zoomAnimationThreshold:4,fadeAnimation:!0,markerZoomAnimation:!0,transform3DLimit:8388608,zoomSnap:1,zoomDelta:1,trackResize:!0},initialize:function(t,i){i=l(this,i),this._initContainer(t),this._initLayout(),this._onResize=e(this._onResize,this),this._initEvents(),i.maxBounds&&this.setMaxBounds(i.maxBounds),void 0!==i.zoom&&(this._zoom=this._limitZoom(i.zoom)),i.center&&void 0!==i.zoom&&this.setView(C(i.center),i.zoom,{reset:!0}),this._handlers=[],this._layers={},this._zoomBoundLayers={},this._sizeChanged=!0,this.callInitHooks(),this._zoomAnimated=_e&&ji&&!Gi&&this.options.zoomAnimation,this._zoomAnimated&&(this._createAnimProxy(),mt(this._proxy,de,this._catchTransitionEnd,this)),this._addLayers(this.options.layers)},setView:function(t,e,n){return e=void 0===e?this._zoom:this._limitZoom(e),t=this._limitCenter(C(t),e,this.options.maxBounds),n=n||{},this._stop(),this._loaded&&!n.reset&&!0!==n&&(void 0!==n.animate&&(n.zoom=i({animate:n.animate},n.zoom),n.pan=i({animate:n.animate,duration:n.duration},n.pan)),this._zoom!==e?this._tryAnimatedZoom&&this._tryAnimatedZoom(t,e,n.zoom):this._tryAnimatedPan(t,n.pan))?(clearTimeout(this._sizeTimer),this):(this._resetView(t,e),this)},setZoom:function(t,i){return this._loaded?this.setView(this.getCenter(),t,{zoom:i}):(this._zoom=t,this)},zoomIn:function(t,i){return t=t||(ji?this.options.zoomDelta:1),this.setZoom(this._zoom+t,i)},zoomOut:function(t,i){return t=t||(ji?this.options.zoomDelta:1),this.setZoom(this._zoom-t,i)},setZoomAround:function(t,i,e){var n=this.getZoomScale(i),o=this.getSize().divideBy(2),s=(t instanceof x?t:this.latLngToContainerPoint(t)).subtract(o).multiplyBy(1-1/n),r=this.containerPointToLatLng(o.add(s));return this.setView(r,i,{zoom:e})},_getBoundsCenterZoom:function(t,i){i=i||{},t=t.getBounds?t.getBounds():z(t);var e=w(i.paddingTopLeft||i.padding||[0,0]),n=w(i.paddingBottomRight||i.padding||[0,0]),o=this.getBoundsZoom(t,!1,e.add(n));if((o="number"==typeof i.maxZoom?Math.min(i.maxZoom,o):o)===1/0)return{center:t.getCenter(),zoom:o};var s=n.subtract(e).divideBy(2),r=this.project(t.getSouthWest(),o),a=this.project(t.getNorthEast(),o);return{center:this.unproject(r.add(a).divideBy(2).add(s),o),zoom:o}},fitBounds:function(t,i){if(!(t=z(t)).isValid())throw new Error("Bounds are not valid.");var e=this._getBoundsCenterZoom(t,i);return this.setView(e.center,e.zoom,i)},fitWorld:function(t){return this.fitBounds([[-90,-180],[90,180]],t)},panTo:function(t,i){return this.setView(t,this._zoom,{pan:i})},panBy:function(t,i){if(t=w(t).round(),i=i||{},!t.x&&!t.y)return this.fire("moveend");if(!0!==i.animate&&!this.getSize().contains(t))return this._resetView(this.unproject(this.project(this.getCenter()).add(t)),this.getZoom()),this;if(this._panAnim||(this._panAnim=new Le,this._panAnim.on({step:this._onPanTransitionStep,end:this._onPanTransitionEnd},this)),i.noMoveStart||this.fire("movestart"),!1!==i.animate){Q(this._mapPane,"leaflet-pan-anim");var e=this._getMapPanePos().subtract(t).round();this._panAnim.run(this._mapPane,e,i.duration||.25,i.easeLinearity)}else this._rawPanBy(t),this.fire("move").fire("moveend");return this},flyTo:function(t,i,e){function n(t){var i=(g*g-m*m+(t?-1:1)*x*x*v*v)/(2*(t?g:m)*x*v),e=Math.sqrt(i*i+1)-i;return e<1e-9?-18:Math.log(e)}function o(t){return(Math.exp(t)-Math.exp(-t))/2}function s(t){return(Math.exp(t)+Math.exp(-t))/2}function r(t){return o(t)/s(t)}function a(t){return m*(s(w)/s(w+y*t))}function h(t){return m*(s(w)*r(w+y*t)-o(w))/x}function u(t){return 1-Math.pow(1-t,1.5)}function l(){var e=(Date.now()-P)/b,n=u(e)*L;e<=1?(this._flyToFrame=f(l,this),this._move(this.unproject(c.add(_.subtract(c).multiplyBy(h(n)/v)),p),this.getScaleZoom(m/a(n),p),{flyTo:!0})):this._move(t,i)._moveEnd(!0)}if(!1===(e=e||{}).animate||!ji)return this.setView(t,i,e);this._stop();var c=this.project(this.getCenter()),_=this.project(t),d=this.getSize(),p=this._zoom;t=C(t),i=void 0===i?p:i;var m=Math.max(d.x,d.y),g=m*this.getZoomScale(p,i),v=_.distanceTo(c)||1,y=1.42,x=y*y,w=n(0),P=Date.now(),L=(n(1)-w)/y,b=e.duration?1e3*e.duration:1e3*L*.8;return this._moveStart(!0,e.noMoveStart),l.call(this),this},flyToBounds:function(t,i){var e=this._getBoundsCenterZoom(t,i);return this.flyTo(e.center,e.zoom,i)},setMaxBounds:function(t){return(t=z(t)).isValid()?(this.options.maxBounds&&this.off("moveend",this._panInsideMaxBounds),this.options.maxBounds=t,this._loaded&&this._panInsideMaxBounds(),this.on("moveend",this._panInsideMaxBounds)):(this.options.maxBounds=null,this.off("moveend",this._panInsideMaxBounds))},setMinZoom:function(t){var i=this.options.minZoom;return this.options.minZoom=t,this._loaded&&i!==t&&(this.fire("zoomlevelschange"),this.getZoom()<this.options.minZoom)?this.setZoom(t):this},setMaxZoom:function(t){var i=this.options.maxZoom;return this.options.maxZoom=t,this._loaded&&i!==t&&(this.fire("zoomlevelschange"),this.getZoom()>this.options.maxZoom)?this.setZoom(t):this},panInsideBounds:function(t,i){this._enforcingBounds=!0;var e=this.getCenter(),n=this._limitCenter(e,this._zoom,z(t));return e.equals(n)||this.panTo(n,i),this._enforcingBounds=!1,this},invalidateSize:function(t){if(!this._loaded)return this;t=i({animate:!1,pan:!0},!0===t?{animate:!0}:t);var n=this.getSize();this._sizeChanged=!0,this._lastCenter=null;var o=this.getSize(),s=n.divideBy(2).round(),r=o.divideBy(2).round(),a=s.subtract(r);return a.x||a.y?(t.animate&&t.pan?this.panBy(a):(t.pan&&this._rawPanBy(a),this.fire("move"),t.debounceMoveend?(clearTimeout(this._sizeTimer),this._sizeTimer=setTimeout(e(this.fire,this,"moveend"),200)):this.fire("moveend")),this.fire("resize",{oldSize:n,newSize:o})):this},stop:function(){return this.setZoom(this._limitZoom(this._zoom)),this.options.zoomSnap||this.fire("viewreset"),this._stop()},locate:function(t){if(t=this._locateOptions=i({timeout:1e4,watch:!1},t),!("geolocation"in navigator))return this._handleGeolocationError({code:0,message:"Geolocation not supported."}),this;var n=e(this._handleGeolocationResponse,this),o=e(this._handleGeolocationError,this);return t.watch?this._locationWatchId=navigator.geolocation.watchPosition(n,o,t):navigator.geolocation.getCurrentPosition(n,o,t),this},stopLocate:function(){return navigator.geolocation&&navigator.geolocation.clearWatch&&navigator.geolocation.clearWatch(this._locationWatchId),this._locateOptions&&(this._locateOptions.setView=!1),this},_handleGeolocationError:function(t){var i=t.code,e=t.message||(1===i?"permission denied":2===i?"position unavailable":"timeout");this._locateOptions.setView&&!this._loaded&&this.fitWorld(),this.fire("locationerror",{code:i,message:"Geolocation error: "+e+"."})},_handleGeolocationResponse:function(t){var i=new M(t.coords.latitude,t.coords.longitude),e=i.toBounds(2*t.coords.accuracy),n=this._locateOptions;if(n.setView){var o=this.getBoundsZoom(e);this.setView(i,n.maxZoom?Math.min(o,n.maxZoom):o)}var s={latlng:i,bounds:e,timestamp:t.timestamp};for(var r in t.coords)"number"==typeof t.coords[r]&&(s[r]=t.coords[r]);this.fire("locationfound",s)},addHandler:function(t,i){if(!i)return this;var e=this[t]=new i(this);return this._handlers.push(e),this.options[t]&&e.enable(),this},remove:function(){if(this._initEvents(!0),this._containerId!==this._container._leaflet_id)throw new Error("Map container is being reused by another instance");try{delete this._container._leaflet_id,delete this._containerId}catch(t){this._container._leaflet_id=void 0,this._containerId=void 0}void 0!==this._locationWatchId&&this.stopLocate(),this._stop(),K(this._mapPane),this._clearControlPos&&this._clearControlPos(),this._resizeRequest&&(g(this._resizeRequest),this._resizeRequest=null),this._clearHandlers(),this._loaded&&this.fire("unload");var t;for(t in this._layers)this._layers[t].remove();for(t in this._panes)K(this._panes[t]);return this._layers=[],this._panes=[],delete this._mapPane,delete this._renderer,this},createPane:function(t,i){var e=G("div","leaflet-pane"+(t?" leaflet-"+t.replace("Pane","")+"-pane":""),i||this._mapPane);return t&&(this._panes[t]=e),e},getCenter:function(){return this._checkIfLoaded(),this._lastCenter&&!this._moved()?this._lastCenter:this.layerPointToLatLng(this._getCenterLayerPoint())},getZoom:function(){return this._zoom},getBounds:function(){var t=this.getPixelBounds();return new T(this.unproject(t.getBottomLeft()),this.unproject(t.getTopRight()))},getMinZoom:function(){return void 0===this.options.minZoom?this._layersMinZoom||0:this.options.minZoom},getMaxZoom:function(){return void 0===this.options.maxZoom?void 0===this._layersMaxZoom?1/0:this._layersMaxZoom:this.options.maxZoom},getBoundsZoom:function(t,i,e){t=z(t),e=w(e||[0,0]);var n=this.getZoom()||0,o=this.getMinZoom(),s=this.getMaxZoom(),r=t.getNorthWest(),a=t.getSouthEast(),h=this.getSize().subtract(e),u=b(this.project(a,n),this.project(r,n)).getSize(),l=ji?this.options.zoomSnap:1,c=h.x/u.x,_=h.y/u.y,d=i?Math.max(c,_):Math.min(c,_);return n=this.getScaleZoom(d,n),l&&(n=Math.round(n/(l/100))*(l/100),n=i?Math.ceil(n/l)*l:Math.floor(n/l)*l),Math.max(o,Math.min(s,n))},getSize:function(){return this._size&&!this._sizeChanged||(this._size=new x(this._container.clientWidth||0,this._container.clientHeight||0),this._sizeChanged=!1),this._size.clone()},getPixelBounds:function(t,i){var e=this._getTopLeftPoint(t,i);return new P(e,e.add(this.getSize()))},getPixelOrigin:function(){return this._checkIfLoaded(),this._pixelOrigin},getPixelWorldBounds:function(t){return this.options.crs.getProjectedBounds(void 0===t?this.getZoom():t)},getPane:function(t){return"string"==typeof t?this._panes[t]:t},getPanes:function(){return this._panes},getContainer:function(){return this._container},getZoomScale:function(t,i){var e=this.options.crs;return i=void 0===i?this._zoom:i,e.scale(t)/e.scale(i)},getScaleZoom:function(t,i){var e=this.options.crs;i=void 0===i?this._zoom:i;var n=e.zoom(t*e.scale(i));return isNaN(n)?1/0:n},project:function(t,i){return i=void 0===i?this._zoom:i,this.options.crs.latLngToPoint(C(t),i)},unproject:function(t,i){return i=void 0===i?this._zoom:i,this.options.crs.pointToLatLng(w(t),i)},layerPointToLatLng:function(t){var i=w(t).add(this.getPixelOrigin());return this.unproject(i)},latLngToLayerPoint:function(t){return this.project(C(t))._round()._subtract(this.getPixelOrigin())},wrapLatLng:function(t){return this.options.crs.wrapLatLng(C(t))},wrapLatLngBounds:function(t){return this.options.crs.wrapLatLngBounds(z(t))},distance:function(t,i){return this.options.crs.distance(C(t),C(i))},containerPointToLayerPoint:function(t){return w(t).subtract(this._getMapPanePos())},layerPointToContainerPoint:function(t){return w(t).add(this._getMapPanePos())},containerPointToLatLng:function(t){var i=this.containerPointToLayerPoint(w(t));return this.layerPointToLatLng(i)},latLngToContainerPoint:function(t){return this.layerPointToContainerPoint(this.latLngToLayerPoint(C(t)))},mouseEventToContainerPoint:function(t){return bt(t,this._container)},mouseEventToLayerPoint:function(t){return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t))},mouseEventToLatLng:function(t){return this.layerPointToLatLng(this.mouseEventToLayerPoint(t))},_initContainer:function(t){var i=this._container=V(t);if(!i)throw new Error("Map container not found.");if(i._leaflet_id)throw new Error("Map container is already initialized.");mt(i,"scroll",this._onScroll,this),this._containerId=n(i)},_initLayout:function(){var t=this._container;this._fadeAnimated=this.options.fadeAnimation&&ji,Q(t,"leaflet-container"+(qi?" leaflet-touch":"")+(Yi?" leaflet-retina":"")+(Li?" leaflet-oldie":"")+(Ai?" leaflet-safari":"")+(this._fadeAnimated?" leaflet-fade-anim":""));var i=q(t,"position");"absolute"!==i&&"relative"!==i&&"fixed"!==i&&(t.style.position="relative"),this._initPanes(),this._initControlPos&&this._initControlPos()},_initPanes:function(){var t=this._panes={};this._paneRenderers={},this._mapPane=this.createPane("mapPane",this._container),at(this._mapPane,new x(0,0)),this.createPane("tilePane"),this.createPane("shadowPane"),this.createPane("overlayPane"),this.createPane("markerPane"),this.createPane("tooltipPane"),this.createPane("popupPane"),this.options.markerZoomAnimation||(Q(t.markerPane,"leaflet-zoom-hide"),Q(t.shadowPane,"leaflet-zoom-hide"))},_resetView:function(t,i){at(this._mapPane,new x(0,0));var e=!this._loaded;this._loaded=!0,i=this._limitZoom(i),this.fire("viewprereset");var n=this._zoom!==i;this._moveStart(n,!1)._move(t,i)._moveEnd(n),this.fire("viewreset"),e&&this.fire("load")},_moveStart:function(t,i){return t&&this.fire("zoomstart"),i||this.fire("movestart"),this},_move:function(t,i,e){void 0===i&&(i=this._zoom);var n=this._zoom!==i;return this._zoom=i,this._lastCenter=t,this._pixelOrigin=this._getNewPixelOrigin(t),(n||e&&e.pinch)&&this.fire("zoom",e),this.fire("move",e)},_moveEnd:function(t){return t&&this.fire("zoomend"),this.fire("moveend")},_stop:function(){return g(this._flyToFrame),this._panAnim&&this._panAnim.stop(),this},_rawPanBy:function(t){at(this._mapPane,this._getMapPanePos().subtract(t))},_getZoomSpan:function(){return this.getMaxZoom()-this.getMinZoom()},_panInsideMaxBounds:function(){this._enforcingBounds||this.panInsideBounds(this.options.maxBounds)},_checkIfLoaded:function(){if(!this._loaded)throw new Error("Set map center and zoom first.")},_initEvents:function(t){this._targets={},this._targets[n(this._container)]=this;var i=t?ft:mt;i(this._container,"click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress",this._handleDOMEvent,this),this.options.trackResize&&i(window,"resize",this._onResize,this),ji&&this.options.transform3DLimit&&(t?this.off:this.on).call(this,"moveend",this._onMoveEnd)},_onResize:function(){g(this._resizeRequest),this._resizeRequest=f(function(){this.invalidateSize({debounceMoveend:!0})},this)},_onScroll:function(){this._container.scrollTop=0,this._container.scrollLeft=0},_onMoveEnd:function(){var t=this._getMapPanePos();Math.max(Math.abs(t.x),Math.abs(t.y))>=this.options.transform3DLimit&&this._resetView(this.getCenter(),this.getZoom())},_findEventTargets:function(t,i){for(var e,o=[],s="mouseout"===i||"mouseover"===i,r=t.target||t.srcElement,a=!1;r;){if((e=this._targets[n(r)])&&("click"===i||"preclick"===i)&&!t._simulated&&this._draggableMoved(e)){a=!0;break}if(e&&e.listens(i,!0)){if(s&&!Ct(r,t))break;if(o.push(e),s)break}if(r===this._container)break;r=r.parentNode}return o.length||a||s||!Ct(r,t)||(o=[this]),o},_handleDOMEvent:function(t){if(this._loaded&&!Mt(t)){var i=t.type;"mousedown"!==i&&"keypress"!==i||ct(t.target||t.srcElement),this._fireDOMEvent(t,i)}},_mouseEvents:["click","dblclick","mouseover","mouseout","contextmenu"],_fireDOMEvent:function(t,e,n){if("click"===t.type){var o=i({},t);o.type="preclick",this._fireDOMEvent(o,o.type,n)}if(!t._stopped&&(n=(n||[]).concat(this._findEventTargets(t,e))).length){var s=n[0];"contextmenu"===e&&s.listens(e,!0)&&Pt(t);var r={originalEvent:t};if("keypress"!==t.type){var a=s.getLatLng&&(!s._radius||s._radius<=10);r.containerPoint=a?this.latLngToContainerPoint(s.getLatLng()):this.mouseEventToContainerPoint(t),r.layerPoint=this.containerPointToLayerPoint(r.containerPoint),r.latlng=a?s.getLatLng():this.layerPointToLatLng(r.layerPoint)}for(var h=0;h<n.length;h++)if(n[h].fire(e,r,!0),r.originalEvent._stopped||!1===n[h].options.bubblingMouseEvents&&-1!==d(this._mouseEvents,e))return}},_draggableMoved:function(t){return(t=t.dragging&&t.dragging.enabled()?t:this).dragging&&t.dragging.moved()||this.boxZoom&&this.boxZoom.moved()},_clearHandlers:function(){for(var t=0,i=this._handlers.length;t<i;t++)this._handlers[t].disable()},whenReady:function(t,i){return this._loaded?t.call(i||this,{target:this}):this.on("load",t,i),this},_getMapPanePos:function(){return ht(this._mapPane)||new x(0,0)},_moved:function(){var t=this._getMapPanePos();return t&&!t.equals([0,0])},_getTopLeftPoint:function(t,i){return(t&&void 0!==i?this._getNewPixelOrigin(t,i):this.getPixelOrigin()).subtract(this._getMapPanePos())},_getNewPixelOrigin:function(t,i){var e=this.getSize()._divideBy(2);return this.project(t,i)._subtract(e)._add(this._getMapPanePos())._round()},_latLngToNewLayerPoint:function(t,i,e){var n=this._getNewPixelOrigin(e,i);return this.project(t,i)._subtract(n)},_latLngBoundsToNewLayerBounds:function(t,i,e){var n=this._getNewPixelOrigin(e,i);return b([this.project(t.getSouthWest(),i)._subtract(n),this.project(t.getNorthWest(),i)._subtract(n),this.project(t.getSouthEast(),i)._subtract(n),this.project(t.getNorthEast(),i)._subtract(n)])},_getCenterLayerPoint:function(){return this.containerPointToLayerPoint(this.getSize()._divideBy(2))},_getCenterOffset:function(t){return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint())},_limitCenter:function(t,i,e){if(!e)return t;var n=this.project(t,i),o=this.getSize().divideBy(2),s=new P(n.subtract(o),n.add(o)),r=this._getBoundsOffset(s,e,i);return r.round().equals([0,0])?t:this.unproject(n.add(r),i)},_limitOffset:function(t,i){if(!i)return t;var e=this.getPixelBounds(),n=new P(e.min.add(t),e.max.add(t));return t.add(this._getBoundsOffset(n,i))},_getBoundsOffset:function(t,i,e){var n=b(this.project(i.getNorthEast(),e),this.project(i.getSouthWest(),e)),o=n.min.subtract(t.min),s=n.max.subtract(t.max);return new x(this._rebound(o.x,-s.x),this._rebound(o.y,-s.y))},_rebound:function(t,i){return t+i>0?Math.round(t-i)/2:Math.max(0,Math.ceil(t))-Math.max(0,Math.floor(i))},_limitZoom:function(t){var i=this.getMinZoom(),e=this.getMaxZoom(),n=ji?this.options.zoomSnap:1;return n&&(t=Math.round(t/n)*n),Math.max(i,Math.min(e,t))},_onPanTransitionStep:function(){this.fire("move")},_onPanTransitionEnd:function(){tt(this._mapPane,"leaflet-pan-anim"),this.fire("moveend")},_tryAnimatedPan:function(t,i){var e=this._getCenterOffset(t)._trunc();return!(!0!==(i&&i.animate)&&!this.getSize().contains(e))&&(this.panBy(e,i),!0)},_createAnimProxy:function(){var t=this._proxy=G("div","leaflet-proxy leaflet-zoom-animated");this._panes.mapPane.appendChild(t),this.on("zoomanim",function(t){var i=ce,e=this._proxy.style[i];rt(this._proxy,this.project(t.center,t.zoom),this.getZoomScale(t.zoom,1)),e===this._proxy.style[i]&&this._animatingZoom&&this._onZoomTransitionEnd()},this),this.on("load moveend",function(){var t=this.getCenter(),i=this.getZoom();rt(this._proxy,this.project(t,i),this.getZoomScale(i,1))},this),this._on("unload",this._destroyAnimProxy,this)},_destroyAnimProxy:function(){K(this._proxy),delete this._proxy},_catchTransitionEnd:function(t){this._animatingZoom&&t.propertyName.indexOf("transform")>=0&&this._onZoomTransitionEnd()},_nothingToAnimate:function(){return!this._container.getElementsByClassName("leaflet-zoom-animated").length},_tryAnimatedZoom:function(t,i,e){if(this._animatingZoom)return!0;if(e=e||{},!this._zoomAnimated||!1===e.animate||this._nothingToAnimate()||Math.abs(i-this._zoom)>this.options.zoomAnimationThreshold)return!1;var n=this.getZoomScale(i),o=this._getCenterOffset(t)._divideBy(1-1/n);return!(!0!==e.animate&&!this.getSize().contains(o))&&(f(function(){this._moveStart(!0,!1)._animateZoom(t,i,!0)},this),!0)},_animateZoom:function(t,i,n,o){this._mapPane&&(n&&(this._animatingZoom=!0,this._animateToCenter=t,this._animateToZoom=i,Q(this._mapPane,"leaflet-zoom-anim")),this.fire("zoomanim",{center:t,zoom:i,noUpdate:o}),setTimeout(e(this._onZoomTransitionEnd,this),250))},_onZoomTransitionEnd:function(){this._animatingZoom&&(this._mapPane&&tt(this._mapPane,"leaflet-zoom-anim"),this._animatingZoom=!1,this._move(this._animateToCenter,this._animateToZoom),f(function(){this._moveEnd(!0)},this))}}),Te=v.extend({options:{position:"topright"},initialize:function(t){l(this,t)},getPosition:function(){return this.options.position},setPosition:function(t){var i=this._map;return i&&i.removeControl(this),this.options.position=t,i&&i.addControl(this),this},getContainer:function(){return this._container},addTo:function(t){this.remove(),this._map=t;var i=this._container=this.onAdd(t),e=this.getPosition(),n=t._controlCorners[e];return Q(i,"leaflet-control"),-1!==e.indexOf("bottom")?n.insertBefore(i,n.firstChild):n.appendChild(i),this},remove:function(){return this._map?(K(this._container),this.onRemove&&this.onRemove(this._map),this._map=null,this):this},_refocusOnMap:function(t){this._map&&t&&t.screenX>0&&t.screenY>0&&this._map.getContainer().focus()}}),ze=function(t){return new Te(t)};be.include({addControl:function(t){return t.addTo(this),this},removeControl:function(t){return t.remove(),this},_initControlPos:function(){function t(t,o){var s=e+t+" "+e+o;i[t+o]=G("div",s,n)}var i=this._controlCorners={},e="leaflet-",n=this._controlContainer=G("div",e+"control-container",this._container);t("top","left"),t("top","right"),t("bottom","left"),t("bottom","right")},_clearControlPos:function(){for(var t in this._controlCorners)K(this._controlCorners[t]);K(this._controlContainer),delete this._controlCorners,delete this._controlContainer}});var Me=Te.extend({options:{collapsed:!0,position:"topright",autoZIndex:!0,hideSingleBase:!1,sortLayers:!1,sortFunction:function(t,i,e,n){return e<n?-1:n<e?1:0}},initialize:function(t,i,e){l(this,e),this._layerControlInputs=[],this._layers=[],this._lastZIndex=0,this._handlingClick=!1;for(var n in t)this._addLayer(t[n],n);for(n in i)this._addLayer(i[n],n,!0)},onAdd:function(t){this._initLayout(),this._update(),this._map=t,t.on("zoomend",this._checkDisabledLayers,this);for(var i=0;i<this._layers.length;i++)this._layers[i].layer.on("add remove",this._onLayerChange,this);return this._container},addTo:function(t){return Te.prototype.addTo.call(this,t),this._expandIfNotCollapsed()},onRemove:function(){this._map.off("zoomend",this._checkDisabledLayers,this);for(var t=0;t<this._layers.length;t++)this._layers[t].layer.off("add remove",this._onLayerChange,this)},addBaseLayer:function(t,i){return this._addLayer(t,i),this._map?this._update():this},addOverlay:function(t,i){return this._addLayer(t,i,!0),this._map?this._update():this},removeLayer:function(t){t.off("add remove",this._onLayerChange,this);var i=this._getLayer(n(t));return i&&this._layers.splice(this._layers.indexOf(i),1),this._map?this._update():this},expand:function(){Q(this._container,"leaflet-control-layers-expanded"),this._form.style.height=null;var t=this._map.getSize().y-(this._container.offsetTop+50);return t<this._form.clientHeight?(Q(this._form,"leaflet-control-layers-scrollbar"),this._form.style.height=t+"px"):tt(this._form,"leaflet-control-layers-scrollbar"),this._checkDisabledLayers(),this},collapse:function(){return tt(this._container,"leaflet-control-layers-expanded"),this},_initLayout:function(){var t="leaflet-control-layers",i=this._container=G("div",t),e=this.options.collapsed;i.setAttribute("aria-haspopup",!0),wt(i),xt(i);var n=this._form=G("form",t+"-list");e&&(this._map.on("click",this.collapse,this),zi||mt(i,{mouseenter:this.expand,mouseleave:this.collapse},this));var o=this._layersLink=G("a",t+"-toggle",i);o.href="#",o.title="Layers",qi?(mt(o,"click",Lt),mt(o,"click",this.expand,this)):mt(o,"focus",this.expand,this),e||this.expand(),this._baseLayersList=G("div",t+"-base",n),this._separator=G("div",t+"-separator",n),this._overlaysList=G("div",t+"-overlays",n),i.appendChild(n)},_getLayer:function(t){for(var i=0;i<this._layers.length;i++)if(this._layers[i]&&n(this._layers[i].layer)===t)return this._layers[i]},_addLayer:function(t,i,n){this._map&&t.on("add remove",this._onLayerChange,this),this._layers.push({layer:t,name:i,overlay:n}),this.options.sortLayers&&this._layers.sort(e(function(t,i){return this.options.sortFunction(t.layer,i.layer,t.name,i.name)},this)),this.options.autoZIndex&&t.setZIndex&&(this._lastZIndex++,t.setZIndex(this._lastZIndex)),this._expandIfNotCollapsed()},_update:function(){if(!this._container)return this;Y(this._baseLayersList),Y(this._overlaysList),this._layerControlInputs=[];var t,i,e,n,o=0;for(e=0;e<this._layers.length;e++)n=this._layers[e],this._addItem(n),i=i||n.overlay,t=t||!n.overlay,o+=n.overlay?0:1;return this.options.hideSingleBase&&(t=t&&o>1,this._baseLayersList.style.display=t?"":"none"),this._separator.style.display=i&&t?"":"none",this},_onLayerChange:function(t){this._handlingClick||this._update();var i=this._getLayer(n(t.target)),e=i.overlay?"add"===t.type?"overlayadd":"overlayremove":"add"===t.type?"baselayerchange":null;e&&this._map.fire(e,i)},_createRadioElement:function(t,i){var e='<input type="radio" class="leaflet-control-layers-selector" name="'+t+'"'+(i?' checked="checked"':"")+"/>",n=document.createElement("div");return n.innerHTML=e,n.firstChild},_addItem:function(t){var i,e=document.createElement("label"),o=this._map.hasLayer(t.layer);t.overlay?((i=document.createElement("input")).type="checkbox",i.className="leaflet-control-layers-selector",i.defaultChecked=o):i=this._createRadioElement("leaflet-base-layers",o),this._layerControlInputs.push(i),i.layerId=n(t.layer),mt(i,"click",this._onInputClick,this);var s=document.createElement("span");s.innerHTML=" "+t.name;var r=document.createElement("div");return e.appendChild(r),r.appendChild(i),r.appendChild(s),(t.overlay?this._overlaysList:this._baseLayersList).appendChild(e),this._checkDisabledLayers(),e},_onInputClick:function(){var t,i,e=this._layerControlInputs,n=[],o=[];this._handlingClick=!0;for(var s=e.length-1;s>=0;s--)t=e[s],i=this._getLayer(t.layerId).layer,t.checked?n.push(i):t.checked||o.push(i);for(s=0;s<o.length;s++)this._map.hasLayer(o[s])&&this._map.removeLayer(o[s]);for(s=0;s<n.length;s++)this._map.hasLayer(n[s])||this._map.addLayer(n[s]);this._handlingClick=!1,this._refocusOnMap()},_checkDisabledLayers:function(){for(var t,i,e=this._layerControlInputs,n=this._map.getZoom(),o=e.length-1;o>=0;o--)t=e[o],i=this._getLayer(t.layerId).layer,t.disabled=void 0!==i.options.minZoom&&n<i.options.minZoom||void 0!==i.options.maxZoom&&n>i.options.maxZoom},_expandIfNotCollapsed:function(){return this._map&&!this.options.collapsed&&this.expand(),this},_expand:function(){return this.expand()},_collapse:function(){return this.collapse()}}),Ce=Te.extend({options:{position:"topleft",zoomInText:"+",zoomInTitle:"Zoom in",zoomOutText:"&#x2212;",zoomOutTitle:"Zoom out"},onAdd:function(t){var i="leaflet-control-zoom",e=G("div",i+" leaflet-bar"),n=this.options;return this._zoomInButton=this._createButton(n.zoomInText,n.zoomInTitle,i+"-in",e,this._zoomIn),this._zoomOutButton=this._createButton(n.zoomOutText,n.zoomOutTitle,i+"-out",e,this._zoomOut),this._updateDisabled(),t.on("zoomend zoomlevelschange",this._updateDisabled,this),e},onRemove:function(t){t.off("zoomend zoomlevelschange",this._updateDisabled,this)},disable:function(){return this._disabled=!0,this._updateDisabled(),this},enable:function(){return this._disabled=!1,this._updateDisabled(),this},_zoomIn:function(t){!this._disabled&&this._map._zoom<this._map.getMaxZoom()&&this._map.zoomIn(this._map.options.zoomDelta*(t.shiftKey?3:1))},_zoomOut:function(t){!this._disabled&&this._map._zoom>this._map.getMinZoom()&&this._map.zoomOut(this._map.options.zoomDelta*(t.shiftKey?3:1))},_createButton:function(t,i,e,n,o){var s=G("a",e,n);return s.innerHTML=t,s.href="#",s.title=i,s.setAttribute("role","button"),s.setAttribute("aria-label",i),wt(s),mt(s,"click",Lt),mt(s,"click",o,this),mt(s,"click",this._refocusOnMap,this),s},_updateDisabled:function(){var t=this._map,i="leaflet-disabled";tt(this._zoomInButton,i),tt(this._zoomOutButton,i),(this._disabled||t._zoom===t.getMinZoom())&&Q(this._zoomOutButton,i),(this._disabled||t._zoom===t.getMaxZoom())&&Q(this._zoomInButton,i)}});be.mergeOptions({zoomControl:!0}),be.addInitHook(function(){this.options.zoomControl&&(this.zoomControl=new Ce,this.addControl(this.zoomControl))});var Se=Te.extend({options:{position:"bottomleft",maxWidth:100,metric:!0,imperial:!0},onAdd:function(t){var i=G("div","leaflet-control-scale"),e=this.options;return this._addScales(e,"leaflet-control-scale-line",i),t.on(e.updateWhenIdle?"moveend":"move",this._update,this),t.whenReady(this._update,this),i},onRemove:function(t){t.off(this.options.updateWhenIdle?"moveend":"move",this._update,this)},_addScales:function(t,i,e){t.metric&&(this._mScale=G("div",i,e)),t.imperial&&(this._iScale=G("div",i,e))},_update:function(){var t=this._map,i=t.getSize().y/2,e=t.distance(t.containerPointToLatLng([0,i]),t.containerPointToLatLng([this.options.maxWidth,i]));this._updateScales(e)},_updateScales:function(t){this.options.metric&&t&&this._updateMetric(t),this.options.imperial&&t&&this._updateImperial(t)},_updateMetric:function(t){var i=this._getRoundNum(t),e=i<1e3?i+" m":i/1e3+" km";this._updateScale(this._mScale,e,i/t)},_updateImperial:function(t){var i,e,n,o=3.2808399*t;o>5280?(i=o/5280,e=this._getRoundNum(i),this._updateScale(this._iScale,e+" mi",e/i)):(n=this._getRoundNum(o),this._updateScale(this._iScale,n+" ft",n/o))},_updateScale:function(t,i,e){t.style.width=Math.round(this.options.maxWidth*e)+"px",t.innerHTML=i},_getRoundNum:function(t){var i=Math.pow(10,(Math.floor(t)+"").length-1),e=t/i;return e=e>=10?10:e>=5?5:e>=3?3:e>=2?2:1,i*e}}),Ze=Te.extend({options:{position:"bottomright",prefix:'<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'},initialize:function(t){l(this,t),this._attributions={}},onAdd:function(t){t.attributionControl=this,this._container=G("div","leaflet-control-attribution"),wt(this._container);for(var i in t._layers)t._layers[i].getAttribution&&this.addAttribution(t._layers[i].getAttribution());return this._update(),this._container},setPrefix:function(t){return this.options.prefix=t,this._update(),this},addAttribution:function(t){return t?(this._attributions[t]||(this._attributions[t]=0),this._attributions[t]++,this._update(),this):this},removeAttribution:function(t){return t?(this._attributions[t]&&(this._attributions[t]--,this._update()),this):this},_update:function(){if(this._map){var t=[];for(var i in this._attributions)this._attributions[i]&&t.push(i);var e=[];this.options.prefix&&e.push(this.options.prefix),t.length&&e.push(t.join(", ")),this._container.innerHTML=e.join(" | ")}}});be.mergeOptions({attributionControl:!0}),be.addInitHook(function(){this.options.attributionControl&&(new Ze).addTo(this)});Te.Layers=Me,Te.Zoom=Ce,Te.Scale=Se,Te.Attribution=Ze,ze.layers=function(t,i,e){return new Me(t,i,e)},ze.zoom=function(t){return new Ce(t)},ze.scale=function(t){return new Se(t)},ze.attribution=function(t){return new Ze(t)};var Ee=v.extend({initialize:function(t){this._map=t},enable:function(){return this._enabled?this:(this._enabled=!0,this.addHooks(),this)},disable:function(){return this._enabled?(this._enabled=!1,this.removeHooks(),this):this},enabled:function(){return!!this._enabled}});Ee.addTo=function(t,i){return t.addHandler(i,this),this};var ke,Ae={Events:li},Be=qi?"touchstart mousedown":"mousedown",Ie={mousedown:"mouseup",touchstart:"touchend",pointerdown:"touchend",MSPointerDown:"touchend"},Oe={mousedown:"mousemove",touchstart:"touchmove",pointerdown:"touchmove",MSPointerDown:"touchmove"},Re=ci.extend({options:{clickTolerance:3},initialize:function(t,i,e,n){l(this,n),this._element=t,this._dragStartTarget=i||t,this._preventOutline=e},enable:function(){this._enabled||(mt(this._dragStartTarget,Be,this._onDown,this),this._enabled=!0)},disable:function(){this._enabled&&(Re._dragging===this&&this.finishDrag(),ft(this._dragStartTarget,Be,this._onDown,this),this._enabled=!1,this._moved=!1)},_onDown:function(t){if(!t._simulated&&this._enabled&&(this._moved=!1,!$(this._element,"leaflet-zoom-anim")&&!(Re._dragging||t.shiftKey||1!==t.which&&1!==t.button&&!t.touches||(Re._dragging=this,this._preventOutline&&ct(this._element),ut(),fi(),this._moving)))){this.fire("down");var i=t.touches?t.touches[0]:t,e=dt(this._element);this._startPoint=new x(i.clientX,i.clientY),this._parentScale=pt(e),mt(document,Oe[t.type],this._onMove,this),mt(document,Ie[t.type],this._onUp,this)}},_onMove:function(t){if(!t._simulated&&this._enabled)if(t.touches&&t.touches.length>1)this._moved=!0;else{var i=t.touches&&1===t.touches.length?t.touches[0]:t,e=new x(i.clientX,i.clientY)._subtract(this._startPoint);(e.x||e.y)&&(Math.abs(e.x)+Math.abs(e.y)<this.options.clickTolerance||(e.x/=this._parentScale.x,e.y/=this._parentScale.y,Pt(t),this._moved||(this.fire("dragstart"),this._moved=!0,this._startPos=ht(this._element).subtract(e),Q(document.body,"leaflet-dragging"),this._lastTarget=t.target||t.srcElement,window.SVGElementInstance&&this._lastTarget instanceof SVGElementInstance&&(this._lastTarget=this._lastTarget.correspondingUseElement),Q(this._lastTarget,"leaflet-drag-target")),this._newPos=this._startPos.add(e),this._moving=!0,g(this._animRequest),this._lastEvent=t,this._animRequest=f(this._updatePosition,this,!0)))}},_updatePosition:function(){var t={originalEvent:this._lastEvent};this.fire("predrag",t),at(this._element,this._newPos),this.fire("drag",t)},_onUp:function(t){!t._simulated&&this._enabled&&this.finishDrag()},finishDrag:function(){tt(document.body,"leaflet-dragging"),this._lastTarget&&(tt(this._lastTarget,"leaflet-drag-target"),this._lastTarget=null);for(var t in Oe)ft(document,Oe[t],this._onMove,this),ft(document,Ie[t],this._onUp,this);lt(),gi(),this._moved&&this._moving&&(g(this._animRequest),this.fire("dragend",{distance:this._newPos.distanceTo(this._startPos)})),this._moving=!1,Re._dragging=!1}}),Ne=(Object.freeze||Object)({simplify:Zt,pointToSegmentDistance:Et,closestPointOnSegment:function(t,i,e){return Dt(t,i,e)},clipSegment:It,_getEdgeIntersection:Ot,_getBitCode:Rt,_sqClosestPointOnSegment:Dt,isFlat:jt,_flat:Wt}),De=(Object.freeze||Object)({clipPolygon:Ht}),je={project:function(t){return new x(t.lng,t.lat)},unproject:function(t){return new M(t.y,t.x)},bounds:new P([-180,-90],[180,90])},We={R:6378137,R_MINOR:6356752.314245179,bounds:new P([-20037508.34279,-15496570.73972],[20037508.34279,18764656.23138]),project:function(t){var i=Math.PI/180,e=this.R,n=t.lat*i,o=this.R_MINOR/e,s=Math.sqrt(1-o*o),r=s*Math.sin(n),a=Math.tan(Math.PI/4-n/2)/Math.pow((1-r)/(1+r),s/2);return n=-e*Math.log(Math.max(a,1e-10)),new x(t.lng*i*e,n)},unproject:function(t){for(var i,e=180/Math.PI,n=this.R,o=this.R_MINOR/n,s=Math.sqrt(1-o*o),r=Math.exp(-t.y/n),a=Math.PI/2-2*Math.atan(r),h=0,u=.1;h<15&&Math.abs(u)>1e-7;h++)i=s*Math.sin(a),i=Math.pow((1-i)/(1+i),s/2),a+=u=Math.PI/2-2*Math.atan(r*i)-a;return new M(a*e,t.x*e/n)}},He=(Object.freeze||Object)({LonLat:je,Mercator:We,SphericalMercator:mi}),Fe=i({},pi,{code:"EPSG:3395",projection:We,transformation:function(){var t=.5/(Math.PI*We.R);return Z(t,.5,-t,.5)}()}),Ue=i({},pi,{code:"EPSG:4326",projection:je,transformation:Z(1/180,1,-1/180,.5)}),Ve=i({},di,{projection:je,transformation:Z(1,0,-1,0),scale:function(t){return Math.pow(2,t)},zoom:function(t){return Math.log(t)/Math.LN2},distance:function(t,i){var e=i.lng-t.lng,n=i.lat-t.lat;return Math.sqrt(e*e+n*n)},infinite:!0});di.Earth=pi,di.EPSG3395=Fe,di.EPSG3857=yi,di.EPSG900913=xi,di.EPSG4326=Ue,di.Simple=Ve;var qe=ci.extend({options:{pane:"overlayPane",attribution:null,bubblingMouseEvents:!0},addTo:function(t){return t.addLayer(this),this},remove:function(){return this.removeFrom(this._map||this._mapToAdd)},removeFrom:function(t){return t&&t.removeLayer(this),this},getPane:function(t){return this._map.getPane(t?this.options[t]||t:this.options.pane)},addInteractiveTarget:function(t){return this._map._targets[n(t)]=this,this},removeInteractiveTarget:function(t){return delete this._map._targets[n(t)],this},getAttribution:function(){return this.options.attribution},_layerAdd:function(t){var i=t.target;if(i.hasLayer(this)){if(this._map=i,this._zoomAnimated=i._zoomAnimated,this.getEvents){var e=this.getEvents();i.on(e,this),this.once("remove",function(){i.off(e,this)},this)}this.onAdd(i),this.getAttribution&&i.attributionControl&&i.attributionControl.addAttribution(this.getAttribution()),this.fire("add"),i.fire("layeradd",{layer:this})}}});be.include({addLayer:function(t){if(!t._layerAdd)throw new Error("The provided object is not a Layer.");var i=n(t);return this._layers[i]?this:(this._layers[i]=t,t._mapToAdd=this,t.beforeAdd&&t.beforeAdd(this),this.whenReady(t._layerAdd,t),this)},removeLayer:function(t){var i=n(t);return this._layers[i]?(this._loaded&&t.onRemove(this),t.getAttribution&&this.attributionControl&&this.attributionControl.removeAttribution(t.getAttribution()),delete this._layers[i],this._loaded&&(this.fire("layerremove",{layer:t}),t.fire("remove")),t._map=t._mapToAdd=null,this):this},hasLayer:function(t){return!!t&&n(t)in this._layers},eachLayer:function(t,i){for(var e in this._layers)t.call(i,this._layers[e]);return this},_addLayers:function(t){for(var i=0,e=(t=t?oi(t)?t:[t]:[]).length;i<e;i++)this.addLayer(t[i])},_addZoomLimit:function(t){!isNaN(t.options.maxZoom)&&isNaN(t.options.minZoom)||(this._zoomBoundLayers[n(t)]=t,this._updateZoomLevels())},_removeZoomLimit:function(t){var i=n(t);this._zoomBoundLayers[i]&&(delete this._zoomBoundLayers[i],this._updateZoomLevels())},_updateZoomLevels:function(){var t=1/0,i=-1/0,e=this._getZoomSpan();for(var n in this._zoomBoundLayers){var o=this._zoomBoundLayers[n].options;t=void 0===o.minZoom?t:Math.min(t,o.minZoom),i=void 0===o.maxZoom?i:Math.max(i,o.maxZoom)}this._layersMaxZoom=i===-1/0?void 0:i,this._layersMinZoom=t===1/0?void 0:t,e!==this._getZoomSpan()&&this.fire("zoomlevelschange"),void 0===this.options.maxZoom&&this._layersMaxZoom&&this.getZoom()>this._layersMaxZoom&&this.setZoom(this._layersMaxZoom),void 0===this.options.minZoom&&this._layersMinZoom&&this.getZoom()<this._layersMinZoom&&this.setZoom(this._layersMinZoom)}});var Ge=qe.extend({initialize:function(t,i){l(this,i),this._layers={};var e,n;if(t)for(e=0,n=t.length;e<n;e++)this.addLayer(t[e])},addLayer:function(t){var i=this.getLayerId(t);return this._layers[i]=t,this._map&&this._map.addLayer(t),this},removeLayer:function(t){var i=t in this._layers?t:this.getLayerId(t);return this._map&&this._layers[i]&&this._map.removeLayer(this._layers[i]),delete this._layers[i],this},hasLayer:function(t){return!!t&&(t in this._layers||this.getLayerId(t)in this._layers)},clearLayers:function(){return this.eachLayer(this.removeLayer,this)},invoke:function(t){var i,e,n=Array.prototype.slice.call(arguments,1);for(i in this._layers)(e=this._layers[i])[t]&&e[t].apply(e,n);return this},onAdd:function(t){this.eachLayer(t.addLayer,t)},onRemove:function(t){this.eachLayer(t.removeLayer,t)},eachLayer:function(t,i){for(var e in this._layers)t.call(i,this._layers[e]);return this},getLayer:function(t){return this._layers[t]},getLayers:function(){var t=[];return this.eachLayer(t.push,t),t},setZIndex:function(t){return this.invoke("setZIndex",t)},getLayerId:function(t){return n(t)}}),Ke=Ge.extend({addLayer:function(t){return this.hasLayer(t)?this:(t.addEventParent(this),Ge.prototype.addLayer.call(this,t),this.fire("layeradd",{layer:t}))},removeLayer:function(t){return this.hasLayer(t)?(t in this._layers&&(t=this._layers[t]),t.removeEventParent(this),Ge.prototype.removeLayer.call(this,t),this.fire("layerremove",{layer:t})):this},setStyle:function(t){return this.invoke("setStyle",t)},bringToFront:function(){return this.invoke("bringToFront")},bringToBack:function(){return this.invoke("bringToBack")},getBounds:function(){var t=new T;for(var i in this._layers){var e=this._layers[i];t.extend(e.getBounds?e.getBounds():e.getLatLng())}return t}}),Ye=v.extend({options:{popupAnchor:[0,0],tooltipAnchor:[0,0]},initialize:function(t){l(this,t)},createIcon:function(t){return this._createIcon("icon",t)},createShadow:function(t){return this._createIcon("shadow",t)},_createIcon:function(t,i){var e=this._getIconUrl(t);if(!e){if("icon"===t)throw new Error("iconUrl not set in Icon options (see the docs).");return null}var n=this._createImg(e,i&&"IMG"===i.tagName?i:null);return this._setIconStyles(n,t),n},_setIconStyles:function(t,i){var e=this.options,n=e[i+"Size"];"number"==typeof n&&(n=[n,n]);var o=w(n),s=w("shadow"===i&&e.shadowAnchor||e.iconAnchor||o&&o.divideBy(2,!0));t.className="leaflet-marker-"+i+" "+(e.className||""),s&&(t.style.marginLeft=-s.x+"px",t.style.marginTop=-s.y+"px"),o&&(t.style.width=o.x+"px",t.style.height=o.y+"px")},_createImg:function(t,i){return i=i||document.createElement("img"),i.src=t,i},_getIconUrl:function(t){return Yi&&this.options[t+"RetinaUrl"]||this.options[t+"Url"]}}),Xe=Ye.extend({options:{iconUrl:"marker-icon.png",iconRetinaUrl:"marker-icon-2x.png",shadowUrl:"marker-shadow.png",iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],tooltipAnchor:[16,-28],shadowSize:[41,41]},_getIconUrl:function(t){return Xe.imagePath||(Xe.imagePath=this._detectIconPath()),(this.options.imagePath||Xe.imagePath)+Ye.prototype._getIconUrl.call(this,t)},_detectIconPath:function(){var t=G("div","leaflet-default-icon-path",document.body),i=q(t,"background-image")||q(t,"backgroundImage");return document.body.removeChild(t),i=null===i||0!==i.indexOf("url")?"":i.replace(/^url\(["']?/,"").replace(/marker-icon\.png["']?\)$/,"")}}),Je=Ee.extend({initialize:function(t){this._marker=t},addHooks:function(){var t=this._marker._icon;this._draggable||(this._draggable=new Re(t,t,!0)),this._draggable.on({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).enable(),Q(t,"leaflet-marker-draggable")},removeHooks:function(){this._draggable.off({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).disable(),this._marker._icon&&tt(this._marker._icon,"leaflet-marker-draggable")},moved:function(){return this._draggable&&this._draggable._moved},_adjustPan:function(t){var i=this._marker,e=i._map,n=this._marker.options.autoPanSpeed,o=this._marker.options.autoPanPadding,s=ht(i._icon),r=e.getPixelBounds(),a=e.getPixelOrigin(),h=b(r.min._subtract(a).add(o),r.max._subtract(a).subtract(o));if(!h.contains(s)){var u=w((Math.max(h.max.x,s.x)-h.max.x)/(r.max.x-h.max.x)-(Math.min(h.min.x,s.x)-h.min.x)/(r.min.x-h.min.x),(Math.max(h.max.y,s.y)-h.max.y)/(r.max.y-h.max.y)-(Math.min(h.min.y,s.y)-h.min.y)/(r.min.y-h.min.y)).multiplyBy(n);e.panBy(u,{animate:!1}),this._draggable._newPos._add(u),this._draggable._startPos._add(u),at(i._icon,this._draggable._newPos),this._onDrag(t),this._panRequest=f(this._adjustPan.bind(this,t))}},_onDragStart:function(){this._oldLatLng=this._marker.getLatLng(),this._marker.closePopup().fire("movestart").fire("dragstart")},_onPreDrag:function(t){this._marker.options.autoPan&&(g(this._panRequest),this._panRequest=f(this._adjustPan.bind(this,t)))},_onDrag:function(t){var i=this._marker,e=i._shadow,n=ht(i._icon),o=i._map.layerPointToLatLng(n);e&&at(e,n),i._latlng=o,t.latlng=o,t.oldLatLng=this._oldLatLng,i.fire("move",t).fire("drag",t)},_onDragEnd:function(t){g(this._panRequest),delete this._oldLatLng,this._marker.fire("moveend").fire("dragend",t)}}),$e=qe.extend({options:{icon:new Xe,interactive:!0,draggable:!1,autoPan:!1,autoPanPadding:[50,50],autoPanSpeed:10,keyboard:!0,title:"",alt:"",zIndexOffset:0,opacity:1,riseOnHover:!1,riseOffset:250,pane:"markerPane",bubblingMouseEvents:!1},initialize:function(t,i){l(this,i),this._latlng=C(t)},onAdd:function(t){this._zoomAnimated=this._zoomAnimated&&t.options.markerZoomAnimation,this._zoomAnimated&&t.on("zoomanim",this._animateZoom,this),this._initIcon(),this.update()},onRemove:function(t){this.dragging&&this.dragging.enabled()&&(this.options.draggable=!0,this.dragging.removeHooks()),delete this.dragging,this._zoomAnimated&&t.off("zoomanim",this._animateZoom,this),this._removeIcon(),this._removeShadow()},getEvents:function(){return{zoom:this.update,viewreset:this.update}},getLatLng:function(){return this._latlng},setLatLng:function(t){var i=this._latlng;return this._latlng=C(t),this.update(),this.fire("move",{oldLatLng:i,latlng:this._latlng})},setZIndexOffset:function(t){return this.options.zIndexOffset=t,this.update()},setIcon:function(t){return this.options.icon=t,this._map&&(this._initIcon(),this.update()),this._popup&&this.bindPopup(this._popup,this._popup.options),this},getElement:function(){return this._icon},update:function(){if(this._icon&&this._map){var t=this._map.latLngToLayerPoint(this._latlng).round();this._setPos(t)}return this},_initIcon:function(){var t=this.options,i="leaflet-zoom-"+(this._zoomAnimated?"animated":"hide"),e=t.icon.createIcon(this._icon),n=!1;e!==this._icon&&(this._icon&&this._removeIcon(),n=!0,t.title&&(e.title=t.title),"IMG"===e.tagName&&(e.alt=t.alt||"")),Q(e,i),t.keyboard&&(e.tabIndex="0"),this._icon=e,t.riseOnHover&&this.on({mouseover:this._bringToFront,mouseout:this._resetZIndex});var o=t.icon.createShadow(this._shadow),s=!1;o!==this._shadow&&(this._removeShadow(),s=!0),o&&(Q(o,i),o.alt=""),this._shadow=o,t.opacity<1&&this._updateOpacity(),n&&this.getPane().appendChild(this._icon),this._initInteraction(),o&&s&&this.getPane("shadowPane").appendChild(this._shadow)},_removeIcon:function(){this.options.riseOnHover&&this.off({mouseover:this._bringToFront,mouseout:this._resetZIndex}),K(this._icon),this.removeInteractiveTarget(this._icon),this._icon=null},_removeShadow:function(){this._shadow&&K(this._shadow),this._shadow=null},_setPos:function(t){at(this._icon,t),this._shadow&&at(this._shadow,t),this._zIndex=t.y+this.options.zIndexOffset,this._resetZIndex()},_updateZIndex:function(t){this._icon.style.zIndex=this._zIndex+t},_animateZoom:function(t){var i=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center).round();this._setPos(i)},_initInteraction:function(){if(this.options.interactive&&(Q(this._icon,"leaflet-interactive"),this.addInteractiveTarget(this._icon),Je)){var t=this.options.draggable;this.dragging&&(t=this.dragging.enabled(),this.dragging.disable()),this.dragging=new Je(this),t&&this.dragging.enable()}},setOpacity:function(t){return this.options.opacity=t,this._map&&this._updateOpacity(),this},_updateOpacity:function(){var t=this.options.opacity;nt(this._icon,t),this._shadow&&nt(this._shadow,t)},_bringToFront:function(){this._updateZIndex(this.options.riseOffset)},_resetZIndex:function(){this._updateZIndex(0)},_getPopupAnchor:function(){return this.options.icon.options.popupAnchor},_getTooltipAnchor:function(){return this.options.icon.options.tooltipAnchor}}),Qe=qe.extend({options:{stroke:!0,color:"#3388ff",weight:3,opacity:1,lineCap:"round",lineJoin:"round",dashArray:null,dashOffset:null,fill:!1,fillColor:null,fillOpacity:.2,fillRule:"evenodd",interactive:!0,bubblingMouseEvents:!0},beforeAdd:function(t){this._renderer=t.getRenderer(this)},onAdd:function(){this._renderer._initPath(this),this._reset(),this._renderer._addPath(this)},onRemove:function(){this._renderer._removePath(this)},redraw:function(){return this._map&&this._renderer._updatePath(this),this},setStyle:function(t){return l(this,t),this._renderer&&this._renderer._updateStyle(this),this},bringToFront:function(){return this._renderer&&this._renderer._bringToFront(this),this},bringToBack:function(){return this._renderer&&this._renderer._bringToBack(this),this},getElement:function(){return this._path},_reset:function(){this._project(),this._update()},_clickTolerance:function(){return(this.options.stroke?this.options.weight/2:0)+this._renderer.options.tolerance}}),tn=Qe.extend({options:{fill:!0,radius:10},initialize:function(t,i){l(this,i),this._latlng=C(t),this._radius=this.options.radius},setLatLng:function(t){return this._latlng=C(t),this.redraw(),this.fire("move",{latlng:this._latlng})},getLatLng:function(){return this._latlng},setRadius:function(t){return this.options.radius=this._radius=t,this.redraw()},getRadius:function(){return this._radius},setStyle:function(t){var i=t&&t.radius||this._radius;return Qe.prototype.setStyle.call(this,t),this.setRadius(i),this},_project:function(){this._point=this._map.latLngToLayerPoint(this._latlng),this._updateBounds()},_updateBounds:function(){var t=this._radius,i=this._radiusY||t,e=this._clickTolerance(),n=[t+e,i+e];this._pxBounds=new P(this._point.subtract(n),this._point.add(n))},_update:function(){this._map&&this._updatePath()},_updatePath:function(){this._renderer._updateCircle(this)},_empty:function(){return this._radius&&!this._renderer._bounds.intersects(this._pxBounds)},_containsPoint:function(t){return t.distanceTo(this._point)<=this._radius+this._clickTolerance()}}),en=tn.extend({initialize:function(t,e,n){if("number"==typeof e&&(e=i({},n,{radius:e})),l(this,e),this._latlng=C(t),isNaN(this.options.radius))throw new Error("Circle radius cannot be NaN");this._mRadius=this.options.radius},setRadius:function(t){return this._mRadius=t,this.redraw()},getRadius:function(){return this._mRadius},getBounds:function(){var t=[this._radius,this._radiusY||this._radius];return new T(this._map.layerPointToLatLng(this._point.subtract(t)),this._map.layerPointToLatLng(this._point.add(t)))},setStyle:Qe.prototype.setStyle,_project:function(){var t=this._latlng.lng,i=this._latlng.lat,e=this._map,n=e.options.crs;if(n.distance===pi.distance){var o=Math.PI/180,s=this._mRadius/pi.R/o,r=e.project([i+s,t]),a=e.project([i-s,t]),h=r.add(a).divideBy(2),u=e.unproject(h).lat,l=Math.acos((Math.cos(s*o)-Math.sin(i*o)*Math.sin(u*o))/(Math.cos(i*o)*Math.cos(u*o)))/o;(isNaN(l)||0===l)&&(l=s/Math.cos(Math.PI/180*i)),this._point=h.subtract(e.getPixelOrigin()),this._radius=isNaN(l)?0:h.x-e.project([u,t-l]).x,this._radiusY=h.y-r.y}else{var c=n.unproject(n.project(this._latlng).subtract([this._mRadius,0]));this._point=e.latLngToLayerPoint(this._latlng),this._radius=this._point.x-e.latLngToLayerPoint(c).x}this._updateBounds()}}),nn=Qe.extend({options:{smoothFactor:1,noClip:!1},initialize:function(t,i){l(this,i),this._setLatLngs(t)},getLatLngs:function(){return this._latlngs},setLatLngs:function(t){return this._setLatLngs(t),this.redraw()},isEmpty:function(){return!this._latlngs.length},closestLayerPoint:function(t){for(var i,e,n=1/0,o=null,s=Dt,r=0,a=this._parts.length;r<a;r++)for(var h=this._parts[r],u=1,l=h.length;u<l;u++){var c=s(t,i=h[u-1],e=h[u],!0);c<n&&(n=c,o=s(t,i,e))}return o&&(o.distance=Math.sqrt(n)),o},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,i,e,n,o,s,r,a=this._rings[0],h=a.length;if(!h)return null;for(t=0,i=0;t<h-1;t++)i+=a[t].distanceTo(a[t+1])/2;if(0===i)return this._map.layerPointToLatLng(a[0]);for(t=0,n=0;t<h-1;t++)if(o=a[t],s=a[t+1],e=o.distanceTo(s),(n+=e)>i)return r=(n-i)/e,this._map.layerPointToLatLng([s.x-r*(s.x-o.x),s.y-r*(s.y-o.y)])},getBounds:function(){return this._bounds},addLatLng:function(t,i){return i=i||this._defaultShape(),t=C(t),i.push(t),this._bounds.extend(t),this.redraw()},_setLatLngs:function(t){this._bounds=new T,this._latlngs=this._convertLatLngs(t)},_defaultShape:function(){return jt(this._latlngs)?this._latlngs:this._latlngs[0]},_convertLatLngs:function(t){for(var i=[],e=jt(t),n=0,o=t.length;n<o;n++)e?(i[n]=C(t[n]),this._bounds.extend(i[n])):i[n]=this._convertLatLngs(t[n]);return i},_project:function(){var t=new P;this._rings=[],this._projectLatlngs(this._latlngs,this._rings,t);var i=this._clickTolerance(),e=new x(i,i);this._bounds.isValid()&&t.isValid()&&(t.min._subtract(e),t.max._add(e),this._pxBounds=t)},_projectLatlngs:function(t,i,e){var n,o,s=t[0]instanceof M,r=t.length;if(s){for(o=[],n=0;n<r;n++)o[n]=this._map.latLngToLayerPoint(t[n]),e.extend(o[n]);i.push(o)}else for(n=0;n<r;n++)this._projectLatlngs(t[n],i,e)},_clipPoints:function(){var t=this._renderer._bounds;if(this._parts=[],this._pxBounds&&this._pxBounds.intersects(t))if(this.options.noClip)this._parts=this._rings;else{var i,e,n,o,s,r,a,h=this._parts;for(i=0,n=0,o=this._rings.length;i<o;i++)for(e=0,s=(a=this._rings[i]).length;e<s-1;e++)(r=It(a[e],a[e+1],t,e,!0))&&(h[n]=h[n]||[],h[n].push(r[0]),r[1]===a[e+1]&&e!==s-2||(h[n].push(r[1]),n++))}},_simplifyPoints:function(){for(var t=this._parts,i=this.options.smoothFactor,e=0,n=t.length;e<n;e++)t[e]=Zt(t[e],i)},_update:function(){this._map&&(this._clipPoints(),this._simplifyPoints(),this._updatePath())},_updatePath:function(){this._renderer._updatePoly(this)},_containsPoint:function(t,i){var e,n,o,s,r,a,h=this._clickTolerance();if(!this._pxBounds||!this._pxBounds.contains(t))return!1;for(e=0,s=this._parts.length;e<s;e++)for(n=0,o=(r=(a=this._parts[e]).length)-1;n<r;o=n++)if((i||0!==n)&&Et(t,a[o],a[n])<=h)return!0;return!1}});nn._flat=Wt;var on=nn.extend({options:{fill:!0},isEmpty:function(){return!this._latlngs.length||!this._latlngs[0].length},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,i,e,n,o,s,r,a,h,u=this._rings[0],l=u.length;if(!l)return null;for(s=r=a=0,t=0,i=l-1;t<l;i=t++)e=u[t],n=u[i],o=e.y*n.x-n.y*e.x,r+=(e.x+n.x)*o,a+=(e.y+n.y)*o,s+=3*o;return h=0===s?u[0]:[r/s,a/s],this._map.layerPointToLatLng(h)},_convertLatLngs:function(t){var i=nn.prototype._convertLatLngs.call(this,t),e=i.length;return e>=2&&i[0]instanceof M&&i[0].equals(i[e-1])&&i.pop(),i},_setLatLngs:function(t){nn.prototype._setLatLngs.call(this,t),jt(this._latlngs)&&(this._latlngs=[this._latlngs])},_defaultShape:function(){return jt(this._latlngs[0])?this._latlngs[0]:this._latlngs[0][0]},_clipPoints:function(){var t=this._renderer._bounds,i=this.options.weight,e=new x(i,i);if(t=new P(t.min.subtract(e),t.max.add(e)),this._parts=[],this._pxBounds&&this._pxBounds.intersects(t))if(this.options.noClip)this._parts=this._rings;else for(var n,o=0,s=this._rings.length;o<s;o++)(n=Ht(this._rings[o],t,!0)).length&&this._parts.push(n)},_updatePath:function(){this._renderer._updatePoly(this,!0)},_containsPoint:function(t){var i,e,n,o,s,r,a,h,u=!1;if(!this._pxBounds||!this._pxBounds.contains(t))return!1;for(o=0,a=this._parts.length;o<a;o++)for(s=0,r=(h=(i=this._parts[o]).length)-1;s<h;r=s++)e=i[s],n=i[r],e.y>t.y!=n.y>t.y&&t.x<(n.x-e.x)*(t.y-e.y)/(n.y-e.y)+e.x&&(u=!u);return u||nn.prototype._containsPoint.call(this,t,!0)}}),sn=Ke.extend({initialize:function(t,i){l(this,i),this._layers={},t&&this.addData(t)},addData:function(t){var i,e,n,o=oi(t)?t:t.features;if(o){for(i=0,e=o.length;i<e;i++)((n=o[i]).geometries||n.geometry||n.features||n.coordinates)&&this.addData(n);return this}var s=this.options;if(s.filter&&!s.filter(t))return this;var r=Ft(t,s);return r?(r.feature=Yt(t),r.defaultOptions=r.options,this.resetStyle(r),s.onEachFeature&&s.onEachFeature(t,r),this.addLayer(r)):this},resetStyle:function(t){return t.options=i({},t.defaultOptions),this._setLayerStyle(t,this.options.style),this},setStyle:function(t){return this.eachLayer(function(i){this._setLayerStyle(i,t)},this)},_setLayerStyle:function(t,i){"function"==typeof i&&(i=i(t.feature)),t.setStyle&&t.setStyle(i)}}),rn={toGeoJSON:function(t){return Kt(this,{type:"Point",coordinates:qt(this.getLatLng(),t)})}};$e.include(rn),en.include(rn),tn.include(rn),nn.include({toGeoJSON:function(t){var i=!jt(this._latlngs),e=Gt(this._latlngs,i?1:0,!1,t);return Kt(this,{type:(i?"Multi":"")+"LineString",coordinates:e})}}),on.include({toGeoJSON:function(t){var i=!jt(this._latlngs),e=i&&!jt(this._latlngs[0]),n=Gt(this._latlngs,e?2:i?1:0,!0,t);return i||(n=[n]),Kt(this,{type:(e?"Multi":"")+"Polygon",coordinates:n})}}),Ge.include({toMultiPoint:function(t){var i=[];return this.eachLayer(function(e){i.push(e.toGeoJSON(t).geometry.coordinates)}),Kt(this,{type:"MultiPoint",coordinates:i})},toGeoJSON:function(t){var i=this.feature&&this.feature.geometry&&this.feature.geometry.type;if("MultiPoint"===i)return this.toMultiPoint(t);var e="GeometryCollection"===i,n=[];return this.eachLayer(function(i){if(i.toGeoJSON){var o=i.toGeoJSON(t);if(e)n.push(o.geometry);else{var s=Yt(o);"FeatureCollection"===s.type?n.push.apply(n,s.features):n.push(s)}}}),e?Kt(this,{geometries:n,type:"GeometryCollection"}):{type:"FeatureCollection",features:n}}});var an=Xt,hn=qe.extend({options:{opacity:1,alt:"",interactive:!1,crossOrigin:!1,errorOverlayUrl:"",zIndex:1,className:""},initialize:function(t,i,e){this._url=t,this._bounds=z(i),l(this,e)},onAdd:function(){this._image||(this._initImage(),this.options.opacity<1&&this._updateOpacity()),this.options.interactive&&(Q(this._image,"leaflet-interactive"),this.addInteractiveTarget(this._image)),this.getPane().appendChild(this._image),this._reset()},onRemove:function(){K(this._image),this.options.interactive&&this.removeInteractiveTarget(this._image)},setOpacity:function(t){return this.options.opacity=t,this._image&&this._updateOpacity(),this},setStyle:function(t){return t.opacity&&this.setOpacity(t.opacity),this},bringToFront:function(){return this._map&&X(this._image),this},bringToBack:function(){return this._map&&J(this._image),this},setUrl:function(t){return this._url=t,this._image&&(this._image.src=t),this},setBounds:function(t){return this._bounds=z(t),this._map&&this._reset(),this},getEvents:function(){var t={zoom:this._reset,viewreset:this._reset};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},getBounds:function(){return this._bounds},getElement:function(){return this._image},_initImage:function(){var t="IMG"===this._url.tagName,i=this._image=t?this._url:G("img");Q(i,"leaflet-image-layer"),this._zoomAnimated&&Q(i,"leaflet-zoom-animated"),this.options.className&&Q(i,this.options.className),i.onselectstart=r,i.onmousemove=r,i.onload=e(this.fire,this,"load"),i.onerror=e(this._overlayOnError,this,"error"),(this.options.crossOrigin||""===this.options.crossOrigin)&&(i.crossOrigin=!0===this.options.crossOrigin?"":this.options.crossOrigin),this.options.zIndex&&this._updateZIndex(),t?this._url=i.src:(i.src=this._url,i.alt=this.options.alt)},_animateZoom:function(t){var i=this._map.getZoomScale(t.zoom),e=this._map._latLngBoundsToNewLayerBounds(this._bounds,t.zoom,t.center).min;rt(this._image,e,i)},_reset:function(){var t=this._image,i=new P(this._map.latLngToLayerPoint(this._bounds.getNorthWest()),this._map.latLngToLayerPoint(this._bounds.getSouthEast())),e=i.getSize();at(t,i.min),t.style.width=e.x+"px",t.style.height=e.y+"px"},_updateOpacity:function(){nt(this._image,this.options.opacity)},_updateZIndex:function(){this._image&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._image.style.zIndex=this.options.zIndex)},_overlayOnError:function(){this.fire("error");var t=this.options.errorOverlayUrl;t&&this._url!==t&&(this._url=t,this._image.src=t)}}),un=hn.extend({options:{autoplay:!0,loop:!0},_initImage:function(){var t="VIDEO"===this._url.tagName,i=this._image=t?this._url:G("video");if(Q(i,"leaflet-image-layer"),this._zoomAnimated&&Q(i,"leaflet-zoom-animated"),i.onselectstart=r,i.onmousemove=r,i.onloadeddata=e(this.fire,this,"load"),t){for(var n=i.getElementsByTagName("source"),o=[],s=0;s<n.length;s++)o.push(n[s].src);this._url=n.length>0?o:[i.src]}else{oi(this._url)||(this._url=[this._url]),i.autoplay=!!this.options.autoplay,i.loop=!!this.options.loop;for(var a=0;a<this._url.length;a++){var h=G("source");h.src=this._url[a],i.appendChild(h)}}}}),ln=qe.extend({options:{offset:[0,7],className:"",pane:"popupPane"},initialize:function(t,i){l(this,t),this._source=i},onAdd:function(t){this._zoomAnimated=t._zoomAnimated,this._container||this._initLayout(),t._fadeAnimated&&nt(this._container,0),clearTimeout(this._removeTimeout),this.getPane().appendChild(this._container),this.update(),t._fadeAnimated&&nt(this._container,1),this.bringToFront()},onRemove:function(t){t._fadeAnimated?(nt(this._container,0),this._removeTimeout=setTimeout(e(K,void 0,this._container),200)):K(this._container)},getLatLng:function(){return this._latlng},setLatLng:function(t){return this._latlng=C(t),this._map&&(this._updatePosition(),this._adjustPan()),this},getContent:function(){return this._content},setContent:function(t){return this._content=t,this.update(),this},getElement:function(){return this._container},update:function(){this._map&&(this._container.style.visibility="hidden",this._updateContent(),this._updateLayout(),this._updatePosition(),this._container.style.visibility="",this._adjustPan())},getEvents:function(){var t={zoom:this._updatePosition,viewreset:this._updatePosition};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},isOpen:function(){return!!this._map&&this._map.hasLayer(this)},bringToFront:function(){return this._map&&X(this._container),this},bringToBack:function(){return this._map&&J(this._container),this},_updateContent:function(){if(this._content){var t=this._contentNode,i="function"==typeof this._content?this._content(this._source||this):this._content;if("string"==typeof i)t.innerHTML=i;else{for(;t.hasChildNodes();)t.removeChild(t.firstChild);t.appendChild(i)}this.fire("contentupdate")}},_updatePosition:function(){if(this._map){var t=this._map.latLngToLayerPoint(this._latlng),i=w(this.options.offset),e=this._getAnchor();this._zoomAnimated?at(this._container,t.add(e)):i=i.add(t).add(e);var n=this._containerBottom=-i.y,o=this._containerLeft=-Math.round(this._containerWidth/2)+i.x;this._container.style.bottom=n+"px",this._container.style.left=o+"px"}},_getAnchor:function(){return[0,0]}}),cn=ln.extend({options:{maxWidth:300,minWidth:50,maxHeight:null,autoPan:!0,autoPanPaddingTopLeft:null,autoPanPaddingBottomRight:null,autoPanPadding:[5,5],keepInView:!1,closeButton:!0,autoClose:!0,closeOnEscapeKey:!0,className:""},openOn:function(t){return t.openPopup(this),this},onAdd:function(t){ln.prototype.onAdd.call(this,t),t.fire("popupopen",{popup:this}),this._source&&(this._source.fire("popupopen",{popup:this},!0),this._source instanceof Qe||this._source.on("preclick",yt))},onRemove:function(t){ln.prototype.onRemove.call(this,t),t.fire("popupclose",{popup:this}),this._source&&(this._source.fire("popupclose",{popup:this},!0),this._source instanceof Qe||this._source.off("preclick",yt))},getEvents:function(){var t=ln.prototype.getEvents.call(this);return(void 0!==this.options.closeOnClick?this.options.closeOnClick:this._map.options.closePopupOnClick)&&(t.preclick=this._close),this.options.keepInView&&(t.moveend=this._adjustPan),t},_close:function(){this._map&&this._map.closePopup(this)},_initLayout:function(){var t="leaflet-popup",i=this._container=G("div",t+" "+(this.options.className||"")+" leaflet-zoom-animated"),e=this._wrapper=G("div",t+"-content-wrapper",i);if(this._contentNode=G("div",t+"-content",e),wt(e),xt(this._contentNode),mt(e,"contextmenu",yt),this._tipContainer=G("div",t+"-tip-container",i),this._tip=G("div",t+"-tip",this._tipContainer),this.options.closeButton){var n=this._closeButton=G("a",t+"-close-button",i);n.href="#close",n.innerHTML="&#215;",mt(n,"click",this._onCloseButtonClick,this)}},_updateLayout:function(){var t=this._contentNode,i=t.style;i.width="",i.whiteSpace="nowrap";var e=t.offsetWidth;e=Math.min(e,this.options.maxWidth),e=Math.max(e,this.options.minWidth),i.width=e+1+"px",i.whiteSpace="",i.height="";var n=t.offsetHeight,o=this.options.maxHeight;o&&n>o?(i.height=o+"px",Q(t,"leaflet-popup-scrolled")):tt(t,"leaflet-popup-scrolled"),this._containerWidth=this._container.offsetWidth},_animateZoom:function(t){var i=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center),e=this._getAnchor();at(this._container,i.add(e))},_adjustPan:function(){if(!(!this.options.autoPan||this._map._panAnim&&this._map._panAnim._inProgress)){var t=this._map,i=parseInt(q(this._container,"marginBottom"),10)||0,e=this._container.offsetHeight+i,n=this._containerWidth,o=new x(this._containerLeft,-e-this._containerBottom);o._add(ht(this._container));var s=t.layerPointToContainerPoint(o),r=w(this.options.autoPanPadding),a=w(this.options.autoPanPaddingTopLeft||r),h=w(this.options.autoPanPaddingBottomRight||r),u=t.getSize(),l=0,c=0;s.x+n+h.x>u.x&&(l=s.x+n-u.x+h.x),s.x-l-a.x<0&&(l=s.x-a.x),s.y+e+h.y>u.y&&(c=s.y+e-u.y+h.y),s.y-c-a.y<0&&(c=s.y-a.y),(l||c)&&t.fire("autopanstart").panBy([l,c])}},_onCloseButtonClick:function(t){this._close(),Lt(t)},_getAnchor:function(){return w(this._source&&this._source._getPopupAnchor?this._source._getPopupAnchor():[0,0])}});be.mergeOptions({closePopupOnClick:!0}),be.include({openPopup:function(t,i,e){return t instanceof cn||(t=new cn(e).setContent(t)),i&&t.setLatLng(i),this.hasLayer(t)?this:(this._popup&&this._popup.options.autoClose&&this.closePopup(),this._popup=t,this.addLayer(t))},closePopup:function(t){return t&&t!==this._popup||(t=this._popup,this._popup=null),t&&this.removeLayer(t),this}}),qe.include({bindPopup:function(t,i){return t instanceof cn?(l(t,i),this._popup=t,t._source=this):(this._popup&&!i||(this._popup=new cn(i,this)),this._popup.setContent(t)),this._popupHandlersAdded||(this.on({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!0),this},unbindPopup:function(){return this._popup&&(this.off({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!1,this._popup=null),this},openPopup:function(t,i){if(t instanceof qe||(i=t,t=this),t instanceof Ke)for(var e in this._layers){t=this._layers[e];break}return i||(i=t.getCenter?t.getCenter():t.getLatLng()),this._popup&&this._map&&(this._popup._source=t,this._popup.update(),this._map.openPopup(this._popup,i)),this},closePopup:function(){return this._popup&&this._popup._close(),this},togglePopup:function(t){return this._popup&&(this._popup._map?this.closePopup():this.openPopup(t)),this},isPopupOpen:function(){return!!this._popup&&this._popup.isOpen()},setPopupContent:function(t){return this._popup&&this._popup.setContent(t),this},getPopup:function(){return this._popup},_openPopup:function(t){var i=t.layer||t.target;this._popup&&this._map&&(Lt(t),i instanceof Qe?this.openPopup(t.layer||t.target,t.latlng):this._map.hasLayer(this._popup)&&this._popup._source===i?this.closePopup():this.openPopup(i,t.latlng))},_movePopup:function(t){this._popup.setLatLng(t.latlng)},_onKeyPress:function(t){13===t.originalEvent.keyCode&&this._openPopup(t)}});var _n=ln.extend({options:{pane:"tooltipPane",offset:[0,0],direction:"auto",permanent:!1,sticky:!1,interactive:!1,opacity:.9},onAdd:function(t){ln.prototype.onAdd.call(this,t),this.setOpacity(this.options.opacity),t.fire("tooltipopen",{tooltip:this}),this._source&&this._source.fire("tooltipopen",{tooltip:this},!0)},onRemove:function(t){ln.prototype.onRemove.call(this,t),t.fire("tooltipclose",{tooltip:this}),this._source&&this._source.fire("tooltipclose",{tooltip:this},!0)},getEvents:function(){var t=ln.prototype.getEvents.call(this);return qi&&!this.options.permanent&&(t.preclick=this._close),t},_close:function(){this._map&&this._map.closeTooltip(this)},_initLayout:function(){var t="leaflet-tooltip "+(this.options.className||"")+" leaflet-zoom-"+(this._zoomAnimated?"animated":"hide");this._contentNode=this._container=G("div",t)},_updateLayout:function(){},_adjustPan:function(){},_setPosition:function(t){var i=this._map,e=this._container,n=i.latLngToContainerPoint(i.getCenter()),o=i.layerPointToContainerPoint(t),s=this.options.direction,r=e.offsetWidth,a=e.offsetHeight,h=w(this.options.offset),u=this._getAnchor();"top"===s?t=t.add(w(-r/2+h.x,-a+h.y+u.y,!0)):"bottom"===s?t=t.subtract(w(r/2-h.x,-h.y,!0)):"center"===s?t=t.subtract(w(r/2+h.x,a/2-u.y+h.y,!0)):"right"===s||"auto"===s&&o.x<n.x?(s="right",t=t.add(w(h.x+u.x,u.y-a/2+h.y,!0))):(s="left",t=t.subtract(w(r+u.x-h.x,a/2-u.y-h.y,!0))),tt(e,"leaflet-tooltip-right"),tt(e,"leaflet-tooltip-left"),tt(e,"leaflet-tooltip-top"),tt(e,"leaflet-tooltip-bottom"),Q(e,"leaflet-tooltip-"+s),at(e,t)},_updatePosition:function(){var t=this._map.latLngToLayerPoint(this._latlng);this._setPosition(t)},setOpacity:function(t){this.options.opacity=t,this._container&&nt(this._container,t)},_animateZoom:function(t){var i=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center);this._setPosition(i)},_getAnchor:function(){return w(this._source&&this._source._getTooltipAnchor&&!this.options.sticky?this._source._getTooltipAnchor():[0,0])}});be.include({openTooltip:function(t,i,e){return t instanceof _n||(t=new _n(e).setContent(t)),i&&t.setLatLng(i),this.hasLayer(t)?this:this.addLayer(t)},closeTooltip:function(t){return t&&this.removeLayer(t),this}}),qe.include({bindTooltip:function(t,i){return t instanceof _n?(l(t,i),this._tooltip=t,t._source=this):(this._tooltip&&!i||(this._tooltip=new _n(i,this)),this._tooltip.setContent(t)),this._initTooltipInteractions(),this._tooltip.options.permanent&&this._map&&this._map.hasLayer(this)&&this.openTooltip(),this},unbindTooltip:function(){return this._tooltip&&(this._initTooltipInteractions(!0),this.closeTooltip(),this._tooltip=null),this},_initTooltipInteractions:function(t){if(t||!this._tooltipHandlersAdded){var i=t?"off":"on",e={remove:this.closeTooltip,move:this._moveTooltip};this._tooltip.options.permanent?e.add=this._openTooltip:(e.mouseover=this._openTooltip,e.mouseout=this.closeTooltip,this._tooltip.options.sticky&&(e.mousemove=this._moveTooltip),qi&&(e.click=this._openTooltip)),this[i](e),this._tooltipHandlersAdded=!t}},openTooltip:function(t,i){if(t instanceof qe||(i=t,t=this),t instanceof Ke)for(var e in this._layers){t=this._layers[e];break}return i||(i=t.getCenter?t.getCenter():t.getLatLng()),this._tooltip&&this._map&&(this._tooltip._source=t,this._tooltip.update(),this._map.openTooltip(this._tooltip,i),this._tooltip.options.interactive&&this._tooltip._container&&(Q(this._tooltip._container,"leaflet-clickable"),this.addInteractiveTarget(this._tooltip._container))),this},closeTooltip:function(){return this._tooltip&&(this._tooltip._close(),this._tooltip.options.interactive&&this._tooltip._container&&(tt(this._tooltip._container,"leaflet-clickable"),this.removeInteractiveTarget(this._tooltip._container))),this},toggleTooltip:function(t){return this._tooltip&&(this._tooltip._map?this.closeTooltip():this.openTooltip(t)),this},isTooltipOpen:function(){return this._tooltip.isOpen()},setTooltipContent:function(t){return this._tooltip&&this._tooltip.setContent(t),this},getTooltip:function(){return this._tooltip},_openTooltip:function(t){var i=t.layer||t.target;this._tooltip&&this._map&&this.openTooltip(i,this._tooltip.options.sticky?t.latlng:void 0)},_moveTooltip:function(t){var i,e,n=t.latlng;this._tooltip.options.sticky&&t.originalEvent&&(i=this._map.mouseEventToContainerPoint(t.originalEvent),e=this._map.containerPointToLayerPoint(i),n=this._map.layerPointToLatLng(e)),this._tooltip.setLatLng(n)}});var dn=Ye.extend({options:{iconSize:[12,12],html:!1,bgPos:null,className:"leaflet-div-icon"},createIcon:function(t){var i=t&&"DIV"===t.tagName?t:document.createElement("div"),e=this.options;if(i.innerHTML=!1!==e.html?e.html:"",e.bgPos){var n=w(e.bgPos);i.style.backgroundPosition=-n.x+"px "+-n.y+"px"}return this._setIconStyles(i,"icon"),i},createShadow:function(){return null}});Ye.Default=Xe;var pn=qe.extend({options:{tileSize:256,opacity:1,updateWhenIdle:Wi,updateWhenZooming:!0,updateInterval:200,zIndex:1,bounds:null,minZoom:0,maxZoom:void 0,maxNativeZoom:void 0,minNativeZoom:void 0,noWrap:!1,pane:"tilePane",className:"",keepBuffer:2},initialize:function(t){l(this,t)},onAdd:function(){this._initContainer(),this._levels={},this._tiles={},this._resetView(),this._update()},beforeAdd:function(t){t._addZoomLimit(this)},onRemove:function(t){this._removeAllTiles(),K(this._container),t._removeZoomLimit(this),this._container=null,this._tileZoom=void 0},bringToFront:function(){return this._map&&(X(this._container),this._setAutoZIndex(Math.max)),this},bringToBack:function(){return this._map&&(J(this._container),this._setAutoZIndex(Math.min)),this},getContainer:function(){return this._container},setOpacity:function(t){return this.options.opacity=t,this._updateOpacity(),this},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},isLoading:function(){return this._loading},redraw:function(){return this._map&&(this._removeAllTiles(),this._update()),this},getEvents:function(){var t={viewprereset:this._invalidateAll,viewreset:this._resetView,zoom:this._resetView,moveend:this._onMoveEnd};return this.options.updateWhenIdle||(this._onMove||(this._onMove=o(this._onMoveEnd,this.options.updateInterval,this)),t.move=this._onMove),this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},createTile:function(){return document.createElement("div")},getTileSize:function(){var t=this.options.tileSize;return t instanceof x?t:new x(t,t)},_updateZIndex:function(){this._container&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._container.style.zIndex=this.options.zIndex)},_setAutoZIndex:function(t){for(var i,e=this.getPane().children,n=-t(-1/0,1/0),o=0,s=e.length;o<s;o++)i=e[o].style.zIndex,e[o]!==this._container&&i&&(n=t(n,+i));isFinite(n)&&(this.options.zIndex=n+t(-1,1),this._updateZIndex())},_updateOpacity:function(){if(this._map&&!Li){nt(this._container,this.options.opacity);var t=+new Date,i=!1,e=!1;for(var n in this._tiles){var o=this._tiles[n];if(o.current&&o.loaded){var s=Math.min(1,(t-o.loaded)/200);nt(o.el,s),s<1?i=!0:(o.active?e=!0:this._onOpaqueTile(o),o.active=!0)}}e&&!this._noPrune&&this._pruneTiles(),i&&(g(this._fadeFrame),this._fadeFrame=f(this._updateOpacity,this))}},_onOpaqueTile:r,_initContainer:function(){this._container||(this._container=G("div","leaflet-layer "+(this.options.className||"")),this._updateZIndex(),this.options.opacity<1&&this._updateOpacity(),this.getPane().appendChild(this._container))},_updateLevels:function(){var t=this._tileZoom,i=this.options.maxZoom;if(void 0!==t){for(var e in this._levels)this._levels[e].el.children.length||e===t?(this._levels[e].el.style.zIndex=i-Math.abs(t-e),this._onUpdateLevel(e)):(K(this._levels[e].el),this._removeTilesAtZoom(e),this._onRemoveLevel(e),delete this._levels[e]);var n=this._levels[t],o=this._map;return n||((n=this._levels[t]={}).el=G("div","leaflet-tile-container leaflet-zoom-animated",this._container),n.el.style.zIndex=i,n.origin=o.project(o.unproject(o.getPixelOrigin()),t).round(),n.zoom=t,this._setZoomTransform(n,o.getCenter(),o.getZoom()),n.el.offsetWidth,this._onCreateLevel(n)),this._level=n,n}},_onUpdateLevel:r,_onRemoveLevel:r,_onCreateLevel:r,_pruneTiles:function(){if(this._map){var t,i,e=this._map.getZoom();if(e>this.options.maxZoom||e<this.options.minZoom)this._removeAllTiles();else{for(t in this._tiles)(i=this._tiles[t]).retain=i.current;for(t in this._tiles)if((i=this._tiles[t]).current&&!i.active){var n=i.coords;this._retainParent(n.x,n.y,n.z,n.z-5)||this._retainChildren(n.x,n.y,n.z,n.z+2)}for(t in this._tiles)this._tiles[t].retain||this._removeTile(t)}}},_removeTilesAtZoom:function(t){for(var i in this._tiles)this._tiles[i].coords.z===t&&this._removeTile(i)},_removeAllTiles:function(){for(var t in this._tiles)this._removeTile(t)},_invalidateAll:function(){for(var t in this._levels)K(this._levels[t].el),this._onRemoveLevel(t),delete this._levels[t];this._removeAllTiles(),this._tileZoom=void 0},_retainParent:function(t,i,e,n){var o=Math.floor(t/2),s=Math.floor(i/2),r=e-1,a=new x(+o,+s);a.z=+r;var h=this._tileCoordsToKey(a),u=this._tiles[h];return u&&u.active?(u.retain=!0,!0):(u&&u.loaded&&(u.retain=!0),r>n&&this._retainParent(o,s,r,n))},_retainChildren:function(t,i,e,n){for(var o=2*t;o<2*t+2;o++)for(var s=2*i;s<2*i+2;s++){var r=new x(o,s);r.z=e+1;var a=this._tileCoordsToKey(r),h=this._tiles[a];h&&h.active?h.retain=!0:(h&&h.loaded&&(h.retain=!0),e+1<n&&this._retainChildren(o,s,e+1,n))}},_resetView:function(t){var i=t&&(t.pinch||t.flyTo);this._setView(this._map.getCenter(),this._map.getZoom(),i,i)},_animateZoom:function(t){this._setView(t.center,t.zoom,!0,t.noUpdate)},_clampZoom:function(t){var i=this.options;return void 0!==i.minNativeZoom&&t<i.minNativeZoom?i.minNativeZoom:void 0!==i.maxNativeZoom&&i.maxNativeZoom<t?i.maxNativeZoom:t},_setView:function(t,i,e,n){var o=this._clampZoom(Math.round(i));(void 0!==this.options.maxZoom&&o>this.options.maxZoom||void 0!==this.options.minZoom&&o<this.options.minZoom)&&(o=void 0);var s=this.options.updateWhenZooming&&o!==this._tileZoom;n&&!s||(this._tileZoom=o,this._abortLoading&&this._abortLoading(),this._updateLevels(),this._resetGrid(),void 0!==o&&this._update(t),e||this._pruneTiles(),this._noPrune=!!e),this._setZoomTransforms(t,i)},_setZoomTransforms:function(t,i){for(var e in this._levels)this._setZoomTransform(this._levels[e],t,i)},_setZoomTransform:function(t,i,e){var n=this._map.getZoomScale(e,t.zoom),o=t.origin.multiplyBy(n).subtract(this._map._getNewPixelOrigin(i,e)).round();ji?rt(t.el,o,n):at(t.el,o)},_resetGrid:function(){var t=this._map,i=t.options.crs,e=this._tileSize=this.getTileSize(),n=this._tileZoom,o=this._map.getPixelWorldBounds(this._tileZoom);o&&(this._globalTileRange=this._pxBoundsToTileRange(o)),this._wrapX=i.wrapLng&&!this.options.noWrap&&[Math.floor(t.project([0,i.wrapLng[0]],n).x/e.x),Math.ceil(t.project([0,i.wrapLng[1]],n).x/e.y)],this._wrapY=i.wrapLat&&!this.options.noWrap&&[Math.floor(t.project([i.wrapLat[0],0],n).y/e.x),Math.ceil(t.project([i.wrapLat[1],0],n).y/e.y)]},_onMoveEnd:function(){this._map&&!this._map._animatingZoom&&this._update()},_getTiledPixelBounds:function(t){var i=this._map,e=i._animatingZoom?Math.max(i._animateToZoom,i.getZoom()):i.getZoom(),n=i.getZoomScale(e,this._tileZoom),o=i.project(t,this._tileZoom).floor(),s=i.getSize().divideBy(2*n);return new P(o.subtract(s),o.add(s))},_update:function(t){var i=this._map;if(i){var e=this._clampZoom(i.getZoom());if(void 0===t&&(t=i.getCenter()),void 0!==this._tileZoom){var n=this._getTiledPixelBounds(t),o=this._pxBoundsToTileRange(n),s=o.getCenter(),r=[],a=this.options.keepBuffer,h=new P(o.getBottomLeft().subtract([a,-a]),o.getTopRight().add([a,-a]));if(!(isFinite(o.min.x)&&isFinite(o.min.y)&&isFinite(o.max.x)&&isFinite(o.max.y)))throw new Error("Attempted to load an infinite number of tiles");for(var u in this._tiles){var l=this._tiles[u].coords;l.z===this._tileZoom&&h.contains(new x(l.x,l.y))||(this._tiles[u].current=!1)}if(Math.abs(e-this._tileZoom)>1)this._setView(t,e);else{for(var c=o.min.y;c<=o.max.y;c++)for(var _=o.min.x;_<=o.max.x;_++){var d=new x(_,c);if(d.z=this._tileZoom,this._isValidTile(d)){var p=this._tiles[this._tileCoordsToKey(d)];p?p.current=!0:r.push(d)}}if(r.sort(function(t,i){return t.distanceTo(s)-i.distanceTo(s)}),0!==r.length){this._loading||(this._loading=!0,this.fire("loading"));var m=document.createDocumentFragment();for(_=0;_<r.length;_++)this._addTile(r[_],m);this._level.el.appendChild(m)}}}}},_isValidTile:function(t){var i=this._map.options.crs;if(!i.infinite){var e=this._globalTileRange;if(!i.wrapLng&&(t.x<e.min.x||t.x>e.max.x)||!i.wrapLat&&(t.y<e.min.y||t.y>e.max.y))return!1}if(!this.options.bounds)return!0;var n=this._tileCoordsToBounds(t);return z(this.options.bounds).overlaps(n)},_keyToBounds:function(t){return this._tileCoordsToBounds(this._keyToTileCoords(t))},_tileCoordsToNwSe:function(t){var i=this._map,e=this.getTileSize(),n=t.scaleBy(e),o=n.add(e);return[i.unproject(n,t.z),i.unproject(o,t.z)]},_tileCoordsToBounds:function(t){var i=this._tileCoordsToNwSe(t),e=new T(i[0],i[1]);return this.options.noWrap||(e=this._map.wrapLatLngBounds(e)),e},_tileCoordsToKey:function(t){return t.x+":"+t.y+":"+t.z},_keyToTileCoords:function(t){var i=t.split(":"),e=new x(+i[0],+i[1]);return e.z=+i[2],e},_removeTile:function(t){var i=this._tiles[t];i&&(Si||i.el.setAttribute("src",si),K(i.el),delete this._tiles[t],this.fire("tileunload",{tile:i.el,coords:this._keyToTileCoords(t)}))},_initTile:function(t){Q(t,"leaflet-tile");var i=this.getTileSize();t.style.width=i.x+"px",t.style.height=i.y+"px",t.onselectstart=r,t.onmousemove=r,Li&&this.options.opacity<1&&nt(t,this.options.opacity),zi&&!Mi&&(t.style.WebkitBackfaceVisibility="hidden")},_addTile:function(t,i){var n=this._getTilePos(t),o=this._tileCoordsToKey(t),s=this.createTile(this._wrapCoords(t),e(this._tileReady,this,t));this._initTile(s),this.createTile.length<2&&f(e(this._tileReady,this,t,null,s)),at(s,n),this._tiles[o]={el:s,coords:t,current:!0},i.appendChild(s),this.fire("tileloadstart",{tile:s,coords:t})},_tileReady:function(t,i,n){if(this._map&&n.getAttribute("src")!==si){i&&this.fire("tileerror",{error:i,tile:n,coords:t});var o=this._tileCoordsToKey(t);(n=this._tiles[o])&&(n.loaded=+new Date,this._map._fadeAnimated?(nt(n.el,0),g(this._fadeFrame),this._fadeFrame=f(this._updateOpacity,this)):(n.active=!0,this._pruneTiles()),i||(Q(n.el,"leaflet-tile-loaded"),this.fire("tileload",{tile:n.el,coords:t})),this._noTilesToLoad()&&(this._loading=!1,this.fire("load"),Li||!this._map._fadeAnimated?f(this._pruneTiles,this):setTimeout(e(this._pruneTiles,this),250)))}},_getTilePos:function(t){return t.scaleBy(this.getTileSize()).subtract(this._level.origin)},_wrapCoords:function(t){var i=new x(this._wrapX?s(t.x,this._wrapX):t.x,this._wrapY?s(t.y,this._wrapY):t.y);return i.z=t.z,i},_pxBoundsToTileRange:function(t){var i=this.getTileSize();return new P(t.min.unscaleBy(i).floor(),t.max.unscaleBy(i).ceil().subtract([1,1]))},_noTilesToLoad:function(){for(var t in this._tiles)if(!this._tiles[t].loaded)return!1;return!0}}),mn=pn.extend({options:{minZoom:0,maxZoom:18,subdomains:"abc",errorTileUrl:"",zoomOffset:0,tms:!1,zoomReverse:!1,detectRetina:!1,crossOrigin:!1},initialize:function(t,i){this._url=t,(i=l(this,i)).detectRetina&&Yi&&i.maxZoom>0&&(i.tileSize=Math.floor(i.tileSize/2),i.zoomReverse?(i.zoomOffset--,i.minZoom++):(i.zoomOffset++,i.maxZoom--),i.minZoom=Math.max(0,i.minZoom)),"string"==typeof i.subdomains&&(i.subdomains=i.subdomains.split("")),zi||this.on("tileunload",this._onTileRemove)},setUrl:function(t,i){return this._url=t,i||this.redraw(),this},createTile:function(t,i){var n=document.createElement("img");return mt(n,"load",e(this._tileOnLoad,this,i,n)),mt(n,"error",e(this._tileOnError,this,i,n)),(this.options.crossOrigin||""===this.options.crossOrigin)&&(n.crossOrigin=!0===this.options.crossOrigin?"":this.options.crossOrigin),n.alt="",n.setAttribute("role","presentation"),n.src=this.getTileUrl(t),n},getTileUrl:function(t){var e={r:Yi?"@2x":"",s:this._getSubdomain(t),x:t.x,y:t.y,z:this._getZoomForUrl()};if(this._map&&!this._map.options.crs.infinite){var n=this._globalTileRange.max.y-t.y;this.options.tms&&(e.y=n),e["-y"]=n}return _(this._url,i(e,this.options))},_tileOnLoad:function(t,i){Li?setTimeout(e(t,this,null,i),0):t(null,i)},_tileOnError:function(t,i,e){var n=this.options.errorTileUrl;n&&i.getAttribute("src")!==n&&(i.src=n),t(e,i)},_onTileRemove:function(t){t.tile.onload=null},_getZoomForUrl:function(){var t=this._tileZoom,i=this.options.maxZoom,e=this.options.zoomReverse,n=this.options.zoomOffset;return e&&(t=i-t),t+n},_getSubdomain:function(t){var i=Math.abs(t.x+t.y)%this.options.subdomains.length;return this.options.subdomains[i]},_abortLoading:function(){var t,i;for(t in this._tiles)this._tiles[t].coords.z!==this._tileZoom&&((i=this._tiles[t].el).onload=r,i.onerror=r,i.complete||(i.src=si,K(i),delete this._tiles[t]))}}),fn=mn.extend({defaultWmsParams:{service:"WMS",request:"GetMap",layers:"",styles:"",format:"image/jpeg",transparent:!1,version:"1.1.1"},options:{crs:null,uppercase:!1},initialize:function(t,e){this._url=t;var n=i({},this.defaultWmsParams);for(var o in e)o in this.options||(n[o]=e[o]);var s=(e=l(this,e)).detectRetina&&Yi?2:1,r=this.getTileSize();n.width=r.x*s,n.height=r.y*s,this.wmsParams=n},onAdd:function(t){this._crs=this.options.crs||t.options.crs,this._wmsVersion=parseFloat(this.wmsParams.version);var i=this._wmsVersion>=1.3?"crs":"srs";this.wmsParams[i]=this._crs.code,mn.prototype.onAdd.call(this,t)},getTileUrl:function(t){var i=this._tileCoordsToNwSe(t),e=this._crs,n=b(e.project(i[0]),e.project(i[1])),o=n.min,s=n.max,r=(this._wmsVersion>=1.3&&this._crs===Ue?[o.y,o.x,s.y,s.x]:[o.x,o.y,s.x,s.y]).join(","),a=mn.prototype.getTileUrl.call(this,t);return a+c(this.wmsParams,a,this.options.uppercase)+(this.options.uppercase?"&BBOX=":"&bbox=")+r},setParams:function(t,e){return i(this.wmsParams,t),e||this.redraw(),this}});mn.WMS=fn,Jt.wms=function(t,i){return new fn(t,i)};var gn=qe.extend({options:{padding:.1,tolerance:0},initialize:function(t){l(this,t),n(this),this._layers=this._layers||{}},onAdd:function(){this._container||(this._initContainer(),this._zoomAnimated&&Q(this._container,"leaflet-zoom-animated")),this.getPane().appendChild(this._container),this._update(),this.on("update",this._updatePaths,this)},onRemove:function(){this.off("update",this._updatePaths,this),this._destroyContainer()},getEvents:function(){var t={viewreset:this._reset,zoom:this._onZoom,moveend:this._update,zoomend:this._onZoomEnd};return this._zoomAnimated&&(t.zoomanim=this._onAnimZoom),t},_onAnimZoom:function(t){this._updateTransform(t.center,t.zoom)},_onZoom:function(){this._updateTransform(this._map.getCenter(),this._map.getZoom())},_updateTransform:function(t,i){var e=this._map.getZoomScale(i,this._zoom),n=ht(this._container),o=this._map.getSize().multiplyBy(.5+this.options.padding),s=this._map.project(this._center,i),r=this._map.project(t,i).subtract(s),a=o.multiplyBy(-e).add(n).add(o).subtract(r);ji?rt(this._container,a,e):at(this._container,a)},_reset:function(){this._update(),this._updateTransform(this._center,this._zoom);for(var t in this._layers)this._layers[t]._reset()},_onZoomEnd:function(){for(var t in this._layers)this._layers[t]._project()},_updatePaths:function(){for(var t in this._layers)this._layers[t]._update()},_update:function(){var t=this.options.padding,i=this._map.getSize(),e=this._map.containerPointToLayerPoint(i.multiplyBy(-t)).round();this._bounds=new P(e,e.add(i.multiplyBy(1+2*t)).round()),this._center=this._map.getCenter(),this._zoom=this._map.getZoom()}}),vn=gn.extend({getEvents:function(){var t=gn.prototype.getEvents.call(this);return t.viewprereset=this._onViewPreReset,t},_onViewPreReset:function(){this._postponeUpdatePaths=!0},onAdd:function(){gn.prototype.onAdd.call(this),this._draw()},_initContainer:function(){var t=this._container=document.createElement("canvas");mt(t,"mousemove",o(this._onMouseMove,32,this),this),mt(t,"click dblclick mousedown mouseup contextmenu",this._onClick,this),mt(t,"mouseout",this._handleMouseOut,this),this._ctx=t.getContext("2d")},_destroyContainer:function(){g(this._redrawRequest),delete this._ctx,K(this._container),ft(this._container),delete this._container},_updatePaths:function(){if(!this._postponeUpdatePaths){this._redrawBounds=null;for(var t in this._layers)this._layers[t]._update();this._redraw()}},_update:function(){if(!this._map._animatingZoom||!this._bounds){this._drawnLayers={},gn.prototype._update.call(this);var t=this._bounds,i=this._container,e=t.getSize(),n=Yi?2:1;at(i,t.min),i.width=n*e.x,i.height=n*e.y,i.style.width=e.x+"px",i.style.height=e.y+"px",Yi&&this._ctx.scale(2,2),this._ctx.translate(-t.min.x,-t.min.y),this.fire("update")}},_reset:function(){gn.prototype._reset.call(this),this._postponeUpdatePaths&&(this._postponeUpdatePaths=!1,this._updatePaths())},_initPath:function(t){this._updateDashArray(t),this._layers[n(t)]=t;var i=t._order={layer:t,prev:this._drawLast,next:null};this._drawLast&&(this._drawLast.next=i),this._drawLast=i,this._drawFirst=this._drawFirst||this._drawLast},_addPath:function(t){this._requestRedraw(t)},_removePath:function(t){var i=t._order,e=i.next,o=i.prev;e?e.prev=o:this._drawLast=o,o?o.next=e:this._drawFirst=e,delete this._drawnLayers[t._leaflet_id],delete t._order,delete this._layers[n(t)],this._requestRedraw(t)},_updatePath:function(t){this._extendRedrawBounds(t),t._project(),t._update(),this._requestRedraw(t)},_updateStyle:function(t){this._updateDashArray(t),this._requestRedraw(t)},_updateDashArray:function(t){if("string"==typeof t.options.dashArray){var i,e=t.options.dashArray.split(","),n=[];for(i=0;i<e.length;i++)n.push(Number(e[i]));t.options._dashArray=n}else t.options._dashArray=t.options.dashArray},_requestRedraw:function(t){this._map&&(this._extendRedrawBounds(t),this._redrawRequest=this._redrawRequest||f(this._redraw,this))},_extendRedrawBounds:function(t){if(t._pxBounds){var i=(t.options.weight||0)+1;this._redrawBounds=this._redrawBounds||new P,this._redrawBounds.extend(t._pxBounds.min.subtract([i,i])),this._redrawBounds.extend(t._pxBounds.max.add([i,i]))}},_redraw:function(){this._redrawRequest=null,this._redrawBounds&&(this._redrawBounds.min._floor(),this._redrawBounds.max._ceil()),this._clear(),this._draw(),this._redrawBounds=null},_clear:function(){var t=this._redrawBounds;if(t){var i=t.getSize();this._ctx.clearRect(t.min.x,t.min.y,i.x,i.y)}else this._ctx.clearRect(0,0,this._container.width,this._container.height)},_draw:function(){var t,i=this._redrawBounds;if(this._ctx.save(),i){var e=i.getSize();this._ctx.beginPath(),this._ctx.rect(i.min.x,i.min.y,e.x,e.y),this._ctx.clip()}this._drawing=!0;for(var n=this._drawFirst;n;n=n.next)t=n.layer,(!i||t._pxBounds&&t._pxBounds.intersects(i))&&t._updatePath();this._drawing=!1,this._ctx.restore()},_updatePoly:function(t,i){if(this._drawing){var e,n,o,s,r=t._parts,a=r.length,h=this._ctx;if(a){for(this._drawnLayers[t._leaflet_id]=t,h.beginPath(),e=0;e<a;e++){for(n=0,o=r[e].length;n<o;n++)s=r[e][n],h[n?"lineTo":"moveTo"](s.x,s.y);i&&h.closePath()}this._fillStroke(h,t)}}},_updateCircle:function(t){if(this._drawing&&!t._empty()){var i=t._point,e=this._ctx,n=Math.max(Math.round(t._radius),1),o=(Math.max(Math.round(t._radiusY),1)||n)/n;this._drawnLayers[t._leaflet_id]=t,1!==o&&(e.save(),e.scale(1,o)),e.beginPath(),e.arc(i.x,i.y/o,n,0,2*Math.PI,!1),1!==o&&e.restore(),this._fillStroke(e,t)}},_fillStroke:function(t,i){var e=i.options;e.fill&&(t.globalAlpha=e.fillOpacity,t.fillStyle=e.fillColor||e.color,t.fill(e.fillRule||"evenodd")),e.stroke&&0!==e.weight&&(t.setLineDash&&t.setLineDash(i.options&&i.options._dashArray||[]),t.globalAlpha=e.opacity,t.lineWidth=e.weight,t.strokeStyle=e.color,t.lineCap=e.lineCap,t.lineJoin=e.lineJoin,t.stroke())},_onClick:function(t){for(var i,e,n=this._map.mouseEventToLayerPoint(t),o=this._drawFirst;o;o=o.next)(i=o.layer).options.interactive&&i._containsPoint(n)&&!this._map._draggableMoved(i)&&(e=i);e&&(zt(t),this._fireEvent([e],t))},_onMouseMove:function(t){if(this._map&&!this._map.dragging.moving()&&!this._map._animatingZoom){var i=this._map.mouseEventToLayerPoint(t);this._handleMouseHover(t,i)}},_handleMouseOut:function(t){var i=this._hoveredLayer;i&&(tt(this._container,"leaflet-interactive"),this._fireEvent([i],t,"mouseout"),this._hoveredLayer=null)},_handleMouseHover:function(t,i){for(var e,n,o=this._drawFirst;o;o=o.next)(e=o.layer).options.interactive&&e._containsPoint(i)&&(n=e);n!==this._hoveredLayer&&(this._handleMouseOut(t),n&&(Q(this._container,"leaflet-interactive"),this._fireEvent([n],t,"mouseover"),this._hoveredLayer=n)),this._hoveredLayer&&this._fireEvent([this._hoveredLayer],t)},_fireEvent:function(t,i,e){this._map._fireDOMEvent(i,e||i.type,t)},_bringToFront:function(t){var i=t._order,e=i.next,n=i.prev;e&&(e.prev=n,n?n.next=e:e&&(this._drawFirst=e),i.prev=this._drawLast,this._drawLast.next=i,i.next=null,this._drawLast=i,this._requestRedraw(t))},_bringToBack:function(t){var i=t._order,e=i.next,n=i.prev;n&&(n.next=e,e?e.prev=n:n&&(this._drawLast=n),i.prev=null,i.next=this._drawFirst,this._drawFirst.prev=i,this._drawFirst=i,this._requestRedraw(t))}}),yn=function(){try{return document.namespaces.add("lvml","urn:schemas-microsoft-com:vml"),function(t){return document.createElement("<lvml:"+t+' class="lvml">')}}catch(t){return function(t){return document.createElement("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="lvml">')}}}(),xn={_initContainer:function(){this._container=G("div","leaflet-vml-container")},_update:function(){this._map._animatingZoom||(gn.prototype._update.call(this),this.fire("update"))},_initPath:function(t){var i=t._container=yn("shape");Q(i,"leaflet-vml-shape "+(this.options.className||"")),i.coordsize="1 1",t._path=yn("path"),i.appendChild(t._path),this._updateStyle(t),this._layers[n(t)]=t},_addPath:function(t){var i=t._container;this._container.appendChild(i),t.options.interactive&&t.addInteractiveTarget(i)},_removePath:function(t){var i=t._container;K(i),t.removeInteractiveTarget(i),delete this._layers[n(t)]},_updateStyle:function(t){var i=t._stroke,e=t._fill,n=t.options,o=t._container;o.stroked=!!n.stroke,o.filled=!!n.fill,n.stroke?(i||(i=t._stroke=yn("stroke")),o.appendChild(i),i.weight=n.weight+"px",i.color=n.color,i.opacity=n.opacity,n.dashArray?i.dashStyle=oi(n.dashArray)?n.dashArray.join(" "):n.dashArray.replace(/( *, *)/g," "):i.dashStyle="",i.endcap=n.lineCap.replace("butt","flat"),i.joinstyle=n.lineJoin):i&&(o.removeChild(i),t._stroke=null),n.fill?(e||(e=t._fill=yn("fill")),o.appendChild(e),e.color=n.fillColor||n.color,e.opacity=n.fillOpacity):e&&(o.removeChild(e),t._fill=null)},_updateCircle:function(t){var i=t._point.round(),e=Math.round(t._radius),n=Math.round(t._radiusY||e);this._setPath(t,t._empty()?"M0 0":"AL "+i.x+","+i.y+" "+e+","+n+" 0,23592600")},_setPath:function(t,i){t._path.v=i},_bringToFront:function(t){X(t._container)},_bringToBack:function(t){J(t._container)}},wn=$i?yn:E,Pn=gn.extend({getEvents:function(){var t=gn.prototype.getEvents.call(this);return t.zoomstart=this._onZoomStart,t},_initContainer:function(){this._container=wn("svg"),this._container.setAttribute("pointer-events","none"),this._rootGroup=wn("g"),this._container.appendChild(this._rootGroup)},_destroyContainer:function(){K(this._container),ft(this._container),delete this._container,delete this._rootGroup,delete this._svgSize},_onZoomStart:function(){this._update()},_update:function(){if(!this._map._animatingZoom||!this._bounds){gn.prototype._update.call(this);var t=this._bounds,i=t.getSize(),e=this._container;this._svgSize&&this._svgSize.equals(i)||(this._svgSize=i,e.setAttribute("width",i.x),e.setAttribute("height",i.y)),at(e,t.min),e.setAttribute("viewBox",[t.min.x,t.min.y,i.x,i.y].join(" ")),this.fire("update")}},_initPath:function(t){var i=t._path=wn("path");t.options.className&&Q(i,t.options.className),t.options.interactive&&Q(i,"leaflet-interactive"),this._updateStyle(t),this._layers[n(t)]=t},_addPath:function(t){this._rootGroup||this._initContainer(),this._rootGroup.appendChild(t._path),t.addInteractiveTarget(t._path)},_removePath:function(t){K(t._path),t.removeInteractiveTarget(t._path),delete this._layers[n(t)]},_updatePath:function(t){t._project(),t._update()},_updateStyle:function(t){var i=t._path,e=t.options;i&&(e.stroke?(i.setAttribute("stroke",e.color),i.setAttribute("stroke-opacity",e.opacity),i.setAttribute("stroke-width",e.weight),i.setAttribute("stroke-linecap",e.lineCap),i.setAttribute("stroke-linejoin",e.lineJoin),e.dashArray?i.setAttribute("stroke-dasharray",e.dashArray):i.removeAttribute("stroke-dasharray"),e.dashOffset?i.setAttribute("stroke-dashoffset",e.dashOffset):i.removeAttribute("stroke-dashoffset")):i.setAttribute("stroke","none"),e.fill?(i.setAttribute("fill",e.fillColor||e.color),i.setAttribute("fill-opacity",e.fillOpacity),i.setAttribute("fill-rule",e.fillRule||"evenodd")):i.setAttribute("fill","none"))},_updatePoly:function(t,i){this._setPath(t,k(t._parts,i))},_updateCircle:function(t){var i=t._point,e=Math.max(Math.round(t._radius),1),n="a"+e+","+(Math.max(Math.round(t._radiusY),1)||e)+" 0 1,0 ",o=t._empty()?"M0 0":"M"+(i.x-e)+","+i.y+n+2*e+",0 "+n+2*-e+",0 ";this._setPath(t,o)},_setPath:function(t,i){t._path.setAttribute("d",i)},_bringToFront:function(t){X(t._path)},_bringToBack:function(t){J(t._path)}});$i&&Pn.include(xn),be.include({getRenderer:function(t){var i=t.options.renderer||this._getPaneRenderer(t.options.pane)||this.options.renderer||this._renderer;return i||(i=this._renderer=this._createRenderer()),this.hasLayer(i)||this.addLayer(i),i},_getPaneRenderer:function(t){if("overlayPane"===t||void 0===t)return!1;var i=this._paneRenderers[t];return void 0===i&&(i=this._createRenderer({pane:t}),this._paneRenderers[t]=i),i},_createRenderer:function(t){return this.options.preferCanvas&&$t(t)||Qt(t)}});var Ln=on.extend({initialize:function(t,i){on.prototype.initialize.call(this,this._boundsToLatLngs(t),i)},setBounds:function(t){return this.setLatLngs(this._boundsToLatLngs(t))},_boundsToLatLngs:function(t){return t=z(t),[t.getSouthWest(),t.getNorthWest(),t.getNorthEast(),t.getSouthEast()]}});Pn.create=wn,Pn.pointsToPath=k,sn.geometryToLayer=Ft,sn.coordsToLatLng=Ut,sn.coordsToLatLngs=Vt,sn.latLngToCoords=qt,sn.latLngsToCoords=Gt,sn.getFeature=Kt,sn.asFeature=Yt,be.mergeOptions({boxZoom:!0});var bn=Ee.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane,this._resetStateTimeout=0,t.on("unload",this._destroy,this)},addHooks:function(){mt(this._container,"mousedown",this._onMouseDown,this)},removeHooks:function(){ft(this._container,"mousedown",this._onMouseDown,this)},moved:function(){return this._moved},_destroy:function(){K(this._pane),delete this._pane},_resetState:function(){this._resetStateTimeout=0,this._moved=!1},_clearDeferredResetState:function(){0!==this._resetStateTimeout&&(clearTimeout(this._resetStateTimeout),this._resetStateTimeout=0)},_onMouseDown:function(t){if(!t.shiftKey||1!==t.which&&1!==t.button)return!1;this._clearDeferredResetState(),this._resetState(),fi(),ut(),this._startPoint=this._map.mouseEventToContainerPoint(t),mt(document,{contextmenu:Lt,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseMove:function(t){this._moved||(this._moved=!0,this._box=G("div","leaflet-zoom-box",this._container),Q(this._container,"leaflet-crosshair"),this._map.fire("boxzoomstart")),this._point=this._map.mouseEventToContainerPoint(t);var i=new P(this._point,this._startPoint),e=i.getSize();at(this._box,i.min),this._box.style.width=e.x+"px",this._box.style.height=e.y+"px"},_finish:function(){this._moved&&(K(this._box),tt(this._container,"leaflet-crosshair")),gi(),lt(),ft(document,{contextmenu:Lt,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseUp:function(t){if((1===t.which||1===t.button)&&(this._finish(),this._moved)){this._clearDeferredResetState(),this._resetStateTimeout=setTimeout(e(this._resetState,this),0);var i=new T(this._map.containerPointToLatLng(this._startPoint),this._map.containerPointToLatLng(this._point));this._map.fitBounds(i).fire("boxzoomend",{boxZoomBounds:i})}},_onKeyDown:function(t){27===t.keyCode&&this._finish()}});be.addInitHook("addHandler","boxZoom",bn),be.mergeOptions({doubleClickZoom:!0});var Tn=Ee.extend({addHooks:function(){this._map.on("dblclick",this._onDoubleClick,this)},removeHooks:function(){this._map.off("dblclick",this._onDoubleClick,this)},_onDoubleClick:function(t){var i=this._map,e=i.getZoom(),n=i.options.zoomDelta,o=t.originalEvent.shiftKey?e-n:e+n;"center"===i.options.doubleClickZoom?i.setZoom(o):i.setZoomAround(t.containerPoint,o)}});be.addInitHook("addHandler","doubleClickZoom",Tn),be.mergeOptions({dragging:!0,inertia:!Mi,inertiaDeceleration:3400,inertiaMaxSpeed:1/0,easeLinearity:.2,worldCopyJump:!1,maxBoundsViscosity:0});var zn=Ee.extend({addHooks:function(){if(!this._draggable){var t=this._map;this._draggable=new Re(t._mapPane,t._container),this._draggable.on({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this),this._draggable.on("predrag",this._onPreDragLimit,this),t.options.worldCopyJump&&(this._draggable.on("predrag",this._onPreDragWrap,this),t.on("zoomend",this._onZoomEnd,this),t.whenReady(this._onZoomEnd,this))}Q(this._map._container,"leaflet-grab leaflet-touch-drag"),this._draggable.enable(),this._positions=[],this._times=[]},removeHooks:function(){tt(this._map._container,"leaflet-grab"),tt(this._map._container,"leaflet-touch-drag"),this._draggable.disable()},moved:function(){return this._draggable&&this._draggable._moved},moving:function(){return this._draggable&&this._draggable._moving},_onDragStart:function(){var t=this._map;if(t._stop(),this._map.options.maxBounds&&this._map.options.maxBoundsViscosity){var i=z(this._map.options.maxBounds);this._offsetLimit=b(this._map.latLngToContainerPoint(i.getNorthWest()).multiplyBy(-1),this._map.latLngToContainerPoint(i.getSouthEast()).multiplyBy(-1).add(this._map.getSize())),this._viscosity=Math.min(1,Math.max(0,this._map.options.maxBoundsViscosity))}else this._offsetLimit=null;t.fire("movestart").fire("dragstart"),t.options.inertia&&(this._positions=[],this._times=[])},_onDrag:function(t){if(this._map.options.inertia){var i=this._lastTime=+new Date,e=this._lastPos=this._draggable._absPos||this._draggable._newPos;this._positions.push(e),this._times.push(i),this._prunePositions(i)}this._map.fire("move",t).fire("drag",t)},_prunePositions:function(t){for(;this._positions.length>1&&t-this._times[0]>50;)this._positions.shift(),this._times.shift()},_onZoomEnd:function(){var t=this._map.getSize().divideBy(2),i=this._map.latLngToLayerPoint([0,0]);this._initialWorldOffset=i.subtract(t).x,this._worldWidth=this._map.getPixelWorldBounds().getSize().x},_viscousLimit:function(t,i){return t-(t-i)*this._viscosity},_onPreDragLimit:function(){if(this._viscosity&&this._offsetLimit){var t=this._draggable._newPos.subtract(this._draggable._startPos),i=this._offsetLimit;t.x<i.min.x&&(t.x=this._viscousLimit(t.x,i.min.x)),t.y<i.min.y&&(t.y=this._viscousLimit(t.y,i.min.y)),t.x>i.max.x&&(t.x=this._viscousLimit(t.x,i.max.x)),t.y>i.max.y&&(t.y=this._viscousLimit(t.y,i.max.y)),this._draggable._newPos=this._draggable._startPos.add(t)}},_onPreDragWrap:function(){var t=this._worldWidth,i=Math.round(t/2),e=this._initialWorldOffset,n=this._draggable._newPos.x,o=(n-i+e)%t+i-e,s=(n+i+e)%t-i-e,r=Math.abs(o+e)<Math.abs(s+e)?o:s;this._draggable._absPos=this._draggable._newPos.clone(),this._draggable._newPos.x=r},_onDragEnd:function(t){var i=this._map,e=i.options,n=!e.inertia||this._times.length<2;if(i.fire("dragend",t),n)i.fire("moveend");else{this._prunePositions(+new Date);var o=this._lastPos.subtract(this._positions[0]),s=(this._lastTime-this._times[0])/1e3,r=e.easeLinearity,a=o.multiplyBy(r/s),h=a.distanceTo([0,0]),u=Math.min(e.inertiaMaxSpeed,h),l=a.multiplyBy(u/h),c=u/(e.inertiaDeceleration*r),_=l.multiplyBy(-c/2).round();_.x||_.y?(_=i._limitOffset(_,i.options.maxBounds),f(function(){i.panBy(_,{duration:c,easeLinearity:r,noMoveStart:!0,animate:!0})})):i.fire("moveend")}}});be.addInitHook("addHandler","dragging",zn),be.mergeOptions({keyboard:!0,keyboardPanDelta:80});var Mn=Ee.extend({keyCodes:{left:[37],right:[39],down:[40],up:[38],zoomIn:[187,107,61,171],zoomOut:[189,109,54,173]},initialize:function(t){this._map=t,this._setPanDelta(t.options.keyboardPanDelta),this._setZoomDelta(t.options.zoomDelta)},addHooks:function(){var t=this._map._container;t.tabIndex<=0&&(t.tabIndex="0"),mt(t,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.on({focus:this._addHooks,blur:this._removeHooks},this)},removeHooks:function(){this._removeHooks(),ft(this._map._container,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.off({focus:this._addHooks,blur:this._removeHooks},this)},_onMouseDown:function(){if(!this._focused){var t=document.body,i=document.documentElement,e=t.scrollTop||i.scrollTop,n=t.scrollLeft||i.scrollLeft;this._map._container.focus(),window.scrollTo(n,e)}},_onFocus:function(){this._focused=!0,this._map.fire("focus")},_onBlur:function(){this._focused=!1,this._map.fire("blur")},_setPanDelta:function(t){var i,e,n=this._panKeys={},o=this.keyCodes;for(i=0,e=o.left.length;i<e;i++)n[o.left[i]]=[-1*t,0];for(i=0,e=o.right.length;i<e;i++)n[o.right[i]]=[t,0];for(i=0,e=o.down.length;i<e;i++)n[o.down[i]]=[0,t];for(i=0,e=o.up.length;i<e;i++)n[o.up[i]]=[0,-1*t]},_setZoomDelta:function(t){var i,e,n=this._zoomKeys={},o=this.keyCodes;for(i=0,e=o.zoomIn.length;i<e;i++)n[o.zoomIn[i]]=t;for(i=0,e=o.zoomOut.length;i<e;i++)n[o.zoomOut[i]]=-t},_addHooks:function(){mt(document,"keydown",this._onKeyDown,this)},_removeHooks:function(){ft(document,"keydown",this._onKeyDown,this)},_onKeyDown:function(t){if(!(t.altKey||t.ctrlKey||t.metaKey)){var i,e=t.keyCode,n=this._map;if(e in this._panKeys)n._panAnim&&n._panAnim._inProgress||(i=this._panKeys[e],t.shiftKey&&(i=w(i).multiplyBy(3)),n.panBy(i),n.options.maxBounds&&n.panInsideBounds(n.options.maxBounds));else if(e in this._zoomKeys)n.setZoom(n.getZoom()+(t.shiftKey?3:1)*this._zoomKeys[e]);else{if(27!==e||!n._popup||!n._popup.options.closeOnEscapeKey)return;n.closePopup()}Lt(t)}}});be.addInitHook("addHandler","keyboard",Mn),be.mergeOptions({scrollWheelZoom:!0,wheelDebounceTime:40,wheelPxPerZoomLevel:60});var Cn=Ee.extend({addHooks:function(){mt(this._map._container,"mousewheel",this._onWheelScroll,this),this._delta=0},removeHooks:function(){ft(this._map._container,"mousewheel",this._onWheelScroll,this)},_onWheelScroll:function(t){var i=Tt(t),n=this._map.options.wheelDebounceTime;this._delta+=i,this._lastMousePos=this._map.mouseEventToContainerPoint(t),this._startTime||(this._startTime=+new Date);var o=Math.max(n-(+new Date-this._startTime),0);clearTimeout(this._timer),this._timer=setTimeout(e(this._performZoom,this),o),Lt(t)},_performZoom:function(){var t=this._map,i=t.getZoom(),e=this._map.options.zoomSnap||0;t._stop();var n=this._delta/(4*this._map.options.wheelPxPerZoomLevel),o=4*Math.log(2/(1+Math.exp(-Math.abs(n))))/Math.LN2,s=e?Math.ceil(o/e)*e:o,r=t._limitZoom(i+(this._delta>0?s:-s))-i;this._delta=0,this._startTime=null,r&&("center"===t.options.scrollWheelZoom?t.setZoom(i+r):t.setZoomAround(this._lastMousePos,i+r))}});be.addInitHook("addHandler","scrollWheelZoom",Cn),be.mergeOptions({tap:!0,tapTolerance:15});var Sn=Ee.extend({addHooks:function(){mt(this._map._container,"touchstart",this._onDown,this)},removeHooks:function(){ft(this._map._container,"touchstart",this._onDown,this)},_onDown:function(t){if(t.touches){if(Pt(t),this._fireClick=!0,t.touches.length>1)return this._fireClick=!1,void clearTimeout(this._holdTimeout);var i=t.touches[0],n=i.target;this._startPos=this._newPos=new x(i.clientX,i.clientY),n.tagName&&"a"===n.tagName.toLowerCase()&&Q(n,"leaflet-active"),this._holdTimeout=setTimeout(e(function(){this._isTapValid()&&(this._fireClick=!1,this._onUp(),this._simulateEvent("contextmenu",i))},this),1e3),this._simulateEvent("mousedown",i),mt(document,{touchmove:this._onMove,touchend:this._onUp},this)}},_onUp:function(t){if(clearTimeout(this._holdTimeout),ft(document,{touchmove:this._onMove,touchend:this._onUp},this),this._fireClick&&t&&t.changedTouches){var i=t.changedTouches[0],e=i.target;e&&e.tagName&&"a"===e.tagName.toLowerCase()&&tt(e,"leaflet-active"),this._simulateEvent("mouseup",i),this._isTapValid()&&this._simulateEvent("click",i)}},_isTapValid:function(){return this._newPos.distanceTo(this._startPos)<=this._map.options.tapTolerance},_onMove:function(t){var i=t.touches[0];this._newPos=new x(i.clientX,i.clientY),this._simulateEvent("mousemove",i)},_simulateEvent:function(t,i){var e=document.createEvent("MouseEvents");e._simulated=!0,i.target._simulatedClick=!0,e.initMouseEvent(t,!0,!0,window,1,i.screenX,i.screenY,i.clientX,i.clientY,!1,!1,!1,!1,0,null),i.target.dispatchEvent(e)}});qi&&!Vi&&be.addInitHook("addHandler","tap",Sn),be.mergeOptions({touchZoom:qi&&!Mi,bounceAtZoomLimits:!0});var Zn=Ee.extend({addHooks:function(){Q(this._map._container,"leaflet-touch-zoom"),mt(this._map._container,"touchstart",this._onTouchStart,this)},removeHooks:function(){tt(this._map._container,"leaflet-touch-zoom"),ft(this._map._container,"touchstart",this._onTouchStart,this)},_onTouchStart:function(t){var i=this._map;if(t.touches&&2===t.touches.length&&!i._animatingZoom&&!this._zooming){var e=i.mouseEventToContainerPoint(t.touches[0]),n=i.mouseEventToContainerPoint(t.touches[1]);this._centerPoint=i.getSize()._divideBy(2),this._startLatLng=i.containerPointToLatLng(this._centerPoint),"center"!==i.options.touchZoom&&(this._pinchStartLatLng=i.containerPointToLatLng(e.add(n)._divideBy(2))),this._startDist=e.distanceTo(n),this._startZoom=i.getZoom(),this._moved=!1,this._zooming=!0,i._stop(),mt(document,"touchmove",this._onTouchMove,this),mt(document,"touchend",this._onTouchEnd,this),Pt(t)}},_onTouchMove:function(t){if(t.touches&&2===t.touches.length&&this._zooming){var i=this._map,n=i.mouseEventToContainerPoint(t.touches[0]),o=i.mouseEventToContainerPoint(t.touches[1]),s=n.distanceTo(o)/this._startDist;if(this._zoom=i.getScaleZoom(s,this._startZoom),!i.options.bounceAtZoomLimits&&(this._zoom<i.getMinZoom()&&s<1||this._zoom>i.getMaxZoom()&&s>1)&&(this._zoom=i._limitZoom(this._zoom)),"center"===i.options.touchZoom){if(this._center=this._startLatLng,1===s)return}else{var r=n._add(o)._divideBy(2)._subtract(this._centerPoint);if(1===s&&0===r.x&&0===r.y)return;this._center=i.unproject(i.project(this._pinchStartLatLng,this._zoom).subtract(r),this._zoom)}this._moved||(i._moveStart(!0,!1),this._moved=!0),g(this._animRequest);var a=e(i._move,i,this._center,this._zoom,{pinch:!0,round:!1});this._animRequest=f(a,this,!0),Pt(t)}},_onTouchEnd:function(){this._moved&&this._zooming?(this._zooming=!1,g(this._animRequest),ft(document,"touchmove",this._onTouchMove),ft(document,"touchend",this._onTouchEnd),this._map.options.zoomAnimation?this._map._animateZoom(this._center,this._map._limitZoom(this._zoom),!0,this._map.options.zoomSnap):this._map._resetView(this._center,this._map._limitZoom(this._zoom))):this._zooming=!1}});be.addInitHook("addHandler","touchZoom",Zn),be.BoxZoom=bn,be.DoubleClickZoom=Tn,be.Drag=zn,be.Keyboard=Mn,be.ScrollWheelZoom=Cn,be.Tap=Sn,be.TouchZoom=Zn,Object.freeze=ti,t.version="1.3.3",t.Control=Te,t.control=ze,t.Browser=Qi,t.Evented=ci,t.Mixin=Ae,t.Util=ui,t.Class=v,t.Handler=Ee,t.extend=i,t.bind=e,t.stamp=n,t.setOptions=l,t.DomEvent=Pe,t.DomUtil=ve,t.PosAnimation=Le,t.Draggable=Re,t.LineUtil=Ne,t.PolyUtil=De,t.Point=x,t.point=w,t.Bounds=P,t.bounds=b,t.Transformation=S,t.transformation=Z,t.Projection=He,t.LatLng=M,t.latLng=C,t.LatLngBounds=T,t.latLngBounds=z,t.CRS=di,t.GeoJSON=sn,t.geoJSON=Xt,t.geoJson=an,t.Layer=qe,t.LayerGroup=Ge,t.layerGroup=function(t,i){return new Ge(t,i)},t.FeatureGroup=Ke,t.featureGroup=function(t){return new Ke(t)},t.ImageOverlay=hn,t.imageOverlay=function(t,i,e){return new hn(t,i,e)},t.VideoOverlay=un,t.videoOverlay=function(t,i,e){return new un(t,i,e)},t.DivOverlay=ln,t.Popup=cn,t.popup=function(t,i){return new cn(t,i)},t.Tooltip=_n,t.tooltip=function(t,i){return new _n(t,i)},t.Icon=Ye,t.icon=function(t){return new Ye(t)},t.DivIcon=dn,t.divIcon=function(t){return new dn(t)},t.Marker=$e,t.marker=function(t,i){return new $e(t,i)},t.TileLayer=mn,t.tileLayer=Jt,t.GridLayer=pn,t.gridLayer=function(t){return new pn(t)},t.SVG=Pn,t.svg=Qt,t.Renderer=gn,t.Canvas=vn,t.canvas=$t,t.Path=Qe,t.CircleMarker=tn,t.circleMarker=function(t,i){return new tn(t,i)},t.Circle=en,t.circle=function(t,i,e){return new en(t,i,e)},t.Polyline=nn,t.polyline=function(t,i){return new nn(t,i)},t.Polygon=on,t.polygon=function(t,i){return new on(t,i)},t.Rectangle=Ln,t.rectangle=function(t,i){return new Ln(t,i)},t.Map=be,t.map=function(t,i){return new be(t,i)};var En=window.L;t.noConflict=function(){return window.L=En,this},window.L=t});

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.13
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.13",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess,

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName){
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			if (split[5]) {
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		return !!(m._a && (m._tzm === undefined));
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.offset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	loadData({
		"version": "2017b",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
			"Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
			"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
			"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5",
			"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4",
			"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5",
			"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4",
			"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
			"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
			"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
			"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0",
			"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0",
			"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0",
			"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0",
			"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
			"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0",
			"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0",
			"America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
			"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
			"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
			"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
			"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
			"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
			"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
			"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
			"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
			"America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4",
			"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
			"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
			"America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
			"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
			"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
			"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
			"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
			"America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
			"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
			"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
			"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
			"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0",
			"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
			"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
			"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6",
			"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
			"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
			"Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
			"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
			"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
			"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
			"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
			"Asia/Kolkata|HMT +0630 IST|-5R.k -6u -5u|01212|-18LFR.k 1unn.k HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
			"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0",
			"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5",
			"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
			"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
			"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
			"Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4",
			"Asia/Rangoon|RMT +0630 +09|-6o.E -6u -90|0121|-21Jio.E SmnS.E 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
			"Atlantic/South_Georgia|-02|20|0||30",
			"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
			"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
			"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"EST|EST|50|0|",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Etc/GMT+0|GMT|0|0|",
			"Etc/GMT+1|-01|10|0|",
			"Etc/GMT+10|-10|a0|0|",
			"Etc/GMT+11|-11|b0|0|",
			"Etc/GMT+12|-12|c0|0|",
			"Etc/GMT+3|-03|30|0|",
			"Etc/GMT+4|-04|40|0|",
			"Etc/GMT+5|-05|50|0|",
			"Etc/GMT+6|-06|60|0|",
			"Etc/GMT+7|-07|70|0|",
			"Etc/GMT+8|-08|80|0|",
			"Etc/GMT+9|-09|90|0|",
			"Etc/GMT-1|+01|-10|0|",
			"Pacific/Port_Moresby|+10|-a0|0||25e4",
			"Pacific/Pohnpei|+11|-b0|0||34e3",
			"Pacific/Tarawa|+12|-c0|0||29e3",
			"Etc/GMT-13|+13|-d0|0|",
			"Etc/GMT-14|+14|-e0|0|",
			"Etc/GMT-2|+02|-20|0|",
			"Etc/GMT-3|+03|-30|0|",
			"Etc/GMT-4|+04|-40|0|",
			"Etc/GMT-5|+05|-50|0|",
			"Etc/GMT-6|+06|-60|0|",
			"Indian/Christmas|+07|-70|0||21e2",
			"Etc/GMT-8|+08|-80|0|",
			"Pacific/Palau|+09|-90|0||21e3",
			"Etc/UCT|UCT|0|0|",
			"Etc/UTC|UTC|0|0|",
			"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
			"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
			"Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
			"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
			"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
			"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
			"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
			"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
			"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
			"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
			"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
			"HST|HST|a0|0|",
			"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Cocos|+0630|-6u|0||596",
			"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
			"Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
			"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
			"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
			"Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"MST|MST|70|0|",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
			"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1",
			"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
			"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4",
			"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
			"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4",
			"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4",
			"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2",
			"Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2",
			"Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3",
			"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
			"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3",
			"Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
			"Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4",
			"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
			"Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"
		],
		"links": [
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Sao_Tome",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Khartoum|Africa/Juba",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Atikokan|America/Coral_Harbour",
			"America/Chicago|US/Central",
			"America/Curacao|America/Aruba",
			"America/Curacao|America/Kralendijk",
			"America/Curacao|America/Lower_Princes",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Cayman",
			"America/Phoenix|US/Arizona",
			"America/Port_of_Spain|America/Anguilla",
			"America/Port_of_Spain|America/Antigua",
			"America/Port_of_Spain|America/Dominica",
			"America/Port_of_Spain|America/Grenada",
			"America/Port_of_Spain|America/Guadeloupe",
			"America/Port_of_Spain|America/Marigot",
			"America/Port_of_Spain|America/Montserrat",
			"America/Port_of_Spain|America/St_Barthelemy",
			"America/Port_of_Spain|America/St_Kitts",
			"America/Port_of_Spain|America/St_Lucia",
			"America/Port_of_Spain|America/St_Thomas",
			"America/Port_of_Spain|America/St_Vincent",
			"America/Port_of_Spain|America/Tortola",
			"America/Port_of_Spain|America/Virgin",
			"America/Regina|Canada/East-Saskatchewan",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Atlantic/Reykjavik|Iceland",
			"Atlantic/South_Georgia|Etc/GMT+2",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT+0|Etc/GMT",
			"Etc/GMT+0|Etc/GMT-0",
			"Etc/GMT+0|Etc/GMT0",
			"Etc/GMT+0|Etc/Greenwich",
			"Etc/GMT+0|GMT",
			"Etc/GMT+0|GMT+0",
			"Etc/GMT+0|GMT-0",
			"Etc/GMT+0|GMT0",
			"Etc/GMT+0|Greenwich",
			"Etc/UCT|UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Oslo|Arctic/Longyearbyen",
			"Europe/Oslo|Atlantic/Jan_Mayen",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Indian/Christmas|Etc/GMT-7",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Palau|Etc/GMT-9",
			"Pacific/Pohnpei|Etc/GMT-11",
			"Pacific/Pohnpei|Pacific/Ponape",
			"Pacific/Port_Moresby|Etc/GMT-10",
			"Pacific/Port_Moresby|Pacific/Chuuk",
			"Pacific/Port_Moresby|Pacific/Truk",
			"Pacific/Port_Moresby|Pacific/Yap",
			"Pacific/Tarawa|Etc/GMT-12",
			"Pacific/Tarawa|Pacific/Funafuti",
			"Pacific/Tarawa|Pacific/Wake",
			"Pacific/Tarawa|Pacific/Wallis"
		]
	});


	return moment;
}));


/***/ }),
/* 1546 */,
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appView = __webpack_require__(2895);

var _appView2 = _interopRequireDefault(_appView);

__webpack_require__(2914);

__webpack_require__(2913);

__webpack_require__(2903);

__webpack_require__(2904);

__webpack_require__(2905);

__webpack_require__(3164);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appComponent = {
  template: _appView2.default,
  restrict: 'E'
};

exports.default = appComponent;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var faviconsContext = __webpack_require__(543);
faviconsContext.keys().forEach(faviconsContext);

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  Leaflet.AwesomeNumberMarkers, a plugin that adds number markers for Leaflet

  http://leafletjs.com
  https://github.com/zahidul-islam
*/

/*global L*/

(function () {
  "use strict";

  L.AwesomeNumberMarkers = L.Icon.extend({
    options: {
      iconSize: [35, 45],
      iconAnchor: [17, 42],
      popupAnchor: [1, -32],
      className: 'awesome-number-marker',
      icon: 'home',
      markerColor: 'blue',
      numberColor: 'white',
      number: ''
    },

    createIcon: function createIcon() {

      var div = document.createElement('div'),
          options = this.options;

      div.innerHTML = this._createInner();
      this._setIconStyles(div, 'icon-' + options.markerColor);

      return div;
    },

    _createInner: function _createInner() {
      var iconColorStyle = "",
          options = this.options;

      if (options.numberColor) {
        iconColorStyle = "style='color: " + options.numberColor + "' ";
      }

      return "<i " + iconColorStyle + "><b>" + options.number + "</b></i>";
    },

    _setIconStyles: function _setIconStyles(img, name) {
      var options = this.options,
          size = L.point(options['iconSize']),
          anchor = L.point(options.iconAnchor);

      img.className = 'awesome-number-marker-' + name + ' ' + options.className;

      if (anchor) {
        img.style.marginLeft = -anchor.x + 'px';
        img.style.marginTop = -anchor.y + 'px';
      }

      if (size) {
        img.style.width = size.x + 'px';
        img.style.height = size.y + 'px';
      }
    }
  });
})();

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AllowOnlyScanDirective = [function () {
  return {
    restrict: "A",
    require: {
      ngModel: "ngModel"
    },
    link: function link(scope, element, attrs, controller) {
      var timerHandle = null;
      var DEFAULT_TIME_LIMIT = 700;
      var MAX_ALLOWED_LIMIT = 2000;
      var TIME_LIMIT = attrs.timeLimit ? Math.min(attrs.timeLimit, MAX_ALLOWED_LIMIT) : DEFAULT_TIME_LIMIT;

      var startTimer = function startTimer() {
        timerHandle = setTimeout(function () {
          var modelValue = "";

          controller.ngModel.$$rawModelValue = modelValue;
          controller.ngModel.$viewValue = modelValue;
          controller.ngModel.$commitViewValue();
          controller.ngModel.$render();

          timerHandle = null;
        }, TIME_LIMIT);
      };

      element.on("keypress", function (event) {
        if (timerHandle === null) {
          startTimer();
        }
      });
    }
  };
}];

exports.default = AllowOnlyScanDirective;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _allowOnlyScan = __webpack_require__(1550);

var _allowOnlyScan2 = _interopRequireDefault(_allowOnlyScan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AllowOnlyScanModule = _angular2.default.module('allow-only-scan-module', []).directive('allowOnlyScan', _allowOnlyScan2.default).name;

exports.default = AllowOnlyScanModule;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _auth = __webpack_require__(523);

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authModule = _angular2.default.module('auth', []).factory('Auth', _auth2.default).name;

exports.default = authModule;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var AutoCapitalizeDirective = function AutoCapitalizeDirective() {
    return {
        restrict: 'A',
        require: {
            ngModel: 'ngModel'
        },
        link: function link(scope, element, attrs, controller) {

            var capitalized = void 0;

            var capitalize = function capitalize(inputValue) {
                if (!inputValue) return inputValue = '';
                if (inputValue) capitalized = inputValue.toUpperCase();

                if (capitalized !== inputValue) {
                    // see where the cursor is before the update so that we can set it back
                    var selection = element[0].selectionStart;
                    controller.ngModel.$setViewValue(capitalized);
                    controller.ngModel.$render();
                    // set back the cursor after rendering
                    element[0].selectionStart = selection;
                    element[0].selectionEnd = selection;
                }
                return capitalized;
            };

            controller.ngModel.$parsers.push(capitalize);
            capitalize(scope[attrs.ngModel]); // capitalize initial value
        }
    };
};

exports.default = AutoCapitalizeDirective;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _capitalize = __webpack_require__(1553);

var _capitalize2 = _interopRequireDefault(_capitalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoCapitalizeModule = _angular2.default.module('auto-capitalize-module', []).directive('capitalize', _capitalize2.default).name;

exports.default = AutoCapitalizeModule;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BranchFactory = function BranchFactory($rootScope, SetupService, Auth, $q, Modal) {
  var getBranchDetails = function getBranchDetails(branchId) {
    var defer = $q.defer();
    SetupService.get(branchId).then(function (setup) {
      return defer.resolve(setup);
    }).catch(function (err) {
      if (err && err.data && err.data.message) {
        Modal.errorModal('error.' + err.data.message);
      }
      return defer.resolve(err);
    });
    return defer.promise;
  };

  return {
    getBranchDetails: getBranchDetails
  };
};

BranchFactory.$inject = ['$rootScope', 'SetupService', 'Auth', '$q', 'Modal'];

exports.default = BranchFactory;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _branch = __webpack_require__(1555);

var _branch2 = _interopRequireDefault(_branch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchModule = _angular2.default.module('app.branch', []).factory('Branch', _branch2.default).name;

exports.default = branchModule;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var configsFactory = function configsFactory($q, HomeService) {
    var _this = this;

    var getConfigs = function getConfigs() {
        var defer = $q.defer();
        HomeService.configs().then(function (res) {
            return defer.resolve(res);
        });
        return defer.promise;
    };

    var setEnvironmentConfig = function setEnvironmentConfig(obj) {
        _this.UIConfig = obj;
    };

    var getEnvironmentConfig = function getEnvironmentConfig() {
        return _this.UIConfig;
    };

    var setPermissionConfig = function setPermissionConfig(obj) {
        _this.permissionConfig = obj;
    };

    var getPermissionConfig = function getPermissionConfig() {
        return _this.permissionConfig;
    };

    return {
        getConfigs: getConfigs,
        setEnvironmentConfig: setEnvironmentConfig,
        getEnvironmentConfig: getEnvironmentConfig,
        setPermissionConfig: setPermissionConfig,
        getPermissionConfig: getPermissionConfig
    };
};

configsFactory.$inject = ['$q', 'HomeService'];

exports.default = configsFactory;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _configs = __webpack_require__(1557);

var _configs2 = _interopRequireDefault(_configs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfigsModule = _angular2.default.module('app.configs', []).factory('Configs', _configs2.default).name;

exports.default = ConfigsModule;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _connectionStatus = __webpack_require__(2492);

var _connectionStatus2 = _interopRequireDefault(_connectionStatus);

__webpack_require__(2915);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConnectionStatusDirective = ['$window', '$timeout', '$rootScope', function ($window, $timeout, $rootScope) {
    return {
        restrict: 'E',
        templateUrl: 'connection-status.html',
        link: function link(scope, element, attrs, controller) {
            var clearMessage = null;

            var initListeners = function initListeners() {
                $rootScope.$on('ServerError', function () {
                    $timeout(function () {
                        return scope.connectionStatus = 'offline';
                    });
                });

                $window.addEventListener("offline", function () {
                    $timeout(function () {
                        return scope.connectionStatus = 'offline';
                    });
                }, false);

                $window.addEventListener("online", function () {
                    $timeout(function () {
                        scope.connectionStatus = 'online';
                        scope.startClearTimer();
                    });
                });
            };

            scope.startClearTimer = function () {
                clearMessage = $timeout(function () {
                    scope.connectionStatus = '';
                }, 3000);
            };

            scope.cancelClearTimer = function () {
                if (clearMessage) {
                    $timeout.cancel(clearMessage);
                }
            };

            scope.refresh = function () {
                $window.location.reload();
            };

            initListeners();
        }
    };
}];

exports.default = ConnectionStatusDirective;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _connectionStatus = __webpack_require__(1559);

var _connectionStatus2 = _interopRequireDefault(_connectionStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConnectionStatusModule = _angular2.default.module('connection-status-module', []).directive('connectionStatus', _connectionStatus2.default).name;

exports.default = ConnectionStatusModule;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var DataCounterFactory = function DataCounterFactory($translate) {
    var locationHoldcount = null;
    var itemHoldcounts = null;
    var remainingToPack = null;
    var atmCodeData = null;
    var allData = null;

    var setCounterForLocationHold = function setCounterForLocationHold(data) {
        locationHoldcount = data;
    };

    var getCounterForLocationHold = function getCounterForLocationHold() {
        return locationHoldcount;
    };

    var setCounterForItemHold = function setCounterForItemHold(data) {
        itemHoldcounts = data;
    };

    var getCounterForItemHold = function getCounterForItemHold() {
        return itemHoldcounts;
    };

    var setPendingPackData = function setPendingPackData(data) {
        remainingToPack = data;
    };

    var getPendingPackData = function getPendingPackData() {
        return remainingToPack;
    };

    var setAtmCodeData = function setAtmCodeData(data) {
        atmCodeData = data;
    };

    var getAtmCodeData = function getAtmCodeData() {
        return atmCodeData;
    };

    var setData = function setData(data) {
        // common method for all
        return allData = data;
    };

    var getData = function getData(data) {
        // common method for all
        return allData;
    };

    return {
        setCounterForLocationHold: setCounterForLocationHold,
        getCounterForLocationHold: getCounterForLocationHold,
        setCounterForItemHold: setCounterForItemHold,
        getCounterForItemHold: getCounterForItemHold,
        setPendingPackData: setPendingPackData,
        getPendingPackData: getPendingPackData,
        setAtmCodeData: setAtmCodeData,
        getAtmCodeData: getAtmCodeData,
        getData: getData,
        setData: setData
    };
};

DataCounterFactory.$inject = ['$translate'];

exports.default = DataCounterFactory;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _datacounter = __webpack_require__(1561);

var _datacounter2 = _interopRequireDefault(_datacounter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataCounterModule = _angular2.default.module('app.data-counter', []).factory('DataCounter', _datacounter2.default).name;

exports.default = dataCounterModule;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var DateUtilFactory = function DateUtilFactory($translate) {
    var date = null;

    var getUTCDate = function getUTCDate(date) {
        var ISOString = moment(date).toISOString();
        var DATE_STRING_LENGTH = 10; // length of 'YYYY-MM-DD' format

        return ISOString.substr(0, DATE_STRING_LENGTH);
    };

    var convertToDate = function convertToDate(date) {
        var ISOString = moment(date).toISOString();
        var DATE_STRING_LENGTH = 10; // length of 'YYYY-MM-DD' format

        var dateString = ISOString.substr(0, DATE_STRING_LENGTH);
        return moment(dateString).toDate();
    };
    var convertToUTCDate = function convertToUTCDate(date) {
        var ISOString = moment.utc(date).toISOString();
        var DATE_STRING_LENGTH = 10; // length of 'YYYY-MM-DD' format

        var dateString = ISOString.substr(0, DATE_STRING_LENGTH);
        return moment.utc(dateString).toDate();
    };

    var convertTime = function convertTime(time) {
        var isUTC = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        // UTC time
        if (!time) {
            return time;
        }

        time = time.split(':');

        var d = new Date();

        d.setUTCHours(+time[0]);
        d.setUTCMinutes(time[1]);
        d.setUTCSeconds(0);
        d.setUTCMilliseconds(0);

        return isUTC ? moment.utc(d).format('hh:mm A') : moment(d).format('hh:mm A');
    };

    var convetToBrowserTimezone = function convetToBrowserTimezone(date) {
        var isDisplaySec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var browserTimezone = moment.tz.guess(); // get the browsers current time zone.
        var abbreviation = moment().tz(browserTimezone).format('z'); // abbreviation of browserTimezone
        var convertDate = isDisplaySec ? moment.tz(date, browserTimezone).format('YYYY-MM-DD | hh:mm:ss A') : moment.tz(date, browserTimezone).format('YYYY-MM-DD | hh:mm A'); // convert date to specific timezone
        var dateString = convertDate.concat(' ', abbreviation);
        return dateString;
    };

    // calculate hours, minutes, seconds between two date
    var calculateDuration = function calculateDuration(startDate, endDate) {
        var ms = moment(endDate).diff(startDate);
        var duration = moment.duration(ms);
        return Math.floor(duration.asHours()) + moment.utc(ms).format(":mm:ss");
    };

    var convertDateTime = function convertDateTime(date, timezone, dateFormat) {
        if (!date) return;
        return moment.tz(date, timezone).format(dateFormat);
    };

    var getTime = function getTime(time) {
        if (!time) {
            return time;
        }

        time = time.split(':');

        var d = new Date();

        d.setHours(+time[0]);
        d.setMinutes(time[1]);
        d.setSeconds(0);
        d.setMilliseconds(0);

        return d;
    };

    var convertToTimeFormat = function convertToTimeFormat(durationString) {
        if (!durationString) return;
        var hoursMatch = durationString.match(/(\d+)\s*hour/);
        var minutesMatch = durationString.match(/(\d+)\s*minute/);
        var secondsMatch = durationString.match(/(\d+)\s*second/);

        var hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
        var minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;
        var seconds = secondsMatch ? parseInt(secondsMatch[1], 10) : 0;

        var pad = function pad(n) {
            return String(n).padStart(2, '0');
        };
        return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    };

    var getTZFormattedDate = function getTZFormattedDate(date, timezone) {
        var dateFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'YYYY-MM-DD';

        if (!date) return;

        var targetTz = timezone || moment.tz.guess();
        var utcMoment = moment.utc(date);
        var isMidnight = utcMoment.hours() === 0 && utcMoment.minutes() === 0 && utcMoment.seconds() === 0;

        var formattedDate = void 0;

        if (isMidnight) {
            formattedDate = utcMoment.format(dateFormat);
        } else {
            formattedDate = utcMoment.tz(targetTz).format(dateFormat);
        }

        return formattedDate + 'T00:00:00Z';
    };

    return {
        getUTCDate: getUTCDate,
        convertToDate: convertToDate,
        convertToUTCDate: convertToUTCDate,
        convertTime: convertTime,
        convetToBrowserTimezone: convetToBrowserTimezone,
        calculateDuration: calculateDuration,
        convertDateTime: convertDateTime,
        getTime: getTime,
        getTZFormattedDate: getTZFormattedDate,
        convertToTimeFormat: convertToTimeFormat
    };
};

DateUtilFactory.$inject = ['$translate'];

exports.default = DateUtilFactory;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _dateUtil = __webpack_require__(1563);

var _dateUtil2 = _interopRequireDefault(_dateUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateUtilModule = _angular2.default.module('app.date-util', []).factory('DateUtil', _dateUtil2.default).name;

exports.default = DateUtilModule;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var denomIconDirective = function denomIconDirective($templateCache, DenominationService) {
    'ngInject';

    return {
        restrict: 'E',
        scope: {
            denomId: '=',
            label: '@',
            iconSize: '@'
        },
        template: '\n            <span class="denom-icon-wrapper" \n                  uib-popover-template="\'denomPopover.html\'" \n                  popover-trigger="\'mouseenter\'" \n                  popover-is-open="isOpen"\n                  ng-click="isOpen = false"\n                  popover-append-to-body="true" \n                  popover-placement="auto top" \n                  popover-class="denom-icon-popover-window">\n                <span ng-if="label" ng-style="iconSize ? {\'font-size\': iconSize + \'px\'} : {}">{{label}}</span>\n                <img ng-if="!label" ng-src="assets/images/{{denomId == \'1\' ? \'$1c\' : denomId}}.png" class="denom-icon-sm" ng-style="iconSize ? {\'width\': iconSize + \'px\'} : {}" />\n            </span>\n        ',
        link: function link(scope) {
            if (!$templateCache.get('denomPopover.html')) {
                $templateCache.put('denomPopover.html', '\n                    <div class="denom-icon-popover-content">\n                        <img ng-src="assets/images/{{denomId == \'1\' ? \'$1c\' : denomId}}.png" class="denom-icon-lg" />\n                        <div class="denom-icon-label">{{denomName || denomId}}</div>\n                    </div>\n                ');
            }
            scope.denomName = '';
            scope.$watch('denomId', function (newVal) {
                if (newVal) {
                    DenominationService.getName(newVal).then(function (name) {
                        scope.denomName = name;
                    });
                }
            });
        }
    };
};
denomIconDirective.$inject = ["$templateCache", "DenominationService"];

exports.default = denomIconDirective;

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var disableCopyPasteDirective = function disableCopyPasteDirective(SetupService, User) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, controller) {
            return SetupService.get(User.getUser().branchId).then(function (data) {
                if (!data.disableCopyPaste) return;
                element.on('copy', function (event) {
                    event.preventDefault();
                    // alert('Copy is not allowed!');
                });

                element.on('paste', function (event) {
                    event.preventDefault();
                    // alert('Paste is not allowed!');
                });
            }).catch(function (err) {
                console.log(err);
            });
        }
    };
};

disableCopyPasteDirective.$inject = ['SetupService', 'User'];

exports.default = disableCopyPasteDirective;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _disableCopyPaste = __webpack_require__(1566);

var _disableCopyPaste2 = _interopRequireDefault(_disableCopyPaste);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisableCopyPasteModule = _angular2.default.module('disable-copy-paste-module', []).directive('disableCopyPaste', _disableCopyPaste2.default).name;

exports.default = DisableCopyPasteModule;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var disableTrackingIdTypingDirective = function disableTrackingIdTypingDirective(SetupService, User) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, controller) {
            return SetupService.get(User.getUser().branchId).then(function (data) {
                if (!data.disableTrackingIdTyping) return;
                var lastKeypressTime = 0;
                var inputBuffer = [];
                element.on('keypress', function (event) {
                    var currentTime = Date.now();
                    var char = String.fromCharCode(event.which);

                    if (currentTime - lastKeypressTime < 1500) {
                        inputBuffer.push(char);
                        if (inputBuffer.length >= 6) {
                            var value = inputBuffer.join('');
                            controller.$setViewValue(value);
                            controller.$render();
                        }
                    } else {
                        inputBuffer = [char];
                    }

                    lastKeypressTime = currentTime;

                    if (inputBuffer.length === 1) {
                        setTimeout(function () {
                            if (inputBuffer.length < 6) {
                                alert("Manual typing is not allowed!");
                                controller.$setViewValue(' ');
                                controller.$render();
                                inputBuffer = [];
                            }
                        }, 1500);
                    }
                });
            }).catch(function (err) {
                console.log(err);
            });
        }
    };
};

disableTrackingIdTypingDirective.$inject = ['SetupService', 'User'];

exports.default = disableTrackingIdTypingDirective;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _disableTrackingIdTyping = __webpack_require__(1568);

var _disableTrackingIdTyping2 = _interopRequireDefault(_disableTrackingIdTyping);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisableTrackingIdTypingModule = _angular2.default.module('disable-tracking-id-typing-module', []).directive('disableTrackingIdTyping', _disableTrackingIdTyping2.default).name;

exports.default = DisableTrackingIdTypingModule;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var EDITABLE_TAGS = /^(INPUT|TEXTAREA|SELECT|OPTION|BUTTON)$/;

var dndDraggableSelectionFix = function dndDraggableSelectionFix() {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            element.on('mousedown', function (event) {
                if (event.button !== 0 || event.shiftKey) return;

                var target = event.target;
                if (!target || EDITABLE_TAGS.test(target.tagName) || target.isContentEditable) return;

                var selection = window.getSelection && window.getSelection();
                if (selection && !selection.isCollapsed) selection.removeAllRanges();
            });
        }
    };
};

exports.default = dndDraggableSelectionFix;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _dndFix = __webpack_require__(1570);

var _dndFix2 = _interopRequireDefault(_dndFix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DndFixModule = _angular2.default.module('dnd-fix-module', []).directive('dndDraggable', _dndFix2.default).name;

exports.default = DndFixModule;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


FetchReactDataFactory.$inject = ["$window", "$log"];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* @ngInject */
function FetchReactDataFactory($window, $log) {
  var STORAGE_KEY = 'ANGULAR_TRANSITION_DATA';
  return {
    getTransitionData: getTransitionData,
    clearTransitionData: clearTransitionData,
    setTransitionData: setTransitionData
  };
  function getTransitionData() {
    var dataString = $window.sessionStorage.getItem(STORAGE_KEY);
    if (!dataString) {
      return null;
    }
    try {
      var payload = JSON.parse(dataString);
      return payload;
    } catch (e) {
      $log.error('Failed to parse transition data', e);
      return null;
    }
  }
  function clearTransitionData() {
    $window.sessionStorage.removeItem(STORAGE_KEY);
  }
  function setTransitionData(data) {
    $window.sessionStorage.setItem(STORAGE_KEY, (0, _stringify2.default)(data));
  }
}

exports.default = FetchReactDataFactory;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _fetchReactData = __webpack_require__(1572);

var _fetchReactData2 = _interopRequireDefault(_fetchReactData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchReactDataModule = _angular2.default.module('fetchReactData', []).factory('FetchReactData', _fetchReactData2.default).name;

exports.default = fetchReactDataModule;

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
     value: true
});

var _from = __webpack_require__(75);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileUploadsDirective = function FileUploadsDirective() {
     return {
          restrict: 'E',
          scope: {
               ngModel: '=',
               ngDisabled: '=',
               fileTypes: '@',
               selectedFiles: '='
          },
          require: {
               ngModel: 'ngModel'
          },
          templateUrl: 'file-upload.html',
          link: function link(scope, element, attrs, controller) {

               var fileInput = element[0].querySelector('[type=file]');
               var btnClass = element[0].querySelector('.button');

               scope.$watch(function () {
                    return attrs.btnClass;
               }, function (newVal) {
                    if (btnClass && newVal && newVal.indexOf(' ') < 0) {
                         btnClass.classList.add(newVal);
                    }
               });

               scope.$watch('fileTypes', function (newVal) {
                    if (fileInput && newVal) {
                         fileInput.setAttribute('accept', newVal);
                    }
               });

               scope.$watch(function () {
                    return attrs.multiple;
               }, function (newVal) {
                    if (fileInput) {
                         var isMultiple = newVal === 'true' || newVal === true;
                         if (isMultiple) {
                              fileInput.setAttribute('multiple', 'multiple');
                         } else {
                              fileInput.removeAttribute('multiple');
                         }
                    }
               });

               element.bind('change', function (changed) {
                    controller.ngModel.path = fileInput.value;
                    controller.ngModel.info = fileInput.files;
                    if (changed.target.files.length < 1) {
                         return;
                    }

                    var imagetype = ['image/jpeg', 'image/png', 'image/jpg'];
                    var fileTypes = ['text/csv', 'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

                    var files = (0, _from2.default)(changed.target.files);
                    var isMultiple = attrs.multiple === 'true' || attrs.multiple === true;

                    // If it is running in SINGLE file mode, clear the array before adding the new file
                    if (!isMultiple) {
                         scope.selectedFiles = [];
                    } else {
                         scope.selectedFiles = scope.selectedFiles || [];
                    }

                    angular.forEach(files, function (item) {
                         if (fileTypes.includes(item.type) || imagetype.includes(item.type)) {
                              if (imagetype.includes(item.type) && !isMultiple) {
                                   scope.selectedFiles = [];
                              }

                              var value = {
                                   fileName: item.name,
                                   size: item.size,
                                   lastModifiedDate: item.lastModifiedDate,
                                   type: item.type,
                                   _file: item
                              };
                              scope.selectedFiles.push(value);
                         }
                    });

                    scope.selectedFiles = _.uniqBy(scope.selectedFiles, 'fileName');
                    var compress = attrs.compress === 'true' || attrs.compress === true;

                    var _loop = function _loop(i, f) {
                         var currentFile = f;

                         // New optimization logic: skip reading if base64 data already exists or if already processed
                         if (currentFile.base64Data || currentFile.processed) {
                              return 'continue';
                         }

                         var isImage = compress && currentFile.type && currentFile.type.startsWith('image/');

                         if (isImage) {
                              reader = new FileReader();

                              reader.onload = function (e) {
                                   var img = new Image();
                                   img.onload = function () {
                                        // Maximum bounding box dimensions
                                        var MAX_WIDTH = 1600;
                                        var MAX_HEIGHT = 1600;
                                        var width = img.width;
                                        var height = img.height;

                                        // Maintain correct aspect ratio
                                        if (width > height) {
                                             if (width > MAX_WIDTH) {
                                                  height *= MAX_WIDTH / width;
                                                  width = MAX_WIDTH;
                                             }
                                        } else {
                                             if (height > MAX_HEIGHT) {
                                                  width *= MAX_HEIGHT / height;
                                                  height = MAX_HEIGHT;
                                             }
                                        }

                                        var canvas = document.createElement('canvas');
                                        canvas.width = width;
                                        canvas.height = height;
                                        var ctx = canvas.getContext('2d');
                                        ctx.drawImage(img, 0, 0, width, height);

                                        // Extract canvas directly as a binary BLOB
                                        canvas.toBlob(function (blob) {
                                             var compressedFile = new File([blob], currentFile.fileName, { type: 'image/jpeg' });
                                             scope.$apply(function () {
                                                  currentFile._file = compressedFile;
                                                  currentFile.size = compressedFile.size;
                                                  currentFile.imageUrl = URL.createObjectURL(compressedFile);
                                                  currentFile.processed = true;
                                             });
                                        }, 'image/jpeg', 0.75); // 75% Quality JPEG
                                   };

                                   img.onerror = function () {
                                        // Fallback: If canvas trick fails, keep original file and mark processed
                                        scope.$apply(function () {
                                             currentFile.imageUrl = URL.createObjectURL(currentFile._file);
                                             currentFile.processed = true;
                                        });
                                   };
                                   img.src = e.target.result;
                              };
                              reader.readAsDataURL(currentFile._file);
                         } else {
                              if (compress) {
                                   // For compress mode (service tickets), we keep original binary file as is
                                   currentFile.processed = true;
                              } else {
                                   // Original behavior for other parts of the app: read raw as base64
                                   reader = new FileReader();

                                   reader.onloadend = function (output) {
                                        scope.$apply(function () {
                                             currentFile.base64Data = output.target.result.split(',')[1];
                                             currentFile.processed = true;
                                        });
                                   };
                                   reader.readAsDataURL(currentFile._file);
                              }
                         }
                    };

                    for (var i = 0, f; f = scope.selectedFiles[i]; i++) {
                         var reader;
                         var reader;

                         var _ret = _loop(i, f);

                         if (_ret === 'continue') continue;
                    }

                    controller.ngModel.$$rawModelValue = scope.selectedFiles;
                    controller.ngModel.$viewValue = scope.selectedFiles;
                    controller.ngModel.$setViewValue(scope.selectedFiles);

                    fileInput.value = '';

                    scope.$apply();
               });
          }
     };
};

exports.default = FileUploadsDirective;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _fileUpload = __webpack_require__(1574);

var _fileUpload2 = _interopRequireDefault(_fileUpload);

var _fileUpload3 = __webpack_require__(2493);

var _fileUpload4 = _interopRequireDefault(_fileUpload3);

__webpack_require__(2917);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileUploadsModule = _angular2.default.module('file-upload-module', []).directive('inputFile', _fileUpload2.default).name;

exports.default = FileUploadsModule;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _navbar = __webpack_require__(1579);

var _navbar2 = _interopRequireDefault(_navbar);

var _user = __webpack_require__(1612);

var _user2 = _interopRequireDefault(_user);

var _auth = __webpack_require__(1552);

var _auth2 = _interopRequireDefault(_auth);

var _storage = __webpack_require__(1589);

var _storage2 = _interopRequireDefault(_storage);

var _modal = __webpack_require__(1605);

var _modal2 = _interopRequireDefault(_modal);

var _confirmSurpervisor = __webpack_require__(1604);

var _confirmSurpervisor2 = _interopRequireDefault(_confirmSurpervisor);

var _stripPrefix = __webpack_require__(1595);

var _stripPrefix2 = _interopRequireDefault(_stripPrefix);

var _timePicker = __webpack_require__(1607);

var _timePicker2 = _interopRequireDefault(_timePicker);

var _allowOnlyScan = __webpack_require__(1551);

var _allowOnlyScan2 = _interopRequireDefault(_allowOnlyScan);

var _connectionStatus = __webpack_require__(1560);

var _connectionStatus2 = _interopRequireDefault(_connectionStatus);

var _dataCounter = __webpack_require__(1562);

var _dataCounter2 = _interopRequireDefault(_dataCounter);

var _branch = __webpack_require__(1556);

var _branch2 = _interopRequireDefault(_branch);

var _dateUtil = __webpack_require__(1564);

var _dateUtil2 = _interopRequireDefault(_dateUtil);

var _stripWhitespace = __webpack_require__(1597);

var _stripWhitespace2 = _interopRequireDefault(_stripWhitespace);

var _searchAndSelect = __webpack_require__(1584);

var _searchAndSelect2 = _interopRequireDefault(_searchAndSelect);

var _sound = __webpack_require__(1587);

var _sound2 = _interopRequireDefault(_sound);

var _changePassword = __webpack_require__(1601);

var _changePassword2 = _interopRequireDefault(_changePassword);

var _timeoutCountdown = __webpack_require__(1609);

var _timeoutCountdown2 = _interopRequireDefault(_timeoutCountdown);

var _autoCapitalize = __webpack_require__(1554);

var _autoCapitalize2 = _interopRequireDefault(_autoCapitalize);

var _configs = __webpack_require__(1558);

var _configs2 = _interopRequireDefault(_configs);

var _navigation = __webpack_require__(1580);

var _navigation2 = _interopRequireDefault(_navigation);

var _timezoneList = __webpack_require__(1599);

var _timezoneList2 = _interopRequireDefault(_timezoneList);

var _fileUpload = __webpack_require__(1575);

var _fileUpload2 = _interopRequireDefault(_fileUpload);

var _streamPrintLogo = __webpack_require__(1593);

var _streamPrintLogo2 = _interopRequireDefault(_streamPrintLogo);

var _streamCompanyLogo = __webpack_require__(1591);

var _streamCompanyLogo2 = _interopRequireDefault(_streamCompanyLogo);

var _disableCopyPaste = __webpack_require__(1567);

var _disableCopyPaste2 = _interopRequireDefault(_disableCopyPaste);

var _paginatedSearchAndSelect = __webpack_require__(1582);

var _paginatedSearchAndSelect2 = _interopRequireDefault(_paginatedSearchAndSelect);

var _disableTrackingIdTyping = __webpack_require__(1569);

var _disableTrackingIdTyping2 = _interopRequireDefault(_disableTrackingIdTyping);

var _fetchReactData = __webpack_require__(1573);

var _fetchReactData2 = _interopRequireDefault(_fetchReactData);

var _dndFix = __webpack_require__(1571);

var _dndFix2 = _interopRequireDefault(_dndFix);

var _denomIcon = __webpack_require__(1565);

var _denomIcon2 = _interopRequireDefault(_denomIcon);

__webpack_require__(2916);

var _searchAutofocus = __webpack_require__(1586);

var _searchAutofocus2 = _interopRequireDefault(_searchAutofocus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonModule = _angular2.default.module('app.common', [_user2.default, _auth2.default, _storage2.default, _navbar2.default, _modal2.default, _stripPrefix2.default, _timePicker2.default, _allowOnlyScan2.default, _connectionStatus2.default, _dataCounter2.default, _branch2.default, _dateUtil2.default, _stripWhitespace2.default, _searchAndSelect2.default, _sound2.default, _autoCapitalize2.default, _configs2.default, _navigation2.default, _timezoneList2.default, _fileUpload2.default, _streamPrintLogo2.default, _streamCompanyLogo2.default, _disableCopyPaste2.default, _paginatedSearchAndSelect2.default, _disableTrackingIdTyping2.default, _fetchReactData2.default, _dndFix2.default]).component('confirmSupervisor', _confirmSurpervisor2.default).component('changePassword', _changePassword2.default).component('timeoutCountdown', _timeoutCountdown2.default).directive('denomIcon', _denomIcon2.default).directive('searchAutofocus', _searchAutofocus2.default).name;

exports.default = commonModule;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navbar = __webpack_require__(2494);

var _navbar2 = _interopRequireDefault(_navbar);

var _navbar3 = __webpack_require__(1578);

var _navbar4 = _interopRequireDefault(_navbar3);

__webpack_require__(2918);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navbarComponent = {
  restrict: 'E',
  bindings: {},
  template: _navbar2.default,
  controller: _navbar4.default
};

exports.default = navbarComponent;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavbarController = function () {
  /*@ngInject*/
  NavbarController.$inject = ["User", "$rootScope", "Auth", "$state", "$document", "BranchService", "$location", "$translate", "UserService", "$q", "UsersService", "$window", "SetupService", "Sound", "HomeService", "Configs", "CommonLayoutService"];
  function NavbarController(User, $rootScope, Auth, $state, $document, BranchService, $location, $translate, UserService, $q, UsersService, $window, SetupService, Sound, HomeService, Configs, CommonLayoutService) {
    var _this = this;

    (0, _classCallCheck3.default)(this, NavbarController);

    this.User = User;
    this.$rootScope = $rootScope;
    this.Auth = Auth;
    this.$state = $state;
    this.userInfo = User.getUser();
    this.isUserLoggedIn = User.isSignedIn();
    this.BranchService = BranchService;
    this.$location = $location;
    this.$translate = $translate;
    this.SetupService = SetupService;
    this.permissions = [];
    this.UserService = UserService;
    this.UsersService = UsersService;
    this.HomeService = HomeService;
    this.Configs = Configs;
    this.$q = $q;
    this.$document = $document;
    this.userBranches = {};
    this.window = $window;
    this.Sound = Sound;
    this.audio = this.Sound.errorBeep();
    this.successAudio = this.Sound.successBeep();
    var data = User.getACL('navbar');
    var perMap = Auth.permissionMap();
    this.callOnce = true;
    this.hideBranchDD = false;
    this.CommonLayoutService = CommonLayoutService;
    var permissionOrder = ['tnt_billing', 'tnt_control', 'branch_mgmt', 'vault_balance', 'vault_operations', 'service_tickets', 'reporting', 'setting', 'divider', 'shipment_batch', 'bulk_cash_management', 'bulk_transfer', 'order_packing', 'route_throw', 'route_control', 'check_out', 'on_demand_call', 'cash_activity', 'ach_management', 'coin_management', 'pickup_request_management', 'check_in', 'atm_count', 'bag_out', 'atm_codes_management', 'fuel_surcharges', 'master_cash_schedule', 'route_progress', 'route_stats', 'deposit_packing', 'tnt_react_app', 'tnt_app_event_logs', 'divider', 'route_sheet', 'coin_pull_report', 'vault_close'];
    this.menuOrder = ['users', 'branch', 'batch', 'location', 'routes', 'item', 'carrier', 'truck', 'holiday', 'branch-funding-source', 'branch-funding-source-holiday', 'log', 'reset-atm-code', 'soft-deleted-shipments', 'service-settings', 'preventative-maintenance'];
    var hasBulkTransferMenuAccess = function hasBulkTransferMenuAccess(aclData) {
      if (!aclData || angular.equals({}, aclData)) return false;
      if (aclData.bulk_transfer && aclData.bulk_transfer.indexOf('all') >= 0) return true;
      return ['bulk_transfer_new', 'bulk_transfer_active', 'bulk_transfer_closed'].some(function (resource) {
        var resourcePermissions = aclData[resource];
        return resourcePermissions instanceof Array && resourcePermissions.indexOf('view') >= 0;
      });
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(permissionOrder)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
            key = _step$value[0],
            permissions = _step$value[1];

        var menuConfig = void 0;
        if (permissions === 'bulk_transfer' && hasBulkTransferMenuAccess(data)) {
          menuConfig = perMap[permissions];
        } else if (permissions in data) {
          menuConfig = perMap[permissions];
        } else {
          if (!angular.equals({}, data)) {
            menuConfig = permissions;
          } else {
            menuConfig = false;
          }
        }
        if (menuConfig) {
          this.permissions.push(menuConfig);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var configureListener = function configureListener() {
      _this.$rootScope.$on('userChanged', function (evt, user) {
        _this.isUserLoggedIn = !!user;
        if (_this.isUserLoggedIn) {
          _this.userInfo = user;
          _this.$q.all([_this.BranchService.get(_this.userInfo.branchId)]
          // this.UserService.getUserBranchGroup(this.userInfo.id)
          ).then(function (data) {
            _this.userInfo.branch = data[0];
            _this.userInfo.branchLink = _this.getBranchLink();
            // this.userBranches = data[1];
          }).catch(function (e) {
            console.log('error ' + e);
          });
        }
      });
    };
    configureListener();

    // setInterval(() => {
    //   if (!this.isUserLoggedIn) return;
    //   // if (this.userInfo && this.userInfo.branchLiability) {
    //   this.getBranchLiability();
    //   // this.callOnce = false;
    //   // }
    // }, 900000)

    // setInterval(() => {
    //   if (this.userInfo && !this.userInfo.branchLiability && this.callOnce) {
    //     this.getBranchLiability();
    //     this.callOnce = false;
    //   }
    // }, 1000)
  }

  (0, _createClass3.default)(NavbarController, [{
    key: 'getBranchLiability',
    value: function getBranchLiability() {
      var _this2 = this;

      this.HomeService.getBranchLiability(this.userInfo.branchId).then(function (data) {
        _this2.userInfo.branchLiability = data.results;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'shiftBranch',
    value: function shiftBranch(selectedBranch) {
      var _this3 = this;

      this.loading = true;
      var savedata = {
        id: this.userInfo.id,
        branchId: selectedBranch.branchId
      };
      this.UsersService.updateUserBranch(savedata.id, savedata).then(function (data) {
        return _this3.HomeService.getBranchLiability(selectedBranch.branchId).then(function (branchLiabilityObj) {
          return [data, branchLiabilityObj.results];
        });
      }).then(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            data = _ref2[0],
            branchLiability = _ref2[1];

        data.branchLiability = branchLiability;
        _this3.User.setUser(data);
        _this3.loading = false;
        // this.$state.go('home');
        setTimeout(function () {
          this.window.location.reload();
        }, 100);
      }).catch(function (err) {
        _this3.loading = false;
        err.data.errors.map(function (e) {
          _this3.errorMessage += e.message + '<br/>';
        });
      });
    }
  }, {
    key: 'menuItemClicked',
    value: function menuItemClicked(menu) {
      var _this4 = this;

      if (menu.state == 'settings') {
        this.pageHeader = undefined;
        for (var i = 0; i < this.menuOrder.length; i++) {
          if (this.aclPermissions['setting-' + this.menuOrder[i]] && this.aclPermissions['setting-' + this.menuOrder[i]].indexOf('view') >= 0) {
            if (this.menuOrder[i] === 'preventative-maintenance') {
              this.window.open('/v2/index.html#/preventative-maintenance', '_self');
            } else {
              this.go('/app/settings/' + this.menuOrder[i] + '/all/1');
            }
            break;
          }
        }
      } else if (menu.state === 'routeStats') {
        var url = this.$state.href(menu.state);
        this.window.open(url, '_blank');
      } else if (menu.state === "tntReactApp") {
        var url = this.$state.href(menu.state);
        this.window.open(url, "_blank");
      } else if (menu.state === "onDemandCall") {
        var url = this.$state.href(menu.state);
        setTimeout(function () {
          _this4.window.open(url, "_self");
        }, 200);
      } else if (menu.state === "pickupRequestManagement") {
        var url = this.$state.href(menu.state);
        setTimeout(function () {
          _this4.window.open(url, "_self");
        }, 200);
      } else if (menu.state === "coinManagement") {
        var url = this.$state.href(menu.state);
        setTimeout(function () {
          _this4.window.open(url, "_self");
        }, 200);
      } else if (menu.state === "cashActivity") {
        var url = this.$state.href(menu.state);
        setTimeout(function () {
          _this4.window.open(url, "_self");
        }, 200);
      } else if (menu.state === "bulkTransfer") {
        setTimeout(function () {
          _this4.window.open('/v2/index.html#/bulk-transfer', '_self');
        }, 200);
      } else if (menu.state === "achManagement") {
        var url = this.$state.href(menu.state);
        setTimeout(function () {
          _this4.window.open(url, "_self");
        }, 200);
      } else if (menu.state === "appEventLogs") {
        var url = this.$state.href(menu.state);
        setTimeout(function () {
          _this4.window.open(url, "_self");
        }, 200);
      } else {
        this.$state.go(menu.state, {}, { reload: true });
      }
      this.setPageWidth();
    }
  }, {
    key: 'go',
    value: function go(path) {
      // this.$state.reload();
      this.$location.path(path);
    }
  }, {
    key: 'getBranchLink',
    value: function getBranchLink() {
      var permissions = this.User.getACL('setting-branch');
      if (permissions && permissions instanceof Array && permissions.includes('edit')) {
        return '/app/settings/branch/edit/' + this.userInfo.branchId;
      } else {
        return '#';
      }
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this5 = this;

      this.$q.all([this.BranchService.get(this.userInfo.branchId), this.UserService.getUserBranchGroup(this.userInfo.id), this.UserService.acl(this.userInfo.id, this.userInfo.branchId), this.SetupService.all(null, 0, 100), this.UsersService.validateUserPermissions(this.userInfo.firstName, this.userInfo.lastName)]).then(function (data) {
        _this5.userInfo.branch = data[0];
        _this5.userInfo.branchLink = _this5.getBranchLink();
        _this5.allBranches = data[3].results;
        if (data[1].length && _this5.allBranches.length) {
          _this5.userBranches = [];
          data[1].forEach(function (selectedBranch) {
            _this5.allBranches.filter(function (data) {
              if (data.branchId == selectedBranch.branchId) {
                _this5.userBranches.push(selectedBranch);
              }
            });
          });
        }
        _this5.aclPermissions = data[2];
        var permissions = data[4];

        if (!permissions.hasAtmCodesPermission && !_this5.CommonLayoutService.isAllowToAccessPages()) {
          _this5.permissions = _this5.permissions.filter(function (pr) {
            return pr.state !== 'atmCodesManagement';
          });

          if (_this5.validateUserPermissionsAndState('/atm-codes-management')) {
            return _this5.$state.go('home');
          }
        }

        if (!permissions.hasSettingsPermission && !_this5.CommonLayoutService.isAllowToAccessPages()) {
          _this5.permissions = _this5.permissions.filter(function (pr) {
            return pr.state !== 'settings';
          });

          if (_this5.validateUserPermissionsAndState('/settings')) {
            return _this5.$state.go('home');
          }
        }

        if (!permissions.vaultOpartionPermission && !_this5.CommonLayoutService.isAllowToAccessPages()) {
          _this5.permissions = _this5.permissions.filter(function (pr) {
            return pr.state !== "vaultOperations";
          });

          if (_this5.validateUserPermissionsAndState('/vault-operations')) {
            return _this5.$state.go('home');
          }
        }

        _this5.setPageWidth();
      }).catch(function (err) {
        console.log(err);
      });

      this.$rootScope.$on('routeChange', function (evt, url) {
        if (url == '/app/home' || url == '/app/user-profile') return _this5.pageHeader = undefined;else if (url == '/app/atm-codes-management') return _this5.pageHeader = _this5.$translate.instant('navbar.atm_codes_management');else if (url == '/app/atm-count') return _this5.pageHeader = _this5.$translate.instant('branch_mgmt.cash_count');else if (url == '/app/deposit-packing') return _this5.pageHeader = _this5.$translate.instant('navbar.deposit_packing');else if (url == '/app/vault-close') return _this5.pageHeader = _this5.$translate.instant('navbar.vaultClose_title');else if (url == '/app/routeControl') return _this5.pageHeader = _this5.$translate.instant('navbar.routeControl_title');else if (url == '/app/checkin') return _this5.pageHeader = _this5.$translate.instant('navbar.checkin_title');else if (url == '/app/checkout') return _this5.pageHeader = _this5.$translate.instant('navbar.checkout_title');else if (url == '/app/route-throw') return _this5.pageHeader = _this5.$translate.instant('navbar.route_title');else if (url == '/app/bag-out') return _this5.pageHeader = _this5.$translate.instant('navbar.bagout_title');else if (url == '/app/route-progress') return _this5.pageHeader = _this5.$translate.instant('navbar.routeProgress_title');else if (url == '/app/order-packing') return _this5.pageHeader = _this5.$translate.instant('navbar.order_packing');else if (url == '/app/currency-pick-report') return _this5.pageHeader = _this5.$translate.instant('navbar.currency_pick_report');
        // else if (url == '/app/bulk-cash-management') return this.pageHeader = this.$translate.instant('navbar.bulk_cash_management');
        else if (url == '/app/bulk-cash') return _this5.pageHeader = _this5.$translate.instant('navbar.bulk_cash');else if (url == '/app/shipment-batch') return _this5.pageHeader = _this5.$translate.instant('navbar.batch_title');else if (url == '/app/route-sheet') return _this5.pageHeader = _this5.$translate.instant('navbar.routeSheet_title');else if (url == '/app/coin-pull-report') return _this5.pageHeader = _this5.$translate.instant('navbar.coinPullReport_title');else if (url == '/app/service-tickets') return _this5.pageHeader = _this5.$translate.instant('navbar.serviceTickets_title');else if (url == '/app/fuel-surcharges') return _this5.pageHeader = _this5.$translate.instant('navbar.fuel_surcharge_title');else if (url == '/app/route-stats') return _this5.pageHeader = _this5.$translate.instant('navbar.route_stats_title');else if (url == '/app/master-cash-schedule') return _this5.pageHeader = _this5.$translate.instant('navbar.master_cash_schedule');else if (url == '/app/vault-operations') return _this5.pageHeader = _this5.$translate.instant('navbar.vault_operations');else if (url == '/app/branch-management/item-holds') return _this5.pageHeader = _this5.$translate.instant('navbar.shipment_holds');else return _this5.pageHeader = undefined;
      });

      this.$rootScope.$on('updateBranchLiability', function (evt, liabilityObj) {
        if (liabilityObj.isVaultLiabilityChange && _this5.userInfo.branchLiability && (0, _typeof3.default)(_this5.userInfo.branchLiability) === 'object') {
          _this5.HomeService.updateVaultLiability(liabilityObj.branchId, liabilityObj.vaultLiability).then(function () {
            if (liabilityObj.branchId === _this5.userInfo.branchId) {
              _this5.userInfo.branchLiability.vault_liability = liabilityObj.vaultLiability;
              _this5.User.setUser(_this5.userInfo);
            }
          }).catch(function (err) {
            console.log(err);
          });
        }
      });
    }
  }, {
    key: 'logout',
    value: function logout() {
      var _this6 = this;

      this.Auth.logout().then(function () {
        _this6.User.clearUser();
        _this6.$state.go('login');
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'setPageWidth',
    value: function setPageWidth() {
      if (this.$state.current && this.$state.current.name && this.$state.current.name == 'routeStats') {
        angular.element(this.$document).find('body').css('max-width', '100%');
        this.hideBranchDD = true;
        // console.log('call', this.$state.current)
      } else {
        // console.log('call', this.$state.current)
        angular.element(this.$document).find('body').css('max-width', '1280px');
        this.hideBranchDD = false;
      }
    }
  }, {
    key: 'validateUserPermissionsAndState',
    value: function validateUserPermissionsAndState(wordToCheck) {
      var currentStateUrl = this.$state.href(this.$state.current);
      return currentStateUrl.toLowerCase().includes(wordToCheck);
    }
  }]);
  return NavbarController;
}();

exports.default = NavbarController;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = __webpack_require__(312);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _navbar = __webpack_require__(1577);

var _navbar2 = _interopRequireDefault(_navbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navbarModule = _angular2.default.module('navbar', [_angularUiRouter2.default]).component('navbar', _navbar2.default).name;

exports.default = navbarModule;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _navigation = __webpack_require__(1581);

var _navigation2 = _interopRequireDefault(_navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navigationModule = _angular2.default.module('app.navigation', []).factory('Navigation', _navigation2.default).name;

exports.default = navigationModule;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var NavigationFactory = function NavigationFactory($state, DataCounter, Configs, CommonLayoutService) {
    var permissions = null;

    var goToServiceHistory = function goToServiceHistory(locationId, date, isRedirected, modal) {
        if (modal) modal.close();
        var obj = {
            locationId: locationId,
            vaultDate: date,
            isRedirected: isRedirected
        };
        DataCounter.setData(obj);
        $state.go('branchManagement.locations');
    };

    var goToItemHistory = function goToItemHistory(trackingId, modal) {
        if (modal) modal.close();
        $state.go('branchManagement.items', {
            id: trackingId
        });
    };

    var goToOrderHistory = function goToOrderHistory(orderNo, date, isRedirected, isCounted, isInProcess, isPending, modal) {
        var fundingSourceId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

        if (modal) modal.close();
        var obj = {
            orderNo: orderNo,
            vaultDate: date,
            isRedirected: isRedirected,
            isCounted: isCounted,
            isInProcess: isInProcess,
            isPending: isPending,
            fundingSourceId: fundingSourceId
        };
        DataCounter.setData(obj);
        $state.go('branchManagement.orders');
    };

    var goToRouteTab = function goToRouteTab(routeId, date, isRedirected, modal) {
        if (modal) modal.close();
        var obj = {
            routeId: routeId,
            vaultDate: date,
            isRedirected: isRedirected
        };
        DataCounter.setData(obj);
        $state.go('branchManagement.routes');
    };

    var goToAtmCount = function goToAtmCount(trackingId, isRedirected, modal) {
        var fundingSourceId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        if (modal) modal.close();
        var obj = {
            trackingId: trackingId,
            isRedirected: isRedirected,
            fundingSourceId: fundingSourceId
        };
        DataCounter.setData(obj);
        $state.go('atmCount');
    };

    var goToOrderPack = function goToOrderPack(routeId, date, locationId, isRedirected, orderNo, isEC, modal) {
        if (modal) modal.close();
        var obj = {
            routeId: routeId,
            vaultDate: date,
            locationId: locationId,
            isRedirected: isRedirected,
            orderNo: orderNo,
            isEC: isEC
        };
        DataCounter.setData(obj);
        $state.go('orderPacking');
    };

    var goToOrderPackingFromLocation = function goToOrderPackingFromLocation(locationId, orderNo, fundingSourceId, modal) {
        if (modal) modal.close();
        var obj = {
            locationId: locationId,
            orderNo: orderNo,
            fundingSourceId: fundingSourceId,
            isRedirected: true
        };
        DataCounter.setData(obj);
        $state.go('orderPacking');
    };

    var goToItemHold = function goToItemHold(trackingId, isRedirected) {
        var obj = {
            trackingId: trackingId,
            isRedirected: isRedirected
        };
        DataCounter.setData(obj);
        $state.go('branchManagement.itemHolds');
    };

    var goToUserTab = function goToUserTab(userId, modal) {
        permissions = Configs.getPermissionConfig();
        if (!permissions.hasSettingsPermission && !CommonLayoutService.isAllowToAccessPages() || !permissions.hasUserEditPermission && !CommonLayoutService.isAllowToAccessPages()) return;

        if (modal) modal.close();
        $state.go('users.edit', {
            id: userId
        });
    };

    var goToVehicleTab = function goToVehicleTab(vehicleId, modal) {
        permissions = Configs.getPermissionConfig();
        if (!permissions.hasSettingsPermission && !CommonLayoutService.isAllowToAccessPages()) return;

        if (modal) modal.close();
        $state.go('truck.edit', {
            id: vehicleId
        });
    };

    var goToLocationTab = function goToLocationTab(locationId, modal) {
        permissions = Configs.getPermissionConfig();
        if (!permissions.hasSettingsPermission && !CommonLayoutService.isAllowToAccessPages()) return;

        if (modal) modal.close();
        $state.go('location.edit', { id: locationId });
    };

    var goToSettingsRouteTab = function goToSettingsRouteTab(route, selectedDay) {
        permissions = Configs.getPermissionConfig();
        if (!permissions.hasSettingsPermission && !CommonLayoutService.isAllowToAccessPages()) return;

        $state.go('routes.edit', { id: route, day: selectedDay });
    };

    var goToAllLocationTab = function goToAllLocationTab(modal) {
        permissions = Configs.getPermissionConfig();
        if (!permissions.hasSettingsPermission && !CommonLayoutService.isAllowToAccessPages()) return;

        if (modal) modal.close();
        $state.go('location.all', { page: 1 });
    };

    var goToServiceTicket = function goToServiceTicket(encounterId, modal) {
        if (modal) modal.close();
        var obj = { encounterId: encounterId };
        DataCounter.setData(obj);
        $state.go('serviceTickets');
    };

    return {
        goToServiceHistory: goToServiceHistory,
        goToItemHistory: goToItemHistory,
        goToOrderHistory: goToOrderHistory,
        goToRouteTab: goToRouteTab,
        goToAtmCount: goToAtmCount,
        goToOrderPack: goToOrderPack,
        goToOrderPackingFromLocation: goToOrderPackingFromLocation,
        goToItemHold: goToItemHold,
        goToUserTab: goToUserTab,
        goToVehicleTab: goToVehicleTab,
        goToLocationTab: goToLocationTab,
        goToSettingsRouteTab: goToSettingsRouteTab,
        goToAllLocationTab: goToAllLocationTab,
        goToServiceTicket: goToServiceTicket
    };
};

NavigationFactory.$inject = ['$state', 'DataCounter', 'Configs', 'CommonLayoutService'];

exports.default = NavigationFactory;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _paginatedSearchAndSelect = __webpack_require__(1583);

var _paginatedSearchAndSelect2 = _interopRequireDefault(_paginatedSearchAndSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginatedSearchAndSelectModule = _angular2.default.module('paginated-search-and-select-module', []).directive('paginatedSearchAndSelect', _paginatedSearchAndSelect2.default).name;

exports.default = PaginatedSearchAndSelectModule;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _paginatedSearchAndSelect = __webpack_require__(2495);

var _paginatedSearchAndSelect2 = _interopRequireDefault(_paginatedSearchAndSelect);

__webpack_require__(2919);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginatedSearchAndSelectDirective = ['$rootScope', '$translate', function ($rootScope, $translate) {
    var DEFAULT_ALL_ITEMS = 'All Items',
        DEFAULT_SELECTED_ITEMS = 'Selected: ',
        DEFAULT_NO_SELECTION = 'None',
        DEFAULT_ITEM_DELIMITER = ', ';

    return {
        require: 'ngModel',
        restrict: 'E',
        replace: true,
        scope: {
            modelValue: '=ngModel',
            options: '=',
            onscroll: "&",
            pageLimit: '=',
            key: '@',
            search: '=',
            modelChanged: '&ngChange',
            totalCount: '=',
            commonSearchGlag: '=',
            onClick: '&',
            allValue: '=',
            displayLabel: '=',
            noneSelected: '=',
            selectedPrefix: '=',
            allLabel: '=',
            isLoading: '=',
            labelName: '@',
            hideLabel: '=',
            toggleCount: '=',
            allowSingleSelect: '=',
            showOldSelected: '=',
            showSelectedFirst: '=',
            showFilterAction: '=',
            applyAction: '&',
            resetAction: '&',
            mode: '=',
            locationDistanceId: '=',
            billingType: '=',
            onShowAll: '&'
        },
        templateUrl: 'paginated-search-and-select.html',
        link: function link(scope, elem, attrs, ngModel) {
            var allValues = [];
            var modelLoaded = false;
            var selectedItemLabel = [];
            var selectedItemValues = [];
            scope.currentPage = 1;
            // const pageLimit = 20;
            scope.isExpanded = false;
            scope.searchKey = '';
            scope.enabledItems = null;
            scope.totalSelected = 0;
            scope.selectAllFlag = false;
            scope.selectAllLoading = false;
            var selectAllSafetyTimeoutId = null;

            function stopSelectAllLoading() {
                scope.selectAllLoading = false;
                if (selectAllSafetyTimeoutId) {
                    clearTimeout(selectAllSafetyTimeoutId);
                    selectAllSafetyTimeoutId = null;
                }
            }
            scope.toggleSelector = function () {
                scope.isExpanded = !scope.isExpanded;
                if (scope.isExpanded) {
                    setTimeout(function () {
                        var searchInput = elem.find('input[type="text"]:not([disabled])');
                        if (searchInput && searchInput.length) {
                            searchInput.focus();
                        }
                    }, 100);
                }
            };

            scope.isDisabled = false;

            setTimeout(function () {
                allValues = scope.options;
                if (!scope.totalCount) {
                    scope.totalCount = 0;
                }
            }, 3000);

            attrs.$observe('required', function (value) {
                scope.required = !!value;
            });

            attrs.$observe('disabled', function (value) {
                scope.isDisabled = !!value;
            });

            scope.isTouched = function () {
                return ngModel ? ngModel.$touched : false;
            };

            scope.onBlurHandler = function () {
                if (ngModel) ngModel.$setTouched();
                setTimeout(function () {
                    if (scope.isExpanded === false) return;
                    if (elem[0].contains(document.activeElement)) {
                        if (!scope.search) elem[0].focus();
                    } else {
                        scope.isExpanded = false;
                        scope.searchKey = '';
                        if (scope.billingType == false) {
                            scope.locationDistanceId = null;
                        }
                        if (scope.mode === 'edit') {
                            scope.searchBy('');
                            // scope.options = [];
                        }
                    }
                }, 50);
            };

            scope._onBlurHandler = function () {
                if (scope.isExpanded === false) return;
                setTimeout(function () {
                    elem[0].focus();
                });
            };

            var notifyChange = function notifyChange() {
                setTimeout(function () {
                    scope.modelChanged();
                });
            };

            scope.searchBy = function (searchText) {
                setTimeout(function () {

                    if (searchText.length === 0 || searchText.length >= 1) {
                        if (allValues && allValues.length === 0) {
                            allValues = scope.options;
                        }
                        scope.selectAllFlag = false;
                        stopSelectAllLoading();
                        scope.onscroll({
                            searchKey: searchText,
                            offset: 1,
                            selectAllFlag: scope.selectAllFlag
                        });
                    }
                }, 50);
            };

            function pushModel() {
                if (!modelLoaded || !scope.enabledItems) return;
                if (!!scope.allValue && scope.enabledItems[scope.allValue]) {
                    // if all value is enabled:
                    scope.modelValue = scope.allValue;
                    notifyChange();
                    return;
                }
                scope.modelValue = (0, _keys2.default)(scope.enabledItems).reduce(function (p, c) {
                    if (scope.enabledItems[c]) {
                        p.push(c);
                        if (selectedItemValues.indexOf(c) == -1) {
                            selectedItemValues.push(c);
                            var lbl = _.filter(scope.options, function (a) {
                                return a.value == c;
                            });
                            if (lbl && lbl.length) {
                                selectedItemLabel.push(lbl[0].label);
                                selectedItemLabel = _.uniq(selectedItemLabel).sort();
                            }
                        }
                    } else {
                        var vIndex = selectedItemValues.indexOf(c);
                        var keyIndex = _.findIndex(selectedItemLabel, function (str) {
                            if (!str) return;

                            str = str.toString();
                            return str.includes(c);
                        });

                        if (keyIndex >= 0) {
                            selectedItemLabel.splice(keyIndex, 1);
                        }
                        if (vIndex >= 0) {
                            selectedItemValues.splice(vIndex, 1);
                        }
                        scope.selectAllFlag = false;
                    }
                    return p;
                }, []);
                notifyChange();
            }

            function pullModel() {
                scope.enabledItems = {}; // reset enabled items
                var isModelArray = angular.isArray(scope.modelValue);
                if (!!scope.allValue && (scope.modelValue === scope.allValue || isModelArray && scope.modelValue.indexOf(scope.allValue) > -1)) {
                    // all is enabled:
                    scope.enabledItems[scope.allValue] = true;
                    modelLoaded = true;
                    return;
                }
                if (angular.isArray(scope.modelValue)) {
                    scope.modelValue.forEach(function (item) {
                        scope.enabledItems[item] = true;
                    });
                } else if (angular.isString(scope.modelValue) || angular.isNumber(scope.modelValue)) {
                    scope.enabledItems[scope.modelValue] = true;
                }
                modelLoaded = scope.modelValue !== undefined;
            }

            scope.itemIsActive = function (item) {
                return !!scope.enabledItems[item.value];
            };

            scope.itemDisabled = function (item) {
                // if (scope.isSelectedAll()) return true;
                return false;
            };

            function wrapTag(content, tag) {
                return '<' + tag + '>' + content + '</' + tag + '>';
            }

            function itemExists(value) {
                var valueId = (value || {}).value || value;
                return !(scope.options || []).every(function (itm) {
                    return itm.value !== valueId;
                });
            }

            scope.itemVisible = function (item) {
                if (!itemExists(item)) return false;
                if (angular.isFunction(item.showIf)) {
                    return !!item.showIf.call(this, item);
                }
                return !item.hidden;
            };

            scope.currentLabel = function () {
                var tag = 'span',
                    allItems = scope.options || [],
                    allLabel = scope.allLabel || DEFAULT_ALL_ITEMS,
                    itemDelim = scope.itemDelimiter || DEFAULT_ITEM_DELIMITER,
                    selPrefix = scope.selectedPrefix || DEFAULT_SELECTED_ITEMS,
                    noSelection = scope.noneSelected || DEFAULT_NO_SELECTION,
                    items = scope.enabledItems || {},
                    label = void 0;

                scope.totalSelected = 0;

                if (!!scope.allValue && items[scope.allValue]) {
                    selectedItemLabel = [];
                    selectedItemValues = [];
                    label = wrapTag(allLabel, tag);
                    scope.totalSelected = scope.totalCount;
                } else {
                    if (scope.options && scope.options.length === 0) {
                        scope.modalValue = [];
                        items = scope.modalValue;
                    }
                    var
                    // indexed = allItems.reduce(function (p, c) {
                    //     p[c.value] = c;
                    //     return p;
                    // }, {}),
                    itemStr = (0, _keys2.default)(items).map(function (e) {
                        return e;
                    }).join(itemDelim);
                    scope.totalSelected = (0, _keys2.default)(items).length || 0;
                    //     .reduce(function (p, c) {
                    //         if (!!indexed[c] && scope.itemVisible(indexed[c])) {
                    //             p.push(indexed[c][scope.displayLabel]);
                    //         }
                    //         scope.totalSelected = p.length || 0;
                    //         return p;
                    //     }, []).join(itemDelim);
                    if (itemStr) {
                        label = wrapTag(selPrefix, tag) + itemStr;
                    } else {
                        label = wrapTag(noSelection, tag);
                    }
                }
                return label;
            };

            scope.$watch('options', function (newValue, oldValue) {
                if (newValue !== oldValue && scope.selectAllFlag) {

                    scope.selectAll();
                }
            }, true);

            scope.isAllSelected = function () {
                if (!scope.totalCount) return false;
                if (!!scope.allValue && scope.enabledItems && scope.enabledItems[scope.allValue]) return true;
                return !!scope.enabledItems && (0, _keys2.default)(scope.enabledItems).length >= scope.totalCount;
            };

            scope.selectAll = function () {
                scope.modelValue = [];
                scope.enabledItems = {};
                scope.selectAllFlag = true;

                var shouldFetchMore = scope.totalCount && scope.options.length < scope.totalCount;
                if (shouldFetchMore) {
                    scope.selectAllLoading = true;
                } else {
                    stopSelectAllLoading();
                }

                var ddElement = elem.find('.bind-cst-scroll');
                ddElement[0].scrollTop = ddElement[0].scrollHeight;

                scope.options.forEach(function (el) {
                    scope.modelValue.push(el.value);
                    scope.enabledItems[el.value] = true;
                });

                if (shouldFetchMore) {
                    if (selectAllSafetyTimeoutId) clearTimeout(selectAllSafetyTimeoutId);
                    selectAllSafetyTimeoutId = setTimeout(stopSelectAllLoading, 20000);
                    scope.onscroll({
                        searchKey: scope.searchKey || '',
                        offset: scope.pageLimit ? Math.ceil(scope.options.length / scope.pageLimit + 1) : scope.currentPage + 1,
                        selectAllFlag: scope.selectAllFlag
                    });
                }

                setTimeout(function () {
                    scope.modelChanged();
                    elem[0].focus();
                });
            };

            scope.selectNone = function () {
                scope.selectAllFlag = false;
                stopSelectAllLoading();
                if (scope.searchKey) {
                    scope.options.forEach(function (el) {
                        delete scope.enabledItems[el.value];
                    });
                } else {
                    scope.enabledItems = {};
                }
                setTimeout(function () {
                    scope.modelChanged();
                    elem[0].focus();
                });
            };

            scope.showAllLocation = function () {
                scope.locationDistanceId = null;
                setTimeout(function () {
                    scope.options = [];
                    scope.onscroll({
                        searchKey: scope.searchKey || '',
                        locationDistanceId: scope.locationDistanceId,
                        offset: 1,
                        selectAllFlag: scope.selectAllFlag
                    });
                    scope.onShowAll();
                });
                scope.modelChanged();
            };

            scope.itemClicked = function (item) {
                if (angular.isArray(scope.modelValue) && scope.modelValue.length == 0) {
                    scope.modelValue = null;
                } else {
                    scope.modelValue = item.value === scope.modelValue ? null : item.value;
                }
                scope.isExpanded = false;
                setTimeout(function () {
                    scope.modelChanged();
                });
            };

            scope.isValid = function () {
                if (!scope.required) return true;
                if (angular.isArray(scope.modelValue)) {
                    return scope.modelValue.length > 0;
                }
                return !!scope.modelValue;
            };

            scope.$watch('enabledItems', pushModel, true);
            scope.$watch('modelValue', pullModel, true);

            scope.sortShowFirst = function (item) {
                var selectedVal = scope.enabledItems && (0, _keys2.default)(scope.enabledItems).length ? (0, _keys2.default)(scope.enabledItems) : [];
                if (scope.options && scope.options.length && selectedVal.length && scope.showSelectedFirst) {
                    var isSelected = selectedVal.findIndex(function (ci) {
                        return String(ci) === String(item.value);
                    });
                    return isSelected >= 0 ? -1 : 1;
                } else {
                    return -1;
                }
            };

            scope._resetAction = function () {
                if (scope.modelValue && scope.modelValue.length) {
                    scope.modelValue = scope.allowSingleSelect ? null : [];
                    setTimeout(function () {
                        scope.applyAction();
                        scope.toggleSelector();
                    }, 500);
                }
            };

            scope._applyAction = function () {
                scope.applyAction();
                scope.toggleSelector();
            };
            scope.flag = false;
            setTimeout(function () {
                elem.find('.bind-cst-scroll').bind('scroll', function (e) {
                    var currentItem = $(this);
                    if (currentItem.scrollTop() + currentItem.innerHeight() >= currentItem[0].scrollHeight - 1) {
                        if (scope.totalCount !== scope.options.length && !scope.isLoading && !scope.selectAllLoading) {
                            if (scope.flag === true) {
                                scope.searchBy('');
                                scope.flag = false;
                            }
                            scope.onscroll({
                                searchKey: scope.searchKey || '',
                                offset: scope.pageLimit ? Math.ceil(scope.options.length / scope.pageLimit + 1) : scope.currentPage + 1,
                                selectAllFlag: scope.selectAllFlag
                            });
                            scope.currentPage += 1;
                        }
                    }
                });
            }, 300);
        }
    };
}];

exports.default = PaginatedSearchAndSelectDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _searchAndSelect = __webpack_require__(1585);

var _searchAndSelect2 = _interopRequireDefault(_searchAndSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchAndSelectModule = _angular2.default.module('search-and-select-module', []).directive('searchAndSelect', _searchAndSelect2.default).name;

exports.default = SearchAndSelectModule;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _searchAndSelect = __webpack_require__(2496);

var _searchAndSelect2 = _interopRequireDefault(_searchAndSelect);

__webpack_require__(2920);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchAndSelectDirective = ['$rootScope', '$translate', function ($rootScope, $translate) {
    var DEFAULT_SELECTED_ITEMS = 'Selected: ',
        DEFAULT_NO_SELECTION = $translate.instant('common.none'),
        OFFSET_VALUE = 10,
        IS_EDIT_OFFSET_VALUE = 11;

    return {
        require: 'ngModel',
        replace: true,
        restrict: 'E',
        scope: {
            values: "=",
            selecteditem: "=ngModel",
            key: "@",
            onscroll: "&",
            totalrecords: "=",
            noneSelected: "=",
            commonSearchFlag: "=",
            longDdWidthFlag: "=",
            onClick: "&",
            hideCount: "=",
            isEdit: '=',
            setId: '@',
            isChangeOffset: '=',
            isChangeOffsetValue: '=',
            focusDropdownId: '@',
            focusDropdownSearch: '@',
            extendDdWidth: "=",
            updatedValues: "=",
            isHighlighted: "="
        },
        templateUrl: 'search-and-select.html',
        link: function link(scope, elm, attrs) {
            var allValues = [];
            scope.focusedIdx = 0;
            scope.dropdownVisible = false;
            scope.prevOffset = 0;
            scope.filteredValues = [];
            scope.ignoreOutsideClickUntil = 0;
            setTimeout(function () {
                allValues = scope.values;
            }, 3000);
            if (!attrs.setId) {
                scope.setId = 'searchString';
            }
            // Observer require field
            attrs.$observe('required', function (value) {
                scope.required = !!value;
            });

            attrs.$observe('disabled', function (value) {
                scope.disabled = !!value;
            });

            scope.$watch('values', function (newValues) {
                if (newValues && Array.isArray(newValues)) {
                    allValues = [].concat((0, _toConsumableArray3.default)(newValues));
                    scope.filteredValues = [].concat((0, _toConsumableArray3.default)(allValues));
                    if ((newValues.length || 0) <= OFFSET_VALUE) {
                        scope.prevOffset = 0;
                    }
                }
            });

            // Check require or not
            scope.isValid = function () {
                return !!scope.required ? !!scope.selecteditem : true;
            };

            scope.itemIsActive = function (item) {
                return scope.selecteditem && item.Value === scope.selecteditem.Value;
            };

            scope.currentLabel = function updateLabel() {
                var tag = 'span',
                    allItems = [scope.selecteditem] || [],
                    selPrefix = scope.selectedPrefix || DEFAULT_SELECTED_ITEMS,
                    noSelection = $translate.instant(scope.noneSelected) || DEFAULT_NO_SELECTION,
                    label = '';
                if (scope.selecteditem != null) {
                    for (var i = 0; i < allItems.length; i++) {
                        if (scope.itemIsActive(allItems[i])) {
                            label = allItems[i].Key;
                        }
                    }
                }

                if (!label) {
                    if (scope.selecteditem == null || scope.selecteditem == "" || scope.selecteditem == undefined) {
                        label = scope.wrapTag(noSelection, tag);
                        scope.selecteditem = null;
                    }
                }
                return label;
            };

            scope.wrapTag = function (content, tag) {
                return '<' + tag + '>' + content + '</' + tag + '>';
            };

            scope.selectItem = function (item) {
                if (scope.selecteditem) {
                    if (item[scope.key] === scope.selecteditem[scope.key]) {
                        scope.selecteditem = null;
                        scope.textChanged(scope.searchKey);
                        scope.showList = true;
                    } else {
                        scope.selecteditem = item;
                        scope.showList = false;
                        if (!scope.commonSearchFlag) {
                            if (scope.searchKey && scope.searchKey.length > 0) {
                                scope.searchKey = '';
                                scope.prevOffset = 0;
                                scope.onscroll({
                                    searchKey: scope.searchKey,
                                    offset: 0
                                });
                            }
                        } else {
                            if (scope.searchKey) {
                                scope.searchKey = '';
                                scope.totalrecords = allValues.length;
                                scope.values = allValues;
                                scope.filteredValues = allValues;
                            }
                        }
                    }
                } else {
                    scope.selecteditem = item;
                    scope.showList = false;
                    if (!scope.commonSearchFlag) {
                        if (scope.searchKey && scope.searchKey.length > 0) {
                            scope.searchKey = '';
                            scope.prevOffset = 0;
                            scope.onscroll({
                                searchKey: scope.searchKey,
                                offset: 0
                            });
                        }
                    } else {
                        if (scope.searchKey) {
                            scope.searchKey = '';
                            scope.totalrecords = allValues.length;
                            scope.values = allValues;
                            scope.filteredValues = allValues;
                        }
                    }
                }
            };

            scope.isActive = function (item) {
                if (scope.selecteditem) {
                    return item[scope.key] === scope.selecteditem[scope.key];
                } else {
                    return false;
                }
            };

            scope.textChanged = function (searchKey) {
                var updatedValues = _.cloneDeep(scope.updatedValues || []);

                if (allValues.length === 0) {
                    allValues = scope.values.slice();
                }

                if (scope.commonSearchFlag) {
                    if (!searchKey || searchKey.trim() === "") {
                        scope.filteredValues = [].concat((0, _toConsumableArray3.default)(allValues));
                        scope.totalrecords = allValues.length;
                    } else {
                        var filtered = allValues.filter(function (item) {
                            return item.Key.toLowerCase().includes(searchKey.toLowerCase());
                        });
                        scope.filteredValues = filtered;
                        scope.totalrecords = filtered.length;
                    }
                } else {
                    scope.prevOffset = 0;
                    scope.ignoreOutsideClickUntil = Date.now() + 500;
                    scope.onscroll({
                        searchKey: searchKey,
                        offset: 0
                    });
                }
            };

            function setDDHeight() {
                if (scope.values && scope.values.length < 9) {
                    if (scope.hideCount) {
                        $(".dropdownone").css("max-height", 100 + scope.values.length * 30);
                    }
                } else {
                    $(".dropdownone").css("max-height", 'none');
                }
            }

            scope.close = function () {
                setTimeout(function () {
                    if (scope.ignoreOutsideClickUntil && Date.now() < scope.ignoreOutsideClickUntil) {
                        return;
                    }
                    if (!scope.showList) {
                        scope.filteredValues = allValues;
                    }
                    scope.focusedIdx = 0;
                    scope.hideDropdown();
                }, 100);
            };

            scope.show = function () {
                if (allValues && allValues.length === 0) {
                    allValues = scope.values;
                }
                setDDHeight();
                scope.focusedIdx = 0;
                scope.showList = true;
                scope.showDropdown();
                if ((!scope.searchKey || scope.searchKey.length === 0) && scope.values && scope.values.length <= OFFSET_VALUE) {
                    scope.prevOffset = 0;
                    scope.offset = 0;
                }
                if ((!scope.searchKey || scope.searchKey.length === 0) && scope.values && scope.values.length <= OFFSET_VALUE) {
                    scope.prevOffset = 0;
                }
                scope.userScrolled = false;
                var cont = elm.find('.inner-item');
                if (cont && cont.length) cont.scrollTop(0);
            };
            scope.setActive = function (itemIndex) {
                scope.focusedIdx = itemIndex;
            };

            scope.dropdownPressed = function () {
                scope.pressedDropdown = true;
            };

            scope.showDropdown = function () {
                scope.dropdownVisible = true;
                setTimeout(function () {
                    var searchInput = elm.find('.search input');
                    if (searchInput && searchInput.length) {
                        searchInput.focus();
                    }
                }, 100);
            };

            scope.hideDropdown = function () {
                scope.dropdownVisible = false;
            };

            scope.selectPreviousItem = function () {
                var prevIndex = scope.focusedIdx - 1;
                if (prevIndex >= 0) {
                    scope.focusedIdx = prevIndex;
                }
            };

            scope.selectNextItem = function () {
                var nextIndex = scope.focusedIdx + 1;
                if (nextIndex < scope.values.length) {
                    scope.focusedIdx = nextIndex;
                }
            };

            scope.selectActiveItem = function () {
                if (scope.focusedIdx >= 0 && scope.focusedIdx < scope.values.length) {
                    scope.selectItem(scope.values[scope.focusedIdx]);
                }
            };
            $rootScope.$on("documentClicked", function (inner, target) {

                var isSearchBox = $(target[0]).is(".searchandselect") || $(target[0]).parents(".searchandselect").length > 0;
                if (!isSearchBox) scope.$apply(function () {
                    scope.showList = true;
                });
            });
            setTimeout(function () {
                var inner = elm.find(".inner-item");
                var menu = elm.find(".dropdownone");
                inner.on('wheel touchmove', function () {
                    scope.userScrolled = true;
                    scope.ignoreOutsideClickUntil = Date.now() + 800;
                });
                // Mark active interaction on scrollbar drag
                inner.on('mousedown', function () {
                    scope.ignoreOutsideClickUntil = Date.now() + 800;
                });
                menu.on('mousedown', function () {
                    scope.ignoreOutsideClickUntil = Date.now() + 800;
                });

                inner.bind('scroll', function () {
                    var currentItem = $(this);
                    if (!scope.userScrolled && currentItem && currentItem.length && currentItem[0].scrollTop > 0) {
                        scope.userScrolled = true;
                    }
                    var atBottom = currentItem[0].scrollHeight - 1 <= currentItem[0].scrollTop + $(currentItem[0]).height() + 1;
                    if (scope.userScrolled && atBottom) {
                        if (scope.values.length !== scope.totalrecords) {
                            setDDHeight();
                            if (scope.isEdit) {
                                if (scope.values.length <= IS_EDIT_OFFSET_VALUE) scope.offset = 0;
                            } else {
                                if (scope.values.length <= OFFSET_VALUE) if (!scope.hideCount) scope.offset = 0;
                            }
                            if (scope.offset == undefined || scope.offset == 0) {
                                if (!scope.hideCount) scope.offset = scope.values.length || OFFSET_VALUE;else scope.offset = OFFSET_VALUE;
                            } else {
                                scope.offset = scope.values && scope.values.length ? scope.values.length : scope.offset + OFFSET_VALUE;
                            }
                            if (scope.prevOffset == scope.offset) {
                                return;
                            }
                            scope.prevOffset = scope.offset;
                            scope.ignoreOutsideClickUntil = Date.now() + 800;
                            if (scope.isChangeOffset) {
                                if (scope.isChangeOffsetValue <= scope.totalrecords) {
                                    scope.onscroll({
                                        searchKey: scope.searchKey,
                                        offset: scope.offset
                                    });
                                }
                            } else {
                                if (scope.offset <= scope.totalrecords) {
                                    scope.onscroll({
                                        searchKey: scope.searchKey,
                                        offset: scope.offset
                                    });
                                }
                            }
                        }
                    }
                });
            }, 50);
            elm.find(".dropdownone .inner-item").bind('click', function () {
                scope.$apply(function () {
                    scope.onClick();
                });
            });

            $(document).mouseup(function (e) {
                var $menu = $('.dropdownone');
                var isOutside = !$menu.is(e.target) && $menu.has(e.target).length == 0;
                if (isOutside) {
                    scope.$apply(function () {
                        if (scope.ignoreOutsideClickUntil && Date.now() < scope.ignoreOutsideClickUntil) {
                            return;
                        }
                        if (scope.showList == true) {
                            scope.showList = false;
                            if (!scope.commonSearchFlag) {
                                if (scope.searchKey && scope.searchKey.length > 0) {
                                    scope.searchKey = '';
                                    scope.prevOffset = 0;
                                    scope.onscroll({
                                        searchKey: scope.searchKey,
                                        offset: 0
                                    });
                                }
                            } else {
                                if (scope.searchKey) {
                                    scope.searchKey = '';
                                    scope.totalrecords = allValues.length;
                                    scope.values = allValues;
                                    scope.filteredValues = allValues;
                                }
                            }
                        }
                    });
                }
            });

            elm.bind("keydown keypress", function (event) {

                var targetElement = $(event.currentTarget).find('.inner-item');
                switch (event.which) {
                    case 38:
                        event.preventDefault();
                        $($(targetElement)).scrollTop(0);
                        $($(targetElement)).scrollTop($(event.currentTarget).find('.highlight-row:first').position().top - $(event.currentTarget).parent().position().top - 100);
                        scope.$apply(scope.selectPreviousItem());
                        break;
                    case 40:
                        event.preventDefault();
                        $($(targetElement)).scrollTop(0);
                        $($(targetElement)).scrollTop($(event.currentTarget).find('.highlight-row:first').position().top - $(event.currentTarget).parent().position().top - 30);
                        scope.$apply(scope.selectNextItem());
                        break;
                    case 13:
                        if (scope.dropdownVisible && scope.values && scope.values.length > 0) {
                            event.preventDefault();
                            scope.$apply(scope.selectActiveItem());
                        }
                        break;
                }
            });
        }
    };
}];

exports.default = SearchAndSelectDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var searchAutofocusDirective = function searchAutofocusDirective() {
    return {
        restrict: 'A',
        link: function link(scope, elem) {
            setTimeout(function () {
                elem[0].focus();
            }, 100);
        }
    };
};

exports.default = searchAutofocusDirective;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _sound = __webpack_require__(1588);

var _sound2 = _interopRequireDefault(_sound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var soundModule = _angular2.default.module('app.sound', []).factory('Sound', _sound2.default).name;

exports.default = soundModule;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _scanner_beep = __webpack_require__(384);

var _scanner_beep2 = _interopRequireDefault(_scanner_beep);

var _success_beep = __webpack_require__(385);

var _success_beep2 = _interopRequireDefault(_success_beep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SoundFactory = function SoundFactory() {
    var successBeep = function successBeep() {
        return _scanner_beep2.default;
    };

    var errorBeep = function errorBeep() {
        return _success_beep2.default;
    };

    var playSuccessBeep = function playSuccessBeep(id) {
        document.querySelector(id).play();
    };

    var PlayErrorBeep = function PlayErrorBeep(id) {
        document.querySelector(id).play();
    };

    return {
        successBeep: successBeep,
        errorBeep: errorBeep,
        playSuccessBeep: playSuccessBeep,
        PlayErrorBeep: PlayErrorBeep
    };
};

exports.default = SoundFactory;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _storage = __webpack_require__(1590);

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storageModule = _angular2.default.module('store', []).factory('Store', _storage2.default).name;

exports.default = storageModule;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StorageFactory = function StorageFactory() {
    var set = function set(key, value) {
        localStorage.setItem(key, value);
    };

    var get = function get(key) {
        return localStorage.getItem(key);
    };

    var remove = function remove(key) {
        localStorage.removeItem(key);
    };
    var clear = function clear() {
        localStorage.clear();
    };

    return {
        set: set,
        get: get,
        remove: remove,
        clear: clear
    };
};

exports.default = StorageFactory;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _streamCompanyLogo = __webpack_require__(1592);

var _streamCompanyLogo2 = _interopRequireDefault(_streamCompanyLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StreamCompanyLogoModule = _angular2.default.module('stream-company-logo-module', []).directive('streamCompanyLogo', _streamCompanyLogo2.default).name;

exports.default = StreamCompanyLogoModule;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var StreamCompanyLogoDirective = function StreamCompanyLogoDirective(EnvironmentConfigService, CommonLayoutService, Configs) {
    function loadImage(scope, element, attrs) {
        setTimeout(function () {
            var attributes = ['companyLogo', 'assets'];
            var envConfig = Configs.getEnvironmentConfig();

            if (envConfig) {
                var arrayBuffer = envConfig.companyLogo ? envConfig.companyLogo['data'] : [];
                if (scope.setPreviewText) CommonLayoutService.setUIConfig(envConfig.assets);
                setLogo(arrayBuffer, attrs);
            }

            if (!envConfig && scope.loadFromDb) {
                return EnvironmentConfigService.getUIConfigs(attributes).then(function (data) {
                    var envConfig = data.results.environmentConfig;
                    var arrayBuffer = envConfig && envConfig.companyLogo ? envConfig.companyLogo['data'] : [];
                    setLogo(arrayBuffer, attrs);
                    if (scope.setPreviewText) CommonLayoutService.setUIConfig(envConfig.assets);
                }).catch(function (err) {
                    console.log(err);
                });
            }
        }, 100);
    };

    function setLogo(arrayBuffer, attrs) {
        if (!arrayBuffer.length) return;
        var objectURL = CommonLayoutService.generateObjectURL(arrayBuffer);
        attrs.$set('src', objectURL);
        CommonLayoutService.updateFavicon(arrayBuffer);
    }

    return {
        restrict: 'A',
        scope: {
            loadFromDb: '=',
            setPreviewText: '='
        },
        link: loadImage
    };
};

StreamCompanyLogoDirective.$inject = ['EnvironmentConfigService', 'CommonLayoutService', 'Configs'];

exports.default = StreamCompanyLogoDirective;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _streamPrintLogo = __webpack_require__(1594);

var _streamPrintLogo2 = _interopRequireDefault(_streamPrintLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StreamPrintLogoModule = _angular2.default.module('stream-print-logo-module', []).directive('streamPrintLogo', _streamPrintLogo2.default).name;

exports.default = StreamPrintLogoModule;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var StreamPrintLogoDirective = function StreamPrintLogoDirective(EnvironmentConfigService, CommonLayoutService, Configs) {
    function loadImage(scope, element, attrs) {
        var attributes = ['printLogo', 'companyLogo'];
        var envConfig = Configs.getEnvironmentConfig();

        if (envConfig) {
            var printLogo = envConfig.printLogo ? envConfig.printLogo['data'] : [];
            var companyLogo = envConfig.companyLogo ? envConfig.companyLogo['data'] : [];
            setLogo(printLogo, companyLogo, attrs);
        }

        if (!envConfig && scope.loadFromDb) {
            return EnvironmentConfigService.details(attributes).then(function (data) {
                if (!data.results) return;
                var printLogo = data.results.printLogo ? data.results.printLogo['data'] : [];
                var companyLogo = data.results.companyLogo ? data.results.companyLogo['data'] : [];
                setLogo(printLogo, companyLogo, attrs);
            }).catch(function (err) {
                console.log(err);
            });
        }
    };

    function setLogo(printLogo, companyLogo, attrs) {
        if (printLogo.length) {
            var printLogoObjectURL = CommonLayoutService.generateObjectURL(printLogo);
            attrs.$set('src', printLogoObjectURL);
        }
        if (companyLogo.length) CommonLayoutService.updateFavicon(companyLogo);
    }

    return {
        restrict: 'A',
        scope: {
            loadFromDb: "="
        },
        link: loadImage
    };
};

StreamPrintLogoDirective.$inject = ['EnvironmentConfigService', 'CommonLayoutService', 'Configs'];

exports.default = StreamPrintLogoDirective;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _stripPrefix = __webpack_require__(1596);

var _stripPrefix2 = _interopRequireDefault(_stripPrefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StripPrefixModule = _angular2.default.module('strip-prefix-module', []).directive('stripPrefix', _stripPrefix2.default).name;

exports.default = StripPrefixModule;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var StripPrefixDirective = ['ScanConfigService', function (ScanConfigService) {
	return {
		restrict: 'A',
		scope: {
			scanType: '=',
			onPressEnter: '&'
		},
		require: {
			ngModel: 'ngModel'
		},
		link: function link(scope, element, attrs, controller) {
			var isEnterCall = false;
			var ENTER_KEY_CODE = 13;
			var modelValue = void 0;
			var stripPrefix = function stripPrefix() {

				if (controller.ngModel.$modelValue) {
					modelValue = controller.ngModel.$modelValue.trim();
				}

				var scanConfig = ScanConfigService.getScanConfig();

				if (!scanConfig) {
					return;
				}

				if (!controller.ngModel.$modelValue) {
					return;
				}

				var charsToStrip = scanConfig[scope.scanType];

				if (modelValue && charsToStrip) {
					for (var index = 0; index < charsToStrip.length; index++) {
						var charToStrip = charsToStrip[index];

						if (modelValue.toUpperCase().startsWith(charToStrip.toUpperCase())) {

							modelValue = modelValue.substr(1);
							break;
						}
					}

					controller.ngModel.$$rawModelValue = modelValue;
					controller.ngModel.$viewValue = modelValue;
					controller.ngModel.$commitViewValue();
					controller.ngModel.$render();
				}
			};

			element.on('keypress', function (event) {
				if (event.keyCode === ENTER_KEY_CODE && !isEnterCall) {
					isEnterCall = true;
					event.preventDefault();
					event.stopPropagation();
					stripPrefix();

					setTimeout(function () {
						scope.onPressEnter();
					}, 500);
					setTimeout(function () {
						isEnterCall = false;
					}, 1500);
				}
			});

			// element.on('blur', function () {
			// 	stripPrefix()
			// })
		}
	};
}];

exports.default = StripPrefixDirective;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _stripWhitespace = __webpack_require__(1598);

var _stripWhitespace2 = _interopRequireDefault(_stripWhitespace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StripWhiteSpaceModule = _angular2.default.module('Strip-white-space-module', []).directive('stripWhitespace', _stripWhitespace2.default).name;

exports.default = StripWhiteSpaceModule;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var StripWhiteSpaceDirective = function StripWhiteSpaceDirective() {
    return {
        restrict: 'A',
        scope: {
            scanType: '=',
            onPressEnter: '&'
        },
        require: {
            ngModel: 'ngModel'
        },
        link: function link(scope, element, attrs, controller) {
            var ENTER_KEY_CODE = 13;
            var modelValue = void 0;
            var stripWhiteSpace = function stripWhiteSpace() {
                if (controller.ngModel.$modelValue) {
                    modelValue = controller.ngModel.$modelValue.trim();
                }

                if (!controller.ngModel.$modelValue) {
                    return;
                }

                controller.ngModel.$$rawModelValue = modelValue;
                controller.ngModel.$viewValue = modelValue;
                controller.ngModel.$commitViewValue();
                controller.ngModel.$render();
            };

            element.on('keypress', function (event) {
                if (event.keyCode === ENTER_KEY_CODE) {
                    // event.preventDefault();
                    // event.stopPropagation();
                    stripWhiteSpace();

                    setTimeout(function () {
                        scope.onPressEnter();
                    }, 500);
                }
            });

            element.on('blur', function () {
                stripWhiteSpace();
            });
        }
    };
};

exports.default = StripWhiteSpaceDirective;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _timezoneList = __webpack_require__(1600);

var _timezoneList2 = _interopRequireDefault(_timezoneList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimezoneModule = _angular2.default.module('app.timezone-list', []).factory('TimezoneList', _timezoneList2.default).name;

exports.default = TimezoneModule;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var timezoneFactory = function timezoneFactory() {
    var getTimezoneList = function getTimezoneList() {
        return [{
            label: 'Browser Timezone',
            value: moment.tz.guess()
        }, {
            label: 'AKST9AKDT',
            value: 'US/Alaska'
        }, {
            label: 'AST4ADT',
            value: 'Canada/Atlantic'
        }, {
            label: 'CST6CDT',
            value: 'CST6CDT'
        }, {
            label: 'EST5EDT',
            value: 'EST5EDT'
        }, {
            label: 'HST10HDT',
            value: 'US/Hawaii'
        }, {
            label: 'MST7MDT',
            value: 'MST7MDT'
        }, {
            label: 'PST8PDT',
            value: 'PST8PDT'
        }, {
            label: 'AKST',
            value: 'Etc/GMT+9'
        }, {
            label: 'AST',
            value: 'Etc/GMT+4'
        }, {
            label: 'CST',
            value: 'Etc/GMT+6'
        }, {
            label: 'EST',
            value: 'Etc/GMT+5'
        }, {
            label: 'HST',
            value: 'Etc/GMT+10'
        }, {
            label: 'MST',
            value: 'Etc/GMT+7'
        }, {
            label: 'PST',
            value: 'Etc/GMT+8'
        }];
    };

    return {
        getTimezoneList: getTimezoneList
    };
};

timezoneFactory.$inject = [];

exports.default = timezoneFactory;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _changePassword = __webpack_require__(2497);

var _changePassword2 = _interopRequireDefault(_changePassword);

var _changePassword3 = __webpack_require__(1602);

var _changePassword4 = _interopRequireDefault(_changePassword3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var changePassword = {
    restrict: 'E',
    bindings: {
        modelDetails: '=',
        onConfirm: '=',
        onError: '=',
        event: '='
    },
    template: _changePassword2.default,
    controller: _changePassword4.default
};

exports.default = changePassword;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangePasswordController = function () {
	/*@ngInject*/
	ChangePasswordController.$inject = ["$translate", "UsersService", "Modal", "$scope", "User"];
	function ChangePasswordController($translate, UsersService, Modal, $scope, User) {
		(0, _classCallCheck3.default)(this, ChangePasswordController);

		this.$translate = $translate;
		this.UsersService = UsersService;
		this.Modal = Modal;
		this.User = User;
		this.model = {
			userId: '',
			password: null,
			cnfPassword: null,
			passwordPolicy: null
		};
		this.errorMessage = null;
		this.passIcon = {
			pass: false,
			cpass: false
		};
	}

	(0, _createClass3.default)(ChangePasswordController, [{
		key: 'focusElementById',
		value: function focusElementById(id) {
			setTimeout(function () {
				document.getElementById(id).focus();
			}, 300);
		}
	}, {
		key: '$onInit',
		value: function $onInit() {
			this.focusElementById(this.modelDetails.isWebPassword ? 'password' : 'read_password');
		}
	}, {
		key: 'changePassword',
		value: function changePassword() {
			var _this = this;

			this.loading = true;
			var passwordKey = this.modelDetails.isWebPassword ? 'password' : 'hhtPassword',
			    savedata = (0, _defineProperty3.default)({
				id: this.modelDetails.id
			}, passwordKey, this.model.password || null);

			this.UsersService.update(this.modelDetails.id, savedata).then(function (data) {
				if (data.error) return _this.Modal.errorModal(data.error);
				_this.onConfirm(_this.modelDetails.id, data);
			}).catch(function (err) {
				console.log(err);
				if (err && err.data && err.data.message) return _this.Modal.errorModal(err.data.message);else return _this.onError(err);
			}).finally(function () {
				_this.loading = false;
			});
		}
	}, {
		key: 'showPassword',
		value: function showPassword(type) {
			this.passIcon[type] = !this.passIcon[type];
		}
	}, {
		key: 'changeWebPassword',
		value: function changeWebPassword() {
			var _this2 = this;

			this.UsersService.changeWebPassword(this.User.getUser().id, this.User.getUser().branchId, this.modelDetails.id, this.model.password).then(function (data) {
				_this2.loading = false;
				if (data && data.message == 'failed') {
					_this2.model.passwordPolicy = data;
					_this2.model.password = null;
					_this2.model.cnfPassword = null;
					return;
				} else {
					_this2.model.passwordPolicy = null;
				}
				_this2.onConfirm(_this2.modelDetails.id, data);
			}).catch(function (err) {
				console.log(err);
				if (err && err.data && err.data.message) {
					return _this2.Modal.errorModal(err.data.message);
				}
			});
		}
	}]);
	return ChangePasswordController;
}();

exports.default = ChangePasswordController;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmSupervisorController = function () {
  /*@ngInject*/
  ConfirmSupervisorController.$inject = ["$translate", "ScanService", "Modal", "$scope", "User"];
  function ConfirmSupervisorController($translate, ScanService, Modal, $scope, User) {
    (0, _classCallCheck3.default)(this, ConfirmSupervisorController);

    this.$translate = $translate;
    this.ScanService = ScanService;
    this.Modal = Modal;
    this.model = {
      id: '',
      password: '',
      branchId: User.getUser().branchId
    };
    this.errorMessage = null;
    this.loading = false;
  }

  (0, _createClass3.default)(ConfirmSupervisorController, [{
    key: 'focusElementById',
    value: function focusElementById(id) {
      setTimeout(function () {
        document.getElementById(id).focus();
      }, 300);
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      this.focusElementById('sup-id');
    }
  }, {
    key: 'confirmSupervisor',
    value: function confirmSupervisor() {
      var _this = this;

      if (this.loading) {
        return;
      }
      this.errorMessage = null;
      if (!this.model.id) {
        this.errorMessage = this.$translate.instant('confirmSupervisorModal.idMissing');
        this.focusElementById('sup-id');
        return;
      }
      if (!this.model.password) {
        this.errorMessage = this.$translate.instant('confirmSupervisorModal.passwordMissing');
        this.focusElementById('sup-password');
        return;
      }
      this.loading = true;
      this.ScanService.scanSupervisor(this.model.id, this.model.password, this.event, this.model.branchId, this.details).then(function (data) {
        if (data.error) {
          // this.loading = false;
          return _this.Modal.errorModal(data.error);
          // return this.onError(data.error)
        }
        _this.onConfirm(_this.model.id.toString(), data, _this.model.convertToPickup);
      }).catch(function (err) {
        // this.focusElementById('sup-password');
        if (err && err.data && err.data.message) {
          _this.loading = false;
          return _this.Modal.errorModal(err.data.message);
        } else {
          return _this.onError(err);
        }
      });
    }
  }]);
  return ConfirmSupervisorController;
}();

exports.default = ConfirmSupervisorController;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _confirmSupervisor = __webpack_require__(2498);

var _confirmSupervisor2 = _interopRequireDefault(_confirmSupervisor);

var _confirmSupervisor3 = __webpack_require__(1603);

var _confirmSupervisor4 = _interopRequireDefault(_confirmSupervisor3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var confirmSupervisor = {
    restrict: 'E',
    bindings: {
        onConfirm: '=',
        onError: '=',
        event: '=',
        details: '=',
        buttonText: '=',
        buttonStyle: '='
    },
    template: _confirmSupervisor2.default,
    controller: _confirmSupervisor4.default
};

exports.default = confirmSupervisor;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _modal = __webpack_require__(1606);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modalModule = _angular2.default.module('app.ui', []).factory('Modal', _modal2.default).name;

exports.default = modalModule;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, Buffer) {Object.defineProperty(exports,"__esModule",{value:true});var _getIterator2=__webpack_require__(35);var _getIterator3=_interopRequireDefault(_getIterator2);var _map=__webpack_require__(76);var _map2=_interopRequireDefault(_map);var _stringify=__webpack_require__(18);var _stringify2=_interopRequireDefault(_stringify);var _entries=__webpack_require__(41);var _entries2=_interopRequireDefault(_entries);var _keys=__webpack_require__(10);var _keys2=_interopRequireDefault(_keys);var _set=__webpack_require__(46);var _set2=_interopRequireDefault(_set);var _from=__webpack_require__(75);var _from2=_interopRequireDefault(_from);var _promise=__webpack_require__(14);var _promise2=_interopRequireDefault(_promise);var _values=__webpack_require__(45);var _values2=_interopRequireDefault(_values);var _typeof2=__webpack_require__(32);var _typeof3=_interopRequireDefault(_typeof2);var _assign=__webpack_require__(19);var _assign2=_interopRequireDefault(_assign);var _slicedToArray2=__webpack_require__(24);var _slicedToArray3=_interopRequireDefault(_slicedToArray2);var _toConsumableArray2=__webpack_require__(37);var _toConsumableArray3=_interopRequireDefault(_toConsumableArray2);var _defineProperty2=__webpack_require__(36);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends2=__webpack_require__(28);var _extends3=_interopRequireDefault(_extends2);var _modal=__webpack_require__(2499);var _modal2=_interopRequireDefault(_modal);var _shipmentSelection=__webpack_require__(2616);var _shipmentSelection2=_interopRequireDefault(_shipmentSelection);var _confirmSupervisor=__webpack_require__(2532);var _confirmSupervisor2=_interopRequireDefault(_confirmSupervisor);var _checkedInAddBag=__webpack_require__(2524);var _checkedInAddBag2=_interopRequireDefault(_checkedInAddBag);var _checkedInAdHocCheckin=__webpack_require__(2523);var _checkedInAdHocCheckin2=_interopRequireDefault(_checkedInAdHocCheckin);var _checkedoutAddBag=__webpack_require__(2525);var _checkedoutAddBag2=_interopRequireDefault(_checkedoutAddBag);var _surchargeDetails=__webpack_require__(2620);var _surchargeDetails2=_interopRequireDefault(_surchargeDetails);var _storedSurchargeDetails=__webpack_require__(2619);var _storedSurchargeDetails2=_interopRequireDefault(_storedSurchargeDetails);var _surchargeHistory=__webpack_require__(2621);var _surchargeHistory2=_interopRequireDefault(_surchargeHistory);var _forceCheckin=__webpack_require__(2550);var _forceCheckin2=_interopRequireDefault(_forceCheckin);var _routeThrowShipmentList=__webpack_require__(2598);var _routeThrowShipmentList2=_interopRequireDefault(_routeThrowShipmentList);var _closeRoute=__webpack_require__(2529);var _closeRoute2=_interopRequireDefault(_closeRoute);var _closeBagout=__webpack_require__(2528);var _closeBagout2=_interopRequireDefault(_closeBagout);var _selectDeliveryLocation=__webpack_require__(2603);var _selectDeliveryLocation2=_interopRequireDefault(_selectDeliveryLocation);var _forceCloseRoute=__webpack_require__(2552);var _forceCloseRoute2=_interopRequireDefault(_forceCloseRoute);var _itemNotDelivered=__webpack_require__(2559);var _itemNotDelivered2=_interopRequireDefault(_itemNotDelivered);var _commitSuccess=__webpack_require__(2531);var _commitSuccess2=_interopRequireDefault(_commitSuccess);var _uploadedFileSelection=__webpack_require__(2631);var _uploadedFileSelection2=_interopRequireDefault(_uploadedFileSelection);var _addLocation=__webpack_require__(2500);var _addLocation2=_interopRequireDefault(_addLocation);var _verifyHoldShipments=__webpack_require__(2634);var _verifyHoldShipments2=_interopRequireDefault(_verifyHoldShipments);var _forceCloseHold=__webpack_require__(2551);var _forceCloseHold2=_interopRequireDefault(_forceCloseHold);var _verifyHoldRelease=__webpack_require__(2633);var _verifyHoldRelease2=_interopRequireDefault(_verifyHoldRelease);var _itemHoldLog=__webpack_require__(2558);var _itemHoldLog2=_interopRequireDefault(_itemHoldLog);var _verifyItemReturn=__webpack_require__(2635);var _verifyItemReturn2=_interopRequireDefault(_verifyItemReturn);var _routeDetails=__webpack_require__(2593);var _routeDetails2=_interopRequireDefault(_routeDetails);var _routeMessenger=__webpack_require__(2594);var _routeMessenger2=_interopRequireDefault(_routeMessenger);var _locationHoldRelease=__webpack_require__(2562);var _locationHoldRelease2=_interopRequireDefault(_locationHoldRelease);var _bulkVerifyComment=__webpack_require__(2519);var _bulkVerifyComment2=_interopRequireDefault(_bulkVerifyComment);var _success_beep=__webpack_require__(385);var _success_beep2=_interopRequireDefault(_success_beep);var _scanner_beep=__webpack_require__(384);var _scanner_beep2=_interopRequireDefault(_scanner_beep);var _routeTransfer=__webpack_require__(2599);var _routeTransfer2=_interopRequireDefault(_routeTransfer);var _translateMessage=__webpack_require__(2623);var _translateMessage2=_interopRequireDefault(_translateMessage);var _orderPack=__webpack_require__(2576);var _orderPack2=_interopRequireDefault(_orderPack);var _orderPackHold=__webpack_require__(2577);var _orderPackHold2=_interopRequireDefault(_orderPackHold);var _orderPackReturn=__webpack_require__(2578);var _orderPackReturn2=_interopRequireDefault(_orderPackReturn);var _checkoutAddItems=__webpack_require__(2527);var _checkoutAddItems2=_interopRequireDefault(_checkoutAddItems);var _changePassword=__webpack_require__(2521);var _changePassword2=_interopRequireDefault(_changePassword);var _timeoutCountdown=__webpack_require__(2622);var _timeoutCountdown2=_interopRequireDefault(_timeoutCountdown);var _residualComment=__webpack_require__(2589);var _residualComment2=_interopRequireDefault(_residualComment);var _holdReason=__webpack_require__(2554);var _holdReason2=_interopRequireDefault(_holdReason);var _convertToCrv=__webpack_require__(2533);var _convertToCrv2=_interopRequireDefault(_convertToCrv);var _deletedReason=__webpack_require__(2541);var _deletedReason2=_interopRequireDefault(_deletedReason);var _atmResidualReceipt=__webpack_require__(2505);var _atmResidualReceipt2=_interopRequireDefault(_atmResidualReceipt);var _balanceSheetInfo=__webpack_require__(2510);var _balanceSheetInfo2=_interopRequireDefault(_balanceSheetInfo);var _routeDelivriesInfoTemplate=__webpack_require__(2592);var _routeDelivriesInfoTemplate2=_interopRequireDefault(_routeDelivriesInfoTemplate);var _coinShiptypeList=__webpack_require__(2530);var _coinShiptypeList2=_interopRequireDefault(_coinShiptypeList);var _stopTransfer=__webpack_require__(2618);var _stopTransfer2=_interopRequireDefault(_stopTransfer);var _routeSequence=__webpack_require__(2595);var _routeSequence2=_interopRequireDefault(_routeSequence);var _remainingResidual=__webpack_require__(2586);var _remainingResidual2=_interopRequireDefault(_remainingResidual);var _remainingToThrow=__webpack_require__(2587);var _remainingToThrow2=_interopRequireDefault(_remainingToThrow);var _routeCheckoutInfo=__webpack_require__(2591);var _routeCheckoutInfo2=_interopRequireDefault(_routeCheckoutInfo);var _routeCheckinInfo=__webpack_require__(2590);var _routeCheckinInfo2=_interopRequireDefault(_routeCheckinInfo);var _pendingPack=__webpack_require__(2580);var _pendingPack2=_interopRequireDefault(_pendingPack);var _branchTransfer=__webpack_require__(2515);var _branchTransfer2=_interopRequireDefault(_branchTransfer);var _internalDelivery=__webpack_require__(2556);var _internalDelivery2=_interopRequireDefault(_internalDelivery);var _editTrackingId=__webpack_require__(2549);var _editTrackingId2=_interopRequireDefault(_editTrackingId);var _depositPackingInfo=__webpack_require__(2544);var _depositPackingInfo2=_interopRequireDefault(_depositPackingInfo);var _lockStatus=__webpack_require__(2564);var _lockStatus2=_interopRequireDefault(_lockStatus);var _ledgerTransactionLog=__webpack_require__(2561);var _ledgerTransactionLog2=_interopRequireDefault(_ledgerTransactionLog);var _atmCodesInfo=__webpack_require__(2503);var _atmCodesInfo2=_interopRequireDefault(_atmCodesInfo);var _moveShipment=__webpack_require__(2573);var _moveShipment2=_interopRequireDefault(_moveShipment);var _updateShipmentTrackingId=__webpack_require__(2628);var _updateShipmentTrackingId2=_interopRequireDefault(_updateShipmentTrackingId);var _autoOpenLocks=__webpack_require__(2506);var _autoOpenLocks2=_interopRequireDefault(_autoOpenLocks);var _checkinForceClose=__webpack_require__(2526);var _checkinForceClose2=_interopRequireDefault(_checkinForceClose);var _shipmentNotPickedUp=__webpack_require__(2615);var _shipmentNotPickedUp2=_interopRequireDefault(_shipmentNotPickedUp);var _bulkUpdateUserPermissions=__webpack_require__(2518);var _bulkUpdateUserPermissions2=_interopRequireDefault(_bulkUpdateUserPermissions);__webpack_require__(2921);var _app=__webpack_require__(5);var _app2=_interopRequireDefault(_app);var _markAsDelivered=__webpack_require__(2570);var _markAsDelivered2=_interopRequireDefault(_markAsDelivered);var _holdShipmentList=__webpack_require__(2555);var _holdShipmentList2=_interopRequireDefault(_holdShipmentList);var _lastOrderInfo=__webpack_require__(2560);var _lastOrderInfo2=_interopRequireDefault(_lastOrderInfo);var _serviceOrderDetails=__webpack_require__(2608);var _serviceOrderDetails2=_interopRequireDefault(_serviceOrderDetails);var _serviceOrderNotes=__webpack_require__(2609);var _serviceOrderNotes2=_interopRequireDefault(_serviceOrderNotes);var _undoPackedOrder=__webpack_require__(2625);var _undoPackedOrder2=_interopRequireDefault(_undoPackedOrder);var _serviceOrderStatusUpdate=__webpack_require__(2610);var _serviceOrderStatusUpdate2=_interopRequireDefault(_serviceOrderStatusUpdate);var _serviceOrderAssign=__webpack_require__(2606);var _serviceOrderAssign2=_interopRequireDefault(_serviceOrderAssign);var _serviceOrderCreate=__webpack_require__(2607);var _serviceOrderCreate2=_interopRequireDefault(_serviceOrderCreate);var _shipmentList=__webpack_require__(2614);var _shipmentList2=_interopRequireDefault(_shipmentList);var _routeStopList=__webpack_require__(2597);var _routeStopList2=_interopRequireDefault(_routeStopList);var _createActionCode=__webpack_require__(2534);var _createActionCode2=_interopRequireDefault(_createActionCode);var _changeDestination=__webpack_require__(2520);var _changeDestination2=_interopRequireDefault(_changeDestination);var _serviceOrderActions=__webpack_require__(2605);var _serviceOrderActions2=_interopRequireDefault(_serviceOrderActions);var _pendingCancelShipments=__webpack_require__(2579);var _pendingCancelShipments2=_interopRequireDefault(_pendingCancelShipments);var _bagoutList=__webpack_require__(2508);var _bagoutList2=_interopRequireDefault(_bagoutList);var _bulkCashAdjustComment=__webpack_require__(2516);var _bulkCashAdjustComment2=_interopRequireDefault(_bulkCashAdjustComment);var _shipmentImage=__webpack_require__(2613);var _shipmentImage2=_interopRequireDefault(_shipmentImage);var _bagoutsOnHoldList=__webpack_require__(2509);var _bagoutsOnHoldList2=_interopRequireDefault(_bagoutsOnHoldList);var _saveLocationLater=__webpack_require__(2601);var _saveLocationLater2=_interopRequireDefault(_saveLocationLater);var _saveRouteChangesLater=__webpack_require__(2602);var _saveRouteChangesLater2=_interopRequireDefault(_saveRouteChangesLater);var _billingContractRules=__webpack_require__(2512);var _billingContractRules2=_interopRequireDefault(_billingContractRules);var _approveBillingRecords=__webpack_require__(2502);var _approveBillingRecords2=_interopRequireDefault(_approveBillingRecords);var _billableEventLog=__webpack_require__(2511);var _billableEventLog2=_interopRequireDefault(_billableEventLog);var _stopComments=__webpack_require__(2617);var _stopComments2=_interopRequireDefault(_stopComments);var _createLanguageMessage=__webpack_require__(2538);var _createLanguageMessage2=_interopRequireDefault(_createLanguageMessage);var _createFuelSurchageCustomer=__webpack_require__(2537);var _createFuelSurchageCustomer2=_interopRequireDefault(_createFuelSurchageCustomer);var _fuelSurchargeLocations=__webpack_require__(2553);var _fuelSurchargeLocations2=_interopRequireDefault(_fuelSurchargeLocations);var _routesInfo=__webpack_require__(2600);var _routesInfo2=_interopRequireDefault(_routesInfo);var _editDeliveryShipment=__webpack_require__(2546);var _editDeliveryShipment2=_interopRequireDefault(_editDeliveryShipment);var _editPickupShipment=__webpack_require__(2547);var _editPickupShipment2=_interopRequireDefault(_editPickupShipment);var _shipmentAssociateToTanker=__webpack_require__(2612);var _shipmentAssociateToTanker2=_interopRequireDefault(_shipmentAssociateToTanker);var _uploadFiles=__webpack_require__(2630);var _uploadFiles2=_interopRequireDefault(_uploadFiles);var _markUndeliveredWithCRV=__webpack_require__(2571);var _markUndeliveredWithCRV2=_interopRequireDefault(_markUndeliveredWithCRV);var _appLogo=__webpack_require__(2501);var _appLogo2=_interopRequireDefault(_appLogo);var _atmLoadShipment=__webpack_require__(2504);var _atmLoadShipment2=_interopRequireDefault(_atmLoadShipment);var _pickupDeliveryShipment=__webpack_require__(2582);var _pickupDeliveryShipment2=_interopRequireDefault(_pickupDeliveryShipment);var _notDeliveredResolution2=__webpack_require__(2575);var _notDeliveredResolution3=_interopRequireDefault(_notDeliveredResolution2);var _pickupHoldRelease=__webpack_require__(2583);var _pickupHoldRelease2=_interopRequireDefault(_pickupHoldRelease);var _duplicateStopsInfo=__webpack_require__(2545);var _duplicateStopsInfo2=_interopRequireDefault(_duplicateStopsInfo);var _branchMgmtCloseBagout=__webpack_require__(2514);var _branchMgmtCloseBagout2=_interopRequireDefault(_branchMgmtCloseBagout);var _makeDeliverable=__webpack_require__(2568);var _makeDeliverable2=_interopRequireDefault(_makeDeliverable);var _rescheduleDeliveries=__webpack_require__(2588);var _rescheduleDeliveries2=_interopRequireDefault(_rescheduleDeliveries);var _logisticItemAssign=__webpack_require__(2565);var _logisticItemAssign2=_interopRequireDefault(_logisticItemAssign);var _logisticItemList=__webpack_require__(2567);var _logisticItemList2=_interopRequireDefault(_logisticItemList);var _logisticItemHoldRelease=__webpack_require__(2566);var _logisticItemHoldRelease2=_interopRequireDefault(_logisticItemHoldRelease);var _serviceTicketResolveImageTemplate=__webpack_require__(2611);var _serviceTicketResolveImageTemplate2=_interopRequireDefault(_serviceTicketResolveImageTemplate);var _previewTicketPictures=__webpack_require__(2585);var _previewTicketPictures2=_interopRequireDefault(_previewTicketPictures);var _uploadContractDocument=__webpack_require__(2629);var _uploadContractDocument2=_interopRequireDefault(_uploadContractDocument);var _viewContractDocument=__webpack_require__(2636);var _viewContractDocument2=_interopRequireDefault(_viewContractDocument);var _updateBillingRecords=__webpack_require__(2626);var _updateBillingRecords2=_interopRequireDefault(_updateBillingRecords);var _sendStopReceipt=__webpack_require__(2604);var _sendStopReceipt2=_interopRequireDefault(_sendStopReceipt);var _changeShiptype=__webpack_require__(2522);var _changeShiptype2=_interopRequireDefault(_changeShiptype);var _bulkImportLocation=__webpack_require__(2517);var _bulkImportLocation2=_interopRequireDefault(_bulkImportLocation);var _itemHistory=__webpack_require__(2557);var _itemHistory2=_interopRequireDefault(_itemHistory);var _createServiceChecklist=__webpack_require__(2540);var _createServiceChecklist2=_interopRequireDefault(_createServiceChecklist);var _createAtmMake=__webpack_require__(2535);var _createAtmMake2=_interopRequireDefault(_createAtmMake);var _createServiceActionPriority=__webpack_require__(2539);var _createServiceActionPriority2=_interopRequireDefault(_createServiceActionPriority);var _nextScheduledOccurences=__webpack_require__(2574);var _nextScheduledOccurences2=_interopRequireDefault(_nextScheduledOccurences);var _bagRemoveConfirmation=__webpack_require__(2507);var _bagRemoveConfirmation2=_interopRequireDefault(_bagRemoveConfirmation);var _postBillingRecord=__webpack_require__(2584);var _postBillingRecord2=_interopRequireDefault(_postBillingRecord);var _createBillingRecords=__webpack_require__(2536);var _createBillingRecords2=_interopRequireDefault(_createBillingRecords);var _locationLogs=__webpack_require__(2563);var _locationLogs2=_interopRequireDefault(_locationLogs);var _branchFundingSourceDenominations=__webpack_require__(2513);var _branchFundingSourceDenominations2=_interopRequireDefault(_branchFundingSourceDenominations);var _deliveryServiceTransaction=__webpack_require__(2542);var _deliveryServiceTransaction2=_interopRequireDefault(_deliveryServiceTransaction);var _verifyBagoutCashCount=__webpack_require__(2632);var _verifyBagoutCashCount2=_interopRequireDefault(_verifyBagoutCashCount);var _editScheduledOrders=__webpack_require__(2548);var _editScheduledOrders2=_interopRequireDefault(_editScheduledOrders);var _pendingShipmentTransfer=__webpack_require__(2581);var _pendingShipmentTransfer2=_interopRequireDefault(_pendingShipmentTransfer);var _updateServiceHistory=__webpack_require__(2627);var _updateServiceHistory2=_interopRequireDefault(_updateServiceHistory);var _denominationBreakdown=__webpack_require__(2543);var _denominationBreakdown2=_interopRequireDefault(_denominationBreakdown);var _routeServiceTickets=__webpack_require__(2596);var _routeServiceTickets2=_interopRequireDefault(_routeServiceTickets);var _masterCashOrderDetails=__webpack_require__(2572);var _masterCashOrderDetails2=_interopRequireDefault(_masterCashOrderDetails);var _markAllDeliveredList=__webpack_require__(2569);var _markAllDeliveredList2=_interopRequireDefault(_markAllDeliveredList);var _uncoveredLocations=__webpack_require__(2624);var _uncoveredLocations2=_interopRequireDefault(_uncoveredLocations);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import scheduledATMShipmentTemplate from './templates/scheduledATMShipment.html'
var generateQueryForReason=function generateQueryForReason(messageType){return{queryJSON:{rules:[{field:'type',condition:'IN',data:messageType}],operator:'AND'}};};// import serviceOrderStatusHistoryEditTemplate from './templates/serviceOrderStatusHistoryEdit.html';
// import createCompanyTemplate from './templates/createCompany.html';
var focusElementById=function focusElementById(id){var element=document.getElementById(id);if(element){setTimeout(function(){element.focus();},800);}};var rejectModal=function rejectModal(modal,negative){modal.result.then(function(result){// console.log('client: resolved: ');
},function(reason){negative({modal:null});});};var LIMIT=10,MAXLIMIT=1000;var ModalFactory=function ModalFactory($uibModal,$translate){var _this=this;/**
   *  Example:
   *
   *  this.Modal.alert({header: 'Record Deleted', message: 'We have removed the branch', callback: ({modal}) => {
   *    modal.close()
   *  }})
   */var alert=function alert(data){confirm((0,_extends3.default)({},data,{buttons:['common.ok']}));};/*
   *  Example:
   *
   *  this.Modal.confirm({header: 'Confirm Delete', message: `Are you sure you want to delete?`, callback: ({modal, $scope}) => {
   *
   *    $scope.loading = true;
   *    $scope.loadingMessage = 'Please wait...'
   *    $scope.errorMessage = 'Some error.'
   *
   *    setTimeout(() => {
   *      modal.close()
   *    }, 5000)
   *  }, size: 'md', type: 'danger'})
   */var confirm=function confirm(_ref){var header=_ref.header,message=_ref.message,_ref$callback=_ref.callback,callback=_ref$callback===undefined?function(_ref2){var modal=_ref2.modal;modal.close();}:_ref$callback,_ref$autoClose=_ref.autoClose,autoClose=_ref$autoClose===undefined?'true':_ref$autoClose,_ref$negative=_ref.negative,negative=_ref$negative===undefined?function(_ref3){var modal=_ref3.modal;modal.close();}:_ref$negative,_ref$size=_ref.size,size=_ref$size===undefined?'md':_ref$size,_ref$buttons=_ref.buttons,buttons=_ref$buttons===undefined?['common.ok','common.cancel']:_ref$buttons,_ref$type=_ref.type,type=_ref$type===undefined?'primary':_ref$type;var modal=$uibModal.open({// keyboard: false,
animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:autoClose?'static':'true',template:_modal2.default,size:size,controller:['$scope',function($scope){$scope.header=header;$scope.message=message;$scope.buttons=buttons;$scope.type=type;$scope.ok=function(){if($scope.isLoading)return;$scope.isLoading=true;callback({modal:modal,$scope:$scope});};$scope.cancel=function(){negative({modal:modal,$scope:$scope});$scope.isLoading=false;};}]});modal.result.then(function(){},function(){negative({modal:modal});});};var routeThrowShipmentListModal=function routeThrowShipmentListModal(title,shipments,isThrown){return $uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_routeThrowShipmentList2.default,size:'lg',controller:['$scope','$uibModalInstance','Navigation','$state',function($scope,$uibModalInstance,Navigation,$state){$scope.title=title;$scope.shipments=shipments;$scope.isThrown=isThrown;$scope.close=function(){$uibModalInstance.dismiss('cancel');};$scope.goToShipment=function(trackingId){$uibModalInstance.dismiss('cancel');$state.go('branchManagement.items',{id:trackingId});};$scope.goToServiceHistory=function(data){return Navigation.goToServiceHistory(data.toLocationId,null,true,$uibModalInstance);};$scope.getLocationUrl=function(data){return $state.href('branchManagement.locations',{locationId:data.toLocationId},{absolute:true});};$scope.onLocationClick=function(event,data){if(event.ctrlKey||event.metaKey||event.button===1){return;}event.preventDefault();$scope.goToServiceHistory(data);};}]}).result.catch(function(){});};// fuzzyMatching for route throw screen
var routeThrowShipmentSelectionModal=function routeThrowShipmentSelectionModal(addBagStructure,choices,callback,negative){var selectionModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_shipmentSelection2.default,size:'lg',controller:['$scope',function($scope){$scope.choices=choices;$scope.selectedIndex=-1;$scope.displayAddBagButton=!!addBagStructure;$scope.loading=false;$scope.setSelected=function(index){$scope.selectedIndex=index;};$scope.keyPressed=function($event){var ESC_KEY_CODE=27;if($event.keyCode===ESC_KEY_CODE){negative({modal:selectionModal});}};$scope.selectItem=function(){if($scope.loading)return;$scope.loading=true;confirmSupervisor('checkin-item-selected',function(_ref4){var modal=_ref4.modal,supId=_ref4.supId;callback({modal:selectionModal,selected:choices[$scope.selectedIndex],supervisorId:supId});modal.close();},function(_ref5){var modal=_ref5.modal;$scope.loading=false;modal.close();});};$scope.cancel=function(){negative({modal:selectionModal});};}]});};var checkedInShipmentSelectionModal=function checkedInShipmentSelectionModal(addBagStructure,choices,callback,negative){var selectionModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_shipmentSelection2.default,size:'lg',controller:['$scope',function($scope){$scope.loading=false;$scope.choices=choices;$scope.selectedIndex=-1;$scope.displayAddBagButton=!!addBagStructure;$scope.setSelected=function(index){$scope.selectedIndex=index;};$scope.showAddBagModal=function(){if($scope.loading)return;$scope.loading=true;checkedInForceAddBag(addBagStructure,function(_ref6){var addBagModal=_ref6.modal,$scope=_ref6.$scope;addBagModal.close();callback({modal:selectionModal,isCreated:true,selected:$scope.bag});},function(_ref7){var addBagModal=_ref7.modal;$scope.loading=false;if(addBagModal)addBagModal.close();});};focusElementById('tab0');$scope.selectItem=function(){if($scope.itemSelected){return;}$scope.itemSelected=true;confirmSupervisor('checkin-item-selected',function(_ref8){var modal=_ref8.modal,supId=_ref8.supId;callback({modal:selectionModal,selected:choices[$scope.selectedIndex],supervisorId:supId});modal.close();},function(_ref9){var modal=_ref9.modal;$scope.itemSelected=false;modal.close();});};$scope.cancel=function(){$scope.itemSelected=false;negative({modal:selectionModal});};}]});rejectModal(selectionModal,negative);};// shipment selection modal for checkout
var checkedOutShipmentSelectionModal=function checkedOutShipmentSelectionModal(addBagStructure,choices,callback,negative){var selectionModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_shipmentSelection2.default,size:'lg',controller:['$scope',function($scope){$scope.itemSelected=false;$scope.choices=choices;$scope.selectedIndex=-1;$scope.displayAddBagButton=!!addBagStructure;focusElementById('tab0');$scope.setSelected=function(index){$scope.selectedIndex=index;};$scope.showAddBagModal=function(){if($scope.loading)return;$scope.loading=true;checkedoutForceAddBag(addBagStructure,function(_ref10){var addBagModal=_ref10.modal,$scope=_ref10.$scope;addBagModal.close();$scope.loading=false;callback({modal:selectionModal,isCreated:true,selected:$scope.bag});},function(_ref11){var addBagModal=_ref11.modal;$scope.loading=false;addBagModal.close();});};$scope.selectItem=function(){// if ( $scope.loading) return;          
$scope.itemSelected=true;confirmSupervisor('checkin-item-selected',function(_ref12){var modal=_ref12.modal,supId=_ref12.supId;modal.close();callback({modal:selectionModal,selected:choices[$scope.selectedIndex],supervisorId:supId});},function(_ref13){var modal=_ref13.modal;$scope.itemSelected=false;modal.close();});};$scope.cancel=function(){negative({modal:selectionModal});};}]});rejectModal(selectionModal,negative);};var confirmSupervisor=function confirmSupervisor(event,details,callback,negative){var modal=$uibModal.open({keyboard:false,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_confirmSupervisor2.default,size:'md',controller:['$scope','$rootScope',function($scope,$rootScope){$scope.event=event;$scope.details=details;$scope.loading=false;$scope.ok=function(supId,data,convertToPickup){$rootScope.supervisorIds=data;$scope.loading=true;callback({modal:modal,supId:supId,convertToPickup:convertToPickup});};$scope.cancel=function(err){if($scope.loading)return;negative({modal:modal});};$scope.keyPressed=function($event){var ESC_KEY_CODE=27;if($event.keyCode===ESC_KEY_CODE){$event.preventDefault();if($scope.loading)return;negative({modal:modal});}};}]});};var checkedInAdHocCheckin=function checkedInAdHocCheckin(_ref14,callback,negative){var branchId=_ref14.branchId,windowId=_ref14.windowId,routeId=_ref14.routeId,date=_ref14.date,supervisorScan=_ref14.supervisorScan,branchVaultDate=_ref14.branchVaultDate,cancelSupervisorChallenge=_ref14.cancelSupervisorChallenge,pickupDate=_ref14.pickupDate;var modal=$uibModal.open({keyboard:false,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_checkedInAdHocCheckin2.default,size:'md',controller:['$scope','LocationService','User','BatchService','CarrierService','RouteService','ShiptypeService','WindowService','$q','$translate','ShipmentService','DateUtil','BranchService',function($scope,LocationService,User,BatchService,CarrierService,RouteService,ShiptypeService,WindowService,$q,$translate,ShipmentService,DateUtil,BranchService){$scope.supervisor={supId:''};$scope.isSupervisorConfirmed=supervisorScan===false;$scope.isCancelSupervisorChallange=cancelSupervisorChallenge;$scope.allowEditTrackingId=true;$scope.errorMessage='';$scope.bag={trackingId:'',quantity:1,branchId:branchId,windowId:windowId};$scope.model={branchId:User.getUser().branchId,pickupDate:'',pickupTime:'',currentTime:moment().format("HH:mm:ss")};$scope.locations=[];$scope.shiptypes=[];$scope.carriers=[];$scope.batches=[];$scope.locationLists=[];$scope.allLocationLists=[];$scope.destinationLocationList=[];$scope.sequenceLists=[];$scope.destinations=[];$scope.destinationLocations=[];$scope.showAllDestinationLocations=false;$scope.showAllFromLocations=true;$scope.loadingLocations={fromLocation:false,destination:false};$scope.loading=false;$scope.branchVaultDate=branchVaultDate;var searchKey=void 0;var offset=void 0;$scope.locationsSearchObj=function(searchKey){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branchId},{field:"active",condition:"=",data:true},{group:{rules:[{field:"locationType",condition:"=",data:"REGULAR"},{field:"locationType",condition:"=",data:"NO_SHIP_NO_GO"},{field:"locationType",condition:"=",data:"ATM"},{field:"locationType",condition:"=",data:"BANK"},{field:"locationType",condition:"=",data:"ON_CALL"}],operator:"OR"}},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:"AND"}};return searchObj.queryJSON.rules.length?searchObj:null;};$scope.bankLocationsSearchObj=function(searchKey){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"locationType",condition:"=",data:"BANK"},{field:'centralBank',condition:'=',data:true},{field:"branchId",condition:"=",data:$scope.model.branchId},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};return searchObj.queryJSON.rules.length?searchObj:null;};$scope.supervisorConfirmed=function(supId){$scope.supervisor.supId=supId;$scope.isSupervisorConfirmed=true;$scope.errorMessage='';init();};$scope.supervisorCancelled=function(){modal.close();};var getShiptypeSearchObj=function getShiptypeSearchObj(allowCoin,allowCash){if(allowCash&&allowCoin){var searchObj={queryJSON:{rules:[{field:'status',condition:'=',data:true}],operator:'AND'}};return searchObj;}else{var _searchObj={queryJSON:{rules:[{field:'coinFlag',condition:'='},{field:'status',condition:'=',data:true}],operator:'AND'}};if(allowCash){_searchObj.queryJSON.rules[0].data=0;}else if(allowCoin){_searchObj.queryJSON.rules[0].data=1;}else{return null;}return _searchObj;}};var init=function init(){$scope.loading=true;return $q.all([fetchFromLocations(searchKey,offset),BatchService.all(null,0,0),BranchService.getBranchSetup(branchId)]).then(function(data){var batches=data[1].results;var branchSetup=data[2];$scope.branchTimeZone=branchSetup?branchSetup.branch.timezone:null;$scope.batches=batches.map(function(batch){return{id:batch.id,inputType:batch.inputType};});var searchObj=getShiptypeSearchObj(null,null);$scope.bag.pickupDate=moment($scope.branchVaultDate).toDate();$scope.bag.pickupTime=$scope.getTime($scope.model.currentTime);$scope.minVaultDate={maxDate:$scope.bag.pickupDate};return ShiptypeService.all(searchObj,0,1000);}).then(function(res){var shiptypes=res.results;return $scope.shiptypes=shiptypes.map(function(shiptype){var mapped={id:shiptype.id,title:shiptype.description,amount:shiptype.amount,amountFlag:shiptype.amountFlag,coinFlag:shiptype.coinFlag};if(shiptype.id=='C'){if(shiptype.amountFlag){$scope.bag.qty=1;}$scope.bag.shiptype=mapped;}return mapped;});}).finally(function(){$scope.loading=false;});};var clearDestinationLocData=function clearDestinationLocData(){$scope.destinationLocationList=[];$scope.destinationAllLocationList=[];$scope.bag.toLocationId="";};var clearFromLocationData=function clearFromLocationData(){$scope.locationLists=[];$scope.allLocationLists=[];$scope.bag.fromLocationId="";};$scope.toggleAllDestinationLocations=function(){$scope.showAllDestinationLocations=!$scope.showAllDestinationLocations;clearDestinationLocData();return fetchDestinations(searchKey,offset);};$scope.toggleAllFromLocations=function(){$scope.showAllFromLocations=!$scope.showAllFromLocations;clearFromLocationData();clearDestinationLocData();return fetchFromLocations(searchKey,offset);};var getDay=function getDay(dateString){var date=moment(dateString);var weekDays={0:'Sun',1:'Mon',2:'Tue',3:'Wed',4:'Thu',5:'Fri',6:'Sat'};if(date){return weekDays[date.day()];}else{return null;}};$scope.reloadData=function(searchKey,offset){return fetchFromLocations(searchKey,offset);};var fetchFromLocations=function fetchFromLocations(searchKey,offset){var loadLocationDatas=$scope.locationsSearchObj(searchKey);if($scope.showAllFromLocations){LocationService.getAllLocation(loadLocationDatas,offset,_app2.default.defaultPageLimit).then(function(res){if(offset===0||offset==undefined){$scope.alltotalRecords=res.total;$scope.allLocationLists=$scope.mappingLocationDatas(res.results);}else{var locations=$scope.mappingLocationDatas(res.results);$scope.allLocationLists=$scope.allLocationLists.concat(locations);}});}else{RouteService.getActiveRouteSequence(routeId,branchId,getDay(date)).then(function(res){$scope.totalRecords=res.length;var sequences=$scope.mappingLocationDatas(res);$scope.locationLists=sequences;});}};$scope.mappingLocationDatas=function(locations){return locations.map(function(location){var locationObj={Key:location.id+' | '+location.name,Value:location.id};if(location.address){locationObj.Key+=' | '+location.address;}if(location.city){locationObj.Key+=' | '+location.city;}if(location.prefix){locationObj.key=location.prefix+' | '+locationObj.text;}return locationObj;});};$scope.reloadDestinationData=function(searchKey,offset){return fetchDestinations(searchKey,offset);};var fetchDestinations=function fetchDestinations(searchKey,offset){if(!$scope.bag||!$scope.bag.fromLocationId){return;}if($scope.showAllDestinationLocations){LocationService.centralBankLocation($scope.model.branchId).then(function(res){$scope.totalAllDestinationLocation=res.length;var destinationLocList=$scope.mappingLocationDatas(res);$scope.destinationAllLocationList=destinationLocList;if($scope.destinationAllLocationList.length&&!$scope.bag.toLocationId){$scope.bag.toLocationId=$scope.destinationAllLocationList[0];}});}else{var fromLocId=$scope.bag.fromLocationId.Value||$scope.bag.fromLocationId;ShipmentService.getDestinationLocations(fromLocId,$scope.bag.shiptype.id,false).then(function(res){$scope.totalDestinationLocation=res.length;var destinationLoc=$scope.mappingLocationDatas(res);$scope.destinationLocationList=destinationLoc;if($scope.destinationLocationList.length&&!$scope.bag.toLocationId){$scope.bag.toLocationId=$scope.destinationLocationList[0];}});}};$scope.reloadDestinations=function(e){if(e&&(e.keyCode===38||e.keyCode===40)){return;}clearDestinationLocData();fetchDestinations(searchKey,offset);};$scope.focusOntoLocation=function(id){setTimeout(function(){var el=document.getElementById(id);if(el)el.focus();},100);};$scope.quantityChanged=function(){if($scope.bag.qty&&$scope.bag.shiptype){$scope.bag.amount=$scope.bag.shiptype.amount*$scope.bag.qty;}};$scope.shiptypeChanged=function(){$scope.showAllDestinationLocations=false;if($scope.bag.shiptype.amountFlag){$scope.bag.qty=1;}if(!$scope.bag.qty){$scope.bag.qty=1;}if($scope.bag.toLocationId){fetchDestinations(searchKey,offset);}if($scope.bag.fromLocationId){fetchDestinations(searchKey,offset);}$scope.bag.amount=$scope.bag.qty*$scope.bag.shiptype.amount;if($scope.bag.shiptype.coinFlag==0){$scope.bag.amount=null;}};$scope.keyPressed=function($event){var ESC_KEY_CODE=27;if($event.keyCode===ESC_KEY_CODE){negative({modal:modal});}};$scope.getTime=function(time){if(!time)return time;time=time.split(':');var d=new Date();d.setHours(+time[0]);d.setMinutes(time[1]);d.setSeconds(0);d.setMilliseconds(0);return d;};$scope.ok=function(){if($scope.loading)return;$scope.errorMessage='';var requiredFields=['shiptype','trackingId','qty','fromLocationId','toLocationId'];var isFormValid=requiredFields.every(function(field){return!!$scope.bag[field];});if($scope.bag.amount==null&&$scope.bag.shiptype.amountFlag){return $scope.errorMessage=$translate.instant('addBagModal.requiredAmountError');}else if(!isFormValid){return $scope.errorMessage=$translate.instant('addBagModal.requiredFieldsError');}$scope.loading=true;$scope.bag.routeId=routeId;$scope.bag.deliveryDate=date;$scope.bag.branchId=branchId;$scope.bag.coinFlag=$scope.bag.shiptype.coinFlag;$scope.bag.shiptypeId=$scope.bag.shiptype.id;$scope.bag.pickupFlag=true;$scope.bag.verified=true;$scope.bag.vaultDate=moment($scope.bag.deliveryDate).format('YYYY-MM-DD');$scope.bag.amount=$scope.bag.amount?$scope.bag.amount:0;$scope.bag.pickupDate=moment($scope.bag.pickupDate).format('YYYY-MM-DD');$scope.bag.pickupTime=moment($scope.bag.pickupTime).format('HH:mm:ss');$scope.bag.branchTimeZone=$scope.branchTimeZone;// Removed mutation here - extraction will be handled by the controller to preserve UI state on error
callback({modal:modal,$scope:$scope});};$scope.cancel=function(){modal.close();};if($scope.isSupervisorConfirmed||supervisorScan===false){init();}}]});rejectModal(modal,negative);};// force add bag for checkin screen 
var checkedInForceAddBag=function checkedInForceAddBag(_ref15,callback,negative){var bagId=_ref15.bagId,branchId=_ref15.branchId,windowId=_ref15.windowId,routeId=_ref15.routeId,date=_ref15.date,supervisorScan=_ref15.supervisorScan,branchVaultDate=_ref15.branchVaultDate,cancelSupervisorChallenge=_ref15.cancelSupervisorChallenge;var modal=$uibModal.open({keyboard:false,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_checkedInAddBag2.default,size:'md',controller:['$scope','LocationService','User','BatchService','CarrierService','RouteService','ShiptypeService','WindowService','$q','$translate','ShipmentService','DateUtil',function($scope,LocationService,User,BatchService,CarrierService,RouteService,ShiptypeService,WindowService,$q,$translate,ShipmentService,DateUtil){$scope.supervisor={supId:''};$scope.isSupervisorConfirmed=supervisorScan===false;$scope.isCancelSupervisorChallange=cancelSupervisorChallenge;$scope.errorMessage='';$scope.bag={trackingId:bagId,quantity:1,branchId:branchId,windowId:windowId};$scope.model={branchId:User.getUser().branchId,pickupDate:'',pickupTime:'',currentTime:moment().format("HH:mm:ss")};$scope.locations=[];$scope.shiptypes=[];$scope.carriers=[];$scope.batches=[];$scope.locationLists=[];$scope.allLocationLists=[];$scope.destinationLocationList=[];$scope.sequenceLists=[];$scope.destinations=[];$scope.destinationLocations=[];$scope.showAllDestinationLocations=false;$scope.showAllFromLocations=false;$scope.loadingLocations={fromLocation:false,destination:false};$scope.loading=false;$scope.branchVaultDate=branchVaultDate;var searchKey=void 0;var offset=void 0;var fromLocationObjs=[];//holds the array of whole location objects
var isLoadingAllLocations=false;var allLocationsSearchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.branchId},{group:{rules:[{field:"locationType",condition:"=",data:"REGULAR"},{field:"locationType",condition:"=",data:"NO_SHIP_NO_GO"},{field:"locationType",condition:"=",data:"ATM"},{field:"locationType",condition:"=",data:"BANK"},{field:"locationType",condition:"=",data:"ON_CALL"}],operator:'OR'}}],operator:'AND'}};$scope.locationsSearchObj=function(searchKey){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branchId},{field:"active",condition:"=",data:true},{group:{rules:[{field:"locationType",condition:"=",data:"REGULAR"},{field:"locationType",condition:"=",data:"NO_SHIP_NO_GO"},{field:"locationType",condition:"=",data:"ATM"},{field:"locationType",condition:"=",data:"BANK"},{field:"locationType",condition:"=",data:"ON_CALL"}],operator:"OR"}},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:"AND"}};return searchObj.queryJSON.rules.length?searchObj:null;};// it search for locationType == "BANK", centralBank == true and return location Branch vise  
$scope.bankLocationsSearchObj=function(searchKey){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"locationType",condition:"=",data:"BANK"},{field:'centralBank',condition:'=',data:true},{field:"branchId",condition:"=",data:$scope.model.branchId},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};return searchObj.queryJSON.rules.length?searchObj:null;};$scope.supervisorConfirmed=function(supId){$scope.supervisor.supId=supId;$scope.isSupervisorConfirmed=true;$scope.errorMessage='';init();};$scope.supervisorCancelled=function(err){$scope.isSupervisorConfirmed=false;$scope.errorMessage=err.toString();};var getShiptypeSearchObj=function getShiptypeSearchObj(allowCoin,allowCash){if(allowCash&&allowCoin){var searchObj={queryJSON:{rules:[{field:'status',condition:'=',data:true}],operator:'AND'}};return searchObj;}else{var _searchObj2={queryJSON:{rules:[{field:'coinFlag',condition:'='},{field:'status',condition:'=',data:true}],operator:'AND'}};if(allowCash){_searchObj2.queryJSON.rules[0].data=0;}else if(allowCoin){_searchObj2.queryJSON.rules[0].data=1;}else{return null;}return _searchObj2;}};var init=function init(){$scope.loading=true;return $q.all([fetchFromLocations(searchKey,offset),WindowService.get(windowId),CarrierService.all(null,0,1000),BatchService.all(null,0,0)]).then(function(data){var windowObj=data[1];var carriers=data[2].results;var batches=data[3].results;$scope.carriers=carriers.map(function(carrier){return{id:carrier.id,description:carrier.description};});$scope.batches=batches.map(function(batch){return{id:batch.id,inputType:batch.inputType};});var searchObj=getShiptypeSearchObj(windowObj.allowCoin,windowObj.allowCash);$scope.bag.pickupDate=DateUtil.convertToDate($scope.branchVaultDate);$scope.bag.pickupTime=$scope.getTime($scope.model.currentTime);$scope.minVaultDate={maxDate:$scope.bag.pickupDate};return ShiptypeService.all(searchObj,0,1000);}).then(function(res){var shiptypes=res.results;return $scope.shiptypes=shiptypes.map(function(shiptype){if(shiptype.id=='C'){if(shiptype.amountFlag){$scope.bag.qty=1;}focusElementById('shiptype-amount');return $scope.bag.shiptype={id:shiptype.id,title:shiptype.description,amount:shiptype.amount,amountFlag:shiptype.amountFlag,coinFlag:shiptype.coinFlag};}return{id:shiptype.id,title:shiptype.description,amount:shiptype.amount,amountFlag:shiptype.amountFlag,coinFlag:shiptype.coinFlag};});}).finally(function(){$scope.loading=false;});};var clearDestinationLocData=function clearDestinationLocData(){$scope.destinationLocationList=[];$scope.destinationAllLocationList=[];$scope.bag.toLocationId="";};var clearFromLocationData=function clearFromLocationData(){$scope.locationLists=[];$scope.alllocationLists=[];$scope.bag.fromLocationId="";};$scope.toggleAllDestinationLocations=function(){$scope.showAllDestinationLocations=!$scope.showAllDestinationLocations;clearDestinationLocData();return fetchDestinations(searchKey,offset);};$scope.toggleAllFromLocations=function(){$scope.showAllFromLocations=!$scope.showAllFromLocations;clearFromLocationData();clearDestinationLocData();return fetchFromLocations(searchKey,offset);};var getDay=function getDay(dateString){var date=moment(dateString);var weekDays={0:'Sun',1:'Mon',2:'Tue',3:'Wed',4:'Thu',5:'Fri',6:'Sat'};if(date){return weekDays[date.day()];}else{return null;}};$scope.reloadData=function(searchKey,offset){return fetchFromLocations(searchKey,offset);};// fetch origin locations
var fetchFromLocations=function fetchFromLocations(searchKey,offset){var defer=$q.defer();// $scope.loadingLocations.fromLocation = true;
var loadLocationDatas='';// if (searchKey) {
//   const searchObj = {
//     queryText: '%' + searchKey + '%',
//     isQuery: false
//   }
//   loadLocationDatas = searchObj;
// } else {
loadLocationDatas=$scope.locationsSearchObj(searchKey);// }
if($scope.showAllFromLocations){LocationService.getAllLocation(loadLocationDatas,offset,_app2.default.defaultPageLimit).then(function(res){if(offset===0||offset==undefined){$scope.alltotalRecords=res.total;$scope.allLocationLists=$scope.mappingLocationDatas(res.results);}else{var locations=$scope.mappingLocationDatas(res.results);$scope.allLocationLists=$scope.allLocationLists.concat(locations);}});}else{RouteService.getActiveRouteSequence(routeId,branchId,getDay(date)).then(function(res){$scope.totalRecords=res.length;var sequences=$scope.mappingLocationDatas(res);$scope.locationLists=$scope.locationLists.concat(sequences);});}};$scope.mappingLocationDatas=function(locations){return locations.map(function(location){var locationObj={Key:location.id+' | '+location.name,Value:location.id};if(location.address){locationObj.Key+=' | '+location.address;}if(location.city){locationObj.Key+=' | '+location.city;}if(location.prefix){locationObj.key=location.prefix+' | '+locationObj.text;}// $scope.loadingLocations.fromLocation = false;
// $scope.loadingLocations.destination = false;
return locationObj;});};$scope.reloadDestinationData=function(searchKey,offset){return fetchDestinations(searchKey,offset);};var fetchDestinations=function fetchDestinations(searchKey,offset){// fetch destination location
var promise=void 0;if(!$scope.bag||!$scope.bag.fromLocationId){return;}// $scope.loadingLocations.destination = true;
if($scope.showAllDestinationLocations){isLoadingAllLocations=true;var loadLocationDestination='';// if (searchKey) {
//   const searchObj = {
//     queryText: '%' + searchKey + '%',
//     isQuery: false
//   }
//   loadLocationDestination = searchObj;
// } else {
loadLocationDestination=$scope.bankLocationsSearchObj(searchKey);// }
LocationService.centralBankLocation($scope.model.branchId).then(function(res){$scope.totalAllDestinationLocation=res.length;var destinationLocList=$scope.mappingLocationDatas(res);$scope.destinationAllLocationList=$scope.destinationAllLocationList.concat(destinationLocList);if($scope.destinationAllLocationList.length){$scope.bag.toLocationId=$scope.destinationAllLocationList[0];}});}else{var selectedFromLocation=fromLocationObjs.find(function(location){return location.id===$scope.bag.fromLocationId;});ShipmentService.getDestinationLocations($scope.bag.fromLocationId['Value'],$scope.bag.shiptype.id,false).then(function(res){$scope.totalDestinationLocation=res.length;var destinationLoc=$scope.mappingLocationDatas(res);$scope.destinationLocationList=$scope.destinationLocationList.concat(destinationLoc);if($scope.destinationLocationList.length){$scope.bag.toLocationId=$scope.destinationLocationList[0];}});}};$scope.reloadDestinations=function(e){if(e&&(e.keyCode===38||e.keyCode===40)){return;}clearDestinationLocData();fetchDestinations(searchKey,offset);};$scope.focusOntoLocation=function(id){focusElementById(id);};$scope.quantityChanged=function(){if($scope.bag.qty){$scope.bag.amount=$scope.bag.shiptype.amount*$scope.bag.qty;}};$scope.shiptypeChanged=function(){$scope.showAllDestinationLocations=false;if($scope.bag.shiptype.amountFlag){$scope.bag.qty=1;}if(!$scope.bag.qty){$scope.bag.qty=1;}if($scope.bag.toLocationId){fetchDestinations(searchKey,offset);}if($scope.bag.fromLocationId){// fetchDestinations();
fetchFromLocations(searchKey,offset);clearFromLocationData();clearDestinationLocData();}$scope.bag.amount=$scope.bag.qty*$scope.bag.shiptype.amount;// set cash amount value as ZERO
if($scope.bag.shiptype.coinFlag==0){$scope.bag.amount=null;}};$scope.keyPressed=function($event){var ESC_KEY_CODE=27;if($event.keyCode===ESC_KEY_CODE){negative({modal:modal});}};$scope.getTime=function(time){if(!time){return time;}time=time.split(':');var d=new Date();d.setHours(+time[0]);d.setMinutes(time[1]);d.setSeconds(0);d.setMilliseconds(0);return d;};$scope.ok=function(){if($scope.loading)return;$scope.errorMessage='';var requiredFields=['shiptype','trackingId','qty','fromLocationId','toLocationId'];var isFormValid=requiredFields.every(function(field){$scope.allField=field;return!!$scope.bag[$scope.allField];});// error check 
if($scope.bag.amount==null&&$scope.bag.shiptype.amountFlag){return $scope.errorMessage=$translate.instant('addBagModal.requiredAmountError');}else if(!isFormValid){return $scope.errorMessage=$translate.instant('addBagModal.requiredFieldsError');}$scope.loading=true;$scope.bag.routeId=routeId;// $scope.bag.pickupDate = date
$scope.bag.deliveryDate=date;$scope.bag.branchId=branchId;$scope.bag.coinFlag=$scope.bag.shiptype.coinFlag;$scope.bag.shiptypeId=$scope.bag.shiptype.id;$scope.bag.pickupFlag=true;$scope.bag.verified=true;$scope.bag.fromLocationId=$scope.bag.fromLocationId.Value;$scope.bag.toLocationId=$scope.bag.toLocationId.Value;$scope.bag.vaultDate=moment($scope.bag.deliveryDate).format('YYYY-MM-DD');$scope.bag.amount=$scope.bag.amount?$scope.bag.amount:0;$scope.bag.pickupDate=moment($scope.bag.pickupDate).format('YYYY-MM-DD'),$scope.bag.pickupTime=moment($scope.bag.pickupTime).format('HH:mm:ss');callback({modal:modal,$scope:$scope});};$scope.cancel=function(){negative({modal:modal});};if($scope.isSupervisorConfirmed||supervisorScan===false){init();}}]});modal.result.then(function(result){// console.log('client: resolved: ' );
},function(reason){negative({modal:null});});};// force add bag for checkout screen
var checkedoutForceAddBag=function checkedoutForceAddBag(_ref16,callback,negative){var bagId=_ref16.bagId,branchId=_ref16.branchId,windowId=_ref16.windowId,routeId=_ref16.routeId,date=_ref16.date,tankerId=_ref16.tankerId,supervisorScan=_ref16.supervisorScan,disabledBag=_ref16.disabledBag,cancelSupervisorChallenge=_ref16.cancelSupervisorChallenge;var modal=$uibModal.open({keyboard:false,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_checkedoutAddBag2.default,size:'md',controller:['$scope','LocationService','User','BatchService','CarrierService','RouteService','ShiptypeService','WindowService','$q','$translate',function($scope,LocationService,User,BatchService,CarrierService,RouteService,ShiptypeService,WindowService,$q,$translate){$scope.supervisor={supId:''};$scope.isSupervisorConfirmed=supervisorScan===false;$scope.errorMessage='';$scope.isCancelSupervisorChallange=cancelSupervisorChallenge;$scope.bag={trackingId:bagId,quantity:1,branchId:branchId,windowId:windowId,tankerId:tankerId,disabledBag:disabledBag};$scope.model={branchId:User.getUser().branchId};$scope.locations=[];$scope.shiptypes=[];$scope.carriers=[];$scope.batches=[];$scope.showAllDestinationLocations=false;$scope.showAllFromLocations=false;$scope.loadingLocations={fromLocation:false,destination:false};$scope.loading=false;$scope.destinations=[];$scope.allDestinations=[];var fromLocationObjs=[];//holds the array of whole location objects
var searchKey=void 0,offset=void 0;$scope.allLocationsSearchObj=function(searchKey){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.branchId},{field:'active',condition:'=',data:true},{group:{rules:[{field:"locationType",condition:"=",data:"REGULAR"},{field:"locationType",condition:"=",data:"NO_SHIP_NO_GO"},{field:"locationType",condition:"=",data:"ATM"},{field:"locationType",condition:"=",data:"BANK"},{field:"locationType",condition:"=",data:"ON_CALL"}],operator:'OR'}},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};return searchObj.queryJSON.rules.length?searchObj:null;};// it search for locationType == "BANK" and centralBank == "TRUE" and return location Branch vise  
$scope.bankLocationsSearchObj=function(searchKey){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"locationType",condition:"=",data:"BANK"},{field:"centralBank",condition:"=",data:true},{field:"branchId",condition:"=",data:$scope.model.branchId},{field:"active",condition:"=",data:true},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};return searchObj.queryJSON.rules.length?searchObj:null;};// show locations as locationType == 'BANK' And active = true
$scope.allBankLocationSearchObj=function(searchKey){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"locationType",condition:"=",data:"BANK"},{field:"active",condition:"=",data:true},{field:"branchId",condition:"=",data:$scope.model.branchId},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};return searchObj.queryJSON.rules.length?searchObj:null;};$scope.supervisorConfirmed=function(supId){$scope.supervisor.supId=supId;$scope.isSupervisorConfirmed=true;$scope.errorMessage='';init();};$scope.supervisorCancelled=function(err){$scope.isSupervisorConfirmed=false;$scope.errorMessage=err.toString();};var getShiptypeSearchObj=function getShiptypeSearchObj(allowCoin,allowCash){if(allowCash&&allowCoin){var searchObj={queryJSON:{rules:[{field:'status',condition:'=',data:true}],operator:'AND'}};return searchObj;}else{var _searchObj3={queryJSON:{rules:[{field:'coinFlag',condition:'='},{field:'status',condition:'=',data:true}],operator:'AND'}};if(allowCash){_searchObj3.queryJSON.rules[0].data=0;}else if(allowCoin){_searchObj3.queryJSON.rules[0].data=1;}else{return null;}return _searchObj3;}};var init=function init(){$scope.loading=true;return $q.all([fetchFromLocations(searchKey,offset),WindowService.get(windowId),CarrierService.all(null,0,1000),BatchService.all(null,0,0),fetchDestinations(searchKey,offset)]).then(function(data){var windowObj=data[1];var carriers=data[2].results;var batches=data[3].results;$scope.carriers=carriers.map(function(carrier){return{id:carrier.id,description:carrier.description};});$scope.batches=batches.map(function(batch){return{id:batch.id,inputType:batch.inputType};});var searchObj=getShiptypeSearchObj(windowObj.allowCoin,windowObj.allowCash);return ShiptypeService.all(searchObj,0,1000);}).then(function(res){var shiptypes=res.results;return $scope.shiptypes=shiptypes.map(function(shiptype){if(shiptype.id=='C'){if(shiptype.amountFlag){$scope.bag.qty=1;}focusElementById('shiptype-amount');return $scope.bag.shiptype={id:shiptype.id,title:shiptype.description,amount:shiptype.amount,amountFlag:shiptype.amountFlag,coinFlag:shiptype.coinFlag};}return{id:shiptype.id,title:shiptype.description,amount:shiptype.amount,amountFlag:shiptype.amountFlag,coinFlag:shiptype.coinFlag};});}).finally(function(){$scope.loading=false;});};$scope.toggleAllDestinationLocations=function(){$scope.showAllDestinationLocations=!$scope.showAllDestinationLocations;$scope.bag.toLocationId="";return fetchDestinations(searchKey,offset);};$scope.toggleAllFromLocations=function(){$scope.showAllFromLocations=!$scope.showAllFromLocations;$scope.bag.fromLocationId="";$scope.bag.toLocationId="";return fetchFromLocations(searchKey,offset);};var getDay=function getDay(dateString){var date=moment(dateString);var weekDays={0:'Sun',1:'Mon',2:'Tue',3:'Wed',4:'Thu',5:'Fri',6:'Sat'};if(date){return weekDays[date.day()];}else{return null;}};$scope.reloadOriginData=function(searchKey,offset){return fetchFromLocations(searchKey,offset);};// fetch origin locations
var fetchFromLocations=function fetchFromLocations(searchKey,offset){var defer=$q.defer();// $scope.loadingLocations.fromLocation = true;
// $scope.bag.toLocationId = "";
var loadLocationDatas='';// if (searchKey) {
//   const searchObj = {
//     queryText: '%' + searchKey + '%',
//     isQuery: false
//   }
//   loadLocationDatas = searchObj;
// } else {      
if($scope.showAllFromLocations){loadLocationDatas=$scope.allBankLocationSearchObj(searchKey);LocationService.all(loadLocationDatas,offset,_app2.default.defaultPageLimit).then(function(data){// $scope.bag.fromLocationId = "";
if(offset===0||offset==undefined){$scope.originTotalRecords=data.total;$scope.fromLocations=$scope.mappingLocationDatas(data.results);}else{var originLocations=$scope.mappingLocationDatas(data.results);$scope.fromLocations=$scope.fromLocations.concat(originLocations);}// $scope.loadingLocations.fromLocation = false;
});}else{LocationService.centralBankLocation($scope.model.branchId).then(function(data){if(offset===0||offset==undefined){$scope.originTotalRecords=data.length;$scope.fromLocations=$scope.mappingLocationDatas(data);}else{var originLocations=$scope.mappingLocationDatas(data);$scope.fromLocations=$scope.fromLocations.concat(originLocations);}// $scope.loadingLocations.fromLocation = false;
});}};$scope.reloadDestinationData=function(searchKey,offset){return fetchDestinations(searchKey,offset);};var fetchDestinations=function fetchDestinations(searchKey,offset){var promise=void 0;var isLoadingAllLocations=false;// $scope.loadingLocations.destination = true;
if($scope.showAllDestinationLocations){isLoadingAllLocations=true;var loadLocationDatas='';// if (searchKey) {
//   const searchObj = {
//     queryText: '%' + searchKey + '%',
//     isQuery: false
//   }
//   loadLocationDatas = searchObj;
// } else {
loadLocationDatas=$scope.allLocationsSearchObj(searchKey);// }
promise=LocationService.getAllLocation(loadLocationDatas,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.totalAllRecords=data.total;$scope.allDestinations=$scope.mappingLocationDatas(data.results);}else{var destLocations=$scope.mappingLocationDatas(data.results);$scope.allDestinations=$scope.allDestinations.concat(destLocations);}// $scope.loadingLocations.destination = false;
}).then(function(){if(offset===0||offset==undefined){$scope.autoSelect();}});}else{promise=RouteService.getActiveRouteSequence(routeId,branchId,getDay(date)).then(function(data){var destinations=data;$scope.totalRecords=data.length;isLoadingAllLocations=true;$scope.destinations=$scope.mappingLocationDatas(destinations);}).then(function(){$scope.autoSelectDestination();});}};// Auto select first location from getActiveRouteSequence API
$scope.autoSelectDestination=function(e){if(e&&(e.keyCode===38||e.keyCode===40)){return;}if($scope.bag.fromLocationId&&!$scope.showAllDestinationLocations&&$scope.destinations.length){$scope.bag.toLocationId=$scope.destinations[0];}$scope.autoSelect();};// Auto select first location from getAllLocation API
$scope.autoSelect=function(){if($scope.bag.fromLocationId&&$scope.showAllDestinationLocations&&$scope.allDestinations.length){$scope.bag.toLocationId=$scope.allDestinations[0];}};$scope.mappingLocationDatas=function(locations){return locations.map(function(location){var locationObj={Key:location.id+' | '+location.name,Value:location.id};if(location.address){locationObj.Key+=' | '+location.address;}if(location.city){locationObj.Key+=' | '+location.city;}if(location.prefix){locationObj.key=location.prefix+' | '+locationObj.text;}return locationObj;});};$scope.reloadDestinations=function(){fetchDestinations(searchKey,offset);};$scope.focusOntoLocation=function(id){focusElementById(id);};$scope.quantityChanged=function(){if($scope.bag.qty){$scope.bag.amount=$scope.bag.shiptype.amount*$scope.bag.qty;}};$scope.shiptypeChanged=function(){$scope.showAllDestinationLocations=false;if($scope.bag.shiptype.amountFlag){$scope.bag.qty=1;}if(!$scope.bag.qty){$scope.bag.qty=1;}$scope.destinationLocationList=[];$scope.destinationAllLocationList=[];$scope.bag.toLocationId="";$scope.locationLists=[];$scope.alllocationLists=[];$scope.bag.fromLocationId="";if($scope.bag.toLocationId){fetchDestinations(searchKey,offset);}if($scope.bag.fromLocationId){fetchFromLocations(searchKey,offset);}$scope.bag.amount=$scope.bag.qty*$scope.bag.shiptype.amount;// set cash amount value as ZERO
if($scope.bag.shiptype.coinFlag==0){$scope.bag.amount=null;}};$scope.keyPressed=function($event){var ESC_KEY_CODE=27;if($event.keyCode===ESC_KEY_CODE){negative({modal:modal,disabledBag:false});}};$scope.ok=function(){$scope.errorMessage='';if($scope.loading)return;var requiredFields=['shiptype','trackingId','qty','fromLocationId','toLocationId'];var isFormValid=requiredFields.every(function(field){$scope.allField=field;return!!$scope.bag[$scope.allField];});// error check 
if($scope.bag.amount==null&&$scope.bag.shiptype.amountFlag){return $scope.errorMessage=$translate.instant('addBagModal.requiredAmountError');}else if(!isFormValid){return $scope.errorMessage=$translate.instant('addBagModal.requiredFieldsError');}$scope.loading=true;$scope.bag.routeId=routeId;$scope.bag.pickupDate=date;$scope.bag.deliveryDate=date;$scope.bag.branchId=branchId;$scope.bag.coinFlag=$scope.bag.shiptype.coinFlag;$scope.bag.shiptypeId=$scope.bag.shiptype.id;$scope.bag.pickupFlag=false;$scope.bag.packedFlag=true;$scope.bag.verified=true;$scope.bag.tankerId=tankerId;$scope.bag.toLocationId=$scope.bag.toLocationId.Value;$scope.bag.fromLocationId=$scope.bag.fromLocationId.Value;$scope.bag.vaultDate=moment($scope.bag.deliveryDate).format('YYYY-MM-DD');$scope.bag.amount=$scope.bag.amount?$scope.bag.amount:0;$scope.bag.disabledBag=false;callback({modal:modal,$scope:$scope,disabledBag:$scope.bag.disabledBag});};$scope.cancel=function(){$scope.bag.disabledBag=false;negative({modal:modal,disabledBag:$scope.bag.disabledBag});};if($scope.isSupervisorConfirmed||supervisorScan===false){init();}}]});};var forceCheckin=function forceCheckin(_ref17,callback,negative){var bagId=_ref17.bagId,branchId=_ref17.branchId,windowId=_ref17.windowId,routeId=_ref17.routeId,checkinDate=_ref17.checkinDate;var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_forceCheckin2.default,size:'md',controller:['$scope','$translate',function($scope){$scope.model={isBagAdded:false,bagId:bagId,scannedBagId:'',supervisor:'',error:''};$scope.showAddBagModal=function(){checkedInForceAddBag({bagId:bagId,branchId:branchId,windowId:windowId,routeId:routeId,checkinDate:checkinDate},function(_ref18){var addBagModal=_ref18.modal,addBagModalScope=_ref18.$scope;addBagModal.close();$scope.model.supervisorId=addBagModalScope.supervisor.supId;$scope.model.isBagAdded=true;focusElementById('bag-id');},function(_ref19){var addBagModal=_ref19.modal;addBagModal.close();});};$scope.fetchDetails=function(){if($scope.model.scannedBagId===$scope.model.bagId){callback({modal:modal,$scope:$scope});}else{$scope.model.error=$translate.instant('error.90905')||'abc';//error which caused this modal to appear
}};$scope.cancel=function(){negative({modal:modal});};}]});};var itemNotDelivered=function itemNotDelivered(trackingId,shipmentDetails,notDeliveredResolution,callback,negative){var itemNotDeliveredmodal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_itemNotDelivered2.default,size:'md',controller:['$scope','MessageService','User','HoldService','ShipmentService','$location','$q','BranchService','SetupService','LocationService','ShiptypeService','DateUtil',function($scope,MessageService,User,HoldService,ShipmentService,$location,$q,BranchService,SetupService,LocationService,ShiptypeService,DateUtil){$scope.model={loading:false,selectedReason:null,reasons:[],deliveryResolutions:[],trackingId:trackingId,updatedTrackingId:trackingId,originalTrackingId:trackingId,shipmentDetails:shipmentDetails,notDeliveredResolution:notDeliveredResolution,vaultDate:'',nextRouteData:'',nextRouteDetails:'',routeList:[],routeSequence:null,lastSelectedRoute:shipmentDetails.routeId||null,routeIds:'',routeId:shipmentDetails.routeId||null,routeInfo:null,totalRoutes:'',date:'',branchId:User.getUser().branchId,isReRoute:null,amount:shipmentDetails.amount||null,qty:shipmentDetails.qty||null,fromLocationListObj:(0,_defineProperty3.default)({loading:false,fromLocationId:{Key:shipmentDetails.fromLocation.id+' | '+shipmentDetails.fromLocation.name,Value:shipmentDetails.fromLocation.id}||null,fromLocationOptions:[],totalRecords:0},'totalRecords',0),toLocationListObj:(0,_defineProperty3.default)({loading:false,destinationId:{Key:shipmentDetails.toLocation.id+' | '+shipmentDetails.toLocation.name,Value:shipmentDetails.toLocation.id}||null,toLocationOptions:[],totalRecords:0},'totalRecords',0),shipTypeObj:(0,_defineProperty3.default)({loading:false,shiptypeId:{Key:shipmentDetails.shiptype.description,Value:shipmentDetails.shiptype.id,coinFlag:shipmentDetails.shiptype.coinFlag,unitValue:shipmentDetails.shiptype.unitValue}||null,shipTypeList:[],totalShipTypes:0},'loading',false)};$scope.model.toLocationId=shipmentDetails.toLocationId?shipmentDetails.toLocationId:null;var loggedInUser=User.getUser();$scope.model.isItemNotDeliveredModal=true;var init=function init(){$scope.model.loading=true;var type=shipmentDetails.toLocation.stopProcess==='L'?['R','NDR']:shipmentDetails.toLocation.stopProcess==='D'?['D_R','NDR']:['D_R','NDR'];var searchObj=generateQueryForReason(type);MessageService.all(loggedInUser.languageId,searchObj,0,1000).then(function(data){if(data.results&&data.results.length){var reasons=data.results.filter(function(obj){return obj.type=='R'||obj.type=='D_R';});reasons.sort(function(a,b){return(b.defaultSelection===true)-(a.defaultSelection===true);});$scope.model.reasons=reasons;var defaultReason=reasons.find(function(item){return item.defaultSelection===true;});if(!defaultReason&&reasons.length){defaultReason=null;}$scope.model.selectedReason=defaultReason?defaultReason.description:null;var deliveryResolutions=data.results.filter(function(obj){return obj.type=='NDR';});deliveryResolutions.sort(function(a,b){return(b.defaultSelection===true)-(a.defaultSelection===true);});$scope.model.deliveryResolutions=deliveryResolutions;var defaultResolution=deliveryResolutions.find(function(item){return item.defaultSelection===true;});if(!defaultResolution){defaultResolution=deliveryResolutions.find(function(item){return item.messageId==='NDR.noTimeline';});// default "No Timeline"
}$scope.model.deliveryResolution=defaultResolution?defaultResolution.description:null;$scope.model.loading=false;}else{$scope.model.reasons=[];$scope.model.deliveryResolutions=[];$scope.model.selectedReason=null;$scope.model.deliveryResolution=null;}$scope.getLocationList();$scope.getShipmentDestinations();$scope.loadShipType();$scope.getNextVaultDate();});};$scope.$watch('model.toLocationListObj.destinationId',function(newVal,oldVal){if(newVal!==oldVal){$scope.getNextVaultDate();}});$scope.getNextVaultDate=function(){var dest=$scope.model.toLocationListObj.destinationId;if(!dest)return;var destinationId=dest.Value||dest;LocationService.getNextValutDateOfLocation(destinationId,$scope.model.branchId).then(function(data){if(data.nextVaultDate){var utcMoment=moment.utc(data.nextVaultDate);var year=utcMoment.year();var month=utcMoment.month();var day=utcMoment.date();var dateObj=new Date(year,month,day,0,0,0,0);$scope.model.date=dateObj;$scope.model.vaultDate=dateObj;}else{$scope.model.date=null;$scope.model.vaultDate=null;}$scope.model.routeIdFromNextVaultDate=data.routeId?data.routeId:null;$scope.model.routeId=data.routeId?data.routeId:null;$scope.handleActionLable();$scope.loadRouteInfo();if(data.routeId){$scope.routeSequenceChanged();}});};$scope.getLocationList=function(searchKey,offset){searchKey=searchKey||'';var locationSearchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.branchId},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};$scope.model.fromLocationListObj.loading=true;return LocationService.all(locationSearchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(!offset||offset===0){$scope.model.fromLocationListObj.totalRecords=data.total;$scope.model.fromLocationListObj.fromLocationOptions=$scope.locationMapping(data.results);}else{var location=$scope.locationMapping(data.results);$scope.model.fromLocationListObj.fromLocationOptions=$scope.model.fromLocationListObj.fromLocationOptions.concat(location);}var selected=$scope.model.fromLocationListObj.fromLocationOptions.find(function(item){return item.Value==$scope.model.fromLocationListObj.fromLocationId;});if(selected){$scope.model.fromLocationListObj.fromLocationId=selected;}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}}).finally(function(){$scope.model.fromLocationListObj.loading=false;});};$scope.getShipmentDestinations=function(searchKey,offset){searchKey=searchKey||'';$scope.model.toLocationListObj.loading=true;return LocationService.getShipmentDestinations($scope.model.branchId,shipmentDetails.fromLocationId,searchKey,offset,_app2.default.defaultPageLimit).then(function(data){if(!offset||offset===0){$scope.model.toLocationListObj.totalRecords=data.total;$scope.model.toLocationListObj.toLocationOptions=$scope.locationMapping(data.results);}else{var location=$scope.locationMapping(data.results);$scope.model.toLocationListObj.toLocationOptions=$scope.model.toLocationListObj.toLocationOptions.concat(location);}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}}).finally(function(){$scope.model.toLocationListObj.loading=false;});};$scope.loadShipType=function(searchKey,offset){searchKey=searchKey||'';var shipTypeSearchObj={queryJSON:{rules:[{field:'status',condition:'=',data:true},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'description',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};$scope.model.shipTypeObj.loading=true;return ShiptypeService.all(shipTypeSearchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.shipTypeObj.totalShipTypes=data.total;$scope.model.shipTypeObj.shipTypeList=$scope.shipTypeDataMapping(data.results);}else{var shipTypes=$scope.shipTypeDataMapping(data.results);$scope.model.shipTypeObj.shipTypeList=$scope.model.shipTypeObj.shipTypeList.concat(shipTypes);}var selected=$scope.model.shipTypeObj.shipTypeList.find(function(item){return item.Value==$scope.model.shipTypeObj.shiptypeId.Value;});if(selected){$scope.model.shipTypeObj.shiptypeId=selected;}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}}).finally(function(){$scope.model.shipTypeObj.loading=false;});};$scope.shipTypeDataMapping=function(shipTypes){return shipTypes.map(function(shipType){return{Key:shipType.id+' | '+shipType.description,Value:shipType.id,faceValue:shipType.amountFlag?shipType.amount:shipType.unitValue,coinFlag:shipType.coinFlag,unitValue:shipType.unitValue,amount:shipType.amount};});};$scope.locationMapping=function(location){return location.map(function(loc){return{Key:loc.id+' | '+loc.name,Value:loc.id};});};$scope.loadRouteInfo=function(){if(!$scope.model.notDeliveredResolution)return;SetupService.get($scope.model.branchId).then(function(data){// $scope.model.vaultDate = moment.utc(data.currentVaultDate).format('YYYY-MM-DD')
// $scope.minVaultDate = {
//   minDate: $scope.model.vaultDate,
// }
return data;}).then(function(data){return getNextAvailableRoutes(ShipmentService,$scope,$scope.model.toLocationId,$location,$q,BranchService,data.holdRoute,HoldService);}).catch(function(err){console.log(err);});};$scope.routeSequenceChanged=function(){// $scope.model.routeSequence = null;
var routeId=$scope.model.routeId?$scope.model.routeId:$scope.model.lastSelectedRoute;if($scope.model.totalRoutes){$scope.model.totalRoutes.map(function(data){$scope.model.routeSequence=data.routeId===routeId?0:$scope.model.routeSequence;});$scope.model.routeInfo=_.find($scope.model.totalRoutes,{routeId:routeId});}};$scope.handleActionLable=function(msg){var selectedDeliveryResolution=$scope.model.deliveryResolutions.filter(function(resolutionObj){return resolutionObj.description==$scope.model.deliveryResolution;});if(selectedDeliveryResolution&&selectedDeliveryResolution.length){$scope.model.isReRoute=selectedDeliveryResolution[0].messageId=='NDR.noTimeline'?false:true;}if(selectedDeliveryResolution[0].messageId==='NDR.redeliverNextDay'){SetupService.get($scope.model.branchId).then(function(data){var branchVault=moment.utc(data.currentVaultDate).add(1,"day").format("YYYY-MM-DD");var nextVault=$scope.model.date?moment($scope.model.date).utc(true).format('YYYY-MM-DD'):null;if(nextVault!==branchVault){$scope.model.vaultDate=branchVault;$scope.model.date=branchVault;$scope.model.routeId=null;$scope.model.routeIdFromNextVaultDate=null;$scope.model.routeList=[];$scope.minVaultDate={minDate:branchVault};}});}};$scope.$watch('model.shipTypeObj.shiptypeId',function(newValue,oldValue){if(newValue!==oldValue){$scope.validateLoadedAmount();}});$scope.validateLoadedAmount=function(){var selected=$scope.model.shipTypeObj.shiptypeId;if(!selected)return;var loadShipmentAmount=null;if(selected.coinFlag){var qty=Number($scope.model.qty)||0;loadShipmentAmount=qty*selected.amount;}else{loadShipmentAmount=shipmentDetails.amount;$scope.model.qty=1;}$scope.model.amount=loadShipmentAmount;};init();$scope.ok=function(err){var trackingChanged=$scope.model.updatedTrackingId!==$scope.model.originalTrackingId;if(trackingChanged){confirmSupervisor('put-items-on-hold',{trackingId:$scope.model.updatedTrackingId},function(_ref20){var modal=_ref20.modal,supId=_ref20.supId;$scope.model.supervisorId=supId;callback({$scope:$scope,modal:itemNotDeliveredmodal,supervisorId:supId});modal.close();},function(_ref21){var modal=_ref21.modal;modal.close();});}else{$scope.model.loading=true;$scope.model.supervisorId=loggedInUser.id;callback({$scope:$scope,modal:itemNotDeliveredmodal,supervisorId:loggedInUser.id});}};$scope.cancel=function(){negative({modal:itemNotDeliveredmodal});};}]});rejectModal(itemNotDeliveredmodal,negative);};var forceCloseRoute=function forceCloseRoute(routeId,routeVerifyData,remainingToCoinCheckout,totalCoinShipmentOnRoute,coinCheckOut,isAllCoinVerified,remainingItemList,callback,negative,routeName){var forceCloseRouteModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_forceCloseRoute2.default,size:'lg',controller:['$scope','$translate','MessageService','User','$q','ScanService','ShipmentService',function($scope,$translate,MessageService,User,$q,ScanService,ShipmentService){$scope.model={routeId:routeId,routeName:routeName,loggedInUser:User.getUser(),remainingToCoinCheckout:remainingToCoinCheckout,totalCoinShipmentOnRoute:totalCoinShipmentOnRoute,reasonList:[],selectedReasonForCoin:null,cursor:0,coinCheckOut:coinCheckOut,isAllCoinVerified:isAllCoinVerified,remainingItemList:remainingItemList,logisticItemReason:[]};$scope.loading=false;$scope.currentrouteId=routeId;var getErrorMessage=function getErrorMessage(err){if(err&&err.data&&err.data.message){return $translate.instant('error.'+err.data.message)||err.data.message;}else{return err.toString();}};var init=function init(){$scope.loading=true;// const loggedInUser = User.getUser()
$scope.model.logisticItemReason.push({title:'logisticItems',messageIds:['IM.barcodeDamaged','IM.notScannable']});routeVerifyData.route.forEach(function(record,index){record.reasons=null;});MessageService.getReasons($scope.model.loggedInUser.languageId,[].concat((0,_toConsumableArray3.default)(routeVerifyData.route),(0,_toConsumableArray3.default)($scope.model.logisticItemReason))).then(function(reasonObjList){$scope.model.reasonList=[{messageId:'coinNotVerified',description:'Coin Not Verified'}];routeVerifyData.route.forEach(function(record,index){record.reasons=reasonObjList.results.shipmentReason[index];});remainingItemList.forEach(function(record,index){record.reasons=reasonObjList.results.logisticItemReason;});$scope.model.routeVerifyResults=routeVerifyData.route;}).catch(function(err){console.error(err);$scope.model.error=getErrorMessage(err);}).finally(function(){$scope.loading=false;});};init();$scope.allowScan=function(routeVerifyResult){return['E_PICKUP_NOT_CHECKED_IN','E_DELIVERY_NOT_DELIVERED','E_DELIVERY_NOT_ON_HOLD'].includes(routeVerifyResult.message);};// Update trackingId 
$scope.updateTrackingId=function(data){$scope.oldTrackingId=data.trackingId;editTrackingIdModal(data.trackingId,function(_ref22){var modal=_ref22.modal,trackingId=_ref22.trackingId,comment=_ref22.comment,supervisorId=_ref22.supervisorId;$scope.newTrackingId=trackingId;ShipmentService.updateShipmentTrackingId(data.shipmentId,$scope.oldTrackingId,$scope.newTrackingId,$scope.model.loggedInUser.branchId,comment).then(function(data){modal.close();}).then(function(){$scope.updateRouteVerifyResults();// find and update existing array with new trackingId
}).catch(function(err){if(err&&err.data&&err.data.message){errorModal("error."+err.data.message);}});},function(_ref23){var modal=_ref23.modal;modal.close();});};// find and update existing array with new trackingId
$scope.updateRouteVerifyResults=function(){var index=_.findIndex($scope.model.routeVerifyResults,{trackingId:$scope.oldTrackingId});var _$scope$model$routeVe=$scope.model.routeVerifyResults.splice(index,1),_$scope$model$routeVe2=(0,_slicedToArray3.default)(_$scope$model$routeVe,1),x=_$scope$model$routeVe2[0];x.trackingId=$scope.newTrackingId;$scope.model.routeVerifyResults.splice(index,0,x);};$scope.selectedCoinReason=function(){routeVerifyData.route.forEach(function(record,index){if(record.coinFlag)record.selectedReason=$scope.model.selectedReasonForCoin;});};$scope.goToScan=function(record){callback({modal:forceCloseRouteModal,action:'scan'// scanValue: record.trackingId
});};$scope.ok=function(err){// $scope.loading = true;
confirmSupervisor('force-close',null,function(_ref24){var modal=_ref24.modal,supId=_ref24.supId;$scope.model.supervisorId=supId;// $scope.loading = false;
callback({$scope:$scope,action:'save',modal:forceCloseRouteModal});modal.close();},function(_ref25){var modal=_ref25.modal;// $scope.loading = false;
modal.close();});};$scope.cancel=function(){negative({modal:forceCloseRouteModal});};}]});rejectModal(forceCloseRouteModal,negative);};var shipmentNotPickedUp=function shipmentNotPickedUp(validShipment,callback,negative){var isImmediateDeliveryTransfer=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_shipmentNotPickedUp2.default,size:'md',controller:['$scope','ShipmentService','DateUtil','LocationService','$location','$q','BranchService','HoldService','SetupService','User','Modal','RouteService',function($scope,ShipmentService,DateUtil,LocationService,$location,$q,BranchService,HoldService,SetupService,User,Modal,RouteService){$scope.model={shipmentInfo:[validShipment],branchId:validShipment.branchId,date:null,routeId:null,loading:false,isGettingRoutes:false,isGettingLocationRoutes:false,fromLocationId:validShipment.fromLocationId,toLocationId:validShipment.toLocationId,loggedInUser:User.getUser(),isShipmentNotPickedUpModal:true,isImmediateDeliveryTransfer:isImmediateDeliveryTransfer,vaultDate:'',isInitializing:false,nextRouteData:'',nextRouteDetails:'',routeList:[],routeSequence:null,lastSelectedRoute:validShipment.routeId||null,routeIds:'',totalRoutes:'',note:'',routeTotalRecords:0,routeOffset:0,routeSearchKey:''};var init=function init(){if(validShipment.vaultDate){var utcMoment=moment.utc(validShipment.vaultDate).add(1,'day');var year=utcMoment.year();var month=utcMoment.month();var day=utcMoment.date();var dateObj=new Date(year,month,day,0,0,0,0);$scope.model.date=dateObj;$scope.model.vaultDate=dateObj;var vaultMoment=moment.utc(validShipment.vaultDate);var minDateObj=new Date(vaultMoment.year(),vaultMoment.month(),vaultMoment.date(),0,0,0,0);$scope.minVaultDate={minDate:minDateObj};$scope.model.isInitializing=true;$scope.onVaultDateChange();}};$scope.mappingData=function(arr,label,value){return arr.map(function(item){var arrayObject={Key:(item[value]||item.routeId||item.id)+" | "+(item[label]||item.routeName||item.name),Value:item[value]||item.routeId||item.id,dataObj:item};return arrayObject;});};$scope.getLocationNextRoute=function(){var vaultDate=$scope.model.date?moment($scope.model.date).format('YYYY-MM-DD'):null;if(!vaultDate)return;LocationService.getNextVaultDateRoute($scope.model.fromLocationId,$scope.model.branchId,vaultDate).then(function(data){if(data.nextVaultDate){var apiDate=moment.utc(data.nextVaultDate).format('YYYY-MM-DD');var currentDate=$scope.model.date?moment($scope.model.date).format('YYYY-MM-DD'):null;if(apiDate!==currentDate){if($scope.model.isInitializing){var utcMoment=moment.utc(data.nextVaultDate);var dateObj=new Date(utcMoment.year(),utcMoment.month(),utcMoment.date(),0,0,0,0);$scope.model.date=dateObj;$scope.model.vaultDate=dateObj;lastVaultDate=apiDate;}else{$scope.model.routeId=null;return;}}}var routeIdStr=data.routeId;if(routeIdStr&&$scope.model.routeList&&$scope.model.routeList.length>0){var preSelected=_.find($scope.model.routeList,{Value:routeIdStr});if(preSelected){$scope.model.routeId=preSelected;}}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.isInitializing=false;});};$scope.getActiveRoutes=function(searchKey,offset){searchKey=searchKey||"";$scope.model.isGettingRoutes=true;var routeSearchObj={queryJSON:{rules:[{field:"branchId",condition:"IN",data:[$scope.model.branchId]},{field:"active",condition:"=",data:true},{field:"holdRoute",condition:"=",data:false},{group:{rules:[{field:"id",condition:"like",data:"%"+searchKey+"%"},{field:"name",condition:"like",data:"%"+searchKey+"%"}],operator:"OR"}}],operator:"AND"}};return RouteService.all(routeSearchObj,offset,20).then(function(res){var routes=$scope.mappingData(res.results,"name","id");if(offset===0||offset===undefined){$scope.model.routeList=routes;$scope.model.routeTotalRecords=res.total;}else{$scope.model.routeList=$scope.model.routeList.concat(routes);}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.isGettingRoutes=false;});};$scope.reloadRouteData=function(searchKey,offset){$scope.model.routeOffset=offset;$scope.model.routeSearchKey=searchKey;$scope.getActiveRoutes(searchKey,offset);};var lastVaultDate=null;$scope.onVaultDateChange=function(){var currentDate=$scope.model.date?moment($scope.model.date).format('YYYY-MM-DD'):null;if(currentDate&&currentDate===lastVaultDate)return;lastVaultDate=currentDate;$scope.model.routeId=null;if($scope.model.date){$scope.model.vaultDate=$scope.model.date;$scope.getActiveRoutes("",0).then(function(){$scope.getLocationNextRoute();});}};init();$scope.ok=function(){if($scope.model.loading||!$scope.model.date||!$scope.model.routeId)return;$scope.model.loading=true;var destRouteDate=moment($scope.model.date).format('YYYY-MM-DD');var destRouteId=$scope.model.routeId.Value||$scope.model.routeId;ShipmentService.shipmentPickupsReRoute($scope.model.branchId,validShipment.trackingId,validShipment.routeId,destRouteId,destRouteDate,$scope.model.loggedInUser.id,$scope.model.note).then(function(data){callback({modal:modal});}).catch(function(err){if(err&&err.data&&err.data.message){return Modal.errorModal('error.'+err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.cancel=function(){negative({modal:modal});};}]});rejectModal(modal,negative);};var checkinForceCloseRoute=function checkinForceCloseRoute(routeId,routeVerifyData,remainingItemList,callback,negative,routeName,vaultDate){var checkInForceCloseRouteModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_checkinForceClose2.default,size:'lg',controller:['$scope','$translate','MessageService','User','$q','ScanService','ShipmentService','CommonLayoutService','DateUtil','LocationService','RouteService',function($scope,$translate,MessageService,User,$q,ScanService,ShipmentService,CommonLayoutService,DateUtil,LocationService,RouteService){$scope.model={routeId:routeId,routeName:routeName,vaultDate:vaultDate,loggedInUser:User.getUser(),remainingItemList:remainingItemList,logisticItemReason:[]};$scope.loading=false;$scope.currentrouteId=routeId;var getErrorMessage=function getErrorMessage(err){if(err&&err.data&&err.data.message){return $translate.instant('error.'+err.data.message)||err.data.message;}else{return err.toString();}};var init=function init(){$scope.loading=true;// const loggedInUser = User.getUser()
$scope.model.logisticItemReason.push({title:'logisticItems',messageIds:['IM.itemLost','IM.itemStolen','IM.itemDamaged']});routeVerifyData.route.forEach(function(record,index){record.reasons=null;});MessageService.getReasons($scope.model.loggedInUser.languageId,[].concat((0,_toConsumableArray3.default)(routeVerifyData.route),(0,_toConsumableArray3.default)($scope.model.logisticItemReason))).then(function(reasonObjList){routeVerifyData.route.forEach(function(record,index){record.reasons=reasonObjList.results.shipmentReason[index];});$scope.model.remainingItemList.forEach(function(record,index){record.reasons=reasonObjList.results.logisticItemReason;});$scope.model.routeVerifyResults=routeVerifyData.route;}).catch(function(err){console.error(err);$scope.model.error=getErrorMessage(err);}).finally(function(){$scope.loading=false;});};init();$scope.maskingString=function(trackingId){return CommonLayoutService.maskingString(trackingId);};$scope.allowScan=function(routeVerifyResult){return['E_PICKUP_NOT_CHECKED_IN','E_DELIVERY_NOT_DELIVERED','E_DELIVERY_NOT_ON_HOLD'].includes(routeVerifyResult.message);};$scope.hasRerouteItems=function(){return _.some($scope.model.routeVerifyResults,function(item){return item.isRequiredPickup&&!item.orderNo&&!item.verified;});};// Update trackingId 
$scope.updateTrackingId=function(data){$scope.oldTrackingId=data.trackingId;editTrackingIdModal(data.trackingId,function(_ref26){var modal=_ref26.modal,trackingId=_ref26.trackingId,comment=_ref26.comment,supervisorId=_ref26.supervisorId;$scope.newTrackingId=trackingId;ShipmentService.updateShipmentTrackingId(data.shipmentId,$scope.oldTrackingId,$scope.newTrackingId,$scope.model.loggedInUser.branchId,comment).then(function(data){modal.close();}).then(function(){$scope.updateRouteVerifyResults();// find and update existing array with new trackingId
}).catch(function(err){if(err&&err.data&&err.data.message){errorModal("error."+err.data.message);}});},function(_ref27){var modal=_ref27.modal;modal.close();});};// find and update existing array with new trackingId
$scope.updateRouteVerifyResults=function(){var index=_.findIndex($scope.model.routeVerifyResults,{trackingId:$scope.oldTrackingId});var _$scope$model$routeVe3=$scope.model.routeVerifyResults.splice(index,1),_$scope$model$routeVe4=(0,_slicedToArray3.default)(_$scope$model$routeVe3,1),x=_$scope$model$routeVe4[0];x.trackingId=$scope.newTrackingId;$scope.model.routeVerifyResults.splice(index,0,x);};$scope.reroute=function(record){record.branchId=$scope.model.loggedInUser.branchId;record.vaultDate=$scope.model.vaultDate;shipmentNotPickedUp(record,function(_ref28){var rerouteModal=_ref28.modal;rerouteModal.close();// Remove the item from the list
var index=_.findIndex($scope.model.routeVerifyResults,{locationId:record.locationId,trackingId:record.trackingId});if(index>-1){$scope.model.routeVerifyResults.splice(index,1);if(record.isError){routeVerifyData.errorCount--;}if($scope.model.routeVerifyResults.length===0&&(!$scope.model.remainingItemList||$scope.model.remainingItemList.length===0)){callback({$scope:$scope,action:'save',modal:checkInForceCloseRouteModal});checkInForceCloseRouteModal.close();}}},function(_ref29){var rerouteModal=_ref29.modal;rerouteModal.close();});};$scope.goToScan=function(record){callback({modal:checkInForceCloseRouteModal,action:'scan',scanValue:record.trackingId});};$scope.ok=function(err){// $scope.loading = true;
confirmSupervisor('force-close',null,function(_ref30){var modal=_ref30.modal,supId=_ref30.supId;$scope.model.supervisorId=supId;// $scope.loading = false;
callback({$scope:$scope,action:'save',modal:checkInForceCloseRouteModal});modal.close();},function(_ref31){var modal=_ref31.modal;// $scope.loading = false;
modal.close();});};$scope.cancel=function(){negative({modal:checkInForceCloseRouteModal});};}]});rejectModal(checkInForceCloseRouteModal,negative);};// common function for holdReleases and returnItems 'used to display next available route according to date'
function getNextAvailableRoutes(ShipmentService,$scope,locationId,$location,$q,BranchService,branchUnassignedOrHoldRoute,HoldService){var routeDefer=$q.defer();var vaultDate=$scope.model.vaultDate?moment($scope.model.vaultDate).format('YYYY-MM-DD'):null;ShipmentService.locationNextRoute($scope.model.branchId,locationId,vaultDate,0).then(function(data){$scope.model.nextRouteData=data;$scope.model.nextRouteDetails=$scope.model.nextRouteData&&$scope.model.nextRouteData[0]?$scope.model.nextRouteData[0]:[];// $scope.model.routeId = $scope.model.nextRouteDetails.routeId;
// $scope.model.date = moment.utc($scope.model.nextRouteDetails.date).format('YYYY-MM-DD');
$scope.model.routeSequence=$scope.model.nextRouteDetails.routeSeq;routeDefer.resolve($scope.model);}).catch(function(err){$scope.errorMessage=$translate.instant('error.'+err.data.message);$scope.errCode=err.data.message;if(err&&err.data&&err.data.message=="91902"){// call if location has no routes 
$scope.model.routeId=branchUnassignedOrHoldRoute.id;$scope.model.routeSequence=0;return loadRouteList($scope.model,$scope,$location,$q,BranchService,branchUnassignedOrHoldRoute,HoldService);}});routeDefer.promise.then(function(routeDetails){// call if location has next available route, and display next available route details selected in table.
return loadRouteList(routeDetails,$scope,$location,$q,BranchService,branchUnassignedOrHoldRoute,HoldService);});}// common function to `load routeList` for release item and return item
function loadRouteList(routeDetails,$scope,$location,$q,BranchService,branchUnassignedOrHoldRoute,HoldService){routeDetails.loadRouteList=true;// get routeList based on branchId and current vaultDate
$scope.days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];$scope.generateSearchObj=function(){var baseDate=$scope.model.date||routeDetails.vaultDate;if(!baseDate){return null;}var day=moment(baseDate).day();if(!day===undefined){return null;}return{queryJSON:{rules:[{field:'branchId',condition:'=',data:routeDetails.branchId},{field:'defRoute'+$scope.days[day]+'Id',condition:'!=',data:null}],operator:'AND'}};};$scope.loadRoutes=function(){$scope.model.lastSelectedRoute=$scope.model.routeId;routeDetails.date=$scope.model.date||routeDetails.date;routeDetails.vaultDate=$scope.model.date||routeDetails.vaultDate;var searchObj=$scope.generateSearchObj();// const formattedDate = moment($scope.model.vaultDate).format('YYYY-MM-DD');
if(!routeDetails.date){return;}var formattedDate=moment(routeDetails.date).format('YYYY-MM-DD');routeDetails.routeList=[];var matchingNextRouteId=null;if($scope.model.nextRouteData&&$scope.model.nextRouteData.length&&$scope.model.date){var selectedDateStr=moment($scope.model.date).format('YYYY-MM-DD');var matchingRoute=_.find($scope.model.nextRouteData,function(route){if(!route.date)return false;var routeDateStr=moment(route.date).utc(true).format('YYYY-MM-DD');return routeDateStr===selectedDateStr;});matchingNextRouteId=matchingRoute?matchingRoute.routeId:null;}$scope.model.routeIdFromNextVaultDate=matchingNextRouteId;return HoldService.getAllRoutes(routeDetails.branchId,formattedDate).then(function(res){routeDetails.totalRoutes=res.result;res.result.forEach(function(routes){routeDetails.routeList.push(routes);});var nextAvailableRoute=routeDetails.nextRouteDetails&&routeDetails.nextRouteDetails.routeId?routeDetails.nextRouteDetails.routeId:null;var isValidRoute=function isValidRoute(routeId){return routeId&&_.find(routeDetails.routeList,{'routeId':routeId});};var selectedRouteId=null;if($scope.model.routeIdFromNextVaultDate&&isValidRoute($scope.model.routeIdFromNextVaultDate)){selectedRouteId=$scope.model.routeIdFromNextVaultDate;}else if(!$scope.model.routeIdFromNextVaultDate){selectedRouteId=null;$scope.model.lastSelectedRoute=null;}else if(nextAvailableRoute&&isValidRoute(nextAvailableRoute)){selectedRouteId=nextAvailableRoute;}$scope.model.routeId=selectedRouteId;if(!$scope.model.routeIdFromNextVaultDate&&routeDetails.routeList.length>0&&$scope.model.isItemNotDeliveredModal){$scope.model.routeId=null;}$scope.model.routeSequence=$scope.model.routeId===branchUnassignedOrHoldRoute.id?0:routeDetails.nextRouteDetails&&routeDetails.nextRouteDetails.routeSeq?routeDetails.nextRouteDetails.routeSeq:0;$scope.model.routeInfo=_.find($scope.model.totalRoutes,{'routeId':$scope.model.routeId});}).catch(function(err){$scope.model.routeId=null;console.log(err);});// if (!searchObj) {
//   return;
// }
// return BranchService.getReleaseRoutes(routeDetails.branchId, formattedDate)
//   .then((res) => {
//     routeDetails.totalRoutes = res;
//     const nextAvailableRoutes = routeDetails.nextRouteDetails
//     if (branchHoldRoute && !_.find(res, { 'routeId': branchHoldRoute.id })) {
//       res.push({
//         'routeName': branchHoldRoute.name,
//         'routeId': branchHoldRoute.id,
//         'stops': 0,
//         'routeSequence': 0
//       });
//     }
//     if (nextAvailableRoutes && !_.find(res, { 'routeId': nextAvailableRoutes.routeId })) {
//       res.push({
//         'routeName': nextAvailableRoutes.routeId,
//         'routeId': nextAvailableRoutes.routeId,
//         'routeSequence': nextAvailableRoutes.routeSeq
//       });
//     }
//     res.forEach((routes) => {
//       routeDetails.routeList.push(routes);
//     })
//     const nextAvailableRoute = routeDetails.nextRouteDetails.routeId;
//     $scope.model.routeId = !_.find(routeDetails.routeList, { 'routeId': nextAvailableRoute }) ? branchHoldRoute.id : nextAvailableRoute;
//     $scope.model.routeSequence = $scope.model.routeId === branchHoldRoute.id ? 0 : routeDetails.nextRouteDetails.routeSeq;
//   })
//   .catch((err) => {
//     console.log(err);
//   })
//   .finally(() => {
//     $scope.loading = false;
//   });
};// load routes on page load based on current vaultDate
var queryParams=$location.search();var dateDefer=$q.defer();// queryParams.date = /\d{4}-\d{2}-\d{2}/.test(queryParams.date) ? queryParams.date : null;
var year=void 0,month=void 0,day=void 0;if(!routeDetails.date&&routeDetails.nextRouteDetails.date){var utcMoment=moment.utc(routeDetails.nextRouteDetails.date);year=utcMoment.year();month=utcMoment.month();day=utcMoment.date();}else if(routeDetails.vaultDate){if(routeDetails.vaultDate instanceof Date){year=routeDetails.vaultDate.getFullYear();month=routeDetails.vaultDate.getMonth();day=routeDetails.vaultDate.getDate();}else{var _utcMoment=moment.utc(routeDetails.vaultDate);year=_utcMoment.year();month=_utcMoment.month();day=_utcMoment.date();}}else{dateDefer.resolve(null);return;}var dateObj=new Date(year,month,day,0,0,0,0);dateDefer.resolve(dateObj);dateDefer.promise.then(function(date){routeDetails.date=date;$scope.model.date=date;}).then(function(){$scope.loadRoutes();}).finally(function(){$scope.loading=false;});}// Release item from HOLD
var holdReleases=function holdReleases(shipment,allowSupervisorScan,callback,negative){var itemReleaseModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_verifyHoldRelease2.default,size:'lg',controller:['$scope','$translate','$location','SetupService','BranchService','MessageService','User','ShipmentService','$q','HoldService','RouteStopService',function($scope,$translate,$location,SetupService,BranchService,MessageService,User,ShipmentService,$q,HoldService,RouteStopService){$scope.loading=false;$scope.model={trackingId:'',holdDate:'',deliveryDate:'',shipments:'',toLocationRoute:'',fromLocationRoute:'',toLocationRouteId:'',toLocationRouteSeq:'',toLocationRouteDate:'',fromLocationRouteId:'',fromLocationRouteSeq:'',fromLocationRouteDate:'',branchId:shipment.branchId?shipment.branchId:User.getUser().branchId,vaultDate:'',nextRouteData:'',nextRouteDetails:'',routeList:[],routeSequence:null,routeIds:'',totalRoutes:'',date:'',toLocationId:'',loadRouteList:false,routeTransfered:'',lastSelectedRoute:null,allowSupervisorScan:allowSupervisorScan,userDetails:User.getUser(),routeStop:[]};$scope.model.trackingId=shipment.trackingId;$scope.model.shipment=shipment.toLocation;// $scope.model.toLocationId = shipment.toLocation ? shipment.toLocation.id : null;
$scope.model.toLocationId=shipment.toLocationId?shipment.toLocationId:null;var getErrorMessage=function getErrorMessage(err){if(err&&err.data&&err.data.message){return $translate.instant('error.'+err.data.message)||err.data.message;}else{return err.toString();}};var init=function init(){$scope.loading=true;fetchBranchLocation($scope.model.branchId).then(function(branchLoc){$scope.model.branchLocation=branchLoc;return SetupService.get($scope.model.branchId);}).then(function(data){$scope.model.vaultDate=moment.utc(data.currentVaultDate).format('YYYY-MM-DD');$scope.minVaultDate={minDate:$scope.model.vaultDate};return data;}).then(function(data){// get next available route based on branchId, VaultDate and toLocationId
return getNextAvailableRoutes(ShipmentService,$scope,$scope.model.toLocationId,$location,$q,BranchService,data.unassignedRoute,HoldService);}).then(function(){return fetchRouteStops();}).finally(function(){$scope.loading=false;});};$scope.routeSequenceChanged=function(){// $scope.model.routeSequence = null;
var routeId=$scope.model.routeId?$scope.model.routeId:$scope.model.lastSelectedRoute;if($scope.model.totalRoutes.length>0){$scope.model.totalRoutes.map(function(data){$scope.model.routeSequence=data.routeId===routeId?0:$scope.model.routeSequence;});$scope.model.routeInfo=_.find($scope.model.totalRoutes,{routeId:routeId});}fetchRouteStops();};$scope.map=null;$scope.model.canShowMap=false;function updateReleaseHoldMap(){var bounds=[];if($scope.map){$scope.map.remove();$scope.map=null;}var branch=$scope.model.branchLocation;var holdLoc=$scope.model.shipment;var stops=$scope.model.routeStops||[];$scope.model.canShowMap=!!(branch&&branch.lat&&branch.long);if(!$scope.model.canShowMap)return;setTimeout(function(){$scope.map=L.map('release-hold-map',{zoomControl:true});L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'&copy; OpenStreetMap contributors'}).addTo($scope.map);// Branch marker
if(branch.lat&&branch.long){var branchMarker=L.marker([branch.lat,branch.long],{icon:new L.AwesomeNumberMarkers({number:'B',markerColor:'black'})}).addTo($scope.map);branchMarker.bindTooltip('<strong>'+branch.branchId+'</strong><br>'+branch.address+'<br>'+branch.city+', '+branch.state+' '+branch.zip,{direction:'top'});bounds.push([branch.lat,branch.long]);}// Hold location marker
if(holdLoc&&holdLoc.lat&&holdLoc.long){var holdMarker=L.marker([holdLoc.lat,holdLoc.long],{icon:new L.AwesomeNumberMarkers({number:'H',markerColor:'cadetblue'})}).addTo($scope.map);holdMarker.bindTooltip('<strong>'+holdLoc.name+' | '+shipment.trackingId+'</strong><br>'+holdLoc.address+','+holdLoc.city+', '+holdLoc.state+' '+holdLoc.zip,{direction:'top'});bounds.push([holdLoc.lat,holdLoc.long]);}// Route stops
if(stops&&stops.length){stops.forEach(function(stop,idx){if(stop.lat&&stop.long){var marker=L.marker([stop.lat,stop.long],{icon:new L.AwesomeNumberMarkers({number:idx+1,markerColor:'green'})}).addTo($scope.map);marker.bindTooltip('<strong>'+stop.locationName+'</strong><br>'+stop.address,{direction:'top'});bounds.push([stop.lat,stop.long]);}});}if(bounds.length)$scope.map.fitBounds(bounds,{padding:[30,30]});setTimeout(function(){return $scope.map.invalidateSize();},200);},100);}function fetchBranchLocation(branchId){return SetupService.get(branchId).then(function(data){return{branchId:branchId,address:data.address,city:data.city,state:data.state,zip:data.zip,lat:data.gpsLat,long:data.gpsLong};});}function fetchRouteStops(){$scope.model.fetchRouteStops=true;setTimeout(function(){if($scope.model.routeId&&$scope.model.date&&$scope.model.branchId){var formattedDate=moment($scope.model.date).format('YYYY-MM-DD');var payload={routeId:$scope.model.routeId,date:formattedDate,branch:$scope.model.branchId};return RouteStopService.routeStopList(payload.routeId,payload.date,payload.branch).then(function(data){$scope.model.routeStops=data&&data.results?data.results:[];updateReleaseHoldMap();}).catch(function(err){$scope.model.routeStops=[];console.error('Error fetching route stops:',err);}).finally(function(){$scope.model.fetchRouteStops=false;});}else{$scope.model.routeStops=[];$scope.model.fetchRouteStops=false;}$scope.$apply();},700);}$scope.removeMap=function(){if($scope.map){$scope.map.remove();$scope.map=null;}};$scope.cancel=function(){// itemReleaseModal.close();
negative({modal:itemReleaseModal});};$scope.validateSupervisorScan=function(){if($scope.model.allowSupervisorScan){var errorMsg=$translate.instant('users.supervisor_scan_error',{firstName:$scope.model.userDetails.firstName,lastName:$scope.model.userDetails.lastName});return confirm({header:$translate.instant('errorModal.title'),message:$translate.instant(errorMsg),callback:function callback(_ref32){var modal=_ref32.modal;$scope.ok();modal.close();},type:'danger',buttons:['common.ok']});}else{$scope.ok();}};$scope.ok=function(err){$scope.isLoading=true;// confirmSupervisor('hold-release', { trackingId: shipment.trackingId }, ({ modal, supId }) => {
verifySupervisorScan('hold-release',{trackingId:shipment.trackingId},$scope).then(function(supervisorInfo){$scope.model.supervisorId=supervisorInfo?supervisorInfo.supId:null;$scope.model.loading=true;callback({supervisorId:supervisorInfo?supervisorInfo.supId:null,comment:$scope.model.comment?$scope.model.comment:null,shipmentAssignedTo:$scope.model.routeId,selectedDate:$scope.model.date,routeInfo:$scope.model.routeInfo,modal:itemReleaseModal});if(supervisorInfo)supervisorInfo.modal.close();// modal.close()
// }, ({ modal }) => {
//   $scope.isLoading = false;
//   modal.close()
// })
});};init();}]});rejectModal(itemReleaseModal,negative);};// Cancel or return item from HOLD
var returnItems=function returnItems(shipment,callback,negative){var itemReturnModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_verifyItemReturn2.default,size:'lg',controller:['$scope','$translate','$location','SetupService','BranchService','MessageService','User','ShipmentService','$q','HoldService',function($scope,$translate,$location,SetupService,BranchService,MessageService,User,ShipmentService,$q,HoldService){$scope.loading=false;$scope.model={trackingId:'',shipments:'',toLocationRoute:'',fromLocationRoute:'',toLocationRouteId:'',toLocationRouteSeq:'',toLocationRouteDate:'',fromLocationRouteId:'',fromLocationRouteSeq:'',fromLocationRouteDate:'',fromLocation:'',branchId:User.getUser().branchId,vaultDate:'',nextRouteData:'',nextRouteDetails:'',routeList:[],routeSequence:null,routeIds:'',totalRoutes:'',date:'',loadRouteList:false,lastSelectedRoute:null};$scope.model.trackingId=shipment.trackingId;$scope.model.toLocationRoute=shipment.toLocation;$scope.model.fromLocation=shipment.fromLocation?shipment.fromLocation.id:null;var getErrorMessage=function getErrorMessage(err){if(err&&err.data&&err.data.message){return $translate.instant('error.'+err.data.message)||err.data.message;}else{return err.toString();}};var init=function init(){$scope.loading=true;SetupService.get($scope.model.branchId).then(function(data){$scope.model.vaultDate=moment.utc(data.currentVaultDate).format('YYYY-MM-DD');$scope.minVaultDate={minDate:$scope.model.vaultDate};return data;}).then(function(data){// get next available route based on branchId, VaultDate and toLocationId
return getNextAvailableRoutes(ShipmentService,$scope,$scope.model.fromLocation,$location,$q,BranchService,data.unassignedRoute,HoldService);}).finally(function(){$scope.loading=false;});// get route sequence based on routeId
$scope.routeSequenceChanged=function(){// $scope.model.routeSequence = null;
var routeId=$scope.model.routeId?$scope.model.routeId:$scope.model.lastSelectedRoute;$scope.model.totalRoutes.map(function(data){$scope.model.routeSequence=data.routeId===routeId?0:$scope.model.routeSequence;});};};$scope.cancel=function(){// itemReturnModal.close();
negative({modal:itemReturnModal});};$scope.ok=function(err){$scope.isLoading=true;confirmSupervisor('return-items',{trackingId:$scope.model.trackingId},function(_ref33){var modal=_ref33.modal,supId=_ref33.supId;$scope.model.supervisorId=supId;$scope.model.loading=true;callback({supervisorId:supId,comment:$scope.model.comment?$scope.model.comment:null,returnItemTo:$scope.model.routeId,selectedDate:$scope.model.date,modal:itemReturnModal});modal.close();},function(_ref34){var modal=_ref34.modal;$scope.isLoading=false;modal.close();});};init();}]});rejectModal(itemReturnModal,negative);};var closeRoute=function closeRoute(remainingItems,callback,negative){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_closeRoute2.default,size:'md',controller:['$scope',function($scope){$scope.remainingItems=remainingItems;$scope.reasonCodes=['Reason Code 1','Reason Code 2','Reason Code 3','Reason Code 4','Reason Code 5'];$scope.model={description:''};$scope.isSupervisorConfirmed=false;$scope.errorMessage='';$scope.supervisorConfirmed=function(supervisorId){$scope.isSupervisorConfirmed=true;$scope.errorMessage='';$scope.supervisor=supervisorId;};$scope.supervisorCancelled=function(){$scope.isSupervisorConfirmed=false;$scope.errorMessage='';};$scope.ok=function(){callback({modal:modal,supervisor:supervisor,remainingItems:$scope.remainingItems,description:$scope.model.description});};$scope.cancel=function(){negative({modal:modal});};}]});};var selectDeliveryLocation=function selectDeliveryLocation(locationIds,callback,negative){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_selectDeliveryLocation2.default,size:'md',controller:['$scope','LocationService','$q',function($scope,LocationService,$q){$scope.selectedLocationId='';$scope.loading=false;var init=function init(){$scope.loading=true;$q.all(locationIds.map(function(locationId){return LocationService.get(locationId);})).then(function(locations){$scope.deliveryLocations=locations;}).catch(function(err){$scope.cancel(err);}).finally(function(){$scope.loading=false;});};$scope.setSelected=function(deliveryLocation){$scope.selectedLocationId=deliveryLocation.id;};$scope.ok=function(){callback({$scope:$scope,modal:modal});};$scope.cancel=function(err){negative({modal:modal});};init();}]});};var closeBagout=function closeBagout(callback,negative){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_closeBagout2.default,size:'sm',controller:['$scope','BagoutService','$state','$location','$translate','SetupService','User',function($scope,BagoutService,$state,$location,$translate,SetupService,User){$scope.model={bagout:{id:''},message:'',isError:false,audio:_success_beep2.default// var currentBranchId = User.getUser().branchId;
};focusElementById('scan-bagout-seal');// SetupService.get(currentBranchId)
//   .then((res) => {
//     $scope.prefixes = res.prefixes;
//   })
$scope.cancel=function(err){negative({modal:modal});};$scope.playScannerBeep=function(){document.querySelector("#scanner_beep").play();};$scope.bagoutScanned=function(){if($scope.model.bagout.id===""||$scope.model.bagout.id==undefined){return;}$scope.model.message='';var finalBagoutData;finalBagoutData=$scope.model.bagout.id;$scope.loading=true;return BagoutService.getShipments(finalBagoutData).then(function(res){modal.close();$scope.loading=false;$location.url('/app/bag-out-print?bagout='+finalBagoutData);}).catch(function(err){$scope.model.isError=true;$scope.loading=false;if(err&&err.data&&err.data.message){$scope.model.bagout.id="";$scope.playScannerBeep();$scope.model.message=$translate.instant(err.data.message);}else{$scope.playScannerBeep();$scope.model.bagout.id=finalBagoutData;$scope.model.message=$translate.instant(error.UnableToLocateBagout);}});};$scope.view=function(){if($scope.isLoading)return;$scope.isLoading=true;$scope.bagoutScanned();};}]});rejectModal(modal,negative);};var commitSuccessModal=function commitSuccessModal(totalDollerAmount,totalEuroAmount,timeStamp,successMessage,transactionType,callback,currencySymbol){var modal=$uibModal.open({keyboard:false,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_commitSuccess2.default,size:'sm',windowClass:'width-415',controller:['$scope','$translate',function($scope,$translate){$scope.model={timeStamp:timeStamp,totalDollerAmount:totalDollerAmount,totalEuroAmount:totalEuroAmount,successMessage:successMessage,date:moment(timeStamp).format('ddd ,ll'),time:moment(timeStamp).format('HH:mm:ss UTC ZZ').replace('UTC','GMT'),transactionType:transactionType,currencySymbol:currencySymbol||'$'};$scope.ok=function(){callback({modal:modal});};}]});};var errorModal=function errorModal(errorCode,params){return confirm({header:$translate.instant('errorModal.title'),// message: $translate.instant(`error.${errorCode}`),
message:$translate.instant(''+errorCode,params),callback:function callback(_ref35){var modal=_ref35.modal;modal.close();},type:'danger',buttons:['common.ok']});};var successModal=function successModal(_ref36){var header=_ref36.header,message=_ref36.message,callback=_ref36.callback,_ref36$autoClose=_ref36.autoClose,autoClose=_ref36$autoClose===undefined?'true':_ref36$autoClose,_ref36$negative=_ref36.negative,negative=_ref36$negative===undefined?function(_ref37){var modal=_ref37.modal;modal.close();}:_ref36$negative,_ref36$size=_ref36.size,size=_ref36$size===undefined?'md':_ref36$size,_ref36$buttons=_ref36.buttons,buttons=_ref36$buttons===undefined?['routeControl.route_throw','common.cancel']:_ref36$buttons,_ref36$type=_ref36.type,type=_ref36$type===undefined?'success':_ref36$type;var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:autoClose?'static':'true',template:_modal2.default,size:size,controller:['$scope',function($scope){$scope.header=header;$scope.message=message;$scope.buttons=buttons;$scope.type=type;$scope.ok=function(){callback({modal:modal,$scope:$scope});};$scope.cancel=function(){negative({modal:modal,$scope:$scope});};}]});};var uploadedFileSelection=function uploadedFileSelection(locations,locationOptions,batchMasters,branches,callback,negative,lastSelectedFile){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_uploadedFileSelection2.default,size:'lg',controller:['$scope','$translate','RouteService','LocationService','$q','SetupService','User','BatchService',function($scope,$translate,RouteService,LocationService,$q,SetupService,User,BatchService){$scope.todayDate=moment().hour(0).minutes(0).seconds(0).toDate();$scope.model={selectedFile:'',uploadedFiles:[],currentVaultDate:null,error:'',pickupDate:null,deliveryDate:null,batchMaster:'',branch:locations.branchId,// branch: User.getUser().branchId,
selected:''};$scope.data={uploadedFiles:[],locations:locationOptions,batchMasters:batchMasters};$scope.offset=0;var init=function init(){$scope.loadingData=true;$q.all([$scope.getAllLocation('',0),SetupService.get($scope.model.branch),RouteService.getUploadedFiles()]).then(function(res){$scope.model.currentVaultDate=res[1].currentVaultDate;$scope.data.uploadedFiles=res[2].results;$scope.data.uploadedFiles=$scope.data.uploadedFiles.filter(function(file){return file!==null&&file!==undefined;}).map(function(file){return{fileName:file};});if($scope.data.uploadedFiles.length>0){$scope.data.uploadedFiles=$scope.mapData(res[2].results);$scope.model.totalRecords=$scope.data.uploadedFiles.length;$scope.model.batchFile=$scope.data.uploadedFiles[0];}}).then(function(){$scope.loadFileData();});};$scope.mapData=function(arrayObj){return arrayObj.map(function(obj){return{Key:obj,Value:obj};});};$scope.loadFileData=function(){var nextIteration=$q.defer();var invalidIndexes=[];var validFiles=[];if(!$scope.model.batchFile)return;var fileIndex=_.findIndex($scope.data.uploadedFiles,{fileName:$scope.model.batchFile.Value});$scope.model.error='';RouteService.getUploadFile($scope.model.batchFile.Value,locations.branchId)// RouteService.getUploadFile($scope.model.batchFile.Value, $scope.model.branch)
.then(function(res){$scope.model.fileDatas=res;if($scope.model.fileDatas.status){validFiles.push($scope.model.fileDatas);}else{$scope.model.pickupDate=moment.utc($scope.model.currentVaultDate).add(1,'second').format('YYYY-MM-DD hh:mm:ss'),$scope.model.deliveryDate=moment.utc($scope.model.currentVaultDate).add(1,'day').format('YYYY-MM-DD hh:mm:ss'),$scope.model.error=res.message;invalidIndexes.push(fileIndex);console.error(res.message);}}).then(function(){for(var i=invalidIndexes.length-1;i>=0;i--){$scope.data.uploadedFiles.splice(invalidIndexes[i],1);}$scope.data.uploadedFiles;return validFiles;}).then(function(fileData){var selectedFileData=[$scope.model.batchFile.Value].map(function(fileName,index){if(fileData[index]&&fileData[index].result&&fileData[index].result.deliveryDate!==null&&fileData[index].result.pickupDate!==null){fileData[index].result.deliveryDate=moment.utc(fileData[index].result.deliveryDate).format('YYYY-MM-DD hh:mm:ss');fileData[index].result.pickupDate=moment.utc(fileData[index].result.pickupDate).format('YYYY-MM-DD hh:mm:ss');}else{if(!fileData[index]){fileData[index]={result:{}};}fileData[index].result.pickupDate=moment.utc($scope.model.currentVaultDate).add(1,'second').format('YYYY-MM-DD hh:mm:ss');fileData[index].result.deliveryDate=moment.utc($scope.model.currentVaultDate).add(1,'day').format('YYYY-MM-DD hh:mm:ss');}return(0,_assign2.default)({},{fileName:fileName,fileData:fileData[index].result,status:fileData[index].status});});$scope.model.selectedFile=selectedFileData[0];return nextIteration.resolve();}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}console.error(err);}).finally(function(){$scope.loadingData=false;});return nextIteration.promise.then(function(){$scope.selectedFileChanged();});};// load locationType == INTERNAL, BANK data based on BranchID
$scope.loadLocationData=function(){var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:branches.map(function(ele){return ele.Value;})},{group:{rules:[{field:'locationType',condition:'=',data:'INTERNAL'},{group:{rules:[{field:'locationType',condition:'=',data:'BANK'},{field:'centralBank',condition:'=',data:true}],operator:'AND'}}],operator:'OR'}}],operator:'AND'}};return searchObj.queryJSON.rules.length?searchObj:null;};// load locationType == INTERNAL, BANK data based on BranchID With Search value
$scope.loadLocationDataWithSearch=function(searchKey){var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:branches.map(function(ele){return ele.Value;})},{group:{rules:[{field:'locationType',condition:'=',data:'INTERNAL'},{group:{rules:[{field:'locationType',condition:'=',data:'BANK'},{field:'centralBank',condition:'=',data:true}],operator:'AND'}}],operator:'OR'}},{group:{rules:[{field:"id",condition:"like",data:"%"+searchKey+"%"},{field:"name",condition:"like",data:"%"+searchKey+"%"}],operator:"OR"}}],operator:'AND'}};return searchObj.queryJSON.rules.length?searchObj:null;};$scope.getAllLocation=function(searchKey,offset){return;var batchSearchObj={branchId:branches.map(function(ele){return ele.Value;}),queryText:'%%'};var loadLocationDatas='';if(searchKey){$scope.offset=0;loadLocationDatas=$scope.loadLocationDataWithSearch(searchKey);}else{if(offset==0){$scope.offset=0;}loadLocationDatas=$scope.loadLocationData();}$q.all([LocationService.getAllLocation(loadLocationDatas,$scope.offset,_app2.default.defaultPageLimit),BatchService.all(batchSearchObj,0,MAXLIMIT)]).then(function(data){var batchSourceIds=data[1].results.filter(function(batch){return!!batch.batchSourceId;}).map(function(batch){return batch.batchSourceId;});if($scope.offset===0){$scope.totalLocationRecords=data[0].total;$scope.data.locations=$scope.mappingLocationDatas(data[0].results).filter(function(location){return batchSourceIds.includes(location.id);});$scope.offset+=10;if($scope.data.locations.length<=10&&!searchKey){$scope.changeOffsetFlag=false;$scope.getAllLocation('',_this.offset);}}else{var _locations=$scope.mappingLocationDatas(data[0].results).filter(function(location){return batchSourceIds.includes(location.id);});$scope.data.locations=$scope.data.locations.concat(_locations);$scope.offset+=10;if($scope.data.locations.length<=10){$scope.changeOffsetFlag=false;if($scope.totalLocationRecords>$scope.offset){$scope.getAllLocation('',$scope.offset);}}else $scope.changeOffsetFlag=true;}});};$scope.mappingLocationDatas=function(locations){return locations.map(function(location){return _.merge({Key:location.id+" | "+location.name,Value:location.id},location);});};$scope.fromLocationChanged=function(){if($scope.model.location){var selectedBatchType=batchMasters.find(function(batchMaster){return batchMaster.batchSourceId===$scope.model.location.id;});if($scope.model.batchMaster!==selectedBatchType.inputType){$scope.model.batchMaster=selectedBatchType.inputType;}}};// to check if pickupDate greater than deliveryDate then set pickupDate equal to deliveryDate
$scope.dateChanged=function(){if($scope.model.pickupDate>$scope.model.deliveryDate){$scope.model.deliveryDate=$scope.model.pickupDate;}};$scope.selectedFileChanged=function(){// if(
//     $scope.model.selectedFile && 
//     $scope.model.selectedFile.fileData && 
//     $scope.model.selectedFile.fileData.pickupDate < $scope.todayDate 
// ) {
//   $scope.model.error = $translate.instant('uploadedFileSelectionModal.pickupDateError');
// }
// else if($scope.model.selectedFile.fileData.deliveryDate < $scope.model.selectedFile.fileData.pickupDate ) {
//   $scope.model.error = $translate.instant('uploadedFileSelectionModal.dateError');
// }
// else {
// $scope.model.error = '';
$scope.model.pickupDate=$scope.model.selectedFile.fileData.pickupDate;$scope.model.deliveryDate=$scope.model.selectedFile.fileData.deliveryDate;// }
};$scope.ok=function(){$scope.loading=true;if(lastSelectedFile){RouteService.unlockFile(lastSelectedFile).then(function(res){});}RouteService.lockFile($scope.model.selectedFile.fileName).then(function(res){if(res.status){callback({$scope:$scope,modal:modal});}else{errorModal(res.message);}});};$scope.cancel=function(){negative({modal:modal});};init();}]});rejectModal(modal,negative);};var addLocation=function addLocation(model,callback,negative){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_addLocation2.default,size:'lg',windowClass:'add-location-modal',controller:['$scope','$translate',function($scope,$translate){$scope.model=model;$scope.ok=function(data){setTimeout(function(){callback({modal:modal,data:data});},1000);};$scope.cancel=function(err){negative({modal:modal,err:err});};}]});};var forceCloseHold=function forceCloseHold(holdShipments,callback,negative){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_forceCloseHold2.default,size:'lg',keyboard:false,controller:['$scope','HoldService','MessageService','$q','$translate','User','CommonLayoutService',function($scope,HoldService,MessageService,$q,$translate,User,CommonLayoutService){$scope.model={loading:false,error:false,holdShipments:holdShipments.slice(),loggedInUser:User.getUser(),forceCloseShipments:[]};function init(){$scope.model.loading=true;var searchObj={queryJSON:{rules:[{field:'type',condition:'=',data:'H'}],operator:'AND'}};$scope.maskingString=function(trackingId){return CommonLayoutService.maskingString(trackingId);};MessageService.all($scope.model.loggedInUser.languageId,searchObj,0,1000).then(function(data){var reasons=data.results;$scope.model.holdShipments.forEach(function(holdShipment){holdShipment.reasons=reasons;});}).catch(function(err){$scope.model.error=err.toString();}).finally(function(err){$scope.model.loading=false;});}$scope.cancel=function(){negative({modal:modal});};$scope.ok=function(){var forceCloseDefer=$q.defer();$scope.model.loading=true;$scope.model.holdShipments.map(function(data){// collect force close data
$scope.model.forceCloseShipments.push({trackingId:data.trackingId,selectedReason:data.selectedReason,status:data.status,branchId:data.branchId});});HoldService.forceClose($scope.model.forceCloseShipments).then(function(data){$scope.model.loading=false;forceCloseDefer.resolve(data);}).catch(function(err){if(err&&err.data&&err.data.message){return errorModal('error.'+err.data.message);}}).finally(function(){$scope.model.loading=false;});forceCloseDefer.promise.then(function(){callback({modal:modal,$scope:$scope});});};init();}]});};var verifyHoldShipments=function verifyHoldShipments(currentVaultDate,allowBulkHoldVerify,callback,negative){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_verifyHoldShipments2.default,size:'lg',keyboard:false,controller:['$scope','$rootScope','HoldService','ShipmentService','$q','SetupService','User','BagoutService',function($scope,$rootScope,HoldService,ShipmentService,$q,SetupService,User,BagoutService){$scope.model={loading:false,verifying:false,trackingId:'',verifiedCount:0,errorCode:null,holdShipmentsCount:0,currentDate:currentVaultDate,verifiedShipments:[],lastProcessed:null,localDateTime:null,bulkVerified:false,branchId:User.getUser().branchId,holdShipmentIndex:null,allowBulkHoldVerify:allowBulkHoldVerify};var holdShipments=[];$scope.prefixes=null;function init(){$scope.loading=true;loadTankerData();getHoldShipmentCount().then(function(_ref38){var results=_ref38.results,total=_ref38.total;holdShipments=results;$scope.model.holdShipmentsCount=total;focusElementById('tracking-id');$scope.loading=false;}).catch(function(err){$scope.loading=false;console.log(err);});}var getHoldShipmentCount=function getHoldShipmentCount(){// const search = {
//   queryJSON: {
//     rules: [
//       {
//         field: 'branchId',
//         condition: '=',
//         data: $scope.model.branchId
//       },
//       {
//         field: 'status',
//         condition: '=',
//         data: 'ON_HOLD'
//       },
//       {
//         group: {
//           rules: [
//             {
//               field: 'verifiedOn',
//               condition: '=',
//               data: null
//             },
//             {
//               field: 'verifiedOn',
//               condition: '!=',
//               data: $scope.model.currentDate
//             },
//           ],
//           operator: 'OR',
//         }
//       }
//     ],
//     operator: 'AND'
//   }
// }
var branch=$scope.model.branchId,status='ON_HOLD',verifiedDate=$scope.model.currentDate;return HoldService.verifyItemHoldData(branch,status,verifiedDate);};// Get tankerId associate with branch
var loadTankerData=function loadTankerData(){return SetupService.get($scope.model.branchId).then(function(tankerData){$scope.model.tankerId=tankerData.tankerId;$scope.prefixes=tankerData.prefixes.bagout?tankerData.prefixes.bagout[0].toLowerCase():null;});};// common function for bulkVerify and verifyShipment
var getShipments=function getShipments(trackingId){if($scope.model.holdShipmentIndex>-1){var trackingIdDefer=$q.defer();if(trackingId.startsWith($scope.prefixes)||trackingId.toLowerCase().startsWith($scope.prefixes)){var finaltrackingId=null;finaltrackingId=trackingId.slice(1);var bagOutsearchObj={queryJSON:{rules:[{field:'id',condition:'=',data:finaltrackingId}],operator:'AND'}};BagoutService.all(bagOutsearchObj,0,1000).then(function(bagOutData){if(bagOutData.results.length){trackingIdDefer.resolve(finaltrackingId);}else{trackingIdDefer.resolve(trackingId);}}).catch(function(err){trackingIdDefer.resolve(trackingId);});}else{trackingIdDefer.resolve(trackingId);}trackingIdDefer.promise.then(function(trackingId){$scope.model.verifying=true;ShipmentService.get(trackingId).then(function(shipment){var localDateTime=moment.utc().toDate();var lastProcessed=moment(localDateTime).format('l h:mm:ss A');shipment.lastProcessed=lastProcessed;$scope.model.verifiedShipments.push(shipment);$scope.model.verifiedCount++;$scope.model.holdShipmentsCount--;holdShipments.splice($scope.model.holdShipmentIndex,1);}).catch(function(err){$scope.model.errorCode=err&&err.data&&err.data.message;console.error(err);}).finally(function(){$scope.model.trackingId=null;$scope.model.verifying=false;focusElementById('tracking-id');});});}else{$scope.model.errorCode=91201;}};$scope.verifyShipment=function(){$scope.model.errorCode=null;if($scope.model.trackingId===null){return;}$scope.model.holdShipmentIndex=holdShipments.findIndex(function(holdShipment){var id=$scope.model.trackingId.slice(1);return holdShipment.trackingId.toLowerCase()===$scope.model.trackingId.toLowerCase()||holdShipment.trackingId.toLowerCase()===id.toLowerCase();});getShipments($scope.model.trackingId);};// Use for verify items as bulk
$scope.bulkVerify=function(){$scope.holdShipmentData=holdShipments;$scope.failedToVerify=[];$scope.model.loading=true;$scope.holdtrackingId=holdShipments.map(function(data){return data.trackingId;});HoldService.bulkVerify($scope.holdtrackingId).then(function(res){var localDateTime=moment.utc().toDate();;var lastProcessed=moment(localDateTime).format('l h:mm:ss A');$scope.model.loading=false;$scope.holdShipmentData.forEach(function(data){if(res.failed.data.includes(data.trackingId)){$scope.model.errorCode=$translate.instant('90619');$scope.failedToVerify.push(data);}else{$scope.model.bulkVerified=true;data.lastProcessed=lastProcessed;$scope.model.verifiedShipments.push(data);}});holdShipments.splice($scope.model.holdShipmentIndex,res.success);$scope.model.verifiedCount=$scope.model.verifiedCount+res.success;$scope.model.holdShipmentsCount=$scope.model.holdShipmentsCount-res.success;holdShipments=$scope.failedToVerify;}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.forceClose=function(){if($scope.allowOnlyOnce)return;$scope.allowOnlyOnce=true;forceCloseHold(holdShipments,function(_ref39){var forceCloseModal=_ref39.modal,modalScope=_ref39.$scope;forceCloseModal.close();holdShipments=[];$scope.model.holdShipmentsCount=0;},function(_ref40){var forceCloseModal=_ref40.modal;$scope.allowOnlyOnce=false;forceCloseModal.close();});};// Call bulkVerify comment modal
$scope.bulkVerifyComments=function(){bulkVerifyComment(holdShipments,function(_ref41){var bulkVerifyCommentModal=_ref41.modal,modalScope=_ref41.$scope;$scope.$on("bulkVerifyComment",function(event,args){$scope.itemVerifyComments=args;return callback({modal:modal,$scope:$scope,Verifycomments:$scope.itemVerifyComments?$scope.itemVerifyComments:null});});});};$scope.ok=function(){if($rootScope.allowOnlyOnce)return;$rootScope.allowOnlyOnce=true;return $scope.bulkVerifyComments();};$scope.cancel=function(err){confirm({header:$translate.instant('verifyHoldShipments.forceClose'),message:$translate.instant('verifyHoldShipments.forceCloseShipments'),callback:function callback(_ref42){var confirmModal=_ref42.modal;confirmModal.close();negative({modal:modal});},type:'danger'});};init();}]});};var bulkVerifyComment=function bulkVerifyComment(modal,callback,negative){var bulkVerifyCommentModal=$uibModal.open({keyboard:false,template:_bulkVerifyComment2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$rootScope','HoldService','$q',function($scope,$rootScope,HoldService,$q){$scope.model={};var init=function init(){};$scope.cancel=function(){$rootScope.allowOnlyOnce=false;bulkVerifyCommentModal.close();};$scope.ok=function(){callback({modal:bulkVerifyCommentModal});$rootScope.allowOnlyOnce=false;bulkVerifyCommentModal.close();$rootScope.$broadcast("bulkVerifyComment",$scope.model.comment);};init();}]});};// return data of holdverify
var itemHoldLogDetails=function itemHoldLogDetails(trackingId,shipment,modal,callback,negative){var itemHoldLogModal=$uibModal.open({template:_itemHoldLog2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','$rootScope','HoldVerifyService','$q',function($scope,$rootScope,HoldVerifyService,$q){$scope.model={holdVerifyData:null,itemholdVerifyDataCount:[],errorCode:null};var init=function init(){$scope.id=trackingId;};$scope.loading=true;HoldVerifyService.get((typeof shipment==='undefined'?'undefined':(0,_typeof3.default)(shipment))=='object'?shipment.id:shipment).then(function(data){if(data){$scope.model.holdVerifyData=data;}else{$scope.model.errorCode=$translate.instant('item_holds.errorMessage');}}).catch(function(err){console.error(err);}).finally(function(){$scope.loading=false;});// HoldVerifyService.all(null, 0, 1000)
//   .then((data) => {
//     if (data.total > 0) {
//       $scope.model.itemholdVerifyDataCount = data;
//     }
//     else {
//       $scope.model.errorCode = $translate.instant('item_holds.errorMessage');
//     }
//   }).catch((err) => {
//     console.error(err);
//   }).finally(() => {
//     $scope.loading = false;
//   });
$scope.cancel=function(){negative({modal:itemHoldLogModal});};init();}]});rejectModal(itemHoldLogModal,negative);};// update VehicalID, MessengerID, DriverId for RouteDetails
var routeDetails=function routeDetails(route,date,supervisorScan,callback,negative){var routeDetailsModal=$uibModal.open({template:_routeDetails2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','UsersService','User','RouteDetailService','TruckService','$q','DateUtil',function($scope,UsersService,User,RouteDetailService,TruckService,$q,DateUtil){$scope.model={routeId:'',lastReleasedDate:'',truck:null,messenger:null,driver:null,branchId:User.getUser().branchId,routeData:'',allowSupervisorScan:supervisorScan,leaveTime:'',arriveTime:'',begMiles:'',endMiles:'',currentTime:moment().format("HH:mm:ss"),curCheckoutTime:'',curLeaveTime:'',curArriveTime:'',curBegMiles:'',curEndMiles:'',leaveDate:'',arriveDate:'',curLeaveDate:'',curArriveDate:'',currentDate:moment(),restrictToTruck:false,restrictTruck:null};$scope.model.routeId=route.routeId;$scope.model.routeDate=date;var userSearchObj=function userSearchObj(searchKey,hideUser){var displayAppUserOnly=arguments.length>2&&arguments[2]!==undefined?arguments[2]:undefined;searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branchId},// {
//   field: "downloadToHHT",
//   condition: "=",
//   data: true
// },
{group:{rules:[{field:"id",condition:"like",data:"%"+searchKey+"%"},{field:"firstName",condition:"like",data:"%"+searchKey+"%"},{field:"lastName",condition:"like",data:"%"+searchKey+"%"}],operator:"OR"}}],operator:'AND'}};if(hideUser){searchObj.queryJSON.rules.push({field:"id",condition:"!=",data:hideUser});}if(searchKey){searchObj.orderBy={order:[['id','ASC']]};}if(displayAppUserOnly){searchObj.queryJSON.rules.push({field:"downloadToHHT",condition:"=",data:true});}return searchObj.queryJSON.rules.length?searchObj:null;};var routeSearchObj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branchId},{field:"routeId",condition:"=",data:$scope.model.routeId},{field:"routeDate",condition:"=",data:$scope.model.routeDate}],operator:'AND'}};var init=function init(){$scope.loading=true;$q.all([RouteDetailService.all(routeSearchObj,0,1000)]).then(function(data){$scope.routeDetailsData=data[0].results;$scope.routeDetailsData.forEach(function(routeData){$scope.model.routeData=routeData;$scope.model.restrictToTruck=routeData.route?routeData.route.restrictToTruck:false;$scope.model.restrictTruck=routeData.route?routeData.route.restrictTruck:null;var hasVehicle=routeData.vehicleId&&routeData.vehicle;var hasRestrictTruck=$scope.model.restrictToTruck&&$scope.model.restrictTruck&&$scope.model.restrictTruck.id;if(hasVehicle&&hasRestrictTruck&&routeData.vehicleId.trim()===$scope.model.restrictTruck.id.trim()){// Both are available and the same — just map Key/Value as normal
routeData.vehicle.Key=routeData.vehicleId.trim()+" | "+routeData.vehicle.make;routeData.vehicle.Value=routeData.vehicleId.trim();$scope.model.truckMismatch=false;}else if(hasRestrictTruck&&(!hasVehicle||routeData.vehicleId.trim()!==$scope.model.restrictTruck.id.trim())){// restrictToTruck is true but assigned truck differs (or is missing) — override and warn user to save
routeData.vehicle={Key:$scope.model.restrictTruck.id.trim()+" | "+$scope.model.restrictTruck.make,Value:$scope.model.restrictTruck.id.trim()};$scope.model.truckMismatch=true;}else if(hasVehicle){// Normal case — no restriction, just map vehicle
routeData.vehicle.Key=routeData.vehicleId.trim()+" | "+routeData.vehicle.make;routeData.vehicle.Value=routeData.vehicleId.trim();$scope.model.truckMismatch=false;}$scope.model.truck=routeData.vehicle;$scope.model.messenger=mapData(routeData.messenger);$scope.model.lastReleasedDate=routeData.updatedAt;$scope.getTruckData('',0);$scope.getMessangerData('',0);$scope.model.driver=mapData(routeData.driver);$scope.getDriverData('',0);$scope.getGuardData('',0);$scope.model.guard=mapData(routeData.guard);$scope.model.curCheckoutTime=routeData.checkoutTime?new Date(routeData.checkoutTime):null;$scope.model.curLeaveTime=routeData.leaveTime?new Date(routeData.leaveTime):null;$scope.model.curArriveTime=routeData.arrTime?new Date(routeData.arrTime):null;$scope.model.curBegMiles=routeData.begMiles,$scope.model.curEndMiles=routeData.endMiles;$scope.model.leaveTime=$scope.model.curLeaveTime?$scope.getTime(moment($scope.model.curLeaveTime).format('HH:mm:ss')):null;$scope.model.arriveTime=$scope.model.curArriveTime?$scope.getTime(moment($scope.model.curArriveTime).format('HH:mm:ss')):null;$scope.model.begMiles=$scope.model.curBegMiles,$scope.model.endMiles=$scope.model.curEndMiles,$scope.model.leaveDate=$scope.model.curLeaveTime?moment($scope.model.curLeaveTime):null;$scope.model.arriveDate=$scope.model.curArriveTime?moment($scope.model.curArriveTime):null;$scope.model.checkOutDate=routeData.checkoutTime?moment(routeData.checkoutTime).format('DD-MMM-YYYY'):null;$scope.model.checkOutTime=routeData.checkoutTime?moment(routeData.checkoutTime).format('hh:mm A'):null;$scope.maxDate={maxDate:$scope.model.currentDate,minDate:routeData.routeDate};$scope.model.requireDriver=routeData.requireDriver;$scope.model.requireGuard=routeData.requireGuard;});}).finally(function(){$scope.loading=false;}).catch(function(err){console.log(err);});};var mapData=function mapData(item){if(item==null)return item;item.Key=item.id+" | "+item.firstName+' '+item.lastName;item.Value=item.id;return item;};var mappingUserData=function mappingUserData(items,searchKey,model){var itemArray=[];items.map(function(item){item.Key=item.id+" | "+item.firstName+' '+item.lastName;item.Value=item.id;if(!searchKey){if(model){if(item.id!==model.Value){itemArray.push(item);}}else{itemArray.push(item);}}else{itemArray.push(item);}});return itemArray;};$scope.getMessangerData=function(searchKey,offset){var searchObj=userSearchObj(searchKey,null,true);if(offset!==0&&!searchKey&&Math.abs(offset%2)==1){offset=offset-1;}UsersService.all(searchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.messangerTotalRecord=data.total;$scope.messangerData=mappingUserData(data.results,searchKey,$scope.model.messenger);if(!searchKey&&$scope.model.messenger){$scope.messangerData.unshift($scope.model.messenger);}}else{var messanger=mappingUserData(data.results,searchKey,$scope.model.messenger);$scope.messangerData=$scope.messangerData.concat(messanger);}});};$scope.getDriverData=function(searchKey,offset){var searchObj=userSearchObj(searchKey,$scope.model.messenger?$scope.model.messenger.id:null,true);if(offset!==0&&!searchKey&&Math.abs(offset%2)==1){offset=offset-1;}UsersService.all(searchObj,offset,_app2.default.defaultPageLimit).then(function(data){$scope.userData=data.results;if(offset===0||offset==undefined){$scope.driverTotalRecord=data.total;$scope.driverData=mappingUserData(data.results,searchKey,$scope.model.driver);if(!searchKey&&$scope.model.driver){$scope.driverData.unshift($scope.model.driver);}}else{$scope.driverTotalRecord=data.total;var driver=mappingUserData(data.results,searchKey,$scope.model.driver);$scope.driverData=$scope.driverData.concat(driver);}});};$scope.getGuardData=function(searchKey,offset){var searchObj=userSearchObj(searchKey,$scope.model.messenger?$scope.model.messenger.id:null,true);if(offset!==0&&!searchKey&&Math.abs(offset%2)==1){offset=offset-1;}UsersService.all(searchObj,offset,_app2.default.defaultPageLimit).then(function(data){$scope.userData=data.results;if(offset===0||offset==undefined){$scope.guardTotalRecord=data.total;$scope.guardData=mappingUserData(data.results,searchKey,$scope.model.guard);if(!searchKey&&$scope.model.guard){$scope.guardData.unshift($scope.model.guard);}}else{$scope.guardTotalRecord=data.total;var guard=mappingUserData(data.results,searchKey,$scope.model.guard);$scope.guardData=$scope.guardData.concat(guard);}});};$scope.messengerSelected=function(){if($scope.model.messenger==null){$scope.model.driver=null;}else{if($scope.model.messenger&&$scope.model.driver){if($scope.model.messenger.id==$scope.model.driver.id){$scope.model.driver=null;}}$scope.getDriverData();}};$scope.getTruckData=function(searchKey,offset){searchKey=searchKey||'';if(offset!==0&&!searchKey&&Math.abs(offset%2)==1){offset=offset-1;}TruckService.getAllTrucks(searchKey,$scope.model.branchId,$scope.model.routeId,$scope.model.routeDate,_app2.default.defaultPageLimit,offset).then(function(data){if(offset===0||offset==undefined){$scope.totalRecord=data.total;$scope.truckData=mappingTruckData(data.results,searchKey);if(!searchKey&&$scope.model.truck){$scope.truckData.unshift($scope.model.truck);}}else{var truckData=mappingTruckData(data.results,searchKey);$scope.truckData=$scope.truckData.concat(truckData);}});};var mappingTruckData=function mappingTruckData(trucks,searchKey){var truckArray=[];trucks.map(function(truck){// if (truck.location.branchId === $scope.model.branchId) {
truck.Key=truck.id+" | "+truck.make;truck.Value=truck.id;if(!searchKey){if($scope.model.truck){if(truck.id!==$scope.model.truck.Value){truckArray.push(truck);}}else{truckArray.push(truck);}}else{truckArray.push(truck);}// }
});return truckArray;};$scope.getTime=function(time){if(!time){return time;}time=time.split(':');var d=new Date();d.setHours(+time[0]);d.setMinutes(time[1]);d.setSeconds(0);d.setMilliseconds(0);return d;};$scope.cancel=function(){negative({modal:routeDetailsModal});};$scope.getLeaveTime=function(){if(!$scope.model.leaveTime)return;var lvTime=$scope.model.leaveTime?moment($scope.model.leaveTime).format('HH:mm:ss'):null;var lvDate=$scope.model.leaveDate?moment($scope.model.leaveDate).format('YYYY-MM-DD'):null;var dt=lvDate+' '+lvTime;return dt;};$scope.getArriveTime=function(){if(!$scope.model.arriveTime)return;var arrTime=$scope.model.arriveTime?moment($scope.model.arriveTime).format('HH:mm:ss'):null;var arrDate=$scope.model.arriveDate?moment($scope.model.arriveDate).format('YYYY-MM-DD'):null;var arrDt=arrDate+' '+arrTime;return arrDt;};$scope.validateLeaveTime=function(){var leaveDateTime=$scope.getLeaveTime();var arriveDateTime=$scope.getArriveTime();var leaveMoment=moment(leaveDateTime,'YYYY-MM-DD HH:mm:ss').seconds(0).milliseconds(0);var checkoutMoment=moment($scope.model.curCheckoutTime).seconds(0).milliseconds(0);var leaveTime=leaveMoment.valueOf();var checkoutTime=checkoutMoment.valueOf();if(leaveTime<checkoutTime){delete $scope.arriveTimeError;$scope.leaveTimeError=$translate.instant('routeControl.leave_time_error');}else if($scope.model.arriveTime&&leaveTime>moment(arriveDateTime,'YYYY-MM-DD HH:mm:ss').valueOf()){delete $scope.arriveTimeError;$scope.leaveTimeError=$translate.instant('routeControl.leave_time_greater_than_arrive_time_error');}else{delete $scope.leaveTimeError;}if($scope.model.arriveDate)$scope.validateArriveDate();};$scope.validateArriveTime=function(){var leaveDateTime=$scope.getLeaveTime();var arriveDateTime=$scope.getArriveTime();var curArriveTime=moment(arriveDateTime).valueOf();var leaveTime=moment(leaveDateTime).valueOf();if($scope.model.arriveTime&&curArriveTime<leaveTime){delete $scope.leaveTimeError;$scope.arriveTimeError=$translate.instant('routeControl.arrive_time_error');}else delete $scope.arriveTimeError;};$scope.validateMileage=function(){// let begMiles = $scope.model.curBegMiles ? $scope.model.curBegMiles : $scope.model.begMiles;
// let endMiles = $scope.model.curEndMiles ? $scope.model.curEndMiles : $scope.model.endMiles;
var begMiles=$scope.model.begMiles;var endMiles=$scope.model.endMiles;if(endMiles!==undefined&&endMiles!==null&&endMiles<begMiles)$scope.mileageError=$translate.instant('routeControl.miles_error');else delete $scope.mileageError;};$scope.validateLeaveDate=function(){if(!$scope.model.leaveDate)return;var checkoutDate=moment($scope.model.curCheckoutTime).format('YYYY-MM-DD');var leaveDate=moment($scope.model.leaveDate).format('YYYY-MM-DD');if(leaveDate<checkoutDate)$scope.leaveDateError=$translate.instant('routeControl.leave_date_error');else delete $scope.leaveDateError;$scope.validateLeaveTime();};$scope.validateArriveDate=function(){if(!$scope.model.arriveDate)return;var curArriveDate=moment($scope.model.arriveDate).format('YYYY-MM-DD');var leaveDate=moment($scope.model.leaveDate).format('YYYY-MM-DD');if(!$scope.model.curLeaveTime&&!$scope.model.leaveTime)return;else if(curArriveDate<leaveDate)$scope.arriveDateError=$translate.instant('routeControl.arrive_date_error');else delete $scope.arriveDateError;$scope.validateArriveTime();};$scope.isError=function(){return $scope.leaveTimeError||$scope.arriveTimeError||$scope.mileageError||$scope.leaveDateError||$scope.arriveDateError;};$scope.validateRouteDetailForm=function(){return $scope.model.leaveDate&&!$scope.model.leaveTime||$scope.model.arriveDate&&!$scope.model.arriveTime||$scope.model.arriveDate&&!$scope.model.leaveDate||$scope.model.arriveTime&&!$scope.model.leaveTime||$scope.model.requireDriver&&!$scope.model.driver||$scope.model.requireGuard&&!$scope.model.guard||$scope.model.arriveDate&&$scope.model.arriveTime&&!$scope.model.endMiles||$scope.model.leaveDate&&$scope.model.leaveTime&&!$scope.model.truck;};$scope.ok=function(err){var leaveDate=$scope.model.leaveDate&&$scope.model.leaveTime?moment($scope.model.leaveDate).format('YYYY-MM-DD'):null;var leaveTime=$scope.model.leaveDate&&$scope.model.leaveTime?moment($scope.model.leaveTime).format('HH:mm:ss'):null;var arriveDate=$scope.model.arriveDate&&$scope.model.arriveTime?moment($scope.model.arriveDate).format('YYYY-MM-DD'):null;var arriveTime=$scope.model.arriveDate&&$scope.model.arriveTime?moment($scope.model.arriveTime).format('HH:mm:ss'):null;if(leaveDate&&leaveTime&&$scope.model.curCheckoutTime){var leaveMoment=moment(leaveDate+' '+leaveTime,'YYYY-MM-DD HH:mm:ss');var checkoutMoment=moment($scope.model.curCheckoutTime);if(leaveMoment.isValid()&&checkoutMoment.isValid()&&leaveMoment.format('YYYY-MM-DD HH:mm')===checkoutMoment.format('YYYY-MM-DD HH:mm')){leaveMoment.seconds(checkoutMoment.seconds());leaveTime=leaveMoment.format('HH:mm:ss');}}if(arriveDate&&arriveTime&&leaveDate&&leaveTime){var arriveMoment=moment(arriveDate+' '+arriveTime,'YYYY-MM-DD HH:mm:ss');var _leaveMoment=moment(leaveDate+' '+leaveTime,'YYYY-MM-DD HH:mm:ss');if(arriveMoment.isValid()&&_leaveMoment.isValid()&&arriveMoment.format('YYYY-MM-DD HH:mm')===_leaveMoment.format('YYYY-MM-DD HH:mm')&&arriveMoment.seconds()===0){arriveMoment.seconds(_leaveMoment.seconds());arriveTime=arriveMoment.format('HH:mm:ss');}}var leaveDateTime=leaveDate+' '+leaveTime;var arriveDateTime=arriveDate+' '+arriveTime;var UTCLeaveTime=$scope.model.leaveDate&&$scope.model.leaveTime?moment(leaveDateTime).utc().format('YYYY-MM-DD HH:mm:ss'):null;var UTCArriveTime=$scope.model.arriveDate&&$scope.model.arriveTime?moment(arriveDateTime).utc().format('YYYY-MM-DD HH:mm:ss'):null;$scope.isLoading=true;verifySupervisorScan('route-details',null,$scope).then(function(supervisorInfo){$scope.loading=true;callback({truck:$scope.model.truck?$scope.model.truck.Value:$scope.model.truck,messenger:$scope.model.messenger?$scope.model.messenger.Value:$scope.model.messenger,driver:$scope.model.driver?$scope.model.driver.Value:$scope.model.driver,guard:$scope.model.guard?$scope.model.guard.Value:$scope.model.guard,leaveTime:UTCLeaveTime,arriveTime:UTCArriveTime,begMiles:!$scope.model.curBegMiles?$scope.model.begMiles:null,endMiles:!$scope.model.curEndMiles?$scope.model.endMiles:null,modal:routeDetailsModal});$scope.isLoading=false;if(supervisorInfo)supervisorInfo.modal.close();});};init();}]});routeDetailsModal.result.then(function(){},function(){negative({modal:routeDetailsModal});});};var routeMessenger=function routeMessenger(route,date,callback,negative){var routeMessengerModal=$uibModal.open({template:_routeMessenger2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','UsersService','User','RouteDetailService','$q',function($scope,UsersService,User,RouteDetailService,$q){$scope.loading=false;$scope.model={routeId:route.routeId,routeDate:date,messenger:null,branchId:User.getUser().branchId};var userSearchObj=function userSearchObj(searchKey){var displayAppUserOnly=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branchId},{group:{rules:[{field:"id",condition:"like",data:"%"+searchKey+"%"},{field:"firstName",condition:"like",data:"%"+searchKey+"%"},{field:"lastName",condition:"like",data:"%"+searchKey+"%"}],operator:"OR"}}],operator:'AND'}};if(searchKey){searchObj.orderBy={order:[['id','ASC']]};}if(displayAppUserOnly){searchObj.queryJSON.rules.push({field:"downloadToHHT",condition:"=",data:true});}return searchObj;};var mapData=function mapData(item){if(item==null)return item;item.Key=item.id+" | "+item.firstName+' '+item.lastName;item.Value=item.id;return item;};var mappingUserData=function mappingUserData(items,searchKey,model){var itemArray=[];items.map(function(item){item.Key=item.id+" | "+item.firstName+' '+item.lastName;item.Value=item.id;if(!searchKey){if(model){if(item.id!==model.Value){itemArray.push(item);}}else{itemArray.push(item);}}else{itemArray.push(item);}});return itemArray;};var routeSearchObj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branchId},{field:"routeId",condition:"=",data:$scope.model.routeId},{field:"routeDate",condition:"=",data:$scope.model.routeDate}],operator:'AND'}};var init=function init(){$scope.loading=true;RouteDetailService.all(routeSearchObj,0,1000).then(function(data){if(data&&data.results&&data.results.length>0){var routeData=data.results[0];$scope.model.messenger=mapData(routeData.messenger);}$scope.getMessangerData('',0);}).finally(function(){$scope.loading=false;}).catch(function(err){console.log(err);});};$scope.getMessangerData=function(searchKey,offset){var searchObj=userSearchObj(searchKey,true);if(offset!==0&&!searchKey&&Math.abs(offset%2)==1){offset=offset-1;}UsersService.all(searchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.messangerTotalRecord=data.total;$scope.messangerData=mappingUserData(data.results,searchKey,$scope.model.messenger);if(!searchKey&&$scope.model.messenger){$scope.messangerData.unshift($scope.model.messenger);}}else{var messanger=mappingUserData(data.results,searchKey,$scope.model.messenger);$scope.messangerData=$scope.messangerData.concat(messanger);}});};$scope.messengerSelected=function(){};$scope.getMessengerAddress=function(){var m=$scope.model.messenger;if(m&&(m.address||m.city||m.state||m.zip)){return(m.address||'')+', '+(m.city||'')+', '+(m.state||'')+' '+(m.zip||'');}return null;};$scope.cancel=function(){negative({modal:routeMessengerModal});};$scope.ok=function(){callback({messengerId:$scope.model.messenger?$scope.model.messenger.Value:null,modal:routeMessengerModal});};init();}]});routeMessengerModal.result.then(function(){},function(){negative({modal:routeMessengerModal});});};// release location from Hold
var locationHoldRelease=function locationHoldRelease(heldLocation,allowSupervisorScan,callback,negative){var locationHoldReleaseModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_locationHoldRelease2.default,size:'lg',controller:['$scope','$translate','$location','MessageService','User','$q',function($scope,$translate,$location,MessageService,User,$q){$scope.loading=false;$scope.model={locationId:'',branchId:User.getUser().branchId,supervisorId:'',comment:'',selectedReason:'',allowSupervisorScan:allowSupervisorScan,userDetails:User.getUser()};$scope.model.locationId=heldLocation.locationId||'';var getErrorMessage=function getErrorMessage(err){if(err&&err.data&&err.data.message){return $translate.instant('error.'+err.data.message)||err.data.message;}else{return err.toString();}};var init=function init(){$scope.loading=true;var loggedInUser=User.getUser();if($scope.model.locationId){var searchObj=generateQueryForReason(['NP']);MessageService.all(loggedInUser.languageId,searchObj,0,1000).then(function(reasonObjList){$scope.model.selectedReason=heldLocation.reason;heldLocation.reasons=reasonObjList.results;$scope.results=reasonObjList.results.map(function(m){return m.description;});}).catch(function(err){console.error(err);$scope.model.error=getErrorMessage(err);}).finally(function(){$scope.loading=false;});}else{$scope.loading=false;}};$scope.cancel=function(){// locationHoldReleaseModal.close();
negative({modal:locationHoldReleaseModal});};$scope.validateSupervisorScan=function(){if($scope.model.allowSupervisorScan){var errorMsg=$translate.instant('users.supervisor_scan_error',{firstName:$scope.model.userDetails.firstName,lastName:$scope.model.userDetails.lastName});return confirm({header:$translate.instant('errorModal.title'),message:$translate.instant(errorMsg),callback:function callback(_ref43){var modal=_ref43.modal;$scope.ok();modal.close();},type:'danger',buttons:['common.ok']});}else{$scope.ok();}};$scope.ok=function(err){$scope.isLoading=true;// confirmSupervisor('location-hold-release', null, ({ modal, supId }) => {
verifySupervisorScan('location-hold-release',null,$scope).then(function(supervisorInfo){$scope.model.supervisorId=supervisorInfo?supervisorInfo.supId:null;$scope.model.loading=true;callback({supervisorId:supervisorInfo?supervisorInfo.supId:null,comment:$scope.model.comment,modal:locationHoldReleaseModal});// modal.close()
if(supervisorInfo)supervisorInfo.modal.close();$scope.isLoading=false;// }, ({ modal }) => {
//   $scope.isLoading = false;
//   modal.close()
// })
});};init();}]});rejectModal(locationHoldReleaseModal,negative);};var translateMessage=function translateMessage(messageId,messageType,callback,negative){var translateMessageModal=$uibModal.open({template:_translateMessage2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$rootScope','MessageService','LanguageService','User','$q','$translate',function($scope,$rootScope,MessageService,LanguageService,User,$q,$translate){$scope.model={message:null,messageId:messageId,messageType:messageType};$scope.toggleSwitchUI={size:'small',label:{on:$translate.instant('common.yes'),off:$translate.instant('common.no')},onColor:'success',offColor:'danger'};var loggedInUser=User.getUser();var init=function init(){$scope.model.loading=true;MessageService.getMessageByMessageId(loggedInUser.languageId,$scope.model.messageId,$scope.model.messageType).then(function(data){$scope.model.message=data.results;$scope.model.message.defaultSelection=!!$scope.model.message.defaultSelection;}).catch(function(err){if(err&&err.data&&err.data.message){translateMessageModal.close();errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.cancel=function(){translateMessageModal.close();};$scope.ok=function(){callback({updatedMessages:$scope.model.message,modal:translateMessageModal});translateMessageModal.close();};init();}]});rejectModal(translateMessageModal,negative);};// route transfer view
var routeTransfer=function routeTransfer(routeId,day,vaultDate,callback,negative){var routeTransferModal=$uibModal.open({template:_routeTransfer2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','RouteService','$q','$translate','BranchService','RouteDetailService','User','$state',function($scope,RouteService,$q,$translate,BranchService,RouteDetailService,User,$state){var _$scope$model;$scope.model=(_$scope$model={days:[{label:$translate.instant('location.sun'),value:'Sun'},{label:$translate.instant('location.mon'),value:'Mon'},{label:$translate.instant('location.tues'),value:'Tue'},{label:$translate.instant('location.wed'),value:'Wed'},{label:$translate.instant('location.thurs'),value:'Thu'},{label:$translate.instant('location.fri'),value:'Fri'},{label:$translate.instant('location.sat'),value:'Sat'},{label:$translate.instant('location.hol'),value:'Hol'}],routeDay:[{label:$translate.instant('location.sun'),value:'Sun'},{label:$translate.instant('location.mon'),value:'Mon'},{label:$translate.instant('location.tues'),value:'Tue'},{label:$translate.instant('location.wed'),value:'Wed'},{label:$translate.instant('location.thurs'),value:'Thu'},{label:$translate.instant('location.fri'),value:'Fri'},{label:$translate.instant('location.sat'),value:'Sat'},{label:$translate.instant('location.hol'),value:'Hol'}],selectedDay:'Mon',selectedDayForMapTwo:'Mon',routeSequenceLocations:[],routeSequenceLocationData:[],routeSequenceData:[],locationListForMap:[],locationListForSecondMap:[],routeSequenceLocData:[],routesList:[],actualLong:"",actualLat:"",locationInfo:"",map:"",rawId:"",branch:"",route:null,loadingRouteSequence:false,loadroutes:true,routePosition:0,routePositionForSecondMap:0},(0,_defineProperty3.default)(_$scope$model,'branch',""),(0,_defineProperty3.default)(_$scope$model,'routeChange',[]),(0,_defineProperty3.default)(_$scope$model,'dayOfWeek',['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']),_$scope$model);$scope.isLocDuplicate={isLocDuplicate:false,message:''};var init=function init(){$scope.model.selectedDay=day;$scope.model.selectedDayForMapTwo=day;$scope.selectedDayOne=true;$scope.selectedDayTwo=true;setTimeout(function(){// Default Map
$scope.mapOne=L.map('mapOne',{center:[39.68649209557518,-101.48273981764913],zoom:4});L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo($scope.mapOne);// Second Map
$scope.mapTwo=L.map('mapTwo',{center:[39.68649209557518,-101.48273981764913],zoom:4});L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo($scope.mapTwo);// Get route info for default map 
RouteService.get(routeId).then(function(data){$scope.model.rawId=data.id;$scope.model.branch=data.branchId;$scope.loadRouteSequence($scope.model.rawId,$scope.model.branch,$scope.model.selectedDay);loadRoutes();});},100);};// Load route list branch vise 
var loadRoutes=function loadRoutes(){var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.branch}],operator:'AND'}};return RouteService.all(searchObj,0,1000).then(function(routes){$scope.model.routesList=routes;}).catch(function(err){$scope.loading=false;});};// get last released date of route
var getRouteReleasedData=function getRouteReleasedData(routeId){var routeSearchObj={queryJSON:{rules:[{field:"routeId",condition:"=",data:routeId},{field:"routeDate",condition:"=",data:vaultDate}],operator:'AND'}};return RouteDetailService.all(routeSearchObj,0,1000).then(function(routeDetails){$scope.lastReleasedDay=routeDetails.results[0].routeDate;$scope.day=new Date($scope.lastReleasedDay);$scope.lastReleasedDayName=$scope.model.dayOfWeek[$scope.day.getDay()];}).catch(function(err){$scope.loading=false;});};// Get route sequence for route
var getRouteSequence=function getRouteSequence(routeId,branchId,selectedDay){$scope.loadingRouteSequence=true;RouteService.getRouteSequence(routeId,branchId,selectedDay).then(function(routeSequenceLocations){$scope.loadingRouteSequence=false;if($scope.model.loadroutes==true){$scope.model.routeSequenceLocationData=routeSequenceLocations;$scope.model.routeSequenceData=$scope.model.routeSequenceLocationData;$scope.routeSequenceDataCount=$scope.model.routeSequenceLocationData.length;$scope.isFlag=true;$scope.model.locationListForMap=[];setMarkers($scope.model.routeSequenceData,$scope.model.routePosition,$scope.actualLat,$scope.actualLong,$scope.locationInfo,$scope.mapOne,$scope.model.locationListForMap);}else{$scope.model.routeSequenceForMapTwo=routeSequenceLocations;$scope.model.routeSequenceLocData=$scope.model.routeSequenceForMapTwo;$scope.routeSequenceLocDataCount=$scope.model.routeSequenceLocData.length;$scope.isFlag=false;$scope.model.locationListForSecondMap=[];setMarkers($scope.model.routeSequenceLocData,$scope.model.routePositionForSecondMap,$scope.actualLatitude,$scope.actualLongitute,$scope.locationInfoForSecondMap,$scope.mapTwo,$scope.model.locationListForSecondMap);}}).catch(function(err){$scope.loadingRouteSequence=false;console.log(err);}).finally(function(){$scope.loadingRouteSequence=false;});};// load routes sequence for default map
$scope.loadRouteSequence=function(routeId,branchId,selectedDay){$scope.lastReleasedDayName=null;$scope.model.loadingRouteSequence=true;$scope.model.loadroutes=true;$scope.model.locationListForMap.forEach(function(id){$scope.mapOne.removeLayer(id);});getRouteSequence(routeId,branchId,selectedDay);getRouteReleasedData($scope.model.rawId);};// load routes sequence for selected route
$scope.routeChange=function(route,branchId,selectedDayForMapTwo){$scope.lastReleasedDayName=null;$scope.model.loadingRouteSequence=true;$scope.model.loadroutes=false;$scope.model.locationListForSecondMap.forEach(function(id){$scope.mapTwo.removeLayer(id);});getRouteSequence(route,branchId,selectedDayForMapTwo);getRouteReleasedData($scope.model.route);};// reRender map on route transfer
$scope.refreshMap1=function(){$scope.model.locationListForMap.forEach(function(ids,index){$scope.mapOne.removeLayer(ids);});$scope.model.locationListForMap=[];setMarkers($scope.model.routeSequenceData,$scope.model.routePosition,$scope.actualLat,$scope.actualLong,$scope.locationInfo,$scope.mapOne,$scope.model.locationListForMap);};// reRender map on route transfer
$scope.refreshMap2=function(){$scope.model.locationListForSecondMap.forEach(function(ids,index){$scope.mapTwo.removeLayer(ids);});$scope.model.locationListForSecondMap=[];setMarkers($scope.model.routeSequenceLocData,$scope.model.routePositionForSecondMap,$scope.actualLatitude,$scope.actualLongitute,$scope.locationInfoForSecondMap,$scope.mapTwo,$scope.model.locationListForSecondMap);};// Set markers for map
var setMarkers=function setMarkers(routeSequenceData,routePosition,actualLat,actualLong,locationInfo,mapFor,locationListForMap){routePosition=routePosition||0;setTimeout(function(){routeSequenceData.forEach(function(sequenceData){if(sequenceData&&sequenceData.lat&&sequenceData.long){routePosition+=1;actualLat=sequenceData.lat;actualLong=sequenceData.long;locationInfo='<strong>'+sequenceData.name+'</strong>'+'<br>'+sequenceData.address+' - '+sequenceData.zip+'<br>'+sequenceData.city+', '+sequenceData.state;var id=L.marker([actualLat,actualLong],{icon:new L.AwesomeNumberMarkers({number:routePosition,markerColor:"blue"})}).addTo(mapFor).bindPopup(locationInfo);id.on('mouseover',function(){id.openPopup();});id.on('mouseout',function(){id.closePopup();});locationListForMap.push(id);}});if($scope.routeSequenceDataCount!==$scope.model.routeSequenceData.length||$scope.routeSequenceLocDataCount!==$scope.model.routeSequenceLocData.length){$scope.routeSequenceDataCount=$scope.model.routeSequenceData.length;$scope.routeSequenceLocDataCount=$scope.model.routeSequenceLocData.length;if(!$scope.isFlag){$scope.isFlag=true;$scope.refreshMap1();$scope.refreshMap2();}}},100);};// Load route sequence based on day (mapOne)
$scope.selectDay=function(day){if(day.label===$scope.lastReleasedDayName)return;$scope.model.locationListForMap.forEach(function(id){$scope.mapOne.removeLayer(id);});$scope.model.locationListForMap=[];$scope.model.routeChange=[];$scope.model.selectedDay=day.value;$scope.selectedDayOne=true;$scope.loadRouteSequence($scope.model.rawId,$scope.model.branch,$scope.model.selectedDay);};// Load route sequence based on day (mapTwo)
$scope.selectDayForMapTwo=function(routeDay){if(routeDay.label===$scope.lastReleasedDayName)return;$scope.model.locationListForSecondMap.forEach(function(id){$scope.mapTwo.removeLayer(id);});$scope.model.locationListForSecondMap=[];$scope.model.selectedDayForMapTwo=routeDay.value;$scope.model.routeChange=[];$scope.selectedDayTwo=true;$scope.routeChange($scope.model.route,$scope.model.branch,$scope.model.selectedDayForMapTwo);};// change route sequences
$scope.routeSequenceLocationMoved=function(index,routeSeq,routePosition,actualLat,actualLong,locationInfo,map,locationListForMap,pick){$scope.isFlag=false;$scope.isLocDuplicate.isDuplicate=false;$scope.isLocDuplicate.message='';var data={id:routeSeq[index].id};data.branchId=routeSeq[index].branchId;if(pick==='one'){var valueArr=$scope.model.routeSequenceLocData.map(function(item){return item.id;});var isDuplicate=valueArr.some(function(item,idx){return valueArr.indexOf(item)!=idx;});if(isDuplicate){showDuplicateMsg(routeSeq[index].id);$scope.model.routeSequenceLocData=(0,_values2.default)($scope.model.routeSequenceLocData.reduce(function(acc,cur){return(0,_assign2.default)(acc,(0,_defineProperty3.default)({},cur.id,cur));},{}));return;}data.transferredFrom=$scope.model.rawId;data.transferredTo=$scope.model.route;data['defRoute'+$scope.model.selectedDay+'Id']=null;data['defRoute'+$scope.model.selectedDayForMapTwo+'Id']=$scope.model.route;if($scope.model.routeChange.length>0){var isCheck=$scope.model.routeChange.some(function(routeChange){return routeChange.id==routeSeq[index].id&&routeChange['defRoute'+$scope.model.selectedDay+'Id']==$scope.model.rawId;});if(!isCheck){$scope.model.routeChange.push(data);}}else{$scope.model.routeChange.push(data);}}else{var valueArr=$scope.model.routeSequenceData.map(function(item){return item.id;});var isDuplicate=valueArr.some(function(item,idx){return valueArr.indexOf(item)!=idx;});if(isDuplicate){showDuplicateMsg(routeSeq[index].id);$scope.model.routeSequenceData=(0,_values2.default)($scope.model.routeSequenceData.reduce(function(acc,cur){return(0,_assign2.default)(acc,(0,_defineProperty3.default)({},cur.id,cur));},{}));return;}data.transferredFrom=$scope.model.route;data.transferredTo=$scope.model.rawId;data['defRoute'+$scope.model.selectedDayForMapTwo+'Id']=null;data['defRoute'+$scope.model.selectedDay+'Id']=$scope.model.rawId;if($scope.model.routeChange.length>0){var isCheck=$scope.model.routeChange.some(function(routeChange){return routeChange.id==routeSeq[index].id&&routeChange['defRoute'+$scope.model.selectedDayForMapTwo+'Id']==$scope.model.route;});if(!isCheck){$scope.model.routeChange.push(data);}}else{$scope.model.routeChange.push(data);}}routeSeq.splice(index,1);setMarkers(routeSeq,routePosition,actualLat,actualLong,locationInfo,map,locationListForMap);};var showDuplicateMsg=function showDuplicateMsg(locationId){$scope.isLocDuplicate.isDuplicate=true;$scope.isLocDuplicate.message=locationId;setTimeout(function(){$scope.isLocDuplicate.isDuplicate=false;$scope.isLocDuplicate.message='';$scope.$digest();},2000);};$scope.ok=function(){var _callback;callback((_callback={modal:routeTransferModal,routeChangeData:$scope.model.routeChange,routeChangeSequence:$scope.model.routeSequenceLocData,routeDay:$scope.selectedDayOne==true?$scope.model.selectedDay:$scope.model.selectedDay},(0,_defineProperty3.default)(_callback,'routeDay',$scope.selectedDayTwo==true?$scope.model.selectedDayForMapTwo:$scope.model.selectedDayForMapTwo),(0,_defineProperty3.default)(_callback,'routeSequence',$scope.model.routeSequenceData),_callback));routeTransferModal.close();};$scope.cancel=function(){// routeTransferModal.close();
negative({modal:routeTransferModal});};init();}]});rejectModal(routeTransferModal,negative);};var changePassword=function changePassword(model,callback,negative){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_changePassword2.default,size:'md',controller:['$scope',function($scope){$scope.modelDetails=model;$scope.ok=function(userId,data){callback({modal:modal});};$scope.cancel=function(err){negative({modal:modal});};}]});};var timeoutCountdown=function timeoutCountdown(model,callback,negative){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_timeoutCountdown2.default,size:'md',controller:['$scope',function($scope){$scope.modelDetails=model;$scope.ok=function(userId,data){callback({modal:modal});};$scope.cancel=function(err){negative({modal:modal});};}]});var events=['click','touchstart','mousemove','keypress','keydown'];var closeModal=function closeModal(){events.forEach(function(event){window.removeEventListener(event,closeModal);});modal.close();};events.forEach(function(event){window.addEventListener(event,closeModal);});};var orderPack=function orderPack(orderShipment,branchId,branchFundingSourceId,account,orderData,deliveryToShipmentTypes,_callback2,negative,currencySymbol){var orderPackModal=$uibModal.open({template:_orderPack2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','$translate','BranchService','SetupService','BulkCashService','OrderPackingService','ShipmentService','User','$q','DateUtil','Sound','$state','CommonLayoutService',function($scope,$translate,BranchService,SetupService,BulkCashService,OrderPackingService,ShipmentService,User,$q,DateUtil,Sound,$state,CommonLayoutService){var _$scope$model2;$scope.loading=false;$scope.checkOnlyOnce=false;$scope.checkLength=0;$scope.routeLists=[];$scope.bagScanError="";$scope.toLocationId=orderShipment.toLocationId;$scope.duplicateTrackingIds=[];var orderTypeOpt=(CommonLayoutService.orderTypes()||[]).find(function(o){return o.value===orderShipment.orderType;});$scope.model=(_$scope$model2={routeId:null,vaultDate:orderShipment.vaultDate?DateUtil.convertToDate(orderShipment.vaultDate):null,total:orderShipment.amount,sourceType:orderShipment.sourceType,orderId:orderShipment.id,orderNo:orderData.orderNo,orderTypeLabel:orderTypeOpt?orderTypeOpt.key:orderShipment.orderType||'',deliveryTrackingIds:[],multiDenomPackableDenoms:[],singleDenomPackableDenoms:[],atmSingleDenomShipments:[],isPackableOrder:orderShipment.sourceType==='PackableOrder',packCoinSeparately:!!(orderShipment.toLocation&&orderShipment.toLocation.packCoinSeparately),hasCoinMultiDenom:false,hasCashMultiDenom:false,toLocation:orderShipment.toLocation.name,toAddress:orderShipment.toLocation.address+", "+orderShipment.toLocation.city+orderShipment.toLocation.state+", "+orderShipment.toLocation.zip,denomIcon:orderShipment.denominationId,denomAmount:orderShipment.amount,trackingIdDelivery:'',deliveryToShipmentTypes:deliveryToShipmentTypes,trackingIdResidual:'',shipmentData:orderShipment.toLocation,multipleDenoms:orderData.validDenominations,invalidDenominations:orderData.invalidDenominations,branch:User.getUser().branchId,supervisorId:User.getUser().id,valutDate:'',ledgerTransaction:[],shipmentsValutDate:DateUtil.getUTCDate(orderShipment.vaultDate),unassignedRouteId:'',shipment:orderShipment,scanLimit:'',lastScannedResidualId:'',lastScannedLoadId:'',isAutoGenerateResidualId:false,isAutoGenerateLoadId:false,residualSuffix:'R',loadSuffix:'L',branchVaultDate:'',routeList:[]},(0,_defineProperty3.default)(_$scope$model2,'routeId',orderShipment.routeId),(0,_defineProperty3.default)(_$scope$model2,'gettingRoutes',false),(0,_defineProperty3.default)(_$scope$model2,'acl',{}),(0,_defineProperty3.default)(_$scope$model2,'hasACL',{}),(0,_defineProperty3.default)(_$scope$model2,'permissionKey','order_packing'),(0,_defineProperty3.default)(_$scope$model2,'currencySymbol',currencySymbol||'$'),(0,_defineProperty3.default)(_$scope$model2,'isAtmSingleDenomOnly',false),(0,_defineProperty3.default)(_$scope$model2,'useAtmCassetteMode',false),(0,_defineProperty3.default)(_$scope$model2,'maxCassettes',null),(0,_defineProperty3.default)(_$scope$model2,'usedCassettes',0),(0,_defineProperty3.default)(_$scope$model2,'remainingCassettes',null),(0,_defineProperty3.default)(_$scope$model2,'noCassettesAvailable',false),(0,_defineProperty3.default)(_$scope$model2,'atmCassetteCapacityError',false),_$scope$model2);$scope.model.ledgerTransaction.push({currencyIcon:orderShipment.denomination.currencyId,denominations:[{icon:orderShipment.denomination.id,amount:orderShipment.coinFlag?-Math.abs(orderShipment.amount):-Math.abs(parseInt(orderShipment.amount)),faceValue:orderShipment.denomination.faceValue,orderPack:true,orderNo:orderShipment.orderNo}],ledger:account});var getAtmCassetteCount=function getAtmCassetteCount(){var loc=orderShipment&&orderShipment.toLocation?orderShipment.toLocation:null;var isAtmCassetteOn=loc&&(loc.scanATMCassette===true||loc.scanATMCassette===1);var maxCassettes=loc&&loc.maxCassettes!=null&&loc.maxCassettes!==''?parseInt(loc.maxCassettes,10):null;if(!isAtmCassetteOn||!maxCassettes||maxCassettes<1)return null;return Math.min(maxCassettes,6);};var getSplitFaceValue=function getSplitFaceValue(item){if(item&&item.faceValue!=null&&Number(item.faceValue)>0)return Number(item.faceValue);var denom=item&&item.shipment&&item.shipment.denomination?item.shipment.denomination:null;var faceValue=denom&&denom.faceValue!=null?Number(denom.faceValue):null;return faceValue&&faceValue>0?faceValue:null;};var parseCassetteAmount=function parseCassetteAmount(value){if(value===null||value===undefined||value==='')return null;var amount=Number(String(value).replace(/[$,\s]/g,''));return isFinite(amount)?amount:null;};var getAtmDenomId=function getAtmDenomId(item){if(!item||!item.shipment)return null;return item.shipment.denominationId||item.shipment.denomination&&item.shipment.denomination.id||null;};// ATM Cassette on toLocation forces single-denom packing (CARD 7038), ignoring BFSD multi-denom
var isAtmCassetteOn=!!(orderShipment.toLocation&&(orderShipment.toLocation.scanATMCassette===true||orderShipment.toLocation.scanATMCassette===1));var loadAtmCassetteUsageSnapshot=function loadAtmCassetteUsageSnapshot(){$scope.model.usedCassettes=0;$scope.model.remainingCassettes=null;$scope.model.noCassettesAvailable=false;if($scope.model.sourceType!=='ATMLoad'||!isAtmCassetteOn)return _promise2.default.resolve();var toLocationId=orderShipment.toLocationId||orderShipment.toLocation&&orderShipment.toLocation.id;if(!orderData.orderNo||!toLocationId)return _promise2.default.resolve();return OrderPackingService.getOrderCassetteUsage(orderData.orderNo,toLocationId).then(function(usage){$scope.model.usedCassettes=Number(usage&&usage.usedCassettes)||0;if(usage&&usage.maxCassettes!=null){$scope.model.maxCassettes=Math.max(Number(usage.maxCassettes),0);}if(usage&&usage.remainingCassettes!=null){$scope.model.remainingCassettes=Math.max(Number(usage.remainingCassettes),0);}}).catch(function(){return _promise2.default.resolve();});};var initializeAtmSingleDenomShipments=function initializeAtmSingleDenomShipments(){$scope.model.atmSingleDenomShipments=[];$scope.model.atmCassetteRows=[];$scope.model.useAtmCassetteMode=false;$scope.model.atmCassetteCapacityError=false;$scope.model.noCassettesAvailable=false;if($scope.model.sourceType!=='ATMLoad')return;var cassetteCount=getAtmCassetteCount();$scope.model.useAtmCassetteMode=!!cassetteCount;// Prefer fresh snapshot max when available; otherwise use location max.
if($scope.model.maxCassettes==null){$scope.model.maxCassettes=cassetteCount;}// Snapshot remaining (if present) only controls available rows for this pack.
var remainingCassettes=$scope.model.remainingCassettes!=null?Math.max(Number($scope.model.remainingCassettes),0):cassetteCount;$scope.model.remainingCassettes=remainingCassettes;$scope.model.noCassettesAvailable=!!cassetteCount&&remainingCassettes<=0;var shipmentList=$scope.model.shipment&&Array.isArray($scope.model.shipment.shipments)?$scope.model.shipment.shipments:$scope.model.shipment&&($scope.model.shipment.shipmentId||$scope.model.shipment.id)?[$scope.model.shipment]:[];shipmentList.forEach(function(s){var isMultiDenomPackable=s.multiDenomPackable===1||s.multiDenomPackable===true;// ATM Cassette ON = single-denom; + maxCassettes = cassette UI
if(!isAtmCassetteOn&&isMultiDenomPackable)return;var totalAmount=Number(s.amount||0);var maxLoad=s.maxLoad!=null&&s.maxLoad!==''?Number(s.maxLoad):null;var denom=s.denomination||{};var splits=[];// Shared pool (maxCassettes): rows built below; legacy mode auto-chunks per-denom splits here.
if(!cassetteCount){if(maxLoad!=null&&maxLoad>0&&totalAmount>maxLoad){var remaining=totalAmount;while(remaining>0){var chunk=Math.min(remaining,maxLoad);splits.push({amount:chunk,trackingId:'',trackingIdResidual:''});remaining-=chunk;}}else{splits.push({amount:totalAmount,trackingId:'',trackingIdResidual:''});}}$scope.model.atmSingleDenomShipments.push({shipment:s,amount:totalAmount,denomIcon:s.denominationId||denom.id,denomLabel:(denom.currencyId||'')+(denom.faceValue!=null?' $'+denom.faceValue:''),faceValue:denom.faceValue!=null?Number(denom.faceValue):null,maxLoad:maxLoad,useCassetteMode:!!cassetteCount,splits:splits});});if(cassetteCount){// Shared cassette pool: sum of ceil(amount/maxLoad) per denom must fit remaining cassettes.
var totalCassettesNeeded=$scope.model.atmSingleDenomShipments.reduce(function(sum,item){if(!item.maxLoad||item.maxLoad<=0)return sum+1;return sum+Math.ceil(item.amount/item.maxLoad);},0);$scope.model.atmCassetteCapacityError=totalCassettesNeeded>remainingCassettes;$scope.model.atmCassetteRows=(0,_from2.default)({length:remainingCassettes},function(){return{denominationId:null,amount:null,trackingId:'',trackingIdResidual:'',lastAutoResidual:''};});if($scope.model.atmSingleDenomShipments.length===1&&$scope.model.atmCassetteRows.length){var denomId=getAtmDenomId($scope.model.atmSingleDenomShipments[0]);if(denomId)$scope.model.atmCassetteRows[0].denominationId=denomId;}}};$scope.getAtmCassetteDenomLabel=function(item){if(!item)return'';if(item.denomLabel)return item.denomLabel;var denom=item.shipment&&item.shipment.denomination?item.shipment.denomination:null;if(!denom)return item.denomIcon||'';return(denom.currencyId||'')+(denom.faceValue!=null?' $'+denom.faceValue:'');};$scope.getAtmCassetteRowDenom=function(row){if(!row||!row.denominationId)return null;return($scope.model.atmSingleDenomShipments||[]).find(function(item){return getAtmDenomId(item)===row.denominationId;})||null;};$scope.selectAtmCassetteRowDenom=function(row,denomItem){if(!row||!denomItem)return;var denomId=getAtmDenomId(denomItem);if(row.denominationId!==denomId){row.denominationId=denomId;var isDecash=$scope.model.shipment&&($scope.model.shipment.orderType==='P'||$scope.model.shipment.orderType==='T');row.amount=isDecash?0:null;row.trackingId='';row.trackingIdResidual='';row.lastAutoResidual='';}row.denomPopoverOpen=false;$scope.checkDuplicateTrackingIds();};$scope.isAtmCassetteSplitActive=function(row){if(!$scope.model.useAtmCassetteMode||!row)return false;var denomItem=$scope.getAtmCassetteRowDenom(row);if(!denomItem)return false;var isDecash=$scope.model.shipment&&($scope.model.shipment.orderType==='P'||$scope.model.shipment.orderType==='T');// T/P: once denom is selected, unlock residual (amount stays $0 / greyed)
if(isDecash){if(row.amount==null||row.amount==='')row.amount=0;return true;}var amount=parseCassetteAmount(row.amount);if(amount==null||amount<=0)return false;var faceValue=getSplitFaceValue(denomItem)||denomItem.faceValue;if(faceValue&&Math.round(amount*100)%Math.round(faceValue*100)!==0)return false;if(denomItem.maxLoad!=null&&denomItem.maxLoad>0&&amount>denomItem.maxLoad)return false;return true;};$scope.onAtmCassetteAmountChange=function(row){if(!row)return;if(!$scope.isAtmCassetteSplitActive(row)){row.trackingId='';row.trackingIdResidual='';row.lastAutoResidual='';}$scope.checkDuplicateTrackingIds();};// T/P: residual drives load ID (same pattern as autoGenerateLoadId)
$scope.onAtmCassetteResidualChange=function(row){if(!row||!$scope.model.isAutoGenerateLoadId)return;var residual=row.trackingIdResidual?String(row.trackingIdResidual).trim():'';row.trackingId=residual?residual.concat($scope.model.loadSuffix):'';};$scope.atmCassetteDenomErrors=function(){if(!$scope.model.useAtmCassetteMode||!Array.isArray($scope.model.atmCassetteRows))return[];var labels=new _set2.default();$scope.model.atmCassetteRows.forEach(function(row){var denomItem=$scope.getAtmCassetteRowDenom(row);if(!denomItem)return;var amount=parseCassetteAmount(row.amount);if(amount!=null&&amount>0&&denomItem.maxLoad!=null&&denomItem.maxLoad>0&&amount>denomItem.maxLoad){labels.add($scope.getAtmCassetteDenomLabel(denomItem));}});return(0,_from2.default)(labels);};$scope.isAtmCassettePackReady=function(){if(!$scope.model.useAtmCassetteMode)return true;if($scope.model.noCassettesAvailable||$scope.model.atmCassetteCapacityError)return false;if(!$scope.model.atmSingleDenomShipments||!$scope.model.atmSingleDenomShipments.length)return false;if($scope.atmCassetteDenomErrors().length)return false;var rows=$scope.model.atmCassetteRows||[];// Any cassette with an amount entered must be fully valid (denom, amount rules, both tracking IDs)
for(var i=0;i<rows.length;i++){var row=rows[i];var hasAmountEntry=row.amount!==null&&row.amount!==undefined&&row.amount!=='';if(!hasAmountEntry)continue;if(!$scope.isAtmCassetteSplitActive(row))return false;var loadId=row.trackingId?String(row.trackingId).trim():'';var residualId=row.trackingIdResidual?String(row.trackingIdResidual).trim():'';if(!loadId||!residualId)return false;}return $scope.model.atmSingleDenomShipments.every(function(item){var denomId=getAtmDenomId(item);var activeRows=rows.filter(function(row){return row.denominationId===denomId&&$scope.isAtmCassetteSplitActive(row);});if(!activeRows.length)return false;var enteredTotal=activeRows.reduce(function(sum,row){return sum+parseCassetteAmount(row.amount);},0);return Math.round(enteredTotal*100)===Math.round(Number(item.amount||0)*100);});};$scope.onAtmSingleDenomSplitLoadChange=function(split){if(!split)return;var loadTrackingId=split.trackingId?String(split.trackingId).trim():'';var currentResidual=split.trackingIdResidual?String(split.trackingIdResidual).trim():'';var autoResidual=loadTrackingId?loadTrackingId.concat($scope.model.residualSuffix):'';if(!loadTrackingId){split.trackingIdResidual='';return;}if(!currentResidual||currentResidual===autoResidual||currentResidual===split.lastAutoResidual){split.trackingIdResidual=autoResidual;}split.lastAutoResidual=autoResidual;};var initializeDenominations=function initializeDenominations(){if($scope.model.multipleDenoms&&$scope.model.shipment&&Array.isArray($scope.model.shipment.shipments)){var forceSingleDenom=$scope.model.sourceType==='ATMLoad'&&isAtmCassetteOn;$scope.model.multiDenomPackableDenoms=forceSingleDenom?[]:$scope.model.multipleDenoms.filter(function(d){var matchingShipment=$scope.model.shipment.shipments.find(function(shipment){return shipment.denominationId===d.id;});return matchingShipment&&matchingShipment.multiDenomPackable===1;}).map(function(d){var matchingShipment=$scope.model.shipment.shipments.find(function(shipment){return shipment.denominationId===d.id;});return(0,_extends3.default)({},d,{multiDenomPackable:matchingShipment.multiDenomPackable});});$scope.model.multipleDenoms=$scope.model.multipleDenoms.map(function(d){var matchingShipment=$scope.model.shipment.shipments.find(function(shipment){return shipment.denominationId===d.id;});return(0,_extends3.default)({},d,{multiDenomPackable:forceSingleDenom?0:Number(matchingShipment.multiDenomPackable),willDebitOnPack:matchingShipment.willDebitOnPack||false});});$scope.model.singleDenomPackableDenoms=$scope.model.multipleDenoms.filter(function(d){var matchingShipment=$scope.model.shipment.shipments.find(function(shipment){return shipment.denominationId===d.id;});return matchingShipment&&(forceSingleDenom||matchingShipment.multiDenomPackable===0);}).map(function(d){var matchingShipment=$scope.model.shipment.shipments.find(function(shipment){return shipment.denominationId===d.id;});return(0,_extends3.default)({},d,{multiDenomPackable:forceSingleDenom?0:matchingShipment.multiDenomPackable,willDebitOnPack:matchingShipment.willDebitOnPack||false});});$scope.model.hasCoinMultiDenom=$scope.model.multiDenomPackableDenoms.some(function(d){return d.coinFlag===true||d.coinFlag===1;});$scope.model.hasCashMultiDenom=$scope.model.multiDenomPackableDenoms.some(function(d){return d.coinFlag!==true&&d.coinFlag!==1;});}};var updateAtmSingleDenomOnlyFlag=function updateAtmSingleDenomOnlyFlag(){// Cassette mode uses per-cassette load/residual IDs for all ATM denoms (single + multi).
if($scope.model.useAtmCassetteMode&&$scope.model.atmSingleDenomShipments&&$scope.model.atmSingleDenomShipments.length>0){$scope.model.isAtmSingleDenomOnly=true;return;}$scope.model.isAtmSingleDenomOnly=$scope.model.sourceType==='ATMLoad'&&Array.isArray($scope.model.atmSingleDenomShipments)&&$scope.model.atmSingleDenomShipments.length>0&&Array.isArray($scope.model.multiDenomPackableDenoms)&&$scope.model.multiDenomPackableDenoms.length===0;};var init=function init(){loadAtmCassetteUsageSnapshot().then(function(){initializeAtmSingleDenomShipments();initializeDenominations();updateAtmSingleDenomOnlyFlag();return SetupService.get(branchId);}).then(function(setup){$scope.model.branchVaultDate=moment.utc(setup.currentVaultDate).format('YYYY-MM-DD');$scope.model.packSlip=setup.packSlip;$scope.model.unassignedRouteId=setup.unassignedRouteId;$scope.model.scanLimit=setup.packCharLength;$scope.model.isAutoGenerateResidualId=orderShipment.orderType==='I'||orderShipment.toLocation.packResidual===0&&orderShipment.orderType!=='T'&&orderShipment.orderType!=='P';$scope.model.isAutoGenerateLoadId=$scope.model.shipment.orderType=='P'||$scope.model.shipment.orderType=='T';$scope.model.printPackLabel=setup.printPackLabel;if(!$scope.model.vaultDate){$scope.model.vaultDate=DateUtil.convertToDate(setup.currentVaultDate);}$scope.minVaultDate={minDate:DateUtil.convertToDate(setup.currentVaultDate)};}).then(function(){$scope.loadPermission();if($scope.model.hasACL[$scope.model.permissionKey]['editRoute']){$scope.getOrderPackRoutes();}$scope.setFocus();}).catch(function(err){if(err&&err.data&&err.data.message){errorModal('error.'+err.data.message);}});};$scope.getAllPackableOrderTrackingIds=function(){var pack=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var trackingIds=[];if($scope.model.multiDenomTrackingId){trackingIds.push($scope.model.multiDenomTrackingId);}if($scope.model.packCoinSeparately&&$scope.model.hasCashMultiDenom&&$scope.model.hasCoinMultiDenom&&$scope.model.multiDenomCoinTrackingId){trackingIds.push($scope.model.multiDenomCoinTrackingId);}$scope.model.singleDenomPackableDenoms.forEach(function(denom){if(!denom.multiDenomPackable&&denom.trackingId){trackingIds.push(denom.trackingId);}});if(!pack){$scope.model.deliveryToShipmentTypes.forEach(function(type){if(type.trackingId){trackingIds.push(type.trackingId);}});}return trackingIds;};$scope.getOrderPackRoutes=function(){$scope.model.gettingRoutes=true;OrderPackingService.getOrderPackRoutes(branchId,moment($scope.model.vaultDate).format('YYYY-MM-DD')).then(function(data){$scope.model.routeList=data.results;$scope.model.routeId=orderShipment.routeId;}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.gettingRoutes=false;});};$scope.loadPermission=function(){$scope.model.acl[$scope.model.permissionKey]=User.getACL($scope.model.permissionKey);$scope.model.hasACL[$scope.model.permissionKey]={};$scope.model.acl[$scope.model.permissionKey].forEach(function(permission){$scope.model.hasACL[$scope.model.permissionKey][permission]=true;});};$scope.onVaultDateChange=function(){$scope.model.routeId=null;$scope.model.routeList=[];var key=$scope.model&&$scope.model.permissionKey;var hasACLMap=$scope.model&&$scope.model.hasACL&&key&&$scope.model.hasACL[key];var aclArray=$scope.model&&$scope.model.acl&&key&&$scope.model.acl[key];var canEditRoute=!!(hasACLMap&&$scope.model.hasACL[key]['editRoute']||Array.isArray(aclArray)&&aclArray.indexOf('editRoute')!==-1);if(canEditRoute){$scope.getOrderPackRoutes();}};$scope.scanLimit=function(trackingId,$event){var ENTER_KEY_CODE=13;if($scope.model.sourceType==='PackableOrder'){$scope.model.lastScannedLoadId=trackingId;}else{$scope.model.lastScannedResidualId=$scope.model.trackingIdResidual;$scope.model.lastScannedLoadId=$scope.model.trackingIdDelivery;}$scope.bagScanLimitExceed=false;if($event.keyCode===ENTER_KEY_CODE&&trackingId&&$scope.model.scanLimit>0){if(trackingId.length>$scope.model.scanLimit&&(!$scope.checkOnlyOnce||trackingId.length!==$scope.checkLength)){$scope.checkOnlyOnce=true;$scope.bagScanLimitExceed=true;$scope.checkLength=trackingId.length;if($scope.model.sourceType==='PackableOrder'){if($scope.model.multiDenomTrackingId===trackingId){$scope.model.multiDenomTrackingId=null;}else{$scope.model.multipleDenoms.forEach(function(denom){if(denom.trackingId===trackingId){denom.trackingId=null;}});}}else{if($scope.model.lastScannedLoadId===trackingId&&$scope.model.isAutoGenerateResidualId){$scope.resetData();}else if($scope.model.lastScannedResidualId===trackingId&&$scope.model.isAutoGenerateLoadId){$scope.resetData();}else if($scope.model.lastScannedLoadId===trackingId){$scope.model.trackingIdDelivery=null;}else{$scope.model.trackingIdResidual=null;}}return $scope.bagScanError=$translate.instant('common.scan_error');}else{delete $scope.bagScanError;$scope.checkLength=trackingId.length>$scope.model.scanLimit?trackingId.length:$scope.model.scanLimit;}}};$scope.focusToDeliveryId=function($event){var ENTER_KEY_CODE=13;if($event.keyCode===ENTER_KEY_CODE&&$scope.model.trackingIdDelivery&&$scope.model.trackingIdResidual&&$scope.model.trackingIdDelivery!=$scope.model.trackingIdResidual&&$scope.model.shipment.routeId===$scope.model.unassignedRouteId&&!$scope.bagScanError){return $scope.packAndHold();}else if($event.keyCode===ENTER_KEY_CODE&&$scope.model.trackingIdDelivery&&!$scope.bagScanError&&$scope.model.isAutoGenerateResidualId){focusElementById('pack-btn');}else if($event.keyCode===ENTER_KEY_CODE&&$scope.model.trackingIdDelivery&&!$scope.bagScanError){focusElementById('trackingIdResidual');}};$scope.focuseToPackBtn=function($event){var ENTER_KEY_CODE=13;if($event.keyCode===ENTER_KEY_CODE&&$scope.model.trackingIdResidual&&!$scope.bagScanError){focusElementById('pack-btn');}};$scope.focuseToPackAndHoldBtn=function($event){var ENTER_KEY_CODE=13;if($event.keyCode===ENTER_KEY_CODE&&$scope.model.trackingIdResidual&&$scope.model.trackingIdDelivery!=$scope.model.trackingIdResidual&&$scope.model.shipment.routeId===$scope.model.unassignedRouteId&&!$scope.bagScanError){// focusElementById('packAndHoldBtn');
return $scope.packAndHold();}};// $scope.playErrorBeep = () => {
//   document.querySelector("#scanner_beep").play()
// }
// $scope.playSuccessBeep = () => {
//   document.querySelector("#success_beep").play()
// }
var mappingRouteDatas=function mappingRouteDatas(routes){return routes.map(function(route){return{Key:route.routeId+" | "+route.routeName,Value:route.routeId};});};var getRouteData=function getRouteData(valutDate){BranchService.getReleaseRoutes(branchId,valutDate).then(function(res){$scope.routeLists=mappingRouteDatas(res);$scope.totalRouteRecords=res.length;}).catch(function(err){if(!err.data.success){errorModal('error.'+err.data.message);}});};$scope.cancel=function(){// orderPackModal.close();
negative({modal:orderPackModal});};$scope.orderPack=function(){// Single entry point to call the API once per Pack click.
var runOnePack=function runOnePack(shipmentId,trackingIdDelivery,amount,denominationId,deliveryToShipTypes,singleDenomShipments){// ATM cassette / single-denom paths carry load+residual on shipment arrays; parent IDs stay null.
var residualTrackingId=$scope.model.sourceType==='ATMLoad'&&$scope.model.isAtmSingleDenomOnly?null:$scope.model.trackingIdResidual;var loadTrackingId=$scope.model.sourceType==='ATMLoad'&&$scope.model.isAtmSingleDenomOnly?null:$scope.model.trackingIdDelivery;return OrderPackingService.orderPackingPack(branchFundingSourceId,shipmentId,loadTrackingId,residualTrackingId,$scope.model.routeId,orderShipment.toLocationId,amount,denominationId,account,branchId,orderShipment.orderNo,$scope.model.supervisorId,moment($scope.model.vaultDate).format("YYYY-MM-DD"),orderShipment.deliveryDate,deliveryToShipTypes||[],singleDenomShipments);};var handlePackErr=function handlePackErr(err){$scope.isPack=false;if(err&&err.data&&err.data.message){Sound.PlayErrorBeep("#scanner_beep");confirm({header:$translate.instant('common.error'),message:$translate.instant('error.'+err.data.message),callback:function callback(_ref44){var modal=_ref44.modal;modal.close();_callback2({modal:orderPackModal,data:[],status:true});},negative:function negative(_ref45){var modal=_ref45.modal;modal.close();_callback2({modal:orderPackModal,data:[],status:true});},type:'danger',buttons:['common.ok']});orderPackModal.close();}};if($scope.model.atmSingleDenomShipments&&$scope.model.atmSingleDenomShipments.length>0){var items=$scope.model.atmSingleDenomShipments;var singleDenomShipments=[];if($scope.model.useAtmCassetteMode){// Shared cassette pool: group the flat row list by the denomination picked on each row,
// then build the same per-denom singleDenomShipments shape the backend already expects.
items.forEach(function(item){var denomId=item.shipment.denominationId||item.shipment.denomination&&item.shipment.denomination.id;if(!denomId)return;var activeRows=($scope.model.atmCassetteRows||[]).filter(function(row){return row.denominationId===denomId&&$scope.isAtmCassetteSplitActive(row);});if(!activeRows.length)return;var trackingIds=activeRows.map(function(row){return row.trackingId;});var amounts=activeRows.map(function(row){return parseCassetteAmount(row.amount);});var perSplitResiduals=activeRows.filter(function(row){return row&&row.trackingId&&row.trackingIdResidual;}).map(function(row){return{trackingId:row.trackingId,trackingIdResidual:row.trackingIdResidual};});var maxLoad=item.shipment.maxLoad!=null&&item.shipment.maxLoad!==''?Number(item.shipment.maxLoad):null;singleDenomShipments.push({denominationId:denomId,maxLoad:maxLoad,amounts:amounts,trackingIds:trackingIds,trackingIdResidual:null,perSplitResiduals:perSplitResiduals});});singleDenomShipments=singleDenomShipments.filter(function(s){return s.denominationId&&s.trackingIds&&s.trackingIds.length>0;});}else{singleDenomShipments=items.map(function(item){var denomId=item.shipment.denominationId||item.shipment.denomination&&item.shipment.denomination.id;var trackingIds=(item.splits||[]).map(function(s){return s.trackingId;}).filter(function(id){return id;});var perSplitResiduals=(item.splits||[]).filter(function(s){return s&&s.trackingId&&s.trackingIdResidual;}).map(function(s){return{trackingId:s.trackingId,trackingIdResidual:s.trackingIdResidual};});var maxLoad=item.shipment.maxLoad!=null&&item.shipment.maxLoad!==''?Number(item.shipment.maxLoad):null;return{denominationId:denomId,maxLoad:maxLoad,trackingIds:trackingIds,trackingIdResidual:null,perSplitResiduals:perSplitResiduals};}).filter(function(s){return s.denominationId&&s.trackingIds&&s.trackingIds.length>0;});}var shipmentIdsCsv=items.map(function(item){return item.shipment.shipmentId||item.shipment.id;}).join(',');return runOnePack(shipmentIdsCsv,$scope.model.trackingIdDelivery,$scope.model.total,null,$scope.model.deliveryToShipmentTypes,singleDenomShipments.length?singleDenomShipments:null).then(function(detail){_callback2({modal:orderPackModal,data:detail||{},status:true});return detail;}).catch(function(err){handlePackErr(err);return $q.reject(err);});}var selectedIds=orderData.shipments.map(function(s){return s.shipmentId;}).join(',');return new _promise2.default(function(resolve,reject){// Non-ATM / non-single-denom path: keep payload as before (no single-denom trackingIds array)
runOnePack(selectedIds,$scope.model.trackingIdDelivery,orderShipment.amount,orderShipment.denominationId,$scope.model.deliveryToShipmentTypes,null).then(function(detail){_callback2({modal:orderPackModal,data:detail,status:true});resolve(detail);}).catch(function(err){handlePackErr(err);reject(err);});});};// pack an order
$scope.pack=function(){$scope.isPack=true;var q=$q.defer();$scope.verifyTrackingId().then(function(result){if($scope.model.sourceType==="PackableOrder"){var trackingIds=$scope.getAllPackableOrderTrackingIds(true);return OrderPackingService.packableOrderPack(branchFundingSourceId,orderShipment.orderNo,$scope.model.supervisorId,$scope.model.routeId,orderShipment.defRouteSequence,trackingIds.join(","),$scope.model.deliveryToShipmentTypes,moment($scope.model.vaultDate).format("YYYY-MM-DD")).then(function(data){if(data&&data.finishedAt){$scope.model.shipmentPackedDate=data.finishedAt;}_callback2({modal:orderPackModal,data:data,status:true});q.resolve(data);});}else{return $scope.orderPack().then(function(data){if(data&&data.finishedAt){$scope.model.shipmentPackedDate=data.finishedAt;}q.resolve(data);});}}).catch(function(err){$scope.errorMessage='';if(err&&err.errorCode&&err.responseData){var allTrackingIds=err.responseData.trackingId||[];var userEnteredIds=err.userEnteredIds||[];var conflictingIds=allTrackingIds.filter(function(id){return userEnteredIds.includes(id);});if(conflictingIds.length>0){var idsList=conflictingIds.join(', ');var message=conflictingIds.length===1?'The following ID '+idsList+' is already in use':'The following IDs '+idsList+' are already in use';errorModal(message);}else{errorModal('error.'+err.errorCode);}}else if(!err.data){errorModal('error.'+err);}else if(err&&err.data&&err.data.errors){err.data.errors.map(function(e){$scope.errorMessage+=e.message+'<br/>';});errorModal($scope.errorMessage);}else if(err&&err.data&&err.data.message){if(err.data.message==='95507'&&err.data.trackingId){errorModal('error.95507',{trackingId:err.data.trackingId});}else{errorModal('error.'+err.data.message);}}else{errorModal(err);}$scope.isPack=false;Sound.PlayErrorBeep("#scanner_beep");});return q.promise;};$scope.verifyTrackingId=function(){return new _promise2.default(function(resolve,reject){if($scope.model.sourceType==='PackableOrder'){var trackingIds=[];if($scope.model.multiDenomTrackingId){trackingIds.push($scope.model.multiDenomTrackingId);}if($scope.model.packCoinSeparately&&$scope.model.hasCashMultiDenom&&$scope.model.hasCoinMultiDenom&&$scope.model.multiDenomCoinTrackingId){trackingIds.push($scope.model.multiDenomCoinTrackingId);}$scope.model.singleDenomPackableDenoms.forEach(function(denom){if(denom.trackingId){trackingIds.push(denom.trackingId);}});$scope.model.deliveryToShipmentTypes.forEach(function(type){if(type.trackingId){trackingIds.push(type.trackingId);}});trackingIds=trackingIds.filter(function(id){return id;});if(trackingIds.length===0){resolve();return;}OrderPackingService.verifyTrackingIds(trackingIds).then(function(res){if(res.data&&res.data.trackingId&&res.data.trackingId.length>0){reject({errorCode:93504,responseData:res.data,userEnteredIds:trackingIds});}else if(res.data&&res.data.shipmentInfo&&res.data.shipmentInfo.length>0){var hasPickupFlag=res.data.shipmentInfo.some(function(info){return info.pickupFlag;});if(hasPickupFlag){reject(93503);}}else{resolve(res);}}).catch(function(error){console.error('Error verifying tracking IDs:',error);reject(error);});}else{var _userEnteredTrackingI;var deliveryToIds=($scope.model.deliveryToShipmentTypes||[]).map(function(shipment){return shipment.trackingId;});var userEnteredTrackingIds=[];var residualIds=[];if($scope.model.useAtmCassetteMode&&$scope.model.atmCassetteRows&&$scope.model.atmCassetteRows.length){$scope.model.atmCassetteRows.forEach(function(row){if(row.trackingId)userEnteredTrackingIds.push(String(row.trackingId).trim());if(row.trackingIdResidual){userEnteredTrackingIds.push(String(row.trackingIdResidual).trim());residualIds.push(String(row.trackingIdResidual).trim());}});}else if($scope.model.atmSingleDenomShipments&&$scope.model.atmSingleDenomShipments.length>0){$scope.model.atmSingleDenomShipments.forEach(function(item){(item.splits||[]).forEach(function(split){if(split.trackingId)userEnteredTrackingIds.push(String(split.trackingId).trim());});(item.splits||[]).forEach(function(split){if(split.trackingIdResidual){userEnteredTrackingIds.push(String(split.trackingIdResidual).trim());residualIds.push(String(split.trackingIdResidual).trim());}});});}if($scope.model.trackingIdDelivery)userEnteredTrackingIds.push(String($scope.model.trackingIdDelivery).trim());if(!($scope.model.sourceType==='ATMLoad'&&$scope.model.isAtmSingleDenomOnly)&&$scope.model.trackingIdResidual){userEnteredTrackingIds.push(String($scope.model.trackingIdResidual).trim());residualIds.push(String($scope.model.trackingIdResidual).trim());}(_userEnteredTrackingI=userEnteredTrackingIds).push.apply(_userEnteredTrackingI,(0,_toConsumableArray3.default)(deliveryToIds.filter(function(id){return id;})));userEnteredTrackingIds=userEnteredTrackingIds.filter(function(id){return id;});var hasAtmPerSplitIds=$scope.model.useAtmCassetteMode&&$scope.model.atmCassetteRows&&$scope.model.atmCassetteRows.length||$scope.model.atmSingleDenomShipments&&$scope.model.atmSingleDenomShipments.length>0;var loadTrackingIds=hasAtmPerSplitIds?userEnteredTrackingIds.filter(function(id){return id&&residualIds.indexOf(id)===-1&&deliveryToIds.indexOf(id)===-1;}):$scope.model.trackingIdDelivery?[String($scope.model.trackingIdDelivery).trim()]:[];var checkShipmentId=$scope.model.shipment&&$scope.model.shipment.shipments&&$scope.model.shipment.shipments[0]?$scope.model.shipment.shipments[0].shipmentId:orderShipment.shipmentId;ShipmentService.chechTrackingIds(userEnteredTrackingIds,checkShipmentId).then(function(res){if(res.data&&res.data.id.indexOf(orderShipment.shipmentId)==-1){reject(93502);}else if(res.data&&res.data.shipmentInfo&&res.data.shipmentInfo.length&&_.find(res.data.shipmentInfo,{id:orderShipment.shipmentId}).pickupFlag){reject(93503);}else if(res.data&&res.data.trackingId&&loadTrackingIds.some(function(id){return res.data.trackingId.indexOf(id.toString())>=0;})){reject({errorCode:93504,responseData:res.data,userEnteredIds:userEnteredTrackingIds});}else if(res.data&&residualIds.length&&residualIds.some(function(id){return res.data.trackingId.indexOf(id.toString())>=0;})){reject({errorCode:93505,responseData:res.data,userEnteredIds:userEnteredTrackingIds});}else if(res.data&&deliveryToIds&&deliveryToIds.some(function(id){return res.data.trackingId.indexOf(id.toString())>=0;})){reject({errorCode:93511,responseData:res.data,userEnteredIds:userEnteredTrackingIds});}else{resolve(res);}}).catch(function(error){console.error('Error checking tracking IDs:',error);reject(error);});}});};$scope.checkDuplicateTrackingIds=function(){var allTrackingIds=[];$scope.duplicateTrackingIds=[];if($scope.model.sourceType==='PackableOrder'){allTrackingIds=$scope.getAllPackableOrderTrackingIds();}else{if($scope.model.trackingIdDelivery)allTrackingIds.push(String($scope.model.trackingIdDelivery).trim());if($scope.model.useAtmCassetteMode&&$scope.model.atmCassetteRows&&$scope.model.atmCassetteRows.length){$scope.model.atmCassetteRows.forEach(function(row){if(row.trackingId)allTrackingIds.push(String(row.trackingId).trim());if(row.trackingIdResidual)allTrackingIds.push(String(row.trackingIdResidual).trim());});}else if($scope.model.atmSingleDenomShipments&&$scope.model.atmSingleDenomShipments.length>0){$scope.model.atmSingleDenomShipments.forEach(function(item){(item.splits||[]).forEach(function(split){if(split.trackingId)allTrackingIds.push(String(split.trackingId).trim());});(item.splits||[]).forEach(function(split){if(split.trackingIdResidual)allTrackingIds.push(String(split.trackingIdResidual).trim());});});}// Global residual ID is only used when we are not in ATM single‑denom‑only mode
if(!($scope.model.sourceType==='ATMLoad'&&$scope.model.isAtmSingleDenomOnly)&&$scope.model.trackingIdResidual){allTrackingIds.push(String($scope.model.trackingIdResidual).trim());}($scope.model.deliveryToShipmentTypes||[]).forEach(function(t){if(t.trackingId)allTrackingIds.push(String(t.trackingId).trim());});}allTrackingIds=allTrackingIds.filter(function(id){return id;});$scope.duplicateTrackingIds=allTrackingIds.filter(function(id,index,arr){return arr.indexOf(id)!==index&&id;});};// put shipment on hold after successfully packed
$scope.putOnHold=function(supId){var holdShipmentDetails=new _promise2.default(function(resolve,reject){if($scope.model.sourceType==='PackableOrder'){// Get all tracking IDs for packable order
var trackingIds=$scope.getAllPackableOrderTrackingIds(true);// Use the new endpoint for multiple shipments
ShipmentService.holdMultipleShipments($scope.model.branch,trackingIds,$scope.model.routeId,$scope.model.shipmentsValutDate,supId,'Put On Hold','Hold').then(function(holdShipments){_callback2({modal:orderPackModal,data:holdShipments});resolve(holdShipments);}).catch(function(err){if(err&&err.data&&err.data.message){Sound.PlayErrorBeep("#scanner_beep");errorModal('error.'+err.data.message);$scope.isPack=false;}});}else{var trackingId=$scope.model.trackingIdDelivery;var holdTrackingIds=[];if($scope.model.sourceType==='ATMLoad'&&$scope.model.useAtmCassetteMode&&$scope.model.atmCassetteRows&&$scope.model.atmCassetteRows.length){holdTrackingIds=$scope.model.atmCassetteRows.filter(function(row){return row.trackingId&&String(row.trackingId).trim();}).map(function(row){return String(row.trackingId).trim();});if(holdTrackingIds.length)trackingId=holdTrackingIds[0];}else if($scope.model.sourceType==='ATMLoad'&&$scope.model.atmSingleDenomShipments&&$scope.model.atmSingleDenomShipments.length&&$scope.model.atmSingleDenomShipments[0].splits&&$scope.model.atmSingleDenomShipments[0].splits.length){trackingId=$scope.model.atmSingleDenomShipments[0].splits[0].trackingId;if(trackingId)holdTrackingIds=[String(trackingId).trim()];}var holdCall=$scope.model.useAtmCassetteMode&&holdTrackingIds.length>1?ShipmentService.holdMultipleShipments($scope.model.branch,holdTrackingIds,$scope.model.routeId,$scope.model.shipmentsValutDate,supId,'Put On Hold','Hold'):ShipmentService.holdShipment($scope.model.branch,trackingId,$scope.model.routeId,$scope.model.shipmentsValutDate,supId,'Put On Hold','Hold');holdCall.then(function(holdShipment){_callback2({modal:orderPackModal,data:holdShipment});resolve(holdShipment);}).catch(function(err){if(err&&err.data&&err.data.message){Sound.PlayErrorBeep("#scanner_beep");errorModal('error.'+err.data.message);$scope.isPack=false;// reject(err)
}});}});return holdShipmentDetails;};$scope.packAndHold=function(){$scope.isPack=true;confirmSupervisor('pack-and-Hold',{trackingId:orderShipment.trackingId},function(_ref46){var modal=_ref46.modal,supId=_ref46.supId;$scope.pack(modal).then(function(){focusElementById('pack-btn');$scope.putOnHold(supId);modal.close();}).catch(function(err){$scope.isPack=false;$scope.loading=false;}).finally(function(){$scope.loading=false;});modal.close();},function(_ref47){var modal=_ref47.modal;$scope.isPack=false;modal.close();});};$scope.autoGenerateResidualId=function(loadTrackingId){if($scope.model.isAutoGenerateResidualId){if(loadTrackingId)$scope.model.trackingIdResidual=loadTrackingId.concat($scope.model.residualSuffix);else $scope.model.trackingIdResidual=null;}};$scope.autoGenerateLoadId=function(residualTrackingId){if($scope.model.isAutoGenerateLoadId){if(residualTrackingId)$scope.model.trackingIdDelivery=residualTrackingId.concat($scope.model.loadSuffix);else $scope.model.trackingIdDelivery=null;}};$scope.setFocus=function(){if($scope.model.isAutoGenerateLoadId)focusElementById('trackingIdResidual');else focusElementById('trackingIdDelivery');};$scope.resetData=function(){$scope.model.trackingIdDelivery=null;$scope.model.trackingIdResidual=null;};$scope.packAndPrint=function(){$scope.model.packedShipmentDetails=[];return $scope.pack().then(function(){if($scope.model.sourceType==='PackableOrder'){// Handle multi-denom packable bag if exists
if($scope.model.multiDenomTrackingId){$scope.model.packedShipmentDetails.push({trackingId:$scope.model.multiDenomTrackingId,isLoadTrackingId:true,locationInfo:{id:$scope.model.shipment.toLocationId||null,name:$scope.model.shipment.toLocation?$scope.model.shipment.toLocation.name:null,address:$scope.model.shipment.toLocation?$scope.model.shipment.toLocation.address:null,city:$scope.model.shipment.toLocation?$scope.model.shipment.toLocation.city:null,state:$scope.model.shipment.toLocation?$scope.model.shipment.toLocation.state:null,zip:$scope.model.shipment.toLocation?$scope.model.shipment.toLocation.zip:null},orderType:$scope.model.shipment.orderType,routeId:$scope.model.routeId,deliveryDate:$scope.model.shipment.deliveryDate,amount:$scope.model.multiDenomPackableDenoms.reduce(function(sum,denom){return sum+denom.amount;},0),denominationId:null,// Multi-denom doesn't have a single denomination
vaultDate:moment.utc($scope.model.shipment.vaultDate).format('MM-DD-YY'),defRouteSequence:$scope.model.shipment.defRouteSequence,shiptypeId:$scope.model.shipment.shiptypeId});}// Handle single denomination packable bags
$scope.model.singleDenomPackableDenoms.forEach(function(denom){if(denom.trackingId){$scope.model.packedShipmentDetails.push({trackingId:denom.trackingId,isLoadTrackingId:true,locationInfo:{id:$scope.model.shipment.toLocationId||null,name:$scope.model.shipment.toLocation?$scope.model.shipment.toLocation.name:null,address:$scope.model.shipment.toLocation?$scope.model.shipment.toLocation.address:null,city:$scope.model.shipment.toLocation?$scope.model.shipment.toLocation.city:null,state:$scope.model.shipment.toLocation?$scope.model.shipment.toLocation.state:null,zip:$scope.model.shipment.toLocation?$scope.model.shipment.toLocation.zip:null},orderType:$scope.model.shipment.orderType,routeId:$scope.model.routeId,deliveryDate:$scope.model.shipment.deliveryDate,amount:denom.amount,denominationId:denom.denominationId,vaultDate:moment.utc($scope.model.shipment.vaultDate).format('MM-DD-YY'),defRouteSequence:$scope.model.shipment.defRouteSequence,shiptypeId:$scope.model.shipment.shiptypeId});}});}else{// Existing logic for Shipment orders
$scope.model.packedShipmentDetails.push({trackingId:$scope.model.trackingIdDelivery,isLoadTrackingId:true,locationInfo:{id:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocationId:null,name:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocation.name:null,address:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocation.address:null,city:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocation.city:null,state:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocation.state:null,zip:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocation.zip:null},orderType:$scope.model.shipment.orderType,routeId:$scope.model.shipment.routeId,deliveryDate:$scope.model.shipment.deliveryDate,amount:$scope.model.shipment.amount,denominationId:$scope.model.shipment.denominationId,vaultDate:moment.utc($scope.model.shipment.vaultDate).format('MM-DD-YY'),defRouteSequence:$scope.model.shipment.defRouteSequence,shiptypeId:$scope.model.shipment.shiptypeId},{trackingId:$scope.model.trackingIdResidual,isLoadTrackingId:false,locationInfo:{id:$scope.model.shipment.fromLocationId?$scope.model.shipment.fromLocationId:null,name:$scope.model.shipment.fromLocationId?$scope.model.shipment.fromLocation.name:null,address:$scope.model.shipment.fromLocationId?$scope.model.shipment.fromLocation.address:null,city:$scope.model.shipment.fromLocationId?$scope.model.shipment.fromLocation.city:null,state:$scope.model.shipment.fromLocationId?$scope.model.shipment.fromLocation.state:null,zip:$scope.model.shipment.fromLocationId?$scope.model.shipment.fromLocation.zip:null},orderType:$scope.model.shipment.orderType,routeId:$scope.model.shipment.routeId,pickupDate:$scope.model.shipment.pickupDate,amount:0,denominationId:$scope.model.shipment.denominationId,vaultDate:moment.utc($scope.model.shipment.vaultDate).format('MM-DD-YY'),defRouteSequence:$scope.model.shipment.defRouteSequence,shiptypeId:$scope.model.shipment.shiptypeId});}$scope.model.deliveryToShipmentTypes.forEach(function(shipmentType){if(shipmentType.trackingId){$scope.model.packedShipmentDetails.push({trackingId:shipmentType.trackingId,isLoadTrackingId:false,locationInfo:{id:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocationId:null,name:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocation.name:null,address:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocation.address:null,city:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocation.city:null,state:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocation.state:null,zip:$scope.model.shipment.toLocationId?$scope.model.shipment.toLocation.zip:null},orderType:null,routeId:$scope.model.shipment.routeId,pickupDate:null,amount:0,shiptypeId:shipmentType.shiptypeId,denominationId:null,vaultDate:moment.utc($scope.model.shipment.vaultDate).format('MM-DD-YY'),defRouteSequence:$scope.model.shipment.defRouteSequence});}});if($scope.model.packSlip){$scope.printPackSlip();}else{$scope.printBarcodes();}});};$scope.printBarcodes=function(){var obj={shipmentDetails:$scope.model.packedShipmentDetails,isPrePackPrint:false};var path=$state.href('printBarcodes');window.w=window.open(path,'_blank');window.w.printData=obj;};$scope.printPackSlip=function(){var routeId=$scope.model.routeId||'NA';var vaultDate=$scope.model.vaultDate;var shipmentPackedDate=$scope.model.shipmentPackedDate;var locationId=$scope.model.shipment.toLocationId;var obj={shipmentData:$scope.model.shipment.shipments?$scope.model.shipment.shipments:[],shipmentDetails:$scope.model.packedShipmentDetails,routeId:routeId,vaultDate:vaultDate,locationId:locationId,shipmentPackedDate:shipmentPackedDate,orderNo:$scope.model.shipment.orderNo};var path=$state.href('printPackSlip');window.w=window.open(path,'_blank');window.w.printData=obj;};$scope.hasDuplicateTrackingIds=function(){if($scope.model.sourceType==='PackableOrder'){var _trackingIds=[];// Add multiDenom tracking ID if exists
if($scope.model.multiDenomTrackingId){_trackingIds.push($scope.model.multiDenomTrackingId);}// Add all single denom tracking IDs
$scope.model.singleDenomPackableDenoms.forEach(function(denom){if(denom.trackingId){_trackingIds.push(denom.trackingId);}});$scope.model.deliveryToShipmentTypes.forEach(function(shipType){if(shipType.trackingId){_trackingIds.push(shipType.trackingId);}});// Filter out empty/null values and check for duplicates
_trackingIds=_trackingIds.filter(function(id){return id;});return _trackingIds.length!==new _set2.default(_trackingIds).size;}var trackingIds=[];if($scope.model.trackingIdDelivery)trackingIds.push(String($scope.model.trackingIdDelivery).trim());if($scope.model.useAtmCassetteMode&&$scope.model.atmCassetteRows&&$scope.model.atmCassetteRows.length){$scope.model.atmCassetteRows.forEach(function(row){if(row.trackingId)trackingIds.push(String(row.trackingId).trim());if(row.trackingIdResidual)trackingIds.push(String(row.trackingIdResidual).trim());});}else if($scope.model.atmSingleDenomShipments&&$scope.model.atmSingleDenomShipments.length>0){$scope.model.atmSingleDenomShipments.forEach(function(item){(item.splits||[]).forEach(function(split){if(split.trackingId)trackingIds.push(String(split.trackingId).trim());if(split.trackingIdResidual)trackingIds.push(String(split.trackingIdResidual).trim());});});}if(!($scope.model.sourceType==='ATMLoad'&&$scope.model.isAtmSingleDenomOnly)&&$scope.model.trackingIdResidual){trackingIds.push(String($scope.model.trackingIdResidual).trim());}($scope.model.deliveryToShipmentTypes||[]).forEach(function(shipType){if(shipType.trackingId)trackingIds.push(String(shipType.trackingId).trim());});trackingIds=trackingIds.filter(function(id){return id;});return trackingIds.length!==new _set2.default(trackingIds).size;};init();}]});rejectModal(orderPackModal,negative);};var holdReason=function holdReason(trackingId,allowSupervisorScan,callback,negative){var holdReasonModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_holdReason2.default,size:'md',controller:['$scope','$translate','$location','MessageService','User','$q',function($scope,$translate,$location,MessageService,User,$q){$scope.loading=false;$scope.model={reasonToClose:'',trackingId:trackingId,allowSupervisorScan:allowSupervisorScan,userDetails:User.getUser()};var init=function init(){// $scope.loading = true;
// $scope.loading = false;
};$scope.cancel=function(){holdReasonModal.close();};$scope.validateSupervisorScan=function(){if($scope.model.allowSupervisorScan){var errorMsg=$translate.instant('users.supervisor_scan_error',{firstName:$scope.model.userDetails.firstName,lastName:$scope.model.userDetails.lastName});return confirm({header:$translate.instant('errorModal.title'),message:$translate.instant(errorMsg),callback:function callback(_ref48){var modal=_ref48.modal;$scope.ok();modal.close();},type:'danger',buttons:['common.ok']});}else{$scope.ok();}};$scope.ok=function(err){// confirmSupervisor('force-to-hold', { trackingId: $scope.model.trackingId }, ({ modal, supId }) => {
verifySupervisorScan('force-to-hold',{trackingId:$scope.model.trackingId},$scope).then(function(supervisorInfo){$scope.model.supervisorId=supervisorInfo?supervisorInfo.supId:null;$scope.model.loading=true;callback({// supervisorId: supId,
supervisorId:supervisorInfo?supervisorInfo.supId:null,reason:$scope.model.reasonToClose,modal:holdReasonModal});// modal.close()
if(supervisorInfo)supervisorInfo.modal.close();// }, ({ modal }) => {
//   modal.close()
// })
});};init();}]});};var convertToCrv=function convertToCrv(shipment,allowSupervisorScan,showError,callback,negative){var convertToCrvModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_convertToCrv2.default,size:'md',controller:['$scope','$translate','$location','MessageService','User','$q','HoldService',function($scope,$translate,$location,MessageService,User,$q,HoldService){$scope.loading=false;$scope.model={shipmentData:shipment,trackingIdResidual:'',allowSupervisorScan:allowSupervisorScan,userDetails:User.getUser(),showError:showError};var init=function init(){focusElementById('residual-trackingId');};$scope.cancel=function(){// convertToCrvModal.close();
negative({modal:convertToCrvModal});};$scope.validateSupervisorScan=function(){if($scope.model.allowSupervisorScan&&$scope.model.showError){var errorMsg=$translate.instant('users.supervisor_scan_error',{firstName:$scope.model.userDetails.firstName,lastName:$scope.model.userDetails.lastName});return confirm({header:$translate.instant('errorModal.title'),message:$translate.instant(errorMsg),callback:function callback(_ref49){var modal=_ref49.modal;$scope.ok();modal.close();},type:'danger',buttons:['common.ok']});}else{$scope.ok();}};$scope.ok=function(err){$scope.isLoading=true;// confirmSupervisor('shipment-hold-convert-CRV', { trackingId: $scope.model.trackingIdResidual }, ({ modal, supId }) => {
verifySupervisorScan('shipment-hold-convert-CRV',{trackingId:$scope.model.trackingIdResidual},$scope).then(function(supervisorInfo){HoldService.verifyAtmResidual($scope.model.trackingIdResidual).then(function(response){if(response.status){callback({supervisor:supervisorInfo?supervisorInfo.supId:null,trackingIdResidual:$scope.model.trackingIdResidual,modal:convertToCrvModal});// modal.close();
if(supervisorInfo)supervisorInfo.modal.close();}else{errorModal(response.message);callback({supervisor:supervisorInfo?supervisorInfo.supId:null,trackingIdResidual:'',modal:convertToCrvModal});// modal.close();
if(supervisorInfo)supervisorInfo.modal.close();}}).catch(function(err){$scope.isLoading=false;console.log(err);});// }, ({ modal }) => {
//   $scope.isLoading = false;
//   modal.close()
// })
});};init();}]});rejectModal(convertToCrvModal,negative);};var deletedReason=function deletedReason(shipment,callback,negative){var deletedReasonModal=$uibModal.open({template:_deletedReason2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$rootScope','$q','MessageService','User',function($scope,$rootScope,$q,MessageService,User){$scope.model={reason:"",loading:false,trackingId:shipment.orderNo,loggedInUser:User.getUser(),messageType:'DS',reasons:[],selectedReasonCode:null};$scope.combineReasonAndComment=function(selectedReasonCode,comment){if(selectedReasonCode&&comment)return selectedReasonCode+' | '+comment;else if(selectedReasonCode)return selectedReasonCode;else if(comment)return comment;else return'';};var init=function init(){MessageService.shipmentDeleteReason($scope.model.messageType,$scope.model.loggedInUser.languageId).then(function(data){var id=document.getElementById('comment');if(id)focusElementById('comment');$scope.model.reasons=data.results;}).catch(function(err){console.log(err);});};$scope.ok=function(){$scope.isLoading=true;confirmSupervisor('verify-delete-shipment',{trackingId:$scope.model.trackingId},function(_ref50){var modal=_ref50.modal,supId=_ref50.supId;$scope.model.supervisorId=supId;$scope.model.loading=true;callback({supervisorId:supId,reason:$scope.combineReasonAndComment($scope.model.selectedReasonCode,$scope.model.reason),modal:deletedReasonModal});modal.close();},function(_ref51){var modal=_ref51.modal;$scope.isLoading=false;modal.close();});};$scope.cancel=function(){// deletedReasonModal.close();
negative({modal:deletedReasonModal});};init();}]});rejectModal(deletedReasonModal,negative);};// Order Packing Hold
var orderPackHold=function orderPackHold(orderShipment,modal,callback){var orderPackHoldModal=$uibModal.open({template:_orderPackHold2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q',function($scope,$q){$scope.model={trackingId:''};var init=function init(){$scope.model.trackingId=orderShipment.trackingId;};$scope.ok=function(){};$scope.cancel=function(){orderPackHoldModal.close();};init();}]});rejectModal(deletedReasonModal,negative);};var atmResidualReceipt=function atmResidualReceipt(shipments,modal,callback){var atmResidualReceiptModal=$uibModal.open({template:_atmResidualReceipt2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'model-body-top',backdrop:'static',size:'md',controller:['$scope','$q',function($scope,$q){// $scope.loading = false;
$scope.model={shipmentData:shipments,trackingId:shipments.trackingId};$scope.zoomLevel=350;$scope.maxZoom=600;$scope.minZoom=200;$scope.zoomIn=function(){if($scope.zoomLevel<$scope.maxZoom){$scope.zoomLevel+=50;}};$scope.zoomOut=function(){if($scope.zoomLevel>$scope.minZoom){$scope.zoomLevel-=50;}};var init=function init(){var TYPED_ARRAY=new Uint8Array(shipments);var STRING_CHAR=TYPED_ARRAY.reduce(function(data,byte){return data+String.fromCharCode(byte);},'');$scope.base64String=window.btoa(STRING_CHAR);};$scope.ok=function(){callback({modal:atmResidualReceiptModal});atmResidualReceiptModal.close();};$scope.cancel=function(){atmResidualReceiptModal.close();};init();}]});};// Add items model for checkout screen
var checkoutAddItems=function checkoutAddItems(modal,callback){var checkoutAddItemsModal=$uibModal.open({template:_checkoutAddItems2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q',function($scope,$q){$scope.model={trackingId:'',description:'',comment:''};var init=function init(){};$scope.ok=function(){};$scope.cancel=function(){checkoutAddItemsModal.close();};$scope.clearScan=function(){$scope.model.trackingId='';};init();}]});};//  If there is a variance then present an optional comment window for user to provide reason
var residualComments=function residualComments(shipments,callback,negative){var residualCommentModal=$uibModal.open({template:_residualComment2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q',function($scope,$q){$scope.model={comment:'',trackingId:shipments.trackingId};var init=function init(){focusElementById('variance-comment');};$scope.ok=function(){$scope.model.loading=true;callback({modal:residualCommentModal,comments:$scope.model.comment});residualCommentModal.close();};$scope.cancel=function(){// residualCommentModal.close();
negative({modal:residualCommentModal});};init();}]});rejectModal(residualCommentModal,negative);};// Order Packing Return
var orderPackReturn=function orderPackReturn(orderShipment,modal,callback){var orderPackReturnModal=$uibModal.open({template:_orderPackReturn2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q',function($scope,$q){$scope.model={trackingId:''};var init=function init(){$scope.model.trackingId=orderShipment.trackingId;};$scope.ok=function(){};$scope.cancel=function(){orderPackReturnModal.close();};init();}]});};var balanceSheetInfo=function balanceSheetInfo(sheetInfo,currency,title,data,modal,callback){var balanaceSheetModal=$uibModal.open({template:_balanceSheetInfo2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','DailyBalanceSheetService','DataCounter','$state',function($scope,DailyBalanceSheetService,DataCounter,$state){$scope.loading=true;$scope.label=title;$scope.currency=currency;$scope.model={sheetInfo:sheetInfo,data:data,dvbDetails:[],mapping:[],isExist:false,showLocId:false,fields:{'amountLoadRequested':'amountLoadRequested','amount':'amount','totalAmount':'totalAmount','amountCounted':'amountCounted','amountLoadActual':'amountLoadActual'},amountField:''};$scope.model.mapping=['ordersPackedAlltime','pendingResidualCount','residualsDeposited','actualResidualsCounted','actualCashLoaded','pendingCrvDepositAll','ordersPacked','depositsPendingRelease','depositsPendingCount','packableOrdersPacked','packableOrdersPackedAlltime','receivedBulkCash','actualDepositsCounted'];var init=function init(){$scope.loading=false;$scope.model.isExist=$scope.model.mapping.includes(data.infoFor);$scope.extraDetails();};$scope.extraDetails=function(){if($scope.model.isExist){$scope.loading=true;DailyBalanceSheetService.allDVBDetails(data.branchId,data.fundingSourceId,data.currencyId,data.denominationId,data.account,data.vaultDate,data.infoFor).then(function(res){$scope.model.dvbDetails=res.results;$scope.model.dvbDetails.map(function(d){if(d.hasOwnProperty('locationId'))$scope.model.showLocId=true;else $scope.model.showLocId=false;d.showGroupCells=true;d.groupRowSpan=1;});if(data.infoFor==='pendingResidualCount'&&res.denomSummary){$scope.setPendingResidualDenomSummary(res.denomSummary,res.results);}if(data.infoFor==='actualDepositsCounted'){$scope.groupDvbDetailsByKey(function(row){return row.locationId+'|'+row.trackingId;});}else if(data.infoFor==='receivedBulkCash'){$scope.groupDvbDetailsByKey(function(row){return row.transactionId;});}}).catch(function(err){console.log(err);}).finally(function(){$scope.loading=false;});}};// Per-denom cards come from Denom STC captured at pickup; whatever the table total has beyond that
// (residuals without STC) is shown as one "not captured" card so the cards still add up to the total.
$scope.setPendingResidualDenomSummary=function(summary,rows){var symbol=rows[0]&&rows[0].symbol||currency;var cards=summary.map(function(d){return{denominationId:d.denominationId,value:Number(d.amount),coinFlag:d.coinFlag,symbol:d.symbol||symbol,sortOrder:Number(d.sortOrder),faceValue:Number(d.faceValue)};});var total=rows.reduce(function(sum,r){return sum+Number(r.amount||0);},0);// Any non-zero gap is shown (negative = cards exceed the table), never hidden.
var notCaptured=Math.round((total-cards.reduce(function(sum,c){return sum+c.value;},0))*100)/100;if(notCaptured!==0)cards.push({denominationId:null,notCaptured:true,value:notCaptured,coinFlag:false,symbol:symbol});$scope.model.sheetInfo=cards;};$scope.groupDvbDetailsByKey=function(getKey){var details=$scope.model.dvbDetails||[];var groupStartIndex=0;details.forEach(function(row,index){if(index===0||getKey(row)!==getKey(details[index-1])){groupStartIndex=index;row.showGroupCells=true;row.groupRowSpan=1;}else{row.showGroupCells=false;details[groupStartIndex].groupRowSpan++;}});};$scope.exportData=function(){if($scope.model.isExist){$scope.exporting=true;DailyBalanceSheetService.exportData(data.branchId,data.fundingSourceId,data.currencyId,data.denominationId,data.account,data.vaultDate,data.infoFor).then(function(res){if(['receivedBulkCash','actualDepositsCounted'].includes(data.infoFor)){$scope.generateExcelFile(res,data.infoFor);}else{$scope.generateFile(res.reportData,res.fileName);}}).catch(function(err){console.log(err);}).finally(function(){$scope.exporting=false;});}};$scope.generateFile=function(reportData,fileName){var a=document.createElement("a");var name=fileName.concat('_',$scope.model.data.vaultDate,'.csv');document.body.appendChild(a);var file=new Blob([reportData],{type:'application/csv'});var fileURL=window.URL.createObjectURL(file);a.href=fileURL;a.download=name;a.click();};$scope.generateExcelFile=function(arrayBuffer,fileName){var a=document.createElement("a");var name=fileName.concat('_',$scope.model.data.vaultDate,'.xlsx');document.body.appendChild(a);var file=new Blob([arrayBuffer],{type:'application/xlsx'});var fileURL=window.URL.createObjectURL(file);a.href=fileURL;a.download=name;a.click();};$scope.findAmount=function(data){var keys=(0,_keys2.default)(data);keys.map(function(key){if($scope.model.fields[key])return $scope.model.amountField=$scope.model.fields[key];});return data[$scope.model.amountField];};$scope.goToServiceHistory=function(locationId){balanaceSheetModal.close();var obj={locationId:locationId,isRedirected:true};DataCounter.setData(obj);$state.go('branchManagement.locations');};$scope.goToItemOrDepositPackHistory=function(trackingId){balanaceSheetModal.close();if($scope.model.data.infoFor==='residualsDeposited'){var obj={trackingId:trackingId,isRedirected:true,fundingSourceId:data.fundingSourceId};DataCounter.setData(obj);$state.go('branchManagement.items');}else{$state.go('branchManagement.items',{id:trackingId});}};$scope.goToOrderHistory=function(orderNo){balanaceSheetModal.close();var info=$scope.model.data.infoFor;var obj={orderNo:orderNo,isRedirected:true,isCounted:info==='actualResidualsCounted'||info==='pendingCrvDepositAll'?true:false,isInProcess:info==='actualCashLoaded'||info==='ordersPackedAlltime'||info==='ordersPacked'||info==='pendingResidualCount'?true:false,fundingSourceId:$scope.model.data.fundingSourceId};DataCounter.setData(obj);$state.go('branchManagement.orders');};$scope.cancel=function(){balanaceSheetModal.close();};init();}]});};var deliveryRouteInfo=function deliveryRouteInfo(data,routeId,vaultDate,flag,timezone,branchId,routeDetails,modal,callback){var routeDelivriesModal=$uibModal.open({template:_routeDelivriesInfoTemplate2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','$state','RouteService','DataCounter','Navigation','$translate','Modal',function($scope,$state,RouteService,DataCounter,Navigation,$translate,Modal){var _this2=this;$scope.loading=false;$scope.title='',$scope.flag='',$scope.routeId=routeId;$scope.model={routesInfo:data,timezone:timezone};$scope.newEmail='';$scope.emailList=[];$scope.sending=false;var init=function init(){$scope.validateUI();};$scope.addEmail=function(){if($scope.newEmail&&/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test($scope.newEmail)&&!$scope.emailList.includes($scope.newEmail)){$scope.emailList.push($scope.newEmail);$scope.newEmail='';}};// Remove email from the list
$scope.removeEmail=function(index,$event){if($event){$event.preventDefault();$event.stopPropagation();}$scope.emailList.splice(index,1);};$scope.sendEmail=function(){if($scope.emailList.length>0){$scope.sending=true;var emailData={routeId:routeId,vaultDate:vaultDate,title:$scope.title,flag:$scope.flag,receiverEmails:$scope.emailList,reportData:data,branchId:branchId};RouteService.pickupReportEmail(emailData).then(function(response){Modal.confirm({header:$translate.instant('successModal.title'),message:$translate.instant('common.email_sent_success'),callback:function callback(_ref52){var modal=_ref52.modal;modal.close();},buttons:['common.ok'],type:'success'});// Clear the email list and input
$scope.emailList=[];$scope.newEmail='';}).catch(function(error){var errorMessage=error&&error.data&&error.data.message?error.data.message:$translate.instant('common.something_went_wrong');Modal.error({title:$translate.instant('common.error'),message:errorMessage});}).finally(function(){$scope.sending=false;});}};var totals=void 0;if(data.length>0){totals=data.reduce(function(acc,d){acc.totalAmount+=d.amount;d.coinFlag?acc.totalCoin++:acc.totalBag++;return acc;},{totalAmount:0,totalCoin:0,totalBag:0});}$scope.print=function(){var new_path=$state.href('printRoutes');window.w=window.open(new_path,'_blank');window.w.printData={'routeId':routeId,'vaultDate':vaultDate,'title':$scope.title,'data':data,'flag':$scope.flag,'timezone':$scope.model.timezone,'totals':totals,'routeDetails':routeDetails};};$scope.exportToCSV=function(){$scope.loading=true;RouteService.exportCSV(routeId,vaultDate,$scope.flag,$scope.model.timezone).then(function(data){_this2.date=moment.utc().format('DDMMYY');_this2.fileName=(routeId+'_'+$scope.flag).concat('_',_this2.date,'.csv');var a=document.createElement("a");document.body.appendChild(a);var file=new Blob([data.reportData.data],{type:'application/csv'});var fileURL=window.URL.createObjectURL(file);a.href=fileURL;a.download=_this2.fileName;a.click();}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.loading=false;});};$scope.goToServiceHistory=function(locationId){routeDelivriesModal.close();var obj={locationId:locationId,isRedirected:true};DataCounter.setData(obj);$state.go('branchManagement.locations');};$scope.goToItemHistory=function(trackingId){routeDelivriesModal.close();$state.go('branchManagement.items',{id:trackingId});};$scope.validateUI=function(){if(flag==='delivery'){$scope.flag='delivery';$scope.title=$translate.instant('branch_mgmt.route_deliveries');}else if(flag==='pickups'){$scope.flag='pickups';$scope.title=$translate.instant('branch_mgmt.route_pickups');}else if(flag==='holdDeliveries'){$scope.flag='holdDeliveries';$scope.title=$translate.instant('branch_mgmt.not_delivered');}else if(flag==='holdPickups'){$scope.flag='holdPickups';$scope.title=$translate.instant('branch_mgmt.not_pickUp');}};$scope.goToItemHold=function(trackingId){return Navigation.goToItemHold(trackingId,true);};$scope.cancel=function(){routeDelivriesModal.close();};init();}]});};// list of all coin shiptypes 
var coinShiptypeList=function coinShiptypeList(routeId,vaultDate,branch,callback){var coinShiptypeListModal=$uibModal.open({template:_coinShiptypeList2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','ShipmentService','$q','ScanService','$translate','Sound','Modal',function($scope,ShipmentService,$q,ScanService,$translate,Sound,Modal){$scope.model={loading:false,shipTypeList:[],routeId:routeId,date:vaultDate,branchId:branch,shiptype:{},branchFundingSourceId:null,inventoryBulkCoin:null,allCoins:[],shipTypeIds:[],coinVerifiedMsg:''};$scope.coinShiptypeList={};var init=function init(){$scope.model.loading=true;ScanService.verifyCoin($scope.model.routeId,$scope.model.date).then(function(data){if(data&&data.results){$scope.model.allCoins=data.results.allCoins;$scope.model.shipTypeList=data.results.groupedCoins;$scope.model.isCodInventoryBulkCoin=$scope.model.allCoins.some(function(item){return item.inventoryBulkCoin===1&&item.codInputValue>0;});$scope.model.shipTypeList.map(function(d){$scope.model.shipTypeIds.push(d.shiptypeId);$scope.coinShiptypeList[d.shiptypeId]={'inputValue':d.inputValue};});}else{$scope.model.coinVerifiedMsg=$translate.instant('checkout.'+data.message);}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.verifyCoin=function(){$scope.incorrectCoins={};var verify=_.map($scope.model.shipTypeList,function(d){if($scope.model.shiptype[d.shiptypeId]){var isCorrect=$scope.model.shiptype[d.shiptypeId].qty==$scope.coinShiptypeList[d.shiptypeId].inputValue;if(!isCorrect){$scope.incorrectCoins[d.shiptypeId]=true;}return isCorrect;}});if(verify.indexOf(false)>=0||verify.indexOf()!==-1)return $scope.isValid=false;else return $scope.isValid=true;};$scope.ok=function(){var validCoins=[];var invalidCoins=[];// Filter coins with COD amount > 0 and use COD amount for ledger check
var coinsToCheck=$scope.model.allCoins.filter(function(c){return c.inventoryBulkCoin&&Number(c.codAmount)>0;}).map(function(c){return{shiptypeId:c.shiptypeId,branchFundingSourceId:c.branchFundingSourceId,amount:c.codAmount,fundingSourceName:c.fundingSourceName};});if(coinsToCheck.length===0){return callback({modal:coinShiptypeListModal,isCodInventoryBulkCoin:$scope.model.isCodInventoryBulkCoin,coinIds:$scope.model.shipTypeIds});}ScanService.getCurrentDenomLedgerBalance($scope.model.branchId,'Regular',coinsToCheck,$scope.model.routeId,$scope.model.date).then(function(data){if(data){coinsToCheck.forEach(function(shipType){var matchingDenomination=data.find(function(denom){return denom.denominationId===shipType.shiptypeId&&denom.branchFundingSourceId===shipType.branchFundingSourceId;});if(matchingDenomination){if(matchingDenomination.alreadyDebited===true){validCoins.push(shipType);}else if(Number(shipType.amount)<=matchingDenomination.balance){validCoins.push(shipType);}else{invalidCoins.push(shipType);}}else{// If denominationId is not present in data
invalidCoins.push(shipType);}});if(invalidCoins.length>0){Sound.PlayErrorBeep("#scanner_beep");var message=$translate.instant('orderPacking.insufficient_coin',{Denomination:invalidCoins[0].shiptypeId,BranchFundingSource:invalidCoins[0].fundingSourceName});errorModal(message);}else{callback({modal:coinShiptypeListModal,isCodInventoryBulkCoin:$scope.model.isCodInventoryBulkCoin,coinIds:$scope.model.shipTypeIds});}}}).catch(function(err){console.log(err);if(err&&err.data&&err.data.message){return Modal.errorModal(err.data.message);}});};$scope.cancel=function(){coinShiptypeListModal.close();};init();}]});};var routeStopTransfer=function routeStopTransfer(vaultDate,date,branchVaultDate,selectedRoutes,branch,routeCheckoutInfo,callback,negative){var routeStopTransferModal=$uibModal.open({template:_stopTransfer2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q','RouteService','Modal','BranchService','SetupService','$timeout','RouteStopService',function($scope,$q,RouteService,Modal,BranchService,SetupService,$timeout,RouteStopService){$scope.model={loading:false,vaultDate:date,routeDate:vaultDate,branchId:branch,selectedRoutes:selectedRoutes,branchVaultDate:branchVaultDate,days:[{label:$translate.instant('location.sun'),value:'Sun'},{label:$translate.instant('location.mon'),value:'Mon'},{label:$translate.instant('location.tues'),value:'Tue'},{label:$translate.instant('location.wed'),value:'Wed'},{label:$translate.instant('location.thurs'),value:'Thu'},{label:$translate.instant('location.fri'),value:'Fri'},{label:$translate.instant('location.sat'),value:'Sat'},{label:$translate.instant('location.hol'),value:'Hol'}],selectedDay:'Mon',dayOfWeek:['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],currentDay:"",routeStopList:[],routePosition:0,originRoute:[],destinationRoute:[],actualLat:"",actualLong:"",locationInfo:"",originStopCount:[],destinationStopCount:[],transferredStops:[],destSequenceInput:[],fromRouteId:selectedRoutes[0],toRouteId:selectedRoutes[1],destinationRouteLength:"",movedObj:{},isMapInitialized:true,isSourceMapInitialized:true,allRoutes:[],fromRouteDate:date,sourceRoutes:[],isUpdating:false,isRouteCheckout:routeCheckoutInfo[0],releaseRouteStatus:'',isPreviousVaultDate:false,destinationRouteIsReleased:false,needsRefresh:false,totalTransferredStops:0,totalTransferredShipments:0,requireThrow:false};$scope.stopList=[];$scope.destinationRouteLatLong=[];$scope.sourceRouteLatLong=[];$scope.loadImage=function(image){$scope.icon={'REGULAR':'regular.png','ATM':'atm.png','BANK':'bank.png','NO_SHIP_NO_GO':'nsng.png','INTERNAL':'internal.png','TRUCK':'truck.png','TANKER':'tanker.png','WINDOW':'window.png','CARRIER':'carrier.png','ON_CALL':'oncall.png','LOCKER':'locker.png','VAULT':'vault.png','DELIVERY':'delivery.png'};var imgURL=$scope.icon[image];return __webpack_require__(51)("./"+imgURL);};var applyStopTransferDisability=function applyStopTransferDisability(stops){stops.forEach(function(stop){stop.disabledStopTransfer=false;stop.disableReason='';var stopStatus=(stop.stopStatus||'').toUpperCase();var isCompleted=stopStatus!=='';var hasCheckedOutDelivery=(stop.shipmentInfo||[]).some(function(info){return info.checkedOut===1;});var hasAnyShipment=(stop.shipmentInfo||[]).some(function(info){return info&&(info.trackingId||info.orderType||info.checkedOut!==null);});var isCantStop=stopStatus==='CANT';var isRequiredPickup=stop.isRequiredPickup===1||stop.isRequiredPickup===true;if(hasCheckedOutDelivery){stop.disabledStopTransfer=true;stop.disableReason='Stop has checked out shipments. Shipments cannot be transferred';}else if(isCompleted&&!isCantStop&&!isRequiredPickup){stop.disabledStopTransfer=true;stop.disableReason='Completed stops cannot be transferred.';}else if(isCantStop&&hasAnyShipment){stop.disabledStopTransfer=true;stop.disableReason='CANT stop with shipments cannot be transferred.';}});};var init=function init(){// get current vaultDate day
$scope.model.loading=true;var today=$scope.model.vaultDate.getDay();$scope.model.currentDay=$scope.model.dayOfWeek[today];$scope.model.selectedDay=$scope.model.currentDay;$scope.date=moment($scope.model.vaultDate).format('YYYY-MM-DD');$scope.minVaultDate={minDate:$scope.model.branchVaultDate};$scope.model.isPreviousVaultDate=$scope.date<moment($scope.model.branchVaultDate).format('YYYY-MM-DD');$scope.loadDestinationRoutes();$scope.loadSourceRoutes();$q.all([SetupService.get($scope.model.branchId),$scope.getRouteStops($scope.model.fromRouteId,$scope.model.toRouteId,$scope.date,$scope.model.branchId)]).then(function(data){$scope.model.branchInfo=data[0];var routeStopDetails=data[1];$scope.model.fromRouteStops=routeStopDetails.resultOne;$scope.model.destinationRouteStops=routeStopDetails.resultTwo;$scope.model.destinationRouteLength=routeStopDetails.resultTwo.length;refreshDestSequenceInputs();if($scope.model.toRouteId){var selectedRoute=$scope.model.allRoutes.find(function(route){return route.routeId===$scope.model.toRouteId;});$scope.model.destinationRouteIsReleased=selectedRoute?selectedRoute.isReleased||selectedRoute.lastReleasedAt:false;}$scope.model.loading=false;// if ($scope.model.isRouteCheckout) {
applyStopTransferDisability($scope.model.fromRouteStops);// }
$scope.getDestinationRouteLatLong();$scope.getSourceRouteLatLong();loadMap(routeStopDetails);if($scope.model.toRouteId)$scope.loadSecondMap(routeStopDetails);});};$scope.getRouteStops=function(fromRouteId,toRouteId,date,branchId){var defer=$q.defer();var fromVaultDate=moment($scope.model.fromRouteDate||$scope.model.vaultDate).format('YYYY-MM-DD');var toVaultDate=moment(date||$scope.model.vaultDate).format('YYYY-MM-DD');RouteService.routeStopTransferList(fromRouteId,toRouteId,fromVaultDate,toVaultDate,branchId).then(function(data){defer.resolve(data);}).catch(function(err){if(err&&err.data&&err.data.message){return Modal.errorModal('error.'+err.data.message);}defer.reject(err);});return defer.promise;};$scope.loadRouteStops=function(){$scope.model.isMapInitialized=true;var formattedDate=moment($scope.model.vaultDate).format('YYYY-MM-DD');$scope.model.releaseRouteStatus='';$scope.getRouteStops(null,$scope.model.toRouteId,formattedDate,$scope.model.branchId).then(function(data){$scope.model.destinationRouteStops=data.resultTwo;$scope.model.destinationRouteLength=data.resultTwo.length;refreshDestSequenceInputs();$scope.model.loading=false;$scope.getDestinationRouteLatLong();$scope.loadSecondMap(data);});};$scope.changeRoute=function(){// load destination routes 
$scope.model.isMapInitialized=false;if($scope.mapTwo){$scope.mapTwo.remove();$scope.stopList.forEach(function(id){$scope.mapTwo.removeLayer(id);});}var selectedRoute=$scope.model.allRoutes.find(function(route){return route.routeId===$scope.model.toRouteId;});$scope.model.destinationRouteIsReleased=selectedRoute?selectedRoute.isReleased||selectedRoute.lastReleasedAt:false;$scope.reloadMap();$scope.loadRouteStops();};$scope.reloadMap=function(){if($scope.model.transferredStops.length>0){$scope.model.transferredStops=[];$scope.mapOne.remove();$scope.stopList.forEach(function(id){$scope.mapOne.removeLayer(id);});$scope.getRouteStops($scope.model.fromRouteId,null,moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),$scope.model.branchId).then(function(data){$scope.model.fromRouteStops=data.resultOne;$scope.model.loading=false;applyStopTransferDisability($scope.model.fromRouteStops);$scope.getSourceRouteLatLong();loadMap(data);});}};var loadMap=function loadMap(data){setTimeout(function(){// First Map
if($scope.model.isSourceMapInitialized){$scope.mapOne=L.map('mapOne',{// center: [39.68649209557518, -101.48273981764913],
// zoom: 4
});$scope.mapOne.fitBounds($scope.sourceRouteLatLong.length?$scope.sourceRouteLatLong:[[$scope.model.branchInfo.gpsLat,$scope.model.branchInfo.gpsLong]]);L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo($scope.mapOne);}setMarkers(data.resultOne,0,$scope.mapOne,$scope.model.originRoute);// set marker position for origin route
},100);};$scope.loadSecondMap=function(data){setTimeout(function(){// Second Map
if($scope.model.isMapInitialized){$scope.mapTwo=L.map('mapTwo',{// center: [39.68649209557518, -101.48273981764913],
// zoom: 4
});$scope.mapTwo.fitBounds($scope.destinationRouteLatLong.length?$scope.destinationRouteLatLong:[[$scope.model.branchInfo.gpsLat,$scope.model.branchInfo.gpsLong]]);L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo($scope.mapTwo);}setMarkers(data.resultTwo,0,$scope.mapTwo,$scope.model.destinationRoute);// set marker position for destination route
},100);};$scope.selectDay=function(day){if(day.value!=$scope.model.currentDay)return;$scope.model.selectedDay=day.value;};$scope.locationMoved=function(index){if(!$scope.model.fromRouteStops[index]||$scope.model.fromRouteStops[index].disabledStopTransfer||$scope.model.toRouteId&&!$scope.model.destinationRouteIsReleased){return;}$scope.refreshFirstMap();$scope.refreshSecondMap();$scope.locations=$scope.model.fromRouteStops[index];$scope.model.movedObj=(0,_assign2.default)({locationId:$scope.locations.locationId,routeDate:moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),fromRouteId:$scope.model.fromRouteId,toRouteId:$scope.model.toRouteId,toRouteDate:moment($scope.model.vaultDate).format('YYYY-MM-DD'),shipmentInfo:$scope.locations.shipmentInfo});if($scope.model.destinationRouteStops.length==$scope.model.destinationRouteLength+1){$scope.model.destinationRouteLength+=1;$scope.model.transferredStops.push($scope.model.movedObj);}$scope.model.fromRouteStops.splice(index,1);refreshDestSequenceInputs();};$scope.routeStopMoved=function(index){$scope.model.destinationRouteStops.splice(index,1);};$scope.arrayFormat=function(trackingIds){var data=trackingIds;return data.join(", ");//  return trackingIds.toString();
};$scope.isMoveAllStopsDisabled=function(){if(!$scope.model.fromRouteStops||!$scope.model.fromRouteStops.length)return true;return $scope.model.fromRouteStops.every(function(stop){return stop.disabledStopTransfer;})||!$scope.model.toRouteId||$scope.model.toRouteId&&!$scope.model.destinationRouteIsReleased;};$scope.moveAllStops=function(){if($scope.isMoveAllStopsDisabled())return;var stopsToMove=$scope.model.fromRouteStops.filter(function(stop){return!stop.disabledStopTransfer;});var stopsToKeep=$scope.model.fromRouteStops.filter(function(stop){return stop.disabledStopTransfer;});stopsToMove.forEach(function(stop){var movedObj=(0,_assign2.default)({locationId:stop.locationId,routeDate:moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),fromRouteId:$scope.model.fromRouteId,toRouteId:$scope.model.toRouteId,toRouteDate:moment($scope.model.vaultDate).format('YYYY-MM-DD'),shipmentInfo:stop.shipmentInfo});$scope.model.transferredStops.push(movedObj);$scope.model.destinationRouteStops.push(stop);});$scope.model.destinationRouteLength+=stopsToMove.length;$scope.model.fromRouteStops=stopsToKeep;refreshDestSequenceInputs();$scope.refreshFirstMap();$scope.refreshSecondMap();};$scope.isTransferDisabled=function(location){return!location||location.disabledStopTransfer||!$scope.model.toRouteId||!$scope.model.destinationRouteIsReleased||$scope.model.isUpdating||$scope.model.isUpdateOptimizing||$scope.model.isOptimizing;};$scope.transferStop=function(index){var stop=$scope.model.fromRouteStops[index];if($scope.isTransferDisabled(stop))return;var movedObj=(0,_assign2.default)({locationId:stop.locationId,routeDate:moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),fromRouteId:$scope.model.fromRouteId,toRouteId:$scope.model.toRouteId,toRouteDate:moment($scope.model.vaultDate).format('YYYY-MM-DD'),shipmentInfo:stop.shipmentInfo});$scope.model.transferredStops.push(movedObj);$scope.model.destinationRouteStops.push(stop);$scope.model.destinationRouteLength+=1;$scope.model.fromRouteStops.splice(index,1);refreshDestSequenceInputs();$scope.refreshFirstMap();$scope.refreshSecondMap();};var refreshDestSequenceInputs=function refreshDestSequenceInputs(){$scope.model.destSequenceInput=$scope.model.destinationRouteStops.map(function(stop,position){return position+1;});};var moveDestStopToIndex=function moveDestStopToIndex(index,targetIndex){var list=$scope.model.destinationRouteStops;if(targetIndex<0||targetIndex>=list.length||targetIndex===index){return refreshDestSequenceInputs();}list.splice(targetIndex,0,list.splice(index,1)[0]);refreshDestSequenceInputs();$scope.refreshSecondMap();};$scope.moveDestStop=function(index,offset){moveDestStopToIndex(index,index+offset);};$scope.destSequenceTyped=function(index){var typed=$scope.model.destSequenceInput[index];if(!angular.isNumber(typed)||isNaN(typed))return refreshDestSequenceInputs();moveDestStopToIndex(index,Math.round(typed)-1);};$scope.optimizeRoute=function(){if(!$scope.model.toRouteId)return;$scope.model.isOptimizing=true;RouteStopService.autoOptimizeRouteStops(moment($scope.model.vaultDate).format('YYYY-MM-DD'),$scope.model.toRouteId).then(function(res){if(res.status||res){return $scope.getRouteStops($scope.model.fromRouteId,$scope.model.toRouteId,moment($scope.model.vaultDate).format('YYYY-MM-DD'),$scope.model.branchId).then(function(data){$scope.model.destinationRouteStops=data.resultTwo;refreshDestSequenceInputs();$scope.refreshSecondMap();});}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal('error.'+err.data.message);}else{Modal.errorModal('An error occurred during route optimization.');}}).finally(function(){$scope.model.isOptimizing=false;});};$scope.updateAndOptimize=function(){if(!$scope.model.transferredStops.length)return;$scope.model.isUpdateOptimizing=true;$scope.model.transferredStops.forEach(function(obj){obj.toRouteSequence=_.findIndex($scope.model.destinationRouteStops,{locationId:obj.locationId})+1;});RouteService.updateStopsAndShipments($scope.model.transferredStops,$scope.model.transferredStops,$scope.model.branchId,false).then(function(res){if(res&&res.status!==false){if(res.requireThrow)$scope.model.requireThrow=true;$scope.model.transferredStops.forEach(function(t){t.shipmentInfo.forEach(function(s){if(s.trackingId)$scope.model.totalTransferredShipments++;else $scope.model.totalTransferredStops++;});});var _selectedRoutes=[{routeId:$scope.model.fromRouteId,date:moment($scope.model.fromRouteDate).format('YYYY-MM-DD')},{routeId:$scope.model.toRouteId,date:moment($scope.model.vaultDate).format('YYYY-MM-DD')}];$scope.model.transferredStops=[];return RouteService.routeStopTransfered(_selectedRoutes,$scope.model.branchId).then(function(){var performRefresh=function performRefresh(){return $scope.getRouteStops($scope.model.fromRouteId,$scope.model.toRouteId,moment($scope.model.vaultDate).format('YYYY-MM-DD'),$scope.model.branchId).then(function(data){$scope.model.fromRouteStops=data.resultOne;$scope.model.destinationRouteStops=data.resultTwo;refreshDestSequenceInputs();applyStopTransferDisability($scope.model.fromRouteStops);$scope.refreshFirstMap();$scope.refreshSecondMap();$scope.model.needsRefresh=true;});};return RouteStopService.autoOptimizeRouteStops(moment($scope.model.vaultDate).format('YYYY-MM-DD'),$scope.model.toRouteId).then(function(){return performRefresh();}).catch(function(err){return performRefresh().then(function(){return $q.reject(err);});});});}else{return $q.reject(res);}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal('error.'+err.data.message);}else if(err&&err.message){Modal.errorModal('error.'+err.message);}else{Modal.errorModal('An error occurred during update and optimize.');}}).finally(function(){$scope.model.isUpdateOptimizing=false;});};$scope.update=function(){$scope.model.isUpdating=true;$scope.model.transferredStops.map(function(obj){obj.toRouteSequence=_.findIndex($scope.model.destinationRouteStops,{locationId:obj.locationId})+1;});callback({modal:routeStopTransferModal,transferredStops:$scope.model.transferredStops,fromRoutesData:$scope.model.fromRouteStops,destinationRoutesData:$scope.model.destinationRouteStops,fromRouteId:$scope.model.fromRouteId,fromRouteDate:moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),toRouteId:$scope.model.toRouteId,toRouteDate:moment($scope.model.vaultDate).format('YYYY-MM-DD'),$scope:$scope});};var setMarkers=function setMarkers(data,routePosition,mapFor,stopList){routePosition=routePosition||0;$scope.stopList=stopList;setTimeout(function(){data.forEach(function(sequenceData){if(sequenceData&&sequenceData.lat&&sequenceData.long){routePosition+=1;$scope.model.actualLat=sequenceData.lat;$scope.model.actualLong=sequenceData.long;$scope.model.locationInfo='<strong>'+sequenceData.locationName+'</strong>'+'<br>'+sequenceData.address+' - '+sequenceData.zip+'<br>'+sequenceData.city+', '+sequenceData.state;var id=L.marker([$scope.model.actualLat,$scope.model.actualLong],{icon:new L.AwesomeNumberMarkers({number:routePosition,markerColor:"blue"})}).addTo(mapFor).bindPopup($scope.model.locationInfo);id.on('mouseover',function(){id.openPopup();});id.on('mouseout',function(){id.closePopup();});stopList.push(id);}});},100);};// reRender map on route transfer
$scope.refreshFirstMap=function(){$scope.model.originRoute.forEach(function(id,index){$scope.mapOne.removeLayer(id);});$scope.model.originRoute=[];setTimeout(function(){setMarkers($scope.model.fromRouteStops,0,$scope.mapOne,$scope.model.originRoute);},500);};// reRender map on route transfer
$scope.refreshSecondMap=function(){$scope.model.destinationRoute.forEach(function(id,index){$scope.mapTwo.removeLayer(id);});$scope.model.destinationRoute=[];setTimeout(function(){setMarkers($scope.model.destinationRouteStops,0,$scope.mapTwo,$scope.model.destinationRoute);},500);};$scope.loadDestinationRoutes=function(){var formattedDate=moment($scope.model.vaultDate).format('YYYY-MM-DD');RouteService.getRoutes($scope.model.branchId,formattedDate).then(function(data){$scope.model.allRoutes=data.results;if($scope.model.toRouteId){var selectedRoute=$scope.model.allRoutes.find(function(route){return route.routeId===$scope.model.toRouteId;});$scope.model.destinationRouteIsReleased=selectedRoute?selectedRoute.isReleased||selectedRoute.lastReleasedAt:false;}}).catch(function(err){console.log(err);});};$scope.loadNextdayRoutes=function(){$scope.model.toRouteId=null;$scope.model.destinationRouteStops=[];$scope.model.releaseRouteStatus='';$scope.model.destinationRouteIsReleased=false;var formattedDate=moment($scope.model.vaultDate).format('YYYY-MM-DD');$scope.model.isPreviousVaultDate=formattedDate<moment($scope.model.branchVaultDate).format('YYYY-MM-DD');$scope.reloadMap();$scope.loadDestinationRoutes();};$scope.reloadDestinationMap=function(){if($scope.model.transferredStops.length>0){$scope.model.transferredStops=[];$scope.mapTwo.remove();$scope.stopList.forEach(function(id){$scope.mapTwo.removeLayer(id);});$scope.getRouteStops(null,$scope.model.toRouteId,moment($scope.model.vaultDate).format('YYYY-MM-DD'),$scope.model.branchId).then(function(data){$scope.model.destinationRouteStops=data.resultTwo;$scope.model.destinationRouteLength=data.resultTwo.length;refreshDestSequenceInputs();$scope.model.loading=false;$scope.getDestinationRouteLatLong();$scope.loadSecondMap(data);});}};$scope.loadSourceRoutes=function(){// load source route list
var formattedDate=moment($scope.model.fromRouteDate).format('YYYY-MM-DD');// console.log("formattedDate", formattedDate);
RouteService.getRoutes($scope.model.branchId,formattedDate).then(function(data){$scope.model.sourceRoutes=data.results;}).catch(function(err){console.log(err);});};$scope.changeSourceRoutes=function(){$scope.model.isSourceMapInitialized=false;if($scope.mapOne){$scope.mapOne.remove();$scope.stopList.forEach(function(id){$scope.mapOne.removeLayer(id);});}$scope.reloadDestinationMap();$scope.loadSourceRouteStops();};$scope.loadSourceRouteStops=function(){$scope.model.isSourceMapInitialized=true;var formattedDate=moment($scope.model.fromRouteDate).format('YYYY-MM-DD');// console.log("formattedDate", formattedDate);
$scope.getRouteStops($scope.model.fromRouteId,null,formattedDate,$scope.model.branchId).then(function(data){$scope.model.fromRouteStops=data.resultOne;$scope.loading=false;applyStopTransferDisability($scope.model.fromRouteStops);$scope.getSourceRouteLatLong();loadMap(data);});};$scope.getSourceRoute=function(){$scope.model.fromRouteId=null;$scope.model.fromRouteStops=[];$scope.reloadDestinationMap();$scope.loadSourceRoutes();};$scope.getSourceRouteLatLong=function(){$scope.sourceRouteLatLong=[];$scope.model.fromRouteStops.forEach(function(d){if(d.lat&&d.long){$scope.sourceRouteLatLong.push(new Array(d.lat,d.long));}});};$scope.getDestinationRouteLatLong=function(){$scope.destinationRouteLatLong=[];$scope.model.destinationRouteStops.forEach(function(d){if(d.lat&&d.long){$scope.destinationRouteLatLong.push(new Array(d.lat,d.long));}});};$scope.ok=function(){$scope.model.isUpdating=true;$scope.model.transferredStops.map(function(obj){obj.toRouteSequence=_.findIndex($scope.model.destinationRouteStops,{locationId:obj.locationId})+1;});callback({modal:routeStopTransferModal,transferredStops:$scope.model.transferredStops,fromRoutesData:$scope.model.fromRouteStops,destinationRoutesData:$scope.model.destinationRouteStops,fromRouteId:$scope.model.fromRouteId,fromRouteDate:moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),toRouteId:$scope.model.toRouteId,toRouteDate:moment($scope.model.vaultDate).format('YYYY-MM-DD'),$scope:$scope});};$scope.cancel=function(){negative({modal:routeStopTransferModal,needsRefresh:$scope.model.needsRefresh,totalTransferredStops:$scope.model.totalTransferredStops,totalTransferredShipments:$scope.model.totalTransferredShipments,requireThrow:$scope.model.requireThrow});};$scope.isDestinationRouteNotReleased=function(){return $scope.model.toRouteId&&!$scope.model.destinationRouteIsReleased;};$scope.releaseDestinationRoute=function(){if(!$scope.model.toRouteId)return;$scope.model.releaseRouteStatus='processing';var formattedDate=moment($scope.model.vaultDate).format('YYYY-MM-DD');RouteService.releaseRoute($scope.model.toRouteId,formattedDate,$scope.model.branchId,'route_control').then(function(res){if(res.status){$scope.model.releaseRouteStatus='success';$scope.model.destinationRouteIsReleased=true;var selectedRoute=$scope.model.allRoutes.find(function(route){return route.routeId===$scope.model.toRouteId;});if(selectedRoute){selectedRoute.isReleased=true;selectedRoute.lastReleasedAt=new Date();}$scope.model.transferredStops=[];if($scope.mapTwo){$scope.model.destinationRoute.forEach(function(id){$scope.mapTwo.removeLayer(id);});$scope.mapTwo.remove();$scope.mapTwo=null;}if($scope.mapOne){$scope.model.originRoute.forEach(function(id){$scope.mapOne.removeLayer(id);});$scope.mapOne.remove();$scope.mapOne=null;}$scope.model.destinationRoute=[];$scope.model.originRoute=[];$scope.model.isMapInitialized=true;$scope.model.isSourceMapInitialized=true;return $q.all([$scope.getRouteStops($scope.model.fromRouteId,null,moment($scope.model.fromRouteDate).format('YYYY-MM-DD'),$scope.model.branchId),$scope.getRouteStops(null,$scope.model.toRouteId,formattedDate,$scope.model.branchId)]);}}).then(function(data){if(data){// Reload source route stops to restore dragged items
$scope.model.fromRouteStops=data[0].resultOne;applyStopTransferDisability($scope.model.fromRouteStops);$scope.getSourceRouteLatLong();loadMap(data[0]);// Reload destination route stops
$scope.model.destinationRouteStops=data[1].resultTwo;$scope.model.destinationRouteLength=data[1].resultTwo.length;refreshDestSequenceInputs();$scope.getDestinationRouteLatLong();$scope.loadSecondMap(data[1]);}}).catch(function(err){$scope.model.releaseRouteStatus='error';if(err&&err.data&&err.data.message){Modal.errorModal('error.'+err.data.message);}}).finally(function(){$timeout(function(){$scope.model.releaseRouteStatus='';},3000);});};init();}]});};var routeSequenceModal=function routeSequenceModal(date,route,branch,branchInfo,callback,negative){var routeSequenceModal=$uibModal.open({template:_routeSequence2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','$q','RouteService','RouteStopService','Modal','LocationService','RouteProgressService',function($scope,$q,RouteService,RouteStopService,Modal,LocationService,RouteProgressService){$scope.model={loading:false,vaultDate:date,branchId:branch,route:route,selectedDay:'Mon',dayOfWeek:['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],currentDay:"",routeStopList:[],sequenceInput:[],routeData:[],isInitialized:true,lat:0,long:0,totalLatLongLocations:0,centerLattitude:0,centerLongitude:0,branchInfo:branchInfo};$scope.loadImage=function(image){$scope.icon={'REGULAR':'regular.png','ATM':'atm.png','BANK':'bank.png','NO_SHIP_NO_GO':'nsng.png','INTERNAL':'internal.png','TRUCK':'truck.png','TANKER':'tanker.png','WINDOW':'window.png','CARRIER':'carrier.png','ON_CALL':'oncall.png','LOCKER':'locker.png','VAULT':'vault.png','DELIVERY':'delivery.png'};var imgURL=$scope.icon[image];return __webpack_require__(51)("./"+imgURL);};var init=function init(){// get current vaultDate day
var today=$scope.model.vaultDate.getDay();$scope.model.currentDay=$scope.model.dayOfWeek[today];// load Route Stops
$scope.loadRouteStop();};$scope.loadRouteStop=function(){$scope.model.loading=true;$scope.locationLatLong=[];var defer=$q.defer();var searchObj={queryJSON:{rules:[{field:"routeId",condition:"=",data:$scope.model.route},{field:"routeDate",condition:"=",data:moment($scope.model.vaultDate).format('YYYY-MM-DD')}],operator:'AND'}};var formattedDate=moment($scope.model.vaultDate).format('YYYY-MM-DD');$q.all([RouteStopService.all(searchObj,0,1000),RouteProgressService.getRouteOriginationCoordinates($scope.model.route,formattedDate).catch(function(err){console.log('Error loading route progress stops coordinates:',err);return{truckCoordinatesInfo:[],userCoordinatesInfo:[]};})]).then(function(_ref53){var _ref54=(0,_slicedToArray3.default)(_ref53,2),routeStopData=_ref54[0],routeProgressData=_ref54[1];$scope.model.loading=false;$scope.model.routeStopList=routeStopData.results;refreshSequenceInputs();$scope.model.truckCoordinatesInfo=routeProgressData.truckCoordinatesInfo||[];$scope.model.userCoordinatesInfo=routeProgressData.userCoordinatesInfo||[];var userCoordinatesInfo=routeProgressData.userCoordinatesInfo||[];var truckCoordinatesInfo=routeProgressData.truckCoordinatesInfo||[];var isUserOriginMismatch=userCoordinatesInfo.length>0&&userCoordinatesInfo[0].userOrigin&&userCoordinatesInfo[0].userOrigin!=='USER';var hasUserNoCoordinates=userCoordinatesInfo.length>0&&(!userCoordinatesInfo[0].lat||!userCoordinatesInfo[0].long);var hasTruckNoCoordinates=truckCoordinatesInfo.length>0&&(!truckCoordinatesInfo[0].lat||!truckCoordinatesInfo[0].long);if(isUserOriginMismatch){$scope.model.originationError='message.originationUserMismatchError';}else if(hasUserNoCoordinates){$scope.model.originationError='message.originationUserError';}else if(hasTruckNoCoordinates){$scope.model.originationError='message.originationTruckError';}else{$scope.model.originationError=null;}$scope.locationIds=$scope.model.routeStopList.map(function(loc){return loc.locationId;});if($scope.model.routeStopList.length){$scope.model.routeStopList.forEach(function(d,index){if(d.location.lat&&d.location.long){$scope.locationLatLong.push(new Array(d.location.lat,d.location.long));$scope.model.totalLatLongLocations+=1;// locations which had lat, long value counted as totalLatLongLocations
$scope.model.lat+=d.location.lat;// sum of Lattitude value of location 
$scope.model.long+=d.location.long;//  sum of Longitude value of location 
}});}defer.resolve(routeStopData);}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});defer.promise.then(function(data){setMarkers(data.results);// set marker position based on location's lat long value
});};var setMarkers=function setMarkers(data){$scope.routePosition=0;setTimeout(function(){if($scope.model.isInitialized){$scope.model.centerLattitude=$scope.model.lat/$scope.model.totalLatLongLocations||39.68649209557518;$scope.model.centerLongitude=$scope.model.long/$scope.model.totalLatLongLocations||-101.48273981764913;$scope.map=L.map('map',{// center: [$scope.model.centerLattitude, $scope.model.centerLongitude],
// zoom: 11
});var fallbackLatLong=null;var _branchInfo=$scope.model.branchInfo||{};if(_branchInfo.gpsLat&&_branchInfo.gpsLong){fallbackLatLong=[_branchInfo.gpsLat,_branchInfo.gpsLong];}var truckCoordinatesInfo=$scope.model.truckCoordinatesInfo&&$scope.model.truckCoordinatesInfo[0]||{};var userCoordinatesInfo=$scope.model.userCoordinatesInfo&&$scope.model.userCoordinatesInfo[0]||{};if(truckCoordinatesInfo.lat&&truckCoordinatesInfo.long){fallbackLatLong=[truckCoordinatesInfo.lat,truckCoordinatesInfo.long];}else if(userCoordinatesInfo.lat&&userCoordinatesInfo.long&&userCoordinatesInfo.userOrigin==='USER'){fallbackLatLong=[userCoordinatesInfo.lat,userCoordinatesInfo.long];}if($scope.locationLatLong.length){$scope.map.fitBounds($scope.locationLatLong);}else if(fallbackLatLong){$scope.map.fitBounds([fallbackLatLong]);}L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo($scope.map);}// Stops sharing the exact same lat/long would otherwise stack into one
// unclickable pin -- fan duplicates out in a tiny circle so each stays visible.
var coordCounts={},coordSeen={};data.forEach(function(s){if(s&&s.location&&s.location.lat&&s.location.long){var key=s.location.lat+','+s.location.long;coordCounts[key]=(coordCounts[key]||0)+1;}});data.forEach(function(sequenceData){if(sequenceData&&sequenceData.location&&sequenceData.location.lat&&sequenceData.location.long){$scope.routePosition=_.findIndex(data,{locationId:sequenceData.locationId})+1;$scope.model.actualLat=parseFloat(sequenceData.location.lat);$scope.model.actualLong=parseFloat(sequenceData.location.long);var coordKey=sequenceData.location.lat+','+sequenceData.location.long;var stopsAtCoord=coordCounts[coordKey];if(stopsAtCoord>1){var seenIndex=coordSeen[coordKey]=(coordSeen[coordKey]||0)+1;var angle=2*Math.PI*(seenIndex-1)/stopsAtCoord;var offset=0.00008;$scope.model.actualLat+=offset*Math.cos(angle);$scope.model.actualLong+=offset*Math.sin(angle);}$scope.model.locationInfo='<strong>'+sequenceData.location.name+'</strong>'+'<br>'+sequenceData.location.address+' - '+sequenceData.location.zip+'<br>'+sequenceData.location.city+', '+sequenceData.location.state;var id=L.marker([$scope.model.actualLat,$scope.model.actualLong],{icon:new L.AwesomeNumberMarkers({number:$scope.routePosition,markerColor:"blue"})}).addTo($scope.map).bindPopup($scope.model.locationInfo);id.on('mouseover',function(){id.openPopup();});id.on('mouseout',function(){id.closePopup();});$scope.model.routeData.push(id);}});$scope.addBranchDetails();},100);};$scope.selectDay=function(day){if(day.value!=$scope.model.currentDay)return;$scope.model.selectedDay=day.value;};var refreshSequenceInputs=function refreshSequenceInputs(){$scope.model.sequenceInput=$scope.model.routeStopList.map(function(stop,position){return position+1;});};$scope.locationMoved=function(index){$scope.model.isInitialized=false;$scope.model.routeStopList.splice(index,1);refreshSequenceInputs();setMarkers($scope.model.routeStopList);};var moveStopToIndex=function moveStopToIndex(index,targetIndex){var list=$scope.model.routeStopList;if(targetIndex<0||targetIndex>=list.length||targetIndex===index){return refreshSequenceInputs();}$scope.model.isInitialized=false;list.splice(targetIndex,0,list.splice(index,1)[0]);refreshSequenceInputs();setMarkers(list);};$scope.moveStop=function(index,offset){moveStopToIndex(index,index+offset);};$scope.sequenceTyped=function(index){var typed=$scope.model.sequenceInput[index];if(!angular.isNumber(typed)||isNaN(typed))return refreshSequenceInputs();moveStopToIndex(index,Math.round(typed)-1);};$scope.autoOptimizeRouteStop=function(){$scope.loading=true;$scope.model.isInitialized=true;var routeDate=moment($scope.model.vaultDate).format('YYYY-MM-DD');RouteStopService.autoOptimizeRouteStops(routeDate,$scope.model.route).then(function(data){$scope.loadRouteStop();// refresh data after route stop optimized
}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}console.log(err);}).finally(function(){$scope.loading=false;});};// Add branch, truck and user details marker on map
$scope.addBranchDetails=function(){var locationLat=void 0,locationLong=void 0,iconNumber=void 0,iconColor=void 0,locationInfo=void 0;var truckCoordinatesInfo=$scope.model.truckCoordinatesInfo&&$scope.model.truckCoordinatesInfo[0]||{};var userCoordinatesInfo=$scope.model.userCoordinatesInfo&&$scope.model.userCoordinatesInfo[0]||{};var isUserOriginMismatch=userCoordinatesInfo.id&&userCoordinatesInfo.userOrigin&&userCoordinatesInfo.userOrigin!=='USER';if(truckCoordinatesInfo.id){locationLat=truckCoordinatesInfo.lat;locationLong=truckCoordinatesInfo.long;iconNumber='T';iconColor='black';locationInfo='<strong>'+truckCoordinatesInfo.id+'</strong><br>'+truckCoordinatesInfo.address+' - '+truckCoordinatesInfo.zip+'<br>'+truckCoordinatesInfo.city+', '+truckCoordinatesInfo.state;}else if(userCoordinatesInfo.id&&!isUserOriginMismatch){locationLat=userCoordinatesInfo.lat;locationLong=userCoordinatesInfo.long;iconNumber='U';iconColor='black';locationInfo='<strong>'+userCoordinatesInfo.id+'</strong><br>'+userCoordinatesInfo.address+' - '+userCoordinatesInfo.zip+'<br>'+userCoordinatesInfo.city+', '+userCoordinatesInfo.state;}else if($scope.model.branchInfo){locationLat=$scope.model.branchInfo.gpsLat;locationLong=$scope.model.branchInfo.gpsLong;iconNumber='B';iconColor='black';locationInfo='<strong>'+$scope.model.branchInfo.branchId+'</strong><br>'+$scope.model.branchInfo.address+' - '+$scope.model.branchInfo.zip+'<br>'+$scope.model.branchInfo.city+', '+$scope.model.branchInfo.state;}if(locationLat&&locationLong){var id=L.marker([locationLat,locationLong],{icon:new L.AwesomeNumberMarkers({number:iconNumber,markerColor:iconColor})}).addTo($scope.map).bindPopup(locationInfo);id.on('mouseover',function(){id.openPopup();});id.on('mouseout',function(){id.closePopup();});}};$scope.fixLocationGeoCode=function(){$scope.model.updatingLocGeoCode=true;LocationService.fixGeocoding($scope.model.branchId,$scope.locationIds).then(function(){$scope.loadRouteStop();}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.updatingLocGeoCode=false;});};$scope.ok=function(){callback({modal:routeSequenceModal,routeSequence:$scope.model.routeStopList});};$scope.cancel=function(){routeSequenceModal.close();};init();}]});};var remainingResiduals=function remainingResiduals(residualShipments,locationId,branch,callback,negative){var remainingResidualModal=$uibModal.open({template:_remainingResidual2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','$q','$translate','DataCounter','$state','DateUtil','AtmResidualService','CommonLayoutService','Navigation',function($scope,$q,$translate,DataCounter,$state,DateUtil,AtmResidualService,CommonLayoutService,Navigation){$scope.model={shipment:'',locationId:'',sortColumn:"vaultDate",reverseSort:false,routeList:[],route:null,messengerIdList:[],messengerId:null,customerList:[],selectedCustomers:[],vaultDate:null,branchId:branch,amount:0};$scope.exportLoading=false;$scope.dateOptions={showWeeks:false};var init=function init(){$scope.model.shipment=residualShipments.result;$scope.model.amount=residualShipments.amount;$scope.model.locationId=locationId;$scope.model.routeList=$scope.getRoutes();$scope.model.messengerIdList=$scope.getMessengerIds();$scope.model.customerList=$scope.getCustomers();$scope.model.selectedCustomers=$scope.model.customerList.slice();};$scope.getOrderType=function(shiptype,type){if(shiptype=="C"&&type!==null){return $translate.instant('atm_residual.order_type_'+type);}else if(shiptype=="C"&&type==null){return shiptype.toUpperCase();}else{return shiptype.toUpperCase();}};$scope.maskingString=function(trackingId){return CommonLayoutService.maskingString(trackingId);};$scope.scanBagId=function(trackingId){callback({modal:remainingResidualModal,trackingId:trackingId});remainingResidualModal.close();};$scope.goToRouteTab=function(data){remainingResidualModal.close();var obj={routeId:data.routeId,vaultDate:data.vaultDate,isRedirected:true};DataCounter.setData(obj);$state.go('branchManagement.routes');};$scope.goToUserTab=function(messengerId){if(!messengerId)return;Navigation.goToUserTab(messengerId,remainingResidualModal);};$scope.goToCustomerTab=function(customerId){if(!customerId)return;remainingResidualModal.close();$state.go('customer.edit',{id:customerId});};$scope.sortData=function(column){// if(column=='type'){
$scope.model.shipment.forEach(function(s){s.type=$scope.getOrderType(s.shiptype,s.orderType);});// }
$scope.model.reverseSort=$scope.model.sortColumn==column?!$scope.model.reverseSort:false;$scope.model.sortColumn=column;};$scope.goToServiceHistory=function(data){remainingResidualModal.close();var obj={locationId:data.fromLocationId,vaultDate:null,isRedirected:true};DataCounter.setData(obj);$state.go('branchManagement.locations');};$scope.goToOrderHistory=function(data){remainingResidualModal.close();var obj={orderNo:data.orderNo,vaultDate:data.vaultDate,isRedirected:true,isInProcess:true,fundingSourceId:$scope.model.locationId.Id};DataCounter.setData(obj);$state.go('branchManagement.orders');};$scope.cancel=function(){negative({modal:remainingResidualModal});};$scope.getRoutes=function(){var grouped=_.groupBy($scope.model.shipment,'routeId');return(0,_keys2.default)(grouped);;};$scope.getMessengerIds=function(){var path='messengerId';var grouped=_($scope.model.shipment).filter(function(object){return!!object[path];}).groupBy(path).value();return(0,_keys2.default)(grouped);};$scope.getCustomers=function(){var grouped=_.groupBy($scope.model.shipment.filter(function(row){return row.customerId;}),'customerId');var list=(0,_keys2.default)(grouped).map(function(key){var row=grouped[key][0];return{customerId:row.customerId,customerName:row.customerName,customerLabel:row.customerId+' | '+row.customerName,ticked:true};});return _.sortBy(list,'customerLabel');};$scope.selectAllCustomers=function(){$scope.model.customerList.forEach(function(c){return c.ticked=true;});$scope.model.selectedCustomers=$scope.model.customerList.slice();};$scope.selectNoCustomers=function(){$scope.model.customerList.forEach(function(c){return c.ticked=false;});$scope.model.selectedCustomers=[];};function filterByRouteId(row){if($scope.model.route)return row['routeId']&&row['routeId'].indexOf($scope.model.route)>-1;else return row;}function filterByMessengerId(row){if($scope.model.messengerId)return row['messengerId']&&row['messengerId']==$scope.model.messengerId;// && row['messengerId'].indexOf($scope.model.messengerId) > -1
else return row;}function filterByVaultDate(row){if($scope.model.vaultDate){var date=moment($scope.model.vaultDate).format('YYYY-MM-DD');return row['vaultDate']&&moment.utc(row['vaultDate']).format('YYYY-MM-DD')==date;}return row;}function getTickedCustomers(){return $scope.model.customerList.filter(function(c){return c.ticked;});}function filterByCustomer(row){var selected=getTickedCustomers();if(!selected.length)return true;return selected.some(function(c){return c.customerId===row['customerId'];});}$scope.filterData=function(){return function(row){return filterByRouteId(row)&&filterByMessengerId(row)&&filterByVaultDate(row)&&filterByCustomer(row);};};$scope.hasFilteredData=function(){return $scope.model.shipment.some($scope.filterData());};$scope.exportRemainingResiduals=function(){if($scope.exportLoading)return;$scope.exportLoading=true;var date=$scope.model.vaultDate?moment($scope.model.vaultDate).format('YYYY-MM-DD'):null;var tickedCustomers=getTickedCustomers();var customerIds=tickedCustomers.length?tickedCustomers.map(function(c){return c.customerId;}):null;AtmResidualService.exportRemainingResiduals($scope.model.route,date,$scope.model.messengerId,locationId.Id,branch,customerIds).then(function(result){$scope.exportLoading=false;if(result.reportData&&result.reportData.length){$scope.downloadFile('Remaining_Residual_'+' '+locationId.Value,result.reportData);}}).catch(function(err){$scope.exportLoading=false;console.log(err);});};$scope.downloadFile=function(filename,reportData){var fileName=filename.concat('.csv');var a=document.createElement("a");document.body.appendChild(a);var file=new Blob([reportData],{type:'application/csv'});var fileURL=window.URL.createObjectURL(file);a.href=fileURL;a.download=fileName;a.click();};$scope.generatePrint=function(){var shipments=$scope.model.shipment.filter(function(row){return filterByRouteId(row)&&filterByMessengerId(row)&&filterByVaultDate(row)&&filterByCustomer(row);});var obj={route:$scope.model.route,branchId:$scope.model.branchId,fundingSource:$scope.model.locationId.Key,pendingATMResiduals:shipments,//$scope.model.route ? $scope.model.shipment.filter(shp => shp.routeId === $scope.model.route) : $scope.model.shipment,
doPrint:true,amount:$scope.model.amount};obj.pendingATMResiduals=$scope.sortByKey(obj.pendingATMResiduals,$scope.model.sortColumn);var path=$state.href('atmCountPrint');window.w=window.open(path,'_blank');window.w.printData=obj;};$scope.sortByKey=function(array,key){var order=$scope.model.reverseSort?'desc':'asc';return _.orderBy(array,[key],[order]);};init();}]});};// let remainingToThrow = (routeId, vaultDate, branchId, isCoinCheckOut, callback, negative) => {
var remainingToThrow=function remainingToThrow(routeId,formattedDate,vaultDate,branchId,isCoinCheckOut,callback,negative){var remainingToThrowModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_remainingToThrow2.default,size:'md',controller:['$scope','$translate','ShipmentService','$q','$location','DataCounter','Navigation',function($scope,$translate,ShipmentService,$q,$location,DataCounter,Navigation){$scope.model={remainingToThrow:[],routeId:routeId,loading:false,isCoinCheckOut:isCoinCheckOut};var init=function init(){$scope.model.loading=true;ShipmentService.remainingToThrowShipments(routeId,formattedDate,branchId,isCoinCheckOut).then(function(data){$scope.model.loading=false;$scope.model.remainingToThrow=data.results;}).catch(function(err){console.log(err);});};// redirect to route throw screen
$scope.redirectToRouteThrow=function(){remainingToThrowModal.close();var data={vaultDate:vaultDate,isRedirected:true};DataCounter.setData(data);$location.url('/app/route-throw');};$scope.cancel=function(){remainingToThrowModal.close();};$scope.ok=function(){callback({modal:remainingToThrowModal});modal.close();};$scope.goToItemHistory=function(trackingId){return Navigation.goToItemHistory(trackingId,remainingToThrowModal);};init();}]});};var routeCheckoutInfo=function routeCheckoutInfo(isShpCheckedOut,routeId,vaultDate,branchId,remainingToCheckedout,field,isCoinVerified,status,callback){var routeCheckoutInfoModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_routeCheckoutInfo2.default,size:'lg',controller:['$scope','$translate','ShipmentService',function($scope,$translate,ShipmentService){$scope.model={loading:false,isShpCheckedOut:isShpCheckedOut,routeId:routeId,shipmentInfo:[],field:field,isCoinVerified:isCoinVerified,status:status};if($scope.model.isShpCheckedOut){$scope.shipmentSearchObj=function(){var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:branchId},{field:'routeId',condition:'=',data:$scope.model.routeId},{field:'vaultDate',condition:'=',data:vaultDate},{field:'checkedOut',condition:'=',data:$scope.model.isShpCheckedOut},{field:'deleted',condition:'=',data:false},{field:'bagSeal',condition:'=',data:null}],operator:'AND'}};if($scope.model.field){searchObj.queryJSON.rules.push({field:'coinFlag',condition:'=',data:$scope.model.field==='cash'?false:true});}return searchObj.queryJSON.rules.length?searchObj:null;};}var init=function init(){if($scope.model.isShpCheckedOut){$scope.model.loading=true;var searchObj=$scope.shipmentSearchObj();ShipmentService.all(searchObj,0,1000).then(function(data){$scope.model.loading=false;$scope.model.shipmentInfo=data.results;}).catch(function(err){console.log(err);});}else{if($scope.model.field){remainingToCheckedout.filter(function(data){if(data.coinFlag&&$scope.model.field==='coin'&&!$scope.model.isCoinVerified&&$scope.model.status=='remaining')$scope.model.shipmentInfo.push(data);else if(data.coinFlag&&$scope.model.field==='coin'&&$scope.model.isCoinVerified&&$scope.model.status=='completed')$scope.model.shipmentInfo.push(data);else if(!data.coinFlag&&$scope.model.field==='cash'&&['E_DELIVERY_NOT_ON_HOLD'].includes(data.message))$scope.model.shipmentInfo.push(data);});}else $scope.model.shipmentInfo=remainingToCheckedout.filter(function(record){return record.message==='E_DELIVERY_NOT_ON_HOLD';});}};$scope.cancel=function(){routeCheckoutInfoModal.close();};$scope.ok=function(){callback({modal:routeCheckoutInfoModal});modal.close();};init();}]});};var routeCheckinInfo=function routeCheckinInfo(isShpCheckedIn,routeId,vaultDate,branchId,remainingToCheckin,callback,negative){var routeCheckinInfoModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_routeCheckinInfo2.default,size:'md',controller:['$scope','$translate','ShipmentService',function($scope,$translate,ShipmentService){$scope.model={loading:false,isShpCheckedIn:isShpCheckedIn,routeId:routeId,shipmentInfo:[]};if($scope.model.isShpCheckedIn){$scope.shipmentSearchObj=function(){var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:branchId},{field:'bagSeal',condition:'=',data:null},{field:'routeId',condition:'=',data:$scope.model.routeId},{field:'vaultDate',condition:'=',data:vaultDate},{field:'checkedIn',condition:'=',data:$scope.model.isShpCheckedIn},{field:'deleted',condition:'=',data:false}],operator:'AND'}};return searchObj.queryJSON.rules.length?searchObj:null;};}var init=function init(){if($scope.model.isShpCheckedIn){$scope.model.loading=true;var searchObj=$scope.shipmentSearchObj();ShipmentService.all(searchObj,0,1000).then(function(data){$scope.model.loading=false;$scope.model.shipmentInfo=data.results;}).catch(function(err){console.log(err);});}else{$scope.model.shipmentInfo=remainingToCheckin;}};$scope.cancel=function(){routeCheckinInfoModal.close();};$scope.ok=function(){callback({modal:routeCheckinInfoModal});modal.close();};init();}]});};var remainingToPack=function remainingToPack(routeId,vaultDate,branchId,isCoinCheckOut,callback,negative){var remainingToPackModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_pendingPack2.default,size:'md',controller:['$scope','$translate','ShipmentService','$q','$location','$rootScope','DataCounter',function($scope,$translate,ShipmentService,$q,$location,$rootScope,DataCounter){$scope.model={pendingPack:[],routeId:routeId,loading:false};var init=function init(){$scope.model.loading=true;ShipmentService.remainingToPackShipments(routeId,vaultDate,branchId,isCoinCheckOut).then(function(data){$scope.model.loading=false;$scope.model.pendingPack=data.results;}).catch(function(err){console.log(err);});};$scope.redirectToOrderPack=function(){remainingToPackModal.close();var data={routeId:$scope.model.routeId,vaultDate:vaultDate,locationId:$scope.model.pendingPack[0].fromLocationId,isRedirected:true};DataCounter.setPendingPackData(data);$location.url('/app/order-packing');};$scope.cancel=function(){remainingToPackModal.close();};$scope.ok=function(){callback({modal:remainingToPackModal});modal.close();};init();}]});};var branchTransferModal=function branchTransferModal(shipmentData,callback,negative){var branchTransfer=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_branchTransfer2.default,size:'md',controller:['$scope','$translate','ShipmentService','BranchService','SetupService','RouteService',function($scope,$translate,ShipmentService,BranchService,SetupService,RouteService){$scope.model={selectedBranch:null,allBranch:[],trackingId:'',comment:'',loading:false,loadingRoutes:false,shipmentData:shipmentData,date:null,vaultDate:null,routeId:null,routeList:[],sameTransferError:false,dateOptions:{minDate:new Date()},isGettingRoutes:false,isGettingLocationRoutes:false,isInitializing:false,routeTotalRecords:0,routeOffset:0,routeSearchKey:''};var formatDate=function formatDate(d){if(!d)return null;return typeof d==='string'?moment.utc(d).format('YYYY-MM-DD'):moment(d).format('YYYY-MM-DD');};var init=function init(){$scope.model.loading=true;BranchService.all(null,0,100).then(function(data){$scope.model.loading=false;$scope.model.allBranch=data.results;}).catch(function(err){console.log(err);});};$scope.mappingData=function(arr,label,value){return arr.map(function(item){var arrayObject={Key:(item[value]||item.routeId||item.id)+" | "+(item[label]||item.routeName||item.name),Value:item[value]||item.routeId||item.id,dataObj:item};return arrayObject;});};$scope.getActiveRoutes=function(searchKey,offset){searchKey=searchKey||"";$scope.model.isGettingRoutes=true;return RouteService.getAvailableRoutes($scope.model.selectedBranch,formatDate($scope.model.vaultDate),offset,20,searchKey).then(function(res){var routes=$scope.mappingData(res.results,"name","id");if(offset===0||offset===undefined){$scope.model.routeList=routes;$scope.model.routeTotalRecords=res.total;}else{$scope.model.routeList=$scope.model.routeList.concat(routes);}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.isGettingRoutes=false;});};$scope.reloadRouteData=function(searchKey,offset){$scope.model.routeOffset=offset;$scope.model.routeSearchKey=searchKey;$scope.getActiveRoutes(searchKey,offset);};$scope.onBranchChange=function(){$scope.model.loading=true;$scope.model.date=null;$scope.model.vaultDate=null;$scope.model.routeId=null;$scope.model.routeList=[];$scope.model.sameTransferError=false;$scope.model.isGettingRoutes=false;$scope.model.isGettingLocationRoutes=false;$scope.model.isInitializing=false;if($scope.model.selectedBranch){SetupService.get($scope.model.selectedBranch).then(function(setup){if(setup&&setup.currentVaultDate){var utcMoment=moment.utc(setup.currentVaultDate);var dateObj=new Date(utcMoment.year(),utcMoment.month(),utcMoment.date(),0,0,0,0);$scope.model.date=dateObj;$scope.model.vaultDate=dateObj;$scope.minVaultDate={minDate:dateObj};$scope.model.minVaultDate=$scope.minVaultDate;$scope.model.isInitializing=true;$scope.onVaultDateChange();}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});}else{$scope.model.loading=false;}};var lastVaultDate=null;$scope.onVaultDateChange=function(){var currentDate=$scope.model.date?moment($scope.model.date).format('YYYY-MM-DD'):null;if(currentDate&&currentDate===lastVaultDate)return;lastVaultDate=currentDate;$scope.model.routeId=null;$scope.model.sameTransferError=false;if($scope.model.date){$scope.model.vaultDate=$scope.model.date;$scope.getActiveRoutes("",0);}};$scope.validateTransfer=function(){var sd=shipmentData;var selectedDate=$scope.model.vaultDate?formatDate($scope.model.vaultDate):null;var currentDate=sd.date?formatDate(sd.date):sd.vaultDate?formatDate(sd.vaultDate):null;var selectedRouteId=$scope.model.routeId?$scope.model.routeId.Value||$scope.model.routeId:null;$scope.model.sameTransferError=$scope.model.selectedBranch==sd.branchId&&selectedDate===currentDate&&selectedRouteId===sd.routeId;};$scope.$watchGroup(['model.selectedBranch','model.vaultDate','model.routeId'],function(){$scope.validateTransfer();});$scope.cancel=function(){branchTransfer.close();};$scope.ok=function(){var destRouteId=$scope.model.routeId?$scope.model.routeId.Value||$scope.model.routeId:null;confirmSupervisor('shipment-branch-transfer',{trackingId:$scope.model.shipmentData.trackingId},function(_ref55){var modal=_ref55.modal,supId=_ref55.supId;callback({modal:branchTransfer,selectedBranch:$scope.model.selectedBranch,selectedDate:formatDate($scope.model.vaultDate),selectedRoute:destRouteId,comment:$scope.model.comment||null,fromBranchId:$scope.model.shipmentData.branchId,supervisorId:supId});modal.close();},function(_ref56){var modal=_ref56.modal;modal.close();});};init();}]});};var internalDeliveryModal=function internalDeliveryModal(shipmentData,callback,negative){var internalDelivery=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_internalDelivery2.default,size:'md',controller:['$scope','$translate','ShipmentService','LocationService','User',function($scope,$translate,ShipmentService,LocationService,User){$scope.model={branch:User.getUser().branchId,locations:[],comment:'',totalLocation:0,shipmentData:shipmentData,location:''};$scope.locationSearchObj=function(searchKey){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branch},{field:"active",condition:"=",data:true},{group:{rules:[{field:"locationType",condition:"=",data:'BANK'},{field:"locationType",condition:"=",data:'REGULAR'},{field:"locationType",condition:"=",data:'ATM'},{field:"locationType",condition:"=",data:'INTERNAL'},{field:"locationType",condition:"=",data:'ON_CALL'},{field:"locationType",condition:"=",data:'DELIVERY'},{field:"locationType",condition:"=",data:'NO_SHIP_NO_GO'}],operator:'OR'}},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:"AND"}};return searchObj.queryJSON.rules.length?searchObj:null;};$scope.mappingLocations=function(locations){return locations.map(function(data){return{Key:data.id+" | "+data.name,Value:data.id};});};var init=function init(){$scope.model.loading=true;$scope.loadInternalLocations('',0);};$scope.loadInternalLocations=function(searchKey,offset){var searchObj=$scope.locationSearchObj(searchKey);LocationService.all(searchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.totalLocation=data.total;$scope.model.locations=$scope.mappingLocations(data.results);}else{var Locations=$scope.mappingLocations(data.results);$scope.model.locations=$scope.model.locations.concat(Locations);}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.cancel=function(){internalDelivery.close();};$scope.ok=function(){confirmSupervisor('internal-delivery',{trackingId:$scope.model.shipmentData.trackingId},function(_ref57){var model=_ref57.model,supId=_ref57.supId;callback({modal:internalDelivery,comment:$scope.model.comment||null,locationId:$scope.model.location.Value,supervisorId:supId});modal.close();},function(_ref58){var modal=_ref58.modal;modal.close();});};init();}]});};var editTrackingIdModal=function editTrackingIdModal(trackingId,callback,negative){var editTrackingId=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_editTrackingId2.default,size:'md',controller:['$scope','$translate','ShipmentService',function($scope,$translate,ScanService){$scope.model={trackingId:trackingId,oldTrackingId:trackingId,comment:''};var init=function init(){};$scope.cancel=function(){editTrackingId.close();};$scope.ok=function(){confirmSupervisor('update-shipment-trackingId',{trackingId:$scope.model.trackingId},function(_ref59){var modal=_ref59.modal,supId=_ref59.supId;callback({modal:editTrackingId,trackingId:$scope.model.trackingId,comment:$scope.model.comment,supervisorId:supId});modal.close();},function(_ref60){var modal=_ref60.modal;modal.close();});};init();}]});};// let createCompanyModal = (callback, negative) => {
//   let createCompany = $uibModal.open({
//     animation: true,
//     ariaLabelledBy: 'modal-title-top',
//     ariaDescribedBy: 'modal-body-top',
//     backdrop: 'static',
//     template: createCompanyTemplate,
//     size: 'md',
//     controller: ['$scope', '$translate', ($scope, $translate) => {
//       $scope.modes = [
//         {
//           label: 'Route',
//           value: 'Route'
//         },
//         {
//           label: 'FLM',
//           value: 'FLM'
//         },
//       ]
//       $scope.model = {
//         status: true,
//         mode: $scope.modes[0].value
//       }
//       $scope.toggleSwitchUI = {
//         size: 'small',
//         label: {
//           on: $translate.instant('common.yes'),
//           off: $translate.instant('common.no'),
//         },
//         onColor: 'success',
//         offColor: 'danger'
//       }
//       const init = () => {
//       }
//       $scope.cancel = () => {
//         createCompany.close()
//       }
//       $scope.ok = () => {
//         callback({
//           modal: createCompany
//         });
//         modal.close()
//       }
//     }]
//   })
// }
var depositPackingInfoModal=function depositPackingInfoModal(data,callback,negative){var depositPackingInfo=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_depositPackingInfo2.default,size:'md',controller:['$scope','$translate','Modal','AtmResidualDepositService','Navigation',function($scope,$translate,Modal,AtmResidualDepositService,Navigation){$scope.model={trackingId:data.trackingId,contents:[]};$scope.pagination={page:1,total:0,pageLimit:10,maxPages:10};var init=function init(){$scope.loadContents();};$scope.loadContents=function(){$scope.model.loading=true;AtmResidualDepositService.contents(data.id,$scope.pagination.pageLimit,($scope.pagination.page-1)*$scope.pagination.pageLimit).then(function(res){$scope.model.loading=false;$scope.model.contents=res;}).catch(function(err){if(err&&err.data&&err.data.message){return Modal.errorModal(err.data.message);}});};$scope.cancel=function(){depositPackingInfo.close();};$scope.ok=function(){callback({modal:depositPackingInfo});modal.close();};$scope.pageChange=function(){$scope.loadContents();};$scope.goToItemHistory=function(trackingId){Navigation.goToItemHistory(trackingId,depositPackingInfo);};$scope.goToServiceHistory=function(data){Navigation.goToServiceHistory(data.locationId,null,true,depositPackingInfo);};init();}]});rejectModal(depositPackingInfo,negative);};var lockStatusModal=function lockStatusModal(routeId,branch,date,isAutoOpenATMs,messengerId,callback,negative){var lockStatus=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_lockStatus2.default,size:'lg',controller:['$scope','$translate','AtmCodesManagementService','Modal','$q','UsersService',function($scope,$translate,AtmCodesManagementService,Modal,$q,UsersService){$scope.model={routeId:routeId,branch:branch,date:date,isAutoOpenATMs:isAutoOpenATMs,lockStatusData:[],messengerId:messengerId,userData:""};var init=function init(){$scope.model.loading=true;$q.all([$scope.getUser(),AtmCodesManagementService.getLockStatus($scope.model.routeId,$scope.model.branch,$scope.model.date,$scope.model.isAutoOpenATMs)]).then(function(res){$scope.model.lockStatusData=res[1].results;}).catch(function(err){console.log(err);if(err&&err.data&&err.data.message){return Modal.errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.getUser=function(){if($scope.model.messengerId){UsersService.get($scope.model.messengerId).then(function(res){$scope.model.userData=res;}).catch(function(err){console.log(err);});}};$scope.cancel=function(){lockStatus.close();};$scope.ok=function(){};init();}]});};var ledgerTransactionLogModal=function ledgerTransactionLogModal(data,callback,negative){var ledgerTransactionLog=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_ledgerTransactionLog2.default,size:'lg',controller:['$scope','BulkCashService','Modal','$translate','DataCounter','$state','Navigation',function($scope,BulkCashService,Modal,$translate,DataCounter,$state,Navigation){$scope.model={loading:false,transactionData:data,logs:[],vaultDate:'',ledgerEntry:{},isValid:false};var init=function init(){$scope.model.loading=true;$scope.modifyString($scope.model.transactionData.comment);BulkCashService.ledgerTransactionLog(data.id,data.branchId).then(function(data){$scope.model.logs=data;$scope.model.vaultDate=moment.utc(data.ledgerTransaction.vaultDate).format('YYYY-MM-DD');$scope.model.ledgerEntry=_.find($scope.model.logs.results,{'denominationId':null});}).catch(function(err){if(err&&err.data&&err.data.message){return Modal.errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.goToOrderHistory=function(data){ledgerTransactionLog.close();var obj={orderNo:data.orderNo,vaultDate:data.vaultDate,isRedirected:true,isInProcess:true,fundingSourceId:$scope.model.transactionData.branchFundingSourceId};DataCounter.setData(obj);$state.go('branchManagement.orders');};$scope.modifyString=function(data){if(data){$scope.model.isValid=data.startsWith('Residual count:');if($scope.model.isValid){$scope.splitString=data.split(',');$scope.trackingId=$scope.splitString[0].split(':')[1].trim();}}};$scope.goToAtmCount=function(){return Navigation.goToAtmCount($scope.trackingId,true,ledgerTransactionLog,$scope.model.transactionData.branchFundingSourceId);};$scope.cancel=function(){ledgerTransactionLog.close();};init();}]});};var atmCodesInfoModal=function atmCodesInfoModal(cacheKey,callback,negative){var atmCodesInfo=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_atmCodesInfo2.default,size:'md',controller:['$scope','ResetAtmCodeService',function($scope,ResetAtmCodeService){$scope.model={cacheKey:cacheKey,loading:false,atmCodeValue:''};var init=function init(){$scope.model.loading=true;ResetAtmCodeService.getAtmCode($scope.model.cacheKey).then(function(data){$scope.model.atmCodeValue=data.results;}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.cancel=function(){atmCodesInfo.close();};init();}]});};var moveShipmentModal=function moveShipmentModal(data,branchId,callback,negative){var moveShipment=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_moveShipment2.default,size:'md',controller:['$scope','RouteService','SetupService','$q','DateUtil',function($scope,RouteService,SetupService,$q,DateUtil){$scope.model={branch:branchId,totalRecord:0,allRoutes:[],date:'',route:'',shipmentData:data};$scope.pagination={page:1,total:0,pageLimit:10,maxPages:10};var init=function init(){$q.all([SetupService.get($scope.model.branch),$scope.loadRoutes('',0)]).then(function(data){var date=DateUtil.convertToDate(data[0].currentVaultDate);$scope.model.date=date;$scope.vaultDate=moment($scope.model.date).format('YYYY-MM-DD');$scope.minVaultDate={minDate:$scope.vaultDate};});};$scope.loadRoutes=function(searchKey,offset){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.branch},{group:{rules:[{field:"id",condition:"like",data:"%"+searchKey+"%"},{field:"name",condition:"like",data:"%"+searchKey+"%"}],operator:"OR"}}],operator:'AND'}};RouteService.all(searchObj,offset,$scope.pagination.pageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.totalRecord=data.total;$scope.model.allRoutes=$scope.mapData(data.results);}else{var routes=$scope.mapData(data.results);$scope.model.allRoutes=$scope.model.allRoutes.concat(routes);}}).catch(function(err){console.log(err);});};$scope.mapData=function(routes){return routes.map(function(route){return{Key:route.id+' | '+route.name,Value:route.id};});};$scope.ok=function(){callback({modal:moveShipment,toRoute:$scope.model.route,date:moment($scope.model.date).format('YYYY-MM-DD')});moveShipment.close();};$scope.ok=function(){confirmSupervisor('move-shipment',function(_ref61){var modal=_ref61.modal,supId=_ref61.supId;callback({modal:moveShipment,toRoute:$scope.model.route,date:moment($scope.model.date).format('YYYY-MM-DD'),supervisorId:supId});modal.close();},function(_ref62){var modal=_ref62.modal;modal.close();});};$scope.cancel=function(){moveShipment.close();};init();}]});};var updateShipmentTrackingId=function updateShipmentTrackingId(oldTrackingId,supervisorScan,_callback3,customerId,negative){var updateTrackingId=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_updateShipmentTrackingId2.default,size:'md',controller:['$scope','ShipmentService',function($scope,ShipmentService){$scope.model={oldTrackingId:oldTrackingId,newTrackingId:'',isDuplicate:false,allowSupervisorScan:supervisorScan,customerId:customerId};var init=function init(){focusElementById('new-tracking-id');};$scope.assertTrackingId=function(){if(($scope.model.newTrackingId&&$scope.model.newTrackingId.toUpperCase())===$scope.model.oldTrackingId.toUpperCase()){$scope.model.isDuplicate=true;}else{$scope.model.isDuplicate=false;}};$scope.ok=function(){if($scope.model.customerId){confirm({header:$translate.instant('common.confirm_title'),message:'Are you sure you want to change the Tracking ID?',callback:function callback(_ref63){var modal=_ref63.modal;_callback3({modal:updateTrackingId,newTrackingId:$scope.model.newTrackingId,supervisorId:null});modal.close();},negative:function negative(_ref64){var modal=_ref64.modal;modal.close();},type:'success'});}else{verifySupervisorScan('update-shipment-trackingId',{trackingId:$scope.model.newTrackingId},$scope).then(function(supervisorInfo){_callback3({modal:updateTrackingId,newTrackingId:$scope.model.newTrackingId,supervisorId:supervisorInfo?supervisorInfo.supId:null});if(supervisorInfo)supervisorInfo.modal.close();});}};$scope.cancel=function(){updateTrackingId.close();};init();}]});};var changeShiptypeId=function changeShiptypeId(shipmentData,customerId,_callback4,negative){var changeShiptypeId=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_changeShiptype2.default,size:'md',controller:['$scope','ShiptypeService','LocationService',function($scope,ShiptypeService,LocationService){$scope.model={shipmentData:shipmentData,shiptypeList:[],totalShiptypes:0,customerId:customerId};var init=function init(){$scope.model.loading=true;$scope.loadShipType('',0);};$scope.loadShipType=function(searchKey,offset){searchKey=searchKey||'';if($scope.model.customerId){return $scope.getDeliveryToLocationsAndShiptypes(searchKey,offset);}var shipTypeSearchObj={queryJSON:{rules:[{field:'status',condition:'=',data:true},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'description',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};return ShiptypeService.all(shipTypeSearchObj,offset,100).then(function(data){if(offset===0||offset==undefined){$scope.model.totalShiptypes=data.total;$scope.model.shiptypeList=$scope.shipTypeDataMapping(data.results);}else{var shipTypes=$scope.shipTypeDataMapping(data.results);$scope.model.shiptypeList=$scope.model.shiptypeList.concat(shipTypes);}if(!$scope.model.shiptype){$scope.model.shiptype=$scope.model.shiptypeList.find(function(item){return item.Key==$scope.model.shipmentData.shiptype;});}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.getDeliveryToLocationsAndShiptypes=function(searchKey,offset){LocationService.getDeliveryToLocationsAndShiptypes(shipmentData.toLocationId,searchKey).then(function(data){var shipTypes=data.results.shipTypeData;if(!offset||offset===0){var currentShipExists=shipTypes.find(function(d){return d.id===shipmentData.shiptypeId;});var totalShiptypes=data.totalRecords.shipTypeCount;if(!currentShipExists&&!searchKey){shipTypes.unshift({id:shipmentData.shiptype,description:shipmentData.shiptype});totalShiptypes++;}$scope.model.totalShiptypes=totalShiptypes;$scope.model.shiptypeList=$scope.shipTypeDataMapping(shipTypes);}else{var newShipTypes=$scope.shipTypeDataMapping(shipTypes);$scope.model.shiptypeList=$scope.model.shiptypeList.concat(newShipTypes);}if(!$scope.model.shiptype){$scope.model.shiptype=$scope.model.shiptypeList.find(function(item){return item.Key==$scope.model.shipmentData.shiptype;});}}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.shipTypeDataMapping=function(shipTypes){return shipTypes.map(function(shipType){return{Key:shipType.description,Value:shipType.id};});};$scope.cancel=function(){negative({modal:changeShiptypeId});};$scope.ok=function(){if($scope.model.customerId){confirm({header:$translate.instant('common.confirm_title'),message:'Are you sure you want to change the shiptype?',callback:function callback(_ref65){var modal=_ref65.modal;_callback4({modal:changeShiptypeId,shiptype:$scope.model.shiptype.Value,supervisorId:null});modal.close();},negative:function negative(_ref66){var modal=_ref66.modal;modal.close();},type:'success'});}else{confirmSupervisor('change-shiptype',{trackingId:$scope.model.shipmentData.trackingId},function(_ref67){var model=_ref67.model,supId=_ref67.supId;_callback4({modal:changeShiptypeId,shiptype:$scope.model.shiptype.Value,supervisorId:supId});modal.close();},function(_ref68){var modal=_ref68.modal;modal.close();});}};init();}]});rejectModal(changeShiptypeId,negative);};var autoOpenLocksModal=function autoOpenLocksModal(routeId,branchId,formattedDate,isAutoOpenATMs,messengerId,performedById,callback,negative){var autoOpenLocks=$uibModal.open({keyboard:false,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_autoOpenLocks2.default,size:'md',controller:['$scope','AtmCodesManagementService','Modal',function($scope,AtmCodesManagementService,Modal){$scope.model={routeId:routeId,branchId:branchId,isAutoOpenATMs:isAutoOpenATMs,messengerId:messengerId,performedById:performedById,autoOpenLocksResult:[],currentDate:moment.utc().format(),failedToOpen:0,totalOpened:0};var init=function init(){$scope.model.loading=true;AtmCodesManagementService.autoOpenLocks(routeId,branchId,formattedDate,isAutoOpenATMs,messengerId,performedById).then(function(res){$scope.model.autoOpenLocksResult=res.results;res.results.filter(function(lock){if(lock.result==1)$scope.model.failedToOpen++;if(lock.result==0)$scope.model.totalOpened++;});}).catch(function(err){if(err&&err.data&&err.data.message){return Modal.errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.removeCharacter=function(message){if(message)return AtmCodesManagementService.removeCharacter(message);};$scope.ok=function(){callback({modal:autoOpenLocks});autoOpenLocks.close();};$scope.cancel=function(){autoOpenLocks.close();};init();}]});};var markAsDelivered=function markAsDelivered(shipment,currentVaultDate,branchTimeZone,callback,negative){var markAsDeliveredModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_markAsDelivered2.default,size:'md',controller:['$scope','DateUtil',function($scope,DateUtil){$scope.model={shipment:shipment,loadedAmount:shipment.loadedAmount,date:'',vaultDate:currentVaultDate,comment:'',deliveryTime:'',branchTimeZone:branchTimeZone,amountExceeds:false// sendDeliveryReceipt: false
};var init=function init(){var time=moment($scope.model.shipment.deliveryDate).tz($scope.model.branchTimeZone).format('HH:mm:ss');var deliveryTime=moment.utc($scope.model.shipment.deliveryDate).format('HH:mm:ss');if(deliveryTime==='00:00:00'){$scope.model.time=null;$scope.model.date=moment($scope.model.shipment.deliveryDate,'YYYY-MM-DD').toDate();}else{$scope.model.time=DateUtil.getTime(time);var dateString=moment($scope.model.shipment.deliveryDate).tz($scope.model.branchTimeZone).format('YYYY-MM-DD');$scope.model.date=moment(dateString,'YYYY-MM-DD').toDate();}$scope.minVaultDate={maxDate:$scope.model.date};};$scope.getTime=function(time){if(!time){return time;}time=time.split(':');var d=new Date();d.setHours(+time[0]);d.setMinutes(time[1]);d.setSeconds(0);d.setMilliseconds(0);return d;};$scope.ok=function(){confirmSupervisor('mark-as-delivered',{trackingId:$scope.model.shipment.trackingId},function(_ref69){var modal=_ref69.modal,supId=_ref69.supId;callback({modal:markAsDeliveredModal,supervisorId:supId,comment:$scope.model.comment,loadedAmount:$scope.model.loadedAmount,date:moment($scope.model.date).format('YYYY-MM-DD'),time:moment($scope.model.time).format('HH:mm:ss')// sendDeliveryReceipt: $scope.model.sendDeliveryReceipt
});modal.close();},function(_ref70){var modal=_ref70.modal;modal.close();});};$scope.cancel=function(){negative({modal:markAsDeliveredModal});};$scope.validateLoadedAmount=function(){var loadShipmentAmount=$scope.model.shipment.amount;var loadedAmount=$scope.model.loadedAmount;if(loadedAmount>loadShipmentAmount)return $scope.model.amountExceeds=true;else $scope.model.amountExceeds=false;};init();}]});rejectModal(markAsDeliveredModal,negative);};var holdShipmentModal=function holdShipmentModal(routeId,vaultDate,branch,callback,negative){var holdShipment=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_holdShipmentList2.default,size:'md',controller:['$scope','HoldService','$state','Modal','Navigation',function($scope,HoldService,$state,Modal,Navigation){$scope.model={routeId:routeId,date:vaultDate,branchId:branch,holdShipments:[],loading:false};var init=function init(){$scope.model.loading=true;HoldService.holdShipmentList($scope.model.routeId,$scope.model.date,$scope.model.branchId).then(function(data){$scope.model.holdShipments=data.results;}).catch(function(err){Modal.errorModal(err.data.message);}).finally(function(){$scope.model.loading=false;});};$scope.ok=function(){callback({modal:holdShipment});modal.close();};$scope.redirectToHold=function(){return $state.go('branchManagement.itemHolds');};$scope.cancel=function(){holdShipment.close();};$scope.goToItemHistory=function(trackingId){return Navigation.goToItemHistory(trackingId,holdShipment);};init();}]});};var lastOrderDetails=function lastOrderDetails(shipment,fundingSourceId,callback,negative){var lastOrderDetailsModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_lastOrderInfo2.default,size:'lg',controller:['$scope','$translate','DataCounter','$state','OrderPackingService',function($scope,$translate,DataCounter,$state,OrderPackingService){$scope.model={lastOrderDetails:[],shipment:shipment,loading:false,fundingSourceId:fundingSourceId};var init=function init(){$scope.model.loading=true;OrderPackingService.getLastOrderInformation(shipment.toLocationId,null).then(function(data){$scope.model.lastOrderDetails=data.results;}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.goToOrderHistory=function(data){lastOrderDetailsModal.close();var obj={orderNo:data.orderNo,vaultDate:data.loadDeliveryDate,isRedirected:true,isCounted:data.residualIsCounted,isInProcess:!data.residualIsCounted,fundingSourceId:$scope.model.fundingSourceId};DataCounter.setData(obj);$state.go('branchManagement.orders');};$scope.cancel=function(){lastOrderDetailsModal.close();};$scope.ok=function(){callback({modal:lastOrderDetailsModal});modal.close();};init();}]});};var serviceOrderDetail=function serviceOrderDetail(data,callback,negative){var serviceOrderDetailModal=$uibModal.open({template:_serviceOrderDetails2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q','$translate','DateUtil','Navigation','User','UsersService',function($scope,$q,$translate,DateUtil,Navigation,User,UsersService){$scope.model={details:data,loggedInUser:User.getUser().id,currentBranch:User.getUser().branchId};var init=function init(){};$scope.convetToBrowserTimezone=function(date){return DateUtil.convetToBrowserTimezone(date);};$scope.redirectToServiceHistory=function(locationId){return Navigation.goToServiceHistory(locationId,null,true,serviceOrderDetailModal);};$scope.goToServiceHistory=function(){if($scope.model.currentBranch===$scope.model.details.branchId){$scope.redirectToServiceHistory($scope.model.details.locationId);}else{$scope.shiftBranch($scope.model.loggedInUser,$scope.model.details.branchId).then(function(){$scope.redirectToServiceHistory($scope.model.details.locationId);});}};$scope.shiftBranch=function(userId,branchId){var obj={id:userId,branchId:branchId};var defer=$q.defer();UsersService.updateUserBranch(obj.id,obj).then(function(data){User.setUser(data);defer.resolve();}).catch(function(err){err.data.errors.map(function(e){$scope.errorMessage+=e.message+'<br/>';});errorModal($scope.errorMessage);});return defer.promise;};$scope.cancel=function(){negative({modal:serviceOrderDetailModal});};init();}]});};var serviceOrderNotes=function serviceOrderNotes(data,serviceHistory,callback,negative){var serviceOrderNotesModal=$uibModal.open({template:_serviceOrderNotes2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q',function($scope,$q){$scope.model={details:data,systemNote:data.serviceOrderNote,serviceOrderUserNote:data.serviceOrderUserNote,serviceHistory:serviceHistory?angular.copy(serviceHistory.filter(function(h){return h.status;})):[]};$scope.getBucketName=function(status){switch(status){case'INCOMPLETED':return $translate.instant('serviceTickets.incomplete');case status:return $translate.instant('serviceTickets.status_'+status);default:return;}};var init=function init(){focusElementById('service-order-user-note');focusElementById('system-note');};$scope.cancel=function(){serviceOrderNotesModal.close();};$scope.ok=function(){callback({modal:serviceOrderNotesModal,$scope:$scope,serviceOrderNote:$scope.model.systemNote,serviceOrderUserNote:$scope.model.serviceOrderUserNote,serviceOrderUserNotes:$scope.model.serviceHistory.filter(function(h){return h.isEdited;}).map(function(h){return{id:h.id,note:h.serviceOrderStatusNote,status:h.status};})});};init();}]});};var undoPackedOrder=function undoPackedOrder(data,callback,negative){var undoPackedOrderModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_undoPackedOrder2.default,size:'md',controller:['$scope',function($scope){$scope.model={shipments:data,deleteOrder:false,deletedReason:null,loading:false};var init=function init(){};$scope.setFocus=function(){setTimeout(function(){if($scope.model.deleteOrder)focusElementById('deleted-reason');});};$scope.ok=function(){confirmSupervisor('order-packing-undo',{trackingId:$scope.model.shipments.trackingId},function(_ref71){var modal=_ref71.modal,supId=_ref71.supId;$scope.model.loading=true;callback({modal:undoPackedOrderModal,supervisorId:supId,deleteOrder:$scope.model.deleteOrder,deletedReason:$scope.model.reason||null,$scope:$scope});modal.close();},function(_ref72){var modal=_ref72.modal;modal.close();});};$scope.cancel=function(){negative({modal:undoPackedOrderModal});};init();}]});rejectModal(undoPackedOrderModal,negative);};var serviceOrderStatusUpdate=function serviceOrderStatusUpdate(data,allowSupervisorScan,customerId,userInfo,callback,negative){var serviceOrderStatusUpdateModal=$uibModal.open({template:_serviceOrderStatusUpdate2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q','$translate','User',function($scope,$q,$translate,User){$scope.model={details:data,note:data.serviceOrderUserNote,currentStatus:data.statusCode==='INCOMPLETED'?$translate.instant('serviceTickets.incomplete'):$translate.instant('serviceTickets.status_'+data.statusCode),newStatus:null,loading:false,allowSupervisorScan:allowSupervisorScan,userDetails:User.getUser(),customerId:customerId,statusList:[{label:'Complete',value:'COMPLETE'},{label:'Incomplete',value:'INCOMPLETED'},{label:'Cancelled',value:'CANCELLED'},{label:'Assigned',value:'ASSIGNED'},{label:'Unassigned',value:'UNASSIGNED'},{label:'On-Route',value:'ON_ROUTE'},{label:'On-Site',value:'ON_SITE'},{label:'Hold',value:'HOLD'},{label:'Hold-Parts',value:'HOLD_PARTS'}]};var init=function init(){if($scope.model.details.externalProcessorId&&!$scope.model.customerId){var status=['COMPLETE','INCOMPLETED','CANCELLED'];$scope.model.statusList=$scope.model.statusList.filter(function(s){return status.includes(s.value);});}else if($scope.model.customerId){var _status=['CANCELLED'];$scope.model.statusList=$scope.model.statusList.filter(function(s){return _status.includes(s.value);});}$scope.model.statusList=$scope.model.statusList.filter(function(data){return data.value!==$scope.model.details.statusCode;});};$scope.validateSupervisorScan=function(){if($scope.model.allowSupervisorScan){var errorMsg=$translate.instant('users.supervisor_scan_error',{firstName:$scope.model.userDetails.firstName,lastName:$scope.model.userDetails.lastName});return confirm({header:$translate.instant('errorModal.title'),message:$translate.instant(errorMsg),callback:function callback(_ref73){var modal=_ref73.modal;$scope.ok();modal.close();},type:'danger',buttons:['common.ok']});}else{$scope.ok();}};$scope.ok=function(){// confirmSupervisor('service-order-status-update', null, ({ modal, supId }) => {
// $scope.model.loading = true;
verifySupervisorScan('shipment-hold-convert-CRV',null,$scope).then(function(supervisorInfo){callback({modal:serviceOrderStatusUpdateModal,note:$scope.model.note,status:$scope.model.newStatus,supervisorId:supervisorInfo?supervisorInfo.supId:userInfo.customerUser?userInfo.id:null});// modal.close();
if(supervisorInfo)supervisorInfo.modal.close();// }, ({ modal }) => {
//   modal.close();
// })
});};$scope.cancel=function(){negative({modal:serviceOrderStatusUpdateModal});};init();}]});rejectModal(serviceOrderStatusUpdateModal,negative);};var serviceOrderAssign=function serviceOrderAssign(data,vaultDate,callback,negative){var serviceOrderAssignModal=$uibModal.open({template:_serviceOrderAssign2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q','ServiceOrderService',function($scope,$q,ServiceOrderService){$scope.model={details:data,// routeId: data.routeId,
statsObj:{route:'route',user:'user',external:'external'},stats:'route',routeList:[],vaultDate:vaultDate,// branchId: branchId,
formattedDate:'',routeStatusInfo:{},serviceOrderinfo:{},serviceUserList:[],serviceZoneUserList:[],// userId: data.userId,
loading:false,loadingRouteStatus:false,loadingServiceOrderDetails:false,updateInProcess:false,externalProcessorCode:null,serviceUserId:null};var init=function init(){$scope.model.formattedDate=moment($scope.model.vaultDate).format('YYYY-MM-DD');$scope.model.loading=true;if($scope.model.details.defaultServiceTicketAssignment==='EXTERNAL'&&!$scope.model.details.externalProcessorId&&$scope.model.details.statusCode!=='ACCEPTED'){$scope.model.stats=$scope.model.statsObj.route;}else if($scope.model.details.defaultServiceTicketAssignment){$scope.model.stats=$scope.model.details.defaultServiceTicketAssignment.toLowerCase();}$q.all([ServiceOrderService.branchActiveRouteAndServiceUser($scope.model.details.branchId,$scope.model.formattedDate,moment.tz.guess()),!$scope.model.details.externalProcessorId&&$scope.model.details.statusCode==='ACCEPTED'?$scope.externalProcessorCode():undefined]).then(function(data){$scope.model.routeList=data[0].results.routeList;$scope.model.serviceUserList=data[0].results.serviceUserList;$scope.model.serviceZoneUserList=data[0].results.serviceZoneUserList;$scope.model.routeId=$scope.model.details.routeId;if($scope.model.details.assignServiceZone){var user=_.find($scope.model.serviceZoneUserList,{'userId':$scope.model.details.userId});if(user)$scope.model.serviceZoneUserId=user.userId;else if(!user)$scope.model.serviceUserId=$scope.model.details.userId;}else{$scope.model.serviceUserId=$scope.model.details.userId;}// $scope.addServiceOrderRouteIdToList();
$scope.routeStatus();$scope.serviceOrderDetails();}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.tabSelection=function(selectedValue){$scope.model.stats=selectedValue;};$scope.routeStatus=function(){var route=$scope.model.routeList.find(function(data){return data['routeId']===$scope.model.routeId;});if(route){$scope.model.loadingRouteStatus=true;ServiceOrderService.getRouteStatus($scope.model.routeId,$scope.model.formattedDate).then(function(data){$scope.model.routeStatusInfo=data.results;}).catch(function(err){if(err&&err.data&&err.data.message){errorModal('error.'+err.data.message);}}).finally(function(){$scope.model.loadingRouteStatus=false;});}else{$scope.model.routeId=null;}};$scope.serviceOrderDetails=function(){var routeId=$scope.model.details.routeId;var branchId=$scope.model.details.branchId;var userId=$scope.model.serviceUserId?$scope.model.serviceUserId:$scope.model.serviceZoneUserId;if(userId){$scope.model.loadingServiceOrderDetails=true;ServiceOrderService.serviceOrderDetails(userId,routeId,branchId,$scope.model.formattedDate).then(function(data){$scope.model.serviceOrderinfo=data.results;}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.loadingServiceOrderDetails=false;});}else{$scope.model.serviceUserId=null;$scope.model.serviceZoneUserId=null;}};$scope.externalProcessorCode=function(){var branchId=$scope.model.details.branchId;$scope.model.loadingExternalProcessorCode=true;ServiceOrderService.getExternalProcessorCode(branchId).then(function(data){$scope.model.externalProcessorCodeList=data.results;}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.loadingExternalProcessorCode=false;});};$scope.addServiceOrderRouteIdToList=function(){var route=$scope.model.routeList.find(function(data){return data['routeId']===$scope.model.details.routeId;});// console.log("route", route);
if(!route){$scope.model.routeList.push({routeId:$scope.model.details.routeId,routeName:$scope.model.details.routeName,arrTime:null});}// console.log($scope.model.routeList);
};$scope.cancel=function(){negative({modal:serviceOrderAssignModal});};$scope.ok=function(){$scope.model.updateInProcess=true;callback({modal:serviceOrderAssignModal,routeId:$scope.model.routeId,userId:$scope.model.serviceUserId?$scope.model.serviceUserId:$scope.model.serviceZoneUserId,externalProcessorCode:$scope.model.externalProcessorCode,currentStats:$scope.model.stats});serviceOrderAssignModal.close();};$scope.resendServiceTicketAssignment=function(){$scope.model.isSendingNotification=true;ServiceOrderService.resendServiceTicketAssignment($scope.model.details.encounterId,$scope.model.details.branchCurrentVaultDate,$scope.model.serviceUserId?$scope.model.serviceUserId:$scope.model.serviceZoneUserId).then(function(){}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.isSendingNotification=false;});};init();}]});rejectModal(serviceOrderAssignModal,negative);};var createServiceTicket=function createServiceTicket(data,callback,negative){var serviceOrderCreateModal=$uibModal.open({template:_serviceOrderCreate2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','$q','ServiceOrderService','User','UserService','LocationService','ActionCodeService','CommonLayoutService','SetupService','BranchService',function($scope,$q,ServiceOrderService,User,UserService,LocationService,ActionCodeService,CommonLayoutService,SetupService,BranchService){$scope.branchList=[];$scope.totalLocation=0;$scope.locationList=[];$scope.actionCodeList=[];$scope.formSubmited=false;$scope.lockTypes=CommonLayoutService.lockTypes();$scope.stopPriorityList=CommonLayoutService.priorityList();$scope.requestedTimeframeOptions=[{label:'ASAP',value:'ASAP'},{label:'24 Hours',value:'24HR'},{label:'48 Hours',value:'48HR'},{label:'72 Hours',value:'72HR'},{label:'Scheduled',value:'SCHEDULED'}];$scope.scheduledPriorityValue='SCHEDULED';$scope.model={details:data,loading:false,customerId:data.customerId,billingReviewRequire:false,branchTimezone:null};// Assign permission check
var acl=User.getACL('service_tickets')||[];$scope.hasAssignPermission=acl.indexOf('assign')>-1;// Assign section state
$scope.assign={statsObj:{route:'route',user:'user',external:'external'},stats:'route',routeList:[],serviceUserList:[],serviceZoneUserList:[],externalProcessorCodeList:[],routeId:null,serviceUserId:null,serviceZoneUserId:null,externalProcessorCode:null,routeStatusInfo:null,serviceOrderinfo:null,loading:false,loadingRouteStatus:false,loadingServiceOrderDetails:false,showExternal:false,assignServiceZone:false};var getSelectedBranchId=function getSelectedBranchId(){return Array.isArray($scope.model.branchId)?$scope.model.branchId[0]:$scope.model.branchId;};$scope.reset=function(){var obj={status:'ACCEPTED',note:null,model:null,serialNumber:null,lockType:null,branchId:data.branch,locationId:null,actionCode:[],actionCodeNotes:null,locationZone:null,make:null,machineOwner:null,FLMProvider:null,SLMProvider:null,locationType:null,requestedTimeframe:null,targetScheduleDate:null,targetScheduleTime:null,targetTime:null,selectedFiles:[]};$scope.locationType=null;(0,_assign2.default)($scope.model,obj);if($scope.model.targetTime){$scope.model.targetScheduleDate=moment($scope.model.targetTime).toDate();$scope.model.targetScheduleTime=moment($scope.model.targetTime).toDate();}};var init=function init(){$scope.reset();$scope.loadActionCode();if($scope.model.branchId){$scope.isLocationLoading=true;$scope.loadBranchLocation('',0);BranchService.getBranchSetup(getSelectedBranchId()).then(function(branchSetup){$scope.model.branchTimezone=branchSetup&&branchSetup.timezone?branchSetup.timezone:moment.tz.guess();}).catch(function(err){console.log(err);$scope.model.branchTimezone=moment.tz.guess();});}$scope.model.billingReviewRequire=false;// Load branch setup for assign section
if($scope.hasAssignPermission){var branchId=User.getUser().branchId;SetupService.get(branchId).then(function(setupData){$scope.assign.assignServiceZone=!!setupData.assignServiceZone;$scope.assign.showExternal=true;// newly created tickets are ACCEPTED, so external is available
$scope.assign.currentVaultDate=setupData.currentVaultDate?moment(setupData.currentVaultDate).format('YYYY-MM-DD'):moment().format('YYYY-MM-DD');$scope.assign.unassignedRouteId=setupData.unassignedRouteId||null;if(setupData.defaultServiceTicketAssignment){$scope.assign.stats=setupData.defaultServiceTicketAssignment.toLowerCase();}});}};// $scope.formatFileSize = (bytes) => {
//   return CommonLayoutService.formatFileSize(bytes);
// }
$scope.removeSelectedFiles=function(index){if($scope.model.selectedFiles){$scope.model.selectedFiles.splice(index,1);}};$scope.viewServiceTicketPictures=function(data,stat,event){if(event&&event.currentTarget){event.currentTarget.blur();}previewTicketPictures(data,function(index){$scope.removeSelectedFiles(index);},function(_ref74){var modal=_ref74.modal;},function(_ref75){var modal=_ref75.modal;modal.close();});};$scope.loadActionCode=function(){$scope.actionCodeList=[];ActionCodeService.all('',0,10000).then(function(data){if(data.results&&data.results.length){$scope.actionCodeList=data.results;}});};$scope.loadUserBranch=function(){$scope.branchList=[];UserService.getUserBranchGroup(User.getUser().id).then(function(data){if(data&&data.length){data.forEach(function(item){$scope.branchList.push({id:item.branchId,name:item.branch.description});});}},function(err){console.log(err);});};$scope.loadBranchLocation=function(searchText,offset){LocationService.getBranchLocationList(searchText,$scope.model.branchId,$scope.model.customerId,offset,_app2.default.defaultPageLimit).then(function(data){if(!offset){$scope.locationList=[];$scope.totalLocation=data.total;}$scope.locationList=_.unionBy($scope.locationList.concat(data.record),'Value');},function(err){console.log(err);}).finally(function(){$scope.isLocationLoading=false;});};$scope.cancel=function(){negative({modal:serviceOrderCreateModal});};$scope.autoPopulateLocationData=function(){if($scope.model.locationId){$scope.model.branchId=User.getUser().branchId;$scope.locationType=$scope.model.locationId.locationType;$scope.model.stopPriority=$scope.model.locationId.stopPriority;$scope.model.model=$scope.model.locationId.model;$scope.model.serialNumber=$scope.model.locationId.serialNumber;$scope.model.make=$scope.model.locationId.make;if($scope.locationType==='ATM'){$scope.model.lockType=$scope.model.locationId.lockType;$scope.model.machineOwner=$scope.model.locationId.machineOwner||'N/A';$scope.model.FLMProvider=$scope.model.locationId.FLMProvider||'N/A';$scope.model.SLMProvider=$scope.model.locationId.SLMProvider||'N/A';}else{$scope.model.lockType=null;$scope.model.machineOwner=null;$scope.model.FLMProvider=null;$scope.model.SLMProvider=null;$scope.model.locationZone=null;$scope.model.locationZonesList=[];}if($scope.model.locationId.locationZone||$scope.model.locationId.locationZone==null){LocationService.getLocationServiceZone($scope.model.details.branch,$scope.model.locationId.Value).then(function(data){if(data&&data.result&&data.result.length>0){var locationZoneKeys=data.result.map(function(res){return res.locationZoneKey;});$scope.model.locationZone=locationZoneKeys.join(', ');$scope.model.locationZonesList=data.result.map(function(res){return(0,_extends3.default)({},res,{dayShort:res.dayOfWeek.substring(0,3).toUpperCase()});});}else{$scope.model.locationZone='N/A';$scope.model.locationZonesList=[];}});}// Load assign data when location is selected
$scope.loadAssignData();}else{$scope.model.branchId=User.getUser().branchId;$scope.model.lockType=null;$scope.model.stopPriority=null;$scope.model.model=null;$scope.model.serialNumber=null;$scope.model.locationZone=null;$scope.model.make=null;$scope.model.machineOwner=null;$scope.model.FLMProvider=null;$scope.model.SLMProvider=null;$scope.locationType=null;// Reset assign section when location is cleared
$scope.assign.routeId=null;$scope.assign.serviceUserId=null;$scope.assign.serviceZoneUserId=null;$scope.assign.externalProcessorCode=null;$scope.assign.routeList=[];$scope.assign.serviceUserList=[];$scope.assign.serviceZoneUserList=[];}};// Load assign data when location is selected
$scope.loadAssignData=function(){if(!$scope.hasAssignPermission||!$scope.model.locationId)return;var branchId=User.getUser().branchId;var vaultDate=$scope.assign.currentVaultDate||moment().format('YYYY-MM-DD');$scope.assign.loading=true;$scope.assign.routeId=null;$scope.assign.serviceUserId=null;$scope.assign.serviceZoneUserId=null;$scope.assign.externalProcessorCode=null;$q.all([ServiceOrderService.branchActiveRouteAndServiceUser(branchId,vaultDate,moment.tz.guess()),$scope.assign.showExternal?ServiceOrderService.getExternalProcessorCode(branchId):$q.resolve(null)]).then(function(results){$scope.assign.routeList=results[0].results.routeList;$scope.assign.serviceUserList=results[0].results.serviceUserList;$scope.assign.serviceZoneUserList=results[0].results.serviceZoneUserList;if(results[1]&&results[1].results){$scope.assign.externalProcessorCodeList=results[1].results;}}).catch(function(err){console.log(err);}).finally(function(){$scope.assign.loading=false;});};$scope.assignTabSelection=function(selectedValue){$scope.assign.stats=selectedValue;};$scope.assignRouteStatus=function(){if(!$scope.assign.routeId){$scope.assign.routeStatusInfo=null;return;}var vaultDate=$scope.assign.currentVaultDate||moment().format('YYYY-MM-DD');$scope.assign.loadingRouteStatus=true;ServiceOrderService.getRouteStatus($scope.assign.routeId,vaultDate).then(function(data){$scope.assign.routeStatusInfo=data.results;}).catch(function(err){console.log(err);}).finally(function(){$scope.assign.loadingRouteStatus=false;});};$scope.assignServiceOrderDetails=function(){var userId=$scope.assign.serviceUserId||$scope.assign.serviceZoneUserId;if(!userId){$scope.assign.serviceUserId=null;$scope.assign.serviceZoneUserId=null;return;}var branchId=User.getUser().branchId;var vaultDate=$scope.assign.currentVaultDate||moment().format('YYYY-MM-DD');var routeId=$scope.assign.unassignedRouteId;$scope.assign.loadingServiceOrderDetails=true;ServiceOrderService.serviceOrderDetails(userId,routeId,branchId,vaultDate).then(function(data){$scope.assign.serviceOrderinfo=data.results;}).catch(function(err){console.log(err);}).finally(function(){$scope.assign.loadingServiceOrderDetails=false;});};$scope.ok=function(){if($scope.formSubmited)return;if($scope.model.requestedTimeframe===$scope.scheduledPriorityValue&&(!$scope.model.targetScheduleDate||!$scope.model.targetScheduleTime))return;$scope.formSubmited=true;var branchTimezone=$scope.model.branchTimezone||moment.tz.guess();var formattedTargetTime=$scope.model.requestedTimeframe===$scope.scheduledPriorityValue&&$scope.model.targetScheduleDate&&$scope.model.targetScheduleTime?moment.tz(moment($scope.model.targetScheduleDate).format('YYYY-MM-DD')+' '+moment($scope.model.targetScheduleTime).format('HH:mm:ss'),'YYYY-MM-DD HH:mm:ss',branchTimezone).utc().format():null;$scope.model.targetTime=formattedTargetTime;var actionCodes=[];$scope.model.actionCode.forEach(function(actionCode){if(actionCode.ticked){actionCodes.push(actionCode.id);}});callback({modal:serviceOrderCreateModal,data:{encounterId:$scope.model.encounterId,note:$scope.model.note,model:$scope.model.model,serialNumber:$scope.model.serialNumber,lockType:$scope.model.lockType,stopPriority:$scope.model.stopPriority,branchId:$scope.model.branchId||null,locationId:$scope.model.locationId&&$scope.model.locationId.Value?$scope.model.locationId.Value:null,actionCode:actionCodes,actionCodeNotes:$scope.model.actionCodeNotes,targetTime:formattedTargetTime,requestedTimeframe:$scope.model.requestedTimeframe,billingReviewRequire:$scope.model.billingReviewRequire,selectedFiles:$scope.model.selectedFiles,$scope:$scope},assignData:$scope.hasAssignPermission?{routeId:$scope.assign.stats==='route'?$scope.assign.routeId:null,userId:$scope.assign.stats==='user'?$scope.assign.serviceUserId||$scope.assign.serviceZoneUserId:null,externalProcessorCode:$scope.assign.stats==='external'?$scope.assign.externalProcessorCode:null,currentStats:$scope.assign.stats}:null});};init();}]});rejectModal(serviceOrderCreateModal,negative);};var shipmentList=function shipmentList(routeId,vaultDate,coinCheckOut,callback,negative){var shipmentListModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_shipmentList2.default,size:'lg',controller:['$scope','ShipmentService','Navigation','$translate','CommonLayoutService','$state',function($scope,ShipmentService,Navigation,$translate,CommonLayoutService,$state){$scope.model={routeId:routeId,vaultDate:vaultDate,coinCheckOut:coinCheckOut,formattedDate:'',loading:false,shipments:[]};var init=function init(){$scope.model.formattedDate=moment($scope.model.vaultDate).format('YYYY-MM-DD');$scope.model.loading=true;ShipmentService.getShipmentsOnRoute($scope.model.routeId,$scope.model.vaultDate,$scope.model.coinCheckOut).then(function(data){$scope.model.shipments=data.results;}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.ok=function(){callback({modal:shipmentListModal});modal.close();};$scope.cancel=function(){negative({modal:shipmentListModal});};$scope.goToServiceHistory=function(data){return Navigation.goToServiceHistory(data.toLocationId,null,true,shipmentListModal);};$scope.goToItemHistory=function(data){return Navigation.goToItemHistory(data.trackingId,shipmentListModal);};$scope.translateMsg=function(status){if(status)return $translate.instant('shipment.'+status);};$scope.loadLocationTypeIcon=function(locationType){return CommonLayoutService.loadLocationTypeIcon(locationType);};$scope.getLocationUrl=function(data){return $state.href('branchManagement.locations',{locationId:data.toLocationId},{absolute:true});};$scope.onLocationClick=function(event,data){if(event.ctrlKey||event.metaKey||event.button===1){return;}event.preventDefault();$scope.goToServiceHistory(data);};init();}]});rejectModal(shipmentListModal,negative);};var routeStopList=function routeStopList(routeId,vaultDate,branchId,callback,negative){var routeStopListModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_routeStopList2.default,size:'lg',controller:['$scope','RouteStopService','Navigation','CommonLayoutService','$state',function($scope,RouteStopService,Navigation,CommonLayoutService,$state){$scope.model={routeId:routeId,vaultDate:vaultDate,branchId:branchId,formattedDate:'',loading:false,stops:[]};var init=function init(){$scope.model.formattedDate=moment($scope.model.vaultDate).format('YYYY-MM-DD');$scope.model.loading=true;RouteStopService.routeStopList($scope.model.routeId,$scope.model.vaultDate,$scope.model.branchId).then(function(data){$scope.model.stops=data.results;}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.ok=function(){callback({modal:routeStopListModal});modal.close();};$scope.cancel=function(){negative({modal:routeStopListModal});};$scope.goToServiceHistory=function(data){return Navigation.goToServiceHistory(data.locationId,null,true,routeStopListModal);};$scope.getLocationUrl=function(data){return $state.href('branchManagement.locations',{locationId:data.locationId},{absolute:true});};$scope.onLocationClick=function(event,data){if(event.ctrlKey||event.metaKey||event.button===1){return;}event.preventDefault();$scope.goToServiceHistory(data);};$scope.loadLocationTypeIcon=function(locationType){return CommonLayoutService.loadLocationTypeIcon(locationType);};$scope.stopPriorityOrdinalSuffix=function(stopPriority){return CommonLayoutService.ordinalSuffixOfStopPriority(stopPriority);};init();}]});rejectModal(routeStopListModal,negative);};// control supervisor scan on perfrom specific operation
function verifySupervisorScan(event,extraData,$scope){return new _promise2.default(function(resolve,reject){if($scope.model.allowSupervisorScan){confirmSupervisor(event,extraData,function(_ref76){var modal=_ref76.modal,supId=_ref76.supId;var obj={modal:modal,supId:supId};resolve(obj);},function(_ref77){var modal=_ref77.modal;$scope.isLoading=false;modal.close();},reject);}else resolve(void undefined);});}var createActionCode=function createActionCode(prioritiesList,pmSchedulesList,callback,negative){var createActionCodeModal=$uibModal.open({template:_createActionCode2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q','User','LocationService',function($scope,$q,User,LocationService){$scope.model={prioritiesList:prioritiesList,pmSchedulesList:pmSchedulesList,pmSearchList:(pmSchedulesList||[]).map(function(pm){return{Key:pm.title+(pm.status==='Suspended'?' (suspended)':''),Value:pm.id,isSuspended:pm.status==='Suspended'};}),totalPMRecords:(pmSchedulesList||[]).length,loadPreventativeMaintenances:function loadPreventativeMaintenances(searchKey,offset){searchKey=searchKey||'';return LocationService.getPreventativeMaintenanceList(10,offset,searchKey).then(function(data){var pmList=(data.results||[]).map(function(pm){return{Key:pm.title+(pm.status==='Suspended'?' (suspended)':''),Value:pm.id,isSuspended:pm.status==='Suspended'};});if(offset===0||offset===undefined){$scope.model.totalPMRecords=data.total||0;$scope.model.pmSearchList=pmList;}else{$scope.model.pmSearchList=$scope.model.pmSearchList.concat(pmList);}}).catch(function(err){return console.error(err);});},preventativeMaintenanceId:null,serviceActionPriorityId:null,serviceType:'FLM',expectedCompletionTime:'',autoAssignable:false,actionCodeLabel:'',actionCode:'',minResponse:0,maxResponse:0,minRootCause:0,maxRootCause:0,thresholds:false,partsCapture:false,actionCodeData:{details:{responses:[],rootCauses:[]}},thresholdList:['redThreshold','orangeThreshold','yellowThreshold','otherThreshold'],isDuplicate:false,acl:{},hasACL:{},permissionKey:'setting-service-settings',requirePicture:false,openRequired:false,category:null,categoryList:[{label:'FLM',value:'FLM'},{label:'SLM',value:'SLM'}],isPMSuspended:function isPMSuspended(val){if(!val)return false;if(val&&(typeof val==='undefined'?'undefined':(0,_typeof3.default)(val))==='object'&&val.isSuspended!==undefined){return val.isSuspended;}var id=val&&(typeof val==='undefined'?'undefined':(0,_typeof3.default)(val))==='object'?val.Value:val;var pm=($scope.model.pmSearchList||[]).find(function(p){return p.Value===id;});return pm&&pm.isSuspended;}};var init=function init(){$scope.loadPermission();$scope.model.loadPreventativeMaintenances('',0);if($scope.model.hasACL['create']){$scope.model.actionCodeData.details.responses.push({id:'',label:'',sortOrder:1});}};$scope.loadPermission=function(){$scope.model.acl[$scope.model.permissionKey]=User.getACL($scope.model.permissionKey);$scope.model.acl[$scope.model.permissionKey].forEach(function(permission){$scope.model.hasACL[permission]=true;});};$scope.addNewServiceResponse=function(){$scope.model.actionCodeData.details.responses.push({id:'',label:'',sortOrder:$scope.model.actionCodeData.details.length+1});};$scope.addNewRootCause=function(){$scope.model.actionCodeData.details.rootCauses.push({id:"",label:"",sortOrder:$scope.model.actionCodeData.details.rootCauses.length+1});};$scope.cancel=function(){createActionCodeModal.close();};$scope.removeResolveCodes=function(index){$scope.model.actionCodeData.details.responses.splice(index,1);};$scope.removeRootCauses=function(index){$scope.model.actionCodeData.details.rootCauses.splice(index,1);};$scope.disableCodeUpdate=function(){var isEmpty=$scope.model.actionCodeData.details.responses.filter(function(item){return!item.label;});var isRootCausesEmpty=$scope.model.actionCodeData.details.rootCauses.filter(function(item){return!item.label;});var thresholds=$scope.model.thresholdList.map(function(d){return $scope.model[d]?moment($scope.model[d]).format('HH:mm:00'):null;});var duplicate=thresholds.reduce(function(acc,currentValue,index,array){if(currentValue)if(array.indexOf(currentValue)!=index&&!acc.includes(currentValue))acc.push(currentValue);return acc;},[]);$scope.model.isDuplicate=duplicate.length;return isEmpty.length||isRootCausesEmpty.length||$scope.model.isDuplicate?true:false;};$scope.ok=function(){callback({modal:createActionCodeModal,actionCodeLabel:$scope.model.actionCodeLabel,actionCode:$scope.model.actionCode,minResponse:$scope.model.minResponse,maxResponse:$scope.model.maxResponse,minRootCause:$scope.model.minRootCause,maxRootCause:$scope.model.maxRootCause,thresholds:$scope.model.thresholds,partsCapture:$scope.model.partsCapture,resolveCodes:$scope.model.actionCodeData.details.responses,rootCauses:$scope.model.actionCodeData.details.rootCauses,redThreshold:$scope.model.redThreshold?moment($scope.model.redThreshold).format('HH:mm:00'):null,orangeThreshold:$scope.model.orangeThreshold?moment($scope.model.orangeThreshold).format('HH:mm:00'):null,yellowThreshold:$scope.model.yellowThreshold?moment($scope.model.yellowThreshold).format('HH:mm:00'):null,otherThreshold:$scope.model.otherThreshold?moment($scope.model.otherThreshold).format('HH:mm:00'):null,requirePicture:$scope.model.requirePicture,openRequired:$scope.model.openRequired,category:$scope.model.category,serviceType:$scope.model.serviceType,expectedCompletionTime:$scope.model.expectedCompletionTime?moment($scope.model.expectedCompletionTime).format('HH:mm:00'):null,autoAssignable:$scope.model.autoAssignable,serviceActionPriorityId:$scope.model.serviceActionPriorityId,preventativeMaintenanceId:$scope.model.preventativeMaintenanceId?$scope.model.preventativeMaintenanceId.Value:null});// createActionCodeModal.close();
};init();}]});};var createServiceChecklist=function createServiceChecklist(pagination,callback,negative){var createServiceChecklistModal=$uibModal.open({template:_createServiceChecklist2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q','User',function($scope,$q,User){$scope.model={serviceChecklistData:{details:{}},acl:{},hasACL:{},permissionKey:'setting-service-checklist'};var init=function init(){$scope.loadPermission();if($scope.model.hasACL['create']){$scope.model.serviceChecklistData.details={label:'',sortOrder:pagination+1,daySelection:30};focusElementById('service-check-list-name');}};$scope.loadPermission=function(){$scope.model.acl[$scope.model.permissionKey]=User.getACL($scope.model.permissionKey);$scope.model.acl[$scope.model.permissionKey].forEach(function(permission){$scope.model.hasACL[permission]=true;});};$scope.cancel=function(){createServiceChecklistModal.close();};$scope.disableCodeUpdate=function(){return!$scope.model.serviceChecklistData.details.label||!$scope.model.serviceChecklistData.details.daySelection;};$scope.ok=function(){callback({modal:createServiceChecklistModal,serviceChecklist:$scope.model.serviceChecklistData.details});// createServiceChecklistModal.close();
};init();}]});};var createAtmMake=function createAtmMake(callback,negative){var createAtmMakeModal=$uibModal.open({template:_createAtmMake2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope',function($scope){$scope.model={atmMakeData:{details:{}}};var init=function init(){$scope.model.atmMakeData.details={vendorName:'',active:true};focusElementById('atm-make-name');};$scope.cancel=function(){if(negative){negative({modal:createAtmMakeModal});return;}createAtmMakeModal.close();};$scope.disableCodeUpdate=function(){return!$scope.model.atmMakeData.details.vendorName;};$scope.ok=function(){callback({modal:createAtmMakeModal,atmMake:$scope.model.atmMakeData.details});};init();}]});};var createServiceActionPriority=function createServiceActionPriority(callback,negative){var createServiceActionPriorityModal=$uibModal.open({template:_createServiceActionPriority2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope',function($scope){$scope.model={priorityData:{details:{}}};var init=function init(){$scope.model.priorityData.details={priority:'',description:'',active:true};focusElementById('priority-name');};$scope.cancel=function(){if(negative){negative({modal:createServiceActionPriorityModal});return;}createServiceActionPriorityModal.close();};$scope.disableCodeUpdate=function(){return!$scope.model.priorityData.details.priority;};$scope.ok=function(){callback({modal:createServiceActionPriorityModal,priorityItem:$scope.model.priorityData.details});};init();}]});};var changeDestinationModal=function changeDestinationModal(shipmentData,customerId,_callback5,negative){var changeDestination=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_changeDestination2.default,size:'md',controller:['$scope','$translate','ShipmentService','LocationService','User',function($scope,$translate,ShipmentService,LocationService,User){$scope.model={branch:User.getUser().branchId,locationList:[],comment:'',totalLocation:0,shipmentData:shipmentData,location:'',errorMsg:'',customerId:customerId};$scope.mappingLocations=function(locations){return locations.map(function(loc){return{Key:loc.id+" | "+loc.name,Value:loc.id};});};var init=function init(){$scope.model.loading=true;$scope.getCentralBankLocation('',0);$scope.model.location={Key:shipmentData.toLocationId+' | '+shipmentData.toLocationName,Value:shipmentData.toLocationId};};$scope.getCentralBankLocation=function(searchKey,offset){searchKey=searchKey||'';if($scope.model.customerId){return $scope.getDeliveryToLocationsAndShiptypes(searchKey,offset);}ShipmentService.getChangeDestinationLocations(shipmentData.trackingId,shipmentData.branchId,searchKey,offset,_app2.default.defaultPageLimit).then(function(data){if(!offset||offset===0){$scope.model.totalLocation=data.total;$scope.model.locationList=$scope.mappingLocations(data.results);}else{var Locations=$scope.mappingLocations(data.results);$scope.model.locationList=$scope.model.locationList.concat(Locations);}}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.getDeliveryToLocationsAndShiptypes=function(searchKey,offset){LocationService.getDeliveryToLocationsAndShiptypes(shipmentData.toLocationId,searchKey).then(function(data){var locations=data.results.destinationData;if(!offset||offset===0){var currentDestExists=locations.find(function(l){return l.id===shipmentData.toLocationId;});var totalLocation=data.totalRecords.destinationCount;if(!currentDestExists&&!searchKey){locations.unshift({id:shipmentData.toLocationId,name:shipmentData.toLocationName});totalLocation++;}$scope.model.totalLocation=totalLocation;$scope.model.locationList=$scope.mappingLocations(locations);}else{var newLocations=$scope.mappingLocations(locations);$scope.model.locationList=$scope.model.locationList.concat(newLocations);}}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.validateDestination=function(){if($scope.model.location&&$scope.model.shipmentData.toLocationId===$scope.model.location.Value){$scope.model.errorMsg=$translate.instant('branch_mgmt.items.duplicate_destination_error',{trackingId:$scope.model.shipmentData.trackingId,locationId:$scope.model.location.Value});}else{delete $scope.model.errorMsg;}};$scope.cancel=function(){negative({modal:changeDestination});};$scope.ok=function(){if($scope.model.customerId){confirm({header:$translate.instant('common.confirm_title'),message:'Are you sure you want to change the destination?',callback:function callback(_ref78){var modal=_ref78.modal;_callback5({modal:changeDestination,comment:$scope.model.comment||null,locationId:$scope.model.location.Value,supervisorId:null});modal.close();},negative:function negative(_ref79){var modal=_ref79.modal;modal.close();},type:'success',buttons:['common.yes','common.no']});}else{confirmSupervisor('change-destination',{trackingId:$scope.model.shipmentData.trackingId},function(_ref80){var model=_ref80.model,supId=_ref80.supId;_callback5({modal:changeDestination,comment:$scope.model.comment||null,locationId:$scope.model.location.Value,supervisorId:supId});modal.close();},function(_ref81){var modal=_ref81.modal;modal.close();});}};init();}]});rejectModal(changeDestination,negative);};var serviceOrderActions=function serviceOrderActions(serviceOrder,callback,negative){var serviceOrderActionsModal=$uibModal.open({template:_serviceOrderActions2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q','ServiceOrderService','$translate','DateUtil','ServiceTicketPartsService',function($scope,$q,ServiceOrderService,$translate,DateUtil,ServiceTicketPartsService){$scope.model={loading:false,serviceOrder:serviceOrder,actionCodes:[],selectedResponses:{},// serviceOrderNote: serviceOrder.serviceOrderNote,
errorMessage:null,isUpdate:false,isValid:false,serviceUserList:[],userId:null,completedTime:null,completedDate:null,completedDateError:null,selectedParts:{},lastArrivalTime:serviceOrder.lastArrivalTime,arrivedDate:null,arrivedTime:null,browserTimezone:moment.tz.guess()};var init=function init(){$scope.model.loading=true;$scope.model.completedDate=moment().toDate();$scope.time=moment().format('HH:mm:ss');$scope.model.completedTime=$scope.getTime($scope.time);var lastArrivalDateTime=$scope.model.lastArrivalTime;if(!lastArrivalDateTime){$scope.model.arrivedDate=moment().toDate();$scope.model.arrivedTime=$scope.getTime($scope.time);}else{var time=moment.utc(lastArrivalDateTime).tz($scope.model.browserTimezone).format('HH:mm:ss');$scope.model.arrivedDate=moment(lastArrivalDateTime);$scope.model.arrivedTime=DateUtil.getTime(time);}$scope.minVaultDate={minDate:$scope.model.serviceOrder.firstAssignOn?moment($scope.model.serviceOrder.firstAssignOn).format('YYYY-MM-DD'):moment().format('YYYY-MM-DD'),maxDate:moment().format('YYYY-MM-DD')};$scope.firstAssignedTime=$scope.model.serviceOrder.firstAssignOn?moment($scope.model.serviceOrder.firstAssignOn).format('HH:mm'):moment().format('HH:mm');$scope.model.minTime=$scope.firstAssignedTime;$scope.model.maxTime=moment().format('HH:mm');$q.all([ServiceOrderService.getServiceOrderActionCodes($scope.model.serviceOrder.encounterId),$scope.getBranchServiceUser(),ServiceTicketPartsService.all(null,0,100)]).then(function(data){$scope.model.userId=$scope.model.serviceOrder.userId;$scope.model.actionCodes=data[0].results;$scope.model.serviceTicketPartList=data[2].results;$scope.model.requireResolveCodesFor=data[0].requireResolveCodesFor;$scope.model.actionCodes.forEach(function(d){$scope.model.selectedResponses[d.serviceOrderActionId]={responseCode:[],selectedParts:[],rootCauseCode:[],note:null,selectionMode:null,rootCauseSelectionMode:null,userNote:null};$scope.model.selectedResponses[d.serviceOrderActionId].note=d.serviceOrderActionNote;$scope.model.selectedResponses[d.serviceOrderActionId].selectionMode=d.maxResponses===1?'single':'multiple';$scope.model.selectedResponses[d.serviceOrderActionId].rootCauseSelectionMode=d.maxRootCauses===1?'single':'multiple';$scope.model.selectedResponses[d.serviceOrderActionId].userNote=d.serviceOrderActionUserNote;d.responses.forEach(function(response){d.selectedResponseCodeIds.forEach(function(responseCodeIds){if(response.id==responseCodeIds){response.ticked=true;}});});d.rootCauses.forEach(function(rootCause){d.selectedRootCauseIds.forEach(function(rootCauseIds){if(rootCause.id==rootCauseIds){rootCause.ticked=true;}});});$scope.model.serviceTicketPartList.forEach(function(list){d.selectedPartIds.forEach(function(partId){if(list.id==partId){list.ticked=true;}});});});$scope.validateUpdateButton();}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.validateUpdateButton=function(){setTimeout(function(){var isValidResponse=void 0,verifyResponse=[];$scope.model.actionCodes.forEach(function(response){isValidResponse=(response.minResponses===0&&!$scope.model.selectedResponses[response.serviceOrderActionId].responseCode.length||$scope.model.selectedResponses[response.serviceOrderActionId].responseCode.length)&&(response.minRootCauses?$scope.model.selectedResponses[response.serviceOrderActionId].rootCauseCode.length:true)&&$scope.model.selectedResponses[response.serviceOrderActionId].userNote?true:undefined;verifyResponse.push(isValidResponse);});if(verifyResponse.indexOf(false)>=0||verifyResponse.indexOf()!==-1)return $scope.model.isValid=false;else return $scope.model.isValid=true;});};$scope.cancel=function(){serviceOrderActionsModal.close();};$scope.translateMessage=function(message){return $translate.instant(message);};$scope.ok=function(){var details=[];$scope.model.isUpdate=true;$scope.model.actionCodes.forEach(function(result){if($scope.model.selectedResponses[result.serviceOrderActionId]){details.push({serviceOrderActionId:result.serviceOrderActionId,responses:$scope.model.selectedResponses[result.serviceOrderActionId].responseCode,rootCauses:$scope.model.selectedResponses[result.serviceOrderActionId].rootCauseCode,actionNote:$scope.model.selectedResponses[result.serviceOrderActionId].note||null,userNote:$scope.model.selectedResponses[result.serviceOrderActionId].userNote||null,actionCode:result.actionCodeId,parts:$scope.model.selectedResponses[result.serviceOrderActionId].selectedParts});}});callback({modal:serviceOrderActionsModal,actionCodeData:details,// serviceOrderNote: $scope.model.serviceOrderNote,
$scope:$scope,completedByUserId:$scope.model.userId,completedDate:moment($scope.model.completedDate).format('YYYY-MM-DD'),completedTime:moment($scope.model.completedTime).format('HH:mm:ss'),arrivedDate:moment($scope.model.arrivedDate).format('YYYY-MM-DD'),arrivedTime:moment($scope.model.arrivedTime).format('HH:mm:ss')});// serviceOrderActionsModal.close();
};$scope.getTime=function(time){if(!time){return time;}time=time.split(':');var d=new Date();d.setHours(+time[0]);d.setMinutes(time[1]);d.setSeconds(0);d.setMilliseconds(0);return d;};$scope.validateCompletedAt=function(){var formatDateTime=function formatDateTime(date,time){return moment(date).format('YYYY-MM-DD').concat(' ',moment(time).format('HH:mm:ss'));};var getTimestamp=function getTimestamp(dateTime){return new Date(dateTime).getTime();};$scope.completedAt=formatDateTime($scope.model.completedDate,$scope.model.completedTime);var completedAtTs=getTimestamp($scope.completedAt);var currentBrowserTime=Date.now();$scope.arrivedAt=formatDateTime($scope.model.arrivedDate,$scope.model.arrivedTime);var arrivedAtTs=getTimestamp($scope.arrivedAt);var serviceOrder=$scope.model.serviceOrder;var baseTimestamp=null;var errorMessageKey='';if(serviceOrder.firstAssignOn){baseTimestamp=getTimestamp(moment(serviceOrder.firstAssignOn).format('YYYY-MM-DD HH:mm:ss'));errorMessageKey='serviceTickets.befor_first_assigned_on_err';}else if(serviceOrder.acceptedOn){baseTimestamp=getTimestamp(moment(serviceOrder.acceptedOn).format('YYYY-MM-DD HH:mm:ss'));errorMessageKey='service_tickets.completed_time.before_first_accepted_on_err';}if(baseTimestamp&&completedAtTs<baseTimestamp){$scope.model.completedDateError=$translate.instant(errorMessageKey);}else if(completedAtTs>currentBrowserTime){$scope.model.completedDateError=$translate.instant('serviceTickets.after_current_date_time_err');}else if(completedAtTs<arrivedAtTs){$scope.model.completedDateError=$translate.instant('service_tickets.completed_date_time_is_before_arrived_time_err');}else{delete $scope.model.completedDateError;}};$scope.validateArrivedTime=function(){$scope.arrivedAt=moment($scope.model.arrivedDate).format('YYYY-MM-DD').concat(' ',moment($scope.model.arrivedTime).format('HH:mm:ss'));var currentBrowserTime=new Date().getTime();var convertArrivedAtToTs=new Date($scope.arrivedAt).getTime();$scope.completedAt=moment($scope.model.completedDate).format('YYYY-MM-DD').concat(' ',moment($scope.model.completedTime).format('HH:mm:ss'));var convertCompletedAtToTs=new Date($scope.completedAt).getTime();if($scope.model.serviceOrder.firstAssignOn){var firstAssignOn=moment($scope.model.serviceOrder.firstAssignOn).format('YYYY-MM-DD HH:mm:ss');var convertFirstAssignOnToTs=new Date(firstAssignOn).getTime();if(moment(convertArrivedAtToTs).isBefore(convertFirstAssignOnToTs)){$scope.model.arrivedDateError=$translate.instant('service_tickets.arrived_time.befor_first_assigned_on_err');}else if(moment(convertArrivedAtToTs).isAfter(currentBrowserTime)){$scope.model.arrivedDateError=$translate.instant('service_tickets.arrived_time.after_current_date_time_err');}else if(moment(convertArrivedAtToTs).isAfter(convertCompletedAtToTs)){$scope.model.arrivedDateError=$translate.instant('service_tickets.arrived_time.after_completed_date_time_err');}else{delete $scope.model.arrivedDateError;}}else if($scope.model.serviceOrder.acceptedOn){var firstAcceptedOn=moment($scope.model.serviceOrder.acceptedOn).format('YYYY-MM-DD HH:mm:ss');var convertFirstAcceptedOnToTs=new Date(firstAcceptedOn).getTime();if(moment(convertArrivedAtToTs).isBefore(convertFirstAcceptedOnToTs)){$scope.model.arrivedDateError=$translate.instant('service_tickets.arrived_time.before_first_accepted_on_err');}else if(moment(convertCompletedAtToTs).isAfter(currentBrowserTime)){$scope.model.completedDateError=$translate.instant('serviceTickets.after_current_date_time_err');}else{delete $scope.model.arrivedDateError;}}else if(moment(convertArrivedAtToTs).isAfter(currentBrowserTime)){$scope.model.arrivedDateError=$translate.instant('service_tickets.arrived_time.after_current_date_time_err');}else{delete $scope.model.arrivedDateError;}};$scope.getBranchServiceUser=function(){return ServiceOrderService.getServiceUser($scope.model.serviceOrder.branchId).then(function(data){$scope.model.serviceUserList=data.results;}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}});};init();}]});rejectModal(serviceOrderActionsModal,negative);};var pendingCancelShipments=function pendingCancelShipments(branchId,routeId,vaultDate,callback,negative){var pendingCancelShipmentsModal=$uibModal.open({template:_pendingCancelShipments2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q','ShipmentService','$state','Navigation',function($scope,$q,ShipmentService,$state,Navigation){$scope.model={shipments:[],loading:false,errorMessage:'',branchId:branchId,routeId:routeId,vaultDate:vaultDate};var init=function init(){$scope.model.loading=true;ShipmentService.getPendingCancelShipments($scope.model.branchId,0,1000,$scope.model.routeId,$scope.model.vaultDate).then(function(data){$scope.model.shipments=data.results;}).catch(function(err){if(err&&err.data&&err.data.message){$scope.model.errorMessage=err.data.message;}}).finally(function(){$scope.model.loading=false;});};$scope.goToItemHistory=function(trackingId){pendingCancelShipmentsModal.close();$state.go('branchManagement.items',{id:trackingId});};$scope.goToServiceHistory=function(locationId){return Navigation.goToServiceHistory(locationId,null,true,pendingCancelShipmentsModal);};$scope.goToOrderHistory=function(data){return Navigation.goToOrderHistory(data.orderNo,data.vaultDate,true,false,true,false,pendingCancelShipmentsModal);};$scope.goToBulkCash=function(){pendingCancelShipmentsModal.close();$state.go('bulkCashManagement');};$scope.cancel=function(){pendingCancelShipmentsModal.close();};$scope.ok=function(){callback({modal:pendingCancelShipmentsModal});pendingCancelShipmentsModal.close();};init();}]});rejectModal(pendingCancelShipmentsModal,negative);};var bagoutListModal=function bagoutListModal(branchId,destinationLocation,bagOutId,infoFor,callback,negative){var bagoutList=$uibModal.open({template:_bagoutList2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','BagoutService','Navigation','$state',function($scope,BagoutService,Navigation,$state){$scope.model={branchId:branchId,destinationLocationId:destinationLocation?destinationLocation.Value:null,destinationLocation:destinationLocation?destinationLocation.Key:null,bagoutList:[],infoFor:infoFor,bagOutId:bagOutId,totalRecords:0,loading:false};$scope.pagination={page:1,total:0,pageLimit:10,maxPages:10};var init=function init(){$scope.loadBagoutList();};$scope.loadBagoutList=function(){var promise=_promise2.default.resolve();promise=$scope.model.infoFor==='remainingBagout'?BagoutService.getRemainingBagoutList($scope.model.branchId,$scope.model.destinationLocationId,($scope.pagination.page-1)*$scope.pagination.pageLimit,$scope.pagination.pageLimit):BagoutService.getTotalItemsInBagoutList($scope.model.bagOutId,($scope.pagination.page-1)*$scope.pagination.pageLimit,$scope.pagination.pageLimit);$scope.model.loading=true;return promise.then(function(res){$scope.model.bagoutList=res.results;$scope.model.totalRecords=res.totalRecords;}).catch(function(err){console.log(err);if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.pageChange=function(){$scope.loadBagoutList();};$scope.goToServiceHistory=function(locationId){return Navigation.goToServiceHistory(locationId,null,true,bagoutList);};$scope.goToItemHistory=function(trackingId){bagoutList.close();$state.go('branchManagement.items',{id:trackingId});};$scope.cancel=function(){bagoutList.close();};init();}]});rejectModal(bagoutList,negative);};var bulkCashAdjustComment=function bulkCashAdjustComment(data,callback,negative){var bulkCashAdjustCommentModal=$uibModal.open({template:_bulkCashAdjustComment2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q',function($scope,$q){$scope.model={comment:'',bulkCashData:data,loading:false};var init=function init(){focusElementById('bulk-cash-adjust-comment');};$scope.ok=function(){// $scope.model.loading = true;
callback({modal:bulkCashAdjustCommentModal,comments:$scope.model.comment});bulkCashAdjustCommentModal.close();};$scope.cancel=function(){negative({modal:bulkCashAdjustCommentModal});};init();}]});rejectModal(bulkCashAdjustCommentModal,negative);};var shipmentImageModal=function shipmentImageModal(shipments,trackingId,stats,modal,callback){var shipmentImage=$uibModal.open({template:_shipmentImage2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'model-body-top',backdrop:'static',size:'md',controller:['$scope','$q',function($scope,$q){$scope.model={shipmentData:shipments,trackingId:trackingId,stats:stats,image:stats==='pickup'?shipments.pickupImageName:shipments.deliveryImageName};$scope.zoomLevel=350;$scope.maxZoom=600;$scope.minZoom=200;$scope.zoomIn=function(){if($scope.zoomLevel<$scope.maxZoom){$scope.zoomLevel+=50;}};$scope.zoomOut=function(){if($scope.zoomLevel>$scope.minZoom){$scope.zoomLevel-=50;}};var init=function init(){};$scope.ok=function(){callback({modal:shipmentImage});shipmentImage.close();};$scope.cancel=function(){shipmentImage.close();};init();}]});};var bagoutsOnHoldModal=function bagoutsOnHoldModal(callback,negative){var bagoutsOnHold=$uibModal.open({template:_bagoutsOnHoldList2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'model-body-top',backdrop:'static',size:'lg',controller:['$scope','$q','User','HoldService',function($scope,$q,User,HoldService){$scope.model={bagoutData:[],branchId:User.getUser().branchId,loading:false};var init=function init(){$scope.model.loading=true;HoldService.getBagoutsOnHold($scope.model.branchId).then(function(data){$scope.model.bagoutData=data.results;}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.ok=function(){confirmSupervisor('solf-delete-bagouts-on-hold',null,function(_ref82){var model=_ref82.model,supId=_ref82.supId;callback({modal:bagoutsOnHold,supervisorId:supId});model.close();},function(_ref83){var modal=_ref83.modal;modal.close();});};$scope.cancel=function(){negative({modal:bagoutsOnHold});};init();}]});rejectModal(bagoutsOnHold,negative);};var saveLocationLaterModal=function saveLocationLaterModal(routeAssignment,deliveryToLocation,locationId,locationStatus,locationBranch,defaultBranch,batchImport,bagoutExport,routeLikeRegular,recurringRouteAssignment,denomination,scheduleRecurringLoad,fundingSource,callback,negative){var saveLater=$uibModal.open({template:_saveLocationLater2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'model-body-top',backdrop:'static',size:'lg',controller:['$scope','$q','DateUtil','$translate',function($scope,$q,DateUtil,$translate){$scope.model={deliveryToLocation:deliveryToLocation,routeAssignment:routeAssignment,locationId:locationId,date:null,time:null,currentDateTime:moment.utc().format(),dateError:null,locationStatus:locationStatus,locationBranch:locationBranch,defaultBranch:defaultBranch,batchImport:batchImport,bagoutExport:bagoutExport,routeLikeRegular:routeLikeRegular,recurringRouteAssignment:recurringRouteAssignment,denomination:denomination,scheduleRecurringLoad:scheduleRecurringLoad,fundingSource:fundingSource};var init=function init(){$scope.minVaultDate={minDate:moment().format('YYYY-MM-DD')};};$scope.calculateDuration=function(startDate,endDate){var ms=moment(endDate).diff(startDate);return ms.valueOf();};$scope.validateDate=function(){var futureDate=$scope.formatDate();if(!futureDate)return;if(!moment(futureDate).isAfter($scope.model.currentDateTime))$scope.model.dateError=$translate.instant('location.date_error');else delete $scope.model.dateError;};$scope.formatDate=function(){if(!$scope.model.date||!$scope.model.time)return;var date=moment($scope.model.date).format('YYYY-MM-DD');var time=moment($scope.model.time).format('HH:mm:ss');var formattedDate=date.concat(' ',time);var dateTime=moment(formattedDate).utc().format();return dateTime;};$scope.ok=function(){var futureDate=$scope.formatDate();var duration=$scope.calculateDuration($scope.model.currentDateTime,futureDate);callback({modal:saveLater,duration:duration,dateTime:futureDate});saveLater.close();};$scope.cancel=function(){saveLater.close();};init();}]});rejectModal(saveLater,negative);};var saveRouteChangesLaterModal=function saveRouteChangesLaterModal(tankerAssignment,routeId,callback,negative){var saveLater=$uibModal.open({template:_saveRouteChangesLater2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'model-body-top',backdrop:'static',size:'lg',controller:['$scope','$translate',function($scope,$translate){$scope.model={tankerAssignment:tankerAssignment,routeId:routeId,date:null,time:null,currentDateTime:moment.utc().format(),dateError:null};var init=function init(){$scope.minVaultDate={minDate:moment().format('YYYY-MM-DD')};};$scope.calculateDuration=function(startDate,endDate){var ms=moment(endDate).diff(startDate);return ms.valueOf();};$scope.validateDate=function(){var futureDate=$scope.formatDate();if(!futureDate)return;if(!moment(futureDate).isAfter($scope.model.currentDateTime))$scope.model.dateError=$translate.instant('location.date_error');else delete $scope.model.dateError;};$scope.formatDate=function(){if(!$scope.model.date||!$scope.model.time)return;var date=moment($scope.model.date).format('YYYY-MM-DD');var time=moment($scope.model.time).format('HH:mm:ss');var formattedDate=date.concat(' ',time);var dateTime=moment(formattedDate).utc().format();return dateTime;};$scope.ok=function(){var futureDate=$scope.formatDate();var duration=$scope.calculateDuration($scope.model.currentDateTime,futureDate);callback({modal:saveLater,duration:duration,dateTime:futureDate});saveLater.close();};$scope.cancel=function(){saveLater.close();};init();}]});rejectModal(saveLater,negative);};var billingContractRulesModal=function billingContractRulesModal(data,isEdit){var contractRules=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var callback=arguments[3];var negative=arguments[4];var billingContractRules=$uibModal.open({template:_billingContractRules2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'model-body-top',backdrop:'static',size:'lg',controller:['$scope','$q','User','CurrencyService','Modal','$translate','SetupService',function($scope,$q,User,CurrencyService,Modal,$translate,SetupService){$scope.model={branchId:User.getUser().branchId,loading:false,billingEventOptions:[{label:'Shipment Delivery',key:'shipment-delivered'},{label:'Shipment Pickup',key:'shipment-pickup'}],locationTypeOptions:[{label:'Any',value:'ANY'},{label:'ATM',value:'ATM'},{label:'Regular',value:'REGULAR'},{label:'NSNG',value:'NSNG'},{label:'On Call',value:'ON_CALL'}],orderTypeOptionsChildren:{'common':[{label:'Any',value:'ANY'},{label:'Scheduled',value:'SCHEDULED'},{label:'Unscheduled',value:'UNSCHEDULED'},{label:'Seasonal',value:'SEASONAL'},{label:'On Call',value:'ON_CALL'}],'ATM':[{label:'ATM Any Service',value:'ATM_ANY_SERVICE'},{label:'ATM Add',value:'ATM_ADD'},{label:'ATM Swap',value:'ATM_SWAP'},{label:'ATM ICL',value:'ATM_ICL'},{label:'ATM CCL',value:'ATM_CCL'},{label:'ATM Recash',value:'ATM_RECASH'},{label:'ATM Decash',value:'ATM_DECASH'}],'services':[{label:'Service Order',value:'SERVICE_ORDER'}]},billingTypeOptions:[{label:'Fixed',value:'FIXED'},{label:'Per Item',value:'PER_ITEM'},{label:'Item Range',value:'ITEM_RANGE'},{label:'Amount Range',value:'AMOUNT_RANGE'},{label:'Time Range',value:'TIME_RANGE'}],billingRateOptionsChildren:{'without_rate':[{label:'Currency',value:'CURRENCY'},{label:'Rate Above',value:'RATE_ABOVE'},{label:'Rate Equal Below',value:'RATE_EQUAL_BELOW'},{label:'Rate Percentage',value:'RATE_PERCENTAGE'},{label:'Percentage',value:'PERCENTAGE'}],'item_options':[{label:'Item Limit',value:'ITEM_LIMIT'},{label:'Value Increment',value:'VALUE_INCREMENT'}],'value_options':[{label:'Value Limit',value:'VALUE_LIMIT'},{label:'Item Increment',value:'ITEM_INCREMENT'}],'time_options':[{label:'Value Limit',value:'VALUE_LIMIT'},{label:'Item Increment',value:'ITEM_INCREMENT'}],'rate_options':[{label:'Rate',value:'RATE'}]},contractRulesOptions:[],existingBillingRules:data,isEdit:isEdit,isValidItemRange:true,duplicateObj:{},itemRangeError:''};var init=function init(){if(!$scope.model.existingBillingRules){$scope.model.contractRulesOptions.push({billingEvent:null,locationType:null,orderType:null,billingTypeObj:{},billingRateObj:{},billingTypeOptions:$scope.model.billingTypeOptions});}else if($scope.model.isEdit&&$scope.model.existingBillingRules.id){var existingBillingRulesObj=$scope.model.existingBillingRules;$scope.model.contractRulesOptions.push({billingEvent:_.find($scope.model.billingEventOptions,{'key':existingBillingRulesObj.billingEvent}),locationType:_.find($scope.model.locationTypeOptions,{'value':existingBillingRulesObj.locationType}),billingTypeObj:{},billingRateObj:{},billingTypeOptions:$scope.model.billingTypeOptions});$scope.model.contractRulesOptions.forEach(function(obj,index){$scope.orderTypeOptionChanged(obj,index);obj.orderType=_.find(obj.options,{'value':existingBillingRulesObj.orderType});obj.billingTypeObj.billingType=_.find(obj.billingTypeOptions,{'value':existingBillingRulesObj.billingType});obj.billingTypeObj.min=existingBillingRulesObj.minQty;obj.billingTypeObj.max=existingBillingRulesObj.maxQty;obj.billingTypeObj.minAmount=existingBillingRulesObj.minAmount;obj.billingTypeObj.maxAmount=existingBillingRulesObj.maxAmount;obj.billingTypeObj.beginTime=existingBillingRulesObj.beginTime?$scope.getTime(existingBillingRulesObj.beginTime):null;obj.billingTypeObj.endTime=existingBillingRulesObj.endTime?$scope.getTime(existingBillingRulesObj.endTime):null;// $scope.billingRateOptionChanged(obj, index);
obj.billingRateOptions=$scope.model.billingRateOptionsChildren['rate_options'];obj.billingRateObj.billingRate=obj.billingRateOptions[0];obj.billingRateObj.rate=existingBillingRulesObj.billingRate;obj.billingRateObj.currency=existingBillingRulesObj.currencyId;});}else{$scope.model.contractRulesOptions.push(_.cloneDeep($scope.model.existingBillingRules));}// CurrencyService.all(null, 0, 100)
//   .then((data) => {
//     $scope.model.currencyList = data.results;
//   })
//   .catch((err) => {
//     console.log(err);
//     if (err && err.data && err.data.message) {
//       Modal.errorModal(err.data.message);
//     }
//   })
$scope.model.loading=true;SetupService.get($scope.model.branchId).then(function(data){$scope.model.contractRulesOptions.forEach(function(cr){cr.billingRateObj.currency=data.currencyId;});}).finally(function(){$scope.model.loading=false;});};$scope.orderTypeOptionChanged=function(orderTypeOption,index){var selectedService=orderTypeOption.billingEvent.key;if(selectedService.startsWith('ATM_'))orderTypeOption.options=$scope.model.orderTypeOptionsChildren['ATM'];else if(selectedService==='repair_maintenance'||selectedService==='part_charge')orderTypeOption.options=$scope.model.orderTypeOptionsChildren['services'];else orderTypeOption.options=$scope.model.orderTypeOptionsChildren['common'];};$scope.billingRateOptionChanged=function(obj,index){obj.billingRateOptions=$scope.model.billingRateOptionsChildren['rate_options'];// let selectedBillingType = obj.billingTypeObj.billingType.value;
// if (selectedBillingType === 'flat' || selectedBillingType === 'PER_ITEM') {
//   obj.billingRateOptions = [...$scope.model.billingRateOptionsChildren['without_rate'], ...$scope.model.billingRateOptionsChildren['rate_options']]
// }
// else if (selectedBillingType === 'ITEM_LIMIT') {
//   obj.billingRateOptions = [...$scope.model.billingRateOptionsChildren['without_rate'], ...$scope.model.billingRateOptionsChildren['item_options']]
// }
// else if (selectedBillingType === 'VALUE_LIMIT') {
//   obj.billingRateOptions = [...$scope.model.billingRateOptionsChildren['without_rate'], ...$scope.model.billingRateOptionsChildren['value_options']]
// }
// else if (selectedBillingType === 'time_limit') {
//   obj.billingRateOptions = [...$scope.model.billingRateOptionsChildren['without_rate'], ...$scope.model.billingRateOptionsChildren['time_options']]
// }
$scope.validateBillingType(obj,index);};$scope.validateBillingType=function(obj,index){obj.billingTypeObj.minAmount=null;obj.billingTypeObj.maxAmount=null;obj.billingTypeObj.beginTime=null;obj.billingTypeObj.endTime=null;obj.billingTypeObj.min=null;obj.billingTypeObj.max=null;delete $scope.model.billingRangeError;};$scope.validateBillingTypeRange=function(obj,index){var billingTypeObj=obj.billingTypeObj;if(billingTypeObj.min&&billingTypeObj.max&&billingTypeObj.min>billingTypeObj.max){$scope.model.billingRangeError=$translate.instant('billableEvents.value_range_error');}else if(billingTypeObj.minAmount&&billingTypeObj.maxAmount&&billingTypeObj.minAmount>billingTypeObj.maxAmount){$scope.model.billingRangeError=$translate.instant('billableEvents.amount_range_error');}else if(billingTypeObj.beginTime&&billingTypeObj.endTime&&billingTypeObj.beginTime>billingTypeObj.endTime){$scope.model.billingRangeError=$translate.instant('billableEvents.time_range_error');}else{delete $scope.model.billingRangeError;}};$scope.validateItemRange=function(){var eq=void 0;contractRules=_.map(contractRules,function(mainObj,mainObjIndex){mainObj.duplicate=false;mainObj.locationType=mainObj.locationType?mainObj.locationType:null;mainObj.orderType=mainObj.orderType?mainObj.orderType:null;eq=_.find($scope.model.contractRulesOptions,function(compareObject,compareObjIndex){var orderType=compareObject.orderType?compareObject.orderType.value:null;var locationType=compareObject.locationType?compareObject.locationType.value:null;if(mainObjIndex>=compareObjIndex){return orderType==mainObj.orderType&&locationType==mainObj.locationType;}});if(eq){$scope.model.duplicateObj=(0,_assign2.default)({},eq);}if(eq){mainObj.duplicate=true;return mainObj;}else{return mainObj;}});var checkAndValidate=contractRules.map(function(obj){if(obj.duplicate)return true;});$scope.model.isValidItemRange=checkAndValidate.indexOf(true)>=0?false:true;if(!$scope.model.isValidItemRange){var findItemRange=_.filter(contractRules,{'orderType':$scope.model.duplicateObj.orderType.value,'locationType':$scope.model.duplicateObj.locationType.value,'billingType':'ITEM_RANGE'});var itemRange=findItemRange.reduce(function(p,v){return p<v?p:v;});if(($scope.model.duplicateObj.billingTypeObj.min&&$scope.model.duplicateObj.billingTypeObj.min)<=itemRange.maxQty){$scope.model.itemRangeError=$translate.instant('billableEvents.itemRangeError',{value:itemRange.maxQty});}else{delete $scope.model.itemRangeError;}}else{delete $scope.model.itemRangeError;}};$scope.getTime=function(time){if(!time){return time;}time=time.split(':');var d=new Date();d.setHours(+time[0]);d.setMinutes(time[1]);d.setSeconds(time[2]);d.setMilliseconds(0);return d;};$scope.ok=function(){callback({contractRulesOptions:$scope.model.contractRulesOptions,modal:billingContractRules});};$scope.cancel=function(){negative({modal:billingContractRules});};init();}]});rejectModal(billingContractRules,negative);};var approveBillingRecords=function approveBillingRecords(data,callback,negative){var approveBillingRecordsModal=$uibModal.open({keyboard:false,template:_approveBillingRecords2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',type:'success',controller:['$scope','$q','$translate','User','BillingRecordsService',function($scope,$q,$translate,User,BillingRecordsService){$scope.model={totalBillingRecords:data.totalRecords,totalAmount:data.totalAmount,customer:data.customer,approvalMessage:'',loading:false,loggedInUser:User.getUser().id,surchargeLoading:true,hasSurcharge:false,totalSurcharge:0,surchargeBreakdown:[]};$scope.type='success';var init=function init(){var bold=function bold(value){return'<b>'+value+'</b>';};var setApprovalMessage=function setApprovalMessage(){var total=($scope.model.totalAmount||0)+($scope.model.hasSurcharge?$scope.model.totalSurcharge:0);$scope.model.approvalMessage=$translate.instant('branch_mgmt.billing_approval.approval_message',(0,_assign2.default)({},$scope.model.totalBillingRecords>0?{totalRecords:bold(Number($scope.model.totalBillingRecords).toLocaleString('en-US'))}:null,{totalAmount:bold(total.toLocaleString('en-US',{style:'currency',currency:'USD'}))}));};setApprovalMessage();var selection=data.surchargeSelection;if(!selection||!selection.customerId){$scope.model.surchargeLoading=false;return;}BillingRecordsService.surchargePreview(selection.billingRecordIds,selection.isApproveAllRecords,selection.startDate,selection.endDate,selection.customerId,selection.locationId,selection.billingCategoryId).then(function(res){$scope.model.totalSurcharge=res&&res.totalSurcharge||0;$scope.model.surchargeBreakdown=(res&&res.surcharges||[]).map(function(surcharge){return{type:surcharge.type,labelKey:SURCHARGE_LABEL_KEYS[surcharge.type],intervalLabelKey:SURCHARGE_INTERVAL_LABEL_KEYS[surcharge.interval]||'',percentage:surcharge.percentage,maxPercentage:surcharge.maxPercentage,amount:surcharge.amount};});$scope.model.hasSurcharge=$scope.model.surchargeBreakdown.length>0;}).catch(function(){$scope.model.hasSurcharge=false;}).finally(function(){setApprovalMessage();$scope.model.surchargeLoading=false;});};$scope.cancel=function(){approveBillingRecordsModal.close();};$scope.ok=function(){// confirmSupervisor('approve-billing-records', null, ({ model, supId }) => {
callback({supervisorId:$scope.model.loggedInUser,modal:approveBillingRecordsModal,$scope:$scope});// model.close();
// }, ({ modal }) => {
//   // $scope.model.loading = false;
//   modal.close();
// })
};init();}]});rejectModal(approveBillingRecordsModal,negative);};var billableEventLogDetails=function billableEventLogDetails(data,callback,negative){var billableEventLogModal=$uibModal.open({template:_billableEventLog2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','BillingRecordsService','$translate','$state','$q','Navigation','CommonLayoutService',function($scope,BillingRecordsService,$translate,$state,$q,Navigation,CommonLayoutService){$scope.model={billingRecordDetails:data,loading:false,searchText:data.searchText,entryType:data.billableEvent,branchId:data.branchId,startDate:data.startDate,endDate:data.endDate,errorMsg:null,logDetails:[],recordType:data.recordType,locationId:data.locationId,vaultDate:data.vaultDate?moment.utc(data.vaultDate).format('YYYY-MM-DD'):null};var init=function init(){$scope.model.loading=true;var promises=null;if($scope.model.recordType=='MANUAL'){promises=BillingRecordsService.manuallyCreatedBillingRecordsLog($scope.model.billingRecordDetails.billingRecordId);}else if($scope.model.entryType==='stop-completed'){promises=BillingRecordsService.getEventLogs('create-route-progress',$scope.model.locationId,$scope.model.vaultDate,$scope.model.branchId);}else{promises=BillingRecordsService.billableEventLogDetails($scope.model.searchText.trackingId||$scope.model.searchText.serviceOrderId,$scope.model.entryType,$scope.model.branchId,$scope.model.startDate,$scope.model.endDate);}promises.then(function(data){$scope.model.logDetails=data.results;$scope.model.logDetails.forEach(function(log){if(log.entryData.hasOwnProperty('rate'))log.entryData.rate=CommonLayoutService.formatAmount(log.entryData.rate);if(log.entryData.hasOwnProperty('amount'))log.entryData.amount=CommonLayoutService.formatAmount(log.entryData.amount);if(log.entryData.hasOwnProperty('loadedAmount'))log.entryData.loadedAmount=CommonLayoutService.formatAmount(log.entryData.loadedAmount);if(log.entryData.hasOwnProperty('amountDue'))log.entryData.amountDue=CommonLayoutService.formatAmount(log.entryData.amountDue);log.readableEntryType=$translate.instant('entry_type.'+log.entryType);if(log.entryData){log.extraDetails=(0,_entries2.default)(log.entryData).map(function(entry){return{key:entry[0],value:(0,_typeof3.default)(entry[1])==='object'?(0,_stringify2.default)(entry[1]):entry[1]};});}});}).catch(function(err){console.error(err);if(err&&err.data&&err.data.message){$scope.model.errorMsg=err.data.message;}}).finally(function(){$scope.model.loading=false;});};$scope.translateMessage=function(prefix,key){if(!key)return;else if(key==='shipment-delivered')return $translate.instant('itemHolds.shipment_delivery');return $translate.instant(prefix.concat(key));};$scope.showShipmentReceipt=function(log,stats){var shipmentObj={};log.forEach(function(details){(0,_assign2.default)(shipmentObj,new Object((0,_defineProperty3.default)({},details.key,details.value)));});document.getElementById('shipment-image').blur();shipmentImageModal(shipmentObj,shipmentObj.trackingId,stats,function(_ref85){var modal=_ref85.modal;},function(_ref86){var modal=_ref86.modal;modal.close();});};$scope.goToContractRuleTab=function(contractId){$state.go('contract.edit',{id:contractId});};$scope.ok=function(){callback({modal:billableEventLogModal});model.close();};$scope.cancel=function(){negative({modal:billableEventLogModal});};$scope.goToItemHistory=function(searchText){if(searchText.trackingId){return Navigation.goToItemHistory(searchText.trackingId,billableEventLogModal);}if(searchText.encounterId){return Navigation.goToServiceTicket(searchText.encounterId,billableEventLogModal);}};init();}]});rejectModal(billableEventLogModal,negative);};var stopComments=function stopComments(routeId,vaultDate,locationId,callback,negative){var stopCommentsModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_stopComments2.default,size:'lg',controller:['$scope','$translate','RouteProgressService','$q','Navigation',function($scope,$translate,RouteProgressService,DataCounter,Navigation){$scope.model={vaultDate:vaultDate,routeId:routeId,loading:false,locationId:locationId,transactionDetails:[],errorMessage:null};var init=function init(){$scope.model.loading=true;RouteProgressService.getStopComments($scope.model.routeId,$scope.model.vaultDate,$scope.model.locationId).then(function(data){$scope.model.transactionDetails=data.results;}).catch(function(err){console.log(err);$scope.model.errorMessage=err.data.message;console.log('errorMessage',$scope.model.errorMessage);}).finally(function(){$scope.model.loading=false;});};$scope.goToItemHistory=function(trackingId){return Navigation.goToItemHistory(trackingId,stopCommentsModal);};$scope.translateTransactionType=function(transactionType){return $translate.instant('shipment.'+transactionType).toUpperCase();};$scope.cancel=function(){stopCommentsModal.close();};$scope.ok=function(){callback({modal:stopCommentsModal});modal.close();};init();}]});rejectModal(stopCommentsModal,negative);};var createLanguageMessage=function createLanguageMessage(messageObj,messageTypes,selectedLanguage,selectedMessageType,callback,negative){var createLanguageMessageModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_createLanguageMessage2.default,size:'lg',controller:['$scope','$translate','MessageService','User','LanguageService',function($scope,$translate,MessageService,User,LanguageService){$scope.model={messageObj:messageObj,loading:false,errorMessage:null,branchId:User.getUser().branchId,languages:null,languageMessageObj:{description:{},messageId:null,type:selectedMessageType},messageTypes:messageTypes,selectedLanguage:selectedLanguage,isCreate:false};var init=function init(){$scope.model.loading=true;LanguageService.all().then(function(response){$scope.model.languages=response.results;$scope.model.languages.map(function(language){$scope.model.languageMessageObj.description[language.id]='';});}).catch(function(err){console.log(err);$scope.model.errorMessage=err.data.message;}).finally(function(){$scope.model.loading=false;});};$scope.cancel=function(){createLanguageMessageModal.close();};$scope.ok=function(){$scope.model.isCreate=true;MessageService.create($scope.model.selectedLanguage,$scope.model.languageMessageObj,$scope.model.branchId).then(function(){callback({modal:createLanguageMessageModal});}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.isCreate=false;});};init();}]});rejectModal(createLanguageMessageModal,negative);};var FuelSurchargeCustomer=function FuelSurchargeCustomer(messageObj,callback,negative){var FuelSurchargeCustomerModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_createFuelSurchageCustomer2.default,size:'md',controller:['$scope','$translate','User','FuelSurchargeService',function($scope,$translate,User,FuelSurchargeService){$scope.customers=[];$scope.model={messageObj:messageObj,loading:false,errorMessage:null,branchId:User.getUser().branchId,isCreate:false,customer:null};var init=function init(){$scope.model.loading=true;$scope.loadCustomers();};$scope.loadCustomers=function(){$scope.customers=[];FuelSurchargeService.fuelSurchagePendingCustomers().then(function(res){if(res.result&&res.result.length){$scope.customers=res.result;}}).catch(function(err){console.log(err);});$scope.isLoading=false;};$scope.cancel=function(){// FuelSurchargeCustomerModal.close();
negative({modal:FuelSurchargeCustomerModal});};$scope.ok=function(){$scope.model.isLoading=true;callback({customer:(0,_assign2.default)($scope.model.customer,{isNew:true}),modal:FuelSurchargeCustomerModal});};init();}]});rejectModal(FuelSurchargeCustomerModal,negative);};var FuelSurchargeLocations=function FuelSurchargeLocations(fuelSurcharge,customerId,callback,negative){var FuelSurchargeLocationModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_fuelSurchargeLocations2.default,size:'lg',controller:['$scope','$translate','User','FuelSurchargeService','$state','Navigation',function($scope,$translate,User,FuelSurchargeService,$state,Navigation){$scope.locations=[];$scope.totalLocations=0;$scope.reverseSort=false;$scope.sortColumn='name';$scope.model={fuelSurcharge:fuelSurcharge,customerId:customerId,loading:false,errorMessage:null,branchId:User.getUser().branchId};$scope.icon={'REGULAR':'regular.png','ATM':'atm.png','BANK':'bank.png','NO_SHIP_NO_GO':'nsng.png','INTERNAL':'internal.png','TRUCK':'truck.png','TANKER':'tanker.png','WINDOW':'window.png','ON_CALL':'oncall.png','CARRIER':'carrier.png','LOCKER':'locker.png','VAULT':'vault.png','DELIVERY':'delivery.png'};$scope.loadImage=function(image){var imgURL=this.icon[image];return __webpack_require__(51)("./"+imgURL);};$scope.filter={// fuelSurchargeId: fuelSurcharge.id,
customerId:$scope.model.customerId,sortingKey:$scope.sortColumn,sortingDir:$scope.reverseSort,limit:10,page:1};var init=function init(){$scope.model.loading=true;$scope.loadLocations();};$scope.sortData=function(column){$scope.reverseSort=$scope.sortColumn==column?!$scope.reverseSort:false;$scope.sortColumn=column;$scope.loadLocations();};$scope.loadLocations=function(){$scope.model.isLoading=true;$scope.locations=[];FuelSurchargeService.fuelSurchargeLocations({'customerId':$scope.filter.customerId,'sortingKey':$scope.sortColumn,'sortingDir':$scope.reverseSort,'limit':$scope.filter.limit,'offset':($scope.filter.page-1)*$scope.filter.limit}).then(function(_ref87){var data=_ref87.data,count=_ref87.count;$scope.totalLocations=count;$scope.locations=data;$scope.model.isLoading=false;}).catch(function(err){$scope.model.errorMessage=err.message;$scope.model.isLoading=false;});};$scope.cancel=function(){negative({modal:FuelSurchargeLocationModal});};$scope.gotoLocation=function(locationId){Navigation.goToLocationTab(locationId,FuelSurchargeLocationModal);};$scope.ok=function(){$scope.model.isLoading=true;callback({modal:FuelSurchargeLocationModal});};init();}]});rejectModal(FuelSurchargeLocationModal,negative);};var routesInfoModal=function routesInfoModal(routeObj,supervisorScan,callback,negative){var routesInfo=$uibModal.open({template:_routesInfo2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','UsersService','User','RouteDetailService','TruckService','$q','DateUtil',function($scope,UsersService,User,RouteDetailService,TruckService,$q,DateUtil){$scope.model={routeId:routeObj.routeId,routeDate:moment.utc(routeObj.routeDate).format('YYYY-MM-DD'),lastReleasedDate:'',truck:null,messenger:null,branchId:routeObj.branchId,routeData:'',allowSupervisorScan:supervisorScan,leaveTime:'',arriveTime:'',begMiles:'',endMiles:'',currentTime:moment().format("HH:mm:ss"),curCheckoutTime:'',curLeaveTime:'',curArriveTime:'',curBegMiles:'',curEndMiles:'',leaveDate:'',arriveDate:'',curLeaveDate:'',curArriveDate:'',currentDate:moment(),curComplTime:'',curComplDate:'',complTime:'',complDate:'',restrictToTruck:false,restrictTruck:null};var userSearchObj=function userSearchObj(searchKey){var displayAppUserOnly=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branchId},{group:{rules:[{field:"id",condition:"like",data:"%"+searchKey+"%"},{field:"firstName",condition:"like",data:"%"+searchKey+"%"},{field:"lastName",condition:"like",data:"%"+searchKey+"%"}],operator:"OR"}}],operator:'AND'}};if(searchKey){searchObj.orderBy={order:[['id','ASC']]};}if(displayAppUserOnly){searchObj.queryJSON.rules.push({field:"downloadToHHT",condition:"=",data:true});}return searchObj.queryJSON.rules.length?searchObj:null;};var routeSearchObj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branchId},{field:"routeId",condition:"=",data:$scope.model.routeId},{field:"routeDate",condition:"=",data:$scope.model.routeDate}],operator:'AND'}};var init=function init(){$scope.loading=true;$q.all([RouteDetailService.all(routeSearchObj,0,1000)]).then(function(data){$scope.getTruckData('',0);$scope.getMessangerData('',0);$scope.routeDetailsData=data[0].results;$scope.routeDetailsData.forEach(function(routeData){$scope.model.routeData=routeData;$scope.model.restrictToTruck=routeData.route?routeData.route.restrictToTruck:false;$scope.model.restrictTruck=routeData.route?routeData.route.restrictTruck:null;var hasVehicle=routeData.vehicleId&&routeData.vehicle;var hasRestrictTruck=$scope.model.restrictToTruck&&$scope.model.restrictTruck&&$scope.model.restrictTruck.id;if(hasVehicle&&hasRestrictTruck&&routeData.vehicleId.trim()===$scope.model.restrictTruck.id.trim()){// Both available and the same — map Key/Value as normal
routeData.vehicle.Key=routeData.vehicleId.trim()+" | "+routeData.vehicle.make;routeData.vehicle.Value=routeData.vehicleId.trim();$scope.model.truckMismatch=false;}else if(hasRestrictTruck&&(!hasVehicle||routeData.vehicleId.trim()!==$scope.model.restrictTruck.id.trim())){// restrictToTruck is true but assigned truck differs (or missing) — override and warn user to save
routeData.vehicle={Key:$scope.model.restrictTruck.id.trim()+" | "+$scope.model.restrictTruck.make,Value:$scope.model.restrictTruck.id.trim()};$scope.model.truckMismatch=true;}else if(hasVehicle){// Normal case — no restriction, just map vehicle
routeData.vehicle.Key=routeData.vehicleId.trim()+" | "+routeData.vehicle.make;routeData.vehicle.Value=routeData.vehicleId.trim();$scope.model.truckMismatch=false;}$scope.model.truck=routeData.vehicle;$scope.model.messenger=mapData(routeData.messenger);$scope.model.lastReleasedDate=routeData.updatedAt;$scope.model.curCheckoutTime=routeData.checkoutTime?new Date(routeData.checkoutTime):null;$scope.model.curLeaveTime=routeData.leaveTime?new Date(routeData.leaveTime):null;$scope.model.curArriveTime=routeData.arrTime?new Date(routeData.arrTime):null;$scope.model.curBegMiles=routeData.begMiles;$scope.model.curEndMiles=routeData.endMiles;$scope.model.leaveTime=$scope.model.curLeaveTime?$scope.getTime(moment($scope.model.curLeaveTime).format('HH:mm:ss')):null;$scope.model.arriveTime=$scope.model.curArriveTime?$scope.getTime(moment($scope.model.curArriveTime).format('HH:mm:ss')):null;$scope.model.begMiles=$scope.model.curBegMiles;$scope.model.endMiles=$scope.model.curEndMiles;$scope.model.leaveDate=$scope.model.curLeaveTime?moment($scope.model.curLeaveTime):null;$scope.model.arriveDate=$scope.model.curArriveTime?moment($scope.model.curArriveTime):null;$scope.model.checkOutDate=routeData.checkoutTime?moment(routeData.checkoutTime).format('DD-MMM-YYYY'):null;$scope.model.checkOutTime=routeData.checkoutTime?moment(routeData.checkoutTime).format('hh:mm A'):null;$scope.model.curComplTime=routeData.complTime?new Date(routeData.complTime):null;$scope.model.complTime=$scope.model.curComplTime?$scope.getTime(moment($scope.model.curComplTime).format('HH:mm:ss')):null;$scope.model.complDate=$scope.model.curComplTime?moment($scope.model.curComplTime):null;$scope.maxDate={maxDate:$scope.model.currentDate,minDate:routeData.routeDate};});}).finally(function(){$scope.loading=false;}).catch(function(err){console.log(err);});};var mapData=function mapData(item){if(item==null)return item;item.Key=item.id+" | "+item.firstName+' '+item.lastName;item.Value=item.id;return item;};var mappingUserData=function mappingUserData(items,searchKey,model){var itemArray=[];items.map(function(item){item.Key=item.id+" | "+item.firstName+' '+item.lastName;item.Value=item.id;if(!searchKey){if(model){if(item.id!==model.Value){itemArray.push(item);}}else{itemArray.push(item);}}else{itemArray.push(item);}});return itemArray;};$scope.getMessangerData=function(searchKey,offset){var searchObj=userSearchObj(searchKey,true);// if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
//   offset = offset - 1;
// }
UsersService.all(searchObj,offset,100).then(function(data){if(offset===0||offset==undefined){$scope.messangerTotalRecord=data.total;$scope.messangerData=mappingUserData(data.results,searchKey,$scope.model.messenger);if(!searchKey&&$scope.model.messenger){$scope.messangerData.unshift($scope.model.messenger);}}else{var messanger=mappingUserData(data.results,searchKey,$scope.model.messenger);$scope.messangerData=$scope.messangerData.concat(messanger);}});};$scope.messengerSelected=function(){if($scope.model.messenger==null){$scope.model.driver=null;}else{if($scope.model.messenger&&$scope.model.driver){if($scope.model.messenger.id==$scope.model.driver.id){$scope.model.driver=null;}}}};$scope.getTruckData=function(searchKey,offset){searchKey=searchKey||'';if(offset!==0&&!searchKey&&Math.abs(offset%2)==1){offset=offset-1;}TruckService.getAllTrucks(searchKey,$scope.model.branchId,$scope.model.routeId,$scope.model.routeDate,_app2.default.defaultPageLimit,offset).then(function(data){if(offset===0||offset==undefined){$scope.totalRecord=data.total;$scope.truckData=mappingTruckData(data.results,searchKey);if(!searchKey&&$scope.model.truck){$scope.truckData.unshift($scope.model.truck);}}else{var truckData=mappingTruckData(data.results,searchKey);$scope.truckData=$scope.truckData.concat(truckData);}});};var mappingTruckData=function mappingTruckData(trucks,searchKey){var truckArray=[];trucks.map(function(truck){truck.Key=truck.id+" | "+truck.make;truck.Value=truck.id;if(!searchKey){if($scope.model.truck){if(truck.id!==$scope.model.truck.Value){truckArray.push(truck);}}else{truckArray.push(truck);}}else{truckArray.push(truck);}});return truckArray;};$scope.getTime=function(time){if(!time){return time;}time=time.split(':');var d=new Date();d.setHours(+time[0]);d.setMinutes(time[1]);d.setSeconds(0);d.setMilliseconds(0);return d;};$scope.cancel=function(){negative({modal:routesInfo});};$scope.clearLeaveFields=function(){$scope.model.leaveDate=null;$scope.model.leaveTime=null;$scope.model.curLeaveTime=null;delete $scope.leaveDateError;delete $scope.leaveTimeError;delete $scope.arriveDateError;delete $scope.arriveTimeError;$scope.validateArriveDate();$scope.validateArriveTime();};$scope.clearArriveFields=function(){$scope.model.arriveDate=null;$scope.model.arriveTime=null;$scope.model.curArriveTime=null;delete $scope.arriveDateError;delete $scope.arriveTimeError;delete $scope.complDateError;delete $scope.complTimeError;$scope.validateComplDate();$scope.validateComplTime();};$scope.getLeaveTime=function(){if(!$scope.model.leaveTime)return;var lvTime=$scope.model.leaveTime?moment($scope.model.leaveTime).format('HH:mm:ss'):null;var lvDate=$scope.model.leaveDate?moment($scope.model.leaveDate).format('YYYY-MM-DD'):null;var dt=lvDate+' '+lvTime;return dt;};$scope.getArriveTime=function(){if(!$scope.model.arriveTime)return;var arrTime=$scope.model.arriveTime?moment($scope.model.arriveTime).format('HH:mm:ss'):null;var arrDate=$scope.model.arriveDate?moment($scope.model.arriveDate).format('YYYY-MM-DD'):null;var arrDt=arrDate+' '+arrTime;return arrDt;};$scope.validateLeaveTime=function(){var leaveDateTime=$scope.getLeaveTime();var arriveDateTime=$scope.getArriveTime();var leaveMoment=moment(leaveDateTime,'YYYY-MM-DD HH:mm:ss').seconds(0).milliseconds(0);var checkoutMoment=moment($scope.model.curCheckoutTime).seconds(0).milliseconds(0);var leaveTime=leaveMoment.valueOf();var checkoutTime=checkoutMoment.valueOf();if(leaveTime<checkoutTime){delete $scope.arriveTimeError;$scope.leaveTimeError=$translate.instant('routeControl.leave_time_error');}else if($scope.model.arriveTime&&leaveTime>moment(arriveDateTime,'YYYY-MM-DD HH:mm:ss').valueOf()){delete $scope.arriveTimeError;$scope.leaveTimeError=$translate.instant('routeControl.leave_time_greater_than_arrive_time_error');}else{delete $scope.leaveTimeError;}if($scope.model.arriveDate)$scope.validateArriveDate();};$scope.validateArriveTime=function(){var leaveDateTime=$scope.getLeaveTime();var arriveDateTime=$scope.getArriveTime();var curArriveTime=moment(arriveDateTime).valueOf();var leaveTime=moment(leaveDateTime).valueOf();if($scope.model.arriveTime&&!$scope.model.leaveTime){$scope.arriveTimeError=$translate.instant('routeControl.leave_time_error');}else if($scope.model.arriveTime&&curArriveTime<leaveTime){delete $scope.leaveTimeError;$scope.arriveTimeError=$translate.instant('routeControl.arrive_time_error');}else delete $scope.arriveTimeError;};$scope.validateMileage=function(){var begMiles=$scope.model.begMiles;var endMiles=$scope.model.endMiles;if(endMiles!==undefined&&endMiles!==null&&endMiles<begMiles)$scope.mileageError=$translate.instant('routeControl.miles_error');else delete $scope.mileageError;};$scope.validateLeaveDate=function(){if(!$scope.model.leaveDate)return;var checkoutDate=moment($scope.model.curCheckoutTime).format('YYYY-MM-DD');var leaveDate=moment($scope.model.leaveDate).format('YYYY-MM-DD');if(leaveDate<checkoutDate)$scope.leaveDateError=$translate.instant('routeControl.leave_date_error');else delete $scope.leaveDateError;$scope.validateLeaveTime();};$scope.validateArriveDate=function(){if(!$scope.model.arriveDate)return;var curArriveDate=moment($scope.model.arriveDate).format('YYYY-MM-DD');var leaveDate=moment($scope.model.leaveDate).format('YYYY-MM-DD');if(!$scope.model.leaveDate){$scope.arriveDateError=$translate.instant('routeControl.leave_date_error');}else if(curArriveDate<leaveDate){$scope.arriveDateError=$translate.instant('routeControl.arrive_date_error');}else{delete $scope.arriveDateError;}$scope.validateArriveTime();};$scope.getComplTime=function(){if(!$scope.model.complTime)return;var complTime=$scope.model.complTime?moment($scope.model.complTime).format('HH:mm:ss'):null;var complDate=$scope.model.complDate?moment($scope.model.complDate).format('YYYY-MM-DD'):null;var dt=complDate+' '+complTime;return dt;};$scope.validateComplTime=function(){var arriveDateTime=$scope.getArriveTime();var curArriveTime=moment(arriveDateTime).valueOf();var complDateTime=$scope.getComplTime();var curComplTime=moment(complDateTime).valueOf();if($scope.model.complTime&&curComplTime<curArriveTime){delete $scope.leaveTimeError;delete $scope.arriveTimeError;delete $scope.complDateError;$scope.complTimeError=$translate.instant('routeControl.compl_time_error');}else delete $scope.complTimeError;};$scope.validateComplDate=function(){if(!$scope.model.complDate)return;var curComplDate=moment($scope.model.complDate).format('YYYY-MM-DD');var arriveDate=moment($scope.model.arriveDate).format('YYYY-MM-DD');if(!$scope.model.curArriveTime&&!$scope.model.arriveTime)return;else if(curComplDate<arriveDate)$scope.complDateError=$translate.instant('routeControl.compl_date_error');else delete $scope.complDateError;$scope.validateComplTime();};$scope.isError=function(){return $scope.leaveTimeError||$scope.arriveTimeError||$scope.mileageError||$scope.leaveDateError||$scope.arriveDateError||$scope.complDateError||$scope.complTimeError;};$scope.validateRouteDetailForm=function(){return $scope.model.leaveDate&&!$scope.model.leaveTime||$scope.model.arriveDate&&!$scope.model.arriveTime||$scope.model.arriveDate&&$scope.model.arriveTime&&!$scope.model.endMiles||$scope.model.leaveDate&&$scope.model.leaveTime&&!$scope.model.truck;};$scope.ok=function(err){var leaveDate=$scope.model.leaveDate&&$scope.model.leaveTime?moment($scope.model.leaveDate).format('YYYY-MM-DD'):null;var leaveTime=$scope.model.leaveDate&&$scope.model.leaveTime?moment($scope.model.leaveTime).format('HH:mm:ss'):null;var arriveDate=$scope.model.arriveDate&&$scope.model.arriveTime?moment($scope.model.arriveDate).format('YYYY-MM-DD'):null;var arriveTime=$scope.model.arriveDate&&$scope.model.arriveTime?moment($scope.model.arriveTime).format('HH:mm:ss'):null;var complDate=$scope.model.complDate&&$scope.model.complTime?moment($scope.model.complDate).format('YYYY-MM-DD'):null;var complTime=$scope.model.arriveDate&&$scope.model.complTime?moment($scope.model.complTime).format('HH:mm:ss'):null;if(leaveDate&&leaveTime&&$scope.model.curCheckoutTime){var leaveMoment=moment(leaveDate+' '+leaveTime,'YYYY-MM-DD HH:mm:ss');var checkoutMoment=moment($scope.model.curCheckoutTime);if(leaveMoment.isValid()&&checkoutMoment.isValid()&&leaveMoment.format('YYYY-MM-DD HH:mm')===checkoutMoment.format('YYYY-MM-DD HH:mm')){leaveMoment.seconds(checkoutMoment.seconds());leaveTime=leaveMoment.format('HH:mm:ss');}}if(arriveDate&&arriveTime&&leaveDate&&leaveTime){var arriveMoment=moment(arriveDate+' '+arriveTime,'YYYY-MM-DD HH:mm:ss');var _leaveMoment2=moment(leaveDate+' '+leaveTime,'YYYY-MM-DD HH:mm:ss');if(arriveMoment.isValid()&&_leaveMoment2.isValid()&&arriveMoment.format('YYYY-MM-DD HH:mm')===_leaveMoment2.format('YYYY-MM-DD HH:mm')&&arriveMoment.seconds()===0){arriveMoment.seconds(_leaveMoment2.seconds());arriveTime=arriveMoment.format('HH:mm:ss');}}var leaveDateTime=leaveDate?leaveDate+' '+leaveTime:null;var arriveDateTime=arriveDate?arriveDate+' '+arriveTime:null;var complDateTime=complDate?complDate+' '+complTime:null;$scope.model.allowSupervisorScan=supervisorScan||$scope.model.curComplTime&&($scope.model.begMiles!==$scope.model.curBegMiles||$scope.model.endMiles!==$scope.model.curEndMiles);$scope.isLoading=true;verifySupervisorScan('route-details',null,$scope).then(function(supervisorInfo){$scope.loading=true;callback({truck:$scope.model.truck?$scope.model.truck.Value:$scope.model.truck,messenger:$scope.model.messenger?$scope.model.messenger.Value:$scope.model.messenger,leaveTime:leaveDateTime,arriveTime:arriveDateTime,complTime:complDateTime,begMiles:$scope.model.begMiles,endMiles:$scope.model.endMiles,supervisorId:supervisorInfo?supervisorInfo.supId:null,modal:routesInfo});$scope.isLoading=false;if(supervisorInfo)supervisorInfo.modal.close();});};init();}]});routesInfo.result.then(function(){},function(){negative({modal:routesInfo});});};var editDeliveryShipment=function editDeliveryShipment(data,branchTimezone,callback,negative){var editDeliveryShipmentModal=$uibModal.open({template:_editDeliveryShipment2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q','RouteService','ShiptypeService','DateUtil','LocationService','DenominationService',function($scope,$q,RouteService,ShiptypeService,DateUtil,LocationService,DenominationService){$scope.model={shipment:data,loading:false,routeListObj:{routeList:[],totalRecords:0},locationListObj:{locationList:[],totalRecords:0,loadLocations:true},shipTypeListObj:{shipTypeList:[],totalRecords:0,loadShipTypes:true},denomObj:{denomList:[],totalRecords:0,loadDenoms:true},shipmentUpdateObj:{oldTrackingId:data.trackingId,newTrackingId:data.trackingId,vaultDate:DateUtil.convertToDate(data.vaultDate),selectedRoute:null,fromLocationId:null,toLocationId:null,deliveryDate:null,deliveryTime:null,amount:data.amount,loadedAmount:data.loadedAmount,qty:data.qty?data.qty:1,comments:null,undoDelivery:false,shiptypeId:null},amountExceeds:false,deliveryDateTimeRequired:false,branchTimezone:branchTimezone};var init=function init(){$scope.model.loading=true;$q.all([$scope.getRouteList('',0),$scope.getShipTypeList('',0),$scope.getLocationList('',0),$scope.getDenominationList()]).then(function(){var shipmentDetail=$scope.model.shipment;var deliveryDate=shipmentDetail.deliveryDate;$scope.model.minVaultDate={minDate:shipmentDetail.vaultDate};$scope.model.minDeliveryDate={minDate:deliveryDate};$scope.model.shipmentUpdateObj.selectedRoute={Key:shipmentDetail.routeName,Value:shipmentDetail.routeId};$scope.model.shipmentUpdateObj.fromLocationId={Key:shipmentDetail.fromLocationId+' | '+shipmentDetail.fromLocationName,Value:shipmentDetail.fromLocationId};$scope.model.shipmentUpdateObj.toLocationId={Key:shipmentDetail.toLocationId+' | '+shipmentDetail.toLocationName,Value:shipmentDetail.toLocationId};$scope.model.shipmentUpdateObj.selectedShipType={Key:shipmentDetail.shiptypeId+' | '+shipmentDetail.shipTypeDescription,Value:shipmentDetail.shiptypeId,faceValue:shipmentDetail.orderNo?shipmentDetail.DenomFaceValue:shipmentDetail.shipTypeFaceValue};if(deliveryDate){var time=moment(deliveryDate).tz($scope.model.branchTimezone).format('HH:mm:ss');var validatationTime=moment.utc(deliveryDate).format('HH:mm:ss');if(validatationTime==='00:00:00'){$scope.model.shipmentUpdateObj.deliveryTime=null;$scope.model.shipmentUpdateObj.deliveryDate=moment(deliveryDate,'YYYY-MM-DD').toDate();}else{$scope.model.shipmentUpdateObj.deliveryTime=DateUtil.getTime(time);var dateString=moment(deliveryDate).tz($scope.model.branchTimezone).format('YYYY-MM-DD');$scope.model.shipmentUpdateObj.deliveryDate=moment(dateString,'YYYY-MM-DD').toDate();}}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}}).finally(function(){$scope.model.loading=false;});};$scope.getDenominationList=function(){var searchObj={queryJSON:{rules:[{field:'currencyId',condition:'=',data:'USD'}],operator:'AND'}};DenominationService.all(searchObj,0,1000).then(function(res){$scope.model.denomObj.denomList=res.results;$scope.model.denomObj.totalRecords=res.total;}).catch(function(err){console.log(err);});};$scope.getRouteList=function(searchKey,offset){searchKey=searchKey||'';var routeSearchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.shipment.branchId},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};return RouteService.all(routeSearchObj,offset,100).then(function(data){if(offset===0||offset==undefined){$scope.model.routeListObj.totalRecords=data.total;$scope.model.routeListObj.routeList=$scope.mapData(data.results);}else{var routes=$scope.mapData(data.results);$scope.model.routeListObj.routeList=$scope.model.routeListObj.routeList.concat(routes);}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}});};$scope.mapData=function(routes){return routes.map(function(route){return{Key:route.name,Value:route.id};});};$scope.getShipTypeList=function(searchKey,offset){searchKey=searchKey||'';var shipTypeSearchObj={queryJSON:{rules:[{field:'status',condition:'=',data:true},{field:'coinFlag',// Add coinFlag condition
condition:'=',data:true},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'description',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};// $scope.model.shipTypeListObj.loadShipTypes = true;
return ShiptypeService.all(shipTypeSearchObj,offset,100).then(function(data){if(offset===0||offset==undefined){$scope.model.shipTypeListObj.totalRecords=data.total;$scope.model.shipTypeListObj.shipTypeList=$scope.shipTypeDataMapping(data.results);}else{var shipTypes=$scope.shipTypeDataMapping(data.results);$scope.model.shipTypeListObj.shipTypeList=$scope.model.shipTypeListObj.shipTypeList.concat(shipTypes);}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}});// .finally(() => {
//   $scope.model.shipTypeListObj.loadShipTypes = false;
// })
};$scope.shipTypeDataMapping=function(shipTypes){return shipTypes.map(function(shipType){return{Key:shipType.id+' | '+shipType.description,Value:shipType.id,faceValue:shipType.amountFlag?shipType.amount:shipType.unitValue};});};$scope.getLocationList=function(searchKey,offset){searchKey=searchKey||'';var locationSearchObj={queryJSON:{rules:[{field:'active',condition:'=',data:true},{field:'branchId',condition:'=',data:$scope.model.shipment.branchId},{field:'locationType',condition:'IN',data:['ATM','NO_SHIP_NO_GO','REGULAR','BANK','INTERNAL','CARRIER','ON_CALL','LOCKER','VAULT','DELIVERY']},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};$scope.model.locationListObj.loading=true;return LocationService.all(locationSearchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.locationListObj.totalRecords=data.total;$scope.model.locationListObj.locationList=$scope.locationMapping(data.results);}else{var location=$scope.locationMapping(data.results);$scope.model.locationListObj.locationList=$scope.model.locationListObj.locationList.concat(location);}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}}).finally(function(){$scope.model.locationListObj.loading=false;});};$scope.locationMapping=function(location){return location.map(function(loc){return{Key:loc.id+' | '+loc.name,Value:loc.id};});};$scope.$watch('model.shipmentUpdateObj.selectedShipType',function(newValue,oldValue){if(newValue!==oldValue){$scope.validateLoadedAmount();}});$scope.validateLoadedAmount=function(){var loadShipmentAmount=null;if($scope.model.shipment.coinFlag&&$scope.model.shipment.shiptypeId!=='C'&&!$scope.model.shipment.orderNo&&$scope.model.shipmentUpdateObj.selectedShipType){loadShipmentAmount=$scope.model.shipmentUpdateObj.qty*$scope.model.shipmentUpdateObj.selectedShipType.faceValue;$scope.model.shipmentUpdateObj.amount=loadShipmentAmount;}else if($scope.model.shipment.coinFlag&&$scope.model.shipment.shiptypeId!=='C'&&$scope.model.shipment.orderNo&&$scope.model.shipmentUpdateObj.selectedShipType){var matchingDenom=$scope.model.denomObj.denomList.find(function(denom){return denom.id===$scope.model.shipmentUpdateObj.selectedShipType.Value;});if(matchingDenom){loadShipmentAmount=$scope.model.shipmentUpdateObj.qty*matchingDenom.faceValue;$scope.model.shipmentUpdateObj.amount=loadShipmentAmount;}}else{loadShipmentAmount=$scope.model.shipmentUpdateObj.amount;}var loadedAmount=$scope.model.shipmentUpdateObj.loadedAmount;if(loadedAmount>loadShipmentAmount)return $scope.model.amountExceeds=true;else $scope.model.amountExceeds=false;};$scope.validateEditDeliveryForm=function(){var shipmentObj=$scope.model.shipmentUpdateObj;return!shipmentObj.newTrackingId||!shipmentObj.vaultDate||!shipmentObj.selectedRoute||shipmentObj.amount===null||!shipmentObj.comments||!shipmentObj.fromLocationId||!shipmentObj.toLocationId||!shipmentObj.qty||!shipmentObj.selectedShipType;};$scope.removeDeliveryDate=function(){setTimeout(function(){if($scope.model.shipmentUpdateObj.undoDelivery){$scope.model.shipmentUpdateObj.deliveryDate=null;$scope.model.shipmentUpdateObj.deliveryTime=null;$scope.model.shipmentUpdateObj.loadedAmount=null;}else if($scope.model.shipment.deliveryDate&&!$scope.model.shipmentUpdateObj.undoDelivery){var time=moment($scope.model.shipment.deliveryDate).format('HH:mm:ss');$scope.model.shipmentUpdateObj.deliveryDate=$scope.model.shipment.deliveryDate;$scope.model.shipmentUpdateObj.deliveryTime=DateUtil.getTime(time);$scope.model.shipmentUpdateObj.loadedAmount=$scope.model.shipment.loadedAmount;}$scope.$apply();},100);};$scope.restrictShipmentUpdate=function(shipmentVaultDate,branchCurrentVaultDate){return moment(shipmentVaultDate).isBefore(branchCurrentVaultDate);};$scope.validateDeliveryDateTime=function(){if($scope.model.deliveryDateTimeRequired===true){$scope.model.deliveryDateTimeRequired=$scope.model.shipment.status==='shipment.hold'&&(!$scope.model.shipmentUpdateObj.deliveryDate||!$scope.model.shipmentUpdateObj.deliveryTime);}};$scope.ok=function(updateState){var shipmentObj=$scope.model.shipment;var shipmentUpdateObj=_.cloneDeep($scope.model.shipmentUpdateObj);if(updateState==='mark_delivered'&&(!$scope.model.shipmentUpdateObj.deliveryDate||!$scope.model.shipmentUpdateObj.deliveryTime)){$scope.model.deliveryDateTimeRequired=true;return;}else{$scope.model.deliveryDateTimeRequired=false;}confirmSupervisor('update-delivery-shipment',{trackingId:$scope.model.trackingId},function(_ref88){var modal=_ref88.modal,supId=_ref88.supId;shipmentUpdateObj.updatedDeliveryDate=shipmentUpdateObj.deliveryDate?moment(shipmentUpdateObj.deliveryDate).format('YYYY-MM-DD'):null;shipmentUpdateObj.updatedDeliveryTime=shipmentUpdateObj.deliveryTime?moment(shipmentUpdateObj.deliveryTime).format('HH:mm:ss'):null;shipmentUpdateObj.updatedVaultDate=moment(shipmentUpdateObj.vaultDate).format('YYYY-MM-DD');shipmentUpdateObj.previousDeliveryDate=shipmentObj.deliveryDate;shipmentUpdateObj.previousVaultDate=moment.utc(shipmentObj.vaultDate).format('YYYY-MM-DD');shipmentUpdateObj.previousRouteId=shipmentObj.routeId;shipmentUpdateObj.previousShipmentAmount=shipmentObj.amount;shipmentUpdateObj.updatedShipmentAmount=shipmentUpdateObj.amount;shipmentUpdateObj.previousLoadedAmount=shipmentObj.loadedAmount;shipmentUpdateObj.updatedLoadedAmount=!(shipmentUpdateObj.loadedAmount===''||shipmentUpdateObj.loadedAmount===undefined)?shipmentUpdateObj.loadedAmount:null;shipmentUpdateObj.branchTimezone=$scope.model.branchTimezone;shipmentUpdateObj.branchId=shipmentObj.branchId;shipmentUpdateObj.updateRouteId=shipmentUpdateObj.selectedRoute?shipmentUpdateObj.selectedRoute.Value:null;shipmentUpdateObj.supervisorUserId=supId;shipmentUpdateObj.fromLocationId=shipmentUpdateObj.fromLocationId?shipmentUpdateObj.fromLocationId.Value:null;shipmentUpdateObj.toLocationId=shipmentUpdateObj.toLocationId?shipmentUpdateObj.toLocationId.Value:null;shipmentUpdateObj.status=shipmentObj.status;shipmentUpdateObj.shiptypeId=shipmentUpdateObj.selectedShipType?shipmentUpdateObj.selectedShipType.Value:null;shipmentUpdateObj.browserTimezone=moment.tz.guess();shipmentUpdateObj.qty=Number(shipmentObj.coinFlag?shipmentUpdateObj.qty?shipmentUpdateObj.qty:1:shipmentObj.qty?shipmentObj.qty:1);callback({modal:editDeliveryShipmentModal,shipments:shipmentUpdateObj,updateState:updateState,$scope:$scope});modal.close();},function(_ref89){var modal=_ref89.modal;modal.close();});};$scope.cancel=function(){negative({modal:editDeliveryShipmentModal,$scope:$scope});};init();}]});rejectModal(editDeliveryShipmentModal,negative);};var sendStopReceipt=function sendStopReceipt(locationEmail,callback,negative){var printStopReceiptModal=$uibModal.open({template:_sendStopReceipt2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope',function($scope){$scope.model={providedEmail:locationEmail,loading:false};var init=function init(){focusElementById('email');};$scope.ok=function(){$scope.model.loading=true;callback({modal:printStopReceiptModal,providedEmail:$scope.model.providedEmail,$scope:$scope});};$scope.cancel=function(){negative({modal:printStopReceiptModal,$scope:$scope});};init();}]});rejectModal(printStopReceiptModal,negative);};var editPickupShipment=function editPickupShipment(data,branchTimezone,callback,negative){var editPickupShipmentModal=$uibModal.open({template:_editPickupShipment2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q','RouteService','DateUtil','ShiptypeService','LocationService',function($scope,$q,RouteService,DateUtil,ShiptypeService,LocationService){$scope.model={shipment:data,loading:false,routeListObj:{routeList:[],totalRecords:0,loadRoutes:true},shipTypeListObj:{shipTypeList:[],totalRecords:0,loadShipTypes:true},locationListObj:{locationList:[],totalRecords:0,loadLocations:true},shipmentUpdateObj:{oldTrackingId:data.trackingId,newTrackingId:data.trackingId,vaultDate:DateUtil.convertToDate(data.vaultDate),selectedRoute:null,selectedShipType:null,fromLocationId:null,toLocationId:null,pickupDate:null,pickupTime:null,amount:data.amount,comments:null},amountExceeds:false,branchTimezone:branchTimezone};var init=function init(){$q.all([$scope.getRouteList('',0),$scope.getShipTypeList('',0),$scope.getLocationList('',0)]).then(function(){var shipmentDetail=$scope.model.shipment;var pickupDate=shipmentDetail.pickupDate;$scope.model.routeListObj.loadRoutes=false;$scope.model.shipTypeListObj.loadShipTypes=false;$scope.model.locationListObj.loadLocations=false;$scope.model.minVaultDate={minDate:shipmentDetail.vaultDate};$scope.model.minPickupDate={minDate:pickupDate};$scope.model.shipmentUpdateObj.selectedRoute={Key:shipmentDetail.routeName,Value:shipmentDetail.routeId};$scope.model.shipmentUpdateObj.selectedShipType={Key:shipmentDetail.description,Value:shipmentDetail.shiptypeId};$scope.model.shipmentUpdateObj.fromLocationId={Key:shipmentDetail.fromLocationId+' | '+shipmentDetail.fromLocationName,Value:shipmentDetail.fromLocationId};$scope.model.shipmentUpdateObj.toLocationId={Key:shipmentDetail.toLocationId+' | '+shipmentDetail.toLocationName,Value:shipmentDetail.toLocationId};// if (pickupDate) {
//   const time = moment(pickupDate).format('HH:mm:ss');
//   $scope.model.shipmentUpdateObj.pickupDate = pickupDate;
//   $scope.model.shipmentUpdateObj.pickupTime = DateUtil.getTime(time);
// }
if(pickupDate){var time=moment(pickupDate).tz($scope.model.branchTimezone).format('HH:mm:ss');var validatationTime=moment.utc(pickupDate).format('HH:mm:ss');if(validatationTime==='00:00:00'){$scope.model.shipmentUpdateObj.pickupTime=null;$scope.model.shipmentUpdateObj.pickupDate=moment(pickupDate,'YYYY-MM-DD').toDate();}else{$scope.model.shipmentUpdateObj.pickupTime=DateUtil.getTime(time);var dateString=moment(pickupDate).tz($scope.model.branchTimezone).format('YYYY-MM-DD');$scope.model.shipmentUpdateObj.pickupDate=moment(dateString,'YYYY-MM-DD').toDate();}}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}});};$scope.getRouteList=function(searchKey,offset){searchKey=searchKey||'';var routeSearchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.shipment.branchId},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};// $scope.model.routeListObj.loadRoutes = true;
return RouteService.all(routeSearchObj,offset,100).then(function(data){if(offset===0||offset==undefined){$scope.model.routeListObj.totalRecords=data.total;$scope.model.routeListObj.routeList=$scope.routeDataMapping(data.results);// if (!searchKey && $scope.model.shipmentUpdateObj.selectedRoute) {
//   $scope.model.routeListObj.routeList.unshift($scope.model.shipmentUpdateObj.selectedRoute);
// }
}else{var routes=$scope.routeDataMapping(data.results);$scope.model.routeListObj.routeList=$scope.model.routeListObj.routeList.concat(routes);}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}});// .finally(() => {
//   $scope.model.routeListObj.loadRoutes = false;
// })
};$scope.routeDataMapping=function(routes){return routes.map(function(route){return{Key:route.name,Value:route.id};});};$scope.getShipTypeList=function(searchKey,offset){searchKey=searchKey||'';var shipTypeSearchObj={queryJSON:{rules:[{field:'status',condition:'=',data:true},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'description',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};// $scope.model.shipTypeListObj.loadShipTypes = true;
return ShiptypeService.all(shipTypeSearchObj,offset,100).then(function(data){if(offset===0||offset==undefined){$scope.model.shipTypeListObj.totalRecords=data.total;$scope.model.shipTypeListObj.shipTypeList=$scope.shipTypeDataMapping(data.results);}else{var shipTypes=$scope.shipTypeDataMapping(data.results);$scope.model.shipTypeListObj.shipTypeList=$scope.model.shipTypeListObj.shipTypeList.concat(shipTypes);}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}});// .finally(() => {
//   $scope.model.shipTypeListObj.loadShipTypes = false;
// })
};$scope.shipTypeDataMapping=function(shipTypes){return shipTypes.map(function(shipType){return{Key:shipType.description,Value:shipType.id};});};$scope.getLocationList=function(searchKey,offset){searchKey=searchKey||'';var locationSearchObj={queryJSON:{rules:[{field:'active',condition:'=',data:true},{field:'branchId',condition:'=',data:$scope.model.shipment.branchId},{field:'locationType',condition:'IN',data:['ATM','NO_SHIP_NO_GO','REGULAR','BANK','INTERNAL','CARRIER','ON_CALL','LOCKER','VAULT','DELIVERY']},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};$scope.model.locationListObj.loading=true;return LocationService.all(locationSearchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.locationListObj.totalRecords=data.total;$scope.model.locationListObj.locationList=$scope.locationMapping(data.results);}else{var location=$scope.locationMapping(data.results);$scope.model.locationListObj.locationList=$scope.model.locationListObj.locationList.concat(location);}}).catch(function(err){if(err&&err.data&&err.data.message){Modal.errorModal(err.data.message);}}).finally(function(){$scope.model.locationListObj.loading=false;});};$scope.locationMapping=function(location){return location.map(function(loc){return{Key:loc.id+' | '+loc.name,Value:loc.id};});};$scope.validateEditPickupForm=function(){var shipmentObj=$scope.model.shipmentUpdateObj;return!shipmentObj.newTrackingId||!shipmentObj.vaultDate||!shipmentObj.selectedRoute||!shipmentObj.pickupDate||!shipmentObj.pickupTime||shipmentObj.amount===null||!shipmentObj.comments||!shipmentObj.selectedShipType||!shipmentObj.fromLocationId||!shipmentObj.toLocationId;};$scope.ok=function(){var shipmentObj=$scope.model.shipment;var shipmentUpdateObj=_.cloneDeep($scope.model.shipmentUpdateObj);confirmSupervisor('update-pickup-shipment',{trackingId:$scope.model.trackingId},function(_ref90){var modal=_ref90.modal,supId=_ref90.supId;shipmentUpdateObj.updatedPickupDate=moment(shipmentUpdateObj.pickupDate).format('YYYY-MM-DD');shipmentUpdateObj.updatedPickupTime=moment(shipmentUpdateObj.pickupTime).format('HH:mm:ss');shipmentUpdateObj.updatedVaultDate=moment(shipmentUpdateObj.vaultDate).format('YYYY-MM-DD');shipmentUpdateObj.previousPickupDate=shipmentObj.pickupDate;shipmentUpdateObj.previousVaultDate=moment.utc(shipmentObj.vaultDate).format('YYYY-MM-DD');shipmentUpdateObj.previousRouteId=shipmentObj.routeId;shipmentUpdateObj.previousShipmentAmount=shipmentObj.amount;shipmentUpdateObj.previousShipTypeId=shipmentObj.shiptypeId;shipmentUpdateObj.updatedShipmentAmount=shipmentUpdateObj.amount;shipmentUpdateObj.previousLoadedAmount=shipmentObj.loadedAmount;shipmentUpdateObj.updatedLoadedAmount=!(shipmentUpdateObj.loadedAmount===''||shipmentUpdateObj.loadedAmount===undefined)?shipmentUpdateObj.loadedAmount:null;shipmentUpdateObj.branchTimezone=$scope.model.branchTimezone;shipmentUpdateObj.browserTimezone=moment.tz.guess();shipmentUpdateObj.branchId=shipmentObj.branchId;shipmentUpdateObj.updateRouteId=shipmentUpdateObj.selectedRoute?shipmentUpdateObj.selectedRoute.Value:null;shipmentUpdateObj.supervisorUserId=supId;shipmentUpdateObj.updatedShipTypeId=shipmentUpdateObj.selectedShipType?shipmentUpdateObj.selectedShipType.Value:null;shipmentUpdateObj.fromLocationId=shipmentUpdateObj.fromLocationId?shipmentUpdateObj.fromLocationId.Value:null;shipmentUpdateObj.toLocationId=shipmentUpdateObj.toLocationId?shipmentUpdateObj.toLocationId.Value:null;callback({modal:editPickupShipmentModal,shipments:shipmentUpdateObj,$scope:$scope});modal.close();},function(_ref91){var modal=_ref91.modal;modal.close();});};$scope.cancel=function(){negative({modal:editPickupShipmentModal,$scope:$scope});};init();}]});rejectModal(editPickupShipmentModal,negative);};var shipmentAssociateToTanker=function shipmentAssociateToTanker(shipmentAssociateToTankerList,scannedTankerId,callback,negative){var shipmentAssociateToTankerModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_shipmentAssociateToTanker2.default,size:'lg',controller:['$scope','$translate',function($scope,$translate){$scope.model={shipmentAssociateToTankerList:shipmentAssociateToTankerList,tankerId:scannedTankerId,loading:false};var init=function init(){};$scope.cancel=function(){shipmentAssociateToTankerModal.close();};$scope.ok=function(){callback({modal:shipmentAssociateToTankerModal,$scope:$scope});};init();}]});};var uploadFiles=function uploadFiles(callback,negative){var uploadFilesModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_uploadFiles2.default,size:'md',controller:['$scope','$translate','ShipmentService',function($scope,$translate,ShipmentService){$scope.model={loading:false,selectedFiles:[]};var init=function init(){};$scope.cancel=function(){uploadFilesModal.close();};$scope.ok=function(){callback({modal:uploadFilesModal,data:$scope.model.selectedFiles.filter(function(d){return delete d._file;})});uploadFilesModal.close();};$scope.removeSelectedFiles=function(index){$scope.model.selectedFiles.splice(index,1);};$scope.downloadFile=function(){$scope.model.isDownloading=true;return ShipmentService.getBatchTemplateFile().then(function(data){var a=document.createElement("a");document.body.appendChild(a);var file=new Blob([data.results],{type:'text/csv'});var fileURL=window.URL.createObjectURL(file);a.href=fileURL;a.download=data.fileName;a.click();}).catch(function(err){console.log(err);}).finally(function(){$scope.model.isDownloading=false;});};init();}]});rejectModal(uploadFilesModal,negative);};var uploadContractDocuments=function uploadContractDocuments(stat,selectedFiles,callback,negative){var uploadDocumentModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',keyboard:false,template:_uploadContractDocument2.default,size:'md',controller:['$scope','$translate','CustomerService','CommonLayoutService','Modal',function($scope,$translate,CustomerService,CommonLayoutService,Modal){$scope.model={loading:false,selectedFiles:selectedFiles,stat:stat};var init=function init(){return $scope.model.stat==='create'?'Save':'Upload';};$scope.cancel=function(){$scope.model.selectedFiles=[];negative({modal:uploadDocumentModal,data:$scope.model.selectedFiles});};$scope.ok=function(){$scope.model.loading=true;callback({modal:uploadDocumentModal,data:$scope.model.selectedFiles,$scope:$scope});};$scope.removeSelectedFiles=function(index){$scope.model.selectedFiles.splice(index,1);};$scope.formatFileSize=function(bytes,decimalPoint){return CommonLayoutService.formatFileSize(bytes);};init();}]});rejectModal(uploadDocumentModal,negative);};var viewContractDocuments=function viewContractDocuments(customerId,callback,negative){var customerDocumentModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',keyboard:false,template:_viewContractDocument2.default,size:'md',controller:['$scope','$translate','CustomerService','CommonLayoutService','Modal','User',function($scope,$translate,CustomerService,CommonLayoutService,Modal,User){$scope.model={loading:false,selectedFile:'',uploadedFiles:[],customerId:customerId,isDeleting:false,isDownloading:false,isPrint:false,branchId:User.getUser().branchId};var init=function init(){$scope.model.loading=true;CustomerService.getUploadedDocument($scope.model.customerId).then(function(res){$scope.model.uploadedFiles=res.files;}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.cancel=function(){negative({modal:customerDocumentModal,data:$scope.model.uploadedFiles});};$scope.ok=function(){callback({modal:customerDocumentModal,data:$scope.model.uploadedFiles});customerDocumentModal.close();};$scope.displaySelectedFiles=function(fileName){$scope.model.isPrint=true;CustomerService.viewContractDocument($scope.model.customerId,fileName).then(function(){}).catch(function(err){console.log(err);}).finally(function(){$scope.model.isPrint=false;});};$scope.downloadSelectedFiles=function(fileName){$scope.model.isDownloading=true;CustomerService.downloadContractDocument($scope.model.customerId,fileName).then(function(){}).catch(function(err){console.log(err);}).finally(function(){$scope.model.isDownloading=false;});};$scope.removeSelectedFiles=function(fileName,index){Modal.confirm({header:$translate.instant('common.confirm_delete_title'),message:$translate.instant('common.confirm_delete_message'),callback:function callback(_ref92){var modal=_ref92.modal;$scope.model.isDeleting=true;CustomerService.deleteContractDocument($scope.model.customerId,fileName,$scope.model.branchId).then(function(){$scope.model.uploadedFiles.splice(index,1);}).catch(function(err){console.log(err);}).finally(function(){$scope.model.isDeleting=false;modal.close();});},negative:function negative(_ref93){var modal=_ref93.modal;modal.close();},type:'danger'});};$scope.formatFileSize=function(bytes,decimalPoint){return CommonLayoutService.formatFileSize(bytes);};init();}]});rejectModal(customerDocumentModal,negative);};var markUndeliveredWithCRV=function markUndeliveredWithCRV(data,callback,negative){var markUndeliveredWithCRVModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_markUndeliveredWithCRV2.default,size:'md',controller:['$scope',function($scope){$scope.model={shipments:data,convertToCRV:false,loading:false,reason:''};var init=function init(){};$scope.ok=function(){callback({modal:markUndeliveredWithCRVModal,convertToCRV:$scope.model.convertToCRV,reason:$scope.model.reason,$scope:$scope});};$scope.cancel=function(){negative({modal:markUndeliveredWithCRVModal});};init();}]});rejectModal(markUndeliveredWithCRVModal,negative);};var viewAppLogo=function viewAppLogo(data,stat,modal,callback){var appLogoModal=$uibModal.open({template:_appLogo2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'model-body-top',backdrop:'static',size:'sm',controller:['$scope','CommonLayoutService',function($scope,CommonLayoutService){$scope.model={base64String:null,header:stat};var init=function init(){if(data.length&&!data[0].hasOwnProperty('base64Data')){$scope.base64String=CommonLayoutService.generateObjectURL(data);}else{var arrayBuffer=Buffer.from(data[0].base64Data,'base64').toString('binary');$scope.base64String=CommonLayoutService.generateObjectURL(arrayBuffer);}};$scope.ok=function(){callback({modal:appLogoModal});appLogoModal.close();};$scope.cancel=function(){appLogoModal.close();};init();}]});};var previewTicketPictures=function previewTicketPictures(selectedFiles,removeCallback,callback,negative){var showRemove=arguments.length>4&&arguments[4]!==undefined?arguments[4]:true;var previewModal=$uibModal.open({template:_previewTicketPictures2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'model-body-top',backdrop:'static',size:'md',controller:['$scope',function($scope){$scope.model={results:[]};$scope.showRemove=showRemove&&typeof removeCallback==='function';var init=function init(){if(selectedFiles&&selectedFiles.length){$scope.model.results=[].concat(selectedFiles);}};$scope.getImageSrc=function(file){if(!file)return'';if(file.imageUrl){return file.imageUrl;}if(!file.base64Data){return'';}if(file.base64Data.startsWith('data:')||file.base64Data.startsWith('blob:')){return file.base64Data;}return'data:'+file.type+';base64,'+file.base64Data;};$scope.download=function(image){if(image.imageUrl){fetch(image.imageUrl).then(function(response){return response.blob();}).then(function(blob){var blobUrl=URL.createObjectURL(blob);var link=document.createElement('a');link.href=blobUrl;link.download=image.fileName||'download';document.body.appendChild(link);link.click();document.body.removeChild(link);URL.revokeObjectURL(blobUrl);}).catch(function(err){console.error('Error downloading image via fetch:',err);});}};$scope.remove=function(index){$scope.model.results.splice(index,1);removeCallback(index);if($scope.model.results.length===0){previewModal.close();}};$scope.close=function(){previewModal.close();};init();}]});rejectModal(previewModal,negative);};// let scheduledATMShipment = (callback, negative) => {
//   let scheduledATMShipmentModal = $uibModal.open({
//     template: scheduledATMShipmentTemplate,
//     animation: true,
//     ariaLabelledBy: 'modal-title-top',
//     ariaDescribedBy: 'model-body-top',
//     backdrop: 'static',
//     size: 'md',
//     controller: ['$scope', 'LocationService', 'User', 'RouteService', 'DenominationService', function ($scope, LocationService, User, RouteService, DenominationService) {
//       $scope.model = {
//         location: null,
//         days: [{
//           label: 'Sunday',
//           DOW: 0,
//           ticked: false
//         },
//         {
//           label: 'Monday',
//           DOW: 1,
//           ticked: false
//         },
//         {
//           label: 'Tuesday',
//           DOW: 2,
//           ticked: false
//         },
//         {
//           label: 'Wednesday',
//           DOW: 3,
//           ticked: false
//         },
//         {
//           label: 'Thursday',
//           DOW: 4,
//           ticked: false
//         },
//         {
//           label: 'Friday',
//           DOW: 5,
//           ticked: false
//         },
//         {
//           label: 'Saturday',
//           DOW: 6,
//           ticked: false
//         }],
//         frequency: [{
//           label: 'Every Week',
//           value: 'every_week'
//         },
//         {
//           label: 'Every 2nd Week',
//           value: 'every_second_week'
//         },
//         {
//           label: 'Every 3rd Week',
//           value: 'every_third_week'
//         },
//         {
//           label: 'Every 4th Week',
//           value: 'every_fourth_week'
//         }],
//         selectedFrequency: null,
//         route: null,
//         amount: null,
//         denomination: null,
//         ABWS: 0,
//         startDate: null,
//         nextDate: null,
//         endDate: null,
//         locationListObj: {
//           results: [],
//           totalLocation: 0
//         },
//         routeListObj: {
//           results: [],
//           totalLocation: 0
//         },
//         branchId: User.getUser().branchId,
//         selectedDays: [],
//         denominationObj: {
//           results: []
//         },
//         selectedDenom: null,
//         startDate: moment(),
//         nextDate: null,
//         endDate: null
//       };
//       const init = () => {
//         $scope.loadLocation('', 0);
//         $scope.getRoutes('', 0);
//         $scope.loadDenomination();
//       }
//       $scope.locationSearchObj = (searchKey) => {
//         searchKey = searchKey || '';
//         const searchObj = {
//           queryJSON: {
//             rules: [
//               {
//                 field: 'branchId',
//                 condition: '=',
//                 data: $scope.model.branchId
//               },
//               {
//                 field: 'active',
//                 condition: '=',
//                 data: true
//               },
//               {
//                 group: {
//                   rules: [{
//                     field: 'id',
//                     condition: 'like',
//                     data: '%' + searchKey + '%'
//                   },
//                   {
//                     field: 'name',
//                     condition: 'like',
//                     data: '%' + searchKey + '%'
//                   }
//                   ],
//                   operator: 'OR'
//                 }
//               }, {
//                 group: {
//                   rules: [
//                     {
//                       field: 'locationType',
//                       condition: '=',
//                       data: 'ATM'
//                     },
//                   ],
//                   operator: 'OR'
//                 }
//               }
//             ],
//             operator: 'AND'
//           },
//         };
//         return searchObj.queryJSON.rules.length ? searchObj : null;
//       }
//       $scope.loadLocation = (searchKey, offset) => {
//         searchKey = searchKey || '';
//         const locationSearchObj = $scope.locationSearchObj(searchKey);
//         LocationService.all(locationSearchObj, offset, AppConstant.defaultPageLimit)
//           .then((res) => {
//             if (offset === 0) {
//               $scope.model.locationListObj.totalLocation = res.total;
//               $scope.model.locationListObj.results = $scope.mappingData(res.results);
//             } else {
//               const locations = $scope.mappingData(res.results);
//               $scope.model.locationListObj.results = $scope.model.locationListObj.results.concat(locations);
//             }
//           })
//           .catch((err) => {
//             console.log(err);
//           })
//       }
//       $scope.mappingData = (list) => {
//         return list.map((item) => {
//           return {
//             Key: item.id + ' | ' + item.name,
//             Value: item.id
//           }
//         });
//       }
//       $scope.getRoutes = (searchKey, offset) => {
//         searchKey = searchKey || '';
//         const routeSearchObj = {
//           queryJSON: {
//             rules: [
//               {
//                 field: 'branchId',
//                 condition: '=',
//                 data: $scope.model.branchId
//               },
//               {
//                 field: 'active',
//                 condition: '=',
//                 data: true
//               },
//               {
//                 group: {
//                   rules: [{
//                     field: 'id',
//                     condition: 'like',
//                     data: '%' + searchKey + '%'
//                   },
//                   {
//                     field: 'name',
//                     condition: 'like',
//                     data: '%' + searchKey + '%'
//                   }
//                   ],
//                   operator: 'OR'
//                 }
//               }
//             ],
//             operator: 'AND'
//           }
//         }
//         return RouteService.all(routeSearchObj, 0, AppConstant.defaultPageLimit)
//           .then((res) => {
//             if (offset === 0) {
//               $scope.model.routeListObj.totalLocation = res.total;
//               $scope.model.routeListObj.results = $scope.mappingData(res.results);
//             } else {
//               const routes = $scope.mappingData(res.results);
//               $scope.model.routeListObj.results = $scope.model.routeListObj.results.concat(routes);
//             }
//           })
//           .catch((err) => {
//             console.log(err);
//           })
//       }
//       $scope.loadDenomination = () => {
//         return DenominationService.all(null, 0, 30)
//           .then((res) => {
//             $scope.model.denominationObj.results = res.results;
//           })
//           .catch((err) => {
//             console.log(err);
//           })
//       }
//       $scope.ok = () => {
//         callback({
//           modal: scheduledATMShipmentModal,
//           location: $scope.model.location.Value,
//           selectedDays: $scope.model.selectedDays,
//           selectedFrequency: $scope.model.selectedFrequency,
//           route: $scope.model.route.Value,
//           amount: $scope.model.amount,
//           denomination: $scope.model.denomination
//         })
//         scheduledATMShipmentModal.close();
//       }
//       $scope.cancel = () => {
//         scheduledATMShipmentModal.close();
//       }
//       init()
//     }]
//   })
//   rejectModal(scheduledATMShipmentModal, negative);
// }
var atmLoadShipment=function atmLoadShipment(shipment,nextOrderNo,branchVaultDate,stats,callback){var atmLoadShipmentModal=$uibModal.open({template:_atmLoadShipment2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$q','BranchFundingSourceService','User','LocationService','CommonLayoutService','OrderViewService','RouteService','DenominationService',function($scope,$q,BranchFundingSourceService,User,LocationService,CommonLayoutService,OrderViewService,RouteService,DenominationService){var _$scope$model3;$scope.model=(_$scope$model3={fundingSourceObj:{branchFundingSource:[],totalBranchFundingSource:0,loading:false},locationObj:{locationList:[],totalLocation:0},routeObj:{routeList:[],totalRoutes:0},isGettingLocationRoutes:false,vaultDate:new Date(branchVaultDate),orderTypes:[],branchId:User.getUser().branchId,customerUser:User.getUser().customerUser?User.getUser().customerId:null},(0,_defineProperty3.default)(_$scope$model3,'orderTypes',CommonLayoutService.orderTypes()),(0,_defineProperty3.default)(_$scope$model3,'denominationAllType',[]),(0,_defineProperty3.default)(_$scope$model3,'denominations',[]),(0,_defineProperty3.default)(_$scope$model3,'orderNo',nextOrderNo),(0,_defineProperty3.default)(_$scope$model3,'shipment',shipment),(0,_defineProperty3.default)(_$scope$model3,'loading',false),(0,_defineProperty3.default)(_$scope$model3,'stats',stats),(0,_defineProperty3.default)(_$scope$model3,'isValidBillCount',true),_$scope$model3);$scope.generateSearchObj=function(searchKey){searchKey=searchKey||'';var obj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branchId},{group:{rules:[{field:"id",condition:"like",data:"%"+searchKey+"%"},{field:"sourceName",condition:"like",data:"%"+searchKey+"%"}],operator:"OR"}}],operator:"AND"}};return obj.queryJSON.rules.length?obj:null;};$scope.getAllFundingSource=function(searchKey,offset){$scope.model.fundingSourceObj.loading=true;var searchObj=$scope.generateSearchObj(searchKey);BranchFundingSourceService.all(searchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.fundingSourceObj.totalBranchFundingSource=data.total;$scope.model.fundingSourceObj.branchFundingSource=$scope.mappingData(data.results,'sourceName','id');}else{var fundingSource=$scope.mappingData(data.results,'sourceName','id');$scope.model.fundingSourceObj.branchFundingSource=$scope.model.fundingSourceObj.branchFundingSource.concat(fundingSource);}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.fundingSourceObj.loading=false;});};$scope.mappingData=function(arr,label,value){return arr.map(function(item){return{Key:item[value]+' | '+item[label],Value:item[value],dataObj:item};});};$scope.locationSearchObj=function(searchKey){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.branchId},{field:'active',condition:'=',data:true},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}},{group:{rules:[{field:'locationType',condition:'=',data:'ATM'},{field:'locationType',condition:'=',data:'REGULAR'},{field:'locationType',condition:'=',data:'DELIVERY'}],operator:'OR'}}],operator:'AND'}};if($scope.model.customerUser){searchObj.queryJSON.rules.push({field:'customerId',condition:'=',data:$scope.model.customerUser});}return searchObj.queryJSON.rules.length?searchObj:null;};$scope.loadLocation=function(searchKey,offset){searchKey=searchKey||'';var locationSearchObj=$scope.locationSearchObj(searchKey);LocationService.all(locationSearchObj,offset,_app2.default.defaultPageLimit).then(function(res){if(offset===0){$scope.model.locationObj.totalLocation=res.total;$scope.model.locationObj.locationList=$scope.mappingData(res.results,'name','id');}else{var locations=$scope.mappingData(res.results,'name','id');$scope.model.locationObj.locationList=$scope.model.locationObj.locationList.concat(locations);}}).catch(function(err){console.log(err);});};$scope.getLocationNextRoute=function(){$scope.model.isGettingLocationRoutes=true;OrderViewService.findLocationRoute($scope.model.toLocation.Value,$scope.getFormattedVaultDate($scope.model.vaultDate)).then(function(res){var routeId=res.results.routeId;var findRoute=_.find($scope.model.routeObj.routeList,{'Value':routeId});if(findRoute)$scope.model.routeId=findRoute;else $scope.model.routeId=null;if($scope.model.fundingSource&&$scope.model.fundingSource.Value){$scope.loadDenominations();}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.isGettingLocationRoutes=false;});};$scope.getActiveRoutes=function(searchKey,offset){searchKey=searchKey||'';var routeSearchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.branchId},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}// this.RouteService.getActiveRoutes(this.branchId, selectedDate)
};return RouteService.all(routeSearchObj,0,_app2.default.defaultPageLimit).then(function(res){var routes=$scope.mappingData(res.results,'name','id');$scope.model.routeObj.routeList=routes;$scope.model.routeObj.totalRoutes=routes.length;}).catch(function(err){console.log(err);});};$scope.loadDenominations=function(){if($scope.model.fundingSource&&$scope.model.fundingSource.Value){var locationId=$scope.model.toLocation?$scope.model.toLocation.Value:null;OrderViewService.getFundingSourceDenomination($scope.model.fundingSource.Value,locationId).then(function(res){$scope.model.denominationAllType=res.results.length?res.results.filter(function(d){return d.shiptypeId=='C';}):[];$scope.removeAlreadyUsedDenom();$scope.addNewDenominations();}).catch(function(err){console.log(err);});}else{var searchObj={queryJSON:{rules:[{field:'currencyId',condition:'=',data:'USD'}],operator:'AND'}};DenominationService.all(searchObj,0,1000).then(function(res){$scope.model.denominationAllType=res.results.length?res.results.filter(function(d){return d.shiptypeId=='C';}):[];$scope.removeAlreadyUsedDenom();$scope.addNewDenominations();}).catch(function(err){console.log(err);});}};$scope.getFormattedVaultDate=function(date){if(!date)return;return moment(date).format('YYYY-MM-DD');};$scope.addNewDenominations=function(){$scope.model.denominations=[];if(!$scope.model.shipment){for(var i=0;$scope.model.denominations.length<4;i++){$scope.model.denominations.push({isEnabled:i==0?true:false,icon:i==0?'USD20':$scope.model.remainingDenominations[0].id,faceValue:i==0?20:$scope.model.remainingDenominations[0].faceValue,amount:null,template:'atm-loads-denomination-selection.html',dollorFlag:true,duplicate:false});$scope.removeAlreadyUsedDenom();}}else{var keys=[],denoms=[];keys=(0,_keys2.default)($scope.model.shipment.denominations);keys.forEach(function(key){denoms.push($scope.model.shipment.denominations[key]);});for(var i=0;$scope.model.denominations.length<4;i++){var isValid=denoms[i]&&$scope.model.shipment.denominations[denoms[i].denominationId];$scope.model.denominations.push({isEnabled:isValid?true:false,icon:isValid?$scope.model.shipment.denominations[denoms[i].denominationId].denominationId:null,faceValue:isValid?$scope.model.shipment.denominations[denoms[i].denominationId].faceValue:null,amount:isValid?$scope.model.shipment.denominations[denoms[i].denominationId].amount:null,billCount:isValid?$scope.model.shipment.denominations[denoms[i].denominationId].billCount:null,template:'atm-loads-denomination-selection.html',dollorFlag:true,duplicate:false,isValid:true});}$scope.removeAlreadyUsedDenom();}};$scope.changeDenomType=function(event,index,denomination){$scope.model.denominations[index].icon=denomination.id;$scope.model.denominations[index].faceValue=denomination.faceValue;$scope.model.denominations[index].isOpen=false;$scope.checkAmount(index,$scope.model.denominations[index].billCount,denomination.faceValue);$scope.removeAlreadyUsedDenom();};$scope.removeAlreadyUsedDenom=function(){$scope.model.remainingDenominations=$scope.model.denominationAllType.filter(function(type){var isValid=true;$scope.model.denominations.forEach(function(data){isValid=!(data.icon===type.id&&data.isEnabled)&&isValid;});return isValid;});};$scope.checkAmount=function(denominationIndex,billCount,faceValue){var orderTypes=['P','T'];var amount=0;amount=billCount>=0?billCount*faceValue:0;if($scope.model.denominations[denominationIndex].isEnabled&&(amount%faceValue>0||billCount==0)&&!orderTypes.includes($scope.model.orderType)){$scope.model.denominations[denominationIndex].isValid=false;$scope.model.isValidBillCount=false;}else if(amount!=null&&amount%faceValue==0){$scope.model.denominations[denominationIndex].isValid=true;$scope.model.isValidBillCount=true;}$scope.model.denominations[denominationIndex].amount=amount;};$scope.turnOffDenom=function(denomination,denomIndex){denomination.isEnabled=false;denomination.billCount=null;var cursor=0;$scope.model.denominations.forEach(function(d){if(!d.isEnabled)cursor++;else cursor=0;});if($scope.model.denominations.length===cursor){$scope.model.isValidBillCount=true;}$scope.removeAlreadyUsedDenom();};$scope.handleDenomination=function(denomination){denomination.isEnabled=!denomination.isEnabled;if(!denomination.isEnabled){denomination.icon='';denomination.amount='';denomination.faceValue='';}else{var isEnabled=$scope.model.denominationAllType.filter(function(){return denomination.isEnabled;});var icon=isEnabled.length==1?'USD20':$scope.model.remainingDenominations[0].id,faceValue=0;$scope.model.denominationAllType.forEach(function(denomData){if(denomData.id==icon){faceValue=denomData.faceValue;}});denomination.icon=icon;denomination.faceValue=faceValue;}$scope.removeAlreadyUsedDenom();};$scope.validateATMOrderCreateBtn=function(){var orderTypes=['P','T'];var cursor=0;var disableButton=$scope.model.denominations.map(function(denom){if(denom.isEnabled)return(orderTypes.includes($scope.model.orderType)?denom.amount>=0:denom.amount>0)&&denom.isValid!==undefined&&denom.isValid||'isEmpty';});disableButton.forEach(function(d){if(d==undefined)cursor++;else cursor=0;});return disableButton.indexOf('isEmpty')!==-1||$scope.model.denominations.length===cursor;;};$scope.validateBillCount=function(){var orderTypes=['P','T'];$scope.model.denominations.map(function(denom){if(denom.isEnabled&&(denom.amount%denom.faceValue>0||denom.billCount==0)&&!orderTypes.includes($scope.model.orderType)){denom.isValid=false;$scope.model.isValidBillCount=false;}else if(denom.amount!==null&&denom.amount>=0&&denom.amount%denom.faceValue==0){denom.isValid=true;$scope.model.isValidBillCount=true;}});};var init=function init(){$scope.model.loading=true;$q.all([$scope.getAllFundingSource('',0),$scope.loadLocation('',0),$scope.getActiveRoutes(0,''),$scope.loadDenominations()]).then(function(){$scope.minVaultDate={minDate:new Date($scope.model.vaultDate)};if($scope.model.shipment&&(0,_typeof3.default)($scope.model.shipment)=='object'){var obj=$scope.model.shipment;$scope.model.fundingSource=obj.fundingSource;$scope.model.orderNo=obj.orderNo;$scope.model.toLocation=obj.location;$scope.model.routeId=obj.route;$scope.model.vaultDate=obj.vaultDate;$scope.model.orderType=obj.orderType;if($scope.model.fundingSource&&$scope.model.fundingSource.Value){$scope.loadDenominations();}}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.ok=function(){var denominations={};$scope.model.denominations.forEach(function(d){if(d.isEnabled&&d.amount>=0){(0,_assign2.default)(denominations,(0,_defineProperty3.default)({},d.icon,{denominationId:d.icon,amount:d.amount,faceValue:d.faceValue,billCount:d.billCount}));}});callback({modal:atmLoadShipmentModal,fundingSource:$scope.model.fundingSource,orderNo:$scope.model.orderNo,location:$scope.model.toLocation,route:$scope.model.routeId,vaultDate:$scope.model.vaultDate,orderType:$scope.model.orderType,denominations:denominations});};$scope.cancel=function(){atmLoadShipmentModal.close();};$scope.$watch('model.fundingSource',function(newVal,oldVal){if(newVal&&newVal.Value&&newVal.Value!==(oldVal&&oldVal.Value)){$scope.loadDenominations();}},true);init();}]});};var pickupDeliveryShipments=function pickupDeliveryShipments(branchId,routeId,vaultDate,flagType,callback,negative){var pickupDeliveryShipmentModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_pickupDeliveryShipment2.default,size:'lg',controller:['$scope','RouteDetailService','Navigation',function($scope,RouteDetailService,Navigation){$scope.model={pickupShipmentList:[],routeId:routeId,branchId:branchId,vaultDate:vaultDate,flagType:flagType,loading:false};var init=function init(){$scope.model.loading=true;RouteDetailService.pickupDeliveryShipments($scope.model.branchId,$scope.model.routeId,$scope.model.vaultDate,$scope.model.flagType).then(function(data){$scope.model.pickupShipmentList=data.results;}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.cancel=function(){pickupDeliveryShipmentModal.close();};$scope.ok=function(){callback({modal:pickupDeliveryShipmentModal});modal.close();};$scope.goToItemHistory=function(trackingId){return Navigation.goToItemHistory(trackingId,pickupDeliveryShipmentModal);};$scope.goToServiceHistory=function(locationId,date){var isRedirected=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;return Navigation.goToServiceHistory(locationId,date,isRedirected,pickupDeliveryShipmentModal);};init();}]});};var notDeliveredResolution=function notDeliveredResolution(trackingId,_notDeliveredResolution,callback,negative){var notDeliveredResolutionModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_notDeliveredResolution3.default,size:'lg',controller:['$scope',function($scope){$scope.model={data:_notDeliveredResolution,trackingId:trackingId};var init=function init(){};$scope.cancel=function(){notDeliveredResolutionModal.close();};$scope.ok=function(){callback({modal:notDeliveredResolutionModal});modal.close();};init();}]});rejectModal(notDeliveredResolutionModal,negative);};var pickupHoldRelease=function pickupHoldRelease(shipment,allowSupervisorScan,callback,negative){var pickupHoldReleaseModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_pickupHoldRelease2.default,size:'lg',controller:['$scope','$translate','$location','SetupService','BranchService','MessageService','User','ShipmentService','$q','HoldService','LocationService',function($scope,$translate,$location,SetupService,BranchService,MessageService,User,ShipmentService,$q,HoldService,LocationService){$scope.loading=false;$scope.model={trackingId:'',holdDate:'',deliveryDate:'',shipments:'',toLocationRoute:'',fromLocationRoute:'',toLocationRouteId:'',toLocationRouteSeq:'',toLocationRouteDate:'',fromLocationRouteId:'',fromLocationRouteSeq:'',fromLocationRouteDate:'',branchId:shipment.branchId?shipment.branchId:User.getUser().branchId,vaultDate:'',nextRouteData:'',nextRouteDetails:'',routeList:[],routeSequence:null,routeIds:'',totalRoutes:'',date:'',toLocationId:'',loadRouteList:false,routeTransfered:'',lastSelectedRoute:null,allowSupervisorScan:allowSupervisorScan,userDetails:User.getUser()};$scope.model.trackingId=shipment.trackingId;$scope.model.shipment=shipment.toLocation;$scope.model.toLocationId=shipment.toLocationId?shipment.toLocationId:null;$scope.model.toLocationName=shipment.toLocationName?shipment.toLocationName:null;var init=function init(){$scope.loading=true;SetupService.get($scope.model.branchId).then(function(data){$scope.model.vaultDate=moment.utc(data.currentVaultDate).format('YYYY-MM-DD');$scope.minVaultDate={minDate:$scope.model.vaultDate};return data;}).then(function(data){$scope.loadLocations().then(function(){$scope.model.location={Key:($scope.model.toLocationId?$scope.model.toLocationId:shipment.toLocation.id)+' | '+($scope.model.toLocationName?$scope.model.toLocationName:shipment.toLocation.name),Value:$scope.model.toLocationId?$scope.model.toLocationId:shipment.toLocation.id};});return getNextAvailableRoutes(ShipmentService,$scope,$scope.model.toLocationId,$location,$q,BranchService,data.unassignedRoute,HoldService);}).finally(function(){$scope.loading=false;});$scope.routeSequenceChanged=function(){var routeId=$scope.model.routeId?$scope.model.routeId:$scope.model.lastSelectedRoute;$scope.model.totalRoutes.map(function(data){$scope.model.routeSequence=data.routeId===routeId?0:$scope.model.routeSequence;});$scope.model.routeInfo=_.find($scope.model.totalRoutes,{'routeId':routeId});};};$scope.mappingLocations=function(locations){return locations.map(function(data){return{Key:data.id+" | "+data.name,Value:data.id};});};$scope.loadLocations=function(searchKey,offset){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branchId},{field:"active",condition:"=",data:true},// {
//   group: {
//     rules: [{
//       field: "locationType",
//       condition: "NOTIN",
//       data: ['TANKER, VAULT, WINDOW, CARRIER, TRUCK']
//     }],
//     operator: 'AND'
//   }
// },
{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:"AND"}};return LocationService.all(searchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.totalLocation=data.total;$scope.model.locations=$scope.mappingLocations(data.results);}else{var Locations=$scope.mappingLocations(data.results);$scope.model.locations=$scope.model.locations.concat(Locations);}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.cancel=function(){negative({modal:pickupHoldReleaseModal});};$scope.validateSupervisorScan=function(){if($scope.model.allowSupervisorScan){var errorMsg=$translate.instant('users.supervisor_scan_error',{firstName:$scope.model.userDetails.firstName,lastName:$scope.model.userDetails.lastName});return confirm({header:$translate.instant('errorModal.title'),message:$translate.instant(errorMsg),callback:function callback(_ref94){var modal=_ref94.modal;$scope.ok();modal.close();},type:'danger',buttons:['common.ok']});}else{$scope.ok();}};$scope.ok=function(){$scope.isLoading=true;verifySupervisorScan('pickup-hold-release',{trackingId:shipment.trackingId},$scope).then(function(supervisorInfo){$scope.model.supervisorId=supervisorInfo?supervisorInfo.supId:null;$scope.model.loading=true;callback({supervisorId:supervisorInfo?supervisorInfo.supId:null,comment:$scope.model.comment?$scope.model.comment:null,shipmentAssignedTo:$scope.model.routeId,selectedDate:$scope.model.date,routeInfo:$scope.model.routeInfo,locationId:$scope.model.location.Value,modal:pickupHoldReleaseModal});if(supervisorInfo)supervisorInfo.modal.close();});};init();}]});rejectModal(pickupHoldReleaseModal,negative);};var duplicateRouteStopList=function duplicateRouteStopList(routeId,routeStops,callback,negative){var duplicateRouteStopListModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_duplicateStopsInfo2.default,size:'lg',controller:['$scope','$state','Navigation','CommonLayoutService',function($scope,$state,Navigation,CommonLayoutService){$scope.model={routeId:routeId,stops:routeStops};var init=function init(){};$scope.ok=function(){callback({modal:duplicateRouteStopListModal});modal.close();};$scope.cancel=function(){negative({modal:duplicateRouteStopListModal});};$scope.goToServiceHistory=function(data){// return Navigation.goToServiceHistory(data.locationId, null, true, duplicateRouteStopListModal);
return $state.go('location.edit',{id:data.locationId});};$scope.loadLocationTypeIcon=function(locationType){return CommonLayoutService.loadLocationTypeIcon(locationType);};init();}]});rejectModal(duplicateRouteStopListModal,negative);};var branchMgmtBagoutClose=function branchMgmtBagoutClose(bagoutObj,callback,negative){var closeBagoutModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_branchMgmtCloseBagout2.default,size:'md',controller:['$scope','$state','$q','LocationService','BagoutService',function($scope,$state,$q,LocationService,BagoutService){$scope.model={routeId:null,loading:false,bagoutObj:bagoutObj,deliveryDate:bagoutObj.deliveryDate,holdRouteId:bagoutObj.holdRouteId};var init=function init(){$scope.model.loading=true;var dayIndex=moment($scope.model.deliveryDate).day();var weekDays=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];$q.all([LocationService.getVisitingRoutes($scope.model.bagoutObj.locationId,weekDays[dayIndex]),BagoutService.getDeliveryRoutes($scope.model.bagoutObj.branchId,moment($scope.model.deliveryDate).format('YYYY-MM-DD'))]).then(function(data){$scope.model.routeList=data[1].results?data[1].results.slice():[];if($scope.model.holdRouteId){$scope.model.routeList.push({id:$scope.model.holdRouteId,name:$scope.model.holdRouteId});}if(data[0].results){if(data[0].results.length===0&&$scope.model.holdRouteId){$scope.model.routeId=$scope.model.routeList[_.findIndex(_this5.routes,{id:_this5.holdRoute.id})];;}else if(data[0].results.length===1){var selectedIndex=_.findIndex($scope.model.routeList,{id:data[0].results[0].id});$scope.model.routeId=selectedIndex>=0?$scope.model.routeList[selectedIndex]:$scope.model.routeList[_.findIndex($scope.model.routeList,{id:$scope.model.holdRouteId})];}}else if($scope.model.holdRouteId){var route=$scope.model.routeList[_.findIndex($scope.model.routeList,{id:$scope.model.holdRouteId})];$scope.model.routeId=route.id;}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.ok=function(){callback({modal:closeBagoutModal,routeId:$scope.model.routeId,deliveryDate:$scope.model.deliveryDate,$scope:$scope});};$scope.cancel=function(){negative({modal:closeBagoutModal});};init();}]});rejectModal(closeBagoutModal,negative);};var makeDeliverable=function makeDeliverable(shipmentObj,callback,negative){var makeDeliverableModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_makeDeliverable2.default,size:'md',controller:['$scope','RouteService','DateUtil',function($scope,RouteService,DateUtil){$scope.model={routeId:null,loading:false,shipmentObj:shipmentObj,routeObj:{results:[],totalRecords:0},vaultDate:DateUtil.convertToDate(shipmentObj.date),branchId:shipmentObj.branchId,trackingId:shipmentObj.trackingId};var init=function init(){$scope.loadRoutes('',0);$scope.model.route={Key:shipmentObj.routeId+' | '+shipmentObj.routeName,Value:shipmentObj.routeId};};$scope.loadRoutes=function(searchKey,offset){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.branchId},{group:{rules:[{field:"id",condition:"like",data:"%"+searchKey+"%"},{field:"name",condition:"like",data:"%"+searchKey+"%"}],operator:"OR"}}],operator:'AND'}};$scope.model.loading=true;RouteService.all(searchObj,offset,10).then(function(data){if(offset===0||offset==undefined){$scope.model.routeObj.totalRecords=data.total;$scope.model.routeObj.results=$scope.mapData(data.results);}else{var routes=$scope.mapData(data.results);$scope.model.routeObj.results=$scope.model.routeObj.results.concat(routes);}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.mapData=function(routes){return routes.map(function(route){return{Key:route.id+' | '+route.name,Value:route.id};});};$scope.ok=function(){callback({modal:makeDeliverableModal,routeId:$scope.model.route.Value,vaultDate:moment($scope.model.vaultDate).format('YYYY-MM-DD'),$scope:$scope});};$scope.cancel=function(){negative({modal:makeDeliverableModal});};init();}]});rejectModal(makeDeliverableModal,negative);};var rescheduleDeliveries=function rescheduleDeliveries(routeObj,callback,negative){var rescheduleDeliveriesModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_rescheduleDeliveries2.default,size:'lg',controller:['$scope','RouteService','DateUtil','VaultOperationsService','Navigation',function($scope,RouteService,DateUtil,VaultOperationsService,Navigation){$scope.model={routeId:null,loading:false,fromRouteId:routeObj.routeId,fromVaultDate:DateUtil.convertToDate(routeObj.routeDate),routeObj:{results:[],totalRecords:0},vaultDate:moment(DateUtil.convertToDate(routeObj.routeDate)).add(1,'days').toDate(),branchId:routeObj.branchId,shipments:[],fetchingShipments:false,shuttleRoute:true};var init=function init(){$scope.loadRoutes('',0);$scope.minVaultDate={minDate:moment(DateUtil.convertToDate(routeObj.branchVaultDate)).add(1,'days').toDate()};$scope.model.fetchingShipments=true;VaultOperationsService.getNotDeliveredShipments(routeObj.routeId,moment.utc(routeObj.routeDate).format('YYYY-MM-DD'),routeObj.branchId).then(function(res){if(res&&res.status){$scope.model.shipments=res.data;}}).catch(function(err){console.error('Error fetching shipments',err);}).finally(function(){$scope.model.fetchingShipments=false;});};$scope.loadRoutes=function(searchKey,offset){searchKey=searchKey||'';$scope.model.loading=true;RouteService.getAvailableRoutes($scope.model.branchId,moment($scope.model.vaultDate).format('YYYY-MM-DD'),offset||0,10,searchKey,$scope.model.shuttleRoute).then(function(data){var filteredResults=data.results;if(offset===0||offset==undefined){$scope.model.routeObj.totalRecords=data.total;$scope.model.routeObj.results=$scope.mapData(filteredResults);}else{var routes=$scope.mapData(filteredResults);$scope.model.routeObj.results=$scope.model.routeObj.results.concat(routes);}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};var lastVaultDate=moment($scope.model.vaultDate).format('YYYY-MM-DD');$scope.onVaultDateChange=function(){var currentDate=$scope.model.vaultDate?moment($scope.model.vaultDate).format('YYYY-MM-DD'):null;if(currentDate&&currentDate===lastVaultDate)return;lastVaultDate=currentDate;$scope.model.route=null;if($scope.model.vaultDate){$scope.loadRoutes('',0);}};$scope.setShuttleRoute=function(shuttleRoute){if($scope.model.shuttleRoute===shuttleRoute)return;$scope.model.shuttleRoute=shuttleRoute;$scope.model.route=null;$scope.loadRoutes('',0);};$scope.mapData=function(routes){return routes.map(function(route){return{Key:route.id+' | '+route.name,Value:route.id};});};$scope.ok=function(){confirmSupervisor('reschedule-deliveries',{routeId:routeObj.routeId},function(_ref95){var supModal=_ref95.modal,supId=_ref95.supId;callback({modal:rescheduleDeliveriesModal,routeId:$scope.model.route.Value,vaultDate:moment($scope.model.vaultDate).format('YYYY-MM-DD'),shipments:$scope.model.shipments,supervisorId:supId,$scope:$scope});supModal.close();},function(_ref96){var supModal=_ref96.modal;supModal.close();});};$scope.cancel=function(){negative({modal:rescheduleDeliveriesModal});};$scope.goToItemHistory=function(trackingId){return Navigation.goToItemHistory(trackingId,rescheduleDeliveriesModal);};$scope.goToServiceHistory=function(locationId){return Navigation.goToServiceHistory(locationId,null,true,rescheduleDeliveriesModal);};init();}]});rejectModal(rescheduleDeliveriesModal,negative);};var logisticItemAssignModal=function logisticItemAssignModal(data,callback,negative){var logisticItemAssignModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_logisticItemAssign2.default,size:'md',controller:['$scope','RouteService','ItemService','UsersService',function($scope,RouteService,ItemService,UsersService){$scope.pagination={page:1,total:0,pageLimit:10,maxPages:10};$scope.model={branchId:data.branchId,barcode:data.barcode,userId:null,routeId:data.status=='available'?null:data.routeId,notes:data.AssignmentNotes,routeList:[],// userKey: data.status == 'available' ? null : data.userKey,
userKey:data.status=='available'?null:data.userKey?{"Key":data.userKey+" | "+data.firstName+" "+data.lastName,"Value":data.userKey}:'',userList:[],loading:false,totalRecord:0,allRoutes:[],date:'',route:data.status=='available'?null:data.routeId?{"Key":data.routeId+" | "+data.routeName,"Value":data.routeId}:''};var init=function init(){$scope.model.loading=true;/* let searchObj = userSearchObj('', true);
          UsersService.all(searchObj, 0, 100)
          .then((data) => {
              let arr = data.results.map((item) => {
                  const arrayObject = {
                      Key: item.id + ' | ' + item.firstName + ' ' + item.lastName,
                      Value: item.id
                  };
                  return arrayObject;
              });
              $scope.model.totalUsers = data.results.length;
              $scope.model.userList = arr;
          })
          .catch((err) => {
            console.log(err);
          }) */ItemService.availableRoutes($scope.model.branchId).then(function(data){$scope.model.routeList=data.results;$scope.model.totalRoutes=data.results.length;}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});$scope.loadUsers('',0);$scope.loadRoutes('',0);};$scope.selectItem=function(){console.log('selectItem = ');/* if ($scope.loading) return;
          $scope.loading = true;
          confirmSupervisor('checkin-item-selected', ({ modal, supId }) => {
            callback({
              modal: selectionModal,
              selected: choices[$scope.selectedIndex],
              supervisorId: supId
            });
            modal.close()
          }, ({ modal }) => {
            $scope.loading = false;
            modal.close()
          }) */};$scope.loadUsers=function(searchKey,offset){searchKey=searchKey||'';var searchObj=userSearchObj(searchKey,true);UsersService.all(searchObj,offset,$scope.pagination.pageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.totalUsers=data.total;$scope.model.userList=$scope.userDataMap(data.results);}else{var userList=$scope.userDataMap(data.results);$scope.model.userList=$scope.model.userList.concat(userList);}}).catch(function(err){console.log(err);});};$scope.userDataMap=function(users){return users.map(function(item){return{Key:item.id+' | '+item.firstName+' '+item.lastName,Value:item.id};});};$scope.loadRoutes=function(searchKey,offset){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',// data: $scope.model.branch
data:$scope.model.branchId},{group:{rules:[{field:"id",condition:"like",data:"%"+searchKey+"%"},{field:"name",condition:"like",data:"%"+searchKey+"%"}],operator:"OR"}}],operator:'AND'}};RouteService.all(searchObj,offset,$scope.pagination.pageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.totalRecord=data.total;$scope.model.allRoutes=$scope.mapData(data.results);}else{var routes=$scope.mapData(data.results);$scope.model.allRoutes=$scope.model.allRoutes.concat(routes);}}).catch(function(err){console.log(err);});};$scope.mapData=function(routes){return routes.map(function(route){return{Key:route.id+' | '+route.name,Value:route.id};});};var userSearchObj=function userSearchObj(searchKey){var displayAppUserOnly=arguments.length>1&&arguments[1]!==undefined?arguments[1]:undefined;searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:"branchId",condition:"=",data:$scope.model.branchId},{group:{rules:[{field:"id",condition:"like",data:"%"+searchKey+"%"},{field:"firstName",condition:"like",data:"%"+searchKey+"%"},{field:"lastName",condition:"like",data:"%"+searchKey+"%"}],operator:"OR"}}],operator:'AND'}};if(searchKey){searchObj.orderBy={order:[['id','ASC']]};}if(displayAppUserOnly){searchObj.queryJSON.rules.push({field:"downloadToHHT",condition:"=",data:true});}return searchObj.queryJSON.rules.length?searchObj:null;};$scope.cancel=function(){logisticItemAssignModal.close();};$scope.itemAssignmentChanged=function(itemAssignmentModel,index,changeIn){if(changeIn=='route'&&$scope.model.route)$scope.model.userKey=null;else if(changeIn=='user'&&$scope.model.userKey)$scope.model.route=null;};$scope.ok=function(){callback({modal:logisticItemAssignModal,barcode:$scope.model.barcode,routeId:$scope.model.route?$scope.model.route.Value:null,notes:$scope.model.notes,userKey:$scope.model.userKey?$scope.model.userKey.Value:null});logisticItemAssignModal.close();};init();}]});rejectModal(logisticItemAssignModal,negative);};var logisticItemList=function logisticItemList(routeId,itemList,stat,callback,negative){var logisticItemListModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_logisticItemList2.default,size:'md',controller:['$scope','$translate',function($scope,$translate){$scope.model={itemList:itemList,routeId:routeId,stat:stat};var init=function init(){};$scope.cancel=function(){logisticItemListModal.close();};$scope.ok=function(){callback({modal:logisticItemListModal});modal.close();};init();}]});};var logisticItemHoldReleaseModal=function logisticItemHoldReleaseModal(data,callback,negative){var logisticItemHoldRelease=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_logisticItemHoldRelease2.default,size:'md',controller:['$scope','ItemService','UsersService',function($scope,ItemService,UsersService){$scope.model={branchId:data.branchId,barcode:data.barcode,userId:null,// routeId: null,
notes:null,// routeList: [],
loading:false};var init=function init(){// $scope.model.loading = true;
// ItemService.availableRoutes($scope.model.branchId)
//   .then((data) => {
//     $scope.model.routeList = data.results;
//     $scope.model.totalRoutes = data.results.length;
//   })
//   .catch((err) => {
//     console.log(err);
//   })
//   .finally(() => {
//     $scope.model.loading = false;
//   })
};$scope.cancel=function(){logisticItemHoldRelease.close();};$scope.ok=function(){callback({modal:logisticItemHoldRelease,barcode:$scope.model.barcode,// routeId: $scope.model.routeId, 
notes:$scope.model.notes});logisticItemHoldRelease.close();};init();}]});rejectModal(logisticItemHoldRelease,negative);};var serviceTicketResolveImage=function serviceTicketResolveImage(picturesObj,callback){var serviceTicketResolveImageModal=$uibModal.open({template:_serviceTicketResolveImageTemplate2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'model-body-top',backdrop:'static',size:'md',controller:['$scope','CommonLayoutService',function($scope,CommonLayoutService){$scope.model={picturesObj:picturesObj,loading:false,results:[]};var init=function init(){var images=$scope.model.picturesObj.pictures.images;images.forEach(function(imageObj){var arrayBuffer=Buffer.from(imageObj.metadata.data,'base64').toString('binary');var base64String=CommonLayoutService.generateObjectURL(arrayBuffer);$scope.model.results.push({base64String:base64String,name:imageObj.name});});};$scope.download=function(imageBase64,name,index){document.getElementById('service-ticket-resolve-image-'+index).blur();var a=document.createElement("a");a.href=imageBase64;a.download=name;a.click();};$scope.cancel=function(){serviceTicketResolveImageModal.close();};init();}]});};var updateBillingRecords=function updateBillingRecords(data,currentStat,callback,negative){var updateBillingRecordsModal=$uibModal.open({template:_updateBillingRecords2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'model-body-top',backdrop:'static',size:'md',controller:['$scope','CommonLayoutService','LocationService','CustomerService','BillingCategoryService','$q','User','BillableEventsService','$translate',function($scope,CommonLayoutService,LocationService,CustomerService,BillingCategoryService,$q,User,BillableEventsService,$translate){$scope.model={locationObj:{results:[],totalRecords:0,selectedLocation:null,loading:false},customerObj:{results:[],totalRecords:0,selectedCustomer:null,loading:false},billingCategoryObj:{results:[],totalRecords:0,selectedCategory:null,loading:false},billableEventsObj:{results:[],totalRecords:0,selectedEvent:null,loading:false},billingTypeList:CommonLayoutService.billingTypeOptions()||[],amount:data.rate,amountDue:data.amountDue,loading:false,billingCategory:data.billingCategory,billingType:data.billingType?data.billingType.toLowerCase():null,billingRecordId:data.billingRecordId,billableEventId:data.billableEventId,billableEvent:$translate.instant('entry_type.'.concat(data.billableEventType)),currentStat:currentStat,isApproved:false,locationCustomerId:data.locationCustomerId,locationCustomerData:data.locationCustomerData,staticBillingOptions:['Pre Bill','Post Bill'],loggedInUserId:User.getUser().id,billableEventType:data.billableEventType};var init=function init(){$scope.model.loading=true;$q.all([$scope.getLocationList(),$scope.getCustomerList(),$scope.getBillingCategory(),$scope.getBillableEvents()]).then(function(){if(data.locationId){if(data.customerId==null&&data.locationCustomerId!==null){$scope.model.customerObj.selectedCustomer={Key:$scope.model.locationCustomerData,Value:$scope.model.locationCustomerId};}$scope.model.locationObj.selectedLocation={Key:data.locationId+' | '+data.locationName,Value:data.locationId,Obj:{customerObj:{id:$scope.model.locationCustomerId}}};}if(data.customerId){$scope.model.customerObj.selectedCustomer={Key:data.customerId+' | '+data.customerName,Value:data.customerId};}$scope.setBillingCatergory();$scope.billingTypeOptionChoice(data);if(data.billableEventType.toLowerCase()=='coin-conversion'){var perItemOption=$scope.model.billingTypeList.find(function(bt){return bt.value==='per_item';});$scope.billingTypeList=[perItemOption];}else if(data.billableEventType.toLowerCase()=='atm-residual-count'){var options=$scope.model.billingTypeList.filter(function(bt){return['fixed','per_item','percentage_fee'].includes(bt.value);});$scope.billingTypeList=options;}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.billingTypeOptionChoice=function(data){var selectedBillingEvent=data.billingCategory?data.billingCategory:null;if(!selectedBillingEvent)return;if($scope.model.staticBillingOptions.includes(selectedBillingEvent)){var fixedOption=$scope.model.billingTypeList.find(function(bt){return bt.label==='Fixed';});$scope.billingTypeList=[fixedOption];}else if(data.billableEvent&&data.billableEvent.toLowerCase()=='coin conversion'){var perItemOption=$scope.model.billingTypeList.find(function(bt){return bt.value==='per_item';});$scope.billingTypeList=[perItemOption];}else if(data.billableEvent&&data.billableEvent.toLowerCase()=='atm residual count'){var options=$scope.model.billingTypeList.filter(function(bt){return['fixed','per_item','percentage_fee'].includes(bt.value);});$scope.billingTypeList=options;}else{$scope.billingTypeList=$scope.model.billingTypeList;}};$scope.translateMessage=function(prefix,key){if(!key)return;return $translate.instant(prefix.concat(key));};$scope.setBillingType=function(data){if($scope.model.staticBillingOptions.includes(data.billingCategory)){$scope.model.billingType="fixed";}else if(data.billableEventType==='coin-conversion'){$scope.model.billingType="per_item";}else{$scope.model.billingType=null;}};$scope.getLocationList=function(searchKey,offset){searchKey=searchKey||'';var locationSearchObj={queryJSON:{rules:[{field:'locationType',condition:'IN',data:['ATM','NO_SHIP_NO_GO','REGULAR','BANK','INTERNAL','CARRIER','ON_CALL','DELIVERY']},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};$scope.model.locationObj.loading=true;return LocationService.all(locationSearchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.locationObj.totalRecords=data.total;$scope.model.locationObj.results=$scope.locationMapping(data.results);}else{var location=$scope.locationMapping(data.results);$scope.model.locationObj.results=$scope.model.locationObj.results.concat(location);}}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.locationObj.loading=false;});};$scope.getBillingCategory=function(searchKey,offset){searchKey=searchKey||'';$scope.model.billingCategoryObj.loading=true;BillingCategoryService.all(searchKey,offset,100).then(function(data){if(offset===0||offset==undefined){$scope.model.billingCategoryObj.totalRecords=data.total;$scope.model.billingCategoryObj.results=$scope.billingCategoryMap(data.results);}else{var results=$scope.billingCategoryMap(data.results);$scope.model.billingCategoryObj.results=$scope.model.billingCategoryObj.results.concat(results);}}).catch(function(err){errorModal(err.data.message);}).finally(function(){$scope.model.billingCategoryObj.loading=false;});};$scope.getBillableEvents=function(searchKey,offset){searchKey=searchKey||'';$scope.model.billableEventsObj.loading=true;BillableEventsService.all(searchKey,offset,100).then(function(data){if(offset===0||offset==undefined){$scope.model.billableEventsObj.totalRecords=data.total;$scope.model.billableEventsObj.results=$scope.billableEventsMap(data.results);}else{var results=$scope.billableEventsMap(data.results);$scope.model.billableEventsObj.results=$scope.model.billableEventsObj.results.concat(results);}}).catch(function(err){errorModal(err.data.message);}).finally(function(){$scope.model.billableEventsObj.loading=false;});};$scope.locationMapping=function(location){return location.map(function(loc){return{Key:loc.id+' | '+loc.name,Value:loc.id,Obj:loc};});};$scope.getCustomerList=function(searchKey,offset){searchKey=searchKey||'';var searchObj={queryJSON:{rules:[{field:'isEnabled',condition:'=',data:true},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};return CustomerService.all(searchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.customerObj.totalRecords=data.total;$scope.model.customerObj.results=$scope.customerMapping(data.results);}else{var location=$scope.customerMapping(data.results);$scope.model.customerObj.results=$scope.model.customerObj.results.concat(location);}}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.customerObj.loading=false;});};$scope.customerMapping=function(mapArray){return mapArray.map(function(obj){return{Key:obj.id+' | '+obj.name,Value:obj.id};});};$scope.billingCategoryMap=function(events){return events.map(function(data){return{Key:data.name,Value:data.id};});};$scope.billableEventsMap=function(events){return events.map(function(ev){return{Key:$scope.translateMessage('entry_type.',ev.type),Value:ev.id,billingCategoryId:ev.billingCategoryId,type:ev.type};});};$scope.autoPopulateLocationDetails=function(){if($scope.model.locationObj.selectedLocation){var customerObj=$scope.model.locationObj.selectedLocation.Obj.customerObj;if(customerObj&&customerObj.id){$scope.model.customerObj.selectedCustomer={Key:customerObj.id+' | '+customerObj.name,Value:customerObj.id};}else{$scope.model.customerObj.selectedCustomer=null;}}else{$scope.model.customerObj.selectedCustomer=null;}};$scope.approved=function(){$scope.model.isApproved=true;};$scope.update=function(){$scope.model.isApproved=false;};$scope.ok=function(){$scope.isLoading=true;if($scope.model.isApproved){$scope.model.allowSupervisorScan=true;}else{$scope.model.allowSupervisorScan=false;}// verifySupervisorScan('approve-billing-record', null, $scope)
//   .then((supervisorInfo) => {
callback({modal:updateBillingRecordsModal,locationId:$scope.model.locationObj.selectedLocation?$scope.model.locationObj.selectedLocation.Value:null,customerId:$scope.model.customerObj.selectedCustomer?$scope.model.customerObj.selectedCustomer.Value:null,billingCategory:$scope.model.billingCategory,billingType:$scope.model.billingType?$scope.model.billingType.toUpperCase():null,amount:$scope.model.amount,amountDue:$scope.model.amountDue,isApproved:$scope.model.isApproved,userId:$scope.model.loggedInUserId,$scope:$scope// });
// if (supervisorInfo) supervisorInfo.modal.close();
});};$scope.cancel=function(){negative({modal:updateBillingRecordsModal});};$scope.setBillingCatergory=function(){var findEvt=$scope.model.billableEventsObj.results.find(function(evt){return evt.Key===$scope.model.billableEvent;});if(!findEvt)return;var findBillingCatergory=$scope.model.billingCategoryObj.results.find(function(ct){return ct.Value===findEvt.billingCategoryId;});if(!findBillingCatergory)return;$scope.model.billingCategory=findBillingCatergory.Key;$scope.model.billableEventId=findEvt.Value;//
};init();}]});rejectModal(updateBillingRecordsModal,negative);};var bulkImportLocation=function bulkImportLocation(data,callback,negative){var bulkImportLocationModal=$uibModal.open({keyboard:false,template:_bulkImportLocation2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','ContractService',function($scope,ContractService){$scope.model={contractName:data.name,locations:null,loading:false};var init=function init(){};$scope.cancel=function(){bulkImportLocationModal.close();};$scope.ok=function(){var locations=$scope.model.locations?JSON.parse($scope.model.locations).replace(/\s/g,"").split(','):null;if(!locations)return;$scope.model.loading=true;ContractService.assertLocationIds(locations,data.contractId,data.useCustomerOnBillingRules,data.showAll===false?data.locationDistanceId:null).then(function(data){if(data.results.inValidLocationIds.length===0){callback({modal:bulkImportLocationModal,locationList:data.results.validLocationIds});bulkImportLocationModal.close();}if(data.results.inValidLocationIds.length===1){$scope.model.errorMessage='The provided locationId ('+data.results.inValidLocationIds.toString()+') is invalid.';}else{$scope.model.errorMessage='The provided locationIds ('+data.results.inValidLocationIds.toString().replace(/,/g,', ')+') are "invalid" or "suspended".';}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};init();}]});};var itemHistory=function itemHistory(data,callback,negative){var itemHistoryModal=$uibModal.open({template:_itemHistory2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','ItemService','$state','CommonLayoutService',function($scope,ItemService,$state,CommonLayoutService){$scope.model={loading:false,itemId:data.itemId,itemLabel:data.label,sortColumn:"createdAt",reverseSort:true,result:[]};$scope.pagination={page:1,total:0,pageLimit:10,maxPages:10};var init=function init(){$scope.loadData();};$scope.loadData=function(){$scope.model.loading=true;ItemService.getItemHistory($scope.model.itemId,$scope.pagination.pageLimit,($scope.pagination.page-1)*$scope.pagination.pageLimit,$scope.model.reverseSort,$scope.model.sortColumn).then(function(data){$scope.model.result=data;}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.pageChange=function(){$scope.loadData();};$scope.translateItemHistoryMsg=function(entryType){return CommonLayoutService.translateItemHistoryMessage(entryType);};$scope.sortData=function(column){$scope.model.reverseSort=$scope.model.sortColumn==column?!$scope.model.reverseSort:false;$scope.model.sortColumn=column;$scope.pageChange();};$scope.exportItemHistoryData=function(){if($scope.exportLoading)return;$scope.exportLoading=true;ItemService.exportItemHistory($scope.model.itemId,$scope.model.reverseSort,$scope.model.sortColumn).then(function(data){$scope.exportLoading=false;if(data.reportData&&data.reportData.length){$scope.downloadFile('Item_History_('+$scope.model.itemLabel+')',data.reportData);}}).catch(function(err){$scope.exportLoading=false;console.log(err);});};$scope.downloadFile=function(filename,reportData){var fileName=filename.concat('.csv');var a=document.createElement("a");document.body.appendChild(a);var file=new Blob([reportData],{type:'application/csv'});var fileURL=window.URL.createObjectURL(file);a.href=fileURL;a.download=fileName;a.click();};$scope.generateItemHistoryPrint=function(){ItemService.getItemHistory($scope.model.itemId,null,null,$scope.model.reverseSort,$scope.model.sortColumn).then(function(data){var path=$state.href('printItemHistory');window.w=window.open(path,'_blank');window.w.printData={results:data.results,itemId:$scope.model.itemId,label:$scope.model.itemLabel};}).catch(function(err){console.log(err);});};$scope.cancel=function(){itemHistoryModal.close();};init();}]});};var nextScheduledOccurences=function nextScheduledOccurences(data){var nextScheduleOccurenceModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_nextScheduledOccurences2.default,size:'md',controller:['$scope',function($scope){$scope.model={nextOccurrence:data.nextOccurrence,data:data};var init=function init(){};$scope.cancel=function(){nextScheduleOccurenceModal.close();};init();}]});};var bagRemoveConfirmation=function bagRemoveConfirmation(data,callback,negative){var bagRemoveConfirmationModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_bagRemoveConfirmation2.default,size:'md',controller:['$scope',function($scope){$scope.model={data:data};var init=function init(){};$scope.cancel=function(){bagRemoveConfirmationModal.close();};$scope.supervisorConfirmed=function(supervisorId){$scope.isSupervisorConfirmed=true;$scope.errorMessage='';$scope.supervisor=supervisorId;callback({modal:bagRemoveConfirmationModal,$scope:$scope});};$scope.supervisorCancelled=function(err){$scope.isSupervisorConfirmed=false;$scope.errorMessage=err.toString();bagRemoveConfirmationModal.close();};init();}]});};var postBillingRecord=function postBillingRecord(callback,negative){var postBillingRecordModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_postBillingRecord2.default,size:'lg',controller:['$scope','$translate','ContractService',function($scope,$translate,ContractService){$scope.model={loading:false,month:[{label:'Jan',value:'January'},{label:'Feb',value:'February'},{label:'Mar',value:'March'},{label:'Apr',value:'April'},{label:'May',value:'May'},{label:'Jun',value:'June'},{label:'Jul',value:'July'},{label:'Aug',value:'August'},{label:'Sep',value:'September'},{label:'Oct',value:'October'},{label:'Nov',value:'November'},{label:'Dec',value:'December'}],contractList:[],totalRecords:0,selectedMonth:null,selectedContract:null};var init=function init(){$scope.model.loading=true;$scope.loadContract('',0);};$scope.loadContract=function(searchKey,offset){searchKey=searchKey||'';var filterObj={queryJSON:{rules:[{field:'status',condition:'=',data:true},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'contractName',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};ContractService.all(filterObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.contractList=$scope.mappingContractDatas(data.results);$scope.model.totalRecords=data.total;}else{var contractList=$scope.mappingContractDatas(data.results);$scope.model.contractList=$scope.model.contractList.concat(contractList);$scope.model.totalRecords=data.total;}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.mappingContractDatas=function(contracts){return contracts.map(function(contract){return{Key:contract.id+' | '+contract.contractName,Value:contract.id};});};$scope.toggleMonth=function(month){$scope.model.selectedMonth=month.value;};$scope.cancel=function(){postBillingRecordModal.close();};$scope.ok=function(){$scope.isLoading=true;callback({modal:postBillingRecordModal,month:$scope.model.selectedMonth,contractId:$scope.model.selectedContract?$scope.model.selectedContract.Value:null,$scope:$scope});};init();}]});};var createBillingRecords=function createBillingRecords(callback,negative){var createBillingRecordsModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_createBillingRecords2.default,size:'md',controller:['$scope','CommonLayoutService','User','$q','LocationService','CustomerService','BillingCategoryService','BillableEventsService','BillingRecordsService','$translate',function($scope,CommonLayoutService,User,$q,LocationService,CustomerService,BillingCategoryService,BillableEventsService,BillingRecordsService,$translate){$scope.model={billingStatus:null,vaultDate:null,billingStatusList:[{Key:'Pending',Value:'PENDING'},{Key:'Pre Bill',Value:'PRE_BILL'},{Key:'Post Bill',Value:'POST_BILL'}],rate:null,amountDue:null,billingCategory:null,billingType:null,locationObj:{results:[],totalRecords:0,selectedLocation:null,loading:false},customerObj:{results:[],totalRecords:0,selectedCustomer:null,loading:false},billingCategoryObj:{loading:false},billableEventObj:{results:[],loading:false},contractObj:{results:[],totalRecords:0,selectedContract:null,loading:false},contractRuleObj:{results:[],totalRecords:0,selectedContractRule:null,loading:false},billingTypeList:CommonLayoutService.billingTypeOptions(),staticBillingOptions:['Pre Bill','Post Bill'],loggedInUserId:User.getUser().id,scheduleTypeOptions:[{label:'Any',value:'any'},{label:'Scheduled',value:'scheduled'},{label:'Unscheduled',value:'unscheduled'}],currentMonthDateOptions:{maxDate:moment().endOf('month')}};var init=function init(){$scope.model.loading=true;$q.all([$scope.getLocationList(),$scope.getBillingCategory(),$scope.loadAllEvents()]).then(function(){// $scope.billingTypeOptionChoice(data);
}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.billingTypeOptionChoice=function(data){var selectedBillingEvent=data.selectedBillingCategory?data.selectedBillingCategory.label:null;if(!selectedBillingEvent)return;if($scope.model.staticBillingOptions.includes(selectedBillingEvent)){var fixedOption=$scope.model.billingTypeList.find(function(bt){return bt.label==='Fixed';});$scope.billingTypeList=[fixedOption];}else{$scope.billingTypeList=$scope.model.billingTypeList;}};$scope.setBillingType=function(data){if($scope.model.staticBillingOptions.includes(data.selectedBillingCategory.label)){$scope.model.billingType="fixed";}else{$scope.model.billingType=null;}};$scope.getLocationList=function(searchKey,offset){searchKey=searchKey||'';var locationSearchObj={queryJSON:{rules:[{field:'active',condition:'=',data:true},{field:'locationType',condition:'IN',data:['ATM','NO_SHIP_NO_GO','REGULAR','BANK','INTERNAL','CARRIER','ON_CALL','DELIVERY']},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};$scope.model.locationObj.loading=true;return LocationService.all(locationSearchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.locationObj.totalRecords=data.total;$scope.model.locationObj.results=$scope.locationMapping(data.results);}else{var location=$scope.locationMapping(data.results);$scope.model.locationObj.results=$scope.model.locationObj.results.concat(location);}}).catch(function(err){if(err&&err.data&&err.data.message){errorModal(err.data.message);}}).finally(function(){$scope.model.locationObj.loading=false;});};$scope.getBillingCategory=function(searchKey,offset){searchKey=searchKey||'';$scope.model.billingCategoryObj.loading=true;BillingCategoryService.all(searchKey,offset,100).then(function(data){if(offset===0||offset==undefined){$scope.model.billingCategoryObj.totalRecords=data.total;$scope.model.billingCategoryObj.results=$scope.billingCategoryMap(data.results);}else{var results=$scope.billingCategoryMap(data.results);$scope.model.billingCategoryObj.results=$scope.model.billingCategoryObj.results.concat(results);}}).catch(function(err){errorModal(err.data.message);}).finally(function(){$scope.model.billingCategoryObj.loading=false;});};$scope.locationMapping=function(location){return location.map(function(loc){return{Key:loc.id+' | '+loc.name,Value:loc.id,Obj:loc};});};$scope.billingCategoryMap=function(events){return events.map(function(data){return{Key:data.name,Value:data.id};});};$scope.autoPopulateLocationDetails=function(){if($scope.model.locationObj.selectedLocation){var customerObj=$scope.model.locationObj.selectedLocation.Obj.customerObj;if(customerObj&&customerObj.id){$scope.model.customerObj.selectedCustomer={Key:customerObj.id+' | '+customerObj.name,Value:customerObj.id};}else{$scope.model.customerObj.selectedCustomer=null;}}else{$scope.model.customerObj.selectedCustomer=null;}};$scope.loadAllEvents=function(){$scope.model.preBillingEventOptions=[];$scope.model.postBillingEventOptions=[];$scope.model.billingCategoryOptions=[];$scope.model.billableEventObj.loading=true;BillableEventsService.all(null,0,30).then(function(events){var billableEvents=events.results.reduce(function(acc,result){var categoryName=result.billingCategory.name;acc[categoryName]=acc[categoryName]||{billingEvents:[],billingCategoryId:result.billingCategoryId};acc[categoryName].billingEvents.push({id:result.id,label:$translate.instant('entry_type.'+result.type),value:result.type});return acc;},{});$scope.model.billingCategoryOptions=(0,_keys2.default)(billableEvents).map(function(key){return{label:key,billingCategoryId:billableEvents[key].billingCategoryId,billingEvents:billableEvents[key].billingEvents};});}).catch(function(err){console.log(err);}).finally(function(){$scope.model.billableEventObj.loading=false;});};$scope.getBillingEventsByCategory=function(obj,index){$scope.model.billableEventObj.results=obj.billingEvents;};$scope.findCustomerContractByLocation=function(){if(!$scope.model.locationObj.selectedLocation){$scope.resetData();return;};$scope.model.contractObj.loading=true;BillingRecordsService.findCustomerContractByLocation($scope.model.locationObj.selectedLocation.Value).then(function(data){$scope.contractData=data.results;$scope.model.contractObj.results=$scope.mapContractData(data.results);$scope.model.contractObj.totalRecords=$scope.model.contractObj.results.length;}).catch(function(err){$scope.Modal.errorModal(err.data.message);}).finally(function(){$scope.model.contractObj.loading=false;});};$scope.resetData=function(){$scope.model.contractObj={results:[],totalRecords:0,selectedContract:null,loading:false};$scope.model.contractRuleObj={results:[],totalRecords:0,selectedContractRule:null,loading:false};$scope.model.customerObj={results:[],totalRecords:0,selectedCustomer:null,loading:false};$scope.applyContractRuleRate();};$scope.mapContractData=function(data){return data.map(function(contract){return{Key:contract.contractId.concat(' | ',contract.contractDescription?contract.contractDescription:'N/A'),Value:contract.contractId};});};$scope.findContractRuleAndCustomerByContractId=function(){$scope.model.contractRuleObj.selectedContractRule=null;$scope.applyContractRuleRate();$scope.model.customerObj.selectedCustomer=null;var selectedContract=$scope.model.contractObj.selectedContract?$scope.model.contractObj.selectedContract.Value:null;$scope.model.contractRuleObj.results=$scope.mapContractRuleData($scope.contractData,selectedContract);$scope.model.customerObj.results=$scope.customerMapping($scope.contractData,selectedContract);$scope.model.customerObj.totalRecords=$scope.model.customerObj.results.length;$scope.model.contractRuleObj.totalRecords=$scope.model.contractRuleObj.results.length;};$scope.mapContractRuleData=function(data,selectedContract){if(!selectedContract)return[];var contractRule=data.find(function(d){return d.contractId===selectedContract;}).contractRules;return contractRule.map(function(d){return{Key:d.id+' | '+d.contractRuleName,Value:d.id,dollarRate:d.dollarRate};});};$scope.applyContractRuleRate=function(){var selectedRule=$scope.model.contractRuleObj.selectedContractRule;var ruleRate=selectedRule&&selectedRule.dollarRate!==null&&selectedRule.dollarRate!==undefined&&selectedRule.dollarRate!==''?parseFloat(selectedRule.dollarRate):null;if(ruleRate!==null&&!isNaN(ruleRate)){$scope.model.rate=ruleRate;$scope.model.amountDue=ruleRate;$scope.model.rateFromRule=true;}else if($scope.model.rateFromRule){$scope.model.rate=null;$scope.model.rateFromRule=false;}};$scope.customerMapping=function(data,selectedContract){if(!selectedContract)return[];var contractRule=data.find(function(d){return d.contractId===selectedContract;}).customerList;return contractRule.map(function(obj){return{Key:obj.id+' | '+obj.name,Value:obj.id};});};$scope.cancel=function(){createBillingRecordsModal.close();};$scope.ok=function(){$scope.isLoading=true;callback({modal:createBillingRecordsModal,// billingStatus: $scope.model.billingStatus,
billingStatus:'PENDING',vaultDate:moment($scope.model.vaultDate).format('YYYY-MM-DD'),rate:$scope.model.rate,amountDue:$scope.model.amountDue,billableEventId:$scope.model.selectedbillableEvent,billingCategory:$scope.model.selectedBillingCategory?$scope.model.selectedBillingCategory.label:null,billingType:$scope.model.billingType.toUpperCase(),scheduleType:$scope.model.scheduleType,locationId:$scope.model.locationObj.selectedLocation.Value,branchId:$scope.model.locationObj.selectedLocation.Obj.branchId,customerContractId:$scope.model.contractObj.selectedContract.Value,contract:$scope.model.contractObj.selectedContract.Key,customerId:$scope.model.customerObj.selectedCustomer.Value,contractRuleId:$scope.model.contractRuleObj.selectedContractRule.Value,contractRule:$scope.model.contractRuleObj.selectedContractRule.Key,$scope:$scope});};init();}]});};var locationLogs=function locationLogs(locationId,callback,negative){var locationLogsModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_locationLogs2.default,size:'lg',controller:['$scope','$translate','LocationService',function($scope,$translate,LocationService){$scope.model={lid:locationId,locationLogs:[],dateRange:{startDate:'',endDate:''},page:1,total:0,pageLimit:10,maxPages:10,searchText:'',logsOf:'',entryTypes:[]};var init=function init(){$scope.setDateRange(moment().format('YYYY-MM-DD'));$scope.model.dateRange.startDate=moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');$scope.model.dateRange.endDate=moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');$scope.loadData($scope.model.dateRange);};$scope.generateSearchObj=function(){return{logsOf:$scope.model.logsOf,entryType:$scope.model.entryType,queryText:$scope.model.searchText,isQuery:false,startDate:moment($scope.model.dateRange.startDate).startOf('day').format('YYYY-MM-DD 00:00:00'),endDate:moment($scope.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')};};$scope.setDateRange=function(date){var currentVaultDate=date||moment();$scope.model.dateRangPickerOptions={autoApply:true,eventHandlers:{'apply.daterangepicker':function applyDaterangepicker(){$scope.model.page=1;$scope.loadData($scope.model.dateRange);}},ranges:{'Today':[moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')],'Current Week':[moment().startOf('week').format('YYYY-MM-DD'),moment().endOf('week').format('YYYY-MM-DD')],'Current Month':[moment().startOf('month').format('YYYY-MM-DD'),moment().endOf('month').format('YYYY-MM-DD')]}};};$scope.pageChange=function(){$scope.model.locationLogsLoading=true;$scope.loadData();};$scope.search=function(){$scope.model.page=1;$scope.model.locationLogsLoading=true;$scope.loadData();};$scope.refresh=function(){$scope.model.locationLogsLoading=true;$scope.loadData();};$scope.loadData=function(){$scope.model.locationLogsLoading=true;var searchObj=$scope.generateSearchObj();LocationService.getLocationLogs($scope.model.lid,searchObj,($scope.model.page-1)*$scope.model.pageLimit,$scope.model.pageLimit).then(function(data){$scope.model.total=data.total;$scope.model.locationLogs=data.results.map(function(log){log.readableEntryType=$translate.instant('entry_type.'+log.entryType);if(log.entryData){log.extraDetails=(0,_entries2.default)(log.entryData).map(function(_ref97){var _ref98=(0,_slicedToArray3.default)(_ref97,2),key=_ref98[0],value=_ref98[1];return{key:key,value:(typeof value==='undefined'?'undefined':(0,_typeof3.default)(value))==='object'?(0,_stringify2.default)(value):value};});}return log;});if(data.allEntryTypes.length>0&&!$scope.model.entryType){$scope.model.entryTypes=data.allEntryTypes.map(function(entryType){return{label:$translate.instant('entry_type.'+entryType),value:entryType};});}}).catch(function(err){console.log(err);}).finally(function(){$scope.model.locationLogsLoading=false;});};$scope.cancel=function(){locationLogsModal.close();};$scope.ok=function(){callback({modal:locationLogsModal,$scope:$scope});};init();}]});rejectModal(locationLogsModal,negative);};var branchFundingSourceDenominations=function branchFundingSourceDenominations(selectedDenominations,callback,negative,currencyId){var orderPackReturnModal=$uibModal.open({template:_branchFundingSourceDenominations2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','$q','BranchFundingSourceService','$http',function($scope,$q,BranchFundingSourceService,$http){$scope.model={denominationObj:{results:[]},fundingSourceDenominations:selectedDenominations};$scope.selectAll=false;$scope.loading=true;$scope.isMultiDenomAllowed=function(denom){if(!denom.coinFlag){return true;}if(denom.coinPackaging&&['INDIVIDUAL','ROLLED'].includes(denom.coinPackaging)){return true;}return false;};var init=function init(){return BranchFundingSourceService.getDenominations().then(function(res){// Filter denominations based on currency ID if provided
var filteredDenominations=res.denominations;if(currencyId){filteredDenominations={};(0,_keys2.default)(res.denominations).forEach(function(key){var denominations=res.denominations[key];var filtered=denominations.filter(function(denom){return denom.currencyId===currencyId;});if(filtered.length>0){filteredDenominations[key]=filtered;}});}$scope.model.denominationObj.results=filteredDenominations;$scope.model.denominationObj.results=$scope.updateDenominationSelection(filteredDenominations,$scope.model.fundingSourceDenominations);for(var key in $scope.model.denominationObj.results){if(Array.isArray($scope.model.denominationObj.results[key])){$scope.model.denominationObj.results[key].forEach(function(denom){if(!$scope.isMultiDenomAllowed(denom)){denom.multiDenomAllowed=false;}});}}$scope.updateSelectAllState();$scope.loading=false;}).catch(function(err){console.log(err);$scope.loading=false;});};$scope.toggleMultiDenom=function(obj){if($scope.isMultiDenomAllowed(obj)){obj.multiDenomAllowed=!obj.multiDenomAllowed;}};$scope.toggleCustomerOrderable=function(obj){obj.customerOrderable=!obj.customerOrderable;};$scope.validateMultiDenom=function(obj){setTimeout(function(){if(!obj.isDenomSelected){obj.multiDenomAllowed=false;obj.customerOrderable=false;}else{if(!$scope.isMultiDenomAllowed(obj)){obj.multiDenomAllowed=false;}}$scope.$apply();});};$scope.toggleSelectAll=function(){for(var key in $scope.model.denominationObj.results){if(Array.isArray($scope.model.denominationObj.results[key])){$scope.model.denominationObj.results[key].forEach(function(denom){denom.isDenomSelected=$scope.selectAll;// Reset multiDenomAllowed when deselecting
if(!denom.isDenomSelected){denom.multiDenomAllowed=false;denom.customerOrderable=false;}else{if(!$scope.isMultiDenomAllowed(denom)){denom.multiDenomAllowed=false;}}});}}};$scope.hasDenominations=function(){if(!$scope.model.denominationObj||!$scope.model.denominationObj.results){return false;}for(var key in $scope.model.denominationObj.results){if(Array.isArray($scope.model.denominationObj.results[key])&&$scope.model.denominationObj.results[key].length>0){return true;}}return false;};$scope.updateSelectAllState=function(){var totalDenoms=0;var selectedDenoms=0;for(var key in $scope.model.denominationObj.results){if(Array.isArray($scope.model.denominationObj.results[key])){$scope.model.denominationObj.results[key].forEach(function(denom){totalDenoms++;if(denom.isDenomSelected){selectedDenoms++;}});}}if(totalDenoms===0){$scope.selectAll=false;}else{$scope.selectAll=selectedDenoms===totalDenoms;}};$scope.updateDenominationSelection=function(target,source){if(!source||(typeof source==='undefined'?'undefined':(0,_typeof3.default)(source))!=="object"||Array.isArray(source)&&!source.length)return target;var _loop=function _loop(key){if(Array.isArray(source[key])&&Array.isArray(target[key])&&source[key].length>0){source[key].forEach(function(sourceItem){target[key].forEach(function(targetItem){if(targetItem.id==sourceItem.id){targetItem.isDenomSelected=sourceItem.hasOwnProperty("isDenomSelected")?sourceItem.isDenomSelected:targetItem.isDenomSelected;// Enforce coin packaging rules when updating multiDenomAllowed
if(sourceItem.hasOwnProperty("multiDenomAllowed")){// If coin with BOXED/BAGGED, force to false
if(!$scope.isMultiDenomAllowed(targetItem)){targetItem.multiDenomAllowed=false;}else{targetItem.multiDenomAllowed=sourceItem.multiDenomAllowed;}}else{targetItem.multiDenomAllowed=targetItem.multiDenomAllowed;}if(sourceItem.hasOwnProperty("customerOrderable")){targetItem.customerOrderable=sourceItem.customerOrderable;}else{targetItem.customerOrderable=targetItem.customerOrderable;}if(sourceItem.hasOwnProperty("expectedResidualPercentage")){targetItem.expectedResidualPercentage=sourceItem.expectedResidualPercentage;}}});});}};for(var key in source){_loop(key);}return target;};$scope.ok=function(){var result={},data=$scope.model.denominationObj.results;var deletedDenominations=[];// Get selected denominations
for(var key in data){if(Array.isArray(data[key])){result[key]=data[key].filter(function(item){return item.isDenomSelected===true;});}}var _loop2=function _loop2(_key){if(Array.isArray($scope.model.fundingSourceDenominations[_key])){$scope.model.fundingSourceDenominations[_key].forEach(function(originalDenom){var existsInResult=result[_key]&&result[_key].find(function(item){return item.id===originalDenom.id;});if(!existsInResult&&originalDenom.branchFundingSourceDenominationId){deletedDenominations.push({id:originalDenom.branchFundingSourceDenominationId,multiDenomAllowed:originalDenom.multiDenomAllowed||false,currencyId:originalDenom.currencyId,coinFlag:originalDenom.coinFlag,denominationId:originalDenom.id});}});}};for(var _key in $scope.model.fundingSourceDenominations){_loop2(_key);}callback({modal:orderPackReturnModal,denominations:result,deletedDenominations:deletedDenominations,$scope:$scope});orderPackReturnModal.close();};$scope.cancel=function(){orderPackReturnModal.close();};init();}]});};var deliveryServiceTransaction=function deliveryServiceTransaction(locationId,branchId,formattedDate,trackingId,callback,negative){var deliveryServiceTransactionModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_deliveryServiceTransaction2.default,size:'lg',controller:['$scope','$translate','ShipmentService','$q','Navigation',function($scope,$translate,ShipmentService,DataCounter,Navigation){$scope.model={locationId:locationId,branchId:branchId,formattedDate:formattedDate,trackingId:trackingId,loading:false,transactionDetails:[],errorMessage:null};var init=function init(){$scope.model.loading=true;ShipmentService.getDeliveryServiceTransaction($scope.model.locationId,$scope.model.branchId,$scope.model.formattedDate,$scope.model.trackingId).then(function(data){$scope.model.transactionDetails=data.data;}).catch(function(err){console.log(err);$scope.model.errorMessage=err.data.message;}).finally(function(){$scope.model.loading=false;});};$scope.goToItemHistory=function(trackingId){return Navigation.goToItemHistory(trackingId,deliveryServiceTransactionModal);};$scope.translateTransactionType=function(transactionType){if(transactionType=='HOLD')return $translate.instant('shipment.hold').toUpperCase();else return $translate.instant('shipment.'+transactionType).toUpperCase();};$scope.cancel=function(){deliveryServiceTransactionModal.close();};$scope.ok=function(){callback({modal:deliveryServiceTransactionModal});modal.close();};init();}]});rejectModal(deliveryServiceTransactionModal,negative);};var verifyBagoutCashCount=function verifyBagoutCashCount(bagId,fundingSource,branchId,_callback6,negative){// negative bagoutContent
var verifyBagoutCashCountModal=$uibModal.open({keyboard:false,template:_verifyBagoutCashCount2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope','$translate','AtmResidualService','User','Sound',function($scope,$translate,AtmResidualService,User,Sound){$scope.model={bagId:bagId,fundingSource:fundingSource,branchId:branchId,amount:0,bagoutId:null,loading:false,trackingId:null};var loggedInUser=User.getUser().id;$scope.completeBagout=false;var init=function init(){$scope.model.loading=true;AtmResidualService.getBagoutContent($scope.model.bagId).then(function(data){$scope.model.bagoutContent=data.shipment;$scope.model.bagoutContent.forEach(function(d){$scope.model.amount+=d.amount;d.status='Pending';$scope.model.trackingId=d.trackingId;$scope.model.routeId=d.routeId;});}).catch(function(err){console.log("err",err);}).finally(function(){$scope.model.loading=false;});};$scope.scanBagoutTrackingId=function($event){var bagoutId=$scope.model.bagoutId;var found=false;var isVerified=false;$scope.model.bagoutContent.forEach(function(data){if(data.trackingId===bagoutId){if(data.status==='Verified'){isVerified=true;}else{data.status='Verified';Sound.PlayErrorBeep("#scanner_beep");$scope.status=data.status;found=true;$scope.model.lastBagoutScanned=null;}}});if(isVerified){$scope.model.lastBagoutScanned=$scope.model.bagoutId;$scope.model.isVerifiedMessage=true;$scope.model.bagoutId=null;}else if(!found){Sound.PlayErrorBeep("#scanner_beep");$scope.model.lastBagoutScanned=$scope.model.bagoutId;$scope.model.isVerifiedMessage=false;$scope.model.bagoutId=null;}else{$scope.model.lastBagoutScanned=null;$scope.model.isVerifiedMessage=false;$scope.model.bagoutId=null;}};$scope.completeBagoutShipments=function(){$scope.completeBagout=true;var trackingIds=$scope.model.bagoutContent.map(function(data){return data.trackingId;});confirm({header:$translate.instant('completeBagoutShipment.completeBagout'),message:$translate.instant('verifyCompleteBagoutShipment.completeBagoutShipment'),callback:function callback(_ref99){var confirmModal=_ref99.modal;AtmResidualService.updateShipmentBagseal(trackingIds,$scope.model.bagId,null,$scope.model.fundingSource,loggedInUser,$scope.model.routeId).then(function(data){_callback6({modal:verifyBagoutCashCountModal});}).catch(function(err){console.log("err",err);}).finally(function(){$scope.completeBagout=false;});confirmModal.close();verifyBagoutCashCountModal.close();}});};$scope.override=function(){$scope.completeBagout=true;var trackingIds=$scope.model.bagoutContent.map(function(data){return data.trackingId;});confirm({header:$translate.instant('overrideBagoutShipment.overrideBagout'),message:$translate.instant('verifyOverrideBagoutShipment.overrideBagoutShipment'),callback:function callback(_ref100){var confirmModal=_ref100.modal;confirmSupervisor('verify-bagout-cash-count',null,function(_ref101){var modal=_ref101.modal,supId=_ref101.supId;if(parseInt(supId)===loggedInUser){errorModal('LoggedIn User doesn\'t have permission to override bagout shipment');modal.close();return;}AtmResidualService.updateShipmentBagseal(trackingIds,$scope.model.bagId,supId,$scope.model.fundingSource,loggedInUser,$scope.model.routeId).then(function(data){_callback6({modal:verifyBagoutCashCountModal});}).catch(function(err){console.log("err",err);}).finally(function(){$scope.completeBagout=false;});_callback6({modal:verifyBagoutCashCountModal,supervisorId:supId,$scope:$scope});modal.close();},function(_ref102){var modal=_ref102.modal;modal.close();});confirmModal.close();verifyBagoutCashCountModal.close();}});};$scope.bagoutStatusesVerified=function(){return $scope.model.bagoutContent.every(function(data){return data.status==='Verified';});};$scope.cancel=function(){verifyBagoutCashCountModal.close();};init();}]});// rejectModal(verifyBagoutCashCountModal,negative)
};var editScheduledOrders=function editScheduledOrders(data,callback,negative){var editScheduledOrdersModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_editScheduledOrders2.default,size:'lg',controller:['$scope','$q','LocationService','CommonLayoutService','$translate','RouteService','OrderViewService',function($scope,$q,LocationService,CommonLayoutService,$translate,RouteService,OrderViewService){$scope.model={data:data,combinedRoutes:[],days:[{label:$translate.instant('location.mon'),value:'Mon'},{label:$translate.instant('location.tues'),value:'Tue'},{label:$translate.instant('location.wed'),value:'Wed'},{label:$translate.instant('location.thurs'),value:'Thu'},{label:$translate.instant('location.fri'),value:'Fri'},{label:$translate.instant('location.sat'),value:'Sat'},{label:$translate.instant('location.sun'),value:'Sun'}],combinedRouteIntervals:CommonLayoutService.combinedRouteIntervals(),dayMap:CommonLayoutService.dayMap(),deletedRecurringStops:[],dayArray:[]};var init=function init(){$scope.loading=true;$q.all([LocationService.get($scope.model.data.toLocationId)]).then(function(res){$scope.model.locationDetails=res[0];console.log($scope.model.locationDetails);$scope.model.locationBranches=$scope.model.locationDetails.locationBranches;$scope.model.locationScheduleRecurringData=$scope.model.locationDetails.locationScheduleRecurringData;console.log($scope.model.locationScheduleRecurringData);$scope.loadRoutes('',0);$scope.createCombinedRoutes($scope.mappingObjKeyVal($scope.model.locationDetails.defRecurringRouteHol));}).catch(function(err){console.log(err);}).finally(function(){$scope.loading=false;});};$scope.cancel=function(){editScheduledOrdersModal.close();};$scope.createCombinedRoutes=function(defRecurringRouteHolId){$scope.model.combinedRoutes=[];$scope.model.days.forEach(function(day){var matchedRoute=_.find($scope.model.locationScheduleRecurringData,{dayOfWeek:day.value});var anchorDate=null;if(matchedRoute){anchorDate=new Date(matchedRoute.anchorDate);anchorDate.setMinutes(anchorDate.getMinutes()+anchorDate.getTimezoneOffset());}$scope.model.combinedRoutes.push({combinedRouteIntervals:[].concat((0,_toConsumableArray3.default)($scope.model.combinedRouteIntervals)),id:matchedRoute?matchedRoute.id:null,frequency:matchedRoute?matchedRoute.frequency:null,sequence:matchedRoute?matchedRoute.sequence:99,day:day,route:day.value==='Hol'?defRecurringRouteHolId:matchedRoute?matchedRoute.route:null,interval:matchedRoute?$scope.getCombinedRouteInterval(matchedRoute.interval,matchedRoute.frequency):null,anchorDate:matchedRoute?anchorDate:null,isVisible:day.value==='Hol'?false:true,locationId:matchedRoute?matchedRoute.locationId:null,nextOccurrence:matchedRoute?matchedRoute.nextOccurrence:null,locationScheduleRecurringLoadData:matchedRoute?matchedRoute.locationScheduleRecurringLoadData:[],hasRouteAssignment:matchedRoute?true:false});});};$scope.getCombinedRouteInterval=function(interval,frequency){return $scope.model.combinedRouteIntervals.find(function(ci){return ci.interval===interval&&ci.frequency===frequency;});};$scope.recheckMonthlyOccurences=function(anchorDate,day,index){if(!anchorDate)return;var selectedDate=new Date(anchorDate);var month=selectedDate.getMonth()+1;var year=selectedDate.getFullYear();var occurrences=$scope.countOccurrencesInMonth(year,month,$scope.model.dayMap[day.value]);switch(occurrences){case 2:$scope.model.combinedRoutes[index].combinedRouteIntervals=[].concat((0,_toConsumableArray3.default)($scope.model.combinedRouteIntervals)).slice(0,-3);break;case 3:$scope.model.combinedRoutes[index].combinedRouteIntervals=[].concat((0,_toConsumableArray3.default)($scope.model.combinedRouteIntervals)).slice(0,-2);break;case 4:$scope.model.combinedRoutes[index].combinedRouteIntervals=[].concat((0,_toConsumableArray3.default)($scope.model.combinedRouteIntervals)).slice(0,-1);break;default:$scope.model.combinedRoutes[index].combinedRouteIntervals=[].concat((0,_toConsumableArray3.default)($scope.model.combinedRouteIntervals));break;}if($scope.model.combinedRoutes[index].interval&&$scope.model.combinedRoutes[index].interval.interval==="MONTHOC"&&$scope.model.combinedRoutes[index].interval.frequency>occurrences){$scope.model.combinedRoutes[index].interval=null;}};$scope.countOccurrencesInMonth=function(year,month,targetDay){var count=0;var startDate=new Date(year,month-1,1);var endDate=new Date(year,month,0);for(var currentDate=startDate;currentDate<=endDate;currentDate.setDate(currentDate.getDate()+1)){if(currentDate.getDay()===targetDay){count++;}}return count;};$scope.mappingObjKeyVal=function(obj){if(obj==null)return obj;obj.Key=obj.name+' ('+obj.branchId+')';obj.Value=obj.id;return obj;};$scope.loadRoutes=function(searchKey,offset){$scope.model.total=[];$scope.model.dayArray=[];var selectedBranch=$scope.model.locationBranches.map(function(branch){return branch;});searchKey=searchKey||'';var routeSearchObj={queryJSON:{rules:[{field:'branchId',condition:'IN',data:selectedBranch},{field:'holdRoute',condition:'=',data:false},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};if(!searchKey&&offset!==0&&Math.abs(offset%2)==1){offset=offset-1;}return RouteService.all(routeSearchObj,offset,_app2.default.defaultPageLimit).then(function(data){$scope.model.currentlyAssignedRoutes={};$scope.model.days.forEach(function(day,index){// let selectedVal = $scope.model.locationDetails[day.value].routeId ? $scope.model.locationDetails[day.value].routeId.Value : '';
if(offset==0||offset==undefined){$scope.model.total.push((0,_defineProperty3.default)({},day.value,{total:data.total}));$scope.model.dayArray.push((0,_defineProperty3.default)({},day.value,$scope.mapRoutes(data.results,searchKey,null)));// if (!searchKey) {
//   $scope.model.dayArray[index][day.value].unshift($scope.model.locationDetails[day.value].routeId);
// }
// if ($scope.model.locationDetails[day.value].routeId) Object.assign($scope.model.currentlyAssignedRoutes, new Object({ [day.value]: $scope.model.locationDetails[day.value].routeId.Value }))
}});});};// $scope.mapRoutes = (routes, searchKey, selectedVal) => {
//   return $scope.model.dayArray[index][day.value].find(d => d.id === routeId)
// }
$scope.mapRoutes=function(mapArray,searchKey,originalVal){var newArray=[];mapArray.map(function(obj){obj.Key=obj.name+' ('+obj.branchId+')';obj.Value=obj.id;if(!searchKey&&originalVal){if(obj.id!==originalVal){newArray.push(obj);}}else{newArray.push(obj);}});return newArray;};$scope.loadDaysRoutes=function(searchKey,offset,index,dayOfData){var selectedBranch=$scope.model.locationBranches.map(function(branch){return branch;});searchKey=searchKey||'';var routeSearchObj={queryJSON:{rules:[{field:'branchId',condition:'IN',data:selectedBranch},{field:'holdRoute',condition:'=',data:false},{group:{rules:[{field:'id',condition:'like',data:'%'+searchKey+'%'},{field:'name',condition:'like',data:'%'+searchKey+'%'}],operator:'OR'}}],operator:'AND'}};if(!searchKey&&offset!==0&&Math.abs(offset%2)==1){offset=offset-1;}return RouteService.all(routeSearchObj,offset,_app2.default.defaultPageLimit).then(function(data){if(offset===0||offset==undefined){$scope.model.total[index][dayOfData]={total:data.total};$scope.model.dayArray[index][dayOfData]=$scope.mapRoutes(data.results,searchKey,null);}else{var newDayData=$scope.mapRoutes(data.results,searchKey,null);$scope.model.dayArray[index][dayOfData]=$scope.model.dayArray[index][dayOfData].concat(newDayData);}});};$scope.validateRouteAssignment=function(){var routeMap=new _map2.default();$scope.model.combinedRoutes.forEach(function(route){if(route.route&&route.sequence&&route.anchorDate&&route.interval){routeMap.set(route.day.value,route);}});};$scope.disableDays=function(currentDate,mode,enableDay){if(enableDay.value==="Hol")return false;return mode==='day'&&currentDate.getDay()!==$scope.model.dayMap[enableDay.value];};$scope.recheckMonthlyOccurences=function(anchorDate,day,index){if(!anchorDate)return;var selectedDate=new Date(anchorDate);var month=selectedDate.getMonth()+1;var year=selectedDate.getFullYear();var occurrences=$scope.countOccurrencesInMonth(year,month,$scope.model.dayMap[day.value]);switch(occurrences){case 2:$scope.model.combinedRoutes[index].combinedRouteIntervals=[].concat((0,_toConsumableArray3.default)($scope.model.combinedRouteIntervals)).slice(0,-3);break;case 3:$scope.model.combinedRoutes[index].combinedRouteIntervals=[].concat((0,_toConsumableArray3.default)($scope.model.combinedRouteIntervals)).slice(0,-2);break;case 4:$scope.model.combinedRoutes[index].combinedRouteIntervals=[].concat((0,_toConsumableArray3.default)($scope.model.combinedRouteIntervals)).slice(0,-1);break;default:$scope.model.combinedRoutes[index].combinedRouteIntervals=[].concat((0,_toConsumableArray3.default)($scope.model.combinedRouteIntervals));break;}if($scope.model.combinedRoutes[index].interval&&$scope.model.combinedRoutes[index].interval.interval==="MONTHOC"&&$scope.model.combinedRoutes[index].interval.frequency>occurrences){$scope.model.combinedRoutes[index].interval=null;}};$scope.showNextScheduledOccurences=function(data){$scope.calculateAndUpdateDayOccurrences(data);};$scope.calculateAndUpdateDayOccurrences=function(route){var params={locationId:route.locationId||_this.model.id,dayOfWeek:route.day.value,anchorDate:moment(route.anchorDate).format('YYYY-MM-DD'),interval:route.interval.interval,frequency:route.interval.frequency||route.frequency,sequence:route.sequence,branchId:$scope.model.locationDetails.branchId};LocationService.calculateDayOccurrences(params.locationId,params.dayOfWeek,params.anchorDate,params.interval,params.frequency,params.sequence,params.branchId).then(function(data){nextScheduledOccurences(data);}).catch(function(error){console.error('Error recalculating occurrences:',error);});};$scope.deleteCombinedRoute=function(selectedRoute){$scope.model.combinedRoutes=$scope.model.combinedRoutes.map(function(route){if(route.id===selectedRoute.id){return(0,_extends3.default)({},route,{id:null,anchorDate:null,frequency:null,sequence:99,// Default sequence value as a placeholder
route:null,interval:null,locationId:null,nextOccurrence:null});}return route;});$scope.model.deletedRecurringStops.push({locationScheduleRecurringId:selectedRoute.id,dayOfWeek:selectedRoute.day.label,routeId:selectedRoute.route.Value,anchorDate:moment.utc(selectedRoute.anchorDate).format('YYYY-MM-DD'),interval:selectedRoute.interval.interval});$scope.validateRouteAssignment();};$scope.ok=function(){var combinedRoutes=[];$scope.model.isUpdating=true;$scope.model.combinedRoutes.forEach(function(r){if(r.route&&r.sequence&&r.anchorDate&&r.interval){combinedRoutes.push({id:r.id?r.id:null,description:r.day.value+' '+(r.locationId?r.locationId:$scope.model.data.toLocationId)+' CombinedRoute',anchorDate:moment(r.anchorDate).format('YYYY-MM-DD'),interval:r.interval.interval,frequency:r.interval.frequency,effectiveTillDate:null,sequence:r.sequence,dayOfWeek:r.day.value,locationId:r.locationId?r.locationId:$scope.model.data.toLocationId,routeId:r.route.Value,route:r.route,nextOccurrence:r.nextOccurrence});}});callback({modal:editScheduledOrdersModal,$scope:$scope,combinedRoutes:combinedRoutes,deletedRecurringStops:$scope.model.deletedRecurringStops});};init();}]});};var pendingShipmentTransfer=function pendingShipmentTransfer(routeObj,routeDate,unassignedRouteId,callback,negative){var pendingShipmentTransferModal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_pendingShipmentTransfer2.default,size:'lg',controller:['$scope','$translate','ShipmentService','$q','$location','DataCounter','Navigation','BranchService',function($scope,$translate,ShipmentService,$q,$location,DataCounter,Navigation,BranchService){$scope.model={pendingShipmentTransfer:[],loading:false,routeId:routeObj.routeId,branchId:routeObj.branchId,unassignedRouteId:unassignedRouteId};var init=function init(){$scope.model.loading=true;ShipmentService.pendingShipmentTransferDetails($scope.model.routeId,routeDate,$scope.model.branchId).then(function(data){$scope.model.pendingShipmentTransfer=data.results;$scope.model.extraDetails=data;}).catch(function(err){console.log(err);errorModal(err.data.message);}).finally(function(){$scope.model.loading=false;});};$scope.resendShipmentTransfer=function(){var trackingIds=$scope.model.pendingShipmentTransfer.map(function(d){return d.trackingId;});var shipmentTransferIds=$scope.model.pendingShipmentTransfer.map(function(d){return d.shipmentTransferId;});var _$scope$model$extraDe=$scope.model.extraDetails.transferOutRouteDetails,transferOutUserId=_$scope$model$extraDe.userId,transferOutRouteId=_$scope$model$extraDe.routeId,transferOutBranchId=_$scope$model$extraDe.branchId,transferOutTruckId=_$scope$model$extraDe.vehicleId,_$scope$model$extraDe2=_$scope$model$extraDe.transferOutVaultDate,transferOutVaultDate=_$scope$model$extraDe2===undefined?null:_$scope$model$extraDe2;var _$scope$model$extraDe3=$scope.model.extraDetails.transferInRouteDetails,transferInUserId=_$scope$model$extraDe3.userId,transferInRouteId=_$scope$model$extraDe3.routeId,transferInBranchId=_$scope$model$extraDe3.branchId,transferInTruckId=_$scope$model$extraDe3.vehicleId,_$scope$model$extraDe4=_$scope$model$extraDe3.transferInVaultDate,transferInVaultDate=_$scope$model$extraDe4===undefined?null:_$scope$model$extraDe4;var comment=$scope.model.extraDetails.comment;$scope.model.isSending=true;ShipmentService.resendShipmentTransfer(trackingIds,transferOutUserId,transferInUserId,transferOutRouteId,transferInRouteId,transferOutBranchId,transferInBranchId,transferOutTruckId,transferInTruckId,comment,transferInVaultDate,transferOutVaultDate,shipmentTransferIds).then(function(res){pendingShipmentTransferModal.close();confirm({header:$translate.instant('Success'),message:res.message,callback:function callback(_ref103){var modal=_ref103.modal;modal.close();},negative:function negative(_ref104){var modal=_ref104.modal;modal.close();},buttons:['common.ok'],type:'success'});}).catch(function(err){console.log(err);errorModal(err.data.message);}).finally(function(){$scope.model.isSending=false;});};$scope.cancel=function(){pendingShipmentTransferModal.close();};// $scope.cancel = () => {
//   negative({
//     modal: pendingShipmentTransferModal
//   });
// }
$scope.ok=function(){callback({modal:pendingShipmentTransferModal,message:''});modal.close();};$scope.goToItemHistory=function(trackingId){return Navigation.goToItemHistory(trackingId,pendingShipmentTransferModal);};$scope.goToServiceHistory=function(locationId){Navigation.goToServiceHistory(locationId,null,true,pendingShipmentTransferModal);};$scope.cancelShipmentTransfer=function(){var shipments=$scope.model.pendingShipmentTransfer.map(function(data){return{shipmentId:data.shipmentId,trackingId:data.trackingId,fromLocationId:data.fromLocationId,toLocationId:data.toLocationId,routeId:data.transferOutRouteId,branchId:$scope.model.branchId,vaultDate:moment.utc(routeDate).format('YYYY-MM-DD')};});confirmSupervisor('cancel-shipment-transfer',null,function(_ref105){var modal=_ref105.modal,supId=_ref105.supId;$scope.isCancelTransferLoading=true;BranchService.cancelShipmentTransfer(shipments,'all',$scope.model.branchId).then(function(){callback({modal:pendingShipmentTransferModal,message:'TRNASFER_CANCELLED'});}).catch(function(err){if(err&&err.data&&err.data.message){errorModal('error.'+err.data.message);}}).finally(function(){modal.close();$scope.isCancelTransferLoading=false;});},function(_ref106){var modal=_ref106.modal;if(modal)modal.close();});};init();}]});};var updateServiceHistory=function updateServiceHistory(data,_callback7,negative){var modal=$uibModal.open({template:_updateServiceHistory2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',windowClass:'update-service-history-modal',controller:['$scope','$uibModalInstance','DateUtil','$translate',function($scope,$uibModalInstance,DateUtil,$translate){$scope.deletedItems=[];var getBucketName=function getBucketName(status){switch(status){case'INCOMPLETED':return $translate.instant('serviceTickets.incomplete');case status:return $translate.instant('serviceTickets.status_'+status);default:return;}};var translateEntryType=function translateEntryType(type){return $translate.instant('entry_type.'+type);};$scope.model={DateUtil:DateUtil,isLoading:false,serviceHistoryData:data.map(function(item){var m=moment(item.timestamp);// Replicate Label Logic
var label=[];if(item.statusUpdate){label=item.statusUpdate;}else if(item.status&&!item.entryType){label=[getBucketName(item.status)];}else if(item.entryType&&!item.status&&!item.statusUpdate){label=[translateEntryType(item.entryType)];}var notes=item.serviceOrderStatusNote||item.entryData&&item.entryData.note||'';var originalTimestampString=m.format('YYYY-MM-DD HH:mm:ss');return(0,_extends3.default)({},item,{tempDate:m.toDate(),tempTime:m.toDate(),originalTimestamp:m.clone(),oldTimestamp:originalTimestampString,oldNote:notes,displayLabel:label,tempNotes:notes,isDeletedFlag:false});})};var getEditedTimestamp=function getEditedTimestamp(record){if(!record)return null;var date=moment(record.tempDate).format('YYYY-MM-DD');var time=moment(record.tempTime).format('HH:mm:ss');return moment(date+' '+time);};$scope.validateAll=function(){var previousInternalTimestamp=null;var previousWasInvalid=false;$scope.model.serviceHistoryData.forEach(function(item,index){item.errorMessage=null;item.isTimeInvalid=false;item.isDateInvalid=false;item.timeError=null;var statusMoment=getEditedTimestamp(item);var now=moment();if(statusMoment.isAfter(now)){if(statusMoment.startOf('day').isAfter(now.startOf('day'))){item.isDateInvalid=true;}else{item.isTimeInvalid=true;}item.timeError='Time cannot be in future';previousInternalTimestamp=statusMoment;previousWasInvalid=true;return;}if(previousWasInvalid){previousInternalTimestamp=statusMoment;return;}if(index>0&&previousInternalTimestamp){if(statusMoment.isBefore(previousInternalTimestamp)){var prevDate=previousInternalTimestamp.clone().startOf('day');var currDate=statusMoment.clone().startOf('day');if(currDate.isBefore(prevDate)){item.isDateInvalid=true;}else{item.isTimeInvalid=true;}item.timeError='Time must be after previous log';previousWasInvalid=true;return;}}previousInternalTimestamp=statusMoment;});};$scope.showRemoveButton=function(historyItem,index){if(!historyItem.status)return false;var firstIndex=_.findIndex($scope.model.serviceHistoryData,function(item){return(item.status==='ON_ROUTE'||item.status==='ON_SITE')&&item.status===historyItem.status;});return firstIndex!==-1&&firstIndex<index;};$scope.hasAnyRemovableItems=function(){return _.some($scope.model.serviceHistoryData,function(item,index){return $scope.showRemoveButton(item,index);});};$scope.confirmAndRemoveHistoryItem=function(historyItem,index){confirm({header:$translate.instant('common.confirm_title'),message:'Are you sure you want to delete this service order status?',callback:function callback(_ref107){var modal=_ref107.modal;historyItem.isDeletedFlag=true;var timestamp=getEditedTimestamp(historyItem);var item={id:historyItem.id,logId:historyItem.logId,status:historyItem.status,entryType:historyItem.entryType,timestamp:timestamp.format('YYYY-MM-DD HH:mm:ss'),notes:historyItem.tempNotes,oldTimestamp:historyItem.oldTimestamp,oldNote:historyItem.oldNote,isExternal:!!historyItem.externalProcessorId,serviceOrderId:historyItem.serviceOrderId,isFirstAccepted:!!historyItem.isFirstAccepted,userId:historyItem.userId,isDeletedFlag:true};_callback7({modal:$uibModalInstance,history:[item],$scope:$scope,isSingleAction:true,onSuccess:function onSuccess(){$scope.model.serviceHistoryData.splice(index,1);$scope.validateAll();}});modal.close();},negative:function negative(_ref108){var modal=_ref108.modal;modal.close();},type:'danger'});};$scope.saveHistoryItem=function(historyItem){$scope.saveErrorMessage=null;var index=_.findIndex($scope.model.serviceHistoryData,{id:historyItem.id});var timestamp=getEditedTimestamp(historyItem);var neighbors=[{item:$scope.model.serviceHistoryData[index-1],isBefore:true,error:'Time must be after previous log'},{item:$scope.model.serviceHistoryData[index+1],isBefore:false,error:$translate.instant('serviceTickets.time_subsequent_error')}];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=(0,_getIterator3.default)(neighbors),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _ref110=_step.value;var _item=_ref110.item,isBefore=_ref110.isBefore,_error=_ref110.error;if(_item&&_item.originalTimestamp){var neighborTs=_item.originalTimestamp;var isInvalid=isBefore?timestamp.isBefore(neighborTs):timestamp.isAfter(neighborTs);if(isInvalid){historyItem.isDateInvalid=timestamp.clone().startOf('day').isSame(neighborTs.clone().startOf('day'))?false:true;historyItem.isTimeInvalid=!historyItem.isDateInvalid;historyItem.timeError=_error;return;}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}var lastCompleteIndex=_.findLastIndex($scope.model.serviceHistoryData,{status:'COMPLETE'});var item={id:historyItem.id,logId:historyItem.logId,status:historyItem.status,entryType:historyItem.entryType,timestamp:timestamp.format('YYYY-MM-DD HH:mm:ss'),notes:historyItem.tempNotes,oldTimestamp:historyItem.oldTimestamp,oldNote:historyItem.oldNote,isLastCompleted:index===lastCompleteIndex,isExternal:!!historyItem.externalProcessorId,serviceOrderId:historyItem.serviceOrderId,userId:historyItem.userId,isFirstAccepted:!!historyItem.isFirstAccepted,isDeletedFlag:false};_callback7({modal:$uibModalInstance,history:[item],$scope:$scope,isSingleAction:true,onSuccess:function onSuccess(updatedItems){if(updatedItems&&updatedItems.length){var updatedItem=updatedItems[0];historyItem.originalTimestamp=moment(updatedItem.timestamp);historyItem.oldTimestamp=updatedItem.timestamp;historyItem.oldNote=updatedItem.notes;}$scope.validateAll();}});};$scope.validateAll();$scope.getFirstError=function(){var itemWithError=_.find($scope.model.serviceHistoryData,function(item){return!!item.errorMessage;});return itemWithError?itemWithError.errorMessage:null;};$scope.hasErrors=function(){return _.some($scope.model.serviceHistoryData,function(item){return!!item.errorMessage||item.isTimeInvalid||item.timeError;});};$scope.ok=function(){var history=[];var lastCompleteIndex=_.findLastIndex($scope.model.serviceHistoryData,{status:'COMPLETE'});$scope.model.serviceHistoryData.forEach(function(item,index){var timestamp=getEditedTimestamp(item);history.push({id:item.id,logId:item.logId,status:item.status,entryType:item.entryType,timestamp:timestamp.format('YYYY-MM-DD HH:mm:ss'),notes:item.tempNotes,oldTimestamp:item.oldTimestamp,oldNote:item.oldNote,isLastCompleted:index===lastCompleteIndex,isExternal:!!item.externalProcessorId,serviceOrderId:item.serviceOrderId,userId:item.userId,isFirstAccepted:!!item.isFirstAccepted});});_callback7({modal:modal,history:history,$scope:$scope});};$scope.cancel=function(){negative({modal:$uibModalInstance});};}]});};var denominationBreakdownModal=function denominationBreakdownModal(items,negative){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_denominationBreakdown2.default,size:'md',controller:['$scope',function($scope){$scope.items=items;$scope.type='primary';$scope.cancel=function(){modal.close();};}]});rejectModal(modal,negative);};var routeServiceTicketsModal=function routeServiceTicketsModal(routeData,negative){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_routeServiceTickets2.default,size:'lg',controller:['$scope','$state','ServiceOrderService','DataCounter','Navigation','DateUtil',function($scope,$state,ServiceOrderService,DataCounter,Navigation,DateUtil){$scope.DateUtil=DateUtil;$scope.model={loading:true,tickets:[],routeData:routeData};$scope.getBucketName=function(status){switch(status){case'INCOMPLETED':return $translate.instant('serviceTickets.incomplete');case status:return $translate.instant('serviceTickets.status_'+status);default:return;}};$scope.calculateHours=function(date){var startDate=new Date();var endDate=new Date(date);var diff=moment(startDate).diff(endDate);return diff;};$scope.getTime=function(time){var ms=moment.duration(time).valueOf();return ms;};$scope.getPriorityDurationHours=function(requestedTimeframe){var priorityHours={'24HR':24,'48HR':48,'72HR':72};return priorityHours[requestedTimeframe]||null;};$scope.getPriorityReferenceTime=function(serviceTicket){return serviceTicket.createdAt;};$scope.formatPriorityRemaining=function(ms){var overdueLabel=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'Overdue';var absoluteMs=Math.abs(ms);var duration=moment.duration(absoluteMs);var totalMinutes=Math.max(Math.floor(duration.asMinutes()),0);var hours=Math.floor(totalMinutes/60);var minutes=totalMinutes%60;var compactDuration=hours>0?hours+'h '+minutes+'m':minutes+'m';return ms<0?overdueLabel+' '+compactDuration:compactDuration+' left';};$scope.decoratePriorityDetails=function(serviceTicket){var branchTimezone=serviceTicket.branchTimezone||routeData&&routeData.timezone||moment.tz.guess();var requestedTimeframe=serviceTicket.requestedTimeframe||null;var referenceTime=$scope.getPriorityReferenceTime(serviceTicket);var comparisonTime=moment().tz(branchTimezone);var effectiveRequestedTimeframe=requestedTimeframe;var priorityRemaining=null;var isOverdue=false;if(requestedTimeframe==='SCHEDULED'&&serviceTicket.targetTime){var targetMoment=moment.tz(serviceTicket.targetTime,branchTimezone);var remainingMs=targetMoment.diff(comparisonTime);isOverdue=remainingMs<=0;priorityRemaining=serviceTicket.completed||serviceTicket.cancelled?null:$scope.formatPriorityRemaining(remainingMs);serviceTicket.targetTimeDisplay=targetMoment.format('MM/DD/YYYY | HH:mm:ss');}else{var priorityHours=$scope.getPriorityDurationHours(requestedTimeframe);if(priorityHours&&referenceTime){var deadlineMoment=moment.tz(referenceTime,branchTimezone).add(priorityHours,'hours');var _remainingMs=deadlineMoment.diff(comparisonTime);isOverdue=_remainingMs<=0;priorityRemaining=serviceTicket.completed||serviceTicket.cancelled?null:$scope.formatPriorityRemaining(_remainingMs);serviceTicket.targetTimeDisplay=deadlineMoment.format('MM/DD/YYYY | HH:mm:ss');serviceTicket.targetTime=deadlineMoment.toISOString();}else if(requestedTimeframe==='ASAP'){if(referenceTime){var asapMoment=moment.tz(referenceTime,branchTimezone);var _remainingMs2=asapMoment.diff(comparisonTime);priorityRemaining=serviceTicket.completed||serviceTicket.cancelled?null:$scope.formatPriorityRemaining(_remainingMs2);serviceTicket.targetTimeDisplay=asapMoment.format('MM/DD/YYYY | HH:mm:ss');serviceTicket.targetTime=asapMoment.toISOString();}else{priorityRemaining=serviceTicket.completed||serviceTicket.cancelled?null:'Immediate';}}}if(isOverdue&&['24HR','48HR','72HR','SCHEDULED'].includes(requestedTimeframe)){effectiveRequestedTimeframe='ASAP';}serviceTicket.displayRequestedTimeframe=effectiveRequestedTimeframe;serviceTicket.priorityRemaining=priorityRemaining;serviceTicket.priorityEscalated=requestedTimeframe!=='ASAP'&&effectiveRequestedTimeframe==='ASAP';serviceTicket.isPriorityAlert=effectiveRequestedTimeframe==='ASAP'||requestedTimeframe==='24HR';};$scope.decorateServiceTicket=function(serviceTicket){if(serviceTicket.completed){var timeDiff=moment(serviceTicket.completedAt).diff(serviceTicket.createdAt);var duration=moment.duration(timeDiff);var timePending=Math.floor(duration.asHours());serviceTicket.timeOpen=timePending+':'+moment.utc(duration.asMilliseconds()).format('mm:ss');}if(serviceTicket.cancelled){var _timeDiff=moment(serviceTicket.cancelledAt).diff(serviceTicket.createdAt);var _duration=moment.duration(_timeDiff);var _timePending=Math.floor(_duration.asHours());serviceTicket.timeOpen=_timePending+':'+moment.utc(_duration.asMilliseconds()).format('mm:ss');}$scope.decoratePriorityDetails(serviceTicket);};$scope.serviceOrderThresolds={routeTickets:{totalRedThreshold:0,totalOrangeThreshold:0,totalYellowThreshold:0,redThresholdIds:[],orangeThresholdIds:[],yellowThresholdIds:[]}};$scope.calculateThresholds=function(){$scope.indexMap={};$scope.serviceOrderThresolds.routeTickets={totalRedThreshold:0,totalOrangeThreshold:0,totalYellowThreshold:0,redThresholdIds:[],orangeThresholdIds:[],yellowThresholdIds:[]};if($scope.model.tickets&&$scope.model.tickets.length){$scope.model.tickets.forEach(function(serviceTickets){if(serviceTickets.thresholds&&serviceTickets.thresholds.length){serviceTickets.thresholds.forEach(function(threshold){if(threshold.redThreshold){if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.redThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('06:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.redThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalRedThreshold++;}}else if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.redThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('04:00:00')&&$scope.calculateHours(serviceTickets.createdAt)<$scope.getTime('06:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.orangeThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalOrangeThreshold++;}}else if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.redThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('02:00:00')&&$scope.calculateHours(serviceTickets.createdAt)<$scope.getTime('04:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.yellowThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalYellowThreshold++;}}}if(threshold.orangeThreshold){if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.orangeThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('06:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.redThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalRedThreshold++;}}else if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.orangeThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('04:00:00')&&$scope.calculateHours(serviceTickets.createdAt)<$scope.getTime('06:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.orangeThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalOrangeThreshold++;}}else if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.orangeThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('02:00:00')&&$scope.calculateHours(serviceTickets.createdAt)<$scope.getTime('04:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.yellowThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalYellowThreshold++;}}}if(threshold.yellowThreshold){if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.yellowThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('06:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.redThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalRedThreshold++;}}else if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.yellowThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('04:00:00')&&$scope.calculateHours(serviceTickets.createdAt)<$scope.getTime('06:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.orangeThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalOrangeThreshold++;}}else if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.yellowThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('02:00:00')&&$scope.calculateHours(serviceTickets.createdAt)<$scope.getTime('04:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.yellowThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalYellowThreshold++;}}}if(threshold.otherThreshold){if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.otherThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('06:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.redThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalRedThreshold++;}}else if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.otherThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('04:00:00')&&$scope.calculateHours(serviceTickets.createdAt)<$scope.getTime('06:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.orangeThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalOrangeThreshold++;}}else if($scope.calculateHours(serviceTickets.createdAt)>$scope.getTime(threshold.otherThreshold)&&$scope.calculateHours(serviceTickets.createdAt)>$scope.getTime('02:00:00')&&$scope.calculateHours(serviceTickets.createdAt)<$scope.getTime('04:00:00')){if(!$scope.indexMap.hasOwnProperty(serviceTickets.encounterId)){$scope.indexMap[serviceTickets.encounterId]=serviceTickets.thresholds.length;$scope.serviceOrderThresolds.routeTickets.yellowThresholdIds.push(serviceTickets.encounterId);$scope.serviceOrderThresolds.routeTickets.totalYellowThreshold++;}}}});}});}};$scope.goToServiceHistory=function(data){return Navigation.goToServiceHistory(data.locationId,null,true,modal);};$scope.getLocationUrl=function(data){return $state.href('branchManagement.locations',{locationId:data.locationId},{absolute:true});};$scope.onLocationClick=function(event,data){if(event.ctrlKey||event.metaKey||event.button===1){return;}event.preventDefault();$scope.goToServiceHistory(data);};var init=function init(){var branchIds=[routeData.branchId||routeData.routeBranchId];var timezone=moment.tz.guess();var allBuckets=['UNACCEPTED','UNASSIGNED','PENDING_ASSIGN','CANT_COMPLETE_BUCKET','ASSIGNED_PENDING_MESSENGER_ACCEPT','ASSIGNED','HOLD','ON_ROUTE','ON_SITE','COMPLETE','CANCELLED'];var displayBuckets=allBuckets;if(routeData.vaultDate&&moment(routeData.vaultDate).startOf('day').isAfter(moment().startOf('day'))){displayBuckets=['UNACCEPTED','UNASSIGNED','PENDING_ASSIGN','CANT_COMPLETE_BUCKET','ASSIGNED_PENDING_MESSENGER_ACCEPT','ASSIGNED','HOLD','ON_ROUTE','ON_SITE'];}var dateRange={};var startDate=moment().subtract(30,'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');var endDate=moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');allBuckets.forEach(function(b){var _startDate=startDate;if(b==='COMPLETE'||b==='CANCELLED'){_startDate=moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');}dateRange[b]={startDate:_startDate,endDate:endDate,columnName:null,sortAsc:null};});var filter={pageLimit:100,pageOffset:0,searchKey:null,dateRange:dateRange};var userId=routeData.userId||null;ServiceOrderService.getServiceOrder(branchIds,null,routeData.routeId,userId,null,'',filter,timezone,null,null).then(function(data){var results=data.results||{};var tickets=[];displayBuckets.forEach(function(bucket){if(results[bucket]&&results[bucket].items){results[bucket].items.forEach(function(item){var createdAt=item.createdAt?new Date(item.createdAt):null;var now=new Date();var timeOpenMs=createdAt?now.getTime()-createdAt.getTime():0;item.timeOpenMs=timeOpenMs;var hours=Math.floor(timeOpenMs/3600000);var minutes=Math.floor(timeOpenMs%3600000/60000);var seconds=Math.floor(timeOpenMs%60000/1000);item.timeOpenDisplay=hours+':'+String(minutes).padStart(2,'0')+':'+String(seconds).padStart(2,'0');if(item.timeOpen===undefined){var duration=moment.duration(timeOpenMs);var timePending=Math.floor(duration.asHours());item.timeOpen=timePending+':'+moment.utc(duration.asMilliseconds()).format('mm:ss');}item.actionCodes=item.actionCodes||(item.actionCodeId?[{actionCodeId:item.actionCodeId}]:[]);$scope.decorateServiceTicket(item);tickets.push(item);});}});$scope.model.tickets=tickets;$scope.calculateThresholds();}).catch(function(err){console.log(err);}).finally(function(){$scope.model.loading=false;});};$scope.sortColumn='encounterId';$scope.reverseSort=false;$scope.sortBy=function(column){if($scope.sortColumn===column){$scope.reverseSort=!$scope.reverseSort;}else{$scope.sortColumn=column;$scope.reverseSort=false;}};$scope.getServiceTicketUrl=function(encounterId){return $state.href('serviceTickets',{encounterId:encounterId},{absolute:true});};$scope.onServiceTicketClick=function(event,encounterId){if(event.ctrlKey||event.metaKey||event.button===1){return;}event.preventDefault();$scope.goToServiceTicket(encounterId);};$scope.goToServiceTicket=function(encounterId){return Navigation.goToServiceTicket(encounterId,modal);};$scope.cancel=function(){modal.close();};init();}]});rejectModal(modal,negative);};var masterCashOrderDetailsModal=function masterCashOrderDetailsModal(date,orders,totalAmount,denomTotals){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_masterCashOrderDetails2.default,windowClass:'master-cash-orders-modal',size:'lg',controller:['$scope','$translate','$state','$filter','Navigation',function($scope,$translate,$state,$filter,Navigation){$scope.date=date;$scope.formattedDate=moment(date).format('MMMM Do, YYYY');$scope.count=orders.length;$scope.totalAmount=totalAmount;$scope.denomTotals=denomTotals;$scope.orders=orders;$scope.cancel=function(){modal.close();};$scope.goToLocation=function(locationId){modal.close();Navigation.goToServiceHistory(locationId,date,true,null);};$scope.goToShipment=function(trackingId){modal.close();$state.go('branchManagement.items',{id:trackingId});};$scope.goToOrderHistory=function(orderNo,fundingSourceId){modal.close();Navigation.goToOrderHistory(orderNo,date,true,false,true,false,null,fundingSourceId);};$scope.printData=function(){var path=$state.href('printMasterCashSchedule');window.w=window.open(path,'_blank');window.w.printData={date:date,formattedDate:$scope.formattedDate,orders:orders,totalAmount:totalAmount,denomTotals:denomTotals};};$scope.exportData=function(){var csvContent="";if(denomTotals&&denomTotals.length){csvContent+="#,Denomination,Amount\n";denomTotals.forEach(function(denom,index){csvContent+='"'+(index+1)+'","'+denom.id+'","'+$filter('currency')(denom.amount||0,'$',2)+'"\n';});csvContent+="\n\n";}csvContent+="Tracking ID,Location ID,Location Name,Order Type,Order No,Amount,Denominations\n";orders.forEach(function(order){var orderNo=order.orderNo||'N/A';var trackingIds=order.parentTrackingId?order.parentTrackingId:order.trackingIds&&order.trackingIds.length>0?order.trackingIds.join(" | "):"N/A";var locationId=''+(order.toLocationId||'');var locationName=''+(order.toLocationName||'');var orderType=order.orderType?$translate.instant('atm_residual.order_type_'+order.orderType):order.shiptypeId?$translate.instant(order.shiptypeId):$translate.instant('common.n_a');var amountStr=$filter('currency')(order.amount||0,'$',2);var amount='"'+amountStr+'"';var denoms=(order.denominations||[]).map(function(d){return d.id+': '+$filter('currency')(d.amount||0,'$',2);}).join(" | ");var row='"'+trackingIds+'","'+locationId+'","'+locationName+'","'+orderType+'","'+orderNo+'",'+amount+',"'+denoms+'"';csvContent+=row+"\n";});var file=new Blob([csvContent],{type:'text/csv'});var fileURL=URL.createObjectURL(file);var a=document.createElement('a');a.href=fileURL;a.target='_blank';a.download='Order_Details_'+date+'.csv';document.body.appendChild(a);a.click();a.remove();};}]});};var bulkUpdateUserPermissionsModal=function bulkUpdateUserPermissionsModal(positive,negative,currentBranchId){var modal=$uibModal.open({template:_bulkUpdateUserPermissions2.default,size:'lg',backdrop:'static',controller:['$scope','$translate','UsersService','BranchService','$q','UserService','Auth','User','$timeout','CustomerService','UserBranchFundingSourceService','BranchFundingSourceService','SetupService',function($scope,$translate,UsersService,BranchService,$q,UserService,Auth,User,$timeout,CustomerService,UserBranchFundingSourceService,BranchFundingSourceService,SetupService){$scope.model={isCustomerUser:true,selectPermission:false,updatePassword:false,updateFundingSource:false,cloneFromUserId:null,cloneToUsers:[],branch:[],branchId:currentBranchId||null,password:'',cnfPassword:'',customer:null,sameForAll:false,applySamePermission:false,branchPermission:null,currentBranchId:currentBranchId||null};$scope.aclPermissions={};$scope.fromUsersObj={results:[],totalRecords:0,pageLimit:10};$scope.toUsersObj={results:[],totalRecords:0,pageLimit:10};$scope.branchData=[];$scope.customerList=[];$scope.cloneFromFundingSources=[];$scope.branchFundingSourceGrouped=[];$scope.model.selectedFundingSource=[];$scope.customerPermissions=['service_tickets','branch_mgmt','branch_mgmt_locations','branch_mgmt_items','branch_mgmt_orders','master_cash_schedule','branch_mgmt_cash_transactions','setting','setting-location','branch_mgmt_customer_pickup_reports','on_demand_call','pickup_request_management','branch_mgmt_deposit_reports','tnt_react_app','branch_mgmt_daily_balance_sheet','branch_mgmt_cancelled_shipments','branch_mgmt_billing_approval','branch_mgmt_contact_request','branch_mgmt_stop_scheduling','branch_mgmt_bin_manifest','branch_mgmt_average_daily_balance','bulk_cash_management','cash_activity','shipment_batch','ach_management','branch_mgmt_billing_approval_create_billing_record','branch_mgmt_billing_approval_approve_billing_record','branch_mgmt_billing_approval_edit_billing_record','branch_mgmt_billing_approval_delete_billing_record','tnt_billing','tnt_billing_billable_events','tnt_billing_billing_category','tnt_billing_contract','tnt_billing_customer','tnt_billing_location_distance','tnt_billing_fuel_surcharges','price_point','tnt_billing_contract_type'];$scope.permissionLoading=false;$scope.permissions={};$scope.localLang={selectAll:$translate.instant('common.selectall'),selectNone:$translate.instant('common.selectnone'),reset:$translate.instant('shipmentBatch.reset'),search:$translate.instant('common.search'),nothingSelected:$translate.instant('common.noneselected')};$scope.autoSelectSameForAll=function(){$scope.model.sameForAll=$scope.model.branch&&$scope.model.branch.length>1;if($scope.model.branch&&$scope.model.branch.length>0){if(!$scope.model.branchId||!$scope.model.branch.find(function(b){return b.id===$scope.model.branchId;})){$scope.model.branchId=$scope.model.branch[0].id;}$scope.model.branchPermission=$scope.model.branchId;}else{$scope.model.branchId=undefined;$scope.model.branchPermission=undefined;}$scope.getBranchPermission();if($scope.model.updateFundingSource){$scope.getFundingSource();}};$scope.assignPermissions=function(){if($scope.model.sameForAll){$scope.model.branchPermission=$scope.model.branchId;$scope.getBranchPermission();}};var init=function init(){$scope.onUserTypeChange();$q.all([BranchService.all(null,0,1000),SetupService.all(null,0,1000)]).then(function(data){var branchesWithExistingSetupRecord=(data[1].results||[]).map(function(s){return s.branchId;});$scope.branchData=(data[0].results||[]).filter(function(b){return branchesWithExistingSetupRecord.includes(b.id);}).map(function(b){return{id:b.id,name:b.id+' | '+(b.description||b.name),ticked:false};});if(currentBranchId){$scope.model.branch=$scope.branchData.filter(function(b){return b.ticked;});if($scope.model.branch.length){$scope.model.branchId=$scope.model.branch[0].id;$scope.model.branchPermission=$scope.model.branchId;$scope.getBranchPermission();}}});};$scope.isOnlyPasswordUpdate=function(){return $scope.model.updatePassword&&!$scope.model.selectPermission&&!$scope.model.updateFundingSource;};$scope.checkAndLoadToUsers=function(){var hasAction=$scope.model.selectPermission||$scope.model.updatePassword||$scope.model.updateFundingSource;if(!$scope.model.cloneFromUserId||!$scope.model.cloneFromUserId.id){if(hasAction){$scope.toUsersObj.results=[];$scope.getToUsersList(null,1);}else{$scope.model.cloneToUsers=[];$scope.toUsersObj.results=[];$scope.toUsersObj.totalRecords=0;// Clear branches and related data if no action and no source
$scope.model.branch=[];$scope.model.branchId=null;if($scope.branchData){$scope.branchData.forEach(function(b){return b.ticked=false;});}$scope.model.customer=null;$scope.model.selectedFundingSource=[];$scope.branchFundingSourceGrouped=[];$scope.aclPermissions={};}}};$scope.setUserType=function(isCustomerUser){if($scope.currentIsCustomerUser!==isCustomerUser){$scope.currentIsCustomerUser=isCustomerUser;$scope.model.isCustomerUser=isCustomerUser;$scope.onUserTypeChange();}};$scope.onUserTypeChange=function(){$scope.currentIsCustomerUser=$scope.model.isCustomerUser;var hadCloneFrom=!!($scope.model.cloneFromUserId&&$scope.model.cloneFromUserId.id);$scope.fromUsersObj.results=[];$scope.fromUsersObj.totalRecords=0;$scope.toUsersObj.results=[];$scope.toUsersObj.totalRecords=0;$scope.toUsersSearchKey=undefined;$scope.model.cloneFromUserId=null;$scope.model.cloneToUsers=[];$scope.model.branch=[];$scope.model.branchId=null;$scope.model.customer=null;$scope.model.selectedFundingSource=[];$scope.branchFundingSourceGrouped=[];$scope.cloneFromFundingSources=[];$scope.aclPermissions={};if($scope.branchData){$scope.branchData.forEach(function(b){return b.ticked=false;});}$scope.customerList=[];if($scope.model.updateFundingSource&&$scope.model.isCustomerUser){$scope.getCustomer(null,0);}var showFromUsers=!$scope.model.selectPermission&&!$scope.isOnlyPasswordUpdate();if(showFromUsers){$scope.getFromUsersList(null,0);}$scope.updateVisiblePermissions();if(!hadCloneFrom){var hasAction=$scope.model.selectPermission||$scope.model.updatePassword||$scope.model.updateFundingSource;if(hasAction){$scope.getToUsersList(null,1);}}};$scope.updateVisiblePermissions=function(){var allPerms=Auth.permission();if($scope.model.isCustomerUser){var filterLevel=function filterLevel(obj){var res={};angular.forEach(obj,function(item,key){if($scope.customerPermissions.indexOf(key)>=0){var newItem=angular.copy(item);if(newItem.child){newItem.child=filterLevel(newItem.child);if((0,_keys2.default)(newItem.child).length===0){delete newItem.child;}}res[key]=newItem;}});return res;};$scope.permissions=filterLevel(allPerms);}else{$scope.permissions=allPerms;}};$scope.getFromUsersList=function(searchKey,offset){$scope.fromUsersObj.loading=true;var searchText=searchKey||'';var recordOffset=offset||0;var trimmedSearch=searchText.trim();var searchTerms=trimmedSearch?/\s{2,}/.test(trimmedSearch)?[trimmedSearch]:trimmedSearch.split(/\s+/):[''];var nameGroupRules=searchTerms.map(function(term){return{group:{rules:[{field:'firstName',condition:'like',data:'%'+term+'%'},{field:'lastName',condition:'like',data:'%'+term+'%'},{field:'id',condition:'like',data:'%'+term+'%'}],operator:'OR'}};});var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.currentBranchId}].concat((0,_toConsumableArray3.default)(nameGroupRules),(0,_toConsumableArray3.default)($scope.model.isCustomerUser?[{field:'customerUser',condition:'=',data:true}]:[{field:'email',condition:'!=',data:null},{field:'customerUser',condition:'=',data:false}])),operator:'AND'},extraDetails:{searchText:searchText,status:$scope.model.isCustomerUser?'customerUser':'web',branchId:$scope.model.currentBranchId,offset:recordOffset}};UsersService.all(searchObj,recordOffset,$scope.fromUsersObj.pageLimit).then(function(data){var users=data.results.map(function(u){return(0,_extends3.default)({},u,{value:u.id,Value:u.id,Key:u.id+' | '+u.firstName+' '+u.lastName});});if(recordOffset===0){$scope.fromUsersObj.results=users;$scope.fromUsersObj.totalRecords=data.total;}else{$scope.fromUsersObj.results=_.uniqBy($scope.fromUsersObj.results.concat(users),'Value');}}).finally(function(){$scope.fromUsersObj.loading=false;});};$scope.toUsersSearchKey=undefined;$scope.getToUsersList=function(searchKey,offset){var hasAction=$scope.model.selectPermission||$scope.model.updatePassword||$scope.model.updateFundingSource;if(!hasAction&&(!$scope.model.cloneFromUserId||!$scope.model.cloneFromUserId.id)){$scope.toUsersObj.results=[];$scope.toUsersObj.totalRecords=0;return;}var searchText=searchKey||'';var recordOffset=offset&&offset>1?(offset-1)*$scope.toUsersObj.pageLimit:0;if(recordOffset===0&&$scope.toUsersSearchKey===searchText&&$scope.toUsersObj.results.length>0){return;}$scope.toUsersSearchKey=searchText;$scope.toUsersObj.loading=true;var trimmedSearch=searchText.trim();var searchTerms=trimmedSearch?/\s{2,}/.test(trimmedSearch)?[trimmedSearch]:trimmedSearch.split(/\s+/):[''];var nameGroupRules=searchTerms.map(function(term){return{group:{rules:[{field:'firstName',condition:'like',data:'%'+term+'%'},{field:'lastName',condition:'like',data:'%'+term+'%'},{field:'id',condition:'like',data:'%'+term+'%'}],operator:'OR'}};});var searchObj={queryJSON:{rules:[{field:'branchId',condition:'=',data:$scope.model.currentBranchId}].concat((0,_toConsumableArray3.default)(nameGroupRules),(0,_toConsumableArray3.default)($scope.model.isCustomerUser?[{field:'customerUser',condition:'=',data:true}]:[{field:'email',condition:'!=',data:null},{field:'customerUser',condition:'=',data:false}])),operator:'AND'},extraDetails:{searchText:searchText,status:$scope.model.isCustomerUser?'customerUser':'web',branchId:$scope.model.currentBranchId,offset:recordOffset}};if($scope.model.cloneFromUserId&&$scope.model.cloneFromUserId.id){searchObj.queryJSON.rules.push({field:'id',condition:'!=',data:$scope.model.cloneFromUserId.id});}UsersService.all(searchObj,recordOffset,$scope.toUsersObj.pageLimit).then(function(data){var users=data.results.map(function(u){return(0,_extends3.default)({},u,{value:u.id,Value:u.id,Key:u.id+' | '+u.firstName+' '+u.lastName});});if(recordOffset===0){$scope.toUsersObj.results=users;$scope.toUsersObj.totalRecords=data.total;}else{$scope.toUsersObj.results=_.uniqBy($scope.toUsersObj.results.concat(users),'Value');}}).finally(function(){$scope.toUsersObj.loading=false;});};$scope.onCloneFromUserChange=function(){if($scope.model.cloneFromUserId&&$scope.model.cloneFromUserId.id){$scope.toUsersObj.results=[];$scope.toUsersSearchKey=undefined;$scope.getToUsersList(null,1);$scope.permissionLoading=true;$scope.getBranchPermission();$q.all({userData:UsersService.get($scope.model.cloneFromUserId.id),branches:UserService.getUserBranchGroup($scope.model.cloneFromUserId.id),customers:CustomerService.all(),fundingSources:UserBranchFundingSourceService.all((0,_stringify2.default)({queryJSON:{rules:[{field:'userId',condition:'=',data:$scope.model.cloneFromUserId.id}],operator:'AND'}}),0,1000)}).then(function(_ref111){var userData=_ref111.userData,branches=_ref111.branches,customers=_ref111.customers,fundingSources=_ref111.fundingSources;$scope.model.branchId=userData.branchId;if(userData.customer){$scope.model.customer=userData.customer?{Key:userData.customer.id+' | '+userData.customer.name,Value:userData.customer.id}:null;}$scope.cloneFromUserBranches=(branches||[]).map(function(b){return{id:b.branchId};});$scope.branchData.forEach(function(b){b.ticked=!!(branches||[]).find(function(ub){return ub.branchId===b.id;});});$scope.model.branch=$scope.branchData.filter(function(b){return b.ticked;});$scope.customerList=(customers.results||[]).map(function(c){return{Key:c.id+' | '+c.name,Value:c.id};});$scope.totalCustomer=customers.total;$scope.cloneFromFundingSources=fundingSources.results||[];$scope.getFundingSource();if($scope.model.branchId){$timeout(function(){$scope.model.branchPermission=$scope.model.branchId;$scope.getBranchPermission();});}else if($scope.cloneFromUserBranches.length>0){$timeout(function(){$scope.model.branchPermission=$scope.cloneFromUserBranches[0].id;$scope.getBranchPermission();});}}).finally(function(){$scope.permissionLoading=false;});}else{$scope.model.branch=[];$scope.model.branchId=null;$scope.model.customer=null;$scope.model.selectedFundingSource=[];$scope.branchFundingSourceGrouped=[];$scope.cloneFromFundingSources=[];$scope.branchData.forEach(function(b){return b.ticked=false;});$scope.aclPermissions={};$scope.toUsersSearchKey=undefined;$scope.checkAndLoadToUsers();}};var getBranchPermissionTimeout=void 0;$scope.getBranchPermission=function(){if(getBranchPermissionTimeout)$timeout.cancel(getBranchPermissionTimeout);getBranchPermissionTimeout=$timeout(function(){if($scope.model.cloneFromUserId&&$scope.model.cloneFromUserId.id){$scope.permissionLoading=true;UserService.acl($scope.model.cloneFromUserId.id,$scope.model.branchPermission).then(function(data){$scope.aclPermissions[$scope.model.branchPermission]=data||{};}).finally(function(){$scope.permissionLoading=false;});}},100);};$scope.getCustomer=function(searchKey,offset){var searchText=searchKey||'';var recordOffset=offset||0;var searchObj={queryJSON:{rules:[{field:'id',condition:'like',data:'%'+searchText+'%'},{field:'name',condition:'like',data:'%'+searchText+'%'}],operator:'OR'}};CustomerService.all(searchObj,recordOffset,10).then(function(data){var customers=(data.results||[]).map(function(c){return{Key:c.id+' | '+c.name,Value:c.id};});if(recordOffset===0){$scope.customerList=customers;$scope.totalCustomer=data.total;}else{$scope.customerList=_.uniqBy($scope.customerList.concat(customers),'Value');}});};$scope.getFundingSource=function(){var selectedBranch=($scope.model.branch||[]).map(function(b){return b.id;});var searchObj={queryJSON:{rules:[],operator:'AND'}};if(selectedBranch.length>0){searchObj.queryJSON.rules.push({field:'branchId',condition:'IN',data:selectedBranch});}var customerId=$scope.model.customer&&$scope.model.customer.Value?$scope.model.customer.Value:null;BranchFundingSourceService.all(searchObj,0,1000,customerId).then(function(data){$scope.branchFundingSourceGrouped=[];var grouped=_.groupBy(data.results,'branchId');var keys=(0,_keys2.default)(grouped);var indexMap2={};var indexMap={},addHeader={};keys.forEach(function(k){delete indexMap2[k];grouped[k].forEach(function(g){if(!addHeader.hasOwnProperty('header')){addHeader['header']=true;$scope.branchFundingSourceGrouped.push({label:'<strong>All Branch Funding Source</strong>',msGroup:true});}if(!indexMap.hasOwnProperty(g.branchId)){indexMap[g.branchId]=grouped[k].length;$scope.branchFundingSourceGrouped.push({label:'<strong>'+k+'</strong>',msGroup:true});}$scope.branchFundingSourceGrouped.push({id:g.id,name:g.sourceName,branch:g.branchId,fundingSourceId:g.id,label:g.sourceName+' | '+'('+(g.locationId||'N/A')+')',ticked:false});});if(!indexMap2.hasOwnProperty(k)){indexMap2[k]=0;$scope.branchFundingSourceGrouped.push({msGroup:false});}});$scope.branchFundingSourceGrouped.push({msGroup:false});// Auto select FS from cloneFromUser if any
if($scope.cloneFromFundingSources){var cloneFromFsIds=($scope.cloneFromFundingSources||[]).map(function(fs){return fs.branchFundingSourceId;});$scope.branchFundingSourceGrouped.forEach(function(fs){if(fs.id){fs.ticked=cloneFromFsIds.includes(fs.id);}});}});};$scope.onSelectPermissionChange=function(){if($scope.model.selectPermission){$scope.model.cloneFromUserId=null;}$scope.onCloneFromUserChange();};$scope.onUpdatePasswordChange=function(){$scope.checkAndLoadToUsers();};$scope.onUpdateFundingSourceChange=function(){$scope.checkAndLoadToUsers();if($scope.model.updateFundingSource){if($scope.customerList.length===0){$scope.getCustomer(null,0);}$scope.getFundingSource();}};$scope.onToUsersChange=function(){};$scope.getSetupDetails=function(){};$scope.validateAutoChekInChekOut=function(){};$scope.getBranchCounters=function(){};$scope.isOnlyPasswordUpdate=function(){var hasPermissionSource=$scope.model.selectPermission||$scope.model.cloneFromUserId&&$scope.model.cloneFromUserId.id;return $scope.model.updatePassword&&!$scope.model.updateFundingSource&&!hasPermissionSource;};$scope.hasPerm=function(key,parentKey){var branchPerms=$scope.aclPermissions[$scope.model.branchPermission]||{};var permissionObj=branchPerms[parentKey];return permissionObj?permissionObj.includes(key):false;};$scope.allowSettings=function(key,parentKey){if($scope.model.cloneFromUserId&&$scope.model.cloneFromUserId.id)return;if(!$scope.aclPermissions[$scope.model.branchPermission])$scope.aclPermissions[$scope.model.branchPermission]={};var branchPerms=$scope.aclPermissions[$scope.model.branchPermission];var hasSetting=branchPerms['setting']&&branchPerms['setting'].includes('all');var settingChild=$scope.permissions.setting?$scope.permissions.setting.child:{};var resources=(0,_keys2.default)(settingChild);var isSelected=resources.find(function(d){return d===parentKey;});if(isSelected&&!hasSetting){if(!branchPerms['setting'])branchPerms['setting']=[];if(!branchPerms['setting'].includes('all'))branchPerms['setting'].push('all');}};$scope.togglePerm=function(key,parentKey){if($scope.model.cloneFromUserId&&$scope.model.cloneFromUserId.id)return;if(!$scope.aclPermissions[$scope.model.branchPermission])$scope.aclPermissions[$scope.model.branchPermission]={};var branchPerms=$scope.aclPermissions[$scope.model.branchPermission];if(!branchPerms[parentKey])branchPerms[parentKey]=[];if(parentKey==='cash_activity'&&!$scope.hasPerm(key,parentKey)){var otherKey=key==='customer'?'funding_source':'customer';branchPerms[parentKey]=branchPerms[parentKey].filter(function(k){return k!==otherKey;});}var allow=false;if(branchPerms[parentKey].includes(key)){branchPerms[parentKey]=branchPerms[parentKey].filter(function(k){return k!==key;});allow=false;// Auto-clear default_redirect if no real perms remain
var activePerms=branchPerms[parentKey].filter(function(k){return k!=='default_redirect';});if(activePerms.length===0&&branchPerms[parentKey].includes('default_redirect')){branchPerms[parentKey]=branchPerms[parentKey].filter(function(k){return k!=='default_redirect';});// Shift redirect back to parent category
var parentCategory=$scope.getParentCategoryKey(parentKey);if(parentCategory){if(!branchPerms[parentCategory]){branchPerms[parentCategory]=[];}if(!branchPerms[parentCategory].includes('default_redirect')){branchPerms[parentCategory]=[].concat((0,_toConsumableArray3.default)(branchPerms[parentCategory]),['default_redirect']);}}}}else{branchPerms[parentKey].push(key);allow=true;}if(allow&&parentKey==='cash_activity'){var _otherKey=key==='customer'?'funding_source':'customer';if($scope.hasPerm(_otherKey,parentKey)){$scope.togglePerm(_otherKey,parentKey);}}// Cascading permissions logic
if(parentKey==='branch_mgmt'){var branchMgmtChild=$scope.permissions.branch_mgmt?$scope.permissions.branch_mgmt.child:{};var resources=(0,_keys2.default)(branchMgmtChild);resources.forEach(function(resource){if($scope.model.isCustomerUser&&$scope.customerPermissions.indexOf(resource)<0)return;if(!branchPerms[resource])branchPerms[resource]=[];if(allow){if(!branchPerms[resource].includes('all'))branchPerms[resource].push('all');}else{branchPerms[resource]=branchPerms[resource].filter(function(k){return k!=='all';});}});}else if(['branch_mgmt_deposit_reports','branch_mgmt_bin_manifest'].includes(parentKey)){var resourcesToUpdate=['tnt_react_app'];resourcesToUpdate.forEach(function(resource){if(!branchPerms[resource])branchPerms[resource]=[];if(allow){if(!branchPerms[resource].includes(key))branchPerms[resource].push(key);}else{branchPerms[resource]=branchPerms[resource].filter(function(k){return k!==key;});}});}else if(parentKey==='branch_mgmt_billing_approval'){var childPermission=$scope.permissions.branch_mgmt&&$scope.permissions.branch_mgmt.child&&$scope.permissions.branch_mgmt.child.branch_mgmt_billing_approval?$scope.permissions.branch_mgmt.child.branch_mgmt_billing_approval.child:{};var _resources=(0,_keys2.default)(childPermission);_resources.forEach(function(resource){if($scope.model.isCustomerUser&&$scope.customerPermissions.indexOf(resource)<0)return;if(!branchPerms[resource])branchPerms[resource]=[];if(allow){if(!branchPerms[resource].includes('allow'))branchPerms[resource].push('allow');}else{branchPerms[resource]=branchPerms[resource].filter(function(k){return k!=='allow';});}});}else if(['setting','branch_mgmt','tnt_billing','tnt_control','reporting','order_packing'].indexOf(parentKey)>=0){var _childPermission=$scope.permissions[parentKey].child||{};var _resources2=(0,_keys2.default)(_childPermission);_resources2.forEach(function(resource){if($scope.model.isCustomerUser&&$scope.customerPermissions.indexOf(resource)<0)return;if(!branchPerms[resource])branchPerms[resource]=[];var permissionsToToggle=(0,_keys2.default)(_childPermission[resource].permission||{}).filter(function(p){return p!=='default_redirect';});if(allow){permissionsToToggle.forEach(function(p){if($scope.model.isCustomerUser&&resource==='setting-location'&&p!=='view'&&p!=='edit')return;if(!branchPerms[resource].includes(p))branchPerms[resource].push(p);});}else{branchPerms[resource]=branchPerms[resource].filter(function(p){return!permissionsToToggle.includes(p);});}});}$scope.cleanupOrphanedDefaultRedirects();};$scope.cleanupOrphanedDefaultRedirects=function(){var branchPerms=$scope.aclPermissions[$scope.model.branchPermission];if(!branchPerms)return;(0,_keys2.default)(branchPerms).forEach(function(resource){var perms=branchPerms[resource];if(Array.isArray(perms)&&perms.includes('default_redirect')&&!$scope.hasAnyPerm(resource)){branchPerms[resource]=perms.filter(function(p){return p!=='default_redirect';});if(branchPerms[resource].length===0){delete branchPerms[resource];}}});};$scope.findResourceNode=function(resource){if($scope.permissions[resource])return $scope.permissions[resource];var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=(0,_getIterator3.default)((0,_values2.default)($scope.permissions)),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var topVal=_step2.value;if(topVal.child&&topVal.child[resource])return topVal.child[resource];if(topVal.child){var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=(0,_getIterator3.default)((0,_values2.default)(topVal.child)),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var childVal=_step3.value;if(childVal.child&&childVal.child[resource])return childVal.child[resource];}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return null;};$scope.hasAnyPerm=function(resource){var branchPerms=$scope.aclPermissions[$scope.model.branchPermission]||{};var permissionObj=branchPerms[resource];if(Array.isArray(permissionObj)&&permissionObj.some(function(p){return p!=='default_redirect';})){return true;}var node=$scope.findResourceNode(resource);if(node&&node.child){return(0,_keys2.default)(node.child).some(function(childKey){return $scope.hasAnyPerm(childKey);});}return false;};$scope.hasChildDefaultRedirect=function(parentKey){var parentPerm=$scope.permissions[parentKey];if(!parentPerm||!parentPerm.child)return false;return(0,_keys2.default)(parentPerm.child).some(function(childKey){return $scope.hasPerm('default_redirect',childKey);});};$scope.getParentCategoryKey=function(resource){if(resource.startsWith('setting-'))return'setting';if(resource.startsWith('branch_mgmt_'))return'branch_mgmt';if(resource.startsWith('tnt_billing_'))return'tnt_billing';if(resource.startsWith('tnt_control_'))return'tnt_control';if(resource.startsWith('reporting_'))return'reporting';return null;};$scope.toggleDefaultRedirect=function(resource){if($scope.model.cloneFromUserId&&$scope.model.cloneFromUserId.id)return;if(!$scope.aclPermissions[$scope.model.branchPermission])$scope.aclPermissions[$scope.model.branchPermission]={};var branchPerms=$scope.aclPermissions[$scope.model.branchPermission];var isCurrentlyChecked=$scope.hasPerm('default_redirect',resource)||$scope.hasChildDefaultRedirect(resource);// Clear default_redirect on ALL resources (radio-style — only one can be default)
(0,_keys2.default)(branchPerms).forEach(function(res){if(Array.isArray(branchPerms[res])){branchPerms[res]=branchPerms[res].filter(function(p){return p!=='default_redirect';});}});var nextResourceToSet=null;if(!isCurrentlyChecked){nextResourceToSet=resource;}else{// If we uncheck a child/grandchild redirect, shift it back to parent category
var parentCategory=$scope.getParentCategoryKey(resource);if(parentCategory){nextResourceToSet=parentCategory;}}if(nextResourceToSet){if(!branchPerms[nextResourceToSet])branchPerms[nextResourceToSet]=[];if(!branchPerms[nextResourceToSet].includes('default_redirect')){branchPerms[nextResourceToSet]=[].concat((0,_toConsumableArray3.default)(branchPerms[nextResourceToSet]),['default_redirect']);}}};$scope.hasActiveAncestors=function(resource){if($scope.permissions[resource]){return true;}var parentKey=null;var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=(0,_getIterator3.default)((0,_entries2.default)($scope.permissions)),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var _step4$value=(0,_slicedToArray3.default)(_step4.value,2),topKey=_step4$value[0],topVal=_step4$value[1];if(topVal.child&&topVal.child[resource]){parentKey=topKey;break;}if(topVal.child){var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=(0,_getIterator3.default)((0,_entries2.default)(topVal.child)),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var _step5$value=(0,_slicedToArray3.default)(_step5.value,2),childKey=_step5$value[0],childVal=_step5$value[1];if(childVal.child&&childVal.child[resource]){parentKey=childKey;break;}}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}if(parentKey)break;}}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}if(!parentKey)return true;if(!$scope.hasAnyPerm(parentKey)){return false;}return $scope.hasActiveAncestors(parentKey);};$scope.disabledPermissions=function(parent,child){if(parent==='branch_mgmt_restore_route_assignments')return true;if($scope.model.isCustomerUser){if(child){if(parent==='setting-location'&&['create','importLocations','clone','editCustomer'].indexOf(child)>=0)return true;if(parent==='bulk_cash_management'&&child!=='view'&&child!=='export')return true;}return $scope.customerPermissions.indexOf(parent)<0;}return false;};$scope.format=function(key){if(typeof key==='string'){key=key.replace('_','-');key=key!=='assign'&&key!=='export'?key.charAt(0).toUpperCase()+key.slice(1):key;key=$translate.instant('common.'+key);}return key;};$scope.expanded={};$scope.toggleExpand=function(key){$scope.expanded[key]=!$scope.expanded[key];};$scope.expand=function(key){return $scope.expanded[key]||false;};$scope.ok=function(){if($scope.model.updatePassword&&$scope.model.password!==$scope.model.cnfPassword){return alert('Passwords do not match');}var payload={isCustomerUser:$scope.model.isCustomerUser,cloneToUsers:$scope.model.cloneToUsers,cloneFromUserId:$scope.model.cloneFromUserId?$scope.model.cloneFromUserId.id:null,updatePassword:$scope.model.updatePassword,password:$scope.model.password,updateBranch:!$scope.isOnlyPasswordUpdate(),branch:$scope.model.branch.map(function(b){return{id:b.id};}),branchId:$scope.model.branchId,updateFundingSource:$scope.model.updateFundingSource,customerId:$scope.model.customer&&$scope.model.updateFundingSource?$scope.model.customer.Value:null,fundingSources:$scope.model.updateFundingSource?($scope.model.selectedFundingSource||[]).map(function(fs){return fs.id||fs.fundingSourceId;}):[],aclPermissions:$scope.aclPermissions,sameForAll:$scope.model.sameForAll,applySamePermission:$scope.model.applySamePermission};modal.close(payload);};$scope.$watch('model.cloneFromUserId',function(newVal,oldVal){if(newVal===oldVal)return;$scope.onCloneFromUserChange();});$scope.cancel=function(){modal.dismiss();};init();}]});return modal.result.then(positive,negative);};var markAllDeliveredListModal=function markAllDeliveredListModal(routeId,vaultDate,branchId,VaultOperationsService,callback,negative){var modal=$uibModal.open({animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',template:_markAllDeliveredList2.default,size:'md',controller:['$scope','Navigation','$state','DataCounter',function($scope,Navigation,$state,DataCounter){$scope.routeId=routeId;$scope.shipments=[];$scope.loading=true;VaultOperationsService.getNotDeliveredShipments(routeId,vaultDate,branchId).then(function(res){$scope.shipments=res.data||[];$scope.loading=false;}).catch(function(err){$scope.loading=false;$scope.errorMessage=err&&err.data&&err.data.message?err.data.message:'Error fetching shipments';});$scope.goToServiceHistory=function(locationId){Navigation.goToServiceHistory(locationId,null,true,modal);};$scope.goToItemHistory=function(trackingId){Navigation.goToItemHistory(trackingId,modal);};$scope.confirm=function(){callback({modal:modal,shipments:$scope.shipments});};$scope.cancel=function(){negative({modal:modal});};}]});modal.result.then(function(){},function(){negative({modal:null});});return modal;};// Shared label maps so the approval preview renders the same names as the grid.
var SURCHARGE_LABEL_KEYS={INSURANCE:'customer.surcharge_insurance',FUEL:'customer.surcharge_fuel',SECURITY:'customer.surcharge_security',LIABILITY:'customer.surcharge_liability'};var SURCHARGE_INTERVAL_LABEL_KEYS={WEEKLY:'customer.surcharge_interval_weekly',BI_WEEKLY:'customer.surcharge_interval_bi_weekly',MONTHLY:'customer.surcharge_interval_monthly',QUARTERLY:'customer.surcharge_interval_quarterly'};// onTheseRecords=true is the Approved tab: the fee on exactly the records on screen, so the
// accrual columns (interval, covers, the quarterly note) do not apply and the table is just
// Surcharge / Fee / Amount. Every other tab shows the accrual-period view unchanged.
var surchargeDetails=function surchargeDetails(_ref112){var customer=_ref112.customer,periodLabel=_ref112.periodLabel,filterAligned=_ref112.filterAligned,_ref112$onTheseRecord=_ref112.onTheseRecords,onTheseRecords=_ref112$onTheseRecord===undefined?false:_ref112$onTheseRecord;var modal=$uibModal.open({template:_surchargeDetails2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope','$translate',function($scope,$translate){$scope.customer=customer;$scope.periodLabel=periodLabel;$scope.onTheseRecords=onTheseRecords===true;$scope.filterAligned=filterAligned!==false;// Separate from filterAligned: a quarterly surcharge counts back beyond the selected month
// whatever the date filter says, so this note appears even when the filter is aligned.
$scope.widerWindowNote=!$scope.onTheseRecords&&customer&&customer.widerSurchargeWindowStart?$translate.instant('surchargeDetailsModal.quarterlyNote',{start:customer.widerSurchargeWindowStart}):'';$scope.cancel=function(){modal.close();};}]});return modal;};var storedSurchargeDetails=function storedSurchargeDetails(_ref113){var customer=_ref113.customer,labelKeys=_ref113.labelKeys;var modal=$uibModal.open({template:_storedSurchargeDetails2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'md',controller:['$scope',function($scope){$scope.customer=customer;$scope.breakdown=(customer&&customer.storedSurchargeBreakdown||[]).map(function(row){return{type:row.type,labelKey:labelKeys[row.type],amount:Number(row.amount)||0,minPercentage:Number(row.minPercentage)||0,maxPercentage:Number(row.maxPercentage)||0};});$scope.cancel=function(){modal.close();};}]});return modal;};var surchargeHistory=function surchargeHistory(_ref114){var customerName=_ref114.customerName,rows=_ref114.rows,labelKeys=_ref114.labelKeys,eventLabels=_ref114.eventLabels;var toLabel=function toLabel(date){return date?moment(date,'YYYY-MM-DD').format('MM-DD-YYYY'):'';};var sameEvents=function sameEvents(a,b){return a.length===b.length&&a.every(function(id,i){return id===b[i];});};var groups=(0,_keys2.default)(labelKeys).map(function(type){var typeRows=(rows||[]).filter(function(row){return row.type===type;});return{type:type,labelKey:labelKeys[type],rows:typeRows.map(function(row,index){var previous=typeRows[index+1];var eventIds=(row.billableEventIds||[]).slice().sort(function(a,b){return a-b;});var previousEventIds=previous?(previous.billableEventIds||[]).slice().sort(function(a,b){return a-b;}):null;var percentage=row.percentage===null||row.percentage===undefined?null:Number(row.percentage);return{id:row.id,enabled:row.enabled,percentage:percentage,intervalLabelKey:SURCHARGE_INTERVAL_LABEL_KEYS[row.interval]||null,eventLabels:eventIds.map(function(id){return eventLabels[id]||'#'+id;}),changedBy:row.changedBy,isCurrent:!row.effectiveTo,fromLabel:toLabel(row.effectiveFrom),toLabel:toLabel(row.effectiveTo),changed:previous?{enabled:row.enabled!==previous.enabled,percentage:percentage!==(previous.percentage===null||previous.percentage===undefined?null:Number(previous.percentage)),interval:row.interval!==previous.interval,events:!sameEvents(eventIds,previousEventIds)}:{}};})};}).filter(function(group){return group.rows.length;});var modal=$uibModal.open({template:_surchargeHistory2.default,animation:true,ariaLabelledBy:'modal-title-top',ariaDescribedBy:'modal-body-top',backdrop:'static',size:'lg',controller:['$scope',function($scope){$scope.customerName=customerName;$scope.groups=groups;$scope.selectedType=null;$scope.selectType=function(type){$scope.selectedType=type;};$scope.cancel=function(){modal.close();};}]});return modal;};var uncoveredLocations=function uncoveredLocations(){return $uibModal.open({animation:true,size:'lg',template:_uncoveredLocations2.default,controller:['$scope','$uibModalInstance','ContractService','$state',function($scope,$uibModalInstance,ContractService,$state){$scope.locations=[];$scope.totalRecords=0;$scope.pagination={page:1,pageLimit:LIMIT};$scope.loading=false;$scope.error='';$scope.load=function(){$scope.loading=true;$scope.error='';var offset=($scope.pagination.page-1)*$scope.pagination.pageLimit;return ContractService.getUncoveredOnCallLocations(offset,$scope.pagination.pageLimit).then(function(data){$scope.locations=data.results;$scope.totalRecords=data.totalRecords;}).catch(function(err){$scope.error=err&&err.data&&err.data.message?err.data.message:err.message;}).finally(function(){$scope.loading=false;});};$scope.goToLocation=function(locationId){$scope.close();$state.go('location.edit',{id:locationId});};$scope.close=function(){return $uibModalInstance.close();};$scope.load();}]});};return{confirm:confirm,alert:alert,checkedInShipmentSelectionModal:checkedInShipmentSelectionModal,checkedOutShipmentSelectionModal:checkedOutShipmentSelectionModal,routeThrowShipmentListModal:routeThrowShipmentListModal,routeThrowShipmentSelectionModal:routeThrowShipmentSelectionModal,confirmSupervisor:confirmSupervisor,markAllDeliveredListModal:markAllDeliveredListModal,checkedInForceAddBag:checkedInForceAddBag,checkedInAdHocCheckin:checkedInAdHocCheckin,checkedoutForceAddBag:checkedoutForceAddBag,forceCheckin:forceCheckin,forceCloseRoute:forceCloseRoute,itemNotDelivered:itemNotDelivered,closeRoute:closeRoute,addLocation:addLocation,selectDeliveryLocation:selectDeliveryLocation,closeBagout:closeBagout,commitSuccessModal:commitSuccessModal,uploadedFileSelection:uploadedFileSelection,verifyHoldShipments:verifyHoldShipments,forceCloseHold:forceCloseHold,errorModal:errorModal,holdReleases:holdReleases,returnItems:returnItems,itemHoldLogDetails:itemHoldLogDetails,routeDetails:routeDetails,routeMessenger:routeMessenger,locationHoldRelease:locationHoldRelease,bulkVerifyComment:bulkVerifyComment,translateMessage:translateMessage,routeTransfer:routeTransfer,orderPack:orderPack,orderPackHold:orderPackHold,orderPackReturn:orderPackReturn,checkoutAddItems:checkoutAddItems,residualComments:residualComments,changePassword:changePassword,holdReason:holdReason,convertToCrv:convertToCrv,deletedReason:deletedReason,atmResidualReceipt:atmResidualReceipt,balanceSheetInfo:balanceSheetInfo,deliveryRouteInfo:deliveryRouteInfo,coinShiptypeList:coinShiptypeList,routeStopTransfer:routeStopTransfer,routeSequenceModal:routeSequenceModal,remainingResiduals:remainingResiduals,remainingToThrow:remainingToThrow,routeCheckoutInfo:routeCheckoutInfo,routeCheckinInfo:routeCheckinInfo,remainingToPack:remainingToPack,branchTransferModal:branchTransferModal,internalDeliveryModal:internalDeliveryModal,depositPackingInfoModal:depositPackingInfoModal,lockStatusModal:lockStatusModal,ledgerTransactionLogModal:ledgerTransactionLogModal,// createCompanyModal,
atmCodesInfoModal:atmCodesInfoModal,moveShipmentModal:moveShipmentModal,updateShipmentTrackingId:updateShipmentTrackingId,autoOpenLocksModal:autoOpenLocksModal,successModal:successModal,checkinForceCloseRoute:checkinForceCloseRoute,markAsDelivered:markAsDelivered,holdShipmentModal:holdShipmentModal,lastOrderDetails:lastOrderDetails,serviceOrderDetail:serviceOrderDetail,serviceOrderNotes:serviceOrderNotes,undoPackedOrder:undoPackedOrder,serviceOrderStatusUpdate:serviceOrderStatusUpdate,serviceOrderAssign:serviceOrderAssign,createServiceTicket:createServiceTicket,shipmentList:shipmentList,routeStopList:routeStopList,createActionCode:createActionCode,changeDestinationModal:changeDestinationModal,serviceOrderActions:serviceOrderActions,pendingCancelShipments:pendingCancelShipments,bagoutListModal:bagoutListModal,bulkCashAdjustComment:bulkCashAdjustComment,shipmentImageModal:shipmentImageModal,bagoutsOnHoldModal:bagoutsOnHoldModal,saveLocationLaterModal:saveLocationLaterModal,saveRouteChangesLaterModal:saveRouteChangesLaterModal,billingContractRulesModal:billingContractRulesModal,approveBillingRecords:approveBillingRecords,billableEventLogDetails:billableEventLogDetails,stopComments:stopComments,createLanguageMessage:createLanguageMessage,FuelSurchargeCustomer:FuelSurchargeCustomer,FuelSurchargeLocations:FuelSurchargeLocations,routesInfoModal:routesInfoModal,editDeliveryShipment:editDeliveryShipment,editPickupShipment:editPickupShipment,shipmentAssociateToTanker:shipmentAssociateToTanker,uploadFiles:uploadFiles,markUndeliveredWithCRV:markUndeliveredWithCRV,viewAppLogo:viewAppLogo,previewTicketPictures:previewTicketPictures,// scheduledATMShipment
atmLoadShipment:atmLoadShipment,pickupDeliveryShipments:pickupDeliveryShipments,notDeliveredResolution:notDeliveredResolution,pickupHoldRelease:pickupHoldRelease,duplicateRouteStopList:duplicateRouteStopList,branchMgmtBagoutClose:branchMgmtBagoutClose,makeDeliverable:makeDeliverable,logisticItemAssignModal:logisticItemAssignModal,logisticItemList:logisticItemList,logisticItemHoldReleaseModal:logisticItemHoldReleaseModal,serviceTicketResolveImage:serviceTicketResolveImage,uploadContractDocuments:uploadContractDocuments,viewContractDocuments:viewContractDocuments,updateBillingRecords:updateBillingRecords,sendStopReceipt:sendStopReceipt,changeShiptypeId:changeShiptypeId,bulkImportLocation:bulkImportLocation,itemHistory:itemHistory,createServiceChecklist:createServiceChecklist,createAtmMake:createAtmMake,nextScheduledOccurences:nextScheduledOccurences,timeoutCountdown:timeoutCountdown,bagRemoveConfirmation:bagRemoveConfirmation,postBillingRecord:postBillingRecord,createBillingRecords:createBillingRecords,locationLogs:locationLogs,branchFundingSourceDenominations:branchFundingSourceDenominations,deliveryServiceTransaction:deliveryServiceTransaction,verifyBagoutCashCount:verifyBagoutCashCount,editScheduledOrders:editScheduledOrders,pendingShipmentTransfer:pendingShipmentTransfer,updateServiceHistory:updateServiceHistory,denominationBreakdownModal:denominationBreakdownModal,shipmentNotPickedUp:shipmentNotPickedUp,createServiceActionPriority:createServiceActionPriority,routeServiceTicketsModal:routeServiceTicketsModal,masterCashOrderDetailsModal:masterCashOrderDetailsModal,bulkUpdateUserPermissionsModal:bulkUpdateUserPermissionsModal,rescheduleDeliveries:rescheduleDeliveries,surchargeDetails:surchargeDetails,storedSurchargeDetails:storedSurchargeDetails,surchargeHistory:surchargeHistory,uncoveredLocations:uncoveredLocations};};ModalFactory.$inject=['$uibModal','$translate'];exports.default=ModalFactory;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(540).Buffer))

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _timePicker = __webpack_require__(1608);

var _timePicker2 = _interopRequireDefault(_timePicker);

__webpack_require__(2922);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimePickerModule = _angular2.default.module('time-picker-module', []).directive('timePicker', _timePicker2.default).name;

exports.default = TimePickerModule;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _timePicker = __webpack_require__(2637);

var _timePicker2 = _interopRequireDefault(_timePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimePickerDirective = [function () {
  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      isRequired: '=ngRequired',
      ngChange: '=',
      displayTimeFormat: '=',
      isMeridian: '=',
      showSeconds: '=',
      showSpinners: '=',
      showFullTime: '=',
      hideHours: '<',
      tab: '@'
    },
    template: _timePicker2.default,
    link: function link(scope, element, attrs) {
      scope.displayTime = '';
      scope.allowOnce = true;

      if (scope.hideHours === undefined) {
        scope.hideHours = false;
      }

      scope.$watch('ngModel', function (newValue, oldValue) {
        var spanElement = element.find("span.time-picker-value");
        spanElement.removeClass('ng-invalid ng-valid');

        if (!scope.ngModel) {
          spanElement.addClass(scope.isRequired ? 'ng-invalid' : 'ng-valid');
          scope.displayTime = null;
          return;
        }

        spanElement.addClass('ng-valid');

        var hour = scope.displayTimeFormat || scope.displayTimeFormat === undefined ? scope.ngModel.getHours() - (scope.ngModel.getHours() >= 12 ? 12 : 0) : scope.ngModel.getHours(),
            minutes = scope.ngModel.getMinutes(),
            seconds = scope.ngModel.getSeconds(),
            period = scope.ngModel.getHours() >= 12 ? 'PM' : 'AM';

        hour = (hour < 10 ? '0' : '') + hour;
        minutes = (minutes < 10 ? '0' : '') + minutes;
        seconds = (seconds < 10 ? '0' : '') + seconds;

        if (scope.hideHours && ['route'].includes(scope.tab)) {
          scope.displayTime = minutes + ':' + seconds;
        } else if ((scope.displayTimeFormat || scope.displayTimeFormat === undefined) && !scope.showSeconds) {
          scope.displayTime = hour + ':' + minutes + ' ' + period;
        } else if (scope.showSeconds) {
          scope.displayTime = (scope.showFullTime ? hour : '00') + ':' + minutes + ':' + seconds;
        } else {
          scope.displayTime = hour + ':' + minutes;
        }
      });

      scope.clear = function () {
        scope.ngModel = null;
        scope.allowOnce = true;
      };

      scope.setAllowOnceValue = function () {
        if (scope.ngModel) scope.allowOnce = false;
      };

      scope.handleTimeChange = function () {
        if (!scope.allowOnce) return;
        var dt = new Date(scope.ngModel).setSeconds('00');
        scope.ngModel = new Date(dt);
      };
    }
  };
}];

exports.default = TimePickerDirective;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _timeoutCountdown = __webpack_require__(2638);

var _timeoutCountdown2 = _interopRequireDefault(_timeoutCountdown);

var _timeoutCountdown3 = __webpack_require__(1610);

var _timeoutCountdown4 = _interopRequireDefault(_timeoutCountdown3);

__webpack_require__(2923);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutCountdown = {
  restrict: 'E',
  bindings: {
    modelDetails: '=',
    onConfirm: '=',
    onError: '=',
    event: '='
  },
  template: _timeoutCountdown2.default,
  controller: _timeoutCountdown4.default
};

exports.default = timeoutCountdown;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeoutCountdownController = function () {
  /*@ngInject*/
  TimeoutCountdownController.$inject = ["$translate", "UsersService", "Modal", "$scope", "User", "Auth", "$state", "$interval", "Idle"];
  function TimeoutCountdownController($translate, UsersService, Modal, $scope, User, Auth, $state, $interval, Idle) {
    (0, _classCallCheck3.default)(this, TimeoutCountdownController);

    this.$translate = $translate;
    this.UsersService = UsersService;
    this.Auth = Auth;
    this.$scope = $scope;
    this.Modal = Modal;
    this.User = User;
    this.$state = $state;
    this.$interval = $interval;
    this.Idle = Idle;
    this.countdown = 0;
  }

  (0, _createClass3.default)(TimeoutCountdownController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      var timeout = this.Idle.getTimeout() || 10;
      this.updateCountdown(timeout);

      this.$scope.$on('IdleWarn', function (event, countdown) {
        _this.$scope.$evalAsync(function () {
          _this.updateCountdown(countdown);
        });
      });

      this.$scope.$on('IdleTimeout', function () {
        _this.$scope.$evalAsync(function () {
          _this.updateCountdown(0);
        });
      });
    }
  }, {
    key: 'updateCountdown',
    value: function updateCountdown(countdown) {
      this.countdown = countdown;
      var hours = Math.floor(this.countdown / 3600);
      var minutes = Math.floor(this.countdown % 3600 / 60);
      var seconds = this.countdown % 60;
      this.countdownDisplay = this.padZero(hours) + ':' + this.padZero(minutes) + ':' + this.padZero(seconds);
      this.message = this.$translate.instant('countdown.message', {
        countdown: this.countdownDisplay
      });
    }
  }, {
    key: 'padZero',
    value: function padZero(value) {
      return value.toString().padStart(2, '0');
    }
  }, {
    key: 'logout',
    value: function logout() {
      if (!this.Auth.isAuthenticated()) {
        this.Auth.logout();
        this.$state.go('login');
        localStorage.removeItem('sessionLength');
      }
    }
  }]);
  return TimeoutCountdownController;
}();

exports.default = TimeoutCountdownController;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserFactory = function UserFactory($rootScope, UserService, Auth) {
  var _this = this;

  this.User = {};
  this.acl = {};
  this.$rootScope = $rootScope;
  this.UserService = UserService;
  this.Auth = Auth;
  this.prevState = {};
  var setACL = function setACL(acl) {
    var navbar = {};
    var setting = {};
    var tntBilling = {};
    var tntControl = {};
    var branchMgmt = {};
    var _reporting = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(acl)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
            key1 = _step$value[0],
            permissions = _step$value[1];

        if (key1.includes('setting-')) {
          setting[key1] = permissions;
        } else if (key1.includes('tnt_billing_')) {
          tntBilling[key1] = permissions;
        } else if (key1.includes('tnt_control_')) {
          tntControl[key1] = permissions;
        } else if (key1.includes('reporting_')) {
          _reporting[key1] = permissions;
        } else {
          navbar[key1] = permissions;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    acl['navbar'] = navbar;
    acl['setting'] = setting;
    acl['tntBilling'] = tntBilling;
    acl['tntControl'] = tntControl;
    acl['_reporting'] = _reporting;
    _this.acl = acl;
  };

  var getACL = function getACL(key) {
    if (key in _this.acl) {
      return _this.acl[key];
    } else {
      return {};
    }
  };

  var hasACL = function hasACL() {
    return (0, _entries2.default)(_this.acl).length;
  };

  var setUser = function setUser(user) {
    $rootScope.$broadcast('userChanged', user);
    _this.user = user;
  };

  var getUser = function getUser() {
    return _this.user;
  };

  var isSignedIn = function isSignedIn() {
    return !!_this.user.email || _this.user.customerUser;
  };

  var clearUser = function clearUser() {
    setUser(null);
  };

  var hasUser = function hasUser() {
    return !angular.equals(_this.user, {});
  };

  var isAccessible = function isAccessible(key) {
    var resource = key.split('.')[0];
    var permissions = key.split('.')[1].split(',');

    if (_this.acl[resource]) {
      return permissions.some(function (p) {
        return _this.acl[resource].indexOf(p.trim()) >= 0;
      });
    } else {
      return false;
    }
  };
  var getPrevState = function getPrevState() {
    return _this.prevState;
  };
  var setPrevState = function setPrevState(state) {
    _this.prevState = state;
  };
  return {
    setUser: setUser,
    getUser: getUser,
    isSignedIn: isSignedIn,
    clearUser: clearUser,
    hasUser: hasUser,
    getACL: getACL,
    setACL: setACL,
    hasACL: hasACL,
    isAccessible: isAccessible,
    getPrevState: getPrevState,
    setPrevState: setPrevState
  };
};

UserFactory.$inject = ['$rootScope', 'UserService', 'Auth'];

exports.default = UserFactory;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _user = __webpack_require__(1611);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userModule = _angular2.default.module('user', []).factory('User', _user2.default).name;

exports.default = userModule;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _access_denied = __webpack_require__(2639);

var _access_denied2 = _interopRequireDefault(_access_denied);

var _access_denied3 = __webpack_require__(1614);

var _access_denied4 = _interopRequireDefault(_access_denied3);

__webpack_require__(2924);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var access_deniedComponent = {
  restrict: 'E',
  bindings: {},
  template: _access_denied2.default,
  controller: _access_denied4.default
};

exports.default = access_deniedComponent;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Access_deniedController =
/*@ngInject*/
["Auth", "$state", "User", "UserService", function Access_deniedController(Auth, $state, User, UserService) {
  (0, _classCallCheck3.default)(this, Access_deniedController);

  this.Auth = Auth;
  this.$state = $state;
  this.User = User;
  this.message = '';
}];

exports.default = Access_deniedController;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(2925);

var achManagementComponent = {
  restrict: "E",
  bindings: {}
};

exports.default = achManagementComponent;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ach_management = __webpack_require__(1615);

var _ach_management2 = _interopRequireDefault(_ach_management);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var achManagementModule = angular.module("achManagement", []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise("/achManagement");

  $stateProvider.state("achManagement", {
    url: "/v2/index.html#/ach-management",
    component: "achManagement",
    data: {
      requireLogin: true,
      requireACL: "ach_management.all"
    }
  });
}]).component("achManagement", _ach_management2.default).name;

exports.default = achManagementModule;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(2926);

var appEventLogsComponent = {
  restrict: "E",
  bindings: {}
};

exports.default = appEventLogsComponent;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app_event_logs = __webpack_require__(1617);

var _app_event_logs2 = _interopRequireDefault(_app_event_logs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appEventLogsModule = angular.module("appEventLogs", []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise("/appEventLogs");

  $stateProvider.state("appEventLogs", {
    url: "/v2/index.html#/tnt-app-event-logs",
    component: "appEventLogs",
    data: {
      requireLogin: true,
      requireACL: "tnt_app_event_logs.all"
    }
  });
}]).component("appEventLogs", _app_event_logs2.default).name;

exports.default = appEventLogsModule;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atm_codes_management = __webpack_require__(2640);

var _atm_codes_management2 = _interopRequireDefault(_atm_codes_management);

var _atm_codes_management3 = __webpack_require__(1620);

var _atm_codes_management4 = _interopRequireDefault(_atm_codes_management3);

__webpack_require__(2927);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMCodesManagementComponent = {
    restrict: 'E',
    template: _atm_codes_management2.default,
    controller: _atm_codes_management4.default
};

exports.default = ATMCodesManagementComponent;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMCodesManagementController = function () {

    /*@ngInject*/
    ATMCodesManagementController.$inject = ["$state", "$q", "$translate", "User", "RouteService", "Modal", "DateUtil", "BranchService", "SetupService", "Sound", "AtmCodesManagementService", "$rootScope", "DataCounter", "Navigation"];
    function ATMCodesManagementController($state, $q, $translate, User, RouteService, Modal, DateUtil, BranchService, SetupService, Sound, AtmCodesManagementService, $rootScope, DataCounter, Navigation) {
        (0, _classCallCheck3.default)(this, ATMCodesManagementController);

        this.$q = $q;
        this.$translate = $translate;
        this.User = User;
        this.Modal = Modal;
        this.DateUtil = DateUtil;
        this.SetupService = SetupService;
        this.Sound = Sound;
        this.$state = $state;
        this.AtmCodesManagementService = AtmCodesManagementService;
        this.$rootScope = $rootScope;
        this.DataCounter = DataCounter;
        this.Navigation = Navigation;

        this.model = {
            messenger: '',
            keyNumber: '',
            date: '',
            route: '',
            day: '',
            selectedDay: 'Mon',
            kabaKey: '',
            SGKey: '',
            // atmCode,
            branch: this.User.getUser().branchId,
            firstName: this.User.getUser().firstName,
            lastName: this.User.getUser().lastName,
            allRoutes: [],
            totalRecords: '',
            loggedInUser: User.getUser().id,
            routeSequence: [],
            messengerId: '',
            stats: 'manual',
            routeList: [],
            routeStatus: "",
            isDisabled: true,
            routeKeyId: ''
        };

        this.isEdit = false;
        this.$rootScope.$broadcast('routeChange', '/app/atm-codes-management');
        this.vaultDateRoutes = [];
        this.atmCodesData = "";
        this.isAutoOpenATMs = false;
        this.isLoadingRoutes = false;
        this.reassignLockObj = {};
    }

    (0, _createClass3.default)(ATMCodesManagementController, [{
        key: 'focuseElementById',
        value: function focuseElementById(id) {
            setTimeout(function () {
                document.getElementById(id).focus();
            }, 300);
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$q.all([this.SetupService.get(this.model.branch)]).then(function (data) {
                clearInterval(_this.apiCallTimer);
                _this.model.date = _this.DateUtil.convertToDate(data[0].currentVaultDate);
                _this.minVaultDate = {
                    minDate: _this.model.date,
                    maxDate: moment(_this.model.date).add(1, 'days').toDate()
                };
            }).then(function () {
                _this.allRoutes().then(function () {
                    _this.getDataFromCheckoutScreen();
                });
            });
        }
    }, {
        key: 'getDataFromCheckoutScreen',
        value: function getDataFromCheckoutScreen() {
            this.atmCodesData = this.DataCounter.getAtmCodeData();
            if (this.atmCodesData && this.atmCodesData.redirectFromCheckoutScreen) {
                this.model.date = this.atmCodesData.vaultDate;
                var route = _.find(this.model.routeList, { routeId: this.atmCodesData.routeId.toUpperCase() });
                if (route) {
                    this.model.route = { Key: route.routeId + " | " + route.routeName, Value: route.routeId
                        // this.routeSequence();
                    };this.getATMLocations();
                }
            }
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model.messenger = "";
            this.model.route = "";
            this.model.kabaKey = "";
            this.model.SGKey = "";
            this.model.routeKeyId = "";
            this.model.routeSequence = [];
            this.model.allRoutes = [];
            this.vaultDateRoutes = [];
            this.model.routeStatus = "";
            // this.model.routeList = [];
        }

        // get vault date routes from routeDetails

    }, {
        key: 'allRoutes',
        value: function allRoutes() {
            var _this2 = this;

            this.reset();
            this.model.routeList = [];
            var date = moment(this.model.date).format('YYYY-MM-DD');
            var defer = this.$q.defer();

            this.isLoadingRoutes = true;
            this.AtmCodesManagementService.getVaultDateRoutes(this.model.branch, date).then(function (data) {
                if (data.results.length) {
                    _this2.model.routeList = data.results;
                    _this2.model.totalRecords = data.results.length;
                    var routes = _this2.mappingRouteData(data.results);
                    _this2.model.allRoutes = _this2.model.allRoutes.concat(routes);
                } else {
                    _this2.model.totalRecords = 0;
                    _this2.model.allRoutes = [];
                }
            }).then(function () {
                defer.resolve();
            }).catch(function (err) {
                console.log(err);
                defer.reject(err);
            }).finally(function () {
                _this2.isLoadingRoutes = false;
            });
            return defer.promise;
        }
    }, {
        key: 'mappingRouteData',
        value: function mappingRouteData(routes) {
            return routes.map(function (route) {
                return {
                    Key: route.routeId + " | " + route.routeName,
                    Value: route.routeId
                };
            });
        }
    }, {
        key: 'routeSequence',
        value: function routeSequence() {
            var _this3 = this;

            if (!this.model.route) {
                return;
            }
            this.loading = true;
            this.locationData = [];
            this.model.routeStatus = '';

            var date = moment(this.model.date).format('YYYY-MM-DD'),
                idx = 0;

            return this.AtmCodesManagementService.getRouteLocation(null, this.model.route.Value, this.model.branch, date).then(function (data) {
                _this3.model.routeSequence = data.results;

                if (_this3.model.routeSequence && _this3.model.routeSequence.length) {
                    _this3.model.routeSequence.forEach(function (history, index) {
                        var nextIndex = index + 1,
                            nextRecord = data.results[nextIndex];

                        history.seq = idx;
                        history.isMatch = 0;

                        if (data.results.length > 1 && nextRecord && nextRecord.secondaryLock && history.locationId === nextRecord.primaryLockId) {
                            history.isMatch = 1;
                            nextRecord.seq = idx;
                        } else {
                            idx = idx + 1;
                        }

                        if (history.lockType === 'RTE' && history.code && history.code.isAlreadyOpened) {
                            _this3.reassignLockObj[history.locationId] = {};
                        }
                    });

                    _this3.locationData = data;
                    _this3.isAutoOpenATMs = data.autoOpenATMs;
                    _this3.model.routeSequence.map(function (routeData) {
                        if (routeData.messengerId && routeData.firstName && routeData.lastName) {
                            _this3.model.messenger = routeData.messengerId + " | " + routeData.firstName + " " + routeData.lastName;
                        } else {
                            _this3.model.messenger = "";
                        }
                        _this3.model.messengerId = routeData.messengerId;
                        _this3.model.kabaKey = routeData.kabaKeyId;
                        _this3.model.SGKey = routeData.SGKeyId;
                        _this3.model.routeKeyId = routeData.routeKeyId;
                        routeData.isEdit = false;
                        routeData.isSave = false;
                        routeData.atmCode = "";
                        return routeData;
                    });
                } else {
                    _this3.resetRouteDetails();
                }
            }).then(function () {
                if (_this3.atmCodesData) {
                    _this3.atmCodesData.redirectFromCheckoutScreen = false;
                    _this3.atmCodesData = _this3.DataCounter.setAtmCodeData();
                }
                _this3.getRouteStatus(_this3.locationData);
            }).catch(function (err) {
                _this3.model.routeSequence = [];
                console.log(err);
            }).finally(function () {
                _this3.loading = false;
            });
        }
    }, {
        key: 'getATMLocations',
        value: function getATMLocations() {
            var _this4 = this;

            if (!this.model.route) return;
            this.callOnce = true;
            clearInterval(this.apiCallTimer);
            this.routeSequence().then(function () {
                _this4.callOnce = false;
                _this4.autoOpenATMLocksProgress();
                _this4.checkOpenCodeProgress();
            });
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            if (!this.model.route) {
                this.model.routeStatus = null;
                this.model.messenger = null;
                clearInterval(this.apiCallTimer);
            }
        }
    }, {
        key: 'getRouteStatus',
        value: function getRouteStatus(data) {
            var selectedRoute = _.find(this.model.routeList, { 'routeId': this.model.route.Value });
            // if (data.length && data.routeStatus.notPacked > 0) {
            //     this.model.isDisabled = true;
            //     return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.pending_pack', {
            //         totalCount: data.routeStatus.notPacked
            //     })
            // }
            // if (data.length && data.routeStatus.notThrown > 0) {
            //     this.model.isDisabled = true;
            //     return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.pending_throw', {
            //         totalCount: data.routeStatus.notThrown
            //     })
            // }
            if (selectedRoute.arrTime && selectedRoute.complTime) {
                this.model.isDisabled = true;
                var checkedInTime = moment(selectedRoute.complTime).format('hh:mm A');
                return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.check_in') + ' | ' + checkedInTime;
            } else if (selectedRoute.arriveTime && !selectedRoute.complTime) {
                this.model.isDisabled = true;
                return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.in_branch');
            } else if (selectedRoute.leaveTime && !selectedRoute.arriveTime) {
                this.model.isDisabled = false;
                return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.on_route');
            } else if (selectedRoute.checkoutTime) {
                this.model.isDisabled = false;
                var checkoutTime = moment(selectedRoute.checkoutTime).format('hh:mm A');
                return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.checked_out') + ' | ' + checkoutTime;
            } else if (!selectedRoute.checkoutTime) {
                this.model.isDisabled = true;
                return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.pending_checkout');
            } else return;
        }
    }, {
        key: 'resetRouteDetails',
        value: function resetRouteDetails() {
            this.model.routeSequence = [];
            this.model.messenger = "";
            this.model.messengerId = "";
            this.model.kabaKey = "";
            this.model.SGKey = "";
            this.model.routeKeyId = "";
        }

        // redirect user to specific location 

    }, {
        key: 'redirectToLocation',
        value: function redirectToLocation(location) {
            if (location != null) {
                this.$rootScope.$broadcast('routeChange', null);
                this.Navigation.goToLocationTab(location);
            } else {
                this.error = this.$translate.instant('error.branch_mgmt.locations_not_found');
            }
        }
    }, {
        key: 'editCode',
        value: function editCode(data, index) {
            this.model.routeSequence[index].isEdit = true;
            this.focuseElementById('atm-code-' + index);
        }

        // it will create record in AtmCodesManagement table and store code to redis

    }, {
        key: 'saveCode',
        value: function saveCode(data, index) {
            var _this5 = this;

            if (data.isOTCLockId) return;

            var keyId = null,
                OTCKeys = data.OTCKeys;

            if (OTCKeys) {
                if (data.lockType === 'LMS') keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].SGKeyId : null;
                if (data.lockType === 'FLM') keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].kabaKeyId : null;
                if (data.lockType === 'RTE') keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].routeKeyId : null;
                if (data.lockType === 'witz') keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].witzKeyId : null;
            }

            this.model.loading = true;
            this.AtmCodesManagementService.create({
                atmCode: data.atmCode,
                locationId: data.originLockId,
                redisLocId: this.generateSerNo(data),
                performedById: this.model.loggedInUser,
                vaultDate: moment(this.model.date).format('YYYY-MM-DD'),
                messengerId: this.model.messengerId,
                routeId: this.model.route.Value,
                keyId: keyId || null,
                branchId: this.model.branch,
                isSecondaryLock: data.secondaryLock || 0,
                isOTCLockId: data.isOTCLockId || 0
            }).then(function (data) {
                _this5.model.routeSequence[index].isSave = true;
                _this5.currentDateTime = moment().format('DD-MM-YY hh:mm:ss A');
                if (index + 1 !== _this5.model.routeSequence.length) _this5.focuseElementById('atm-code-' + (index + 1));
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this5.errorMessage += e.message + '<br/>';
                });
            }).finally(function () {
                _this5.model.loading = false;
            });
        }
    }, {
        key: 'autoCommit',
        value: function autoCommit(data, index) {
            if (this.model.routeSequence[index].atmCode) return this.saveCode(data, index);
        }
    }, {
        key: 'autoOpenLocks',
        value: function autoOpenLocks() {
            var _this6 = this;

            var formattedDate = moment(this.model.date).format('YYYY-MM-DD'),
                messengerId = this.model.messengerId,
                performedById = this.model.loggedInUser;

            this.Modal.confirmSupervisor('auto-open-locks', null, function (_ref) {
                var modal = _ref.modal,
                    supId = _ref.supId;

                modal.close();
                _this6.Modal.autoOpenLocksModal(_this6.model.route.Value, _this6.model.branch, formattedDate, _this6.isAutoOpenATMs, messengerId, performedById, function (_ref2) {
                    var modal = _ref2.modal;

                    // this.routeSequence(); // refresh data
                    _this6.getATMLocations();
                }, function (_ref3) {
                    var modal = _ref3.modal;

                    modal.close();
                });
            }, function (_ref4) {
                var modal = _ref4.modal;

                modal.close();
            });
        }
    }, {
        key: 'getLockStatus',
        value: function getLockStatus() {
            var _this7 = this;

            var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
            // this.gettingLockStatus = this.loading;
            // this.gettingLockStatus = true;

            this.Modal.confirmSupervisor('get-lock-status', null, function (_ref5) {
                var modal = _ref5.modal,
                    supId = _ref5.supId;

                modal.close();
                _this7.Modal.lockStatusModal(_this7.model.route.Value, _this7.model.branch, formattedDate, _this7.isAutoOpenATMs, _this7.model.messengerId, function (_ref6) {
                    var modal = _ref6.modal;
                }, function (_ref7) {
                    var modal = _ref7.modal;

                    modal.close();
                });
            }, function (_ref8) {
                var modal = _ref8.modal;

                // this.gettingLockStatus = false;
                modal.close();
            });
        }
    }, {
        key: 'removeCharacter',
        value: function removeCharacter(message) {
            if (message) return this.AtmCodesManagementService.removeCharacter(message);
        }
    }, {
        key: 'getKeys',
        value: function getKeys(data) {
            this.keyId = '';
            // let OTCKeys = JSON.parse(data.OTCKeys);
            var OTCKeys = data.OTCKeys;

            if (data && data.messengerId && OTCKeys) {
                if (data.lockType === 'LMS') return this.keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].SGKeyId : null;
                if (data.lockType === 'FLM') return this.keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].kabaKeyId : null;
                if (data.lockType === 'RTE') return this.keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].routeKeyId : null;
                if (data.lockType === 'witz' || data.lockType === 'TDS') return this.keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].witzKeyId : null;
            } else this.keyId = '';
        }
    }, {
        key: 'generateSerNo',
        value: function generateSerNo(data) {
            if (data.lockType === 'LMS' && !isNaN(data.locationId) && data.locationId.substring(data.locationId.length - 4) != '0000') return data.locationId + '0000';else return data.locationId;
        }
    }, {
        key: 'autoOpenATMLocksProgress',
        value: function autoOpenATMLocksProgress() {
            var _this8 = this;

            this.openLockStack = [];
            if (!this.model.route || !this.model.messengerId) {
                clearInterval(this.apiCallTimer);
                return;
            };

            this.loadingOpenLockStats = true;
            var formattedVaultDate = moment(this.model.date).format('YYYY-MM-DD');
            this.AtmCodesManagementService.autoOpenATMLocksProgress(this.model.route.Value, formattedVaultDate, this.model.messengerId).then(function (data) {
                _this8.model.autoOpenATMLocksProgressInfo = data;
                if (_this8.model.autoOpenATMLocksProgressInfo.message === 'completed') {
                    clearInterval(_this8.apiCallTimer);
                    if (_this8.callOnce) _this8.routeSequence();
                    return;
                } else {
                    _this8.callOnce = true;
                }
                _this8.openLockStack.push({ value: _this8.model.autoOpenATMLocksProgressInfo.results.totalLocationProcessed, type: 'success', message: 'Processed' }, { value: _this8.model.autoOpenATMLocksProgressInfo.results.totalInProgress, type: 'warning', message: 'Pending' });
                _this8.totalLocations = _this8.model.autoOpenATMLocksProgressInfo.results.totalLocations;
            }).catch(function (err) {
                _this8.Modal.errorModal(err.data.message);
                clearInterval(_this8.apiCallTimer);
            }).finally(function () {
                _this8.loadingOpenLockStats = false;
            });
        }
    }, {
        key: 'checkOpenCodeProgress',
        value: function checkOpenCodeProgress() {
            var _this9 = this;

            if (!this.model.route || !this.model.messengerId) {
                return;
            };

            var timeleft = 30;
            this.apiCallTimer = setInterval(function () {
                if (timeleft <= 0) {
                    _this9.autoOpenATMLocksProgress();
                    timeleft = 30;
                }
                timeleft -= 1;
                // console.log(`API call countdown (${timeleft})`);
            }, 1000);
        }
    }, {
        key: 'reassignLock',
        value: function reassignLock(data) {
            var _this10 = this;

            var lockType = data.lockType,
                locationId = data.locationId,
                OTCCompanyName = data.OTCCompanyName,
                OTCKeys = data.OTCKeys;

            var toKeyId = OTCKeys[OTCCompanyName].routeKeyId;

            this.model.routeSequence.forEach(function (location) {
                if (location && location.lockType === 'RTE' && location.code && location.code.isAlreadyOpened) {
                    _this10.reassignLockObj[location.locationId].isDisabled = true;
                    if (location.locationId === locationId) {
                        _this10.reassignLockObj[locationId].loadingReassignLock = true;
                    }
                }
            });

            this.AtmCodesManagementService.reassignLock(lockType, toKeyId, locationId, OTCCompanyName, this.model.loggedInUser, this.model.route.Value, this.model.messengerId, moment(this.model.date).format('YYYY-MM-DD'), this.model.branch).then(function (result) {
                _this10.routeSequence();
            }).catch(function (err) {
                _this10.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this10.reassignLockObj[locationId].loadingReassignLock = false;
                _this10.model.routeSequence.forEach(function (location) {
                    if (location && location.lockType === 'RTE' && location.code && location.code.isAlreadyOpened) {
                        _this10.reassignLockObj[location.locationId].isDisabled = false;
                    }
                });
            });
        }
    }]);
    return ATMCodesManagementController;
}();

exports.default = ATMCodesManagementController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atm_codes_management = __webpack_require__(1619);

var _atm_codes_management2 = _interopRequireDefault(_atm_codes_management);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMCodesManagementModule = angular.module('atmCodesManagement', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('atm-codes-management');

    $stateProvider.state('atmCodesManagement', {
        url: '/atm-codes-management',
        component: 'atmCodesManagement',
        data: {
            requireLogin: true,
            requireACL: 'atm_codes_management.all'
        },
        parent: 'app'
    });
}]).component('atmCodesManagement', _atm_codes_management2.default).name;

exports.default = ATMCodesManagementModule;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atm_count = __webpack_require__(2641);

var _atm_count2 = _interopRequireDefault(_atm_count);

var _atm_count3 = __webpack_require__(1623);

var _atm_count4 = _interopRequireDefault(_atm_count3);

__webpack_require__(2928);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMCountComponent = {
    restrict: 'E',
    template: _atm_count2.default,
    controller: _atm_count4.default
};

exports.default = ATMCountComponent;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _isFinite = __webpack_require__(315);

var _isFinite2 = _interopRequireDefault(_isFinite);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMCountController = function () {

    /*@ngInject*/
    ATMCountController.$inject = ["$state", "$q", "$window", "$scope", "$http", "Modal", "LocationService", "User", "SetupService", "DateUtil", "ShipmentService", "BranchFundingSourceService", "HoldService", "AtmResidualService", "BulkCashService", "Sound", "$translate", "$rootScope", "DataCounter", "$location", "UserBranchFundingSourceService", "UsersService", "DenominationService", "AtmResidualDepositService", "ShiptypeService", "Navigation", "UserService", "CurrencyService", "FetchReactData"];
    function ATMCountController($state, $q, $window, $scope, $http, Modal, LocationService, User, SetupService, DateUtil, ShipmentService, BranchFundingSourceService, HoldService, AtmResidualService, BulkCashService, Sound, $translate, $rootScope, DataCounter, $location, UserBranchFundingSourceService, UsersService, DenominationService, AtmResidualDepositService, ShiptypeService, Navigation, UserService, CurrencyService, FetchReactData) {
        var _this = this;

        (0, _classCallCheck3.default)(this, ATMCountController);

        this.locationSearchObj = function (searchKey) {
            searchKey = searchKey || '';
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: _this.model.branch
                    }, {
                        group: {
                            rules: [{
                                field: 'locationId',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'sourceName',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        };

        this.codUnfitFilter = function (denom) {
            if (!denom || !denom.unfit) return false;
            if (_this.isShiptypeCoinRestrictionEnabled()) {
                return denom.shiptypeId === _this.countRestriction.shiptypeId;
            }
            if (!_this.isCODShipment()) return true;

            var includedIds = _this.codFlags && Array.isArray(_this.codFlags.includedDenominationIds) ? _this.codFlags.includedDenominationIds : [];
            if (includedIds.length === 0) return false;

            var includedSet = new _set2.default(includedIds);
            var all = _this.model.depositRecord && _this.model.depositRecord.denominations ? _this.model.depositRecord.denominations : [];
            var allowed = new _set2.default();
            all.forEach(function (d) {
                if (!d.unfit && includedSet.has(d.id)) {
                    allowed.add(d.shiptypeId + '|' + d.faceValue);
                }
            });
            return allowed.has(denom.shiptypeId + '|' + denom.faceValue);
        };

        this.codCashFilter = function (denom) {
            if (!denom || denom.unfit || denom.coinFlag) return false;
            if (_this.isShiptypeCoinRestrictionEnabled()) return false;
            if (!_this.isCODShipment()) return true;
            var includedIds = _this.codFlags && Array.isArray(_this.codFlags.includedDenominationIds) ? _this.codFlags.includedDenominationIds : [];
            if (includedIds.length === 0) return false;
            var includedSet = new _set2.default(includedIds);
            return includedSet.has(denom.id);
        };

        this.codCoinFilter = function (denom) {
            if (!denom || denom.unfit || !denom.coinFlag) return false;
            if (_this.isShiptypeCoinRestrictionEnabled()) {
                return denom.shiptypeId === _this.countRestriction.shiptypeId;
            }
            if (!_this.isCODShipment()) return true;
            var includedIds = _this.codFlags && Array.isArray(_this.codFlags.includedDenominationIds) ? _this.codFlags.includedDenominationIds : [];
            if (includedIds.length === 0) return false;
            var includedSet = new _set2.default(includedIds);
            return includedSet.has(denom.id);
        };

        this.$q = $q;
        this.$state = $state;
        this.$window = $window;
        this.$http = $http;
        this.FetchReactData = FetchReactData;
        this.LocationService = LocationService;
        this.User = User;
        this.SetupService = SetupService;
        this.DateUtil = DateUtil;
        this.ShipmentService = ShipmentService;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.AtmResidualService = AtmResidualService;
        this.BulkCashService = BulkCashService;
        this.UsersService = UsersService;
        this.HoldService = HoldService;
        this.Modal = Modal;
        this.$scope = $scope;
        this.Sound = Sound;
        this.$rootScope = $rootScope;
        this.DataCounter = DataCounter;
        this.$location = $location;
        this.DenominationService = DenominationService;
        this.AtmResidualDepositService = AtmResidualDepositService;
        this.ShiptypeService = ShiptypeService, this.$translate = $translate;
        this.Navigation = Navigation;
        this.UserBranchFundingSourceService = UserBranchFundingSourceService;
        this.UserService = UserService;
        this.CurrencyService = CurrencyService;
        this.currencySymbol = '$';
        this.currencyPattern = /^(\$|€|CA\$|C\$|J\$)?([0-9 _ ,]*(\.\d*)?)$/;
        this.currencyPatternStrict = /^(\$|€|CA\$|C\$|J\$)?((\d{1,3}(,\d{3})*)|\d*)(\.\d+)?$/;
        this.residualCashAmountPattern = /^$|^(\$|€|CA\$|C\$|J\$)?\d+(?:\.00)?$/;
        this.residualCoinAmountPattern = /^$|^(\$|€|CA\$|C\$|J\$)?(?:(?:\d+(?:\.\d{0,2})?)|(?:\.\d{1,2}))$/;
        this.currencyData = [];
        this.model = {
            branch: User.getUser().branchId,
            vaultDate: '',
            beginTime: '',
            atmResidual: [],
            loggedInUserId: User.getUser().id,
            branchCounters: [],
            selectedBranchCounter: null,
            hasCounters: false,
            unfitTotalCashCounted: 0,
            depositRecord: {
                declaredTotalAmount: 0,
                countedVariance: 0,
                totalAmount: 0,
                statedTotalAmount: 0,
                depositShipment: null,
                depositRecord: null,
                denominations: [],
                receiptAmount: 0,
                childTotalDeposit: 0,
                coinTotalDeposit: 0,
                unfitTotalDeposit: 0,
                notes: '',
                previousNotes: ''
                // ledgerTransaction: []
            } };
        this.lastScanned = "";
        this.isError = true;
        this.successCount = 0;
        this.orderType = "";
        this.atmResidualRecord = { notes: '' };
        this.shipmentData = [];
        this.enterSuffix = _app2.default.scan_enter_suffix;
        this.pickupDate = "";
        this.remainingResiduals = [];
        this.allDenominations = [];
        this.isEdit = false;
        this.$rootScope.$broadcast('routeChange', '/app/atm-count');
        this.locationData = '';
        this.isEmergencyType = '';
        this.branchTimeZone = '';
        this.showCoins = false;
        this.showUnfit = false;
        this.showCash = true;
        this.shiptype = 'deposit';
        this.MAXLIMIT = 1000;
        this.isBulkCash = false;
        this.autoCounting = false;

        this.isBulkDeposit = false;
        this.isBulkDepositCommit = false;
        this.browserTimezone = moment.tz.guess();
        this.countRestriction = { enabled: false, shiptypeId: null };
        this._initBulkDepositDataStructures();
    }

    (0, _createClass3.default)(ATMCountController, [{
        key: 'roundTo2DecimalsForDisplay',
        value: function roundTo2DecimalsForDisplay(value) {
            if (value == null || value === '') return '0';
            var str = String(value).replace(/,/g, '').replace(/\s/g, '');
            var num = Number(str);
            if (!(0, _isFinite2.default)(num)) return value != null && value !== '' ? String(value) : '0';
            var rounded = Math.round(num * 100) / 100;
            return rounded.toLocaleString(undefined, { maximumFractionDigits: 2 });
        }
    }, {
        key: '_getDefaultBulkDepositData',
        value: function _getDefaultBulkDepositData() {
            return {
                shipment: null,
                statedTotal: 0,
                declaredTotal: 0,
                countedTotal: 0,
                countedVariance: 0,
                bags: {},
                metadata: {
                    hasActiveBulkDeposit: false,
                    isClosingBulkDeposit: false,
                    nextBagIndex: 0,
                    shiptype: {
                        countable: false,
                        daysToCount: 0
                    },
                    branchCurrentVaultDate: null,
                    shipmentVaultDate: null
                }
            };
        }
    }, {
        key: '_getDefaultActiveBagData',
        value: function _getDefaultActiveBagData() {
            return {
                bagIndex: null,
                isEditMode: false,
                isCounting: false,
                originalBagValues: null,
                originalDepositData: null,
                bag: null,
                depositData: this._getDefaultDepositData()
            };
        }
    }, {
        key: '_getDefaultDepositData',
        value: function _getDefaultDepositData() {
            return {
                depositShipment: null,
                depositRecord: null,
                declaredTotalAmount: 0,
                countedVariance: 0,
                totalAmount: 0,
                statedTotalAmount: 0,
                denominations: [],
                previousDenominations: [],
                childTotalDeposit: 0,
                coinTotalDeposit: 0,
                unfitTotalDeposit: 0,
                codFlags: null
            };
        }
    }, {
        key: '_getDefaultBagData',
        value: function _getDefaultBagData() {
            return {
                trackingId: '',
                declaredAmount: null,
                countedAmount: 0,
                countedVariance: 0,
                status: 'pending',
                shipmentId: null,
                depositRecordId: null,
                countCompletedAt: null,
                depositRecord: null,
                cashDenomTotals: 0,
                coinDenomTotals: 0,
                unfitDenomTotals: 0
            };
        }
    }, {
        key: '_initBulkDepositDataStructures',
        value: function _initBulkDepositDataStructures() {
            this.bulkDepositData = this._getDefaultBulkDepositData();
            this.activeBagData = this._getDefaultActiveBagData();
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.$q.all([this.model.branch = this.User.getUser().branchId, this.SetupService.get(this.model.branch), this.DenominationService.all({}, null, this.MAXLIMIT), this.UserService.getBranchCounters(this.model.branch), this.UsersService.get(this.model.loggedInUserId)]).then(function (data) {
                _this2.getAllLocation('', 0);
                _this2.model.vaultDate = _this2.DateUtil.convertToDate(data[1].currentVaultDate);
                _this2.branchTimeZone = data[1].timezone;
                _this2.minVaultDate = {
                    maxDate: _this2.model.vaultDate
                };
                _this2.model.depositRecord.denominations = angular.copy(_this2.denominationsDataMap(data[2].results));
                _this2.allDenominations = _this2.model.depositRecord.denominations;

                var countersRes = data[3] || {};
                var userDetail = data[4] || {};
                _this2.model.branchCounters = (countersRes.branchCounters || []).map(function (c) {
                    return {
                        id: c.id,
                        name: c.name,
                        sn: c.serialNumber
                    };
                });
                _this2.model.hasCounters = _this2.model.branchCounters.length > 0;

                var isWebUser = !userDetail.customerUser && !!userDetail.email;
                if (!_this2.model.hasCounters) {
                    _this2.disableCounterSelection = true;
                    _this2.model.selectedBranchCounter = null;
                } else if (userDetail.supervisor) {
                    _this2.disableCounterSelection = false;
                } else if (isWebUser) {
                    var found = userDetail.branchCounterId ? _this2.model.branchCounters.find(function (bc) {
                        return bc.id === userDetail.branchCounterId;
                    }) : null;
                    if (found) {
                        _this2.model.selectedBranchCounter = found;
                        _this2.disableCounterSelection = true;
                    } else {
                        _this2.model.selectedBranchCounter = null;
                        _this2.disableCounterSelection = true;
                        _this2.Modal.errorModal('error.web_user_counter_required');
                    }
                } else {
                    _this2.disableCounterSelection = false;
                }
            }).then(function () {
                _this2.loadPermission();
                _this2.loadCurrencyData();
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'loadCurrencyData',
        value: function loadCurrencyData() {
            var _this3 = this;

            if (this.currencyData.length > 0) {
                return this.$q.resolve(this.currencyData);
            }

            return this.SetupService.get(this.model.branch).then(function (setup) {
                var currencyIds = Array.isArray(setup.availableCurrencyIds) && setup.availableCurrencyIds.length > 0 ? setup.availableCurrencyIds : [setup.currencyId];

                var currencySearchObj = {
                    queryJSON: {
                        rules: currencyIds.map(function (id) {
                            return {
                                field: "id",
                                condition: "=",
                                data: id
                            };
                        }),
                        operator: "OR"
                    }
                };

                return _this3.CurrencyService.all(currencySearchObj, 0, 100);
            }).then(function (data) {
                _this3.currencyData = data.results || [];
                return _this3.currencyData;
            }).catch(function (err) {
                console.log('Error loading currency data:', err);
                _this3.currencyData = [];
                return [];
            });
        }
    }, {
        key: 'setCurrencySymbol',
        value: function setCurrencySymbol() {
            var _this4 = this;

            if (!this.model.locationId || !this.model.locationId.currencyId) {
                this.currencySymbol = '$';
                return;
            }

            var currencyId = this.model.locationId.currencyId;

            if (Array.isArray(this.currencyData) && this.currencyData.length > 0) {
                var currency = this.currencyData.find(function (c) {
                    return c.id === currencyId;
                });
                this.currencySymbol = currency && currency.symbol ? currency.symbol : '$';
            } else {
                this.loadCurrencyData().then(function () {
                    var currency = _this4.currencyData.find(function (c) {
                        return c.id === currencyId;
                    });
                    _this4.currencySymbol = currency && currency.symbol ? currency.symbol : '$';
                });
            }
        }
    }, {
        key: 'canUseCounter',
        value: function canUseCounter() {
            if (!this.model.hasCounters) return true;
            return !!(this.model.selectedBranchCounter && this.model.selectedBranchCounter.id);
        }
    }, {
        key: 'onCounterSelected',
        value: function onCounterSelected() {
            this.resetData();
            this.model.locationId = null;
        }
    }, {
        key: 'canShowAutoCountButton',
        value: function canShowAutoCountButton() {
            return this.model.hasCounters && !!(this.model.selectedBranchCounter && this.model.selectedBranchCounter.id) && this.shiptype === 'residual' && (this.model.atmResidual || []).length > 0 && this.isEdit;
        }
    }, {
        key: 'autoCountFromCounter',
        value: function autoCountFromCounter() {
            var _this5 = this;

            if (!this.canShowAutoCountButton() || this.autoCounting) return;
            this.autoCounting = true;
            var branchId = this.model.branch;
            var vaultDate = moment(this.model.vaultDate).format('YYYY-MM-DD');
            var sn = this.model.selectedBranchCounter.sn;
            this.$http.get(_app2.default.api + '/cashcounts/latest', { params: { branchId: branchId, vaultDate: vaultDate, sn: sn } }).then(function (res) {
                if (!res || !res.data || !res.data.data) return;
                var counts = res.data.data.counts || {};
                if (!counts || (0, _keys2.default)(counts).length === 0) return;
                (_this5.model.atmResidual || []).forEach(function (row, idx) {
                    var key = row.denominationId; // e.g., 'USD20'
                    var billCount = Number(counts[key]);
                    if ((0, _isFinite2.default)(billCount) && billCount > 0) {
                        var face = Number(row.faceValue) || 0;
                        row.countedResidual = billCount * face;
                        row.denomCountedResidual = billCount.toLocaleString();
                        _this5.calculateAmount(idx);
                    }
                });
                _this5.totalAmount();
            }).catch(function (err) {
                console.error(err);
            }).finally(function () {
                _this5.autoCounting = false;
            });
        }
    }, {
        key: 'loadPermission',
        value: function loadPermission() {
            var _this6 = this;

            this.acl = {};
            this.hasACL = {};

            ['atm_count'].forEach(function (permissionKey) {
                _this6.acl[permissionKey] = _this6.User.getACL(permissionKey);

                _this6.hasACL[permissionKey] = {};

                _this6.acl[permissionKey].forEach(function (permission) {
                    _this6.hasACL[permissionKey][permission] = true;
                });
            });
        }
    }, {
        key: 'focusElementById',
        value: function focusElementById(id) {
            setTimeout(function () {
                document.getElementById(id).focus();
            }, 300);
        }

        // Get current time

    }, {
        key: 'getTime',
        value: function getTime(time) {
            if (!time) {
                return time;
            }

            time = time.split(':');

            var d = new Date();

            d.setHours(+time[0]);
            d.setMinutes(time[1]);
            d.setSeconds(0);
            d.setMilliseconds(0);

            return d;
        }

        // Get fundingSource

    }, {
        key: 'getAllLocation',
        value: function getAllLocation(searchKey, offset) {
            var _this7 = this;

            this.UserBranchFundingSourceService.getBranchFundingSource(this.model.loggedInUserId, this.model.branch).then(function (data) {
                if (offset === 0) {
                    _this7.totalRecords = data.total;
                    _this7.locationLists = _this7.mappingLocationData(data.results);
                } else {
                    var locations = _this7.mappingLocationData(data.results);
                    _this7.locationLists = _this7.locationLists.concat(locations);
                }
                return data.results;
            }).then(function (fundingSourceData) {
                _this7.loadAtmCount(fundingSourceData);
            });
        }
    }, {
        key: 'mappingLocationData',
        value: function mappingLocationData(locations) {
            return locations.map(function (location) {
                return {
                    Key: location.id + " | " + location.locationId + " | " + location.sourceName,
                    Value: location.locationId,
                    Id: location.id,
                    EditCountAnytime: location.editCountAnytime,
                    varianceCheckEnabled: location.varianceCheckEnabled || false,
                    varianceThreshold: location.varianceThreshold,
                    currencyId: location.currencyId
                };
            });
        }
    }, {
        key: 'depositCommitDisabled',
        value: function depositCommitDisabled() {
            var patterns = /^[0-9]\d*(\,\d+)?$/;
            var invalidValues = false;
            this.model.depositRecord.denominations.forEach(function (denom) {
                if (!patterns.test(denom.totalCounted)) {
                    invalidValues = true;
                }
            });
            var totalBills = Number(this.model.depositRecord.childTotalDeposit) + Number(this.model.depositRecord.coinTotalDeposit) + Number(this.model.depositRecord.unfitTotalDeposit);
            return this.model.depositRecord.totalAmount !== totalBills || !this.model.bagId || !this.model.beginTime || !this.pickupDate || totalBills < 0 || invalidValues;
        }
    }, {
        key: 'denominationsDataMap',
        value: function denominationsDataMap(list) {
            return list.map(function (item) {
                return {
                    id: item.id,
                    label: item.id + ' | ' + item.name,
                    faceValue: item.faceValue,
                    totalCounted: item.totalCounted || 0,
                    coinFlag: item.coinFlag || false,
                    totalValue: item.totalCounted * item.faceValue,
                    currencyId: item.currencyId,
                    shiptypeId: item.shiptypeId,
                    unfit: item.unfit || false,
                    symbol: item.currency && item.currency.symbol ? item.currency.symbol : null
                };
            });
        }
    }, {
        key: 'toggleTab',
        value: function toggleTab(tabType) {
            switch (tabType) {
                case 'cash':
                    this.showCash = !this.showCash;
                    break;
                case 'coin':
                    this.showCoins = !this.showCoins;
                    break;
                case 'unfit':
                    this.showUnfit = !this.showUnfit;
                    break;
                default:
                    this.showCash = true;
                    this.showCoins = false;
                    this.showUnfit = false;
            }

            if (!this.showUnfit && !this.showCoins && !this.showCash) {
                this.showCash = true;
                this.showCoins = false;
                this.showUnfit = false;
            }
        }
    }, {
        key: 'depositDenomChange',
        value: function depositDenomChange(denomId) {
            var index = this.model.depositRecord.denominations.findIndex(function (item) {
                return item.id === denomId;
            });
            var countedTotal = Number(this.model.depositRecord.denominations[index].totalCounted * this.model.depositRecord.denominations[index].faceValue) || 0;
            this.model.depositRecord.denominations[index].totalValue = countedTotal;
            this.depositCountTotal();
        }
    }, {
        key: 'depositCountTotal',
        value: function depositCountTotal() {
            var _this8 = this;

            this.model.depositRecord.childTotalDeposit = this.model.depositRecord.denominations.filter(function (denom) {
                return !denom.coinFlag && !denom.unfit;
            }).reduce(function (sum, denom) {
                return sum + (Number(denom.totalCounted * denom.faceValue) || 0);
            }, 0);
            this.model.depositRecord.coinTotalDeposit = this.model.depositRecord.denominations.filter(function (denom) {
                return denom.coinFlag && !denom.unfit;
            }).reduce(function (sum, denom) {
                return sum + (Number(denom.totalCounted * denom.faceValue) || 0);
            }, 0);

            var unfitDenomsViewBased = this.getViewUnfitDenominations();
            this.model.depositRecord.unfitTotalDeposit = unfitDenomsViewBased.reduce(function (sum, denom) {
                if (_this8.shiptype === 'deposit') {
                    return sum + (Number(denom.totalValue) || 0);
                } else {
                    return sum + (Number(denom.totalCashCounted) || 0);
                }
            }, 0);
            this.model.depositRecord.totalAmount = Number(this.model.depositRecord.childTotalDeposit) + Number(this.model.depositRecord.coinTotalDeposit) + Number(this.model.depositRecord.unfitTotalDeposit);
            this.model.depositRecord.countedVariance = Number(this.model.depositRecord.totalAmount) - Number(this.model.depositRecord.declaredTotalAmount);
        }
    }, {
        key: 'hasUnfitDenoms',
        value: function hasUnfitDenoms() {
            return this.getViewUnfitDenominations().length > 0;
        }
    }, {
        key: 'getFilteredUnfitDenominations',
        value: function getFilteredUnfitDenominations() {
            var _this9 = this;

            if (!this.model.depositRecord.denominations || !this.childShipmentData || !Array.isArray(this.childShipmentData)) {
                return [];
            }

            var unfitDenoms = this.model.depositRecord.denominations.filter(function (denom) {
                return denom.unfit;
            });
            return unfitDenoms.filter(function (unfitDenom) {
                return _this9.childShipmentData.some(function (shipment) {
                    return shipment.faceValue === unfitDenom.faceValue && shipment.shiptypeId === unfitDenom.shiptypeId;
                });
            });
        }
    }, {
        key: 'getViewUnfitDenominations',
        value: function getViewUnfitDenominations() {
            if (this.shiptype === 'residual') {
                return this.getFilteredUnfitDenominations();
            }
            var denoms = this.model.depositRecord && this.model.depositRecord.denominations ? this.model.depositRecord.denominations : [];
            return denoms.filter(function (d) {
                return d.unfit;
            });
        }
    }, {
        key: 'calculateUnfitAmount',
        value: function calculateUnfitAmount(index) {
            var unfitDenoms = this.getFilteredUnfitDenominations();
            if (unfitDenoms[index]) {
                var denom = unfitDenoms[index];
                var countedAmount = Number(denom.totalCashCounted) || 0;
                var faceValue = Number(denom.faceValue) || 0;

                if (faceValue > 0) {
                    var billCount = countedAmount / faceValue;
                    denom.denomTotalCashCounted = billCount.toLocaleString();
                    denom.isInvalidAmount = billCount !== Math.floor(billCount);
                } else {
                    denom.denomTotalCashCounted = '0';
                    denom.isInvalidAmount = false;
                }

                this.updateUnfitTotal();
            }
        }
    }, {
        key: 'updateUnfitTotal',
        value: function updateUnfitTotal() {
            var unfitDenoms = this.getFilteredUnfitDenominations();
            this.model.unfitTotalCashCounted = unfitDenoms.reduce(function (sum, denom) {
                return sum + (Number(denom.totalCashCounted) || 0);
            }, 0);

            this.depositCountTotal();
            this.model.countedResidualTotalDisplay = (Number(this.model.countedResidualTotal) || 0) + (Number(this.model.unfitTotalCashCounted) || 0);
        }
    }, {
        key: 'initializeUnfitDenominations',
        value: function initializeUnfitDenominations() {
            var _this10 = this;

            if (!this.model.depositRecord.denominations || !this.childShipmentData || !Array.isArray(this.childShipmentData)) {
                return;
            }

            try {
                var matchingUnfitDenoms = this.getFilteredUnfitDenominations();

                matchingUnfitDenoms.forEach(function (unfitDenom) {
                    var matchingShipment = _this10.childShipmentData.find(function (shipment) {
                        return shipment.faceValue === unfitDenom.faceValue && shipment.shiptypeId === unfitDenom.shiptypeId;
                    });

                    if (matchingShipment) {
                        unfitDenom.totalCashCounted = 0;
                        unfitDenom.denomTotalCashCounted = 0;
                        unfitDenom.shiptypeId = matchingShipment.shiptypeId;
                        unfitDenom.faceValue = matchingShipment.faceValue;
                        unfitDenom.denominationSymbol = matchingShipment.denominationSymbol;
                    }
                });

                this.updateUnfitTotal();
            } catch (error) {
                console.log('Error initializing unfit denominations:', error);
            }
        }
    }, {
        key: 'prepareUnfitDenominationsData',
        value: function prepareUnfitDenominationsData() {
            var _this11 = this;

            var unfitDenoms = this.getFilteredUnfitDenominations();

            if (!unfitDenoms || unfitDenoms.length === 0) {
                return null;
            }

            return unfitDenoms.map(function (unfitDenom) {
                var matchingShipment = _this11.childShipmentData.find(function (shipment) {
                    return shipment.faceValue === unfitDenom.faceValue && shipment.shiptypeId === unfitDenom.shiptypeId;
                });

                if (!matchingShipment) {
                    console.warn('No matching shipment found for unfit denomination:', unfitDenom);
                    return null;
                }

                return {
                    denominationId: unfitDenom.id,
                    faceValue: Number(unfitDenom.faceValue),
                    amount: Number(unfitDenom.totalCashCounted) || 0,
                    quantity: Number(unfitDenom.totalCashCounted) / Number(unfitDenom.faceValue) || 0,

                    // Shipment details for DEPOSITRECORD
                    shipmentId: matchingShipment.residualShipmentId,
                    orderNo: matchingShipment.orderNo,
                    trackingId: matchingShipment.trackingId,
                    fromLocationId: matchingShipment.fromLocationId,
                    toLocationId: matchingShipment.toLocationId,
                    routeId: matchingShipment.routeId,
                    shiptypeId: matchingShipment.shiptypeId,
                    currencyId: matchingShipment.currencyId,
                    branchId: matchingShipment.branchId || _this11.model.branch,

                    isEC: matchingShipment.isEC,
                    orderType: matchingShipment.orderType,
                    amountLoadRequested: matchingShipment.amountLoadRequested,

                    fromLocationName: matchingShipment.fromLocationName,
                    toLocationName: matchingShipment.toLocationName
                };
            }).filter(function (item) {
                return item !== null;
            });
        }
    }, {
        key: 'restorePreviousUnfitDenominations',
        value: function restorePreviousUnfitDenominations() {
            var _this12 = this;

            if (!this.model.parentAtmResidual || !this.model.parentAtmResidual.orderNo) {
                return;
            }

            if (!this.childShipmentData || !Array.isArray(this.childShipmentData)) {
                return;
            }

            var orderNo = this.model.parentAtmResidual.orderNo;
            var account = this.model.parentAtmResidual.account;

            var shipmentIds = this.childShipmentData.map(function (shipment) {
                return shipment.residualShipmentId;
            }).filter(Boolean);

            if (shipmentIds.length === 0) {
                return;
            }

            this.AtmResidualService.getExistingUnfitDenominations(orderNo, shipmentIds, account).then(function (allExistingUnfitData) {
                if (allExistingUnfitData && allExistingUnfitData.length > 0) {
                    // Restore the unfit denomination values using business logic matching
                    _this12.restoreUnfitValues(allExistingUnfitData);
                }
            }).catch(function (err) {
                console.log('Error fetching existing unfit denominations:', err);
            });
        }
    }, {
        key: 'restoreUnfitValues',
        value: function restoreUnfitValues(existingUnfitData) {
            var _this13 = this;

            this.model.unfitTotalCashCounted = 0;

            if (this.model.depositRecord && this.model.depositRecord.denominations) {
                this.model.depositRecord.denominations.forEach(function (denom) {

                    var existingData = existingUnfitData.find(function (existing) {
                        return existing.denominationId === denom.id;
                    });
                    if (existingData) {
                        denom.totalCashCounted = existingData.amount;
                        var billCount = existingData.amount / existingData.faceValue;
                        denom.denomTotalCashCounted = billCount.toLocaleString();

                        denom.isInvalidAmount = billCount !== Math.floor(billCount);

                        _this13.model.unfitTotalCashCounted += existingData.amount;
                    } else {
                        denom.totalCashCounted = 0;
                        denom.denomTotalCashCounted = 0;
                        denom.isInvalidAmount = false;
                    }
                });
            }
            this.model.countedResidualTotalDisplay = (Number(this.model.countedResidualTotal) || 0) + (Number(this.model.unfitTotalCashCounted) || 0);
        }
    }, {
        key: 'isCODShipment',
        value: function isCODShipment() {
            return this.codFlags && this.codFlags.isPackable && this.codFlags.isCRVed;
        }
    }, {
        key: 'setCountRestrictionFromShipment',
        value: function setCountRestrictionFromShipment(shipmentRecord) {
            var enabled = !!(shipmentRecord && shipmentRecord.restrictCoinCountByShiptype && shipmentRecord.restrictCoinShiptypeId);
            this.countRestriction = {
                enabled: enabled,
                shiptypeId: enabled ? shipmentRecord.restrictCoinShiptypeId : null
            };
        }
    }, {
        key: 'isShiptypeCoinRestrictionEnabled',
        value: function isShiptypeCoinRestrictionEnabled() {
            return !!(this.countRestriction && this.countRestriction.enabled && this.countRestriction.shiptypeId);
        }
    }, {
        key: 'denomsDataUpdate',


        // update total counted by the total from deposit record
        value: function denomsDataUpdate(denomsData) {
            return this.model.depositRecord.denominations.map(function (item) {
                var denomRecord = denomsData.find(function (denom) {
                    return denom.denominationId === item.id;
                });
                var totalCounted = 0;
                var totalValue = 0;
                if (denomRecord) {
                    totalCounted = Number((denomRecord.amount / item.faceValue).toFixed(6));
                    totalValue = denomRecord.amount;
                }
                return (0, _extends3.default)({}, item, {
                    totalCounted: totalCounted,
                    totalValue: totalValue
                });
            });
        }

        // Commit residual shipment and Add entry to ledgerTransaction

    }, {
        key: 'commitResidualShipment',
        value: function commitResidualShipment() {
            var _this14 = this;

            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var addDeposit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var shipments = this.parentShipment;
            if (this.isCommit) return;
            if (!this.model.parentAtmResidual) return;
            this.isCommit = true;
            this.monthlySupId = null;

            var unfitTotal = this.model.unfitTotalCashCounted ? this.model.unfitTotalCashCounted : 0;
            var newAmount = (this.model.countedResidualTotal || 0) + unfitTotal;

            return this.getExpectedResidual().then(function () {
                _this14.checkMonthlyCountLimit(newAmount).then(function () {
                    var data = _this14.model.parentAtmResidual,
                        cashReturnedVault = _this14.model.expectedResidualToSend,
                        variance = _this14.model.varianceToSend,
                        orderType = data.orderType,
                        expectedResidual = _this14.model.expectedResidualToSend;

                    if (orderType == 'A' && (expectedResidual > 0 && _this14.model.expectedResidualTotal !== _this14.model.crvTotal || _this14.model.countedResidualTotalDisplay > 0)) {
                        _this14.confirmUpdateShipment() // user confirmation before update `shipment.orderType` (calling before residualCountCommit) 
                        .then(function (res) {
                            _this14.orderType = 'S';
                            return _this14.commit(index, data, cashReturnedVault, variance, shipments, addDeposit);
                        }).catch(function () {
                            _this14.isCommit = false;
                        });
                    } else {
                        return _this14.commit(index, data, cashReturnedVault, variance, shipments, addDeposit);
                    }
                }).catch(function () {
                    _this14.isCommit = false;
                });
            });
        }
    }, {
        key: 'commit',
        value: function commit(index, data, cashReturnedVault, variance, shipments) {
            var _this15 = this;

            var addDeposit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

            if (variance != 0) {
                this.Modal.residualComments(shipments, function (_ref) {
                    var modal = _ref.modal,
                        comments = _ref.comments;

                    _this15.residualCountCommit(comments, addDeposit);
                }, function (_ref2) {
                    var modal = _ref2.modal;

                    _this15.focusElementById('residual-commit');
                    if (modal) modal.close();
                    _this15.isCommit = false;
                });
            } else {
                // call if variance zero
                return this.residualCountCommit(null, addDeposit);
            }
        }
    }, {
        key: 'residualCountCommit',
        value: function residualCountCommit(comments) {
            var _this16 = this;

            var addDeposit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            // return this.getExpectedResidual().then(() => {
            var defer = this.$q.defer();
            var pickupDate = moment(this.pickupDate).format('YYYY-MM-DD');
            var pickupTime = moment(this.model.beginTime).format('HH:mm:ss');

            var unfitDenomsData = this.prepareUnfitDenominationsData();
            var unfitTotal = unfitDenomsData && this.model.unfitTotalCashCounted ? this.model.unfitTotalCashCounted : 0;
            var totalCountedResidual = this.model.countedResidualTotal + unfitTotal;

            var parentResidual = {
                trackingId: this.model.parentAtmResidual.trackingId,
                actualLoad: this.model.parentAtmResidual.denomActualLoad.split(",").join(''),
                cashReturnedVault: this.model.crvTotal,
                expectedResidual: this.model.parentAtmResidual.expectedResidual,
                countedResidual: totalCountedResidual,
                variance: this.model.varianceToSend,
                denominationId: this.model.parentAtmResidual.denominationId,
                faceValue: this.model.parentAtmResidual.faceValue,
                loadedAmount: this.model.parentAtmResidual.loadedAmount,
                atmResidualId: this.model.parentAtmResidual.atmResidualId,
                residualAmount: this.model.parentAtmResidual.residualAmount,
                comments: comments || this.atmResidualRecord.comment || '',
                notes: this.atmResidualRecord.notes || '',
                transferredAmount: 0,
                dispensedAmount: 0,
                account: this.model.parentAtmResidual.account,
                orderNo: this.model.parentAtmResidual.orderNo,
                manualPriorLoadAmount: this.model.parentAtmResidual.manualPriorLoadAmount,
                divertedAmount: this.model.parentAtmResidual && this.model.parentAtmResidual.divertedAmount != null ? this.model.parentAtmResidual.divertedAmount : null
            };

            this.checkSupervisorApproval(this.model.varianceTotal).then(function (supId) {
                // Array of children with necessary data
                var children = _this16.model.atmResidual.map(function (data, index) {

                    var divisor = (data.coinPackaging === 'ROLLED' || data.coinPackaging === 'INDIVIDUAL') && data.unitValue != null ? data.unitValue : data.faceValue;

                    // prevent division by zero
                    divisor = divisor || 1;

                    return {
                        trackingId: data.trackingId,
                        actualLoad: data.denomActualLoad.split(",").join(''),
                        cashReturnedVault: Number((data.crv / divisor).toFixed(4)),
                        expectedResidual: data.denomExpectedResidual.split(",").join(''),
                        countedResidual: data.denomCountedResidual.split(",").join(''),
                        variance: Number((data.variance / divisor).toFixed(4)),
                        denominationId: data.denominationId,
                        faceValue: data.faceValue,
                        loadedAmount: data.loadedAmount,
                        atmResidualId: data.atmResidualId,
                        residualAmount: data.residualAmount,
                        comments: comments || _this16.atmResidualRecord.comment || '',
                        notes: _this16.atmResidualRecord.notes || '',
                        transferredAmount: Number(((data.transferredAmount || 0) / divisor).toFixed(4)),
                        dispensedAmount: Number(((data.dispensedAmount || 0) / divisor).toFixed(4)),
                        supervisorId: supId,
                        manualPriorLoadAmount: data.manualPriorLoadAmount
                    };
                });

                if (!_this16.model.parentAtmResidual.finishedAt) {
                    var data = _this16.model.parentAtmResidual;
                    if (data.actualLoad === 0 && data.crv === data.requestLoad && data.countedResidual === data.requestLoad && !data.isDeliveryShipmentDeleted && !['T', 'P'].includes(data.orderType)) {
                        _this16.Modal.confirm({
                            header: _this16.$translate.instant('itemHolds.converttocrv'),
                            message: _this16.$translate.instant('atm_residual.convert_to_crv_msg'),
                            callback: function callback(_ref3) {
                                var modal = _ref3.modal;

                                _this16.convertToCrv(data, modal);
                                _this16.isCommit = false;
                            },
                            negative: function negative(_ref4) {
                                var modal = _ref4.modal;

                                modal.close();
                                _this16.isCommit = false;
                            },
                            buttons: ['itemHolds.converttocrv', 'common.cancel'],
                            type: 'success'
                        });
                        return;
                    }
                    // Make a single service call with children array and unfit denominations
                    _this16.AtmResidualService.ResidualCountCommit(_this16.model.locationId.Id, _this16.model.branch, pickupDate, pickupTime, _this16.branchTimeZone, _this16.model.loggedInUserId, children, parentResidual, supId, unfitDenomsData, _this16.monthlySupId, _this16.monthlyLimitDetails ? _this16.monthlyLimitDetails.monthlyCashCountLimitAmount : 0, _this16.monthlyLimitDetails ? _this16.monthlyLimitDetails.totalCountedThisMonth : 0, _this16.monthlyLimitDetails ? _this16.monthlyLimitDetails.newCountAmount : 0).then(function (data) {
                        _this16.successCount += data.successfulCommits;
                        _this16.bagCount();
                        if (addDeposit) {
                            return _this16.AtmResidualDepositService.createResidualDepositShipment(parentResidual.trackingId).then(function (depositShipment) {
                                _this16.updateData();
                                _this16.model.bagId = depositShipment.trackingId;
                                _this16.loadShipmentByTrackingId();
                                _this16.isCommit = false;
                                defer.resolve(data);
                            }).catch(function (err) {
                                _this16.updateData();
                                _this16.model.bagId = _this16.lastScanned;
                                _this16.loadShipmentByTrackingId();
                                _this16.isCommit = false;
                                var message = err && err.data && err.data.message ? err.data.message : err && err.message ? err.message : 'Unable to create the deposit shipment.';
                                _this16.Modal.errorModal(message);
                                defer.reject(err);
                            });
                        }

                        _this16.isCommit = false;
                        _this16.updateData();
                        _this16.model.bagId = _this16.lastScanned;
                        _this16.loadShipmentByTrackingId();
                        defer.resolve(data);
                    }).catch(function (err) {
                        _this16.isCommit = false;
                        if (err && err.data && err.data.message && err.data.message != "93751") {
                            _this16.Sound.PlayErrorBeep("#scanner_beep");
                            _this16.Modal.errorModal('error.' + err.data.message);
                        } else if (err && err.data && err.data.message && err.data.message == "93751") {
                            _this16.Sound.PlayErrorBeep("#scanner_beep");
                            var message = _this16.$translate.instant('error.' + err.data.message, {
                                amount: _this16.totalResidualAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            });
                            _this16.Modal.errorModal(message);
                        }
                        defer.reject(err);
                    });
                } else {
                    _this16.atmResidualRecord.comment = comments;
                    return _this16.residualCountEdit(children, parentResidual, comments, supId);
                }

                _this16.isPressExpectedResidualButton = true;
            }).catch(function (err) {
                _this16.isPressExpectedResidualButton = false;
                _this16.isCommit = false;
            });

            return defer.promise;
            // });
        }
    }, {
        key: 'confirmUpdateShipment',
        value: function confirmUpdateShipment() {
            var _this17 = this;

            // user confirmation before update `shipment.orderType`
            this.isCommit = true;

            var defer = this.$q.defer(),
                message = this.model.expectedResidualToSend > 0 && this.model.expectedResidualTotal !== this.model.crvTotal ? 'atm_residual.warning' : 'atm_residual.total_cash_count.warning';

            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_title'),
                message: this.$translate.instant(message),
                callback: function callback(_ref5) {
                    var modal = _ref5.modal,
                        $scope = _ref5.$scope;

                    _this17.isCommit = true;
                    _this17.updateOrderType() // call when confirmed
                    .then(function (data) {
                        _this17.isCommit = false;
                        defer.resolve(data);
                    }).catch(function (err) {
                        _this17.isCommit = false;
                        defer.reject(err);
                    });
                    modal.close();
                },
                negative: function negative(_ref6) {
                    var modal = _ref6.modal;

                    _this17.isCommit = false;
                    modal.close();
                },
                type: 'danger'
            });
            return defer.promise;
        }
    }, {
        key: 'updateOrderType',
        value: function updateOrderType() {
            var _this18 = this;

            // find matching reacords form ATMRESIDUAL and update `shipment.orderType` for both residual and load shipments
            var orderNo = this.atmResidualRecord.orderNo,
                deliveryShipmentId = this.atmResidualRecord.deliveryShipmentId,
                residualShipmentId = this.atmResidualRecord.residualShipmentId;
            var defer = this.$q.defer();
            this.AtmResidualService.findAtmResidualRecord(orderNo, deliveryShipmentId, residualShipmentId).then(function (data) {
                defer.resolve(data);
            }).catch(function (err) {
                _this18.isCommit = false;
                if (err && err.data && err.data.message) {
                    _this18.Modal.errorModal('error.' + err.data.message);
                }
                defer.reject(err);
            });
            return defer.promise;
        }
    }, {
        key: 'goToOrderHistory',
        value: function goToOrderHistory(data) {
            var isPending = !this.model.parentAtmResidual.packedFlag;
            var isCounted = this.model.parentAtmResidual.finishedAt;
            var fundingSourceId = this.model.locationId ? this.model.locationId.Id : null;
            this.Navigation.goToOrderHistory(this.atmResidualRecord.orderNo, this.model.vaultDate, true, isCounted, null, isPending, null, fundingSourceId);
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(data) {
            this.Navigation.goToServiceHistory(this.fromLocationId, null, true, null);
        }
    }, {
        key: 'calculateAmount',
        value: function calculateAmount(index) {
            var data = this.model.atmResidual[index]; // current child data
            var atmResidual = this.model.atmResidual[index];
            var parentData = this.model.parentAtmResidual; // parent data for comparison

            // Initialize child values, using 0 if undefined
            var expectedResidual = data.expectedResidual || 0;
            var requestLoad = data.requestLoad || 0;
            var actualLoad = data.actualLoad || 0;
            var countedResidual = data.countedResidual || 0;
            var madeCRV = data.madeCRV || 0;

            var transferredAmount = data.transferredAmount || 0;
            var dispensedAmount = data.dispensedAmount || 0;

            // Initialize parent values, using 0 if undefined
            var parentRequestLoad = parentData ? parentData.requestLoad || 0 : 0;
            var parentExpectedResidual = parentData ? parentData.expectedResidual || 0 : 0;
            var parentActualLoad = parentData ? parentData.actualLoad || 0 : 0;

            // Calculate for current child row (atmResidual) based on parent restrictions
            if (atmResidual.finishedAt && atmResidual.crv != null && !this.isEdit) {
                data.actualLoad = Number((requestLoad - atmResidual.crv).toFixed(4));
            } else if (atmResidual.finishedAt && data.actualLoad === "") {
                data.actualLoad = 0;
            } else {
                actualLoad = data.actualLoad || 0;
            }

            if (atmResidual.finishedAt && data.expectedResidual === "") {
                data.expectedResidual = 0;
            } else {
                expectedResidual = data.expectedResidual || 0;
            }

            var divisor = (atmResidual.coinPackaging === 'ROLLED' || atmResidual.coinPackaging === 'INDIVIDUAL') && atmResidual.unitValue ? atmResidual.unitValue : atmResidual.faceValue;

            divisor = divisor || 1;

            atmResidual.denomActualLoad = Number((actualLoad / divisor).toFixed(4)).toLocaleString();
            atmResidual.denomExpectedResidual = Number((expectedResidual / divisor).toFixed(4)).toLocaleString();
            atmResidual.denomCountedResidual = Number((countedResidual / divisor).toFixed(4)).toLocaleString();

            // Calculate CRV and variance
            var loadAmount = atmResidual.actualLoad || 0;
            var expectedResidualAmount = atmResidual.expectedResidual || 0;
            var countedResidualAmount = atmResidual.countedResidual || 0;
            var priorLoadAmount = atmResidual.actualPriorLoad || atmResidual.manualPriorLoadAmount || 0;

            if (atmResidual.finishedAt && atmResidual.crv != null && !this.isEdit) {
                atmResidual.crv;
            } else if (atmResidual.finishedAt && (atmResidual.crv === '' || atmResidual.crv === undefined) && !loadAmount) {
                atmResidual.crv = 0;
            } else {
                atmResidual.crv = Number((requestLoad - loadAmount).toFixed(4));
            }

            if (madeCRV) {
                atmResidual.variance = Number((atmResidual.crv - countedResidualAmount).toFixed(4));
            } else if (priorLoadAmount == 0 && atmResidual.crv === 0) {
                atmResidual.variance = 0;
            } else {
                atmResidual.variance = Number((countedResidualAmount - expectedResidualAmount).toFixed(4));
            }

            data.denomTransferredAmount = Number((transferredAmount / divisor).toFixed(4)).toLocaleString();
            data.denomDispensedAmount = Number((dispensedAmount / divisor).toFixed(4)).toLocaleString();
            // If all validations pass, reset error and update totals
            this.isError = false;
            this.totalAmount();
        }
    }, {
        key: 'calculateFromBillCount',
        value: function calculateFromBillCount(index, denomField, amountField) {
            var data = this.model.atmResidual[index];
            if (!data) return;

            var divisor = (data.coinPackaging === 'ROLLED' || data.coinPackaging === 'INDIVIDUAL') && data.unitValue ? data.unitValue : data.faceValue;
            divisor = divisor || 1;

            var countRaw = data[denomField];
            var count = countRaw ? Number(String(countRaw).split(",").join('')) : 0;

            data[amountField] = Number((count * divisor).toFixed(4));

            this.calculateAmount(index);

            var calculatedCount = Number((data[amountField] / divisor).toFixed(4));
            if (count === calculatedCount || countRaw === '' && calculatedCount === 0) {
                data[denomField] = countRaw;
            }
        }
    }, {
        key: 'setFocus',
        value: function setFocus(event) {
            this.focusElementById('residual-commit');
        }

        // Reset totalAmount

    }, {
        key: 'resetTotal',
        value: function resetTotal() {
            this.model.actualLoadTotal = 0;
            this.model.crvTotal = 0;
            this.model.expectedResidualTotal = 0;
            this.model.dispensedAmountTotal = 0;
            this.model.transferredAmountTotal = 0;
            this.model.countedResidualTotal = 0;
            this.model.varianceTotal = 0;
            this.shipmentLoading = false;
        }

        // Display sum of all cell value

    }, {
        key: 'totalAmount',
        value: function totalAmount() {
            var _this19 = this;

            this.model.actualLoadTotal = 0;
            this.model.crvTotal = 0;
            this.model.expectedResidualTotal = 0;
            this.model.countedResidualTotal = 0;
            this.model.dispensedAmountTotal = 0;
            this.model.transferredAmountTotal = 0;
            this.model.varianceTotal = 0;
            this.model.varianceToSend = 0;
            this.model.cashReturnedVaultToSend = 0;
            this.model.expectedResidualToSend = 0;

            this.model.atmResidual.forEach(function (residualRecord) {
                _this19.model.actualLoadTotal += residualRecord.actualLoad ? residualRecord.actualLoad : 0;
                _this19.model.crvTotal += residualRecord.crv ? residualRecord.crv : 0;
                _this19.model.expectedResidualTotal += residualRecord.expectedResidual ? residualRecord.expectedResidual : 0;
                _this19.model.countedResidualTotal += residualRecord.countedResidual ? residualRecord.countedResidual : 0;
                _this19.model.dispensedAmountTotal += residualRecord.dispensedAmount ? residualRecord.dispensedAmount : 0;
                _this19.model.transferredAmountTotal += residualRecord.transferredAmount ? residualRecord.transferredAmount : 0;
                _this19.model.varianceTotal += residualRecord.variance ? residualRecord.variance : 0;
                _this19.model.expectedResidualToSend += Number(residualRecord.denomExpectedResidual.split(",").join(''));

                var divisor = (residualRecord.coinPackaging === 'ROLLED' || residualRecord.coinPackaging === 'INDIVIDUAL') && residualRecord.unitValue ? residualRecord.unitValue : residualRecord.faceValue;

                // prevent division by zero in case of bad data
                divisor = divisor || 1;

                _this19.model.cashReturnedVaultToSend += Number((residualRecord.crv / divisor).toFixed(4));
                _this19.model.varianceToSend += Number((residualRecord.variance / divisor).toFixed(4));
            });

            if (this.model.parentAtmResidual) this.model.parentAtmResidual.actualLoad = this.model.actualLoadTotal;
            if (this.model.parentAtmResidual) this.model.parentAtmResidual.crv = this.model.crvTotal;
            this.model.countedResidualTotalDisplay = (Number(this.model.countedResidualTotal) || 0) + (Number(this.model.unfitTotalCashCounted) || 0);
        }
    }, {
        key: 'commitDisabled',
        value: function commitDisabled(index) {
            var shouldDisabled = false;
            var isValidPriorLoadAmount = false;
            var totalValidActualLoad = 0,
                totalValidCountedResidual = 0,
                totalValidExpectedResidual = 0;

            for (var i = 0; i < this.model.atmResidual.length; i++) {
                var data = this.model.atmResidual[i];
                var isWrong = this.validateResidualData(data);
                if (isWrong) shouldDisabled = true;

                totalValidActualLoad += Number(data.actualLoad) || 0;
                totalValidCountedResidual += Number(data.countedResidual) || 0;
                totalValidExpectedResidual += Number(data.expectedResidual) || 0;
            }

            totalValidActualLoad = Number(totalValidActualLoad.toFixed(4));
            totalValidCountedResidual = Number(totalValidCountedResidual.toFixed(4));
            totalValidExpectedResidual = Number(totalValidExpectedResidual.toFixed(4));

            if (this.hasUnfitDenoms() && this.shiptype === 'residual') {
                var unfitValidationFailed = this.validateUnfitDenominations();
                if (unfitValidationFailed) shouldDisabled = true;
            }

            if (this.expectedResidualDetails && this.expectedResidualDetails.length > 0) {
                isValidPriorLoadAmount = this.expectedResidualDetails.some(function (d) {
                    return !d.isValidAmount && d.manualPriorLoadAmount >= 0;
                });
            }

            var parentActualLoad = this.model.parentAtmResidual.actualLoad != null ? Number(Number(this.model.parentAtmResidual.actualLoad).toFixed(4)) : 0;

            if (this.model.parentAtmResidual.actualLoad == null || parentActualLoad < totalValidActualLoad) {
                shouldDisabled = true;
            }

            return shouldDisabled || isValidPriorLoadAmount;
        }
    }, {
        key: 'isActualLoadExceedsRequestLoad',
        value: function isActualLoadExceedsRequestLoad(data) {
            if (data && data.actualLoad !== "" && data.actualLoad != null && data.requestLoad !== "" && data.requestLoad != null) {
                return Number(data.actualLoad) > Number(data.requestLoad);
            }
            return false;
        }
    }, {
        key: 'validateResidualData',
        value: function validateResidualData(data) {
            var countPattern = /^([0-9][0-9 _ ,]*)?(\.[0-9]+)?$/;
            var amountPattern = /^-?([0-9][0-9 _ ,]*)?(\.[0-9]+)?$/;

            var isValidActualLoad = countPattern.test(data.denomActualLoad !== null && data.denomActualLoad !== undefined ? String(data.denomActualLoad) : "invalid"),
                isValidExpectedResidual = countPattern.test(data.denomExpectedResidual !== null && data.denomExpectedResidual !== undefined ? String(data.denomExpectedResidual) : "invalid"),
                isValidCountedResidual = countPattern.test(data.denomCountedResidual !== null && data.denomCountedResidual !== undefined ? String(data.denomCountedResidual) : "invalid"),
                isValidTransferredAmount = countPattern.test(data.denomTransferredAmount !== null && data.denomTransferredAmount !== undefined ? String(data.denomTransferredAmount) : "invalid"),
                isValidDispensedAmount = countPattern.test(data.denomDispensedAmount !== null && data.denomDispensedAmount !== undefined ? String(data.denomDispensedAmount) : "invalid"),
                isValidCRV = amountPattern.test(data.crv !== null && data.crv !== undefined ? String(data.crv) : "invalid");

            var isDisabled = data.actualLoad !== "" && data.actualLoad >= 0 && data.countedResidual !== "" && data.countedResidual >= 0 && data.expectedResidual !== "" && data.expectedResidual >= 0 || 'isEmpty';

            var isWrong = isDisabled === 'isEmpty' || isValidActualLoad === false || isValidExpectedResidual === false || isValidCountedResidual === false || isValidCRV === false || data.isLoadShipmentIsOnHold || !this.pickupDate || !this.model.beginTime || isValidTransferredAmount === false || isValidDispensedAmount === false || this.isActualLoadExceedsRequestLoad(data) || data.transferredAmount === undefined || data.dispensedAmount === undefined;

            return isWrong;
        }
    }, {
        key: 'validateUnfitDenominations',
        value: function validateUnfitDenominations() {
            var unfitDenoms = this.getViewUnfitDenominations();
            var hasValidationErrors = false;

            // Pattern to validate whole numbers only (no decimals)
            var wholeNumberPattern = /^[0-9]\d*(\,\d+)?$/;

            unfitDenoms.forEach(function (denom) {
                var amount = Number(denom.totalCashCounted) || 0;
                var faceValue = Number(denom.faceValue) || 0;

                // Skip validation if amount is 0 or empty
                if (amount === 0) return;

                if (faceValue > 0) {
                    var billCount = amount / faceValue;
                    var billCountString = billCount.toLocaleString();

                    // Validate that the bill count is a whole number
                    if (!wholeNumberPattern.test(billCountString) || billCount !== Math.floor(billCount)) {
                        hasValidationErrors = true;
                    }
                }
            });

            return hasValidationErrors;
        }
    }, {
        key: 'expectedResidualDisabled',
        value: function expectedResidualDisabled(index) {
            var shouldDisabled = false;
            var totalValidActualLoad = 0,
                totalValidCountedResidual = 0,
                totalValidExpectedResidual = 0;
            for (var i = 0; i < this.model.atmResidual.length; i++) {
                var data = this.model.atmResidual[i];
                var isWrong = this.expectedResidualData(data);
                if (isWrong) shouldDisabled = true;
                totalValidActualLoad += Number(data.actualLoad);
                totalValidCountedResidual += Number(data.countedResidual);
                totalValidExpectedResidual += Number(data.expectedResidual);
            }
            return shouldDisabled;
        }
    }, {
        key: 'expectedResidualData',
        value: function expectedResidualData(data) {
            var patterns = /^-?\d+$/,
                isValidActualLoad = patterns.test(data.denomActualLoad),
                isValidExpectedResidual = patterns.test(data.denomExpectedResidual),
                isValidCountedResidual = patterns.test(data.denomCountedResidual),
                isValidTransferredAmount = patterns.test(data.denomTransferredAmount),
                isValidDispensedAmount = patterns.test(data.denomDispensedAmount),
                isValidCRV = patterns.test(data.crv);

            var isDisabled = data.actualLoad !== "" && data.actualLoad !== undefined && data.actualLoad !== null && data.countedResidual !== "" && data.countedResidual !== undefined && data.countedResidual !== null
            // && data.expectedResidual !== "" && data.expectedResidual !== undefined && data.expectedResidual !== null
            || 'isEmpty';

            var isWrong = isDisabled === 'isEmpty' || isValidActualLoad === false || isValidExpectedResidual === false || isValidCountedResidual === false || isValidCRV === false || data.isLoadShipmentIsOnHold || !this.pickupDate || !this.model.beginTime || isValidTransferredAmount === false || isValidDispensedAmount === false;

            return isWrong;
        }

        // Make cells nonEditable if bagId not match with trackingId

    }, {
        key: 'disableRow',
        value: function disableRow(index) {
            var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (this.lastScanned) {
                return this.model.parentAtmResidual.trackingId.toUpperCase() !== this.lastScanned.toUpperCase() || this.model.parentAtmResidual.finishedAt;
            }
            return false;
        }

        // Hide commint button if bagId not match with trackingId

    }, {
        key: 'showCommit',
        value: function showCommit(index) {
            if (this.lastScanned) return this.model.atmResidual[index].trackingId.toUpperCase() === this.lastScanned.toUpperCase();
        }

        // get residual bag counts 

    }, {
        key: 'bagCount',
        value: function bagCount(focusTrackingId) {
            var _this20 = this;

            if (!this.model.locationId) {
                return this.shipmentData = [];
            }
            return this.AtmResidualService.getResidualBagCount(this.model.locationId.Id, this.model.branch).then(function (data) {
                _this20.remainingResiduals = data;
                _this20.remainingResidualBag = data.result.length;
                _this20.model.depositRecord.denominations = _this20.allDenominations.filter(function (o) {
                    return o.currencyId === _this20.model.locationId.currencyId;
                });
                _this20.setCurrencySymbol();
                if (focusTrackingId) _this20.focusElementById('trackingId');
            }).catch(function (err) {
                console.log(err);
            });
        }

        // show remaining residual shipment to be counted

    }, {
        key: 'residualBag',
        value: function residualBag() {
            var _this21 = this;

            this.Modal.remainingResiduals(this.remainingResiduals, this.model.locationId, this.model.branch, function (_ref7) {
                var modal = _ref7.modal,
                    trackingId = _ref7.trackingId;

                _this21.model.bagId = trackingId;
                _this21.loadShipmentByTrackingId();
                modal.close();
            }, function (_ref8) {
                var modal = _ref8.modal;

                modal.close();
            });
        }
    }, {
        key: 'getOrderType',
        value: function getOrderType(type) {
            switch (type) {
                case type:
                    return this.$translate.instant('atm_residual.order_type_' + type);
                default:
                    return '';
            }
        }
    }, {
        key: 'scanSuffix',
        value: function scanSuffix() {
            if (this.enterSuffix.length > 0 && this.model.bagId.endsWith(this.enterSuffix)) {
                var bagIdLength = this.model.bagId.length;
                this.model.bagId = this.model.bagId.slice(0, bagIdLength - this.enterSuffix.length);
            }
        }

        // Load shipments based on orderNo

    }, {
        key: 'loadShipments',
        value: function loadShipments() {
            var _this22 = this;

            if (this.shipmentLoading || !this.model.locationId) return;
            this.successCount = 0;
            this.finishedAt = null;
            this.expectedResidualDetails = [];
            this.isEdit = false;

            if (this.model.bagId === undefined) {
                return this.shipmentData = [];
            }
            this.shipmentLoading = true;
            this.model.requestLoadTotal = 0;
            this.lastScanned = this.model.bagId;
            this.AtmResidualService.getResidualShipments(this.model.bagId, this.model.locationId.Value).then(function (data) {
                // Initialize/reset variables
                _this22.model.atmResidual = [];
                _this22.model.parentAtmResidual = null;
                _this22.parentShipment = null;
                _this22.isError = false;
                _this22.shipmentData = data;

                // Separate parent and child shipments
                _this22.childShipmentData = data.filter(function (d) {
                    return d.bagSeal !== null;
                });
                var parentShipments = data.filter(function (d) {
                    return d.bagSeal === null;
                });

                // Map parent shipment if exists
                if (parentShipments && parentShipments.length > 0) {
                    _this22.parentShipment = parentShipments[0];
                    _this22.fromLocationId = _this22.parentShipment.fromLocationId;
                    _this22.orderType = _this22.parentShipment.orderType;
                    _this22.model.parentAtmResidual = _this22.mapShipmentToModel(_this22.parentShipment, true);
                    _this22.findShipmentToCommit(_this22.parentShipment, 0);
                    _this22.model.parentAtmResidual.parentStatedAmount = _this22.parentShipment && _this22.parentShipment.amount ? _this22.parentShipment.amount : 0;
                }

                // Map each child shipment
                _this22.childShipmentData.forEach(function (data, index) {
                    var mappedShipment = _this22.mapShipmentToModel(data);
                    _this22.model.atmResidual[index] = mappedShipment;
                    _this22.model.requestLoadTotal += mappedShipment.requestLoad;
                    _this22.originalCountAmount += parseFloat(data.amountCounted) || 0;

                    _this22.fromLocationId = data.fromLocationId;
                    _this22.fromLocationName = data.fromLocationName;
                    _this22.isEmergencyType = data.isEC;
                    _this22.isLoadShipmentIsOnHold = data.isLoadShipmentIsOnHold;

                    _this22.finishedAt = mappedShipment.finishedAt;
                    if (_this22.finishedAt) _this22.isEdit = false;
                    if (data.notes) _this22.atmResidualRecord.notes = data.notes;

                    _this22.calculateAmount(index);
                });
                _this22.calculateAmountForParent();
            }).then(function () {
                _this22.resetTotal();
            }).then(function () {
                _this22.totalAmount();
                if (_this22.shipmentData.length) return _this22.focusElementById('counted-residual');
            }).then(function () {
                if (_this22.locationData) {
                    _this22.locationData.isRedirected = false;
                    _this22.locationData = _this22.DataCounter.setData();
                }
                _this22.validateResidualCountEdit();
                _this22.model.cloneAtmResidual = _.cloneDeep(_this22.model.atmResidual);
                _this22.initializeUnfitDenominations();
                _this22.restorePreviousUnfitDenominations();
            }).then(function () {
                return _this22.getExpectedResidual();
            }).catch(function (err) {
                _this22.shipmentLoading = false;
                console.log(err);
                _this22.Modal.errorModal(err.data.message);
            });
        }
    }, {
        key: 'checkMonthlyCountLimit',
        value: function checkMonthlyCountLimit(newAmount) {
            var _this23 = this;

            var shiptype = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.shiptype;

            var deferred = this.$q.defer();

            var locId = this.fromLocationId;
            if (!locId) {
                deferred.resolve();
                return deferred.promise;
            }

            // Determine if this is an edit and get the corresponding shipment's vault date
            var isEdit = false;
            var type = (shiptype || '').toLowerCase();
            if (type === 'deposit' || type === 'cod' || type === 'bulkcash') {
                isEdit = this.showEditDepositButton() || !!this.isEdit;
            } else if (type === 'bulkdeposit') {
                isEdit = !!(this.activeBagData && (this.activeBagData.isEditMode || this.activeBagData.bagIndex !== null && this.canEditBag(this.activeBagData.bagIndex)));
            } else if (type === 'residual' || type === 'c') {
                isEdit = !!(this.shipmentData.length && this.model.locationId && this.hasACL['atm_count'] && this.hasACL['atm_count']['editCommitted'] && this.finishedAt) || !!this.isEdit;
            }

            // Delta Calculation: Pass the difference during edit, otherwise pass full newAmount for first-time count.
            var deltaAmount = isEdit ? newAmount - (this.originalCountAmount || 0) : newAmount;

            // Determine the month: prioritize the branch's global vault date
            var activeVaultDate = this.model.vaultDate;
            var monthName = activeVaultDate ? moment(activeVaultDate).format('MMMM') : moment().format('MMMM');

            this.AtmResidualDepositService.getMonthlyCountCheck(locId, deltaAmount, this.model.branch, monthName, shiptype).then(function (result) {
                if (result && result.wouldExceed) {
                    var sym = _this23.currencySymbol || '$';
                    var fmt = function fmt(v) {
                        return sym + Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    };
                    var limitAmt = result.monthlyCashCountLimitAmount;
                    var counted = result.totalCountedThisMonth;
                    var current = result.newCountAmount;
                    var newTotal = counted + current;
                    var exceedBy = newTotal - limitAmt;

                    _this23.monthlyLimitDetails = {
                        monthlyCashCountLimitAmount: limitAmt,
                        totalCountedThisMonth: counted,
                        newCountAmount: current
                    };

                    _this23.Modal.confirm({
                        header: 'Monthly Cash Count Limit Exceeded',
                        message: '\n                            <div style="line-height:1.8">\n                                <p>Count will Exceed Monthly Count Threshold. Do you Wish to Proceed?</p>\n                            </div>',
                        callback: function callback(_ref9) {
                            var modal = _ref9.modal;

                            if (modal) modal.close();
                            _this23.Modal.confirmSupervisor('monthly-cash-count-limit-exceeded', null, function (_ref10) {
                                var supModal = _ref10.modal,
                                    supId = _ref10.supId;

                                if (supModal) supModal.close();
                                _this23.monthlySupId = supId;
                                deferred.resolve(supId);
                            }, function (_ref11) {
                                var supModal = _ref11.modal;

                                if (supModal) supModal.close();
                                deferred.reject();
                            }, 'modal-top-offset');
                        },
                        negative: function negative(_ref12) {
                            var modal = _ref12.modal;

                            if (modal) modal.close();
                            deferred.reject();
                        },
                        buttons: ['common.ok', 'common.cancel'],
                        type: 'success'
                    });
                } else {
                    deferred.resolve();
                }
            }).catch(function (err) {
                console.error("Monthly Count Check failed:", err);
                deferred.resolve();
            });

            return deferred.promise;
        }
    }, {
        key: 'commitDeposit',
        value: function commitDeposit() {
            var _this24 = this;

            this.isCommit = true;
            this.monthlySupId = null;

            var newAmount = this.model.depositRecord.totalAmount || 0;
            this.checkMonthlyCountLimit(newAmount).then(function () {
                var countedVariance = _this24.model.depositRecord.countedVariance || 0;
                if (countedVariance !== 0) {
                    _this24.Modal.residualComments({ trackingId: _this24.model.bagId }, function (_ref13) {
                        var modal = _ref13.modal,
                            comments = _ref13.comments;

                        _this24._executeDepositCommit(comments);
                    }, function (_ref14) {
                        var modal = _ref14.modal;

                        _this24.isCommit = false;
                        modal.close();
                    });
                } else {
                    _this24._executeDepositCommit(null);
                }
            }).catch(function () {
                _this24.isCommit = false;
            });
        }
    }, {
        key: '_executeDepositCommit',
        value: function _executeDepositCommit(comment) {
            var _this25 = this;

            var denomsData = this.model.depositRecord.denominations.map(function (denom, _) {
                return {
                    denominationId: denom.id,
                    quantity: Number(denom.totalCounted)
                };
            });

            var fundingSource = this.model.locationId.Id,
                trackingId = this.model.bagId,
                branchId = this.model.branch,
                pickupDate = moment(this.pickupDate).format('YYYY-MM-DD'),
                pickupTime = moment(this.model.beginTime).format('HH:mm:ss'),
                branchTimeZone = this.branchTimeZone,
                countedByUserId = this.model.loggedInUserId,
                declaredTotalAmount = this.model.depositRecord.declaredTotalAmount,
                countedVariance = this.model.depositRecord.countedVariance;

            this.checkSupervisorApproval(countedVariance).then(function (supId) {
                var hasExistingDepositRecord = _this25.model.depositRecord && _this25.model.depositRecord.depositRecord && _this25.model.depositRecord.depositRecord.id;
                var isEditOperation = hasExistingDepositRecord || _this25.finishedAt || _this25.isEdit && hasExistingDepositRecord || _this25.successCount > 0;

                if (isEditOperation && hasExistingDepositRecord) {
                    // Use edit API when there's an existing deposit record
                    _this25.AtmResidualDepositService.editDepositCount(fundingSource, trackingId, comment, denomsData, branchId, pickupDate, pickupTime, branchTimeZone, countedByUserId, _this25.model.depositRecord.depositRecord.id, declaredTotalAmount, countedVariance, supId, _this25.browserTimezone, _this25.monthlySupId, _this25.monthlyLimitDetails ? _this25.monthlyLimitDetails.monthlyCashCountLimitAmount : 0, _this25.monthlyLimitDetails ? _this25.monthlyLimitDetails.totalCountedThisMonth : 0, _this25.monthlyLimitDetails ? _this25.monthlyLimitDetails.newCountAmount : 0, _this25.model.depositRecord.notes || null).then(function (data) {
                        _this25.model.depositRecord.previousDenominations = _.cloneDeep(_this25.model.depositRecord.denominations);
                        _this25.isCommit = false;
                        _this25.isEdit = false;
                        _this25.loadDepositShipment();
                        _this25.updateDepositData(data);
                        _this25.validateDepositCountEdit();
                    }).catch(function (err) {
                        _this25.isCommit = false;
                        if (err && err.data && err.data.message) {
                            _this25.Sound.PlayErrorBeep("#scanner_beep");
                            var raw = String(err.data.message || '');
                            if (raw.startsWith('E_NEGATIVE_FINAL_LEDGER|')) {
                                var csv = raw.split('|')[1] || '';
                                var text = 'This change would make the ledger balance negative for (' + csv + ').';
                                _this25.Modal.errorModal(text);
                            } else {
                                _this25.Modal.errorModal('error.' + raw);
                            }
                        }
                    });
                } else {
                    _this25.AtmResidualDepositService.commitDepositCount(fundingSource, trackingId, comment, denomsData, branchId, pickupDate, pickupTime, branchTimeZone, countedByUserId, declaredTotalAmount, countedVariance, supId, _this25.browserTimezone, _this25.monthlySupId, _this25.monthlyLimitDetails ? _this25.monthlyLimitDetails.monthlyCashCountLimitAmount : 0, _this25.monthlyLimitDetails ? _this25.monthlyLimitDetails.totalCountedThisMonth : 0, _this25.monthlyLimitDetails ? _this25.monthlyLimitDetails.newCountAmount : 0, _this25.model.depositRecord.notes || null).then(function (data) {
                        _this25.isCommit = false;
                        _this25.isEdit = false;
                        _this25.successCount++;
                        _this25.updateDepositData(data);
                        _this25.validateDepositCountEdit();
                        _this25.model.bagId = _this25.lastScanned;
                        if (_this25.isCODShipment()) {
                            _this25.bagCount();
                            return _this25.loadDepositShipment();
                        }
                        _this25.bagCount();
                        _this25.loadShipmentByTrackingId();
                    }).catch(function (err) {
                        _this25.isCommit = false;
                        if (err && err.data && err.data.message) {
                            _this25.Sound.PlayErrorBeep("#scanner_beep");
                            var raw = String(err.data.message || '');
                            if (raw.startsWith('E_NEGATIVE_FINAL_LEDGER|')) {
                                var csv = raw.split('|')[1] || '';
                                var text = 'This change would make the ledger balance negative for (' + csv + ').';
                                _this25.Modal.errorModal(text);
                            } else {
                                _this25.Modal.errorModal('error.' + raw);
                            }
                        }
                    });
                }
            }).catch(function (err) {
                _this25.isCommit = false;
            });
        }
    }, {
        key: 'checkSupervisorApproval',
        value: function checkSupervisorApproval(conditionValue) {
            var deferred = this.$q.defer();

            if (this.model.locationId && this.model.locationId.varianceCheckEnabled && Math.abs(conditionValue) > this.model.locationId.varianceThreshold) {
                this.Modal.confirmSupervisor('variance-threshold-exceeded', null, function (_ref15) {
                    var modal = _ref15.modal,
                        supId = _ref15.supId;

                    modal.close();
                    deferred.resolve(supId);
                }, function (_ref16) {
                    var modal = _ref16.modal;

                    modal.close();
                    deferred.reject();
                });
            } else {
                deferred.resolve(this.monthlySupId || null);
            }

            return deferred.promise;
        }
    }, {
        key: 'resetDepositCommit',
        value: function resetDepositCommit() {
            this.model.depositRecord.depositRecord = null;
            var denominations = this.model.depositRecord.denominations.map(function (denom) {
                return (0, _extends3.default)({}, denom, {
                    totalCounted: 0,
                    totalValue: 0
                });
            });

            this.model.depositRecord.denominations = denominations;
            this.model.depositRecord.totalAmount = 0;
            this.model.depositRecord.countedVariance = 0;
            this.model.depositRecord.declaredTotalAmount = 0;
            this.model.depositRecord.notes = '';
            this.model.depositRecord.previousNotes = '';
        }
    }, {
        key: 'loadShipmentByTrackingId',
        value: function loadShipmentByTrackingId() {
            var _this26 = this;

            if (this.shipmentLoading || !this.model.locationId || !this.model.bagId) return;
            this.shipmentLoading = true;
            this.lastScanned = this.model.bagId;
            this.finishedAt = null;
            this.successCount = 0;
            this.fromLocationId = null;
            this.fromLocationName = null;
            this.originalCountAmount = 0;

            var fundingSourceId = this.model.locationId ? this.model.locationId.Id : null;
            this.ShipmentService.updateShipmentCountStatus(this.model.bagId, this.model.locationId.Value, fundingSourceId).then(function (data) {
                _this26.shipmentLoading = false;

                if (data && data.pickupFlag === true) {
                    if (data.shiptypeId === 'C') {
                        _this26.isBagout = false;
                        _this26.shiptype = 'residual';
                        _this26.isBulkDeposit = false;
                        _this26.resetBulkDepositData();
                        _this26.loadShipments();
                    } else if (data.shiptypeId === 'BULKDEPOSIT') {
                        _this26.isBagout = false;
                        _this26.shiptype = 'bulkdeposit';
                        _this26.isBulkDeposit = true;
                        _this26.loadBulkDepositShipment();
                    } else {
                        _this26.isBagout = false;
                        _this26.shiptype = 'deposit';
                        _this26.isBulkDeposit = false;
                        _this26.resetBulkDepositData();
                        _this26.loadDepositShipment();
                    }
                }
                if (data && data.isBagout === true && data.deleted == false) {
                    _this26.isBagout = true;
                    _this26.isBulkDeposit = false;
                    _this26.resetBulkDepositData();
                    _this26.loadBagoutcontent();
                }
                _this26.toggleTab();
            }).catch(function (err) {
                _this26.model.depositRecord.depositShipment = null;
                _this26.shipmentData = [];
                _this26.shipmentLoading = false;
                _this26.isBagout = false;

                if (err.data && err.data.message && err.data.message.startsWith('COUNTING_ORDER_VIOLATION:')) {
                    var requiredTrackingId = err.data.message.split(':')[1];
                    _this26.Modal.errorModal('Please count ' + requiredTrackingId + ' first.');
                } else {
                    _this26.Modal.errorModal("error." + err.data.message);
                }
            }).finally(function () {
                _this26.isPressExpectedResidualButton = false;
            });
        }
    }, {
        key: 'loadBagoutcontent',
        value: function loadBagoutcontent() {
            var _this27 = this;

            setTimeout(function () {
                _this27.Modal.verifyBagoutCashCount(_this27.model.bagId, _this27.model.locationId.Id, _this27.model.branch, function (_ref17) {
                    var modal = _ref17.modal;

                    _this27.bagCount();
                }, function (_ref18) {
                    var modal = _ref18.modal;

                    modal.close();
                });
            }, 300);
        }
    }, {
        key: 'loadDepositShipment',
        value: function loadDepositShipment() {
            var _this28 = this;

            if (this.shipmentLoading || !this.model.locationId || !this.model.bagId) return;
            this.shipmentLoading = true;
            this.lastScanned = this.model.bagId;
            this.finishedAt = null;

            this.AtmResidualDepositService.getDepositShipmentRecord(this.model.bagId, this.model.locationId.Value).then(function (data) {
                _this28.shipmentLoading = false;
                _this28.fromLocationId = data.shipmentRecord.fromLocationId;
                _this28.fromLocationName = data.shipmentRecord.fromLocation.name;
                _this28.model.depositRecord.depositShipment = data.shipmentRecord;
                _this28.model.depositRecord.depositRecord = data.depositRecord;
                _this28.model.depositRecord.statedTotalAmount = data.shipmentRecord.amount || 0;

                _this28.codFlags = {
                    isPackable: data.shipmentRecord.isPackable || false,
                    isCRVed: data.shipmentRecord.isCRVed || false,
                    includedDenominationIds: data.shipmentRecord.includedDenominationIds || []
                };
                _this28.setCountRestrictionFromShipment(data.shipmentRecord);
                if (data.depositRecord) {
                    _this28.originalCountAmount = data.depositRecord.totalAmount || 0;
                    _this28.finishedAt = data.depositRecord.countedAt;
                    _this28.isEdit = false;
                    _this28.pickupDateTime(data.depositRecord.pickupDate);
                    _this28.model.depositRecord.countedVariance = data.depositRecord.countedVariance || 0;
                    _this28.model.depositRecord.declaredTotalAmount = data.depositRecord.declaredTotalAmount;
                    _this28.model.depositRecord.totalVariance = data.depositRecord.totalVariance || 0;
                    _this28.model.depositRecord.denominations = _this28.denomsDataUpdate(data.depositRecord.denominations);
                    _this28.model.depositRecord.previousDenominations = _.cloneDeep(_this28.model.depositRecord.denominations);
                    _this28.model.depositRecord.notes = data.depositRecord.notes || '';
                    _this28.model.depositRecord.previousNotes = _this28.model.depositRecord.notes;
                    _this28.isBulkCash = false;
                } else if (data.shipmentRecord && data.shipmentRecord.countCompletedAt && data.shipmentRecord.shiptypeId === 'BULKCASH') {
                    _this28.finishedAt = data.shipmentRecord.countCompletedAt;
                    _this28.isEdit = false;
                    _this28.isBulkCash = true;
                    _this28.resetDepositCommit();
                    _this28.pickupDateTime(data.shipmentRecord.pickupDate);
                } else {
                    _this28.isEdit = true;
                    _this28.resetDepositCommit();
                }
                _this28.depositCountTotal();
                _this28.pickupDateTime(data.shipmentRecord.pickupDate);
                _this28.model.depositRecord.totalDeposit = data.shipmentRecord.amount || 0;
                _this28.validateDepositCountEdit();
            }).catch(function (err) {
                console.error(err);
                if (err.data.message) _this28.Modal.errorModal(err.data.message);
                _this28.shipmentLoading = false;
            });
        }
    }, {
        key: 'updateDepositData',
        value: function updateDepositData() {
            this.finishedAt = moment().format('MM-DD-YYYY | h:mm A');
            this.model.bagId = "";
            this.isEdit = false;
            this.model.depositRecord.previousNotes = this.model.depositRecord.notes || '';
            this.focusElementById('trackingId');
        }
    }, {
        key: 'validateDepositCountEdit',
        value: function validateDepositCountEdit() {
            var _this29 = this;

            this.isSameVaultDate = true;
            return this.AtmResidualService.getVaultDate(this.model.branch, this.lastScanned).then(function (data) {
                var shipmentVaultDate = new Date(data.shipmentVaultDate);
                var branchCurrentVaultDate = new Date(data.branchCurrentVaultDate);
                if (_this29.model.locationId && !_this29.model.locationId.EditCountAnytime) _this29.isSameVaultDate = shipmentVaultDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();else if (_this29.model.locationId && _this29.model.locationId.EditCountAnytime) _this29.isSameVaultDate = true;
                if (_this29.isBulkCash) {
                    _this29.allowBulkCashEdit = shipmentVaultDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();
                }
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'showDepositCommit',
        value: function showDepositCommit() {
            if (this.lastScanned) return this.model.depositRecord.depositShipment.trackingId.toUpperCase() === this.lastScanned.toUpperCase();
        }
        // find matching records 

    }, {
        key: 'findShipmentToCommit',
        value: function findShipmentToCommit(shipmentData, index) {
            if (this.model.parentAtmResidual.trackingId.toUpperCase() == this.lastScanned.toUpperCase()) {
                this.atmResidualRecord = {
                    deliveryShipmentId: shipmentData.deliveryShipmentId,
                    residualShipmentId: shipmentData.residualShipmentId,
                    orderNo: shipmentData.orderNo,
                    comment: shipmentData.comment,
                    notes: shipmentData.notes || ''
                };
                this.pickupDateTime(shipmentData.pickupDate);
            }
        }
    }, {
        key: 'mapShipmentToModel',
        value: function mapShipmentToModel(shipmentData) {
            var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return {
                requestLoad: shipmentData.amountLoadRequested,
                actualLoad: this.validateActualLoad(shipmentData),
                crv: shipmentData.amountCRV >= 0 ? shipmentData.amountCRV : '',
                expectedResidual: this.validateExpectedResidual(shipmentData),
                countedResidual: this.validateCountedResidual(shipmentData),
                variance: '',
                denomActualLoad: '',
                denomExpectedResidual: '',
                denomCountedResidual: '',
                faceValue: shipmentData.faceValue !== null ? shipmentData.faceValue : 1,
                coinFlag: shipmentData.coinFlag,
                trackingId: shipmentData.trackingId,
                finishedAt: shipmentData.finishedAt ? moment(shipmentData.finishedAt).format('MM-DD-YYYY | h:mm A') : '',
                remaining: shipmentData.finishedAt ? this.successCount++ : 0,
                currencyIcon: shipmentData.currencyId,
                denominationId: shipmentData.denominationId,
                denominationSymbol: shipmentData.denominationSymbol,
                comments: '',
                notes: shipmentData.notes || '',
                orderType: shipmentData.orderType,
                isEC: shipmentData.isEC,
                isLoadShipmentIsOnHold: shipmentData.isLoadShipmentIsOnHold,
                loadedAmount: shipmentData.loadedAmount,
                atmResidualId: shipmentData.atmResidualId,
                residualAmount: shipmentData.amount,
                branchId: shipmentData.branchId,
                routeId: shipmentData.routeId,
                vaultDate: moment.utc(shipmentData.vaultDate).format('MM-DD-YYYY'),
                toLocation: shipmentData.toLocation,
                fromLocation: shipmentData.fromLocation,
                isDeliveryShipmentDeleted: shipmentData.isDeliveryShipmentDeleted,
                isParent: isParent, // Adding a flag to identify if it's a parent shipment
                transferredAmount: shipmentData.transferredAmount || 0,
                dispensedAmount: shipmentData.dispensedAmount || 0,
                denomTransferredAmount: '',
                denomDispensedAmount: '',
                account: shipmentData.isEC ? 'emergency' : 'regular',
                orderNo: shipmentData.orderNo,
                madeCRV: shipmentData.madeCRV || 0,
                divertedAmount: shipmentData.divertedAmount !== undefined ? shipmentData.divertedAmount : null,
                unitValue: shipmentData.unitValue,
                coinPackaging: shipmentData.coinPackaging
            };
        }
    }, {
        key: 'calculateAmountForParent',
        value: function calculateAmountForParent() {
            if (!this.model.parentAtmResidual) return;

            var data = this.model.parentAtmResidual;

            // Initialize calculation variables
            var expectedResidual = data.expectedResidual ? data.expectedResidual : 0;
            var requestLoad = data.requestLoad ? data.requestLoad : 0;
            var actualLoad = data.actualLoad ? data.actualLoad : 0;
            var crv = data.crv ? data.crv : 0;
            // Perform necessary calculations for the parent residual
            // As parent atm residual record deleted so sum of child
            var totalActualLoad = this.model.atmResidual.reduce(function (sum, record) {
                return sum + Number(record.actualLoad);
            }, 0);

            var totalExpectedResidual = this.model.atmResidual.reduce(function (sum, record) {
                return sum + Number(record.expectedResidual);
            }, 0);

            data.actualLoad = totalActualLoad;
            data.expectedResidual = totalExpectedResidual;

            if (data.finishedAt && data.crv != null && !this.isEdit) {
                data.crv;
            } else if (data.finishedAt && (data.crv === '' || data.crv === undefined)) {
                data.crv = 0;
            } else {
                data.crv = requestLoad - actualLoad;
            }
            // Denominated values
            data.denomActualLoad = (actualLoad / data.faceValue).toLocaleString();
            data.denomExpectedResidual = totalExpectedResidual;

            var transferredAmount = data.transferredAmount || 0;
            var dispensedAmount = data.dispensedAmount || 0;
            var countedResidual = data.countedResidual || 0;

            data.denomTransferredAmount = (transferredAmount / data.faceValue).toLocaleString();
            data.denomDispensedAmount = (dispensedAmount / data.faceValue).toLocaleString();
            // Calculate variance for the parent
            // data.variance = actualLoad - (crv + expectedResidual);
            data.variance = countedResidual - expectedResidual;

            // Update totals
            this.totalAmount();
        }
    }, {
        key: 'pickupDateTime',
        value: function pickupDateTime(pickupDate) {
            if (pickupDate) {
                var time = moment(pickupDate).tz(this.browserTimezone).format('HH:mm:ss');
                var validatationTime = moment.utc(pickupDate).format('HH:mm:ss');

                if (validatationTime === '00:00:00') {
                    this.model.beginTime = null;
                    this.pickupDate = moment(pickupDate, 'YYYY-MM-DD').toDate();
                } else {
                    this.model.beginTime = this.DateUtil.getTime(time);
                    var dateString = moment(pickupDate).tz(this.browserTimezone).format('YYYY-MM-DD');
                    this.pickupDate = moment(dateString, 'YYYY-MM-DD').toDate();
                }
            } else {
                this.model.beginTime = "";
                this.pickupDate = "";
            }
        }
    }, {
        key: 'validateActualLoad',
        value: function validateActualLoad(data, index) {
            if (data.actualLoad) {
                return data.actualLoad;
            } else if (data.orderType === "T" || data.orderType === "P") {
                return 0;
            } else {
                return '';
            }
        }
    }, {
        key: 'validateCountedResidual',
        value: function validateCountedResidual(data, index) {
            if (data.amountCounted !== null) {
                return data.amountCounted;
            } else if (data.orderType === "A" || data.orderType === "I" || data.orderType === "R" || data.orderType === "C" || data.isEC) {
                return 0;
            } else {
                return '';
            }
        }
    }, {
        key: 'validateExpectedResidual',
        value: function validateExpectedResidual(data, index) {
            if (data.amountExpected) {
                return data.amountExpected;
            }
            // else if (data.orderType === "A" || data.orderType === "I" || data.orderType === "R" || data.orderType === "C" || data.isEC) {
            //     return 0;
            // }
            else {
                    return 0;
                }
        }

        // show ATM residual receipt 

    }, {
        key: 'showResidualReceipt',
        value: function showResidualReceipt(shipments) {
            this.Modal.atmResidualReceipt(shipments, function (_ref19) {
                var modal = _ref19.modal;
            }, function (_ref20) {
                var modal = _ref20.modal;

                modal.close();
            });
        }
    }, {
        key: 'editResidualCommit',
        value: function editResidualCommit() {
            if (this.isEdit) {
                return this.commitResidualShipment(0);
            }
            this.isEdit = true;
            this.restorePreviousUnfitDenominations();
            if (!this.model.bagId) return this.model.bagId = this.lastScanned;
        }
    }, {
        key: 'editDepositCommit',
        value: function editDepositCommit() {
            if (this.isEdit) {
                return this.commitDeposit(0);
            }
            this.isEdit = true;
            if (!this.model.bagId) return this.model.bagId = this.lastScanned;
        }
    }, {
        key: 'showEditDepositButton',
        value: function showEditDepositButton() {
            try {
                return !!(this.model && this.model.depositRecord && this.model.depositRecord.depositShipment && this.model.locationId && this.hasACL && this.hasACL['atm_count'] && this.hasACL['atm_count']['editCommitted'] && this.finishedAt);
            } catch (e) {
                console.error(e);
                return false;
            }
        }
    }, {
        key: 'isEditDepositButtonDisabled',
        value: function isEditDepositButtonDisabled() {
            if (!this.isSameVaultDate) return true;
            if (this.isCommit) return true;
            if (this.isBulkCash && !this.allowBulkCashEdit) return true;
            if (this.isEdit && !this.model.bagId) return true;
            if (this.isEdit && !this.hasDenominationvalueChanged()) return true;
            if (this.model && this.model.depositRecord && !this.model.depositRecord.declaredTotalAmount) return true;
            if (this.isEdit && this.depositCommitDisabled && this.depositCommitDisabled()) return true;
            return false;
        }

        // redirect user to service history 

    }, {
        key: 'redirectToLocation',
        value: function redirectToLocation(locationId) {
            var obj = {
                locationId: locationId,
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.locations');
        }
    }, {
        key: 'loadAtmCount',
        value: function loadAtmCount(data) {
            var _this30 = this;

            var transitionData = this.FetchReactData.getTransitionData();
            this.locationData = transitionData || this.DataCounter.getData();
            var fundingSource = void 0;
            if (this.locationData && this.locationData.isRedirected || this.locationLists.length === 1) {
                if (this.locationData && this.locationData.fundingSourceId) {
                    fundingSource = _.find(data, { id: this.locationData.fundingSourceId });
                } else if (this.locationData && this.locationData.destinationLocationId) {
                    fundingSource = _.find(data, { locationId: this.locationData.destinationLocationId });
                }
                this.model.locationId = {
                    Key: fundingSource ? fundingSource.locationId + " | " + fundingSource.sourceName : data[0].locationId + " | " + data[0].sourceName,
                    Value: fundingSource ? fundingSource.locationId : data[0].locationId,
                    Id: fundingSource ? fundingSource.id : data[0].id,
                    EditCountAnytime: fundingSource ? fundingSource.editCountAnytime : data[0].editCountAnytime,
                    varianceCheckEnabled: fundingSource ? fundingSource.varianceCheckEnabled : data[0].varianceCheckEnabled,
                    varianceThreshold: fundingSource ? fundingSource.varianceThreshold : data[0].varianceThreshold,
                    currencyId: fundingSource ? fundingSource.currencyId : data[0].currencyId
                };
                this.setCurrencySymbol();
                if (this.locationData && this.locationData.isRedirected) this.model.bagId = this.locationData.trackingId;
                return this.bagCount().then(function () {
                    _this30.loadShipmentByTrackingId();
                    _this30.locationData.isRedirected = false;
                    _this30.locationData = _this30.DataCounter.setData();
                    _this30.FetchReactData.clearTransitionData();
                });
            }
        }
    }, {
        key: 'residualCountEdit',
        value: function residualCountEdit(children, parentResidual, comments, supervisorId) {
            var _this31 = this;

            var unfitDenomsData = this.prepareUnfitDenominationsData();

            var unfitTotal = unfitDenomsData && this.model.unfitTotalCashCounted ? this.model.unfitTotalCashCounted : 0;
            var totalCountedResidual = this.model.countedResidualTotal + unfitTotal;

            var updatedParentResidual = (0, _extends3.default)({}, parentResidual, {
                countedResidual: totalCountedResidual
            });

            this.AtmResidualService.ResidualCountEdit(this.model.branch, this.model.loggedInUserId, children, updatedParentResidual, this.model.locationId.Id, unfitDenomsData, this.monthlySupId, this.monthlyLimitDetails ? this.monthlyLimitDetails.monthlyCashCountLimitAmount : 0, this.monthlyLimitDetails ? this.monthlyLimitDetails.totalCountedThisMonth : 0, this.monthlyLimitDetails ? this.monthlyLimitDetails.newCountAmount : 0).then(function (res) {
                _this31.isCommit = false;
                _this31.updateData();
                _this31.model.bagId = _this31.lastScanned;
                _this31.loadShipmentByTrackingId();
            }).catch(function (err) {
                _this31.isCommit = false;
                if (err && err.data && err.data.message) {
                    _this31.Sound.PlayErrorBeep("#scanner_beep");
                    _this31.Modal.errorModal('error.' + err.data.message);
                }
            });
        }
    }, {
        key: 'updateData',
        value: function updateData() {
            this.model.parentAtmResidual.finishedAt = moment().format('MM-DD-YYYY | h:mm A');
            this.model.atmResidual.forEach(function (residual) {
                return residual.finishedAt = moment().format('MM-DD-YYYY | h:mm A');
            });
            this.finishedAt = this.model.parentAtmResidual.finishedAt;

            this.model.bagId = "";
            this.isEdit = false;
            this.focusElementById('trackingId');
        }
    }, {
        key: 'validateResidualCountEdit',
        value: function validateResidualCountEdit() {
            var _this32 = this;

            this.isSameVaultDate = true;
            return this.AtmResidualService.getVaultDate(this.model.branch, this.lastScanned).then(function (data) {
                var shipmentVaultDate = new Date(data.shipmentVaultDate);
                var branchCurrentVaultDate = new Date(data.branchCurrentVaultDate);
                if (_this32.model.locationId && !_this32.model.locationId.EditCountAnytime) _this32.isSameVaultDate = shipmentVaultDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();else if (_this32.model.locationId && _this32.model.locationId.EditCountAnytime) _this32.isSameVaultDate = true;
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'getComments',
        value: function getComments(comment) {
            this.Modal.confirm({
                header: this.$translate.instant('common.comment'),
                message: comment,
                callback: function callback(_ref21) {
                    var modal = _ref21.modal;

                    modal.close();
                },
                negative: function negative(_ref22) {
                    var modal = _ref22.modal;

                    modal.close();
                },
                buttons: ['common.close'],
                type: 'success'
            });
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            this.model.bagId = null;
            this.shipmentData = [];
            this.isError = true;
            this.isBagout = false;
            this.model.depositRecord.depositShipment = null;
            this.resetBulkDepositData();
        }
    }, {
        key: 'convertToCrv',
        value: function convertToCrv(shipment) {
            var _this33 = this;

            var modal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            modal.close();

            this.UsersService.checkSupervisor(this.model.loggedInUserId).then(function (userInfo) {
                shipment.amount = shipment.requestLoad;
                _this33.Modal.convertToCrv(shipment, !userInfo.supervisor, true, function (_ref23) {
                    var supervisor = _ref23.supervisor,
                        trackingIdResidual = _ref23.trackingIdResidual,
                        modal = _ref23.modal;

                    if (trackingIdResidual) {
                        return _this33.AtmResidualService.convertToCRV(shipment.branchId, shipment.routeId, trackingIdResidual, userInfo.supervisor ? userInfo.id : supervisor).then(function () {
                            _this33.Modal.confirm({
                                header: _this33.$translate.instant('successModal.title'),
                                message: _this33.$translate.instant('ATM Residual <b>' + _this33.model.bagId + '</b> successfully Became CRV'),
                                callback: function callback(_ref24) {
                                    var modal = _ref24.modal;

                                    _this33.reloadData();
                                    modal.close();
                                },
                                buttons: ['common.ok'],
                                type: 'success'
                            });
                        }).catch(function (err) {
                            if (err && err.data && err.data.message) {
                                _this33.Modal.errorModal('error.' + err.data.message);
                                _this33.reloadData();
                            }
                        }).finally(function () {
                            modal.close();
                        });
                    } else {
                        if (modal) modal.close();
                    }
                }, function (_ref25) {
                    var modal = _ref25.modal;

                    if (modal) modal.close();
                });
            }).catch(function (err) {
                _this33.Modal.errorModal(err.data.message);
            });
        }
    }, {
        key: 'reloadData',
        value: function reloadData() {
            this.resetData();
            this.bagCount();
            this.focusElementById('trackingId');
        }
    }, {
        key: 'cancelEdit',
        value: function cancelEdit() {
            this.isEdit = false;
            this.expectedResidualDetails = [];
            this.loadShipments();
        }
    }, {
        key: 'hasDenominationvalueChanged',
        value: function hasDenominationvalueChanged() {
            var _this34 = this;

            if ((this.model.depositRecord.notes || '') !== (this.model.depositRecord.previousNotes || '')) {
                return true;
            }
            if (Array.isArray(this.model.depositRecord.previousDenominations)) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    var _loop = function _loop() {
                        var itemA = _step.value;

                        var itemB = _this34.model.depositRecord.denominations.find(function (item) {
                            return item.id === itemA.id;
                        });
                        if (!itemB || itemA.totalValue !== itemB.totalValue) {
                            return {
                                v: true
                            };
                        }
                    };

                    for (var _iterator = (0, _getIterator3.default)(this.model.depositRecord.previousDenominations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _ret = _loop();

                        if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return false;
        }
    }, {
        key: 'cancelDepositCountEdit',
        value: function cancelDepositCountEdit() {
            this.isEdit = false;
            this.loadDepositShipment();
        }
    }, {
        key: 'hasResidualCountvalueChanged',
        value: function hasResidualCountvalueChanged() {
            var _this35 = this;

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                var _loop2 = function _loop2() {
                    var itemA = _step2.value;

                    var itemB = _this35.model.atmResidual.find(function (item) {
                        return item.id === itemA.id;
                    });
                    if (!itemB || itemA.totalValue !== itemB.totalValue) {
                        return {
                            v: true
                        };
                    }
                };

                for (var _iterator2 = (0, _getIterator3.default)(this.model.cloneAtmResidual), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _ret2 = _loop2();

                    if ((typeof _ret2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret2)) === "object") return _ret2.v;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return false;
        }
    }, {
        key: 'getExpectedResidual',
        value: function getExpectedResidual() {
            var _this36 = this;

            if (!this.model.parentAtmResidual || !this.model.parentAtmResidual.orderNo) return;

            this.gettingExpectedResidual = true;
            this.isPressExpectedResidualButton = true;

            var data = this.model.atmResidual.map(function (d) {
                var expectedResidualDetails = _this36.expectedResidualDetails && _this36.expectedResidualDetails.length > 0 ? _this36.expectedResidualDetails.find(function (item) {
                    return item.trackingId === d.trackingId;
                }) : {};

                var multiplier = (d.coinPackaging === 'ROLLED' || d.coinPackaging === 'INDIVIDUAL') && d.unitValue != null ? d.unitValue : d.faceValue;

                return {
                    trackingId: d.trackingId,
                    denominationId: d.denominationId,
                    toLocationId: _this36.model.locationId.Value,

                    crv: d.crv != null && d.crv !== "" ? Number(parseFloat(d.crv).toFixed(4)) : 0,

                    denomTransferredAmount: d.denomTransferredAmount != null && d.denomTransferredAmount !== "" ? Number((parseFloat(d.denomTransferredAmount.toString().replace(/,/g, "")) * multiplier).toFixed(4)) : 0,

                    dispensedAmount: d.dispensedAmount != null && d.dispensedAmount !== "" ? Number(parseFloat(d.dispensedAmount).toFixed(4)) : 0,

                    countedResidual: d.countedResidual != null && d.countedResidual !== "" ? Number(parseFloat(d.countedResidual).toFixed(4)) : 0,

                    actualPriorLoad: expectedResidualDetails ? Number(parseFloat(expectedResidualDetails.actualPriorLoad || 0).toFixed(4)) : 0,

                    manualPriorLoadAmount: expectedResidualDetails ? Number(parseFloat(expectedResidualDetails.manualPriorLoadAmount || 0).toFixed(4)) : 0,

                    faceValue: d.faceValue,

                    amountExpected: d.denomExpectedResidual != null && d.denomExpectedResidual !== "" ? Number((parseFloat(d.denomExpectedResidual.toString().replace(/,/g, "")) * multiplier).toFixed(4)) : 0,

                    hasManuallySetPriorLoad: expectedResidualDetails ? expectedResidualDetails.hasManuallySetPriorLoad || false : false,

                    actualLoad: d.actualLoad != null && d.actualLoad !== "" ? Number(parseFloat(d.actualLoad).toFixed(4)) : 0
                };
            });
            var resultMap = {};

            return this.AtmResidualService.getExpectedResidual(this.model.branch, this.lastScanned, data, this.model.locationId.Id, this.model.parentAtmResidual.orderNo).then(function (data) {
                _this36.expectedResidualDetails = data.results;
                _this36.model.expectedResidualToSend = 0;
                _this36.model.varianceToSend = 0;
                _this36.totalResidualAmount = data.expectedResidualAmount;

                data.results.forEach(function (item) {
                    item.actualPriorLoad = item.actualPriorLoad;
                    item.manualPriorLoadAmount = item.manualPriorLoadAmount ? item.manualPriorLoadAmount : item.hasManuallySetPriorLoad ? item.actualPriorLoad : 0;
                    item.isEditablePriorLoad = item.manualPriorLoadAmount > 0 ? true : false;
                    item.isValidAmount = item.isValidAmount || true;
                    resultMap[item.trackingId] = item;
                });

                var expectedResidualTotal = data.results.reduce(function (sum, item) {
                    return sum + item.expectedResidual;
                }, 0);

                _this36.model.atmResidual.forEach(function (d) {
                    var result = resultMap[d.trackingId];

                    if (result) {
                        var divisor = (d.coinPackaging === 'ROLLED' || d.coinPackaging === 'INDIVIDUAL') && d.unitValue != null ? d.unitValue : d.faceValue;

                        // prevent division by zero in case of bad data
                        divisor = divisor || 1;

                        d.expectedResidual = result.expectedResidual;
                        d.denomExpectedResidual = (result.expectedResidual / divisor).toLocaleString();
                        d.variance = result.variance;
                        d.actualPriorLoad = result.actualPriorLoad;
                        d.manualPriorLoadAmount = result.manualPriorLoadAmount;
                        d.faceValue = d.faceValue;
                        d.hasManuallySetPriorLoad = result.hasManuallySetPriorLoad;

                        _this36.model.expectedResidualToSend += Number(d.expectedResidual / divisor);
                        _this36.model.varianceToSend += Number(d.variance);
                    }
                });

                _this36.manualPriorLoadDenominations = _this36.expectedResidualDetails.filter(function (d) {
                    return d.hasManuallySetPriorLoad && d.manualPriorLoadAmount > 0;
                }).map(function (d) {
                    return d.denominationId;
                });

                var totalVariance = _this36.model.atmResidual.reduce(function (sum, item) {
                    return sum + item.variance;
                }, 0);

                _this36.model.parentAtmResidual.expectedResidual = expectedResidualTotal;
                _this36.model.expectedResidualTotal = expectedResidualTotal;
                _this36.model.parentAtmResidual.denomExpectedResidual = expectedResidualTotal;
                _this36.model.varianceTotal = totalVariance;
            }).catch(function (err) {
                _this36.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this36.gettingExpectedResidual = false;
            });
        }
    }, {
        key: 'hasCountingBag',
        value: function hasCountingBag() {
            if (!this.bulkDepositData.bags) return false;
            return (0, _values2.default)(this.bulkDepositData.bags).some(function (bag) {
                return bag.status === 'counting';
            });
        }
    }, {
        key: 'getCountingBagIndex',
        value: function getCountingBagIndex() {
            if (!this.bulkDepositData.bags) return null;
            var entries = (0, _entries2.default)(this.bulkDepositData.bags);
            var countingEntry = entries.find(function (_ref26) {
                var _ref27 = (0, _slicedToArray3.default)(_ref26, 2),
                    index = _ref27[0],
                    bag = _ref27[1];

                return bag.status === 'counting';
            });
            return countingEntry ? parseInt(countingEntry[0]) : null;
        }
    }, {
        key: 'setActiveBag',
        value: function setActiveBag(bagIndex) {
            var loadData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (this.activeBagData.bagIndex !== null && this.activeBagData.bagIndex !== bagIndex) {
                this.clearActiveBag();
            }

            this.activeBagData.bagIndex = bagIndex;
            this.activeBagData.bag = this.bulkDepositData.bags[bagIndex];

            if (this.activeBagData.bag) {
                this.activeBagData.originalBagValues = {
                    countedAmount: this.activeBagData.bag.countedAmount || 0,
                    countedVariance: this.activeBagData.bag.countedVariance || 0,
                    declaredAmount: this.activeBagData.bag.declaredAmount || null
                };
                this.originalCountAmount = this.activeBagData.originalBagValues.countedAmount || 0;
            }

            if (loadData && this.activeBagData.bag) {
                this.loadActiveBagData();
            }
        }
    }, {
        key: 'clearActiveBag',
        value: function clearActiveBag() {
            this.activeBagData = this._getDefaultActiveBagData();
        }
    }, {
        key: 'getActiveBag',
        value: function getActiveBag() {
            return this.activeBagData.bag;
        }
    }, {
        key: 'isBagActive',
        value: function isBagActive(bagIndex) {
            return this.activeBagData.bagIndex === bagIndex;
        }
    }, {
        key: 'getBagsArray',
        value: function getBagsArray() {
            return (0, _keys2.default)(this.bulkDepositData.bags).map(function (key) {
                return parseInt(key);
            }).sort(function (a, b) {
                return a - b;
            });
        }
    }, {
        key: 'getBagByIndex',
        value: function getBagByIndex(bagIndex) {
            return this.bulkDepositData.bags[bagIndex];
        }
    }, {
        key: 'isBagExpanded',
        value: function isBagExpanded(bagIndex) {
            return this.isBagActive(bagIndex);
        }
    }, {
        key: 'isBagInEditMode',
        value: function isBagInEditMode(bagIndex) {
            return this.isBagActive(bagIndex) && this.activeBagData.isEditMode;
        }
    }, {
        key: 'isBagCollapseDisabled',
        value: function isBagCollapseDisabled(bagIndex) {
            return false;
        }
    }, {
        key: 'onBulkDepositDeclaredTotalChange',
        value: function onBulkDepositDeclaredTotalChange() {
            this.calculateBulkDepositTotals();
        }
    }, {
        key: 'bulkDepositCommitDisabled',
        value: function bulkDepositCommitDisabled() {
            if (!this.activeBagData.bag) return true;
            var bag = this.activeBagData.bag;

            if (bag.status === 'counted' && this.activeBagData.isEditMode) {
                return !this.hasBagDenominationValueChanged();
            }

            return bag.status === 'counted' && !this.activeBagData.isEditMode;
        }
    }, {
        key: 'hasBagDenominationValueChanged',
        value: function hasBagDenominationValueChanged() {
            if (!this.activeBagData.depositData.previousDenominations || !this.activeBagData.depositData.denominations) {
                return false;
            }

            var previous = this.activeBagData.depositData.previousDenominations;
            var current = this.activeBagData.depositData.denominations;

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                var _loop3 = function _loop3() {
                    var prevDenom = _step3.value;

                    var currDenom = current.find(function (item) {
                        return item.id === prevDenom.id;
                    });
                    if (!currDenom || prevDenom.totalValue !== currDenom.totalValue) {
                        return {
                            v: true
                        };
                    }
                };

                for (var _iterator3 = (0, _getIterator3.default)(previous), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _ret3 = _loop3();

                    if ((typeof _ret3 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret3)) === "object") return _ret3.v;
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return false;
        }
    }, {
        key: 'updateBagDenomsTotals',
        value: function updateBagDenomsTotals(bagIndex) {
            var bag = this.bulkDepositData.bags[bagIndex];
            if (!bag || !this.activeBagData.depositData.denominations) return;

            var denoms = this.activeBagData.depositData.denominations;

            bag.cashDenomTotals = denoms.filter(function (d) {
                return !d.coinFlag && !d.unfit;
            }).reduce(function (sum, d) {
                return sum + (Number(d.totalCounted * d.faceValue) || 0);
            }, 0);

            bag.coinDenomTotals = denoms.filter(function (d) {
                return d.coinFlag && !d.unfit;
            }).reduce(function (sum, d) {
                return sum + (Number(d.totalCounted * d.faceValue) || 0);
            }, 0);

            bag.unfitDenomTotals = denoms.filter(function (d) {
                return d.unfit;
            }).reduce(function (sum, d) {
                return sum + (Number(d.totalValue) || 0);
            }, 0);
        }
    }, {
        key: 'resetBulkDepositData',
        value: function resetBulkDepositData() {
            this.isBulkDeposit = false;
            this.bulkDepositData = this._getDefaultBulkDepositData();
            this.clearActiveBag();
        }
    }, {
        key: 'loadBulkDepositShipment',
        value: function loadBulkDepositShipment() {
            var _this37 = this;

            if (this.shipmentLoading || !this.model.locationId || !this.model.bagId) return;
            this.shipmentLoading = true;
            this.lastScanned = this.model.bagId;
            this.finishedAt = null;
            this.bulkDepositData = this._getDefaultBulkDepositData();
            this.clearActiveBag();

            this.AtmResidualDepositService.getBulkDepositShipmentRecord(this.model.bagId, this.model.locationId.Value).then(function (data) {
                _this37.shipmentLoading = false;

                if (data && data.shipmentRecord) {
                    _this37.fromLocationId = data.shipmentRecord.fromLocationId;
                    _this37.fromLocationName = data.shipmentRecord.fromLocation ? data.shipmentRecord.fromLocation.name : '';

                    _this37.bulkDepositData.shipment = data.shipmentRecord;
                    _this37.bulkDepositData.statedTotal = data.shipmentRecord.amount || 0;

                    if (data.shipmentRecord.shiptype) {
                        _this37.bulkDepositData.metadata.shiptype = {
                            countable: data.shipmentRecord.shiptype.countable === 1 || data.shipmentRecord.shiptype.countable === true,
                            daysToCount: data.shipmentRecord.shiptype.daysToCount || 0
                        };
                    }

                    var isDeleted = data.shipmentRecord.deleted === true || data.shipmentRecord.deleted === 1;
                    if (isDeleted) {
                        _this37.isEdit = false;
                    }

                    _this37.pickupDateTime(data.shipmentRecord.pickupDate);

                    _this37.bulkDepositData.bags = {};
                    _this37.bulkDepositData.metadata.nextBagIndex = 0;
                    _this37.bulkDepositData.declaredTotal = data.shipmentRecord.amount || 0;
                    _this37.bulkDepositData.countedTotal = 0;
                    _this37.bulkDepositData.countedVariance = 0;

                    if (data.individualBags && data.individualBags.length > 0) {
                        _this37.loadExistingBags(data.individualBags);
                    }

                    _this37.bulkDepositData.metadata.hasActiveBulkDeposit = true;
                    _this37.isEdit = true;

                    _this37.validateBulkDepositVaultDate();
                }
            }).catch(function (err) {
                _this37.Modal.errorModal(err.data && err.data.message ? err.data.message : 'Error loading bulk deposit');
                _this37.shipmentLoading = false;
                _this37.isBulkDeposit = false;
            });
        }
    }, {
        key: 'loadExistingBags',
        value: function loadExistingBags(bagsArray) {
            var _this38 = this;

            bagsArray.forEach(function (bagData, index) {
                var bagStatus = 'pending';
                if (bagData.depositRecord && bagData.depositRecord.countedAt) {
                    bagStatus = 'counted';
                } else if (bagData.countCompletedAt) {
                    bagStatus = 'counted';
                } else if (bagData.id || bagData.shipmentId) {
                    bagStatus = 'counting';
                }

                var countedAmount = bagData.depositRecord ? bagData.depositRecord.totalAmount || 0 : bagData.countedAmount || 0;

                var countedVariance = bagData.depositRecord ? bagData.depositRecord.countedVariance || 0 : bagData.countedVariance || 0;

                _this38.bulkDepositData.bags[index] = {
                    trackingId: bagData.trackingId || '',
                    declaredAmount: bagData.depositRecord ? bagData.depositRecord.declaredTotalAmount : bagData.amount || null,
                    countedAmount: countedAmount,
                    countedVariance: countedVariance,
                    status: bagStatus,
                    shipmentId: bagData.id || bagData.shipmentId || null,
                    depositRecordId: bagData.depositRecordId || (bagData.depositRecord ? bagData.depositRecord.id : null),
                    countCompletedAt: bagData.countCompletedAt || (bagData.depositRecord ? bagData.depositRecord.countedAt : null) || null,
                    countVaultDate: bagData.depositRecord ? bagData.depositRecord.countVaultDate || null : null,
                    depositRecord: bagData.depositRecord || null,
                    cashDenomTotals: 0,
                    coinDenomTotals: 0,
                    unfitDenomTotals: 0
                };

                _this38.bulkDepositData.metadata.nextBagIndex = Math.max(_this38.bulkDepositData.metadata.nextBagIndex, index + 1);
            });

            this.calculateBulkDepositTotals();
        }
    }, {
        key: 'loadActiveBagData',
        value: function loadActiveBagData() {
            var _this39 = this;

            var bagIndex = this.activeBagData.bagIndex;
            var bag = this.activeBagData.bag;

            if (!bag || !bag.trackingId) {
                return this.$q.resolve();
            }

            if (bag.status === 'counting' && !bag.depositRecordId && !bag.depositRecord) {
                var filteredDenominations = this.allDenominations || [];
                if (this.model.locationId && this.model.locationId.currencyId) {
                    filteredDenominations = this.allDenominations.filter(function (o) {
                        return o.currencyId === _this39.model.locationId.currencyId;
                    });
                }

                this.activeBagData.depositData = {
                    depositShipment: null,
                    depositRecord: null,
                    declaredTotalAmount: bag.declaredAmount || 0,
                    countedVariance: bag.countedVariance || 0,
                    totalAmount: bag.countedAmount || 0,
                    statedTotalAmount: bag.declaredAmount || 0,
                    denominations: angular.copy(filteredDenominations),
                    previousDenominations: [],
                    childTotalDeposit: 0,
                    coinTotalDeposit: 0,
                    unfitTotalDeposit: 0,
                    codFlags: null
                };

                this.activeBagData.depositData.denominations.forEach(function (denom) {
                    denom.totalCounted = 0;
                    denom.totalValue = 0;
                });

                this.activeBagData.depositData.totalAmount = 0;
                this.activeBagData.depositData.childTotalDeposit = 0;
                this.activeBagData.depositData.coinTotalDeposit = 0;
                this.activeBagData.depositData.unfitTotalDeposit = 0;
                this.activeBagData.depositData.countedVariance = 0;

                this.calculateActiveBagTotals();
                this.updateBagDenomsTotals(bagIndex);

                return this.$q.resolve();
            }

            return this.AtmResidualDepositService.getDepositShipmentRecord(bag.trackingId, this.model.locationId.Value).then(function (data) {
                if (_this39.activeBagData.bagIndex !== bagIndex) {
                    return;
                }
                bag.countCompletedAt = data.shipmentRecord.countCompletedAt || null;
                var filteredDenominations = _this39.allDenominations || [];
                if (_this39.model.locationId && _this39.model.locationId.currencyId) {
                    filteredDenominations = _this39.allDenominations.filter(function (o) {
                        return o.currencyId === _this39.model.locationId.currencyId;
                    });
                }

                var bagCodFlags = {
                    isPackable: data.shipmentRecord.isPackable || false,
                    isCRVed: data.shipmentRecord.isCRVed || false,
                    includedDenominationIds: data.shipmentRecord.includedDenominationIds || []
                };

                _this39.codFlags = bagCodFlags;
                _this39.setCountRestrictionFromShipment(data.shipmentRecord);

                _this39.activeBagData.depositData = {
                    depositShipment: data.shipmentRecord,
                    depositRecord: data.depositRecord,
                    declaredTotalAmount: bag.declaredAmount || 0,
                    countedVariance: bag.countedVariance || 0,
                    totalAmount: bag.countedAmount || 0,
                    statedTotalAmount: bag.declaredAmount || 0,
                    denominations: angular.copy(filteredDenominations),
                    previousDenominations: [],
                    childTotalDeposit: 0,
                    coinTotalDeposit: 0,
                    unfitTotalDeposit: 0,
                    codFlags: bagCodFlags
                };

                if (data.depositRecord) {
                    bag.depositRecordId = data.depositRecord.id || bag.depositRecordId;
                    _this39.activeBagData.depositRecordId = data.depositRecord.id || bag.depositRecordId;
                    _this39.activeBagData.depositData.denominations = _this39.denomsDataUpdate(data.depositRecord.denominations);
                    _this39.activeBagData.depositData.totalAmount = data.depositRecord.totalAmount || 0;

                    var userDeclaredAmount = bag.declaredAmount;
                    var dbDeclaredAmount = data.depositRecord.declaredTotalAmount;

                    if (userDeclaredAmount !== null && userDeclaredAmount !== undefined) {
                        _this39.activeBagData.depositData.declaredTotalAmount = userDeclaredAmount;
                    } else {
                        _this39.activeBagData.depositData.declaredTotalAmount = dbDeclaredAmount;
                        bag.declaredAmount = dbDeclaredAmount;
                    }

                    bag.countedAmount = data.depositRecord.totalAmount || 0;

                    _this39.activeBagData.depositData.previousDenominations = _.cloneDeep(_this39.activeBagData.depositData.denominations);

                    _this39.calculateActiveBagTotals();

                    bag.countedVariance = _this39.activeBagData.depositData.countedVariance;
                } else {
                    _this39.activeBagData.depositData.denominations.forEach(function (denom) {
                        denom.totalCounted = 0;
                        denom.totalValue = 0;
                    });

                    _this39.activeBagData.depositData.totalAmount = 0;
                    _this39.activeBagData.depositData.childTotalDeposit = 0;
                    _this39.activeBagData.depositData.coinTotalDeposit = 0;
                    _this39.activeBagData.depositData.unfitTotalDeposit = 0;
                    _this39.activeBagData.depositData.countedVariance = 0;

                    bag.countedAmount = 0;
                    bag.countedVariance = 0;
                    _this39.calculateActiveBagTotals();
                }

                _this39.updateBagDenomsTotals(bagIndex);
            }).catch(function (err) {
                console.error('Error loading active bag data:', err);
                return _this39.$q.resolve();
            });
        }
    }, {
        key: 'calculateBulkDepositTotals',
        value: function calculateBulkDepositTotals() {
            var countedTotal = 0;
            var countedCount = 0;

            (0, _values2.default)(this.bulkDepositData.bags).forEach(function (bag) {
                if (bag.status === 'counted' && bag.countedAmount) {
                    countedTotal += Number(bag.countedAmount) || 0;
                    countedCount++;
                }
            });

            this.bulkDepositData.countedTotal = countedTotal;
            this.bulkDepositData.countedVariance = Number(this.bulkDepositData.countedTotal || 0) - Number(this.bulkDepositData.declaredTotal || 0);

            return countedCount;
        }
    }, {
        key: 'calculateActiveBagTotals',
        value: function calculateActiveBagTotals() {
            if (!this.activeBagData.depositData.denominations) return;

            var depositData = this.activeBagData.depositData;
            var bag = this.activeBagData.bag;

            depositData.childTotalDeposit = depositData.denominations.filter(function (denom) {
                return !denom.coinFlag && !denom.unfit;
            }).reduce(function (sum, denom) {
                return sum + (Number(denom.totalCounted * denom.faceValue) || 0);
            }, 0);

            depositData.coinTotalDeposit = depositData.denominations.filter(function (denom) {
                return denom.coinFlag && !denom.unfit;
            }).reduce(function (sum, denom) {
                return sum + (Number(denom.totalCounted * denom.faceValue) || 0);
            }, 0);

            depositData.unfitTotalDeposit = depositData.denominations.filter(function (denom) {
                return denom.unfit;
            }).reduce(function (sum, denom) {
                return sum + (Number(denom.totalValue) || 0);
            }, 0);

            depositData.totalAmount = Number(depositData.childTotalDeposit) + Number(depositData.coinTotalDeposit) + Number(depositData.unfitTotalDeposit);

            var declaredTotal = Number(depositData.declaredTotalAmount) || 0;
            depositData.countedVariance = Number(depositData.totalAmount) - declaredTotal;

            if (bag) {
                bag.declaredAmount = declaredTotal;
                bag.countedAmount = depositData.totalAmount;
                bag.countedVariance = depositData.countedVariance;
            }
        }
    }, {
        key: 'validateBulkDepositVaultDate',
        value: function validateBulkDepositVaultDate() {
            var _this40 = this;

            if (!this.model.bagId || !this.model.branch) {
                return this.$q.resolve();
            }

            return this.AtmResidualService.getVaultDate(this.model.branch, this.model.bagId).then(function (data) {
                var shipmentVaultDate = new Date(data.shipmentVaultDate);
                var branchCurrentVaultDate = new Date(data.branchCurrentVaultDate);

                _this40.bulkDepositData.metadata.branchCurrentVaultDate = branchCurrentVaultDate;
                _this40.bulkDepositData.metadata.shipmentVaultDate = shipmentVaultDate;
            }).catch(function (err) {
                _this40.bulkDepositData.metadata.branchCurrentVaultDate = null;
                _this40.bulkDepositData.metadata.shipmentVaultDate = null;
            });
        }
    }, {
        key: 'isBulkDepositDeleted',
        value: function isBulkDepositDeleted() {
            if (!this.bulkDepositData.shipment) return false;
            var deleted = this.bulkDepositData.shipment.deleted;
            return deleted === true || deleted === 1;
        }
    }, {
        key: 'hasCountingBag',
        value: function hasCountingBag() {
            if (!this.bulkDepositData || !this.bulkDepositData.bags) return false;
            var bags = this.bulkDepositData.bags;
            for (var key in bags) {
                var bag = bags[key];
                if (bag && bag.shipmentId && !bag.countCompletedAt) {
                    return true;
                }
            }
            return false;
        }
    }, {
        key: 'getCountingBagIndex',
        value: function getCountingBagIndex() {
            if (!this.bulkDepositData || !this.bulkDepositData.bags) return null;
            var bags = this.bulkDepositData.bags;
            for (var key in bags) {
                var bag = bags[key];
                if (bag && bag.shipmentId && !bag.countCompletedAt) {
                    return key;
                }
            }
            return null;
        }
    }, {
        key: 'isBagLocked',
        value: function isBagLocked(bagIndex) {
            if (!this.hasCountingBag()) return false;
            var countingBagIndex = this.getCountingBagIndex();
            var normalizedCountingIndex = countingBagIndex !== null ? Number(countingBagIndex) : null;
            var normalizedBagIndex = Number(bagIndex);
            return normalizedCountingIndex !== null && normalizedCountingIndex !== normalizedBagIndex;
        }

        // isWithinDaysToCountLimit() {
        //     const shiptype = this.bulkDepositData.metadata.shiptype;
        //     if (!shiptype || !shiptype.countable) {
        //         return true;
        //     }

        //     const branchCurrentVaultDate = this.bulkDepositData.metadata.branchCurrentVaultDate;
        //     const shipmentVaultDate = this.bulkDepositData.metadata.shipmentVaultDate;

        //     if (!branchCurrentVaultDate || !shipmentVaultDate) {
        //         return false;
        //     }

        //     // Handle daysToCount = 0: Everything must happen on the same vault date as shipment
        //     if (shiptype.daysToCount <= 0) {
        //         return this.isSameDate(branchCurrentVaultDate, shipmentVaultDate);
        //     }

        //     // Handle daysToCount > 0: Check if current date is within the allowed range
        //     const currentMoment = moment(branchCurrentVaultDate);
        //     const shipmentMoment = moment(shipmentVaultDate);
        //     const daysDiff = currentMoment.diff(shipmentMoment, 'days');

        //     return daysDiff <= shiptype.daysToCount;
        // }

    }, {
        key: 'isSameDate',
        value: function isSameDate(date1, date2) {
            if (!date1 || !date2) return false;
            return moment(date1).isSame(moment(date2), 'day');
        }
    }, {
        key: 'canEditBag',
        value: function canEditBag(bagIndex) {
            var bag = this.bulkDepositData.bags[bagIndex];
            if (!bag || bag.status !== 'counted') return false;
            if (this.isBulkDepositDeleted()) return false;
            if (this.isBagLocked(bagIndex)) return false;

            if (bag.countVaultDate) {
                if (!this.model.vaultDate) return false;
                if (!this.isSameDate(this.model.vaultDate, bag.countVaultDate)) {
                    return false;
                }
            }

            return true;
        }
    }, {
        key: 'getBagEditRestrictionMessage',
        value: function getBagEditRestrictionMessage(bagIndex) {
            var bag = this.bulkDepositData.bags[bagIndex];
            if (!bag || bag.status !== 'counted') return null;

            if (this.isBulkDepositDeleted()) {
                return 'This bulk deposit has been closed and is read-only.';
            }

            if (this.isBagLocked(bagIndex)) {
                return 'Cannot edit this bag while another bag is being counted.';
            }

            if (bag.countVaultDate && this.model.vaultDate) {
                if (!this.isSameDate(this.model.vaultDate, bag.countVaultDate)) {
                    var countDate = moment(bag.countVaultDate).format('YYYY-MM-DD');
                    var currentDate = moment(this.model.vaultDate).format('YYYY-MM-DD');
                    return 'Cannot edit: Bag was counted on ' + countDate + ', but current vault date is ' + currentDate + '.';
                }
            }

            return null;
        }
    }, {
        key: 'canStartBagCount',
        value: function canStartBagCount(bagIndex) {
            if (this.isBagLocked(bagIndex)) return false;

            var bag = this.bulkDepositData.bags[bagIndex];
            if (!bag || bag.status !== 'pending') return false;

            var hasTrackingId = bag.trackingId && String(bag.trackingId).trim().length > 0;

            var declaredAmountValue = 0;
            if (bag.declaredAmount) {
                if (typeof bag.declaredAmount === 'string') {
                    declaredAmountValue = parseFloat(bag.declaredAmount.replace(/[^0-9.-]/g, '')) || 0;
                } else {
                    declaredAmountValue = Number(bag.declaredAmount) || 0;
                }
            }
            var hasDeclaredAmount = declaredAmountValue > 0;

            return hasTrackingId && hasDeclaredAmount;

            // return this.isWithinDaysToCountLimit();
        }
    }, {
        key: 'addBulkDepositBag',
        value: function addBulkDepositBag() {
            if (this.hasCountingBag()) {
                this.Modal.errorModal('Cannot add new bags while a bag is being counted.');
                return;
            }
            var newIndex = this.bulkDepositData.metadata.nextBagIndex;
            this.bulkDepositData.bags[newIndex] = this._getDefaultBagData();
            this.bulkDepositData.metadata.nextBagIndex++;
            this.calculateBulkDepositTotals();
        }
    }, {
        key: 'removeBulkDepositBag',
        value: function removeBulkDepositBag(bagIndex) {
            var bag = this.bulkDepositData.bags[bagIndex];

            if (!bag) return;

            if (bag.status === 'counted' || bag.shipmentId) {
                this.Modal.errorModal('Cannot remove bags that have been counted.');
                return;
            }

            delete this.bulkDepositData.bags[bagIndex];
            this.calculateBulkDepositTotals();
        }
    }, {
        key: 'updateBagTrackingId',
        value: function updateBagTrackingId(bagIndex, trackingId) {
            if (this.isBagLocked(bagIndex)) return;

            var bag = this.bulkDepositData.bags[bagIndex];
            if (bag && bag.trackingId !== trackingId) {
                bag.trackingId = trackingId;
            }
        }
    }, {
        key: 'updateBagDeclaredAmount',
        value: function updateBagDeclaredAmount(bagIndex, declaredAmount) {
            if (this.isBagLocked(bagIndex)) return;

            var bag = this.bulkDepositData.bags[bagIndex];
            if (!bag) return;

            var numericValue = declaredAmount;
            if (typeof declaredAmount === 'string') {
                numericValue = parseFloat(declaredAmount.replace(/[^0-9.-]/g, '')) || null;
            }

            bag.declaredAmount = numericValue;

            if (this.isBagActive(bagIndex)) {
                this.activeBagData.depositData.declaredTotalAmount = numericValue;
                this.calculateActiveBagTotals();
            }

            this.calculateBulkDepositTotals();
        }
    }, {
        key: 'toggleBagCollapse',
        value: function toggleBagCollapse(bagIndex) {
            var bag = this.bulkDepositData.bags[bagIndex];
            if (!bag) return;

            var canExpand = bag.status === 'counting' || bag.status === 'counted' || bag.shipmentId;
            if (!canExpand) return;

            // If this bag is already active, restore original values and clear it (collapse)
            if (this.isBagActive(bagIndex)) {
                if (this.activeBagData.originalBagValues) {
                    var original = this.activeBagData.originalBagValues;
                    bag.countedAmount = original.countedAmount;
                    bag.countedVariance = original.countedVariance;
                    bag.declaredAmount = original.declaredAmount;
                }

                if (this.activeBagData.isEditMode) {
                    this.activeBagData.isEditMode = false;
                }

                this.calculateBulkDepositTotals();
                this.clearActiveBag();
                return;
            }

            this.setActiveBag(bagIndex, true);
        }
    }, {
        key: 'startBagCount',
        value: function startBagCount(bagIndex) {
            var _this41 = this;

            var bag = this.bulkDepositData.bags[bagIndex];
            if (!this.canStartBagCount(bagIndex)) {
                this.Modal.errorModal('Please provide tracking ID and declared amount');
                return;
            }

            if (bag.shipmentId) {
                bag.status = 'counting';
                this.setActiveBag(bagIndex, true);
                return;
            }

            this.shipmentLoading = true;
            this.AtmResidualDepositService.createIndividualBagShipment(this.bulkDepositData.shipment.trackingId, bag.trackingId, bag.declaredAmount, this.model.loggedInUserId).then(function (data) {
                _this41.shipmentLoading = false;
                if (data && data.success) {
                    bag.shipmentId = data.shipmentId;
                    bag.status = 'counting';
                    _this41.setActiveBag(bagIndex, true);
                }
            }).catch(function (err) {
                _this41.shipmentLoading = false;
                _this41.Modal.errorModal(err.data && err.data.message ? err.data.message : 'Error creating bag shipment');
            });
        }
    }, {
        key: 'activeBagDenomChange',
        value: function activeBagDenomChange(denomId) {
            if (!this.activeBagData.depositData.denominations) return;

            var index = this.activeBagData.depositData.denominations.findIndex(function (item) {
                return item.id === denomId;
            });

            if (index !== -1) {
                var denom = this.activeBagData.depositData.denominations[index];
                var countedTotal = Number(denom.totalCounted * denom.faceValue) || 0;
                denom.totalValue = countedTotal;
            }

            this.calculateActiveBagTotals();
            this.updateBagDenomsTotals(this.activeBagData.bagIndex);
        }
    }, {
        key: 'commitActiveBagCount',
        value: function commitActiveBagCount() {
            var _this42 = this;

            this.monthlySupId = null;
            var bag = this.activeBagData.bag;

            var depositData = this.activeBagData.depositData;
            if (!bag || !depositData) {
                this.Modal.errorModal('No bag selected for counting');
                return;
            }

            if (depositData.totalAmount === 0) {
                this.Modal.errorModal('Please enter denomination counts');
                return;
            }

            if (!depositData.declaredTotalAmount || depositData.declaredTotalAmount <= 0) {
                this.Modal.errorModal('Declared amount must be greater than 0');
                return;
            }

            // if (!this.isWithinDaysToCountLimit()) {
            //     this.Modal.errorModal('Days to Count limit has been exceeded for shiptype');
            //     return;
            // }

            if (!this.pickupDate || !this.model.beginTime) {
                this.Modal.errorModal('Pickup date and time are required before committing this bag.');
                return;
            }

            var newAmount = depositData.totalAmount || 0;
            this.checkMonthlyCountLimit(newAmount).then(function () {
                if (depositData.countedVariance && depositData.countedVariance !== 0) {
                    _this42.Modal.residualComments({ trackingId: bag.trackingId }, function (_ref28) {
                        var modal = _ref28.modal,
                            comments = _ref28.comments;

                        _this42._executeActiveBagCommit(comments);
                        modal.close();
                    }, function (_ref29) {
                        var modal = _ref29.modal;

                        modal.close();
                    });
                } else {
                    _this42._executeActiveBagCommit(null);
                }
            });
        }
    }, {
        key: '_executeActiveBagCommit',
        value: function _executeActiveBagCommit(comment) {
            var _this43 = this;

            var bag = this.activeBagData.bag;
            var depositData = this.activeBagData.depositData;

            var denomsData = depositData.denominations.map(function (denom) {
                return {
                    denominationId: denom.id,
                    quantity: Number(denom.totalCounted) || 0
                };
            });

            var fundingSource = this.model.locationId.Id;
            var trackingId = bag.trackingId;
            var branchId = this.model.branch;
            var pickupDate = moment(this.pickupDate).format('YYYY-MM-DD');
            var pickupTime = moment(this.model.beginTime).format('HH:mm:ss');
            var branchTimeZone = this.branchTimeZone;
            var countedByUserId = this.model.loggedInUserId;
            var declaredTotalAmount = depositData.declaredTotalAmount;
            var countedVariance = depositData.countedVariance;

            this.checkSupervisorApproval(countedVariance).then(function (supId) {
                _this43.isBulkDepositCommit = true;

                if (bag.depositRecordId) {
                    _this43.AtmResidualDepositService.editDepositCount(fundingSource, trackingId, comment, denomsData, branchId, pickupDate, pickupTime, branchTimeZone, countedByUserId, bag.depositRecordId, declaredTotalAmount, countedVariance, supId, _this43.browserTimezone, _this43.monthlySupId, _this43.monthlyLimitDetails ? _this43.monthlyLimitDetails.monthlyCashCountLimitAmount : 0, _this43.monthlyLimitDetails ? _this43.monthlyLimitDetails.totalCountedThisMonth : 0, _this43.monthlyLimitDetails ? _this43.monthlyLimitDetails.newCountAmount : 0).then(function () {
                        _this43.isBulkDepositCommit = false;

                        bag.countedAmount = depositData.totalAmount;
                        bag.countedVariance = depositData.countedVariance;

                        if (depositData.denominations) {
                            depositData.previousDenominations = _.cloneDeep(depositData.denominations);
                        }
                        _this43.loadActiveBagData().then(function () {
                            _this43.activeBagData.isEditMode = false;
                            _this43.clearActiveBag();
                            _this43.calculateBulkDepositTotals();
                        });
                    }).catch(function (err) {
                        _this43.isBulkDepositCommit = false;
                        if (err && err.data && err.data.message) {
                            _this43.Sound.PlayErrorBeep("#scanner_beep");
                            _this43.Modal.errorModal('error.' + err.data.message);
                        } else {
                            _this43.Modal.errorModal('Error editing bag count');
                        }
                    });
                } else {
                    _this43.AtmResidualDepositService.commitDepositCount(fundingSource, trackingId, comment, denomsData, branchId, pickupDate, pickupTime, branchTimeZone, countedByUserId, declaredTotalAmount, countedVariance, supId, _this43.browserTimezone, _this43.monthlySupId, _this43.monthlyLimitDetails ? _this43.monthlyLimitDetails.monthlyCashCountLimitAmount : 0, _this43.monthlyLimitDetails ? _this43.monthlyLimitDetails.totalCountedThisMonth : 0, _this43.monthlyLimitDetails ? _this43.monthlyLimitDetails.newCountAmount : 0).then(function () {
                        _this43.isBulkDepositCommit = false;

                        bag.status = 'counted';
                        bag.countedAmount = depositData.totalAmount;
                        bag.countedVariance = depositData.countedVariance;
                        _this43.activeBagData.isEditMode = false;
                        _this43.loadActiveBagData().then(function () {
                            _this43.activeBagData.isEditMode = false;
                            _this43.clearActiveBag();
                            _this43.calculateBulkDepositTotals();
                        });

                        _this43.Sound.playSuccessBeep("#success_beep");
                    }).catch(function (err) {
                        _this43.isBulkDepositCommit = false;
                        if (err && err.data && err.data.message) {
                            _this43.Sound.PlayErrorBeep("#scanner_beep");
                            _this43.Modal.errorModal('error.' + err.data.message);
                        } else {
                            _this43.Modal.errorModal('Error committing bag count');
                        }
                    });
                }
            }).catch(function (err) {
                _this43.isBulkDepositCommit = false;
            });
        }
    }, {
        key: 'editBag',
        value: function editBag(bagIndex) {
            var bag = this.bulkDepositData.bags[bagIndex];
            if (!bag || bag.status !== 'counted') {
                this.Modal.errorModal('Can only edit counted bags');
                return;
            }

            if (!bag.trackingId) {
                this.Modal.errorModal('Bag tracking ID is required');
                return;
            }

            if (!this.canEditBag(bagIndex)) {
                this.Modal.errorModal('Cannot edit bag: Parent bulk deposit must be on the same vault date or location must allow editing anytime');
                return;
            }

            this.activeBagData.originalBagValues = {
                countedAmount: bag.countedAmount || 0,
                countedVariance: bag.countedVariance || 0,
                declaredAmount: bag.declaredAmount || 0
            };

            this.setActiveBag(bagIndex, true);
            this.activeBagData.isEditMode = true;
        }
    }, {
        key: 'cancelBagEdit',
        value: function cancelBagEdit() {
            var _this44 = this;

            var bagIndex = this.activeBagData.bagIndex;
            var bag = this.activeBagData.bag;

            if (!bag) return;

            var isBagStillExpanded = this.isBagActive(bagIndex);

            if (bag.status === 'counted' && bag.trackingId && isBagStillExpanded) {
                this.loadActiveBagData().then(function () {
                    var depositData = _this44.activeBagData.depositData;
                    if (depositData && depositData.depositRecord) {
                        bag.countedAmount = depositData.depositRecord.totalAmount || 0;
                        bag.countedVariance = depositData.depositRecord.countedVariance || 0;
                        bag.declaredAmount = depositData.depositRecord.declaredTotalAmount || bag.declaredAmount || 0;
                    }

                    if (_this44.activeBagData.originalBagValues) {
                        _this44.activeBagData.originalBagValues = null;
                    }

                    _this44.activeBagData.isEditMode = false;
                    _this44.calculateBulkDepositTotals();
                });
            } else {
                // Restore original values
                if (this.activeBagData.originalBagValues) {
                    var original = this.activeBagData.originalBagValues;
                    bag.countedAmount = original.countedAmount;
                    bag.countedVariance = original.countedVariance;
                    bag.declaredAmount = original.declaredAmount;
                    this.activeBagData.originalBagValues = null;
                }

                this.activeBagData.isEditMode = false;
                if (!isBagStillExpanded) {
                    this.clearActiveBag();
                }
                this.calculateBulkDepositTotals();
            }
        }
    }, {
        key: 'reopenBulkDepositCount',
        value: function reopenBulkDepositCount() {
            var _this45 = this;

            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_title'),
                message: 'Are you sure you want to reopen the bulk deposit?',
                callback: function callback(_ref30) {
                    var modal = _ref30.modal;

                    var trackingId = _this45.bulkDepositData.shipment.trackingId;
                    var userId = _this45.model.loggedInUserId;

                    _this45.AtmResidualDepositService.reopenBulkDeposit(trackingId, userId).then(function () {
                        _this45.bagCount();
                        _this45.loadBulkDepositShipment();
                    }).catch(function (err) {
                        _this45.Modal.errorModal(err.data && err.data.message ? err.data.message : 'Error reopening bulk deposit count');
                    }).finally(function () {
                        modal.close();
                    });
                },
                type: 'success',
                buttons: ['common.yes', 'common.no']
            });
        }
    }, {
        key: 'closeBulkDepositCount',
        value: function closeBulkDepositCount() {
            var _this46 = this;

            this.monthlySupId = null;

            var amount = this.bulkDepositData.countedTotal;
            this.checkMonthlyCountLimit(amount, 'bulkdeposit').then(function () {
                _this46.Modal.confirmSupervisor('close-bulk-deposit-count', { trackingId: _this46.bulkDepositData.shipment.trackingId }, function (_ref31) {
                    var modal = _ref31.modal,
                        supId = _ref31.supId;

                    _this46.finalizeBulkDepositCount(_this46.bulkDepositData.shipment.trackingId, supId);
                    modal.close();
                }, function (_ref32) {
                    var modal = _ref32.modal;

                    modal.close();
                });
            });
        }
    }, {
        key: 'finalizeBulkDepositCount',
        value: function finalizeBulkDepositCount(trackingId, supId) {
            var _this47 = this;

            this.bulkDepositData.metadata.isClosingBulkDeposit = true;

            this.AtmResidualDepositService.finalizeBulkDeposit(trackingId, supId).then(function () {
                _this47.bulkDepositData.metadata.isClosingBulkDeposit = false;

                if (_this47.model.locationId) {
                    _this47.bagCount();
                }

                _this47.Modal.confirm({
                    header: _this47.$translate.instant('successModal.title'),
                    message: _this47.$translate.instant('Bulk deposit count has been closed successfully.'),
                    callback: function callback(_ref33) {
                        var modal = _ref33.modal;

                        modal.close();
                        _this47.resetBulkDepositData();
                        _this47.model.bagId = '';
                        _this47.focusElementById('trackingId');
                    },
                    type: 'success',
                    buttons: ['common.close']
                });
            }).catch(function (err) {
                _this47.bulkDepositData.metadata.isClosingBulkDeposit = false;
                _this47.Modal.errorModal(err.data && err.data.message ? err.data.message : 'Error closing bulk deposit count');
            });
        }
    }, {
        key: 'allBagsCommitted',
        value: function allBagsCommitted() {
            var _this48 = this;

            var bagKeys = (0, _keys2.default)(this.bulkDepositData.bags);
            if (bagKeys.length === 0) return false;

            return bagKeys.every(function (key) {
                var bag = _this48.bulkDepositData.bags[key];
                return bag.status === 'counted' && bag.trackingId && bag.declaredAmount;
            });
        }
    }, {
        key: 'getCountedBagsCount',
        value: function getCountedBagsCount() {
            return (0, _values2.default)(this.bulkDepositData.bags).filter(function (bag) {
                return bag.status === 'counted';
            }).length;
        }
    }, {
        key: 'getTotalBagsCount',
        value: function getTotalBagsCount() {
            return (0, _keys2.default)(this.bulkDepositData.bags).length;
        }
    }, {
        key: 'validateManuallyPriorLoadedAmount',
        value: function validateManuallyPriorLoadedAmount(denomination) {
            if (denomination.manualPriorLoadAmount > 0) {

                var divisor = (denomination.coinPackaging === 'ROLLED' || denomination.coinPackaging === 'INDIVIDUAL') && denomination.unitValue != null ? Number(denomination.unitValue) : Number(denomination.faceValue);

                divisor = divisor || 1;

                var scaledAmount = Math.round(Number(denomination.manualPriorLoadAmount) * 10000);
                var scaledDivisor = Math.round(divisor * 10000);

                denomination.isValidAmount = scaledAmount % scaledDivisor === 0;
            } else if (denomination.manualPriorLoadAmount == null || denomination.manualPriorLoadAmount === undefined || denomination.manualPriorLoadAmount === "") {
                denomination.isValidAmount = false;
            } else {
                denomination.isValidAmount = true;
            }
        }
    }, {
        key: 'isDisableExpectedResidual',
        value: function isDisableExpectedResidual() {
            if (this.expectedResidualDetails && this.expectedResidualDetails.length > 0) {
                return this.expectedResidualDetails.some(function (d) {
                    return !d.isValidAmount && (d.manualPriorLoadAmount >= 0 || d.manualPriorLoadAmount == null || d.manualPriorLoadAmount == undefined);
                });
            }
            return false;
        }
    }]);
    return ATMCountController;
}();

exports.default = ATMCountController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atm_count = __webpack_require__(1622);

var _atm_count2 = _interopRequireDefault(_atm_count);

var _print = __webpack_require__(1627);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMCountModule = angular.module('atmCount', [_print2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/atm-count');

    $stateProvider.state('atmCount', {
        url: '/atm-count',
        component: 'atmCount',
        data: {
            requireLogin: true,
            requireACL: 'atm_count.all'
        },
        parent: 'app'
    });
}]).component('atmCount', _atm_count2.default).directive('roundTo2Decimals', function () {
    return {
        require: ['ngModel', '^atmCount'],
        link: function link(scope, element, attrs, ctrls) {
            var ngModel = ctrls[0];
            var atmCountCtrl = ctrls[1];
            if (!atmCountCtrl || typeof atmCountCtrl.roundTo2DecimalsForDisplay !== 'function') return;
            ngModel.$formatters.push(function (value) {
                if (value == null || value === '') return value;
                return atmCountCtrl.roundTo2DecimalsForDisplay(value);
            });
        }
    };
}).directive('denominationMultiple', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            denomFaceValue: '<denominationMultiple',
            coinPackaging: '<',
            unitValue: '<'
        },
        link: function link(scope, element, attrs, ngModel) {
            function isValidAmount(amount, faceValue) {
                if (!amount) return true;

                var face = Number(faceValue) || 0;
                var value = Number(amount);

                if (!isFinite(value) || face <= 0) return true;
                if (value <= 0) return true;

                var faceStr = face.toString();
                var valueStr = value.toString();

                var faceDecimals = 0;
                var faceDotIndex = faceStr.indexOf('.');
                if (faceDotIndex >= 0) {
                    faceDecimals = faceStr.length - faceDotIndex - 1;
                }

                var valueDecimals = 0;
                var valueDotIndex = valueStr.indexOf('.');
                if (valueDotIndex >= 0) {
                    valueDecimals = valueStr.length - valueDotIndex - 1;
                }

                // Use the maximum decimal places from either the face value or the user input
                var decimals = Math.max(faceDecimals, valueDecimals);
                var factor = Math.pow(10, decimals);

                var scaledFace = Math.round(face * factor);
                if (scaledFace <= 0) return true;

                var scaledValue = Math.round(value * factor);

                if (scaledValue < scaledFace) return false;
                return scaledValue % scaledFace === 0;
            }

            ngModel.$validators.denominationMultiple = function (modelValue) {
                // Default to standard face value logic
                var targetValidationValue = scope.denomFaceValue;

                // Override for ROLLED and INDIVIDUAL to check against unitValue instead
                if (scope.unitValue && ['ROLLED', 'INDIVIDUAL'].includes(scope.coinPackaging)) {
                    targetValidationValue = scope.unitValue;
                }

                return isValidAmount(modelValue, targetValidationValue);
            };

            scope.$watchGroup(['denomFaceValue', 'coinPackaging', 'unitValue'], function () {
                ngModel.$validate();
            });
        }
    };
}).name;

exports.default = ATMCountModule;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atm_count_print = __webpack_require__(2642);

var _atm_count_print2 = _interopRequireDefault(_atm_count_print);

var _atm_count_print3 = __webpack_require__(1626);

var _atm_count_print4 = _interopRequireDefault(_atm_count_print3);

__webpack_require__(2929);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMCountPrintComponent = {
  restrict: 'E',
  bindings: {},
  template: _atm_count_print2.default,
  controller: _atm_count_print4.default
};

exports.default = ATMCountPrintComponent;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMCountPrintController = function () {
    /*@ngInject*/
    ATMCountPrintController.$inject = ["$translate"];
    function ATMCountPrintController($translate) {
        (0, _classCallCheck3.default)(this, ATMCountPrintController);

        this.$translate = $translate;
    }

    (0, _createClass3.default)(ATMCountPrintController, [{
        key: "$onInit",
        value: function $onInit() {
            if (window.opener && window.opener.w && window.opener.w.printData && window.opener.w.printData.doPrint) {
                this.pendingATMResidualCount = window.opener.w.printData.pendingATMResiduals;
                this.routeId = window.opener.w.printData.route;
                this.branchId = window.opener.w.printData.branchId;
                this.fundingSource = window.opener.w.printData.fundingSource;
                this.amount = window.opener.w.printData.amount;
                setTimeout(function () {
                    window.print();
                }, 1000);
            }
        }
    }, {
        key: "getOrderType",
        value: function getOrderType(shiptype, type) {
            if (shiptype == "C" && type !== null) {
                return this.$translate.instant('atm_residual.order_type_' + type);
            } else if (shiptype == "C" && type == null) {
                return shiptype.toUpperCase();
            } else {
                return shiptype.toUpperCase();
            }
        }
    }]);
    return ATMCountPrintController;
}();

exports.default = ATMCountPrintController;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _atm_count_print = __webpack_require__(1625);

var _atm_count_print2 = _interopRequireDefault(_atm_count_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMCountPrintModule = angular.module('atmCountPrint', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider.otherwise('/atm-count');

	$stateProvider.state('atmCountPrint', {
		url: '/atm-count-print',
		component: 'atmCountPrint',
		data: {
			requireLogin: true,
			requireACL: 'atm_count.all'
		}
	});
}]).component('atmCountPrint', _atm_count_print2.default).name;

exports.default = ATMCountPrintModule;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(2930);

var autoRoutingComponent = {
  restrict: "E",
  bindings: {}
};

exports.default = autoRoutingComponent;

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auto_routing = __webpack_require__(1628);

var _auto_routing2 = _interopRequireDefault(_auto_routing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var autoRoutingModule = angular.module("autoRouting", []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise("/autoRouting");

  $stateProvider.state("autoRouting", {
    url: "/v2/index.html#/automated-routing-control",
    component: "autoRouting",
    data: {
      requireLogin: true
    }
  });
}]).component("autoRouting", _auto_routing2.default).name;

exports.default = autoRoutingModule;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bagout = __webpack_require__(2643);

var _bagout2 = _interopRequireDefault(_bagout);

var _bagout3 = __webpack_require__(1631);

var _bagout4 = _interopRequireDefault(_bagout3);

__webpack_require__(2931);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bagoutComponent = {
  restrict: 'E',
  bindings: {},
  template: _bagout2.default,
  controller: _bagout4.default
};

exports.default = bagoutComponent;

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BagoutController = function () {
  /*@ngInject*/
  BagoutController.$inject = ["Auth", "$state", "User", "UserService", "RouteService", "$translate", "BranchService", "Modal", "ShipmentService", "$q", "$scope", "Sound", "SetupService", "$rootScope", "LocationService", "BagoutService", "$location", "Configs"];
  function BagoutController(Auth, $state, User, UserService, RouteService, $translate, BranchService, Modal, ShipmentService, $q, $scope, Sound, SetupService, $rootScope, LocationService, BagoutService, $location, Configs) {
    (0, _classCallCheck3.default)(this, BagoutController);


    this.BranchService = BranchService;
    this.$state = $state;
    this.$q = $q;
    this.User = User;
    this.RouteService = RouteService;
    this.ShipmentService = ShipmentService;
    this.SetupService = SetupService;
    this.LocationService = LocationService;
    this.BagoutService = BagoutService;
    this.$translate = $translate;
    this.Modal = Modal;
    this.$scope = $scope;
    this.Sound = Sound;
    this.isError = false;
    this.$rootScope = $rootScope;
    this.user;
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();

    this.branches = [];
    this.routes = [];

    this.message = null;
    this.messageTwo = null;
    this.lastBagoutScanned = null;
    this.lastbagScanned = null;
    this.isBagScanned = false;
    this.prevErrorCode = '';
    this.forceToStope = ['90703', '90704', '90706'];
    this.bagScanDisable = false;
    this.bagoutScanDisable = true;
    this.loading = false;
    this.branchId = null;
    this.bagScanLimit = "";
    this.checkOnlyOnce = false;
    this.totalLocations = 0;
    this.locationList = [];
    this.loadRemainingBagouts = false;
    this.BagoutInfo = '';
    this.loadBagouts = false;
    this.$location = $location;
    this.$rootScope.$broadcast('routeChange', '/app/bag-out');
    this.sortBy = {
      fieldName: 'id',
      sortASC: true
    };
    this.Configs = Configs;
  }

  (0, _createClass3.default)(BagoutController, [{
    key: 'resetModel',
    value: function resetModel() {
      this.model = {
        bagout: {
          trackingId: ''
        },
        bag: {
          id: ''
        }
      };
    }
  }, {
    key: 'focusElementById',
    value: function focusElementById(id) {
      setTimeout(function () {
        document.getElementById(id).focus();
      }, 500);
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.resetModel();
      // this.focusElementById('bag-id');
      var branchId = this.User.getUser().branchId;
      this.branchId = branchId;

      this.SetupService.get(branchId).then(function (setup) {
        _this.prefixes = setup.prefixes;
        _this.bagScanLimit = setup.packCharLength;
        _this.loadDeliverToLocation('', 0);
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this.Modal.errorModal(err.data.message);
        }
      });
    }
  }, {
    key: 'scanError',
    value: function scanError() {
      this.bagScanLimitExceed = true;
      this.checkOnlyOnce = true;
      this.loading = false;
      this.isError = true;
      this.bagoutScanDisable = false;
    }
  }, {
    key: 'bagoutScanned',
    value: function bagoutScanned(event) {
      var _this2 = this;

      if (!this.model.bag.trackingId || !this.model.bagout.id) {
        return;
      }

      this.loading = true;
      this.reset();

      this.lastBagoutScanned = {
        scannedDate: moment(new Date()).format('ddd ,ll'),
        scannedTime: moment(new Date()).format('LTS'),
        id: this.model.bagout.id
      };

      if (this.model.bagout.id) {
        // let finalBagOutId;
        // if (this.prefixes && this.prefixes.bagout) {
        //   if (this.model.bagout.id.toUpperCase().startsWith(this.prefixes.bagout[0])) {
        //     finalBagOutId = this.model.bagout.id.slice(this.prefixes.bagout[0].length)
        //   } else {
        //     finalBagOutId = this.model.bagout.id;
        //   }
        // } else {
        //   finalBagOutId = this.model.bagout.id;
        // }

        // if (this.bagScanLimit && this.bagScanLimit > 0) {
        //   if (finalBagOutId.length > this.bagScanLimit && (!this.checkOnlyOnce || finalBagOutId.length !== this.checkLength)) {
        //     this.lastScanned = finalBagOutId;
        //     this.checkLength = finalBagOutId.length;
        //     finalBagOutId = "";
        //     this.scanError();
        //     // this.clearBagout(event);
        //     this.clearBagId(event);
        //     this.bagScanError = this.$translate.instant('common.scan_error');
        //     return Promise.resolve();
        //   }
        //   else {
        //     this.checkLength = finalBagOutId.length > this.bagScanLimit ? finalBagOutId.length : this.bagScanLimit;
        //   }
        // }

        // this.model.bagout.id = finalBagOutId;

        return this.ShipmentService.addToBag(this.model.bag.trackingId, this.model.bag.toLocationId, this.model.bagout.id, this.lastBagScanned.branchId).then(function (result) {
          if (result.status === false) {
            _this2.loading = true;
            _this2.isError = true;
            _this2.message = _this2.$translate.instant('error.' + result.message) || null;
            _this2.Sound.PlayErrorBeep("#scanner_beep");
            return;
          } else {
            _this2.isError = false;
            _this2.message = _this2.$translate.instant('bagout.item') + ' ' + _this2.model.bag.trackingId + ' ' + _this2.$translate.instant('bagout.added') + ' (' + _this2.$translate.instant('bagout.bagout') + ' | ' + _this2.model.bagout.id + ') ';
            _this2.messageTwo = _this2.$translate.instant('bagout.totalItems') + ' | ' + result.currentBagCount;

            _this2.model.bagout.destination = {
              name: result.bagDeliveryLocationName,
              address: result.bagDeliveryLocationAddress
            };
            _this2.Sound.playSuccessBeep("#success_beep");
          }

          delete _this2.bagScanError;
          _this2.lastBagoutScanned = (0, _assign2.default)({}, _this2.lastBagoutScanned, _this2.model.bagout);
          _this2.loading = false;
          _this2.model.bag = {};
          // this.model.bagout.id = ''
          _this2.prevErrorCode = '';
          _this2.bagoutScanDisable = false;
          _this2.focusElementById('bag-id');
        }).catch(function (err) {
          delete _this2.bagScanError;
          _this2.Sound.PlayErrorBeep("#scanner_beep");
          _this2.isError = true;

          if (err.data && err.data.message) {

            // if (this.forceToStope.indexOf(err.data.message) > -1) {
            //   this.model.bag.trackingId = undefined;
            //   this.clearBagId(event);
            // }

            _this2.message = _this2.$translate.instant('error.' + err.data.message, {
              trackingId: _this2.lastBagScanned.trackingId,
              bagoutId: _this2.model.bagout.id
            }) || null;

            _this2.lastBagoutScanned = (0, _assign2.default)({}, _this2.lastBagoutScanned, _this2.model.bagout);
            _this2.prevErrorCode = err.data.message;
            // return this.clearBagout(event);

            if (err.data.message == '90704') {
              _this2.clearBagout(event);
              _this2.bagoutScanDisable = true;
              _this2.loading = false;
              // this.focusElementById('bag-id'); 
              // this.focusElementById('bagout-id'); 
              return _this2.clearBagId(event);
            } else {
              _this2.clearBagId(event);
              return _this2.clearBagout(event);
            }
          } else {
            _this2.message = err.toString();
          }
        });
      } else {
        this.bagoutScanDisable = false;
      }
    }
  }, {
    key: 'selectDeliveryLocation',
    value: function selectDeliveryLocation(shipment) {
      var locationFields = ['deliveryLoc1Id', 'deliveryLoc2Id', 'deliveryLocCodId', 'deliveryLocCoinId'];
      var defer = this.$q.defer();
      var availableDeliveryLocations = [];

      locationFields.forEach(function (locationField) {
        var locationId = shipment.toLocation[locationField];
        if (locationId && availableDeliveryLocations.indexOf(locationId) === -1) {
          availableDeliveryLocations.push(locationId);
        }
      });

      if (availableDeliveryLocations.length === 0) {
        defer.reject(new Error('Delivery Locations are missing for location ' + shipment.toLocation.name));
      } else if (availableDeliveryLocations.length === 1) {
        defer.resolve(availableDeliveryLocations[0]);
      } else {
        this.Modal.selectDeliveryLocation(availableDeliveryLocations, function (_ref) {
          var $scope = _ref.$scope,
              modal = _ref.modal;

          defer.resolve($scope.selectedLocationId);
          modal.close();
        }, function (_ref2) {
          var modal = _ref2.modal;

          modal.close();
        });
      }

      return defer.promise;
    }
  }, {
    key: 'bagScanned',
    value: function bagScanned(event) {
      var _this3 = this;

      if (!this.model.bag.trackingId) {
        return;
      }

      this.bagScanDisable = true;
      this.loading = false;

      if (this.model.bag.trackingId && this.prefixes && this.prefixes.deliveryAndPickups) {
        if (this.model.bag.trackingId.toUpperCase().startsWith(this.prefixes.deliveryAndPickups[0])) {
          this.model.bag.trackingId = this.model.bag.trackingId.slice(this.prefixes.deliveryAndPickups[0].length).trim();
        }
      }

      if (this.forceToStope.indexOf(this.prevErrorCode) >= 0) {
        if (this.lastBagScanned && this.lastBagScanned.trackingId !== this.model.bag.trackingId) {
          this.isError = true;
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.model.bag.trackingId = undefined;
          this.model.bag.toLocation = undefined;
          // this.model.bagout = {};
          this.bagScanDisable = false;
          this.message = this.$translate.instant('error.rescanLastItemId');
          this.messageTwo = '';
          return _promise2.default.resolve();
        }
      }

      var bagScanObj = {
        queryJSON: {
          rules: [{
            field: 'trackingId',
            condition: '=',
            data: this.model.bag.trackingId
          }, {
            field: 'branchId',
            condition: '=',
            data: this.branchId
          }],
          operator: 'AND'
        }
      };

      // this.ShipmentService.get(this.model.bag.trackingId)
      return this.ShipmentService.all(bagScanObj).then(function (shipments) {
        var shipment = shipments.results.length > 0 ? shipments.results[0] : undefined;

        delete _this3.lastBagScanned;
        delete _this3.isError;
        delete _this3.message;
        delete _this3.messageTwo;
        delete _this3.bagScanError;
        _this3.lastBagScanned = (0, _assign2.default)({}, shipment);

        if (!shipment) {
          _this3.lastBagScanned = { trackingId: _this3.model.bag.trackingId };
          _this3.isError = true;
          _this3.Sound.PlayErrorBeep("#scanner_beep");
          _this3.message = _this3.message = _this3.$translate.instant('bagout.bagNotFound') + ' (' + _this3.lastBagScanned.trackingId + ' | ' + _this3.$translate.instant('bagout.bagNotFound') + ') ';
          _this3.focusElementById('bag-id');
          return _this3.clearBagId(event);
        }

        if (shipment.branchId !== _this3.branchId) {
          _this3.Sound.PlayErrorBeep("#scanner_beep");
          _this3.isError = true;
          _this3.message = _this3.$translate.instant("error." + 91321);
          _this3.bagoutScanDisable = true;
          _this3.focusElementById('bag-id');
          return _this3.clearBagId(event);
        }

        if (shipment.bagSeal) {
          _this3.isError = true;
          _this3.Sound.PlayErrorBeep("#scanner_beep");
          _this3.message = _this3.$translate.instant('bagout.bagAlreadyAdded') + ' (' + _this3.lastBagScanned.trackingId + ' | ' + _this3.$translate.instant('bagout.previouslyAdded') + ') ';
          _this3.focusElementById('bag-id');
          return _this3.clearBagId(event);
        }

        if (shipment.holdFlag) {
          _this3.isError = true;
          _this3.Sound.PlayErrorBeep("#scanner_beep");
          _this3.message =
          // this.$translate.instant('bagout.shipmentOnHold') + '<br/>' +
          _this3.lastBagScanned.trackingId + ' | ' + _this3.$translate.instant('bagout.shipmentOnHold');
          _this3.focusElementById('bag-id');
          return _this3.clearBagId(event);
        } else if (shipment.deliveredFlag) {
          _this3.isError = true;
          _this3.Sound.PlayErrorBeep("#scanner_beep");
          _this3.message = 'Shipment has already been delivered (' + _this3.lastBagScanned.trackingId + ' | Delivered) ';
          _this3.focusElementById('bag-id');
          return _this3.clearBagId(event);
        } else if (!shipment.checkedIn && shipment.shiptypeId !== 'BULKCASH') {
          _this3.isError = true;
          _this3.Sound.PlayErrorBeep("#scanner_beep");
          _this3.message = _this3.$translate.instant('bagout.shipmentNotCheckedIn') + ' (' + _this3.lastBagScanned.trackingId + ' | ' + _this3.$translate.instant('bagout.notCheckedIn') + ') ';
          _this3.focusElementById('bag-id');
          return _this3.clearBagId(event);
        }

        if (shipment.toLocation) {
          _this3.model.bag.deliveryLocationId = shipment.toLocation.id;
          _this3.Sound.playSuccessBeep("#success_beep");
          _this3.bagScanDisable = false;
          _this3.bagoutScanDisable = false;
          // this.focusElementById('bagout-id');
          _this3.focusElementById('bag-id');
        } else {
          _this3.isError = true;
          _this3.Sound.PlayErrorBeep("#scanner_beep");
          _this3.message = _this3.$translate.instant('bagout.wrongDestination') || null;
          _this3.focusElementById('bag-id');
          return _this3.clearBagId(event);
        }

        // this.selectDeliveryLocation(shipment)
        // .then((selectedLocationId) => {
        //   this.model.bag.deliveryLocationId = selectedLocationId;
        //   this.focusElementById('bagout-id');
        // })
        // .catch((err) => {
        //   this.isError = true;
        //   this.message = err.message
        // })

        _this3.model.bag = shipment;
        if (_this3.forceToStope.indexOf(_this3.prevErrorCode) >= 0) {
          if (_this3.lastBagScanned.trackingId == _this3.model.bag.trackingId) {
            _this3.Sound.playSuccessBeep("#success_beep");
            _this3.model.bag.toLocation = undefined;
            _this3.model.bag.trackingId = null;
            _this3.prevErrorCode = undefined;
            _this3.bagScanDisable = false;
            _this3.bagoutScanDisable = true;
            _this3.focusElementById('bag-id');
          }
        }
      }).catch(function (err) {
        _this3.Sound.PlayErrorBeep("#scanner_beep");
        _this3.lastBagScanned = { trackingId: _this3.model.bag.trackingId };
        _this3.isError = true;
        _this3.message = _this3.$translate.instant("error." + err.data.message);
        // this.model.bag = {};
        _this3.bagoutScanDisable = true;
        _this3.clearBagId(event);
      });
    }
  }, {
    key: 'closePrint',
    value: function closePrint() {
      var _this4 = this;

      // if (this.isLoading) true;
      // this.isLoading = true;
      // this.Modal.closeBagout('', ({ modal }) => {
      //   this.isLoading = false;
      //   if (modal) modal.close();
      // }, ({ modal }) => {
      //   this.isLoading = false;
      //   if (modal) modal.close();
      // });
      if (this.model.bagout.id === "" || this.model.bagout.id == undefined) {
        return;
      }

      var finalBagOutId = void 0;
      if (this.prefixes && this.prefixes.bagout) {
        if (this.model.bagout.id.toUpperCase().startsWith(this.prefixes.bagout[0])) {
          finalBagOutId = this.model.bagout.id.slice(this.prefixes.bagout[0].length);
        } else {
          finalBagOutId = this.model.bagout.id;
        }
      } else {
        finalBagOutId = this.model.bagout.id;
      }

      return this.BagoutService.getShipments(finalBagOutId).then(function () {
        _this4.loading = false;
        _this4.$location.url('/app/bag-out-print?bagout=' + finalBagOutId);
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this4.Modal.errorModal(err.data.message);
        }
      });
    }
  }, {
    key: 'clearBagId',
    value: function clearBagId(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        event.stopPropagation();
        this.model.bag = {};
        this.model.bag.toLocation = undefined;
        this.bagScanDisable = false;
        // this.focusElementById('bag-id');
      };
    }
  }, {
    key: 'clearBagout',
    value: function clearBagout(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        event.stopPropagation();
        // this.BagoutInfo = []
        this.model.bagout = {};
        this.bagoutScanDisable = false;
        this.focusElementById('bagout-id');
      }
    }
  }, {
    key: 'locationSearchObj',
    value: function locationSearchObj(searchKey) {
      searchKey = searchKey || '';

      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.branchId
          }, {
            field: 'active',
            condition: '=',
            data: true
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }, {
            group: {
              rules: [{
                group: {
                  rules: [{
                    field: 'locationType',
                    condition: "IN",
                    data: ["DELIVERY", "BANK"]
                  }, {
                    field: "bagoutEnabled",
                    condition: "=",
                    data: true
                  }],
                  "operator": "AND"
                }
              }],
              "operator": "OR"
            }
          }],
          operator: 'AND'
        },
        order: {
          fieldName: this.sortBy.fieldName,
          sortASC: this.sortBy.sortASC
        }
      };
      return searchObj.queryJSON.rules.length ? searchObj : null;
    }
  }, {
    key: 'loadDeliverToLocation',
    value: function loadDeliverToLocation(searchKey, offset) {
      var _this5 = this;

      var locationSearchObj = this.locationSearchObj(searchKey);
      this.LocationService.all(locationSearchObj, offset, _app2.default.defaultPageLimit).then(function (res) {
        if (offset === 0) {
          _this5.totalLocations = res.total;
          _this5.locationList = _this5.locationMapping(res.results);
        } else {
          var locations = _this5.locationMapping(res.results);
          _this5.locationList = _this5.locationList.concat(locations);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'locationMapping',
    value: function locationMapping(data) {
      return data.map(function (loc) {
        return {
          Key: loc.id + ' | ' + loc.name,
          Value: loc.id
        };
      });
    }
  }, {
    key: 'getRemainingBagoutCount',
    value: function getRemainingBagoutCount() {
      var _this6 = this;

      var focusTargetId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'bag-id';


      if (!this.model.toLocation) {
        return this.remainingBagoutInfo = '';
      };

      this.loadRemainingBagouts = true;
      return this.BagoutService.getRemainingBagoutCount(this.branchId, this.model.toLocation.Value).then(function (res) {
        _this6.remainingBagoutInfo = res;
        _this6.focusElementById(focusTargetId);
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this6.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this6.loadRemainingBagouts = false;
      });
    }
  }, {
    key: 'getTotalItemsInBagoutCount',
    value: function getTotalItemsInBagoutCount() {
      var _this7 = this;

      if (!this.model.bagout.id) return;

      this.loadBagouts = true;
      return this.BagoutService.getTotalItemsInBagoutCount(this.model.bagout.id).then(function (res) {
        _this7.BagoutInfo = res;
        _this7.focusElementById('bag-id');
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this7.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this7.loadBagouts = false;
      });
    }
  }, {
    key: 'getBagoutList',
    value: function getBagoutList(infoFor) {
      if (infoFor === 'remainingBagout') {
        if (!this.model.toLocation) return;
      } else if (infoFor === 'includedBagout') {
        if (!this.model.bagout.id && !this.lastScanned) return;
      }

      var bagSealId = this.model.bagout.id ? this.model.bagout.id : this.lastScanned;
      this.Modal.bagoutListModal(this.branchId, this.model.toLocation ? this.model.toLocation : null, bagSealId, infoFor, function (_ref3) {
        var $scope = _ref3.$scope,
            modal = _ref3.modal;

        modal.close();
      }, function (_ref4) {
        var modal = _ref4.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'loadOrAddBagouts',
    value: function loadOrAddBagouts(event) {
      var _this8 = this;

      if (!this.model.bagout.id) return;

      this.bagScanLimitExceed = false;
      this.reset();
      // this.lastScannedBagoutId();

      var finalBagOutId = void 0;
      if (this.prefixes && this.prefixes.bagout) {
        if (this.model.bagout.id.toUpperCase().startsWith(this.prefixes.bagout[0])) {
          finalBagOutId = this.model.bagout.id.slice(this.prefixes.bagout[0].length);
          this.lastScanned = finalBagOutId;
          this.model.bagout.id = this.lastScanned;
          this.lastScannedBagoutId();
        } else {
          finalBagOutId = this.model.bagout.id;
          this.lastScanned = finalBagOutId;
          this.model.bagout.id = this.lastScanned;
          this.lastScannedBagoutId();
        }
      } else {
        finalBagOutId = this.model.bagout.id;
        this.lastScanned = finalBagOutId;
        this.model.bagout.id = this.lastScanned;
        this.lastScannedBagoutId();
      }

      // if (this.bagScanLimit && this.bagScanLimit > 0) {
      //   if (finalBagOutId.length > this.bagScanLimit && (!this.checkOnlyOnce || finalBagOutId.length !== this.checkLength)) {
      //     this.lastScanned = finalBagOutId;
      //     this.checkLength = finalBagOutId.length;
      //     finalBagOutId = "";
      //     this.scanError();
      //     this.clearBagout(event);
      //     this.clearBagId(event);
      //     this.bagScanError = this.$translate.instant('common.scan_error');
      //     this.model.bagout.id = finalBagOutId;
      //     this.lastScannedBagoutId();
      //     return Promise.resolve();
      //   }
      //   else {
      //     this.checkLength = finalBagOutId.length > this.bagScanLimit ? finalBagOutId.length : this.bagScanLimit;
      //     this.model.bagout.id = finalBagOutId;
      //     this.lastScannedBagoutId();
      //     delete this.isError;
      //     delete this.bagScanError;
      //   }
      // }

      if (this.bagScanLimit && this.bagScanLimit > 0) {
        var envConfig = this.Configs.getEnvironmentConfig();
        var bagOutLimit = envConfig && envConfig.bagoutManifestConfig && envConfig.bagoutManifestConfig.bagOutScanLimit || _app2.default.defaultBagOutScanLimit;
        console.log(bagOutLimit);

        if (finalBagOutId.length > bagOutLimit) {
          this.lastScanned = finalBagOutId;
          // this.checkLength = finalBagOutId.length;
          finalBagOutId = "";
          this.scanError();
          this.clearBagout(event);
          this.clearBagId(event);
          this.bagScanError = this.$translate.instant('bagout.scan_error', {
            maxLength: bagOutLimit
          });
          // $scope.model.errorMsg = $translate.instant('branch_mgmt.items.duplicate_destination_error', {
          //     trackingId: $scope.model.shipmentData.trackingId,
          //     locationId: $scope.model.location.Value
          //   })
          this.model.bagout.id = finalBagOutId;
          this.lastScannedBagoutId();
          return _promise2.default.resolve();
        } else {
          // this.checkLength = finalBagOutId.length > this.bagScanLimit ? finalBagOutId.length : this.bagScanLimit;
          this.model.bagout.id = finalBagOutId;
          this.lastScannedBagoutId();
          delete this.isError;
          delete this.bagScanError;
        }
      }

      this.getTotalItemsInBagoutCount().then(function () {
        // this.loading = false;
        _this8.bagoutScanDisable = false;
        _this8.focusElementById('bag-id');
      });
    }
  }, {
    key: 'addBagout',
    value: function addBagout(event) {
      var _this9 = this;

      if (!this.model.bag.trackingId) return;

      this.bagScanned(event).then(function () {
        if (!_this9.isError && _this9.model.bag.trackingId) {
          return _this9.bagoutScanned(event).then(function () {
            if (!_this9.isError) {
              _this9.getRemainingBagoutCount();
              _this9.getTotalItemsInBagoutCount();
            }
          });
        }
      });
    }
  }, {
    key: 'lastScannedBagoutId',
    value: function lastScannedBagoutId() {
      this.lastBagoutScanned = {
        scannedDate: moment(new Date()).format('ddd ,ll'),
        scannedTime: moment(new Date()).format('LTS'),
        id: this.lastScanned
      };
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.bagScanLimitExceed = false;
      this.bagoutScanDisable = true;
      delete this.lastBagoutScanned;
      delete this.isError;
      delete this.message;
      delete this.messageTwo;
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      this.reset();
      this.model.bag = {};
      this.model.bagout = {};
      this.lastBagScanned = null;
      this.remainingBagoutInfo = '';
      this.BagoutInfo = '';
      this.bagoutScanDisable = false;
      this.prevErrorCode = undefined;
      this.lastScanned = null;
    }
  }]);
  return BagoutController;
}();

exports.default = BagoutController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bagout = __webpack_require__(1630);

var _bagout2 = _interopRequireDefault(_bagout);

var _print = __webpack_require__(1633);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bagoutModule = angular.module('bagout', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/bag-out');

  $stateProvider.state('bagout', {
    url: '/bag-out',
    component: 'bagout',
    data: {
      requireLogin: true,
      requireACL: 'bag_out.all'
    },
    parent: 'app'
  }).state('bagoutPrint', {
    url: '/bag-out-print',
    component: 'printBagout',
    data: {
      requireLogin: true,
      requireACL: 'bag_out.all'
    },
    parent: 'app'
  });
}]).component('bagout', _bagout2.default).component('printBagout', _print2.default).name;

exports.default = bagoutModule;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bagoutPrint = __webpack_require__(2644);

var _bagoutPrint2 = _interopRequireDefault(_bagoutPrint);

var _print = __webpack_require__(1634);

var _print2 = _interopRequireDefault(_print);

__webpack_require__(2932);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printComponent = {
  restrict: 'E',
  bindings: {},
  template: _bagoutPrint2.default,
  controller: _print2.default
};

exports.default = printComponent;

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintController = function () {
  /*@ngInject*/
  PrintController.$inject = ["Auth", "$state", "$scope", "User", "UserService", "DateUtil", "$translate", "ShipmentService", "BagoutService", "Modal", "$location", "RouteService", "LocationService", "SetupService", "BranchService", "Branch", "Sound", "$q"];
  function PrintController(Auth, $state, $scope, User, UserService, DateUtil, $translate, ShipmentService, BagoutService, Modal, $location, RouteService, LocationService, SetupService, BranchService, Branch, Sound, $q) {
    (0, _classCallCheck3.default)(this, PrintController);


    this.$state = $state;
    this.$scope = $scope;
    this.User = User;
    this.$translate = $translate;
    this.BagoutService = BagoutService;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.BranchService = BranchService;
    this.Branch = Branch;
    this.SetupService = SetupService;
    this.$q = $q;
    this.Sound = Sound;
    this.Modal = Modal;
    this.$location = $location;
    this.ShipmentService = ShipmentService;
    this.DateUtil = DateUtil;
    this.todayDate = moment().hour(0).minutes(0).seconds(0).toDate();
    this.routes = [];
    this.holdRoute = '';
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();
    this.model = {
      bagout: {
        id: '',
        gettingRoutes: false
      },
      deliveryDate: '',
      branchId: this.User.getUser().branchId,
      supervisorId: this.User.getUser().id,
      isSupervisor: _.isUndefined(this.User.getUser().supervisor) ? false : this.User.getUser().supervisor
    };
    this.isBagoutSelected = false;
    this.bagOutData = "";
    this.branchFromLocation = {};

    this.barcodeOptions = {
      format: 'CODE128', lineColor: '#030303', width: 3.7, height: 100, displayValue: false,
      font: 'monospace', textAlign: 'center', textPosition: 'bottom', textMargin: 0, fontSize: 25,
      marginTop: 0, marginBottom: 0
    };
  }

  (0, _createClass3.default)(PrintController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.focusElementById('bagout-scan-id');
      var bagoutId = this.$location.search().bagout;
      var self = this;
      this.BranchService.getBranchSetup(this.model.branchId).then(function (data) {
        _this.supervisorScan = data.supervisorScan;
        if (data.holdRouteId) {
          _this.RouteService.get(data.holdRouteId).then(function (route) {
            if (route && route.id) {
              _this.holdRoute = route;
            }
          }).catch(function (err) {
            if (err && err.data && err.data.message) {
              _this.Modal.errorModal(err.data.message);
              // console.log(err);
            }
          });
        }
      });

      this.SetupService.get(this.model.branchId).then(function (data) {
        _this.model.deliveryDate = _this.DateUtil.convertToDate(data.currentVaultDate);
        _this.vaultDate = _this.DateUtil.convertToDate(data.currentVaultDate);
        _this.finalVaultDate = {
          minDate: _this.vaultDate
        };
        _this.branchFromLocation = data.fromLocation;
      }).catch(function (err) {
        console.log(err);
      });

      if (bagoutId) {
        this.model.bagout.id = bagoutId;
        this.Branch.getBranchDetails(this.model.branchId).then(function (branchDetails) {
          self.prefixes = branchDetails.prefixes;
          self.bagoutScanned();
        });
      }
    }
  }, {
    key: 'focusElementById',
    value: function focusElementById(id) {
      setTimeout(function () {
        document.getElementById(id).focus();
      }, 300);
    }
  }, {
    key: 'bagoutScanned',
    value: function bagoutScanned() {
      var _this2 = this;

      var finalBagoutData;
      if (this.model.bagout.id === "" || this.model.bagout.id == undefined) {
        return;
      }

      finalBagoutData = this.model.bagout.id;
      this.isLoading = false;
      return this.BagoutService.getShipments(finalBagoutData).then(function (res) {
        _this2.bagSealId = res.data.bagout.id;
        _this2.model.isError = false;
        _this2.model.bagout = (0, _assign2.default)({}, res.data.bagout, {
          shipments: res.data.shipments,
          totalBags: res.data.shipments.length,
          totalAmount: res.data.shipments.reduce(function (partialTotal, shipment) {
            return partialTotal + shipment.amount;
          }, 0)
        });
        _this2.isBagoutSelected = true;
        _this2.Sound.playSuccessBeep("#success_beep");
        return _this2.loadVisitingRoutes();
      }).catch(function (err) {
        _this2.model.isError = true;
        if (err && err.data && err.data.message) {
          _this2.model.bagout.id = "";
          finalBagoutData = "";
          _this2.Sound.PlayErrorBeep("#scanner_beep");
          _this2.model.message = _this2.$translate.instant(err.data.message);
        } else {
          _this2.model.message = _this2.$translate.instant(error.UnableToLocateBagout);
        }
        // this.model.message = "";
        _this2.isBagoutSelected = false;
      });
    }
  }, {
    key: '_closeBagout',
    value: function _closeBagout(modal) {
      var bagoutDetails = this.model.bagout;
      var shipmentData = [];
      var shipments = bagoutDetails.shipments;

      shipments.forEach(function (s) {
        shipmentData.push({
          trackingId: s.trackingId,
          amount: s.amount,
          denominationId: s.denominationId,
          locationId: s.fromLocation.id,
          locationName: s.fromLocation.name,
          stopProcess: s.fromLocation.stopProcess
        });
      });

      return this.BagoutService.closeBagout(bagoutDetails.id, this.model.branchId, this.model.route.id, moment(this.model.deliveryDate).format('YYYY-MM-DD'), bagoutDetails.carrierId ? bagoutDetails.carrier.id : null, bagoutDetails.carrierId ? bagoutDetails.carrier.name : null, this.model.supervisorId, shipmentData);
    }
  }, {
    key: 'closeBagout',
    value: function closeBagout(isPrint) {
      var _this3 = this;

      // console.log(this.supervisorScan , this.model.isSupervisor)
      if (!isPrint && this.isLoading) {
        return;
      } else {
        this.isLoading = true;
        setTimeout(function () {
          _this3.isLoading = false;
        }, 500);
      }

      if (this.supervisorScan || !this.model.isSupervisor) {
        this.Modal.confirmSupervisor('verify-hold', null, function (_ref) {
          var modal = _ref.modal,
              supId = _ref.supId;

          _this3.putOnHold(true, isPrint, modal, supId);
        }, function (_ref2) {
          var modal = _ref2.modal;

          _this3.isLoading = false;
          modal.close();
        });
      } else {
        this.Modal.confirm({
          header: this.$translate.instant('bagout.confirmCloseBagoutTitle'),
          message: this.$translate.instant('bagout.confirmCloseBagoutMessage') + (' <strong>' + this.model.bagout.id + '</strong>?'),
          callback: function callback(_ref3) {
            var modal = _ref3.modal,
                $scope = _ref3.$scope;

            if (_this3.model.route.id == _this3.holdRoute.id) {
              modal.close();
              $scope.isLoading = true;
              _this3.putOnHold(true, isPrint, modal, _this3.model.supervisorId);
            } else {
              $scope.loading = true;
              _this3._closeBagout(modal, $scope).then(function (res) {
                if (res.data && res.data.closed) {
                  modal.close();
                  _this3.isLoading = true;
                  if (isPrint) {
                    _this3.isLoading = false;
                    return _this3.print();
                  }
                }
              }).catch(function (err) {
                modal.close();
                if (err && err.data && err.data.message) {
                  _this3.Sound.PlayErrorBeep("#scanner_beep");
                  var _error = err.data.message.length > 7 ? err.data.message : 'error.' + err.data.message;
                  _this3.Modal.errorModal(_error);
                }
              }).finally(function () {
                _this3.bagoutScanned();
              });
            }
          },
          type: 'danger'
        });
      }
    }
  }, {
    key: 'deleteBagout',
    value: function deleteBagout() {
      var _this4 = this;

      this.Modal.confirm({
        header: this.$translate.instant('bagout.confirmDeleteBagoutTitle'),
        message: this.$translate.instant('bagout.confirmDeleteBagoutMessage') + (' <strong>' + this.model.bagout.id + '</strong>?'),
        callback: function callback(_ref4) {
          var modal = _ref4.modal,
              $scope = _ref4.$scope;

          _this4.BagoutService.deleteBagout(_this4.model.bagout.id).then(function (response) {
            _this4.isLoading = true;
            if (res.status) {
              _this4.Sound.playSuccessBeep("#success_beep");
              modal.close();
            }
          }).catch(function (err) {
            modal.close();
            if (err && err.data && err.data.message) {
              _this4.Sound.PlayErrorBeep("#scanner_beep");
              var _error2 = err.data.message.length > 7 ? err.data.message : 'error.' + err.data.message;
              _this4.Modal.errorModal(_error2);
            }
          }).finally(function () {
            _this4.isLoading = true;
            _this4.goToBagout();
          });
        },
        type: 'danger'
      });
    }

    // put shipment on hold if route id same as hold route

  }, {
    key: 'confirmSupervisor',
    value: function confirmSupervisor(closeBagout, isPrint) {
      var _this6 = this;

      this.Modal.confirmSupervisor('verify-hold', null, function (_ref5) {
        var modal = _ref5.modal,
            supId = _ref5.supId;

        return _this6.putOnHold(closeBagout, isPrint, modal, supId);
      }, function (_ref6) {
        var modal = _ref6.modal;

        _this6.isPutOnHold = false;
        _this6.isLoading = false;
        modal.close();
      });
    }
  }, {
    key: 'putOnHold',
    value: function putOnHold(closeBagout, isPrint) {
      var _this7 = this;

      var modal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var supId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var allPromise = [];
      this.isPutOnHold = true;
      if (closeBagout) {
        allPromise.push(this._closeBagout());
      }
      this.$q.all(allPromise).then(function (data) {
        _this7.ShipmentService.holdShipment(_this7.model.branchId, _this7.model.bagout.id, _this7.model.route.id, moment(_this7.vaultDate).format('YYYY-MM-DD'), supId, '', '').then(function (data) {
          modal.close();
          if (isPrint) {
            return _this7.print();
          }
        }).catch(function (err) {
          modal.close();
          if (err && err.data && err.data.message) {
            _this7.Modal.errorModal('error.' + err.data.message);
          }
        }).finally(function () {
          _this7.isPutOnHold = false;
          _this7.bagoutScanned();
        });
      }).catch(function (err) {
        _this7.isPutOnHold = false;
        if (err && err.data && err.data.message) {
          if (modal) modal.close();
          _this7.Sound.PlayErrorBeep("#scanner_beep");
          var _error3 = err.data.message.length > 7 ? err.data.message : 'error.' + err.data.message;
          return _this7.Modal.errorModal(_error3);
        }
      });
    }
  }, {
    key: 'loadVisitingRoutes',
    value: function loadVisitingRoutes() {
      var _this8 = this;

      if (!this.model.bagout || !this.model.bagout.location || !this.model.bagout.location.id) {
        return;
      }

      var dayIndex = moment(this.model.deliveryDate).day();
      var weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

      this.model.gettingRoutes = true;
      this.$q.all([this.LocationService.getVisitingRoutes(this.model.bagout.location.id, weekDays[dayIndex]), // for selected index
      this.BagoutService.getDeliveryRoutes(this.model.branchId, moment(this.model.deliveryDate).format('YYYY-MM-DD')) // fro route list
      ]).then(function (data) {
        _this8.routes = data[1].results ? data[1].results.slice() : [];

        if (_this8.holdRoute) {
          _this8.routes.push(_this8.holdRoute);
        }

        if (data[0].results) {
          if (data[0].results.length === 0 && _this8.holdRoute) {
            _this8.model.route = _this8.routes[_.findIndex(_this5.routes, { id: _this5.holdRoute.id })];;
          } else if (data[0].results.length === 1) {
            var selectedIndex = _.findIndex(_this8.routes, { id: data[0].results[0].id });
            _this8.model.route = selectedIndex >= 0 ? _this8.routes[selectedIndex] : _this8.routes[_.findIndex(_this8.routes, { id: _this8.holdRoute.id })];
          }
        } else if (_this8.holdRoute) {
          _this8.model.route = _this8.routes[_.findIndex(_this8.routes, { id: _this8.holdRoute.id })];;
        }
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this8.model.gettingRoutes = false;
      });
    }
  }, {
    key: 'print',
    value: function print() {
      setTimeout(function () {
        window.print();
      }, 1000);
      this._clearTimeOut();
    }
  }, {
    key: '_clearTimeOut',
    value: function _clearTimeOut() {
      var _this9 = this;

      var timeId = setTimeout(function () {
        _this9.isLoading = false;
        _this9.isBagoutSelected = true;
        _this9.isPutOnHold = false;
        _this9.$scope.$apply();
        clearTimeout(timeId);
      }, 1000);
    }
  }, {
    key: 'confirmPrint',
    value: function confirmPrint() {
      if (this.isLoading) return;
      this.isLoading = true;

      if (!this.model.bagout.closed) {
        this.closeBagout(true);
      } else {
        this.print();
      }
      this._clearTimeOut();
    }
  }, {
    key: 'goToBagout',
    value: function goToBagout() {
      window.history.go(-1);
    }
  }, {
    key: 'dateChanged',
    value: function dateChanged() {
      this.loadVisitingRoutes();
    }
  }]);
  return PrintController;
}();

exports.default = PrintController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _batchAll = __webpack_require__(2645);

var _batchAll2 = _interopRequireDefault(_batchAll);

var _batchAll3 = __webpack_require__(1636);

var _batchAll4 = _interopRequireDefault(_batchAll3);

__webpack_require__(2933);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var batchallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _batchAll2.default,
  controller: _batchAll4.default
};

exports.default = batchallComponent;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _batchBase = __webpack_require__(263);

var _batchBase2 = _interopRequireDefault(_batchBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BatchallController = function (_BatchBaseController) {
  BatchallController.$inject = ["Auth", "$state", "User", "Modal", "BatchService", "$translate", "$stateParams", "$scope", "$location"];
  (0, _inherits3.default)(BatchallController, _BatchBaseController);

  /*@ngInject*/
  function BatchallController(Auth, $state, User, Modal, BatchService, $translate, $stateParams, $scope, $location) {
    (0, _classCallCheck3.default)(this, BatchallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BatchallController.__proto__ || (0, _getPrototypeOf2.default)(BatchallController)).call(this, Auth, $state, User, BatchService, Modal, $translate, $stateParams, $location));

    _this.id = 'batch.all';
    _this.loading = true;
    _this.batches = [];
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.hasACL = {};
    _this.searchText = '', _this.User = User, _this.branchId = _this.User.getUser().branchId;
    _this.$location = $location;
    _this.filterByValue = null;
    _this.model.filterByAllBranch = false;
    return _this;
  }

  (0, _createClass3.default)(BatchallController, [{
    key: '$onInit',
    value: function $onInit() {
      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
    }
  }, {
    key: 'edit',
    value: function edit(batch) {
      this.$state.go('batch.edit', {
        id: batch.batchSourceId
      });
    }
  }, {
    key: 'delete',
    value: function _delete(batch) {
      var _this2 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + batch.batchSource.name + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this2.Service.remove(batch.batchSourceId, _this2.branchId).then(function (data) {
            _this2.allowOnlyOnce = false;
            modal.close();
            _this2.refresh();
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this2.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      // this.loading = true
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      var searchObj = this.generateSearchObj();

      this.loading = true;
      this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this3.total = data.total;

        _this3.loading = false;
        _this3.batches = data.results;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.error = err.message;
      });
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(batch) {
      batch.expand = !batch.expand;
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      return {
        branchId: this.branchId,
        queryText: '%' + this.searchText + '%',
        isQuery: false,
        filterByAllBranch: this.model.filterByAllBranch
      };
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'filterByBranch',
    value: function filterByBranch(value) {
      this.page = 1;
      this.filterByValue = this.filterByValue === value ? undefined : value;
      this.model.filterByAllBranch = this.filterByValue ? true : false;
      this.loadData();
    }
  }]);
  return BatchallController;
}(_batchBase2.default);

exports.default = BatchallController;

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _batchAll = __webpack_require__(1635);

var _batchAll2 = _interopRequireDefault(_batchAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var batchallModule = angular.module('batchall', []).component('batchall', _batchAll2.default).name;

exports.default = batchallModule;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _batch = __webpack_require__(2646);

var _batch2 = _interopRequireDefault(_batch);

var _batch3 = __webpack_require__(1639);

var _batch4 = _interopRequireDefault(_batch3);

__webpack_require__(2934);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var batchComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _batch2.default,
  controller: _batch4.default
};

exports.default = batchComponent;

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BatchController = function (_SettingBase) {
  BatchController.$inject = ["$state"];
  (0, _inherits3.default)(BatchController, _SettingBase);

  /*@ngInject*/
  function BatchController($state) {
    (0, _classCallCheck3.default)(this, BatchController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BatchController.__proto__ || (0, _getPrototypeOf2.default)(BatchController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'batch';
    _this.$state = $state;

    return _this;
  }

  (0, _createClass3.default)(BatchController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(BatchController.prototype.__proto__ || (0, _getPrototypeOf2.default)(BatchController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['setting-batch']) {
        this.hasACL[this.acl['setting-batch'][key]] = true;
      }
    }
  }]);
  return BatchController;
}(_SettingBase3.default);

exports.default = BatchController;

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _batchCreate = __webpack_require__(2647);

var _batchCreate2 = _interopRequireDefault(_batchCreate);

var _batchCreate3 = __webpack_require__(1641);

var _batchCreate4 = _interopRequireDefault(_batchCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var batchcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _batchCreate2.default,
  controller: _batchCreate4.default
};

exports.default = batchcreateComponent;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _batchBase = __webpack_require__(263);

var _batchBase2 = _interopRequireDefault(_batchBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BatchCreateController = function (_BatchBaseController) {
	BatchCreateController.$inject = ["Auth", "$state", "User", "BatchService", "Modal", "$translate", "CustomerService", "LocationService"];
	(0, _inherits3.default)(BatchCreateController, _BatchBaseController);

	/*@ngInject*/
	function BatchCreateController(Auth, $state, User, BatchService, Modal, $translate, CustomerService, LocationService) {
		(0, _classCallCheck3.default)(this, BatchCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (BatchCreateController.__proto__ || (0, _getPrototypeOf2.default)(BatchCreateController)).call(this, Auth, $state, User, BatchService, Modal, $translate));

		_this.onLoad = function () {
			_this.model = {
				inputType: null,
				batchSourceId: null,
				description: ''
			};

			// fetch exisitning batches and remove their cooresponding location from locations dropdown
			_this.Service.all(null, 0, 100).then(function (batches) {
				return batches.results.map(function (batch) {
					return batch.batchSourceId;
				});
			}).then(function (locationsToIgnore) {
				_this.locationsToIgnore = locationsToIgnore;
				_this.getAllLocation('', 0);
			});
		};

		_this.locationSearchObj = function (searchKey) {
			searchKey = searchKey || '';

			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: '=',
						data: _this.User.getUser().branchId
					}, {
						group: {
							rules: [{
								field: 'locationType',
								condition: '=',
								data: 'INTERNAL'
							}, {
								field: 'locationType',
								condition: '=',
								data: 'BANK'
							}],
							operator: 'OR'
						}
					}, {
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'name',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};
			return searchObj.queryJSON.rules.length ? searchObj : null;
		};

		_this.CustomerService = CustomerService;
		_this.LocationService = LocationService;
		_this.locationsToIgnore;
		_this.offset = 0;
		_this.changeOffsetFlag = false;
		_this.inputTypes = ['UUU', 'UVV', 'VVV', 'ULV', 'UHV', 'VUV'];
		_this.DEFAULT_INPUT_TYPE = 'VVV';
		_this.locations = [];
		_this.currentBranch = User.getUser().branchId;
		return _this;
	}

	(0, _createClass3.default)(BatchCreateController, [{
		key: '$onInit',
		value: function $onInit() {
			this.onLoad();
		}
	}, {
		key: 'mappingLocationDatas',
		value: function mappingLocationDatas(locations) {
			return locations.map(function (location) {
				location.Key = location.id + " | " + location.name;
				location.Value = location.id;
				return location;
			});
		}
	}, {
		key: 'getAllLocation',
		value: function getAllLocation(searchKey, offset) {
			var _this2 = this;

			var locationSearchObj = this.locationSearchObj(searchKey);
			if (searchKey) {
				this.offset = 0;
			} else {
				if (offset == 0) {
					this.offset = 0;
				}
			}
			this.LocationService.getAllLocation(locationSearchObj, this.offset, _app2.default.defaultPageLimit).then(function (res) {
				if (_this2.offset === 0) {
					_this2.totalLocationRecords = res.total;
					_this2.locations = _this2.mappingLocationDatas(res.results).filter(function (location) {
						return !_this2.locationsToIgnore.includes(location.id);
					});
					_this2.offset += 10;
					if (_this2.locations.length <= 10 && !searchKey) {
						_this2.changeOffsetFlag = false;
						_this2.getAllLocation('', _this2.offset);
					}
				} else {
					var locations = _this2.mappingLocationDatas(res.results).filter(function (location) {
						return !_this2.locationsToIgnore.includes(location.id);
					});
					_this2.locations = _this2.locations.concat(locations);
					_this2.offset += 10;
					if (_this2.locations.length <= 10) {
						_this2.changeOffsetFlag = false;
						if (_this2.totalLocationRecords > _this2.offset) {
							_this2.getAllLocation('', _this2.offset);
						}
					} else _this2.changeOffsetFlag = true;
				}
			});
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this3 = this;

			this.loading = true;
			this.model.batchSourceId = this.model.batchSourceId.id;
			this.Service.create(this.model, this.currentBranch).then(function (res) {
				_this3.askCreate();
			}).finally(function () {
				_this3.loading = false;
				_this3.onLoad();
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.model = {
				inputType: null,
				batchSourceId: null,
				description: ''
			};
			this.clearErrors();
			// this.getAllLocation('', 0);
		}
	}]);
	return BatchCreateController;
}(_batchBase2.default);

exports.default = BatchCreateController;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _batchCreate = __webpack_require__(1640);

var _batchCreate2 = _interopRequireDefault(_batchCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var batchCreateModule = angular.module('batchcreate', []).component('batchcreate', _batchCreate2.default).name;

exports.default = batchCreateModule;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _batchEdit = __webpack_require__(2648);

var _batchEdit2 = _interopRequireDefault(_batchEdit);

var _batchEdit3 = __webpack_require__(1644);

var _batchEdit4 = _interopRequireDefault(_batchEdit3);

__webpack_require__(2935);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var batcheditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _batchEdit2.default,
  controller: _batchEdit4.default
};

exports.default = batcheditComponent;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _batchBase = __webpack_require__(263);

var _batchBase2 = _interopRequireDefault(_batchBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BatchEditController = function (_BatchBaseController) {
	BatchEditController.$inject = ["Auth", "$state", "User", "BatchService", "Modal", "$translate", "$stateParams", "LocationService", "$q"];
	(0, _inherits3.default)(BatchEditController, _BatchBaseController);

	/*@ngInject*/
	function BatchEditController(Auth, $state, User, BatchService, Modal, $translate, $stateParams, LocationService, $q) {
		(0, _classCallCheck3.default)(this, BatchEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (BatchEditController.__proto__ || (0, _getPrototypeOf2.default)(BatchEditController)).call(this, Auth, $state, User, BatchService, Modal, $translate, $stateParams));

		_this.LocationService = LocationService;
		_this.$q = $q;

		_this.defaultModel = {
			inputType: '',
			description: '',
			locationId: '',
			batchSourceId: ''
		};

		_this.inputTypes = ['UUU', 'UVV', 'VVV', 'ULV', 'UHV', 'VUV'];
		_this.DEFAULT_INPUT_TYPE = 'VVV';
		_this.locations = [];
		_this.batchName = $stateParams.id;
		_this.currentBranch = User.getUser().branchId;
		_this.model = angular.copy(_this.defaultModel);
		return _this;
	}

	(0, _createClass3.default)(BatchEditController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.$q.all([this.Service.get(this.$stateParams.id), this.LocationService.get(this.$stateParams.id)]).then(function (data) {
				var batchData = data[0];
				var locationData = data[1];

				_this2.rawId = batchData.batchSourceId;
				// this.model.id = data.id
				// this.model.description = data.description
				// this.model.inputType = data.inputType
				// this.model.batchSourceId = data.batchSourceId
				for (var key in _this2.model) {
					_this2.defaultModel[key] = batchData[key];
				}

				_this2.batchName = _this2.rawId + ' | ' + locationData.name;
				_this2.model = angular.copy(_this2.defaultModel);
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			// this.$q.all([
			// 	this.Service.get(this.$stateParams.id),
			// 	this.LocationService.get(this.$stateParams.id)
			// ])
			// 	.then((data) => {
			// 		const batchData = data[0];
			// 		const locationData = data[1];
			// 		this.rawId = batchData.batchSourceId
			// 		for (let key in this.model) {
			// 			this.model[key] = batchData[key];
			// 		}
			// 		this.batchName = this.rawId + ' | ' + locationData.name;
			// 	})
			this.model = angular.copy(this.defaultModel);
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this3 = this;

			// if (!this.validate()) {
			// 	return
			// }

			this.loading = true;
			this.Service.update(this.rawId, {
				id: this.model.id,
				description: this.model.description,
				inputType: this.model.inputType,
				batchSourceId: this.model.batchSourceId
			}, this.currentBranch).then(function (data) {
				_this3.loading = false;
				window.history.go(-1);
			}).catch(function (err) {
				_this3.loading = false;
				err.data.errors.map(function (e) {
					_this3.errorMessage += e.message + '<br/>';
				});
			});
		}
	}]);
	return BatchEditController;
}(_batchBase2.default);

exports.default = BatchEditController;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _batchEdit = __webpack_require__(1643);

var _batchEdit2 = _interopRequireDefault(_batchEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var batchEditModule = angular.module('batchedit', []).component('batchedit', _batchEdit2.default).name;

exports.default = batchEditModule;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _batch = __webpack_require__(1638);

var _batch2 = _interopRequireDefault(_batch);

var _create = __webpack_require__(1642);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(1645);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(1637);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var batchModule = angular.module('batch', [_create2.default, _edit2.default, _all2.default]).component('batch', _batch2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('batch.edit', {
    url: '/edit/:id',
    component: 'batchedit'
  }).state('batch.create', {
    url: '/create',
    component: 'batchcreate'
  }).state('batch.all', {
    url: '/all/:page',
    component: 'batchall'
  });
}]).name;

exports.default = batchModule;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branchAll = __webpack_require__(2649);

var _branchAll2 = _interopRequireDefault(_branchAll);

var _branchAll3 = __webpack_require__(1648);

var _branchAll4 = _interopRequireDefault(_branchAll3);

__webpack_require__(2936);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _branchAll2.default,
  controller: _branchAll4.default
};

exports.default = branchallComponent;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _branchBase = __webpack_require__(264);

var _branchBase2 = _interopRequireDefault(_branchBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchallController = function (_BranchBaseController) {
  BranchallController.$inject = ["Auth", "$state", "User", "Modal", "BranchService", "$translate", "$stateParams", "$scope", "$location"];
  (0, _inherits3.default)(BranchallController, _BranchBaseController);

  /*@ngInject*/
  function BranchallController(Auth, $state, User, Modal, BranchService, $translate, $stateParams, $scope, $location) {
    (0, _classCallCheck3.default)(this, BranchallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BranchallController.__proto__ || (0, _getPrototypeOf2.default)(BranchallController)).call(this, Auth, $state, User, BranchService, Modal, $translate, $stateParams, $location));

    _this.id = 'branch.all';
    _this.loading = true;
    _this.branches = [];
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.hasACL = {};
    _this.searchText = '';
    _this.$location = $location;
    return _this;
  }

  (0, _createClass3.default)(BranchallController, [{
    key: '$onInit',
    value: function $onInit() {
      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
    }
  }, {
    key: 'edit',
    value: function edit(branch) {
      this.$state.go('branch.edit', {
        id: branch.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(branch) {
      var _this2 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + branch.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this2.Service.remove(branch.id).then(function (data) {
            _this2.allowOnlyOnce = false;
            modal.close();
            _this2.refresh();
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this2.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      var searchObj = this.generateSearchObj();

      this.loading = true;
      this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this3.total = data.total;
        _this3.loading = false;
        _this3.branches = data.results;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.error = err.message;
        _this3.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      return {
        queryText: '%' + this.searchText + '%',
        isQuery: false
      };
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(branch) {
      branch.expand = !branch.expand;
    }
  }]);
  return BranchallController;
}(_branchBase2.default);

exports.default = BranchallController;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branchAll = __webpack_require__(1647);

var _branchAll2 = _interopRequireDefault(_branchAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchallModule = angular.module('branchall', []).component('branchall', _branchAll2.default).name;

exports.default = branchallModule;

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch = __webpack_require__(2650);

var _branch2 = _interopRequireDefault(_branch);

var _branch3 = __webpack_require__(1651);

var _branch4 = _interopRequireDefault(_branch3);

__webpack_require__(2937);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _branch2.default,
  controller: _branch4.default
};

exports.default = branchComponent;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchController = function (_SettingBase) {
  BranchController.$inject = ["$state"];
  (0, _inherits3.default)(BranchController, _SettingBase);

  /*@ngInject*/
  function BranchController($state) {
    (0, _classCallCheck3.default)(this, BranchController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BranchController.__proto__ || (0, _getPrototypeOf2.default)(BranchController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'branch';
    _this.$state = $state;

    return _this;
  }

  (0, _createClass3.default)(BranchController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(BranchController.prototype.__proto__ || (0, _getPrototypeOf2.default)(BranchController.prototype), '$onInit', this).call(this);

      for (var key in this.acl['setting-' + this.id]) {
        this.hasACL[this.acl['setting-' + this.id][key]] = true;
      }
    }
  }]);
  return BranchController;
}(_SettingBase3.default);

exports.default = BranchController;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _window = __webpack_require__(2651);

var _window2 = _interopRequireDefault(_window);

var _window3 = __webpack_require__(1653);

var _window4 = _interopRequireDefault(_window3);

__webpack_require__(2938);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var windowComponent = {
  restrict: 'E',
  bindings: {
    model: '=ngModel',
    branch: '='
  },
  template: _window2.default,
  controller: _window4.default
};

exports.default = windowComponent;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WindowContoller = function () {
	function WindowContoller(LocationService) {
		(0, _classCallCheck3.default)(this, WindowContoller);

		this.LocationService = LocationService;
		this.locations = [];
	}

	(0, _createClass3.default)(WindowContoller, [{
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			if (!this.branch) {
				return;
			}

			var locationSearchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: '=',
						data: this.branch
					}, {
						field: 'locationType',
						condition: '=',
						data: 'WINDOW'
					}],
					operator: 'AND'
				}
			};

			return this.LocationService.getAllLocation(locationSearchObj, 0, 1000).then(function (data) {
				_this.locations = data.results;
			}).catch(function (err) {
				console.error(err);
			});
		}
	}, {
		key: 'valueChanged',
		value: function valueChanged() {
			this.model.isSaved = false;
		}
	}]);
	return WindowContoller;
}();

WindowContoller.$inject = ['LocationService'];

exports.default = WindowContoller;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branchCreate = __webpack_require__(2652);

var _branchCreate2 = _interopRequireDefault(_branchCreate);

var _branchCreate3 = __webpack_require__(1655);

var _branchCreate4 = _interopRequireDefault(_branchCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _branchCreate2.default,
  controller: _branchCreate4.default
};

exports.default = branchcreateComponent;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _branchBase = __webpack_require__(264);

var _branchBase2 = _interopRequireDefault(_branchBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchCreateController = function (_BranchBaseController) {
	BranchCreateController.$inject = ["Auth", "$state", "User", "BranchService", "Modal", "$translate", "$stateParams", "WindowService"];
	(0, _inherits3.default)(BranchCreateController, _BranchBaseController);

	/*@ngInject*/
	function BranchCreateController(Auth, $state, User, BranchService, Modal, $translate, $stateParams, WindowService) {
		(0, _classCallCheck3.default)(this, BranchCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (BranchCreateController.__proto__ || (0, _getPrototypeOf2.default)(BranchCreateController)).call(this, Auth, $state, User, BranchService, Modal, $translate));

		_this.WindowService = WindowService;

		_this.model.id = '';
		_this.model.description = '';
		_this.model.windows = [];
		_this.model.businessDayMon = false;
		_this.model.businessDayTue = false;
		_this.model.businessDayWed = false;
		_this.model.businessDayThu = false;
		_this.model.businessDayFri = false;
		_this.model.businessDaySat = false;
		_this.model.businessDaySun = false;
		_this.model.businessDayHol = false;

		_this.businessDays = [{ label: 'Monday', model: 'businessDayMon' }, { label: 'Tuesday', model: 'businessDayTue' }, { label: 'Wednesday', model: 'businessDayWed' }, { label: 'Thursday', model: 'businessDayThu' }, { label: 'Friday', model: 'businessDayFri' }, { label: 'Saturday', model: 'businessDaySat' }, { label: 'Sunday', model: 'businessDaySun' }, { label: 'Holiday', model: 'businessDayHol' }];
		_this.isDaySelected = function (day) {
			return _this.model[day.model];
		};
		_this.toggleDay = function (day) {
			_this.model[day.model] = !_this.model[day.model];
		};
		return _this;
	}

	(0, _createClass3.default)(BranchCreateController, [{
		key: 'addWindow',
		value: function addWindow() {
			this.model.windows.push({
				expand: true,
				id: null,
				description: null,
				allowCash: true,
				allowCoin: false
			});
		}
	}, {
		key: 'toggleExpand',
		value: function toggleExpand(window) {
			window.expand = !window.expand;
		}
	}, {
		key: 'deleteWindow',
		value: function deleteWindow(index) {
			var _this2 = this;

			this.Modal.confirm({
				header: this.$translate.instant('branch.confirm'),
				message: this.$translate.instant('branch.confirm_delete_message'),
				callback: function callback(_ref) {
					var modal = _ref.modal,
					    $scope = _ref.$scope;

					_this2.model.windows.splice(index, 1);
					modal.close();
				},
				negative: function negative(_ref2) {
					var modal = _ref2.modal,
					    $scope = _ref2.$scope;

					modal.close();
				},
				type: 'primary',
				buttons: ['common.yes', 'common.no']
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			for (var key in this.model) {
				this.model[key] = '';
			}
			this.model.windows = [];
			this.clearErrors();
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this3 = this;

			this.loading = true;
			this.Service.create({
				id: this.model.id,
				description: this.model.description,
				windows: this.model.windows,
				businessDayMon: this.model.businessDayMon,
				businessDayTue: this.model.businessDayTue,
				businessDayWed: this.model.businessDayWed,
				businessDayThu: this.model.businessDayThu,
				businessDayFri: this.model.businessDayFri,
				businessDaySat: this.model.businessDaySat,
				businessDaySun: this.model.businessDaySun,
				businessDayHol: this.model.businessDayHol
			}).then(function (data) {
				_this3.loading = false;
				_this3.askCreate();
			}).catch(function (err) {
				_this3.loading = false;
				err.data.errors.map(function (e) {
					_this3.errorMessage += e.message + '<br/>';
				});
			});
		}
	}]);
	return BranchCreateController;
}(_branchBase2.default);

exports.default = BranchCreateController;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branchCreate = __webpack_require__(1654);

var _branchCreate2 = _interopRequireDefault(_branchCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchCreateModule = angular.module('branchcreate', []).component('branchcreate', _branchCreate2.default).name;

exports.default = branchCreateModule;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branchEdit = __webpack_require__(2653);

var _branchEdit2 = _interopRequireDefault(_branchEdit);

var _branchEdit3 = __webpack_require__(1658);

var _branchEdit4 = _interopRequireDefault(_branchEdit3);

__webpack_require__(2939);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var brancheditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _branchEdit2.default,
  controller: _branchEdit4.default
};

exports.default = brancheditComponent;

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _branchBase = __webpack_require__(264);

var _branchBase2 = _interopRequireDefault(_branchBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchEditController = function (_BranchBaseController) {
	BranchEditController.$inject = ["Auth", "$state", "User", "BranchService", "Modal", "$translate", "$stateParams", "WindowService", "$q"];
	(0, _inherits3.default)(BranchEditController, _BranchBaseController);

	/*@ngInject*/
	function BranchEditController(Auth, $state, User, BranchService, Modal, $translate, $stateParams, WindowService, $q) {
		(0, _classCallCheck3.default)(this, BranchEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (BranchEditController.__proto__ || (0, _getPrototypeOf2.default)(BranchEditController)).call(this, Auth, $state, User, BranchService, Modal, $translate, $stateParams));

		_this.WindowService = WindowService;
		_this.$q = $q;

		_this.model.id = '';
		_this.model.description = '';
		_this.businessDays = [{ label: 'Monday', model: 'businessDayMon' }, { label: 'Tuesday', model: 'businessDayTue' }, { label: 'Wednesday', model: 'businessDayWed' }, { label: 'Thursday', model: 'businessDayThu' }, { label: 'Friday', model: 'businessDayFri' }, { label: 'Saturday', model: 'businessDaySat' }, { label: 'Sunday', model: 'businessDaySun' }, { label: 'Holiday', model: 'businessDayHol' }];
		_this.isDaySelected = function (day) {
			return _this.model[day.model];
		};
		_this.toggleDay = function (day) {
			_this.model[day.model] = !_this.model[day.model];
		};
		return _this;
	}

	(0, _createClass3.default)(BranchEditController, [{
		key: '$onInit',
		value: function $onInit() {
			this.loadData();
		}
	}, {
		key: 'loadData',
		value: function loadData() {
			var _this2 = this;

			this.Service.get(this.$stateParams.id).then(function (data) {
				_this2.rawId = data.id;
				_this2.model.id = data.id;
				_this2.model.description = data.description;
				_this2.model.windows = data.windows;
				_this2.model.windows.forEach(function (data) {
					data.oldValue = data.id;
				});
				_this2.model.businessDayMon = data.businessDayMon;
				_this2.model.businessDayTue = data.businessDayTue;
				_this2.model.businessDayWed = data.businessDayWed;
				_this2.model.businessDayThu = data.businessDayThu;
				_this2.model.businessDayFri = data.businessDayFri;
				_this2.model.businessDaySat = data.businessDaySat;
				_this2.model.businessDaySun = data.businessDaySun;
				_this2.model.businessDayHol = data.businessDayHol;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'addWindow',
		value: function addWindow() {
			this.model.windows.push({
				expand: true,
				id: null,
				isSaved: false,
				description: null
			});
		}
	}, {
		key: 'toggleExpand',
		value: function toggleExpand(window) {
			window.expand = !window.expand;
		}
	}, {
		key: 'saveWindow',
		value: function saveWindow(index) {
			var _this3 = this;

			var windowObj = this.model.windows[index];
			var windowObjData = {
				id: windowObj.id,
				description: windowObj.description,
				branchId: this.model.id,
				allowCoin: windowObj.allowCoin,
				allowCash: windowObj.allowCash,
				locationId: windowObj.locationId,
				oldValue: windowObj.oldValue
			};

			if (windowObj.branchId && windowObj.oldValue) {
				this.WindowService.update(windowObj.oldValue, windowObjData).then(function (res) {
					_this3.model.windows.splice(index, 1, res);
					windowObj.expand = false;
					windowObj.isSaved = true;
				}).then(function () {
					_this3.loadData();
				}).catch(function (err) {
					_this3.errorMessage = _this3.$translate.instant('error.' + 90993);
					console.log(err);
				});
			} else {
				this.WindowService.create(windowObjData).then(function (res) {
					res.branchId = _this3.model.id;
					_this3.model.windows.splice(index, 1, res);
					windowObj.expand = false;
					windowObj.isSaved = true;
				}).then(function () {
					_this3.loadData();
				}).catch(function (err) {
					err.data.errors.map(function (e) {
						_this3.errorMessage += e.message + '<br/>';
					});
				});
			}
		}
	}, {
		key: 'deleteWindow',
		value: function deleteWindow(index) {
			var _this4 = this;

			this.Modal.confirm({
				header: this.$translate.instant('branch.confirm'),
				message: this.$translate.instant('branch.confirm_delete_message'),
				callback: function callback(_ref) {
					var modal = _ref.modal,
					    $scope = _ref.$scope;

					var windowObj = _this4.model.windows[index];

					if (windowObj.branchId) {
						//is already created
						_this4.WindowService.remove(windowObj.id).then(function () {
							_this4.model.windows.splice(index, 1);
							modal.close();
						});
					} else {
						// is newly added
						_this4.model.windows.splice(index, 1);
						modal.close();
					}
				},
				negative: function negative(_ref2) {
					var modal = _ref2.modal,
					    $scope = _ref2.$scope;

					modal.close();
				},
				type: 'primary',
				buttons: ['common.yes', 'common.no']
			});
		}
	}, {
		key: 'reset',
		value: function reset(e) {
			this.loadData();
			delete this.errorMessage;
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this5 = this;

			if (!this.validate()) {
				return;
			}

			this.loading = true;

			this.$q.all(this.model.windows.filter(function (windowObj) {
				return windowObj.isSaved === false;
			}).map(function (windowObj) {
				return windowObj.branchId && windowObj.oldValue ? _this5.WindowService.update(windowObj.oldValue, windowObj) : _this5.WindowService.create((0, _assign2.default)(windowObj, { branchId: _this5.model.id }));
			})).then(function () {
				return _this5.Service.update(_this5.rawId, {
					id: _this5.model.id,
					description: _this5.model.description,
					businessDayMon: _this5.model.businessDayMon,
					businessDayTue: _this5.model.businessDayTue,
					businessDayWed: _this5.model.businessDayWed,
					businessDayThu: _this5.model.businessDayThu,
					businessDayFri: _this5.model.businessDayFri,
					businessDaySat: _this5.model.businessDaySat,
					businessDaySun: _this5.model.businessDaySun,
					businessDayHol: _this5.model.businessDayHol
				});
			}).then(function (data) {
				_this5.loading = false;
				window.history.go(-1);
			}).catch(function (err) {
				_this5.loading = false;
				if (err && err.data && err.data.errors) {
					err.data.errors.map(function (e) {
						_this5.errorMessage += e.message + '<br/>';
					});
				} else {
					_this5.errorMessage = _this5.$translate.instant('error.' + 90993);
				}
			});
		}
	}]);
	return BranchEditController;
}(_branchBase2.default);

exports.default = BranchEditController;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branchEdit = __webpack_require__(1657);

var _branchEdit2 = _interopRequireDefault(_branchEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchEditModule = angular.module('branchedit', []).component('branchedit', _branchEdit2.default).name;

exports.default = branchEditModule;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch = __webpack_require__(1650);

var _branch2 = _interopRequireDefault(_branch);

var _create = __webpack_require__(1656);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(1659);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(1649);

var _all2 = _interopRequireDefault(_all);

var _window = __webpack_require__(1652);

var _window2 = _interopRequireDefault(_window);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchModule = angular.module('branch', [_create2.default, _edit2.default, _all2.default]).component('branch', _branch2.default).component('window', _window2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('branch.edit', {
    url: '/edit/:id',
    component: 'branchedit',
    data: {
      requireACL: 'setting-branch.edit'
    }
  }).state('branch.create', {
    url: '/create',
    component: 'branchcreate',
    data: {
      requireACL: 'setting-branch.create'
    }
  }).state('branch.all', {
    url: '/all/:page',
    component: 'branchall',
    data: {
      requireACL: 'setting-branch.view'
    }
  });
}]).name;

exports.default = branchModule;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_funding_sourceAll = __webpack_require__(2654);

var _branch_funding_sourceAll2 = _interopRequireDefault(_branch_funding_sourceAll);

var _branch_funding_sourceAll3 = __webpack_require__(1662);

var _branch_funding_sourceAll4 = _interopRequireDefault(_branch_funding_sourceAll3);

__webpack_require__(2940);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchFundingSourceallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _branch_funding_sourceAll2.default,
  controller: _branch_funding_sourceAll4.default
};

exports.default = branchFundingSourceallComponent;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _branch_funding_sourceBase = __webpack_require__(265);

var _branch_funding_sourceBase2 = _interopRequireDefault(_branch_funding_sourceBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceallController = function (_BranchFundingSourceB) {
  BranchFundingSourceallController.$inject = ["Auth", "$state", "User", "Modal", "BranchFundingSourceService", "$translate", "$stateParams", "$scope", "$location"];
  (0, _inherits3.default)(BranchFundingSourceallController, _BranchFundingSourceB);

  /*@ngInject*/
  function BranchFundingSourceallController(Auth, $state, User, Modal, BranchFundingSourceService, $translate, $stateParams, $scope, $location) {
    (0, _classCallCheck3.default)(this, BranchFundingSourceallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BranchFundingSourceallController.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceallController)).call(this, Auth, $state, User, BranchFundingSourceService, Modal, $translate, $stateParams, $location));

    _this.id = 'branch-funding-source.all';
    _this._status = 'all';
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.loading = true;
    _this.branchFundingSourceData = [];
    _this.hasAcl = {};
    _this.searchText = '';
    _this.$location = $location;
    _this.branch = User.getUser().branchId;
    return _this;
  }

  (0, _createClass3.default)(BranchFundingSourceallController, [{
    key: '$onInit',
    value: function $onInit() {
      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
    }
  }, {
    key: 'edit',
    value: function edit(branchFundingSource) {
      this.$state.go('branch-funding-source.edit', {
        id: branchFundingSource.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(branchFundingSource) {
      var _this2 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + branchFundingSource.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this2.Service.remove(branchFundingSource.id, _this2.branch).then(function (data) {
            _this2.allowOnlyOnce = false;
            modal.close();
            _this2.refresh();
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this2.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      var obj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.branch
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + this.searchText + '%'
              }, {
                field: 'sourceName',
                condition: 'like',
                data: '%' + this.searchText + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };
      return obj.queryJSON.rules.length ? obj : null;
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }

    // Load All BranchFundingSource

  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      var searchObj = this.generateSearchObj();

      this.loading = true;
      this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this3.total = data.total;
        _this3.branchFundingSourceData = data.results;
        _this3.loading = false;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.error = err.message;
      });
    }
  }]);
  return BranchFundingSourceallController;
}(_branch_funding_sourceBase2.default);

exports.default = BranchFundingSourceallController;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_funding_sourceAll = __webpack_require__(1661);

var _branch_funding_sourceAll2 = _interopRequireDefault(_branch_funding_sourceAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchFundingSourceallModule = angular.module('branchFundingSourceall', []).component('branchFundingSourceall', _branch_funding_sourceAll2.default).name;

exports.default = branchFundingSourceallModule;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_funding_source = __webpack_require__(2655);

var _branch_funding_source2 = _interopRequireDefault(_branch_funding_source);

var _branch_funding_source3 = __webpack_require__(1665);

var _branch_funding_source4 = _interopRequireDefault(_branch_funding_source3);

__webpack_require__(2941);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchFundingSourceComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _branch_funding_source2.default,
  controller: _branch_funding_source4.default
};

exports.default = branchFundingSourceComponent;

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceController = function (_SettingBase) {
  BranchFundingSourceController.$inject = ["$state"];
  (0, _inherits3.default)(BranchFundingSourceController, _SettingBase);

  /*@ngInject*/
  function BranchFundingSourceController($state) {
    (0, _classCallCheck3.default)(this, BranchFundingSourceController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BranchFundingSourceController.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'branch-funding-source';
    _this.$state = $state;
    _this.hasACL = {};
    return _this;
  }

  (0, _createClass3.default)(BranchFundingSourceController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(BranchFundingSourceController.prototype.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['setting-branch-funding-source']) {
        this.hasACL[this.acl['setting-branch-funding-source'][key]] = true;
      }
    }
  }]);
  return BranchFundingSourceController;
}(_SettingBase3.default);

exports.default = BranchFundingSourceController;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_funding_sourceCreate = __webpack_require__(2656);

var _branch_funding_sourceCreate2 = _interopRequireDefault(_branch_funding_sourceCreate);

var _branch_funding_sourceCreate3 = __webpack_require__(1667);

var _branch_funding_sourceCreate4 = _interopRequireDefault(_branch_funding_sourceCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchFundingSourcecreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _branch_funding_sourceCreate2.default,
  controller: _branch_funding_sourceCreate4.default
};

exports.default = branchFundingSourcecreateComponent;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _branch_funding_sourceBase = __webpack_require__(265);

var _branch_funding_sourceBase2 = _interopRequireDefault(_branch_funding_sourceBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceCreateController = function (_BranchFundingSourceB) {
	BranchFundingSourceCreateController.$inject = ["Auth", "$state", "User", "BranchFundingSourceService", "Modal", "$translate", "LocationService", "ShiptypeService", "UserBranchService", "BranchService", "$q", "$scope", "TimezoneList", "UsersService", "CommonLayoutService", "CurrencyService"];
	(0, _inherits3.default)(BranchFundingSourceCreateController, _BranchFundingSourceB);

	/*@ngInject*/
	function BranchFundingSourceCreateController(Auth, $state, User, BranchFundingSourceService, Modal, $translate, LocationService, ShiptypeService, UserBranchService, BranchService, $q, $scope, TimezoneList, UsersService, CommonLayoutService, CurrencyService) {
		(0, _classCallCheck3.default)(this, BranchFundingSourceCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (BranchFundingSourceCreateController.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceCreateController)).call(this, Auth, $state, User, BranchFundingSourceService, Modal, $translate, $scope));

		_this.Auth = Auth;
		_this.$state = $state;
		_this.LocationService = LocationService;
		_this.ShiptypeService = ShiptypeService;
		_this.BranchService = BranchService;
		_this.UserBranchService = UserBranchService;
		_this.TimezoneList = TimezoneList;
		_this.UsersService = UsersService;
		_this.CommonLayoutService = CommonLayoutService;
		_this.CurrencyService = CurrencyService;
		_this.$q = $q;
		_this.hasACL = {};
		_this.businessDays = [{
			label: _this.$translate.instant('location.mon'),
			model: 'businessDayMon'
		}, {
			label: _this.$translate.instant('location.tues'),
			model: 'businessDayTue'
		}, {
			label: _this.$translate.instant('location.wed'),
			model: 'businessDayWed'
		}, {
			label: _this.$translate.instant('location.thurs'),
			model: 'businessDayThu'
		}, {
			label: _this.$translate.instant('location.fri'),
			model: 'businessDayFri'
		}, {
			label: _this.$translate.instant('location.sat'),
			model: 'businessDaySat'
		}, {
			label: _this.$translate.instant('location.sun'),
			model: 'businessDaySun'
		}, {
			label: _this.$translate.instant('location.hol'),
			model: 'businessDayHol'
		}];

		_this.orderLeadDays = [{
			label: _this.$translate.instant('branchFundingSource.one_business_day'),
			value: 1
		}, {
			label: _this.$translate.instant('branchFundingSource.two_business_day'),
			value: 2
		}, {
			label: _this.$translate.instant('branchFundingSource.three_business_day'),
			value: 3
		}, {
			label: _this.$translate.instant('branchFundingSource.four_business_day'),
			value: 4
		}, {
			label: _this.$translate.instant('branchFundingSource.five_business_day'),
			value: 5
		}];

		_this.defaultModel = {
			// id: '',
			sourceName: '',
			branchId: User.getUser().branchId,
			shiptypeId: null,
			locationId: null,
			maxResidualDeposit: null,
			residualDeposit: true,
			manualDeposit: false,
			enableBankReport: false,
			bankReportFTPHost: '',
			bankReportFTPPort: 22,
			bankReportFTPUser: '',
			bankReportFTPPassword: '',
			bankReportFTPPrivateKey: '',
			key: "password",
			bankReportFTPDirectory: '',
			bankReportFilenameFormat: '',
			enableVaultReport: false,
			requireCountCommit: false,
			vaultReportRecipientName: '',
			vaultReportRecipientEmail: '',
			unpackAnyTime: false,
			editCountAnytime: false,
			deliveryReport: false,
			enforceBalanceCheckOnVaultClose: false,
			partialECDeposit: false,
			enableOrderMgmt: false,
			orderLeadTime: false,
			orderLeadDay: null,
			customerOrderLeadTime: false,
			orderLeadDays: null,
			orderLeadCutoff: null,
			depositProcessingTime: null,
			enforceStraps: false,
			orderInterest: false,
			loadedInterest: false,
			residualInterest: false,
			autoOrdering: true,
			autoOrderApproval: false,
			orderSequenceStart: null,
			orderApprovalThreshold: null,
			businessDayMon: false,
			businessDayTue: false,
			businessDayWed: false,
			businessDayThu: false,
			businessDayFri: false,
			businessDaySat: false,
			businessDaySun: false,
			businessDayHol: false,
			orderInterestPercentage: null,
			loadedInterestPercentage: null,
			residualInterestPercentage: null,
			networkData: false,
			autoReconcile: false,
			allowECLoad: false,
			orderCutoffTime: null,
			maxOrders: null,
			orderIdSequencing: false,
			regularInventoryId: null,
			emergencyInventoryId: null,
			editAmount: false,
			allowAmount: false,
			adHocDeposit: false,
			unifiedInventoryId: null,
			bankReportType: 'NONE',
			multiDenomPack: true,
			multiDenomBillLimit: null,
			expectedResidual: false,
			timezone: null,
			pocEmail: '',
			atmForecasting: false,
			currencyId: 'USD',
			ecOrderLeadTime: null,
			varianceCheckEnabled: false,
			varianceThreshold: 0,
			denominations: [],
			autoCreateShipments: false,
			vaultReportFileType: '',
			bagoutForCount: false,
			inventoryBulkCoin: false,
			debitBulkCoinOnPack: false,
			contractedRate: null,
			averageBalanceFee: false,
			customerACH: false,
			customerACHOrderLeadDays: null,
			customerACHSettlementDays: null,
			bankOrder: false,
			bankOrderLeadDays: null,
			autoSendAccounting: false,
			autoSendAccountingTime: null,
			autoSendAccountingEmails: null,
			autoSendCustomerCount: false,
			autoSendCustomerCountTime: null,
			autoSendCustomerACH: false,
			autoSendCustomerACHTime: null
		};

		_this.locationList = [];
		_this.shiptypeData = [];
		_this.branch = [];
		_this.loading = false;
		_this.model = angular.copy(_this.defaultModel);
		_this.timezoneList = _this.TimezoneList.getTimezoneList();
		_this.loggedInUser = User.getUser().id;
		_this.browserTimezone = moment.tz.guess();
		_this.bankReportTypes = _this.CommonLayoutService.bankReportTypes();
		_this.vaultReportFileTypes = [{ label: 'Excel', value: 'excel' }, { label: 'PDF', value: 'pdf' }];
		_this.emailValidation = true;
		_this.intervalList = [{
			label: 'Dynamic',
			value: 'dynamic',
			day: 0
		}, {
			label: 'Weekly',
			value: 'weekly',
			day: 7
		}, {
			label: 'Bi-Weekly',
			value: 'Bi-weekly',
			day: 10
		}, {
			label: 'First Day of Month',
			value: 'first-day-of-month',
			day: 30
		}, {
			label: '2nd Weekly',
			value: '2nd-weekly',
			day: 14
		}, {
			label: '3rd Weekly',
			value: '3rd-weekly',
			day: 21
		}, {
			label: '4th Weekly',
			value: '4th-weekly',
			day: 28
		}, {
			label: '5th Weekly',
			value: '5th-weekly',
			day: 35
		}, {
			label: '6th Weekly',
			value: '6th-weekly',
			day: 42
		}, {
			label: '7th Weekly',
			value: '7th-weekly',
			day: 49
		}, {
			label: '8th Weekly',
			value: '8th-weekly',
			day: 56
		}, {
			label: '9th Weekly',
			value: '9th-weekly',
			day: 63
		}, {
			label: '10th Weekly',
			value: '10th-weekly',
			day: 70
		}, {
			label: '11th Weekly',
			value: '11th-weekly',
			day: 77
		}, {
			label: '12th Weekly',
			value: '12th-weekly',
			day: 84
		}];

		_this.orderingProfileOptions = [];
		return _this;
	}

	// load all location


	(0, _createClass3.default)(BranchFundingSourceCreateController, [{
		key: 'loadLocations',
		value: function loadLocations(searchKey, offset) {
			var _this2 = this;

			searchKey = searchKey || null;

			this.Service.fundingSourceLocation(null, searchKey, this.model.branchId, _app2.default.defaultPageLimit, offset).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this2.totalRecord = data.total;
					_this2.locationList = _this2.mappingLocationData(data.results);
				} else {
					var location = _this2.mappingLocationData(data.results);
					_this2.locationList = _this2.locationList.concat(location);
				}
			}).catch(function (err) {
				_this2.errorMessage = err.data.message + '<br/>';
			});
		}
	}, {
		key: 'mappingLocationData',
		value: function mappingLocationData(location) {
			return location.map(function (loc) {
				return {
					Key: loc.locationId + " | " + loc.locationName,
					Value: loc.locationId
				};
			});
		}

		// load all shiptype

	}, {
		key: 'loadshiptype',
		value: function loadshiptype(searchKey, offset) {
			var _this3 = this;

			searchKey = searchKey || '';

			var shiptypeSearchObj = {
				queryJSON: {
					rules: [{
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'description',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};

			this.ShiptypeService.all(shiptypeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this3.totalRecords = data.total;
					_this3.shiptypeList = _this3.mappingShiptypeData(data.results);
				} else {
					var shiptype = _this3.mappingShiptypeData(data.results);
					_this3.shiptypeList = _this3.shiptypeList.concat(shiptype);
				}
			});
		}
	}, {
		key: 'mappingShiptypeData',
		value: function mappingShiptypeData(shiptype) {
			return shiptype.map(function (shiptypes) {
				return {
					Key: shiptypes.id + " | " + shiptypes.description,
					Value: shiptypes.id
				};
			});
		}
	}, {
		key: '$onInit',
		value: function $onInit() {
			var _this4 = this;

			this.$q.all([this.loadLocations('', 0), this.loadshiptype('', 0), this.UsersService.getUserFieldData(this.loggedInUser), this.CurrencyService.all(null, 0, 100), this.BranchService.getBranchSetup(this.model.branchId)
			// this.UserBranchService.getUserBranches(this.model.loggedInUser)
			]).then(function (data) {
				_this4.userDetails = data[2];
				_this4.branchSetup = data[4];
				_this4.currencyData = data[3].results.filter(function (o) {
					return _this4.branchSetup.availableCurrencyIds && _this4.branchSetup.availableCurrencyIds.includes(o.id);
				});
				_this4.model.currencyId = _this4.branchSetup.currencyId;
				// this.model.timezone = (this.userDetails && this.userDetails.timezone) ? this.userDetails.timezone : this.browserTimezone;
				// this.branch = data[2].results.map((b) => (b.branchId));
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'loadBranchLocations',
		value: function loadBranchLocations() {
			this.model.locationId = "";
			this.loadLocations();
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.model = angular.copy(this.defaultModel);
			// this.model.timezone = (this.userDetails && this.userDetails.timezone) ? this.userDetails.timezone : this.browserTimezone;
			this.orderProfileData = [];
			this.orderingProfileOptions = [];
			this.clearErrors();
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this5 = this;

			this.generateOrderProfile();
			this.loading = true;
			var bfsDenoms = (0, _values2.default)(this.model.denominations).flat();
			var denominations = bfsDenoms.filter(function (d) {
				return d.currencyId === _this5.model.currencyId;
			}).map(function (d) {
				return {
					denominationId: d.id,
					multiDenomAllowed: d.multiDenomAllowed,
					customerOrderable: d.customerOrderable || false,
					expectedResidualPercentage: _this5.expectedResidualValue(d),
					currencyId: d.currencyId,
					coinFlag: d.coinFlag
				};
			});

			var newData = { // id: this.model.id,
				sourceName: this.model.sourceName,
				branchId: this.model.branchId,
				shiptypeId: this.model.shiptypeId.Value,
				locationId: this.model.locationId.Value,
				timezone: this.model.timezone,
				maxResidualDeposit: this.model.maxResidualDeposit ? this.model.maxResidualDeposit : null,
				orderInterestPercentage: this.model.orderInterestPercentage ? this.removePrecentageSign('orderInterestPercentage') : null,
				loadedInterestPercentage: this.model.loadedInterestPercentage ? this.removePrecentageSign('loadedInterestPercentage') : null,
				residualInterestPercentage: this.model.residualInterestPercentage ? this.removePrecentageSign('residualInterestPercentage') : null,
				currencyId: this.model.currencyId,
				varianceCheckEnabled: this.model.varianceCheckEnabled,
				contractedRate: this.model.averageBalanceFee ? this.model.contractedRate : null,
				averageBalanceFee: this.model.averageBalanceFee
			};
			newData = _.pick((0, _assign2.default)(this.model, newData), (0, _keys2.default)(this.defaultModel));
			this.businessDays.forEach(function (day) {
				newData[day.model] = !!_this5.model[day.model];
			});
			newData.orderCutoffTime = newData.orderCutoffTime ? moment(newData.orderCutoffTime).format('HH:mm:ss') : null;
			newData.orderLeadCutoff = newData.orderLeadCutoff ? moment(newData.orderLeadCutoff).format('HH:mm:ss') : null;
			newData.autoSendAccountingTime = newData.autoSendAccountingTime ? moment(newData.autoSendAccountingTime).format('HH:mm:ss') : null;
			newData.autoSendCustomerCountTime = newData.autoSendCustomerCountTime ? moment(newData.autoSendCustomerCountTime).format('HH:mm:ss') : null;
			newData.autoSendCustomerACHTime = newData.autoSendCustomerACHTime ? moment(newData.autoSendCustomerACHTime).format('HH:mm:ss') : null;
			newData.orderProfileData = this.orderProfileData;
			newData.userId = this.loggedInUser;
			newData.bankReportFTPPassword = this.model.key === 'password' && this.model.bankReportFTPPassword ? this.model.bankReportFTPPassword : null;
			newData.bankReportFTPPrivateKey = this.model.key === 'privateKey' && this.model.bankReportFTPPrivateKey ? this.model.bankReportFTPPrivateKey : null;
			newData.unifiedInventoryId = this.model.bankReportType === 'CASHCONNECT' && this.model.unifiedInventoryId ? this.model.unifiedInventoryId : null;
			newData.regularInventoryId = this.model.bankReportType === 'USBANK' && this.model.regularInventoryId ? this.model.regularInventoryId : null;
			newData.emergencyInventoryId = this.model.bankReportType === 'USBANK' && this.model.emergencyInventoryId ? this.model.emergencyInventoryId : null;
			newData.multiDenomBillLimit = this.model.multiDenomPack ? this.model.multiDenomBillLimit : null;
			newData.varianceThreshold = this.model.varianceCheckEnabled ? this.model.varianceThreshold : null;
			newData.inventoryBulkCoin = this.model.inventoryBulkCoin ? this.model.inventoryBulkCoin : false;
			newData.debitBulkCoinOnPack = this.model.debitBulkCoinOnPack ? this.model.debitBulkCoinOnPack : false;
			newData.allowAmount = this.model.allowAmount ? this.model.allowAmount : false;
			newData.adHocDeposit = this.model.adHocDeposit ? this.model.adHocDeposit : false;
			newData.denominations = denominations;

			this.Service.create(newData).then(function (data) {
				_this5.loading = false;
				_this5.askCreate().then(function (createAnotherFundingSource) {
					if (createAnotherFundingSource) _this5.loadLocations('', 0);
				});
			}).catch(function (err) {
				_this5.loading = false;

				if (err && err.data && err.data.errors) {
					err.data.errors.map(function (e) {
						_this5.errorMessage += e.message + '<br/>';
					});
				} else {
					_this5.Modal.errorModal(err.data.message);
				}
			});
		}
	}, {
		key: 'validateManualDeposit',
		value: function validateManualDeposit() {
			this.model.manualDeposit = !this.model.residualDeposit;
		}
	}, {
		key: 'validateResidualDeposit',
		value: function validateResidualDeposit() {
			this.model.residualDeposit = !this.model.manualDeposit;
		}
	}, {
		key: 'resetDeposit',
		value: function resetDeposit() {
			if (this.model.manualDeposit) this.model.maxResidualDeposit = null;
		}
	}, {
		key: 'resetBankReportData',
		value: function resetBankReportData() {
			if (!this.model.enableBankReport) {
				this.model.bankReportFTPHost = null;
				this.model.bankReportFTPPort = 22;
				this.model.bankReportFTPUser = null;
				this.model.bankReportFTPPassword = null;
				this.model.bankReportFTPPrivateKey = null;
				this.model.bankReportFTPDirectory = null;
				this.model.bankReportFilenameFormat = null;
				this.model.regularInventoryId = null;
				this.model.emergencyInventoryId = null;
				this.model.unifiedInventoryId = null;
				this.model.bankReportType = 'NONE';
			}
			if (!this.model.enableVaultReport) {
				this.model.vaultReportRecipientName = null;
				this.model.vaultReportRecipientEmail = null;
				this.model.key = 'password';
			}
		}
	}, {
		key: 'isDaySelected',
		value: function isDaySelected(day) {
			return this.model[day.model];
		}
	}, {
		key: 'toggleDay',
		value: function toggleDay(day) {
			this.model[day.model] = !this.model[day.model];
		}
	}, {
		key: 'resetOrderMgmt',
		value: function resetOrderMgmt() {
			if (!this.model.enableOrderMgmt) {};
		}
	}, {
		key: 'resetAutoOrderingData',
		value: function resetAutoOrderingData() {
			if (!this.model.autoOrdering) {
				this.model.networkData = false;
				this.model.autoReconcile = false;
				this.model.allowECLoad = false;
				this.model.enforceStraps = false;
				this.model.orderLeadTime = false;
				this.model.orderLeadDay = null;
				this.model.depositProcessingTime = null;
				this.model.enforceStraps = false;
				this.model.orderInterest = false;
				this.model.loadedInterest = false;
				this.model.residualInterest = false;
				this.model.orderInterestPercentage = null;
				this.model.loadedInterestPercentage = null;
				this.model.residualInterestPercentage = null;
				this.model.orderCutoffTime = null;
				this.model.maxOrders = null;
				this.model.orderIdSequencing = false;
				this.model.autoOrderApproval = false;
				this.model.orderSequenceStart = null;
				this.model.orderApprovalThreshold = null;
				this.orderProfileData = [];
				this.orderingProfileOptions = [];
				this.model.timezone = null;
				this.model.ecOrderLeadTime = null;
			}
		}
	}, {
		key: 'resetCustomerOrderLeadData',
		value: function resetCustomerOrderLeadData() {
			if (!this.model.customerOrderLeadTime) {
				this.model.orderLeadDays = null;
				this.model.orderLeadCutoff = null;
			}
		}
	}, {
		key: 'resetCustomerAchData',
		value: function resetCustomerAchData() {
			if (!this.model.customerACH) {
				this.model.customerACHOrderLeadDays = null;
				this.model.customerACHSettlementDays = null;
			}
		}
	}, {
		key: 'resetBankOrderData',
		value: function resetBankOrderData() {
			if (!this.model.bankOrder) {
				this.model.bankOrderLeadDays = null;
			}
		}
	}, {
		key: 'resetAchSendAccountingData',
		value: function resetAchSendAccountingData() {
			if (!this.model.autoSendAccounting) {
				this.model.autoSendAccountingTime = null;
				this.model.autoSendAccountingEmails = null;
			}
		}
	}, {
		key: 'resetAutoSendCustCountData',
		value: function resetAutoSendCustCountData() {
			if (!this.model.autoSendCustomerCount) {
				this.model.autoSendCustomerCountTime = null;
			}
		}
	}, {
		key: 'resetAutoSendCustACHData',
		value: function resetAutoSendCustACHData() {
			if (!this.model.autoSendCustomerACH) {
				this.model.autoSendCustomerACHTime = null;
			}
		}
	}, {
		key: 'ngPercentage',
		value: function ngPercentage(key) {
			if (this.model[key] && this.model[key].length) {
				var str = this.model[key];
				return this.model[key] = str.endsWith('%') ? str : str + '%';
			}
		}
	}, {
		key: 'removePrecentageSign',
		value: function removePrecentageSign(key) {
			if (this.model[key] && this.model[key].length) {
				var str = this.model[key] || '';
				return this.model[key] = str.endsWith('%') ? str.replace('%', '') : str;
			}
		}

		// addOrderProfile() {
		// 	this.orderingProfileOptions.push({
		// 		profileName: null,
		// 		addsOrSwaps: 0,
		// 		maxLoadDays: 7,
		// 		isEdit: true,
		// 		isValidProfile: false,
		// 		status: true,
		// 		intervalObj: {
		// 			interval: {
		// 				label: 'Weekly',
		// 				value: 'weekly',
		// 				day: 7
		// 			},
		// 			intervalOptions: this.intervalList
		// 		}
		// 	})
		// }

	}, {
		key: 'validateOrderingProfileFormControl',
		value: function validateOrderingProfileFormControl() {
			var _this6 = this;

			var disableButton = this.orderingProfileOptions.map(function (data) {
				_this6.isValidFormControl = true;
				_this6.isValidFormControl = _this6.isValidFormControl && data.isValidProfile;
				return _this6.isValidFormControl;
			});
			if (disableButton.indexOf(false) >= 0 && this.orderingProfileOptions.length > 0) return false;else return true;
		}
	}, {
		key: 'removeOrderingProfile',
		value: function removeOrderingProfile(index) {
			var _this7 = this;

			this.Modal.confirm({
				header: this.$translate.instant('common.confirm_delete_title'),
				message: this.$translate.instant('common.confirm_delete_message') + '?',
				callback: function callback(_ref) {
					var modal = _ref.modal,
					    $scope = _ref.$scope;

					_this7.orderingProfileOptions.splice(index, 1);
					modal.close();
				},
				negative: function negative(_ref2) {
					var modal = _ref2.modal;

					modal.close();
				},
				type: 'danger'
			});
		}
	}, {
		key: 'saveOrderingProfile',
		value: function saveOrderingProfile(obj, event) {
			event.preventDefault();
			obj.isValidProfile = true;
		}
	}, {
		key: 'setEditFlag',
		value: function setEditFlag(obj) {
			obj.isEdit = false;
		}
	}, {
		key: 'editOrderingProfile',
		value: function editOrderingProfile(obj) {
			obj.isEdit = true;
			obj.isValidBillingRules = false;
		}
	}, {
		key: 'setMTBWLValue',
		value: function setMTBWLValue(obj) {
			var selectedInterval = obj.intervalObj.interval;
			obj.maxLoadDays = selectedInterval['day'];
		}
	}, {
		key: 'generateOrderProfile',
		value: function generateOrderProfile() {
			var _this8 = this;

			if (!this.orderingProfileOptions.length) return [];
			this.orderProfileData = [];

			this.orderingProfileOptions.forEach(function (obj) {
				_this8.orderProfileData.push({
					profileName: obj.profileName,
					addsOrSwaps: obj.addsOrSwaps,
					maxLoadDays: obj.maxLoadDays,
					status: obj.status,
					intervalLabel: obj.intervalObj.interval.label,
					intervalValue: obj.intervalObj.interval.value
				});
			});
		}
	}, {
		key: 'hasValidEmails',
		value: function hasValidEmails(receiverMail) {
			if (!receiverMail) return false;
			var emails = receiverMail.split(',').map(function (email) {
				return email.trim();
			});

			var uniqueEmails = new _set2.default();
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = (0, _getIterator3.default)(emails), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var email = _step.value;

					if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
						return false;
					}
					if (uniqueEmails.has(email)) {
						return false;
					}
					uniqueEmails.add(email);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return true;
		}
	}, {
		key: 'updateOrderProfileStatus',
		value: function updateOrderProfileStatus(obj) {
			var _this9 = this;

			this.Modal.confirmSupervisor('update-order-profile-status', null, function (_ref3) {
				var modal = _ref3.modal,
				    supId = _ref3.supId;

				obj.status = !obj.status;
				modal.close();
			}, function (_ref4) {
				var modal = _ref4.modal;

				modal.close();
				_this9.isLoading = false;
			});
		}
	}, {
		key: 'branchFundingSourceDenominationsModal',
		value: function branchFundingSourceDenominationsModal() {
			var _this10 = this;

			this.Modal.branchFundingSourceDenominations(this.model.denominations, function (_ref5) {
				var modal = _ref5.modal,
				    denominations = _ref5.denominations,
				    $scope = _ref5.$scope;

				_this10.isLoading = true;
				setTimeout(function () {
					_this10.model.denominations = denominations;
					_this10.isLoading = false;
				}, 100);
				modal.close();
			}, function (_ref6) {
				var modal = _ref6.modal;

				modal.close();
			}, this.model.currencyId);
		}
	}, {
		key: 'onCurrencyChange',
		value: function onCurrencyChange() {
			this.model.denominations = {};
		}
	}, {
		key: 'isMultiDenomAllowed',
		value: function isMultiDenomAllowed(denom) {
			if (!denom.coinFlag) {
				return true;
			}
			if (denom.coinPackaging && ['INDIVIDUAL', 'ROLLED'].includes(denom.coinPackaging)) {
				return true;
			}
			return false;
		}
	}, {
		key: 'toggleMultiDenom',
		value: function toggleMultiDenom(obj) {
			if (this.isMultiDenomAllowed(obj)) {
				obj.multiDenomAllowed = !obj.multiDenomAllowed;
			}
		}
	}, {
		key: 'isExpectedResidualDenom',
		value: function isExpectedResidualDenom(denom) {
			return !denom.coinFlag && !denom.unfit;
		}
	}, {
		key: 'expectedResidualValue',
		value: function expectedResidualValue(denom) {
			if (!this.model.expectedResidual || !this.isExpectedResidualDenom(denom)) return null;
			var value = denom.expectedResidualPercentage;
			if (value === null || value === undefined || value === '') return null;
			return Number(String(value).replace('%', ''));
		}
	}, {
		key: 'addResidualPercentSign',
		value: function addResidualPercentSign(denom) {
			var value = denom.expectedResidualPercentage;
			if (value !== null && value !== undefined && String(value) !== '' && !String(value).endsWith('%')) {
				denom.expectedResidualPercentage = value + '%';
			}
		}
	}, {
		key: 'removeResidualPercentSign',
		value: function removeResidualPercentSign(denom) {
			var value = denom.expectedResidualPercentage;
			if (value && String(value).endsWith('%')) {
				denom.expectedResidualPercentage = String(value).replace('%', '');
			}
		}
	}, {
		key: 'toggleCustomerOrderable',
		value: function toggleCustomerOrderable(obj) {
			obj.customerOrderable = !obj.customerOrderable;
		}
	}, {
		key: 'validateMultiDenom',
		value: function validateMultiDenom(obj) {
			var _this11 = this;

			setTimeout(function () {
				if (!obj.isDenomSelected) {
					obj.multiDenomAllowed = false;
				} else {
					if (!_this11.isMultiDenomAllowed(obj)) {
						obj.multiDenomAllowed = false;
					}
				}
				_this11.$scope.$apply();
			});
		}
	}, {
		key: 'removeDenomination',
		value: function removeDenomination(key, index) {
			this.model.denominations[key].splice(index, 1);
		}
	}]);
	return BranchFundingSourceCreateController;
}(_branch_funding_sourceBase2.default);

exports.default = BranchFundingSourceCreateController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_funding_sourceCreate = __webpack_require__(1666);

var _branch_funding_sourceCreate2 = _interopRequireDefault(_branch_funding_sourceCreate);

__webpack_require__(2942);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchFundingSourceCreateModule = angular.module('branchFundingSourcecreate', []).component('branchFundingSourcecreate', _branch_funding_sourceCreate2.default).name;

exports.default = branchFundingSourceCreateModule;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_funding_sourceEdit = __webpack_require__(2657);

var _branch_funding_sourceEdit2 = _interopRequireDefault(_branch_funding_sourceEdit);

var _branch_funding_sourceEdit3 = __webpack_require__(1670);

var _branch_funding_sourceEdit4 = _interopRequireDefault(_branch_funding_sourceEdit3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchFundingSourceeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _branch_funding_sourceEdit2.default,
  controller: _branch_funding_sourceEdit4.default
};

exports.default = branchFundingSourceeditComponent;

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _branch_funding_sourceBase = __webpack_require__(265);

var _branch_funding_sourceBase2 = _interopRequireDefault(_branch_funding_sourceBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceEditController = function (_BranchFundingSourceB) {
	BranchFundingSourceEditController.$inject = ["Auth", "$state", "User", "BranchFundingSourceService", "Modal", "$translate", "LocationService", "$stateParams", "ShiptypeService", "UserBranchService", "BranchService", "$q", "$scope", "TimezoneList", "UsersService", "DateUtil", "BranchFundingSourceOrderProfileService", "CommonLayoutService", "CurrencyService"];
	(0, _inherits3.default)(BranchFundingSourceEditController, _BranchFundingSourceB);

	/*@ngInject*/
	function BranchFundingSourceEditController(Auth, $state, User, BranchFundingSourceService, Modal, $translate, LocationService, $stateParams, ShiptypeService, UserBranchService, BranchService, $q, $scope, TimezoneList, UsersService, DateUtil, BranchFundingSourceOrderProfileService, CommonLayoutService, CurrencyService) {
		(0, _classCallCheck3.default)(this, BranchFundingSourceEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (BranchFundingSourceEditController.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceEditController)).call(this, Auth, $state, User, BranchFundingSourceService, Modal, $translate, $scope));

		_this.LocationService = LocationService;
		_this.ShiptypeService = ShiptypeService;
		_this.BranchService = BranchService;
		_this.$stateParams = $stateParams;
		_this.UserBranchService = UserBranchService;
		_this.TimezoneList = TimezoneList;
		_this.UsersService = UsersService;
		_this.DateUtil = DateUtil;
		_this.BranchFundingSourceOrderProfileService = BranchFundingSourceOrderProfileService;
		_this.CommonLayoutService = CommonLayoutService;
		_this.CurrencyService = CurrencyService;
		_this.$q = $q;
		_this.hasACL = {};
		_this.rawId = '';
		_this.emailValidation = true;

		_this.defaultModel = {
			// id: '',
			sourceName: '',
			branchId: User.getUser().branchId,
			shiptypeId: null,
			locationId: null,
			loggedInUser: User.getUser().id,
			maxResidualDeposit: null,
			residualDeposit: false,
			manualDeposit: false,
			enableBankReport: false,
			bankReportFTPHost: null,
			bankReportFTPPort: 22,
			bankReportFTPUser: null,
			bankReportFTPPassword: null,
			bankReportFTPPrivateKey: null,
			key: "password",
			bankReportFTPDirectory: null,
			bankReportFilenameFormat: null,
			enableVaultReport: false,
			requireCountCommit: false,
			vaultReportRecipientName: null,
			vaultReportRecipientEmail: null,
			unpackAnyTime: false,
			editCountAnytime: false,
			deliveryReport: false,
			enforceBalanceCheckOnVaultClose: false,
			partialECDeposit: false,
			enableOrderMgmt: false,
			orderLeadTime: false,
			orderLeadDay: null,
			customerOrderLeadTime: false,
			orderLeadDays: null,
			orderLeadCutoff: null,
			depositProcessingTime: null,
			enforceStraps: false,
			orderInterest: false,
			loadedInterest: false,
			residualInterest: false,
			autoOrdering: false,
			autoOrderApproval: false,
			orderSequenceStart: 0,
			orderApprovalThreshold: null,
			businessDayMon: false,
			businessDayTue: false,
			businessDayWed: false,
			businessDayThu: false,
			businessDayFri: false,
			businessDaySat: false,
			businessDaySun: false,
			businessDayHol: false,
			orderInterestPercentage: null,
			loadedInterestPercentage: null,
			residualInterestPercentage: null,
			networkData: false,
			autoReconcile: false,
			allowECLoad: false,
			orderCutoffTime: null,
			maxOrders: null,
			orderIdSequencing: false,
			regularInventoryId: null,
			emergencyInventoryId: null,
			editAmount: false,
			allowAmount: false,
			adHocDeposit: false,
			unifiedInventoryId: null,
			bankReportType: 'NONE',
			multiDenomPack: true,
			multiDenomBillLimit: null,
			expectedResidual: false,
			timezone: null,
			pocEmail: '',
			atmForecasting: false,
			currencyId: null,
			ecOrderLeadTime: null,
			varianceCheckEnabled: false,
			varianceThreshold: 0,
			autoCreateShipments: false,
			inventoryBulkCoin: false,
			debitBulkCoinOnPack: false,
			vaultReportFileType: '',
			bagoutForCount: false,
			contractedRate: null,
			averageBalanceFee: false,
			customerACH: false,
			customerACHOrderLeadDays: null,
			customerACHSettlementDays: null,
			bankOrder: false,
			bankOrderLeadDays: null,
			autoSendAccounting: false,
			autoSendAccountingTime: null,
			autoSendAccountingEmails: null,
			autoSendCustomerCount: false,
			autoSendCustomerCountTime: null,
			autoSendCustomerACH: false,
			autoSendCustomerACHTime: null
		};

		_this.businessDays = [{
			label: _this.$translate.instant('location.mon'),
			model: 'businessDayMon'
		}, {
			label: _this.$translate.instant('location.tues'),
			model: 'businessDayTue'
		}, {
			label: _this.$translate.instant('location.wed'),
			model: 'businessDayWed'
		}, {
			label: _this.$translate.instant('location.thurs'),
			model: 'businessDayThu'
		}, {
			label: _this.$translate.instant('location.fri'),
			model: 'businessDayFri'
		}, {
			label: _this.$translate.instant('location.sat'),
			model: 'businessDaySat'
		}, {
			label: _this.$translate.instant('location.sun'),
			model: 'businessDaySun'
		}, {
			label: _this.$translate.instant('location.hol'),
			model: 'businessDayHol'
		}];

		_this.orderLeadDays = [{
			label: _this.$translate.instant('branchFundingSource.one_business_day'),
			value: 1
		}, {
			label: _this.$translate.instant('branchFundingSource.two_business_day'),
			value: 2
		}, {
			label: _this.$translate.instant('branchFundingSource.three_business_day'),
			value: 3
		}, {
			label: _this.$translate.instant('branchFundingSource.four_business_day'),
			value: 4
		}, {
			label: _this.$translate.instant('branchFundingSource.five_business_day'),
			value: 5
		}];
		_this.locationData = [];
		_this.shiptypeData = [];
		_this.branch = [];
		_this.model = angular.copy(_this.defaultModel);
		_this.loading = false;
		_this.timezoneList = _this.TimezoneList.getTimezoneList();
		_this.browserTimezone = moment.tz.guess();
		_this.bankReportTypes = _this.CommonLayoutService.bankReportTypes();
		_this.vaultReportFileTypes = [{ label: 'Excel', value: 'excel' }, { label: 'PDF', value: 'pdf' }];

		_this.intervalList = [{
			label: 'Dynamic',
			value: 'dynamic',
			day: 0
		}, {
			label: 'Weekly',
			value: 'weekly',
			day: 7
		}, {
			label: 'Bi-Weekly',
			value: 'Bi-weekly',
			day: 10
		}, {
			label: 'First Day of Month',
			value: 'first-day-of-month',
			day: 30
		}, {
			label: '2nd Weekly',
			value: '2nd-weekly',
			day: 14
		}, {
			label: '3rd Weekly',
			value: '3rd-weekly',
			day: 21
		}, {
			label: '4th Weekly',
			value: '4th-weekly',
			day: 28
		}, {
			label: '5th Weekly',
			value: '5th-weekly',
			day: 35
		}, {
			label: '6th Weekly',
			value: '6th-weekly',
			day: 42
		}, {
			label: '7th Weekly',
			value: '7th-weekly',
			day: 49
		}, {
			label: '8th Weekly',
			value: '8th-weekly',
			day: 56
		}, {
			label: '9th Weekly',
			value: '9th-weekly',
			day: 63
		}, {
			label: '10th Weekly',
			value: '10th-weekly',
			day: 70
		}, {
			label: '11th Weekly',
			value: '11th-weekly',
			day: 77
		}, {
			label: '12th Weekly',
			value: '12th-weekly',
			day: 84
		}];

		_this.orderingProfileOptions = [];
		_this.deleteOrderProfileRecord = [];
		return _this;
	}

	(0, _createClass3.default)(BranchFundingSourceEditController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.model.loading = true;
			this.$q.all([this.UserBranchService.getUserBranches(this.model.loggedInUser), this.Service.get(this.$stateParams.id), this.UsersService.getUserFieldData(this.model.loggedInUser),
			// this.getOrderProfile(),
			this.getFundingSourceHolidayCount(), this.CurrencyService.all(null, 0, 100), this.BranchService.getBranchSetup(this.model.branchId)]).then(function (data) {
				_this2.branch = data[0].results.map(function (b) {
					return b.branchId;
				});
				_this2.branchFundingData = data[1].results;
				_this2.defaultModel = data[1].results;
				(0, _assign2.default)(_this2.model, data[1].results);
				_this2.model.id = data[1].results.id;
				_this2.userDetails = data[2];
				_this2.model.timezone = data[1].results.autoOrdering == false ? data[1].results.timezone = null : data[1].results.timezone;
				_this2.model.maxResidualDeposit = data[1].results.maxResidualDeposit ? data[1].results.maxResidualDeposit : null;
				_this2.model.orderInterestPercentage = data[1].results.orderInterestPercentage ? _this2.ngPercentage('orderInterestPercentage') : null;
				_this2.model.loadedInterestPercentage = data[1].results.loadedInterestPercentage ? _this2.ngPercentage('loadedInterestPercentage') : null;
				_this2.model.residualInterestPercentage = data[1].results.residualInterestPercentage ? _this2.ngPercentage('residualInterestPercentage') : null;
				_this2.model.orderCutoffTime = _this2.DateUtil.getTime(data[1].results.orderCutoffTime);
				_this2.model.orderLeadCutoff = _this2.DateUtil.getTime(data[1].results.orderLeadCutoff);
				_this2.model.autoSendAccountingTime = _this2.DateUtil.getTime(data[1].results.autoSendAccountingTime);
				_this2.model.autoSendCustomerCountTime = _this2.DateUtil.getTime(data[1].results.autoSendCustomerCountTime);
				_this2.model.autoSendCustomerACHTime = _this2.DateUtil.getTime(data[1].results.autoSendCustomerACHTime);
				_this2.model.key = _this2.model.bankReportFTPPassword ? 'password' : _this2.model.bankReportFTPPrivateKey ? 'privateKey' : null;
				_this2.model.contractedRate = data[1].results.averageBalanceFee ? data[1].results.contractedRate : null;
				_this2.model.averageBalanceFee = data[1].results.averageBalanceFee;
				if (data[1].results.location) {
					data[1].results.location.Key = data[1].results.location.id + " | " + data[1].results.location.name;
					data[1].results.location.Value = data[1].results.location.id;
				}
				if (data[1].results.shiptype) {
					data[1].results.shiptype.Key = data[1].results.shiptype.id + " | " + data[1].results.shiptype.description;
					data[1].results.shiptype.Value = data[1].results.shiptype.id;
				}
				if (data[1].results.currency) {
					data[1].results.currency.Key = data[1].results.currency.id + " | " + data[1].results.currency.name;
					data[1].results.currency.Value = data[1].results.currency.id;
				}
				_this2.model.locationId = data[1].results.location;
				_this2.model.shiptypeId = data[1].results.shiptype;
				_this2.branchFundingSourceDenominations = _.cloneDeep(_this2.branchFundingData.denominations);
				_this2.model.denominations = data[1].results.denominations;
				_.flatten(_.values(_this2.model.denominations)).forEach(function (d) {
					return _this2.addResidualPercentSign(d);
				});
				_this2.branchSetup = data[5];
				_this2.currencyData = data[4].results.filter(function (o) {
					return _this2.branchSetup.availableCurrencyIds && _this2.branchSetup.availableCurrencyIds.includes(o.id);
				});
				_this2.defaultModel.currencyId = _this2.branchSetup.availableCurrencyIds ? _this2.branchSetup.availableCurrencyIds.find(function (c) {
					return c === _this2.defaultModel.currencyId;
				}) || _this2.defaultModel.currencyId : _this2.defaultModel.currencyId;
				_this2.model.currencyId = _this2.defaultModel.currencyId;
				_this2.originalCurrencyId = _this2.defaultModel.currencyId;
				_this2.getAllLocation('', 0);
				_this2.getAllShiptype('', 0);
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this2.model.loading = false;
			});
		}

		// get all location

	}, {
		key: 'getAllLocation',
		value: function getAllLocation(searchKey, offset) {
			var _this3 = this;

			searchKey = searchKey || null;
			var locationId = this.model.locationId ? this.model.locationId.Value : null;

			if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
				offset = offset - 1;
			}

			this.Service.fundingSourceLocation(locationId, searchKey, this.model.branchId, _app2.default.defaultPageLimit, offset).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this3.totalRecord = data.total;
					_this3.locationList = _this3.mappingLocationData(data.results, searchKey);
					if (!searchKey && _this3.model.locationId) {
						_this3.locationList.unshift(_this3.model.locationId);
					}
				} else {
					var location = _this3.mappingLocationData(data.results, searchKey);
					_this3.locationList = _this3.locationList.concat(location);
				}
			}).catch(function (err) {
				_this3.errorMessage = err.data.message + '<br/>';
			});
		}
	}, {
		key: 'mappingLocationData',
		value: function mappingLocationData(locations, searchKey) {
			var _this4 = this;

			var location = [];
			locations.map(function (loc) {
				loc.Key = loc.locationId + " | " + loc.locationName;
				loc.Value = loc.locationId;
				if (!searchKey && _this4.model.locationId) {
					if (loc.locationId !== _this4.model.locationId.id) {
						location.push(loc);
					}
				} else {
					location.push(loc);
				}
			});
			return location;
		}

		// load all shiptype

	}, {
		key: 'loadshiptype',
		value: function loadshiptype(searchKey, offset) {

			searchKey = searchKey || '';

			var shiptypeSearchObj = {
				queryJSON: {
					rules: [{
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'description',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};

			return shiptypeSearchObj.queryJSON.rules.length ? shiptypeSearchObj : null;
		}

		// get all shiptype

	}, {
		key: 'getAllShiptype',
		value: function getAllShiptype(searchKey, offset) {
			var _this5 = this;

			var loadShiptypeDatas = this.loadshiptype(searchKey);
			if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
				offset = offset - 1;
			}
			this.ShiptypeService.all(loadShiptypeDatas, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this5.totalRecords = data.total;
					_this5.shiptypeList = _this5.mappingShiptypeData(data.results, searchKey);
					if (!searchKey && _this5.model.shiptypeId) {
						_this5.shiptypeList.unshift(_this5.model.shiptypeId);
					}
				} else {
					var shiptype = _this5.mappingShiptypeData(data.results, searchKey);
					_this5.shiptypeList = _this5.shiptypeList.concat(shiptype);
				}
			});
		}
	}, {
		key: 'mappingShiptypeData',
		value: function mappingShiptypeData(shiptypes, searchKey) {
			var _this6 = this;

			var shiptypeData = [];
			shiptypes.map(function (shiptype) {
				if (!searchKey) {
					if (shiptype.id !== _this6.model.shiptypeId.id) {
						shiptype.Key = shiptype.id + " | " + shiptype.description;
						shiptype.Value = shiptype.id;
						shiptypeData.push(shiptype);
					}
				} else {
					shiptype.Key = shiptype.id + " | " + shiptype.description;
					shiptype.Value = shiptype.id;
					shiptypeData.push(shiptype);
				}
			});
			return shiptypeData;
		}
	}, {
		key: 'reset',
		value: function reset() {
			var _this7 = this;

			this.isLoading = true;
			this.model.loading = true;
			this.Service.get(this.$stateParams.id).then(function (data) {
				_this7.branchFundingData = data.results;
				_this7.defaultModel = data.results;
				var loggedInUser = _this7.model.loggedInUser;
				_this7.model = angular.copy(_this7.defaultModel);
				_this7.model.loggedInUser = loggedInUser;
				_this7.model.orderCutoffTime = _this7.DateUtil.getTime(_this7.model.orderCutoffTime);
				_this7.model.orderLeadCutoff = _this7.DateUtil.getTime(_this7.model.orderLeadCutoff);
				_this7.model.autoSendAccountingTime = _this7.DateUtil.getTime(_this7.model.autoSendAccountingTime);
				_this7.model.autoSendCustomerCountTime = _this7.DateUtil.getTime(_this7.model.autoSendCustomerCountTime);
				_this7.model.autoSendCustomerACHTime = _this7.DateUtil.getTime(_this7.model.autoSendCustomerACHTime);
				_this7.model.timezone = _this7.defaultModel.timezone;

				if (_this7.branchFundingData.location) {
					_this7.branchFundingData.location.Key = _this7.branchFundingData.location.id + " | " + _this7.branchFundingData.location.name;
					_this7.branchFundingData.location.Value = _this7.branchFundingData.location.id;
				}
				if (_this7.branchFundingData.shiptype) {
					_this7.branchFundingData.shiptype.Key = _this7.branchFundingData.shiptype.id + " | " + _this7.branchFundingData.shiptype.description;
					_this7.branchFundingData.shiptype.Value = _this7.branchFundingData.shiptype.id;
				}
				_this7.model.locationId = _this7.branchFundingData.location;
				_this7.model.shiptypeId = _this7.branchFundingData.shiptype;

				_this7.deleteOrderProfileRecord = [];
				_this7.orderProfileData = [];
				_this7.orderingProfileOptions = [];
				_this7.getAllLocation('', 0);
				_this7.clearErrors();
				_this7.model.key = _this7.model.bankReportFTPPassword ? 'password' : _this7.model.bankReportFTPPrivateKey ? 'privateKey' : null;
				_this7.model.denominations = _this7.branchFundingData.denominations;
				_.flatten(_.values(_this7.model.denominations)).forEach(function (d) {
					return _this7.addResidualPercentSign(d);
				});
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this7.isLoading = false;
				_this7.model.loading = false;
			});
		}
	}, {
		key: 'loadBranchLocations',
		value: function loadBranchLocations() {
			this.model.locationId = null;
			this.getAllLocation('', 0);
		}
	}, {
		key: 'submit',
		value: function submit() {
			var _this8 = this;

			this.generateOrderProfile();
			this.loading = true;

			var updateObj = {
				id: this.model.id,
				sourceName: this.model.sourceName,
				branchId: this.model.branchId,
				shiptypeId: this.model.shiptypeId.Value,
				locationId: this.model.locationId.Value,
				maxResidualDeposit: this.model.maxResidualDeposit ? this.model.maxResidualDeposit : null,
				orderInterestPercentage: this.model.orderInterestPercentage ? this.removePrecentageSign('orderInterestPercentage') : null,
				loadedInterestPercentage: this.model.loadedInterestPercentage ? this.removePrecentageSign('loadedInterestPercentage') : null,
				residualInterestPercentage: this.model.residualInterestPercentage ? this.removePrecentageSign('residualInterestPercentage') : null,
				currencyId: this.model.currencyId,
				varianceCheckEnabled: this.model.varianceCheckEnabled,
				contractedRate: this.model.averageBalanceFee ? this.model.contractedRate : null,
				averageBalanceFee: this.model.averageBalanceFee
			};

			updateObj.varianceThreshold = this.model.varianceCheckEnabled ? this.model.varianceThreshold : null;
			updateObj = _.pick((0, _assign2.default)(this.model, updateObj), (0, _keys2.default)(this.defaultModel));
			this.businessDays.forEach(function (day) {
				updateObj[day.model] = !!_this8.model[day.model];
			});
			updateObj.orderCutoffTime = updateObj.orderCutoffTime ? moment(updateObj.orderCutoffTime).format('HH:mm:ss') : null;
			updateObj.orderLeadCutoff = updateObj.orderLeadCutoff ? moment(updateObj.orderLeadCutoff).format('HH:mm:ss') : null;
			updateObj.autoSendAccountingTime = updateObj.autoSendAccountingTime ? moment(updateObj.autoSendAccountingTime).format('HH:mm:ss') : null;
			updateObj.autoSendCustomerCountTime = updateObj.autoSendCustomerCountTime ? moment(updateObj.autoSendCustomerCountTime).format('HH:mm:ss') : null;
			updateObj.autoSendCustomerACHTime = updateObj.autoSendCustomerACHTime ? moment(updateObj.autoSendCustomerACHTime).format('HH:mm:ss') : null;
			updateObj.orderLeadDays = this.model.customerOrderLeadTime && this.model.orderLeadDays !== null && this.model.orderLeadDays !== '' ? parseInt(this.model.orderLeadDays, 10) : null;
			updateObj.customerACHOrderLeadDays = this.model.customerACH && this.model.customerACHOrderLeadDays !== null && this.model.customerACHOrderLeadDays !== '' ? parseInt(this.model.customerACHOrderLeadDays, 10) : null;
			updateObj.customerACHSettlementDays = this.model.customerACH && this.model.customerACHSettlementDays !== null && this.model.customerACHSettlementDays !== '' ? parseInt(this.model.customerACHSettlementDays, 10) : null;
			updateObj.bankOrderLeadDays = this.model.bankOrder && this.model.bankOrderLeadDays !== null && this.model.bankOrderLeadDays !== '' ? parseInt(this.model.bankOrderLeadDays, 10) : null;
			updateObj.orderProfileData = this.orderProfileData;
			updateObj.userId = this.model.loggedInUser;
			updateObj.deleteOrderProfileRecord = this.deleteOrderProfileRecord;
			updateObj.bankReportFTPPassword = this.model.key === 'password' && this.model.bankReportFTPPassword ? this.model.bankReportFTPPassword : null;
			updateObj.bankReportFTPPrivateKey = this.model.key === 'privateKey' && this.model.bankReportFTPPrivateKey ? this.model.bankReportFTPPrivateKey : null;
			updateObj.unifiedInventoryId = this.model.bankReportType === 'CASHCONNECT' && this.model.unifiedInventoryId ? this.model.unifiedInventoryId : null;
			updateObj.regularInventoryId = this.model.bankReportType === 'USBANK' && this.model.regularInventoryId ? this.model.regularInventoryId : null;
			updateObj.emergencyInventoryId = this.model.bankReportType === 'USBANK' && this.model.emergencyInventoryId ? this.model.emergencyInventoryId : null;
			updateObj.multiDenomBillLimit = this.model.multiDenomPack ? this.model.multiDenomBillLimit : null;
			updateObj.timezone = this.model.timezone ? this.model.timezone : null;
			updateObj.inventoryBulkCoin = this.model.inventoryBulkCoin ? this.model.inventoryBulkCoin : false;
			updateObj.debitBulkCoinOnPack = this.model.debitBulkCoinOnPack ? this.model.debitBulkCoinOnPack : false;
			updateObj.allowAmount = this.model.allowAmount ? this.model.allowAmount : false;
			updateObj.adHocDeposit = this.model.adHocDeposit ? this.model.adHocDeposit : false;
			updateObj.denominations = this.compareObjects(this.branchFundingSourceDenominations, this.model.denominations);

			// delete updateObj.location;
			// delete updateObj.shiptype;
			delete updateObj.currency;

			this.Service.update(this.model.id, (0, _extends3.default)({}, updateObj, { userId: this.model.loggedInUser })).then(function (data) {
				window.history.go(-1);
			}).catch(function (err) {

				_this8.model.shiptypeId = {
					Key: updateObj.shiptype.id + " | " + updateObj.shiptype.description,
					Value: updateObj.shiptype.id
				};

				_this8.model.locationId = {
					Key: updateObj.location.id + " | " + updateObj.location.name,
					Value: updateObj.location.id
				};

				if (err && err.data && err.data.errors) {
					err.data.errors.map(function (e) {
						_this8.errorMessage += e.message + '<br/>';
					});
				} else {
					_this8.Modal.errorModal(err.data.message);
				}
			}).finally(function () {
				_this8.loading = false;
			});
		}
	}, {
		key: 'validateManualDeposit',
		value: function validateManualDeposit() {
			this.model.manualDeposit = !this.model.residualDeposit;
		}
	}, {
		key: 'validateResidualDeposit',
		value: function validateResidualDeposit() {
			this.model.residualDeposit = !this.model.manualDeposit;
		}
	}, {
		key: 'resetDeposit',
		value: function resetDeposit() {
			if (this.model.manualDeposit) this.model.maxResidualDeposit = null;
		}
	}, {
		key: 'resetBankReportData',
		value: function resetBankReportData() {
			if (!this.model.enableBankReport) {
				this.model.bankReportFTPHost = null;
				this.model.bankReportFTPPort = 22;
				this.model.bankReportFTPUser = null;
				this.model.bankReportFTPPassword = null;
				this.model.bankReportFTPPrivateKey = null;
				this.model.bankReportFTPDirectory = null;
				this.model.bankReportFilenameFormat = null;
				this.model.regularInventoryId = null;
				this.model.emergencyInventoryId = null;
				this.model.unifiedInventoryId = null;
				this.model.bankReportType = 'NONE';
			}
			if (!this.model.enableVaultReport) {
				this.model.vaultReportRecipientName = null;
				this.model.vaultReportRecipientEmail = null;
				this.model.key = 'password';
			}
		}
	}, {
		key: 'hasValidEmails',
		value: function hasValidEmails(receiverMail) {
			if (!receiverMail) return false;
			var emails = receiverMail.split(',').map(function (email) {
				return email.trim();
			});

			var uniqueEmails = new _set2.default();
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = (0, _getIterator3.default)(emails), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var email = _step.value;

					if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
						return false;
					}
					if (uniqueEmails.has(email)) {
						return false;
					}
					uniqueEmails.add(email);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return true;
		}
	}, {
		key: 'isDaySelected',
		value: function isDaySelected(day) {
			return this.model[day.model];
		}
	}, {
		key: 'toggleDay',
		value: function toggleDay(day) {
			this.model[day.model] = !this.model[day.model];
		}
	}, {
		key: 'resetOrderMgmt',
		value: function resetOrderMgmt() {
			if (!this.model.enableOrderMgmt) {};
		}
	}, {
		key: 'resetAutoOrderingData',
		value: function resetAutoOrderingData() {
			var _this9 = this;

			if (!this.model.autoOrdering) {
				this.model.networkData = false;
				this.model.autoReconcile = false;
				this.model.allowECLoad = false;
				this.model.enforceStraps = false;
				this.model.orderLeadTime = false;
				this.model.orderLeadDay = null;
				this.model.depositProcessingTime = null;
				this.model.enforceStraps = false;
				this.model.orderInterest = false;
				this.model.loadedInterest = false;
				this.model.residualInterest = false;
				this.model.orderInterestPercentage = null;
				this.model.loadedInterestPercentage = null;
				this.model.residualInterestPercentage = null;
				this.model.orderCutoffTime = null;
				this.model.timezone = null;
				this.model.maxOrders = null;
				this.model.orderIdSequencing = false;
				this.model.autoOrderApproval = false;
				this.model.orderSequenceStart = null;
				this.model.orderApprovalThreshold = null;
				this.orderingProfileOptions.forEach(function (obj) {
					_this9.deleteOrderProfileRecord.push(obj.orderProfileId);
				});
				this.orderProfileData = [];
				this.orderingProfileOptions = [];
				this.model.ecOrderLeadTime = null;
			}
		}
	}, {
		key: 'resetCustomerOrderLeadData',
		value: function resetCustomerOrderLeadData() {
			if (!this.model.customerOrderLeadTime) {
				this.model.orderLeadDays = null;
				this.model.orderLeadCutoff = null;
			}
		}
	}, {
		key: 'resetCustomerAchData',
		value: function resetCustomerAchData() {
			if (!this.model.customerACH) {
				this.model.customerACHOrderLeadDays = null;
				this.model.customerACHSettlementDays = null;
			}
		}
	}, {
		key: 'resetBankOrderData',
		value: function resetBankOrderData() {
			if (!this.model.bankOrder) {
				this.model.bankOrderLeadDays = null;
			}
		}
	}, {
		key: 'resetAchSendAccountingData',
		value: function resetAchSendAccountingData() {
			if (!this.model.autoSendAccounting) {
				this.model.autoSendAccountingTime = null;
				this.model.autoSendAccountingEmails = null;
			}
		}
	}, {
		key: 'resetAutoSendCustCountData',
		value: function resetAutoSendCustCountData() {
			if (!this.model.autoSendCustomerCount) {
				this.model.autoSendCustomerCountTime = null;
			}
		}
	}, {
		key: 'resetAutoSendCustACHData',
		value: function resetAutoSendCustACHData() {
			if (!this.model.autoSendCustomerACH) {
				this.model.autoSendCustomerACHTime = null;
			}
		}
	}, {
		key: 'ngPercentage',
		value: function ngPercentage(key) {
			if (this.model[key]) {
				var str = this.model[key].toString();
				return this.model[key] = str ? str.endsWith('%') ? str : str + '%' : null;
			}
		}
	}, {
		key: 'removePrecentageSign',
		value: function removePrecentageSign(key) {
			if (this.model[key] && this.model[key].length) {
				var str = this.model[key] || '';
				return this.model[key] = str.endsWith('%') ? str.replace('%', '') : str;
			}
		}

		// addOrderProfile() {
		// 	this.orderingProfileOptions.push({
		// 		profileName: null,
		// 		addsOrSwaps: 0,
		// 		maxLoadDays: 7,
		// 		isEdit: true,
		// 		isValidProfile: false,
		// 		status: true,
		// 		intervalObj: {
		// 			interval: {
		// 				label: 'Weekly',
		// 				value: 'weekly',
		// 				day: 7
		// 			},
		// 			intervalOptions: this.intervalList
		// 		},
		// 		orderProfileId: null
		// 	})
		// }

	}, {
		key: 'validateOrderingProfileFormControl',
		value: function validateOrderingProfileFormControl() {
			var _this10 = this;

			var disableButton = this.orderingProfileOptions.map(function (data) {
				_this10.isValidFormControl = true;
				_this10.isValidFormControl = _this10.isValidFormControl && data.isValidProfile;
				return _this10.isValidFormControl;
			});
			if (disableButton.indexOf(false) >= 0 && this.orderingProfileOptions.length > 0) return false;else return true;
		}
	}, {
		key: 'removeOrderingProfile',
		value: function removeOrderingProfile(obj, index) {
			var _this11 = this;

			this.Modal.confirm({
				header: this.$translate.instant('common.confirm_delete_title'),
				message: this.$translate.instant('common.confirm_delete_message') + '?',
				callback: function callback(_ref) {
					var modal = _ref.modal,
					    $scope = _ref.$scope;

					_this11.orderingProfileOptions.splice(index, 1);
					if (obj.orderProfileId) _this11.deleteOrderProfileRecord.push(obj.orderProfileId);
					modal.close();
				},
				negative: function negative(_ref2) {
					var modal = _ref2.modal;

					modal.close();
				},
				type: 'danger'
			});
		}
	}, {
		key: 'saveOrderingProfile',
		value: function saveOrderingProfile(obj, event) {
			event.preventDefault();
			obj.isValidProfile = true;
		}
	}, {
		key: 'setEditFlag',
		value: function setEditFlag(obj) {
			obj.isEdit = false;
		}
	}, {
		key: 'editOrderingProfile',
		value: function editOrderingProfile(obj) {
			obj.isEdit = true;
			obj.isValidBillingRules = false;
		}
	}, {
		key: 'setMTBWLValue',
		value: function setMTBWLValue(obj) {
			var selectedInterval = obj.intervalObj.interval;
			obj.maxLoadDays = selectedInterval['day'];
		}
	}, {
		key: 'generateOrderProfile',
		value: function generateOrderProfile() {
			var _this12 = this;

			if (!this.orderingProfileOptions.length) return [];
			this.orderProfileData = [];

			this.orderingProfileOptions.forEach(function (obj) {
				_this12.orderProfileData.push({
					profileName: obj.profileName,
					addsOrSwaps: obj.addsOrSwaps,
					maxLoadDays: obj.maxLoadDays,
					status: obj.status,
					intervalLabel: obj.intervalObj.interval.label,
					intervalValue: obj.intervalObj.interval.value,
					orderProfileId: obj.orderProfileId ? obj.orderProfileId : null
				});
			});
		}
	}, {
		key: 'orderProfileQuery',
		value: function orderProfileQuery() {
			var orderProfileObj = {
				queryJSON: {
					rules: [{
						field: 'branchFundingSourceId',
						condition: '=',
						data: this.$stateParams.id
					}],
					operator: 'AND'
				}
			};

			return orderProfileObj.queryJSON.rules.length ? orderProfileObj : null;
		}
	}, {
		key: 'getOrderProfile',
		value: function getOrderProfile() {
			var _this13 = this;

			var searchObj = this.orderProfileQuery();

			this.BranchFundingSourceOrderProfileService.all(searchObj, 0, 100).then(function (orderProfile) {
				orderProfile.results.forEach(function (op, index) {
					var _this13$orderingProfi;

					var loadInterval = op.loadInterval ? _.find(_this13.intervalList, { 'value': op.loadInterval }) : null;

					_this13.orderingProfileOptions.push((_this13$orderingProfi = {
						name: op.name,
						description: op.description,
						status: op.status,
						isValidBillingRules: true,
						intervalObj: {
							interval: loadInterval,
							intervalOptions: _this13.intervalList
						},
						isEdit: false,
						profileName: op.name,
						addsOrSwaps: op.addsBWSwaps,
						maxLoadDays: op.maxBWLoads,
						isValidProfile: true
					}, (0, _defineProperty3.default)(_this13$orderingProfi, 'status', op.active), (0, _defineProperty3.default)(_this13$orderingProfi, 'orderProfileId', op.id), _this13$orderingProfi));
				});
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this13.loading = false;
			});
		}
	}, {
		key: 'updateOrderProfileStatus',
		value: function updateOrderProfileStatus(obj) {
			var _this14 = this;

			this.Modal.confirmSupervisor('update-order-profile-status', null, function (_ref3) {
				var modal = _ref3.modal,
				    supId = _ref3.supId;

				obj.status = !obj.status;
				modal.close();
			}, function (_ref4) {
				var modal = _ref4.modal;

				modal.close();
				_this14.isLoading = false;
			});
		}
	}, {
		key: 'getFundingSourceHolidayCount',
		value: function getFundingSourceHolidayCount() {
			var _this15 = this;

			var startDate = moment().format('YYYY-MM-DD');
			var endDate = moment().endOf('year').format('YYYY-MM-DD');

			this.Service.getFundingSourceHolidayCount(this.$stateParams.id, startDate, endDate).then(function (data) {
				_this15.totalFundingSourceHoliday = data.total;
			}).catch(function (err) {
				console.log(err);
			});
		}
		// convertDateTime() {
		// 	const orderCutoffTime = moment.tz(this.model.orderCutoffTime, this.model.timezone).format('HH:mm:ss');
		// 	this.model.orderCutoffTime = this.DateUtil.getTime(orderCutoffTime);
		// 	console.log(this.model.orderCutoffTime)
		// }

	}, {
		key: 'branchFundingSourceDenominationsModal',
		value: function branchFundingSourceDenominationsModal() {
			var _this16 = this;

			this.Modal.branchFundingSourceDenominations(this.model.denominations, function (_ref5) {
				var modal = _ref5.modal,
				    denominations = _ref5.denominations,
				    deletedDenominations = _ref5.deletedDenominations,
				    $scope = _ref5.$scope;

				_this16.isLoading = true;
				setTimeout(function () {
					_this16.model.denominations = denominations;
					// Store deleted denominations for tracking
					_this16.deletedDenominations = deletedDenominations || [];
					_this16.isLoading = false;
				}, 100);
				modal.close();
			}, function (_ref6) {
				var modal = _ref6.modal;

				modal.close();
			}, this.model.currencyId);
		}
	}, {
		key: 'isMultiDenomAllowed',
		value: function isMultiDenomAllowed(denom) {
			if (!denom.coinFlag) {
				return true;
			}
			if (denom.coinPackaging && ['INDIVIDUAL', 'ROLLED'].includes(denom.coinPackaging)) {
				return true;
			}
			return false;
		}
	}, {
		key: 'toggleMultiDenom',
		value: function toggleMultiDenom(obj) {
			if (this.isMultiDenomAllowed(obj)) {
				obj.multiDenomAllowed = !obj.multiDenomAllowed;
			}
		}
	}, {
		key: 'isExpectedResidualDenom',
		value: function isExpectedResidualDenom(denom) {
			return !denom.coinFlag && !denom.unfit;
		}
	}, {
		key: 'expectedResidualValue',
		value: function expectedResidualValue(denom) {
			if (!this.model.expectedResidual || !this.isExpectedResidualDenom(denom)) return null;
			var value = denom.expectedResidualPercentage;
			if (value === null || value === undefined || value === '') return null;
			return Number(String(value).replace('%', ''));
		}
	}, {
		key: 'addResidualPercentSign',
		value: function addResidualPercentSign(denom) {
			var value = denom.expectedResidualPercentage;
			if (value !== null && value !== undefined && String(value) !== '' && !String(value).endsWith('%')) {
				denom.expectedResidualPercentage = value + '%';
			}
		}
	}, {
		key: 'removeResidualPercentSign',
		value: function removeResidualPercentSign(denom) {
			var value = denom.expectedResidualPercentage;
			if (value && String(value).endsWith('%')) {
				denom.expectedResidualPercentage = String(value).replace('%', '');
			}
		}
	}, {
		key: 'toggleCustomerOrderable',
		value: function toggleCustomerOrderable(obj) {
			obj.customerOrderable = !obj.customerOrderable;
		}
	}, {
		key: 'validateMultiDenom',
		value: function validateMultiDenom(obj) {
			var _this17 = this;

			setTimeout(function () {
				if (!obj.isDenomSelected) {
					obj.multiDenomAllowed = false;
				} else {
					if (!_this17.isMultiDenomAllowed(obj)) {
						obj.multiDenomAllowed = false;
					}
				}
				_this17.$scope.$apply();
			});
		}
	}, {
		key: 'removeDenomination',
		value: function removeDenomination(key, index) {
			this.model.denominations[key].splice(index, 1);
		}
	}, {
		key: 'onCurrencyChange',
		value: function onCurrencyChange() {
			var _this18 = this;

			if (this.originalCurrencyId) {
				if (this.model.currencyId === this.originalCurrencyId) {
					if (this.branchFundingSourceDenominations && (0, _keys2.default)(this.branchFundingSourceDenominations).length > 0) {
						this.model.denominations = _.cloneDeep(this.branchFundingSourceDenominations);
						_.flatten(_.values(this.model.denominations)).forEach(function (d) {
							return _this18.addResidualPercentSign(d);
						});
					}
				} else {
					if (this.model.denominations && (0, _keys2.default)(this.model.denominations).length > 0) {
						this.model.denominations = {};
					}
				}
			}
		}
	}, {
		key: 'compareObjects',
		value: function compareObjects(objA, objB) {
			var _this19 = this;

			var results = { create: [], update: [], delete: [] };

			// First, add all deleted denominations from modal tracking
			if (this.deletedDenominations && this.deletedDenominations.length > 0) {
				results.delete = results.delete.concat(this.deletedDenominations);
			}

			var idSetA = {};

			for (var category in objA) {
				objA[category].forEach(function (itemA) {
					idSetA[itemA.id] = itemA;
				});
			}

			var _loop = function _loop(_category) {
				objA[_category].forEach(function (itemA) {
					var itemB = objB[_category] ? objB[_category].find(function (item) {
						return item.id === itemA.id;
					}) : null;
					if (itemB) {
						var pctA = itemA.expectedResidualPercentage === null || itemA.expectedResidualPercentage === undefined ? null : Number(itemA.expectedResidualPercentage);
						var pctB = _this19.expectedResidualValue(itemB);
						if (itemA.multiDenomAllowed !== itemB.multiDenomAllowed || itemA.customerOrderable !== itemB.customerOrderable || pctA !== pctB) {
							results.update.push({
								denominationId: itemB.id,
								multiDenomAllowed: itemB.multiDenomAllowed || false,
								customerOrderable: itemB.customerOrderable || false,
								expectedResidualPercentage: pctB,
								currencyId: itemB.currencyId,
								coinFlag: itemB.coinFlag,
								id: itemA.branchFundingSourceDenominationId,
								modifiedByUserId: _this19.model.loggedInUser
							});
						}
					} else {
						// Only add to delete if not already tracked by modal
						var alreadyTracked = _this19.deletedDenominations && _this19.deletedDenominations.find(function (d) {
							return d.denominationId === itemA.id;
						});
						if (!alreadyTracked) {
							results.delete.push({
								id: itemA.branchFundingSourceDenominationId,
								multiDenomAllowed: itemA.multiDenomAllowed || false,
								currencyId: itemA.currencyId,
								coinFlag: itemA.coinFlag,
								denominationId: itemA.id
							});
						}
					}
				});
			};

			for (var _category in objA) {
				_loop(_category);
			}

			for (var _category2 in objB) {
				// if (!objA[category]) continue;

				objB[_category2].forEach(function (itemB) {
					if (!idSetA[itemB.id]) {
						results.create.push({
							createdByUserId: _this19.model.loggedInUser,
							modifiedByUserId: _this19.model.loggedInUser,
							denominationId: itemB.id,
							multiDenomAllowed: itemB.multiDenomAllowed || false,
							customerOrderable: itemB.customerOrderable || false,
							expectedResidualPercentage: _this19.expectedResidualValue(itemB),
							branchFundingSourceId: _this19.model.id,
							currencyId: itemB.currencyId,
							coinFlag: itemB.coinFlag
						});
					}
				});
			}

			return results;
		}
	}]);
	return BranchFundingSourceEditController;
}(_branch_funding_sourceBase2.default);

exports.default = BranchFundingSourceEditController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_funding_sourceEdit = __webpack_require__(1669);

var _branch_funding_sourceEdit2 = _interopRequireDefault(_branch_funding_sourceEdit);

__webpack_require__(2943);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchFundingSourceEditModule = angular.module('branchFundingSourceedit', []).component('branchFundingSourceedit', _branch_funding_sourceEdit2.default).name;

exports.default = branchFundingSourceEditModule;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_funding_source = __webpack_require__(1664);

var _branch_funding_source2 = _interopRequireDefault(_branch_funding_source);

var _all = __webpack_require__(1663);

var _all2 = _interopRequireDefault(_all);

var _create = __webpack_require__(1668);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(1671);

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchFundingSourceModule = angular.module('branchFundingSource', [_all2.default, _create2.default, _edit2.default]).component('branchFundingSource', _branch_funding_source2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('branch-funding-source.all', {
    url: '/all/:page',
    component: 'branchFundingSourceall',
    data: {
      requireACL: 'setting-branch-funding-source.view'
    }
  }).state('branch-funding-source.create', {
    url: '/create',
    component: 'branchFundingSourcecreate',
    data: {
      requireACL: 'setting-branch-funding-source.create'
    }
  }).state('branch-funding-source.edit', {
    url: '/edit/:id',
    component: 'branchFundingSourceedit',
    data: {
      requireACL: 'setting-branch-funding-source.edit'
    }
  });
}]).name;

exports.default = branchFundingSourceModule;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _branch_funding_source_holidayAll = __webpack_require__(2658);

var _branch_funding_source_holidayAll2 = _interopRequireDefault(_branch_funding_source_holidayAll);

var _branch_funding_source_holidayAll3 = __webpack_require__(1674);

var _branch_funding_source_holidayAll4 = _interopRequireDefault(_branch_funding_source_holidayAll3);

__webpack_require__(2944);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchFundingSourceHolidayAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template: _branch_funding_source_holidayAll2.default,
    controller: _branch_funding_source_holidayAll4.default
};

exports.default = branchFundingSourceHolidayAllComponent;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _branch_funding_source_holidayBase = __webpack_require__(266);

var _branch_funding_source_holidayBase2 = _interopRequireDefault(_branch_funding_source_holidayBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceHolidayAllController = function (_BranchFundingSourceH) {
    BranchFundingSourceHolidayAllController.$inject = ["Auth", "$state", "User", "Modal", "BranchFundingSourceHolidayService", "$translate", "$stateParams", "$location"];
    (0, _inherits3.default)(BranchFundingSourceHolidayAllController, _BranchFundingSourceH);

    /*@ngInject*/
    function BranchFundingSourceHolidayAllController(Auth, $state, User, Modal, BranchFundingSourceHolidayService, $translate, $stateParams, $location) {
        (0, _classCallCheck3.default)(this, BranchFundingSourceHolidayAllController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BranchFundingSourceHolidayAllController.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceHolidayAllController)).call(this, Auth, $state, User, BranchFundingSourceHolidayService, Modal, $translate, $stateParams, $location));

        _this.id = 'branch-funding-source-holiday.all';
        _this._status = 'all';
        _this.page = 1;
        _this.total = 0;
        _this.pageLimit = 10;
        _this.maxPages = 10;
        _this.loading = true;
        _this.branchFundingSourceHolidayData = [];
        _this.hasAcl = {};
        _this.searchText = '';
        _this.$location = $location;
        _this.branch = User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(BranchFundingSourceHolidayAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var pageId = this.$stateParams.page;
            if (pageId > 0) {
                this.page = pageId;
            }
            this.loadData();
        }
    }, {
        key: 'edit',
        value: function edit(branchFundingSourceHoliday) {
            this.$state.go('branch-funding-source-holiday.edit', {
                id: branchFundingSourceHoliday.id
            });
        }
    }, {
        key: 'delete',
        value: function _delete(branchFundingSourceHoliday) {
            var _this2 = this;

            if (this.allowOnlyOnce) return;
            this.allowOnlyOnce = true;
            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_delete_title'),
                message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + branchFundingSourceHoliday.id + '</strong>?'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    $scope.loading = true;
                    _this2.Service.remove(branchFundingSourceHoliday.id, branchFundingSourceHoliday.branchFundingSourceId, _this2.branch).then(function (data) {
                        _this2.allowOnlyOnce = false;
                        modal.close();
                        _this2.refresh();
                    });
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    _this2.allowOnlyOnce = false;
                    modal.close();
                },
                type: 'danger'
            });
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.loadData();
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'generateSearchObj',
        value: function generateSearchObj() {
            var obj = {
                queryJSON: {
                    rules: [{
                        field: 'id',
                        condition: 'like',
                        data: '%' + this.searchText + '%'
                    }, {
                        field: 'name',
                        condition: 'like',
                        data: '%' + this.searchText + '%'
                    }],
                    operator: 'OR'
                }
            };
            return obj.queryJSON.rules.length ? obj : null;
        }
    }, {
        key: 'search',
        value: function search() {
            this.page = 1;
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var _this3 = this;

            var searchObj = this.generateSearchObj();

            this.loading = true;
            this.Service.all(searchObj, this.branch, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
                _this3.total = data.total;
                _this3.branchFundingSourceHolidayData = data.results;
                _this3.loading = false;
            }).catch(function (err) {
                _this3.loading = false;
                _this3.error = err.message;
            });
        }
    }]);
    return BranchFundingSourceHolidayAllController;
}(_branch_funding_source_holidayBase2.default);

exports.default = BranchFundingSourceHolidayAllController;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _branch_funding_source_holidayAll = __webpack_require__(1673);

var _branch_funding_source_holidayAll2 = _interopRequireDefault(_branch_funding_source_holidayAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceHolidayAllModule = angular.module('branchFundingSourceHolidayAll', []).component('branchFundingSourceHolidayAll', _branch_funding_source_holidayAll2.default).name;

exports.default = BranchFundingSourceHolidayAllModule;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_funding_source_holiday = __webpack_require__(2659);

var _branch_funding_source_holiday2 = _interopRequireDefault(_branch_funding_source_holiday);

var _branch_funding_source_holiday3 = __webpack_require__(1677);

var _branch_funding_source_holiday4 = _interopRequireDefault(_branch_funding_source_holiday3);

__webpack_require__(2945);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchFundingSourceHolidayComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _branch_funding_source_holiday2.default,
  controller: _branch_funding_source_holiday4.default
};

exports.default = branchFundingSourceHolidayComponent;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceHolidayController = function (_SettingBase) {
    BranchFundingSourceHolidayController.$inject = ["$state"];
    (0, _inherits3.default)(BranchFundingSourceHolidayController, _SettingBase);

    /*@ngInject*/
    function BranchFundingSourceHolidayController($state) {
        (0, _classCallCheck3.default)(this, BranchFundingSourceHolidayController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BranchFundingSourceHolidayController.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceHolidayController)).call(this));

        _this.acl = {};
        _this.hasACL = {};
        _this.id = 'branch-funding-source-holiday';
        _this.$state = $state;
        _this.hasACL = {};
        return _this;
    }

    (0, _createClass3.default)(BranchFundingSourceHolidayController, [{
        key: '$onInit',
        value: function $onInit() {
            (0, _get3.default)(BranchFundingSourceHolidayController.prototype.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceHolidayController.prototype), '$onInit', this).call(this);
            for (var key in this.acl['setting-branch-funding-source-holiday']) {
                this.hasACL[this.acl['setting-branch-funding-source-holiday'][key]] = true;
            }
        }
    }]);
    return BranchFundingSourceHolidayController;
}(_SettingBase3.default);

exports.default = BranchFundingSourceHolidayController;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _branch_funding_source_holidayCreate = __webpack_require__(2660);

var _branch_funding_source_holidayCreate2 = _interopRequireDefault(_branch_funding_source_holidayCreate);

var _branch_funding_source_holidayCreate3 = __webpack_require__(1679);

var _branch_funding_source_holidayCreate4 = _interopRequireDefault(_branch_funding_source_holidayCreate3);

__webpack_require__(2946);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchFundingSourceHolidayCreateComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template: _branch_funding_source_holidayCreate2.default,
    controller: _branch_funding_source_holidayCreate4.default
};

exports.default = branchFundingSourceHolidayCreateComponent;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _branch_funding_source_holidayBase = __webpack_require__(266);

var _branch_funding_source_holidayBase2 = _interopRequireDefault(_branch_funding_source_holidayBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceHolidayCreateController = function (_BranchFundingSourceH) {
    BranchFundingSourceHolidayCreateController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "BranchFundingSourceHolidayService", "BranchFundingSourceService", "DateUtil"];
    (0, _inherits3.default)(BranchFundingSourceHolidayCreateController, _BranchFundingSourceH);

    /*@ngInject*/
    function BranchFundingSourceHolidayCreateController(Auth, User, $state, $translate, $stateParams, $location, Modal, BranchFundingSourceHolidayService, BranchFundingSourceService, DateUtil) {
        (0, _classCallCheck3.default)(this, BranchFundingSourceHolidayCreateController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BranchFundingSourceHolidayCreateController.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceHolidayCreateController)).call(this, Auth, $state, User, BranchFundingSourceHolidayService, Modal, $translate, $stateParams));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.Modal = Modal;
        _this.BranchFundingSourceHolidayService = BranchFundingSourceHolidayService;
        _this.BranchFundingSourceService = BranchFundingSourceService;
        _this.DateUtil = DateUtil;

        _this.defaultModel = {
            isCreate: false,
            branchId: User.getUser().branchId,
            name: null,
            holidayDate: new Date(),
            repeat: false,
            selectedFundingSource: null,
            branchFundingSourceObj: {
                totalRecords: 0,
                results: [],
                loading: false
            }
        };

        _this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: _this.$translate.instant('common.yes'),
                off: _this.$translate.instant('common.no')
            },
            onColor: 'success',
            offColor: 'danger'
        };

        _this.model = angular.copy(_this.defaultModel);
        return _this;
    }

    (0, _createClass3.default)(BranchFundingSourceHolidayCreateController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loadData();
        }
    }, {
        key: 'generateSearchObj',
        value: function generateSearchObj(searchKey) {
            searchKey = searchKey || '';
            var obj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: "id",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "sourceName",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return obj.queryJSON.rules.length ? obj : null;
        }
    }, {
        key: 'getAllFundingSource',
        value: function getAllFundingSource(searchKey, offset) {
            var _this2 = this;

            this.model.branchFundingSourceObj.loading = true;
            var searchObj = this.generateSearchObj(searchKey);

            this.BranchFundingSourceService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this2.model.branchFundingSourceObj.totalRecords = data.total;
                    _this2.model.branchFundingSourceObj.results = _this2.fundingSourceMap(data.results);
                } else {
                    var fundingSource = _this2.fundingSourceMap(data.results);
                    _this2.model.branchFundingSourceObj.results = _this2.model.branchFundingSourceObj.results.concat(fundingSource);
                }
            }).catch(function (err) {
                _this2.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this2.model.branchFundingSourceObj.loading = false;
            });
        }
    }, {
        key: 'fundingSourceMap',
        value: function fundingSourceMap(fundingSource) {
            return fundingSource.map(function (data) {
                return {
                    Key: data.id + ' | ' + data.sourceName,
                    Value: data.id
                };
            });
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this3 = this;

            this.model.isCreate = true;
            delete this.model.errorMessage;

            this.Service.create({
                name: this.model.name,
                holidayDate: this.DateUtil.getUTCDate(this.model.holidayDate),
                repeat: this.model.repeat,
                branchFundingSourceId: this.model.selectedFundingSource.Value,
                branchId: this.model.branchId
            }).then(function () {
                _this3.askCreate().then(function () {
                    return _this3.loadData();
                });
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this3.model.errorMessage = e.message;
                });
            }).finally(function () {
                _this3.model.isCreate = false;
            });
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            this.getAllFundingSource('', 0);
        }
    }, {
        key: 'reset',
        value: function reset() {
            // this.model = angular.copy(this.defaultModel);
            this.model.name = null;
            this.model.holidayDate = new Date();
            this.model.repeat = false;
            this.model.selectedFundingSource = null;
            this.clearErrors();
        }
    }]);
    return BranchFundingSourceHolidayCreateController;
}(_branch_funding_source_holidayBase2.default);

exports.default = BranchFundingSourceHolidayCreateController;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_funding_source_holidayCreate = __webpack_require__(1678);

var _branch_funding_source_holidayCreate2 = _interopRequireDefault(_branch_funding_source_holidayCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceHolidayCreateModule = angular.module('branchFundingSourceHolidayCreate', []).component('branchFundingSourceHolidayCreate', _branch_funding_source_holidayCreate2.default).name;

exports.default = BranchFundingSourceHolidayCreateModule;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _branch_funding_source_holidayEdit = __webpack_require__(2661);

var _branch_funding_source_holidayEdit2 = _interopRequireDefault(_branch_funding_source_holidayEdit);

var _branch_funding_source_holidayEdit3 = __webpack_require__(1682);

var _branch_funding_source_holidayEdit4 = _interopRequireDefault(_branch_funding_source_holidayEdit3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceHolidayEditComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template: _branch_funding_source_holidayEdit2.default,
    controller: _branch_funding_source_holidayEdit4.default
};

exports.default = BranchFundingSourceHolidayEditComponent;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _branch_funding_source_holidayBase = __webpack_require__(266);

var _branch_funding_source_holidayBase2 = _interopRequireDefault(_branch_funding_source_holidayBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceHolidayEditController = function (_BranchFundingSourceH) {
    BranchFundingSourceHolidayEditController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "BranchFundingSourceHolidayService", "BranchFundingSourceService", "$q", "DateUtil"];
    (0, _inherits3.default)(BranchFundingSourceHolidayEditController, _BranchFundingSourceH);

    /*@ngInject*/
    function BranchFundingSourceHolidayEditController(Auth, User, $state, $translate, $stateParams, $location, Modal, BranchFundingSourceHolidayService, BranchFundingSourceService, $q, DateUtil) {
        (0, _classCallCheck3.default)(this, BranchFundingSourceHolidayEditController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BranchFundingSourceHolidayEditController.__proto__ || (0, _getPrototypeOf2.default)(BranchFundingSourceHolidayEditController)).call(this, Auth, $state, User, BranchFundingSourceHolidayService, Modal, $translate, $stateParams));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.Modal = Modal;
        _this.BranchFundingSourceHolidayService = BranchFundingSourceHolidayService;
        _this.BranchFundingSourceService = BranchFundingSourceService;
        _this.DateUtil = DateUtil;
        _this.$q = $q;

        _this.defaultModel = {
            branchId: User.getUser().branchId,
            name: null,
            holidayDate: null,
            repeat: false,
            selectedFundingSource: null,
            branchFundingSourceObj: {
                totalRecords: 0,
                results: [],
                loading: false
            }
        };

        _this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: _this.$translate.instant('common.yes'),
                off: _this.$translate.instant('common.no')
            },
            onColor: 'success',
            offColor: 'danger'
        };

        _this.model = angular.copy(_this.defaultModel);
        return _this;
    }

    (0, _createClass3.default)(BranchFundingSourceHolidayEditController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.$q.all([this.Service.get(this.$stateParams.id), this.getAllFundingSource('', 0)]).then(function (data) {
                _this2.fundingSourceHolidayObj = data[0];
                _this2.defaultModel = _this2.fundingSourceHolidayObj;
                _this2.rawId = _this2.fundingSourceHolidayObj.id;
                _this2.model.name = _this2.fundingSourceHolidayObj.name;
                _this2.model.holidayDate = _this2.DateUtil.convertToDate(_this2.fundingSourceHolidayObj.holidayDate);
                _this2.model.repeat = _this2.fundingSourceHolidayObj.repeat;

                if (_this2.fundingSourceHolidayObj.branchFundingSourceId) {
                    _this2.fundingSourceHolidayObj.branchFundingSource.Key = _this2.fundingSourceHolidayObj.branchFundingSource.id + ' | ' + _this2.fundingSourceHolidayObj.branchFundingSource.sourceName;
                    _this2.fundingSourceHolidayObj.branchFundingSource.Value = _this2.fundingSourceHolidayObj.branchFundingSource.id;
                }
                _this2.model.selectedFundingSource = _this2.fundingSourceHolidayObj.branchFundingSource;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.model.selectedFundingSource = this.fundingSourceHolidayObj.branchFundingSource;
        }
    }, {
        key: 'update',
        value: function update() {
            var _this3 = this;

            this.model.isUpdating = true;
            delete this.model.errorMessage;

            this.Service.update(this.$stateParams.id, {
                name: this.model.name,
                holidayDate: moment(this.model.holidayDate).format('YYYY-MM-DD'),
                repeat: this.model.repeat,
                branchFundingSourceId: this.model.selectedFundingSource.Value,
                branchId: this.model.branchId
            }).then(function () {
                window.history.go(-1);
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this3.model.errorMessage = e.message;
                });
            }).finally(function () {
                _this3.model.isUpdating = false;
            });
        }
    }, {
        key: 'generateSearchObj',
        value: function generateSearchObj(searchKey) {
            searchKey = searchKey || '';
            var obj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: "id",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "sourceName",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return obj.queryJSON.rules.length ? obj : null;
        }
    }, {
        key: 'getAllFundingSource',
        value: function getAllFundingSource(searchKey, offset) {
            var _this4 = this;

            this.model.branchFundingSourceObj.loading = true;
            this.BranchFundingSourceService.all(this.generateSearchObj(searchKey), offset, _app2.default.defaultPageLimit).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this4.model.branchFundingSourceObj.totalRecords = data.total;
                    _this4.model.branchFundingSourceObj.results = _this4.fundingSourceMap(data.results);
                } else {
                    var fundingSource = _this4.fundingSourceMap(data.results);
                    _this4.model.branchFundingSourceObj.results = _this4.model.branchFundingSourceObj.results.concat(fundingSource);
                }
            }).catch(function (err) {
                _this4.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this4.model.branchFundingSourceObj.loading = false;
            });
        }
    }, {
        key: 'fundingSourceMap',
        value: function fundingSourceMap(fundingSource) {
            return fundingSource.map(function (data) {
                return {
                    Key: data.id + ' | ' + data.sourceName,
                    Value: data.id
                };
            });
        }
    }]);
    return BranchFundingSourceHolidayEditController;
}(_branch_funding_source_holidayBase2.default);

exports.default = BranchFundingSourceHolidayEditController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_funding_source_holidayEdit = __webpack_require__(1681);

var _branch_funding_source_holidayEdit2 = _interopRequireDefault(_branch_funding_source_holidayEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceHolidayEditModule = angular.module('branchFundingSourceHolidayEdit', []).component('branchFundingSourceHolidayEdit', _branch_funding_source_holidayEdit2.default).name;

exports.default = BranchFundingSourceHolidayEditModule;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _branch_funding_source_holiday = __webpack_require__(1676);

var _branch_funding_source_holiday2 = _interopRequireDefault(_branch_funding_source_holiday);

var _all = __webpack_require__(1675);

var _all2 = _interopRequireDefault(_all);

var _create = __webpack_require__(1680);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(1683);

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceHolidayModule = angular.module('branchFundingSourceHoliday', [_all2.default, _create2.default, _edit2.default]).component('branchFundingSourceHoliday', _branch_funding_source_holiday2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('branch-funding-source-holiday.all', {
        url: '/all/:page',
        component: 'branchFundingSourceHolidayAll',
        data: {
            requireACL: 'setting-branch-funding-source-holiday.view'
        }
    }).state('branch-funding-source-holiday.create', {
        url: '/create',
        component: 'branchFundingSourceHolidayCreate',
        data: {
            requireACL: 'setting-branch-funding-source-holiday.create'
        }
    }).state('branch-funding-source-holiday.edit', {
        url: '/edit/:id',
        component: 'branchFundingSourceHolidayEdit',
        data: {
            requireACL: 'setting-branch-funding-source-holiday.edit'
        }
    });
}]).name;

exports.default = BranchFundingSourceHolidayModule;

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_management = __webpack_require__(2662);

var _branch_management2 = _interopRequireDefault(_branch_management);

var _branch_management3 = __webpack_require__(1686);

var _branch_management4 = _interopRequireDefault(_branch_management3);

__webpack_require__(2947);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementComponent = {
  restrict: 'E',
  bindings: {},
  template: _branch_management2.default,
  controller: _branch_management4.default
};

exports.default = branchManagementComponent;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _location_holds = __webpack_require__(525);

var _location_holds2 = _interopRequireDefault(_location_holds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchManagementController = function () {
  /*@ngInject*/
  BranchManagementController.$inject = ["Auth", "$state", "User", "UserService", "$translate", "$location", "Modal", "DataCounter", "$q", "HoldService", "HoldLocationService", "$rootScope", "UsersService", "CommonLayoutService", "$window"];
  function BranchManagementController(Auth, $state, User, UserService, $translate, $location, Modal, DataCounter, $q, HoldService, HoldLocationService, $rootScope, UsersService, CommonLayoutService, $window) {
    (0, _classCallCheck3.default)(this, BranchManagementController);

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.$location = $location;
    this.HoldLocationService = HoldLocationService;
    this.HoldService = HoldService;
    this.Modal = Modal;
    this.DataCounter = DataCounter;
    this.holdServiceData = [];
    this.itemHoldServiceData = [];
    this.$rootScope = $rootScope;
    this.currentBranch = User.getUser().branchId;
    this.UsersService = UsersService;
    this.CommonLayoutService = CommonLayoutService;
    this.userInfo = User.getUser();
    this.$window = $window;

    this.tabConfig = {
      'branch_mgmt_routes': {
        title: 'branch_mgmt.routes.title',
        state: 'branchManagement.routes'
      },
      'branch_mgmt_locations': {
        title: 'branch_mgmt.locations.title',
        state: 'branchManagement.locations'
      },
      'branch_mgmt_items': {
        title: 'branch_mgmt.items.title',
        state: 'branchManagement.items'
      },
      'branch_mgmt_tankers': {
        title: 'branch_mgmt.tankers.title',
        state: 'branchManagement.tankers'
      },
      'branch_mgmt_bagouts': {
        title: 'branch_mgmt.bagouts.title',
        state: 'branchManagement.bagouts'
      },
      'branch_mgmt_orders': {
        title: 'branch_mgmt.orders.title',
        state: 'branchManagement.orders'
      },
      'branch_mgmt_item_holds': {
        title: 'branch_mgmt.item_holds.title',
        state: 'branchManagement.itemHolds'
      },
      'branch_mgmt_location_holds': {
        title: 'branch_mgmt.location_holds.title',
        state: 'branchManagement.locationHolds'
      },
      'branch_mgmt_bypass_code': {
        title: 'branch_mgmt.bypass_code.title',
        state: 'branchManagement.bypassCode'
      },
      'branch_mgmt_daily_balance_sheet': {
        title: 'branch_mgmt.daily_balance_sheet.title',
        state: 'branchManagement.dailyBalanceSheet'
      },
      'branch_mgmt_monthly_report': {
        title: 'branch_mgmt.monthly_report.title',
        state: 'branchManagement.monthlyReport'
      },
      'branch_mgmt_deleted_shipments': {
        title: 'branch_mgmt.deleted_shipments.title',
        state: 'branchManagement.deletedShipments'
      },
      'branch_mgmt_cancelled_shipments': {
        title: 'branch_mgmt.cancelled_shipments.title',
        state: 'branchManagement.cancelledShipments'
      },
      'branch_mgmt_branch_performance': {
        title: 'branch_mgmt.branch_performance.title',
        state: 'branchManagement.branchPerformance'
      },
      'branch_mgmt_final_residual_count_commit': {
        title: 'branch_mgmt.final_residual_count_commit.title',
        state: 'branchManagement.finalResidualCountCommit'
      },
      'branch_mgmt_cash_transactions': {
        title: 'branch_mgmt.cash_transactions.title',
        state: 'branchManagement.cashDeliveries'
      },
      'branch_mgmt_tnt_bypass_code': {
        title: 'branch_mgmt.tnt_bypass_code.title',
        state: 'branchManagement.tntBypassCode'
      },
      'branch_mgmt_physical_cash_count': {
        title: 'branch_mgmt.physical_cash_count.title',
        state: 'branchManagement.physicalCashCount'
      },
      'branch_mgmt_lock_open_errors': {
        title: 'branch_mgmt.lock_open_errors.title',
        state: 'branchManagement.lockOpenErrors'
      },
      'branch_mgmt_billing_approval': {
        title: 'branch_mgmt.billing_approval.title',
        state: 'branchManagement.billingApproval'
      },
      'branch_mgmt_count_variances': {
        title: 'branch_mgmt.count_variances.title',
        state: 'branchManagement.countVariances'
      },
      'branch_mgmt_restore_route_assignments': {
        title: 'branch_mgmt.restore_route_assignments.title',
        state: 'branchManagement.restoreRouteAssignments'
      },
      'branch_mgmt_stop_performance': {
        title: 'branch_mgmt.stop_performance.title',
        state: 'branchManagement.stopPerformance'
      },
      'branch_mgmt_customer_pickup_reports': {
        title: 'branch_mgmt.customer_pickup_reports.title',
        state: 'branchManagement.customerPickupReports'
      },
      'branch_mgmt_contact_request': {
        title: 'branch_mgmt.contact_request.title',
        state: 'branchManagement.contactRequest'
      },
      'branch_mgmt_import_file_view': {
        title: 'branch_mgmt.import_file_view.title',
        state: 'branchManagement.importFileView'
      },
      'branch_mgmt_stop_scheduling': {
        title: 'branch_mgmt.stop_scheduling.title',
        state: 'branchManagement.stopScheduling'
      },
      'branch_mgmt_bin_manifest': {
        title: 'branch_mgmt.bin_manifest.title',
        state: 'branchManagement.binManifest'
      },
      'branch_mgmt_deposit_reports': {
        title: 'branch_mgmt.deposit_reports.title',
        state: 'branchManagement.depositReports'
      },
      'branch_mgmt_average_daily_balance': {
        title: 'branch_mgmt.average_daily_balance.title',
        state: 'branchManagement.averageDailyBalance'
      },
      'branch_mgmt_mileage_report': {
        title: 'Mileage Report',
        state: 'branchManagement.mileageReport'
      }
    };

    this.tabs = [];
    this.$rootScope.$broadcast('routeChange', null);
  }

  (0, _createClass3.default)(BranchManagementController, [{
    key: 'loadPermission',
    value: function loadPermission() {
      var _this = this;

      this.acl = {};
      this.hasACL = {};

      ['branch_mgmt', 'branch_mgmt_routes', 'branch_mgmt_locations', 'branch_mgmt_items', 'branch_mgmt_tankers', 'branch_mgmt_bagouts', 'branch_mgmt_orders', 'branch_mgmt_item_holds', 'branch_mgmt_location_holds', 'branch_mgmt_bypass_code', 'branch_mgmt_daily_balance_sheet', 'branch_mgmt_monthly_report', 'branch_mgmt_deleted_shipments', 'branch_mgmt_cancelled_shipments', 'branch_mgmt_branch_performance', 'branch_mgmt_final_residual_count_commit', 'branch_mgmt_cash_transactions', 'branch_mgmt_tnt_bypass_code', 'branch_mgmt_physical_cash_count', 'branch_mgmt_lock_open_errors', 'branch_mgmt_billing_approval', 'branch_mgmt_count_variances', 'branch_mgmt_restore_route_assignments', 'branch_mgmt_stop_performance', 'branch_mgmt_customer_pickup_reports', 'branch_mgmt_contact_request', 'branch_mgmt_import_file_view', 'branch_mgmt_stop_scheduling', 'branch_mgmt_bin_manifest', 'branch_mgmt_deposit_reports', 'branch_mgmt_average_daily_balance', 'branch_mgmt_mileage_report'].forEach(function (permissionKey) {
        _this.acl[permissionKey] = _this.User.getACL(permissionKey);

        _this.hasACL[permissionKey] = {};
        if (_this.acl[permissionKey] && _this.acl[permissionKey].length > 0) {
          _this.acl[permissionKey].forEach(function (permission) {
            _this.hasACL[permissionKey][permission] = true;
          });
        }
      });
    }
  }, {
    key: 'itemHoldSearchObj',
    value: function itemHoldSearchObj() {
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.currentBranch
          }, {
            field: 'status',
            condition: '=',
            data: 'ON_HOLD'
          }],
          operator: 'AND'
        }
      };
      return searchObj.queryJSON.rules.length ? searchObj : null;
    }
  }, {
    key: 'locationSearchObj',
    value: function locationSearchObj() {
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'status',
            condition: '=',
            data: 'ON_HOLD'
          }],
          operator: 'AND'
        }
      };
      return searchObj.queryJSON.rules.length ? searchObj : null;
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      var itemHoldSearchObj = this.itemHoldSearchObj();
      this.validateUserPermissions();

      this.$q.all([this.HoldLocationService.holdLocationCount(this.currentBranch), this.HoldService.holdItemCount(itemHoldSearchObj)]).then(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            holdLocationsdata = _ref2[0],
            itemsHoldData = _ref2[1];

        _this2.tabConfig.branch_mgmt_location_holds.extra = {
          LocationHoldcount: holdLocationsdata.total
        };

        _this2.DataCounter.setCounterForLocationHold(_this2.tabConfig.branch_mgmt_location_holds.extra.LocationHoldcount);

        _this2.$rootScope.$on('setLocationHoldCount', function (evt, data) {
          _this2.tabConfig.branch_mgmt_location_holds.extra = { LocationHoldcount: data.totalRecords };
          _this2.DataCounter.setCounterForLocationHold(_this2.tabConfig.branch_mgmt_location_holds.extra.LocationHoldcount);
        });

        _this2.tabConfig.branch_mgmt_item_holds.extra = {
          itemHoldcount: itemsHoldData.total
        };

        _this2.DataCounter.setCounterForItemHold(_this2.tabConfig.branch_mgmt_item_holds.extra.itemHoldcount);
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'validateUserPermissions',
    value: function validateUserPermissions() {
      var _this3 = this;

      this.loading = true;
      var currentUrl = this.$location.url();
      this.UsersService.validateUserPermissions(this.userInfo.firstName, this.userInfo.lastName).then(function (permission) {
        if (!permission.hasTntBypassCodePermission && !_this3.CommonLayoutService.isAllowToAccessPages()) {
          delete _this3.tabConfig['branch_mgmt_tnt_bypass_code'];

          if (_this3.validateUserPermissionsAndState('/TNT-bypass-code')) {
            return _this3.$state.go('home');
          }
        }

        _this3.loadPermission();

        _lodash2.default.forEach(_this3.hasACL, function (permissionObj, key) {
          if (permissionObj.all) {
            var tabConfig = _this3.tabConfig[key];
            if (tabConfig) {
              if (tabConfig.state === 'branchManagement.binManifest') {
                tabConfig.isReact = true;
              }
              _this3.tabs.push(tabConfig);
            }
          }
        });

        if (currentUrl.endsWith('/branch-management') && _this3.tabs && _this3.tabs.length) {
          _this3.$state.go(_this3.tabs[0].state);
        }
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this3.loading = false;
      });
    }
  }, {
    key: 'validateUserPermissionsAndState',
    value: function validateUserPermissionsAndState(wordToCheck) {
      var currentStateUrl = this.$state.href(this.$state.current);
      return currentStateUrl.includes(wordToCheck);
    }
  }, {
    key: 'gotoReactUrl',
    value: function gotoReactUrl(state, $event) {
      if (state === "branchManagement.binManifest") {
        $event.preventDefault();
        var baseUrl = this.$window.location.origin;
        var reactUrl = baseUrl + '/v2/index.html#/bin-manifest';
        this.$window.open(reactUrl, "_self");
      }
      if (state === "branchManagement.depositReports") {
        $event.preventDefault();
        var _baseUrl = this.$window.location.origin;
        var _reactUrl = _baseUrl + '/v2/index.html#/deposit-record';
        this.$window.open(_reactUrl, "_self");
      }
      if (state === "branchManagement.averageDailyBalance") {
        $event.preventDefault();
        var _baseUrl2 = this.$window.location.origin;
        var _reactUrl2 = _baseUrl2 + '/v2/index.html#/average-daily-balance';
        this.$window.open(_reactUrl2, "_self");
      }
      if (state === "branchManagement.mileageReport") {
        $event.preventDefault();
        var _baseUrl3 = this.$window.location.origin;
        var _reactUrl3 = _baseUrl3 + '/v2/index.html#/mileage-report';
        this.$window.open(_reactUrl3, "_self");
      }
    }
  }]);
  return BranchManagementController;
}();

exports.default = BranchManagementController;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _average_daily_vault_balance = __webpack_require__(2663);

var _average_daily_vault_balance2 = _interopRequireDefault(_average_daily_vault_balance);

var _average_daily_vault_balance3 = __webpack_require__(1688);

var _average_daily_vault_balance4 = _interopRequireDefault(_average_daily_vault_balance3);

__webpack_require__(2948);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementAverageDailyVaultBalanceComponent = {
  restrict: "E",
  bindings: {},
  template: _average_daily_vault_balance2.default,
  controller: _average_daily_vault_balance4.default
};
exports.default = branchManagementAverageDailyVaultBalanceComponent;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchManagementAverageDailyVaultBalanceController = function () {
  /*@ngInject*/
  function BranchManagementAverageDailyVaultBalanceController() {
    (0, _classCallCheck3.default)(this, BranchManagementAverageDailyVaultBalanceController);
  }

  (0, _createClass3.default)(BranchManagementAverageDailyVaultBalanceController, [{
    key: "$onInit",
    value: function $onInit() {}
  }]);
  return BranchManagementAverageDailyVaultBalanceController;
}();

exports.default = BranchManagementAverageDailyVaultBalanceController;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _average_daily_vault_balance = __webpack_require__(1687);

var _average_daily_vault_balance2 = _interopRequireDefault(_average_daily_vault_balance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementAverageDailyVaultBalanceModule = angular.module('branchManagementAverageDailyVaultBalance', []).component('branchManagementAverageDailyVaultBalanceComponent', _average_daily_vault_balance2.default).name;

exports.default = branchManagementAverageDailyVaultBalanceModule;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bagouts = __webpack_require__(2664);

var _bagouts2 = _interopRequireDefault(_bagouts);

var _bagouts3 = __webpack_require__(1691);

var _bagouts4 = _interopRequireDefault(_bagouts3);

__webpack_require__(2949);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementBagoutsComponent = {
  restrict: "E",
  bindings: {},
  template: _bagouts2.default,
  controller: _bagouts4.default
};

exports.default = branchManagementBagoutsComponent;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BagoutsController = function () {
  /*@ngInject*/
  BagoutsController.$inject = ["Auth", "$state", "User", "UserService", "RouteService", "$translate", "LocationService", "ScanService", "$location", "$q", "Modal", "ShipmentService", "BranchService", "BagoutService", "SetupService", "DateUtil", "HoldService", "Navigation", "$rootScope"];
  function BagoutsController(Auth, $state, User, UserService, RouteService, $translate, LocationService, ScanService, $location, $q, Modal, ShipmentService, BranchService, BagoutService, SetupService, DateUtil, HoldService, Navigation, $rootScope) {
    (0, _classCallCheck3.default)(this, BagoutsController);

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.BranchService = BranchService;
    this.ScanService = ScanService;
    this.$q = $q;
    this.Modal = Modal;
    this.ShipmentService = ShipmentService;
    this.BagoutService = BagoutService;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.HoldService = HoldService;
    this.Navigation = Navigation;
    this.$rootScope = $rootScope;

    this.model = {
      bagout: null,
      test: null,
      branch: this.User.getUser().branchId,
      search: null,
      dateRange: {
        startDate: null,
        endDate: null
      },
      // date range picker for bagout tab
      dateRangPickerOptions: {},
      bagoutObj: {
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        },
        results: [],
        totalRecords: 0
      },
      loggedInUserId: this.User.getUser().id

      // this.showDt = moment().diff(moment(this.model.dateRange.startDate)) > 3024018327 ? true : false;
    };this.valutDate = "";
    this.routes = [];
    this.branches = [];
    this.bagsealData = [];
    this.allbagseal = [];
    this.shipmentData = [];
    this.isError = false;
    this.msg = '';
    this.isShipmentDelivered = false;
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/bagouts-history');
  }

  // openPicker() {
  //   this.showDt = moment().diff(moment(this.model.dateRange.startDate)) > 633830668646 ? true : false;
  //   setTimeout(function () { angular.element('#dtpc').trigger('click'); }, 200);
  // }

  (0, _createClass3.default)(BagoutsController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$q.all([this.SetupService.get(this.User.getUser().branchId)]).then(function (data) {
        _this.valutDate = _this.DateUtil.convertToDate(data[0].currentVaultDate);
        _this.setDateRange(_this.valutDate);
        _this.model.dateRange.startDate = moment(_this.valutDate).startOf('day').format('YYYY-MM-DD');
        _this.model.dateRange.endDate = moment(_this.valutDate).endOf('day').format('YYYY-MM-DD');
        _this.holdRouteId = data[0].holdRouteId;
      }).then(function () {
        _this.loadPermission();
        _this.getBagSealData('', 0);
      }).catch(function (err) {
        console.log(err);
      });

      this.model.noItemDisplayed = this.$translate.instant('error.branch_mgmt.location');
      this.model.noItems = true;
      this.model.dateRange;
    }
  }, {
    key: 'loadPermission',
    value: function loadPermission() {
      var _this2 = this;

      this.acl = {};
      this.hasACL = {};

      [].forEach(function (permissionKey) {
        _this2.acl[permissionKey] = _this2.User.getACL(permissionKey);

        _this2.hasACL[permissionKey] = {};

        _this2.acl[permissionKey].forEach(function (permission) {
          _this2.hasACL[permissionKey][permission] = true;
        });
      });
    }
  }, {
    key: 'getBagSealData',
    value: function getBagSealData(searchKey, offset) {
      var _this3 = this;

      searchKey = searchKey || null;

      var startDate = this.getStartDate();
      var endDate = this.getEndDate();

      this.model.bagoutObj.loading = true;
      this.BagoutService.fetchBagSeals(searchKey, startDate, endDate, this.model.bagoutObj.pagination.pageLimit, offset).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this3.model.bagoutObj.results = _this3.mapData(data.results);
          _this3.model.bagoutObj.totalRecords = data.total;
        } else {
          var bagouts = _this3.mapData(data.results);
          _this3.model.bagoutObj.results = _this3.model.bagoutObj.results.concat(bagouts);
        }
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this3.model.bagoutObj.loading = false;
      });
    }
  }, {
    key: 'mapData',
    value: function mapData(arrayObj) {
      return arrayObj.map(function (obj) {
        return {
          Key: obj.bagSeal + ' | (' + (obj.closedDate ? moment.utc(obj.closedDate).format('YYYY-MM-DD') : 'Open') + ') | ' + obj.toLocationId,
          Value: obj.bagSeal
        };
      });
    }
  }, {
    key: 'setDateRange',
    value: function setDateRange(date) {
      var _this4 = this;

      var currentVaultDate = moment(date).format() || moment();
      this.model.dateRangPickerOptions = {
        autoApply: true,
        opens: "left",
        // drops: "auto",
        maxDate: moment(currentVaultDate),
        eventHandlers: {
          'apply.daterangepicker': function applyDaterangepicker() {
            _this4.onDateChanged();
          }
        },
        ranges: {
          'Today': [moment(currentVaultDate).startOf('day').format('YYYY-MM-DD'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD')],
          'Last 5 Vault Date': [moment(currentVaultDate).subtract(4, 'day').format('YYYY-MM-DD'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD')],
          'Last 7 Vault Date': [moment(currentVaultDate).subtract(6, 'day').format('YYYY-MM-DD'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD')],
          'Last 10 Vault Date': [moment(currentVaultDate).subtract(9, 'day').format('YYYY-MM-DD'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD')]
        }
      };
    }
  }, {
    key: 'onDateChanged',
    value: function onDateChanged() {
      this.model.bagout = null;
      this.shipmentData = [];
      this.model.noItems = true;
      this.model.noItemDisplayed = this.$translate.instant('error.branch_mgmt.location');
      this.getBagSealData('', 0);
    }

    // Get data of bagout

  }, {
    key: 'loadDataOfBagoutHistory',
    value: function loadDataOfBagoutHistory(date) {
      var _this5 = this;

      this.msg = '';
      // this.showDt = moment().diff(moment(this.model.dateRange.startDate)) > 633830668646 ? true : false;
      // this.startDate = moment(this.model.dateRange.startDate).format('YYYY-MM-DD HH:mm:ss');
      // this.endDate = moment(this.model.dateRange.endDate).format('YYYY-MM-DD HH:mm:ss');

      if (this.model.bagout === "" || this.model.bagout == null) {
        this.model.noItems = true;
        delete this.model.noDataFound;
        this.model.noItemDisplayed = this.$translate.instant('error.branch_mgmt.location');
        this.shipmentData = [];
        return;
      }

      this.loading = true;
      this.$q.all([this.BagoutService.getBagsealData(this.model.bagout.Value), this.ShipmentService.getShipmentTrakingDetail(this.model.bagout.Value)]).then(function (res) {
        _this5.loading = false;
        _this5.shipmentData = res[0].shipment;
        _this5.bagOutData = res[0].bagout;
        _this5.bagoutShipmentDetails = res[1][0] || [];
        // if (res[1] && res[1].length) {
        //   this.isShipmentDelivered = res[1][0].deliveredFlag;
        // }

        _this5.isShipmentDelivered = res[1] && res[1].length ? res[1][0].deliveredFlag : undefined;

        if (_this5.bagOutData.closed) {
          _this5.bagOutClosed = _this5.$translate.instant('bagout.status_closed');
          _this5.closedDate = moment.utc(_this5.bagOutData.closedDate).format('YYYY-MM-DD');
        } else {
          _this5.bagOutClosed = _this5.$translate.instant('bagout.status_notclosed');
          _this5.createdAt = moment.utc(_this5.bagOutData.createdAt).format('YYYY-MM-DD hh:mm:ss A');
          _this5.updatedAt = moment.utc(_this5.bagOutData.updatedAt).format('YYYY-MM-DD hh:mm:ss A');
        }

        if (_this5.shipmentData.length) {
          delete _this5.model.noItemDisplayed;
          _this5.model.noItems = false;
          _this5.localDateTime = moment(_this5.valutDate).format('MM-DD-YYYY');
        } else {
          delete _this5.model.noItemDisplayed;
          _this5.model.noItems = false;
          _this5.model.noDataFound = _this5.$translate.instant('error.branch_mgmt.bagout_not_found');
        }
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this5.loading = false;
      });
    }

    // undo all bagout

  }, {
    key: 'undoBagouts',
    value: function undoBagouts(allowOnce) {
      var _this6 = this;

      this.allowOnce = allowOnce;
      this.BagoutService.undoBagout(this.model.bagout.Value, this.bagOutData.branchId).then(function (data) {
        _this6.allowOnce = false;
        _this6.model.bagout = null;
        _this6.shipmentData = [];
        _this6.model.noItems = true;
        delete _this6.model.noDataFound;
        _this6.model.noItemDisplayed = _this6.$translate.instant('error.branch_mgmt.location');
        _this6.getBagSealData('', 0);
      }).catch(function (err) {
        _this6.allowOnce = false;
        if (err && err.data && err.data.message) {
          return _this6.Modal.errorModal('error.' + err.data.message);
        }
      });
    }
  }, {
    key: 'confirmUndoBagouts',
    value: function confirmUndoBagouts() {
      var _this7 = this;

      if (this.allowOnce) return;
      this.allowOnce = true;
      this.Modal.confirmSupervisor('undo-bagouts', null, function (_ref) {
        var modal = _ref.modal,
            supId = _ref.supId;

        modal.close();
        setTimeout(function () {
          _this7.allowOnce = false;
        }, 1000);
        _this7.Modal.confirm({
          header: _this7.$translate.instant('common.confirm_delete_title'),
          message: _this7.$translate.instant('bagout.delete_message'),
          callback: function callback(_ref2) {
            var modal = _ref2.modal,
                $scope = _ref2.$scope;

            _this7.allowOnce = true;
            _this7.undoBagouts(_this7.allowOnce);
            modal.close();
          },
          type: 'danger'
        });
      }, function (_ref3) {
        var modal = _ref3.modal;

        _this7.allowOnce = false;
        modal.close();
      });
    }
  }, {
    key: 'markAsDelivered',
    value: function markAsDelivered() {
      var _this8 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirmSupervisor('mark-delivered', null, function (_ref4) {
        var modal = _ref4.modal,
            supId = _ref4.supId;

        modal.close();
        _this8.HoldService.markToDelivered(supId, _this8.model.bagout.Value).then(function (response) {
          _this8.isError = false;
          _this8.allowOnlyOnce = false;
          _this8.msg = _this8.$translate.instant('branch_mgmt.bagout.delivery_success');
          _this8.isShipmentDelivered = true;
        }).catch(function (err) {
          _this8.isError = true;
          _this8.allowOnlyOnce = false;
          if (err && err.data && err.data.message) {
            _this8.msg = _this8.$translate.instant('error.' + err.data.message);
          }
          // else {
          //   this.msg = this.$translate.instant('branch_mgmt.bagout.error_delivery');
          // }
        });
      }, function (_ref5) {
        var modal = _ref5.modal;

        _this8.allowOnlyOnce = false;
        modal.close();
      });
    }
  }, {
    key: 'getStartDate',
    value: function getStartDate() {
      return this.model.dateRange.startDate ? moment(this.model.dateRange.startDate).format('YYYY-MM-DD') : null;
    }
  }, {
    key: 'getEndDate',
    value: function getEndDate() {
      return this.model.dateRange.endDate ? moment(this.model.dateRange.endDate).format('YYYY-MM-DD') : null;
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(locationId) {
      return this.Navigation.goToServiceHistory(locationId, null, true, null);
    }
  }, {
    key: 'goToItemHistory',
    value: function goToItemHistory(trackingId) {
      this.Navigation.goToItemHistory(trackingId, null);
    }
  }, {
    key: 'print',
    value: function print() {
      var totalAmount = 0;
      var url = this.$state.href('branchMgmtBagoutPrint');

      this.shipmentData.forEach(function (s) {
        return totalAmount += s.amount;
      });

      window.w = window.open(url, '_blank');
      window.w.printData = {
        results: this.shipmentData,
        fromLocationName: this.bagoutShipmentDetails.fromLocation.name,
        fromLocationAddress: this.bagoutShipmentDetails.fromLocation.address,
        toLocationName: this.bagoutShipmentDetails.toLocation.name,
        toLocationAddress: this.bagoutShipmentDetails.toLocation.address,
        bagSealId: this.bagoutShipmentDetails.trackingId,
        routeId: this.bagoutShipmentDetails.route.id,
        routeName: this.bagoutShipmentDetails.route.name,
        totalBags: this.shipmentData.length,
        totalAmount: totalAmount,
        vaultDate: this.bagoutShipmentDetails.vaultDate
      };
    }
  }, {
    key: 'closebag',
    value: function closebag() {
      var _this9 = this;

      var obj = {
        deliveryDate: this.valutDate,
        locationId: this.bagOutData.locationId,
        branchId: this.model.branch,
        bagoutId: this.model.bagout.Value,
        holdRouteId: this.holdRouteId
      };

      this.Modal.branchMgmtBagoutClose(obj, function (_ref6) {
        var modal = _ref6.modal,
            routeId = _ref6.routeId,
            deliveryDate = _ref6.deliveryDate,
            $scope = _ref6.$scope;

        $scope.loading = true;
        if (routeId == _this9.holdRouteId) {
          modal.close();
          _this9.putOnHold(true, routeId, deliveryDate);
        } else {
          _this9._closeBagout(routeId, deliveryDate).then(function (res) {
            if (res.data && res.data.closed) {
              modal.close();
            }
          }).catch(function (err) {
            modal.close();
            if (err && err.data && err.data.message) {
              _this9.Modal.errorModal('error.' + err.data.message);
            }
          }).finally(function () {
            $scope.loading = false;
            _this9.loadDataOfBagoutHistory();
          });
        }
      }, function (_ref7) {
        var modal = _ref7.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: '_closeBagout',
    value: function _closeBagout(routeId, deliveryDate) {
      var bagoutDetails = this.bagoutShipmentDetails;
      var shipmentData = [];

      this.shipmentData.forEach(function (s) {
        shipmentData.push({
          trackingId: s.trackingId,
          amount: s.amount,
          denominationId: s.denominationId,
          locationId: s.fromLocationId,
          locationName: s.fromLocationName
        });
      });

      return this.BagoutService.closeBagout(this.model.bagout.Value, this.model.branch, routeId, moment(deliveryDate).format('YYYY-MM-DD'), bagoutDetails.carrierId ? bagoutDetails.carrier.id : null, bagoutDetails.carrierId ? bagoutDetails.carrier.name : null, this.model.loggedInUserId, shipmentData);
    }
  }, {
    key: 'putOnHold',
    value: function putOnHold(closeBagout, routeId, deliveryDate, $scope) {
      var _this10 = this;

      this.Modal.confirmSupervisor('verify-hold', null, function (_ref8) {
        var modal = _ref8.modal,
            supId = _ref8.supId;

        var allPromise = [];

        if (closeBagout) allPromise.push(_this10._closeBagout(routeId, deliveryDate));

        _this10.$q.all(allPromise).then(function () {
          _this10.ShipmentService.holdShipment(_this10.model.branch, _this10.model.bagout.Value, routeId, moment(deliveryDate).format('YYYY-MM-DD'), supId, '', '').then(function () {
            return modal.close();
          }).catch(function (err) {
            modal.close();
            if (err && err.data && err.data.message) {
              _this10.Modal.errorModal('error.' + err.data.message);
            }
          });
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            if (modal) modal.close();
            return _this10.Modal.errorModal('error.' + err.data.message);
          }
        }).finally(function () {
          _this10.loadDataOfBagoutHistory();
        });
      }, function (_ref9) {
        var modal = _ref9.modal;

        modal.close();
      });
    }
  }, {
    key: 'removeTrackingIdFromBagout',
    value: function removeTrackingIdFromBagout(shipment) {
      var _this11 = this;

      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('bagout.remove_tracking-id-message'),
        callback: function callback(_ref10) {
          var modal = _ref10.modal,
              $scope = _ref10.$scope;

          _this11.BagoutService.removeTrackingIdFromBagout(shipment.trackingId, _this11.model.branch, _this11.model.bagout.Value, shipment.fromLocationId, _this11.bagOutData.locationId, shipment.vaultDate).then(function () {
            _this11.loadDataOfBagoutHistory();
          }).catch(function () {
            if (err && err.data && err.data.message) {
              return _this11.Modal.errorModal('error.' + err.data.message);
            }
          });
          modal.close();
        },
        type: 'danger'
      });
    }
  }]);
  return BagoutsController;
}();

exports.default = BagoutsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bagouts = __webpack_require__(1690);

var _bagouts2 = _interopRequireDefault(_bagouts);

var _print = __webpack_require__(1695);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementBagoutsModule = angular.module('branchManagementBagoutsHistory', [_print2.default]).component('branchManagementBagoutsHistory', _bagouts2.default).name;

exports.default = branchManagementBagoutsModule;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bagouts = __webpack_require__(2665);

var _bagouts2 = _interopRequireDefault(_bagouts);

var _bagouts3 = __webpack_require__(1694);

var _bagouts4 = _interopRequireDefault(_bagouts3);

__webpack_require__(2950);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printComponent = {
    restrict: 'E',
    bindings: {},
    template: _bagouts2.default,
    controller: _bagouts4.default
};

exports.default = printComponent;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintController = function () {
    /*@ngInject*/
    PrintController.$inject = ["$translate", "$scope"];
    function PrintController($translate, $scope) {
        (0, _classCallCheck3.default)(this, PrintController);

        this.$translate = $translate;
        this.$scope = $scope;

        this.model = {
            bagout: null
        };

        this.barcodeOptions = {
            format: 'CODE128', lineColor: '#030303', width: 3.7, height: 100, displayValue: false,
            font: 'monospace', textAlign: 'center', textPosition: 'bottom', textMargin: 0, fontSize: 25,
            marginTop: 0, marginBottom: 0
        };

        this.loadCompanyLogo = false;
    }

    (0, _createClass3.default)(PrintController, [{
        key: '$onInit',
        value: function $onInit() {
            if (window.opener && window.opener.w && window.opener.w.printData) {
                this.model.bagout = window.opener.w.printData;
                this.print();
            }
        }
    }, {
        key: 'print',
        value: function print() {
            var _this = this;

            setTimeout(function () {
                window.print();
            }, 1500);

            var timeId = setTimeout(function () {
                _this.loadCompanyLogo = true;
                _this.$scope.$apply();
                clearTimeout(timeId);
            }, 1000);
        }
    }]);
    return PrintController;
}();

exports.default = PrintController;

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bagouts = __webpack_require__(1693);

var _bagouts2 = _interopRequireDefault(_bagouts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printModule = angular.module('branchMgmtBagoutPrint', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/branchManagement.bagouts');

    $stateProvider.state('branchMgmtBagoutPrint', {
        url: '/print-bagout',
        component: 'branchMgmtBagoutPrint',
        data: {
            requireLogin: true,
            requireACL: 'branch_mgmt_bagouts.all'
        }
    });
}]).component('branchMgmtBagoutPrint', _bagouts2.default).name;

exports.default = printModule;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _billing_approval = __webpack_require__(2666);

var _billing_approval2 = _interopRequireDefault(_billing_approval);

var _billing_approval3 = __webpack_require__(1697);

var _billing_approval4 = _interopRequireDefault(_billing_approval3);

__webpack_require__(2951);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementBillingApprovalComponent = {
  restrict: "E",
  bindings: {},
  template: _billing_approval2.default,
  controller: _billing_approval4.default
};

exports.default = branchManagementBillingApprovalComponent;

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingApprovalController = function () {
  /*@ngInject*/
  BillingApprovalController.$inject = ["Auth", "$state", "User", "DataCounter", "$translate", "$q", "Modal", "$scope", "DateUtil", "SetupService", "Navigation", "BillingRecordsService", "BillingCategoryService", "CommonLayoutService", "ServiceOrderService", "UserBranchService", "BillableEventsService", "CustomerService", "$rootScope"];
  function BillingApprovalController(Auth, $state, User, DataCounter, $translate, $q, Modal, $scope, DateUtil, SetupService, Navigation, BillingRecordsService, BillingCategoryService, CommonLayoutService, ServiceOrderService, UserBranchService, BillableEventsService, CustomerService, $rootScope) {
    var _this = this;

    (0, _classCallCheck3.default)(this, BillingApprovalController);

    this.goToContractRuleTab = function (contractId) {
      _this.$state.go('contract.edit', {
        id: contractId
      });
    };

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.Modal = Modal;
    this.DataCounter = DataCounter;
    this.$scope = $scope;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.Navigation = Navigation;
    this.BillingRecordsService = BillingRecordsService;
    this.BillingCategoryService = BillingCategoryService;
    this.CommonLayoutService = CommonLayoutService;
    this.ServiceOrderService = ServiceOrderService;
    this.UserBranchService = UserBranchService;
    this.BillableEventsService = BillableEventsService;
    this.CustomerService = CustomerService;
    this.$rootScope = $rootScope;

    this.model = {
      loading: false,
      searchText: null,
      billingCategory: null,
      branch: User.getUser().branchId,
      billableCustomerObj: {
        totalPendingAmount: 0,
        totalPendingRecords: 0,
        totalApprovedAmount: 0,
        totalApprovedRecords: 0,
        totalUnassignedRecords: 0,
        totalUnassignedAmount: 0,
        totalDeletedRecords: 0,
        totalDeletedAmount: 0,
        totalReviewRecords: 0,
        totalReviewAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        },
        customerHistory: {}
      },
      billingRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        },
        billingHistory: {},
        loading: false
      },
      billingRecordApproveObj: {},
      stats: {
        unassigned: 'unassigned',
        pending: 'pending',
        approved: 'approved',
        deleted: 'deleted',
        review: 'review',
        no_activity: 'no_activity'
      },
      billingCategoryObj: {
        totalRecords: 0,
        results: [],
        loading: false
      },
      billingTypeList: this.CommonLayoutService.billingTypeOptions(),
      // isApproved: false,
      unassignedStats: {
        customerAssigned: 'customerAssigned',
        customerNotAssigned: 'customerNotAssigned'
      },
      currentUnassignedStat: 'customerAssigned',
      unAssignedCustomersBillingRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        }
      },
      dateRangeOptions: {
        startDate: null,
        endDate: null
      },
      loggedInUser: User.getUser().id,
      userBranchList: [],
      billingEventListObj: {
        loading: false,
        results: [],
        totalRecords: 0
      },
      unassignedCustomerObj: {},
      pendingCustomerObj: {},
      approvedCustomerObj: {},
      rejectedCustomerObj: {},
      reviewCustomerObj: {},
      noActivityCustomerObj: {},
      staticBillingEventRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        },
        billingHistory: {},
        loading: false
      },
      customerListObj: {
        totalRecords: 0,
        results: [],
        loading: false
      },
      noActivityBillingRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        }
      },
      rejectedBillingRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        }
      },
      billingReviewRecordsObj: {
        totalRecords: 0,
        totalAmount: 0,
        results: [],
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        }
      },
      hasActiveSurcharge: false,
      hasStoredSurcharge: false,
      surchargePeriodLabel: '',
      surchargeFilterAligned: true
    };

    this.model.currentStats = this.model.stats.pending;
    this.sortColumn = "vaultDate";
    this.reverseSort = true;
    this.deleteBillingRecordsObj = {};
    this.model.generatingStaticBillingRecord = {};
    this.undoApprovedBillingRecordsObj = {};
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/billing-approval');
    this.isCustomerUser = this.User.getUser().customerUser;

    this.surchargeTypes = ['INSURANCE', 'FUEL', 'SECURITY', 'LIABILITY'];
    this.surchargeIntervalLabelKeys = {
      WEEKLY: 'customer.surcharge_interval_weekly',
      BI_WEEKLY: 'customer.surcharge_interval_bi_weekly',
      MONTHLY: 'customer.surcharge_interval_monthly',
      QUARTERLY: 'customer.surcharge_interval_quarterly'
    };
    this.surchargeLabelKeys = {
      INSURANCE: 'customer.surcharge_insurance',
      FUEL: 'customer.surcharge_fuel',
      SECURITY: 'customer.surcharge_security',
      LIABILITY: 'customer.surcharge_liability'
    };
  }

  (0, _createClass3.default)(BillingApprovalController, [{
    key: 'loadPermission',
    value: function loadPermission() {
      var _this2 = this;

      this.acl = {};
      this.hasACL = {};

      ['branch_mgmt_billing_approval_create_billing_record', 'branch_mgmt_billing_approval_approve_billing_record', 'branch_mgmt_billing_approval_edit_billing_record', 'branch_mgmt_billing_approval_delete_billing_record'].forEach(function (permissionKey) {
        _this2.acl[permissionKey] = _this2.User.getACL(permissionKey);
        _this2.hasACL[permissionKey] = {};

        if (_this2.acl[permissionKey] && _this2.acl[permissionKey].length > 0) {
          _this2.acl[permissionKey].forEach(function (permission) {
            _this2.hasACL[permissionKey][permission] = true;
          });
        }
      });
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this3 = this;

      this.model.loading = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(this.model.billingTypeList)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;

          this.model.billingTypeList[k].value = this.model.billingTypeList[k].value.toUpperCase();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$q.all([this.SetupService.get(this.model.branch), this.UserBranchService.getUserBranches(this.model.loggedInUser)]).then(function (data) {
        _this3.model.setupDetails = data[0];
        _this3.model.userBranchList = data[1].results;
        _this3.setDateRangeOptions('dateRangPickerOptionsfor');
        _this3.model.dateRangeOptions = {
          startDate: moment().startOf('months').format('YYYY-MM-DD'),
          endDate: moment().endOf('months').format('YYYY-MM-DD')
        };

        _this3.loadPermission();
        _this3.getBillingCategory('', 0);
        _this3.getBillingEventsList('', 0);

        if (_this3.isCustomerUser) {
          _this3.getCustomerList('', 0).then(function () {
            if (!_this3.model.customerId) return;
            _this3.model.billableCustomerObj.pagination.page = 1;
            _this3.billableCustomer();
          });
        } else {
          _this3.loadData();
        }
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this3.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this3.model.loading = false;
      });
    }
  }, {
    key: 'setDateRangeOptions',
    value: function setDateRangeOptions(modelValue) {
      var _this4 = this;

      this.model[modelValue] = {
        autoApply: true,
        opens: "left",
        eventHandlers: {
          'apply.daterangepicker': function applyDaterangepicker() {
            if (_this4.model.currentStats === _this4.model.stats.unassigned) _this4.loadUnassignedTabRecords();else if (_this4.model.currentStats === _this4.model.stats.deleted) {
              _this4.getRejectedRecords();
              // this.billableCustomer();
            } else _this4.loadData();
          }
        },
        ranges: {
          'Current Year': [moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')],
          'Last 6 Months': [moment().subtract('5', 'months').format('YYYY-MM-DD'), moment().endOf('day').format('YYYY-MM-DD')],
          'Last 30 Days': [moment().subtract('29', 'days').format('YYYY-MM-DD'), moment().endOf('day').format('YYYY-MM-DD')],
          'Today': [moment().startOf('day').format('YYYY-MM-DD'), moment().endOf('day').format('YYYY-MM-DD')],
          'Previous Week': [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'day').format('YYYY-MM-DD')],
          'Current Week': [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')],
          'Previous Month': [moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')],
          'Current Month': [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]
        }
      };
    }
  }, {
    key: 'getStartDate',
    value: function getStartDate() {
      return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD') : null;
    }
  }, {
    key: 'getEndDate',
    value: function getEndDate() {
      return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD') : null;
    }
  }, {
    key: 'billableCustomer',
    value: function billableCustomer() {
      var _this5 = this;

      setTimeout(function () {
        _this5.model.billableCustomerObj.customerHistory.process = true;
        var branches = _this5.model.selectedBranch && _this5.model.selectedBranch.length > 0 ? _this5.model.selectedBranch.map(function (branchObj) {
          return branchObj.branchId;
        }) : null;
        var billingEventsId = _this5.model.billingEvents ? _this5.model.billingEvents.Value : null;
        var billingCategoryId = _this5.model.billingCategory ? _this5.model.billingCategory.Value : null;
        var searchText = _this5.model.searchText ? _this5.model.searchText : null;
        var customer = _this5.model.customerId ? _this5.model.customerId.Value : null;

        var startDate = _this5.getStartDate();
        var endDate = _this5.getEndDate();

        _this5.BillingRecordsService.getBillableCustomer(searchText, _this5.model.currentStats, (_this5.model.billableCustomerObj.pagination.page - 1) * _this5.model.billableCustomerObj.pagination.pageLimit, _this5.model.billableCustomerObj.pagination.pageLimit, startDate, endDate, branches, billingEventsId, billingCategoryId, customer).then(function (data) {
          _this5.model.billableCustomerObj.results = data.results;
          _this5.model.billableCustomerObj.totalPendingAmount = data.totalPendingAmount;
          _this5.model.billableCustomerObj.totalPendingRecords = data.totalPendingRecords;
          _this5.model.billableCustomerObj.totalApprovedAmount = data.totalApprovedAmount;
          _this5.model.billableCustomerObj.totalApprovedRecords = data.totalApprovedRecords;
          _this5.model.billableCustomerObj.totalUnassignedAmount = data.totalUnassignedAmount;
          _this5.model.billableCustomerObj.totalReviewRecords = data.totalReviewRecords;
          _this5.model.billableCustomerObj.totalReviewAmount = data.totalReviewAmount;
          _this5.model.billableCustomerObj.totalNoActivityRecords = data.totalNoActivityRecords;
          _this5.model.billableCustomerObj.totalNoActivityAmount = data.totalNoActivityAmount;
          _this5.model.rejectedBillingRecordsObj.totalRecords = data.totalDeletedRecords;
          _this5.model.rejectedBillingRecordsObj.totalAmount = data.totalDeletedAmount;
          // this.model.billableCustomerObj.totalUnassignedRecords = data.totalUnassignedRecords;
          _this5.model.billableCustomerObj.customerAssignedTotalRecords = data.customerAssignedTotalRecords;
          _this5.model.billableCustomerObj.customerList = data.customerList;
          _this5.model.unassignedCustomerObj.totalUnAssignedBillableCustomers = data.totalUnAssignedBillableCustomers;
          _this5.model.pendingCustomerObj.totalPendingBillableCustomers = data.totalPendingBillableCustomers;
          _this5.model.approvedCustomerObj.totalApprovedBillablecustomers = data.totalApprovedBillablecustomers;
          _this5.model.reviewCustomerObj.totalReviewBillablecustomers = data.totalReviewBillablecustomers;
          _this5.model.noActivityCustomerObj.totalNoActivityBillablecustomers = data.totalNoActivityBillablecustomers;
          _this5.applySurchargeTotals(_this5.model.billableCustomerObj.results, data);
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this5.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          _this5.model.billableCustomerObj.customerHistory.process = false;
        });
      }, 100);
    }
  }, {
    key: 'setPage',
    value: function setPage(isExpanded, customerId) {
      if (!isExpanded) return;
      this.model.billingRecordsObj.billingHistory[customerId] = { page: 1 };
    }
  }, {
    key: 'getBillingRecords',
    value: function getBillingRecords(data, event) {
      var _this6 = this;

      var branches = null,
          billingEventsId = null,
          billingCategoryId = null;
      document.getElementById('expand-btn-' + data.customerId).blur();

      if (!data.expanded && this.model.billingRecordsObj.billingHistory[data.customerId] && this.model.billingRecordsObj.billingHistory[data.customerId].details) {
        // if (data.isSelected) data.isSelected = false;
        this.model.billingRecordsObj.billingHistory[data.customerId].details.totalRecordSelected = 0;
        return;
      } else if (data.expanded && data.isSelected) {
        // data.isSelected = false;
      }

      var startDate = this.getStartDate();
      var endDate = this.getEndDate();

      if (this.model.currentStats == 'unassigned' && this.model.selectedBranch) {
        branches = this.model.selectedBranch.map(function (branchObj) {
          return branchObj.branchId;
        });
        billingEventsId = this.model.billingEvents ? this.model.billingEvents.Value : null;
      }
      billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;
      this.model.billingRecordsObj.billingHistory[data.customerId].process = true;
      this.BillingRecordsService.getBillingRecords(this.model.searchText ? this.model.searchText : null, data.customerId, this.reverseSort, this.sortColumn, this.model.currentStats, (this.model.billingRecordsObj.billingHistory[data.customerId].page - 1) * this.model.billingRecordsObj.pagination.pageLimit, this.model.billingRecordsObj.pagination.pageLimit, startDate, endDate, branches, billingEventsId, billingCategoryId).then(function (history) {
        _this6.model.billingRecordsObj.billingHistory[data.customerId].details = history;
        _this6.model.billingRecordsObj.billingHistory[data.customerId].details.pageLimit = _this6.model.billingRecordsObj.pagination.pageLimit;

        data.totalLocationServiced = history.totalLocationServiced;
        data.totalBillableEvents = history.totalRecords;

        _this6.model.billingRecordsObj.billingHistory[data.customerId].details.results.forEach(function (record) {
          if (record.billingCategory) {
            record.billingCategoryObj = {};
            record.billingCategoryObj.Key = record.billingCategory;
          }

          if (data.isSelected) {
            record.isSelected = true;
          }
        });
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this6.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this6.model.billingRecordsObj.billingHistory[data.customerId].process = false;
      });
    }
  }, {
    key: 'selectAllBillingRecords',
    value: function selectAllBillingRecords(data) {
      var totalSelected = 0;
      var totalRecords = data.totalBillableEvents;

      if (data.isSelected && this.model.billingRecordsObj.billingHistory[data.customerId] && data.expanded) {
        this.model.billingRecordsObj.billingHistory[data.customerId].details.results.forEach(function (d) {
          return d.isSelected = true;
        });
        this.model.billingRecordsObj.billingHistory[data.customerId].details.totalRecordSelected = totalRecords;
      } else if (!data.isSelected && this.model.billingRecordsObj.billingHistory[data.customerId]) {
        this.model.billingRecordsObj.billingHistory[data.customerId].details.results.forEach(function (d) {
          return d.isSelected = false;
        });
        this.model.billingRecordsObj.billingHistory[data.customerId].details.totalRecordSelected = totalSelected;
      }
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(locationId) {
      return this.Navigation.goToServiceHistory(locationId, null, true, null);
    }
  }, {
    key: 'goToRouteTab',
    value: function goToRouteTab(routeId, vaultDate) {
      return this.Navigation.goToRouteTab(routeId, vaultDate, true, null);
    }
  }, {
    key: 'tabSelection',
    value: function tabSelection(selectedValue) {
      var _this7 = this;

      setTimeout(function () {
        _this7.model.billingCategory = null;
        _this7.model.currentStats = selectedValue;
        _this7.model.dateRangeOptions = {
          startDate: null,
          endDate: null
        };
        _this7.model.dateRangeOptions.startDate = moment().startOf('months').format('YYYY-MM-DD');
        _this7.model.dateRangeOptions.endDate = moment().endOf('months').format('YYYY-MM-DD');
        _this7.setDateRangeOptions('dateRangPickerOptionsfor');
        _this7.model.billableCustomerObj.pagination.page = 1;
        _this7.model.customerId = _this7.isCustomerUser ? _this7.model.customerListObj.results[0] : null;

        if (selectedValue === _this7.model.stats.approved) {
          _this7.reverseSort = false;
          _this7.sortColumn = 'vaultDate';
          _this7.loadData();
        } else if (selectedValue === _this7.model.stats.pending || selectedValue === _this7.model.stats.unassigned) {
          _this7.reverseSort = true;
          _this7.sortColumn = 'vaultDate';
          _this7.loadData();
        } else if (selectedValue === _this7.model.stats.deleted) {
          _this7.reverseSort = true;
          _this7.sortColumn = 'vaultDate';
          _this7.loadData();
        } else if (selectedValue === _this7.model.stats.review) {
          _this7.model.searchText = null;
          _this7.reverseSort = true;
          _this7.sortColumn = 'vaultDate';
          _this7.loadData();
        } else if (selectedValue === _this7.model.stats.no_activity) {
          _this7.loadData();
        }
        _this7.getBillingCategory('', 0);
      });
    }
  }, {
    key: 'validateBillingRecordSelection',
    value: function validateBillingRecordSelection(billingRecord, customerObj) {
      var _this8 = this;

      var totalSelected = 0,
          length = this.model.billingRecordsObj.billingHistory[customerObj.customerId].details.results.length;
      this.model.billingRecordsObj.billingHistory[customerObj.customerId].details.totalRecordSelected = 0;

      setTimeout(function () {
        if (!billingRecord.isSelected && customerObj.isSelected) {
          customerObj.isSelected = false;
          _this8.model.billingRecordsObj.billingHistory[customerObj.customerId].details.totalRecordSelected = length - 1;
        } else {
          _this8.model.billingRecordsObj.billingHistory[customerObj.customerId].details.results.forEach(function (data) {
            if (data.isSelected) totalSelected++;

            _this8.model.billingRecordsObj.billingHistory[customerObj.customerId].details.totalRecordSelected = totalSelected;
            if (totalSelected === length) customerObj.isSelected = false;
            if (customerObj.totalBillableEvents === totalSelected) customerObj.isSelected = true;
            // else customerObj.isSelected = false;
          });
        }
        _this8.$scope.$apply();
      });
    }
  }, {
    key: 'billingRecordApproval',
    value: function billingRecordApproval(customerObj, billingRecord) {
      var _this9 = this;

      var totalAmount = 0,
          totalRecords = 0,
          records = [],
          obj = {};

      if (!customerObj.isSelected) {
        this.model.billingRecordsObj.billingHistory[customerObj.customerId].details.results.forEach(function (data) {
          if (data.isSelected) {
            var _records$push;

            totalAmount += data.amountDue;
            totalRecords++;
            records.push((_records$push = {
              billingRecordId: data.billingRecordId,
              amount: data.amount,
              billingType: data.billingType,
              billingCategory: data.billingCategory,
              locationId: data.locationId,
              branchId: data.branchId
            }, (0, _defineProperty3.default)(_records$push, 'locationId', data.locationId), (0, _defineProperty3.default)(_records$push, 'contractRuleId', data.contractRuleId), (0, _defineProperty3.default)(_records$push, 'contractId', data.customerContractId), (0, _defineProperty3.default)(_records$push, 'vaultDate', data.vaultDate), (0, _defineProperty3.default)(_records$push, 'rate', data.rate), (0, _defineProperty3.default)(_records$push, 'amountDue', data.amountDue), _records$push));
          }
        });

        if (!this.model.billingRecordsObj.billingHistory[customerObj.customerId].details.totalRecordSelected && billingRecord) {
          var _records$push2;

          totalAmount = billingRecord.amountDue || 0;
          totalRecords++;
          records.push((_records$push2 = {
            billingRecordId: billingRecord.billingRecordId,
            amount: billingRecord.amount,
            billingType: billingRecord.billingType,
            billingCategory: billingRecord.billingCategory,
            locationId: billingRecord.locationId,
            branchId: billingRecord.branchId
          }, (0, _defineProperty3.default)(_records$push2, 'locationId', billingRecord.locationId), (0, _defineProperty3.default)(_records$push2, 'contractRuleId', billingRecord.contractRuleId), (0, _defineProperty3.default)(_records$push2, 'contractId', billingRecord.customerContractId), (0, _defineProperty3.default)(_records$push2, 'vaultDate', billingRecord.vaultDate), (0, _defineProperty3.default)(_records$push2, 'rate', billingRecord.rate), (0, _defineProperty3.default)(_records$push2, 'amountDue', billingRecord.amountDue), _records$push2));
        }

        obj = {
          totalAmount: totalAmount,
          totalRecords: totalRecords,
          customer: customerObj.customerName
        };
      } else {
        obj = {
          totalAmount: customerObj.totalAmount,
          totalRecords: customerObj.totalBillableEvents,
          customer: customerObj.customerName
        };
      }

      obj.surchargeSelection = {
        customerId: customerObj.customerId,
        isApproveAllRecords: !!customerObj.isSelected,
        billingRecordIds: records.map(function (record) {
          return record.billingRecordId;
        }),
        startDate: customerObj.isSelected ? this.getStartDate() : null,
        endDate: customerObj.isSelected ? this.getEndDate() : null,
        locationId: this.model.searchText,
        billingCategoryId: this.model.billingCategory ? this.model.billingCategory.Value : null
      };

      this.Modal.approveBillingRecords(obj, function (_ref) {
        var supervisorId = _ref.supervisorId,
            modal = _ref.modal,
            $scope = _ref.$scope;

        $scope.model.loading = true;
        _this9.approve(customerObj, records, supervisorId, modal, $scope);
      }, function (_ref2) {
        var modal = _ref2.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'approve',
    value: function approve(customerObj, billingRecords, userId) {
      var _this10 = this;

      var modal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var $scope = arguments[4];

      // if (!customerObj.expanded) return;

      this.removeFocus('approve-all-' + customerObj.customerId);
      this.model.billingRecordApproveObj[customerObj.customerId] = { process: true };

      var startDate = customerObj.isSelected ? this.getStartDate() : null;
      var endDate = customerObj.isSelected ? this.getEndDate() : null;
      billingRecords = customerObj.isSelected ? [] : billingRecords;
      var customerId = customerObj.customerId;
      var billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;
      var locationId = this.model.searchText;

      this.BillingRecordsService.approveBillingRecords(billingRecords, userId, customerObj.isSelected, startDate, endDate, customerId, locationId, billingCategoryId).then(function () {
        modal.close();
        _this10.billableCustomer();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this10.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        $scope.model.loading = false;
        if (modal) modal.close();
        _this10.model.billingRecordApproveObj[customerObj.customerId].process = false;
      });
    }
  }, {
    key: 'removeFocus',
    value: function removeFocus(id) {
      if (!id) return;
      return document.getElementById(id).blur();
    }
  }, {
    key: 'sortData',
    value: function sortData(column, obj, event) {
      this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
      this.sortColumn = column;
      this.getBillingRecords(obj, event);
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      if (this.model.currentStats === this.model.stats.pending) {
        this.model.billableCustomerObj.pagination.page = 1;
        this.billableCustomer();
        this.getCustomerList('', 0);
      } else if (this.model.currentStats === this.model.stats.approved) {
        this.model.billableCustomerObj.pagination.page = 1;
        this.billableCustomer();
        this.getCustomerList('', 0);
      } else if (this.model.currentStats === this.model.stats.unassigned) {
        this.model.searchText = null;
        if (this.model.currentUnassignedStat === this.model.unassignedStats.customerNotAssigned) {
          this.model.unAssignedCustomersBillingRecordsObj.pagination.page = 1;
          this.getUnassignedCustomerBillingRecords();
        } else {
          this.model.billableCustomerObj.pagination.page = 1;
          this.billableCustomer();
          this.getCustomerList('', 0);
        }
      } else if (this.model.currentStats === this.model.stats.deleted) {
        this.model.rejectedBillingRecordsObj.pagination.page = 1;
        this.getRejectedRecords();
      } else if (this.model.currentStats === this.model.stats.review) {
        this.model.billableCustomerObj.pagination.page = 1;
        this.billableCustomer();
        this.getCustomerList('', 0);
      } else if (this.model.currentStats === this.model.stats.no_activity) {
        this.model.billableCustomerObj.pagination.page = 1;
        this.billableCustomer();
        this.getCustomerList('', 0);
      }
    }
  }, {
    key: 'updateBillingRecords',
    value: function updateBillingRecords(billingRecordsObj, customerObj) {
      var _this11 = this;

      billingRecordsObj.isEdit = false;
      this.model.billingRecordsObj.billingHistory[customerObj.customerId].isUpdate = true;
      var startDate = this.getStartDate();
      var endDate = this.getEndDate();
      var billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;
      var selectedCustomerId = this.model.customerId ? this.model.customerId.Value : null;
      var selectedBillableEvent = this.model.billingEvents ? this.model.billingEvents.Value : null;

      this.Modal.updateBillingRecords(billingRecordsObj, this.model.currentStats, function (_ref3) {
        var modal = _ref3.modal,
            locationId = _ref3.locationId,
            customerId = _ref3.customerId,
            billingCategory = _ref3.billingCategory,
            billingType = _ref3.billingType,
            amount = _ref3.amount,
            amountDue = _ref3.amountDue,
            isApproved = _ref3.isApproved,
            userId = _ref3.userId,
            $scope = _ref3.$scope;


        _this11.BillingRecordsService.updateBillingRecords(billingRecordsObj.billingRecordId, amount || null, amountDue || null, billingRecordsObj.branchId, billingCategory, billingType, locationId, customerId, _this11.model.currentStats, startDate, endDate, isApproved, userId, _this11.model.searchText, billingCategoryId, selectedCustomerId, selectedBillableEvent, $scope.model.billableEventId, $scope.model.billableEvent).then(function (data) {
          if (customerObj.customerId === customerId) {
            billingRecordsObj.rate = amount;
            billingRecordsObj.amountDue = amountDue;
            billingRecordsObj.billingCategoryObj.Key = billingCategory;
            var evtType = $scope.model.billableEventsObj.results.filter(function (billableEvt) {
              return $scope.model.billableEventId === billableEvt.Value;
            })[0];
            billingRecordsObj.billableEventType = evtType.type;
            billingRecordsObj.billingType = billingType;
            billingRecordsObj.locationId = locationId;
            if (data && data.storedSurchargeBreakdown) {
              billingRecordsObj.storedSurcharge = data.storedSurcharge;
              billingRecordsObj.storedSurchargeBreakdown = data.storedSurchargeBreakdown;
            }

            if (_this11.model.currentStats.toUpperCase() === 'UNASSIGNED') {
              // this.billableCustomer();
              _this11.model.billingRecordsObj.billingHistory[customerObj.customerId].page = 1;
              _this11.getBillingRecords(customerObj);
              _this11.model.billableCustomerObj.customerAssignedTotalRecords = _this11.model.billableCustomerObj.customerAssignedTotalRecords - 1;
              _this11.model.billableCustomerObj.totalUnassignedAmount = data.totalUnassignedAmount;
              _this11.model.billableCustomerObj.totalUnassignedRecords = data.totalUnassignedRecords;
            } else if (_this11.model.currentStats.toUpperCase() === 'PENDING') {
              _this11.model.billableCustomerObj.totalPendingAmount = data.totalPendingBucketAmount;
              _this11.model.billableCustomerObj.totalPendingRecords = data.totalPendingRecords;
            } else if (_this11.model.currentStats.toUpperCase() === 'APPROVED') {
              _this11.model.billableCustomerObj.totalApprovedAmount = data.totalApprovedAmount;
              _this11.model.billableCustomerObj.totalApprovedRecords = data.totalApprovedRecords;
            } else if (_this11.model.currentStats.toUpperCase() === 'REVIEW') {
              _this11.model.billableCustomerObj.totalReviewAmount = data.totalReviewBucketAmount;
              _this11.model.billableCustomerObj.totalReviewRecords = data.totalReviewRecords;
            }
            customerObj.totalAmount = data.totalPendingAmount;
            _this11.billableCustomer();
          } else {
            _this11.billableCustomer();
          }
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this11.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          modal.close();
          _this11.model.billingRecordsObj.billingHistory[customerObj.customerId].isUpdate = false;
          $scope.isLoading = false;
        });
      }, function (_ref4) {
        var modal = _ref4.modal;

        if (modal) modal.close();
        _this11.model.billingRecordsObj.billingHistory[customerObj.customerId].isUpdate = false;
      });
    }
  }, {
    key: 'deleteBillingRecords',
    value: function deleteBillingRecords(billingRecordsObj, from) {
      var _this12 = this;

      var customer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.deleteBillingRecordsObj[billingRecordsObj.billingRecordId] = { loading: true };
      var billingCategoryId = this.model.billingCategory ? this.model.billingCategory.Value : null;
      var selectedCustomerId = this.model.customerId ? this.model.customerId.Value : null;
      var selectedBillableEvent = this.model.billingEvents ? this.model.billingEvents.Value : null;

      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message'),
        callback: function callback(_ref5) {
          var modal = _ref5.modal,
              $scope = _ref5.$scope;

          var payload = {
            billingRecordId: billingRecordsObj.billingRecordId,
            userId: _this12.model.loggedInUser,
            branchId: billingRecordsObj.branchId,
            billingCategory: _this12.model.billingCategory,
            locationId: billingRecordsObj.locationId,
            routeId: billingRecordsObj.routeId,
            contractRuleId: billingRecordsObj.contractRuleId,
            contractRuleName: billingRecordsObj.contractRuleName,
            customerId: billingRecordsObj.customerId,
            rate: billingRecordsObj.rate,
            vaultDate: billingRecordsObj.vaultDate,
            contractId: billingRecordsObj.customerContractId,
            startDate: _this12.getStartDate(),
            endDate: _this12.getEndDate(),
            currentStat: from,
            searchText: _this12.model.searchText,
            selectedBillingCategoryId: billingCategoryId,
            selectedCustomerId: selectedCustomerId,
            selectedBillableEvent: selectedBillableEvent
          };

          _this12.BillingRecordsService.deleteBillingRecord(payload).then(function (res) {
            if (customer) {
              _this12.model.billingRecordsObj.billingHistory[customer.customerId].page = 1;
              _this12.getBillingRecords(customer);
            }

            if (from === "NOT_ASSIGNED") {
              _this12.getUnassignedCustomerBillingRecords();
            }

            if (from === "ASSIGNED" || from === "NOT_ASSIGNED") {
              _this12.model.billableCustomerObj.totalUnassignedAmount = res[from].totalBucketAmount;
              _this12.model.billableCustomerObj.customerAssignedTotalRecords = res[from].totalRecords;
              if (customer) customer.totalAmount = res[from].totalAmount;
            }

            if (from === "PENDING") {
              _this12.model.billableCustomerObj.totalPendingAmount = res[from].totalBucketAmount;
              _this12.model.billableCustomerObj.totalPendingRecords = res[from].totalRecords;
              if (customer) customer.totalAmount = res[from].totalAmount;
            }

            if (from === "REVIEW") {
              _this12.model.billableCustomerObj.totalReviewAmount = res[from].totalBucketAmount;
              _this12.model.billableCustomerObj.totalReviewRecords = res[from].totalRecords;
              if (customer) customer.totalAmount = res[from].totalAmount;
            }

            modal.close();
          }).catch(function (err) {
            modal.close();
            _this12.Modal.errorModal(err.data.message);
          }).finally(function () {
            _this12.deleteBillingRecordsObj[billingRecordsObj.billingRecordId].loading = false;
          });
        },
        negative: function negative(_ref6) {
          var modal = _ref6.modal;

          modal.close();
          _this12.deleteBillingRecordsObj[billingRecordsObj.billingRecordId].loading = false;
        },
        type: 'danger'
      });
    }
  }, {
    key: 'getBillingCategory',
    value: function getBillingCategory(searchKey, offset) {
      var _this13 = this;

      searchKey = searchKey || '';
      var billingCategorySearchObj = {
        queryJSON: {
          rules: [{
            group: {
              rules: [{
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      this.model.billingCategoryObj.loading = true;
      this.BillingCategoryService.all(billingCategorySearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this13.model.billingCategoryObj.totalRecords = data.total;
          _this13.model.billingCategoryObj.results = _this13.billingCategoryMap(data.results);
        } else {
          var results = _this13.billingCategoryMap(data.results);
          _this13.model.billingCategoryObj.results = _this13.model.billingCategoryObj.results.concat(results);
        }
      }).catch(function (err) {
        _this13.Modal.errorModal(err.data.message);
      }).finally(function () {
        _this13.model.billingCategoryObj.loading = false;
      });
    }
  }, {
    key: 'billingCategoryMap',
    value: function billingCategoryMap(events) {
      return events.map(function (data) {
        return {
          Key: data.name,
          Value: data.id
        };
      });
    }
  }, {
    key: 'goToBillableEventsTab',
    value: function goToBillableEventsTab(billingRecordsObj) {
      var obj = {
        searchText: billingRecordsObj.trackingId,
        branchId: billingRecordsObj.branchId,
        billableEvent: billingRecordsObj.billableEventType,
        createdAt: billingRecordsObj.createdAt,
        isRedirected: true
      };

      this.DataCounter.setData(obj);
      this.$state.go('log.all', {
        page: 1
      });
    }
  }, {
    key: 'resetData',
    value: function resetData(customerObj) {
      if (!customerObj) {
        customerObj.isSelected = false;
      }
    }
  }, {
    key: 'translateMessage',
    value: function translateMessage(prefix, key) {
      if (!key) return;
      return this.$translate.instant(prefix.concat(key));
    }
  }, {
    key: 'billableEventLogDetails',
    value: function billableEventLogDetails(billingRecordsObj) {
      var obj = {
        searchText: {
          trackingId: billingRecordsObj.trackingId,
          serviceOrderId: billingRecordsObj.serviceOrderId,
          encounterId: billingRecordsObj.encounterId,
          billingId: billingRecordsObj.billingId || billingRecordsObj.billingRecordId
        },
        branchId: billingRecordsObj.branchId,
        billableEvent: billingRecordsObj.billableEventType,
        createdAt: billingRecordsObj.createdAt,
        startDate: moment.utc(billingRecordsObj.createdAt).format('YYYY-MM-DD 00:00:00'),
        endDate: moment.utc(billingRecordsObj.createdAt).add(1, 'days').format('YYYY-MM-DD 23:59:59'),
        customerContractId: billingRecordsObj.customerContractId,
        contractName: billingRecordsObj.contractName,
        contractRuleName: billingRecordsObj.contractRuleName,
        locationId: billingRecordsObj.locationId,
        vaultDate: billingRecordsObj.vaultDate
      };

      this.Modal.billableEventLogDetails(obj, function (_ref7) {
        var modal = _ref7.modal;

        modal.close();
      }, function (_ref8) {
        var modal = _ref8.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'unassignedTabSelection',
    value: function unassignedTabSelection(selectedValue) {
      this.model.currentUnassignedStat = selectedValue;

      if (this.model.currentUnassignedStat === this.model.unassignedStats.customerAssigned) {
        // this.model.unAssignedCustomersBillingRecordsObj = {
        //   totalRecords: 0,
        //   totalAmount: 0,
        //   results: [],
        //   pagination: {
        //     page: 1,
        //     total: 0,
        //     pageLimit: 10,
        //     maxPages: 10
        //   }
        // }
        this.model.dateRangeOptions.startDate = moment().startOf('months').format('YYYY-MM-DD');
        this.model.dateRangeOptions.endDate = moment().endOf('months').format('YYYY-MM-DD');
        this.setDateRangeOptions('dateRangPickerOptionsfor');
        this.reverseSort = true;
        this.sortColumn = 'vaultDate';
        this.model.billableCustomerObj.pagination.page = 1;
        this.model.customerId = this.isCustomerUser ? this.model.customerListObj.results[0] : null;
        this.filterRecords();
        this.getCustomerList('', 0);
      } else {
        this.model.dateRangeOptions.startDate = moment().startOf('months').format('YYYY-MM-DD');
        this.model.dateRangeOptions.endDate = moment().endOf('months').format('YYYY-MM-DD');
        this.reverseSort = false;
        this.sortColumn = 'vaultDate';
        this.setDateRangeOptions('dateRangPickerOptionsfor');
        this.model.unAssignedCustomersBillingRecordsObj.pagination.page = 1;
        this.getUnassignedCustomerBillingRecords();
      }
    }
  }, {
    key: 'getUnassignedCustomerBillingRecords',
    value: function getUnassignedCustomerBillingRecords() {
      var _this14 = this;

      setTimeout(function () {
        _this14.model.unAssignedCustomersBillingRecordsObj.loading = true;
        var startDate = _this14.getStartDate();
        var endDate = _this14.getEndDate();
        var branches = _this14.model.selectedBranch.map(function (branchObj) {
          return branchObj.branchId;
        });
        var billingEventsId = _this14.model.billingEvents ? _this14.model.billingEvents.Value : null;
        var billingCategoryId = _this14.model.billingCategory ? _this14.model.billingCategory.Value : null;

        _this14.BillingRecordsService.getBillingRecords(_this14.model.searchText, null, _this14.reverseSort, _this14.sortColumn, _this14.model.currentStats, (_this14.model.unAssignedCustomersBillingRecordsObj.pagination.page - 1) * _this14.model.unAssignedCustomersBillingRecordsObj.pagination.pageLimit, _this14.model.unAssignedCustomersBillingRecordsObj.pagination.pageLimit, startDate, endDate, branches, billingEventsId, billingCategoryId).then(function (history) {
          _this14.model.unAssignedCustomersBillingRecordsObj.records = history.results;
          _this14.model.unAssignedCustomersBillingRecordsObj.totalRecords = history.totalRecords;
          _this14.model.unAssignedCustomersBillingRecordsObj.records.forEach(function (record) {
            if (record.billingCategory) {
              record.billingCategoryObj = {};
              record.billingCategoryObj.Key = record.billingCategory;
            }
          });

          // this.model.billableCustomerObj.totalPendingAmount = history.totalPendingAmount;
          // this.model.billableCustomerObj.totalPendingRecords = history.totalPendingRecords;
          // this.model.billableCustomerObj.totalApprovedAmount = history.totalApprovedAmount;
          // this.model.billableCustomerObj.totalApprovedRecords = history.totalApprovedRecords;
          _this14.model.billableCustomerObj.totalUnassignedAmount = history.totalUnassignedAmount;
          _this14.model.billableCustomerObj.customerAssignedTotalRecords = history.totalUnassignedRecords;
        }).catch(function (err) {
          console.log(err);
          if (err && err.data && err.data.message) {
            _this14.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          _this14.model.unAssignedCustomersBillingRecordsObj.loading = false;
        });
      }, 200);
    }
  }, {
    key: 'sortUnassignedCustomerBillingRecords',
    value: function sortUnassignedCustomerBillingRecords(column) {
      this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
      this.sortColumn = column;
      this.getUnassignedCustomerBillingRecords();
    }
  }, {
    key: 'exportBillingRecords',
    value: function exportBillingRecords() {
      var _this15 = this;

      setTimeout(function () {
        var _document$getElementB;

        var startDate = _this15.getStartDate();
        var endDate = _this15.getEndDate();
        var currentStat = ['pending', 'approved', 'deleted', 'review', 'no_activity'].includes(_this15.model.currentStats) ? 'other' : 'unassigned';
        var branches = null,
            billingEventsId = null,
            billingCategoryId = null,
            customerId = _this15.model.currentStats === 'deleted' && _this15.model.customerId ? _this15.model.customerId.Value : null;

        if (currentStat == 'unassigned' && _this15.model.selectedBranch) {
          branches = _this15.model.selectedBranch.map(function (branchObj) {
            return branchObj.branchId;
          });
          billingEventsId = _this15.model.billingEvents ? _this15.model.billingEvents.Value : null;
        }
        billingCategoryId = _this15.model.billingCategory ? _this15.model.billingCategory.Value : null;

        var customerList = void 0;
        if (currentStat == 'unassigned' && _this15.model.currentUnassignedStat === _this15.model.unassignedStats.customerNotAssigned) customerList = [];else customerList = _this15.model.billableCustomerObj.customerList;

        var classesToAdd = ['glyphicon', 'glyphicon-refresh', 'fast-right-spinner'];
        (_document$getElementB = document.getElementById('export-btn-loading-' + currentStat).classList).add.apply(_document$getElementB, classesToAdd);
        document.getElementById('export-btn-' + currentStat).classList.add('disabled');

        return _this15.BillingRecordsService.exportBillingReport(startDate, endDate, _this15.model.currentStats, customerList, _this15.model.currentUnassignedStat, _this15.model.searchText, branches, billingEventsId, billingCategoryId, customerId).then(function () {}).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this15.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          var _document$getElementB2;

          (_document$getElementB2 = document.getElementById('export-btn-loading-' + currentStat).classList).remove.apply(_document$getElementB2, classesToAdd);
          document.getElementById('export-btn-' + currentStat).classList.remove('disabled');
        });
      }, 100);
    }
  }, {
    key: 'isAllowToTestStaticBill',
    value: function isAllowToTestStaticBill() {
      var firstName = this.User.getUser().firstName;
      var lastName = this.User.getUser().lastName;
      var userId = this.User.getUser().id;
      return (firstName.toUpperCase() === 'COORWORKS' && lastName.toUpperCase() === 'ADMIN' || lastName.toUpperCase() === 'COORWORKS' && firstName.toUpperCase() === 'ADMIN' && userId === 1000) && this.model.currentStats === this.model.stats.pending;
    }
  }, {
    key: 'generateStaticBillingRecord',
    value: function generateStaticBillingRecord(type) {
      var _this16 = this;

      this.model.generatingStaticBillingRecord[type] = { status: true };

      this.BillingRecordsService.generateStaticBillingRecord(type).then(function () {
        _this16.loadData();
      }).catch(function (err) {
        _this16.Modal.errorModal(err.data.message);
      }).finally(function () {
        _this16.model.generatingStaticBillingRecord[type] = { status: false };
      });
    }
  }, {
    key: 'updateCustomerNotAssignBillingRecords',
    value: function updateCustomerNotAssignBillingRecords(billingRecordsObj) {
      var _this17 = this;

      this.model.billingRecordsObj.loading = true;
      var startDate = this.getStartDate();
      var endDate = this.getEndDate();

      this.Modal.updateBillingRecords(billingRecordsObj, this.model.currentStats, function (_ref9) {
        var modal = _ref9.modal,
            locationId = _ref9.locationId,
            customerId = _ref9.customerId,
            billingCategory = _ref9.billingCategory,
            billingType = _ref9.billingType,
            amount = _ref9.amount,
            amountDue = _ref9.amountDue,
            isApproved = _ref9.isApproved,
            userId = _ref9.userId,
            $scope = _ref9.$scope;


        _this17.BillingRecordsService.updateBillingRecords(billingRecordsObj.billingRecordId, amount || null, amountDue || null, billingRecordsObj.branchId, billingCategory, billingType, locationId, customerId, _this17.model.currentStats, startDate, endDate, isApproved, userId, null, null, null, null, $scope.model.billableEventId, $scope.model.billableEvent).then(function () {
          _this17.billableCustomer();
          _this17.getUnassignedCustomerBillingRecords();
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this17.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          modal.close();
          _this17.model.billingRecordsObj.loading = false;
          $scope.isLoading = false;
        });
      }, function (_ref10) {
        var modal = _ref10.modal;

        if (modal) modal.close();
        _this17.model.billingRecordsObj.loading = false;
      });
    }
  }, {
    key: 'serviceOrderNotes',
    value: function serviceOrderNotes(data) {
      var _this18 = this;

      var vaultDate = this.DateUtil.getUTCDate(data.branchCurrentVaultDate);

      this.Modal.serviceOrderNotes(data, function (_ref11) {
        var modal = _ref11.modal,
            serviceOrderUserNote = _ref11.serviceOrderUserNote,
            serviceOrderNote = _ref11.serviceOrderNote;

        _this18.ServiceOrderService.updateServiceOrderNote(data.encounterId, data.serviceOrderId, data.branchId, serviceOrderUserNote, serviceOrderNote, vaultDate, data.routeId, data.statusCode).then(function () {
          modal.close();
          data.serviceOrderUserNote = serviceOrderUserNote;
          data.serviceOrderNote = serviceOrderNote;
        }).catch(function (err) {
          console.log(err);
          if (err && err.data && err.data.message) {
            _this18.Modal.errorModal(err.data.message);
          }
        });
      });
    }
  }, {
    key: 'selectNone',
    value: function selectNone() {
      var _this19 = this;

      if (this.model.selectedBranch && this.model.selectedBranch.length) {
        this.model.selectedBranch.forEach(function (branch) {
          branch.ticked = false;
        });
        setTimeout(function () {
          _this19.loadUnassignedTabRecords();
        });
      }
    }
  }, {
    key: 'resetSelectedBranch',
    value: function resetSelectedBranch() {
      var _this20 = this;

      if (this.model.userBranchList && this.model.userBranchList.length) {
        this.model.userBranchList.forEach(function (branch) {
          branch.ticked = false;
        });
        this.model.selectedBranch.forEach(function (branch) {
          branch.ticked = false;
        });
        setTimeout(function () {
          _this20.loadUnassignedTabRecords();
        });
      }
    }
  }, {
    key: 'loadUnassignedTabRecords',
    value: function loadUnassignedTabRecords() {
      if (this.model.currentStats === this.model.stats.unassigned) {
        if (this.model.currentUnassignedStat === this.model.unassignedStats.customerNotAssigned) {
          this.model.unAssignedCustomersBillingRecordsObj.pagination.page = 1;
          this.getUnassignedCustomerBillingRecords();
        } else {
          this.model.billableCustomerObj.pagination.page = 1;
          this.filterRecords();
        }
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      if (this.model.userBranchList && this.model.userBranchList.length) {
        this.model.userBranchList.forEach(function (branch) {
          branch.ticked = false;
        });
      }

      if (this.model.selectedBranch && this.model.selectedBranch.length) {
        this.model.selectedBranch.forEach(function (branch) {
          branch.ticked = false;
        });
      }

      this.model.searchText = null;
      this.model.billingEvents = null;
      this.model.billingCategory = null;
    }
  }, {
    key: 'getBillingEventsList',
    value: function getBillingEventsList(searchKey, offset) {
      var _this21 = this;

      searchKey = searchKey || '';

      var billingEventSearchObj = {
        queryJSON: {
          rules: [{
            group: {
              rules: [{
                field: 'type',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      this.model.billingEventListObj.loading = true;
      this.BillableEventsService.all(billingEventSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this21.model.billingEventListObj.totalRecords = data.total;
          _this21.model.billingEventListObj.results = _this21.billingEventsMap(data.results);
        } else {
          var results = _this21.billingEventsMap(data.results);
          _this21.model.billingEventListObj.results = _this21.model.billingEventListObj.results.concat(results);
        }
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this21.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this21.model.billingEventListObj.loading = false;
      });
    }
  }, {
    key: 'billingEventsMap',
    value: function billingEventsMap(events) {
      var _this22 = this;

      return events.map(function (data) {
        return {
          Key: _this22.$translate.instant('entry_type.' + data.type),
          Value: data.id
        };
      });
    }
  }, {
    key: 'filterRecords',
    value: function filterRecords() {
      var _this23 = this;

      setTimeout(function () {
        _this23.model.filterRecords = true;
        var branches = null,
            billingEventsId = null,
            searchText = null,
            billingCategoryId = null,
            customer = null;

        if (_this23.model.currentStats == 'unassigned' && _this23.model.selectedBranch) {
          branches = _this23.model.selectedBranch.map(function (branchObj) {
            return branchObj.branchId;
          });
          billingEventsId = _this23.model.billingEvents ? _this23.model.billingEvents.Value : null;
          searchText = _this23.model.searchText;
          billingCategoryId = _this23.model.billingCategory ? _this23.model.billingCategory.Value : null;
          customer = _this23.model.customerId ? _this23.model.customerId.Value : null;
        }

        var startDate = _this23.getStartDate();
        var endDate = _this23.getEndDate();

        _this23.BillingRecordsService.getBillableCustomer(searchText, _this23.model.currentStats, (_this23.model.billableCustomerObj.pagination.page - 1) * _this23.model.billableCustomerObj.pagination.pageLimit, _this23.model.billableCustomerObj.pagination.pageLimit, startDate, endDate, branches, billingEventsId, billingCategoryId, customer).then(function (data) {
          _this23.model.billableCustomerObj.results = data.results;
          _this23.model.billableCustomerObj.totalPendingAmount = data.totalPendingAmount;
          _this23.model.billableCustomerObj.totalPendingRecords = data.totalPendingRecords;
          _this23.model.billableCustomerObj.totalApprovedAmount = data.totalApprovedAmount;
          _this23.model.billableCustomerObj.totalApprovedRecords = data.totalApprovedRecords;
          _this23.model.billableCustomerObj.totalUnassignedAmount = data.totalUnassignedAmount;
          _this23.model.rejectedBillingRecordsObj.totalRecords = data.totalDeletedRecords;
          _this23.model.rejectedBillingRecordsObj.totalAmount = data.totalDeletedAmount;
          // this.model.billableCustomerObj.totalUnassignedRecords = data.totalUnassignedRecords;
          _this23.model.billableCustomerObj.customerAssignedTotalRecords = data.customerAssignedTotalRecords;
          _this23.model.billableCustomerObj.customerList = data.customerList;
          _this23.model.unassignedCustomerObj.totalUnAssignedBillableCustomers = data.totalUnAssignedBillableCustomers;
          _this23.model.pendingCustomerObj.totalPendingBillableCustomers = data.totalPendingBillableCustomers;
          _this23.model.approvedCustomerObj.totalApprovedBillablecustomers = data.totalApprovedBillablecustomers;
          _this23.applySurchargeTotals(_this23.model.billableCustomerObj.results, data);
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this23.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          _this23.model.filterRecords = false;
        });
      });
    }
  }, {
    key: 'applySurchargeTotals',
    value: function applySurchargeTotals(results, data) {
      var _this24 = this;

      this.model.hasStoredSurcharge = (results || []).some(function (customer) {
        return Number(customer.storedSurcharge) > 0;
      });

      if (!results || results.length === 0) {
        this.model.hasActiveSurcharge = false;
        return this.$q.resolve();
      }

      var customerIds = results.map(function (customer) {
        return customer.customerId;
      });
      var eventAmounts = data && data.eventAmounts || [];
      var periods = data && data.surchargePeriods || {};
      var cutoffs = data && data.surchargeCutoffs || {};
      var monthPeriod = periods.MONTHLY || null;
      var chargeOnTheseRecords = this.model.currentStats === this.model.stats.approved;

      this.model.surchargePeriodLabel = this.formatSurchargePeriod(periods.MONTHLY);
      this.model.surchargeFilterAligned = !data || data.surchargeFilterAligned !== false;

      return this.CustomerService.getSurchargeConfigBulk(customerIds).then(function (surchargeConfigByCustomer) {
        _this24.model.surchargeConfigByCustomer = surchargeConfigByCustomer;
        var eventAmountsByCustomer = {};
        eventAmounts.forEach(function (row) {
          eventAmountsByCustomer[row.customerId] = eventAmountsByCustomer[row.customerId] || {};
          var byEvent = eventAmountsByCustomer[row.customerId];
          byEvent[row.billableEventId] = byEvent[row.billableEventId] || {};
          byEvent[row.billableEventId][row.periodKey] = {
            amount: Number(row.amount) || 0,
            filterAmount: Number(row.filterAmount) || 0
          };
        });

        var hasActiveSurcharge = false;

        results.forEach(function (customer) {
          var customerEventAmounts = eventAmountsByCustomer[customer.customerId] || {};
          var customerSurcharges = surchargeConfigByCustomer[customer.customerId] || {};
          var surchargeBreakdown = [];
          var totalSurcharge = 0;
          var totalPeriodSurcharge = 0;
          var widerWindowStart = null;

          _this24.surchargeTypes.forEach(function (type) {
            var typeConfig = customerSurcharges[type];
            if (!typeConfig || !typeConfig.enabled) return;

            hasActiveSurcharge = true;

            var interval = typeConfig.interval || 'MONTHLY';
            var cutoff = cutoffs[interval] || cutoffs.MONTHLY || null;
            var period = periods[interval] || periods.MONTHLY || null;

            var base = (typeConfig.billableEventIds || []).reduce(function (acc, billableEventId) {
              var buckets = customerEventAmounts[billableEventId] || {};
              (0, _keys2.default)(buckets).forEach(function (monthKey) {
                acc.filter += buckets[monthKey].filterAmount;
                if (_this24.isMonthInSurchargePeriod(monthKey, period)) acc.period += buckets[monthKey].amount;
              });
              return acc;
            }, { filter: 0, period: 0 });

            var percentage = Number(typeConfig.percentage) || 0;
            var amount = base.filter * percentage / 100;
            var periodAmount = base.period * percentage / 100;

            if (period && monthPeriod && period.start < monthPeriod.start && (!widerWindowStart || period.start < widerWindowStart)) {
              widerWindowStart = period.start;
            }

            surchargeBreakdown.push({
              type: type,
              labelKey: _this24.surchargeLabelKeys[type],
              percentage: typeConfig.percentage,
              interval: interval,
              intervalLabelKey: _this24.surchargeIntervalLabelKeys[interval] || '',
              period: period,
              periodLabel: _this24.formatSurchargePeriod(period),
              cutoff: cutoff,
              cutoffLabel: cutoff ? moment(cutoff.date).format('DD-MMM-YYYY') : '',
              coverageLabel: period && cutoff ? _this24.formatSurchargePeriod({ start: period.start, end: cutoff.date }) : '',
              isFinal: !!(cutoff && cutoff.isFinal),
              amount: amount,
              periodBase: base.period,
              periodAmount: periodAmount,
              displayAmount: chargeOnTheseRecords ? amount : periodAmount
            });
            totalSurcharge += amount;
            totalPeriodSurcharge += periodAmount;
          });

          customer.surchargeBreakdown = surchargeBreakdown;
          customer.widerSurchargeWindowStart = widerWindowStart ? moment(widerWindowStart).format('DD-MMM-YYYY') : null;
          customer.totalRecordSurcharge = totalSurcharge;
          customer.totalPeriodSurcharge = totalPeriodSurcharge;
          customer.totalSurcharge = chargeOnTheseRecords ? totalSurcharge : totalPeriodSurcharge;
          customer.totalPending = (Number(customer.totalAmount) || 0) + customer.totalSurcharge;
        });

        _this24.model.hasActiveSurcharge = hasActiveSurcharge;
      }).catch(function () {
        _this24.model.hasActiveSurcharge = false;
      });
    }
  }, {
    key: 'isMonthInSurchargePeriod',
    value: function isMonthInSurchargePeriod(monthKey, period) {
      if (!monthKey || !period || !period.start || !period.end) return false;
      return monthKey >= period.start && monthKey <= period.end;
    }
  }, {
    key: 'isSurchargeAffected',
    value: function isSurchargeAffected(billingRecordsObj) {
      if (!billingRecordsObj) return false;
      var customerSurcharges = (this.model.surchargeConfigByCustomer || {})[billingRecordsObj.customerId] || {};

      return this.surchargeTypes.some(function (type) {
        var typeConfig = customerSurcharges[type];
        return !!typeConfig && typeConfig.enabled && (typeConfig.billableEventIds || []).indexOf(billingRecordsObj.billableEventId) !== -1;
      });
    }
  }, {
    key: 'formatSurchargePeriod',
    value: function formatSurchargePeriod(period) {
      if (!period || !period.start || !period.end) return '';
      return moment(period.start).format('DD-MMM-YYYY') + ' - ' + moment(period.end).format('DD-MMM-YYYY');
    }
  }, {
    key: 'showStoredSurchargeDetails',
    value: function showStoredSurchargeDetails(customer) {
      var modal = this.Modal.storedSurchargeDetails({ customer: customer, labelKeys: this.surchargeLabelKeys });

      if (modal && modal.result) {
        modal.result.finally(function () {
          setTimeout(function () {
            if (document.activeElement && document.activeElement.blur) {
              document.activeElement.blur();
            }
          });
        });
      }
    }
  }, {
    key: 'showSurchargeDetails',
    value: function showSurchargeDetails(customer) {
      var modal = this.Modal.surchargeDetails({
        customer: customer,
        periodLabel: this.model.surchargePeriodLabel,
        filterAligned: this.model.surchargeFilterAligned,
        onTheseRecords: this.model.currentStats === this.model.stats.approved
      });

      if (modal && modal.result) {
        modal.result.finally(function () {
          setTimeout(function () {
            if (document.activeElement && document.activeElement.blur) {
              document.activeElement.blur();
            }
          });
        });
      }
    }
  }, {
    key: 'setStaticBillingEventsRecordsPage',
    value: function setStaticBillingEventsRecordsPage(isExpanded, billingRecordId) {
      if (!isExpanded) return;
      this.model.staticBillingEventRecordsObj.billingHistory[billingRecordId] = { page: 1 };
    }
  }, {
    key: 'getStaticBillingEventsRecords',
    value: function getStaticBillingEventsRecords(data, staticBillingCategory) {
      var _this25 = this;

      document.getElementById('expand-btn-' + data.billingRecordId).blur();

      if (!data.expanded) return;

      staticBillingCategory = staticBillingCategory === 'pre-bill' ? 'PRE_BILL' : 'POST_BILL';
      this.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].process = true;

      this.BillingRecordsService.getStaticBillingEventsRecords(staticBillingCategory, data.vaultDate, data.customerContractId, data.contractRuleId, data.locationId, this.model.staticBillingEventRecordsObj.pagination.pageLimit, (this.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].page - 1) * this.model.staticBillingEventRecordsObj.pagination.pageLimit, this.model.currentStats).then(function (history) {
        _this25.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].details = history;
        _this25.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].details.pageLimit = _this25.model.staticBillingEventRecordsObj.pagination.pageLimit;
        _this25.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].details.results.forEach(function (record) {
          if (record.billingCategory) {
            record.billingCategoryObj = {};
            record.billingCategoryObj.Key = record.billingCategory;
          }
        });
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this25.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this25.model.staticBillingEventRecordsObj.billingHistory[data.billingRecordId].process = false;
      });
    }
  }, {
    key: 'getCustomerList',
    value: function getCustomerList(searchKey, offset) {
      var _this26 = this;

      searchKey = searchKey || '';

      var customerSearchObj = {
        queryJSON: {
          rules: [{
            field: 'isEnabled',
            condition: '=',
            data: true
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      if (this.isCustomerUser) {
        customerSearchObj.queryJSON.rules.push({
          field: 'id',
          condition: '=',
          data: this.User.getUser().customerId
        });
      }

      this.model.customerListObj.loading = true;
      return this.CustomerService.all(customerSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        _this26.model.customerListObj.loading = true;
        if (offset === 0 || offset == undefined) {
          _this26.model.customerListObj.totalRecords = data.total;
          _this26.model.customerListObj.results = _this26.customerMapping(data.results);
        } else {
          var customers = _this26.customerMapping(data.results);
          _this26.model.customerListObj.results = _this26.model.customerListObj.results.concat(customers);
        }

        if (_this26.isCustomerUser) {
          _this26.model.customerId = _this26.model.customerListObj.results[0];
        }
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this26.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this26.model.customerListObj.loading = false;
      });
    }
  }, {
    key: 'customerMapping',
    value: function customerMapping(customers) {
      return customers.map(function (customer) {
        return {
          Key: customer.id + ' | ' + customer.name,
          Value: customer.id
        };
      });
    }
  }, {
    key: 'getRejectedRecords',
    value: function getRejectedRecords() {
      var _this27 = this;

      setTimeout(function () {
        var billingCategoryId = void 0;
        _this27.model.rejectedBillingRecordsObj.loading = true;
        var startDate = _this27.getStartDate();
        var endDate = _this27.getEndDate();
        var customer = _this27.model.customerId ? _this27.model.customerId.Value : null;
        billingCategoryId = _this27.model.billingCategory ? _this27.model.billingCategory.Value : null;

        _this27.BillingRecordsService.getBillingRecords(_this27.model.searchText, customer, _this27.reverseSort, _this27.sortColumn, _this27.model.currentStats, (_this27.model.rejectedBillingRecordsObj.pagination.page - 1) * _this27.model.rejectedBillingRecordsObj.pagination.pageLimit, _this27.model.rejectedBillingRecordsObj.pagination.pageLimit, startDate, endDate, [], null, billingCategoryId).then(function (history) {
          _this27.model.rejectedBillingRecordsObj.records = history.results;
          _this27.model.rejectedBillingRecordsObj.totalRecords = history.totalRecords;
          _this27.model.rejectedBillingRecordsObj.totalAmount = history.totalDeletedAmount;

          _this27.model.billableCustomerObj.totalPendingAmount = history.totalPendingAmount;
          _this27.model.billableCustomerObj.totalPendingRecords = history.totalPendingRecords;
          _this27.model.billableCustomerObj.totalApprovedAmount = history.totalApprovedAmount;
          _this27.model.billableCustomerObj.totalApprovedRecords = history.totalApprovedRecords;
          _this27.model.billableCustomerObj.totalUnassignedAmount = history.totalUnassignedAmount;
          _this27.model.billableCustomerObj.customerAssignedTotalRecords = history.totalUnassignedRecords;
          _this27.model.billableCustomerObj.totalReviewAmount = history.totalReviewAmount;
          _this27.model.billableCustomerObj.totalReviewRecords = history.totalReviewRecords;

          _this27.model.rejectedBillingRecordsObj.records.forEach(function (record) {
            if (record.billingCategory) {
              record.billingCategoryObj = {};
              record.billingCategoryObj.Key = record.billingCategory;
            }
          });
        }).catch(function (err) {
          console.log(err);
          if (err && err.data && err.data.message) {
            _this27.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          _this27.model.rejectedBillingRecordsObj.loading = false;
        });
      }, 200);
    }
  }, {
    key: 'sortRejectedBillingRecords',
    value: function sortRejectedBillingRecords(column) {
      this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
      this.sortColumn = column;
      this.getRejectedRecords();
    }
  }, {
    key: 'exportRejectedBillingRecords',
    value: function exportRejectedBillingRecords() {
      this.model.currentUnassignedStat = null;
      this.exportBillingRecords();
    }
  }, {
    key: 'postBillingRecordModal',
    value: function postBillingRecordModal(type) {
      var _this28 = this;

      this.Modal.postBillingRecord(function (_ref12) {
        var modal = _ref12.modal,
            month = _ref12.month,
            contractId = _ref12.contractId,
            $scope = _ref12.$scope;

        $scope.isLoading = true;
        _this28.BillingRecordsService.createPostBillingRecords(month, contractId).then(function () {
          modal.close();
          _this28.loadData();
        }).catch(function (err) {
          _this28.Modal.errorModal(err.data.message);
        }).finally(function () {
          $scope.isLoading = false;
        });
      }, function (_ref13) {
        var modal = _ref13.modal;

        modal.close();
      });
    }
  }, {
    key: 'undoApprovedBillingRecords',
    value: function undoApprovedBillingRecords(billingRecordsObj, status, customer) {
      var _this29 = this;

      this.undoApprovedBillingRecordsObj[billingRecordsObj.billingRecordId] = { loading: true };

      var description = this.$translate.instant('branch_mgmt.billing_approval.unapprove_message');

      if (billingRecordsObj.type !== 'MANUAL') {
        description = description.concat(' ', this.$translate.instant('branch_mgmt.billing_approval.unapprove_static_note'));
      }

      if (this.isSurchargeAffected(billingRecordsObj)) {
        description = description.concat(' ', this.$translate.instant('branch_mgmt.billing_approval.unapprove_surcharge_warning'));
      }

      this.Modal.confirm({
        header: this.$translate.instant('branch_mgmt.billing_approval.unapprove_title'),
        message: description,
        callback: function callback(_ref14) {
          var modal = _ref14.modal,
              $scope = _ref14.$scope;

          $scope.loading = true;
          var data = {
            billingRecordId: billingRecordsObj.billingRecordId,
            rate: billingRecordsObj.rate,
            branchId: billingRecordsObj.branchId,
            billingCategory: billingRecordsObj.billingCategory,
            billingType: billingRecordsObj.billingType,
            amountDue: billingRecordsObj.amountDue,
            status: status,
            customerId: billingRecordsObj.customerId,
            locationId: billingRecordsObj.locationId,
            startDate: _this29.getStartDate(),
            endDate: _this29.getEndDate(),
            userId: _this29.model.loggedInUser,
            contractId: billingRecordsObj.customerContractId,
            contractRuleId: billingRecordsObj.contractRuleId,
            vaultDate: billingRecordsObj.vaultDate
          };

          _this29.BillingRecordsService.undoApproveBillingRecords(data).then(function () {
            modal.close();
            _this29.billableCustomer();
          }).catch(function (err) {
            if (err && err.data && err.data.message) {
              _this29.Modal.errorModal(err.data.message);
            } else {
              _this29.Modal.errorModal(err);
            }
          }).finally(function () {
            _this29.undoApprovedBillingRecordsObj[billingRecordsObj.billingRecordId].loading = false;
          });
        },
        negative: function negative(_ref15) {
          var modal = _ref15.modal;

          modal.close();
          _this29.undoApprovedBillingRecordsObj[billingRecordsObj.billingRecordId].loading = false;
        },
        type: 'danger'
      });
    }
  }, {
    key: 'createBillingRecords',
    value: function createBillingRecords() {
      var _this30 = this;

      this.Modal.createBillingRecords(function (_ref16) {
        var modal = _ref16.modal,
            billingStatus = _ref16.billingStatus,
            vaultDate = _ref16.vaultDate,
            rate = _ref16.rate,
            amountDue = _ref16.amountDue,
            billableEventId = _ref16.billableEventId,
            billingCategory = _ref16.billingCategory,
            billingType = _ref16.billingType,
            scheduleType = _ref16.scheduleType,
            locationId = _ref16.locationId,
            branchId = _ref16.branchId,
            customerContractId = _ref16.customerContractId,
            contract = _ref16.contract,
            customerId = _ref16.customerId,
            contractRuleId = _ref16.contractRuleId,
            contractRule = _ref16.contractRule,
            $scope = _ref16.$scope;

        var data = { billingStatus: billingStatus, vaultDate: vaultDate, rate: rate, amountDue: amountDue, billableEventId: billableEventId, billingCategory: billingCategory, billingType: billingType, scheduleType: scheduleType, locationId: locationId, branchId: branchId, customerContractId: customerContractId, contract: contract, customerId: customerId, contractRuleId: contractRuleId, contractRule: contractRule };
        _this30.BillingRecordsService.createBillingRecords(data).then(function () {
          modal.close();
          _this30.loadData();
        }).catch(function (err) {
          _this30.Modal.errorModal(err.data.message);
        }).finally(function () {
          $scope.isLoading = false;
        });
      }, function (_ref17) {
        var modal = _ref17.modal;

        modal.close();
      });
    }
  }, {
    key: 'manuallyCreatedBillingRecordsLog',
    value: function manuallyCreatedBillingRecordsLog(billingRecordsObj) {
      var obj = { billingRecordId: billingRecordsObj.billingRecordId, recordType: 'MANUAL', searchText: billingRecordsObj.billingRecordId };

      this.Modal.billableEventLogDetails(obj, function (_ref18) {
        var modal = _ref18.modal;

        modal.close();
      }, function (_ref19) {
        var modal = _ref19.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'coinConversionBillingRecordsLog',
    value: function coinConversionBillingRecordsLog(billingRecordsObj) {
      var obj = {
        recordType: 'MANUAL',
        searchText: billingRecordsObj.billingRecordId,
        billingRecordId: billingRecordsObj.billingRecordId,
        branchId: billingRecordsObj.branchId,
        billableEvent: billingRecordsObj.billableEventType,
        createdAt: billingRecordsObj.createdAt,
        startDate: moment.utc(billingRecordsObj.createdAt).format('YYYY-MM-DD 00:00:00'),
        endDate: moment.utc(billingRecordsObj.createdAt).add(1, 'days').format('YYYY-MM-DD 23:59:59'),
        customerContractId: billingRecordsObj.customerContractId,
        contractName: billingRecordsObj.contractName,
        contractRuleName: billingRecordsObj.contractRuleName,
        locationId: billingRecordsObj.locationId,
        vaultDate: billingRecordsObj.vaultDate
      };

      this.Modal.billableEventLogDetails(obj, function (_ref20) {
        var modal = _ref20.modal;

        modal.close();
      }, function (_ref21) {
        var modal = _ref21.modal;

        if (modal) modal.close();
      });
    }
  }]);
  return BillingApprovalController;
}();

exports.default = BillingApprovalController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _billing_approval = __webpack_require__(1696);

var _billing_approval2 = _interopRequireDefault(_billing_approval);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementBillingApprovalModule = angular.module('branchManagementBillingApproval', []).component('branchManagementBillingApproval', _billing_approval2.default).name;

exports.default = branchManagementBillingApprovalModule;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bin_manifest = __webpack_require__(2667);

var _bin_manifest2 = _interopRequireDefault(_bin_manifest);

var _bin_manifest3 = __webpack_require__(1700);

var _bin_manifest4 = _interopRequireDefault(_bin_manifest3);

__webpack_require__(2952);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementBinManifestComponent = {
  restrict: "E",
  bindings: {},
  template: _bin_manifest2.default,
  controller: _bin_manifest4.default
};

exports.default = branchManagementBinManifestComponent;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BinManifestController = function () {
  /*@ngInject*/
  function BinManifestController() {
    (0, _classCallCheck3.default)(this, BinManifestController);
  }

  (0, _createClass3.default)(BinManifestController, [{
    key: "$onInit",
    value: function $onInit() {}
  }]);
  return BinManifestController;
}();

exports.default = BinManifestController;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bin_manifest = __webpack_require__(1699);

var _bin_manifest2 = _interopRequireDefault(_bin_manifest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementBinManifestModule = angular.module('branchManagementBinManifest', []).component('branchManagementBinManifest', _bin_manifest2.default).name;

exports.default = branchManagementBinManifestModule;

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _branch_performance = __webpack_require__(2668);

var _branch_performance2 = _interopRequireDefault(_branch_performance);

var _branch_performance3 = __webpack_require__(1703);

var _branch_performance4 = _interopRequireDefault(_branch_performance3);

__webpack_require__(2953);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementBranchPerformanceComponent = {
    restrict: "E",
    binding: {},
    template: _branch_performance2.default,
    controller: _branch_performance4.default
};

exports.default = branchManagementBranchPerformanceComponent;

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _d3Selection = __webpack_require__(377);

var _stackedBarMin = __webpack_require__(654);

var _stackedBarMin2 = _interopRequireDefault(_stackedBarMin);

__webpack_require__(532);

var _miniTooltip = __webpack_require__(653);

var _miniTooltip2 = _interopRequireDefault(_miniTooltip);

var _tooltip = __webpack_require__(318);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _donutMin = __webpack_require__(651);

var _donutMin2 = _interopRequireDefault(_donutMin);

var _legendMin = __webpack_require__(652);

var _legendMin2 = _interopRequireDefault(_legendMin);

var _barMin = __webpack_require__(650);

var _barMin2 = _interopRequireDefault(_barMin);

var _lineMin = __webpack_require__(317);

var _lineMin2 = _interopRequireDefault(_lineMin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchPerformanceController = function () {
  /*@ngInject*/
  BranchPerformanceController.$inject = ["Auth", "User", "UserBranchService", "$q", "$translate", "RouteService", "BranchPerformanceService", "$filter", "ReportService", "$rootScope"];
  function BranchPerformanceController(Auth, User, UserBranchService, $q, $translate, RouteService, BranchPerformanceService, $filter, ReportService, $rootScope) {
    (0, _classCallCheck3.default)(this, BranchPerformanceController);

    this.Auth = Auth;
    this.User = User;
    this.UserBranchService = UserBranchService;
    this.$q = $q;
    this.$translate = $translate;
    this.RouteService = RouteService;
    this.BranchPerformanceService = BranchPerformanceService;
    this.$filter = $filter;
    this.ReportService = ReportService;
    this.$rootScope = $rootScope;
    this.model = {
      stats: 'branch',
      tab: 'routes',
      dateRangeOption: {
        startDate: null,
        endDate: null
      },
      dateRangPickerOptions: {},
      dateRangPickerOptionsfor: {},
      loggedInUser: User.getUser().id,
      userBranchList: [],
      selectedBranch: '',
      totalBranches: 0,
      totalRoutes: 0,
      routeList: [],
      messenger: '',
      messengerList: [],
      totalMessenger: 0,
      loadRouteList: false,
      selectedRouteType: null,
      selectedOrderType: null,
      selectedAccount: null,
      selectedOrderStatus: null,
      gettingRouteStat: false,
      routeStats: {},
      gettingRoutePerformanceStat: false,
      actionCodes: [],
      selectedServiceStatus: null,
      selectedActionCode: null,
      currentBranch: this.User.getUser().branchId,
      gettingRouteLocationStat: false
    };

    this.stats = {
      branch: 'branch',
      all: 'all'
    };

    this.tabs = {
      routes: 'routes',
      orders: 'orders',
      services: 'services'
    };

    this.localLang = {
      selectAll: this.$translate.instant('common.selectall'),
      selectNone: this.$translate.instant('common.selectnone'),
      reset: this.$translate.instant('shipmentBatch.reset'),
      search: this.$translate.instant('common.search'),
      nothingSelected: this.$translate.instant('branch.all_branches') //default-label is deprecated and replaced with this.
    };

    this.allRouteTypes = [{
      key: 'Regular Routes',
      value: false
    }, {
      key: 'Event Routes',
      value: true
    }];

    this.allAccounts = [{
      key: 'Regular',
      value: 'regular'
    }, {
      key: 'Emergency',
      value: 'emergency'
    }];

    this.allOrderTypes = [{
      key: 'Adds',
      value: 'A'
    }, {
      key: 'Swaps',
      value: 'S'
    }, {
      key: 'ICLs',
      value: 'I'
    }, {
      key: 'CCLs',
      value: 'C'
    }, {
      key: 'Recashes',
      value: 'R'
    }, {
      key: 'Permanent Decash',
      value: 'P'
    }, {
      key: 'Temp Decash',
      value: 'T'
    }];

    this.allOrderStatuses = [{
      key: 'Loaded',
      value: 'loaded'
    }, {
      key: 'CRVed',
      value: 'CRVed'
    }, {
      key: 'Short-Loaded',
      value: 'shortLoaded'
    }, {
      key: 'Cancelled',
      value: 'cancelled'
    }, {
      key: 'Deleted (not CRV deleted)',
      value: 'deleted'
    }];

    this.allServiceStatuses = [{
      key: 'Unassigned',
      value: 'unassigned'
    }, {
      key: 'Pending Route Assign',
      value: 'pendingRouteAssign'
    }, {
      key: 'Assigned',
      value: 'ASSIGNED'
    }, {
      key: 'On Route',
      value: 'ON_ROUTE'
    }, {
      key: 'On Site',
      value: 'ON_SITE'
    }, {
      key: 'Hold',
      value: 'HOLD'
    }, {
      key: 'Hold Parts',
      value: 'HOLD_PARTS'
    }, {
      key: 'Completed',
      value: 'COMPLETE'
    }, {
      key: 'Cancelled',
      value: 'CANCELLED'
    }];

    this.intervalList = [{
      key: 'Min',
      value: 'min'
    }, {
      key: 'Minute',
      value: 'minute'
    }, {
      key: 'Hour',
      value: 'hour'
    }, {
      key: 'Hourly',
      value: 'hourly'
    }, {
      key: 'Day',
      value: 'day'
    }, {
      key: 'Daily',
      value: 'daily'
    }, {
      key: 'Week',
      value: 'week'
    }, {
      key: 'Weekly',
      value: 'weekly'
    }, {
      key: 'Month',
      value: 'month'
    }, {
      key: 'Monthly',
      value: 'monthly'
    }, {
      key: 'Year',
      value: 'year'
    }, {
      key: 'Yearly',
      value: 'yearly'
    }];

    this.donutChartDataObj = {};
    this.barChartDataObj = {};
    this.routeList = [];
    this.vehicleList = [];
    this.messengerList = [];
    this.bucketObj = {
      routePerformance: {
        bucketExpanded: true
      },
      routeLocationPerformance: {
        bucketExpanded: true
      },
      ledgerActivityReport: {
        bucketExpanded: true
      },
      loadCompletedActivity: {
        bucketExpanded: true
      },
      residualCompletedActivity: {
        bucketExpanded: true
      },
      deliveryCompletedActivity: {
        bucketExpanded: true
      },
      pickupCompletedActivity: {
        bucketExpanded: true
      },
      bagoutCompletedActivity: {
        bucketExpanded: true
      },
      serviceOrderCompletedActivity: {
        bucketExpanded: true
      },
      serviceOrderCancelledActivity: {
        bucketExpanded: true
      }
    };

    this.ordersGraphList = [{
      label: 'Ledger Activity Report',
      value: 'ledgerActivityReport',
      results: [],
      loading: false
    }, {
      label: 'Load Completed Activity',
      value: 'loadCompletedActivity',
      results: [],
      loading: false
    }, {
      label: 'Residual Completed Activity',
      value: 'residualCompletedActivity',
      results: [],
      loading: false
    }, {
      label: 'Delivery Completed Activity',
      value: 'deliveryCompletedActivity',
      results: [],
      loading: false
    }, {
      label: 'Pickup Completed Activity',
      value: 'pickupCompletedActivity',
      results: [],
      loading: false
    }, {
      label: 'Bagout Completed Activity',
      value: 'bagoutCompletedActivity',
      results: [],
      loading: false
    }];

    this.serviceOrdersGraphList = [{
      label: 'Service Order Completed Activity',
      value: 'serviceOrderCompletedActivity',
      results: [],
      loading: false
    }, {
      label: 'Service Order Cancelled Activity',
      value: 'serviceOrderCancelledActivity',
      results: [],
      loading: false
    }];
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/branch-performance');
  }

  (0, _createClass3.default)(BranchPerformanceController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.loadUserBranches('', 0).then(function (data) {
        _this.setDateRangeOptions(_this.currentVaultDate, 'dateRangPickerOptionsfor');
        _this.model.dateRangeOption.startDate = moment(_this.currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss');
        _this.model.dateRangeOption.endDate = moment(_this.currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss');
        // this.getRouteMessenger('', 0);
        _this.loadData();
        // this.createLineChart();
      });
    }
  }, {
    key: 'createDonutChart',
    value: function createDonutChart() {
      var _this2 = this;

      setTimeout(function () {
        _this2.donutChartDataObj.extraInfo.graphList.forEach(function (obj, index) {
          var selector = '.js-donut-chart-container-' + obj.value;
          var donut = (0, _donutMin2.default)(),
              donutContainer = (0, _d3Selection.select)(selector),
              containerWidth = donutContainer.node() ? donutContainer.node().getBoundingClientRect().width : false,
              legendChart = (0, _legendMin2.default)(),
              legendContainer = void 0,
              legendChartHeight = _this2.model.tab === 'routes' ? 100 : 170;

          if (containerWidth) {
            var dataset = _this2.donutChartDataObj[obj.value];

            donut.isAnimated(true).highlightSliceById(1)
            // .emptyDataConfig({ showEmptySlice: true, emptySliceColor: 'rgb(57 194 201)' })
            .hasFixedHighlightedSlice(true).width(containerWidth).height(containerWidth / 1.2).externalRadius(containerWidth / 2.5).internalRadius(containerWidth / 5).percentageFormat('.1f').on('customMouseOver', function (data) {
              legendChart.highlight(data.data.id);
            }).on('customMouseOut', function () {
              // legendChart.highlight(1);
              legendChart.clearHighlight();
            });

            donutContainer.datum(dataset).call(donut);

            legendChart.width(300).height(legendChartHeight);

            if (obj.value === 'avgLoaded') {
              legendChart.numberFormat('$,');
            } else {
              legendChart.numberFormat('');
            }
            legendContainer = (0, _d3Selection.select)('.js-legend-chart-container-' + obj.value);
            legendContainer.datum(dataset).call(legendChart);
          }
        });
      }, 500);
    }
  }, {
    key: 'createBarChart',
    value: function createBarChart() {
      var _this3 = this;

      setTimeout(function () {
        _this3.barChartDataObj.extraInfo.graphList.forEach(function (obj, index) {
          var barChart = (0, _barMin2.default)(),
              chartTooltip = (0, _miniTooltip2.default)(),
              margin = {
            left: _this3.model.tab === 'routes' ? 70 : 30,
            right: 20,
            top: 10,
            bottom: 30
          },
              barContainer = (0, _d3Selection.select)('.js-bar-chart-tooltip-container'),
              containerWidth = barContainer.node() ? barContainer.node().getBoundingClientRect().width : false,
              tooltipContainer = void 0,
              dataObj = {},
              barChartHeight = _this3.model.tab === 'routes' ? 387 : 457;

          if (containerWidth) {
            var dataset = _this3.barChartDataObj[obj.value];

            dataset.forEach(function (d) {
              if (obj.value === 'avgRouteTime') {
                var hour = moment.duration(d.value).asHours().toFixed(0);
                dataObj[hour] = d.value;
                d.value = hour;
              } else if (obj.value === 'avgStopTime') {
                var minutes = moment.duration(d.value).asMinutes().toFixed(0);
                dataObj[minutes] = d.value;
                d.value = minutes;
              }
            });

            barChart.isHorizontal(true).isAnimated(true).margin(margin).width(containerWidth)
            // .colorSchema(britecharts.colors.colorSchemas.green)
            // .valueLabel('percentage')
            // .labelsNumberFormat('.0%')
            .percentageAxisToMaxRatio(1.1).height(barChartHeight).on('customMouseOver', chartTooltip.show).on('customMouseMove', chartTooltip.update).on('customMouseOut', chartTooltip.hide);

            barContainer.datum(dataset).call(barChart);

            tooltipContainer = (0, _d3Selection.select)('.bar-chart .metadata-group');
            chartTooltip.valueFormatter(function (value) {
              return dataObj[value];
            });
            tooltipContainer.datum([]).call(chartTooltip);
          }
        });
      }, 500);
    }
  }, {
    key: 'redrawChart',
    value: function redrawChart() {
      (0, _d3Selection.selectAll)('.donut-chart').remove();
      (0, _d3Selection.selectAll)('.britechart-legend').remove();
      this.createDonutChart();
      if (this.model.tab !== 'services') {
        this.createBarChart();
      }
    }
  }, {
    key: 'stateSelection',
    value: function stateSelection(selectedValue) {
      this.model.stats = selectedValue;
    }
  }, {
    key: 'tabSelection',
    value: function tabSelection(selectedValue) {
      this.model.tab = selectedValue;
      // selectAll('.donut-chart').remove();
      // selectAll('.britechart-legend').remove();
      this.loadData();
    }
  }, {
    key: 'setDateRangeOptions',
    value: function setDateRangeOptions(date, modelValue) {
      var _this4 = this;

      var currentVaultDate = moment(date).format() || moment();
      this.model[modelValue] = {
        autoApply: true,
        eventHandlers: {
          'apply.daterangepicker': function applyDaterangepicker() {
            _this4.resetData();
            _this4.loadData();
          }
        },
        ranges: {
          'Today': [moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')],
          'Current Week': [moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')],
          'Current Month': [moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')],
          'Past 30': [moment(currentVaultDate).subtract(29, 'days').format('YYYY-MM-DD HH:mm:ss')]
          // 'Past 60': [
          //   moment(currentVaultDate).subtract(59, 'days').format('YYYY-MM-DD HH:mm:ss')
          // ],
          // 'Past 90': [
          //   moment(currentVaultDate).subtract(89, 'days').format('YYYY-MM-DD HH:mm:ss')
          // ],
          // 'Current Year': [
          //     moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'),
          //     moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')
          // ]
        }
      };
    }
  }, {
    key: 'loadUserBranches',
    value: function loadUserBranches(searchKey, offset) {
      var _this5 = this;

      searchKey = searchKey || '';
      return this.UserBranchService.getUserBranches(this.model.loggedInUser).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this5.model.totalBranches = data.results.length;
          _this5.model.userBranchList = _this5.userBranchMap(data.results);
        } else {
          var branches = _this5.userBranchMap(data.results);
          _this5.model.userBranchList = _this5.model.userBranchList.concat(branches);
        }
        _this5.model.userBranchList.filter(function (branch) {
          if (branch.Key == _this5.model.currentBranch) {
            branch.ticked = true;
          }
        });
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'userBranchMap',
    value: function userBranchMap(branches) {
      return branches.map(function (branch) {
        return {
          Key: branch.branchId,
          Value: branch.branchId
        };
      });
    }
  }, {
    key: 'messengerMapping',
    value: function messengerMapping(array) {
      return array.map(function (obj) {
        return {
          Key: obj.messengerId + ' (' + obj.messengerName + ')',
          Value: obj.messengerId
        };
      });
    }
  }, {
    key: 'getRoutePerformance',
    value: function getRoutePerformance() {
      var _this6 = this;

      var key = 'route-performance';
      this.isRoutePerformanceRecordFound = true;
      this.loadContainer(key);

      setTimeout(function () {
        _this6.model.gettingRoutePerformanceStat = true;
        var startDate = moment(_this6.model.dateRangeOption.startDate).format('YYYY-MM-DD');
        var endDate = moment(_this6.model.dateRangeOption.endDate).format('YYYY-MM-DD');
        var branchIds = _this6.model.selectedBranch.length ? _this6.model.selectedBranch.map(function (b) {
          return b.Key;
        }) : null;
        var groupInterval = _this6.model.selectedInterval ? _this6.model.selectedInterval : null;
        var groupBy = ['branch'];
        var reverseSort = false;
        var route = [];
        var dataSet = [];
        var statsList = [{
          label: 'Avg Time | Checkout',
          value: 'avgTimeCheckinStartSec'
        }, {
          label: 'Avg Time | On Route',
          value: 'avgTimeOutOfBranchSec'
        }, {
          label: 'Avg Time | Load',
          value: 'avgTimeLoadSec'
        }, {
          label: 'Avg Time | Start Route',
          value: 'avgTimeLoadStartSec'
        }, {
          label: 'Avg Time | Route',
          value: 'avgTimeCycleSec'
        }];

        return _this6.ReportService.routePerformance(startDate, endDate, groupInterval, reverseSort, branchIds, route, groupBy, 500, 0).then(function (data) {
          _this6.model.routePerformanceStats = data.results;
          if (_this6.model.routePerformanceStats.length) {
            _this6.generateStackedBarChart(_this6.model.routePerformanceStats, statsList, key, 'Route Performance', _this6.model.tab);
          } else {
            _this6.removeLoadingContainer(key);
            _this6.isRoutePerformanceRecordFound = false;
          }
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          _this6.model.gettingRoutePerformanceStat = false;
        });
      }, 500);
    }
  }, {
    key: 'getRouteLocationPerformance',
    value: function getRouteLocationPerformance() {
      var _this7 = this;

      var key = 'route-location-performance';
      this.isRouteLocationRecordFound = true;
      this.loadContainer(key);

      setTimeout(function () {
        _this7.model.gettingRouteLocationStat = true;
        var startDate = moment(_this7.model.dateRangeOption.startDate).format('YYYY-MM-DD');
        var endDate = moment(_this7.model.dateRangeOption.endDate).format('YYYY-MM-DD');
        var branchIds = _this7.model.selectedBranch.length ? _this7.model.selectedBranch.map(function (b) {
          return b.Key;
        }) : null;
        var groupInterval = _this7.model.selectedInterval ? _this7.model.selectedInterval : null;
        var groupBy = ['branch'];
        var reverseSort = false;
        var route = [];

        var statsList = [{
          label: 'Avg Time | To Customer',
          value: 'avgTimeToCustomerSec'
        }, {
          label: 'Avg Time | AT Customer',
          value: 'avgTimeAtCustomerSec'
        }, {
          label: 'Avg Time | To Truck',
          value: 'avgTimeToTruckSec'
        }];

        return _this7.ReportService.routeLocationPerformance(startDate, endDate, groupInterval, reverseSort, branchIds, route, groupBy, 500, 0).then(function (data) {
          _this7.model.routeLocationStats = data.results;
          if (_this7.model.routeLocationStats.length) {
            _this7.generateStackedBarChart(_this7.model.routeLocationStats, statsList, key, 'Route Location Performance', _this7.model.tab);
          } else {
            _this7.removeLoadingContainer(key);
            _this7.isRouteLocationRecordFound = false;
          }
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          _this7.model.gettingRouteLocationStat = false;
        });
      }, 500);
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      (0, _d3Selection.selectAll)('.stacked-bar').remove();
      if (this.model.tab === 'routes') {
        this.getRoutePerformance();
        this.getRouteLocationPerformance();
      } else if (this.model.tab === 'orders') {
        this.getLedgerActivityReport();
        this.getLoadCompletedActivity();
        this.getDeliveryCompletedActivity();
        this.getResidualCompletedActivity();
        this.getPickupCompletedActivity();
        this.getBagoutCompletedActivity();
      } else if (this.model.tab === 'services') {
        this.getServiceOrderCompletedActivity();
        this.getServiceOrderCancelledActivity();
      }
    }
  }, {
    key: 'resetRouteFilter',
    value: function resetRouteFilter() {
      this.model.messenger = null;
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      if (this.model.tab === 'routes') {
        this.resetRouteFilter();
      }
    }
  }, {
    key: 'getLedgerActivityReport',
    value: function getLedgerActivityReport() {
      var _this8 = this;

      var obj = _.find(this.ordersGraphList, { 'value': 'ledgerActivityReport' });
      obj.isRecordsFound = true;
      this.loadContainer(obj.value);

      setTimeout(function () {
        var startDate = moment(_this8.model.dateRangeOption.startDate).format('YYYY-MM-DD');
        var endDate = moment(_this8.model.dateRangeOption.endDate).format('YYYY-MM-DD');
        var branchIds = _this8.model.selectedBranch.length ? _this8.model.selectedBranch.map(function (b) {
          return b.Key;
        }) : null;
        var groupInterval = _this8.model.selectedInterval ? _this8.model.selectedInterval : null;
        var groupBy = ['branch'];
        var denomination = [];
        var fundingSource = [];
        var account = [];
        var currency = ['USD'];

        var statsList = [{
          label: 'Total | System Adjust',
          value: 'totalSystemAdjust'
        }, {
          label: 'Total | User Adjust',
          value: 'totalUserAdjust'
        }, {
          label: 'Total Amount',
          value: 'totalAmount'
        }];

        obj.loading = true;
        return _this8.ReportService.ledgerActivityReport(startDate, endDate, groupInterval, groupBy, account, branchIds, fundingSource, currency, denomination, 500, 0).then(function (data) {
          _this8.model.ledgerActivityReportData = data.results;
          obj.results = _this8.model.ledgerActivityReportData;
          if (_this8.model.ledgerActivityReportData.length) {
            _this8.generateStackedBarChart(_this8.model.ledgerActivityReportData, statsList, obj.value, obj.label, _this8.model.tab);
          } else {
            _this8.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          obj.loading = false;
        });
      }, 500);
    }
  }, {
    key: 'getLoadCompletedActivity',
    value: function getLoadCompletedActivity() {
      var _this9 = this;

      var obj = _.find(this.ordersGraphList, { 'value': 'loadCompletedActivity' });
      obj.isRecordsFound = true;
      this.loadContainer(obj.value);

      setTimeout(function () {
        var startDate = moment(_this9.model.dateRangeOption.startDate).format('YYYY-MM-DD');
        var endDate = moment(_this9.model.dateRangeOption.endDate).format('YYYY-MM-DD');
        var branchIds = _this9.model.selectedBranch.length ? _this9.model.selectedBranch.map(function (b) {
          return b.Key;
        }) : null;
        var groupInterval = _this9.model.selectedInterval ? _this9.model.selectedInterval : null;
        var groupBy = ['branch'];
        var denomination = [];
        var fundingSource = [];
        var currency = ['USD'];
        var location = [];
        var route = [];

        var statsList = [
        // {
        //   label: 'Avg Time | To Deliver',
        //   value: 'avgTimeToDeliverSec'
        // },
        {
          label: 'Total Amount',
          value: 'totalAmount'
        }];

        obj.loading = true;
        return _this9.ReportService.loadCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, route, fundingSource, location, currency, denomination, 500, 0).then(function (data) {
          _this9.model.loadCompletedActivityData = data.results;
          obj.results = _this9.model.loadCompletedActivityData;
          if (_this9.model.loadCompletedActivityData.length) {
            _this9.generateStackedBarChart(_this9.model.loadCompletedActivityData, statsList, obj.value, obj.label, _this9.model.tab);
          } else {
            _this9.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          obj.loading = false;
        });
      }, 500);
    }
  }, {
    key: 'getDeliveryCompletedActivity',
    value: function getDeliveryCompletedActivity() {
      var _this10 = this;

      var obj = _.find(this.ordersGraphList, { 'value': 'deliveryCompletedActivity' });
      obj.isRecordsFound = true;
      this.loadContainer(obj.value);

      setTimeout(function () {
        var startDate = moment(_this10.model.dateRangeOption.startDate).format('YYYY-MM-DD');
        var endDate = moment(_this10.model.dateRangeOption.endDate).format('YYYY-MM-DD');
        var branchIds = _this10.model.selectedBranch.length ? _this10.model.selectedBranch.map(function (b) {
          return b.Key;
        }) : null;
        var groupInterval = _this10.model.selectedInterval ? _this10.model.selectedInterval : null;
        var groupBy = ['branch'];
        var shiptype = [];
        var toLocation = [];
        var fromLocation = [];
        var route = [];

        var statsList = [
        // {
        //   label: 'Avg Time | To Deliver',
        //   value: 'avgTimeToDeliverSec'
        // },
        {
          label: 'Total Amount',
          value: 'totalAmount'
        }];

        obj.loading = true;
        return _this10.ReportService.deliveryCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, route, fromLocation, toLocation, shiptype, 500, 0).then(function (data) {
          _this10.model.deliveryCompletedActivityData = data.results;
          obj.results = _this10.model.deliveryCompletedActivityData;
          if (_this10.model.deliveryCompletedActivityData.length) {
            _this10.generateStackedBarChart(_this10.model.deliveryCompletedActivityData, statsList, obj.value, obj.label, _this10.model.tab);
          } else {
            _this10.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          obj.loading = false;
        });
      }, 500);
    }
  }, {
    key: 'getResidualCompletedActivity',
    value: function getResidualCompletedActivity() {
      var _this11 = this;

      var obj = _.find(this.ordersGraphList, { 'value': 'residualCompletedActivity' });
      obj.isRecordsFound = true;
      this.loadContainer(obj.value);

      setTimeout(function () {
        var startDate = moment(_this11.model.dateRangeOption.startDate).format('YYYY-MM-DD');
        var endDate = moment(_this11.model.dateRangeOption.endDate).format('YYYY-MM-DD');
        var branchIds = _this11.model.selectedBranch.length ? _this11.model.selectedBranch.map(function (b) {
          return b.Key;
        }) : null;
        var groupInterval = _this11.model.selectedInterval ? _this11.model.selectedInterval : null;
        var groupBy = ['branch'];
        var route = [];
        var fundingSource = [];
        var location = [];
        var currency = [];
        var denomination = [];

        var statsList = [{
          label: 'Total Amount | Load Requested',
          value: 'totalAmountLoadRequested'
        }, {
          label: 'Total Amount | Load Actual',
          value: 'totalAmountLoadActual'
        }, {
          label: 'Total Amount | Expected',
          value: 'totalAmountExpected'
        }, {
          label: 'Total CRV',
          value: 'totalCRV'
        }, {
          label: 'Total Amount | Counted',
          value: 'totalAmountCounted'
        }, {
          label: 'Total Variance',
          value: 'totalVariance'
        }];

        obj.loading = true;
        return _this11.ReportService.residualCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, route, fundingSource, location, currency, denomination, 500, 0).then(function (data) {
          _this11.model.residualCompletedActivityData = data.results;
          obj.results = _this11.model.residualCompletedActivityData;
          if (_this11.model.residualCompletedActivityData.length) {
            _this11.generateStackedBarChart(_this11.model.residualCompletedActivityData, statsList, obj.value, obj.label, _this11.model.tab);
          } else {
            _this11.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          obj.loading = false;
        });
      }, 500);
    }
  }, {
    key: 'getPickupCompletedActivity',
    value: function getPickupCompletedActivity() {
      var _this12 = this;

      var obj = _.find(this.ordersGraphList, { 'value': 'pickupCompletedActivity' });
      obj.isRecordsFound = true;
      this.loadContainer(obj.value);

      setTimeout(function () {
        var startDate = moment(_this12.model.dateRangeOption.startDate).format('YYYY-MM-DD');
        var endDate = moment(_this12.model.dateRangeOption.endDate).format('YYYY-MM-DD');
        var branchIds = _this12.model.selectedBranch.length ? _this12.model.selectedBranch.map(function (b) {
          return b.Key;
        }) : null;
        var groupInterval = _this12.model.selectedInterval ? _this12.model.selectedInterval : null;
        var groupBy = ['branch'];
        var shiptype = [];
        var toLocation = [];
        var fromLocation = [];
        var route = [];

        var statsList = [{
          label: 'Total Amount',
          value: 'totalAmount'
        }];

        obj.loading = true;
        return _this12.ReportService.pickupCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, route, fromLocation, toLocation, shiptype, 500, 0).then(function (data) {
          _this12.model.pickupCompletedActivityData = data.results;
          obj.results = _this12.model.pickupCompletedActivityData;
          if (_this12.model.pickupCompletedActivityData.length) {
            _this12.generateStackedBarChart(_this12.model.pickupCompletedActivityData, statsList, obj.value, obj.label, _this12.model.tab);
          } else {
            _this12.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          obj.loading = false;
        });
      }, 500);
    }
  }, {
    key: 'getBagoutCompletedActivity',
    value: function getBagoutCompletedActivity() {
      var _this13 = this;

      var obj = _.find(this.ordersGraphList, { 'value': 'bagoutCompletedActivity' });
      obj.isRecordsFound = true;
      this.loadContainer(obj.value);

      setTimeout(function () {
        var startDate = moment(_this13.model.dateRangeOption.startDate).format('YYYY-MM-DD');
        var endDate = moment(_this13.model.dateRangeOption.endDate).format('YYYY-MM-DD');
        var branchIds = _this13.model.selectedBranch.length ? _this13.model.selectedBranch.map(function (b) {
          return b.Key;
        }) : null;
        var groupInterval = _this13.model.selectedInterval ? _this13.model.selectedInterval : null;
        var groupBy = ['branch'];
        var shiptype = [];
        var toLocation = [];
        var fromLocation = [];
        var carrier = [];

        var statsList = [{
          label: 'Total Amount',
          value: 'totalAmount'
        }];

        obj.loading = true;
        return _this13.ReportService.bagoutCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, carrier, fromLocation, toLocation, shiptype, 500, 0).then(function (data) {
          _this13.model.bagoutCompletedActivityData = data.results;
          if (_this13.model.bagoutCompletedActivityData.length) {
            _this13.model.bagoutCompletedActivityData = _this13.findDuplicateEntry(_this13.model.bagoutCompletedActivityData, 'date', 'totalAmount');
            obj.results = _this13.model.bagoutCompletedActivityData.filter(function (d) {
              return !d.matchPreviousRow;
            });

            _this13.generateStackedBarChart(obj.results, statsList, obj.value, obj.label, _this13.model.tab);
          } else {
            _this13.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          obj.loading = false;
        });
      }, 500);
    }
  }, {
    key: 'getServiceOrderCompletedActivity',
    value: function getServiceOrderCompletedActivity() {
      var _this14 = this;

      var obj = _.find(this.serviceOrdersGraphList, { 'value': 'serviceOrderCompletedActivity' });
      obj.isRecordsFound = true;
      this.loadContainer(obj.value);

      setTimeout(function () {
        var startDate = moment(_this14.model.dateRangeOption.startDate).format('YYYY-MM-DD');
        var endDate = moment(_this14.model.dateRangeOption.endDate).format('YYYY-MM-DD');
        var branchIds = _this14.model.selectedBranch.length ? _this14.model.selectedBranch.map(function (b) {
          return b.Key;
        }) : null;
        var groupInterval = _this14.model.selectedInterval ? _this14.model.selectedInterval : null;
        var groupBy = ['branch'];
        var location = [];
        var route = [];
        var user = [];
        var externalProcessor = [];

        var statsList = [{
          label: 'Avg Time | Open',
          value: 'avgTimeOpenSec'
        }];

        obj.loading = true;
        return _this14.ReportService.serviceOrderCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, location, route, user, externalProcessor, 500, 0).then(function (data) {
          _this14.model.serviceOrderCompletedActivityData = data.results;
          obj.results = _this14.model.serviceOrderCompletedActivityData;
          if (_this14.model.serviceOrderCompletedActivityData.length) {
            _this14.generateStackedBarChart(_this14.model.serviceOrderCompletedActivityData, statsList, obj.value, obj.label, _this14.model.tab);
          } else {
            _this14.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          obj.loading = false;
        });
      }, 500);
    }
  }, {
    key: 'getServiceOrderCancelledActivity',
    value: function getServiceOrderCancelledActivity() {
      var _this15 = this;

      var obj = _.find(this.serviceOrdersGraphList, { 'value': 'serviceOrderCancelledActivity' });
      obj.isRecordsFound = true;
      this.loadContainer(obj.value);

      setTimeout(function () {
        var startDate = moment(_this15.model.dateRangeOption.startDate).format('YYYY-MM-DD');
        var endDate = moment(_this15.model.dateRangeOption.endDate).format('YYYY-MM-DD');
        var branchIds = _this15.model.selectedBranch.length ? _this15.model.selectedBranch.map(function (b) {
          return b.Key;
        }) : null;
        var groupInterval = _this15.model.selectedInterval ? _this15.model.selectedInterval : null;
        var groupBy = ['branch'];
        var location = [];
        var route = [];
        var user = [];
        var externalProcessor = [];

        var statsList = [{
          label: 'Avg Time | Open',
          value: 'avgTimeOpenSec'
        }];

        obj.loading = true;
        return _this15.ReportService.serviceOrderCancelledActivity(startDate, endDate, groupInterval, groupBy, branchIds, location, route, user, externalProcessor, 500, 0).then(function (data) {
          _this15.model.serviceOrderCancelledActivityData = data.results;
          obj.results = _this15.model.serviceOrderCancelledActivityData;
          if (_this15.model.serviceOrderCancelledActivityData.length) {
            _this15.generateStackedBarChart(_this15.model.serviceOrderCancelledActivityData, statsList, obj.value, obj.label, _this15.model.tab);
          } else {
            _this15.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          obj.loading = false;
        });
      }, 500);
    }
  }, {
    key: 'translateStatus',
    value: function translateStatus(statusCode) {
      return this.$translate.instant('serviceTickets.status_' + statusCode);
    }
  }, {
    key: 'getOrderType',
    value: function getOrderType(orderType) {
      return this.$translate.instant('shipment.order_type_' + orderType);
    }
  }, {
    key: 'convertSecToHMS',
    value: function convertSecToHMS(seconds) {
      seconds = Number(seconds);
      var h = Math.floor(seconds / 3600);
      var m = Math.floor(seconds % 3600 / 60);
      var s = Math.floor(seconds % 3600 % 60);

      var hDisplay = h > 0 ? h + ":" : '00' + ':';
      var mDisplay = m > 0 ? m + ":" : '00' + ':';
      var sDisplay = s > 0 ? s : '00';

      return hDisplay + mDisplay + sDisplay;
    }
  }, {
    key: 'validateBucket',
    value: function validateBucket(stat) {
      this.bucketObj[stat].bucketExpanded = !this.bucketObj[stat].bucketExpanded;
    }
  }, {
    key: 'createStackedBarChart',
    value: function createStackedBarChart(data, stat, title, currentTab) {
      var _this16 = this;

      var chart = (0, _stackedBarMin2.default)(),
          chartTooltip = (0, _tooltip2.default)(),
          selector = '.js-stacked-bar-chart-tooltip-container-' + stat,
          selectorLoading = '.js-loading-container-' + stat,
          container = (0, _d3Selection.select)(selector),
          containerWidth = container.node() ? container.node().getBoundingClientRect().width : false,
          tooltipContainer,
          dataset,
          margin = {
        left: 0,
        right: 20,
        top: 50,
        bottom: 30
      };

      if (containerWidth) {
        $(selectorLoading).empty();
        dataset = { data: data };
        chart.tooltipThreshold(600)
        // .aspectRatio(0.5)
        .height(400).width(containerWidth).margin(margin).grid('horizontal').isAnimated(true).stackLabel('stack').nameLabel('date')
        // .betweenBarsPadding(0.8)
        // .nameLabelFormat('')
        // .xTicks(1)
        .valueLabel('views')
        // .valueLabelFormat(',f')
        // .yAxisLabel('ferfer')
        .colorSchema(['#6aedc7', //green
        '#39c2c9', //blue
        '#ffce00', //yellow
        '#ffa71a', //orange
        '#ff938c'] //red
        ).on("customMouseOver", chartTooltip.show).on('customMouseMove', chartTooltip.update).on("customMouseOut", chartTooltip.hide);

        container.datum(dataset.data).call(chart);

        // dataset.data.map((obj, index) => {
        //   if (currentTab === this.tabs.routes) {
        //     // obj.stack.startsWith('Avg') ? chartTooltip.valueFormatter((value) => moment.utc(value * 1000).format('HH:mm:ss')) : obj.value;
        //     obj.views = obj.stack.startsWith('Avg') ? moment.utc(obj.views * 1000).format('HH:mm:ss') : obj.views;
        //     obj.value = obj.stack.startsWith('Avg') ? moment.utc(obj.value * 1000).format('HH:mm:ss') : obj.value;
        //   }
        //   else if (currentTab === this.tabs.orders) {
        //     // obj.stack.startsWith('Avg') ? chartTooltip.valueFormatter((value) => moment.utc(value * 1000).format('HH:mm:ss')) : chartTooltip.valueFormatter((value) => this.$filter('currency')(value, '$', 0));;
        //     obj.views = obj.stack.startsWith('Avg') ? moment.utc(obj.views * 1000).format('HH:mm:ss') : this.$filter('currency')(obj.views, '$', 0);
        //   }
        // })

        chartTooltip.topicLabel('values').dateLabel('key').nameLabel('stack').title(title);

        tooltipContainer = (0, _d3Selection.select)('.js-stacked-bar-chart-tooltip-container-' + stat + ' .metadata-group');
        tooltipContainer.datum([]).call(chartTooltip);
        if (currentTab === this.tabs.routes || currentTab === this.tabs.services) chartTooltip.valueFormatter(function (value) {
          return moment.utc(value * 1000).format('HH:mm:ss');
        });else if (currentTab === this.tabs.orders) chartTooltip.valueFormatter(function (value) {
          return _this16.$filter('currency')(value, '$', 0);
        });
      }
    }
  }, {
    key: 'generateStackedBarChart',
    value: function generateStackedBarChart(statsData, statsList, currentStat, title, currentTab) {
      var _this17 = this;

      var dataSet = [];
      statsData.forEach(function (d) {
        statsList.forEach(function (stat) {
          dataSet.push({
            stack: stat.label,
            date: d.date,
            views: currentStat === 'ledgerActivityReport' ? Math.abs(d[stat.value]) : d[stat.value]
          });
        });
      });

      setTimeout(function () {
        _this17.createStackedBarChart(dataSet, currentStat, title, currentTab);
      }, 500);
    }
  }, {
    key: 'findDuplicateEntry',
    value: function findDuplicateEntry(item, sortBy, col) {
      var list = item;
      var sortByKey = sortBy;

      list = _.sortBy(list, [sortByKey]);
      list[0].matchPreviousRow = false;

      for (var i = 0; i < list.length; i++) {
        var date = list[i][sortByKey];
        var cursor = 1;

        for (var j = i + 1; j < list.length; j++) {
          if (list[j][sortByKey] === date && !list[j].matchPreviousRow) {
            cursor++;
            list[j].matchPreviousRow = true;
            if (col) list[i][col] += list[j][col];
          } else {
            break;
          }
        }
        list[i].cursor = cursor;
      }
      return list;
    }
  }, {
    key: 'loadContainer',
    value: function loadContainer(stat) {
      var selector = '.js-loading-container-' + stat;
      var stackedBar = (0, _stackedBarMin2.default)(),
          stackedBarContainer = (0, _d3Selection.select)(selector),
          containerWidth = stackedBarContainer.node() ? stackedBarContainer.node().getBoundingClientRect().width : false;
      if (containerWidth) {
        stackedBarContainer.html(stackedBar.loadingState());
      }
    }
  }, {
    key: 'removeLoadingContainer',
    value: function removeLoadingContainer(stat) {
      var selector = '.js-loading-container-' + stat;
      $(selector).empty();
    }
  }]);
  return BranchPerformanceController;
}();

exports.default = BranchPerformanceController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(59)))

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _branch_performance = __webpack_require__(1702);

var _branch_performance2 = _interopRequireDefault(_branch_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementBranchPerformanceModule = angular.module('branchManagementBranchPerformance', []).component('branchManagementBranchPerformance', _branch_performance2.default).name;

exports.default = branchManagementBranchPerformanceModule;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bypass_code = __webpack_require__(2669);

var _bypass_code2 = _interopRequireDefault(_bypass_code);

var _bypass_code3 = __webpack_require__(1706);

var _bypass_code4 = _interopRequireDefault(_bypass_code3);

__webpack_require__(2954);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementBypassCodeComponent = {
  restrict: "E",
  bindings: {},
  template: _bypass_code2.default,
  controller: _bypass_code4.default
};

exports.default = branchManagementBypassCodeComponent;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIMIT = 10;
var MAXLIMIT = 1000;

var BypassCodeController = function () {
    /*@ngInject*/
    BypassCodeController.$inject = ["Auth", "$state", "User", "UsersService", "DateUtil", "RouteService", "DataCounter", "$translate", "$location", "$q", "Modal", "BranchService", "HoldLocationService", "$scope", "LocationService", "BypassCodeService", "SetupService", "RouteStopService", "$rootScope"];
    function BypassCodeController(Auth, $state, User, UsersService, DateUtil, RouteService, DataCounter, $translate, $location, $q, Modal, BranchService, HoldLocationService, $scope, LocationService, BypassCodeService, SetupService, RouteStopService, $rootScope) {
        (0, _classCallCheck3.default)(this, BypassCodeController);

        this.BranchService = BranchService;
        this.UsersService = UsersService;
        this.DateUtil = DateUtil;
        this.RouteService = RouteService;
        this.LocationService = LocationService;
        this.BypassCodeService = BypassCodeService;
        this.Modal = Modal;
        this.$translate = $translate;
        this.SetupService = SetupService;
        this.$q = $q;
        this.RouteStopService = RouteStopService;
        this.$rootScope = $rootScope;
        this.model = {
            routeId: null,
            branchId: null,
            userId: null,
            locationId: null,
            issues: null,
            comments: null,
            trackingId: null,
            bypassCode: null,
            supvApproveId: 0,
            canNotScanLocation: false
        };
        this.userLists = [];
        this.routeLists = [];
        this.branches = [];
        this.allUsers = [];
        this.allBypassCodeData = [];
        this.date = new Date();

        this.issues = [{
            lable: $translate.instant('branch_mgmt.bypass_code.locationdp'),
            value: "cant_scan_location"
        }, {
            lable: $translate.instant('branch_mgmt.bypass_code.truckdp'),
            value: "cant_load_truck"
        }];

        this.locationLists = [];
        // Convert exponents to number
        Number.prototype.noExponents = function () {
            var data = String(this).split(/[eE]/);
            if (data.length == 1) return data[0];

            var z = '',
                sign = this < 0 ? '-' : '',
                str = data[0].replace('.', ''),
                mag = Number(data[1]) + 1;

            if (mag < 0) {
                z = sign + '0.';
                while (mag++) {
                    z += '0';
                }return z + str.replace(/^\-/, '');
            }
            mag -= str.length;
            while (mag--) {
                z += '0';
            }return str + z;
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/4P-bypass-code');
    }

    (0, _createClass3.default)(BypassCodeController, [{
        key: 'loadPermission',
        value: function loadPermission() {
            var _this = this;

            this.acl = {};
            this.hasACL = {};

            [].forEach(function (permissionKey) {
                _this.acl[permissionKey] = _this.User.getACL(permissionKey);

                _this.hasACL[permissionKey] = {};

                _this.acl[permissionKey].forEach(function (permission) {
                    _this.hasACL[permissionKey][permission] = true;
                });
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.loading = true;
            this.loadPermission();

            this.$q.all([this.BranchService.all(null, 0, MAXLIMIT)]).then(function (data) {
                var branches = data[0].results;
                _this2.branches = branches;
                _this2.getAllBypassCode();
            });
        }
    }, {
        key: 'getAllLocation',
        value: function getAllLocation(searchKey, offset) {
            var _this3 = this;

            var loadLocationDatas = '';

            if (searchKey) loadLocationDatas = this.loadLocationDataWithSearch(searchKey);else loadLocationDatas = this.loadLocationData();

            if (document.getElementById("select").selectedIndex == 1) {
                this.LocationService.getAllLocation(loadLocationDatas, offset, LIMIT).then(function (data) {

                    if (offset === 0) {
                        _this3.totalRecords = data.total;
                        _this3.locationLists = _this3.mappingLocationDatas(data.results);
                    } else {
                        var locations = _this3.mappingLocationDatas(data.results);
                        _this3.locationLists = _this3.locationLists.concat(locations);
                    }
                });
            } else {
                this.getRouteStopData(searchKey, offset);
            }
        }
    }, {
        key: 'getRouteStopData',
        value: function getRouteStopData(searchKey, offset) {
            var _this4 = this;

            var loadRouteStops = '';

            if (searchKey) loadRouteStops = this.loadRouteStopWithSearch(searchKey);else loadRouteStops = this.loadRouteStopData();

            this.RouteStopService.all(loadRouteStops, offset, LIMIT).then(function (data) {
                if (offset === 0) {
                    _this4.totalRecords = data.total;
                    _this4.locationLists = _this4.mappingRouteStops(data.results);
                } else {
                    var locations = _this4.mappingRouteStops(data.results);
                    _this4.locationLists = _this4.locationLists.concat(locations);
                }
            });
        }
    }, {
        key: 'getAllUsers',
        value: function getAllUsers(searchKey, offset) {
            var _this5 = this;

            var loadUserDatas = '';
            if (searchKey) loadUserDatas = this.loadUserDataWithSearch(searchKey);else loadUserDatas = this.loadUserData();

            this.UsersService.all(loadUserDatas, offset, LIMIT).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this5.totalUserRecord = data.total;
                    _this5.userLists = _this5.mappingUserDatas(data.results);
                } else {
                    var users = _this5.mappingUserDatas(data.results);
                    _this5.userLists = _this5.userLists.concat(users);
                }
            });
        }
    }, {
        key: 'branchChanged',
        value: function branchChanged() {
            var _this6 = this;

            this.model.routeId = null;
            this.model.locationId = null;
            this.model.userId = null;
            this.locations = [];
            this.locationLists = [];
            this.totalRecords = 0;
            this.SetupService.get(this.model.branchId).then(function (setup) {
                var date = _this6.DateUtil.convertToDate(setup.currentVaultDate);
                var vaultDate = moment(date).format('YYYY-MM-DD');
                _this6.vaultDate = vaultDate;
                _this6.isCoinCheckOut = setup.coinCheckOut;
                _this6.getRouteData(vaultDate);
                _this6.locationChanged();
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this6.Modal.errorModal('error.' + err.data.message);
                }
            });
            this.getUserData();
        }

        // load locationType == TRUCK data based on BranchID

    }, {
        key: 'loadRouteStopData',
        value: function loadRouteStopData() {
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "routeId",
                        condition: "=",
                        data: this.model.routeId.Value
                    }, {
                        field: "routeDate",
                        condition: "=",
                        data: this.vaultDate
                    }],
                    operator: "AND"
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        // load locationType == TRUCK data based on BranchID

    }, {
        key: 'loadRouteStopWithSearch',
        value: function loadRouteStopWithSearch(searchKey) {
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "routeId",
                        condition: "=",
                        data: this.model.routeId.Value
                    }, {
                        field: "routeDate",
                        condition: "=",
                        data: this.vaultDate
                    }, {
                        group: {
                            rules: [{
                                field: "locationId",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        // load locationType == REGULAR, NO_SHIP_NO_GO, ATM, BANK, ON_CALL data based on BranchID

    }, {
        key: 'loadLocationData',
        value: function loadLocationData() {
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: "locationType",
                                condition: "=",
                                data: "REGULAR"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "NO_SHIP_NO_GO"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "ATM"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "BANK"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "ON_CALL"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        // load locationType == REGULAR, NO_SHIP_NO_GO, ATM, BANK, ON_CALL data based on BranchID With Search value

    }, {
        key: 'loadLocationDataWithSearch',
        value: function loadLocationDataWithSearch(searchKey) {
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: "locationType",
                                condition: "=",
                                data: "REGULAR"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "NO_SHIP_NO_GO"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "ATM"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "BANK"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "ON_CALL"
                            }],
                            operator: "OR"
                        }
                    }, {
                        group: {
                            rules: [{
                                field: "id",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "name",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        // load data based on BranchID

    }, {
        key: 'loadUserData',
        value: function loadUserData() {
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: 'downloadToHHT',
                                condition: '=',
                                data: true
                            }, {
                                field: 'email',
                                condition: '!=',
                                data: null
                            }, {
                                field: 'supervisor',
                                condition: '=',
                                data: true
                            }, {
                                field: 'serviceUser',
                                condition: '=',
                                data: true
                            }, {
                                field: 'customerUser',
                                condition: '=',
                                data: true
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        // load data based on BranchID With search value

    }, {
        key: 'loadUserDataWithSearch',
        value: function loadUserDataWithSearch(searchKey) {
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: 'downloadToHHT',
                                condition: '=',
                                data: true
                            }, {
                                field: 'email',
                                condition: '!=',
                                data: null
                            }, {
                                field: 'supervisor',
                                condition: '=',
                                data: true
                            }, {
                                field: 'serviceUser',
                                condition: '=',
                                data: true
                            }, {
                                field: 'customerUser',
                                condition: '=',
                                data: true
                            }],
                            operator: "OR"
                        }
                    }, {
                        group: {
                            rules: [{
                                field: "id",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "firstName",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "lastName",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }

        // change location type based on issues

    }, {
        key: 'locationChanged',
        value: function locationChanged() {
            var _this7 = this;

            var loadLocationDatas = this.loadLocationData();

            if (document.getElementById("select").selectedIndex == 1) {
                this.LocationService.getAllLocation(loadLocationDatas, 0, LIMIT).then(function (data) {
                    _this7.model.canNotScanLocation = true;
                    _this7.locationTypeData = data.results;
                    _this7.totalRecords = data.total;
                    _this7.locationLists = _this7.mappingLocationDatas(data.results);
                });
            }
        }
    }, {
        key: 'getRouteStops',
        value: function getRouteStops() {
            var _this8 = this;

            this.model.locationId = "";
            if (document.getElementById("select").selectedIndex == 2 && this.model.routeId) {
                var loadRouteStops = this.loadRouteStopData();
                this.RouteStopService.all(loadRouteStops, 0, LIMIT).then(function (data) {
                    _this8.model.canNotScanLocation = false;
                    _this8.locationTypeData = data.results;
                    _this8.totalRecords = data.total;
                    _this8.locationLists = _this8.mappingRouteStops(data.results);
                });
            }
        }
    }, {
        key: 'mappingLocationDatas',
        value: function mappingLocationDatas(locations) {
            return locations.map(function (location) {
                return {
                    Key: location.id + " | " + location.name,
                    Value: location.id
                };
            });
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            if (this.model.branchId !== null) {
                this.model.locationId = "";
                this.locationChanged();
                this.getRouteStops();
            }
        }
    }, {
        key: 'mappingUserDatas',
        value: function mappingUserDatas(users) {
            return users.map(function (user) {
                return {
                    Key: user.id + " | " + user.firstName + " " + user.lastName,
                    Value: user.id
                };
            });
        }
    }, {
        key: 'getUserData',
        value: function getUserData() {
            var _this9 = this;

            this.UsersService.all(this.loadUserData(), 0, LIMIT).then(function (data) {
                _this9.totalUserRecord = data.total;
                _this9.userLists = _this9.mappingUserDatas(data.results);
            });
        }
    }, {
        key: 'mappingRouteDatas',
        value: function mappingRouteDatas(routes) {
            return routes.map(function (route) {
                return {
                    Key: route.routeId + " | " + route.routeName,
                    Value: route.routeId
                };
            });
        }
    }, {
        key: 'getRouteData',
        value: function getRouteData(vaultDate) {
            var _this10 = this;

            this.BranchService.getReleaseRoutes(this.model.branchId, vaultDate, this.isCoinCheckOut).then(function (res) {
                _this10.routeLists = _this10.mappingRouteDatas(res);
                _this10.totalRouteRecords = res.length;
            }).catch(function (err) {
                if (!err.data.success) {
                    _this10.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'readMul',
        value: function readMul(mul) {
            return typeof mul !== 'number' || isNaN(mul) ? 1 : mul;
        }
    }, {
        key: 'readDate',
        value: function readDate(date) {
            return (typeof date === 'undefined' ? 'undefined' : (0, _typeof3.default)(date)) !== 'object' || false === date instanceof Date ? new Date() : date;
        }
    }, {
        key: 'pad',
        value: function pad(s, p, r) {
            if (!s || !p || p.length <= s.length) return s;
            return r ? (s + p).substr(0, p.length) : (p + s).substr(-p.length);
        }
    }, {
        key: 'getDate',
        value: function getDate(date) {
            date = this.readDate(date);
            var year = String(date.getFullYear()).substr(-2),
                // use last 2 digits of year
            day = this.pad(date.getDate().toString(), '00'),
                // left zero padded date
            month = (date.getMonth() + 1).toString(); // month of year as string (date.getMonth is zero indexed)

            return parseInt(month + day + year);
        }
    }, {
        key: 'getDayOfMonth',
        value: function getDayOfMonth(date, mul) {
            return this.readDate(date).getDate() * this.readMul(mul);
        }
    }, {
        key: 'encode',
        value: function encode(numericId, date, mul) {
            // console.log("encode", numericId, date, mul)
            return Number(numericId) + this.getDate(date) - this.getDayOfMonth(date, mul);
        }
    }, {
        key: 'decode',
        value: function decode(bypassCode, date, mul) {
            // console.log("decode", bypassCode, date, mul)
            return Number(bypassCode) - this.getDate(date) + this.getDayOfMonth(date, mul);
        }
    }, {
        key: 'confirmSupervisor',
        value: function confirmSupervisor() {
            var _this11 = this;

            if (this.isLoading) return;
            this.isLoading = true;
            this.Modal.confirmSupervisor('generate-bypass-code', null, function (_ref) {
                var modal = _ref.modal,
                    supId = _ref.supId;

                _this11.model.supvApproveId = supId;
                _this11.generateBypassCode();
                modal.close();
            }, function (_ref2) {
                var modal = _ref2.modal;

                if (modal) modal.close();
                _this11.isLoading = false;
            });
        }
    }, {
        key: 'generateBypassCode',
        value: function generateBypassCode() {
            var _this12 = this;

            this.loading = true;
            // console.log(this.model.locationId.Value, this.vaultDate, this.model.canNotScanLocation == true ? 7 : 8)
            var seedVal = this.model.locationId ? this.model.locationId.Value : parseInt(this.model.trackingId, 36);
            var bypassCode = this.encode(seedVal, new Date(this.vaultDate), this.model.canNotScanLocation == true ? 7 : 8);
            this.model.bypassCode = bypassCode.noExponents();

            this.model.type = this.model.issues;
            this.model.locationId = this.model.locationId.Value;
            this.model.userId = this.model.userId.Value;
            this.model.routeId = this.model.routeId.Value;
            this.BypassCodeService.create(this.model).then(function (data) {
                _this12.isLoading = false;
                _this12.bypassCode = data.bypassCode;
                _this12.getAllBypassCode();
                _this12.reset();
            }).catch(function (err) {
                _this12.isLoading = false;
                _this12.loading = false;
                var errorCode = err && err.data && err.data.message;
                if (errorCode) {
                    if (err.data.errors[0].path === 'bypasscode_tracking_id_unique') {
                        _this12.bypassCodeThrowError = _this12.$translate.instant('error.trackingIdUnique');
                    } else {
                        _this12.bypassCodeThrowError = _this12.$translate.instant('error.bypassCodeNotGenerate');
                    }
                    _this12.Modal.errorModal(_this12.bypassCodeThrowError);
                } else {
                    console.log(err);
                }
            });
        }
    }, {
        key: 'getAllBypassCode',
        value: function getAllBypassCode() {
            var _this13 = this;

            this.BypassCodeService.all(null, 0, 100).then(function (allBypassCode) {
                _this13.allBypassCodeData = allBypassCode.results;
                _this13.loading = false;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model.routeId = null;
            this.model.userId = null;
            this.model.locationId = null;
            this.model.comments = null;
            this.model.trackingId = null;
            this.model.bypassCode = null;
            this.model.supvApproveId = 0;
            this.model.issues = null;
            this.locationLists = [];
            this.totalRecords = 0;
        }
    }, {
        key: 'mappingRouteStops',
        value: function mappingRouteStops(data) {
            return data.map(function (d) {
                return {
                    Key: d.location.id + " | " + d.location.name,
                    Value: d.location.id
                };
            });
        }
    }, {
        key: 'translateIssue',
        value: function translateIssue(message) {
            if (!message || message === 'Location') return;
            return this.$translate.instant('branch_mgmt.tnt_bypass_code.' + message);
        }
    }]);
    return BypassCodeController;
}();

exports.default = BypassCodeController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bypass_code = __webpack_require__(1705);

var _bypass_code2 = _interopRequireDefault(_bypass_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementBypassCodeModule = angular.module('branchManagementBypassCode', []).component('branchManagementBypassCode', _bypass_code2.default).name;

exports.default = branchManagementBypassCodeModule;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cancelled_shipments = __webpack_require__(2670);

var _cancelled_shipments2 = _interopRequireDefault(_cancelled_shipments);

var _cancelled_shipments3 = __webpack_require__(1709);

var _cancelled_shipments4 = _interopRequireDefault(_cancelled_shipments3);

__webpack_require__(2955);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementCancelledShipmentsComponent = {
    restrict: "E",
    binding: {},
    template: _cancelled_shipments2.default,
    controller: _cancelled_shipments4.default
};

exports.default = branchManagementCancelledShipmentsComponent;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelledShipmentController = function () {
    /*@ngInject*/
    CancelledShipmentController.$inject = ["Auth", "User", "SetupService", "ShipmentService", "Navigation", "Modal", "$state", "$rootScope"];
    function CancelledShipmentController(Auth, User, SetupService, ShipmentService, Navigation, Modal, $state, $rootScope) {
        (0, _classCallCheck3.default)(this, CancelledShipmentController);

        this.Auth = Auth;
        this.User = User;
        this.SetupService = SetupService;
        this.ShipmentService = ShipmentService;
        this.Navigation = Navigation;
        this.Modal = Modal;
        this.$state = $state;
        this.$rootScope = $rootScope;

        this.model = {
            branch: User.getUser().branchId,
            getPendingCancelShp: false,
            getCancelledShp: false,
            pendingCancelShipments: [],
            cancelledShipments: [],
            loading: false,
            pendingCancelShipmentError: null,
            cancelledShipmentError: null
        };

        this.cancelledShpPaginationObj = {
            page: 1,
            total: 0,
            pageLimit: _app2.default.defaultPageLimit,
            maxPages: 10
        };

        this.pendingCancelShpPaginationObj = {
            page: 1,
            total: 0,
            pageLimit: _app2.default.defaultPageLimit,
            maxPages: 10
        };
        this.sortColumn = "trackingId";
        this.reverseSort = true;
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/cancelled-shipments');
    }

    (0, _createClass3.default)(CancelledShipmentController, [{
        key: '$onInit',
        value: function $onInit() {
            this.getPendingCancelShipment();
            this.getCancelledShipments();
        }
    }, {
        key: 'getPendingCancelShipment',
        value: function getPendingCancelShipment() {
            var _this = this;

            this.model.getPendingCancelShp = true;

            this.ShipmentService.getPendingCancelShipments(this.model.branch, (this.pendingCancelShpPaginationObj.page - 1) * this.pendingCancelShpPaginationObj.pageLimit, this.pendingCancelShpPaginationObj.pageLimit).then(function (data) {
                _this.model.pendingCancelShipments = data.results;
                _this.pendingCancelShpPaginationObj.total = data.totalRecords;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this.model.pendingCancelShipmentError = err.data.message;
                }
            }).finally(function () {
                _this.model.getPendingCancelShp = false;
            });
        }
    }, {
        key: 'getCancelledShipments',
        value: function getCancelledShipments() {
            var _this2 = this;

            this.model.getCancelledShp = true;

            this.ShipmentService.getCancelledShipments(this.model.branch, (this.cancelledShpPaginationObj.page - 1) * this.cancelledShpPaginationObj.pageLimit, this.cancelledShpPaginationObj.pageLimit).then(function (data) {
                _this2.model.cancelledShipments = data.results;
                _this2.cancelledShpPaginationObj.total = data.totalRecords;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this2.model.cancelledShipmentError = err.data.message;
                }
            }).finally(function () {
                _this2.model.getCancelledShp = false;
            });
        }
    }, {
        key: 'goToItemHistory',
        value: function goToItemHistory(trackingId) {
            this.$state.go('branchManagement.items', {
                id: trackingId
            });
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(locationId) {
            return this.Navigation.goToServiceHistory(locationId, null, true, null);
        }
    }, {
        key: 'goToOrderHistory',
        value: function goToOrderHistory(data) {
            return this.Navigation.goToOrderHistory(data.orderNo, data.vaultDate, true, false, true, false, null);
        }
    }, {
        key: 'orderPackingUndo',
        value: function orderPackingUndo(shipment) {
            var _this3 = this;

            if (this.loading) return;
            this.loading = true;

            this.Modal.undoPackedOrder(shipment, function (_ref) {
                var modal = _ref.modal,
                    supervisorId = _ref.supervisorId,
                    deleteOrder = _ref.deleteOrder,
                    deletedReason = _ref.deletedReason,
                    $scope = _ref.$scope;

                console.log(supervisorId, deleteOrder, deletedReason);
                _this3.ShipmentService.orderPackingUndo(_this3.model.branch, shipment.shipmentId, supervisorId, deletedReason, deleteOrder).then(function () {
                    modal.close();
                    _this3.loading = false;
                    _this3.loadData();
                }).catch(function (err) {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        _this3.loading = false;
                        _this3.Modal.errorModal('error.' + err.data.message);
                    }
                });
            }, function (_ref2) {
                var modal = _ref2.modal;

                if (modal) modal.close();
                _this3.loading = false;
            });
        }
    }, {
        key: 'sortData',
        value: function sortData(column) {
            this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
            this.sortColumn = column;
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            this.pendingCancelShpPaginationObj.page = 1;
            this.getPendingCancelShipment();
        }
    }, {
        key: 'goToBulkCash',
        value: function goToBulkCash() {
            this.$state.go('bulkCashManagement');
        }
    }]);
    return CancelledShipmentController;
}();

exports.default = CancelledShipmentController;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cancelled_shipments = __webpack_require__(1708);

var _cancelled_shipments2 = _interopRequireDefault(_cancelled_shipments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementCancelledShipmentsModule = angular.module('branchManagementCancelledShipments', []).component('branchManagementCancelledShipments', _cancelled_shipments2.default).name;

exports.default = branchManagementCancelledShipmentsModule;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cash_deliveries = __webpack_require__(2671);

var _cash_deliveries2 = _interopRequireDefault(_cash_deliveries);

var _cash_deliveries3 = __webpack_require__(1712);

var _cash_deliveries4 = _interopRequireDefault(_cash_deliveries3);

__webpack_require__(2956);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementCashDeliveriesComponent = {
  restrict: "E",
  bindings: {},
  template: _cash_deliveries2.default,
  controller: _cash_deliveries4.default
};

exports.default = branchManagementCashDeliveriesComponent;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CashDeliveriesController = function () {
  /*@ngInject*/
  CashDeliveriesController.$inject = ["Auth", "$state", "User", "DataCounter", "$translate", "$q", "Modal", "$scope", "DateUtil", "SetupService", "Navigation", "UsersService", "BranchFundingSourceService", "CashDeliveriesService", "ShipmentService", "TimezoneList", "$rootScope"];
  function CashDeliveriesController(Auth, $state, User, DataCounter, $translate, $q, Modal, $scope, DateUtil, SetupService, Navigation, UsersService, BranchFundingSourceService, CashDeliveriesService, ShipmentService, TimezoneList, $rootScope) {
    (0, _classCallCheck3.default)(this, CashDeliveriesController);

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.Modal = Modal;
    this.DataCounter = DataCounter;
    this.$scope = $scope;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.Navigation = Navigation;
    this.UsersService = UsersService;
    this.BranchFundingSourceService = BranchFundingSourceService;
    this.CashDeliveriesService = CashDeliveriesService;
    this.ShipmentService = ShipmentService;
    this.TimezoneList = TimezoneList;
    this.$rootScope = $rootScope;

    this.model = {
      loading: false,
      search: null,
      branch: User.getUser().branchId,
      dateRange: {},
      selectedFundingSource: null,
      vaultDate: null,
      cashDeliveriesData: [],
      searchText: null,
      currentStats: 'cashDeliveries',
      cashPickupsData: [],
      defaultPageLimit: _app2.default.defaultPageLimit,
      selectedToLocation: null,
      selectedFromLocation: null,
      cashPickupLocationsObj: {
        totalRecords: 0,
        results: []
      },
      cashDeliveryLocationsObj: {
        totalRecords: 0,
        results: []
      },
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      dateRangeOptions: {
        startDate: null,
        endDate: null
      },
      deliveryPickupDateRangeOptions: {
        startDate: null,
        endDate: null
      },
      // fundingSourceObj: {
      //   totalRecords: 0,
      //   results: []
      // },
      timezone: null,
      isExportingCashTransactions: false,
      timezoneList: this.TimezoneList.getTimezoneList(),
      loggedInUser: User.getUser().id,
      filterByDeliveryDate: false,
      filterByPickupDate: false,
      filterByVaultDate: true
    };

    this.stats = {
      cashDeliveries: 'cashDeliveries',
      cashPickups: 'cashPickups'
    };

    this.sortColumn = "processingDate";
    this.reverseSort = true;
    this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/cash-transactions');
  }

  (0, _createClass3.default)(CashDeliveriesController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.model.loading = true;
      this.$q.all([this.SetupService.get(this.model.branch), this.UsersService.getUserFieldData(this.model.loggedInUser)]).then(function (data) {
        // this.currentVaultDate = this.DateUtil.getUTCDate(data[0].currentVaultDate);
        _this.model.vaultDate = _this.DateUtil.convertToDate(data[0].currentVaultDate);
        _this.loadDateRangePicker(_this.model.vaultDate, _this.model.dateRangeOptions, 'dateRange');
        _this.model.dateRangeOptions.startDate = moment(_this.model.vaultDate).subtract(30, 'days').format('YYYY-MM-DD 00:00:00');
        _this.model.dateRangeOptions.endDate = moment(_this.model.vaultDate).add(14, 'days').format('YYYY-MM-DD 23:59:59');
        _this.model.deliveryPickupDateRangeOptions.startDate = moment(_this.model.vaultDate).subtract(30, 'days').format('YYYY-MM-DD 00:00:00');
        _this.model.deliveryPickupDateRangeOptions.endDate = moment(_this.model.vaultDate).add(14, 'days').format('YYYY-MM-DD 23:59:59');
        _this.model.userdetails = data[1];
        _this.model.timezone = _this.model.userdetails.timezone ? _this.model.userdetails.timezone : moment.tz.guess();
        // if (this.model.fundingSourceObj.results.length === 1) {
        //   this.model.selectedFundingSource = this.model.fundingSourceObj.results[0];
        //   this.loadData();
        // }
        _this.getCashDeliveryLocations('', 0);
        _this.getCashPickupLocations('', 0);
        _this.loadData();
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this.model.loading = false;
      });
    }
  }, {
    key: 'loadDateRangePicker',
    value: function loadDateRangePicker(date, dateRangeOption, modelVal) {
      var _this2 = this;

      var currentVaultDate = moment(date).format() || moment();
      this.model[modelVal] = {
        autoApply: true,
        eventHandlers: {
          'apply.daterangepicker': function applyDaterangepicker() {
            _this2.loadLocationList().then(function () {
              _this2.loadData();
            });
          }
        },
        ranges: this.getCustomRange(currentVaultDate)
      };
    }
  }, {
    key: 'getCustomRange',
    value: function getCustomRange(currentVaultDate) {
      return {
        'Running 45 Days': [moment(currentVaultDate).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss')],
        'Today': [moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        'Current Week': [moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')],
        'Current Month': [moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')],
        'Current Year': [moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')]
      };
    }

    // fundingSourceSearchObj = (searchKey) => {
    //   searchKey = searchKey || '';
    //   const searchObj = {
    //     queryJSON: {
    //       rules: [
    //         {
    //           field: 'branchId',
    //           condition: '=',
    //           data: this.model.branch
    //         },
    //         {
    //           field: 'deliveryReport',
    //           condition: '=',
    //           data: true
    //         },
    //         {
    //           group: {
    //             rules: [{
    //               field: 'locationId',
    //               condition: 'like',
    //               data: '%' + searchKey + '%'
    //             },
    //             {
    //               field: 'sourceName',
    //               condition: 'like',
    //               data: '%' + searchKey + '%'
    //             }
    //             ],
    //             operator: 'OR'
    //           }
    //         }
    //       ],
    //       operator: 'AND'
    //     }
    //   };
    //   return searchObj.queryJSON.rules.length ? searchObj : null;
    // }

    // getBranchFundingSource(searchKey, offset) {
    //   const searchObj = this.fundingSourceSearchObj(searchKey);

    //   return this.BranchFundingSourceService.all(searchObj, offset, AppConstants.defaultPageLimit)
    //     .then((data) => {
    //       if (offset === 0) {
    //         this.model.fundingSourceObj.totalRecords = data.total;
    //         this.model.fundingSourceObj.results = this.locationMapping(data.results);
    //       }
    //       else {
    //         const fundingSource = this.locationMapping(data.results);
    //         this.model.fundingSourceObj.results = this.model.fundingSourceObj.results.concat(fundingSource);
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // }

    // locationMapping(fundingSource) {
    //   return fundingSource.map((data) => {
    //     return {
    //       Key: data.locationId + " | " + data.sourceName,
    //       Value: data.locationId,
    //       Id: data.id
    //     }
    //   });
    // }

  }, {
    key: 'loadData',
    value: function loadData() {
      this.model.pagination.page = 1;
      if (this.model.currentStats === this.stats.cashDeliveries) return this.getCashDeliveries();else if (this.model.currentStats === this.stats.cashPickups) return this.getCashPickups();
    }
  }, {
    key: 'getCashDeliveries',
    value: function getCashDeliveries() {
      var _this3 = this;

      var startDate = this.getStartDate();
      var endDate = this.getEndDate();
      var fromLocationId = this.model.selectedFromLocation ? this.model.selectedFromLocation.Value : null;

      this.model.loadCashDeliveries = true;
      this.CashDeliveriesService.cashDeliveries(this.model.searchText, fromLocationId, this.model.branch, startDate, endDate, (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit, this.reverseSort, this.sortColumn, this.model.timezone, this.customerId, this.model.filterByDeliveryDate, this.model.filterByVaultDate).then(function (data) {
        _this3.model.pagination.total = data.totalRecords;
        _this3.model.cashDeliveriesData = data.results;
        // this.resetData();
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this3.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this3.model.loadCashDeliveries = false;
      });
    }
  }, {
    key: 'downloadFile',
    value: function downloadFile(locationId, reportPrefix, reportData) {
      var fileName = reportPrefix.concat('.csv');
      var a = document.createElement("a");
      document.body.appendChild(a);
      var file = new Blob([reportData], { type: 'application/csv' });
      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    }
  }, {
    key: 'exportCashDeliveries',
    value: function exportCashDeliveries() {
      var _this4 = this;

      // const fromLocationId = this.model.selectedFromLocation.Value;
      var startDate = this.getStartDate();
      var endDate = this.getEndDate();
      var reportPrefix = 'Cash_Deliveries(' + this.model.branch + ')';
      var fromLocationId = this.model.selectedFromLocation ? this.model.selectedFromLocation.Value : null;

      this.model.isExportingCashDeliveries = true;
      this.CashDeliveriesService.exportCashDeliveries(this.model.searchText, fromLocationId, this.model.branch, startDate, endDate, this.reverseSort, this.sortColumn, this.model.timezone, this.customerId, this.model.filterByDeliveryDate, this.model.filterByVaultDate).then(function (data) {
        _this4.downloadFile(fromLocationId, reportPrefix, data.reportData);
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this4.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this4.model.isExportingCashDeliveries = false;
      });
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      if (this.model.currentStats === this.stats.cashDeliveries) return this.getCashDeliveries();else if (this.model.currentStats === this.stats.cashPickups) return this.getCashPickups();
    }
  }, {
    key: 'getOrderType',
    value: function getOrderType(type) {
      return this.ShipmentService.getOrderType(type);
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      if ((this.model.currentStats === this.stats.cashDeliveries && this.model.cashDeliveriesData.length == 0 || this.model.currentStats === this.stats.cashPickups && this.model.cashPickupsData.length == 0) && this.model.searchText) {
        this.model.searchText = null;
      }
      // this.model.searchText = null;
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(locationId) {
      return this.Navigation.goToServiceHistory(locationId, null, true, null);
    }
  }, {
    key: 'tabSelection',
    value: function tabSelection(selectedValue) {
      this.model.pagination.page = 1;
      this.model.currentStats = selectedValue;
      // if (this.model.currentStats === this.stats.cashDeliveries && !this.model.selectedFundingSource) {
      //   this.model.cashDeliveriesData = [];
      // }
      this.sortColumn = "processingDate";
      this.reverseSort = true;

      if (!this.model.filterBy) {
        this.model.filterBy = 'vaultDate';
      } else if (this.model.filterBy && this.model.filterBy !== 'vaultDate') {
        this.model.filterBy = this.model.currentStats === this.stats.cashPickups ? 'pickupDate' : 'deliveryDate';
      }

      this.validateFilterByDate(this.model.filterBy);
      this.loadData();
    }
  }, {
    key: 'getCashPickups',
    value: function getCashPickups() {
      var _this5 = this;

      this.model.loadCashPickups = true;
      var startDate = this.getStartDate();
      var endDate = this.getEndDate();
      var toLocationId = this.model.selectedToLocation ? this.model.selectedToLocation.Value : null;

      this.CashDeliveriesService.cashPickups(this.model.searchText, toLocationId, this.model.branch, startDate, endDate, (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit, this.reverseSort, this.sortColumn, this.model.timezone, this.customerId, this.model.filterByPickupDate, this.model.filterByVaultDate).then(function (data) {
        _this5.model.pagination.total = data.totalRecords;
        _this5.model.cashPickupsData = data.results;
        // this.resetData();
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this5.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this5.model.loadCashPickups = false;
      });
    }
  }, {
    key: 'exportCashPickups',
    value: function exportCashPickups() {
      var _this6 = this;

      // const fundingSourceLocationId = this.model.selectedFundingSource.Value;
      var startDate = this.getStartDate();
      var endDate = this.getEndDate();
      var reportPrefix = 'Cash_Pickups(' + this.model.branch + ')';
      var toLocationId = this.model.selectedToLocation ? this.model.selectedToLocation.Value : null;

      this.model.isExportingCashPickups = true;

      this.CashDeliveriesService.exportCashPickups(this.model.searchText, toLocationId, this.model.branch, startDate, endDate, this.reverseSort, this.sortColumn, this.model.timezone, this.customerId, this.model.filterByPickupDate, this.model.filterByVaultDate).then(function (data) {
        _this6.downloadFile(toLocationId, reportPrefix, data.reportData);
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this6.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this6.model.isExportingCashPickups = false;
      });
    }
  }, {
    key: 'sortData',
    value: function sortData(column) {
      this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
      this.sortColumn = column;
      this.loadData();
    }
  }, {
    key: 'getCashPickupLocations',
    value: function getCashPickupLocations(searchKey, offset) {
      var _this7 = this;

      var startDate = this.getStartDate();
      var endDate = this.getEndDate();
      var selectedToLocation = this.model.selectedToLocation ? this.model.selectedToLocation.Value : null;

      return this.CashDeliveriesService.cashPickupLocations(this.model.branch, startDate, endDate, this.model.defaultPageLimit, offset, true, this.customerId, this.model.filterByPickupDate, this.model.filterByVaultDate).then(function (data) {
        if (offset === 0) {
          _this7.model.cashPickupLocationsObj.totalRecords = data.totalRecords;
          _this7.model.cashPickupLocationsObj.results = _this7.locationMapping(data.results);
        } else {
          var fromLocation = _this7.locationMapping(data.results);
          _this7.model.cashPickupLocationsObj.results = _this7.model.cashPickupLocationsObj.results.concat(fromLocation);
        }

        if (!_this7.isLocationFound(_this7.model.cashPickupLocationsObj.results, selectedToLocation)) _this7.model.selectedToLocation = null;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'getCashDeliveryLocations',
    value: function getCashDeliveryLocations(searchKey, offset) {
      var _this8 = this;

      var startDate = this.getStartDate();
      var endDate = this.getEndDate();
      var selectedFromLocation = this.model.selectedFromLocation ? this.model.selectedFromLocation.Value : null;

      return this.CashDeliveriesService.cashDeliveryLocations(this.model.branch, startDate, endDate, this.model.defaultPageLimit, offset, true, this.customerId, this.model.filterByDeliveryDate, this.model.filterByVaultDate).then(function (data) {
        if (offset === 0) {
          _this8.model.cashDeliveryLocationsObj.totalRecords = data.totalRecords;
          _this8.model.cashDeliveryLocationsObj.results = _this8.locationMapping(data.results);
        } else {
          var fromLocation = _this8.locationMapping(data.results);
          _this8.model.cashDeliveryLocationsObj.results = _this8.model.cashDeliveryLocationsObj.results.concat(fromLocation);
        }

        if (!_this8.isLocationFound(_this8.model.cashDeliveryLocationsObj.results, selectedFromLocation)) _this8.model.selectedFromLocation = '';
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'locationMapping',
    value: function locationMapping(loc) {
      return loc.map(function (data) {
        return {
          Key: data.locationId + " | " + data.locationName,
          Value: data.locationId
        };
      });
    }
  }, {
    key: 'getStartDate',
    value: function getStartDate() {
      if (this.model.filterByVaultDate) {
        return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
      } else {
        return this.model.deliveryPickupDateRangeOptions.startDate ? moment(this.model.deliveryPickupDateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
      }
    }
  }, {
    key: 'getEndDate',
    value: function getEndDate() {
      if (this.model.filterByVaultDate) {
        return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
      } else {
        return this.model.deliveryPickupDateRangeOptions.endDate ? moment(this.model.deliveryPickupDateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
      }
    }
  }, {
    key: 'loadLocationList',
    value: function loadLocationList() {
      if (this.model.currentStats === this.stats.cashDeliveries) {
        this.model.cashDeliveryLocationsObj.results = [];
        return this.getCashDeliveryLocations('', 0);
      } else if (this.model.currentStats === this.stats.cashPickups) {
        this.model.cashPickupLocationsObj.results = [];
        return this.getCashPickupLocations('', 0);
      }
    }
  }, {
    key: 'isLocationFound',
    value: function isLocationFound(results, locationId) {
      if (!locationId) return true;
      var loc = _.find(results, { 'Value': locationId });
      return (typeof loc === 'undefined' ? 'undefined' : (0, _typeof3.default)(loc)) === 'object' ? true : false;
    }
  }, {
    key: 'exportCashTransactions',
    value: function exportCashTransactions() {
      var _this9 = this;

      this.model.isExportingCashTransactions = true;

      var startDate = this.getStartDate();
      var endDate = this.getEndDate();
      var toLocationId = this.model.selectedToLocation ? this.model.selectedToLocation.Value : null;
      var fromLocationId = this.model.selectedFromLocation ? this.model.selectedFromLocation.Value : null;

      this.CashDeliveriesService.exportCashTransactions(this.model.searchText, this.model.currentStats, fromLocationId, toLocationId, this.model.branch, startDate, endDate, this.reverseSort, this.sortColumn, this.model.timezone, this.customerId, this.model.filterByDeliveryDate, this.model.filterByPickupDate, this.model.filterByVaultDate).then(function () {}).catch(function (err) {
        if (err && err.data && err.data.message) {
          return _this9.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        setTimeout(function () {
          _this9.model.isExportingCashTransactions = false;
        });
      });
    }
  }, {
    key: 'goToItemHistory',
    value: function goToItemHistory(trackingId) {
      this.Navigation.goToItemHistory(trackingId, null);
    }
  }, {
    key: 'validateFilterByDate',
    value: function validateFilterByDate(filterBy) {
      if (!filterBy) return;
      this.model.filterBy = filterBy;

      if (filterBy === 'vaultDate') {
        this.model.filterByVaultDate = true;
        this.model.filterByDeliveryDate = false;
        this.model.filterByPickupDate = false;
      } else if (this.model.currentStats === this.stats.cashDeliveries && filterBy === 'deliveryDate') {
        this.model.filterByVaultDate = false;
        this.model.filterByDeliveryDate = true;
        this.model.filterByPickupDate = false;
      } else if (this.model.currentStats === this.stats.cashPickups && filterBy === 'pickupDate') {
        this.model.filterByVaultDate = false;
        this.model.filterByDeliveryDate = false;
        this.model.filterByPickupDate = true;
      }
    }
  }]);
  return CashDeliveriesController;
}();

exports.default = CashDeliveriesController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cash_deliveries = __webpack_require__(1711);

var _cash_deliveries2 = _interopRequireDefault(_cash_deliveries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementCashDeliveriesModule = angular.module('branchManagementCashDeliveries', []).component('branchManagementCashDeliveries', _cash_deliveries2.default).name;

exports.default = branchManagementCashDeliveriesModule;

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contact_request = __webpack_require__(2672);

var _contact_request2 = _interopRequireDefault(_contact_request);

var _contact_request3 = __webpack_require__(1715);

var _contact_request4 = _interopRequireDefault(_contact_request3);

__webpack_require__(2957);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementContactRequestComponent = {
    restrict: "E",
    bindings: {},
    template: _contact_request2.default,
    controller: _contact_request4.default
};

exports.default = branchManagementContactRequestComponent;

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactRequestController = function () {
    /*@ngInject*/
    ContactRequestController.$inject = ["DateUtil", "$translate", "$q", "User", "Modal", "TimezoneList", "SetupService", "ContactRequestService", "RouteService", "CustomerService", "$state", "LocationService", "DataCounter", "Navigation", "UserBranchService", "$rootScope"];
    function ContactRequestController(DateUtil, $translate, $q, User, Modal, TimezoneList, SetupService, ContactRequestService, RouteService, CustomerService, $state, LocationService, DataCounter, Navigation, UserBranchService, $rootScope) {
        (0, _classCallCheck3.default)(this, ContactRequestController);

        this.DateUtil = DateUtil;
        this.$translate = $translate;
        this.User = User;
        this.Modal = Modal;
        this.TimezoneList = TimezoneList;
        this.SetupService = SetupService;
        this.ContactRequestService = ContactRequestService;
        this.RouteService = RouteService;
        this.CustomerService = CustomerService;
        this.LocationService = LocationService;
        this.DataCounter = DataCounter;
        this.$state = $state;
        this.Navigation = Navigation;
        this.UserBranchService = UserBranchService;
        this.$q = $q;
        this.$rootScope = $rootScope;

        this.model = {
            timezoneList: this.TimezoneList.getTimezoneList(),
            contactRequestObj: {
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                loading: false
            },
            routeListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            locationListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null
            },
            loggedInUser: User.getUser().id,
            branchId: User.getUser().branchId,
            customerId: null,
            userBranchList: [],
            timezone: null,
            isExporting: false,
            currentStats: 'pending',
            isCompleted: 0
        };

        this.routeLocalLang = {
            nothingSelected: this.$translate.instant('checkout.selectRoute'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        };
        this.locationLocalLang = {
            nothingSelected: this.$translate.instant('branch_mgmt.items.locations'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        };
        this.branchLocalLang = {
            nothingSelected: this.$translate.instant('common.selectBranch'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        };

        this.stats = {
            pending: 'pending',
            completed: 'completed'
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/contact-request');
    }

    (0, _createClass3.default)(ContactRequestController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.model.loading = true;

            this.$q.all([this.SetupService.get(this.model.branchId), this.UserBranchService.getUserBranches(this.model.loggedInUser), this.routesAndLocationList()]).then(function (data) {
                _this.model.setupDetails = data[0];
                _this.model.userBranchList = data[1].results;

                _this.model.userBranchList.filter(function (branch) {
                    if (branch.branchId == _this.model.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                });

                _this.model.vaultDate = _this.DateUtil.convertToDate(_this.model.setupDetails.currentVaultDate);
                _this.loadDateRangePicker(_this.model.vaultDate, _this.model.dateRangeOptions, 'dateRange');
                _this.model.dateRangeOptions.startDate = moment(_this.model.vaultDate).subtract(30, 'days').format('YYYY-MM-DD 00:00:00');
                _this.model.dateRangeOptions.endDate = moment(_this.model.vaultDate).add(14, 'days').format('YYYY-MM-DD 23:59:59');
                _this.loadData();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this.model.loading = false;
            });
        }
    }, {
        key: 'loadDateRangePicker',
        value: function loadDateRangePicker(date, dateRangeOption, modelVal) {
            var _this2 = this;

            var currentVaultDate = moment(date).format() || moment();
            this.model[modelVal] = {
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this2.reset();
                        _this2.loadData();
                    }
                },
                ranges: {
                    'Running 45 Days': [moment(currentVaultDate).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Year': [moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(locationId) {
            var obj = {
                locationId: locationId,
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.locations');
        }
    }, {
        key: 'downloadFile',
        value: function downloadFile(reportPrefix, reportData) {
            var fileName = reportPrefix.concat('.csv');
            var a = document.createElement("a");
            document.body.appendChild(a);
            var file = new Blob([reportData], { type: 'application/csv' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }
    }, {
        key: 'exportReports',
        value: function exportReports() {
            var _this3 = this;

            var startDate = this.getStartDate();
            var endDate = this.getEndDate();
            var branchIds = this.getSelectedBranches();
            var routeId = this.getSelectedRoutes();
            var locationId = this.getSelectedLocations();
            var title = !this.model.isCompleted ? 'Pending_contact_request_' : 'Completed_contact_request_';
            var reportPrefix = title + '(' + startDate + '_' + endDate + ')';

            this.model.isExporting = true;
            this.ContactRequestService.exportContactRequest(branchIds, routeId, locationId, startDate, endDate, this.model.isCompleted).then(function (data) {
                _this3.downloadFile(reportPrefix, data.reportData);
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this3.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this3.model.isExporting = false;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model.contactRequestObj.pagination.page = 1;
        }
    }, {
        key: 'resetLocationAndRoute',
        value: function resetLocationAndRoute() {
            var _this4 = this;

            setTimeout(function () {
                _this4.model.locationId = [];
                _this4.model.routeId = [];
            });
        }
    }, {
        key: 'routesAndLocationList',
        value: function routesAndLocationList() {
            var _this5 = this;

            setTimeout(function () {
                var branchId = _this5.getSelectedBranches();

                _this5.model.loadingList = true;
                _this5.ContactRequestService.routesAndLocationList(branchId).then(function (data) {
                    _this5.model.contactRequestObj.routeList = _this5.dataMapping(data.routes, 'routeId', 'routeName');
                    _this5.model.contactRequestObj.locationList = _this5.dataMapping(data.locations, 'locationId', 'locationName');
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this5.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this5.model.loadingList = false;
                });
            });
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var _this6 = this;

            setTimeout(function () {
                var startDate = _this6.getStartDate();
                var endDate = _this6.getEndDate();
                var routeId = _this6.getSelectedRoutes();
                var locationId = _this6.getSelectedLocations();
                var branchId = _this6.getSelectedBranches();

                _this6.model.contactRequestObj.loading = true;
                _this6.ContactRequestService.contactRequest(branchId, routeId, locationId, startDate, endDate, _this6.model.isCompleted, (_this6.model.contactRequestObj.pagination.page - 1) * _this6.model.contactRequestObj.pagination.pageLimit, _this6.model.contactRequestObj.pagination.pageLimit).then(function (data) {
                    _this6.model.contactRequestObj.results = data.results;
                    _this6.model.contactRequestObj.pagination.total = data.total;
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this6.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this6.model.contactRequestObj.loading = false;
                });
            });
        }
    }, {
        key: 'getSelectedBranches',
        value: function getSelectedBranches() {
            return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map(function (branch) {
                return branch.branchId;
            }) : null;
        }
    }, {
        key: 'getSelectedRoutes',
        value: function getSelectedRoutes() {
            return Array.isArray(this.model.routeId) ? this.model.routeId.map(function (r) {
                return r.Value;
            }) : null;
        }
    }, {
        key: 'getSelectedLocations',
        value: function getSelectedLocations() {
            return Array.isArray(this.model.locationId) ? this.model.locationId.map(function (l) {
                return l.Value;
            }) : null;
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(locationId) {
            return this.Navigation.goToServiceHistory(locationId, null, true, null);
        }
    }, {
        key: 'goToRouteTab',
        value: function goToRouteTab(routeId, vaultDate) {
            return this.Navigation.goToRouteTab(routeId, vaultDate, true, null);
        }
    }, {
        key: 'getStartDate',
        value: function getStartDate() {
            return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD') : null;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate() {
            return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD') : null;
        }
    }, {
        key: 'printReport',
        value: function printReport() {
            var _this7 = this;

            setTimeout(function () {
                var startDate = _this7.getStartDate();
                var endDate = _this7.getEndDate();
                var routeId = _this7.getSelectedRoutes();
                var locationId = _this7.getSelectedLocations();
                var branchId = _this7.getSelectedBranches();

                _this7.model.isPrint = true;
                _this7.ContactRequestService.contactRequest(branchId, routeId, locationId, startDate, endDate, _this7.model.isCompleted, 0, 5000).then(function (data) {
                    var url = _this7.$state.href('contactRequestPrint');
                    window.w = window.open(url, '_blank');
                    window.w.printData = {
                        results: data.results, startDate: startDate, endDate: endDate, isCompleted: _this7.model.isCompleted
                    };
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this7.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this7.model.isPrint = false;
                });
            });
        }
    }, {
        key: 'dataMapping',
        value: function dataMapping(data, value, label) {
            return data.map(function (d) {
                return {
                    Key: d[value] + ' | ' + d[label],
                    Value: d[value]
                };
            });
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.loadData();
        }
    }, {
        key: 'markCompleteContactRequest',
        value: function markCompleteContactRequest(id) {
            var _this8 = this;

            this.model.markComplete = true;
            this.Modal.confirmSupervisor('mark-complete-contact-request', null, function (_ref) {
                var modal = _ref.modal,
                    supId = _ref.supId;

                _this8.ContactRequestService.markCompleteContactRequest(id, supId).then(function () {
                    _this8.loadData();
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        _this8.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    modal.close();
                    _this8.model.markComplete = false;
                });
            }, function (_ref2) {
                var modal = _ref2.modal;

                modal.close();
                _this8.model.markComplete = false;
            });
        }
    }, {
        key: 'tabSelection',
        value: function tabSelection() {
            this.model.contactRequestObj.pagination.page = 1;
            if (this.model.currentStats === this.stats.pending) this.model.isCompleted = 0;else if (this.model.currentStats === this.stats.completed) this.model.isCompleted = 1;
            this.loadData();
        }
    }]);
    return ContactRequestController;
}();

exports.default = ContactRequestController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contact_request = __webpack_require__(1714);

var _contact_request2 = _interopRequireDefault(_contact_request);

var _print = __webpack_require__(1719);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementContactRequestModule = angular.module('branchManagementContactRequest', [_print2.default]).component('branchManagementContactRequest', _contact_request2.default).name;

exports.default = branchManagementContactRequestModule;

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contact_request_print = __webpack_require__(2673);

var _contact_request_print2 = _interopRequireDefault(_contact_request_print);

var _contact_request_print3 = __webpack_require__(1718);

var _contact_request_print4 = _interopRequireDefault(_contact_request_print3);

__webpack_require__(2958);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printComponent = {
    restrict: 'E',
    bindings: {},
    template: _contact_request_print2.default,
    controller: _contact_request_print4.default
};

exports.default = printComponent;

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintController = function () {
    /*@ngInject*/
    PrintController.$inject = ["$translate"];
    function PrintController($translate) {
        (0, _classCallCheck3.default)(this, PrintController);

        this.$translate = $translate;
        this.model = {
            contactRequestObj: null
        };
    }

    (0, _createClass3.default)(PrintController, [{
        key: "$onInit",
        value: function $onInit() {
            if (window.opener && window.opener.w && window.opener.w.printData) {
                this.model.contactRequestObj = window.opener.w.printData;
                this.print();
            }
        }
    }, {
        key: "print",
        value: function print() {
            setTimeout(function () {
                window.print();
            }, 1500);
        }
    }]);
    return PrintController;
}();

exports.default = PrintController;

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contact_request_print = __webpack_require__(1717);

var _contact_request_print2 = _interopRequireDefault(_contact_request_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printModule = angular.module('contactRequestPrint', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/branchManagement.contactRequest');

    $stateProvider.state('contactRequestPrint', {
        url: '/print-contact-request-report',
        component: 'contactRequestPrint',
        data: {
            requireLogin: true,
            requireACL: 'branch_mgmt_contact_request.all'
        }
    });
}]).component('contactRequestPrint', _contact_request_print2.default).name;

exports.default = printModule;

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _count_variances = __webpack_require__(2674);

var _count_variances2 = _interopRequireDefault(_count_variances);

var _count_variances3 = __webpack_require__(1721);

var _count_variances4 = _interopRequireDefault(_count_variances3);

__webpack_require__(2959);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementCountVariancesComponent = {
    restrict: "E",
    bindings: {},
    template: _count_variances2.default,
    controller: _count_variances4.default
};

exports.default = branchManagementCountVariancesComponent;

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountVariancesController = function () {
    /*@ngInject*/

    CountVariancesController.$inject = ["DateUtil", "$translate", "$q", "User", "Modal", "TimezoneList", "SetupService", "UsersService", "UserBranchService", "CountVariancesService", "DataCounter", "$state", "Navigation", "$rootScope"];
    function CountVariancesController(DateUtil, $translate, $q, User, Modal, TimezoneList, SetupService, UsersService, UserBranchService, CountVariancesService, DataCounter, $state, Navigation, $rootScope) {
        (0, _classCallCheck3.default)(this, CountVariancesController);

        this.DateUtil = DateUtil;
        this.$translate = $translate;
        this.User = User;
        this.Modal = Modal;
        this.TimezoneList = TimezoneList;
        this.SetupService = SetupService;
        this.UsersService = UsersService;
        this.UserBranchService = UserBranchService;
        this.CountVariancesService = CountVariancesService;
        this.DataCounter = DataCounter;
        this.$state = $state;
        this.$q = $q;
        this.Navigation = Navigation;
        this.$rootScope = $rootScope;

        this.model = {
            timezoneList: this.TimezoneList.getTimezoneList(),
            countVariancesObj: {
                totalRecords: 0,
                results: []
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null
            },
            loggedInUser: User.getUser().id,
            branch: User.getUser().branchId,
            userBranchList: [],
            timezone: null,
            sortColumn: "countedAt",
            reverseSort: true,
            loadCountVariances: false,
            isExporting: false
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/count-variances');
    }

    (0, _createClass3.default)(CountVariancesController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.model.loading = true;
            this.$q.all([this.SetupService.get(this.model.branch), this.UsersService.getUserFieldData(this.model.loggedInUser), this.UserBranchService.getUserBranches(this.model.loggedInUser)]).then(function (data) {
                _this.model.setupDetails = data[0];
                _this.model.userDetails = data[1];
                _this.model.userBranchList = data[2].results;
                _this.model.vaultDate = _this.DateUtil.convertToDate(_this.model.setupDetails.currentVaultDate);
                _this.model.timezone = _this.model.userDetails && _this.model.userDetails.timezone ? _this.model.userDetails.timezone : moment.tz.guess();

                _this.model.userBranchList.filter(function (branch) {
                    if (branch.branchId == _this.model.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                });

                _this.loadDateRangePicker(_this.model.vaultDate, _this.model.dateRangeOptions, 'dateRange');
                _this.model.dateRangeOptions.startDate = moment(_this.model.vaultDate).subtract(30, 'days').format('YYYY-MM-DD 00:00:00');
                _this.model.dateRangeOptions.endDate = moment(_this.model.vaultDate).add(14, 'days').format('YYYY-MM-DD 23:59:59');

                _this.loadData();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this.model.loading = false;
            });
        }
    }, {
        key: 'loadDateRangePicker',
        value: function loadDateRangePicker(date, dateRangeOption, modelVal) {
            var _this2 = this;

            var currentVaultDate = moment(date).format() || moment();
            this.model[modelVal] = {
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this2.loadData();
                    }
                },
                ranges: {
                    'Running 45 Days': [moment(currentVaultDate).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Year': [moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            this.model.pagination.page = 1;
            this.getCountVariances();
        }
    }, {
        key: 'getCountVariances',
        value: function getCountVariances() {
            var _this3 = this;

            setTimeout(function () {
                var startDate = _this3.getStartDate();
                var endDate = _this3.getEndDate();
                var branches = _this3.model.selectedBranch.map(function (branchObj) {
                    return branchObj.branchId;
                });

                _this3.model.loadCountVariances = true;
                _this3.CountVariancesService.countVariances(_this3.model.searchText, branches, startDate, endDate, (_this3.model.pagination.page - 1) * _this3.model.pagination.pageLimit, _this3.model.pagination.pageLimit, _this3.reverseSort, _this3.sortColumn, _this3.model.timezone).then(function (data) {
                    _this3.model.pagination.total = data.totalRecords;
                    _this3.model.countVariancesObj.results = data.results;
                    _this3.model.countVariancesObj.totalRecords = data.totalRecords;
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this3.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this3.model.loadCountVariances = false;
                    setTimeout(function () {
                        var el = document.getElementById('countVariancesSearch');
                        if (el) el.focus();
                    }, 100);
                });
            });
        }
    }, {
        key: 'getStartDate',
        value: function getStartDate() {
            return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate() {
            return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
        }
    }, {
        key: 'sortData',
        value: function sortData(column) {
            this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
            this.sortColumn = column;
            this.loadData();
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(locationId) {
            var obj = {
                locationId: locationId,
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.locations');
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.getCountVariances();
        }
    }, {
        key: 'exportData',
        value: function exportData() {
            var _this4 = this;

            var reportPrefix = 'Count_Variances(' + moment().format('YYYY-MM-DD_HH:mm') + ')';
            var branchIds = this.model.selectedBranch.map(function (b) {
                return b.branchId;
            });
            var startDate = this.getStartDate();
            var endDate = this.getEndDate();

            this.model.isExporting = true;

            this.CountVariancesService.exportCountVariances(this.model.searchText, branchIds, startDate, endDate, this.reverseSort, this.sortColumn, this.model.timezone).then(function (data) {
                _this4.downloadFile(reportPrefix, data.reportData);
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this4.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this4.model.isExporting = false;
            });
        }
    }, {
        key: 'downloadFile',
        value: function downloadFile(reportPrefix, reportData) {
            var fileName = reportPrefix.concat('.csv');
            var a = document.createElement("a");
            document.body.appendChild(a);
            var file = new Blob([reportData], { type: 'application/csv' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }
    }, {
        key: 'getComments',
        value: function getComments(data) {
            this.Modal.confirm({
                header: this.$translate.instant('common.comment'),
                message: data.comment,
                callback: function callback(_ref) {
                    var modal = _ref.modal;

                    modal.close();
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    modal.close();
                },
                buttons: ['common.close'],
                type: 'success'
            });
        }
    }, {
        key: 'goToUserTab',
        value: function goToUserTab(userId) {
            if (!userId) return;
            this.Navigation.goToUserTab(userId, null);
        }
    }, {
        key: 'showReceipt',
        value: function showReceipt(pickupImageName, trackingId) {
            if (!pickupImageName) return;
            var shipmentData = {
                pickupImageName: pickupImageName,
                trackingId: trackingId
            };
            this.Modal.atmResidualReceipt(shipmentData, function (_ref3) {
                var modal = _ref3.modal;
            }, function (_ref4) {
                var modal = _ref4.modal;

                modal.close();
            });
        }
    }]);
    return CountVariancesController;
}();

exports.default = CountVariancesController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _count_variances = __webpack_require__(1720);

var _count_variances2 = _interopRequireDefault(_count_variances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementCountVariancesModule = angular.module("branchManagementCountVariances", []).component("branchManagementCountVariances", _count_variances2.default).name;

exports.default = branchManagementCountVariancesModule;

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _customer_pickup_reports = __webpack_require__(2675);

var _customer_pickup_reports2 = _interopRequireDefault(_customer_pickup_reports);

var _customer_pickup_reports3 = __webpack_require__(1724);

var _customer_pickup_reports4 = _interopRequireDefault(_customer_pickup_reports3);

__webpack_require__(2960);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementCustomerPickupReportsComponent = {
    restrict: "E",
    bindings: {},
    template: _customer_pickup_reports2.default,
    controller: _customer_pickup_reports4.default
};

exports.default = branchManagementCustomerPickupReportsComponent;

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerPickupReportsController = function () {
    /*@ngInject*/
    CustomerPickupReportsController.$inject = ["DateUtil", "$translate", "$q", "User", "Modal", "TimezoneList", "SetupService", "ShiptypeService", "RouteService", "CustomerService", "$state", "LocationService", "DataCounter", "Navigation", "$rootScope"];
    function CustomerPickupReportsController(DateUtil, $translate, $q, User, Modal, TimezoneList, SetupService, ShiptypeService, RouteService, CustomerService, $state, LocationService, DataCounter, Navigation, $rootScope) {
        (0, _classCallCheck3.default)(this, CustomerPickupReportsController);

        this.DateUtil = DateUtil;
        this.$translate = $translate;
        this.User = User;
        this.Modal = Modal;
        this.TimezoneList = TimezoneList;
        this.SetupService = SetupService;
        this.ShiptypeService = ShiptypeService;
        this.RouteService = RouteService;
        this.CustomerService = CustomerService;
        this.LocationService = LocationService;
        this.DataCounter = DataCounter;
        this.$state = $state;
        this.Navigation = Navigation;
        this.$q = $q;
        this.$rootScope = $rootScope;

        this.model = {
            timezoneList: this.TimezoneList.getTimezoneList(),
            customerPickupReportObj: {
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                loading: false
            },
            shiptypeObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            routeListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            customerListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            locationListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null
            },
            loggedInUser: User.getUser().id,
            branchId: User.getUser().branchId,
            isCustomerUser: this.User.getUser().customerUser,
            customerId: null,
            userBranchList: [],
            timezone: null,
            isExporting: false,
            branchTimeZone: null
        };
        this.shipTypeLocalLang = {
            nothingSelected: this.$translate.instant('common.select_shiptype'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        };
        this.routeLocalLang = {
            nothingSelected: this.$translate.instant('checkout.selectRoute'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        };
        this.locationLocalLang = {
            nothingSelected: this.$translate.instant('branch_mgmt.items.locations'),
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search')
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/customer-pickup-reports');
    }

    (0, _createClass3.default)(CustomerPickupReportsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.model.loading = true;
            if (this.model.isCustomerUser) {
                this.model.customerId = {
                    Key: this.model.isCustomerUser ? this.User.getUser().firstName + ' | ' + this.User.getUser().lastName : null,
                    Value: this.model.isCustomerUser ? this.User.getUser().customerId : null
                };
            }

            this.$q.all([this.SetupService.get(this.model.branchId), this.loadshiptype('', 0), this.getRouteList('', 0), this.getCustomerList('', 0), this.getLocationList('', 0)]).then(function (data) {
                _this.model.setupDetails = data[0];
                _this.model.branchTimeZone = data[0].timezone;
                _this.model.vaultDate = _this.DateUtil.convertToDate(_this.model.setupDetails.currentVaultDate);
                _this.loadDateRangePicker(_this.model.vaultDate, _this.model.dateRangeOptions, 'dateRange');
                _this.model.dateRangeOptions.startDate = moment(_this.model.vaultDate).subtract(30, 'days').format('YYYY-MM-DD 00:00:00');
                _this.model.dateRangeOptions.endDate = moment(_this.model.vaultDate).add(14, 'days').format('YYYY-MM-DD 23:59:59');

                _this.customerPickupReport();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this.model.loading = false;
            });
        }
    }, {
        key: 'loadDateRangePicker',
        value: function loadDateRangePicker(date, dateRangeOption, modelVal) {
            var _this2 = this;

            var currentVaultDate = moment(date).format() || moment();
            this.model[modelVal] = {
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this2.reset();
                        _this2.customerPickupReport();
                    }
                },
                ranges: {
                    'Running 45 Days': [moment(currentVaultDate).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Year': [moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: 'loadCustomerReports',
        value: function loadCustomerReports() {}
    }, {
        key: 'loadshiptype',
        value: function loadshiptype(searchKey, offset) {
            var _this3 = this;

            searchKey = searchKey || '';

            var shiptypeSearchObj = {
                queryJSON: {
                    rules: [{
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'description',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };

            this.ShiptypeService.all(shiptypeSearchObj, offset, 100).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this3.model.shiptypeObj.totalRecords = data.total;
                    _this3.model.shiptypeObj.results = _this3.mappingShiptypes(data.results);
                } else {
                    var shiptype = _this3.mappingShiptypes(data.results);
                    _this3.model.shiptypeObj.results = _this3.model.shiptypeObj.results.concat(shiptype);
                }
            });
        }
    }, {
        key: 'mappingShiptypes',
        value: function mappingShiptypes(shiptype) {
            return shiptype.map(function (shiptypes) {
                return {
                    Key: shiptypes.id + " | " + shiptypes.description,
                    Value: shiptypes.id
                };
            });
        }
    }, {
        key: 'getRouteList',
        value: function getRouteList(searchKey, offset) {
            var _this4 = this;

            searchKey = searchKey || '';

            var routeSearchObj = {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };

            this.model.routeListObj.loading = true;
            return this.RouteService.all(routeSearchObj, offset, 10000).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this4.model.routeListObj.totalRecords = data.total;
                    _this4.model.routeListObj.results = _this4.routeMapping(data.results);
                } else {
                    var routes = _this4.routeMapping(data.results);
                    _this4.model.routeListObj.results = _this4.model.routeListObj.results.concat(routes);
                }
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this4.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this4.model.routeListObj.loading = false;
            });
        }
    }, {
        key: 'routeMapping',
        value: function routeMapping(routes) {
            return routes.map(function (route) {
                return {
                    Key: route.name,
                    Value: route.id
                };
            });
        }
    }, {
        key: 'getCustomerList',
        value: function getCustomerList(searchKey, offset) {
            var _this5 = this;

            searchKey = searchKey || '';

            var customerSearchObj = {
                queryJSON: {
                    rules: [{
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };

            this.model.customerListObj.loading = true;
            return this.CustomerService.all(customerSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this5.model.customerListObj.totalRecords = data.total;
                    _this5.model.customerListObj.results = _this5.customerMapping(data.results);
                } else {
                    var customers = _this5.customerMapping(data.results);
                    _this5.model.customerListObj.results = _this5.model.customerListObj.results.concat(customers);
                }
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this5.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this5.model.customerListObj.loading = false;
            });
        }
    }, {
        key: 'customerMapping',
        value: function customerMapping(customers) {
            return customers.map(function (customer) {
                return {
                    Key: customer.name,
                    Value: customer.id
                };
            });
        }
    }, {
        key: 'getLocationList',
        value: function getLocationList(searchKey, offset) {
            var _this6 = this;

            searchKey = searchKey || '';

            var searchObj = {
                queryJSON: {
                    rules: [
                    // {
                    //     field: 'branchId',
                    //     condition: '=',
                    //     data: this.model.branchId
                    // },
                    {
                        field: 'customerId',
                        condition: '!=',
                        data: null
                    }, {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };

            if (this.model.customerId) {
                searchObj.queryJSON.rules.push({
                    field: 'customerId',
                    condition: '=',
                    data: this.model.customerId.Value
                });
            }

            this.model.locationListObj.loading = true;
            return this.LocationService.all(searchObj, offset, 10000).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this6.model.locationListObj.totalRecords = data.total;
                    _this6.model.locationListObj.results = _this6.locationMapping(data.results);
                } else {
                    var routes = _this6.locationMapping(data.results);
                    _this6.model.locationListObj.results = _this6.model.locationListObj.results.concat(routes);
                }
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this6.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this6.model.locationListObj.loading = false;
            });
        }
    }, {
        key: 'locationMapping',
        value: function locationMapping(locations) {
            return locations.map(function (loc) {
                return {
                    Key: loc.id + ' | ' + loc.name,
                    Value: loc.id
                };
            });
        }
    }, {
        key: 'customerPickupReport',
        value: function customerPickupReport() {
            var _this7 = this;

            setTimeout(function () {
                var startDate = _this7.getStartDate();
                var endDate = _this7.getEndDate();
                var shiptypeId = _this7.model.shiptypeId.length ? _this7.model.shiptypeId.map(function (s) {
                    return s.Value;
                }) : null;
                var routeId = _this7.model.routeId.length ? _this7.model.routeId.map(function (r) {
                    return r.Value;
                }) : null;
                var customerId = _this7.model.customerId ? _this7.model.customerId.Value : null;
                var locationId = _this7.model.locationId.length ? _this7.model.locationId.map(function (l) {
                    return l.Value;
                }) : null;

                _this7.model.customerPickupReportObj.loading = true;
                _this7.CustomerService.customerPickupReport(_this7.model.searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId, (_this7.model.customerPickupReportObj.pagination.page - 1) * _this7.model.customerPickupReportObj.pagination.pageLimit, _this7.model.customerPickupReportObj.pagination.pageLimit).then(function (data) {
                    _this7.model.customerPickupReportObj.pagination.total = data.totalRecords;
                    _this7.model.customerPickupReportObj.results = data.results;
                    _this7.model.customerPickupReportObj.totalRecords = data.totalRecords;
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this7.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this7.model.customerPickupReportObj.loading = false;
                });
            });
        }
    }, {
        key: 'getStartDate',
        value: function getStartDate() {
            return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD') : null;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate() {
            return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD') : null;
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.customerPickupReport();
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(locationId) {
            var obj = {
                locationId: locationId,
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.locations');
        }
    }, {
        key: 'goToItemHistory',
        value: function goToItemHistory(trackingId) {
            this.Navigation.goToItemHistory(trackingId, null);
        }
    }, {
        key: 'downloadFile',
        value: function downloadFile(reportPrefix, reportData) {
            var fileName = reportPrefix.concat('.csv');
            var a = document.createElement("a");
            document.body.appendChild(a);
            var file = new Blob([reportData], { type: 'application/csv' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }
    }, {
        key: 'exportReports',
        value: function exportReports() {
            var _this8 = this;

            var startDate = this.getStartDate();
            var endDate = this.getEndDate();
            var shiptypeId = this.model.shiptypeId.length ? this.model.shiptypeId.map(function (s) {
                return s.Value;
            }) : null;
            var routeId = this.model.routeId ? this.model.routeId.Value : null;
            var customerId = this.model.customerId ? this.model.customerId.Value : null;
            var locationId = this.model.locationId ? this.model.locationId.Value : null;
            var reportPrefix = 'Customer_Pickup_reports_' + (customerId ? customerId + "_" : '') + '(' + startDate + '_' + endDate + ')';

            this.model.isExporting = true;
            this.CustomerService.exportCustomerPickupReport(this.model.searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId, this.model.branchTimeZone).then(function (data) {
                _this8.downloadFile(reportPrefix, data.reportData);
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this8.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this8.model.isExporting = false;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model.customerPickupReportObj.pagination.page = 1;
        }
    }, {
        key: 'resetLocation',
        value: function resetLocation() {
            var _this9 = this;

            setTimeout(function () {
                _this9.model.locationId = [];
            });
        }
    }, {
        key: 'printReport',
        value: function printReport() {
            var _this10 = this;

            setTimeout(function () {
                var startDate = _this10.getStartDate();
                var endDate = _this10.getEndDate();
                var shiptypeId = _this10.model.shiptypeId.length ? _this10.model.shiptypeId.map(function (s) {
                    return s.Value;
                }) : null;
                var routeId = _this10.model.routeId.length ? _this10.model.routeId.map(function (r) {
                    return r.Value;
                }) : null;
                var customerId = _this10.model.customerId ? _this10.model.customerId.Value : null;
                var locationId = _this10.model.locationId.length ? _this10.model.locationId.map(function (l) {
                    return l.Value;
                }) : null;

                _this10.model.isPrint = true;
                _this10.CustomerService.customerPickupReport(_this10.model.searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId, 0, 10000).then(function (data) {
                    var group = _.groupBy(data.results, 'customerId');
                    var keys = (0, _keys2.default)(group);
                    var reportData = [];

                    keys.forEach(function (key) {
                        var totalAmount = 0;
                        group[key].forEach(function (d) {
                            return totalAmount += d.amount;
                        });
                        reportData.push({
                            customer: group[key][0].customerId + ' | ' + group[key][0].customerName,
                            results: group[key],
                            totalRecords: group[key].length,
                            totalAmount: totalAmount
                        });
                    });

                    var url = _this10.$state.href('customerReportPrint');
                    window.w = window.open(url, '_blank');
                    window.w.printData = {
                        results: reportData,
                        startDate: _this10.getStartDate(),
                        endDate: _this10.getEndDate(),
                        branchTimeZone: _this10.model.branchTimeZone
                    };
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this10.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this10.model.isPrint = false;
                });
            });
        }
    }, {
        key: 'formattedDate',
        value: function formattedDate(date) {
            var fromVault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var validatationTime = moment.utc(date).format('HH:mm:ss');
            if (validatationTime === '00:00:00') {
                return fromVault ? moment.utc(date).format('YYYY-MM-DD') : moment.utc(date).format('YYYY-MM-DD | hh:mm a');
            } else {
                return fromVault ? this.DateUtil.convertDateTime(date, this.model.branchTimeZone, 'YYYY-MM-DD') : this.DateUtil.convertDateTime(date, this.model.branchTimeZone, 'YYYY-MM-DD | hh:mm a');
            }
        }
    }]);
    return CustomerPickupReportsController;
}();

exports.default = CustomerPickupReportsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _customer_pickup_reports = __webpack_require__(1723);

var _customer_pickup_reports2 = _interopRequireDefault(_customer_pickup_reports);

var _print = __webpack_require__(1728);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementCustomerPickupReportsModule = angular.module('branchManagementCustomerPickupReports', [_print2.default]).component('branchManagementCustomerPickupReports', _customer_pickup_reports2.default).name;

exports.default = branchManagementCustomerPickupReportsModule;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _customer_report = __webpack_require__(2676);

var _customer_report2 = _interopRequireDefault(_customer_report);

var _customer_report3 = __webpack_require__(1727);

var _customer_report4 = _interopRequireDefault(_customer_report3);

__webpack_require__(2961);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printComponent = {
    restrict: 'E',
    bindings: {},
    template: _customer_report2.default,
    controller: _customer_report4.default
};

exports.default = printComponent;

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintController = function () {
    /*@ngInject*/
    PrintController.$inject = ["$translate", "DateUtil"];
    function PrintController($translate, DateUtil) {
        (0, _classCallCheck3.default)(this, PrintController);

        this.$translate = $translate;
        this.DateUtil = DateUtil;
        this.model = {
            reportDataObj: null,
            branchTimeZone: null
        };
    }

    (0, _createClass3.default)(PrintController, [{
        key: '$onInit',
        value: function $onInit() {
            if (window.opener && window.opener.w && window.opener.w.printData) {
                this.model.reportDataObj = window.opener.w.printData;
                this.model.branchTimeZone = window.opener.w.printData.branchTimeZone;
                this.print();
            }
        }
    }, {
        key: 'print',
        value: function print() {
            setTimeout(function () {
                window.print();
            }, 1500);
        }
    }, {
        key: 'formattedDate',
        value: function formattedDate(date) {
            var fromVault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var validatationTime = moment.utc(date).format('HH:mm:ss');
            if (validatationTime === '00:00:00') {
                return fromVault ? moment.utc(date).format('YYYY-MM-DD') : moment.utc(date).format('YYYY-MM-DD | hh:mm a');
            } else {
                return fromVault ? this.DateUtil.convertDateTime(date, this.model.branchTimeZone, 'YYYY-MM-DD') : this.DateUtil.convertDateTime(date, this.model.branchTimeZone, 'YYYY-MM-DD | hh:mm a');
            }
        }
    }]);
    return PrintController;
}();

exports.default = PrintController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _customer_report = __webpack_require__(1726);

var _customer_report2 = _interopRequireDefault(_customer_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printModule = angular.module('customerReportPrint', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/branchManagement.customerPickupReports');

    $stateProvider.state('customerReportPrint', {
        url: '/print-customer-report',
        component: 'customerReportPrint',
        data: {
            requireLogin: true,
            requireACL: 'branch_mgmt_customer_pickup_reports.all'
        }
    });
}]).component('customerReportPrint', _customer_report2.default).name;

exports.default = printModule;

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _daily_balance_sheet = __webpack_require__(2677);

var _daily_balance_sheet2 = _interopRequireDefault(_daily_balance_sheet);

var _daily_balance_sheet3 = __webpack_require__(1730);

var _daily_balance_sheet4 = _interopRequireDefault(_daily_balance_sheet3);

__webpack_require__(2962);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchMgmtDailyBalanceSheetComponent = {
  restrict: "E",
  bindings: {},
  template: _daily_balance_sheet2.default,
  controller: _daily_balance_sheet4.default
};

exports.default = branchMgmtDailyBalanceSheetComponent;

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DailyBalanceSheetController = function () {
    /*@ngInject*/
    DailyBalanceSheetController.$inject = ["$state", "$stateParams", "$location", "$translate", "$q", "User", "SetupService", "DateUtil", "CurrencyService", "BranchFundingSourceService", "DailyBalanceSheetService", "Modal", "UserBranchFundingSourceService", "DataCounter", "$rootScope", "DenominationService"];
    function DailyBalanceSheetController($state, $stateParams, $location, $translate, $q, User, SetupService, DateUtil, CurrencyService, BranchFundingSourceService, DailyBalanceSheetService, Modal, UserBranchFundingSourceService, DataCounter, $rootScope, DenominationService) {
        (0, _classCallCheck3.default)(this, DailyBalanceSheetController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.$translate = $translate;
        this.$q = $q;
        this.User = User;
        this.SetupService = SetupService;
        this.DateUtil = DateUtil;
        this.CurrencyService = CurrencyService;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.DailyBalanceSheetService = DailyBalanceSheetService;
        this.UserBranchFundingSourceService = UserBranchFundingSourceService;
        this.Modal = Modal;
        this.DenominationService = DenominationService;
        this.denominationAllType = [];
        this.balanceSheetData = '';
        this.currency = '';
        this.total = 0;
        this.isError = true;
        this.DataCounter = DataCounter;
        this.$rootScope = $rootScope;
        this.model = {
            stats: 'regular',
            branchId: User.getUser().branchId,
            date: null,
            fundingSourceId: null,
            currency: null,
            loggedInUserId: User.getUser().id
        };

        this.allCurrency = [];
        this.filteredCurrency = [];

        this.stats = {
            regular: 'regular',
            emergency: 'emergency'
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/daily-balance-sheet');
    }

    (0, _createClass3.default)(DailyBalanceSheetController, [{
        key: 'setCurrencySymbol',
        value: function setCurrencySymbol(currencyId) {
            if (!currencyId || !this.allCurrency || !this.allCurrency.length) {
                this.currency = '$';
                return;
            }

            var selectedCurrency = this.allCurrency.find(function (c) {
                return c.id === currencyId;
            });
            this.currency = selectedCurrency && selectedCurrency.symbol ? selectedCurrency.symbol : '$';
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.dataObj = this.DataCounter.getData();

            this.$q.all([this.SetupService.get(this.model.branchId), this.CurrencyService.all(null, 0, 100), this.DailyBalanceSheetService.getEarliestVaultDate(this.model.branchId), this.DenominationService.all(null, 0, 1000)]).then(function (data) {
                if (_this.dataObj && _this.dataObj.isRedirected) {
                    _this.model.date = _this.DateUtil.convertToDate(_this.dataObj.vaultDate);
                    _this.currentVaultDate = moment(_this.model.date).format('YYYY-MM-DD');
                } else {
                    _this.model.date = _this.DateUtil.convertToDate(data[0].currentVaultDate);
                    _this.currentVaultDate = moment(_this.model.date).format('YYYY-MM-DD');
                }
                if (data[2] && data[2].earliestVaultDate) {
                    _this.minVaultDate = {
                        minDate: data[2].earliestVaultDate
                    };
                }
                _this.allCurrency = data[1].results.filter(function (obj) {
                    return data[0].availableCurrencyIds && data[0].availableCurrencyIds.includes(obj.id);
                });
                _this.branchTimezone = data[0].timezone;
                _this.denominationAllType = data[3].results;
            }).then(function () {
                _this.getBranchFundingSource('', 0).then(function () {
                    if (_this.locationLists.length === 1) {
                        _this.model.fundingSourceId = _this.locationLists[0];
                        _this.filterCurrenciesByBFS();
                        _this.vaultBalance();
                    } else {
                        _this.autoLoadDVBHistory();
                    }
                });
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'tabSelection',
        value: function tabSelection(selectedValue) {
            this.model.stats = selectedValue;
            this.vaultBalance();
        }

        // BranchFundingSource search obj

    }, {
        key: 'branchFundingSourceObj',
        value: function branchFundingSourceObj(searchKey) {
            searchKey = searchKey || '';
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: "id",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "sourceName",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'mappingBranchFundingSource',
        value: function mappingBranchFundingSource(locations) {
            return locations.map(function (location) {
                return {
                    Key: location.id + " | " + location.sourceName,
                    Value: location.id,
                    manualDeposit: location.manualDeposit,
                    dataObj: location
                };
            });
        }

        // Load branchFundingSource data

    }, {
        key: 'getBranchFundingSource',
        value: function getBranchFundingSource(searchKey, offset) {
            var _this2 = this;

            // const loadLocationData = this.branchFundingSourceObj(searchKey);
            return this.UserBranchFundingSourceService.getBranchFundingSource(this.model.loggedInUserId, this.model.branchId).then(function (data) {
                if (offset === 0) {
                    _this2.totalRecords = data.total;
                    _this2.locationLists = _this2.mappingBranchFundingSource(data.results);
                } else {
                    var locations = _this2.mappingBranchFundingSource(data.results);
                    _this2.locationLists = _this2.locationLists.concat(locations);
                }
            });
        }

        // Print Manifest of daily balance sheet

    }, {
        key: 'printManifest',
        value: function printManifest() {
            var obj = {
                data: this.balanceSheetData,
                currency: this.currency,
                currencyId: this.model.currency,
                branch: this.model.branchId,
                vaultDate: moment(this.model.date).format('MM/DD/YYYY'),
                manualDeposit: this.model.fundingSourceId.manualDeposit
            };
            var new_path = this.$state.href('printDailyBalanceSheet');
            window.w = window.open(new_path, '_blank');
            window.w.printData = obj;
        }
    }, {
        key: 'printManifestReport',
        value: function printManifestReport() {
            var obj = {
                data: this.balanceSheetData,
                currency: this.currency,
                currencyId: this.model.currency,
                branch: this.model.branchId,
                vaultDate: moment(this.model.date).format('MM/DD/YYYY'),
                vaultDateRaw: moment(this.model.date).format('YYYY-MM-DD'),
                manualDeposit: this.model.fundingSourceId.manualDeposit,
                fundingSourceId: this.model.fundingSourceId.Value,
                fundingSourceName: this.model.fundingSourceId.dataObj.sourceName,
                branchTimezone: this.branchTimezone
            };
            var new_path = this.$state.href('printDailyBalanceSheetReport');
            window.w = window.open(new_path, '_blank');
            window.w.printData = obj;
        }
    }, {
        key: 'filterCurrenciesByBFS',
        value: function filterCurrenciesByBFS() {
            var _this3 = this;

            if (!this.model.fundingSourceId) {
                this.filteredCurrency = [];
                this.model.currency = null;
                this.currency = '';
                return;
            }

            var selectedBFS = this.locationLists.find(function (bfs) {
                return bfs.Value === _this3.model.fundingSourceId.Value;
            });
            var currencyId = selectedBFS ? selectedBFS.dataObj.currencyId : null;

            if (currencyId) {
                this.filteredCurrency = this.allCurrency.filter(function (currency) {
                    return currency.id === currencyId;
                });
                if (this.filteredCurrency.length > 0) {
                    this.model.currency = currencyId;
                    this.setCurrencySymbol(currencyId);
                }
            } else {
                this.filteredCurrency = [];
                this.model.currency = null;
                this.currency = '';
            }
        }

        // get vault balance 

    }, {
        key: 'vaultBalance',
        value: function vaultBalance() {
            var _this4 = this;

            this.totalLiability = 0;

            if (!this.model.fundingSourceId) {
                return;
            }

            this.model.loading = true;

            this.setCurrencySymbol(this.model.currency);

            var currentVaultDate = moment(this.model.date).format('YYYY-MM-DD');
            this.DailyBalanceSheetService.getVaultBalance(this.model.branchId, this.model.fundingSourceId.Value, this.model.stats, this.model.currency, currentVaultDate, this.model.fundingSourceId.manualDeposit).then(function (data) {
                _this4.model.loading = false;
                _this4.isError = false;
                _this4.balanceSheetData = data;
                _this4.totalLiability = data.totalLiability;
                _this4.resetFilter();
            }).catch(function (err) {
                _this4.isError = true;
                if (err && err.data && err.data.message) {
                    return _this4.Modal.errorModal('error.' + err.data.message);
                }
            });
        }
    }, {
        key: 'sheetInfo',
        value: function sheetInfo(infoFor, title) {
            var _this5 = this;

            var infoObject = [],
                data = {
                branchId: this.model.branchId,
                fundingSourceId: this.model.fundingSourceId.Value,
                currencyId: this.model.currency,
                denominationId: null,
                account: this.model.stats,
                vaultDate: moment(this.model.date).format('YYYY-MM-DD'),
                infoFor: infoFor,
                manualDeposit: this.model.fundingSourceId.manualDeposit
            };

            this.balanceSheetData.shipment.map(function (shipment) {
                var denom = (_this5.denominationAllType || []).find(function (d) {
                    return d.id === shipment.denominationId;
                });
                infoObject.push({
                    'denominationId': shipment.denominationId,
                    'value': shipment[infoFor],
                    'coinFlag': shipment.coinFlag,
                    'currencyId': shipment.currencyId,
                    'symbol': shipment.symbol,
                    'sortOrder': denom ? Number(denom.shiptype ? denom.shiptype.sortOrder : denom.sortOrder) : null,
                    'faceValue': denom ? Number(denom.faceValue) : null
                });
            });

            this.Modal.balanceSheetInfo(infoObject, this.currency, this.$translate.instant(title), data, function (_ref) {
                var modal = _ref.modal;

                modal.close();
            });
        }

        // generate vault report 

    }, {
        key: 'generateVaultReport',
        value: function generateVaultReport() {
            var _this6 = this;

            var currentVaultDate = moment(this.model.date).format('YYYY-MM-DD');
            this.DailyBalanceSheetService.vaultReport(this.model.branchId, String(this.model.fundingSourceId.Value), this.model.stats, this.model.currency, currentVaultDate, this.branchTimezone, this.currency).then(function (data) {
                // console.log(data)
            }).catch(function (err) {
                console.log(err);
                return _this6.Modal.errorModal(err);
            });
        }
    }, {
        key: 'autoLoadDVBHistory',
        value: function autoLoadDVBHistory() {
            var fundingSource = void 0;
            if (this.dataObj && this.dataObj.isRedirected) {
                if (this.dataObj.fundingSourceId) {
                    fundingSource = _lodash2.default.find(this.locationLists, { Value: this.dataObj.fundingSourceId });
                }
                this.model.fundingSourceId = {
                    Key: fundingSource ? fundingSource.Key : this.locationLists[0].Key,
                    Value: fundingSource ? fundingSource.Value : this.locationLists[0].Value,
                    manualDeposit: fundingSource ? fundingSource.manualDeposit : this.locationLists[0].manualDeposit
                };
                this.filterCurrenciesByBFS();
                this.vaultBalance();
            }
        }
    }, {
        key: 'resetFilter',
        value: function resetFilter() {
            if (this.dataObj) {
                this.dataObj.isRedirected = false;
                this.dataObj = this.DataCounter.setData({});
            }
        }
    }, {
        key: 'emailVaultBalanceReport',
        value: function emailVaultBalanceReport() {
            var _this7 = this;

            this.isSendingReport = true;
            var currentVaultDate = moment(this.model.date).format('YYYY-MM-DD');
            this.DailyBalanceSheetService.emailVaultBalanceReport(this.model.branchId, currentVaultDate, String(this.model.fundingSourceId.Value)).then(function () {}).catch(function (err) {
                if (err && err.data && err.data.message) {
                    return _this7.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this7.isSendingReport = false;
            });
        }
    }]);
    return DailyBalanceSheetController;
}();

exports.default = DailyBalanceSheetController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _daily_balance_sheet = __webpack_require__(1729);

var _daily_balance_sheet2 = _interopRequireDefault(_daily_balance_sheet);

var _print = __webpack_require__(1737);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchMgmtDailyBalanceSheetModule = angular.module('branchMgmtDailyBalanceSheet', [_print2.default]).component('branchMgmtDailyBalanceSheet', _daily_balance_sheet2.default).name;

exports.default = branchMgmtDailyBalanceSheetModule;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _daily_balance_sheet_print = __webpack_require__(2678);

var _daily_balance_sheet_print2 = _interopRequireDefault(_daily_balance_sheet_print);

var _daily_balance_sheet_print3 = __webpack_require__(1733);

var _daily_balance_sheet_print4 = _interopRequireDefault(_daily_balance_sheet_print3);

__webpack_require__(2963);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DailyBalanceSheetPrintComponent = {
  restrict: 'E',
  bindings: {},
  template: _daily_balance_sheet_print2.default,
  controller: _daily_balance_sheet_print4.default
};

exports.default = DailyBalanceSheetPrintComponent;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DailyBalanceSheetPrintController = function () {
    /*@ngInject*/
    DailyBalanceSheetPrintController.$inject = ["$state", "$stateParams"];
    function DailyBalanceSheetPrintController($state, $stateParams) {
        (0, _classCallCheck3.default)(this, DailyBalanceSheetPrintController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.balanceSheetData = '';
        this.totalLiability = 0;
        this.total = 0;
        this.manualDeposit = false;
    }

    (0, _createClass3.default)(DailyBalanceSheetPrintController, [{
        key: '$onInit',
        value: function $onInit() {
            var printData = undefined;
            if (window.opener && window.opener.w && window.opener.w.printData) {
                printData = window.opener.w.printData;
            }
            this.balanceSheetData = printData.data;
            this.currency = printData.currency || '$';
            this.branch = printData.branch;
            this.vaultDate = printData.vaultDate;
            this.totalLiability = this.balanceSheetData.totalLiability;
            this.manualDeposit = printData.manualDeposit;

            setTimeout(function () {
                window.print();
            }, 1500);
        }
    }]);
    return DailyBalanceSheetPrintController;
}();

exports.default = DailyBalanceSheetPrintController;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _daily_balance_sheet_report_print = __webpack_require__(2679);

var _daily_balance_sheet_report_print2 = _interopRequireDefault(_daily_balance_sheet_report_print);

var _daily_balance_sheet_report_print3 = __webpack_require__(1735);

var _daily_balance_sheet_report_print4 = _interopRequireDefault(_daily_balance_sheet_report_print3);

__webpack_require__(2964);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DailyBalanceSheetReportPrintComponent = {
  restrict: 'E',
  bindings: {},
  template: _daily_balance_sheet_report_print2.default,
  controller: _daily_balance_sheet_report_print4.default
};

exports.default = DailyBalanceSheetReportPrintComponent;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DailyBalanceSheetReportPrintController = function () {
    /*@ngInject*/
    DailyBalanceSheetReportPrintController.$inject = ["$timeout", "DailyBalanceSheetService", "DateUtil"];
    function DailyBalanceSheetReportPrintController($timeout, DailyBalanceSheetService, DateUtil) {
        (0, _classCallCheck3.default)(this, DailyBalanceSheetReportPrintController);

        this.$timeout = $timeout;
        this.DailyBalanceSheetService = DailyBalanceSheetService;
        this.DateUtil = DateUtil;
        this.printData = window.printData;

        this.loading = true;
        this.reportData = null;
    }

    (0, _createClass3.default)(DailyBalanceSheetReportPrintController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (!this.printData) {
                this.loading = false;
                return;
            }

            var _printData = this.printData,
                branch = _printData.branch,
                fundingSourceId = _printData.fundingSourceId,
                currencyId = _printData.currencyId,
                vaultDateRaw = _printData.vaultDateRaw,
                branchTimezone = _printData.branchTimezone;


            this.DailyBalanceSheetService.getVaultReportPrintData(branch, fundingSourceId, currencyId, vaultDateRaw, branchTimezone).then(function (res) {
                if (res && res.data) {
                    _this.reportData = res.data;
                }
                _this.loading = false;

                _this.$timeout(function () {
                    window.print();
                }, 500); // Give DOM time to render
            }).catch(function (err) {
                console.error("Error fetching vault report data:", err);
                _this.loading = false;
            });
        }
    }, {
        key: 'formatCurrency',
        value: function formatCurrency(amount) {
            var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$';

            if (amount === undefined || amount === null || amount === '') {
                return '';
            }
            return '' + symbol + Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }]);
    return DailyBalanceSheetReportPrintController;
}();

exports.default = DailyBalanceSheetReportPrintController;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _daily_balance_sheet_report_print = __webpack_require__(1734);

var _daily_balance_sheet_report_print2 = _interopRequireDefault(_daily_balance_sheet_report_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DailyBalanceSheetReportPrintModule = angular.module('printDailyBalanceSheetReport', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$stateProvider.state('printDailyBalanceSheetReport', {
		url: '/print-daily-balance-sheet-report',
		component: 'printDailyBalanceSheetReport',
		data: {
			requireLogin: true,
			requireACL: 'branch_mgmt_daily_balance_sheet.all'
		}
	});
}]).component('printDailyBalanceSheetReport', _daily_balance_sheet_report_print2.default).name;

exports.default = DailyBalanceSheetReportPrintModule;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _daily_balance_sheet_print = __webpack_require__(1732);

var _daily_balance_sheet_print2 = _interopRequireDefault(_daily_balance_sheet_print);

var _daily_balance_sheet_report = __webpack_require__(1736);

var _daily_balance_sheet_report2 = _interopRequireDefault(_daily_balance_sheet_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DailyBalanceSheetPrintModule = angular.module('printDailyBalanceSheet', [_daily_balance_sheet_report2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider.otherwise('/daily-balance-sheet');

	$stateProvider.state('printDailyBalanceSheet', {
		url: '/print-daily-balance-sheet',
		component: 'printDailyBalanceSheet',
		data: {
			requireLogin: true,
			requireACL: 'branch_mgmt_daily_balance_sheet.all'
		}
	});
}]).component('printDailyBalanceSheet', _daily_balance_sheet_print2.default).name;

exports.default = DailyBalanceSheetPrintModule;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deleted_shipments = __webpack_require__(2680);

var _deleted_shipments2 = _interopRequireDefault(_deleted_shipments);

var _deleted_shipments3 = __webpack_require__(1739);

var _deleted_shipments4 = _interopRequireDefault(_deleted_shipments3);

__webpack_require__(2965);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementDeletedShipmentsComponent = {
    restrict: "E",
    binding: {},
    template: _deleted_shipments2.default,
    controller: _deleted_shipments4.default
};

exports.default = branchManagementDeletedShipmentsComponent;

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SoftDeletedShipmentsController = function () {
    /*@ngInject*/
    SoftDeletedShipmentsController.$inject = ["Auth", "User", "$q", "$state", "ShipmentService", "DataCounter", "Modal", "$translate", "Navigation", "$rootScope"];
    function SoftDeletedShipmentsController(Auth, User, $q, $state, ShipmentService, DataCounter, Modal, $translate, Navigation, $rootScope) {
        (0, _classCallCheck3.default)(this, SoftDeletedShipmentsController);

        this.Auth = Auth;
        this.User = User;
        this.$q = $q;
        this.$state = $state;
        this.ShipmentService = ShipmentService;
        this.DataCounter = DataCounter;
        this.Modal = Modal;
        this.$translate = $translate;
        this.Navigation = Navigation;
        this.$rootScope = $rootScope;

        this.model = {
            branch: User.getUser().branchId,
            softDeletedShipments: [],
            toLocation: '',
            selectedUser: '',
            selectedReason: null,
            trackingId: '',
            date: ''
        };

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.sortOrder = {
            fieldName: 'vaultDate',
            order: 'DESC'
        };

        this.totalLocations = 0;
        this.totalUsers = 0;
        this.totalReasons = 0;
        this.locationList = [];
        this.userList = [];
        this.reasonList = [];
        this.shipmentData = '';
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/deleted-shipments');
    }

    (0, _createClass3.default)(SoftDeletedShipmentsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.moment = moment;
            this.shipmentData = this.DataCounter.getData();
            this.getUniqueRecords();
            if (this.shipmentData && this.shipmentData.isRedirected) this.filterRecords();else this.getSoftDeletedShipments();
        }
    }, {
        key: 'getSoftDeletedShipments',
        value: function getSoftDeletedShipments() {
            var _this = this;

            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branch
                    }, {
                        field: 'deleted',
                        condition: '=',
                        data: true
                    }],
                    operator: 'AND'
                },
                order: {
                    fieldName: this.sortOrder.fieldName,
                    keyword: this.sortOrder.order
                }
            };

            if (this.model.trackingId) {
                searchObj.queryJSON.rules.push({
                    field: 'trackingId',
                    condition: 'like',
                    data: "%" + this.model.trackingId + "%"
                });
            }

            if (this.model.date) {
                searchObj.queryJSON.rules.push({
                    field: 'vaultDate',
                    condition: '=',
                    data: moment(this.model.date).format('YYYY-MM-DD')
                });
            }

            if (this.model.toLocation) {
                searchObj.queryJSON.rules.push({
                    field: 'toLocationId',
                    condition: '=',
                    data: this.model.toLocation.Value
                });
            }

            if (this.model.selectedUser) {
                searchObj.queryJSON.rules.push({
                    field: 'deletedByUserId',
                    condition: '=',
                    data: this.model.selectedUser.Value
                });
            }

            if (this.model.selectedReason) {
                searchObj.queryJSON.rules.push({
                    field: 'deletedReason',
                    condition: '=',
                    data: this.model.selectedReason.reason
                });
            }

            this.model.loading = true;
            return this.ShipmentService.all(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit).then(function (data) {
                _this.model.softDeletedShipments = data.results;
                _this.pagination.total = data.total;
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this.model.loading = false;
            });
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.getSoftDeletedShipments();
        }
    }, {
        key: 'getUniqueRecords',
        value: function getUniqueRecords() {
            var _this2 = this;

            this.isLoading = true;
            this.ShipmentService.getUniqueRecords(this.model.branch).then(function (data) {
                _this2.model.uniqueRecords = data.results;
            }).then(function () {
                _this2.loadLocations();
                _this2.loadUsers();
                // this.loadReason();
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this2.isLoading = false;
            });
        }
    }, {
        key: 'loadLocations',
        value: function loadLocations() {
            this.totalLocations = this.model.uniqueRecords.locations.length;
            var location = this.mappingLocation(this.model.uniqueRecords.locations);
            this.locationList = this.locationList.concat(location);
        }
    }, {
        key: 'mappingLocation',
        value: function mappingLocation(data) {
            return data.map(function (loc) {
                return {
                    Key: loc.locationId + ' | ' + loc.locationName,
                    Value: loc.locationId
                };
            });
        }
    }, {
        key: 'loadUsers',
        value: function loadUsers() {
            this.totalUsers = this.model.uniqueRecords.userIds.length;
            var user = this.mappingUser(this.model.uniqueRecords.userIds);
            this.userList = this.userList.concat(user);
        }
    }, {
        key: 'mappingUser',
        value: function mappingUser(data) {
            return data.map(function (user) {
                return {
                    Key: user.id + ' | ' + user.name,
                    Value: user.id
                };
            });
        }
    }, {
        key: 'loadReason',
        value: function loadReason() {
            this.totalReasons = this.model.uniqueRecords.deletedReasons.length;
            var reason = this.mappingReason(this.model.uniqueRecords.deletedReasons);
            this.reasonList = this.reasonList.concat(reason);
        }
    }, {
        key: 'mappingReason',
        value: function mappingReason(data) {
            return data.map(function (d) {
                return {
                    Key: d.reason,
                    Value: d.reason
                };
            });
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(data) {
            var obj = {
                locationId: data.toLocation.id,
                vaultDate: null,
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.locations');
        }
    }, {
        key: 'goToRouteTab',
        value: function goToRouteTab(data) {
            var obj = {
                routeId: data.routeId,
                vaultDate: data.vaultDate,
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.routes');
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            this.model.trackingId = null;
            this.model.date = null;
            this.model.toLocation = null;
            this.model.selectedUser = null;
            this.model.selectedReason = null;
            this.getSoftDeletedShipments();
        }
    }, {
        key: 'filterRecords',
        value: function filterRecords() {
            var _this3 = this;

            if (this.shipmentData && this.shipmentData.isRedirected) {
                this.model.trackingId = this.shipmentData.trackingId;
                this.getSoftDeletedShipments().then(function () {
                    _this3.resetFilters();
                });
            }
        }
    }, {
        key: 'resetFilters',
        value: function resetFilters() {
            if (this.shipmentData) {
                this.shipmentData.isRedirected = false;
                this.shipmentData = this.DataCounter.setData();
            }
        }
    }, {
        key: 'confirmUndoDelete',
        value: function confirmUndoDelete(shipment) {
            var _this4 = this;

            if (this.loading) return;
            this.loading = true;

            this.Modal.confirm({
                header: this.$translate.instant('softDeletedShipments.undo_delete_title'),
                message: this.$translate.instant('softDeletedShipments.undo_delete_warning') + (' <strong>' + shipment.trackingId + '</strong>?'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    modal.close();
                    _this4.undoSoftDeleteShipment(shipment);
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    modal.close();
                    _this4.loading = false;
                },
                type: 'danger'
            });
        }
    }, {
        key: 'undoSoftDeleteShipment',
        value: function undoSoftDeleteShipment(shipment) {
            var _this5 = this;

            this.ShipmentService.undoSoftDeleteShipment(shipment.id, shipment.branchId, shipment.trackingId).then(function () {
                _this5.resetFilters();
                _this5.getSoftDeletedShipments();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    if (err.data.message === '92719') {
                        var errorMessage = _this5.$translate.instant('error.' + err.data.message, {
                            trackingId: shipment.trackingId
                        });
                        _this5.Modal.errorModal(errorMessage);
                    } else {
                        _this5.Modal.errorModal(err.data.message);
                    }
                }
            }).finally(function () {
                _this5.loading = false;
            });
        }
    }, {
        key: 'goToItemHistory',
        value: function goToItemHistory(data) {
            this.Navigation.goToItemHistory(data.trackingId, null);
        }
    }]);
    return SoftDeletedShipmentsController;
}();

exports.default = SoftDeletedShipmentsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deleted_shipments = __webpack_require__(1738);

var _deleted_shipments2 = _interopRequireDefault(_deleted_shipments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementDeletedShipmentsModule = angular.module('branchManagementDeletedShipments', []).component('branchManagementDeletedShipments', _deleted_shipments2.default).name;

exports.default = branchManagementDeletedShipmentsModule;

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _deposit_reports = __webpack_require__(2681);

var _deposit_reports2 = _interopRequireDefault(_deposit_reports);

var _deposit_reports3 = __webpack_require__(1742);

var _deposit_reports4 = _interopRequireDefault(_deposit_reports3);

__webpack_require__(2966);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementDepositReportsComponent = {
  restrict: "E",
  bindings: {},
  template: _deposit_reports2.default,
  controller: _deposit_reports4.default
};

exports.default = branchManagementDepositReportsComponent;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DepositReportsController = function () {
  /*@ngInject*/
  function DepositReportsController() {
    (0, _classCallCheck3.default)(this, DepositReportsController);
  }

  (0, _createClass3.default)(DepositReportsController, [{
    key: "$onInit",
    value: function $onInit() {}
  }]);
  return DepositReportsController;
}();

exports.default = DepositReportsController;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _deposit_reports = __webpack_require__(1741);

var _deposit_reports2 = _interopRequireDefault(_deposit_reports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementDepositReportsModule = angular.module('branchManagementDepositReports', []).component('branchManagementDepositReports', _deposit_reports2.default).name;

exports.default = branchManagementDepositReportsModule;

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _final_residual_count_commit = __webpack_require__(2682);

var _final_residual_count_commit2 = _interopRequireDefault(_final_residual_count_commit);

var _final_residual_count_commit3 = __webpack_require__(1745);

var _final_residual_count_commit4 = _interopRequireDefault(_final_residual_count_commit3);

__webpack_require__(2967);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementFinalResidualCountCommitComponent = {
  restrict: "E",
  bindings: {},
  template: _final_residual_count_commit2.default,
  controller: _final_residual_count_commit4.default
};

exports.default = branchManagementFinalResidualCountCommitComponent;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FinalResidualCountCommitController = function () {
  /*@ngInject*/
  FinalResidualCountCommitController.$inject = ["Auth", "$state", "User", "DataCounter", "$translate", "$q", "Modal", "$scope", "DateUtil", "SetupService", "Navigation", "UsersService", "BranchFundingSourceService", "AtmResidualService", "DenominationService", "$rootScope"];
  function FinalResidualCountCommitController(Auth, $state, User, DataCounter, $translate, $q, Modal, $scope, DateUtil, SetupService, Navigation, UsersService, BranchFundingSourceService, AtmResidualService, DenominationService, $rootScope) {
    var _this = this;

    (0, _classCallCheck3.default)(this, FinalResidualCountCommitController);

    this.locationSearchObj = function (searchKey) {
      searchKey = searchKey || '';
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: _this.model.branch
          }, {
            group: {
              rules: [{
                field: 'locationId',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'sourceName',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };
      return searchObj.queryJSON.rules.length ? searchObj : null;
    };

    this.userSearchObj = function (searchKey) {
      searchKey = searchKey || '';
      var searchObj = {
        queryJSON: {
          rules: [
          // {
          //   field: 'downloadToHHT',
          //   condition: '=',
          //   data: 1
          // },
          {
            field: 'branchId',
            condition: '=',
            data: _this.model.branch
          }, {
            group: {
              rules: [{
                field: 'firstName',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'lastName',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };
      return searchObj.queryJSON.rules.length ? searchObj : null;
    };

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.Modal = Modal;
    this.DataCounter = DataCounter;
    this.$scope = $scope;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.Navigation = Navigation;
    this.UsersService = UsersService;
    this.BranchFundingSourceService = BranchFundingSourceService;
    this.AtmResidualService = AtmResidualService;
    this.DenominationService = DenominationService;
    this.$rootScope = $rootScope;
    this.model = {
      loading: false,
      search: null,
      branch: User.getUser().branchId,
      totalLocationRecords: 0,
      fundingSourceList: [],
      residualCountCommitList: [],
      totalUsers: 0,
      userList: [],
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 30,
        maxPages: 10
      },
      paginationDeposit: {
        page: 1,
        total: 0,
        pageLimit: 30,
        maxPages: 10
      },
      gettingResidualShipment: false,
      gettingDepositShipment: false,
      residualTrackingIds: [],
      depositTrackingIds: [],
      loggedInUser: User.getUser().id,
      authorizeCountCommit: false,
      currentStats: 'pending',
      statsObj: {
        pending: 'pending',
        authorized: 'authorized'
      },
      denomsList: [],
      residualsCompletedApprovalList: [],
      depositsCompletedApprovalList: [],
      gettingResidualCompletedApprovalList: false,
      dateRangeOption: {
        startDate: null,
        endDate: null
      },
      dateRangPickerOptions: {},
      dateRangPickerOptionsfor: {},
      searchText: '',
      isExportingAuthorizedResidual: false,
      isDepositsAuthorizedResidualExporting: false,
      browserTimezone: moment.tz.guess()
    };

    this.toggleSelect = false;
    this.depositToggleSelect = false;
    this.sortColumn = "row";
    this.reverseSort = false;
    this.depositSortColumn = "row";
    this.depositReverseSort = false;
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/final-residual-count-commit');
  }

  (0, _createClass3.default)(FinalResidualCountCommitController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.dataObj = this.DataCounter.getData();

      this.$q.all([this.SetupService.get(this.model.branch), this.loadAllDenomination()]).then(function (data) {
        _this2.currentVaultDate = _this2.DateUtil.getUTCDate(data[0].currentVaultDate);
        _this2.setDateRangeOptions(_this2.currentVaultDate, 'dateRangPickerOptionsfor');
        _this2.model.dateRangeOption.startDate = moment(_this2.currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss');
        _this2.model.dateRangeOption.endDate = moment(_this2.currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss');

        _this2.getFundingSource('', 0).then(function () {
          _this2.autoSetOrLoadData();
        });
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'getFundingSource',
    value: function getFundingSource(searchKey, offset) {
      var _this3 = this;

      var loadLocationData = this.locationSearchObj(searchKey);
      return this.BranchFundingSourceService.all(loadLocationData, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0) {
          _this3.model.totalLocationRecords = data.total;
          _this3.model.fundingSourceList = _this3.mappingLocationData(data.results);
        } else {
          var locations = _this3.mappingLocationData(data.results);
          _this3.model.fundingSourceList = _this3.model.fundingSourceList.concat(locations);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'mappingLocationData',
    value: function mappingLocationData(locations) {
      return locations.map(function (data) {
        return {
          Key: data.locationId + " | " + data.sourceName,
          Value: data.locationId,
          Id: data.id
        };
      });
    }
  }, {
    key: 'getResidualsCountCommit',
    value: function getResidualsCountCommit() {
      var _this4 = this;

      if (!this.model.fundingSource) {
        this.model.residualCountCommitList = [];
        return;
      }

      var startDate = !this.toggleSelect ? moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD 00:00:00') : null;
      var endDate = !this.toggleSelect ? moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD 23:59:59') : null;

      this.model.gettingResidualShipment = true;
      this.model.gettingDepositShipment = true;
      var denoms = [];
      var userId = this.model.user && this.model.user.Value ? this.model.user.Value : null;
      if (this.model.denoms && this.model.denoms.length) {
        this.model.denoms.forEach(function (item) {
          if (item.ticked) {
            denoms.push(item.Value);
          }
        });
      }
      return this.AtmResidualService.getResidualsCountCommit(this.model.searchText, this.model.fundingSource.Id, startDate, endDate, denoms, userId).then(function (data) {
        if (data && _this4.allDenominations) {
          if (data.atmDenomSummary && Array.isArray(data.atmDenomSummary)) {
            data.atmDenomSummary.forEach(function (summary) {
              var denom = _this4.allDenominations.find(function (d) {
                return d.id === summary.denominationId;
              });
              if (denom) {
                summary.sortOrder = denom.sortOrder;
                summary.faceValue = denom.faceValue;
              }
            });
          }
          if (data.depositDenomSummary && Array.isArray(data.depositDenomSummary)) {
            data.depositDenomSummary.forEach(function (summary) {
              var denom = _this4.allDenominations.find(function (d) {
                return d.id === summary.denominationId;
              });
              if (denom) {
                summary.sortOrder = denom.sortOrder;
                summary.faceValue = denom.faceValue;
              }
            });
          }
        }
        _this4.model.residualCountCommitList = data;
        // this.model.pagination.total = data.totalRecords;
        _this4.resetFilter();
        // this.model.residualCountCommitList.results.forEach(shipment => {
        //   if (this.model.residualTrackingIds.includes(shipment.trackingId)) { shipment.isSelected = true; }
        // });
        // console.log(this.model.residualCountCommitList);
      }).catch(function (err) {
        console.log(err);
        _this4.Modal.errorModal(err.data.message);
      }).finally(function () {
        _this4.model.gettingResidualShipment = false;
        _this4.model.gettingDepositShipment = false;
      });
    }
  }, {
    key: 'showDenomBreakdown',
    value: function showDenomBreakdown(data) {
      var _this5 = this;

      this.AtmResidualService.getDepositDenominationBreakdown(data.orderNo, data.trackingId, data.locationId, data.countVaultDate).then(function (denoms) {
        _this5.Modal.denominationBreakdownModal({
          denomData: denoms,
          orderNo: data.orderNo || data.trackingId,
          locationId: data.locationId,
          countVaultDate: data.countVaultDate,
          statedTotalAmount: data.statedTotalAmount,
          amountCounted: data.amountCounted,
          countedVariance: denoms.length == 1 ? data.amountVariance : null
        });
      }).catch(function (err) {
        console.log(err);
        _this5.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: 'goToUserTab',
    value: function goToUserTab(userId) {
      if (!userId) return;
      this.Navigation.goToUserTab(userId, null);
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(locationId) {
      if (!locationId) return;
      this.Navigation.goToServiceHistory(locationId, null, true, null);
    }
  }, {
    key: 'goToItemHistory',
    value: function goToItemHistory(trackingId) {
      this.$state.go('branchManagement.items', {
        id: trackingId
      });
    }
  }, {
    key: 'goToOrderHistory',
    value: function goToOrderHistory(data) {
      return this.Navigation.goToOrderHistory(data.orderNo, null, true, true, false, false, null, this.model.fundingSource.Id);
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      this.model.residualTrackingIds = [];
      this.model.depositTrackingIds = [];
      this.loadData();
    }
  }, {
    key: 'goToATMCount',
    value: function goToATMCount(data) {
      return this.Navigation.goToAtmCount(data.parentTrackingId, true, null, this.model.fundingSource.Id);
    }
  }, {
    key: 'goToATMCountOfDeposit',
    value: function goToATMCountOfDeposit(data) {
      var trackingId = data.parentTrackingId ? data.parentTrackingId : data.trackingId;
      return this.Navigation.goToAtmCount(trackingId, true, null, this.model.fundingSource.Id);
    }
  }, {
    key: 'selectedResiduals',
    value: function selectedResiduals(event, data, index) {
      if (event.target.checked) {
        this.model.residualTrackingIds.push(data.trackingId);
      } else {
        var _index = this.model.residualTrackingIds.indexOf(data.trackingId);
        this.model.residualTrackingIds.splice(_index, 1);
      }
    }
  }, {
    key: 'selectedDepositResiduals',
    value: function selectedDepositResiduals(event, data, index) {
      if (event.target.checked) {
        this.model.depositTrackingIds.push(data.trackingId);
      } else {
        var _index2 = this.model.depositTrackingIds.indexOf(data.trackingId);
        this.model.depositTrackingIds.splice(_index2, 1);
      }
    }
  }, {
    key: 'getComments',
    value: function getComments(data) {
      this.Modal.confirm({
        header: this.$translate.instant('common.comment'),
        message: data.comment,
        callback: function callback(_ref) {
          var modal = _ref.modal;

          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          modal.close();
        },
        buttons: ['common.close'],
        type: 'success'
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.model.residualTrackingIds = [];
      this.model.depositTrackingIds = [];
      this.model.pagination.page = 1;
      this.model.paginationDeposit.page = 1;
    }
  }, {
    key: 'toggleAllResidualSelection',
    value: function toggleAllResidualSelection() {
      var _this6 = this;

      this.model.residualTrackingIds = [];
      this.model.residualCountCommitList.results.forEach(function (shipment) {
        if (_this6.toggleSelect) {
          shipment.isSelected = _this6.toggleSelect;
          _this6.model.residualTrackingIds.push(shipment.trackingId);
        } else {
          shipment.isSelected = _this6.toggleSelect;
          _this6.model.residualTrackingIds = [];
        }
      });
      // this.toggleSelect = !this.toggleSelect;
    }
  }, {
    key: 'toggleAllDepositSelection',
    value: function toggleAllDepositSelection() {
      var _this7 = this;

      this.model.depositTrackingIds = [];
      this.model.residualCountCommitList.countedDeposits.forEach(function (shipment) {
        if (_this7.depositToggleSelect) {
          shipment.isDepositSelected = _this7.depositToggleSelect;
          _this7.model.depositTrackingIds.push(shipment.trackingId);
        } else {
          shipment.isDepositSelected = _this7.depositToggleSelect;
          _this7.model.depositTrackingIds = [];
        }
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      this.getResidualUsers('', 0);
      if (this.model.currentStats === this.model.statsObj.pending) return this.getResidualsCountCommit();else if (this.model.currentStats === this.model.statsObj.authorized) return this.getResidualsCompletedApproval();
    }
  }, {
    key: 'autoSetOrLoadData',
    value: function autoSetOrLoadData() {
      var findFundingSource = void 0;
      this.model.currentStats = this.model.statsObj.pending;

      if (this.dataObj && this.dataObj.isRedirected || this.model.fundingSourceList.length === 1) {
        if (this.dataObj) {
          findFundingSource = _.find(this.model.fundingSourceList, { Value: this.dataObj.fundingSourceLocation });
        }
        this.model.fundingSource = {
          Key: findFundingSource ? findFundingSource.Key : this.model.fundingSourceList[0].Key,
          Value: findFundingSource ? findFundingSource.Value : this.model.fundingSourceList[0].Value,
          Id: findFundingSource ? findFundingSource.Id : this.model.fundingSourceList[0].Id
        };
        this.loadData();
      }
    }
  }, {
    key: 'resetFilter',
    value: function resetFilter() {
      if (this.dataObj) {
        this.dataObj.isRedirected = false;
        this.dataObj = this.DataCounter.setData();
      }
    }
  }, {
    key: 'validateSupervisorScan',
    value: function validateSupervisorScan(sectionType) {
      var _this8 = this;

      this.UsersService.checkSupervisor(this.model.loggedInUser).then(function (userInfo) {
        if (userInfo && userInfo.supervisor) {
          return _this8.bulkAuthorize(userInfo.id, sectionType);
        } else {
          _this8.Modal.confirmSupervisor('bulk-authorize-count-commit', null, function (_ref3) {
            var modal = _ref3.modal,
                supId = _ref3.supId;

            modal.close();
            return _this8.bulkAuthorize(supId, sectionType);
          }, function (_ref4) {
            var modal = _ref4.modal;

            modal.close();
            _this8.isLoading = false;
          });
        }
      }).catch(function (err) {
        console.log("err", err);
        _this8.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: 'bulkAuthorize',
    value: function bulkAuthorize(userId, sectionType) {
      var _this9 = this;

      var denoms = [];
      if (this.model.denoms && this.model.denoms.length) {
        this.model.denoms.forEach(function (item) {
          if (item.ticked) {
            denoms.push(item.Value);
          }
        });
      }
      this.model.authorizeCountCommit = true;
      var user = this.model.user && this.model.user.Value ? this.model.user.Value : null;
      var startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD 00:00:00');
      var endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD 23:59:59');
      (sectionType === 'deposit' ? this.AtmResidualService.authorizeDepositsCount(this.model.fundingSource.Id, this.model.branch, userId, this.model.searchText, startDate, endDate, user, denoms) : this.AtmResidualService.authorizeResidualCount(this.model.fundingSource.Id, this.model.branch, userId)).then(function (data) {
        _this9.loadData();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this9.Modal.errorModal(err.data.message);
        } else {
          _this9.Modal.errorModal(err);
        }
      }).finally(function () {
        _this9.model.authorizeCountCommit = false;
      });
    }
  }, {
    key: 'tabSelection',
    value: function tabSelection(selectedValue) {
      this.toggleSelect = false;
      this.depositToggleSelect = false;
      this.reverseSort = false;
      this.sortColumn = "row";
      this.depositReverseSort = false;
      this.depositSortColumn = "row";
      this.model.stats = selectedValue;
      this.model.user = null;
      this.reset();
      this.loadData();
    }
  }, {
    key: 'onFundingSourceChange',
    value: function onFundingSourceChange() {
      this.resetSearchText();
      this.reset();
      this.model.user = null;
      this.getResidualUsers('', 0);
      this.getResidualsCountCommit();
      this.getResidualsCompletedApproval();
    }
  }, {
    key: 'onDateRangeChange',
    value: function onDateRangeChange() {
      this.reset();
      this.model.user = null;
      this.loadData();
    }
  }, {
    key: 'getResidualsCompletedApproval',
    value: function getResidualsCompletedApproval() {
      var _this10 = this;

      if (!this.model.fundingSource) {
        this.model.pagination.page = 1;
        this.model.paginationDeposit.page = 1;
        this.model.residualsCompletedApprovalList = [];
        this.model.depositsCompletedApprovalList = [];
        return;
      }

      var startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD 00:00:00');
      var endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD 23:59:59');

      this.model.gettingResidualCompletedApprovalList = true;
      setTimeout(function () {
        var denoms = [];
        var userId = _this10.model.user && _this10.model.user.Value ? _this10.model.user.Value : null;
        if (_this10.model.denoms && _this10.model.denoms.length) {
          _this10.model.denoms.forEach(function (item) {
            if (item.ticked) {
              denoms.push(item.Value);
            }
          });
        }
        var depositOffset = (_this10.model.paginationDeposit.page - 1) * _this10.model.paginationDeposit.pageLimit;
        var atmOffset = (_this10.model.pagination.page - 1) * _this10.model.pagination.pageLimit;
        var depositLimit = _this10.model.paginationDeposit.pageLimit;
        var atmLimit = _this10.model.pagination.pageLimit;
        _this10.AtmResidualService.getResidualsCompletedApproval(_this10.model.searchText, _this10.model.fundingSource.Id, moment.tz.guess(), startDate, endDate, denoms, userId, atmOffset, atmLimit, depositOffset, depositLimit).then(function (data) {
          if (data && data.atmDenomSummary && Array.isArray(data.atmDenomSummary) && _this10.allDenominations) {
            data.atmDenomSummary.forEach(function (summary) {
              var denom = _this10.allDenominations.find(function (d) {
                return d.id === summary.denominationId;
              });
              if (denom) {
                summary.sortOrder = denom.sortOrder;
                summary.faceValue = denom.faceValue;
              }
            });
          }
          _this10.model.residualsCompletedApprovalList = data;
          _this10.model.pagination.total = data.totalRecords;
        });
        _this10.AtmResidualService.getDepositsCompletedApproval(_this10.model.searchText, _this10.model.fundingSource.Id, moment.tz.guess(), startDate, endDate, userId, denoms, depositOffset, depositLimit).then(function (data) {
          if (data && data.depositDenomSummary && Array.isArray(data.depositDenomSummary) && _this10.allDenominations) {
            data.depositDenomSummary.forEach(function (summary) {
              var denom = _this10.allDenominations.find(function (d) {
                return d.id === summary.denominationId;
              });
              if (denom) {
                summary.sortOrder = denom.sortOrder;
                summary.faceValue = denom.faceValue;
              }
            });
          }
          _this10.model.depositsCompletedApprovalList = data;
          _this10.model.paginationDeposit.total = data.totalCountedDepositsRecords;
        }).catch(function (err) {
          console.log(err);
          if (err && err.data && err.data.message) {
            _this10.Modal.errorModal(err.data.message);
          } else {
            _this10.Modal.errorModal(err);
          }
        }).finally(function () {
          _this10.model.gettingResidualCompletedApprovalList = false;
        });
      });
    }
  }, {
    key: 'setDateRangeOptions',
    value: function setDateRangeOptions(date, modelValue) {
      var _this11 = this;

      var currentVaultDate = moment(date).format() || moment();
      this.model[modelValue] = {
        autoApply: true,
        eventHandlers: {
          'apply.daterangepicker': function applyDaterangepicker() {
            if (_this11.model.currentStats === _this11.model.statsObj.pending) {
              _this11.toggleSelect = false;
            }
            _this11.reset();
            _this11.loadData();
          }
        },
        ranges: {
          'Today': [moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')],
          'Current Week': [moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')],
          'Current Month': [moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')],
          'Past 30': [moment(currentVaultDate).subtract(29, 'days').format('YYYY-MM-DD HH:mm:ss')],
          'Past 60': [moment(currentVaultDate).subtract(59, 'days').format('YYYY-MM-DD HH:mm:ss')],
          'Past 90': [moment(currentVaultDate).subtract(89, 'days').format('YYYY-MM-DD HH:mm:ss')],
          'Current Year': [moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')]
        }
      };
    }
  }, {
    key: 'sortData',
    value: function sortData(column) {
      this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
      this.sortColumn = column;
    }
  }, {
    key: 'sortDepositData',
    value: function sortDepositData(column) {
      this.depositReverseSort = this.depositSortColumn == column ? !this.depositReverseSort : false;
      this.depositSortColumn = column;
    }
  }, {
    key: 'resetSearchText',
    value: function resetSearchText() {
      this.model.searchText = '';
    }
  }, {
    key: 'selectAllPendingResiduals',
    value: function selectAllPendingResiduals() {
      var _this12 = this;

      this.toggleSelect = !this.toggleSelect;
      if (this.toggleSelect) {
        this.resetSearchText();
      }
      this.getResidualsCountCommit().then(function () {
        _this12.toggleAllResidualSelection();
      });
    }
  }, {
    key: 'selectAllPendingDeposits',
    value: function selectAllPendingDeposits() {
      var _this13 = this;

      this.depositToggleSelect = !this.depositToggleSelect;
      // if (this.depositToggleSelect) {
      //   this.resetSearchText();
      // }
      this.getResidualsCountCommit().then(function () {
        _this13.toggleAllDepositSelection();
      });
    }
  }, {
    key: 'assertToggleSelection',
    value: function assertToggleSelection() {
      if (this.model.searchText) this.toggleSelect = false;
    }
  }, {
    key: 'assertDepositToggleSelection',
    value: function assertDepositToggleSelection() {
      if (this.model.searchText) this.depositToggleSelect = false;
    }
  }, {
    key: 'printAuthorizedResidual',
    value: function printAuthorizedResidual() {
      var denoms = [];
      if (this.model.denoms && this.model.denoms.length) {
        this.model.denoms.forEach(function (item) {
          if (item.ticked) {
            denoms.push(item.Value);
          }
        });
      }
      var obj = {
        currentStats: 'authorizedResidual',
        searchText: this.model.searchText,
        branchId: this.model.branch,
        startDate: this.getStartDate(),
        endDate: this.getEndDate(),
        vaultDate: this.currentVaultDate,
        timezone: this.model.browserTimezone,
        fundingSource: this.model.fundingSource,
        denoms: denoms, user: this.model.user && this.model.user.Value ? this.model.user.Value : null,
        sectionType: 'atm'
      };

      var path = this.$state.href('printFinalResidualCountCommit');
      window.w = window.open(path, '_blank');
      window.w.printData = obj;
    }
  }, {
    key: 'printAuthorizedDepositsResidual',
    value: function printAuthorizedDepositsResidual() {
      var denoms = [];
      if (this.model.denoms && this.model.denoms.length) {
        this.model.denoms.forEach(function (item) {
          if (item.ticked) {
            denoms.push(item.Value);
          }
        });
      }
      var obj = {
        currentStats: 'authorizedResidual',
        searchText: this.model.searchText,
        branchId: this.model.branch,
        startDate: this.getStartDate(),
        endDate: this.getEndDate(),
        vaultDate: this.currentVaultDate,
        timezone: this.model.browserTimezone,
        fundingSource: this.model.fundingSource,
        user: this.model.user && this.model.user.Value ? this.model.user.Value : null,
        denoms: denoms,
        sectionType: 'deposit'
      };

      var path = this.$state.href('printFinalResidualCountCommit');
      window.w = window.open(path, '_blank');
      window.w.printData = obj;
    }
  }, {
    key: 'downloadFile',
    value: function downloadFile(reportPrefix, reportData) {
      var fileName = reportPrefix.concat('.csv');
      var a = document.createElement("a");
      document.body.appendChild(a);
      var file = new Blob([reportData], { type: 'application/csv' });
      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    }
  }, {
    key: 'exportResidualsCompletedApproval',
    value: function exportResidualsCompletedApproval() {
      var _this14 = this;

      var startDate = this.getStartDate();
      var endDate = this.getEndDate();
      var reportPrefix = 'Authorized_Residual_Count_' + this.model.fundingSource.Value + '_(' + this.model.branch + ')';
      var denoms = [];
      var user = this.model.user && this.model.user.Value ? this.model.user.Value : null;
      if (this.model.denoms && this.model.denoms.length) {
        this.model.denoms.forEach(function (item) {
          if (item.ticked) {
            denoms.push(item.Value);
          }
        });
      }
      this.model.isExportingAuthorizedResidual = true;
      this.AtmResidualService.exportResidualsCompletedApproval(this.model.searchText, this.model.fundingSource.Id, this.model.browserTimezone, startDate, endDate, denoms, user, 0, 1000).then(function (data) {
        _this14.downloadFile(reportPrefix, data.reportData);
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this14.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this14.model.isExportingAuthorizedResidual = false;
      });
    }
  }, {
    key: 'exportDepositsResidualsCompletedApproval',
    value: function exportDepositsResidualsCompletedApproval() {
      var _this15 = this;

      var startDate = this.getStartDate();
      var endDate = this.getEndDate();
      var reportPrefix = 'Authorized_Deposits_Count_' + this.model.fundingSource.Value + '_(' + this.model.branch + ')';
      var denoms = [];
      var user = this.model.user && this.model.user.Value ? this.model.user.Value : null;
      if (this.model.denoms && this.model.denoms.length) {
        this.model.denoms.forEach(function (item) {
          if (item.ticked) {
            denoms.push(item.Value);
          }
        });
      }
      this.model.isDepositsAuthorizedResidualExporting = true;
      this.AtmResidualService.exportDepositsResidualsCompletedApproval(this.model.searchText, this.model.fundingSource.Id, this.model.browserTimezone, startDate, endDate, user, denoms, 0, 1000).then(function (data) {
        _this15.downloadFile(reportPrefix, data.reportData);
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this15.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this15.model.isDepositsAuthorizedResidualExporting = false;
      });
    }
  }, {
    key: 'getStartDate',
    value: function getStartDate() {
      return this.model.dateRangeOption.startDate ? moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD 00:00:00') : null;
    }
  }, {
    key: 'getEndDate',
    value: function getEndDate() {
      return this.model.dateRangeOption.endDate ? moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD 23:59:59') : null;
    }
  }, {
    key: 'loadAllDenomination',
    value: function loadAllDenomination() {
      var _this16 = this;

      return this.DenominationService.all(null, 0, 1000).then(function (data) {
        _this16.allDenominations = data.results.map(function (denom) {
          return (0, _extends3.default)({}, denom, {
            sortOrder: denom.sortOrder || denom.denominationSortOrder || 0
          });
        });
        _this16.denomsList = _this16.mappingData(_this16.allDenominations, 'name', 'id');
        return _this16.denomsList;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'mappingData',
    value: function mappingData(arr, label, value) {
      return arr.map(function (item) {
        var arrayObject = {
          Key: item[value] + ' | ' + item[label],
          Value: item[value]
        };

        return arrayObject;
      });
    }
  }, {
    key: 'getResidualUsers',
    value: function getResidualUsers(searchKey, offset) {
      var _this17 = this;

      if (!this.model.fundingSource) {
        this.model.userList = [];
        this.model.totalUsers = 0;
        this.model.user = null;
        return this.$q.resolve();
      }
      var branchId = this.model.branch;
      var fundingSourceId = this.model.fundingSource.Id;
      var startDate = !this.toggleSelect ? moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD 00:00:00') : null;
      var endDate = !this.toggleSelect ? moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD 23:59:59') : null;
      var status = this.model.currentStats;

      return this.AtmResidualService.getCountedUsers(branchId, fundingSourceId, startDate, endDate, searchKey, offset, _app2.default.defaultPageLimit, status).then(function (data) {
        var usersList = _this17.mappingUserData(data.results);
        if (offset === 0) {
          _this17.model.totalUsers = data.total;
          _this17.model.userList = usersList;
        } else {
          _this17.model.userList = _this17.model.userList.concat(usersList);
        }

        if (_this17.model.user && _this17.model.user.Value) {
          var exists = _this17.model.userList.some(function (u) {
            return u.Value === _this17.model.user.Value;
          });
          if (!exists) {
            _this17.model.user = null;
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'mappingUserData',
    value: function mappingUserData(arr) {
      return arr.map(function (item) {
        var arrayObject = {
          Key: item.id + ' | ' + item.firstName + ' ' + item.lastName,
          Value: item.id
        };
        return arrayObject;
      });
    }
  }]);
  return FinalResidualCountCommitController;
}();

exports.default = FinalResidualCountCommitController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _final_residual_count_commit = __webpack_require__(1744);

var _final_residual_count_commit2 = _interopRequireDefault(_final_residual_count_commit);

var _print = __webpack_require__(1749);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementFinalResidualCountCommitModule = angular.module('branchManagementFinalResidualCountCommit', [_print2.default]).component('branchManagementFinalResidualCountCommit', _final_residual_count_commit2.default).name;

exports.default = branchManagementFinalResidualCountCommitModule;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _final_residual_count_commit_print = __webpack_require__(2683);

var _final_residual_count_commit_print2 = _interopRequireDefault(_final_residual_count_commit_print);

var _final_residual_count_commit_print3 = __webpack_require__(1748);

var _final_residual_count_commit_print4 = _interopRequireDefault(_final_residual_count_commit_print3);

__webpack_require__(2968);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printComponent = {
    restrict: 'E',
    bindings: {},
    template: _final_residual_count_commit_print2.default,
    controller: _final_residual_count_commit_print4.default
};

exports.default = printComponent;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintController = function () {
    /*@ngInject*/
    PrintController.$inject = ["Auth", "AtmResidualService", "$translate", "Modal"];
    function PrintController(Auth, AtmResidualService, $translate, Modal) {
        (0, _classCallCheck3.default)(this, PrintController);

        this.AtmResidualService = AtmResidualService;
        this.$translate = $translate;
        this.Modal = Modal;
        this.model = {
            branchId: null,
            endDate: null,
            searchText: null,
            startDate: null,
            vaultDate: null,
            currentStats: null,
            residualsCompletedApprovalList: [],
            fundingSource: null,
            limit: 1000,
            offset: 0,
            totalApprovedRecords: 0,
            gettingResidualCompletedApprovalList: false
        };
    }

    (0, _createClass3.default)(PrintController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var printData = undefined;

            if (window.opener && window.opener.w && window.opener.w.printData) {

                printData = window.opener.w.printData;
                this.model.currentStats = printData.currentStats;
                this.model.searchText = printData.searchText;
                this.model.branchId = printData.branchId;
                this.model.startDate = printData.startDate;
                this.model.endDate = printData.endDate;
                this.model.vaultDate = printData.vaultDate;
                this.model.timezone = printData.timezone;
                this.model.fundingSource = printData.fundingSource;
                this.model.denoms = printData.denoms;
                this.model.user = printData.user || null;
                this.model.sectionType = printData.sectionType;
                if (this.model.currentStats === 'authorizedResidual') {
                    this.model.gettingResidualCompletedApprovalList = true;
                    var serviceCall = this.model.sectionType === 'deposit' ? this.AtmResidualService.getDepositsCompletedApproval(this.model.searchText, this.model.fundingSource.Id, this.model.timezone, this.model.startDate, this.model.endDate, this.model.user, this.model.denoms, this.model.offset, this.model.limit) : this.AtmResidualService.getResidualsCompletedApproval(this.model.searchText, this.model.fundingSource.Id, this.model.timezone, this.model.startDate, this.model.endDate, this.model.denoms, this.model.user, this.model.offset, this.model.limit);

                    return serviceCall.then(function (data) {
                        _this.model.residualsCompletedApprovalList = data;
                        _this.model.totalApprovedRecords = data.totalRecords;
                        _this.print();
                    }).catch(function (err) {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            _this.Modal.errorModal(err.data.message);
                        } else {
                            _this.Modal.errorModal(err);
                        }
                    }).finally(function () {
                        _this.model.gettingResidualCompletedApprovalList = false;
                    });
                }
            }
        }
    }, {
        key: 'print',
        value: function print() {
            setTimeout(function () {
                window.print();
            }, 1500);
        }
    }]);
    return PrintController;
}();

exports.default = PrintController;

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _final_residual_count_commit_print = __webpack_require__(1747);

var _final_residual_count_commit_print2 = _interopRequireDefault(_final_residual_count_commit_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printFinalResidualCountCommitModule = angular.module('printFinalResidualCountCommit', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/branchManagement.locations');

    $stateProvider.state('printFinalResidualCountCommit', {
        url: '/print-final-residual-count-commit',
        component: 'printFinalResidualCountCommit',
        data: {
            requireLogin: true,
            requireACL: 'branch_mgmt_final_residual_count_commit.all'
        }
    });
}]).component('printFinalResidualCountCommit', _final_residual_count_commit_print2.default).name;

exports.default = printFinalResidualCountCommitModule;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _import_file_view = __webpack_require__(2684);

var _import_file_view2 = _interopRequireDefault(_import_file_view);

var _import_file_view3 = __webpack_require__(1751);

var _import_file_view4 = _interopRequireDefault(_import_file_view3);

__webpack_require__(2969);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementImportFileViewComponent = {
  restrict: "E",
  bindings: {},
  template: _import_file_view2.default,
  controller: _import_file_view4.default
};

exports.default = branchManagementImportFileViewComponent;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportFileViewController = function () {
    /*@ngInject*/
    ImportFileViewController.$inject = ["Auth", "$state", "User", "DateUtil", "$translate", "$q", "Modal", "SetupService", "ImportFileViewService", "$rootScope"];
    function ImportFileViewController(Auth, $state, User, DateUtil, $translate, $q, Modal, SetupService, ImportFileViewService, $rootScope) {
        (0, _classCallCheck3.default)(this, ImportFileViewController);

        this.DateUtil = DateUtil;
        this.Modal = Modal;
        this.SetupService = SetupService;
        this.User = User;
        this.Auth = Auth;
        this.$translate = $translate;
        this.$q = $q;
        this.$state = $state;
        this.ImportFileViewService = ImportFileViewService;
        this.$rootScope = $rootScope;

        this.model = {
            currentBranch: User.getUser().branchId,
            branchCurrentVaultDate: '',
            loading: false,
            importFileViewObj: {
                results: [],
                totalRoutes: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                loading: false,
                status: null,
                statusList: [{ label: 'Success', value: 'OK' }, { label: 'Failed', value: 'ERROR' }],
                fileAdapterList: [],
                fileAdapter: null
            },
            evertecBatchFileObj: {
                results: [],
                totalRoutes: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                loading: false,
                statusList: [{ label: 'Success', value: 'OK' }, { label: 'Failed', value: 'ERROR' }],
                status: null,
                searchText: null
            },
            stats: {
                importFile: 'importFile',
                evertecBatch: 'evertecBatch'
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null
            },
            currentStat: 'importFile'
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/import-file-view');
    }

    (0, _createClass3.default)(ImportFileViewController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.model.loading = true;
            this.$q.all([this.SetupService.get(this.model.currentBranch), this.ImportFileViewService.getFileAdapterTypes()]).then(function (data) {
                _this.model.setupDetails = data[0];
                _this.model.importFileViewObj.fileAdapterList = data[1].results;
                _this.model.formattedvaultDate = _this.DateUtil.convertToDate(_this.model.setupDetails.currentVaultDate);
                _this.loadDateRangePicker(_this.model.dateRangeOptions, 'dateRange');
                _this.model.dateRangeOptions.startDate = moment().subtract(10, 'days').format('YYYY-MM-DD HH:mm:ss');
                _this.model.dateRangeOptions.endDate = moment();
                _this.loadData();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this.model.loading = false;
            });
        }
    }, {
        key: 'loadDateRangePicker',
        value: function loadDateRangePicker(dateRangeOption, modelVal) {
            var _this2 = this;

            this.model[modelVal] = {
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this2.filterImportFileView();
                    }
                },
                ranges: {
                    'Running 10 Days': [moment().subtract(10, 'days').format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            if (this.model.currentStat === this.model.stats.importFile) this.importFileView();
            if (this.model.currentStat === this.model.stats.evertecBatch) this.evertecBatchFileView();
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.loadData();
        }
    }, {
        key: 'tabSelection',
        value: function tabSelection() {
            if (this.model.currentStat === this.model.stats.importFile) {
                this.model.evertecBatchFileObj.pagination.page = 1;
                this.model.evertecBatchFileObj.status = null;
                this.model.evertecBatchFileObj.searchText = null;
                this.importFileView();
            } else if (this.model.currentStat === this.model.stats.evertecBatch) {
                this.model.importFileViewObj.pagination.page = 1;
                this.model.importFileViewObj.status = null;
                this.model.importFileViewObj.fileAdapter = null;
                this.evertecBatchFileView();
            }
        }
    }, {
        key: 'filterEvertecBatchView',
        value: function filterEvertecBatchView() {
            this.model.evertecBatchFileObj.pagination.page = 1;
            this.evertecBatchFileView();
        }
    }, {
        key: 'filterImportFileView',
        value: function filterImportFileView() {
            this.model.importFileViewObj.pagination.page = 1;
            this.importFileView();
        }
    }, {
        key: 'getStartDate',
        value: function getStartDate() {
            return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD 00:00:00') : null;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate() {
            return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59') : null;
        }
    }, {
        key: 'importFileView',
        value: function importFileView() {
            var _this3 = this;

            var status = this.model.importFileViewObj.status;
            var fileAdapter = this.model.importFileViewObj.fileAdapter;
            var startDate = this.getStartDate();
            var endDate = this.getEndDate();

            this.model.importFileViewObj.loading = true;
            this.ImportFileViewService.importFiles(startDate, endDate, status, fileAdapter, this.model.importFileViewObj.pagination.pageLimit, (this.model.importFileViewObj.pagination.page - 1) * this.model.importFileViewObj.pagination.pageLimit).then(function (data) {
                _this3.model.importFileViewObj.pagination.total = data.total;
                _this3.model.importFileViewObj.results = data.results;
                _this3.model.importFileViewObj.totalRecords = data.total;
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this3.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this3.model.importFileViewObj.loading = false;
            });
        }
    }, {
        key: 'evertecBatchFileView',
        value: function evertecBatchFileView() {
            var _this4 = this;

            var searchText = this.model.evertecBatchFileObj.searchText;
            var status = this.model.evertecBatchFileObj.status;

            this.model.evertecBatchFileObj.loading = true;
            this.ImportFileViewService.evertecBatchFiles(searchText, status, this.model.evertecBatchFileObj.pagination.pageLimit, (this.model.evertecBatchFileObj.pagination.page - 1) * this.model.evertecBatchFileObj.pagination.pageLimit).then(function (data) {
                _this4.model.evertecBatchFileObj.pagination.total = data.total;
                _this4.model.evertecBatchFileObj.results = data.results;
                _this4.model.evertecBatchFileObj.totalRecords = data.total;
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this4.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this4.model.evertecBatchFileObj.loading = false;
            });
        }
    }, {
        key: 'formatFileSize',
        value: function formatFileSize(bytes, decimalPoint) {
            if (bytes == 0) return '0 Bytes';
            var k = 1000,
                dm = decimalPoint || 2,
                sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }
    }, {
        key: 'formatSeconds',
        value: function formatSeconds(duration) {
            if (!duration) return;
            return Math.round(duration * 100) / 100 + ' Seconds';
        }
    }, {
        key: 'formatDate',
        value: function formatDate(date) {
            if (!date) return;
            return moment(date, 'MMDDYY').format('YYYY-MM-DD');
        }
    }]);
    return ImportFileViewController;
}();

exports.default = ImportFileViewController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _import_file_view = __webpack_require__(1750);

var _import_file_view2 = _interopRequireDefault(_import_file_view);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementImportFileViewModule = angular.module('branchManagementImportFileView', []).component('branchManagementImportFileView', _import_file_view2.default).name;

exports.default = branchManagementImportFileViewModule;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item_holds = __webpack_require__(1754);

var _item_holds2 = _interopRequireDefault(_item_holds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementItemHoldsModule = angular.module('branchManagementItemHolds', []).component('branchManagementItemHolds', _item_holds2.default).name;

exports.default = branchManagementItemHoldsModule;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item_holds = __webpack_require__(2685);

var _item_holds2 = _interopRequireDefault(_item_holds);

var _item_holds3 = __webpack_require__(1755);

var _item_holds4 = _interopRequireDefault(_item_holds3);

__webpack_require__(2970);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementItemHoldsComponent = {
  restrict: "E",
  bindings: {},
  template: _item_holds2.default,
  controller: _item_holds4.default
};

exports.default = branchManagementItemHoldsComponent;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemHoldsController = function () {
  /*@ngInject*/

  ItemHoldsController.$inject = ["Auth", "$state", "User", "UserService", "SetupService", "DateUtil", "RouteService", "$translate", "LocationService", "DataCounter", "ScanService", "$location", "$q", "Modal", "ShipmentService", "BranchService", "HoldService", "$scope", "UsersService", "Sound", "RouteStopService", "Navigation", "BulkCashService", "$rootScope", "CommonLayoutService"];
  function ItemHoldsController(Auth, $state, User, UserService, SetupService, DateUtil, RouteService, $translate, LocationService, DataCounter, ScanService, $location, $q, Modal, ShipmentService, BranchService, HoldService, $scope, UsersService, Sound, RouteStopService, Navigation, BulkCashService, $rootScope, CommonLayoutService) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ItemHoldsController);

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.BranchService = BranchService;
    this.ScanService = ScanService;
    this.DataCounter = DataCounter;
    this.$q = $q;
    this.$scope = $scope;
    this.Modal = Modal;
    this.ShipmentService = ShipmentService;
    this.HoldService = HoldService;
    this.BulkCashService = BulkCashService;
    this.UsersService = UsersService;
    this.RouteStopService = RouteStopService;
    this.Sound = Sound;
    this.Navigation = Navigation;
    this.$rootScope = $rootScope;
    this.CommonLayoutService = CommonLayoutService;

    this.model = {
      loading: false,
      lastChecked: null,
      search: null,
      branch: User.getUser().branchId,
      status: '',
      dateRange: {
        startDate: null,
        endDate: null
      },
      // includeReleased: false,

      dateRangPickerOptions: {
        autoApply: true,
        maxDate: moment(),
        eventHandlers: {
          'apply.daterangepicker': function applyDaterangepicker() {
            _this.loadData();
          }
        },
        ranges: {}
      },
      defaultRanges: {
        'Today': [moment().startOf('day'), moment()]
      },
      extraRanges: {
        'Current Week': [moment().startOf('week'), moment()],
        'Current Month': [moment().startOf('month'), moment()]
      },
      hasUnverifiedShipments: false,
      showVerifiedDate: false
    };

    this.fromLocations = [];
    this.toLocations = [];
    this.supervisors = [];
    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: _app2.default.defaultPageLimit,
      maxPages: 10
    };

    this.statusList = [{
      lable: 'All',
      value: ''
    }, {
      lable: 'Unverified',
      value: 'notSameVaultDate'
    }, {
      lable: 'Verified',
      value: 'sameVaultDate'
    }];

    this.shipments = [];
    this.branches = [];
    this.currentVaultDate = "";
    this.sortColumn = "verifiedOn";
    this.reverseSort = true;
    this.branchTimeZone = "";
    this.reportPrefix = 'Item_Hold';
    this.isExporting = false;
    this.shipmentData = '';
    this.branchVaultDate = '';
    this.loggedInUser = this.User.getUser().id;
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/item-holds');
    this.toggleSwitchUI = {
      size: 'small',
      onColor: 'success',
      offColor: 'danger'
    };
    this.showMapView = false;
    this.map = null;
  }

  (0, _createClass3.default)(ItemHoldsController, [{
    key: 'updateLastChecked',
    value: function updateLastChecked() {
      this.model.lastChecked = moment(this.currentVaultDate).format('YYYY-MM-DD');
    }
  }, {
    key: 'loadPermission',
    value: function loadPermission() {
      var _this2 = this;

      this.acl = {};
      this.hasACL = {};

      [].forEach(function (permissionKey) {
        _this2.acl[permissionKey] = _this2.User.getACL(permissionKey);

        _this2.hasACL[permissionKey] = {};

        _this2.acl[permissionKey].forEach(function (permission) {
          _this2.hasACL[permissionKey][permission] = true;
        });
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      this.loadData();
    }
  }, {
    key: 'search',
    value: function search() {
      this.pagination.page = 1;
      this.loadData();
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      // const searchObj = {
      //   queryJSON: {
      //     rules: [
      //       {
      //         field: 'status',
      //         condition: '=',
      //         data: 'ON_HOLD'
      //       },
      //     ],
      //     operator: 'AND'
      //   }
      // };

      // if (this.model.search) {
      //   searchObj.queryJSON.rules.push({
      //     group: {
      //       rules: [
      //         {
      //           field: 'trackingId',
      //           condition: 'like',
      //           data: `%${this.model.search}%`
      //         },
      //         {
      //           field: 'toLocationId',
      //           condition: 'like',
      //           data: `%${this.model.search}%`
      //         }
      //       ],
      //       operator: 'OR'
      //     }
      //   });
      // }

      // if (this.User.getUser().branchId) {
      //   searchObj.queryJSON.rules.push({
      //     field: 'branchId',
      //     condition: '=',
      //     data: this.User.getUser().branchId
      //   });
      // }

      // // for verified shipment
      // if (this.model.status === 'sameVaultDate') {
      //   searchObj.queryJSON.rules.push({
      //     field: 'verifiedOn',
      //     condition: '=',
      //     data: this.currentVaultDate
      //   })
      // }

      // // for unverified shipment
      // if (this.model.status === 'notSameVaultDate') {
      //   searchObj.queryJSON.rules.push({
      //     group: {
      //       rules: [
      //         {
      //           field: 'verifiedOn',
      //           condition: '=',
      //           data: null
      //         },
      //         {
      //           field: 'verifiedOn',
      //           condition: '!=',
      //           data: this.currentVaultDate
      //         }
      //       ],
      //       operator: 'OR'
      //     }
      //   })
      // }

      // if (this.model.fromLocation && this.model.fromLocation.Key) {
      //   searchObj.queryJSON.rules.push({
      //     field: 'fromLocationId',
      //     condition: '=',
      //     data: this.model.fromLocation.Value
      //   });
      // }

      // if (this.model.toLocation && this.model.toLocation.Key) {
      //   searchObj.queryJSON.rules.push({
      //     field: 'toLocationId',
      //     condition: '=',
      //     data: this.model.toLocation.Value
      //   });
      // }

      // if (this.model.supId && this.model.supId.Key) {
      //   searchObj.queryJSON.rules.push({
      //     field: 'supvHoldId',
      //     condition: '=',
      //     data: this.model.supId.Value
      //   });
      // }

      // return searchObj.queryJSON.rules.length ? searchObj : null;

      var searchObj = {
        trackingId: this.model.search ? '%' + this.model.search + '%' : null,
        toLocationId: this.model.toLocation && this.model.toLocation.Key ? this.model.toLocation.Value : null,
        fromLocationId: this.model.fromLocation && this.model.fromLocation.Key ? this.model.fromLocation.Value : null,
        supId: this.model.supId && this.model.supId.Key ? this.model.supId.Value : null,
        isVerified: this.model.status === 'sameVaultDate' ? true : false,
        verifiedOn: this.model.status === 'sameVaultDate' || this.model.status === 'notSameVaultDate' ? this.currentVaultDate : null,
        branchId: this.User.getUser().branchId,
        sortOrder: this.reverseSort ? 'DESC' : 'ASC',
        sortColumn: this.sortColumn
      };
      return searchObj;
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      var searchObj = this.generateSearchObj();
      this.model.loading = true;
      this.moment = moment;
      this.model.hasUnverifiedShipments = false;
      // this.model.showVerifiedDate = false;
      this.verifiedOn = "";
      this.updateLastChecked();

      return this.HoldService.holdItems(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit).then(function (data) {
        _this3.pagination.total = data.total;

        _this3.pagination.loading = false;
        _this3.shipments = data.results;

        if (_this3.model.status !== 'sameVaultDate' && data.pendingToVerifyShipments > 0) {
          _this3.model.hasUnverifiedShipments = true;
        }

        _this3.shipments.forEach(function (shipment) {
          _this3.verifiedOn = moment.utc(shipment.verifiedOn).format('YYYY-MM-DD');
          shipment.onHold = shipment.status === 'ON_HOLD';

          if (shipment.onHold) {

            // if (!shipment.verifiedOn || this.verifiedOn != this.currentVaultDate) {
            //   this.model.hasUnverifiedShipments = true;
            // }

            // if (this.verifiedOn == this.currentVaultDate) {
            //   this.model.showVerifiedDate = true;
            // }

            shipment.status = 'HOLD';
          } else {
            shipment.status = 'RELEASES';
          }
        });
      })
      // .then(() => {
      //   const promises = this.shipments.map(({ trackingId }) => new Promise(res => {
      //     this.ShipmentService.get(trackingId)
      //       .then(res)
      //       .catch(e => res(null))
      //   }));

      //   return this.$q.all(promises)
      //     .then((shipments) => {
      //       shipments.forEach((shipment, index) => {
      //         if (shipment == null) return;
      //         if (shipment.tankerId == null) {
      //           shipment.tankerId = this.branches.tankerId;
      //           this.shipments[index] = _.merge(this.shipments[index], shipment);
      //         } else {
      //           this.shipments[index] = _.merge(this.shipments[index], shipment);
      //         }
      //       });
      //     })
      //     .catch((err) => {
      //       this.error = err.message;
      //     });
      // })
      .catch(function (err) {
        _this3.error = err.message;
      }).finally(function () {
        _this3.model.loading = false;
        _this3.validateMapView();
        if (_this3.showMapView && _this3.isValidMapView) {
          setTimeout(function () {
            return _this3.initHoldMap();
          }, 200);
        }
      });
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this4 = this;

      this.loadPermission();
      this.model.status = this.statusList[0].value;
      this.model.dateRangPickerOptions.ranges = (0, _assign2.default)(this.model.defaultRanges);
      this.shipmentData = this.DataCounter.getData();
      this.$q.all([this.SetupService.get(this.User.getUser().branchId), this.loadToLocation(null, 0, _app2.default.defaultPageLimit), this.loadFromLocation(null, 0, _app2.default.defaultPageLimit), this.loadSupervisors(null, 0, _app2.default.defaultPageLimit), this.getSoftDeleteShipmentPermission()]).then(function (data) {
        _this4.currentVaultDate = _this4.DateUtil.getUTCDate(data[0].currentVaultDate); // branch vaultDate converted to UTC format
        _this4.branchTimeZone = data[0].timezone;
        _this4.branchVaultDate = data[0].currentVaultDate; // branch vaultDate without conversion
        _this4.setupInfo = data[0];
        _this4.convertToPickup = data[0].convertToPickup;
      }).then(function () {
        if (_this4.shipmentData && _this4.shipmentData.isRedirected) _this4.filterRecords();else _this4.loadData();
      }).catch(function (err) {
        console.log(err);
      });

      this.model.dateRange;
    }
  }, {
    key: 'loadFromLocation',
    value: function loadFromLocation(searchKey, offset) {
      var _this5 = this;

      var searchObj = {
        // holdFlag: 1,
        branchId: this.User.getUser().branchId,
        searchVal: searchKey || ''
      };
      this.ShipmentService.getShipmentFromLocations(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this5.totalFromLocation = data.total;
          _this5.fromLocations = _this5.mappingLocationData(data.results);
        } else {
          var fromLocations = _this5.mappingLocationData(data.results);
          _this5.fromLocations = _this5.fromLocations.concat(fromLocations);
        }
      });
    }
  }, {
    key: 'loadToLocation',
    value: function loadToLocation(searchKey, offset) {
      var _this6 = this;

      var searchObj = {
        holdFlag: 1,
        branchId: this.User.getUser().branchId,
        searchVal: searchKey || ''
      };
      this.ShipmentService.getShipmentToLocations(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this6.totalToLocation = data.total;
          _this6.toLocations = _this6.mappingLocationData(data.results);
        } else {
          var toLocations = _this6.mappingLocationData(data.results);
          _this6.toLocations = _this6.toLocations.concat(toLocations);
        }
      });
    }
  }, {
    key: 'mappingLocationData',
    value: function mappingLocationData(location) {
      return location.map(function (loc) {
        return {
          Key: loc.id + " | " + loc.name,
          Value: loc.id
        };
      });
    }
  }, {
    key: 'loadSupervisors',
    value: function loadSupervisors(searchKey, offset) {
      var _this7 = this;

      searchKey = searchKey || '';
      var searchObj = {
        queryJSON: {
          rules: [{
            field: "supervisor",
            condition: "=",
            data: true
          }, {
            field: "branchId",
            condition: "=",
            data: this.model.branch
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'firstName',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'lastName',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: "AND"
        }
      };

      this.UsersService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this7.totalSupervisor = data.total;
          _this7.supervisors = _this7.mappingUserData(data.results);
        } else {
          var supervisors = _this7.mappingUserData(data.results);
          _this7.supervisors = _this7.supervisors.concat(supervisors);
        }
      });
    }
  }, {
    key: 'mappingUserData',
    value: function mappingUserData(users) {
      return users.map(function (user) {
        return {
          Key: user.id + ' | ' + user.firstName + ' ' + user.lastName,
          Value: user.id
        };
      });
    }
    // show All log of itemHold data 

  }, {
    key: 'showAllLog',
    value: function showAllLog(shipment) {
      this.Modal.itemHoldLogDetails(shipment, function (_ref) {
        var modal = _ref.modal;
      });
    }

    // Release item from HOLD

  }, {
    key: 'releaseItem',
    value: function releaseItem(shipment) {
      var _this8 = this;

      if (this.isLoading) return;
      this.isLoading = true;

      this.UsersService.checkSupervisor(this.loggedInUser).then(function (userInfo) {
        _this8.Modal.holdReleases(shipment, !userInfo.supervisor, function (_ref2) {
          var supervisorId = _ref2.supervisorId,
              comment = _ref2.comment,
              shipmentAssignedTo = _ref2.shipmentAssignedTo,
              selectedDate = _ref2.selectedDate,
              routeInfo = _ref2.routeInfo,
              modal = _ref2.modal;

          var hDate = moment(selectedDate).format('YYYY-MM-DD');
          _this8.ShipmentService.holdRelease(shipment.trackingId, shipment.routeId, shipmentAssignedTo, hDate, userInfo.supervisor ? userInfo.id : supervisorId, comment, shipment.branchId).then(function (data) {
            modal.close();
            var totals = _this8.DataCounter.getCounterForItemHold();
            _this8.DataCounter.setCounterForItemHold(totals - 1);
            _this8.Sound.playSuccessBeep("#success_beep");
          }).then(function () {
            if (routeInfo.routeTransfered) {
              _this8.updateRouteDetail(shipmentAssignedTo, selectedDate);
            }
            // if (routeInfo.autoOptimize) {
            //   this.autoOptimizeRouteStop(shipmentAssignedTo, selectedDate);
            // }
          }).then(function () {
            _this8.loadData();
            _this8.isLoading = false;
          }).catch(function (err) {
            modal.close();
            _this8.isLoading = false;
            _this8.Sound.PlayErrorBeep("#scanner_beep");
            if (err && err.data && err.data.message) {
              return _this8.Modal.errorModal("error." + err.data.message);
            }
          });
        }, function (_ref3) {
          var modal = _ref3.modal;

          _this8.isLoading = false;
          if (modal) modal.close();
        });
      }).catch(function (err) {
        _this8.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: 'autoOptimizeRouteStop',
    value: function autoOptimizeRouteStop(routeId, routeDate) {
      var _this9 = this;

      var formattedDate = moment.utc(routeDate).format('YYYY-MM-DD');
      this.RouteStopService.autoOptimizeRouteStops(formattedDate, routeId).then(function (data) {}).catch(function (err) {
        if (err && err.data && err.data.message) {
          return _this9.Modal.errorModal(err.data.message);
        }
      });
    }
  }, {
    key: 'updateRouteDetail',
    value: function updateRouteDetail(route, date) {
      var _this10 = this;

      var formattedDate = moment.utc(date).format('YYYY-MM-DD');
      var defer = this.$q.defer();
      this.HoldService.updateRouteDetail(route).then(function (data) {
        defer.resolve();
      }).catch(function (err) {
        console.log(err);
        defer.reject();
      });
      defer.promise.then(function () {
        return _this10.RouteService.releaseRoute(route, formattedDate);
      });
    }

    // Cancel Delivery & Return Item from HOLD

  }, {
    key: 'returnItem',
    value: function returnItem(shipment) {
      var _this11 = this;

      if (this.isLoading) return;
      this.isLoading = true;
      this.Modal.returnItems(shipment, function (_ref4) {
        var supervisorId = _ref4.supervisorId,
            comment = _ref4.comment,
            returnItemTo = _ref4.returnItemTo,
            selectedDate = _ref4.selectedDate,
            modal = _ref4.modal;

        var hDate = moment.utc(selectedDate).format('YYYY-MM-DD hh:mm:ss');
        _this11.ShipmentService.shipmentReturn(shipment.tankerId, shipment.trackingId, shipment.routeId, returnItemTo, hDate, supervisorId, comment, shipment.branchId).then(function (data) {
          modal.close();
          var totals = _this11.DataCounter.getCounterForItemHold();
          _this11.DataCounter.setCounterForItemHold(totals - 1);
        }).then(function () {
          _this11.loadData();
          _this11.isLoading = false;
        }).catch(function (err) {
          modal.close();
          _this11.isLoading = false;
          if (err && err.data && err.data.message) {
            return _this11.Modal.errorModal("error." + err.data.message);
          }
        });
      }, function (_ref5) {
        var modal = _ref5.modal;

        if (modal) modal.close();
        _this11.isLoading = false;
      });
    }

    // verify hold shipment, update tanker for shipemnt 

  }, {
    key: 'validateSupervisorScan',
    value: function validateSupervisorScan() {
      var _this12 = this;

      if (this.isLoading) return;
      this.isLoading = true;

      this.UsersService.checkSupervisor(this.loggedInUser).then(function (userInfo) {
        if (userInfo && userInfo.supervisor) {
          _this12.$rootScope.supervisorIds = {
            id: userInfo.id,
            name: userInfo.firstName + ' ' + userInfo.lastName
          };
          return _this12.verifyHoldShipment(userInfo.id);
        } else {
          _this12.Modal.confirmSupervisor('verify-shipments', null, function (_ref6) {
            var modal = _ref6.modal,
                supId = _ref6.supId;

            modal.close();
            return _this12.verifyHoldShipment(supId);
          }, function (_ref7) {
            var modal = _ref7.modal;

            modal.close();
            _this12.isLoading = false;
          });
        }
      }).catch(function (err) {
        _this12.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: 'verifyHoldShipment',
    value: function verifyHoldShipment(supId) {
      var _this13 = this;

      this.Modal.verifyHoldShipments(this.model.lastChecked, this.setupInfo.allowBulkHoldVerify, function (_ref8) {
        var modal = _ref8.modal,
            $scope = _ref8.$scope,
            Verifycomments = _ref8.Verifycomments;

        var defer = _this13.$q.defer();
        $scope.loading = true;
        _this13.holdTrackingId = $scope.model.verifiedShipments.map(function (data) {
          return data.trackingId;
        });

        _this13.HoldService.verifyHoldshipment(_this13.User.getUser().branchId, _this13.holdTrackingId, Verifycomments, supId, _this13.currentVaultDate, $scope.model.bulkVerified).then(function (data) {
          modal.close();
          defer.resolve(data);
          return _this13.ShipmentService.updateShipmentTankerId(_this13.holdTrackingId, $scope.model.tankerId, _this13.model.branch); //  update tanker for shipemnt
        }).catch(function (err) {
          modal.close();
          if (err && err.data && err.data.message) {
            defer.reject(err);
            _this13.Modal.errorModal('error.' + err.data.message);
          }
        });
        defer.promise.then(function () {
          _this13.loadData();
          _this13.isLoading = false;
        });
      }, function (_ref9) {
        var modal = _ref9.modal;

        modal.close();
        _this13.isLoading = false;
      });
    }

    // show log of verify data by trackingId   

  }, {
    key: 'showLogById',
    value: function showLogById(shipment) {
      var _this14 = this;

      if (this.isLoading) return;
      this.isLoading = true;
      this.Modal.itemHoldLogDetails(shipment.trackingId, shipment.holdverifies[0].holdId, false, function (_ref10) {
        var modal = _ref10.modal;

        if (modal) modal.close();
        _this14.isLoading = false;
      }, function (_ref11) {
        var modal = _ref11.modal;

        if (modal) modal.close();
        _this14.isLoading = false;
      });
    }
  }, {
    key: 'convertToCrv',
    value: function convertToCrv(shipment) {
      var _this15 = this;

      if (this.isLoading) return;
      this.isLoading = true;

      this.UsersService.checkSupervisor(this.loggedInUser).then(function (userInfo) {
        _this15.Modal.convertToCrv(shipment, !userInfo.supervisor, true, function (_ref12) {
          var supervisor = _ref12.supervisor,
              trackingIdResidual = _ref12.trackingIdResidual,
              modal = _ref12.modal;

          if (trackingIdResidual) {
            var defer = _this15.$q.defer();
            _this15.HoldService.convertToCRV(_this15.model.branch, shipment.trackingId, trackingIdResidual, userInfo.supervisor ? userInfo.id : supervisor).then(function (data) {
              modal.close();
              var totals = _this15.DataCounter.getCounterForItemHold();
              _this15.DataCounter.setCounterForItemHold(totals - 1);
              defer.resolve(data);
            }).catch(function (err) {
              modal.close();
              if (err && err.data && err.data.message) {
                _this15.isLoading = false;
                _this15.Modal.errorModal('error.' + err.data.message);
              }
            });
            defer.promise.then(function () {
              _this15.isLoading = false;
              _this15.loadData();
            });
          } else {
            if (modal) modal.close();
            _this15.isLoading = false;
          }
        }, function (_ref13) {
          var modal = _ref13.modal;

          if (modal) modal.close();
          _this15.isLoading = false;
        });
      }).catch(function (err) {
        _this15.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: 'convertToCrvPackableOrder',
    value: function convertToCrvPackableOrder(shipment) {
      var _this16 = this;

      if (this.isLoading) return;
      this.isLoading = true;
      this.Modal.confirm({
        header: 'Confirm CRV Conversion',
        message: 'Are you sure you want to convert this Shipment to CRV?',
        callback: function callback(_ref14) {
          var modal = _ref14.modal,
              $scope = _ref14.$scope;

          modal.close();
          _this16.UsersService.checkSupervisor(_this16.loggedInUser).then(function (userInfo) {
            _this16.Modal.confirmSupervisor('shipment-hold-convert-CRV', { trackingId: shipment.trackingId }, function (_ref15) {
              var supModal = _ref15.modal,
                  supId = _ref15.supId;

              supModal.close();
              var defer = _this16.$q.defer();
              _this16.HoldService.convertToCrvPackableOrder(_this16.model.branch, shipment.trackingId, shipment.packableOrderShipmentId, supId).then(function (data) {
                var totals = _this16.DataCounter.getCounterForItemHold();
                _this16.DataCounter.setCounterForItemHold(totals - 1);
                defer.resolve(data);
              }).catch(function (err) {
                if (err && err.data && err.data.message) {
                  _this16.isLoading = false;
                  _this16.Modal.errorModal('error.' + err.data.message);
                }
              });

              defer.promise.then(function () {
                _this16.isLoading = false;
                _this16.loadData();
              });
            }, function (_ref16) {
              var supModal = _ref16.modal;

              supModal.close();
              _this16.isLoading = false;
            });
          }).catch(function (err) {
            _this16.Modal.errorModal(err.data.message);
            _this16.isLoading = false;
          });
        },
        negative: function negative(_ref17) {
          var modal = _ref17.modal,
              $scope = _ref17.$scope;

          modal.close();
          _this16.isLoading = false;
        }
      });
    }

    // soft delete shipment (it will update shipment.deleted flag true, and hold.status = 'DELETED')
    // note : if user delete loadShipments it will also delete residualShipments   

  }, {
    key: 'removeShipment',
    value: function removeShipment(shipment) {
      var _this17 = this;

      if (this.isLoading) return;
      this.isLoading = true;
      this.shipmentId = shipment.shipmentId || null;
      this.Modal.deletedReason(shipment, function (_ref18) {
        var supervisorId = _ref18.supervisorId,
            reason = _ref18.reason,
            modal = _ref18.modal;

        _this17.HoldService.softDeleteShipment(shipment.trackingId, supervisorId, reason, _this17.shipmentId, shipment.branchId).then(function () {
          modal.close();
          var totals = _this17.DataCounter.getCounterForItemHold();
          _this17.DataCounter.setCounterForItemHold(totals - 1);
        }).then(function () {
          setTimeout(function () {
            _this17.loadData();
            _this17.isLoading = false;
          }, 500);
        }).catch(function (err) {
          modal.close();
          _this17.isLoading = false;
          if (err && err.data && err.data.message) {
            return _this17.Modal.errorModal('error.' + err.data.message);
          }
        });
      }, function (_ref19) {
        var modal = _ref19.modal;

        if (modal) modal.close();
        _this17.isLoading = false;
      });
    }
  }, {
    key: 'sortData',
    value: function sortData(column) {
      this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
      this.sortColumn = column;
      this.loadData();
    }

    //   getOrderType(type) {
    //     switch (type) {
    //         case type: return this.$translate.instant('shipment.order_type_' + type);
    //         default: return '';
    //     }
    // }

  }, {
    key: 'goToItemHistory',
    value: function goToItemHistory(trackingId) {
      this.$state.go('branchManagement.items', {
        id: trackingId
      });
    }
  }, {
    key: 'markAsDelivered',
    value: function markAsDelivered(shipment) {
      var _this18 = this;

      this.Modal.markAsDelivered(shipment, this.branchVaultDate, this.branchTimeZone, function (_ref20) {
        var modal = _ref20.modal,
            supervisorId = _ref20.supervisorId,
            comment = _ref20.comment,
            loadedAmount = _ref20.loadedAmount,
            date = _ref20.date,
            time = _ref20.time,
            sendDeliveryReceipt = _ref20.sendDeliveryReceipt;

        _this18.HoldService.shipmentDelivery(shipment.trackingId, shipment.route.id, supervisorId, comment, shipment.branchId, loadedAmount, date, time, _this18.branchTimeZone, shipment.orderType, shipment.amount, sendDeliveryReceipt).then(function () {
          modal.close();
          var totals = _this18.DataCounter.getCounterForItemHold();
          _this18.DataCounter.setCounterForItemHold(totals - 1);
          _this18.loadData(); // refresh data after shipment delivered  
        }).catch(function (err) {
          modal.close();
          _this18.Modal.errorModal('error.' + err.data.message);
        });
      }, function (_ref21) {
        var modal = _ref21.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'redirectToOrderTab',
    value: function redirectToOrderTab(data) {
      var obj = {
        orderNo: data.orderNo,
        vaultDate: data.holdDate,
        isRedirected: true,
        isCounted: false,
        isInProcess: true,
        fundingSourceId: data.fundingSourceId
      };
      this.DataCounter.setData(obj);
      this.$state.go('branchManagement.orders');
    }
  }, {
    key: 'removeLeadingZero',
    value: function removeLeadingZero(orderNo) {
      if (orderNo) return orderNo.replace(/^0+/, '');
    }
  }, {
    key: 'exportData',
    value: function exportData() {
      var _this19 = this;

      var searchObj = this.generateSearchObj();
      searchObj.currentVaultDate = this.currentVaultDate;

      this.isExporting = true;
      this.HoldService.exportItemHoldData(searchObj, 0, 10000).then(function (data) {
        _this19.fileName = _this19.reportPrefix.concat('_', _this19.currentVaultDate, '.csv');
        var a = document.createElement("a");
        document.body.appendChild(a);
        var file = new Blob([data.reportData], { type: 'application/csv' });
        var fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = _this19.fileName;
        a.click();
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this19.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this19.isExporting = false;
      });
    }
  }, {
    key: 'filterRecords',
    value: function filterRecords() {
      var _this20 = this;

      if (this.shipmentData && this.shipmentData.isRedirected) {
        this.model.search = this.shipmentData.trackingId;
        this.loadData().then(function () {
          _this20.resetFilters();
        });
      }
    }
  }, {
    key: 'resetFilters',
    value: function resetFilters() {
      if (this.shipmentData) {
        this.shipmentData.isRedirected = false;
        this.shipmentData = this.DataCounter.setData();
      }
    }
  }, {
    key: 'orderPackingUndo',
    value: function orderPackingUndo(shipment) {
      var _this21 = this;

      if (this.loading) return;
      this.loading = true;

      this.Modal.undoPackedOrder(shipment, function (_ref22) {
        var modal = _ref22.modal,
            supervisorId = _ref22.supervisorId,
            deleteOrder = _ref22.deleteOrder,
            deletedReason = _ref22.deletedReason,
            $scope = _ref22.$scope;

        _this21.ShipmentService.orderPackingUndo(shipment.branchId, shipment.shipmentId, supervisorId, deletedReason, deleteOrder).then(function () {
          modal.close();
          _this21.loading = false;
          var totals = _this21.DataCounter.getCounterForItemHold();
          _this21.DataCounter.setCounterForItemHold(totals - 1);
          _this21.loadData();
        }).catch(function (err) {
          modal.close();
          if (err && err.data && err.data.message) {
            _this21.loading = false;
            _this21.Modal.errorModal('error.' + err.data.message);
          }
        });
      }, function (_ref23) {
        var modal = _ref23.modal;

        if (modal) modal.close();
        _this21.loading = false;
      });
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(locationId) {
      return this.Navigation.goToServiceHistory(locationId, null, true, null);
    }
  }, {
    key: 'isAllowedToUnpack',
    value: function isAllowedToUnpack(shipment) {
      var shipmentPackedDate = void 0,
          branchCurrentVaultDate = void 0;

      if (shipment.fundingSourceId && shipment.unpackAnyTime) {
        return true;
      } else if (shipment.fundingSourceId && !shipment.unpackAnyTime) {
        shipmentPackedDate = new Date(shipment.packedDate);
        branchCurrentVaultDate = new Date(this.branchVaultDate);
        return shipmentPackedDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();
      } else {
        return true;
      }
    }
  }, {
    key: 'markAsCheckedIn',
    value: function markAsCheckedIn(shipment) {
      var _this22 = this;

      this.Modal.confirmSupervisor('mark-as-checked-in', shipment.trackingId, function (_ref24) {
        var modal = _ref24.modal,
            supId = _ref24.supId;

        _this22.HoldService.shipmentHoldMarkCheckedIn(shipment.trackingId, supId, shipment.branchId, shipment.routeId).then(function () {
          modal.close();
          var totals = _this22.DataCounter.getCounterForItemHold();
          _this22.DataCounter.setCounterForItemHold(totals - 1);
          _this22.loadData();
        }).catch(function (err) {
          modal.close();
          if (err && err.data && err.data.message) {
            return _this22.Modal.errorModal('error.' + err.data.message);
          }
        });
      }, function (_ref25) {
        var modal = _ref25.modal;

        modal.close();
      });
    }
  }, {
    key: 'softDeleteBagouts',
    value: function softDeleteBagouts() {
      var _this23 = this;

      var reason = 'Auto Soft Delete Bagouts Enabled';

      this.isSoftDeleting = true;
      this.Modal.bagoutsOnHoldModal(function (_ref26) {
        var modal = _ref26.modal,
            supervisorId = _ref26.supervisorId;

        _this23.HoldService.softDeleteBagoutsOnHold(_this23.model.branch, supervisorId, reason).then(function () {
          _this23.loadData();
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this23.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          modal.close();
          _this23.isSoftDeleting = false;
        });
      }, function (_ref27) {
        var modal = _ref27.modal;

        if (modal) modal.close();
        _this23.isSoftDeleting = false;
      });
    }
  }, {
    key: 'formatAddress',
    value: function formatAddress(data) {
      var locationAddress = '';
      if (!data || !data.toLocation) return;

      if (data.toLocation.address) {
        locationAddress = locationAddress.concat(data.toLocation.address, ', ');
      }
      if (data.toLocation.city) {
        locationAddress = locationAddress.concat(data.toLocation.city, ', ');
      }
      if (data.toLocation.state) {
        locationAddress = locationAddress.concat(data.toLocation.state, ', ');
      }
      if (data.toLocation.zip) {
        locationAddress = locationAddress.concat(data.toLocation.zip, '.');
      }
      return locationAddress;
    }
  }, {
    key: 'isNullorEmptyString',
    value: function isNullorEmptyString(comment) {
      return comment == null || comment.trim() === '';
    }
  }, {
    key: 'releasePickupShipment',
    value: function releasePickupShipment(shipment) {
      var _this24 = this;

      if (this.isLoading) return;
      this.isLoading = true;

      this.UsersService.checkSupervisor(this.loggedInUser).then(function (userInfo) {
        _this24.Modal.pickupHoldRelease(shipment, !userInfo.supervisor, function (_ref28) {
          var supervisorId = _ref28.supervisorId,
              comment = _ref28.comment,
              shipmentAssignedTo = _ref28.shipmentAssignedTo,
              selectedDate = _ref28.selectedDate,
              routeInfo = _ref28.routeInfo,
              locationId = _ref28.locationId,
              modal = _ref28.modal;

          var hDate = moment(selectedDate).utc(true).format('YYYY-MM-DD');
          _this24.HoldService.pickupHoldRelease(shipment.trackingId, shipment.routeId, shipmentAssignedTo, hDate, userInfo.supervisor ? userInfo.id : supervisorId, comment, shipment.branchId, locationId).then(function () {
            modal.close();
            var totals = _this24.DataCounter.getCounterForItemHold();
            _this24.DataCounter.setCounterForItemHold(totals - 1);
            _this24.Sound.playSuccessBeep("#success_beep");
          }).then(function () {
            if (routeInfo.routeTransfered) {
              _this24.updateRouteDetail(shipmentAssignedTo, selectedDate);
            }
          }).then(function () {
            _this24.loadData();
            _this24.isLoading = false;
          }).catch(function (err) {
            modal.close();
            _this24.isLoading = false;
            _this24.Sound.PlayErrorBeep("#scanner_beep");
            if (err && err.data && err.data.message) {
              return _this24.Modal.errorModal("error." + err.data.message);
            }
          });
        }, function (_ref29) {
          var modal = _ref29.modal;

          _this24.isLoading = false;
          if (modal) modal.close();
        });
      }).catch(function (err) {
        _this24.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: 'convertShipmentHoldToPickup',
    value: function convertShipmentHoldToPickup(shipment) {
      var _this25 = this;

      this.Modal.confirmSupervisor('convert-shipment-hold-to-pickup', shipment.trackingId, function (_ref30) {
        var modal = _ref30.modal,
            supId = _ref30.supId;

        _this25.HoldService.convertShipmentHoldToPickup(shipment.trackingId, shipment.routeId, supId, shipment.branchId, shipment.fromLocationId, shipment.toLocationId).then(function () {
          modal.close();
          var totals = _this25.DataCounter.getCounterForItemHold();
          _this25.DataCounter.setCounterForItemHold(totals - 1);
          _this25.loadData();
        }).catch(function (err) {
          modal.close();
          if (err && err.data && err.data.message) {
            return _this25.Modal.errorModal('error.' + err.data.message);
          }
        });
      }, function (_ref31) {
        var modal = _ref31.modal;

        modal.close();
      });
    }
  }, {
    key: 'canReleaseForCount',
    value: function canReleaseForCount(shipment) {
      return !!(shipment && shipment.onHold && shipment.canReleaseForCount === 1);
    }
  }, {
    key: 'releaseForCount',
    value: function releaseForCount(shipment) {
      var _this26 = this;

      if (this.isLoading) return;
      this.isLoading = true;

      this.Modal.confirmSupervisor('release-for-count', shipment.trackingId, function (_ref32) {
        var modal = _ref32.modal,
            supId = _ref32.supId;

        var defaultComment = 'Released for count';
        _this26.HoldService.releaseForCount(shipment.trackingId, shipment.routeId, supId, defaultComment).then(function () {
          modal.close();
          var totals = _this26.DataCounter.getCounterForItemHold();
          _this26.DataCounter.setCounterForItemHold(Math.max(0, totals - 1));
        }).then(function () {
          _this26.loadData();
          _this26.isLoading = false;
        }).catch(function (err) {
          modal.close();
          _this26.isLoading = false;
          if (err && err.data && err.data.message) {
            return _this26.Modal.errorModal('error.' + err.data.message);
          }
        });
      }, function (_ref33) {
        var modal = _ref33.modal;

        if (modal) modal.close();
        _this26.isLoading = false;
      });
    }
  }, {
    key: 'getOrderType',
    value: function getOrderType(shiptype, orderType) {
      if (shiptype == "C" && orderType !== null) {
        return this.$translate.instant('atm_residual.order_type_' + orderType);
      } else if (shiptype == "C" && orderType == null) {
        return shiptype.toUpperCase();
      } else {
        return shiptype.toUpperCase();
      }
    }
  }, {
    key: 'getSoftDeleteShipmentPermission',
    value: function getSoftDeleteShipmentPermission() {
      var _this27 = this;

      this.UsersService.validateUserPermissions(this.User.getUser().firstName, this.User.getUser().lastName).then(function (permissions) {
        _this27.hasSoftDeleteShipmentPermission = permissions.hasSoftDeleteShipmentPermission || _this27.CommonLayoutService.isAllowToAccessPages();
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'validateMapView',
    value: function validateMapView() {
      this.isValidMapView = !!(this.showMapView && !this.model.loading && Array.isArray(this.shipments) && this.shipments.some(function (s) {
        return s.toLocation && s.toLocation.lat && s.toLocation.long;
      }));
      return this.isValidMapView;
    }
  }, {
    key: 'toggleMapView',
    value: function toggleMapView() {
      var _this28 = this;

      this.validateMapView();
      if (!this.showMapView && this.map) {
        this.map.remove();
        this.map = null;
      } else if (this.showMapView && !this.map && this.isValidMapView) {
        setTimeout(function () {
          _this28.initHoldMap();
        }, 200);
      }
    }
  }, {
    key: 'initHoldMap',
    value: function initHoldMap() {
      var _this29 = this;

      try {
        if (!document.getElementById('hold-map')) {
          console.error('Map container not found');
          return;
        }

        if (this.map) {
          this.map.remove();
        }

        // Get branch location
        var branchLat = this.setupInfo && this.setupInfo.gpsLat ? this.setupInfo.gpsLat : 39.6864921;
        var branchLng = this.setupInfo && this.setupInfo.gpsLong ? this.setupInfo.gpsLong : -101.4827398;

        this.map = L.map('hold-map', {});

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors'
        }).addTo(this.map);

        // Branch marker with complete info
        var branchInfo = '<strong>' + this.setupInfo.branchId + '</strong><br>' + this.setupInfo.address + ' - ' + this.setupInfo.zip + '<br>' + this.setupInfo.city + ', ' + this.setupInfo.state;

        var branchMarker = L.marker([branchLat, branchLng], {
          icon: new L.AwesomeNumberMarkers({
            number: 'B',
            markerColor: 'black'
          })
        }).addTo(this.map).bindPopup(branchInfo);

        branchMarker.on('mouseover', function () {
          this.openPopup();
        });

        branchMarker.on('mouseout', function () {
          this.closePopup();
        });

        // Hold locations
        if (this.shipments) {
          this.shipments.forEach(function (shipment, index) {
            if (shipment.toLocation && shipment.toLocation.lat && shipment.toLocation.long) {
              var locationInfo = '<strong>' + shipment.toLocation.name + '</strong> | <span>' + shipment.trackingId + '</span><br>' + shipment.toLocation.address + ' - ' + shipment.toLocation.zip + '<br>' + shipment.toLocation.city + ', ' + shipment.toLocation.state;
              var marker = L.marker([shipment.toLocation.lat, shipment.toLocation.long], {
                icon: new L.AwesomeNumberMarkers({
                  number: index + 1,
                  markerColor: 'blue'
                })
              }).addTo(_this29.map).bindPopup(locationInfo);

              marker.on('mouseover', function () {
                this.openPopup();
              });

              marker.on('mouseout', function () {
                this.closePopup();
              });
            }
          });
        }

        var bounds = this.shipments.filter(function (s) {
          return s.toLocation && s.toLocation.lat && s.toLocation.long;
        }).map(function (s) {
          return [s.toLocation.lat, s.toLocation.long];
        });
        bounds.push([branchLat, branchLng]);

        if (bounds.length) {
          this.map.fitBounds(bounds);
        } else {
          this.map.setView([branchLat, branchLng], 7);
        }

        setTimeout(function () {
          _this29.map.invalidateSize();
        }, 100);
      } catch (error) {
        console.error('Error initializing map:', error);
      }
    }
  }, {
    key: 'canShowMap',
    get: function get() {
      return this.isValidMapView;
    }
  }]);
  return ItemHoldsController;
}();

exports.default = ItemHoldsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _items = __webpack_require__(1757);

var _items2 = _interopRequireDefault(_items);

var _print = __webpack_require__(1759);

var _print2 = _interopRequireDefault(_print);

__webpack_require__(533);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementItemsModule = angular.module('branchManagementItemHistoryHolds', [_print2.default]).component('branchManagementItemHistoryHolds', _items2.default).name;

exports.default = branchManagementItemsModule;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _items = __webpack_require__(2686);

var _items2 = _interopRequireDefault(_items);

var _items3 = __webpack_require__(1758);

var _items4 = _interopRequireDefault(_items3);

__webpack_require__(533);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementItemsComponent = {
  restrict: "E",
  bindings: {},
  template: _items2.default,
  controller: _items4.default
};

exports.default = branchManagementItemsComponent;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemsController = function () {
  /*@ngInject*/
  ItemsController.$inject = ["Auth", "$state", "User", "$translate", "$location", "$q", "Modal", "$scope", "TransactionService", "SetupService", "ShipmentService", "DateUtil", "RouteService", "$stateParams", "DataCounter", "HoldService", "Navigation", "UsersService", "$window", "TimezoneList", "LocationService", "CommonLayoutService", "$rootScope"];
  function ItemsController(Auth, $state, User, $translate, $location, $q, Modal, $scope, TransactionService, SetupService, ShipmentService, DateUtil, RouteService, $stateParams, DataCounter, HoldService, Navigation, UsersService, $window, TimezoneList, LocationService, CommonLayoutService, $rootScope) {
    (0, _classCallCheck3.default)(this, ItemsController);

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$scope = $scope;
    this.Modal = Modal;
    this.$q = $q;
    this.TransactionService = TransactionService;
    this.SetupService = SetupService;
    this.ShipmentService = ShipmentService;
    this.DateUtil = DateUtil;
    this.RouteService = RouteService;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.DataCounter = DataCounter;
    this.HoldService = HoldService;
    this.Navigation = Navigation;
    this.UsersService = UsersService;
    this.$window = $window;
    this.TimezoneList = TimezoneList;
    this.LocationService = LocationService;
    this.CommonLayoutService = CommonLayoutService;
    this.$rootScope = $rootScope;

    this.model = {
      search: "",
      branch: User.getUser().branchId,
      stats: "itemStatus",
      isSentToHold: false,
      timezone: null,
      timezoneList: this.TimezoneList.getTimezoneList()
    };

    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: 10,
      maxPages: 10
    };

    this.stats = {
      itemStatus: 'itemStatus',
      itemHistory: 'itemHistory'
    };

    this.sortOrder = {
      fieldName: 'transactionDate',
      order: 'DESC'
    };

    this.transactionData = [];
    this.trackingIdData = [];
    this.lastScanned = "";
    this.valutDate = "";
    this.itemStatus = [];
    this.shipmentData = {};
    this.newUrl = "";
    this.trackingIdBranch = "";
    this.isAllowedToUnpack = false;
    this.userDetails = this.User.getUser();
    this.loggedInUser = this.User.getUser().id;
    this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/shipment-history');
    this.selectedDepositAmountValue = "totalAmount";
  }

  (0, _createClass3.default)(ItemsController, [{
    key: "loadPermission",
    value: function loadPermission() {
      var _this = this;

      this.acl = {};
      this.hasACL = {};
      var permissionsToCheck = ['branch_mgmt_items'];

      permissionsToCheck.forEach(function (permissionKey) {
        _this.acl[permissionKey] = _this.User.getACL(permissionKey);

        _this.hasACL[permissionKey] = {};

        _this.acl[permissionKey].forEach(function (permission) {
          _this.hasACL[permissionKey][permission] = true;
        });
      });
      this.hasBranchMgmtItemsEditPermission = this.hasACL['branch_mgmt_items']['edit'];
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;

      this.$q.all([this.SetupService.get(this.model.branch), this.UsersService.getUserFieldData(this.loggedInUser), this.getSoftDeleteShipmentPermission()]).then(function (data) {
        _this2.valutDate = _this2.DateUtil.convertToDate(data[0].currentVaultDate);
        _this2.branchInfo = data[0];
        _this2.model.userdetails = data[1];
        _this2.model.timezone = _this2.model.userdetails.timezone ? _this2.model.userdetails.timezone : moment.tz.guess();
      }).then(function () {
        _this2.loadPermission();
        _this2.loadItemHistory();
      }).catch(function (err) {
        console.log(err);
      });

      this.model.errorMsg = this.$translate.instant('error.branch_mgmt.items_not_display');
      this.model.noItemDisplay = true;
    }
  }, {
    key: "loadItemHistory",
    value: function loadItemHistory() {
      var dataCounter = this.DataCounter.getData();
      if (this.$stateParams.id) {
        this.model.search = this.$stateParams.id;
        this.loadData();
      } else if (dataCounter && dataCounter.trackingId && dataCounter.isRedirected) {
        this.model.search = dataCounter.trackingId;
        this.loadData();
        this.DataCounter.setData();
      } else {
        this.model.search = "";
      }
    }
  }, {
    key: "print",
    value: function print() {
      setTimeout(function () {
        return window.print();
      }, 100);
    }
  }, {
    key: "pageChange",
    value: function pageChange() {
      this.getTransactionHistory();
    }
  }, {
    key: "tabSelection",
    value: function tabSelection(selectedValue) {
      this.model.stats = selectedValue;
    }
  }, {
    key: "replaceURL",
    value: function replaceURL() {
      this.$state.transitionTo('branchManagement.items', { id: this.model.search });
      // this.$state.transitionTo('branchManagement.items', { id: "" }, { reload: false })
    }
  }, {
    key: "generateSearchObj",
    value: function generateSearchObj() {
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'trackingId',
            condition: '=',
            data: this.model.search
          }],
          operator: 'AND'
        },
        order: {
          fieldName: this.sortOrder.fieldName,
          keyword: this.sortOrder.order
        }
      };
      return searchObj.queryJSON.rules.length ? searchObj : null;
    }
  }, {
    key: "getTransactionHistory",
    value: function getTransactionHistory() {
      var _this3 = this;

      // const searchObj = this.generateSearchObj();

      if (this.model.search == '') {
        return;
      }

      if (this.lastScanned && this.model.search != this.lastScanned) {
        delete this.msg;
        delete this.branchTransferMsg;
        delete this.shipmentDeliveredMsg;
        delete this.updateTrackingIdMsg;
        this.pagination.page = 1;
      }

      this.model.loading = true;
      return this.TransactionService.transactionHistory(this.model.search, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit).then(function (data) {
        if (data.results.length) {
          _this3.lastScanned = _this3.model.search;
          _this3.pagination.total = data.total;
          _this3.pagination.loading = false;
          _this3.shipments = data.results;
          _this3.depositRecord = data.depositRecord;

          if (_this3.depositRecord) {
            _this3.depositPopover = "\n              <div><b>Stated Value</b>: " + _this3.formatAmount(_this3.depositRecord.statedTotalAmount) + "</div>\n              <div><b>Declared Value</b>: " + _this3.formatAmount(_this3.depositRecord.declaredTotalAmount) + "</div>\n              <div><b>Counted Value</b>: " + _this3.formatAmount(_this3.depositRecord.totalAmount) + "</div>\n              <div><b>Counted Variance</b>: " + _this3.formatAmount(_this3.depositRecord.countedVariance) + "</div>\n          ";
          }

          _this3.model.isError = false;
          _this3.model.noItemDisplay = false;
          // this.model.vaultCloseDetails = data.vaultCloseInfo;
          _this3.getLocalTime();
          // this.findVaultDate();
          // this.localDateTime = moment(this.valutDate).format('MM-DD-YYYY');
        } else {
          // this.model.isError = true;
          // this.model.search = '';
          // this.model.message = this.$translate.instant('error.branch_mgmt.items_id_not_found');
          _this3.shipments = [];
        }
      }).catch(function (err) {
        console.log(err);
        _this3.error = err.message;
      }).finally(function () {
        _this3.model.loading = false;
      });
    }

    // redirect to item hold screen

  }, {
    key: "itemHold",
    value: function itemHold(trackingId) {
      if (trackingId) {
        this.$state.go('branchManagement.itemHolds', {
          trackingId: trackingId
        });
      }
    }
  }, {
    key: "isCustomerLocation",
    value: function isCustomerLocation(trackingId) {
      var _this4 = this;

      if (!this.customerId) {
        return _promise2.default.resolve(true);
      }
      return this.ShipmentService.hasCustomerShipment(trackingId, this.customerId, this.model.branch).then(function () {
        return _promise2.default.resolve(true);
      }).catch(function (err) {
        _this4.itemStatus = [];
        _this4.shipments = [];
        _this4.pagination.total = 0;
        _this4.shipmentData = {};
        _this4.model.loading = false;
        if (err && err.data && err.data.message) {
          _this4.Modal.errorModal(err.data.message);
        }
        return _promise2.default.resolve(false);
      });
    }
  }, {
    key: "getItemStatus",
    value: function getItemStatus() {
      var _this5 = this;

      if (this.model.search == '') {
        return;
      }

      var defer = this.$q.defer();
      this.model.loading = true;
      this.isCustomerLocation(this.model.search).then(function (allow) {
        if (allow) {
          return _this5.ShipmentService.getItemStatus(_this5.model.search);
        }
      }).then(function (data) {
        _this5.trackingIdBranch = data.branchId;
        _this5.isLoadShipmentCheckedOut = data.isLoadShipmentCheckedOut;
        _this5.isResidualshipmentCheckedIn = data.isResidualshipmentCheckedIn;
        _this5.depositedAt = data.depositedAt;
        if (data.results.length) {
          var _this5$shipmentData;

          _this5.itemStatus = data.results;
          _this5.shipmentData = (_this5$shipmentData = {
            branchId: _this5.itemStatus[0].branchId,
            trackingId: _this5.itemStatus[0].trackingId,
            routeId: _this5.itemStatus[0].routeId,
            toLocationId: _this5.itemStatus[0].toLocationId,
            date: _this5.itemStatus[0].vaultDate,
            status: _this5.itemStatus[0].status,
            isOnHold: _this5.itemStatus[0].holdFlag,
            isDeleted: _this5.itemStatus[0].deleted,
            isLoadShpDelivered: _this5.itemStatus[0].isLoadShpDelivered,
            isResidualShpCheckedIn: _this5.itemStatus[0].isResidualShpCheckedIn,
            isDelivered: _this5.itemStatus[0].isDelivered,
            checkedIn: _this5.itemStatus[0].checkedIn,
            pending: _this5.itemStatus[0].pending,
            shipmentId: _this5.itemStatus[0].shipmentId,
            denominationId: _this5.itemStatus[0].denominationId,
            orderNo: _this5.itemStatus[0].orderNo,
            packedFlag: _this5.itemStatus[0].packedFlag,
            checkedOut: _this5.itemStatus[0].checkedOut,
            orderType: _this5.itemStatus[0].orderType,
            translatedStatus: _this5.$translate.instant(_this5.itemStatus[0].status),
            amount: _this5.itemStatus[0].amount,
            bagSeal: _this5.itemStatus[0].bagSeal,
            isBagoutDelivered: _this5.itemStatus[0].isBagoutDelivered,
            bagoutDeliveryImageName: _this5.itemStatus[0].bagoutDeliveryImageName,
            bagoutDeliveryDate: _this5.itemStatus[0].bagoutDeliveryDate,
            bagoutSignatureFirstName: _this5.itemStatus[0].bagoutSignatureFirstName,
            bagoutSignatureLastName: _this5.itemStatus[0].bagoutSignatureLastName,
            pickupFlag: _this5.itemStatus[0].pickupFlag,
            unpackAnyTime: _this5.itemStatus[0].unpackAnyTime,
            fundingSourceId: _this5.itemStatus[0].fundingSourceId,
            packedDate: _this5.itemStatus[0].packedDate,
            coinFlag: _this5.itemStatus[0].coinFlag,
            coinDebited: _this5.itemStatus[0].coinDebited,
            isRequiredPickup: _this5.itemStatus[0].isRequiredPickup,
            shipmentCheckedIn: _this5.itemStatus[0].shipmentCheckedIn,
            deliveryDate: _this5.itemStatus[0].deliveryDate,
            fromLocationType: _this5.itemStatus[0].fromLocationType,
            fromLocationId: _this5.itemStatus[0].fromLocationId,
            fromLocationName: _this5.itemStatus[0].fromLocationName,
            toLocationName: _this5.itemStatus[0].toLocationName,
            toLocationType: _this5.itemStatus[0].toLocationType,
            loadedAmount: _this5.itemStatus[0].loadedAmount,
            routeName: _this5.itemStatus[0].routeName,
            receivedByName: _this5.itemStatus[0].receivedByName,
            vaultDate: _this5.itemStatus[0].vaultDate,
            fromLocationEmail: _this5.itemStatus[0].fromLocationEmail,
            toLocationEmail: _this5.itemStatus[0].toLocationEmail,
            shiptype: _this5.itemStatus[0].shiptype,
            countCompletedAt: _this5.itemStatus[0].countCompletedAt,
            countStartedAt: _this5.itemStatus[0].countStartedAt,
            isParentDelivery: _this5.itemStatus[0].isParentDelivery,
            packableOrderShipmentId: _this5.itemStatus[0].packableOrderShipmentId,
            canConvertToCRV: _this5.itemStatus[0].canConvertToCRV,
            shiptypeId: _this5.itemStatus[0].shiptypeId,
            individuallyDeliverable: _this5.itemStatus[0].individuallyDeliverable,
            individuallyDeliverableVaultDate: _this5.itemStatus[0].individuallyDeliverableVaultDate,
            individuallyDeliverableRouteId: _this5.itemStatus[0].individuallyDeliverableRouteId,
            isPackableOrder: _this5.itemStatus[0].isPackableOrder,
            packedAt: _this5.itemStatus[0].packedAt,
            packableOrderShipmentTrackingIds: _this5.itemStatus[0].packableOrderShipmentTrackingIds
          }, (0, _defineProperty3.default)(_this5$shipmentData, "coinDebited", _this5.itemStatus[0].coinDebited), (0, _defineProperty3.default)(_this5$shipmentData, "isPackableOrder", data.CODOrdersMetrics.isPackableOrder), (0, _defineProperty3.default)(_this5$shipmentData, "totalCODCoinsOnRoute", data.CODOrdersMetrics.totalCODCoinsOnRoute), (0, _defineProperty3.default)(_this5$shipmentData, "isCoinDebited", data.CODOrdersMetrics.isCoinDebited), (0, _defineProperty3.default)(_this5$shipmentData, "isBulkInventoryOn", data.CODOrdersMetrics.isBulkInventoryOn), (0, _defineProperty3.default)(_this5$shipmentData, "isDebitBulkCoinOnPack", data.CODOrdersMetrics.isDebitBulkCoinOnPack), _this5$shipmentData);
          _this5.model.noItemDisplay = false;
          _this5.model.isSentToHold = false;
          _this5.model.loading = false;
          _this5.isError = false;
          _this5.model.message = '';
          _this5.getLocalTime();
        } else {
          _this5.noDataFound = _this5.$translate.instant('error.branch_mgmt.items_id_not_found');
          _this5.isError = true;
          _this5.itemStatus = [];
        }
        defer.resolve(_this5.trackingIdBranch);
      }).catch(function (err) {
        _this5.itemStatus = [];
        _this5.shipments = [];
        _this5.pagination.total = 0;
        _this5.shipmentData = {};
        if (err && err.data && err.data.message) {
          return _this5.Modal.errorModal("error." + err.data.message);
        }
      }).finally(function () {
        _this5.model.loading = false;
      });
      return defer.promise;
    }
  }, {
    key: "getLocalTime",
    value: function getLocalTime() {
      // this.localDate = moment.utc().toDate();
      // this.localDateTime = moment(this.localDate).format('l h:mm A');
      return moment.utc().format();
    }
  }, {
    key: "getOrderType",
    value: function getOrderType(shiptype, orderType) {
      if (shiptype == "C" && orderType !== null) {
        return this.$translate.instant('atm_residual.order_type_' + orderType);
      } else if (shiptype == "C" && orderType == null) {
        return shiptype.toUpperCase();
      } else {
        return shiptype.toUpperCase();
      }
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var _this6 = this;

      if (this.model.search == '') {
        return;
      }

      this.getItemStatus().then(function (trackingIdBranch) {
        _this6.getTransactionHistory();
        _this6.shipments = [];
        _this6.model.isError = true;
        if (!_this6.trackingIdBranch) _this6.model.message = _this6.$translate.instant('error.branch_mgmt.items_id_not_found');
        _this6.validateOrderPackingUndo();
      });
    }
  }, {
    key: "sendToHold",
    value: function sendToHold() {
      var _this7 = this;

      var reason = '',
          comments = 'send to hold';
      var defer = this.$q.defer();

      var holdShipment = function holdShipment() {
        var supId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        _this7.ShipmentService.holdShipment(_this7.shipmentData.branchId, _this7.shipmentData.trackingId, _this7.shipmentData.routeId, _this7.shipmentData.date, supId ? supId : _this7.loggedInUser, reason, comments).then(function () {
          delete _this7.updateTrackingIdMsg;
          _this7.model.isSentToHold = true;
          _this7.msg = _this7.$translate.instant('branch_mgmt.itemhistory.reRelease');
          defer.resolve();
        }).catch(function (err) {
          _this7.model.isSentToHold = false;
          if (err && err.data && err.data.message) {
            _this7.Modal.errorModal("error." + err.data.message);
          }
          defer.reject();
        });
      };

      if (this.branchInfo.supervisorScan) {
        this.Modal.confirmSupervisor('send-to-hold', { trackingId: this.shipmentData.trackingId }, function (_ref) {
          var modal = _ref.modal,
              supId = _ref.supId;

          holdShipment(supId);
          modal.close();
        }, function (_ref2) {
          var modal = _ref2.modal;

          modal.close();
        });
      } else {
        this.Modal.confirm({
          header: this.$translate.instant('branch.confirm'),
          message: this.$translate.instant('item.confirm_hold_message', { lable: this.shipmentData.trackingId }),
          callback: function callback(_ref3) {
            var modal = _ref3.modal;

            holdShipment();
            modal.close();
          },
          type: 'success'
        });
      }
      return defer.promise.then(function () {
        return _this7.loadData();
      });
    }

    // Release item from HOLD

  }, {
    key: "releaseItem",
    value: function releaseItem() {
      var _this8 = this;

      this.date = "";
      this.routeId = "";

      var defer = this.$q.defer();
      this.UsersService.checkSupervisor(this.loggedInUser).then(function (userInfo) {
        _this8.Modal.holdReleases(_this8.shipmentData, !userInfo.supervisor, function (_ref4) {
          var supervisorId = _ref4.supervisorId,
              comment = _ref4.comment,
              shipmentAssignedTo = _ref4.shipmentAssignedTo,
              selectedDate = _ref4.selectedDate,
              routeInfo = _ref4.routeInfo,
              modal = _ref4.modal;

          if (selectedDate) {
            var d = new Date(selectedDate);
            var yearLocal = d.getFullYear();
            var monthLocal = d.getMonth() + 1;
            var dayLocal = d.getDate();
            var pad = function pad(v) {
              return v < 10 ? '0' + v : '' + v;
            };

            _this8.date = yearLocal + "-" + pad(monthLocal) + "-" + pad(dayLocal);
          } else {
            _this8.date = '';
          }
          _this8.routeId = shipmentAssignedTo;

          _this8.ShipmentService.holdRelease(_this8.shipmentData.trackingId, _this8.shipmentData.routeId, shipmentAssignedTo, _this8.date, userInfo.supervisor ? userInfo.id : supervisorId, comment, _this8.shipmentData.branchId).then(function (data) {
            var totals = _this8.DataCounter.getCounterForItemHold();
            if (totals > 0 && _this8.shipmentData.isOnHold) _this8.DataCounter.setCounterForItemHold(totals - 1);
            modal.close();
            defer.resolve();
          }).catch(function (err) {
            modal.close();
            if (err && err.data && err.data.message) {
              return _this8.Modal.errorModal("error." + err.data.message);
            }
          });
        }, function (_ref5) {
          var modal = _ref5.modal;

          if (modal) modal.close();
        });
      }).catch(function (err) {
        _this8.Modal.errorModal(err.data.message);
      });
      defer.promise.then(function () {
        return _this8.releaseRoute(_this8.routeId, _this8.date);
      });
    }
  }, {
    key: "releaseRoute",
    value: function releaseRoute(route, date) {
      var _this9 = this;

      this.RouteService.releaseRoute(route, date).then(function () {
        delete _this9.branchTransferMsg;
        delete _this9.updateTrackingIdMsg;
        delete _this9.msg;
        return _this9.loadData();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          return _this9.Modal.errorModal("error." + err.data.message);
        }
      });
    }
  }, {
    key: "branchTransfer",
    value: function branchTransfer() {
      var _this10 = this;

      if (this.shipmentData.status === 'shipment.bagout' || this.shipmentData.status === 'shipment.deposited' || this.shipmentData.shiptypeId === "BULKCASH" && this.shipmentData.bagSeal !== null) {
        this.model.errorMsg = this.$translate.instant('error.branch_transfer_not_display', {
          bagSeal: this.shipmentData.bagSeal
        });
        return this.Modal.errorModal(this.model.errorMsg);
      }

      var defer = this.$q.defer();
      this.Modal.branchTransferModal(this.shipmentData, function (_ref6) {
        var branchTransferModal = _ref6.modal,
            selectedBranch = _ref6.selectedBranch,
            comment = _ref6.comment,
            supervisorId = _ref6.supervisorId,
            selectedRoute = _ref6.selectedRoute,
            selectedDate = _ref6.selectedDate,
            fromBranchId = _ref6.fromBranchId;


        if (_this10.shipmentData.isPackableOrder && _this10.shipmentData.packedAt && _this10.shipmentData.packableOrderShipmentTrackingIds && _this10.shipmentData.packableOrderShipmentTrackingIds.split(',').length > 1) {
          _this10.Modal.confirm({
            header: 'Confirm COD Order Transfer',
            message: "Are you sure you want to transfer all shipments <b>(" + _this10.shipmentData.packableOrderShipmentTrackingIds + ")</b> for this order?",
            callback: function callback(_ref7) {
              var modal = _ref7.modal;

              modal.close();
              _this10.shipmentBranchTransfer(selectedBranch, supervisorId, comment, selectedRoute, selectedDate, fromBranchId, branchTransferModal, defer);
            },
            negative: function negative(_ref8) {
              var modal = _ref8.modal;

              modal.close();
            }
          }, function (_ref9) {
            var modal = _ref9.modal;

            if (modal) modal.close();
          });
        } else {
          _this10.shipmentBranchTransfer(selectedBranch, supervisorId, comment, selectedRoute, selectedDate, fromBranchId, branchTransferModal, defer);
        }
      }, function (_ref10) {
        var branchTransferModal = _ref10.branchTransferModal;

        branchTransferModal.close();
      });
      defer.promise.then(function () {
        return _this10.loadData();
      });
    }
  }, {
    key: "shipmentBranchTransfer",
    value: function shipmentBranchTransfer(selectedBranch, supervisorId, comment, selectedRoute, selectedDate, fromBranchId, modal, defer) {
      var _this11 = this;

      this.ShipmentService.branchTransfer(selectedBranch, this.shipmentData.trackingId, this.shipmentData.routeId, this.shipmentData.date, supervisorId, comment, selectedRoute, selectedDate, fromBranchId).then(function (data) {
        delete _this11.msg;
        delete _this11.updateTrackingIdMsg;
        _this11.branchTransferMsg = _this11.$translate.instant('branch_mgmt.itemhistory.branchTransferred');
        defer.resolve();
        modal.close();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this11.Modal.errorModal('error.' + err.data.message);
        }
        defer.reject();
      });
    }
  }, {
    key: "internalDelivery",
    value: function internalDelivery() {
      var _this12 = this;

      if (this.shipmentData.status === 'shipment.bagout' || this.shipmentData.status === 'shipment.deposited' || this.shipmentData.shiptypeId === "BULKCASH" && this.shipmentData.bagSeal !== null) {
        this.model.errorMsg = this.$translate.instant('error.internal_delivery_not_display', {
          bagSeal: this.shipmentData.bagSeal
        });
        return this.Modal.errorModal(this.model.errorMsg);
      }
      var defer = this.$q.defer();
      this.Modal.internalDeliveryModal(this.shipmentData, function (_ref11) {
        var modal = _ref11.modal,
            comment = _ref11.comment,
            locationId = _ref11.locationId,
            supervisorId = _ref11.supervisorId;

        _this12.ShipmentService.updateFromLocation(_this12.shipmentData.branchId, _this12.shipmentData.trackingId, locationId, supervisorId, comment).then(function (data) {
          delete _this12.msg;
          delete _this12.branchTransferMsg;
          delete _this12.updateTrackingIdMsg;
          defer.resolve();
          modal.close();
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this12.Modal.errorModal('error.' + err.data.message);
          }
          defer.reject();
        });
      }, function (_ref12) {
        var modal = _ref12.modal;

        modal.close();
      });
      defer.promise.then(function () {
        return _this12.loadData();
      });
    }
  }, {
    key: "updateTrackingId",
    value: function updateTrackingId() {
      var _this13 = this;

      if (this.shipmentData.status === 'shipment.bagout' || this.shipmentData.status === 'shipment.deposited' || this.shipmentData.shiptypeId === "BULKCASH" && this.shipmentData.bagSeal !== null) {
        this.model.errorMsg = this.$translate.instant('error.tracking_id_not_display', {
          bagSeal: this.shipmentData.bagSeal
        });
        return this.Modal.errorModal(this.model.errorMsg);
      }
      this.Modal.updateShipmentTrackingId(this.shipmentData.trackingId, this.branchInfo.supervisorScan, function (_ref13) {
        var modal = _ref13.modal,
            newTrackingId = _ref13.newTrackingId,
            supervisorId = _ref13.supervisorId;

        _this13.ShipmentService.updateShipmentTrackingId(_this13.shipmentData.shipmentId, _this13.shipmentData.trackingId, newTrackingId, _this13.shipmentData.branchId).then(function (res) {
          _this13.model.search = newTrackingId; // set new trackingId
          _this13.loadData(); // reload data after edit trackingId
          _this13.updateTrackingIdMsg = _this13.$translate.instant('branch_mgmt.items.trackingIdUpdated');
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this13.Modal.errorModal('error.' + err.data.message);
          }
        });
        modal.close();
      }, this.customerId, function (_ref14) {
        var modal = _ref14.modal;

        modal.close();
      });
    }
  }, {
    key: "redirectToLocation",
    value: function redirectToLocation(locationId) {
      this.$state.go('location.edit', {
        id: locationId
      });
    }
  }, {
    key: "goToServiceHistory",
    value: function goToServiceHistory(e, locationId, params) {
      var obj = {
        locationId: locationId,
        isRedirected: true
      };

      var locationData = this.DataCounter.setData(obj);
      params.DataCounter = locationData;

      if (e.ctrlKey) {
        localStorage.setItem('DataCounter', (0, _stringify2.default)(locationData));
        var url = this.$state.href('branchManagement.locations', params);
        window.open(url, '_blank');
      } else {
        localStorage.setItem('DataCounter', (0, _stringify2.default)(locationData));
        this.$state.go('branchManagement.locations', params, { notify: false });
      }
    }
  }, {
    key: "goToRouteTab",
    value: function goToRouteTab(e, data, params) {
      var obj = {
        routeId: data.routeId,
        vaultDate: data.pickupFlag && data.countCompletedAt ? this.DateUtil.getTZFormattedDate(data.pickupDate, this.model.timezone) : data.vaultDate,
        isRedirected: true
      };

      var routeData = this.DataCounter.setData(obj);
      params.DataCounter = routeData;

      if (e.ctrlKey) {
        localStorage.setItem('DataCounter', (0, _stringify2.default)(routeData));
        var url = this.$state.href('branchManagement.routes', params);
        window.open(url, '_blank');
      } else {
        localStorage.setItem('DataCounter', (0, _stringify2.default)(routeData));
        this.$state.go('branchManagement.routes', params, { notify: false });
      }
    }
  }, {
    key: "orderPackingUndo",
    value: function orderPackingUndo(shipment) {
      var _this14 = this;

      if (this.loading) return;
      this.loading = true;

      this.Modal.undoPackedOrder(shipment, function (_ref15) {
        var modal = _ref15.modal,
            supervisorId = _ref15.supervisorId,
            deleteOrder = _ref15.deleteOrder,
            deletedReason = _ref15.deletedReason,
            $scope = _ref15.$scope;

        _this14.ShipmentService.orderPackingUndo(_this14.shipmentData.branchId, shipment.shipmentId, supervisorId, deletedReason, deleteOrder).then(function () {
          modal.close();
          _this14.loading = false;
          return _this14.loadData();
        }).catch(function (err) {
          modal.close();
          if (err && err.data && err.data.message) {
            _this14.loading = false;
            _this14.Modal.errorModal('error.' + err.data.message);
          }
        });
      }, function (_ref16) {
        var modal = _ref16.modal;

        if (modal) modal.close();
        _this14.loading = false;
      });
    }
  }, {
    key: "softDeleteShipment",
    value: function softDeleteShipment(shipment) {
      var _this15 = this;

      if (this.loading) return;
      this.loading = true;

      this.Modal.deletedReason(shipment, function (_ref17) {
        var supervisorId = _ref17.supervisorId,
            reason = _ref17.reason,
            modal = _ref17.modal;

        _this15.ShipmentService.softDeleteShipment(shipment.shipmentId, shipment.branchId, reason, supervisorId).then(function () {
          modal.close();
          _this15.loading = false;
          var totals = _this15.DataCounter.getCounterForItemHold();
          if (totals > 0 && _this15.shipmentData.isOnHold) _this15.DataCounter.setCounterForItemHold(totals - 1);
          return _this15.loadData();
        }).catch(function (err) {
          modal.close();
          if (err && err.data && err.data.message) {
            _this15.loading = false;
            _this15.Modal.errorModal('error.' + err.data.message);
          }
        });
      }, function (_ref18) {
        var modal = _ref18.modal;

        if (modal) modal.close();
        _this15.loading = false;
      });
    }
  }, {
    key: "markAsDelivered",
    value: function markAsDelivered(shipment) {
      var _this16 = this;

      if (this.loading) return;
      this.loading = true;

      this.Modal.markAsDelivered(shipment, this.branchInfo.currentVaultDate, this.branchInfo.timezone, function (_ref19) {
        var modal = _ref19.modal,
            supervisorId = _ref19.supervisorId,
            comment = _ref19.comment,
            loadedAmount = _ref19.loadedAmount,
            date = _ref19.date,
            time = _ref19.time;

        _this16.HoldService.shipmentDelivery(shipment.trackingId, shipment.routeId, supervisorId, comment, shipment.branchId, loadedAmount, date, time, _this16.branchInfo.timezone, shipment.orderType, shipment.amount).then(function () {
          var totals = _this16.DataCounter.getCounterForItemHold();
          if (totals > 0 && _this16.shipmentData.isOnHold) _this16.DataCounter.setCounterForItemHold(totals - 1);
          modal.close();
          _this16.loadData(); // refresh data after shipment delivered  
        }).catch(function (err) {
          modal.close();
          _this16.Modal.errorModal('error.' + err.data.message);
        }).finally(function () {
          _this16.loading = false;
        });
      }, function (_ref20) {
        var modal = _ref20.modal;

        if (modal) modal.close();
        _this16.loading = false;
      });
    }
  }, {
    key: "changeDestination",
    value: function changeDestination() {
      var _this17 = this;

      if (this.validateShpDestination) return;
      this.validateShpDestination = true;

      this.Modal.changeDestinationModal(this.shipmentData, this.customerId, function (_ref21) {
        var modal = _ref21.modal,
            comment = _ref21.comment,
            locationId = _ref21.locationId,
            supervisorId = _ref21.supervisorId;

        _this17.ShipmentService.changeDestination(_this17.shipmentData.trackingId, _this17.shipmentData.branchId, _this17.shipmentData.routeId, locationId, comment).then(function () {
          delete _this17.msg;
          delete _this17.branchTransferMsg;
          delete _this17.updateTrackingIdMsg;
          delete _this17.shipmentDeliveredMsg;
          _this17.loadData();
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this17.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          modal.close();
          _this17.validateShpDestination = false;
        });
      }, function (_ref22) {
        var modal = _ref22.modal;

        if (modal) modal.close();
        _this17.validateShpDestination = false;
      });
    }
  }, {
    key: "redirectToATM",
    value: function redirectToATM(item) {
      return this.Navigation.goToAtmCount(item.trackingId, true, null, item.fundingSourceId);
    }
  }, {
    key: "validateOrderPackingUndo",
    value: function validateOrderPackingUndo() {
      var shipmentPackedDate = void 0,
          branchCurrentVaultDate = void 0;

      if (this.shipmentData && this.shipmentData.fundingSourceId && this.shipmentData.unpackAnyTime) {
        this.isAllowedToUnpack = true;
      } else if (this.shipmentData.fundingSourceId && !this.shipmentData.unpackAnyTime) {
        shipmentPackedDate = new Date(this.shipmentData.packedDate);
        branchCurrentVaultDate = new Date(this.branchInfo.currentVaultDate);
        this.isAllowedToUnpack = shipmentPackedDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();
      } else {
        this.isAllowedToUnpack = true;
      }
    }
  }, {
    key: "markAsCheckedIn",
    value: function markAsCheckedIn(shipment) {
      var _this18 = this;

      this.Modal.confirmSupervisor('mark-as-checked-in', shipment.trackingId, function (_ref23) {
        var modal = _ref23.modal,
            supId = _ref23.supId;

        _this18.HoldService.shipmentHoldMarkCheckedIn(shipment.trackingId, supId, shipment.branchId, shipment.routeId).then(function () {
          modal.close();
          _this18.loadData();
        }).catch(function (err) {
          modal.close();
          if (err && err.data && err.data.message) {
            return _this18.Modal.errorModal('error.' + err.data.message);
          }
        });
      }, function (_ref24) {
        var modal = _ref24.modal;

        modal.close();
      });
    }
  }, {
    key: "translateItemStatus",
    value: function translateItemStatus(status, orderNo, denominationId) {
      if (!status) return;else if (status === 'shipment.bagout' && orderNo && denominationId) return this.$translate.instant('branch_mgmt.items.childResidual');else if (status.startsWith('shipment')) return this.$translate.instant(status);else if (status.startsWith('CANT')) return this.$translate.instant("shipment." + status);else return;
    }
  }, {
    key: "goToDVB",
    value: function goToDVB(data) {
      var obj = {
        fundingSourceId: data.fundingSourceId,
        vaultDate: data.vaultDate,
        isRedirected: true
      };
      this.DataCounter.setData(obj);
      this.$state.go('branchManagement.dailyBalanceSheet');
    }
  }, {
    key: "showReceipt",
    value: function showReceipt(shipments, stats) {
      document.getElementById('shipment-image').blur();
      var shipmentCopy = (0, _assign2.default)({}, shipments);
      if (shipmentCopy.tranType === 'BAGOUT' && this.shipmentData.isBagoutDelivered) {
        shipmentCopy.deliveryImageName = this.shipmentData.bagoutDeliveryImageName;
      }
      this.Modal.shipmentImageModal(shipmentCopy, this.model.search, stats, function (_ref25) {
        var modal = _ref25.modal;
      }, function (_ref26) {
        var modal = _ref26.modal;

        modal.close();
      });
    }

    // findVaultDate(transactionCreatedAt) {
    //   if (this.model.vaultCloseDetails) {
    //     let transactionDate = moment.utc(transactionCreatedAt).valueOf();
    //     let vaultCloseTime = moment.utc(this.model.vaultCloseDetails.createdAt).valueOf();
    //     if (moment(transactionDate).isAfter(vaultCloseTime)) {
    //       return moment.utc(this.shipmentData.date).add(1, 'd').format('YYYY-MM-DD');
    //     }
    //     else if (moment(transactionDate).isBefore(vaultCloseTime)) {
    //       return moment.utc(this.shipmentData.date).format('YYYY-MM-DD');
    //     }
    //   }
    //   else {
    //     return moment.utc(this.shipmentData.date).format('YYYY-MM-DD');
    //   }
    // }

  }, {
    key: "allowInternalDelivery",
    value: function allowInternalDelivery(locationType) {
      var locationTypeList = ['REGULAR', 'DELIVERY', 'NO_SHIP_NO_GO', 'BANK', 'ATM', 'INTERNAL', 'ON_CALL'];
      return locationTypeList.indexOf(locationType) > -1;
    }
  }, {
    key: "makeDeliverable",
    value: function makeDeliverable() {
      var _this19 = this;

      this.Modal.makeDeliverable(this.shipmentData, function (_ref27) {
        var modal = _ref27.modal,
            routeId = _ref27.routeId,
            vaultDate = _ref27.vaultDate;

        _this19.ShipmentService.makeDeliverable(_this19.shipmentData.trackingId, routeId, vaultDate, _this19.loggedInUser, _this19.shipmentData.branchId).then(function () {
          _this19.loadData();
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this19.Modal.errorModal('error.' + err.data.message);
          }
        }).finally(function () {
          modal.close();
        });
      }, function (_ref28) {
        var modal = _ref28.modal;

        modal.close();
      });
    }
  }, {
    key: "printShipment",
    value: function printShipment(records, type) {
      var _this20 = this;

      this.model.isPrint = true;
      this.ShipmentService.printStopReceipt(this.shipmentData.trackingId, this.selectedDepositAmountValue).then(function (data) {
        var shipments = data.reportData;
        var totalPickups = 0,
            totalDeliveries = 0;
        totalPickups = records && records.tranType === 'PICKUP' ? 1 : 0;
        totalDeliveries = records && (records.tranType === 'DELIVERY' || records.tranType === 'BAGOUT') ? 1 : 0;
        var stopDateTime = records.transactionDate ? moment(records.transactionDate).tz(_this20.model.timezone).format('MM/DD/YYYY hh:mm:ss A Z') : 'N/A';
        var url = _this20.$state.href('branchMgmtPrintStopReceipt');

        window.w = window.open(url, '_blank');
        window.w.printData = {
          shipmentRecords: records,
          results: data.reportData,
          envConfigResults: data.envConfigData,
          totalPickups: totalPickups, totalDeliveries: totalDeliveries, stopDateTime: stopDateTime
        };
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this20.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this20.model.isPrint = false;
      });
    }
  }, {
    key: "sendDeliveryOrPickupReceipt",
    value: function sendDeliveryOrPickupReceipt(stat) {
      var _this21 = this;

      var formattedDate = this.DateUtil.getUTCDate(this.shipmentData.vaultDate),
          trackingId = this.shipmentData.trackingId,
          locationId = stat === 'delivery' ? this.shipmentData.toLocationId : this.shipmentData.fromLocationId,
          branchId = this.shipmentData.branchId,
          routeId = stat === 'delivery' && this.shipmentData.individuallyDeliverable && this.shipmentData.individuallyDeliverableRouteId ? this.shipmentData.individuallyDeliverableRouteId : this.shipmentData.routeId,
          locationEmail = stat === 'delivery' && this.shipmentData.toLocationEmail ? this.shipmentData.toLocationEmail : stat === 'pickup' && this.shipmentData.fromLocationEmail ? this.shipmentData.fromLocationEmail : null;

      this.Modal.sendStopReceipt(locationEmail, function (_ref29) {
        var modal = _ref29.modal,
            providedEmail = _ref29.providedEmail,
            $scope = _ref29.$scope;

        _this21.LocationService.sendDeliveryOrPickupReceipt(trackingId, locationId, branchId, routeId, formattedDate, providedEmail, _this21.selectedDepositAmountValue, _this21.model.timezone, stat.toUpperCase()).then(function () {}).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this21.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          modal.close();
          $scope.model.loading = false;
        });
      }, function (_ref30) {
        var modal = _ref30.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: "changeShiptype",
    value: function changeShiptype() {
      var _this22 = this;

      if (this.shipmentData.status === 'shipment.bagout' || this.shipmentData.status === 'shipment.deposited' || this.shipmentData.shiptypeId === "BULKCASH" && this.shipmentData.bagSeal !== null) {
        this.model.errorMsg = this.$translate.instant('error.branch_mgmt_shiptype_not_display', {
          bagSeal: this.shipmentData.bagSeal
        });
        return this.Modal.errorModal(this.model.errorMsg);
      }

      this.Modal.changeShiptypeId(this.shipmentData, this.customerId, function (_ref31) {
        var modal = _ref31.modal,
            shiptype = _ref31.shiptype,
            supervisorId = _ref31.supervisorId;

        _this22.ShipmentService.changeShiptype(_this22.shipmentData.trackingId, _this22.shipmentData.branchId, shiptype).then(function (res) {
          _this22.loadData(); // reload data after edit shiptypeid
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this22.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          modal.close();
        });
      }, function (_ref32) {
        var modal = _ref32.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: "getSoftDeleteShipmentPermission",
    value: function getSoftDeleteShipmentPermission() {
      var _this23 = this;

      this.UsersService.validateUserPermissions(this.User.getUser().firstName, this.User.getUser().lastName).then(function (permissions) {
        var softDeletePerm = permissions.hasSoftDeleteShipmentPermission || _this23.CommonLayoutService.isAllowToAccessPages();
        if (_this23.User.getUser().customerUser) {
          var aclList = _this23.User.getACL('branch_mgmt_items') || [];
          _this23.hasSoftDeleteShipmentPermission = aclList.includes('edit');
        } else {
          _this23.hasSoftDeleteShipmentPermission = softDeletePerm;
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: "translateTranType",
    value: function translateTranType(type) {
      if (!type) return;

      if (['HOLD', 'BAGOUT'].includes(type)) return this.$translate.instant("shipment." + type.toLowerCase()).toUpperCase();else return this.$translate.instant("shipment." + type).toUpperCase();
    }
  }, {
    key: "formatAmount",
    value: function formatAmount(amount) {
      var formatted = amount.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return formatted;
    }
  }, {
    key: "isShipmentCounted",
    value: function isShipmentCounted() {
      return this.shipmentData && this.shipmentData.countCompletedAt;
    }
  }, {
    key: "convertToCrv",
    value: function convertToCrv(shipment) {
      var _this24 = this;

      if (this.loading) return;
      this.loading = true;

      this.UsersService.checkSupervisor(this.loggedInUser).then(function (userInfo) {
        _this24.Modal.convertToCrv(shipment, !userInfo.supervisor, true, function (_ref33) {
          var supervisor = _ref33.supervisor,
              trackingIdResidual = _ref33.trackingIdResidual,
              modal = _ref33.modal;

          if (trackingIdResidual) {
            var defer = _this24.$q.defer();
            _this24.HoldService.convertToCRV(_this24.model.branch, shipment.trackingId, trackingIdResidual, userInfo.supervisor ? userInfo.id : supervisor).then(function (data) {
              modal.close();
              defer.resolve(data);
            }).catch(function (err) {
              modal.close();
              if (err && err.data && err.data.message) {
                _this24.loading = false;
                _this24.Modal.errorModal('error.' + err.data.message);
              }
            });

            defer.promise.then(function () {
              _this24.loading = false;
              _this24.loadData();
            });
          } else {
            if (modal) modal.close();
            _this24.loading = false;
          }
        }, function (_ref34) {
          var modal = _ref34.modal;

          if (modal) modal.close();
          _this24.loading = false;
        });
      }).catch(function (err) {
        _this24.loading = false;
        _this24.Modal.errorModal(err.data && err.data.message ? err.data.message : err);
      });
    }
  }, {
    key: "convertToCrvPackableOrder",
    value: function convertToCrvPackableOrder(shipment) {
      var _this25 = this;

      if (this.loading) return;
      this.loading = true;

      this.Modal.confirm({
        header: 'Confirm CRV Conversion',
        message: 'Are you sure you want to convert this Shipment to CRV?',
        callback: function callback(_ref35) {
          var modal = _ref35.modal;

          modal.close();
          _this25.UsersService.checkSupervisor(_this25.loggedInUser).then(function (userInfo) {
            _this25.Modal.confirmSupervisor('shipment-hold-convert-CRV', { trackingId: shipment.trackingId }, function (_ref36) {
              var supModal = _ref36.modal,
                  supId = _ref36.supId;

              supModal.close();
              var defer = _this25.$q.defer();
              _this25.HoldService.convertToCrvPackableOrder(_this25.model.branch, shipment.trackingId, shipment.packableOrderShipmentId, supId).then(function (data) {
                defer.resolve(data);
              }).catch(function (err) {
                if (err && err.data && err.data.message) {
                  _this25.loading = false;
                  _this25.Modal.errorModal('error.' + err.data.message);
                }
              });

              defer.promise.then(function () {
                _this25.loading = false;
                _this25.loadData();
              });
            }, function (_ref37) {
              var supModal = _ref37.modal;

              supModal.close();
              _this25.loading = false;
            });
          }).catch(function (err) {
            _this25.loading = false;
            _this25.Modal.errorModal(err.data && err.data.message ? err.data.message : err);
          });
        },
        negative: function negative(_ref38) {
          var modal = _ref38.modal;

          modal.close();
          _this25.loading = false;
        }
      }, function (_ref39) {
        var modal = _ref39.modal;

        if (modal) modal.close();
        _this25.loading = false;
      });
    }
  }, {
    key: "convertShipmentToCrv",
    value: function convertShipmentToCrv() {
      var shipment = this.shipmentData;
      if (!shipment || !shipment.packedFlag || shipment.checkedOut) return;

      if (shipment.packableOrderShipmentId) {
        return this.convertToCrvPackableOrder(shipment);
      }

      return this.convertToCrv(shipment);
    }
  }]);
  return ItemsController;
}();

exports.default = ItemsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _items = __webpack_require__(1760);

var _items2 = _interopRequireDefault(_items);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printModule = angular.module('branchMgmtPrintStopReceipt', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/branchManagement.items');

    $stateProvider.state('branchMgmtPrintStopReceipt', {
        url: '/print-stop-receipt',
        component: 'branchMgmtPrintStopReceipt',
        data: {
            requireLogin: true,
            requireACL: 'branch_mgmt_items.all'
        }
    });
}]).component('branchMgmtPrintStopReceipt', _items2.default).name;

exports.default = printModule;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _items = __webpack_require__(2687);

var _items2 = _interopRequireDefault(_items);

var _items3 = __webpack_require__(1761);

var _items4 = _interopRequireDefault(_items3);

__webpack_require__(2971);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printComponent = {
    restrict: 'E',
    bindings: {},
    template: _items2.default,
    controller: _items4.default
};

exports.default = printComponent;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintController = function () {
    /*@ngInject*/
    PrintController.$inject = ["$translate"];
    function PrintController($translate) {
        (0, _classCallCheck3.default)(this, PrintController);

        this.formatAmount = function (val) {
            var num = Number(val || 0);
            return num.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        };

        this.$translate = $translate;
        this.model = {
            item: null
        };
    }

    (0, _createClass3.default)(PrintController, [{
        key: '$onInit',
        value: function $onInit() {
            if (window.opener && window.opener.w && window.opener.w.printData) {
                this.model.item = window.opener.w.printData;
                this.model.companyPhoneNumber = this.formatPhoneNumber(this.model.item.envConfigResults[0].assets.companyPhoneNumber);
                this.printShipment();
            }
        }
    }, {
        key: 'printShipment',
        value: function printShipment() {
            setTimeout(function () {
                window.print();
            }, 1500);
        }
    }, {
        key: 'formatPhoneNumber',
        value: function formatPhoneNumber(input) {
            if (!input) return '';
            var digits = input.replace(/\D/g, '');

            if (digits.length === 0) return '';
            if (digits.length < 4) return '(' + digits;
            if (digits.length < 7) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
            if (digits.length <= 10) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);

            return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6, 10) + ' ' + digits.slice(10);
        }
    }]);
    return PrintController;
}();

exports.default = PrintController;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location_holds = __webpack_require__(1763);

var _location_holds2 = _interopRequireDefault(_location_holds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementLocationHoldsModule = angular.module('branchManagementLocationHolds', []).component('branchManagementLocationHolds', _location_holds2.default).name;

exports.default = branchManagementLocationHoldsModule;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location_holds = __webpack_require__(2688);

var _location_holds2 = _interopRequireDefault(_location_holds);

var _location_holds3 = __webpack_require__(525);

var _location_holds4 = _interopRequireDefault(_location_holds3);

__webpack_require__(2972);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementLocationHoldsComponent = {
  restrict: "E",
  bindings: {},
  template: _location_holds2.default,
  controller: _location_holds4.default
};

exports.default = branchManagementLocationHoldsComponent;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locations = __webpack_require__(1765);

var _locations2 = _interopRequireDefault(_locations);

var _print = __webpack_require__(1767);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementLocationsModule = angular.module('branchManagementLocationsHistoryHolds', [_print2.default]).component('branchManagementLocationsHistoryHolds', _locations2.default).name;

exports.default = branchManagementLocationsModule;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locations = __webpack_require__(2689);

var _locations2 = _interopRequireDefault(_locations);

var _locations3 = __webpack_require__(1766);

var _locations4 = _interopRequireDefault(_locations3);

__webpack_require__(2973);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementLocationsComponent = {
  restrict: "E",
  bindings: {},
  template: _locations2.default,
  controller: _locations4.default
};

exports.default = branchManagementLocationsComponent;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _from = __webpack_require__(75);

var _from2 = _interopRequireDefault(_from);

var _map = __webpack_require__(76);

var _map2 = _interopRequireDefault(_map);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationsController = function () {
  /*@ngInject*/
  LocationsController.$inject = ["Auth", "$state", "User", "$translate", "LocationService", "$location", "$q", "Modal", "ShipmentService", "BranchService", "$scope", "SetupService", "Branch", "DateUtil", "BagoutService", "DataCounter", "ServiceOrderService", "UsersService", "$window", "Navigation", "TimezoneList", "TransactionService", "$rootScope", "HoldService", "FetchReactData"];
  function LocationsController(Auth, $state, User, $translate, LocationService, $location, $q, Modal, ShipmentService, BranchService, $scope, SetupService, Branch, DateUtil, BagoutService, DataCounter, ServiceOrderService, UsersService, $window, Navigation, TimezoneList, TransactionService, $rootScope, HoldService, FetchReactData) {
    var _this = this;

    (0, _classCallCheck3.default)(this, LocationsController);

    this.sortData = function (column, bucket) {
      if (!_this.sortOrderData[bucket]) _this.sortOrderData[bucket] = {};

      if (_this.sortOrderData[bucket] && _this.sortOrderData[bucket][_this.model.sortColumn]) {
        _this.sortOrderData[bucket][_this.model.reverseSort] = _this.sortOrderData[bucket][_this.model.sortColumn] === column ? !_this.sortOrderData[bucket][_this.model.reverseSort] : false;
      } else _this.sortOrderData[bucket][_this.model.reverseSort] = false;

      _this.sortOrderData[bucket][_this.model.sortColumn] = column;
    };

    this.$translate = $translate;
    this.Auth = Auth;
    this.FetchReactData = FetchReactData;
    this.$state = $state;
    this.User = User;
    this.LocationService = LocationService;
    this.BranchService = BranchService;
    this.$q = $q;
    this.$scope = $scope;
    this.Modal = Modal;
    this.ShipmentService = ShipmentService;
    this.SetupService = SetupService;
    this.Branch = Branch;
    this.DateUtil = DateUtil;
    this.BagoutService = BagoutService;
    this.DataCounter = DataCounter;
    this.$location = $location;
    this.ServiceOrderService = ServiceOrderService;
    this.UsersService = UsersService;
    this.$window = $window;
    this.Navigation = Navigation;
    this.TimezoneList = TimezoneList;
    this.TransactionService = TransactionService;
    this.$rootScope = $rootScope;
    this.HoldService = HoldService;

    this.model = {
      branchId: this.User.getUser().branchId,
      search: null,
      dateRangeOptions: {
        startDate: null,
        endDate: null
      },
      locationId: '',
      type: '',

      // date range picker for bagout tab
      dateRanges: {
        startDate: null,
        endDate: null
      },
      dateRangPickerOptions: {},

      billingRulesDateRanges: {
        startDate: null,
        endDate: null
      },
      billingHistoryDateRanges: {
        startDate: null,
        endDate: null
      },
      // date range picker for service tab
      dateRangPickerOptionsfor: {},
      serviceHistoryData: {},
      loggedInUser: User.getUser().id,
      deliveryServiceHistory: [],
      pickupServiceHistory: [],
      timezone: null,
      timezoneList: this.TimezoneList.getTimezoneList(),
      currentStatsOfServiceHistory: 'single',
      fromLocationSearchText: null,
      toLocationSearchText: null,
      sortColumn: "completedAt",
      reverseSort: true,
      completedServiceTickets: [],
      isLoadingCompletedServiceOrder: false,
      deliveryServiceHistoryObj: {
        sortColumn: "serviceDate",
        reverseSort: false
      },
      atmServiceHistoryObj: {
        sortColumn: "serviceDate",
        reverseSort: false
      },
      pickupServiceHistoryObj: {
        sortColumn: "serviceDate",
        reverseSort: false
      },
      noPickupServiceHistoryObj: {
        sortColumn: "routeId",
        reverseSort: true
      }
    };
    this.sortOrderData = {};
    this.bucketsExpand = {};

    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: _app2.default.defaultPageLimit,
      maxPages: 10
    };

    this.pickupHistoryObj = {
      pagination: {
        page: 1,
        total: 0,
        pageLimit: _app2.default.defaultPageLimit,
        maxPages: 10
      }
    };

    this.deliveryHistoryObj = {
      pagination: {
        page: 1,
        total: 0,
        pageLimit: _app2.default.defaultPageLimit,
        maxPages: 10
      }
    };

    this.transactionHistoryObj = {
      results: [],
      totalRecords: 0,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      loading: false
    };

    this.billingRulesObj = {
      results: [],
      totalRecords: 0,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      loading: false
    };

    this.billingHistoryObj = {
      results: [],
      totalRecords: 0,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      loading: false
    };

    this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
    this.currentVaultDate = "";
    this.itemHistory = [];
    this.currentStats = "";
    this.locationData = "";
    this.isAllow = true;
    this.serviceTickets = false;
    this.serviceHistory = {};
    this.bucketExpanded = false;
    this.locationDetails = {};
    this.serviceHistoryStats = {
      single: 'single',
      all: 'all'
    };
    this.selectedDepositAmountValue = null;
    this.isLoading = false;
  }

  (0, _createClass3.default)(LocationsController, [{
    key: 'loadPermission',
    value: function loadPermission() {
      var _this2 = this;

      this.acl = {};
      this.hasACL = {};

      [].forEach(function (permissionKey) {
        _this2.acl[permissionKey] = _this2.User.getACL(permissionKey);

        _this2.hasACL[permissionKey] = {};

        _this2.acl[permissionKey].forEach(function (permission) {
          _this2.hasACL[permissionKey][permission] = true;
        });
      });
    }
  }, {
    key: 'print',
    value: function print() {
      var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      var obj = {
        branchId: this.model.branchId,
        searchText: this.getLocationId(),
        startDate: moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss'),
        endDate: moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59'),
        vaultDate: moment(this.currentVaultDate).format('MM-DD-YYYY'),
        currentStats: stats ? stats : this.currentStats,
        timezone: this.model.timezone,
        locationType: this.locationDetails.locationType,
        customerId: this.customerId || null,
        toLocationSearchText: this.model.toLocationSearchText,
        fromLocationSearchText: this.model.fromLocationSearchText,
        selectedDepositAmountValue: this.selectedDepositAmountValue,
        deliveryServiceHistoryObj: this.model.deliveryServiceHistoryObj,
        atmServiceHistoryObj: this.model.atmServiceHistoryObj,
        pickupServiceHistoryObj: this.model.pickupServiceHistoryObj,
        noPickupServiceHistoryObj: this.model.noPickupServiceHistoryObj
      };

      var url = this.$state.href('printLocation');
      window.w = window.open(url, '_blank');
      window.w.printData = obj;
    }

    // do not allow to paste string into datepicker

  }, {
    key: 'dontAllow',
    value: function dontAllow(element) {
      element.on('cut copy paste', function (event) {
        event.preventDefault();
      });
    }
  }, {
    key: 'setDateRangeOptions',
    value: function setDateRangeOptions(date, dateRangeOption, modelVal) {
      var _this3 = this;

      var currentVaultDate = moment(date).format() || moment();
      this.model[modelVal] = {
        autoApply: true,
        // maxDate: moment(currentVaultDate).endOf('day').format('YYYY-MM-DD'),
        eventHandlers: {
          'apply.daterangepicker': function applyDaterangepicker() {
            _this3.pagination.page = 1;
            if (_this3.currentStats === "ServiceHistory") {
              // this.loadDataOfServiceHistory(dateRangeOption)
              // this.getPickupServiceHistory();
              // this.getDeliveryServiceHistory();
              _this3.getLocationDetail();
            }
            // if (this.currentStats === "ItemHistory") return this.loadDataOfItemHistory(dateRangeOption)
            if (_this3.currentStats === "BagoutHistory") return _this3.bagoutScanned(dateRangeOption);
            if (_this3.currentStats === "RepairHistory") return _this3.getCompletedServiceTickets(dateRangeOption);
            if (_this3.currentStats === "BillingRule") return _this3.getBillingRules(dateRangeOption);
            if (_this3.currentStats === "BillingHistory") return _this3.getBillingHistory(dateRangeOption);
          }
        },
        ranges: {
          'Running 67 Days': [moment(currentVaultDate).subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).add(7, 'days').format('YYYY-MM-DD HH:mm:ss')],
          'Today': [moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')],
          'Current Week': [moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')],
          'Current Month': [moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')],
          'Current Year': [moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')]
        }
      };
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this4 = this;

      this.loadPermission();
      this.locationData = this.DataCounter.getData();
      this.$rootScope.$broadcast('routeChange', '/app/branch-management/locations');
      var transitionData = this.FetchReactData.getTransitionData();
      var queryLocationId = transitionData ? transitionData.locationId : this.$location.search().locationId;

      this.$q.all([this.SetupService.get(this.model.branchId), this.UsersService.getUserFieldData(this.model.loggedInUser)]).then(function (data) {
        _this4.currentVaultDate = _this4.DateUtil.getUTCDate(data[0].currentVaultDate);
        _this4.serviceTickets = data[0].serviceTickets;
        _this4.model.userdetails = data[1];
        _this4.model.timezone = _this4.model.userdetails.timezone ? _this4.model.userdetails.timezone : moment.tz.guess();
        // this.setDateRangeOptions(this.currentVaultDate, this.model.dateRanges, 'dateRangPickerOptions')
        // this.model.dateRanges.startDate = moment(this.currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss');
        // this.model.dateRanges.endDate = moment(this.currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');

        _this4.setDateRangeOptions(moment(), _this4.model.dateRangeOptions, 'dateRangPickerOptionsfor');
        _this4.model.dateRangeOptions.startDate = moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss');
        _this4.model.dateRangeOptions.endDate = moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
        _this4.model.billingRulesDateRanges.startDate = moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss');
        _this4.model.billingRulesDateRanges.endDate = moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
        _this4.model.billingHistoryDateRanges.startDate = moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss');
        _this4.model.billingHistoryDateRanges.endDate = moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
      }).then(function () {
        _this4.loadLocations('', 0);
        _this4.loadData();
        // After locations are loaded, set fromLocationId from query param if present
        if (queryLocationId) {
          _this4.model.fromLocationId = queryLocationId;
          _this4.FetchReactData.clearTransitionData();
          localStorage.setItem('locationData', (0, _stringify2.default)({
            locationId: queryLocationId,
            isRedirected: true
          }));
          _this4.getLocationDetail();
        }
        _this4.replaceURL();
      }).catch(function (err) {
        console.log(err);
      });

      this.currentStats = "ServiceHistory";
      this.model.fromLocationId = "";
      this.model.tolocationId = "";
      this.model.isData = false;
      this.model.bagOutDetails = true;
      this.model.noDataDisplayed = true;
      this.model.records = this.$translate.instant('error.branch_mgmt.location');
      this.model.noDetailFound = this.$translate.instant('error.branch_mgmt.location');

      // Set up browser back button listener
      this.$window.onpopstate = function (event) {
        if (_this4.$state.current.name !== 'branchManagement.locations') {
          localStorage.removeItem('locationData'); // Clear data
        } else {
          var storedData = localStorage.getItem('locationData');
          if (storedData) {
            var data = JSON.parse(storedData);
            _this4.DataCounter.setData(data);
            localStorage.removeItem('locationData');
          }
        }
      };

      // Listen for state changes to clear data when not using back button
      this.$scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        if (fromState.name !== 'branchManagement.locations') {
          // Clear data if navigating away from 'branchManagement.locations' state
          localStorage.removeItem('locationData');
        }
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      this.locationData = this.DataCounter.getData();
      if (this.locationData && this.locationData.isRedirected) {
        // this.model.fromLocationId = {
        //   Key: this.locationData.locationId,
        //   Value: this.locationData.locationId
        // };
        this.model.fromLocationId = this.locationData.locationId;
        if (this.locationData.vaultDate) {
          var date = this.DateUtil.getUTCDate(new Date());
          // let date = this.DateUtil.getUTCDate(this.locationData.vaultDate);
          var startDate = new Date(date).valueOf();
          var endDate = new Date(this.currentVaultDate).valueOf();
          this.model.dateRangeOptions.startDate = moment(date).startOf('day').format('YYYY-MM-DD HH:mm:ss');
          if (startDate > endDate) this.model.dateRangeOptions.endDate = moment(date).add(14, 'days').format('YYYY-MM-DD HH:mm:ss');else this.model.dateRangeOptions.endDate = moment(this.currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss');
        }
        // this.loadDataOfServiceHistory(this.model.dateRangeOptions);
        // this.getPickupServiceHistory();
        // this.getDeliveryServiceHistory();
        this.getLocationDetail();
      }
    }
  }, {
    key: 'replaceURL',
    value: function replaceURL() {
      var locationId = void 0;
      if (this.model.currentStatsOfServiceHistory === this.serviceHistoryStats.all && this.model.fromLocationId) locationId = this.model.fromLocationId.Value;else locationId = this.model.fromLocationId;

      var obj = { locationId: locationId, isRedirected: true };
      localStorage.setItem('locationData', (0, _stringify2.default)(obj));
      this.$state.transitionTo('branchManagement.locations', { id: locationId });
    }
  }, {
    key: 'serviceHistoryTabSelection',
    value: function serviceHistoryTabSelection(selectedValue) {
      if (selectedValue === this.serviceHistoryStats.single) {
        setTimeout(function () {
          var el = document.getElementById('serviceHistorySingleSearch');
          if (el) el.focus();
        }, 100);
      }
      if (!this.model.fromLocationId) return;
      this.model.fromLocationId = null;
      this.reset();
    }
  }, {
    key: 'tabSelection',
    value: function tabSelection(selectedValue, date) {
      this.model.fromLocationId = this.getLocationId();
      var locationId = _lodash2.default.find(this.locationList, { Value: this.model.fromLocationId });
      if (this.model.fromLocationId && !locationId && !_lodash2.default.isEmpty(this.locationDetails)) {
        // locationId = {
        //   Key: this.locationDetails.locationId + ' | ' + this.locationDetails.locationName + ' | ',
        //   Value: this.locationDetails.locationId
        // }
        locationId = this.mappingLocationData([this.locationDetails], { id: 'locationId', name: 'locationName', address: 'locationAddress', city: 'locationCity', state: 'locationState', zip: 'locationZip', country: 'locationCountry' })[0];
      }
      if (selectedValue == 'ServiceHistory') {
        this.model.currentStatsOfServiceHistory = this.serviceHistoryStats.single;
        this.pagination.page = 1;
        this.pickupHistoryObj.pagination.page = 1;
        this.deliveryHistoryObj.pagination.page = 1;
        this.setDateRange();
        this.getLocationDetail();
        // this.loadDataOfServiceHistory(date);
        // this.getDeliveryServiceHistory();
        // this.getPickupServiceHistory();
      }
      // else if (selectedValue == 'ItemHistory') {
      //   this.pagination.page = 1;
      //   this.loadDataOfItemHistory(date)
      // }
      else if (selectedValue == 'BagoutHistory') {
          this.model.fromLocationId = locationId;
          this.pagination.page = 1;
          this.setDateRange();
          this.bagoutScanned(date);
        } else if (selectedValue == 'RepairHistory') {
          this.model.fromLocationId = locationId;
          this.pagination.page = 1;
          this.setDateRange();
          this.getCompletedServiceTickets(date);
        } else if (selectedValue == 'BillingRule') {
          this.model.fromLocationId = locationId;
          this.billingRulesObj.pagination.page = 1;
          this.setDateRange();
          this.getBillingRules(date);
        } else if (selectedValue == 'BillingHistory') {
          this.model.fromLocationId = locationId;
          this.billingHistoryObj.pagination.page = 1;
          this.setDateRange();
          this.getBillingHistory(date);
        }
      this.currentStats = selectedValue;
    }
  }, {
    key: 'isCustomerLocation',
    value: function isCustomerLocation(locationId) {
      var _this5 = this;

      if (!this.customerId) {
        return _promise2.default.resolve(true);
      }
      return this.LocationService.hasCustomerLocation(locationId, this.customerId, this.model.branchId).then(function () {
        return _promise2.default.resolve(true);
      }).catch(function (err) {
        _this5.serviceHistory = { results: [] };
        _this5.locationDetails = {};
        _this5.model.isData = true;
        _this5.model.unableToFind = _this5.$translate.instant('error.branch_mgmt.location_not_found');
        if (err && err.data && err.data.message) {
          _this5.Modal.errorModal(err.data.message);
        }
        return _promise2.default.resolve(false);
      });
    }
  }, {
    key: 'onLocationSelected',
    value: function onLocationSelected() {
      var _this6 = this;

      this.$scope.$evalAsync(function () {
        _this6.getLocationDetail();
        _this6.replaceURL();
      });
    }
  }, {
    key: 'getLocationDetail',
    value: function getLocationDetail() {
      var _this7 = this;

      if (!this.model.fromLocationId) return;
      this.model.fromLocationSearchText = null;
      this.model.toLocationSearchText = null;
      this.model.pickupServiceHistoryObj.reverseSort = false;
      this.model.pickupServiceHistoryObj.sortColumn = "serviceDate";
      this.model.deliveryServiceHistoryObj.reverseSort = false;
      this.model.deliveryServiceHistoryObj.sortColumn = "serviceDate";
      this.isCustomerLocation(this.getLocationId()).then(function (allow) {
        if (allow) {
          _this7.loadDataOfServiceHistory(_this7.model.dateRangeOptions);
          _this7.getDeliveryServiceHistory();
          _this7.getPickupServiceHistory();
          _this7.getNoPickupHistory();
        }
      }).catch(function (err) {
        // this.model.pickupServiceHistory = [];
        // this.pickupHistoryObj.pagination.total
        // this.deliveryHistoryObj.pagination.total = 0;
        // this.model.deliveryServiceHistory = [];
        // this.serviceHistory = [];
        // this.serviceHistoryTotal = 0;
        _this7.serviceHistory = { results: [] };
        _this7.locationDetails = {};
        _this7.model.isData = true;
        _this7.model.unableToFind = _this7.$translate.instant('error.branch_mgmt.location_not_found');
        if (err && err.data && err.data.message) {
          return _this7.Modal.errorModal('error.' + err.data.message);
        }
      });
    }
    // load transaction data based on fromLocation and refNumber

  }, {
    key: 'loadDataOfServiceHistory',
    value: function loadDataOfServiceHistory(date) {
      var _this8 = this;

      var self = this;
      var searchData = this.getLocationId();

      if (!searchData) {
        return;
      }

      if (searchData != self.lastScanned) {
        self.pagination.page = 1;
      }

      date.startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
      date.endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
      self.loading = true;
      self.model.isData = false;
      self.ShipmentService.ServiceItemHistory(searchData, date.startDate, date.endDate, (self.pagination.page - 1) * self.pagination.pageLimit, self.pagination.pageLimit, self.model.atmServiceHistoryObj.sortColumn, self.model.atmServiceHistoryObj.reverseSort).then(function (data) {
        if (data && data.results && data.results.length) {
          var orderNoGrp = new _map2.default();
          data.results.forEach(function (cur) {
            var key = cur.parentLoadTrackingId;
            if (!orderNoGrp.has(key)) {
              orderNoGrp.set(key, {
                commonAttributes: {}, // to store shared attributes
                orders: [] // to store individual orders
              });
            }
            orderNoGrp.get(key).orders.push(cur);
          });
          // Extract common attributes and prepare final grouped data
          var groupedData = (0, _from2.default)(orderNoGrp.entries()).map(function (_ref) {
            var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                key = _ref2[0],
                group = _ref2[1];

            var commonOrder = group.orders[0];

            return {
              orderNo: commonOrder.orderNo,
              deliveryAmount: group.orders.reduce(function (sum, order) {
                return sum + order.deliveryAmount;
              }, 0),
              serviceDate: commonOrder.serviceDate,
              orderType: commonOrder.orderType,
              status: commonOrder.status,
              deletedReason: commonOrder.deletedReason,
              transType: commonOrder.transType || null,
              routeId: commonOrder.routeId,
              toLocationId: commonOrder.toLocationId,
              toLocationName: commonOrder.toLocationName,
              loadTrackingId: commonOrder.parentLoadTrackingId,
              residualTrackingId: commonOrder.parentResidualTrackingId,
              isEC: commonOrder.isEC,
              deliveryDate: commonOrder.deliveryDate,
              deliveredFlag: commonOrder.deliveredFlag,
              fromLocationId: commonOrder.fromLocationId,
              fromLocationName: commonOrder.fromLocationName,
              residualAmount: group.orders.reduce(function (sum, order) {
                return sum + order.residualAmount;
              }, 0),
              loadedAmount: group.orders.reduce(function (sum, order) {
                return sum + order.loadedAmount;
              }, 0),
              amountCounted: group.orders.reduce(function (sum, order) {
                return sum + order.amountCounted;
              }, 0),
              amountCRV: group.orders.reduce(function (sum, order) {
                return sum + order.amountCRV;
              }, 0),
              packed: commonOrder.packed,
              fundingSourceId: commonOrder.fundingSourceId,
              denominations: _lodash2.default.uniqBy(group.orders.filter(function (order) {
                return order.denominationId;
              }), 'denominationId').map(function (order) {
                return {
                  denominationId: order.denominationId,
                  deliveryAmount: order.deliveryAmount,
                  amountCounted: order.amountCounted
                };
              }),
              parentLoadShipmentDetails: commonOrder.parentLoadShipmentDetails,
              parentResidualShipmentDetails: commonOrder.parentResidualShipmentDetails,
              finishedAt: commonOrder.finishedAt,
              amountVariance: commonOrder.amountVariance
            };
          });
          self.serviceHistory.results = groupedData;
          self.serviceHistoryTotal = data.total;
          // self.loading = false;
          // self.model.isData = false;
          self.lastScanned = searchData;
          self.vaultDate = moment(self.currentVaultDate).format('MM-DD-YYYY');
          self.calculateDays(date.startDate, date.endDate);
        } else {
          // self.loading = false;
          // self.model.isData = false;
          self.model.unableToFind = self.$translate.instant('error.branch_mgmt.location_not_found');
          self.serviceHistory = { results: [] };
          self.serviceHistoryTotal = 0;
        }
        self.locationDetails = {
          locationId: data.locationId,
          locationName: data.locationName,
          locationType: data.locationType,
          locationAddress: data.locationAddress,
          locationCity: data.locationCity,
          locationState: data.locationState,
          locationZip: data.locationZip,
          locationCountry: data.locationCountry
        };
        return data;
      }).then(function (data) {
        if (_this8.locationData) {
          // this.model.fromLocationId = {
          //   Key: this.locationData.locationId + ' | ' + data.locationName,
          //   Value: this.locationData.locationId
          // };
          _this8.model.fromLocationId = _this8.locationData.locationId;
          _this8.locationData.isRedirected = false;
          _this8.locationData = _this8.DataCounter.setData();
        }
      }).catch(function (err) {
        self.serviceHistory = { results: [] };
        self.locationDetails = {};
        self.serviceHistoryTotal = 0;
        self.model.isData = true;
        self.model.unableToFind = self.$translate.instant('error.branch_mgmt.location_not_found');

        if (err && err.data && err.data.message) {
          return _this8.Modal.errorModal('error.' + err.data.message);
        }
      }).finally(function () {
        self.model.isData = true;
        self.loading = false;
      });
    }
  }, {
    key: 'pageChangeServiceHistory',
    value: function pageChangeServiceHistory(date) {
      this.loadDataOfServiceHistory(date);
    }
  }, {
    key: 'getOrderType',
    value: function getOrderType(type) {
      return this.ShipmentService.getOrderType(type);
    }
  }, {
    key: 'redirectToOrderPage',
    value: function redirectToOrderPage(data) {
      var obj = {
        orderNo: data.orderNo,
        vaultDate: data.serviceDate,
        isRedirected: true,
        isCounted: data.residualTrackingId && data.finishedAt ? true : false,
        isInProcess: data.residualTrackingId && !data.finishedAt ? true : false,
        fundingSourceId: data.fundingSourceId
      };
      this.DataCounter.setData(obj);
      this.$state.go('branchManagement.orders');
    }
  }, {
    key: 'redirectToAtmCount',
    value: function redirectToAtmCount(data) {
      var obj = {
        trackingId: data.residualTrackingId,
        isRedirected: true,
        fundingSourceId: data.fundingSourceId
      };
      this.DataCounter.setData(obj);
      this.$state.go('atmCount');
    }
  }, {
    key: 'convertTime',
    value: function convertTime(microSeconds) {
      return this.ShipmentService.convertTime(microSeconds);
    }

    // load transaction data based on toLocation
    // loadDataOfItemHistory(date) {

    //   date.startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
    //   date.endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
    //   var searchData = this.model.fromLocationId;
    //   var self = this;

    //   if (searchData === '') {
    //     return;
    //   }

    //   if (searchData != self.lastScanned) {
    //     self.pagination.page = 1;
    //   }

    //   self.model.loading = true;
    //   return self.ShipmentService.LocationsItemHistory(searchData, date.startDate, date.endDate, (self.pagination.page - 1) * self.pagination.pageLimit, self.pagination.pageLimit)
    //     .then((data) => {
    //       if (data.results.length) {
    //         self.itemHistory = data;
    //         self.itemHistoryTotal = data.total;
    //         self.model.loading = false;
    //         self.model.noDataDisplayed = false;
    //         self.lastScanned = searchData;
    //         self.vaultDate = moment(self.currentVaultDate).format('MM-DD-YYYY');
    //       }
    //       else {
    //         self.model.loading = false;
    //         self.model.noDataDisplayed = false;
    //         self.model.noDataFound = self.$translate.instant('error.branch_mgmt.location_not_found');
    //         self.itemHistory = [];
    //         self.itemHistoryTotal = 0;
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     })
    //     .finally(() => {
    //       self.model.loading = false;
    //     });
    // }

    // pageChangeItemHistory(date) {
    //   this.loadDataOfItemHistory(date)
    // }

    // redirect user to specific location 

  }, {
    key: 'editLocation',
    value: function editLocation(fromLocationId) {
      var _this9 = this;

      if (fromLocationId != null) {
        setTimeout(function () {
          _this9.Navigation.goToLocationTab(_this9.getLocationId());
        }, 200);
      } else {
        this.error = this.$translate.instant('error.branch_mgmt.locations_not_found');
      }
    }
  }, {
    key: 'bagoutScanned',
    value: function bagoutScanned(date) {
      var _this10 = this;

      if (this.model.loading || !this.model.fromLocationId) return;
      // this.model.loading = true;
      this.isCustomerLocation(this.model.fromLocationId.Value).then(function (allow) {
        if (allow) {
          _this10.loadBagoutScanned(date);
        }
      }).catch(function (err) {
        _this10.model.unableToFind = _this10.$translate.instant('error.branch_mgmt.location_not_found');
        if (err && err.data && err.data.message) {
          return _this10.Modal.errorModal(err.data.message);
        }
        _this10.model.loading = false;
        delete _this10.model.noDetailFound;
        _this10.model.bagOutDetails = false;
        _this10.bagOutData = null;
        _this10.bagOutTotal = 0;
        _this10.noDataFound = _this10.$translate.instant('common.no_data_found');
      });
    }

    // Load bagout history based on location

  }, {
    key: 'loadBagoutScanned',
    value: function loadBagoutScanned(date) {
      var _this11 = this;

      var searchText = this.model.fromLocationId ? this.model.fromLocationId.Value : null;

      var self = this;

      if (!searchText) {
        return;
      }

      if (searchText != self.lastScanned) {
        self.pagination.page = 1;
      }

      this.model.loading = true;
      date.startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
      date.endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');

      this.BagoutService.getBagoutData(searchText, date.startDate, date.endDate, this.customerId, (self.pagination.page - 1) * self.pagination.pageLimit, self.pagination.pageLimit).then(function (data) {
        if (data.results.length) {
          _this11.model.loading = false;
          _this11.bagOutTotal = data.total;
          delete _this11.model.noDetailFound;
          _this11.localDateTime = moment(_this11.currentVaultDate).format('MM-DD-YYYY');
          _this11.bagOutData = data.results;
          self.lastScanned = searchText;
          self.calculateDays(date.startDate, date.endDate);
        } else {
          _this11.model.loading = false;
          delete _this11.model.noDetailFound;
          _this11.model.bagOutDetails = false;
          _this11.bagOutData = null;
          _this11.bagOutTotal = 0;
          _this11.noDataFound = _this11.$translate.instant('common.no_data_found');
        }
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this11.model.loading = false;
      });
    }
  }, {
    key: 'pageChangeBagoutHistory',
    value: function pageChangeBagoutHistory(date) {
      this.bagoutScanned(date);
    }
  }, {
    key: 'goToItemHistory',
    value: function goToItemHistory(trackingId) {
      this.$state.go('branchManagement.items', {
        id: trackingId
      });
    }
  }, {
    key: 'showResidualReceipt',
    value: function showResidualReceipt(shipments) {
      shipments.trackingId = shipments.residualTrackingId;
      this.Modal.atmResidualReceipt(shipments, function (_ref3) {
        var modal = _ref3.modal;
      }, function (_ref4) {
        var modal = _ref4.modal;

        modal.close();
      });
    }
  }, {
    key: 'goToContract',
    value: function goToContract(contractId) {
      this.$state.go('contract.edit', {
        id: contractId
      });
    }
  }, {
    key: 'exportServiceHistory',
    value: function exportServiceHistory() {
      var _this12 = this;

      var self = this;
      var searchData = this.getLocationId();
      var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
      var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
      var reportPrefix = 'Service_History';

      self.isExporting = true;
      this.ShipmentService.exportServiceHistoryData(searchData, startDate, endDate, 0, 10000).then(function (data) {
        _this12.fileName = reportPrefix.concat('_', searchData, '.csv');
        var a = document.createElement("a");
        document.body.appendChild(a);
        var file = new Blob([data.reportData], { type: 'application/csv' });
        var fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = _this12.fileName;
        a.click();
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this12.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        self.isExporting = false;
      });
    }
  }, {
    key: 'exportBagoutHistory',
    value: function exportBagoutHistory() {
      var _this13 = this;

      var self = this;
      var searchData = this.model.fromLocationId ? this.model.fromLocationId.Value : null;
      var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
      var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
      var reportPrefix = 'Bagout_History';

      self.isExporting = true;
      this.BagoutService.exportBagoutHistory(searchData, startDate, endDate, 0, 100000).then(function (data) {
        _this13.fileName = reportPrefix.concat('_', searchData, '.csv');
        var a = document.createElement("a");
        document.body.appendChild(a);
        var file = new Blob([data.csvString], { type: 'application/csv' });
        var fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = _this13.fileName;
        a.click();
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this13.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        self.isExporting = false;
      });
    }
  }, {
    key: 'calculateDays',
    value: function calculateDays(startDate, endDate) {
      var start = moment(startDate, 'YYYY-MM-DD');
      var end = moment(endDate, 'YYYY-MM-DD');
      var days = moment.duration(end.diff(start)).asDays();

      if (days + 1 > 31) this.isAllow = false;else this.isAllow = true;

      return this.isAllow;
    }
  }, {
    key: 'redirectToOrderPack',
    value: function redirectToOrderPack(data) {
      var info = {
        routeId: data.routeId,
        vaultDate: data.serviceDate,
        locationId: data.fromLocationId,
        isRedirected: true,
        orderNo: data.orderNo,
        isEC: data.isEC,
        status: data.status,
        fundingSourceId: data.fundingSourceId
      };
      this.DataCounter.setPendingPackData(info);
      this.$state.go('orderPacking');
    }
  }, {
    key: 'goToSoftDeleteShpTab',
    value: function goToSoftDeleteShpTab(shipment) {
      var obj = {
        trackingId: shipment.loadTrackingId,
        isRedirected: true
      };
      this.DataCounter.setData(obj);
      this.$state.go('soft-deleted-shipments.all', {
        page: 1
      });
    }
  }, {
    key: 'goToItemHold',
    value: function goToItemHold(shipment) {
      var obj = {
        trackingId: shipment.loadTrackingId,
        isRedirected: true
      };
      this.DataCounter.setData(obj);
      this.$state.go('branchManagement.itemHolds');
    }
  }, {
    key: 'redirectTo',
    value: function redirectTo(data) {
      if (data.residualTrackingId || !data.residualTrackingId && data.status === 'shipment.deleted') return this.goToItemHistory(data.loadTrackingId);else if (!data.residualTrackingId && data.loadTrackingId) return this.goToItemHistory(data.loadTrackingId);else return this.redirectToOrderPack(data);
    }

    // Load repair history

  }, {
    key: 'getCompletedServiceTickets',
    value: function getCompletedServiceTickets(date) {
      var _this14 = this;

      var searchText = this.model.fromLocationId ? this.model.fromLocationId.Value : null;
      var self = this;
      this.buckets = [];
      var bucketName = "";

      if (searchText != self.lastScanned) {
        self.pagination.page = 1;
      }

      this.model.isLoadingCompletedServiceOrder = true;
      date.startDate = moment(self.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
      date.endDate = moment(self.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');

      self.ServiceOrderService.getCompletedServiceTickets(searchText, self.pagination.pageLimit, (self.pagination.page - 1) * self.pagination.pageLimit, date.startDate, date.endDate, moment.tz.guess(), this.customerId, bucketName, this.model.reverseSort, this.model.sortColumn).then(function (data) {
        self.model.completedServiceTickets = data.results;
        self.model.completedServiceTicketsCount = data.totalRecords;
        self.lastScanned = searchText;

        var res = (0, _keys2.default)(self.model.completedServiceTickets);
        res.map(function (key) {
          if (self.model.completedServiceTickets[key] && self.model.completedServiceTickets[key].items.length || key == 'COMPLETE' || key == 'CANCELLED') _this14.buckets.push({ bucket: key });
        });

        _this14.buckets.forEach(function (d, i) {
          if (_this14.bucketsExpand) {
            _this14.bucketsExpand[d.bucket] = {
              isExpanded: _this14.bucketsExpand[d.bucket] && _this14.bucketsExpand[d.bucket].isExpanded ? _this14.bucketsExpand[d.bucket].isExpanded : false,
              bucketName: d.bucket,
              child: _this14.bucketsExpand[d.bucket] && _this14.bucketsExpand[d.bucket].child ? _this14.bucketsExpand[d.bucket].child : {}

            };
            d.bucketExpanded = _this14.bucketsExpand[d.bucket].isExpanded || false;
          }

          self.model.completedServiceTickets[d.bucket].page = self.model.completedServiceTickets[d.bucket].page || 1;
          self.model.completedServiceTickets[d.bucket].limit = self.model.completedServiceTickets[d.bucket].limit || _app2.default.defaultPageLimit;
          self.model.completedServiceTickets[d.bucket].offset = self.model.completedServiceTickets[d.bucket].offset || 0;
          // this.sortData(this.model.sortColumn, d.bucket);

          if (!_this14.sortOrderData[d.bucket]) _this14.sortOrderData[d.bucket] = {};
          _this14.sortOrderData[d.bucket][_this14.model.sortColumn] = _this14.model.sortColumn;
          _this14.sortOrderData[d.bucket][_this14.model.reverseSort] = true;
        });
        _this14.model.isLoadingCompletedServiceOrder = false;
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          self.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this14.model.isLoadingCompletedServiceOrder = false;
      });
    }

    // Load repair history sorting

  }, {
    key: 'bucketSort',
    value: function bucketSort(column, bucket) {
      if (!this.sortOrderData[bucket]) this.sortOrderData[bucket] = {};

      if (this.sortOrderData[bucket] && this.sortOrderData[bucket][this.model.sortColumn]) {
        this.sortOrderData[bucket][this.model.reverseSort] = this.sortOrderData[bucket][this.model.sortColumn] === column ? !this.sortOrderData[bucket][this.model.reverseSort] : false;
      } else this.sortOrderData[bucket][this.model.reverseSort] = false;

      this.sortOrderData[bucket][this.model.sortColumn] = column;
      if (bucket === 'COMPLETE' || bucket === 'CANCELLED') {
        this.pageChange(this.model.dateRangeOptions, bucket);
      }
    }
  }, {
    key: 'getBucketName',
    value: function getBucketName(status) {
      switch (status) {
        case 'INCOMPLETED':
          return this.$translate.instant('serviceTickets.incomplete');
        case status:
          return this.$translate.instant('serviceTickets.status_' + status);
        default:
          return;
      }
    }
  }, {
    key: 'setStatusExpanded',
    value: function setStatusExpanded(bucketName) {
      this.bucketsExpand[bucketName].isExpanded = !this.bucketsExpand[bucketName].isExpanded;
    }
  }, {
    key: 'calculateAssignAndAcceptTime',
    value: function calculateAssignAndAcceptTime(assignTime, acceptTime) {
      return moment(assignTime).isSameOrAfter(acceptTime);
    }
  }, {
    key: 'calculateDuration',
    value: function calculateDuration(startDate, endDate) {
      var start = moment(startDate).valueOf();
      var end = moment(endDate).valueOf();

      if (start && end && end < start) {
        // reverse the date order
        var t = startDate;
        startDate = endDate;
        endDate = t;
      }

      var ms = moment(endDate).diff(startDate);
      var duration = moment.duration(ms);
      return Math.floor(duration.asHours()) + moment.utc(ms).format(":mm:ss");
    }
  }, {
    key: 'loadOrderHistoryData',
    value: function loadOrderHistoryData(data, event) {
      if (data.expanded) {
        this.getServiceOrderHistory(data, event);
      } else {
        delete this.model.serviceHistoryData[data.serviceOrderId];
      }
      document.getElementById('expand-btn-' + data.serviceOrderId).blur();
    }
  }, {
    key: 'getServiceOrderHistory',
    value: function getServiceOrderHistory(data, event) {
      var _this15 = this;

      this.serviceHistory[data.serviceOrderId] = { process: true };
      this.ServiceOrderService.serviceOrderHistory(data.encounterId, data.serviceOrderId, data.externalProcessorId).then(function (history) {
        _this15.model.serviceHistoryData[data.serviceOrderId] = { details: history };
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this15.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this15.serviceHistory[data.serviceOrderId].process = false;
      });
      event.preventDefault();
    }
  }, {
    key: 'formatJsonObj',
    value: function formatJsonObj(obj) {
      delete obj.notes;
      var details = (0, _stringify2.default)(obj);
      var addPipe = details.replace(/,/g, ' | ');
      var removeCurlyBraces = addPipe.replace(/[{}]/g, "");
      var finalObj = removeCurlyBraces.replace(/:/g, ": ");
      return finalObj.replace(/\"/g, "");
    }
  }, {
    key: 'redirectToServiceHistory',
    value: function redirectToServiceHistory(locationId, locationName) {
      this.model.fromLocationId = locationId;
      document.getElementById("repair-history").classList.remove('active');
      document.getElementById("bagout-history").classList.remove('active');
      document.getElementById("service-history").classList.add('active');
      return this.tabSelection('ServiceHistory', this.model.dateRangPickerOptions);
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(serviceOrder) {
      this.setDateRange();
      this.redirectToServiceHistory(serviceOrder.locationId, serviceOrder.locationName);
    }
  }, {
    key: 'goToRouteTab',
    value: function goToRouteTab(serviceOrder) {
      var _this16 = this;

      if (this.model.branchId === serviceOrder.branchId) {
        this.redirectToRouteTab(serviceOrder.routeId, serviceOrder.branchCurrentVaultDate);
      } else {
        this.shiftBranch(this.model.loggedInUser, serviceOrder.branchId).then(function () {
          _this16.redirectToRouteTab(serviceOrder.routeId, serviceOrder.branchCurrentVaultDate);
        });
      }
    }
  }, {
    key: 'redirectToRouteTab',
    value: function redirectToRouteTab(routeId, vaultDate) {
      return this.Navigation.goToRouteTab(routeId, vaultDate, true, null);
    }
  }, {
    key: 'goToRouteStatus',
    value: function goToRouteStatus(obj) {
      var date = obj.countCompletedAt ? this.DateUtil.getTZFormattedDate(obj.pickupDate, this.model.timezone) : obj.serviceDate;
      this.redirectToRouteTab(obj.routeId, date);
    }
  }, {
    key: 'shiftBranch',
    value: function shiftBranch(userId, selectedBranch) {
      var _this17 = this;

      var obj = {
        id: userId,
        branchId: selectedBranch
      };
      var defer = this.$q.defer();
      this.UsersService.updateUserBranch(obj.id, obj).then(function (data) {
        _this17.User.setUser(data);
        defer.resolve();
      }).catch(function (err) {
        err.data.errors.map(function (e) {
          _this17.errorMessage += e.message + '<br/>';
        });
        _this17.Modal.errorModal(_this17.errorMessage);
      });
      return defer.promise;
    }
  }, {
    key: 'pageChange',
    value: function pageChange(date, bucketName) {
      var _this18 = this;

      var searchText = this.model.fromLocationId ? this.model.fromLocationId.Value : null;

      this.model.completedServiceTickets[bucketName].process = true;
      date.startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
      date.endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
      this.ServiceOrderService.getCompletedServiceTickets(searchText, this.model.completedServiceTickets[bucketName].limit, (this.model.completedServiceTickets[bucketName].page - 1) * this.model.completedServiceTickets[bucketName].limit, date.startDate, date.endDate, moment.tz.guess(), this.customerId, bucketName, this.sortOrderData[bucketName] && this.sortOrderData[bucketName][this.model.reverseSort], this.sortOrderData[bucketName] && this.sortOrderData[bucketName][this.model.sortColumn]) // this.model.reverseSort, this.model.sortColumn
      .then(function (data) {

        _this18.model.completedServiceTickets[bucketName].items = data.results[bucketName].items || [];
        _this18.model.completedServiceTickets[bucketName].totalCount = data.results[bucketName].totalCount || 0;

        if (_this18.model.completedServiceTickets[bucketName] && _this18.model.completedServiceTickets[bucketName].items.length) {
          _this18.isValid = true;
          _this18.model.completedServiceTickets[bucketName].items.forEach(function (info, index) {
            _this18.model.completedServiceTickets[bucketName].items[index].expanded = _this18.bucketsExpand[bucketName].child[info.encounterId] || false;
          });
        }
        if (_this18.buckets.length <= 0) _this18.isValid = false;
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this18.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this18.model.completedServiceTickets[bucketName].process = false;
      });
    }
  }, {
    key: 'setDateRangeForRepairHistory',
    value: function setDateRangeForRepairHistory() {
      this.setDateRangeOptions(moment(), this.model.dateRangeOptions, 'dateRangPickerOptionsfor');
      this.model.dateRangeOptions.startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
      this.model.dateRangeOptions.endDate = moment().endOf('week').format('YYYY-MM-DD HH:mm:ss');
    }
  }, {
    key: 'goToUserTab',
    value: function goToUserTab(userId) {
      if (!userId) return;
      this.Navigation.goToUserTab(userId, null);
    }
  }, {
    key: 'setDateRange',
    value: function setDateRange() {
      this.setDateRangeOptions(moment(), this.model.dateRangeOptions, 'dateRangPickerOptionsfor');
      this.model.dateRangeOptions.startDate = moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss');
      this.model.dateRangeOptions.endDate = moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
    }
  }, {
    key: 'validateBucket',
    value: function validateBucket(event) {
      this.bucketExpanded = !this.bucketExpanded;
      event.preventDefault();
    }
  }, {
    key: 'translateItemStatus',
    value: function translateItemStatus(status) {
      if (!status) return;

      if (!status.startsWith('shipment')) return status;else if (status.startsWith('shipment')) return this.$translate.instant(status);else if (status.startsWith('CANT')) return this.$translate.instant('shipment.' + status);else return;
    }
  }, {
    key: 'getDeliveryServiceHistory',
    value: function getDeliveryServiceHistory() {
      var _this19 = this;

      var searchText = this.getLocationId();
      var self = this;
      var LocationSearchText = null;

      if (!searchText) {
        return;
      }

      if (searchText != this.lastScanned) {
        this.pagination.page = 1;
      }

      this.model.loadDeliveryServiceHistory = true;
      this.model.isDeliveryServiceHistory = true;
      var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
      var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
      LocationSearchText = this.model.fromLocationSearchText;

      this.ShipmentService.getDeliveryServiceHistory(searchText, this.model.branchId, startDate, endDate, (this.deliveryHistoryObj.pagination.page - 1) * this.deliveryHistoryObj.pagination.pageLimit, this.deliveryHistoryObj.pagination.pageLimit, LocationSearchText, this.model.deliveryServiceHistoryObj.sortColumn, this.model.deliveryServiceHistoryObj.reverseSort).then(function (data) {
        _this19.deliveryHistoryObj.pagination.total = data.totalRecords;
        _this19.model.deliveryServiceHistory = data.results;
        _this19.lastScanned = searchText;
        // this.model.isDeliveryServiceHistory = true;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this19.model.loadDeliveryServiceHistory = false;
      });
    }
  }, {
    key: 'getPickupServiceHistory',
    value: function getPickupServiceHistory() {
      var _this20 = this;

      var searchText = this.getLocationId();
      var self = this;
      var LocationSearchText = null;

      if (!searchText) {
        return;
      }

      if (searchText != this.lastScanned) {
        this.pagination.page = 1;
      }

      this.model.loadPickupServiceHistory = true;
      this.model.isPickupServiceHistory = false;

      var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
      var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
      LocationSearchText = this.model.toLocationSearchText;
      this.ShipmentService.getPickupServiceHistory(searchText, this.model.branchId, startDate, endDate, (this.pickupHistoryObj.pagination.page - 1) * this.pickupHistoryObj.pagination.pageLimit, this.pickupHistoryObj.pagination.pageLimit, LocationSearchText, this.model.pickupServiceHistoryObj.sortColumn, this.model.pickupServiceHistoryObj.reverseSort, this.model.timezone).then(function (data) {
        _this20.pickupHistoryObj.pagination.total = data.totalRecords;
        _this20.model.pickupServiceHistory = data.results;

        _this20.hasMatchingDepositRecord = _this20.model.pickupServiceHistory.some(function (pickupServiceHistory) {
          return ['DEPOSIT', 'BULKCASH'].includes(pickupServiceHistory.shiptypeId) && pickupServiceHistory && pickupServiceHistory.isVariance;
        });

        if (_this20.hasMatchingDepositRecord) {
          _this20.selectedDepositAmountValue = 'totalAmount';
        } else {
          _this20.selectedDepositAmountValue = null;
        }

        _this20.lastScanned = searchText;
        _this20.model.isPickupServiceHistory = true;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this20.model.loadPickupServiceHistory = false;
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      if (!this.model.fromLocationId) {
        this.model.isData = false;
        this.model.isPickupServiceHistory = false;
        this.model.isDeliveryServiceHistory = false;
        this.transactionHistoryObj.isNopuTransactionHistory = false;
        this.pagination.page = 1;
        this.pickupHistoryObj.pagination.page = 1;
        this.deliveryHistoryObj.pagination.page = 1;
        this.serviceHistory = { results: [] };
        this.transactionHistoryObj.results = [];
      }
    }
  }, {
    key: 'downloadFile',
    value: function downloadFile(locationId, reportPrefix, reportData) {
      var fileName = reportPrefix.concat('_', locationId, '.csv');
      var a = document.createElement("a");
      document.body.appendChild(a);
      var file = new Blob([reportData], { type: 'application/csv' });
      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    }
  }, {
    key: 'exportDeliveryServiceHistory',
    value: function exportDeliveryServiceHistory() {
      var _this21 = this;

      var locationId = this.getLocationId();
      var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
      var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
      var reportPrefix = 'Load_Delivery_Service_History';
      var LocationSearchText = null;
      LocationSearchText = this.model.fromLocationSearchText;

      this.model.isExportingDeliveryServiceHistory = true;
      this.ShipmentService.exportDeliveryServiceHistory(locationId, startDate, endDate, this.model.timezone, LocationSearchText, this.model.deliveryServiceHistoryObj.sortColumn, this.model.deliveryServiceHistoryObj.reverseSort).then(function (data) {
        _this21.downloadFile(locationId, reportPrefix, data.reportData);
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this21.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this21.model.isExportingDeliveryServiceHistory = false;
      });
    }
  }, {
    key: 'exportPickupServiceHistory',
    value: function exportPickupServiceHistory() {
      var _this22 = this;

      var locationId = this.getLocationId();
      var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
      var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
      var reportPrefix = 'Pickup_Service_History';
      var LocationSearchText = null;
      LocationSearchText = this.model.toLocationSearchText;

      this.model.isExportingPickupServiceHistory = true;
      this.ShipmentService.exportPickupServiceHistory(locationId, startDate, endDate, this.model.timezone, LocationSearchText, this.selectedDepositAmountValue, this.model.pickupServiceHistoryObj.sortColumn, this.model.pickupServiceHistoryObj.reverseSort).then(function (data) {
        _this22.downloadFile(locationId, reportPrefix, data.reportData);
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this22.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this22.model.isExportingPickupServiceHistory = false;
      });
    }
  }, {
    key: 'translateTransactionType',
    value: function translateTransactionType(tranType) {
      if (!tranType) return;else return this.$translate.instant('shipment.' + tranType);
    }
  }, {
    key: 'showReceipt',
    value: function showReceipt(shipments, stats) {
      this.Modal.shipmentImageModal(shipments, shipments.trackingId, stats, function (_ref5) {
        var modal = _ref5.modal;
      }, function (_ref6) {
        var modal = _ref6.modal;

        modal.close();
      });
    }

    // load all location

  }, {
    key: 'loadLocations',
    value: function loadLocations(searchKey, offset) {
      var _this23 = this;

      searchKey = searchKey || '';

      var searchObj = {
        queryJSON: {
          rules: [
          // {
          //   field: 'branchId',
          //   condition: '=',
          //   data: this.model.branchId
          // },
          // {
          //   field: 'active',
          //   condition: '=',
          //   data: true
          // },
          {
            field: 'locationType',
            condition: 'IN',
            data: ['REGULAR', 'ATM', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO', 'ON_CALL']
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'address',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      if (this.customerId) {
        searchObj.queryJSON.rules.push({
          field: 'customerId',
          condition: '=',
          data: this.customerId
        });
      }

      this.LocationService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this23.totalRecord = data.total;
          _this23.locationList = _this23.mappingLocationData(data.results);
        } else {
          var location = _this23.mappingLocationData(data.results);
          _this23.locationList = _this23.locationList.concat(location);
        }
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this23.Modal.errorModal(err.data.message);
        }
      });
    }

    // mappingLocationData(location) {
    //   return location.map((loc) => {
    //     return {
    //       Key: loc.id + " | " + loc.name + " | (" + (loc.address ? loc.address + ", " : '') + (loc.city ? loc.city + ", " : '') + (loc.zip ? loc.zip + ", " : '') + (loc.state ? loc.state +( loc.country ?  ", " : '') : '') + loc.country + ")",
    //       Value: loc.id
    //     }
    //   });
    // }

  }, {
    key: 'mappingLocationData',
    value: function mappingLocationData(location) {
      var objKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { id: 'id', name: 'name', address: 'address', city: 'city', zip: 'zip', state: 'state', country: 'country' };

      return location.map(function (loc) {
        var id = loc[objKeys.id] || loc.id;
        var name = loc[objKeys.name] || loc.name;
        var address = loc[objKeys.address] || loc.address;
        var city = loc[objKeys.city] || loc.city;
        var zip = loc[objKeys.zip] || loc.zip;
        var state = loc[objKeys.state] || loc.state;
        var country = loc[objKeys.country] || loc.country;

        var addressParts = [];

        if (address) addressParts.push(address);
        if (city) addressParts.push(city);
        if (zip) addressParts.push(zip);
        if (state) addressParts.push(state);
        if (country) addressParts.push(country);

        var formattedAddress = addressParts.length > 0 ? '(' + addressParts.join(', ') + ')' : '';

        return {
          Key: id + ' | ' + name + ' | ' + formattedAddress,
          Value: id
        };
      });
    }
  }, {
    key: 'getNoPickupHistory',
    value: function getNoPickupHistory() {
      var _this24 = this;

      var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD 00:00:00');
      var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
      var searchText = this.getLocationId();

      if (!searchText) {
        return;
      }

      if (searchText != this.lastScanned) {
        this.transactionHistoryObj.pagination.page = 1;
      }

      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'trackingId',
            condition: '=',
            data: 'NOPU'
          }, {
            field: 'transactionDate',
            condition: 'BETWEEN',
            data: [startDate, endDate]
          }, {
            group: {
              rules: [{
                field: 'fromLocationId',
                condition: '=',
                data: searchText
              }, {
                field: 'toLocationId',
                condition: '=',
                data: searchText
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        },
        order: {
          fieldName: this.model.noPickupServiceHistoryObj.sortColumn,
          keyword: this.model.noPickupServiceHistoryObj.reverseSort ? 'ASC' : 'DESC'
        }
      };

      this.transactionHistoryObj.loading = true;
      this.transactionHistoryObj.isNopuTransactionHistory = false;
      this.TransactionService.all(searchObj, (this.transactionHistoryObj.pagination.page - 1) * this.transactionHistoryObj.pagination.pageLimit, this.transactionHistoryObj.pagination.pageLimit).then(function (data) {
        _this24.transactionHistoryObj.pagination.total = data.total;
        _this24.transactionHistoryObj.results = data.results;
        _this24.transactionHistoryObj.totalRecords = data.total;
        _this24.transactionHistoryObj.isNopuTransactionHistory = true;
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this24.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this24.transactionHistoryObj.loading = false;
      });
    }
  }, {
    key: 'exportNoPickupTransactionHistory',
    value: function exportNoPickupTransactionHistory() {
      var _this25 = this;

      var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD 00:00:00');
      var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
      var reportPrefix = 'No_Pickup_History';

      this.transactionHistoryObj.isExporting = true;
      this.TransactionService.exportNoPickupTransactionHistory(this.getLocationId(), startDate, endDate, this.model.timezone, this.model.noPickupServiceHistoryObj.sortColumn, this.model.noPickupServiceHistoryObj.reverseSort).then(function (data) {
        _this25.downloadFile(_this25.getLocationId(), reportPrefix, data.reportData);
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this25.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this25.transactionHistoryObj.isExporting = false;
      });
    }
  }, {
    key: 'getNextNopuRecords',
    value: function getNextNopuRecords() {
      this.getNoPickupHistory();
    }
  }, {
    key: 'sendDeliveryOrPickupReceipt',
    value: function sendDeliveryOrPickupReceipt(row, stat) {
      var _this26 = this;

      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_title'),
        message: this.$translate.instant('location.confirm_re_send_receipt', { stat: stat }),
        callback: function callback(_ref7) {
          var modal = _ref7.modal;

          var formattedDate = _this26.DateUtil.getUTCDate(row.serviceDate),
              trackingId = row.trackingId,
              locationId = stat === 'delivery' ? row.toLocationId : row.fromLocationId,
              branchId = row.branchId,
              routeId = row.routeId,
              providedEmails = null;

          _this26.isSending = true;
          _this26.LocationService.sendDeliveryOrPickupReceipt(trackingId, locationId, branchId, routeId, formattedDate, providedEmails, _this26.selectedDepositAmountValue, _this26.model.timezone, stat.toUpperCase()).then(function () {}).catch(function (err) {
            if (err && err.data && err.data.message) {
              _this26.Modal.errorModal(err.data.message);
            }
          }).finally(function () {
            modal.close();
            _this26.isSending = false;
          });
        },
        type: 'success'
      });
    }
  }, {
    key: 'sendOrderReceipt',
    value: function sendOrderReceipt(row) {
      var _this27 = this;

      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_title'),
        message: this.$translate.instant('location.confirm_re_send_order_receipt'),
        callback: function callback(_ref8) {
          var modal = _ref8.modal;

          var formattedDate = _this27.DateUtil.getUTCDate(row.serviceDate),
              orderNo = row.orderNo,
              locationId = row.toLocationId,
              branchId = row.branchId,
              routeId = row.routeId,
              providedEmails = null;

          _this27.isSending = true;
          _this27.LocationService.sendOrderReceipt(orderNo, locationId, branchId, routeId, formattedDate, providedEmails).then(function () {}).catch(function (err) {
            if (err && err.data && err.data.message) {
              _this27.Modal.errorModal(err.data.message);
            }
          }).finally(function () {
            modal.close();
            _this27.isSending = false;
          });
        },
        type: 'success'
      });
    }
  }, {
    key: 'clearData',
    value: function clearData() {
      if (!this.model.fromLocationId) {
        this.serviceHistory.results = [];
        this.serviceHistoryTotal = 0;
        this.model.deliveryServiceHistory = [];
        this.model.pickupServiceHistory = [];
        this.transactionHistoryObj.results = [];
        this.model.isData = false;
        this.model.toLocationSearchText = null;
        this.model.fromLocationSearchText = null;
      }
    }
  }, {
    key: 'getLocationId',
    value: function getLocationId() {
      var transitionData = this.FetchReactData.getTransitionData();
      if (transitionData && transitionData.locationId) {
        return transitionData.locationId;
      }
      if (this.model.currentStatsOfServiceHistory === this.serviceHistoryStats.single && this.model.fromLocationId) {
        var locationId = (0, _typeof3.default)(this.model.fromLocationId) === 'object' ? this.model.fromLocationId.Value : this.model.fromLocationId;
        return locationId;
      } else if (this.model.currentStatsOfServiceHistory === this.serviceHistoryStats.all && this.model.fromLocationId) return this.model.fromLocationId.Value;
    }
  }, {
    key: 'setAmount',
    value: function setAmount(obj) {
      if (!obj) return;
      return obj.formattedLoadedAmount !== null ? obj.formattedLoadedAmount : obj.formattedAmount;
      // const status = ['Hold'];

      // if (status.includes(this.translateItemStatus(obj.status))) {
      //   return obj.formattedLoadedAmount !== null ? obj.formattedLoadedAmount : obj.formattedAmount;
      // }
      // else return obj.formattedLoadedAmount
    }
  }, {
    key: 'getBillingRules',
    value: function getBillingRules(date) {
      var _this28 = this;

      this.billingRulesObj.loading = true;
      var locationId = (0, _typeof3.default)(this.model.fromLocationId) === 'object' && this.model.fromLocationId ? this.model.fromLocationId.Value : this.model.fromLocationId;
      if (!locationId) return;
      date.startDate = moment(this.model.billingRulesDateRanges.startDate).format('YYYY-MM-DD HH:mm:ss');
      date.endDate = moment(this.model.billingRulesDateRanges.endDate).format('YYYY-MM-DD 23:59:59');
      this.LocationService.getBillingRulesByLocationId(locationId, (this.billingRulesObj.pagination.page - 1) * this.billingRulesObj.pagination.pageLimit, this.billingRulesObj.pagination.pageLimit, date.startDate, date.endDate).then(function (res) {
        _this28.billingRulesObj.results = res.result;
        _this28.billingRulesObj.totalRecords = res.totalRecords;
        _this28.billingRulesObj.pagination.total = res.totalRecords;
        _this28.billingRulesObj.loading = false;
      });
    }
  }, {
    key: 'getBillingHistory',
    value: function getBillingHistory(date) {
      var _this29 = this;

      this.billingHistoryObj.loading = true;
      var locationId = (0, _typeof3.default)(this.model.fromLocationId) === 'object' && this.model.fromLocationId ? this.model.fromLocationId.Value : this.model.fromLocationId;
      if (!locationId) return;
      date.startDate = moment(this.model.billingHistoryDateRanges.startDate).format('YYYY-MM-DD HH:mm:ss');
      date.endDate = moment(this.model.billingHistoryDateRanges.endDate).format('YYYY-MM-DD 23:59:59');
      this.LocationService.getBillingHistory(locationId, (this.billingHistoryObj.pagination.page - 1) * this.billingHistoryObj.pagination.pageLimit, this.billingHistoryObj.pagination.pageLimit, date.startDate, date.endDate).then(function (res) {
        _this29.billingHistoryObj.results = res.results;
        _this29.billingHistoryObj.totalRecords = res.total;
        _this29.billingHistoryObj.pagination.total = res.total;
        if (_this29.billingHistoryObj.results) {
          _this29.billingHistoryObj.results.forEach(function (log) {

            log.readableEntryType = _this29.$translate.instant('entry_type.' + log.entryType);
            if (log.entryData) {
              log.extraDetails = (0, _entries2.default)(log.entryData).map(function (entry) {
                return {
                  key: entry[0],
                  value: (0, _typeof3.default)(entry[1]) === 'object' ? (0, _stringify2.default)(entry[1]) : entry[1]
                };
              });
            }
          });
        }
        _this29.billingHistoryObj.loading = false;
      });
    }
  }, {
    key: 'exportBillingLocations',
    value: function exportBillingLocations() {
      var _this30 = this;

      var locationId = (0, _typeof3.default)(this.model.fromLocationId) === 'object' ? this.model.fromLocationId.Value : this.model.fromLocationId;
      if (!locationId) return;
      var startDate = moment(this.model.billingRulesDateRanges.startDate).format('YYYY-MM-DD HH:mm:ss');
      var endDate = moment(this.model.billingRulesDateRanges.endDate).format('YYYY-MM-DD 23:59:59');
      var reportPrefix = 'Billing_Rules';
      this.LocationService.exportBillingRulesByLocationId(locationId, startDate, endDate).then(function (res) {
        _this30.fileName = reportPrefix.concat('_', locationId, '.csv');
        var a = document.createElement("a");
        document.body.appendChild(a);
        var file = new Blob([res.csvString], { type: 'application/csv' });
        var fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = _this30.fileName;
        a.click();
      });
    }
  }, {
    key: 'exportBillingHistory',
    value: function exportBillingHistory() {
      var _this31 = this;

      var locationId = (0, _typeof3.default)(this.model.fromLocationId) === 'object' ? this.model.fromLocationId.Value : this.model.fromLocationId;
      if (!locationId) return;
      var startDate = moment(this.model.billingHistoryDateRanges.startDate).format('YYYY-MM-DD HH:mm:ss');
      var endDate = moment(this.model.billingHistoryDateRanges.endDate).format('YYYY-MM-DD 23:59:59');
      var reportPrefix = 'Billing_History';
      this.LocationService.exportBillingHistory(locationId, startDate, endDate).then(function (res) {
        _this31.fileName = reportPrefix.concat('_', locationId, '.csv');
        var a = document.createElement("a");
        document.body.appendChild(a);
        var file = new Blob([res.csvString], { type: 'application/csv' });
        var fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = _this31.fileName;
        a.click();
      });
    }
  }, {
    key: 'deliveryServiceTransactionModal',
    value: function deliveryServiceTransactionModal(obj) {
      var formattedDate = moment(obj.serviceDate).format('YYYY-MM-DD');
      this.Modal.deliveryServiceTransaction(obj.toLocationId, this.model.branchId, formattedDate, obj.trackingId, function (_ref9) {
        var modal = _ref9.modal;

        modal.close();
      }, function (_ref10) {
        var modal = _ref10.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'depositPopover',
    value: function depositPopover(pickupServiceHistory) {
      return '<div><b>Stated Value</b>: ' + this.formatAmount(pickupServiceHistory.statedTotalAmount) + '</div>\n    <div><b>Declared Value</b>: ' + this.formatAmount(pickupServiceHistory.declaredTotalAmount) + '</div>\n    <div><b>Counted Value</b>: ' + this.formatAmount(pickupServiceHistory.totalAmount) + '</div>\n    <div><b>Counted Variance</b>: ' + this.formatAmount(pickupServiceHistory.countedVariance) + '</div>';
    }
  }, {
    key: 'formatAmount',
    value: function formatAmount(amount) {
      var formatted = amount.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return formatted;
    }
  }, {
    key: 'sortDeliveryServiceHistoryData',
    value: function sortDeliveryServiceHistoryData(column, event) {
      this.model.deliveryServiceHistoryObj.reverseSort = this.model.deliveryServiceHistoryObj.sortColumn == column ? !this.model.deliveryServiceHistoryObj.reverseSort : false;
      this.model.deliveryServiceHistoryObj.sortColumn = column;
      this.getDeliveryServiceHistory();
      event.preventDefault();
    }
  }, {
    key: 'sortAtmServiceHistoryData',
    value: function sortAtmServiceHistoryData(column, event, date) {
      this.model.atmServiceHistoryObj.reverseSort = this.model.atmServiceHistoryObj.sortColumn == column ? !this.model.atmServiceHistoryObj.reverseSort : false;
      this.model.atmServiceHistoryObj.sortColumn = column;
      this.loadDataOfServiceHistory(date);
      event.preventDefault();
    }
  }, {
    key: 'sortPickupServiceHistoryData',
    value: function sortPickupServiceHistoryData(column, event) {
      this.model.pickupServiceHistoryObj.reverseSort = this.model.pickupServiceHistoryObj.sortColumn == column ? !this.model.pickupServiceHistoryObj.reverseSort : false;
      this.model.pickupServiceHistoryObj.sortColumn = column;
      this.getPickupServiceHistory();
      event.preventDefault();
    }
  }, {
    key: 'sortNoPickupServiceHistoryData',
    value: function sortNoPickupServiceHistoryData(column, event) {
      this.model.noPickupServiceHistoryObj.reverseSort = this.model.noPickupServiceHistoryObj.sortColumn == column ? !this.model.noPickupServiceHistoryObj.reverseSort : false;
      this.model.noPickupServiceHistoryObj.sortColumn = column;
      this.getNoPickupHistory();
      event.preventDefault();
    }
  }, {
    key: 'convertToCrv',
    value: function convertToCrv(shipment) {
      var _this32 = this;

      if (this.isLoading) return;
      this.isLoading = true;

      this.UsersService.checkSupervisor(this.model.loggedInUser).then(function (userInfo) {
        _this32.Modal.convertToCrv(shipment, !userInfo.supervisor, true, function (_ref11) {
          var supervisor = _ref11.supervisor,
              trackingIdResidual = _ref11.trackingIdResidual,
              modal = _ref11.modal;

          if (trackingIdResidual) {
            _this32.HoldService.convertToCRV(_this32.model.branchId, shipment.trackingId, trackingIdResidual, userInfo.supervisor ? userInfo.id : supervisor).then(function (data) {
              modal.close();
              _this32.isLoading = false;
              _this32.getDeliveryServiceHistory();
            }).catch(function (err) {
              modal.close();
              if (err && err.data && err.data.message) {
                _this32.isLoading = false;
                _this32.Modal.errorModal('error.' + err.data.message);
              }
            });
          } else {
            if (modal) modal.close();
            _this32.isLoading = false;
          }
        }, function (_ref12) {
          var modal = _ref12.modal;

          if (modal) modal.close();
          _this32.isLoading = false;
        });
      }).catch(function (err) {
        _this32.Modal.errorModal(err.data.message);
        _this32.isLoading = false;
      });
    }
  }, {
    key: 'convertToCrvPackableOrder',
    value: function convertToCrvPackableOrder(shipment) {
      var _this33 = this;

      if (this.isLoading) return;
      this.isLoading = true;
      this.Modal.confirm({
        header: 'Confirm CRV Conversion',
        message: 'Are you sure you want to convert this Shipment to CRV?',
        callback: function callback(_ref13) {
          var modal = _ref13.modal,
              $scope = _ref13.$scope;

          modal.close();
          _this33.UsersService.checkSupervisor(_this33.model.loggedInUser).then(function (userInfo) {
            _this33.Modal.confirmSupervisor('shipment-hold-convert-CRV', { trackingId: shipment.trackingId }, function (_ref14) {
              var supModal = _ref14.modal,
                  supId = _ref14.supId;

              supModal.close();
              _this33.HoldService.convertToCrvPackableOrder(_this33.model.branchId, shipment.trackingId, shipment.packableOrderShipmentId, supId).then(function (data) {
                _this33.isLoading = false;
                _this33.getDeliveryServiceHistory();
              }).catch(function (err) {
                if (err && err.data && err.data.message) {
                  _this33.isLoading = false;
                  _this33.Modal.errorModal('error.' + err.data.message);
                }
              });
            }, function (_ref15) {
              var supModal = _ref15.modal;

              supModal.close();
              _this33.isLoading = false;
            });
          }).catch(function (err) {
            _this33.Modal.errorModal(err.data.message);
            _this33.isLoading = false;
          });
        },
        negative: function negative(_ref16) {
          var modal = _ref16.modal,
              $scope = _ref16.$scope;

          modal.close();
          _this33.isLoading = false;
        }
      });
    }
  }, {
    key: 'convertShipmentToCrv',
    value: function convertShipmentToCrv(shipment) {
      if (shipment.packableOrderShipmentId) {
        this.convertToCrvPackableOrder(shipment);
      } else {
        this.convertToCrv(shipment);
      }
    }
  }, {
    key: 'redirectToCashCount',
    value: function redirectToCashCount(item) {
      return this.Navigation.goToAtmCount(item.trackingId, true, null, item.fundingSourceId);
    }
  }]);
  return LocationsController;
}();

exports.default = LocationsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _print = __webpack_require__(1768);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printLocationModule = angular.module('printLocation', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/branchManagement.locations');

    $stateProvider.state('printLocation', {
        url: '/print-location',
        component: 'printLocation',
        data: {
            requireLogin: true,
            requireACL: 'branch_mgmt_locations.all'
        }
    });
}]).component('printLocation', _print2.default).name;

exports.default = printLocationModule;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _locationPrint = __webpack_require__(2690);

var _locationPrint2 = _interopRequireDefault(_locationPrint);

var _print = __webpack_require__(1769);

var _print2 = _interopRequireDefault(_print);

__webpack_require__(2974);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printComponent = {
    restrict: 'E',
    bindings: {},
    template: _locationPrint2.default,
    controller: _print2.default
};

exports.default = printComponent;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _from = __webpack_require__(75);

var _from2 = _interopRequireDefault(_from);

var _map = __webpack_require__(76);

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintController = function () {
    /*@ngInject*/
    PrintController.$inject = ["ShipmentService", "BagoutService", "TransactionService", "$translate", "$q", "Modal", "DateUtil"];
    function PrintController(ShipmentService, BagoutService, TransactionService, $translate, $q, Modal, DateUtil) {
        (0, _classCallCheck3.default)(this, PrintController);

        this.ShipmentService = ShipmentService;
        this.BagoutService = BagoutService;
        this.TransactionService = TransactionService;
        this.$translate = $translate;
        this.DateUtil = DateUtil;
        this.branchId = "";
        this.endDate = "";
        this.searchText = "";
        this.startDate = "";
        this.vaultDate = "";
        this.currentStats = "";
        this.locationType = "";
        this.Modal = Modal;
        this.toLocationSearchText = "";
        this.fromLocationSearchText = "";
    }

    (0, _createClass3.default)(PrintController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var printData = undefined;
            if (window.opener && window.opener.w && window.opener.w.printData) {
                printData = window.opener.w.printData;
                this.branchId = printData.branchId;
                this.endDate = printData.endDate;
                this.searchText = printData.searchText;
                this.startDate = printData.startDate;
                this.vaultDate = printData.vaultDate;
                this.customerId = printData.customerId || null;
                this.currentStats = printData.currentStats;
                this.loading = true;
                this.timezone = printData.timezone;
                this.locationType = printData.locationType;
                this.toLocationSearchText = printData.toLocationSearchText;
                this.fromLocationSearchText = printData.fromLocationSearchText;
                this.selectedDepositAmountValue = printData.selectedDepositAmountValue;
                this.deliveryServiceHistoryObj = printData.deliveryServiceHistoryObj;
                this.atmServiceHistoryObj = printData.atmServiceHistoryObj;
                this.pickupServiceHistoryObj = printData.pickupServiceHistoryObj;
                this.noPickupServiceHistoryObj = printData.noPickupServiceHistoryObj;

                if (this.currentStats === 'ServiceHistory') {
                    return this.ShipmentService.ServiceItemHistory(this.searchText, this.startDate, this.endDate, 0, 5000, this.atmServiceHistoryObj.sortColumn, this.atmServiceHistoryObj.reverseSort).then(function (data) {
                        _this.loading = false;
                        _this.serviceHistory = data;

                        var orderNoGrp = new _map2.default();
                        data.results.forEach(function (cur) {
                            var key = cur.parentLoadTrackingId;
                            if (!orderNoGrp.has(key)) {
                                orderNoGrp.set(key, {
                                    commonAttributes: {}, // to store shared attributes
                                    orders: [] // to store individual orders
                                });
                            }
                            orderNoGrp.get(key).orders.push(cur);
                        });
                        // Extract common attributes and prepare final grouped data
                        var groupedData = (0, _from2.default)(orderNoGrp.entries()).map(function (_ref) {
                            var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                                key = _ref2[0],
                                group = _ref2[1];

                            var commonOrder = group.orders[0];

                            return {
                                orderNo: commonOrder.orderNo,
                                deliveryAmount: group.orders.reduce(function (sum, order) {
                                    return sum + order.deliveryAmount;
                                }, 0),
                                serviceDate: commonOrder.serviceDate,
                                orderType: commonOrder.orderType,
                                status: commonOrder.status,
                                deletedReason: commonOrder.deletedReason,
                                transType: commonOrder.transType || null,
                                routeId: commonOrder.routeId,
                                toLocationId: commonOrder.toLocationId,
                                toLocationName: commonOrder.toLocationName,
                                loadTrackingId: commonOrder.parentLoadTrackingId,
                                residualTrackingId: commonOrder.parentResidualTrackingId,
                                isEC: commonOrder.isEC,
                                deliveryDate: commonOrder.deliveryDate,
                                deliveredFlag: commonOrder.deliveredFlag,
                                fromLocationId: commonOrder.fromLocationId,
                                fromLocationName: commonOrder.fromLocationName,
                                residualAmount: group.orders.reduce(function (sum, order) {
                                    return sum + order.residualAmount;
                                }, 0),
                                loadedAmount: group.orders.reduce(function (sum, order) {
                                    return sum + order.loadedAmount;
                                }, 0),
                                amountCounted: group.orders.reduce(function (sum, order) {
                                    return sum + order.amountCounted;
                                }, 0),
                                amountCRV: group.orders.reduce(function (sum, order) {
                                    return sum + order.amountCRV;
                                }, 0),
                                denominations: _lodash2.default.uniqBy(group.orders.filter(function (order) {
                                    return order.denominationId;
                                }), 'denominationId').map(function (order) {
                                    return {
                                        denominationId: order.denominationId,
                                        deliveryAmount: order.deliveryAmount,
                                        amountCounted: order.amountCounted
                                    };
                                }),
                                parentLoadShipmentDetails: commonOrder.parentLoadShipmentDetails,
                                parentResidualShipmentDetails: commonOrder.parentResidualShipmentDetails,
                                finishedAt: commonOrder.finishedAt,
                                amountVariance: commonOrder.amountVariance
                            };
                        });
                        _this.serviceHistory.results = groupedData;
                        _this.serviceHistoryTotal = data.total;
                        _this.print();
                    }).catch(function (err) {
                        console.log(err);
                    });
                } else if (this.currentStats === 'ItemHistory') {
                    return this.ShipmentService.LocationsItemHistory(this.searchText, this.startDate, this.endDate, 0, 5000).then(function (data) {
                        _this.loading = false;
                        _this.itemHistory = data;
                        _this.print();
                    }).catch(function (err) {
                        console.log(err);
                    });
                } else if (this.currentStats === 'deliveryServiceHistory') {
                    return this.ShipmentService.printDeliveryServiceHistory(this.searchText, this.startDate, this.endDate, this.timezone, this.fromLocationSearchText, this.deliveryServiceHistoryObj.sortColumn, this.deliveryServiceHistoryObj.reverseSort).then(function (data) {
                        _this.loading = false;
                        _this.deliveryServiceHistoryData = data;
                        _this.print();
                    }).catch(function (err) {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            _this.Modal.errorModal(err.data.message);
                        }
                    });
                } else if (this.currentStats === 'pickupServiceHistory') {
                    return this.ShipmentService.printPickupServiceHistory(this.searchText, this.startDate, this.endDate, this.timezone, this.toLocationSearchText, this.pickupServiceHistoryObj.sortColumn, this.pickupServiceHistoryObj.reverseSort).then(function (data) {
                        _this.loading = false;
                        _this.pickupServiceHistoryData = data;
                        _this.print();
                    }).catch(function (err) {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            _this.Modal.errorModal(err.data.message);
                        }
                    });
                } else if (this.currentStats === 'noPickupHistory') {
                    return this.TransactionService.printNoPickupTransactionHistory(this.searchText, this.startDate, this.endDate, this.timezone, this.noPickupServiceHistoryObj.sortColumn, this.noPickupServiceHistoryObj.reverseSort).then(function (data) {
                        _this.loading = false;
                        _this.noPickupServiceHistoryData = data;
                        _this.print();
                    }).catch(function (err) {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            _this.Modal.errorModal(err.data.message);
                        }
                    });
                } else {
                    return this.BagoutService.getBagoutData(this.searchText, this.startDate, this.endDate, this.customerId, 0, 5000).then(function (data) {
                        _this.loading = false;
                        _this.bagOutData = data.results;
                        _this.print();
                    }).catch(function (err) {
                        console.log(err);
                    });
                }
            }
        }
    }, {
        key: 'getOrderType',
        value: function getOrderType(type) {
            return this.ShipmentService.getOrderType(type);
        }
    }, {
        key: 'convertTime',
        value: function convertTime(microSeconds) {
            return this.ShipmentService.convertTime(microSeconds);
        }
    }, {
        key: 'translateItemStatus',
        value: function translateItemStatus(status) {
            if (!status) return;else return this.$translate.instant(status);
        }
    }, {
        key: 'print',
        value: function print() {
            setTimeout(function () {
                window.print();
            }, 1000);
        }
    }, {
        key: 'translateTransactionType',
        value: function translateTransactionType(tranType) {
            if (!tranType) return;else return this.$translate.instant('shipment.' + tranType);
        }
    }, {
        key: 'setAmount',
        value: function setAmount(obj) {
            if (!obj) return;
            return obj.formattedLoadedAmount !== null ? obj.formattedLoadedAmount : obj.formattedAmount;
            // const status = ['Hold'];

            // if (status.includes(this.translateItemStatus(obj.status))) {
            //     return obj.formattedLoadedAmount !== null ? obj.formattedLoadedAmount : obj.formattedAmount;
            // }
            // else return obj.formattedLoadedAmount
        }
    }]);
    return PrintController;
}();

exports.default = PrintController;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lock_open_errors = __webpack_require__(1771);

var _lock_open_errors2 = _interopRequireDefault(_lock_open_errors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementLockOpenErrorsModule = angular.module('branchManagementLockOpenErrors', []).component('branchManagementLockOpenErrors', _lock_open_errors2.default).name;

exports.default = branchManagementLockOpenErrorsModule;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lock_open_errors = __webpack_require__(2691);

var _lock_open_errors2 = _interopRequireDefault(_lock_open_errors);

var _lock_open_errors3 = __webpack_require__(1772);

var _lock_open_errors4 = _interopRequireDefault(_lock_open_errors3);

__webpack_require__(2975);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementLockOpenErrorsComponent = {
  restrict: "E",
  bindings: {},
  template: _lock_open_errors2.default,
  controller: _lock_open_errors4.default
};

exports.default = branchManagementLockOpenErrorsComponent;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LockOpenErrorsController = function () {
  /*@ngInject*/
  LockOpenErrorsController.$inject = ["Auth", "User", "Modal", "LockOpenErrorService", "UserBranchService", "Navigation", "$q", "$translate", "AtmCodesManagementService", "$state", "ResetAtmCodeService", "$rootScope"];
  function LockOpenErrorsController(Auth, User, Modal, LockOpenErrorService, UserBranchService, Navigation, $q, $translate, AtmCodesManagementService, $state, ResetAtmCodeService, $rootScope) {
    (0, _classCallCheck3.default)(this, LockOpenErrorsController);

    this.Auth = Auth;
    this.User = User;
    this.Modal = Modal;
    this.LockOpenErrorService = LockOpenErrorService;
    this.UserBranchService = UserBranchService;
    this.Navigation = Navigation;
    this.$q = $q;
    this.$translate = $translate;
    this.AtmCodesManagementService = AtmCodesManagementService;
    this.$state = $state;
    this.ResetAtmCodeService = ResetAtmCodeService;
    this.$rootScope = $rootScope;

    this.model = {
      branchObj: {
        results: [],
        totalRecords: 0
      },
      lockTypeObj: {
        results: [],
        totalRecords: 0
      },
      locationIdObj: {
        results: [],
        totalRecords: 0
      },
      ErrorObj: {
        results: [],
        totalRecords: 0
      },
      loggedInUser: User.getUser().id,
      branch: '',
      locationId: '',
      error: '',
      lockType: '',
      currentBranch: User.getUser().branchId,
      atmCodeList: [],
      loading: false,
      isExporting: false,
      dateRangeOption: {
        startDate: null,
        endDate: null
      },
      dateRangPickerOptions: {},
      dateRangPickerOptionsfor: {}
    };
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/lock-open-errors');
  }

  (0, _createClass3.default)(LockOpenErrorsController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$q.all([this.UserBranchService.getUserBranches(this.model.loggedInUser)]).then(function (data) {
        _this.model.branchObj.results = data[0].results;
        _this.model.branchObj.results.forEach(function (branch) {
          branch.ticked = true;
        });

        _this.setDateRangeOptions('dateRangPickerOptionsfor');
        // this.model.dateRangeOption.startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
        // this.model.dateRangeOption.endDate = moment().endOf('week').format('YYYY-MM-DD HH:mm:ss');

        setTimeout(function () {
          _this.getATMCodes().then(function () {
            _this.model.atmCodeList.forEach(function (obj) {
              if (obj.lockType) _this.model.lockTypeObj.results.push({ Key: obj.lockType, Value: obj.lockType });
              _this.model.locationIdObj.results.push({ Key: obj.locationId, Value: obj.locationId });
              _this.model.ErrorObj.results.push({ Key: obj.message, Value: obj.message });
            });

            _this.model.lockTypeObj.results = _.uniqBy(_this.model.lockTypeObj.results, 'Key');
            _this.model.locationIdObj.results = _.uniqBy(_this.model.locationIdObj.results, 'Key');
            _this.model.ErrorObj.results = _.uniqBy(_this.model.ErrorObj.results, 'Key');
            _this.model.lockTypeObj.totalRecords = _this.model.lockTypeObj.results.length;
            _this.model.locationIdObj.totalRecords = _this.model.locationIdObj.results.length;
            _this.model.ErrorObj.totalRecords = _this.model.ErrorObj.results.length;
          });
        });
      }).catch(function (err) {
        console.log(err);
        _this.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: 'getATMCodes',
    value: function getATMCodes() {
      var _this2 = this;

      var branchIds = this.model.branch.map(function (b) {
        return b.branchId;
      });
      var startDate = this.getStartDate();
      var endDate = this.getEndDate();

      this.model.loading = true;
      return this.LockOpenErrorService.getFailedToOpenLocks(branchIds, startDate, endDate).then(function (data) {
        _this2.model.atmCodeList = _.orderBy(data.results, ['createdAt'], ['desc']);
      }).catch(function (err) {
        console.log(err);
        _this2.Modal.errorModal(err.data.message);
      }).finally(function () {
        _this2.model.loading = false;
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      setTimeout(function () {
        _this3.getATMCodes();
      });
    }
  }, {
    key: 'resetBranchSelection',
    value: function resetBranchSelection() {
      var _this4 = this;

      this.model.branchObj.results.forEach(function (branch) {
        if (branch.branchId == _this4.model.currentBranch) {
          branch.ticked = true;
        } else {
          branch.ticked = false;
        }
      });
    }
  }, {
    key: 'filterRecords',
    value: function filterRecords() {
      var branch = this.model.branch;
      var locationId = this.model.locationId ? this.model.locationId.Value : null;
      var lockType = this.model.lockType ? this.model.lockType.Value : null;
      var error = this.model.error ? this.model.error.Value : null;

      return function (row) {

        function filterByBranchId() {
          if (branch.length) return branch.some(function (data) {
            return row['branchId'].indexOf(data.branchId) > -1;
          });else return row['branchId'].indexOf('') > -1;
        }

        function filterByLocationId() {
          if (locationId) return row['locationId'] && row['locationId'].indexOf(locationId) > -1;else return row;
        }

        function filterByLockType() {
          if (lockType) return row['lockType'] && row['lockType'].indexOf(lockType) > -1;else return row;
        }

        function filterByError() {
          if (error) return row['message'] && row['message'].indexOf(error) > -1;else return row;
        }

        return filterByBranchId() && filterByLocationId() && filterByLockType() && filterByError();
      };
    }
  }, {
    key: 'fixAtmCode',
    value: function fixAtmCode(atmCodeObj) {
      var _this5 = this;

      if (this.allowOnce) return;
      this.allowOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('resetAtmCode.delete_open_code_error_message'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this5.allowOnce = true;
          _this5.delete(atmCodeObj, _this5.allowOnce);
          modal.close();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this5.allowOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'delete',
    value: function _delete(atmCodeObj, allowOnce) {
      var _this6 = this;

      this.allowOnce = allowOnce;
      this.model.isDeleting = true;
      this.ResetAtmCodeService.deleteAtmCode(atmCodeObj.cacheKey, atmCodeObj.branchId).then(function (res) {
        setTimeout(function () {
          _this6.getATMCodes(); // reload data after delete
        }, 500);
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this6.allowOnce = false;
        _this6.model.isDeleting = false;
      });
    }
  }, {
    key: 'exportData',
    value: function exportData() {
      var _this7 = this;

      var reportPrefix = 'Lock_Open_Errors(' + moment().format('YYYY-MM-DD_HH:mm') + ')';
      var branchIds = this.model.branch.map(function (b) {
        return b.branchId;
      });
      var startDate = this.getStartDate();
      var endDate = this.getEndDate();

      this.model.isExporting = true;

      this.LockOpenErrorService.exportFailedToOpenLock(branchIds, startDate, endDate).then(function (data) {
        _this7.downloadFile(reportPrefix, data.reportData);
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this7.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this7.model.isExporting = false;
      });
    }
  }, {
    key: 'downloadFile',
    value: function downloadFile(reportPrefix, reportData) {
      var fileName = reportPrefix.concat('.csv');
      var a = document.createElement("a");
      document.body.appendChild(a);
      var file = new Blob([reportData], { type: 'application/csv' });
      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(locationId) {
      return this.Navigation.goToLocationTab(locationId);
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      this.model.dateRangeOption = {};
      this.model.locationId = '';
      this.model.error = '';
      this.model.lockType = '';
    }
  }, {
    key: 'setDateRangeOptions',
    value: function setDateRangeOptions(modelValue) {
      var _this8 = this;

      this.model[modelValue] = {
        autoApply: true,
        eventHandlers: {
          'apply.daterangepicker': function applyDaterangepicker() {
            _this8.getATMCodes();
          }
        },
        ranges: {
          'Today': [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
          'Current Week': [moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')]
          // 'Current Month': [
          //   moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          //   moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
          // ],
        }
      };
    }
  }, {
    key: 'getStartDate',
    value: function getStartDate() {
      return this.model.dateRangeOption.startDate ? moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }
  }, {
    key: 'getEndDate',
    value: function getEndDate() {
      return this.model.dateRangeOption.endDate ? moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }
  }, {
    key: 'translateOTCCompanyName',
    value: function translateOTCCompanyName(companyName) {
      if (!companyName) return;
      return this.$translate.instant('location.' + companyName);
    }
  }, {
    key: 'goToUserTab',
    value: function goToUserTab(userId) {
      if (!userId) return;
      this.Navigation.goToUserTab(userId, null);
    }
  }]);
  return LockOpenErrorsController;
}();

exports.default = LockOpenErrorsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mileage_report = __webpack_require__(1774);

var _mileage_report2 = _interopRequireDefault(_mileage_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mileageReportModule = angular.module('mileageReport', []).component('mileageReportComponent', _mileage_report2.default).name;

exports.default = mileageReportModule;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mileage_report = __webpack_require__(2692);

var _mileage_report2 = _interopRequireDefault(_mileage_report);

var _mileage_report3 = __webpack_require__(1775);

var _mileage_report4 = _interopRequireDefault(_mileage_report3);

__webpack_require__(2976);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mileageReportComponent = {
    restrict: "E",
    bindings: {},
    template: _mileage_report2.default,
    controller: _mileage_report4.default
};
exports.default = mileageReportComponent;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MileageReportController = function () {
  /*@ngInject*/
  function MileageReportController() {
    (0, _classCallCheck3.default)(this, MileageReportController);
  }

  (0, _createClass3.default)(MileageReportController, [{
    key: "$onInit",
    value: function $onInit() {}
  }]);
  return MileageReportController;
}();

exports.default = MileageReportController;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _monthly_report = __webpack_require__(1777);

var _monthly_report2 = _interopRequireDefault(_monthly_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementMonthlyReportModule = angular.module('branchManagementMonthlyReport', []).component('branchManagementMonthlyReport', _monthly_report2.default).name;

exports.default = branchManagementMonthlyReportModule;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _monthly_report = __webpack_require__(2693);

var _monthly_report2 = _interopRequireDefault(_monthly_report);

var _monthly_report3 = __webpack_require__(1778);

var _monthly_report4 = _interopRequireDefault(_monthly_report3);

__webpack_require__(2977);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementMonthlyReportComponent = {
    restrict: "E",
    binding: {},
    template: _monthly_report2.default,
    controller: _monthly_report4.default
};

exports.default = branchManagementMonthlyReportComponent;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MonthlyReportController = function () {
    /*@ngInject*/
    MonthlyReportController.$inject = ["Auth", "$state", "User", "SetupService", "MonthlyReportService", "DateUtil", "$translate", "$location", "$q", "Modal", "$scope", "$rootScope"];
    function MonthlyReportController(Auth, $state, User, SetupService, MonthlyReportService, DateUtil, $translate, $location, $q, Modal, $scope, $rootScope) {
        (0, _classCallCheck3.default)(this, MonthlyReportController);

        this.$rootScope = $rootScope;
        this.model = {
            startVaultDate: "",
            endVaultDate: "",
            branch: User.getUser().branchId,
            monthlyReport: [],
            search: "",
            dateRange: {
                startDate: null,
                endDate: null
            }
        };
        this.MonthlyReportService = MonthlyReportService;
        this.SetupService = SetupService;
        this.DateUtil = DateUtil;
        this.$q = $q;
        this.sortColumn = "vaultDate";
        this.reverseSort = false;
        this.reportPrefix = 'MonthlyReport';
        this.Modal = Modal;

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: _app2.default.defaultPageLimit,
            maxPages: 10
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/monthly-report');
    }

    (0, _createClass3.default)(MonthlyReportController, [{
        key: 'loadPermission',
        value: function loadPermission() {
            var _this = this;

            this.acl = {};
            this.hasACL = {};

            [].forEach(function (permissionKey) {
                _this.acl[permissionKey] = _this.User.getACL(permissionKey);

                _this.hasACL[permissionKey] = {};

                _this.acl[permissionKey].forEach(function (permission) {
                    _this.hasACL[permissionKey][permission] = true;
                });
            });
        }
    }, {
        key: 'setDateRange',
        value: function setDateRange(date) {
            var _this2 = this;

            var currentVaultDate = date || moment();
            this.model.dateRangPickerOptions = {
                autoApply: true,
                maxDate: moment(currentVaultDate).endOf('day').format('YYYY-MM-DD'),
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this2.pagination.page = 1;
                        _this2.generateReport(_this2.model.dateRange);
                    }
                },
                ranges: {
                    'Today': [moment(currentVaultDate).format('YYYY-MM-DD'), moment(currentVaultDate).format('YYYY-MM-DD')],
                    'Current Week': [moment(currentVaultDate).startOf('week').format('YYYY-MM-DD'), moment(currentVaultDate).endOf('week').format('YYYY-MM-DD')],
                    'Current Month': [moment(currentVaultDate).startOf('month').format('YYYY-MM-DD'), moment(currentVaultDate).endOf('month').format('YYYY-MM-DD')]
                }
            };
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this3 = this;

            this.$q.all([this.SetupService.get(this.model.branch)]).then(function (data) {
                _this3.currentVaultDate = _this3.DateUtil.convertToDate(data[0].currentVaultDate);
                _this3.vaultDate = moment(_this3.currentVaultDate).format('YYYY-MM-DD');
                _this3.setDateRange(_this3.vaultDate);
                _this3.model.dateRange.startDate = moment(_this3.currentVaultDate).format('YYYY-MM-DD');
                _this3.model.dateRange.endDate = moment(_this3.currentVaultDate).endOf('day').format('YYYY-MM-DD');
            }).then(function () {
                _this3.loadPermission();
                _this3.generateReport();
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'generateReport',
        value: function generateReport(date) {
            var _this4 = this;

            this.startDate = moment(this.model.dateRange.startDate).format('YYYY-MM-DD');
            this.endDate = moment(this.model.dateRange.endDate).format('YYYY-MM-DD');
            this.model.loading = true;

            this.MonthlyReportService.getMonthlyReport(this.startDate, this.endDate, this.model.search, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit).then(function (data) {
                _this4.model.loading = false;
                _this4.model.monthlyReport = data.results;
                _this4.pagination.total = data.totalRecord;
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this4.model.loading = false;
            });
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.generateReport();
        }
    }, {
        key: 'search',
        value: function search() {
            this.pagination.page = 1;
            this.generateReport();
        }
    }, {
        key: 'SortData',
        value: function SortData(column) {
            this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
            this.sortColumn = column;
        }

        // export data to CSV file

    }, {
        key: 'exportToCSV',
        value: function exportToCSV() {
            var _this5 = this;

            var startDate = moment(this.model.dateRange.startDate).format('YYYY-MM-DD');
            var endDate = moment(this.model.dateRange.endDate).format('YYYY-MM-DD');
            this.loading = true;
            this.MonthlyReportService.exportDataToCSV(this.model.search, startDate, endDate, 0, 200000).then(function (data) {
                _this5.date = moment.utc().format('DDMMYY');
                _this5.fileName = _this5.reportPrefix.concat('_', _this5.date, '.csv');
                var a = document.createElement("a");
                document.body.appendChild(a);
                var file = new Blob([data.reportData], { type: 'application/csv' });
                var fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = _this5.fileName;
                a.click();
                _this5.loading = false;
            }).catch(function (err) {
                _this5.loading = false;
                if (err && err.data && err.data.message) {
                    _this5.Modal.errorModal(err.data.message);
                }
                console.log(err);
            });
        }
    }]);
    return MonthlyReportController;
}();

exports.default = MonthlyReportController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _orders = __webpack_require__(1780);

var _orders2 = _interopRequireDefault(_orders);

var _print = __webpack_require__(1782);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementOrdersModule = angular.module('branchManagementOrdersHistory', [_print2.default]).component('branchManagementOrdersHistory', _orders2.default).name;

exports.default = branchManagementOrdersModule;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _orders = __webpack_require__(2694);

var _orders2 = _interopRequireDefault(_orders);

var _orders3 = __webpack_require__(1781);

var _orders4 = _interopRequireDefault(_orders3);

__webpack_require__(2978);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementOrdersComponent = {
  restrict: "E",
  bindings: {},
  template: _orders2.default,
  controller: _orders4.default
};

exports.default = branchManagementOrdersComponent;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrdersController = function () {
    /*@ngInject*/
    OrdersController.$inject = ["Auth", "$state", "User", "$translate", "$location", "$q", "Modal", "$scope", "BranchFundingSourceService", "SetupService", "DateUtil", "AtmResidualService", "$stateParams", "DataCounter", "$rootScope", "FetchReactData", "$timeout"];
    function OrdersController(Auth, $state, User, $translate, $location, $q, Modal, $scope, BranchFundingSourceService, SetupService, DateUtil, AtmResidualService, $stateParams, DataCounter, $rootScope, FetchReactData, $timeout) {
        var _this = this;

        (0, _classCallCheck3.default)(this, OrdersController);

        this.locationSearchObj = function (searchKey) {
            searchKey = searchKey || '';
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: _this.model.branch
                    }, {
                        group: {
                            rules: [{
                                field: 'locationId',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'sourceName',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        };

        this.$translate = $translate;
        this.Auth = Auth;
        this.$state = $state;
        this.User = User;
        this.$scope = $scope;
        this.Modal = Modal;
        this.FetchReactData = FetchReactData;
        this.$q = $q;
        this.$timeout = $timeout;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.SetupService = SetupService;
        this.DateUtil = DateUtil;
        this.$stateParams = $stateParams;
        this.AtmResidualService = AtmResidualService;
        this.DataCounter = DataCounter;
        this.countedResidualShipments = [];
        this.errorShipments = [];
        this.$rootScope = $rootScope;

        this.model = {
            branch: User.getUser().branchId,
            search: null,
            ATM: "",
            date: "",
            atmResidual: [],
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            stats: ['inProcess'],
            dateRangeOptions: {
                startDate: null,
                endDate: null
            },
            dateRange: {},
            currencyFilter: 'ALL'
        };

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.completedPagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.pendingPagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.inProcessPagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.errorPagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.stats = {
            completed: 'completed',
            pending: 'pending',
            errors: 'errors',
            inProcess: 'inProcess'
        };

        this.exportLoading = {
            completed: false,
            pending: false,
            errors: false,
            inProcess: false
        };

        this.locationLists = [];
        this.locationData = "";
        this.amount = 0;
        this.shipmentInProcessData = [];
        this.cursor = 0;
        this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/orders');
    }

    (0, _createClass3.default)(OrdersController, [{
        key: 'setDateRangeOptions',
        value: function setDateRangeOptions(date, dateRangeOption, modelVal) {
            var _this2 = this;

            var currentVaultDate = moment(date).format() || moment();
            this.model[modelVal] = {
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this2.loadData();
                    }
                },
                ranges: {
                    'Running 45 Days': [moment(currentVaultDate).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).add(14, 'days').format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Year': [moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: 'loadPermission',
        value: function loadPermission() {
            var _this3 = this;

            this.acl = {};
            this.hasACL = {};

            ['branch_mgmt_orders'].forEach(function (permissionKey) {
                var aclList = _this3.User.getACL(permissionKey);
                _this3.acl[permissionKey] = Array.isArray(aclList) ? aclList : [];

                _this3.hasACL[permissionKey] = {};

                _this3.acl[permissionKey].forEach(function (permission) {
                    _this3.hasACL[permissionKey][permission] = true;
                });
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this4 = this;

            this.loadPermission();
            this.moment = moment;
            var transitionData = this.FetchReactData.getTransitionData();
            this.locationData = transitionData || this.DataCounter.getData();

            this.$q.all([this.SetupService.get(this.model.branch)]).then(function (data) {
                _this4.vaultDate = _this4.DateUtil.convertToDate(data[0].currentVaultDate);
                _this4.setDateRangeOptions(_this4.vaultDate, _this4.model.dateRangeOptions, 'dateRange');
                if (_this4.locationData && _this4.locationData.vaultDate && _this4.locationData.isRedirected) {
                    _this4.model.dateRangeOptions.startDate = moment(_this4.locationData.vaultDate).subtract(30, 'days').format('YYYY-MM-DD');
                    _this4.model.dateRangeOptions.endDate = moment(_this4.locationData.vaultDate).add(14, 'days').format('YYYY-MM-DD');
                } else {
                    _this4.model.dateRangeOptions.startDate = moment(_this4.vaultDate).subtract(30, 'days').format('YYYY-MM-DD');
                    _this4.model.dateRangeOptions.endDate = moment(_this4.vaultDate).add(14, 'days').format('YYYY-MM-DD');
                }
                var available = Array.isArray(data[0].availableCurrencyIds) ? data[0].availableCurrencyIds : [data[0].currencyId];
                _this4.currencyOptions = [{ id: 'ALL', name: _this4.$translate.instant('common.All') }].concat(available.map(function (id) {
                    return { id: id, name: id };
                }));
                _this4.model.currencyFilter = 'ALL';
            }).then(function () {
                _this4.getFundingSource('', 0).then(function (res) {
                    if (_this4.$stateParams.id) {
                        _this4.model.fundingSource = {
                            Key: res.results[0].locationId + " | " + res.results[0].sourceName, Value: res.results[0].locationId, Id: res.results[0].id
                        };
                        _this4.model.search = _this4.$stateParams.id;
                        _this4.countedResiduals();
                        // this.errorShipmentList();
                    } else {
                        _this4.model.search = null;
                    }
                    return res.results;
                }).then(function (fundingSourceData) {
                    _this4.loadOrderHistory(fundingSourceData);
                });
            }).catch(function (err) {
                console.log(err);
            });
        }

        // Get fundingSource

    }, {
        key: 'getFundingSource',
        value: function getFundingSource(searchKey, offset) {
            var _this5 = this;

            var defer = this.$q.defer();
            var loadLocationData = this.locationSearchObj(searchKey);
            this.BranchFundingSourceService.all(loadLocationData, offset, _app2.default.defaultPageLimit, this.customerId).then(function (data) {
                if (offset === 0) {
                    _this5.totalRecords = data.total;
                    _this5.locationLists = _this5.mappingLocationData(data.results);
                } else {
                    var locations = _this5.mappingLocationData(data.results);
                    _this5.locationLists = _this5.locationLists.concat(locations);
                }
                defer.resolve(data);
            });
            return defer.promise;
        }
    }, {
        key: 'mappingLocationData',
        value: function mappingLocationData(locations) {
            return locations.map(function (data) {
                return {
                    Key: data.locationId + " | " + data.sourceName,
                    Value: data.locationId,
                    Id: data.id
                };
            });
        }
    }, {
        key: 'countedResiduals',
        value: function countedResiduals() {
            var _this6 = this;

            if (!this.model.fundingSource) {
                this.countedResidualShipments = [];
                this.completedPagination.total = 0;
                return this.$q.resolve();
            }

            this.loading = true;
            var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
            var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
            var currencyId = this.model.currencyFilter === 'ALL' ? null : this.model.currencyFilter;
            var isFromRedirect = this.locationData && this.locationData.isRedirected && this.locationData.orderNo;

            return this.AtmResidualService.orderHistory(this.model.branch, startDate, endDate, this.model.fundingSource.Id, this.customerId, this.model.search, (this.completedPagination.page - 1) * this.completedPagination.pageLimit, this.completedPagination.pageLimit, currencyId).then(function (data) {
                _this6.loading = false;
                _this6.countedResidualShipments = data.completedShipment;
                _this6.completedPagination.total = data.totalRecords;
                if (_this6.model.search && _this6.model.stats.length === 1 && (!_this6.countedResidualShipments || _this6.countedResidualShipments.length === 0)) {
                    if (_this6.cursor >= 2) return;
                    _this6.model.stats = [_this6.stats.pending];
                    _this6.cursor++;
                    return _this6.unpackedShipmentList();
                }

                if (_this6.countedResidualShipments) {
                    _this6.cursor = 0;
                }
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    return _this6.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                if (!isFromRedirect) {
                    _this6.resetFilter();
                    _this6.resetData();
                } else {
                    // Clear redirect flag but keep the search value
                    if (_this6.locationData) {
                        _this6.locationData = _this6.DataCounter.setData();
                        _this6.FetchReactData.clearTransitionData();
                    }
                }
            });
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            this.completedPagination.page = 1;
            this.pendingPagination.page = 1;
            this.inProcessPagination.page = 1;
            this.errorPagination.page = 1;
            this.model.search = this.model.search || null;

            var promises = [];
            if (this.model.stats.includes(this.stats.errors)) {
                promises.push(this.errorShipmentList());
            }
            if (this.model.stats.includes(this.stats.completed)) {
                promises.push(this.countedResiduals());
            }
            if (this.model.stats.includes(this.stats.pending)) {
                promises.push(this.unpackedShipmentList());
            }
            if (this.model.stats.includes(this.stats.inProcess)) {
                promises.push(this.shipmentInProcessList());
            }
            return this.$q.all(promises);
        }

        // Display sum of all cell value

    }, {
        key: 'totalAmount',
        value: function totalAmount() {
            var _this7 = this;

            this.model.actualLoadTotal = 0;
            this.model.crvTotal = 0;
            this.model.requestLoadTotal = 0;
            this.model.countedResidualTotal = 0;
            this.model.varianceTotal = 0;

            return this.countedResidualShipments.map(function (data, index) {
                _this7.model.requestLoadTotal += data.amountLoadRequested ? data.amountLoadRequested : 0;
                _this7.model.actualLoadTotal += data.amountLoadActual ? data.amountLoadActual : 0;
                _this7.model.crvTotal += data.amountCRV ? data.amountCRV : 0;
                _this7.model.countedResidualTotal += data.amountCounted ? data.amountCounted : 0;
                _this7.model.varianceTotal += data.variance ? data.variance : 0;
            });
        }

        // redirect to items page

    }, {
        key: 'goToItemHistory',
        value: function goToItemHistory(trackingId) {
            this.$state.go('branchManagement.items', {
                id: trackingId
            });
        }
    }, {
        key: 'loadOrderHistory',
        value: function loadOrderHistory(data) {
            var _this8 = this;

            if (!this.locationData || !this.locationData.isRedirected) return;
            if (this.locationData.fundingSourceId) {
                var fundingSource = _lodash2.default.find(data, { id: this.locationData.fundingSourceId });
                if (fundingSource) {
                    return this.applyOrderHistoryFundingSource(fundingSource);
                }
                return this.BranchFundingSourceService.get(this.locationData.fundingSourceId).then(function (res) {
                    return _this8.applyOrderHistoryFundingSource(res.results);
                }).catch(function () {
                    return _this8.applyOrderHistoryFundingSource(data[0]);
                });
            }
            return this.applyOrderHistoryFundingSource(data[0]);
        }
    }, {
        key: 'applyOrderHistoryFundingSource',
        value: function applyOrderHistoryFundingSource(fundingSource) {
            this.model.fundingSource = {
                Key: fundingSource.locationId + " | " + fundingSource.sourceName,
                Value: fundingSource.locationId,
                Id: fundingSource.id
            };
            this.model.search = this.locationData.orderNo;
            if (this.locationData.isCounted) {
                this.model.stats = [this.stats.completed];
                return this.countedResiduals();
            } else if (this.locationData.isInProcess) {
                this.model.stats = [this.stats.inProcess];
                return this.shipmentInProcessList();
            } else {
                this.model.stats = [this.stats.pending];
                return this.unpackedShipmentList();
            }
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var promises = [];
            if (this.model.stats.includes(this.stats.errors)) promises.push(this.errorShipmentList());
            if (this.model.stats.includes(this.stats.completed)) promises.push(this.countedResiduals());
            if (this.model.stats.includes(this.stats.pending)) promises.push(this.unpackedShipmentList());
            if (this.model.stats.includes(this.stats.inProcess)) promises.push(this.shipmentInProcessList());
            return this.$q.all(promises);
        }
    }, {
        key: 'completedPageChange',
        value: function completedPageChange() {
            this.countedResiduals();
        }
    }, {
        key: 'pendingPageChange',
        value: function pendingPageChange() {
            this.unpackedShipmentList();
        }
    }, {
        key: 'inProcessPageChange',
        value: function inProcessPageChange() {
            this.shipmentInProcessList();
        }
    }, {
        key: 'errorPageChange',
        value: function errorPageChange() {
            this.errorShipmentList();
        }
    }, {
        key: 'filterData',
        value: function filterData() {
            this.model.search = this.model.search || null;
            this.completedPagination.page = 1;
            this.pendingPagination.page = 1;
            this.inProcessPagination.page = 1;
            this.errorPagination.page = 1;
            this.loadData();
        }

        // load data of shipment request error (SHIPMENTREQUEST.result = 'error') 

    }, {
        key: 'errorShipmentList',
        value: function errorShipmentList() {
            var _this9 = this;

            if (!this.model.fundingSource) {
                this.errorShipments = [];
                this.errorPagination.total = 0;
                return this.$q.resolve();
            }

            this.model.loading = true;
            var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY/MM/DD');
            var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY/MM/DD');
            var currencyId = this.model.currencyFilter === 'ALL' ? null : this.model.currencyFilter;

            return this.AtmResidualService.errorShipmentList(this.model.branch, this.model.fundingSource.Id, startDate, endDate, this.model.search, (this.errorPagination.page - 1) * this.errorPagination.pageLimit, this.errorPagination.pageLimit, currencyId).then(function (data) {
                _this9.model.loading = false;
                _this9.errorPagination.total = data.totalRecords;
                _this9.errorShipments = data.errorShipment;
            }).then(function () {
                _this9.resetFilter();
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    return _this9.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'jumpToNextPage',
        value: function jumpToNextPage() {
            this.errorShipmentList();
        }
    }, {
        key: 'tabSelection',
        value: function tabSelection(selectedValue) {
            var hadActiveSearch = !!this.model.search;
            if (hadActiveSearch) {
                this.clearSearch();
            }

            var index = this.model.stats.indexOf(selectedValue);
            if (index === -1) {
                this.model.stats.unshift(selectedValue);

                if (hadActiveSearch) {
                    // If there was an active search, reload all selected tabs to show all data
                    this.loadData();
                } else {
                    // Only fetch data for the newly selected tab
                    this.model.search = this.model.search || null;
                    if (selectedValue === this.stats.errors) {
                        this.errorPagination.page = 1;
                        this.errorShipmentList();
                    } else if (selectedValue === this.stats.completed) {
                        this.completedPagination.page = 1;
                        this.countedResiduals();
                    } else if (selectedValue === this.stats.pending) {
                        this.pendingPagination.page = 1;
                        this.unpackedShipmentList();
                    } else if (selectedValue === this.stats.inProcess) {
                        this.inProcessPagination.page = 1;
                        this.shipmentInProcessList();
                    }
                }
            } else {
                if (this.model.stats.length > 1) {
                    this.model.stats.splice(index, 1);
                    if (hadActiveSearch) {
                        // Reload remaining tabs if search was cleared during deselection
                        this.loadData();
                    }
                }
            }
        }
    }, {
        key: 'unpackedShipmentList',
        value: function unpackedShipmentList() {
            var _this10 = this;

            var self = this;
            if (!self.model.fundingSource) {
                self.pendingPackShipments = {};
                self.pendingPagination.total = 0;
                return self.$q.resolve();
            }

            self.gettingUnPackedShp = true;
            var startDate = moment(self.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
            var endDate = moment(self.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
            var currencyId = self.model.currencyFilter === 'ALL' ? null : self.model.currencyFilter;

            return self.AtmResidualService.unpackedShipmentList(self.model.branch, startDate, endDate, self.model.fundingSource.Id, self.customerId, self.model.search, self.pendingPagination.pageLimit, (self.pendingPagination.page - 1) * self.pendingPagination.pageLimit, currencyId).then(function (data) {
                self.pendingPackShipments = data;
                self.pendingPagination.total = data.totalRecords;
                if (_this10.model.search && _this10.model.stats.length === 1 && _this10.pendingPackShipments.results.length === 0) {
                    if (_this10.cursor >= 2) return;
                    _this10.model.stats = [_this10.stats.inProcess];
                    _this10.cursor++;
                    return _this10.shipmentInProcessList();
                }

                if (_this10.pendingPackShipments.results.length > 0) {
                    _this10.cursor = 0;
                }
                _this10.resetFilter();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    self.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                self.gettingUnPackedShp = false;
                _this10.resetData();
            });
        }
    }, {
        key: 'resetFilter',
        value: function resetFilter() {
            if (this.locationData) {
                this.locationData.isRedirected = false;
                this.locationData = this.DataCounter.setData();
                this.FetchReactData.clearTransitionData();
            }
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(locationId) {
            var obj = {
                locationId: locationId,
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.locations');
        }
    }, {
        key: 'shipmentInProcessList',
        value: function shipmentInProcessList() {
            var _this11 = this;

            var self = this;
            if (!self.model.fundingSource) {
                self.shipmentInProcessData = [];
                self.inProcessPagination.total = 0;
                return self.$q.resolve();
            }

            self.loadInProcessShpList = true;
            var startDate = moment(self.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
            var endDate = moment(self.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
            var currencyId = self.model.currencyFilter === 'ALL' ? null : self.model.currencyFilter;

            return self.AtmResidualService.shipmentInProcess(self.model.branch, startDate, endDate, self.model.fundingSource.Id, this.customerId, self.model.search, (self.inProcessPagination.page - 1) * self.inProcessPagination.pageLimit, self.inProcessPagination.pageLimit, currencyId).then(function (data) {
                self.shipmentInProcessData = data.results;
                self.inProcessPagination.total = data.totalRecords;
                if (_this11.model.search && _this11.model.stats.length === 1 && (!_this11.shipmentInProcessData || _this11.shipmentInProcessData.length === 0)) {
                    if (_this11.cursor >= 2) return;
                    _this11.model.stats = [_this11.stats.completed];
                    _this11.cursor++;
                    return _this11.countedResiduals();
                }

                if (_this11.shipmentInProcessData) {
                    _this11.cursor = 0;
                }
                _this11.resetFilter();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    self.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                self.loadInProcessShpList = false;
                _this11.resetData();
            });
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            if (this.cursor >= 2) {
                this.cursor = 0;
                this.model.search = null;
                this.model.stats = [this.stats.inProcess];
                this.loadData();
            }
        }
    }, {
        key: 'clearSearch',
        value: function clearSearch() {
            this.model.search = null;
        }
    }, {
        key: 'downloadFile',
        value: function downloadFile(reportPrefix, reportData) {
            var fileName = reportPrefix.concat('.csv');
            var a = document.createElement("a");
            document.body.appendChild(a);
            var file = new Blob([reportData], { type: 'application/csv' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
            document.body.removeChild(a);
        }
    }, {
        key: 'exportToCSV',
        value: function exportToCSV(tab) {
            var _this12 = this;

            if (!this.model.fundingSource) {
                return;
            }

            var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
            var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD');
            var currencyId = this.model.currencyFilter === 'ALL' ? null : this.model.currencyFilter;

            this.exportLoading[tab] = true;
            this.AtmResidualService.exportOrdersCSV(tab, this.model.branch, startDate, endDate, this.model.fundingSource.Id, this.customerId, this.model.search, currencyId).then(function (data) {
                if (data.status && data.reportData) {
                    var fileName = "";
                    if (tab === _this12.stats.inProcess) {
                        fileName = 'In_Process_Orders_' + startDate + '_to_' + endDate;
                    } else if (tab === _this12.stats.completed) {
                        fileName = 'Completed_Orders_' + startDate + '_to_' + endDate;
                    } else if (tab === _this12.stats.pending) {
                        fileName = 'Pending_Orders_' + startDate + '_to_' + endDate;
                    } else if (tab === _this12.stats.errors) {
                        fileName = 'Error_Orders_' + startDate + '_to_' + endDate;
                    }
                    _this12.downloadFile(fileName, data.reportData);
                } else {
                    _this12.Modal.errorModal(data.message || "No records found to export.");
                }
            }).catch(function (err) {
                console.error(err);
                _this12.Modal.errorModal("An error occurred during export.");
            }).finally(function () {
                _this12.exportLoading[tab] = false;
            });
        }
    }, {
        key: 'print',
        value: function print(tab) {
            if (!this.model.fundingSource) {
                return;
            }

            var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD');
            var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD');

            var obj = {
                branch: this.model.branch,
                startDate: startDate,
                endDate: endDate,
                fundingSourceId: this.model.fundingSource.Id,
                fundingSourceKey: this.model.fundingSource.Key,
                customerId: this.customerId,
                search: this.model.search,
                currencyFilter: this.model.currencyFilter,
                tab: tab,
                totalCount: tab === this.stats.errors ? this.model.pagination.total : this.pagination.total
            };

            var url = this.$state.href('printOrders');
            window.w = window.open(url, '_blank');
            window.w.printData = obj;
        }
    }]);
    return OrdersController;
}();

exports.default = OrdersController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _print = __webpack_require__(1783);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printOrdersModule = angular.module('printOrders', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('printOrders', {
        url: '/print-orders',
        component: 'printOrders',
        params: {
            id: null
        }
    });
}]).component('printOrders', _print2.default).name;

exports.default = printOrdersModule;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ordersPrint = __webpack_require__(2695);

var _ordersPrint2 = _interopRequireDefault(_ordersPrint);

var _print = __webpack_require__(1784);

var _print2 = _interopRequireDefault(_print);

__webpack_require__(2979);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printComponent = {
    template: _ordersPrint2.default,
    controller: _print2.default
};

exports.default = printComponent;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintOrdersController = function () {
    /*@ngInject*/
    PrintOrdersController.$inject = ["$timeout", "AtmResidualService", "$translate"];
    function PrintOrdersController($timeout, AtmResidualService, $translate) {
        (0, _classCallCheck3.default)(this, PrintOrdersController);

        this.$timeout = $timeout;
        this.AtmResidualService = AtmResidualService;
        this.$translate = $translate;
        this.results = [];
        this.loading = false;
        this.tabLabel = '';
    }

    (0, _createClass3.default)(PrintOrdersController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var printData = undefined;
            if (window.opener && window.opener.w && window.opener.w.printData) {
                printData = window.opener.w.printData;
                this.branch = printData.branch;
                this.startDate = printData.startDate;
                this.endDate = printData.endDate;
                this.fundingSourceId = printData.fundingSourceId;
                this.fundingSourceKey = printData.fundingSourceKey;
                this.customerId = printData.customerId;
                this.search = printData.search;
                this.currencyFilter = printData.currencyFilter;
                this.tab = printData.tab;
                this.tabLabel = this.formatTabLabel(this.tab);
                this.totalCount = printData.totalCount;
            }

            if (!this.tab) return;

            var currencyId = this.currencyFilter === 'ALL' ? null : this.currencyFilter;
            var fetchPromise = void 0;

            if (this.tab === 'inProcess') {
                fetchPromise = this.AtmResidualService.shipmentInProcess(this.branch, this.startDate, this.endDate, this.fundingSourceId, this.customerId, this.search, 0, this.totalCount || 10000, currencyId).then(function (data) {
                    _this.results = data.results;
                });
            } else if (this.tab === 'completed') {
                fetchPromise = this.AtmResidualService.orderHistory(this.branch, this.startDate, this.endDate, this.fundingSourceId, this.customerId, this.search, 0, this.totalCount || 10000, currencyId).then(function (data) {
                    _this.results = data.completedShipment;
                });
            } else if (this.tab === 'pending') {
                fetchPromise = this.AtmResidualService.unpackedShipmentList(this.branch, this.startDate, this.endDate, this.fundingSourceId, this.customerId, this.search, this.totalCount || 10000, 0, currencyId).then(function (data) {
                    _this.results = data.results;
                });
            } else if (this.tab === 'errors') {
                var errStartDate = moment(this.startDate).format('YYYY/MM/DD');
                var errEndDate = moment(this.endDate).format('YYYY/MM/DD');
                fetchPromise = this.AtmResidualService.errorShipmentList(this.branch, this.fundingSourceId, errStartDate, errEndDate, this.search, 0, this.totalCount || 10000, currencyId).then(function (data) {
                    _this.results = data.errorShipment;
                });
            }

            if (fetchPromise) {
                this.loading = true;
                fetchPromise.then(function () {
                    _this.$timeout(function () {
                        window.print();
                    }, 1000);
                }).catch(function (err) {
                    console.error(err);
                }).finally(function () {
                    _this.loading = false;
                });
            }
        }
    }, {
        key: 'formatTabLabel',
        value: function formatTabLabel(tab) {
            switch (tab) {
                case 'inProcess':
                    return 'IN PROCESS';
                case 'completed':
                    return 'COMPLETED';
                case 'pending':
                    return 'PENDING';
                case 'errors':
                    return 'ERRORS';
                default:
                    return '';
            }
        }
    }]);
    return PrintOrdersController;
}();

PrintOrdersController.$inject = ['$timeout', 'AtmResidualService', '$translate'];

exports.default = PrintOrdersController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _physical_cash_count = __webpack_require__(1786);

var _physical_cash_count2 = _interopRequireDefault(_physical_cash_count);

var _print = __webpack_require__(1788);

var _print2 = _interopRequireDefault(_print);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementPhysicalCashCountModule = angular.module('branchManagementPhysicalCashCount', [_print2.default]).component('branchManagementPhysicalCashCount', _physical_cash_count2.default).name;

exports.default = branchManagementPhysicalCashCountModule;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _physical_cash_count = __webpack_require__(2696);

var _physical_cash_count2 = _interopRequireDefault(_physical_cash_count);

var _physical_cash_count3 = __webpack_require__(1787);

var _physical_cash_count4 = _interopRequireDefault(_physical_cash_count3);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementPhysicalCashCountComponent = {
  restrict: "E",
  bindings: {},
  template: _physical_cash_count2.default,
  controller: _physical_cash_count4.default
};

exports.default = branchManagementPhysicalCashCountComponent;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhysicalCashCountController = function () {
    /*@ngInject*/
    PhysicalCashCountController.$inject = ["Auth", "$state", "User", "UsersService", "DateUtil", "$translate", "$q", "Modal", "BranchService", "SetupService", "PhysicalCashCountService", "$rootScope"];
    function PhysicalCashCountController(Auth, $state, User, UsersService, DateUtil, $translate, $q, Modal, BranchService, SetupService, PhysicalCashCountService, $rootScope) {
        (0, _classCallCheck3.default)(this, PhysicalCashCountController);

        this.BranchService = BranchService;
        this.UsersService = UsersService;
        this.DateUtil = DateUtil;
        this.Modal = Modal;
        this.SetupService = SetupService;
        this.User = User;
        this.Auth = Auth;
        this.$translate = $translate;
        this.$q = $q;
        this.$state = $state;
        this.PhysicalCashCountService = PhysicalCashCountService;
        this.$rootScope = $rootScope;

        this.model = {
            currentBranch: User.getUser().branchId,
            cashCountObj: {},
            branchCurrentVaultDate: '',
            loading: false,
            physicalCashCountRecord: [],
            commitRecords: false,
            fundingSourceData: [],
            acl: {},
            hasACL: {},
            permissionKey: 'branch_mgmt_physical_cash_count',
            balanceCheckIds: [],
            currency: 'USD',
            loggedInUser: this.User.getUser().id,
            isSupervisor: false,
            isPriorVaultDate: false
        };

        this.accountType = [{
            lable: "Regular",
            value: "regular"
        }, {
            lable: "Emergency",
            value: "emergency"
        }];
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/physical-cash-count');
    }

    (0, _createClass3.default)(PhysicalCashCountController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.model.loading = true;
            this.$q.all([this.SetupService.get(this.model.currentBranch), this.UsersService.checkSupervisor(this.model.loggedInUser)]).then(function (data) {
                var setupData = data[0];
                var userDetails = data[1];

                _this.model.branchCurrentVaultDate = _this.DateUtil.convertToDate(setupData.currentVaultDate);
                _this.model.date = _this.model.branchCurrentVaultDate;
                _this.model.userInfo = userDetails;
                _this.model.isSupervisor = userDetails.supervisor;
                _this.model.maxVaultDate = {
                    minDate: _this.model.date,
                    maxDate: _this.model.branchCurrentVaultDate
                    // maxDate: moment(this.model.branchCurrentVaultDate).add(0, 'days').toDate()
                };
                _this.getFundingSource().then(function () {
                    _this.getRequirementOrBalanceCount();
                    _this.loadPermission();
                }).catch(function (err) {
                    console.log(err);
                    _this.Modal.errorModal(err.data.message);
                });
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                // this.model.loading = false;
            });
        }
    }, {
        key: 'getFundingSource',
        value: function getFundingSource() {
            var _this2 = this;

            return this.PhysicalCashCountService.getFundingSource(this.model.currentBranch).then(function (data) {
                _this2.model.fundingSource = data.results;
                _this2.model.fundingSourceData = _this2.model.fundingSource.map(function (fc) {
                    return { fundingSourceId: fc.fundingSourceId, name: fc.sourceName, currencyId: fc.currencyId };
                });
            });
        }
    }, {
        key: 'getRequirementOrBalanceCount',
        value: function getRequirementOrBalanceCount() {
            var _this3 = this;

            this.model.loading = true;
            var formattedDate = moment(this.model.date).format('YYYY-MM-DD');

            var currentVaultDate = new Date(this.model.branchCurrentVaultDate).getTime();
            var selectedDate = new Date(this.model.date).getTime();
            this.model.isPriorVaultDate = moment(selectedDate).isBefore(currentVaultDate);

            this.PhysicalCashCountService.findRequirementOrBalanceCount(this.model.currentBranch, this.model.fundingSourceData, formattedDate).then(function (results) {
                _this3.model.physicalCashCountData = results;
                _this3.model.denominations = results.denominations;
                _this3.model.fundingSourceStatus = results.fundingSourceStatus;
                _this3.defaultCashCountData();
                _this3.shouldShowLabels();
            }).catch(function (err) {
                console.log(err);
                _this3.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this3.model.balanceCheckIds = [];
                _this3.model.loading = false;
            });
        }
    }, {
        key: 'confirmSupervisor',
        value: function confirmSupervisor(stat) {
            var _this4 = this;

            var entryType = stat === 'edit' ? 'edit-physical-cash-count' : 'physical-cash-count-commit';
            if (this.model.userInfo && this.model.userInfo.supervisor) {
                this.Modal.confirmSupervisor(entryType, null, function (_ref) {
                    var modal = _ref.modal,
                        supId = _ref.supId;

                    _this4.verifyLedgerBalance(supId, stat);
                    modal.close();
                }, function (_ref2) {
                    var modal = _ref2.modal;

                    modal.close();
                });
            } else {
                this.verifyLedgerBalance(this.model.loggedInUser, stat);
            }
        }
    }, {
        key: 'commit',
        value: function commit(userId) {
            var _this5 = this;

            var formattedDate = moment(this.model.date).format('YYYY-MM-DD');

            var data = this.model.physicalCashCountRecord.filter(function (d) {
                return d.status === 'Pending' && d.denominations && d.denominations.length > 0;
            });

            this.model.commitRecords = true;
            return this.PhysicalCashCountService.commitPhysicalCashCount(data, this.model.currentBranch, userId, this.model.currency, null, formattedDate).then(function () {
                _this5.getRequirementOrBalanceCount();
            }).catch(function (err) {
                console.log(err);
                _this5.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this5.model.commitRecords = false;
            });
        }
    }, {
        key: 'verifyLedgerBalance',
        value: function verifyLedgerBalance(userId, stat) {
            var _this6 = this;

            var data = this.model.physicalCashCountRecord.map(function (d) {
                return {
                    denominations: d.denominations,
                    fundingSourceId: d.fundingSourceId,
                    branchId: _this6.model.currentBranch
                };
            });

            this.isCheckForVariance = true;
            this.PhysicalCashCountService.checkForVariance(data).then(function (res) {
                if (res && res.hasVariance) {
                    _this6.Modal.confirm({
                        header: _this6.$translate.instant('common.confirm_title'),
                        message: _this6.$translate.instant('The current count will produce a variance. Are you sure you want to commit with a variance?'),
                        callback: function callback(_ref3) {
                            var modal = _ref3.modal,
                                $scope = _ref3.$scope;

                            _this6.isCommit = true;
                            if (stat === 'edit') {
                                _this6.editPhysicalCashCount(userId);
                            } else {
                                _this6.commit(userId);
                            }
                            modal.close();
                        },
                        negative: function negative(_ref4) {
                            var modal = _ref4.modal;

                            _this6.isCommit = false;
                            modal.close();
                        },
                        type: 'danger'
                    });
                } else {
                    if (stat === 'edit') {
                        _this6.editPhysicalCashCount(userId);
                    } else {
                        _this6.commit(userId);
                    }
                }
            }).catch(function (err) {
                console.log(err);
                _this6.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this6.isCheckForVariance = false;
            });
        }
    }, {
        key: 'calculateTotalAmount',
        value: function calculateTotalAmount(index) {
            var totalDenominationsAmount = 0;
            this.model.physicalCashCountRecord[index].denominations.forEach(function (denom) {
                totalDenominationsAmount = totalDenominationsAmount + (denom.amount || 0);
            });
            this.model.physicalCashCountRecord[index].totalAmount = totalDenominationsAmount;
        }
    }, {
        key: 'calculateAccountBalance',
        value: function calculateAccountBalance(index, accountType, amount) {
            var _this7 = this;

            this.model.physicalCashCountRecord[index].enteredRegularAmount = 0;
            this.model.physicalCashCountRecord[index].enteredEmergencyAmount = 0;

            this.model.physicalCashCountRecord[index].denominations.forEach(function (denom) {
                if (denom.account === 'regular') {
                    _this7.model.physicalCashCountRecord[index].enteredRegularAmount += denom.amount || 0;
                } else if (denom.account === 'emergency') {
                    _this7.model.physicalCashCountRecord[index].enteredEmergencyAmount += denom.amount || 0;
                }

                if (_this7.model.physicalCashCountRecord[index].enteredRegularAmount > _this7.model.physicalCashCountRecord[index].regularBalance) {
                    _this7.model.physicalCashCountRecord[index].regularBalanceError = "Regular Balance Is Out Of Bulk Cash";
                } else {
                    _this7.model.physicalCashCountRecord[index].regularBalanceError = null;
                }

                if (_this7.model.physicalCashCountRecord[index].enteredEmergencyAmount > _this7.model.physicalCashCountRecord[index].emergencyBalance) {
                    _this7.model.physicalCashCountRecord[index].emergencyBalanceError = "Emergency Balance Is Out Of Bulk Cash";
                } else {
                    _this7.model.physicalCashCountRecord[index].emergencyBalanceError = null;
                };

                if (_this7.model.physicalCashCountRecord[index].regularBalanceError && _this7.model.physicalCashCountRecord[index].emergencyBalanceError) {
                    _this7.model.physicalCashCountRecord[index].commonBalanceError = "Regular & Emergency Balance Is Out Of Bulk Cash";
                } else _this7.model.physicalCashCountRecord[index].commonBalanceError = null;
            });
        }
    }, {
        key: 'validBalanceDisabled',
        value: function validBalanceDisabled() {
            var disableButton = this.model.physicalCashCountRecord.map(function (data) {
                var validate = false;
                if (data.regularBalanceError || data.emergencyBalanceError) {
                    validate = true;
                    data.validBalanceErr = validate;
                    return validate;
                }

                if (data.regularBalanceError === null || data.emergencyBalanceError === null) {
                    validate = false;
                    data.validBalanceErr = validate;
                    return validate;
                }
                return validate;
            });

            if (disableButton.indexOf(true) >= 0) return true;else return false;
        }
    }, {
        key: 'defaultCashCountData',
        value: function defaultCashCountData() {
            var _this8 = this;

            var denom = [];
            this.model.physicalCashCountRecord = [];
            this.model.fundingSource.forEach(function (fs, index) {
                var fundingSourceObj = _.find(_this8.model.fundingSourceStatus, { 'fundingSourceId': fs.fundingSourceId });

                _this8.model.physicalCashCountRecord[index] = {
                    denominations: [],
                    fundingSourceId: fs.fundingSourceId,
                    fundingSourceName: fs.sourceName,
                    // vaultDate: this.model.branchCurrentVaultDate,
                    status: fundingSourceObj.status,
                    finishedByUserId: fundingSourceObj.finishedByUserId,
                    finishedByUserName: fundingSourceObj.finishedByUserName,
                    finishedAt: fundingSourceObj.finishedAt,
                    totalAmount: 0,
                    balanceCheckId: fundingSourceObj.balanceCheckId,
                    edit: false,
                    regularBalance: fundingSourceObj.regularLedgerBalance,
                    emergencyBalance: fundingSourceObj.emergencyLedgerBalance,
                    enteredRegularAmount: 0,
                    enteredEmergencyAmount: 0,
                    approved: fundingSourceObj.approved,
                    approvedByUserId: fundingSourceObj.approvedByUserId,
                    approvedByUserName: fundingSourceObj.approvedByUserName,
                    approvedAt: fundingSourceObj.approvedAt
                };
            });

            this.model.denominations.forEach(function (d) {
                denom.push({
                    cashBalance: d.cashBalance,
                    denominationId: d.denominationId,
                    faceValue: d.denominationFaceValue,
                    amount: d.amountCounted >= 0 ? d.amountCounted : null,
                    account: d.account,
                    status: d.status,
                    fundingSourceId: d.fundingSourceId,
                    denominationCoinFlag: d.denominationCoinFlag,
                    sortOrder: d.shipTypeSortOrder,
                    isValid: false,
                    amountVariance: d.amountVariance
                });
            });

            var denomGroup = _.groupBy(denom, function (entry) {
                return entry.status && entry.fundingSourceId;
            });
            this.model.physicalCashCountRecord.forEach(function (record) {
                if (record.status == 'Completed') {
                    if (denomGroup[record.fundingSourceId]) {
                        denomGroup[record.fundingSourceId].forEach(function (d) {
                            record.totalAmount += d.amount;
                            d.isValid = true;
                        });
                    }
                }
                record.denominations = denomGroup[record.fundingSourceId] || [];
            });

            this.model.physicalCashCountRecord.forEach(function (d) {
                d.denominations = _.sortBy(d.denominations, ['faceValue', 'asc']);
            });
        }
    }, {
        key: 'validateDenomAmount',
        value: function validateDenomAmount(fundingSourceIndex, denominationIndex) {
            var _this9 = this;

            var disableButton = this.model.physicalCashCountRecord[fundingSourceIndex].denominations.map(function (data) {
                if (data.amount === undefined || data.amount === "" || data.amount === null || (_this9.isFloat(data.faceValue) ? Math.round(data.amount % data.faceValue) > 0 : data.amount % data.faceValue > 0)) return false;else return true;
            });

            if (disableButton[denominationIndex] === true) this.model.physicalCashCountRecord[fundingSourceIndex].denominations[denominationIndex].isValid = true;else this.model.physicalCashCountRecord[fundingSourceIndex].denominations[denominationIndex].isValid = false;
        }
    }, {
        key: 'commitDisabled',
        value: function commitDisabled() {
            var disableButton = this.model.physicalCashCountRecord ? this.model.physicalCashCountRecord.map(function (data) {
                var validate = true;
                if (data && data.denominations) {
                    data.denominations.map(function (denom) {
                        return validate = validate && denom.isValid;
                    });
                }
                return validate;
            }) : [];
            if (disableButton.indexOf(false) >= 0) return true;else return false;
        }
    }, {
        key: 'hideCommitBtn',
        value: function hideCommitBtn() {
            var currentVaultDate = new Date(this.model.branchCurrentVaultDate).getTime();
            var selectedDate = new Date(this.model.date).getTime();
            var isPastVaultDate = moment(selectedDate).isBefore(currentVaultDate);

            var hideButton = this.model.physicalCashCountRecord.map(function (data) {
                var validate = true;
                validate = validate && (data.status === 'Completed' || isPastVaultDate);
                return validate;
            });
            if (hideButton.indexOf(false) >= 0) return false;else return true;
        }
    }, {
        key: 'shouldShowLabels',
        value: function shouldShowLabels() {
            var map = {};
            this.model.physicalCashCountData.denominations.forEach(function (item) {
                var fundingSourceId = item.fundingSourceId,
                    account = item.account;


                if (!map[fundingSourceId]) {
                    map[fundingSourceId] = {
                        regular: [],
                        emergency: []
                    };
                }

                if (map[fundingSourceId][account]) {
                    map[fundingSourceId][account].push(item);
                }
            });

            var result = {};

            (0, _keys2.default)(map).forEach(function (fsId) {
                var sourceData = map[fsId];

                result[fsId] = {
                    regular: {
                        count: sourceData.regular.length,
                        hasDenominations: sourceData.regular.length > 0
                    },
                    emergency: {
                        count: sourceData.emergency.length,
                        hasDenominations: sourceData.emergency.length > 0
                    }
                };
            });

            this.model.fundingSourceDenoms = result;
        }
    }, {
        key: 'print',
        value: function print(fundingSourceId) {
            var physicalCashCountData = this.model.physicalCashCountRecord.filter(function (data) {
                return data.status === 'Completed' && data.fundingSourceId === fundingSourceId;
            });

            var url = this.$state.href('printPhysicalCashCount');
            window.w = window.open(url, '_blank');
            window.w.printData = {
                physicalCashCountData: physicalCashCountData,
                branch: this.model.currentBranch,
                isSupervisor: this.model.isSupervisor,
                denomsForAccount: this.model.fundingSourceDenoms[fundingSourceId]
            };
        }
    }, {
        key: 'loadPermission',
        value: function loadPermission() {
            var _this10 = this;

            this.model.acl[this.model.permissionKey] = this.User.getACL(this.model.permissionKey);
            this.model.hasACL[this.model.permissionKey] = {};
            this.model.acl[this.model.permissionKey].forEach(function (permission) {
                _this10.model.hasACL[_this10.model.permissionKey][permission] = true;
            });

            if (this.model.hasACL[this.model.permissionKey]['edit']) {
                this.model.maxVaultDate.minDate = null;
            }
        }
    }, {
        key: 'edit',
        value: function edit(balanceCheckObj) {
            var _this11 = this;

            balanceCheckObj.edit = true;
            balanceCheckObj.status = 'Pending';
            balanceCheckObj.denominations.forEach(function (denom) {
                return denom.status = 'Pending';
            });
            this.model.balanceCheckIds.push(balanceCheckObj.balanceCheckId);

            var fundingSourceIndex = _.findIndex(this.model.fundingSource, { fundingSourceId: balanceCheckObj.fundingSourceId });

            if (fundingSourceIndex !== undefined) {
                this.model.physicalCashCountRecord[fundingSourceIndex].denominations.map(function (data, denominationIndex) {
                    if (data.amount === undefined || data.amount === '' || _this11.isFloat(data.faceValue) ? Math.round(data.amount % data.faceValue) > 0 : data.amount % data.faceValue > 0) {
                        _this11.model.physicalCashCountRecord[fundingSourceIndex].denominations[denominationIndex].isValid = false;
                    } else _this11.model.physicalCashCountRecord[fundingSourceIndex].denominations[denominationIndex].isValid = true;
                });
            }
        }
    }, {
        key: 'showCancelEditButton',
        value: function showCancelEditButton() {
            var validateBtn = this.model.physicalCashCountRecord.map(function (data) {
                var validate = true;
                validate = validate && data.edit;
                return validate;
            });

            if (validateBtn.indexOf(true) >= 0) return true;else return false;
        }
    }, {
        key: 'cancelEdit',
        value: function cancelEdit() {
            this.defaultCashCountData();
            this.model.balanceCheckIds = [];
        }
    }, {
        key: 'editPhysicalCashCount',
        value: function editPhysicalCashCount(supId) {
            var _this12 = this;

            var formattedDate = moment(this.model.date).format('YYYY-MM-DD');

            var data = this.model.physicalCashCountRecord.filter(function (d) {
                return d.status === 'Pending' && d.denominations && d.denominations.length > 0;
            });

            this.model.commitRecords = true;
            return this.PhysicalCashCountService.editPhysicalCashCount(data, this.model.balanceCheckIds, supId, this.model.currentBranch, this.model.currency, formattedDate).then(function () {
                _this12.getRequirementOrBalanceCount();
            }).catch(function (err) {
                console.log(err);
                _this12.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this12.model.commitRecords = false;
                _this12.model.balanceCheckIds = [];
            });
        }
    }, {
        key: 'approveWithSupervisor',
        value: function approveWithSupervisor(data) {
            var _this13 = this;

            if (this.model.userInfo && this.model.userInfo.supervisor) {
                this.Modal.confirmSupervisor('approve-physical-cash-count', null, function (_ref5) {
                    var modal = _ref5.modal,
                        supId = _ref5.supId;

                    data.userId = supId;
                    _this13.approvePhysicalCashCount(data);
                    modal.close();
                }, function (_ref6) {
                    var modal = _ref6.modal;

                    modal.close();
                });
            } else {
                data.userId = this.model.loggedInUser;
                this.approvePhysicalCashCount(data);
            }
        }
    }, {
        key: 'approvePhysicalCashCount',
        value: function approvePhysicalCashCount(data) {
            var _this14 = this;

            var totalVariance = data.denominations.reduce(function (sum, denom) {
                return sum + (denom.amount - denom.cashBalance);
            }, 0);
            data.totalVariance = Number(totalVariance).toFixed(2);
            this.isApprovePhysicalCashCount = true;

            if (totalVariance !== 0) {
                this.Modal.confirm({
                    header: this.$translate.instant('common.confirm_title'),
                    message: this.$translate.instant('Are you sure you want to approve a cash count with a variance?'),
                    callback: function callback(_ref7) {
                        var modal = _ref7.modal;

                        _this14.approve(data, modal);
                    },
                    negative: function negative(_ref8) {
                        var modal = _ref8.modal;

                        modal.close();
                        _this14.isApprovePhysicalCashCount = false;
                    },
                    type: 'success'
                });
            } else {
                this.approve(data);
            }
        }
    }, {
        key: 'approve',
        value: function approve(data, modal) {
            var _this15 = this;

            var formattedDate = moment(this.model.date).format('YYYY-MM-DD'),
                denoms = [];
            data.denominations.forEach(function (d) {
                denoms.push({ denominationId: d.denominationId, amount: d.amount, account: d.account, variance: d.amountVariance });
            });

            this.PhysicalCashCountService.approvePhysicalCashCount(formattedDate, data.fundingSourceId, this.model.currentBranch, data.userId, data.totalAmount, data.totalVariance, denoms).then(function () {
                _this15.getRequirementOrBalanceCount();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    return _this15.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                if (modal) modal.close();
                _this15.isApprovePhysicalCashCount = false;
            });
        }
    }, {
        key: 'isFloat',
        value: function isFloat(n) {
            return n % 1 !== 0;
        }
    }, {
        key: 'amountVariance',
        value: function amountVariance(amount) {
            var num = Number(amount);
            return num.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
    }]);
    return PhysicalCashCountController;
}();

exports.default = PhysicalCashCountController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _print_physical_cash_count = __webpack_require__(1789);

var _print_physical_cash_count2 = _interopRequireDefault(_print_physical_cash_count);

__webpack_require__(535);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printModule = angular.module('printPhysicalCashCount', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/branchManagement.physicalCashCount');

    $stateProvider.state('printPhysicalCashCount', {
        url: '/print-physical-cash-count',
        component: 'printPhysicalCashCount',
        data: {
            requireLogin: true,
            requireACL: 'branch_mgmt_physical_cash_count.all'
        }
    });
}]).component('printPhysicalCashCount', _print_physical_cash_count2.default).name;

exports.default = printModule;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _print_physical_cash_count = __webpack_require__(2697);

var _print_physical_cash_count2 = _interopRequireDefault(_print_physical_cash_count);

var _print_physical_cash_count3 = __webpack_require__(1790);

var _print_physical_cash_count4 = _interopRequireDefault(_print_physical_cash_count3);

__webpack_require__(535);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printComponent = {
    restrict: 'E',
    bindings: {},
    template: _print_physical_cash_count2.default,
    controller: _print_physical_cash_count4.default
};

exports.default = printComponent;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintController = function () {
    /*@ngInject*/
    PrintController.$inject = ["Auth", "$state", "$location", "ShipmentService", "BagoutService", "DateUtil", "$translate", "$q", "Modal"];
    function PrintController(Auth, $state, $location, ShipmentService, BagoutService, DateUtil, $translate, $q, Modal) {
        (0, _classCallCheck3.default)(this, PrintController);

        this.ShipmentService = ShipmentService;
        this.BagoutService = BagoutService;
        this.$translate = $translate;
        this.DateUtil = DateUtil;
        this.Modal = Modal;
    }

    (0, _createClass3.default)(PrintController, [{
        key: '$onInit',
        value: function $onInit() {
            var printData = undefined;
            if (window.opener && window.opener.w && window.opener.w.printData) {
                printData = window.opener.w.printData;
                this.physicalCashCountData = printData.physicalCashCountData;
                this.branch = printData.branch;
                this.isSupervisor = printData.isSupervisor;
                this.denomsForAccount = printData.denomsForAccount;
                this.print();
            }
        }
    }, {
        key: 'print',
        value: function print() {
            setTimeout(function () {
                window.print();
            }, 1500);
        }
    }, {
        key: 'amountVariance',
        value: function amountVariance(amount) {
            var num = Number(amount);
            return num.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
    }, {
        key: 'isFloat',
        value: function isFloat(n) {
            return n % 1 !== 0;
        }
    }]);
    return PrintController;
}();

exports.default = PrintController;

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _restore_route_assignments = __webpack_require__(1792);

var _restore_route_assignments2 = _interopRequireDefault(_restore_route_assignments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementRestoreRouteAssignmentsModule = angular.module('branchManagementRestoreRouteAssignments', []).component('branchManagementRestoreRouteAssignments', _restore_route_assignments2.default).name;

exports.default = branchManagementRestoreRouteAssignmentsModule;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _restore_route_assignments = __webpack_require__(2698);

var _restore_route_assignments2 = _interopRequireDefault(_restore_route_assignments);

var _restore_route_assignments3 = __webpack_require__(1793);

var _restore_route_assignments4 = _interopRequireDefault(_restore_route_assignments3);

__webpack_require__(2980);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementRestoreRouteAssignmentsComponent = {
    restrict: "E",
    bindings: {},
    template: _restore_route_assignments2.default,
    controller: _restore_route_assignments4.default
};

exports.default = branchManagementRestoreRouteAssignmentsComponent;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RestoreRouteAssignmentsComponent = function () {
    /*@ngInject*/
    RestoreRouteAssignmentsComponent.$inject = ["Auth", "$state", "User", "DateUtil", "$translate", "$q", "Modal", "RestoreRouteAssignmentService", "DataCounter", "UserBranchService", "CommonLayoutService", "Navigation", "$rootScope"];
    function RestoreRouteAssignmentsComponent(Auth, $state, User, DateUtil, $translate, $q, Modal, RestoreRouteAssignmentService, DataCounter, UserBranchService, CommonLayoutService, Navigation, $rootScope) {
        (0, _classCallCheck3.default)(this, RestoreRouteAssignmentsComponent);

        this.Auth = Auth;
        this.$state = $state;
        this.User = User;
        this.DateUtil = DateUtil;
        this.$translate = $translate;
        this.$q = $q;
        this.Modal = Modal;
        this.RestoreRouteAssignmentService = RestoreRouteAssignmentService;
        this.DataCounter = DataCounter;
        this.UserBranchService = UserBranchService;
        this.CommonLayoutService = CommonLayoutService;
        this.Navigation = Navigation;
        this.$rootScope = $rootScope;

        this.model = {
            currentBranch: User.getUser().branchId,
            loggedInUserId: User.getUser().id,
            loading: false,
            searchText: null,
            locRouteAssignmentObj: {
                results: [],
                totalRecords: 0,
                loading: false,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                toggleSelect: false,
                selectedLocRouteChangeIds: []
            },
            localLang: this.CommonLayoutService.multiSelectLangTranslation()
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/restore-route-assignments');
    }

    (0, _createClass3.default)(RestoreRouteAssignmentsComponent, [{
        key: '$onInit',
        value: function $onInit() {
            // this.model.loading = true;
            // this.SetupService.get(this.model.currentBranch)
            //     .then((data) => {
            //         this.model.branchCurrentVaultDate = this.DateUtil.convertToDate(data.currentVaultDate);
            //         this.model.date = this.model.branchCurrentVaultDate;
            //         this.model.maxVaultDate = { maxDate: this.model.branchCurrentVaultDate };
            //     })
            //     .catch((err) => {
            //         console.log(err);
            //     })
            //     .finally(() => {
            //         this.model.loading = false;
            //     })
            this.loadUserBranches();
        }
    }, {
        key: 'findLocationRouteChange',
        value: function findLocationRouteChange() {
            var _this = this;

            setTimeout(function () {
                _this.model.locRouteAssignmentObj.loading = true;
                var branch = _this.model.selectedBranch && _this.model.selectedBranch.length ? _this.model.selectedBranch.map(function (d) {
                    return d.branchId;
                }).toString() : _this.model.branch;

                _this.RestoreRouteAssignmentService.getLocationRouteChange(_this.model.locRouteAssignmentObj.searchText, branch, (_this.model.locRouteAssignmentObj.pagination.page - 1) * _this.model.locRouteAssignmentObj.pagination.pageLimit, _this.model.locRouteAssignmentObj.pagination.pageLimit).then(function (data) {
                    _this.model.locRouteAssignmentObj.pagination.total = data.totalRecords;
                    _this.model.locRouteAssignmentObj.results = data.results;
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this.model.locRouteAssignmentObj.loading = false;
                });
            });
        }
    }, {
        key: 'goToLocation',
        value: function goToLocation(locationId) {
            this.Navigation.goToLocationTab(locationId);
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.model.locRouteAssignmentObj.toggleSelect = !this.model.locRouteAssignmentObj.toggleSelect;
            this.findLocationRouteChange();
        }
    }, {
        key: 'searchRecords',
        value: function searchRecords() {
            this.model.locRouteAssignmentObj.pagination.page = 1;
            this.findLocationRouteChange();
        }
    }, {
        key: 'selectAllLocations',
        value: function selectAllLocations() {
            var _this2 = this;

            this.model.locRouteAssignmentObj.toggleSelect = !this.model.locRouteAssignmentObj.toggleSelect;
            this.model.locRouteAssignmentObj.selectedLocRouteChangeIds = [];

            this.model.locRouteAssignmentObj.results.forEach(function (d) {
                if (_this2.model.locRouteAssignmentObj.toggleSelect) {
                    d.isSelected = _this2.model.locRouteAssignmentObj.toggleSelect;
                    _this2.model.locRouteAssignmentObj.selectedLocRouteChangeIds.push({ id: d.locRouteChangeId, locationId: d.locationId });
                } else {
                    d.isSelected = _this2.model.locRouteAssignmentObj.toggleSelect;
                    _this2.model.locRouteAssignmentObj.selectedLocRouteChangeIds = [];
                }
            });
        }
    }, {
        key: 'selectLocations',
        value: function selectLocations(data, index) {
            if (data.isSelected) {
                this.model.locRouteAssignmentObj.selectedLocRouteChangeIds.push({ id: data.locRouteChangeId, locationId: data.locationId });
            } else {
                this.model.locRouteAssignmentObj.selectedLocRouteChangeIds.splice(index, 1);
            }
        }
    }, {
        key: 'undoLocationRouteChange',
        value: function undoLocationRouteChange() {
            var _this3 = this;

            this.model.loading = true;
            this.RestoreRouteAssignmentService.undoLocationRouteChange(this.model.locRouteAssignmentObj.selectedLocRouteChangeIds, this.model.currentBranch, this.model.loggedInUserId).then(function () {
                _this3.model.locRouteAssignmentObj.selectedLocRouteChangeIds = [];
                _this3.findLocationRouteChange();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this3.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this3.model.loading = false;
            });
        }
    }, {
        key: 'loadUserBranches',
        value: function loadUserBranches() {
            var _this4 = this;

            this.UserBranchService.getUserBranches(this.model.loggedInUserId).then(function (data) {
                _this4.model.userBranchList = data.results;
                _this4.model.totalBranches = _this4.model.userBranchList.length;

                _this4.model.userBranchList.filter(function (branch) {
                    if (branch.branchId == _this4.model.currentBranch) {
                        branch.ticked = true;
                    }
                });

                _this4.findLocationRouteChange();
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'resetPagination',
        value: function resetPagination() {
            this.model.locRouteAssignmentObj.pagination.page = 1;
        }
    }]);
    return RestoreRouteAssignmentsComponent;
}();

exports.default = RestoreRouteAssignmentsComponent;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routes = __webpack_require__(1798);

var _routes2 = _interopRequireDefault(_routes);

var _print = __webpack_require__(1795);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementRoutesModule = angular.module('branchManagementRoutes', [_print2.default]).component('branchManagementRoutes', _routes2.default).name;

exports.default = branchManagementRoutesModule;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _print_routes = __webpack_require__(1796);

var _print_routes2 = _interopRequireDefault(_print_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printRoutesModule = angular.module('printRoutes', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider.otherwise('/routes');

	$stateProvider.state('printRoutes', {
		url: '/print-routes',
		component: 'printRoutes',
		data: {
			requireLogin: true,
			requireACL: 'branch_mgmt_routes.all'
		}
	});
}]).component('printRoutes', _print_routes2.default).name;

exports.default = printRoutesModule;

// ?branch&route&date

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_routes = __webpack_require__(2699);

var _print_routes2 = _interopRequireDefault(_print_routes);

var _print_routes3 = __webpack_require__(1797);

var _print_routes4 = _interopRequireDefault(_print_routes3);

__webpack_require__(2981);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printRoutesComponent = {
  restrict: 'E',
  bindings: {},
  template: _print_routes2.default,
  controller: _print_routes4.default
};

exports.default = printRoutesComponent;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintRoutesController = function () {
    /*@ngInject*/
    PrintRoutesController.$inject = ["$state", "$stateParams", "User", "ShipmentService", "$location"];
    function PrintRoutesController($state, $stateParams, User, ShipmentService, $location) {
        (0, _classCallCheck3.default)(this, PrintRoutesController);

        this.ShipmentService = ShipmentService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.User = User;
        this.routesInfo = [];
        this.title = '';
        this.vaultDate = '';
        this.routeId = '';
        this.timezone = '';
        this.totals = [];
        this.routeDetails = [];
    }

    (0, _createClass3.default)(PrintRoutesController, [{
        key: '$onInit',
        value: function $onInit() {
            var printData = undefined;

            // First check URL parameters
            var urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('data')) {
                try {
                    printData = {
                        data: JSON.parse(decodeURIComponent(urlParams.get('data'))),
                        title: decodeURIComponent(urlParams.get('title') || ''),
                        vaultDate: decodeURIComponent(urlParams.get('vaultDate') || ''),
                        routeId: decodeURIComponent(urlParams.get('routeId') || ''),
                        flag: decodeURIComponent(urlParams.get('flag') || ''),
                        timezone: decodeURIComponent(urlParams.get('timezone') || ''),
                        totals: JSON.parse(decodeURIComponent(urlParams.get('totals') || '{}')),
                        routeDetails: JSON.parse(decodeURIComponent(urlParams.get('routeDetails') || '{}'))
                    };
                } catch (e) {
                    console.error('Error parsing URL parameters:', e);
                }
            }

            // If no URL data, try window.opener
            if (!printData && window.opener && window.opener.w && window.opener.w.printData) {
                printData = window.opener.w.printData;
            }

            if (printData) {
                this.routesInfo = printData.data;
                this.title = printData.title;
                this.vaultDate = printData.vaultDate;
                this.routeId = printData.routeId;
                this.flag = printData.flag;
                this.timezone = printData.timezone;
                this.logoBase64 = printData.logoBase64 || null;
                this.totals = printData.totals;
                this.routeDetails = printData.routeDetails;
            }

            if (window.opener && window.opener.w && window.opener.w.printData && !window.opener.w.printData.email) {
                setTimeout(function () {
                    window.print();
                }, 1000);
            }
        }
    }]);
    return PrintRoutesController;
}();

exports.default = PrintRoutesController;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routes = __webpack_require__(2700);

var _routes2 = _interopRequireDefault(_routes);

var _routes3 = __webpack_require__(1799);

var _routes4 = _interopRequireDefault(_routes3);

__webpack_require__(2982);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementRoutesComponent = {
  restrict: 'E',
  bindings: {},
  template: _routes2.default,
  controller: _routes4.default
};

exports.default = branchManagementRoutesComponent;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoutesController = function () {
  /*@ngInject*/
  RoutesController.$inject = ["Auth", "$state", "User", "Navigation", "RouteService", "$translate", "LocationService", "ScanService", "$window", "$q", "Modal", "ShipmentService", "BranchService", "DateUtil", "SetupService", "DataCounter", "$filter", "UsersService", "TimezoneList", "CommonLayoutService", "$rootScope", "FetchReactData"];
  function RoutesController(Auth, $state, User, Navigation, RouteService, $translate, LocationService, ScanService, $window, $q, Modal, ShipmentService, BranchService, DateUtil, SetupService, DataCounter, $filter, UsersService, TimezoneList, CommonLayoutService, $rootScope, FetchReactData) {
    (0, _classCallCheck3.default)(this, RoutesController);

    this.FetchReactData = FetchReactData;
    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.BranchService = BranchService;
    this.ScanService = ScanService;
    this.$q = $q;
    this.Modal = Modal;
    this.ShipmentService = ShipmentService;
    this.showData = false;
    this.DateUtil = DateUtil;
    this.SetupService = SetupService;
    this.DataCounter = DataCounter;
    this.Navigation = Navigation;
    this.$filter = $filter;
    this.UsersService = UsersService;
    this.TimezoneList = TimezoneList;
    this.$window = $window;
    this.CommonLayoutService = CommonLayoutService;
    this.$rootScope = $rootScope;

    this.model = {
      route: null,
      branch: User.getUser().branchId,
      type: '',
      max: 200,
      deliveries: [],
      pickups: [],
      date: '',
      routeStatsObj: {
        routeDetails: {}
      },
      pickupShipmentStats: {
        pickupAmount: '$',
        pickupCount: '#'
      },
      selectedPickupShipmentStats: '$',
      deliveryShipmentStats: {
        deliveryAmount: '$',
        deliveryCount: '#'
      },
      selectedDeliveryShipmentStats: '$',
      timezone: moment.tz.guess(),
      buckets: [],
      timezoneList: this.TimezoneList.getTimezoneList(),
      loggedInUser: User.getUser().id
    };

    this.routes = [];
    this.allRoutes = [];
    this.branches = [];
    this.locationEvent = [];
    this.shipmentEvent = [];
    this.locationData = '';

    this.days = [{ label: this.$translate.instant('location.sun'), value: 'Sun' }, { label: this.$translate.instant('location.mon'), value: 'Mon' }, { label: this.$translate.instant('location.tues'), value: 'Tue' }, { label: this.$translate.instant('location.wed'), value: 'Wed' }, { label: this.$translate.instant('location.thurs'), value: 'Thu' }, { label: this.$translate.instant('location.fri'), value: 'Fri' }, { label: this.$translate.instant('location.sat'), value: 'Sat' }, { label: this.$translate.instant('location.hol'), value: 'Hol' }];
  }

  (0, _createClass3.default)(RoutesController, [{
    key: 'loadPermission',
    value: function loadPermission() {
      var _this = this;

      this.acl = {};
      this.hasACL = {};

      [].forEach(function (permissionKey) {
        _this.acl[permissionKey] = _this.User.getACL(permissionKey);

        _this.hasACL[permissionKey] = {};

        _this.acl[permissionKey].forEach(function (permission) {
          _this.hasACL[permissionKey][permission] = true;
        });
      });
    }
  }, {
    key: 'tabSelection',
    value: function tabSelection(selectedValue) {
      if (selectedValue == 'Sum') {} else if (selectedValue == 'All') {}
      this.model.type = selectedValue;
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.locationData = this.FetchReactData.getTransitionData() || this.DataCounter.getData();

      var routeData = localStorage.getItem('DataCounter');
      if (routeData) {
        var data = JSON.parse(routeData);
        this.DataCounter.setData(data);
        localStorage.removeItem('DataCounter');
      }
      // const transitionData = this.FetchReactData.getTransitionData();
      // if (transitionData) {
      //   this.DataCounter.setData(transitionData);
      //   this.FetchReactData.clearTransitionData();
      // }
      // this.model.type = "Sum";
      this.loadPermission();
      this.$rootScope.$broadcast('routeChange', '/app/branch-management/routes');

      this.$q.all([
      // this.BranchService.all(null, 0, 1000),
      this.SetupService.get(this.User.getUser().branchId), this.UsersService.getUserFieldData(this.model.loggedInUser)]).then(function (data) {
        var date = _this2.DateUtil.convertToDate(data[0].currentVaultDate);
        _this2.model.date = date;
        _this2.model.userdetails = data[1];
        _this2.model.timezone = _this2.model.userdetails.timezone ? _this2.model.userdetails.timezone : moment.tz.guess();
        // this.branches = data[0].results;
      }).then(function () {
        // this.getRoutes('', 0)
        _this2.loadRoutes();
      }).catch(function (err) {
        console.log(err);
      });
    }

    // getRoutes(searchKey, offset) {
    //   searchKey = searchKey || '';
    //   const routeSearchObj = {
    //     queryJSON: {
    //       rules: [
    //         {
    //           field: 'branchId',
    //           condition: '=',
    //           data: this.User.getUser().branchId
    //         },
    //         {
    //           group: {
    //             rules: [{
    //               field: 'id',
    //               condition: 'like',
    //               data: '%' + searchKey + '%'
    //             },
    //             {
    //               field: 'name',
    //               condition: 'like',
    //               data: '%' + searchKey + '%'
    //             }
    //             ],
    //             operator: 'OR'
    //           }
    //         }
    //       ],
    //       operator: 'AND'
    //     }
    //   };

    //   return this.RouteService.all(routeSearchObj, offset, AppConstatnt.defaultPageLimit)
    //     .then((data) => {
    //       if (offset === 0 || offset == undefined) {
    //         this.totalRoutes = data.total;
    //         this.routes = this.mapData(data.results);
    //       } else {
    //         const routes = this.mapData(data.results);
    //         this.routes = this.routes.concat(routes);
    //       }
    //     })
    // }

  }, {
    key: 'resetData',
    value: function resetData() {
      this.totalRoutes = "";
      this.model.route = "";
      this.routes = [];
      this.currentRouteStatus = "";
      this.locationEvent = [];
      this.shipmentEvent = [];
      this.currentRoute = "";
      this.currentTime = "";
      this.showData = false;
    }
  }, {
    key: 'loadRoutes',
    value: function loadRoutes() {
      var _this3 = this;

      this.resetData();
      this.loading = true;
      var formattedDate = "";

      if (this.locationData && this.locationData.isRedirected && this.locationData.vaultDate) {
        this.model.date = this.DateUtil.convertToDate(this.locationData.vaultDate);
        formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      } else formattedDate = moment(this.model.date).format('YYYY-MM-DD');

      return this.RouteService.getActiveRoutes(this.model.branch, formattedDate).then(function (res) {
        var routes = _this3.mapData(res.results);
        _this3.totalRoutes = routes.length;
        _this3.routes = _this3.routes.concat(routes);
        return res.results;
      }).then(function (routeData) {
        _this3.loadData(routeData);
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this3.loading = false;
      });
    }
  }, {
    key: 'loadData',
    value: function loadData(routeData) {
      if (this.locationData && this.locationData.isRedirected) {
        var route = _lodash2.default.find(routeData, { routeId: this.locationData.routeId });
        if (route) {
          this.model.route = { Key: route.routeName, Value: route.routeId, autoCheckInUpdate: route.autoCheckInUpdate };
          return this.loadRouteData();
        } else {
          return this.resetRedirectionData();
        }
      }
    }
  }, {
    key: 'mapData',
    value: function mapData(routes) {
      return routes.map(function (route) {
        return {
          Key: route.routeName,
          Value: route.routeId,
          autoCheckInUpdate: route.autoCheckInUpdate
        };
      });
    }

    // load route data base on vaultDate and routeId 

  }, {
    key: 'loadRouteData',
    value: function loadRouteData() {
      var _this4 = this;

      if (!this.model.route) {
        return;
      }

      this.loading = true;
      this.currentDate = moment(this.model.date).format('YYYY-MM-DD');
      this.model.buckets = [];
      var shortLoadAmount = 0;

      // if (this.model.route && this.model.route.Value) {
      this.RouteService.routeStatus(this.model.route.Value, this.currentDate, this.model.branch).then(function (data) {
        _this4.showData = true;
        // var localTime = moment.utc().toDate();
        // this.currentTime = moment(localTime).format('LT');
        _this4.model.routeStatsObj.results = data.results;
        _this4.model.routeStatsObj.delivery = _this4.model.routeStatsObj.results.delivery;
        _this4.model.routeStatsObj.pickups = _this4.model.routeStatsObj.results.pickups;
        _this4.model.routeStatsObj.routeDetails = _this4.model.routeStatsObj.results.routeDetails;
        _this4.model.routeStatsObj.routeStops = _this4.model.routeStatsObj.results.routeStops;
        _this4.model.routeStatsObj.buckets = _this4.model.routeStatsObj.results.buckets;
        var keys = (0, _keys2.default)(_this4.model.routeStatsObj.buckets);

        keys.map(function (key) {
          _this4.model.buckets.push({ title: key });
        });

        var shortLoadShipments = _this4.model.routeStatsObj.buckets['SHORT_LOAD'].results;
        shortLoadShipments.forEach(function (s, index) {
          var nextIndex = index + 1;
          if (shortLoadShipments[nextIndex] && s.trackingId === shortLoadShipments[nextIndex].trackingId) {
            shortLoadShipments.splice(nextIndex, 1);
          }
          shortLoadAmount += s.loadedAmount;
        });
        _this4.model.routeStatsObj.buckets['SHORT_LOAD'].amount = shortLoadAmount;
      }).then(function () {
        _this4.routeStopStacked();
        _this4.stacked();
        _this4.deliveryAmountStacked();
        _this4.generateShipmentsList();
        _this4.resetRedirectionData();
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this4.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this4.loading = false;
      });
      // } else {
      // this.loading = false;
      // return false;
      // }
    }
  }, {
    key: 'routeStopStacked',
    value: function routeStopStacked() {
      this.routeStopStackData = [];
      var totalRouteStop = this.model.routeStatsObj.routeStops.totalRouteStop;
      var completedRouteStopCount = this.model.routeStatsObj.routeStops.completedRouteStopCount;
      var cantRouteStopCount = this.model.routeStatsObj.routeStops.cantRouteStopCount;
      var noPickupRouteStopCount = this.model.routeStatsObj.routeStops.noPickupRouteStopCount;
      var notWorkedRouteStopCount = this.model.routeStatsObj.routeStops.notWorkedRouteStopCount;
      var totalStopProcessed = this.model.routeStatsObj.routeStops.totalStopProcessed;
      var partialRouteStopCount = this.model.routeStatsObj.routeStops.partialRouteStopCount;
      var madeCRV = this.model.routeStatsObj.routeStops.madeCRV;

      this.routeStopStackData.push({ value: completedRouteStopCount, type: 'success' }, { value: noPickupRouteStopCount, type: 'warning' }, { value: cantRouteStopCount + notWorkedRouteStopCount, type: 'danger' },
      // { value: notWorkedRouteStopCount, type: 'danger' },
      { value: partialRouteStopCount, type: 'warning' }, { value: madeCRV, type: 'warning' });
    }
  }, {
    key: 'branchChanged',


    // filter route data according to branchId
    value: function branchChanged() {
      this.model.route = null;
      this.showData = false;
      this.getRoutes('', 0);
    }
  }, {
    key: 'routeInfo',
    value: function routeInfo(routeOf) {
      if (this.model.routeStatsObj.results[routeOf] && this.model.routeStatsObj.results[routeOf].data && this.model.routeStatsObj.results[routeOf].data.length) {
        this.currentDate = moment(this.model.date).format('YYYY-MM-DD');
        this.Modal.deliveryRouteInfo(this.model.routeStatsObj.results[routeOf].data, this.model.route.Value, this.currentDate, routeOf, this.model.timezone, this.model.branch, this.model.routeStatsObj.routeDetails, function (_ref) {
          var modal = _ref.modal;

          modal.close();
        });
      }
    }
  }, {
    key: 'shipmentsOnHoldInfo',
    value: function shipmentsOnHoldInfo(type, info) {
      if (this.model.routeStatsObj.results[type] && this.model.routeStatsObj.results[type][info] && this.model.routeStatsObj.results[type][info].length) {
        this.Modal.deliveryRouteInfo(this.model.routeStatsObj.results[type][info], this.model.route.Value, this.currentDate, info, this.model.timezone, this.model.branch, this.model.routeStatsObj.routeDetails, function (_ref2) {
          var modal = _ref2.modal;

          modal.close();
        });
      }
    }
  }, {
    key: 'resetRedirectionData',
    value: function resetRedirectionData() {
      if (this.locationData) {
        this.locationData.isRedirected = false;
        this.locationData = this.DataCounter.setData();
        this.FetchReactData.clearTransitionData();
      }
    }
  }, {
    key: 'redirectToItemHistory',
    value: function redirectToItemHistory(trackingId) {
      this.$state.go('branchManagement.items', {
        id: trackingId
      });
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(locationId) {
      var obj = {
        locationId: locationId,
        isRedirected: true
      };
      this.DataCounter.setData(obj);
      this.$state.go('branchManagement.locations');
    }
  }, {
    key: 'goToRouteTab',
    value: function goToRouteTab(route) {
      var today = this.model.date.getDay();
      var selectedDay = this.days[today].value;
      this.Navigation.goToSettingsRouteTab(route, selectedDay);
    }
  }, {
    key: 'stacked',
    value: function stacked() {
      this.deliveriesStack = [];
      this.pickupsStack = [];

      var totalDelivered = this.model.routeStatsObj.delivery.delivered;
      var deliveriesOnHold = this.model.routeStatsObj.delivery.deliveriesOnHold;
      var cantDelivered = this.model.routeStatsObj.delivery.cantDelivered;
      var totalPickedUp = this.model.routeStatsObj.pickups.pickedup;
      var pickupsOnHold = this.model.routeStatsObj.pickups.pickupsOnHold;

      this.deliveriesStack.push({ value: totalDelivered, type: 'blue' }, { value: deliveriesOnHold, type: 'warning' }, { value: cantDelivered, type: 'danger' });
      this.pickupsStack.push({ value: totalPickedUp, type: 'blue' }, { value: pickupsOnHold, type: 'warning' });
    }
  }, {
    key: 'translateRouteStatus',
    value: function translateRouteStatus(status) {
      if (!status || typeof status !== 'string') return;else return this.$translate.instant('branch_mgmt.' + status);
    }
  }, {
    key: 'convertToMillisecond',
    value: function convertToMillisecond(date) {
      var browserTimezone = moment.tz.guess(); // get the browsers current time zone.
      var convertDate = moment.tz(date, browserTimezone).format(); // convert date to specific timezone
      return moment(convertDate).valueOf(); // convert date in milliseconds
    }
  }, {
    key: 'pickupStateSelection',
    value: function pickupStateSelection(selectedValue) {
      this.model.selectedPickupShipmentStats = this.model.pickupShipmentStats[selectedValue];;
    }
  }, {
    key: 'deliveryStateSelection',
    value: function deliveryStateSelection(selectedValue) {
      this.model.selectedDeliveryShipmentStats = this.model.deliveryShipmentStats[selectedValue];
    }
  }, {
    key: 'getBucketName',
    value: function getBucketName(status) {
      switch (status) {
        case status:
          return this.$translate.instant('branch_mgmt.routes.bucket_' + status);
        default:
          return;
      }
    }
  }, {
    key: 'generateShipmentsList',
    value: function generateShipmentsList() {
      var _this5 = this;

      this.model.buckets.forEach(function (bucket) {
        if (!_this5.model.routeStatsObj.buckets[bucket.title].results.length) return;

        var shipmentList = _this5.model.routeStatsObj.buckets[bucket.title].results;
        var sortByKey = bucket.title === 'PICKEDUP' || bucket.title === 'PENDING_PICKUP' ? 'fromLocationId' : bucket.title === 'CANT_STOP' || bucket.title === 'CRV' ? 'locationId' : 'toLocationId';

        shipmentList = _lodash2.default.sortBy(shipmentList, [sortByKey]);
        shipmentList[0].matchPreviousRow = false;

        for (var i = 0; i < shipmentList.length; i++) {
          var locationId = shipmentList[i][sortByKey];
          var cursor = 1;

          for (var j = i + 1; j < shipmentList.length; j++) {
            if (shipmentList[j][sortByKey] === locationId && !shipmentList[j].matchPreviousRow) {
              cursor++;
              shipmentList[j].matchPreviousRow = true;
            } else {
              break;
            }
          }
          shipmentList[i].cursor = cursor;
        }
        _this5.model.routeStatsObj.buckets[bucket.title].results = shipmentList;
      });
    }
  }, {
    key: 'loadImage',
    value: function loadImage(type) {
      this.icon = {
        'REGULAR': 'regular.png',
        'ATM': 'atm.png',
        'BANK': 'bank.png',
        'NO_SHIP_NO_GO': 'nsng.png',
        'INTERNAL': 'internal.png',
        'TRUCK': 'truck.png',
        'TANKER': 'tanker.png',
        'WINDOW': 'window.png',
        'CARRIER': 'carrier.png',
        'ON_CALL': 'oncall.png',
        'LOCKER': 'locker.png',
        'VAULT': 'vault.png',
        'DELIVERY': 'delivery.png'
      };

      var imgURL = this.icon[type];
      return __webpack_require__(51)("./" + imgURL);
    }
  }, {
    key: 'getOrderType',
    value: function getOrderType(shiptype, type) {
      if (shiptype == "C" && type !== null) {
        return this.$translate.instant('atm_residual.order_type_' + type);
      } else if (shiptype == "C" && type == null) {
        return shiptype.toUpperCase();
      } else {
        return shiptype.toUpperCase();
      }
      // return this.ShipmentService.getOrderType(type);
    }
  }, {
    key: 'ordinalSuffixOf',
    value: function ordinalSuffixOf(number) {
      return this.CommonLayoutService.ordinalSuffixOfStopPriority(number);
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(locationId) {
      return this.Navigation.goToServiceHistory(locationId, null, true, null);
    }
  }, {
    key: 'goToItemHistory',
    value: function goToItemHistory(trackingId) {
      this.$state.go('branchManagement.items', {
        id: trackingId
      });
    }
  }, {
    key: 'showReceipt',
    value: function showReceipt(shipments, stats) {
      document.getElementById('shipment-image').blur();
      this.Modal.shipmentImageModal(shipments, shipments.trackingId, stats, function (_ref3) {
        var modal = _ref3.modal;
      }, function (_ref4) {
        var modal = _ref4.modal;

        modal.close();
      });
    }
  }, {
    key: 'getComments',
    value: function getComments(comment) {
      this.Modal.confirm({
        header: this.$translate.instant('common.comment'),
        message: comment,
        callback: function callback(_ref5) {
          var modal = _ref5.modal;

          modal.close();
        },
        negative: function negative(_ref6) {
          var modal = _ref6.modal;

          modal.close();
        },
        buttons: ['common.close'],
        type: 'success'
      });
    }
  }, {
    key: 'calculateDuration',
    value: function calculateDuration(startDate, endDate) {
      var start = moment(startDate).valueOf();
      var end = moment(endDate).valueOf();

      if (start && end && end < start) {
        // reverse the date order
        var t = startDate;
        startDate = endDate;
        endDate = t;
      }

      var ms = moment(endDate).diff(startDate);
      var duration = moment.duration(ms);
      return Math.floor(duration.asHours()) + moment.utc(ms).format(":mm:ss");
    }
  }, {
    key: 'deliveryAmountStacked',
    value: function deliveryAmountStacked() {
      this.deliveryAmountStack = [];

      var totalDeliveredAmount = this.model.routeStatsObj.delivery.totalDeliveredShipmentAmount;
      var totalNotDeliveredAmount = this.model.routeStatsObj.buckets['NOT_LOADED_OR_NOT_DELIVERED'].amount;
      var totalNotDeliveredShipments = this.model.routeStatsObj.buckets['NOT_LOADED_OR_NOT_DELIVERED'].results.length;
      var totalDeliveredShipments = this.model.routeStatsObj.delivery.delivered;
      var notDeliveredShipments = this.model.routeStatsObj.delivery.notDeliveredShipments.length;
      var notDeliveredShipmentAmount = this.model.routeStatsObj.delivery.notDeliveredShipmentAmount;

      this.deliveryAmountStack.push({ value: totalDeliveredShipments, type: 'success', amount: totalDeliveredAmount }, { value: totalNotDeliveredShipments, type: 'warning', amount: totalNotDeliveredAmount }, { value: notDeliveredShipments, type: 'danger', amount: notDeliveredShipmentAmount });
    }
  }, {
    key: 'currencyFilter',
    value: function currencyFilter(amount) {
      var fraction = amount % 1 === 0 ? 0 : 2;
      return this.$filter('currency')(amount, '$', fraction);
    }
  }, {
    key: 'stopCommentsModal',
    value: function stopCommentsModal(obj) {
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.stopComments(this.model.route.Value, formattedDate, obj.toLocationId || obj.locationId, function (_ref7) {
        var modal = _ref7.modal;

        modal.close();
      }, function (_ref8) {
        var modal = _ref8.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'sendDeliveryPickupReports',
    value: function sendDeliveryPickupReports(sendDeliveryReports, sendPickupReports) {
      var _this6 = this;

      var routeId = this.model.route.Value;
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');

      this.reportsObj = {};
      this.reportsObj[routeId] = { sendDeliveryReports: sendDeliveryReports, sendPickupReports: sendPickupReports };

      this.RouteService.sendDeliveryPickupReports(routeId, formattedDate, this.model.timezone, sendDeliveryReports, sendPickupReports).then(function () {
        var msg = sendDeliveryReports ? _this6.$translate.instant('route.delivery_report_msg', { routeId: routeId }) : _this6.$translate.instant('route.pickup_report_msg', { routeId: routeId });

        _this6.Modal.confirm({
          header: _this6.$translate.instant('successModal.title'),
          message: msg,
          callback: function callback(_ref9) {
            var modal = _ref9.modal;

            modal.close();
          },
          buttons: ['common.ok'],
          type: 'success'
        });
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          return _this6.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this6.reportsObj[routeId].sendDeliveryReports = false;
        _this6.reportsObj[routeId].sendPickupReports = false;
      });
    }
  }, {
    key: 'exportAllRouteStops',
    value: function exportAllRouteStops() {
      var _this7 = this;

      this.model.exportRouteStops = true;
      var routeId = this.model.route.Value;
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');

      this.RouteService.exportAllRouteStops(this.model.branch, routeId, formattedDate, this.model.timezone).then(function () {}).catch(function (err) {
        if (err && err.data && err.data.message) {
          return _this7.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this7.model.exportRouteStops = false;
      });
    }
  }, {
    key: 'print',
    value: function print(title, flag, data) {
      var new_path = this.$state.href('printRoutes');
      window.w = window.open(new_path, '_blank');
      window.w.printData = {
        routeId: this.model.route.Value,
        vaultDate: this.currentDate,
        title: title, flag: flag, data: data,
        timezone: this.model.timezone
      };
    }
  }, {
    key: 'redirectToATMCount',
    value: function redirectToATMCount(item) {
      return this.Navigation.goToAtmCount(item.trackingId, true, null, item.fundingSourceId);
    }
  }, {
    key: 'notDeliveredResolutionModal',
    value: function notDeliveredResolutionModal(trackingId, obj) {
      this.Modal.notDeliveredResolution(trackingId, obj, function (_ref10) {
        var modal = _ref10.modal;

        modal.close();
      }, function (_ref11) {
        var modal = _ref11.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'checkInManifest',
    value: function checkInManifest() {
      var url = this.$state.href('printCheckin', {
        branchId: this.model.branch,
        scannedRouteId: this.model.route.Value,
        date: this.currentDate
      });

      this.$window.open(url, '_blank');
    }
  }]);
  return RoutesController;
}();

exports.default = RoutesController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stop_performance = __webpack_require__(1801);

var _stop_performance2 = _interopRequireDefault(_stop_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementStopPerformanceModule = angular.module('branchManagementStopPerformance', []).component('branchManagementStopPerformance', _stop_performance2.default).name;

exports.default = branchManagementStopPerformanceModule;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stop_performance = __webpack_require__(2701);

var _stop_performance2 = _interopRequireDefault(_stop_performance);

var _stop_performance3 = __webpack_require__(1802);

var _stop_performance4 = _interopRequireDefault(_stop_performance3);

__webpack_require__(2983);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementStopPerformanceComponent = {
    restrict: 'E',
    bindings: {},
    template: _stop_performance2.default,
    controller: _stop_performance4.default
};

exports.default = branchManagementStopPerformanceComponent;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StopPerformance = function () {
    /*@ngInject*/

    StopPerformance.$inject = ["DateUtil", "$translate", "$q", "User", "Modal", "TimezoneList", "SetupService", "UsersService", "UserBranchService", "RouteStopService", "DataCounter", "$state", "Navigation", "RouteService", "$rootScope"];
    function StopPerformance(DateUtil, $translate, $q, User, Modal, TimezoneList, SetupService, UsersService, UserBranchService, RouteStopService, DataCounter, $state, Navigation, RouteService, $rootScope) {
        (0, _classCallCheck3.default)(this, StopPerformance);

        this.DateUtil = DateUtil;
        this.$translate = $translate;
        this.User = User;
        this.Modal = Modal;
        this.TimezoneList = TimezoneList;
        this.SetupService = SetupService;
        this.UsersService = UsersService;
        this.UserBranchService = UserBranchService;
        this.RouteStopService = RouteStopService;
        this.RouteService = RouteService;
        this.DataCounter = DataCounter;
        this.$state = $state;
        this.$q = $q;
        this.Navigation = Navigation;
        this.$rootScope = $rootScope;

        this.model = {
            timezoneList: this.TimezoneList.getTimezoneList(),
            stopPerformanceObj: {
                loading: false,
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                }
            },
            routeListObj: {
                loading: false,
                results: [],
                totalRecords: 0
            },
            loggedInUser: User.getUser().id,
            branch: User.getUser().branchId,
            userBranchList: [],
            timezone: null,
            sortColumn: "countedAt",
            reverseSort: true,
            isExporting: false,
            dateRangeOptions: {
                startDate: null,
                endDate: null
            }
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/stop-performance');
        this.initialSearchFocusApplied = false;
    }

    (0, _createClass3.default)(StopPerformance, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.model.loading = true;
            this.$q.all([this.SetupService.get(this.model.branch), this.UsersService.getUserFieldData(this.model.loggedInUser), this.UserBranchService.getUserBranches(this.model.loggedInUser)]).then(function (data) {
                _this.model.setupDetails = data[0];
                _this.model.userDetails = data[1];
                _this.model.userBranchList = data[2].results;
                _this.model.vaultDate = _this.DateUtil.convertToDate(_this.model.setupDetails.currentVaultDate);
                _this.model.timezone = _this.model.userDetails && _this.model.userDetails.timezone ? _this.model.userDetails.timezone : moment.tz.guess();

                _this.model.userBranchList.filter(function (branch) {
                    if (branch.branchId == _this.model.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                });

                _this.setDateRangeOptions('dateRangPickerOptionsfor');
                _this.model.dateRangeOptions.startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                _this.model.dateRangeOptions.endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');

                _this.loadData();
                _this.getRouteList();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this.model.loading = false;
            });
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            this.model.stopPerformanceObj.pagination.page = 1;
            this.getStopPerformance();
        }
    }, {
        key: 'getStopPerformance',
        value: function getStopPerformance() {
            var _this2 = this;

            setTimeout(function () {
                var branches = _this2.model.selectedBranch.map(function (branchObj) {
                    return branchObj.branchId;
                });
                var routeId = _this2.model.routeId ? _this2.model.routeId.Value : null;
                var startDate = _this2.getStartDate();
                var endDate = _this2.getEndDate();

                _this2.model.stopPerformanceObj.loading = true;
                _this2.RouteStopService.stopPerformance(_this2.model.searchText, null, null, branches, _this2.reverseSort, _this2.sortColumn, routeId, _this2.model.timezone, (_this2.model.stopPerformanceObj.pagination.page - 1) * _this2.model.stopPerformanceObj.pagination.pageLimit, _this2.model.stopPerformanceObj.pagination.pageLimit, startDate, endDate).then(function (data) {
                    _this2.model.stopPerformanceObj.pagination.total = data.total;
                    _this2.model.stopPerformanceObj.results = data.results;
                    _this2.model.stopPerformanceObj.totalRecords = data.total;
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this2.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this2.model.stopPerformanceObj.loading = false;
                    if (!_this2.initialSearchFocusApplied) {
                        _this2.initialSearchFocusApplied = true;
                        setTimeout(function () {
                            var el = document.getElementById('stopPerformanceSearch');
                            if (el) el.focus();
                        }, 100);
                    }
                });
            });
        }
    }, {
        key: 'sortData',
        value: function sortData(column) {
            this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
            this.sortColumn = column;
            this.loadData();
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(locationId) {
            var obj = {
                locationId: locationId,
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.locations');
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.getStopPerformance();
        }
    }, {
        key: 'exportData',
        value: function exportData() {
            var _this3 = this;

            var reportPrefix = 'Stop_Performance(' + moment().format('YYYY-MM-DD_HH:mm') + ')';
            var branches = this.model.selectedBranch.map(function (branchObj) {
                return branchObj.branchId;
            });
            var routeId = this.model.routeId ? this.model.routeId.Value : null;
            var startDate = this.getStartDate();
            var endDate = this.getEndDate();

            this.model.isExporting = true;
            this.RouteStopService.exportStopPerformance(this.model.searchText, null, null, branches, this.reverseSort, this.sortColumn, routeId, this.model.timezone, 0, 1000, startDate, endDate).then(function (data) {
                _this3.downloadFile(reportPrefix, data.reportData);
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this3.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this3.model.isExporting = false;
            });
        }
    }, {
        key: 'downloadFile',
        value: function downloadFile(reportPrefix, reportData) {
            var fileName = reportPrefix.concat('.csv');
            var a = document.createElement("a");
            document.body.appendChild(a);
            var file = new Blob([reportData], { type: 'application/csv' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }
    }, {
        key: 'getRouteList',
        value: function getRouteList(searchKey, offset) {
            var _this4 = this;

            setTimeout(function () {
                searchKey = searchKey || '';

                var routeSearchObj = {
                    queryJSON: {
                        rules: [{
                            field: 'branchId',
                            condition: 'IN',
                            data: _this4.getSelectedBranches()
                        }, {
                            group: {
                                rules: [{
                                    field: 'id',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                }, {
                                    field: 'name',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                }],
                                operator: 'OR'
                            }
                        }],
                        operator: 'AND'
                    }
                };

                _this4.model.routeListObj.loading = true;
                return _this4.RouteService.all(routeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
                    if (offset === 0 || offset == undefined) {
                        _this4.model.routeListObj.totalRecords = data.total;
                        _this4.model.routeListObj.results = _this4.mapData(data.results);
                    } else {
                        var routes = _this4.mapData(data.results);
                        _this4.model.routeListObj.results = _this4.model.routeListObj.results.concat(routes);
                    }
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this4.model.routeListObj.loading = false;
                });
            });
        }
    }, {
        key: 'mapData',
        value: function mapData(routes) {
            return routes.map(function (route) {
                return {
                    Key: route.name,
                    Value: route.id
                };
            });
        }
    }, {
        key: 'getSelectedBranches',
        value: function getSelectedBranches() {
            return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map(function (branch) {
                return branch.branchId;
            }) : null;
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            this.model.routeId = null;
        }
    }, {
        key: 'setDateRangeOptions',
        value: function setDateRangeOptions(modelValue) {
            var _this5 = this;

            this.model[modelValue] = {
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this5.loadData();
                    }
                },
                ranges: {
                    'Previous Week': [moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'), moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')],
                    'Last 60 Days': [moment().subtract('59', 'days').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: 'getStartDate',
        value: function getStartDate() {
            return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate() {
            return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
        }
    }]);
    return StopPerformance;
}();

exports.default = StopPerformance;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stop_scheduling = __webpack_require__(1804);

var _stop_scheduling2 = _interopRequireDefault(_stop_scheduling);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementStopSchedulingModule = angular.module('branchManagementStopScheduling', []).component('branchManagementStopScheduling', _stop_scheduling2.default).name;

exports.default = branchManagementStopSchedulingModule;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stop_scheduling = __webpack_require__(2702);

var _stop_scheduling2 = _interopRequireDefault(_stop_scheduling);

var _stop_scheduling3 = __webpack_require__(1805);

var _stop_scheduling4 = _interopRequireDefault(_stop_scheduling3);

__webpack_require__(2984);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementStopSchedulingComponent = {
  restrict: "E",
  bindings: {},
  template: _stop_scheduling2.default,
  controller: _stop_scheduling4.default
};

exports.default = branchManagementStopSchedulingComponent;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StopSchedulingController = function () {
    /*@ngInject*/
    StopSchedulingController.$inject = ["Auth", "$state", "User", "DateUtil", "$translate", "$q", "Modal", "SetupService", "StopSchedulingService", "LocationService", "RouteService", "UserBranchService", "CommonLayoutService", "Navigation", "$rootScope"];
    function StopSchedulingController(Auth, $state, User, DateUtil, $translate, $q, Modal, SetupService, StopSchedulingService, LocationService, RouteService, UserBranchService, CommonLayoutService, Navigation, $rootScope) {
        (0, _classCallCheck3.default)(this, StopSchedulingController);

        this.DateUtil = DateUtil;
        this.Modal = Modal;
        this.SetupService = SetupService;
        this.User = User;
        this.Auth = Auth;
        this.$translate = $translate;
        this.$q = $q;
        this.$state = $state;
        this.StopSchedulingService = StopSchedulingService;
        this.LocationService = LocationService;
        this.RouteService = RouteService;
        this.UserBranchService = UserBranchService;
        this.CommonLayoutService = CommonLayoutService;
        this.Navigation = Navigation;
        this.$rootScope = $rootScope;

        this.defaultModel = {
            currentBranch: User.getUser().branchId,
            loggedInUser: User.getUser().id,
            loggedInUserName: User.getUser().firstName.concat(' ', User.getUser().lastName),
            branchCurrentVaultDate: '',
            loading: false,
            branchUnassignedRoute: null,
            routeObj: {
                results: [],
                totalRoutes: 0,
                loading: false
            },
            locationObj: {
                results: [],
                totalLocation: 0,
                loading: false
            },
            stopScheduling: [],
            sameForAll: false,
            recurringPatternList: [{
                label: 'Daily',
                value: 'daily'
            }, {
                label: 'Weekly',
                value: 'weekly'
            }, {
                label: 'Monthly',
                value: 'monthly'
            }],
            selectedPattern: 'daily',
            recurWeeks: 0,
            recurringDays: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false
            },
            serviceSchedule: [{
                label: 'Monday',
                value: 'monday'
            }, {
                label: 'Tuesday',
                value: 'tuesday'
            }, {
                label: 'Wednesday',
                value: 'wednesday'
            }, {
                label: 'Thursday',
                value: 'thursday'
            }, {
                label: 'Friday',
                value: 'friday'
            }, {
                label: 'Saturday',
                value: 'saturday'
            }, {
                label: 'Sunday',
                value: 'sunday'
            }],
            recurringMonths: {
                january: false,
                february: false,
                march: false,
                april: false,
                may: false,
                june: false,
                july: false,
                august: false,
                september: false,
                october: false,
                november: false,
                december: false
            },
            recurringMonthObj: {
                day: {
                    dayInterval: null,
                    monthInterval: null
                },
                month: {
                    weekInterval: null,
                    selectedWeekDay: null,
                    monthInterval: null,
                    weekIntervalList: [{
                        lable: 'First',
                        value: 1
                    }, {
                        lable: 'Second',
                        value: 2
                    }, {
                        lable: 'Third',
                        value: 3
                    }, {
                        lable: 'Forth',
                        value: 4
                    }, {
                        lable: 'Fifth',
                        value: 5
                    }],
                    weekDayList: [{
                        lable: 'Sunday',
                        value: 0
                    }, {
                        lable: 'Monday',
                        value: 1
                    }, {
                        lable: 'Tuesday',
                        value: 2
                    }, {
                        lable: 'Wednesday',
                        value: 3
                    }, {
                        lable: 'Thursday',
                        value: 4
                    }, {
                        lable: 'Friday',
                        value: 5
                    }, {
                        lable: 'Saturday',
                        value: 6
                    }]
                }
            },
            recurringStartDate: null,
            recurringEndDate: null,
            endRecurringAfter: null,
            dateRangeOptions: {
                startDate: null,
                endDate: null
            },
            selectedBranch: []
        };

        this.localLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: this.$translate.instant('branch.all_branches') //default-label is deprecated and replaced with this.
        };

        this.model = angular.copy(this.defaultModel);
        this.selectedMonthlyPattern = 'day';
        this.userBranchList = [];
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/stop-scheduling');
    }

    (0, _createClass3.default)(StopSchedulingController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.model.loading = true;
            this.$q.all([this.SetupService.get(this.model.currentBranch), this.UserBranchService.getUserBranches(this.model.loggedInUser)]).then(function (data) {
                _this.setupDetails = data[0];
                _this.userBranchList = data[1].results;
                _this.userBranchList.filter(function (branch) {
                    if (branch.branchId == _this.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                });

                _this.model.formattedvaultDate = _this.DateUtil.convertToDate(_this.setupDetails.currentVaultDate);
                _this.model.branchUnassignedRoute = _this.setupDetails.unassignedRouteId ? { Key: _this.setupDetails.unassignedRoute.id + ' | ' + _this.setupDetails.unassignedRoute.name, Value: _this.setupDetails.unassignedRoute.id } : null;
                _this.cloneBranchUnassignedRoute = _this.model.branchUnassignedRoute;
                _this.loadLocation('', 0);
                _this.loadRoutes('', 0);
                _this.model.stopScheduling.push({
                    route: _this.model.branchUnassignedRoute,
                    location: null,
                    status: 'create'
                });
                _this.validateRecurringStartDate();
                _this.setDateRange();
                _this.getPendingChanges();
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this.model.loading = false;
            });
        }
    }, {
        key: 'setDateRange',
        value: function setDateRange() {
            this.loadDateRangePicker(this.model.dateRangeOptions, 'dateRange');
            this.model.dateRangeOptions.startDate = moment().subtract(10, 'days').format('YYYY-MM-DD HH:mm:ss');
            this.model.dateRangeOptions.endDate = moment();
        }
    }, {
        key: 'loadDateRangePicker',
        value: function loadDateRangePicker(dateRangeOption, modelVal) {
            var _this2 = this;

            this.model[modelVal] = {
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this2.getPendingChanges();
                    }
                },
                ranges: {
                    'Running 10 Days': [moment().subtract(10, 'days').format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: 'getStartDate',
        value: function getStartDate() {
            return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD 00:00:00') : null;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate() {
            return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59') : null;
        }
    }, {
        key: 'loadLocation',
        value: function loadLocation(searchKey, offset) {
            var _this3 = this;

            searchKey = searchKey || '';

            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: this.model.currentBranch
                    }, {
                        field: 'locationType',
                        condition: '!=',
                        data: 'TANKER'
                    }, {
                        field: 'locationType',
                        condition: '!=',
                        data: 'TRUCK'
                    }, {
                        field: 'locationType',
                        condition: '!=',
                        data: 'WINDOW'
                    }, {
                        field: 'active',
                        condition: '=',
                        data: true
                    }, {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };

            this.model.locationObj.loading = true;
            this.LocationService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (res) {
                if (offset === 0) {
                    _this3.model.locationObj.totalLocation = res.total;
                    _this3.model.locationObj.results = _this3.mappingData(res.results, 'name', 'id');
                } else {
                    var locations = _this3.mappingData(res.results, 'name', 'id');
                    _this3.model.locationObj.results = _this3.model.locationObj.results.concat(locations);
                }
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this3.model.locationObj.loading = false;
            });
        }
    }, {
        key: 'loadRoutes',
        value: function loadRoutes(searchKey, offset) {
            var _this4 = this;

            searchKey = searchKey || '';

            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: this.model.currentBranch
                    }, {
                        field: 'holdRoute',
                        condition: '=',
                        data: false
                    }, {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };

            this.model.routeObj.loading = true;
            return this.RouteService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (res) {
                if (offset === 0 || offset == undefined) {
                    _this4.model.routeObj.totalRoutes = res.total;
                    _this4.model.routeObj.results = _this4.mappingData(res.results, 'name', 'id');
                } else {
                    var routes = _this4.mappingData(res.results, 'name', 'id');
                    _this4.model.routeObj.results = _this4.model.routeObj.results.concat(routes);
                }
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this4.model.routeObj.loading = false;
            });
        }
    }, {
        key: 'mappingData',
        value: function mappingData(arr, label, value) {
            return arr.map(function (item) {
                var arrayObject = {
                    Key: item[value] + ' | ' + item[label],
                    Value: item[value],
                    dataObj: item
                };

                return arrayObject;
            });
        }
    }, {
        key: 'addNewRecord',
        value: function addNewRecord() {
            var _this5 = this;

            this.isValid = true;

            // if (this.model.sameForAll) return;
            this.model.stopScheduling.map(function (denom) {
                if (denom.route == null || denom.location == null) _this5.isValid = false;
            });

            if (this.isValid) this.add();
        }
    }, {
        key: 'add',
        value: function add() {
            this.model.stopScheduling.push({
                route: !this.model.sameForAll ? this.model.branchUnassignedRoute : this.model.stopScheduling[0].route,
                location: null,
                status: 'create'
            });
        }
    }, {
        key: 'removeRecords',
        value: function removeRecords(index) {
            this.model.stopScheduling.splice(index, 1);
        }
    }, {
        key: 'selectedPattern',
        value: function selectedPattern(pattern) {
            this.model.selectedPattern = pattern.value;
        }
    }, {
        key: 'resetRecurringData',
        value: function resetRecurringData() {
            var _this6 = this;

            (0, _keys2.default)(this.model.recurringMonths).filter(function (key) {
                return _this6.model.recurringMonths[key] = false;
            });
            this.model.recurWeeks = 0;
        }
    }, {
        key: 'getMonthlyPattern',
        value: function getMonthlyPattern(pattern) {
            this.selectedMonthlyPattern = pattern;
        }
    }, {
        key: 'sameForAll',
        value: function sameForAll() {
            var _this7 = this;

            setTimeout(function () {
                if (_this7.model.sameForAll) {
                    _this7.model.stopScheduling.forEach(function (stop) {
                        stop.route = null;
                    });
                }
            });
        }
    }, {
        key: 'updateRoutes',
        value: function updateRoutes(seletedValue) {
            if (this.model.sameForAll) {
                this.model.stopScheduling.forEach(function (stop) {
                    stop.route = seletedValue;
                });
            }
        }
    }, {
        key: 'validateRecurringBtn',
        value: function validateRecurringBtn() {
            var _this8 = this;

            var isValidDay = false;

            (0, _keys2.default)(this.model.recurringDays).filter(function (key) {
                if (_this8.model.recurringDays[key]) isValidDay = true;
            });

            return (this.model.recurringStartDate && (this.model.recurringEndDate || this.model.endRecurringAfter) && this.model.selectedPattern === 'weekly' ? isValidDay : true) || 'isEmpty';
        }
    }, {
        key: 'toggleDay',
        value: function toggleDay(day) {
            this.model.recurringDays[day.value] = !this.model.recurringDays[day.value];
        }
    }, {
        key: 'isDaySelected',
        value: function isDaySelected(day) {
            return this.model.recurringDays[day.value];
        }
    }, {
        key: 'validateRecurringStartDate',
        value: function validateRecurringStartDate() {
            this.minRecurrStartDate = {
                minDate: moment(),
                maxDate: moment(this.model.recurringStartDate).add(1, 'years')
            };
            this.model.recurringStartDate = this.minRecurrStartDate.minDate;
        }
    }, {
        key: 'validateEndDate',
        value: function validateEndDate() {
            this.minRecurrDate = {
                // minDate: moment(this.model.recurringStartDate).add(1, 'days'),
                maxDate: moment(this.model.recurringStartDate).add(1, 'years')
            };

            if (this.model.recurringEndDate && moment(this.model.recurringStartDate).isAfter(this.model.recurringEndDate)) {
                this.model.recurringEndDate = moment(this.model.recurringStartDate).add(1, 'days');
            }
        }
    }, {
        key: 'confirmRecurring',
        value: function confirmRecurring() {
            var _this9 = this;

            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_title'),
                message: this.$translate.instant('branch_mgmt.stop_scheduling.confirm_recurring'),
                callback: function callback(_ref) {
                    var modal = _ref.modal;

                    _this9.isCommit = false;
                    modal.close();
                    _this9.createRecurring(modal);
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    modal.close();
                    _this9.isCommit = false;
                },
                buttons: ['common.ok', 'common.cancel'],
                type: 'success'
            });
        }
    }, {
        key: 'createRecurring',
        value: function createRecurring(modal) {
            var _this10 = this;

            var weeklyRecurring = {},
                monthlyRecurring_the = {},
                monthlyRecurring_day = {},
                scheduledStops = [];

            this.model.stopScheduling.forEach(function (s) {
                scheduledStops.push({
                    locationId: s.location.Value,
                    locationKey: s.location.Key,
                    routeId: s.route.Value,
                    routeKey: s.route.Key,
                    locationAddress: _this10.formatAddress(s.location.dataObj),
                    stopPriority: s.location.dataObj.stopPriority,
                    locationType: s.location.dataObj.locationType,
                    locationName: s.location.dataObj.name
                });
            });

            var obj = {
                createdByUserId: this.model.loggedInUser,
                createdByUserName: this.model.loggedInUserName,
                branchId: this.model.currentBranch,
                recurringStartDate: moment(this.model.recurringStartDate).format('YYYY-MM-DD 00:00:00'),
                recurringEndDate: this.model.recurringEndDate ? moment(this.model.recurringEndDate).format('YYYY-MM-DD 23:59:59') : null,
                selectedPattern: this.model.selectedPattern,
                recurringDayInterval: this.model.recurringDayInterval,
                endRecurringAfter: this.model.endRecurringAfter,
                scheduledStops: scheduledStops
            };

            obj.recurringFrequency = this.recurringFrequency(this.model.selectedPattern, this.model.recurWeeks, this.model.recurringMonthObj);

            if (this.model.selectedPattern === 'weekly') {
                weeklyRecurring = {
                    recurWeeks: this.model.recurWeeks,
                    recurringDays: (0, _keys2.default)(this.model.recurringDays).filter(function (key) {
                        return _this10.model.recurringDays[key];
                    })
                };
                var weekDays = weeklyRecurring.recurringDays.map(function (rd) {
                    return rd.charAt(0).toUpperCase() + rd.slice(1);
                });
                weeklyRecurring.scheduleWeekDays = weekDays.splice(',').join(' | ');
                obj.weeklyRecurring = weeklyRecurring;
            }

            if (this.model.selectedPattern === 'monthly' && this.selectedMonthlyPattern === 'the') {
                monthlyRecurring_the = {
                    weekInterval: this.model.recurringMonthObj.month.weekInterval,
                    selectedWeekDay: this.model.recurringMonthObj.month.selectedWeekDay,
                    monthInterval: this.model.recurringMonthObj.month.monthInterval,
                    frequencyMonth: this.model.recurringMonthObj.month.frequencyMonth,
                    frequencyWeek: this.model.recurringMonthObj.month.frequencyWeek
                };
                obj.recurringMonthObj = monthlyRecurring_the;
            }

            if (this.model.selectedPattern === 'monthly' && this.selectedMonthlyPattern === 'day') {
                monthlyRecurring_day = {
                    selectedMonthlyPattern: this.selectedMonthlyPattern,
                    dayInterval: this.model.recurringMonthObj.day.dayInterval,
                    monthInterval: this.model.recurringMonthObj.day.monthInterval,
                    frequencyMonth: this.model.recurringMonthObj.day.frequencyMonth,
                    frequencyDay: this.model.recurringMonthObj.day.frequencyDay
                };
                obj.recurringMonthObj = monthlyRecurring_day;
            }

            obj.selectedMonthlyPattern = this.selectedMonthlyPattern;
            this.model.isCreateRecurring = true;
            this.StopSchedulingService.createStopScheduling(obj).then(function () {
                _this10.resetData();
                _this10.getPendingChanges();
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                if (modal) modal.close();
                _this10.model.isCreateRecurring = false;
            });
        }
    }, {
        key: 'recurringFrequency',
        value: function recurringFrequency() {
            var selectedPattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var recurWeeks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var recurringMonthObj = arguments[2];

            var weeks = { 1: 'Every 1st Week', 2: 'Every 2nd Week', 3: 'Every 3rd Week', 4: 'Every 4th Week' };
            var dayOfWeekObj = { 0: 'sunday', 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday' };

            switch (selectedPattern) {
                case 'daily':
                    {
                        return 'Daily';
                    }
                case 'weekly':
                    {
                        return weeks[recurWeeks];
                    }
                case 'monthly':
                    {
                        if (this.selectedMonthlyPattern === 'day') {
                            recurringMonthObj.day.frequencyMonth = this.CommonLayoutService.ordinalSuffixOf(recurringMonthObj.day.monthInterval) + ' Month';
                            recurringMonthObj.day.frequencyDay = this.CommonLayoutService.ordinalSuffixOf(recurringMonthObj.day.dayInterval) + ' Day';
                            return 'Monthly';
                        } else if (this.selectedMonthlyPattern === 'the') {
                            recurringMonthObj.month.frequencyMonth = this.CommonLayoutService.ordinalSuffixOf(recurringMonthObj.month.monthInterval) + ' Month';
                            recurringMonthObj.month.frequencyWeek = weeks[recurringMonthObj.month.weekInterval] + ' (' + dayOfWeekObj[recurringMonthObj.month.selectedWeekDay] + ')';
                            return 'Monthly';
                        }
                    }
                default:
                    return;
            }
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            var _this11 = this;

            this.model = angular.copy(this.defaultModel);
            this.model.branchUnassignedRoute = this.cloneBranchUnassignedRoute;
            this.userBranchList.filter(function (branch) {
                if (branch.branchId == _this11.setupDetails.branchId) {
                    branch.ticked = true;
                    _this11.model.selectedBranch.push(branch);
                } else {
                    branch.ticked = false;
                }
            });

            this.loadLocation('', 0);
            this.loadRoutes('', 0);
            this.setDateRange();
            this.validateRecurringStartDate();
            this.addNewRecord();
            this.getPendingChanges();
        }
    }, {
        key: 'getPendingChanges',
        value: function getPendingChanges() {
            var _this12 = this;

            this.pendingChangesObj = (0, _defineProperty3.default)({
                results: [],
                loading: false,
                currentPage: 1,
                maxPages: 10,
                filteredResults: [],
                pageLimit: 10,
                page: 1,
                totalRecords: 0
            }, 'loading', false);
            setTimeout(function () {
                var startDate = _this12.getStartDate();
                var endDate = _this12.getEndDate();
                var searchText = _this12.model.searchText;
                var branchId = _this12.getSelectedBranches();

                _this12.pendingChangesObj.loading = true;
                _this12.StopSchedulingService.getPendingChanges(startDate, endDate, branchId, searchText).then(function (data) {
                    _this12.pendingChangesObj.results = data.results;
                    _this12.pendingChangesObj.totalRecords = data.results.length;
                    _this12.paginator();
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        _this12.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this12.pendingChangesObj.loading = false;
                    setTimeout(function () {
                        var el = document.getElementById('stopSchedulingSearch');
                        if (el) el.focus();
                    }, 100);
                });
            });
        }
    }, {
        key: 'cancelScheduledStops',
        value: function cancelScheduledStops(jobKey, event) {
            var _this13 = this;

            this.model.deleteStopRecurring = true;
            this.Modal.confirm({
                header: this.$translate.instant('errorModal.title'),
                message: this.$translate.instant('verifyHoldShipments.forceCloseShipments'),
                callback: function callback(_ref3) {
                    var modal = _ref3.modal;

                    _this13.StopSchedulingService.cancelScheduledStops(jobKey).then(function () {
                        _this13.getPendingChanges();
                        event.preventDefault();
                    }).catch(function (err) {
                        if (err && err.data && err.data.message) {
                            _this13.Modal.errorModal(err.data.message);
                        }
                    }).finally(function () {
                        _this13.model.deleteStopRecurring = false;
                    });
                    modal.close();
                },
                buttons: ['common.ok', 'common.cancel'],
                type: 'danger'
            });
        }
    }, {
        key: 'paginator',
        value: function paginator() {
            var begin = (this.pendingChangesObj.currentPage - 1) * this.pendingChangesObj.maxPages;
            var end = begin + this.pendingChangesObj.maxPages;
            this.pendingChangesObj.filteredResults = this.pendingChangesObj.results.slice(begin, end);
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            var begin = (this.pendingChangesObj.page - 1) * this.pendingChangesObj.maxPages;
            var end = begin + this.pendingChangesObj.maxPages;
            this.pendingChangesObj.filteredResults = this.pendingChangesObj.results.slice(begin, end);
        }
    }, {
        key: 'splitKey',
        value: function splitKey(key) {
            if (!key) return;
            return key.split(' | ')[1];
        }
    }, {
        key: 'editLocation',
        value: function editLocation(locationId) {
            this.Navigation.goToLocationTab(locationId);
        }
    }, {
        key: 'getSelectedBranches',
        value: function getSelectedBranches() {
            return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map(function (branch) {
                return branch.branchId;
            }) : null;
        }
    }, {
        key: 'capitalizeFirstLetter',
        value: function capitalizeFirstLetter(value) {
            if (typeof value !== 'string') return;else return value.charAt(0).toUpperCase() + value.slice(1);
        }
    }, {
        key: 'refreshPendingChanges',
        value: function refreshPendingChanges(event) {
            this.getPendingChanges();
            event.preventDefault();
        }
    }, {
        key: 'formatAddress',
        value: function formatAddress(data) {
            var locationAddress = '';
            if (data.address) locationAddress = locationAddress.concat(data.address, ', ');
            if (data.city) locationAddress = locationAddress.concat(data.city, ', ');
            if (data.zip) locationAddress = locationAddress.concat(data.zip, ', ');
            if (data.state) locationAddress = locationAddress.concat(data.state, ', ');
            if (data.country) locationAddress = locationAddress.concat(data.country);
            return locationAddress;
        }
    }]);
    return StopSchedulingController;
}();

exports.default = StopSchedulingController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tankers = __webpack_require__(1810);

var _tankers2 = _interopRequireDefault(_tankers);

var _print = __webpack_require__(1807);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementTankersModule = angular.module('branchManagementTankersHistory', [_print2.default]).component('branchManagementTankersHistory', _tankers2.default).name;

exports.default = branchManagementTankersModule;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _print_tankers = __webpack_require__(1808);

var _print_tankers2 = _interopRequireDefault(_print_tankers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printTankersModule = angular.module('printTankers', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider.otherwise('/tankers-history');

	$stateProvider.state('printTankers', {
		url: '/print-tankers',
		component: 'printTankers',
		data: {
			requireLogin: true
		}
	});
}]).component('printTankers', _print_tankers2.default).name;

exports.default = printTankersModule;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_tankers = __webpack_require__(2703);

var _print_tankers2 = _interopRequireDefault(_print_tankers);

var _print_tankers3 = __webpack_require__(1809);

var _print_tankers4 = _interopRequireDefault(_print_tankers3);

__webpack_require__(2985);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printTankersComponent = {
  restrict: 'E',
  bindings: {},
  template: _print_tankers2.default,
  controller: _print_tankers4.default
};

exports.default = printTankersComponent;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintTankersController = function () {
    /*@ngInject*/
    PrintTankersController.$inject = ["$state", "$stateParams", "$translate", "TransactionService"];
    function PrintTankersController($state, $stateParams, $translate, TransactionService) {
        (0, _classCallCheck3.default)(this, PrintTankersController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.TransactionService = TransactionService;
        this.model = {
            tankerList: [],
            isLoading: false
        };
    }

    (0, _createClass3.default)(PrintTankersController, [{
        key: '$onInit',
        value: function $onInit() {
            var printData = undefined;
            if (window.opener && window.opener.w && window.opener.w.printData) {
                printData = window.opener.w.printData;
                this.model.limit = printData.limit;
                this.model.selectedValue = printData.selectedValue;
                this.model.dateRange = printData.dateRange;
                this.printTankerContent();
            }
        }
    }, {
        key: 'printTankerContent',
        value: function printTankerContent() {
            var _this = this;

            if (this.model.isLoading) return;
            this.model.isLoading = true;
            var filter = {};
            filter.locationId = this.model.selectedValue;
            if (this.model.dateRange.startDate && this.model.dateRange.endDate) {
                filter.transactionDate = {
                    start: moment(this.model.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
                    end: moment(this.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                };
            }

            return this.TransactionService.currentContent(filter, 0, this.model.limit).then(function (data) {
                if (data.result.length) {
                    _this.model.tankerList = data.result;
                    _this.model.isLoading = false;
                    setTimeout(function () {
                        window.print();
                    }, 2000);
                }
            }).catch(function (err) {
                _this.error = err.message;
                _this.model.isLoading = false;
            });
        }
    }, {
        key: 'translateTranType',
        value: function translateTranType(tranType) {
            if (!tranType) return;
            return this.$translate.instant('shipment.' + tranType).toUpperCase();
        }
    }]);
    return PrintTankersController;
}();

exports.default = PrintTankersController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tankers = __webpack_require__(2704);

var _tankers2 = _interopRequireDefault(_tankers);

var _tankers3 = __webpack_require__(1811);

var _tankers4 = _interopRequireDefault(_tankers3);

__webpack_require__(2986);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementTankersComponent = {
  restrict: "E",
  bindings: {},
  template: _tankers2.default,
  controller: _tankers4.default
};

exports.default = branchManagementTankersComponent;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TankersController = function () {
  /*@ngInject*/
  TankersController.$inject = ["Auth", "$state", "User", "$scope", "RouteService", "$translate", "LocationService", "DataCounter", "$q", "Modal", "BranchService", "TransactionService", "DateUtil", "SetupService", "$rootScope"];
  function TankersController(Auth, $state, User, $scope, RouteService, $translate, LocationService, DataCounter, $q, Modal, BranchService, TransactionService, DateUtil, SetupService, $rootScope) {
    (0, _classCallCheck3.default)(this, TankersController);

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.BranchService = BranchService;
    this.DataCounter = DataCounter;
    this.$q = $q;
    this.$scope = $scope;
    this.Modal = Modal;
    this.TransactionService = TransactionService;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.$rootScope = $rootScope;
    this.model = {
      tanker: {
        data: ''
      },
      search: "",
      branch: this.User.getUser().branchId,
      dateRange: {
        startDate: null,
        endDate: null
      },

      // date range picker for Tanker tab
      dateRangPickerOptions: {}

    };
    this.stats = {
      currentContents: 'currentContents',
      contentsHistory: 'contentsHistory'
    };
    this.currentStats = 'currentContents';
    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: 10,
      maxPages: 10
    };

    this.routes = [];
    this.allRoutes = [];
    this.branches = [];
    this.tankerData = [];
    this.tankersData = [];
    this.currentTankersData = [];
    this.totalCurrentTanker = 0;
    this.routeData = [];
    this.tankers = [];
    this.lastScanned = "";
    this.currentVaultDate = "";
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/tankers');
  }

  // get only TANKER data


  (0, _createClass3.default)(TankersController, [{
    key: 'loadTanker',
    value: function loadTanker(searchKey, offset) {
      var _this = this;

      searchKey = searchKey || '';
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'locationType',
            condition: '=',
            data: 'TANKER'
          }, {
            field: 'branchId',
            condition: '=',
            data: this.User.getUser().branchId
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      this.LocationService.getAllLocation(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {

        if (offset === 0 || offset == undefined) {
          _this.totalTanker = data.total;
          _this.tankers = _this.mapData(data.results);
        } else {
          var tankers = _this.mapData(data.results);
          _this.tankers = _this.tankers.concat(tankers);
        }
      });
    }
  }, {
    key: 'mapData',
    value: function mapData(arrayObj) {
      return arrayObj.map(function (obj) {
        return {
          Key: obj.id + ' | ' + obj.name,
          Value: obj.id
        };
      });
    }
  }, {
    key: 'loadPermission',
    value: function loadPermission() {
      var _this2 = this;

      this.acl = {};
      this.hasACL = {};

      [].forEach(function (permissionKey) {
        _this2.acl[permissionKey] = _this2.User.getACL(permissionKey);

        _this2.hasACL[permissionKey] = {};

        _this2.acl[permissionKey].forEach(function (permission) {
          _this2.hasACL[permissionKey][permission] = true;
        });
      });
    }

    // do not allow to paste string into datepicker

  }, {
    key: 'dontAllow',
    value: function dontAllow(element) {
      element.on('cut copy paste', function (event) {
        event.preventDefault();
      });
    }
  }, {
    key: 'setDateRange',
    value: function setDateRange(date) {
      var _this3 = this;

      var currentVaultDate = moment(date).format() || moment();
      this.model.dateRangPickerOptions = {
        autoApply: true,
        // maxDate: moment(currentVaultDate).endOf('day').format('YYYY-MM-DD'),
        eventHandlers: {
          'apply.daterangepicker': function applyDaterangepicker() {
            if (_this3.currentStats == 'currentContents') {
              _this3.pagination.page = 1;
              _this3.loadCurrentContent();
            } else if (_this3.currentStats == 'contentsHistory') {
              _this3.pagination.page = 1;
              _this3.loadDataOfTankersHistory(_this3.model.dateRanges);
            }
          }
        },
        ranges: {
          'Today': [moment(currentVaultDate).format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).format('YYYY-MM-DD HH:mm:ss')],
          'Current Week': [moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')],
          'Current Month': [moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')]
        }
      };
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this4 = this;

      this.$q.all([
      // this.RouteService.all(null, 0, 1000),
      // this.BranchService.all(null, 0, 1000),
      this.SetupService.get(this.User.getUser().branchId)]).then(function (data) {
        // const routes = data[0].results;
        // const branches = data[1].results;
        // this.branches = branches;
        _this4.currentVaultDate = _this4.DateUtil.getUTCDate(data[0].currentVaultDate);
        _this4.setDateRange(_this4.currentVaultDate);
        _this4.model.dateRange.startDate = moment(_this4.currentVaultDate).format('YYYY-MM-DD 00:00:00');
        _this4.model.dateRange.endDate = moment(_this4.currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }).then(function () {
        _this4.loadPermission();
        if (_this4.currentStats == 'currentContents') {
          _this4.loadTanker('', 0);
        } else if (_this4.currentStats == 'contentsHistory') {}
      }).catch(function (err) {
        console.log(err);
      });

      this.model.errorMsg = this.$translate.instant('error.branch_mgmt.tanker');
      this.model.noItemDisplay = true;
      this.model.isError = true;
    }

    // branchChanged() {
    //   this.tankerData = this.tankers.filter((shipments) => {
    //     if (shipments.branchId == this.User.getUser().branchId) {
    //       return shipments.branchId === this.User.getUser().branchId;
    //     }
    //     else {
    //       this.model.noItemDisplay = true;
    //       this.tankersData = [];
    //       this.model.tanker.data = "";
    //     }
    //   })
    //   this.loadTanker('', 0);
    // }

  }, {
    key: 'pageChange',
    value: function pageChange() {
      if (this.currentStats == 'currentContents') {
        this.loadCurrentContent();
      } else if (this.currentStats == 'contentsHistory') {
        this.loadDataOfTankersHistory(this.model.dateRanges);
      }
    }
  }, {
    key: 'generateSearchObjs',
    value: function generateSearchObjs() {
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'tranType',
            condition: '!=',
            data: null
          }, {
            group: {
              rules: [{
                field: 'fromLocationId',
                condition: '=',
                data: this.model.tanker.data.Value
              }, {
                field: 'toLocationId',
                condition: '=',
                data: this.model.tanker.data.Value
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      if (this.model.dateRange.startDate && this.model.dateRange.endDate) {
        searchObj.queryJSON.rules.push({
          field: 'transactionDate',
          condition: 'BETWEEN',
          data: [moment(this.model.dateRange.startDate).format('YYYY-MM-DD 00:00:00'), moment(this.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')]
        });
      }
      return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    // Get data of Tanker

  }, {
    key: 'loadDataOfTankersHistory',
    value: function loadDataOfTankersHistory() {
      var _this5 = this;

      if (this.model.tanker.data && this.model.tanker.data.Value) {
        var searchObj = this.generateSearchObjs();
        this.model.loading = true;

        if (this.model.tanker.data.Value != this.lastScanned) {
          this.pagination.page = 1;
        }

        return this.TransactionService.all(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit).then(function (data) {
          if (data.results.length) {
            _this5.pagination.total = data.total;
            _this5.lastScanned = _this5.model.tanker.data.Value;
            _this5.pagination.loading = false;
            _this5.tankersData = data.results;
            _this5.model.isError = false;
            _this5.model.noItemDisplay = false;
            _this5.localDateTime = moment(_this5.currentVaultDate).format('MM-DD-YYYY');
            _this5.isTanker = true;
          } else {
            _this5.model.noItemDisplay = true;
            _this5.model.messages = _this5.$translate.instant('error.branch_mgmt.tanker_found');
            _this5.tankersData = [];
          }
        }).catch(function (err) {
          console.log(err);
          _this5.error = err.message;
        }).finally(function () {
          _this5.model.loading = false;
        });
      } else {
        this.tankersData = [];
        this.model.messages = false;
        this.model.errorMsg = this.$translate.instant('error.branch_mgmt.tanker');
        this.model.noItemDisplay = true;
        this.model.isError = true;
      }
    }
  }, {
    key: 'tabSelection',
    value: function tabSelection(selectedValue) {
      if (selectedValue == 'currentContents') {
        this.pagination.page = 1;
        this.loadCurrentContent();
      } else if (selectedValue == 'contentsHistory') {
        this.pagination.page = 1;
        this.loadDataOfTankersHistory();
      }
      this.currentStats = selectedValue;
    }
  }, {
    key: 'loadCurrentContent',
    value: function loadCurrentContent() {
      var _this6 = this;

      if (this.model.loading) return;
      if (this.model.tanker.data && this.model.tanker.data.Value) {
        this.model.loading = true;

        if (this.model.tanker.data.Value != this.lastScanned) {
          this.pagination.page = 1;
        }
        var filter = {};
        filter.locationId = this.model.tanker.data.Value;

        if (this.model.dateRange.startDate && this.model.dateRange.endDate) {
          filter.transactionDate = {
            start: moment(this.model.dateRange.startDate).format('YYYY-MM-DD'),
            end: moment(this.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD')
          };
        }

        return this.TransactionService.currentContent(filter, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit).then(function (data) {
          if (data.result.length) {
            _this6.pagination.total = data.total;
            _this6.lastScanned = _this6.model.tanker.data.Value;
            _this6.currentTankersData = data.result;
            _this6.totalCurrentTanker = data.total;
            _this6.model.isError = false;
            _this6.model.noItemDisplay = false;
            _this6.localDateTime = moment(_this6.currentVaultDate).format('MM-DD-YYYY');
            _this6.pagination.loading = false;
          } else {
            _this6.model.noItemDisplay = true;
            _this6.model.messages = _this6.$translate.instant('error.branch_mgmt.tanker_found');
            _this6.currentTankersData = [];
            _this6.totalCurrentTanker = 0;
          }
        }).catch(function (err) {
          console.log(err);
          _this6.error = err.message;
        }).finally(function () {
          _this6.model.loading = false;
        });
      } else {
        this.currentTankersData = [];
        this.totalCurrentTanker = 0;
        this.model.messages = false;
        this.model.errorMsg = this.$translate.instant('error.branch_mgmt.tanker');
        this.model.noItemDisplay = true;
        this.model.isError = true;
      }
    }
  }, {
    key: 'browserTZ',
    value: function browserTZ() {
      return moment.tz.guess();
    }
  }, {
    key: 'getLocalTime',
    value: function getLocalTime() {
      return moment().format('hh:mm A');
    }
  }, {
    key: 'printTankerContent',
    value: function printTankerContent() {
      var obj = {
        selectedValue: this.model.tanker.data.Value,
        dateRange: this.model.dateRange,
        limit: this.totalCurrentTanker
      };
      var path = this.$state.href('printTankers');
      window.w = window.open(path, '_blank');
      window.w.printData = obj;
    }
  }, {
    key: 'goToItemHoldTab',
    value: function goToItemHoldTab(trackingId) {
      var obj = {
        trackingId: trackingId,
        isRedirected: true
      };
      this.DataCounter.setData(obj);
      this.$state.go('branchManagement.itemHolds');
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(locationId) {
      var obj = {
        locationId: locationId,
        isRedirected: true
      };
      this.DataCounter.setData(obj);
      this.$state.go('branchManagement.locations');
    }
  }, {
    key: 'translateTranType',
    value: function translateTranType(tranType) {
      if (!tranType) return;
      return this.$translate.instant('shipment.' + tranType).toUpperCase();
    }
  }, {
    key: 'goToItemHistory',
    value: function goToItemHistory(trackingId) {
      this.$state.go('branchManagement.items', {
        id: trackingId
      });
    }
  }]);
  return TankersController;
}();

exports.default = TankersController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tnt_bypass_code = __webpack_require__(1813);

var _tnt_bypass_code2 = _interopRequireDefault(_tnt_bypass_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementTntBypassCodeModule = angular.module('branchManagementTntBypassCode', []).component('branchManagementTntBypassCode', _tnt_bypass_code2.default).name;

exports.default = branchManagementTntBypassCodeModule;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tnt_bypass_code = __webpack_require__(2705);

var _tnt_bypass_code2 = _interopRequireDefault(_tnt_bypass_code);

var _tnt_bypass_code3 = __webpack_require__(1814);

var _tnt_bypass_code4 = _interopRequireDefault(_tnt_bypass_code3);

__webpack_require__(2987);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementTntBypassCodeComponent = {
  restrict: "E",
  bindings: {},
  template: _tnt_bypass_code2.default,
  controller: _tnt_bypass_code4.default
};

exports.default = branchManagementTntBypassCodeComponent;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import _ from 'lodash';
var LIMIT = 10;
var MAXLIMIT = 1000;

var TNTBypassCodeController = function () {
    /*@ngInject*/
    TNTBypassCodeController.$inject = ["Auth", "$state", "User", "UsersService", "DateUtil", "RouteService", "$translate", "$q", "Modal", "BranchService", "LocationService", "BypassCodeService", "SetupService", "RouteStopService", "$rootScope"];
    function TNTBypassCodeController(Auth, $state, User, UsersService, DateUtil, RouteService, $translate, $q, Modal, BranchService, LocationService, BypassCodeService, SetupService, RouteStopService, $rootScope) {
        (0, _classCallCheck3.default)(this, TNTBypassCodeController);

        this.BranchService = BranchService;
        this.UsersService = UsersService;
        this.DateUtil = DateUtil;
        this.RouteService = RouteService;
        this.LocationService = LocationService;
        this.BypassCodeService = BypassCodeService;
        this.Modal = Modal;
        this.SetupService = SetupService;
        this.User = User;
        this.Auth = Auth;
        this.RouteStopService = RouteStopService;
        this.$translate = $translate;
        this.$q = $q;
        this.$state = $state;
        this.$rootScope = $rootScope;

        this.model = {
            generatingCode: false,
            routeId: null,
            branchId: null,
            userId: null,
            locationId: null,
            selectedIssue: null,
            comments: null,
            trackingId: null,
            bypassCode: null,
            supvApproveId: 0,
            canNotScanLocation: false,
            type: null,
            userListObj: {
                userList: [],
                totalRecords: 0
            },
            routeListObj: {
                routeList: [],
                totalRecords: 0
            },
            branchList: [],
            allUsers: [],
            allBypassCodeData: [],
            locationLists: [],
            locationListObj: {
                locationList: [],
                totalRecords: 0
            },
            currentDate: new Date(),
            loading: true,
            bypassCodeList: [],
            totalBypassCode: 0,
            isCoinCheckOut: 0,
            vaultDate: null,
            issueList: [{
                lable: $translate.instant('branch_mgmt.tnt_bypass_code.cant_scan_location'),
                value: "cant_scan_location"
            }, {
                lable: $translate.instant('branch_mgmt.tnt_bypass_code.cant_load_truck'),
                value: "cant_load_truck"
            }, {
                lable: $translate.instant('branch_mgmt.tnt_bypass_code.cant_scan_delivery'),
                value: "cant_scan_delivery"
            }, {
                lable: $translate.instant('branch_mgmt.tnt_bypass_code.skip_delivery'),
                value: "skip_delivery"
            }, {
                lable: $translate.instant('branch_mgmt.tnt_bypass_code.cant_close_atm'),
                value: "cant_close_atm"
            }],
            bypassCodeTypeMap: {
                cant_scan_location: 'LocationArrival',
                cant_load_truck: 'LoadPickup',
                cant_scan_delivery: 'UnloadDelivery',
                // 'DeliverDelivery'
                skip_delivery: 'SkipDeliveries',
                cant_close_atm: 'CantCloseAtm',
                override_close: 'OverrideClose'
            },
            currentBranch: User.getUser().branchId,
            paginationObj: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            loggedInUserId: User.getUser().id
        };
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/TNT-bypass-code');
    }

    (0, _createClass3.default)(TNTBypassCodeController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$q.all([this.BranchService.all(null, 0, MAXLIMIT), this.loadPermission()]).then(function (data) {
                _this.model.branchList = data[0].results;
                _this.getAllBypassCode();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'loadPermission',
        value: function loadPermission() {
            var _this2 = this;

            this.acl = {};
            this.hasACL = {};

            ['branch_mgmt_tnt_bypass_code'].forEach(function (permissionKey) {
                _this2.acl[permissionKey] = _this2.User.getACL(permissionKey);
                _this2.acl[permissionKey].forEach(function (permission) {
                    _this2.hasACL[permission] = true;
                });
            });
        }
    }, {
        key: 'branchChanged',
        value: function branchChanged() {
            var _this3 = this;

            this.model.routeId = null;
            this.model.locationId = null;
            this.model.userId = null;
            this.model.locationListObj.locationList = [];
            this.model.locationListObj.totalRecords = 0;
            this.model.paginationObj.page = 1;

            this.SetupService.get(this.model.branchId).then(function (setup) {
                var currentVaultDate = _this3.DateUtil.convertToDate(setup.currentVaultDate);
                var formattedDate = moment(currentVaultDate).format('YYYY-MM-DD');
                _this3.model.vaultDate = formattedDate;
                _this3.model.isCoinCheckOut = setup.coinCheckOut;
            }).then(function () {
                _this3.getAllBypassCode();
                _this3.getRouteData();
                _this3.getAllLocation('', 0);
                _this3.getAllUsers('', 0);
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this3.Modal.errorModal('error.' + err.data.message);
                }
            });
        }
    }, {
        key: 'locationListSearchObj',
        value: function locationListSearchObj(searchKey) {
            searchKey = searchKey || '';

            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: "locationType",
                                condition: "=",
                                data: "REGULAR"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "NO_SHIP_NO_GO"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "ATM"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "BANK"
                            }, {
                                field: "locationType",
                                condition: "=",
                                data: "ON_CALL"
                            }],
                            operator: "OR"
                        }
                    }, {
                        group: {
                            rules: [{
                                field: "id",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "name",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };

            if (this.model.selectedIssue === 'cant_scan_delivery' || this.model.selectedIssue === 'skip_delivery') {
                searchObj.queryJSON.rules[1].group.rules.push({
                    field: "locationType",
                    condition: "=",
                    data: "DELIVERY"
                });
            }

            if (this.model.selectedIssue === 'cant_close_atm' || this.model.selectedIssue === 'override_close') {
                searchObj.queryJSON.rules[1].group.rules = [];
                searchObj.queryJSON.rules[1].group.rules.push({
                    field: "locationType",
                    condition: "=",
                    data: "ATM"
                });
            }

            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'getAllLocation',
        value: function getAllLocation(searchKey, offset) {
            var _this4 = this;

            searchKey = searchKey || '';

            if (this.model.selectedIssue !== 'cant_load_truck') {
                this.LocationService.getAllLocation(this.locationListSearchObj(searchKey), offset, LIMIT).then(function (data) {
                    if (offset === 0 || offset == undefined) {
                        _this4.model.locationListObj.totalRecords = data.total;
                        _this4.model.locationListObj.locationList = _this4.locationListMap(data.results);
                    } else {
                        var locations = _this4.locationListMap(data.results);
                        _this4.model.locationListObj.locationList = _this4.model.locationListObj.locationList.concat(locations);
                    }
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this4.Modal.errorModal(err.data.message);
                    }
                });
            } else {
                if (this.model.routeId) return this.getRouteStops(searchKey, offset);
            }
        }
    }, {
        key: 'locationListMap',
        value: function locationListMap(locations) {
            return locations.map(function (l) {
                return {
                    Key: l.id + " | " + l.name,
                    Value: l.id,
                    Obj: l
                };
            });
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            if (this.model.branchId !== null) {
                this.model.locationId = "";
                this.getAllLocation('', 0);
            }
        }
    }, {
        key: 'userListSearchObj',
        value: function userListSearchObj(searchKey) {
            searchKey = searchKey || '';

            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: 'downloadToHHT',
                                condition: '=',
                                data: true
                            }, {
                                field: 'email',
                                condition: '!=',
                                data: null
                            }, {
                                field: 'supervisor',
                                condition: '=',
                                data: true
                            }, {
                                field: 'serviceUser',
                                condition: '=',
                                data: true
                            }, {
                                field: 'customerUser',
                                condition: '=',
                                data: true
                            }],
                            operator: "OR"
                        }
                    }, {
                        group: {
                            rules: [{
                                field: "id",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "firstName",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "lastName",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'getAllUsers',
        value: function getAllUsers(searchKey, offset) {
            var _this5 = this;

            searchKey = searchKey || '';

            this.UsersService.all(this.userListSearchObj(searchKey), offset, LIMIT).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this5.model.userListObj.totalRecords = data.total;
                    _this5.model.userListObj.userList = _this5.userListMap(data.results);
                } else {
                    var users = _this5.userListMap(data.results);
                    _this5.model.userListObj.userList = _this5.model.userListObj.userList.concat(users);
                }
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this5.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'userListMap',
        value: function userListMap(users) {
            return users.map(function (u) {
                return {
                    Key: u.id + " | " + u.firstName + " " + u.lastName,
                    Value: u.id
                };
            });
        }
    }, {
        key: 'routeStopSearchObj',
        value: function routeStopSearchObj(searchKey) {
            searchKey = searchKey || '';

            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "routeId",
                        condition: "=",
                        data: this.model.routeId.Value
                    }, {
                        field: "routeDate",
                        condition: "=",
                        data: this.model.vaultDate
                    }, {
                        group: {
                            rules: [{
                                field: "locationId",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'getRouteStops',
        value: function getRouteStops(searchKey, offset) {
            var _this6 = this;

            searchKey = searchKey || null;

            this.RouteStopService.all(this.routeStopSearchObj(searchKey), offset, LIMIT).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this6.model.locationListObj.totalRecords = data.total;
                    _this6.model.locationListObj.locationList = _this6.locationMap(data.results);
                } else {
                    var locations = _this6.locationMap(data.results);
                    _this6.model.locationListObj.locationList = _this6.model.locationListObj.locationList.concat(locations);
                }
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this6.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'locationMap',
        value: function locationMap(data) {
            return data.map(function (d) {
                return {
                    Key: d.location.id + " | " + d.location.name,
                    Value: d.location.id
                };
            });
        }
    }, {
        key: 'getRouteData',
        value: function getRouteData() {
            var _this7 = this;

            this.BranchService.getReleaseRoutes(this.model.branchId, this.model.vaultDate, this.model.isCoinCheckOut).then(function (data) {
                _this7.model.routeListObj.routeList = _this7.routeListMap(data);
                _this7.model.routeListObj.totalRecords = data.length;
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this7.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'routeListMap',
        value: function routeListMap(routes) {
            return routes.map(function (r) {
                return {
                    Key: r.routeId + " | " + r.routeName,
                    Value: r.routeId
                };
            });
        }
    }, {
        key: 'confirmSupervisor',
        value: function confirmSupervisor() {
            var _this8 = this;

            if (this.isLoading) return;
            this.isLoading = true;

            var allPromise = [],
                errors = '';

            this.Modal.confirmSupervisor('generate-bypass-code', null, function (_ref) {
                var modal = _ref.modal,
                    supId = _ref.supId;

                _this8.model.supvApproveId = supId;

                if (_this8.hasACL.overrideClose && _this8.model.selectedIssue === 'cant_close_atm') {
                    allPromise.push(_this8.closeLock());

                    _this8.$q.all(allPromise).then(function (_ref2) {
                        var _ref3 = (0, _slicedToArray3.default)(_ref2, 1),
                            results = _ref3[0];

                        if (results && results.data && results.data.length > 0) {
                            if (results.data[0].result === 0) {
                                _this8.generateBypassCode();
                            } else if (results.data[0].result === 1) {
                                if (_this8.hasACL && _this8.hasACL.overrideClose) {
                                    var issueExists = _this8.model.issueList.some(function (issue) {
                                        return issue.value === 'override_close';
                                    });
                                    if (!issueExists) {
                                        _this8.model.issueList.push({
                                            lable: _this8.$translate.instant('branch_mgmt.tnt_bypass_code.override_close'),
                                            value: "override_close"
                                        });
                                    }
                                }
                                errors += results.data[0].message;
                                errors += '\n------- (If the lock doesn\'t close, you can generate a bypass code using the "Override Close" option.)';
                                _this8.Modal.errorModal(errors);
                            }
                        }
                    }).catch(function (err) {
                        _this8.Modal.errorModal(err);
                    }).finally(function () {
                        modal.close();
                        _this8.isLoading = false;
                    });
                } else {
                    modal.close();
                    _this8.generateBypassCode();
                }
            }, function (_ref4) {
                var modal = _ref4.modal;

                if (modal) modal.close();
                _this8.isLoading = false;
            });
        }
    }, {
        key: 'bypassCodeSearchObj',
        value: function bypassCodeSearchObj() {
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branchId ? this.model.branchId : this.model.currentBranch
                    }],
                    operator: 'AND'
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'getAllBypassCode',
        value: function getAllBypassCode() {
            var _this9 = this;

            this.model.loading = true;

            this.BypassCodeService.all(this.bypassCodeSearchObj(), (this.model.paginationObj.page - 1) * this.model.paginationObj.pageLimit, this.model.paginationObj.pageLimit).then(function (data) {
                _this9.model.bypassCodeList = data.results;
                _this9.model.totalBypassCode = data.total;
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this9.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this9.model.loading = false;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            if (this.model.selectedIssue && this.model.selectedIssue === 'override_close') {
                this.model.issueList = this.model.issueList.filter(function (d) {
                    return d.value !== 'override_close';
                });
            }
            this.model.routeId = null;
            this.model.userId = null;
            this.model.locationId = null;
            this.model.comments = null;
            this.model.trackingId = null;
            // this.model.bypassCode = null;
            this.model.supvApproveId = 0;
            this.model.selectedIssue = null;
            this.model.locationListObj.locationList = [];
            this.model.locationListObj.totalRecords = 0;
            this.model.paginationObj.page = 1;
            this.model.closeCode = null;
        }
    }, {
        key: 'resetLocationObj',
        value: function resetLocationObj() {
            if (this.model.selectedIssue === 'cant_load_truck' && !this.model.routeId) {
                this.model.locationListObj.locationList = [];
                this.model.locationListObj.totalRecords = 0;
            }
            this.model.closeCode = null;
        }
    }, {
        key: 'getRouteStopList',
        value: function getRouteStopList() {
            if (this.model.selectedIssue === 'cant_load_truck' && this.model.routeId) {
                return this.getRouteStops('', 0);
            }
        }
    }, {
        key: 'createBypassCode',
        value: function createBypassCode() {
            var _this10 = this;

            var type = this.model.selectedIssue;
            var branchId = this.model.branchId;
            var routeId = this.model.routeId.Value;
            var userId = this.model.userId.Value;
            var locationId = this.model.locationId.Value;
            var comments = this.model.comments;
            var bypassCode = this.model.bypassCode;
            var supvApproveId = this.model.supvApproveId;

            this.BypassCodeService.create({ type: type, branchId: branchId, routeId: routeId, userId: userId, locationId: locationId, comments: comments, bypassCode: bypassCode, supvApproveId: supvApproveId }).then(function (data) {
                _this10.reset();
                _this10.getAllBypassCode();
            }).catch(function (err) {
                var errorCode = err && err.data && err.data.message;
                if (errorCode) {
                    if (err.data.errors[0].path === 'bypasscode_tracking_id_unique') {
                        _this10.bypassCodeThrowError = _this10.$translate.instant('error.trackingIdUnique');
                    } else {
                        _this10.bypassCodeThrowError = _this10.$translate.instant('error.bypassCodeNotGenerate');
                    }
                    _this10.Modal.errorModal(_this10.bypassCodeThrowError);
                } else {
                    console.log(err);
                }
            }).finally(function () {
                _this10.isLoading = false;
            });
        }
    }, {
        key: 'generateBypassCode',
        value: function generateBypassCode() {
            var _this11 = this;

            this.model.generatingCode = true;

            var type = this.model.bypassCodeTypeMap[this.model.selectedIssue];
            var branchId = this.model.branchId;
            var routeId = this.model.routeId.Value;
            var userId = this.model.userId.Value;
            var locationId = this.model.locationId.Value;
            var vaultDate = this.model.vaultDate;

            this.BypassCodeService.generateBypassCode(type, branchId, routeId, userId, vaultDate, locationId).then(function (data) {
                _this11.model.bypassCode = data.code;
                _this11.createBypassCode();
            }).catch(function (err) {
                console.log(err);
                _this11.isLoading = false;
                _this11.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this11.model.generatingCode = false;
            });
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.getAllBypassCode();
        }
    }, {
        key: 'translateIssue',
        value: function translateIssue(message) {
            if (!message || message === 'Location') return;
            return this.$translate.instant('branch_mgmt.tnt_bypass_code.' + message);
        }
    }, {
        key: 'closeLock',
        value: function closeLock() {
            var _this12 = this;

            var branchId = this.model.branchId;
            var userId = this.model.userId.Value;
            var locationId = this.model.locationId.Value;
            var OTCCompanyName = this.model.locationId.Obj.OTCCompanyName;
            var closecode = this.model.closeCode;
            var locktype = this.model.locationId.Obj.lockType;

            var data = { userId: userId, company: OTCCompanyName, serno: locationId, closecode: closecode, empid: userId, locktype: locktype, branchId: branchId };
            return this.BypassCodeService.closeLock(data).then(function (results) {
                return results;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this12.Modal.errorModal(err.data.message);
                }
            });
        }
    }]);
    return TNTBypassCodeController;
}();

exports.default = TNTBypassCodeController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch_management = __webpack_require__(1685);

var _branch_management2 = _interopRequireDefault(_branch_management);

var _routes = __webpack_require__(1794);

var _routes2 = _interopRequireDefault(_routes);

var _item_holds = __webpack_require__(1753);

var _item_holds2 = _interopRequireDefault(_item_holds);

var _location_holds = __webpack_require__(1762);

var _location_holds2 = _interopRequireDefault(_location_holds);

var _items = __webpack_require__(1756);

var _items2 = _interopRequireDefault(_items);

var _locations = __webpack_require__(1764);

var _locations2 = _interopRequireDefault(_locations);

var _bagouts = __webpack_require__(1692);

var _bagouts2 = _interopRequireDefault(_bagouts);

var _orders = __webpack_require__(1779);

var _orders2 = _interopRequireDefault(_orders);

var _tankers = __webpack_require__(1806);

var _tankers2 = _interopRequireDefault(_tankers);

var _bypass_code = __webpack_require__(1707);

var _bypass_code2 = _interopRequireDefault(_bypass_code);

var _daily_balance_sheet = __webpack_require__(1731);

var _daily_balance_sheet2 = _interopRequireDefault(_daily_balance_sheet);

var _monthly_report = __webpack_require__(1776);

var _monthly_report2 = _interopRequireDefault(_monthly_report);

var _deleted_shipments = __webpack_require__(1740);

var _deleted_shipments2 = _interopRequireDefault(_deleted_shipments);

var _cancelled_shipments = __webpack_require__(1710);

var _cancelled_shipments2 = _interopRequireDefault(_cancelled_shipments);

var _branch_performance = __webpack_require__(1704);

var _branch_performance2 = _interopRequireDefault(_branch_performance);

var _final_residual_count_commit = __webpack_require__(1746);

var _final_residual_count_commit2 = _interopRequireDefault(_final_residual_count_commit);

var _cash_deliveries = __webpack_require__(1713);

var _cash_deliveries2 = _interopRequireDefault(_cash_deliveries);

var _tnt_bypass_code = __webpack_require__(1812);

var _tnt_bypass_code2 = _interopRequireDefault(_tnt_bypass_code);

var _physical_cash_count = __webpack_require__(1785);

var _physical_cash_count2 = _interopRequireDefault(_physical_cash_count);

var _lock_open_errors = __webpack_require__(1770);

var _lock_open_errors2 = _interopRequireDefault(_lock_open_errors);

var _billing_approval = __webpack_require__(1698);

var _billing_approval2 = _interopRequireDefault(_billing_approval);

var _count_variances = __webpack_require__(1722);

var _count_variances2 = _interopRequireDefault(_count_variances);

var _restore_route_assignments = __webpack_require__(1791);

var _restore_route_assignments2 = _interopRequireDefault(_restore_route_assignments);

var _stop_performance = __webpack_require__(1800);

var _stop_performance2 = _interopRequireDefault(_stop_performance);

var _customer_pickup_reports = __webpack_require__(1725);

var _customer_pickup_reports2 = _interopRequireDefault(_customer_pickup_reports);

var _contact_request = __webpack_require__(1716);

var _contact_request2 = _interopRequireDefault(_contact_request);

var _import_file_view = __webpack_require__(1752);

var _import_file_view2 = _interopRequireDefault(_import_file_view);

var _stop_scheduling = __webpack_require__(1803);

var _stop_scheduling2 = _interopRequireDefault(_stop_scheduling);

var _bin_manifest = __webpack_require__(1701);

var _bin_manifest2 = _interopRequireDefault(_bin_manifest);

var _deposit_reports = __webpack_require__(1743);

var _deposit_reports2 = _interopRequireDefault(_deposit_reports);

var _averageDailyVaultBalance = __webpack_require__(1689);

var _averageDailyVaultBalance2 = _interopRequireDefault(_averageDailyVaultBalance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branchManagementModule = angular.module('branchManagement', [_routes2.default, _item_holds2.default, _location_holds2.default, _items2.default, _orders2.default, _locations2.default, _bagouts2.default, _tankers2.default, _bypass_code2.default, _daily_balance_sheet2.default, _monthly_report2.default, _deleted_shipments2.default, _cancelled_shipments2.default, _branch_performance2.default, _final_residual_count_commit2.default, _cash_deliveries2.default, _tnt_bypass_code2.default, _physical_cash_count2.default, _lock_open_errors2.default, _billing_approval2.default, _count_variances2.default, _restore_route_assignments2.default, _stop_performance2.default, _customer_pickup_reports2.default, _contact_request2.default, _import_file_view2.default, _stop_scheduling2.default, _bin_manifest2.default, _deposit_reports2.default, _averageDailyVaultBalance2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('branchManagement.routes', {
    url: '/routes',
    component: 'branchManagementRoutes',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_routes.all'
    }
  }).state('branchManagement.itemHolds', {
    url: '/item-holds',
    component: 'branchManagementItemHolds',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_item_holds.all'
    }
  }).state('branchManagement.locationHolds', {
    url: '/location-holds',
    component: 'branchManagementLocationHolds',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_item_holds.all'
    }
  }).state('branchManagement.items', {
    url: '/shipment-history/:id',
    params: { id: null },
    component: 'branchManagementItemHistoryHolds',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_items.all'
    }
  }).state('branchManagement.locations', {
    url: '/locations-history?locationId',
    params: {
      locationId: {
        dynamic: true
      }
    },
    component: 'branchManagementLocationsHistoryHolds',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_locations.all'
    }
  }).state('branchManagement.bagouts', {
    url: '/bagouts-history',
    component: 'branchManagementBagoutsHistory',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_bagouts.all'
    }
  }).state('branchManagement.orders', {
    url: '/order-history/:id',
    params: { id: null },
    component: 'branchManagementOrdersHistory',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_orders.all'
    }
  }).state('branchManagement.tankers', {
    url: '/tankers-history',
    component: 'branchManagementTankersHistory',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_tankers.all'
    }
  }).state('branchManagement.bypassCode', {
    url: '/4P-bypass-code',
    component: 'branchManagementBypassCode',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_bypass_code.all'
    }
  }).state('branchManagement.dailyBalanceSheet', {
    url: '/daily-balance-sheet',
    component: 'branchMgmtDailyBalanceSheet',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_daily_balance_sheet.all'
    }
  }).state('branchManagement.monthlyReport', {
    url: '/monthly-report',
    component: 'branchManagementMonthlyReport',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_monthly_report.all'
    }
  }).state('branchManagement.deletedShipments', {
    url: '/deleted-shipments',
    component: 'branchManagementDeletedShipments',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_deleted_shipments.all'
    }
  }).state('branchManagement.cancelledShipments', {
    url: '/cancelled-shipments',
    component: 'branchManagementCancelledShipments',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_cancelled_shipments.all'
    }
  }).state('branchManagement.branchPerformance', {
    url: '/branch-performance',
    component: 'branchManagementBranchPerformance',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_branch_performance.all'
    }
  }).state('branchManagement.finalResidualCountCommit', {
    url: '/final-residual-count-commit',
    component: 'branchManagementFinalResidualCountCommit',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_final_residual_count_commit.all'
    }
  }).state('branchManagement.cashDeliveries', {
    url: '/cash-transactions',
    component: 'branchManagementCashDeliveries',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_cash_transactions.all'
    }
  }).state('branchManagement.tntBypassCode', {
    url: '/TNT-bypass-code',
    component: 'branchManagementTntBypassCode',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_tnt_bypass_code.all'
    }
  }).state('branchManagement.physicalCashCount', {
    url: '/physical-cash-count',
    component: 'branchManagementPhysicalCashCount',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_physical_cash_count.all'
    }
  }).state('branchManagement.lockOpenErrors', {
    url: '/lock-open-errors',
    component: 'branchManagementLockOpenErrors',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_lock_open_errors.all'
    }
  }).state('branchManagement.billingApproval', {
    url: '/billing-approval',
    component: 'branchManagementBillingApproval',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_billing_approval.all'
    }
  }).state('branchManagement.countVariances', {
    url: '/count-variances',
    component: 'branchManagementCountVariances',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_count_variances.all'
    }
  }).state('branchManagement.restoreRouteAssignments', {
    url: '/restore-route-assignments',
    component: 'branchManagementRestoreRouteAssignments',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_restore_route_assignments.all'
    }
  }).state('branchManagement.stopPerformance', {
    url: '/stop-performance',
    component: 'branchManagementStopPerformance',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_stop_performance.all'
    }
  }).state('branchManagement.customerPickupReports', {
    url: '/customer-pickup-reports',
    component: 'branchManagementCustomerPickupReports',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_customer_pickup_reports.all'
    }
  }).state('branchManagement.contactRequest', {
    url: '/contact-request',
    component: 'branchManagementContactRequest',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_contact_request.all'
    }
  }).state('branchManagement.importFileView', {
    url: '/import-file-view',
    component: 'branchManagementImportFileView',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_import_file_view.all'
    }
  }).state('branchManagement.stopScheduling', {
    url: '/stop-scheduling',
    component: 'branchManagementStopScheduling',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_stop_scheduling.all'
    }
  }).state('branchManagement.binManifest', {
    url: '/v2/index.html#/branch-management/bin-manifest',
    component: 'branchManagementBinManifest',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_bin_manifest.all'
    }
  }).state('branchManagement.depositReports', {
    url: '/v2/index.html#/branch-management/deposit-record',
    component: 'branchManagementDepositReports',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_deposit_reports.all'
    }
  }).state('branchManagement.averageDailyBalance', {
    url: '/v2/index.html#/branch-management/average-daily-balance',
    component: 'branchManagementAverageDailyVaultBalanceComponent',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_average_daily_balance.all'
    }
  }).state('branchManagement.mileageReport', {
    url: '/v2/index.html#/branch-management/mileage-report',
    component: 'mileageReportComponent',
    data: {
      requireLogin: true,
      requireACL: 'branch_mgmt_mileage_report.all'
    }
  });
}]).component('branchManagement', _branch_management2.default).name;

exports.default = branchManagementModule;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bulk_cash_management = __webpack_require__(2706);

var _bulk_cash_management2 = _interopRequireDefault(_bulk_cash_management);

var _bulk_cash_management3 = __webpack_require__(1817);

var _bulk_cash_management4 = _interopRequireDefault(_bulk_cash_management3);

__webpack_require__(2988);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bulkCashManagementComponent = {
  restrict: 'E',
  template: _bulk_cash_management2.default,
  controller: _bulk_cash_management4.default
};

exports.default = bulkCashManagementComponent;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BulkCashManagementController = function () {

    /*@ngInject*/
    BulkCashManagementController.$inject = ["$state", "$q", "$window", "Modal", "$translate", "BranchService", "OrderViewService", "UserService", "UsersService", "CommonLayoutService", "LocationService", "BranchFundingSourceService", "DenominationService", "BulkCashService", "User", "CurrencyService", "UserBranchService", "SetupService", "LedgerService", "LedgerTransactionService", "Sound", "DateUtil", "$rootScope", "UserBranchFundingSourceService", "Navigation"];
    function BulkCashManagementController($state, $q, $window, Modal, $translate, BranchService, OrderViewService, UserService, UsersService, CommonLayoutService, LocationService, BranchFundingSourceService, DenominationService, BulkCashService, User, CurrencyService, UserBranchService, SetupService, LedgerService, LedgerTransactionService, Sound, DateUtil, $rootScope, UserBranchFundingSourceService, Navigation) {
        (0, _classCallCheck3.default)(this, BulkCashManagementController);

        this.$q = $q;
        this.$state = $state;
        this.$window = $window;
        this.Sound = Sound;
        // this.audio = this.Sound.errorBeep();
        // this.successAudio = this.Sound.successBeep();
        this.Modal = Modal;
        this.BranchService = BranchService;
        this.LocationService = LocationService;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.DenominationService = DenominationService;
        this.BulkCashService = BulkCashService;
        this.CurrencyService = CurrencyService;
        this.User = User;
        this.UserService = UserService;
        this.UsersService = UsersService;
        this.OrderViewService = OrderViewService;
        this.UserBranchService = UserBranchService;
        this.$translate = $translate;
        this.SetupService = SetupService;
        this.LedgerService = LedgerService;
        this.CommonLayoutService = CommonLayoutService;
        this.LedgerTransactionService = LedgerTransactionService;
        this.DateUtil = DateUtil;
        this.$rootScope = $rootScope;
        this.userInfo = User.getUser();
        this.UserBranchFundingSourceService = UserBranchFundingSourceService;
        this.Navigation = Navigation;
        this.model = {
            loading: true,
            branchId: null,
            locationId: null,
            orderNumber: null,
            requireAmount: null,
            totalreceivedAmount: 0,
            receivedAmountFlag: false,
            stats: 'Regular',
            date: 7,
            ledger: null,
            isDebit: false,
            loggedInUser: this.User.getUser().id,
            searchText: '',
            vaultDate: '',
            dateRangeOptions: {
                startDate: null,
                endDate: null
            },
            adjustment: false
        };

        this.ledgers = [{
            lable: "Regular",
            value: "regular"
        }, {
            lable: "Emergency",
            value: "emergency"
        }];

        this.stats = {
            regular: 'Regular',
            emergency: 'Emergency'
        };
        this.dateRanges = [{
            lable: 'Last 30 Days',
            value: 30
        }, {
            lable: 'Last 10 Days',
            value: 10
        }, {
            lable: 'Last Week',
            value: 7
        }];

        this.orderSort = {
            type: false,
            orderId: false,
            datetime: false,
            order: 'DESC',
            fieldName: 'startTimestamp'
        };

        this.dollorStats = [];
        this.branches = [];
        this.denominationAllType = [];
        this.denominationType = [];
        this.locationLists = [];
        this.denominations = [];
        this.selectedDenomination = [];
        this.fundingSourceDenominations = [];
        this.totalDenominationsAmount = 0;
        this.page = 1;
        this.total = 0;
        this.pageLimit = 10;
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };
        this.isClickDenominationFiler = false;
        this.currencyType = [];
        this.currencyData = [];
        this.denominationGrouped = [];
        this.totalBillAmount = 0;
        this.totalAmount = 0;
        this.transactionHistoryObj = {};
        this.currencySymbol = '$';
        this.$rootScope.$broadcast('routeChange', '/app/bulk-cash');
        this.acl = {};
        this.hasACL = {};
        this.permissionKey = 'bulk_cash_management';
        this.hasCreditDebitPermissions = true;
        this.isViewOnly = false;
        this.adjustmentTypes = [{
            lable: 'Adjustment In (Credit)',
            value: false,
            isAdjustment: true
        }, {
            lable: 'Bulk Cash In (Credit)',
            value: false,
            isAdjustment: false
        }, {
            lable: 'Adjustment Out (Debit)',
            value: true,
            isAdjustment: true
        }];
        this.model.selectedAdjustmentType = this.adjustmentTypes[1];
    }

    (0, _createClass3.default)(BulkCashManagementController, [{
        key: 'setCurrencySymbol',
        value: function setCurrencySymbol() {
            var currencyId = this.model.locationId ? this.model.locationId.currencyId : this.selectedBranchSetupObj ? this.selectedBranchSetupObj.currencyId : null;

            if (currencyId && Array.isArray(this.currencyData) && this.currencyData.length) {
                var currency = this.currencyData.find(function (c) {
                    return c.id === currencyId;
                });
                this.currencySymbol = currency && currency.symbol ? currency.symbol : '$';
            } else {
                this.currencySymbol = '$';
            }
        }
    }, {
        key: 'setDateRangeOptions',
        value: function setDateRangeOptions(date, dateRangeOption, modelVal) {
            var _this = this;

            // let currentVaultDate = moment(date).format() || moment();
            this.model[modelVal] = {
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this.loadBulkCashHistory();
                        _this.getAmountByDenom();
                    }
                },
                ranges: {
                    'Running 45 Days': [moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'), moment().add(14, 'days').format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Year': [moment().startOf('year').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('year').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.moment = moment;
            // if (!this.dollorStats.length) {
            //     this.dollorStats.push('All')
            // }
            this.$q.all([this.model.branchId = this.User.getUser().branchId, this.SetupService.get(this.model.branchId), this.DenominationService.all(null, 0, 1000), this.SetupService.all(null, 0, _app2.default.defaultPageSize), this.loadPermission(), this.UsersService.validateUserPermissions(this.userInfo.firstName, this.userInfo.lastName)
            // this.getLedgerAmountAndDenomBalance()
            // this.bulkCashDenominationHistory()
            ]).then(function (data) {
                _this2.hasCreditDebitPermissions = data[5].hasBulkCashPermission || _this2.CommonLayoutService.isAllowToAccessPages();
                _this2.isViewOnly = _this2.userInfo.customerUser && _this2.hasACL[_this2.permissionKey]['view'] && !_this2.hasACL[_this2.permissionKey]['all'];
                if (_this2.isViewOnly) {
                    _this2.hasCreditDebitPermissions = false;
                }
                _this2.denominationAllType = data[2].results;
                _this2.allSetups = data[3].results;
                _this2.setup = data[1];
                _this2.allSetups.map(function (setup) {
                    if (setup.branchId == _this2.model.branchId) {
                        _this2.selectedBranchSetupObj = setup;
                    }
                });
                _this2._locationPromise = _this2.getAllLocation('', 0);
                _this2.defaultBulkCash();
                _this2.loadCurrency();
                _this2.focuseElementById('trackingId');
                _this2.denominationGroup = [];
                _this2.denominationAllType.map(function (denomination) {
                    if (denomination.shiptype.coinFlag == false && _this2.setup.availableCurrencyIds && _this2.setup.availableCurrencyIds.includes(denomination.currencyId)) {
                        if (denomination.id == "1") {
                            denomination.icon = '<img  src="assets/images/$1c.png" />';
                        }
                        if (denomination.id !== "1") {
                            denomination.icon = '<img  src="assets/images/' + denomination.id + '.png" />';
                        }
                        denomination.ticked = false;
                        return _this2.denominationGroup.push(denomination);
                    }
                });
                var date = _this2.DateUtil.convertToDate(_this2.setup.currentVaultDate);
                _this2.model.vaultDate = moment(date).format('YYYY-MM-DD');
                _this2.setDateRangeOptions(date, _this2.model.dateRangeOptions, 'dateRange');
                _this2.model.dateRangeOptions.startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
                _this2.model.dateRangeOptions.endDate = moment().add(14, 'day').format('YYYY-MM-DD');

                _this2._locationPromise.then(function () {
                    if (_this2.isViewOnly && _this2.locationLists.length === 1) {
                        _this2.model.locationId = _this2.locationLists[0];
                        _this2.setCurrencySymbol();
                        _this2.loadBulkCashHistory();
                        _this2.fundingSourceDenomination();
                    } else if (!_this2.isViewOnly && _this2.locationLists.length === 1) {
                        _this2.model.locationId = _this2.locationLists[0];
                        _this2.setFocus();
                        _this2.loadBulkCashHistory();
                        _this2.resetData();
                    }
                });
            });
        }
    }, {
        key: 'loadPermission',
        value: function loadPermission() {
            var _this3 = this;

            this.acl[this.permissionKey] = this.User.getACL(this.permissionKey);
            this.hasACL[this.permissionKey] = {};
            this.acl[this.permissionKey].forEach(function (permission) {
                _this3.hasACL[_this3.permissionKey][permission] = true;
            });

            if (!this.hasACL[this.permissionKey]['debit']) {
                this.adjustmentTypes = this.adjustmentTypes.filter(function (type) {
                    return !type.value;
                });
            }
        }
    }, {
        key: 'focuseElementById',
        value: function focuseElementById(id) {
            if (!this.hasCreditDebitPermissions) return;
            setTimeout(function () {
                var el = document.getElementById(id);
                if (el && typeof el.focus === 'function') {
                    el.focus();
                }
            }, 300);
        }
    }, {
        key: 'loadCurrency',
        value: function loadCurrency() {
            var _this4 = this;

            var currencyIds = Array.isArray(this.setup.availableCurrencyIds) && this.setup.availableCurrencyIds.length > 0 ? this.setup.availableCurrencyIds : [this.setup.currencyId];

            var currencySearchObj = {
                queryJSON: {
                    rules: currencyIds.map(function (id) {
                        return {
                            field: "id",
                            condition: "=",
                            data: id
                        };
                    }),
                    operator: "OR" // OR because we want currencies matching ANY of the IDs
                }
            };
            return this.CurrencyService.all(currencySearchObj, 0, 100).then(function (data) {
                _this4.currencyData = data.results;
                var currencyId = _this4.model.locationId ? _this4.model.locationId.currencyId : _this4.selectedBranchSetupObj ? _this4.selectedBranchSetupObj.currencyId : "USD";

                // Initialize filtered currency data
                _this4.filteredCurrencyData = _this4.currencyData.filter(function (currency) {
                    return currency.id === currencyId;
                });

                _this4.setCurrencySymbol();

                // Set currency image path for selectedBranchSetupObj
                if (_this4.selectedBranchSetupObj && currencyId) {
                    _this4.selectedBranchSetupObj.currencyIcon = '../../assets/images/' + (currencyId || 'USD') + '.png';
                }

                // Set currency image path for existing bulk cash entries
                if (_this4.addBulkCash && _this4.addBulkCash.length > 0) {
                    _this4.addBulkCash.forEach(function (bulkCashEntry) {
                        if (bulkCashEntry.currencyId) {
                            bulkCashEntry.currencyIcon = '../../assets/images/' + (bulkCashEntry.currencyId || 'USD') + '.png';
                        }
                    });
                }
            }).catch(function (err) {
                console.log(err);
            });
            // return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'bulkCashHistorySearchObj',
        value: function bulkCashHistorySearchObj() {
            var date = this.moment.utc().subtract(this.model.date, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
            var searchObj = this.model.branchId ? {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branchId
                    }, {
                        field: 'account',
                        condition: '=',
                        data: this.model.stats
                    }, {
                        group: {
                            rules: [{
                                field: "startTimestamp",
                                condition: ">",
                                data: date
                            }],
                            operator: "AND"
                        }
                    }],
                    operator: 'AND'
                },
                order: {
                    fieldName: this.orderSort.fieldName || 'id',
                    keyword: this.orderSort.order || 'ASC'
                }
            } : null;

            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'getBulkCashHistorys',
        value: function getBulkCashHistorys() {
            var _this5 = this;

            this.isClickDenominationFiler = false;
            var searchObj = this.bulkCashHistorySearchObj();
            this.LedgerTransactionService.all(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit).then(function (res) {
                _this5.pagination.total = res.total;
                _this5.pagination.loading = false;
                _this5.bulkCashHistorys = res.results;
                return _this5.bulkCashHistorys.map(function (bulkCash) {
                    bulkCash.mainEntry = bulkCash.ledgers.find(function (entry) {
                        return entry.denominationId == null;
                    });
                    return bulkCash;
                });
            }).then(function () {
                _this5.getLedgerAmountAndDenomBalance();
                // console.log(this.bulkCashHistorys);
            }).catch(function (e) {
                console.log('Error : ', e);
            });
        }
    }, {
        key: 'getLedgerAmountAndDenomBalance',
        value: function getLedgerAmountAndDenomBalance() {
            var _this6 = this;

            if (!this.model.locationId) {
                return;
            }

            var defer = this.$q.defer(),
                denominations = null;

            var currencyId = this.model.locationId ? this.model.locationId.currencyId : this.selectedBranchSetupObj ? this.selectedBranchSetupObj.currencyId : null;

            this.LedgerTransactionService.getLedgerAmountAndDenomBalance(this.model.branchId, this.model.locationId.Value, denominations, this.model.stats, this.model.vaultDate, currencyId).then(function (res) {
                _this6.curBalance = res.totalAmount;
                _this6.denomBalance = res.denomBalance;
                if (_this6.denomBalance && Array.isArray(_this6.denomBalance)) {
                    _this6.denomBalance.forEach(function (data) {
                        var denom = (_this6.denominationAllType || []).find(function (d) {
                            return d.id === data.denominationId;
                        });
                        if (denom) {
                            data.sortOrder = denom.sortOrder;
                            data.faceValue = denom.faceValue;
                        }
                    });
                }
                if (_this6.addBulkCash && _this6.addBulkCash.length > 0) {
                    _this6.addBulkCash.forEach(function (bulkCash, index) {
                        _this6.loadDenomination(bulkCash.currencyId, index);
                    });
                }
                _this6.setCurrencySymbol();
                defer.resolve();
            }).catch(function (e) {
                console.log('Error : ', e);
                defer.reject();
            });
            defer.promise.then(function () {
                _this6.totalRequireAmount();
            });
        }

        // Modulus Operator

    }, {
        key: 'defaultBulkCash',
        value: function defaultBulkCash() {
            var currencyId = this.model.locationId ? this.model.locationId.currencyId : this.currencyData.length > 0 ? this.currencyData[0].id : this.selectedBranchSetupObj.currencyId;

            var bulkCashEntry = {
                requireAmount: '',
                ledger: this.ledgers[0].value,
                denominations: [],
                denominationType: [],
                totalreceivedAmount: '',
                checkAndValidate: false,
                currencyId: currencyId,
                currencyIcon: '',
                currencyIsOpen: '',
                currencyTemplate: 'currencyType-selection.html'
            };

            // Set currency image path from currency id
            bulkCashEntry.currencyIcon = '../../assets/images/' + (currencyId || 'USD') + '.png';

            this.addBulkCash = [bulkCashEntry];
        }

        // load BranchFundingSource data

    }, {
        key: 'loadLocationData',
        value: function loadLocationData(searchKey) {
            searchKey = searchKey || '';
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: "id",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "sourceName",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'mappingLocationDatas',
        value: function mappingLocationDatas(locations) {
            return locations.map(function (location) {
                return {
                    Key: location.id + " | " + location.sourceName,
                    Value: location.id,
                    currencyId: location.currencyId
                };
            });
        }
    }, {
        key: 'getAllLocation',
        value: function getAllLocation(searchKey, offset) {
            var _this7 = this;

            // const loadLocationDatas = this.loadLocationData(searchKey);
            return this.UserBranchFundingSourceService.getBranchFundingSource(this.model.loggedInUser, this.model.branchId).then(function (data) {
                if (offset === 0) {
                    _this7.totalRecords = data.total;
                    _this7.locationLists = _this7.mappingLocationDatas(data.results);
                } else {
                    var locations = _this7.mappingLocationDatas(data.results);
                    _this7.locationLists = _this7.locationLists.concat(locations);
                }
            });
        }
    }, {
        key: 'setFocus',
        value: function setFocus() {
            if (!this.model.locationId) {
                return;
            }
            if (this.hasCreditDebitPermissions) {
                this.focuseElementById('trackingId');
            } else {
                this.focuseElementById('requireAmount-' + this.addBulkCash.length);
            }
        }
    }, {
        key: 'addDenomination',
        value: function addDenomination(bulkCashIndex, denominationIndex) {
            var icon = this.addBulkCash[denominationIndex].filterDenominationType[0].id,
                faceValue = 0;
            this.addBulkCash[bulkCashIndex].denominationType.forEach(function (denomData) {
                if (denomData.id == icon) {
                    faceValue = denomData.faceValue;
                }
            });

            var denomMeta = this.addBulkCash[bulkCashIndex].denominationType.find(function (d) {
                return d.id === icon;
            }) || {};
            var coinFlag = denomMeta.coinFlag || denomMeta.shiptype && denomMeta.shiptype.coinFlag || 0;
            if (!coinFlag) {
                var fallback = (this.denominationAllType || []).find(function (d) {
                    return d.id === icon;
                }) || {};
                coinFlag = fallback.coinFlag || fallback.shiptype && fallback.shiptype.coinFlag || 0;
            }

            this.addBulkCash[denominationIndex].denominations.push({
                icon: icon,
                faceValue: faceValue,
                amount: null,
                units: null,
                coinFlag: coinFlag,
                template: 'bulk-cash-denomination-selection.html',
                dollorFlag: true,
                duplicate: false
            });

            this.removeAlreadyUsedDenom(denominationIndex);

            this.selectedDenomination[this.addBulkCash[denominationIndex].denominations.length - 1] = this.addBulkCash[bulkCashIndex].denominationType[0].id;
            if (this.addBulkCash[denominationIndex].denominations.length > 1) {
                this.checkDuplicateEntry(bulkCashIndex, denominationIndex);
            }
            this.checkAndValidateCommit(bulkCashIndex);
            if (this.addBulkCash[bulkCashIndex].denominations.length) {
                this.focuseElementById('denomAmount-' + (bulkCashIndex + 1) + '-' + this.addBulkCash[bulkCashIndex].denominations.length);
            }
            // this.commitDisabled();
        }
    }, {
        key: 'addNewBulkCash',
        value: function addNewBulkCash() {
            var currencyId = this.model.locationId ? this.model.locationId.currencyId : 'USD';

            var bulkCashEntry = {
                requireAmount: '',
                ledger: this.model.stats === this.stats.regular ? 'regular' : 'emergency',
                denominations: [],
                denominationType: [],
                totalreceivedAmount: '',
                // currency: 'USD',
                checkAndValidate: false,
                currencyId: currencyId,
                currencyIcon: '',
                currencyIsOpen: '',
                currencyTemplate: 'currencyType-selection.html'
            };

            // Set currency image path from currency id
            bulkCashEntry.currencyIcon = '../../assets/images/' + (currencyId || 'USD') + '.png';

            this.addBulkCash.push(bulkCashEntry);
            this.loadDenomination(currencyId, this.addBulkCash.length - 1);
            this.setCurrencySymbol();

            // this.commitDisabled();
        }
    }, {
        key: 'loadAclPermission',
        value: function loadAclPermission() {
            var _this8 = this;

            this.UserService.acl(this.User.getUser().id, this.model.branch).then(function (permissions) {
                _this8.aclPermission = permissions;
            }).catch(function (e) {
                return console.log('error in permission', e);
            });
        }
    }, {
        key: 'removeDenomination',
        value: function removeDenomination(bulkCashIndex, denominationIndex, bulkCashAmount) {
            this.addBulkCash[bulkCashIndex].denominations.splice(denominationIndex, 1);
            this.calculateAmount(bulkCashIndex, denominationIndex); // check and deduct amount if array removed from stack
            this.checkDuplicateEntry(bulkCashIndex, denominationIndex);
            this.checkAmountWithRequireAmount(bulkCashIndex, denominationIndex, bulkCashAmount);
            // this.commitDisabled();
            this.removeAlreadyUsedDenom(bulkCashIndex);
            if (this.addBulkCash[bulkCashIndex].denominations.length) {
                var elementId = 'denomAmount-' + (bulkCashIndex + 1) + '-' + this.addBulkCash[bulkCashIndex].denominations.length;
                var element = document.getElementById(elementId);

                if (element) {
                    this.focuseElementById(elementId);
                }
            } else {
                this.focuseElementById('addDenomination-' + (bulkCashIndex + 1));
            }
        }
    }, {
        key: 'removeBulkCash',
        value: function removeBulkCash(bulkCashIndex) {
            var _this9 = this;

            if (this.addBulkCash.length === 1) {
                return this.Modal.alert({
                    type: 'danger',
                    header: this.$translate.instant('bulkCash.alertModalTitle'),
                    message: this.$translate.instant('bulkCash.alertModalMessage'),
                    callback: function callback(_ref) {
                        var modal = _ref.modal;
                        modal.close();
                    }
                });
            }

            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_delete_title'),
                message: this.$translate.instant('bulkCash.delete_message'),
                callback: function callback(_ref2) {
                    var modal = _ref2.modal,
                        $scope = _ref2.$scope;

                    _this9.remove(bulkCashIndex);
                    _this9.totalRequireAmount();
                    modal.close();
                },
                type: 'danger'
            });
        }
    }, {
        key: 'remove',
        value: function remove(bulkCashIndex) {
            this.addBulkCash[bulkCashIndex] = [];
            this.addBulkCash.splice(bulkCashIndex, 1);
            this.focuseElementById('requireAmount-' + this.addBulkCash.length);
        }

        // Calculate Amount for each Value 

    }, {
        key: 'calculateAmount',
        value: function calculateAmount(bulkCashIndex, denominationIndex) {
            var _this10 = this;

            this.totalDenominationsAmount = 0;
            this.addBulkCash[bulkCashIndex].denominations.map(function (denomination) {
                if (denomination.coinFlag) {
                    var computed = Number((denomination.units || 0) * (denomination.faceValue || 0));
                    denomination.amount = computed;
                }
                _this10.totalDenominationsAmount = Number(_this10.totalDenominationsAmount) + Number(denomination.amount || 0);
            });
            this.addBulkCash[bulkCashIndex].totalreceivedAmount = this.totalDenominationsAmount;
        }

        // change denominationType

    }, {
        key: 'changeType',
        value: function changeType(event, type, bulkCashIndex, denominationIndex, imageIndex, denomFaceValue, amounts) {
            var denomMeta = this.addBulkCash[bulkCashIndex].denominationType.find(function (d) {
                return d.id === type;
            }) || {};
            var isCoin = denomMeta.coinFlag || denomMeta.shiptype && denomMeta.shiptype.coinFlag || 0;
            if (!isCoin) {
                var fallback = (this.denominationAllType || []).find(function (d) {
                    return d.id === type;
                }) || {};
                isCoin = fallback.coinFlag || fallback.shiptype && fallback.shiptype.coinFlag || 0;
            }
            this.addBulkCash[bulkCashIndex].denominations[denominationIndex].icon = type;
            this.addBulkCash[bulkCashIndex].denominations[denominationIndex].faceValue = denomFaceValue;
            this.addBulkCash[bulkCashIndex].denominations[denominationIndex].coinFlag = isCoin;
            this.addBulkCash[bulkCashIndex].denominations[denominationIndex].units = null;
            this.addBulkCash[bulkCashIndex].denominations[denominationIndex].amount = null;
            this.selectedDenomination[imageIndex] = this.addBulkCash[bulkCashIndex].denominationType[imageIndex].id;
            this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isOpen = false;

            if (this.addBulkCash[bulkCashIndex].denominations.length > 1) {
                this.checkDuplicateEntry(bulkCashIndex, denominationIndex);
            }
            this.checkAndValidateCommit(bulkCashIndex);
            this.isMultiple(bulkCashIndex, amounts, denomFaceValue, denominationIndex);
            this.removeAlreadyUsedDenom(bulkCashIndex);
        }
    }, {
        key: 'removeAlreadyUsedDenom',
        value: function removeAlreadyUsedDenom(index) {
            var _this11 = this;

            this.addBulkCash[index].filterDenominationType = this.addBulkCash[index].denominationType.filter(function (type) {
                var isValid = true;
                _this11.addBulkCash[index].denominations.forEach(function (data) {
                    isValid = !(data.icon === type.id) && isValid;
                });
                return isValid;
            });
        }

        //change currencyType

    }, {
        key: 'changeCurrencyType',
        value: function changeCurrencyType(event, type, bulkCashIndex, currencyIndex) {
            this.addBulkCash[bulkCashIndex].currencyId = type;

            // Set currency image path from currency id
            this.addBulkCash[bulkCashIndex].currencyIcon = '../../assets/images/' + (type || 'USD') + '.png';

            this.addBulkCash[bulkCashIndex].currencyIsOpen = false;
            this.addBulkCash[bulkCashIndex].denominations = [];
            this.addBulkCash[bulkCashIndex].totalreceivedAmount = 0;
            this.loadDenomination(type, bulkCashIndex);
            this.checkAndValidateCommit(bulkCashIndex);
            this.setCurrencySymbol();
        }

        // load denomination based on currencyType

    }, {
        key: 'loadDenomination',
        value: function loadDenomination(selectedType, bulkCashIndex) {
            var _this12 = this;

            this.addBulkCash[bulkCashIndex].denominations = [];
            this.addBulkCash[bulkCashIndex].denominationType = [];
            this.addBulkCash[bulkCashIndex].filterDenominationType = [];
            var sourceDenoms = this.model.isDebit ? this.denominationAllType : this.fundingSourceDenominations;

            sourceDenoms.forEach(function (denominationType) {
                var isMatchingDenom = (_this12.denomBalance || []).some(function (denom) {
                    return denom.denominationId === denominationType.id && denom.balance !== 0;
                });
                if (denominationType.currencyId == selectedType && (isMatchingDenom || !_this12.model.isDebit)) {
                    _this12.addBulkCash[bulkCashIndex].denominationType.push(denominationType);
                    _this12.addBulkCash[bulkCashIndex].filterDenominationType.push(denominationType);
                }
            });
        }
    }, {
        key: 'checkAmountWithRequireAmount',
        value: function checkAmountWithRequireAmount() {
            var _this13 = this;

            this.addBulkCash.forEach(function (bulkCash, bulkCashIndex) {
                var requiredNum = Number(bulkCash.requireAmount || 0);
                bulkCash.denominations.forEach(function (denomination, denominationIndex) {
                    _this13.calculateAmount(bulkCashIndex, denominationIndex);
                    if (bulkCash.denominations.length > 1) {
                        _this13.checkDuplicateEntry(bulkCashIndex, denominationIndex);
                    }
                    _this13.checkAndValidateCommit(bulkCashIndex);

                    var isCoin = !!denomination.coinFlag;
                    var effectiveAmount = isCoin ? Number(denomination.units || 0) * Number(denomination.faceValue || 0) : Number(denomination.amount || 0);

                    _this13.isMultiple(bulkCashIndex, effectiveAmount, Number(denomination.faceValue || 0), denominationIndex, requiredNum);
                });
            });
        }
    }, {
        key: 'totalRequireAmount',
        value: function totalRequireAmount() {
            var _this14 = this;

            this.totalAmount = 0;
            if (this.addBulkCash && this.addBulkCash.length) {
                this.addBulkCash.forEach(function (bulkCash) {
                    _this14.totalAmount += bulkCash.requireAmount ? bulkCash.requireAmount : 0;
                    if (_this14.model.isDebit) {
                        bulkCash.ledger = _this14.model.stats === 'Regular' ? 'regular' : 'emergency';
                    }
                });
            }
            if (this.model.isDebit) {
                this.isLimitExceed = this.totalAmount > this.curBalance;
                if (this.isLimitExceed) this.limitExceededErr = this.$translate.instant('bulkCash.error_limitExceeded');else delete this.limitExceededErr;
            } else {
                this.isLimitExceed = false;
                delete this.limitExceededErr;
            }
        }
    }, {
        key: 'isMultiple',
        value: function isMultiple(bulkCashIndex, amounts, denomFaceValue, denominationIndex, bulkCashAmount) {
            var currentDenom = this.addBulkCash[bulkCashIndex].denominations[denominationIndex];
            var denomBalance = this.denomBalance.find(function (balance) {
                return balance.denominationId === currentDenom.icon;
            });

            var amt = Number(amounts || 0);
            var fv = Number(denomFaceValue || 0);
            var required = Number(bulkCashAmount || 0);
            var isCoin = !!currentDenom.coinFlag;

            if (isCoin) {
                var unitsNum = Number(currentDenom.units || 0);
                var computed = unitsNum * fv;
                var exceedsBalance = this.model.isDebit && denomBalance && computed > Number(denomBalance.balance || 0);
                if (!(unitsNum > 0) || required > 0 && computed > required || exceedsBalance) {
                    this.addBulkCash[bulkCashIndex].checkAndValidate = false;
                    this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = false;
                } else {
                    this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = true;
                }
                return;
            }

            if (fv > 0 && amt % fv > 0 || required > 0 && amt > required) {
                this.addBulkCash[bulkCashIndex].checkAndValidate = false;
                this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = false;
            } else if (denomBalance && amt > denomBalance.balance && this.model.isDebit) {
                this.addBulkCash[bulkCashIndex].checkAndValidate = false;
                this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = false;
            } else if (fv > 0 && amt > 0 && amt % fv === 0) {
                this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = true;
            } else {
                this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = false;
            }
        }

        // Check Duplicate Entries

    }, {
        key: 'checkDuplicateEntry',
        value: function checkDuplicateEntry(bulkCashIndex, denominationIndex) {
            var _this15 = this;

            this.addBulkCash[bulkCashIndex].denominations = _.map(this.addBulkCash[bulkCashIndex].denominations, function (mainObj, mainObjIndex) {
                mainObj.duplicate = false;
                _this15.isValidDirective = true;
                var eq = _.find(_this15.addBulkCash[bulkCashIndex].denominations, function (compairObject, compairObjIndex) {
                    if (mainObjIndex > compairObjIndex) {
                        return compairObject.icon == mainObj.icon;
                    }
                });
                if (eq) {
                    mainObj.duplicate = true;
                    _this15.isValidDirective = false;
                    _this15.addBulkCash[bulkCashIndex].checkAndValidate = false;
                    return mainObj;
                } else {
                    return mainObj;
                }
            });
        }
    }, {
        key: 'loadLedgerData',
        value: function loadLedgerData(bulkCashIndex, denominationIndex, account) {
            this.checkAndValidateCommit(bulkCashIndex);
            // this.checkAmountWithRequireAmount();
        }
    }, {
        key: 'fundingSourceDenomination',
        value: function fundingSourceDenomination() {
            var _this16 = this;

            if (!this.model.locationId) {
                return;
            }
            var currencyId = this.model.locationId.currencyId;
            var bfsId = this.model.locationId.Value;

            if (!currencyId) {
                console.error('No currency ID found for selected BFS');
                return;
            }

            // Fetch BFS-selected denominations and filter by currency
            this.BranchFundingSourceService.get(bfsId).then(function (data) {
                var denomMap = data && data.results && data.results.denominations ? data.results.denominations : {};
                var billsForCurrency = Array.isArray(denomMap[currencyId]) ? denomMap[currencyId] : [];
                var coinsForCurrency = Array.isArray(denomMap['Coin']) ? denomMap['Coin'].filter(function (d) {
                    return d.currencyId === currencyId;
                }) : [];
                _this16.fundingSourceDenominations = billsForCurrency.concat(coinsForCurrency);

                // Update denominationGroup for the dropdown (exclude coins)
                // this.denominationGroup = [];
                // this.fundingSourceDenominations.forEach((denomination) => {
                //     if(denomination.id == "1"){
                //         denomination.icon = '<img  src="assets/images/$1c.png" />';
                //     }
                //     if(denomination.id !== "1"){
                //         denomination.icon = '<img  src="assets/images/' + denomination.id + '.png" />';
                //     }
                //     denomination.ticked = false;
                //     this.denominationGroup.push(denomination);
                // });

                // Update the currency ID and image path to match the BFS currency
                if (_this16.addBulkCash && _this16.addBulkCash.length > 0) {
                    _this16.addBulkCash[0].currencyId = currencyId;
                    _this16.addBulkCash[0].currencyIcon = '../../assets/images/' + (currencyId || 'USD') + '.png';
                }

                // Filter currencyData for popover to only show the selected BFS currency
                _this16.filteredCurrencyData = _this16.currencyData.filter(function (currency) {
                    return currency.id === currencyId;
                });

                _this16.setCurrencySymbol();

                // Load denominations for the updated currency using BFS-selected list
                _this16.loadDenomination(currencyId, 0);
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'denominationSearchObj',
        value: function denominationSearchObj() {
            var selectedDollorStats = this.dollorStats.map(function (dollorStat) {
                return dollorStat.id;
            });
            var searchObj = this.model.branchId ? {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branchId
                    }, {
                        field: 'account',
                        condition: '=',
                        data: this.model.stats
                    }],
                    operator: 'AND'
                },
                order: {
                    fieldName: this.orderSort.fieldName || 'id',
                    keyword: this.orderSort.order || 'ASC'
                }
            } : null;

            if (selectedDollorStats.length) {
                searchObj.queryJSON.rules.push({
                    field: 'denominationId',
                    condition: 'IN',
                    data: selectedDollorStats
                });
            }

            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'bulkCashDenominationHistory',
        value: function bulkCashDenominationHistory() {
            var _this17 = this;

            if (!this.model.locationId) {
                return this.resetBulkCashDenomination();
            }

            this.isClickDenominationFiler = true;
            // let date = this.moment.utc().subtract(this.model.date, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
            var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
            var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
            var searchObj = this.denominationSearchObj();
            this.LedgerTransactionService.getLedgerDenomination(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit, this.model.searchText, startDate, endDate, this.model.locationId.Value).then(function (res) {
                _this17.bulkCashHistorys = res.results;
                _this17.bulkCashHistorys.map(function (bulkCash, index) {
                    var startBalance = 0;
                    var nextIndex = index + 1;
                    var nextRecord = _this17.bulkCashHistorys[nextIndex] ? _this17.bulkCashHistorys[nextIndex] : null;

                    bulkCash.ledgers.forEach(function (ledger) {
                        if (ledger.denomination) {
                            startBalance += ledger.change * ledger.denomination.faceValue;
                        }
                        bulkCash.mainEntry = bulkCash.ledgers.find(function (entry) {
                            return entry.denominationId == null;
                        });
                        bulkCash.nextEntry = nextRecord ? nextRecord.ledgers.find(function (entry) {
                            return entry.denominationId == null;
                        }) : null;
                    });
                    var depositRecords = bulkCash.depositRecords || bulkCash.depositrecords || [];
                    var fromLoc = null;
                    var toLoc = null;

                    if (depositRecords.length > 0) {
                        fromLoc = depositRecords[0].fromLocation || depositRecords[0].fromlocation;
                        toLoc = depositRecords[0].shipment && depositRecords[0].shipment.toLocation ? depositRecords[0].shipment.toLocation : bulkCash.branchFundingSource ? bulkCash.branchFundingSource.location : null;
                    } else if (bulkCash.shipmentLocation) {
                        fromLoc = bulkCash.shipmentLocation.fromLocation;
                        toLoc = bulkCash.shipmentLocation.toLocation ? bulkCash.shipmentLocation.toLocation : bulkCash.branchFundingSource ? bulkCash.branchFundingSource.location : null;
                    } else if (bulkCash.branchFundingSource && bulkCash.branchFundingSource.location) {
                        fromLoc = bulkCash.branchFundingSource.location;
                    }
                    if (bulkCash.adjustment) {
                        fromLoc = null;
                        toLoc = null;
                    }
                    bulkCash.fromLocationName = fromLoc ? fromLoc.id + ' | ' + fromLoc.name : 'N/A';
                    bulkCash.toLocationName = toLoc ? toLoc.id + ' | ' + toLoc.name : 'N/A';
                    bulkCash.fromLocation = fromLoc;
                    bulkCash.toLocation = toLoc;
                    bulkCash.type = startBalance;
                    bulkCash.startBalance = startBalance;
                    bulkCash.endBalance = startBalance;
                    bulkCash.isBalanceMismatched = bulkCash.totalValue !== 0 && bulkCash.nextEntry && bulkCash.mainEntry && bulkCash.mainEntry.prevBalance !== bulkCash.nextEntry.curBalance ? true : false;
                    return bulkCash;
                });
                _this17.pagination.total = res.total;
                _this17.pagination.loading = false;
            }).then(function () {
                _this17.getLedgerAmountAndDenomBalance();
            }).catch(function (err) {
                _this17.pagination.loading = false;
                _this17.Modal.errorModal(err.data.message || err.data || err.message);
            });
        }
    }, {
        key: 'resetBulkCashDenomination',
        value: function resetBulkCashDenomination() {
            this.bulkCashHistorys = [];
            this.model.date = 7;
            this.curBalance = 0;
            this.resetDenomSelection();
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(locationId) {
            return this.Navigation.goToServiceHistory(locationId, null, true, null);
        }
    }, {
        key: 'loadBulkCashHistory',
        value: function loadBulkCashHistory(rating) {
            // var index = this.dollorStats.indexOf(rating);

            // if (index > -1) {
            //     this.dollorStats.splice(index, 1);
            // }
            // else {
            //     this.dollorStats.push(rating);
            // }
            this.pagination.page = 1;
            this.bulkCashDenominationHistory();
            // console.log(this.dollorStats)
        }
    }, {
        key: 'resetLedgerData',
        value: function resetLedgerData() {
            this.resetDenomSelection();
            this.bulkCashDenominationHistory();
        }
    }, {
        key: 'checkAndValidateCommit',
        value: function checkAndValidateCommit(bulkCashIndex) {
            var _this18 = this;

            // if (this.addBulkCash[bulkCashIndex].denominations.length > 0) {
            if (Number(this.addBulkCash[bulkCashIndex].totalreceivedAmount).toFixed(2) == Number(this.addBulkCash[bulkCashIndex].requireAmount).toFixed(2)) {
                var isDuplicate = this.addBulkCash[bulkCashIndex].denominations.map(function (data) {
                    if (data.duplicate) {
                        return data.duplicate;
                    } else if (data.coinFlag && !_this18.model.isDebit && (data.units == undefined || data.units == null) || !data.coinFlag && (data.amount == undefined || data.amount == null)) {
                        return true;
                    } else {
                        return false;
                    }
                });
                if (isDuplicate.indexOf(true) >= 0) {
                    this.addBulkCash[bulkCashIndex].checkAndValidate = false;
                } else {
                    this.addBulkCash[bulkCashIndex].checkAndValidate = true;
                }
                if (!this.addBulkCash[bulkCashIndex].ledger) this.addBulkCash[bulkCashIndex].checkAndValidate = false;
            } else {
                this.addBulkCash[bulkCashIndex].checkAndValidate = false;
            }
        }

        // check and validate commit button 

    }, {
        key: 'commitDisabled',
        value: function commitDisabled() {
            var _this19 = this;

            var disableButton = this.addBulkCash.map(function (data) {
                _this19.validate = true;
                data.denominations.map(function (denom) {
                    _this19.validate = _this19.validate && denom.isValidate;
                });
                return data.checkAndValidate && _this19.validate;
            });
            if (disableButton.indexOf(false) >= 0) return true;else return false;
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.bulkCashDenominationHistory();
        }
    }, {
        key: 'accountChange',
        value: function accountChange() {
            this.pagination = {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            };
            this.orderSort.fieldName = 'startTimestamp';
            this.orderSort.order = 'DESC';
            this.denomBalance = [];
            this.bulkCashDenominationHistory();
            this.getAmountByDenom();
            this.updateLedgerAccount();
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            var currencyId = this.model.locationId ? this.model.locationId.currencyId : this.selectedBranchSetupObj ? this.selectedBranchSetupObj.currencyId : "USD";

            var bulkCashEntry = {
                requireAmount: '',
                ledger: this.model.stats === this.stats.regular ? 'regular' : 'emergency',
                denominations: [],
                totalreceivedAmount: '',
                checkAndValidate: false,
                currencyId: currencyId,
                currencyIcon: '',
                denominationType: '',
                currencyIsOpen: '',
                currencyTemplate: 'currencyType-selection.html'
            };

            // Set currency image path from currency id
            bulkCashEntry.currencyIcon = '../../assets/images/' + (currencyId || 'USD') + '.png';

            this.addBulkCash = [bulkCashEntry];
            this.model.orderNumber = "";
            // this.model.locationId = "";
            this.loadDenomination(currencyId, 0);
            this.setCurrencySymbol();

            if (this.model.locationId) {
                this.fundingSourceDenomination();
            }

            this.isCommited = false;
            this.model.selectedAdjustmentType = this.adjustmentTypes[1];
            this.model.isDebit = false;
            this.model.adjustment = false;
            this.model.comments = null;
            // this.updateAdjustmentValue();
            delete this.limitExceededErr;
        }

        // reset all data

    }, {
        key: 'performReset',
        value: function performReset() {
            var _this20 = this;

            this.isPerformReset = true;
            this.Modal.confirm({
                header: this.$translate.instant('common.reset'),
                message: this.$translate.instant('bulkCash.resetData'),
                callback: function callback(_ref3) {
                    var modal = _ref3.modal;

                    _this20.resetData();
                    modal.close();
                    _this20.isPerformReset = false;
                    _this20.model.selectedAdjustmentType = _this20.adjustmentTypes[1];
                    _this20.model.isDebit = false;
                    _this20.model.adjustment = false;
                    _this20.model.comments = null;
                    // this.updateAdjustmentValue();
                    // this.curBalance = 0;
                },
                negative: function negative(_ref4) {
                    var modal = _ref4.modal;

                    _this20.isPerformReset = false;
                    modal.close();
                },
                type: 'danger'
            });
        }
    }, {
        key: 'commit',
        value: function commit() {
            var _this21 = this;

            this.isCommited = true;
            var totalAmount = 0;
            var currentDate = moment();
            var bulkCashComment = this.model.orderNumber;
            var endBalance = this.curBalance;

            this.addBulkCash.forEach(function (data) {
                if (_this21.model.isDebit) {
                    data.denominations.forEach(function (denom) {
                        denom.amount = -Math.abs(denom.amount);
                        denom.isDebit = true;
                        denom.userId = _this21.model.loggedInUser;
                        denom.startBalance = _this21.curBalance;
                        endBalance = endBalance + denom.amount;
                        denom.endBalance = endBalance;
                    });
                }
                totalAmount += data.totalreceivedAmount || 0;
            });

            // if (this.model.isDebit) {
            //     this.Modal.bulkCashAdjustComment(this.addBulkCash, ({ modal, comments }) => {
            //         bulkCashComment = bulkCashComment ? bulkCashComment.concat(' ', comments) : comments;
            //         return this.commitBulkCash(totalDollerAmount, totalEuroAmount, currentDate, bulkCashComment, modal);
            //     }, ({ modal }) => {
            //         this.isCommited = false;
            //         if (modal) modal.close();
            //     });
            // }
            // else {
            bulkCashComment = bulkCashComment && this.model.comments ? bulkCashComment.concat(' | ', this.model.comments) : bulkCashComment ? bulkCashComment : this.model.comments;
            return this.commitBulkCash(totalAmount, currentDate, bulkCashComment, null);
            // }
        }
    }, {
        key: 'commitBulkCash',
        value: function commitBulkCash(totalAmount, currentDate, comment, bulkCashAdjustCommentModal) {
            var _this22 = this;

            // Add Bulk Cash
            this.BulkCashService.commitBulkCash(this.model.branchId, this.model.locationId.Value, this.addBulkCash, comment, true, 'bulkCash', this.model.isDebit, this.model.adjustment).then(function () {
                var ledgerAdjustMessage = _this22.$translate.instant('bulkCash.adjustLedger');
                var successMessage = _this22.$translate.instant('bulkCash.successMessage');
                var msg = _this22.model.isDebit ? ledgerAdjustMessage : successMessage;
                var transactionType = _this22.model.isDebit ? 'Debit' : 'Credit';

                _this22.Modal.commitSuccessModal(totalAmount, null, currentDate, msg, transactionType, function (_ref5) {
                    var modal = _ref5.modal;

                    modal.close();
                    _this22.Sound.playSuccessBeep("#success_beep");
                    _this22.resetData();

                    _this22.focuseElementById('trackingId');

                    // this.getLedgerAmountAndDenomBalance();

                    if (_this22.model.locationId) {
                        setTimeout(function () {
                            _this22.loadBulkCashHistory();
                        }, 100);
                    }
                }, _this22.currencySymbol);
            }).catch(function (err) {
                console.log(err);
                _this22.Sound.PlayErrorBeep("#scanner_beep");
                if (err && err.data && err.data.message === 'ER_SIGNAL_EXCEPTION: E_LEDGERTRANSACTION_ACTIVE') {
                    return _this22.Modal.errorModal('error.95001');
                } else {
                    _this22.Modal.errorModal('error.' + err.data.message);
                }
            }).finally(function () {
                _this22.isCommited = false;
                if (bulkCashAdjustCommentModal) bulkCashAdjustCommentModal.close();
            });
        }

        // reset denom selection

    }, {
        key: 'resetDenomSelection',
        value: function resetDenomSelection() {
            this.denominations = [];
            this.dollorStats = [];
            this.denominationAllType.map(function (denomination) {
                denomination.ticked = false;
            });
            // Reset currencyData to show all currencies when no BFS is selected
            if (this.originalCurrencyData) {
                this.currencyData = [].concat((0, _toConsumableArray3.default)(this.originalCurrencyData));
            }
        }
    }, {
        key: 'sortRecord',
        value: function sortRecord(fieldName) {
            this.orderSort.order = 'DESC';
            if (fieldName == 'startTimestamp') {
                this.orderSort.datTime = !this.orderSort.datTime;
                if (this.orderSort.datTime) {
                    this.orderSort.order = 'ASC';
                }
                this.orderSort.fieldName = fieldName;
            }
            this.bulkCashDenominationHistory();
        }
    }, {
        key: 'getAmountByDenom',
        value: function getAmountByDenom() {
            var _this23 = this;

            if (!this.model.locationId) return;
            // let date = this.moment.utc().subtract(this.model.date, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
            var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
            var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
            var selectedDollorStats = this.dollorStats.map(function (dollorStat) {
                return dollorStat.id;
            });
            this.LedgerTransactionService.getLedgerDenomTotal(this.model.branchId, this.model.stats, selectedDollorStats.toString(), this.model.locationId.Value).then(function (data) {
                if (data && data.results.length) {
                    _this23.denominations = data.results;
                    _this23.denominations.forEach(function (data) {
                        var denom = (_this23.denominationAllType || []).find(function (d) {
                            return d.id === data.denominationId;
                        });
                        if (denom) {
                            data.sortOrder = denom.sortOrder;
                            data.faceValue = denom.faceValue;
                        }
                    });
                } else _this23.denominations = [];
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this23.Modal.errorModal('error.' + err.data.message);
                }
            });
            // if (data.length) {
            //     this.totalDenomAmount = 0;
            //     this.denominations = {};

            //     data.forEach((d) => {
            //         const grouped = _.groupBy(d.ledgers, 'denominationId');
            //         const keys = Object.keys(grouped);

            //         keys.map((denomId) => {
            //             if (denomId !== "null") {
            //                 this.denominations[denomId] = {
            //                     denomAmount: 0
            //                 };
            //             }
            //         })
            //     })

            //     data.forEach((d) => {
            //         const grouped = _.groupBy(d.ledgers, 'denominationId');
            //         const keys = Object.keys(grouped);

            //         keys.map((denomId) => {
            //             if (denomId !== "null") {
            //                 grouped[denomId].map(data => {
            //                     if (data.denominationId && data.denomination) {
            //                         this.denominations[denomId].icon = `assets/images/${denomId}.png`;
            //                         this.denominations[denomId].denomAmount += (data.change * data.denomination.faceValue);
            //                     }
            //                 })
            //             }
            //         })
            //     })
            // }
        }
    }, {
        key: 'showLog',
        value: function showLog(data) {
            this.Modal.ledgerTransactionLogModal(data, function (_ref6) {
                var modal = _ref6.modal;

                modal.close();
            }, function (_ref7) {
                var modal = _ref7.modal;

                modal.close();
            });
        }
    }, {
        key: 'updateLedgerAccount',
        value: function updateLedgerAccount() {
            var _this24 = this;

            this.addBulkCash.forEach(function (data) {
                if (_this24.model.stats === _this24.stats.regular) data.ledger = 'regular';else if (_this24.model.stats === _this24.stats.emergency) data.ledger = 'emergency';
            });
        }

        // updateAdjustmentValue() {
        //     this.model.isDebit ? this.model.adjustment = true : this.model.adjustment = false;
        // }

    }, {
        key: 'isManualAdjustment',
        value: function isManualAdjustment(bulkCashDetails) {
            if (!bulkCashDetails.mainEntry) return;

            if (!bulkCashDetails.comment || bulkCashDetails.mainEntry.change >= 0) return;

            var adjustmentList = ['Undo pack of:', 'Order pack tracking:', 'Creating emergency deposit for', 'Creating deposit for', 'Editing residual:', 'Coin Shipment Checkout'];
            var len = adjustmentList.length;

            for (var i = 0; i < len; i++) {
                var regex = new RegExp(adjustmentList[i], 'i');
                if (bulkCashDetails.comment.match(regex)) return false;
            }
            return true;
        }
    }, {
        key: 'updateBulkCashFlag',
        value: function updateBulkCashFlag(bulkCashDetails) {
            var _this25 = this;

            // console.log('bulkCashDetails', bulkCashDetails.id, bulkCashDetails.bulkCash);
            this.transactionHistoryObj[bulkCashDetails.id] = { process: true };
            this.BulkCashService.updateBulkCashFlag(bulkCashDetails.id, bulkCashDetails.bulkCash).then(function () {}).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this25.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this25.transactionHistoryObj[bulkCashDetails.id].process = false;
            });
        }
    }, {
        key: 'findAdjustmentType',
        value: function findAdjustmentType(type) {
            var _this26 = this;

            this.model.adjustment = type.isAdjustment;
            this.model.isDebit = type.value;
            if (this.addBulkCash && this.addBulkCash.length > 0) {
                this.addBulkCash.forEach(function (bulkCash, index) {
                    _this26.loadDenomination(bulkCash.currencyId, index);
                });
            }
        }
    }, {
        key: 'printBulkCash',
        value: function printBulkCash() {
            var _this27 = this;

            var path = this.$state.href('printBulkCash');
            window.w = window.open(path, '_blank');

            var branchName = this.model.branchId;
            if (this.selectedBranchSetupObj && this.selectedBranchSetupObj.branchName) {
                branchName = this.model.branchId + " | " + this.selectedBranchSetupObj.branchName;
            }

            var locationName = "";
            if (this.model.locationId && this.model.locationId.Key) {
                locationName = this.model.locationId.Key;
            }

            var dateRange = "";
            if (this.model.dateRangeOptions && this.model.dateRangeOptions.startDate) {
                dateRange = "(" + moment(this.model.dateRangeOptions.startDate).format('Do MMMM, YYYY') + ") To (" + moment(this.model.dateRangeOptions.endDate).format('Do MMMM, YYYY') + ")";
            }

            window.w.printData = null;

            var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
            var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
            var searchObj = this.denominationSearchObj();

            this.LedgerTransactionService.getLedgerDenomination(searchObj, 0, this.pagination.total || 1000, this.model.searchText, startDate, endDate, this.model.locationId.Value).then(function (res) {
                var allHistorys = res.results.map(function (bulkCash, index) {
                    var startBalance = 0;
                    var nextIndex = index + 1;
                    var nextRecord = res.results[nextIndex] ? res.results[nextIndex] : null;

                    bulkCash.ledgers.forEach(function (ledger) {
                        if (ledger.denomination) {
                            startBalance += ledger.change * ledger.denomination.faceValue;
                        }
                        bulkCash.mainEntry = bulkCash.ledgers.find(function (entry) {
                            return entry.denominationId == null;
                        });
                        bulkCash.nextEntry = nextRecord ? nextRecord.ledgers.find(function (entry) {
                            return entry.denominationId == null;
                        }) : null;
                    });
                    var depositRecords = bulkCash.depositRecords || bulkCash.depositrecords || [];
                    var fromLoc = null;
                    var toLoc = null;

                    if (depositRecords.length > 0) {
                        fromLoc = depositRecords[0].fromLocation || depositRecords[0].fromlocation;
                        toLoc = depositRecords[0].shipment && depositRecords[0].shipment.toLocation ? depositRecords[0].shipment.toLocation : bulkCash.branchFundingSource ? bulkCash.branchFundingSource.location : null;
                    } else if (bulkCash.shipmentLocation) {
                        fromLoc = bulkCash.shipmentLocation.fromLocation;
                        toLoc = bulkCash.shipmentLocation.toLocation ? bulkCash.shipmentLocation.toLocation : bulkCash.branchFundingSource ? bulkCash.branchFundingSource.location : null;
                    } else if (bulkCash.branchFundingSource && bulkCash.branchFundingSource.location) {
                        fromLoc = bulkCash.branchFundingSource.location;
                    }
                    if (bulkCash.adjustment) {
                        fromLoc = null;
                        toLoc = null;
                    }
                    bulkCash.fromLocationName = fromLoc ? fromLoc.id + ' | ' + fromLoc.name : 'N/A';
                    bulkCash.toLocationName = toLoc ? toLoc.id + ' | ' + toLoc.name : 'N/A';
                    bulkCash.fromLocation = fromLoc;
                    bulkCash.toLocation = toLoc;
                    bulkCash.type = startBalance;
                    bulkCash.startBalance = startBalance;
                    bulkCash.endBalance = startBalance;
                    bulkCash.isBalanceMismatched = bulkCash.totalValue !== 0 && bulkCash.nextEntry && bulkCash.mainEntry && bulkCash.mainEntry.prevBalance !== bulkCash.nextEntry.curBalance ? true : false;
                    return bulkCash;
                });

                if (window.w) {
                    window.w.printData = {
                        denomBalance: _this27.denomBalance,
                        bulkCashHistorys: allHistorys,
                        currencySymbol: _this27.currencySymbol,
                        branchName: branchName,
                        locationName: locationName,
                        dateRange: dateRange,
                        searchText: _this27.model.searchText,
                        curBalance: _this27.curBalance,
                        accountType: _this27.model.stats === _this27.stats.regular ? 'regular' : 'emergency',
                        ready: true
                    };
                }
            }).catch(function (err) {
                console.log("Error fetching bulk cash history for print", err);
            });
        }
    }, {
        key: 'exportToExcel',
        value: function exportToExcel() {
            var _this28 = this;

            var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
            var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
            var searchObj = this.denominationSearchObj();

            var payload = {
                search: (0, _stringify2.default)(searchObj),
                orderNo: this.model.searchText,
                startDate: startDate,
                endDate: endDate,
                fundingSourceId: this.model.locationId.Value,
                branchId: this.model.branchId,
                account: this.model.stats === this.stats.regular ? 'regular' : 'emergency',
                timezone: moment.tz.guess()
            };

            this.isExporting = true;
            var fundingSourceName = this.model.locationId && this.model.locationId.Key ? this.model.locationId.Key : '';
            this.LedgerTransactionService.exportBulkCashHistoryExcel(payload, fundingSourceName).then(function () {}).catch(function (err) {
                console.log("Error exporting bulk cash history excel", err);
            }).finally(function () {
                _this28.isExporting = false;
            });
        }
    }]);
    return BulkCashManagementController;
}();

exports.default = BulkCashManagementController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bulk_cash_management = __webpack_require__(1816);

var _bulk_cash_management2 = _interopRequireDefault(_bulk_cash_management);

var _print = __webpack_require__(1819);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bulkCashManagementModule = angular.module('bulkCashManagement', [_print2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/bulk-cash');

  $stateProvider.state('bulkCashManagement', {
    url: '/bulk-cash',
    component: 'bulkCashManagement',
    data: {
      requireLogin: true,
      requireACL: 'bulk_cash_management.all,view'
    },
    parent: 'app'
  });
}]).component('bulkCashManagement', _bulk_cash_management2.default).name;

exports.default = bulkCashManagementModule;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _print_bulk_cash = __webpack_require__(1820);

var _print_bulk_cash2 = _interopRequireDefault(_print_bulk_cash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintBulkCashModule = angular.module('printBulkCash', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$stateProvider.state('printBulkCash', {
		url: '/bulk-cash-print',
		component: 'printBulkCash',
		data: {
			requireLogin: true,
			requireACL: 'bulk_cash_management.all,view'
		}
	});
}]).component('printBulkCash', _print_bulk_cash2.default).name;

exports.default = PrintBulkCashModule;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_bulk_cash = __webpack_require__(2707);

var _print_bulk_cash2 = _interopRequireDefault(_print_bulk_cash);

var _print_bulk_cash3 = __webpack_require__(1821);

var _print_bulk_cash4 = _interopRequireDefault(_print_bulk_cash3);

__webpack_require__(2989);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintBulkCashComponent = {
  restrict: 'E',
  bindings: {},
  template: _print_bulk_cash2.default,
  controller: _print_bulk_cash4.default
};

exports.default = PrintBulkCashComponent;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintBulkCashController = function () {
    /*@ngInject*/
    PrintBulkCashController.$inject = ["$translate", "$scope"];
    function PrintBulkCashController($translate, $scope) {
        (0, _classCallCheck3.default)(this, PrintBulkCashController);

        this.$translate = $translate;
        this.$scope = $scope;
    }

    (0, _createClass3.default)(PrintBulkCashController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var checkData = setInterval(function () {
                if (window.opener && window.opener.w && window.opener.w.printData && window.opener.w.printData.ready) {
                    clearInterval(checkData);
                    var data = window.opener.w.printData;
                    _this.denomBalance = data.denomBalance;
                    _this.bulkCashHistorys = data.bulkCashHistorys;
                    _this.currencySymbol = data.currencySymbol;
                    _this.branchName = data.branchName;
                    _this.locationName = data.locationName;
                    _this.dateRange = data.dateRange;
                    _this.searchText = data.searchText;
                    _this.curBalance = data.curBalance;
                    _this.accountType = data.accountType;

                    if (_this.$scope) {
                        _this.$scope.$applyAsync();
                    }

                    setTimeout(function () {
                        window.print();
                    }, 1000);
                }
            }, 100);
        }
    }, {
        key: 'isManualAdjustment',
        value: function isManualAdjustment(bulkCashDetails) {
            if (!bulkCashDetails.mainEntry) return;

            if (!bulkCashDetails.comment || bulkCashDetails.mainEntry.change >= 0) return;

            var adjustmentList = ['Undo pack of:', 'Order pack tracking:', 'Creating emergency deposit for', 'Creating deposit for', 'Editing residual:', 'Coin Shipment Checkout'];
            var len = adjustmentList.length;

            for (var i = 0; i < len; i++) {
                var regex = new RegExp(adjustmentList[i], 'i');
                if (bulkCashDetails.comment.match(regex)) return false;
            }
            return true;
        }
    }]);
    return PrintBulkCashController;
}();

exports.default = PrintBulkCashController;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carrierAll = __webpack_require__(2708);

var _carrierAll2 = _interopRequireDefault(_carrierAll);

var _carrierAll3 = __webpack_require__(1823);

var _carrierAll4 = _interopRequireDefault(_carrierAll3);

__webpack_require__(2990);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var carrierallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _carrierAll2.default,
  controller: _carrierAll4.default
};

exports.default = carrierallComponent;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _carrierBase = __webpack_require__(267);

var _carrierBase2 = _interopRequireDefault(_carrierBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarrierallController = function (_CarrierBaseControlle) {
  CarrierallController.$inject = ["Auth", "$state", "User", "Modal", "CarrierService", "$translate", "$stateParams", "$scope", "$location"];
  (0, _inherits3.default)(CarrierallController, _CarrierBaseControlle);

  /*@ngInject*/
  function CarrierallController(Auth, $state, User, Modal, CarrierService, $translate, $stateParams, $scope, $location) {
    (0, _classCallCheck3.default)(this, CarrierallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CarrierallController.__proto__ || (0, _getPrototypeOf2.default)(CarrierallController)).call(this, Auth, $state, User, CarrierService, Modal, $translate, $stateParams, $location));

    _this.id = 'carrier.all';
    _this.loading = true;
    _this.carriers = [];
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.hasACL = {};
    _this._status = 'all';
    _this.userStatus = [{
      label: 'All',
      value: 'all'
    }, {
      label: 'Active',
      value: 'active'
    }, {
      label: 'Inactive',
      value: 'inactive'
    }];
    _this.searchText = '';
    _this.$location = $location;
    _this.branch = User.getUser().branchId;
    _this.model.filterByAllBranch = false;
    _this.filterByValue = null;
    return _this;
  }

  (0, _createClass3.default)(CarrierallController, [{
    key: '$onInit',
    value: function $onInit() {
      this.moment = moment;
      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
    }
  }, {
    key: 'edit',
    value: function edit(carrier) {
      this.$state.go('carrier.edit', {
        id: carrier.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(carrier) {
      var _this2 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + carrier.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          _this2.Service.remove(carrier.id).then(function (data) {
            _this2.allowOnlyOnce = false;
            modal.close();
            _this2.refresh();
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this2.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      this.loading = true;
      this.Service.all({
        queryText: '%' + this.searchText + '%',
        isQuery: false,
        branch: this.branch,
        filterByAllBranch: this.model.filterByAllBranch
      }, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this3.total = data.total;

        _this3.loading = false;
        _this3.carriers = data.results;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.error = err.message;
      });
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(carrier) {
      carrier.expand = !carrier.expand;
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.refresh();
    }
  }, {
    key: 'filterByBranch',
    value: function filterByBranch(value) {
      this.page = 1;
      this.filterByValue = this.filterByValue === value ? undefined : value;
      this.model.filterByAllBranch = this.filterByValue ? true : false;
      this.loadData();
    }
  }]);
  return CarrierallController;
}(_carrierBase2.default);

exports.default = CarrierallController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carrierAll = __webpack_require__(1822);

var _carrierAll2 = _interopRequireDefault(_carrierAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var carrierallModule = angular.module('carrierall', []).component('carrierall', _carrierAll2.default).name;

exports.default = carrierallModule;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carrier = __webpack_require__(2709);

var _carrier2 = _interopRequireDefault(_carrier);

var _carrier3 = __webpack_require__(1826);

var _carrier4 = _interopRequireDefault(_carrier3);

__webpack_require__(2991);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var carrierComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _carrier2.default,
  controller: _carrier4.default
};

exports.default = carrierComponent;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarrierController = function (_SettingBase) {
  CarrierController.$inject = ["$state"];
  (0, _inherits3.default)(CarrierController, _SettingBase);

  /*@ngInject*/
  function CarrierController($state) {
    (0, _classCallCheck3.default)(this, CarrierController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CarrierController.__proto__ || (0, _getPrototypeOf2.default)(CarrierController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'carrier';
    _this.$state = $state;
    _this.hasACL = {};
    return _this;
  }

  (0, _createClass3.default)(CarrierController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(CarrierController.prototype.__proto__ || (0, _getPrototypeOf2.default)(CarrierController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['setting-carrier']) {
        this.hasACL[this.acl['setting-carrier'][key]] = true;
      }
    }
  }]);
  return CarrierController;
}(_SettingBase3.default);

exports.default = CarrierController;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carrierCreate = __webpack_require__(2710);

var _carrierCreate2 = _interopRequireDefault(_carrierCreate);

var _carrierCreate3 = __webpack_require__(1828);

var _carrierCreate4 = _interopRequireDefault(_carrierCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var carriercreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _carrierCreate2.default,
  controller: _carrierCreate4.default
};

exports.default = carriercreateComponent;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _carrierBase = __webpack_require__(267);

var _carrierBase2 = _interopRequireDefault(_carrierBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarrierCreateController = function (_CarrierBaseControlle) {
	CarrierCreateController.$inject = ["Auth", "$state", "User", "CarrierService", "Modal", "$translate", "UserBranchService", "CarrierBranchService"];
	(0, _inherits3.default)(CarrierCreateController, _CarrierBaseControlle);

	/*@ngInject*/
	function CarrierCreateController(Auth, $state, User, CarrierService, Modal, $translate, UserBranchService, CarrierBranchService) {
		(0, _classCallCheck3.default)(this, CarrierCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (CarrierCreateController.__proto__ || (0, _getPrototypeOf2.default)(CarrierCreateController)).call(this, Auth, $state, User, CarrierService, Modal, $translate, UserBranchService, CarrierBranchService));

		_this.UserBranchService = UserBranchService;
		_this.CarrierBranchService = CarrierBranchService;

		_this.defaultModel = {
			id: '',
			name: '',
			description: '',
			POCName: '',
			POCEmail: '',
			POCPhone: '',
			allBranch: [],
			branch: '',
			loggedInUser: User.getUser().id
		};
		_this.model = angular.copy(_this.defaultModel);
		_this.branches = [];
		return _this;
	}

	(0, _createClass3.default)(CarrierCreateController, [{
		key: '$onInit',
		value: function $onInit() {
			this.loading = false;
			this.loadBranch();
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.model = angular.copy(this.defaultModel);
			this.clearErrors();
			this.resetMultiBranchSelection();
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this2 = this;

			this.loading = true;
			this.Service.create({
				id: this.model.id,
				name: this.model.name,
				description: this.model.description,
				POCPhone: this.model.POCPhone,
				POCEmail: this.model.POCEmail,
				POCName: this.model.POCName,
				branchId: this.model.defaultBranch
			}).then(function (data) {
				_this2.loading = false;
				_this2.createCarrierBranch();
				_this2.askCreate();
			}).catch(function (err) {
				_this2.loading = false;
				err.data.errors.map(function (e) {
					_this2.errorMessage += e.message + '<br/>';
				});
			});
		}

		// Reset Multi-Branch selection

	}, {
		key: 'resetMultiBranchSelection',
		value: function resetMultiBranchSelection() {
			var _this3 = this;

			if (this.model.branch && this.model.branch.length) {
				this.model.branch.forEach(function (selectedBranch) {
					_this3.model.allBranch.filter(function (branch) {
						if (branch.branchId == selectedBranch.branchId) {
							branch.ticked = false;
						}
					});
				});
			}
			this.loadBranch();
		}

		// Load branch user has permission

	}, {
		key: 'loadBranch',
		value: function loadBranch() {
			var _this4 = this;

			this.UserBranchService.getUserBranches(this.model.loggedInUser).then(function (data) {
				_this4.model.allBranch = data.results;
				_this4.model.allBranch.filter(function (branch) {
					if (branch.branchId == _this4.User.getUser().branchId) {
						branch.ticked = true;
						_this4.model.defaultBranch = branch.branchId;
					}
				});
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'createCarrierBranch',
		value: function createCarrierBranch() {
			this.branches = this.model.branch.map(function (b) {
				return b.branchId;
			});
			this.CarrierBranchService.createBranchGroup(this.model.id, this.branches).then(function (res) {
				// console.log(res);
			}).catch(function (err) {
				console.log(err);
			});
		}
	}]);
	return CarrierCreateController;
}(_carrierBase2.default);

exports.default = CarrierCreateController;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carrierCreate = __webpack_require__(1827);

var _carrierCreate2 = _interopRequireDefault(_carrierCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var carrierCreateModule = angular.module('carriercreate', []).component('carriercreate', _carrierCreate2.default).name;

exports.default = carrierCreateModule;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carrierEdit = __webpack_require__(2711);

var _carrierEdit2 = _interopRequireDefault(_carrierEdit);

var _carrierEdit3 = __webpack_require__(1831);

var _carrierEdit4 = _interopRequireDefault(_carrierEdit3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var carriereditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _carrierEdit2.default,
  controller: _carrierEdit4.default
};

exports.default = carriereditComponent;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _carrierBase = __webpack_require__(267);

var _carrierBase2 = _interopRequireDefault(_carrierBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarrierEditController = function (_CarrierBaseControlle) {
	CarrierEditController.$inject = ["Auth", "$state", "User", "CarrierService", "Modal", "$translate", "$stateParams", "CarrierBranchService", "$q", "UserBranchService"];
	(0, _inherits3.default)(CarrierEditController, _CarrierBaseControlle);

	/*@ngInject*/
	function CarrierEditController(Auth, $state, User, CarrierService, Modal, $translate, $stateParams, CarrierBranchService, $q, UserBranchService) {
		(0, _classCallCheck3.default)(this, CarrierEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (CarrierEditController.__proto__ || (0, _getPrototypeOf2.default)(CarrierEditController)).call(this, Auth, $state, User, CarrierService, Modal, $translate, $stateParams, CarrierBranchService, $q, UserBranchService));

		_this.$q = $q;
		_this.CarrierBranchService = CarrierBranchService;
		_this.UserBranchService = UserBranchService;

		_this.defaultModel = {
			id: '',
			name: '',
			description: '',
			POCName: '',
			POCEmail: '',
			POCPhone: '',
			allBranch: [],
			defaultBranch: '',
			loggedInUser: User.getUser().id
		};
		_this.model = angular.copy(_this.defaultModel);
		_this.branchData = [];
		_this.branches = [];
		return _this;
	}

	(0, _createClass3.default)(CarrierEditController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.loading = true;

			this.$q.all([this.Service.get(this.$stateParams.id), this.UserBranchService.getUserBranches(this.model.loggedInUser)]).then(function (data) {
				_this2.defaultModel = data[0];
				_this2.rawId = data[0].id;
				_this2.model.id = data[0].id;
				_this2.model.name = data[0].name;
				_this2.model.description = data[0].description;
				_this2.model.POCEmail = data[0].POCEmail;
				_this2.model.POCName = data[0].POCName;
				_this2.model.POCPhone = data[0].POCPhone;
				_this2.model.defaultBranch = data[0].branchId;
				_this2.branchData = data[1].results;
			}).then(function () {
				_this2.loadBranch();
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this2.loading = false;
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.resetMultiBranchSelection();
			this.model = angular.copy(this.defaultModel);
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this3 = this;

			// if (!this.validate()) {
			// 	return
			// }

			this.loading = true;
			this.Service.update(this.rawId, {
				name: this.model.name,
				description: this.model.description,
				POCPhone: this.model.POCPhone,
				POCEmail: this.model.POCEmail,
				POCName: this.model.POCName,
				branchId: this.model.defaultBranch
			}).then(function (data) {
				_this3.updateBranchGroup();
			}).then(function () {
				_this3.loading = false;
				window.history.go(-1);
			}).catch(function (err) {
				_this3.loading = false;
				err.data.errors.map(function (e) {
					_this3.errorMessage += e.message + '<br/>';
				});
			});
		}

		// Reset Multi-Branch selection

	}, {
		key: 'resetMultiBranchSelection',
		value: function resetMultiBranchSelection() {
			var _this4 = this;

			var usersBranches = this.model.allBranch.map(function (data) {
				return data.branchId;
			});
			if (this.model.branch && this.model.branch.length && usersBranches) {
				this.model.allBranch.forEach(function (selectedBranch) {
					_this4.branchData.filter(function (branch) {
						var isIncludes = usersBranches.includes(branch.branchId);
						if (branch.branchId == selectedBranch.branchId) {
							branch.ticked = true;
						}
						if (!isIncludes) {
							branch.ticked = false;
						}
					});
				});
			}
			this.loadBranch();
		}
	}, {
		key: 'loadBranch',
		value: function loadBranch() {
			var _this5 = this;

			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'carrierId',
						condition: '=',
						data: this.$stateParams.id
					}],
					operator: 'AND'
				}
			};

			this.CarrierBranchService.all(searchObj, 0, 100).then(function (data) {
				_this5.model.allBranch = data.results;
				_this5.model.allBranch.forEach(function (selectedBranch) {
					_this5.branchData.filter(function (branch) {
						if (branch.branchId == selectedBranch.branchId) {
							branch.ticked = true;
						}
					});
				});
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'updateBranchGroup',
		value: function updateBranchGroup() {
			this.branches = this.model.branch.map(function (b) {
				return b.branchId;
			});
			this.CarrierBranchService.updateBranchGroup(this.rawId, this.branches).then(function (res) {
				// console.log(res);
			}).catch(function (err) {
				console.log(err);
			});
		}
	}]);
	return CarrierEditController;
}(_carrierBase2.default);

exports.default = CarrierEditController;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carrierEdit = __webpack_require__(1830);

var _carrierEdit2 = _interopRequireDefault(_carrierEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var carrierEditModule = angular.module('carrieredit', []).component('carrieredit', _carrierEdit2.default).name;

exports.default = carrierEditModule;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carrier = __webpack_require__(1825);

var _carrier2 = _interopRequireDefault(_carrier);

var _create = __webpack_require__(1829);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(1832);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(1824);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var carrierModule = angular.module('carrier', [_create2.default, _edit2.default, _all2.default]).component('carrier', _carrier2.default).config(["$stateProvider", function ($stateProvider) {
  "ngInject";

  $stateProvider.state('carrier.edit', {
    url: '/edit/:id',
    component: 'carrieredit',
    data: {
      requireACL: 'setting-carrier.edit'
    }
  }).state('carrier.create', {
    url: '/create',
    component: 'carriercreate',
    data: {
      requireACL: 'setting-carrier.create'
    }
  }).state('carrier.all', {
    url: '/all/:page',
    component: 'carrierall',
    data: {
      requireACL: 'setting-carrier.view'
    }
  });
}]).name;

exports.default = carrierModule;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(2992);

var cashActivityComponent = {
  restrict: "E",
  bindings: {}
};

exports.default = cashActivityComponent;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cash_activity = __webpack_require__(1834);

var _cash_activity2 = _interopRequireDefault(_cash_activity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cashActivityModule = angular.module("cashActivity", []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise("/cashActivity");

  $stateProvider.state("cashActivity", {
    url: "/v2/index.html#/cash-activity",
    component: "cashActivity",
    data: {
      requireLogin: true,
      requireACL: "cash_activity.customer,funding_source"
    }
  });
}]).component("cashActivity", _cash_activity2.default).name;

exports.default = cashActivityModule;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkin = __webpack_require__(2712);

var _checkin2 = _interopRequireDefault(_checkin);

var _checkin3 = __webpack_require__(1837);

var _checkin4 = _interopRequireDefault(_checkin3);

__webpack_require__(2993);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkinComponent = {
  restrict: 'E',
  bindings: {},
  template: _checkin2.default,
  controller: _checkin4.default
};

exports.default = checkinComponent;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckInController = function () {
  /*@ngInject*/

  CheckInController.$inject = ["Auth", "$state", "User", "$translate", "BranchService", "CustomerService", "Modal", "RouteService", "WindowService", "TruckService", "$q", "ScanService", "ShipmentService", "LocationService", "ShiptypeService", "SetupService", "$location", "$timeout", "$window", "Sound", "TransactionService", "$rootScope", "ItemService"];
  function CheckInController(Auth, $state, User, $translate, BranchService, CustomerService, Modal, RouteService, WindowService, TruckService, $q, ScanService, ShipmentService, LocationService, ShiptypeService, SetupService, $location, $timeout, $window, Sound, TransactionService, $rootScope, ItemService) {
    (0, _classCallCheck3.default)(this, CheckInController);

    this.submitManifest = function () {
      var _this = this;

      if (!(this.manifest.totalBagCount > 0)) return;
      if (this.manifest.isSubmitting || this.manifest.isCompleted) return;
      this.manifest.isSubmitting = true;
      this.ShipmentService.createCheckinManifest(this.shipmentData.shipment.fromLocationId, this.vaultDate, this.model.route, this.manifest.totalBagCount, this.manifest.manifestID, this.loggedInUser).then(function (data) {
        _this.manifest.isCompleted = true;
        _this.callCheckinBag().then(function () {
          _this.Sound.playSuccessBeep("#success_beep");
          _this.resetManifestForm();
        });
      }).catch(function (err) {
        _this.manifest.isCompleted = false;
        console.log(err);
      }).finally(function () {
        _this.manifest.isSubmitting = false;
      });
    };

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.Modal = Modal;
    this.ScanService = ScanService;
    this.ShipmentService = ShipmentService;
    this.LocationService = LocationService;
    this.ShiptypeService = ShiptypeService;
    this.TransactionService = TransactionService;
    this.TruckService = TruckService;
    this.SetupService = SetupService;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$location = $location;
    this.checkAndCall = false;
    this.Sound = Sound;
    this.BranchService = BranchService;
    this.CustomerService = CustomerService;
    this.RouteService = RouteService;
    this.WindowService = WindowService;
    this.$rootScope = $rootScope;
    this.ItemService = ItemService;
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();
    this.$window = $window;
    this.user = null;
    this.shpmentsCount = [];
    this.branches = [];
    this.customers = [];
    this.routes = [];
    this.windows = [];
    this.trucks = [];
    this.shiptypes = [];
    this.checkinShipmentData = [];
    this.branchWiseShipment = [];
    this.availableDestinationData = [];
    this.getAvailableDestination = [];
    this.routeVerifyData = {};
    this.destinationData = {
      previouslyScannedId: '',
      destinations: {
        self: null,
        deliveryLoc1: null,
        deliveryLoc2: null,
        deliveryLocCod: null,
        deliveryLocCoin: null
      }
    };

    this.scannerBeep = null;
    this.closedRoute = null;
    this.bagIdCopy = null;

    this.bagCheckinError = '';
    this.bagCheckinMessage = '';
    this.shipmentChangeMessage = '';
    this.isShipperChanged = false;
    this.trueOriginalShipperLocationId = null;

    this.wasItemFound = false;
    this.isManuallyAddedShipment = false;
    this.isCheckinSuccessfull = true;
    this.lastScanned = null;
    this.remainingCheckinItemCount = null;
    this.resetModel();
    this.resetNewValues();
    this.branchId = this.User.getUser().branchId;
    this.loggedInUser = this.User.getUser().id;
    this.checkInDate = $location.search().routeDate || null;
    this.vaultDate = '';
    this.setupData = '';
    this.shipmentTankerData = [];
    this.disabledBag = false;
    this.isEventFired = false;
    // this.bagScanLimit = AppConstant.scanLimit;
    this.bagScanLimit = "";
    this.checkOnlyOnce = false;
    this.checkLength = 0;
    this.enterSuffix = _app2.default.scan_enter_suffix;
    this.remainingToCheckin = [];
    this.$rootScope.$broadcast('routeChange', '/app/checkin');
    this.shipmentData = {};
    this.locationOnHold = false;

    this.checkInScanTab = {
      shipment: 'shipment',
      items: 'items'
    };

    this.itemStats = {
      cash: 'cash',
      items: 'items'
    };

    this.currentCheckInTab = this.checkInScanTab.shipment;
    this.logisticItemObj = {
      barcode: null,
      itemScanLimitExceed: false,
      allowItemScanOnce: false,
      disableItemScan: false,
      defaultLength: 0,
      lastScannedItem: null,
      lastUpdated: null,
      isError: false,
      itemCheckInError: null,
      itemCheckInMessage: null,
      remainingItemList: [],
      checkedInItemList: [],
      itemDetails: {},
      wasItemFound: false,
      isItemCheckedIn: false,
      remainingItemsCount: 0,
      checkedInItemsCount: 0
    };
    this.manifest = {
      showManifestModal: false,
      totalBagCount: null,
      manifestID: null,
      isSubmitting: false,
      isCompleted: false
    };
  }

  (0, _createClass3.default)(CheckInController, [{
    key: 'loadWindows',
    value: function loadWindows() {
      var _this2 = this;

      return this.BranchService.get(this.model.branch).then(function (branch) {
        _this2.windows = branch.windows;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      return this.$q.all([this.BranchService.all(null, 0, 1000), this.RouteService.all(null, 0, 1000), this.TruckService.all(null, 0, 1000), this.ShiptypeService.all(null, 0, 1000), this.ScanService.getShipmentTanker(this.branchId, this.vaultDate)]).then(function (res) {
        _this3.branches = res[0].results;
        _this3.routes = res[1].results;
        _this3.trucks = res[2].results;
        _this3.shiptypes = res[3].results;
        _this3.shipmentTankerData = res[4].map(function (data) {
          return data.tankerId.toUpperCase();
        });
      });
    }
  }, {
    key: 'verifyRoute',
    value: function verifyRoute(routeId, date) {
      var _this4 = this;

      return this.ScanService.routeCheckinVerify(this.branchId, routeId, date, this.model.messengerId).then(function (data) {
        _this4.checkInData(routeId);
        _this4.routeVerifyData = data;

        _this4.logisticItemObj.remainingItemList = _this4.routeVerifyData.checkedOutItemList || [];
        _this4.logisticItemObj.remainingItemsCount = _this4.logisticItemObj.remainingItemList.length || 0;
        _this4.logisticItemObj.checkedInItemList = _this4.routeVerifyData.checkedInItemList || [];
        _this4.logisticItemObj.checkedInItemsCount = _this4.logisticItemObj.checkedInItemList.length || 0;
        _this4.routeVerifyData.errorCount = 0;
        _this4.remainingCheckinItemCount = 0;
        _this4.remainingToCheckin = [];

        if (_this4.routeVerifyData.route) {
          _this4.routeVerifyData.route.forEach(function (record) {

            switch (record.message) {
              case 'E_PICKUP_NOT_CHECKED_IN':
              case 'E_DELIVERY_NOT_DELIVERED':
                if (!(record.isRequiredPickup === 1 && !record.orderNo && record.verified === 0)) {
                  _this4.remainingCheckinItemCount++;
                  _this4.remainingToCheckin.push(record);
                }
                break;
            }

            if (record.isError || record.message === 'E_LOCATION_NOT_ON_HOLD') {
              _this4.routeVerifyData.errorCount++;
            }
          });
          _this4.routeVerifyData.errorCount = _this4.routeVerifyData.errorCount + _this4.logisticItemObj.remainingItemsCount;
        }
        return data;
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this4.Modal.errorModal('error.' + err.data.message);
        }
      });
    }
  }, {
    key: 'focusElementById',
    value: function focusElementById(id) {
      setTimeout(function () {
        if (!document.getElementById(id)) return;
        document.getElementById(id).focus();
      }, 300);
    }
  }, {
    key: 'loadCheckinDate',
    value: function loadCheckinDate() {
      var _this5 = this;

      this.checkInDate = this.$location.search().routeDate;
      if (!this.checkInDate) {
        var branchId = this.User.getUser().branchId;

        this.SetupService.get(branchId).then(function (setup) {
          _this5.setupData = setup;
          _this5.checkInDate = moment(setup.currentVaultDate).utc().format('YYYY-MM-DD');
          _this5.prefixes = setup.prefixes;
          _this5.vaultDate = moment(setup.currentVaultDate).utc().format('YYYY-MM-DD');
          _this5.bagScanLimit = setup.packCharLength;
          _this5.locationOnHold = setup.locationOnHold;
          if (_this5.setupData.enableAutoSubmit) _this5.autoSubmitItem = true;else _this5.autoSubmitItem = false;
        }).then(function () {
          _this5.loadData();
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this5.Modal.errorModal(err.data.message);
          }
        });
      }
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      this.model.currentItemStat = this.itemStats.cash;
      this.scannedRouteId = "";
      // focus on the messenger field
      if (!this.hasRoute) {
        this.focusElementById('route-scan-id');
      }
      this.loadCheckinDate();
      this.user = this.User.getUser();
      this.model.branch = this.user.branchId;
    }
  }, {
    key: 'routeScanned',
    value: function routeScanned() {
      var _this6 = this;

      var finalRouteData;
      if (this.scannedRouteId === '' || this.isEventFired) return;

      this.closedRoute = undefined;
      this.lastStatusUpdate = undefined;
      finalRouteData = this.scannedRouteId;
      this.isEventFired = true;

      this.verifyRoute(finalRouteData, this.checkInDate).then(function (data) {
        if (!data) return;
        return _this6.scanRoute(finalRouteData, _this6.checkInDate);
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this6.routeError();
          _this6.Modal.errorModal('error.' + err.data.message);
        }
      }).finally(function () {
        _this6.isEventFired = false;
        _this6.scannedRouteId = '';
        finalRouteData = '';
      });
    }
  }, {
    key: 'scanRoute',
    value: function scanRoute(finalRouteData, checkInDate) {
      var _this7 = this;

      this.ScanService.scanRoute(this.model.branch, finalRouteData, checkInDate, false, true, true).then(function (data) {
        if (data.error) {
          _this7.isEventFired = false;
          return _this7.Modal.errorModal(data.error);
        }
        _this7.model.route = data.route.routeId;
        _this7.model.routeObj = data.route;
        _this7.model.loadTruck = true; //!!data.route.loadTruck;
      }).then(function (data) {
        _this7.focusElementById('window-scan-id');
        _this7.Sound.playSuccessBeep("#success_beep");
        _this7.hasRoute = true;
        _this7.model.window = "";
      }).catch(function (err) {
        _this7.hasRoute = false;
        if (err && err.data && err.data.message) {
          _this7.routeError();
          _this7.Modal.errorModal('error.' + err.data.message);
        }
      });
    }
  }, {
    key: 'routeError',
    value: function routeError() {
      this.hasRoute = false;
      this.Sound.PlayErrorBeep("#scanner_beep");
    }
  }, {
    key: 'windowScanned',
    value: function windowScanned() {
      var _this8 = this;

      var finalWindowData;

      // if (this.prefixes && this.prefixes.window) {
      // if (this.model.window.startsWith(this.prefixes.window[0])) {
      // finalWindowData = this.model.window.slice(this.prefixes.window[0].length)
      // } else {
      // finalWindowData = this.model.window;
      // }
      // } else {
      // finalWindowData = this.model.window;
      // }

      finalWindowData = this.model.window;
      this.BranchService.get(this.user.branchId).then(function (branchObj) {
        _this8.hasWindow = branchObj.windows.some(function (window) {
          return finalWindowData.toUpperCase() === window.id.toUpperCase();
        });

        if (_this8.hasWindow) {
          _this8.model.window = finalWindowData;
          _this8.focusElementById('messengerId');
          _this8.Sound.playSuccessBeep("#success_beep");
          _this8.model.messengerId = "";
        } else if (finalWindowData === '') {
          return;
        } else {
          _this8.Sound.PlayErrorBeep("#scanner_beep");
          _this8.model.window = '';
          finalWindowData = '';
          _this8.Modal.errorModal('error.' + 11000);
        }
      });
    }
  }, {
    key: 'setFocus1',
    value: function setFocus1(ele) {
      this.focusElementById(this.hasMessenger ? 'bagId' : 'messengerId');
    }
  }, {
    key: 'messengerScanned',
    value: function messengerScanned() {
      var _this9 = this;

      var finalMessengerData;
      if (this.model.messengerId === "") {
        return;
      }

      // if (this.prefixes && this.prefixes.messenger) {
      //   if (this.model.messengerId.startsWith(this.prefixes.messenger[0])) {
      //     finalMessengerData = this.model.messengerId.slice(this.prefixes.messenger[0].length)
      //   } else {
      //     finalMessengerData = this.model.messengerId;
      //   }
      // } else {
      //   finalMessengerData = this.model.messengerId;
      // }

      finalMessengerData = this.model.messengerId;
      this.ScanService.scanMessenger(this.model.branch, this.model.route, finalMessengerData, this.checkInDate, true).then(function (data) {
        // console.log(data)
        if (data.error) {
          _this9.model.messengerId = '';
          finalMessengerData = '';
          return _this9.Modal.errorModal(data.error);
        }
        _this9.hasMessenger = true;
        _this9.model.messengerId = finalMessengerData;
        if (_this9.model.routeObj && _this9.model.routeObj.scanUserItems === 1) {
          _this9.getCheckinUserAssignedItems();
        }
      }).then(function () {
        _this9.focusElementById('truckId');
        _this9.Sound.playSuccessBeep("#success_beep");
        if (_this9.setupData && _this9.setupData.virtualTankers && _this9.setupData.defaultFromTankerId && !_this9.model.fromTanker) {
          _this9.model.fromTanker = _this9.setupData.defaultFromTankerId;
        } else {
          _this9.model.fromTanker = "";
        }
      }).catch(function (err) {
        if (err.data.message) {
          _this9.Sound.PlayErrorBeep("#scanner_beep");
          _this9.model.messengerId = '';
          finalMessengerData = '';
          return _this9.Modal.errorModal('error.' + err.data.message);
        }
      });
    }
  }, {
    key: 'resetFromTanker',
    value: function resetFromTanker() {
      this.model.fromTanker = "";
      this.Sound.PlayErrorBeep("#scanner_beep");
    }
  }, {
    key: 'getTankerSearchObj',
    value: function getTankerSearchObj(id) {
      return {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branch
          }, {
            field: 'id',
            condition: '=',
            data: id
          }],
          operator: 'AND'
        }
      };
    }
  }, {
    key: 'fromTankerScanned',
    value: function fromTankerScanned() {
      var _this10 = this;

      var finalFromTankerData;
      if (this.model.fromTanker === "") {
        return;
      }

      if (this.setupData.tankerId.toUpperCase() === this.model.fromTanker) {
        this.resetFromTanker();
        return this.Modal.errorModal('error.' + 90926);
      } else if (this.setupData.virtualTankerId.toUpperCase() === this.model.fromTanker) {
        this.resetFromTanker();
        return this.Modal.errorModal('error.' + 90927);
      } else if (this.shipmentTankerData.includes(this.model.fromTanker)) {
        this.resetFromTanker();
        return this.Modal.errorModal('error.' + 90928);
      }

      // if (this.prefixes && this.prefixes.tanker) {
      //   if (this.model.fromTanker.startsWith(this.prefixes.tanker[0])) {
      //     finalFromTankerData = this.model.fromTanker.slice(this.prefixes.tanker[0].length)
      //   } else {
      //     finalFromTankerData = this.model.fromTanker;
      //   }
      // } else {
      //   finalFromTankerData = this.model.fromTanker;
      // }

      finalFromTankerData = this.model.fromTanker;
      var searchObj = this.getTankerSearchObj(finalFromTankerData);
      this.LocationService.all(searchObj, 0, 1000).then(function (res) {
        var tanker = res.results[0];
        if (tanker.locationType !== 'TANKER') {
          _this10.model.toTanker = "";
          return _this10.Modal.errorModal('error.' + 90914);
        }

        _this10.hasFromTanker = !!finalFromTankerData;
        _this10.model.fromTanker = finalFromTankerData;

        // Always ask for ToTanker, irrespective of loadTruck value
        if (_this10.model.loadTruck) {
          _this10.focusElementById('toTanker');
          _this10.Sound.playSuccessBeep("#success_beep");
          if (_this10.setupData && _this10.setupData.virtualTankers && _this10.setupData.defaultToTankerId && !_this10.model.toTanker) {
            _this10.model.toTanker = _this10.setupData.defaultToTankerId;
          } else {
            _this10.model.toTanker = "";
          }
        } else {
          _this10.showCheckin = true;
        }
      }).catch(function (err) {
        _this10.Sound.PlayErrorBeep("#scanner_beep");
        _this10.model.fromTanker = "";
        finalFromTankerData = "";
        return _this10.Modal.errorModal('error.' + 90914);
      });
    }
  }, {
    key: 'toTankerScanned',
    value: function toTankerScanned() {
      var _this11 = this;

      var finalToTankerData = void 0,
          holdTanker = this.setupData.tankerId,
          virtualTanker = this.setupData.virtualTankerId;

      if (this.model.toTanker === "") {
        return;
      }

      if (holdTanker.toUpperCase() === this.model.toTanker) {
        this.resetToTanker();
        return this.Modal.errorModal('error.' + 90926);
      } else if (virtualTanker.toUpperCase() === this.model.toTanker) {
        this.resetToTanker();
        return this.Modal.errorModal('error.' + 90927);
      } else if (this.model.toTanker === this.model.fromTanker) {
        this.resetToTanker();
        return this.Modal.errorModal('error.' + 90929);
      }

      finalToTankerData = this.model.toTanker;
      var searchObj = this.getTankerSearchObj(finalToTankerData);
      this.LocationService.all(searchObj, 0, 1000).then(function (res) {
        var tanker = res.results[0];
        if (tanker.locationType !== 'TANKER') {
          _this11.resetToTanker();
          return _this11.Modal.errorModal('error.' + 90911);
        }
        _this11.focusElementById('barcode');
        _this11.hasToTanker = _this11.showCheckin = !!_this11.model.toTanker;
      }).catch(function (err) {
        _this11.resetToTanker();
        return _this11.Modal.errorModal('error.' + 90911);
      });
    }
  }, {
    key: 'resetToTanker',
    value: function resetToTanker() {
      this.model.toTanker = "";
      this.Sound.PlayErrorBeep("#scanner_beep");
      // return this.Modal.errorModal('error.' + 90911)
    }
  }, {
    key: 'setDestination',
    value: function setDestination(destination) {
      this.isDestinationChanged = this.model.destination.id !== destination.id;
      this.newValues.destination = destination;
    }
  }, {
    key: 'stopPropagation',
    value: function stopPropagation(event) {
      event.stopPropagation();
      event.preventDefault();
    }

    // get checkedIn shipment based on branchId and routeId

  }, {
    key: 'checkInData',
    value: function checkInData(routeId) {
      var _this12 = this;

      this.ScanService.shipmentCheckInCheckOutData(this.model.branch, routeId, this.vaultDate).then(function (data) {
        _this12.checkedInItem = data.checkInCheckOutCount.totalCheckedInItemCount;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'checkinBag',
    value: function checkinBag() {
      var _this13 = this;

      var fromLocationId = this.model.shipper && this.model.shipper.Value !== this.trueOriginalShipperLocationId ? this.model.shipper.Value : undefined;
      var isManuallyAddedShipment = this.isManuallyAddedShipment;
      this.isManuallyAddedShipment = false;
      return this.ShipmentService.checkinShipment(this.model.branch, this.model.bagId, this.model.route, this.checkInDate, this.model.window, this.model.fromTanker, this.model.toTanker, fromLocationId, isManuallyAddedShipment).then(function (response) {

        if (response.error) {
          _this13.isError = true;
          return _this13.Modal.errorModal(response.error);
        }
        // if (this.remainingCheckinItemCount >= 0) {
        //   this.remainingCheckinItemCount--
        // }
        _this13.clearScan();
        _this13.Sound.playSuccessBeep("#success_beep");
      }).finally(function () {
        _this13.verifyRoute(_this13.model.route, _this13.checkInDate);
        _this13.lastStatusUpdate = new Date();
      });
    }

    // autoSubmit() {
    //   // this.isProvisionalCredit = false;
    //   const bagScannedPromise = this.bagScanned();
    //   //in case of error bagScanned returns non promise values are returned ther's a check for .then function
    //   if (bagScannedPromise && typeof bagScannedPromise.then === "function") {
    //     bagScannedPromise.then(() => {
    //       return this.bagSubmitted();
    //     })
    //   }

    //   return bagScannedPromise;
    // }

  }, {
    key: 'callCheckinBag',
    value: function callCheckinBag() {
      var _this14 = this;

      if (!this.model.bagId || this.isError) {
        this.isEventFired = false;
        return _promise2.default.resolve();
      }
      var successMessage = this.model.bagId + " " + this.$translate.instant('checkin.checkedin');

      this.isError = false;
      this.bagCheckinMessage = '';
      return this.checkinBag().then(function () {
        _this14.bagCheckinMessage = successMessage;
        _this14.isEventFired = false;
      }).catch(function (err) {
        _this14.isEventFired = false;
        _this14.isError = true;
        if (err && err.data && err.data.message) {
          _this14.Sound.PlayErrorBeep("#scanner_beep");
          _this14.bagCheckinError = _this14.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        } else {
          _this14.bagCheckinError = err.toString();
        }
      });
    }
  }, {
    key: 'bagSubmitted',
    value: function bagSubmitted() {
      var _this15 = this;

      return new _promise2.default(function (resolve, reject) {
        // if (this.newValues.amount <= 0) {
        //   this.Modal.errorModal("Cannot allow shipment check-in with a $0 amount.");
        //   return reject();
        // }
        var shipment = _this15.Shipmentresponse || _this15.shipmentData && _this15.shipmentData.shipment;

        _this15.proceedWithCheckIn(shipment, resolve, reject);
      });
    }
  }, {
    key: 'proceedWithCheckIn',
    value: function proceedWithCheckIn(shipment, resolve, reject) {
      var _this16 = this;

      if (shipment && (shipment.orderNo === null || shipment.orderNo === "") && (!shipment.verified || shipment.verified === 0) && (shipment.isRequiredPickup || shipment.isRequiredPickup === 1)) {
        this.Modal.confirmSupervisor('checkin-not-picked-up', {}, function (_ref) {
          var modal = _ref.modal,
              supId = _ref.supId;

          _this16.callCheckinBag().then(function () {
            modal.close();
            resolve();
          }).catch(function (err) {
            modal.close();
            reject(err);
          });
        }, function (_ref2) {
          var modal = _ref2.modal;

          modal.close();
          _this16.isEventFired = false;
          _this16.disabledBag = false;
          _this16.focusElementById('bagId');
          reject('Supervisor challenge cancelled');
        });
        return;
      }

      if (this.shipmentData && this.shipmentData.shipment && this.shipmentData.shipment.shiptypeId === 'BULKCASH' && this.locationData && this.locationData.locationType === 'BANK' && this.locationData.centralBank === true) {
        this.manifest.showManifestModal = true;
        resolve();
      } else {
        this.callCheckinBag().then(resolve).catch(reject);
      }
    }
  }, {
    key: 'editShipper',
    value: function editShipper(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (!this.model.bagId) return;

      this.isEditingShipper = true;
      this.loadShipperLocations('', 0);
      this.focusElementById('shipperSelection');
    }
  }, {
    key: 'onShipperSelected',
    value: function onShipperSelected() {
      var _this17 = this;

      this.$timeout(function () {
        if (!_this17.selectedShipperLocation) {
          _this17.selectedShipperLocation = _this17.originalShipperLocationObj;
        }

        _this17.model.shipper = {
          name: _this17.selectedShipperLocation.dataObj ? _this17.selectedShipperLocation.dataObj.name : _this17.selectedShipperLocation.name,
          address: _this17.selectedShipperLocation.dataObj ? _this17.selectedShipperLocation.dataObj.address : _this17.selectedShipperLocation.address,
          Value: _this17.selectedShipperLocation.Value,
          Key: _this17.selectedShipperLocation.Key
        };

        _this17.isShipperChanged = (_this17.model.shipper.Value || null) !== (_this17.originalShipperLocationId || null);

        _this17.isEditingShipper = false;
      });
    }
  }, {
    key: 'mappingData',
    value: function mappingData(arr, label, value) {
      return arr.map(function (item) {
        var arrayObject = {
          Key: item[value] + ' | ' + item[label],
          Value: item[value],
          value: item[value],
          label: item[label],
          dataObj: item
        };
        return arrayObject;
      });
    }
  }, {
    key: 'loadShipperLocations',
    value: function loadShipperLocations(searchKey, offset) {
      var _this18 = this;

      searchKey = searchKey || '';

      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.branchId
          }, {
            field: 'active',
            condition: '=',
            data: true
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      this.shipperLocationsLoading = true;
      return this.LocationService.all(searchObj, offset, _app2.default.defaultPageLimit || 10).then(function (res) {
        var locations = _this18.mappingData(res.results, 'name', 'id');
        if (offset === 0 || offset === undefined) {
          _this18.shipperLocationObj = {
            total: res.total,
            results: locations
          };
        } else {
          _this18.shipperLocationObj.results = _this18.shipperLocationObj.results.concat(locations);
        }
      }).catch(function (err) {
        console.error(err);
      }).finally(function () {
        _this18.shipperLocationsLoading = false;
      });
    }
  }, {
    key: 'setAvailableDestinations',
    value: function setAvailableDestinations(fromLocationId, toLocationData, shiptypeId) {
      var _this19 = this;

      var destinationsLoadedDefer = this.$q.defer();
      var addAvailableDestinations = function addAvailableDestinations(locationFields) {
        var addedDesintationIds = [];

        locationFields.forEach(function (field) {
          var destinationObj = _this19.destinationData.destinations[field];

          if (destinationObj && addedDesintationIds.indexOf(destinationObj.value) === -1) {
            _this19.availableDestinations.push(destinationObj);
            addedDesintationIds.push(destinationObj.value);
          }
        });
      };

      this.destinationData.destinations.self = {
        name: toLocationData.name,
        address: toLocationData.address,
        value: toLocationData.id
      };

      if (this.destinationData.previouslyScannedId === fromLocationId) {
        destinationsLoadedDefer.resolve();
      } else {
        this.LocationService.get(fromLocationId).then(function (locationData) {
          var destinations = _this19.destinationData.destinations;
          var locationFields = ['deliveryLoc1', 'deliveryLoc2', 'deliveryLocCod', 'deliveryLocCoin'];

          _this19.locationData = locationData;

          locationFields.forEach(function (field) {
            var locationObj = locationData[field];

            if (locationObj && locationObj.id) {
              destinations[field] = {
                name: locationObj.name,
                address: locationObj.address,
                value: locationObj.id,
                city: locationObj.city,
                zip: locationObj.zip,
                state: locationObj.state,
                country: locationObj.country
              };
            }
          });

          destinationsLoadedDefer.resolve();
        });
      }

      return destinationsLoadedDefer.promise.then(function () {
        var coinLocations = ['self', 'deliveryLocCoin'];
        var cashLocations = ['self', 'deliveryLoc1', 'deliveryLoc2', 'deliveryLocCod'];
        var locationFields = [];
        // this.getAvailableDestination = [];
        _this19.availableDestinations = [];

        _this19.selectedShiptype = _this19.shiptypes.find(function (shiptype) {
          return shiptype.id === shiptypeId;
        });

        locationFields = _this19.selectedShiptype.coinFlag ? coinLocations : cashLocations;

        var areAllDestinationsNull = locationFields.slice(1) // remove 'self'
        .every(function (deliverToField) {
          //checks whether for a given location field the value is falsy
          return !_this19.destinationData.destinations[deliverToField];
        });

        if (areAllDestinationsNull) {
          // if destinations other than self are null then select locationFields of other group
          locationFields = _this19.selectedShiptype.coinFlag ? cashLocations : coinLocations;
        }

        return addAvailableDestinations(locationFields);
      });
    }
  }, {
    key: 'keyPressed',
    value: function keyPressed(controlId, $event) {
      var ESC_KEY_CODE = 27;
      var BACKSPACE_KEY_CODE = 8;
      if (controlId === 'bagId') {
        if ($event.keyCode === ESC_KEY_CODE) {
          this.clearScan(true);
        }
        if ($event.keyCode === BACKSPACE_KEY_CODE && this.model.bagId && this.model.bagId.length <= 1) {
          this.clearScan(true);
        }
      }
    }
  }, {
    key: 'scanSuffix',
    value: function scanSuffix(value) {
      if (this.enterSuffix.length > 0 && value && value.toUpperCase().endsWith(this.enterSuffix)) {
        var bagIdLength = value.length;
        return value.slice(0, bagIdLength - this.enterSuffix.length);
      } else return value;
    }
  }, {
    key: 'autoSubmit',
    value: function autoSubmit() {
      var _this20 = this;

      this.verifyProvisionalCashShipment();
      var bagScannedPromise = this.bagScanned();

      setTimeout(function () {
        if (bagScannedPromise && typeof bagScannedPromise.then === "function") {
          bagScannedPromise.then(function () {
            setTimeout(function () {
              return _this20.bagSubmitted();
            }, 700);
          });
        }
      }, this.interval);

      return bagScannedPromise;
    }
  }, {
    key: 'verifyProvisionalCashShipment',
    value: function verifyProvisionalCashShipment() {
      var provisionalCredit = _.find(this.routeVerifyData.route, { 'trackingId': this.model.bagId });
      this.isProvisionalCredit = provisionalCredit && provisionalCredit.shiptypeId === 'PC' ? true : false;
      this.interval = this.isProvisionalCredit ? 1500 : 0;

      if (this.isProvisionalCredit) {
        document.getElementById('bagId').blur();
        var element = document.getElementById("provisional-credit");
        if (!element) return;
        element.style.display = 'flex';
      }
    }
  }, {
    key: 'removeOverlayToast',
    value: function removeOverlayToast() {
      var _this21 = this;

      setTimeout(function () {
        var element = document.getElementById("provisional-credit");
        if (!element) return;
        _this21.focusElementById('bagId');
        element.style.display = 'none';
      }, this.interval);
    }
  }, {
    key: 'bagScanned',
    value: function bagScanned() {
      var _this22 = this;

      this.checkAndCall = false;
      this.model.bagId = this.scanSuffix(this.model.bagId);

      if (!this.model.bagId || this.isEventFired) {
        return;
      }

      this.bagScanLimitExceed = false;

      if (this.bagScanLimit && this.bagScanLimit > 0) {
        if (this.model.bagId.length > this.bagScanLimit && (!this.checkOnlyOnce || this.model.bagId.length !== this.checkLength)) {
          delete this.bagCheckinError;
          delete this.bagCheckinMessage;
          delete this.shipmentChangeMessage;
          this.bagScanLimitExceed = true;
          this.checkOnlyOnce = true;
          this.lastScanned = this.model.bagId;
          this.checkLength = this.model.bagId.length;
          this.model.bagId = "";
          this.lastStatusUpdate = new Date();
          return this.bagScanError = this.$translate.instant('common.bagScanError');
        } else {
          this.checkLength = this.model.bagId.length > this.bagScanLimit ? this.model.bagId.length : this.bagScanLimit;
        }
      }

      if (this.isDestinationChanged || this.isAmountChanged) {
        this.checkAndCall = true;
        return this.saveChanges();
      }

      if (!this.model.window) {
        return this.Modal.errorModal('11000');
      }

      delete this.lastStatusUpdate;

      if (this.bagIdCopy === this.model.bagId && this.isCheckinSuccessfull) {
        this.isEventFired = true;
        this.isCheckinSuccessfull = false;
        return this.bagSubmitted();
      } else {
        this.bagIdCopy = this.model.bagId;
        this.lastScanned = this.model.bagId;
      }

      this.isError = false;
      this.wasItemFound = true;
      this.bagCheckinError = '';

      this.resetNewValues();
      this.getAvailableDestination = [];
      this.Shipmentresponse = [];
      this.fuzzyMatch = false;
      this.disabledBag = true;

      return this.ShipmentService.verifyShipment(this.model.branch, this.model.bagId, this.model.route, this.checkInDate, this.model.window, this.model.fromTanker, this.model.toTanker).then(function (response) {
        _this22.verifyProvisionalCashShipment();
        _this22.removeOverlayToast();
        _this22.shipmentData = response;
        _this22.Shipmentresponse = response.shipment;
        if (response.window.fuzzyMatching) {
          _this22.fuzzyMatch = true;
          _this22.isEventFired = true;
          return _this22.Modal.checkedInShipmentSelectionModal({
            bagId: _this22.model.bagId,
            branchId: _this22.model.branch,
            windowId: _this22.model.window,
            routeId: _this22.model.route,
            date: _this22.checkInDate
          }, response.shipments, function (_ref3) {
            var modal = _ref3.modal,
                isCreated = _ref3.isCreated,
                selected = _ref3.selected,
                supervisorId = _ref3.supervisorId;


            var bagDefer = _this22.$q.defer();

            if (isCreated) {
              _this22.ShipmentService.create(selected).then(function () {
                bagDefer.resolve();
              }).catch(function (err) {
                bagDefer.reject(err);
              });
            } else {
              bagDefer.resolve();
            }

            bagDefer.promise.then(function () {
              _this22.model.bagId = selected.trackingId;
              _this22.isEventFired = false;
              _this22.autoSubmit();
              _this22.verifyRoute(_this22.model.route, _this22.checkInDate);
              _this22.disabledBag = false;
              if (modal) modal.close();
            }).catch(function (err) {
              _this22.disabledBag = false;
              _this22.isEventFired = false;
              if (err && err.data && err.data.message) {
                // this.model.bagId = '';
                _this22.Sound.PlayErrorBeep("#scanner_beep");
                return _this22.Modal.errorModal("error." + err.data.message);
              } else {
                console.log(err);
              }
            });
          }, function (_ref4) {
            var modal = _ref4.modal;

            if (modal) modal.close();
            _this22.isEventFired = false;
            _this22.disabledBag = false;
            _this22.focusElementById('bagId');
          });
        }
        return response;
      }).then(function (response) {
        return _this22.getDestinationList();
      }).then(function (response) {

        if (response.error) {

          _this22.lastStatusUpdate = new Date();
          _this22.isError = true;
          // this.model.bagId = '';
          return _this22.Modal.errorModal(response.error.message);
        }

        _this22.disabledBag = false;
        _this22.isCheckinSuccessfull = true;
        _this22.model.coinFlag = response.shipment.coinFlag;

        _this22.model.shipper = {
          name: response.shipment.fromLocationName,
          address: response.shipment.fromAddress,
          Value: response.shipment.fromLocationId,
          Key: response.shipment.fromLocationId + ' | ' + response.shipment.fromLocationName
        };

        _this22.trueOriginalShipperLocationId = response.shipment.fromLocationId;
        _this22.originalShipperLocationId = response.shipment.fromLocationId;
        _this22.originalShipperLocationObj = {
          name: response.shipment.fromLocationName,
          address: response.shipment.fromAddress,
          Value: response.shipment.fromLocationId,
          Key: response.shipment.fromLocationId + ' | ' + response.shipment.fromLocationName
        };
        _this22.selectedShipperLocation = {
          name: response.shipment.fromLocationName,
          address: response.shipment.fromAddress,
          Value: response.shipment.fromLocationId,
          Key: response.shipment.fromLocationId + ' | ' + response.shipment.fromLocationName
        };

        _this22.model.id = response.shipment.shipmentId;
        var dest = _this22.getAvailableDestination.length ? _this22.getSelectedDestination(_this22.getAvailableDestination) : _this22.Shipmentresponse;
        _this22.model.destination = _this22.newValues.destination = Array.isArray(dest) ? dest.length ? dest[0] : null : dest;
        _this22.model.shiptype = _this22.newValues.shiptype = response.shipment.shiptypeId;
        _this22.model.amount = _this22.newValues.amount = response.shipment.amount;

        setTimeout(function () {
          if (_this22.model.amount !== null && _this22.model.amount <= 1 && _this22.model.amount !== '') {
            _this22.Sound.PlayErrorBeep("#scanner_beep");
          }
        }, 500);

        _this22.model.quantity = _this22.newValues.quantity = response.shipment.qty || 1;
        _this22.newValues.shiptypeUnitAmount = response.shipment.shiptypeAmount;
        _this22.focusElementById('bagId');
      }).catch(function (err) {
        _this22.focusElementById('bagId');
        _this22.disabledBag = false;
        if (!_this22.fuzzyMatch && _this22.isEventFired) {
          _this22.isEventFired = false;
        }
        _this22.isCheckinSuccessfull = false;

        _this22.isError = true;

        if (_this22.fuzzyMatch == false) {
          _this22.lastStatusUpdate = new Date();
        }

        if (err && err.data && err.data.message) {
          _this22.Sound.PlayErrorBeep("#scanner_beep");
          _this22.bagCheckinError = _this22.$translate.instant('error.' + err.data.message) || null;
          _this22.lastScanned = _this22.model.bagId;
          _this22.model.bagId = "";
        }

        if (err && err.data && err.data.message === '90908') {

          // load shipment details for displaying purpose
          _this22.ShipmentService.get(_this22.lastScanned).then(function (shipmentData) {
            _this22.shipmentDetails = shipmentData;
            _this22.setAvailableDestinations(shipmentData.fromLocationId, shipmentData.toLocation, shipmentData.shiptypeId).then(function () {
              _this22.Sound.PlayErrorBeep("#scanner_beep");
              _this22.isCheckinSuccessfull = false;
              _this22.model.coinFlag = shipmentData.coinFlag;

              _this22.model.shipper = {
                name: shipmentData.fromLocation.name,
                address: shipmentData.fromLocation.address,
                Value: shipmentData.fromLocationId,
                Key: shipmentData.fromLocationId + ' | ' + shipmentData.fromLocation.name
              };

              _this22.trueOriginalShipperLocationId = shipmentData.fromLocationId;
              _this22.originalShipperLocationId = shipmentData.fromLocationId;
              _this22.originalShipperLocationObj = {
                name: shipmentData.fromLocation.name,
                address: shipmentData.fromLocation.address,
                Value: shipmentData.fromLocationId,
                Key: shipmentData.fromLocationId + ' | ' + shipmentData.fromLocation.name
              };
              _this22.selectedShipperLocation = {
                name: shipmentData.fromLocation.name,
                address: shipmentData.fromLocation.address,
                Value: shipmentData.fromLocationId,
                Key: shipmentData.fromLocationId + ' | ' + shipmentData.fromLocation.name
              };

              _this22.model.id = shipmentData.id;
              _this22.model.destination = _this22.newValues.destination = _this22.availableDestinations[0];
              _this22.model.shiptype = _this22.newValues.shiptype = shipmentData.shiptypeId;
              _this22.model.amount = _this22.newValues.amount = shipmentData.amount;
              _this22.model.quantity = _this22.newValues.quantity = shipmentData.qty || 1;
              _this22.newValues.shiptypeUnitAmount = shipmentData.shiptypeAmount;
            }).then(function () {
              _this22.Modal.itemNotDelivered(_this22.lastScanned, _this22.shipmentDetails, _this22.setupData.notDeliveredResolution, function (_ref5) {
                var $scope = _ref5.$scope,
                    modal = _ref5.modal;

                $scope.model.loading = true;
                var promise = _promise2.default.resolve();
                promise = promise.then(function () {
                  // !this.shipmentDetails.shiptype.coinFlag || !this.shipmentDetails.orderNo
                  if (_this22.setupData.notDeliveredResolution) {
                    if ($scope.model.isReRoute) {
                      // re route shipment
                      return _this22.ShipmentService.shipmentReRoute(_this22.model.branch, _this22.lastScanned, _this22.model.route, $scope.model.routeId, //destRouteId, 
                      $scope.model.date ? moment($scope.model.date).utc(true).format('YYYY-MM-DD') : '', $scope.model.supervisorId, $scope.model.selectedReason, $scope.model.deliveryResolution, $scope.model.note, $scope.model.updatedTrackingId, $scope.model.originalTrackingId, $scope.model.amount, $scope.model.qty, $scope.model.toLocationListObj.destinationId.Value, $scope.model.fromLocationListObj.fromLocationId.Value, $scope.model.shipTypeObj.shiptypeId.Value);
                    } else {
                      // hold Shipment Not Delivered
                      return _this22.ShipmentService.holdShipmentNotDelivered(_this22.model.branch, _this22.lastScanned, _this22.model.route, _this22.checkInDate, $scope.model.supervisorId, $scope.model.selectedReason, $scope.model.deliveryResolution, $scope.model.note, _this22.setupData.notDeliveredResolution, 'Hold', $scope.model.updatedTrackingId, $scope.model.originalTrackingId, $scope.model.amount, $scope.model.qty, $scope.model.toLocationListObj.destinationId.Value, $scope.model.fromLocationListObj.fromLocationId.Value, $scope.model.shipTypeObj.shiptypeId.Value);
                    }
                  } else {
                    // only hold
                    return _this22.ShipmentService.putShipmentOnHold(_this22.model.branch, _this22.lastScanned, _this22.model.route, _this22.checkInDate, $scope.model.supervisorId, $scope.model.selectedReason, 'Hold', $scope.model.updatedTrackingId, $scope.model.originalTrackingId, $scope.model.amount, $scope.model.qty, $scope.model.toLocationListObj.destinationId.Value, $scope.model.fromLocationListObj.fromLocationId.Value, $scope.model.shipTypeObj.shiptypeId.Value);
                  }
                }).then(function () {
                  _this22.isError = false;
                  modal.close();
                  _this22.Sound.playSuccessBeep("#success_beep");
                  _this22.bagCheckinMessage = _this22.setupData.notDeliveredResolution && $scope.model.isReRoute ? _this22.$translate.instant('checkin.reRoute') : _this22.$translate.instant('checkin.putOnHold');
                  return _this22.verifyRoute(_this22.model.route, _this22.checkInDate);
                }).catch(function (err) {
                  _this22.lastStatusUpdate = new Date();
                  _this22.isError = true;
                  if (modal) modal.close();
                  // this.model.bagId = '';
                  _this22.Sound.PlayErrorBeep("#scanner_beep");
                  if (err && err.data && err.data.message) {
                    // this.bagCheckinError = this.$translate.instant('error.' + err.data.message) || null;
                    return _this22.Modal.errorModal('error.' + err.data.message);
                  }
                }).finally(function () {
                  _this22.clearScan();
                  $scope.model.loading = false;
                  if (modal) modal.close();
                });
              }, function (_ref6) {
                var modal = _ref6.modal;

                if (modal) modal.close();
              });
            }).catch(function (err) {
              _this22.Sound.PlayErrorBeep("#scanner_beep");
              // this.model.bagId = '';
              console.log(err);
            });
          }).catch(function (err) {
            // this.model.bagId = '';
            _this22.Sound.PlayErrorBeep("#scanner_beep");
            console.log(err);
          });
        }
        if (err && err.data && err.data.message === '90905') {
          //item not found
          _this22.wasItemFound = false;
          _this22.Sound.PlayErrorBeep("#scanner_beep");
          _this22.isEventFired = true;
          // this.isError = false;
          _this22.forceAddBag();
        }
        if (err && err.data && err.data.message === '90922') {
          setTimeout(function () {
            _this22.isDisableRefreshButton = true;
            _this22.Modal.bagRemoveConfirmation({ bagId: _this22.lastScanned, cancelSupervisorChallenge: _this22.setupData.cancelSupervisorChallenge }, function (_ref7) {
              var modal = _ref7.modal,
                  $scope = _ref7.$scope;

              if ($scope.isSupervisorConfirmed) {
                _this22.clearScan(true);
                _this22.clearItemScan();
                _this22.isDisableRefreshButton = false;
                _this22.routeVerifyData.route = _this22.routeVerifyData.route.filter(function (t) {
                  return t.trackingId !== _this22.lastScanned;
                });
                _this22.routeVerifyData.errorCount = 0;
                _this22.remainingCheckinItemCount = 0;
                _this22.remainingToCheckin = [];

                if (_this22.routeVerifyData.route) {
                  _this22.routeVerifyData.route.forEach(function (record) {

                    switch (record.message) {
                      case 'E_PICKUP_NOT_CHECKED_IN':
                      case 'E_DELIVERY_NOT_DELIVERED':
                        if (!(record.isRequiredPickup === 1 && !record.orderNo && record.verified === 0)) {
                          _this22.remainingCheckinItemCount++;
                          _this22.remainingToCheckin.push(record);
                        }
                        break;
                    }

                    if (record.isError || record.message === 'E_LOCATION_NOT_ON_HOLD') {
                      _this22.routeVerifyData.errorCount++;
                    }
                  });
                  _this22.routeVerifyData.errorCount = _this22.routeVerifyData.errorCount + _this22.logisticItemObj.remainingItemsCount;
                }

                modal.close();
              }
            }, function (_ref8) {
              var modal = _ref8.modal;

              if (modal) modal.close();
            });
          }, 500);
        }
      });
    }
  }, {
    key: 'getDestinationList',
    value: function getDestinationList(shiptype, field) {
      var _this23 = this;

      var defer = this.$q.defer();
      this.gettingDestination = true;
      var shiptypeId = shiptype ? shiptype : this.shipmentData.shipment.shiptypeId;
      this.ShipmentService.getDestinationLocations(this.shipmentData.shipment.fromLocationId, shiptypeId, false).then(function (responses) {
        _this23.getAvailableDestination = responses;

        if (_this23.shipmentData.shipment && _this23.shipmentData.shipment.toLocationId) {
          _this23.focusElementById('destinationSelection');
          var rawSelectedDest = _this23.getAvailableDestination.length ? _this23.getSelectedDestination(_this23.getAvailableDestination) : null;
          var selectedDest = Array.isArray(rawSelectedDest) ? rawSelectedDest.length ? rawSelectedDest[0] : null : rawSelectedDest;
          return _this23.setAvailableDestinations(_this23.getAvailableDestination.length ? _this23.shipmentData.shipment.fromLocationId : _this23.shipmentData.shipment.toLocationId, {
            id: selectedDest ? selectedDest.id : _this23.Shipmentresponse.toLocationId,
            name: selectedDest ? selectedDest.name : _this23.Shipmentresponse.toLocationName,
            address: selectedDest ? selectedDest.address : _this23.Shipmentresponse.toAddress
          }, shiptypeId).then(function () {
            _this23.gettingDestination = false;
            defer.resolve(_this23.shipmentData);
          }).catch(function (err) {
            console.error(err);
          });
        } else {
          defer.resolve(_this23.shipmentData);
        }
      });
      return defer.promise;
    }
  }, {
    key: 'changeShipType',
    value: function changeShipType(shiptype, field) {
      var _this24 = this;

      this.getDestinationList(shiptype, field).then(function (response) {
        _this24.setDestinations(response);
      }).then(function () {
        return _this24.shipmentAmountChanged(field);
      });
    }
  }, {
    key: 'resetShipType',
    value: function resetShipType() {
      var _this25 = this;

      this.getDestinationList().then(function (response) {
        _this25.setDestinations(response);
      }).then(function () {
        _this25.resetChanges();
      }).then(function () {
        var selectedShiptype = _this25.shiptypes.find(function (shiptype) {
          return shiptype.id === _this25.newValues.shiptype;
        });
        _this25.newValues.shiptypeUnitAmount = selectedShiptype.amount;
        _this25.model.coinFlag = selectedShiptype.coinFlag;
      });
    }
  }, {
    key: 'setDestinations',
    value: function setDestinations(response) {
      if (response.error) {

        this.lastStatusUpdate = new Date();
        this.isError = true;
        return this.Modal.errorModal(response.error.message);
      }
      this.disabledBag = false;
      this.isCheckinSuccessfull = true;

      this.model.shipper = {
        name: response.shipment.fromLocationName,
        address: response.shipment.fromAddress
      };

      this.model.id = response.shipment.shipmentId;
      var dest = this.getAvailableDestination.length ? this.getSelectedDestination(this.getAvailableDestination) : this.Shipmentresponse;
      this.model.destination = this.newValues.destination = Array.isArray(dest) ? dest.length ? dest[0] : null : dest;
    }
  }, {
    key: 'override',
    value: function override() {
      var _this26 = this;

      this.Modal.confirmSupervisor('checkin-override', null, function (_ref9) {
        var modal = _ref9.modal,
            supId = _ref9.supId;

        if (supId) {
          return _this26.loadWindows().then(function () {
            _this26.overridenBySupervisor = true;
          }).catch(function (err) {
            console.log(err);
          });
        }
        modal.close();
      }, function (_ref10) {
        var modal = _ref10.modal;

        modal.close();
      });
    }
  }, {
    key: 'saveOverride',
    value: function saveOverride() {
      this.overridenBySupervisor = false;
    }
  }, {
    key: 'closeRoute',
    value: function closeRoute() {
      var _this27 = this;

      if (this.isEventFired) return;
      this.isEventFired = true;
      this.RouteService.closeRoute(this.model.branch, this.model.route, this.checkInDate, this.model.window).then(function (data) {
        // console.log(data);
        _this27.isEventFired = false;
        if (!data.isError) {
          _this27.Sound.playSuccessBeep("#success_beep");
          _this27.closedRoute = _this27.model.route;
          _this27.lastStatusUpdate = new Date();
          _this27.resetModel();
          _this27.resetChanges();
          _this27.focusElementById('route-scan-id');
        } else {
          _this27.Modal.errorModal(data.messageCode);
        }

        return;
      }).catch(function (err) {
        _this27.isEventFired = false;
        if (err && err.data && err.data.message) {
          _this27.Sound.PlayErrorBeep("#scanner_beep");
          _this27.Modal.errorModal(err.data.message);
        } else {
          console.error(err);
        }
      });
    }
  }, {
    key: 'forceClose',
    value: function forceClose() {
      var _this28 = this;

      if (this.isEventFired) return;
      this.isEventFired = true;

      var holdShipments = [],
          deliveredShipments = [],
          holdLocations = [],
          missingPickups = [];

      this.Modal.checkinForceCloseRoute(this.model.route, this.routeVerifyData, this.logisticItemObj.remainingItemList, function (_ref11) {
        var $scope = _ref11.$scope,
            action = _ref11.action,
            modal = _ref11.modal,
            scanValue = _ref11.scanValue;

        if (action === 'scan') {
          _this28.isEventFired = false;
          _this28.model.bagId = "";
          modal.close();
          _this28.focusElementById('bagId');
          return;
        }

        $scope.model.routeVerifyResults.filter(function (record) {
          return record.isOverridable && record.selectedReason && (record.isError || ['E_LOCATION_NOT_ON_HOLD', 'MISSING_PICKUP'].includes(record.message));
        }).map(function (record) {
          switch (record.message) {
            case 'E_PICKUP_NOT_CHECKED_IN':
            case 'E_DELIVERY_NOT_DELIVERED':
              {
                if (record.selectedReason === 'Delivered') {
                  deliveredShipments.push({
                    trackingId: record.trackingId,
                    fromLocationId: record.fromLocationId,
                    toLocationId: record.toLocationId,
                    pickupDate: record.pickupDate,
                    branchId: _this28.model.branch,
                    routeId: _this28.model.route,
                    vaultDate: _this28.checkInDate
                  });
                } else if (record.selectedReason !== 'Delivered') {
                  holdShipments.push({
                    branch: _this28.model.branch,
                    route: _this28.model.route,
                    checkInDate: _this28.checkInDate,
                    supervisorId: $scope.model.supervisorId,
                    comment: ' ',
                    routeVerifyResults: [{
                      isError: record.isError,
                      isOverridable: record.isOverridable,
                      selectedReason: record.selectedReason,
                      trackingId: record.trackingId
                    }]
                  });
                }
                break;
              }

            case 'E_LOCATION_NOT_ON_HOLD':
              {
                if (_this28.locationOnHold) {
                  holdLocations.push({
                    locationId: record.locationId,
                    route: _this28.model.route,
                    checkInDate: _this28.checkInDate,
                    selectedReason: record.selectedReason,
                    comment: ' ',
                    supervisorId: $scope.model.supervisorId
                  });
                }
                break;
              }

            case 'MISSING_PICKUP':
              {
                missingPickups.push({
                  locationId: record.locationId,
                  routeId: _this28.model.route,
                  vaultDate: _this28.checkInDate,
                  selectedReason: record.selectedReason,
                  comments: record.noPickupComment,
                  supervisorId: $scope.model.supervisorId,
                  messengerId: _this28.model.messengerId,
                  shiptypeId: record.shiptypeId
                });
                break;
              }
          }
        });

        _this28.$q.all([_this28.ShipmentService.bulkHoldShipment(holdShipments), _this28.ShipmentService.bulkUpdateDeliveredShipment(deliveredShipments, _this28.model.branch), _this28.LocationService.bulkHoldLocations(holdLocations, _this28.model.branch), _this28.logisticItemBulkHold(), _this28.ShipmentService.bulkUpdateNoPickupStop(missingPickups, _this28.model.branch)]).then(function () {
          return _this28.verifyRoute(_this28.model.route, _this28.checkInDate);
        }).then(function () {
          var hasBlockingRouteIssues = (_this28.routeVerifyData.route || []).some(function (record) {
            if (record.message === 'E_LOCATION_NOT_ON_HOLD' && _this28.locationOnHold === false) {
              return false;
            }

            return record.isError || record.message === 'MISSING_PICKUP';
          });

          var hasBlockingIssues = hasBlockingRouteIssues || _this28.logisticItemObj.remainingItemsCount > 0;

          if (!hasBlockingIssues) {
            return _this28.RouteService.closeRoute(_this28.model.branch, _this28.model.route, _this28.checkInDate, _this28.model.window);
          } else {
            return null;
          }
        }).then(function (data) {
          if (data && !data.isError) {
            _this28.closedRoute = _this28.model.route;
            _this28.lastStatusUpdate = new Date();
            _this28.resetModel();
            _this28.focusElementById('route-scan-id');
            _this28.Sound.playSuccessBeep("#success_beep");
          }
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this28.Sound.PlayErrorBeep("#scanner_beep");
            _this28.Modal.errorModal('error.' + err.data.message);
          } else {
            console.error(err.toString());
          }
        }).finally(function () {
          if (modal) modal.close();
          _this28.isEventFired = false;
          $scope.loading = false;
        });
      }, function (_ref12) {
        var modal = _ref12.modal;

        if (modal) modal.close();
        _this28.isEventFired = false;
      }, this.model.routeObj.name, this.checkInDate);
    }
  }, {
    key: 'forceAddBag',
    value: function forceAddBag() {
      var _this29 = this;

      var addBagDefer = this.$q.defer();
      var user = this.User.getUser();
      var isSupervisor = user && user.supervisor;
      var supervisorScanRequired = isSupervisor ? this.setupData.supervisorScan : true;

      return this.Modal.checkedInForceAddBag({
        bagId: this.lastScanned,
        branchId: this.model.branch,
        windowId: this.model.window,
        routeId: this.model.route,
        date: this.checkInDate,
        supervisorScan: supervisorScanRequired,
        branchVaultDate: this.setupData.currentVaultDate,
        cancelSupervisorChallenge: this.setupData.cancelSupervisorChallenge
      }, function (_ref13) {
        var modal = _ref13.modal,
            $scope = _ref13.$scope;

        $scope.bag.routeId = _this29.model.route;
        $scope.bag.pickupDate = $scope.bag.pickupDate;
        $scope.bag.pickupTime = $scope.bag.pickupTime;
        $scope.bag.convertPickupDate = true;
        $scope.bag.branchTimeZone = _this29.setupData.timezone;
        _this29.ShipmentService.create($scope.bag).then(function (res) {
          _this29.model.bagId = res.trackingId;
          _this29.isCheckinSuccessfull = true;
          _this29.isEventFired = false;
          _this29.isError = '';
          modal.close();
          // this.autoSubmit()
          _this29.wasItemFound = true;
          _this29.isManuallyAddedShipment = true;
          _this29.bagCheckOutError = '';
          _this29.bagCheckOutMessage = '';
          _this29.lastStatusUpdate = '';
          // this.verifyRoute(this.model.route, this.checkInDate)
          addBagDefer.resolve($scope.bag);
        }).catch(function (err) {
          if (err && err.data && err.data.errors) {
            _this29.Sound.PlayErrorBeep("#scanner_beep");
            _this29.Modal.errorModal("error." + err.data.errors[0].path);
          } else if (err && err.data && err.data.message) {
            _this29.Sound.PlayErrorBeep("#scanner_beep");
            _this29.Modal.errorModal(err.data.message);
          } else {
            console.log(err);
          }
        });
        addBagDefer.promise.then(function (data) {
          return _this29.createTransaction(data);
        });
      }, function (_ref14) {
        var modal = _ref14.modal;

        _this29.focusElementById('bagId');
        _this29.isEventFired = false;
        if (modal) modal.close();
      });
    }
  }, {
    key: 'resetManifestForm',
    value: function resetManifestForm() {
      this.manifest = {
        showManifestModal: false,
        totalBagCount: null,
        manifestID: null,
        isSubmitting: false,
        isCompleted: false
      };
    }

    // create transaction record

  }, {
    key: 'createTransaction',
    value: function createTransaction(shipmentData) {
      var _this30 = this;

      var transData = {
        tranType: 'PICKUP',
        trackingId: shipmentData.trackingId,
        transactionDate: moment.utc(),
        sequence: 0,
        amount: shipmentData.amount,
        qty: shipmentData.qty,
        bagSeal: null,
        comments: 'Manually Added to Checkin',
        sentOnRoute: 0,
        sentEndOfDay: 0,
        routeId: shipmentData.routeId,
        toLocationId: shipmentData.toLocationId,
        fromLocationId: shipmentData.fromLocationId,
        performedById: this.loggedInUser,
        shiptypeId: shipmentData.shiptypeId,
        branchId: this.model.branch
      };
      this.TransactionService.create(transData).then(function () {
        return _this30.verifyBag();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this30.Sound.PlayErrorBeep("#scanner_beep");
          _this30.Modal.errorModal(err.data.message);
        }
      });
    }
  }, {
    key: 'verifyBag',
    value: function verifyBag() {
      var _this31 = this;

      this.ShipmentService.verifyShipment(this.model.branch, this.model.bagId, this.model.route, this.checkInDate, this.model.window, this.model.fromTanker, this.model.toTanker).then(function () {
        _this31.isError = false;
        return _this31.autoSubmit();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this31.lastStatusUpdate = new Date();
          _this31.isError = true;
          _this31.Sound.PlayErrorBeep("#scanner_beep");
          _this31.bagCheckinError = _this31.$translate.instant('error.' + err.data.message) || null;
          _this31.lastScanned = _this31.model.bagId;
          _this31.clearScan();
        }
      });
    }
  }, {
    key: 'clearScan',
    value: function clearScan(clearError) {
      var _this32 = this;

      var fieldsToClear = ['bagId', 'destination', 'availableDestinations', 'amount', 'shiptype', 'quantity', 'shipper'];
      fieldsToClear.forEach(function (field) {
        delete _this32.model[field];
        delete _this32.newValues[field];
      });
      this.resetManifestForm();
      this.bagIdCopy = '';
      this.model.bagId = '';
      this.isAmountChanged = this.isDestinationChanged = this.isShipperChanged = false;

      this.isEditingShipper = false;
      this.selectedShipperLocation = null;
      this.originalShipperLocationId = null;
      this.trueOriginalShipperLocationId = null;
      this.originalShipperLocationObj = null;

      if (clearError) {
        this.lastStatusUpdate = undefined;
        this.bagCheckinError = '';
        this.bagCheckinMessage = '';
        this.shipmentChangeMessage = '';
        this.isError = false;
      }
      this.bagScanLimitExceed = false;
      this.checkOnlyOnce = false;
      this.isEventFired = false;
      this.setFocus();
    }
  }, {
    key: 'shipmentAmountChanged',
    value: function shipmentAmountChanged(field) {
      var _this33 = this;

      if (field === 'quantity') {
        if (this.newValues.quantity) {
          this.newValues.amount = this.newValues.quantity * this.newValues.shiptypeUnitAmount;
        }
      }
      if (field === 'shiptype') {
        var selectedShiptype = this.shiptypes.find(function (shiptype) {
          return shiptype.id === _this33.newValues.shiptype;
        });

        this.newValues.shiptypeUnitAmount = selectedShiptype.amount;
        this.model.coinFlag = selectedShiptype.coinFlag;

        if (this.model.coinFlag) {
          if (this.newValues.quantity) {
            this.newValues.amount = this.newValues.quantity * this.newValues.shiptypeUnitAmount;
          }
        } else {
          this.newValues.amount = this.model.amount;
          this.newValues.quantity = 1;
        }
      }

      var keys = ['destination', 'shiptype', 'amount', 'quantity'];
      this.isAmountChanged = keys.some(function (key) {

        if (key === 'amount') {
          setTimeout(function () {
            if (_this33.newValues.amount !== null && _this33.newValues.amount <= 1 && _this33.newValues.amount !== '') {
              _this33.Sound.PlayErrorBeep("#scanner_beep");
            }
          }, 500);
        }

        return _this33.newValues[key] !== _this33.model[key];
      });
    }
  }, {
    key: 'saveChanges',
    value: function saveChanges() {
      var _this34 = this;

      var proceed = function proceed(supId, modal) {
        var destinationChangePromise = _this34.$q.when().promise;
        var amountChangePromise = _this34.$q.when().promise;
        var date = _this34.checkInDate;
        _this34.shipmentChangeMessage = '';
        _this34.bagCheckinMessage = '';
        _this34.isError = false;
        delete _this34.lastStatusUpdate;

        if (_this34.isDestinationChanged) {
          destinationChangePromise = _this34.ShipmentService.changeShipmentDestination(_this34.model.bagId, _this34.model.route, date, _this34.newValues.destination.id).then(function (data) {
            _this34.model.destination = _this34.newValues.destination;
            _this34.isDestinationChanged = false;
            return;
          });
        }

        if (_this34.isAmountChanged) {
          amountChangePromise = _this34.ShipmentService.changeShipmentAmount(_this34.model.id, _this34.model.bagId, _this34.model.route, date, _this34.newValues.shiptype, _this34.newValues.quantity, _this34.newValues.amount, _this34.branchId, _this34.model.amount, supId).then(function (data) {
            _this34.model.quantity = _this34.newValues.quantity;
            _this34.model.amount = _this34.newValues.amount;
            _this34.isAmountChanged = false;
            return;
          });
        }

        _this34.$q.all([destinationChangePromise, amountChangePromise]).then(function () {
          if (_this34.isShipperChanged) {
            _this34.originalShipperLocationId = _this34.model.shipper.Value;
            _this34.originalShipperLocationObj = {
              name: _this34.model.shipper.name,
              address: _this34.model.shipper.address,
              Value: _this34.model.shipper.Value,
              Key: _this34.model.shipper.Key
            };
            _this34.selectedShipperLocation = _this34.model.shipper;
            _this34.isShipperChanged = false;
          }
          _this34.isError = false;
          _this34.lastStatusUpdate = new Date();
          _this34.shipmentChangeMessage = _this34.$translate.instant('checkin.successfullySaved');
          // return this.autoSubmit()
          // if (this.checkAndCall == true) {
          // return this.bagSubmitted()
          // }
        }).then(function () {
          return _this34.verifyShipments();
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this34.model.bagId = "";
            _this34.Sound.PlayErrorBeep("#scanner_beep");
            _this34.Modal.errorModal('error.' + err.data.message);
          }
        }).finally(function () {
          // this.Sound.PlayErrorBeep("#scanner_beep");
          if (modal) {
            modal.close();
          }
        });
      };

      var user = this.User.getUser();
      var isSupervisor = user && user.supervisor;
      var supervisorScanRequired = isSupervisor ? this.setupData.supervisorScan : true;

      if (supervisorScanRequired) {
        this.Modal.confirmSupervisor('save-shipment-changes', { trackingId: this.model.bagId }, function (_ref15) {
          var modal = _ref15.modal,
              supId = _ref15.supId;

          proceed(supId, modal);
        }, function (_ref16) {
          var modal = _ref16.modal;

          modal.close();
        });
      } else {
        proceed(this.loggedInUser, null);
      }
    }
  }, {
    key: 'verifyShipments',
    value: function verifyShipments() {
      var _this35 = this;

      this.ShipmentService.verifyShipment(this.model.branch, this.model.bagId, this.model.route, this.checkInDate, this.model.window, this.model.fromTanker, this.model.toTanker).then(function () {
        return _this35.bagSubmitted();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          delete _this35.shipmentChangeMessage;
          _this35.isError = true;
          _this35.Sound.PlayErrorBeep("#scanner_beep");
          _this35.bagCheckinError = _this35.$translate.instant('error.' + err.data.message) || null;
          _this35.lastScanned = _this35.model.bagId;
          // this.model.bagId = "";
          _this35.verifyRoute(_this35.model.route, _this35.checkInDate);
          _this35.clearScan();
        }
      });
    }
  }, {
    key: 'resetChanges',
    value: function resetChanges() {
      this.newValues = {
        destination: this.model.destination,
        shiptype: this.model.shiptype,
        amount: this.model.amount,
        quantity: this.model.quantity
      };

      if (this.isShipperChanged) {
        this.model.shipper = this.originalShipperLocationObj;
        this.selectedShipperLocation = this.originalShipperLocationObj;
        this.isShipperChanged = false;
      }

      this.isDestinationChanged = false;
      this.isAmountChanged = false;
    }
  }, {
    key: 'resetModel',
    value: function resetModel() {
      this.hasMessenger = false;
      this.hasRoute = false;
      this.hasWindow = false;
      this.hasFromTanker = false;
      this.hasToTanker = false;
      this.overridenBySupervisor = false;
      this.showCheckin = false;

      this.model = {
        route: undefined,
        branch: this.User.getUser().branchId,
        customer: undefined,
        window: undefined,
        fromTanker: undefined,
        toTanker: undefined,
        shipper: {},
        loadTruck: null
      };
      this.availableDestinations = [];
      this.availableDestination = [];
      this.isError = false;
      this.bagCheckinError = '';
      this.bagCheckinMessage = '';
      this.shipmentChangeMessage = '';

      this.resetNewValues();
    }
  }, {
    key: 'resetNewValues',
    value: function resetNewValues() {
      this.newValues = {
        destination: {},
        shiptype: '',
        amount: '',
        quantity: ''
      };

      //not a changable value but reset it as all the other values that are displayed are also cleared
      this.model.shipper = {};

      this.isDestinationChanged = false;
      this.isAmountChanged = false;
    }
  }, {
    key: 'printManifest',
    value: function printManifest() {
      // const new_path = `${this.$location.protocol()}://${this.$location.host()}:${this.$location.port()}/print-checkin/${this.branchId}/${this.closedRoute}/${this.vaultDate}`ul   // this.$window.open(new_path, '_blank')

      var url = this.$state.href('printCheckin', {
        branchId: this.branchId,
        scannedRouteId: this.closedRoute,
        date: this.vaultDate
      });

      window.w = window.open(url, '_blank');
      window.w.printData = {
        itemList: this.logisticItemObj.checkedInItemList
      };
    }
  }, {
    key: 'shipmentInfo',
    value: function shipmentInfo(isShpCheckedIn) {
      this.Modal.routeCheckinInfo(isShpCheckedIn, this.model.route, this.vaultDate, this.model.branch, this.remainingToCheckin, function (_ref17) {
        var modal = _ref17.modal;

        modal.close();
      }, function (_ref18) {
        var modal = _ref18.modal;

        modal.close();
      });
    }
  }, {
    key: 'scanPrefix',
    value: function scanPrefix(prefixType, field) {
      if (this.model[field] && this.prefixes && this.prefixes[prefixType]) {
        if (this.model[field].startsWith(this.prefixes[prefixType][0])) {
          this.model[field] = this.model[field].slice(this.prefixes[prefixType][0].length).trim();
        }
      }
    }
  }, {
    key: 'refreshData',
    value: function refreshData() {
      var _this36 = this;

      this.model.refreshItems = true;
      this.verifyRoute(this.model.route, this.checkInDate).then(function () {
        _this36.clearScan(true);
        _this36.clearItemScan();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this36.Modal.errorModal('error.' + err.data.message);
        }
      }).finally(function () {
        _this36.model.refreshItems = false;
      });
    }
  }, {
    key: 'getSelectedDestination',
    value: function getSelectedDestination(destinations) {
      var _this37 = this;

      if (!destinations || !destinations.length || _.isEmpty(this.Shipmentresponse)) return;
      var toLoc = destinations.filter(function (d) {
        return d.id == _this37.Shipmentresponse.toLocationId;
      });

      if (toLoc && toLoc.length) return _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)(toLoc)));
      return destinations;
    }
  }, {
    key: 'tabSelection',
    value: function tabSelection(selectedValue) {
      this.model.currentItemStat = selectedValue;
    }
  }, {
    key: 'checkInTabSelection',
    value: function checkInTabSelection(selectedValue) {
      this.currentCheckInTab = selectedValue;
      if (this.currentCheckInTab === this.checkInScanTab.items) {
        this.clearItemScan();
        this.model.currentItemStat = this.itemStats.items;
      } else if (this.currentCheckInTab === this.checkInScanTab.shipment) {
        this.clearScan();
        this.model.currentItemStat = this.itemStats.cash;
      }
    }
  }, {
    key: 'remainingLogisticItemList',
    value: function remainingLogisticItemList() {
      this.Modal.logisticItemList(this.model.route, this.logisticItemObj.remainingItemList, 'remaining', function (_ref19) {
        var modal = _ref19.modal;

        modal.close();
      }, function (_ref20) {
        var modal = _ref20.modal;

        modal.close();
      });
    }
  }, {
    key: 'logisticItemCheckedInList',
    value: function logisticItemCheckedInList() {
      this.Modal.logisticItemList(this.model.route, this.logisticItemObj.checkedInItemList, 'checkedIn', function (_ref21) {
        var modal = _ref21.modal;

        modal.close();
      }, function (_ref22) {
        var modal = _ref22.modal;

        modal.close();
      });
    }
  }, {
    key: 'clearItemScan',
    value: function clearItemScan() {
      this.logisticItemObj.barcode = null;
      this.logisticItemObj.itemScanLimitExceed = false;
      this.logisticItemObj.allowItemScanOnce = false;
      this.logisticItemObj.disableItemScan = false;
      this.logisticItemObj.defaultLength = 0;
      this.logisticItemObj.lastUpdated = null;
      this.logisticItemObj.lastScannedItem = null;
      this.logisticItemObj.isError = false;
      this.logisticItemObj.itemCheckInError = null;
      this.logisticItemObj.itemCheckInMessage = null;
      this.logisticItemObj.itemScanError = null;
      this.logisticItemObj.itemDetails = {};
      this.logisticItemObj.wasItemFound = false;
      this.focusElementById('barcode');
    }
  }, {
    key: 'itemScanKeyPress',
    value: function itemScanKeyPress($event) {
      var ESC_KEY_CODE = 27;
      var BACKSPACE_KEY_CODE = 8;
      if ($event.keyCode === ESC_KEY_CODE) return this.clearItemScan();
      if ($event.keyCode === BACKSPACE_KEY_CODE && this.logisticItemObj.barcode && this.logisticItemObj.barcode.length <= 1) return this.clearItemScan();
    }
  }, {
    key: 'logisticItemScan',
    value: function logisticItemScan() {
      var _this38 = this;

      this.logisticItemObj.barcode = this.scanSuffix(this.logisticItemObj.barcode);

      if (!this.logisticItemObj.barcode) return;

      this.logisticItemObj.itemScanLimitExceed = false;
      this.logisticItemObj.isError = false;
      this.logisticItemObj.itemCheckInMessage = null;

      if (this.bagScanLimit && this.bagScanLimit > 0) {
        if (this.logisticItemObj.barcode.length > this.bagScanLimit && (!this.logisticItemObj.allowItemScanOnce || this.logisticItemObj.barcode.length !== this.logisticItemObj.defaultLength)) {
          delete this.logisticItemObj.itemCheckInError;
          delete this.logisticItemObj.itemCheckInMessage;
          this.logisticItemObj.itemScanLimitExceed = true;
          this.logisticItemObj.allowItemScanOnce = true;
          this.logisticItemObj.lastScannedItem = this.logisticItemObj.barcode;
          this.logisticItemObj.defaultLength = this.logisticItemObj.barcode.length;
          this.logisticItemObj.barcode = "";
          this.logisticItemObj.isError = true;
          this.logisticItemObj.lastUpdated = new Date();
          return this.logisticItemObj.itemScanError = this.$translate.instant('common.bagScanError');
        } else {
          this.logisticItemObj.defaultLength = this.logisticItemObj.barcode.length > this.bagScanLimit ? this.logisticItemObj.barcode.length : this.bagScanLimit;
        }
      }

      this.logisticItemObj.itemDetails = this.logisticItemObj.remainingItemList.find(function (item) {
        return item.barcode.toUpperCase() == _this38.logisticItemObj.barcode;
      });
      if (this.logisticItemObj.itemDetails) this.logisticItemObj.wasItemFound = true;else if (_.isEmpty(this.logisticItemObj.itemDetails)) this.logisticItemObj.wasItemFound = false;

      delete this.logisticItemObj.lastUpdated;
      if (!this.autoSubmitItem) {
        if (this.logisticItemObj.barcodeCopy === this.logisticItemObj.barcode && this.logisticItemObj.wasItemFound) {
          this.logisticItemObj.isItemCheckedIn = false;
          return this.logisticItemSubmitted();
        } else if (!this.logisticItemObj.wasItemFound) {
          this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
          return this.logisticItemSubmitted();
        } else {
          this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
        }
      } else if (this.autoSubmitItem) {
        this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
        return _promise2.default.resolve();
      }
    }
  }, {
    key: 'logisticItemSubmitted',
    value: function logisticItemSubmitted() {
      var _this39 = this;

      if (!this.logisticItemObj.barcode) return;
      var successMessage = this.$translate.instant('item.checked_in');

      return this.ItemService.logisticItemCheckIn(this.branchId, this.logisticItemObj.barcode, this.user.id, this.logisticItemObj.itemDetails ? this.logisticItemObj.itemDetails.keepRouteAssignment : 0).then(function () {
        _this39.logisticItemObj.itemCheckInMessage = successMessage;1;
        _this39.logisticItemObj.isItemCheckedIn = true;
        _this39.logisticItemObj.itemDetails = {};
        _this39.verifyRoute(_this39.model.route, _this39.checkInDate);
      }).catch(function (err) {
        _this39.logisticItemObj.isItemCheckedIn = false;
        _this39.logisticItemObj.isError = true;

        if (err && err.data && err.data.message) {
          _this39.Sound.PlayErrorBeep("#scanner_beep");
          _this39.logisticItemObj.itemCheckInError = _this39.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        } else {
          _this39.logisticItemObj.itemCheckInError = err.toString();
        }
      }).finally(function () {
        _this39.logisticItemObj.barcode = null;
        _this39.logisticItemObj.lastUpdated = new Date();
        _this39.logisticItemObj.lastScannedItem = _this39.logisticItemObj.barcodeCopy;
        _this39.logisticItemObj.barcodeCopy = null;
      });
    }
  }, {
    key: 'autoSubmitItems',
    value: function autoSubmitItems($event) {
      var _this40 = this;

      var promise = this.logisticItemScan($event);

      if (promise && typeof promise.then === "function") {
        promise.then(function () {
          setTimeout(function () {
            _this40.logisticItemSubmitted();
          }, 700);
        });
      }

      return promise;
    }
  }, {
    key: 'setFocus',
    value: function setFocus() {
      if (this.currentCheckInTab === this.checkInScanTab.items) {
        this.focusElementById('barcode');
      } else if (this.currentCheckInTab === this.checkInScanTab.shipment) {
        this.focusElementById('bagId');
      }
    }
  }, {
    key: 'logisticItemBulkHold',
    value: function logisticItemBulkHold() {
      var _this41 = this;

      return this.ItemService.logisticItemBulkHold(this.model.route, this.branchId, this.vaultDate, this.user.id, this.logisticItemObj.remainingItemList).then().catch(function (err) {
        if (err && err.data && err.data.message) {
          _this41.Modal.errorModal('error.' + err.data.message);
        }
      });
    }
  }, {
    key: 'getCheckinUserAssignedItems',
    value: function getCheckinUserAssignedItems() {
      var _this42 = this;

      this.ScanService.getCheckinUserAssignedItems(this.model.routeObj.routeId, this.model.branch, this.model.messengerId).then(function (res) {
        _this42.logisticItemObj.remainingItemList = res.data.remainingItemList || [];
        _this42.logisticItemObj.remainingItemsCount = res.data.remainingItemList.length || 0;
        _this42.logisticItemObj.checkedInItemList = _this42.routeVerifyData.checkedInItemList || [];
        _this42.logisticItemObj.checkedInItemsCount = res.data.checkedInItemList.length || 0;
        _this42.routeVerifyData.errorCount = 0;
        _this42.remainingCheckinItemCount = 0;
        _this42.remainingToCheckin = [];
        if (_this42.routeVerifyData.route) {
          _this42.routeVerifyData.route.forEach(function (record) {

            switch (record.message) {
              case 'E_PICKUP_NOT_CHECKED_IN':
              case 'E_DELIVERY_NOT_DELIVERED':
                if (!(record.isRequiredPickup === 1 && !record.orderNo && record.verified === 0)) {
                  _this42.remainingCheckinItemCount++;
                  _this42.remainingToCheckin.push(record);
                }
                break;
            }

            if (record.isError || record.message === 'E_LOCATION_NOT_ON_HOLD') {
              _this42.routeVerifyData.errorCount++;
            }
          });
          _this42.routeVerifyData.errorCount = _this42.routeVerifyData.errorCount + _this42.logisticItemObj.remainingItemsCount;
        }
      });
    }
  }]);
  return CheckInController;
}();

exports.default = CheckInController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkin = __webpack_require__(1836);

var _checkin2 = _interopRequireDefault(_checkin);

var _print = __webpack_require__(1839);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkinModule = angular.module('checkin', [_print2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/checkin');

  $stateProvider.state('checkin', {
    url: '/checkin',
    component: 'checkin',
    data: {
      requireLogin: true,
      requireACL: 'check_in.all'
    },
    parent: 'app'
  });
}]).component('checkin', _checkin2.default).name;

exports.default = checkinModule;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _print_checkin = __webpack_require__(1840);

var _print_checkin2 = _interopRequireDefault(_print_checkin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printCheckinModule = angular.module('printCheckin', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider.otherwise('/checkin');

	$stateProvider.state('printCheckin', {
		url: '/print-checkin/{branchId}/{scannedRouteId}/{date}',
		component: 'printCheckin',
		data: {
			requireLogin: true,
			requireACL: 'check_in.all'
		}
	});
}]).component('printCheckin', _print_checkin2.default).name;

exports.default = printCheckinModule;

// ?branch&route&date

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_checkin = __webpack_require__(2713);

var _print_checkin2 = _interopRequireDefault(_print_checkin);

var _print_checkin3 = __webpack_require__(1841);

var _print_checkin4 = _interopRequireDefault(_print_checkin3);

__webpack_require__(2994);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printCheckinComponent = {
  restrict: 'E',
  bindings: {},
  template: _print_checkin2.default,
  controller: _print_checkin4.default
};

exports.default = printCheckinComponent;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintCheckinController = function () {
    /*@ngInject*/
    PrintCheckinController.$inject = ["$state", "$stateParams", "User", "ShipmentService"];
    function PrintCheckinController($state, $stateParams, User, ShipmentService) {
        (0, _classCallCheck3.default)(this, PrintCheckinController);

        this.ShipmentService = ShipmentService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.User = User;
        this.isRouteAutoCheckin = false;
        this.model = {
            generateCheckinManifest: false,
            itemList: []
        };
    }

    (0, _createClass3.default)(PrintCheckinController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this = this;

            var branchId = this.$stateParams.branchId;
            var routeId = this.$stateParams.scannedRouteId;
            var vaultDate = this.$stateParams.date;

            this.model.generateCheckinManifest = true;
            this.ShipmentService.getCheckinManifestData(branchId, routeId, vaultDate).then(function (data) {
                _this.routeId = routeId;
                _this.isRouteAutoCheckin = data.routeAutoCheckIn;
                _this.deliveryDate = vaultDate;
                _this.shipmentReportData = data;
                _this.model.itemList = data.itemList;
                _this.userData = _this.User.getUser();
                _this.messengerDetails = data.messengerDetail;
                if (_this.isRouteAutoCheckin) {
                    _this.holdShipments = data.results.filter(function (ship) {
                        return ship.holdFlag === true;
                    });
                    _this.nonHoldShipments = data.results.filter(function (ship) {
                        return !ship.holdFlag;
                    });
                } else {
                    _this.holdShipments = [];
                    _this.nonHoldShipments = data.results;
                }
                setTimeout(function () {
                    window.print();
                }, 1000);
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this.loading = false;
                _this.model.generateCheckinManifest = false;
            });
        }
    }]);
    return PrintCheckinController;
}();

exports.default = PrintCheckinController;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkout = __webpack_require__(2714);

var _checkout2 = _interopRequireDefault(_checkout);

var _checkout3 = __webpack_require__(1843);

var _checkout4 = _interopRequireDefault(_checkout3);

__webpack_require__(2995);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkoutComponent = {
  restrict: 'E',
  bindings: {},
  template: _checkout2.default,
  controller: _checkout4.default
};

exports.default = checkoutComponent;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckOutController = function () {
  /*@ngInject*/
  CheckOutController.$inject = ["Auth", "$state", "User", "$translate", "UsersService", "BranchService", "CustomerService", "Modal", "RouteService", "SetupService", "RouteStopService", "DateUtil", "DataCounter", "WindowService", "TruckService", "$q", "ScanService", "ShipmentService", "LocationService", "ShiptypeService", "$location", "$stateParams", "$window", "RouteDetailService", "Sound", "$rootScope", "ItemService", "CommonLayoutService"];
  function CheckOutController(Auth, $state, User, $translate, UsersService, BranchService, CustomerService, Modal, RouteService, SetupService, RouteStopService, DateUtil, DataCounter, WindowService, TruckService, $q, ScanService, ShipmentService, LocationService, ShiptypeService, $location, $stateParams, $window, RouteDetailService, Sound, $rootScope, ItemService, CommonLayoutService) {
    (0, _classCallCheck3.default)(this, CheckOutController);


    this.$translate = $translate;
    this.UsersService = UsersService;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.Modal = Modal;
    this.ScanService = ScanService;
    this.ShipmentService = ShipmentService;
    this.LocationService = LocationService;
    this.ShiptypeService = ShiptypeService;
    this.SetupService = SetupService;
    this.$q = $q;
    this.$location = $location;
    this.$window = $window;
    this.RouteDetailService = RouteDetailService;
    this.Sound = Sound;
    this.BranchService = BranchService;
    this.CustomerService = CustomerService;
    this.RouteService = RouteService;
    this.WindowService = WindowService;
    this.TruckService = TruckService;
    this.DataCounter = DataCounter;
    this.CommonLayoutService = CommonLayoutService;
    this.$rootScope = $rootScope;
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();
    this.$stateParams = $stateParams;
    this.ItemService = ItemService;
    this.checkedoutRoute = '';
    // this.totalCoinShiptype = '';
    // this.shipTypeList = [];
    // this.total = '';
    this.user = null;
    this.finalTruckIdData = null;
    this.finalFromTankerData = '';
    this.responseData = '';
    this.branches = [];
    this.customers = [];
    this.routes = [];
    this.route = [];
    this.windows = [];
    this.trucks = [];
    this.shiptypes = [];
    this.routeVerifyData = {};
    this.truckData = {};
    this.destinationData = {
      previouslyScannedId: '',
      destinations: {
        self: null,
        deliveryLoc1: null,
        deliveryLoc2: null,
        deliveryLocCod: null,
        deliveryLocCoin: null
      }
    };

    this.stats = {
      cash: 'cash',
      coin: 'coin',
      items: 'items'
    };

    this.scannerBeep = null;
    this.closedRoute = null;
    this.bagIdCopy = null;
    this.lastScanned = null;
    this.bagCheckOutError = '';
    this.bagCheckInMessage = '';
    this.vaultDate = '';
    this.shipmentReportData = [];
    this.virtualTanker = '';
    this.setupData = "";
    this.checkoutTruckLiability = false;
    this.wasItemFound = false;
    this.wasItemThrow = false;
    this.isCheckOutSuccessful = true;
    this.finalToTankerData = "";
    // this.checkOutDate = $location.search().routeDate || null
    this.branchId = this.User.getUser().branchId;
    this.remainingCheckoutItemCount = 0;
    this.remainingForCheckout = null;
    this.resetModel();
    this.disabledBag = false;
    this.isEventFired = false;
    this.isSuccessForceAddBag = false;
    this.isDisabledBag = "";
    // this.bagScanLimit = AppConstant.scanLimit;
    this.bagScanLimit = "";
    this.checkOnlyOnce = false;
    this.checkLength = 0;
    this.enterSuffix = _app2.default.scan_enter_suffix;
    this.remainingToCheckedout = [];
    this.RouteStopService = RouteStopService;
    this.date = "";
    this.DateUtil = DateUtil;
    this.isCheckOutNextRoute = true;
    this.optimizedStops = undefined;
    this.isEnableMultiFunction = _app2.default.isEnableMultiFunction;
    this.routeCheckedOutData;
    this.$rootScope.$broadcast('routeChange', '/app/checkout');
    this.coinCheckOut = '';
    this.autoCheckOut = '';
    this.totalCoinCheckedOut = 0;
    this.totalCashCheckedOut = 0;
    this.checkoutTab = {
      shipment: 'shipment',
      items: 'items'
    };
    this.currentCheckoutTab = this.checkoutTab.shipment;
    this.logisticItemObj = {
      barcode: null,
      itemScanLimitExceed: false,
      allowItemScanOnce: false,
      disableItemScan: false,
      defaultLength: 0,
      lastScannedItem: null,
      lastUpdated: null,
      isError: false,
      itemCheckOutError: null,
      itemCheckOutMessage: null,
      remainingItemList: [],
      checkedOutItemList: [],
      itemDetails: {},
      wasItemFound: false,
      isItemCheckedOut: false,
      remainingItemsCount: 0,
      checkedOutItemsCount: 0,
      errorCode: null
    };
    this.model.routeDetailConfiguration = 'messenger';
    this.shipmentData = {};
    this.routeDetailConfigurationList = this.CommonLayoutService.configuration();
    this.inventoryBulkCoin = false;
    this.isInventoryBulkCoinOfCOD = false;
  }

  (0, _createClass3.default)(CheckOutController, [{
    key: 'loadWindows',
    value: function loadWindows() {
      var _this = this;

      return this.BranchService.get(this.model.branch).then(function (branch) {
        _this.windows = branch.windows;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this2 = this;

      return this.$q.all([this.BranchService.all(null, 0, 1000), this.RouteService.all(null, 0, 1000),
      // this.TruckService.all(null, 0, 1000),
      this.ShiptypeService.all(null, 0, 1000)]).then(function (res) {
        _this2.branches = res[0].results;
        _this2.routes = res[1].results;
        // this.trucks = res[2].results;
        _this2.shiptypes = res[2].results;
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this2.Modal.errorModal('error.' + err.data.message);
        }
      }).finally(function () {
        if (!_this2.hasRoute) {
          _this2.focusElementById('route-scan-id');
        }
      });
    }
  }, {
    key: 'verifyRoute',
    value: function verifyRoute(routeId, date) {
      var _this3 = this;

      return this.ScanService.routeCheckoutVerify(this.branchId, routeId, date, this.model.messenger).then(function (data) {
        _this3.checkOutData(routeId);
        _this3.routeVerifyData = data;
        _this3.logisticItemObj.remainingItemList = _this3.routeVerifyData.remainingItemList || [];
        _this3.logisticItemObj.remainingItemsCount = _this3.logisticItemObj.remainingItemList.length || 0;
        _this3.logisticItemObj.checkedOutItemList = _this3.routeVerifyData.checkedOutItemList || [];
        _this3.logisticItemObj.checkedOutItemsCount = _this3.logisticItemObj.checkedOutItemList.length || 0;
        _this3.logisticItemObj.availableItemList = _this3.routeVerifyData.availableItemList || [];
        _this3.logisticItemObj.availableItemCount = _this3.logisticItemObj.availableItemList.length || 0;
        _this3.remainingCheckoutItemCount = 0;
        _this3.remainingCashCheckoutItemCount = 0;
        _this3.remainingCoinCheckoutItemCount = 0;
        _this3.routeVerifyData.errorCount = 0;
        _this3.totalCoinVerified = 0;
        _this3.remainingToCheckedout = [];

        if (_this3.routeVerifyData.route) {
          _this3.routeVerifyData.route.forEach(function (record) {
            if (!['OK_DELIVERY', 'OK_DELIVERY_ON_HOLD'].includes(record.message)) {
              if (_this3.coinCheckOut && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) _this3.remainingCheckoutItemCount++;
              if (!_this3.coinCheckOut) {
                if (record.qty && record.coinFlag && !_this3.routeVerifyData.coinVerified) _this3.remainingCoinCheckoutItemCount = _this3.remainingCoinCheckoutItemCount + record.qty;else if (record.coinFlag && record.qty && _this3.routeVerifyData.coinVerified) _this3.totalCoinVerified = _this3.totalCoinVerified + record.qty;else if (!record.coinFlag && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) _this3.remainingCashCheckoutItemCount++;
              }
              _this3.remainingToCheckedout.push(record);
            }
            if (record.isError && ['E_COIN_SHIPMENT_NOT_VERIFIED', 'E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) {
              _this3.routeVerifyData.errorCount++;
            }
          });
          _this3.routeVerifyData.errorCount = _this3.routeVerifyData.errorCount + _this3.logisticItemObj.remainingItemsCount;
        }
      });
    }
  }, {
    key: 'focusElementById',
    value: function focusElementById(id) {
      setTimeout(function () {
        if (!document.getElementById(id)) return;
        document.getElementById(id).focus();
      });
    }
  }, {
    key: 'getTankerSearchObj',
    value: function getTankerSearchObj(tankerId) {
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branch
          }, {
            field: 'locationType',
            condition: '=',
            data: 'TANKER'
          }],
          operator: 'AND'
        }
      };

      if (tankerId) {
        searchObj.queryJSON.rules.push({
          field: 'id',
          condition: '=',
          data: tankerId
        });
      }

      return searchObj;
    }
  }, {
    key: 'stopPropagation',
    value: function stopPropagation(event) {
      event.stopPropagation();
      event.preventDefault();
    }

    // get checkedOut shipment based on branchId and routeId

  }, {
    key: 'checkOutData',
    value: function checkOutData(routeId) {
      var _this4 = this;

      this.ScanService.shipmentCheckInCheckOutData(this.model.branch, routeId, this.vaultDate).then(function (data) {
        _this4.totalShipmentCheckedOut = data.checkInCheckOutCount.totalShipmentCheckedOut;
        _this4.remainingForCheckout = data.checkInCheckOutCount.remainingCheckoutCount;
        _this4.totalCoinCheckedOut = data.checkInCheckOutCount.totalCoinCheckedOut;
        _this4.totalCashCheckedOut = data.checkInCheckOutCount.totalCashCheckedOut;
        _this4.totalCoinShipmentOnRoute = data.checkInCheckOutCount.totalCoinShipmentOnRoute;
        _this4.remainingCoinCheckoutItemCount = _this4.totalCoinShipmentOnRoute;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'loadCheckoutDate',
    value: function loadCheckoutDate() {
      var _this5 = this;

      this.checkOutDate = this.$location.search().routeDate;

      if (!this.checkInDate) {
        var branchId = this.User.getUser().branchId;

        this.SetupService.get(branchId).then(function (setup) {
          _this5.setupData = setup;
          _this5.checkoutTruckLiability = setup.checkoutTruckLiability;
          _this5.virtualTanker = setup.virtualTankerId;
          _this5.date = _this5.DateUtil.convertToDate(setup.currentVaultDate);
          _this5.vaultDate = moment.utc(setup.currentVaultDate).format('YYYY-MM-DD');
          _this5.checkOutDate = moment(setup.currentVaultDate).utc().format('YYYY-MM-DD');
          _this5.bagScanLimit = setup.packCharLength;
          _this5.prefixes = setup.prefixes;
          _this5.coinCheckOut = setup.coinCheckOut;
          _this5.addBagToCheckout = setup.addBagToCheckout;

          if (_this5.setupData.enableAutoSubmit) _this5.autoSubmitItem = true;else _this5.autoSubmitItem = false;
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this5.Modal.errorModal('error.' + err.data.message);
          }
        });
      }
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      this.model.stats = this.stats.cash;
      this.scannedRouteId = "";
      this.loadData();
      this.loadCheckoutDate();
      this.user = this.User.getUser();
      this.model.branch = this.user.branchId;
      this.loggedInUser = this.user.id;
    }
  }, {
    key: 'routeScanned',
    value: function routeScanned() {
      var _this6 = this;

      var finalRouteData, cloneRouteId;
      this.model.allTrucks = [];
      if (this.scannedRouteId === '') {
        return;
      }

      finalRouteData = this.scannedRouteId;
      cloneRouteId = angular.copy(finalRouteData);
      this.closedRoute = undefined;
      this.lastStatusUpdate = undefined;

      var defer = this.$q.defer();
      this.verifyRoute(finalRouteData, this.checkOutDate).then(function () {
        return _this6.ScanService.updateRouteCheckoutStartTime(finalRouteData, _this6.checkOutDate);
      }).then(function () {
        return defer.resolve();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this6.routeError();
          if (err.data.message === '91510') {
            var errorMessage = _this6.$translate.instant('error.' + err.data.message, {
              routeId: cloneRouteId.toUpperCase()
            });
            _this6.Modal.confirm({
              header: _this6.$translate.instant('errorModal.title'),
              message: _this6.$translate.instant(errorMessage),
              callback: function callback(_ref) {
                var modal = _ref.modal;

                var obj = {
                  routeId: cloneRouteId.toUpperCase(),
                  isRedirected: true
                };
                _this6.DataCounter.setData(obj);
                _this6.$state.go('routeControl');
                modal.close();
              },
              negative: function negative(_ref2) {
                var modal = _ref2.modal;

                modal.close();
                cloneRouteId = "";
              },
              buttons: ['routeControl.stop_transfer', 'common.cancel'],
              type: 'danger'
            });
          } else {
            _this6.Modal.errorModal('error.' + err.data.message);
          }
          _this6.focusElementById('route-scan-id');
        }
      }).finally(function () {
        if (_this6.hasRoute) {
          _this6.focusElementById('messenger-scan-id');
        } else {
          _this6.focusElementById('route-scan-id');
        }
        _this6.scannedRouteId = '';
        _this6.model.messenger = "";
        finalRouteData = '';
      });
      defer.promise.then(function () {
        return _this6.scanRoute(finalRouteData, _this6.checkOutDate);
      });
    }
  }, {
    key: 'scanRoute',
    value: function scanRoute(finalRouteData, checkOutDate) {
      var _this7 = this;

      this.ScanService.scanRoute(this.model.branch, finalRouteData, checkOutDate, false, false, false).then(function (data) {
        if (data.error) {
          return _this7.Modal.errorModal(data.error);
        }

        _this7.model.route = data.route.routeId;
        _this7.model.routeObj = data.route;
        _this7.model.toTruck = data.route.vehicleId;
        _this7.model.loadTruckFlag = data.route.loadTruck;
        _this7.autoCheckOut = data.route.autoCheckOut;
        _this7.model.restrictTruck = data.route.restrictTruck;
        _this7.model.restrictToTruck = data.route.restrictToTruck;
        if (!_this7.model.loadTruckFlag) {
          if (_this7.model.restrictToTruck === 1) {
            // Route is restricted — clear toTruck so the truck screen stays visible.
            // The readonly input shows the restricted truck; user presses Enter to confirm via toTruckScanned().
            _this7.model.toTruck = null;
            if (_this7.model.restrictTruck) {
              _this7.restrictedTruckDisplay = _this7.model.restrictTruck.id + ' | ' + _this7.model.restrictTruck.make;
            } else {
              _this7.restrictedTruckDisplay = '';
            }
          } else {
            // No restriction — load truck dropdown
            _this7.TruckService.getAllTrucks(null, _this7.model.branch, _this7.model.route, _this7.vaultDate, 100, 0).then(function (res) {
              _this7.model.allTrucks = res.results;
            }).catch(function (err) {
              console.error(err);
            });
          }
        }
      }).then(function () {
        _this7.verifyShipment(finalRouteData, checkOutDate).then(function () {
          if (_this7.isShipmentThrown) {
            _this7.Sound.playSuccessBeep("#success_beep");
            _this7.focusElementById('messenger-scan-id');
            _this7.model.messenger = "";
          }
        }).then(function () {
          _this7.getRouteTanker(_this7.model.route, _this7.vaultDate).then(function (res) {
            _this7.responseData = res.route;
          }).catch(function (err) {
            console.log(err);
          });
        });
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this7.routeError();
          _this7.Modal.errorModal("error." + err.data.message);
          _this7.focusElementById('route-scan-id');
        }
      });
    }
  }, {
    key: 'verifyShipment',
    value: function verifyShipment(routeId, vaultDate) {
      var _this8 = this;

      var defer = this.$q.defer();
      this.ScanService.shipmentVerify(routeId, vaultDate, this.coinCheckOut, this.model.branch).then(function (data) {
        _this8.remainingToThrow = data.remainingToThrow;
        if (_this8.remainingToThrow > 0) {
          _this8.routeError();
          _this8.focusElementById('route-scan-id');
          _this8.message = _this8.$translate.instant('error.' + 94013, {
            pendingToThrow: _this8.remainingToThrow
          });
          _this8.Modal.errorModal(_this8.message);
        } else {
          _this8.hasRoute = true;
          _this8.isShipmentThrown = true;
        }
        defer.resolve();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this8.routeError();
          _this8.focusElementById('route-scan-id');
          _this8.Modal.errorModal("error." + err.data.message);
        }
      });
      return defer.promise;
    }
  }, {
    key: 'routeError',
    value: function routeError() {
      this.hasRoute = false;
      this.isShipmentThrown = false;
      this.Sound.PlayErrorBeep("#scanner_beep");
    }
  }, {
    key: 'messengerScanned',
    value: function messengerScanned() {
      var _this9 = this;

      var finalMessengerData;
      if (this.model.messenger === '') {
        return;
      }

      // if (this.prefixes && this.prefixes.messenger) {
      //   if (this.model.messenger.startsWith(this.prefixes.messenger[0])) {
      //     finalMessengerData = this.model.messenger.slice(this.prefixes.messenger[0].length)
      //   } else {
      //     finalMessengerData = this.model.messenger;
      //   }
      // } else {
      //   finalMessengerData = this.model.messenger;
      // }

      finalMessengerData = this.model.messenger;
      this.ScanService.scanMessenger(this.model.branch, this.model.route, finalMessengerData, this.checkOutDate, false).then(function (data) {
        if (data.error) {
          _this9.focusElementById('messenger-scan-id');
          _this9.model.messenger = '';
          _this9.Modal.errorModal(data.error);
          throw new Error(data.error);
        }

        _this9.hasMessenger = true;
        _this9.model.messenger = finalMessengerData;
        _this9.Sound.playSuccessBeep("#success_beep");
        if (_this9.model.routeObj && _this9.model.routeObj.scanUserItems === 1) {
          _this9.getCheckoutUserAssignedItems();
        }
      }).then(function () {
        if (!_this9.checkoutTruckLiability) {
          if (!_this9.responseData && !_this9.routeVerifyData.requireThrow || !_this9.responseData && _this9.routeVerifyData.requireThrow) {
            _this9.hasFromTanker = true;
            _this9.model.window = "";
            _this9.model.fromTanker = _this9.virtualTanker;
            _this9.focusElementById('window-scan-id');
          } else {
            _this9.focusElementById('from-tanker-id');
            _this9.model.fromTanker = '';
          }
        } else {
          _this9.focusElementById('truckId-scan-id');
        }
      }).then(function () {
        _this9.updateMessenger(_this9.model.messenger);
      }).catch(function (err) {
        if (err.data.message) {
          _this9.model.messenger = '';
          finalMessengerData = '';
          _this9.Sound.PlayErrorBeep("#scanner_beep");
          _this9.Modal.errorModal("error." + err.data.message);
          _this9.focusElementById('messenger-scan-id');
        }
      });
    }
  }, {
    key: 'getCheckoutUserAssignedItems',
    value: function getCheckoutUserAssignedItems() {
      var _this10 = this;

      this.ScanService.getCheckoutUserAssignedItems(this.model.routeObj.routeId, this.model.branch, this.model.messenger).then(function (res) {
        _this10.logisticItemObj.remainingItemList = res.data.remainingItemList || [];
        _this10.logisticItemObj.remainingItemsCount = res.data.remainingItemList.length || 0;
        _this10.logisticItemObj.checkedOutItemList = res.data.checkedOutItemList || [];
        _this10.logisticItemObj.checkedOutItemsCount = res.data.checkedOutItemList.length || 0;
        _this10.logisticItemObj.availableItemList = res.data.availableItemList || [];
        _this10.logisticItemObj.availableItemCount = res.data.availableItemList.length || 0;
        _this10.remainingCheckoutItemCount = 0;
        _this10.remainingCashCheckoutItemCount = 0;
        _this10.remainingCoinCheckoutItemCount = 0;
        _this10.routeVerifyData.errorCount = 0;
        _this10.totalCoinVerified = 0;
        _this10.remainingToCheckedout = [];
        if (_this10.routeVerifyData.route) {
          _this10.routeVerifyData.route.forEach(function (record) {
            if (!['OK_DELIVERY', 'OK_DELIVERY_ON_HOLD'].includes(record.message)) {
              if (_this10.coinCheckOut && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) _this10.remainingCheckoutItemCount++;
              if (!_this10.coinCheckOut) {
                if (record.qty && record.coinFlag && !_this10.routeVerifyData.coinVerified) _this10.remainingCoinCheckoutItemCount = _this10.remainingCoinCheckoutItemCount + record.qty;else if (record.coinFlag && record.qty && _this10.routeVerifyData.coinVerified) _this10.totalCoinVerified = _this10.totalCoinVerified + record.qty;else if (!record.coinFlag && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) _this10.remainingCashCheckoutItemCount++;
              }
              _this10.remainingToCheckedout.push(record);
            }
            if (record.isError && ['E_COIN_SHIPMENT_NOT_VERIFIED', 'E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) {
              _this10.routeVerifyData.errorCount++;
            }
          });
          _this10.routeVerifyData.errorCount = _this10.routeVerifyData.errorCount + _this10.logisticItemObj.remainingItemsCount;
        }
      });
    }
  }, {
    key: 'truckIDScanned',
    value: function truckIDScanned() {
      var _this11 = this;

      var finalTruckIdData;
      if (this.model.truckId === '') {
        return;
      }
      finalTruckIdData = this.model.truckId;
      this.ScanService.scanTruckId(this.model.truckId).then(function (data) {
        if (data.error) {
          _this11.focusElementById('truckId-scan-id');
          _this11.model.truckId = '';
          _this11.finalTruckIdData = '';
          _this11.truckData = {};
          _this11.Modal.errorModal(data.error);
          throw new Error(data.error);
        }

        if (!_this11.responseData && !_this11.routeVerifyData.requireThrow || !_this11.responseData && _this11.routeVerifyData.requireThrow) {
          _this11.hasFromTanker = true;
          _this11.model.window = "";
          _this11.model.fromTanker = _this11.virtualTanker;
          _this11.focusElementById('window-scan-id');
        } else {
          _this11.focusElementById('from-tanker-id');
          _this11.model.fromTanker = '';
        }

        _this11.finalTruckIdData = finalTruckIdData;
        _this11.truckData = data.truck;
        _this11.Sound.playSuccessBeep("#success_beep");
      }).catch(function (err) {
        if (err.data.message) {
          _this11.model.truckId = '';
          finalTruckIdData = '';
          _this11.finalTruckIdData = '';
          _this11.truckData = {};
          _this11.Sound.PlayErrorBeep("#scanner_beep");
          _this11.Modal.errorModal("error." + err.data.message);
          _this11.focusElementById('truckId-scan-id');
        }
      });
    }

    // Update scanned messengerId when doing checkout process

  }, {
    key: 'updateMessenger',
    value: function updateMessenger(messenger) {
      var _this12 = this;

      this.RouteDetailService.routeUpdateDetails(this.branchId, this.model.route, this.valutDate, null, messenger, null, null, null, null, null, null).then(function (data) {
        // console.log(data);
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          return _this12.Modal.errorModal('error.' + err.data.message);
        }
      });
    }
  }, {
    key: 'windowScanId',
    value: function windowScanId() {
      this.hasFromTanker = true;
      this.model.window = "";
      if (this.setupData && this.setupData.virtualTankers && this.setupData.defaultFromTankerId && !this.model.fromTanker) {
        this.model.fromTanker = this.setupData.defaultFromTankerId;
        this.finalFromTankerData = this.setupData.defaultFromTankerId;
      } else {
        this.model.fromTanker = this.finalFromTankerData;
      }
      this.Sound.playSuccessBeep("#success_beep");
      return this.focusElementById('window-scan-id');
    }
  }, {
    key: 'resetDataAndPlayBuzzer',
    value: function resetDataAndPlayBuzzer() {
      this.model.fromTanker = '';
      this.finalFromTankerData = '';
      this.Sound.PlayErrorBeep("#scanner_beep");
    }
  }, {
    key: 'getRouteTanker',
    value: function getRouteTanker(route, vaultDate) {
      return this.ScanService.scanFromTanker(route, vaultDate);
    }
  }, {
    key: 'fromTankerScanned',
    value: function fromTankerScanned() {
      var _this13 = this;

      if (this.model.fromTanker === '') {
        return;
      }

      // if (this.prefixes && this.prefixes.tanker) {
      //   if (this.model.fromTanker.startsWith(this.prefixes.tanker[0])) {
      //     this.finalFromTankerData = this.model.fromTanker.slice(this.prefixes.tanker[0].length)
      //   } else {
      //     this.finalFromTankerData = this.model.fromTanker;
      //   }
      // } else {
      //   this.finalFromTankerData = this.model.fromTanker;
      // }

      this.finalFromTankerData = this.model.fromTanker;
      this.getRouteTanker(this.model.route, this.vaultDate).then(function (res) {
        _this13.response = res.route;
        if (_this13.response && _this13.response.id.toUpperCase() === _this13.model.fromTanker) {
          _this13.windowScanId();
        } else {
          _this13.resetDataAndPlayBuzzer();
          return _this13.Modal.errorModal("error." + 91304);
        }
      }).catch(function (err) {
        if (err.data.message) {
          _this13.resetDataAndPlayBuzzer();
          return _this13.Modal.errorModal("error." + err.data.message);
        }
      });
    }
  }, {
    key: 'windowScanned',
    value: function windowScanned() {
      var _this14 = this;

      var finalWindowData;
      if (this.model.window === '') {
        return;
      }

      // if (this.prefixes && this.prefixes.window) {
      //     if (this.model.window.startsWith(this.prefixes.window[0])) {
      //       finalWindowData = this.model.window.slice(this.prefixes.window[0].length)
      //       console.log(finalWindowData);
      //     } else {
      //       finalWindowData = this.model.window;
      //       console.log(finalWindowData);
      //     }
      //   } 
      //   else {
      //     finalWindowData = this.model.window;
      //     console.log(finalWindowData);
      //   }

      finalWindowData = this.model.window;
      this.BranchService.get(this.user.branchId).then(function (branchObj) {
        _this14.hasWindow = branchObj.windows.some(function (window) {
          return finalWindowData.toUpperCase() === window.id.toUpperCase();
        });

        if (_this14.hasWindow) {
          _this14.model.window = finalWindowData;
          if (!_this14.model.loadTruckFlag) {
            _this14.hasToTruck = _this14.model.toTruck;
          }

          if (_this14.model.loadTruckFlag) {
            if (_this14.setupData && _this14.setupData.virtualTankers && _this14.setupData.defaultToTankerId && !_this14.model.toTanker) {
              _this14.model.toTanker = _this14.setupData.defaultToTankerId;
              _this14.finalToTankerData = _this14.setupData.defaultToTankerId;
            } else {
              _this14.model.toTanker = '';
            }
            _this14.focusElementById('to-tanker-id');
            _this14.Sound.playSuccessBeep("#success_beep");
          }
        } else {
          _this14.model.window = '';
          finalWindowData = '';
          _this14.Sound.PlayErrorBeep("#scanner_beep");
          _this14.Modal.errorModal("error." + 11000);
        }
      });
    }
  }, {
    key: 'toTankerScanned',
    value: function toTankerScanned() {
      var _this15 = this;

      if (this.model.toTanker === "") {
        return;
      }

      if (this.setupData.tankerId.toUpperCase() === this.model.toTanker) {
        this.resetToTanker();
        return this.Modal.errorModal('error.' + 90926);
      } else if (this.virtualTanker.toUpperCase() === this.model.toTanker) {
        this.resetToTanker();
        return this.Modal.errorModal('error.' + 90927);
      } else if (this.model.toTanker === this.model.fromTanker) {
        this.resetToTanker();
        return this.Modal.errorModal('error.' + 90929);
      }

      // this.ShipmentService.isValideTanker(this.model.toTanker, this.vaultDate)
      //   .then((res) => {
      //     if (!res.status) {
      //       this.resetToTanker();
      //       return this.Modal.errorModal("error." + 91307)
      //     }
      //     else {
      this.finalToTankerData = this.model.toTanker;
      var searchObj = this.getTankerSearchObj(this.finalToTankerData);

      this.LocationService.all(searchObj, 0, 1).then(function (res) {
        if (res.results && res.results.length) {
          _this15.hasToTanker = true;
          _this15.model.toTanker = _this15.finalToTankerData;
          _this15.Sound.playSuccessBeep("#success_beep");
          _this15.setFocus();
        } else {
          _this15.resetToTanker();
          return _this15.Modal.errorModal("error." + 91307);
        }
      }).catch(function (err) {
        if (err.data.message) {
          _this15.resetToTanker();
          return _this15.Modal.errorModal("error." + err.data.message);
        }
      });
      // }
      // })
    }
  }, {
    key: 'resetToTanker',
    value: function resetToTanker() {
      this.model.toTanker = '';
      this.finalToTankerData = '';
      this.Sound.PlayErrorBeep("#scanner_beep");
    }
  }, {
    key: 'toTruckScanned',
    value: function toTruckScanned() {
      var _this16 = this;

      // When route is restricted to a truck, the input is readonly/pre-filled.
      // Auto-set toTruck from the restricted truck so setTruckForRoute gets the right ID.
      if ((this.model.restrictToTruck === 1 || this.model.restrictToTruck === true) && this.model.restrictTruck) {
        this.model.toTruck = this.model.restrictTruck.id;
      }

      if (!this.model.toTruck || this.model.toTruck === "") {
        return;
      }

      this.TruckService.setTruckForRoute(this.model.toTruck, this.model.route, this.checkOutDate, this.model.branch).then(function (res) {
        if (res) {
          _this16.hasToTruck = true;
          _this16.setFocus();
        } else {
          _this16.model.toTruck = '';
          _this16.Sound.PlayErrorBeep("#scanner_beep");
          return _this16.Modal.errorModal("error." + 91309);
        }
      }).catch(function (err) {
        if (err.data.message) {
          _this16.model.toTruck = '';
          _this16.Sound.PlayErrorBeep("#scanner_beep");
          return _this16.Modal.errorModal(err.data.message);
        }
      });
    }
  }, {
    key: 'setDestination',
    value: function setDestination(destination) {
      this.isDestinationChanged = this.model.destination.value !== destination.value;
      this.newValues.destination = destination;
    }
  }, {
    key: 'checkOutBag',
    value: function checkOutBag() {
      var _this17 = this;

      return this.ShipmentService.checkoutShipment(this.model.branch, this.model.bagId, this.model.route, this.checkOutDate, this.model.window, this.model.fromTanker, this.model.loadTruckFlag ? this.model.toTanker : this.model.toTruck).then(function (response) {
        if (response.error) {
          _this17.isError = true;
          return _this17.Modal.errorModal(response.error);
        }
        _this17.clearScan();
        _this17.Sound.playSuccessBeep("#success_beep");
      }).finally(function () {
        _this17.verifyRoute(_this17.model.route, _this17.checkOutDate);
        _this17.lastStatusUpdate = new Date();
      });
    }
  }, {
    key: 'autoSubmit',
    value: function autoSubmit($event) {
      var _this18 = this;

      var bagScannedPromise = this.bagScanned($event);

      //in case of error bagScanned returns non promise values are returned there's a check for .then function
      if (bagScannedPromise && typeof bagScannedPromise.then === "function") {
        bagScannedPromise.then(function () {
          setTimeout(function () {
            _this18.bagSubmitted();
          }, 700);
        });
      }

      return bagScannedPromise;
    }
  }, {
    key: 'keyPressed',
    value: function keyPressed(controlId, $event) {
      var ESC_KEY_CODE = 27;
      var BACKSPACE_KEY_CODE = 8;
      if (controlId === 'bagId') {
        if ($event.keyCode === ESC_KEY_CODE) {
          this.clearScan(true);
        }
        if ($event.keyCode === BACKSPACE_KEY_CODE && this.model.bagId && this.model.bagId.length <= 1) {
          this.clearScan(true);
        }
      }
    }
  }, {
    key: 'bagSubmitted',
    value: function bagSubmitted() {
      var _this19 = this;

      if (!this.model.bagId || this.isError) {
        this.isEventFired = false;
        return;
      }
      var successMessage = this.$translate.instant('checkout.checkedout', {
        bagId: this.model.bagId.toString(),
        tankerId: this.model.loadTruckFlag ? this.model.toTanker : this.model.toTruck
      });

      this.isError = false;
      this.bagCheckOutMessage = '';
      this.bagIdCopy = '';
      return this.checkOutBag().then(function () {
        _this19.bagIdCopy = _this19.lastScanned;
        _this19.isSuccessForceAddBag = false;
        _this19.bagCheckOutMessage = successMessage;
        _this19.isEventFired = false;
      }).catch(function (err) {
        _this19.model.bagId = "";
        _this19.isSuccessForceAddBag = false;
        _this19.isError = true;
        _this19.isEventFired = false;
        if (err && err.data && err.data.message) {
          _this19.Sound.PlayErrorBeep("#scanner_beep");
          _this19.bagCheckOutError = _this19.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        } else {
          _this19.bagCheckOutError = err.toString();
        }
      });
    }
  }, {
    key: 'scanSuffix',
    value: function scanSuffix(value) {
      if (this.enterSuffix.length > 0 && value && value.toUpperCase().endsWith(this.enterSuffix)) {
        var bagIdLength = value.length;
        return value.slice(0, bagIdLength - this.enterSuffix.length);
      } else return value;
    }
  }, {
    key: 'bagScanned',
    value: function bagScanned($event) {
      var _this20 = this;

      this.model.bagId = this.scanSuffix(this.model.bagId);
      this.lastScanned = this.model.bagId;

      if (!this.model.bagId || this.isEventFired) {
        return;
      }

      this.bagScanLimitExceed = false;

      if (this.bagScanLimit && this.bagScanLimit > 0) {
        if (this.model.bagId.length > this.bagScanLimit && (!this.checkOnlyOnce || this.model.bagId.length !== this.checkLength)) {
          delete this.bagCheckOutError;
          delete this.bagCheckOutMessage;
          this.bagScanLimitExceed = true;
          this.checkOnlyOnce = true;
          this.checkLength = this.model.bagId.length;
          this.model.bagId = "";
          this.lastStatusUpdate = new Date();
          return this.bagScanError = this.$translate.instant('common.bagScanError');
        } else {
          this.checkLength = this.model.bagId.length > this.bagScanLimit ? this.model.bagId.length : this.bagScanLimit;
        }
      }

      delete this.lastStatusUpdate;
      if (this.bagIdCopy === this.model.bagId && this.isCheckOutSuccessful && this.wasItemFound) {
        this.isCheckOutSuccessful = false;
        this.isEventFired = true;
        return this.bagSubmitted();
      } else {
        this.bagIdCopy = this.model.bagId;
      }

      if (this.isSuccessForceAddBag) {
        this.model.bagId = this.lastScanned;
      }

      this.isError = false;
      this.wasItemFound = true;
      this.wasItemThrow = true;
      this.bagCheckOutError = '';
      this.disabledBag = true;
      return this.ShipmentService.verifyCheckoutShipment(this.model.branch, this.model.bagId, this.model.route, this.checkOutDate, this.model.window, this.model.fromTanker, this.model.loadTruckFlag ? this.model.toTanker : this.model.toTruck).then(function (response) {
        _this20.disabledBag = false;
        if (response.error) {
          _this20.lastStatusUpdate = new Date();
          _this20.isError = true;
          _this20.wasItemFound = false;
          if (response.errorCode == 91311 || response.message == '91311') {
            if (!_this20.addBagToCheckout) {
              _this20.model.bagId = "";
              return _this20.Modal.errorModal("Tracking ID does not exist.");
            } else {
              _this20.model.bagId = "";
              return _this20.forceAddBag($event);
            }
          }
          return _this20.Modal.errorModal(response.error);
        }
        if (response.shipment.inventoryBulkCoin) {
          _this20.inventoryBulkCoin = true;
        }
        if (response.shipment.coinFlag && response.shipment.inventoryBulkCoin) {
          var shipment = response.shipment;
          _this20.ScanService.getCurrentDenomLedgerBalance(_this20.model.branch, 'Regular', [shipment], _this20.model.route, _this20.checkOutDate).then(function (data) {
            var balanceData = data && data.length > 0 ? data.find(function (item) {
              return Number(item.branchFundingSourceId) === Number(shipment.branchFundingSourceId) && item.denominationId === shipment.shiptypeId;
            }) || data[0] : null;

            if (balanceData && balanceData.alreadyDebited) {
              if (!_this20.shipmentData[shipment.branchFundingSourceId]) {
                _this20.shipmentData[shipment.branchFundingSourceId] = {};
              }
              if (!_this20.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId]) {
                _this20.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId] = {
                  amount: shipment.amount
                };
              } else {
                _this20.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId].amount += shipment.amount;
              }
              return;
            }

            var checkAmount = null;
            if (_this20.shipmentData && _this20.shipmentData[shipment.branchFundingSourceId] && _this20.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId]) {
              checkAmount = _this20.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId].amount + shipment.amount;
            } else {
              checkAmount = shipment.amount;
            }

            var balance = balanceData ? Number(balanceData.balance) : 0;
            var amountToCheck = Number(checkAmount);

            if (!balanceData || amountToCheck > balance) {
              _this20.Sound.PlayErrorBeep("#scanner_beep");
              var message = _this20.$translate.instant('orderPacking.insufficient_coin', {
                Denomination: shipment.shiptypeId,
                BranchFundingSource: shipment.fundingSourceName
              });
              _this20.disabledBag = false;
              _this20.isEventFired = false;
              _this20.isCheckOutSuccessful = false;
              _this20.lastStatusUpdate = new Date();
              _this20.isError = true;
              _this20.clearItems($event);
              _this20.Modal.errorModal(message);
            } else {

              if (!_this20.shipmentData[shipment.branchFundingSourceId]) {
                _this20.shipmentData[shipment.branchFundingSourceId] = {};
              }

              if (!_this20.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId]) {
                _this20.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId] = {
                  amount: shipment.amount
                };
              } else {
                _this20.shipmentData[shipment.branchFundingSourceId][shipment.shiptypeId].amount += shipment.amount;
              }
            }
          }).catch(function (err) {
            if (err && err.data && err.data.message) {
              _this20.Modal.errorModal(err.data.message);
            }
          });
        }
        if (_this20.checkoutTruckLiability && _this20.truckData && _this20.truckData.truckLiability) {
          _this20.ShipmentService.verifyTruckLiability(_this20.model.route, _this20.vaultDate, _this20.truckData.liabilityLimit, response.shipment.amount).then(function (data) {
            if (!data.isWithinLiability) {
              _this20.disabledBag = false;
              _this20.isEventFired = false;
              _this20.Sound.PlayErrorBeep("#scanner_beep");
              _this20.isCheckOutSuccessful = false;
              _this20.lastStatusUpdate = new Date();
              _this20.isError = true;
              _this20.clearItems($event);
              return _this20.bagCheckOutError = _this20.$translate.instant('common.bagScanTruckError');
            }
          });
        }

        if (response.window.fuzzyMatching) {
          _this20.disabledBag = false;
          _this20.wasItemFound = false;
          // this.isEventFired = true;
          return _this20.Modal.checkedOutShipmentSelectionModal({
            bagId: _this20.model.bagId,
            branchId: _this20.model.branch,
            windowId: _this20.model.window,
            routeId: _this20.model.route,
            date: _this20.checkOutDate,
            tankerId: _this20.model.fromTanker,
            supervisorScan: !_this20.setupData.supervisorScan,
            disabledBag: _this20.disabledBag,
            cancelSupervisorChallenge: _this20.setupData.cancelSupervisorChallenge
          }, response.shipments, function (_ref3) {
            var modal = _ref3.modal,
                isCreated = _ref3.isCreated,
                selected = _ref3.selected;

            var bagDefer = _this20.$q.defer();

            if (isCreated) {
              _this20.ShipmentService.create(selected).then(function () {
                bagDefer.resolve();
              }).catch(function (err) {
                bagDefer.reject(err);
              });
            } else {
              bagDefer.resolve();
            }

            bagDefer.promise.then(function () {
              _this20.isEventFired = false;
              _this20.model.bagId = selected.trackingId;
              _this20.autoSubmit($event);
              _this20.verifyRoute(_this20.model.route, _this20.checkOutDate);
              _this20.disabledBag = false;
              modal.close();
            }).catch(function (err) {
              _this20.disabledBag = false;
              _this20.isEventFired = false;
              if (err && err.data && err.data.message) {
                _this20.Sound.PlayErrorBeep("#scanner_beep");
                return _this20.Modal.errorModal("error." + 90990);
              } else {
                console.log(err);
              }
            });
          }, function (_ref4) {
            var modal = _ref4.modal;

            modal.close();
            _this20.isEventFired = false;
            _this20.disabledBag = false;
            _this20.focusElementById('bagId');
          });
        } else {
          _this20.isCheckOutSuccessful = true;
          _this20.model.shipment = response.shipment;

          _this20.model.shipment.quantity = _this20.model.shipment.quantity || 1;
          _this20.disabledBag = false;
          _this20.focusElementById('bagId');
        }
        _this20.lastScanned = _this20.model.bagId;
      }).catch(function (err) {
        _this20.focusElementById('bagId');
        // console.error(err);
        _this20.disabledBag = false;
        _this20.isEventFired = false;
        _this20.Sound.PlayErrorBeep("#scanner_beep");
        _this20.isCheckOutSuccessful = false;
        // this.model.bagId = '';
        _this20.lastStatusUpdate = new Date();
        _this20.isError = true;
        _this20.clearItems($event);

        if (err && err.data && err.data.message) {
          _this20.bagCheckOutError = _this20.$translate.instant('error.' + err.data.message) || null;
        }

        if (err && err.data && err.data.message === '91311') {
          //item not found
          _this20.disabledBag = false;
          _this20.wasItemFound = false;
          if (!_this20.addBagToCheckout) {
            _this20.model.bagId = "";
            return _this20.Modal.errorModal("Tracking ID does not exist.");
          } else {
            _this20.model.bagId = "";
            return _this20.forceAddBag($event);
          }
        }
        if (err && err.data && err.data.message === '91316') {
          // item remaining to throw
          _this20.wasItemThrow = false;
        }
        if (err && err.data && err.data.message === '91322') {
          // item remaining to throw
          _this20.isDisableRefreshButton = true;
          _this20.Modal.bagRemoveConfirmation({ bagId: _this20.lastScanned, cancelSupervisorChallenge: _this20.setupData.cancelSupervisorChallenge }, function (_ref5) {
            var modal = _ref5.modal,
                $scope = _ref5.$scope;

            if ($scope.isSupervisorConfirmed) {
              _this20.clearScan(true);
              _this20.clearItemScan();
              _this20.isDisableRefreshButton = false;
              _this20.remainingCheckoutItemCount = 0;
              _this20.remainingCashCheckoutItemCount = 0;
              _this20.remainingCoinCheckoutItemCount = 0;
              _this20.routeVerifyData.errorCount = 0;
              _this20.totalCoinVerified = 0;
              _this20.remainingToCheckedout = [];
              _this20.routeVerifyData.route = _this20.routeVerifyData.route.filter(function (t) {
                return t.trackingId !== _this20.lastScanned;
              });
              _this20.routeVerifyData.route.forEach(function (record) {
                if (!['OK_DELIVERY', 'OK_DELIVERY_ON_HOLD'].includes(record.message)) {
                  if (_this20.coinCheckOut && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) _this20.remainingCheckoutItemCount++;
                  if (!_this20.coinCheckOut) {
                    if (record.qty && record.coinFlag && !_this20.routeVerifyData.coinVerified) _this20.remainingCoinCheckoutItemCount = _this20.remainingCoinCheckoutItemCount + record.qty;else if (record.coinFlag && record.qty && _this20.routeVerifyData.coinVerified) _this20.totalCoinVerified = _this20.totalCoinVerified + record.qty;else if (!record.coinFlag && ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) _this20.remainingCashCheckoutItemCount++;
                  }
                  _this20.remainingToCheckedout.push(record);
                }
                if (record.isError && ['E_COIN_SHIPMENT_NOT_VERIFIED', 'E_DELIVERY_NOT_ON_HOLD'].includes(record.message)) {
                  _this20.routeVerifyData.errorCount++;
                }
              });
              _this20.routeVerifyData.errorCount = _this20.routeVerifyData.errorCount + _this20.logisticItemObj.remainingItemsCount;
              modal.close();
            }
          }, function (_ref6) {
            var modal = _ref6.modal;

            if (modal) modal.close();
          });
        }
        _this20.isSuccessForceAddBag = false;
      });
    }
  }, {
    key: 'clearItems',
    value: function clearItems(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        event.stopPropagation();
        this.disabledBag = false;
        this.model.bagId = "";
        // this.focusElementById('bag-id');
      };
    }

    // autoThrowTanker() {
    //   return new Promise(
    //     function (resolve, reject) {
    //          this.ShipmentService.throwTanker(this.model.branch, this.model.bagId, this.model.fromTanker, this.vaultDate, this.vaultDate)
    //         .then((data) => {
    //           console.log(this.model.branch, this.model.bagId, this.model.fromTanker, this.vaultDate, this.vaultDate);
    //           resolve(data);
    //         })
    //         .catch((err) => {
    //           if (err && err.data && err.data.message) {
    //             this.Sound.PlayErrorBeep("#scanner_beep");
    //             this.Modal.errorModal('error.' + err.data.message)
    //           }
    //           reject(err)
    //         })
    //     })
    // }

  }, {
    key: 'autoThrow',
    value: function autoThrow() {
      var _this21 = this;

      this.bagCheckOutMessage = "";
      this.model.bagId = this.lastScanned;
      this.ShipmentService.throwTanker(this.model.branch, this.model.bagId, this.model.fromTanker, this.vaultDate, this.loggedInUser).then(function (data) {
        // console.log(data);
      }).then(function () {
        return _this21.checkOutBag().then(function () {
          var successMessage = _this21.$translate.instant('checkout.checkedout', {
            bagId: _this21.model.bagId.toString(),
            tankerId: _this21.model.loadTruckFlag ? _this21.model.toTanker : _this21.model.toTruck
          });
          _this21.isError = false;
          _this21.bagCheckOutMessage = successMessage;
        });
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this21.Sound.PlayErrorBeep("#scanner_beep");
          _this21.Modal.errorModal('error.' + err.data.message);
        }
      });
    }
  }, {
    key: 'closeRoute',
    value: function closeRoute() {
      var _this22 = this;

      if (this.isEventFired) return;
      this.isEventFired = true;
      this.model.loading = true;
      return this.RouteService.routeCheckout(this.model.branch, this.model.route, this.checkOutDate, this.model.fromTanker, this.model.loadTruckFlag ? this.model.toTanker : this.model.toTruck, this.model.window, this.model.messenger, this.model.routeDetailConfiguration).then(function (data) {
        _this22.routeCheckedOutData = data;
        _this22.isEventFired = false;
        _this22.model.loading = false;
        if (data.isError) {
          return _this22.Modal.errorModal(data.messageCode);
        }
        _this22.isInventoryBulkCoinOfCOD = !!data.coinDebitedDuringCheckout;
        _this22.releaseRoute(_this22.model.route);
        _this22.checkedoutRoute = _this22.model.route;
        _this22.lastStatusUpdate = new Date();
        _this22.zipSuffix = moment.utc(_this22.setupData.currentVaultDate).format('MMDDYY');
        _this22.Sound.playSuccessBeep("#success_beep");
        _this22.resetModel();
        if (_this22.isEnableMultiFunction) _this22.isCheckOutNextRoute = false;
        if (_this22.isCheckOutNextRoute) _this22.focusElementById('route-scan-id');
        return;
      }).catch(function (err) {
        _this22.isEventFired = false;
        _this22.model.loading = false;
        if (!err) {
          return _this22.Modal.errorModal('Lock Opening Still in process for route ' + _this22.model.route + '. This process can take a while, please check after some time.');
        } else if (err && err.data && err.data.message) {
          _this22.Sound.PlayErrorBeep("#scanner_beep");
          _this22.Modal.errorModal('error.' + err.data.message);
        } else {
          console.error(err);
        }
      });
    }
  }, {
    key: 'releaseRoute',
    value: function releaseRoute(route) {
      this.executeReleaseRoutes([route]).then(function () {});
    }

    // update .zip after closing route

  }, {
    key: 'executeReleaseRoutes',
    value: function executeReleaseRoutes(route) {
      var _this23 = this;

      return route.reduce(function (p, route) {
        var nextIteration = _this23.$q.defer();

        p.then(function () {
          _this23.RouteService.releaseRoute(route, _this23.vaultDate, _this23.model.branch).then(function (res) {}).catch(function (err) {
            console.error(err);
          }).finally(function () {
            nextIteration.resolve();
          });
        });

        return nextIteration.promise;
      }, this.$q.when()).finally(function () {});
    }

    // print checkout manifest 

  }, {
    key: 'printManifest',
    value: function printManifest() {
      // const new_path = `${this.$location.protocol()}://${this.$location.host()}:${this.$location.port()}/print-checkout/${this.branchId}/${this.checkedoutRoute}/${this.vaultDate}`
      // this.$window.open(new_path, '_blank')

      var url = this.$state.href('printCheckout', {
        branchId: this.branchId,
        scannedRouteId: this.checkedoutRoute,
        date: this.vaultDate
      });

      window.w = window.open(url, '_blank');
      // window.w.printData = {
      //   itemList: this.logisticItemObj.checkedOutItemList
      // };
    }
  }, {
    key: 'forceClose',
    value: function forceClose(event) {
      var _this24 = this;

      if (this.isEventFired) return;
      this.isEventFired = true;

      var filteredRouteVerifyData = {
        route: this.routeVerifyData.route.filter(function (record) {
          return ['E_DELIVERY_NOT_ON_HOLD'].includes(record.message);
        }),
        errorCount: this.routeVerifyData.errorCount,
        shipments: this.routeVerifyData.shipments
      };

      var coinFlag = 0,
          deliveryCoin = 0,
          isAllCoinVerified = void 0,
          coinIds = [];

      this.routeVerifyData.route.filter(function (d) {
        if (d.coinFlag) coinFlag++;
        if (d.message === 'OK_DELIVERY_COIN') deliveryCoin++;

        if (d.message === 'E_COIN_SHIPMENT_NOT_VERIFIED') {
          coinIds.push(d.shiptypeId);
        }
      });

      isAllCoinVerified = coinFlag == deliveryCoin;

      this.Modal.forceCloseRoute(this.model.route, filteredRouteVerifyData, this.remainingCoinCheckoutItemCount, this.totalCoinShipmentOnRoute, this.coinCheckOut, isAllCoinVerified, this.logisticItemObj.remainingItemList, function (_ref7) {
        var $scope = _ref7.$scope,
            action = _ref7.action,
            modal = _ref7.modal,
            scanValue = _ref7.scanValue;

        _this24.isEventFired = false;
        if (action === 'scan') {
          _this24.model.bagId = "";
          // this.bagScanned()
          modal.close();
          _this24.setFocus();
          return;
        }

        var holdShipmentObj = [{
          branch: _this24.model.branch,
          route: _this24.model.route,
          checkOutDate: _this24.checkOutDate,
          supervisorId: $scope.model.supervisorId,
          comment: '',
          routeVerifyResults: $scope.model.routeVerifyResults
        }];

        _this24.RouteService.validateLedgerBalanceAgainstRouteCoinHandler(_this24.model.route, _this24.vaultDate).then(function (res) {
          _this24.ShipmentService.bulkHoldShipment(holdShipmentObj).then(function () {
            return _this24.logisticItemBulkHold();
          }).then(function () {
            return _this24.ScanService.verifyCoin(_this24.model.route, _this24.vaultDate).then(function (data) {
              if (data) {
                _this24.isInventoryBulkCoinOfCOD = data.results.allCoins.some(function (item) {
                  return item.inventoryBulkCoin === 1 && item.codInputValue > 0;
                });
              }
            });
          }).then(function () {
            if (_this24.totalCoinShipmentOnRoute > 0 && !isAllCoinVerified) {
              return _this24.verifyCoin(_this24.model.route, _this24.vaultDate, _this24.model.branch, coinIds).then(function () {
                return _this24.routeCheckOut(_this24.model.route, _this24.checkOutDate);
              });
            }
          }).then(function () {
            if (_this24.totalCoinShipmentOnRoute == 0 || isAllCoinVerified) {
              return _this24.routeCheckOut(_this24.model.route, _this24.checkOutDate);
            }
          }).catch(function (err) {
            if (err && err.data && err.data.message) {
              _this24.Sound.PlayErrorBeep("#scanner_beep");
              return _this24.Modal.errorModal('error.' + err.data.message);
            }
          }).finally(function () {
            $scope.loading = false;
            modal.close();
          });
        }).catch(function (err) {
          _this24.isEventFired = false;
          if (err && err.data && err.data.message) {
            _this24.Sound.PlayErrorBeep("#scanner_beep");
            return _this24.Modal.errorModal(err.data.message);
          } else {
            _this24.Modal.errorModal(err);
          }
        });
      }, function (_ref8) {
        var modal = _ref8.modal;

        _this24.isEventFired = false;
        if (modal) modal.close();
      }, undefined, this.model.routeObj.name);
    }
  }, {
    key: 'routeCheckOut',
    value: function routeCheckOut(route, date) {
      var _this25 = this;

      return this.verifyRoute(route, date).then(function () {
        if (!_this25.routeVerifyData.errorCount) {
          _this25.closeRoute();
        }
      });
    }
  }, {
    key: 'forceAddBag',
    value: function forceAddBag($event) {
      var _this26 = this;

      var user = this.User.getUser();
      var isSupervisor = user && user.supervisor;
      var supervisorScanRequired = isSupervisor ? this.setupData.supervisorScan : true;

      return this.Modal.checkedoutForceAddBag({
        bagId: this.lastScanned,
        branchId: this.model.branch,
        windowId: this.model.window,
        routeId: this.model.route,
        date: this.checkOutDate,
        tankerId: this.model.fromTanker,
        supervisorScan: supervisorScanRequired,
        disabledBag: this.disabledBag,
        cancelSupervisorChallenge: this.setupData.cancelSupervisorChallenge
      }, function (_ref9) {
        var modal = _ref9.modal,
            $scope = _ref9.$scope,
            disabledBag = _ref9.disabledBag;

        _this26.isDisabledBag = disabledBag;
        $scope.bag.routeId = _this26.model.route;
        $scope.bag.pickupDate = _this26.checkOutDate;
        // $scope.bag.packedFlag = true
        _this26.ShipmentService.create($scope.bag).then(function (res) {
          _this26.isSuccessForceAddBag = true;
          _this26.isEventFired = false;
          _this26.model.bagId = _this26.lastScanned;
          modal.close();
          _this26.autoSubmit($event);
          _this26.wasItemFound = true;
          _this26.bagCheckOutError = '';
          _this26.bagCheckOutMessage = '';
          _this26.lastStatusUpdate = '';
          _this26.isError = '';
          _this26.disabledBag = disabledBag;
          _this26.verifyRoute(_this26.model.route, _this26.checkOutDate);
        }).catch(function (err) {
          _this26.lastScanned = "";
          _this26.model.bagId = "";
          _this26.disabledBag = disabledBag;
          _this26.isSuccessForceAddBag = false;
          if (err && err.data && err.data.errors) {
            _this26.Sound.PlayErrorBeep("#scanner_beep");
            _this26.Modal.errorModal("error." + err.data.errors[0].path);
          } else if (err && err.data && err.data.message) {
            _this26.Sound.PlayErrorBeep("#scanner_beep");
            _this26.Modal.errorModal(err.data.message);
          } else {
            console.log(err);
          }
        });
      }, function (_ref10) {
        var modal = _ref10.modal;

        _this26.focusElementById('bagId');
        _this26.isEventFired = false;
        _this26.model.bagId = "";
        _this26.disabledBag = false;
        modal.close();
      });
    }

    // Add items modal

  }, {
    key: 'addItems',
    value: function addItems() {
      this.Modal.checkoutAddItems(function (_ref11) {
        var modal = _ref11.modal;
      }, function (_ref12) {
        var modal = _ref12.modal;

        modal.close();
      });
    }
  }, {
    key: 'clearScan',
    value: function clearScan(clearError) {
      this.model.shipment = {};
      this.model.bagId = '';

      if (clearError) {
        this.lastStatusUpdate = undefined;
        this.bagCheckOutError = '';
        this.bagCheckInMessage = '';
        this.isError = false;
      }
      this.isEventFired = false;
      this.isSuccessForceAddBag = false;
      this.bagScanLimitExceed = false;
      this.checkOnlyOnce = false;
      this.disabledBag = false;
      this.shipmentAssociateToTankerList = [];
      this.model.scannedTankerId = '';
      this.setFocus();
    }
  }, {
    key: 'resetModel',
    value: function resetModel() {
      this.hasMessenger = false;
      this.hasRoute = false;
      this.isShipmentThrown = true;
      this.hasWindow = false;
      this.hasFromTanker = false;
      this.hasToTanker = false;
      this.hasToTruck = false;

      this.model = {
        route: undefined,
        branch: this.User.getUser().branchId,
        window: undefined,
        fromTanker: undefined,
        toTanker: undefined,
        toTruck: undefined,
        loadTruckFlag: false,
        messenger: undefined,
        truckId: undefined
      };

      this.isError = false;
      this.bagCheckOutError = '';
      this.bagCheckOutMessage = '';
    }

    // coinShipTypes() {
    //   this.ShipmentService.getCoinShiptypes(this.model.route, this.vaultDate)
    //     .then((data) => {
    //       this.shipTypeList = data.results;
    //       this.total = data.total;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     })
    // }

    // showCoinShiptypes() {
    //   this.Modal.coinShiptypeList(this.shipTypeList, this.total, ({ modal, totalCoinShiptype }) => {
    //   }, ({ modal }) => {
    //     modal.close();
    //   });
    // }

  }, {
    key: 'shipmentInfo',
    value: function shipmentInfo(isShpCheckedOut, field, status) {
      // console.log(isShpCheckedOut, field);
      var isCoinVerified = this.routeVerifyData.coinVerified;
      this.Modal.routeCheckoutInfo(isShpCheckedOut, this.model.route, this.vaultDate, this.model.branch, this.remainingToCheckedout, field, isCoinVerified, status, function (_ref13) {
        var modal = _ref13.modal;

        modal.close();
      }, function (_ref14) {
        var modal = _ref14.modal;

        modal.close();
      });
    }
  }, {
    key: 'AutoOptimizeRoute',
    value: function AutoOptimizeRoute() {
      var _this27 = this;

      // console.log(this.vaultDate, this.model.branch, this.checkedoutRoute, this.date);
      this.Modal.routeSequenceModal(this.date, this.checkedoutRoute, this.model.branch, function (_ref15) {
        var modal = _ref15.modal,
            routeSequence = _ref15.routeSequence;

        _this27.RouteStopService.updateRouteStop(routeSequence, _this27.model.branch) // update route Sequence
        .then(function (data) {
          return _this27.routeStopTransfer([_this27.checkedoutRoute]).then(function () {
            modal.close();
            _this27.optimizedStops = data.updatedStops;
          });
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            return _this27.Modal.errorModal('error.' + err.data.message);
          }
        });
      }, function (_ref16) {
        var modal = _ref16.modal;

        modal.close();
      });
    }
  }, {
    key: 'routeStopTransfer',
    value: function routeStopTransfer(routes) {
      var _this28 = this;

      var defer = this.$q.defer();
      // this.RouteService.routeStopTransfered(routes, this.vaultDate, this.model.branch)
      this.RouteService.routeStopTransfered([{ routeId: routes, date: this.vaultDate }], this.model.branch).then(function (data) {
        defer.resolve();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          return _this28.Modal.errorModal('error.' + err.data.message);
        }
        defer.reject(err);
      });
      return defer.promise;
    }
  }, {
    key: 'closeInfo',
    value: function closeInfo() {
      this.isCheckOutNextRoute = true;
      this.optimizedStops = null;
      this.checkedoutRoute = null;
      this.focusElementById('route-scan-id');
    }
  }, {
    key: 'checkOutNextRoute',
    value: function checkOutNextRoute() {
      this.isCheckOutNextRoute = true;
      this.optimizedStops = null;
      this.checkedoutRoute = null;
      this.model.stats = 'cash';
      this.model.routeDetailConfiguration = 'messenger';
      this.focusElementById('route-scan-id');
    }
  }, {
    key: 'autoGenerateAtmCodes',
    value: function autoGenerateAtmCodes() {
      var data = {
        routeId: this.checkedoutRoute,
        vaultDate: this.vaultDate,
        redirectFromCheckoutScreen: true
      };
      this.DataCounter.setAtmCodeData(data);
      this.$location.url('/app/atm-codes-management');
    }
  }, {
    key: 'tabSelection',
    value: function tabSelection(selectedValue) {
      this.model.stats = selectedValue;
    }
  }, {
    key: 'verifyCoinShipment',
    value: function verifyCoinShipment() {
      var _this29 = this;

      this.Modal.coinShiptypeList(this.model.route, this.vaultDate, this.model.branch, function (_ref17) {
        var modal = _ref17.modal,
            isCodInventoryBulkCoin = _ref17.isCodInventoryBulkCoin,
            coinIds = _ref17.coinIds;

        _this29.isInventoryBulkCoinOfCOD = isCodInventoryBulkCoin;
        _this29.verifyCoin(_this29.model.route, _this29.vaultDate, _this29.model.branch, coinIds).then(function () {
          modal.close();
          _this29.verifyRoute(_this29.model.route, _this29.checkOutDate);
        });
      }, function (_ref18) {
        var modal = _ref18.modal;

        modal.close();
      });
    }
  }, {
    key: 'verifyCoin',
    value: function verifyCoin(routeId, vaultDate, branchId) {
      var _this30 = this;

      var coinIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      var defer = this.$q.defer();
      this.ScanService.verifyRouteCoin(routeId, vaultDate, branchId, coinIds).then(function (res) {
        defer.resolve();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this30.Modal.errorModal(err.data.message);
        }
      });
      return defer.promise;
    }
  }, {
    key: 'scanPrefix',
    value: function scanPrefix(prefixType, field) {
      if (this.model[field] && this.prefixes && this.prefixes[prefixType]) {
        if (this.model[field].startsWith(this.prefixes[prefixType][0])) {
          this.model[field] = this.model[field].slice(this.prefixes[prefixType][0].length).trim();
        }
      }
    }
  }, {
    key: 'scanTankerId',
    value: function scanTankerId() {
      var _this31 = this;

      if (!this.model.scannedTankerId) return;

      this.lastStatusUpdate = undefined;
      this.shipmentAssociateToTankerList = this.remainingToCheckedout.filter(function (s) {
        return s.tankerId == _this31.model.scannedTankerId;
      });

      if (this.shipmentAssociateToTankerList.length == 0) {
        var errorMsg = this.$translate.instant('checkout.tanker_association_error', { tankerId: this.model.scannedTankerId });
        this.Modal.errorModal(errorMsg);
      }
    }
  }, {
    key: 'shipmentAssociateToTankerModal',
    value: function shipmentAssociateToTankerModal() {
      var _this32 = this;

      this.Modal.shipmentAssociateToTanker(this.shipmentAssociateToTankerList, this.model.scannedTankerId, function (_ref19) {
        var modal = _ref19.modal,
            $scope = _ref19.$scope;

        var trackingIds = _this32.shipmentAssociateToTankerList.map(function (d) {
          return d.trackingId;
        });

        $scope.model.loading = true;
        return _this32.ShipmentService.checkoutShipment(_this32.model.branch, trackingIds, _this32.model.route, _this32.checkOutDate, _this32.model.window, _this32.model.fromTanker, _this32.model.loadTruckFlag ? _this32.model.toTanker : _this32.model.toTruck).then(function () {
          _this32.clearScan();
          _this32.Sound.playSuccessBeep("#success_beep");
          _this32.verifyRoute(_this32.model.route, _this32.checkOutDate);
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this32.Modal.errorModal('error.' + err.data.message);
          }
        }).finally(function () {
          modal.close();
          $scope.model.loading = false;
        });
      }, function (_ref20) {
        var modal = _ref20.modal;

        modal.close();
      });
    }
  }, {
    key: 'checkoutTabSelection',
    value: function checkoutTabSelection(selectedValue) {
      this.currentCheckoutTab = selectedValue;
      if (this.currentCheckoutTab === this.checkoutTab.items) {
        this.clearItemScan();
        this.model.stats = this.stats.items;
      } else if (this.currentCheckoutTab === this.checkoutTab.shipment) {
        this.clearScan();
        this.model.stats = this.stats.cash;
      }
    }
  }, {
    key: 'remainingLogisticItemList',
    value: function remainingLogisticItemList() {
      this.Modal.logisticItemList(this.model.route, this.logisticItemObj.remainingItemList, 'remaining', function (_ref21) {
        var modal = _ref21.modal;

        modal.close();
      }, function (_ref22) {
        var modal = _ref22.modal;

        modal.close();
      });
    }
  }, {
    key: 'logisticItemCheckedOutList',
    value: function logisticItemCheckedOutList() {
      this.Modal.logisticItemList(this.model.route, this.logisticItemObj.checkedOutItemList, 'checkedOut', function (_ref23) {
        var modal = _ref23.modal;

        modal.close();
      }, function (_ref24) {
        var modal = _ref24.modal;

        modal.close();
      });
    }
  }, {
    key: 'availableLogisticItems',
    value: function availableLogisticItems() {
      this.Modal.logisticItemList(this.model.route, this.logisticItemObj.availableItemList, 'available', function (_ref25) {
        var modal = _ref25.modal;

        modal.close();
      }, function (_ref26) {
        var modal = _ref26.modal;

        modal.close();
      });
    }
  }, {
    key: 'clearItemScan',
    value: function clearItemScan() {
      this.logisticItemObj.barcode = null;
      this.logisticItemObj.itemScanLimitExceed = false;
      this.logisticItemObj.allowItemScanOnce = false;
      this.logisticItemObj.disableItemScan = false;
      this.logisticItemObj.defaultLength = 0;
      this.logisticItemObj.lastUpdated = null;
      this.logisticItemObj.lastScannedItem = null;
      this.logisticItemObj.isError = false;
      this.logisticItemObj.itemCheckOutError = null;
      this.logisticItemObj.itemCheckOutMessage = null;
      this.logisticItemObj.itemScanError = null;
      this.logisticItemObj.itemDetails = {};
      this.logisticItemObj.wasItemFound = false;
      this.logisticItemObj.errorCode = null;
      this.logisticItemObj.loading = false;
      this.setFocus();
    }
  }, {
    key: 'itemScanKeyPress',
    value: function itemScanKeyPress($event) {
      var ESC_KEY_CODE = 27;
      var BACKSPACE_KEY_CODE = 8;
      if ($event.keyCode === ESC_KEY_CODE) return this.clearItemScan();
      if ($event.keyCode === BACKSPACE_KEY_CODE && this.logisticItemObj.barcode && this.logisticItemObj.barcode.length <= 1) return this.clearItemScan();
    }
  }, {
    key: 'logisticItemScan',
    value: function logisticItemScan() {
      var _this33 = this;

      this.logisticItemObj.barcode = this.scanSuffix(this.logisticItemObj.barcode);

      if (!this.logisticItemObj.barcode) return;

      this.logisticItemObj.itemScanLimitExceed = false;
      this.logisticItemObj.isError = false;
      this.logisticItemObj.itemCheckOutMessage = null;

      if (this.bagScanLimit && this.bagScanLimit > 0) {
        if (this.logisticItemObj.barcode.length > this.bagScanLimit && (!this.logisticItemObj.allowItemScanOnce || this.logisticItemObj.barcode.length !== this.logisticItemObj.defaultLength)) {
          delete this.logisticItemObj.itemCheckOutError;
          delete this.logisticItemObj.itemCheckOutMessage;
          delete this.logisticItemObj.errorCode;
          this.logisticItemObj.itemScanLimitExceed = true;
          this.logisticItemObj.allowItemScanOnce = true;
          this.logisticItemObj.lastScannedItem = this.logisticItemObj.barcode;
          this.logisticItemObj.defaultLength = this.logisticItemObj.barcode.length;
          this.logisticItemObj.barcode = "";
          this.logisticItemObj.isError = true;
          this.logisticItemObj.lastUpdated = new Date();
          return this.logisticItemObj.itemScanError = this.$translate.instant('common.bagScanError');
        } else {
          this.logisticItemObj.defaultLength = this.logisticItemObj.barcode.length > this.bagScanLimit ? this.logisticItemObj.barcode.length : this.bagScanLimit;
        }
      }

      this.logisticItemObj.itemDetails = this.logisticItemObj.remainingItemList.find(function (item) {
        return item.barcode.toUpperCase() == _this33.logisticItemObj.barcode;
      });
      if (this.logisticItemObj.itemDetails) this.logisticItemObj.wasItemFound = true;else if (_.isEmpty(this.logisticItemObj.itemDetails)) this.logisticItemObj.wasItemFound = false;

      delete this.logisticItemObj.lastUpdated;
      if (!this.autoSubmitItem) {
        if (this.logisticItemObj.barcodeCopy === this.logisticItemObj.barcode && this.logisticItemObj.wasItemFound) {
          this.logisticItemObj.isItemCheckedOut = false;
          return this.logisticItemSubmitted();
        } else if (!this.logisticItemObj.wasItemFound) {
          this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
          return this.forceAddItem();
        } else {
          this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
        }
      } else if (this.autoSubmitItem) {
        this.logisticItemObj.barcodeCopy = this.logisticItemObj.barcode;
        return _promise2.default.resolve();
      }
    }
  }, {
    key: 'logisticItemSubmitted',
    value: function logisticItemSubmitted() {
      var _this34 = this;

      if (!this.logisticItemObj.barcode) return;
      var successMessage = this.$translate.instant('item.checked_out');

      return this.ItemService.logisticItemCheckOut(this.branchId, this.logisticItemObj.barcode, this.user.id).then(function () {
        _this34.logisticItemObj.itemCheckOutMessage = successMessage;
        _this34.logisticItemObj.isItemCheckedOut = true;
        _this34.logisticItemObj.itemDetails = {};
        _this34.verifyRoute(_this34.model.route, _this34.checkOutDate);
      }).catch(function (err) {
        _this34.logisticItemObj.isItemCheckedOut = false;
        _this34.logisticItemObj.isError = true;
        if (err && err.data && err.data.message) {
          _this34.Sound.PlayErrorBeep("#scanner_beep");
          _this34.logisticItemObj.errorCode = err.data.message;
          _this34.logisticItemObj.itemCheckOutError = _this34.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        } else {
          _this34.logisticItemObj.itemCheckOutError = err.toString();
        }
      }).finally(function () {
        _this34.logisticItemObj.barcode = null;
        _this34.logisticItemObj.lastUpdated = new Date();
        _this34.logisticItemObj.lastScannedItem = _this34.logisticItemObj.barcodeCopy;
        _this34.logisticItemObj.barcodeCopy = null;
      });
    }
  }, {
    key: 'autoSubmitItems',
    value: function autoSubmitItems($event) {
      var _this35 = this;

      var promise = this.logisticItemScan($event);

      if (promise && typeof promise.then === "function") {
        promise.then(function () {
          setTimeout(function () {
            if (_this35.logisticItemObj.wasItemFound) return _this35.logisticItemSubmitted();else if (!_this35.logisticItemObj.wasItemFound) return _this35.forceAddItem();
          }, 700);
        });
      }

      return promise;
    }
  }, {
    key: 'logisticItemBulkHold',
    value: function logisticItemBulkHold() {
      var _this36 = this;

      return this.ItemService.logisticItemBulkHold(this.model.route, this.branchId, this.vaultDate, this.user.id, this.logisticItemObj.remainingItemList).then().catch(function (err) {
        if (err && err.data && err.data.message) {
          _this36.Modal.errorModal(err.data.message);
        }
      });
    }
  }, {
    key: 'setFocus',
    value: function setFocus() {
      if (this.currentCheckoutTab === this.checkoutTab.items) {
        this.focusElementById('barcode');
      } else if (this.currentCheckoutTab === this.checkoutTab.shipment) {
        this.focusElementById('bagId');
      }
    }
  }, {
    key: 'refreshData',
    value: function refreshData() {
      var _this37 = this;

      this.model.refreshItems = true;
      this.verifyRoute(this.model.route, this.checkOutDate).then(function () {
        _this37.clearScan(true);
        _this37.clearItemScan();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this37.Modal.errorModal('error.' + err.data.message);
        }
      }).finally(function () {
        _this37.model.refreshItems = false;
      });
    }
  }, {
    key: 'forceAddItem',
    value: function forceAddItem() {
      var _this38 = this;

      this.logisticItemObj.loading = true;

      var successMessage = this.$translate.instant('item.checked_out');
      var userKey = null;

      return this.ItemService.logisticItemForceAdd(this.branchId, this.logisticItemObj.barcodeCopy, this.user.id, this.model.route, null, false, userKey).then(function () {
        _this38.logisticItemObj.itemCheckOutMessage = successMessage;
        _this38.logisticItemObj.isItemCheckedOut = true;
        _this38.logisticItemObj.itemDetails = {};
        _this38.logisticItemObj.errorCode = null;
        _this38.logisticItemObj.isError = false;
        _this38.logisticItemObj.itemCheckOutError = null;
        _this38.verifyRoute(_this38.model.route, _this38.checkOutDate);
      }).catch(function (err) {
        _this38.logisticItemObj.isItemCheckedOut = false;
        _this38.logisticItemObj.isError = true;
        if (err && err.data && err.data.message) {
          _this38.Sound.PlayErrorBeep("#scanner_beep");
          _this38.logisticItemObj.itemCheckOutError = _this38.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        } else {
          _this38.logisticItemObj.itemCheckOutError = err.toString();
        }
      }).finally(function () {
        _this38.logisticItemObj.barcode = null;
        _this38.logisticItemObj.lastUpdated = new Date();
        _this38.logisticItemObj.lastScannedItem = _this38.logisticItemObj.barcodeCopy;
        _this38.logisticItemObj.barcodeCopy = null;
        _this38.logisticItemObj.loading = false;

        _this38.setFocus();
      });
    }
  }]);
  return CheckOutController;
}(); // import audio from "../../assets/audio/scanner_beep.mp3"


exports.default = CheckOutController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkout = __webpack_require__(1842);

var _checkout2 = _interopRequireDefault(_checkout);

var _print = __webpack_require__(1845);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkoutModule = angular.module('checkout', [_print2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  // $urlRouterProvider.otherwise('/checkout');

  $stateProvider.state('checkout', {
    url: '/checkout',
    component: 'checkout',
    data: {
      requireLogin: true,
      requireACL: 'check_out.all'
    },
    parent: 'app'
  });
}]).component('checkout', _checkout2.default).name;

exports.default = checkoutModule;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _print_checkout = __webpack_require__(1846);

var _print_checkout2 = _interopRequireDefault(_print_checkout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printCheckoutModule = angular.module('printCheckout', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider.otherwise('/checkout');

	$stateProvider.state('printCheckout', {
		url: '/print-checkout/{branchId}/{scannedRouteId}/{date}',
		component: 'printCheckout',
		data: {
			requireLogin: true,
			requireACL: 'check_out.all'
		}
	});
}]).component('printCheckout', _print_checkout2.default).name;

exports.default = printCheckoutModule;

// ?branch&route&date

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_checkout = __webpack_require__(2715);

var _print_checkout2 = _interopRequireDefault(_print_checkout);

var _print_checkout3 = __webpack_require__(1847);

var _print_checkout4 = _interopRequireDefault(_print_checkout3);

__webpack_require__(2996);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printCheckoutComponent = {
  restrict: 'E',
  bindings: {},
  template: _print_checkout2.default,
  controller: _print_checkout4.default
};

exports.default = printCheckoutComponent;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintCheckoutController = function () {
    /*@ngInject*/
    PrintCheckoutController.$inject = ["Auth", "$state", "User", "$translate", "UsersService", "ShipmentService", "$location", "$stateParams", "RouteDetailService"];
    function PrintCheckoutController(Auth, $state, User, $translate, UsersService, ShipmentService, $location, $stateParams, RouteDetailService) {
        (0, _classCallCheck3.default)(this, PrintCheckoutController);

        this.$translate = $translate;
        this.UsersService = UsersService;
        this.Auth = Auth;
        this.$state = $state;
        this.User = User;
        this.ShipmentService = ShipmentService;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.branchId = this.User.getUser().branchId;
        this.shipmentReportData = [];
        this.totalAmount = 0;
        this.totalCoin = 0;
        this.RouteDetailService = RouteDetailService;
        this.model = {
            itemList: []
        };
    }

    (0, _createClass3.default)(PrintCheckoutController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var branch = this.$stateParams.branchId;
            var route = this.$stateParams.scannedRouteId;
            var date = this.$stateParams.date;

            this.ShipmentService.getCheckoutManifestData(branch, route, date).then(function (data) {
                _this.routeId = route;
                _this.deliveryDate = date;
                _this.shipmentReportData = data;
                _this.model.itemList = data.itemList;
                if (_this.shipmentReportData && _this.shipmentReportData.results && _this.shipmentReportData.results.length > 0) {
                    _this.shipmentReportData.results = _.sortBy(_this.shipmentReportData.results, ['fromLocationId', 'toLocationId']);
                    _this.shipmentReportData.results[0].matchPreviousRow = false;
                    for (var i = 0; i < _this.shipmentReportData.results.length; i++) {
                        var from = _this.shipmentReportData.results[i].fromLocationId;
                        var to = _this.shipmentReportData.results[i].toLocationId;
                        var rows = 1;
                        for (var j = i + 1; j < _this.shipmentReportData.results.length; j++) {
                            if (_this.shipmentReportData.results[j].fromLocationId === from && _this.shipmentReportData.results[j].toLocationId === to && !_this.shipmentReportData.results[j].matchPreviousRow) {
                                rows++;
                                _this.shipmentReportData.results[j].matchPreviousRow = true;
                            } else {
                                break;
                            }
                        }
                        _this.shipmentReportData.results[i].rows = rows;
                    }
                }
                _this.userData = _this.User.getUser();
                _this.messengerDetails = data.messengerDetail;
                setTimeout(function () {
                    window.print();
                }, 1000);
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this.loading = false;
            });
        }
    }]);
    return PrintCheckoutController;
}();

exports.default = PrintCheckoutController;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(2997);

var coinManagementComponent = {
  restrict: "E",
  bindings: {}
};

exports.default = coinManagementComponent;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _coin_management = __webpack_require__(1848);

var _coin_management2 = _interopRequireDefault(_coin_management);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coinManagementModule = angular.module("coinManagement", []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise("/coinManagement");

  $stateProvider.state("coinManagement", {
    url: "/v2/index.html#/coin-management",
    component: "coinManagement",
    data: {
      requireLogin: true,
      requireACL: "coin_management.all"
    }
  });
}]).component("coinManagement", _coin_management2.default).name;

exports.default = coinManagementModule;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _coin_pull_report = __webpack_require__(2716);

var _coin_pull_report2 = _interopRequireDefault(_coin_pull_report);

var _coin_pull_report3 = __webpack_require__(1851);

var _coin_pull_report4 = _interopRequireDefault(_coin_pull_report3);

__webpack_require__(2998);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoinPullReportComponent = {
  restrict: 'E',
  bindings: {
    printData: '='
  },
  template: _coin_pull_report2.default,
  controller: _coin_pull_report4.default
};

exports.default = CoinPullReportComponent;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoinPullReportController = function () {
    /*@ngInject*/
    CoinPullReportController.$inject = ["Auth", "$state", "$stateParams", "DateUtil", "User", "UserService", "RouteService", "$translate", "$q", "SetupService", "$rootScope"];
    function CoinPullReportController(Auth, $state, $stateParams, DateUtil, User, UserService, RouteService, $translate, $q, SetupService, $rootScope) {
        (0, _classCallCheck3.default)(this, CoinPullReportController);

        this.$translate = $translate;
        this.Auth = Auth;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.DateUtil = DateUtil;
        this.User = User;
        this.RouteService = RouteService;
        this.SetupService = SetupService;
        this.$q = $q;
        this.$rootScope = $rootScope;

        this.coinReportData = [];
        this.routes = [];
        this.totalValues = {};
        this.routeList = [];
        this.showReport = false;
        this.loading = false;

        this.model = {
            route: '',
            date: null,
            branch: this.$stateParams.branch || this.User.getUser().branchId,
            currentStats: 'route'
        };

        this.selected = {
            route: ''
        };

        this.stats = {
            route: 'route',
            branch: 'branch'
        };

        this.$rootScope.$broadcast('routeChange', '/app/coin-pull-report');
        this.days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    }

    (0, _createClass3.default)(CoinPullReportController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // this.$q.all([
            // this.RouteService.all(undefined, 0, 1000),
            this.SetupService.get(this.model.branch)
            // ])
            .then(function (data) {
                // this.routes = data[0].results
                _this.model.date = _this.DateUtil.convertToDate(data.currentVaultDate || undefined);
                _this.model.day = _this.days[moment(_this.model.date).day()];

                _this.startMaxDate = {
                    minDate: _this.model.date
                };
            }).catch(function (err) {
                _this.error = err.message;
            });
            this.getAllRoutes();
        }
    }, {
        key: 'getAllRoutes',
        value: function getAllRoutes(searchKey, offset) {
            var _this2 = this;

            searchKey = searchKey || '';

            var routeSearchObj = {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branch
                    }, {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };

            this.RouteService.all(routeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this2.totalRecords = data.total;
                    _this2.routeList = _this2.mappingRouteDatas(data.results);
                } else {
                    var routes = _this2.mappingRouteDatas(data.results);
                    _this2.routeList = _this2.routeList.concat(routes);
                }
            });
        }
    }, {
        key: 'mappingRouteDatas',
        value: function mappingRouteDatas(routes) {
            return routes.map(function (route) {
                return {
                    Key: route.id + " | " + route.name,
                    Value: route.id
                };
            });
        }
    }, {
        key: 'print',
        value: function print() {
            var obj = {
                coinReportData: this.coinReportData,
                model: this.model,
                doPrint: true
            };
            var url = this.$state.href('coinPullReportPrint');
            window.w = window.open(url, '_blank');
            window.w.printData = obj;
        }
    }, {
        key: 'show',
        value: function show() {
            this.loadData(this.selected.route ? this.selected.route.Value : null, moment(this.model.date).format('YYYY-MM-DD'));
        }
    }, {
        key: 'loadData',
        value: function loadData(route, date) {
            var _this3 = this;

            if (!route) {
                this.coinReportData = [];
                return;
            }

            this.loading = true;

            this.RouteService.coinPullReport(route, date).then(function (data) {

                data.forEach(function (row) {
                    var coins = angular.copy(row);
                    delete coins.address;
                    delete coins.city;
                    delete coins.fromLocationId;
                    delete coins.name;

                    row.coins = coins;
                });

                _this3.coinReportData = data;

                var coinKeys = [];
                if (_this3.coinReportData.length > 0 && _this3.coinReportData[0].coins) {
                    var keys = (0, _keys2.default)(_this3.coinReportData[0].coins);
                    coinKeys = keys;
                }

                _this3.coinReportData = data.map(function (branchReport) {
                    var total = 0;

                    coinKeys.forEach(function (coinKey) {
                        total += branchReport[coinKey];
                    });

                    branchReport.total = total;

                    return branchReport;
                }).filter(function (branchReport) {
                    return branchReport.total > 0;
                });

                // console.log(this.coinReportData);
                _this3.showReport = true;
            }).catch(function (err) {
                console.log('Some error', err);
            }).finally(function () {
                _this3.loading = false;
                _this3.model.route = _this3.selected.route.Value;
            });
        }
    }, {
        key: 'tabSelection',
        value: function tabSelection(selectedValue) {
            this.model.currentStats = selectedValue;
        }
    }, {
        key: 'branchCoinPullReport',
        value: function branchCoinPullReport() {
            var _this4 = this;

            this.loading = true;
            this.RouteService.branchCoinPullReport(this.model.branch, moment(this.model.date).format('YYYY-MM-DD')).then(function (data) {
                _this4.model.branchCoinReport = data.results;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this4.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this4.loading = false;
            });
        }
    }, {
        key: 'printBranchCoinReport',
        value: function printBranchCoinReport() {
            var url = this.$state.href('branchCoinPullReportPrint');
            window.w = window.open(url, '_blank');
            window.w.printData = {
                results: this.model.branchCoinReport,
                branch: this.model.branch,
                day: this.model.day,
                date: this.model.date
            };
        }
    }]);
    return CoinPullReportController;
}();

exports.default = CoinPullReportController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _coin_pull_report = __webpack_require__(1850);

var _coin_pull_report2 = _interopRequireDefault(_coin_pull_report);

var _print_route_coin = __webpack_require__(1858);

var _print_route_coin2 = _interopRequireDefault(_print_route_coin);

var _print_branch_coin = __webpack_require__(1853);

var _print_branch_coin2 = _interopRequireDefault(_print_branch_coin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoinPullReportModule = angular.module('CoinPullReport', [_print_route_coin2.default, _print_branch_coin2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/coin-pull-report');

  $stateProvider.state('coin-pull-report', {
    url: '/coin-pull-report',
    component: 'coinPullReport',
    data: {
      requireLogin: true,
      requireACL: 'coin_pull_report.all'
    },
    parent: 'app'
  });
}]).component('coinPullReport', _coin_pull_report2.default).name;

exports.default = CoinPullReportModule;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _print_branch_coin = __webpack_require__(1854);

var _print_branch_coin2 = _interopRequireDefault(_print_branch_coin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printModule = angular.module('branchCoinPullReportPrint', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/branchManagement.bagouts');

    $stateProvider.state('branchCoinPullReportPrint', {
        url: '/print-branch-coin',
        component: 'branchCoinPullReportPrint',
        data: {
            requireLogin: true,
            requireACL: 'coin_pull_report.all'
        }
    });
}]).component('branchCoinPullReportPrint', _print_branch_coin2.default).name;

exports.default = printModule;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _print_branch_coin = __webpack_require__(2717);

var _print_branch_coin2 = _interopRequireDefault(_print_branch_coin);

var _print_branch_coin3 = __webpack_require__(1855);

var _print_branch_coin4 = _interopRequireDefault(_print_branch_coin3);

__webpack_require__(2999);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printComponent = {
    restrict: 'E',
    bindings: {},
    template: _print_branch_coin2.default,
    controller: _print_branch_coin4.default
};

exports.default = printComponent;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintController = function () {
    /*@ngInject*/
    PrintController.$inject = ["$translate"];
    function PrintController($translate) {
        (0, _classCallCheck3.default)(this, PrintController);

        this.$translate = $translate;
        this.model = {
            bagout: null
        };
    }

    (0, _createClass3.default)(PrintController, [{
        key: "$onInit",
        value: function $onInit() {
            if (window.opener && window.opener.w && window.opener.w.printData) {
                this.model.branchCoinReport = window.opener.w.printData;
                this.print();
            }
        }
    }, {
        key: "print",
        value: function print() {
            setTimeout(function () {
                window.print();
            }, 1500);
        }
    }]);
    return PrintController;
}();

exports.default = PrintController;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _coin_pull_report_print = __webpack_require__(2718);

var _coin_pull_report_print2 = _interopRequireDefault(_coin_pull_report_print);

var _coin_pull_report_print3 = __webpack_require__(1857);

var _coin_pull_report_print4 = _interopRequireDefault(_coin_pull_report_print3);

__webpack_require__(3000);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoinPullReportPrintComponent = {
  restrict: 'E',
  bindings: {},
  template: _coin_pull_report_print2.default,
  controller: _coin_pull_report_print4.default
};

exports.default = CoinPullReportPrintComponent;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoinPullReportPrintController = function () {
  /*@ngInject*/
  CoinPullReportPrintController.$inject = ["Auth", "$state", "Modal", "$translate", "$stateParams", "RouteService", "User"];
  function CoinPullReportPrintController(Auth, $state, Modal, $translate, $stateParams, RouteService, User) {
    (0, _classCallCheck3.default)(this, CoinPullReportPrintController);

    this.Modal = Modal;
    this.Auth = Auth;
    this.$state = $state;
    this.$translate = $translate;
    this.$stateParams = $stateParams;
    this.RouteService = RouteService;
    this.User = User;
    this.id = 'print';

    this.model = {
      branch: this.$stateParams.branch || this.User.getUser().branchId
    };
    this.coinReportData = [];
  }

  (0, _createClass3.default)(CoinPullReportPrintController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      if (window.opener && window.opener.w && window.opener.w.printData && window.opener.w.printData.doPrint) {
        this.model = window.opener.w.printData.model;
        this.coinReportData = window.opener.w.printData.coinReportData;
        this.showReport = true;

        setTimeout(function () {
          window.print();
        }, 1000);
      } else if (this.$stateParams.route && this.$stateParams.date) {
        var route = this.$stateParams.route;
        var date = this.$stateParams.date;
        this.loading = true;

        this.RouteService.coinPullReport(route, moment(date).format('YYYY-MM-DD')).then(function (data) {
          // console.log(data);
          data.forEach(function (row) {
            var coins = angular.copy(row);
            delete coins.address;
            delete coins.city;
            delete coins.fromLocationId;
            delete coins.name;

            row.coins = coins;
          });

          _this.coinReportData = data;

          var coinKeys = [];
          if (_this.coinReportData.length > 0 && _this.coinReportData[0].coins) {
            var keys = (0, _keys2.default)(_this.coinReportData[0].coins);
            coinKeys = keys;
          }

          _this.coinReportData = data.map(function (branchReport) {
            var total = 0;

            coinKeys.forEach(function (coinKey) {
              total += branchReport[coinKey];
            });

            branchReport.total = total;
            return branchReport;
          }).filter(function (branchReport) {
            return branchReport.total > 0;
          });

          _this.showReport = true;

          setTimeout(function () {
            window.print();
          }, 1000);
        }).catch(function (err) {
          console.log('Some error', err);
        }).finally(function () {
          var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

          _this.loading = false;
          _this.model.route = route;
          _this.model.date = date;
          _this.model.day = days[moment(_this.model.date).day()];
        });
      }
    }
  }]);
  return CoinPullReportPrintController;
}();

exports.default = CoinPullReportPrintController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _coin_pull_report_print = __webpack_require__(1856);

var _coin_pull_report_print2 = _interopRequireDefault(_coin_pull_report_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoinPullReportPrintModule = angular.module('CoinPullReportPrint', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider.otherwise('/coin-pull-report');

	$stateProvider.state('coinPullReportPrint', {
		url: '/coin-pull-report-print?route&date&branch',
		component: 'coinPullReportPrint',
		data: {
			requireLogin: true
		}
	});
}]).component('coinPullReportPrint', _coin_pull_report_print2.default).name;

exports.default = CoinPullReportPrintModule;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_region_routingAll = __webpack_require__(2719);

var _delivery_region_routingAll2 = _interopRequireDefault(_delivery_region_routingAll);

var _delivery_region_routingAll3 = __webpack_require__(1860);

var _delivery_region_routingAll4 = _interopRequireDefault(_delivery_region_routingAll3);

__webpack_require__(3001);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deliveryRegionRoutingAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template: _delivery_region_routingAll2.default,
    controller: _delivery_region_routingAll4.default
};

exports.default = deliveryRegionRoutingAllComponent;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryRegionRoutingAllController = function () {
    /*@ngInject*/

    DeliveryRegionRoutingAllController.$inject = ["User", "$state", "$stateParams", "CommonLayoutService", "RegionRoutingService", "$scope", "SetupService", "Modal"];
    function DeliveryRegionRoutingAllController(User, $state, $stateParams, CommonLayoutService, RegionRoutingService, $scope, SetupService, Modal) {
        (0, _classCallCheck3.default)(this, DeliveryRegionRoutingAllController);

        this.User = User;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.RegionRoutingService = RegionRoutingService;
        this.CommonLayoutService = CommonLayoutService;
        this.SetupService = SetupService;
        this.hasAcl = {};
        this.$scope = $scope;
        this.Modal = Modal;

        this.model = {
            branch: User.getUser().branchId,
            loggedInUser: User.getUser(),
            regionRouting: false,
            weekDays: CommonLayoutService.getWeekDays(),
            selectedDay: 'Sun',
            bucketObj: {},
            regionsObj: {}
        };
        this.map = '';
    }

    (0, _createClass3.default)(DeliveryRegionRoutingAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var pageId = this.$stateParams.page;
            if (pageId > 0) {
                this.page = pageId;
            }
            /* this.SetupService.get(this.model.branch)
                .then((data) => {
                    this.loadMap();
                    this.branchDetails(data);
                    this.getAllLocations();
                })
                .catch((err) => {
                    this.Modal.errorModal('error.' + err.data.message);
                }) */
        }
    }, {
        key: 'edit',
        value: function edit(obj) {
            this.$state.go('delivery-region-routing.edit', {
                id: obj.id
            });
        }
    }, {
        key: 'selectDay',
        value: function selectDay(day) {
            this.model.selectedDay = day.value;
        }
    }, {
        key: 'getAllLocations',
        value: function getAllLocations() {
            var _this = this;

            // this.model.bucketObj[title].process = true;

            this.RegionRoutingService.getAllLocations(10, 0).then(function (data) {
                // this.model.bucketObj[title].details = data;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                // this.model.bucketObj[title].process = false;
            });
        }
    }, {
        key: 'getLocations',
        value: function getLocations(title) {
            var _this2 = this;

            this.model.bucketObj[title].process = true;

            this.RegionRoutingService.getLocations(title, this.model.regionsObj[title].latDetails, this.model.regionsObj[title].longDetails, this.model.bucketObj[title].pagination.pageLimit, (this.model.bucketObj[title].pagination.page - 1) * this.model.bucketObj[title].pagination.pageLimit).then(function (data) {
                _this2.model.bucketObj[title].details = data;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this2.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this2.model.bucketObj[title].process = false;
            });
        }
    }, {
        key: 'findMinMaxLat',
        value: function findMinMaxLat(array) {
            // TODO: better solution for this
            var lowest = Number.POSITIVE_INFINITY;
            var highest = Number.NEGATIVE_INFINITY;
            for (var i = array.length - 1; i >= 0; i--) {
                var tmp = array[i].lat;
                if (tmp < lowest) lowest = tmp;
                if (tmp > highest) highest = tmp;
            }
            return { lowest: lowest, highest: highest };
        }
    }, {
        key: 'findMinMaxLong',
        value: function findMinMaxLong(array) {
            // TODO: better solution for this
            var lowest = Number.NEGATIVE_INFINITY;
            var highest = void 0;
            for (var i = array.length - 1; i >= 0; i--) {
                var tmp = array[i].lng;
                if (tmp > lowest) highest = tmp;
            }
            lowest = _.min(array, 'lng');
            return { lowest: highest, highest: lowest.lng };
        }
    }]);
    return DeliveryRegionRoutingAllController;
}();

;

exports.default = DeliveryRegionRoutingAllController;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_region_routingAll = __webpack_require__(1859);

var _delivery_region_routingAll2 = _interopRequireDefault(_delivery_region_routingAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryRegionRoutingAllModule = angular.module('deliveryRegionRoutingAll', []).component('deliveryRegionRoutingAll', _delivery_region_routingAll2.default).name;

exports.default = DeliveryRegionRoutingAllModule;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_region_routingCreate = __webpack_require__(2720);

var _delivery_region_routingCreate2 = _interopRequireDefault(_delivery_region_routingCreate);

var _delivery_region_routingCreate3 = __webpack_require__(1863);

var _delivery_region_routingCreate4 = _interopRequireDefault(_delivery_region_routingCreate3);

__webpack_require__(3002);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deliveryRegionRoutingCreateComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template: _delivery_region_routingCreate2.default,
    controller: _delivery_region_routingCreate4.default
};

exports.default = deliveryRegionRoutingCreateComponent;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryRegionRoutingCreateController = function () {
    /*@ngInject*/

    DeliveryRegionRoutingCreateController.$inject = ["User", "$state", "CommonLayoutService", "RegionRoutingService", "LocationZoneService", "$scope", "SetupService", "Modal", "$sce", "AtmMakesService", "ServiceActionPrioritiesService", "ActionCodeService", "$translate", "$timeout"];
    function DeliveryRegionRoutingCreateController(User, $state, CommonLayoutService, RegionRoutingService, LocationZoneService, $scope, SetupService, Modal, $sce, AtmMakesService, ServiceActionPrioritiesService, ActionCodeService, $translate, $timeout) {
        (0, _classCallCheck3.default)(this, DeliveryRegionRoutingCreateController);

        this.User = User;
        this.$sce = $sce;
        this.$state = $state;
        this.$timeout = $timeout;
        this.RegionRoutingService = RegionRoutingService;
        this.LocationZoneService = LocationZoneService;
        this.CommonLayoutService = CommonLayoutService;
        this.SetupService = SetupService;
        this.AtmMakesService = AtmMakesService;
        this.ServiceActionPrioritiesService = ServiceActionPrioritiesService;
        this.ActionCodeService = ActionCodeService;
        this.$translate = $translate;
        this.hasAcl = {};
        this.$scope = $scope;
        this.Modal = Modal;
        this.bulkZones = [];
        this.savingAll = false;
        this.bulkSaveAlert = {
            show: false,
            type: 'success', // 'success' or 'error'
            message: ''
        };

        this.makesLocalLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: '(Select Makes)'
        };
        this.actionsLocalLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: '(Select Actions)'
        };
        this.customersLocalLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: '(Select Customer)'
        };
        this.actionPrioritiesLocalLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: '(Select Action Priority)'
        };

        this.model = {
            branch: User.getUser().branchId,
            loggedInUser: User.getUser(),
            regionRouting: false,
            weekDays: CommonLayoutService.dayOfWeek(),
            selectedDay: 'MONDAY',
            bucketObj: {},
            regionsObj: {},
            locationData: {}
        };
        this.map = '';
        this.location = {
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            process: true,
            bucketExpanded: true
        };
        this.loadinglocationZone = false;
        this.ruleAssignmentConfig = this.getRuleAssignmentConfig();
        this.ruleAssignmentDrag = this.getDefaultRuleAssignmentDrag();
    }

    (0, _createClass3.default)(DeliveryRegionRoutingCreateController, [{
        key: 'buildThresholdOptions',
        value: function buildThresholdOptions(labels) {
            return labels.map(function (label) {
                return {
                    value: parseFloat(/([\d.]+)/.exec(label)[1]),
                    label: label
                };
            });
        }
    }, {
        key: 'getRuleAssignmentConfig',
        value: function getRuleAssignmentConfig() {
            return {
                activeStatuses: ['Active Status', 'Logged In On Service Mode', 'Logged In On User Schedule'],
                distances: this.buildThresholdOptions(['<=5 Miles', '<=10 Miles', '<=20 Miles', '<=50 Miles', '<=100 Miles']),
                locationPriorities: this.CommonLayoutService.priorityList(),
                makes: [],
                actionCodes: [],
                actionPriorities: [],
                modes: ['FLM', 'SLM'],
                estWorkloads: this.buildThresholdOptions(['<=2 Hours', '<=4 Hours', '<=6 Hours', '<=8 Hours', '<=10 Hours', '<=24 Hours', '<=48 Hours', '<=72 Hours']),
                tickets: this.buildThresholdOptions(['<=3 Tickets', '<=5 Tickets', '<=7 Tickets', '<=10 Tickets', '<=20 Tickets'])
            };
        }
    }, {
        key: 'getDefaultRuleAssignmentDrag',
        value: function getDefaultRuleAssignmentDrag() {
            return {
                zoneKey: null,
                dragIndex: null,
                dragOverIndex: null
            };
        }
    }, {
        key: 'nextRuleUid',
        value: function nextRuleUid() {
            this._ruleUidCounter = (this._ruleUidCounter || 0) + 1;
            return 'rule_uid_' + this._ruleUidCounter;
        }
    }, {
        key: 'parseRuleJsonArray',
        value: function parseRuleJsonArray(value) {
            if (!value) return [];
            if (Array.isArray(value)) return value;
            if (typeof value === 'string') {
                try {
                    var parsed = JSON.parse(value);
                    if (Array.isArray(parsed)) return parsed;
                } catch (e) {
                    // fall through
                }
                if (value.indexOf(',') !== -1) {
                    return value.split(',').map(function (s) {
                        return s.trim();
                    });
                }
                return [value];
            }
            return [value];
        }
    }, {
        key: 'withMissingSelected',
        value: function withMissingSelected(options, selectedValues) {
            var missing = selectedValues.filter(function (value) {
                return !options.some(function (option) {
                    return option.Value === value;
                });
            });
            return options.concat(missing.map(function (value) {
                return { Value: value, Key: String(value), ticked: true };
            }));
        }
    }, {
        key: 'normalizeRuleAssignment',
        value: function normalizeRuleAssignment() {
            var rule = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var zoneKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var cfg = this.ruleAssignmentConfig;
            var zone = zoneKey ? this.model.bucketObj[zoneKey] : null;
            var parsedMakes = this.parseRuleJsonArray(rule.makes);
            var parsedActionCodes = this.parseRuleJsonArray(rule.actionCodes).map(Number);
            var parsedCustomers = this.parseRuleJsonArray(rule.customerIds).map(Number);
            var parsedActionPriorities = this.parseRuleJsonArray(rule.serviceActionPriorityIds).map(Number);

            var normalized = {
                id: rule.id || null,
                _uid: rule._uid || this.nextRuleUid(),
                sequence: rule.sequence || index + 1,
                assigneeUserId: rule.assigneeUserId || null,
                assigneeUser: rule.assigneeUser || null,
                activeStatus: rule.activeStatus || cfg.activeStatuses[0],
                distanceInMiles: this.readRuleJsonValue(rule.distanceInMiles),
                locationPriority: this.readRuleJsonValue(rule.locationPriority),
                customerIds: parsedCustomers,
                makes: parsedMakes,
                actionCodes: parsedActionCodes,
                serviceActionPriorityIds: parsedActionPriorities,
                mode: this.readRuleJsonValue(rule.mode),
                estWorkloadInHours: this.readRuleJsonValue(rule.estWorkloadInHours),
                totalTicketsAssigned: this.readRuleJsonValue(rule.totalTicketsAssigned),
                isActive: typeof rule.isActive === 'boolean' ? rule.isActive : null,
                isEditing: !!rule.isEditing,
                isSaving: false
            };

            var makesOptions = this.withMissingSelected(cfg.makes.map(function (make) {
                return {
                    Value: make.Value,
                    Key: make.Key,
                    ticked: parsedMakes.includes(make.Value)
                };
            }), parsedMakes);

            var actionCodesOptions = this.withMissingSelected(cfg.actionCodes.map(function (code) {
                return {
                    Value: code.Value,
                    Key: code.Key,
                    ticked: parsedActionCodes.includes(code.Value)
                };
            }), parsedActionCodes);

            var customerOptions = this.withMissingSelected((zone && zone.customerOptions || []).map(function (customer) {
                return {
                    Value: customer.Value,
                    Key: customer.Key,
                    ticked: parsedCustomers.includes(customer.Value)
                };
            }), parsedCustomers);

            var actionPriorityOptions = this.withMissingSelected(cfg.actionPriorities.map(function (priority) {
                return {
                    Value: priority.Value,
                    Key: priority.Key,
                    ticked: parsedActionPriorities.includes(priority.Value)
                };
            }), parsedActionPriorities);

            normalized.editModel = rule.editModel && rule.isEditing ? _.cloneDeep(rule.editModel) : {
                assignee: this.getAssigneeObject(normalized.assigneeUserId, rule, zoneKey),
                activeStatus: normalized.activeStatus,
                distanceInMiles: normalized.distanceInMiles,
                locationPriority: normalized.locationPriority,
                customerOptions: customerOptions,
                selectedCustomers: customerOptions.filter(function (c) {
                    return c.ticked;
                }),
                customerIds: normalized.customerIds,
                makesOptions: makesOptions,
                actionCodesOptions: actionCodesOptions,
                selectedMakes: makesOptions.filter(function (m) {
                    return m.ticked;
                }),
                selectedActionCodes: actionCodesOptions.filter(function (a) {
                    return a.ticked;
                }),
                makes: normalized.makes,
                actionCodes: normalized.actionCodes,
                actionPriorityOptions: actionPriorityOptions,
                selectedActionPriorities: actionPriorityOptions.filter(function (p) {
                    return p.ticked;
                }),
                serviceActionPriorityIds: normalized.serviceActionPriorityIds,
                mode: normalized.mode,
                estWorkloadInHours: normalized.estWorkloadInHours,
                totalTicketsAssigned: normalized.totalTicketsAssigned,
                isActive: typeof rule.isActive === 'boolean' ? rule.isActive : true
            };

            return normalized;
        }
    }, {
        key: 'readRuleJsonValue',
        value: function readRuleJsonValue(value) {
            var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (value === undefined) return fallback;
            if (Array.isArray(value)) return value.length ? value[0] : null;
            if (value && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
                if (value.value) return value.value;
                if (value.label) return value.label;
                var firstValue = (0, _values2.default)(value)[0];
                return firstValue !== undefined ? firstValue : null;
            }
            return value;
        }
    }, {
        key: 'buildRuleAssignmentPayload',
        value: function buildRuleAssignmentPayload(rule, indexOrSequence) {
            var sequence = typeof indexOrSequence === 'number' ? indexOrSequence + 1 : undefined;

            var isActive = typeof rule.isActive === 'boolean' ? rule.isActive : typeof (rule.editModel && rule.editModel.isActive) === 'boolean' ? rule.editModel.isActive : false;

            return {
                id: rule.id || undefined,
                assigneeUserId: 'assignee' in rule ? rule.assignee && rule.assignee.Value || null : rule.assigneeUserId || null,
                isActive: isActive,
                sequence: sequence,
                distanceInMiles: rule.distanceInMiles || null,
                locationPriority: rule.locationPriority || null,
                customerIds: rule.selectedCustomers && rule.selectedCustomers.length ? rule.selectedCustomers.map(function (c) {
                    return c.Value;
                }) : null,
                makes: rule.selectedMakes && rule.selectedMakes.length ? rule.selectedMakes.map(function (m) {
                    return m.Value;
                }) : null,
                actionCodes: rule.selectedActionCodes && rule.selectedActionCodes.length ? rule.selectedActionCodes.map(function (a) {
                    return a.Value;
                }) : null,
                serviceActionPriorityIds: rule.selectedActionPriorities && rule.selectedActionPriorities.length ? rule.selectedActionPriorities.map(function (p) {
                    return p.Value;
                }) : null,
                mode: rule.mode || null,
                estWorkloadInHours: rule.estWorkloadInHours || null,
                totalTicketsAssigned: rule.totalTicketsAssigned || null
            };
        }
    }, {
        key: 'applyZoneRuleAssignments',
        value: function applyZoneRuleAssignments(zoneKey) {
            var _this = this;

            var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            this.ensureZoneRuleAssignmentState(zoneKey);
            var zone = this.model.bucketObj[zoneKey];
            zone.ruleAssignments = (rules || []).map(function (rule, index) {
                return _this.normalizeRuleAssignment(rule, index, zoneKey);
            });
        }
    }, {
        key: 'ensureZoneRuleAssignmentState',
        value: function ensureZoneRuleAssignmentState(zoneKey) {
            if (!this.model.bucketObj[zoneKey]) return;

            if (!Array.isArray(this.model.bucketObj[zoneKey].ruleAssignments)) {
                this.model.bucketObj[zoneKey].ruleAssignments = [];
            }

            if (typeof this.model.bucketObj[zoneKey].showRuleAssignments === 'undefined') {
                this.model.bucketObj[zoneKey].showRuleAssignments = false;
            }

            if (!this.model.bucketObj[zoneKey].rulesPagination) {
                this.model.bucketObj[zoneKey].rulesPagination = {
                    pageLimit: 5,
                    total: 0
                };
            }

            if (!Array.isArray(this.model.bucketObj[zoneKey].assigneeOptions)) {
                this.model.bucketObj[zoneKey].assigneeOptions = [];
                this.model.bucketObj[zoneKey].totalAssignees = 0;
            }

            if (!Array.isArray(this.model.bucketObj[zoneKey].customerOptions)) {
                this.model.bucketObj[zoneKey].customerOptions = [];
            }
        }
    }, {
        key: 'getNextPendingSequence',
        value: function getNextPendingSequence(zone) {
            var pendingCount = (zone.ruleAssignments || []).filter(function (r) {
                return !r.id;
            }).length;
            return (zone.rulesPagination ? zone.rulesPagination.total : 0) + pendingCount + 1;
        }
    }, {
        key: 'renumberPendingRules',
        value: function renumberPendingRules(zoneKey) {
            var zone = this.model.bucketObj[zoneKey];
            if (!zone) return;
            var nextSequence = (zone.rulesPagination ? zone.rulesPagination.total : 0) + 1;
            (zone.ruleAssignments || []).forEach(function (rule) {
                if (!rule.id) rule.sequence = nextSequence++;
            });
        }
    }, {
        key: 'syncLoadedRuleSequences',
        value: function syncLoadedRuleSequences(zoneKey) {
            var zone = this.model.bucketObj[zoneKey];
            if (!zone || !zone.rulesPagination) return;
            var total = zone.rulesPagination.total;
            zone.ruleAssignments.forEach(function (rule, index) {
                if (rule.id) rule.sequence = total - index;
            });
        }
    }, {
        key: 'openRuleAssignmentPanel',
        value: function openRuleAssignmentPanel(zoneKey) {
            var _this2 = this;

            this.ensureZoneRuleAssignmentState(zoneKey);
            var zone = this.model.bucketObj[zoneKey];
            zone.showRuleAssignments = true;
            zone.rulesLoading = true;

            _promise2.default.all([this.loadAssignees('', 0, zoneKey), this.loadCustomers(zoneKey)]).then(function () {
                return _this2.refreshZoneRulesFromApi(zoneKey);
            }).then(function () {
                if (!zone.ruleAssignments.length) {
                    _this2.addInlineZoneRuleAssignment(zoneKey);
                }
            }).finally(function () {
                zone.rulesLoading = false;
            });
        }
    }, {
        key: 'hasEditingRuleAssignment',
        value: function hasEditingRuleAssignment(zoneKey) {
            var zone = this.model.bucketObj[zoneKey];
            if (!zone) return false;
            return (zone.ruleAssignments || []).some(function (r) {
                return r.isEditing;
            });
        }
    }, {
        key: 'isZoneRuleDragDisabled',
        value: function isZoneRuleDragDisabled(zoneKey) {
            var zone = this.model.bucketObj[zoneKey];
            if (!zone) return false;
            return (zone.ruleAssignments || []).some(function (r) {
                return !r.id || r.isEditing || r.isSaving;
            });
        }
    }, {
        key: 'hasMoreRules',
        value: function hasMoreRules(zoneKey) {
            var zone = this.model.bucketObj[zoneKey];
            if (!zone || !zone.rulesPagination) return false;
            var loadedSavedCount = (zone.ruleAssignments || []).filter(function (r) {
                return r.id;
            }).length;
            return loadedSavedCount < zone.rulesPagination.total;
        }
    }, {
        key: 'loadMoreRules',
        value: function loadMoreRules(zoneKey) {
            var _this3 = this;

            this.ensureZoneRuleAssignmentState(zoneKey);
            var zone = this.model.bucketObj[zoneKey];
            if (zone.rulesLoading || zone.rulesLoadingMore || !this.hasMoreRules(zoneKey)) return;
            var offset = zone.ruleAssignments.filter(function (r) {
                return r.id;
            }).length;
            zone.rulesLoadingMore = true;

            this.RegionRoutingService.getLocationZoneRules(zone.locationZoneId, zone.rulesPagination.pageLimit, offset).then(function (data) {
                var _zone$ruleAssignments;

                var newRules = (data.results || []).map(function (rule, i) {
                    return _this3.normalizeRuleAssignment(rule, offset + i, zoneKey);
                });
                (_zone$ruleAssignments = zone.ruleAssignments).push.apply(_zone$ruleAssignments, (0, _toConsumableArray3.default)(newRules));
                zone.rulesPagination.total = data.total || zone.rulesPagination.total;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this3.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                zone.rulesLoadingMore = false;
            });
        }
    }, {
        key: 'deleteZoneRuleAssignment',
        value: function deleteZoneRuleAssignment(zoneKey, index) {
            var _this4 = this;

            this.ensureZoneRuleAssignmentState(zoneKey);
            var zone = this.model.bucketObj[zoneKey];
            var rules = zone.ruleAssignments;
            var rule = rules[index];
            if (!rule) return;

            if (!rule.id) {
                rules.splice(index, 1);
                this.renumberPendingRules(zoneKey);
                if (!rules.length) {
                    zone.showRuleAssignments = false;
                }
                return;
            }

            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_delete_title'),
                type: 'danger',
                message: this.$translate.instant('common.confirm_delete_message'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    $scope.loading = true;
                    zone.rulesLoading = true;

                    _this4.RegionRoutingService.deleteLocationZoneRule(zone.locationZoneId, rule.id).then(function () {
                        modal.close();
                        return _this4.refreshZoneRulesFromApi(zoneKey);
                    }).catch(function (err) {
                        $scope.isLoading = false;
                        $scope.loading = false;
                        _this4.refreshZoneRulesFromApi(zoneKey);
                        if (err && err.data && err.data.message) {
                            _this4.Modal.errorModal(err.data.message);
                        }
                    }).finally(function () {
                        zone.rulesLoading = false;
                    });
                }
            });
        }
    }, {
        key: 'toggleZoneRuleAssignments',
        value: function toggleZoneRuleAssignments(zoneKey) {
            this.ensureZoneRuleAssignmentState(zoneKey);
            var zone = this.model.bucketObj[zoneKey];
            if (zone.showRuleAssignments) {
                zone.showRuleAssignments = false;
                this.clearInlineRuleAssignmentDrag();
                return;
            }

            this.openRuleAssignmentPanel(zoneKey);
        }
    }, {
        key: 'updateLocationZoneLocations',
        value: function updateLocationZoneLocations(zoneKey) {
            var _this5 = this;

            var zone = this.model.bucketObj[zoneKey];
            if (!zone || !zone.locationZoneId || zone.syncingZoneLocations) return;

            zone.syncingZoneLocations = true;
            this.RegionRoutingService.syncZoneLocations(zone.locationZoneId).then(function (data) {
                _this5.showBulkAlert('success', 'Location zone updated: ' + data.added + ' location(s) added, ' + data.removed + ' removed, ' + data.total + ' total in zone.');
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this5.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                zone.syncingZoneLocations = false;
            });
        }
    }, {
        key: 'addInlineZoneRuleAssignment',
        value: function addInlineZoneRuleAssignment(zoneKey) {
            this.ensureZoneRuleAssignmentState(zoneKey);
            var zone = this.model.bucketObj[zoneKey];
            var rules = zone.ruleAssignments;
            var newRule = this.normalizeRuleAssignment({ sequence: this.getNextPendingSequence(zone) }, rules.length, zoneKey);
            newRule.isEditing = true;
            newRule.editModel = _.cloneDeep(newRule.editModel);
            rules.push(newRule);
            zone.showRuleAssignments = true;
        }
    }, {
        key: 'startEditZoneRuleAssignment',
        value: function startEditZoneRuleAssignment(zoneKey, index) {
            this.ensureZoneRuleAssignmentState(zoneKey);
            var rule = this.model.bucketObj[zoneKey].ruleAssignments[index];
            if (!rule || rule.isSaving) return;

            var normalized = this.normalizeRuleAssignment(rule, index, zoneKey);
            rule.isEditing = true;
            rule.editModel = normalized.editModel;
        }
    }, {
        key: 'cancelEditZoneRuleAssignment',
        value: function cancelEditZoneRuleAssignment(zoneKey, index) {
            this.ensureZoneRuleAssignmentState(zoneKey);
            var rules = this.model.bucketObj[zoneKey].ruleAssignments;
            var rule = rules[index];
            if (!rule || rule.isSaving) return;

            if (!rule.id) {
                rules.splice(index, 1);
                this.renumberPendingRules(zoneKey);
                if (!rules.length) {
                    this.model.bucketObj[zoneKey].showRuleAssignments = false;
                }
                return;
            }

            rule.isEditing = false;
            var normalized = this.normalizeRuleAssignment(rule, index, zoneKey);
            rule.editModel = normalized.editModel;
        }
    }, {
        key: 'saveZoneRuleAssignment',
        value: function saveZoneRuleAssignment(zoneKey, index) {
            var _this6 = this;

            this.ensureZoneRuleAssignmentState(zoneKey);
            var rules = this.model.bucketObj[zoneKey].ruleAssignments;
            var rule = rules[index];
            if (!rule || !rule.editModel || rule.isSaving) return;

            if (!rule.editModel.assignee) {
                this.Modal.errorModal('Assignee is required.');
                return;
            }

            var payload = this.buildRuleAssignmentPayload(rule.editModel, rule.id ? (rule.sequence || index + 1) - 1 : undefined);
            var locationZoneId = this.model.bucketObj[zoneKey].locationZoneId;
            rule.isSaving = true;

            var request = rule.id ? this.RegionRoutingService.updateLocationZoneRule(locationZoneId, rule.id, payload) : this.RegionRoutingService.createLocationZoneRule(locationZoneId, payload);

            request.then(function () {
                rule.isSaving = false;
                _this6.refreshZoneRulesFromApi(zoneKey, rule); // exclude this rule from pendingRules — it's now saved
            }).catch(function (err) {
                rule.isSaving = false;
                if (err && err.data && err.data.message) {
                    _this6.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'refreshZoneRulesFromApi',
        value: function refreshZoneRulesFromApi(zoneKey) {
            var _this7 = this;

            var excludeRule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            this.ensureZoneRuleAssignmentState(zoneKey);
            var zone = this.model.bucketObj[zoneKey];
            if (!zone || !zone.locationZoneId) return _promise2.default.resolve();

            var pendingRules = (zone.ruleAssignments || []).filter(function (r) {
                return !r.id && r !== excludeRule;
            });
            var existingRules = zone.ruleAssignments || [];

            var loadedCount = Math.max(zone.rulesPagination.pageLimit, existingRules.filter(function (r) {
                return r.id;
            }).length);

            return this.RegionRoutingService.getLocationZoneRules(zone.locationZoneId, loadedCount, 0).then(function (data) {
                var rules = data.results || [];

                rules.forEach(function (rule) {
                    var match = existingRules.find(function (r) {
                        return r.id === rule.id;
                    });
                    if (match && match.isEditing && match !== excludeRule) {
                        rule.isEditing = true;
                        rule.editModel = match.editModel;
                    }
                });

                _this7.applyZoneRuleAssignments(zoneKey, rules);
                zone.rulesPagination.total = data.total || 0;

                if (pendingRules.length) {
                    var _model$bucketObj$zone;

                    (_model$bucketObj$zone = _this7.model.bucketObj[zoneKey].ruleAssignments).push.apply(_model$bucketObj$zone, (0, _toConsumableArray3.default)(pendingRules));
                    _this7.renumberPendingRules(zoneKey);
                }

                zone.savedRuleCount = zone.rulesPagination.total;
                zone.showRuleAssignments = true;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this7.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'startInlineRuleAssignmentDrag',
        value: function startInlineRuleAssignmentDrag(zoneKey, index) {
            this.ruleAssignmentDrag.zoneKey = zoneKey;
            this.ruleAssignmentDrag.dragIndex = index;
            this.ruleAssignmentDrag.dragOverIndex = index;
        }
    }, {
        key: 'setInlineRuleAssignmentDragOver',
        value: function setInlineRuleAssignmentDragOver(zoneKey, index) {
            if (this.ruleAssignmentDrag.zoneKey !== zoneKey || this.ruleAssignmentDrag.dragIndex === null) return;
            this.ruleAssignmentDrag.dragOverIndex = index;
        }
    }, {
        key: 'dropInlineRuleAssignment',
        value: function dropInlineRuleAssignment(zoneKey, index) {
            var fromIndex = this.ruleAssignmentDrag.dragIndex;
            if (this.ruleAssignmentDrag.zoneKey !== zoneKey) {
                this.clearInlineRuleAssignmentDrag();
                return;
            }

            if (fromIndex === null || fromIndex === index) {
                this.clearInlineRuleAssignmentDrag();
                return;
            }

            var rules = this.model.bucketObj[zoneKey].ruleAssignments;

            if (rules.some(function (rule) {
                return !rule.id || rule.isEditing || rule.isSaving;
            })) {
                this.clearInlineRuleAssignmentDrag();
                return;
            }

            var movedRule = rules.splice(fromIndex, 1)[0];
            rules.splice(index, 0, movedRule);
            this.syncLoadedRuleSequences(zoneKey);
            this.clearInlineRuleAssignmentDrag();
            this.persistZoneRuleSequences(zoneKey);
            this.scrollRuleRowIntoView(movedRule);
        }

        // The scrollable rule list only shows a handful of rows at a time, so a row
        // dropped near the top or bottom of the loaded set can easily land outside the
        // visible area. $timeout (rather than acting immediately) waits for the digest
        // that applies the reorder to the DOM before we go looking for the row.

    }, {
        key: 'scrollRuleRowIntoView',
        value: function scrollRuleRowIntoView(rule) {
            var rowId = rule && (rule.id || rule._uid);
            if (!rowId) return;

            this.$timeout(function () {
                var el = document.getElementById('zone-rule-row-' + rowId);
                if (el && typeof el.scrollIntoView === 'function') {
                    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            });
        }
    }, {
        key: 'clearInlineRuleAssignmentDrag',
        value: function clearInlineRuleAssignmentDrag() {
            this.ruleAssignmentDrag = this.getDefaultRuleAssignmentDrag();
        }
    }, {
        key: 'persistZoneRuleSequences',
        value: function persistZoneRuleSequences(zoneKey) {
            var _this8 = this;

            this.ensureZoneRuleAssignmentState(zoneKey);
            var zone = this.model.bucketObj[zoneKey];
            var rules = zone.ruleAssignments || [];

            if (!rules.length) return _promise2.default.resolve();
            if (rules.some(function (rule) {
                return !rule.id || rule.isEditing || rule.isSaving;
            })) return _promise2.default.resolve();

            var locationZoneId = zone.locationZoneId;
            var payload = rules.map(function (rule) {
                return { id: rule.id, sequence: rule.sequence };
            });

            zone.rulesLoading = true;
            return this.RegionRoutingService.reorderLocationZoneRules(locationZoneId, payload).then(function () {
                _this8.refreshZoneRulesFromApi(zoneKey);
            }).catch(function (err) {
                _this8.refreshZoneRulesFromApi(zoneKey);
                if (err && err.data && err.data.message) {
                    _this8.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                zone.rulesLoading = false;
            });
        }
    }, {
        key: 'getAssigneeObject',
        value: function getAssigneeObject(assigneeId) {
            var rule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var zoneKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var zone = zoneKey ? this.model.bucketObj[zoneKey] : null;
            var found = (zone && zone.assigneeOptions || []).find(function (item) {
                return item.Value === assigneeId;
            });
            if (found) return found;

            if (assigneeId) {
                var user = rule.assigneeUser || {};
                return {
                    Value: assigneeId,
                    Key: user.firstName ? assigneeId + ' | ' + user.firstName + ' ' + user.lastName : rule.userName ? assigneeId + ' | ' + rule.userName : rule.userKey || assigneeId
                };
            }
            return null;
        }
    }, {
        key: 'getActionCodeObject',
        value: function getActionCodeObject(actionCodeId) {
            return this.ruleAssignmentConfig.actionCodes.find(function (item) {
                return item.Value === actionCodeId;
            }) || null;
        }
    }, {
        key: 'getMakeObject',
        value: function getMakeObject(makeId) {
            return this.ruleAssignmentConfig.makes.find(function (item) {
                return item.Value === makeId;
            }) || null;
        }
    }, {
        key: 'loadRuleAssignmentOptions',
        value: function loadRuleAssignmentOptions() {
            var _this9 = this;

            return _promise2.default.all([this.AtmMakesService.all('', 0, 1000), this.ServiceActionPrioritiesService.all(null, 0, 1000), this.ActionCodeService.all('', 0, 1000)]).then(function (_ref2) {
                var _ref3 = (0, _slicedToArray3.default)(_ref2, 3),
                    atmMakeData = _ref3[0],
                    priorityData = _ref3[1],
                    actionCodesData = _ref3[2];

                _this9.ruleAssignmentConfig.makes = (atmMakeData.results || []).filter(function (item) {
                    return item.active;
                }).map(function (item) {
                    return {
                        Value: item.vendorName,
                        Key: item.vendorName
                    };
                });
                _this9.ruleAssignmentConfig.totalMakes = atmMakeData.totalRecords || _this9.ruleAssignmentConfig.makes.length;

                _this9.ruleAssignmentConfig.actionCodes = (actionCodesData.results || []).map(function (code) {
                    return {
                        Value: code.id,
                        Key: code.code + ' | ' + code.label
                    };
                });

                _this9.ruleAssignmentConfig.actionPriorities = (priorityData.results || []).filter(function (item) {
                    return item.active;
                }).map(function (item) {
                    return { Value: item.id, Key: item.priority };
                });
            }).catch(function (err) {
                console.log(err);
                _this9.ruleAssignmentConfig.makes = [];
                _this9.ruleAssignmentConfig.actionCodes = [];
                _this9.ruleAssignmentConfig.actionPriorities = [];
            });
        }
    }, {
        key: 'loadAssignees',
        value: function loadAssignees(searchKey, offset, zoneKey) {
            searchKey = searchKey || '';
            this.ensureZoneRuleAssignmentState(zoneKey);
            var zone = this.model.bucketObj[zoneKey];
            if (!zone || !zone.locationZoneId) return _promise2.default.resolve();

            return this.RegionRoutingService.getAssignableUsersForZone(zone.locationZoneId, searchKey, 10, offset).then(function (data) {
                var mapped = (data.results || []).map(function (user) {
                    return {
                        Value: user.id,
                        Key: user.id + " | " + user.firstName + " " + user.lastName
                    };
                });

                if (offset === 0 || offset == undefined) {
                    zone.totalAssignees = data.total;
                    zone.assigneeOptions = mapped;
                } else {
                    zone.assigneeOptions = (zone.assigneeOptions || []).concat(mapped);
                }
            });
        }
    }, {
        key: 'loadCustomers',
        value: function loadCustomers(zoneKey) {
            this.ensureZoneRuleAssignmentState(zoneKey);
            var zone = this.model.bucketObj[zoneKey];
            if (!zone || !zone.locationZoneId) return _promise2.default.resolve();

            return this.RegionRoutingService.getAssignableCustomersForZone(zone.locationZoneId, '', 1000, 0).then(function (data) {
                zone.customerOptions = (data.results || []).map(function (customer) {
                    return {
                        Value: customer.id,
                        Key: customer.id + ' | ' + customer.name
                    };
                });
            });
        }
    }, {
        key: 'showBulkAlert',
        value: function showBulkAlert(type, message) {
            var _this10 = this;

            this.bulkSaveAlert = {
                show: true,
                type: type,
                message: this.$sce.trustAsHtml(message)
            };

            // Auto-hide success alerts after 5 seconds
            if (type === 'success') {
                setTimeout(function () {
                    _this10.$scope.$apply(function () {
                        _this10.closeBulkAlert();
                    });
                }, 5000);
            }
        }
    }, {
        key: 'closeBulkAlert',
        value: function closeBulkAlert() {
            this.bulkSaveAlert.show = false;
            this.bulkSaveAlert.message = '';
        }
    }, {
        key: 'saveForAllDays',
        value: function saveForAllDays() {
            var _this11 = this;

            if (!this.bulkZones.length) {
                this.showBulkAlert('error', "No changes to save for all days.");
                return;
            }

            this.savingAll = true;
            this.closeBulkAlert(); // Hide any existing alerts

            var payload = {
                loggedInUser: this.model.loggedInUser,
                branch: this.model.branch,
                zones: this.bulkZones,
                daysToExclude: [this.model.selectedDay]
            };

            this.RegionRoutingService.bulkAllDaySaveLocationZones(payload).then(function (response) {
                var results = response.results || {};
                var msg = "";

                // Success summary
                if (results.created && results.created.length) {
                    msg += '<strong>Created:</strong> ' + results.created.map(function (z) {
                        return z.zone + ' (' + z.successfulDays + '/' + z.totalDays + ' days)';
                    }).join(", ") + '.<br>';
                }
                if (results.updated && results.updated.length) {
                    msg += '<strong>Updated:</strong> ' + results.updated.map(function (z) {
                        return z.zone + ' (' + z.successfulDays + '/' + z.totalDays + ' days)';
                    }).join(", ") + '.<br>';
                }
                if (results.deleted && results.deleted.length) {
                    msg += '<strong>Deleted:</strong> ' + results.deleted.map(function (z) {
                        return (z.zone || z.name) + ' (' + z.successfulDays + '/' + z.totalDays + ' days)';
                    }).join(", ") + '.<br>';
                }

                // Show success or error based on whether there were errors
                if (results.errors && results.errors.length) {
                    msg += "<strong>Errors:</strong><br>" + results.errors.map(function (e) {
                        return e.action.toUpperCase() + ' ' + e.zone + (e.day ? " (" + e.day + ")" : "") + ': ' + e.error;
                    }).join("<br>");
                    _this11.showBulkAlert('error', msg);
                } else {
                    _this11.showBulkAlert('success', msg || "Zones saved for all days successfully!");
                }

                _this11.bulkZones = [];
            }).catch(function () {
                _this11.showBulkAlert('error', "Failed to save zones for all days");
            }).finally(function () {
                _this11.savingAll = false;
                _this11.dayChanged();
                _this11.getLocationZoneCount();
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this12 = this;

            this.model.selectedDay = 'MONDAY';
            _promise2.default.all([this.SetupService.get(this.model.branch), this.loadRuleAssignmentOptions()]).then(function (_ref4) {
                var _ref5 = (0, _slicedToArray3.default)(_ref4, 1),
                    data = _ref5[0];

                _this12.loadMap();
                _this12.branchDetails(data);
                _this12.dayChanged();
                _this12.getLocationZoneCount();
            }).catch(function (err) {
                _this12.Modal.errorModal('error.' + err.data.message);
            });
        }
    }, {
        key: 'selectDay',
        value: function selectDay(day) {
            this.model.selectedDay = day.value;
            this.dayChanged();
            this.bulkZones = [];
            this.closeBulkAlert();
        }
    }, {
        key: 'loadMap',
        value: function loadMap() {
            var _this13 = this;

            this.map = L.map('map', {
                center: [39.3684121, -76.7991077],
                zoom: 8,
                editable: true
            });

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(this.map);

            // L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
            //     // attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
            //     // maxZoom: 19
            // }).addTo(this.map);

            // L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
            //     // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            //     subdomains: 'abcd',
            //     maxZoom: 19
            // }).addTo(this.map);

            this.editableLayers = new L.FeatureGroup();
            this.map.addLayer(this.editableLayers);

            // const MyCustomMarker = L.Icon.extend({
            //     options: {
            //         shadowUrl: null,
            //         iconAnchor: new L.Point(12, 12),
            //         iconSize: new L.Point(24, 24),
            //         iconUrl: '../client/app/assets/images/marker-icon.png'
            //     }
            // });

            var options = {
                position: 'topleft',
                draw: {
                    polyline: {
                        shapeOptions: {
                            // color: '#013220',
                            weight: 3
                        }
                    },
                    polygon: {
                        allowIntersection: false, // Restricts shapes to simple polygons
                        drawError: {
                            // color: '#e1e100', // Color the shape will turn when intersects
                            message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
                        },
                        shapeOptions: {
                            // color: '#bada55'
                        }
                    },
                    circle: false,
                    rectangle: {
                        shapeOptions: {
                            clickable: true
                        }
                    },
                    marker: false,
                    circlemarker: false
                    // marker: {
                    //     icon: new MyCustomMarker()
                    // }
                },
                edit: {
                    featureGroup: this.editableLayers, //REQUIRED!!
                    remove: true
                }
            };

            L.EditToolbar.Delete.include({ // remove "CLEAR ALL" button from toolbar 
                removeAllLayers: false
            });

            var drawControl = new L.Control.Draw(options);

            this.map.addControl(drawControl);

            this.map.on(L.Draw.Event.CREATED, function (e) {
                var type = e.layerType,
                    layer = e.layer;

                if (type === 'marker') {
                    layer.bindPopup('A popup!');
                }

                _this13.editableLayers.addLayer(layer);

                var content = document.createElement("input");
                content.setAttribute("type", "text");

                var feature = _this13.editableLayers.feature = _this13.editableLayers.feature || {};
                feature.type = "Feature";
                feature.properties = feature.properties || {};
                feature.properties[type] = {};

                content.addEventListener('keyup', function (event) {
                    feature.properties[type]['name'] = content.value;

                    // console.log('event.key, inserted_row.length = ', this.previousTitle, event.key);
                    // console.log('this.model.regionsObj = ', this.model.regionsObj);
                    // console.log('this.model.bucketObj = ', this.model.bucketObj);
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        layer.closePopup();

                        _this13.model.regionsObj[feature.properties[type]['name']] = {
                            latDetails: {},
                            longDetails: {}
                        };

                        _this13.model.bucketObj[feature.properties[type]['name']] = {
                            pagination: {
                                page: 1,
                                total: 0,
                                pageLimit: 10,
                                maxPages: 10
                            },
                            gettingBranch: false,
                            searchText: null,
                            process: true,
                            type: type,
                            zone: feature.properties[type]['name'],
                            ruleAssignments: [],
                            showRuleAssignments: false
                        };

                        if (type === 'rectangle' || type === 'polyline' || type === 'polygon') {
                            var latLong = layer.getLatLngs();
                            var minMaxLat = _this13.findMinMaxLat(type !== 'polyline' ? latLong[0] : latLong);
                            var minMaxLong = _this13.findMinMaxLong(type !== 'polyline' ? latLong[0] : latLong);

                            _this13.model.regionsObj[feature.properties[type]['name']].latDetails.min = minMaxLat.lowest;
                            _this13.model.regionsObj[feature.properties[type]['name']].latDetails.max = minMaxLat.highest;
                            _this13.model.regionsObj[feature.properties[type]['name']].longDetails.min = minMaxLong.lowest;
                            _this13.model.regionsObj[feature.properties[type]['name']].longDetails.max = minMaxLong.highest;
                            // console.log('>>>>> ENTER >', this.model, feature.properties[type]);
                            _this13.createLocationZone(feature.properties[type]['name'], layer, type, type !== 'polyline' ? latLong : new Array(latLong));
                        }
                    } /* else if (event.key === 'Enter') {
                        event.preventDefault();
                        layer.closePopup();
                        this.$scope.$apply(() => {
                            let latLong = layer.getLatLngs();
                            let minMaxLat = this.findMinMaxLat(type !== 'polyline' ? latLong[0] : latLong);
                            let minMaxLong = this.findMinMaxLong(type !== 'polyline' ? latLong[0] : latLong);
                            this.model.regionsObj[feature.properties[type]['name']].latDetails.min = minMaxLat.lowest;
                            this.model.regionsObj[feature.properties[type]['name']].latDetails.max = minMaxLat.highest;
                            this.model.regionsObj[feature.properties[type]['name']].longDetails.min = minMaxLong.lowest;
                            this.model.regionsObj[feature.properties[type]['name']].longDetails.max = minMaxLong.highest;
                            this.model.bucketObj[feature.properties[type]['name']].pagination.page = 1;
                            this.updateLocationZone(feature.properties[type]['name'], layer);
                        });
                      } */
                });

                layer.on('popupclose', function (e) {
                    if (!feature.properties[type]['name']) return;
                    layer.bindTooltip(feature.properties[type]['name'], {
                        permanent: true,
                        direction: 'top'
                    });

                    _this13.$scope.$apply(function () {
                        if (_this13.model.bucketObj.hasOwnProperty(_this13.previousTitle) && _this13.model.regionsObj.hasOwnProperty(_this13.previousTitle) && _this13.previousTitle !== feature.properties[type]['name']) {
                            _this13.model.bucketObj[feature.properties[type]['name']] = _this13.model.bucketObj[_this13.previousTitle];
                            _this13.model.regionsObj[feature.properties[type]['name']] = _this13.model.regionsObj[_this13.previousTitle];
                            _this13.model.bucketObj[feature.properties[type]['name']].details.title = feature.properties[type]['name'];
                            delete _this13.model.regionsObj[_this13.previousTitle];
                            delete _this13.model.bucketObj[_this13.previousTitle];
                        }
                    });
                });

                layer.on('popupopen', function () {
                    layer.closeTooltip();
                    _this13.previousTitle = _.cloneDeep(feature.properties[type]['name']);
                    feature.properties[type]['name'] = content.value;
                    content.focus();
                });

                // layer.on('move', () => { // TODO: better solution for this
                //     console.log('Test', this.model.regionsObj)
                // })


                setTimeout(function () {
                    layer.bindPopup(content).openPopup();
                }, 100);
            });

            this.map.on(L.Draw.Event.EDITED, function (e) {
                var layers = e.layers;
                layers.eachLayer(function (layer) {
                    var shape = void 0,
                        title = void 0;
                    if (layer instanceof L.Rectangle) shape = 'rectangle';else if (layer instanceof L.Polygon) shape = 'polygon';else if (layer instanceof L.Polyline) shape = 'polyline';

                    if (layer._popup && layer._popup._content) {
                        title = layer._popup._content;
                        _this13.model.regionsObj[title] = {
                            latDetails: {},
                            longDetails: {}
                        };

                        var latLong = layer.getLatLngs();
                        var originalLatLong = _this13.model.bucketObj[title].actualLatLong;
                        var minMaxLat = _this13.findMinMaxLat(shape !== 'polyline' ? latLong[0] : latLong);
                        var minMaxLong = _this13.findMinMaxLong(shape !== 'polyline' ? latLong[0] : latLong);
                        _this13.model.regionsObj[title].latDetails.min = minMaxLat.lowest;
                        _this13.model.regionsObj[title].latDetails.max = minMaxLat.highest;
                        _this13.model.regionsObj[title].longDetails.min = minMaxLong.lowest;
                        _this13.model.regionsObj[title].longDetails.max = minMaxLong.highest;
                        _this13.updateLocationZone(title, layer, shape, shape !== 'polyline' ? latLong : new Array(latLong), originalLatLong);
                    }
                });
            });

            this.map.on(L.Draw.Event.DELETED, function (e) {
                var layers = e.layers;
                layers.eachLayer(function (layer) {
                    var title = void 0;
                    // let popup = layer.getPopup();
                    // console.log("popup", popup)
                    // layer.unbindPopup().bindPopup(popup);
                    if (layer._tooltip && layer._tooltip._content) {
                        title = layer._tooltip._content;
                        _this13.deleteLocationZone(title);
                    } else if (layer._popup && layer._popup._content) {
                        title = layer._popup._content;
                        _this13.deleteLocationZone(title);
                    }
                });
            });
        }
    }, {
        key: 'branchDetails',
        value: function branchDetails(data) {
            this.map.setView([data.gpsLat, data.gpsLong], 11);

            var locationInfo = '<strong>' + data.branchId + '</strong>' + '<br>' + data.address + ' - ' + data.zip + '<br>' + data.city + ', ' + data.state;

            var marker = L.marker([data.gpsLat, data.gpsLong], {
                icon: new L.AwesomeNumberMarkers({
                    number: 'B',
                    markerColor: 'black'
                })
            }).addTo(this.map).bindPopup(locationInfo);

            marker.on('mouseover', function () {
                marker.openPopup();
            });

            marker.on('mouseout', function () {
                marker.closePopup();
            });
        }
    }, {
        key: 'updateLocationZone',
        value: function updateLocationZone(title, layer, shape, latLong, originalLatLong) {
            var _this14 = this;

            this.model.bucketObj[title].process = true;

            // console.log('updateLocationZone = ', this.model.bucketObj[title].details.inserted_row[0].id);

            this.RegionRoutingService.updateLocationZone(this.model.loggedInUser, this.model.branch, title,
            // this.model.bucketObj[title].details.inserted_row ? this.model.bucketObj[title].details.inserted_row[0].id : null,
            this.model.bucketObj[title].locationZoneId,
            // this.model.bucketObj[title].type, 
            this.model.regionsObj[title].latDetails, this.model.regionsObj[title].longDetails, this.model.selectedDay, shape, latLong, this.model.bucketObj[title].pagination.pageLimit, (this.model.bucketObj[title].pagination.page - 1) * this.model.bucketObj[title].pagination.pageLimit).then(function (data) {
                _this14.bulkZones.push({
                    action: 'update',
                    id: _this14.model.bucketObj[title].locationZoneId,
                    title: title,
                    latDetails: _this14.model.regionsObj[title].latDetails,
                    longDetails: _this14.model.regionsObj[title].longDetails,
                    shape: shape,
                    locationData: latLong
                });
                _this14.closeBulkAlert();
                _this14.model.bucketObj[title].details = data;
                _this14.dayChanged();
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this14.Modal.errorModal(err.data.message);
                    _this14.model.bucketObj[title].process = false;
                    // this.model.bucketObj = {};
                    // this.model.regionsObj = {};
                    // this.map.removeLayer(layer);
                    layer.setLatLngs(originalLatLong);
                }
            }).finally(function () {
                if (_this14.model.bucketObj[title] && _this14.model.bucketObj[title].process) _this14.model.bucketObj[title].process = false;
            });
        }
    }, {
        key: 'createLocationZone',
        value: function createLocationZone(title, layer, type, latLong) {
            var _this15 = this;

            this.model.bucketObj[title].process = true;
            this.model.bucketObj[title].getLocations = true;

            // this.model.bucketObj[title].type

            this.RegionRoutingService.createLocationZone(this.model.loggedInUser, this.model.branch, title,
            // this.model.bucketObj[title].type, 
            this.model.regionsObj[title].latDetails, this.model.regionsObj[title].longDetails, this.model.selectedDay, type, latLong, this.model.bucketObj[title].pagination.pageLimit, (this.model.bucketObj[title].pagination.page - 1) * this.model.bucketObj[title].pagination.pageLimit).then(function (data) {
                _this15.bulkZones.push({
                    action: 'create',
                    title: title,
                    latDetails: _this15.model.regionsObj[title].latDetails,
                    longDetails: _this15.model.regionsObj[title].longDetails,
                    shape: type,
                    locationData: latLong
                });
                _this15.closeBulkAlert();
                _this15.model.bucketObj[title].details = data;
                _this15.model.bucketObj[title].zone = title;
                data.inserted_row.forEach(function (d) {
                    _this15.model.bucketObj[title].locationZoneId = d.id;
                });
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this15.Modal.errorModal(err.data.message);
                    _this15.model.bucketObj[title].process = false;
                    _this15.model.bucketObj[title].getLocations = false;
                    // this.model.bucketObj = {};
                    // this.model.regionsObj = {};
                    _this15.map.removeLayer(layer);
                    // delete this.model.bucketObj[title];
                }
            }).finally(function () {
                _this15.dayChanged();
                if (_this15.model.bucketObj[title] && _this15.model.bucketObj[title].process) {
                    _this15.model.bucketObj[title].process = false;
                    _this15.model.bucketObj[title].getLocations = false;
                }
            });
        }
    }, {
        key: 'getLocations',
        value: function getLocations(title) {
            var _this16 = this;

            this.model.bucketObj[title].process = true;
            var searchText = this.model.bucketObj[title].searchText;

            this.RegionRoutingService.getLocations(title, this.model.regionsObj[title].latDetails, this.model.regionsObj[title].longDetails, this.model.branch, searchText, this.model.bucketObj[title].pagination.pageLimit, (this.model.bucketObj[title].pagination.page - 1) * this.model.bucketObj[title].pagination.pageLimit, this.model.bucketObj[title].actualLatLong).then(function (data) {
                _this16.model.bucketObj[title].details = data;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this16.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this16.model.bucketObj[title].process = false;
            });
        }
    }, {
        key: 'search',
        value: function search(title) {
            this.model.bucketObj[title].pagination.page = 1;
            this.getLocations(title);
        }
    }, {
        key: 'findMinMaxLat',
        value: function findMinMaxLat(array) {
            // TODO: better solution for this
            if (array.length === 0) {
                return { lowest: null, highest: null };
            }

            var lowest = Number.POSITIVE_INFINITY;
            var highest = Number.NEGATIVE_INFINITY;

            array.forEach(function (coord) {
                if (coord.lat < lowest) {
                    lowest = coord.lat;
                }
                if (coord.lat > highest) {
                    highest = coord.lat;
                }
            });
            return { lowest: lowest, highest: highest };
        }
    }, {
        key: 'findMinMaxLong',
        value: function findMinMaxLong(array) {
            // TODO: better solution for this
            if (array.length === 0) {
                return { lowest: null, highest: null };
            }

            var lowest = Number.POSITIVE_INFINITY;
            var highest = Number.NEGATIVE_INFINITY;

            array.forEach(function (coord) {
                if (coord.lng < lowest) {
                    lowest = coord.lng;
                }
                if (coord.lng > highest) {
                    highest = coord.lng;
                }
            });

            return { lowest: lowest, highest: highest };
        }

        // findMinMaxLong(array) { // TODO: better solution for this
        //     let lowest = Number.NEGATIVE_INFINITY;
        //     let highest;
        //     for (let i = array.length - 1; i >= 0; i--) {
        //         let tmp = array[i].lng;
        //         if (tmp > lowest) highest = tmp;
        //     }
        //     lowest = _.min(array, 'lng');
        //     return { lowest: highest, highest: lowest.lng };
        // }

    }, {
        key: 'dayChanged',
        value: function dayChanged() {
            var _this17 = this;

            if (!this.model.selectedDay) return;
            this.loadinglocationZone = true;
            this.model.bucketObj = {};
            this.RegionRoutingService.getDayWiseLocationZone(this.model.branch, this.model.selectedDay).then(function (data) {
                _this17.results = data.locationZoneResult;
                _this17.editableLayers.clearLayers(); // Clear existing layers

                data.locationZoneResult.forEach(function (obj) {
                    _this17.model.bucketObj[obj.name] = {
                        pagination: {
                            page: 1,
                            total: 0,
                            pageLimit: 10,
                            maxPages: 10
                        },
                        gettingBranch: false,
                        searchText: null,
                        process: false,
                        type: obj.shape,
                        details: {
                            results: obj.locationDetails,
                            total: obj.totalLocationRecords
                        },
                        locationZoneId: obj.id,
                        zone: obj.name,
                        actualLatLong: obj.locationData[obj.name].latLong,
                        ruleAssignments: [],
                        savedRuleCount: (obj.rules || []).length,
                        showRuleAssignments: false
                    };

                    _this17.model.regionsObj[obj.name] = {
                        latDetails: {
                            min: obj.latMin,
                            max: obj.latMax

                        },
                        longDetails: {
                            min: obj.lonMin,
                            max: obj.lonMax
                        }
                    };

                    var layer = void 0,
                        latLngs = void 0;
                    if (obj.shape === null) return;else if (obj.shape === 'rectangle') {
                        latLngs = obj.locationData[obj.name].latLong;
                        layer = L.rectangle(latLngs).addTo(_this17.editableLayers);
                        layer.bindPopup(obj.name, { autoClose: false }).openPopup();
                    } else if (obj.shape === 'polygon') {
                        latLngs = obj.locationData[obj.name].latLong;
                        layer = L.polygon(latLngs).addTo(_this17.editableLayers);
                        layer.bindPopup(obj.name, { autoClose: false }).openPopup();
                    } else if (obj.shape === 'polyline') {
                        latLngs = obj.locationData[obj.name].latLong;
                        layer = L.polyline(latLngs).addTo(_this17.editableLayers);
                        layer.bindPopup(obj.name, { autoClose: false }).openPopup();
                    }
                });

                _this17.locationZoneCountObj[_this17.model.selectedDay] = { totalRecords: data.totalCount };
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this17.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this17.loadinglocationZone = false;
            });
        }
    }, {
        key: 'deleteLocationZone',
        value: function deleteLocationZone(title) {
            var _this18 = this;

            this.deletingServiceZone = true;
            this.RegionRoutingService.deleteLocationZone(this.model.bucketObj[title].locationZoneId, title, this.model.branch).then(function () {
                _this18.dayChanged();
                _this18.bulkZones.push({
                    action: 'delete',
                    name: title,
                    branchId: _this18.model.branch
                });
                _this18.closeBulkAlert();
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this18.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this18.deletingServiceZone = false;
            });
        }
    }, {
        key: 'getLocationZoneCount',
        value: function getLocationZoneCount() {
            var _this19 = this;

            this.countLocationZone = true;
            this.locationZoneCountObj = {};
            this.RegionRoutingService.getLocationZoneCount(this.model.branch).then(function (data) {
                data.locationZoneResult.forEach(function (obj) {
                    _this19.locationZoneCountObj[obj.dayOfWeek] = { totalRecords: obj.count };
                });
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this19.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this19.countLocationZone = false;
            });
        }
    }]);
    return DeliveryRegionRoutingCreateController;
}();

;

exports.default = DeliveryRegionRoutingCreateController;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_region_routingCreate = __webpack_require__(1862);

var _delivery_region_routingCreate2 = _interopRequireDefault(_delivery_region_routingCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTO_SCROLL_EDGE = 40;
var AUTO_SCROLL_STEP = 14;

function startAutoScroll(container, direction) {
    if (container._ruleAutoScrollDirection === direction) return;
    stopAutoScroll(container);
    container._ruleAutoScrollDirection = direction;
    container._ruleAutoScrollInterval = setInterval(function () {
        container.scrollTop += direction * AUTO_SCROLL_STEP;
    }, 16);
}

function stopAutoScroll(container) {
    if (container._ruleAutoScrollInterval) {
        clearInterval(container._ruleAutoScrollInterval);
        container._ruleAutoScrollInterval = null;
        container._ruleAutoScrollDirection = null;
    }
}

function ruleAssignmentDraggableDirective() {
    return {
        restrict: 'A',
        scope: {
            onDragStart: '&',
            onDragOver: '&',
            onDrop: '&',
            onDragEnd: '&',
            dragDisabled: '<?'
        },
        link: function link(scope, element) {
            var node = element[0];
            var syncDraggableState = function syncDraggableState() {
                node.setAttribute('draggable', scope.dragDisabled ? 'false' : 'true');
            };

            syncDraggableState();
            scope.$watch('dragDisabled', syncDraggableState);

            var handleDragStart = function handleDragStart(event) {
                if (scope.dragDisabled) {
                    event.preventDefault();
                    return;
                }
                if (event.dataTransfer) {
                    event.dataTransfer.effectAllowed = 'move';
                    try {
                        event.dataTransfer.setData('text/plain', 'rule-assignment');
                    } catch (e) {}
                }
                scope.$applyAsync(function () {
                    return scope.onDragStart({ $event: event });
                });
            };

            var handleDragOver = function handleDragOver(event) {
                if (scope.dragDisabled) return;
                event.preventDefault();
                if (event.dataTransfer) {
                    event.dataTransfer.dropEffect = 'move';
                }

                var scrollContainer = node.closest('.zone-rule-rows-scroll');
                if (scrollContainer) {
                    var rect = scrollContainer.getBoundingClientRect();
                    if (event.clientY - rect.top < AUTO_SCROLL_EDGE) {
                        startAutoScroll(scrollContainer, -1);
                    } else if (rect.bottom - event.clientY < AUTO_SCROLL_EDGE) {
                        startAutoScroll(scrollContainer, 1);
                    } else {
                        stopAutoScroll(scrollContainer);
                    }
                }

                scope.$applyAsync(function () {
                    return scope.onDragOver({ $event: event });
                });
            };

            var handleDrop = function handleDrop(event) {
                var scrollContainer = node.closest('.zone-rule-rows-scroll');
                if (scrollContainer) stopAutoScroll(scrollContainer);

                if (scope.dragDisabled) return;
                event.preventDefault();
                scope.$applyAsync(function () {
                    return scope.onDrop({ $event: event });
                });
            };

            var handleDragEnd = function handleDragEnd(event) {
                var scrollContainer = node.closest('.zone-rule-rows-scroll');
                if (scrollContainer) stopAutoScroll(scrollContainer);

                scope.$applyAsync(function () {
                    return scope.onDragEnd({ $event: event });
                });
            };

            node.addEventListener('dragstart', handleDragStart);
            node.addEventListener('dragover', handleDragOver);
            node.addEventListener('drop', handleDrop);
            node.addEventListener('dragend', handleDragEnd);

            scope.$on('$destroy', function () {
                node.removeEventListener('dragstart', handleDragStart);
                node.removeEventListener('dragover', handleDragOver);
                node.removeEventListener('drop', handleDrop);
                node.removeEventListener('dragend', handleDragEnd);

                var scrollContainer = node.closest('.zone-rule-rows-scroll');
                if (scrollContainer) stopAutoScroll(scrollContainer);
            });
        }
    };
}

function ruleAssignmentLoadMoreSentinelDirective() {
    return {
        restrict: 'A',
        scope: {
            onLoadMore: '&',
            scrollDisabled: '<?'
        },
        link: function link(scope, element) {
            var node = element[0];
            var scrollRoot = node.closest('.zone-rule-rows-scroll') || null;
            var observer = null;

            var disconnect = function disconnect() {
                if (observer) {
                    observer.disconnect();
                    observer = null;
                }
            };

            var connect = function connect() {
                if (observer || scope.scrollDisabled) return;
                observer = new IntersectionObserver(function (entries) {
                    if (entries.some(function (entry) {
                        return entry.isIntersecting;
                    })) {
                        scope.$applyAsync(function () {
                            return scope.onLoadMore();
                        });
                    }
                }, { root: scrollRoot, rootMargin: '100px' });
                observer.observe(node);
            };

            scope.$watch('scrollDisabled', function (disabled) {
                if (disabled) disconnect();else connect();
            });

            scope.$on('$destroy', disconnect);
        }
    };
}

var DeliveryRegionRoutingCreateModule = angular.module('deliveryRegionRoutingCreate', []).directive('ruleAssignmentDraggable', ruleAssignmentDraggableDirective).directive('ruleAssignmentLoadMoreSentinel', ruleAssignmentLoadMoreSentinelDirective).component('deliveryRegionRoutingCreate', _delivery_region_routingCreate2.default).name;

exports.default = DeliveryRegionRoutingCreateModule;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_region_routing = __webpack_require__(2721);

var _delivery_region_routing2 = _interopRequireDefault(_delivery_region_routing);

var _delivery_region_routing3 = __webpack_require__(1866);

var _delivery_region_routing4 = _interopRequireDefault(_delivery_region_routing3);

__webpack_require__(3003);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deliveryRegionRoutingComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _delivery_region_routing2.default,
    controller: _delivery_region_routing4.default
};

exports.default = deliveryRegionRoutingComponent;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryRegionRoutingController = function (_SettingBase) {
    DeliveryRegionRoutingController.$inject = ["$state"];
    (0, _inherits3.default)(DeliveryRegionRoutingController, _SettingBase);

    /*@ngInject*/
    function DeliveryRegionRoutingController($state) {
        (0, _classCallCheck3.default)(this, DeliveryRegionRoutingController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DeliveryRegionRoutingController.__proto__ || (0, _getPrototypeOf2.default)(DeliveryRegionRoutingController)).call(this));

        _this.acl = {};
        _this.hasACL = {};
        _this.id = 'delivery-region-routing';
        _this.$state = $state;
        return _this;
    }

    (0, _createClass3.default)(DeliveryRegionRoutingController, [{
        key: '$onInit',
        value: function $onInit() {
            (0, _get3.default)(DeliveryRegionRoutingController.prototype.__proto__ || (0, _getPrototypeOf2.default)(DeliveryRegionRoutingController.prototype), '$onInit', this).call(this);
            for (var key in this.acl['setting-delivery-region-routing']) {
                this.hasACL[this.acl['setting-delivery-region-routing'][key]] = true;
            }
        }
    }]);
    return DeliveryRegionRoutingController;
}(_SettingBase3.default);

exports.default = DeliveryRegionRoutingController;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_region_routingEdit = __webpack_require__(2722);

var _delivery_region_routingEdit2 = _interopRequireDefault(_delivery_region_routingEdit);

var _delivery_region_routingEdit3 = __webpack_require__(1868);

var _delivery_region_routingEdit4 = _interopRequireDefault(_delivery_region_routingEdit3);

__webpack_require__(3004);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deliveryRegionRoutingEditComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template: _delivery_region_routingEdit2.default,
    controller: _delivery_region_routingEdit4.default
};

exports.default = deliveryRegionRoutingEditComponent;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryRegionRoutingEditController = function () {
    /*@ngInject*/

    DeliveryRegionRoutingEditController.$inject = ["User", "$state"];
    function DeliveryRegionRoutingEditController(User, $state) {
        (0, _classCallCheck3.default)(this, DeliveryRegionRoutingEditController);

        this.User = User;
        this.$state = $state;
        this.hasAcl = {};
        this.model = {
            branch: User.getUser().branchId
        };
    }

    (0, _createClass3.default)(DeliveryRegionRoutingEditController, [{
        key: '$onInit',
        value: function $onInit() {
            console.log('Edit');
        }
    }]);
    return DeliveryRegionRoutingEditController;
}();

;

exports.default = DeliveryRegionRoutingEditController;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_region_routingEdit = __webpack_require__(1867);

var _delivery_region_routingEdit2 = _interopRequireDefault(_delivery_region_routingEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryRegionRoutingEditModule = angular.module('deliveryRegionRoutingEdit', []).component('deliveryRegionRoutingEdit', _delivery_region_routingEdit2.default).name;

exports.default = DeliveryRegionRoutingEditModule;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_region_routing = __webpack_require__(1865);

var _delivery_region_routing2 = _interopRequireDefault(_delivery_region_routing);

var _all = __webpack_require__(1861);

var _all2 = _interopRequireDefault(_all);

var _create = __webpack_require__(1864);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(1869);

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryRegionRoutingModule = angular.module('deliveryRegionRouting', [_create2.default, _all2.default, _edit2.default]).component('deliveryRegionRouting', _delivery_region_routing2.default).config(["$stateProvider", function ($stateProvider) {
    "ngInject";

    $stateProvider.state('delivery-region-routing.create', {
        url: '/create',
        component: 'deliveryRegionRoutingCreate',
        data: {
            requireACL: 'setting-delivery-region-routing.create'
        }
    }).state('delivery-region-routing.all', {
        url: '/all/:page',
        component: 'deliveryRegionRoutingAll',
        data: {
            requireACL: 'setting-delivery-region-routing.view'
        }
    }).state('delivery-region-routing.edit/:id', {
        url: '/edit/:id',
        component: 'deliveryRegionRoutingCreate',
        data: {
            requireACL: 'setting-delivery-region-routing.edit'
        }
    });
}]).name;

exports.default = DeliveryRegionRoutingModule;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deposit_packing = __webpack_require__(2723);

var _deposit_packing2 = _interopRequireDefault(_deposit_packing);

var _deposit_packing3 = __webpack_require__(1872);

var _deposit_packing4 = _interopRequireDefault(_deposit_packing3);

__webpack_require__(3005);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var depositPackingComponent = {
    restrict: 'E',
    template: _deposit_packing2.default,
    controller: _deposit_packing4.default
};

exports.default = depositPackingComponent;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _from = __webpack_require__(75);

var _from2 = _interopRequireDefault(_from);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DepositPackingController = function () {

    /*@ngInject*/
    DepositPackingController.$inject = ["$state", "$q", "$rootScope", "$scope", "$window", "BranchFundingSourceService", "Modal", "User", "CurrencyService", "SetupService", "DateUtil", "CarrierService", "AtmResidualDepositService", "AtmResidualService", "$location", "DenominationService", "$translate", "BulkCashService", "Sound", "Navigation", "DataCounter", "UserBranchFundingSourceService", "RouteService", "LocationDeliveryService", "LocationService"];
    function DepositPackingController($state, $q, $rootScope, $scope, $window, BranchFundingSourceService, Modal, User, CurrencyService, SetupService, DateUtil, CarrierService, AtmResidualDepositService, AtmResidualService, $location, DenominationService, $translate, BulkCashService, Sound, Navigation, DataCounter, UserBranchFundingSourceService, RouteService, LocationDeliveryService, LocationService) {
        var _this = this;

        (0, _classCallCheck3.default)(this, DepositPackingController);

        this.fundingSourceSearchObj = function (searchKey) {
            searchKey = searchKey || '';
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: _this.model.branch
                    }, {
                        group: {
                            rules: [{
                                field: 'locationId',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'sourceName',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        };

        this.carrierSearchObj = function (searchKey) {
            searchKey = searchKey || '';
            var searchObj = {
                branch: _this.model.branch,
                queryText: '%' + searchKey + '%'
                // queryJSON: {
                //     rules: [
                //         {
                //             field: 'id',
                //             condition: 'like',
                //             data: '%' + searchKey + '%'
                //         },
                //         {
                //             field: 'name',
                //             condition: 'like',
                //             data: '%' + searchKey + '%'
                //         }
                //     ],
                //     operator: 'OR'
                // }
            };
            return searchObj;
        };

        this.$q = $q;
        this.$state = $state;
        this.$window = $window;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.CurrencyService = CurrencyService;
        this.DateUtil = DateUtil;
        this.SetupService = SetupService;
        this.CarrierService = CarrierService;
        this.AtmResidualDepositService = AtmResidualDepositService;
        this.User = User;
        this.AtmResidualService = AtmResidualService;
        this.Modal = Modal;
        this.$location = $location;
        this.DenominationService = DenominationService;
        this.$translate = $translate;
        this.BulkCashService = BulkCashService;
        this.Sound = Sound;
        this.$rootScope = $rootScope;
        this.page = 1;
        this.total = 0;
        this.pageLimit = 10;
        this.maxPages = 10;
        this.Navigation = Navigation;
        this.DataCounter = DataCounter;
        this.UserBranchFundingSourceService = UserBranchFundingSourceService;
        this.currencySymbol = '$';
        this.RouteService = RouteService;
        this.LocationDeliveryService = LocationDeliveryService;
        this.LocationService = LocationService;

        this.model = {
            fundingSourceId: null,
            branch: User.getUser().branchId,
            userId: User.getUser().id,
            currency: null,
            allCurrency: [],
            vaultDate: '',
            allCarrier: [],
            ledgerTransaction: [],
            allDenomination: [],
            stats: 'pending',
            trackingId: "",
            dateRanges: {
                startDate: null,
                endDate: null
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            dateRangPickerOptions: {},
            dateRangPicker: {},
            denomination: [],
            account: 'regular'
            // isManualDeposit: false,
            // isResidualDeposit: false
        };

        this.dateRangeOption = {
            startDate: null,
            endDate: null
        };

        this.stats = {
            pending: 'pending',
            packed: 'packed',
            released: 'released'
        };

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 5000,
            maxPages: 10
        };

        this.ledgers = [{
            lable: "Regular",
            value: "regular"
        }, {
            lable: "Emergency",
            value: "emergency"
        }];

        this.paginationObj = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.loading = false;
        this.locationLists = [];
        this.pendingResidualData = [];
        this.SelectedPendingDeposit = [];
        this.maxAtmResidualDepositLimit = 0;
        this.isLimitExceed = false;
        this.depositLimitExceedMsg = "";
        this.residualIds = [];
        this.denominationsBreakdown = [];
        this.successMessage = "";
        this.pendingReleaseData = [];
        this.contents = [];
        this.setupFromLocation = "";
        this.releasedDeposit = [];
        this.pendingDepositTotal = 0;
        this.packedDepositTotal = 0;
        this.releasedDepositTotal = 0;
        this.errorMessage = "";
        this.isError = false;
        this.emergencyPackPreviewData = [];
        this.denominationIds = [];
        this.totalAmount = 0;
        this.toggleSelect = true;
        this.$rootScope.$broadcast('routeChange', '/app/deposit-packing');
        this.residuals = [];
        this.selectedDenomination = [];
        this.filterDenomination = [];
        this.isWarning = false;
        this.packPreviewError = '';
        this.cashDepositData = '';
        this.noRecords = 0;
        this.deliveryLocations = [];
        this.model.deliveryLocation = null;
        this.model.routeId = null;
        this.model.routeName = null;
        this.model.deliveryDate = null;
        this.routeList = [];
        this.loadingRoutes = false;
    }

    (0, _createClass3.default)(DepositPackingController, [{
        key: 'setCurrencySymbol',
        value: function setCurrencySymbol() {
            if (!this.model || !this.model.currency || !Array.isArray(this.model.allCurrency)) {
                this.currencySymbol = '$';
                return;
            }

            var currencyId = this.model.currency;
            var currency = this.model.allCurrency.find(function (c) {
                return c.id === currencyId;
            });
            this.currencySymbol = currency && currency.symbol ? currency.symbol : '$';
        }
    }, {
        key: 'setCurrencySymbol',
        value: function setCurrencySymbol() {
            if (!this.model || !this.model.currency || !Array.isArray(this.model.allCurrency)) {
                this.currencySymbol = '$';
                return;
            }

            var currencyId = this.model.currency;
            var currency = this.model.allCurrency.find(function (c) {
                return c.id === currencyId;
            });
            this.currencySymbol = currency && currency.symbol ? currency.symbol : '$';
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.cashDepositData = this.DataCounter.getData();
            this.$q.all([this.SetupService.get(this.model.branch), this.getFundingSource('', 0), this.CurrencyService.all(null, 0, 100), this.getAllCarrier('', 0)]).then(function (data) {
                var date = moment(data[0].currentVaultDate);
                _this2.maxAtmResidualDepositLimit = data[0].limitPerATMDeposit;
                _this2.model.vaultDate = _this2.DateUtil.convertToDate(date);
                _this2.model.allCurrency = data[2].results.filter(function (obj) {
                    return data[0].availableCurrencyIds && data[0].availableCurrencyIds.includes(obj.id);
                });
                // this.model.currency = data[2].currencyId;
                _this2.minVaultDate = {
                    minDate: _this2.model.vaultDate
                };
                _this2.minDeliveryDate = { minDate: _this2.model.vaultDate };
                _this2.setupFromLocation = data[0].fromLocation;
                // this.model.currency = data[0].currency.id;
                _this2.model.date = _this2.model.vaultDate;
                if (!_this2.model.deliveryDate) {
                    _this2.model.deliveryDate = _this2.model.vaultDate;
                }
                _this2.setCurrencySymbol();
            }).then(function () {
                _this2.setDateRange(_this2.model.vaultDate, _this2.model.dateRanges, 'dateRangPickerOptions');
                _this2.model.dateRanges.startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
                _this2.model.dateRanges.endDate = moment().endOf('week').format('YYYY-MM-DD HH:mm:ss');
            });
            // .then(() => {
            //     this.setDateRange(this.model.vaultDate, this.dateRangeOption, 'dateRangPicker');
            //     this.dateRangeOption.startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
            //     this.dateRangeOption.endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
            //     console.log(this.dateRangeOption.startDate);
            //     console.log(this.dateRangeOption.endDate);
            // })
        }
    }, {
        key: 'setDateRange',
        value: function setDateRange(date, dateRangeOption, modelValue) {
            var _this3 = this;

            var currentVaultDate = moment(date).format() || moment();
            this.model[modelValue] = {
                autoApply: true,
                // maxDate: moment(currentVaultDate).endOf('day').format('YYYY-MM-DD'),
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        return _this3.filterData();
                        // if (this.model.stats === this.stats.released) return this.filterData(dateRangeOption);
                        // if (this.model.stats === this.stats.pending) return this.seletDepositByDate(dateRangeOption);
                    }
                },
                ranges: {
                    'Today': [moment().format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }

        // tab selection

    }, {
        key: 'tabSelection',
        value: function tabSelection(selectedValue) {
            delete this.successMessage;
            this.model.stats = selectedValue;
        }

        // Get fundingSource locations 

    }, {
        key: 'getFundingSource',
        value: function getFundingSource(searchKey, offset) {
            var _this4 = this;

            // const loadFundingSourceData = this.fundingSourceSearchObj(searchKey);
            this.UserBranchFundingSourceService.getBranchFundingSource(this.model.userId, this.model.branch).then(function (data) {
                if (offset === 0) {
                    _this4.totalRecords = data.total;
                    _this4.locationLists = _this4.mappingFundingSourceData(data.results);
                } else {
                    var locations = _this4.mappingFundingSourceData(data.results);
                    _this4.locationLists = _this4.locationLists.concat(locations);
                }
            });
        }
    }, {
        key: 'mappingFundingSourceData',
        value: function mappingFundingSourceData(locations) {
            return locations.map(function (location) {
                return {
                    Key: location.id + " | " + location.locationId + " | " + location.sourceName,
                    Value: location.locationId,
                    Id: location.id,
                    LocationId: location.locationId,
                    sourceName: location.sourceName,
                    residualDeposit: location.residualDeposit,
                    manualDeposit: location.manualDeposit,
                    partialECDeposit: location.partialECDeposit,
                    currencyId: location.currencyId
                };
            });
        }

        // Get Carriers

    }, {
        key: 'getAllCarrier',
        value: function getAllCarrier(searchKey, offset) {
            var _this5 = this;

            var loadCarrierData = this.carrierSearchObj(searchKey);
            this.CarrierService.all(loadCarrierData, offset, _app2.default.defaultPageLimit).then(function (data) {
                if (offset === 0) {
                    _this5.totalRecord = data.total;
                    _this5.carrierLists = _this5.mappingCarrierData(data.results);
                } else {
                    var carriers = _this5.mappingCarrierData(data.results);
                    _this5.carrierLists = _this5.carrierLists.concat(carriers);
                }
            }).then(function () {
                setTimeout(function () {
                    _this5.loadDepositPacking();
                }, 1000);
            });
        }
    }, {
        key: 'mappingCarrierData',
        value: function mappingCarrierData(carriers) {
            return carriers.map(function (crr) {
                return {
                    Key: crr.id + " | " + crr.name,
                    Value: crr.id,
                    Name: crr.name
                };
            });
        }

        // get pending deposit

    }, {
        key: 'getPendingResiduals',
        value: function getPendingResiduals() {
            var _this6 = this;

            if (!this.model.fundingSourceId || !this.model.currency || !this.model.account) {
                return;
            }

            this.loading = true;
            this.AtmResidualDepositService.getPendingResidualDeposit(this.model.branch, this.model.fundingSourceId.Value, this.model.fundingSourceId.Id, this.model.currency, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit).then(function (data) {
                _this6.isError = false;
                if (data.totalRecords > 0) {
                    _this6.pendingResidualData = data;
                    _this6.pendingDepositTotal = data.totalRecords;
                    _this6.residuals = data;
                    _this6.denomGroup();
                } else {
                    _this6.reset();
                }
            }).then(function () {
                _this6.getSelectedResidualId();
            }).catch(function (err) {
                _this6.reset();
                console.log(err);
                if (err && err.data && err.data.message) {
                    return _this6.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this6.loading = false;
            });
        }
    }, {
        key: 'getSelectedResidualId',
        value: function getSelectedResidualId() {
            var _this7 = this;

            this.residualIds.map(function (id) {
                _this7.pendingResidualData.records.filter(function (data) {
                    if (data.atmResidualId == id) {
                        data.isSelected = true;
                    }
                });
            });
        }
    }, {
        key: 'buildErrorMessage',
        value: function buildErrorMessage(err) {
            if (!err || !err.data) return '';

            var message = err.data.message || '';

            if (Array.isArray(err.data.warnings) && err.data.warnings.length) {
                message += '<br><br>' + err.data.warnings.join('<br>');
            }

            return message;
        }
    }, {
        key: 'reset',
        value: function reset() {
            delete this.successMessage;
            delete this.msg;
            this.isError = true;
            this.denominationsBreakdown = [];
            this.residualIds = [];
            this.pendingResidualData = [];
            this.model.trackingId = "";
            this.errorMessage = this.$translate.instant('atm_deposit_packing.no_data_found');
        }
    }, {
        key: 'selectedDeposit',
        value: function selectedDeposit(event, data, index) {
            delete this.successMessage;

            if (event.target.checked) {
                this.residualIds.push(data.atmResidualId);
            } else {
                var _index = this.residualIds.indexOf(data.atmResidualId);
                this.residualIds.splice(_index, 1);
            }
            this.packPreview();
            if (this.residualIds && this.residualIds.length) this.msg = this.$translate.instant('atm_deposit_packing.selected_residual', { total: this.residualIds.length });else delete this.msg;
        }
    }, {
        key: 'packPreview',
        value: function packPreview() {
            var _this8 = this;

            if (this.residualIds.length) {
                this.model.loading = true;
                this.AtmResidualDepositService.residualPackPreview(this.model.branch, this.model.fundingSourceId.Value, this.model.fundingSourceId.Id, this.model.currency, this.model.trackingId, this.residualIds).then(function (res) {
                    _this8.denominationsBreakdown = res;
                    _this8.checkResidualDepositLimit(res.summary.totalAmount, res.summary.depositLimit);
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        return _this8.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this8.model.loading = false;
                });
            } else {
                this.denominationsBreakdown = [];
                this.model.trackingId = "";
            }
        }

        // check deposit limit with branch Max ATM Residual Deposit

    }, {
        key: 'checkResidualDepositLimit',
        value: function checkResidualDepositLimit(totalDenomAmount, depositLimit) {
            if (totalDenomAmount > depositLimit) {
                this.isLimitExceed = true;
                this.depositLimitExceedMsg = this.$translate.instant('atm_deposit_packing.limit_exceed');
            } else {
                this.isLimitExceed = false;
                delete this.depositLimitExceedMsg;
            }
        }

        // pack residual deposit

    }, {
        key: 'pack',
        value: function pack() {
            var _this9 = this;

            if (!this.model.deliveryLocation) {
                this.Modal.errorModal('Please select a delivery location');
                return;
            }
            if (!this.model.routeId) {
                this.Modal.errorModal('Please enter a route ID');
                return;
            }
            if (!this.model.deliveryDate) {
                this.Modal.errorModal('Please select a delivery date');
                return;
            }

            this.packLoader = this.loading;
            this.packLoader = true;

            var carrierId = this.model.carrierId ? this.model.carrierId.Value : null;
            var toLocationId = this.model.deliveryLocation ? this.model.deliveryLocation.id : null;
            var routeId = this.model.routeId || null;
            var deliveryDate = this.model.deliveryDate ? moment(this.model.deliveryDate).format('YYYY-MM-DD') : null;

            this.AtmResidualDepositService.commitDeposit(this.model.branch, this.model.fundingSourceId.Value, this.model.fundingSourceId.Id, this.model.currency, this.model.trackingId, this.model.account, carrierId, this.model.userId, this.residualIds, toLocationId, routeId, deliveryDate).then(function (data) {
                _this9.successMessage = _this9.$translate.instant('atm_deposit_packing.packed', {
                    trackingId: _this9.model.trackingId
                });
                _this9.Sound.playSuccessBeep("#success_beep");
            }).then(function () {
                delete _this9.msg;
                _this9.model.deliveryLocation = null;
                _this9.model.routeSelection = null;
                _this9.model.routeId = null;
                _this9.model.routeName = null;
                _this9.model.deliveryDate = _this9.model.vaultDate;
                _this9.refreshData(); // refresh data after successfully deposit packed
            }).catch(function (err) {
                console.log(err);
                _this9.Sound.PlayErrorBeep("#scanner_beep");
                if (err && err.data && err.data.message === 'ER_SIGNAL_EXCEPTION: E_LEDGERTRANSACTION_ACTIVE') {
                    return _this9.Modal.errorModal('error.95001');
                } else {
                    return _this9.Modal.errorModal(_this9.buildErrorMessage(err));
                }
            }).finally(function () {
                _this9.packLoader = false;
            });
        }
    }, {
        key: 'refreshData',
        value: function refreshData() {
            this.pagination.page = 1;

            if (this.model.stats === this.stats.pending) {
                // load PendingResiduals, packedDeposit and released data
                this.denominationsBreakdown = [];
                this.residualIds = [];
                this.model.trackingId = "";
                this.loadPendingResiduals();
                this.pendingToRelease();
                this.showReleasedDeposit();
            }

            if (this.model.stats === this.stats.packed) {
                // load packedDeposit and releasedDeposit data
                this.paginationObj.page = 1;
                this.pendingToRelease();
                this.showReleasedDeposit();
            }
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            delete this.successMessage;
            this.loadPendingResiduals();
        }
    }, {
        key: 'loadPendingResiduals',
        value: function loadPendingResiduals() {
            this.getPendingResiduals();
        }
    }, {
        key: 'isFormValidate',
        value: function isFormValidate() {
            return this.model.fundingSourceId && this.model.account && this.model.currency;
        }

        // load pending to relase residual deposit 

    }, {
        key: 'pendingToRelease',
        value: function pendingToRelease() {
            var _this10 = this;

            if (!this.model.fundingSourceId || !this.model.currency || !this.model.account) {
                return;
            }

            this.pendingPackLoader = this.loading;
            this.pendingPackLoader = true;

            var carrierId = this.model.carrierId ? this.model.carrierId.Value : null;

            this.AtmResidualDepositService.getPendingRelease(this.model.branch, this.model.fundingSourceId.Value, this.model.currency, this.model.account, carrierId, this.paginationObj.pageLimit, (this.paginationObj.page - 1) * this.paginationObj.pageLimit).then(function (data) {
                _this10.pendingReleaseData = data;
                _this10.packedDepositTotal = data.totalRecords;
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    return _this10.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this10.pendingPackLoader = false;
            });
        }
    }, {
        key: 'jumpToNextPage',
        value: function jumpToNextPage() {
            delete this.successMessage;
            this.pendingToRelease();
        }

        // show packed residual deposit info

    }, {
        key: 'showContents',
        value: function showContents(depositId) {
            var _this11 = this;

            var defer = this.$q.defer();

            this.contentLoader = this.loading;
            this.contentLoader = true;

            this.AtmResidualDepositService.contents(depositId, this.pageLimit, (this.page - 1) * this.pageLimit).then(function (res) {
                _this11.contents = res;
                defer.resolve(_this11.contents);
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    return _this11.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this11.contentLoader = false;
            });
            return defer.promise;
        }

        // PrintManifest for ATM deposit

    }, {
        key: 'printManifest',
        value: function printManifest(data, index) {
            this.obj = {
                data: data,
                setupFromLocation: this.setupFromLocation,
                toLocation: this.model.fundingSourceId,
                carrier: this.model.carrierId,
                account: this.model.account,
                currencySymbol: this.currencySymbol
            };
            var new_path = this.$state.href('printDepositPacking');
            window.w = window.open(new_path, '_blank');
            window.w.printData = this.obj;
        }
    }, {
        key: 'printPackedDepositLabel',
        value: function printPackedDepositLabel(data) {
            var _this12 = this;

            var deliveryLocation = this.model.deliveryLocation || {};
            var locationInfo = {
                id: deliveryLocation.id || null,
                name: deliveryLocation.name || null,
                address: deliveryLocation.address || null,
                city: deliveryLocation.city || null,
                state: deliveryLocation.state || null,
                zip: deliveryLocation.zip || null
            };

            var denominations = (data.denominations || []).filter(function (d) {
                return d && (d.amount || d.inputValue || d.units || d.totalAmount);
            }).map(function (d) {
                return {
                    id: d.icon || d.denominationId || d.id || '',
                    amount: Number(d.units ? Number(d.units) * Number(d.faceValue || 0) : d.amount || d.inputValue || d.totalAmount || 0),
                    symbol: d.symbol || _this12.currencySymbol
                };
            });

            var totalDenomAmount = denominations.reduce(function (total, denomination) {
                return total + denomination.amount;
            }, 0);
            var isMultiDenomPack = denominations.length > 0;

            var shipmentDetails = [{
                trackingId: data.trackingId || this.model.trackingId,
                toLocationId: locationInfo.id,
                isLoadTrackingId: true,
                locationInfo: locationInfo,
                orderNo: null,
                orderType: 'BULKCASH',
                routeId: data.routeId || this.model.routeId || null,
                deliveryDate: data.deliveryDate || (this.model.deliveryDate ? moment(this.model.deliveryDate).format('YYYY-MM-DD') : null),
                pickupDate: null,
                amount: Number(data.totalAmount || 0),
                denominationId: !isMultiDenomPack ? data.denominationId || null : null,
                vaultDate: data.deliveryDate || (this.model.deliveryDate ? moment(this.model.deliveryDate).format('YYYY-MM-DD') : null),
                defRouteSequence: data.defRouteSequence != null ? data.defRouteSequence : null,
                denominations: denominations,
                shiptypeId: data.shiptypeId || 'BULKCASH',
                symbol: data.symbol || this.currencySymbol,
                fundingSource: this.model.fundingSourceId ? this.model.fundingSourceId.sourceName : null,
                totalDenomAmount: totalDenomAmount
            }];

            var obj = {
                shipmentDetails: shipmentDetails,
                isPrePackPrint: false,
                multiDenomPack: false,
                depositShipmentLabelPrePack: true,
                currencySymbol: this.currencySymbol
            };
            var path = this.$state.href('printBarcodes');
            window.w = window.open(path, '_blank');
            window.w.printData = obj;
        }
    }, {
        key: 'relesePendingDeposit',
        value: function relesePendingDeposit(data) {
            var _this13 = this;

            this.releaseLoader = {};
            this.releaseLoader[data.trackingId] = { process: true };
            var carrierId = this.model.carrierId ? this.model.carrierId.Value : null;
            var carrierName = this.model.carrierId ? this.model.carrierId.Name : null;

            this.AtmResidualDepositService.release(data.id, this.isResidualDeposit(), this.model.branch, data.trackingId, carrierId, carrierName, this.model.userId).then(function (res) {
                _this13.successMessage = _this13.$translate.instant('atm_deposit_packing.released', {
                    trackingId: data.trackingId
                });
                _this13.Sound.playSuccessBeep("#success_beep");
                _this13.refreshData(); // refresh data after successfully released 
            }).catch(function (err) {
                console.log(err);
                _this13.Sound.PlayErrorBeep("#scanner_beep");
                if (err && err.data && err.data.message) {
                    return _this13.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this13.releaseLoader[data.trackingId].process = false;
            });
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            this.pagination.page = 1;
            this.paginationObj.page = 1;
            this.model.pagination.page = 1;

            if (this.isFundingSourceValid()) {
                this.showReleasedDeposit();
                this.pendingToRelease();
                this.loadDeliveryLocations();
                this.model.currency = this.model.fundingSourceId.currencyId;
            }
        }
    }, {
        key: 'loadDeliveryLocations',
        value: function loadDeliveryLocations() {
            var _this14 = this;

            if (!this.model.fundingSourceId || !this.model.fundingSourceId.LocationId) {
                this.validDeliveryLocationIds = [];
                this.deliveryLocations = [];
                this.totalDeliveryLocations = 0;
                this.model.deliveryLocation = null;
                this.model.routeId = null;
                this.model.deliveryDate = null;
                this.routeList = [];
                return;
            }

            var locationMap = {};
            var add = function add(loc) {
                if (loc && loc.id) locationMap[loc.id] = { id: loc.id, name: loc.name || loc.id, Key: loc.id + ' | ' + (loc.name || loc.id), Value: loc.id };
            };
            var centralBank = this.model.branch ? this.LocationService.centralBankLocation(this.model.branch).catch(function () {
                return [];
            }) : this.$q.resolve([]);
            this.$q.all([this.LocationDeliveryService.getLocationDeliveryDetails(this.model.fundingSourceId.LocationId), centralBank]).then(function (_ref) {
                var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                    deliveryData = _ref2[0],
                    centralBankLocations = _ref2[1];

                (deliveryData || []).forEach(function (d) {
                    return d.destinationLocation && add(d.destinationLocation);
                });
                (centralBankLocations || []).forEach(add);
                _this14.validDeliveryLocationIds = (0, _keys2.default)(locationMap);

                if (_this14.validDeliveryLocationIds.length === 0) {
                    _this14.deliveryLocations = [];
                    _this14.totalDeliveryLocations = 0;
                    _this14.model.deliveryLocation = null;
                    _this14.loadRouteSchedule();
                    return;
                }

                // Initial fetch will figure out if we just have 1 location
                _this14.getDeliveryLocations('', 0).then(function () {
                    if (_this14.validDeliveryLocationIds.length === 1 && _this14.deliveryLocations.length === 1) {
                        _this14.model.deliveryLocation = _this14.deliveryLocations[0];
                        _this14.loadRouteSchedule();
                    } else {
                        _this14.model.deliveryLocation = null;
                        _this14.model.routeSelection = null;
                        _this14.model.routeId = null;
                        _this14.model.routeName = null;
                        _this14.routeList = [];
                    }
                });
            }).catch(function (err) {
                console.error('Error loading delivery locations:', err);
                _this14.validDeliveryLocationIds = [];
                _this14.deliveryLocations = [];
                _this14.totalDeliveryLocations = 0;
                _this14.model.deliveryLocation = null;
                _this14.model.routeSelection = null;
                _this14.model.routeId = null;
                _this14.model.routeName = null;
                _this14.routeList = [];
                _this14.totalRoutes = 0;
            });
        }
    }, {
        key: 'getDeliveryLocations',
        value: function getDeliveryLocations(searchKey, offset) {
            var _this15 = this;

            if (!this.validDeliveryLocationIds || !this.validDeliveryLocationIds.length) {
                return this.$q.resolve();
            }

            searchKey = searchKey || '';
            var limit = 10;
            offset = offset || 0;

            var locationSearchObj = {
                queryJSON: {
                    rules: [{ field: "id", condition: "IN", data: this.validDeliveryLocationIds }, {
                        group: {
                            rules: [{ field: "id", condition: "like", data: "%" + searchKey + "%" }, { field: "name", condition: "like", data: "%" + searchKey + "%" }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };

            return this.LocationService.all(locationSearchObj, offset, limit).then(function (data) {
                var results = (data.results || []).map(function (loc) {
                    return {
                        id: loc.id,
                        name: loc.name || loc.id,
                        Key: loc.id + ' | ' + (loc.name || loc.id),
                        Value: loc.id,
                        address: loc.address,
                        city: loc.city,
                        state: loc.state,
                        zip: loc.zip,
                        country: loc.country
                    };
                });

                if (offset === 0) {
                    _this15.totalDeliveryLocations = data.total;
                    _this15.deliveryLocations = results;
                } else {
                    _this15.deliveryLocations = _this15.deliveryLocations.concat(results);
                }
            }).catch(function (err) {
                console.error("Error fetching delivery locations:", err);
            });
        }
    }, {
        key: 'onRouteChange',
        value: function onRouteChange() {
            if (this.model.routeSelection) {
                this.model.routeId = this.model.routeSelection.routeId;
                this.model.routeName = this.model.routeSelection.routeName;
            } else {
                this.model.routeId = null;
                this.model.routeName = null;
            }
        }
    }, {
        key: 'loadRouteSchedule',
        value: function loadRouteSchedule() {
            if (!this.model.deliveryLocation || !this.model.deliveryLocation.id || !this.model.branch) {
                this.routeList = [];
                this.totalRoutes = 0;
                this.model.routeSelection = null;
                this.model.routeId = null;
                this.model.routeName = null;
                return;
            }
            this.getRoutes('', 0);
        }
    }, {
        key: 'getRoutes',
        value: function getRoutes(searchKey, offset) {
            var _this16 = this;

            if (!this.model.deliveryLocation || !this.model.deliveryLocation.id || !this.model.branch) return;

            searchKey = searchKey || '';
            this.loadingRoutes = true;

            var routeSearchObj = {
                queryJSON: {
                    rules: [{ field: "branchId", condition: "IN", data: [this.model.branch] }, {
                        group: {
                            rules: [{ field: "id", condition: "like", data: "%" + searchKey + "%" }, { field: "name", condition: "like", data: "%" + searchKey + "%" }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };

            var deliveryDate = this.model.deliveryDate ? moment(this.model.deliveryDate).format('YYYY-MM-DD') : this.model.vaultDate ? moment(this.model.vaultDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');

            var scheduledPromise = this.$q.resolve({ results: [] });
            if (offset === 0 || offset == undefined) {
                scheduledPromise = this.RouteService.getScheduledRouteByLocationId(deliveryDate, this.model.deliveryLocation.id, this.model.branch);
            }

            this.$q.all([scheduledPromise, this.RouteService.all(routeSearchObj, offset, 10)]).then(function (_ref3) {
                var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
                    scheduledRoutes = _ref4[0],
                    allRoutes = _ref4[1];

                var branchRoutes = (allRoutes.results || []).map(function (route) {
                    return {
                        Key: route.id + ' | ' + (route.name || route.id),
                        Value: route.id,
                        routeId: route.id,
                        routeName: route.name || route.id,
                        isScheduled: false,
                        isHold: !!route.holdRoute
                    };
                });

                var scheduledIds = new _set2.default((scheduledRoutes.results || []).map(function (route) {
                    return route.id;
                }));
                branchRoutes.forEach(function (route) {
                    if (scheduledIds.has(route.routeId)) {
                        route.isScheduled = true;
                    }
                });

                if (offset === 0 || offset == undefined) {
                    _this16.totalRoutes = allRoutes.total;
                    var sortedRoutes = branchRoutes.sort(function (a, b) {
                        if (a.isScheduled !== b.isScheduled) return a.isScheduled ? -1 : 1;
                        if (a.isHold !== b.isHold) return a.isHold ? 1 : -1;
                        return (a.routeName || '').localeCompare(b.routeName || '');
                    });

                    _this16.routeList = sortedRoutes;

                    if (_this16.routeList.length > 0) {
                        var scheduledRoute = _this16.routeList.find(function (r) {
                            return r.isScheduled;
                        });
                        if (scheduledRoute) {
                            _this16.model.routeSelection = scheduledRoute;
                            _this16.model.routeId = scheduledRoute.routeId;
                            _this16.model.routeName = scheduledRoute.routeName;
                        }
                    }
                } else {
                    var currentIds = new _set2.default(_this16.routeList.map(function (r) {
                        return r.routeId;
                    }));
                    var newRoutes = branchRoutes.filter(function (r) {
                        return !currentIds.has(r.routeId);
                    });
                    _this16.routeList = _this16.routeList.concat(newRoutes);
                }
            }).catch(function (err) {
                console.error(err);
            }).finally(function () {
                _this16.loadingRoutes = false;
            });
        }
    }, {
        key: 'resetPendingResidualData',
        value: function resetPendingResidualData() {
            if (this.model.fundingSourceId && this.model.fundingSourceId.residualDeposit && this.isFundingSourceValid()) {
                if (this.model.account === 'regular') {
                    this.resetEmergencyPackPreview();
                    this.getPendingResiduals();
                }
                if (this.model.account === 'emergency') {
                    this.resetRegularPackPreview();
                    this.getEmergencyPackingData();
                }
            }
        }

        // show released deposit data

    }, {
        key: 'showReleasedDeposit',
        value: function showReleasedDeposit() {
            var _this17 = this;

            if (!this.model.fundingSourceId || !this.model.currency || !this.model.account) {
                return;
            }

            this.releasedLoader = this.loading;
            this.releasedLoader = true;

            var rangeStart = this.model.dateRanges && this.model.dateRanges.startDate ? this.model.dateRanges.startDate : moment().startOf('week');
            var rangeEnd = this.model.dateRanges && this.model.dateRanges.endDate ? this.model.dateRanges.endDate : moment().endOf('week');
            var startDate = moment(rangeStart).format('YYYY-MM-DD') + 'T00:00:00.000Z';
            var endDate = moment(rangeEnd).format('YYYY-MM-DD') + 'T23:59:59.999Z';
            var carrierId = this.model.carrierId ? this.model.carrierId.Value : null;

            this.AtmResidualDepositService.released(this.model.branch, this.model.fundingSourceId.Value, this.model.currency, this.model.account, carrierId, startDate, endDate, this.model.pagination.pageLimit, (this.model.pagination.page - 1) * this.model.pagination.pageLimit).then(function (res) {
                _this17.releasedDeposit = res;
                _this17.releasedDepositTotal = res.totalRecords;
                _this17.autoOpenContentModal();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    return _this17.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this17.releasedLoader = false;
            });
        }
    }, {
        key: 'filterData',
        value: function filterData() {
            this.model.pagination.page = 1;
            this.showReleasedDeposit();
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            this.showReleasedDeposit();
        }

        // show details of residual shipment details which is already has been packed or released

    }, {
        key: 'packedDepositInfo',
        value: function packedDepositInfo(data) {
            this.Modal.depositPackingInfoModal(data, function (_ref5) {
                var modal = _ref5.modal;

                modal.close();
            }, function (_ref6) {
                var modal = _ref6.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'getEmergencyPackingData',
        value: function getEmergencyPackingData() {
            var _this18 = this;

            if (!this.model.fundingSourceId || !this.model.currency || !this.model.account) {
                return;
            }

            this.emergencyPackLoader = this.loading;
            this.emergencyPackLoader = true;
            this.filterDenomination = [];

            this.AtmResidualDepositService.emergencyPackPreview(this.model.branch, this.model.fundingSourceId.Value, this.model.currency).then(function (res) {
                _this18.emergencyPackPreviewData = res;
                _this18.emergencyPackPreviewData.breakdown.forEach(function (denom) {
                    _this18.filterDenomination.push({
                        denominationId: denom.denominationId,
                        faceValue: denom.denominationFaceValue,
                        balance: denom.totalAmount
                    });
                });
                _this18.defaultDenominationArray();
                _this18.addRemainingDenominations(0);
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this18.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this18.emergencyPackLoader = false;
            });
        }
    }, {
        key: 'resetRegularPackPreview',
        value: function resetRegularPackPreview() {
            delete this.successMessage;
            this.denominationsBreakdown = [];
            this.residualIds = [];
            this.pendingResidualData = [];
            this.model.trackingId = "";
        }
    }, {
        key: 'selectedEmergencyPackPreview',
        value: function selectedEmergencyPackPreview(event, data, index) {
            var _this19 = this;

            delete this.successMessage;
            this.totalAmount = 0;

            if (event.target.checked) {
                this.emergencyPackPreviewData.breakdown.forEach(function (d) {
                    _this19.denominationIds.push(d);
                    d.isSelected = true;
                });
                this.getTotalAmount(this.denominationIds);
            } else {
                this.emergencyPackPreviewData.breakdown.forEach(function (d) {
                    var index = _this19.denominationIds.indexOf(d);
                    _this19.denominationIds.splice(index, 1);
                    d.isSelected = false;
                });
                this.getTotalAmount(this.denominationIds);
            }
            // this.checkResidualDepositLimit(res.summary.totalAmount, res.summary.depositLimit);
        }
    }, {
        key: 'getTotalAmount',
        value: function getTotalAmount(array) {
            var _this20 = this;

            array.forEach(function (d) {
                _this20.totalAmount += d.totalAmount;
            });
        }
    }, {
        key: 'emergencyPack',
        value: function emergencyPack() {
            var _this21 = this;

            if (!this.model.deliveryLocation) {
                this.Modal.errorModal('Please select a delivery location');
                return;
            }
            if (!this.model.routeId) {
                this.Modal.errorModal('Please enter a route ID');
                return;
            }
            if (!this.model.deliveryDate) {
                this.Modal.errorModal('Please select a delivery date');
                return;
            }

            this.packEmergencyDeposit = this.loading;
            this.packEmergencyDeposit = true;

            var carrierId = this.model.carrierId ? this.model.carrierId.Value : null;
            var toLocationId = this.model.deliveryLocation ? this.model.deliveryLocation.id : null;
            var routeId = this.model.routeId || null;
            var deliveryDate = this.model.deliveryDate ? moment(this.model.deliveryDate).format('YYYY-MM-DD') : null;

            this.AtmResidualDepositService.commitEmergencyDeposit(this.model.branch, this.model.fundingSourceId.Value, this.model.currency, this.model.trackingId, carrierId, this.model.userId, toLocationId, routeId, deliveryDate).then(function (data) {
                _this21.successMessage = _this21.$translate.instant('atm_deposit_packing.packed', {
                    trackingId: _this21.model.trackingId
                });
                _this21.Sound.playSuccessBeep("#success_beep");
            }).then(function () {
                _this21.model.deliveryLocation = null;
                _this21.model.routeSelection = null;
                _this21.model.routeId = null;
                _this21.model.routeName = null;
                _this21.model.deliveryDate = _this21.model.vaultDate;
                _this21.refreshEmergencyData(); // refresh data after successfully deposit packed
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message === 'ER_SIGNAL_EXCEPTION: E_LEDGERTRANSACTION_ACTIVE') {
                    return _this21.Modal.errorModal('error.95001');
                } else {
                    return _this21.Modal.errorModal(_this21.buildErrorMessage(err));
                }
            }).finally(function () {
                _this21.packEmergencyDeposit = false;
            });
        }
    }, {
        key: 'refreshEmergencyData',
        value: function refreshEmergencyData() {
            this.model.trackingId = "";
            this.denominationIds = [];
            this.pendingToRelease();
            this.getEmergencyPackingData();
            this.showReleasedDeposit();
        }
    }, {
        key: 'resetEmergencyPackPreview',
        value: function resetEmergencyPackPreview() {
            delete this.successMessage;
            this.denominationIds = [];
            this.emergencyPackPreviewData = [];
            this.model.trackingId = "";
        }
    }, {
        key: 'selectDepositByDate',
        value: function selectDepositByDate() {
            var _this22 = this;

            delete this.successMessage;
            this.residualIds = [];
            var date = moment(this.model.date).format('YYYY-MM-DD');

            if (this.pendingResidualData && this.pendingResidualData.records) {
                this.pendingResidualData.records.filter(function (d) {
                    if (moment.utc(d.countedDate).format('YYYY-MM-DD') === date) {
                        d.isSelected = true;
                        _this22.residualIds.push(d.atmResidualId);
                    } else {
                        _this22.toggleSelect = true;
                        d.isSelected = false;
                    }
                });
                this.packPreview();
            }
            if (this.residualIds && this.residualIds.length) this.msg = this.$translate.instant('atm_deposit_packing.selected_residual', { total: this.residualIds.length });else delete this.msg;
        }
    }, {
        key: 'resetSelection',
        value: function resetSelection() {
            this.denominationsBreakdown = [];
            this.model.trackingId = "";
            this.residualIds = [];
            this.pendingResidualData.records.filter(function (d) {
                d.isSelected = false;
            });
            this.toggleSelect = true;
            delete this.successMessage;
            delete this.msg;
        }
    }, {
        key: 'toggleAllSelection',
        value: function toggleAllSelection() {
            var _this23 = this;

            delete this.successMessage;
            this.residualIds = [];

            if (this.pendingResidualData && this.pendingResidualData.records) {
                this.pendingResidualData.records.filter(function (d) {
                    d.isSelected = _this23.toggleSelect;
                    _this23.residualIds.push(d.atmResidualId);
                });
                this.toggleSelect = !this.toggleSelect;
                if (this.toggleSelect) {
                    return this.residualIds = [], this.denominationsBreakdown = [], delete this.msg;
                }
                if (!this.toggleSelect) {
                    return this.packPreview(), this.msg = this.$translate.instant('atm_deposit_packing.selected_residual', { total: this.residualIds.length });
                }
            }
        }
    }, {
        key: 'isValidate',
        value: function isValidate() {
            return this.model.fundingSourceId && this.model.account && this.model.currency;
        }
    }, {
        key: 'exportPendingResidalData',
        value: function exportPendingResidalData() {
            var _this24 = this;

            this.isExporting = true;
            this.AtmResidualDepositService.exportPendingPackData(this.model.branch, this.model.fundingSourceId.Value, this.model.fundingSourceId.Id, this.model.currency, this.currencySymbol, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit).then(function (data) {
                _this24.downloadFile(data, 'pending_pack');
            }).catch(function (err) {
                _this24.isExporting = false;
                console.log(err);
            });
        }
    }, {
        key: 'downloadFile',
        value: function downloadFile(data, fileName) {
            this.reportPrefix = fileName;
            this.date = moment.utc().format('DDMMYY');
            this.fileName = this.reportPrefix.concat('_', this.date, '.csv');
            var a = document.createElement("a");
            document.body.appendChild(a);
            var file = new Blob([data.reportData], { type: 'application/csv' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = this.fileName;
            a.click();
            this.isExporting = false;
        }
    }, {
        key: 'exportPackedResidualData',
        value: function exportPackedResidualData() {
            var _this25 = this;

            this.isExporting = true;
            var carrierId = this.model.carrierId ? this.model.carrierId.Value : null;
            this.AtmResidualDepositService.exportPackedResidualData(this.model.branch, this.model.fundingSourceId.Value, this.model.currency, this.currencySymbol, this.model.account, carrierId, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit).then(function (data) {
                _this25.downloadFile(data, 'pending_release');
            }).catch(function (err) {
                _this25.isExporting = false;
                console.log(err);
            });
        }
    }, {
        key: 'exportReleasedResidualData',
        value: function exportReleasedResidualData() {
            var _this26 = this;

            this.isExporting = true;

            var startDate = moment(this.model.dateRanges.startDate).format('YYYY-MM-DD') + 'T00:00:00.000Z',
                endDate = moment(this.model.dateRanges.endDate).format('YYYY-MM-DD') + 'T23:59:59.999Z';

            var carrierId = this.model.carrierId ? this.model.carrierId.Value : null;

            this.AtmResidualDepositService.exportReleasedResidualData(this.model.branch, this.model.fundingSourceId.Value, this.model.currency, this.currencySymbol, this.model.account, carrierId, startDate, endDate, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit).then(function (data) {
                _this26.downloadFile(data, 'released');
            }).catch(function (err) {
                _this26.isExporting = false;
                console.log(err);
            });
        }
    }, {
        key: 'confirmUndoDeposit',
        value: function confirmUndoDeposit(data) {
            var _this27 = this;

            this.Modal.confirm({
                header: this.$translate.instant('atm_deposit_packing.undo_deposit_pack'),
                message: this.$translate.instant('atm_deposit_packing.undo_deposit_msg'),
                callback: function callback(_ref7) {
                    var modal = _ref7.modal;

                    modal.close();
                    _this27.undoDeposit(data);
                },
                negative: function negative(_ref8) {
                    var modal = _ref8.modal;

                    modal.close();
                },
                type: 'danger'
            });
        }
    }, {
        key: 'undoDeposit',
        value: function undoDeposit(data) {
            var _this28 = this;

            var force = false;
            this.AtmResidualDepositService.undoDepositPack(data.id, force).then(function (res) {
                _this28.reloadData(); // reload data after undo deposit
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message === 'ER_SIGNAL_EXCEPTION: E_LEDGERTRANSACTION_ACTIVE') {
                    return _this28.Modal.errorModal('error.95001');
                } else {
                    return _this28.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'reloadData',
        value: function reloadData() {
            if (this.model.account === 'regular') {
                this.model.fundingSourceId.manualDeposit ? this.getLedgerDenomBalance() : this.getPendingResiduals();
            }
            if (this.model.account === 'emergency') {
                this.model.fundingSourceId.manualDeposit ? this.getLedgerDenomBalance() : this.getEmergencyPackingData();
            }
            this.pendingToRelease();
        }
    }, {
        key: 'printEmergencyPackedData',
        value: function printEmergencyPackedData() {
            var obj = {
                data: {
                    branchId: this.model.branch,
                    currency: this.model.currency,
                    printEmergencyPackData: true,
                    account: this.model.account
                },
                setupFromLocation: this.setupFromLocation,
                toLocation: this.model.fundingSourceId,
                carrier: this.model.carrierId,
                currencySymbol: this.currencySymbol
                // account: this.model.account
            };
            var new_path = this.$state.href('printDepositPacking');
            window.w = window.open(new_path, '_blank');
            window.w.printData = obj;
        }
    }, {
        key: 'reloadPageData',
        value: function reloadPageData() {
            if (this.model.stats === this.stats.pending) {
                if (this.model.account === 'regular') this.getPendingResiduals();
                if (this.model.account === 'emergency') this.getEmergencyPackingData();
            } else if (this.model.stats === this.stats.packed) {
                this.pendingToRelease();
            } else {
                this.showReleasedDeposit();
            }
        }

        // create unique denomination group from existing pendingResidualData

    }, {
        key: 'denomGroup',
        value: function denomGroup() {
            var _this29 = this;

            this.denominationGroup = [];
            var uniqueDenoms = new _set2.default();
            (this.pendingResidualData.records || []).forEach(function (record) {
                if (record.denominationId) {
                    record.denominationId.split(',').forEach(function (d) {
                        uniqueDenoms.add(d.trim());
                    });
                }
            });

            (0, _from2.default)(uniqueDenoms).forEach(function (denomId) {
                var icon = '<img  src="assets/images/' + denomId + '.png" />';
                _this29.denominationGroup.push({ icon: icon, denominationId: denomId });
            });
        }
    }, {
        key: 'filterDataByDenom',
        value: function filterDataByDenom() {
            var results = [];
            var shipmentAmount = 0;
            if (this.model.denomination.length) {
                this.resetSelection();
                var selectedDenoms = this.model.denomination.map(function (d) {
                    return d.denominationId;
                });

                this.residuals.records.forEach(function (record) {
                    var recDenoms = record.denominationId ? record.denominationId.split(',').map(function (d) {
                        return d.trim();
                    }) : [];
                    if (recDenoms.some(function (d) {
                        return selectedDenoms.includes(d);
                    })) {
                        shipmentAmount += record.amount || 0;
                        results.push(record);
                    }
                });
                this.pendingResidualData = {
                    records: results,
                    totalPendingDeposit: shipmentAmount,
                    totalRecords: this.residuals.totalRecords
                };
            } else {
                this.resetSelection(); // reset denomination breakdown selection
                this.resetData(); //  reset filtered data by denom
            }
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            this.resetSelection();
            return this.pendingResidualData = this.residuals;
        }
    }, {
        key: 'isResidualDeposit',
        value: function isResidualDeposit() {
            return this.model.fundingSourceId && this.model.fundingSourceId.residualDeposit;
        }

        ///// Manual Deposit Logic //////

    }, {
        key: 'getLedgerDenomBalance',
        value: function getLedgerDenomBalance() {
            var _this30 = this;

            if (!this.isValidate()) {
                return;
            }

            this.isLoading = true;
            this.AtmResidualDepositService.ledgerDenomBalance(this.model.branch, this.model.account, this.model.fundingSourceId.Id).then(function (data) {
                _this30.model.ledgerData = (0, _extends3.default)({}, data, {
                    results: data.results.filter(function (item) {
                        return item.balance > 0;
                    })
                });
                _this30.filterDenomination = _this30.model.ledgerData.results;
                _this30.defaultDenominationArray();
                _this30.addRemainingDenominations(0);
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this30.isLoading = false;
            });
        }
    }, {
        key: 'loadManualDepositData',
        value: function loadManualDepositData() {
            if (this.model.fundingSourceId && this.model.fundingSourceId.manualDeposit && this.isFundingSourceValid()) {
                this.model.stats = 'pending';
                this.resetDenomData();
                this.getLedgerDenomBalance();
            }
        }
    }, {
        key: 'defaultDenominationArray',
        value: function defaultDenominationArray() {
            this.denominationData = [{
                trackingId: '',
                account: this.model.account,
                denominations: [],
                remainingDenominations: [],
                totalAmount: '',
                isValid: false,
                currencyIcon: this.model.currency,
                denomTemplate: 'denomType-selection.html'
            }];
        }
    }, {
        key: 'addRow',
        value: function addRow() {
            this.denominationData.push({
                trackingId: '',
                account: this.model.account,
                denominations: [],
                remainingDenominations: [],
                totalAmount: '',
                isValid: false,
                currencyIcon: this.model.currency,
                denomTemplate: 'denomType-selection.html'
            });
            if (this.filterDenomination) {
                this.addRemainingDenominations(this.denominationData.length - 1);
            }
            this.checkDuplicateTrackingIds();
        }
    }, {
        key: 'removeRow',
        value: function removeRow(index) {
            var _this31 = this;

            var row = this.denominationData[index];
            var hasDenominations = row.denominations && row.denominations.length > 0;
            var hasTrackingId = row.trackingId && row.trackingId.trim().length > 0;

            var doDelete = function doDelete() {
                _this31.denominationData.splice(index, 1);
                _this31.checkDuplicateTrackingIds();
                _this31.denominationData.forEach(function (r, rIdx) {
                    r.denominations.forEach(function (denom, dIdx) {
                        var val = denom.coinFlag ? denom.units : denom.amount;
                        _this31.checkAmount(rIdx, dIdx, denom.ledgerDenomBalance, val, denom.faceValue, denom.coinFlag);
                    });
                });
            };

            if (hasDenominations || hasTrackingId) {
                this.Modal.confirm({
                    header: this.$translate.instant('common.confirm_delete_title'),
                    message: this.$translate.instant('common.confirm_delete_message'),
                    callback: function callback(_ref9) {
                        var modal = _ref9.modal;

                        doDelete();
                        modal.close();
                    },
                    negative: function negative(_ref10) {
                        var modal = _ref10.modal;

                        modal.close();
                    },
                    type: 'danger'
                });
            } else {
                doDelete();
            }
        }
    }, {
        key: 'checkDuplicateTrackingIds',
        value: function checkDuplicateTrackingIds() {
            if (!this.denominationData) return;

            var trackingIdCounts = {};
            this.denominationData.forEach(function (data) {
                if (data.trackingId) {
                    var id = data.trackingId.trim().toLowerCase();
                    trackingIdCounts[id] = (trackingIdCounts[id] || 0) + 1;
                }
            });

            this.denominationData.forEach(function (data) {
                if (data.trackingId) {
                    var id = data.trackingId.trim().toLowerCase();
                    data.isDuplicateTrackingId = trackingIdCounts[id] > 1;
                } else {
                    data.isDuplicateTrackingId = false;
                }
            });
        }
    }, {
        key: 'addDenomination',
        value: function addDenomination(index) {
            var _this32 = this;

            var denomLength = this.denominationData[index].denominations.length;
            var defaultDenomIcon = this.filterDenomination[0].denominationId;
            var icon = denomLength ? this.denominationData[index].remainingDenominations[0].denominationId : defaultDenomIcon;
            var faceValue = 0;
            var ledgerDenomBalance = 0;
            var coinFlag = 0;
            var symbol = this.currencySymbol;

            this.filterDenomination.forEach(function (denomData) {
                if (denomData.denominationId == icon) {
                    faceValue = denomData.faceValue;
                    ledgerDenomBalance = denomData.balance;
                    coinFlag = denomData.coinFlag || 0;
                    symbol = denomData.symbol || _this32.currencySymbol;
                }
            });

            this.denominationData[index].denominations.push({
                icon: icon,
                faceValue: faceValue,
                amount: null,
                units: null,
                inputValue: null,
                coinFlag: coinFlag,
                template: 'denomination-selection.html',
                ledgerDenomBalance: ledgerDenomBalance,
                symbol: symbol
            });

            var denomIndex = _.findIndex(this.denominationData[index].denominations, { icon: icon });
            this.setFocus(denomIndex);
            this.removeAlreadyUsedDenom(index);
        }
    }, {
        key: 'addRemainingDenominations',
        value: function addRemainingDenominations(index) {
            var _this33 = this;

            this.filterDenomination.forEach(function (data) {
                _this33.denominationData[index].remainingDenominations.push(data);
            });
        }
    }, {
        key: 'removeAlreadyUsedDenom',
        value: function removeAlreadyUsedDenom(index) {
            var _this34 = this;

            this.denominationData[index].remainingDenominations = this.filterDenomination.filter(function (type) {
                var isValid = true;
                _this34.denominationData[index].denominations.forEach(function (data) {
                    isValid = !(data.icon === type.denominationId) && isValid;
                });
                return isValid;
            });
        }
    }, {
        key: 'removeDenomination',
        value: function removeDenomination(parentIndex, denominationIndex) {
            var _this35 = this;

            var denom = this.denominationData[parentIndex].denominations[denominationIndex];
            this.denominationData[parentIndex].denominations.splice(denominationIndex, 1);
            var length = this.denominationData[parentIndex].denominations.length;
            this.calculateAmount(parentIndex, denominationIndex); // check and deduct amount if denom removed from array
            this.removeAlreadyUsedDenom(parentIndex);
            this.validateMsg(parentIndex);
            this.denominationData.forEach(function (row, rIdx) {
                row.denominations.forEach(function (d, dIdx) {
                    var val = d.coinFlag ? d.units : d.amount;
                    _this35.checkAmount(rIdx, dIdx, d.ledgerDenomBalance, val, d.faceValue, d.coinFlag);
                });
            });
            // if (length && !denom.isValid && denom.amount) this.adHocPackPreview(parentIndex);
        }
    }, {
        key: 'changeDenomination',
        value: function changeDenomination(event, denomId, parentIndex, denominationIndex, imageIndex, faceValue, amount, ledgerDenomBalance, coinFlag, symbol) {
            var currentDenom = this.denominationData[parentIndex].denominations[denominationIndex];
            var isCoinTypeChange = currentDenom.coinFlag !== coinFlag || currentDenom.icon !== denomId;

            this.denominationData[parentIndex].denominations[denominationIndex].icon = denomId;
            this.denominationData[parentIndex].denominations[denominationIndex].faceValue = faceValue;
            this.denominationData[parentIndex].denominations[denominationIndex].ledgerDenomBalance = ledgerDenomBalance;
            this.denominationData[parentIndex].denominations[denominationIndex].coinFlag = coinFlag || 0;
            this.denominationData[parentIndex].denominations[denominationIndex].symbol = symbol || this.currencySymbol;
            this.selectedDenomination[imageIndex] = this.filterDenomination[imageIndex].denominationId;
            this.denominationData[parentIndex].denominations[denominationIndex].isOpen = false;

            // Only reset values if changing between coin and cash types
            if (isCoinTypeChange) {
                this.denominationData[parentIndex].denominations[denominationIndex].amount = null;
                this.denominationData[parentIndex].denominations[denominationIndex].units = null;
                this.denominationData[parentIndex].denominations[denominationIndex].inputValue = null;
                this.calculateAmount(parentIndex);
            }

            this.checkAmount(parentIndex, denominationIndex, ledgerDenomBalance, amount, faceValue, coinFlag);
            this.removeAlreadyUsedDenom(parentIndex);
            // if (amount) this.adHocPackPreview(parentIndex);
        }
    }, {
        key: 'calculateAmount',
        value: function calculateAmount(parentIndex, denominationIndex) {
            var _this36 = this;

            this.totalDenominationsAmount = 0;
            this.denominationData[parentIndex].denominations.map(function (data) {
                if (data.coinFlag && data.units) {
                    // For coins: totalAmount = units * faceValue
                    var coinAmount = Number(data.units * data.faceValue || 0);
                    _this36.totalDenominationsAmount = Number(_this36.totalDenominationsAmount) + coinAmount;
                } else if (!data.coinFlag && data.amount) {
                    // For cash: totalAmount = amount (already in currency)
                    _this36.totalDenominationsAmount = Number(_this36.totalDenominationsAmount) + Number(data.amount || 0);
                }
            });
            this.denominationData[parentIndex].totalAmount = this.totalDenominationsAmount;
        }
    }, {
        key: 'validateAmount',
        value: function validateAmount(parentIndex, denominationIndex, ledgerDenomBalance, inputValue, faceValue, coinFlag) {
            // For coins, store the inputValue as units
            if (coinFlag) {
                this.denominationData[parentIndex].denominations[denominationIndex].units = Number(inputValue);
                this.denominationData[parentIndex].denominations[denominationIndex].amount = null;
            } else {
                // For cash, store the inputValue as amount
                this.denominationData[parentIndex].denominations[denominationIndex].amount = Number(inputValue);
                this.denominationData[parentIndex].denominations[denominationIndex].units = null;
            }

            this.calculateAmount(parentIndex);
            this.checkAmount(parentIndex, denominationIndex, ledgerDenomBalance, inputValue, faceValue, coinFlag);
        }

        // validate amount to make sure it will not exceeds current ledger denomination balance

    }, {
        key: 'checkAmount',
        value: function checkAmount(parentIndex, denominationIndex, ledgerDenomBalance, amount, faceValue, coinFlag) {
            var _this37 = this;

            if (parentIndex === undefined) return;

            var currentDenomId = this.denominationData[parentIndex].denominations[denominationIndex].icon;
            var otherRowsAmount = 0;
            this.denominationData.forEach(function (row, idx) {
                if (idx < parentIndex) {
                    var denom = row.denominations.find(function (d) {
                        return d.icon === currentDenomId;
                    });
                    if (denom) {
                        otherRowsAmount += denom.coinFlag ? Number(denom.units || 0) * denom.faceValue : Number(denom.amount || 0);
                    }
                }
            });
            ledgerDenomBalance = ledgerDenomBalance - otherRowsAmount;

            if (coinFlag) {
                // For coins: validate calculated amount (units * faceValue) against balance
                var calculatedAmount = amount * faceValue;
                if (calculatedAmount > ledgerDenomBalance) {
                    this.denominationData[parentIndex].denominations[denominationIndex].isValid = false;
                } else if (amount && amount > 0) {
                    this.denominationData[parentIndex].denominations[denominationIndex].isValid = true;
                } else {
                    this.denominationData[parentIndex].denominations[denominationIndex].isValid = false;
                }
            } else {
                // For cash: validate amount is divisible by faceValue
                if (amount % faceValue > 0 || amount > ledgerDenomBalance) {
                    this.denominationData[parentIndex].denominations[denominationIndex].isValid = false;
                } else if (amount && amount % faceValue == 0) {
                    this.denominationData[parentIndex].denominations[denominationIndex].isValid = true;
                } else {
                    this.denominationData[parentIndex].denominations[denominationIndex].isValid = false;
                }
            }

            // Also trigger checkAmount for other rows with the same denomination if this is not a sub-call
            if (!this._isChecking) {
                this._isChecking = true;
                this.denominationData.forEach(function (row, idx) {
                    if (idx !== parentIndex) {
                        var dIdx = _.findIndex(row.denominations, { icon: currentDenomId });
                        if (dIdx !== -1) {
                            var denom = row.denominations[dIdx];
                            var val = denom.coinFlag ? denom.units : denom.amount;
                            _this37.checkAmount(idx, dIdx, denom.ledgerDenomBalance, val, denom.faceValue, denom.coinFlag);
                        }
                    }
                });
                this._isChecking = false;
            }
        }
    }, {
        key: 'validatePackButton',
        value: function validatePackButton(index) {
            var data = this.denominationData[index].denominations;

            var disableButton = data.map(function (denom) {
                return denom.isValid !== undefined && denom.isValid || 'isEmpty';
            }).indexOf('isEmpty') !== -1;

            return disableButton;
        }
    }, {
        key: 'isTableScrollable',
        value: function isTableScrollable() {
            var el = document.getElementById('deposit-packing-table-container');
            if (el) {
                return el.scrollHeight > el.clientHeight;
            }
            return false;
        }
    }, {
        key: 'resetDenomData',
        value: function resetDenomData() {
            this.model.trackingId = "";
            delete this.packPreviewError;
            this.model.adHocPackPreviewData = [];
            this.isWarning = false;
        }
    }, {
        key: 'adHocPack',
        value: function adHocPack(index) {
            var _this38 = this;

            if (!this.model.deliveryLocation) {
                this.Modal.errorModal('Please select a delivery location');
                return;
            }
            if (!this.model.routeId) {
                this.Modal.errorModal('Please enter a route ID');
                return;
            }
            if (!this.model.deliveryDate) {
                this.Modal.errorModal('Please select a delivery date');
                return;
            }

            var hasEmptyTracking = this.denominationData.some(function (d) {
                return !d.trackingId;
            });
            if (hasEmptyTracking) {
                this.Modal.errorModal('Please ensure all shipments have a Tracking ID.');
                return;
            }

            var trackingIds = this.denominationData.map(function (d) {
                return d.trackingId;
            }).join(', ');

            this.Modal.confirmSupervisor('ad-hoc-pack', { trackingId: trackingIds }, function (_ref11) {
                var modal = _ref11.modal,
                    supId = _ref11.supId;

                _this38.adHocPackLoader = true;
                var carrierId = _this38.model.carrierId ? _this38.model.carrierId.Value : null;
                var toLocationId = _this38.model.deliveryLocation ? _this38.model.deliveryLocation.id : null;
                var routeId = _this38.model.routeId || null;
                var deliveryDate = _this38.model.deliveryDate ? moment(_this38.model.deliveryDate).format('YYYY-MM-DD') : null;

                var deposits = _this38.denominationData.map(function (data, index) {
                    return {
                        trackingId: data.trackingId,
                        amounts: _this38.amountMapping(index)
                    };
                });

                _this38.AtmResidualDepositService.adHocPack(_this38.model.branch, _this38.model.fundingSourceId.Value, _this38.model.currency, _this38.model.account, carrierId, supId, deposits, toLocationId, routeId, deliveryDate).then(function () {
                    _this38.model.deliveryLocation = null;
                    _this38.model.routeSelection = null;
                    _this38.model.routeId = null;
                    _this38.model.routeName = null;
                    _this38.model.deliveryDate = _this38.model.vaultDate;
                    _this38.resetDenomData();
                    _this38.model.fundingSourceId.manualDeposit ? _this38.getLedgerDenomBalance() : _this38.getEmergencyPackingData();
                    _this38.pendingToRelease();
                    _this38.showReleasedDeposit();
                    _this38.Sound.playSuccessBeep("#success_beep");
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message === 'ER_SIGNAL_EXCEPTION: E_LEDGERTRANSACTION_ACTIVE') {
                        _this38.Modal.errorModal('error.95001');
                    } else if (err && err.data && err.data.message) {
                        _this38.Modal.errorModal(_this38.buildErrorMessage(err));
                    }
                }).finally(function () {
                    modal.close();
                    _this38.adHocPackLoader = false;
                });
            }, function (_ref12) {
                var modal = _ref12.modal;

                modal.close();
                _this38.adHocPackLoader = false;
            });
        }
    }, {
        key: 'validatePackAllButton',
        value: function validatePackAllButton() {
            var _this39 = this;

            if (!this.denominationData || !this.denominationData.length) return true;
            var isInvalid = false;
            this.denominationData.forEach(function (data, index) {
                if (!data.trackingId || !data.denominations || !data.denominations.length || data.isDuplicateTrackingId) {
                    isInvalid = true;
                } else if (_this39.validatePackButton(index)) {
                    isInvalid = true;
                }
            });
            return isInvalid;
        }
    }, {
        key: 'focuseElementById',
        value: function focuseElementById(id) {
            setTimeout(function () {
                document.getElementById(id).focus();
            }, 300);
        }

        // set focus on amount when denomination add

    }, {
        key: 'setFocus',
        value: function setFocus(index) {
            this.focuseElementById('denomBox-' + (index + 1));
        }
    }, {
        key: 'isManualDeposit',
        value: function isManualDeposit() {
            return this.model.fundingSourceId && this.model.fundingSourceId.manualDeposit;
        }
    }, {
        key: 'isFundingSourceValid',
        value: function isFundingSourceValid() {
            var isValid = this.isResidualDeposit() && this.isManualDeposit() || !this.isResidualDeposit() && !this.isManualDeposit() ? false : true;
            return isValid;
        }
    }, {
        key: 'adHocPackPreview',
        value: function adHocPackPreview(index) {
            var _this40 = this;

            var amounts = this.amountMapping(index);
            this.isLoadingPackPreview = true;

            this.AtmResidualDepositService.adHocPackPreview(this.model.branch, this.model.fundingSourceId.Value, this.model.currency, this.model.account, amounts).then(function (data) {
                _this40.model.adHocPackPreviewData = data;
                _this40.isWarning = data.warnings.length ? true : false;
                delete _this40.packPreviewError;
            }).catch(function (err) {
                console.log(err);
                _this40.packPreviewError = err.data.message;
            }).finally(function () {
                _this40.isLoadingPackPreview = false;
            });
        }
    }, {
        key: 'amountMapping',
        value: function amountMapping(index) {
            var amounts = {};
            this.denominationData[index].denominations.forEach(function (info) {
                if (info.icon) {
                    if (info.coinFlag && info.units) {
                        // For coins: send units * faceValue as amount
                        var coinAmount = info.units * info.faceValue;
                        amounts[info.icon] = coinAmount;
                    } else if (!info.coinFlag && info.amount) {
                        // For cash: send amount directly
                        amounts[info.icon] = info.amount;
                    }
                }
            });
            return amounts;
        }
    }, {
        key: 'validateMsg',
        value: function validateMsg(index) {
            var denomLength = this.denominationData[index].denominations.length;
            if (!denomLength) {
                this.model.adHocPackPreviewData = [];
                this.isWarning = false;
                delete this.packPreviewError;
            }
        }
    }, {
        key: 'goToItemHistory',
        value: function goToItemHistory(trackingId) {
            this.Navigation.goToItemHistory(trackingId, null);
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(data) {
            this.Navigation.goToServiceHistory(data.locationId, null, true, null);
        }
    }, {
        key: 'loadDepositPacking',
        value: function loadDepositPacking() {
            var findFundingSource = void 0;
            if (this.cashDepositData && this.cashDepositData.isRedirected || this.locationLists.length === 1) {
                if (this.cashDepositData) {
                    findFundingSource = _.find(this.locationLists, { Id: this.cashDepositData.fundingSourceId });
                    this.model.dateRanges.startDate = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
                    this.model.dateRanges.endDate = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
                }
                this.model.fundingSourceId = {
                    Key: findFundingSource ? findFundingSource.Key : this.locationLists[0].Key,
                    Value: findFundingSource ? findFundingSource.Value : this.locationLists[0].Value,
                    Id: findFundingSource ? findFundingSource.Id : this.locationLists[0].Id,
                    residualDeposit: findFundingSource ? findFundingSource.residualDeposit : this.locationLists[0].residualDeposit,
                    manualDeposit: findFundingSource ? findFundingSource.manualDeposit : this.locationLists[0].manualDeposit,
                    partialECDeposit: findFundingSource ? findFundingSource.partialECDeposit : this.locationLists[0].partialECDeposit
                };
                this.model.account = 'regular';
                if (this.carrierLists.length) {
                    this.model.carrierId = {
                        Key: this.carrierLists[0].Key,
                        Value: this.carrierLists[0].Value,
                        Name: this.carrierLists[0].Name
                    };
                }
                if (this.cashDepositData && this.cashDepositData.isRedirected) this.model.stats = this.stats.released;
                this.loadData();
                this.resetPendingResidualData();
                this.loadManualDepositData();
            }
        }
    }, {
        key: 'resetFilter',
        value: function resetFilter() {
            if (this.cashDepositData) {
                this.cashDepositData.isRedirected = false;
                this.cashDepositData = this.DataCounter.setData();
            }
        }
    }, {
        key: 'autoOpenContentModal',
        value: function autoOpenContentModal() {
            var _this41 = this;

            if (this.cashDepositData && this.cashDepositData.isRedirected) {
                setTimeout(function () {
                    var deposit = _this41.releasedDeposit.records.find(function (data) {
                        return data.trackingId === _this41.cashDepositData.trackingId;
                    });
                    if (deposit) _this41.packedDepositInfo(deposit);
                    _this41.resetFilter();
                }, 1500);
            }
        }
    }, {
        key: 'goToAtmCount',
        value: function goToAtmCount(trackingId) {
            return this.Navigation.goToAtmCount(trackingId, true, null, this.model.fundingSourceId.Id);
        }
    }, {
        key: 'exportReleasedDeposit',
        value: function exportReleasedDeposit(data) {
            var _this42 = this;

            this.isExporting = true;
            this.AtmResidualDepositService.exportReleasedDeposit(data.id).then(function (res) {
                _this42.releasedDepositData = res;
                if (_this42.releasedDepositData.totalRecords > 0) {
                    return _this42.downloadFile(_this42.releasedDepositData, 'released_deposit');
                } else {
                    return _this42.Modal.errorModal('common.noDataFound');
                }
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    return _this42.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this42.isExporting = false;
            });
        }
    }, {
        key: 'resetDenominations',
        value: function resetDenominations() {
            this.filterDenomination = [];
            this.isLimitExceed = false;
            delete this.depositLimitExceedMsg;
        }
    }, {
        key: 'toggleReleasedDenominations',
        value: function toggleReleasedDenominations(released) {

            this.releasedDeposit.records.forEach(function (record) {
                if (record !== released) {
                    record.showDenominations = false;
                }
            });

            released.showDenominations = !released.showDenominations;
        }
    }, {
        key: 'togglePackedDenominations',
        value: function togglePackedDenominations(packed) {

            this.pendingReleaseData.records.forEach(function (record) {
                if (record !== packed) {
                    record.showDenominations = false;
                }
            });

            packed.showDenominations = !packed.showDenominations;
        }
    }]);
    return DepositPackingController;
}();

exports.default = DepositPackingController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deposit_packing = __webpack_require__(1871);

var _deposit_packing2 = _interopRequireDefault(_deposit_packing);

var _print = __webpack_require__(1874);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var depositPackingModule = angular.module('depositPacking', [_print2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/deposit-packing');

    $stateProvider.state('depositPacking', {
        url: '/deposit-packing',
        component: 'depositPacking',
        data: {
            requireLogin: true,
            requireACL: 'deposit_packing.all'
        },
        parent: 'app'
    });
}]).component('depositPacking', _deposit_packing2.default).name;

exports.default = depositPackingModule;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _print_deposit_packing = __webpack_require__(1875);

var _print_deposit_packing2 = _interopRequireDefault(_print_deposit_packing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printDepositPackingModule = angular.module('printDepositPacking', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider.otherwise('/deposit-packing');

	$stateProvider.state('printDepositPacking', {
		url: '/print-deposit-packing',
		component: 'printDepositPacking',
		data: {
			requireLogin: true,
			requireACL: 'deposit_packing.all'
		}
	});
}]).component('printDepositPacking', _print_deposit_packing2.default).name;

exports.default = printDepositPackingModule;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_deposit_packing = __webpack_require__(2724);

var _print_deposit_packing2 = _interopRequireDefault(_print_deposit_packing);

var _print_deposit_packing3 = __webpack_require__(1876);

var _print_deposit_packing4 = _interopRequireDefault(_print_deposit_packing3);

__webpack_require__(3006);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printDepositPackingComponent = {
  restrict: 'E',
  bindings: {},
  template: _print_deposit_packing2.default,
  controller: _print_deposit_packing4.default
};

exports.default = printDepositPackingComponent;

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintDepositPackingController = function () {
    /*@ngInject*/
    PrintDepositPackingController.$inject = ["$state", "$stateParams", "AtmResidualDepositService", "$q"];
    function PrintDepositPackingController($state, $stateParams, AtmResidualDepositService, $q) {
        (0, _classCallCheck3.default)(this, PrintDepositPackingController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.manifestData = "";
        this.setupFromLocation = "";
        this.toLocation = "";
        this.carrier = "";
        this.totalDenomAmount = 0;
        this.AtmResidualDepositService = AtmResidualDepositService;
        this.$q = $q;
        this.contents = [];
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 5000,
            maxPages: 10
        };
    }

    (0, _createClass3.default)(PrintDepositPackingController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this = this;

            var printData = undefined;
            this.date = new Date();

            if (window.opener && window.opener.w && window.opener.w.printData) {
                printData = window.opener.w.printData;
                this.manifestData = printData.data;
                this.setupFromLocation = printData.setupFromLocation;
                this.toLocation = printData.toLocation;
                this.carrier = printData.carrier;
                this.currencySymbol = printData.currencySymbol || '$';
                this.loading = true;

                if (this.manifestData.account === 'regular' && this.toLocation.residualDeposit) {
                    var defer = this.$q.defer();
                    this.AtmResidualDepositService.contents(this.manifestData.id, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit).then(function (res) {
                        _this.contents = res;
                        _this.contents.records.forEach(function (data) {
                            _this.totalDenomAmount += data.amount;
                        });
                        defer.resolve(res);
                    }).catch(function (err) {
                        console.log(err);
                        defer.reject(err);
                    }).finally(function () {
                        _this.loading = false;
                    });
                    return defer.promise.then(function (data) {
                        setTimeout(function () {
                            window.print();
                        }, 1000);
                    });
                } else {
                    this.loading = false;
                    setTimeout(function () {
                        window.print();
                    }, 1000);
                }
            }

            if (this.manifestData && this.manifestData.account === 'emergency' && this.manifestData.printEmergencyPackData) {
                this.pendingPackLoader = true;
                this.AtmResidualDepositService.getPendingRelease(this.manifestData.branchId, this.toLocation.Value, this.manifestData.currency, this.manifestData.account, this.carrier ? this.carrier.Value : null, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit).then(function (data) {
                    _this.pendingReleaseData = data;
                    _this.totalDenomAmount = data.totalPendingRelease;
                }).catch(function (err) {
                    console.log(err);
                }).finally(function () {
                    _this.pendingPackLoader = false;
                });
            }

            // setTimeout(() => {
            //     window.print()
            // }, 1000)
        }
    }]);
    return PrintDepositPackingController;
}();

exports.default = PrintDepositPackingController;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _forgot_password = __webpack_require__(2725);

var _forgot_password2 = _interopRequireDefault(_forgot_password);

var _forgot_password3 = __webpack_require__(1878);

var _forgot_password4 = _interopRequireDefault(_forgot_password3);

__webpack_require__(3007);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var forgotPasswordComponent = {
  restrict: 'E',
  bindings: {},
  template: _forgot_password2.default,
  controller: _forgot_password4.default
};

exports.default = forgotPasswordComponent;

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgotPasswordController = function () {
  /*@ngInject*/
  ForgotPasswordController.$inject = ["Auth", "User", "$scope", "$rootScope", "$state", "$location", "$translate", "MobileAppService", "ngToast", "$stateParams"];
  function ForgotPasswordController(Auth, User, $scope, $rootScope, $state, $location, $translate, MobileAppService, ngToast, $stateParams) {
    (0, _classCallCheck3.default)(this, ForgotPasswordController);

    this.Auth = Auth;
    this.User = User;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$location = $location;
    this.ngToast = ngToast;
    this.MobileAppService = MobileAppService;
    this.$stateParams = $stateParams;
    this.isLoggedIn = false;
    if (Auth.isAuthenticated()) {
      this.$state.go('home');
    }
    this.$translate = $translate;
    this.isForgotLoading = false;
    this.name = 'forgotPassword';
    this.userCredentials = {
      email: ''
    };

    this.resetCredentials = {
      email: '',
      code: '',
      password: '',
      cpassword: ''
    };

    this.error = '';
    this.successMsg = '';
    this.appData = '';

    this.togglePassword = {
      pass: false,
      cpass: false
    };

    this.model = {
      passwordPolicy: null,
      showPasswordPolicy: false
    };
  }

  (0, _createClass3.default)(ForgotPasswordController, [{
    key: '$onInit',
    value: function $onInit() {
      this.isForceChangePassword = this.$stateParams.isForceChangedPassword;
    }
  }, {
    key: 'submitForgotPWD',
    value: function submitForgotPWD(form) {
      var _this = this;

      if (this.isForgotLoading) return;
      this.error = '';
      this.successMsg = '';
      if (form.$valid) {
        this.isForgotLoading = true;
        this.Auth.isUserEmailExist(this.userCredentials).then(function (data) {
          if (data.status) {
            _this.name = 'resetPassword';
            _this.resetCredentials.email = _this.userCredentials.email;
            _this.successMsg = _this.$translate.instant('login.reset_password_request_code');
            if (data && data.errors) {
              _this.model.passwordPolicy = (0, _extends3.default)({}, data);
            }
          } else {
            _this.error = 'No user match with provided email address';
          }
          _this.isForgotLoading = false;
        }, function (error) {
          console.log(error);
          _this.isForgotLoading = false;
        }, function () {
          setTimeout(function () {
            if (_this.successMsg) {
              _this.successMsg = '';
            }
          }, 3000);
        });
      } else {
        if (form.$error.required) {
          this.error = this.$translate.instant('login.email_required');
        } else if (form.$error.email && form.$error.email.length) {
          this.error = this.$translate.instant('login.invalid_email_required');
        }
      }
    }
  }, {
    key: 'resetPassword',
    value: function resetPassword(form) {
      var _this2 = this;

      if (this.isResetLoading) return;
      this.error = '';
      this.successMsg = '';

      if (form.$valid) {
        this.isResetLoading = true;
        this.Auth.resetUserPassword(this.resetCredentials).then(function (data) {
          if (data.status && data.message !== 'failed') {
            _this2.successMsg = _this2.$translate.instant('login.reset_request_success');
            setTimeout(function () {
              _this2.$state.go('login');
            }, 2500);
          } else if (data && data.message == 'failed') {
            _this2.model.passwordPolicy = data;
          }
          _this2.isResetLoading = false;
        }, function (error) {
          _this2.isResetLoading = false;
          _this2.error = error.data.message;
        });
      } else {
        if (form.$error.required) {
          this.error = this.$translate.instant('login.email_required');
        } else if (form.$error.email && form.$error.email.length) {
          this.error = this.$translate.instant('login.invalid_email_required');
        }
      }
    }
  }, {
    key: 'showPassword',
    value: function showPassword(control) {
      this.togglePassword[control] = !this.togglePassword[control];
    }
  }, {
    key: 'checkPasswordPolicy',
    value: function checkPasswordPolicy() {
      this.successMsg = '';
      this.model.passwordPolicy.isCurrentPassSameAsPrevious = false;
      if (!this.model.passwordPolicy || !this.model.passwordPolicy.errors) return;
      var pwd = this.resetCredentials.password || "";
      if (!pwd) {
        this.model.passwordPolicy.filterErrors = [];
        return;
      }
      var unmet = [];
      this.model.passwordPolicy.errors.forEach(function (rule) {
        var isValid = true;
        switch (rule.validation) {
          case "min":
            isValid = pwd.length >= rule.arguments;
            break;
          case "uppercase":
            isValid = (pwd.match(/[A-Z]/g) || []).length >= rule.arguments;
            break;
          case "lowercase":
            isValid = (pwd.match(/[a-z]/g) || []).length >= rule.arguments;
            break;
          case "digits":
            isValid = (pwd.match(/[0-9]/g) || []).length >= rule.arguments;
            break;
          case "symbols":
            isValid = (pwd.match(/[^A-Za-z0-9]/g) || []).length >= rule.arguments;
            break;
        }
        if (!isValid) unmet.push(rule);
      });
      this.model.passwordPolicy.filterErrors = unmet;
    }
  }]);
  return ForgotPasswordController;
}();

exports.default = ForgotPasswordController;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _forgot_password = __webpack_require__(1877);

var _forgot_password2 = _interopRequireDefault(_forgot_password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var forgotPasswordModule = angular.module('forgotPassword', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/forgor-password');

  $stateProvider.state('forgot_password', {
    url: '/forgot-password',
    component: 'forgotPassword',
    data: {
      requireLogin: false
    }
  }).state('change_password', {
    url: '/change-password',
    component: 'forgotPassword',
    params: {
      isForceChangedPassword: false
    },
    data: {
      requireLogin: false
    }
  });
}]).component('forgotPassword', _forgot_password2.default).name;

exports.default = forgotPasswordModule;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _holiday = __webpack_require__(2726);

var _holiday2 = _interopRequireDefault(_holiday);

var _holiday3 = __webpack_require__(1881);

var _holiday4 = _interopRequireDefault(_holiday3);

__webpack_require__(3008);

__webpack_require__(2907);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HolidayComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _holiday2.default,
  controller: _holiday4.default
};

exports.default = HolidayComponent;

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HolidaysController = function () {
  /*@ngInject*/
  HolidaysController.$inject = ["Auth", "$state", "User", "$translate", "BranchService", "Modal", "$stateParams", "HolidayService", "$q", "HolidayModal", "UserBranchService", "uiCalendarConfig", "$scope"];
  function HolidaysController(Auth, $state, User, $translate, BranchService, Modal, $stateParams, HolidayService, $q, HolidayModal, UserBranchService, uiCalendarConfig, $scope) {
    var _this = this;

    (0, _classCallCheck3.default)(this, HolidaysController);

    this.BranchService = BranchService;
    this.HolidayService = HolidayService;
    this.HolidayModal = HolidayModal;
    this.UserBranchService = UserBranchService;
    this.User = User;
    this.$q = $q;
    this.uiCalendarConfig = uiCalendarConfig;

    this.branches = [];
    this.holidays = [];
    this.model = {
      branch: this.User.getUser().branchId,
      loggedInUser: User.getUser().id
    };

    this.hasACL = {};

    //full calendar breaks 'this' so declaring this callback as an arrow fn
    this.alertOnEventClick = function (event, jsEvent, view) {
      var model = {
        id: event.id,
        name: event.title,
        // startDate: event.start,
        // endDate: event.end || event.start, // event.end is null when start and end is same
        startDate: moment.utc(event.start).format('YYYY-MM-DD 12:00:00'),
        endDate: moment.utc(event.end || event.start).format('YYYY-MM-DD 23:59:59'),
        branch: event.branch
      };

      _this.HolidayModal.holidayForm(_this.hasACL, model, function (_ref) {
        var $scope = _ref.$scope,
            modal = _ref.modal;
        //edit cb
        _this.HolidayService.removeGrouped({
          name: event.title,
          branch: event.branch
        }).then(function () {
          return _this.HolidayService.createGrouped({
            startDate: model.startDate,
            endDate: model.endDate,
            // startDate: moment.utc($scope.model.startDate ).format('YYYY-MM-DD 00:00:00'),
            // endDate:  moment.utc($scope.model.endDate).format('YYYY-MM-DD 23:59:59'),
            name: $scope.model.name,
            branch: $scope.model.branch[0] // while editing only single branch is selected
          });
        }).then(function () {
          return _this.loadHolidays();
        }).catch(function (err) {
          console.log(err);
        }).finally(function () {
          return modal.close();
        });
      }, function (_ref2) {
        var modal = _ref2.modal;
        //cancel cb
        modal.close();
      }, function (_ref3) {
        var $scope = _ref3.$scope,
            modal = _ref3.modal;
        //delete cb
        _this.HolidayService.removeGrouped({
          name: $scope.model.name,
          branch: $scope.model.branch
        }).then(function () {
          return _this.loadHolidays();
        }).catch(function (err) {
          return console.log(err);
        }).finally(function () {
          return modal.close();
        });
      });
    };
  }

  (0, _createClass3.default)(HolidaysController, [{
    key: 'loadHolidays',
    value: function loadHolidays() {
      var _this2 = this;

      this.loading = true;

      var searchObj = this.model.branch ? {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branch
          }],
          operator: 'AND'
        }
      } : null;

      this.HolidayService.getGrouped(searchObj, 0, 100).then(function (data) {
        if (data && data.results) {
          _this2.holidays = [data.results.map(function (holiday) {
            return {
              title: holiday.name,
              // start: moment(holiday.holidayDate).hours(0).minutes(0).toDate(),
              // end: moment(holiday.holidayEnd).hours(23).minutes(59).toDate(),
              start: moment.utc(holiday.holidayDate).format('YYYY-MM-DD 12:00:00'),
              end: moment.utc(holiday.holidayEnd).format('YYYY-MM-DD 23:59:59'),
              allDay: false,
              //extra data
              branch: holiday.branchId
            };
          })];
        }
      }).finally(function () {
        _this2.loading = false;
      });
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this3 = this;

      this.loading = true;

      this.uiConfig = {
        calendar: {
          height: 450,
          editable: false,
          header: {
            left: 'title',
            center: '',
            right: 'today prev,next'
          },
          displayEventTime: false,
          eventClick: this.alertOnEventClick,
          loadHolidays: this.loadHolidays()
        }
      };

      this.acl['setting-holiday'].forEach(function (permission) {
        _this3.hasACL[permission] = true;
      });

      var branchDefer = this.UserBranchService.getUserBranches(this.model.loggedInUser).then(function (data) {
        if (data && data.results) {
          _this3.branches = data.results.map(function (branch) {
            return branch.branchId;
          });
        }
      });

      var holidayDefer = this.loadHolidays();

      this.$q.all([branchDefer, holidayDefer]).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'addHoliday',
    value: function addHoliday() {
      var _this4 = this;

      var getHoliday = function getHoliday(name, branch, momentDate) {
        return {
          name: name,
          branchId: branch,
          holidayDate: moment.utc(momentDate).format('YYYY-MM-DD 12:00:00')
        };
      };

      this.HolidayModal.holidayForm(this.hasACL, null, function (_ref4) {
        var $scope = _ref4.$scope,
            modal = _ref4.modal;


        $scope.model.branch.reduce(function (p, branch) {
          var nextIteration = _this4.$q.defer();

          p.then(function () {
            _this4.HolidayService.createGrouped({
              startDate: $scope.model.startDate,
              endDate: $scope.model.endDate,
              name: $scope.model.name,
              branch: branch
            }).then(function () {
              return nextIteration.resolve();
            }).catch(function (err) {
              return nextIteration.reject(err);
            });
          });

          return nextIteration.promise;
        }, _this4.$q.when()).then(function () {
          return _this4.loadHolidays();
        }).catch(function (err) {
          console.error(err);
        }).finally(function () {
          modal.close();
        });
      }, function (_ref5) {
        var modal = _ref5.modal;

        modal.close();
      });
    }
  }]);
  return HolidaysController;
}();

exports.default = HolidaysController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _holiday = __webpack_require__(1880);

var _holiday2 = _interopRequireDefault(_holiday);

var _modal = __webpack_require__(1883);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var holdidayModule = angular.module('holiday', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";
}]).component('holiday', _holiday2.default).service('HolidayModal', _modal2.default).name;

exports.default = holdidayModule;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _holidayFormTemplate = __webpack_require__(2727);

var _holidayFormTemplate2 = _interopRequireDefault(_holidayFormTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HolidayModalFactory = function HolidayModalFactory($uibModal, $translate) {

  var holidayForm = function holidayForm(acl, holidayData, callback, negative, deleteCallback) {
    var modal = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      backdrop: 'static',
      template: _holidayFormTemplate2.default,
      controller: ['$scope', 'BranchService', 'UserBranchService', 'User', function ($scope, BranchService, UserBranchService, User) {
        $scope.acl = acl;
        $scope.model = holidayData;
        $scope.isInEditMode = !!holidayData;
        $scope.titleKey = $scope.isInEditMode ? 'editHoliday' : 'createHoliday';
        $scope.loading = false;
        $scope.today = moment().format('YYYY-MM-DD 12:00:00');
        $scope.loggedInUser = User.getUser().id;
        $scope.todayMinDate = {
          minDate: $scope.today
        };

        var init = function init() {
          return UserBranchService.getUserBranches($scope.loggedInUser).then(function (data) {
            if (data && data.results) {

              if ($scope.isInEditMode) {
                $scope.branches = data.results.filter(function (branch) {
                  return branch.branchId === $scope.model.branch;
                }).map(function (branch) {
                  branch.ticked = true;
                  return branch;
                });
              } else {
                $scope.branches = data.results;
              }
            }
          });
        };

        $scope.isDisabledDate = function (currentDate, mode) {
          if ($scope.model.startDate > $scope.model.endDate) {
            $scope.model.endDate = $scope.model.startDate;
          } else if ($scope.model.startDate == null) {
            $scope.model.endDate = null;
          }
          $scope.effectiveMinDate = {
            minDate: $scope.model.startDate
          };
        };

        $scope.save = function () {
          $scope.loading = true;
          $scope.model.branch = $scope.model.branch.map(function (branchObj) {
            return branchObj.branchId;
          });
          callback({
            $scope: $scope,
            modal: modal
          });
        };

        $scope.cancel = function () {
          negative({
            modal: modal
          });
        };

        $scope.delete = function () {
          $scope.model.branch = $scope.model.branch.map(function (branchObj) {
            return branchObj.branchId;
          })[0];
          deleteCallback({
            $scope: $scope,
            modal: modal
          });
        };

        init().then(function () {

          $scope.$watch(function () {
            if ($scope.model) {
              return $scope.model.startDate;
            }
          }, function (nv, ov) {
            if (!ov && nv) {
              $scope.model.startDate = moment($scope.model.startDate).format('YYYY-MM-DD 12:00:00');
              $scope.model.endDate = moment($scope.model.endDate).format('YYYY-MM-DD 23:59:59');
              $scope.model.endDate = moment($scope.model.startDate).format('YYYY-MM-DD 23:59:59');
            }
          });
        });
      }]
    });
  };

  return {
    holidayForm: holidayForm
  };
};

HolidayModalFactory.$inject = ['$uibModal', '$translate'];

exports.default = HolidayModalFactory;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _home = __webpack_require__(2728);

var _home2 = _interopRequireDefault(_home);

var _home3 = __webpack_require__(1885);

var _home4 = _interopRequireDefault(_home3);

__webpack_require__(3009);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var homeComponent = {
  restrict: 'E',
  bindings: {},
  template: _home2.default,
  controller: _home4.default
};

exports.default = homeComponent;

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _d3Selection = __webpack_require__(377);

var _line = __webpack_require__(317);

var _line2 = _interopRequireDefault(_line);

var _tooltip = __webpack_require__(318);

var _tooltip2 = _interopRequireDefault(_tooltip);

__webpack_require__(532);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeController = function () {
  /*@ngInject*/
  HomeController.$inject = ["Auth", "$state", "ConfigService", "UserService", "DateUtil", "User", "SetupService", "RouteService", "ShipmentService", "BypassCodeService", "$translate", "$location", "$q", "Modal", "HoldService", "HoldLocationService", "$scope", "HomeService", "LogService", "DailyStatService", "$rootScope", "RouteDetailService", "$filter"];
  function HomeController(Auth, $state, ConfigService, UserService, DateUtil, User, SetupService, RouteService, ShipmentService, BypassCodeService, $translate, $location, $q, Modal, HoldService, HoldLocationService, $scope, HomeService, LogService, DailyStatService, $rootScope, RouteDetailService, $filter) {
    (0, _classCallCheck3.default)(this, HomeController);

    this.isDateChanged = function (currentDate, mode) {
      this.loading = true;
      this.vaultDate = currentDate;
      this.dailtStats = [];
      this.getDashboardData();
      this.getYesterdayData();
      if (this.tabShow == 'numbers') {
        this.dashboarShow('numbers');
      } else if (this.tabShow == 'chart') {
        this.dashboarShow('chart');
      }
    };

    this.openDatePicker = function () {
      this.datePopupIsOpened = true;
    };

    this.clearChart = function () {
      this.graphItems.forEach(function (obj, index) {
        if (obj.aclPermission) {
          var selector = '.js-line-chart-container-' + obj.key;
          var selectorLoading = '.js-loading-container-' + obj.key;
          $(selector).empty();
          $(selectorLoading).empty();
        }
      });
    };

    this.getRouteDetailsData = function () {
      var _this = this;

      var routeSearchObj = {
        queryJSON: {
          rules: [{
            field: "branchId",
            condition: "=",
            data: this.model.branch
          }, {
            field: "routeDate",
            condition: "=",
            data: moment(this.currentVaultDate).format("YYYY-MM-DD")
          }],
          operator: 'AND'
        }
      };

      this.RouteDetailService.all(routeSearchObj, 0, 1000).then(function (routeDetails) {
        var routeSchedule = [];
        routeDetails.results.forEach(function (routeData) {
          routeSchedule.push({
            routeId: routeData.routeId,
            routeDate: _this.moment.utc(routeData.routeDate).format('YYYY-MM-DD')
          });
        });
        _this.routeSchedule = routeSchedule;
      }).catch(function (err) {
        _this.loading = false;
      });
    };

    this.Auth = Auth;
    this.$state = $state;
    this.$config = ConfigService;
    this.UserService = UserService;
    this.User = User;
    this.SetupService = SetupService;
    this.RouteService = RouteService;
    this.ShipmentService = ShipmentService;
    this.BypassCodeService = BypassCodeService;
    this.$translate = $translate;
    this.$location = $location;
    this.$q = $q;
    this.Modal = Modal;
    this.HoldService = HoldService;
    this.HoldLocationService = HoldLocationService;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.DateUtil = DateUtil;
    this.HomeService = HomeService;
    this.logService = LogService;
    this.entryTypes = [];
    this.logs = [];
    this.DailyStatService = DailyStatService;
    this.RouteDetailService = RouteDetailService;
    this.model = {
      branch: '',
      loggedInUserId: User.getUser().id
    };
    this.loading = true;
    this.aclPermission = {};
    this.model.branch = this.User.getUser().branchId;

    this.dailtStats = [];
    this.totalChartKeys = [];
    this.graphItems = [];
    this.tabShow = 'numbers';
    this.previousDays = {};
    this.datePopupIsOpened = false;
    this.dailtStatsDataOrNot = false;
    this.vaultDate = "";
    this.dashboardCount = [];
    this.$filter = $filter;
    this.pendingFilesToDownload = [];
    this.routeProgressDetails = [];
  }

  (0, _createClass3.default)(HomeController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.$config.getConfig().then(function (cfg) {
        return _this2.applicationVersion = cfg.config.version;
      });
      this.loading = true;
      this.moment = moment;
      this.recentActivities();
      this.loadAclPermission();
      this.SetupService.get(this.model.branch).then(function (data) {
        _this2.vaultDate = _this2.DateUtil.convertToDate(data.currentVaultDate || undefined);
        _this2.currentVaultDate = _this2.DateUtil.convertToDate(data.currentVaultDate || undefined);
        _this2.getDashboardData();
        _this2.getYesterdayData();
        _this2.getRouteDetailsData();
        _this2.loading = false;
        _this2.options = {
          maxDate: _this2.vaultDate,
          showWeeks: true
        };
      }).catch(function (err) {
        _this2.loading = false;
        console.log(err);
        if (err && err.data && err.data.message) {
          _this2.Modal.errorModal('error.' + err.data.message);
        }
      });
      this.$rootScope.$broadcast('routeChange', '/app/home');
    }
  }, {
    key: 'dashboarShow',
    value: function dashboarShow(tabName) {
      this.tabShow = tabName;
      if (this.tabShow == 'chart' && !_lodash2.default.hasIn(this.dailtStats, 'bagoutCount')) {
        this.clearChart();
        this.loadGraphData();
      }
    }
  }, {
    key: 'getTotalChartKeys',
    value: function getTotalChartKeys() {
      return [{
        key: 'checkInCount',
        label: this.$translate.instant('dashboard.check_in'),
        aclPermission: angular.isDefined(this.aclPermission.check_in),
        maxRatio: 2
      }, {
        key: 'checkOutCount',
        label: this.$translate.instant('dashboard.check_out'),
        aclPermission: angular.isDefined(this.aclPermission.check_out),
        maxRatio: 2
      }, {
        key: 'checkInTotalAmount',
        label: this.$translate.instant('dashboard.check_in_amount'),
        aclPermission: angular.isDefined(this.aclPermission.check_in),
        maxRatio: 2
      }, {
        key: 'checkOutTotalAmount',
        label: this.$translate.instant('dashboard.check_out_amount'),
        aclPermission: angular.isDefined(this.aclPermission.check_out),
        maxRatio: 2
      }, {
        key: 'holdCount',
        label: this.$translate.instant('dashboard.shipment_hold'),
        aclPermission: angular.isDefined(this.aclPermission.branch_mgmt_item_holds),
        maxRatio: 2
      }, {
        key: 'holdLocationCount',
        label: this.$translate.instant('dashboard.location_hold'),
        aclPermission: angular.isDefined(this.aclPermission.branch_mgmt_location_holds),
        maxRatio: 2
      }, {
        key: 'byPassCodeCount',
        label: this.$translate.instant('dashboard.bypasscode_used'),
        aclPermission: angular.isDefined(this.aclPermission.branch_mgmt_bypass_code),
        maxRatio: 2
      }, {
        key: 'bagoutCount',
        label: this.$translate.instant('dashboard.bag_out'),
        aclPermission: angular.isDefined(this.aclPermission.bag_out),
        maxRatio: 2
      }, {
        key: 'activeAppUsers',
        label: this.$translate.instant('dashboard.active_app_users'),
        aclPermission: angular.isDefined(this.aclPermission['setting-users']),
        maxRatio: 2
      }, {
        key: 'serviceTickets',
        label: this.$translate.instant('navbar.serviceTickets_title'),
        aclPermission: angular.isDefined(this.aclPermission['service_tickets']),
        maxRatio: 2
      }, {
        key: 'routeRunTime',
        label: this.$translate.instant('dashboard.route_run_time'),
        aclPermission: angular.isDefined(this.aclPermission['route_control']),
        maxRatio: 2
      }, {
        key: 'countedResidualsAmount',
        label: this.$translate.instant('branch_mgmt.daily_balance_sheet.actualResidual'),
        aclPermission: angular.isDefined(this.aclPermission.atm_count),
        maxRatio: 2
      }, {
        key: 'cashDepositedAmount',
        label: this.$translate.instant('dashboard.total_cash_deposited'),
        aclPermission: angular.isDefined(this.aclPermission.atm_count),
        maxRatio: 2
      }];
    }
  }, {
    key: 'loadAclPermission',
    value: function loadAclPermission() {
      var _this3 = this;

      this.UserService.acl(this.User.getUser().id, this.model.branch).then(function (permissions) {
        _this3.aclPermission = permissions;
      }).catch(function (e) {
        return console.log('error in permission', e);
      });
    }
  }, {
    key: 'loadGraphData',
    value: function loadGraphData() {
      var _this4 = this;

      this.dailtStatsDataOrNot = false;
      this.graphItems = this.getTotalChartKeys();
      var endDate = this.moment.utc(this.vaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      var startDate = moment.utc(moment.utc(endDate).subtract(6, 'days')).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      var grediantColor = ['#41cfea', '#6AEDC7', '#41cfea', '#6AEDC7', '#41cfea', '#6AEDC7', '#ffb11b', '#f3c51c', '#ffb11b', '#f3c51c', '#ffb11b', '#f3c51c', '#fd9e62', '#ffa71a', '#fd9e62', '#ffa71a', '#fd9e62', '#ffa71a'];
      setTimeout(function () {
        _this4.graphItems.forEach(function (obj, index) {
          if (obj.aclPermission) {
            var selector = '.js-loading-container-' + obj.key;
            var lineChart = (0, _line2.default)(),
                lineContainer = (0, _d3Selection.select)(selector),
                containerWidth = lineContainer.node() ? lineContainer.node().getBoundingClientRect().width : false;
            if (containerWidth) {
              lineContainer.html(lineChart.loadingState());
            }
          }
        });
      }, 100);

      this.DailyStatService.getDailyStats(startDate, endDate, this.model.branch).then(function (res) {
        var chartArray = {};
        _this4.dailtStatsRecord = res;
        if (!res.length) {
          setTimeout(function () {
            _this4.graphItems.forEach(function (obj, index) {
              if (obj.aclPermission) {
                var selectorLoading = '.js-loading-container-' + obj.key;
                $(selectorLoading).empty();
                _this4.dailtStatsDataOrNot = true;
              }
            });
          }, 500);
        }

        if (res.length) {
          //create dataset object 
          res.forEach(function (item, index) {
            var dataObj = item.data;
            _this4.graphItems.forEach(function (obj, index) {
              if (obj.aclPermission) {
                if (chartArray[obj.key] && chartArray[obj.key].dataset) {
                  chartArray[obj.key]['dataset'].dataByTopic[0].dates.push({
                    date: _this4.moment.utc(item.date).format('DD-MMM-YYYY'),
                    value: dataObj[obj.key] || 0,
                    fullDate: _this4.moment.utc(item.date).format()
                  });
                } else {
                  chartArray[obj.key] = {
                    dataset: {}
                  };
                  chartArray[obj.key].dataset = {
                    dataByTopic: [{
                      topic: obj.key,
                      topicName: obj.label,
                      branch: item.branchId,
                      dates: [{
                        date: _this4.moment.utc(item.date).format('DD-MMM-YYYY'),
                        value: dataObj[obj.key] || 0,
                        fullDate: _this4.moment.utc(item.date).format()
                      }]
                    }]
                  };
                  if (obj.key.indexOf('Amount') >= 0) {
                    chartArray[obj.key].dataset.dataByTopic[0].topicName = obj.label.replace(obj.label, 'Amount');
                  }
                }
              }
            });
          });
          _this4.dailtStats = chartArray;
          var i = 0;
          _this4.graphItems.forEach(function (obj, index) {
            if (obj.aclPermission) {
              var selector = '.js-line-chart-container-' + obj.key;
              var selectorLoading = '.js-loading-container-' + obj.key;
              var lineChart = (0, _line2.default)(),
                  chartTooltip = (0, _tooltip2.default)(),
                  lineContainer = (0, _d3Selection.select)(selector),
                  containerWidth = lineContainer.node() ? lineContainer.node().getBoundingClientRect().width : false,
                  tooltipContainer = void 0,
                  dataset = void 0;

              if (containerWidth) {
                dataset = chartArray[obj.key].dataset;
                setTimeout(function () {
                  $(selectorLoading).empty();
                  lineChart.lineGradient([grediantColor[i], grediantColor[i + 1]]).colorSchema([grediantColor[i + 1]]).isAnimated(false).aspectRatio(0.7).height(200).tooltipThreshold(0).grid('horizontal').lineCurve('catmullRom').width(containerWidth).margin({ left: 50, right: 20, top: 20, bottom: 50 }).xTicks(2).dateLabel('date').valueLabel('value').on('customMouseOver', chartTooltip.show).on('customMouseMove', function (dataPoint, topicColorMap, x) {
                    chartTooltip.update(dataPoint, topicColorMap, 66);
                  }).on('customMouseOut', chartTooltip.hide);

                  lineContainer.datum(dataset).call(lineChart);

                  tooltipContainer = (0, _d3Selection.select)(selector + ' .line-chart .metadata-group');
                  chartTooltip.title(obj.label);
                  if (obj.key.indexOf('Amount') >= 0) {
                    chartTooltip.valueFormatter(function (value) {
                      return _this4.$filter('currency')(value, '$', 2);
                    });
                  }
                  tooltipContainer.datum([]).call(chartTooltip);

                  var redrawChart = function redrawChart() {
                    var container = (0, _d3Selection.select)(selector);
                    var newContainerWidth = container.node() ? container.node().getBoundingClientRect().width : false;
                    // Setting the new width on the chart
                    lineChart.width(newContainerWidth);
                    // Rendering the chart again
                    container.datum(dataset).call(lineChart);
                  };
                  var throttledRedraw = _lodash2.default.throttle(redrawChart, 200);
                  window.addEventListener("resize", throttledRedraw);
                  i += 2;
                }, 1000);
                _this4.loading = false;
              }
            }
          });
        }
      });
    }

    // Load dashboard statistics

  }, {
    key: 'getDashboardData',
    value: function getDashboardData() {
      var _this5 = this;

      if (moment(this.vaultDate).isSame(this.currentVaultDate, 'day')) {
        this.HomeService.dashboard(moment(this.vaultDate).format('YYYY-MM-DD'), this.model.branch, this.model.loggedInUserId).then(function (data) {
          _this5.uploadedFileList = data.batchFiles;
          // this.pendingFilesToDownload = data.pendingFilesToDownload || [];
          _this5.routeProgressDetails = data.routesInProgress || [];
          _this5.dashboardCount = _this5.getTotalChartKeys();
          _this5.dashboardCount.forEach(function (obj, index) {
            obj.hasCurrency = false;
            obj.itemCount = data[obj.key] || 0;
            if (obj.key.indexOf('Amount') >= 0) {
              obj.hasCurrency = true;
            }
          });
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        var endDate = moment(this.vaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
        var startDate = moment.utc(endDate).startOf('day').format('YYYY-MM-DD 00:00:00');
        var data = void 0;

        this.DailyStatService.getDailyStats(startDate, endDate, this.model.branch).then(function (dailyStats) {
          return _this5.HomeService.branchStats(_this5.model.branch, startDate, endDate, _this5.model.loggedInUserId).then(function (branchStats) {
            return [dailyStats, branchStats];
          });
        }).then(function (_ref) {
          var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
              dailyStats = _ref2[0],
              branchStats = _ref2[1];

          // let data = dailyStats.length && dailyStats[0].data ? dailyStats[0].data : {};
          var keys = (0, _keys2.default)(branchStats.results);

          keys.forEach(function (key) {
            data = (0, _assign2.default)(dailyStats.length ? dailyStats[0].data : {}, (0, _defineProperty3.default)({}, key, branchStats.results[key] && branchStats.results[key][0] ? branchStats.results[key][0] : branchStats.results[key] !== null ? branchStats.results[key] : 0));
          });

          _this5.dashboardCount = _this5.getTotalChartKeys();
          _this5.dashboardCount.forEach(function (obj, index) {
            data[obj.key] = data[obj.key] && data[obj.key].length === 0 ? 0 : data[obj.key];
            obj.hasCurrency = false;
            obj.itemCount = data[obj.key] || 0;
            if (obj.key.indexOf('Amount') >= 0) {
              obj.hasCurrency = true;
            }
          });
        });
      }
    }
  }, {
    key: 'getYesterdayData',
    value: function getYesterdayData() {
      var _this6 = this;

      var endDate = moment(this.vaultDate).subtract(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
      var startDate = moment.utc(moment.utc(endDate)).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      var keys = this.getTotalChartKeys();
      this.DailyStatService.getDailyStats(startDate, endDate, this.model.branch).then(function (res) {
        if (res.length && res[0].data) {
          // let data = JSON.parse(res[0].data);
          var data = res[0].data;
          keys.forEach(function (obj) {
            _this6.previousDays[obj.key] = data[obj.key] || 0;
          });
        } else {
          keys.forEach(function (obj) {
            _this6.previousDays[obj.key] = 0;
          });
        }
        _this6.loading = false;
      }).catch(function (err) {
        console.log(err);
        keys.forEach(function (obj) {
          _this6.previousDays[obj.key] = 0;
        });
      });
    }
  }, {
    key: 'recentActivities',
    value: function recentActivities() {
      var _this7 = this;

      this.model.gettingRecentLogs = true;
      this.logService.recentActivity(this.model.branch, this.entryType).then(function (data) {
        _this7.logs = data.results;
        if (_this7.logs.length) {
          _this7.logs.forEach(function (log) {
            log.readableEntryType = _this7.$translate.instant('entry_type.' + log.entryType);
            if (log.entryData) {
              log.extraDetails = (0, _entries2.default)(log.entryData).map(function (entry) {
                return {
                  key: entry[0],
                  value: (0, _typeof3.default)(entry[1]) === 'object' ? (0, _stringify2.default)(entry[1]) : entry[1]
                };
              });
            }
          });
          _this7.entryTypes = data.entryTypes.map(function (entryType) {
            return {
              label: _this7.$translate.instant('entry_type.' + entryType),
              value: entryType
            };
          });
        }
      }).catch(function (err) {
        _this7.error = err.message;
      }).finally(function () {
        _this7.model.gettingRecentLogs = false;
      });
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(log) {
      log.expand = !log.expand;
    }
  }]);
  return HomeController;
}();

exports.default = HomeController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(4)))

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _home = __webpack_require__(1884);

var _home2 = _interopRequireDefault(_home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var homeModule = angular.module('home', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/home');

  $stateProvider.state('home', {
    url: '/home',
    component: 'home',
    data: {
      requireLogin: true
    },
    parent: 'app'
  });
}]).component('home', _home2.default).name;

exports.default = homeModule;

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _home = __webpack_require__(1886);

var _home2 = _interopRequireDefault(_home);

var _login = __webpack_require__(1950);

var _login2 = _interopRequireDefault(_login);

var _forgot_password = __webpack_require__(1879);

var _forgot_password2 = _interopRequireDefault(_forgot_password);

var _settings = __webpack_require__(526);

var _settings2 = _interopRequireDefault(_settings);

var _item = __webpack_require__(1897);

var _item2 = _interopRequireDefault(_item);

var _routes = __webpack_require__(2034);

var _routes2 = _interopRequireDefault(_routes);

var _carrier = __webpack_require__(1833);

var _carrier2 = _interopRequireDefault(_carrier);

var _location = __webpack_require__(1932);

var _location2 = _interopRequireDefault(_location);

var _users = __webpack_require__(2362);

var _users2 = _interopRequireDefault(_users);

var _truck = __webpack_require__(2347);

var _truck2 = _interopRequireDefault(_truck);

var _main = __webpack_require__(1951);

var _main2 = _interopRequireDefault(_main);

var _vault = __webpack_require__(2374);

var _vault2 = _interopRequireDefault(_vault);

var _batch = __webpack_require__(1646);

var _batch2 = _interopRequireDefault(_batch);

var _access_denied = __webpack_require__(524);

var _access_denied2 = _interopRequireDefault(_access_denied);

var _routeSheet = __webpack_require__(2001);

var _routeSheet2 = _interopRequireDefault(_routeSheet);

var _checkin = __webpack_require__(1838);

var _checkin2 = _interopRequireDefault(_checkin);

var _checkout = __webpack_require__(1844);

var _checkout2 = _interopRequireDefault(_checkout);

var _shipment_batch = __webpack_require__(2069);

var _shipment_batch2 = _interopRequireDefault(_shipment_batch);

var _route_control = __webpack_require__(2013);

var _route_control2 = _interopRequireDefault(_route_control);

var _route_throw = __webpack_require__(2022);

var _route_throw2 = _interopRequireDefault(_route_throw);

var _bagout = __webpack_require__(1632);

var _bagout2 = _interopRequireDefault(_bagout);

var _coin_pull_report = __webpack_require__(1852);

var _coin_pull_report2 = _interopRequireDefault(_coin_pull_report);

var _holiday = __webpack_require__(1882);

var _holiday2 = _interopRequireDefault(_holiday);

var _user_profile = __webpack_require__(2350);

var _user_profile2 = _interopRequireDefault(_user_profile);

var _branch = __webpack_require__(1660);

var _branch2 = _interopRequireDefault(_branch);

var _log = __webpack_require__(1945);

var _log2 = _interopRequireDefault(_log);

var _branch_management = __webpack_require__(1815);

var _branch_management2 = _interopRequireDefault(_branch_management);

var _vault_close = __webpack_require__(2380);

var _vault_close2 = _interopRequireDefault(_vault_close);

var _order_packing = __webpack_require__(1967);

var _order_packing2 = _interopRequireDefault(_order_packing);

var _bulk_cash_management = __webpack_require__(1818);

var _bulk_cash_management2 = _interopRequireDefault(_bulk_cash_management);

var _atm_count = __webpack_require__(1624);

var _atm_count2 = _interopRequireDefault(_atm_count);

var _deposit_packing = __webpack_require__(1873);

var _deposit_packing2 = _interopRequireDefault(_deposit_packing);

var _vault_balance = __webpack_require__(2377);

var _vault_balance2 = _interopRequireDefault(_vault_balance);

var _branch_funding_source = __webpack_require__(1672);

var _branch_funding_source2 = _interopRequireDefault(_branch_funding_source);

var _atm_codes_management = __webpack_require__(1621);

var _atm_codes_management2 = _interopRequireDefault(_atm_codes_management);

var _reset_atm_code = __webpack_require__(1998);

var _reset_atm_code2 = _interopRequireDefault(_reset_atm_code);

var _route_progress = __webpack_require__(2016);

var _route_progress2 = _interopRequireDefault(_route_progress);

var _service_tickets = __webpack_require__(2064);

var _service_tickets2 = _interopRequireDefault(_service_tickets);

var _service_settings = __webpack_require__(2043);

var _service_settings2 = _interopRequireDefault(_service_settings);

var _vault_operations = __webpack_require__(2383);

var _vault_operations2 = _interopRequireDefault(_vault_operations);

var _route_stats = __webpack_require__(2019);

var _route_stats2 = _interopRequireDefault(_route_stats);

var _branch_funding_source_holiday = __webpack_require__(1684);

var _branch_funding_source_holiday2 = _interopRequireDefault(_branch_funding_source_holiday);

var _master_cash_schedule = __webpack_require__(1954);

var _master_cash_schedule2 = _interopRequireDefault(_master_cash_schedule);

var _tnt_billing = __webpack_require__(2176);

var _tnt_billing2 = _interopRequireDefault(_tnt_billing);

var _tnt_control = __webpack_require__(2333);

var _tnt_control2 = _interopRequireDefault(_tnt_control);

var _delivery_region_routing = __webpack_require__(1870);

var _delivery_region_routing2 = _interopRequireDefault(_delivery_region_routing);

var _service_ticket_parts = __webpack_require__(2061);

var _service_ticket_parts2 = _interopRequireDefault(_service_ticket_parts);

var _verify_2FA_code = __webpack_require__(2386);

var _verify_2FA_code2 = _interopRequireDefault(_verify_2FA_code);

var _reporting = __webpack_require__(1992);

var _reporting2 = _interopRequireDefault(_reporting);

var _item_type = __webpack_require__(1912);

var _item_type2 = _interopRequireDefault(_item_type);

var _tnt_react_app = __webpack_require__(2336);

var _tnt_react_app2 = _interopRequireDefault(_tnt_react_app);

var _on_demand_call = __webpack_require__(1960);

var _on_demand_call2 = _interopRequireDefault(_on_demand_call);

var _pickup_request_management = __webpack_require__(1979);

var _pickup_request_management2 = _interopRequireDefault(_pickup_request_management);

var _coin_management = __webpack_require__(1849);

var _coin_management2 = _interopRequireDefault(_coin_management);

var _auto_routing = __webpack_require__(1629);

var _auto_routing2 = _interopRequireDefault(_auto_routing);

var _cash_activity = __webpack_require__(1835);

var _cash_activity2 = _interopRequireDefault(_cash_activity);

var _ach_management = __webpack_require__(1616);

var _ach_management2 = _interopRequireDefault(_ach_management);

var _mileage_report = __webpack_require__(1773);

var _mileage_report2 = _interopRequireDefault(_mileage_report);

var _app_event_logs = __webpack_require__(1618);

var _app_event_logs2 = _interopRequireDefault(_app_event_logs);

var _preventative_maintenance = __webpack_require__(1981);

var _preventative_maintenance2 = _interopRequireDefault(_preventative_maintenance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Customer from './customer'
var componentModule = _angular2.default.module('app.components', [_main2.default, _home2.default, _login2.default, _forgot_password2.default, _routeSheet2.default, _settings2.default, _batch2.default, _branch2.default, _vault2.default,
// Customer,
// Contract,
_item2.default, _routes2.default, _carrier2.default,
// Message,
// Shiptype,
_users2.default, _location2.default, _truck2.default, _access_denied2.default, _checkin2.default, _checkout2.default, _shipment_batch2.default, _route_control2.default, _bagout2.default, _coin_pull_report2.default, _holiday2.default, _user_profile2.default,
// Setup,
_log2.default, _route_throw2.default, _branch_management2.default, _vault_close2.default, _order_packing2.default, _bulk_cash_management2.default, _atm_count2.default, _deposit_packing2.default, _vault_balance2.default,
// Denomination,
_branch_funding_source2.default, _atm_codes_management2.default,
// MobileApp,
// FuelSurcharges,
// Account,
_reset_atm_code2.default, _route_progress2.default,
// SoftDeletedShipments,
_service_tickets2.default, _service_settings2.default,
// BillableEvents,
// BillingCategory,
_vault_operations2.default, _route_stats2.default, _branch_funding_source_holiday2.default, _master_cash_schedule2.default, _tnt_billing2.default, _tnt_control2.default, _delivery_region_routing2.default, _service_ticket_parts2.default, _verify_2FA_code2.default, _reporting2.default, _item_type2.default, _tnt_react_app2.default, _on_demand_call2.default, _pickup_request_management2.default, _coin_management2.default, _auto_routing2.default, _cash_activity2.default, _ach_management2.default, _mileage_report2.default, _app_event_logs2.default, _preventative_maintenance2.default]).directive('hideZero', function () {
    return {
        link: function link(scope, element) {
            element.on('input change', function () {
                if (this.value === '0') {
                    this.value = '';
                }
            });
        }
    };
}).name;
// import BillingCategory from './billing_category'

// import SoftDeletedShipments from './soft_deleted_shipments'

// import FuelSurcharges from './fuel_surcharges'
// import Account from './account'

// import Setup from './setup'

// import Contract from './contract'
exports.default = componentModule;

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _itemAll = __webpack_require__(1889);

var _itemAll2 = _interopRequireDefault(_itemAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemallModule = angular.module('itemall', []).component('itemall', _itemAll2.default).name;

exports.default = itemallModule;

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _itemAll = __webpack_require__(2729);

var _itemAll2 = _interopRequireDefault(_itemAll);

var _itemAll3 = __webpack_require__(1890);

var _itemAll4 = _interopRequireDefault(_itemAll3);

__webpack_require__(3010);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _itemAll2.default,
  controller: _itemAll4.default
};

exports.default = itemallComponent;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _itemBase = __webpack_require__(268);

var _itemBase2 = _interopRequireDefault(_itemBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemallController = function (_ItemBaseController) {
  itemallController.$inject = ["Auth", "$state", "User", "Modal", "ItemService", "$translate", "$stateParams", "Navigation"];
  (0, _inherits3.default)(itemallController, _ItemBaseController);

  /*@ngInject*/
  function itemallController(Auth, $state, User, Modal, ItemService, $translate, $stateParams, Navigation) {
    (0, _classCallCheck3.default)(this, itemallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (itemallController.__proto__ || (0, _getPrototypeOf2.default)(itemallController)).call(this, Auth, $state, User, ItemService, Modal, $translate, $stateParams, Navigation));

    _this.sortData = function (column) {
      _this.model.reverseSort = _this.model.sortColumn == column ? !_this.model.reverseSort : true;
      _this.model.sortColumn = column;
      _this.loadData();
    };

    _this.goToUserTab = function (userKey) {
      if (!userKey) return;
      _this.Navigation.goToUserTab(userKey, null);
    };

    _this.User = User;
    _this.$state = $state;
    _this.Navigation = Navigation;
    _this.hasAcl = {};
    _this.model = {
      branchId: _this.User.getUser().branchId,
      loggedInUserId: _this.User.getUser().id,
      itemsObj: {
        results: [],
        status: null,
        pagination: {
          page: 1,
          total: 0,
          pageLimit: 10,
          maxPages: 10
        },
        loading: false,
        searchText: null,
        statusList: [{ label: 'Checked Out', value: 'checkedOut' }, { label: 'Checked In', value: 'checkedIn' }, { label: 'Hold', value: 'hold' }, { label: 'Deleted', value: 'deleted' }, { label: 'Lost', value: 'lost' }]
      },
      sortColumn: "assignmentCreatedAt",
      reverseSort: false
    };
    _this.selectedItemStatus = null;
    return _this;
  }

  (0, _createClass3.default)(itemallController, [{
    key: '$onInit',
    value: function $onInit() {
      this.loadData();
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this2 = this;

      this.model.itemsObj.loading = true;
      this.Service.getItemList(this.model.branchId, this.model.itemsObj.searchText, this.model.itemsObj.pagination.pageLimit, (this.model.itemsObj.pagination.page - 1) * this.model.itemsObj.pagination.pageLimit, this.model.reverseSort, this.model.sortColumn, this.selectedItemStatus).then(function (data) {
        _this2.model.itemsObj.pagination.total = data.total;
        _this2.model.itemsObj.results = data.results;
        _this2.totalAssigned = data.totalAssigned;
        _this2.totalAvailable = data.totalAvailable;
        _this2.totalCheckout = data.totalCheckout;
        _this2.totalHold = data.totalHold;
        _this2.totalLost = data.totalLost;
        _this2.totalDeleted = data.totalDeleted;
      }).catch(function (err) {
        _this2.error = err.message;
      }).finally(function () {
        _this2.model.itemsObj.loading = false;
        setTimeout(function () {
          var el = document.getElementById('itemsSearchText');
          if (el) el.focus();
        }, 100);
      });
    }
  }, {
    key: 'translateStatus',
    value: function translateStatus(statusCode) {
      return this.$translate.instant('shipment.' + statusCode);
    }
  }, {
    key: 'filterItemView',
    value: function filterItemView() {
      this.model.itemsObj.pagination.page = 1;
      this.loadData();
    }
  }, {
    key: 'editItems',
    value: function editItems(items) {
      this.$state.go('items.edit', {
        id: items.itemId
      });
    }
  }, {
    key: 'logisticItemAssign',
    value: function logisticItemAssign(data) {
      var _this3 = this;

      this.Modal.logisticItemAssignModal(data, function (_ref) {
        var modal = _ref.modal,
            barcode = _ref.barcode,
            routeId = _ref.routeId,
            notes = _ref.notes,
            userKey = _ref.userKey;

        _this3.model.isAssign = true;
        return _this3.Service.logisticItemAssign(_this3.model.branchId, barcode, _this3.model.loggedInUserId, routeId, notes, true, userKey, data.itemId, 5).then(function () {
          _this3.resetPage();
          _this3.loadData();
        }).catch(function (err) {
          _this3.formatErrorMessage(err);
        }).finally(function () {
          _this3.model.isAssign = false;
        });
      }, function (_ref2) {
        var modal = _ref2.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'confirmItemHold',
    value: function confirmItemHold(item) {
      var _this4 = this;

      this.Modal.confirm({
        header: this.$translate.instant('branch.confirm'),
        message: this.$translate.instant('item.confirm_hold_message', { lable: item.label }),
        callback: function callback(_ref3) {
          var modal = _ref3.modal;

          _this4.model.isSendToHold = true;
          _this4.Service.logisticItemHold(_this4.model.branchId, item.barcode, _this4.model.loggedInUserId).then(function () {
            _this4.resetPage();
            _this4.loadData();
          }).catch(function (err) {
            _this4.formatErrorMessage(err);
          }).finally(function () {
            modal.close();
            _this4.model.isSendToHold = false;
          });
        },
        negative: function negative(_ref4) {
          var modal = _ref4.modal;

          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'confirmItemHoldRelease',
    value: function confirmItemHoldRelease(data) {
      var _this5 = this;

      this.Modal.logisticItemHoldReleaseModal(data, function (_ref5) {
        var modal = _ref5.modal,
            barcode = _ref5.barcode,
            notes = _ref5.notes;

        _this5.model.isAssign = true;
        return _this5.Service.logisticItemHoldRelease(_this5.model.branchId, barcode, _this5.model.loggedInUserId, data.routeId, notes).then(function () {
          _this5.resetPage();
          _this5.loadData();
        }).catch(function (err) {
          _this5.formatErrorMessage(err);
        }).finally(function () {
          _this5.model.isAssign = false;
        });
      }, function (_ref6) {
        var modal = _ref6.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'confirmItemDelete',
    value: function confirmItemDelete(item) {
      var _this6 = this;

      this.Modal.confirm({
        header: this.$translate.instant('branch.confirm'),
        message: this.$translate.instant('item.confirm_delete_message', { lable: item.label }),
        callback: function callback(_ref7) {
          var modal = _ref7.modal;

          _this6.model.isDeleting = true;
          _this6.Service.logisticItemDelete(_this6.model.branchId, item.barcode, _this6.model.loggedInUserId).then(function () {
            _this6.resetPage();
            _this6.loadData();
          }).catch(function (err) {
            _this6.formatErrorMessage(err);
          }).finally(function () {
            modal.close();
            _this6.model.isDeleting = false;
          });
        },
        negative: function negative(_ref8) {
          var modal = _ref8.modal;

          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'confirmItemCheckIn',
    value: function confirmItemCheckIn(item) {
      var _this7 = this;

      this.Modal.confirm({
        header: this.$translate.instant('branch.confirm'),
        message: this.$translate.instant('item.confirm_check_in_message', { lable: item.label }),
        callback: function callback(_ref9) {
          var modal = _ref9.modal;

          _this7.model.isDeleting = true;
          _this7.Service.logisticItemCheckIn(_this7.model.branchId, item.barcode, _this7.model.loggedInUserId).then(function () {
            _this7.resetPage();
            _this7.loadData();
          }).catch(function (err) {
            _this7.formatErrorMessage(err);
          }).finally(function () {
            modal.close();
            _this7.model.isDeleting = false;
          });
        },
        negative: function negative(_ref10) {
          var modal = _ref10.modal;

          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'logisticItemReAssign',
    value: function logisticItemReAssign(data) {
      var _this8 = this;

      this.Modal.logisticItemAssignModal(data, function (_ref11) {
        var modal = _ref11.modal,
            barcode = _ref11.barcode,
            routeId = _ref11.routeId,
            notes = _ref11.notes,
            userKey = _ref11.userKey;

        _this8.model.isAssign = true;
        return _this8.Service.logisticItemReAssign(_this8.model.branchId, barcode, _this8.model.loggedInUserId, routeId, notes, data.itemAssignmentId, userKey, data.itemId, 5).then(function () {
          _this8.resetPage();
          _this8.loadData();
        }).catch(function (err) {
          _this8.formatErrorMessage(err);
        }).finally(function () {
          _this8.model.isAssign = false;
        });
      }, function (_ref12) {
        var modal = _ref12.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'confirmUndoItemAssignment',
    value: function confirmUndoItemAssignment(item) {
      var _this9 = this;

      this.Modal.confirm({
        header: this.$translate.instant('branch.confirm'),
        message: this.$translate.instant('item.confirm_undo_item_assignment_warning'),
        callback: function callback(_ref13) {
          var modal = _ref13.modal;

          _this9.model.undoItemAssignment = true;
          _this9.Service.undoItemAssignment(_this9.model.branchId, item.barcode, _this9.model.loggedInUserId, item.routeId, item.itemAssignmentId, item.userKey, item.itemId, 6).then(function () {
            _this9.resetPage();
            _this9.loadData();
          }).catch(function (err) {
            _this9.formatErrorMessage(err);
          }).finally(function () {
            modal.close();
            _this9.model.undoItemAssignment = false;
          });
        },
        negative: function negative(_ref14) {
          var modal = _ref14.modal;

          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'formatErrorMessage',
    value: function formatErrorMessage(err) {
      var errorPrefix = err.data.message.length === 5 ? 'error.' : '';
      this.Modal.errorModal(errorPrefix + err.data.message);
    }
  }, {
    key: 'itemHistory',
    value: function itemHistory(item) {
      this.Modal.itemHistory(item, function (_ref15) {
        // modal.close();

        var modal = _ref15.modal;
      }, function (_ref16) {
        var modal = _ref16.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'filterRecords',
    value: function filterRecords(value) {
      this.model.itemsObj.pagination.page = 1;
      this.selectedItemStatus = this.selectedItemStatus === value ? undefined : value;
      document.getElementById(value).blur();
      this.loadData();
    }
  }, {
    key: 'confirmItemLost',
    value: function confirmItemLost(item) {
      var _this10 = this;

      this.Modal.confirm({
        header: this.$translate.instant('branch.confirm'),
        message: this.$translate.instant('item.confirm_lost_message', { lable: item.label }),
        callback: function callback(_ref17) {
          var modal = _ref17.modal;

          _this10.model.isLost = true;
          _this10.Service.logisticItemLost(_this10.model.branchId, item.barcode, _this10.model.loggedInUserId, item.itemId, 7, item.routeId, item.userKey).then(function () {
            _this10.resetPage();
            _this10.loadData();
          }).catch(function (err) {
            _this10.formatErrorMessage(err);
          }).finally(function () {
            modal.close();
            _this10.model.isLost = false;
          });
        },
        negative: function negative(_ref18) {
          var modal = _ref18.modal;

          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'confirmItemReturnToAvailable',
    value: function confirmItemReturnToAvailable(item) {
      var _this11 = this;

      this.Modal.confirmSupervisor('return-item-available', null, function (_ref19) {
        var modal = _ref19.modal,
            supId = _ref19.supId;

        _this11.model.isReturnAvailable = true;
        _this11.Service.logisticItemReturnAvailable(_this11.model.branchId, item.barcode, supId, item.itemId, 9, item.routeId, item.userKey).then(function () {
          _this11.resetPage();
          _this11.loadData();
        }).catch(function (err) {
          _this11.formatErrorMessage(err);
        }).finally(function () {
          modal.close();
          _this11.model.isReturnAvailable = false;
        });
      }, function (_ref20) {
        var modal = _ref20.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'resetPage',
    value: function resetPage() {
      this.model.itemsObj.pagination.page = 1;
    }
  }]);
  return itemallController;
}(_itemBase2.default);

exports.default = itemallController;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _itemCreate = __webpack_require__(1892);

var _itemCreate2 = _interopRequireDefault(_itemCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemCreateModule = angular.module('itemcreate', []).component('itemcreate', _itemCreate2.default).name;

exports.default = itemCreateModule;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _itemCreate = __webpack_require__(2730);

var _itemCreate2 = _interopRequireDefault(_itemCreate);

var _itemCreate3 = __webpack_require__(1893);

var _itemCreate4 = _interopRequireDefault(_itemCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemCreateComponent = {
  restrict: 'E',
  bindings: {},
  template: _itemCreate2.default,
  controller: _itemCreate4.default
};

exports.default = itemCreateComponent;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _itemBase = __webpack_require__(268);

var _itemBase2 = _interopRequireDefault(_itemBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemCreateController = function (_ItemBaseController) {
	ItemCreateController.$inject = ["Auth", "$state", "User", "ItemService", "Modal", "$translate", "$stateParams", "LocationService", "ServiceOrderService", "DateUtil"];
	(0, _inherits3.default)(ItemCreateController, _ItemBaseController);

	/*@ngInject*/
	function ItemCreateController(Auth, $state, User, ItemService, Modal, $translate, $stateParams, LocationService, ServiceOrderService, DateUtil) {
		(0, _classCallCheck3.default)(this, ItemCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (ItemCreateController.__proto__ || (0, _getPrototypeOf2.default)(ItemCreateController)).call(this, Auth, $state, User, ItemService, Modal, $translate, $stateParams));

		_this.LocationService = LocationService;
		_this.ServiceOrderService = ServiceOrderService;
		_this.ItemService = ItemService;
		_this.user = User;
		_this.DateUtil = DateUtil;
		_this.hasACL = {};
		_this.defaultModel = {
			itemTypeId: null,
			barcode: null,
			itemLabel: null,
			notes: null,
			loggedInUserId: _this.User.getUser().id,
			selectedBranch: [],
			errorMessage: '',
			branchId: _this.User.getUser().branchId,
			loading: false,
			reference: null,
			expirationDate: null
		};
		_this.model = angular.copy(_this.defaultModel);
		_this.userBranches = [];
		_this.itemTypes = [];
		_this.itemTypeList = [];
		return _this;
	}

	(0, _createClass3.default)(ItemCreateController, [{
		key: '$onInit',
		value: function $onInit() {
			// this.loadUserBranches();
			// this.loadItemTypesX();
			this.loadItemTypes();
			this.model.maxDate = {
				minDate: moment().add('1', 'day')
			};
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.userBranches.forEach(function (branch) {
				branch.ticked = false;
			});
			this.model = angular.copy(this.defaultModel);
			this.clearErrors();
		}
	}, {
		key: 'submit',
		value: function submit() {
			var _this2 = this;

			this.model.loading = true;
			this.Service.create({
				label: this.model.itemTypeId.Label,
				barcode: this.model.barcode,
				branchId: this.model.branchId,
				itemTypeId: this.model.itemTypeId.Value,
				notes: this.model.notes,
				reference: this.model.reference,
				expirationDate: this.model.expirationDate ? moment(this.model.expirationDate).format('YYYY-MM-DD') : null
			}).then(function () {
				_this2.askCreate();
			}).catch(function (err) {
				err.data.errors.map(function (e) {
					_this2.model.errorMessage += e.message + '<br/>';
				});
			}).finally(function () {
				_this2.model.loading = false;
			});
		}
	}, {
		key: 'loadItemTypesX',
		value: function loadItemTypesX() {
			var _this3 = this;

			this.ItemService.getItemTypes().then(function (res) {
				_this3.itemTypes = res.results;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'loadUserBranches',
		value: function loadUserBranches() {
			var _this4 = this;

			this.ServiceOrderService.getUserBranchList(this.model.loggedInUserId).then(function (res) {
				_this4.userBranches = res.results;
				_this4.userBranches.forEach(function (branch) {
					if (branch.branchId == _this4.branchId) {
						branch.ticked = true;
					}
				});
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'getSelectedBranches',
		value: function getSelectedBranches() {
			return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map(function (branch) {
				return branch.branchId;
			}) : null;
		}
	}, {
		key: 'loadItemTypes',
		value: function loadItemTypes(searchKey, offset) {
			var _this5 = this;

			searchKey = searchKey || null;

			return this.ItemService.getItemTypes(null, searchKey, _app2.default.defaultPageLimit, offset).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this5.itemTypes = data.results;
					_this5.totalRecords = data.total;
					_this5.itemTypeList = _this5.dataMapping(data.results);
				} else {
					var records = _this5.dataMapping(data.results);
					_this5.itemTypeList = _this5.itemTypeList.concat(records);
				}
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'dataMapping',
		value: function dataMapping(array) {
			return array.map(function (data) {
				return {
					Key: data.id + ' | ' + data.label,
					Value: data.id,
					Label: data.label
				};
			});
		}
	}, {
		key: 'validateForm',
		value: function validateForm() {
			return !(this.model.itemTypeId && this.model.barcode);
		}
	}]);
	return ItemCreateController;
}(_itemBase2.default);

exports.default = ItemCreateController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _itemEdit = __webpack_require__(1895);

var _itemEdit2 = _interopRequireDefault(_itemEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemEditModule = angular.module('itemedit', []).component('itemedit', _itemEdit2.default).name;

exports.default = itemEditModule;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _itemEdit = __webpack_require__(2731);

var _itemEdit2 = _interopRequireDefault(_itemEdit);

var _itemEdit3 = __webpack_require__(1896);

var _itemEdit4 = _interopRequireDefault(_itemEdit3);

__webpack_require__(3011);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _itemEdit2.default,
  controller: _itemEdit4.default
};

exports.default = itemeditComponent;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _itemBase = __webpack_require__(268);

var _itemBase2 = _interopRequireDefault(_itemBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemEditController = function (_ItemBaseController) {
	ItemEditController.$inject = ["Auth", "$state", "User", "ItemService", "Modal", "$translate", "$stateParams", "LocationService", "ServiceOrderService", "$scope", "DateUtil"];
	(0, _inherits3.default)(ItemEditController, _ItemBaseController);

	/*@ngInject*/
	function ItemEditController(Auth, $state, User, ItemService, Modal, $translate, $stateParams, LocationService, ServiceOrderService, $scope, DateUtil) {
		(0, _classCallCheck3.default)(this, ItemEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (ItemEditController.__proto__ || (0, _getPrototypeOf2.default)(ItemEditController)).call(this, Auth, $state, User, ItemService, Modal, $translate, $stateParams));

		_this.LocationService = LocationService;
		_this.ServiceOrderService = ServiceOrderService;
		_this.ItemService = ItemService;
		_this.$scope = $scope;
		_this.user = User;
		_this.DateUtil = DateUtil;
		_this.hasACL = {};
		_this.defaultModel = {
			itemTypeId: null,
			barcode: null,
			itemLabel: null,
			notes: null,
			loggedInUserId: _this.User.getUser().id,
			selectedBranch: [],
			errorMessage: null,
			branchId: _this.User.getUser().branchId,
			loading: false,
			gettingItems: false,
			reference: null,
			expirationDate: null
		};
		_this.model = angular.copy(_this.defaultModel);
		_this.userBranches = [];
		_this.itemTypes = [];
		_this.itemTypeList = [];
		return _this;
	}

	(0, _createClass3.default)(ItemEditController, [{
		key: '$onInit',
		value: function $onInit() {
			this.loadData();
			this.loadItemTypes('', 0);
			this.maxDate = {
				minDate: moment().add('1', 'day')
			};
		}
	}, {
		key: 'loadItemTypes',
		value: function loadItemTypes(searchKey, offset) {
			var _this2 = this;

			searchKey = searchKey || null;

			var itemTypeId = this.model.itemTypeId ? this.model.itemTypeId.Value : null;

			if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
				offset = offset - 1;
			}

			this.ItemService.getItemTypes(this.model.itemTypeId, searchKey, _app2.default.defaultPageLimit, offset).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this2.itemTypes = data.results;
					_this2.totalRecords = data.total;
					_this2.itemTypeList = _this2.dataMapping(data.results, searchKey);
				} else {
					var records = _this2.dataMapping(data.results, searchKey);
					_this2.itemTypeList = _this2.itemTypeList.concat(records);
				}
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'dataMapping',
		value: function dataMapping(types, searchKey) {
			var _this3 = this;

			var type = [];
			types.map(function (data) {
				data.Key = data.id + " | " + data.label;
				data.Value = data.id;
				data.Label = data.label;

				if (!searchKey && _this3.model.itemTypeId) {
					if (data.id !== _this3.model.itemTypeId) {
						type.push(data);
					}
				} else {
					type.push(data);
				}
			});
			return type;
		}
	}, {
		key: 'loadData',
		value: function loadData() {
			var _this4 = this;

			this.model.gettingItems = true;
			this.Service.getItem(this.$stateParams.id).then(function (data) {
				_this4.defaultModel = data;
				_this4.itemObj = data;
				_this4.rawId = data.itemId;
				_this4.model.itemTypeId = data.itemTypeId;
				_this4.model.barcode = data.barcode;
				_this4.model.itemLabel = data.label;
				_this4.model.notes = data.notes;
				_this4.model.reference = data.reference || 'N/A';
				_this4.model.expirationDate = data.expirationDate ? _this4.DateUtil.convertToDate(data.expirationDate) : null;

				_this4.model.itemTypeId = {
					Key: _this4.itemObj.itemTypeId + ' | ' + _this4.itemObj.label,
					Value: _this4.itemObj.itemTypeId,
					Label: _this4.itemObj.label
				};
			}).catch(function (err) {
				console.error(err);
			}).finally(function () {
				_this4.model.gettingItems = false;
			});
		}
	}, {
		key: 'changeItemType',
		value: function changeItemType() {
			// console.log('>>1>>>>',this.model.itemTypeId);
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.model = angular.copy(this.defaultModel);
			this.model.itemTypeId = {
				Key: this.itemObj.itemTypeId + ' | ' + this.itemObj.label,
				Value: this.itemObj.itemTypeId,
				Label: this.itemObj.label
			};
			this.clearErrors();
		}
	}, {
		key: 'submit',
		value: function submit() {
			var _this5 = this;

			this.errorMessage = '';
			this.model.loading = true;

			this.Service.update(this.rawId, {
				itemId: this.itemObj.itemId,
				barcode: this.model.barcode,
				// itemTypeId: this.itemObj.itemTypeId,
				// itemTypeId: this.model.itemTypeId,
				label: this.model.itemTypeId.Label,
				itemTypeId: this.model.itemTypeId.Value,
				// label: this.model.itemLabel,
				notes: this.model.notes,
				branchId: this.model.branchId,
				reference: this.model.reference,
				expirationDate: this.model.expirationDate ? moment(this.model.expirationDate).format('YYYY-MM-DD') : null
			}).then(function () {
				window.history.go(-1);
			}).catch(function (err) {
				err.data.errors.map(function (e) {
					_this5.errorMessage += e.message;
				});
			}).finally(function () {
				_this5.model.loading = false;
			});
		}
	}, {
		key: 'validateForm',
		value: function validateForm() {
			return !(this.model.itemTypeId && this.model.barcode);
		}
	}]);
	return ItemEditController;
}(_itemBase2.default);

exports.default = ItemEditController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item = __webpack_require__(1898);

var _item2 = _interopRequireDefault(_item);

var _create = __webpack_require__(1891);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(1894);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(1888);

var _all2 = _interopRequireDefault(_all);

var _print = __webpack_require__(1900);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemModule = angular.module('items', [_create2.default, _edit2.default, _all2.default, _print2.default]).component('items', _item2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('items.create', {
    url: '/create',
    component: 'itemcreate'
  }).state('items.edit', {
    url: '/edit/:id',
    component: 'itemedit'
  }).state('items.all', {
    url: '/all/:page',
    component: 'itemall'
  });
}]).name;

exports.default = itemModule;

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item = __webpack_require__(2732);

var _item2 = _interopRequireDefault(_item);

var _item3 = __webpack_require__(1899);

var _item4 = _interopRequireDefault(_item3);

__webpack_require__(3012);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _item2.default,
  controller: _item4.default
};

exports.default = itemComponent;

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemController = function (_SettingBase) {
  ItemController.$inject = ["$state"];
  (0, _inherits3.default)(ItemController, _SettingBase);

  /*@ngInject*/
  function ItemController($state) {
    (0, _classCallCheck3.default)(this, ItemController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ItemController.__proto__ || (0, _getPrototypeOf2.default)(ItemController)).call(this));

    _this.$state = $state;
    _this.id = "items";
    _this.acl = {};
    _this.hasACL = {};

    return _this;
  }

  (0, _createClass3.default)(ItemController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(ItemController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ItemController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['setting-' + this.id]) {
        this.hasACL[this.acl['setting-' + this.id][key]] = true;
      }
    }
  }]);
  return ItemController;
}(_SettingBase3.default);

exports.default = ItemController;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _item_history = __webpack_require__(1901);

var _item_history2 = _interopRequireDefault(_item_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printItemHistoryModule = angular.module('printItemHistory', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$stateProvider.state('printItemHistory', {
		url: '/print-item-history',
		component: 'printItemHistory'
	});
}]).component('printItemHistory', _item_history2.default).name;

exports.default = printItemHistoryModule;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item_history = __webpack_require__(2733);

var _item_history2 = _interopRequireDefault(_item_history);

var _item_history3 = __webpack_require__(1902);

var _item_history4 = _interopRequireDefault(_item_history3);

__webpack_require__(3013);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemHistoryComponent = {
  restrict: 'E',
  bindings: {},
  template: _item_history2.default,
  controller: _item_history4.default
};

exports.default = itemHistoryComponent;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemHistoryController = function () {
    /*@ngInject*/
    itemHistoryController.$inject = ["$state", "$stateParams", "$translate", "$scope", "CommonLayoutService"];
    function itemHistoryController($state, $stateParams, $translate, $scope, CommonLayoutService) {
        var _this = this;

        (0, _classCallCheck3.default)(this, itemHistoryController);

        this.translateItemHistoryMsg = function (entryType) {
            return _this.CommonLayoutService.translateItemHistoryMessage(entryType);
        };

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.$scope = $scope;
        this.CommonLayoutService = CommonLayoutService;

        this.model = {
            itemHistoryObj: null
        };
        this.loadCompanyLogo = false;
    }

    (0, _createClass3.default)(itemHistoryController, [{
        key: "$onInit",
        value: function $onInit() {
            if (window.opener && window.opener.w && window.opener.w.printData) {
                this.model.itemHistoryObj = window.opener.w.printData;
                this.print();
            }
        }
    }, {
        key: "print",
        value: function print() {
            var _this2 = this;

            setTimeout(function () {
                window.print();
            }, 1500);

            var timeId = setTimeout(function () {
                _this2.loadCompanyLogo = true;
                _this2.$scope.$apply();
                clearTimeout(timeId);
            }, 1000);
        }
    }]);
    return itemHistoryController;
}();

exports.default = itemHistoryController;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item_typeAll = __webpack_require__(1904);

var _item_typeAll2 = _interopRequireDefault(_item_typeAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemTypeAllModule = angular.module('itemTypeAll', []).component('itemTypeAll', _item_typeAll2.default).name;

exports.default = itemTypeAllModule;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item_typeAll = __webpack_require__(2734);

var _item_typeAll2 = _interopRequireDefault(_item_typeAll);

var _item_typeAll3 = __webpack_require__(1905);

var _item_typeAll4 = _interopRequireDefault(_item_typeAll3);

__webpack_require__(3014);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemTypeAllComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _item_typeAll2.default,
  controller: _item_typeAll4.default
};

exports.default = itemTypeAllComponent;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _item_typeBase = __webpack_require__(269);

var _item_typeBase2 = _interopRequireDefault(_item_typeBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemTypeAllController = function (_ItemTypeBaseControll) {
  itemTypeAllController.$inject = ["Auth", "$state", "User", "Modal", "ItemTypeService", "$translate", "$stateParams", "$location"];
  (0, _inherits3.default)(itemTypeAllController, _ItemTypeBaseControll);

  /*@ngInject*/
  function itemTypeAllController(Auth, $state, User, Modal, ItemTypeService, $translate, $stateParams, $location) {
    (0, _classCallCheck3.default)(this, itemTypeAllController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (itemTypeAllController.__proto__ || (0, _getPrototypeOf2.default)(itemTypeAllController)).call(this, Auth, $state, User, ItemTypeService, Modal, $translate, $stateParams));

    _this.User = User;
    _this.$state = $state;
    _this.$location = $location;
    _this.hasAcl = {};
    _this.model = {
      ItemTypeObj: {
        totalRecords: 0,
        categoryList: [],
        loading: false
      },
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      searchText: ''
    };
    return _this;
  }

  (0, _createClass3.default)(itemTypeAllController, [{
    key: '$onInit',
    value: function $onInit() {
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      this.model.pagination.page = 1;
      this.loadAllItemType();
    }
  }, {
    key: 'searchObj',
    value: function searchObj() {
      var obj = {
        queryJSON: {
          rules: [{
            group: {
              rules: [{
                field: 'label',
                condition: 'like',
                data: '%' + this.model.searchText + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };
      return obj.queryJSON.rules.length ? obj : null;
    }
  }, {
    key: 'loadAllItemType',
    value: function loadAllItemType() {
      var _this2 = this;

      this.model.ItemTypeObj.loading = true;
      this.Service.all(this.searchObj(), (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit).then(function (data) {
        _this2.model.ItemTypeObj.categoryList = data.results;
        _this2.model.ItemTypeObj.totalRecords = data.total;
      }).catch(function (err) {
        _this2.Modal.errorModal(err.data.message);
      }).finally(function () {
        _this2.model.ItemTypeObj.loading = false;
      });
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.model.pagination.page);
      this.$stateParams.page = this.model.pagination.page;
      this.$location.path(newUrl);
      this.loadAllItemType();
    }
  }, {
    key: 'search',
    value: function search() {
      this.pageChange();
    }
  }, {
    key: 'editItemType',
    value: function editItemType(itemsType) {
      this.$state.go('items-type.edit', {
        id: itemsType.id
      });
    }
  }]);
  return itemTypeAllController;
}(_item_typeBase2.default);

exports.default = itemTypeAllController;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item_typeCreate = __webpack_require__(1907);

var _item_typeCreate2 = _interopRequireDefault(_item_typeCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemTypeCreateModule = angular.module('itemTypeCreate', []).component('itemTypeCreate', _item_typeCreate2.default).name;

exports.default = itemTypeCreateModule;

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item_typeCreate = __webpack_require__(2735);

var _item_typeCreate2 = _interopRequireDefault(_item_typeCreate);

var _item_typeCreate3 = __webpack_require__(1908);

var _item_typeCreate4 = _interopRequireDefault(_item_typeCreate3);

__webpack_require__(3015);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemTypeCreateComponent = {
  restrict: 'E',
  bindings: {},
  template: _item_typeCreate2.default,
  controller: _item_typeCreate4.default
};

exports.default = itemTypeCreateComponent;

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _item_typeBase = __webpack_require__(269);

var _item_typeBase2 = _interopRequireDefault(_item_typeBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemTypeCreateController = function (_ItemTypeBaseControll) {
	ItemTypeCreateController.$inject = ["Auth", "$state", "User", "ItemTypeService", "Modal", "$translate", "$stateParams"];
	(0, _inherits3.default)(ItemTypeCreateController, _ItemTypeBaseControll);

	/*@ngInject*/
	function ItemTypeCreateController(Auth, $state, User, ItemTypeService, Modal, $translate, $stateParams) {
		(0, _classCallCheck3.default)(this, ItemTypeCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (ItemTypeCreateController.__proto__ || (0, _getPrototypeOf2.default)(ItemTypeCreateController)).call(this, Auth, $state, User, ItemTypeService, Modal, $translate, $stateParams));

		_this.ItemTypeService = ItemTypeService;
		_this.user = User;
		_this.hasACL = {};
		_this.defaultModel = {
			label: null,
			loading: false
		};
		_this.model = angular.copy(_this.defaultModel);
		return _this;
	}

	(0, _createClass3.default)(ItemTypeCreateController, [{
		key: '$onInit',
		value: function $onInit() {}
	}, {
		key: 'reset',
		value: function reset() {
			this.model = angular.copy(this.defaultModel);
			this.clearErrors();
		}
	}, {
		key: 'submit',
		value: function submit() {
			var _this2 = this;

			this.model.loading = true;
			this.Service.create({
				label: this.model.label
			}).then(function () {
				_this2.askCreate();
			}).catch(function (err) {
				err.data.errors.map(function (e) {
					_this2.model.errorMessage += e.message + '<br/>';
				});
			}).finally(function () {
				_this2.model.loading = false;
			});
		}
	}]);
	return ItemTypeCreateController;
}(_item_typeBase2.default);

exports.default = ItemTypeCreateController;

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item_typeEdit = __webpack_require__(1910);

var _item_typeEdit2 = _interopRequireDefault(_item_typeEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemTypeEditModule = angular.module('itemTypeEdit', []).component('itemTypeEdit', _item_typeEdit2.default).name;

exports.default = itemTypeEditModule;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item_typeEdit = __webpack_require__(2736);

var _item_typeEdit2 = _interopRequireDefault(_item_typeEdit);

var _item_typeEdit3 = __webpack_require__(1911);

var _item_typeEdit4 = _interopRequireDefault(_item_typeEdit3);

__webpack_require__(3016);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemTypeEditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _item_typeEdit2.default,
  controller: _item_typeEdit4.default
};

exports.default = itemTypeEditComponent;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _item_typeBase = __webpack_require__(269);

var _item_typeBase2 = _interopRequireDefault(_item_typeBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemTypeEditController = function (_ItemTypeBaseControll) {
    ItemTypeEditController.$inject = ["Auth", "$state", "User", "ItemTypeService", "Modal", "$translate", "$stateParams", "$scope"];
    (0, _inherits3.default)(ItemTypeEditController, _ItemTypeBaseControll);

    /*@ngInject*/
    function ItemTypeEditController(Auth, $state, User, ItemTypeService, Modal, $translate, $stateParams, $scope) {
        (0, _classCallCheck3.default)(this, ItemTypeEditController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ItemTypeEditController.__proto__ || (0, _getPrototypeOf2.default)(ItemTypeEditController)).call(this, Auth, $state, User, ItemTypeService, Modal, $translate, $stateParams));

        _this.ItemTypeService = ItemTypeService;
        _this.$scope = $scope;
        _this.user = User;
        _this.hasACL = {};
        _this.defaultModel = {
            label: null,
            loading: false
        };
        _this.model = angular.copy(_this.defaultModel);
        return _this;
    }

    (0, _createClass3.default)(ItemTypeEditController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.Service.get(this.$stateParams.id).then(function (data) {
                _this2.defaultModel = data.results;
                _this2.rawId = data.results.id;
                _this2.model.id = data.results.id;
                _this2.model.label = data.results.label;
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.clearErrors();
        }
    }, {
        key: 'update',
        value: function update() {
            var _this3 = this;

            this.model.isUpdating = true;
            delete this.model.errorMessage;

            this.Service.update(this.$stateParams.id, {
                label: this.model.label
            }).then(function () {
                window.history.go(-1);
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this3.model.errorMessage = e.message;
                });
            }).finally(function () {
                _this3.model.isUpdating = false;
            });
        }
    }]);
    return ItemTypeEditController;
}(_item_typeBase2.default);

exports.default = ItemTypeEditController;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item_type = __webpack_require__(1913);

var _item_type2 = _interopRequireDefault(_item_type);

var _create = __webpack_require__(1906);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(1909);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(1903);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemTypeModule = angular.module('itemType', [_create2.default, _edit2.default, _all2.default]).component('itemType', _item_type2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('items-type.create', {
    url: '/create',
    component: 'itemTypeCreate'
  }).state('items-type.edit', {
    url: '/edit/:id',
    component: 'itemTypeEdit'
  }).state('items-type.all', {
    url: '/all/:page',
    component: 'itemTypeAll'
  });
}]).name;

exports.default = itemTypeModule;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item_type = __webpack_require__(2737);

var _item_type2 = _interopRequireDefault(_item_type);

var _item_type3 = __webpack_require__(1914);

var _item_type4 = _interopRequireDefault(_item_type3);

__webpack_require__(3017);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemTypeComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _item_type2.default,
  controller: _item_type4.default
};

exports.default = itemTypeComponent;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemTypeController = function (_SettingBase) {
  ItemTypeController.$inject = ["$state"];
  (0, _inherits3.default)(ItemTypeController, _SettingBase);

  /*@ngInject*/
  function ItemTypeController($state) {
    (0, _classCallCheck3.default)(this, ItemTypeController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ItemTypeController.__proto__ || (0, _getPrototypeOf2.default)(ItemTypeController)).call(this));

    _this.$state = $state;
    _this.id = "items-type";
    _this.acl = {};
    _this.hasACL = {};

    return _this;
  }

  (0, _createClass3.default)(ItemTypeController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(ItemTypeController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ItemTypeController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['setting-' + this.id]) {
        this.hasACL[this.acl['setting-' + this.id][key]] = true;
      }
    }
  }]);
  return ItemTypeController;
}(_SettingBase3.default);

exports.default = ItemTypeController;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locationAll = __webpack_require__(1916);

var _locationAll2 = _interopRequireDefault(_locationAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationallModule = angular.module('locationall', []).component('locationall', _locationAll2.default).name;

exports.default = locationallModule;

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locationAll = __webpack_require__(2738);

var _locationAll2 = _interopRequireDefault(_locationAll);

var _locationAll3 = __webpack_require__(1917);

var _locationAll4 = _interopRequireDefault(_locationAll3);

__webpack_require__(3018);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _locationAll2.default,
  controller: _locationAll4.default
};

exports.default = locationallComponent;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _locationBase = __webpack_require__(107);

var _locationBase2 = _interopRequireDefault(_locationBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationallController = function (_LocationBaseControll) {
  LocationallController.$inject = ["Auth", "$state", "User", "Modal", "LocationService", "$translate", "$stateParams", "$scope", "$location", "DataCounter"];
  (0, _inherits3.default)(LocationallController, _LocationBaseControll);

  /*@ngInject*/
  function LocationallController(Auth, $state, User, Modal, LocationService, $translate, $stateParams, $scope, $location, DataCounter) {
    (0, _classCallCheck3.default)(this, LocationallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LocationallController.__proto__ || (0, _getPrototypeOf2.default)(LocationallController)).call(this, Auth, $state, User, LocationService, Modal, $translate, $stateParams, $location));

    _this.loadImage = function (image) {
      var imgURL = this.icon[image];
      return __webpack_require__(51)("./" + imgURL);
    };

    _this.id = 'location.all';
    _this.loading = false; //true
    _this.locations = [];
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.hasACL = {};
    _this.$location = $location;
    _this.branch = User.getUser().branchId;
    _this.DataCounter = DataCounter;
    _this.customerId = User.getUser().customerUser ? User.getUser().customerId : null;
    _this.loggedInUserId = User.getUser().id;
    _this.User = User;

    _this.icon = {
      'REGULAR': 'regular.png',
      'ATM': 'atm.png',
      'BANK': 'bank.png',
      'NO_SHIP_NO_GO': 'nsng.png',
      'INTERNAL': 'internal.png',
      'TRUCK': 'truck.png',
      'TANKER': 'tanker.png',
      'WINDOW': 'window.png',
      'ON_CALL': 'oncall.png',
      'CARRIER': 'carrier.png',
      'LOCKER': 'locker.png',
      'VAULT': 'vault.png',
      'DELIVERY': 'delivery.png'
    };
    _this.searchObj = {
      type: '',
      text: '',
      status: 'active'
    };

    _this.locationStatus = [{
      label: $translate.instant('location_types.All'),
      value: null
    }, {
      label: $translate.instant('common.active'),
      value: 'active'
    }, {
      label: $translate.instant('common.inactive'),
      value: 'inactive'
    }, {
      label: $translate.instant('location.pending_changes'),
      value: 'pending_changes'
    }];

    _this.locationTypeList = ['', 'DELIVERY', 'ATM', 'LOCKER', 'Regular', 'Bank', 'ON_CALL', 'NO_SHIP_NO_GO', 'Internal', 'Truck', 'Tanker', 'Carrier', 'Window', 'VAULT'];
    _this.locationTypes = _this.locationTypeList.map(function (list) {
      if (list == '') {
        return {
          value: '',
          label: $translate.instant('location_types.All')
        };
      }
      return {
        value: list,
        label: $translate.instant('location_types.' + list)
      };
    });

    _this.reportPrefix = 'Locations';
    _this.isExporting = false;
    _this.locationUpdateHistory = {};
    _this.locationHistory = {};
    _this.pendingLocationChanges = {};
    _this.pagination = {
      page: 1,
      total: 0,
      pageLimit: 10,
      maxPages: 10
    };
    _this.locationIds = [];
    _this.customerContractData = '';
    _this.selectedLocations = [];
    _this.filterByValue = null;
    _this.model.filterByAllBranch = false;
    return _this;
  }

  (0, _createClass3.default)(LocationallController, [{
    key: '$onInit',
    value: function $onInit() {
      this.customerContractData = this.DataCounter.getData();

      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
    }
  }, {
    key: 'edit',
    value: function edit(location) {
      this.$state.go('location.edit', {
        id: location.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(location) {
      var _this2 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + location.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this2.Service.remove(location.id, _this2.branch).then(function (data) {
            _this2.allowOnlyOnce = false;
            modal.close();
            _this2.refresh();
          }).catch(function (err) {
            $scope.isLoading = false;
            $scope.loading = false;
            _this2.allowOnlyOnce = false;
            if (err && err.data && err.data.message) {
              return _this2.Modal.errorModal('location.reference_error');
            }
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this2.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      var searchObj = this.generateSearchObj();
      this.loading = true;
      this.Service.getAllLocation(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this3.total = data.total;
        _this3.loading = false;
        _this3.locations = data.results;
        _this3.totalActiveLocation = data.totalActive;
        _this3.totalInActiveLocation = data.totalInActive;
        _this3.maintainDriveDistance = data.maintainDriveDistance;

        _this3.selectedLocations.forEach(function (selectedLoc) {
          _this3.locations.forEach(function (loc) {
            if (selectedLoc.locationId === loc.id) {
              loc.isSelected = true;
            }
          });
        });

        setTimeout(function () {
          _this3.resetRedirectionalData();
        }, 5000);
      }).catch(function (err) {
        _this3.loading = false;
        _this3.error = err.message;
        if (err && err.data && err.data.message) {
          _this3.Modal.errorModal(err.data.message);
        }
      });
    }
  }, {
    key: 'filterByBranch',
    value: function filterByBranch(value) {
      this.page = 1;
      this.filterByValue = this.filterByValue === value ? undefined : value;
      this.model.filterByAllBranch = this.filterByValue ? true : false;
      this.loadData();
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      var obj = {
        queryJSON: {
          rules: [],
          getPendingChanges: true,
          getLocationCount: true,
          filterByAllBranch: this.model.filterByAllBranch,
          operator: 'AND'
        }
      };

      if (!this.customerContractData) {
        obj.queryJSON.rules.push({
          field: 'branchId',
          condition: '=',
          data: this.branch
        });
      }
      if (this.customerId) {
        obj.queryJSON.rules.push({
          field: 'customerId',
          condition: '=',
          data: this.customerId
        });
      }
      if (this.searchObj.text) {
        var searchFields = ['id', 'name', 'refNumber', 'keyNum', 'idOTCLock', 'address', 'city'];
        var trimmedSearchText = this.searchObj.text.trim();
        var searchWords = trimmedSearchText.split(/[^a-zA-Z0-9]+/).filter(function (word) {
          return (/[a-zA-Z0-9]/.test(word)
          );
        });

        if (!searchWords.length && trimmedSearchText) {
          searchWords = [trimmedSearchText];
        }

        if (searchWords.length) {
          obj.queryJSON.rules.push({
            "group": {
              "operator": "AND",
              "rules": searchWords.map(function (word) {
                return {
                  "group": {
                    "operator": "OR",
                    "rules": searchFields.map(function (field) {
                      return {
                        "data": "%" + word + "%",
                        "field": field,
                        "condition": "like"
                      };
                    })
                  }
                };
              })
            }
          });
        }
      }

      if (this.searchObj.type) {
        obj.queryJSON.rules.push({
          field: 'locationType',
          condition: '=',
          data: this.searchObj.type
        });
      }

      if (this.customerContractData && this.customerContractData.isRedirected) {
        obj.queryJSON.rules.push({
          field: 'customerId',
          condition: '=',
          data: this.customerContractData.customerId
        });
      }

      if (this.searchObj.status) {
        if (this.searchObj.status == 'active') {
          obj.queryJSON.rules.push({
            field: 'active',
            condition: '=',
            data: true
          });
        } else if (this.searchObj.status == 'inactive') {
          obj.queryJSON.rules.push({
            field: 'active',
            condition: '=',
            data: false
          });
        } else if (this.locationIds.length) {
          obj.queryJSON.rules.push({
            field: 'id',
            condition: 'IN',
            data: this.locationIds
          });
        }
      }

      return obj.queryJSON.rules.length ? obj : { branch: this.branch };
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);

      if (this.searchObj.status == 'pending_changes') {
        this.getLocationIds();
      } else {
        this.locationIds = [];
        this.loadData();
      }
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(location) {
      location.expand = !location.expand;
    }
  }, {
    key: 'exportData',
    value: function exportData() {
      var _this4 = this;

      var searchText = this.searchObj.text ? this.searchObj.text : null;
      var locationType = this.searchObj.type ? this.searchObj.type : null;
      var status = null;

      if (this.searchObj.status) {
        if (this.searchObj.status == 'active') status = true;else status = false;
      }

      this.isExporting = true;
      this.Service.exportLocations(searchText, locationType, status, this.branch, this.customerId, this.model.filterByAllBranch, this.loggedInUserId).then(function (data) {
        _this4.fileName = _this4.reportPrefix.concat('_', _this4.branch, '.csv');
        var a = document.createElement("a");
        document.body.appendChild(a);
        var file = new Blob([data.csvString], { type: 'application/csv' });
        var fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = _this4.fileName;
        a.click();
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          return _this4.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this4.isExporting = false;
      });
    }
  }, {
    key: 'setPage',
    value: function setPage(isExpanded, locationId) {
      if (!isExpanded) return;
      this.locationHistory[locationId] = { page: 1 };
    }
  }, {
    key: 'getLocationUpdateHistory',
    value: function getLocationUpdateHistory(isExpanded, locationId) {
      var _this5 = this;

      document.getElementById('expand-btn-' + locationId).blur();
      if (!isExpanded) return;

      this.locationHistory[locationId].process = true;

      this.Service.getLocationUpdateHistory(locationId, this.pagination.pageLimit, (this.locationHistory[locationId].page - 1) * this.pagination.pageLimit).then(function (history) {
        return _this5.getPendingLocationChanges(locationId).then(function (locationChanges) {
          return [history, locationChanges];
        });
      }).then(function (_ref3) {
        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
            history = _ref4[0],
            locationChanges = _ref4[1];

        _this5.locationUpdateHistory[locationId] = { details: history };
        _this5.pendingLocationChanges[locationId] = { details: locationChanges };
        _this5.locationUpdateHistory[locationId].details.results.forEach(function (log) {
          log.entryData = _this5.formatJson(log.entryData);
        });
        _this5.locationUpdateHistory[locationId].details.pageLimit = _this5.pagination.pageLimit;
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this5.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this5.locationHistory[locationId].process = false;
      });
    }
  }, {
    key: 'formatJson',
    value: function formatJson(obj) {
      if (_lodash2.default.isEmpty(obj)) return;
      return obj;
    }
  }, {
    key: 'isArray',
    value: function isArray(key) {
      return Array.isArray(key);
    }
  }, {
    key: 'getPendingLocationChanges',
    value: function getPendingLocationChanges(locationId) {
      return this.Service.getPendingLocationChanges(locationId).then(function (data) {
        return data;
      });
    }
  }, {
    key: 'translateMessage',
    value: function translateMessage(key) {
      if (!key) return;
      return this.$translate.instant('location.' + key);
    }
  }, {
    key: 'getLocationIds',
    value: function getLocationIds() {
      var _this6 = this;

      this.locationIds = [];
      this.Service.getPendingLocationChangesIds().then(function (data) {
        _this6.locationIds = data.results;
        _this6.loadData();
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this6.Modal.errorModal(err.data.message);
        }
      });
    }
  }, {
    key: 'resetRedirectionalData',
    value: function resetRedirectionalData() {
      if (this.customerContractData) {
        this.customerContractData.isRedirected = false;
        this.customerContractData = this.DataCounter.setData();
      }
    }
  }, {
    key: 'selectLocations',
    value: function selectLocations(location, event) {
      var _this7 = this;

      setTimeout(function () {
        if (location.isSelected) {
          _this7.selectedLocations.push({
            locationId: location.id,
            locationName: location.name
          });
        } else {
          var locIndex = _lodash2.default.findIndex(_this7.selectedLocations, { 'locationId': location.id });
          _this7.selectedLocations.splice(locIndex, 1);
        }
      });
    }
  }, {
    key: 'printLocationBarcodes',
    value: function printLocationBarcodes() {
      var obj = {
        selectedLocations: this.selectedLocations
      };

      var path = this.$state.href('printLocationBarcodes');
      window.w = window.open(path, '_blank');
      window.w.printData = obj;
    }
  }, {
    key: 'updateLocationDrivingDistance',
    value: function updateLocationDrivingDistance() {
      var _this8 = this;

      this.model.updateDistance = true;
      this.Service.updateLocationDrivingDistance(this.model.filterByAllBranch, this.branch).then(function () {
        _this8.Modal.confirm({
          header: _this8.$translate.instant('successModal.title'),
          message: 'Driving distance updated successfully.',
          callback: function callback(_ref5) {
            var modal = _ref5.modal;

            modal.close();
          },
          type: 'success',
          buttons: ['common.ok']
        });
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this8.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this8.model.updateDistance = false;
      });
    }
  }, {
    key: 'bulkUpdateLocationDistance',
    value: function bulkUpdateLocationDistance() {
      var _this9 = this;

      this.isBulkUpdateLocationDistance = true;
      this.Service.bulkUpdateLocationDistance(this.branch).then(function () {
        _this9.Modal.confirm({
          header: _this9.$translate.instant('successModal.title'),
          message: 'Location distance updated successfully.',
          callback: function callback(_ref6) {
            var modal = _ref6.modal;

            modal.close();
          },
          type: 'success',
          buttons: ['common.ok']
        });
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this9.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this9.isBulkUpdateLocationDistance = false;
      });
    }
  }, {
    key: 'isAllowToBulkUpdateLocationDistance',
    value: function isAllowToBulkUpdateLocationDistance() {
      var firstName = this.User.getUser().firstName;
      var lastName = this.User.getUser().lastName;
      var userId = this.User.getUser().id;
      return firstName.toUpperCase() === 'COORWORKS' && lastName.toUpperCase() === 'ADMIN' || firstName.toUpperCase() === 'ADMIN' && lastName.toUpperCase() === 'COORWORKS';
    }
  }]);
  return LocationallController;
}(_locationBase2.default);

exports.default = LocationallController;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locationClone = __webpack_require__(1919);

var _locationClone2 = _interopRequireDefault(_locationClone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationCloneModule = angular.module('locationclone', []).component('locationclone', _locationClone2.default).name;

exports.default = locationCloneModule;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locationClone = __webpack_require__(2739);

var _locationClone2 = _interopRequireDefault(_locationClone);

var _locationClone3 = __webpack_require__(1920);

var _locationClone4 = _interopRequireDefault(_locationClone3);

__webpack_require__(3019);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationCloneComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _locationClone2.default,
  controller: _locationClone4.default
};

exports.default = locationCloneComponent;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(631);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(627);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _locationBase = __webpack_require__(107);

var _locationBase2 = _interopRequireDefault(_locationBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationCloneController = function (_LocationBaseControll) {
  LocationCloneController.$inject = ["Auth", "$state", "User", "LocationService", "Modal", "$translate", "UserBranchService", "BranchService", "$timeout", "CommonLayoutService"];
  (0, _inherits3.default)(LocationCloneController, _LocationBaseControll);

  /*@ngInject*/
  function LocationCloneController(Auth, $state, User, LocationService, Modal, $translate, UserBranchService, BranchService, $timeout, CommonLayoutService) {
    (0, _classCallCheck3.default)(this, LocationCloneController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LocationCloneController.__proto__ || (0, _getPrototypeOf2.default)(LocationCloneController)).call(this, Auth, $state, User, LocationService, Modal, $translate));

    _this.$timeout = $timeout;

    _this.LocationService = LocationService;
    _this.UserBranchService = UserBranchService;
    _this.BranchService = BranchService;
    _this.User = User;
    _this.CommonLayoutService = CommonLayoutService;

    _this.sourceLocationSelected = null;
    _this.sourceLocation = null;

    _this.cloneOptions = {
      branches: true,
      lockSetup: true,
      weeklyRoutes: true,
      recurringRoutes: true,
      denominations: true,
      scheduledLoadAmounts: true,
      deliverToLocations: true,
      hoursOfOperation: true
    };

    _this.newLocations = {};
    _this.newLocationCounter = 0;
    _this._newLocationsArray = [];

    _this.userBranches = [];

    _this.validationErrors = {};
    _this.isSubmitting = false;

    _this.sourceLocationSearchConfig = {
      results: [],
      totalRecords: 0,
      isLoading: false,
      searchKey: ''
    };

    _this.sourceLocationDataMap = {};

    _this.states = [{ label: 'Alabama', value: 'AL' }, { label: 'Alaska', value: 'AK' }, { label: 'American Samoa', value: 'AS' }, { label: 'Arizona', value: 'AZ' }, { label: 'Arkansas', value: 'AR' }, { label: 'California', value: 'CA' }, { label: 'Colorado', value: 'CO' }, { label: 'Connecticut', value: 'CT' }, { label: 'Delaware', value: 'DE' }, { label: 'District Of Columbia', value: 'DC' }, { label: 'Florida', value: 'FL' }, { label: 'Georgia', value: 'GA' }, { label: 'Guam', value: 'GU' }, { label: 'Hawaii', value: 'HI' }, { label: 'Idaho', value: 'ID' }, { label: 'Illinois', value: 'IL' }, { label: 'Indiana', value: 'IN' }, { label: 'Iowa', value: 'IA' }, { label: 'Kansas', value: 'KS' }, { label: 'Kentucky', value: 'KY' }, { label: 'Louisiana', value: 'LA' }, { label: 'Maine', value: 'ME' }, { label: 'Maryland', value: 'MD' }, { label: 'Massachusetts', value: 'MA' }, { label: 'Michigan', value: 'MI' }, { label: 'Minnesota', value: 'MN' }, { label: 'Mississippi', value: 'MS' }, { label: 'Missouri', value: 'MO' }, { label: 'Montana', value: 'MT' }, { label: 'Nebraska', value: 'NE' }, { label: 'Nevada', value: 'NV' }, { label: 'New Hampshire', value: 'NH' }, { label: 'New Jersey', value: 'NJ' }, { label: 'New Mexico', value: 'NM' }, { label: 'New York', value: 'NY' }, { label: 'North Carolina', value: 'NC' }, { label: 'North Dakota', value: 'ND' }, { label: 'Northern Mariana Islands', value: 'MP' }, { label: 'Ohio', value: 'OH' }, { label: 'Oklahoma', value: 'OK' }, { label: 'Oregon', value: 'OR' }, { label: 'Pennsylvania', value: 'PA' }, { label: 'Puerto Rico', value: 'PR' }, { label: 'Rhode Island', value: 'RI' }, { label: 'South Carolina', value: 'SC' }, { label: 'South Dakota', value: 'SD' }, { label: 'Tennessee', value: 'TN' }, { label: 'Texas', value: 'TX' }, { label: 'Utah', value: 'UT' }, { label: 'Vermont', value: 'VT' }, { label: 'Virgin Islands', value: 'VI' }, { label: 'Virginia', value: 'VA' }, { label: 'Washington', value: 'WA' }, { label: 'West Virginia', value: 'WV' }, { label: 'Wisconsin', value: 'WI' }, { label: 'Wyoming', value: 'WY' }];
    return _this;
  }

  (0, _createClass3.default)(LocationCloneController, [{
    key: '$onInit',
    value: function $onInit() {
      this.loadUserBranches();
      this.addNewLocationRow();
      this.searchSourceLocations('', 0);
    }

    /**
     * Load user's accessible branches
     */

  }, {
    key: 'loadUserBranches',
    value: function loadUserBranches() {
      var _this2 = this;

      var userId = this.User.getUser().id;
      this.UserBranchService.getUserBranches(userId).then(function (data) {
        _this2.userBranches = data.results || [];
        _this2.resetAvailableBranches();
      }).catch(function (err) {
        console.error('Error loading user branches:', err);
        var errorMessage = err && err.data && err.data.message ? err.data.message : 'Error loading branches';
        _this2.Modal.errorModal(errorMessage);
      });
    }
  }, {
    key: 'searchSourceLocations',
    value: function searchSourceLocations() {
      var _this3 = this;

      var searchKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this.sourceLocationSearchConfig.isLoading = true;
      this.sourceLocationSearchConfig.searchKey = searchKey;

      var branchId = this.User.getUser().branchId;
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: branchId
          }],
          operator: 'AND'
        }
      };

      if (searchKey && searchKey.trim()) {
        searchObj.queryJSON.rules.push({
          group: {
            rules: [{
              field: 'id',
              condition: 'like',
              data: '%' + searchKey.trim() + '%'
            }, {
              field: 'name',
              condition: 'like',
              data: '%' + searchKey.trim() + '%'
            }],
            operator: 'OR'
          }
        });
      }

      this.LocationService.getAllLocation(searchObj, offset, _app2.default.defaultPageLimit).then(function (responseData) {
        if (offset === 0) {
          _this3.sourceLocationSearchConfig.results = [];
          _this3.sourceLocationSearchConfig.totalRecords = responseData.total || 0;
        }

        if (responseData.results && Array.isArray(responseData.results)) {
          var newResults = responseData.results.map(function (locationItem) {
            _this3.sourceLocationDataMap[locationItem.id] = locationItem;

            return {
              Key: locationItem.id + ' | ' + locationItem.name,
              Value: locationItem.id,
              locationType: locationItem.locationType,
              name: locationItem.name
            };
          });

          if (offset === 0) {
            _this3.sourceLocationSearchConfig.results = newResults;
          } else {
            _this3.sourceLocationSearchConfig.results = _this3.sourceLocationSearchConfig.results.concat(newResults);
          }
        }
      }).catch(function (error) {
        console.error('Error searching source locations:', error);
        var errorMessage = error && error.data && error.data.message ? error.data.message : 'Error searching locations';
        _this3.Modal.errorModal(errorMessage);
      }).finally(function () {
        _this3.sourceLocationSearchConfig.isLoading = false;
      });
    }
  }, {
    key: 'onSourceLocationSelected',
    value: function onSourceLocationSelected() {
      var _this4 = this;

      this.$timeout(function () {
        if (!_this4.sourceLocationSelected || !_this4.sourceLocationSelected.Value) {
          _this4.sourceLocation = null;
          _this4.resetCloneOptions();
          return;
        }

        var selectedLocationId = _this4.sourceLocationSelected.Value;

        if (_this4.sourceLocation && _this4.sourceLocation.id === selectedLocationId) {
          return;
        }

        _this4.loading = true;
        _this4.LocationService.get(selectedLocationId).then(function (locationData) {
          _this4.sourceLocationDataMap[selectedLocationId] = locationData;
          _this4.sourceLocation = locationData;
          _this4.resetCloneOptions();
          _this4.clearAllBranchSelections();
        }).catch(function (error) {
          console.error('Error loading source location:', error);
          var errorMessage = error && error.data && error.data.message ? error.data.message : 'Error loading source location';
          _this4.Modal.errorModal(errorMessage);
          _this4.resetSourceLocationSelection();
        }).finally(function () {
          _this4.loading = false;
        });
      }, 0);
    }
  }, {
    key: 'resetCloneOptions',
    value: function resetCloneOptions() {
      this.cloneOptions = {
        branches: true,
        lockSetup: true,
        weeklyRoutes: true,
        recurringRoutes: true,
        denominations: true,
        scheduledLoadAmounts: true,
        deliverToLocations: true,
        hoursOfOperation: true
      };
    }
  }, {
    key: 'toggleCloneOption',
    value: function toggleCloneOption(optionName) {
      var _this5 = this;

      if (optionName === 'branches') {
        this.$timeout(function () {
          _this5.clearAllBranchSelections();
          _this5.resetAvailableBranches();
        }, 0);
      }
    }
  }, {
    key: 'clearAllBranchSelections',
    value: function clearAllBranchSelections() {
      var _this6 = this;

      (0, _keys2.default)(this.newLocations).forEach(function (locationKey) {
        if (_this6.newLocations[locationKey]) {
          _this6.newLocations[locationKey].branchIds = [];
          _this6.newLocations[locationKey].branches = [];
          _this6.newLocations[locationKey].branchId = null;
          _this6.newLocations[locationKey].availableBranches = _this6.createBranchListCopy();
          if (_this6.newLocations[locationKey].errors) {
            delete _this6.newLocations[locationKey].errors.branches;
          }
        }
      });
    }
  }, {
    key: 'resetAvailableBranches',
    value: function resetAvailableBranches() {
      var _this7 = this;

      (0, _keys2.default)(this.newLocations).forEach(function (locationKey) {
        if (_this7.newLocations[locationKey]) {
          _this7.newLocations[locationKey].availableBranches = _this7.createBranchListCopy();
        }
      });
    }
  }, {
    key: 'getAvailableBranchesForRow',
    value: function getAvailableBranchesForRow(locationKey) {
      if (!this.newLocations[locationKey]) {
        return [];
      }

      if (!this.newLocations[locationKey].availableBranches) {
        this.newLocations[locationKey].availableBranches = this.createBranchListCopy();
      }

      return this.newLocations[locationKey].availableBranches;
    }
  }, {
    key: 'createBranchListCopy',
    value: function createBranchListCopy() {
      if (this.userBranches && this.userBranches.length > 0) {
        return this.userBranches.map(function (branch) {
          return {
            branchId: branch.branchId,
            ticked: false
          };
        });
      }
      return [];
    }
  }, {
    key: 'onNonUSToggle',
    value: function onNonUSToggle(locationKey) {
      var location = this.newLocations[locationKey];
      if (!location) return;

      if (location.isNonUSLocation) {
        location.state = '';
        location.country = '';
      } else {
        location.state = '';
        location.country = 'US';
      }
      this._newLocationsArray = [];
    }
  }, {
    key: 'hasAnyNonUSLocation',
    value: function hasAnyNonUSLocation() {
      return (0, _values2.default)(this.newLocations).some(function (loc) {
        return loc && loc.isNonUSLocation === true;
      });
    }
  }, {
    key: 'addNewLocationRow',
    value: function addNewLocationRow() {
      var locationKey = 'loc_' + this.newLocationCounter++;
      this.newLocations[locationKey] = {
        id: '',
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: 'US',
        isNonUSLocation: false,
        branchIds: [],
        branches: [],
        availableBranches: this.createBranchListCopy(),
        errors: {}
      };
      this._newLocationsArray = [];
    }
  }, {
    key: 'removeLocationRow',
    value: function removeLocationRow(key) {
      delete this.newLocations[key];
      this._newLocationsArray = [];
    }
  }, {
    key: 'getSourceLocationType',
    value: function getSourceLocationType() {
      return this.sourceLocation && this.sourceLocation.locationType ? this.sourceLocation.locationType : 'N/A';
    }
  }, {
    key: 'getSourceLocationBranches',
    value: function getSourceLocationBranches() {
      if (!this.sourceLocation) return 'N/A';

      if (this.sourceLocation.locationBranches && Array.isArray(this.sourceLocation.locationBranches) && this.sourceLocation.locationBranches.length > 0) {
        var branchIds = this.sourceLocation.locationBranches.filter(function (b) {
          return b;
        });
        return branchIds.length > 0 ? branchIds.join(', ') : 'N/A';
      }

      if (this.sourceLocation.branchId) {
        return this.sourceLocation.branchId;
      }

      return 'N/A';
    }
  }, {
    key: 'getSourceLocationFundingSource',
    value: function getSourceLocationFundingSource() {
      if (!this.sourceLocation) return 'N/A';

      if (this.sourceLocation.bankSource && this.sourceLocation.bankSource.Key) {
        return this.sourceLocation.bankSource.Key;
      }

      return this.sourceLocation.bankSourceId || 'N/A';
    }
  }, {
    key: 'getSourceLocationStopProcess',
    value: function getSourceLocationStopProcess() {
      var _this8 = this;

      if (!this.sourceLocation || !this.sourceLocation.stopProcess) return 'N/A';

      var stopProcessList = this.CommonLayoutService.stopProcessList();
      var stopProcess = stopProcessList.find(function (sp) {
        return sp.value === _this8.sourceLocation.stopProcess;
      });
      return stopProcess ? stopProcess.label : this.sourceLocation.stopProcess;
    }
  }, {
    key: 'getSourceLocationRouteLikeRegular',
    value: function getSourceLocationRouteLikeRegular() {
      return this.sourceLocation && this.sourceLocation.handleAtmLikeRegular ? 'ON' : 'OFF';
    }
  }, {
    key: 'getSourceLocationId',
    value: function getSourceLocationId() {
      if (this.sourceLocation && this.sourceLocation.id) {
        return this.sourceLocation.id;
      }
      if (this.sourceLocationSelected && this.sourceLocationSelected.Value) {
        return this.sourceLocationSelected.Value;
      }
      return null;
    }
  }, {
    key: 'validateAllLocations',
    value: function validateAllLocations() {
      var _this9 = this;

      this.validationErrors = {};
      var isValid = true;
      var locationIds = new _set2.default();
      var errorMessages = [];
      var rowNumber = 1;

      (0, _keys2.default)(this.newLocations).forEach(function (key) {
        var location = _this9.newLocations[key];
        location.errors = {};
        var rowErrors = [];

        if (!location.id || !location.id.trim()) {
          location.errors.id = true;
          rowErrors.push('Location ID');
          isValid = false;
        } else {
          if (locationIds.has(location.id.trim())) {
            location.errors.id = true;
            rowErrors.push('Location ID "' + location.id.trim() + '" is duplicated');
            isValid = false;
          } else {
            locationIds.add(location.id.trim());
          }
        }

        if (!location.name || !location.name.trim()) {
          location.errors.name = true;
          rowErrors.push('Name');
          isValid = false;
        }

        if (!location.address || !location.address.trim()) {
          location.errors.address = true;
          rowErrors.push('Address');
          isValid = false;
        }

        if (!location.city || !location.city.trim()) {
          location.errors.city = true;
          rowErrors.push('City');
          isValid = false;
        }

        if (!location.state || !location.state.trim()) {
          location.errors.state = true;
          rowErrors.push('State');
          isValid = false;
        }

        if (!location.zip || !location.zip.trim()) {
          location.errors.zip = true;
          rowErrors.push('Zip');
          isValid = false;
        } else {
          var zipPattern = /^\d{5,6}$/;
          if (!zipPattern.test(location.zip.trim())) {
            location.errors.zip = true;
            rowErrors.push('Zip (must be 5-6 digits)');
            isValid = false;
          }
        }

        if (location.isNonUSLocation) {
          if (!location.country || !location.country.trim()) {
            location.errors.country = true;
            rowErrors.push('Country');
            isValid = false;
          } else {
            var countryPattern = /^[a-zA-Z ]*$/;
            if (!countryPattern.test(location.country.trim())) {
              location.errors.country = true;
              rowErrors.push('Country (invalid format)');
              isValid = false;
            }
          }
        } else {
          location.country = 'US';
        }

        if (location.isNonUSLocation && location.state && location.state.trim()) {
          var statePattern = /^[a-zA-Z ]*$/;
          if (!statePattern.test(location.state.trim())) {
            location.errors.state = true;
            rowErrors.push('State (invalid format)');
            isValid = false;
          }
        }

        if (!_this9.cloneOptions.branches) {
          var selectedBranches = location.branches;

          var hasBranches = false;
          if (selectedBranches && Array.isArray(selectedBranches) && selectedBranches.length > 0) {
            hasBranches = selectedBranches.some(function (branch) {
              return branch && branch.branchId;
            });
          }

          if (!hasBranches && location.availableBranches && Array.isArray(location.availableBranches)) {
            hasBranches = location.availableBranches.some(function (branch) {
              return branch && branch.ticked === true;
            });
          }

          if (!hasBranches) {
            location.errors.branches = true;
            rowErrors.push('Location Branch');
            isValid = false;
          }
        }

        if (rowErrors.length > 0) {
          var locationId = location.id && location.id.trim() ? '"' + location.id.trim() + '"' : 'Row ' + rowNumber;
          var fieldsList = rowErrors.join(', ');
          errorMessages.push(locationId + ': ' + fieldsList + ' ' + (rowErrors.length === 1 ? 'is' : 'are') + ' required');
        }

        rowNumber++;
      });

      return {
        isValid: isValid,
        errorMessages: errorMessages
      };
    }
  }, {
    key: 'validateLocationIdsUniqueness',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _this10 = this;

        var locationIds, validationResponse, existingIds, errorMessage;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                locationIds = (0, _values2.default)(this.newLocations).map(function (loc) {
                  return loc && loc.id ? loc.id.trim() : '';
                }).filter(function (id) {
                  return id;
                });

                if (!(locationIds.length === 0)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', { isValid: true, duplicateIds: [] });

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return this.LocationService.validateLocationIds(locationIds);

              case 6:
                validationResponse = _context.sent;

                if (!(validationResponse && validationResponse.existingIds && validationResponse.existingIds.length > 0)) {
                  _context.next = 11;
                  break;
                }

                existingIds = validationResponse.existingIds;


                (0, _keys2.default)(this.newLocations).forEach(function (locationKey) {
                  var locationId = _this10.newLocations[locationKey] && _this10.newLocations[locationKey].id ? _this10.newLocations[locationKey].id.trim() : '';
                  if (existingIds.indexOf(locationId) !== -1) {
                    _this10.newLocations[locationKey].errors.id = true;
                  }
                });

                return _context.abrupt('return', { isValid: false, duplicateIds: existingIds });

              case 11:
                return _context.abrupt('return', { isValid: true, duplicateIds: [] });

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](3);

                console.error('Error validating location IDs:', _context.t0);
                errorMessage = _context.t0 && _context.t0.data && _context.t0.data.message ? _context.t0.data.message : 'Unable to validate location IDs';

                this.Modal.errorModal(errorMessage);
                return _context.abrupt('return', { isValid: false, duplicateIds: [] });

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 14]]);
      }));

      function validateLocationIdsUniqueness() {
        return _ref.apply(this, arguments);
      }

      return validateLocationIdsUniqueness;
    }()
  }, {
    key: 'submit',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var _this11 = this;

        var sourceLocationId, validationResultMsgs, errorMessage, validationResult, duplicateIdsList, newLocationsArray, cloneData, result, createdCount, errorDetails, message, locationIds, _message, errorMsg, _errorDetails, _errorMessage;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.validationErrors = {};
                (0, _keys2.default)(this.newLocations).forEach(function (key) {
                  _this11.newLocations[key].errors = {};
                });

                if (!(!this.sourceLocation || !this.sourceLocation.id)) {
                  _context2.next = 5;
                  break;
                }

                this.Modal.errorModal('Please select a source location');
                return _context2.abrupt('return');

              case 5:
                sourceLocationId = this.sourceLocation.id;
                validationResultMsgs = this.validateAllLocations();

                if (validationResultMsgs.isValid) {
                  _context2.next = 11;
                  break;
                }

                errorMessage = validationResultMsgs.errorMessages.length > 0 ? validationResultMsgs.errorMessages[0] : 'Please complete all required fields';

                this.Modal.errorModal(errorMessage);
                return _context2.abrupt('return');

              case 11:
                _context2.next = 13;
                return this.validateLocationIdsUniqueness();

              case 13:
                validationResult = _context2.sent;

                if (validationResult.isValid) {
                  _context2.next = 18;
                  break;
                }

                duplicateIdsList = validationResult.duplicateIds.join(', ');

                this.Modal.errorModal('These IDs already exist: ' + duplicateIdsList);
                return _context2.abrupt('return');

              case 18:
                newLocationsArray = (0, _values2.default)(this.newLocations).filter(function (location) {
                  var locationId = location && location.id ? location.id.trim() : '';
                  var locationName = location && location.name ? location.name.trim() : '';
                  return locationId && locationName;
                }).map(function (location) {
                  var locationData = {
                    id: location.id.trim(),
                    name: location.name.trim(),
                    address: location.address.trim(),
                    city: location.city.trim(),
                    state: location.state.trim(),
                    zip: location.zip.trim(),
                    country: location.country || 'US'
                  };

                  if (!_this11.cloneOptions.branches) {
                    var branchIds = [];

                    if (location.branches && Array.isArray(location.branches) && location.branches.length > 0) {
                      branchIds = location.branches.map(function (b) {
                        return b && b.branchId ? b.branchId : null;
                      }).filter(function (id) {
                        return id !== null;
                      });
                    }

                    if (branchIds.length === 0 && location.availableBranches && Array.isArray(location.availableBranches)) {
                      branchIds = location.availableBranches.filter(function (branch) {
                        return branch && branch.ticked === true;
                      }).map(function (branch) {
                        return branch.branchId;
                      }).filter(function (id) {
                        return id;
                      });
                    }

                    if (branchIds.length > 0) {
                      locationData.branchIds = branchIds;
                    }
                  }

                  return locationData;
                });

                if (!(newLocationsArray.length === 0)) {
                  _context2.next = 22;
                  break;
                }

                this.Modal.errorModal('Please add at least one location');
                return _context2.abrupt('return');

              case 22:
                cloneData = {
                  sourceLocationId: sourceLocationId,
                  cloneOptions: (0, _extends3.default)({}, this.cloneOptions),
                  newLocations: newLocationsArray
                };


                this.isSubmitting = true;
                this.loading = true;

                _context2.prev = 25;
                _context2.next = 28;
                return this.LocationService.cloneLocation(cloneData);

              case 28:
                result = _context2.sent;


                if (result && result.success) {
                  createdCount = result.createdLocations && Array.isArray(result.createdLocations) ? result.createdLocations.length : 0;


                  if (result.errors && result.errors.length > 0) {
                    errorDetails = result.errors.map(function (e) {
                      return e.locationId + ': ' + e.error;
                    }).join('\n');
                    message = createdCount + ' created, ' + result.errors.length + ' failed:\n' + errorDetails;

                    // if (result.geocodeErrors && result.geocodeErrors.length > 0) {
                    //   console.info('Geocoding errors:', result.geocodeErrors);
                    // }

                    this.Modal.errorModal(message);
                  } else {
                    locationIds = result.createdLocations && Array.isArray(result.createdLocations) ? result.createdLocations.join(', ') : '';
                    _message = createdCount === 1 ? 'Created location successfully: ' + locationIds : 'Created ' + createdCount + ' locations successfully: ' + locationIds;

                    // if (result.geocodeErrors && result.geocodeErrors.length > 0) {
                    //   console.info('Geocoding errors:', result.geocodeErrors);
                    // }

                    this.Modal.successModal({
                      header: this.$translate.instant('successModal.title'),
                      message: _message,
                      callback: function callback(_ref3) {
                        var modal = _ref3.modal;

                        modal.close();
                        _this11.reset();
                      },
                      buttons: ['common.ok']
                    });
                  }
                } else {
                  errorMsg = result && result.message ? result.message : 'Failed to create locations';
                  _errorDetails = '';

                  if (result && result.errors && Array.isArray(result.errors) && result.errors.length > 0) {
                    _errorDetails = '\n' + result.errors.map(function (e) {
                      return (e.locationId || 'Unknown') + ': ' + e.error;
                    }).join('\n');
                  }
                  this.Modal.errorModal(errorMsg + _errorDetails);
                }
                _context2.next = 38;
                break;

              case 32:
                _context2.prev = 32;
                _context2.t0 = _context2['catch'](25);

                console.error('Error cloning locations:', _context2.t0);
                _errorMessage = 'Failed to create locations';

                if (_context2.t0 && _context2.t0.data && _context2.t0.data.message) {
                  _errorMessage = _context2.t0.data.message;
                } else if (_context2.t0 && _context2.t0.message) {
                  _errorMessage = _context2.t0.message;
                }
                this.Modal.errorModal(_errorMessage);

              case 38:
                _context2.prev = 38;

                this.isSubmitting = false;
                this.loading = false;
                return _context2.finish(38);

              case 42:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[25, 32, 38, 42]]);
      }));

      function submit() {
        return _ref2.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'reset',
    value: function reset() {
      this.resetSourceLocationSelection();
      this.newLocations = {};
      this.newLocationCounter = 0;
      this.validationErrors = {};
      this.sourceLocationSearchConfig.results = [];
      this.sourceLocationSearchConfig.totalRecords = 0;
      this.sourceLocationSearchConfig.searchKey = '';
      this.sourceLocationDataMap = {};
      this.addNewLocationRow();
      this.searchSourceLocations('', 0);
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.reset();
    }
  }, {
    key: 'buildSourceLocationDetails',
    value: function buildSourceLocationDetails(locationData) {
      var branchesDisplay = 'N/A';
      if (locationData && locationData.locationBranches && Array.isArray(locationData.locationBranches)) {
        branchesDisplay = locationData.locationBranches.map(function (lb) {
          return lb.branchId || lb.branch && lb.branch.id || lb.id || '';
        }).filter(function (b) {
          return b;
        }).join(', ');
      } else if (locationData && locationData.branchId) {
        branchesDisplay = locationData.branchId;
      }

      var bankSourceName = 'N/A';
      if (locationData && locationData.bankSource && locationData.bankSource.sourceName) {
        bankSourceName = locationData.bankSource.sourceName;
      } else if (locationData && locationData.bankSourceId) {
        bankSourceName = locationData.bankSourceId;
      }

      return {
        locationType: locationData && locationData.locationType ? locationData.locationType : 'N/A',
        branches: branchesDisplay,
        fundingSource: bankSourceName,
        stopProcess: locationData && locationData.stopProcess ? locationData.stopProcess : 'N/A',
        routeLikeRegular: locationData && locationData.handleAtmLikeRegular ? 'ON' : 'OFF'
      };
    }
  }, {
    key: 'resetSourceLocationSelection',
    value: function resetSourceLocationSelection() {
      this.sourceLocationSelected = null;
      this.sourceLocation = null;
    }
  }, {
    key: 'getNewLocationsArray',
    value: function getNewLocationsArray() {
      var _this12 = this;

      var currentKeys = (0, _keys2.default)(this.newLocations).sort().join(',');
      var cachedKeys = this._newLocationsArray.map(function (loc) {
        return loc.key;
      }).sort().join(',');

      if (currentKeys !== cachedKeys) {
        this._newLocationsArray = (0, _keys2.default)(this.newLocations).map(function (locationKey) {
          return (0, _extends3.default)({
            key: locationKey
          }, _this12.newLocations[locationKey]);
        });
      }

      return this._newLocationsArray;
    }
  }, {
    key: 'getNewLocationsCount',
    value: function getNewLocationsCount() {
      return (0, _keys2.default)(this.newLocations).length;
    }
  }, {
    key: 'shouldShowBranchColumn',
    value: function shouldShowBranchColumn() {
      return !this.cloneOptions.branches;
    }
  }]);
  return LocationCloneController;
}(_locationBase2.default);

exports.default = LocationCloneController;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _deliver_location = __webpack_require__(2740);

var _deliver_location2 = _interopRequireDefault(_deliver_location);

var _deliver_location3 = __webpack_require__(1922);

var _deliver_location4 = _interopRequireDefault(_deliver_location3);

__webpack_require__(3020);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deliverLocationComponent = {
  restrict: 'E',
  bindings: {
    model: '=ngModel',
    locations: '=',
    title: '=',
    isValidDirective: '=',
    isEdit: '='
  },
  template: _deliver_location2.default,
  controller: _deliver_location4.default
};

exports.default = deliverLocationComponent;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _locationBase = __webpack_require__(107);

var _locationBase2 = _interopRequireDefault(_locationBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lastErrorIndex = -1;

var DeliverLocationController = function (_locationBaseControll) {
    DeliverLocationController.$inject = ["Modal", "$stateParams", "$translate", "$q", "Auth", "$state", "$scope", "ShiptypeService", "LocationService"];
    (0, _inherits3.default)(DeliverLocationController, _locationBaseControll);

    /*@ngInject*/
    function DeliverLocationController(Modal, $stateParams, $translate, $q, Auth, $state, $scope, ShiptypeService, LocationService) {
        (0, _classCallCheck3.default)(this, DeliverLocationController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DeliverLocationController.__proto__ || (0, _getPrototypeOf2.default)(DeliverLocationController)).call(this, Auth, $state, Modal, $translate, $stateParams, $scope));

        _this.$q = $q;
        _this.ShiptypeService = ShiptypeService;
        _this.LocationService = LocationService;
        _this.$translate = $translate;
        _this.selectedDelLocationOptions = [];
        _this.allLocations = [];
        _this.allShipTypes = [];
        _this.$scope = $scope;
        _this.oldBranchLocation = [];
        return _this;
    }

    (0, _createClass3.default)(DeliverLocationController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.getAllShipType('', 0);
            this.$scope.$watch(function () {
                return _this2.model.branch;
            }, function (newValue, oldValue) {
                if (newValue && newValue.length > 0) {
                    if (newValue != oldValue && _this2.isEdit) {
                        _this2.model.deliveryToLocation.map(function (obj, index) {
                            _this2.model.deliveryToLocation[index].allLocations = [];
                            // this.model.deliveryToLocation[index].location = null;
                            // this.model.deliveryToLocation[index].locationDetails = null;
                            _this2.model.deliveryToLocation[index].totalLocation = 0;
                        });
                        _this2.isDataShift = false;
                        _this2.loadLocation('', 0);
                        _this2.checkDuplicateEntry();
                    } else {
                        // if (this.model.deliveryToLocation) {
                        //     this.model.deliveryToLocation.map((d) => {
                        //         const allShipType = [{ Key: this.$translate.instant('location.all_coin'), Value: 'all coin' }]
                        //         d.allShipeType = allShipType.concat(d.allShipeType)
                        //     })
                        // }
                        _this2.isDataShift = true;
                        _this2.loadLocation('', 0);
                    }
                } else {
                    if (_this2.model && _this2.model.deliveryToLocation && _this2.model.deliveryToLocation.length) {
                        _this2.model.deliveryToLocation.map(function (location, index) {
                            _this2.totalLocationRecords = _this2.model.deliveryToLocation[index].locationDetails ? 1 : 0;
                            _this2.allLocations = _this2.model.deliveryToLocation[index].locationDetails ? _this2.mappingArray([_this2.model.deliveryToLocation[index].locationDetails], '', null, 'setDeliverToLocation') : [];
                        });
                    }
                }
                _this2.updatePickupRequirement();
            });
        }
    }, {
        key: 'locationSearchObj',
        value: function locationSearchObj(searchKey) {
            var selectedBranch = Array.isArray(this.model.branch) ? this.model.branch.map(function (branch) {
                return branch.branchId;
            }) : this.model.branch.split();
            searchKey = searchKey || '';
            var searchObj = {
                queryJSON: {
                    rules: [{
                        group: {
                            operator: 'OR',
                            rules: [{
                                field: 'centralBank',
                                condition: '!=',
                                data: 0
                            }, {
                                group: {
                                    operator: 'AND',
                                    rules: [{
                                        field: 'centralBank',
                                        condition: '=',
                                        data: 0
                                    }, {
                                        field: 'id',
                                        condition: '!=',
                                        data: this.model.id
                                    }]
                                }
                            }]
                        }
                    }, {
                        field: 'branchId',
                        condition: 'IN',
                        data: selectedBranch
                    }, {
                        field: 'active',
                        condition: '=',
                        data: true
                    }, {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }, {
                        group: {
                            rules: [{
                                field: 'locationType',
                                condition: '=',
                                data: 'DELIVERY'
                            }, {
                                field: 'locationType',
                                condition: '=',
                                data: 'BANK'
                            }, {
                                field: 'locationType',
                                condition: '=',
                                data: 'ATM'
                            }, {
                                field: 'locationType',
                                condition: '=',
                                data: 'REGULAR'
                            }, {
                                field: 'locationType',
                                condition: '=',
                                data: 'ON_CALL'
                            }, {
                                field: 'locationType',
                                condition: '=',
                                data: 'NO_SHIP_NO_GO'
                            }, {
                                field: 'locationType',
                                condition: '=',
                                data: 'VAULT'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'loadLocation',
        value: function loadLocation(searchKey, offset) {
            var _this3 = this;

            var locationSearchObj = this.locationSearchObj(searchKey);
            this.LocationService.all(locationSearchObj, offset, _app2.default.defaultPageLimit).then(function (res) {
                if (offset === 0) {
                    _this3.totalLocationRecords = res.total;
                    _this3.allLocations = _this3.mappingArray(res.results, '', null, 'location');
                    if (_this3.isEdit && !_this3.isDataShift) {
                        _this3.model.deliveryToLocation.map(function (location, index) {
                            _this3.model.deliveryToLocation[index].totalLocation = res.total;
                            _this3.model.deliveryToLocation[index].allLocations = _this3.mappingArray(res.results, '', null, 'location');
                        });
                    }
                } else {
                    var locations = _this3.mappingArray(res.results, '', null, 'location');
                    _this3.allLocations = _this3.allLocations.concat(locations);
                }
            });
        }
    }, {
        key: 'shipTypeSearchObj',
        value: function shipTypeSearchObj(searchKey) {
            searchKey = searchKey || '';
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: 'status',
                        condition: '=',
                        data: true
                    }, {
                        group: {
                            rules: [{
                                field: 'description',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'AND'
                        }
                    }],
                    operator: 'AND'
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'getAllShipType',
        value: function getAllShipType(searchKey, offset) {
            var _this4 = this;

            var shipTypeSearchObj = this.shipTypeSearchObj(searchKey);
            this.ShiptypeService.all(shipTypeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {

                _this4.allCoinShipType = [{ Key: _this4.$translate.instant('location.all_coin'), Value: 'all coin' }];

                if (data.results) {
                    if (offset === 0) {
                        _this4.totalShipTypeRecords = data.total;
                        _this4.allShipType = _this4.mappingArray(data.results, '', null, 'shipType');
                        _this4.allShipTypes = _this4.allCoinShipType.concat(_this4.allShipType);
                    } else {
                        var shiptype = _this4.mappingArray(data.results, '', null, 'shipType');
                        _this4.allShipTypes = _this4.allShipTypes.concat(shiptype);
                    }
                }
            });
        }
    }, {
        key: 'getEditShipType',
        value: function getEditShipType(searchKey, offset, index) {
            var _this5 = this;

            if (this.isEdit) {
                if (offset !== 0 && this.model.deliveryToLocation && !searchKey && Math.abs(offset % 2) == 1) {
                    offset = offset - 1;
                }
            }
            var shipTypeSearchObj = this.shipTypeSearchObj(searchKey);
            this.ShiptypeService.all(shipTypeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
                var selectedVal = _this5.model.deliveryToLocation[index].shipTypeDetails ? _this5.model.deliveryToLocation[index].shipTypeDetails.Value : '';
                if (data.results) {
                    if (offset === 0) {
                        _this5.model.deliveryToLocation[index].totalShipment = data.total;
                        _this5.model.deliveryToLocation[index].allShipeType = _this5.mappingArray(data.results, searchKey, selectedVal, 'shipType');
                    } else {
                        var shiptype = _this5.mappingArray(data.results, searchKey, selectedVal, 'shipType');
                        _this5.model.deliveryToLocation[index].allShipeType = _this5.model.deliveryToLocation[index].allShipeType.concat(shiptype);
                    }
                }
            });
        }
    }, {
        key: 'mappingArray',
        value: function mappingArray(mapArray, searchKey, originalVal, type) {
            var newArray = [];
            mapArray.map(function (obj) {

                if (type == 'shipType') {
                    obj.Key = obj.description;
                } else if (type === 'setDeliverToLocation') {
                    obj.Key = obj.Key; //+ ' | ' + obj.Value;
                } else {
                    obj.Key = obj.id + ' | ' + obj.name;
                }
                obj.Value = obj.id || obj.Value;
                if (!searchKey && originalVal) {
                    if (obj.id !== originalVal) {
                        newArray.push(obj);
                    }
                } else {
                    newArray.push(obj);
                }
            });
            return newArray;
        }
    }, {
        key: 'loadEditLocation',
        value: function loadEditLocation(searchKey, offset, index) {
            var _this6 = this;

            searchKey = searchKey || '';
            var locationSearchObj = this.locationSearchObj(searchKey);
            if (this.isEdit) {
                if (offset !== 0 && this.model.deliveryToLocation && !searchKey && Math.abs(offset % 2) == 1) {
                    offset = offset - 1;
                }
            }
            this.LocationService.all(locationSearchObj, offset, _app2.default.defaultPageLimit).then(function (res) {
                var selectedVal = _this6.model.deliveryToLocation[index].locationDetails ? _this6.model.deliveryToLocation[index].locationDetails.Value : '';
                var deliveryToLocation = _this6.model.deliveryToLocation[index].locationDetails ? _this6.model.deliveryToLocation[index].locationDetails.Key : '';

                var locationDetails = {
                    Key: deliveryToLocation,
                    Value: selectedVal
                };

                if (offset === 0) {
                    _this6.model.deliveryToLocation[index].totalLocation = res.total;
                    _this6.model.deliveryToLocation[index].allLocations = _this6.mappingArray(res.results, searchKey, null, 'location');
                    if (!searchKey) {
                        _this6.model.deliveryToLocation[index].allLocations.unshift(locationDetails);
                    }
                } else {
                    var locations = _this6.mappingArray(res.results, searchKey, null, 'location');
                    _this6.model.deliveryToLocation[index].allLocations = _this6.model.deliveryToLocation[index].allLocations.concat(locations);
                }
            });
        }
    }, {
        key: 'addDeliverLocationOption',
        value: function addDeliverLocationOption() {
            var _this7 = this;

            if (this.model.deliveryToLocation == undefined) this.model.deliveryToLocation = [];
            var locationSearchObj = this.locationSearchObj('');
            var shipTypeSearchObj = this.shipTypeSearchObj('');

            this.$q.all([this.LocationService.all(locationSearchObj, 0, _app2.default.defaultPageLimit), this.ShiptypeService.all(shipTypeSearchObj, 0, _app2.default.defaultPageLimit)]).then(function (data) {

                var locations = _this7.mappingArray(data[0].results, '', null, 'location');
                var shiptypes = _this7.mapShiptypeArray(data[1].results, '', null);
                var allCoinShipType = [{ Key: _this7.$translate.instant('location.all_coin'), Value: 'all coin' }];
                var allShipTypes = allCoinShipType.concat(shiptypes);
                _this7.model.deliveryToLocation.push({
                    shipType: null,
                    shipTypeDetails: null,
                    location: null,
                    locationDetails: null,
                    duplicate: false,
                    totalLocation: data[0].total,
                    allLocations: locations,
                    totalShipment: data[1].total || 0,
                    allShipeType: allShipTypes,
                    sortOrder: _this7.model.deliveryToLocation.length,
                    individualDelivery: false,
                    pickupRequired: false,
                    disablePickupRequire: false
                });
                if (_this7.model.deliveryToLocation.length > 1) {
                    _this7.checkDuplicateEntry();
                }
            });
        }
    }, {
        key: 'updatePickupRequirement',
        value: function updatePickupRequirement() {
            if (!this.model.deliveryToLocation || this.model.deliveryToLocation.length === 0) return;

            var duplicate = {};

            this.model.deliveryToLocation.forEach(function (item) {
                if (item.shipTypeDetails) {
                    var key = '' + item.shipTypeDetails.Value;

                    if (duplicate[key]) {
                        duplicate[key].push(item);
                    } else {
                        duplicate[key] = [item];
                    }
                }
            });

            for (var key in duplicate) {
                if (duplicate[key].length > 1) {
                    duplicate[key].forEach(function (item) {
                        item.disablePickupRequire = true;
                        item.pickupRequired = false;
                    });
                } else {
                    duplicate[key].forEach(function (item) {
                        item.disablePickupRequire = false;
                    });
                }
            }
        }
    }, {
        key: 'mapShiptypeArray',
        value: function mapShiptypeArray(mapArray, searchKey, originalVal) {
            var newArray = [];
            mapArray.map(function (obj) {
                obj.Key = obj.description;
                obj.Value = obj.id;
                if (!searchKey && originalVal) {
                    if (obj.id !== originalVal) {
                        newArray.push(obj);
                    }
                } else {
                    newArray.push(obj);
                }
            });
            return newArray;
        }
    }, {
        key: 'removeDeliverLocationOption',
        value: function removeDeliverLocationOption(location, index) {
            this.model.deliveryToLocation.splice(index, 1);
            if (this.model.locationToBeUpdated && this.model.locationToBeUpdated.length) {
                var locIndex = _.findIndex(this.model.locationToBeUpdated, { locationId: location.locationDetails.Value, shiptypeId: location.shipTypeDetails.Value });
                this.model.locationToBeUpdated.splice(locIndex, 1);
            }
            this.checkDuplicateEntry();
            this.updatePickupRequirement();
        }
    }, {
        key: 'checkDuplicateEntry',
        value: function checkDuplicateEntry() {
            var _this8 = this;

            this.model.deliveryToLocation = _.map(this.model.deliveryToLocation, function (mainObj, mainObjIndex) {
                mainObj.duplicate = false;
                mainObj.location = mainObj.locationDetails ? mainObj.locationDetails.Value : null;
                mainObj.shipType = mainObj.shipTypeDetails ? mainObj.shipTypeDetails.Value : null;
                var eq = _.find(_this8.model.deliveryToLocation, function (compairObject, compairObjIndex) {
                    compairObject.location = compairObject.locationDetails ? compairObject.locationDetails.Value : null;
                    compairObject.shipType = compairObject.shipTypeDetails ? compairObject.shipTypeDetails.Value : null;
                    if (mainObjIndex > compairObjIndex) {
                        return compairObject.shipType == mainObj.shipType && compairObject.location == mainObj.location;
                    }
                });
                if (eq) {
                    mainObj.duplicate = true;
                    return mainObj;
                } else {
                    return mainObj;
                }
            });
            var checkValidDirective = this.model.deliveryToLocation.map(function (obj) {
                if (obj.duplicate) return true;
            });
            this.isValidDirective = checkValidDirective.indexOf(true) >= 0 ? false : true;
        }
    }]);
    return DeliverLocationController;
}(_locationBase2.default);

exports.default = DeliverLocationController;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _locationCreate = __webpack_require__(1924);

var _locationCreate2 = _interopRequireDefault(_locationCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationCreateModule = angular.module('locationcreate', ['ngMap']).component('locationcreate', _locationCreate2.default).name;

exports.default = locationCreateModule;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locationCreate = __webpack_require__(2741);

var _locationCreate2 = _interopRequireDefault(_locationCreate);

var _locationCreate3 = __webpack_require__(1925);

var _locationCreate4 = _interopRequireDefault(_locationCreate3);

__webpack_require__(3021);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '=',

    // these bindings will be used when this template is used in modal in shipment_batch
    model: '=',
    success: '=',
    error: '='
  },
  template: _locationCreate2.default,
  controller: _locationCreate4.default
};

exports.default = locationcreateComponent;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _from = __webpack_require__(75);

var _from2 = _interopRequireDefault(_from);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _map2 = __webpack_require__(76);

var _map3 = _interopRequireDefault(_map2);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _locationBase = __webpack_require__(107);

var _locationBase2 = _interopRequireDefault(_locationBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationCreateController = function (_LocationBaseControll) {
	LocationCreateController.$inject = ["Auth", "$state", "User", "LocationService", "Modal", "$translate", "IdStoreService", "BranchService", "CustomerService", "NgMap", "RouteService", "ContractService", "$q", "$scope", "UserBranchService", "LocationBranchService", "OrderViewService", "Configs", "SetupService", "CommonLayoutService", "DenominationService", "DateUtil", "BranchFundingSourceService", "BranchFundingSourceOrderProfileService", "CostCenterService", "AtmMakesService"];
	(0, _inherits3.default)(LocationCreateController, _LocationBaseControll);

	/*@ngInject*/
	function LocationCreateController(Auth, $state, User, LocationService, Modal, $translate, IdStoreService, BranchService, CustomerService, NgMap, RouteService, ContractService, $q, $scope, UserBranchService, LocationBranchService, OrderViewService, Configs, SetupService, CommonLayoutService, DenominationService, DateUtil, BranchFundingSourceService, BranchFundingSourceOrderProfileService, CostCenterService, AtmMakesService) {
		(0, _classCallCheck3.default)(this, LocationCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (LocationCreateController.__proto__ || (0, _getPrototypeOf2.default)(LocationCreateController)).call(this, Auth, $state, User, LocationService, Modal, $translate));
		// here _ = location


		_this.isDisabledDate = function (currentDate) {
			// if (this.model.seasonStart > this.model.seasonEnd) {
			// 	// this.model.seasonEnd = this.model.seasonStart;
			// 	this.today = moment.utc(currentDate).format()
			// } else {
			// 	this.today = moment.utc().format()
			// }
			this.todayMinDate = {
				minDate: this.model.seasonStart,
				formatDayTitle: 'MMMM',
				maxMode: "day"
			};
		};

		_this.isPMSuspended = function (val) {
			if (!val) return false;
			if (val && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' && val.isSuspended !== undefined) {
				return val.isSuspended;
			}
			var id = val && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' ? val.Value : val;
			var pm = (_this.pmSearchList || []).find(function (p) {
				return p.Value === id;
			});
			return pm && pm.isSuspended;
		};

		_this.NgMap = NgMap;
		_this.ContractService = ContractService;
		_this.BranchService = BranchService;
		_this.CustomerService = CustomerService;
		_this.RouteService = RouteService;
		_this.$scope = $scope;
		_this.$q = $q;
		_this.User = User;
		_this.LocationService = LocationService;
		_this.IdStoreService = IdStoreService;
		_this.UserBranchService = UserBranchService;
		_this.LocationBranchService = LocationBranchService;
		_this.DenominationService = DenominationService;
		_this.Configs = Configs;
		_this.totalCostomers = 0;
		_this.totalContracts = 0;
		_this.customer = [];
		_this.branch = [];
		_this.branches = [];
		_this.locations = [];
		_this.contracts = [];
		_this.contractDays = [];
		_this.costCenterList = [];
		_this.locationZoneList = [];
		_this.isValidDirective = true;
		_this.isValidDenomination = true;
		_this.isValidMaxLoad = true;
		_this.errorMessage = "";
		_this.SetupService = SetupService;
		_this.isAutoDetectOnFormSubmit = false;
		_this.CommonLayoutService = CommonLayoutService;
		_this.DateUtil = DateUtil;
		_this.BranchFundingSourceService = BranchFundingSourceService;
		_this.BranchFundingSourceOrderProfileService = BranchFundingSourceOrderProfileService;
		_this.CostCenterService = CostCenterService;
		_this.AtmMakesService = AtmMakesService;
		_this.OrderViewService = OrderViewService;
		_this.atmMakesList = [];
		_this.locationSlots = [];
		_this.denominations = [];
		_this.showAddSlotForm = false;
		_this.pickupRequestTimes = [];
		_this.days = [{
			label: _this.$translate.instant('location.mon'),
			value: 'Mon'
		}, {
			label: _this.$translate.instant('location.tues'),
			value: 'Tue'
		}, {
			label: _this.$translate.instant('location.wed'),
			value: 'Wed'
		}, {
			label: _this.$translate.instant('location.thurs'),
			value: 'Thu'
		}, {
			label: _this.$translate.instant('location.fri'),
			value: 'Fri'
		}, {
			label: _this.$translate.instant('location.sat'),
			value: 'Sat'
		}, {
			label: _this.$translate.instant('location.sun'),
			value: 'Sun'
		}, {
			label: _this.$translate.instant('location.hol'),
			value: 'Hol'
		}];

		_this.lockTypes = CommonLayoutService.lockTypes();

		_this.states = [{
			label: 'Alabama', value: 'AL'
		}, {
			label: 'Alaska', value: 'AK'
		}, {
			label: 'American Samoa', value: 'AS'
		}, {
			label: 'Arizona', value: 'AZ'
		}, {
			label: 'Arkansas', value: 'AR'
		}, {
			label: 'California', value: 'CA'
		}, {
			label: 'Colorado', value: 'CO'
		}, {
			label: 'Connecticut', value: 'CT'
		}, {
			label: 'Delaware', value: 'DE'
		}, {
			label: 'District Of Columbia', value: 'DC'
		},
		// {
		// 	label: 'Federated States Of Micronesia', value: 'FM'
		// },
		{
			label: 'Florida', value: 'FL'
		}, {
			label: 'Georgia', value: 'GA'
		}, {
			label: 'Guam', value: 'GU'
		}, {
			label: 'Hawaii', value: 'HI'
		}, {
			label: 'Idaho', value: 'ID'
		}, {
			label: 'Illinois', value: 'IL'
		}, {
			label: 'Indiana', value: 'IN'
		}, {
			label: 'Iowa', value: 'IA'
		}, {
			label: 'Kansas', value: 'KS'
		}, {
			label: 'Kentucky', value: 'KY'
		}, {
			label: 'Louisiana', value: 'LA'
		}, {
			label: 'Maine', value: 'ME'
		}, {
			label: 'Marshall Islands', value: 'MH'
		}, {
			label: 'Maryland', value: 'MD'
		}, {
			label: 'Massachusetts', value: 'MA'
		}, {
			label: 'Michigan', value: 'MI'
		}, {
			label: 'Minnesota', value: 'MN'
		}, {
			label: 'Mississippi', value: 'MS'
		}, {
			label: 'Missouri', value: 'MO'
		}, {
			label: 'Montana', value: 'MT'
		}, {
			label: 'Nebraska', value: 'NE'
		}, {
			label: 'Nevada', value: 'NV'
		}, {
			label: 'New Hampshire', value: 'NH'
		}, {
			label: 'New Jersey', value: 'NJ'
		}, {
			label: 'New Mexico', value: 'NM'
		}, {
			label: 'New York', value: 'NY'
		}, {
			label: 'North Carolina', value: 'NC'
		}, {
			label: 'North Dakota', value: 'ND'
		}, {
			label: 'Northern Mariana Islands', value: 'MP'
		}, {
			label: 'Ohio', value: 'OH'
		}, {
			label: 'Oklahoma', value: 'OK'
		}, {
			label: 'Oregon', value: 'OR'
		}, {
			label: 'Palau', value: 'PW'
		}, {
			label: 'Pennsylvania', value: 'PA'
		}, {
			label: 'Puerto Rico', value: 'PR'
		}, {
			label: 'Rhode Island', value: 'RI'
		}, {
			label: 'South Carolina', value: 'SC'
		}, {
			label: 'South Dakota', value: 'SD'
		}, {
			label: 'Tennessee', value: 'TN'
		}, {
			label: 'Texas', value: 'TX'
		}, {
			label: 'Utah', value: 'UT'
		}, {
			label: 'Vermont', value: 'VT'
		}, {
			label: 'Virgin Islands', value: 'VI'
		}, {
			label: 'Virginia', value: 'VA'
		}, {
			label: 'Washington', value: 'WA'
		}, {
			label: 'West Virginia', value: 'WV'
		}, {
			label: 'Wisconsin', value: 'WI'
		}, {
			label: 'Wyoming', value: 'WY'
		}];

		_this.branchFilter = function (rec) {}
		// debugger;


		// this.sameForAll = false
		;_this.defBackoutTimes = false;
		_this._types = [{
			label: _this.$translate.instant('location_types.DELIVERY'),
			value: 'DELIVERY'
		}, {
			label: _this.$translate.instant('routeControl.ATM'),
			value: 'ATM'
		}, {
			label: _this.$translate.instant('routeControl.nsng'),
			value: 'NO_SHIP_NO_GO'
		}, {
			label: _this.$translate.instant('routeControl.regular'),
			value: 'REGULAR'
		}, {
			label: _this.$translate.instant('routeControl.bank'),
			value: 'BANK'
		}, {
			label: _this.$translate.instant('routeControl.on_call'),
			value: 'ON_CALL'
		}, {
			label: _this.$translate.instant('routeControl.internal'),
			value: 'INTERNAL'
		}, {
			label: _this.$translate.instant('location_types.LOCKER'),
			value: 'LOCKER'
		}, {
			label: _this.$translate.instant('routeControl.truck'),
			value: 'TRUCK'
		}, {
			label: _this.$translate.instant('routeControl.tanker'),
			value: 'TANKER'
		}, {
			label: _this.$translate.instant('routeControl.carrier'),
			value: 'CARRIER'
		}, {
			label: _this.$translate.instant('routeControl.window'),
			value: 'WINDOW'
		}, {
			label: _this.$translate.instant('location_types.VAULT'),
			value: 'VAULT'
		}];

		_this.day = {
			routeId: [],
			stops: [{
				label: 'Stop1',
				value: 'stop1'
			}, {
				label: 'Stop2',
				value: 'stop2'
			}],
			options: [{
				label: 'Weekly',
				value: 'Weekly'
			}, {
				label: 'Bi-Monthly',
				value: 'Bi_Monthly'
			}, {
				label: 'Monthly',
				value: 'monthly'
			}, {
				label: 'Seasonal',
				value: 'Seasonal'
			}]

			// this.OTCCompanyNameList = [
			// 	{
			// 		label: 'First Premier',
			// 		value: 'FirstPremier'
			// 	},
			// 	{
			// 		label: 'VTS',
			// 		value: 'VTS'
			// 	},
			// {
			// 	label: 'DevCo',
			// 	value: 'DevCo'
			// },
			// {
			// 	label: 'Witzco',
			// 	value: 'witzco'
			// }
			// ]

		};_this.operationDays = [{
			label: _this.$translate.instant('location.mon'),
			value: 'Mon'
		}, {
			label: _this.$translate.instant('location.tues'),
			value: 'Tue'
		}, {
			label: _this.$translate.instant('location.wed'),
			value: 'Wed'
		}, {
			label: _this.$translate.instant('location.thurs'),
			value: 'Thu'
		}, {
			label: _this.$translate.instant('location.fri'),
			value: 'Fri'
		}, {
			label: _this.$translate.instant('location.sat'),
			value: 'Sat'
		}, {
			label: _this.$translate.instant('location.sun'),
			value: 'Sun'
		}, {
			label: _this.$translate.instant('location.hol'),
			value: 'Holiday'
		}];

		_this.dateFormat = 'MM/dd';
		_this.today = moment.utc().format(), _this._map = _this._map.bind(_this);
		_this.onMarkerDragEnd = _this.onMarkerDragEnd.bind(_this);

		_this.defaultModel = {
			id: null,
			location: '',
			status: true,
			customer: null,
			defaultBranch: null,
			loggedInUser: User.getUser().id,
			currentBranch: User.getUser().branchId,
			_address: '',
			_city: '',
			_state: null,
			_zip: '',
			refId: null,
			_poc: '',
			pocPhone: '',
			pocEmail: '',
			RNdeliveries: false,
			RNpickups: false,
			RNnoPickup: false,
			RNzeroPickup: false,
			individualBagout: false,
			centralBank: false,
			deliverBagOutPiece: false,
			balanceType: 'DENOMINATION',
			forecastingFlowDirection: 'EMPTY',
			flowThreshold: 0.2,
			Mon: {
				routeId: null,
				stops: null,
				options: null
			},
			Tue: {
				routeId: null,
				stops: null,
				options: null
			},
			Wed: {
				routeId: null,
				stops: null,
				options: null
			},
			Thu: {
				routeId: null,
				stops: null,
				options: null
			},
			Fri: {
				routeId: null,
				stops: null,
				options: null
			},
			Sat: {
				routeId: null,
				stops: null,
				options: null
			},
			Sun: {
				routeId: null,
				stops: null,
				options: null
			},
			Hol: {
				routeId: null,
				stops: null,
				options: null
			},
			seasonStart: null,
			seasonEnd: null,
			// startTime: null,
			// endTime: null,
			_type: null,
			keyId: '',
			maxDepositAmount: 0,
			// deliveryBackoutTimes: false,
			roundedDeposits: false,
			codAllow: false,
			allowMulti: false,
			bulkTransfer: false,
			deliveryLoc1: null,
			deliveryLoc2: null,
			deliveryLocCoin: null,
			deliveryLocCod: null,
			lastTransaction: true,
			_leave: true,
			verifyToTruck: true,
			verifyCoinToTruck: false,
			maxCassettes: null,
			atmCassette: false,
			packCoinSeparately: false,
			captureDenomStc: false,
			TRdeliveries: true,
			TRpickups: true,
			latitude: undefined,
			longitude: undefined,
			sameForAll: false,
			lockType: null,
			comments: null,
			OTCCompanyName: null,
			stopProcess: null,
			openTimeSun: null,
			closeTimeSun: null,
			openTimeMon: null,
			closeTimeMon: null,
			openTimeTue: null,
			closeTimeTue: null,
			openTimeWed: null,
			closeTimeWed: null,
			openTimeThu: null,
			closeTimeThu: null,
			openTimeFri: null,
			closeTimeFri: null,
			openTimeSat: null,
			closeTimeSat: null,
			openTimeHoliday: null,
			closeTimeHoliday: null,
			isSameOperationTime: false,
			ATMTransfer: false,
			OTCGeoFence: false,
			closeReq: false,
			closeEndOfStop: false,
			zoneRouting: false,
			stopPriority: null,
			model: null,
			serialNumber: null,
			secondaryLock: false,
			secondaryLockId: null,
			secondaryLockType: null,
			secondaryLockOTCCompanyName: null,
			secondaryLockCloseReq: false,
			secondaryLockAutoOpen: false,
			secondaryLockStaticOpenCode: null,
			enableOrderProfile: false,
			fundingSourceObj: {
				results: [],
				totalRecords: 0,
				loading: false,
				selectedFundingSource: null
			},
			orderProfileObj: {
				results: [],
				totalRecords: 0,
				loading: false,
				selectedOrderProfile: null
			},
			denominationSourceObj: {
				results: [],
				totalRecords: 0,
				loading: false,
				selectedDenomination: null
			},
			locationSlotDenominations: {
				results: [],
				totalRecords: 0
			},
			handleAtmLikeRegular: false,
			handleAtmLikeRegularLocationType: ['ATM', 'LOCKER', 'DELIVERY', 'BANK', 'ON_CALL', "NO_SHIP_NO_GO"],
			idBatchImport: null,
			idBagoutExport: null,
			idBagoutDepositExport: null,
			idOTCLock: null,
			scheduledLocations: [],
			deleteScheduledLocationIds: [],
			selectedDenomination: [],
			routeListObj: {
				result: [],
				totalRecords: 0
			},
			NFCLock: false,
			NFCScan: false,
			NFCTagId: null,
			distanceFromBranch: null,
			travelTimeToBranch: null,
			isNonUSLocation: false,
			costCenter: null,
			selectedLocationZones: [],
			customerCostCenter: null,
			recurringStops: [],
			make: [],
			accountNumber: null,
			machineOwner: null,
			bankSourceId: null,
			FLMProvider: null,
			SLMProvider: null,
			optional1: null,
			optional2: null,
			optional3: null,
			bankWeek: null,
			frequencyOptions: null,
			dayOfWeekOptions: null,
			contractExpirationDate: null,
			forecastingStrategy: 'DISABLED',
			liabilityThreshold: null,
			securityThreshold: null,
			atmEmptyAtCalculationMethod: 'PERCENT_CHANGE',
			aecPercentChangeValue: '0.5%',
			aecPercentChangePeriodA: '30D',
			aecPercentChangePeriodB: '15D',
			aecWeightedAvgWeightA: 0.75,
			aecWeightedAvgPeriodA: '30D',
			aecWeightedAvgWeightB: 0.35,
			aecWeightedAvgPeriodB: '15D',
			aecSinglePeriod: '30D',
			addToSwapRatio: 'ALWAYS_ADD',
			deliveryCutOff: false,
			deliveryCutOffTime: null,
			lastRouteStop: false,
			targetStopTime: null,
			printDeliveryManifest: false,
			podReceipt: false,
			sendManifestOnDelivery: false,
			manifestRecipientEmail: '',
			zeroAmountPickupRecipientEmail: '',
			pickupSLA: false,
			pickupSLATime: null,
			autoRerouteMissed: false,
			packResidual: true,
			coinPermitted: false,
			bagoutEnabled: false,
			isTransferHoldLocation: false,
			monthlyCashCountLimit: false,
			monthlyCashCountLimitAmount: 0,
			fallbackFillRate: 0,
			singleBranch: null,
			preventativeMaintenanceId: null
		};
		_this.custNotSelectError = false;
		_this.locationType = ['TANKER', 'TRUCK', 'INTERNAL', 'WINDOW'];
		_this.openTime = 'openTime';
		_this.closeTime = 'closeTime';
		_this.OTCCompanyNameList = [];
		_this.dateOptions = {
			formatDayTitle: 'MMMM',
			maxMode: "day"
			// dateDisabled:
		};

		_this.stopPriorityList = _this.CommonLayoutService.priorityList();
		_this.bankWeekList = _this.CommonLayoutService.bankWeekList();
		_this.frequencyList = _this.CommonLayoutService.frequency();
		_this.weekDayList = _this.CommonLayoutService.dayOfWeek();
		_this.foreCastingList = _this.CommonLayoutService.forecastingMethod();
		_this.atmEmptyAtCalculationMethodList = _this.CommonLayoutService.atmEmptyAtCalculationMethod();
		// this.loadLocationId();

		_this.passWdIcon = {};
		_this.passwordStats = ['primary', 'secondary'];
		_this.customerCostCenterObj = {
			results: [],
			total: 0
		};
		_this.combinedRouteIntervals = _this.CommonLayoutService.combinedRouteIntervals();
		_this.combinedRoutes = [];
		_this.dayMap = _this.CommonLayoutService.dayMap();
		_this.locationRecurringLoad = [];
		_this.isValidRecurringLoad = true;
		_this.addToSwapRatioOptions = [{
			label: 'Always Add',
			value: 'ALWAYS_ADD'
		}, {
			label: 'Always Swap',
			value: 'ALWAYS_SWAP'
		}, {
			label: '2 Adds Between Swap',
			value: '2_ADDS_BETWEEN_SWAP'
		}, {
			label: '3 Adds Between Swap',
			value: '3_ADDS_BETWEEN_SWAP'
		}, {
			label: '4 Adds Between Swap',
			value: '4_ADDS_BETWEEN_SWAP'
		}, {
			label: '5 Adds Between Swap',
			value: '5_ADDS_BETWEEN_SWAP'
		}, {
			label: '6 Adds Between Swap',
			value: '6_ADDS_BETWEEN_SWAP'
		}];
		_this.balanceTypes = [{ label: 'Denomination', value: 'DENOMINATION' }, { label: 'Percentage', value: 'PERCENTAGE' }];
		_this.forecastingFlowDirection = [{ label: 'Fill', value: 'FILL' }, { label: 'Empty', value: 'EMPTY' }];
		_this.manifestTypeList = [{
			value: 'bin_manifest_transport', label: 'Bin Manifest Transport'
		}, {
			value: 'bagout_manifest', label: 'Bagout Manifest'
		}, {
			value: 'delivery_manifest', label: 'Delivery Manifest'
		}];
		_this.manifestFileType = [{ value: 'EXCEL', label: 'EXCEL' }, { value: 'PDF', label: 'PDF' }];
		return _this;
	}

	(0, _createClass3.default)(LocationCreateController, [{
		key: '_map',
		value: function _map($event) {
			this.model.latitude = $event.latLng.lat();
			this.model.longitude = $event.latLng.lng();
			if (this.model.latitude, this.model.longitude) {
				this.getAddressFromLatLng(this.model.latitude, this.model.longitude);
			}
		}
	}, {
		key: 'loadPreventativeMaintenances',
		value: function loadPreventativeMaintenances(searchKey, offset) {
			var _this2 = this;

			searchKey = searchKey || '';
			return this.Service.getPreventativeMaintenanceList(10, offset, searchKey).then(function (data) {
				var pmList = (data.results || []).map(function (pm) {
					return {
						Key: pm.title + (pm.status === 'Suspended' ? ' (suspended)' : ''),
						Value: pm.id,
						isSuspended: pm.status === 'Suspended'
					};
				});
				if (offset === 0 || offset === undefined) {
					_this2.totalPMRecords = data.total || 0;
					_this2.pmSearchList = pmList;
				} else {
					_this2.pmSearchList = _this2.pmSearchList.concat(pmList);
				}
			});
		}
	}, {
		key: 'loadRoutes',
		value: function loadRoutes(searchKey, offset) {
			var _this3 = this;

			var selectedBranch = Array.isArray(this.model.branch) ? this.model.branch.map(function (branch) {
				return branch.branchId;
			}) : this.model.currentBranch.split();
			searchKey = searchKey || '';
			var routeSearchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: 'IN',
						data: selectedBranch
					}, {
						field: 'holdRoute',
						condition: '=',
						data: false
					}, {
						field: 'active',
						condition: '=',
						data: true
					}, {
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'name',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};

			return this.RouteService.all(routeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this3.totalRoutes = data.total;
					_this3.day.routeId = _this3.mapRoutes(data.results);
				} else {
					var routeId = _this3.mapRoutes(data.results);
					_this3.day.routeId = _this3.day.routeId.concat(routeId);
				}
			});
		}
	}, {
		key: 'mapRoutes',
		value: function mapRoutes(mapArray) {
			return mapArray.map(function (obj) {
				return {
					Key: obj.name + ' (' + obj.shortName + ')',
					Value: obj.id
				};
			});
		}
	}, {
		key: 'dontAllow',


		// do not allow to paste string into textbox
		value: function dontAllow(element) {
			element.on('cut copy paste', function (event) {
				event.preventDefault();
			});
		}
	}, {
		key: 'isUTC',
		value: function isUTC() {
			this.x = moment(this.model.seasonEnd).format('Y-MM-DD');
			this.expDate = this.x + 'T23:59:59.000Z';
			this.model.seasonEnd = this.expDate;
		}
	}, {
		key: 'searchPaginate',
		value: function searchPaginate(searchKey, idKey, nameKey) {
			return {
				queryJSON: {
					rules: [{
						field: idKey,
						condition: 'like',
						data: '%' + searchKey + '%'
					}, {
						field: nameKey,
						condition: 'like',
						data: '%' + searchKey + '%'
					}],
					operator: 'OR'
				}
			};
		}
	}, {
		key: 'customerSearchObj',
		value: function customerSearchObj(searchKey) {
			return {
				queryJSON: {
					rules: [{
						field: "isEnabled",
						condition: "=",
						data: true
					}, {
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "name",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};
		}
	}, {
		key: 'loadCustomer',
		value: function loadCustomer(searchKey, offset) {
			var _this4 = this;

			searchKey = searchKey || '';
			var costomerSearchObj = this.customerSearchObj(searchKey);
			return this.CustomerService.all(costomerSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this4.totalCostomers = data.total;
					_this4.customer = _this4.mapCustomerData(data.results);
				} else {
					var customer = _this4.mapCustomerData(data.results);
					_this4.customer = _this4.customer.concat(customer);
				}
			});
		}
	}, {
		key: 'mapCustomerData',
		value: function mapCustomerData(mapArray) {
			return mapArray.map(function (obj) {
				return {
					Key: obj.id + ' | ' + obj.name,
					Value: obj.id
				};
			});
		}
	}, {
		key: 'loadCostCenter',
		value: function loadCostCenter(searchKey, offset) {
			var _this5 = this;

			searchKey = searchKey || '';

			var obj = {
				queryJSON: {
					rules: [{
						field: "customerFlag",
						condition: "=",
						data: false
					}, {
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "name",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};

			return this.CostCenterService.all(obj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this5.totalCostCenter = data.total;
					_this5.costCenterList = _this5.mapCustomerData(data.results);
				} else {
					var costCenter = _this5.mapCustomerData(data.results);
					_this5.costCenterList = _this5.costCenterList.concat(costCenter);
				}
			});
		}
	}, {
		key: 'loadCustomersCostCenter',
		value: function loadCustomersCostCenter(searchKey, offset) {
			var _this6 = this;

			searchKey = searchKey || '';

			var obj = {
				queryJSON: {
					rules: [{
						field: "customerFlag",
						condition: "=",
						data: true
					}, {
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "name",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};

			return this.CostCenterService.all(obj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this6.customerCostCenterObj.total = data.total;
					_this6.customerCostCenterObj.results = _this6.mapCustomerData(data.results);
				} else {
					var costCenter = _this6.mapCustomerData(data.results);
					_this6.customerCostCenterObj.results = _this6.customerCostCenterObj.results.concat(costCenter);
				}
			});
		}
	}, {
		key: 'loadLocationZone',
		value: function loadLocationZone(searchKey, offset) {
			this.totalLocationZone = 0;
			this.locationZoneList = [];
			return this.$q.resolve();
		}

		// loadContract(searchKey, offset) {
		// 	searchKey = searchKey || '';
		// 	let contractSearchObj = this.searchPaginate(searchKey, 'contractId', 'contractName')
		// 	return this.ContractService.all(contractSearchObj, offset, AppConstants.defaultPageLimit)
		// 		.then((data) => {
		// 			if (offset === 0 || offset == undefined) {
		// 				this.totalContracts = data.total;
		// 				this.contracts = this.mapContractsData(data.results);
		// 			} else {
		// 				const contracts = this.mapContractsData(data.results);
		// 				this.contracts = this.contracts.concat(contracts);
		// 			}
		// 		});
		// }

		// mapContractsData(mapArray) {
		// 	return mapArray.map((obj) => {
		// 		return {
		// 			Key: obj.contractId + ' | ' + obj.contractName,
		// 			Value: obj.id
		// 		}
		// 	});
		// }

	}, {
		key: '$onInit',
		value: function $onInit() {
			var _this7 = this;

			this.isValid = true;
			this.isValidRecurringStops = true;
			this.intervalList = this.CommonLayoutService.intervalList();

			this.passwordStats.forEach(function (stat) {
				_this7.passWdIcon[stat] = { viewStaticOpenCode: false };
			});

			if (this.model && this.model.id && this.model.refId && this.model.id == this.model.refId) {
				this.defaultModel.id = this.nextAvailableId = this.model.refId;
			}
			this.model = (0, _assign2.default)(this.defaultModel, this.model || {});
			this.model = angular.copy(this.defaultModel);
			// this.model.OTCCompanyName = this.OTCCompanyNameList[0].value;
			this.model.defaultBranch = this.User.getUser().branchId;

			this.loading = true;
			if (!this.nextAvailableId) {
				this.loadLocationId();
			}
			this.loadAtmMakes();

			this.startMaxDate = {
				minDate: moment().startOf('day').format('YYYY-MM-DD 00:00:00')
			};

			this.$q.all([this.loadUsersBranch(),
			// this.loadContract('', 0),
			this.loadCustomer('', 0), this.loadRoutes('', 0), this.loadCostCenter('', 0), this.loadCustomersCostCenter('', 0), this.loadLocationZone('', 0), this.getAllFundingSource('', 0), this.loadConfigs(), this.createCombinedRoutes(), this.getAllDenominations('', 0), this.getAllLocationSlotDenominations('', 0), this.loadPickupRequestTimes(), this.loadPreventativeMaintenances('', 0)]).then(function (data) {
				// this.branch = data[0].results
			}).finally(function () {
				_this7.loading = false;
			}).catch(function (err) {
				console.log(err);
			});

			this.$scope.$watch(function () {
				return _this7.model.coinPermitted;
			}, function (newVal, oldVal) {
				if (_this7.model._type === 'ATM' && _this7.model.bankSourceId && _this7.model.denominationSourceObj && _this7.model.denominationSourceObj.results && _this7.model.denominationSourceObj.results.length > 0 && newVal !== oldVal) {
					_this7.getFilteredDenominations();
				}
			});
		}
	}, {
		key: 'loadBranchData',
		value: function loadBranchData() {
			var _this8 = this;

			if (!this.model.branch.length) {
				this.days.map(function (day) {
					_this8.model[day.value].routeId = null;
				});
			}
			this.model.selectedLocationZones = [];
			setTimeout(function () {
				_this8.loadRoutes('', 0);
				_this8.routeList('', 0);
				_this8.loadLocationZone('', 0);
				_this8.$scope.$digest();
			}, 1000);
		}

		// Display next availableId on branch change

	}, {
		key: 'loadLocationId',
		value: function loadLocationId() {
			this.previewNextAvailableId();
		}

		// Display next available ID for location

	}, {
		key: 'previewNextAvailableId',
		value: function previewNextAvailableId() {
			var _this9 = this;

			this.branchId = this.IdStoreService.branchIdPrefix(this.model.defaultBranch);
			this.IdStoreService.getPreviewNextId(this.branchId, 1).then(function (data) {
				_this9.nextAvailableId = data.start;
			}).catch(function (err) {
				_this9.nextAvailableId = "";
				console.log(err);
			});
		}
	}, {
		key: 'changeCustomer',
		value: function changeCustomer() {
			var _this10 = this;

			if (this.model.customer) {
				if (this.model.sameForAll) {
					this.custNotSelectError = false;
					// this.clearContractDays();
				}
				this.CustomerService.get(this.model.customer.Value).then(function (data) {
					// this.loadDays(data);
					if (_this10.model.sameForAll) _this10.clearContractDays();
				});
			} else {
				if (this.model.sameForAll) {
					this.uncheckSameForAll();
					this.clearContractDays();
				}
			}
		}
	}, {
		key: 'clearContractDays',
		value: function clearContractDays() {
			for (var day in this.contractDays) {
				if (this.contractDays[day]) {
					for (var key in this.model[day]) {
						this.model[day][key] = '';
					}
				}
			}
			// this.contractDays = []
		}
	}, {
		key: 'createCombinedRoutes',
		value: function createCombinedRoutes() {
			var _this11 = this;

			this.combinedRoutes = [];
			this.days.forEach(function (day) {
				_this11.combinedRoutes.push({
					sequence: 99,
					day: day,
					route: null,
					interval: null,
					anchorDate: null,
					combinedRouteIntervals: [].concat((0, _toConsumableArray3.default)(_this11.combinedRouteIntervals)),
					isVisible: day.value === 'Hol' ? false : true
				});
			});
		}
	}, {
		key: 'sameAll',
		value: function sameAll() {
			var _this12 = this;

			this.contractDays = [];
			this.days.forEach(function (data) {
				_this12.contractDays[data.value] = true;
			});

			if (this.model.sameForAll) {
				for (var day in this.contractDays) {
					if (this.contractDays[day]) {
						for (var key in this.model[day]) {
							this.model[day][key] = '';
						}
					}
				}
			}
		}
	}, {
		key: 'updateAll',
		value: function updateAll(selectedDay, opt) {
			if (this.model.sameForAll) {
				if (this.contractDays[selectedDay]) {
					for (var day in this.contractDays) {
						if (this.contractDays[day]) {
							this.model[day][opt] = this.model[selectedDay][opt];
						}
					}
				}
			}
		}
	}, {
		key: 'uncheckSameForAll',
		value: function uncheckSameForAll() {
			var _this13 = this;

			this.custNotSelectError = true;
			setTimeout(function () {
				_this13.custNotSelectError = false;
				_this13.model.sameForAll = false;
				_this13.$scope.$digest();
			}, 4000);
		}
	}, {
		key: 'changeLocationType',
		value: function changeLocationType() {
			this.model.centralBank = false;
			this.model.verifyToTruck = ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(this.model._type) > -1;
			// this.model.verifyCoinToTruck = this.model.verifyToTruck;

			if (this.model._type !== 'ATM') {
				this.model.maxCassettes = null;
			}

			if (this.model._type == 'WINDOW' || this.model._type == 'INTERNAL' || this.model._type == 'TANKER') {
				var anyOne = void 0;
				this.branch.forEach(function (d, index) {
					if (anyOne == null && d.ticked) {
						anyOne = d;
					} else {
						d.ticked = false;
					}
				});
				if (anyOne) {
					this.model.singleBranch = anyOne.branchId;
					this.model.branch = [anyOne];
				} else {
					this.model.singleBranch = null;
					this.model.branch = [];
				}
				this.loadLocationZone('', 0);
			}
			if (this.model._type !== 'ATM' && this.model._type !== 'LOCKER') {
				this.model.lockType = null;
				this.model.OTCCompanyName = null;
			}
			// else this.model.OTCCompanyName = this.OTCCompanyNameList[0].value;
			this.showStopProcess = ['TANKER', 'TRUCK', 'WINDOW', 'CARRIER', 'LOCKER'].indexOf(this.model._type) === -1;
			if (!this.showStopProcess) this.model.stopProcess = null;
			this.createLocationRecurringLoad();
		}
	}, {
		key: 'onAtmCassetteChange',
		value: function onAtmCassetteChange() {
			if (!this.model.atmCassette) {
				this.model.maxCassettes = null;
			}
		}

		// Reset Multi-Branch selection

	}, {
		key: 'resetMultiBranchSelection',
		value: function resetMultiBranchSelection() {
			var _this14 = this;

			if (this.model.branch && this.model.branch.length) {
				this.model.branch.forEach(function (selectedBranch) {
					_this14.branch.filter(function (branch) {
						if (branch.branchId == selectedBranch.branchId) {
							branch.ticked = false;
						}
					});
				});
			}
			this.loadUsersBranch();
		}
	}, {
		key: 'onSingleBranchChange',
		value: function onSingleBranchChange() {
			var _this15 = this;

			this.branch.forEach(function (b) {
				b.ticked = b.branchId === _this15.model.singleBranch;
			});
			this.model.branch = this.branch.filter(function (b) {
				return b.ticked;
			});
			this.loadBranchData();
		}

		// Load branch user has permission

	}, {
		key: 'loadUsersBranch',
		value: function loadUsersBranch() {
			var _this16 = this;

			this.UserBranchService.getUserBranches(this.model.loggedInUser).then(function (data) {
				_this16.branch = data.results;
				_this16.branch.filter(function (branch) {
					if (branch.branchId == _this16.model.defaultBranch) {
						branch.ticked = true;
					}
				});
				if (_this16.model._type == 'WINDOW' || _this16.model._type == 'INTERNAL' || _this16.model._type == 'TANKER') {
					_this16.model.singleBranch = _this16.model.defaultBranch;
					_this16.model.branch = _this16.branch.filter(function (b) {
						return b.ticked;
					});
					_this16.loadLocationZone('', 0);
				}
				_this16.getSetupDetails();
				// this.model.OTCCompanyName = this.OTCCompanyNameList[0].value;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'calculateCoinAmount',
		value: function calculateCoinAmount(recurringLoad, denom) {
			if (recurringLoad.qty) {
				if (denom.faceValue) {
					recurringLoad.amount = recurringLoad.qty * denom.faceValue;
				}
			}
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.resetMultiBranchSelection();
			this.model = angular.copy(this.defaultModel);
			this.getAllDenominations();
			this.getAllLocationSlotDenominations();
			this.nextAvailableId = "";
			this.errorMessage = "";
			this.day.routeId = [];
			this.totalRoutes = 0;
			this.clearErrors();
			angular.element("input[type='time']").val(null); // reset Delivery-Backout-time toggle Data on switch-off
			this.previewNextAvailableId();
			this.resetCombinedRoutes();
			this.locationRecurringLoad = [];
		}

		// create branch group for location

	}, {
		key: 'createLocationBranch',
		value: function createLocationBranch() {
			this.branches = this.model.branch.map(function (branchObj) {
				return branchObj.branchId;
			});
			this.LocationBranchService.createLocationBranchGroup({
				locationId: this.nextAvailableId,
				branches: this.branches
			}).then(function (res) {}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this17 = this;

			var promise = _promise2.default.resolve();
			this.isAutoDetectOnFormSubmit = true;
			promise = promise
			// .then(() => this.autoDetect())
			.then(function () {
				_this17.loading = true;
				if (_this17.model.deliveryToLocation && _this17.model.deliveryToLocation.length) {
					_this17.model.deliveryToLocation.map(function (deliveryLocObj, index) {
						if (deliveryLocObj.allLocations) {
							delete _this17.model.deliveryToLocation[index].allLocations;
						}
						if (deliveryLocObj.allShipeType) {
							delete _this17.model.deliveryToLocation[index].allShipeType;
						}
					});
				}

				if (_this17.model.scheduledLocations.length) {
					_this17.model.scheduledLocations.forEach(function (d) {
						d.vaultDate = moment(d.vaultDate).format('YYYY-MM-DD');
						d.routeId = d.routeId.Value;
					});
				}

				// Validate user-entered maxLoad is divisible by denomination faceValue
				_this17.checkForMaxLoadFaceValueDivisibility();
				if (_this17.model.selectedDenomination.length) {
					_this17.model.selectedDenomination.forEach(function (i) {
						i.maxLoad = i.maxLoad, i.maxResidualThreshold = _this17.convertStr(i.maxResidualThreshold), i.minResidualThreshold = _this17.convertStr(i.minResidualThreshold);
						i.id = i.denom.id; // denominationId
					});
				}

				// if (this.model.recurringStops.length && ['TRUCK', 'INTERNAL', 'TANKER', 'WINDOW', 'CARRIER'].indexOf(this.model._type) === -1) {
				// const recurringStops = [];
				// this.model.recurringStops.forEach((d) => {
				// 	d.anchorDate = moment(d.anchorDate).format('YYYY-MM-DD');
				// 	d.effectiveTillDate = d.effectiveTillDate ? moment(d.effectiveTillDate).format('YYYY-MM-DD') : null;
				// 	d.routeId = d.route.Value;
				// 	d.locationId = this.nextAvailableId;
				// 	delete d.route;
				// 	recurringStops.push(_.cloneDeep(d));
				// })

				var combinedRoutes = [];
				_this17.combinedRoutes.forEach(function (r) {
					if (r.route && r.sequence && r.anchorDate && r.interval) {
						combinedRoutes.push({
							anchorDate: moment(r.anchorDate).format('YYYY-MM-DD'),
							effectiveTillDate: null,
							frequency: r.interval.frequency,
							sequence: r.sequence,
							interval: r.interval.interval,
							routeId: r.route.Value,
							locationId: '' + _this17.nextAvailableId,
							description: r.day.value + ' ' + _this17.nextAvailableId + ' CombinedRoute',
							dayOfWeek: r.day.value,
							locationScheduleRecurringLoadData: _this17.locationRecurringLoad.flatMap(function (d) {
								return d.locationScheduleRecurringDay === r.day.value ? (0, _entries2.default)(d.recurringLoad).filter(function (_ref) {
									var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
									    key = _ref2[0],
									    value = _ref2[1];

									return value.amount !== "";
								}).map(function (_ref3) {
									var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
									    key = _ref4[0],
									    value = _ref4[1];

									return { denominationId: key, amount: value.amount };
								}) : [];
							})
						});
					}
				});

				// }
				_this17.x = moment(_this17.model.seasonEnd).format('Y-MM-DD');
				_this17.expDate = moment(_this17.model.seasonEnd).format('YYYY-MM-DD');
				_this17.effDate = moment(_this17.model.seasonStart).format('YYYY-MM-DD');

				_this17.Service.create({
					id: _this17.nextAvailableId,
					name: _this17.model.name,
					comments: _this17.model.comments || null,
					active: _this17.model.status,
					customerId: _this17.model.customer ? _this17.model.customer.Value : null,
					// customerContractId: this.model.contract ? this.model.contract.Value : null,
					branchId: _this17.model.defaultBranch,
					address: _this17.model._address || null,
					city: _this17.model._city || null,
					state: _this17.model._state,
					zip: _this17.model._zip || null,
					refNumber: _this17.model.refId ? _this17.model.refId : null,
					poc: _this17.model._poc || null,
					phone: _this17.model.pocPhone || null,
					email: _this17.model.pocEmail || null,
					balanceType: _this17.model.balanceType,
					forecastingFlowDirection: _this17.model.forecastingFlowDirection,
					flowThreshold: _this17.model.flowThreshold && _this17.model.balanceType == 'PERCENTAGE' ? _this17.convertStr(_this17.model.flowThreshold) / 100 : _this17.model.flowThreshold,
					routeNotificationDeliveries: _this17.model.RNdeliveries,
					routeNotificationPickups: _this17.model.RNpickups,
					routeNotificationNoPickup: _this17.model.RNnoPickup,
					routeNotificationZeroPickup: _this17.model.RNzeroPickup,
					defRouteMonId: _this17.model.Mon.routeId ? _this17.model.Mon.routeId.Value : null,
					// defRouteMonStop: this.model.Tue.stops,
					defRouteSeqMon: _this17.model.Mon.options || 1,
					defRouteTueId: _this17.model.Tue.routeId ? _this17.model.Tue.routeId.Value : null,
					// defRouteTueStop: this.model.Tue.stops,
					defRouteSeqTue: _this17.model.Tue.options || 1,
					defRouteWedId: _this17.model.Wed.routeId ? _this17.model.Wed.routeId.Value : null,
					// defRouteWedStop: this.model.Wed.stops,
					defRouteSeqWed: _this17.model.Wed.options || 1,
					defRouteThuId: _this17.model.Thu.routeId ? _this17.model.Thu.routeId.Value : null,
					// defRouteThuStop: this.model.Thu.stops,
					defRouteSeqThu: _this17.model.Thu.options || 1,
					defRouteFriId: _this17.model.Fri.routeId ? _this17.model.Fri.routeId.Value : null,
					// defRouteFriStop: this.model.Fri.stops,
					defRouteSeqFri: _this17.model.Fri.options || 1,
					defRouteSatId: _this17.model.Sat.routeId ? _this17.model.Sat.routeId.Value : null,
					// defRouteSatStop: this.model.Sat.stops,
					defRouteSeqSat: _this17.model.Sat.options || 1,
					defRouteSunId: _this17.model.Sun.routeId ? _this17.model.Sun.routeId.Value : null,
					// defRouteSunStop: this.model.Sun.stops,
					defRouteSeqSun: _this17.model.Sun.options || 1,
					defRouteHolId: _this17.model.Hol.routeId ? _this17.model.Hol.routeId.Value : null,
					// defRouteHolStop: this.model.Hol.stops,
					defRouteSeqHol: _this17.model.Hol.options || 1,
					seasonStart: _this17.model.seasonStart ? _this17.effDate : null,
					seasonEnd: _this17.model.seasonEnd ? _this17.expDate : null,
					// deliveryBackoutTimes: this.model.deliveryBackoutTimes,
					deliverBagOutPiece: _this17.model.deliverBagOutPiece,
					individualBagout: _this17.model.individualBagout,
					centralBank: _this17.model.centralBank,
					// openTime: this.model.startTime ? moment(this.model.startTime).format('HH:mm:ss') : null,
					// closeTime: this.model.endTime ? moment(this.model.endTime).format('HH:mm:ss') : null,
					deliveryLoc1Id: _this17.model.deliveryLoc1 || null,
					deliveryLoc2Id: _this17.model.deliveryLoc2 || null,
					deliveryLocCoinId: _this17.model.deliveryLocCoin || null,
					deliveryLocCodId: _this17.model.deliveryLocCod || null,
					locationType: _this17.model._type,
					keyNum: _this17.model.keyId || null,
					maxDepositAmount: _this17.model.maxDepositAmount || null,
					decimalCash: _this17.model.roundedDeposits,
					codPickup: _this17.model.codAllow,
					allowMulti: _this17.model.allowMulti,
					scanLeaveLocation: _this17.model._leave,
					scanLastTranscation: _this17.model.lastTransaction,
					verifyToTruck: ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(_this17.model._type) > -1 ? _this17.model.verifyToTruck : false,
					verifyCoinToTruck: ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(_this17.model._type) > -1 && _this17.model.verifyToTruck ? _this17.model.verifyCoinToTruck : false,
					scanATMCassette: _this17.model._type === 'ATM' ? _this17.model.atmCassette : false,
					maxCassettes: _this17.model._type === 'ATM' && _this17.model.atmCassette ? parseInt(_this17.model.maxCassettes, 10) : null,
					packCoinSeparately: !!_this17.model.packCoinSeparately,
					captureDenomStc: _this17.model._type === 'ATM' ? !!_this17.model.captureDenomStc : false,
					noPrintDelivery: !_this17.model.TRdeliveries,
					noPrintPickup: !_this17.model.TRpickups,
					lat: _this17.model.latitude ? parseFloat(_this17.model.latitude) : undefined,
					long: _this17.model.longitude ? parseFloat(_this17.model.longitude) : undefined,
					deliveryToLocation: _this17.model.deliveryToLocation || [],
					lockType: _this17.model.lockType,
					OTCCompanyName: _this17.model.OTCCompanyName || null,
					stopProcess: _this17.model.stopProcess || null,
					openTimeSun: _this17.model.openTimeSun ? moment(_this17.model.openTimeSun).format('HH:mm:00') : null,
					closeTimeSun: _this17.model.closeTimeSun ? moment(_this17.model.closeTimeSun).format('HH:mm:00') : null,
					openTimeMon: _this17.model.openTimeMon ? moment(_this17.model.openTimeMon).format('HH:mm:00') : null,
					closeTimeMon: _this17.model.closeTimeMon ? moment(_this17.model.closeTimeMon).format('HH:mm:00') : null,
					openTimeTue: _this17.model.openTimeTue ? moment(_this17.model.openTimeTue).format('HH:mm:00') : null,
					closeTimeTue: _this17.model.closeTimeTue ? moment(_this17.model.closeTimeTue).format('HH:mm:00') : null,
					openTimeWed: _this17.model.openTimeWed ? moment(_this17.model.openTimeWed).format('HH:mm:00') : null,
					closeTimeWed: _this17.model.closeTimeWed ? moment(_this17.model.closeTimeWed).format('HH:mm:00') : null,
					openTimeThu: _this17.model.openTimeThu ? moment(_this17.model.openTimeThu).format('HH:mm:00') : null,
					closeTimeThu: _this17.model.closeTimeThu ? moment(_this17.model.closeTimeThu).format('HH:mm:00') : null,
					openTimeFri: _this17.model.openTimeFri ? moment(_this17.model.openTimeFri).format('HH:mm:00') : null,
					closeTimeFri: _this17.model.closeTimeFri ? moment(_this17.model.closeTimeFri).format('HH:mm:00') : null,
					openTimeSat: _this17.model.openTimeSat ? moment(_this17.model.openTimeSat).format('HH:mm:00') : null,
					closeTimeSat: _this17.model.closeTimeSat ? moment(_this17.model.closeTimeSat).format('HH:mm:00') : null,
					openTimeHoliday: _this17.model.openTimeHoliday ? moment(_this17.model.openTimeHoliday).format('HH:mm:00') : null,
					closeTimeHoliday: _this17.model.closeTimeHoliday ? moment(_this17.model.closeTimeHoliday).format('HH:mm:00') : null,
					ATMTransfer: _this17.model.ATMTransfer,
					OTCGeoFence: _this17.model.OTCGeoFence,
					closeReq: _this17.model.closeReq,
					closeEndOfStop: _this17.model.stopProcess === 'L' && _this17.model.closeEndOfStop,
					zoneRouting: _this17.model.zoneRouting,
					stopPriority: ['REGULAR', 'ATM', 'ON_CALL', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO'].indexOf(_this17.model._type) > -1 ? _this17.model.stopPriority : null,
					model: _this17.model._type === 'ATM' ? _this17.model.model : null,
					serialNumber: _this17.model._type === 'ATM' ? _this17.model.serialNumber : null,
					staticOpenCode: _this17.model.lockType === 'static' ? _this17.model.staticOpenCode : null,
					userId: _this17.model.loggedInUser,
					vaultDate: _this17.DateUtil.getUTCDate(_this17.model.setupDetails.currentVaultDate),
					secondaryLock: _this17.model.secondaryLock,
					secondaryLockId: _this17.model.secondaryLock ? _this17.model.secondaryLockId : null,
					secondaryLockType: _this17.model.secondaryLock ? _this17.model.secondaryLockType : null,
					secondaryLockOTCCompanyName: _this17.model.secondaryLock ? _this17.model.secondaryLockOTCCompanyName : null,
					secondaryLockCloseReq: _this17.model.secondaryLockType !== 'static' && _this17.model.secondaryLock ? _this17.model.secondaryLockCloseReq : false,
					secondaryLockAutoOpen: _this17.model.secondaryLockType !== 'static' && _this17.model.secondaryLock ? _this17.model.secondaryLockAutoOpen : false,
					secondaryLockStaticOpenCode: _this17.model.secondaryLock && _this17.model.secondaryLockType == 'static' ? _this17.model.secondaryLockStaticOpenCode : null,
					enableOrderProfile: _this17.model.enableOrderProfile,
					branchFundingSourceId: _this17.model.enableOrderProfile ? _this17.model.fundingSourceObj.selectedFundingSource.Value : null,
					branchFundingSourceOrderProfileId: _this17.model.enableOrderProfile ? _this17.model.orderProfileObj.selectedOrderProfile.Value : null,
					handleAtmLikeRegular: _this17.model.handleAtmLikeRegularLocationType.includes(_this17.model._type) ? _this17.model.handleAtmLikeRegular : false,
					idBatchImport: _this17.model.idBatchImport || null,
					idBagoutExport: _this17.model.idBagoutExport || null,
					idBagoutDepositExport: _this17.model.idBagoutDepositExport || null,
					idOTCLock: _this17.model.idOTCLock || null,
					scheduledLocations: _this17.model.scheduledLocations,
					NFCLock: _this17.model.lockType === 'witz' || _this17.model.lockType === 'TDS' ? _this17.model.NFCLock : false,
					country: _this17.model.isNonUSLocation ? _this17.model.country : 'US',
					NFCScan: _this17.model.NFCScan,
					NFCTagId: _this17.model.NFCScan ? _this17.model.NFCTagId : null,
					distanceFromBranch: _this17.model.distanceFromBranch,
					travelTimeToBranch: _this17.model.travelTimeToBranch,
					costCenterId: _this17.model.costCenter ? _this17.model.costCenter.Value : null,
					customerCostCenterId: _this17.model.customerCostCenter ? _this17.model.customerCostCenter.Value : null,
					accountNumber: _this17.model.accountNumber ? _this17.model.accountNumber.trim() : null,
					make: _this17.parseMakeValues(_this17.model.make),
					machineOwner: _this17.model.machineOwner,
					bankSourceId: _this17.model.bankSourceId ? _this17.model.bankSourceId.Value : null,
					FLMProvider: _this17.model.FLMProvider,
					SLMProvider: _this17.model.SLMProvider,
					bankWeek: _this17.model.bankWeek,
					optional1: _this17.model.optional1,
					optional2: _this17.model.optional2,
					optional3: _this17.model.optional3,
					frequency: _this17.model.frequencyOptions,
					dayOfWeek: _this17.model.dayOfWeekOptions,
					// recurringStops,
					combinedRoutes: combinedRoutes,
					defRecurringRouteHolId: _this17.combinedRoutes[7].route ? _this17.combinedRoutes[7].route.Value : null,
					locationDistanceId: _this17.model.locationDistanceId ? _this17.model.locationDistanceId : null,
					contractExpirationDate: _this17.model.contractExpirationDate ? moment(_this17.model.contractExpirationDate).format('YYYY-MM-DD') : null,
					// locationDenomination:  this.model.denominationSourceObj.selectedDenomination && this.model._type === 'ATM' ? this.model.denominationSourceObj.selectedDenomination : [],
					locationDenomination: _this17.model.selectedDenomination,
					liabilityThreshold: _this17.model.liabilityThreshold ? _this17.model.liabilityThreshold : null,
					securityThreshold: _this17.model.securityThreshold ? _this17.model.securityThreshold : null,
					forecastingStrategy: _this17.model.forecastingStrategy,
					atmEmptyAtCalculationMethod: _this17.model.atmEmptyAtCalculationMethod,
					aecPercentChangeValue: _this17.model.aecPercentChangeValue ? _this17.convertStr(_this17.model.aecPercentChangeValue) : 0.5,
					aecPercentChangePeriodA: _this17.model.aecPercentChangePeriodA ? _this17.model.aecPercentChangePeriodA : '30D',
					aecPercentChangePeriodB: _this17.model.aecPercentChangePeriodB ? _this17.model.aecPercentChangePeriodB : '15D',
					aecWeightedAvgWeightA: _this17.model.aecWeightedAvgWeightA ? _this17.model.aecWeightedAvgWeightA : 0.75,
					aecWeightedAvgPeriodA: _this17.model.aecWeightedAvgPeriodA ? _this17.model.aecWeightedAvgPeriodA : '30D',
					aecWeightedAvgWeightB: _this17.model.aecWeightedAvgWeightB ? _this17.model.aecWeightedAvgWeightB : 0.35,
					aecWeightedAvgPeriodB: _this17.model.aecWeightedAvgPeriodB ? _this17.model.aecWeightedAvgPeriodB : '15D',
					aecSinglePeriod: _this17.model.aecSinglePeriod ? _this17.model.aecSinglePeriod : '30D',
					addSwapRatio: _this17.model.addToSwapRatio,
					deliveryCutOff: _this17.model.deliveryCutOff,
					deliveryCutOffTime: _this17.model.deliveryCutOff && _this17.model.deliveryCutOffTime ? moment(_this17.model.deliveryCutOffTime).format('HH:mm:ss') : null,
					lastRouteStop: _this17.model._type === 'DELIVERY' ? _this17.model.lastRouteStop : false,
					targetStopTime: _this17.model.targetStopTime ? moment(_this17.model.targetStopTime).format('HH:mm:ss') : null,
					printDeliveryManifest: _this17.model.printDeliveryManifest,
					podReceipt: _this17.model.podReceipt,
					locationSlots: _this17.locationSlots,
					sendManifestOnDelivery: _this17.model.sendManifestOnDelivery ? _this17.model.sendManifestOnDelivery : false,
					manifestType: _this17.model.sendManifestOnDelivery ? _this17.model.manifestType : null,
					manifestRecipientEmail: _this17.model.sendManifestOnDelivery ? _this17.model.manifestRecipientEmail : null,
					zeroAmountPickupRecipientEmail: _this17.model.sendManifestOnDelivery ? _this17.model.zeroAmountPickupRecipientEmail : null,
					manifestFileType: _this17.model.sendManifestOnDelivery ? _this17.model.manifestFileType : null,
					pickupSLA: _this17.model.pickupSLA,
					pickupSLATime: _this17.model.pickupSLA ? _this17.model.pickupSLATime : null,
					autoRerouteMissed: _this17.model.autoRerouteMissed,
					packResidual: _this17.model._type === 'ATM' ? _this17.model.packResidual : false,
					coinPermitted: _this17.model._type === 'ATM' ? _this17.model.coinPermitted : false,
					monthlyCashCountLimit: !!_this17.model.monthlyCashCountLimit,
					monthlyCashCountLimitAmount: _this17.model.monthlyCashCountLimitAmount,
					bagoutEnabled: ['BANK', 'DELIVERY'].includes(_this17.model._type) ? _this17.model.bagoutEnabled : false,
					bulkTransfer: ['TANKER', 'TRUCK', 'INTERNAL'].includes(_this17.model._type) ? _this17.model.bulkTransfer : false,
					isTransferHoldLocation: _this17.model._type === 'INTERNAL' ? _this17.model.isTransferHoldLocation : false,
					fallbackFillRate: _this17.model.fallbackFillRate,
					preventativeMaintenanceId: ['ATM', 'ON_CALL'].includes(_this17.model._type) && _this17.model.preventativeMaintenanceId ? _this17.model.preventativeMaintenanceId.Value : null
				}).then(function (data) {
					_this17.loading = false;
					if (_this17.success) {
						// the template is opened in some modal
						_this17.success(data);
					} else {
						_this17.askCreate().then(function (valid) {
							if (valid) {
								setTimeout(function () {
									_this17.resetMultiBranchSelection();
									_this17.previewNextAvailableId();
									_this17.loadRoutes('', 0);
								}, 500);
							}
						});
					}
				}).then(function () {
					_this17.createLocationBranch();
				}).catch(function (err) {
					_this17.loading = false;
					_this17.previewNextAvailableId();
					if (_this17.error) {
						// the template is opened in some modal
						_this17.error(err);
					}

					if (err && err.data && err.data.errors) {
						err.data.errors.map(function (e) {
							if (e && e.path == "LOCATION.refNumber") {
								_this17.errorMessage = _this17.$translate.instant('location.refNumberUnique');
								_this17.Modal.errorModal(_this17.errorMessage);
							} else if (e && e.path == 'LOCATION.NFCTagId') {
								_this17.errorMessage = _this17.$translate.instant('common.unique_nfc_tag_id');
								_this17.Modal.errorModal(_this17.errorMessage);
							} else {
								_this17.errorMessage = e.value === "1009" ? _this17.$translate.instant('common.error_' + e.path.toLowerCase() + '_key') : e.message + '<br/>';
								_this17.Modal.errorModal(_this17.errorMessage);
							}
						});
					} else if (err && err.data && err.data.message) {
						_this17.Modal.errorModal(err.data.message);
					}
				});
			});
		}
	}, {
		key: 'autoDetect',
		value: function autoDetect() {
			var _this18 = this;

			if (!this.render) return;

			var address = '';

			if (this.model._address) address += this.model._address + ", ";
			if (this.model._city) address += this.model._city + ", ";
			if (this.model._state) address += this.model._state + ", ";
			if (this.model._zip) address += this.model._zip;

			this.model.updatingDrivingDistance = true;

			if (['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf(this.model._type) > -1 && this.maintainDriveDistance && this.model.status) {

				return this.Service.getLocationDrivingDistance(address, this.formatAddress(this.model.setupDetails)).then(function (data) {
					if (data.status) {
						if (_lodash2.default.isEmpty(data.results)) {
							return _promise2.default.reject('location.invalidAddress');
						} else if (data.results.status === 'NOT_FOUND') {
							return _promise2.default.reject('location.not_found');
						} else if (data.results.status === 'ZERO_RESULTS') {
							return _promise2.default.reject('location.zero_results');
						} else {
							_this18.model.distanceFromBranch = data.results.distance.text;
							_this18.model.travelTimeToBranch = data.results.duration.text;
							_this18.model.locationDistance = data.results.locationDistance ? data.results.locationDistance.label : '';
							_this18.model.locationDistanceId = data.results.locationDistance ? data.results.locationDistance.id : '';
							return _this18.locationGeoCodes(address);
						}
					} else return _promise2.default.reject(data.errorMessage);
				}).catch(function (err) {
					_this18.Modal.errorModal(err);
					return _promise2.default.reject();
				}).finally(function () {
					_this18.model.updatingDrivingDistance = false;
				});
			} else {
				this.model.updatingDrivingDistance = false;
				return this.locationGeoCodes(address);
			}
		}
	}, {
		key: 'locationGeoCodes',
		value: function locationGeoCodes(address) {
			var _this19 = this;

			var defer = this.$q.defer();

			if (address == '') {
				this.loading = false;
				return defer.resolve();
			}
			var geocoder = new google.maps.Geocoder();
			var results = geocoder.geocode({ 'address': address });
			if (!results || results.length == 0) return defer.resolve();

			geocoder.geocode({ 'address': address }, function (results, status) {
				if (status === 'OK') {
					var latitude = results[0].geometry.location.lat();
					var longitude = results[0].geometry.location.lng();
					_this19.setMarkerPosition(latitude, longitude);
					_this19.$scope.$apply();
					return defer.resolve();
				} else if (status === 'NOT_FOUND') {
					_this19.loading = false;
					_this19.Modal.errorModal('location.not_found');
					return defer.reject();
				} else if (status === 'ZERO_RESULTS') {
					_this19.loading = false;
					if (_this19.maintainDriveDistance) _this19.Modal.errorModal('location.zero_results');else if (!_this19.maintainDriveDistance) _this19.Modal.errorModal('location.invalidAddress');
					return defer.reject();
				} else {
					_this19.Modal.errorModal('location.invalidAddress');
					_this19.loading = false;
					return defer.reject();
				}
			});
			return defer.promise;
		}
	}, {
		key: 'getAddressFromLatLng',
		value: function getAddressFromLatLng(lat, lng) {
			var _this20 = this;

			var defer = this.$q.defer();

			if (!lat || !lng) {
				this.loading = false;
				return defer.resolve();
			}

			var geocoder = new google.maps.Geocoder();
			var latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

			geocoder.geocode({ location: latlng }, function (results, status) {
				if (status === 'OK' && results && results.length > 0) {
					var result = results[0];
					var addressComponents = result.address_components;

					var locationData = {
						address: '',
						city: '',
						country: '',
						state: '',
						zip: ''
					};

					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = (0, _getIterator3.default)(addressComponents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var component = _step.value;

							var types = component.types;
							var locAddress = null;
							if (types.length === 0) locAddress = component.long_name;else if (types.includes('street_number')) locAddress = component.short_name;else if (types.includes('route')) locAddress = component.long_name;

							if (locAddress) {
								locationData.address = [locationData.address, locAddress].filter(Boolean).join(' ');
							}
							if (types.includes('locality')) {
								locationData.city = component.long_name;
							}
							if (types.includes('country')) {
								locationData.country = component.long_name;
							}
							if (types.includes('administrative_area_level_1')) {
								locationData.state = component.long_name;
							}
							if (types.includes('postal_code')) {
								locationData.zip = component.long_name;
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}

					_this20.model._address = locationData.address;
					_this20.model._city = locationData.city;
					_this20.model.country = locationData.country;
					_this20.model._zip = locationData.zip;
					if (_this20.model.isNonUSLocation) {
						_this20.model._state = locationData.state;
					} else {
						var matchedState = _this20.states.find(function (state) {
							return state.label.toLowerCase() === locationData.state.toLowerCase();
						});
						_this20.model._state = matchedState ? matchedState.value : '';
					}

					_this20.loading = false;
					_this20.$scope.$apply();

					return defer.resolve(locationData);
				} else if (status === 'ZERO_RESULTS' || status === 'NOT_FOUND') {
					_this20.loading = false;
					_this20.Modal.errorModal('location.not_found');
					return defer.reject('No results found');
				} else {
					_this20.loading = false;
					_this20.Modal.errorModal('location.invalidAddress');
					return defer.reject('Geocoder failed: ' + status);
				}
			});

			return defer.promise;
		}
	}, {
		key: 'setMarkerPosition',
		value: function setMarkerPosition(lat, lng) {
			var _this21 = this;

			var self = this;
			if (!lat && !lng) {
				var lat = document.getElementById("lat").value;
				var lng = document.getElementById("lng").value;
			} else {
				if (lat && lng) {
					this.getAddressFromLatLng(lat, lng);
				}
				document.getElementById("lat").value = lat;
				document.getElementById("lng").value = lng;
				self.model.latitude = document.getElementById("lat").value;
				self.model.longitude = document.getElementById("lng").value;
			}

			var oldMarker;

			var latlng = new google.maps.LatLng(lat, lng);

			var options = { zoom: 16, center: latlng, mapTypeId: google.maps.MapTypeId.ROADMAP };

			var map = new google.maps.Map(document.getElementById("map"), options);

			oldMarker = new google.maps.Marker({ position: latlng, map: map, draggable: true });

			google.maps.event.addListener(oldMarker, "dragend", function (event) {
				var dragLat = event.latLng.lat();
				var dragLng = event.latLng.lng();
				if (dragLat && dragLng) {
					_this21.getAddressFromLatLng(dragLat, dragLng);
				}
				document.getElementById("lat").value = dragLat;
				document.getElementById("lng").value = dragLng;
				self.model.latitude = dragLat;
				self.model.longitude = dragLng;
				self.$scope.$apply();
			});

			google.maps.event.addListener(map, "click", function (event) {
				// get lat/long of click
				var clickLat = event.latLng.lat();
				var clickLong = event.latLng.lng();

				if (clickLat && clickLong) {
					_this21.getAddressFromLatLng(clickLat, clickLong);
				}

				// show in input box
				document.getElementById("lat").value = clickLat;
				document.getElementById("lng").value = clickLong;

				self.model.latitude = clickLat;
				self.model.longitude = clickLong;

				var marker = new google.maps.Marker({ position: new google.maps.LatLng(clickLat, clickLong), map: map, draggable: true });

				if (oldMarker != undefined) {
					oldMarker.setMap(null);
				}
				oldMarker = marker;

				google.maps.event.addListener(marker, "dragend", function (event) {
					var dragLat = event.latLng.lat();
					var dragLng = event.latLng.lng();
					if (dragLat && dragLng) {
						_this21.getAddressFromLatLng(dragLat, dragLng);
					}
					document.getElementById("lat").value = dragLat;
					document.getElementById("lng").value = dragLng;
					self.model.latitude = dragLat;
					self.model.longitude = dragLng;
					self.$scope.$apply();
				});
			});

			if (this.maintainDriveDistance) {
				this.marker = new google.maps.Marker({
					position: new google.maps.LatLng(this.model.setupDetails.gpsLat, this.model.setupDetails.gpsLong),
					map: map,
					label: {
						text: 'B',
						color: 'white',
						fontWeight: 'bold'
					}
				});

				var branchInfoPopup = new google.maps.InfoWindow({
					content: '\n\t\t\t\t<h6>Branch Address</h6>\n\t\t\t\t<p>' + this.model.setupDetails.address + ', ' + this.model.setupDetails.city + ', \n\t\t\t\t   ' + this.model.setupDetails.state + ', ' + this.model.setupDetails.zip + '</p>\n\t\t\t'
				});

				this.marker.addListener('click', function () {
					branchInfoPopup.open({
						anchor: _this21.marker,
						map: map
					});
				});
			}
		}
	}, {
		key: 'branchLocation',
		value: function branchLocation() {
			var _this22 = this;

			var branchLocation = this.model.setupDetails,
			    mapElement = document.getElementById('map'),
			    locationLatitude = document.getElementById("lat").value,
			    locationLongitude = document.getElementById("lng").value;

			var map = new google.maps.Map(mapElement, {
				zoom: 16,
				center: new google.maps.LatLng(locationLatitude, locationLongitude),
				mapTypeId: google.maps.MapTypeId.ROADMAP
			});

			var branchInfoPopup = new google.maps.InfoWindow({
				content: '\n\t\t\t\t<h6>Branch Address</h6>\n\t\t\t\t<p>' + this.model.setupDetails.address + ', ' + this.model.setupDetails.city + ', \n\t\t\t\t   ' + this.model.setupDetails.state + ', ' + this.model.setupDetails.zip + '</p>\n\t\t\t'
			});

			new google.maps.Marker({
				position: new google.maps.LatLng(locationLatitude, locationLongitude),
				map: map
			});

			this.marker = new google.maps.Marker({
				position: new google.maps.LatLng(branchLocation.gpsLat, branchLocation.gpsLong),
				map: map,
				label: {
					text: 'B',
					color: 'white',
					fontWeight: 'bold'
				}
			});

			this.marker.addListener('click', function () {
				branchInfoPopup.open({
					anchor: _this22.marker,
					map: map
				});
			});
		}
	}, {
		key: 'loadConfigs',
		value: function loadConfigs() {
			var _this23 = this;

			this.Configs.getConfigs().then(function (data) {
				_this23.googleMapConfig = data.googleMap;
				_this23.maintainDriveDistance = data.maintainDriveDistance;
				_this23.apiKey = '//maps.google.com/maps/api/js?key=' + _this23.googleMapConfig.key + '&libraries=places';
				setTimeout(function () {
					_this23.render = true;
				}, 100);
				setTimeout(function () {
					_this23.render = true;
					if (_this23.maintainDriveDistance) _this23.branchLocation();
				}, 1000);
				return data;
			}).then(function (data) {
				_this23.companyMapping(data.otcCompanyList);
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'sameOperationTime',
		value: function sameOperationTime() {
			var _this24 = this;

			this.contractDays = [];
			this.operationDays.forEach(function (data) {
				_this24.contractDays[data.value] = true;
			});

			if (this.model.isSameOperationTime) {
				for (var day in this.contractDays) {
					if (this.contractDays[day]) {
						this.model[this.openTime + day] = '';
						this.model[this.closeTime + day] = '';
					}
				}
			}
		}
	}, {
		key: 'updateTime',
		value: function updateTime(selectedDay) {
			if (this.model.isSameOperationTime) {
				if (this.contractDays[selectedDay]) {
					for (var day in this.contractDays) {
						if (this.contractDays[day]) {
							this.model[this.openTime + day] = this.model[this.openTime + selectedDay];
							this.model[this.closeTime + day] = this.model[this.closeTime + selectedDay];
						}
					}
				}
			}
		}
	}, {
		key: 'companyMapping',
		value: function companyMapping(data) {
			this.OTCCompanyNameList = this.CommonLayoutService.OTCCompanyMapping(data);
		}
	}, {
		key: 'getSetupDetails',
		value: function getSetupDetails() {
			var _this25 = this;

			if (!this.model.defaultBranch) {
				return this.model.setupDetails = "";
			}
			this.SetupService.get(this.model.defaultBranch).then(function (data) {
				_this25.model.setupDetails = data;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'autoDetectGeoCoordinates',
		value: function autoDetectGeoCoordinates() {
			this.isAutoDetectOnFormSubmit = false;
			this.autoDetect();
		}
	}, {
		key: 'showPassword',
		value: function showPassword(stat, type) {
			this.passWdIcon[stat][type] = !this.passWdIcon[stat][type];
		}
	}, {
		key: 'resetOTCCompany',
		value: function resetOTCCompany() {
			if (this.model.lockType === 'static') this.model.OTCCompanyName = null;
			if (this.model.secondaryLockType === 'static') this.model.secondaryLockOTCCompanyName = null;
		}
	}, {
		key: 'fundingSourceSearchObj',
		value: function fundingSourceSearchObj(searchKey) {
			searchKey = searchKey || '';
			var selectedBranch = Array.isArray(this.model.branch) ? this.model.branch.map(function (branch) {
				return branch.branchId;
			}) : this.model.currentBranch.split();

			var obj = {
				queryJSON: {
					rules: [{
						field: "branchId",
						condition: "=",
						data: this.model.defaultBranch ? this.model.defaultBranch : selectedBranch
					}, {
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "sourceName",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};
			return obj.queryJSON.rules.length ? obj : null;
		}
	}, {
		key: 'getAllFundingSource',
		value: function getAllFundingSource(searchKey, offset) {
			var _this26 = this;

			this.model.fundingSourceObj.loading = true;
			var searchObj = this.fundingSourceSearchObj(searchKey);

			this.BranchFundingSourceService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this26.model.fundingSourceObj.totalRecords = data.total;
					_this26.model.fundingSourceObj.results = _this26.fundingSourceDataMap(data.results);
				} else {
					var fundingSource = _this26.fundingSourceDataMap(data.results);
					_this26.model.fundingSourceObj.results = (_this26.model.fundingSourceObj.results || []).concat(fundingSource);
				}
			}).catch(function (err) {
				_this26.Modal.errorModal(err.data.message);
			}).finally(function () {
				_this26.model.fundingSourceObj.loading = false;
			});
		}
	}, {
		key: 'fundingSourceDataMap',
		value: function fundingSourceDataMap(list) {
			return list.map(function (bfs) {
				return {
					Key: bfs.id + ' | ' + bfs.sourceName,
					Value: bfs.id,
					Obj: bfs
				};
			});
		}
	}, {
		key: 'orderProfileSearchObj',
		value: function orderProfileSearchObj(searchKey) {
			if (!this.model.fundingSourceObj.selectedFundingSource) return;
			searchKey = searchKey || '';
			var obj = {
				queryJSON: {
					rules: [{
						field: "branchFundingSourceId",
						condition: "=",
						data: this.model.fundingSourceObj.selectedFundingSource.Value
					}, {
						group: {
							rules: [{
								field: "name",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "loadInterval",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};
			return obj.queryJSON.rules.length ? obj : null;
		}
	}, {
		key: 'getOrderProfile',
		value: function getOrderProfile(searchKey, offset) {
			var _this27 = this;

			this.model.orderProfileObj.loading = true;
			var searchObj = this.orderProfileSearchObj(searchKey);

			this.BranchFundingSourceOrderProfileService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this27.model.orderProfileObj.totalRecords = data.total;
					_this27.model.orderProfileObj.results = _this27.orderProfileDataMap(data.results);
				} else {
					var fundingSource = _this27.orderProfileDataMap(data.results);
					_this27.model.orderProfileObj.results = (_this27.model.orderProfileObj.results || []).concat(fundingSource);
				}
			}).catch(function (err) {
				_this27.Modal.errorModal(err.data.message);
			}).finally(function () {
				_this27.model.orderProfileObj.loading = false;
			});
		}
	}, {
		key: 'orderProfileDataMap',
		value: function orderProfileDataMap(list) {
			return list.map(function (op) {
				return {
					Key: op.name + ' | ' + op.loadInterval,
					Value: op.id
				};
			});
		}
	}, {
		key: 'resetDataOnBranchChange',
		value: function resetDataOnBranchChange() {
			if (this.model.enableOrderProfile) {
				this.model.fundingSourceObj.selectedFundingSource = null;
				this.model.orderProfileObj.selectedOrderProfile = null;
			}
			this.model.bankSourceId = null;
		}
	}, {
		key: 'createLocationScheduled',
		value: function createLocationScheduled() {
			if (this.model.scheduledLocations.length <= 0) this.routeList('', 0);

			this.minVaultDate = {
				minDate: this.model.setupDetails.currentVaultDate
			};
			this.model.scheduledLocations.push({
				vaultDate: null,
				routeId: null,
				sequence: 99,
				status: 'Create',
				scheduleLocationId: null
			});
		}
	}, {
		key: 'routeList',
		value: function routeList(searchKey, offset) {
			var _this28 = this;

			searchKey = searchKey || '';

			var selectedBranch = this.model.branch.map(function (branch) {
				return branch.branchId;
			});
			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: 'IN',
						data: selectedBranch
					}, {
						field: 'holdRoute',
						condition: '=',
						data: false
					}, {
						field: 'active',
						condition: '=',
						data: true
					}, {
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'name',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};

			this.model.routeListObj.loading = true;
			return this.RouteService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this28.model.routeListObj.totalRecords = data.total;
					_this28.model.routeListObj.results = _this28.mapData(data.results);
				} else {
					var routes = _this28.mapData(data.results);
					_this28.model.routeListObj.results = _this28.model.routeListObj.results.concat(routes);
				}
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					Modal.errorModal(err.data.message);
				}
			}).finally(function () {
				_this28.model.routeListObj.loading = false;
			});
		}
	}, {
		key: 'mapData',
		value: function mapData(routes) {
			return routes.map(function (route) {
				return {
					Key: route.name,
					Value: route.id
				};
			});
		}
	}, {
		key: 'deleteScheduledLocation',
		value: function deleteScheduledLocation(index) {
			this.model.scheduledLocations.splice(index, 1);
			this.validateScheduledLocation();
		}
	}, {
		key: 'validateScheduledLocation',
		value: function validateScheduledLocation() {
			var _this29 = this;

			this.model.scheduledLocations = _lodash2.default.map(this.model.scheduledLocations, function (obj, index) {
				obj.isDuplicate = false;
				var match = _lodash2.default.find(_this29.model.scheduledLocations, function (compairObject, compairObjIndex) {
					if (index > compairObjIndex) return new Date(compairObject.vaultDate).getDate() == new Date(obj.vaultDate).getDate();
				});
				if (match) {
					obj.isDuplicate = true;
					return obj;
				} else {
					return obj;
				}
			});
			var isValid = this.model.scheduledLocations.map(function (obj) {
				if (obj.isDuplicate) return true;
			});
			this.isValid = isValid.indexOf(true) >= 0 ? false : true;
		}
	}, {
		key: 'resetText',
		value: function resetText() {
			this.model._state = null;
			this.model.country = null;
		}
	}, {
		key: 'parseMakeValues',
		value: function parseMakeValues(makeValue) {
			if (Array.isArray(makeValue)) {
				return makeValue.map(function (item) {
					if (!item) return null;
					if (typeof item === 'string') {
						var _vendorName = item.trim();
						return _vendorName ? { atmMakeId: null, vendorName: _vendorName } : null;
					}
					var vendorName = (item.vendorName || item.Value || item.value || item.Key || item.label || '').trim();
					var atmMakeId = item.atmMakeId || item.id || item.atmMake && item.atmMake.id || null;
					return vendorName ? { atmMakeId: atmMakeId, vendorName: vendorName } : null;
				}).filter(Boolean);
			}

			if (!makeValue) return [];

			return String(makeValue).split(',').map(function (item) {
				return item.trim();
			}).filter(Boolean).map(function (vendorName) {
				return { atmMakeId: null, vendorName: vendorName };
			});
		}
	}, {
		key: 'serializeMakeValues',
		value: function serializeMakeValues(makeValue) {
			var values = this.parseMakeValues(makeValue);
			return values.length ? values.map(function (item) {
				return item.vendorName;
			}).join(', ') : null;
		}
	}, {
		key: 'buildAtmMakeOptions',
		value: function buildAtmMakeOptions(results, selectedMakes) {
			var selectedValues = this.parseMakeValues(selectedMakes);
			var selectedById = selectedValues.map(function (item) {
				return item.atmMakeId;
			}).filter(Boolean);
			var selectedByName = selectedValues.map(function (item) {
				return item.vendorName;
			}).filter(Boolean);
			var options = (results || []).filter(function (item) {
				return item.active;
			}).map(function (item) {
				return {
					Key: item.vendorName,
					Value: item.vendorName,
					id: item.id,
					atmMakeId: item.id,
					vendorName: item.vendorName,
					ticked: selectedById.includes(item.id) || selectedByName.includes(item.vendorName)
				};
			});

			selectedValues.forEach(function (selectedItem) {
				if (options.findIndex(function (item) {
					return item.atmMakeId === selectedItem.atmMakeId || item.Value === selectedItem.vendorName;
				}) === -1) {
					options.push({
						Key: selectedItem.vendorName,
						Value: selectedItem.vendorName,
						id: selectedItem.atmMakeId || selectedItem.vendorName,
						atmMakeId: selectedItem.atmMakeId,
						vendorName: selectedItem.vendorName,
						ticked: true
					});
				}
			});

			return options;
		}
	}, {
		key: 'loadAtmMakes',
		value: function loadAtmMakes() {
			var _this30 = this;

			var selectedMakes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.model.make;

			return this.AtmMakesService.all('', 0, 1000, true).then(function (_ref5) {
				var results = _ref5.results;

				_this30.atmMakesList = _this30.buildAtmMakeOptions(results, selectedMakes);
				_this30.model.make = _this30.parseMakeValues(selectedMakes);
			}).catch(function (err) {
				console.log(err);
				_this30.atmMakesList = [];
				_this30.model.make = [];
			});
		}
	}, {
		key: 'formatAddress',
		value: function formatAddress(data) {
			var locationAddress = '';
			if (data.address) locationAddress = locationAddress.concat(data.address, ', ');
			if (data.city) locationAddress = locationAddress.concat(data.city, ', ');
			if (data.state) locationAddress = locationAddress.concat(data.state, ', ');
			if (data.zip) locationAddress = locationAddress.concat(data.zip);
			return locationAddress;
		}
	}, {
		key: 'filterStopProcess',
		value: function filterStopProcess() {
			if (this.model.stopProcess !== 'L') this.model.closeEndOfStop = false;
			if (!this.model._type) return;

			var typeMap = {
				ATM: ['L', 'A'],
				ON_CALL: ['D', 'B'],
				REGULAR: ['D'],
				NO_SHIP_NO_GO: ['D'],
				BANK: ['D'],
				DELIVERY: ['D'],
				INTERNAL: ['D']
			};

			var allowed = typeMap[this.model._type];
			var list = this.CommonLayoutService.stopProcessList();
			this.stopProcessList = allowed ? list.filter(function (_ref6) {
				var value = _ref6.value;
				return allowed.includes(value);
			}) : list;
			if (allowed && !allowed.includes(this.model.stopProcess)) {
				this.model.stopProcess = null;
			}
		}
	}, {
		key: 'createLocationRecurring',
		value: function createLocationRecurring() {
			if (this.model.recurringStops.length <= 0) this.routeList('', 0);

			this.model.recurringStops.push({
				description: null,
				route: null,
				sequence: 99,
				status: 'Create',
				anchorDate: null,
				effectiveTillDate: null,
				interval: null,
				frequency: 99,
				minEndDate: {}
			});
		}
	}, {
		key: 'deleteRecurringLocation',
		value: function deleteRecurringLocation(index) {
			this.model.recurringStops.splice(index, 1);
			this.validateRecurringLocation();
		}
	}, {
		key: 'validateRecurringLocation',
		value: function validateRecurringLocation() {
			var _this31 = this;

			this.model.recurringStops = _lodash2.default.map(this.model.recurringStops, function (obj, index) {
				obj.isDuplicate = false;
				var match = _lodash2.default.find(_this31.model.recurringStops, function (compairObject, compairObjIndex) {
					if (index > compairObjIndex) {
						return new Date(compairObject.anchorDate).getDate() == new Date(obj.anchorDate).getDate() && (compairObject.route && obj.route ? compairObject.route.Value == obj.route.Value : true) && compairObject.interval == obj.interval;
					}
				});
				if (match) {
					obj.isDuplicate = true;
					return obj;
				} else {
					return obj;
				}
			});
			var isValid = this.model.recurringStops.map(function (obj) {
				if (obj.isDuplicate) return true;
			});
			this.isValidRecurringStops = isValid.indexOf(true) >= 0 ? false : true;
		}
	}, {
		key: 'validateReccuringEndDate',
		value: function validateReccuringEndDate(obj) {
			obj.minEndDate = {
				minDate: moment(obj.anchorDate)
			};
			if (obj.effectiveTillDate && obj.anchorDate > obj.effectiveTillDate) {
				obj.effectiveTillDate = moment(obj.anchorDate);
			}
		}
	}, {
		key: 'disableDays',
		value: function disableDays(currentDate, mode, enableDay) {
			if (enableDay.value === "Hol") return false;
			return mode === 'day' && currentDate.getDay() !== this.dayMap[enableDay.value];
		}
	}, {
		key: 'recheckMonthlyOccurences',
		value: function recheckMonthlyOccurences(anchorDate, day, index) {
			if (!anchorDate) return;
			var selectedDate = new Date(anchorDate);
			var month = selectedDate.getMonth() + 1;
			var year = selectedDate.getFullYear();
			var occurrences = this.countOccurrencesInMonth(year, month, this.dayMap[day.value]);

			switch (occurrences) {
				case 2:
					this.combinedRoutes[index].combinedRouteIntervals = [].concat((0, _toConsumableArray3.default)(this.combinedRouteIntervals)).slice(0, -3);
					break;
				case 3:
					this.combinedRoutes[index].combinedRouteIntervals = [].concat((0, _toConsumableArray3.default)(this.combinedRouteIntervals)).slice(0, -2);
					break;
				case 4:
					this.combinedRoutes[index].combinedRouteIntervals = [].concat((0, _toConsumableArray3.default)(this.combinedRouteIntervals)).slice(0, -1);
					break;
				default:
					this.combinedRoutes[index].combinedRouteIntervals = [].concat((0, _toConsumableArray3.default)(this.combinedRouteIntervals));
					break;
			}
			if (this.combinedRoutes[index].interval && this.combinedRoutes[index].interval.interval === "MONTHOC" && this.combinedRoutes[index].interval.frequency > occurrences) {
				this.combinedRoutes[index].interval = null;
			}
		}
	}, {
		key: 'countOccurrencesInMonth',
		value: function countOccurrencesInMonth(year, month, targetDay) {
			var count = 0;
			var startDate = new Date(year, month - 1, 1);
			var endDate = new Date(year, month, 0);

			for (var currentDate = startDate; currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
				if (currentDate.getDay() === targetDay) {
					count++;
				}
			}

			return count;
		}
	}, {
		key: 'resetCombinedRoutes',
		value: function resetCombinedRoutes() {
			this.createCombinedRoutes();
		}
	}, {
		key: 'denominationsSearchObj',
		value: function denominationsSearchObj(searchKey) {
			searchKey = searchKey || '';

			var obj = {
				queryJSON: {
					rules: [{
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "name",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}, {
						field: "coinFlag",
						condition: "=",
						data: 0
					}],
					operator: "AND"
				}
			};
			return obj.queryJSON.rules.length ? obj : null;
		}
	}, {
		key: 'getAllDenominations',
		value: function getAllDenominations(searchKey, offset) {
			var _this32 = this;

			if (!this.model.bankSourceId) return;

			this.model.denominationSourceObj.loading = true;
			// const searchObj = this.denominationsSearchObj(searchKey);

			return this.OrderViewService.getFundingSourceDenominationUnpack(this.model.bankSourceId.Value).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this32.model.denominationSourceObj.totalRecords = data.results.length;
					_this32.model.denominationSourceObj.results = _this32.denominationsDataMap(data.results);
				} else {
					var denominations = _this32.denominationsDataMap(data.results);
					_this32.model.denominationSourceObj.results = _this32.model.denominations.concat(denominations);
				}
				_this32.getFilteredDenominations();
			}).catch(function (err) {
				_this32.Modal.errorModal(err.data.message);
			}).finally(function () {
				_this32.model.denominationSourceObj.loading = false;
			});
		}
	}, {
		key: 'getAllLocationSlotDenominations',
		value: function getAllLocationSlotDenominations(searchKey, offset) {
			var _this33 = this;

			return this.DenominationService.all(searchKey, offset, 1000).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this33.model.locationSlotDenominations.totalRecords = data.results.length;
					_this33.model.locationSlotDenominations.results = _this33.denominationsDataMap(data.results);
				} else {
					var denominations = _this33.denominationsDataMap(data.results);
					_this33.model.locationSlotDenominations.results = _this33.model.locationSlotDenominations.concat(denominations);
				}
			}).catch(function (err) {
				_this33.Modal.errorModal(err.data.message);
				_this33.model.locationSlotDenominations.results = [];
			});
		}
	}, {
		key: 'getFilteredDenominations',
		value: function getFilteredDenominations() {
			var _this34 = this;

			this.model.selectedDenomination = [];
			this.locationRecurringLoad = [];
			this.filteredDenominations = {
				results: [],
				totalRecords: 0
			};

			if (this.model._type === 'ATM') {
				this.filteredDenominations.results = this.model.denominationSourceObj.results.filter(function (denom) {
					if (!denom.coinFlag) {
						return true;
					}
					if (denom.coinFlag && _this34.model.coinPermitted && denom.multiDenomPackable && denom.coinPackaging && ['INDIVIDUAL', 'ROLLED'].includes(denom.coinPackaging)) {
						return true;
					}
					return false;
				});
				this.filteredDenominations.totalRecords = this.filteredDenominations.results.length;
			} else {
				this.filteredDenominations.results = this.model.denominationSourceObj.results;
				this.filteredDenominations.totalRecords = this.filteredDenominations.results.length;
			}
		}
	}, {
		key: 'denominationsDataMap',
		value: function denominationsDataMap(list) {
			return list.map(function (denom) {
				return {
					id: denom.id,
					Key: denom.id + ' | ' + denom.name,
					Value: denom.id,
					strapCount: denom.strapCount,
					faceValue: denom.faceValue,
					coinFlag: denom.coinFlag,
					shiptypeId: denom.shiptypeId,
					multiDenomPackable: denom.multiDenomPackable,
					coinPackaging: denom.coinPackaging
				};
			});
		}
	}, {
		key: 'createLocationRecurringLoad',
		value: function createLocationRecurringLoad() {
			var _this35 = this;

			if (['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO'].indexOf(this.model._type) === -1) {
				this.locationRecurringLoad = [];
				return;
			}

			setTimeout(function () {
				_this35.days.forEach(function (day) {
					_this35.locationRecurringLoad.push({
						day: day,
						denominations: _this35.model.selectedDenomination,
						recurringLoad: {}
					});
				});

				var uniqueDayMap = new _map3.default();

				for (var i = 0; i < _this35.locationRecurringLoad.length; i++) {
					var item = _this35.locationRecurringLoad[i];
					var dayValue = item.day.value;

					if (!uniqueDayMap.has(dayValue)) {
						uniqueDayMap.set(dayValue, (0, _extends3.default)({}, item, { denominations: [].concat((0, _toConsumableArray3.default)(item.denominations)) }));
					} else {
						(function () {
							var _existingItem$denomin;

							var existingItem = uniqueDayMap.get(dayValue);
							var existingDenominationIds = new _set2.default(existingItem.denominations.map(function (denom) {
								return denom.id;
							}));
							var uniqueDenominations = item.denominations.filter(function (denom) {
								return !existingDenominationIds.has(denom.id);
							});
							(_existingItem$denomin = existingItem.denominations).push.apply(_existingItem$denomin, (0, _toConsumableArray3.default)(uniqueDenominations));

							if ((0, _keys2.default)(existingItem.recurringLoad).length === 0 && (0, _keys2.default)(item.recurringLoad).length > 0) {
								existingItem.recurringLoad = item.recurringLoad;
							}
						})();
					}
				}

				_this35.locationRecurringLoad = (0, _from2.default)(uniqueDayMap.values());

				_this35.locationRecurringLoad.forEach(function (item) {
					var _item$denominations;

					// Filter out denominations
					item.denominations = item.denominations.filter(function (denom) {
						denom && denom.denom ? denom.denom.Value : null;
					});
					var newDenomination = _this35.model.selectedDenomination.filter(function (denom) {
						return denom.isNew && denom.denom;
					}); //add new denomination
					if (newDenomination.length > 0) (_item$denominations = item.denominations).push.apply(_item$denominations, (0, _toConsumableArray3.default)(newDenomination));

					var validDenominationIds = new _set2.default(item.denominations.map(function (denom) {
						return denom.denom ? denom.denom.Value : null;
					}));
					(0, _keys2.default)(item.recurringLoad).forEach(function (key) {
						if (!validDenominationIds.has(key)) delete item.recurringLoad[key];
					});
				});

				_this35.validateRouteAssignment();
				_this35.$scope.$apply();
			}, 100);
		}
	}, {
		key: 'checkDenomKeyExists',
		value: function checkDenomKeyExists() {
			var isValid = this.model.selectedDenomination.map(function (d) {
				return !d.denom || 'isEmpty';
			}).indexOf('isEmpty') !== -1;
			return isValid;
		}
	}, {
		key: 'checkForStrapCount',
		value: function checkForStrapCount() {
			for (var i = 0; i < this.locationRecurringLoad.length; ++i) {
				for (var j = 0; j < this.locationRecurringLoad[i].denominations.length; ++j) {
					var denomination = this.locationRecurringLoad[i].denominations[j];
					var recurringLoad = this.locationRecurringLoad[i]['recurringLoad'];
					if (denomination.denom && denomination.denom.strapCount && recurringLoad && recurringLoad[denomination.denom.Value] && !denomination.denom.coinFlag) {
						var loadAmount = recurringLoad[denomination.denom.Value].amount;
						var faceValue = denomination.denom.faceValue;

						if (loadAmount !== undefined && loadAmount !== null && loadAmount !== '' && loadAmount / faceValue % denomination.denom.strapCount !== 0) {
							recurringLoad[denomination.denom.id].isValid = false;
						} else {
							recurringLoad[denomination.denom.id].isValid = true;
						}
					} else if (recurringLoad && recurringLoad[denomination.denom.Value] && denomination.denom.coinFlag) {
						recurringLoad[denomination.denom.id].isValid = true;
					}
				}
			}
			this.isValidRecurringLoad = this.checkRecurringLoadValidity(this.locationRecurringLoad);
		}
	}, {
		key: 'checkForMaxLoadFaceValueDivisibility',
		value: function checkForMaxLoadFaceValueDivisibility() {
			this.isValidMaxLoad = true;
			if (!this.model.selectedDenomination || !this.model.selectedDenomination.length) {
				return true;
			}

			function isValidAmount(amount, faceValue) {
				if (!isFinite(amount) || !isFinite(faceValue) || faceValue <= 0 || amount <= 0) {
					return false;
				}
				var quotient = amount / faceValue;
				var epsilon = 1e-9;
				return Math.abs(quotient - Math.round(quotient)) < epsilon;
			}

			this.model.selectedDenomination.forEach(function (denomObj) {
				denomObj.isMaxLoadValid = true;

				var denom = denomObj.denom;
				var faceValueRaw = denom && denom.faceValue;
				var maxLoadRaw = denomObj.maxLoad;

				// Don't block until user selects denomination and enters maxLoad
				if (!denom || faceValueRaw === undefined || faceValueRaw === null || maxLoadRaw === undefined || maxLoadRaw === null || maxLoadRaw === '') {
					return;
				}

				var faceValue = Number(String(faceValueRaw).replace(/,/g, ''));
				var maxLoad = Number(String(maxLoadRaw).replace(/,/g, ''));

				if (!isFinite(faceValue) || faceValue === 0 || !isFinite(maxLoad)) {
					denomObj.isMaxLoadValid = false;
					return;
				}

				denomObj.isMaxLoadValid = isValidAmount(maxLoad, faceValue);
			});

			this.isValidMaxLoad = this.model.selectedDenomination.every(function (denomObj) {
				if (!denomObj.denom) return true;
				return denomObj.isMaxLoadValid !== false;
			});

			return this.isValidMaxLoad;
		}
	}, {
		key: 'isValidTargetStopTime',
		value: function isValidTargetStopTime() {
			if (!this.model.targetStopTime) return true;
			return this.model.targetStopTime.getHours() > 0 || this.model.targetStopTime.getMinutes() > 0;
		}
	}, {
		key: 'validateRouteAssignment',
		value: function validateRouteAssignment() {
			var _this36 = this;

			this.totalRouteAssignment = 0;

			var routeMap = new _map3.default();
			this.combinedRoutes.forEach(function (route) {
				if (route.route && route.sequence && route.anchorDate && route.interval) {
					routeMap.set(route.day.value, route);
				}
			});

			this.locationRecurringLoad.forEach(function (location) {
				var route = routeMap.get(location.day.value);

				if (route) {
					_this36.totalRouteAssignment++;
					location.locationScheduleRecurringDay = route.day.value;
					location.hasLocationScheduleRecurring = true;
				} else {
					location.hasLocationScheduleRecurring = false;
					location.recurringLoad = {};
				}
			});
		}
	}, {
		key: 'checkRecurringLoadValidity',
		value: function checkRecurringLoadValidity(data) {
			var isValidFlag = true;
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = (0, _getIterator3.default)(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var item = _step2.value;

					if (item.recurringLoad) {
						for (var key in item.recurringLoad) {
							var isValid = item.recurringLoad[key].isValid;
							if (!isValid) return false;
							if (isValid) isValidFlag = true;
						}
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			return isValidFlag;
		}
	}, {
		key: 'convertStr',
		value: function convertStr(str) {
			if (!str) return;
			return Number(str.replace('%', ''));
		}
	}, {
		key: 'ngPercentage',
		value: function ngPercentage() {
			if (this.model.aecPercentChangeValue && !String(this.model.aecPercentChangeValue).endsWith('%')) {
				return this.model.aecPercentChangeValue = this.model.aecPercentChangeValue + '%';
			}
		}
	}, {
		key: 'removePercentageSign',
		value: function removePercentageSign() {
			if (this.model.aecPercentChangeValue && String(this.model.aecPercentChangeValue).endsWith('%')) {
				return this.model.aecPercentChangeValue = String(this.model.aecPercentChangeValue).replace('%', '');
			}
		}
	}, {
		key: 'createLocationDenomination',
		value: function createLocationDenomination() {
			// if(this.model.selectedDenomination.length <= 0) this.getAllDenominations('', 0);
			// this.model.selectedDenomination.push({
			// 	denom: null,
			// 	maxLoad: this.model._type === 'ATM' ? null : 0,
			// 	minResidualThreshold: this.model._type === 'ATM' ? null : 0,
			// 	maxResidualThreshold: this.model._type === 'ATM' ? null : 0,
			// 	minResidualThresholdPercentage: this.model._type === 'ATM' ? null : '0%',
			// 	maxResidualThresholdPercentage: this.model._type === 'ATM' ? null : '0%',
			// 	status: 'Create',
			// 	isNew: true,
			// 	disableFields: this.model._type === 'ATM' ? false : true
			// });
			this.model.selectedDenomination.push({
				denom: null,
				maxLoad: null,
				minResidualThreshold: null,
				maxResidualThreshold: null,
				minResidualThresholdPercentage: null,
				maxResidualThresholdPercentage: null,
				status: 'Create',
				isNew: true,
				disableFields: false
			});
		}
	}, {
		key: 'deleteDenominationSelected',
		value: function deleteDenominationSelected(index) {
			this.model.selectedDenomination.splice(index, 1);
			this.validateDenominationSelected();
			this.createLocationRecurringLoad();
		}
	}, {
		key: 'createLocationSlots',
		value: function createLocationSlots() {
			if (!this.model.locationSlotDenominations.results) {
				this.model.locationSlotDenominations.results = [];
			}
			var mxdDenominations = this.model.locationSlotDenominations.results.filter(function (d) {
				return d.shiptypeId === 'MXD';
			});
			this.locationSlots.push({
				denominationId: mxdDenominations[0] || null,
				slotTrackingId: ''
			});
			this.validateLocationSlotsDuplicate();
		}
	}, {
		key: 'deleteLocationSlotsSelected',
		value: function deleteLocationSlotsSelected(index) {
			this.locationSlots.splice(index, 1);
			this.validateLocationSlotsDuplicate();
		}
	}, {
		key: 'validateDenominationSelected',
		value: function validateDenominationSelected() {
			var _this37 = this;

			this.model.selectedDenomination = _lodash2.default.map(this.model.selectedDenomination, function (mainObj, mainIndex) {
				// if (mainObj.denom && (mainObj.denom.coinFlag || this.model._type !== 'ATM')) {
				// 	mainObj.maxLoad = 0;
				// 	mainObj.minResidualThreshold = 0;
				// 	mainObj.maxResidualThreshold = 0;
				// 	mainObj.disableFields = true;
				// }
				// else {
				// 	mainObj.disableFields = false;
				// }

				mainObj.isDuplicate = false;
				var match = _lodash2.default.find(_this37.model.selectedDenomination, function (compairObject, compairObjIndex) {
					if (mainIndex > compairObjIndex && compairObject.denom && mainObj.denom && compairObject.denom.Value && mainObj.denom.Value) {
						return compairObject.denom.Value === mainObj.denom.Value;
					}
				});
				if (match) {
					mainObj.isDuplicate = true;
					return mainObj;
				}
				return mainObj;
			});

			var isValid = this.model.selectedDenomination.map(function (obj, index) {
				if (obj.isDuplicate) return true;
			});
			this.isValidDenomination = isValid.indexOf(true) >= 0 ? false : true;
			this.validateLocationSlotsDuplicate();
			this.checkForMaxLoadFaceValueDivisibility();
		}
	}, {
		key: 'ngResidualPercentage',
		value: function ngResidualPercentage(index, type) {
			var item = this.model.selectedDenomination[index];
			if (type == 'min' && item.minResidualThresholdPercentage && !String(item.minResidualThresholdPercentage).endsWith('%')) {
				item.minResidualThreshold = item.minResidualThresholdPercentage / 100 + '%';
				return item.minResidualThresholdPercentage = item.minResidualThresholdPercentage + '%';
			} else if (type == 'max' && item.maxResidualThresholdPercentage && !String(item.maxResidualThresholdPercentage).endsWith('%')) {
				item.maxResidualThreshold = item.maxResidualThresholdPercentage / 100 + '%';
				return item.maxResidualThresholdPercentage = item.maxResidualThresholdPercentage + '%';
			}
		}
	}, {
		key: 'removeResidualPercentageSign',
		value: function removeResidualPercentageSign(index, type) {
			var item = this.model.selectedDenomination[index];
			if (type == 'min' && item.minResidualThresholdPercentage && item.minResidualThresholdPercentage.endsWith('%')) {
				item.minResidualThreshold = item.minResidualThreshold.replace('%', '');
				return item.minResidualThresholdPercentage = item.minResidualThresholdPercentage.replace('%', '');
			} else if (type == 'max' && item.maxResidualThresholdPercentage && item.maxResidualThresholdPercentage.endsWith('%')) {
				item.maxResidualThreshold = item.maxResidualThreshold.replace('%', '');
				return item.maxResidualThresholdPercentage = item.maxResidualThresholdPercentage.replace('%', '');
			}
		}
	}, {
		key: 'validateLocationSlotsDuplicate',
		value: function validateLocationSlotsDuplicate() {
			var _this38 = this;

			if (!this.locationSlots || this.locationSlots.length === 0) {
				this.duplicateLocationSlotError = false;
				return true;
			}
			this.locationSlots.forEach(function (slot) {
				return slot.isDuplicate = false;
			});
			var hasDuplicate = false;
			this.locationSlots.forEach(function (slot, index) {
				var denomId = slot.denominationId && (slot.denominationId.id || slot.denominationId.Value || slot.denominationId);
				var trackingId = (slot.slotTrackingId || '').trim().toLowerCase();
				var match = _this38.locationSlots.find(function (other, otherIdx) {
					if (index > otherIdx) {
						var otherDenomId = other.denominationId && (other.denominationId.id || other.denominationId.Value || other.denominationId);
						var otherTrackingId = (other.slotTrackingId || '').trim().toLowerCase();
						return denomId === otherDenomId && trackingId === otherTrackingId;
					}
					return false;
				});
				if (match) {
					slot.isDuplicate = true;
					hasDuplicate = true;
				}
			});
			this.duplicateLocationSlotError = hasDuplicate;
			return !hasDuplicate;
		}
	}, {
		key: 'onFlowThresholdBlur',
		value: function onFlowThresholdBlur() {
			if (this.model.balanceType === 'PERCENTAGE' && this.model.flowThreshold) {
				var val = parseFloat(this.model.flowThreshold.toString());
				if (!isNaN(val)) {
					this.model.flowThreshold = val + '%';
				}
			}
		}
	}, {
		key: 'onFlowThresholdFocus',
		value: function onFlowThresholdFocus() {
			if (this.model.balanceType === 'PERCENTAGE' && typeof this.model.flowThreshold === 'string') {
				this.model.flowThreshold = this.model.flowThreshold.replace('%', '');
			}
		}
	}, {
		key: 'resetFlowThreshold',
		value: function resetFlowThreshold() {
			this.model.flowThreshold = this.model.balanceType == 'PERCENTAGE' ? this.convertStr(0.2) / 100 : 0.2;
		}
	}, {
		key: 'hasValidEmails',
		value: function hasValidEmails(emailString) {
			var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (!emailString) return !isRequired;
			var emails = emailString.split(',').map(function (email) {
				return email.trim();
			});
			var uniqueEmails = new _set2.default();
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = (0, _getIterator3.default)(emails), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var email = _step3.value;

					if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
						return false;
					}
					if (uniqueEmails.has(email)) {
						return false;
					}
					uniqueEmails.add(email);
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			return true;
		}
	}, {
		key: 'loadPickupRequestTimes',
		value: function loadPickupRequestTimes() {
			var _this39 = this;

			return this.LocationService.getPickupRequestTimes().then(function (data) {
				if (data.status) {
					_this39.pickupRequestTimes = data.data;
				}
			}).catch(function (err) {
				console.log('Error loading pickup request times:', err);
			});
		}
	}, {
		key: 'onMarkerDragEnd',
		value: function onMarkerDragEnd($event) {
			this.model.latitude = $event.latLng.lat();
			this.model.longitude = $event.latLng.lng();
			if (this.model.latitude && this.model.longitude) {
				this.getAddressFromLatLng(this.model.latitude, this.model.longitude);
			}
			document.getElementById("lat").value = this.model.latitude;
			document.getElementById("lng").value = this.model.longitude;
		}
	}]);
	return LocationCreateController;
}(_locationBase2.default);

exports.default = LocationCreateController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locationEdit = __webpack_require__(1927);

var _locationEdit2 = _interopRequireDefault(_locationEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationEditModule = angular.module('locationedit', []).component('locationedit', _locationEdit2.default).name;

exports.default = locationEditModule;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locationEdit = __webpack_require__(2742);

var _locationEdit2 = _interopRequireDefault(_locationEdit);

var _locationEdit3 = __webpack_require__(1928);

var _locationEdit4 = _interopRequireDefault(_locationEdit3);

__webpack_require__(3022);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _locationEdit2.default,
  controller: _locationEdit4.default
};

exports.default = locationeditComponent;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _log = __webpack_require__(620);

var _log2 = _interopRequireDefault(_log);

var _map2 = __webpack_require__(76);

var _map3 = _interopRequireDefault(_map2);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(75);

var _from2 = _interopRequireDefault(_from);

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _locationBase = __webpack_require__(107);

var _locationBase2 = _interopRequireDefault(_locationBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationEditController = function (_LocationBaseControll) {
	LocationEditController.$inject = ["Auth", "$state", "User", "LocationService", "Modal", "$translate", "$stateParams", "BranchService", "CustomerService", "NgMap", "RouteService", "ContractService", "$q", "LocationDeliveryService", "ShiptypeService", "UserBranchService", "LocationBranchService", "$scope", "DateUtil", "Configs", "SetupService", "OrderViewService", "CommonLayoutService", "DenominationService", "BranchFundingSourceService", "BranchFundingSourceOrderProfileService", "StopSchedulingService", "CostCenterService", "AtmMakesService"];
	(0, _inherits3.default)(LocationEditController, _LocationBaseControll);

	/*@ngInject*/
	function LocationEditController(Auth, $state, User, LocationService, Modal, $translate, $stateParams, BranchService, CustomerService, NgMap, RouteService, ContractService, $q, LocationDeliveryService, ShiptypeService, UserBranchService, LocationBranchService, $scope, DateUtil, Configs, SetupService, OrderViewService, CommonLayoutService, DenominationService, BranchFundingSourceService, BranchFundingSourceOrderProfileService, StopSchedulingService, CostCenterService, AtmMakesService) {
		var _this$model;

		(0, _classCallCheck3.default)(this, LocationEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (LocationEditController.__proto__ || (0, _getPrototypeOf2.default)(LocationEditController)).call(this, Auth, $state, User, LocationService, Modal, $translate, $stateParams));

		_this.isDisabledDate = function (currentDate) {
			// if (this.model.seasonStart > this.model.seasonEnd) {
			// 	// this.model.seasonEnd = this.model.seasonStart;
			// 	this.today = moment.utc(currentDate).format();
			// 	this.dateRangeError = 'Start date should be greater than end date';
			// } else {
			// 	this.today = moment.utc().format();
			// 	delete this.dateRangeError;
			// }
			this.todayMinDate = {
				minDate: this.model.seasonStart,
				formatDayTitle: 'MMMM',
				maxMode: "day"
			};
		};

		_this.pageName = 'location';

		_this.isPMSuspended = function (val) {
			if (!val) return false;
			if (val && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' && val.isSuspended !== undefined) {
				return val.isSuspended;
			}
			var id = val && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' ? val.Value : val;
			var pm = (_this.pmSearchList || []).find(function (p) {
				return p.Value === id;
			});
			return pm && pm.isSuspended;
		};

		_this.rawId = '';
		_this.NgMap = NgMap;
		_this.ContractService = ContractService;
		_this.BranchService = BranchService;
		_this.CustomerService = CustomerService;
		_this.RouteService = RouteService;
		_this.LocationDeliveryService = LocationDeliveryService;
		_this.ShiptypeService = ShiptypeService;
		_this.UserBranchService = UserBranchService;
		_this.LocationBranchService = LocationBranchService;
		_this.SetupService = SetupService;
		_this.CommonLayoutService = CommonLayoutService;
		_this.BranchFundingSourceService = BranchFundingSourceService;
		_this.BranchFundingSourceOrderProfileService = BranchFundingSourceOrderProfileService;
		_this.DenominationService = DenominationService;
		_this.StopSchedulingService = StopSchedulingService;
		_this.CostCenterService = CostCenterService;
		_this.AtmMakesService = AtmMakesService;
		_this.OrderViewService = OrderViewService;
		_this.atmMakesList = [];
		_this.DateUtil = DateUtil;
		_this.Configs = Configs;
		_this.$scope = $scope;
		_this.$q = $q;
		_this.customer = [];
		_this.branch = [];
		_this.locations = [];
		_this.contracts = [];
		_this.contractDays = [];
		_this.costCenterList = [];
		_this.locationZoneList = [];
		_this.totalCostomers = 0;
		_this.totalContracts = 0;
		_this.locationSlots = [];
		_this.denominations = [];
		_this.showAddSlotForm = false;
		_this.pickupRequestTimes = [];
		_this.model = (_this$model = {
			location: 'LOC',
			status: true,
			customer: '',
			costCenter: '',
			selectedLocationZones: [],
			comments: null,
			defaultBranch: null,
			loggedInUser: User.getUser().id,
			branchId: User.getUser().branchId,
			_address: 'add',
			_city: 'city',
			_state: null,
			_zip: 'zip',
			refId: null,
			_poc: 'poc',
			pocPhone: 'phone',
			pocEmail: 'a@a.a',
			RNdeliveries: true,
			RNpickups: false,
			RNnoPickup: false,
			RNzeroPickup: false,
			deliverBagOutPiece: false,
			individualBagout: false,
			centralBank: false,
			selectedDenomination: [],
			locationBalanceActive: [],
			Mon: {
				routeId: '',
				stops: '',
				options: ''
			},
			Tue: {
				routeId: '',
				stops: '',
				options: ''
			},
			Wed: {
				routeId: '',
				stops: '',
				options: ''
			},
			Thu: {
				routeId: '',
				stops: '',
				options: ''
			},
			Fri: {
				routeId: '',
				stops: '',
				options: ''
			},
			Sat: {
				routeId: '',
				stops: '',
				options: ''
			},
			Sun: {
				routeId: '',
				stops: '',
				options: ''
			},
			Hol: {
				routeId: '',
				stops: '',
				options: ''
			},
			seasonStart: null,
			seasonEnd: null,
			startTime: null,
			endTime: null,
			_type: 'ATM',
			keyId: '',
			maxDepositAmount: 0,
			// deliveryBackoutTimes: true,
			roundedDeposits: false,
			codAllow: true,
			allowMulti: false,
			bulkTransfer: false
		}, (0, _defineProperty3.default)(_this$model, 'individualBagout', false), (0, _defineProperty3.default)(_this$model, 'deliveryLoc1', null), (0, _defineProperty3.default)(_this$model, 'deliveryLoc2', null), (0, _defineProperty3.default)(_this$model, 'deliveryLocCoin', null), (0, _defineProperty3.default)(_this$model, 'deliveryLocCod', null), (0, _defineProperty3.default)(_this$model, 'lastTransaction', true), (0, _defineProperty3.default)(_this$model, '_leave', true), (0, _defineProperty3.default)(_this$model, 'verifyToTruck', true), (0, _defineProperty3.default)(_this$model, 'verifyCoinToTruck', false), (0, _defineProperty3.default)(_this$model, 'maxCassettes', null), (0, _defineProperty3.default)(_this$model, 'atmCassette', false), (0, _defineProperty3.default)(_this$model, 'packCoinSeparately', false), (0, _defineProperty3.default)(_this$model, 'captureDenomStc', false), (0, _defineProperty3.default)(_this$model, 'TRdeliveries', true), (0, _defineProperty3.default)(_this$model, 'TRpickups', true), (0, _defineProperty3.default)(_this$model, 'latitude', 41.74), (0, _defineProperty3.default)(_this$model, 'longitude', -102.18), (0, _defineProperty3.default)(_this$model, 'sameForAll', false), (0, _defineProperty3.default)(_this$model, 'lockType', null), (0, _defineProperty3.default)(_this$model, 'openTimeSun', null), (0, _defineProperty3.default)(_this$model, 'closeTimeSun', null), (0, _defineProperty3.default)(_this$model, 'openTimeMon', null), (0, _defineProperty3.default)(_this$model, 'closeTimeMon', null), (0, _defineProperty3.default)(_this$model, 'openTimeTue', null), (0, _defineProperty3.default)(_this$model, 'closeTimeTue', null), (0, _defineProperty3.default)(_this$model, 'openTimeWed', null), (0, _defineProperty3.default)(_this$model, 'closeTimeWed', null), (0, _defineProperty3.default)(_this$model, 'openTimeThu', null), (0, _defineProperty3.default)(_this$model, 'closeTimeThu', null), (0, _defineProperty3.default)(_this$model, 'openTimeFri', null), (0, _defineProperty3.default)(_this$model, 'closeTimeFri', null), (0, _defineProperty3.default)(_this$model, 'openTimeSat', null), (0, _defineProperty3.default)(_this$model, 'closeTimeSat', null), (0, _defineProperty3.default)(_this$model, 'openTimeHoliday', null), (0, _defineProperty3.default)(_this$model, 'closeTimeHoliday', null), (0, _defineProperty3.default)(_this$model, 'isSameOperationTime', false), (0, _defineProperty3.default)(_this$model, 'ATMTransfer', false), (0, _defineProperty3.default)(_this$model, 'OTCGeoFence', false), (0, _defineProperty3.default)(_this$model, 'closeReq', false), (0, _defineProperty3.default)(_this$model, 'closeEndOfStop', false), (0, _defineProperty3.default)(_this$model, 'zoneRouting', false), (0, _defineProperty3.default)(_this$model, 'stopPriority', null), (0, _defineProperty3.default)(_this$model, 'model', null), (0, _defineProperty3.default)(_this$model, 'serialNumber', null), (0, _defineProperty3.default)(_this$model, 'secondaryLock', false), (0, _defineProperty3.default)(_this$model, 'secondaryLockId', null), (0, _defineProperty3.default)(_this$model, 'secondaryLockType', null), (0, _defineProperty3.default)(_this$model, 'secondaryLockOTCCompanyName', null), (0, _defineProperty3.default)(_this$model, 'secondaryLockCloseReq', false), (0, _defineProperty3.default)(_this$model, 'secondaryLockAutoOpen', false), (0, _defineProperty3.default)(_this$model, 'enableOrderProfile', false), (0, _defineProperty3.default)(_this$model, 'fundingSourceObj', {
			results: [],
			totalRecords: 0,
			loading: false,
			selectedFundingSource: null
		}), (0, _defineProperty3.default)(_this$model, 'orderProfileObj', {
			results: [],
			totalRecords: 0,
			loading: false,
			selectedOrderProfile: null
		}), (0, _defineProperty3.default)(_this$model, 'denominationSourceObj', {
			results: [],
			totalRecords: 0,
			loading: false,
			selectedDenomination: []
		}), (0, _defineProperty3.default)(_this$model, 'locationSlotDenominations', {
			results: [],
			totalRecords: 0
		}), (0, _defineProperty3.default)(_this$model, 'handleAtmLikeRegular', false), (0, _defineProperty3.default)(_this$model, 'handleAtmLikeRegularLocationType', ['ATM', 'LOCKER', 'DELIVERY', 'BANK', 'ON_CALL', "NO_SHIP_NO_GO"]), (0, _defineProperty3.default)(_this$model, 'idBatchImport', null), (0, _defineProperty3.default)(_this$model, 'idBagoutExport', null), (0, _defineProperty3.default)(_this$model, 'idBagoutDepositExport', null), (0, _defineProperty3.default)(_this$model, 'idOTCLock', null), (0, _defineProperty3.default)(_this$model, 'scheduledLocations', []), (0, _defineProperty3.default)(_this$model, 'deleteScheduledLocationIds', []), (0, _defineProperty3.default)(_this$model, 'routeListObj', {
			result: [],
			totalRecords: 0
		}), (0, _defineProperty3.default)(_this$model, 'NFCLock', false), (0, _defineProperty3.default)(_this$model, 'country', null), (0, _defineProperty3.default)(_this$model, 'NFCScan', false), (0, _defineProperty3.default)(_this$model, 'NFCTagId', null), (0, _defineProperty3.default)(_this$model, 'isNonUSLocation', false), (0, _defineProperty3.default)(_this$model, 'customerCostCenter', null), (0, _defineProperty3.default)(_this$model, 'recurringStops', []), (0, _defineProperty3.default)(_this$model, 'deletedRecurringStops', []), (0, _defineProperty3.default)(_this$model, 'make', []), (0, _defineProperty3.default)(_this$model, 'accountNumber', null), (0, _defineProperty3.default)(_this$model, 'machineOwner', null), (0, _defineProperty3.default)(_this$model, 'bankSourceId', null), (0, _defineProperty3.default)(_this$model, 'FLMProvider', null), (0, _defineProperty3.default)(_this$model, 'SLMProvider', null), (0, _defineProperty3.default)(_this$model, 'optional1', null), (0, _defineProperty3.default)(_this$model, 'optional2', null), (0, _defineProperty3.default)(_this$model, 'optional3', null), (0, _defineProperty3.default)(_this$model, 'bankWeek', null), (0, _defineProperty3.default)(_this$model, 'frequencyOptions', null), (0, _defineProperty3.default)(_this$model, 'dayOfWeekOptions', null), (0, _defineProperty3.default)(_this$model, 'contractExpirationDate', null), (0, _defineProperty3.default)(_this$model, 'forecastingStrategy', null), (0, _defineProperty3.default)(_this$model, 'liabilityThreshold', null), (0, _defineProperty3.default)(_this$model, 'securityThreshold', null), (0, _defineProperty3.default)(_this$model, 'atmEmptyAtCalculationMethod', null), (0, _defineProperty3.default)(_this$model, 'aecPercentChangeValue', null), (0, _defineProperty3.default)(_this$model, 'aecPercentChangePeriodA', null), (0, _defineProperty3.default)(_this$model, 'aecPercentChangePeriodB', null), (0, _defineProperty3.default)(_this$model, 'aecWeightedAvgWeightA', null), (0, _defineProperty3.default)(_this$model, 'aecWeightedAvgPeriodA', null), (0, _defineProperty3.default)(_this$model, 'aecWeightedAvgWeightB', null), (0, _defineProperty3.default)(_this$model, 'aecWeightedAvgPeriodB', null), (0, _defineProperty3.default)(_this$model, 'aecSinglePeriod', null), (0, _defineProperty3.default)(_this$model, 'addToSwapRatio', null), (0, _defineProperty3.default)(_this$model, 'deliveryCutOff', false), (0, _defineProperty3.default)(_this$model, 'deliveryCutOffTime', null), (0, _defineProperty3.default)(_this$model, 'lastRouteStop', false), (0, _defineProperty3.default)(_this$model, 'targetStopTime', null), (0, _defineProperty3.default)(_this$model, 'printDeliveryManifest', false), (0, _defineProperty3.default)(_this$model, 'balanceType', 'DENOMINATION'), (0, _defineProperty3.default)(_this$model, 'forecastingFlowDirection', 'EMPTY'), (0, _defineProperty3.default)(_this$model, 'flowThreshold', 0.2), (0, _defineProperty3.default)(_this$model, 'podReceipt', false), (0, _defineProperty3.default)(_this$model, 'locationSlots', []), (0, _defineProperty3.default)(_this$model, 'sendManifestOnDelivery', false), (0, _defineProperty3.default)(_this$model, 'manifestRecipientEmail', ''), (0, _defineProperty3.default)(_this$model, 'zeroAmountPickupRecipientEmail', ''), (0, _defineProperty3.default)(_this$model, 'pickupSLA', false), (0, _defineProperty3.default)(_this$model, 'pickupSLATime', null), (0, _defineProperty3.default)(_this$model, 'autoRerouteMissed', false), (0, _defineProperty3.default)(_this$model, 'packResidual', true), (0, _defineProperty3.default)(_this$model, 'coinPermitted', false), (0, _defineProperty3.default)(_this$model, 'bagoutEnabled', false), (0, _defineProperty3.default)(_this$model, 'isTransferHoldLocation', false), (0, _defineProperty3.default)(_this$model, 'singleBranch', null), (0, _defineProperty3.default)(_this$model, 'fallbackFillRate', 0), (0, _defineProperty3.default)(_this$model, 'preventativeMaintenanceId', null), _this$model);

		_this.days = [{
			label: _this.$translate.instant('location.mon'),
			value: 'Mon'
		}, {
			label: _this.$translate.instant('location.tues'),
			value: 'Tue'
		}, {
			label: _this.$translate.instant('location.wed'),
			value: 'Wed'
		}, {
			label: _this.$translate.instant('location.thurs'),
			value: 'Thu'
		}, {
			label: _this.$translate.instant('location.fri'),
			value: 'Fri'
		}, {
			label: _this.$translate.instant('location.sat'),
			value: 'Sat'
		}, {
			label: _this.$translate.instant('location.sun'),
			value: 'Sun'
		}, {
			label: _this.$translate.instant('location.hol'),
			value: 'Hol'
		}];

		// this.sameForAll = false
		_this.today = _moment2.default.utc().format(), _this.defBackoutTimes = false;
		_this._types = [{
			label: _this.$translate.instant('location_types.DELIVERY'),
			value: 'DELIVERY'
		}, {
			label: _this.$translate.instant('routeControl.ATM'),
			value: 'ATM'
		}, {
			label: _this.$translate.instant('routeControl.nsng'),
			value: 'NO_SHIP_NO_GO'
		}, {
			label: _this.$translate.instant('routeControl.regular'),
			value: 'REGULAR'
		}, {
			label: _this.$translate.instant('routeControl.bank'),
			value: 'BANK'
		}, {
			label: _this.$translate.instant('routeControl.on_call'),
			value: 'ON_CALL'
		}, {
			label: _this.$translate.instant('routeControl.internal'),
			value: 'INTERNAL'
		}, {
			label: _this.$translate.instant('location_types.LOCKER'),
			value: 'LOCKER'
		}, {
			label: _this.$translate.instant('routeControl.truck'),
			value: 'TRUCK'
		}, {
			label: _this.$translate.instant('routeControl.tanker'),
			value: 'TANKER'
		}, {
			label: _this.$translate.instant('routeControl.carrier'),
			value: 'CARRIER'
		}, {
			label: _this.$translate.instant('routeControl.window'),
			value: 'WINDOW'
		}, {
			label: _this.$translate.instant('location_types.VAULT'),
			value: 'VAULT'
		}];

		_this.day = {
			routeId: [],
			stops: [{
				label: 'Stop1',
				value: 'stop1'
			}, {
				label: 'Stop2',
				value: 'stop2'
			}],
			options: [{
				label: 'Weekly',
				value: 'Weekly'
			}, {
				label: 'Bi-Monthly',
				value: 'Bi_Monthly'
			}, {
				label: 'Monthly',
				value: 'monthly'
			}, {
				label: 'Seasonal',
				value: 'Seasonal'
			}]
		};

		_this.dateFormat = 'MM/dd';
		_this.lockTypes = CommonLayoutService.lockTypes();

		_this.addToSwapRatioOptions = [{
			label: 'Always Add',
			value: 'ALWAYS_ADD'
		}, {
			label: 'Always Swap',
			value: 'ALWAYS_SWAP'
		}, {
			label: '2 Adds Between Swap',
			value: '2_ADDS_BETWEEN_SWAP'
		}, {
			label: '3 Adds Between Swap',
			value: '3_ADDS_BETWEEN_SWAP'
		}, {
			label: '4 Adds Between Swap',
			value: '4_ADDS_BETWEEN_SWAP'
		}, {
			label: '5 Adds Between Swap',
			value: '5_ADDS_BETWEEN_SWAP'
		}, {
			label: '6 Adds Between Swap',
			value: '6_ADDS_BETWEEN_SWAP'
		}];

		// this.OTCCompanyNameList = [
		// 	{
		// 		label: 'First Premier',
		// 		value: 'FirstPremier'
		// 	},
		// 	{
		// 		label: 'VTS',
		// 		value: 'VTS'
		// 	},
		// 	{
		// 		label: 'DevCo',
		// 		value: 'DevCo'
		// 	},
		// 	{
		// 		label: 'Witzco',
		// 		value: 'witzco'
		// 	}
		// ]

		_this.states = [{
			label: 'Alabama', value: 'AL'
		}, {
			label: 'Alaska', value: 'AK'
		}, {
			label: 'American Samoa', value: 'AS'
		}, {
			label: 'Arizona', value: 'AZ'
		}, {
			label: 'Arkansas', value: 'AR'
		}, {
			label: 'California', value: 'CA'
		}, {
			label: 'Colorado', value: 'CO'
		}, {
			label: 'Connecticut', value: 'CT'
		}, {
			label: 'Delaware', value: 'DE'
		}, {
			label: 'District Of Columbia', value: 'DC'
		},
		// {
		// 	label: 'Federated States Of Micronesia', value: 'FM'
		// },
		{
			label: 'Florida', value: 'FL'
		}, {
			label: 'Georgia', value: 'GA'
		}, {
			label: 'Guam', value: 'GU'
		}, {
			label: 'Hawaii', value: 'HI'
		}, {
			label: 'Idaho', value: 'ID'
		}, {
			label: 'Illinois', value: 'IL'
		}, {
			label: 'Indiana', value: 'IN'
		}, {
			label: 'Iowa', value: 'IA'
		}, {
			label: 'Kansas', value: 'KS'
		}, {
			label: 'Kentucky', value: 'KY'
		}, {
			label: 'Louisiana', value: 'LA'
		}, {
			label: 'Maine', value: 'ME'
		}, {
			label: 'Marshall Islands', value: 'MH'
		}, {
			label: 'Maryland', value: 'MD'
		}, {
			label: 'Massachusetts', value: 'MA'
		}, {
			label: 'Michigan', value: 'MI'
		}, {
			label: 'Minnesota', value: 'MN'
		}, {
			label: 'Mississippi', value: 'MS'
		}, {
			label: 'Missouri', value: 'MO'
		}, {
			label: 'Montana', value: 'MT'
		}, {
			label: 'Nebraska', value: 'NE'
		}, {
			label: 'Nevada', value: 'NV'
		}, {
			label: 'New Hampshire', value: 'NH'
		}, {
			label: 'New Jersey', value: 'NJ'
		}, {
			label: 'New Mexico', value: 'NM'
		}, {
			label: 'New York', value: 'NY'
		}, {
			label: 'North Carolina', value: 'NC'
		}, {
			label: 'North Dakota', value: 'ND'
		}, {
			label: 'Northern Mariana Islands', value: 'MP'
		}, {
			label: 'Ohio', value: 'OH'
		}, {
			label: 'Oklahoma', value: 'OK'
		}, {
			label: 'Oregon', value: 'OR'
		}, {
			label: 'Palau', value: 'PW'
		}, {
			label: 'Pennsylvania', value: 'PA'
		}, {
			label: 'Puerto Rico', value: 'PR'
		}, {
			label: 'Rhode Island', value: 'RI'
		}, {
			label: 'South Carolina', value: 'SC'
		}, {
			label: 'South Dakota', value: 'SD'
		}, {
			label: 'Tennessee', value: 'TN'
		}, {
			label: 'Texas', value: 'TX'
		}, {
			label: 'Utah', value: 'UT'
		}, {
			label: 'Vermont', value: 'VT'
		}, {
			label: 'Virgin Islands', value: 'VI'
		}, {
			label: 'Virginia', value: 'VA'
		}, {
			label: 'Washington', value: 'WA'
		}, {
			label: 'West Virginia', value: 'WV'
		}, {
			label: 'Wisconsin', value: 'WI'
		}, {
			label: 'Wyoming', value: 'WY'
		}];

		_this.stopPriorityList = _this.CommonLayoutService.priorityList();

		_this.operationDays = [{
			label: _this.$translate.instant('location.mon'),
			value: 'Mon'
		}, {
			label: _this.$translate.instant('location.tues'),
			value: 'Tue'
		}, {
			label: _this.$translate.instant('location.wed'),
			value: 'Wed'
		}, {
			label: _this.$translate.instant('location.thurs'),
			value: 'Thu'
		}, {
			label: _this.$translate.instant('location.fri'),
			value: 'Fri'
		}, {
			label: _this.$translate.instant('location.sat'),
			value: 'Sat'
		}, {
			label: _this.$translate.instant('location.sun'),
			value: 'Sun'
		}, {
			label: _this.$translate.instant('location.hol'),
			value: 'Holiday'
		}];

		_this.manifestTypeList = [{
			value: 'bin_manifest_transport', label: 'Bin Manifest Transport'
		}, {
			value: 'bagout_manifest', label: 'Bagout Manifest'
		}, {
			value: 'delivery_manifest', label: 'Delivery Manifest'
		}];
		_this.manifestFileType = [{ value: 'EXCEL', label: 'EXCEL' }, { value: 'PDF', label: 'PDF' }];

		_this._map = _this._map.bind(_this);
		_this.onMarkerDragEnd = _this.onMarkerDragEnd.bind(_this);
		_this.total = [];
		_this.dayArray = [];
		_this.unshiftSelected = true;
		_this.isValidDirective = true;
		_this.renderDirective = false;
		_this.custNotSelectError = false;
		_this.locationType = ['TANKER', 'TRUCK', 'INTERNAL', 'WINDOW'];
		_this.hasACL = {};
		_this.openTime = 'openTime';
		_this.closeTime = 'closeTime';
		_this.OTCCompanyNameList = [];
		_this.currentLocationAddressObj = {};
		_this.locationAddressUpdateObj = {};
		_this.currentlyAssignedRoutes = {};
		_this.updatedAssignedRoutes = {};
		_this.currentlyAssignedDeliveryToLocation = {};
		_this.updatedDeliveryToLocation = {};
		_this.isLocationAddressChanged = false;
		_this.isRouteAssignmentChanged = false;
		_this.isDeliveryToLocationUpdated = false;
		_this.locationHistory = {};
		_this.currentlyAssignedLocationStatus = {};
		_this.isLocationStatus = false;
		_this.currentlyAssignedAllBranches = {};
		_this.isAllBranchesChanged = false;
		_this.currentlyAssignedDefaultBranch = {};
		_this.isDefaultBranchChanged = false;
		_this.currentlyAssignedBatchImport = {};
		_this.isBatchImportChanged = false;
		_this.currentlyAssignedBagoutExport = {};
		_this.isBagoutExportChanged = false;
		_this.currentlyAssignedHandleAtmLikeRegular = {};
		_this.isHandleAtmLikeRegular = false;

		_this.dateOptions = {
			formatDayTitle: 'MMMM',
			maxMode: "day"
		};

		_this.passWdIcon = {};
		_this.passwordStats = ['primary', 'secondary'];
		_this.pendingStopsChangesObj = {
			results: [],
			total: 0,
			loading: false
		};
		_this.customerCostCenterObj = {
			results: [],
			total: 0
		};

		_this.intervalList = _this.CommonLayoutService.intervalList();
		_this.bankWeekList = _this.CommonLayoutService.bankWeekList();
		_this.frequencyList = _this.CommonLayoutService.frequency();
		_this.weekDayList = _this.CommonLayoutService.dayOfWeek();
		_this.combinedRouteIntervals = _this.CommonLayoutService.combinedRouteIntervals();
		_this.foreCastingList = _this.CommonLayoutService.forecastingMethod();
		_this.combinedRoutes = [];
		_this.originalCombinedRoutes = [];
		_this.dayMap = _this.CommonLayoutService.dayMap();
		_this.LocationService = LocationService;
		_this.locationRecurringLoad = [];
		_this.originalLocationRecurringLoad = [];
		_this.recurringLoadSnapshotTaken = false;
		_this.isValidRecurringLoad = true;
		_this.atmEmptyAtCalculationMethodList = _this.CommonLayoutService.atmEmptyAtCalculationMethod();
		_this.fallbackFillRateDisplay = "0.0000%";
		_this.balanceTypes = [{ label: 'Denomination', value: 'DENOMINATION' }, { label: 'Percentage', value: 'PERCENTAGE' }];
		_this.forecastingFlowDirection = [{ label: 'Fill', value: 'FILL' }, { label: 'Empty', value: 'EMPTY' }];
		return _this;
	}

	(0, _createClass3.default)(LocationEditController, [{
		key: '_map',
		value: function _map($event) {
			this.model.latitude = $event.latLng.lat();
			this.model.longitude = $event.latLng.lng();
			if (this.model.latitude, this.model.longitude) {
				this.getAddressFromLatLng(this.model.latitude, this.model.longitude);
			}
		}
	}, {
		key: 'changeCustomer',
		value: function changeCustomer() {
			var _this2 = this;

			if (this.model.customer) {
				if (this.model.sameForAll) {
					this.custNotSelectError = false;
					// this.clearContractDays()
				}
				this.CustomerService.get(this.model.customer.Value).then(function (data) {
					// this.loadDays(data)
					if (_this2.model.sameForAll) _this2.clearContractDays();
				});
			} else {
				if (this.model.sameForAll) {
					this.uncheckSameForAll();
					this.clearContractDays();
				}
			}
		}
	}, {
		key: 'clearContractDays',
		value: function clearContractDays() {
			for (var day in this.contractDays) {
				if (this.contractDays[day]) {
					for (var key in this.model[day]) {
						this.model[day][key] = '';
					}
				}
			}
			// this.contractDays = []
		}
		// loadDays(data) {
		// 	this.contractDays = []
		// 	for (let key in data) {
		// 		if (key.toString().includes('serviceSchedule')) {
		// 			this.contractDays[key.toString().replace('serviceSchedule', '')] = data[key]
		// 		}
		// 	}
		// }

	}, {
		key: 'sameAll',
		value: function sameAll() {
			var _this3 = this;

			this.contractDays = [];
			this.days.forEach(function (data) {
				_this3.contractDays[data.value] = true;
			});

			if (this.model.sameForAll) {
				this.custNotSelectError = false;
				for (var day in this.contractDays) {
					if (this.contractDays[day]) {
						for (var key in this.model[day]) {
							this.model[day][key] = '';
						}
					}
				}
			}
		}
	}, {
		key: 'updateAll',
		value: function updateAll(selectedDay, opt) {
			if (this.model.sameForAll) {
				if (this.contractDays[selectedDay]) {
					for (var day in this.contractDays) {
						if (this.contractDays[day]) {
							this.model[day][opt] = this.model[selectedDay][opt];
						}
					}
				}
			}
		}
	}, {
		key: 'uncheckSameForAll',
		value: function uncheckSameForAll() {
			var _this4 = this;

			this.custNotSelectError = true;
			setTimeout(function () {
				_this4.custNotSelectError = false;
				_this4.model.sameForAll = false;
				_this4.$scope.$digest();
			}, 4000);
		}
	}, {
		key: 'getDate',
		value: function getDate(time) {
			if (!time) {
				return time;
			}
			time = time.split(':');

			var d = new Date();

			d.setUTCHours(+time[0]);
			d.setUTCMinutes(time[1]);
			d.setUTCSeconds(0);
			d.setUTCMilliseconds(0);

			return d;
		}
	}, {
		key: 'getNonUTCDate',
		value: function getNonUTCDate(time) {
			if (!time) {
				return time;
			}

			time = time.split(':');

			var d = new Date();

			d.setHours(+time[0]);
			d.setMinutes(time[1]);
			d.setSeconds(0);
			d.setMilliseconds(0);

			return d;
		}
	}, {
		key: 'locationSearchObj',
		value: function locationSearchObj() {
			var selectedBranch = this.model.branch.map(function (branch) {
				return branch.branchId;
			});
			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'id',
						condition: '!=',
						data: this.rawId
					}, {
						field: 'branchId',
						condition: 'IN',
						data: selectedBranch
					}, {
						field: 'active',
						condition: '=',
						data: true
					}, {
						group: {
							rules: [{
								field: 'locationType',
								condition: '=',
								data: 'DELIVERY'
							}, {
								field: 'locationType',
								condition: '=',
								data: 'BANK'
							}, {
								field: 'locationType',
								condition: '=',
								data: 'ATM'
							}, {
								field: 'locationType',
								condition: '=',
								data: 'REGULAR'
							}, {
								field: 'locationType',
								condition: '=',
								data: 'ON_CALL'
							}, {
								field: 'locationType',
								condition: '=',
								data: 'NO_SHIP_NO_GO'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};
			return searchObj.queryJSON.rules.length ? searchObj : null;
			// }, 1000);
		}

		// changeBranch() {
		// 	this.total = [];
		// 	this.dayArray = [];
		// 	this.unshiftSelected = false;
		// 	this.days.forEach((day) => {
		// 		this.model[day.value].routeId = null;
		// 	})
		// 	this.loadRoutes('', 0)
		// }

	}, {
		key: 'mappingObjKeyVal',
		value: function mappingObjKeyVal(obj) {
			if (obj == null) return obj;
			obj.Key = obj.name + ' (' + obj.branchId + ')';
			obj.Value = obj.id;
			return obj;
		}
	}, {
		key: 'loadRoutes',
		value: function loadRoutes(searchKey, offset) {
			var _this5 = this;

			this.total = [];
			this.dayArray = [];
			var selectedBranch = this.model.branch.map(function (branch) {
				return branch.branchId;
			});
			searchKey = searchKey || '';
			var routeSearchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: 'IN',
						data: selectedBranch
					}, {
						field: 'holdRoute',
						condition: '=',
						data: false
					}, {
						field: 'active',
						condition: '=',
						data: true
					}, {
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'name',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};

			if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1 && this.unshiftSelected) {
				offset = offset - 1;
			}
			return this.RouteService.all(routeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				_this5.currentlyAssignedRoutes = {};

				_this5.days.forEach(function (day, index) {
					var selectedVal = _this5.model[day.value].routeId ? _this5.model[day.value].routeId.Value : '';
					if (offset == 0 || offset == undefined) {
						_this5.total.push((0, _defineProperty3.default)({}, day.value, {
							total: data.total
						}));
						_this5.dayArray.push((0, _defineProperty3.default)({}, day.value, _this5.mapRoutes(data.results, searchKey, selectedVal)));
						if (!searchKey && selectedVal && _this5.unshiftSelected) {
							_this5.dayArray[index][day.value].unshift(_this5.model[day.value].routeId);
						}
						// this.obj[day.value] = {};
						if (_this5.model[day.value].routeId) (0, _assign2.default)(_this5.currentlyAssignedRoutes, new Object((0, _defineProperty3.default)({}, day.value, _this5.model[day.value].routeId.Value)));
						// } else {
						// 	const routeId = this.mapRoutes(data.results, searchKey, selectedVal);
						// 	this.day.routeId = this.day.routeId.concat(routeId);
					}
				});
			});
		}
	}, {
		key: 'loadCustomer',
		value: function loadCustomer(searchKey, offset) {
			var _this6 = this;

			searchKey = searchKey || '';
			var costomerSearchObj = this.searchPaginate(searchKey, 'id', 'name');
			if (offset !== 0 && this.model.customer && !searchKey && Math.abs(offset % 2) == 1) {
				offset = offset - 1;
			}
			return this.CustomerService.all(costomerSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				var selectedVal = _this6.model.customer ? _this6.model.customer.Value : '';
				if (offset === 0 || offset == undefined) {
					_this6.totalCostomers = data.total;
					_this6.customer = _this6.mapArrayData(data.results, searchKey, selectedVal);

					if (!searchKey && selectedVal) {
						_this6.customer.unshift(_this6.model.customer);
					}
				} else {
					var customer = _this6.mapArrayData(data.results, searchKey, selectedVal);
					_this6.customer = _this6.customer.concat(customer);
				}
			});
		}
	}, {
		key: 'loadCostCenter',
		value: function loadCostCenter(searchKey, offset) {
			var _this7 = this;

			searchKey = searchKey || '';

			var obj = {
				queryJSON: {
					rules: [{
						field: "customerFlag",
						condition: "=",
						data: false
					}, {
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "name",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};

			return this.CostCenterService.all(obj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this7.totalCostCenter = data.total;
					_this7.costCenterList = _this7.costCenterMap(data.results);
				} else {
					var costCenter = _this7.costCenterMap(data.results);
					_this7.costCenterList = _this7.costCenterList.concat(costCenter);
				}
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'loadCustomersCostCenter',
		value: function loadCustomersCostCenter(searchKey, offset) {
			var _this8 = this;

			searchKey = searchKey || '';

			var obj = {
				queryJSON: {
					rules: [{
						field: "customerFlag",
						condition: "=",
						data: true
					}, {
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "name",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};

			return this.CostCenterService.all(obj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this8.customerCostCenterObj.total = data.total;
					_this8.customerCostCenterObj.results = _this8.costCenterMap(data.results);
				} else {
					var costCenter = _this8.costCenterMap(data.results);
					_this8.customerCostCenterObj.results = _this8.customerCostCenterObj.results.concat(costCenter);
				}
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'loadLocationZone',
		value: function loadLocationZone(searchKey, offset) {
			var _this9 = this;

			var selectedBranchIds = Array.isArray(this.model.branch) ? this.model.branch.map(function (branch) {
				return branch.branchId;
			}) : [];
			var locationId = this.$stateParams.id || this.model.id;
			if (!locationId || !selectedBranchIds.length) {
				this.totalLocationZone = 0;
				this.locationZoneList = [];
				return this.$q.resolve();
			}

			var assigned = this.assignedLocationZones || [];
			var assignedIds = assigned.map(function (z) {
				return z.id;
			});

			return this.Service.getCoveringZones(locationId, selectedBranchIds).then(function (data) {
				var byId = {};
				(data && data.results || []).forEach(function (z) {
					byId[z.id] = { id: z.id, name: z.name, branchId: z.branchId, dayOfWeek: z.dayOfWeek };
				});
				assigned.forEach(function (z) {
					if (selectedBranchIds.indexOf(z.branchId) > -1 && !byId[z.id]) byId[z.id] = { id: z.id, name: z.name, branchId: z.branchId, dayOfWeek: z.dayOfWeek };
				});

				var candidate = (0, _values2.default)(byId);
				_this9.totalLocationZone = candidate.length;
				_this9.locationZoneList = _this9.locationZoneMap(candidate);
				_this9.locationZoneList.forEach(function (zone) {
					if (zone && zone.zoneId != null) zone.ticked = assignedIds.indexOf(zone.zoneId) > -1;
				});
				_this9.model.selectedLocationZones = _this9.locationZoneList.filter(function (zone) {
					return zone && zone.zoneId != null && zone.ticked;
				});
			});
		}
	}, {
		key: 'buildLocationZoneIdsForSave',
		value: function buildLocationZoneIdsForSave() {
			var selectedBranchIds = Array.isArray(this.model.branch) ? this.model.branch.map(function (branch) {
				return branch.branchId;
			}) : [];
			var hiddenAssigned = (this.assignedLocationZones || []).filter(function (z) {
				return selectedBranchIds.indexOf(z.branchId) === -1;
			}).map(function (z) {
				return z.id;
			});
			var visibleTicked = (this.locationZoneList || []).filter(function (z) {
				return z && z.zoneId != null && z.ticked;
			}).map(function (z) {
				return z.zoneId;
			});
			return (0, _from2.default)(new _set2.default(hiddenAssigned.concat(visibleTicked)));
		}
	}, {
		key: 'loadDaysRoutes',
		value: function loadDaysRoutes(searchKey, offset, index, dayOfData) {
			var _this10 = this;

			var selectedBranch = this.model.branch.map(function (branch) {
				return branch.branchId;
			});
			searchKey = searchKey || '';
			var routeSearchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: 'IN',
						data: selectedBranch
					}, {
						field: 'holdRoute',
						condition: '=',
						data: false
					}, {
						field: 'active',
						condition: '=',
						data: true
					}, {
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'name',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};
			if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
				offset = offset - 1;
			}
			return this.RouteService.all(routeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				var routeValue = _this10.model[dayOfData].routeId ? _this10.model[dayOfData].routeId.Value : null;
				if (offset === 0 || offset == undefined) {
					_this10.total[index][dayOfData] = {
						total: data.total
					};

					_this10.dayArray[index][dayOfData] = _this10.mapRoutes(data.results, searchKey, routeValue);
				} else {

					var newDayData = _this10.mapRoutes(data.results, searchKey, routeValue);
					_this10.dayArray[index][dayOfData] = _this10.dayArray[index][dayOfData].concat(newDayData);
				}
			});
		}
	}, {
		key: 'calculateCoinAmount',
		value: function calculateCoinAmount(recurringLoad, denom) {
			if (recurringLoad.qty) {
				if (denom.faceValue) {
					recurringLoad.amount = recurringLoad.qty * denom.faceValue;
				}
			} else {
				recurringLoad.amount = '';
			}
		}
	}, {
		key: 'calculateAndUpdateDayOccurrences',
		value: function calculateAndUpdateDayOccurrences(route) {
			var _this11 = this;

			var params = {
				locationId: route.locationId || this.model.id,
				dayOfWeek: route.day.value,
				anchorDate: (0, _moment2.default)(route.anchorDate).format('YYYY-MM-DD'),
				interval: route.interval.interval,
				frequency: route.interval.frequency || route.frequency,
				sequence: route.sequence,
				branchId: this.model.branchId
			};

			// TODO: only fetch from db if something changes in route
			this.LocationService.calculateDayOccurrences(params.locationId, params.dayOfWeek, params.anchorDate, params.interval, params.frequency, params.sequence, params.branchId).then(function (data) {
				_this11.Modal.nextScheduledOccurences(data);
			}).catch(function (error) {
				console.error('Error recalculating occurrences:', error);
			});
		}
	}, {
		key: 'mapRoutes',
		value: function mapRoutes(mapArray, searchKey, originalVal) {
			var newArray = [];
			mapArray.map(function (obj) {
				obj.Key = obj.name + ' (' + obj.shortName + ')';
				obj.Value = obj.id;
				newArray.push(obj);
			});
			return newArray;
		}
	}, {
		key: 'searchPaginate',
		value: function searchPaginate(searchKey, idField, nameField) {
			return {
				queryJSON: {
					rules: [{
						field: idField,
						condition: 'like',
						data: '%' + searchKey + '%'
					}, {
						field: nameField,
						condition: 'like',
						data: '%' + searchKey + '%'
					}],
					operator: 'OR'
				}
			};
		}
	}, {
		key: 'customerSearchObj',
		value: function customerSearchObj(searchKey) {
			return {
				queryJSON: {
					rules: [{
						field: "isEnabled",
						condition: "=",
						data: true
					}, {
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "name",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};
		}
	}, {
		key: 'loadCustomer',
		value: function loadCustomer(searchKey, offset) {
			var _this12 = this;

			searchKey = searchKey || '';
			var costomerSearchObj = this.customerSearchObj(searchKey);
			if (offset !== 0 && this.model.customer && !searchKey && Math.abs(offset % 2) == 1) {
				offset = offset - 1;
			}
			return this.CustomerService.all(costomerSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				var selectedVal = _this12.model.customer ? _this12.model.customer.Value : '';
				if (offset === 0 || offset == undefined) {
					_this12.totalCostomers = data.total;
					_this12.customer = _this12.mapArrayData(data.results, searchKey, selectedVal);

					if (!searchKey && selectedVal) {
						_this12.customer.unshift(_this12.model.customer);
					}
				} else {
					var customer = _this12.mapArrayData(data.results, searchKey, selectedVal);
					_this12.customer = _this12.customer.concat(customer);
				}
			});
		}

		// loadContract(searchKey, offset) {
		// 	searchKey = searchKey || '';
		// 	let contractSearchObj = this.searchPaginate(searchKey, 'contractId', 'contractName');
		// 	if (offset !== 0 && this.model.contract && !searchKey && Math.abs(offset % 2) == 1) {
		// 		offset = offset - 1;
		// 	}
		// 	return this.ContractService.all(contractSearchObj, offset, AppConstants.defaultPageLimit)
		// 		.then((data) => {
		// 			let selectedVal = this.model.contract ? this.model.contract.Value : '';
		// 			if (offset === 0 || offset == undefined) {
		// 				this.totalContracts = data.total;
		// 				this.contracts = this.mapContractsData(data.results, searchKey, selectedVal);
		// 				if (!searchKey && selectedVal) {
		// 					this.contracts.unshift(this.model.contract);
		// 				}
		// 			} else {
		// 				const contracts = this.mapContractsData(data.results, searchKey, selectedVal);
		// 				this.contracts = this.contracts.concat(contracts);
		// 			}
		// 		});
		// }

	}, {
		key: 'mapArrayData',
		value: function mapArrayData(mapArray, searchKey, originalVal) {
			var newArray = [];
			mapArray.map(function (obj) {
				obj.Key = obj.id + ' | ' + obj.name;
				obj.Value = obj.id;
				if (!searchKey && originalVal) {
					if (obj.id !== originalVal) {
						newArray.push(obj);
					}
				} else {
					newArray.push(obj);
				}
			});
			return newArray;
		}
	}, {
		key: 'costCenterMap',
		value: function costCenterMap(events) {
			return events.map(function (data) {
				return {
					Key: data.id + ' | ' + data.name,
					Value: data.id
				};
			});
		}

		// mapContractsData(mapArray, searchKey, originalVal) {
		// 	let newArray = [];
		// 	mapArray.map((obj) => {
		// 		obj.Key = obj.contractId + ' | ' + obj.contractName;
		// 		obj.Value = obj.id;
		// 		if (!searchKey && originalVal) {
		// 			if (obj.id !== originalVal) {
		// 				newArray.push(obj);
		// 			}
		// 		} else {
		// 			newArray.push(obj);
		// 		}
		// 	});
		// 	return newArray;
		// }

	}, {
		key: 'mapShiptypeArray',
		value: function mapShiptypeArray(mapArray, searchKey, originalVal) {
			var newArray = [];
			mapArray.map(function (obj) {
				obj.Key = obj.description;
				obj.Value = obj.id;
				if (!searchKey && originalVal) {
					if (obj.id !== originalVal) {
						newArray.push(obj);
					}
				} else {
					newArray.push(obj);
				}
			});
			return newArray;
		}
	}, {
		key: 'setKeyValue',
		value: function setKeyValue(obj) {
			if (obj == null) return obj;
			obj.Key = obj.id + ' | ' + obj.name;
			obj.Value = obj.id;
			return obj;
		}
	}, {
		key: 'locationZoneMap',
		value: function locationZoneMap(records) {
			var DAY_ORDER = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY', 'HOLIDAY'];
			var byBranch = _lodash2.default.groupBy(records || [], 'branchId');

			var grouped = [];
			(0, _keys2.default)(byBranch).sort().forEach(function (branchId) {
				grouped.push({ label: '<strong>' + branchId + '</strong>', msGroup: true });
				var byDay = _lodash2.default.groupBy(byBranch[branchId], 'dayOfWeek');
				DAY_ORDER.filter(function (d) {
					return byDay[d];
				}).forEach(function (day) {
					grouped.push({ label: '<strong>' + day + '</strong>', msGroup: true });
					byDay[day].forEach(function (z) {
						var info = z.id + ' | ' + z.name + ' (' + z.branchId + ', ' + z.dayOfWeek + ')';
						grouped.push({
							Key: info, Value: z.id, zoneId: z.id, zoneInfo: info,
							label: z.id + ' | ' + z.name, ticked: false
						});
					});
					grouped.push({ msGroup: false });
				});
				grouped.push({ msGroup: false });
			});
			return grouped;
		}
	}, {
		key: 'setLocationZoneKeyValue',
		value: function setLocationZoneKeyValue(obj) {
			if (obj == null) return obj;
			var label = obj.id + ' | ' + obj.name + ' (' + obj.branchId + ', ' + obj.dayOfWeek + ')';
			obj.Key = label;
			obj.Value = obj.id;
			obj.zoneId = obj.id;
			obj.zoneInfo = label;
			obj.ticked = true;
			return obj;
		}

		// mappingContractKeyVal(obj) {
		// 	if (obj == null) return obj;
		// 	obj.Key = obj.contractId + ' | ' + obj.contractName,
		// 		obj.Value = obj.id
		// 	return obj
		// }

	}, {
		key: 'loadBranchData',
		value: function loadBranchData() {
			var _this13 = this;

			if (!this.model.branch.length) {
				this.days.map(function (day) {
					_this13.model[day.value].routeId = null;
				});
			}
			setTimeout(function () {
				_this13.loadRoutes('', 0);
				_this13.routeList('', 0);
				_this13.loadLocationZone('', 0);
				_this13.$scope.$digest();
			}, 1000);
		}
	}, {
		key: 'shipTypeSearchObj',
		value: function shipTypeSearchObj() {
			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'status',
						condition: '=',
						data: true
					}],
					operator: 'AND'
				}
			};
			return searchObj.queryJSON.rules.length ? searchObj : null;
		}
	}, {
		key: '$onInit',
		value: function $onInit() {
			var _this14 = this;

			this.isValid = true;
			this.isValidMaxLoad = true;
			this.isValidRecurringStops = true;

			this.passwordStats.forEach(function (stat) {
				_this14.passWdIcon[stat] = { viewStaticOpenCode: false };
			});
			this.currentlyAssignedDeliveryToLocation = {};
			var shipTypeSearchObj = this.shipTypeSearchObj();

			this.startMaxDate = {
				minDate: (0, _moment2.default)().startOf('day').format('YYYY-MM-DD 00:00:00')
			};

			this.$q.all([this.UserBranchService.getUserBranches(this.model.loggedInUser), this.Service.get(this.$stateParams.id), this.LocationDeliveryService.getLocationDeliveryDetails(this.$stateParams.id), this.ShiptypeService.all(shipTypeSearchObj, 0, _app2.default.defaultPageLimit), this.LocationBranchService.get(this.$stateParams.id),
			// this.Service.getCombinedLocationRecurring(this.$stateParams.id),
			this.loadConfigs(), this.getPendingLocationChanges(), this.loadPreventativeMaintenances('', 0)]).then(function (data) {
				_this14.branch = data[0].results;
				data[4].results.forEach(function (selectedBranch) {
					_this14.branch.filter(function (branch) {
						if (branch.branchId == selectedBranch.branchId) {
							branch.ticked = true;
						}
					});
				});
				_this14.defaultModel = data[1];
				_this14.locationBranches = _this14.branch.filter(function (b) {
					return b.ticked;
				}).map(function (c) {
					return c.branchId;
				});
				_this14.rawId = data[1].id;
				_this14.model.id = data[1].id;
				_this14.model.name = data[1].name;
				_this14.model.status = data[1].active;
				_this14.model.customer = data[1].customer && data[1].customer.isEnabled ? _this14.setKeyValue(data[1].customer) : null;
				// this.model.contract = this.mappingContractKeyVal(data[1].customerContract)
				_this14.model.defaultBranch = data[1].branchId || null;

				var pmId = data[1].preventativeMaintenanceId;
				if (pmId) {
					_this14.Service.getPreventativeMaintenance(pmId).then(function (pm) {
						_this14.model.preventativeMaintenanceId = {
							Key: pm.title + (pm.status === 'Suspended' || pm.status === false ? ' (suspended)' : ''),
							Value: pm.id,
							isSuspended: pm.status === 'Suspended' || pm.status === false
						};
					}).catch(function (err) {
						return console.error(err);
					});
				} else {
					_this14.model.preventativeMaintenanceId = null;
				}
				if (['WINDOW', 'INTERNAL', 'TANKER'].includes(data[1].locationType)) {
					_this14.model.singleBranch = data[1].branchId || null;
					_this14.model.branch = _this14.branch.filter(function (b) {
						return b.ticked;
					});
				}
				_this14.model._address = data[1].address;
				_this14.model._city = data[1].city;
				_this14.model._state = data[1].state;
				_this14.model._zip = data[1].zip;
				_this14.model.refId = data[1].refNumber;
				_this14.model._poc = data[1].poc;
				_this14.model.pocPhone = data[1].phone || null;
				_this14.model.pocEmail = data[1].email;
				_this14.model.deliverBagOutPiece = data[1].deliverBagOutPiece;
				_this14.model.individualBagout = data[1].individualBagout;
				_this14.model.centralBank = data[1].centralBank;
				_this14.model.RNdeliveries = !!data[1].routeNotificationDeliveries;
				_this14.model.RNpickups = !!data[1].routeNotificationPickups;
				_this14.model.RNnoPickup = !!data[1].routeNotificationNoPickup;
				_this14.model.RNzeroPickup = !!data[1].routeNotificationZeroPickup;
				_this14.model.Mon.routeId = _this14.mappingObjKeyVal(data[1].defRouteMon);
				_this14.model.Tue.stops = data[1].defRouteMonStop;
				_this14.model.Mon.options = data[1].defRouteSeqMon;
				_this14.model.Tue.routeId = _this14.mappingObjKeyVal(data[1].defRouteTue);
				_this14.model.Tue.stops = data[1].defRouteTueStop;
				_this14.model.Tue.options = data[1].defRouteSeqTue;
				_this14.model.Wed.routeId = _this14.mappingObjKeyVal(data[1].defRouteWed);
				_this14.model.Wed.stops = data[1].defRouteWedStop;
				_this14.model.Wed.options = data[1].defRouteSeqWed;
				_this14.model.Thu.routeId = _this14.mappingObjKeyVal(data[1].defRouteThu);
				_this14.model.Thu.stops = data[1].defRouteThuStop;
				_this14.model.Thu.options = data[1].defRouteSeqThu;
				_this14.model.Fri.routeId = _this14.mappingObjKeyVal(data[1].defRouteFri);
				_this14.model.Fri.stops = data[1].defRouteFriStop;
				_this14.model.Fri.options = data[1].defRouteSeqFri;
				_this14.model.Sat.routeId = _this14.mappingObjKeyVal(data[1].defRouteSat);
				_this14.model.Sat.stops = data[1].defRouteSatStop;
				_this14.model.Sat.options = data[1].defRouteSeqSat;
				_this14.model.Sun.routeId = _this14.mappingObjKeyVal(data[1].defRouteSun);
				_this14.model.Sun.stops = data[1].defRouteSunStop;
				_this14.model.Sun.options = data[1].defRouteSeqSun;
				_this14.model.Hol.routeId = _this14.mappingObjKeyVal(data[1].defRouteHol);
				_this14.model.Hol.stops = data[1].defRouteHolStop;
				_this14.model.Hol.options = data[1].defRouteSeqHol;
				_this14.model.seasonStart = data[1].seasonStart ? data[1].seasonStart : null;
				_this14.model.seasonEnd = data[1].seasonEnd ? data[1].seasonEnd : null;
				_this14.effctDate = (0, _moment2.default)(_this14.model.seasonStart).format('Y-MM-DD');
				// this.model.deliveryBackoutTimes = data[1].deliveryBackoutTimes
				// this.model.startTime = this.getDate(data[1].openTime)
				// this.model.endTime = this.getDate(data[1].closeTime)
				_this14.model.deliveryLoc1 = data[1].deliveryLoc1Id;
				_this14.model.deliveryLoc2 = data[1].deliveryLoc2Id;
				_this14.model.deliveryLocCoin = data[1].deliveryLocCoinId;
				_this14.model.deliveryLocCod = data[1].deliveryLocCodId;
				_this14.model._type = data[1].locationType;
				_this14.model.keyId = data[1].keyNum;
				_this14.model.maxDepositAmount = data[1].maxDepositAmount || 0;
				_this14.model.roundedDeposits = data[1].decimalCash;
				_this14.model.codAllow = data[1].codPickup;
				_this14.model.allowMulti = data[1].allowMulti;
				_this14.model.bulkTransfer = !!data[1].bulkTransfer;
				_this14.model._leave = data[1].scanLeaveLocation;
				_this14.model.lastTransaction = data[1].scanLastTransaction;
				_this14.model.verifyToTruck = data[1].verifyToTruck;
				_this14.model.verifyCoinToTruck = data[1].verifyCoinToTruck !== undefined ? data[1].verifyCoinToTruck : false;
				_this14.model.atmCassette = data[1].scanATMCassette;
				_this14.model.maxCassettes = data[1].maxCassettes != null ? data[1].maxCassettes : null;
				_this14.model.packCoinSeparately = !!data[1].packCoinSeparately;
				_this14.model.captureDenomStc = !!data[1].captureDenomStc;
				_this14.model.TRdeliveries = !data[1].noPrintDelivery;
				_this14.model.TRpickups = !data[1].noPrintPickup;
				_this14.model.latitude = data[1].lat;
				_this14.model.longitude = data[1].long;
				// this.model.deliveryBackoutTimes = !!(data[1].openTime || data[1].closeTime)
				_this14.model.lockType = data[1].lockType || null;
				_this14.model.comments = data[1].comments || null;
				_this14.model.OTCCompanyName = data[1].OTCCompanyName || null;
				_this14.model.stopProcess = data[1].stopProcess || null;
				_this14.model.openTimeSun = _this14.getNonUTCDate(data[1].openTimeSun);
				_this14.model.closeTimeSun = _this14.getNonUTCDate(data[1].closeTimeSun);
				_this14.model.openTimeMon = _this14.getNonUTCDate(data[1].openTimeMon);
				_this14.model.closeTimeMon = _this14.getNonUTCDate(data[1].closeTimeMon);
				_this14.model.openTimeTue = _this14.getNonUTCDate(data[1].openTimeTue);
				_this14.model.closeTimeTue = _this14.getNonUTCDate(data[1].closeTimeTue);
				_this14.model.openTimeWed = _this14.getNonUTCDate(data[1].openTimeWed);
				_this14.model.closeTimeWed = _this14.getNonUTCDate(data[1].closeTimeWed);
				_this14.model.openTimeThu = _this14.getNonUTCDate(data[1].openTimeThu);
				_this14.model.closeTimeThu = _this14.getNonUTCDate(data[1].closeTimeThu);
				_this14.model.openTimeFri = _this14.getNonUTCDate(data[1].openTimeFri);
				_this14.model.closeTimeFri = _this14.getNonUTCDate(data[1].closeTimeFri);
				_this14.model.openTimeSat = _this14.getNonUTCDate(data[1].openTimeSat);
				_this14.model.closeTimeSat = _this14.getNonUTCDate(data[1].closeTimeSat);
				_this14.model.openTimeHoliday = _this14.getNonUTCDate(data[1].openTimeHoliday);
				_this14.model.closeTimeHoliday = _this14.getNonUTCDate(data[1].closeTimeHoliday);
				_this14.model.ATMTransfer = data[1].ATMTransfer;
				_this14.model.OTCGeoFence = data[1].OTCGeoFence;
				_this14.model.closeReq = data[1].closeReq;
				_this14.model.closeEndOfStop = !!data[1].closeEndOfStop;
				_this14.model.zoneRouting = data[1].zoneRouting;
				_this14.model.staticOpenCode = data[1].staticOpenCode;
				_this14.currentLocationAddressObj = {
					address: data[1].address,
					city: data[1].city,
					state: data[1].state,
					zip: data[1].zip
				};
				_this14.model.stopPriority = data[1].stopPriority;
				_this14.model.model = data[1].model;
				_this14.model.serialNumber = data[1].serialNumber;
				_this14.model.secondaryLock = data[1].secondaryLock;
				_this14.model.secondaryLockId = data[1].secondaryLockId;
				_this14.model.secondaryLockType = data[1].secondaryLockType;
				_this14.model.secondaryLockOTCCompanyName = data[1].secondaryLockOTCCompanyName;
				_this14.model.secondaryLockCloseReq = data[1].secondaryLockCloseReq;
				_this14.model.secondaryLockAutoOpen = data[1].secondaryLockAutoOpen;
				_this14.model.secondaryLockStaticOpenCode = data[1].secondaryLockStaticOpenCode;
				_this14.model.enableOrderProfile = data[1].enableOrderProfile;
				_this14.model.handleAtmLikeRegular = data[1].handleAtmLikeRegular;
				_this14.model.idBatchImport = data[1].idBatchImport;
				_this14.model.idBagoutExport = data[1].idBagoutExport;
				_this14.model.idBagoutDepositExport = data[1].idBagoutDepositExport;
				_this14.model.idOTCLock = data[1].idOTCLock;
				_this14.model.scheduledLocations = data[1].scheduledLocations.length > 0 ? _lodash2.default.cloneDeep(data[1].scheduledLocations) : [];
				_this14.model.NFCLock = data[1].NFCLock;
				_this14.model.country = data[1].country;
				_this14.model.isNonUSLocation = data[1].country !== 'US' ? true : false;
				_this14.model.NFCScan = data[1].NFCScan;
				_this14.model.NFCTagId = data[1].NFCTagId;
				_this14.model.distanceFromBranch = data[1].distanceFromBranch;
				_this14.model.travelTimeToBranch = data[1].travelTimeToBranch;
				_this14.model.costCenter = _this14.setKeyValue(data[1].costCenter);
				_this14.assignedLocationZones = (data[1].locationZones || []).map(function (zone) {
					return { id: zone.id, name: zone.name, branchId: zone.branchId, dayOfWeek: zone.dayOfWeek };
				});
				_this14.model.selectedLocationZones = (data[1].locationZones || []).map(function (zone) {
					return _this14.setLocationZoneKeyValue(zone);
				});
				_this14.model.customerCostCenter = _this14.setKeyValue(data[1].customerCostCenter);
				_this14.model.accountNumber = data[1].accountNumber;
				_this14.orderProfile = data[1].atmOrderProfile;
				_this14.model.recurringStops = data[1].locationScheduleRecurringData;
				_this14.locationScheduleRecurringData = _lodash2.default.cloneDeep(data[1].locationScheduleRecurringData);
				_this14.loadAtmMakes(data[1].make);
				_this14.model.machineOwner = data[1].machineOwner;
				_this14.model.bankSourceId = data[1].bankSource;
				_this14.model.FLMProvider = data[1].FLMProvider;
				_this14.model.SLMProvider = data[1].SLMProvider;
				_this14.model.bankWeek = data[1].bankWeek;
				_this14.model.frequencyOptions = data[1].frequency;
				_this14.model.dayOfWeekOptions = data[1].dayOfWeek;
				_this14.model.optional1 = data[1].optional1;
				_this14.model.optional2 = data[1].optional2;
				_this14.model.optional3 = data[1].optional3;
				_this14.model.locationDistanceId = data[1].locationDistanceId ? data[1].locationDistanceId : null;
				_this14.model.locationDistance = data[1].locationDistance ? data[1].locationDistance.label : null;
				_this14.model.contractExpirationDate = data[1].contractExpirationDate ? (0, _moment2.default)(data[1].contractExpirationDate).format('YYYY-MM-DD') : null;
				_this14.model.forecastingStrategy = data[1].forecastingStrategy;
				_this14.model.liabilityThreshold = data[1].liabilityThreshold;
				_this14.model.securityThreshold = data[1].securityThreshold;
				_this14.model.atmEmptyAtCalculationMethod = data[1].atmEmptyAtCalculationMethod;
				_this14.model.aecPercentChangeValue = data[1].aecPercentChangeValue + '%';
				_this14.model.aecPercentChangePeriodA = data[1].aecPercentChangePeriodA;
				_this14.model.aecPercentChangePeriodB = data[1].aecPercentChangePeriodB;
				_this14.model.aecSinglePeriod = data[1].aecSinglePeriod;
				_this14.model.aecWeightedAvgWeightA = data[1].aecWeightedAvgWeightA;
				_this14.model.aecWeightedAvgPeriodA = data[1].aecWeightedAvgPeriodA;
				_this14.model.aecWeightedAvgWeightB = data[1].aecWeightedAvgWeightB;
				_this14.model.aecWeightedAvgPeriodB = data[1].aecWeightedAvgPeriodB;
				_this14.model.denominationSourceObj.selectedDenomination = data[1].locationDenomination;
				_this14.model.locationBalanceActive = data[1].locationBalanceActive ? data[1].locationBalanceActive : [];
				_this14.model.addToSwapRatio = data[1].addSwapRatio;
				_this14.model.deliveryCutOff = data[1].deliveryCutOff;
				_this14.model.deliveryCutOffTime = _this14.getNonUTCDate(data[1].deliveryCutOffTime);
				_this14.model.pickupSLA = data[1].pickupSLA;
				_this14.model.pickupSLATime = data[1].pickupSLATime;
				_this14.model.lastRouteStop = data[1].lastRouteStop;
				_this14.model.targetStopTime = _this14.getNonUTCDate(data[1].targetStopTime);
				_this14.model.printDeliveryManifest = data[1].printDeliveryManifest;
				_this14.model.balanceType = data[1].balanceType;
				_this14.model.forecastingFlowDirection = data[1].forecastingFlowDirection;
				_this14.model.flowThreshold = data[1].flowThreshold ? data[1].flowThreshold >= 0.1 && data[1].flowThreshold <= 0.9 ? (data[1].flowThreshold * 100).toFixed(3) : data[1].flowThreshold.toFixed(3) : 0.2;
				_this14.model.podReceipt = data[1].podReceipt;
				_this14.model.locationSlots = data[1].locationSlots || [];
				_this14.model.sendManifestOnDelivery = data[1].sendManifestOnDelivery;
				_this14.model.manifestType = data[1].manifestType;
				_this14.model.manifestFileType = data[1].manifestFileType;
				_this14.model.manifestRecipientEmail = data[1].manifestRecipientEmail;
				_this14.model.zeroAmountPickupRecipientEmail = data[1].zeroAmountPickupRecipientEmail;
				_this14.model.autoRerouteMissed = data[1].autoRerouteMissed;
				_this14.model.packResidual = data[1].packResidual;
				_this14.model.coinPermitted = data[1].coinPermitted;
				_this14.model.bagoutEnabled = data[1].bagoutEnabled;
				_this14.model.isTransferHoldLocation = data[1].isTransferHoldLocation;
				_this14.model.monthlyCashCountLimit = data[1].monthlyCashCountLimit;
				_this14.model.monthlyCashCountLimitAmount = data[1].monthlyCashCountLimitAmount;
				_this14.model.fallbackFillRate = data[1].fallbackFillRate === 0 ? 0 : _this14.toDecimalString(data[1].fallbackFillRate);
				var rawFfr = data[1].fallbackFillRate || 0;
				_this14.fallbackFillRateDisplay = (rawFfr * 100 * 86400).toFixed(4) + '%';
				_this14.filterStopProcess();
				// this.model.recurringStops.forEach(recurringStop => {
				// 	recurringStop.anchorDate = recurringStop.anchorDate ? this.DateUtil.convertToDate(recurringStop.anchorDate) : null;
				// 	recurringStop.effectiveTillDate = recurringStop.effectiveTillDate ? this.DateUtil.convertToDate(recurringStop.effectiveTillDate) : null;
				// })

				_this14.currentlyAssignedBatchImport = {
					idBatchImport: data[1].idBatchImport
				};

				_this14.currentlyAssignedBagoutExport = {
					idBagoutExport: data[1].idBagoutExport
				};

				_this14.currentlyAssignedHandleAtmLikeRegular = {
					handleAtmLikeRegular: data[1].handleAtmLikeRegular
				};

				_this14.currentlyAssignedLocationStatus = {
					active: data[1].active
				};

				_this14.currentlyAssignedDefaultBranch = {
					branchId: data[1].branchId
				};

				_this14.currentlyAssignedFundingSource = {
					bankSourceId: data[1].bankSource ? data[1].bankSource.Key : null,
					addSwapRatio: data[1].addSwapRatio || null
					// this.model.deliveryToLocation = this.locationMapping(data[2], data[3], data[3]);

				};setTimeout(function () {
					_this14.$q.all([_this14.loadRoutes('', 0),
					// this.loadContract('', 0),
					[], _this14.loadCustomer('', 0), _this14.Service.all(_this14.locationSearchObj(), 0, _app2.default.defaultPageLimit), _this14.routeList('', 0), _this14.loadCostCenter('', 0), _this14.loadLocationZone('', 0), _this14.getAllFundingSource('', 0), _this14.loadCustomersCostCenter('', 0), _this14.getAllDenominations('', 0), _this14.getAllLocationSlotDenominations('', 0), _this14.onFlowThresholdBlur('', 0), _this14.loadPickupRequestTimes()]).then(function (res) {

						// if (data[1].locationDenomination) {
						// 	const denominations = data[1].locationDenomination.map((ele) => ele.denomination);
						// 	this.model.selectedDenomination = this.denominationsDataMap(denominations);

						// 	this.model.selectedDenomination.map((e) => {
						// 		this.model.denominationSourceObj.results.map(i => {
						// 			if (e.id == i.id) {
						// 				i.ticked = true
						// 			}
						// 		})
						// 	})
						// }

						if (data[1].locationDenomination) {
							_this14.model.selectedDenomination = data[1].locationDenomination.map(function (item) {
								var _denomination;

								if (item.denomination && _this14.model._type !== 'ATM') {
									item.disableFields = true;
									item.isDisabled = true;
								} else {
									item.disableFields = false;
									item.isDisabled = false;
								}

								var balanceActiveItem = data[1].locationBalanceActive.find(function (balanceItem) {
									return balanceItem.denominationId === item.denomination.id;
								});
								return (0, _extends3.default)({}, item, {
									locationBalanceActiveId: balanceActiveItem ? balanceActiveItem.id : null,
									isDisabled: true,
									denomination: (_denomination = {
										Key: item.denomination.id + ' | ' + item.denomination.name,
										Value: item.denomination.id,
										strapCount: item.denomination.strapCount,
										faceValue: item.denomination.faceValue
									}, (0, _defineProperty3.default)(_denomination, 'strapCount', item.denomination.strapCount), (0, _defineProperty3.default)(_denomination, 'coinFlag', item.denomination.coinFlag), _denomination),
									minResidualThreshold: balanceActiveItem ? Math.round(balanceActiveItem.residualMinimum * 1000000) / 1000000 + '%' : '0%',
									maxResidualThreshold: balanceActiveItem ? Math.round(balanceActiveItem.residualMaximum * 1000000) / 1000000 + '%' : '0%',
									minResidualThresholdPercentage: balanceActiveItem ? Math.round(balanceActiveItem.residualMinimum * 100 * 10000) / 10000 + '%' : '0%',
									maxResidualThresholdPercentage: balanceActiveItem ? Math.round(balanceActiveItem.residualMaximum * 100 * 10000) / 10000 + '%' : '0%'
								});
							});
						}

						_this14.cloneSelectedDenoms = _lodash2.default.cloneDeep(_this14.model.selectedDenomination);

						_this14.DefaultDenominations = _this14.model.selectedDenomination.map(function (item) {
							return {
								id: item.denomination.Value,
								Key: item.denomination.Key, //`${item.denomination.id} | ${item.denomination.name}`,
								Value: item.denomination.Value, //item.denomination.id,
								maxLoad: item.maxLoad,
								maxResidualThreshold: _this14.convertStr(item.maxResidualThreshold),
								minResidualThreshold: _this14.convertStr(item.minResidualThreshold),
								locationDenominationId: item.id,
								locationBalanceActiveId: item.locationBalanceActiveId,
								denominationStatus: undefined,
								locationBalanceActiveStatus: undefined,
								status: undefined
								// ticked: true 
							};
						});

						_this14.getFilteredDenominations();
						_this14.checkForMaxLoadFaceValueDivisibility();
						// if (this.model.enableOrderProfile && this.orderProfile) {

						// 	this.model.orderProfileObj.selectedOrderProfile = {
						// 		Key: this.orderProfile.branchFundingSourceOrderProfile.name + ' | ' + this.orderProfile.branchFundingSourceOrderProfile.loadInterval,
						// 		Value: this.orderProfile.branchFundingSourceOrderProfile.id
						// 	}

						// 	this.model.fundingSourceObj.selectedFundingSource = {
						// 		Key: this.orderProfile.branchFundingSource.id + ' | ' + this.orderProfile.branchFundingSource.sourceName,
						// 		Value: this.orderProfile.branchFundingSource.id
						// 	}
						// 	this.getOrderProfile('', 0);
						// }

						_this14.model.deliveryToLocation = _this14.locationMapping(_lodash2.default.cloneDeep(data[2]), data[3], res[3]);

						_this14.model.deliveryToLocation.forEach(function (loc, index) {
							(0, _assign2.default)(_this14.currentlyAssignedDeliveryToLocation, new Object((0, _defineProperty3.default)({}, index, loc.shipTypeDetails.Key.concat(' | ', loc.locationDetails.Key))));
						});

						_this14.defaultModel.deliveryToLocation = _this14.locationMapping(data[2], data[3], res[3]);
						_this14.defaultModel.locationScheduleRecurringData = data[1].locationScheduleRecurringData ? data[1].locationScheduleRecurringData : [];
						_this14.defaultModel.scheduledLocations = data[1].scheduledLocations ? data[1].scheduledLocations : [];

						_this14.renderDirective = true;

						if (_this14.model.customer) _this14.changeCustomer();

						_this14.model.scheduledLocations.map(function (sl) {
							sl.vaultDate = _this14.DateUtil.convertToDate(sl.vaultDate);
							sl.routeId = {
								Key: sl.route.name,
								Value: sl.route.id
							};
							sl.status = 'Update';
							sl.scheduleLocationId = sl.id;
						});

						_this14.scheduledLocations = _this14.model.scheduledLocations.map(function (sl) {
							return {
								id: sl.id,
								vaultDate: _this14.DateUtil.convertToDate(sl.vaultDate),
								routeId: sl.route.id,
								sequence: sl.sequence,
								route: {
									Key: sl.route.name,
									Value: sl.route.id
								},
								locationId: sl.locationId,
								createdAt: sl.createdAt,
								updatedAt: sl.updatedAt
							};
						});
						_this14.createCombinedRoutes(_this14.mappingObjKeyVal(data[1].defRecurringRouteHol));
						_this14.originalCombinedRoutes = _lodash2.default.cloneDeep(_this14.combinedRoutes);
						_this14.createLocationRecurringLoad();
						_this14.validateLocationSlotsDuplicate();
					});
					_this14.$scope.$digest();
				});
			}).then(function () {
				_this14.allowStopProcess();
				_this14.getSetupDetails();
			}).finally(function () {
				_this14.loading = false;
			}).catch(function (err) {
				console.log(err);
			});

			this.$scope.$watch(function () {
				return _this14.model.coinPermitted;
			}, function (newVal, oldVal) {
				if (_this14.model._type === 'ATM' && _this14.model.bankSourceId && _this14.model.denominationSourceObj && _this14.model.denominationSourceObj.results && _this14.model.denominationSourceObj.results.length > 0 && newVal !== oldVal) {
					_this14.getFilteredDenominations();
				}
			});
		}
	}, {
		key: 'locationMapping',
		value: function locationMapping(deliveryToLocation, shiptypes, locations) {
			var _this15 = this;

			if (!deliveryToLocation) return [];
			return deliveryToLocation.map(function (location, index) {
				location.disablePickupRequire = false;
				location.shipType = location.shiptypeId;
				location.shipTypeDetails = {
					Key: location.shiptype.description,
					Value: location.shiptypeId
				};
				location.totalShipment = shiptypes.total;
				location.allShipeType = _this15.mapShiptypeArray(shiptypes.results, '', location.shipTypeDetails.Value);
				location.allShipeType.unshift(location.shipTypeDetails);

				location.location = location.destinationLocationId;
				location.locationDetails = {
					Key: location.destinationLocationId + " | " + location.destinationLocation.name,
					Value: location.destinationLocationId
				};
				location.totalLocation = locations.total;
				location.allLocations = _this15.mapArrayData(locations.results, '', location.locationDetails.Value);

				location.allLocations.unshift(location.locationDetails);

				location.sortOrder = location.sortOrder || 0;
				location.duplicate = false;
				return location;
			});
		}
	}, {
		key: 'getCenter',
		value: function getCenter() {
			var DEFAULT_LATITUDE = -1,
			    DEFAULT_LONGITUDE = -1;
			var lat = void 0,
			    long = void 0;

			lat = this.model.latitude || DEFAULT_LATITUDE;
			long = this.model.longitude || DEFAULT_LONGITUDE;

			return lat && long ? [lat, long] : false;
		}
	}, {
		key: 'createCombinedRoutes',
		value: function createCombinedRoutes(defRecurringRouteHolId) {
			var _this16 = this;

			this.combinedRoutes = [];
			this.days.forEach(function (day) {
				var matchedRoute = _lodash2.default.find(_this16.locationScheduleRecurringData, { dayOfWeek: day.value });
				var anchorDate;
				if (matchedRoute) {
					anchorDate = new Date(matchedRoute.anchorDate);
					anchorDate.setMinutes(anchorDate.getMinutes() + anchorDate.getTimezoneOffset());
				}
				_this16.combinedRoutes.push({
					combinedRouteIntervals: [].concat((0, _toConsumableArray3.default)(_this16.combinedRouteIntervals)),
					id: matchedRoute ? matchedRoute.id : null,
					frequency: matchedRoute ? matchedRoute.frequency : null,
					sequence: matchedRoute ? matchedRoute.sequence : 99,
					day: day,
					route: day.value === 'Hol' ? defRecurringRouteHolId : matchedRoute ? matchedRoute.route : null,
					interval: matchedRoute ? _this16.getCombinedRouteInterval(matchedRoute.interval, matchedRoute.frequency) : null,
					anchorDate: matchedRoute ? anchorDate : null,
					isVisible: day.value === 'Hol' ? false : true,
					locationId: matchedRoute ? matchedRoute.locationId : null,
					nextOccurrence: matchedRoute ? matchedRoute.nextOccurrence : null,
					locationScheduleRecurringLoadData: matchedRoute ? matchedRoute.locationScheduleRecurringLoadData : []
				});
			});
		}
	}, {
		key: 'getCombinedRouteInterval',
		value: function getCombinedRouteInterval(interval, frequency) {
			return this.combinedRouteIntervals.find(function (ci) {
				return ci.interval === interval && ci.frequency === frequency;
			});
		}
	}, {
		key: 'getRouteFromDayArray',
		value: function getRouteFromDayArray(index, day, routeId) {
			return this.dayArray[index][day.value].find(function (d) {
				return d.id === routeId;
			});
		}
	}, {
		key: 'changeLocationType',
		value: function changeLocationType() {
			this.model.centralBank = false;
			this.model.verifyToTruck = ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(this.model._type) > -1;
			// this.model.verifyCoinToTruck = this.model.verifyToTruck;

			if (this.model._type !== 'ATM') {
				this.model.maxCassettes = null;
			}

			if (this.model._type == 'WINDOW' || this.model._type == 'INTERNAL' || this.model._type == 'TANKER') {
				var anyOne = void 0;
				this.branch.forEach(function (d, index) {
					if (anyOne == null && d.ticked) {
						anyOne = d;
					} else {
						d.ticked = false;
					}
				});
				// if (anyOne) {
				// 	this.model.singleBranch = anyOne.branchId;
				// 	this.model.branch = this.branch.filter(b => b.ticked);
				// } else {
				// 	this.model.singleBranch = null;
				// 	this.model.branch = [];
				// }
			}
			if (this.model._type !== 'ATM' && this.model._type !== 'LOCKER') {
				this.model.lockType = null;
				this.model.OTCCompanyName = null;
			}

			this.createLocationRecurringLoad();
		}
	}, {
		key: 'onAtmCassetteChange',
		value: function onAtmCassetteChange() {
			if (!this.model.atmCassette) {
				this.model.maxCassettes = null;
			}
		}
	}, {
		key: 'onSingleBranchChange',
		value: function onSingleBranchChange() {
			var _this17 = this;

			this.branch.forEach(function (b) {
				b.ticked = b.branchId === _this17.model.singleBranch;
			});
			this.model.branch = this.branch.filter(function (b) {
				return b.ticked;
			});
			this.loadBranchData();
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.$onInit();
			for (var key in this.model) {
				if (key == "today") {
					today: (0, _moment2.default)().hour(0).minutes(0).second(0).toDate();
				}
			}
			this.resetData();
			this.model.isSameOperationTime = false;
			this.model.sameForAll = false;
			this.currentLocationAddressObj = {};
			this.locationAddressUpdateObj = {};
			this.currentlyAssignedRoutes = {};
			this.updatedAssignedRoutes = {};
			this.currentlyAssignedDeliveryToLocation = {};
			this.updatedDeliveryToLocation = {};
			this.isLocationAddressChanged = false;
			this.isRouteAssignmentChanged = false;
			this.isDeliveryToLocationUpdated = false;
			this.assignedDeliveryLocation = [];
			this.assignedRoutes = [];
			this.model.deletedRecurringStops = [];
			this.locationRecurringLoad = [];
		}
	}, {
		key: 'resetData',
		value: function resetData() {
			if (this.model.startTime && this.model.endTime !== (0, _moment2.default)().format('hh:mm s')) {} else {
				angular.element("input[type='time']").val(null);
			}
		}
	}, {
		key: 'validateDeleteRecurringStops',
		value: function validateDeleteRecurringStops(selectedRoute) {
			if (selectedRoute.route || selectedRoute.anchorDate || selectedRoute.interval) {
				return true;
			}
			this.deleteCombinedRoute(selectedRoute);
		}
	}, {
		key: 'isUTC',
		value: function isUTC() {
			this.x = (0, _moment2.default)(this.model.seasonEnd).format('Y-MM-DD');
			this.expDate = this.x + 'T23:59:59.000Z';
			this.model.seasonEnd = this.expDate;
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this18 = this;

			var promise = _promise2.default.resolve();
			this.findLocationAddressChange();
			this.findRouteAssignmentChange();
			// if (!this.validate()) {
			// 	return
			// }
			// this.autoDetect()
			// .then(() => {

			this.loading = true;

			if (this.isLocationAddressChanged || !this.model.distanceFromBranch && !this.model.travelTimeToBranch || !this.model.latitude || !this.model.longitude) {
				promise = promise.then(function () {
					return _this18.autoDetect();
				});
			}

			this.x = (0, _moment2.default)(this.model.seasonEnd).format('Y-MM-DD');
			this.expDate = (0, _moment2.default)(this.model.seasonEnd).format('YYYY-MM-DD');
			this.effDate = (0, _moment2.default)(this.model.seasonStart).format('YYYY-MM-DD');
			this.checkForMaxLoadFaceValueDivisibility();

			var SavedDenominations = (this.model.selectedDenomination || []).map(function (item) {
				return {
					id: item.denomination ? item.denomination.id || item.denomination.Value : null,
					Key: item.denomination ? item.denomination.Key || item.denomination.Value + ' | ' + item.name : null,
					Value: item.denomination ? item.denomination.Value : null,
					maxLoad: item.maxLoad,
					denominationStatus: item.denominationStatus,
					locationBalanceActiveStatus: item.locationBalanceActiveStatus,
					status: item.status,
					maxResidualThreshold: _this18.convertStr(item.maxResidualThreshold),
					minResidualThreshold: _this18.convertStr(item.minResidualThreshold),
					locationDenominationId: item.id,
					locationBalanceActiveId: item.locationBalanceActiveId
					// ticked: item.ticked || false
				};
			});

			if (this.model.deliveryToLocation && this.model.deliveryToLocation.length) {
				this.model.deliveryToLocation.map(function (deliveryLocObj, index) {
					delete deliveryLocObj.$$hashKey;
					// if (deliveryLocObj.allLocations) {
					// 	delete (this.model.deliveryToLocation[index].allLocations)
					// }
					// if (deliveryLocObj.allShipeType) {
					// 	delete (this.model.deliveryToLocation[index].allShipeType)
					// }
				});
			}

			if (this.model.scheduledLocations.length) {
				this.model.scheduledLocations.forEach(function (d) {
					d.vaultDate = (0, _moment2.default)(d.vaultDate).format('YYYY-MM-DD');
					d.routeId = d.routeId.Value;
				});
			}

			var savedScheduledLocations = (this.model.scheduledLocations || []).map(function (sl) {
				return {
					id: sl.id,
					vaultDate: _moment2.default.utc(sl.vaultDate).format('YYYY-MM-DD'),
					routeId: sl.routeId,
					sequence: sl.sequence,
					route: {
						Key: sl.route ? sl.route.name : null,
						Value: sl.route ? sl.route.id : null
					},
					locationId: sl.locationId,
					createdAt: sl.createdAt,
					updatedAt: sl.updatedAt
				};
			});

			// if (this.model.recurringStops.length && ['TRUCK', 'INTERNAL', 'TANKER', 'WINDOW', 'CARRIER'].indexOf(this.model._type) === -1) {
			// const recurringStops = [];
			// this.model.recurringStops.forEach((d) => {
			// 	d.anchorDate = moment(d.anchorDate).format('YYYY-MM-DD');
			// 	d.effectiveTillDate = d.effectiveTillDate ? moment(d.effectiveTillDate).format('YYYY-MM-DD') : null;
			// 	d.routeId = d.route.Value;
			// 	d.locationId = this.model.id;
			// 	delete d.route;
			// 	recurringStops.push(_.cloneDeep(d));
			// })

			var combinedRoutes = [];
			this.combinedRoutes.forEach(function (r) {
				if (r.route && r.sequence && r.anchorDate && r.interval) {
					combinedRoutes.push({
						id: r.id ? r.id : null,
						description: r.day.value + ' ' + (r.locationId ? r.locationId : _this18.model.id) + ' CombinedRoute',
						anchorDate: (0, _moment2.default)(r.anchorDate).format('YYYY-MM-DD'),
						interval: r.interval.interval,
						frequency: r.interval.frequency,
						effectiveTillDate: null,
						sequence: r.sequence,
						dayOfWeek: r.day.value,
						locationId: _this18.model.id,
						routeId: r.route.Value,
						route: r.route,
						nextOccurrence: r.nextOccurrence,
						locationScheduleRecurringLoadData: _this18.locationRecurringLoad.flatMap(function (d) {
							return d.locationScheduleRecurringDay === r.day.value ? (0, _entries2.default)(d.recurringLoad).map(function (_ref3) {
								var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
								    key = _ref4[0],
								    value = _ref4[1];

								return {
									id: value.id ? value.id : null,
									amount: value.amount,
									locationScheduleRecurringId: r.id,
									denominationId: key,
									dayOfWeek: r.day.value
								};
							}).sort(function (a, b) {
								return a.id - b.id;
							}) : [];
						})
					});
				}
			});

			// this.locationScheduleRecurringData.forEach(route => {
			// 	recurringStops.forEach(recurringStop => {
			// 		if (!_.isEqual(route, recurringStop) && recurringStop.id) {
			// 			recurringStop.status = 'Update';
			// 		}
			// 		else if (_.isEqual(route, recurringStop) && recurringStop.id) {
			// 			recurringStop.status = null;
			// 		}
			// 	})
			// })
			// }

			var savedData = {
				id: this.model.id,
				updatedAt: this.defaultModel.updatedAt,
				name: this.model.name,
				active: this.model.status,
				customerId: this.model.customer ? this.model.customer.Value : null,
				// customerContractId: this.model.contract ? this.model.contract.Value : null,
				branchId: this.model.defaultBranch,
				address: this.model._address || null,
				city: this.model._city || null,
				state: this.model._state,
				zip: this.model._zip || null,
				refNumber: this.model.refId ? this.model.refId : null,
				poc: this.model._poc || null,
				phone: this.model.pocPhone || null,
				email: this.model.pocEmail || null,
				routeNotificationDeliveries: this.model.RNdeliveries,
				routeNotificationPickups: this.model.RNpickups,
				routeNotificationNoPickup: this.model.RNnoPickup,
				routeNotificationZeroPickup: this.model.RNzeroPickup,
				defRouteMonId: this.model.Mon.routeId ? this.model.Mon.routeId.Value : null,
				// defRouteMonStop: this.model.Tue.stops,
				defRouteSeqMon: this.model.Mon.options || 1,
				defRouteTueId: this.model.Tue.routeId ? this.model.Tue.routeId.Value : null,
				// defRouteTueStop: this.model.Tue.stops,
				defRouteSeqTue: this.model.Tue.options || 1,
				defRouteWedId: this.model.Wed.routeId ? this.model.Wed.routeId.Value : null,
				// defRouteWedStop: this.model.Wed.stops,
				defRouteSeqWed: this.model.Wed.options || 1,
				defRouteThuId: this.model.Thu.routeId ? this.model.Thu.routeId.Value : null,
				// defRouteThuStop: this.model.Thu.stops,
				defRouteSeqThu: this.model.Thu.options || 1,
				defRouteFriId: this.model.Fri.routeId ? this.model.Fri.routeId.Value : null,
				// defRouteFriStop: this.model.Fri.stops,
				defRouteSeqFri: this.model.Fri.options || 1,
				defRouteSatId: this.model.Sat.routeId ? this.model.Sat.routeId.Value : null,
				// defRouteSatStop: this.model.Sat.stops,
				defRouteSeqSat: this.model.Sat.options || 1,
				defRouteSunId: this.model.Sun.routeId ? this.model.Sun.routeId.Value : null,
				// defRouteSunStop: this.model.Sun.stops,
				defRouteSeqSun: this.model.Sun.options || 1,
				defRouteHolId: this.model.Hol.routeId ? this.model.Hol.routeId.Value : null,
				// defRouteHolStop: this.model.Hol.stops,
				defRouteSeqHol: this.model.Hol.options || 1,
				// seasonStart: this.model.seasonStart,
				// seasonEnd: this.model.seasonEnd,
				seasonStart: this.model.seasonStart ? this.effDate : null,
				seasonEnd: this.model.seasonEnd ? this.expDate : null,
				// deliveryBackoutTimes: this.model.deliveryBackoutTimes,
				deliverBagOutPiece: this.model.deliverBagOutPiece,
				individualBagout: this.model.individualBagout,
				centralBank: this.model.centralBank,
				openTime: this.model.startTime ? (0, _moment2.default)(this.model.startTime).format('HH:mm:ss') : null,
				closeTime: this.model.endTime ? (0, _moment2.default)(this.model.endTime).format('HH:mm:ss') : null,
				deliveryLoc1Id: this.model.deliveryLoc1 || null,
				deliveryLoc2Id: this.model.deliveryLoc2 || null,
				deliveryLocCoinId: this.model.deliveryLocCoin || null,
				deliveryLocCodId: this.model.deliveryLocCod || null,
				locationType: this.model._type,
				keyNum: this.model.keyId || null,
				maxDepositAmount: this.model.maxDepositAmount,
				decimalCash: this.model.roundedDeposits,
				codPickup: this.model.codAllow,
				allowMulti: this.model.allowMulti,
				scanLeaveLocation: this.model._leave,
				scanLastTransaction: this.model.lastTransaction,
				verifyToTruck: ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(this.model._type) > -1 ? this.model.verifyToTruck : false,
				verifyCoinToTruck: ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(this.model._type) > -1 && this.model.verifyToTruck ? this.model.verifyCoinToTruck : false,
				scanATMCassette: this.model._type === 'ATM' ? this.model.atmCassette : false,
				maxCassettes: this.model._type === 'ATM' && this.model.atmCassette ? parseInt(this.model.maxCassettes, 10) : null,
				packCoinSeparately: !!this.model.packCoinSeparately,
				captureDenomStc: this.model._type === 'ATM' ? !!this.model.captureDenomStc : false,
				monthlyCashCountLimit: !!this.model.monthlyCashCountLimit,
				monthlyCashCountLimitAmount: this.model.monthlyCashCountLimitAmount,
				noPrintDelivery: !this.model.TRdeliveries,
				noPrintPickup: !this.model.TRpickups,
				lat: this.model.latitude,
				long: this.model.longitude,
				deliveryToLocation: this.model.deliveryToLocation || [],
				lockType: this.model.lockType,
				comments: this.model.comments || null,
				OTCCompanyName: this.model.OTCCompanyName || null,
				stopProcess: this.model.stopProcess || null,
				openTimeSun: this.model.openTimeSun ? (0, _moment2.default)(this.model.openTimeSun).format('HH:mm:00') : null,
				closeTimeSun: this.model.closeTimeSun ? (0, _moment2.default)(this.model.closeTimeSun).format('HH:mm:00') : null,
				openTimeMon: this.model.openTimeMon ? (0, _moment2.default)(this.model.openTimeMon).format('HH:mm:00') : null,
				closeTimeMon: this.model.closeTimeMon ? (0, _moment2.default)(this.model.closeTimeMon).format('HH:mm:00') : null,
				openTimeTue: this.model.openTimeTue ? (0, _moment2.default)(this.model.openTimeTue).format('HH:mm:00') : null,
				closeTimeTue: this.model.closeTimeTue ? (0, _moment2.default)(this.model.closeTimeTue).format('HH:mm:00') : null,
				openTimeWed: this.model.openTimeWed ? (0, _moment2.default)(this.model.openTimeWed).format('HH:mm:00') : null,
				closeTimeWed: this.model.closeTimeWed ? (0, _moment2.default)(this.model.closeTimeWed).format('HH:mm:00') : null,
				openTimeThu: this.model.openTimeThu ? (0, _moment2.default)(this.model.openTimeThu).format('HH:mm:00') : null,
				closeTimeThu: this.model.closeTimeThu ? (0, _moment2.default)(this.model.closeTimeThu).format('HH:mm:00') : null,
				openTimeFri: this.model.openTimeFri ? (0, _moment2.default)(this.model.openTimeFri).format('HH:mm:00') : null,
				closeTimeFri: this.model.closeTimeFri ? (0, _moment2.default)(this.model.closeTimeFri).format('HH:mm:00') : null,
				openTimeSat: this.model.openTimeSat ? (0, _moment2.default)(this.model.openTimeSat).format('HH:mm:00') : null,
				closeTimeSat: this.model.closeTimeSat ? (0, _moment2.default)(this.model.closeTimeSat).format('HH:mm:00') : null,
				openTimeHoliday: this.model.openTimeHoliday ? (0, _moment2.default)(this.model.openTimeHoliday).format('HH:mm:00') : null,
				closeTimeHoliday: this.model.closeTimeHoliday ? (0, _moment2.default)(this.model.closeTimeHoliday).format('HH:mm:00') : null,
				ATMTransfer: this.model.ATMTransfer,
				OTCGeoFence: this.model.OTCGeoFence,
				closeReq: this.model.closeReq,
				closeEndOfStop: this.model.stopProcess === 'L' && this.model.closeEndOfStop,
				newLocationAddress: this.newLocationAddress,
				previousLocationAddress: this.previousLocationAddress,
				isLocationAddressChanged: this.isLocationAddressChanged,
				newAssignedRoutes: this.newAssignedRoutes,
				previouslyAssignedRoutes: this.previouslyAssignedRoutes,
				isRouteAssignmentChanged: this.isRouteAssignmentChanged,
				zoneRouting: this.model.zoneRouting,
				stopPriority: ['REGULAR', 'ATM', 'ON_CALL', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO'].indexOf(this.model._type) > -1 ? this.model.stopPriority : null,
				model: this.model._type === 'ATM' ? this.model.model : null,
				serialNumber: this.model._type === 'ATM' ? this.model.serialNumber : null,
				staticOpenCode: this.model.lockType === 'static' ? this.model.staticOpenCode : null,
				vaultDate: this.DateUtil.getUTCDate(this.model.setupDetails.currentVaultDate),
				userId: this.model.loggedInUser,
				secondaryLock: this.model.secondaryLock,
				secondaryLockId: this.model.secondaryLock ? this.model.secondaryLockId : null,
				secondaryLockType: this.model.secondaryLock ? this.model.secondaryLockType : null,
				secondaryLockOTCCompanyName: this.model.secondaryLock ? this.model.secondaryLockOTCCompanyName : null,
				secondaryLockCloseReq: this.model.secondaryLockType !== 'static' && this.model.secondaryLock ? this.model.secondaryLockCloseReq : false,
				secondaryLockAutoOpen: this.model.secondaryLockType !== 'static' && this.model.secondaryLock ? this.model.secondaryLockAutoOpen : false,
				secondaryLockStaticOpenCode: this.model.secondaryLock && this.model.secondaryLockType == 'static' ? this.model.secondaryLockStaticOpenCode : null,
				enableOrderProfile: this.model.enableOrderProfile,
				branchFundingSourceId: this.model.enableOrderProfile ? this.model.fundingSourceObj.selectedFundingSource.Value : null,
				branchFundingSourceOrderProfileId: this.model.enableOrderProfile ? this.model.orderProfileObj.selectedOrderProfile.Value : null,
				atmOrderProfileId: this.orderProfile ? this.orderProfile.id : null,
				handleAtmLikeRegular: this.model.handleAtmLikeRegularLocationType.includes(this.model._type) ? this.model.handleAtmLikeRegular : false,
				idBatchImport: this.model.idBatchImport || null,
				idBagoutExport: this.model.idBagoutExport || null,
				idBagoutDepositExport: this.model.idBagoutDepositExport || null,
				idOTCLock: this.model.idOTCLock || null,
				scheduledLocations: this.model.scheduledLocations,
				deleteScheduledLocationIds: this.model.deleteScheduledLocationIds,
				NFCLock: this.model.lockType === 'witz' || this.model.lockType === 'TDS' ? this.model.NFCLock : false,
				country: this.model.isNonUSLocation ? this.model.country : 'US',
				NFCScan: this.model.NFCScan,
				NFCTagId: this.model.NFCScan ? this.model.NFCTagId : null,
				distanceFromBranch: this.model.distanceFromBranch,
				travelTimeToBranch: this.model.travelTimeToBranch,
				costCenterId: this.model.costCenter ? this.model.costCenter.Value : null,
				locationZoneIds: this.buildLocationZoneIdsForSave(),
				customerCostCenterId: this.model.customerCostCenter ? this.model.customerCostCenter.Value : null,
				accountNumber: this.model.accountNumber ? this.model.accountNumber.trim() : null,
				// recurringStops,
				deletedRecurringStops: this.model.deletedRecurringStops,
				make: this.parseMakeValues(this.model.make),
				machineOwner: this.model.machineOwner,
				bankSourceId: this.model.bankSourceId ? this.model.bankSourceId.Value : null,
				FLMProvider: this.model.FLMProvider,
				SLMProvider: this.model.SLMProvider,
				bankWeek: this.model.bankWeek ? this.model.bankWeek : null,
				optional1: this.model.optional1,
				optional2: this.model.optional2,
				optional3: this.model.optional3,
				frequency: this.model.frequencyOptions,
				dayOfWeek: this.model.dayOfWeekOptions,
				combinedRoutes: combinedRoutes,
				defRecurringRouteHolId: this.combinedRoutes[7].route ? this.combinedRoutes[7].route.Value : null,
				locationDistanceId: this.model.locationDistanceId ? this.model.locationDistanceId : null,
				contractExpirationDate: this.model.contractExpirationDate ? (0, _moment2.default)(this.model.contractExpirationDate).format('YYYY-MM-DD') : null,
				// locationDenomination: this.model.selectedDenomination && this.model._type === 'ATM' ? this.model.selectedDenomination : null,
				locationDenomination: SavedDenominations && ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO'].includes(this.model._type) ? SavedDenominations : [],
				forecastingStrategy: this.model.bankSourceId && this.model.bankSourceId.atmForecasting === true ? this.model.forecastingStrategy : 'DISABLED',
				liabilityThreshold: this.model.bankSourceId && this.model.bankSourceId.atmForecasting === true ? this.model.liabilityThreshold ? this.model.liabilityThreshold : null : null,
				securityThreshold: this.model.bankSourceId && this.model.bankSourceId.atmForecasting === true ? this.model.securityThreshold ? this.model.securityThreshold : null : null,
				atmEmptyAtCalculationMethod: this.model.atmEmptyAtCalculationMethod ? this.model.atmEmptyAtCalculationMethod : 'PERCENT_CHANGE',
				aecPercentChangeValue: this.model.aecPercentChangeValue ? this.convertStr(this.model.aecPercentChangeValue) : 0.5,
				aecPercentChangePeriodA: this.model.aecPercentChangePeriodA ? this.model.aecPercentChangePeriodA : '30D',
				aecPercentChangePeriodB: this.model.aecPercentChangePeriodB ? this.model.aecPercentChangePeriodB : '15D',
				aecWeightedAvgWeightA: this.model.aecWeightedAvgWeightA ? this.model.aecWeightedAvgWeightA : 0.75,
				aecWeightedAvgPeriodA: this.model.aecWeightedAvgPeriodA ? this.model.aecWeightedAvgPeriodA : '30D',
				aecWeightedAvgWeightB: this.model.aecWeightedAvgWeightB ? this.model.aecWeightedAvgWeightB : 0.35,
				aecWeightedAvgPeriodB: this.model.aecWeightedAvgPeriodB ? this.model.aecWeightedAvgPeriodB : '15D',
				aecSinglePeriod: this.model.aecSinglePeriod ? this.model.aecSinglePeriod : '30D',
				locationBranches: this.branch.filter(function (b) {
					return b.ticked;
				}).map(function (c) {
					return c.branchId;
				}),
				locationScheduleRecurringData: combinedRoutes,
				locationBalanceActive: this.model.locationBalanceActive,
				addSwapRatio: this.model.addToSwapRatio,
				deletedLocationDenominationIds: this.deletedLocationDenominationIds,
				deliveryCutOff: this.model.deliveryCutOff,
				deliveryCutOffTime: this.model.deliveryCutOff && this.model.deliveryCutOffTime ? (0, _moment2.default)(this.model.deliveryCutOffTime).format('HH:mm:ss') : null,
				lastRouteStop: this.model._type === 'DELIVERY' ? this.model.lastRouteStop : false,
				targetStopTime: this.model.targetStopTime ? (0, _moment2.default)(this.model.targetStopTime).format('HH:mm:ss') : null,
				printDeliveryManifest: this.model.printDeliveryManifest,
				balanceType: this.model.balanceType,
				forecastingFlowDirection: this.model.forecastingFlowDirection,
				flowThreshold: this.model.flowThreshold && this.model.balanceType == 'PERCENTAGE' ? this.convertStr(this.model.flowThreshold) / 100 : this.model.flowThreshold,
				podReceipt: this.model.podReceipt,
				locationSlots: this.model.locationSlots,
				sendManifestOnDelivery: this.model.sendManifestOnDelivery ? this.model.sendManifestOnDelivery : false,
				manifestType: this.model.sendManifestOnDelivery ? this.model.manifestType : null,
				manifestRecipientEmail: this.model.sendManifestOnDelivery ? this.model.manifestRecipientEmail : null,
				zeroAmountPickupRecipientEmail: this.model.sendManifestOnDelivery ? this.model.zeroAmountPickupRecipientEmail : null,
				manifestFileType: this.model.sendManifestOnDelivery ? this.model.manifestFileType : null,
				pickupSLA: this.model.pickupSLA,
				pickupSLATime: this.model.pickupSLA ? this.model.pickupSLATime : null,
				autoRerouteMissed: this.model.autoRerouteMissed,
				packResidual: this.model._type === 'ATM' ? this.model.packResidual : false,
				coinPermitted: this.model._type === 'ATM' ? this.model.coinPermitted : false,
				bagoutEnabled: ['BANK', 'DELIVERY'].includes(this.model._type) ? this.model.bagoutEnabled : false,
				bulkTransfer: ['TANKER', 'TRUCK', 'INTERNAL'].includes(this.model._type) ? this.model.bulkTransfer : false,
				isTransferHoldLocation: this.model._type === 'INTERNAL' ? this.model.isTransferHoldLocation : false,
				fallbackFillRate: this.model.fallbackFillRate,
				preventativeMaintenanceId: ['ATM', 'ON_CALL'].includes(this.model._type) && this.model.preventativeMaintenanceId ? this.model.preventativeMaintenanceId.Value : null
			};

			var hasDenominationChanges = !_lodash2.default.isEqual(this.DefaultDenominations, SavedDenominations) || this.DefaultDenominations.length !== SavedDenominations.length;
			if (hasDenominationChanges) {
				// Include changes in `savedData.changedObj`
				savedData.changedObj = (0, _extends3.default)({}, savedData.changedObj, {
					locationDenomination: {
						"Old Value": this.DefaultDenominations,
						"Updated Value": SavedDenominations
					}
				}, this.findDifferencesWithReturn(this.defaultModel, savedData));
			} else {
				savedData.changedObj = (0, _extends3.default)({}, savedData.changedObj, this.findDifferencesWithReturn(this.defaultModel, savedData));
			}

			var hasRecurringDataChanges = !_lodash2.default.isEqual(_lodash2.default.sortBy(this.defaultModel.locationScheduleRecurringData, 'id'), _lodash2.default.sortBy(savedData.locationScheduleRecurringData, 'id')) || this.defaultModel.locationScheduleRecurringData.length !== savedData.locationScheduleRecurringData.length;

			if (hasRecurringDataChanges) {
				savedData.changedObj = (0, _extends3.default)({}, savedData.changedObj, {
					locationScheduleRecurringData: {
						"Old Value": this.defaultModel.locationScheduleRecurringData,
						"Updated Value": savedData.locationScheduleRecurringData
					}
				}, this.findDifferencesWithReturn(this.defaultModel, savedData));
			} else {
				savedData.changedObj = (0, _extends3.default)({}, savedData.changedObj, this.findDifferencesWithReturn(this.defaultModel, savedData));
			}

			var hasScheduledLocationchanges = !_lodash2.default.isEqual(this.scheduledLocations, savedScheduledLocations) || this.scheduledLocations.length !== savedScheduledLocations.length;

			if (hasScheduledLocationchanges) {
				savedData.changedObj = (0, _extends3.default)({}, savedData.changedObj, {
					scheduledLocations: {
						"Old Value": this.scheduledLocations,
						"Updated Value": savedScheduledLocations
					}
				}, this.findDifferencesWithReturn(this.defaultModel, savedData));
			} else {
				savedData.changedObj = (0, _extends3.default)({}, savedData.changedObj, this.findDifferencesWithReturn(this.defaultModel, savedData));
			}

			promise = promise.then(function () {
				return _this18.Service.update(_this18.rawId, savedData);
			}).then(function (data) {
				_this18.loading = false;
				window.history.length <= 1 ? _this18.$state.go('location.all', { page: 1 }, { reload: true }) : window.history.go(-1);
			}).then(function () {
				_this18.updateLocationBranch();
			}).catch(function (err) {
				_this18.loading = false;

				if (err && err.status === 409) {
					_this18.Modal.confirm({
						header: 'Warning',
						message: 'This location has been updated by another user since you opened this page. Please reload the page to view the latest changes before saving.',
						type: 'warning',
						buttons: ['common.ok']
					});
					return;
				}

				var errorPath = err && err.data && err.data.errors && err.data.errors[0].path;

				if (errorPath === 'LOCATION.NFCTagId') {
					_this18.errorMessage = _this18.$translate.instant('common.unique_nfc_tag_id');
				} else if (errorPath === "LOCATION.refNumber") {
					_this18.errorMessage = _this18.$translate.instant('location.refNumberUnique');
				} else if (err && err.data && err.data.errors) {
					err.data.errors.map(function (e) {
						_this18.errorMessage = e.message + '<br/>';
					});
				} else {
					_this18.errorMessage = err && err.data && err.data.message ? err.data.message : err;
				}
				_this18.Modal.errorModal(_this18.errorMessage);
			});
			// })
		}
	}, {
		key: 'findDifferencesWithReturn',
		value: function findDifferencesWithReturn(objA, objB) {
			function compareObjects(obj1, obj2) {
				var diff = {};

				for (var key in obj1) {
					if (obj1.hasOwnProperty(key)) {

						if (['locationDenomination', 'locationScheduleRecurringData', 'scheduledLocations'].includes(key)) {
							continue; // Skip these keys
						}

						if ((0, _typeof3.default)(obj1[key]) === 'object' && obj1[key] !== null && obj2[key] !== null) {
							if (Array.isArray(obj1[key])) {
								if ((0, _stringify2.default)(obj1[key]) !== (0, _stringify2.default)(obj2[key])) {
									diff[key] = {
										"Old Value": obj1[key],
										"Updated Value": obj2[key]
									};
								}
							} else if (obj2[key] !== undefined && obj1[key] !== undefined) {
								var nestedDiff = compareObjects(obj1[key], obj2[key]);
								if ((0, _keys2.default)(nestedDiff).length > 0) {
									diff[key] = nestedDiff;
								}
							}
						} else if (obj1[key] !== obj2[key] && obj2[key] !== undefined && obj1[key] !== undefined) {
							if (key === 'status') {
								diff[key] = {
									"Old Value": obj1[key] ? "Active" : "Suspended",
									"Updated Value": obj2[key] ? "Active" : "Suspended"
								};
							} else {
								diff[key] = {
									"Old Value": obj1[key],
									"Updated Value": obj2[key]
								};
							}
						}
					}
				}
				return diff;
			}
			return compareObjects(objA, objB);
		}

		// update branch group for location 

	}, {
		key: 'updateLocationBranch',
		value: function updateLocationBranch() {
			this.branches = this.model.branch.map(function (branchObj) {
				return branchObj.branchId;
			});
			this.LocationBranchService.updateLocationBranchGroup({
				locationId: this.model.id,
				branches: this.branches
			}).then(function (res) {}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'askToChange',
		value: function askToChange() {
			var _this19 = this;

			if (!this.model.status) {
				this.model.status = !this.model.status;
				this.Modal.confirm({
					header: this.$translate.instant(this.pageName + '.suspend_' + this.pageName),
					message: this.$translate.instant(this.pageName + '.suspend_' + this.pageName + '_message'),
					callback: function callback(_ref5) {
						var modal = _ref5.modal,
						    $scope = _ref5.$scope;

						_this19.model.status = !_this19.model.status;
						modal.close();
					},
					negative: function negative(_ref6) {
						var modal = _ref6.modal,
						    $scope = _ref6.$scope;

						modal.close();
					},
					type: 'danger',
					buttons: ['common.yes', 'common.no']
				});
			}
		}
	}, {
		key: 'autoDetect',
		value: function autoDetect() {
			var _this20 = this;

			if (!this.render) return _promise2.default.resolve();

			var address = '';

			if (this.model._address) address += this.model._address + ", ";
			if (this.model._city) address += this.model._city + ", ";
			if (this.model._state) address += this.model._state + ", ";
			if (this.model._zip) address += this.model._zip;

			this.model.updatingDrivingDistance = true;
			this.findLocationAddressChange();

			if (['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf(this.model._type) > -1 && this.maintainDriveDistance && (this.isLocationAddressChanged || !this.model.distanceFromBranch && !this.model.travelTimeToBranch) && this.model.status) {

				return this.Service.getLocationDrivingDistance(address, this.formatAddress(this.model.setupDetails)).then(function (data) {
					if (data.status) {
						if (_lodash2.default.isEmpty(data.results)) {
							return _promise2.default.reject('location.invalidAddress');
						} else if (data.results.status === 'NOT_FOUND') {
							return _promise2.default.reject('location.not_found');
						} else if (data.results.status === 'ZERO_RESULTS') {
							return _promise2.default.reject('location.zero_results');
						} else {
							_this20.model.distanceFromBranch = data.results.distance.text;
							_this20.model.travelTimeToBranch = data.results.duration.text;
							_this20.model.locationDistance = data.results.locationDistance ? data.results.locationDistance.label : '';
							_this20.model.locationDistanceId = data.results.locationDistance ? data.results.locationDistance.id : '';
							return _this20.locationGeoCodes(address);
						}
					} else return _promise2.default.reject(data.errorMessage);
				}).catch(function (err) {
					// this.Modal.errorModal(err);
					return _promise2.default.reject(err);
				}).finally(function () {
					_this20.model.updatingDrivingDistance = false;
				});
			} else {
				this.model.updatingDrivingDistance = false;
				return this.locationGeoCodes(address);
			}
		}
	}, {
		key: 'locationGeoCodes',
		value: function locationGeoCodes(address) {
			var _this21 = this;

			if (!address) return;
			var geocoder = new google.maps.Geocoder();
			var results = geocoder.geocode({ 'address': address });
			if (!results || results.length == 0) return;else if (address == '') {
				this.Modal.errorModal('location.invalidAddress');
				this.loading = false;
				return;
			}

			return geocoder.geocode({ 'address': address }, function (results, status) {
				if (status === 'OK') {
					var latitude = results[0].geometry.location.lat();
					var longitude = results[0].geometry.location.lng();
					_this21.setMarkerPosition(latitude, longitude);
					_this21.$scope.$apply();
				} else if (status === 'NOT_FOUND') {
					_this21.loading = false;
					_this21.Modal.errorModal('location.not_found');
				} else if (status === 'ZERO_RESULTS') {
					_this21.loading = false;
					_this21.Modal.errorModal('location.zero_results');
				} else {
					_this21.Modal.errorModal('location.invalidAddress');
					_this21.loading = false;
				}
			});
		}
	}, {
		key: 'getAddressFromLatLng',
		value: function getAddressFromLatLng(lat, lng) {
			var _this22 = this;

			var defer = this.$q.defer();

			if (!lat || !lng) {
				this.loading = false;
				return defer.resolve();
			}

			var geocoder = new google.maps.Geocoder();
			var latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

			geocoder.geocode({ location: latlng }, function (results, status) {
				if (status === 'OK' && results && results.length > 0) {
					var result = results[0];
					var addressComponents = result.address_components;

					var locationData = {
						address: '',
						city: '',
						country: '',
						state: '',
						zip: ''
					};

					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = (0, _getIterator3.default)(addressComponents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var component = _step.value;

							var types = component.types;
							var locAddress = null;
							if (types.length === 0) locAddress = component.long_name;else if (types.includes('street_number')) locAddress = component.short_name;else if (types.includes('route')) locAddress = component.long_name;

							if (locAddress) {
								locationData.address = [locationData.address, locAddress].filter(Boolean).join(' ');
							}

							if (types.includes('locality')) {
								locationData.city = component.long_name;
							}
							if (types.includes('country')) {
								locationData.country = component.long_name;
							}
							if (types.includes('administrative_area_level_1')) {
								locationData.state = component.long_name;
							}
							if (types.includes('postal_code')) {
								locationData.zip = component.long_name;
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}

					_this22.model._address = locationData.address;
					_this22.model._city = locationData.city;
					_this22.model.country = locationData.country;
					_this22.model._zip = locationData.zip;

					if (_this22.model.isNonUSLocation) {
						_this22.model._state = locationData.state;
					} else {
						var matchedState = _this22.states.find(function (state) {
							return state.label.toLowerCase() === locationData.state.toLowerCase();
						});
						_this22.model._state = matchedState ? matchedState.value : '';
					}

					_this22.loading = false;
					_this22.$scope.$apply();

					return defer.resolve(locationData);
				} else if (status === 'ZERO_RESULTS' || status === 'NOT_FOUND') {
					_this22.loading = false;
					_this22.Modal.errorModal('location.not_found');
					return defer.reject('No results found');
				} else {
					_this22.loading = false;
					_this22.Modal.errorModal('location.invalidAddress');
					return defer.reject('Geocoder failed: ' + status);
				}
			});

			return defer.promise;
		}
	}, {
		key: 'setMarkerPosition',
		value: function setMarkerPosition(lat, lng) {
			var _this23 = this;

			var self = this;
			if (!lat && !lng) {
				var lat = document.getElementById("lat").value;
				var lng = document.getElementById("lng").value;
			} else {
				if (lat && lng) {
					this.getAddressFromLatLng(lat, lng);
				}
				document.getElementById("lat").value = lat;
				document.getElementById("lng").value = lng;
				self.model.latitude = document.getElementById("lat").value;
				self.model.longitude = document.getElementById("lng").value;
			}

			var oldMarker;

			var latlng = new google.maps.LatLng(lat, lng);

			var options = { zoom: 16, center: latlng, mapTypeId: google.maps.MapTypeId.ROADMAP };

			var map = new google.maps.Map(document.getElementById("map"), options);

			oldMarker = new google.maps.Marker({ position: latlng, map: map, draggable: true });

			google.maps.event.addListener(oldMarker, "dragend", function (event) {
				var dragLat = event.latLng.lat();
				var dragLng = event.latLng.lng();
				if (dragLat && dragLng) {
					_this23.getAddressFromLatLng(dragLat, dragLng);
				}
				document.getElementById("lat").value = dragLat;
				document.getElementById("lng").value = dragLng;
				self.model.latitude = dragLat;
				self.model.longitude = dragLng;
				self.$scope.$apply();
			});

			google.maps.event.addListener(map, "click", function (event) {
				// get lat/long of click
				var clickLat = event.latLng.lat();
				var clickLong = event.latLng.lng();
				if (clickLat && clickLong) {
					_this23.getAddressFromLatLng(clickLat, clickLong);
				}
				// show in input box
				document.getElementById("lat").value = clickLat;
				document.getElementById("lng").value = clickLong;

				self.model.latitude = clickLat;
				self.model.longitude = clickLong;

				var marker = new google.maps.Marker({ position: new google.maps.LatLng(clickLat, clickLong), map: map, draggable: true });

				if (oldMarker != undefined) {
					oldMarker.setMap(null);
				}
				oldMarker = marker;

				google.maps.event.addListener(marker, "dragend", function (event) {
					var dragLat = event.latLng.lat();
					var dragLng = event.latLng.lng();
					if (dragLat && dragLng) {
						_this23.getAddressFromLatLng(dragLat, dragLng);
					}
					document.getElementById("lat").value = dragLat;
					document.getElementById("lng").value = dragLng;
					self.model.latitude = dragLat;
					self.model.longitude = dragLng;
					self.$scope.$apply();
				});
			});

			if (this.maintainDriveDistance) {
				this.marker = new google.maps.Marker({
					position: new google.maps.LatLng(this.model.setupDetails.gpsLat, this.model.setupDetails.gpsLong),
					map: map,
					label: {
						text: 'B',
						color: 'white',
						fontWeight: 'bold'
					}
				});

				var branchInfoPopup = new google.maps.InfoWindow({
					content: '\n\t\t\t\t<h6>Branch Address</h6>\n\t\t\t\t<p>' + this.model.setupDetails.address + ', ' + this.model.setupDetails.city + ', \n\t\t\t\t   ' + this.model.setupDetails.state + ', ' + this.model.setupDetails.zip + '</p>\n\t\t\t'
				});

				this.marker.addListener('click', function () {
					branchInfoPopup.open({
						anchor: _this23.marker,
						map: map
					});
				});
			}
		}
	}, {
		key: 'branchLocation',
		value: function branchLocation() {
			var _this24 = this;

			var branchLocation = this.model.setupDetails,
			    mapElement = document.getElementById('map'),
			    locationLatitude = document.getElementById("lat").value,
			    locationLongitude = document.getElementById("lng").value;

			var map = new google.maps.Map(mapElement, {
				zoom: 16,
				center: new google.maps.LatLng(locationLatitude, locationLongitude),
				mapTypeId: google.maps.MapTypeId.ROADMAP
			});

			var branchInfoPopup = new google.maps.InfoWindow({
				content: '\n\t\t\t\t<h6>Branch Address</h6>\n\t\t\t\t<p>' + this.model.setupDetails.address + ', ' + this.model.setupDetails.city + ', \n\t\t\t\t   ' + this.model.setupDetails.state + ', ' + this.model.setupDetails.zip + '</p>\n\t\t\t'
			});

			new google.maps.Marker({
				position: new google.maps.LatLng(locationLatitude, locationLongitude),
				map: map
			});

			this.marker = new google.maps.Marker({
				position: new google.maps.LatLng(branchLocation.gpsLat, branchLocation.gpsLong),
				map: map,
				label: {
					text: 'B',
					color: 'white',
					fontWeight: 'bold'
				}
			});

			this.marker.addListener('click', function () {
				branchInfoPopup.open({
					anchor: _this24.marker,
					map: map
				});
			});
		}
	}, {
		key: 'resetSeason',
		value: function resetSeason() {
			this.model.seasonStart = null;
			this.model.seasonEnd = null;
		}
	}, {
		key: 'allowStopProcess',
		value: function allowStopProcess() {
			this.showStopProcess = ['TANKER', 'TRUCK', 'WINDOW', 'CARRIER', 'LOCKER'].indexOf(this.model._type) === -1;
			if (!this.showStopProcess) this.model.stopProcess = null;
		}
	}, {
		key: 'loadConfigs',
		value: function loadConfigs() {
			var _this25 = this;

			this.Configs.getConfigs().then(function (data) {
				_this25.googleMapConfig = data.googleMap;
				_this25.maintainDriveDistance = data.maintainDriveDistance;
				_this25.apiKey = '//maps.google.com/maps/api/js?key=' + _this25.googleMapConfig.key + '&libraries=places';
				setTimeout(function () {
					_this25.render = true;
				}, 100);
				setTimeout(function () {
					if (_this25.maintainDriveDistance) _this25.branchLocation();
				}, 1000);
				return data;
			}).then(function (data) {
				_this25.companyMapping(data.otcCompanyList);
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'sameOperationTime',
		value: function sameOperationTime() {
			var _this26 = this;

			this.contractDays = [];
			this.operationDays.forEach(function (data) {
				_this26.contractDays[data.value] = true;
			});

			if (this.model.isSameOperationTime) {
				for (var day in this.contractDays) {
					if (this.contractDays[day]) {
						this.model[this.openTime + day] = '';
						this.model[this.closeTime + day] = '';
					}
				}
			}
		}
	}, {
		key: 'updateTime',
		value: function updateTime(selectedDay) {
			if (this.model.isSameOperationTime) {
				if (this.contractDays[selectedDay]) {
					for (var day in this.contractDays) {
						if (this.contractDays[day]) {
							this.model[this.openTime + day] = this.model[this.openTime + selectedDay];
							this.model[this.closeTime + day] = this.model[this.closeTime + selectedDay];
						}
					}
				}
			}
		}
	}, {
		key: 'companyMapping',
		value: function companyMapping(data) {
			this.OTCCompanyNameList = this.CommonLayoutService.OTCCompanyMapping(data);
		}
	}, {
		key: 'getSetupDetails',
		value: function getSetupDetails() {
			var _this27 = this;

			if (!this.model.defaultBranch) {
				return this.model.setupDetails = "";
			}
			this.SetupService.get(this.model.defaultBranch).then(function (data) {
				_this27.model.setupDetails = data;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'findLocationAddressChange',
		value: function findLocationAddressChange() {
			this.locationAddressUpdateObj = {
				address: this.model._address,
				city: this.model._city,
				state: this.model._state,
				zip: this.model._zip
			};

			var newLocationAddress = this.findDifference(this.locationAddressUpdateObj, this.currentLocationAddressObj);
			var previousLocationAddress = this.findDifference(this.currentLocationAddressObj, this.locationAddressUpdateObj);
			if (!_lodash2.default.isEmpty(newLocationAddress) && !_lodash2.default.isEmpty(previousLocationAddress)) this.isLocationAddressChanged = true;

			this.newLocationAddress = this.formatLocationAddress(newLocationAddress);
			this.previousLocationAddress = this.formatLocationAddress(previousLocationAddress);
		}
	}, {
		key: 'findDifference',
		value: function findDifference(object, base) {
			var _this28 = this;

			return _lodash2.default.transform(object, function (result, value, key) {
				if (!_lodash2.default.isEqual(value, base[key])) {
					result[key] = _lodash2.default.isObject(value) && _lodash2.default.isObject(base[key]) ? _this28.findDifference(value, base[key]) : value;
				}
			});
		}
	}, {
		key: 'formatLocationAddress',
		value: function formatLocationAddress(obj) {
			var locationAddress = '';
			if (obj.address) {
				locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.address);
			}
			if (obj.city) {
				locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.city);
			}
			if (obj.state) {
				locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.state);
			}
			if (obj.zip) {
				locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.zip);
			}
			return locationAddress;
		}
	}, {
		key: 'findRouteAssignmentChange',
		value: function findRouteAssignmentChange() {
			var _this29 = this;

			// TODO: better solution for this
			this.isRouteAssignmentUpdate = false;
			this.updatedAssignedRoutes = {};
			this.assignedRoutes = [];

			this.days.forEach(function (day, index) {
				if (_this29.model[day.value].routeId) (0, _assign2.default)(_this29.updatedAssignedRoutes, new Object((0, _defineProperty3.default)({}, day.value, _this29.model[day.value].routeId.Value)));
			});

			this.previouslyAssignedRoutes = this.findDifference(this.currentlyAssignedRoutes, this.updatedAssignedRoutes);
			this.newAssignedRoutes = this.findDifference(this.updatedAssignedRoutes, this.currentlyAssignedRoutes);
			this.isRouteAssignmentUpdate = !_lodash2.default.isEmpty(this.previouslyAssignedRoutes) || !_lodash2.default.isEmpty(this.newAssignedRoutes);

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(this.newAssignedRoutes)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
					    newKey = _step2$value[0],
					    newValue = _step2$value[1];

					if (this.previouslyAssignedRoutes[newKey] === undefined) {
						this.assignedRoutes.push({ key: 'defRoute' + [newKey] + 'Id', value: newValue });
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = (0, _getIterator3.default)((0, _entries2.default)(this.previouslyAssignedRoutes)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
					    oldKey = _step3$value[0],
					    oldValue = _step3$value[1];

					if (this.newAssignedRoutes[oldKey] === undefined) {
						this.assignedRoutes.push({ key: 'defRoute' + [oldKey] + 'Id', value: null });
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = (0, _getIterator3.default)((0, _entries2.default)(this.previouslyAssignedRoutes)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
					    oldKey = _step4$value[0],
					    oldValue = _step4$value[1];

					var _iteratorNormalCompletion7 = true;
					var _didIteratorError7 = false;
					var _iteratorError7 = undefined;

					try {
						for (var _iterator7 = (0, _getIterator3.default)((0, _entries2.default)(this.newAssignedRoutes)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
							var _step7$value = (0, _slicedToArray3.default)(_step7.value, 2),
							    newKey = _step7$value[0],
							    newValue = _step7$value[1];

							if (oldKey === newKey && this.previouslyAssignedRoutes[oldKey] != this.newAssignedRoutes[newKey]) {
								this.assignedRoutes.push({ key: 'defRoute' + [newKey] + 'Id', value: newValue });
							}
						}
					} catch (err) {
						_didIteratorError7 = true;
						_iteratorError7 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion7 && _iterator7.return) {
								_iterator7.return();
							}
						} finally {
							if (_didIteratorError7) {
								throw _iteratorError7;
							}
						}
					}
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = (0, _getIterator3.default)((0, _entries2.default)(this.newAssignedRoutes)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var _step5$value = (0, _slicedToArray3.default)(_step5.value, 2),
					    newKey = _step5$value[0],
					    newValue = _step5$value[1];

					(0, _assign2.default)(this.newAssignedRoutes, new Object((0, _defineProperty3.default)({}, newKey, newValue + ' | ' + newKey)));
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}

			var _iteratorNormalCompletion6 = true;
			var _didIteratorError6 = false;
			var _iteratorError6 = undefined;

			try {
				for (var _iterator6 = (0, _getIterator3.default)((0, _entries2.default)(this.previouslyAssignedRoutes)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
					var _step6$value = (0, _slicedToArray3.default)(_step6.value, 2),
					    oldKey = _step6$value[0],
					    oldValue = _step6$value[1];

					(0, _assign2.default)(this.previouslyAssignedRoutes, new Object((0, _defineProperty3.default)({}, oldKey, oldValue + ' | ' + oldKey)));
				}
			} catch (err) {
				_didIteratorError6 = true;
				_iteratorError6 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion6 && _iterator6.return) {
						_iterator6.return();
					}
				} finally {
					if (_didIteratorError6) {
						throw _iteratorError6;
					}
				}
			}
		}
	}, {
		key: 'formatRecurringRouteLabel',
		value: function formatRecurringRouteLabel(route) {
			if (!route || !route.route || !route.sequence || !route.anchorDate || !route.interval) return null;
			var routeName = route.route.Key || route.route.Value;
			var intervalLabel = route.interval.label || route.interval.interval + '-' + route.interval.frequency;
			var anchorDate = (0, _moment2.default)(route.anchorDate).format('DD-MMM-YYYY');
			return routeName + ' | ' + intervalLabel + ' | Seq ' + route.sequence + ' | ' + anchorDate + ' | ' + route.day.value;
		}
	}, {
		key: 'findRecurringRouteAssignmentChange',
		value: function findRecurringRouteAssignmentChange() {
			var _this30 = this;

			this.isRecurringRouteAssignmentUpdate = false;
			this.currentlyAssignedRecurringRoutes = {};
			this.updatedRecurringRoutes = {};
			this.recurringRouteAssignmentUpdatedValues = { rowsToSave: [], idsToDelete: [].concat((0, _toConsumableArray3.default)(this.model.deletedRecurringStops || [])) };

			var buildMapFromRoutes = function buildMapFromRoutes(routes) {
				var map = {};
				(routes || []).forEach(function (route, index) {
					if (index > 6) return;
					var label = _this30.formatRecurringRouteLabel(route);
					if (label) map[route.day.value] = label;
				});
				return map;
			};

			this.currentlyAssignedRecurringRoutes = buildMapFromRoutes(this.originalCombinedRoutes);
			this.updatedRecurringRoutes = buildMapFromRoutes(this.combinedRoutes);

			this.previouslyAssignedRecurringRoutes = this.findDifference(this.currentlyAssignedRecurringRoutes, this.updatedRecurringRoutes);
			this.newAssignedRecurringRoutes = this.findDifference(this.updatedRecurringRoutes, this.currentlyAssignedRecurringRoutes);
			this.isRecurringRouteAssignmentUpdate = !_lodash2.default.isEmpty(this.previouslyAssignedRecurringRoutes) || !_lodash2.default.isEmpty(this.newAssignedRecurringRoutes);

			if (this.isRecurringRouteAssignmentUpdate) {
				var changedDays = new _set2.default([].concat((0, _toConsumableArray3.default)((0, _keys2.default)(this.previouslyAssignedRecurringRoutes)), (0, _toConsumableArray3.default)((0, _keys2.default)(this.newAssignedRecurringRoutes))));

				(this.combinedRoutes || []).forEach(function (r, index) {
					if (index > 6 || !changedDays.has(r.day.value)) return;
					if (r.route && r.sequence && r.anchorDate && r.interval) {
						var dayLoadData = (_this30.locationRecurringLoad || []).find(function (d) {
							return d.day && d.day.value === r.day.value;
						});
						var locationScheduleRecurringLoadData = dayLoadData && dayLoadData.recurringLoad ? (0, _entries2.default)(dayLoadData.recurringLoad).filter(function (_ref10) {
							var _ref11 = (0, _slicedToArray3.default)(_ref10, 2),
							    value = _ref11[1];

							return value && value.amount !== undefined && value.amount !== null && value.amount !== '';
						}).map(function (_ref12) {
							var _ref13 = (0, _slicedToArray3.default)(_ref12, 2),
							    denominationId = _ref13[0],
							    value = _ref13[1];

							return {
								id: value.id ? value.id : null,
								amount: value.amount,
								denominationId: denominationId
							};
						}) : [];

						_this30.recurringRouteAssignmentUpdatedValues.rowsToSave.push({
							id: r.id ? r.id : null,
							description: r.day.value + ' ' + (r.locationId ? r.locationId : _this30.model.id) + ' CombinedRoute',
							anchorDate: (0, _moment2.default)(r.anchorDate).format('YYYY-MM-DD'),
							interval: r.interval.interval,
							frequency: r.interval.frequency,
							effectiveTillDate: null,
							sequence: r.sequence,
							dayOfWeek: r.day.value,
							locationId: _this30.model.id,
							routeId: r.route.Value,
							locationScheduleRecurringLoadData: locationScheduleRecurringLoadData
						});
					}
				});
			}
		}
	}, {
		key: 'formatDenominationLabel',
		value: function formatDenominationLabel(denom) {
			if (!denom || !denom.Key) return null;
			return denom.Key + ' | Max Load ' + (denom.maxLoad != null ? denom.maxLoad : 0) + ' | Min Residual ' + (denom.minResidualThreshold != null ? denom.minResidualThreshold : 0) + '% | Max Residual ' + (denom.maxResidualThreshold != null ? denom.maxResidualThreshold : 0) + '%';
		}
	}, {
		key: 'findDenominationChange',
		value: function findDenominationChange() {
			var _this31 = this;

			this.isDenominationUpdate = false;
			this.currentlyAssignedDenominations = {};
			this.updatedDenominations = {};
			this.denominationUpdatedValues = { rowsToSave: [], deletedLocationDenominationIds: [].concat((0, _toConsumableArray3.default)(this.deletedLocationDenominationIds || [])) };

			var currentDenominations = (this.model.selectedDenomination || []).map(function (item) {
				return {
					id: item.denomination ? item.denomination.id || item.denomination.Value : null,
					Key: item.denomination ? item.denomination.Key || item.denomination.Value + ' | ' + item.name : null,
					Value: item.denomination ? item.denomination.Value : null,
					maxLoad: item.maxLoad,
					denominationStatus: item.denominationStatus,
					locationBalanceActiveStatus: item.locationBalanceActiveStatus,
					status: item.status,
					maxResidualThreshold: _this31.convertStr(item.maxResidualThreshold),
					minResidualThreshold: _this31.convertStr(item.minResidualThreshold),
					locationDenominationId: item.id,
					locationBalanceActiveId: item.locationBalanceActiveId
				};
			});

			var buildMapFromDenominations = function buildMapFromDenominations(denominations) {
				var map = {};
				(denominations || []).forEach(function (denom, index) {
					var label = _this31.formatDenominationLabel(denom);
					if (label) map[denom.Value || index] = label;
				});
				return map;
			};

			this.currentlyAssignedDenominations = buildMapFromDenominations(this.DefaultDenominations);
			this.updatedDenominations = buildMapFromDenominations(currentDenominations);

			this.previouslyAssignedDenominations = this.findDifference(this.currentlyAssignedDenominations, this.updatedDenominations);
			this.newAssignedDenominations = this.findDifference(this.updatedDenominations, this.currentlyAssignedDenominations);
			this.isDenominationUpdate = !_lodash2.default.isEmpty(this.previouslyAssignedDenominations) || !_lodash2.default.isEmpty(this.newAssignedDenominations) || !!(this.denominationUpdatedValues.deletedLocationDenominationIds && this.denominationUpdatedValues.deletedLocationDenominationIds.length);

			if (this.isDenominationUpdate) {
				this.denominationUpdatedValues.rowsToSave = currentDenominations;
			}
		}
	}, {
		key: 'formatRecurringLoadLabel',
		value: function formatRecurringLoadLabel(dayValue, denom, loadData) {
			if (!loadData || !denom || !denom.denomination) return null;
			var denomLabel = denom.denomination.Key || denom.denomination.name;
			if (!denomLabel) return null;
			var isCleared = loadData.amount === '' || loadData.amount === null || loadData.amount === undefined;
			var amountDisplay = isCleared ? '-' : loadData.amount;
			return denom.denomination.coinFlag ? dayValue + ' | ' + denomLabel + ' | Amount ' + amountDisplay + ' | Qty ' + loadData.qty : dayValue + ' | ' + denomLabel + ' | Amount ' + amountDisplay;
		}
	}, {
		key: 'findScheduleRecurringLoadChange',
		value: function findScheduleRecurringLoadChange() {
			var _this32 = this;

			this.isScheduleRecurringLoadUpdate = false;
			this.currentlyAssignedScheduleRecurringLoad = {};
			this.updatedScheduleRecurringLoad = {};
			this.scheduleRecurringLoadUpdatedValues = { rowsToSave: [] };

			var buildMapFromRecurringLoad = function buildMapFromRecurringLoad(recurringLoadData) {
				var map = {};
				(recurringLoadData || []).forEach(function (dayData) {
					var dayValue = dayData.day ? dayData.day.value : null;
					if (!dayValue) return;
					(dayData.denominations || []).forEach(function (denom) {
						var denominationId = denom.denomination ? denom.denomination.Value : null;
						if (!denominationId) return;
						var loadData = dayData.recurringLoad ? dayData.recurringLoad[denominationId] : null;
						var label = _this32.formatRecurringLoadLabel(dayValue, denom, loadData);
						if (label) map[dayValue + '-' + denominationId] = label;
					});
				});
				return map;
			};

			this.currentlyAssignedScheduleRecurringLoad = buildMapFromRecurringLoad(this.originalLocationRecurringLoad);
			this.updatedScheduleRecurringLoad = buildMapFromRecurringLoad(this.locationRecurringLoad);

			this.previouslyAssignedScheduleRecurringLoad = this.findDifference(this.currentlyAssignedScheduleRecurringLoad, this.updatedScheduleRecurringLoad);
			this.newAssignedScheduleRecurringLoad = this.findDifference(this.updatedScheduleRecurringLoad, this.currentlyAssignedScheduleRecurringLoad);
			this.isScheduleRecurringLoadUpdate = !_lodash2.default.isEmpty(this.previouslyAssignedScheduleRecurringLoad) || !_lodash2.default.isEmpty(this.newAssignedScheduleRecurringLoad);

			if (this.isScheduleRecurringLoadUpdate) {
				var changedKeys = new _set2.default([].concat((0, _toConsumableArray3.default)((0, _keys2.default)(this.previouslyAssignedScheduleRecurringLoad)), (0, _toConsumableArray3.default)((0, _keys2.default)(this.newAssignedScheduleRecurringLoad))));

				(this.locationRecurringLoad || []).forEach(function (dayData) {
					var dayValue = dayData.day ? dayData.day.value : null;
					if (!dayValue) return;
					var matchedRoute = (_this32.combinedRoutes || []).find(function (r) {
						return r.day && r.day.value === dayValue && r.id;
					});
					if (!matchedRoute) return;

					(0, _entries2.default)(dayData.recurringLoad || {}).forEach(function (_ref14) {
						var _ref15 = (0, _slicedToArray3.default)(_ref14, 2),
						    denominationId = _ref15[0],
						    loadData = _ref15[1];

						if (!changedKeys.has(dayValue + '-' + denominationId)) return;
						_this32.scheduleRecurringLoadUpdatedValues.rowsToSave.push({
							id: loadData.id ? loadData.id : null,
							amount: loadData.amount,
							denominationId: denominationId,
							locationScheduleRecurringId: matchedRoute.id
						});
					});
				});
			}
		}
	}, {
		key: 'saveLater',
		value: function saveLater() {
			var _this33 = this;

			this.findRouteAssignmentChange();
			this.findDeliveryToLocationChange();
			this.findRecurringRouteAssignmentChange();
			this.findDenominationChange();
			this.findScheduleRecurringLoadChange();
			this.updateLocationStatus();
			this.updateAllBranches();
			this.updateDefaultBranch();
			this.updateFundingSource();
			this.updateBatchImport();
			this.updateBagoutExport();
			this.updateHandleAtmLikeRegular();

			var deliveryToLocation = {
				previouslyAssignedDeliveryToLocation: (0, _values2.default)(this.previouslyAssignedDeliveryToLocation),
				newAssignedDeliveryToLocation: (0, _values2.default)(this.newAssignedDeliveryToLocation),
				isDeliveryToLocationUpdated: this.isDeliveryToLocationUpdate,
				updatedValues: this.assignedDeliveryLocation,
				key: 'update_delivery_location'
			};

			var routeAssignment = {
				previouslyAssignedRoutes: (0, _values2.default)(this.previouslyAssignedRoutes),
				newAssignedRoutes: (0, _values2.default)(this.newAssignedRoutes),
				isRouteAssignmentChanged: this.isRouteAssignmentUpdate,
				updatedValues: this.assignedRoutes,
				key: 'update_route_assignment'
			};

			var recurringRouteAssignment = {
				previouslyAssignedRecurringRoutes: (0, _values2.default)(this.previouslyAssignedRecurringRoutes),
				newAssignedRecurringRoutes: (0, _values2.default)(this.newAssignedRecurringRoutes),
				isRecurringRouteAssignmentChanged: this.isRecurringRouteAssignmentUpdate,
				updatedValues: this.recurringRouteAssignmentUpdatedValues,
				key: 'update_recurring_route_assignment'
			};

			var denomination = {
				previouslyAssignedDenominations: (0, _values2.default)(this.previouslyAssignedDenominations),
				newAssignedDenominations: (0, _values2.default)(this.newAssignedDenominations),
				isDenominationChanged: this.isDenominationUpdate,
				updatedValues: this.denominationUpdatedValues,
				key: 'update_denomination'
			};

			var scheduleRecurringLoad = {
				previouslyAssignedScheduleRecurringLoad: (0, _values2.default)(this.previouslyAssignedScheduleRecurringLoad),
				newAssignedScheduleRecurringLoad: (0, _values2.default)(this.newAssignedScheduleRecurringLoad),
				isScheduleRecurringLoadChanged: this.isScheduleRecurringLoadUpdate,
				updatedValues: this.scheduleRecurringLoadUpdatedValues,
				key: 'update_schedule_recurring_load'
			};

			var locationStatus = {
				previouslyAssignedLocationStatus: (0, _values2.default)(this.previouslyAssignedLocationStatus),
				newAssignedLocationStatus: (0, _values2.default)(this.newAssignedLocationStatus),
				isLocationStatus: this.islocationstatusUpdated,
				updatedValues: this.assignedLocationStatus,
				key: 'update_location_status'
			};

			var allBranches = {
				previouslyAssignedAllBranches: this.locationBranches,
				newAssignedAllBranches: this.currentSelectedBranches,
				isAllBranchesChanged: this.isBranchesUpdated,
				// updatedValues: this.assignedAllBranches,
				key: 'update_all_branches'
			};

			var defaultBranch = {
				previouslyAssignedDefaultBranch: (0, _values2.default)(this.previouslyAssignedDefaultBranch),
				newAssignedDefaultBranch: (0, _values2.default)(this.newAssignedDefaultBranch),
				isDefaultBranchChanged: this.isDefaultBranchUpdate,
				updatedValues: this.assignedDefaultBranch,
				key: 'update_default_branch'
			};

			var fundingSource = {
				previouslyAssignedFundingSource: this.previouslyAssignedFundingSource,
				newAssignedFundingSource: this.newAssignedFundingSource,
				isBankSourceChanged: this.isBankSourceUpdate,
				previouslyAssignedSwapRatio: this.previouslyAssignedSwapRatio,
				newAssignedSwapRatio: this.newAssignedSwapRatio,
				isSwapRatioChanged: this.isSwapRatioUpdate,
				isFundingSourceChanged: this.isFundingSourceUpdate,
				updatedValues: this.assignedFundingSource,
				key: 'update_funding_source'
			};

			var batchImport = {
				previouslyAssignedBatchImport: (0, _values2.default)(this.previouslyAssignedBatchImport),
				newAssignedBatchImport: (0, _values2.default)(this.newAssignedBatchImport),
				isBatchImportChanged: this.isBatchImportUpdate,
				updatedValues: this.assignedBatchImport,
				key: 'update_batch_import_location'
			};

			var bagoutExport = {
				previouslyAssignedBagoutExport: (0, _values2.default)(this.previouslyAssignedBagoutExport),
				newAssignedBagoutExport: (0, _values2.default)(this.newAssignedBagoutExport),
				isBagoutExportChanged: this.isBagoutExportUpdate,
				updatedValues: this.assignedBagoutExport,
				key: 'update_bagout_export_location'
			};

			var routeLikeRegular = {
				previouslyAssignedHandleAtmLikeRegular: (0, _values2.default)(this.previouslyAssignedHandleAtmLikeRegular),
				newAssignedHandleAtmLikeRegular: (0, _values2.default)(this.newAssignedHandleAtmLikeRegular),
				isHandleAtmLikeRegular: this.isHandleAtmLikeRegularUpdate,
				updatedValues: this.assignedHandleAtmLikeRegular,
				key: 'update_route_like_regular'
			};

			var extraDetails = {
				id: this.rawId,
				branchId: this.model.defaultBranch,
				name: this.model.name,
				locationType: this.model._type,
				userId: this.model.loggedInUser,
				username: this.User.getUser().firstName.concat(' ', this.User.getUser().lastName)
			};

			this.Modal.saveLocationLaterModal(routeAssignment, deliveryToLocation, this.rawId, locationStatus, allBranches, defaultBranch, batchImport, bagoutExport, routeLikeRegular, recurringRouteAssignment, denomination, scheduleRecurringLoad, fundingSource, function (_ref16) {
				var modal = _ref16.modal,
				    duration = _ref16.duration,
				    dateTime = _ref16.dateTime;

				routeAssignment.executeAt = routeAssignment.isRouteAssignmentChanged ? dateTime : null;
				deliveryToLocation.executeAt = deliveryToLocation.isDeliveryToLocationUpdated ? dateTime : null;
				locationStatus.executeAt = locationStatus.isLocationStatus ? dateTime : null;
				allBranches.executeAt = allBranches.isAllBranchesChanged ? dateTime : null;
				defaultBranch.executeAt = defaultBranch.isDefaultBranchChanged ? dateTime : null;
				batchImport.executeAt = batchImport.isBatchImportChanged ? dateTime : null;
				bagoutExport.executeAt = bagoutExport.isBagoutExportChanged ? dateTime : null;
				routeLikeRegular.executeAt = routeLikeRegular.isHandleAtmLikeRegular ? dateTime : null;
				recurringRouteAssignment.executeAt = recurringRouteAssignment.isRecurringRouteAssignmentChanged ? dateTime : null;
				denomination.executeAt = denomination.isDenominationChanged ? dateTime : null;
				scheduleRecurringLoad.executeAt = scheduleRecurringLoad.isScheduleRecurringLoadChanged ? dateTime : null;
				fundingSource.executeAt = fundingSource.isFundingSourceChanged ? dateTime : null;

				var routeDetailsObj = routeAssignment.isRouteAssignmentChanged ? routeAssignment : {};
				var deliveryToLocationObj = deliveryToLocation.isDeliveryToLocationUpdated ? deliveryToLocation : {};
				var locationStatusObj = locationStatus.isLocationStatus ? locationStatus : {};
				var allBranchesObj = allBranches.isAllBranchesChanged ? allBranches : {};
				var defaultBranchObj = defaultBranch.isDefaultBranchChanged ? defaultBranch : {};
				var batchImportObj = batchImport.isBatchImportChanged ? batchImport : {};
				var bagoutExportObj = bagoutExport.isBagoutExportChanged ? bagoutExport : {};
				var routeLikeRegularObj = routeLikeRegular.isHandleAtmLikeRegular ? routeLikeRegular : {};
				var recurringRouteAssignmentObj = recurringRouteAssignment.isRecurringRouteAssignmentChanged ? recurringRouteAssignment : {};
				var denominationObj = denomination.isDenominationChanged ? denomination : {};
				var scheduleRecurringLoadObj = scheduleRecurringLoad.isScheduleRecurringLoadChanged ? scheduleRecurringLoad : {};
				var fundingSourceObj = fundingSource.isFundingSourceChanged ? fundingSource : {};

				_this33.Service.saveLocationChanges(extraDetails, routeDetailsObj, deliveryToLocationObj, duration, locationStatusObj, allBranchesObj, defaultBranchObj, batchImportObj, bagoutExportObj, routeLikeRegularObj, recurringRouteAssignmentObj, denominationObj, scheduleRecurringLoadObj, fundingSourceObj).then(function () {
					return window.history.go(-1);
				}).catch(function (err) {
					console.log(err);
					_this33.Modal.errorModal(err.data.message);
				});
			}, function (_ref17) {
				var modal = _ref17.modal;

				if (modal) modal.close();
			});
		}
	}, {
		key: 'findDeliveryToLocationChange',
		value: function findDeliveryToLocationChange() {
			var _this34 = this;

			this.isDeliveryToLocationUpdate = false;
			this.updatedDeliveryToLocation = {};
			this.assignedDeliveryLocation = [];

			this.model.deliveryToLocation.forEach(function (loc, index) {
				(0, _assign2.default)(_this34.updatedDeliveryToLocation, new Object((0, _defineProperty3.default)({}, index, loc.shipTypeDetails.Key.concat(' | ', loc.locationDetails.Key))));
				_this34.assignedDeliveryLocation.push({
					locationId: loc.locationDetails.Value, shiptypeId: loc.shipTypeDetails.Value,
					sortOrder: loc.sortOrder, coinFlag: loc.shipTypeDetails.coinFlag
				});
			});

			this.previouslyAssignedDeliveryToLocation = this.findDifference(this.currentlyAssignedDeliveryToLocation, this.updatedDeliveryToLocation);
			this.newAssignedDeliveryToLocation = this.findDifference(this.updatedDeliveryToLocation, this.currentlyAssignedDeliveryToLocation);
			this.isDeliveryToLocationUpdate = !_lodash2.default.isEmpty(this.previouslyAssignedDeliveryToLocation) || !_lodash2.default.isEmpty(this.newAssignedDeliveryToLocation);

			if (this.assignedDeliveryLocation.length && this.pendingLocationChanges && this.pendingLocationChanges.results && this.pendingLocationChanges.results.pendingChanges.length) {
				var uniqueRecords = this.model.locationToBeUpdated.filter(function (item1) {
					return !_this34.assignedDeliveryLocation.some(function (item2) {
						return item2.locationId === item1.locationId && item2.shiptypeId === item1.shiptypeId;
					});
				});

				this.assignedDeliveryLocation = [].concat((0, _toConsumableArray3.default)(uniqueRecords), (0, _toConsumableArray3.default)(this.assignedDeliveryLocation));
				this.assignedDeliveryLocation.forEach(function (assignedLoc, index) {
					assignedLoc.sortOrder = index + 1;
				});
			}
		}
	}, {
		key: 'updateLocationStatus',
		value: function updateLocationStatus() {
			this.islocationstatusUpdated = false;
			this.assignedLocationStatus = [];
			this.updatedLocationStatus = {
				active: this.model.status
			};

			var previouslyAssignedLocationStatus = this.findDifference(this.currentlyAssignedLocationStatus, this.updatedLocationStatus);
			var newAssignedLocationStatus = this.findDifference(this.updatedLocationStatus, this.currentlyAssignedLocationStatus);
			this.islocationstatusUpdated = !_lodash2.default.isEmpty(previouslyAssignedLocationStatus) || !_lodash2.default.isEmpty(newAssignedLocationStatus);

			this.previouslyAssignedLocationStatus = previouslyAssignedLocationStatus;
			this.newAssignedLocationStatus = newAssignedLocationStatus;

			var _iteratorNormalCompletion8 = true;
			var _didIteratorError8 = false;
			var _iteratorError8 = undefined;

			try {
				for (var _iterator8 = (0, _getIterator3.default)((0, _entries2.default)(this.updatedLocationStatus)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
					var _step8$value = (0, _slicedToArray3.default)(_step8.value, 2),
					    key = _step8$value[0],
					    value = _step8$value[1];

					this.assignedLocationStatus.push(key, value);
				}
			} catch (err) {
				_didIteratorError8 = true;
				_iteratorError8 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion8 && _iterator8.return) {
						_iterator8.return();
					}
				} finally {
					if (_didIteratorError8) {
						throw _iteratorError8;
					}
				}
			}
		}
	}, {
		key: 'updateAllBranches',
		value: function updateAllBranches() {
			this.isBranchesUpdated = false;
			this.currentSelectedBranches = this.model.branch.map(function (branchObj) {
				return branchObj.branchId;
			});
			this.isBranchesUpdated = !_lodash2.default.isEqual(this.locationBranches, this.currentSelectedBranches);
		}
	}, {
		key: 'updateDefaultBranch',
		value: function updateDefaultBranch() {
			this.isDefaultBranchUpdate = false;
			this.assignedDefaultBranch = [];
			this.updatedDefaultBranch = {
				branchId: this.model.defaultBranch
			};

			var previouslyAssignedDefaultBranch = this.findDifference(this.currentlyAssignedDefaultBranch, this.updatedDefaultBranch);
			var newAssignedDefaultBranch = this.findDifference(this.updatedDefaultBranch, this.currentlyAssignedDefaultBranch);
			this.isDefaultBranchUpdate = !_lodash2.default.isEmpty(previouslyAssignedDefaultBranch) || !_lodash2.default.isEmpty(newAssignedDefaultBranch);

			this.previouslyAssignedDefaultBranch = previouslyAssignedDefaultBranch;
			this.newAssignedDefaultBranch = newAssignedDefaultBranch;

			var _iteratorNormalCompletion9 = true;
			var _didIteratorError9 = false;
			var _iteratorError9 = undefined;

			try {
				for (var _iterator9 = (0, _getIterator3.default)((0, _entries2.default)(this.updatedDefaultBranch)), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
					var _step9$value = (0, _slicedToArray3.default)(_step9.value, 2),
					    key = _step9$value[0],
					    value = _step9$value[1];

					this.assignedDefaultBranch.push(key, value);
				}
			} catch (err) {
				_didIteratorError9 = true;
				_iteratorError9 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion9 && _iterator9.return) {
						_iterator9.return();
					}
				} finally {
					if (_didIteratorError9) {
						throw _iteratorError9;
					}
				}
			}
		}
	}, {
		key: 'formatSwapRatioLabel',
		value: function formatSwapRatioLabel(value) {
			if (!value) return null;
			var option = this.addToSwapRatioOptions.find(function (opt) {
				return opt.value === value;
			});
			return option ? option.label : value;
		}
	}, {
		key: 'updateFundingSource',
		value: function updateFundingSource() {
			this.isFundingSourceUpdate = false;
			this.assignedFundingSource = [];
			this.updatedFundingSource = {
				bankSourceId: this.model.bankSourceId ? this.model.bankSourceId.Key : null,
				addSwapRatio: this.model.addToSwapRatio || null
			};

			var previouslyAssignedFundingSource = this.findDifference(this.currentlyAssignedFundingSource, this.updatedFundingSource);
			var newAssignedFundingSource = this.findDifference(this.updatedFundingSource, this.currentlyAssignedFundingSource);
			// isFundingSourceUpdate covers the whole section (used to gate the backend save and the shared
			// date/time picker) - Add: Swap Ratio is still persisted together with bankSourceId in one update,
			// since it's derived from the funding source selection, but each is shown as its own row below.
			this.isFundingSourceUpdate = !_lodash2.default.isEmpty(previouslyAssignedFundingSource) || !_lodash2.default.isEmpty(newAssignedFundingSource);

			this.previouslyAssignedFundingSource = [previouslyAssignedFundingSource.bankSourceId].filter(function (value) {
				return value !== null && value !== undefined;
			});
			this.newAssignedFundingSource = [newAssignedFundingSource.bankSourceId].filter(function (value) {
				return value !== null && value !== undefined;
			});
			this.isBankSourceUpdate = !!(this.previouslyAssignedFundingSource.length || this.newAssignedFundingSource.length);

			this.previouslyAssignedSwapRatio = [this.formatSwapRatioLabel(previouslyAssignedFundingSource.addSwapRatio)].filter(function (value) {
				return value !== null && value !== undefined;
			});
			this.newAssignedSwapRatio = [this.formatSwapRatioLabel(newAssignedFundingSource.addSwapRatio)].filter(function (value) {
				return value !== null && value !== undefined;
			});
			this.isSwapRatioUpdate = !!(this.previouslyAssignedSwapRatio.length || this.newAssignedSwapRatio.length);

			var fundingSourceValues = {
				bankSourceId: this.model.bankSourceId ? this.model.bankSourceId.Value : null,
				addSwapRatio: this.model.addToSwapRatio || null
			};

			var _iteratorNormalCompletion10 = true;
			var _didIteratorError10 = false;
			var _iteratorError10 = undefined;

			try {
				for (var _iterator10 = (0, _getIterator3.default)((0, _entries2.default)(fundingSourceValues)), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
					var _step10$value = (0, _slicedToArray3.default)(_step10.value, 2),
					    key = _step10$value[0],
					    value = _step10$value[1];

					this.assignedFundingSource.push(key, value);
				}
			} catch (err) {
				_didIteratorError10 = true;
				_iteratorError10 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion10 && _iterator10.return) {
						_iterator10.return();
					}
				} finally {
					if (_didIteratorError10) {
						throw _iteratorError10;
					}
				}
			}
		}
	}, {
		key: 'updateBatchImport',
		value: function updateBatchImport() {
			this.isBatchImportUpdate = false;
			this.assignedBatchImport = [];
			this.updatedBatchImport = {
				idBatchImport: this.model.idBatchImport || null
			};

			var previouslyAssignedBatchImport = this.findDifference(this.currentlyAssignedBatchImport, this.updatedBatchImport);
			var newAssignedBatchImport = this.findDifference(this.updatedBatchImport, this.currentlyAssignedBatchImport);
			this.isBatchImportUpdate = !_lodash2.default.isEmpty(previouslyAssignedBatchImport) || !_lodash2.default.isEmpty(newAssignedBatchImport);

			this.previouslyAssignedBatchImport = previouslyAssignedBatchImport;
			this.newAssignedBatchImport = newAssignedBatchImport;

			var _iteratorNormalCompletion11 = true;
			var _didIteratorError11 = false;
			var _iteratorError11 = undefined;

			try {
				for (var _iterator11 = (0, _getIterator3.default)((0, _entries2.default)(this.updatedBatchImport)), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
					var _step11$value = (0, _slicedToArray3.default)(_step11.value, 2),
					    key = _step11$value[0],
					    value = _step11$value[1];

					this.assignedBatchImport.push(key, value);
				}
			} catch (err) {
				_didIteratorError11 = true;
				_iteratorError11 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion11 && _iterator11.return) {
						_iterator11.return();
					}
				} finally {
					if (_didIteratorError11) {
						throw _iteratorError11;
					}
				}
			}
		}
	}, {
		key: 'updateBagoutExport',
		value: function updateBagoutExport() {
			this.isBagoutExportUpdate = false;
			this.assignedBagoutExport = [];
			this.updatedBagoutExport = {
				idBagoutExport: this.model.idBagoutExport || null
			};

			var previouslyAssignedBagoutExport = this.findDifference(this.currentlyAssignedBagoutExport, this.updatedBagoutExport);
			var newAssignedBagoutExport = this.findDifference(this.updatedBagoutExport, this.currentlyAssignedBagoutExport);

			this.isBagoutExportUpdate = !_lodash2.default.isEmpty(previouslyAssignedBagoutExport) || !_lodash2.default.isEmpty(newAssignedBagoutExport);

			this.previouslyAssignedBagoutExport = previouslyAssignedBagoutExport;
			this.newAssignedBagoutExport = newAssignedBagoutExport;

			var _iteratorNormalCompletion12 = true;
			var _didIteratorError12 = false;
			var _iteratorError12 = undefined;

			try {
				for (var _iterator12 = (0, _getIterator3.default)((0, _entries2.default)(this.updatedBagoutExport)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
					var _step12$value = (0, _slicedToArray3.default)(_step12.value, 2),
					    key = _step12$value[0],
					    value = _step12$value[1];

					this.assignedBagoutExport.push(key, value);
				}
			} catch (err) {
				_didIteratorError12 = true;
				_iteratorError12 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion12 && _iterator12.return) {
						_iterator12.return();
					}
				} finally {
					if (_didIteratorError12) {
						throw _iteratorError12;
					}
				}
			}
		}
	}, {
		key: 'updateHandleAtmLikeRegular',
		value: function updateHandleAtmLikeRegular() {
			this.isHandleAtmLikeRegularUpdate = false;
			this.assignedHandleAtmLikeRegular = [];
			this.updatedHandleAtmLikeRegular = {
				handleAtmLikeRegular: this.model.handleAtmLikeRegular
			};

			var previouslyAssignedHandleAtmLikeRegular = this.findDifference(this.currentlyAssignedHandleAtmLikeRegular, this.updatedHandleAtmLikeRegular);
			var newAssignedHandleAtmLikeRegular = this.findDifference(this.updatedHandleAtmLikeRegular, this.currentlyAssignedHandleAtmLikeRegular);
			this.isHandleAtmLikeRegularUpdate = !_lodash2.default.isEmpty(previouslyAssignedHandleAtmLikeRegular) || !_lodash2.default.isEmpty(newAssignedHandleAtmLikeRegular);

			this.previouslyAssignedHandleAtmLikeRegular = previouslyAssignedHandleAtmLikeRegular;
			this.newAssignedHandleAtmLikeRegular = newAssignedHandleAtmLikeRegular;

			var _iteratorNormalCompletion13 = true;
			var _didIteratorError13 = false;
			var _iteratorError13 = undefined;

			try {
				for (var _iterator13 = (0, _getIterator3.default)((0, _entries2.default)(this.updatedHandleAtmLikeRegular)), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
					var _step13$value = (0, _slicedToArray3.default)(_step13.value, 2),
					    key = _step13$value[0],
					    value = _step13$value[1];

					this.assignedHandleAtmLikeRegular.push(key, value);
				}
			} catch (err) {
				_didIteratorError13 = true;
				_iteratorError13 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion13 && _iterator13.return) {
						_iterator13.return();
					}
				} finally {
					if (_didIteratorError13) {
						throw _iteratorError13;
					}
				}
			}
		}
	}, {
		key: 'loadPreventativeMaintenances',
		value: function loadPreventativeMaintenances(searchKey, offset) {
			var _this35 = this;

			searchKey = searchKey || '';
			return this.Service.getPreventativeMaintenanceList(10, offset, searchKey).then(function (data) {
				var pmList = (data.results || []).map(function (pm) {
					return {
						Key: pm.title + (pm.status === 'Suspended' ? ' (suspended)' : ''),
						Value: pm.id,
						isSuspended: pm.status === 'Suspended'
					};
				});
				if (offset === 0 || offset === undefined) {
					_this35.totalPMRecords = data.total || 0;
					_this35.pmSearchList = pmList;
				} else {
					_this35.pmSearchList = _this35.pmSearchList.concat(pmList);
				}
			});
		}
	}, {
		key: 'getPendingLocationChanges',
		value: function getPendingLocationChanges() {
			var _this36 = this;

			var deliveryLocations = [];
			this.pendingStopsChangesObj.loading = true;
			return this.Service.getPendingLocationChanges(this.$stateParams.id).then(function (data) {
				_this36.pendingLocationChanges = data;
				_this36.pendingStopsChangesObj.results = data.results.scheduleStops;
				_this36.pendingStopsChangesObj.total = data.results.scheduleStops.length;
				data.results.pendingChanges.forEach(function (pendingChanges) {
					if (pendingChanges.updatedValues && pendingChanges.updatedValues.length) {
						pendingChanges.updatedValues.forEach(function (updatedRecord) {
							deliveryLocations.push(updatedRecord);
						});
					}
				});
				_this36.model.locationToBeUpdated = deliveryLocations;
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this36.pendingStopsChangesObj.loading = false;
			});
		}
	}, {
		key: 'translateMessage',
		value: function translateMessage(key) {
			if (!key) return;
			return this.$translate.instant('location.' + key);
		}
	}, {
		key: 'confirmDeleteAllPendingChanges',
		value: function confirmDeleteAllPendingChanges() {
			var _this37 = this;

			this.Modal.confirm({
				header: this.$translate.instant('common.confirm_delete_title'),
				message: this.$translate.instant('common.confirm_delete_message'),
				callback: function callback(_ref19) {
					var modal = _ref19.modal,
					    $scope = _ref19.$scope;

					_this37.removeAllPendingLocationChanges();
					modal.close();
				},
				negative: function negative(_ref20) {
					var modal = _ref20.modal;

					modal.close();
				},
				type: 'danger'
			});
		}
	}, {
		key: 'cancelScheduledStops',
		value: function cancelScheduledStops(jobKey, event) {
			var _this38 = this;

			this.model.deleteStopRecurring = true;
			this.Modal.confirm({
				header: this.$translate.instant('errorModal.title'),
				message: this.$translate.instant('verifyHoldShipments.forceCloseShipments'),
				callback: function callback(_ref21) {
					var modal = _ref21.modal;

					_this38.StopSchedulingService.cancelScheduledStops(jobKey).then(function () {
						_this38.getPendingLocationChanges();
						event.preventDefault();
					}).catch(function (err) {
						if (err && err.data && err.data.message) {
							_this38.Modal.errorModal(err.data.message);
						}
					}).finally(function () {
						_this38.model.deleteStopRecurring = false;
					});
					modal.close();
				},
				buttons: ['common.ok', 'common.cancel'],
				type: 'danger'
			});
		}
	}, {
		key: 'removeLocationChanges',
		value: function removeLocationChanges(jobId) {
			var _this39 = this;

			return this.Service.removeLocationChanges(jobId).then(function () {
				_this39.getPendingLocationChanges();
			}).catch(function (err) {
				console.log(err);
				if (err && err.data && err.data.message) {
					_this39.Modal.errorModal(err.data.message);
				}
			});
		}
	}, {
		key: 'removeAllPendingLocationChanges',
		value: function removeAllPendingLocationChanges() {
			var _this40 = this;

			var jobIds = _lodash2.default.uniq((this.pendingLocationChanges.results.pendingChanges || []).map(function (history) {
				return history.jobId;
			}));

			return this.$q.all(jobIds.map(function (jobId) {
				return _this40.Service.removeLocationChanges(jobId);
			})).then(function () {
				_this40.getPendingLocationChanges();
			}).catch(function (err) {
				console.log(err);
				if (err && err.data && err.data.message) {
					_this40.Modal.errorModal(err.data.message);
				}
			});
		}
	}, {
		key: 'showPassword',
		value: function showPassword(stat, type) {
			this.passWdIcon[stat][type] = !this.passWdIcon[stat][type];
		}
	}, {
		key: 'resetOTCCompany',
		value: function resetOTCCompany() {
			if (this.model.lockType === 'static') this.model.OTCCompanyName = null;
			if (this.model.secondaryLockType === 'static') this.model.secondaryLockOTCCompanyName = null;
		}
	}, {
		key: 'fundingSourceSearchObj',
		value: function fundingSourceSearchObj(searchKey) {
			searchKey = searchKey || '';
			var selectedBranch = this.model.branch.map(function (branch) {
				return branch.branchId;
			});

			var obj = {
				queryJSON: {
					rules: [{
						field: "branchId",
						condition: "=",
						data: this.model.defaultBranch ? this.model.defaultBranch : selectedBranch
					}, {
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "sourceName",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};
			return obj.queryJSON.rules.length ? obj : null;
		}
	}, {
		key: 'getAllFundingSource',
		value: function getAllFundingSource(searchKey, offset) {
			var _this41 = this;

			this.model.fundingSourceObj.loading = true;
			var searchObj = this.fundingSourceSearchObj(searchKey);

			return this.BranchFundingSourceService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this41.model.fundingSourceObj.totalRecords = data.total;
					_this41.model.fundingSourceObj.results = _this41.fundingSourceDataMap(data.results);
				} else {
					var fundingSource = _this41.fundingSourceDataMap(data.results);
					_this41.model.fundingSourceObj.results = (_this41.model.fundingSourceObj.results || []).concat(fundingSource);
				}
			}).catch(function (err) {
				_this41.Modal.errorModal(err.data.message);
			}).finally(function () {
				_this41.model.fundingSourceObj.loading = false;
			});
		}
	}, {
		key: 'fundingSourceDataMap',
		value: function fundingSourceDataMap(list) {
			return list.map(function (bfs) {
				return {
					Key: bfs.id + ' | ' + bfs.sourceName,
					Value: bfs.id,
					atmForecasting: bfs.atmForecasting,
					enforceStraps: bfs.enforceStraps
				};
			});
		}
	}, {
		key: 'orderProfileSearchObj',
		value: function orderProfileSearchObj(searchKey) {
			if (!this.model.fundingSourceObj.selectedFundingSource) return;
			searchKey = searchKey || '';
			var obj = {
				queryJSON: {
					rules: [{
						field: "branchFundingSourceId",
						condition: "=",
						data: this.model.fundingSourceObj.selectedFundingSource.Value
					}, {
						group: {
							rules: [{
								field: "name",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "loadInterval",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};
			return obj.queryJSON.rules.length ? obj : null;
		}
	}, {
		key: 'getOrderProfile',
		value: function getOrderProfile(searchKey, offset) {
			var _this42 = this;

			this.model.orderProfileObj.loading = true;
			var searchObj = this.orderProfileSearchObj(searchKey);

			this.BranchFundingSourceOrderProfileService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this42.model.orderProfileObj.totalRecords = data.total;
					_this42.model.orderProfileObj.results = _this42.orderProfileDataMap(data.results);
				} else {
					var fundingSource = _this42.orderProfileDataMap(data.results);
					_this42.model.orderProfileObj.results = (_this42.model.orderProfileObj.results || []).concat(fundingSource);
				}
			}).catch(function (err) {
				_this42.Modal.errorModal(err.data.message);
			}).finally(function () {
				_this42.model.orderProfileObj.loading = false;
			});
		}
	}, {
		key: 'orderProfileDataMap',
		value: function orderProfileDataMap(list) {
			return list.map(function (op) {
				return {
					Key: op.name + ' | ' + op.loadInterval,
					Value: op.id
				};
			});
		}
	}, {
		key: 'resetDataOnBranchChange',
		value: function resetDataOnBranchChange() {
			if (this.model.enableOrderProfile) {
				this.model.fundingSourceObj.selectedFundingSource = null;
				this.model.orderProfileObj.selectedOrderProfile = null;
			}
			this.model.bankSourceId = null;
		}
	}, {
		key: 'createLocationScheduled',
		value: function createLocationScheduled() {
			if (this.model.scheduledLocations.length <= 0) this.routeList('', 0);

			this.minVaultDate = {
				minDate: this.model.setupDetails.currentVaultDate
			};
			this.model.scheduledLocations.push({
				vaultDate: null,
				routeId: null,
				sequence: 99,
				status: 'Create',
				scheduleLocationId: null
			});
		}
	}, {
		key: 'routeList',
		value: function routeList(searchKey, offset) {
			var _this43 = this;

			searchKey = searchKey || '';

			var selectedBranch = this.model.branch.map(function (branch) {
				return branch.branchId;
			});
			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: 'IN',
						data: selectedBranch
					}, {
						field: 'holdRoute',
						condition: '=',
						data: false
					}, {
						field: 'active',
						condition: '=',
						data: true
					}, {
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'name',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};

			this.model.routeListObj.loading = true;
			return this.RouteService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this43.model.routeListObj.totalRecords = data.total;
					_this43.model.routeListObj.results = _this43.mapData(data.results);
				} else {
					var routes = _this43.mapData(data.results);
					_this43.model.routeListObj.results = _this43.model.routeListObj.results.concat(routes);
				}
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					Modal.errorModal(err.data.message);
				}
			}).finally(function () {
				_this43.model.routeListObj.loading = false;
			});
		}
	}, {
		key: 'mapData',
		value: function mapData(routes) {
			return routes.map(function (route) {
				return {
					Key: route.name,
					Value: route.id
				};
			});
		}
	}, {
		key: 'deleteScheduledLocation',
		value: function deleteScheduledLocation(index) {
			this.model.deleteScheduledLocationIds.push(this.model.scheduledLocations[index].scheduleLocationId);
			this.model.scheduledLocations.splice(index, 1);
			this.validateScheduledLocation();
		}
	}, {
		key: 'validateScheduledLocation',
		value: function validateScheduledLocation() {
			var _this44 = this;

			this.model.scheduledLocations = _lodash2.default.map(this.model.scheduledLocations, function (obj, index) {
				obj.isDuplicate = false;
				var match = _lodash2.default.find(_this44.model.scheduledLocations, function (compairObject, compairObjIndex) {
					if (index > compairObjIndex) return new Date(compairObject.vaultDate).getDate() == new Date(obj.vaultDate).getDate();
				});
				if (match) {
					obj.isDuplicate = true;
					return obj;
				} else {
					return obj;
				}
			});
			var isValid = this.model.scheduledLocations.map(function (obj) {
				if (obj.isDuplicate) return true;
			});
			this.isValid = isValid.indexOf(true) >= 0 ? false : true;
		}
	}, {
		key: 'resetText',
		value: function resetText() {
			this.model._state = null;
			this.model.country = null;
		}
	}, {
		key: 'parseMakeValues',
		value: function parseMakeValues(makeValue) {
			if (Array.isArray(makeValue)) {
				return makeValue.map(function (item) {
					if (!item) return null;
					if (typeof item === 'string') return item.trim();
					// handle {Key, Value} from isteven-multi-select output-model
					return (item.Value || item.value || item.Key || item.label || item.vendorName || '').trim();
				}).filter(Boolean);
			}

			if (!makeValue) return [];

			return String(makeValue).split(',').map(function (item) {
				return item.trim();
			}).filter(Boolean);
		}
	}, {
		key: 'serializeMakeValues',
		value: function serializeMakeValues(makeValue) {
			var values = this.parseMakeValues(makeValue);
			return values.length ? values.join(', ') : null;
		}
	}, {
		key: 'buildAtmMakeOptions',
		value: function buildAtmMakeOptions(results, selectedMakes) {
			var selectedValues = this.parseMakeValues(selectedMakes);
			var options = (results || []).filter(function (item) {
				return item.active;
			}).map(function (item) {
				return {
					Key: item.vendorName,
					Value: item.vendorName,
					ticked: selectedValues.includes(item.vendorName)
				};
			});

			return options;
		}
	}, {
		key: 'loadAtmMakes',
		value: function loadAtmMakes() {
			var _this45 = this;

			var selectedMakes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.model.make;

			return this.AtmMakesService.all('', 0, 1000, true).then(function (_ref22) {
				var results = _ref22.results;

				_this45.atmMakesList = _this45.buildAtmMakeOptions(results, selectedMakes);
				_this45.model.make = _this45.parseMakeValues(selectedMakes);
			}).catch(function (err) {
				console.log(err);
				_this45.atmMakesList = [];
				_this45.model.make = [];
			});
		}
	}, {
		key: 'capitalizeFirstLetter',
		value: function capitalizeFirstLetter(value) {
			if (typeof value !== 'string') return;else return value.charAt(0).toUpperCase() + value.slice(1);
		}
	}, {
		key: 'splitKey',
		value: function splitKey(key) {
			if (!key) return;
			return key.split(' | ')[1];
		}
	}, {
		key: 'formatAddress',
		value: function formatAddress(data) {
			var locationAddress = '';
			if (data.address) locationAddress = locationAddress.concat(data.address, ', ');
			if (data.city) locationAddress = locationAddress.concat(data.city, ', ');
			if (data.state) locationAddress = locationAddress.concat(data.state, ', ');
			if (data.zip) locationAddress = locationAddress.concat(data.zip);
			return locationAddress;
		}
	}, {
		key: 'filterStopProcess',
		value: function filterStopProcess() {
			if (this.model.stopProcess !== 'L') this.model.closeEndOfStop = false;
			if (!this.model._type) return;

			var typeMap = {
				ATM: ['L', 'A'],
				ON_CALL: ['D', 'B'],
				REGULAR: ['D'],
				NO_SHIP_NO_GO: ['D'],
				BANK: ['D'],
				DELIVERY: ['D'],
				INTERNAL: ['D']
			};

			var allowed = typeMap[this.model._type];
			var list = this.CommonLayoutService.stopProcessList();
			this.stopProcessList = allowed ? list.filter(function (_ref23) {
				var value = _ref23.value;
				return allowed.includes(value);
			}) : list;
			if (allowed && !allowed.includes(this.model.stopProcess)) {
				this.model.stopProcess = null;
			}
		}
	}, {
		key: 'createLocationRecurring',
		value: function createLocationRecurring() {
			if (this.model.recurringStops.length <= 0) this.routeList('', 0);

			this.model.recurringStops.push({
				description: null,
				route: null,
				sequence: 99,
				status: 'Create',
				anchorDate: null,
				effectiveTillDate: null,
				interval: null,
				frequency: 99
			});
		}
	}, {
		key: 'deleteRecurringLocation',
		value: function deleteRecurringLocation(index) {
			this.model.deletedRecurringStops.push(this.model.recurringStops[index].id);
			this.model.recurringStops.splice(index, 1);
			this.validateRecurringLocation();
		}
	}, {
		key: 'validateRecurringLocation',
		value: function validateRecurringLocation() {
			var _this46 = this;

			this.model.recurringStops = _lodash2.default.map(this.model.recurringStops, function (obj, index) {
				obj.isDuplicate = false;
				var match = _lodash2.default.find(_this46.model.recurringStops, function (compairObject, compairObjIndex) {
					if (index > compairObjIndex) {
						return new Date(compairObject.anchorDate).getDate() == new Date(obj.anchorDate).getDate() && (compairObject.route && obj.route ? compairObject.route.Value == obj.route.Value : true) && compairObject.interval == obj.interval;
					}
				});
				if (match) {
					obj.isDuplicate = true;
					return obj;
				} else {
					return obj;
				}
			});

			var isValid = this.model.recurringStops.map(function (obj) {
				if (obj.isDuplicate) return true;
			});

			this.isValidRecurringStops = isValid.indexOf(true) >= 0 ? false : true;
		}
	}, {
		key: 'validateReccuringEndDate',
		value: function validateReccuringEndDate(obj) {
			obj.minEndDate = {
				minDate: (0, _moment2.default)(obj.anchorDate)
			};
			if (obj.effectiveTillDate && obj.anchorDate > obj.effectiveTillDate) {
				obj.effectiveTillDate = (0, _moment2.default)(obj.anchorDate);
			}
		}
	}, {
		key: 'disableDays',
		value: function disableDays(currentDate, mode, enableDay) {
			if (enableDay.value === "Hol") return false;
			return mode === 'day' && currentDate.getDay() !== this.dayMap[enableDay.value];
		}
	}, {
		key: 'recheckMonthlyOccurences',
		value: function recheckMonthlyOccurences(anchorDate, day, index) {
			if (!anchorDate) return;
			var selectedDate = new Date(anchorDate);
			var month = selectedDate.getMonth() + 1;
			var year = selectedDate.getFullYear();
			var occurrences = this.countOccurrencesInMonth(year, month, this.dayMap[day.value]);

			switch (occurrences) {
				case 2:
					this.combinedRoutes[index].combinedRouteIntervals = [].concat((0, _toConsumableArray3.default)(this.combinedRouteIntervals)).slice(0, -3);
					break;
				case 3:
					this.combinedRoutes[index].combinedRouteIntervals = [].concat((0, _toConsumableArray3.default)(this.combinedRouteIntervals)).slice(0, -2);
					break;
				case 4:
					this.combinedRoutes[index].combinedRouteIntervals = [].concat((0, _toConsumableArray3.default)(this.combinedRouteIntervals)).slice(0, -1);
					break;
				default:
					this.combinedRoutes[index].combinedRouteIntervals = [].concat((0, _toConsumableArray3.default)(this.combinedRouteIntervals));
					break;
			}
			if (this.combinedRoutes[index].interval && this.combinedRoutes[index].interval.interval === "MONTHOC" && this.combinedRoutes[index].interval.frequency > occurrences) {
				this.combinedRoutes[index].interval = null;
			}
		}
	}, {
		key: 'countOccurrencesInMonth',
		value: function countOccurrencesInMonth(year, month, targetDay) {
			var count = 0;
			var startDate = new Date(year, month - 1, 1);
			var endDate = new Date(year, month, 0);

			for (var currentDate = startDate; currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
				if (currentDate.getDay() === targetDay) {
					count++;
				}
			}

			return count;
		}
	}, {
		key: 'showNextScheduledOccurences',
		value: function showNextScheduledOccurences(data) {
			this.calculateAndUpdateDayOccurrences(data);
			//this.Modal.nextScheduledOccurences(data);
		}
	}, {
		key: 'deleteCombinedRoute',
		value: function deleteCombinedRoute(selectedRoute) {
			this.combinedRoutes = this.combinedRoutes.map(function (route) {
				if (route.id === selectedRoute.id) {
					return (0, _extends3.default)({}, route, {
						id: null,
						anchorDate: null,
						frequency: null,
						sequence: 99, // Default sequence value as a placeholder
						route: null,
						interval: null,
						locationId: null,
						nextOccurrence: null
					});
				}
				return route;
			});

			this.model.deletedRecurringStops.push(selectedRoute.id);

			this.locationRecurringLoad = this.locationRecurringLoad.map(function (data) {
				if (selectedRoute.day.value === data.day.value) {
					return {
						day: data.day,
						denominations: data.denominations,
						recurringLoad: {},
						hasLocationScheduleRecurring: false
					};
				};
				return data;
			});

			this.validateRouteAssignment();
			this.checkForStrapCount();
		}
	}, {
		key: 'denominationsSearchObj',
		value: function denominationsSearchObj(searchKey) {
			searchKey = searchKey || '';

			var obj = {
				queryJSON: {
					rules: [{
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "name",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};
			return obj.queryJSON.rules.length ? obj : null;
		}
	}, {
		key: 'getAllDenominations',
		value: function getAllDenominations(searchKey, offset) {
			var _this47 = this;

			if (!this.model.bankSourceId) return;

			this.model.denominationSourceObj.loading = true;
			// const searchObj = this.denominationsSearchObj(searchKey);

			return this.OrderViewService.getFundingSourceDenominationUnpack(this.model.bankSourceId.Value).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this47.model.denominationSourceObj.totalRecords = data.results.length;
					_this47.model.denominationSourceObj.results = _this47.denominationsDataMap(data.results);
				} else {
					var denominations = _this47.denominationsDataMap(data.results);
					_this47.model.denominationSourceObj.results = _this47.model.denominations.concat(denominations);
				}
			}).catch(function (err) {
				_this47.Modal.errorModal(err.data.message);
			}).finally(function () {
				_this47.model.denominationSourceObj.loading = false;
			});
		}
	}, {
		key: 'getAllLocationSlotDenominations',
		value: function getAllLocationSlotDenominations(searchKey, offset) {
			var _this48 = this;

			return this.DenominationService.all(searchKey, offset, 1000).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this48.model.locationSlotDenominations.totalRecords = data.results.length;
					_this48.model.locationSlotDenominations.results = _this48.denominationsDataMap(data.results);
				} else {
					var denominations = _this48.denominationsDataMap(data.results);
					_this48.model.locationSlotDenominations.results = _this48.model.denominations.concat(denominations);
				}
			}).catch(function (err) {
				_this48.Modal.errorModal(err.data.message);
			});
		}
	}, {
		key: 'getFilteredDenominations',
		value: function getFilteredDenominations() {
			var _this49 = this;

			setTimeout(function () {
				_this49.filteredDenominations = {
					results: [],
					totalRecords: 0
				};

				_this49.deletedLocationDenominationIds = [];

				if (_this49.model._type === 'ATM') {
					_this49.filteredDenominations.results = _this49.model.denominationSourceObj.results.filter(function (denom) {
						// Include cash (non-coin) denominations
						if (!denom.coinFlag) {
							return true;
						}
						// Include coin if: location has coinPermitted AND coin is multiDenomPackable AND packaging is loose/rolled
						if (denom.coinFlag && _this49.model.coinPermitted && denom.multiDenomPackable && denom.coinPackaging && ['INDIVIDUAL', 'ROLLED'].includes(denom.coinPackaging)) {
							return true;
						}
						return false;
					});
					_this49.filteredDenominations.totalRecords = _this49.filteredDenominations.results.length;
				} else {
					_this49.filteredDenominations.results = _this49.model.denominationSourceObj.results;
					_this49.filteredDenominations.totalRecords = _this49.filteredDenominations.results.length;
				}

				if (_this49.model.locationSlots) {
					_this49.model.locationSlots = _this49.model.locationSlots.map(function (slot) {
						if (slot.denominationId) {
							var matchingDenom = _this49.model.locationSlotDenominations.results.find(function (d) {
								return d.id === slot.denominationId;
							});
							if (matchingDenom) {
								slot.denominationId = matchingDenom;
							}
						}
						return slot;
					});
				}

				_this49.model.selectedDenomination = _this49.cloneSelectedDenoms.filter(function (itemB) {
					return _this49.filteredDenominations.results.some(function (itemA) {
						return itemA.id === itemB.denominationId;
					});
				});

				_this49.deletedLocationDenominationIds = _this49.cloneSelectedDenoms.filter(function (itemB) {
					return !_this49.filteredDenominations.results.some(function (itemA) {
						return itemA.id === itemB.denominationId;
					});
				}).map(function (item) {
					return {
						locationDenominationId: item.id,
						locationBalanceActiveId: item.locationBalanceActiveId
					};
				});
				_this49.createLocationRecurringLoad();
			}, 500);
		}
	}, {
		key: 'getLocationDenoms',
		value: function getLocationDenoms(searchKey, offset) {
			var _this50 = this;

			if (!this.model.bankSourceId) return;
			this.getAllDenominations(searchKey, offset).then(function () {
				return _this50.getFilteredDenominations();
			});
		}
	}, {
		key: 'denominationsDataMap',
		value: function denominationsDataMap(list) {
			return list.map(function (denom) {
				return {
					id: denom.id,
					Key: denom.id + ' | ' + denom.name,
					Value: denom.id,
					strapCount: denom.strapCount,
					faceValue: denom.faceValue,
					coinFlag: denom.coinFlag,
					shiptypeId: denom.shiptypeId,
					multiDenomPackable: denom.multiDenomPackable,
					coinPackaging: denom.coinPackaging
				};
			});
		}
	}, {
		key: 'isFormInvalid',
		value: function isFormInvalid(form) {
			for (var i = 0; i < form.$$controls.length; i++) {
				var field = form.$$controls[i];
				if (field.$$attr.ngModel !== '$ctrl.model.contractExpirationDate' && field.$invalid) {
					return true;
				}
			}
			return false;
		}
	}, {
		key: 'createLocationRecurringLoad',
		value: function createLocationRecurringLoad() {
			var _this51 = this;

			if (['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO'].indexOf(this.model._type) === -1) {
				this.locationRecurringLoad = [];
				return;
			}

			setTimeout(function () {
				_this51.days.forEach(function (day) {
					_this51.locationRecurringLoad.push({
						day: day,
						denominations: _this51.model.selectedDenomination,
						recurringLoad: {}
					});
				});

				var routeScheduleMap = new _map3.default();

				_this51.combinedRoutes.forEach(function (route) {
					route.locationScheduleRecurringLoadData.forEach(function (lsr) {
						var key = route.day.value + '-' + lsr.denominationId;
						routeScheduleMap.set(key, { amount: lsr.amount, id: lsr.id });
					});
				});

				_this51.locationRecurringLoad.forEach(function (data) {
					_this51.model.selectedDenomination.forEach(function (denom) {
						var key = data.day.value + '-' + denom.denominationId;
						if (routeScheduleMap.has(key)) {
							if (denom.denomination.coinFlag) {
								data.recurringLoad[denom.denominationId] = { amount: routeScheduleMap.get(key).amount, id: routeScheduleMap.get(key).id, qty: routeScheduleMap.get(key).amount / denom.denomination.faceValue };
							} else {
								data.recurringLoad[denom.denominationId] = { amount: routeScheduleMap.get(key).amount, id: routeScheduleMap.get(key).id };
							}
						}
					});
				});

				var uniqueDayMap = new _map3.default();

				for (var i = 0; i < _this51.locationRecurringLoad.length; i++) {
					var item = _this51.locationRecurringLoad[i];
					var dayValue = item.day.value;

					if (!uniqueDayMap.has(dayValue)) {
						uniqueDayMap.set(dayValue, (0, _extends3.default)({}, item, { denominations: [].concat((0, _toConsumableArray3.default)(item.denominations)) }));
					} else {
						(function () {
							var _existingItem$denomin;

							var existingItem = uniqueDayMap.get(dayValue);
							var existingDenominationIds = new _set2.default(existingItem.denominations.map(function (denom) {
								return denom.id;
							}));
							var uniqueDenominations = item.denominations.filter(function (denom) {
								return !existingDenominationIds.has(denom.id);
							});
							(_existingItem$denomin = existingItem.denominations).push.apply(_existingItem$denomin, (0, _toConsumableArray3.default)(uniqueDenominations));

							if ((0, _keys2.default)(existingItem.recurringLoad).length === 0 && (0, _keys2.default)(item.recurringLoad).length > 0) {
								existingItem.recurringLoad = item.recurringLoad;
							}
						})();
					}
				}

				_this51.locationRecurringLoad = (0, _from2.default)(uniqueDayMap.values());

				_this51.locationRecurringLoad.forEach(function (item) {
					item.denominations = _this51.model.selectedDenomination.filter(function (denom) {
						return denom.denomination && denom.denomination.Value;
					}); //Filter denominations to include only those with denominationId 
					var newDenomination = _this51.model.selectedDenomination.filter(function (denom) {
						return denom.isNew && denom.denomination;
					}); // Add new denominations (if any)
					// if (newDenomination.length >0) item.denominations.push(...newDenomination); 
					if (newDenomination.length > 0) {
						// Use a Set for uniqueness
						var uniqueDenominationsSet = new _set2.default(item.denominations.map(function (denom) {
							return denom.denomination.Value;
						}));
						newDenomination.forEach(function (newDenom) {
							if (!uniqueDenominationsSet.has(newDenom.denomination && newDenom.denomination.Value)) {
								item.denominations.push(newDenom);
								uniqueDenominationsSet.add(newDenom.denomination && newDenom.denomination.Value);
							}
						});
					}

					var validDenominationIds = new _set2.default(_this51.model.selectedDenomination.map(function (denom) {
						return denom.denomination ? denom.denomination.Value : null;
					}));
					(0, _keys2.default)(item.recurringLoad).forEach(function (key) {
						if (!validDenominationIds.has(key)) delete item.recurringLoad[key];
					});
				});

				_this51.validateRouteAssignment();
				_this51.checkForStrapCount();

				if (!_this51.recurringLoadSnapshotTaken) {
					_this51.originalLocationRecurringLoad = _lodash2.default.cloneDeep(_this51.locationRecurringLoad);
					_this51.recurringLoadSnapshotTaken = true;
				}

				_this51.$scope.$apply();
			}, 100);
		}
	}, {
		key: 'checkDenomKeyExists',
		value: function checkDenomKeyExists() {
			var isValid = this.model.selectedDenomination.map(function (d) {
				return !d.denomination || 'isEmpty';
			}).indexOf('isEmpty') !== -1;
			return isValid;
		}
	}, {
		key: 'checkForStrapCount',
		value: function checkForStrapCount() {
			for (var i = 0; i < this.locationRecurringLoad.length; ++i) {
				for (var j = 0; j < this.locationRecurringLoad[i].denominations.length; ++j) {
					var denomination = this.locationRecurringLoad[i].denominations[j];
					var recurringLoad = this.locationRecurringLoad[i]['recurringLoad'];

					if (denomination.denomination && denomination.denomination.strapCount && recurringLoad && recurringLoad[denomination.denomination.Value] && !denomination.denomination.coinFlag) {
						var loadAmount = recurringLoad[denomination.denomination.Value].amount;
						var faceValue = denomination.denomination.faceValue;

						if (loadAmount !== undefined && loadAmount !== null && loadAmount !== '' && loadAmount / faceValue % denomination.denomination.strapCount !== 0 && this.model.bankSourceId.enforceStraps == true) {
							recurringLoad[denomination.denomination.Value].isValid = false;
						} else if (loadAmount !== undefined && loadAmount !== null && loadAmount !== '' && loadAmount % faceValue !== 0) {
							recurringLoad[denomination.denomination.Value].isValid = false;
						} else {
							recurringLoad[denomination.denomination.Value].isValid = true;
						}
					} else if (recurringLoad && recurringLoad[denomination.denomination.Value] && denomination.denomination.coinFlag) {
						recurringLoad[denomination.denomination.Value].isValid = true;
					}
				}
			}
			this.isValidRecurringLoad = this.checkRecurringLoadValidity(this.locationRecurringLoad);
		}
	}, {
		key: 'checkForMaxLoadFaceValueDivisibility',
		value: function checkForMaxLoadFaceValueDivisibility() {
			this.isValidMaxLoad = true;
			if (!this.model.selectedDenomination || !this.model.selectedDenomination.length) {
				return true;
			}

			function isValidAmount(amount, faceValue) {
				if (!isFinite(amount) || !isFinite(faceValue) || faceValue <= 0 || amount <= 0) {
					return false;
				}
				var quotient = amount / faceValue;
				var epsilon = 1e-9;
				return Math.abs(quotient - Math.round(quotient)) < epsilon;
			}

			this.model.selectedDenomination.forEach(function (denomObj) {
				denomObj.isMaxLoadValid = true;

				var denomination = denomObj.denomination;
				var faceValueRaw = denomination && denomination.faceValue;
				var maxLoadRaw = denomObj.maxLoad;

				if (!denomination || faceValueRaw === undefined || faceValueRaw === null || maxLoadRaw === undefined || maxLoadRaw === null || maxLoadRaw === '') {
					return;
				}

				var faceValue = Number(String(faceValueRaw).replace(/,/g, ''));
				var maxLoad = Number(String(maxLoadRaw).replace(/,/g, ''));

				if (!isFinite(faceValue) || faceValue === 0 || !isFinite(maxLoad)) {
					denomObj.isMaxLoadValid = false;
					return;
				}

				denomObj.isMaxLoadValid = isValidAmount(maxLoad, faceValue);
			});

			this.isValidMaxLoad = this.model.selectedDenomination.every(function (denomObj) {
				if (!denomObj.denomination) return true;
				return denomObj.isMaxLoadValid !== false;
			});

			return this.isValidMaxLoad;
		}
	}, {
		key: 'isValidTargetStopTime',
		value: function isValidTargetStopTime() {
			if (!this.model.targetStopTime) return true;
			return this.model.targetStopTime.getHours() > 0 || this.model.targetStopTime.getMinutes() > 0;
		}
	}, {
		key: 'validateRouteAssignment',
		value: function validateRouteAssignment() {
			var _this52 = this;

			this.totalRouteAssignment = 0;

			var routeMap = new _map3.default();
			this.combinedRoutes.forEach(function (route) {
				if (route.route && route.sequence && route.anchorDate && route.interval) {
					routeMap.set(route.day.value, route);
				}
			});

			this.locationRecurringLoad.forEach(function (location) {
				var route = routeMap.get(location.day.value);

				if (route) {
					_this52.totalRouteAssignment++;
					location.locationScheduleRecurringDay = route.day.value;
					location.hasLocationScheduleRecurring = true;
				} else {
					location.hasLocationScheduleRecurring = false;
					location.recurringLoad = {};
				}
			});
		}
	}, {
		key: 'checkRecurringLoadValidity',
		value: function checkRecurringLoadValidity(data) {
			var isValidFlag = true;
			var _iteratorNormalCompletion14 = true;
			var _didIteratorError14 = false;
			var _iteratorError14 = undefined;

			try {
				for (var _iterator14 = (0, _getIterator3.default)(data), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
					var item = _step14.value;

					if (item.recurringLoad) {
						for (var key in item.recurringLoad) {
							var isValid = item.recurringLoad[key].isValid;
							if (!isValid) return false;
							if (isValid) isValidFlag = true;
						}
					}
				}
			} catch (err) {
				_didIteratorError14 = true;
				_iteratorError14 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion14 && _iterator14.return) {
						_iterator14.return();
					}
				} finally {
					if (_didIteratorError14) {
						throw _iteratorError14;
					}
				}
			}

			return isValidFlag;
		}
	}, {
		key: 'convertStr',
		value: function convertStr(str) {
			if (!str) return;
			return Number(str.replace('%', ''));
		}
	}, {
		key: 'ngPercentage',
		value: function ngPercentage() {
			if (this.model.aecPercentChangeValue && !String(this.model.aecPercentChangeValue).endsWith('%')) {
				return this.model.aecPercentChangeValue = this.model.aecPercentChangeValue + '%';
			}
		}
	}, {
		key: 'removePercentageSign',
		value: function removePercentageSign() {
			if (this.model.aecPercentChangeValue && this.model.aecPercentChangeValue.endsWith('%')) {
				return this.model.aecPercentChangeValue = this.model.aecPercentChangeValue.replace('%', '');
			}
		}
	}, {
		key: 'onDenominationReset',
		value: function onDenominationReset() {
			var _this53 = this;

			this.model.selectedDenomination = [];
			this.model.denominationSourceObj.results.forEach(function (ele) {
				ele.ticked = false;
			});
			setTimeout(function () {
				_this53.model.denominationSourceObj.selectedDenomination.forEach(function (item) {
					_this53.model.denominationSourceObj.results.forEach(function (ele) {
						if (item.denominationId === ele.value) {
							ele.ticked = true;
							_this53.model.selectedDenomination.push({
								id: ele.value,
								label: ele.label,
								value: ele.value
							});
						}
					});
				});
				_this53.$scope.$apply();
			}, 100);
		}
	}, {
		key: 'getLocationLogs',
		value: function getLocationLogs(id) {
			this.Modal.locationLogs(id, function (_ref24) {
				var modal = _ref24.modal;
			}, function (_ref25) {
				var modal = _ref25.modal;

				if (modal) modal.close();
			});
		}
	}, {
		key: 'createLocationDenomination',
		value: function createLocationDenomination() {
			// if(this.model.selectedDenomination.length <= 0) this.getAllDenominations('', 0);

			// this.model.selectedDenomination.push({
			// 	denomination: null,
			// 	maxLoad: this.model._type === 'ATM' ? null : 0,
			// 	minResidualThreshold: this.model._type === 'ATM' ? null : 0,
			// 	maxResidualThreshold: this.model._type === 'ATM' ? null : 0,
			// 	minResidualThresholdPercentage: this.model._type === 'ATM' ? null : '0%',
			// 	maxResidualThresholdPercentage: this.model._type === 'ATM' ? null : '0%',
			// 	status: 'Create',
			// 	isNew: true,
			// 	disableFields: this.model._type === 'ATM' ? false : true
			// })
			this.model.selectedDenomination.push({
				denomination: null,
				maxLoad: null,
				minResidualThreshold: null,
				maxResidualThreshold: null,
				minResidualThresholdPercentage: null,
				maxResidualThresholdPercentage: null,
				status: 'Create',
				isNew: true,
				disableFields: false
			});
		}
	}, {
		key: 'isNewRow',
		value: function isNewRow(denomObj) {
			return denomObj.isNew === true;
		}
	}, {
		key: 'editDenominationSelected',
		value: function editDenominationSelected(index) {
			var selectedDenomination = this.model.selectedDenomination.find(function (e, i) {
				return i === index;
			});
			this.model.selectedDenomination[index].isEditing = true; //disabled denomination

			this.model.selectedDenomination[index].disableFields = false;

			if (selectedDenomination.locationBalanceActiveId == null && selectedDenomination.id) {
				selectedDenomination.locationBalanceActiveStatus = 'Create';
				selectedDenomination.denominationStatus = 'Update';
			} else if (selectedDenomination.locationBalanceActiveId && selectedDenomination.id) {
				selectedDenomination.status = 'Update';
			}
		}
	}, {
		key: 'deleteDenominationSelected',
		value: function deleteDenominationSelected(index) {
			var deletedDenom = this.model.selectedDenomination.splice(index, 1);
			if (!this.isNewRow(deletedDenom) && deletedDenom[0].id && deletedDenom[0].locationBalanceActiveId) {
				this.deletedLocationDenominationIds.push({
					locationDenominationId: deletedDenom[0].id,
					locationBalanceActiveId: deletedDenom[0].locationBalanceActiveId
				});
			}
			this.validateDenominationSelected();
			this.createLocationRecurringLoad();
		}
	}, {
		key: 'validateDenominationSelected',
		value: function validateDenominationSelected() {
			var _this54 = this;

			this.model.selectedDenomination = _lodash2.default.map(this.model.selectedDenomination, function (mainObj, mainIndex) {
				// if (mainObj.denomination && mainObj.denomination.coinFlag) {
				// 	mainObj.maxLoad = 0;
				// 	mainObj.minResidualThreshold = 0;
				// 	mainObj.maxResidualThreshold = 0;
				// 	mainObj.disableFields = true;
				// }
				// else {
				// 	mainObj.disableFields = false;
				// }

				mainObj.isDuplicate = false;

				var match = _lodash2.default.find(_this54.model.selectedDenomination, function (compairObject, compairObjIndex) {
					if (mainIndex > compairObjIndex && compairObject.denomination && mainObj.denomination && compairObject.denomination.Value && mainObj.denomination.Value) {
						return compairObject.denomination.Value === mainObj.denomination.Value;
					}
				});
				if (match) {
					mainObj.isDuplicate = true;
					return mainObj;
				} else {
					return mainObj;
				}
			});
			var isValid = this.model.selectedDenomination.map(function (obj) {
				if (obj.isDuplicate) return true;
			});
			this.isValid = isValid.indexOf(true) >= 0 ? false : true;
			this.validateLocationSlotsDuplicate();
			this.checkForMaxLoadFaceValueDivisibility();
		}
	}, {
		key: 'ngResidualPercentage',
		value: function ngResidualPercentage(index, type) {
			var item = this.model.selectedDenomination[index];
			if (type == 'min' && item.minResidualThresholdPercentage && !String(item.minResidualThresholdPercentage).endsWith('%')) {
				item.minResidualThreshold = item.minResidualThresholdPercentage / 100 + '%';
				return item.minResidualThresholdPercentage = item.minResidualThresholdPercentage + '%';
			} else if (type == 'max' && item.maxResidualThresholdPercentage && !String(item.maxResidualThresholdPercentage).endsWith('%')) {
				item.maxResidualThreshold = item.maxResidualThresholdPercentage / 100 + '%';
				return item.maxResidualThresholdPercentage = item.maxResidualThresholdPercentage + '%';
			}
		}
	}, {
		key: 'removeResidualPercentageSign',
		value: function removeResidualPercentageSign(index, type) {
			var item = this.model.selectedDenomination[index];
			if (type == 'min' && item.minResidualThresholdPercentage && item.minResidualThresholdPercentage.endsWith('%')) {
				item.minResidualThreshold = item.minResidualThreshold.replace('%', '');
				return item.minResidualThresholdPercentage = item.minResidualThresholdPercentage.replace('%', '');
			} else if (type == 'max' && item.maxResidualThresholdPercentage && item.maxResidualThresholdPercentage.endsWith('%')) {
				item.maxResidualThreshold = item.maxResidualThreshold.replace('%', '');
				return item.maxResidualThresholdPercentage = item.maxResidualThresholdPercentage.replace('%', '');
			}
		}
	}, {
		key: 'validateDisabledDenomFields',
		value: function validateDisabledDenomFields() {
			var _this55 = this;

			if (!this.model.selectedDenomination) return;
			this.model.selectedDenomination.forEach(function (data) {
				if (data.denomination && _this55.model._type !== 'ATM') {
					data.disableFields = true;
					// data.isDisabled = true;
					// data.isEditing = false;
				} else {
					data.disableFields = false;
					// data.isDisabled = false;
					// data.isEditing = true;
				}
			});
		}
	}, {
		key: 'setAlwaysSwapRatio',
		value: function setAlwaysSwapRatio() {
			if (!this.model.bankSourceId || this.model._type !== 'ATM') {
				this.model.addToSwapRatio = null;
				return;
			}

			if (this.model.bankSourceId && !this.model.addToSwapRatio) this.model.addToSwapRatio = 'ALWAYS_ADD';
		}
	}, {
		key: 'createLocationSlots',
		value: function createLocationSlots() {
			if (!this.model.locationSlotDenominations.results) {
				this.model.locationSlotDenominations.results = [];
			}
			var mxdDenominations = this.model.locationSlotDenominations.results.filter(function (d) {
				return d.shiptypeId === 'MXD';
			});
			this.model.locationSlots.push({
				denominationId: mxdDenominations[0] || null,
				slotTrackingId: '',
				isEditing: true,
				isDisabled: false
			});
			this.validateLocationSlotsDuplicate();
		}
	}, {
		key: 'editLocationSlot',
		value: function editLocationSlot(index) {
			var slot = this.model.locationSlots[index];
			slot.isEditing = true;
			slot.isDisabled = false;
			this.validateLocationSlotsDuplicate();
		}
	}, {
		key: 'deleteLocationSlotsSelected',
		value: function deleteLocationSlotsSelected(index) {
			if (!this.model.locationSlots) {
				this.model.locationSlots = [];
			}
			this.model.locationSlots.splice(index, 1);
			if (this.model.locationSlots.length === 0) {
				this.model.locationSlots = [];
			}
			this.validateLocationSlotsDuplicate();
		}
	}, {
		key: 'validateLocationSlotsDuplicate',
		value: function validateLocationSlotsDuplicate() {
			var _this56 = this;

			if (!this.model.locationSlots || this.model.locationSlots.length === 0) {
				this.duplicateLocationSlotError = false;
				return true;
			}
			this.model.locationSlots.forEach(function (slot) {
				return slot.isDuplicate = false;
			});
			var hasDuplicate = false;
			this.model.locationSlots.forEach(function (slot, index) {
				var denomId = slot.denominationId && (slot.denominationId.id || slot.denominationId.Value || slot.denominationId);
				var trackingId = (slot.slotTrackingId || '').trim().toLowerCase();
				var match = _this56.model.locationSlots.find(function (other, otherIdx) {
					if (index > otherIdx) {
						var otherDenomId = other.denominationId && (other.denominationId.id || other.denominationId.Value || other.denominationId);
						var otherTrackingId = (other.slotTrackingId || '').trim().toLowerCase();
						return denomId === otherDenomId && trackingId === otherTrackingId;
					}
					return false;
				});
				if (match) {
					slot.isDuplicate = true;
					hasDuplicate = true;
				}
			});
			this.duplicateLocationSlotError = hasDuplicate;
			return !hasDuplicate;
		}
	}, {
		key: 'onFlowThresholdBlur',
		value: function onFlowThresholdBlur() {
			if (this.model.balanceType === 'PERCENTAGE' && this.model.flowThreshold) {
				var val = parseFloat(this.model.flowThreshold.toString());
				if (!isNaN(val)) {
					this.model.flowThreshold = val + '%';
				}
			}
		}
	}, {
		key: 'onFlowThresholdFocus',
		value: function onFlowThresholdFocus() {
			if (this.model.balanceType === 'PERCENTAGE' && typeof this.model.flowThreshold === 'string') {
				this.model.flowThreshold = this.model.flowThreshold.replace('%', '');
			}
		}
	}, {
		key: 'resetFlowThreshold',
		value: function resetFlowThreshold() {
			this.model.flowThreshold = this.model.balanceType == 'PERCENTAGE' ? this.convertStr(0.2) / 100 : 0.2;
		}
	}, {
		key: 'hasValidEmails',
		value: function hasValidEmails(emailString) {
			var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (!emailString) return !isRequired;
			var emails = emailString.split(',').map(function (email) {
				return email.trim();
			});
			var uniqueEmails = new _set2.default();
			var _iteratorNormalCompletion15 = true;
			var _didIteratorError15 = false;
			var _iteratorError15 = undefined;

			try {
				for (var _iterator15 = (0, _getIterator3.default)(emails), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
					var email = _step15.value;

					if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
						return false;
					}
					if (uniqueEmails.has(email)) {
						return false;
					}
					uniqueEmails.add(email);
				}
			} catch (err) {
				_didIteratorError15 = true;
				_iteratorError15 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion15 && _iterator15.return) {
						_iterator15.return();
					}
				} finally {
					if (_didIteratorError15) {
						throw _iteratorError15;
					}
				}
			}

			return true;
		}
	}, {
		key: 'loadPickupRequestTimes',
		value: function loadPickupRequestTimes() {
			var _this57 = this;

			return this.LocationService.getPickupRequestTimes().then(function (data) {
				if (data.status) {
					_this57.pickupRequestTimes = data.data;
				}
			}).catch(function (err) {
				console.log('Error loading pickup request times:', err);
			});
		}
	}, {
		key: 'onMarkerDragEnd',
		value: function onMarkerDragEnd($event) {
			this.model.latitude = $event.latLng.lat();
			this.model.longitude = $event.latLng.lng();
			if (this.model.latitude && this.model.longitude) {
				this.getAddressFromLatLng(this.model.latitude, this.model.longitude);
			}
			document.getElementById("lat").value = this.model.latitude;
			document.getElementById("lng").value = this.model.longitude;
		}
	}, {
		key: 'toDecimalString',
		value: function toDecimalString(x) {
			return x.toFixed(Math.max(0, -Math.floor((0, _log2.default)(Math.abs(x))) + 3));
		}
	}]);
	return LocationEditController;
}(_locationBase2.default);

exports.default = LocationEditController;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locationImport_locations = __webpack_require__(1930);

var _locationImport_locations2 = _interopRequireDefault(_locationImport_locations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var importLocationsModule = angular.module('importLocations', []).component('importLocations', _locationImport_locations2.default).name;

exports.default = importLocationsModule;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _locationImport_locations = __webpack_require__(2743);

var _locationImport_locations2 = _interopRequireDefault(_locationImport_locations);

var _locationImport_locations3 = __webpack_require__(1931);

var _locationImport_locations4 = _interopRequireDefault(_locationImport_locations3);

__webpack_require__(3023);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var importLocationsComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template: _locationImport_locations2.default,
    controller: _locationImport_locations4.default
};

exports.default = importLocationsComponent;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _locationBase = __webpack_require__(107);

var _locationBase2 = _interopRequireDefault(_locationBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportLocationsController = function (_LocationBaseControll) {
    ImportLocationsController.$inject = ["Auth", "$state", "User", "LocationService", "Modal", "$translate", "$stateParams", "$http"];
    (0, _inherits3.default)(ImportLocationsController, _LocationBaseControll);

    /*@ngInject*/
    function ImportLocationsController(Auth, $state, User, LocationService, Modal, $translate, $stateParams, $http) {
        (0, _classCallCheck3.default)(this, ImportLocationsController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ImportLocationsController.__proto__ || (0, _getPrototypeOf2.default)(ImportLocationsController)).call(this, Auth, $state, User, LocationService, Modal, $translate, $stateParams));

        _this.LocationService = LocationService;
        // this.Upload = Upload;

        _this.$http = $http;
        _this.model = {
            locationFile: "",
            locationData: []
        };
        return _this;
    }

    (0, _createClass3.default)(ImportLocationsController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'uploadLocationData',
        value: function uploadLocationData() {
            var _this2 = this;

            var locationData = [];
            var url = _app2.default.api + '/location/import-locations-data';
            this.$http({
                url: url,
                method: "POST",
                data: { locations: this.model.locations }
                // headers: { 'Content-Type': undefined }
            }).then(function (response) {
                _this2.model.locationData = response.data;
            });
        }
    }, {
        key: 'uploadFile',
        value: function uploadFile() {
            // debugger;
            // this.Upload.upload({
            //     url: AppConstants.api + `/location/import-locations`,
            //     data: {file: this.model.file},
            //     method: 'POST'
            // }).then(function (resp) {
            //     console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
            // }, function (resp) {
            //     console.log('Error status: ' + resp.status);
            // }, function (evt) {
            //     var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            //     console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            // });

            // this.Upload.http({
            //     url: AppConstants.api + `/location/import-locations`,
            //     headers : {
            //         'Content-Type': 'text/csv'
            //     },
            //     data: this.model.file
            // });

            // console.log(event.target.files);
            // console.log(event.target.files[0]);
            // var formData = new FormData();
            // formData.append('file', event.target.files);
            // console.log(formData)
            // this.$http({
            //     url: AppConstants.api + `/location/add-route-sequence`,
            //     method: "POST",
            //     data: formData,
            //     headers: {'Content-Type': undefined}
            // }).then(function (response) {
            //     console.log(response);
            // });

            // $http
            // .post(AppConstants.api + `/location/create`, data)
            // .then((res) => {
            //     return res.data
            // })
            // httpPostFactory('upload_image.php', formData, function (callback) {
            //    // recieve image name to use in a ng-src 
            //     console.log(callback);
            // });

            //         let testData = new FormData();
            // testData.append('file_upload', this.file, this.file.name);
            // console.log(event.target.files);
            // this.LocationService,importRouteSequence()
            // .then(() => {
            // 
            // })
            // .catch((err) => {
            // console.log(err);
            // })
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model.locationFile = "";
        }
    }]);
    return ImportLocationsController;
}(_locationBase2.default);

exports.default = ImportLocationsController;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location = __webpack_require__(1933);

var _location2 = _interopRequireDefault(_location);

var _create = __webpack_require__(1923);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(1926);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(1915);

var _all2 = _interopRequireDefault(_all);

var _missinglatlng = __webpack_require__(1935);

var _missinglatlng2 = _interopRequireDefault(_missinglatlng);

var _deliver_location = __webpack_require__(1921);

var _deliver_location2 = _interopRequireDefault(_deliver_location);

var _import_locations = __webpack_require__(1929);

var _import_locations2 = _interopRequireDefault(_import_locations);

var _clone = __webpack_require__(1918);

var _clone2 = _interopRequireDefault(_clone);

var _print = __webpack_require__(1938);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationModule = angular.module('location', [_create2.default, _edit2.default, _all2.default, _missinglatlng2.default, _import_locations2.default, _clone2.default, _print2.default]).component('location', _location2.default).component('deliverLocation', _deliver_location2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('location.edit', {
    url: '/edit/:id',
    component: 'locationedit',
    data: {
      requireACL: 'setting-location.edit'
    }
  }).state('location.create', {
    url: '/create',
    component: 'locationcreate',
    data: {
      requireACL: 'setting-location.create'
    }
  }).state('location.all', {
    url: '/all/:page',
    component: 'locationall',
    data: {
      requireACL: 'setting-location.view'
    }
  }).state('location.missinglatlng', {
    url: '/missinglatlng/:page',
    component: 'locationMissinglatlng',
    data: {
      requireACL: 'setting-location.view'
    }
  }).state('location.import_locations', {
    url: '/import-locations/:page',
    component: 'importLocations',
    data: {
      requireACL: 'setting-location.importLocations'
    }
  }).state('location.clone', {
    url: '/clone',
    component: 'locationclone',
    data: {
      requireACL: 'setting-location.clone'
    }
  });
}]).name;

exports.default = locationModule;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location = __webpack_require__(2744);

var _location2 = _interopRequireDefault(_location);

var _location3 = __webpack_require__(1934);

var _location4 = _interopRequireDefault(_location3);

__webpack_require__(3024);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _location2.default,
  controller: _location4.default
};

exports.default = locationComponent;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationController = function (_SettingBase) {
  LocationController.$inject = ["$state"];
  (0, _inherits3.default)(LocationController, _SettingBase);

  /*@ngInject*/
  function LocationController($state) {
    (0, _classCallCheck3.default)(this, LocationController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LocationController.__proto__ || (0, _getPrototypeOf2.default)(LocationController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'location';
    _this.$state = $state;

    return _this;
  }

  (0, _createClass3.default)(LocationController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(LocationController.prototype.__proto__ || (0, _getPrototypeOf2.default)(LocationController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['setting-location']) {
        this.hasACL[this.acl['setting-location'][key]] = true;
      }
    }
  }]);
  return LocationController;
}(_SettingBase3.default);

exports.default = LocationController;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _locationMissinglatlng = __webpack_require__(1936);

var _locationMissinglatlng2 = _interopRequireDefault(_locationMissinglatlng);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationMissinglatlngModule = angular.module('locationMissinglatlng', []).component('locationMissinglatlng', _locationMissinglatlng2.default).name;

exports.default = locationMissinglatlngModule;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locationMissinglatlng = __webpack_require__(2745);

var _locationMissinglatlng2 = _interopRequireDefault(_locationMissinglatlng);

var _locationMissinglatlng3 = __webpack_require__(1937);

var _locationMissinglatlng4 = _interopRequireDefault(_locationMissinglatlng3);

__webpack_require__(3025);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationMissinglatlngComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _locationMissinglatlng2.default,
  controller: _locationMissinglatlng4.default
};

exports.default = locationMissinglatlngComponent;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _locationBase = __webpack_require__(107);

var _locationBase2 = _interopRequireDefault(_locationBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationMissinglatlngController = function (_LocationBaseControll) {
  LocationMissinglatlngController.$inject = ["Auth", "$state", "User", "Modal", "LocationService", "$translate", "$stateParams", "$scope", "$location", "SetupService"];
  (0, _inherits3.default)(LocationMissinglatlngController, _LocationBaseControll);

  /*@ngInject*/
  function LocationMissinglatlngController(Auth, $state, User, Modal, LocationService, $translate, $stateParams, $scope, $location, SetupService) {
    (0, _classCallCheck3.default)(this, LocationMissinglatlngController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LocationMissinglatlngController.__proto__ || (0, _getPrototypeOf2.default)(LocationMissinglatlngController)).call(this, Auth, $state, User, LocationService, Modal, $translate, $stateParams, $location));

    _this.loadImage = function (image) {
      var imgURL = this.icon[image];
      return __webpack_require__(51)("./" + imgURL);
    };

    _this.id = 'location.all';
    _this.loading = false; //true
    _this.locations = [];
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.hasACL = {};
    _this.$location = $location;
    _this.branch = User.getUser().branchId;
    _this.customerId = User.getUser().customerUser ? User.getUser().customerId : null;
    _this.SetupService = SetupService;
    _this.enableGeoCoding = "";

    _this.icon = {
      'REGULAR': 'regular.png',
      'ATM': 'atm.png',
      'BANK': 'bank.png',
      'NO_SHIP_NO_GO': 'nsng.png',
      'INTERNAL': 'internal.png',
      'TRUCK': 'truck.png',
      'TANKER': 'tanker.png',
      'WINDOW': 'window.png',
      'ON_CALL': 'oncall.png',
      'CARRIER': 'carrier.png',
      'LOCKER': 'locker.png',
      'VAULT': 'vault.png',
      'DELIVERY': 'delivery.png'
    };
    _this.searchObj = {
      type: '',
      text: ''
    };
    _this.locationTypeList = ['', 'DELIVERY', 'ATM', 'Regular', 'Bank', 'ON_CALL', 'LOCKER', 'NO_SHIP_NO_GO', 'Internal', 'Truck', 'Tanker', 'Carrier', 'Window', 'VAULT'];
    _this.locationTypes = _this.locationTypeList.map(function (list) {
      if (list == '') {
        return {
          value: '',
          label: $translate.instant('location_types.All')
        };
      }
      return {
        value: list,
        label: $translate.instant('location_types.' + list)
      };
    });
    return _this;
  }

  (0, _createClass3.default)(LocationMissinglatlngController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }

      this.SetupService.get(this.branch).then(function (data) {
        _this2.enableGeoCoding = data.enableGeoCoding;
      }).then(function () {
        _this2.loadData();
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'edit',
    value: function edit(location) {
      this.$state.go('location.edit', {
        id: location.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(location) {
      var _this3 = this;

      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + location.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this3.Service.remove(location.id).then(function (data) {
            modal.close();
            _this3.refresh();
          });
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this4 = this;

      var searchObj = this.generateSearchObj();
      this.loading = true;
      this.Service.getAllLocation(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this4.total = data.total;

        _this4.loading = false;
        _this4.locations = data.results;
      }).catch(function (err) {
        _this4.loading = false;
        _this4.error = err.message;
      });
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      var obj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.branch
          }, {
            group: {
              rules: [{
                field: 'lat',
                condition: 'IS NULL'
              }, {
                field: 'long',
                condition: 'IS NULL'
              }],
              operator: 'OR'
            }
          }, {
            group: {
              rules: [{
                field: 'locationType',
                condition: '!=',
                data: 'TANKER'
              }, {
                field: 'locationType',
                condition: '!=',
                data: 'INTERNAL'
              }],
              operator: 'AND'
            }
          }],
          operator: 'AND'
        }
      };

      if (this.customerId) {
        obj.queryJSON.rules.push({
          field: 'customerId',
          condition: '=',
          data: this.customerId
        });
      }
      if (this.searchObj.text) {
        obj.queryJSON.rules.push({
          "group": {
            "rules": [{
              "data": "%" + this.searchObj.text + "%",
              "field": "id",
              "condition": "like"
            }, {
              "data": "%" + this.searchObj.text + "%",
              "field": "name",
              "condition": "like"
            }],
            "operator": "OR"
          }
        });
      }

      if (this.searchObj.type) {
        obj.queryJSON.rules.push({
          field: 'locationType',
          condition: '=',
          data: this.searchObj.type
        });
      }

      return obj.queryJSON.rules.length ? obj : { branch: this.branch };
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(location) {
      location.expand = !location.expand;
    }
  }, {
    key: 'fixGeoCode',
    value: function fixGeoCode() {
      var _this5 = this;

      this.model.loading = true;
      this.Service.fixGeocoding(this.branch, []).then(function (data) {
        _this5.loadData();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this5.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this5.model.loading = false;
      });
    }
  }]);
  return LocationMissinglatlngController;
}(_locationBase2.default);

exports.default = LocationMissinglatlngController;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _print_location_barcodes = __webpack_require__(1939);

var _print_location_barcodes2 = _interopRequireDefault(_print_location_barcodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printLocationBarcodesModule = angular.module('printLocationBarcodes', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$stateProvider.state('printLocationBarcodes', {
		url: '/print-location-barcodes',
		component: 'printLocationBarcodes',
		data: {
			requireLogin: true,
			requireACL: 'setting-location.view'
		}
	});
}]).component('printLocationBarcodes', _print_location_barcodes2.default).name;

exports.default = printLocationBarcodesModule;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_location_barcodes = __webpack_require__(2746);

var _print_location_barcodes2 = _interopRequireDefault(_print_location_barcodes);

var _print_location_barcodes3 = __webpack_require__(1940);

var _print_location_barcodes4 = _interopRequireDefault(_print_location_barcodes3);

__webpack_require__(3026);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printLocationBarcodesComponent = {
  restrict: 'E',
  bindings: {},
  template: _print_location_barcodes2.default,
  controller: _print_location_barcodes4.default
};

exports.default = printLocationBarcodesComponent;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintLocationBarcodesController = function () {
    /*@ngInject*/
    PrintLocationBarcodesController.$inject = ["$state", "$stateParams", "$translate"];
    function PrintLocationBarcodesController($state, $stateParams, $translate) {
        (0, _classCallCheck3.default)(this, PrintLocationBarcodesController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.model = {
            selectedLocations: [],
            barcodeOptions: {
                format: 'CODE128', lineColor: '#030303', width: 3.7, height: 80, displayValue: true,
                font: 'monospace', textAlign: 'center', textPosition: 'bottom', textMargin: 0, fontSize: 20,
                marginTop: 0, marginBottom: 0
            }
        };
    }

    (0, _createClass3.default)(PrintLocationBarcodesController, [{
        key: '$onInit',
        value: function $onInit() {
            var printData = undefined;
            if (window.opener && window.opener.w && window.opener.w.printData) {
                printData = window.opener.w.printData;
                this.model.selectedLocations = printData.selectedLocations;
                setTimeout(function () {
                    window.print();
                }, 1500);
            }
        }
    }]);
    return PrintLocationBarcodesController;
}();

exports.default = PrintLocationBarcodesController;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logAll = __webpack_require__(1942);

var _logAll2 = _interopRequireDefault(_logAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logallModule = angular.module('logall', []).component('logall', _logAll2.default).name;

exports.default = logallModule;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logAll = __webpack_require__(2747);

var _logAll2 = _interopRequireDefault(_logAll);

var _logAll3 = __webpack_require__(1943);

var _logAll4 = _interopRequireDefault(_logAll3);

__webpack_require__(3027);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _logAll2.default,
  controller: _logAll4.default
};

exports.default = logallComponent;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _logBase = __webpack_require__(1944);

var _logBase2 = _interopRequireDefault(_logBase);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogAllController = function (_LogBaseController) {
  LogAllController.$inject = ["Auth", "$state", "User", "Modal", "LogService", "$translate", "$stateParams", "$location", "$q", "SetupService", "DateUtil", "UserBranchService", "DataCounter"];
  (0, _inherits3.default)(LogAllController, _LogBaseController);

  /*@ngInject*/
  function LogAllController(Auth, $state, User, Modal, LogService, $translate, $stateParams, $location, $q, SetupService, DateUtil, UserBranchService, DataCounter) {
    (0, _classCallCheck3.default)(this, LogAllController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LogAllController.__proto__ || (0, _getPrototypeOf2.default)(LogAllController)).call(this, Auth, $state, User, LogService, Modal, $translate, $stateParams, $location, $q, SetupService, DateUtil, UserBranchService));

    _this.loading = false;
    _this.logs = [];
    _this.hasAcl = {};
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 25;
    _this.maxPages = 10;
    _this.searchText = '';
    _this.logsOf = '';
    // this.entryType = ''
    _this.$location = $location;
    _this.DateUtil = DateUtil;
    _this.$q = $q;
    _this.SetupService = SetupService;
    _this.UserBranchService = UserBranchService;
    _this.DataCounter = DataCounter;
    _this.entryTypes = [];
    _this.model = {
      branchId: null,
      dateRange: {
        startDate: '',
        endDate: ''
      },
      loggedInUser: User.getUser().id
    };
    return _this;
  }

  (0, _createClass3.default)(LogAllController, [{
    key: 'setDateRange',
    value: function setDateRange(date) {
      var _this2 = this;

      var currentVaultDate = date || moment();
      this.model.dateRangPickerOptions = {
        autoApply: true,
        eventHandlers: {
          'apply.daterangepicker': function applyDaterangepicker() {
            _this2.page = 1;
            _this2.loadData(_this2.model.dateRange);
          }
        },
        ranges: {
          'Today': [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
          'Current Week': [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')],
          'Current Month': [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]
        }
      };
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this3 = this;

      this.billableEventObj = this.DataCounter.getData();
      if (this.billableEventObj && this.billableEventObj.isRedirected) {
        this.searchText = this.billableEventObj.searchText;
        this.entryType = this.billableEventObj.billableEvent;
        this.branchId = this.billableEventObj.branchId;
      }

      this.model.loading = true;
      var pageId = this.$stateParams.page,
          branch = this.User.getUser().branchId;

      if (pageId > 0) {
        this.page = pageId;
      }

      this.$q.all([this.SetupService.get(branch), this.UserBranchService.getUserBranches(this.model.loggedInUser)]).then(function (data) {
        _this3.currentVaultDate = _this3.DateUtil.convertToDate(data[0].currentVaultDate);
        _this3.vaultDate = moment().format('YYYY-MM-DD');
        _this3.setDateRange(_this3.vaultDate);

        if (_this3.billableEventObj && _this3.billableEventObj.isRedirected) {
          _this3.model.dateRange.startDate = moment(_this3.billableEventObj.createdAt).format('YYYY-MM-DD 00:00:00');
          _this3.model.dateRange.endDate = moment(_this3.billableEventObj.createdAt).add(1, 'days').format('YYYY-MM-DD 23:59:59');
        } else {
          _this3.model.dateRange.startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
          _this3.model.dateRange.endDate = moment().endOf('week').format('YYYY-MM-DD HH:mm:ss');
        }

        _this3.branches = data[1].results;
        _this3.model.branchId = branch;
      }).then(function () {
        _this3.loadData();
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this3.model.loading = false;
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      return {
        logsOf: this.logsOf,
        entryType: this.entryType,
        queryText: this.searchText,
        isQuery: false,
        startDate: moment(this.model.dateRange.startDate).startOf('day').format('YYYY-MM-DD 00:00:00'),
        endDate: moment(this.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        branchId: this.model.branchId || ''
      };
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this4 = this;

      var searchObj = this.generateSearchObj();

      this.loading = true;
      this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this4.total = data.total;
        _this4.loading = false;
        _this4.logs = data.results;

        _this4.logs.forEach(function (log) {

          log.readableEntryType = _this4.$translate.instant('entry_type.' + log.entryType);
          if (log.entryData) {
            log.extraDetails = (0, _entries2.default)(log.entryData).map(function (entry) {
              return {
                key: entry[0],
                value: (0, _typeof3.default)(entry[1]) === 'object' ? (0, _stringify2.default)(entry[1]) : entry[1]
              };
            });
          }
        });
        if (data.allEntryTypes.length > 0) {
          _this4.entryTypes = data.allEntryTypes.map(function (entryType) {
            return {
              label: _this4.$translate.instant('entry_type.' + entryType),
              value: entryType
            };
          });
        }
      }).then(function () {
        _this4.resetRedirectionData();
      }).catch(function (err) {
        _this4.loading = false;
        _this4.error = err.message;
      });
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(log) {
      log.expand = !log.expand;
    }
  }, {
    key: 'setLogsOf',
    value: function setLogsOf(value) {
      this.logsOf = this.logsOf === value ? undefined : value;
      this.loadData();
    }
  }, {
    key: 'filterData',
    value: function filterData() {
      this.page = 1;
      this.loadData();
    }
  }, {
    key: 'showShipmentReceipt',
    value: function showShipmentReceipt(log, stats) {
      var shipmentObj = {};

      log.forEach(function (details) {
        (0, _assign2.default)(shipmentObj, new Object((0, _defineProperty3.default)({}, details.key, details.value)));
      });

      document.getElementById('shipment-image').blur();
      this.Modal.shipmentImageModal(shipmentObj, shipmentObj.trackingId, stats, function (_ref2) {
        var modal = _ref2.modal;
      }, function (_ref3) {
        var modal = _ref3.modal;

        modal.close();
      });
    }
  }, {
    key: 'resetRedirectionData',
    value: function resetRedirectionData() {
      if (this.billableEventObj) {
        this.billableEventObj.isRedirected = false;
        this.billableEventObj = this.DataCounter.setData();
      }
    }
  }]);
  return LogAllController;
}(_logBase2.default);

exports.default = LogAllController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _commonBase = __webpack_require__(44);

var _commonBase2 = _interopRequireDefault(_commonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogBaseController = function (_CommonBase) {
  LogBaseController.$inject = ["Auth", "$state", "User", "Service", "Modal", "$translate", "$stateParams"];
  (0, _inherits3.default)(LogBaseController, _CommonBase);

  /*@ngInject*/
  function LogBaseController(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, LogBaseController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LogBaseController.__proto__ || (0, _getPrototypeOf2.default)(LogBaseController)).call(this, Auth, $state, User, Service, Modal, $translate, $stateParams));

    _this.errors = {};
    _this.model = {};
    _this.loading = false;
    _this.errorMessage = '';
    _this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: 'Yes',
        off: 'No'
      },
      onColor: 'success',
      offColor: 'danger'
    };

    return _this;
  }

  return LogBaseController;
}(_commonBase2.default);

exports.default = LogBaseController;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _log = __webpack_require__(1946);

var _log2 = _interopRequireDefault(_log);

var _all = __webpack_require__(1941);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logModule = angular.module('item', [_all2.default]).component('log', _log2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('log.all', {
    url: '/all/:page',
    component: 'logall'
  });
}]).name;

exports.default = logModule;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _log = __webpack_require__(2748);

var _log2 = _interopRequireDefault(_log);

var _log3 = __webpack_require__(1947);

var _log4 = _interopRequireDefault(_log3);

__webpack_require__(3028);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _log2.default,
  controller: _log4.default
};

exports.default = logComponent;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogController = function (_SettingBase) {
  LogController.$inject = ["$state"];
  (0, _inherits3.default)(LogController, _SettingBase);

  /*@ngInject*/
  function LogController($state) {
    (0, _classCallCheck3.default)(this, LogController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LogController.__proto__ || (0, _getPrototypeOf2.default)(LogController)).call(this));

    _this.$state = $state;
    _this.id = "log";
    _this.acl = {};
    _this.hasACL = {};

    return _this;
  }

  (0, _createClass3.default)(LogController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(LogController.prototype.__proto__ || (0, _getPrototypeOf2.default)(LogController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['setting-' + this.id]) {
        this.hasACL[this.acl['setting-' + this.id][key]] = true;
      }
    }
  }]);
  return LogController;
}(_SettingBase3.default);

exports.default = LogController;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _login = __webpack_require__(2749);

var _login2 = _interopRequireDefault(_login);

var _login3 = __webpack_require__(1949);

var _login4 = _interopRequireDefault(_login3);

__webpack_require__(3029);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loginComponent = {
  restrict: 'E',
  bindings: {},
  template: _login2.default,
  controller: _login4.default
};

exports.default = loginComponent;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginController = function () {
  /*@ngInject*/
  LoginController.$inject = ["Auth", "User", "$state", "$location", "$translate", "EnvironmentConfigService", "Configs", "Idle", "UserService"];
  function LoginController(Auth, User, $state, $location, $translate, EnvironmentConfigService, Configs, Idle, UserService) {
    (0, _classCallCheck3.default)(this, LoginController);

    this.Auth = Auth;
    this.User = User;
    this.$state = $state;
    this.$location = $location;
    this.EnvironmentConfigService = EnvironmentConfigService;
    this.Configs = Configs;
    this.Idle = Idle;
    this.UserService = UserService;
    this.isLoggedIn = false;
    if (Auth.isAuthenticated()) {
      this.$state.go('home');
    }
    this.$translate = $translate;

    this.name = 'Login';
    this.userCredentials = {
      emailOrUserId: '',
      password: ''
    };

    this.error = '';
    this.appData = '';
    this.model = {
      passwordPolicy: null
    };
  }

  (0, _createClass3.default)(LoginController, [{
    key: '$onInit',
    value: function $onInit() {
      this.mobileAppData();
      if (this.Idle.running() && !this.Auth.isAuthenticated()) {
        this.Idle.unwatch();
      }
    }
  }, {
    key: 'mobileAppData',
    value: function mobileAppData() {
      var _this = this;

      this.EnvironmentConfigService.getUIConfigs().then(function (data) {
        _this.appData = data.results.mobileAppDownloadLinks;
        var envConfig = data.results.environmentConfig;
        _this.Configs.setEnvironmentConfig(envConfig);
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'downloadFile',
    value: function downloadFile() {
      var link = document.createElement("a");
      link.download = "TNTMobile";
      link.href = this.appData.android.downloadLink;
      link.click();
    }
  }, {
    key: 'login',
    value: function login() {
      var _this2 = this;

      if (!this.isLoggedIn) {
        this.isLoggedIn = true;
        this.error = '';

        this.Auth.login(this.userCredentials).then(function (data) {

          if (data && data.message !== 'failed' && !data.validate2FA) {
            _this2.User.setUser(data);
            var sessionLength = JSON.parse(localStorage.getItem('sessionLength'));
            if (!_this2.Idle.running() && sessionLength) {
              _this2.Idle.watch();
            }
            if (sessionLength) {
              _this2.Idle.setIdle(sessionLength * 60);
            }
            _this2.$translate.use(data.languageId.id || data.languageId);

            var prevStateData = _this2.User.getPrevState();
            var hasSpecificPrevState = false;
            var prevUrl = '';
            if (prevStateData && prevStateData['hash']) {
              prevUrl = prevStateData['hash'];
              if (prevUrl !== '#/home' && prevUrl !== '/home' && prevUrl !== '#/' && prevUrl !== '/') {
                hasSpecificPrevState = true;
              }
            }

            if (data.customerUser) {
              _this2.UserService.acl(data.id, data.branchId).then(function (aclData) {
                _this2.User.setACL(aclData);

                var redirectState = null;
                var perMap = _this2.Auth.permissionMap();

                var findState = function findState(resources, targetResourceName) {
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(resources)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                          key = _step$value[0],
                          resObj = _step$value[1];

                      if (key === targetResourceName) {
                        return resObj.redirectState || resObj.state;
                      }
                      if (resObj.child) {
                        var childState = findState(resObj.child, targetResourceName);
                        if (childState) return childState;
                      }
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }

                  return null;
                };

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(aclData)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
                        resName = _step2$value[0],
                        perms = _step2$value[1];

                    if (Array.isArray(perms) && perms.includes('default_redirect')) {
                      var matchedState = findState(perMap, resName);
                      if (matchedState) {
                        redirectState = matchedState;
                        break;
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }

                if (!redirectState) {
                  if (hasSpecificPrevState) {
                    _this2.User.setPrevState('');
                    _this2.$location.path(prevUrl.substr(2));
                    return;
                  }
                  redirectState = 'app.userProfile';
                }

                var url = _this2.$state.href(redirectState, { page: 1 });
                if (url && (url.includes('index.html') || url.includes('/v2/'))) {
                  var idx = url.indexOf('/v2/');
                  if (idx !== -1) {
                    url = url.substring(idx);
                  } else {
                    var idx2 = url.indexOf('index.html');
                    if (idx2 !== -1) {
                      url = '/' + url.substring(idx2);
                    }
                  }
                  if (redirectState.startsWith('branchManagement.')) {
                    url = url.replace('#/branch-management/', '#/');
                  }
                  window.open(url, '_self');
                } else {
                  _this2.$state.go(redirectState, { page: 1 });
                }
              }).catch(function (err) {
                console.error('Error loading ACL on login:', err);
                if (hasSpecificPrevState) {
                  _this2.User.setPrevState('');
                  _this2.$location.path(prevUrl.substr(2));
                } else {
                  _this2.$state.go('app.userProfile');
                }
              });
            } else if (hasSpecificPrevState) {
              _this2.User.setPrevState('');
              _this2.$location.path(prevUrl.substr(2));
            } else {
              _this2.$state.go('home');
            }
          } else if (data && data.message == 'failed') {
            _this2.model.passwordPolicy = data;
          } else if (data.validate2FA) {
            _this2.$state.go('verify_2FA_code', {
              userId: _this2.userCredentials.emailOrUserId
            });
          }
          _this2.isLoggedIn = false;
        }, function (err) {
          _this2.error = err.data.message;
          _this2.isLoggedIn = false;
        });
      }
    }
  }]);
  return LoginController;
}();

exports.default = LoginController;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _login = __webpack_require__(1948);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loginModule = angular.module('login', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/login');

  $stateProvider.state('login', {
    url: '/login',
    component: 'login',
    data: {
      requireLogin: false
    }
  });
}]).component('login', _login2.default).name;

exports.default = loginModule;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _main = __webpack_require__(1952);

var _main2 = _interopRequireDefault(_main);

var _settings = __webpack_require__(526);

var _settings2 = _interopRequireDefault(_settings);

var _access_denied = __webpack_require__(524);

var _access_denied2 = _interopRequireDefault(_access_denied);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mainModule = angular.module('main', [_settings2.default, _access_denied2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/app');

  $stateProvider.state('app', {
    url: '/app',
    component: 'app',
    data: {
      requireLogin: true
    },
    resolve: {
      getACL: ["$q", "UserService", "User", "$state", function getACL($q, UserService, User, $state) {
        var de = $q.defer();
        UserService.acl().then(function (data) {
          User.setACL(data);
          de.resolve('done');
        }).catch(function (err) {
          de.reject($state.target('login', undefined, {
            location: true
          }));
        });

        return de.promise;
      }]
    }
  });
}]).component('main', _main2.default).name;

exports.default = mainModule;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _main = __webpack_require__(2750);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(1953);

var _main4 = _interopRequireDefault(_main3);

__webpack_require__(3030);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mainComponent = {
  restrict: 'E',
  bindings: {},
  template: _main2.default,
  controller: _main4.default
};

exports.default = mainComponent;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MainController =
/*@ngInject*/
["Auth", "$state", "User", "UserService", function MainController(Auth, $state, User, UserService) {
  (0, _classCallCheck3.default)(this, MainController);


  this.Auth = Auth;
  this.$state = $state;
  this.User = User;
  this.message = 'Welcome to Rangers';
}];

exports.default = MainController;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _master_cash_schedule = __webpack_require__(1955);

var _master_cash_schedule2 = _interopRequireDefault(_master_cash_schedule);

var _print = __webpack_require__(1957);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var masterCashScheduleModule = angular.module('masterCashSchedule', [_print2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/master-cash-schedule');

    $stateProvider.state('masterCashSchedule', {
        url: '/master-cash-schedule',
        component: 'masterCashSchedule',
        data: {
            requireLogin: true,
            requireACL: 'master_cash_schedule.view'
        },
        parent: 'app'
    });
}]).component('masterCashSchedule', _master_cash_schedule2.default).name;

exports.default = masterCashScheduleModule;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _master_cash_schedule = __webpack_require__(2751);

var _master_cash_schedule2 = _interopRequireDefault(_master_cash_schedule);

var _master_cash_schedule3 = __webpack_require__(1956);

var _master_cash_schedule4 = _interopRequireDefault(_master_cash_schedule3);

__webpack_require__(3031);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MasterCashSchedualeComponent = {
    restrict: 'E',
    template: _master_cash_schedule2.default,
    controller: _master_cash_schedule4.default
};

exports.default = MasterCashSchedualeComponent;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNan = __webpack_require__(621);

var _isNan2 = _interopRequireDefault(_isNan);

var _isFinite = __webpack_require__(315);

var _isFinite2 = _interopRequireDefault(_isFinite);

var _map = __webpack_require__(76);

var _map2 = _interopRequireDefault(_map);

var _from = __webpack_require__(75);

var _from2 = _interopRequireDefault(_from);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MasterCashScheduleController = function () {
  /*@ngInject*/
  MasterCashScheduleController.$inject = ["$state", "$q", "$window", "$scope", "Modal", "User", "SetupService", "DateUtil", "Sound", "$translate", "DenominationService", "UserBranchService", "$rootScope", "BranchFundingSourceService", "CustomerService", "LocationService", "CommonLayoutService", "RouteService", "OrderViewService", "Navigation", "DataCounter", "ShiptypeService", "ShipmentService", "OrderPackingService", "ServiceOrderService", "UserBranchFundingSourceService", "$location"];
  function MasterCashScheduleController($state, $q, $window, $scope, Modal, User, SetupService, DateUtil, Sound, $translate, DenominationService, UserBranchService, $rootScope, BranchFundingSourceService, CustomerService, LocationService, CommonLayoutService, RouteService, OrderViewService, Navigation, DataCounter, ShiptypeService, ShipmentService, OrderPackingService, ServiceOrderService, UserBranchFundingSourceService, $location) {
    var _this = this;

    (0, _classCallCheck3.default)(this, MasterCashScheduleController);

    this.getStartDateForCalendar = function (selectedDate) {
      var lastDayOfPreviousMonth = new Date(selectedDate.setDate(0));

      // start by setting the starting date of the calendar same as the last day of previous month
      var startingDateOfCalendar = lastDayOfPreviousMonth;

      // but since we actually want to find the last Monday of previous month
      // we will start going back in days intil we encounter our last Monday of previous month
      if (startingDateOfCalendar.getDay() != 0) {
        do {
          startingDateOfCalendar = new Date(startingDateOfCalendar.setDate(startingDateOfCalendar.getDate() - 1));
        } while (startingDateOfCalendar.getDay() != 0);
      }

      return startingDateOfCalendar;
    };

    this.loadImage = function (image) {
      var imgURL = this.icon[image];
      return __webpack_require__(51)("./" + imgURL);
    };

    this.redirectToOrderPack = function (order) {
      var data = {
        orderNo: order.orderNo,
        routeId: order.routeId,
        vaultDate: moment(_this.model.selectedBranch.currentVaultDate).format('YYYY-MM-DD'),
        locationId: order.toLocationId,
        fundingSourceId: order.fundingSourceId,
        isRedirected: true
      };
      _this.DataCounter.setData(data);
      _this.$location.url('/app/order-packing');
    };

    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$state = $state;
    this.$window = $window;
    this.User = User;
    this.SetupService = SetupService;
    this.DenominationService = DenominationService;
    this.CustomerService = CustomerService;
    this.LocationService = LocationService;
    this.DateUtil = DateUtil;
    this.UserBranchService = UserBranchService;
    this.BranchFundingSourceService = BranchFundingSourceService;
    this.RouteService = RouteService;
    this.CommonLayoutService = CommonLayoutService;
    this.OrderViewService = OrderViewService;
    this.Navigation = Navigation;
    this.DataCounter = DataCounter;
    this.Modal = Modal;
    this.$scope = $scope;
    this.MAXLIMIT = 1000;
    this.ShiptypeService = ShiptypeService;
    this.ShipmentService = ShipmentService;
    this.ServiceOrderService = ServiceOrderService;
    this.OrderPackingService = OrderPackingService;
    this.$translate = $translate;
    this.$location = $location;
    this.UserBranchFundingSourceService = UserBranchFundingSourceService;
    this.$currentTab = "";
    this.$currentViewTab = "table";
    this.icon = {
      'REGULAR': 'regular.png',
      'ATM': 'atm.png',
      'BANK': 'bank.png',
      'NO_SHIP_NO_GO': 'nsng.png',
      'INTERNAL': 'internal.png',
      'TRUCK': 'truck.png',
      'TANKER': 'tanker.png',
      'WINDOW': 'window.png',
      'ON_CALL': 'oncall.png',
      'CARRIER': 'carrier.png',
      'LOCKER': 'locker.png',
      'VAULT': 'vault.png',
      'DELIVERY': 'delivery.png'
    };
    this.filterDataSet = {
      userBranches: [],
      branchFundingSource: [],
      totalBranchFundingSource: 0,
      status: [],
      totalCustomer: 0,
      customerList: [],
      totalLocation: 0,
      locationList: [],
      orderTypes: this.CommonLayoutService.orderTypes(),
      denomsList: [],
      multiPackabledenomsList: [],
      singlePackabledenomsList: [],
      routeList: [],
      totalRoutes: 0,
      currentVaultDate: null
    };

    this.mainPageFilters = {
      totalLocation: 0,
      locationList: [],
      offset: 0
    };
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();

    this.allStatus = [{ Value: 'pendingPack', Key: 'Pending Pack' }, { Value: 'CRVed', Key: 'CRVed' }, { Value: 'packed', Key: 'Packed' }, { Value: 'completed', Key: 'Completed' }, { Value: 'hold', Key: 'Hold' }, { Value: 'scheduled', Key: 'Scheduled' }];
    this.filterDataSet.status = this.allStatus;
    this.filterDataSet.totalStatus = this.filterDataSet.status.length;

    this.monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    this.weekDaysName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    this.denominationAllType = [];
    this.allDenoms = [];
    this.denomModelType = ['single', 'multi', 'atm'];
    this.sortColumn = '';
    this.reverseSort = false;
    this.allOrderTypes = [];

    this.handleOrderTypeChange = function (value) {
      if (_this.newCash.status === 'scheduled') {
        _this.newCash.shiptypeId = value;
      } else {
        _this.newCash.orderType = value;
      }
    };

    this.updateOrderTypeOrShiptypeId = function () {
      _this.newCash.orderTypeOrShiptypeId = _this.newCash.orderType || _this.newCash.shiptypeId;
    };

    this.newCash = {
      orderNo: null,
      locationId: null,
      orderType: null,
      vaultDate: null,
      routeId: null,
      denominations: [],
      trackingIdDelivery: null,
      batchId: null,
      multiDenomPackableDenoms: [],
      singleDenomPackableDenoms: [],
      remainingDenominations: [],
      multiDenominations: [],
      remainingMultiDenominations: [],
      remainingAtmDenominations: [],
      atmDenominations: [],
      isInteracted: false
    };

    this.newCash.orderTypeOrShiptypeId = null;

    this.updatedCash = {
      orderNo: null,
      locationId: null,
      orderType: null,
      vaultDate: null,
      routeId: null,
      denominations: [],
      trackingIdDelivery: null,
      batchId: null,
      multiDenominations: []
    };

    this.filter = {};
    this.branchId = this.User.getUser().branchId;
    this.userDetails = this.User.getUser();
    this._calendar = {
      displayMonth: "",
      displayYear: "",
      monthIndex: 0,
      selectedDateData: null
    };
    this.calendarDays = [];
    this.dateRangPickerOptions = {
      autoApply: true,
      eventHandlers: {
        "apply.daterangepicker": function applyDaterangepicker() {
          // console.log(this.dateRangeOptions.startDate)
          _this.generateCalendarDays(_this._calendar.monthIndex, _this.dateRangeOptions.startDate.format("MMM DD YYYY"));
        }
      }
    };
    this.$rootScope.$broadcast("routeChange", "/app/master-cash-schedule");
    this.currentOrderStat = null;
    this.orderStatObj = {
      atRisk: "atRisk",
      ATM: "ATM",
      Cash: "Cash",
      Scheduled: "Scheduled",
      All: "All"
    };

    this.shipmentsCreateStats = {
      prePacked: { all: "prePacked" },
      cashDeliveries: { single: "single", recurring: "recurring", all: "cashDeliveries" },
      ATMOrders: { single: "single", recurring: "recurring", all: "ATMOrdersView" },
      stops: { multiple: "multiple" }
    };

    this.model = {
      // currentScheduledStats: 'ATM',
      currentStats: this.shipmentsCreateStats.prePacked.all,
      currentChildStat: null,
      ATMLoadAccountStats: {
        regular: "Regular",
        emergency: "Emergency"
      }
    };

    this.istevenMultiSelectLocalLang = {
      selectAll: "Select all",
      selectNone: "Select None",
      reset: "Reset",
      search: "Search.",
      nothingSelected: "Select Denomination"
    };

    this.denominationTypeMapping = {
      PENNY: {
        category: "01",
        categoryName: "coin1",
        template: null,
        coinFlag: true
      },
      NICKEL: {
        category: "05",
        categoryName: "coin5",
        template: null,
        coinFlag: true
      },
      DIMES: {
        category: "10",
        categoryName: "coin10",
        template: null,
        coinFlag: true
      },
      QUARTER: {
        category: "25",
        categoryName: "coin25",
        template: null,
        coinFlag: true
      },
      HALF_US_DOLLAR: {
        category: "50",
        categoryName: "coin50",
        template: null,
        coinFlag: true
      },
      ONE_US_DOLLAR: {
        category: "1$",
        categoryName: "coin1$",
        template: null,
        coinFlag: true
      },
      COIN_MISC: {}
    };
    this.coinTypes = {};

    this.fromLocationObj = {
      results: [],
      totalRecords: 0,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      loading: false
    };

    this.deliveryLocationObj = {
      results: [],
      totalRecords: 0,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      loading: false
    };

    // this.scheduledATMShipmentObj = {
    //     results: [],
    //     totalRecords: 0,
    //     pagination: {
    //         page: 1,
    //         total: 0,
    //         pageLimit: 10,
    //         maxPages: 10
    //     },
    //     loading: false,
    // }

    // this.scheduledCashShipmentObj = {
    //     results: [],
    //     totalRecords: 0,
    //     pagination: {
    //         page: 1,
    //         total: 0,
    //         pageLimit: 10,
    //         maxPages: 10
    //     },
    //     loading: false,
    // }


    this.getHeaderTotal = function () {

      if (!_this.newCash) return 0;

      // When editing a packable (Change) order, use shipment-level cash/coin
      if (_this.newCash.isPackableOrder) {
        var cashFromShipments = _this.newCash.cashShipmentAmount || 0;
        var coinFromShipments = _this.newCash.coinShipmentAmount || 0;
        var packableTotal = cashFromShipments + coinFromShipments;
        if (packableTotal > 0) {
          return packableTotal;
        }
      } else {
        // For non-packable (ATM / COD) orders, use cashAmount + coinAmount
        var cashFromFields = _this.newCash.cashAmount || 0;
        var coinFromFields = _this.newCash.coinAmount || 0;
        var liveTotal = cashFromFields + coinFromFields;
        if (liveTotal > 0) {
          return liveTotal;
        }
      }

      return 0;
    };

    // this.scheduledStats = {
    //     ATM: 'ATM',
    //     Cash: 'Cash',
    // }

    this.toggleSwitchUI = {
      size: "mini",
      label: {
        on: this.$translate.instant("common.on"),
        off: this.$translate.instant("common.off")
      },
      onColor: "success",
      offColor: "danger"
    };

    this.recurringPatternList = [{
      label: "Daily",
      value: "daily"
    }, {
      label: "Weekly",
      value: "weekly"
    }, {
      label: "Monthly",
      value: "monthly"
    }];

    this.serviceSchedule = [{
      label: "Monday",
      value: "monday"
    }, {
      label: "Tuesday",
      value: "tuesday"
    }, {
      label: "Wednesday",
      value: "wednesday"
    }, {
      label: "Thursday",
      value: "thursday"
    }, {
      label: "Friday",
      value: "friday"
    }, {
      label: "Saturday",
      value: "saturday"
    }, {
      label: "Sunday",
      value: "sunday"
    }];

    this.monthList = [{
      label: "Jan",
      value: "january"
    }, {
      label: "Feb",
      value: "february"
    }, {
      label: "March",
      value: "march"
    }, {
      label: "April",
      value: "april"
    }, {
      label: "May",
      value: "may"
    }, {
      label: "June",
      value: "june"
    }, {
      label: "July",
      value: "july"
    }, {
      label: "Aug",
      value: "august"
    }, {
      label: "Sep",
      value: "september"
    }, {
      label: "Oct",
      value: "october"
    }, {
      label: "Nov",
      value: "november"
    }, {
      label: "Dec",
      value: "december"
    }];

    this.customerUser = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
    this.isValidBillCount = true;
    this.isValidStrapBillCount = true;
    this.invalidSingleDenomCoin = false;
    this.invalidSingleDenomCoinList = [];
    this.selectedMonthlyPattern = "day";
    this.allOrders = [];
    this.multiDenomIndex = 0;
    this.singleDenomIndex = 0;
    this.atmDenomIndex = 0;
  }

  (0, _createClass3.default)(MasterCashScheduleController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;

      this.filterDataSet.orderTypes.push({ key: 'Change Order Delivery', value: 'COD' });
      this.denomSearchObj = {};
      this.model.gettingServiceOrder = true;
      this.$q.all([this.SetupService.get(this.branchId), this.DenominationService.all(null, 0, this.MAXLIMIT), this.ShiptypeService.all(null, 0, this.MAXLIMIT), this.loadUserBranches("", 0), this.getAllFundingSource("", 0), this.getCustomer("", 0), this.loadLocation("", 0, true), this.loadFromLocation("", 0), this.resetDateRange(), this.getActiveRoutes(0, "")]).then(function (data) {
        var allDenoms = _.orderBy(data[1].results, ["sortOrder"], ["asc"]);
        _this2.allDenoms = allDenoms;
        _this2.newCash.multiDenomPackableDenoms = allDenoms.length ? allDenoms.filter(function (d) {
          return d.multiDenomPackable == true;
        }) : [];
        _this2.newCash.singleDenomPackableDenoms = allDenoms.length ? allDenoms.filter(function (d) {
          return d.multiDenomPackable == false;
        }) : [];

        _this2.newCash.remainingMultiDenominations = allDenoms.filter(function (d) {
          return d.multiDenomPackable;
        });
        _this2.newCash.remainingSingleDenominations = allDenoms.filter(function (d) {
          return !d.multiDenomPackable;
        });
        _this2.denominationAllType = allDenoms.length ? allDenoms : [];
        _this2.setupDetails = data[0];
        _this2.shiptypeList = _.orderBy(data[2].results, ["sortOrder"], ["ASC"]);

        _this2.branchHoldRoute = _this2.setupDetails.holdRouteId;
        _this2.branchUnassignedRoute = _this2.setupDetails.unassignedRouteId;
        _this2.branchCurrentVaultDate = _this2.setupDetails.currentVaultDate;

        _this2.filterDataSet.denomsList = _this2.mappingData(_this2.denominationAllType, "name", "id");
        _this2.filterDataSet.multiPackabledenomsList = _this2.mappingData(_this2.newCash.multiDenomPackableDenoms, "name", "id");
        _this2.filterDataSet.singlePackabledenomsList = _this2.mappingData(_this2.newCash.singleDenomPackableDenoms, "name", "id");
        _this2.resetDateRange();

        _this2.loadPermission();
        _this2.generateCalendarDays(_this2._calendar.monthIndex);
        _this2.removeUsedDenoms();

        var customerDetails = _.find(_this2.filterDataSet.customerList, { Value: _this2.userDetails.customerId });
        var customer = _this2.userDetails.customerUser ? customerDetails : null;
        _this2.filter.customerId = customer;

        _this2.shiptypeList.forEach(function (s) {
          if (_this2.denominationTypeMapping[s.denominationType] && !_this2.coinTypes[s.denominationType]) {
            _this2.coinTypes[s.denominationType] = {
              denomList: [],
              isOpen: false,
              template: "order-view-coin-selection.html",
              selected: null,
              category: null,
              categoryName: null
            };
          }
        });

        _this2.shiptypeList.forEach(function (s) {
          if (_this2.denominationTypeMapping[s.denominationType]) {
            _this2.coinTypes[s.denominationType].denomList.push({
              icon: s.id
            });
            _this2.coinTypes[s.denominationType].coinFlag = true;
            _this2.coinTypes[s.denominationType].category = _this2.denominationTypeMapping[s.denominationType].category;
            _this2.coinTypes[s.denominationType].categoryName = _this2.denominationTypeMapping[s.denominationType].categoryName;
            _this2.coinTypes[s.denominationType].selected = _this2.coinTypes[s.denominationType].denomList[0].icon;
          }
        });

        _this2.coinValues = {};

        if (_this2.shiptypeList) {
          _this2.shiptypeList.map(function (shiptype) {
            _this2.coinValues[shiptype.id] = {
              amountFlag: shiptype.amountFlag,
              unitValue: shiptype.unitValue,
              amount: shiptype.amount
            };
          });
        }

        _this2.denominationTypeKeys = (0, _keys2.default)(_this2.coinTypes).sort(function (a, b) {
          var aMinSortOrder = _.min(_this2.shiptypeList.filter(function (s) {
            return s.denominationType === a;
          }).map(function (s) {
            return s.sortOrder;
          })) || 999;
          var bMinSortOrder = _.min(_this2.shiptypeList.filter(function (s) {
            return s.denominationType === b;
          }).map(function (s) {
            return s.sortOrder;
          })) || 999;
          return aMinSortOrder - bMinSortOrder;
        });
        _this2.allOrderTypes = [].concat((0, _toConsumableArray3.default)(_this2.filterDataSet.orderTypes)).filter(function (o) {
          return o.key !== "Change Order Delivery";
        });
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: "loadPermission",
    value: function loadPermission() {
      var _this3 = this;

      this.acl = {};
      this.hasACL = {};

      ["master_cash_schedule"].forEach(function (permissionKey) {
        _this3.acl[permissionKey] = _this3.User.getACL(permissionKey);

        _this3.hasACL[permissionKey] = {};

        _this3.acl[permissionKey].forEach(function (permission) {
          _this3.hasACL[permissionKey][permission] = true;
        });
      });
    }

    // Get current time

  }, {
    key: "getTime",
    value: function getTime(time) {
      if (!time) {
        return time;
      }

      time = time.split(":");

      var d = new Date();

      d.setHours(+time[0]);
      d.setMinutes(time[1]);
      d.setSeconds(0);
      d.setMilliseconds(0);

      return d;
    }
  }, {
    key: "CalendarDay",
    value: function CalendarDay(d) {
      var vaultDate = this.DateUtil.convertToDate(this.branchCurrentVaultDate);
      return {
        date: d,
        isPastDate: d.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0),
        isToday: d.setHours(0, 0, 0, 0) == new Date(vaultDate).setHours(0, 0, 0, 0),
        isMonthDate: d.getMonth() == this.monthNames.indexOf(this._calendar.displayMonth),
        formatedDate: moment(d).format("YYYY-MM-DD")
      };
    }
  }, {
    key: "getAllStatus",
    value: function getAllStatus(searchKey) {
      if (!searchKey) {
        this.filterDataSet.status = this.allStatus;
      } else {
        this.filterDataSet.status = this.allStatus.filter(function (status) {
          return status.Key.toLowerCase().includes(searchKey.toLowerCase());
        });
      }
    }
  }, {
    key: "generateCalendarDays",
    value: function generateCalendarDays(monthIndex) {
      var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // we reset our calendar
      this.calendar = [];

      // we set the date
      // let day = new Date(
      //     new Date().setMonth(new Date().getMonth() + monthIndex)
      // );
      // console.log(date, monthIndex);
      var now = date ? new Date(date) : new Date();
      var current = new Date(now.getFullYear(), now.getMonth() + monthIndex);

      var currentMonth = "" + new Date().getMonth() + new Date().getFullYear();
      var selectedMonth = "" + current.getMonth() + current.getFullYear();
      this.formattedSelectedMonth = current.getMonth() + 1 + "-" + current.getFullYear();
      this.hidePreviousMonth = parseInt(currentMonth) > parseInt(selectedMonth);
      // set the dispaly month for UI
      this._calendar.displayMonth = this.monthNames[current.getMonth()];
      this._calendar.displayYear = current.getFullYear();

      var startingDateOfCalendar = this.getStartDateForCalendar(current);

      var dateToAdd = startingDateOfCalendar;

      for (var i = 0; i < 42; i++) {
        this.calendar.push(this.CalendarDay(new Date(dateToAdd)));
        dateToAdd = new Date(dateToAdd.setDate(dateToAdd.getDate() + 1));
      }

      this.setCalendarWeeks();
      this.onDateSelect(null);
      this.getAtmOrders();
    }
  }, {
    key: "nextMonth",
    value: function nextMonth() {
      this._calendar.monthIndex++;
      this._calendar.isSidePanelOpen = false;
      this._calendar.isNew = false;
      this._calendar.isEdit = false;
      // this.resetDateRange();
      this.generateCalendarDays(this._calendar.monthIndex);
      this.setStartDate(this.formattedSelectedMonth);
      this.setEndDate(this.formattedSelectedMonth);
    }
  }, {
    key: "previousMonth",
    value: function previousMonth() {
      this._calendar.monthIndex--;
      this._calendar.isSidePanelOpen = false;
      this._calendar.isNew = false;
      this._calendar.isEdit = false;
      // this.resetDateRange();
      this.generateCalendarDays(this._calendar.monthIndex);
      this.setStartDate(this.formattedSelectedMonth);
      this.setEndDate(this.formattedSelectedMonth);
    }
  }, {
    key: "onDateSelect",
    value: function onDateSelect(dayData, index) {
      this._calendar.selectedDateData = dayData;
      this._calendar.isSidePanelOpen = !!dayData;
    }
  }, {
    key: "setCalendarWeeks",
    value: function setCalendarWeeks() {
      var _this4 = this;

      this.calendarDays = [];
      var weekDays = [];
      var chunkSize = 7;
      this.calendar.map(function (day, index) {
        weekDays.push(day);
        if (++index % chunkSize === 0) {
          var isCurrentMonth = weekDays.filter(function (item) {
            return item.isMonthDate;
          });
          if (isCurrentMonth && isCurrentMonth.length) {
            _this4.calendarDays.push(weekDays);
          }
          weekDays = [];
        }
      });
    }
  }, {
    key: "createNewCashSchedule",
    value: function createNewCashSchedule(day) {
      var fromTabSelecation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      day = day || moment();

      this._calendar.isEdit = false;
      this._calendar.isNew = true;
      this.newCash = {
        batchId: "B1-" + moment().toDate().getTime(),
        fromLocation: null,
        toLocation: null,
        vaultDate: moment(day.formatedDate),
        routeId: null,
        cashAmount: 0,
        coinAmount: 0,
        totalAmount: 0,
        isInteracted: false,
        trackingId: null,
        coinShipmentObj: {},
        branchId: this.model.branch,
        recurringStartDate: moment(day.formatedDate),
        recurringEndDate: null,
        recurringDays: {
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false
        },
        recurringMonths: {
          january: false,
          february: false,
          march: false,
          april: false,
          may: false,
          june: false,
          july: false,
          august: false,
          september: false,
          october: false,
          november: false,
          december: false
        },
        selectedPattern: "daily",
        recurWeeks: 0,
        recurringMonthObj: {
          day: {
            dayInterval: null,
            monthInterval: null
          },
          month: {
            weekInterval: null,
            selectedWeekDay: null,
            monthInterval: null,
            weekIntervalList: [{
              lable: "First",
              value: 1
            }, {
              lable: "Second",
              value: 2
            }, {
              lable: "Third",
              value: 3
            }, {
              lable: "Forth",
              value: 4
            }, {
              lable: "Fifth",
              value: 5
            }],
            weekDayList: [{
              lable: "Sunday",
              value: 0
            }, {
              lable: "Monday",
              value: 1
            }, {
              lable: "Tuesday",
              value: 2
            }, {
              lable: "Wednesday",
              value: 3
            }, {
              lable: "Thursday",
              value: 4
            }, {
              lable: "Friday",
              value: 5
            }, {
              lable: "Saturday",
              value: 6
            }]
          }
        },
        endRecurringAfter: null,
        account: this.model.ATMLoadAccountStats.regular
      };
      this.isValidBillCount = true;
      this.isValidStrapBillCount = true;
      this.onDateSelect(day);
      this.getActiveRoutes(0, "");
      this.scrollToTop();
      this.addNewDenominations();
      this.model.currentStats = null;
      if (this.customerUser) {
        if (!fromTabSelecation) {
          this.$currentTab = 'cashDeliveries';
        }
        this.filterOrderTypes();
        this.model.currentStats = this.shipmentsCreateStats.cashDeliveries.all;
        this.model.currentChildStat = this.shipmentsCreateStats.cashDeliveries.single;
        this.newCash.orderType = 'COD';
        if (!fromTabSelecation) {
          this.generateOrderNumber();
        }
      } else {
        this.model.currentStats = this.shipmentsCreateStats.prePacked.all;
      }
      this.validateRecurringStartDate();
      this.updateOrderTypeOrShiptypeId();
      this.setMaxDate(moment(this.filterDataSet.currentVaultDate));
    }
  }, {
    key: "editCashSchedule",
    value: function editCashSchedule(data) {
      var _this5 = this;

      this._calendar.isSidePanelOpen = true;
      this.onDateSelect(data);
      this.scrollToTop();
      var denominations = [];
      var multiDenominations = [];
      var atmDenominations = [];
      var date = this.normalizeDate(data.serviceDate);
      if (data.isPackableOrder) {

        denominations = angular.copy(data.denominations.filter(function (o) {
          return !o.multiDenomPackable;
        }));
        multiDenominations = angular.copy(data.denominations.filter(function (o) {
          return o.multiDenomPackable;
        }));
      } else {
        atmDenominations = angular.copy(data.denominations);
      }
      var obj = {
        id: new Date().getTime(),
        vaultDate: this.DateUtil.convertToDate(date),
        amount: data.amount,
        orderNo: data.orderNo,
        locationId: { Key: data.toLocationId + " | " + data.toLocationName, Value: data.toLocationId } || null,
        orderType: data.orderType || null,
        routeId: data.routeId || null,
        denominationId: data.denominationId,
        multiDenominations: multiDenominations || [],
        denominations: denominations || [],
        fetchedDenominations: data.fetchedDenominations || [],
        atmDenominations: atmDenominations || [],
        trackingIdDelivery: data.trackingIdDelivery,
        packedFlag: data.packedFlag,
        batchId: data.batchId,
        coinShipments: data.coinShipments ? data.coinShipments.map(function (coinShipment) {
          return (0, _extends3.default)({}, coinShipment, {
            shiptypeId: coinShipment.denominationId || coinShipment.shiptypeId
          });
        }) : [],
        shiptypeId: data.shiptypeId,
        coinShipmentAmount: data.coinShipmentAmount,
        cashShipmentAmount: data.cashShipmentAmount,
        fundingSourceId: data.fundingSourceId,
        fundingSourceName: data.fundingSourceName,
        fundingSource: this.filterDataSet.branchFundingSource.find(function (bfs) {
          return String(bfs.Value) === String(data.fundingSourceId);
        }) || data.fundingSource,
        trackingIds: data.trackingIds,
        status: data.status,
        loadedAmount: data.loadedAmount,
        deliveredFlag: data.deliveredFlag,
        cashOrderId: data.cashOrderId,
        shipmentId: data.shipmentId,
        jobKey: data.jobKey || null,
        jobId: data.jobId || null,
        scheduleWeekDays: data.scheduleWeekDays || null,
        recurringFrequency: data.recurringFrequency || null,
        recurringDayInterval: data.recurringDayInterval || null,
        frequencyWeek: data.frequencyWeek || null,
        locationScheduleRecurringId: data.locationScheduleRecurringId || null,
        isEC: data.isEC,
        editAmount: data.editAmount,
        isPackableOrder: data.isPackableOrder,
        type: data.type
      };

      this.newCash = (0, _assign2.default)(this.newCash, obj);
      this.updateOrderTypeOrShiptypeId();
      this.cloneShipmentObj = angular.copy(this.newCash);
      this.editRouteLookupDate = this.getFormattedVaultDate(this.newCash.vaultDate);

      if (data.denominations && data.denominations.length) {
        this.removeUsedDenoms();
      }

      if (this.newCash.isPackableOrder) {
        if (this.newCash.remainingDenominations && Array.isArray(this.newCash.remainingDenominations)) {
          this.newCash.remainingDenominations.forEach(function (atmDenom) {
            if (!atmDenom.multiDenomPackable) {
              // Check if multiDenomPackable is false
              _this5.newCash.denominations.push((0, _extends3.default)({}, atmDenom, {
                isEnabled: false,
                amount: null,
                template: "order-view-denomination-selection.html"
              }));
            }
          });
        }
        if (this.newCash.remainingMultiDenominations && Array.isArray(this.newCash.remainingMultiDenominations)) {
          this.newCash.remainingMultiDenominations.forEach(function (atmDenom) {
            if (atmDenom.multiDenomPackable) {
              // Check if multiDenomPackable is false
              _this5.newCash.multiDenominations.push((0, _extends3.default)({}, atmDenom, {
                isEnabled: false,
                amount: null,
                template: "order-view-multi-denomination-selection.html"
              }));
            }
          });
        }
      } else {
        if (this.newCash.remainingAtmDenominations && Array.isArray(this.newCash.remainingAtmDenominations)) {
          this.newCash.remainingAtmDenominations.forEach(function (atmDenom) {
            _this5.newCash.atmDenominations.push((0, _extends3.default)({}, atmDenom, {
              isEnabled: false,
              amount: null,
              icon: atmDenom.id,
              template: "order-view-atm-denomination-selection.html"
            }));
          });
        }
      }

      if (this.userDetails.customerUser) {
        var customerLeadMinDate = this.getCustomerLeadMinDate();
        this.setMaxDate(customerLeadMinDate || this.filterDataSet.currentVaultDate);
      } else {
        this.setMaxDate(this.filterDataSet.currentVaultDate);
      }
      this._calendar.isEdit = true;
      this.calculateDenominationAmount();
      this.validateBillCount();
      this.checkForStrapCount();
      if (this.newCash.batchId && this.newCash.coinShipments && this.newCash.coinShipments.length > 0) {
        var calculatedCoinAmount = this.newCash.coinShipments.reduce(function (sum, coinShipment) {
          return sum + (coinShipment.amount || 0);
        }, 0);
        this.newCash.coinShipmentAmount = calculatedCoinAmount;
      }

      this.updatedCash = angular.copy(this.newCash);
      this._calendar.isNew = false;
    }
  }, {
    key: "addNewDenominations",
    value: function addNewDenominations() {
      var _this6 = this;

      var length = this.model.currentStats === this.shipmentsCreateStats.cashDeliveries.all ? 5 : 4;
      this.newCash.denominations = [];
      this.newCash.multiDenominations = [];
      this.newCash.atmDenominations = [];

      this.denomModelType.forEach(function (d) {
        var type = void 0,
            remainingDenomModelKey = void 0;
        switch (d) {
          case "single":
            type = 'denominations';
            remainingDenomModelKey = 'remainingDenominations';
            break;
          case "multi":
            type = 'multiDenominations';
            remainingDenomModelKey = 'remainingMultiDenominations';
            break;
          case "atm":
            type = 'atmDenominations';
            remainingDenomModelKey = 'remainingAtmDenominations';
            break;
          default:
            'denominations';
        }

        for (var i = 0; _this6.newCash[type] && _this6.newCash[type].length < length; i++) {
          _this6.newCash[type].push({
            id: i == 0 ? 'USD20' : _this6.newCash[remainingDenomModelKey][0] && _this6.newCash[remainingDenomModelKey][0].id,
            isEnabled: i == 0 ? true : false,
            icon: i == 0 ? "USD20" : _this6.newCash[remainingDenomModelKey].length > 0 ? _this6.newCash[remainingDenomModelKey][0].id : null,
            faceValue: i == 0 ? 20 : _this6.newCash[remainingDenomModelKey].length > 0 ? _this6.newCash[remainingDenomModelKey][0].faceValue : 0,
            amount: null,
            template: d == "single" ? "order-view-denomination-selection.html" : d == 'multi' ? "order-view-multi-denomination-selection.html" : "order-view-atm-denomination-selection.html",
            dollorFlag: true,
            duplicate: false,
            multiDenomPackable: i == 0 ? true : _this6.newCash[remainingDenomModelKey][0] && _this6.newCash[remainingDenomModelKey][0].multiDenomPackable,
            strapCount: i == 0 ? 100 : _this6.newCash[remainingDenomModelKey][0] && _this6.newCash[remainingDenomModelKey][0].strapCount || 0
          });
          _this6.removeAlreadyUsedDenom(type, remainingDenomModelKey);
        }
      });
    }
  }, {
    key: "changeDenomType",
    value: function changeDenomType(event, index, denomination, type) {
      this.newCash[type][index].icon = denomination.id;
      this.newCash[type][index].faceValue = denomination.faceValue;
      this.newCash[type][index].isOpen = false;
      this.newCash[type][index].isValid = false;
      this.newCash[type][index].multiDenomPackable = denomination.multiDenomPackable;
      this.newCash[type][index].coinFlag = denomination.coinFlag;
      this.newCash[type][index].sortOrder = denomination.sortOrder;
      this.newCash[type][index].strapCount = denomination.strapCount;
      this.newCash[type][index].shiptypeId = denomination.shiptypeId;

      if (this.shouldUseAmountInput(this.newCash[type][index])) {
        this.newCash[type][index].amount = null;
        this.newCash[type][index].billCount = null;
      } else {
        this.checkAmount(index, this.newCash[type][index].billCount, denomination.faceValue, type);
      }

      this.calculateDenominationAmount(type);
      this.removeUsedDenoms();

      if (type === 'denominations') {
        this.checkSingleDenomCoinShiptype();
      }

      // this.removeAlreadyUsedDenom(type, type == 'denominations' ? 'remainingDenominations' ? 'atmDenominations' : 'remainingAtmDenominations': 'remainingMultiDenominations');
    }
  }, {
    key: "checkSingleDenomCoinShiptype",
    value: function checkSingleDenomCoinShiptype() {
      var invalidDenoms = (this.newCash.denominations || []).filter(function (denomination) {
        return denomination && denomination.isEnabled && denomination.coinFlag && (!denomination.shiptypeId || denomination.icon !== denomination.shiptypeId);
      });
      this.invalidSingleDenomCoinList = invalidDenoms.map(function (d) {
        return d.icon;
      });
      this.invalidSingleDenomCoin = invalidDenoms.length > 0;
      return this.invalidSingleDenomCoin;
    }
  }, {
    key: "getInvalidSingleDenomCoinMessage",
    value: function getInvalidSingleDenomCoinMessage() {
      var list = this.invalidSingleDenomCoinList || [];
      if (!list.length) return '';
      return list.length > 1 ? "Selected (" + list.join(', ') + ") denominations do not have a valid shiptype configured." : "Selected (" + list.join(', ') + ") denomination does not have a valid shiptype configured.";
    }
  }, {
    key: "closePanel",
    value: function closePanel() {
      this._calendar.isEdit = false;
      this.onDateSelect(null);
      this.isValidBillCount = true;
      this.isValidStrapBillCount = true;
      this.invalidSingleDenomCoin = false;
      this.invalidSingleDenomCoinList = [];
      this.newCash.atmDenominations = [];
      this.newCash.denominations = [];
      this.newCash.multiDenominations = [];
      this.updatedCash = {
        orderNo: null,
        locationId: null,
        orderType: null,
        vaultDate: null,
        routeId: null,
        denominations: [],
        trackingIdDelivery: null,
        batchId: null,
        multiDenominations: []
      };
    }
  }, {
    key: "handleDenomination",
    value: function handleDenomination(denomination, type) {
      if (type === 'remainingDenominations') {
        denomination = this.newCash.denominations.find(function (d) {
          return d.isEnabled === false;
        });
      } else if (type === 'remainingMultiDenominations') {
        denomination = this.newCash.multiDenominations.find(function (d) {
          return d.isEnabled === false;
        });
      } else if (type === 'remainingAtmDenominations') {
        denomination = this.newCash.atmDenominations.find(function (d) {
          return d.isEnabled === false;
        });
      }
      denomination.isEnabled = !denomination.isEnabled;

      if ('isDeleted' in denomination) {
        denomination.isDeleted = false;
      }
      if (!denomination.isEnabled) {
        denomination.icon = "";
        denomination.amount = "";
        denomination.faceValue = "";
      } else {
        var isMultiPackable = type === 'remainingMultiDenominations' || type === 'remainingAtmDenominations';
        var nextIndex = this.newCash[type].findIndex(function (item) {
          return item.faceValue > denomination.faceValue && item.id === denomination.icon && item.multiDenomPackable === isMultiPackable;
        });
        do {
          nextIndex += 1;
        } while (nextIndex < this.newCash[type].length && this.newCash[type][nextIndex].multiDenomPackable !== isMultiPackable);

        if (nextIndex < this.newCash[type].length) {
          var nextDenomination = this.newCash[type][nextIndex];
          denomination.icon = nextDenomination.id;
          denomination.faceValue = nextDenomination.faceValue;
          denomination.sortOrder = nextDenomination.sortOrder;
          denomination.coinFlag = nextDenomination.coinFlag;
          denomination.shiptypeId = nextDenomination.shiptypeId;
        }
        if (this.newCash.orderType === 'P' || this.newCash.orderType === 'T') {
          denomination.amount = 0;
          denomination.billCount = 0;
        }
      }

      this.calculateDenominationAmount(type === 'remainingDenominations' ? 'denominations' : 'multiDenominations');
      if (this.newCash.orderType === 'P' || this.newCash.orderType === 'T') this.validateBillCount();
      this.removeUsedDenoms();

      if (type === 'remainingDenominations') {
        this.checkSingleDenomCoinShiptype();
      }
    }
  }, {
    key: "removeDenomination",
    value: function removeDenomination(index, denomData) {
      this.newCash.denominations.splice(index, 1);
    }
  }, {
    key: "removeAlreadyUsedDenom",
    value: function removeAlreadyUsedDenom(_type, remainingDenomModelKey) {
      // Create a Set of used icons for more reliable filtering
      var usedIcons = new _set2.default();

      // Collect all enabled icons
      if (this.newCash[_type] && Array.isArray(this.newCash[_type])) {
        this.newCash[_type].forEach(function (data) {
          if (data.isEnabled && data.icon) {
            usedIcons.add(data.icon);
          }
        });
      }

      // Filter out denominations that have icons already in use
      this.newCash[remainingDenomModelKey] = this.denominationAllType.filter(function (type) {
        return !usedIcons.has(type.id);
      });
    }
  }, {
    key: "turnOffDenom",
    value: function turnOffDenom(denomination, denomIndex, type) {
      //= 'denominations'

      if (denomination.multiDenomPackable && type === 'multiDenominations') {
        this.multiDenomIndex = this.multiDenomIndex - 1;
      } else if (!denomination.multiDenomPackable && type === 'denominations') {
        this.singleDenomIndex = this.singleDenomIndex - 1;
      } else if (type === 'atmDenominations') {
        this.atmDenomIndex = this.atmDenomIndex - 1;
      }
      denomination.isEnabled = false;
      denomination.billCount = null;
      denomination.amount = null;

      if ('isDeleted' in denomination) {
        denomination.isDeleted = true;
      }

      var cursor = 0;
      this.newCash[type].forEach(function (d) {
        if (!d.isEnabled) cursor++;else cursor = 0;
      });
      if (this.newCash[type].length === cursor) {
        this.isValidBillCount = true;
      }
      this.validateBillCount();

      if (type === 'denominations') {
        denomination.isValid = false;
        this.newCash.denominations.sort(function (a, b) {
          return b.isEnabled - a.isEnabled;
        });
        this.checkSingleDenomCoinShiptype();
      } else if (type === 'multiDenominations') {
        denomination.isValid = false;
        this.newCash.multiDenominations.sort(function (a, b) {
          return b.isEnabled - a.isEnabled;
        });
      } else if (type === 'atmDenominations') {
        denomination.isValid = false;
        this.newCash.atmDenominations.sort(function (a, b) {
          return b.isEnabled - a.isEnabled;
        });
      }

      this.calculateDenominationAmount();
      this.removeUsedDenoms();
    }

    //load filters data list

  }, {
    key: "loadUserBranches",
    value: function loadUserBranches() {
      var _this7 = this;

      this.ServiceOrderService.getUserBranchList(this.User.getUser().id).then(function (res) {
        _this7.filterDataSet.userBranches = res.results;
        _this7.filterDataSet.userBranches.forEach(function (branch) {
          if (branch.branchId == _this7.branchId) {
            _this7.filterDataSet.currentVaultDate = moment.utc(branch.currentVaultDate).format("YYYY-MM-DD");
            branch.ticked = true;
          }
        });
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: "userBranchMap",
    value: function userBranchMap(branches) {
      return branches.map(function (branch) {
        return {
          Key: branch.branchId,
          Value: branch.branchId
        };
      });
    }
  }, {
    key: "generateSearchObj",
    value: function generateSearchObj(searchKey) {
      searchKey = searchKey || "";

      var branchId = this.getSelectedBranches();
      var obj = {
        queryJSON: {
          rules: [{
            field: "branchId",
            condition: "IN",
            data: branchId && branchId.length ? branchId : [this.branchId]
          }, {
            group: {
              rules: [{
                field: "id",
                condition: "like",
                data: "%" + searchKey + "%"
              }, {
                field: "sourceName",
                condition: "like",
                data: "%" + searchKey + "%"
              }],
              operator: "OR"
            }
          }],
          operator: "AND"
        }
      };
      return obj.queryJSON.rules.length ? obj : null;
    }
  }, {
    key: "getAllFundingSource",
    value: function getAllFundingSource(searchKey, offset) {
      var _this8 = this;

      this.isLoading = true;

      if (this.customerUser) {
        this.UserBranchFundingSourceService.getBranchFundingSource(this.userDetails.id, this.branchId).then(function (data) {
          _this8.filterDataSet.totalBranchFundingSource = data.total;
          _this8.filterDataSet.branchFundingSource = _this8.mappingData(data.results, "sourceName", "id");
        }).catch(function (err) {
          err.data && err.data.message ? _this8.Modal.errorModal(err.data.message) : console.error(err);
        }).finally(function () {
          _this8.isLoading = false;
        });
        return;
      }

      var searchObj = this.generateSearchObj(searchKey);

      this.BranchFundingSourceService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this8.filterDataSet.totalBranchFundingSource = data.total;
          _this8.filterDataSet.branchFundingSource = _this8.mappingData(data.results, "sourceName", "id");
        } else {
          var fundingSource = _this8.mappingData(data.results, "sourceName", "id");
          _this8.filterDataSet.branchFundingSource = _this8.filterDataSet.branchFundingSource.concat(fundingSource);
        }
      }).catch(function (err) {
        err.data && err.data.message ? _this8.Modal.errorModal(err.data.message) : console.error(err);
      }).finally(function () {
        _this8.isLoading = false;
      });
    }
  }, {
    key: "customerSearchPaginate",
    value: function customerSearchPaginate(searchKey, idKey, nameKey) {
      return {
        queryJSON: {
          rules: [{
            field: idKey,
            condition: "like",
            data: "%" + searchKey + "%"
          }, {
            field: nameKey,
            condition: "like",
            data: "%" + searchKey + "%"
          }],
          operator: "OR"
        }
      };
    }
  }, {
    key: "getCustomer",
    value: function getCustomer(searchKey, offset) {
      var _this9 = this;

      searchKey = searchKey || "";
      var costomerSearchObj = this.customerSearchPaginate(searchKey, "id", "name");
      if (!searchKey) {
        costomerSearchObj.queryJSON.rules = [];
        costomerSearchObj.queryJSON.operator = "AND";
      }
      if (this.customerUser) {
        costomerSearchObj.queryJSON.rules.push({
          field: "id",
          condition: "=",
          data: this.customerUser
        });
      }

      if (offset !== 0 && !searchKey && Math.abs(offset % 2) === 1) {
        offset = offset - 1;
      }
      return this.CustomerService.all(costomerSearchObj, offset, _app2.default.defaultPageLimit).then(function (res) {
        var selectedVal = _this9.model.customer ? _this9.model.customer.Value : "";
        if (offset === 0 || offset == undefined) {
          _this9.filterDataSet.totalCustomer = res.total;
          var customers = _this9.mappingData(res.results, "name", "id");
          // if (!searchKey && selectedVal) {
          // 	customers.unshift(this.model.customer);
          // }
          _this9.filterDataSet.customerList = _.uniqBy(customers, "Value");
        } else {
          var _customers = _this9.mappingData(res.results, "name", "id");
          _this9.filterDataSet.customerList = _.uniqBy(_this9.filterDataSet.customerList.concat(_customers), "Value");
        }
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this9.errorMessage = err.data.message;
        }
      });
    }
  }, {
    key: "filterOrderTypes",
    value: function filterOrderTypes() {
      if (this.$currentTab === 'cashDeliveries') {
        this.filterDataSet.shipTypes = [];

        var _shiptypeList$filter = this.shiptypeList.filter(function (st) {
          return st.id === 'COD';
        }),
            _shiptypeList$filter2 = (0, _slicedToArray3.default)(_shiptypeList$filter, 1),
            shipType = _shiptypeList$filter2[0];

        if (shipType) {
          this.filterDataSet.shipTypes.push({
            key: shipType.description,
            value: shipType.id
          });
        }
      } else {
        this.filterDataSet.orderTypes = this.CommonLayoutService.orderTypes().filter(function (orderType) {
          return orderType.value !== 'X' || orderType.value !== 'COD';
        });
        if (this.customerUser) {
          this.filterDataSet.orderTypes = this.filterDataSet.orderTypes.filter(function (o) {
            return o.value === 'A' || o.value === 'S';
          });
        }
      }
    }
  }, {
    key: "isHoldRoute",
    value: function isHoldRoute(route) {
      if (!route) return false;
      var routeId = route.Value ? route.Value : route;
      if (this.filterDataSet && this.filterDataSet.routeList) {
        var routeObj = this.filterDataSet.routeList.find(function (r) {
          return r.Value === routeId;
        });
        if (routeObj && routeObj.dataObj && routeObj.dataObj.holdRoute) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "locationSearchObj",
    value: function locationSearchObj(searchKey) {
      var forMainPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var tabType = this.$currentTab;
      searchKey = searchKey || "";
      var branchId = this.getSelectedBranches();
      var searchObj = {
        queryJSON: {
          rules: [{
            field: "branchId",
            condition: "IN",
            data: branchId && branchId.length ? branchId : [this.branchId]
          }, {
            field: "active",
            condition: "=",
            data: true
          }, {
            group: {
              rules: [{
                field: "id",
                condition: "like",
                data: "%" + searchKey + "%"
              }, {
                field: "name",
                condition: "like",
                data: "%" + searchKey + "%"
              }],
              operator: "OR"
            }
          }],
          operator: "AND"
        }
      };

      // Add locationType rules based on tab type
      if (tabType === 'cashDeliveries') {
        if (!forMainPage && this.newCash && this.newCash.fundingSource && this.newCash.fundingSource.Value) {
          searchObj.queryJSON.rules.push({
            field: "bankSourceId",
            condition: "=",
            data: this.newCash.fundingSource.Value
          });
          searchObj.queryJSON.rules.push({
            group: {
              rules: [{ field: "locationType", condition: "=", data: "REGULAR" }, { field: "locationType", condition: "=", data: "ON_CALL" }, { field: "locationType", condition: "=", data: "NO_SHIP_NO_GO" }, { field: "locationType", condition: "=", data: "BANK" }],
              operator: "OR"
            }
          });
        }
      }
      if (tabType === 'cashCoin') {
        searchObj.queryJSON.rules.push({
          group: {
            rules: [{
              field: "locationType",
              condition: "=",
              data: "REGULAR"
            }, {
              field: "locationType",
              condition: "=",
              data: "ON_CALL"
            }, {
              field: "locationType",
              condition: "=",
              data: "NO_SHIP_NO_GO"
            }, {
              field: "locationType",
              condition: "=",
              data: "BANK"
            }],
            operator: "OR"
          }
        });
      } else if (tabType === 'ATMOrders' || tabType === 'atmLoad') {
        searchObj.queryJSON.rules.push({
          field: "locationType",
          condition: "=",
          data: "ATM"
        });
      }

      if (!forMainPage && (tabType === 'cashDeliveries' || tabType === 'ATMOrders' || tabType === 'atmLoad') && this.newCash && this.newCash.fundingSource && this.newCash.fundingSource.Value) {
        searchObj.queryJSON.rules.push({
          field: 'bankSourceId',
          condition: '=',
          data: this.newCash.fundingSource.Value
        });
      }

      if (forMainPage && this.model && this.model.fundingSourceId && this.model.fundingSourceId.Value) {
        searchObj.queryJSON.rules.push({
          field: 'bankSourceId',
          condition: '=',
          data: this.model.fundingSourceId.Value
        });
      }

      if (this.customerUser) {
        searchObj.queryJSON.rules.push({
          field: "customerId",
          condition: "=",
          data: this.customerUser
        });
      }

      return searchObj.queryJSON.rules.length ? searchObj : null;
    }
  }, {
    key: "onMainFundingSourceSelected",
    value: function onMainFundingSourceSelected() {
      this.mainPageFilters.locationList = [];
      this.mainPageFilters.totalLocation = 0;
      this.mainPageFilters.offset = 0;
      if (this.filter.locationId) this.filter.locationId = null;
      this.loadLocation('', 0, true);
      if (typeof this.filterOrderView === 'function') {
        this.filterOrderView();
      }
    }
  }, {
    key: "fetchLocationsOnEvent",
    value: function fetchLocationsOnEvent(searchKey) {
      var _this10 = this;

      searchKey = searchKey || "";

      var locationSearchObj = this.locationSearchObj(searchKey);
      this.LocationService.all(locationSearchObj, 0, _app2.default.defaultPageLimit).then(function (res) {
        _this10.filterDataSet.totalLocation = res.total;
        _this10.filterDataSet.locationList = _this10.mappingData(res.results, "name", "id");
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: "loadLocation",
    value: function loadLocation(searchKey, offset) {
      var _this11 = this;

      var forMainPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      searchKey = searchKey || "";

      if (!forMainPage && (this.$currentTab === 'cashDeliveries' || this.$currentTab === 'ATMOrders' || this.$currentTab === 'atmLoad') && (!this.newCash || !this.newCash.fundingSource || !this.newCash.fundingSource.Value)) {
        if (offset === 0) {
          this.filterDataSet.totalLocation = 0;
          this.filterDataSet.locationList = [];
        }
        return this.$q.resolve();
      }

      var locationSearchObj = this.locationSearchObj(searchKey, forMainPage);
      this.LocationService.all(locationSearchObj, offset, _app2.default.defaultPageLimit).then(function (res) {
        if (offset === 0) {
          if (forMainPage) {
            _this11.mainPageFilters.totalLocation = res.total;
            _this11.mainPageFilters.locationList = _this11.mappingData(res.results, "name", "id");
            _this11.mainPageFilters.offset = offset;
          } else {
            _this11.filterDataSet.totalLocation = res.total;
            _this11.filterDataSet.locationList = _this11.mappingData(res.results, "name", "id");
          }
        } else {
          var locations = _this11.mappingData(res.results, "name", "id");
          if (forMainPage) {
            _this11.mainPageFilters.locationList = _this11.mainPageFilters.locationList.concat(locations);
            _this11.mainPageFilters.offset = offset;
          } else {
            _this11.filterDataSet.locationList = _this11.filterDataSet.locationList.concat(locations);
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: "getActiveRoutes",
    value: function getActiveRoutes(searchKey, offset) {
      var _this12 = this;

      searchKey = searchKey || "";

      var branchId = this.getSelectedBranches();
      var routeSearchObj = {
        queryJSON: {
          rules: [{
            field: "branchId",
            condition: "IN",
            data: branchId && branchId.length ? branchId : [this.branchId]
          }, {
            field: "active",
            condition: "=",
            data: true
          }, {
            group: {
              rules: [{
                field: "id",
                condition: "like",
                data: "%" + searchKey + "%"
              }, {
                field: "name",
                condition: "like",
                data: "%" + searchKey + "%"
              }],
              operator: "OR"
            }
          }],
          operator: "AND"
        }
      };

      // this.RouteService.getActiveRoutes(this.branchId, selectedDate)
      return this.RouteService.all(routeSearchObj, 0, this.MAXLIMIT).then(function (res) {
        if (_this12.branchHoldRoute && _this12.model.currentStats === _this12.shipmentsCreateStats.prePacked.all) {
          res.results.unshift({ id: "HOLD", name: "HOLD" });
        }

        var routes = _this12.mappingData(res.results, "name", "id");
        _this12.filterDataSet.routeList = routes;
        _this12.filterDataSet.totalRoutes = routes.length;
        if (_this12.newCash.toLocation && _this12.newCash.fundingSource && _this12.filterDataSet.routeList.length === 1) {
          _this12.newCash.routeId = _this12.filterDataSet.routeList[0];
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: "mappingData",
    value: function mappingData(arr, label, value) {
      return arr.map(function (item) {
        var arrayObject = {
          Key: item[value] + " | " + item[label],
          Value: item[value],
          dataObj: item
        };

        return arrayObject;
      });
    }
  }, {
    key: "sortCollection",
    value: function sortCollection(column) {
      var _this13 = this;

      if (this.sortColumn === column) {
        this.reverseSort = !this.reverseSort;
      } else {
        this.sortColumn = column;
        this.reverseSort = false;
      }
      this.allOrders = this.allOrders.sort(function (a, b) {
        var valueA = a[column];
        var valueB = b[column];

        if (valueA === null || valueA === undefined) valueA = '';
        if (valueB === null || valueB === undefined) valueB = '';

        if (typeof valueA === 'string') {
          valueA = valueA.toLowerCase();
          valueB = valueB.toLowerCase();
        }
        if (valueA < valueB) {
          return _this13.reverseSort ? 1 : -1;
        }
        if (valueA > valueB) {
          return _this13.reverseSort ? -1 : 1;
        }
        return 0;
      });
    }
  }, {
    key: "getAtmOrders",
    value: function getAtmOrders() {
      var _this14 = this;

      this.model.gettingServiceOrder = true;
      setTimeout(function () {
        var startDate = _this14.getStartDate();
        var endDate = _this14.getEndDate();
        var fundingSourceId = _this14.model.fundingSourceId ? _this14.model.fundingSourceId.Value : null;
        var customerId = _this14.filter.customerId ? _this14.filter.customerId.Value : null;
        var locationId = _this14.filter.locationId ? _this14.filter.locationId.Value : null;
        var orderType = _this14.filter.orderType;
        var routeId = _this14.model.routeId ? _this14.model.routeId.Value : null;
        var status = _this14.model.status ? _this14.model.status.Value : null;
        var denominationId = _this14.getSelectedDenoms();
        var branchId = _this14.getSelectedBranches();
        var searchText = _this14.searchText;
        _this14.collection = {};
        _this14.sortColumn = '';
        _this14.reverseSort = false;

        _this14.OrderViewService.getAtmOrders(searchText, branchId, startDate, endDate, _this14.currentOrderStat, fundingSourceId, customerId, locationId, orderType, routeId, status, denominationId).then(function (data) {
          _this14.allOrders = [];

          var orderNoGrp = _.groupBy(data.results, function (item) {
            var isScheduled = item.type === 'scheduledATMLoadOrders' || item.type === 'scheduledPackableOrder';

            if (isScheduled) {
              var safeDate = item.serviceDate ? moment.utc(item.serviceDate).format('YYYY-MM-DD') : 'UNSCHEDULED';
              var _loc = item.toLocationId || 'UNKNOWN_LOC';

              return "ATM_" + _loc + "_" + safeDate;
            }

            var order = item.orderNo || 'NO_ORDER';
            var job = item.jobId || 'NO_JOB';
            var batch = item.batchId || 'NO_BATCH';
            var loc = item.toLocationId || 'UNKNOWN_LOC';

            if (!item.orderNo && !item.jobId && !item.batchId) {
              var _safeDate = item.serviceDate ? moment.utc(item.serviceDate).format('YYYY-MM-DD') : 'UNSCHEDULED';
              return "INDIVIDUAL_" + loc + "_" + _safeDate;
            }

            return order + "_" + job + "_" + batch + "_" + loc;
          });

          var keys = (0, _keys2.default)(orderNoGrp);
          var groupedData = keys.map(function (key) {
            var group = orderNoGrp[key];
            var firstItem = group[0];

            var hasDenominations = group.some(function (obj) {
              return obj.denominationId != null && obj.orderNo != null;
            });

            return (0, _extends3.default)({
              orderNo: firstItem.orderNo || null,
              jobId: firstItem.jobId || null,
              batchId: firstItem.batchId || null,
              serviceDate: firstItem.serviceDate ? moment.utc(firstItem.serviceDate).format('YYYY-MM-DD') : null,

              shipments: (0, _from2.default)(new _map2.default(group.filter(function (order) {
                return order.status === 'scheduled' || !(order.coinFlag === 0 && order.batchId || order.bagSeal == null && order.status !== 'pendingPack' && order.isPackableOrder !== 1);
              }).map(function (order) {
                return (0, _extends3.default)({}, order, {
                  denominationId: order.denominationId ? order.denominationId : order.trackingIdDelivery && order.trackingIdDelivery.split('-').length > 1 ? order.trackingIdDelivery.split('-').pop() : null
                });
              }).map(function (order) {
                return [order.trackingIdDelivery + "-" + order.denominationId, order];
              })).values())

            }, firstItem, {

              cashShipmentAmount: group.reduce(function (sum, obj) {
                if (hasDenominations && obj.denominationId == null && obj.orderType !== 'COD') return sum;
                return obj.coinFlag === 0 ? sum + obj.amount : sum;
              }, 0),

              coinShipmentAmount: group.reduce(function (sum, obj) {
                if (hasDenominations && obj.denominationId == null && obj.orderType !== 'COD') return sum;
                return obj.coinFlag === 1 ? sum + obj.amount : sum;
              }, 0),

              amount: group.reduce(function (sum, obj) {
                if (hasDenominations && obj.denominationId == null && obj.orderType !== 'COD') return sum;
                return sum + obj.amount;
              }, 0),

              denominations: group.map(function (order) {
                var denomObj = null;
                if (order.denominationId) {
                  denomObj = _this14.allDenoms.find(function (denom) {
                    return denom.id === order.denominationId;
                  });
                } else if (order.trackingIdDelivery) {
                  var trackingIdParts = order.trackingIdDelivery.split('-');
                  var lastTrackingId = trackingIdParts[trackingIdParts.length - 1];
                  denomObj = _this14.allDenoms.find(function (denom) {
                    return denom.id === lastTrackingId;
                  });
                } else if (order.status === 'scheduled' && order.denominationId == null) {
                  denomObj = _this14.allDenoms.find(function (denom) {
                    return denom.id === order.shiptypeId;
                  });
                }

                if (denomObj) {
                  return {
                    isEnabled: !!denomObj,
                    icon: denomObj.id || null,
                    id: denomObj.id || null,
                    faceValue: denomObj ? denomObj.faceValue : 0,
                    amount: order.amount,
                    template: !order.isPackableOrder ? "order-view-atm-denomination-selection.html" : order.isPackableOrder && order.multiDenomPackable ? "order-view-multi-denomination-selection.html" : "order-view-denomination-selection.html",
                    dollarFlag: true,
                    duplicate: false,
                    strapCount: denomObj.strapCount,
                    multiDenomPackable: order.multiDenomPackable,
                    coinFlag: denomObj ? denomObj.coinFlag : false,
                    sortOrder: denomObj ? denomObj.sortOrder : 0,
                    shiptypeId: denomObj ? denomObj.shiptypeId : null,
                    billCount: denomObj ? Math.floor(order.amount / denomObj.faceValue) : 0,
                    isValid: true,
                    status: order.status || null
                  };
                }
              }).filter(Boolean).sort(function (a, b) {
                return a.sortOrder - b.sortOrder || a.faceValue - b.faceValue;
              }),

              coinShipments: group.filter(function (order) {
                return order.coinFlag === 1 && order.batchId;
              }).map(function (order) {
                return (0, _extends3.default)({}, order, {
                  shiptypeId: order.denominationId || order.shiptypeId
                });
              }),

              trackingIds: [].concat((0, _toConsumableArray3.default)(new _set2.default(group.filter(function (order) {
                return order.trackingIdDelivery;
              }).map(function (order) {
                return order.trackingIdDelivery;
              })))),

              parentTrackingId: function () {
                var foundOrder = group.find(function (order) {
                  return order.parentTrackingId;
                });
                return foundOrder ? foundOrder.parentTrackingId : null;
              }(),

              fundingSource: firstItem.fundingSource,
              type: firstItem.type || 'none',
              formatAddress: firstItem.toLocationName + " | " + (firstItem.toLocationAddress || '') + " " + (firstItem.toLocationCity || '') + " " + (firstItem.toLocationState || '')
            });
          });

          if (_this14.$currentViewTab == 'calender') {
            groupedData.forEach(function (d) {
              _this14.collection[moment.utc(d.serviceDate).format("YYYY-MM-DD")] = {
                total: 0,
                collections: [],
                totalPackedShipments: 0,
                totalPendingPackShipments: 0,
                totalRecords: 0
              };
            });
            groupedData.forEach(function (d, index) {
              var dataObj = _this14.collection[moment.utc(d.serviceDate).format("YYYY-MM-DD")];
              if (d.orderNo == null || !d.deliveredFlag) {
                dataObj.total += d.amount;
              } else if (d.orderNo !== null && d.deliveredFlag) {
                dataObj.total += d.loadedAmount;
              }
              dataObj.totalRecords++;

              if (d.status === "packed") dataObj.totalPackedShipments++;else if (d.status === "pendingPack") dataObj.totalPendingPackShipments++;

              dataObj.collections.push({
                status: d.status,
                orderNo: d.orderNo,
                orderType: d.orderType,
                serviceDate: d.serviceDate,
                amount: d.amount,
                toLocationId: d.toLocationId,
                toLocationName: d.toLocationName,
                routeId: d.routeId,
                routeName: d.routeName,
                denominationId: d.denominationId,
                trackingIdDelivery: d.trackingIdDelivery,
                shipments: d.shipments || [],
                packedFlag: d.packedFlag,
                toLocationType: d.toLocationType,
                batchId: d.batchId,
                coinShipments: d.coinShipments || [],
                shiptypeId: d.shiptypeId,
                coinShipmentAmount: d.coinShipmentAmount,
                cashShipmentAmount: d.cashShipmentAmount,
                fundingSourceId: d.fundingSourceId,
                fundingSourceName: d.fundingSourceName,
                fundingSource: d.fundingSource,
                trackingIds: d.trackingIds,
                loadedAmount: d.loadedAmount,
                deliveredFlag: d.deliveredFlag,
                cashOrderId: d.cashOrderId,
                denominations: d.denominations,
                fetchedDenominations: d.denominations,
                shipmentId: d.loadShipmentId,
                jobKey: d.jobKey || null,
                jobId: d.jobId || null,
                scheduleWeekDays: d.scheduleWeekDays || null,
                recurringFrequency: d.recurringFrequency || null,
                recurringDayInterval: d.recurringDayInterval || null,
                frequencyWeek: d.frequencyWeek || null,
                locationScheduleRecurringId: d.locationScheduleRecurringId || null,
                isEC: d.isEC,
                editAmount: d.editAmount,
                isPackableOrder: d.isPackableOrder || 0,
                formatAddress: d.formatAddress || null,
                type: d.type,
                parentTrackingId: d.parentTrackingId || null
              });
            });
          } else {
            groupedData.forEach(function (d, index) {
              _this14.allOrders.push({
                status: d.status,
                orderNo: d.orderNo,
                orderType: d.orderType,
                serviceDate: d.serviceDate,
                amount: d.amount,
                toLocationId: d.toLocationId,
                toLocationName: d.toLocationName,
                routeId: d.routeId,
                routeName: d.routeName,
                denominationId: d.denominationId,
                trackingIdDelivery: d.trackingIdDelivery,
                shipments: d.shipments || [],
                packedFlag: d.packedFlag,
                toLocationType: d.toLocationType,
                batchId: d.batchId,
                coinShipments: d.coinShipments || [],
                shiptypeId: d.shiptypeId,
                coinShipmentAmount: d.coinShipmentAmount,
                cashShipmentAmount: d.cashShipmentAmount,
                fundingSourceId: d.fundingSourceId,
                fundingSourceName: d.fundingSourceName,
                fundingSource: d.fundingSource,
                trackingIds: d.trackingIds,
                loadedAmount: d.loadedAmount,
                deliveredFlag: d.deliveredFlag,
                cashOrderId: d.cashOrderId,
                denominations: d.denominations,
                fetchedDenominations: d.denominations,
                shipmentId: d.loadShipmentId,
                jobKey: d.jobKey || null,
                jobId: d.jobId || null,
                scheduleWeekDays: d.scheduleWeekDays || null,
                recurringFrequency: d.recurringFrequency || null,
                recurringDayInterval: d.recurringDayInterval || null,
                frequencyWeek: d.frequencyWeek || null,
                locationScheduleRecurringId: d.locationScheduleRecurringId || null,
                isEC: d.isEC,
                editAmount: d.editAmount,
                isPackableOrder: d.isPackableOrder || 0,
                formatAddress: d.formatAddress || null,
                type: d.type,
                branchId: d.branchId,
                parentTrackingId: d.parentTrackingId || null
              });
            });
            _this14.sortCollection('serviceDate');
          }
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this14.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          _this14.onDateSelect(null);
          _this14.model.gettingServiceOrder = false;
          setTimeout(function () {
            var el = document.getElementById('masterCashSearch');
            if (el) el.focus();
          }, 100);
        });
      });
    }
  }, {
    key: "getStartDate",
    value: function getStartDate() {
      return this.dateRangeOptions.startDate ? moment(this.dateRangeOptions.startDate).format("YYYY-MM-DD") : null;
    }
  }, {
    key: "getEndDate",
    value: function getEndDate() {
      return this.dateRangeOptions.endDate ? moment(this.dateRangeOptions.endDate).format("YYYY-MM-DD") : null;
    }
  }, {
    key: "setStartDate",
    value: function setStartDate(input) {
      if (!input) return;

      var startDate = this.$currentViewTab === 'calender' ? moment(input, "MM-YYYY").startOf("month") : moment(this.branchCurrentVaultDate);

      this.dateRangeOptions = { startDate: startDate };
    }
  }, {
    key: "setEndDate",
    value: function setEndDate(input) {
      if (!input) return;
      var endDate = this.$currentViewTab === 'calender' ? moment(input, "MM-YYYY").endOf("month") : moment(this.branchCurrentVaultDate).add(7, 'days');

      this.dateRangeOptions.endDate = endDate;
    }
  }, {
    key: "goToRouteTab",
    value: function goToRouteTab(data) {
      var obj = {
        routeId: data.routeId,
        vaultDate: data.serviceDate,
        isRedirected: true
      };
      this.DataCounter.setData(obj);
      this.$state.go('branchManagement.routes');
    }
  }, {
    key: "goToServiceHistory",
    value: function goToServiceHistory(data) {

      if (data && data.toLocationId && data.orderNo && data.status === 'pendingPack') {
        var fundingSourceId = data.fundingSourceId ? data.fundingSourceId : this.model.locationId && this.model.locationId.Value;
        this.Navigation.goToOrderPackingFromLocation(data.toLocationId, data.orderNo, fundingSourceId);
      } else {
        var obj = {
          locationId: data.toLocationId,
          vaultDate: null,
          isRedirected: true
        };
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.locations');
      }
    }
  }, {
    key: "goToItemHistory",
    value: function goToItemHistory(trackingId) {
      this.$state.go('branchManagement.items', {
        id: trackingId
      });
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      return window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, {
    key: "getOrderStats",
    value: function getOrderStats(value) {
      if (value == this.orderStatObj.All) {
        this.currentOrderStat = null;
      } else {
        this.currentOrderStat = this.currentOrderStat === value ? null : value;
      }
      var id = void 0;
      switch (value) {
        case this.orderStatObj.atRisk:
          id = "at-risk";
          break;
        case this.orderStatObj.ATM:
          id = "atm";
          break;
        case this.orderStatObj.Cash:
          id = "cash";
          break;
        case this.orderStatObj.Scheduled:
          id = "scheduled";
          break;
        case this.orderStatObj.All:
          id = "all";
          break;
      }
      // const id = value === this.orderStatObj.atRisk ? 'at-risk' : this.orderStatObj.ATM ? 'atm' : this.orderStatObj.Cash ? 'cash' : 'scheduled';
      document.getElementById(id).blur();
      this.filterOrderView();
      // if (this.currentOrderStat !== this.orderStatObj.Scheduled) this.getAtmOrders();
    }
  }, {
    key: "resetDateRange",
    value: function resetDateRange() {
      if (this.$currentViewTab == 'calender') {
        this.dateRangeOptions = {
          startDate: moment().startOf("month"),
          endDate: moment().endOf("month")
        };
      } else {
        this.dateRangeOptions = {
          startDate: moment(this.branchCurrentVaultDate),
          endDate: moment(this.branchCurrentVaultDate).add(7, 'days')
        };
      }
    }
  }, {
    key: "getSelectedBranches",
    value: function getSelectedBranches() {
      return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map(function (branch) {
        return branch.branchId;
      }) : null;
    }
  }, {
    key: "getSelectedDenoms",
    value: function getSelectedDenoms() {
      return Array.isArray(this.filter.selectedDenoms) ? this.filter.selectedDenoms.map(function (denom) {
        return denom.Value;
      }) : null;
    }
  }, {
    key: "openOrderDetailsModal",
    value: function openOrderDetailsModal(date) {
      var _this15 = this;

      if (!this.collection || !this.collection[date] || !this.collection[date].collections || this.collection[date].collections.length === 0) {
        return;
      }
      var collections = this.collection[date].collections;
      var totalAmount = this.collection[date].total;
      var denomTotals = {};

      collections.forEach(function (order) {
        if (order.denominations && order.denominations.length) {
          order.denominations.forEach(function (denom) {
            if (denom.id) {
              if (!denomTotals[denom.id]) {
                denomTotals[denom.id] = 0;
              }
              denomTotals[denom.id] += denom.amount || 0;
            }
          });
        }
      });

      // Order the denom totals by DB sort order so they display in sequence.
      var orderedDenomTotals = _.orderBy((0, _keys2.default)(denomTotals).map(function (id) {
        var denomObj = _this15.allDenoms.find(function (d) {
          return d.id === id;
        });
        return {
          id: id,
          amount: denomTotals[id],
          sortOrder: denomObj ? denomObj.sortOrder : 999
        };
      }), ["sortOrder"], ["asc"]);

      if (this.Modal.masterCashOrderDetailsModal) {
        this.Modal.masterCashOrderDetailsModal(date, collections, totalAmount, orderedDenomTotals);
      }
    }
  }, {
    key: "filterOrderView",
    value: function filterOrderView() {
      this._calendar.isEdit = false;
      this._calendar.isNew = false;
      this.getAtmOrders();
    }
  }, {
    key: "resetDataOnBranchChange",
    value: function resetDataOnBranchChange() {
      var _this16 = this;

      setTimeout(function () {
        _this16.model.fundingSourceId = null;
        _this16.filter.locationId = null;
        _this16.getAllFundingSource("", 0);
        _this16.loadLocation("", 0);
        _this16.loadFromLocation("", 0);
      });
    }
  }, {
    key: "resetFilter",
    value: function resetFilter() {
      var _this17 = this;

      this.model.status = null;
      this.searchText = null;
      this.currentOrderStat = null;
      this.model.routeId = null;
      this.model.fundingSourceId = null;
      this.filter.locationId = null;
      if (this.userDetails.customerUser) {
        var customerDetails = _.find(this.filterDataSet.customerList, { Value: this.userDetails.customerId });
        this.filter.customerId = customerDetails;
      } else {
        this.filter.customerId = null;
      }
      this.filter.orderType = null;
      this.filter.selectedDenoms = [];
      this.setStartDate(this.formattedSelectedMonth);
      this.setEndDate(this.formattedSelectedMonth);
      this.filterDataSet.userBranches.forEach(function (branch) {
        branch.ticked = false;
        if (branch.branchId == _this17.branchId) {
          _this17.filterDataSet.currentVaultDate = moment.utc(branch.currentVaultDate).format("YYYY-MM-DD");
          branch.ticked = true;
        }
      });

      this.istevenMultiSelectLocalLang.nothingSelected = "Select Denomination";
      this.filterDataSet.denomsList.forEach(function (denom) {
        denom.ticked = false;
      });
      this.filterOrderView();
    }
  }, {
    key: "goToItemHistory",
    value: function goToItemHistory(trackingId) {
      this.Navigation.goToItemHistory(trackingId, null);
    }
  }, {
    key: "changeCoinType",
    value: function changeCoinType(event, type, coin) {
      this.coinTypes[type].selected = coin;
      this.coinTypes[type].isOpen = false;
      this.getCurrency();
      this.getCurrencyTotal();
    }
  }, {
    key: "getCurrencyTotal",
    value: function getCurrencyTotal() {
      // const cashAmount = this.newCash.cashAmount;
      // const coinAmount = this.newCash.coinAmount;
      // this.newCash.totalAmount = cashAmount + coinAmount;

      if (this.newCash.isPackableOrder) {
        var allDenominations = [].concat((0, _toConsumableArray3.default)(this.newCash.multiDenominations), (0, _toConsumableArray3.default)(this.newCash.denominations));

        var cashShipmentAmount = 0;
        var coinShipmentAmount = 0;

        allDenominations.forEach(function (denomination) {
          if (denomination.isEnabled) {
            if (denomination.coinFlag) {
              coinShipmentAmount += denomination.amount || 0;
            } else {
              cashShipmentAmount += denomination.amount || 0;
            }
          }
        });

        this.newCash.cashShipmentAmount = cashShipmentAmount;
        this.newCash.coinShipmentAmount = coinShipmentAmount;
      } else {
        var cashFromDenoms = 0;
        var coinFromDenoms = 0;
        this.newCash.atmDenominations.filter(function (denomination) {
          return denomination.isEnabled;
        }).forEach(function (denomination) {
          var amt = denomination.amount || 0;
          if (denomination.coinFlag) coinFromDenoms += amt;else cashFromDenoms += amt;
        });
        if (cashFromDenoms > 0) {
          this.newCash.cashShipmentAmount = cashFromDenoms;
        }
        if (coinFromDenoms > 0) {
          this.newCash.coinShipmentAmount = coinFromDenoms;
        }
      }
    }
  }, {
    key: "getCurrency",
    value: function getCurrency() {
      var _this18 = this;

      var coinsTotal = 0;
      var coinKeys = (0, _keys2.default)(this.coinTypes);
      coinKeys.forEach(function (coinKey) {
        if (!_this18.coinTypes[coinKey]) return;
        var coinType = _this18.coinTypes[coinKey].selected;
        var categoryName = _this18.coinTypes[coinKey].categoryName;
        if (_this18.newCash.coinShipmentObj[categoryName] >= 0) {
          coinsTotal += _this18.newCash.coinShipmentObj[categoryName] * _this18.getCoinValue(coinType);
          _this18.newCash.coinAmount = coinsTotal;
        }
      });
      if (this.newCash.cashAmount) {
        this.newCash.totalAmount = this.newCash.cashAmount + coinsTotal;
      } else {
        this.newCash.totalAmount = coinsTotal;
      }
    }
  }, {
    key: "getCoinValue",
    value: function getCoinValue(coinType) {
      return this.coinValues[coinType].amountFlag ? this.coinValues[coinType].amount : this.coinValues[coinType].unitValue;
    }
  }, {
    key: "loadFromLocation",
    value: function loadFromLocation(searchKey, offset) {
      var _this19 = this;

      searchKey = searchKey || "";

      var branchId = this.getSelectedBranches();
      var searchObj = {
        queryJSON: {
          rules: [{ field: "branchId", condition: "=", data: branchId && branchId.length ? branchId : [this.branchId] }, { field: "active", condition: "=", data: true }, {
            group: {
              rules: [{ field: "locationType", condition: "=", data: "ATM" }, { field: "locationType", condition: "=", data: "BANK" }, { field: "locationType", condition: "=", data: "REGULAR" }, { field: "locationType", condition: "=", data: "ON_CALL" }, { field: "locationType", condition: "=", data: "NO_SHIP_NO_GO" }, { field: "locationType", condition: "=", data: "DELIVERY" }, { field: "locationType", condition: "=", data: "INTERNAL" }, {
                field: "centralBank",
                condition: "=",
                data: true
              }],
              operator: "OR"
            }
          }, {
            group: {
              rules: [{
                field: "id",
                condition: "like",
                data: "%" + searchKey + "%"
              }, {
                field: "name",
                condition: "like",
                data: "%" + searchKey + "%"
              }],
              operator: "OR"
            }
          }],
          operator: "AND"
        }
      };

      if (this.customerUser) {
        searchObj.queryJSON.rules.push({
          field: "customerId",
          condition: "=",
          data: this.customerUser
        });
      }

      this.LocationService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this19.fromLocationObj.totalRecords = data.total;
          _this19.fromLocationObj.results = _this19.mappingLocData(data.results);
        } else {
          var locations = _this19.mappingLocData(data.results);
          _this19.fromLocationObj.results = _this19.fromLocationObj.results.concat(locations);
        }
      });
    }
  }, {
    key: "mappingLocData",
    value: function mappingLocData(list) {
      return list.map(function (loc) {
        return {
          Key: loc.id + " | " + loc.name,
          Value: loc.id
        };
      });
    }
  }, {
    key: "createCashDeliveries",
    value: function createCashDeliveries() {
      var _this20 = this;

      var dtFormat = "YYYY-MM-DD";
      var obj = this.newCash;
      var shipments = [];
      var days = { 0: "Sun", 1: "Mon", 2: "Tue", 3: "Wed", 4: "Thu", 5: "Fri", 6: "Sat" };
      var selectedDay = days[moment(obj.vaultDate).day()];
      var seqKey = "defRouteSeq" + selectedDay;
      var uniqueShipmentFields = (0, _keys2.default)(this.coinTypes);

      uniqueShipmentFields.forEach(function (field) {
        var type = _this20.coinTypes[field].categoryName;
        if (typeof obj.coinShipmentObj[type] === "number" && obj.coinShipmentObj[type] > 0) {
          var shiptypeId = _this20.coinTypes[field].selected;
          var coinFlag = !!_this20.coinTypes[field].coinFlag;
          shipments.push({
            pickupDate: moment(obj.vaultDate).format(dtFormat),
            deliveryDate: moment(obj.vaultDate).format(dtFormat),
            vaultDate: moment(obj.vaultDate).format(dtFormat),
            fromLocationId: obj.fromLocation.Value,
            toLocationId: obj.toLocation.Value,
            routeSeq: obj.toLocation.dataObj[seqKey] || 0,
            routeId: obj.routeId.Value,
            batchId: obj.batchId,
            branchId: _this20.getSelectedBranches().toString(),
            coinFlag: coinFlag,
            trackingId: obj.trackingId + "-" + shiptypeId,
            amount: obj.coinShipmentObj[type] * _this20.getCoinValue(shiptypeId),
            qty: obj.coinShipmentObj[type],
            shiptypeId: shiptypeId,
            pickupFlag: false,
            packedFlag: true
          });
        }
      });

      if (typeof obj.cashAmount === "number" && obj.cashAmount >= 0) {
        shipments.push({
          pickupDate: moment(obj.vaultDate).format(dtFormat),
          deliveryDate: moment(obj.vaultDate).format(dtFormat),
          vaultDate: moment(obj.vaultDate).format(dtFormat),
          fromLocationId: obj.fromLocation.Value,
          toLocationId: obj.toLocation.Value,
          routeSeq: obj.toLocation.dataObj[seqKey] || 0,
          routeId: obj.routeId.Value,
          batchId: obj.batchId,
          branchId: this.getSelectedBranches().toString(),
          trackingId: obj.trackingId,
          amount: obj.cashAmount,
          qty: 1,
          shiptypeId: "C",
          pickupFlag: false,
          packedFlag: true
        });
      }

      this.isCommitDisabled = true;
      return this.ShipmentService.createShipments(shipments, this.userDetails.id, this.branchHoldRoute).then(function () {
        _this20._calendar.isSidePanelOpen = false;
        _this20.getAtmOrders();
      }).catch(function (err) {
        if (err && err.data && err.data.errors) {
          _this20.Modal.errorModal(err.data.errors[0].message);
        } else if (err && err.data && err.data.message) {
          _this20.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this20.isCommitDisabled = false;
      });
    }
  }, {
    key: "getDeliverToBankLocations",
    value: function getDeliverToBankLocations(searchKey, offset) {
      var _this21 = this;

      searchKey = searchKey || "";
      var fromLocation = this.newCash.fromLocation;

      if (!fromLocation) {
        this.deliveryLocationObj.results = [];
        this.newCash.toLocation = null;
        return;
      }

      var branch = this.getSelectedBranches().toString();
      this.LocationService.getBankDeliverLocations(searchKey, branch, fromLocation.Value, offset, this.deliveryLocationObj.pagination.pageLimit, this.customerUser).then(function (res) {
        if (offset === 0 || offset == undefined) {
          _this21.deliveryLocationObj.totalRecords = res.totalRecords;
          _this21.deliveryLocationObj.results = _this21.mappingData(res.locations, "name", "id");
        } else {
          var locations = _this21.mappingData(res.locations, "name", "id");
          _this21.deliveryLocationObj.results = _this21.deliveryLocationObj.results.concat(locations);
        }
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this21.Modal.errorModal(err.data.message);
        }
      });
    }
  }, {
    key: "getBranchCurrentVaultDate",
    value: function getBranchCurrentVaultDate() {
      var _this22 = this;

      setTimeout(function () {
        var branch = _this22.getSelectedBranches().toString();
        _this22.branchDetails = _.find(_this22.filterDataSet.userBranches, { branchId: branch });
        _this22.filterDataSet.currentVaultDate = moment.utc(_this22.branchDetails.currentVaultDate).format("YYYY-MM-DD");
      });
    }
  }, {
    key: "isAllowToCreateCashDeliveries",
    value: function isAllowToCreateCashDeliveries(selectedDate) {
      return moment(selectedDate).isSameOrAfter(this.filterDataSet.currentVaultDate);
    }
  }, {
    key: "tabViewSelection",
    value: function tabViewSelection(pStat) {
      var _this23 = this;

      if (this.$currentViewTab == pStat) return;
      this.$currentViewTab = pStat;
      this.model.status = null;
      this.searchText = null;
      this.currentOrderStat = null;
      this.model.routeId = null;
      this.model.fundingSourceId = null;
      this.filter.locationId = null;
      if (!this.userDetails.customerUser) {
        this.filter.customerId = null;
      }
      this.filter.orderType = null;
      this.filter.selectedDenoms = [];
      this.setStartDate(this.formattedSelectedMonth);
      this.setEndDate(this.formattedSelectedMonth);
      this.filterDataSet.userBranches.forEach(function (branch) {
        branch.ticked = false;
        if (branch.branchId == _this23.branchId) {
          _this23.filterDataSet.currentVaultDate = moment.utc(branch.currentVaultDate).format("YYYY-MM-DD");
          branch.ticked = true;
        }
      });

      this.istevenMultiSelectLocalLang.nothingSelected = "Select Denomination";
      this.filterDataSet.denomsList.forEach(function (denom) {
        denom.ticked = false;
      });
      this._calendar.isEdit = false;
      this._calendar.isNew = false;
      this._calendar.monthIndex = 0;
      this.generateCalendarDays(this._calendar.monthIndex);
    }
  }, {
    key: "tabSelection",
    value: function tabSelection(pStat, cStat) {
      this.newCash.batchId = "B1-" + moment().toDate().getTime();
      this.newCash.fromLocation = null;
      this.newCash.toLocation = null;
      this.newCash.routeId = null;
      this.newCash.cashAmount = 0;
      this.newCash.coinAmount = 0;
      this.newCash.totalAmount = 0;
      this.newCash.trackingId = null;
      this.newCash.coinShipmentObj = {};
      this.newCash.branchId = this.model.branch;
      this.newCash.orderNo = null;

      this.newCash.branchFundingSourceId = null;
      this.$currentTab = pStat;
      this.model.currentChildStat = null;
      if (this._calendar.selectedDateData) {
        this.createNewCashSchedule(this._calendar.selectedDateData, true);
      }
      if (pStat && cStat) this.model.currentStats = this.shipmentsCreateStats[pStat][cStat];

      this.filterOrderTypes();
      if (pStat === 'cashDeliveries' || pStat === 'ATMOrders' || pStat === 'atmLoad') {
        this.filterDataSet.locationList = [];
        this.filterDataSet.totalLocation = 0;
      }

      if (pStat === 'cashDeliveries') {
        this.newCash.orderType = 'COD';
      } else {
        this.newCash.orderType = null;
      }
    }
  }, {
    key: "childTabSelection",
    value: function childTabSelection(pStat, cStat) {
      this.model.currentChildStat = this.shipmentsCreateStats[pStat][cStat];
    }
  }, {
    key: "onLocationSelect",
    value: function onLocationSelect() {
      var selectedLocation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "hel";

      console.log("SELECTED, ", selectedLocation);
    }
  }, {
    key: "getLocationNextRoute",
    value: function getLocationNextRoute() {
      var _this24 = this;

      if (!this.newCash.toLocation) return;

      this.model.isGettingLocationRoutes = true;

      if (this.newCash.fundingSource && this.newCash.fundingSource.Value) {
        this.getFundingSourceDenomination(this.newCash.fundingSource.Value);
      }

      this.$q.all([this.RouteService.getScheduledRouteByLocationId(this.getFormattedVaultDate(this.newCash.vaultDate), this.newCash.toLocation.Value, this.branchId), this.OrderViewService.findLocationRoute(this.newCash.toLocation.Value, this.getFormattedVaultDate(this.newCash.vaultDate))]).then(function (res) {
        var routes = _this24.mappingData(res[0].results, "name", "id");
        // this.filterDataSet.routeList = routes;
        // this.filterDataSet.totalRoutes = routes.length;

        var routeId = res[0] && res[0].results && res[0].results.length ? res[0].results[0].id : null;
        var findRoute = routeId ? _.find(_this24.filterDataSet.routeList, { Value: routeId }) : null;
        if (findRoute) _this24.newCash.routeId = findRoute;else _this24.newCash.routeId = null;
        if (_this24.newCash.toLocation && (_this24.newCash.fundingSource || _this24.newCash.fromLocation) && _this24.filterDataSet.routeList.length == 1) {
          _this24.newCash.routeId = _this24.filterDataSet.routeList[0];
        }
        if (_this24.userDetails.customerUser && !_this24.newCash.routeId) {
          var holdRoute = _.find(_this24.filterDataSet.routeList, { Value: _this24.branchHoldRoute });
          var unassignedRoute = _.find(_this24.filterDataSet.routeList, { Value: _this24.branchUnassignedRoute });
          _this24.newCash.routeId = holdRoute || unassignedRoute || null;
        }
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this24.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this24.model.isGettingLocationRoutes = false;
      });
    }
  }, {
    key: "onEditVaultDateChange",
    value: function onEditVaultDateChange() {
      var _this25 = this;

      var locationId = this.newCash.locationId && this.newCash.locationId.Value;
      var requestedDate = this.getFormattedVaultDate(this.newCash.vaultDate);
      if (!locationId || !requestedDate) return;

      if (requestedDate === this.editRouteLookupDate) return;
      this.editRouteLookupDate = requestedDate;

      var saved = this.cloneShipmentObj || {};
      if (requestedDate === this.getFormattedVaultDate(saved.vaultDate)) {
        this.newCash.routeId = saved.routeId || null;
        return;
      }

      this.model.isGettingLocationRoutes = true;
      this.RouteService.getScheduledRouteByLocationId(requestedDate, locationId, this.branchId).then(function (res) {
        if (_this25.getFormattedVaultDate(_this25.newCash.vaultDate) !== requestedDate) return;

        var routeId = res && res.results && res.results.length ? res.results[0].id : null;
        var route = routeId ? _.find(_this25.filterDataSet.routeList, { Value: routeId }) : null;
        if (!route) {
          route = _.find(_this25.filterDataSet.routeList, { Value: _this25.branchHoldRoute }) || _.find(_this25.filterDataSet.routeList, { Value: _this25.branchUnassignedRoute });
        }
        _this25.newCash.routeId = route ? route.Value : null;
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this25.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this25.model.isGettingLocationRoutes = false;
      });
    }
  }, {
    key: "getFormattedVaultDate",
    value: function getFormattedVaultDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    }
  }, {
    key: "createAtmOrders",
    value: function createAtmOrders() {
      var _this26 = this;

      var totalAmount = 0,
          denominations = [],
          shipments = [];
      var branchId = this.getSelectedBranches().toString();

      this.newCash.isCreatingAtmOrders = true;
      this.newCash.atmDenominations.forEach(function (d) {
        // for atmLoad
        if (d.isEnabled && d.amount >= 0) {
          var billCount = _this26.shouldUseAmountInput(d) ? _this26.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
          denominations.push({
            denominationId: d.icon,
            amount: d.amount,
            faceValue: d.faceValue,
            billCount: billCount,
            coinFlag: d.coinFlag || 0,
            multiDenomPackable: d.multiDenomPackable || false
          });
          totalAmount += d.amount;
        }
      });

      if (this.model.currentStats === this.shipmentsCreateStats.cashDeliveries.all) {
        var uniqueShipmentFields = (0, _keys2.default)(this.coinTypes);
        uniqueShipmentFields.forEach(function (field) {
          var type = _this26.coinTypes[field].categoryName;
          if (typeof _this26.newCash.coinShipmentObj[type] === "number" && _this26.newCash.coinShipmentObj[type] > 0) {
            var shiptypeId = _this26.coinTypes[field].selected;
            var coinFlag = !!_this26.coinTypes[field].coinFlag;
            shipments.push({
              coinFlag: coinFlag,
              shiptypeId: shiptypeId,
              amount: _this26.newCash.coinShipmentObj[type] * _this26.getCoinValue(shiptypeId),
              qty: _this26.newCash.coinShipmentObj[type]
            });
          }
        });
      }

      var obj = {
        orderNo: this.newCash.orderNo,
        orderType: this.newCash.orderType,
        totalAmount: this.newCash.totalAmount,
        deliveryDate: moment(this.newCash.vaultDate).format("YYYY-MM-DD"),
        vaultDate: moment(this.newCash.vaultDate).format("YYYY-MM-DD"),
        branchFundingSourceId: this.newCash.fundingSource.Value,
        routeId: this.newCash.routeId ? this.newCash.routeId.Value || this.newCash.routeId : null,
        locationId: this.newCash.toLocation.Value,
        createdByUserId: this.userDetails.id,
        branchId: branchId,
        denominations: denominations,
        shipments: shipments,
        manualDeposit: this.newCash.fundingSource.dataObj["manualDeposit"],
        fromLocationId: this.newCash.fundingSource.dataObj["locationId"],
        sourceName: this.newCash.fundingSource.dataObj["sourceName"],
        account: this.newCash.account
      };

      this.OrderViewService.createAtmOrders(obj).then(function (res) {
        _this26._calendar.isSidePanelOpen = false;
        _this26.getAtmOrders();
      }).catch(function (err) {
        if (err && err.data && err.data.errors && err.data.errors.length) {
          if (err.data.errors[0].path == "SHIPMENT.shipment_tracking_id_unique") {
            _this26.Modal.errorModal("error.shipment_tracking_id_unique");
          }
        } else if (err && err.data && err.data.message) {
          _this26.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this26.newCash.isCreatingAtmOrders = false;
      });
    }

    // calculateDenominationAmount(type = 'denominations') {
    //   if (!this.newCash[type]) return;
    //   let totalAmount = this.newCash[type].reduce((sum, d) => {
    //     return d.isEnabled && d.amount !== undefined ? sum + d.amount : sum;
    //   }, 0);
    //   this.newCash.cashAmount = (this.newCash.cashAmount || 0) + totalAmount;
    //   this.getCurrencyTotal();
    // }

  }, {
    key: "calculateDenominationAmount",
    value: function calculateDenominationAmount() {
      var totalCashAmount = 0,
          totalCoinAmount = 0;
      if (this.$currentTab === 'cashDeliveries') {
        [].concat((0, _toConsumableArray3.default)(this.newCash.denominations), (0, _toConsumableArray3.default)(this.newCash.multiDenominations)).forEach(function (d) {
          if (d.isEnabled && d.amount !== undefined && !d.coinFlag) totalCashAmount += d.amount;
          if (d.isEnabled && d.amount !== undefined && d.coinFlag) totalCoinAmount += d.amount;
        });
      } else {
        this.newCash.atmDenominations.forEach(function (d) {
          if (d.isEnabled && d.amount !== undefined && !d.coinFlag) totalCashAmount += d.amount;
          if (d.isEnabled && d.amount !== undefined && d.coinFlag) totalCoinAmount += d.amount;
        });
      }
      this.newCash.coinAmount = totalCoinAmount;
      this.newCash.cashAmount = totalCashAmount;
      this.newCash.totalAmount = this.newCash.cashAmount + this.newCash.coinAmount;
      this.getCurrencyTotal();
    }
  }, {
    key: "getSelectedFundingSourceData",
    value: function getSelectedFundingSourceData() {
      if (this.newCash && this.newCash.fundingSource && this.newCash.fundingSource.dataObj) {
        return this.newCash.fundingSource.dataObj;
      }

      var selectedFundingSourceId = this.newCash ? this.newCash.fundingSourceId || this.newCash.fundingSource && this.newCash.fundingSource.Value : null;

      if (!selectedFundingSourceId || !Array.isArray(this.filterDataSet.branchFundingSource)) {
        return null;
      }

      var selectedFundingSource = this.filterDataSet.branchFundingSource.find(function (bfs) {
        return String(bfs.Value) === String(selectedFundingSourceId);
      });

      return selectedFundingSource ? selectedFundingSource.dataObj : null;
    }
  }, {
    key: "shouldUseAmountInput",
    value: function shouldUseAmountInput(denomination) {
      var fundingSource = this.getSelectedFundingSourceData();
      return !!(fundingSource && fundingSource.allowAmount && denomination);
    }
  }, {
    key: "getBillCountFromAmount",
    value: function getBillCountFromAmount(amount, faceValue) {
      var parsedAmount = Number(amount);
      var parsedFaceValue = Number(faceValue);

      if (!(0, _isFinite2.default)(parsedAmount) || !(0, _isFinite2.default)(parsedFaceValue) || parsedFaceValue <= 0) {
        return null;
      }

      var billCount = parsedAmount / parsedFaceValue;
      var roundedBillCount = Math.round(billCount);

      return Math.abs(billCount - roundedBillCount) < 0.000001 ? roundedBillCount : billCount;
    }
  }, {
    key: "handleDenominationInputChange",
    value: function handleDenominationInputChange(denominationIndex, type) {
      this.newCash.isInteracted = true;
      var denomination = this.newCash[type] && this.newCash[type][denominationIndex];
      if (!denomination) return;

      if (this.shouldUseAmountInput(denomination)) {
        this.checkAmountFromAmount(denominationIndex, denomination.amount, denomination.faceValue, type);
        return;
      }

      this.checkAmount(denominationIndex, denomination.billCount, denomination.faceValue, type);
    }
  }, {
    key: "checkAmountFromAmount",
    value: function checkAmountFromAmount(denominationIndex, amount, faceValue, type) {
      var orderTypes = ["P", "T"];
      var normalizedAmount = amount >= 0 ? Number(amount) : null;
      var billCount = this.getBillCountFromAmount(normalizedAmount, faceValue);
      var isDivisible = Math.abs(billCount - Math.round(billCount)) < 0.000001;

      if (this.newCash[type][denominationIndex].isEnabled) {
        if (orderTypes.includes(this.newCash.orderType)) {
          // Decash: allow 0, but NOT null/empty. Check divisibility if non-zero.
          this.newCash[type][denominationIndex].isValid = normalizedAmount === 0 || normalizedAmount !== null && isDivisible;
        } else {
          // Regular: must be > 0 and divisible
          this.newCash[type][denominationIndex].isValid = normalizedAmount !== null && normalizedAmount > 0 && isDivisible;
        }
      }

      this.validateBillCount();

      this.newCash[type][denominationIndex].amount = normalizedAmount;
      this.newCash[type][denominationIndex].billCount = normalizedAmount !== null ? this.getBillCountFromAmount(normalizedAmount, faceValue) : null;
    }
  }, {
    key: "checkAmount",
    value: function checkAmount(denominationIndex, billCount, faceValue, type) {
      //= 'denominations'
      var orderTypes = ["P", "T"];
      var amount = 0;
      amount = billCount >= 0 ? billCount * faceValue : null;
      var amountInCents = amount ? Math.round(amount * 100) : 0;
      if (this.newCash[type][denominationIndex].isEnabled) {
        if (orderTypes.includes(this.newCash.orderType)) {
          // Decash: allow 0, but NOT null/empty
          this.newCash[type][denominationIndex].isValid = billCount !== null;
        } else {
          // Regular: must be > 0
          this.newCash[type][denominationIndex].isValid = billCount !== 0 && billCount !== null;
        }
      }

      this.validateBillCount();
      this.newCash[type][denominationIndex].amount = amount;
    }
  }, {
    key: "validateATMOrderCreateBtn",
    value: function validateATMOrderCreateBtn() {
      var _this27 = this;

      var orderTypes = ["P", "T"];
      var cursor = 0,
          isValidDay = false,
          isValidMonth = false;

      (0, _keys2.default)(this.newCash.recurringDays).filter(function (key) {
        if (_this27.newCash.recurringDays[key]) isValidDay = true;
      });

      // Object.keys(this.newCash.recurringMonths).filter((key) => {
      //     if (this.newCash.recurringMonths[key]) isValidMonth = true;
      // });

      var disableButton = this.newCash.atmDenominations.map(function (denom) {
        // for atmLoad
        if (denom.isEnabled) return (orderTypes.includes(_this27.newCash.orderType) ? denom.amount >= 0 : denom.amount > 0) && denom.isValid !== undefined && denom.isValid && (
        // (this.model.currentChildStat === this.shipmentsCreateStats.ATMOrders.recurring && this.newCash.selectedPattern === 'monthly' ? isValidMonth : true) &&
        _this27.model.currentChildStat === _this27.shipmentsCreateStats.ATMOrders.recurring ? _this27.newCash.recurringStartDate && (_this27.newCash.recurringEndDate || _this27.newCash.endRecurringAfter) && _this27.newCash.selectedPattern === "weekly" ? isValidDay : true : true) || "isEmpty";
      });

      disableButton.forEach(function (d) {
        if (d == undefined) cursor++;else cursor = 0;
      });
      if (this.model.currentStats === this.shipmentsCreateStats.cashDeliveries.all || this.model.currentStats === this.shipmentsCreateStats.ATMOrders.all) {
        if (this.newCash.coinAmount > 0 || this.newCash.cashAmount > 0) return false;
      }
      return disableButton.indexOf("isEmpty") !== -1 || this.newCash.atmDenominations.length === cursor;
    }
  }, {
    key: "validateBillCount",
    value: function validateBillCount() {
      var _this28 = this;

      var orderTypes = ["P", "T"];
      var isAllValid = true;
      var isMultipleInvalid = false;
      var isZeroInvalid = false;
      var fundingSource = this.getSelectedFundingSourceData();
      var allowAmount = !!(fundingSource && fundingSource.allowAmount);

      var denomsToValidate = [];
      var isPackable = this.newCash.isPackableOrder !== undefined && this.newCash.isPackableOrder !== null ? !!this.newCash.isPackableOrder : this.$currentTab === 'cashDeliveries' || this.model.currentStats === this.shipmentsCreateStats.cashDeliveries.all || this.model.currentStats === this.shipmentsCreateStats.prePacked.all;

      if (isPackable) {
        denomsToValidate = [].concat((0, _toConsumableArray3.default)(this.newCash.denominations || []), (0, _toConsumableArray3.default)(this.newCash.multiDenominations || []));
      } else {
        denomsToValidate = this.newCash.atmDenominations || [];
      }

      denomsToValidate.forEach(function (denom) {
        if (denom.isEnabled) {
          var isDecash = orderTypes.includes(_this28.newCash.orderType);
          if (isDecash && !_this28._calendar.isEdit) {
            denom.amount = 0;
            denom.billCount = 0;
          }
          if (allowAmount) {
            // Amount Mode Logic
            var amount = denom.amount !== null && denom.amount !== undefined ? Number(denom.amount) : null;
            var faceValue = Number(denom.faceValue || 0);
            var calculatedBillCount = _this28.getBillCountFromAmount(amount, faceValue);
            var isDivisible = Math.abs(calculatedBillCount - Math.round(calculatedBillCount)) < 0.000001;

            if (amount !== null && !isDivisible) {
              denom.isValid = false;
              isAllValid = false;
              isMultipleInvalid = true;
            } else if (amount === 0 || amount > 0 && Math.round(calculatedBillCount) === 0) {
              denom.isValid = isDecash;
              if (!isDecash) {
                isAllValid = false;
                if (_this28.newCash.isInteracted) {
                  isZeroInvalid = true;
                }
              }
            } else if (amount === null || amount === undefined) {
              denom.isValid = false; // Empty field is always invalid
              isAllValid = false;
            } else {
              denom.isValid = true;
            }
          } else {
            // Quantity Mode Logic
            var billCount = denom.billCount !== null && denom.billCount !== undefined ? Number(denom.billCount) : null;
            if (billCount === 0) {
              denom.isValid = isDecash;
              if (!isDecash) {
                isAllValid = false;
                if (_this28.newCash.isInteracted) {
                  isZeroInvalid = true;
                }
              }
            } else if (billCount === null || billCount === undefined) {
              denom.isValid = false; // Empty field is always invalid
              isAllValid = false;
            } else {
              denom.isValid = true;
            }
          }
        }
      });
      this.isValidBillCount = isAllValid;
      this.isMultipleInvalid = isMultipleInvalid;
      this.isZeroInvalid = isZeroInvalid;
      if (orderTypes.includes(this.newCash.orderType)) this.calculateDenominationAmount();
    }
  }, {
    key: "updateScheduledShipment",
    value: function updateScheduledShipment() {
      var _this29 = this;

      this.isUpdatingAtmOrders = true;
      var amount = 0;
      var denominations = [];
      var locationId = this.newCash.locationId.Value || null;
      var locationScheduleRecurringId = this.newCash.locationScheduleRecurringId || null;
      this.newCash.isUpdatingAtmOrders = true;
      if (this.newCash.isPackableOrder) {
        denominations = [].concat((0, _toConsumableArray3.default)(this.newCash.denominations), (0, _toConsumableArray3.default)(this.newCash.multiDenominations)).filter(function (denom) {
          return denom.isEnabled;
        });
      } else {
        denominations = this.newCash.atmDenominations.filter(function (denom) {
          return denom.isEnabled;
        });
      }
      if (this.updatedCash.coinShipmentAmount) {
        amount = this.updatedCash.coinShipmentAmount;
      } else {
        amount = this.newCash.cashShipmentAmount;
      }

      if (this.newCash.fetchedDenominations) {
        this.newCash.fetchedDenominations.forEach(function (denomination) {
          var found = denominations.find(function (d) {
            return d.icon === denomination.icon;
          });
          if (!found) {
            denominations.push((0, _extends3.default)({}, denomination, {
              isDeleted: true
            }));
          }
        });
      }

      this.OrderViewService.updateScheduledShipment(denominations, locationId, locationScheduleRecurringId).then(function () {
        _this29.getAtmOrders();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this29.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this29.newCash.isUpdatingAtmOrders = false;
        _this29._calendar.isSidePanelOpen = false;
        _this29._calendar.isEdit = false;
      });
    }
  }, {
    key: "updatePendingPackShipment",
    value: function updatePendingPackShipment() {
      var _this30 = this;

      var orderNo = this.newCash.orderNo;
      var locationId = this.newCash.locationId.Value || null;
      var orderType = this.newCash.orderType;
      var vaultDate = moment(this.newCash.vaultDate).format('YYYY-MM-DD');
      var routeId = this.newCash.routeId;
      var branch = this.getSelectedBranches().toString();
      var cashOrderId = this.newCash.cashOrderId;
      var trackingId = this.newCash.trackingIdDelivery;
      var amount = 0;
      var denominations = [];
      if (this.newCash.isPackableOrder) {
        denominations = [].concat((0, _toConsumableArray3.default)(this.newCash.denominations), (0, _toConsumableArray3.default)(this.newCash.multiDenominations)).filter(function (denom) {
          return denom.isEnabled;
        });
      } else {
        denominations = this.newCash.atmDenominations.filter(function (denom) {
          return denom.isEnabled;
        });
      }
      if (this.updatedCash.coinShipmentAmount) {
        amount = this.updatedCash.coinShipmentAmount;
      } else {
        amount = this.newCash.cashShipmentAmount;
      }
      var denominationId = this.newCash.denominationId;
      this.newCash.isUpdatingAtmOrders = true;

      if (this.newCash.fetchedDenominations) {
        this.newCash.fetchedDenominations.forEach(function (denomination) {
          var found = denominations.find(function (d) {
            return d.icon === denomination.icon;
          });
          if (!found) {
            denominations.push((0, _extends3.default)({}, denomination, {
              isDeleted: true
            }));
          }
        });
      }
      var updateServiceCall = this.newCash.isPackableOrder ? this.OrderViewService.updatePendingPackOrder : this.OrderViewService.updatePendingPackShipment;
      updateServiceCall.call(this.OrderViewService, denominations, vaultDate, locationId, routeId, orderNo, orderType, amount, branch, denominationId, this.userDetails.id).then(function () {
        _this30.getAtmOrders();
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this30.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this30.newCash.isUpdatingAtmOrders = false;
        _this30._calendar.isSidePanelOpen = false;
        _this30._calendar.isEdit = false;
      });
    }
  }, {
    key: "cancelAtmOrder",
    value: function cancelAtmOrder(shipment) {
      var _this31 = this;

      this.newCash.deleteAtmOrders = true;
      shipment.trackingId = shipment.trackingIdDelivery;

      var performDelete = function performDelete(modal, supId) {
        var deleteMethod = shipment.isPackableOrder ? _this31.OrderPackingService.softDeleteOrder(shipment.orderNo, supId, _this31.branchId) : _this31.ShipmentService.softDeleteWholeShipment(shipment.orderNo, _this31.branchId, supId);

        deleteMethod.then(function () {
          modal.close();
          _this31._calendar.isEdit = false;
          _this31._calendar.isNew = false;
          setTimeout(function () {
            _this31.getAtmOrders();
          }, 500);
        }).catch(function (err) {
          modal.close();
          if (err && err.data && err.data.message) {
            _this31.Modal.errorModal("error." + err.data.message);
          }
        }).finally(function () {
          _this31.newCash.deleteAtmOrders = false;
        });
      };

      if (this.userDetails.customerUser) {
        this.Modal.confirm({
          header: 'Confirm Delete',
          message: 'Are you sure you want to delete this shipment?',
          type: 'danger',
          callback: function callback(_ref) {
            var modal = _ref.modal;
            return performDelete(modal, null);
          },
          negative: function negative(_ref2) {
            var modal = _ref2.modal;

            _this31.newCash.deleteAtmOrders = false;
            modal.close();
          }
        });
      } else {
        this.Modal.confirmSupervisor('order-delete', null, function (_ref3) {
          var modal = _ref3.modal,
              supId = _ref3.supId;
          return performDelete(modal, supId);
        }, function (_ref4) {
          var modal = _ref4.modal;

          _this31.newCash.deleteAtmOrders = false;
          modal.close();
        });
      }
    }

    // cancelAtmOrder() {
    //     const branch = this.getSelectedBranches().toString();
    //     this.Modal.confirmSupervisor('cancel-atm-order', null, ({ modal, supId }) => {
    //         this.newCash.deleteAtmOrders = true;

    //         this.OrderViewService.cancelAtmOrder(this.newCash.cashOrderId, branch, supId)
    //             .then(() => {
    //                 setTimeout(() => {
    //                     this.getAtmOrders();
    //                 }, 500)
    //             })
    //             .catch((err) => {
    //                 if (err && err.data && err.data.message) {
    //                     this.Modal.errorModal(err.data.message);
    //                 }
    //             })
    //             .finally(() => {
    //                 this.newCash.deleteAtmOrders = false;
    //                 this._calendar.isSidePanelOpen = false;
    //                 this._calendar.isEdit = false;
    //                 modal.close();
    //             })
    //     }, ({ modal }) => {
    //         modal.close();
    //     });
    // }

    // scheduledTabSelection() {
    //     if (this.model.currentStats === this.stats.pending) this.model.isCompleted = 0;
    //     else if (this.model.currentStats === this.stats.completed) this.model.isCompleted = 1;
    //     this.loadData();
    // }

    // createScheduledAtmShipment() {
    //     this.Modal.scheduledATMShipment(({ modal }) => {
    //     }, ({ modal }) => {
    //         modal.close();
    //     })
    // }

  }, {
    key: "toggleDay",
    value: function toggleDay(day) {
      this.newCash.recurringDays[day.value] = !this.newCash.recurringDays[day.value];
    }
  }, {
    key: "selectedPattern",
    value: function selectedPattern(pattern) {
      this.newCash.selectedPattern = pattern.value;
    }
  }, {
    key: "isDaySelected",
    value: function isDaySelected(day) {
      return this.newCash.recurringDays[day.value];
    }
  }, {
    key: "validateRecurringStartDate",
    value: function validateRecurringStartDate() {
      this.newCash.currentStats = this.model.currentStats;
      this.minRecurrStartDate = {
        // minDate: this.model.currentStats === this.shipmentsCreateStats.stops.multiple ? moment():  this.newCash.vaultDate,
        // moment().isSameOrAfter(this._calendar.selectedDateData.date) ? moment() : this._calendar.selectedDateData.date
        minDate: moment(),
        maxDate: moment(this.newCash.recurringStartDate).add(1, "years")
      };
      this.newCash.recurringStartDate = this.minRecurrStartDate.minDate;
    }
  }, {
    key: "validateEndDate",
    value: function validateEndDate() {
      this.minRecurrDate = {
        minDate: this.newCash.recurringStartDate,
        maxDate: moment(this.newCash.recurringStartDate).add(1, "years")
      };

      if (this.newCash.recurringEndDate && moment(this.newCash.recurringStartDate).isAfter(this.newCash.recurringEndDate)) {
        this.newCash.recurringEndDate = this.newCash.recurringStartDate;
      }
    }
  }, {
    key: "confirmRecurring",
    value: function confirmRecurring(currentStats) {
      var _this32 = this;

      this.Modal.confirm({
        header: this.$translate.instant("common.confirm_title"),
        message: this.$translate.instant("master_cash_schedule.confirm_recurring"),
        callback: function callback(_ref5) {
          var modal = _ref5.modal;

          _this32.isCommit = false;
          modal.close();
          _this32.createRecurring(modal, currentStats);
        },
        negative: function negative(_ref6) {
          var modal = _ref6.modal;

          modal.close();
          _this32.isCommit = false;
        },
        buttons: ["common.ok", "common.cancel"],
        type: "success"
      });
    }
  }, {
    key: "createRecurring",
    value: function createRecurring(modal, currentStats) {
      var _this33 = this;

      var totalAmount = 0,
          denominations = [],
          shipments = [];
      var branchId = this.getSelectedBranches().toString();
      var dayOfMonthObj = {
        january: 0,
        february: 1,
        march: 2,
        april: 3,
        may: 4,
        june: 5,
        july: 6,
        august: 7,
        september: 8,
        october: 9,
        november: 10,
        december: 11
      };

      if (this.$currentTab === "cashDeliveries") {
        this.newCash.denominations.forEach(function (d) {
          if (d.isEnabled && d.amount > 0) {
            var billCount = _this33.shouldUseAmountInput(d) ? _this33.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
            denominations.push({
              denominationId: d.icon,
              amount: d.amount,
              faceValue: d.faceValue,
              billCount: billCount,
              multiDenomPackable: d.multiDenomPackable,
              coinFlag: d.coinFlag,
              shiptypeId: d.shiptypeId
            });
            totalAmount += d.amount;
          }
        });

        this.newCash.multiDenominations.forEach(function (d) {
          if (d.isEnabled && d.amount > 0) {
            var billCount = _this33.shouldUseAmountInput(d) ? _this33.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
            denominations.push({
              denominationId: d.icon,
              amount: d.amount,
              faceValue: d.faceValue,
              billCount: billCount,
              multiDenomPackable: d.multiDenomPackable,
              coinFlag: d.coinFlag
            });
            totalAmount += d.amount;
          }
        });
      } else {

        this.newCash.atmDenominations.forEach(function (d) {
          // for atmLoad
          if (d.isEnabled && d.amount > 0) {
            var billCount = _this33.shouldUseAmountInput(d) ? _this33.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
            denominations.push({
              denominationId: d.icon,
              amount: d.amount,
              faceValue: d.faceValue,
              billCount: billCount,
              multiDenomPackable: d.multiDenomPackable,
              coinFlag: d.coinFlag
            });
            totalAmount += d.amount;
          }
        });
      }

      if (currentStats === this.shipmentsCreateStats.cashDeliveries.all) {
        var uniqueShipmentFields = (0, _keys2.default)(this.coinTypes);
        uniqueShipmentFields.forEach(function (field) {
          var type = _this33.coinTypes[field].categoryName;
          if (typeof _this33.newCash.coinShipmentObj[type] === "number" && _this33.newCash.coinShipmentObj[type] > 0) {
            var shiptypeId = _this33.coinTypes[field].selected;
            var coinFlag = !!_this33.coinTypes[field].coinFlag;
            shipments.push({
              coinFlag: coinFlag,
              shiptypeId: shiptypeId,
              amount: _this33.newCash.coinShipmentObj[type] * _this33.getCoinValue(shiptypeId),
              qty: _this33.newCash.coinShipmentObj[type]
            });
          }
        });
      }

      var obj = {
        orderNo: this.newCash.orderNo,
        orderType: this.newCash.orderType,
        totalAmount: this.newCash.totalAmount,
        vaultDate: moment(this.newCash.vaultDate).format("YYYY-MM-DD"),
        fundingSourceId: this.newCash.fundingSource.Value,
        routeId: this.newCash.routeId.Value,
        locationId: this.newCash.toLocation.Value,
        createdByUserId: this.userDetails.id,
        branchId: branchId,
        denominations: denominations,
        shipments: shipments,
        manualDeposit: this.newCash.fundingSource.dataObj["manualDeposit"],
        fromLocationId: this.newCash.fundingSource.dataObj["locationId"],
        fundingSourceName: this.newCash.fundingSource.dataObj["sourceName"],
        recurringStartDate: moment(this.newCash.recurringStartDate).format("YYYY-MM-DD 00:00:00"),
        recurringEndDate: this.newCash.recurringEndDate ? moment(this.newCash.recurringEndDate).format("YYYY-MM-DD 23:59:59") : null,
        selectedPattern: this.newCash.selectedPattern,
        recurWeeks: this.newCash.recurWeeks,
        recurringDays: (0, _keys2.default)(this.newCash.recurringDays).filter(function (key) {
          return _this33.newCash.recurringDays[key];
        }),
        toLocationName: this.newCash.toLocation.dataObj.name,
        routeName: this.newCash.routeId.dataObj.name,
        customerId: this.newCash.toLocation.dataObj.customerId,
        recurringFrequency: this.recurringFrequency(this.newCash.selectedPattern, this.newCash.recurWeeks, this.newCash.recurringMonthObj),
        scheduleMonths: (0, _keys2.default)(this.newCash.recurringMonths).filter(function (key) {
          return _this33.newCash.recurringMonths[key];
        }),
        recurringDayInterval: this.newCash.recurringDayInterval,
        selectedMonthlyPattern: this.selectedMonthlyPattern,
        endRecurringAfter: this.newCash.endRecurringAfter
      };

      if (this.selectedMonthlyPattern === "the") {
        this.monthlyRecurring = {
          weekInterval: this.newCash.recurringMonthObj.month.weekInterval,
          selectedWeekDay: this.newCash.recurringMonthObj.month.selectedWeekDay,
          monthInterval: this.newCash.recurringMonthObj.month.monthInterval,
          frequencyMonth: this.newCash.recurringMonthObj.month.frequencyMonth,
          frequencyWeek: this.newCash.recurringMonthObj.month.frequencyWeek
        };
      }

      var weekDays = obj.recurringDays.map(function (rd) {
        return rd.charAt(0).toUpperCase() + rd.slice(1);
      });
      obj.scheduleWeekDays = weekDays.splice(",").join(" | ");
      obj.scheduleMonths = obj.scheduleMonths.map(function (d) {
        return dayOfMonthObj[d];
      });
      obj.recurringMonthObj = this.selectedMonthlyPattern === "day" ? this.newCash.recurringMonthObj.day : this.monthlyRecurring;
      obj.isPackableOrder = this.$currentTab === "cashDeliveries" ? 1 : 0;
      this.newCash.isCreateRecurring = true;
      this.OrderViewService.createRecurringATMLoadShipment(obj).then(function (res) {
        _this33.getAtmOrders();
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        if (modal) modal.close();
        _this33.newCash.isCreateRecurring = false;
      });
    }
  }, {
    key: "generateOrderNumber",
    value: function generateOrderNumber() {
      var _this34 = this;

      this.model.gettingOrderNo = true;
      this.OrderViewService.generateOrderNumber().then(function (res) {
        _this34.newCash.orderNo = res.nextOrderNumber;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this34.model.gettingOrderNo = false;
      });
    }
  }, {
    key: "getLocationOrdersSinceSwap",
    value: function getLocationOrdersSinceSwap() {
      var _this35 = this;

      if (!this.newCash.toLocation) return;

      this.model.gettingLocOrder = true;
      this.OrderViewService.getLocationOrdersSinceSwap(this.newCash.toLocation.Value).then(function (res) {
        _this35.nextOrderType = res.nextOrderType;
        _this35.newCash.orderType = _this35.nextOrderType;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this35.model.gettingLocOrder = false;
      });
    }
  }, {
    key: "setOrderType",
    value: function setOrderType() {
      if (this.model.currentChildStat === this.shipmentsCreateStats.ATMOrders.recurring && this.newCash.toLocation) {
        this.getLocationOrdersSinceSwap();
      }
    }
  }, {
    key: "recurringFrequency",
    value: function recurringFrequency() {
      var selectedPattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var recurWeeks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var recurringMonthObj = arguments[2];

      var weeks = { 1: "Every 1st Week", 2: "Every 2nd Week", 3: "Every 3rd Week", 4: "Every 4th Week" };
      var dayOfWeekObj = { 0: "sunday", 1: "monday", 2: "tuesday", 3: "wednesday", 4: "thursday", 5: "friday", 6: "saturday" };

      switch (selectedPattern) {
        case "daily":
          {
            return "Daily";
          }
        case "weekly":
          {
            return weeks[recurWeeks];
          }
        case "monthly":
          {
            if (this.selectedMonthlyPattern === "day") {
              recurringMonthObj.day.frequencyMonth = this.CommonLayoutService.ordinalSuffixOf(recurringMonthObj.day.monthInterval) + " Month";
              recurringMonthObj.day.frequencyDay = recurringMonthObj.day.dayInterval;
              return "Monthly";
            } else if (this.selectedMonthlyPattern === "the") {
              recurringMonthObj.month.frequencyMonth = this.CommonLayoutService.ordinalSuffixOf(recurringMonthObj.month.monthInterval) + " Month";
              recurringMonthObj.month.frequencyWeek = weeks[recurringMonthObj.month.weekInterval] + " (" + dayOfWeekObj[recurringMonthObj.month.selectedWeekDay] + ")";
              return "Monthly";
            }
          }
        default:
          return;
      }
    }
  }, {
    key: "cancelRecurringATMLoadShipment",
    value: function cancelRecurringATMLoadShipment(obj) {
      var _this36 = this;

      this.newCash.deleteAtmOrders = true;
      var denominationId = null;
      if (obj.isPackableOrder) {
        if (obj.coinShipments.length > 0) {
          denominationId = obj.coinShipments[0].denominations[0].denominationId;
        } else {
          denominationId = obj.denominationId;
        }
      } else {
        denominationId = null; //As in case of ATM Load Shipment, denominationId is not required we delete the whole job
      }
      this.OrderViewService.cancelRecurringATMLoadShipment(obj.jobId, null).then(function (res) {
        _this36._calendar.isSidePanelOpen = false;
        _this36._calendar.isNew = false;
        _this36._calendar.isEdit = false;
        _this36.getAtmOrders();
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this36.newCash.deleteAtmOrders = false;
      });
    }
  }, {
    key: "allowRecurring",
    value: function allowRecurring() {
      return moment(moment().format("YYYY-MM-DD")).isSameOrBefore(this._calendar.selectedDateData.formatedDate);
    }
  }, {
    key: "toggleMonth",
    value: function toggleMonth(month) {
      this.newCash.recurringMonths[month.value] = !this.newCash.recurringMonths[month.value];
    }
  }, {
    key: "isMonthSelected",
    value: function isMonthSelected(month) {
      return this.newCash.recurringMonths[month.value];
    }
  }, {
    key: "resetRecurringData",
    value: function resetRecurringData() {
      var _this37 = this;

      (0, _keys2.default)(this.newCash.recurringMonths).filter(function (key) {
        return _this37.newCash.recurringMonths[key] = false;
      });
      this.newCash.recurWeeks = 0;
    }
  }, {
    key: "getMonthlyPattern",
    value: function getMonthlyPattern(pattern) {
      this.selectedMonthlyPattern = pattern;
    }
  }, {
    key: "resetMothlyPattern",
    value: function resetMothlyPattern() {
      if (this.selectedMonthlyPattern === "day") {
        this.newCash.recurringMonthObj.month.weekInterval = null;
        this.newCash.recurringMonthObj.month.selectedWeekDay = null;
        this.newCash.recurringMonthObj.month.monthInterval = null;
      } else if (this.selectedMonthlyPattern === "the") {
        this.newCash.recurringMonthObj.day = {
          dayInterval: null,
          monthInterval: null
        };
      }
    }
  }, {
    key: "updatePackedCashBag",
    value: function updatePackedCashBag() {
      var _this38 = this;

      var vaultDate = moment(this.newCash.vaultDate).format("YYYY-MM-DD");
      var routeId = this.newCash.routeId;
      var branch = this.getSelectedBranches().toString();
      var trackingId = this.newCash.trackingIdDelivery;
      var coinShipments = this.updatedCash.coinShipments;
      var cashShipmentAmount = this.updatedCash.cashShipmentAmount;
      this.newCash.isUpdatingPackedCashBag = true;
      this.OrderViewService.updatePackedCashBag(trackingId, vaultDate, routeId, branch, coinShipments, cashShipmentAmount).then(function () {
        setTimeout(function () {
          _this38.getAtmOrders();
        }, 500);
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this38.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this38.newCash.isUpdatingPackedCashBag = false;
        _this38._calendar.isSidePanelOpen = false;
        _this38._calendar.isEdit = false;
      });
    }
  }, {
    key: "getRouteListFromSelectedLocation",
    value: function getRouteListFromSelectedLocation() {
      var _this39 = this;

      var locationId = void 0;
      if (this.model.currentStats === this.shipmentsCreateStats.prePacked.all && this.newCash.fromLocation) {
        locationId = this.newCash.fromLocation.Value;
      } else if (this.newCash.fundingSource) {
        locationId = this.newCash.fundingSource.dataObj["locationId"];
      }
      var vaultDate = moment(this.newCash.vaultDate).format("YYYY-MM-DD");

      if (!locationId || !vaultDate) {
        this.newCash.routeId = "";
        this.getActiveRoutes(0, "");
        return;
      };
      this.RouteService.getScheduledRouteByLocationId(vaultDate, locationId, this.branchId).then(function (res) {
        var routes = _this39.mappingData(res.results, "name", "id");
        // this.filterDataSet.routeList = routes;
        // this.filterDataSet.totalRoutes = routes.length;
        // this.newCash.routeId = "";

        var routeId = res.results && res.results.length > 0 ? res.results[0].id : null;
        var findRoute = _.find(routes, { Value: routeId });
        if (findRoute) _this39.newCash.routeId = findRoute;else _this39.newCash.routeId = null;
      });
    }
  }, {
    key: "updateTotalUpdateAmount",
    value: function updateTotalUpdateAmount(coinShipment) {
      if (!coinShipment.qty) return;
      var amount = 0;
      this.updatedCash.coinShipmentAmount -= coinShipment.amount;
      if (this.newCash.isPackableOrder) {
        amount = Number(coinShipment.qty) * coinShipment.denomFaceValue;
      } else {
        amount = Number(coinShipment.qty) * this.getCoinValue(coinShipment.shiptypeId);
      }
      coinShipment.amount = amount;
      this.updatedCash.coinShipmentAmount += amount;
    }
  }, {
    key: "checkForStrapCount",
    value: function checkForStrapCount() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.newCash.fundingSource) return true;

      var isValid = true;
      if (this.newCash.fundingSource.dataObj) {
        var strapCountEnforced = this.newCash.fundingSource.dataObj.enforceStraps || false;
        if (strapCountEnforced) {
          var denomsToValidate = [];
          if (type) {
            denomsToValidate = this.newCash[type] || [];
          } else {
            var isPackable = this.newCash.isPackableOrder !== undefined && this.newCash.isPackableOrder !== null ? !!this.newCash.isPackableOrder : this.$currentTab === 'cashDeliveries' || this.model.currentStats === this.shipmentsCreateStats.cashDeliveries.all || this.model.currentStats === this.shipmentsCreateStats.prePacked.all;

            if (isPackable) {
              denomsToValidate = [].concat((0, _toConsumableArray3.default)(this.newCash.multiDenominations || []), (0, _toConsumableArray3.default)(this.newCash.denominations || []));
            } else {
              denomsToValidate = this.newCash.atmDenominations || [];
            }
          }

          for (var i = 0; i < denomsToValidate.length; ++i) {
            var item = denomsToValidate[i];
            if (item.strapCount && item.billCount && item.isEnabled) {
              if (item.billCount % item.strapCount !== 0) {
                isValid = false;
                break;
              }
            }
          }
        }
      }
      this.isValidStrapBillCount = isValid;
      return isValid;
    }

    // scheduleLocation(modal) {
    //     const branchId = this.getSelectedBranches().toString();

    //     const obj = {
    //         vaultDate: moment(this.newCash.vaultDate).format('YYYY-MM-DD'),
    //         routeId: this.newCash.routeId.Value,
    //         locationId: this.newCash.toLocation.Value,
    //         createdByUserId: `${this.userDetails.id}`,
    //         createdByUserName: `${this.userDetails.firstName} ${this.userDetails.lastName}`,
    //         branchId,
    //         recurringStartDate: moment(this.newCash.recurringStartDate).format('YYYY-MM-DD 00:00:00'),
    //         recurringEndDate: moment(this.newCash.recurringEndDate).format('YYYY-MM-DD 23:59:59'),
    //         selectedPattern: this.newCash.selectedPattern,
    //         recurWeeks: this.newCash.recurWeeks,
    //         locationName: this.newCash.toLocation.dataObj.name,
    //         routeName: this.newCash.routeId.dataObj.name,
    //         customerId: this.newCash.toLocation.dataObj.customerId,
    //         routeSequence: this.newCash.routeSequence || null,
    //         locationType: this.newCash.toLocation.dataObj.locationType,
    //         recurringDays: Object.keys(this.newCash.recurringDays).filter((key) => {
    //             return this.newCash.recurringDays[key]
    //         })
    //     };

    //     console.log(obj)
    //     this.newCash.isCreateRecurring = true;
    //     this.OrderViewService.createLocationRecurring(obj)
    //         .then(() => {
    //             this.getAtmOrders();
    //         })
    //         .catch(err => {
    //             console.log(err);
    //         })
    //         .finally(() => {
    //             if (modal) modal.close();
    //             this.newCash.isCreateRecurring = false;
    //         })
    // }

    // confirmLocationRecurring() {
    //     this.Modal.confirm({
    //         header: this.$translate.instant('common.confirm_title'),
    //         message: this.$translate.instant('master_cash_schedule.confirm_stops_recurring'),
    //         callback: (({
    //             modal
    //         }) => {
    //             this.isCommit = false;
    //             modal.close();
    //             this.scheduleLocation(modal)
    //         }),
    //         negative: (({
    //             modal,
    //         }) => {
    //             modal.close();
    //             this.isCommit = false;
    //         }),
    //         buttons: ['common.ok', 'common.cancel'],
    //         type: 'success'
    //     })
    // }

    // validateStopsScheduleBtn() {
    //     const disableButton = this.newCash.recurringStartDate && this.newCash.recurringEndDate &&
    //         this.newCash.toLocation && this.newCash.toLocation.Value && this.newCash.routeId &&
    //         this.newCash.routeId.Value || 'isEmpty';
    //     return disableButton.indexOf('isEmpty') !== -1;
    // }

  }, {
    key: "handleEditCash",
    value: function handleEditCash(dateCollection) {
      var _this40 = this;

      if (dateCollection.isPackableOrder) {
        this.allOrderTypes = [].concat((0, _toConsumableArray3.default)(this.filterDataSet.orderTypes)).filter(function (o) {
          return o.key == "Change Order Delivery";
        });
      } else {
        this.allOrderTypes = [].concat((0, _toConsumableArray3.default)(this.filterDataSet.orderTypes)).filter(function (o) {
          return o.key !== "Change Order Delivery" && o.value !== 'T&R';
        });
      }
      this.$q.all([this.getAllFundingSource("", 0), this.getFundingSourceDenomination(dateCollection.fundingSourceId, dateCollection)]).then(function () {
        _this40.editCashSchedule(dateCollection);
        if (dateCollection.isPackableOrder) {
          _this40.checkForStrapCount('denominations');
          _this40.checkForStrapCount('multiDenominations');
        } else {
          _this40.checkForStrapCount('atmDenominations');
        }
      }).catch(function (error) {
        console.error("Error in getFundingSourceDenomination:", error);
      });
    }
  }, {
    key: "redirectToOrderTab",
    value: function redirectToOrderTab(data) {
      var isInProcess = data.packedFlag && !data.finishedAt;
      var isPending = !data.packedFlag;
      var isCounted = data.finishedAt;
      var fundingSourceId = data.fundingSourceId ? data.fundingSourceId : this.model.locationId && this.model.locationId.Value;
      this.Navigation.goToOrderHistory(data.orderNo, data.vaultDate, true, isCounted, isInProcess, isPending, null, fundingSourceId);
    }
  }, {
    key: "getFundingSourceDenomination",
    value: function getFundingSourceDenomination(branchFundingSourceId) {
      var _this41 = this;

      var dateCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!branchFundingSourceId) return;
      this.loadBfsDenomination = true;
      this.denominationAllType = [];
      this.newCash.denominations = [];
      this.newCash.multiDenominations = [];
      this.newCash.remainingDenominations = [];
      this.newCash.remainingMultiDenominations = [];
      this.newCash.remainingAtmDenominations = [];
      this.newCash.atmDenominations = [];
      var fetchDenominations = [];

      var selectedBFS = this.filterDataSet.branchFundingSource.find(function (bfs) {
        return bfs.Value === branchFundingSourceId;
      });
      var currencyId = selectedBFS ? selectedBFS.dataObj.currencyId : null;
      var locationId = dateCollection && dateCollection.toLocationId ? dateCollection.toLocationId : this.newCash.toLocation ? this.newCash.toLocation.Value : null;
      if (dateCollection) {
        fetchDenominations = dateCollection.isPackableOrder === 1 ? this.OrderViewService.getFundingSourceDenominationUnpack(branchFundingSourceId) : this.OrderViewService.getFundingSourceDenomination(branchFundingSourceId, locationId);
      } else {
        fetchDenominations = this.$currentTab === "cashDeliveries" ? this.OrderViewService.getFundingSourceDenominationUnpack(branchFundingSourceId) : this.OrderViewService.getFundingSourceDenomination(branchFundingSourceId, locationId);
      }

      return fetchDenominations.then(function (res) {
        var filteredResults = res.results.sort(function (a, b) {
          return a.sortOrder - b.sortOrder || a.faceValue - b.faceValue;
        });
        if (currencyId) {
          filteredResults = res.results.sort(function (a, b) {
            return a.sortOrder - b.sortOrder || a.faceValue - b.faceValue;
          }).filter(function (denom) {
            return denom.currencyId === currencyId;
          });
        }

        // this.denominationAllType = filteredResults;
        var denominationsToUse = filteredResults.filter(function (d) {
          return !d.unfit;
        });
        if (_this41.customerUser) {
          denominationsToUse = denominationsToUse.filter(function (d) {
            return d.customerOrderable;
          });
        }

        _this41.denominationAllType = denominationsToUse;

        _this41.denomModelType.forEach(function (d) {
          var type = void 0,
              remainingDenomModelKey = void 0;
          switch (d) {
            case "single":
              type = 'denominations';
              remainingDenomModelKey = 'remainingDenominations';
              break;
            case "multi":
              type = 'multiDenominations';
              remainingDenomModelKey = 'remainingMultiDenominations';
              break;
            case "atm":
              type = 'atmDenominations';
              remainingDenomModelKey = 'remainingAtmDenominations';
              break;
            default:
              'denominations';
          }
          // this.newCash[remainingDenomModelKey] = filteredResults.sort((a, b) => a.sortOrder - b.sortOrder);
          // if (filteredResults && filteredResults.length > 0) {
          _this41.newCash[remainingDenomModelKey] = denominationsToUse.sort(function (a, b) {
            return a.sortOrder - b.sortOrder || a.faceValue - b.faceValue;
          });
          if (denominationsToUse && denominationsToUse.length > 0) {
            // for (var i = 0; this.newCash[type].length < length; i++) {
            //     console.log(this.newCash[remainingDenomModelKey][i].coinFlag, this.newCash[remainingDenomModelKey][i].id)
            //       this.newCash[type].push({
            //           isEnabled: i === 0,
            //           icon: this.newCash[remainingDenomModelKey].length > 0 ? this.newCash[remainingDenomModelKey][0].id : null,
            //           faceValue: this.newCash[remainingDenomModelKey].length > 0 ? this.newCash[remainingDenomModelKey][0].faceValue : 0,
            //           amount: null,
            //           template: d == 'single' ? 'order-view-denomination-selection.html' : 'order-view-multi-denomination-selection.html',
            //           dollarFlag: true,
            //           duplicate: false,
            //           multiDenomPackable: i == 0 ? true : this.newCash[remainingDenomModelKey][0].multiDenomPackable,
            //           strapCount: i === 0 ? 100 : (this.newCash[remainingDenomModelKey].length > 0 && this.newCash[remainingDenomModelKey][0].strapCount) || 0,
            //           coinFlag: this.newCash[remainingDenomModelKey][i].coinFlag
            //       });
            //       this.removeAlreadyUsedDenom(type, remainingDenomModelKey);
            //     }
            if (d == 'single') {
              var _newCash$denomination;

              // let allSingleDenoms = filteredResults.filter(d => !d.multiDenomPackable).map((denom, index) => ({
              var allSingleDenoms = denominationsToUse.filter(function (d) {
                return !d.multiDenomPackable;
              }).map(function (denom, index) {
                return {
                  isEnabled: index == 0,
                  icon: denom.id,
                  faceValue: denom.faceValue,
                  amount: null,
                  template: "order-view-denomination-selection.html",
                  dollarFlag: true,
                  duplicate: true,
                  multiDenomPackable: false,
                  strapCount: denom.strapCount || 0,
                  coinFlag: denom.coinFlag,
                  sortOrder: denom.sortOrder,
                  shiptypeId: denom.shiptypeId
                };
              });
              (_newCash$denomination = _this41.newCash.denominations).push.apply(_newCash$denomination, (0, _toConsumableArray3.default)(allSingleDenoms));
              _this41.removeAlreadyUsedDenom('denominations', 'remainingDenominations');
              _this41.checkSingleDenomCoinShiptype();
            } else if (d == 'multi') {
              var _newCash$multiDenomin;

              // let allMultiDenoms = filteredResults.filter(d => d.multiDenomPackable).map((denom, index) => ({
              var allMultiDenoms = denominationsToUse.filter(function (d) {
                return d.multiDenomPackable;
              }).map(function (denom, index) {
                return {
                  isEnabled: index == 0,
                  icon: denom.id,
                  faceValue: denom.faceValue,
                  amount: null,
                  template: 'order-view-multi-denomination-selection.html',
                  dollarFlag: true,
                  duplicate: true,
                  multiDenomPackable: true,
                  strapCount: denom.strapCount || 0,
                  coinFlag: denom.coinFlag,
                  sortOrder: denom.sortOrder,
                  shiptypeId: denom.shiptypeId
                };
              });
              (_newCash$multiDenomin = _this41.newCash.multiDenominations).push.apply(_newCash$multiDenomin, (0, _toConsumableArray3.default)(allMultiDenoms));
              _this41.removeAlreadyUsedDenom('multiDenominations', 'remainingMultiDenominations');
            } else if (d === 'atm') {
              var _newCash$atmDenominat;

              var allAtmDenoms = denominationsToUse.map(function (denom, index) {
                return {
                  isEnabled: index == 0,
                  id: denom.id,
                  icon: denom.id,
                  faceValue: denom.faceValue,
                  amount: null,
                  template: 'order-view-atm-denomination-selection.html',
                  dollarFlag: true,
                  duplicate: true,
                  multiDenomPackable: denom.multiDenomPackable,
                  strapCount: denom.strapCount || 0,
                  coinFlag: denom.coinFlag,
                  sortOrder: denom.sortOrder,
                  shiptypeId: denom.shiptypeId
                };
              });
              // For ATM orders, allow as many denominations as are available (no hard cap)
              (_newCash$atmDenominat = _this41.newCash.atmDenominations).push.apply(_newCash$atmDenominat, (0, _toConsumableArray3.default)(allAtmDenoms));
              _this41.removeAlreadyUsedDenom('atmDenominations', 'remainingAtmDenominations');
            }
          }
        });
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this41.loadBfsDenomination = false;
        if (_this41.newCash.orderType === 'P' || _this41.newCash.orderType === 'T') _this41.validateBillCount();
      });
    }
  }, {
    key: "onFundingSourceSelected",
    value: function onFundingSourceSelected() {
      this.newCash.toLocation = null;
      this.filterDataSet.locationList = [];
      this.filterDataSet.totalLocation = 0;
      this.newCash.routeId = null;
      if (this.userDetails.customerUser) {
        this.applyCustomerFundingSourceLeadDate();
      }
      this.loadLocation('', 0);
    }
  }, {
    key: "getSelectedFundingSourceLeadConfig",
    value: function getSelectedFundingSourceLeadConfig() {
      var fundingSource = this.newCash && this.newCash.fundingSource && this.newCash.fundingSource.dataObj ? this.newCash.fundingSource.dataObj : null;
      if (fundingSource && 'customerOrderLeadTime' in fundingSource && 'orderLeadDays' in fundingSource && 'orderLeadCutoff' in fundingSource) return fundingSource;
      var selectedFundingSourceId = this.newCash ? this.newCash.fundingSourceId || this.newCash.fundingSource && this.newCash.fundingSource.Value : null;
      if (!selectedFundingSourceId || !Array.isArray(this.filterDataSet.branchFundingSource)) return null;
      var selectedFundingSource = this.filterDataSet.branchFundingSource.find(function (bfs) {
        return String(bfs.Value) === String(selectedFundingSourceId);
      });
      return selectedFundingSource ? selectedFundingSource.dataObj : null;
    }
  }, {
    key: "getSelectedBranchCalendar",
    value: function getSelectedBranchCalendar() {
      var _this42 = this;

      return _.find(this.filterDataSet.userBranches, function (branch) {
        return branch.branchId == _this42.branchId;
      });
    }
  }, {
    key: "isBranchBusinessDay",
    value: function isBranchBusinessDay(date, branchRow) {
      if (!branchRow) return true;
      var dayFlagByIsoWeekday = {
        1: 'businessDayMon', 2: 'businessDayTue', 3: 'businessDayWed', 4: 'businessDayThu',
        5: 'businessDayFri', 6: 'businessDaySat', 7: 'businessDaySun'
      };
      var flagName = dayFlagByIsoWeekday[date.isoWeekday()];
      return !!branchRow[flagName];
    }
  }, {
    key: "addBranchBusinessDays",
    value: function addBranchBusinessDays(startDate, days, branchRow) {
      var date = moment(startDate);
      if (!branchRow) return date.add(days, 'days');
      var counted = 0;
      while (counted < days) {
        date = date.add(1, 'day');
        if (this.isBranchBusinessDay(date, branchRow)) counted += 1;
      }
      return date;
    }
  }, {
    key: "isNonBusinessDay",
    value: function isNonBusinessDay(date, mode) {
      if (mode !== 'day' || !this.shouldApplyCustomerFundingSourceLeadDate()) return false;
      return !this.isBranchBusinessDay(moment(date), this.getSelectedBranchCalendar());
    }
  }, {
    key: "getCustomerLeadMinDate",
    value: function getCustomerLeadMinDate() {
      var currentVaultDate = moment(this.filterDataSet.currentVaultDate);
      var fundingSource = this.getSelectedFundingSourceLeadConfig();
      if (!currentVaultDate.isValid() || !fundingSource || !fundingSource.customerOrderLeadTime) return null;

      var leadDays = Number(fundingSource.orderLeadDays);
      var cutoff = fundingSource.orderLeadCutoff;
      if ((0, _isNan2.default)(leadDays) || leadDays < 0 || !cutoff) return null;

      var parsedCutoff = moment(cutoff, ["HH:mm:ss", "HH:mm", "hh:mm A"], true);
      if (!parsedCutoff.isValid()) return null;

      var now = moment();
      var cutoffToday = moment().startOf("day").hour(parsedCutoff.hour()).minute(parsedCutoff.minute()).second(parsedCutoff.second()).millisecond(0);
      var dayOffset = leadDays + (now.isAfter(cutoffToday) ? 1 : 0);
      var branchRow = this.getSelectedBranchCalendar();
      var minDate = this.addBranchBusinessDays(currentVaultDate.startOf("day"), dayOffset, branchRow);

      return minDate;
    }
  }, {
    key: "shouldApplyCustomerFundingSourceLeadDate",
    value: function shouldApplyCustomerFundingSourceLeadDate() {
      var fundingSource = this.getSelectedFundingSourceLeadConfig();
      return !!(this.userDetails.customerUser && fundingSource && fundingSource.customerOrderLeadTime);
    }
  }, {
    key: "setMaxDate",
    value: function setMaxDate(minDate) {
      this.maxDate = this.maxDate || {};
      if (minDate) {
        this.maxDate.minDate = minDate;
      } else {
        delete this.maxDate.minDate;
      }
    }
  }, {
    key: "applyCustomerFundingSourceLeadDate",
    value: function applyCustomerFundingSourceLeadDate() {
      var minDate = this.getCustomerLeadMinDate();
      this.setMaxDate(minDate);
      if (!minDate) return;
      this.newCash.vaultDate = moment(minDate);
      this.onVaultDateChange();
    }
  }, {
    key: "createPackableOrder",
    value: function createPackableOrder() {
      var _this43 = this;

      this.newOrder = this.newCash;
      var totalAmount = 0,
          denominations = [];

      var branchId = this.getSelectedBranches().toString();
      this.newOrder.isCreating = true;
      this.newCash.isCreatingAtmOrders = true;

      this.newOrder.denominations.forEach(function (d) {
        if (d.isEnabled && d.amount >= 0) {
          var billCount = _this43.shouldUseAmountInput(d) ? _this43.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
          denominations.push({
            denominationId: d.icon,
            amount: d.amount,
            multiDenomPackable: d.multiDenomPackable,
            coinFlag: d.coinFlag,
            shiptypeId: d.shiptypeId,
            qty: billCount
          });
          totalAmount += d.amount;
        }
      });

      this.newOrder.multiDenominations.forEach(function (d) {
        if (d.isEnabled && d.amount >= 0) {
          var billCount = _this43.shouldUseAmountInput(d) ? _this43.getBillCountFromAmount(d.amount, d.faceValue) : d.billCount;
          denominations.push({
            denominationId: d.icon,
            amount: d.amount,
            multiDenomPackable: d.multiDenomPackable,
            coinFlag: d.coinFlag,
            shiptypeId: d.shiptypeId,
            qty: billCount
          });
          totalAmount += d.amount;
        }
      });

      var obj = {
        fundingSourceId: this.newOrder.fundingSource.Value,
        locationId: this.newOrder.toLocation ? this.newOrder.toLocation.Value : null,
        orderNo: this.newOrder.orderNo,
        branchId: branchId,
        fromLocationId: this.newCash.fundingSource.dataObj["locationId"],
        routeId: this.newOrder.routeId.Value ? this.newOrder.routeId.Value : null,
        createdByUserId: this.userDetails.id,
        totalAmount: totalAmount,
        deliveryDate: moment(this.newOrder.vaultDate).format("YYYY-MM-DD"),
        comment: this.newOrder.comment ? this.newOrder.comment : null,
        denominations: denominations,
        account: this.newOrder.account,
        sourceName: this.newOrder.fundingSource.dataObj["sourceName"],
        currencyId: this.newOrder.fundingSource.dataObj["currencyId"]
      };

      this.OrderViewService.createPackableOrder(obj).then(function () {
        _this43._calendar.isSidePanelOpen = false;
        _this43.getAtmOrders();
      }).catch(function (err) {
        if (err && err.data && err.data.errors && err.data.errors.length) {
          if (err.data.errors[0].path === "SHIPMENT.shipment_tracking_id_unique") {
            _this43.Modal.errorModal("error.shipment_tracking_id_unique");
          }
        } else if (err && err.data && err.data.message) {
          _this43.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this43.newOrder.isCreating = false;
        _this43.newCash.isCreatingAtmOrders = false;
      });
    }
  }, {
    key: "removeUsedDenoms",
    value: function removeUsedDenoms() {
      var _this44 = this;

      this.denomModelType.forEach(function (d) {
        var type = void 0,
            remainingDenomModelKey = void 0;
        switch (d) {
          case "single":
            type = 'denominations';
            remainingDenomModelKey = 'remainingDenominations';
            break;
          case "multi":
            type = 'multiDenominations';
            remainingDenomModelKey = 'remainingMultiDenominations';
            break;
          case "atm":
            type = 'atmDenominations';
            remainingDenomModelKey = 'remainingAtmDenominations';
            break;
          default:
            'denominations';
        }
        _this44.removeAlreadyUsedDenom(type, remainingDenomModelKey);
      });
    }
  }, {
    key: "resetRouteId",
    value: function resetRouteId(key) {
      if (!this.model[key]) {
        this.newCash.routeId = null;
      }
    }
  }, {
    key: "editScheduledOrder",
    value: function editScheduledOrder(obj) {
      var _this45 = this;

      this.Modal.editScheduledOrders(obj, function (_ref7) {
        var modal = _ref7.modal,
            $scope = _ref7.$scope,
            combinedRoutes = _ref7.combinedRoutes,
            deletedRecurringStops = _ref7.deletedRecurringStops;

        _this45.OrderViewService.updateRecurrinRoute(combinedRoutes, deletedRecurringStops, obj.toLocationId, obj.branchId).then(function () {
          setTimeout(function () {
            _this45.getAtmOrders();
          }, 100);
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            _this45.Modal.errorModal(err.data.message);
          }
        }).finally(function () {
          $scope.model.isUpdating = false;
          modal.close();
        });
      }, function (_ref8) {
        var modal = _ref8.modal,
            err = _ref8.err;

        if (err && err.data && err.data.message) {
          modal.close();
          _this45.Modal.errorModal(err.data.message);
        } else {
          modal.close();
        }
      });
    }
  }, {
    key: "normalizeDate",
    value: function normalizeDate(dateStr) {
      var suffix = "T00:00:00.000Z";
      if (!dateStr.endsWith(suffix)) {
        return dateStr + suffix;
      }
      return dateStr;
    }
  }, {
    key: "onVaultDateChange",
    value: function onVaultDateChange() {
      // Reset route when date changes
      this.newCash.routeId = null;

      // Refresh routes for the new date
      if (this.newCash.toLocation) {
        this.getLocationNextRoute();
      }

      if (this.newCash.vaultDate && this.newCash.recurringStartDate) {
        if (moment(this.newCash.vaultDate).isAfter(this.newCash.recurringStartDate)) {
          this.newCash.recurringStartDate = moment(this.newCash.vaultDate);
        }
      }

      if (this.newCash.vaultDate) {
        this.minRecurrStartDate = {
          minDate: moment(this.newCash.vaultDate),
          maxDate: moment(this.newCash.recurringStartDate || this.newCash.vaultDate).add(1, "years")
        };
      }
    }
  }, {
    key: "convertScheduledOrderToPackableOrderModal",
    value: function convertScheduledOrderToPackableOrderModal(order) {
      var _this46 = this;

      this.Modal.confirm({
        header: this.$translate.instant("common.confirm_title"),
        message: this.$translate.instant("Are you sure you want to convert this scheduled order to Packable Order?"),
        callback: function callback(_ref9) {
          var modal = _ref9.modal;

          modal.close();
          _this46.convertScheduledOrderToPackableOrder(order, modal);
        },
        negative: function negative(_ref10) {
          var modal = _ref10.modal;

          modal.close();
        },
        buttons: ["common.ok", "common.cancel"],
        type: "primary"
      });
    }
  }, {
    key: "convertScheduledOrderToPackableOrder",
    value: function convertScheduledOrderToPackableOrder(order, modal) {
      var _this47 = this;

      this.isCretePackableOrder = true;
      var branchId = this.getSelectedBranches().toString();
      this.OrderViewService.convertScheduledOrderToPackableOrder(order.fundingSourceId, order.toLocationId, order.serviceDate, this.userDetails.id, branchId).then(function () {
        setTimeout(function () {
          _this47.getAtmOrders();
        }, 100);
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this47.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        if (modal) modal.close();
        _this47.isCretePackableOrder = false;
      });
    }
  }, {
    key: "convertNext7VaultDateScheduledOrderToPackableOrderModal",
    value: function convertNext7VaultDateScheduledOrderToPackableOrderModal(order) {
      var _this48 = this;

      this.Modal.confirm({
        header: this.$translate.instant("common.confirm_title"),
        message: this.$translate.instant("Are you sure you want to convert next 7 vaultDate scheduled orders to Packable Order?"),
        callback: function callback(_ref11) {
          var modal = _ref11.modal;

          modal.close();
          _this48.convertNext7VaultDateScheduledOrderToPackableOrder(order, modal);
        },
        negative: function negative(_ref12) {
          var modal = _ref12.modal;

          modal.close();
        },
        buttons: ["common.ok", "common.cancel"],
        type: "primary"
      });
    }
  }, {
    key: "convertNext7VaultDateScheduledOrderToPackableOrder",
    value: function convertNext7VaultDateScheduledOrderToPackableOrder(order, modal) {
      var _this49 = this;

      this.isCreteAllPackableOrder = true;
      var branchId = this.getSelectedBranches().toString();
      this.OrderViewService.convertScheduledOrderToPackableOrder(null, null, null, this.userDetails.id, branchId).then(function () {
        setTimeout(function () {
          _this49.getAtmOrders();
        }, 100);
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this49.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        if (modal) modal.close();
        _this49.isCreteAllPackableOrder = false;
      });
    }
  }]);
  return MasterCashScheduleController;
}();

exports.default = MasterCashScheduleController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _print_master_cash_schedule = __webpack_require__(1958);

var _print_master_cash_schedule2 = _interopRequireDefault(_print_master_cash_schedule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printMasterCashScheduleModule = angular.module('printMasterCashSchedule', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$stateProvider.state('printMasterCashSchedule', {
		url: '/print-master-cash-schedule',
		component: 'printMasterCashSchedule'
	});
}]).component('printMasterCashSchedule', _print_master_cash_schedule2.default).name;

exports.default = printMasterCashScheduleModule;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_master_cash_schedule = __webpack_require__(2752);

var _print_master_cash_schedule2 = _interopRequireDefault(_print_master_cash_schedule);

var _print_master_cash_schedule3 = __webpack_require__(1959);

var _print_master_cash_schedule4 = _interopRequireDefault(_print_master_cash_schedule3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printMasterCashScheduleComponent = {
  restrict: 'E',
  bindings: {},
  template: _print_master_cash_schedule2.default,
  controller: _print_master_cash_schedule4.default
};

exports.default = printMasterCashScheduleComponent;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printMasterCashScheduleController = function () {
    /*@ngInject*/
    printMasterCashScheduleController.$inject = ["$scope"];
    function printMasterCashScheduleController($scope) {
        (0, _classCallCheck3.default)(this, printMasterCashScheduleController);

        this.$scope = $scope;
        this.model = {
            printData: null
        };
    }

    (0, _createClass3.default)(printMasterCashScheduleController, [{
        key: "$onInit",
        value: function $onInit() {
            if (window.opener && window.opener.w && window.opener.w.printData) {
                this.model.printData = window.opener.w.printData;
                this.print();
            }
        }
    }, {
        key: "print",
        value: function print() {
            setTimeout(function () {
                window.print();
            }, 1500);
        }
    }]);
    return printMasterCashScheduleController;
}();

exports.default = printMasterCashScheduleController;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _on_demand_call = __webpack_require__(1961);

var _on_demand_call2 = _interopRequireDefault(_on_demand_call);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onDemandCallModule = angular.module("onDemandCall", []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise("/onDemandCall");

  $stateProvider.state("onDemandCall", {
    url: "/v2/index.html#/on-demand-service",
    component: "onDemandCall",
    data: {
      requireLogin: true,
      requireACL: "on_demand_call.all"
    }
  });
}]).component("onDemandCall", _on_demand_call2.default).name;

exports.default = onDemandCallModule;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(3032);

var onDemandCallComponent = {
  restrict: "E",
  bindings: {}
};

exports.default = onDemandCallComponent;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _currency_pick_report = __webpack_require__(2753);

var _currency_pick_report2 = _interopRequireDefault(_currency_pick_report);

var _currency_pick_report3 = __webpack_require__(1963);

var _currency_pick_report4 = _interopRequireDefault(_currency_pick_report3);

__webpack_require__(3033);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencyPickReportComponent = {
  template: _currency_pick_report2.default,
  controller: _currency_pick_report4.default,
  bindings: {}
};

exports.default = currencyPickReportComponent;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrencyPickReportController = function () {
  /*@ngInject*/
  CurrencyPickReportController.$inject = ["$state", "$stateParams", "OrderPackingService", "Modal", "$translate", "$rootScope", "User", "SetupService", "BranchFundingSourceService", "$q", "RouteService", "DateUtil", "BranchService", "DataCounter"];
  function CurrencyPickReportController($state, $stateParams, OrderPackingService, Modal, $translate, $rootScope, User, SetupService, BranchFundingSourceService, $q, RouteService, DateUtil, BranchService, DataCounter) {
    (0, _classCallCheck3.default)(this, CurrencyPickReportController);

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.OrderPackingService = OrderPackingService;
    this.Modal = Modal;
    this.$translate = $translate;
    this.$rootScope = $rootScope;
    this.User = User;
    this.SetupService = SetupService;
    this.BranchFundingSourceService = BranchFundingSourceService;
    this.$q = $q;
    this.RouteService = RouteService;
    this.DateUtil = DateUtil;
    this.BranchService = BranchService;
    this.DataCounter = DataCounter;

    this.$rootScope.$broadcast('routeChange', '/app/currency-pick-report');

    this.model = {
      date: new Date(),
      fundingSource: null,
      route: null,
      loading: false
    };
    this.isCoinCheckOut = false;

    this.locationLists = [];
    this.routeList = [];
  }

  (0, _createClass3.default)(CurrencyPickReportController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.title = 'Currency Pick Report';
      this.branchId = this.User.getUser().branchId;
      this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
      this.SetupService.get(this.branchId).then(function (data) {
        _this.model.date = _this.DateUtil.convertToDate(data.currentVaultDate || undefined);

        var dataObj = _this.DataCounter.getData();
        if (dataObj && dataObj.date) {
          _this.model.date = moment(dataObj.date).toDate();
        }

        _this.isCoinCheckOut = data.coinCheckOut;
      }).catch(function (err) {
        _this.error = err.message;
      }).finally(function () {
        _this.getFundingSource('', 0).then(function () {
          var dataObj = _this.DataCounter.getData();
          if (dataObj && dataObj.fundingSourceId) {
            _this.model.fundingSource = _this.locationLists.find(function (item) {
              return String(item.Id) === String(dataObj.fundingSourceId);
            });
            if (_this.model.fundingSource) {
              _this.loadData();
              _this.loadRoutes();
            }
          }
        });
        _this.loadRoutes();
      });
    }
  }, {
    key: 'loadRoutes',
    value: function loadRoutes() {
      var _this2 = this;

      var vaultDate = moment(this.model.date).format('YYYY-MM-DD');
      // this.RouteService.getBranchRoutes(this.branchId, vaultDate)
      this.BranchService.getReleaseRoutes(this.branchId, vaultDate, this.isCoinCheckOut).then(function (data) {
        _this2.routeList = data || [];
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'locationSearchObj',
    value: function locationSearchObj(searchKey) {
      searchKey = searchKey || '';
      return {
        queryJSON: {
          rules: [{ field: 'branchId', condition: '=', data: this.branchId },
          // { field: 'enforceStraps', condition: '=', data: true },
          {
            group: {
              rules: [{ field: 'locationId', condition: 'like', data: '%' + searchKey + '%' }, { field: 'sourceName', condition: 'like', data: '%' + searchKey + '%' }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };
    }
  }, {
    key: 'getFundingSource',
    value: function getFundingSource(searchKey, offset) {
      var _this3 = this;

      var loadLocationData = this.locationSearchObj(searchKey);
      return this.BranchFundingSourceService.all(loadLocationData, offset, _app2.default.defaultPageLimit, this.customerId).then(function (data) {
        var mapped = data.results.map(function (fs) {
          return {
            Key: fs.locationId + " | " + fs.sourceName,
            Value: fs.locationId,
            Id: fs.id
          };
        });

        if (offset === 0) {
          _this3.totalRecords = data.total;
          _this3.locationLists = mapped;
        } else {
          _this3.locationLists = _this3.locationLists.concat(mapped);
        }
        return data;
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this4 = this;

      if (!this.model.fundingSource || !this.model.date) return;
      this.model.loading = true;
      this.OrderPackingService.orderPackingList(this.branchId, this.model.fundingSource.Value).then(function (data) {
        _this4.allShipments = data || [];
        _this4.filterData();
      }).catch(function (err) {
        return console.error('Error loading report:', err);
      }).finally(function () {
        _this4.model.loading = false;
      });
    }
  }, {
    key: 'filterData',
    value: function filterData() {
      var _this5 = this;

      var selectedRouteId = this.model.route;
      var selectedDate = moment(this.model.date).format('YYYY-MM-DD');
      var shipments = (this.allShipments || []).filter(function (item) {
        var routeMatch = !selectedRouteId || selectedRouteId === 'ALL' || item.routeId === selectedRouteId;
        var dateMatch = !selectedDate || item.vaultDate && moment.utc(item.vaultDate).format('YYYY-MM-DD') === selectedDate;
        var coinFlag = !item.denomination.coinFlag;
        return routeMatch && dateMatch && coinFlag;
      });
      var denomsMap = {};
      shipments.forEach(function (item) {
        var d = item.denomination;
        if (!d) return;
        if (!denomsMap[d.id]) {
          denomsMap[d.id] = {
            id: d.id,
            name: d.name,
            faceValue: Number(d.faceValue),
            strapCount: Number(d.strapCount) || 100,
            bundleCount: Number(d.bundleCount) || 10,
            bundleQty: 0,
            bundleAmt: 0,
            strapQty: 0,
            strapAmt: 0,
            looseQty: 0,
            looseAmt: 0,
            total: 0
          };
        }
        denomsMap[d.id].total += Number(item.amount);
      });

      (0, _values2.default)(denomsMap).forEach(function (target) {
        var totalBills = Math.floor(target.total / target.faceValue);
        var billsPerStrap = target.strapCount;
        var strapsPerBundle = target.bundleCount;
        var billsPerBundle = billsPerStrap * strapsPerBundle; // 1000

        var bundleQty = Math.floor(totalBills / billsPerBundle);
        target.bundleQty = bundleQty;
        target.bundleAmt = bundleQty * billsPerBundle * target.faceValue;

        var remainingBills = totalBills - bundleQty * billsPerBundle;

        var strapQty = Math.floor(remainingBills / billsPerStrap);
        target.strapQty = strapQty;
        target.strapAmt = strapQty * billsPerStrap * target.faceValue;

        remainingBills -= strapQty * billsPerStrap;

        target.looseQty = remainingBills;
        target.looseAmt = remainingBills * target.faceValue;
      });

      this.denominations = (0, _values2.default)(denomsMap).sort(function (a, b) {
        return a.faceValue - b.faceValue;
      });

      this.grandTotals = {
        bundleAmt: 0,
        strapAmt: 0,
        looseAmt: 0,
        total: 0
      };
      this.denominations.forEach(function (d) {
        _this5.grandTotals.bundleAmt += d.bundleAmt;
        _this5.grandTotals.strapAmt += d.strapAmt;
        _this5.grandTotals.looseAmt += d.looseAmt;
        _this5.grandTotals.total += d.total;
      });
    }
  }, {
    key: 'formatAmount',
    value: function formatAmount(amount) {
      return amount.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: amount < 1 ? 2 : 0,
        maximumFractionDigits: 2
      });
    }
  }, {
    key: 'print',
    value: function print() {
      var printData = {
        date: moment(this.model.date).format('MM/DD/YYYY'),
        routeId: this.model.route ? this.model.route : null,
        fundingSource: this.model.fundingSource ? this.model.fundingSource.Key : '',
        denominations: this.denominations,
        grandTotals: this.grandTotals
      };
      var path = this.$state.href('printCurrencyPickReport');
      window.w = window.open(path, '_blank');
      window.w.printData = printData;
    }
  }]);
  return CurrencyPickReportController;
}();

exports.default = CurrencyPickReportController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _currency_pick_report = __webpack_require__(1962);

var _currency_pick_report2 = _interopRequireDefault(_currency_pick_report);

var _print_currency_pick_report = __webpack_require__(1965);

var _print_currency_pick_report2 = _interopRequireDefault(_print_currency_pick_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencyPickReportModule = _angular2.default.module('currencyPickReport', []).component('currencyPickReport', _currency_pick_report2.default).component('printCurrencyPickReport', _print_currency_pick_report2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $stateProvider.state('orderPacking.currencyPickReport', {
    url: '/currency-pick-report',
    views: {
      '@app': {
        component: 'currencyPickReport'
      }
    },
    data: {
      requireLogin: true,
      requireACL: 'currency_pick_report.view'
    }
  }).state('printCurrencyPickReport', {
    url: '/currency-pick-report/print',
    component: 'printCurrencyPickReport',
    data: {
      requireLogin: true,
      layout: 'blank'
    }
  });
}]).name;

exports.default = currencyPickReportModule;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_currency_pick_report = __webpack_require__(2754);

var _print_currency_pick_report2 = _interopRequireDefault(_print_currency_pick_report);

var _print_currency_pick_report3 = __webpack_require__(1966);

var _print_currency_pick_report4 = _interopRequireDefault(_print_currency_pick_report3);

__webpack_require__(3034);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printCurrencyPickComponent = {
  restrict: 'E',
  bindings: {},
  template: _print_currency_pick_report2.default,
  controller: _print_currency_pick_report4.default
};

exports.default = printCurrencyPickComponent;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintCurrencyPickReportController = function () {
  PrintCurrencyPickReportController.$inject = ["$timeout"];
  function PrintCurrencyPickReportController($timeout) {
    'ngInject';

    (0, _classCallCheck3.default)(this, PrintCurrencyPickReportController);
    this.$timeout = $timeout;
    this.date = '';
    this.routeId = '';
    this.fundingSource = '';
    this.denominations = [];
  }

  (0, _createClass3.default)(PrintCurrencyPickReportController, [{
    key: '$onInit',
    value: function $onInit() {
      if (window.opener && window.opener.w && window.opener.w.printData) {
        var data = window.opener.w.printData;
        this.date = data.date;
        this.routeId = data.routeId;
        this.fundingSource = data.fundingSource;
        this.denominations = data.denominations || [];
        this.grandTotals = data.grandTotals;
      }
      this.$timeout(function () {
        window.print();
      }, 1000);
    }
  }, {
    key: 'formatAmount',
    value: function formatAmount(amount) {
      return amount.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: amount < 1 ? 2 : 0,
        maximumFractionDigits: 2
      });
    }
  }]);
  return PrintCurrencyPickReportController;
}();

exports.default = PrintCurrencyPickReportController;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _order_packing = __webpack_require__(1968);

var _order_packing2 = _interopRequireDefault(_order_packing);

var _print_barcodes = __webpack_require__(1970);

var _print_barcodes2 = _interopRequireDefault(_print_barcodes);

var _print_packed_orders = __webpack_require__(1973);

var _print_packed_orders2 = _interopRequireDefault(_print_packed_orders);

var _print_packing_slip = __webpack_require__(1976);

var _print_packing_slip2 = _interopRequireDefault(_print_packing_slip);

var _currency_pick_report = __webpack_require__(1964);

var _currency_pick_report2 = _interopRequireDefault(_currency_pick_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var orderPackingModule = angular.module('orderPacking', [_print_barcodes2.default, _print_packed_orders2.default, _print_packing_slip2.default, _currency_pick_report2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/order-packing');

  $stateProvider.state('orderPacking', {
    url: '/order-packing',
    component: 'orderPacking',
    data: {
      requireLogin: true,
      requireACL: 'order_packing.all'
    },
    parent: 'app'
  });
}]).component('orderPacking', _order_packing2.default).name;

exports.default = orderPackingModule;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _order_packing = __webpack_require__(2755);

var _order_packing2 = _interopRequireDefault(_order_packing);

var _order_packing3 = __webpack_require__(1969);

var _order_packing4 = _interopRequireDefault(_order_packing3);

__webpack_require__(3035);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var orderPackingComponent = {
  restrict: 'E',
  template: _order_packing2.default,
  controller: _order_packing4.default
};

exports.default = orderPackingComponent;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderPackingController = function () {

    /*@ngInject*/
    OrderPackingController.$inject = ["$state", "$q", "$window", "Modal", "BranchService", "DataCounter", "$rootScope", "LocationService", "ShipmentService", "User", "UserBranchService", "BranchFundingSourceService", "$location", "OrderPackingService", "LedgerTransactionService", "$translate", "$scope", "SetupService", "DateUtil", "Sound", "HoldService", "Navigation", "AtmResidualDepositService", "UserBranchFundingSourceService", "RouteStopService", "RouteService", "UsersService", "DenominationService", "LocationDeliveryService", "$timeout", "CurrencyService"];
    function OrderPackingController($state, $q, $window, Modal, BranchService, DataCounter, $rootScope, LocationService, ShipmentService, User, UserBranchService, BranchFundingSourceService, $location, OrderPackingService, LedgerTransactionService, $translate, $scope, SetupService, DateUtil, Sound, HoldService, Navigation, AtmResidualDepositService, UserBranchFundingSourceService, RouteStopService, RouteService, UsersService, DenominationService, LocationDeliveryService, $timeout, CurrencyService) {
        var _this = this;

        (0, _classCallCheck3.default)(this, OrderPackingController);

        this.printBarcodes = function () {
            _this.pendingPackShipmentDetails = [];
            var orderShipments = _this.sort(_this.orderShipments, _this.sortColumn, _this.reverseSort);

            orderShipments.map(function (shipmentItem) {
                if (shipmentItem.isSelected) {
                    var totalDenomAmount = 0;
                    if (_this.model.locationId.multiDenomPack && shipmentItem.denominations) {
                        shipmentItem.denominations.forEach(function (d) {
                            return totalDenomAmount += d.amount || 0;
                        });
                    }

                    _this.pendingPackShipmentDetails.push({
                        trackingId: shipmentItem.trackingIdDelivery,
                        toLocationId: shipmentItem.toLocationId,
                        locationInfo: {
                            id: shipmentItem.toLocationId ? shipmentItem.toLocationId : null,
                            name: shipmentItem.toLocationId ? shipmentItem.toLocation.name : null,
                            address: shipmentItem.toLocationId ? shipmentItem.toLocation.address : null,
                            city: shipmentItem.toLocationId ? shipmentItem.toLocation.city : null,
                            state: shipmentItem.toLocationId ? shipmentItem.toLocation.state : null,
                            zip: shipmentItem.toLocationId ? shipmentItem.toLocation.zip : null
                        },
                        orderNo: shipmentItem.orderNo,
                        orderType: shipmentItem.orderType,
                        routeId: shipmentItem.routeId,
                        deliveryDate: shipmentItem.deliveryDate,
                        amount: shipmentItem.amount,
                        denominationId: !_this.model.locationId.multiDenomPack ? shipmentItem.denominationId : null,
                        vaultDate: moment.utc(shipmentItem.vaultDate).format('YYYY-MM-DD'),
                        defRouteSequence: shipmentItem.defRouteSequence,
                        denominations: _this.model.locationId.multiDenomPack ? shipmentItem.denominations : [],
                        shiptypeId: shipmentItem.shiptypeId,
                        symbol: shipmentItem.symbol || _this.currencySymbol,
                        fundingSource: _this.model.locationId ? _this.model.locationId.sourceName : null,
                        totalDenomAmount: totalDenomAmount
                    });
                }
            });

            var obj = {
                shipmentDetails: _this.pendingPackShipmentDetails,
                isPrePackPrint: true,
                multiDenomPack: _this.model.locationId.multiDenomPack,
                currencySymbol: _this.currencySymbol
            };

            var path = _this.$state.href('printBarcodes');
            window.w = window.open(path, '_blank');
            window.w.printData = obj;
        };

        this.$q = $q;
        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.Modal = Modal;
        this.BranchService = BranchService;
        this.LocationService = LocationService;
        this.ShipmentService = ShipmentService;
        this.User = User;
        this.UserBranchService = UserBranchService;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.OrderPackingService = OrderPackingService;
        this.LedgerTransactionService = LedgerTransactionService;
        this.$location = $location;
        this.$translate = $translate;
        this.SetupService = SetupService;
        this.DateUtil = DateUtil;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.DataCounter = DataCounter;
        this.Sound = Sound;
        this.HoldService = HoldService;
        this.Navigation = Navigation;
        this.AtmResidualDepositService = AtmResidualDepositService;
        this.UserBranchFundingSourceService = UserBranchFundingSourceService;
        this.RouteStopService = RouteStopService;
        this.RouteService = RouteService;
        this.UsersService = UsersService;
        this.DenominationService = DenominationService;
        this.CurrencyService = CurrencyService;
        this.currencySymbol = '$';
        this.currencyData = [];
        this.model = {
            loading: false,
            branchId: null,
            locationId: null,
            date: '',
            stats: 'pending',
            ledger: 'regular',
            loggedInUser: this.User.getUser().id,
            branch: this.User.getUser().branchId,
            selectedFundingSource: null,
            gettingLedgerDenomBalance: false,
            pendingFilterDate: null
        };
        this.denominations = {};
        this.denominationsArray = [];
        this.ledgerBalance = {
            totalAmount: 0,
            results: []
        };
        this.denoms = [];
        this.stats = {
            pending: 'pending',
            completed: 'completed',
            onHold: 'onHold'
        };

        this.accounts = {
            regular: 'regular',
            emergency: 'emergency'
        };

        this.ledgers = [{
            lable: "Regular",
            value: "regular"
        }, {
            lable: "Emergency",
            value: "emergency"
        }];
        this.orderSort = {
            id: false,
            total: false,
            route: false,
            toLocation: false
        };
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 1000,
            maxPages: 10
        };

        this.branches = [];
        this.locationLists = [];
        this.orderShipments = [];
        // this.groupedOrders = [];
        this.allOrderShipments = [];
        this.lastScannedLocation = "";
        this.lastScannedDate = "";
        this.allPackedShipments = [];
        this.allPackedChildShipments = [];
        this.packedShipmentBalances = [];
        this.packedShipments = [];
        this.packedChildShipments = [];
        this.reverseSort = true;
        this.sortColumn = "orderNo";
        this.currentPage = 1;
        this.itemsPerPage = 10;
        this.filteredItems = [];
        this.pageLimit = 10;
        this.page = 1;
        this.currentVaultDate = "";
        this.currentDenomBalance = "";
        this.routeList = [];
        this.remainingOrders = "";
        this.clearRouteId = false;
        this.pendingPackData = "";
        this.regularCount = 0;
        this.emergencyCount = 0;
        this.loadOnHoldShipments = true;
        this.shipmentsOnHoldList = [];
        this.$rootScope.$broadcast('routeChange', '/app/order-packing');
        this.userDetails = this.User.getUser();
        this.toggleSelect = true;
        this.completedShipmentDetails = [];
        this.LocationDeliveryService = LocationDeliveryService;
        this.deliveryToShipmentTypes = [];
    }

    // load BranchFundingSource data


    (0, _createClass3.default)(OrderPackingController, [{
        key: 'loadBranchFundingSource',
        value: function loadBranchFundingSource(searchKey) {
            searchKey = searchKey || '';
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        group: {
                            rules: [{
                                field: "id",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "sourceName",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: "AND"
                }
            };
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'mappingBranchFundingSource',
        value: function mappingBranchFundingSource(locations) {
            return locations.map(function (location) {
                return {
                    Key: location.id + " | " + location.sourceName,
                    Value: location.id,
                    locId: location.locationId,
                    currencyId: location.currencyId,
                    multiDenomPack: location.multiDenomPack,
                    multiDenomBillLimit: location.multiDenomBillLimit,
                    sourceName: location.sourceName
                };
            });
        }
    }, {
        key: 'getBranchFundingSource',
        value: function getBranchFundingSource(searchKey, offset) {
            var _this2 = this;

            // const loadLocationDatas = this.loadBranchFundingSource(searchKey);
            var defer = this.$q.defer();
            this.UserBranchFundingSourceService.getBranchFundingSource(this.model.loggedInUser, this.model.branch).then(function (data) {
                if (offset === 0) {
                    _this2.totalRecords = data.total;
                    _this2.locationLists = _this2.mappingBranchFundingSource(data.results);
                    defer.resolve(_this2.locationLists);
                } else {
                    var locations = _this2.mappingBranchFundingSource(data.results);
                    _this2.locationLists = _this2.locationLists.concat(locations);
                }
            });
            defer.promise.then(function () {
                _this2.pendingPackData = _this2.DataCounter.getPendingPackData();
                var redirectData = _this2.DataCounter.getData();

                if (_this2.pendingPackData && _this2.pendingPackData.isRedirected && _this2.locationLists.length) {
                    _this2.model.locationId = _.find(_this2.locationLists, { locId: _this2.pendingPackData.locationId });
                    _this2.model.date = _this2.DateUtil.convertToDate(_this2.pendingPackData.vaultDate);
                    if (_this2.pendingPackData.isEC) _this2.model.ledger = 'emergency';else _this2.model.ledger = 'regular';
                    _this2.getShipmentData(false);
                    if (_this2.$translate.instant(_this2.pendingPackData.status) === 'Hold') {
                        _this2.model.stats = _this2.stats.onHold;
                        _this2.getPendingPackShipmentsOnHold();
                    }
                } else if (redirectData && redirectData.isRedirected && redirectData.locationId && redirectData.orderNo && _this2.locationLists.length) {

                    var fundingSource = _.find(_this2.locationLists, { Value: redirectData.fundingSourceId });
                    if (fundingSource) {
                        _this2.model.locationId = fundingSource;
                    }

                    _this2.model.searchText = redirectData.orderNo;

                    _this2.getShipmentData(false);
                } else if (_this2.locationLists.length === 1) {
                    _this2.model.locationId = _this2.locationLists[0];
                    _this2.getShipmentData(false);
                }

                // Call BFS-dependent methods only after a BFS is selected
                if (_this2.model.locationId) {
                    _this2.loadAllTabData(); // Load data for all tabs to ensure counts are displayed
                }
            }).finally(function () {
                // Only call getAvailableLedgerBalance if a BFS is selected
                if (_this2.model.locationId) {
                    _this2.getAvailableLedgerBalance();
                }
                _this2.resetFilterData();
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this3 = this;

            this.model.branchId = this.User.getUser().branchId;
            var currencyPickACL = this.User.getACL('currency_pick_report');
            this.canViewCurrencyPick = Array.isArray(currencyPickACL) && currencyPickACL.indexOf('view') !== -1;

            this.$q.all([this.SetupService.get(this.model.branchId)]).then(function (data) {
                _this3.model.date = _this3.DateUtil.convertToDate(data[0].currentVaultDate);
                _this3.currentVaultDate = moment(_this3.model.date).format('YYYY-MM-DD');
                _this3.minVaultDate = {
                    minDate: _this3.model.date
                };
                _this3.branchVaultDate = data[0].currentVaultDate;
                _this3.model.printPackLabel = data[0].printPackLabel;
                _this3.model.printPrePack = data[0].printPrePack;
            }).then(function () {
                // Load currency data on init
                _this3.loadCurrencyData();
                _this3.getBranchFundingSource('', 0);
                // Get all denominations on init for filtering when BFS changes
                _this3.getAllDenoms();
                // BFS-dependent calls moved to getBranchFundingSource method
                // this.getPackedShipment();
                // this.getPendingPackShipmentsOnHold();
                // this.getcurBalanceByDenom();
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'getAllDenoms',
        value: function getAllDenoms() {
            var _this4 = this;

            // Get all denominations on init for filtering when BFS changes
            this.DenominationService.all('', 0, 1000).then(function (data) {
                _this4.allDenominations = data.results.map(function (denom) {
                    return (0, _extends3.default)({}, denom, {
                        sortOrder: denom.sortOrder || denom.denominationSortOrder || 0
                    });
                }); // Store all denominations
                _this4.filterDenominationsByBFS(); // Apply initial filtering if BFS is already selected
            }).catch(function (err) {
                console.log(err);
            });
        }

        // Filter denominations based on selected BFS currency

    }, {
        key: 'filterDenominationsByBFS',
        value: function filterDenominationsByBFS() {
            if (!this.model.locationId || !this.allDenominations) {
                this.filteredDenoms = [];
                return;
            }

            var currencyId = this.model.locationId.currencyId;
            if (!currencyId) {
                console.error('No currency ID found for selected BFS');
                this.filteredDenoms = [];
                return;
            }

            // Filter denominations by currency on frontend
            this.filteredDenoms = this.allDenominations.filter(function (denom) {
                return denom.currencyId === currencyId;
            });

            // Set currency symbol
            this.setCurrencySymbol();
        }
    }, {
        key: 'setCurrencySymbol',
        value: function setCurrencySymbol() {
            var _this5 = this;

            if (!this.model.locationId || !this.model.locationId.currencyId) {
                this.currencySymbol = '$';
                return;
            }

            var currencyId = this.model.locationId.currencyId;

            if (Array.isArray(this.currencyData) && this.currencyData.length > 0) {
                var currency = this.currencyData.find(function (c) {
                    return c.id === currencyId;
                });
                this.currencySymbol = currency && currency.symbol ? currency.symbol : '$';
            } else {
                // Load currency data if not already loaded
                this.loadCurrencyData().then(function () {
                    var currency = _this5.currencyData.find(function (c) {
                        return c.id === currencyId;
                    });
                    _this5.currencySymbol = currency && currency.symbol ? currency.symbol : '$';
                });
            }
        }
    }, {
        key: 'loadCurrencyData',
        value: function loadCurrencyData() {
            var _this6 = this;

            if (this.currencyData.length > 0) {
                return this.$q.resolve(this.currencyData);
            }

            return this.SetupService.get(this.model.branchId).then(function (setup) {
                var currencyIds = Array.isArray(setup.availableCurrencyIds) && setup.availableCurrencyIds.length > 0 ? setup.availableCurrencyIds : [setup.currencyId];

                var currencySearchObj = {
                    queryJSON: {
                        rules: currencyIds.map(function (id) {
                            return {
                                field: "id",
                                condition: "=",
                                data: id
                            };
                        }),
                        operator: "OR"
                    }
                };

                return _this6.CurrencyService.all(currencySearchObj, 0, 100);
            }).then(function (data) {
                _this6.currencyData = data.results || [];
                return _this6.currencyData;
            }).catch(function (err) {
                console.log('Error loading currency data:', err);
                _this6.currencyData = [];
                return [];
            });
        }
    }, {
        key: 'getCurrentDenomLedgerBalance',
        value: function getCurrentDenomLedgerBalance(denominationId) {
            var item = this.ledgerBalance.results.find(function (result) {
                return result.denominationId === denominationId;
            });
            return item ? item.balance : 0;
        }
    }, {
        key: 'getDenomLedgerSymbol',
        value: function getDenomLedgerSymbol(denominationId) {
            var item = this.ledgerBalance && this.ledgerBalance.results ? this.ledgerBalance.results.find(function (r) {
                return r.denominationId === denominationId;
            }) : null;
            return item && item.symbol ? item.symbol : this.currencySymbol;
        }
    }, {
        key: 'getPackedAmount',
        value: function getPackedAmount(denominationId) {
            var balance = this.packedShipmentBalances[denominationId] && this.packedShipmentBalances[denominationId].totalAmount;
            return balance || 0;
        }
    }, {
        key: 'getPackedCashTotal',
        value: function getPackedCashTotal() {
            var _this7 = this;

            if (!this.cashLedgerDenoms || !this.packedShipmentBalances) return 0;
            return this.cashLedgerDenoms.reduce(function (sum, d) {
                return sum + _this7.getPackedAmount(d.id);
            }, 0);
        }
    }, {
        key: 'getPackedCoinTotal',
        value: function getPackedCoinTotal() {
            var _this8 = this;

            if (!this.coinLedgerDenoms || !this.packedShipmentBalances) return 0;
            return this.coinLedgerDenoms.reduce(function (sum, d) {
                return sum + _this8.getPackedAmount(d.id);
            }, 0);
        }
    }, {
        key: 'getLedgerBalanceClass',
        value: function getLedgerBalanceClass(denominationId) {
            var balance = this.getCurrentDenomLedgerBalance(denominationId);
            if (balance === 0) return 'bg-yellow';
            return this.denominations[denominationId] ? balance < this.denominations[denominationId].denomAmount ? 'bg-orange' : '' : '';
        }
    }, {
        key: 'getTotalClass',
        value: function getTotalClass() {
            var allZero = this.ledgerBalance.totalAmount;
            return allZero !== 0 ? '' : 'bg-yellow';
        }
    }, {
        key: 'focuseElementById',
        value: function focuseElementById(id) {
            setTimeout(function () {
                document.getElementById(id) ? document.getElementById(id).focus() : null;
            }, 300);
        }
    }, {
        key: 'tabSelection',
        value: function tabSelection(selectedValue) {
            this.model.stats = selectedValue;
            this.model.searchText = null;
            // this.model.route = null;
            this.model.orderType = null;
            this.model.selectedFundingSource = null;
            this.model.customerId = null;
            this.model.pendingFilterDate = null;
            this.getOrderPackCounts(this.allOrderShipments);
            this.getOrderPackedCounts(this.allPackedShipments);
            this.filterOnHoldShipments(this.shipmentsOnHoldList);
            this.loadLedgerData();
            if (this.model.locationId) this.getAvailableLedgerBalance();
            this.loadOrderPackingList();
            this.focuseElementById('searchtext');
        }
    }, {
        key: 'getPackedShipment',
        value: function getPackedShipment() {
            var _this9 = this;

            if (!this.model.locationId) {
                this.allPackedShipments = [];
                this.allPackedChildShipments = [];
                this.loadOrderPackingList();
                return;
            }

            var shipmentSearchObj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    }, {
                        field: 'packedFlag',
                        condition: '=',
                        data: true
                    }, {
                        field: 'pickupFlag',
                        condition: '=',
                        data: false
                    }, {
                        field: 'batchId',
                        condition: '=',
                        data: null
                    }, {
                        field: 'vaultDate',
                        condition: '>=',
                        data: moment(this.model.date).format('YYYY-MM-DD')
                    }, {
                        field: 'deleted',
                        condition: '=',
                        data: false
                    }],
                    operator: "AND"
                },
                order: {
                    fieldName: 'createdAt',
                    keyword: 'DESC'
                }
            };
            var vaultDate = moment(this.model.date).format('YYYY-MM-DD');
            var bfsId = this.model.locationId ? this.model.locationId.Value : null;
            this.OrderPackingService.getPackedShipments(this.model.branchId, vaultDate, 0, 500, bfsId).then(function (data) {
                _this9.model.gettingPackedShipmentList = true;
                // this.pagination.total = data.total;
                // this.pagination.loading = false;
                _this9.allPackedShipments = data.results || [];

                var allShipments = _this9.allPackedShipments || [];

                var buildRowFromShipments = function buildRowFromShipments(shipments) {
                    var first = shipments[0] || {};
                    var shipmentWithNullBagSeal = shipments.find(function (s) {
                        return s.bagSeal === null;
                    }) || first;
                    var denominations = shipments.map(function (order) {
                        if (order.denomination) {
                            return (0, _extends3.default)({}, order.denomination, {
                                amount: order.amount,
                                sortOrder: order.denomination.sortOrder || order.denomination.denominationSortOrder || 0
                            });
                        }
                        return null;
                    }).filter(Boolean);

                    var amount = shipments.reduce(function (sum, obj) {
                        if (obj.bagSeal === null && obj.packableOrderShipmentId === null) {
                            return sum;
                        }
                        return sum + obj.amount;
                    }, 0);

                    return (0, _extends3.default)({
                        orderNo: first.orderNo || 'no-order',
                        packableOrderShipmentId: shipmentWithNullBagSeal && shipmentWithNullBagSeal.packableOrderShipmentId || first && first.packableOrderShipmentId || null,
                        deliveredFlag: shipments.some(function (s) {
                            return !!s.deliveredFlag;
                        }),
                        denominations: denominations,
                        shipments: shipments
                    }, first, {
                        id: shipmentWithNullBagSeal ? shipmentWithNullBagSeal.id : first.id || null,
                        trackingId: shipmentWithNullBagSeal ? shipmentWithNullBagSeal.trackingId : first.trackingId || null,
                        amount: amount,
                        isSelected: false
                    });
                };

                var getNonPackableGroupKey = function getNonPackableGroupKey(shipment) {
                    if (!shipment) return 'no-shipment';
                    if (shipment.bagSeal) return 'bag_' + shipment.bagSeal;
                    if (shipment.trackingId) return 'tracking_' + shipment.trackingId.split('-')[0];
                    return 'id_' + (shipment.id || 'unknown');
                };

                var ordersMap = _.groupBy(allShipments, function (shipment) {
                    return shipment.orderNo || 'no-order';
                });
                var groupedData = [];

                (0, _keys2.default)(ordersMap).forEach(function (orderKey) {
                    var orderShipments = ordersMap[orderKey];
                    var hasPackable = orderShipments.some(function (s) {
                        return s.packableOrderShipmentId !== null && s.packableOrderShipmentId !== undefined;
                    });

                    if (!hasPackable) {
                        // ATM orders: keep multi-denom loads together, but show each single-denom load separately.
                        var isAtmOrder = orderShipments.some(function (s) {
                            var loc = s.toLocation || {};
                            return loc.locationType === 'ATM';
                        });

                        if (isAtmOrder) {
                            var byBagSeal = _.groupBy(orderShipments, function (s) {
                                return s.bagSeal || s.trackingId;
                            });
                            (0, _keys2.default)(byBagSeal).forEach(function (bagKey) {
                                var bagGroup = byBagSeal[bagKey] || [];
                                groupedData.push(buildRowFromShipments(bagGroup));
                            });
                        } else {
                            // Non-ATM: keep existing behaviour (one row per order group)
                            var nonPackableGroups = _.groupBy(orderShipments, getNonPackableGroupKey);
                            (0, _keys2.default)(nonPackableGroups).forEach(function (groupKey) {
                                groupedData.push(buildRowFromShipments(nonPackableGroups[groupKey]));
                            });
                        }
                    } else {
                        var bbShipments = [];
                        var nonBBShipments = [];

                        orderShipments.forEach(function (s) {
                            var denom = s.denomination || {};
                            var isCoin = denom && (denom.coinFlag === true || denom.coinFlag === 1);
                            var coinPackaging = denom ? denom.coinPackaging || null : null;
                            var isBB = isCoin && (coinPackaging === 'BOXED' || coinPackaging === 'BAGGED');

                            if (isBB) {
                                bbShipments.push(s);
                            } else {
                                nonBBShipments.push(s);
                            }
                        });

                        var byBag = _.groupBy(nonBBShipments, function (s) {
                            return s.packableOrderShipmentId;
                        });
                        var bagKeys = (0, _keys2.default)(byBag);

                        var targetBagKey = null;
                        bagKeys.forEach(function (key) {
                            var bagShipments = byBag[key] || [];
                            if (!targetBagKey && bagShipments.length > 1) {
                                targetBagKey = key;
                            }
                        });
                        if (!targetBagKey && bagKeys.length > 0) {
                            targetBagKey = bagKeys[0];
                        }

                        bagKeys.forEach(function (bagKey) {
                            var bagShipments = byBag[bagKey] || [];
                            groupedData.push(buildRowFromShipments(bagShipments));
                        });
                        bbShipments.forEach(function (bb) {
                            groupedData.push(buildRowFromShipments([bb]));
                        });
                    }
                });

                _this9.allPackedShipments = groupedData;
                _this9.allPackedChildShipments = data.childShipments || [];
                // this.packedShipmentBalances = data.packedShipmentBalances || [];
                _this9.getPackedDenomAmount(_this9.allPackedChildShipments);
                // this.loadLedgerData()
                _this9.loadOrderPackingList();
                _this9.getOrderPackedCounts(_this9.allPackedShipments);
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this9.model.gettingPackedShipmentList = false;
            });
        }
    }, {
        key: 'getPackedDenomAmount',
        value: function getPackedDenomAmount(shipments) {
            var _this10 = this;

            this.packedShipmentBalances = {};
            shipments.map(function (shipment) {
                var denominationId = shipment.denomination ? shipment.denomination.id : null;
                var denominationName = shipment.denomination ? shipment.denomination.name : null;

                if (denominationId) {
                    // Group by denomination and sum amounts
                    if (!_this10.packedShipmentBalances[denominationId]) {
                        _this10.packedShipmentBalances[denominationId] = {
                            denominationName: denominationName,
                            totalAmount: 0
                        };
                    }
                    _this10.packedShipmentBalances[denominationId].totalAmount += shipment.amount;
                }
            });
        }
    }, {
        key: 'getOrderPackedCounts',
        value: function getOrderPackedCounts(array) {
            var _this11 = this;

            this.orderPackedRegularCount = 0;
            this.orderPackedEmergencyCount = 0;
            array.filter(function (item) {
                _this11.orderPackedEmergencyCount += item.isEC;
                _this11.orderPackedRegularCount += !item.isEC;
            });
        }
    }, {
        key: 'getOrderPackingList',
        value: function getOrderPackingList(clearRouteId) {
            if (!this.DataCounter.getData()) {
                this.model.searchText = "";
            };
            return this.getShipmentData(clearRouteId);
        }
    }, {
        key: 'getShipmentData',
        value: function getShipmentData(clearRouteId) {
            var _this12 = this;

            this.clearRouteId = clearRouteId;
            if (this.clearRouteId) {
                this.model.route = null;
            }

            if (this.model.locationId && this.model.locationId.Value != this.lastScannedLocation || this.model.date != this.lastScannedDate) {
                this.page = 1;
            }

            if (!this.model.locationId) {
                this.allOrderShipments = [];
                this.orderShipments = [];
            }

            this.model.loading = true;
            if (this.model.date != null && this.model.branchId && this.model.locationId) {
                var date = moment(this.model.date).format('YYYY-MM-DD');
                this.OrderPackingService.orderPackingList(this.model.branchId, this.model.locationId.locId).then(function (data) {
                    if (data.length > 0) {
                        _this12.denominations = {};
                        _this12.denominationsArray = [];
                        _this12.lastScannedLocation = _this12.model.locationId.Value;
                        _this12.lastScannedDate = _this12.model.date;
                        _this12.total = data.length;
                        _this12.allOrderShipments = data;
                        var orderNoGrp = _.groupBy(_this12.allOrderShipments, function (order) {
                            return order.orderNo + '_' + order.sourceType;
                        });
                        var keys = (0, _keys2.default)(orderNoGrp);
                        var groupedData = [];
                        keys.forEach(function (key) {
                            var groupedOrders = orderNoGrp[key];
                            var sourceType = key.split("_")[1];
                            var shouldUseMultiDenomModel = _this12.model.locationId && _this12.model.locationId.multiDenomPack || sourceType === 'PackableOrder';

                            if (shouldUseMultiDenomModel) {
                                groupedData.push((0, _extends3.default)({
                                    orderNo: key.split("_")[0], // Extract original orderNo
                                    sourceType: sourceType, // Extract sourceType
                                    denominations: groupedOrders.map(function (order) {
                                        return (0, _extends3.default)({}, order.denomination, {
                                            amount: order.amount,
                                            coinPackaging: order.coinPackaging || (order.denomination ? order.denomination.coinPackaging : null),
                                            coinFlag: order.coinFlag || (order.denomination ? order.denomination.coinFlag : false),
                                            multiDenomPackable: order.multiDenomPackable || (order.denomination ? order.denomination.multiDenomPackable : false),
                                            sortOrder: order.denomination ? order.denomination.sortOrder || order.denomination.denominationSortOrder || 0 : 0
                                        });
                                    }),
                                    shipments: groupedOrders.map(function (order) {
                                        return (0, _extends3.default)({}, order, {
                                            coinPackaging: order.coinPackaging || (order.denomination ? order.denomination.coinPackaging : null),
                                            debitBulkCoinOnPack: order.debitBulkCoinOnPack
                                        });
                                    })
                                }, groupedOrders[0], {
                                    amount: groupedOrders.reduce(function (sum, obj) {
                                        return sum + obj.amount;
                                    }, 0),
                                    isSelected: false
                                }));
                            } else {
                                groupedOrders.forEach(function (shipment) {
                                    groupedData.push((0, _extends3.default)({}, shipment, {
                                        denominations: [(0, _extends3.default)({}, shipment.denomination, {
                                            amount: shipment.amount,
                                            coinPackaging: shipment.coinPackaging || (shipment.denomination ? shipment.denomination.coinPackaging : null),
                                            coinFlag: shipment.coinFlag || (shipment.denomination ? shipment.denomination.coinFlag : false),
                                            multiDenomPackable: shipment.multiDenomPackable || (shipment.denomination ? shipment.denomination.multiDenomPackable : false),
                                            sortOrder: shipment.denomination ? shipment.denomination.sortOrder || shipment.denomination.denominationSortOrder || 0 : 0
                                        })],
                                        shipments: [(0, _extends3.default)({}, shipment, {
                                            coinPackaging: shipment.coinPackaging || (shipment.denomination ? shipment.denomination.coinPackaging : null),
                                            debitBulkCoinOnPack: shipment.debitBulkCoinOnPack
                                        })],
                                        isSelected: false
                                    }));
                                });
                            }
                        });

                        _this12.allOrderShipments = groupedData;
                        _this12.getRoutes(_this12.allOrderShipments);
                    } else {
                        _this12.total = 0;
                        _this12.orderShipments = [];
                        _this12.allOrderShipments = [];
                        _this12.denominations = {};
                        _this12.denominationsArray = [];
                    }
                }).then(function () {
                    _this12.loadOrderPackingList();
                    if (_this12.model.stats === 'pending') {
                        _this12.focuseElementById('searchtext');
                    }
                    // this.getAvailableLedgerBalance();
                    // if (this.model.ledger) {
                    //     this.getcurBalanceByDenom();
                    // }
                }).then(function () {
                    if (_this12.pendingPackData) {
                        _this12.pendingPackData.isRedirected = false;
                    }
                }).catch(function (err) {
                    _this12.Modal.errorModal('error.' + err.data.message);
                }).finally(function () {
                    _this12.model.loading = false;
                });
            }
        }
    }, {
        key: 'getOrderType',
        value: function getOrderType(obj) {
            if (obj && obj.orderType) {
                var key = 'shipment.order_type_' + obj.orderType;
                var translated = this.$translate.instant(key);
                return translated !== key ? translated : obj.orderType;
            }
            if (obj && obj.shiptypeId) return obj.shiptypeId;
            return '';
        }

        // get balance by denomination from ledger

    }, {
        key: 'orderPack',
        value: function orderPack(orderShipment) {
            var _this13 = this;

            if (this.isLoading) return;
            this.isLoading = true;

            var defer = this.$q.defer();
            var locationDeliveryPromise = _promise2.default.resolve();

            // Only make the LocationDeliveryService call if the locationType is ATM and stopProcess is L and not emergency load
            if (orderShipment.toLocation.stopProcess === 'L' && orderShipment.toLocation.locationType === 'ATM' && orderShipment.isEC === 0 || orderShipment.sourceType === 'PackableOrder') {
                locationDeliveryPromise = this.LocationDeliveryService.getLocationDeliveryDetails(orderShipment.toLocation.id).then(function (results) {
                    _this13.deliveryToShipmentTypes = results.filter(function (shipType) {
                        return shipType.pickupRequired === true;
                    });
                });
            } else {
                this.deliveryToShipmentTypes = [];
            }
            var requestedDenomIds = orderShipment.denominations.map(function (denom) {
                return denom.id;
            });
            // Assuming orderShipment.denominations is now an array
            var denominationPromise = this.OrderPackingService.getcurBalanceByDenom(this.model.branchId, this.model.ledger, requestedDenomIds, this.model.locationId.Value);

            // Use Promise.all to ensure both promises complete before proceeding
            _promise2.default.all([locationDeliveryPromise, denominationPromise]).then(function (_ref) {
                var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                    _ = _ref2[0],
                    data = _ref2[1];

                var responseDenomIds = data.map(function (item) {
                    return item.denominationId;
                });
                var missingDenomIds = requestedDenomIds.filter(function (id) {
                    return !responseDenomIds.includes(id);
                });

                if (missingDenomIds.length > 0) {
                    _this13.isLoading = false;
                    _this13.Sound.PlayErrorBeep("#scanner_beep");
                    _this13.message = _this13.$translate.instant('orderPacking.insufficient_balance', {
                        Denomination: missingDenomIds.join(', ')
                    });
                    return _this13.Modal.errorModal(_this13.message);
                }

                var results = orderShipment.denominations.map(function (denom) {
                    var balanceData = data.find(function (denomBalance) {
                        return denomBalance.denominationId === denom.id;
                    });
                    if (!balanceData) {
                        return {
                            denomination: denom,
                            balance: { balance: 0, denominationId: denom.id, currencyId: null },
                            isDenomAvailable: false
                        };
                    }
                    return {
                        denomination: denom,
                        balance: balanceData,
                        isDenomAvailable: true
                    };
                });

                var validDenominations = [];
                var invalidDenominations = [];
                var availableAmountCanBePacked = _this13.model.locationId.multiDenomBillLimit;
                var multiDenomBillLimitExceed = false;

                // Get debitBulkCoinOnPack flag from first shipment
                var firstShipment = orderShipment.shipments && orderShipment.shipments[0];
                var debitBulkCoinOnPack = firstShipment && (firstShipment.debitBulkCoinOnPack === 1 || firstShipment.debitBulkCoinOnPack === true);

                results.forEach(function (result) {
                    var denomination = result.denomination,
                        balance = result.balance,
                        isDenomAvailable = result.isDenomAvailable;

                    var amountInCents = Math.round(denomination.amount * 100);
                    var faceValueInCents = Math.round(denomination.faceValue * 100);
                    var isValid = amountInCents % faceValueInCents === 0;
                    var isPTZeroAllowed = ["T", "P"].includes(orderShipment.orderType) && Number(denomination.amount) === 0;
                    if (!isDenomAvailable) {
                        invalidDenominations.push(denomination);
                        return;
                    }

                    var inAdequateCash = balance.balance < denomination.amount;

                    // Check if this is a BB coin (BOXED/BAGGED) that should be debited independently
                    var coinPackaging = denomination.coinPackaging;
                    var coinFlag = denomination.coinFlag === 1 || denomination.coinFlag === true;
                    var isBB = debitBulkCoinOnPack && coinPackaging && (coinPackaging === 'BOXED' || coinPackaging === 'BAGGED') && coinFlag;

                    if (isPTZeroAllowed) {
                        validDenominations.push(denomination);
                        return;
                    }

                    if (orderShipment.orderType && !["T", "P", "S"].includes(orderShipment.orderType) || denomination.amount > 0) {
                        // Check balance for all denominations, including BB coins
                        // Even if BB coins are debited independently, we should validate balance upfront
                        if (isBB) {
                            // BB coins debited independently: still chleck balance, but they're always valid if balance is sufficient
                            if (inAdequateCash) {
                                invalidDenominations.push(denomination);
                            } else {
                                validDenominations.push(denomination);
                            }
                        } else if (isValid && denomination.amount >= denomination.faceValue && !inAdequateCash) {
                            var shouldApplyMultiDenomBillLimit = _this13.model.locationId.multiDenomPack && orderShipment.sourceType !== 'PackableOrder';
                            if (shouldApplyMultiDenomBillLimit) {
                                if (denomination.amount <= availableAmountCanBePacked) {
                                    validDenominations.push(denomination);
                                    availableAmountCanBePacked -= denomination.amount;
                                } else {
                                    invalidDenominations.push(denomination);
                                    multiDenomBillLimitExceed = true;
                                }
                            } else {
                                validDenominations.push(denomination);
                            }
                        } else {
                            invalidDenominations.push(denomination);
                        }
                    }
                });

                orderShipment.validDenominations = validDenominations;
                orderShipment.invalidDenominations = invalidDenominations;

                if (invalidDenominations.length > 0) {
                    _this13.Sound.PlayErrorBeep("#scanner_beep");
                    _this13.message = _this13.$translate.instant('orderPacking.invalidDenominations') || null;

                    if (multiDenomBillLimitExceed) {
                        _this13.message = _this13.$translate.instant('orderPacking.multi_denom_bill_limit_exceed');
                    } else if (invalidDenominations.some(function (denom) {
                        return denom.amount < denom.faceValue;
                    })) {
                        _this13.message = _this13.$translate.instant('orderPacking.invalidAmount');
                    } else {
                        _this13.message = _this13.$translate.instant('orderPacking.insufficient_balance', {
                            Denomination: invalidDenominations.map(function (d) {
                                return d.id;
                            }).join(', ')
                        });
                    }

                    _this13.isLoading = false;
                    return _this13.Modal.errorModal(_this13.message);
                } else {
                    return _this13.callOrderPack(orderShipment);
                }
            }).catch(function (err) {
                console.log(err);
                _this13.isLoading = false;
            });
        }
    }, {
        key: 'callOrderPack',
        value: function callOrderPack(orderShipment) {
            var _this14 = this;

            var selectedOrder = null;
            var isMultiDenomModel = this.model.locationId && this.model.locationId.multiDenomPack || orderShipment.sourceType === 'PackableOrder';
            if (isMultiDenomModel) {
                selectedOrder = this.orderShipments.find(function (order) {
                    return order.orderNo === orderShipment.orderNo && order.sourceType === orderShipment.sourceType;
                });
                // include only shipments whose value
                selectedOrder.shipments = orderShipment.shipments.filter(function (shipment) {
                    return orderShipment.validDenominations.some(function (denom) {
                        return denom.id === shipment.denominationId;
                    });
                });
            } else {
                selectedOrder = this.orderShipments.find(function (order) {
                    return order.trackingId === orderShipment.trackingId;
                });
            }
            // get selected shipments
            this.Modal.orderPack(orderShipment, this.model.branchId, this.model.locationId.Value, this.model.ledger, selectedOrder, this.deliveryToShipmentTypes, function (_ref3) {
                var modal = _ref3.modal,
                    data = _ref3.data,
                    status = _ref3.status;

                if (status) {
                    // Refresh all tab data after successful packing
                    _this14.loadAllTabData();
                    _this14.getAvailableLedgerBalance();
                    modal.close();
                    _this14.isLoading = false;
                }
            }, function (_ref4) {
                var modal = _ref4.modal;

                _this14.isLoading = false;
                modal.close();
            }, this.currencySymbol);
        }
    }, {
        key: 'paginator',
        value: function paginator() {
            this.begin = (this.page - 1) * this.itemsPerPage;
            this.end = this.begin + this.itemsPerPage;
            // this.filteredItems = this.orderShipments.slice(this.begin, this.end);
        }
    }, {
        key: 'sortCollection',
        value: function sortCollection(type, column) {
            if (this.sortColumn !== column) {
                this.reverseSort = false;
            } else {
                this.reverseSort = !this.reverseSort;
            }
            this.sortColumn = column;
        }
    }, {
        key: 'getSortExpression',
        value: function getSortExpression() {
            return this.sortColumn === 'orderNo' ? function (item) {
                return Number(item.orderNo) || 0;
            } : this.sortColumn;
        }
        // sort data table by column
        // SortData(column) {
        //     console.log(this.orderShipments);
        //     this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;

        //     this.orderShipments = this.sort(this.orderShipments, column, this.reverseSort)
        //     console.log(this.orderShipments);
        // }

    }, {
        key: 'sort',
        value: function sort(array, column, reverse) {
            var finalArray = array.sort(function (a, b) {
                if (typeof a[column] == 'string') {
                    var val = (a[column] + '').localeCompare(b[column] + '');
                }

                if (a[column] > b[column]) return 1;
                if (a[column] < b[column]) return -1;
                return 0;
            });

            if (reverse) finalArray = finalArray.reverse();
            return finalArray;
        }

        // get class based on sort data

    }, {
        key: 'getSortClass',
        value: function getSortClass(column) {
            if (this.sortColumn == column) {
                return this.reverseSort ? 'arrow-down' : 'arrow-up';
            }
            return '';
        }
    }, {
        key: 'calculateDenomAmount',
        value: function calculateDenomAmount(shipments) {
            var _this15 = this;

            this.totalDenomAmount = 0;
            this.denominations = {};

            shipments.forEach(function (order) {
                if (order.denominations && Array.isArray(order.denominations)) {
                    order.denominations.forEach(function (denom) {
                        var denomId = denom.id;

                        if (!_this15.denominations[denomId]) {
                            _this15.denominations[denomId] = {
                                denominationId: denomId,
                                denomAmount: 0,
                                name: denom.name,
                                faceValue: denom.faceValue,
                                icon: 'assets/images/' + denomId + '.png',
                                symbol: denom.symbol || _this15.currencySymbol,
                                sortOrder: denom.sortOrder || denom.denominationSortOrder || 0
                            };
                        }

                        _this15.denominations[denomId].denomAmount += denom.amount;
                        _this15.totalDenomAmount += denom.amount;
                    });
                }
            });
            this.denominationsArray = (0, _values2.default)(this.denominations);
        }
    }, {
        key: 'getRoutes',
        value: function getRoutes(data) {
            var grouped = _.groupBy(data, 'routeId');
            var routeList = (0, _keys2.default)(grouped);
            this.routeList = routeList;
        }

        // filter order packing list based on selected route and account

    }, {
        key: 'filterOrderPacking',
        value: function filterOrderPacking(data) {
            var _this16 = this;

            var filterOrderPackList = void 0;
            // let list = data.filter((shipment => shipment.bagSeal === null)) || []; // to get only parent shipments
            var list = data || [];
            if (this.model.customerId) {
                list = list.filter(function (item) {
                    return item.customerId == _this16.model.customerId;
                });
            }
            if (this.model.pendingFilterDate) {
                var selectedDate = moment.parseZone(this.model.pendingFilterDate).format('YYYY-MM-DD');
                list = list.filter(function (item) {
                    var itemDate = item.vaultDate || item.deliveryDate;
                    return itemDate && moment(itemDate).utc().format('YYYY-MM-DD') === selectedDate;
                });
            }

            list = list.map(function (item) {
                if (!item.orderType && item.shiptypeId) {
                    item.orderType = item.shiptypeId;
                }
                return item;
            });
            if (this.pendingPackData && this.pendingPackData.isRedirected) {
                if (this.routeList.includes(this.pendingPackData.routeId)) {
                    this.model.route = this.pendingPackData.routeId;
                }
                if (this.pendingPackData.orderNo) this.model.searchText = this.pendingPackData.orderNo;
            }

            if (!this.model.searchText && this.model.ledger == 'regular' && !this.model.route && this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.fundingSourceId == _this16.model.selectedFundingSource && !data.isEC) {
                        return data;
                    }
                });
            } else if (!this.model.searchText && this.model.ledger == 'regular' && !this.model.route && this.model.orderType) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.orderType == _this16.model.orderType && !data.isEC) {
                        return data;
                    }
                });
            } else if (!this.model.searchText && this.model.ledger == 'emergency' && !this.model.route && this.model.orderType) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.orderType == _this16.model.orderType && data.isEC) {
                        return data;
                    }
                });
            } else if (!this.model.searchText && this.model.ledger == 'regular' && this.model.route && this.model.orderType) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.routeId == _this16.model.route && data.orderType == _this16.model.orderType && !data.isEC) {
                        return data;
                    }
                });
            } else if (!this.model.searchText && this.model.ledger == 'emergency' && this.model.route && this.model.orderType) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.routeId == _this16.model.route && data.orderType == _this16.model.orderType && data.isEC) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.ledger == 'regular' && !this.model.route && this.model.orderType) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.orderType == _this16.model.orderType && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0) && !data.isEC) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.ledger == 'emergency' && !this.model.route && this.model.orderType) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.orderType == _this16.model.orderType && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0) && data.isEC) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.ledger == 'regular' && this.model.route && this.model.orderType) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.routeId == _this16.model.route && data.orderType == _this16.model.orderType && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0) && !data.isEC) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.ledger == 'emergency' && this.model.route && this.model.orderType) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.routeId == _this16.model.route && data.orderType == _this16.model.orderType && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0) && data.isEC) {
                        return data;
                    }
                });
            } else if (!this.model.searchText && this.model.ledger == 'emergency' && !this.model.route && this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.fundingSourceId == _this16.model.selectedFundingSource && data.isEC) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.ledger == 'emergency' && !this.model.route && !this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.isEC && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0)) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.ledger == 'emergency' && !this.model.route && this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.isEC && data.fundingSourceId == _this16.model.selectedFundingSource && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0)) {
                        return data;
                    }
                });
            } else if (!this.model.searchText && this.model.ledger == 'emergency' && this.model.route && this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.routeId === _this16.model.route && data.isEC && data.fundingSourceId == _this16.model.selectedFundingSource && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0)) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.ledger == 'emergency' && this.model.route && this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.routeId === _this16.model.route && data.isEC && data.fundingSourceId == _this16.model.selectedFundingSource && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0)) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.ledger == 'regular' && !this.model.route && !this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (!data.isEC && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0)) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.ledger == 'regular' && !this.model.route && this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (!data.isEC && data.fundingSourceId == _this16.model.selectedFundingSource && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0)) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.route && this.model.ledger == 'regular' && !this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.routeId === _this16.model.route && !data.isEC && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0)) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.route && this.model.ledger == 'regular' && this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.routeId === _this16.model.route && !data.isEC && data.fundingSourceId == _this16.model.selectedFundingSource && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0)) {
                        return data;
                    }
                });
            } else if (!this.model.searchText && this.model.route && this.model.ledger == 'regular' && this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.routeId === _this16.model.route && !data.isEC && data.fundingSourceId == _this16.model.selectedFundingSource) {
                        return data;
                    }
                });
            } else if (this.model.searchText && this.model.route && this.model.ledger == 'emergency' && !this.model.selectedFundingSource) {
                filterOrderPackList = list.filter(function (data) {
                    if (data.routeId === _this16.model.route && data.isEC && (data.orderNo.indexOf(_this16.model.searchText) >= 0 || data.toLocationId.indexOf(_this16.model.searchText) >= 0)) {
                        return data;
                    }
                });
            } else if (this.model.route && this.model.ledger == 'emergency') {
                filterOrderPackList = list.filter(function (data) {
                    return data.routeId === _this16.model.route && data.isEC;
                });
            } else if (this.model.route && this.model.ledger == 'regular') {
                filterOrderPackList = list.filter(function (data) {
                    return data.routeId === _this16.model.route && !data.isEC;
                });
            } else if (this.model.ledger && this.model.ledger == 'emergency') {
                filterOrderPackList = list.filter(function (data) {
                    return data.isEC;
                });
            } else if (this.model.ledger && this.model.ledger == 'regular') {
                filterOrderPackList = list.filter(function (data) {
                    return !data.isEC;
                });
            } else {
                filterOrderPackList = list;
            }
            this.calculateDenomAmount(filterOrderPackList);

            if (this.model.stats === 'pending') {
                this.getOrderPackCounts(filterOrderPackList);
            } else if (this.model.stats === 'completed') {
                this.getOrderPackedCounts(filterOrderPackList);
            } else if (this.model.stats === 'onHold') {
                this.filterOnHoldShipments(filterOrderPackList);
            }

            return filterOrderPackList.map(function (item) {
                if (item.orderType && item.orderType === item.shiptypeId) {
                    item.orderType = null;
                }
                return item;
            });;
        }
    }, {
        key: 'loadOrderPackingList',
        value: function loadOrderPackingList() {
            if (this.allOrderShipments.length && this.model.stats === 'pending') {
                this.orderShipments = this.filterOrderPacking(this.allOrderShipments);
                this.reverseSort = false;
                this.getOrderPackCounts(this.orderShipments);
                this.findUniqueOrderNo(this.orderShipments);
                this.sortCollection('P', 'vaultDate');
                this.getSortClass('vaultDate');
                this.getRoutes(this.allOrderShipments);
                this.getOrderTypeList(this.allOrderShipments);
                this.getFundingSource(this.allOrderShipments);
                this.getCustomerList(this.allOrderShipments);
            }

            if (this.allPackedShipments.length && this.model.stats === 'completed') {
                this.packedChildShipments = this.filterOrderPacking(this.allPackedChildShipments);
                this.packedShipments = this.filterOrderPacking(this.allPackedShipments);
                this.reverseSort = true;
                this.sortCollection('P', 'vaultDate');
                this.getSortClass('vaultDate');
                this.getPackedDenomAmount(this.packedChildShipments);
                this.getRoutes(this.allPackedShipments);
                this.getOrderTypeList(this.allPackedShipments);
                this.getFundingSource(this.allPackedShipments);
                this.getCustomerList(this.allPackedShipments);
            } else {
                this.packedShipments = [];
            }

            if (this.shipmentsOnHoldList.length && this.model.stats === 'onHold') {
                var orderNoGrp = _.groupBy(this.shipmentsOnHoldList, function (s) {
                    return s.packableOrderShipmentId ? s.orderNo + '_' + s.packableOrderShipmentId : s.trackingId;
                });
                var keys = (0, _keys2.default)(orderNoGrp);
                var groupedHold = keys.map(function (key) {
                    var group = orderNoGrp[key];
                    var parent = group[0];
                    var denominations = group.map(function (g) {
                        if (g.denominationId) {
                            return {
                                id: g.denominationId,
                                name: g.denominationName,
                                faceValue: g.denominationFaceValue,
                                amount: g.amount,
                                symbol: g.symbol,
                                sortOrder: g.sortOrder || g.denominationSortOrder || 0
                            };
                        }
                    }).filter(Boolean);

                    return (0, _extends3.default)({}, parent, {
                        orderNo: parent.packableOrderShipmentId ? key.split("_")[0] : parent.orderNo,
                        packableOrderShipmentId: parent.packableOrderShipmentId ? key.split("_")[1] : parent.packableOrderShipmentId,
                        // ensure single-denom (non-COD) rows still have denominations array
                        denominations: denominations.length ? denominations : parent.denominationId ? [{
                            id: parent.denominationId,
                            name: parent.denominationName,
                            faceValue: parent.denominationFaceValue,
                            amount: parent.amount,
                            symbol: parent.symbol,
                            sortOrder: parent.sortOrder || parent.denominationSortOrder || 0
                        }] : [],
                        shipments: group,
                        amount: group.reduce(function (sum, x) {
                            return sum + (x.amount || 0);
                        }, 0)
                    });
                });
                this.onHoldShipmentList = this.filterOrderPacking(groupedHold);
                this.reverseSort = true;
                this.sortCollection('H', 'trackingId');
                this.getSortClass('trackingId');
                this.getRoutes(groupedHold);
                this.getOrderTypeList(groupedHold);
                this.getFundingSource(groupedHold);
                this.getCustomerList(groupedHold);
            } else {
                this.onHoldShipmentList = [];
            }

            // if (this.orderShipments.length && this.model.stats === 'pending') {
            //     return this.focuseElementById('pack-btn');
            // }
        }
    }, {
        key: 'findUniqueOrderNo',
        value: function findUniqueOrderNo() {
            var orderNoGrp = _.groupBy(this.orderShipments, function (shipment) {
                return shipment.orderNo + '_' + shipment.sourceType;
            });
            var keys = (0, _keys2.default)(orderNoGrp);
            this.remainingOrders = keys.length;
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            if (this.model.locationId) {
                this.getPackedShipment();
            }
        }

        // orderPack(orderShipment, index) {
        //     this.disablePack(index);
        //     this.Modal.orderPack(orderShipment, this.model.branchId, this.model.locationId.Value, this.model.ledger, ({ modal, data, status }) => {
        //         if (status) {
        //             this.getShipmentData();
        //             this.getPackedShipment();
        //         }
        //         modal.close();
        //     })
        // }

    }, {
        key: 'loadLedgerData',
        value: function loadLedgerData() {
            if (this.allOrderShipments.length && this.model.stats === 'pending') {
                this.orderShipments = this.filterData(this.allOrderShipments);
                this.reverseSort = true;
                this.sortCollection('P', 'orderNo');
                this.getSortClass('orderNo');
            }

            if (this.allPackedShipments.length && this.model.stats === 'completed') {
                this.packedShipments = this.filterData(this.allPackedShipments);
                this.reverseSort = true;
                this.sortCollection('C', 'id');
                this.getSortClass('id');
            }

            // if (this.model.ledger) {
            //     this.getcurBalanceByDenom();
            // }
        }
    }, {
        key: 'filterData',
        value: function filterData(dataArray) {
            var filteredData = void 0;
            if (this.model.ledger && this.model.ledger == 'emergency') {
                filteredData = dataArray.filter(function (item) {
                    return item.isEC;
                });
            } else if (this.model.ledger) {
                filteredData = dataArray.filter(function (item) {
                    return !item.isEC;
                });
            } else {
                filteredData = dataArray;
            }
            this.calculateDenomAmount(filteredData);
            return filteredData;
        }

        // orderHold(orderShipment) {
        //     this.Modal.orderPackHold(orderShipment, ({ modal }) => {
        //     })
        // }

    }, {
        key: 'orderPackingCancel',
        value: function orderPackingCancel(orderShipment) {
            var _this17 = this;

            this.isCancel = true;
            var shipmentId = orderShipment.shipmentId;
            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_delete_title'),
                message: this.$translate.instant('orderPacking.confirm_delete_message') + (' <strong>' + shipmentId + '</strong>?'),
                callback: function callback(_ref5) {
                    var modal = _ref5.modal,
                        $scope = _ref5.$scope;

                    _this17.OrderPackingService.orderPackingCancel(shipmentId, orderShipment.branchId).then(function (data) {
                        modal.close();
                        _this17.getShipmentData();
                    }).catch(function (err) {
                        _this17.Modal.errorModal('error.' + err.data.message);
                    });
                },
                type: 'danger'
            });
            setTimeout(function () {
                _this17.isCancel = false;
            }, 1000);
        }
    }, {
        key: 'getOrderPackCounts',
        value: function getOrderPackCounts(array) {
            var _this18 = this;

            this.emergencyCount = 0;
            this.regularCount = 0;
            array.filter(function (item) {
                _this18.emergencyCount += item.isEC;
                _this18.regularCount += !item.isEC;
            });
        }
    }, {
        key: 'redirectToOrderTab',
        value: function redirectToOrderTab(data) {
            var isInProcess = data.packedFlag && !data.finishedAt;
            var isPending = !data.packedFlag;
            var isCounted = data.finishedAt;
            var fundingSourceId = data.fundingSourceId ? data.fundingSourceId : this.model.locationId.Value;
            this.Navigation.goToOrderHistory(data.orderNo, data.vaultDate, true, isCounted, isInProcess, isPending, null, fundingSourceId);
        }
    }, {
        key: 'softDeleteShipment',
        value: function softDeleteShipment(shipment) {
            var _this19 = this;

            this.Modal.deletedReason(shipment, function (_ref6) {
                var supervisorId = _ref6.supervisorId,
                    reason = _ref6.reason,
                    modal = _ref6.modal;
                if (shipment.sourceType === "PackableOrder") {
                    _this19.OrderPackingService.softDeleteOrder(shipment.orderNo, supervisorId, shipment.branchId).then(function (res) {
                        modal.close();
                        // Refresh all tab data after successful soft delete operation
                        _this19.loadAllTabData();
                    }).catch(function (err) {
                        modal.close();
                        if (err && err.data && err.data.message) {
                            _this19.Modal.errorModal(err.data.message);
                        }
                    });
                } else {
                    _this19.ShipmentService.softDeleteShipment(shipment.shipmentId, shipment.branchId, reason, supervisorId).then(function (res) {
                        modal.close();
                        // Refresh all tab data after successful soft delete operation
                        _this19.loadAllTabData();
                    }).catch(function (err) {
                        modal.close();
                        if (err && err.data && err.data.message) {
                            _this19.Modal.errorModal(err.data.message);
                        }
                    });
                }
            }, function (_ref7) {
                var modal = _ref7.modal;

                modal.close();
            });
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(data) {
            var obj = {
                locationId: data.toLocation.id || data.toLocationId,
                vaultDate: null,
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.locations');
        }
    }, {
        key: 'formatAddress',
        value: function formatAddress(data) {
            this.locationAddress = '';
            if (data.toLocation.address) {
                this.locationAddress = this.locationAddress.concat(data.toLocation.address, ', ');
            }
            if (data.toLocation.city) {
                this.locationAddress = this.locationAddress.concat(data.toLocation.city, ', ');
            }
            if (data.toLocation.state) {
                this.locationAddress = this.locationAddress.concat(data.toLocation.state, ', ');
            }
            if (data.toLocation.zip) {
                this.locationAddress = this.locationAddress.concat(data.toLocation.zip);
            }
            return this.locationAddress;
        }
    }, {
        key: 'convertToCrv',
        value: function convertToCrv(shipment, event) {
            var _this20 = this;

            if (this.loading) return;
            this.loading = true;

            if (event && event.target) {
                event.target.blur();
            }

            var allowSupervisorScan = this.userDetails.hasOwnProperty('supervisor') ? !this.userDetails.supervisor : false;

            this.Modal.convertToCrv(shipment, allowSupervisorScan, true, function (_ref8) {
                var supervisor = _ref8.supervisor,
                    trackingIdResidual = _ref8.trackingIdResidual,
                    modal = _ref8.modal;

                if (trackingIdResidual) {
                    // For CRV we need the load tracking ID:
                    // 1) Prefer explicit loadTrackingId from the completed row (when present)
                    // 2) Otherwise fall back to bagSeal (parent load)
                    // 3) Finally, fall back to this row's trackingId (ATM single‑denom with no parent)
                    var trackingLoad = shipment.loadTrackingId || shipment.bagSeal || shipment.trackingId;

                    // Also send all single‑denom trackingIds that belong to this
                    // packed row (helpful for ATM and multi‑denom orders).
                    var singleDenomTrackingIds = (shipment.shipments || []).filter(function (s) {
                        return s.denominationId || s.denomination && s.denomination.id;
                    }).map(function (s) {
                        return s.trackingId;
                    });

                    _this20.HoldService.convertToCRV(_this20.model.branchId, trackingLoad, trackingIdResidual, allowSupervisorScan ? supervisor : _this20.model.loggedInUser, singleDenomTrackingIds).then(function (data) {
                        modal.close();
                        _this20.loading = false;
                        // Refresh all tab data after successful CRV conversion
                        _this20.loadAllTabData();
                    }).catch(function (err) {
                        modal.close();
                        if (err && err.data && err.data.message) {
                            _this20.loading = false;
                            _this20.Modal.errorModal('error.' + err.data.message);
                        }
                    });
                } else {
                    if (modal) modal.close();
                    _this20.loading = false;
                }
            }, function (_ref9) {
                var modal = _ref9.modal;

                if (modal) modal.close();
                _this20.loading = false;
            });
        }
    }, {
        key: 'convertToCrvPackableOrder',
        value: function convertToCrvPackableOrder(shipment, event) {
            var _this21 = this;

            if (this.isLoading) return;
            this.isLoading = true;

            if (event && event.target) {
                event.target.blur();
            }

            this.Modal.confirm({
                header: 'Confirm CRV Conversion',
                message: 'Are you sure you want to convert this Shipment to CRV?',
                callback: function callback(_ref10) {
                    var modal = _ref10.modal,
                        $scope = _ref10.$scope;

                    modal.close();
                    _this21.UsersService.checkSupervisor(_this21.model.loggedInUser).then(function (userInfo) {
                        _this21.Modal.confirmSupervisor('shipment-hold-convert-CRV', { trackingId: shipment.trackingId }, function (_ref11) {
                            var supModal = _ref11.modal,
                                supId = _ref11.supId;

                            supModal.close();
                            _this21.HoldService.convertToCrvPackableOrder(_this21.model.branch, shipment.trackingId, shipment.packableOrderShipmentId, supId).then(function (data) {
                                _this21.isLoading = false;
                                // Refresh all tab data after successful packable order packing
                                _this21.loadAllTabData();
                            }).catch(function (err) {
                                if (err && err.data && err.data.message) {
                                    _this21.isLoading = false;
                                    _this21.Modal.errorModal('error.' + err.data.message);
                                }
                            });
                        }, function (_ref12) {
                            var supModal = _ref12.modal;

                            supModal.close();
                            _this21.isLoading = false;
                        });
                    }).catch(function (err) {
                        _this21.Modal.errorModal(err.data.message);
                        _this21.isLoading = false;
                    });
                },
                negative: function negative(_ref13) {
                    var modal = _ref13.modal,
                        $scope = _ref13.$scope;

                    modal.close();
                    _this21.isLoading = false;
                }
            }, function (_ref14) {
                var modal = _ref14.modal;

                if (modal) modal.close();
                _this21.isLoading = false;
            });
        }
    }, {
        key: 'lastOrderDetails',
        value: function lastOrderDetails(shipment) {
            this.Modal.lastOrderDetails(shipment, this.model.locationId.Value, function (_ref15) {
                var modal = _ref15.modal;

                modal.close();
            }, function (_ref16) {
                var modal = _ref16.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'orderPackingUndo',
        value: function orderPackingUndo(shipment) {
            var _this22 = this;

            if (this.loading) return;
            this.loading = true;

            this.Modal.undoPackedOrder(shipment, function (_ref17) {
                var modal = _ref17.modal,
                    supervisorId = _ref17.supervisorId,
                    deleteOrder = _ref17.deleteOrder,
                    deletedReason = _ref17.deletedReason,
                    $scope = _ref17.$scope;

                _this22.ShipmentService.orderPackingUndo(_this22.model.branchId, shipment.shipmentId, supervisorId, deletedReason, deleteOrder).then(function () {
                    modal.close();
                    _this22.loading = false;
                    // Refresh all tab data after successful undo operation
                    _this22.loadAllTabData();
                }).catch(function (err) {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        _this22.loading = false;
                        _this22.Modal.errorModal('error.' + err.data.message);
                    }
                });
                // .finally(() => {
                //     $scope.model.loading = false;
                // })
            }, function (_ref18) {
                var modal = _ref18.modal;

                if (modal) modal.close();
                _this22.loading = false;
                // $scope.model.loading = false;
            });
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            if (this.model.locationId) {
                this.getPackedShipment();
                this.getOrderPackingList(false);
            }
        }
    }, {
        key: 'getAvailableLedgerBalance',
        value: function getAvailableLedgerBalance() {
            var _this23 = this;

            this.model.ledgerShortFall = 0;
            this.cashTotalBalance = 0;
            this.coinTotalBalance = 0;
            this.cashLedgerDenoms = [];
            this.coinLedgerDenoms = [];
            this.model.gettingLedgerDenomBalance = true;

            // Pass BFS ID if selected, otherwise pass null for no filtering
            var bfsId = this.model.locationId ? this.model.locationId.Value : null;

            this.AtmResidualDepositService.ledgerDenomBalanceFundingSource(this.model.branchId, this.model.ledger, bfsId).then(function (data) {
                _this23.ledgerBalance = data;
                var availableLedgerBalance = data.totalAmount;
                var cashRemainingToBePack = _this23.totalDenomAmount;
                _this23.model.ledgerShortFall = availableLedgerBalance - cashRemainingToBePack;
                var filteredDenoms = _this23.allDenominations.filter(function (denom) {
                    return data.results.some(function (item) {
                        return item.denominationId === denom.id;
                    });
                });
                _this23.filteredDenoms = filteredDenoms;
                _this23.cashLedgerDenoms = filteredDenoms.filter(function (d) {
                    return d.coinFlag === false;
                });
                _this23.coinLedgerDenoms = filteredDenoms.filter(function (d) {
                    return d.coinFlag === true;
                });
                _this23.cashTotalBalance = _this23.cashLedgerDenoms.reduce(function (sum, d) {
                    return sum + _this23.getCurrentDenomLedgerBalance(d.id);
                }, 0);
                _this23.coinTotalBalance = _this23.coinLedgerDenoms.reduce(function (sum, d) {
                    return sum + _this23.getCurrentDenomLedgerBalance(d.id);
                }, 0);
                // this.totalLedgerBalance = this.cashTotalBalance + this.coinTotalBalance;
                if (_this23.orderShipments.length) {
                    return _this23.focuseElementById('pack-btn');
                }
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this23.Modal.errorModal('error.' + err.data.message);
                }
            }).finally(function () {
                _this23.model.gettingLedgerDenomBalance = false;
            });
        }

        // Load all tab data when BFS selection changes

    }, {
        key: 'loadAllTabData',
        value: function loadAllTabData() {
            var _this24 = this;

            // Load data for all tabs to ensure counts are displayed
            this.getPackedShipment(); // Completed tab
            this.getPendingPackShipmentsOnHold(); // On Hold tab
            this.getOrderPackingList(false); // Pending tab
            this.filterDenominationsByBFS(); // Filter denominations

            // After all data is loaded, calculate counts for all tabs
            // Use timeout to ensure all async operations complete
            this.$timeout(function () {
                _this24.calculateAllTabCounts();
                if (_this24.model.stats === 'pending') {
                    _this24.focuseElementById('searchtext');
                }
            }, 500); // Longer delay to ensure all data is loaded
        }

        // Calculate counts for all tabs regardless of current active tab

    }, {
        key: 'calculateAllTabCounts',
        value: function calculateAllTabCounts() {
            // Calculate counts for Pending tab
            if (this.allOrderShipments && this.allOrderShipments.length > 0 && this.orderShipments.length > 0) {
                this.getOrderPackCounts(this.orderShipments);
            }

            // Calculate counts for Completed tab
            if (this.allPackedShipments && this.allPackedShipments.length > 0 && this.packedShipments.length > 0) {
                this.getOrderPackedCounts(this.packedShipments);
            }

            // Calculate counts for On Hold tab
            if (this.shipmentsOnHoldList && this.shipmentsOnHoldList.length > 0) {
                this.filterOnHoldShipments(this.shipmentsOnHoldList);
            }
        }

        // Refresh BFS-dependent data when BFS selection changes

    }, {
        key: 'refreshCompletedTabData',
        value: function refreshCompletedTabData() {
            // Load all tab data to ensure counts are updated
            this.loadAllTabData();
        }

        // Handle BFS selection change - ensures proper sequencing of operations

    }, {
        key: 'onBFSChange',
        value: function onBFSChange() {
            // Clear existing data to avoid showing stale information
            this.clearExistingData();
            // Set currency symbol based on new BFS
            this.setCurrencySymbol();
            // First get available ledger balance
            this.getAvailableLedgerBalance();
            // Then refresh all tab data
            this.refreshCompletedTabData();
        }

        // Clear existing data when BFS changes to avoid showing stale information

    }, {
        key: 'clearExistingData',
        value: function clearExistingData() {
            // Clear pending data
            this.allOrderShipments = [];
            this.orderShipments = [];
            this.total = 0;

            // Clear completed data
            this.allPackedShipments = [];
            this.allPackedChildShipments = [];

            // Clear on hold data
            this.shipmentsOnHoldList = [];

            // Reset counts
            this.regularCount = 0;
            this.emergencyCount = 0;
            this.orderPackedRegularCount = 0;
            this.orderPackedEmergencyCount = 0;
            this.regularShipmentsOnHoldCount = 0;
            this.emergencyShipmentsOnHoldCount = 0;

            // Clear denominations
            this.denominations = {};
            this.denominationsArray = [];
            this.totalDenomAmount = 0;
            this.model.searchText = "";
            this.model.route = null;
            this.model.pendingFilterDate = null;
        }
    }, {
        key: 'goToBulkCash',
        value: function goToBulkCash() {
            this.$state.go('bulkCashManagement');
        }
    }, {
        key: 'getPendingPackShipmentsOnHold',
        value: function getPendingPackShipmentsOnHold() {
            var _this25 = this;

            if (!this.model.locationId) {
                this.shipmentsOnHoldList = [];
                this.loadOrderPackingList();
                return;
            }

            var date = moment(this.model.date).format('YYYY-MM-DD');
            this.loadOnHoldShipments = true;

            return this.OrderPackingService.getPendingPackShipmentsOnHold(this.model.branchId, date).then(function (data) {
                _this25.shipmentsOnHoldList = data.results;
                _this25.loadOrderPackingList();
                _this25.filterOnHoldShipments(_this25.shipmentsOnHoldList);
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this25.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this25.loadOnHoldShipments = false;
            });
        }
    }, {
        key: 'filterOnHoldShipments',
        value: function filterOnHoldShipments(data) {
            var _this26 = this;

            // Deduplicate COD multi-denom rows: group by unique shipment key
            // For COD rows we have packableOrderShipmentId; otherwise fallback to trackingId
            var grouped = _.groupBy(data, function (s) {
                return s.packableOrderShipmentId ? s.orderNo + '_' + s.packableOrderShipmentId : s.trackingId;
            });
            var uniqueShipments = (0, _keys2.default)(grouped).map(function (k) {
                return grouped[k][0];
            });

            this.regularShipmentsOnHoldCount = 0;
            this.emergencyShipmentsOnHoldCount = 0;
            uniqueShipments.forEach(function (item) {
                _this26.emergencyShipmentsOnHoldCount += item.isEC;
                _this26.regularShipmentsOnHoldCount += !item.isEC;
            });
        }
    }, {
        key: 'goToItemHistory',
        value: function goToItemHistory(trackingId) {
            this.Navigation.goToItemHistory(trackingId, null);
        }
    }, {
        key: 'releaseItem',
        value: function releaseItem(shipment) {
            var _this27 = this;

            if (this.isLoading) return;
            this.isLoading = true;

            this.UsersService.checkSupervisor(this.model.loggedInUser).then(function (userInfo) {
                _this27.Modal.holdReleases(shipment, !userInfo.supervisor, function (_ref19) {
                    var supervisorId = _ref19.supervisorId,
                        comment = _ref19.comment,
                        shipmentAssignedTo = _ref19.shipmentAssignedTo,
                        selectedDate = _ref19.selectedDate,
                        routeInfo = _ref19.routeInfo,
                        modal = _ref19.modal;

                    var hDate = moment(selectedDate).format('YYYY-MM-DD');
                    _this27.ShipmentService.holdRelease(shipment.trackingId, shipment.routeId, shipmentAssignedTo, hDate, userInfo.supervisor ? userInfo.id : supervisorId, comment, shipment.branchId).then(function () {
                        modal.close();
                        _this27.Sound.playSuccessBeep("#success_beep");
                    }).then(function () {
                        if (routeInfo.routeTransfered) {
                            _this27.updateRouteDetail(shipmentAssignedTo, selectedDate);
                        }
                        if (routeInfo.autoOptimize) {
                            _this27.autoOptimizeRouteStop(shipmentAssignedTo, selectedDate);
                        }
                    }).then(function () {
                        // Refresh all tab data after successful release operation
                        _this27.loadAllTabData();
                        _this27.isLoading = false;
                    }).catch(function (err) {
                        modal.close();
                        _this27.isLoading = false;
                        _this27.Sound.PlayErrorBeep("#scanner_beep");
                        if (err && err.data && err.data.message) {
                            return _this27.Modal.errorModal("error." + err.data.message);
                        }
                    });
                }, function (_ref20) {
                    var modal = _ref20.modal;

                    _this27.isLoading = false;
                    if (modal) modal.close();
                });
            }).catch(function (err) {
                _this27.Modal.errorModal(err.data.message);
            });
        }
    }, {
        key: 'autoOptimizeRouteStop',
        value: function autoOptimizeRouteStop(routeId, routeDate) {
            var _this28 = this;

            var formattedDate = moment.utc(routeDate).format('YYYY-MM-DD');
            this.RouteStopService.autoOptimizeRouteStops(formattedDate, routeId).then(function () {
                return void undefined;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    return _this28.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'updateRouteDetail',
        value: function updateRouteDetail(route, date) {
            var _this29 = this;

            var formattedDate = moment.utc(date).format('YYYY-MM-DD');
            this.HoldService.updateRouteDetail(route).then(function () {
                return _this29.RouteService.releaseRoute(route, formattedDate);
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'isAllowedToUnpack',
        value: function isAllowedToUnpack(shipment) {
            var shipmentPackedDate = void 0,
                branchCurrentVaultDate = void 0;

            if (shipment.fundingSourceId && shipment.unpackAnyTime) {
                return true;
            } else if (shipment.fundingSourceId && !shipment.unpackAnyTime) {
                shipmentPackedDate = new Date(shipment.packedDate);
                branchCurrentVaultDate = new Date(this.branchVaultDate);
                return shipmentPackedDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();
            } else {
                return true;
            }
        }
    }, {
        key: 'getFundingSource',
        value: function getFundingSource(data) {
            var grouped = _.groupBy(data, 'fundingSourceId');
            var list = [];

            var keys = (0, _keys2.default)(grouped);
            keys.map(function (key) {
                var location = key.concat(" | ", grouped[key][0].sourceName);
                list.push({ Key: location, Value: key });
            });
            this.fundingSourceList = list;
        }
    }, {
        key: 'getCustomerList',
        value: function getCustomerList(data) {
            var withCustomer = (data || []).filter(function (item) {
                return item.customerId;
            });
            var grouped = _.groupBy(withCustomer, 'customerId');
            var keys = (0, _keys2.default)(grouped);
            this.customerList = keys.map(function (key) {
                var sample = grouped[key][0];
                return {
                    label: sample.customerName ? key + ' | ' + sample.customerName : key,
                    value: key
                };
            });
        }
    }, {
        key: 'exportPackedShipment',
        value: function exportPackedShipment() {
            var _this30 = this;

            var date = moment(this.model.date).format('YYYY-MM-DD');
            var bfsId = this.model.locationId ? this.model.locationId.Value : null;

            this.exportCompletedView = true;
            return this.OrderPackingService.exportPackedShipments(this.model.branchId, date, this.sortColumn, !this.reverseSort, this.model.orderType, this.model.route, this.model.searchText, bfsId, this.currencySymbol, this.model.customerId).then(function () {
                _this30.exportCompletedView = false;
            }).catch(function (err) {
                _this30.exportCompletedView = false;
                if (err && err.data && err.data.message) {
                    return _this30.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'exportPendingPackShipments',
        value: function exportPendingPackShipments() {
            var _this31 = this;

            var date = moment(this.model.date).format('YYYY-MM-DD');

            this.exportPendingPackView = true;
            var pendingFilterDate = this.model.pendingFilterDate ? moment.parseZone(this.model.pendingFilterDate).format('YYYY-MM-DD') : null;
            return this.OrderPackingService.exportPendingPackShipmentsAndOrders(this.model.locationId.locId, this.model.locationId.Key, this.model.branchId, this.model.orderType, this.model.route, this.model.searchText, date, this.currencySymbol, pendingFilterDate, this.model.customerId).then(function () {}).catch(function (err) {
                if (err && err.data && err.data.message) {
                    return _this31.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this31.exportPendingPackView = false;
            });
        }
    }, {
        key: 'toggleAllShipmentSelection',
        value: function toggleAllShipmentSelection() {
            var _this32 = this;

            this.completedShipmentDetails = [];
            this.packedShipments.forEach(function (shipment) {
                shipment.isSelected = _this32.toggleSelect;
            });
            this.toggleSelect = !this.toggleSelect;
        }
    }, {
        key: 'printPackedShipmentLabel',
        value: function printPackedShipmentLabel() {
            var _this33 = this;

            this.completedShipmentDetails = [];
            var packedShipments = this.sort([].concat((0, _toConsumableArray3.default)(this.packedShipments)), this.sortColumn, this.reverseSort);

            packedShipments.forEach(function (shipment) {
                if (shipment.isSelected) {
                    if (_this33.model.locationId && _this33.model.locationId.multiDenomPack) {
                        var firstItem = shipment.shipments && shipment.shipments[0] || shipment;
                        var trackingId = firstItem.loadTrackingId || shipment.loadTrackingId || shipment.bagSeal || shipment.trackingId;
                        if (trackingId) {
                            trackingId = trackingId.split('-')[0];
                        }

                        var totalDenomAmount = 0;
                        var denominations = (shipment.denominations || []).map(function (denom) {
                            totalDenomAmount += denom.amount || 0;
                            return {
                                id: denom.id || denom.denominationId,
                                amount: denom.amount,
                                symbol: denom.symbol || _this33.currencySymbol
                            };
                        });

                        _this33.completedShipmentDetails.push({
                            trackingId: trackingId,
                            isLoadTrackingId: true,
                            locationInfo: {
                                id: shipment.toLocationId || null,
                                name: shipment.toLocation ? shipment.toLocation.name : null,
                                address: shipment.toLocation ? shipment.toLocation.address : null,
                                city: shipment.toLocation ? shipment.toLocation.city : null,
                                state: shipment.toLocation ? shipment.toLocation.state : null,
                                zip: shipment.toLocation ? shipment.toLocation.zip : null
                            },
                            orderNo: shipment.orderNo,
                            orderType: _this33.getOrderType(shipment),
                            routeId: shipment.routeId,
                            deliveryDate: shipment.deliveryDate,
                            amount: totalDenomAmount,
                            vaultDate: moment.utc(shipment.vaultDate).format('MM-DD-YY'),
                            defRouteSequence: shipment.defRouteSequence,
                            fundingSource: _this33.model.locationId ? _this33.model.locationId.sourceName : null,
                            denominations: denominations,
                            totalDenomAmount: totalDenomAmount,
                            symbol: shipment.symbol || _this33.currencySymbol
                        });
                    } else {
                        (shipment.shipments || [shipment]).forEach(function (item) {
                            var isR = !item.trackingId && shipment.residualTrackingId;
                            _this33.completedShipmentDetails.push({
                                trackingId: item.loadTrackingId || item.trackingId || (isR ? shipment.residualTrackingId : shipment.orderNo + '-' + item.denominationId),
                                isLoadTrackingId: !isR,
                                locationInfo: {
                                    id: isR ? shipment.fromLocationId ? shipment.fromLocation.id : null : shipment.toLocationId ? shipment.toLocationId : null,
                                    name: isR ? shipment.fromLocationId ? shipment.fromLocation.name : null : shipment.toLocationId ? shipment.toLocation.name : null,
                                    address: isR ? shipment.fromLocationId ? shipment.fromLocation.address : null : shipment.toLocationId ? shipment.toLocation.address : null,
                                    city: isR ? shipment.fromLocationId ? shipment.fromLocation.city : null : shipment.toLocationId ? shipment.toLocation.city : null,
                                    state: isR ? shipment.fromLocationId ? shipment.fromLocation.state : null : shipment.toLocationId ? shipment.toLocation.state : null,
                                    zip: isR ? shipment.fromLocationId ? shipment.fromLocation.zip : null : shipment.toLocationId ? shipment.toLocation.zip : null
                                },
                                orderNo: shipment.orderNo,
                                orderType: _this33.getOrderType(shipment),
                                routeId: shipment.routeId,
                                deliveryDate: shipment.deliveryDate,
                                pickupDate: isR ? shipment.pickupDate : null,
                                amount: item.amount,
                                denominationId: item.denominationId,
                                vaultDate: moment.utc(shipment.vaultDate).format('MM-DD-YY'),
                                defRouteSequence: shipment.defRouteSequence,
                                fundingSource: _this33.model.locationId ? _this33.model.locationId.sourceName : null
                            });
                        });
                    }
                }
            });

            var obj = {
                shipmentDetails: this.completedShipmentDetails,
                isPrePackPrint: false,
                multiDenomPack: this.model.locationId ? this.model.locationId.multiDenomPack : false,
                currencySymbol: this.currencySymbol
            };

            var path = this.$state.href('printBarcodes');
            window.w = window.open(path, '_blank');
            window.w.printData = obj;
        }
    }, {
        key: 'validateBarcodeBtn',
        value: function validateBarcodeBtn() {
            var disableButton = this.packedShipments.map(function (ps) {
                return !ps.isSelected || 'isEmpty';
            }).indexOf('isEmpty') !== -1;

            return disableButton;
        }
    }, {
        key: 'getOrderTypeList',
        value: function getOrderTypeList(data) {
            var _this34 = this;

            this.orderTypeList = [];
            // Prefer orderType when present; fall back to shiptypeId only when orderType is missing
            var normalized = data.map(function (d) {
                return {
                    orderType: d.orderType || null,
                    shiptypeId: d.shiptypeId || null
                };
            });

            var orderTypes = normalized.filter(function (x) {
                return x.orderType || x.shiptypeId;
            });
            var grouped = _.groupBy(orderTypes, function (x) {
                return x.orderType || x.shiptypeId;
            });
            var keys = (0, _keys2.default)(grouped);
            keys.forEach(function (key) {
                var sample = grouped[key][0];
                var hasOrderType = !!sample.orderType;
                var label = key;

                if (hasOrderType) {
                    // Try translation, fall back to raw value if translation doesn't exist
                    var translationKey = "shipment.order_type_" + key;
                    var translated = _this34.$translate.instant(translationKey);
                    label = translated !== translationKey ? translated : key;
                }

                _this34.orderTypeList.push({
                    label: label,
                    value: key
                });
            });
        }
    }, {
        key: 'toggleAllPrePackShipments',
        value: function toggleAllPrePackShipments() {
            var _this35 = this;

            this.pendingPackShipmentDetails = [];
            this.orderShipments.forEach(function (shipment) {
                shipment.isSelected = _this35.toggleSelect;
            });
            this.orderShipments.forEach(function (order) {
                order.isSelected = _this35.toggleSelect;
            });
            this.toggleSelect = !this.toggleSelect;
        }
    }, {
        key: 'validatePrePackPrintBtn',
        value: function validatePrePackPrintBtn() {
            var disableButton = this.orderShipments.map(function (ps) {
                return !ps.isSelected || 'isEmpty';
            }).indexOf('isEmpty') !== -1;

            return disableButton;
        }
    }, {
        key: 'resetFilterData',
        value: function resetFilterData() {
            this.routeObj = this.DataCounter.setData();
        }
    }, {
        key: 'printPackedOrders',
        value: function printPackedOrders() {
            var date = moment(this.model.date).format('YYYY-MM-DD');
            var bfsId = this.model.locationId ? this.model.locationId.Value : null;
            var obj = {
                branchId: this.model.branchId,
                vaultDate: date,
                sortColumn: this.sortColumn,
                reverseSort: this.reverseSort,
                orderType: this.model.orderType,
                route: this.model.route,
                searchText: this.model.searchText,
                fundingSourceId: bfsId,
                currencySymbol: this.currencySymbol,
                customerId: this.model.customerId
            };
            var path = this.$state.href('printPackedOrders');
            window.w = window.open(path, '_blank');
            window.w.printData = obj;
        }
    }, {
        key: 'goToCurrencyPick',
        value: function goToCurrencyPick() {
            var dateToPass = this.model.pendingFilterDate || this.model.date;
            var obj = {
                fundingSourceId: this.model.locationId ? this.model.locationId.Value : null,
                date: moment(dateToPass).format('YYYY-MM-DD')
            };
            this.DataCounter.setData(obj);
            this.$state.go('orderPacking.currencyPickReport');
        }
    }]);
    return OrderPackingController;
}();

exports.default = OrderPackingController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _print_barcodes = __webpack_require__(1971);

var _print_barcodes2 = _interopRequireDefault(_print_barcodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printBarcodesModule = angular.module('printBarcodes', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider.otherwise('/order-packing');

	$stateProvider.state('printBarcodes', {
		url: '/print-barcodes',
		component: 'printBarcodes',
		data: {
			requireLogin: true,
			requireACL: 'order_packing.all'
		}
	});
}]).component('printBarcodes', _print_barcodes2.default).name;

exports.default = printBarcodesModule;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_barcodes = __webpack_require__(2756);

var _print_barcodes2 = _interopRequireDefault(_print_barcodes);

var _print_barcodes3 = __webpack_require__(1972);

var _print_barcodes4 = _interopRequireDefault(_print_barcodes3);

__webpack_require__(3036);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printBarcodesComponent = {
  restrict: 'E',
  bindings: {},
  template: _print_barcodes2.default,
  controller: _print_barcodes4.default
};

exports.default = printBarcodesComponent;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintBarcodesController = function () {
    /*@ngInject*/
    PrintBarcodesController.$inject = ["$state", "$stateParams", "$translate"];
    function PrintBarcodesController($state, $stateParams, $translate) {
        (0, _classCallCheck3.default)(this, PrintBarcodesController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.model = {
            shipmentDetails: [],
            barcodeOptions: {
                format: 'CODE128', lineColor: '#030303', width: 3, height: 120, displayValue: true,
                font: 'monospace', textAlign: 'center', textPosition: 'bottom', textMargin: 0, fontSize: 20,
                marginTop: 0, marginBottom: 0
                // background: '#ffffff', margin: 0, marginTop: undefined, marginBottom: undefined, marginLeft: undefined,
                // marginRight: undefined, valid: function (valid) { }
            }
        };
    }

    (0, _createClass3.default)(PrintBarcodesController, [{
        key: '$onInit',
        value: function $onInit() {
            var printData = undefined;
            if (window.opener && window.opener.w && window.opener.w.printData) {
                printData = window.opener.w.printData;
                this.model.shipmentDetails = printData.shipmentDetails;
                this.model.isPrePackPrint = printData.isPrePackPrint;
                this.model.barcodeOptions.displayValue = !printData.isPrePackPrint;
                this.model.multiDenomPack = printData.multiDenomPack;
                this.model.depositShipmentLabelPrePack = printData.depositShipmentLabelPrePack;
                this.currencySymbol = printData.currencySymbol || '$';
                setTimeout(function () {
                    window.print();
                }, 2000);
            }
        }
    }, {
        key: 'formatLocationAddress',
        value: function formatLocationAddress(obj) {
            var locationAddress = '';
            if (obj.address) {
                locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.address);
            }
            if (obj.city) {
                locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.city);
            }
            if (obj.state) {
                locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.state);
            }
            if (obj.zip) {
                locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.zip);
            }
            return locationAddress;
        }
    }, {
        key: 'getOrderType',
        value: function getOrderType(obj) {
            if (obj.orderType) {
                var key = 'shipment.order_type_' + obj.orderType;
                var translated = this.$translate.instant(key);
                return translated !== key ? translated : obj.orderType;
            }
            return obj.shiptypeId || '';
        }
    }]);
    return PrintBarcodesController;
}();

exports.default = PrintBarcodesController;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _print_packed_orders = __webpack_require__(1974);

var _print_packed_orders2 = _interopRequireDefault(_print_packed_orders);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printPackedOrdersModule = angular.module('printPackedOrders', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider.otherwise('/order-packing');

	$stateProvider.state('printPackedOrders', {
		url: '/print-packed-orders',
		component: 'printPackedOrders',
		data: {
			requireLogin: true,
			requireACL: 'order_packing.all'
		}
	});
}]).component('printPackedOrders', _print_packed_orders2.default).name;

exports.default = printPackedOrdersModule;

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_packed_orders = __webpack_require__(2757);

var _print_packed_orders2 = _interopRequireDefault(_print_packed_orders);

var _print_packed_orders3 = __webpack_require__(1975);

var _print_packed_orders4 = _interopRequireDefault(_print_packed_orders3);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printPackedOrdersComponent = {
  restrict: 'E',
  bindings: {},
  template: _print_packed_orders2.default,
  controller: _print_packed_orders4.default
};

exports.default = printPackedOrdersComponent;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintPackedOrdersController = function () {
    /*@ngInject*/
    PrintPackedOrdersController.$inject = ["$state", "$stateParams", "$translate", "OrderPackingService"];
    function PrintPackedOrdersController($state, $stateParams, $translate, OrderPackingService) {
        (0, _classCallCheck3.default)(this, PrintPackedOrdersController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.OrderPackingService = OrderPackingService;
        this.model = {
            results: {}
        };
        this.headers = ["Delivery Date", "Order No", "Order Type", "Tracking Id", "Amount", "Denomination", "OrderTotal", "Route", "To Location", "Address"];
        this.accounts = [{
            label: 'Regular',
            value: 'regularShipmentData'
        }, {
            label: 'Emergency',
            value: 'emergencyShipmentData'
        }];
        this.users = [{
            label: 'Pack',
            value: 'pack'
        }, {
            label: 'Pack',
            value: 'pack'
        }, {
            label: 'Receiver',
            value: 'receiver'
        }];
    }

    (0, _createClass3.default)(PrintPackedOrdersController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this = this;

            if (window.opener && window.opener.w && window.opener.w.printData) {
                this.loading = true;
                var data = window.opener.w.printData;
                var branchId = data.branchId,
                    vaultDate = data.vaultDate,
                    sortColumn = data.sortColumn,
                    reverseSort = data.reverseSort,
                    orderType = data.orderType,
                    route = data.route,
                    searchText = data.searchText,
                    fundingSourceId = data.fundingSourceId,
                    currencySymbol = data.currencySymbol,
                    customerId = data.customerId;

                this.vaultDate = vaultDate;
                this.currencySymbol = currencySymbol || '$';

                this.OrderPackingService.printPackedShipments(branchId, vaultDate, sortColumn, !reverseSort, orderType, route, searchText, fundingSourceId, currencySymbol, customerId).then(function (data) {
                    _this.model.results = data.results;
                    if (data.currencySymbol) _this.currencySymbol = data.currencySymbol;
                    _this.regularOrdersTotal = _this.model.results.regularShipmentData.reduce(function (sum, row) {
                        return sum + Number(String(row[4]).replace(/[^0-9.]/g, ""));
                    }, 0);
                    _this.emergencyOrdersTotal = _this.model.results.emergencyShipmentData.reduce(function (sum, row) {
                        return sum + Number(String(row[4]).replace(/[^0-9.]/g, ""));
                    }, 0);
                    setTimeout(function () {
                        window.print();
                    }, 1000);
                }).catch(function (err) {
                    console.log(err);
                }).finally(function () {
                    _this.loading = false;
                });
            }
        }
    }, {
        key: "shouldRemoveBorder",
        value: function shouldRemoveBorder(currentIndex, stat) {
            if (currentIndex === 0) return false;

            var currentRow = this.model.results[stat][currentIndex];
            var prevRow = this.model.results[stat][currentIndex - 1];

            var currentOrder = currentRow[1];
            var prevOrder = prevRow[1];

            var currentTracking = currentRow[3];
            var currentRoute = currentRow[7];

            if (currentOrder === prevOrder && !currentTracking && !currentRoute) {
                return true;
            }

            return false;
        }
    }]);
    return PrintPackedOrdersController;
}();

exports.default = PrintPackedOrdersController;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_packing_slip = __webpack_require__(1977);

var _print_packing_slip2 = _interopRequireDefault(_print_packing_slip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printPackingSlipModule = angular.module('printPackingSlip', []).config(["$stateProvider", function ($stateProvider) {
  "ngInject";

  $stateProvider.state('printPackSlip', {
    url: '/print-pack-slip',
    component: 'printPackSlip',
    data: {
      requireLogin: true,
      requireACL: 'order_packing.all'
    }
  });
}]).component('printPackSlip', _print_packing_slip2.default).name;

exports.default = printPackingSlipModule;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_packing_slip = __webpack_require__(2758);

var _print_packing_slip2 = _interopRequireDefault(_print_packing_slip);

var _print_packing_slip3 = __webpack_require__(1978);

var _print_packing_slip4 = _interopRequireDefault(_print_packing_slip3);

__webpack_require__(3037);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printPackingSlipComponent = {
  bindings: {},
  template: _print_packing_slip2.default,
  controller: _print_packing_slip4.default
};

exports.default = printPackingSlipComponent;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintPackingSlipController = function () {
    /*@ngInject*/
    PrintPackingSlipController.$inject = ["$state", "$stateParams", "$translate", "User", "DateUtil"];
    function PrintPackingSlipController($state, $stateParams, $translate, User, DateUtil) {
        (0, _classCallCheck3.default)(this, PrintPackingSlipController);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.User = User;
        this.DateUtil = DateUtil;
        this.model = {
            shipmentDetails: [],
            shipmentData: []
        };
        this.totalAmount = 0;
        this.parentTrackingIds = [];
    }

    (0, _createClass3.default)(PrintPackingSlipController, [{
        key: '$onInit',
        value: function $onInit() {
            var printData = void 0;
            if (window.opener && window.opener.w && window.opener.w.printData) {
                printData = window.opener.w.printData;

                this.model.shipmentDetails = printData.shipmentDetails || [];
                this.model.shipmentData = printData.shipmentData || [];
                this.routeId = printData.routeId;
                this.locationId = printData.locationId;
                this.orderNo = printData.orderNo;
                this.shipmentPackedDate = printData.shipmentPackedDate;
                this.setParentTrackingId();
                this.calculateTotal();
            }
            setTimeout(function () {
                return window.print();
            }, 1000);
        }
    }, {
        key: 'setParentTrackingId',
        value: function setParentTrackingId() {
            this.parentTrackingIds = this.model.shipmentDetails.filter(function (d) {
                return d.isLoadTrackingId === true;
            });
            this.isSingleParentTracking = this.parentTrackingIds.length === 1;
        }
    }, {
        key: 'calculateTotal',
        value: function calculateTotal() {
            this.totalAmount = this.model.shipmentData.reduce(function (sum, s) {
                return sum + (s.amount || 0);
            }, 0);
        }
    }, {
        key: 'formatAmount',
        value: function formatAmount(amount) {
            return amount.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: amount < 1 ? 2 : 0,
                maximumFractionDigits: 2
            });
        }
    }]);
    return PrintPackingSlipController;
}();

exports.default = PrintPackingSlipController;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pickup_request_management = __webpack_require__(1980);

var _pickup_request_management2 = _interopRequireDefault(_pickup_request_management);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pickupRequestManagementModule = angular.module('pickupRequestManagement', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/pickup-request-management');

  $stateProvider.state('pickupRequestManagement', {
    url: '/v2/index.html#/pickup-request-management',
    component: 'pickupRequestManagement',
    data: {
      requireLogin: true,
      requireACL: 'pickup_request_management.view'
    }
  });
}]).component('pickupRequestManagement', _pickup_request_management2.default).name;

exports.default = pickupRequestManagementModule;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(3038);

var pickupRequestManagementComponent = {
  restrict: "E",
  bindings: {}
};

exports.default = pickupRequestManagementComponent;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preventative_maintenance = __webpack_require__(1982);

var _preventative_maintenance2 = _interopRequireDefault(_preventative_maintenance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var preventativeMaintenanceModule = angular.module("preventativeMaintenance", []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise("/preventativeMaintenance");

  $stateProvider.state("preventativeMaintenance", {
    url: "/v2/index.html#/preventative-maintenance",
    component: "preventativeMaintenance"
  });
}]).component("preventativeMaintenance", _preventative_maintenance2.default).name;

exports.default = preventativeMaintenanceModule;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var preventativeMaintenanceComponent = {
  restrict: "E",
  bindings: {}
};

exports.default = preventativeMaintenanceComponent;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _liability = __webpack_require__(1984);

var _liability2 = _interopRequireDefault(_liability);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var liabilityModule = angular.module('liability', []).component('liability', _liability2.default).name;

exports.default = liabilityModule;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _liability = __webpack_require__(2759);

var _liability2 = _interopRequireDefault(_liability);

var _liability3 = __webpack_require__(1985);

var _liability4 = _interopRequireDefault(_liability3);

__webpack_require__(3039);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportingComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _liability2.default,
    controller: _liability4.default
};

exports.default = reportingComponent;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportingController = function () {
    /*@ngInject*/
    reportingController.$inject = ["$state", "Modal", "$translate", "$q", "RouteService", "User", "DateUtil", "SetupService", "TruckService", "UsersService", "UserBranchService"];
    function reportingController($state, Modal, $translate, $q, RouteService, User, DateUtil, SetupService, TruckService, UsersService, UserBranchService) {
        (0, _classCallCheck3.default)(this, reportingController);

        this.mappingUserData = function (userList) {
            return userList.map(function (user) {
                return {
                    Key: user.id + " | " + user.firstName + ' ' + user.lastName,
                    Value: user.id
                };
            });
        };

        this.$state = $state;
        this.$translate = $translate;
        this.$q = $q;
        this.Modal = Modal;
        this.RouteService = RouteService;
        this.User = User;
        this.DateUtil = DateUtil;
        this.SetupService = SetupService;
        this.TruckService = TruckService;
        this.UsersService = UsersService;
        this.UserBranchService = UserBranchService;
        this.acl = {};
        this.hasACL = {};
        this.id = 'liability';

        this.model = {
            liabilityReportObj: {
                loading: false,
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                }
            },
            routeListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            truckListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            messengerListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null
            },
            branch: User.getUser().branchId,
            loggedInUser: User.getUser().id,
            userBranchList: [],
            selectedBranch: []
        };
    }

    (0, _createClass3.default)(reportingController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            for (var key in this.acl['reporting_' + this.id]) {
                this.hasACL[this.acl['reporting_' + this.id][key]] = true;
            }

            this.model.loading = true;

            this.$q.all([this.SetupService.get(this.model.branch), this.UserBranchService.getUserBranches(this.model.loggedInUser)]).then(function (data) {
                _this.model.setupDetails = data[0];
                _this.model.userBranchList = data[1].results;
                _this.model.vaultDate = _this.DateUtil.convertToDate(_this.model.setupDetails.currentVaultDate);

                _this.model.userBranchList.filter(function (branch) {
                    if (branch.branchId == _this.model.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                });

                _this.setDateRangeOptions('dateRangeOptions');
                _this.model.dateRangeOptions.startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                _this.model.dateRangeOptions.endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');

                _this.getRouteList();
                _this.getTruckData();
                _this.getMessangerData();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this.model.loading = false;
            });
        }
    }, {
        key: 'setDateRangeOptions',
        value: function setDateRangeOptions(modelValue) {
            this.model[modelValue] = {
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        // this.loadData();
                    }
                },
                ranges: {
                    'Previous Week': [moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'), moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')],
                    'Last 60 Days': [moment().subtract('59', 'days').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: 'getStartDate',
        value: function getStartDate() {
            return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate() {
            return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
        }
    }, {
        key: 'getRouteList',
        value: function getRouteList(searchKey, offset) {
            var _this2 = this;

            setTimeout(function () {
                searchKey = searchKey || '';

                var routeSearchObj = {
                    queryJSON: {
                        rules: [{
                            field: 'branchId',
                            condition: 'IN',
                            data: _this2.getSelectedBranches()
                        }, {
                            group: {
                                rules: [{
                                    field: 'id',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                }, {
                                    field: 'name',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                }],
                                operator: 'OR'
                            }
                        }],
                        operator: 'AND'
                    }
                };

                _this2.model.routeListObj.loading = true;
                return _this2.RouteService.all(routeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
                    if (offset == 0 || offset === undefined) {
                        _this2.model.routeListObj.totalRecords = data.total;
                        _this2.model.routeListObj.results = _this2.routeDataMapping(data.results);
                    } else {
                        var routes = _this2.routeDataMapping(data.results);
                        _this2.model.routeListObj.results = _this2.model.routeListObj.results.concat(routes);
                    }
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this2.model.routeListObj.loading = false;
                });
            });
        }
    }, {
        key: 'routeDataMapping',
        value: function routeDataMapping(routes) {
            return routes.map(function (route) {
                return {
                    Key: route.name,
                    Value: route.id
                };
            });
        }
    }, {
        key: 'getTruckData',
        value: function getTruckData(searchKey, offset) {
            var _this3 = this;

            setTimeout(function () {
                searchKey = searchKey || '';

                var searchObj = {
                    queryText: '%' + searchKey + '%',
                    isQuery: false,
                    branch: _this3.getSelectedBranches().toString(),
                    filterByAllBranch: false
                };

                _this3.model.truckListObj.loading = true;
                _this3.TruckService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
                    if (offset == 0 || offset === undefined) {
                        _this3.model.truckListObj.totalRecords = data.total;
                        _this3.model.truckListObj.results = _this3.mappingTruckData(data.results);
                    } else {
                        var truckData = _this3.mappingTruckData(data.results);
                        _this3.model.truckListObj.results = _this3.model.truckListObj.results.concat(truckData);
                    }
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        _this3.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this3.model.truckListObj.loading = false;
                });
            });
        }
    }, {
        key: 'mappingTruckData',
        value: function mappingTruckData(trucks) {
            return trucks.map(function (truck) {
                return {
                    Key: truck.id + " | " + truck.make,
                    Value: truck.id
                };
            });
        }
    }, {
        key: 'userSearchObj',
        value: function userSearchObj(searchKey) {
            searchKey = searchKey || '';
            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: "branchId",
                        condition: "=",
                        data: this.getSelectedBranches()
                    }, {
                        group: {
                            rules: [{
                                field: "id",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "firstName",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "lastName",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: 'AND'
                }
            };

            if (searchKey) {
                searchObj.queryJSON.orderBy = {
                    order: [['id', 'ASC']]
                };
            }
            return searchObj.queryJSON.rules.length ? searchObj : null;
        }
    }, {
        key: 'getMessangerData',
        value: function getMessangerData(searchKey, offset) {
            var _this4 = this;

            setTimeout(function () {
                var searchObj = _this4.userSearchObj(searchKey);

                _this4.model.messengerListObj.loading = true;
                _this4.UsersService.all(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
                    if (offset == 0 || offset === undefined) {
                        _this4.model.messengerListObj.messangerTotalRecord = data.total;
                        _this4.model.messengerListObj.results = _this4.mappingUserData(data.results);
                    } else {
                        var messanger = _this4.mappingUserData(data.results);
                        _this4.model.messengerListObj.results = _this4.model.messengerListObj.results.concat(messanger);
                    }
                }).catch(function (error) {
                    console.error("Error:", error);
                }).finally(function () {
                    _this4.model.messengerListObj.loading = false;
                });
            });
        }
    }, {
        key: 'getSelectedBranches',
        value: function getSelectedBranches() {
            return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map(function (branch) {
                return branch.branchId;
            }) : null;
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            this.model.route = null;
            this.model.truck = null;
            this.model.messenger = null;
        }
    }]);
    return reportingController;
}();

exports.default = reportingController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _on_hold = __webpack_require__(1987);

var _on_hold2 = _interopRequireDefault(_on_hold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onHoldModule = angular.module('onHold', []).component('onHold', _on_hold2.default).name;

exports.default = onHoldModule;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _on_hold = __webpack_require__(2760);

var _on_hold2 = _interopRequireDefault(_on_hold);

var _on_hold3 = __webpack_require__(1988);

var _on_hold4 = _interopRequireDefault(_on_hold3);

__webpack_require__(3040);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OnHoldComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _on_hold2.default,
    controller: _on_hold4.default
};

exports.default = OnHoldComponent;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OnHoldController = function () {
    /*@ngInject*/
    OnHoldController.$inject = ["$state", "Modal", "$translate", "$q", "User", "DateUtil", "SetupService", "UsersService", "UserBranchService", "RouteService", "ReportService", "Navigation", "DataCounter"];
    function OnHoldController($state, Modal, $translate, $q, User, DateUtil, SetupService, UsersService, UserBranchService, RouteService, ReportService, Navigation, DataCounter) {
        (0, _classCallCheck3.default)(this, OnHoldController);

        this.$state = $state;
        this.Modal = Modal;
        this.$translate = $translate;
        this.$q = $q;
        this.User = User;
        this.DateUtil = DateUtil;
        this.SetupService = SetupService;
        this.UsersService = UsersService;
        this.UserBranchService = UserBranchService;
        this.RouteService = RouteService;
        this.ReportService = ReportService;
        this.Navigation = Navigation;
        this.DataCounter = DataCounter;
        this.acl = {};
        this.hasACL = {};
        this.id = "on_hold";

        this.model = {
            onHoldReportObj: {
                loading: false,
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                }
            },
            routeListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            supervisorListObj: {
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                loading: false
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null
            },
            branch: User.getUser().branchId,
            loggedInUser: User.getUser().id,
            userBranchList: [],
            isExporting: false
        };
    }

    (0, _createClass3.default)(OnHoldController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            for (var key in this.acl['reporting_' + this.id]) {
                this.hasACL[this.acl['reporting_' + this.id][key]] = true;
            }

            this.model.loading = true;

            this.$q.all([this.SetupService.get(this.model.branch), this.UserBranchService.getUserBranches(this.model.loggedInUser)]).then(function (data) {
                _this.model.setupDetails = data[0];
                _this.model.userBranchList = data[1].results;
                _this.model.vaultDate = _this.DateUtil.convertToDate(_this.model.setupDetails.currentVaultDate);

                _this.model.userBranchList.filter(function (branch) {
                    if (branch.branchId == _this.model.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                });

                _this.setDateRangeOptions('dateRangeOptions');
                _this.model.dateRangeOptions.startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                _this.model.dateRangeOptions.endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');

                _this.search();
                _this.getRouteList();
                _this.loadSupervisors();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this.model.loading = false;
            });
        }
    }, {
        key: 'setDateRangeOptions',
        value: function setDateRangeOptions(modelValue) {
            var _this2 = this;

            this.model[modelValue] = {
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this2.search();
                        //this.onHoldReport();
                    }
                },
                ranges: {
                    'Previous Week': [moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'), moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')],
                    'Last 60 Days': [moment().subtract('59', 'days').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: 'getStartDate',
        value: function getStartDate() {
            return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate() {
            return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
        }
    }, {
        key: 'getRouteList',
        value: function getRouteList(searchKey, offset) {
            var _this3 = this;

            setTimeout(function () {
                searchKey = searchKey || '';

                var routeSearchObj = {
                    queryJSON: {
                        rules: [{
                            field: 'branchId',
                            condition: 'IN',
                            data: _this3.getSelectedBranches()
                        }, {
                            group: {
                                rules: [{
                                    field: 'id',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                }, {
                                    field: 'name',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                }],
                                operator: 'OR'
                            }
                        }],
                        operator: 'AND'
                    }
                };

                _this3.model.routeListObj.loading = true;
                return _this3.RouteService.all(routeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
                    if (offset == 0 || offset === undefined) {
                        _this3.model.routeListObj.totalRecords = data.total;
                        _this3.model.routeListObj.results = _this3.routeDataMapping(data.results);
                    } else {
                        var routes = _this3.routeDataMapping(data.results);
                        _this3.model.routeListObj.results = _this3.model.routeListObj.results.concat(routes);
                    }
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this3.model.routeListObj.loading = false;
                });
            });
        }
    }, {
        key: 'routeDataMapping',
        value: function routeDataMapping(routes) {
            return routes.map(function (route) {
                return {
                    Key: route.name,
                    Value: route.id
                };
            });
        }
    }, {
        key: 'getSelectedBranches',
        value: function getSelectedBranches() {
            return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map(function (branch) {
                return branch.branchId;
            }) : null;
        }
    }, {
        key: 'loadSupervisors',
        value: function loadSupervisors(searchKey, offset) {
            var _this4 = this;

            setTimeout(function () {
                _this4.model.supervisorListObj.loading = true;
                _this4.ReportService.userList(searchKey, _this4.getSelectedBranches(), offset, _this4.model.supervisorListObj.pagination.pageLimit).then(function (data) {
                    if (offset == 0 || offset === undefined) {
                        _this4.model.supervisorListObj.totalRecords = data.totalRecords;
                        _this4.model.supervisorListObj.results = _this4.mappingUserData(data.results);
                    } else {
                        var supervisorList = _this4.mappingUserData(data.results);
                        _this4.model.supervisorListObj.results = _this4.model.supervisorListObj.results.concat(supervisorList);
                    }
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this4.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this4.model.supervisorListObj.loading = false;
                });
            });
        }
    }, {
        key: 'mappingUserData',
        value: function mappingUserData(users) {
            return users.map(function (user) {
                return {
                    Key: user.userId + ' | ' + user.userName,
                    Value: user.userId
                };
            });
        }
    }, {
        key: 'onHoldReport',
        value: function onHoldReport() {
            var _this5 = this;

            setTimeout(function () {
                var startDate = _this5.getStartDate();
                var endDate = _this5.getEndDate();
                var routeId = _this5.model.routeId ? _this5.model.routeId.Value : null;
                var branches = _this5.model.selectedBranch.map(function (branchObj) {
                    return branchObj.branchId;
                });
                var supvHoldId = _this5.model.supvHoldId ? _this5.model.supvHoldId.Value : null;

                _this5.model.onHoldReportObj.loading = true;
                _this5.ReportService.onHoldReport(_this5.model.searchText, startDate, endDate, routeId, branches, supvHoldId, (_this5.model.onHoldReportObj.pagination.page - 1) * _this5.model.onHoldReportObj.pagination.pageLimit, _this5.model.onHoldReportObj.pagination.pageLimit).then(function (data) {
                    _this5.model.onHoldReportObj.pagination.total = data.totalRecords;
                    _this5.model.onHoldReportObj.results = data.results;
                    _this5.model.onHoldReportObj.totalRecords = data.totalRecords;
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this5.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this5.model.onHoldReportObj.loading = false;
                });
            });
        }
    }, {
        key: 'downloadFile',
        value: function downloadFile(reportPrefix, reportData) {
            var fileName = reportPrefix.concat('.csv');
            var a = document.createElement("a");
            document.body.appendChild(a);
            var file = new Blob([reportData], { type: 'application/csv' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }
    }, {
        key: 'exportToCSV',
        value: function exportToCSV() {
            var _this6 = this;

            var startDate = this.getStartDate();
            var endDate = this.getEndDate();
            var routeId = this.model.routeId ? this.model.routeId.Value : null;
            var branches = this.model.selectedBranch.map(function (branchObj) {
                return branchObj.branchId;
            });

            var reportPrefix = 'HOLD_Reports_(' + moment(startDate).format('YYYY-MM-DD') + '_' + moment(endDate).format('YYYY-MM-DD') + ')';

            this.model.isExporting = true;
            this.ReportService.exportHoldReport(this.model.searchText, startDate, endDate, routeId, branches).then(function (data) {
                _this6.downloadFile(reportPrefix, data.reportData);
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this6.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this6.model.isExporting = false;
            });
        }
    }, {
        key: 'goToItemHistory',
        value: function goToItemHistory(trackingId) {
            this.Navigation.goToItemHistory(trackingId, null);
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.onHoldReport();
        }
    }, {
        key: 'search',
        value: function search() {
            this.model.onHoldReportObj.pagination.page = 1;
            this.onHoldReport();
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            this.model.routeId = null;
            this.model.supvHoldId = null;
            this.model.onHoldReportObj.pagination.page = 1;
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(locationId) {
            var obj = {
                locationId: locationId,
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.locations');
        }
    }]);
    return OnHoldController;
}();

exports.default = OnHoldController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_performance = __webpack_require__(1990);

var _route_performance2 = _interopRequireDefault(_route_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routePerformanceModule = angular.module('routePerformance', []).component('routePerformance', _route_performance2.default).name;

exports.default = routePerformanceModule;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_performance = __webpack_require__(2761);

var _route_performance2 = _interopRequireDefault(_route_performance);

var _route_performance3 = __webpack_require__(1991);

var _route_performance4 = _interopRequireDefault(_route_performance3);

__webpack_require__(3041);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routePerformanceComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _route_performance2.default,
    controller: _route_performance4.default
};

exports.default = routePerformanceComponent;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoutePerformanceController = function () {
    /*@ngInject*/
    RoutePerformanceController.$inject = ["$state"];
    function RoutePerformanceController($state) {
        (0, _classCallCheck3.default)(this, RoutePerformanceController);

        this.$state = $state;
        this.id = "route_performance";
        this.acl = {};
        this.hasACL = {};
    }

    (0, _createClass3.default)(RoutePerformanceController, [{
        key: '$onInit',
        value: function $onInit() {
            for (var key in this.acl['reporting_' + this.id]) {
                this.hasACL[this.acl['reporting_' + this.id][key]] = true;
            }
        }
    }]);
    return RoutePerformanceController;
}();

exports.default = RoutePerformanceController;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reporting = __webpack_require__(1993);

var _reporting2 = _interopRequireDefault(_reporting);

var _liability = __webpack_require__(1983);

var _liability2 = _interopRequireDefault(_liability);

var _route_performance = __webpack_require__(1989);

var _route_performance2 = _interopRequireDefault(_route_performance);

var _on_hold = __webpack_require__(1986);

var _on_hold2 = _interopRequireDefault(_on_hold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportingModule = angular.module('reporting', [_liability2.default, _route_performance2.default, _on_hold2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('liability', {
        url: '/liability',
        component: 'liability',
        parent: 'reporting',
        data: {
            requireLogin: true,
            requireACL: 'reporting_liability.view'
        },
        resolve: {
            hasACL: function hasACL() {
                return {};
            }
        }
    }).state('route_performance', {
        url: '/route-performance',
        component: 'routePerformance',
        parent: 'reporting',
        data: {
            requireLogin: true,
            requireACL: 'reporting_route_performance.view'
        },
        resolve: {
            hasACL: function hasACL() {
                return {};
            }
        }
    }).state('on_hold', {
        url: '/on-hold',
        component: 'onHold',
        parent: 'reporting',
        data: {
            requireLogin: true,
            requireACL: 'reporting_on_hold.view'
        },
        resolve: {
            hasACL: function hasACL() {
                return {};
            }
        }
    });
}]).component('reporting', _reporting2.default).name;

exports.default = reportingModule;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reporting = __webpack_require__(2762);

var _reporting2 = _interopRequireDefault(_reporting);

var _reporting3 = __webpack_require__(1994);

var _reporting4 = _interopRequireDefault(_reporting3);

__webpack_require__(3042);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportingComponent = {
    restrict: 'E',
    bindings: {},
    template: _reporting2.default,
    controller: _reporting4.default
};

exports.default = reportingComponent;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportingController = function () {
    /*@ngInject*/
    ReportingController.$inject = ["Auth", "$state", "User", "UserService", "$translate", "$location", "Modal", "DataCounter", "$q", "$rootScope"];
    function ReportingController(Auth, $state, User, UserService, $translate, $location, Modal, DataCounter, $q, $rootScope) {
        (0, _classCallCheck3.default)(this, ReportingController);


        this.$state = $state;

        this.$translate = $translate;
        this.Auth = Auth;
        this.$state = $state;
        this.User = User;
        this.$q = $q;
        this.$location = $location;
        this.Modal = Modal;
        this.DataCounter = DataCounter;
        this.$rootScope = $rootScope;
        this.currentBranch = User.getUser().branchId;

        this.tabConfig = {
            'reporting_liability': {
                title: 'Liability',
                state: 'liability'
            },
            'reporting_route_performance': {
                title: 'Route Performance',
                state: 'route_performance'
            },
            'reporting_on_hold': {
                title: 'On Hold',
                state: 'on_hold'
            }
        };

        this.acl = User.getACL('_reporting');
        this.tabs = [];
    }

    (0, _createClass3.default)(ReportingController, [{
        key: 'getStateDiff',
        value: function getStateDiff(array) {
            var diff = [];
            var index = 0;
            for (var i = 0; i < array.length; i++) {
                var key = array[i];
                if (!(key in this.acl)) {
                    diff[index++] = array[i];
                }
            }
            return diff;
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var toDeregister = this.getStateDiff((0, _keys2.default)(this.tabConfig));
            for (var i = 0; i < toDeregister.length; i++) {
                if (this.$state.get(toDeregister[i])) {
                    this.$state.router.stateRegistry.deregister(toDeregister[i]);
                }
            }

            _.forEach((0, _keys2.default)(this.tabConfig), function (key, i) {
                if (_this.acl[key] && _this.acl[key].indexOf('view') >= 0) {
                    var tabConfig = _this.tabConfig[key];
                    if (tabConfig) {
                        var obj = (0, _assign2.default)(tabConfig, { key: key });
                        _this.tabs.push(obj);
                    }
                }
            });
            if (this.$state.current.name == 'reporting' && this.tabs.length) {
                this.$state.go(this.tabs[0].state);
            }

            this.$rootScope.$broadcast('routeChange', null);
        }
    }, {
        key: 'hasAcl',
        value: function hasAcl(key) {
            if (this.acl[key] && this.acl[key].indexOf('view') >= 0) {
                return true;
            } else {
                return false;
            }
        }
    }]);
    return ReportingController;
}();

exports.default = ReportingController;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reset_atm_codeAll = __webpack_require__(1996);

var _reset_atm_codeAll2 = _interopRequireDefault(_reset_atm_codeAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resetAtmCodeAllModule = angular.module('resetAtmCodeAll', []).component('resetAtmCodeAll', _reset_atm_codeAll2.default).name;

exports.default = resetAtmCodeAllModule;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reset_atm_codeAll = __webpack_require__(2763);

var _reset_atm_codeAll2 = _interopRequireDefault(_reset_atm_codeAll);

var _reset_atm_codeAll3 = __webpack_require__(1997);

var _reset_atm_codeAll4 = _interopRequireDefault(_reset_atm_codeAll3);

__webpack_require__(3043);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resetAtmCodeAllComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _reset_atm_codeAll2.default,
  controller: _reset_atm_codeAll4.default
};

exports.default = resetAtmCodeAllComponent;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetAtmCodeAllController = function () {
    /*@ngInject*/
    ResetAtmCodeAllController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "$stateParams", "$location", "SetupService", "RouteService", "$q", "DateUtil", "ResetAtmCodeService"];
    function ResetAtmCodeAllController(Auth, $state, User, Modal, $translate, $stateParams, $location, SetupService, RouteService, $q, DateUtil, ResetAtmCodeService) {
        (0, _classCallCheck3.default)(this, ResetAtmCodeAllController);

        this.loading = true;
        this.$location = $location;
        this.$translate = $translate;
        this.Modal = Modal;
        this.SetupService = SetupService;
        this.RouteService = RouteService;
        this.$q = $q;
        this.DateUtil = DateUtil;
        this.User = User;
        this.ResetAtmCodeService = ResetAtmCodeService;

        this.model = {
            vaultDate: '',
            allRoutes: [],
            branch: this.User.getUser().branchId,
            allAtmCodes: []
        };

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.routeList = [];
        this.totalRecord = 0;
        this.keys = "ATMCodes:*";
    }

    (0, _createClass3.default)(ResetAtmCodeAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$q.all([this.SetupService.get(this.model.branch), this.loadRoutes('', 0)
            // this.getAtmCodeFromRedis()
            ]).then(function (data) {
                var date = _this.DateUtil.convertToDate(data[0].currentVaultDate);
                _this.model.date = date;
                _this.vaultDate = moment(_this.model.date).format('YYYY-MM-DD');
                _this.minVaultDate = {
                    minDate: _this.valutDate
                };
            });
        }
    }, {
        key: 'loadRoutes',
        value: function loadRoutes(searchKey, offset) {
            var _this2 = this;

            searchKey = searchKey || '';

            var searchObj = {
                queryJSON: {
                    rules: [{
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branch
                    }, {
                        group: {
                            rules: [{
                                field: "id",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }, {
                                field: "name",
                                condition: "like",
                                data: "%" + searchKey + "%"
                            }],
                            operator: "OR"
                        }
                    }],
                    operator: 'AND'
                }
            };

            this.RouteService.all(searchObj, offset, this.pagination.pageLimit).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this2.totalRecord = data.total;
                    _this2.routeList = _this2.mapData(data.results);
                } else {
                    var routes = _this2.mapData(data.results);
                    _this2.routeList = _this2.routeList.concat(routes);
                }
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'mapData',
        value: function mapData(routes) {
            return routes.map(function (route) {
                return {
                    Key: route.id + ' | ' + route.name,
                    Value: route.id
                };
            });
        }
    }, {
        key: 'getAtmCodeFromRedis',
        value: function getAtmCodeFromRedis() {
            var _this3 = this;

            if (!this.model.route) {
                return this.model.allAtmCodes = [];
            }

            this.model.allAtmCodes = [];
            this.model.loading = true;
            var prefix = '',
                key = '',
                formattedDate = '';

            // if (this.model.route) {
            prefix = 'ATMCodes:';
            key = prefix.concat(this.model.route.Value, ':*');
            formattedDate = moment(this.model.date).format('MM-DD-YYYY');
            // }
            // else {
            //     key = this.keys;
            // }

            this.ResetAtmCodeService.getAllKeys(key, formattedDate).then(function (res) {
                _this3.model.allAtmCodes = res.results;
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this3.model.loading = false;
            });
        }
    }, {
        key: 'confirmDelete',
        value: function confirmDelete(key) {
            var _this4 = this;

            if (this.allowOnce) return;
            this.allowOnce = true;
            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_delete_title'),
                message: this.$translate.instant('resetAtmCode.delete_message'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    _this4.allowOnce = true;
                    _this4.delete(key, _this4.allowOnce);
                    modal.close();
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    _this4.allowOnce = false;
                    modal.close();
                },
                type: 'danger'
            });
        }
    }, {
        key: 'delete',
        value: function _delete(key, allowOnce) {
            var _this5 = this;

            this.allowOnce = allowOnce;
            this.model.isDeleting = true;
            this.ResetAtmCodeService.deleteAtmCode(key, this.model.branch).then(function (res) {
                setTimeout(function () {
                    _this5.getAtmCodeFromRedis(); // reload data after delete
                }, 1000);
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this5.allowOnce = false;
                _this5.model.isDeleting = false;
            });
        }
    }, {
        key: 'getAtmCode',
        value: function getAtmCode(cacheKey) {
            this.Modal.atmCodesInfoModal(cacheKey, function (_ref3) {
                var modal = _ref3.modal;

                modal.close();
            }, function (_ref4) {
                var modal = _ref4.modal;

                modal.close();
            });
        }
    }]);
    return ResetAtmCodeAllController;
}();

exports.default = ResetAtmCodeAllController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reset_atm_code = __webpack_require__(1999);

var _reset_atm_code2 = _interopRequireDefault(_reset_atm_code);

var _all = __webpack_require__(1995);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resetAtmCodeModule = angular.module('resetAtmCode', [_all2.default]).component('resetAtmCode', _reset_atm_code2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('reset-atm-code.all', {
        url: '/all/:page',
        component: 'resetAtmCodeAll'
    });
}]).name;

exports.default = resetAtmCodeModule;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reset_atm_code = __webpack_require__(2764);

var _reset_atm_code2 = _interopRequireDefault(_reset_atm_code);

var _reset_atm_code3 = __webpack_require__(2000);

var _reset_atm_code4 = _interopRequireDefault(_reset_atm_code3);

__webpack_require__(3044);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resetAtmCodeComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _reset_atm_code2.default,
    controller: _reset_atm_code4.default
};

exports.default = resetAtmCodeComponent;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetAtmCodeController = function (_SettingBase) {
    ResetAtmCodeController.$inject = ["$state"];
    (0, _inherits3.default)(ResetAtmCodeController, _SettingBase);

    /*@ngInject*/
    function ResetAtmCodeController($state) {
        (0, _classCallCheck3.default)(this, ResetAtmCodeController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ResetAtmCodeController.__proto__ || (0, _getPrototypeOf2.default)(ResetAtmCodeController)).call(this));

        _this.$state = $state;
        _this.id = "reset-atm-code";
        _this.acl = {};
        _this.hasACL = {};

        return _this;
    }

    (0, _createClass3.default)(ResetAtmCodeController, [{
        key: '$onInit',
        value: function $onInit() {
            (0, _get3.default)(ResetAtmCodeController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ResetAtmCodeController.prototype), '$onInit', this).call(this);
            for (var key in this.acl['setting-' + this.id]) {
                this.hasACL[this.acl['setting-' + this.id][key]] = true;
            }
        }
    }]);
    return ResetAtmCodeController;
}(_SettingBase3.default);

exports.default = ResetAtmCodeController;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeSheet = __webpack_require__(2005);

var _routeSheet2 = _interopRequireDefault(_routeSheet);

var _print = __webpack_require__(2002);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeSheetModule = angular.module('routeSheet', [_print2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/routeSheet');

  $stateProvider.state('routeSheet', {
    url: '/route-sheet',
    component: 'routeSheet',
    data: {
      requireLogin: true,
      requireACL: 'route_sheet.all'
    },
    parent: 'app'
  });
}]).component('routeSheet', _routeSheet2.default).name;

exports.default = routeSheetModule;

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _print = __webpack_require__(2003);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printModule = angular.module('print', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider.otherwise('/routeSheet');

	$stateProvider.state('print', {
		url: '/print?route&date&branch&prefix',
		component: 'print',
		data: {
			requireLogin: true,
			requireACL: 'route_sheet.all'
		}
	});
}]).component('print', _print2.default).name;

exports.default = printModule;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print = __webpack_require__(2765);

var _print2 = _interopRequireDefault(_print);

var _print3 = __webpack_require__(2004);

var _print4 = _interopRequireDefault(_print3);

__webpack_require__(3045);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printComponent = {
  restrict: 'E',
  bindings: {},
  template: _print2.default,
  controller: _print4.default
};

exports.default = printComponent;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _coin1Print = __webpack_require__(139);

var _coin1Print2 = _interopRequireDefault(_coin1Print);

var _coin5Print = __webpack_require__(142);

var _coin5Print2 = _interopRequireDefault(_coin5Print);

var _coin10Print = __webpack_require__(140);

var _coin10Print2 = _interopRequireDefault(_coin10Print);

var _coin25Print = __webpack_require__(141);

var _coin25Print2 = _interopRequireDefault(_coin25Print);

var _coin50Print = __webpack_require__(143);

var _coin50Print2 = _interopRequireDefault(_coin50Print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintController = function () {
  /*@ngInject*/
  PrintController.$inject = ["Auth", "$state", "Modal", "$translate", "$stateParams", "RouteService", "DateUtil"];
  function PrintController(Auth, $state, Modal, $translate, $stateParams, RouteService, DateUtil) {
    (0, _classCallCheck3.default)(this, PrintController);

    this.Modal = Modal;
    this.Auth = Auth;
    this.$state = $state;
    this.$translate = $translate;
    this.$stateParams = $stateParams;
    this.RouteService = RouteService;
    this.DateUtil = DateUtil;
    this.id = 'print';
    this.routeSheet = [];
    this.model = {};
    this.model.route = {};
    this.model.date = new Date('2017-01-01');
  }

  (0, _createClass3.default)(PrintController, [{
    key: 'computeData',
    value: function computeData(routeSheet) {
      var _this = this;

      var totalBags = 0;
      var totalKeys = 0;
      var coinTypeOrder = ['B', 'H', 'L'];

      routeSheet.forEach(function (r) {
        var sortedCoinsOrder = (0, _keys2.default)(r.totals);

        totalBags += r.totalCashShipments || 0;
        if (r.keyNum) {
          totalKeys++;
        }

        sortedCoinsOrder = sortedCoinsOrder.sort(function (coinA, coinB) {
          var coinAVal = coinA.indexOf('1$') >= 0 ? 100 : parseInt(coinA);
          var coinBVal = coinB.indexOf('1$') >= 0 ? 100 : parseInt(coinB);;

          //add weights for coin types i.e. B, H and L
          coinAVal += coinTypeOrder.indexOf(coinA.charAt(2));
          coinBVal += coinTypeOrder.indexOf(coinB.charAt(2));

          return coinAVal - coinBVal;
        });

        r.sortedCoinsOrder = sortedCoinsOrder;
        r.coinTypes = r.sortedCoinsOrder.length;

        // dont call bagStack in ngRepeat as it returns fresh array every time it will lead to digest cycle error
        r.bagStack = _this.bagStack(r.coinTypes, r.trackingIds);
        // delete r.trackingIds;
      });

      this.totalBags = totalBags;
      this.totalKeys = totalKeys;
    }
  }, {
    key: 'bagStack',
    value: function bagStack(coinTypes, bags) {
      var array = [];
      var i = void 0,
          j = void 0,
          chunk = 0;

      // column height is dependent on coinTypes so change the chunk size accordingly
      if (coinTypes > 12) {
        chunk = 6;
      } else if (coinTypes > 6 && coinTypes <= 12) {
        chunk = 4;
      } else {
        chunk = 3;
      }

      for (i = 0, j = bags.length; i < j; i += chunk) {
        array.push(bags.slice(i, i + chunk));
      }

      return array;
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      var printData = undefined;

      if (window.opener && window.opener.w && window.opener.w.printData && window.opener.w.printData.generateSheet) {
        printData = window.opener.w.printData;
      } else if (this.$stateParams.route && this.$stateParams.date && this.$stateParams.branch) {
        var routeId = this.$stateParams.route,
            dateString = this.$stateParams.date,
            branchName = this.$stateParams.branch;
        this.loading = true;
        return this.RouteService.get(routeId).then(function (route) {
          _this2.model.route = route;
          _this2.model.barcodeId = _this2.$stateParams.prefix ? _this2.$stateParams.prefix + route.id : route.id;
          _this2.model.date = dateString;
          _this2.branchName = branchName;
          return _this2.RouteService.sheet(routeId, new Date(dateString));
        }).then(function (data) {
          var routeSheet = data.records;
          _this2.branchId = data.branch;
          _this2.driverId = data.driverId;
          _this2.messengerId = data.messengerId;
          _this2.guardId = data.guardId;
          _this2.vehicleId = data.vehicleId;
          _this2.computeData(routeSheet);
          _this2.routeSheet = routeSheet;
          _this2.noDataFound = true;
          // this.totalBags = 0
          // this.routeSheet.forEach((r) => {
          //   this.totalBags += r.totalCashShipments
          //   r.coinTypes = Object.keys(r.totals).length;
          // })
          _this2.loading = false;
          return data.records && data.records.length;
        }).then(function (shouldPrint) {
          if (shouldPrint) {
            setTimeout(function () {
              window.print();
            }, 1000);
          }
        }).catch(function (err) {
          _this2.loading = false;
          console.log('Some error', err);
        });
      }

      this.routeSheet = printData.data;
      this.model = printData.model;
      this.totalBags = printData.totalBags;
      this.branchName = printData.branchName;
      this.branchId = printData.branchId;
      this.driverId = printData.driverId;
      this.messengerId = printData.messengerId;
      this.guardId = printData.guardId;
      this.vehicleId = printData.vehicleId;
      this.totalKeys = printData.totalKeys;

      setTimeout(function () {
        window.print();
      }, 2000);
    }
  }, {
    key: 'bagStack',
    value: function bagStack(cointTypes, bags) {
      var array = [];
      var i = void 0,
          j = void 0,
          chunk = 0;

      // column height is dependent on cointTypes so change the chunk size accordingly
      if (cointTypes > 12) {
        chunk = 6;
      } else if (cointTypes > 6 && cointTypes <= 12) {
        chunk = 4;
      } else {
        chunk = 3;
      }

      for (i = 0, j = bags.length; i < j; i += chunk) {
        array.push(bags.slice(i, i + chunk));
      }

      return array;
    }
  }, {
    key: 'icon',
    value: function icon(key) {
      key = key.substr(0, key.length - 1);
      switch (key) {
        case '01':
          return _coin1Print2.default;
        case '05':
          return _coin5Print2.default;
        case '25':
          return _coin25Print2.default;
        case '50':
          return _coin50Print2.default;
        case '10':
          return _coin10Print2.default;
        default:
          return _coin1Print2.default;
      }
    }
  }]);
  return PrintController;
}();

exports.default = PrintController;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeSheet = __webpack_require__(2766);

var _routeSheet2 = _interopRequireDefault(_routeSheet);

var _routeSheet3 = __webpack_require__(2006);

var _routeSheet4 = _interopRequireDefault(_routeSheet3);

__webpack_require__(3046);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeSheetComponent = {
  restrict: 'E',
  bindings: {
    printData: '='
  },
  template: _routeSheet2.default,
  controller: _routeSheet4.default
};

exports.default = routeSheetComponent;

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _coin1Print = __webpack_require__(139);

var _coin1Print2 = _interopRequireDefault(_coin1Print);

var _coin5Print = __webpack_require__(142);

var _coin5Print2 = _interopRequireDefault(_coin5Print);

var _coin10Print = __webpack_require__(140);

var _coin10Print2 = _interopRequireDefault(_coin10Print);

var _coin25Print = __webpack_require__(141);

var _coin25Print2 = _interopRequireDefault(_coin25Print);

var _coin50Print = __webpack_require__(143);

var _coin50Print2 = _interopRequireDefault(_coin50Print);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteSheetController = function () {
  /*@ngInject*/
  RouteSheetController.$inject = ["Auth", "$state", "DateUtil", "User", "UserService", "RouteService", "$translate", "$filter", "$q", "SetupService", "LocationService", "$rootScope"];
  function RouteSheetController(Auth, $state, DateUtil, User, UserService, RouteService, $translate, $filter, $q, SetupService, LocationService, $rootScope) {
    (0, _classCallCheck3.default)(this, RouteSheetController);

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.DateUtil = DateUtil;
    this.User = User;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.SetupService = SetupService;
    this.$filter = $filter;
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.routePrefix = null;
    this.routeSheet = [];
    this.fullRouteSheet = [];
    this.routes = [];
    this.routeList = [];
    this.branchName = " ";
    this.allData = "";
    this.model = {
      date: null,
      // day: null ,
      branchId: this.User.getUser().branchId
      // this.model.route = ''
      // this.model.date = new Date('2017-01-01')
    };this.noDataFound = false;
    this.$rootScope.$broadcast('routeChange', '/app/route-sheet');
  }

  (0, _createClass3.default)(RouteSheetController, [{
    key: 'initBarcodeOptions',
    value: function initBarcodeOptions() {
      this.barcodeOptions = {
        format: 'CODE128',
        lineColor: '#000000',
        width: 2,
        height: 50,
        displayValue: true,
        fontOptions: '',
        font: 'monospace',
        textAlign: 'center',
        textPosition: 'bottom',
        textMargin: 2,
        fontSize: 20,
        background: '#ffffff',
        margin: 0,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        valid: function valid(_valid) {}
      };
    }

    // do not allow to paste string into datepicker

  }, {
    key: 'dontAllow',
    value: function dontAllow(element) {
      element.on('cut copy paste', function (event) {
        event.preventDefault();
      });
    }

    // get tanker data

  }, {
    key: 'loadRoutes',
    value: function loadRoutes() {
      var onlyHoldRoutes = {
        queryJSON: {
          rules: [{
            field: 'holdRoute',
            condition: '=',
            data: '0'
          }, {
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          }],
          operator: 'AND'
        }
      };
      return onlyHoldRoutes.queryJSON.rules.length ? onlyHoldRoutes : null;
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.SetupService.get(this.User.getUser().branchId).then(function (data) {
        var date = _this.DateUtil.getUTCDate(data.currentVaultDate);
        _this.valutDate = moment(date).format('YYYY-MM-DD');
        _this.model.date = moment(_this.valutDate).toDate();
        _this.branchName = data.branch.description;
        _this.routePrefix = data.prefixes.route[0];
      }).catch(function (err) {
        _this.error = err.message;
      });

      this.getRouteData();
    }

    // load routeData

  }, {
    key: 'getRouteData',
    value: function getRouteData(searchKey, offset) {
      var _this2 = this;

      var loadRouteData = '';
      if (searchKey) {
        var searchObj = {
          queryText: '%' + searchKey + '%',
          isQuery: false
        };
        loadRouteData = searchObj;
      } else {
        loadRouteData = this.loadRoutes();
      }
      this.RouteService.all(loadRouteData, offset, _app2.default.defaultPageLimit).then(function (data) {

        if (offset === 0 || offset == undefined) {
          _this2.totalRecord = data.total;
          _this2.routeList = _this2.mappingRouteData(data.results);
        } else {
          var routes = _this2.mappingRouteData(data.results);
          _this2.routeList = _this2.routeList.concat(routes);
        }
      });
    }
  }, {
    key: 'mappingRouteData',
    value: function mappingRouteData(routes) {
      return routes.map(function (route) {
        return {
          Key: route.id + " | " + route.name,
          Value: route.id
        };
      });
    }
  }, {
    key: 'print',
    value: function print() {
      var obj = {
        data: this.routeSheet,
        model: this.model,
        totalBags: this.totalBags,
        branchName: this.branchName,
        branchId: this.allData.branch,
        driverId: this.allData.driverId,
        messengerId: this.allData.messengerId,
        guardId: this.allData.guardId,
        vehicleId: this.allData.vehicleId,
        totalKeys: this.totalKeys,
        generateSheet: true
      };
      var url = this.$state.href('print');
      window.w = window.open(url, '_blank');

      window.w.printData = obj;
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.model.route) {
        return;
      }
      this.model.barcodeId = this.routePrefix ? this.routePrefix + this.model.route.Value : this.model.route.Value;
      this.loadData(this.model.route.Value, this.model.date, this.model.branchId);
    }
  }, {
    key: 'computeData',
    value: function computeData(routeSheet) {
      var _this3 = this;

      var totalBags = 0;
      var coinTypeOrder = ['B', 'H', 'L'];
      var totalKeys = 0;
      routeSheet.forEach(function (r) {
        var sortedCoinsOrder = (0, _keys2.default)(r.totals);

        totalBags += r.totalCashShipments || 0;
        if (r.keyNum) {
          totalKeys++;
        }

        sortedCoinsOrder = sortedCoinsOrder.sort(function (coinA, coinB) {
          var coinAVal = coinA.indexOf('1$') >= 0 ? 100 : parseInt(coinA);
          var coinBVal = coinB.indexOf('1$') >= 0 ? 100 : parseInt(coinB);;

          //add weights for coin types i.e. B, H and L
          coinAVal += coinTypeOrder.indexOf(coinA.charAt(2));
          coinBVal += coinTypeOrder.indexOf(coinB.charAt(2));

          return coinAVal - coinBVal;
        });

        r.sortedCoinsOrder = sortedCoinsOrder;
        r.coinTypes = r.sortedCoinsOrder.length;

        // dont call bagStack in ngRepeat as it returns fresh array every time it will lead to digest cycle error
        r.bagStack = _this3.bagStack(r.coinTypes, r.trackingIds);
        // delete r.trackingIds;
      });

      this.totalBags = totalBags;
      this.totalKeys = totalKeys;
    }
  }, {
    key: 'loadData',
    value: function loadData(route, date, branchId) {
      var _this4 = this;

      // var day = moment(date).format('ddd');
      this.loading = true;
      this.RouteService.sheet(route, date, branchId).then(function (data) {
        _this4.noDataFound = true;
        _this4.loading = false;
        _this4.allData = data;
        _this4.fullRouteSheet = data.records;
        _this4.filterData();
      }).catch(function (err) {
        _this4.loading = false;
        console.log('Some error', err);
      });
    }
  }, {
    key: 'bagStack',
    value: function bagStack(coinTypes, bags) {
      var array = [];
      var i = void 0,
          j = void 0,
          chunk = 0;

      // column height is dependent on coinTypes so change the chunk size accordingly
      if (coinTypes > 12) {
        chunk = 6;
      } else if (coinTypes > 6 && coinTypes <= 12) {
        chunk = 4;
      } else {
        chunk = 3;
      }

      for (i = 0, j = bags.length; i < j; i += chunk) {
        array.push(bags.slice(i, i + chunk));
      }

      return array;
    }
  }, {
    key: 'icon',
    value: function icon(key) {
      key = key.substr(0, key.length - 1);
      switch (key) {
        case '01':
          return _coin1Print2.default;
        case '05':
          return _coin5Print2.default;
        case '25':
          return _coin25Print2.default;
        case '50':
          return _coin50Print2.default;
        case '10':
          return _coin10Print2.default;
        default:
          return _coin1Print2.default;
      }
    }

    // filter routeSequence data according to locationType

  }, {
    key: 'filterData',
    value: function filterData(branchId) {
      var _this5 = this;

      var routeSheet = [];
      var locationTypes = ["NO_SHIP_NO_GO"];

      if (this.printSeq) {
        routeSheet = this.fullRouteSheet.slice().filter(function (r) {
          return r.seq == _this5.printSeq;
        });
      } else {
        routeSheet = this.fullRouteSheet.slice();
      }
      this.computeData(routeSheet);
      this.routeSheet = routeSheet;
      this.branchId = this.allData.branch;
      this.driverId = this.allData.driverId;
      this.messengerId = this.allData.messengerId;
      this.guardId = this.allData.guardId;
      this.vehicleId = this.allData.vehicleId;
    }
  }]);
  return RouteSheetController;
}();

exports.default = RouteSheetController; /**/
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_manifest_all = __webpack_require__(2767);

var _delivery_manifest_all2 = _interopRequireDefault(_delivery_manifest_all);

var _delivery_manifest_all3 = __webpack_require__(2008);

var _delivery_manifest_all4 = _interopRequireDefault(_delivery_manifest_all3);

__webpack_require__(3047);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deliveryManifestAllComponent = {
    restrict: 'E',
    bindings: {},
    template: _delivery_manifest_all2.default,
    controller: _delivery_manifest_all4.default
};

exports.default = deliveryManifestAllComponent;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryManifestAllController = function () {
    /*@ngInject*/
    DeliveryManifestAllController.$inject = ["Auth", "$state", "$translate", "ShipmentService"];
    function DeliveryManifestAllController(Auth, $state, $translate, ShipmentService) {
        (0, _classCallCheck3.default)(this, DeliveryManifestAllController);

        this.$translate = $translate;
        this.$state = $state;
        this.Auth = Auth;
        this.ShipmentService = ShipmentService;
        this.printData = [];
        this.printData = undefined;
        this.loading = false;
    }

    (0, _createClass3.default)(DeliveryManifestAllController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this = this;

            if (window.opener && window.opener.w && window.opener.w.printData) {
                this.printData = window.opener.w.printData;

                this.loading = true;
                this.ShipmentService.deliveryManifestAll(this.printData.routeId, this.printData.routeDate).then(function (res) {
                    _this.printData = res.results;
                    setTimeout(function () {
                        window.print();
                    }, 1500);
                }).catch(function (err) {
                    console.log(err);
                }).finally(function () {
                    _this.loading = false;
                });
            }
        }
    }]);
    return DeliveryManifestAllController;
}();

exports.default = DeliveryManifestAllController;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_manifest_all = __webpack_require__(2007);

var _delivery_manifest_all2 = _interopRequireDefault(_delivery_manifest_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deliveryManifestAllModule = angular.module('deliveryManifestAll', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/routeControl');

    $stateProvider.state('deliveryManifestAll', {
        url: '/delivery-manifest-all',
        component: 'deliveryManifestAll',
        data: {
            requireLogin: true,
            requireACL: 'route_control.all'
        }
    });
}]).component("deliveryManifestAll", _delivery_manifest_all2.default).name;

exports.default = deliveryManifestAllModule;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_manifest_combined = __webpack_require__(2768);

var _delivery_manifest_combined2 = _interopRequireDefault(_delivery_manifest_combined);

var _delivery_manifest_combined3 = __webpack_require__(2011);

var _delivery_manifest_combined4 = _interopRequireDefault(_delivery_manifest_combined3);

__webpack_require__(3048);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deliveryManifestCombinedComponent = {
    restrict: 'E',
    bindings: {},
    template: _delivery_manifest_combined2.default,
    controller: _delivery_manifest_combined4.default
};

exports.default = deliveryManifestCombinedComponent;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteDeliveryManifestController = function () {
    /*@ngInject*/
    RouteDeliveryManifestController.$inject = ["Auth", "$state", "$translate", "ShipmentService", "CommonLayoutService"];
    function RouteDeliveryManifestController(Auth, $state, $translate, ShipmentService, CommonLayoutService) {
        var _this = this;

        (0, _classCallCheck3.default)(this, RouteDeliveryManifestController);

        this.loadLocationTypeIcon = function (locationType) {
            return _this.CommonLayoutService.loadLocationTypeIcon(locationType);
        };

        this.$translate = $translate;
        this.$state = $state;
        this.Auth = Auth;
        this.ShipmentService = ShipmentService;
        this.CommonLayoutService = CommonLayoutService;
        this.printData = [];
        this.printData = undefined;
        this.loading = false;
        this.totalCoinShipment = 0;
        this.totalCashShipment = 0;
        this.coinShipmentQty = 0;
    }

    (0, _createClass3.default)(RouteDeliveryManifestController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this2 = this;

            if (window.opener && window.opener.w && window.opener.w.printData) {
                this.printData = window.opener.w.printData;

                this.loading = true;
                this.ShipmentService.deliveryManifestCombined(this.printData.routeId, this.printData.routeDate).then(function (res) {
                    _this2.routeId = _this2.printData.routeId;
                    _this2.vaultDate = _this2.printData.routeDate;
                    _this2.printData = res.results;
                    _this2.total = res.totalAmount;

                    _this2.printData.forEach(function (shipment) {
                        if (shipment.coinFlag) {
                            _this2.totalCoinShipment++;
                            _this2.coinShipmentQty += shipment.qty;
                        } else _this2.totalCashShipment++;
                    });

                    setTimeout(function () {
                        window.print();
                    }, 1000);
                }).catch(function (err) {
                    console.log(err);
                }).finally(function () {
                    _this2.loading = false;
                });
            };
        }
    }, {
        key: "translateStatus",
        value: function translateStatus(statusCode) {
            return this.$translate.instant(statusCode);
        }
    }]);
    return RouteDeliveryManifestController;
}();

exports.default = RouteDeliveryManifestController;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _delivery_manifest_combined = __webpack_require__(2010);

var _delivery_manifest_combined2 = _interopRequireDefault(_delivery_manifest_combined);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deliveryManifestCombinedModule = angular.module('deliveryManifestCombined', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/routeControl');

    $stateProvider.state('deliveryManifestCombined', {
        url: '/delivery-manifest-combined',
        component: 'deliveryManifestCombined',
        data: {
            requireLogin: true,
            requireACL: 'route_control.all'
        }
    });
}]).component("deliveryManifestCombined", _delivery_manifest_combined2.default).name;

exports.default = deliveryManifestCombinedModule;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _route_control = __webpack_require__(2014);

var _route_control2 = _interopRequireDefault(_route_control);

var _delivery_manifest_all = __webpack_require__(2009);

var _delivery_manifest_all2 = _interopRequireDefault(_delivery_manifest_all);

var _delivery_manifest_combined = __webpack_require__(2012);

var _delivery_manifest_combined2 = _interopRequireDefault(_delivery_manifest_combined);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeControlModule = angular.module('routeControl', [_delivery_manifest_all2.default, _delivery_manifest_combined2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/routeControl');

  $stateProvider.state('routeControl', {
    url: '/routeControl',
    component: 'routeControl',
    data: {
      requireLogin: true,
      requireACL: 'route_control.all'
    },
    parent: 'app'
  });
}]).component('routeControl', _route_control2.default).name;

exports.default = routeControlModule;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _route_control = __webpack_require__(2769);

var _route_control2 = _interopRequireDefault(_route_control);

var _route_control3 = __webpack_require__(2015);

var _route_control4 = _interopRequireDefault(_route_control3);

__webpack_require__(3049);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeControlComponent = {
  restrict: 'E',
  bindings: {},
  template: _route_control2.default,
  controller: _route_control4.default
};

exports.default = routeControlComponent;

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _coin1Print = __webpack_require__(139);

var _coin1Print2 = _interopRequireDefault(_coin1Print);

var _coin5Print = __webpack_require__(142);

var _coin5Print2 = _interopRequireDefault(_coin5Print);

var _coin10Print = __webpack_require__(140);

var _coin10Print2 = _interopRequireDefault(_coin10Print);

var _coin25Print = __webpack_require__(141);

var _coin25Print2 = _interopRequireDefault(_coin25Print);

var _coin50Print = __webpack_require__(143);

var _coin50Print2 = _interopRequireDefault(_coin50Print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteControlController = function () {
  /*@ngInject*/
  RouteControlController.$inject = ["Auth", "$state", "User", "$q", "UserService", "Modal", "DateUtil", "RouteService", "$translate", "BranchService", "RouteDetailService", "ScanService", "ShipmentService", "LocationService", "$location", "ngToast", "$timeout", "UsersService", "SetupService", "RouteStopService", "HoldService", "$rootScope", "DataCounter", "Sound", "Configs", "$scope", "FetchReactData", "$window", "AutomatedRoutingStopsService", "TransactionService"];
  function RouteControlController(Auth, $state, User, $q, UserService, Modal, DateUtil, RouteService, $translate, BranchService, RouteDetailService, ScanService, ShipmentService, LocationService, $location, ngToast, $timeout, UsersService, SetupService, RouteStopService, HoldService, $rootScope, DataCounter, Sound, Configs, $scope, FetchReactData, $window, AutomatedRoutingStopsService, TransactionService) {
    (0, _classCallCheck3.default)(this, RouteControlController);


    this.BranchService = BranchService;
    this.RouteDetailService = RouteDetailService;
    this.RouteService = RouteService;
    this.ScanService = ScanService;
    this.ShipmentService = ShipmentService;
    this.LocationService = LocationService;
    this.HoldService = HoldService;
    this.$q = $q;
    this.FetchReactData = FetchReactData;
    this.$window = $window;
    this.$state = $state;
    this.$location = $location;
    this.User = User;
    this.UsersService = UsersService;
    this.AutomatedRoutingStopsService = AutomatedRoutingStopsService;
    this.ngToast = ngToast;
    this.$translate = $translate;
    this.$timeout = $timeout;
    this.Modal = Modal;
    this.toggleSelect = true;
    this.SetupService = SetupService;
    this.RouteStopService = RouteStopService;
    this.DateUtil = DateUtil;
    this.$rootScope = $rootScope;
    this.DataCounter = DataCounter;
    this.Configs = Configs;
    this.Sound = Sound;
    this.TransactionService = TransactionService;
    this.branchName = '';
    this.hasAutoRoutingPermission = false;
    this.autoRouteLoading = false;
    this.branches = [];
    this.model = {
      branch: this.User.getUser().branchId,
      date: '',
      receiverMail: ''
    };
    this.selectedRouteArr = [];
    this.allRoutes = [];
    this.releasingRoutes = false;
    this.releaseRouteErrors = [];
    this.branch = '';

    this.shouldDisableBranch = false;
    this.today = moment().hour(0).minutes(0).second(0).toDate();

    this.days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    this.routes = [];
    this.loading = false;
    this.hasACL = {};
    this.hasPermission = "";
    this.routeDetails = [];
    this.routePrefix = '';
    this.selectedRoutes = [];
    this.isRouteTransfered = false;
    this.routeStopTransferedData = "";
    this.stopTransferredMessage = "";
    this.isPreviousVaultDate = false;
    this.model.loading = true;
    this.holdCount = 0;
    this.$rootScope.$broadcast('routeChange', '/app/routeControl');
    this.routeObj = {};
    this.branchDetails = "";
    this.loadShipmentList = false;
    this.printItemList = [{
      label: this.$translate.instant('navbar.routeSheet_title'),
      value: 'routeSheet'
    }, {
      label: this.$translate.instant('shipmentBatch.manifest'),
      value: 'deliveryManifest'
    }, {
      label: this.$translate.instant('shipmentBatch.manifestAll'),
      value: 'deliveryManifestAll'
    }, {
      label: this.$translate.instant('shipmentBatch.delivery_manifest_combined'),
      value: 'deliveryManifestCombined'
    }, {
      label: this.$translate.instant('routeControl.coin_report'),
      value: 'coinReport'
    }];
    this.cloneStopTransferValue = '';
    this.isFromRouteIsCheckedOut = false;
    this.isEmailSending = false;

    this.$scope = $scope;
  }

  (0, _createClass3.default)(RouteControlController, [{
    key: 'loadPermission',
    value: function loadPermission() {
      var _this = this;

      this.acl = {};
      this.hasACL = {};

      ['route_control'].forEach(function (permissionKey) {
        _this.acl[permissionKey] = _this.User.getACL(permissionKey);
        _this.hasACL[permissionKey] = {};

        if (_this.acl[permissionKey] && _this.acl[permissionKey].length > 0) {
          _this.acl[permissionKey].forEach(function (permission) {
            _this.hasACL[permissionKey][permission] = true;
          });
        }
        _this.hasPermission = _this.hasACL[permissionKey];
      });
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.permissions = this.Configs.getPermissionConfig();
      this.loadPermission();
      this.moment = moment;
      // const queryParams = this.$location.search();
      var dateDefer = this.$q.defer();

      this.loading = true;
      this.model.branch = this.User.getUser().branchId;
      // queryParams.date = /\d{4}-\d{2}-\d{2}/.test(queryParams.date) ? queryParams.date : null;
      // if (queryParams.date) {
      //   const date = moment(queryParams.date).toDate();
      //   this.valutDate = moment(date).format('YYYY-MM-DD');
      //   this.minVaultDate = {
      //     minDate: this.valutDate
      //   }
      //   dateDefer.resolve(date);
      // }
      // else {
      var channel = new BroadcastChannel('app_sync_channel');

      channel.onmessage = function (event) {
        if (event.data.type === 'REACT_TAB_CLOSED') {
          _this2.FetchReactData.clearTransitionData();
        }
      };

      this.SetupService.get(this.model.branch).then(function (setup) {
        _this2.branchDetails = setup;
        _this2.routePrefix = setup.prefixes.route ? setup.prefixes.route[0] : '';
        var date = _this2.DateUtil.convertToDate(setup.currentVaultDate);
        _this2.valutDate = moment(date).format('YYYY-MM-DD');
        _this2.isCoinCheckIn = setup.coinCheckIn;
        _this2.minVaultDate = {
          minDate: _this2.valutDate
        };
        _this2.isCoinCheckOut = setup.coinCheckOut;
        dateDefer.resolve(date);
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this2.Modal.errorModal('error.' + err.data.message);
        }
      });
      // }
      dateDefer.promise.then(function (date) {
        _this2.model.date = date;

        return _this2.loadBranches();
      }).then(function () {
        _this2.loadRoutes().then(function () {
          _this2.autoOpenStopTransfer();
          return _this2.itemHoldCount();
        });
      }).finally(function () {
        // this.loading = false;
      });

      // this.$doc = angular.element(document)
      // this.$doc.on('keydown', this.handler.bind(this))
    }

    // $onDestroy(){
    //   this.$doc.off('keydown', this.handler)
    // }

  }, {
    key: 'routeDetail',
    value: function routeDetail(route) {
      var _this3 = this;

      if (this.isLoading) return;
      this.isLoading = true;
      var date = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.routeDetails(route, date, this.branchDetails.supervisorScan, function (_ref) {
        var truck = _ref.truck,
            messenger = _ref.messenger,
            driver = _ref.driver,
            modal = _ref.modal,
            guard = _ref.guard,
            leaveTime = _ref.leaveTime,
            arriveTime = _ref.arriveTime,
            begMiles = _ref.begMiles,
            endMiles = _ref.endMiles;

        _this3.RouteDetailService.routeUpdateDetails(_this3.model.branch, route.routeId, date, truck, messenger, driver, guard, leaveTime, arriveTime, begMiles, endMiles).then(function (data) {
          _this3.isLoading = false;
          modal.close();
        }).catch(function (err) {
          _this3.isLoading = false;
          modal.close();
          if (err && err.data && err.data.message) {
            return _this3.Modal.errorModal("error." + err.data.message);
          }
        });
      }, function (_ref2) {
        var modal = _ref2.modal;

        _this3.isLoading = false;
        modal.close();
      });
    }
  }, {
    key: 'openMessengerModal',
    value: function openMessengerModal(route) {
      var _this4 = this;

      if (this.isLoading) return;
      this.isLoading = true;
      var date = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.routeMessenger(route, date, function (_ref3) {
        var messengerId = _ref3.messengerId,
            modal = _ref3.modal;

        _this4.RouteDetailService.updateMessenger(_this4.model.branch, route.routeId, date, messengerId).then(function (data) {
          _this4.isLoading = false;
          modal.close();
          _this4.loadRoutes();
        }).catch(function (err) {
          _this4.isLoading = false;
          modal.close();
          if (err && err.data && err.data.message) {
            return _this4.Modal.errorModal("error." + err.data.message);
          }
        });
      }, function (_ref4) {
        var modal = _ref4.modal;

        _this4.isLoading = false;
        modal.close();
      });
    }
  }, {
    key: 'loadBranches',
    value: function loadBranches() {
      this.branches = [this.User.getUser().branchId];
      return this.$q.when();

      // return this.BranchService.all(null, 0, 100)
      //   .then((data) => {
      // 		this.branches = data.results.map((branch) => {
      //       return branch.id;
      //     })
      // 	})
      // 	.catch((err) => {
      // 		this.error = err.message
      // 	})
      //   .finally(() => {
      //     this.loading = false
      //   })
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      var day = this.model.date.getDay();

      if (!day === undefined) {
        return null;
      }

      return {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branch
          }, {
            field: 'defRoute' + this.days[day] + 'Id',
            condition: '!=',
            data: null
          }],
          operator: 'AND'
        }
      };
    }
  }, {
    key: 'loadRoutes',
    value: function loadRoutes() {
      var _this5 = this;

      this.loading = true;
      var searchObj = this.generateSearchObj();
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      if (!searchObj) {
        return;
      }

      var defer = this.$q.defer();
      this.BranchService.getReleaseRoutes(this.model.branch, formattedDate, this.isCoinCheckOut).then(function (res) {
        _this5.selectedRouteArr = [];
        _this5.selectedRoutes = [];
        // const routes = res.filter(route => (route.routeDetailId) || (!route.routeDetailId && (route.totalShipments > 0 || route.stops > 0)));
        _this5.allRoutes = _lodash2.default.orderBy(res, [function (route) {
          return _this5.isUnassignedRoute(route);
        }, 'totalShipments', 'routeName'], ['asc', 'desc', 'asc']);
        _this5.allRoutes.forEach(function (route) {
          return _this5.handleRouteMileage(route);
        });
        _this5.routes = _this5.allRoutes.filter(function (data) {
          return !data.isCheckedIn;
        });
      }).then(function () {
        var date = moment(_this5.model.date).format('YYYY-MM-DD');
        _this5.isPreviousVaultDate = date < _this5.valutDate;
        if (_this5.isPreviousVaultDate) {
          _this5.model.checkedInRoute = true;
          _this5.routes = _this5.allRoutes;
        } else _this5.model.checkedInRoute = false;
        defer.resolve();
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this5.loading = false;
      });
      return defer.promise;
    }
  }, {
    key: 'resetData',
    value: function resetData() {
      this.selectedRouteArr = [];
      this.selectedRoutes = [];
      this.toggleSelect = false;
      this.clear();
      this.toggleAllRouteSelection();
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.routeStopTransferedData = "";
      this.stopTransferredMessage = "";
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this6 = this;

      this.loading = true;
      var searchObj = this.generateSearchObj();
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');

      return this.BranchService.getReleaseRoutes(this.model.branch, formattedDate, this.isCoinCheckOut).then(function (res) {
        _this6.resetData();
        // const routes = res.filter(route => route.routeDetailId || !route.routeDetailId && (route.totalShipments > 0 || route.stops > 0));
        _this6.allRoutes = _lodash2.default.orderBy(res, [function (route) {
          return _this6.isUnassignedRoute(route);
        }, 'totalShipments', 'routeName'], ['asc', 'desc', 'asc']);
        _this6.allRoutes.forEach(function (route) {
          return _this6.handleRouteMileage(route);
        });
        _this6.loading = false;
      }).catch(function (err) {
        console.log(err);
      }).finally(function () {
        _this6.cloneStopTransferValue = '';
      });
    }
  }, {
    key: 'editRoute',
    value: function editRoute(route) {
      var _this7 = this;

      var day = this.model.date.getDay();

      // this.$location.search('branch', this.model.branch)
      // this.$location.search('date', moment(this.model.date).format('YYYY-MM-DD'));

      if (!route.isCheckedOut && this.permissions && this.permissions.hasSettingsPermission) {
        setTimeout(function () {
          _this7.$state.go('routes.edit', {
            id: route.routeId,
            day: _this7.days[day]
          });
        }, 200);
      } else {
        var obj = {
          routeId: route.routeId,
          vaultDate: moment(this.model.date).format('YYYY-MM-DD') + 'T00:00:00.000Z',
          isRedirected: true
        };
        this.DataCounter.setData(obj);
        this.$location.url('/app/branch-management/routes');
      }
    }
  }, {
    key: 'toggleAllRouteSelection',
    value: function toggleAllRouteSelection() {
      var _this8 = this;

      this.selectedRouteArr = [];
      this.routes.forEach(function (route) {
        route.isSelected = _this8.toggleSelect;
        _this8.selectedRoute(route.isSelected, route);
      });
      this.toggleSelect = !this.toggleSelect;
    }
  }, {
    key: 'executeReleaseRoutes',
    value: function executeReleaseRoutes(routes) {
      var _this9 = this;

      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');

      routes.forEach(function (route) {
        route.status = 'processing';
      });

      return routes.reduce(function (p, route) {
        var nextIteration = _this9.$q.defer();

        p.then(function () {
          _this9.RouteService.releaseRoute(route.routeId, formattedDate, _this9.model.branch, 'route_control').then(function (res) {
            if (res.status) {
              route.isReleased = true;
            }
          }).then(function () {
            route.status = 'success';
            route.isReleased = true;
            _this9.Sound.playSuccessBeep("#success_beep");
          }).catch(function (err) {
            _this9.Sound.PlayErrorBeep("#scanner_beep");
            _this9.error = JSON.parse(err.data.message);
            route.status = 'error';
            if (_this9.error.message == 'E_ROUTEDETAIL_DISABLED_MULTICHECKOUT' && _this9.error.errorCode == '90000') {
              _this9.releaseRouteErrors[route.routeId] = {
                errorCode: _this9.error.errorCode,
                message: _this9.$translate.instant('error.disabled_multi_checkout')
              };
            } else {
              _this9.releaseRouteErrors[route.routeId] = _this9.error;
            }
          }).finally(function () {
            nextIteration.resolve();
          });
        });

        return nextIteration.promise;
      }, this.$q.when()).finally(function () {
        _this9.$timeout(function () {
          routes.forEach(function (route) {
            route.status = '';
          });
        }, 3000);
      });
    }
  }, {
    key: 'releaseRoute',
    value: function releaseRoute(route) {
      var _this10 = this;

      this.executeReleaseRoutes([route]).then(function () {
        return _this10.loadRoutes();
      });
    }
  }, {
    key: 'printSheet',
    value: function printSheet(route) {
      var _this11 = this;

      if (this.isPrintLoading) return;
      this.isPrintLoading = true;
      this.branchName = this.User.getUser().branch.description;
      var url = this.$state.href('print', {
        prefix: this.routePrefix,
        route: route.routeId,
        date: moment(this.model.date).format('YYYY-MM-DD'),
        branch: this.branchName
      });
      setTimeout(function () {
        _this11.isPrintLoading = false;
        window.open(url, '_blank');
      }, 1000);
    }
  }, {
    key: 'printCoin',
    value: function printCoin(route) {
      var _this12 = this;

      if (this.isPrintCoinLoading) return;
      this.isPrintCoinLoading = true;
      var url = this.$state.href('coinPullReportPrint', {
        route: route.routeId,
        date: moment(this.model.date).format('YYYY-MM-DD'),
        branch: this.model.branch
      });

      setTimeout(function () {
        _this12.isPrintCoinLoading = false;
        window.open(url, '_blank');
      }, 1000);
    }
  }, {
    key: 'selectedRoute',
    value: function selectedRoute(event, route) {
      var isChecked = event && event.target ? event.target.checked : event;
      this.routeDetails = [];
      if (isChecked) {
        this.selectedRouteArr.push(route.routeId);
        this.selectedRoutes.push(route.isCheckedIn);
        this.isFromRouteIsCheckedOut = this.selectedRoutes[0];
      } else {
        var index = this.selectedRouteArr.indexOf(route.routeId);
        this.selectedRouteArr.splice(index, 1);
        this.selectedRoutes.splice(index, 1);
      }
      this.isRouteCheckedIn = _lodash2.default.includes(this.selectedRoutes, 1);
      this.checkReleasedRoute();
      this.isRouteReleased = this.routeDetails.filter(function (obj) {
        return !obj.lastReleasedAt;
      });
    }
  }, {
    key: 'releaseRoutes',
    value: function releaseRoutes() {
      var _this13 = this;

      var selectedRoutes = this.routes.filter(function (route) {
        return route.isSelected;
      });

      if (!selectedRoutes || !selectedRoutes.length) {
        return;
      }

      this.releasingRoutes = true;

      this.executeReleaseRoutes(selectedRoutes).then(function () {
        _this13.ngToast.create({
          className: 'success',
          content: _this13.$translate.instant('routeControl.routesReleasedSuccessfully', { routeName: '' })
        });
        return _this13.loadRoutes();
      }).catch(function () {
        _this13.ngToast.create({
          className: 'danger',
          content: _this13.$translate.instant('routeControl.routesReleaseFailed', { routeName: '' })
        });
      }).finally(function () {
        _this13.releasingRoutes = false;
      });
    }
  }, {
    key: 'printSheets',
    value: function printSheets() {
      var _this14 = this;

      if (this.isPrintSheetLoading) return;
      var routes = this.routes.filter(function (route, i) {
        return route.isSelected;
      });
      if (!routes.length) return;
      this.isPrintSheetLoading = true;
      routes.forEach(function (route, i) {
        var url = _this14.$state.href('print', {
          route: route.routeId,
          date: moment(_this14.model.date).format('YYYY-MM-DD'),
          branch: _this14.model.branch
        });
        setTimeout(function () {
          if (routes.length == i + 1) {
            _this14.isPrintSheetLoading = false;
          };
          if (url) {
            window.open(url, '_blank');
          }
        }, 1000);
      });
    }
  }, {
    key: 'printCoins',
    value: function printCoins() {
      var _this15 = this;

      if (this.isPrintCoinsLoading) return;
      var routes = this.routes.filter(function (route, i) {
        return route.isSelected;
      });
      if (!routes.length) return;
      this.isPrintCoinsLoading = true;
      routes.forEach(function (route, i) {
        var url = _this15.$state.href('coinPullReportPrint', {
          route: route.routeId,
          date: moment(_this15.model.date).format('YYYY-MM-DD'),
          branch: _this15.model.branch
        });
        setTimeout(function () {
          if (routes.length == i + 1) {
            _this15.isPrintCoinsLoading = false;
          };
          if (url) {
            window.open(url, '_blank');
          }
        }, 1000);
      });
    }
  }, {
    key: 'showCheckedInRoutes',
    value: function showCheckedInRoutes(event) {
      if (event.target.checked) {
        this.routes = this.allRoutes;
      } else {
        this.routes = this.allRoutes.filter(function (res) {
          return !res.isCheckedIn;
        });
      }
    }
  }, {
    key: 'checkReleasedRoute',
    value: function checkReleasedRoute() {
      var _this16 = this;

      this.selectedRouteArr.map(function (data) {
        var routes = _lodash2.default.find(_this16.allRoutes, { 'routeId': data });
        _this16.routeDetails.push(routes);
      });
    }

    // handler(e) {
    //   if (e.keyCode === 13) {
    //     this.loadRoutes()
    //   }
    // }

    // $scope.$on('$destroy',function(){
    //   $doc.off('keydown', handler);
    // })

  }, {
    key: 'stopTransferView',
    value: function stopTransferView(override) {
      var _this17 = this;

      this.routeDetails = [];
      this.cloneStopTransferValue = '';

      // pass selected date instead of vault date
      this.Modal.routeStopTransfer(this.model.date, this.model.date, this.valutDate, this.selectedRouteArr, this.model.branch, this.selectedRoutes, function (_ref5) {
        var modal = _ref5.modal,
            transferredStops = _ref5.transferredStops,
            fromRoutesData = _ref5.fromRoutesData,
            destinationRoutesData = _ref5.destinationRoutesData,
            fromRouteId = _ref5.fromRouteId,
            fromRouteDate = _ref5.fromRouteDate,
            toRouteId = _ref5.toRouteId,
            toRouteDate = _ref5.toRouteDate,
            $scope = _ref5.$scope;

        // console.log("transferredStops",transferredStops.length );
        _this17.cloneStopTransferValue = _lodash2.default.cloneDeep({ transferredStops: transferredStops, $scope: $scope, override: override, fromRouteId: fromRouteId, fromRouteDate: fromRouteDate, toRouteId: toRouteId, toRouteDate: toRouteDate, modal: modal, destinationRoutesData: destinationRoutesData });
        return _this17.transferRouteStops(transferredStops, $scope, override, fromRouteId, fromRouteDate, toRouteId, toRouteDate, modal, destinationRoutesData);
      }, function (_ref6) {
        var modal = _ref6.modal,
            needsRefresh = _ref6.needsRefresh,
            totalTransferredStops = _ref6.totalTransferredStops,
            totalTransferredShipments = _ref6.totalTransferredShipments,
            requireThrow = _ref6.requireThrow;

        modal.close();
        if (needsRefresh) {
          _this17.loadRoutes().then(function () {
            _this17.showStopTransferredMessage(totalTransferredStops, totalTransferredShipments, requireThrow);
          });
        }
      });
    }
  }, {
    key: 'transferRouteStops',
    value: function transferRouteStops(transferredStops, $scope, override, fromRouteId, fromRouteDate, toRouteId, toRouteDate, modal, destinationRoutesData) {
      var _this18 = this;

      var selectedRoutes = [],
          totalTransferredStops = 0,
          totalTransferredShipments = 0;

      var destinationRouteSequence = (destinationRoutesData || []).map(function (stop) {
        return {
          routeId: toRouteId,
          routeDate: toRouteDate,
          locationId: stop.locationId
        };
      });

      this.updateStopsAndShipments(transferredStops, $scope, override, destinationRouteSequence).then(function (data) {
        if (data && data.status !== false) {
          var requireThrow = data.requireThrow;

          selectedRoutes.push({
            routeId: fromRouteId,
            date: fromRouteDate
          }, {
            routeId: toRouteId,
            date: toRouteDate
          });

          transferredStops.forEach(function (t) {
            t.shipmentInfo.forEach(function (s) {
              if (s.trackingId) totalTransferredShipments++;else if (!s.trackingId) totalTransferredStops++;
            });
          });

          return _this18.routeStopTransfer(selectedRoutes, $scope).then(function () {
            modal.close();
            $scope.model.isUpdating = false;
            return _this18.loadRoutes().then(function () {
              _this18.showStopTransferredMessage(totalTransferredStops, totalTransferredShipments, requireThrow);
            });
          });
        } else {
          $scope.model.isUpdating = false;
        }
      });
    }
  }, {
    key: 'showStopTransferredMessage',
    value: function showStopTransferredMessage(totalTransferredStops, totalTransferredShipments, requireThrow) {
      var _this19 = this;

      if ((!totalTransferredStops || totalTransferredStops === 0) && (!totalTransferredShipments || totalTransferredShipments === 0)) return;

      setTimeout(function () {

        if (requireThrow && !_this19.isFromRouteIsCheckedOut && totalTransferredShipments > 0 && totalTransferredStops === 0) {
          _this19.stopTransferredMessage = _this19.$translate.instant('routeControl.StopTransferredMessage', { totalStops: totalTransferredShipments });
        } else if (totalTransferredShipments > 0 && totalTransferredStops === 0) {
          _this19.stopTransferredMessage = '<b> ' + totalTransferredShipments + ' </b> ' + _this19.$translate.instant('routeControl.shipmentTransferred');
        } else if (totalTransferredStops > 0 && totalTransferredShipments === 0) {
          _this19.stopTransferredMessage = _this19.$translate.instant('routeControl.stops_transferred', { totalStops: totalTransferredStops });
        } else if (totalTransferredStops > 0 && totalTransferredShipments > 0 && !requireThrow && !_this19.isFromRouteIsCheckedOut) {
          _this19.stopTransferredMessage = _this19.$translate.instant('routeControl.stops_transferred', { totalStops: totalTransferredStops }) + ',' + ('<b> ' + totalTransferredShipments + ' </b> ') + _this19.$translate.instant('routeControl.shipmentTransferred');
        } else if (totalTransferredStops > 0 && totalTransferredShipments > 0 && requireThrow && !_this19.isFromRouteIsCheckedOut) {
          _this19.stopTransferredMessage = _this19.$translate.instant('routeControl.stops_transferred', { totalStops: totalTransferredStops }) + ',' + _this19.$translate.instant('routeControl.StopTransferredMessage', { totalStops: totalTransferredShipments });
        }

        _this19.Modal.confirm({
          header: _this19.$translate.instant('successModal.title'),
          message: _this19.$translate.instant(_this19.stopTransferredMessage),
          callback: function callback(_ref7) {
            var modal = _ref7.modal;

            if (requireThrow && totalTransferredShipments > 0) _this19.$state.go('routeThrow');
            _this19.isFromRouteIsCheckedOut = false;
            modal.close();
          },
          negative: function negative(_ref8) {
            var modal = _ref8.modal;

            modal.close();
            _this19.isFromRouteIsCheckedOut = false;
          },
          buttons: requireThrow && totalTransferredShipments > 0 ? ['routeControl.route_throw', 'common.cancel'] : ['common.ok', 'common.cancel'],
          type: 'success'
        });
      }, 500);
    }
  }, {
    key: 'routeStopTransfer',
    value: function routeStopTransfer(routes, $scope) {
      var _this20 = this;

      var defer = this.$q.defer();
      this.RouteService.routeStopTransfered(routes, this.model.branch).then(function (data) {
        // this.loadRoutes();
        // modal.close();
        defer.resolve();
      }).catch(function (err) {
        // this.selectedRouteArr = [];
        $scope.model.isUpdating = false;
        if (err && err.data && err.data.message) {
          return _this20.Modal.errorModal('error.' + err.data.message);
        }
        defer.reject(err);
      });
      return defer.promise;
    }
  }, {
    key: 'updateStopsAndShipments',
    value: function updateStopsAndShipments(transferredStopsData, $scope, override, destinationRouteSequence) {
      var _this21 = this;

      var defer = this.$q.defer();
      return this.RouteService.updateStopsAndShipments(transferredStopsData, transferredStopsData, this.model.branch, override, destinationRouteSequence).then(function (data) {
        if (data.status === true) {
          _this21.routeStopTransferedData = data.results;
          defer.resolve(_this21.routeStopTransferedData);
        } else {
          if (data.message === '94291') {
            _this21.Modal.confirm({
              header: _this21.$translate.instant('errorModal.title'),
              message: _this21.$translate.instant('error.' + data.message),
              callback: function callback(_ref9) {
                var modal = _ref9.modal;

                var val = _this21.cloneStopTransferValue;
                $scope.model.isUpdating = true;
                _this21.transferRouteStops(data.remainingStops, $scope, true, val.fromRouteId, val.fromRouteDate, val.toRouteId, val.toRouteDate, val.modal, val.destinationRoutesData);
                modal.close();
              },
              negative: function negative(_ref10) {
                var modal = _ref10.modal;

                modal.close();
              },
              buttons: ['checkin.override', 'common.cancel'],
              type: 'danger'
            });
          } else {
            return _this21.Modal.errorModal('error.' + data.message);
          }
          defer.resolve(data);
        }
        $scope.model.isUpdating = false;
        return defer.promise;
      });
    }
  }, {
    key: 'loadSequence',
    value: function loadSequence(route) {
      var _this22 = this;

      this.Modal.routeSequenceModal(this.model.date, route.routeId, this.model.branch, this.branchDetails, function (_ref11) {
        var modal = _ref11.modal,
            routeSequence = _ref11.routeSequence;

        _this22.RouteStopService.updateRouteStop(routeSequence, _this22.model.branch) // update route Sequence
        .then(function (data) {
          _this22.refreshRouteErt([route.routeId]);
          if (!route.routeTransfered) {
            var formattedDate = moment(_this22.model.date).format('YYYY-MM-DD');
            return _this22.routeStopTransfer([{ routeId: route.routeId, date: formattedDate }]).then(function () {
              modal.close();
              _this22.loadRoutes();
            });
          } else {
            modal.close();
          }
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            return _this22.Modal.errorModal('error.' + err.data.message);
          }
        });
      }, function (_ref12) {
        var modal = _ref12.modal;

        modal.close();
      });
    }
  }, {
    key: 'handleRouteMileage',
    value: function handleRouteMileage(route) {
      var mileageData = route.estimatedRouteMilage;
      if (!mileageData) return;

      var activeRoute = null;
      if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.ActiveRoutes && mileageData.routeAnalysis.ActiveRoutes.length > 0) {
        activeRoute = mileageData.routeAnalysis.ActiveRoutes[0];
      }

      var formattedTime = 'N/A';
      var totalDistance = 'N/A';

      if (activeRoute && activeRoute.Summary) {
        formattedTime = this.DateUtil.convertToTimeFormat(activeRoute.Summary.TotalTimeByHours);
        totalDistance = activeRoute.Summary.DistanceMiles;
      } else if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.routesSummary) {
        totalDistance = mileageData.routeAnalysis.routesSummary.TotalFleetDistanceMiles;
      } else if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.OverallSummary) {
        // Fallback for old format
        formattedTime = mileageData.routeAnalysis.OverallSummary.TotalTimeInService || this.DateUtil.convertToTimeFormat(mileageData.routeAnalysis.OverallSummary.TotalDurationHours);
        totalDistance = mileageData.routeAnalysis.OverallSummary.TotalDistanceMiles;
      }

      if (mileageData && mileageData.routeAnalysis) {
        mileageData.routeAnalysis.OverallSummary = {
          TotalTimeInService: formattedTime,
          TotalDistanceMiles: totalDistance
        };
      }
    }
  }, {
    key: 'refreshRouteErt',
    value: function refreshRouteErt(routeIds) {
      var _this23 = this;

      var date = moment(this.model.date).format('YYYY-MM-DD');
      return this.AutomatedRoutingStopsService.getRouteEstimatedReturnTimes(routeIds, date).then(function (res) {
        var ertMap = res && res.results || {};
        _this23.allRoutes.forEach(function (r) {
          if (Object.prototype.hasOwnProperty.call(ertMap, r.routeId)) {
            var ertData = ertMap[r.routeId];
            r.estimatedReturnTime = ertData && ertData.estimatedReturnTime || null;
            r.estimatedRouteMilage = ertData && ertData.estimatedRouteMilage || null;
            _this23.handleRouteMileage(r);
          }
        });
      }).catch(function (err) {
        return console.log(err);
      });
    }
  }, {
    key: 'itemHoldSearchObj',
    value: function itemHoldSearchObj() {
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branch
          }, {
            field: 'status',
            condition: '=',
            data: 'ON_HOLD'
          }],
          operator: 'AND'
        }
      };
      return searchObj.queryJSON.rules.length ? searchObj : null;
    }
  }, {
    key: 'itemHoldCount',
    value: function itemHoldCount() {
      var _this24 = this;

      this.model.loading = true;
      var searchObj = this.itemHoldSearchObj();
      this.HoldService.holdItemCount(searchObj).then(function (data) {
        _this24.holdCount = data.total;
        _this24.model.loading = false;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'holdShipmentList',
    value: function holdShipmentList(data) {
      var date = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.holdShipmentModal(data.routeId, date, data.branchId, function (_ref13) {
        var modal = _ref13.modal;

        modal.close();
      }, function (_ref14) {
        var modal = _ref14.modal;

        modal.close();
      });
    }
  }, {
    key: 'remainingToThrowShipments',
    value: function remainingToThrowShipments(route) {
      // show remaining throw shipments
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.remainingToThrow(route.routeId, formattedDate, this.model.date, route.branchId, this.isCoinCheckOut, function (_ref15) {
        var modal = _ref15.modal;

        modal.close();
      }, function (_ref16) {
        var modal = _ref16.modal;

        modal.close();
      });
    }
  }, {
    key: 'remainingToPackShipments',
    value: function remainingToPackShipments(route) {
      // show remaining to pack shipments
      var date = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.remainingToPack(route.routeId, date, route.branchId, this.isCoinCheckOut, function (_ref17) {
        var modal = _ref17.modal;

        modal.close();
      }, function (_ref18) {
        var modal = _ref18.modal;

        modal.close();
      });
    }
  }, {
    key: 'redirectToCheckInScreen',
    value: function redirectToCheckInScreen(route) {
      return this.$state.go('checkin');
    }
  }, {
    key: 'openAdHocCheckinModal',
    value: function openAdHocCheckinModal() {
      var _this25 = this;

      var unassignedRouteId = this.branchDetails && this.branchDetails.unassignedRouteId;

      if (!unassignedRouteId) {
        return this.Modal.errorModal(this.$translate.instant('routeControl.adHocCheckinNoUnassignedRoute'));
      }

      var setupMissing = !this.branchDetails.defaultWindowId || !this.branchDetails.defaultToTankerId;
      if (setupMissing) {
        return this.Modal.errorModal(this.$translate.instant('routeControl.adHocCheckinSetupMissing'));
      }

      this.Modal.checkedInAdHocCheckin({
        branchId: this.model.branch,
        windowId: this.branchDetails.defaultWindowId,
        routeId: unassignedRouteId,
        date: this.model.date,
        supervisorScan: false,
        branchVaultDate: this.model.date,
        cancelSupervisorChallenge: true
      }, function (_ref19) {
        var modal = _ref19.modal,
            $scope = _ref19.$scope;

        $scope.bag.branchTimeZone = _this25.branchDetails && _this25.branchDetails.timezone;
        $scope.bag.vaultDate = moment(_this25.model.date).format('YYYY-MM-DD');
        // Show supervisor challenge on save, like other supervisor-gated actions
        _this25.Modal.confirmSupervisor('ad-hoc-checkin', null, function (_ref20) {
          var supModal = _ref20.modal,
              supId = _ref20.supId;

          supModal.close();
          var pickupTimeZone = moment.tz(moment($scope.bag.pickupDate).format('YYYY-MM-DD') + ' ' + $scope.bag.pickupTime, 'YYYY-MM-DD HH:mm:ss', $scope.bag.branchTimeZone).utc().format();

          var payload = {
            branchId: _this25.model.branch || $scope.bag.branchId,
            trackingId: $scope.bag.trackingId,
            routeId: $scope.bag.routeId,
            date: pickupTimeZone,
            windowId: _this25.branchDetails.defaultWindowId,
            toTankerId: _this25.branchDetails.defaultToTankerId,
            fromTankerId: _this25.branchDetails.defaultFromTankerId,
            amount: $scope.bag.amount || 0,
            qty: $scope.bag.qty || 1,
            shiptypeId: $scope.bag.shiptypeId,
            fromLocationId: $scope.bag.fromLocationId.Value || $scope.bag.fromLocationId,
            toLocationId: $scope.bag.toLocationId.Value || $scope.bag.toLocationId,
            performedByUserId: _this25.User.getUser().id
          };

          _this25.ShipmentService.adhocCheckIn(payload).then(function (res) {
            _this25.Sound.playSuccessBeep("#success_beep");
            modal.close();
            return _this25.loadRoutes();
          }).catch(function (err) {
            console.error('[AdHocCheckin] error =>', err);
            $scope.loading = false;
            var msg = err && err.data && (err.data.message || err.data.error || (0, _stringify2.default)(err.data));
            return _this25.Modal.errorModal(msg ? 'error.' + msg : 'An unexpected error occurred.');
          });
        }, function (_ref21) {
          var supModal = _ref21.modal;

          supModal.close();
          $scope.loading = false; // supervisor cancelled — re-enable the add-bag form
        });
      }, function (_ref22) {
        var modal = _ref22.modal;

        if (modal) modal.close();
      });
    }

    // redirect to item hold screen

  }, {
    key: 'redirectToItemHold',
    value: function redirectToItemHold() {
      return this.$state.go('branchManagement.itemHolds');
    }

    // if route exceed liabilityLimit. User will redirect from checkOut screen and User is presented with "Route Transfer Modal"

  }, {
    key: 'autoOpenStopTransfer',
    value: function autoOpenStopTransfer() {
      var _this26 = this;

      this.routeObj = this.DataCounter.getData();

      if (this.routeObj && this.routeObj.isRedirected) {
        var route = this.routes.find(function (data) {
          return data['routeId'].toUpperCase() === _this26.routeObj.routeId;
        });

        if (route) {
          // this.routes.forEach((route) => {
          // if (route.routeId.toUpperCase() === this.routeObj.routeId) {
          route.isSelected = true;
          this.selectedRoute(route.isSelected, route);
          // }
          // });
          setTimeout(function () {
            _this26.stopTransferView(false);
            _this26.resetFilterData();
          }, 1500);
        } else {
          var errorMessage = this.$translate.instant('routeControl.not_found', {
            routeId: this.routeObj.routeId
          });
          setTimeout(function () {
            _this26.Modal.errorModal(errorMessage);
            _this26.resetFilterData();
          }, 1500);
        }
      }
    }
  }, {
    key: 'resetFilterData',
    value: function resetFilterData() {
      if (this.routeObj && this.routeObj.isRedirected) {
        this.routeObj.isRedirected = false;
        this.routeObj = this.DataCounter.setData();
      }
    }
  }, {
    key: 'shipmentListModal',
    value: function shipmentListModal(route) {
      var _this27 = this;

      if (this.loadShipmentList) return;
      this.loadShipmentList = true;
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.shipmentList(route.routeId, formattedDate, this.branchDetails.coinCheckOut, function (_ref23) {
        var modal = _ref23.modal;

        modal.close();
      }, function (_ref24) {
        var modal = _ref24.modal;

        if (modal) modal.close();
        _this27.loadShipmentList = false;
      });
    }
  }, {
    key: 'routeStopListModal',
    value: function routeStopListModal(route) {
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.routeStopList(route.routeId, formattedDate, this.model.branch, function (_ref25) {
        var modal = _ref25.modal;

        modal.close();
      }, function (_ref26) {
        var modal = _ref26.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'goToCancelledShipmentTab',
    value: function goToCancelledShipmentTab() {
      this.$state.go('branchManagement.cancelledShipments');
    }
  }, {
    key: 'generateManifest',
    value: function generateManifest(routeDetails, selectPrintOption) {
      // For email options, validate email first
      if (selectPrintOption.startsWith('email')) {
        if (!routeDetails.receiverMail) {
          return this.ngToast.create({
            className: 'danger',
            content: this.$translate.instant('common.enter_valid_email')
          });
        }
      }

      if (selectPrintOption === 'routeSheet') return this.printSheet(routeDetails);
      if (selectPrintOption === 'deliveryManifest') return this.printBatch(routeDetails);
      if (selectPrintOption === 'coinReport') return this.printCoin(routeDetails);
      if (selectPrintOption === 'deliveryManifestAll') return this.printManifestAll(routeDetails);
      if (selectPrintOption === 'deliveryManifestCombined') return this.printDeliveryManifestCombined(routeDetails);
      if (selectPrintOption === 'emailDeliveryManifest') return this.emailManifest(routeDetails, 'printBatch');
      if (selectPrintOption === 'emailDeliveryManifestAll') return this.emailManifest(routeDetails, 'deliveryManifestAll');
      if (selectPrintOption === 'emailDeliveryManifestCombined') return this.emailManifest(routeDetails, 'deliveryManifestCombined');
      if (selectPrintOption === 'emailRouteSheet') return this.emailManifest(routeDetails, 'emailRouteSheet');
    }
  }, {
    key: 'printManifestAll',
    value: function printManifestAll(routeDetails) {
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      var url = this.$state.href('deliveryManifestAll');

      window.w = window.open(url, '_blank');
      window.w.printData = {
        routeId: routeDetails.routeId,
        routeDate: formattedDate
      };
    }
  }, {
    key: 'printBatch',
    value: function printBatch(routeDetails) {
      var _this28 = this;

      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');

      this.ShipmentService.getShipmentsOnRoute(routeDetails.routeId, formattedDate, this.isCoinCheckOut).then(function (data) {
        if (data.results.length) {
          var url = _this28.$state.href('printBatch');
          window.w = window.open(url, '_blank');
          window.w.printData = {
            trackingIds: data.results.map(function (d) {
              return d.trackingId;
            })
          };
        } else {
          var errorMessage = _this28.$translate.instant('routeControl.no_shipment_found', {
            routeId: routeDetails.routeId
          });
          _this28.Modal.errorModal(errorMessage);
        }
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          var errorMessage = _this28.$translate.instant('routeControl.no_shipment_found', {
            routeId: routeDetails.routeId
          });
          _this28.Modal.errorModal(errorMessage);
        }
      });
    }
  }, {
    key: 'pendingCancelShipmentModal',
    value: function pendingCancelShipmentModal(route) {
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.pendingCancelShipments(route.branchId, route.routeId, formattedDate, function (_ref27) {
        var modal = _ref27.modal;

        modal.close();
      }, function (_ref28) {
        var modal = _ref28.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'goToRouteProgress',
    value: function goToRouteProgress(data) {
      document.getElementById('routeProgress').blur();
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      var obj = {
        routeId: data.routeId,
        vaultDate: formattedDate + 'T00:00:00.000Z',
        isRedirected: true
      };
      this.DataCounter.setData(obj);
      this.$state.go('routeProgress');
    }
  }, {
    key: 'showRouteServiceTickets',
    value: function showRouteServiceTickets(route) {
      this.Modal.routeServiceTicketsModal({
        routeId: route.routeId,
        branchId: this.model.branch,
        vaultDate: this.model.date,
        userId: route.messengerId
      }, function () {});
    }
  }, {
    key: 'pickupDeliveryShipmentsModal',
    value: function pickupDeliveryShipmentsModal(route, flagType) {
      // if(route.totalPickupsCount === 0) return;
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.pickupDeliveryShipments(route.branchId, route.routeId, formattedDate, flagType, function (_ref29) {
        var modal = _ref29.modal;

        modal.close();
      }, function (_ref30) {
        var modal = _ref30.modal;

        modal.close();
      });
    }
  }, {
    key: 'duplicateRouteStopList',
    value: function duplicateRouteStopList(data) {
      this.Modal.duplicateRouteStopList(data.routeId, data.duplicateStops, function (_ref31) {
        var modal = _ref31.modal;

        modal.close();
      }, function (_ref32) {
        var modal = _ref32.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'printDeliveryManifestCombined',
    value: function printDeliveryManifestCombined(routeDetails) {
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      var url = this.$state.href('deliveryManifestCombined');
      window.w = window.open(url, '_blank');
      window.w.printData = {
        routeId: routeDetails.routeId,
        routeDate: formattedDate
      };
    }
  }, {
    key: 'handlePrintBatchManifest',
    value: function handlePrintBatchManifest(routeDetails, formattedDate) {
      var _this29 = this;

      return this.ShipmentService.getShipmentsOnRoute(routeDetails.routeId, formattedDate, this.isCoinCheckOut).then(function (data) {
        if (data.results.length) {
          return data.results.map(function (d) {
            return d.trackingId;
          });
        } else {
          var errorMessage = _this29.$translate.instant('routeControl.no_shipment_found', {
            routeId: routeDetails.routeId
          });
          _this29.Modal.errorModal(errorMessage);
          throw new Error(errorMessage);
        }
      });
    }

    // emailManifest(routeDetails, selectPrintOption) {
    //   const deferred = this.$q.defer();
    //   const formattedDate = moment(this.model.date).format('YYYY-MM-DD');

    //   // Handle printBatch case first
    //   if (selectPrintOption === 'printBatch') {
    //     this.handlePrintBatchManifest(routeDetails, formattedDate)
    //       .then((trackingIds) => {
    //         routeDetails.shipments = trackingIds;
    //         return this.sendEmailManifest(routeDetails, selectPrintOption, formattedDate, true);
    //       })
    //       .then((response) => {
    //         routeDetails.isEmailSending = false;
    //         routeDetails.receiverMail = null;
    //         if (response.success) {
    //           this.Modal.confirm({
    //             header: this.$translate.instant('successModal.title'),
    //             message: this.$translate.instant('common.email_sent_success'),
    //             callback: (({ modal }) => {
    //               modal.close();
    //             }),
    //             buttons: ['common.ok'],
    //             type: 'success'
    //           });
    //         }
    //         deferred.resolve();
    //       })
    //       .catch((error) => {
    //         console.error('Error in emailManifest:', error);
    //         routeDetails.isEmailSending = false;
    //         deferred.reject(error);
    //       });
    //   } else {
    //     // Handle other manifest types
    //     this.sendEmailManifest(routeDetails, selectPrintOption, formattedDate, false)
    //       .then((response) => {
    //         routeDetails.isEmailSending = false;
    //         if (response.success) {
    //           this.Modal.confirm({
    //             header: this.$translate.instant('successModal.title'),
    //             message: this.$translate.instant('common.email_sent_success'),
    //             callback: (({ modal }) => {
    //               modal.close();
    //             }),
    //             buttons: ['common.ok'],
    //             type: 'success'
    //           });
    //         }
    //         deferred.resolve();
    //       })
    //       .catch((error) => {
    //         console.error('Error in emailManifest:', error);
    //         routeDetails.isEmailSending = false;
    //         this.Modal.errorModal(this.$translate.instant('common.email_sent_error'));
    //         deferred.reject(error);
    //       })
    //       .finally(() => {
    //         routeDetails.isEmailSending = false;
    //         routeDetails.receiverMail = null;
    //       });
    //   }

    //   return deferred.promise;
    // }

  }, {
    key: 'emailManifest',
    value: function emailManifest(routeDetails, selectPrintOption) {
      var _this30 = this;

      var routeId = routeDetails.routeId;
      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      routeDetails.isEmailSending = true;
      var apiCall = void 0;
      switch (selectPrintOption) {
        case 'deliveryManifestCombined':
          apiCall = this.ShipmentService.deliveryManifestCombined(routeId, formattedDate).then(function (res) {
            var emailData = {
              routeId: routeId,
              vaultDate: formattedDate,
              reportData: res.results,
              receiverEmail: routeDetails.receiverMail,
              branchId: _this30.model.branch,
              title: 'DeliveryManifestCombined'
            };

            return _this30.RouteService.emailManifest(routeId, emailData);
          }).then(function () {
            routeDetails.isEmailSending = false;
            routeDetails.receiverMail = null;
            _this30.Modal.confirm({
              header: _this30.$translate.instant('successModal.title'),
              message: _this30.$translate.instant('common.email_sent_success'),
              callback: function callback(_ref33) {
                var modal = _ref33.modal;

                modal.close();
              },
              buttons: ['common.ok'],
              type: 'success'
            });
          });
          break;

        case 'deliveryManifestAll':
          apiCall = this.ShipmentService.deliveryManifestAll(routeId, formattedDate).then(function (res) {
            var emailData = {
              routeId: routeId,
              vaultDate: formattedDate,
              reportData: res.results,
              receiverEmail: routeDetails.receiverMail,
              branchId: _this30.model.branch,
              title: 'DeliveryManifestAll'
            };

            return _this30.RouteService.emailManifest(routeId, emailData);
          }).then(function () {
            routeDetails.isEmailSending = false;
            routeDetails.receiverMail = null;
            _this30.Modal.confirm({
              header: _this30.$translate.instant('successModal.title'),
              message: _this30.$translate.instant('common.email_sent_success'),
              callback: function callback(_ref34) {
                var modal = _ref34.modal;

                modal.close();
              },
              buttons: ['common.ok'],
              type: 'success'
            });
          });
          break;
        case 'printBatch':
          apiCall = this.ShipmentService.getShipmentsOnRoute(routeId, formattedDate, this.isCoinCheckOut).then(function (data) {
            if (data.results.length) {
              var trackingIds = data.results.map(function (d) {
                return d.trackingId;
              });
              _this30.ShipmentService.batchRecords(trackingIds).then(function (res) {
                var emailData = {
                  routeId: routeId,
                  vaultDate: formattedDate,
                  reportData: res.results,
                  receiverEmail: routeDetails.receiverMail,
                  branchId: _this30.model.branch,
                  title: 'DeliveryManifest'
                };
                _this30.RouteService.emailManifest(routeId, emailData).then(function () {
                  routeDetails.isEmailSending = false;
                  routeDetails.receiverMail = null;
                  _this30.Modal.confirm({
                    header: _this30.$translate.instant('successModal.title'),
                    message: _this30.$translate.instant('common.email_sent_success'),
                    callback: function callback(_ref35) {
                      var modal = _ref35.modal;

                      modal.close();
                    },
                    buttons: ['common.ok'],
                    type: 'success'
                  });
                });
              });
            }
          });

          break;
        case 'emailRouteSheet':
          var payload = {
            routeId: routeId,
            vaultDate: formattedDate,
            receiverEmails: routeDetails.receiverMail,
            branchId: this.model.branch
          };
          apiCall = this.RouteService.emailRouteSheet(routeId, payload).then(function () {
            routeDetails.isEmailSending = false;
            routeDetails.receiverMail = null;
            _this30.Modal.confirm({
              header: _this30.$translate.instant('successModal.title'),
              message: _this30.$translate.instant('common.email_sent_success'),
              callback: function callback(_ref36) {
                var modal = _ref36.modal;

                modal.close();
              },
              buttons: ['common.ok'],
              type: 'success'
            });
          });
          break;
        default:
          apiCall = _promise2.default.reject(new Error('Invalid print option'));
      }

      return apiCall.catch(function (error) {
        console.error('Error in emailManifest:', error);
        routeDetails.isEmailSending = false;
        routeDetails.receiverMail = null;
        _this30.Modal.error({
          title: _this30.$translate.instant('common.error'),
          message: error.message || _this30.$translate.instant('common.something_went_wrong')
        });
      });
    }
  }, {
    key: 'hasValidEmails',
    value: function hasValidEmails(receiverMail) {
      if (!receiverMail) return false;
      var emails = receiverMail.split(',').map(function (email) {
        return email.trim();
      });

      var uniqueEmails = new _set2.default();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(emails), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var email = _step.value;

          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            return false;
          }
          if (uniqueEmails.has(email)) {
            return false;
          }
          uniqueEmails.add(email);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    }
  }, {
    key: 'pendingShipmentTransferModal',
    value: function pendingShipmentTransferModal(route) {
      var _this31 = this;

      var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.pendingShipmentTransfer(route, formattedDate, this.branchDetails.unassignedRouteId, function (_ref37) {
        var modal = _ref37.modal,
            message = _ref37.message;

        if (message === 'TRNASFER_CANCELLED') {
          modal.close();
          _this31.loadRoutes();
          _this31.clear();
        }
        modal.close();
      }, function (_ref38) {
        var modal = _ref38.modal;

        modal.close();
      });
    }

    // sendEmailManifest(routeDetails, selectPrintOption, formattedDate, shipments) {
    //   routeDetails.isEmailSending = true;
    //   const relativeUrl = this.$state.href(selectPrintOption);
    //   const fullUrl = window.location.origin + relativeUrl;
    //   const emailData = {
    //     routeId: routeDetails.routeId,
    //     routeDate: formattedDate,
    //     receiverEmail: routeDetails.receiverMail,
    //     shipments: shipments,
    //     branchId: this.model.branch
    //   };

    //   return this.RouteService.emailManifest(routeDetails.routeId, emailData);
    // }

    // handleEmailClick(route) {

    //   if (this.branchDetails.fromLocation.email) {
    //       route.receiverMail = this.branchDetails.fromLocation.email;
    //   }
    // }

  }, {
    key: 'isUnassignedRoute',
    value: function isUnassignedRoute(route) {
      return route.routeId === (this.branchDetails && this.branchDetails.unassignedRouteId) && route.isSpecialRoute === 1;
    }
  }, {
    key: 'goToAutoRouting',
    value: function goToAutoRouting() {
      var _this32 = this;

      this.autoRouteLoading = true;
      var routes = [];
      this.selectedRouteArr.forEach(function (route, i) {
        var findRoute = _this32.routes.find(function (r) {
          return r.routeId === route && !_this32.isUnassignedRoute(r);
        });
        if (findRoute) {
          routes.push(findRoute);
        }
      });

      var unassignedRouteItem = this.allRoutes.find(function (r) {
        return _this32.isUnassignedRoute(r);
      });
      if (unassignedRouteItem && !routes.find(function (r) {
        return r.routeId === unassignedRouteItem.routeId;
      })) {
        routes.push(unassignedRouteItem);
      }

      this.FetchReactData.setTransitionData({
        selectedRoutes: routes,
        vaultDate: this.model.date,
        branchId: this.model.branch,
        isRedirected: true
      });
      var activeRouteSelected = routes.some(function (r) {
        return !_this32.isUnassignedRoute(r);
      });
      if (!activeRouteSelected) {
        this.Modal.errorModal('Please select at least one route which is not unassigned.');
        this.FetchReactData.clearTransitionData();
        this.autoRouteLoading = false;
        return;
      }
      this.AutomatedRoutingStopsService.assignAutomatedRoutes(routes.map(function (t) {
        return t.routeId;
      }), moment(this.model.date).format("YYYY-MM-DD"), this.model.branch).then(function () {
        var baseUrl = _this32.$window.location.origin;
        var reactUrl = baseUrl + '/v2/index.html#/automated-routing-control';
        _this32.$window.open(reactUrl, "_blank");
      }).catch(function (error) {
        console.log(error);
        _this32.Modal.errorModal(error.data.message || _this32.$translate.instant('common.something_went_wrong'));
        _this32.FetchReactData.clearTransitionData();
      }).finally(function () {
        _this32.autoRouteLoading = false;
      });
    }
  }, {
    key: 'isAllowToAutoRoutingControl',
    value: function isAllowToAutoRoutingControl() {
      var config = this.Configs.getEnvironmentConfig();
      var usersString = config && config.permissions && config.permissions.automatedRoutingControl ? config.permissions.automatedRoutingControl.users : '';
      var hasConfigAutoRoutingPermission = true;
      if (usersString) {
        var userList = usersString.split(',').map(function (u) {
          return u.trim().toLowerCase();
        });
        var firstName = this.User.getUser().firstName ? this.User.getUser().firstName.trim().toLowerCase() : '';
        var lastName = this.User.getUser().lastName ? this.User.getUser().lastName.trim().toLowerCase() : '';

        var nameFormat1 = firstName + ' ' + lastName;
        var nameFormat2 = lastName + ' ' + firstName;
        hasConfigAutoRoutingPermission = userList.includes(nameFormat1) || userList.includes(nameFormat2);
      }
      return hasConfigAutoRoutingPermission;
    }
  }]);
  return RouteControlController;
}();

exports.default = RouteControlController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_progress = __webpack_require__(2017);

var _route_progress2 = _interopRequireDefault(_route_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeProgressModule = angular.module('routeProgress', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/routeProgress');

    $stateProvider.state('routeProgress', {
        url: '/route-progress',
        component: 'routeProgress',
        data: {
            requireLogin: true,
            requireACL: 'route_progress.all'
        },
        parent: 'app'
    });
}]).component('routeProgress', _route_progress2.default).name;

exports.default = routeProgressModule;

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_progress = __webpack_require__(2770);

var _route_progress2 = _interopRequireDefault(_route_progress);

var _route_progress3 = __webpack_require__(2018);

var _route_progress4 = _interopRequireDefault(_route_progress3);

__webpack_require__(3050);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeProgressComponent = {
    restrict: 'E',
    bindings: {},
    template: _route_progress2.default,
    controller: _route_progress4.default
};

exports.default = routeProgressComponent;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _SettingBase = __webpack_require__(34);

var _SettingBase2 = _interopRequireDefault(_SettingBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteProgressController = function () {
    /*@ngInject*/
    RouteProgressController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "SetupService", "RouteService", "$q", "DateUtil", "RouteProgressService", "$rootScope", "DataCounter", "Navigation", "CommonLayoutService", "TimezoneList", "$window"];
    function RouteProgressController(Auth, $state, User, Modal, $translate, SetupService, RouteService, $q, DateUtil, RouteProgressService, $rootScope, DataCounter, Navigation, CommonLayoutService, TimezoneList, $window) {
        (0, _classCallCheck3.default)(this, RouteProgressController);

        this.$state = $state;
        this.User = User;
        this.Modal = Modal;
        this.$translate = $translate;
        this.SetupService = SetupService;
        this.RouteService = RouteService;
        this.$q = $q;
        this.DateUtil = DateUtil;
        this.RouteProgressService = RouteProgressService;
        this.$rootScope = $rootScope;
        this.DataCounter = DataCounter;
        this.Navigation = Navigation;
        this.CommonLayoutService = CommonLayoutService;
        this.$window = $window;
        this.TimezoneList = TimezoneList;

        this.model = {
            vaultDate: '',
            allRoutes: [],
            branch: this.User.getUser().branchId,
            route: null,
            routeStops: [],
            estimatedRouteMilage: {},
            routeDetails: {},
            sortColumn: "_index",
            reverseSort: false,
            estimatedRouteMilageLoading: false,
            estimatedRouteMilageError: null,
            timezone: null,
            timezoneList: this.TimezoneList.getTimezoneList()
        };

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.colorMapping = {
            DO: 'green',
            CANT: 'red',
            PENDING: 'orange',
            PARTIAL: 'orange',
            NO_PICKUP: 'red',
            DELIVERED_NO_PICKUP: 'red',
            NOT: 'red'
        };

        this.mapMarkerFilters = [{
            label: this.$translate.instant('routeProgress.completed'),
            value: ['DO'],
            isChecked: true
        }, {
            label: this.$translate.instant("routeProgress.cant"),
            value: ['CANT'],
            isChecked: true
        }, {
            label: this.$translate.instant('routeProgress.pending'),
            value: ['PENDING', null],
            isChecked: true
        }, {
            label: this.$translate.instant('routeProgress.no_pickup'),
            value: ['NO_PICKUP'],
            isChecked: true
        }, {
            label: this.$translate.instant('routeProgress.completed_no_pickup'),
            value: ['DELIVERED_NO_PICKUP'],
            isChecked: true
        }, {
            label: this.$translate.instant('atm_residual.crv'),
            value: ['CRV'],
            isChecked: true
        }, {
            label: this.$translate.instant('routeProgress.not_worked'),
            value: ['NOT'],
            isChecked: true
        }];
        this.totalRecord = 0;
        this.markerPosition = [];
        this.isInitialized = true;
        this.stackData = [];
        this.branchInfo = '';
        this.routeDataObj = {};
        this.$rootScope.$broadcast('routeChange', '/app/route-progress');
    }

    (0, _createClass3.default)(RouteProgressController, [{
        key: 'loadImage',
        value: function loadImage(image) {
            this.icon = {
                'REGULAR': 'regular.png',
                'ATM': 'atm.png',
                'BANK': 'bank.png',
                'NO_SHIP_NO_GO': 'nsng.png',
                'INTERNAL': 'internal.png',
                'TRUCK': 'truck.png',
                'TANKER': 'tanker.png',
                'WINDOW': 'window.png',
                'CARRIER': 'carrier.png',
                'ON_CALL': 'oncall.png',
                'LOCKER': 'locker.png',
                'VAULT': 'vault.png',
                'DELIVERY': 'delivery.png'
            };

            var imgURL = this.icon[image];
            return __webpack_require__(51)("./" + imgURL);
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$q.all([this.SetupService.get(this.model.branch)]).then(function (data) {
                _this.routeDataObj = _this.DataCounter.getData();
                _this.branchInfo = data[0];
                _this.model.timezone = _this.model.timezoneList.find(function (timezone) {
                    return timezone.value === moment.tz.guess();
                }).value;
                var branchVaultDate = _this.routeDataObj && _this.routeDataObj.isRedirected ? _this.routeDataObj.vaultDate : data[0].currentVaultDate;
                var date = _this.DateUtil.convertToDate(branchVaultDate);
                _this.model.date = date;
                _this.vaultDate = moment(_this.model.date).format('YYYY-MM-DD');
                _this.minVaultDate = {
                    maxDate: _this.vaultDate
                };
            }).then(function () {
                _this.loadRoutes().then(function () {
                    return _this.autoSetAndLoadData();
                });
                // this.loadMap();
            });
        }
    }, {
        key: 'loadMap',
        value: function loadMap(routeSequenceData) {
            this.routePosition = 0;
            this.centerLattitude = this.lat / this.totalLatLongLocations || 39.68649209557518;
            this.centerLongitude = this.long / this.totalLatLongLocations || -101.48273981764913;
            this.mapMarkerFilters.forEach(function (obj) {
                return obj.isChecked = true;
            });
            if (this.isInitialized) {
                this.map = L.map('map', {
                    // center: [this.centerLattitude, this.centerLongitude],
                    // zoom: 11
                });

                var fallbackLatLong = [this.branchInfo.gpsLat, this.branchInfo.gpsLong];
                if (this.stopsInfo) {
                    var truckCoordinatesInfo = this.stopsInfo.truckCoordinatesInfo[0] || {};
                    var userCoordinatesInfo = this.stopsInfo.userCoordinatesInfo ? this.stopsInfo.userCoordinatesInfo[0] || {} : {};
                    if (truckCoordinatesInfo.lat && truckCoordinatesInfo.long) {
                        fallbackLatLong = [truckCoordinatesInfo.lat, truckCoordinatesInfo.long];
                    } else if (userCoordinatesInfo.lat && userCoordinatesInfo.long && (!userCoordinatesInfo.userOrigin || userCoordinatesInfo.userOrigin === 'USER')) {
                        fallbackLatLong = [userCoordinatesInfo.lat, userCoordinatesInfo.long];
                    }
                }
                this.map.fitBounds(this.locationLatLong.length ? this.locationLatLong : [fallbackLatLong]);

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }).addTo(this.map);
            }
            this.manageMarkers();
        }
    }, {
        key: 'manageMarkers',
        value: function manageMarkers(i) {
            var _this2 = this;

            var activeMarkers = [],
                cursor = 0;

            if (i >= 0 && this.mapMarkerFilters[i]) {
                this.mapMarkerFilters[i].isChecked = !this.mapMarkerFilters[i].isChecked;
            }
            if (this.markerPosition && this.markerPosition.length) {
                this.markerPosition.forEach(function (marker) {
                    _this2.map.removeLayer(marker);
                });
            }

            this.mapMarkerFilters.forEach(function (obj) {
                if (obj.isChecked) activeMarkers = activeMarkers.concat(obj.value);
            });
            this.model.routeStops.forEach(function (sequenceData, index) {
                if (sequenceData && sequenceData.lat && sequenceData.long && activeMarkers.indexOf(sequenceData.stopStatus) >= 0) {
                    // this.routePosition = _.findIndex(routeSequenceData, { locationId: sequenceData.locationId }) + 1;
                    _this2.markerColor = sequenceData.stopStatus ? _this2.colorMapping[sequenceData.stopStatus] : 'blue';
                    _this2.actualLat = sequenceData.lat;
                    _this2.actualLong = sequenceData.long;

                    _this2.locationInfo = '<strong>' + sequenceData.name + '</strong>' + '<br>' + sequenceData.address + ' - ' + sequenceData.zip + '<br>' + sequenceData.city + ', ' + sequenceData.state;
                    if (sequenceData.completedTime) _this2.locationInfo = _this2.locationInfo.concat(', ', '<br>', '<strong>', moment(sequenceData.completedTime).format('YYYY-MM-DD hh:mm a'), '</strong>');
                    var id = L.marker([_this2.actualLat, _this2.actualLong], {
                        icon: new L.AwesomeNumberMarkers({
                            // number: index + 1,
                            number: sequenceData.routeSeq = sequenceData._index, //=== -1 ? 'ST' : sequenceData.routeSeq,
                            markerColor: _this2.markerColor
                        })
                    }).addTo(_this2.map).bindPopup(_this2.locationInfo);

                    id.on('mouseover', function () {
                        id.openPopup();
                    });

                    id.on('mouseout', function () {
                        id.closePopup();
                    });

                    _this2.markerPosition.push(id);
                }
            });

            var waypoints = this.model.coordinates.map(function (c) {
                return L.latLng(c.latlng);
            });
            L.polyline(waypoints, { color: "#40826D" }).addTo(this.map);

            function createArrowIcon(degree) {
                return L.divIcon({
                    className: 'custom-icon',
                    html: '<div style="transform: rotate(' + degree + 'deg);"><img src="../../assets/images/direction.png" class="direction-icon" /></div>',
                    iconSize: [22, 22],
                    iconAnchor: [11, 11]
                });
            }

            this.model.coordinates.forEach(function (point) {
                if (!point.direction || point.direction == -1) return;
                cursor++;
                var latLng = point.latlng;
                var arrowMarker = L.marker(latLng, { icon: createArrowIcon(point.direction) });
                arrowMarker.addTo(_this2.map);
            });

            if (cursor === 0) {
                var someFeatures = [];

                this.model.coordinates.map(function (c) {
                    someFeatures.push({
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates": [c.latlng[1], c.latlng[0]]
                        }
                    });
                });

                var geojsonMarkerOptions = {
                    radius: 4,
                    fillColor: "#40826D",
                    color: "#000",
                    weight: 1,
                    opacity: 1,
                    fillOpacity: 0.8
                };

                L.geoJSON(someFeatures, {
                    pointToLayer: function pointToLayer(feature, latlng) {
                        return L.circleMarker(latlng, geojsonMarkerOptions);
                    }
                }).addTo(this.map);
            }
        }
    }, {
        key: 'loadRoutes',
        value: function loadRoutes() {
            var _this3 = this;

            var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
            this.gettingRoutes = true;
            return this.RouteService.getActiveRoutes(this.model.branch, formattedDate).then(function (res) {
                if (res.results.length) {
                    _this3.model.allRoutes = res.results;
                } else {
                    _this3.model.allRoutes = [];
                }
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this3.gettingRoutes = false;
            });
        }
    }, {
        key: 'getRouteStops',
        value: function getRouteStops() {
            var _this4 = this;

            this.model.routeStartTime = null;
            this.model.allRoutes.find(function (route) {
                if (route.routeId == _this4.model.route && route.routeBeginTime) {
                    var utcRouteTime = moment.utc(route.routeBeginTime, "HH:mm:ss");
                    _this4.model.routeStartTime = utcRouteTime.tz(_this4.model.timezone).format();
                }
            });
            var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
            this.model.loading = true;
            this.lat = 0;
            this.long = 0;
            this.totalLatLongLocations = 0;
            this.stopsInfo = "";
            this.locationLatLong = [];

            this.RouteProgressService.getRouteStops(this.model.route, formattedDate, this.model.branch).then(function (data) {
                var routeProgressData = _.orderBy(data.results, ['completedTime'], ['asc']);
                _this4.model.routeStops = data.results;
                _this4.model.coordinates = data.coordinates;
                _this4.model.routeDetails = data.routeDetails;
                _this4.model.routeDetails.complTime = moment(_this4.model.routeDetails.complTime).utc(true).format('hh:mm a');

                _this4.model.routeStops.forEach(function (j) {
                    routeProgressData.forEach(function (k, index) {
                        if (j.completedTime && k.completedTime && j.locationId == k.locationId) {
                            j.stopProcessOrder = index + 1;
                        }
                    });
                });

                _this4.stopsInfo = data;
                if (_this4.model.routeStops.length) {
                    _this4.model.routeStops.forEach(function (data, index) {
                        if (data.lat && data.long) {
                            _this4.locationLatLong.push(new Array(data.lat, data.long));
                            _this4.totalLatLongLocations += 1; // locations which had lat, long value counted as totalLatLongLocations
                            _this4.lat += data.lat; // sum of Lattitude value of location 
                            _this4.long += data.long; //  sum of Longitude value of location 
                        }
                    });
                }
                _this4.resetSorting();
                _this4.model.estimatedRouteMilage = {};
                _this4.model.estimatedRouteMilageError = null;
                _this4.checkCache();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    return _this4.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                if (_this4.mapLoadingTimeout) {
                    clearTimeout(_this4.mapLoadingTimeout);
                }
                _this4.safeReloadMapContainer();
                _this4.mapLoadingTimeout = setTimeout(function () {
                    if (_this4.model.routeStops.length) {
                        _this4.loadMap(_this4.model.routeStops);
                        _this4.addBranchDetails();
                    }
                }, 100);
                _this4.stacked();
                _this4.resetRedirectionData();
                _this4.model.loading = false;
            });
        }
    }, {
        key: 'reloadMapContainer',
        value: function reloadMapContainer() {
            var _this5 = this;

            this.map.remove();
            this.isInitialized = true;
            this.markerPosition.forEach(function (id) {
                _this5.map.removeLayer(id);
            });
            this.markerPosition = [];
        }
    }, {
        key: 'safeReloadMapContainer',
        value: function safeReloadMapContainer() {
            if (this.map) {
                this.map.remove();
                this.map = null;
            }
            this.isInitialized = true;
            this.markerPosition = [];
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            this.model.route = null;
            this.model.routeStops = [];
        }
    }, {
        key: 'refreshData',
        value: function refreshData() {
            this.getRouteStops();
        }
    }, {
        key: 'goToRouteTab',
        value: function goToRouteTab() {
            var date = moment(this.model.date).format('YYYY-MM-DD');
            var obj = {
                routeId: this.model.route,
                vaultDate: date + 'T00:00:00.000Z',
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.routes');
        }
    }, {
        key: 'goToItemHold',
        value: function goToItemHold(trackingId) {
            var obj = {
                trackingId: trackingId,
                isRedirected: true
            };
            this.DataCounter.setData(obj);
            this.$state.go('branchManagement.itemHolds');
        }
    }, {
        key: 'getStopStatus',
        value: function getStopStatus(data) {
            if (data && !data.stopStatus && !data.completedTime || data.stopStatus === 'PENDING') return this.$translate.instant('routeProgress.pending');else if (data.completedTime && data.stopStatus === 'PARTIAL') return this.$translate.instant('routeProgress.partial');else if (data && data.stopStatus === 'DO') return this.$translate.instant('routeProgress.completed');
            // else if (data && data.stopStatus === 'CANT' && data.totalTransactionRecords === 0) return this.$translate.instant('routeProgress.cant');
            else if (data && data.stopStatus === 'CANT' && (data.totalTransactionRecords > 0 || data.totalTransactionRecords === 0)) return this.$translate.instant('routeProgress.cant').toUpperCase();else if (data.completedTime && data.stopStatus === 'NO_PICKUP') return this.$translate.instant('routeProgress.no_pickup');
                // else if (data.completedTime && data.stopStatus === 'DELIVERED_NO_PICKUP') return this.$translate.instant('routeProgress.delivered_no_pickup');
                else if (data.completedTime && data.stopStatus === 'DELIVERED_NO_PICKUP') return this.$translate.instant('routeProgress.completed_no_pickup');else if (data.completedTime && data.stopStatus === 'CRV') return this.$translate.instant('shipment.CRVed');else if (data.completedTime && data.stopStatus === 'NOT') return this.$translate.instant('routeProgress.not_worked');else return;
        }
    }, {
        key: 'stacked',
        value: function stacked() {
            this.stackData = [];
            var totalRemaining = 0;
            var totalDelivered = 0;
            var cantProcessed = 0;
            var notWorked = 0;
            // let CRVed = 0;

            this.model.routeStops.forEach(function (data) {
                if (data && !data.stopStatus && !data.completedTime) totalRemaining++;else if (data && data.stopStatus === 'NOT') notWorked++;else if (data && data.stopStatus === 'DO') totalDelivered++;
                // else if (data && data.stopStatus === 'CRV') CRVed++;
                else if (data && (data.stopStatus === 'CANT' || data.stopStatus === 'PENDING' || data.stopStatus === 'PARTIAL' || data.stopStatus === 'NO_PICKUP' || data.stopStatus === 'DELIVERED_NO_PICKUP' || data.stopStatus === 'CRV')) return cantProcessed++;
            });

            this.stackData.push({ value: totalRemaining, type: 'info' }, { value: totalDelivered, type: 'success' }, { value: notWorked, type: 'danger' },
            // { value: CRVed, type: 'warning' },
            { value: cantProcessed, type: 'warning' });
        }
    }, {
        key: 'goToUserTab',
        value: function goToUserTab(id) {
            return this.Navigation.goToUserTab(id, null);
        }
    }, {
        key: 'addBranchDetails',
        value: function addBranchDetails() {
            var locationLat = void 0,
                locationLong = void 0,
                iconNumber = void 0,
                iconColor = void 0,
                locationInfo = void 0;
            var truckCoordinatesInfo = this.stopsInfo.truckCoordinatesInfo[0] || {};
            var userCoordinatesInfo = this.stopsInfo.userCoordinatesInfo && this.stopsInfo.userCoordinatesInfo[0] || {};
            var isUserOriginMismatch = userCoordinatesInfo.id && userCoordinatesInfo.userOrigin && userCoordinatesInfo.userOrigin !== 'USER';
            if (truckCoordinatesInfo.id) {
                locationLat = truckCoordinatesInfo.lat;
                locationLong = truckCoordinatesInfo.long;
                iconNumber = 'T';
                iconColor = 'black';
                locationInfo = '<strong>' + truckCoordinatesInfo.id + '</strong><br>' + truckCoordinatesInfo.address + ' - ' + truckCoordinatesInfo.zip + '<br>' + truckCoordinatesInfo.city + ', ' + truckCoordinatesInfo.state;
            } else if (userCoordinatesInfo.id && !isUserOriginMismatch) {
                locationLat = userCoordinatesInfo.lat;
                locationLong = userCoordinatesInfo.long;
                iconNumber = 'U';
                iconColor = 'black';
                locationInfo = '<strong>' + userCoordinatesInfo.id + '</strong><br>' + userCoordinatesInfo.address + ' - ' + userCoordinatesInfo.zip + '<br>' + userCoordinatesInfo.city + ', ' + userCoordinatesInfo.state;
            } else {
                locationLat = this.branchInfo.gpsLat;
                locationLong = this.branchInfo.gpsLong;
                iconNumber = 'B';
                iconColor = 'black';
                locationInfo = '<strong>' + this.branchInfo.branchId + '</strong><br>' + this.branchInfo.address + ' - ' + this.branchInfo.zip + '<br>' + this.branchInfo.city + ', ' + this.branchInfo.state;
            }
            var id = L.marker([locationLat, locationLong], {
                icon: new L.AwesomeNumberMarkers({
                    number: iconNumber,
                    markerColor: iconColor
                })
            }).addTo(this.map).bindPopup(locationInfo);

            id.on('mouseover', function () {
                id.openPopup();
            });

            id.on('mouseout', function () {
                id.closePopup();
            });
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(locationId) {
            return this.Navigation.goToServiceHistory(locationId, null, true, null);
        }
    }, {
        key: 'sortData',
        value: function sortData(column) {
            this.model.reverseSort = this.model.sortColumn == column ? !this.model.reverseSort : false;
            this.model.sortColumn = column;
        }
    }, {
        key: 'resetSorting',
        value: function resetSorting() {
            this.model.sortColumn = '_index';
            this.model.reverseSort = false;
            // this.getEstimatedRouteMilage();
        }
    }, {
        key: 'getComments',
        value: function getComments(data, comments) {
            var locationId = data.locationId;
            this.Modal.confirm({
                header: this.$translate.instant('common.comment') + ' | ' + locationId,
                message: comments,
                callback: function callback(_ref) {
                    var modal = _ref.modal;

                    modal.close();
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    modal.close();
                },
                buttons: ['routeSheet.close'],
                type: 'success'
            });
        }
    }, {
        key: 'autoSetAndLoadData',
        value: function autoSetAndLoadData() {
            if (this.routeDataObj && this.routeDataObj.isRedirected) {
                this.model.date = this.DateUtil.convertToDate(this.routeDataObj.vaultDate);
                this.model.route = this.routeDataObj.routeId;
                this.getRouteStops();
            }
        }
    }, {
        key: 'resetRedirectionData',
        value: function resetRedirectionData() {
            if (this.routeDataObj) {
                this.routeDataObj.isRedirected = false;
                this.routeDataObj = this.DataCounter.setData();
            }
        }
    }, {
        key: 'stopCommentsModal',
        value: function stopCommentsModal(obj) {
            var formattedDate = moment(this.model.date).format('YYYY-MM-DD');
            this.Modal.stopComments(obj.routeId, formattedDate, obj.locationId, function (_ref3) {
                var modal = _ref3.modal;

                modal.close();
            }, function (_ref4) {
                var modal = _ref4.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'redirectToHistoryTab',
        value: function redirectToHistoryTab(data) {
            if (data.totalPickupShipments == 0) return;

            if (data.totalPickupShipments > 1) {
                return this.$window.open('/app/branch-management/locations-history?locationId=' + data.locationId, '_blank');
            } else {
                return this.$window.open('/app/branch-management/shipment-history/' + data.pickupTrackingIds, '_blank');
            }
        }
    }, {
        key: 'getMilagePayload',
        value: function getMilagePayload() {
            if (this.model.routeDetails.arrTime) return;
            if (this.model.routeStops.length == 0) return;

            var stopsToSend = void 0;
            var allCompleted = this.model.routeStops.every(function (s) {
                return s.completedTime;
            });
            if (!this.model.routeDetails.arrTime && allCompleted) {
                // only last stop
                var last = this.model.routeStops[this.model.routeStops.length - 1];
                stopsToSend = [{
                    name: last.locationId,
                    lat: last.lat,
                    long: last.long,
                    targetStopTime: last.targetStopTime
                }];
            } else {
                // your existing logic
                stopsToSend = this.model.routeStops.filter(function (item) {
                    return !item.completedTime;
                }).map(function (item) {
                    return {
                        name: item.locationId,
                        lat: item.lat,
                        long: item.long,
                        targetStopTime: item.targetStopTime
                    };
                });
            }
            var tempRouteStops = angular.copy(this.model.routeStops);
            var startPoint = void 0;
            var routeStarted = !!this.model.routeDetails.leaveTime;
            var truckCoordinatesInfo = this.stopsInfo.truckCoordinatesInfo[0] || {};
            var userCoordinatesInfo = this.stopsInfo.userCoordinatesInfo && this.stopsInfo.userCoordinatesInfo[0] || {};
            var routeOrigination = this.model.routeDetails.origination || (truckCoordinatesInfo.id ? 'TRUCK' : userCoordinatesInfo.id ? 'USER' : 'BRANCH');
            var fallbackStartPoint = truckCoordinatesInfo.id ? {
                name: truckCoordinatesInfo.id,
                lat: truckCoordinatesInfo.lat,
                long: truckCoordinatesInfo.long,
                origination: 'TRUCK'
            } : userCoordinatesInfo.id ? {
                name: userCoordinatesInfo.id,
                lat: userCoordinatesInfo.lat,
                long: userCoordinatesInfo.long,
                origination: 'USER'
            } : {
                name: this.model.branch,
                lat: this.branchInfo.gpsLat,
                long: this.branchInfo.gpsLong,
                origination: 'BRANCH'
            };
            if (routeStarted) {
                var lastCompletedStop = tempRouteStops.slice().reverse().find(function (item) {
                    return item.completedTime;
                });

                if (lastCompletedStop) {
                    startPoint = {
                        name: lastCompletedStop.locationId,
                        lat: lastCompletedStop.lat,
                        long: lastCompletedStop.long,
                        completedTime: lastCompletedStop.completedTime
                    };
                } else {
                    startPoint = fallbackStartPoint;
                }
            } else {
                startPoint = fallbackStartPoint;
            };

            return {
                branch: {
                    name: this.model.branch,
                    coords: {
                        lat: this.branchInfo.gpsLat,
                        long: this.branchInfo.gpsLong
                    }
                },
                stops: stopsToSend.filter(function (stop) {
                    return stop.lat && stop.long;
                }),
                route: {
                    name: this.model.route
                },
                startPoint: {
                    name: startPoint.name,
                    lat: startPoint.lat,
                    long: startPoint.long,
                    origination: startPoint.origination || routeOrigination,
                    completedTime: startPoint.completedTime || null
                },
                deliveryDate: moment(this.model.date).format('YYYY-MM-DD'),
                branchTimezone: this.branchInfo.timezone,
                totalStops: this.model.routeStops.length,
                completedStops: this.model.routeStops.filter(function (item) {
                    return item.completedTime;
                }).length,
                isRouteProgress: true
            };
        }
    }, {
        key: 'checkCache',
        value: function checkCache() {
            var _this6 = this;

            var payload = this.getMilagePayload();
            if (!payload || !payload.stops.length) return;
            payload.checkCacheOnly = true;
            this.RouteProgressService.getEstimatedRouteMileage(payload).then(function (res) {
                if (res && (res.results || res.data || res.routeAnalysis)) {
                    // Cache hit, process the data
                    _this6.handleMileageResponse(res);
                }
            }).catch(function (err) {
                console.log('Error checking cache:', err);
            });
        }
    }, {
        key: 'handleMileageResponse',
        value: function handleMileageResponse(res) {
            var _this7 = this;

            var mileageData = res.data ? res.data : res.results ? res.results.data : res;
            this.model.estimatedRouteMilage = mileageData;

            var activeRoute = null;
            if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.ActiveRoutes && mileageData.routeAnalysis.ActiveRoutes.length > 0) {
                activeRoute = mileageData.routeAnalysis.ActiveRoutes[0];
            }

            var formattedTime = 'N/A';
            var totalDistance = 'N/A';

            if (activeRoute && activeRoute.Summary) {
                formattedTime = this.DateUtil.convertToTimeFormat(activeRoute.Summary.TotalTimeByHours);
                totalDistance = activeRoute.Summary.DistanceMiles;
            } else if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.routesSummary) {
                totalDistance = mileageData.routeAnalysis.routesSummary.TotalFleetDistanceMiles;
            } else if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.OverallSummary) {
                // Fallback for old format
                formattedTime = mileageData.routeAnalysis.OverallSummary.TotalTimeInService || this.DateUtil.convertToTimeFormat(mileageData.routeAnalysis.OverallSummary.TotalDurationHours);
                totalDistance = mileageData.routeAnalysis.OverallSummary.TotalDistanceMiles;
            }

            if (this.model.estimatedRouteMilage && this.model.estimatedRouteMilage.routeAnalysis) {
                this.model.estimatedRouteMilage.routeAnalysis.OverallSummary = {
                    TotalTimeInService: formattedTime,
                    TotalDistanceMiles: totalDistance
                };
            }

            this.model.routeStops.forEach(function (stop) {
                var stopDuration = null;
                if (activeRoute && activeRoute.Schedule) {
                    stopDuration = activeRoute.Schedule.find(function (item) {
                        return item.ShipmentLabel == stop.locationId;
                    });
                } else if (_this7.model.estimatedRouteMilage && _this7.model.estimatedRouteMilage.routeAnalysis && _this7.model.estimatedRouteMilage.routeAnalysis.Schedule) {
                    // Fallback for old format
                    stopDuration = _this7.model.estimatedRouteMilage.routeAnalysis.Schedule.find(function (item) {
                        return item.ShipmentLabel == stop.locationId;
                    });
                }

                if (!stopDuration) {
                    stop.estimatedTimeArrival = null;
                    stop.StopNumber = "End";
                } else {
                    stop.estimatedTimeArrival = stopDuration.ScheduledStartTime;
                    stop.StopNumber = stopDuration.StopNumber;
                }
            });

            this.model.routeStops.sort(function (a, b) {
                if (a.completedTime && !b.completedTime) return -1;
                if (!a.completedTime && b.completedTime) return 1;

                if (a.StopNumber === 'End') return 1;
                if (b.StopNumber === 'End') return -1;
                return a.StopNumber - b.StopNumber;
            });

            this.model.routeStops.forEach(function (stop, index) {
                stop._index = index + 1;
            });

            if (this.mapLoadingTimeout) {
                clearTimeout(this.mapLoadingTimeout);
            }
            this.safeReloadMapContainer();
            this.mapLoadingTimeout = setTimeout(function () {

                if (_this7.model.routeStops.length) {
                    _this7.loadMap(_this7.model.routeStops);
                    _this7.addBranchDetails();
                }
            }, 100);
            this.stacked();
            this.resetRedirectionData();
            this.model.loading = false;
            this.model.estimatedRouteMilageLoading = false;
        }
    }, {
        key: 'getEstimatedRouteMilage',
        value: function getEstimatedRouteMilage() {
            var _this8 = this;

            if (this.model.routeDetails.arrTime) return;
            if (this.model.routeStops.length == 0) {
                if (this.model.estimatedRouteMilage && this.model.estimatedRouteMilage.routeAnalysis && this.model.estimatedRouteMilage.routeAnalysis.OverallSummary) {
                    this.model.estimatedRouteMilage.routeAnalysis.OverallSummary.TotalTimeInService = 'N/A';
                    this.model.estimatedRouteMilage.routeAnalysis.OverallSummary.TotalDistanceMiles = 'N/A';
                }
                this.model.estimatedRouteMilageLoading = false;
                this.model.loading = false;
                return;
            };
            this.model.estimatedRouteMilageLoading = true;

            var payload = this.getMilagePayload();
            if (!payload) {
                this.model.estimatedRouteMilageLoading = false;
                return;
            }
            this.RouteProgressService.getEstimatedRouteMileage(payload).then(function (res) {
                _this8.handleMileageResponse(res);
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this8.model.estimatedRouteMilageError = err.data.message ? err.data.message : 'Get Estimated Route Mileage Error';
                }
                _this8.model.loading = false;
                _this8.model.estimatedRouteMilageLoading = false;
            });
        }
    }, {
        key: 'getRouteEditDay',
        value: function getRouteEditDay() {
            return this.model.date ? moment(this.model.date).format('ddd') : '';
        }
    }, {
        key: 'calculateTotalTime',
        value: function calculateTotalTime(arriveTime, leaveTime) {
            var arriveDate = moment(arriveTime);
            var leaveDate = moment(leaveTime);

            var duration = moment.duration(arriveDate.diff(leaveDate));

            var hours = duration.asHours();
            var minutes = duration.minutes();
            var seconds = duration.seconds();

            return Number(hours).toFixed(0) + ' hours, ' + Number(minutes).toFixed(0) + ' minutes, ' + Number(seconds).toFixed(0) + ' seconds';
        }
    }, {
        key: 'formatMiles',
        value: function formatMiles(miles) {
            if (!miles) return 0;
            return parseFloat(miles).toLocaleString() || 0;
        }
    }]);
    return RouteProgressController;
}();

exports.default = RouteProgressController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_stats = __webpack_require__(2020);

var _route_stats2 = _interopRequireDefault(_route_stats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeStatsModule = angular.module('routeStats', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/routeStats');

    $stateProvider.state('routeStats', {
        url: '/route-stats',
        component: 'routeStats',
        data: {
            requireLogin: true,
            requireACL: 'route_stats.all'
        },
        parent: 'app'
    });
}]).component('routeStats', _route_stats2.default).name;

exports.default = routeStatsModule;

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _route_stats = __webpack_require__(2771);

var _route_stats2 = _interopRequireDefault(_route_stats);

var _route_stats3 = __webpack_require__(2021);

var _route_stats4 = _interopRequireDefault(_route_stats3);

__webpack_require__(3051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeStatsComponent = {
    restrict: 'E',
    bindings: {},
    template: _route_stats2.default,
    controller: _route_stats4.default
};

exports.default = routeStatsComponent;

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _SettingBase = __webpack_require__(34);

var _SettingBase2 = _interopRequireDefault(_SettingBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteStatsController = function () {
    /*@ngInject*/
    RouteStatsController.$inject = ["Auth", "$scope", "$state", "User", "Modal", "$uibModal", "$translate", "SetupService", "RouteService", "RouteStatsService", "$q", "DateUtil", "RouteProgressService", "VaultOperationsService", "$rootScope", "DataCounter", "Navigation", "CommonLayoutService", "UserBranchService"];
    function RouteStatsController(Auth, $scope, $state, User, Modal, $uibModal, $translate, SetupService, RouteService, RouteStatsService, $q, DateUtil, RouteProgressService, VaultOperationsService, $rootScope, DataCounter, Navigation, CommonLayoutService, UserBranchService) {
        (0, _classCallCheck3.default)(this, RouteStatsController);

        this.$state = $state;
        this.User = User;
        this.Modal = Modal;
        this.$translate = $translate;
        this.SetupService = SetupService;
        this.RouteService = RouteService;
        this.RouteStatsService = RouteStatsService;
        this.$q = $q;
        this.DateUtil = DateUtil;
        this.RouteProgressService = RouteProgressService;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.DataCounter = DataCounter;
        this.Navigation = Navigation;
        this.VaultOperationsService = VaultOperationsService;
        this.CommonLayoutService = CommonLayoutService;
        this.UserBranchService = UserBranchService;

        this.model = {
            vaultDate: null,
            allRoutes: [],
            totalRoutes: 0,
            branch: this.User.getUser().branchId,
            selectedRoute: {},
            route: null,
            routeStops: [],
            infoWindowLoading: false,
            loadingMap: false,
            shipmentServiceTickets: [],
            selectedBranch: '',
            branchObj: {
                results: [],
                totalRecords: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                searchText: null
            },
            routeListObj: {
                loading: false,
                results: [],
                totalRecords: 0
            },
            loggedInUser: User.getUser().id,
            isExporting: false
        };

        this.colorMapping = {
            DO: 'green',
            CANT: 'red',
            PENDING: 'orange',
            PARTIAL: 'orange',
            NO_PICKUP: 'red',
            DELIVERED_NO_PICKUP: 'red'
        };

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };
        this.showShipmentSidebar = false;
        this.markerPosition = [];
        this.isInitialized = true;
        this.routeDataObj = {};
        this.branchInfo = null;
        this.$rootScope.$broadcast('routeChange', '/app/route-stats');
    }

    (0, _createClass3.default)(RouteStatsController, [{
        key: 'loadImage',
        value: function loadImage(image) {
            this.icon = {
                'REGULAR': 'regular.png',
                'ATM': 'atm.png',
                'BANK': 'bank.png',
                'NO_SHIP_NO_GO': 'nsng.png',
                'INTERNAL': 'internal.png',
                'TRUCK': 'truck.png',
                'TANKER': 'tanker.png',
                'WINDOW': 'window.png',
                'CARRIER': 'carrier.png',
                'ON_CALL': 'oncall.png',
                'LOCKER': 'locker.png',
                'VAULT': 'vault.png',
                'DELIVERY': 'delivery.png'
            };

            var imgURL = this.icon[image];
            return __webpack_require__(51)("./" + imgURL);
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$q.all([this.SetupService.get(this.model.branch), this.UserBranchService.getUserBranches(this.model.loggedInUser)
            //this.getRouteList()
            ]).then(function (data) {
                setTimeout(function () {
                    _this.branchInfo = data[0];
                    var date = _this.DateUtil.convertToDate(data[0].currentVaultDate);
                    _this.vaultDate = moment(date).format('YYYY-MM-DD');

                    _this.model.branchObj.results = data[1].results;
                    _this.model.branchObj.results.forEach(function (branch) {
                        if (branch.branchId == _this.model.branch) {
                            branch.ticked = true;
                        }
                    });
                    _this.getRouteList();
                    _this.filterRouteList();
                    _this.loadMap();
                    _this.$scope.$apply();
                });
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'loadMap',
        value: function loadMap() {
            this.routePosition = 0;
            this.centerLattitude = this.lat / this.totalLatLongLocations || 28.635308;
            this.centerLongitude = this.long / this.totalLatLongLocations || 77.70641;

            if (this.isInitialized) {
                this.map = L.map('map', {
                    center: [this.centerLattitude, this.centerLongitude],
                    zoom: 11
                });

                // this.map.fitBounds(this.locationLatLong.length ? this.locationLatLong : [[this.branchInfo.gpsLat, this.branchInfo.gpsLong]]);
                if (this.locationLatLong && this.locationLatLong.length) {
                    this.map.fitBounds(this.locationLatLong);
                }

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }).addTo(this.map);
            }
            this.manageMarkers();
            // this.drawRoute()
        }
    }, {
        key: 'drawRoute',
        value: function drawRoute() {
            var pointA = new L.LatLng(28.635308, 77.22496);
            var pointB = new L.LatLng(28.984461, 77.70641);
            var pointList = [pointA, pointB];

            var firstpolyline = new L.Routing(pointList, {
                color: 'black',
                weight: 3,
                opacity: 0.5,
                smoothFactor: 1
            });
            firstpolyline.addTo(this.map);
        }
    }, {
        key: 'manageMarkers',
        value: function manageMarkers() {
            var _this2 = this;

            if (this.markerPosition && this.markerPosition.length) {
                this.markerPosition.forEach(function (marker) {
                    _this2.map.removeLayer(marker);
                });
            }

            this.model.routeStops.forEach(function (sequenceData, index) {
                if (sequenceData && sequenceData.lat && sequenceData.long) {
                    // this.routePosition = _.findIndex(routeSequenceData, { locationId: sequenceData.locationId }) + 1;
                    _this2.markerColor = sequenceData.stopStatus ? _this2.colorMapping[sequenceData.stopStatus] : 'blue';
                    _this2.actualLat = sequenceData.lat;
                    _this2.actualLong = sequenceData.long;

                    _this2.locationInfo = '<strong>' + _.cloneDeep(sequenceData.routeSeq) + '</strong> | ' + '<strong>' + sequenceData.name + '</strong>' + '<br>' + sequenceData.address + ' - ' + sequenceData.zip + '<br>' + sequenceData.city + ', ' + sequenceData.state;
                    if (sequenceData.completedTime) _this2.locationInfo = _this2.locationInfo.concat(', ', '<br>', '<strong>', moment(sequenceData.completedTime).format('YYYY-MM-DD hh:mm a'), '</strong>');
                    var id = L.marker([_this2.actualLat, _this2.actualLong], {
                        icon: new L.AwesomeNumberMarkers({
                            // number: index + 1,
                            number: sequenceData.routeSeq = sequenceData._index, //=== -1 ? 'ST' : sequenceData.routeSeq,
                            markerColor: _this2.markerColor
                        })
                    }).addTo(_this2.map).bindPopup(_this2.locationInfo);

                    id.on('mouseover', function () {
                        id.openPopup();
                    });

                    id.on('mouseout', function () {
                        id.closePopup();
                    });
                    id.on('click', function () {
                        if (_this2.model.infoWindowLoading) return;
                        _this2.openNav();
                        _this2.model.infoWindowLoading = true;
                        _this2.model.selectedLocation = sequenceData;
                        _this2.showShipmentSidebar = true;
                        _this2.getRouteShipmentDetail();
                        // setTimeout(() => {
                        //     this.model.infoWindowLoading = false;
                        //     this.$scope.$apply()
                        // }, 1500)
                    });

                    _this2.markerPosition.push(id);
                }
            });
            if (this.map && this.model.coordinates && this.model.coordinates.length) {
                var createArrowIcon = function createArrowIcon(degree) {
                    return L.divIcon({
                        className: 'custom-icon',
                        html: '<div style="transform: rotate(' + degree + 'deg);"><img src="../../assets/images/direction.png" class="direction-icon" /></div>',
                        iconSize: [22, 22],
                        iconAnchor: [11, 11]
                    });
                };

                var waypoints = this.model.coordinates.map(function (c) {
                    return L.latLng(c.latlng);
                });
                L.polyline(waypoints, { color: "#40826D" }).addTo(this.map);

                this.model.coordinates.forEach(function (point) {
                    if (!point.direction || point.direction == -1) return;
                    var latLng = point.latlng;
                    var arrowMarker = L.marker(latLng, { icon: createArrowIcon(point.direction) });
                    arrowMarker.addTo(_this2.map);
                });
            }
        }
    }, {
        key: 'onLocationSelect',
        value: function onLocationSelect(shipmentLoc) {
            if (this.model.infoWindowLoading) return;
            this.openNav();
            this.model.infoWindowLoading = true;
            this.model.selectedLocation = shipmentLoc;
            this.showShipmentSidebar = true;
            this.getRouteShipmentDetail();
        }
    }, {
        key: 'infoWindowToggle',
        value: function infoWindowToggle(route) {
            this.getRouteStops(route);
        }
    }, {
        key: 'getRouteList',
        value: function getRouteList() {
            var _this3 = this;

            setTimeout(function () {
                var startDate = moment(_this3.vaultDate).format('YYYY-MM-DD');
                var endDate = moment(_this3.vaultDate).format('YYYY-MM-DD');
                var branches = _this3.getSelectedBranches();
                var routeId = _this3.model.routeId ? _this3.model.routeId.Value : null;

                _this3.gettingRoutes = true;
                _this3.VaultOperationsService.getRouteList('', startDate, endDate, 0, 1000, 'routeDate', 'DESC', moment.tz.guess(), null, branches, routeId).then(function (data) {
                    _this3.model.allRoutes = data.results;
                    _this3.model.totalRecords = data.totalRecords;

                    _this3.showShipmentSidebar = false;
                    _this3.model.selectedRoute = null;
                    if (_this3.map) {
                        _this3.map.eachLayer(function (layer) {
                            if (layer instanceof L.Polyline || layer instanceof L.Marker) {
                                _this3.map.removeLayer(layer);
                            }
                        });
                    }

                    _this3.markerPosition = [];
                    _this3.model.routeStops = [];
                    _this3.model.coordinates = [];
                    _this3.locationLatLong = [];
                    _this3.lat = 0;
                    _this3.long = 0;
                    _this3.totalLatLongLocations = 0;
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this3.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this3.gettingRoutes = false;
                });
            });
        }
    }, {
        key: 'removeMapMarkers',
        value: function removeMapMarkers() {
            var _this4 = this;

            this.map.remove();
            this.isInitialized = true;
            this.markerPosition.forEach(function (id) {
                _this4.map.removeLayer(id);
            });
            this.markerPosition = [];
        }
    }, {
        key: 'resetSorting',
        value: function resetSorting() {
            this.model.sortColumn = '_index';
            this.model.reverseSort = false;
        }
    }, {
        key: 'getRouteStops',
        value: function getRouteStops(route) {
            var _this5 = this;

            if (route) {
                // if (!this.model.selectedRoute || this.model.selectedRoute.routeId == route.routeId) return
                // this.model.selectedRoute = route;
                if (this.model.selectedRoute && this.model.selectedRoute.routeId === route.routeId) {
                    this.model.selectedRoute = null;
                    this.showShipmentSidebar = false;
                    if (this.map) {
                        this.map.remove();
                        this.isInitialized = true;
                        this.markerPosition.forEach(function (id) {
                            _this5.map.removeLayer(id);
                        });
                        this.markerPosition = [];
                        this.model.routeStops = [];
                        setTimeout(function () {
                            _this5.loadMap();
                            _this5.map.invalidateSize();
                            if (_this5.locationLatLong && _this5.locationLatLong.length) {
                                _this5.map.fitBounds(_this5.locationLatLong);
                            }
                        }, 100);
                    }
                } else {
                    this.model.selectedRoute = route;
                    if (this.model.loadingMap) return;
                    route.isLoading = true;
                    route.isExpand = true;
                    this.model.loadingMap = true;
                    var formattedDate = this.DateUtil.getUTCDate(route.routeDate);
                    this.model.loading = true;
                    this.routePosition = 0;
                    this.lat = 0;
                    this.long = 0;
                    this.totalLatLongLocations = 0;
                    this.stopsInfo = "";
                    this.locationLatLong = [];
                    this.closeNav();
                    this.RouteProgressService.getRouteStops(route.routeId, formattedDate, route.branchId).then(function (data) {
                        _this5.model.loadingMap = false;
                        route.isLoading = false;
                        var routeProgressData = _.orderBy(data.results, ['completedTime'], ['asc']);
                        _this5.model.routeStops = data.results;
                        _this5.model.routeDetails = data.routeDetails;
                        route.shipmentLocations = _this5.model.routeStops;
                        _this5.model.coordinates = data.coordinates;

                        _this5.model.routeStops.forEach(function (j) {
                            routeProgressData.forEach(function (k, index) {
                                if (j.completedTime && k.completedTime && j.locationId == k.locationId) {
                                    j.stopProcessOrder = index + 1;
                                }
                            });
                        });

                        _this5.stopsInfo = data;
                        if (_this5.model.routeStops.length) {
                            _this5.model.routeStops.forEach(function (data, index) {
                                if (data.lat && data.long) {
                                    _this5.locationLatLong.push(new Array(data.lat, data.long));
                                    _this5.totalLatLongLocations += 1;
                                    _this5.lat += data.lat;
                                    _this5.long += data.long;
                                }
                            });
                        }
                        _this5.resetSorting();
                    }).then(function () {
                        if (_this5.map) {
                            _this5.removeMapMarkers();
                        }
                        // if (this.map && this.model.routeStops.length) { this.removeMapMarkers() }

                        setTimeout(function () {
                            // if (this.model.routeStops.length) {
                            _this5.loadMap();
                            _this5.addBranchDetails();
                            // }
                        }, 100);
                    }).catch(function (err) {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            return _this5.Modal.errorModal(err.data.message);
                        }
                        _this5.model.loadingMap = false;
                        route.isLoading = false;
                    }).finally(function () {});
                }
            } else {
                this.map.remove();
                this.isInitialized = true;
                this.markerPosition.forEach(function (id) {
                    _this5.map.removeLayer(id);
                });
                this.markerPosition = [];
                this.model.routeStops = [];
                this.closeNav();
                setTimeout(function () {
                    _this5.loadMap();
                }, 100);
            }
            // route.isExpand = !route.isExpand;
        }
    }, {
        key: 'getRouteShipmentDetail',
        value: function getRouteShipmentDetail() {
            var _this6 = this;

            // console.log(this.model.selectedRoute, this.model.selectedLocation)
            // let locationId = 'RF0217AS1', //this.model.selectedLocation.locationId,
            // routeId = 'BAL-001', //this.model.selectedLocation.routeId,
            // vaultDate = '2021-12-22'; //this.DateUtil.getUTCDate(this.model.selectedLocation.routeDate);

            var locationId = this.model.selectedLocation.locationId,
                routeId = this.model.selectedLocation.routeId,
                vaultDate = this.DateUtil.getUTCDate(this.model.selectedLocation.routeDate);

            this.model.infoWindowLoading = true;
            this.RouteStatsService.getRouteShipmentDetail(vaultDate, routeId, locationId, this.model.routeDetails.messengerId).then(function (res) {
                _this6.model.shipmentDetails = res.result;
                _this6.model.shipmentServiceTickets = res.serviceTickets;
                _this6.model.locationActivity = res.locationActivity;
            }).catch(function (error) {
                console.log(error);
            }).finally(function () {
                _this6.model.infoWindowLoading = false;
            });
        }
    }, {
        key: 'showShipmentReceipt',
        value: function showShipmentReceipt(dataObj, stats) {
            var shipmentObj = {};

            dataObj.forEach(function (details) {
                (0, _assign2.default)(shipmentObj, new Object((0, _defineProperty3.default)({}, details.key, details.value)));
            });

            // document.getElementById('shipment-image').blur();
            this.Modal.shipmentImageModal(shipmentObj, shipmentObj.trackingId, stats, function (_ref2) {
                var modal = _ref2.modal;
            }, function (_ref3) {
                var modal = _ref3.modal;

                modal.close();
            });
        }
    }, {
        key: 'openNav',
        value: function openNav() {
            var _this7 = this;

            document.getElementById("locationShipmentInfo").style.width = '25%'; //this.getScreenWidth();
            // document.getElementById("map").style.marginRight = '23%' //this.getScreenWidth();
            if (this.map) {
                setTimeout(function () {
                    _this7.map.invalidateSize();
                    if (_this7.locationLatLong && _this7.locationLatLong.length) {
                        _this7.map.fitBounds(_this7.locationLatLong);
                    }
                }, 500);
            }
        }
    }, {
        key: 'closeNav',
        value: function closeNav() {
            var _this8 = this;

            document.getElementById("locationShipmentInfo").style.width = "0px";
            document.getElementById("map").style.marginRight = "0px";
            this.showShipmentSidebar = false;
            if (this.map) {
                setTimeout(function () {
                    _this8.map.invalidateSize();
                    if (_this8.locationLatLong && _this8.locationLatLong.length) {
                        _this8.map.fitBounds(_this8.locationLatLong);
                    }
                    _this8.markerPosition = [];
                    _this8.model.routeStops = [];
                    _this8.model.coordinates = [];
                    _this8.locationLatLong = [];
                    _this8.lat = 0;
                    _this8.long = 0;
                    _this8.totalLatLongLocations = 0;
                }, 500);
            }
        }
    }, {
        key: 'translateTransactionType',
        value: function translateTransactionType(transactionType, shipment) {
            if (!transactionType) return this.$translate.instant('common.n_a');
            if (transactionType.includes('shipment.')) {
                return this.$translate.instant('' + transactionType);
            } else {
                return this.$translate.instant('shipment.' + transactionType).toUpperCase();
            }
        }
    }, {
        key: 'goToUserTab',
        value: function goToUserTab(userId) {
            if (!userId) return;
            this.Navigation.goToUserTab(userId, null);
        }
    }, {
        key: 'addBranchDetails',
        value: function addBranchDetails() {
            if (!this.branchInfo || !this.branchInfo.gpsLat || !this.branchInfo.gpsLong) return;

            var locationInfo = '<strong>' + this.branchInfo.branchId + '</strong>' + '<br>' + this.branchInfo.address + ' - ' + this.branchInfo.zip + '<br>' + this.branchInfo.city + ', ' + this.branchInfo.state;

            var id = L.marker([this.branchInfo.gpsLat, this.branchInfo.gpsLong], {
                icon: new L.AwesomeNumberMarkers({
                    number: 'B',
                    markerColor: 'black'
                })
            }).addTo(this.map).bindPopup(locationInfo);

            id.on('mouseover', function () {
                id.openPopup();
            });

            id.on('mouseout', function () {
                id.closePopup();
            });
        }
    }, {
        key: 'getStopStatus',
        value: function getStopStatus(data) {
            if (data && !data.stopStatus && !data.completedTime || data.stopStatus === 'PENDING') return this.$translate.instant('routeProgress.pending');else if (data.completedTime && data.stopStatus === 'PARTIAL') return this.$translate.instant('routeProgress.partial');else if (data && data.stopStatus === 'DO') return this.$translate.instant('routeProgress.delivered');else if (data && data.stopStatus === 'CANT' && (data.totalTransactionRecords > 0 || data.totalTransactionRecords === 0)) return this.$translate.instant('routeProgress.cant').toUpperCase();else if (data.completedTime && data.stopStatus === 'NO_PICKUP') return this.$translate.instant('routeProgress.no_pickup');else if (data.completedTime && data.stopStatus === 'DELIVERED_NO_PICKUP') return this.$translate.instant('routeProgress.delivered_no_pickup');else return;
        }
    }, {
        key: 'getSelectedBranches',
        value: function getSelectedBranches() {
            return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map(function (branch) {
                return branch.branchId;
            }) : null;
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            var _this9 = this;

            setTimeout(function () {
                _this9.model.routeId = null;
                // this.model.selectedBranch = null;
                _this9.showShipmentSidebar = false;
                if (_this9.map) {
                    _this9.map.remove();
                    _this9.isInitialized = true;
                    _this9.markerPosition.forEach(function (id) {
                        _this9.map.removeLayer(id);
                    });
                    _this9.markerPosition = [];
                    _this9.model.routeStops = [];
                    setTimeout(function () {
                        _this9.loadMap();
                        _this9.map.invalidateSize();
                        if (_this9.locationLatLong && _this9.locationLatLong.length) {
                            _this9.map.fitBounds(_this9.locationLatLong);
                        }
                        _this9.model.selectedRoute = null;
                    }, 100);
                }
                _this9.$scope.$apply();
            });
        }
    }, {
        key: 'filterRouteList',
        value: function filterRouteList(searchKey, offset) {
            var _this10 = this;

            setTimeout(function () {
                var startDate = moment(_this10.vaultDate).format('YYYY-MM-DD');
                var endDate = moment(_this10.vaultDate).format('YYYY-MM-DD');
                var branches = _this10.getSelectedBranches();
                searchKey = searchKey || null;

                _this10.VaultOperationsService.getFilterRouteList(startDate, endDate, branches, null, searchKey, _app2.default.defaultPageLimit, offset).then(function (data) {
                    if (offset === 0 || offset == undefined) {
                        _this10.model.routeListObj.totalRecords = data.totalRecords;
                        _this10.model.routeListObj.results = _this10.mapData(data.data);
                    } else {
                        var routes = _this10.mapData(data.data);
                        _this10.model.routeListObj.results = _this10.model.routeListObj.results.concat(routes);
                    }
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this10.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this10.gettingRoutes = false;
                });
            });
        }
    }, {
        key: 'mapData',
        value: function mapData(routes) {
            return routes.map(function (route) {
                return {
                    Key: route.routeId,
                    Value: route.routeId
                };
            });
        }
    }, {
        key: 'exportData',
        value: function exportData(route) {
            var _this11 = this;

            var formattedDate = this.DateUtil.getUTCDate(route.routeDate);
            var reportPrefix = 'Route Stop';

            this.model.isExporting = true;
            this.RouteProgressService.exportRouteStops(route.routeId, formattedDate, route.branchId).then(function (data) {
                _this11.fileName = reportPrefix.concat('_', route.branchId, '_', route.routeId, '.csv');
                var a = document.createElement("a");
                document.body.appendChild(a);
                var file = new Blob([data.csvString], { type: 'application/csv' });
                var fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = _this11.fileName;
                a.click();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this11.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this11.model.isExporting = false;
            });
        }
    }, {
        key: 'showReceipt',
        value: function showReceipt(shipment, stats) {
            document.getElementById('shipment-image').blur();
            this.Modal.shipmentImageModal(shipment, shipment.trackingId, stats, function (_ref4) {
                var modal = _ref4.modal;
            }, function (_ref5) {
                var modal = _ref5.modal;

                modal.close();
            });
        }
    }]);
    return RouteStatsController;
}();

exports.default = RouteStatsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _route_throw = __webpack_require__(2023);

var _route_throw2 = _interopRequireDefault(_route_throw);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeThrowModule = angular.module('routeThrow', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/route-throw');

  $stateProvider.state('routeThrow', {
    url: '/route-throw',
    component: 'routeThrow',
    data: {
      requireLogin: true
    },
    parent: 'app'
  });
}]).component('routeThrow', _route_throw2.default).name;

exports.default = routeThrowModule;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _route_throw = __webpack_require__(2772);

var _route_throw2 = _interopRequireDefault(_route_throw);

var _route_throw3 = __webpack_require__(2024);

var _route_throw4 = _interopRequireDefault(_route_throw3);

__webpack_require__(3052);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeThrowComponent = {
  restrict: 'E',
  bindings: {
    printData: '='
  },
  template: _route_throw2.default,
  controller: _route_throw4.default
};

exports.default = routeThrowComponent;

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteThrowController = function () {
  /*@ngInject*/
  RouteThrowController.$inject = ["Auth", "$state", "User", "UsersService", "RouteService", "$translate", "LocationService", "ScanService", "$location", "$q", "Modal", "ShipmentService", "Branch", "Sound", "$rootScope", "DataCounter", "DateUtil"];
  function RouteThrowController(Auth, $state, User, UsersService, RouteService, $translate, LocationService, ScanService, $location, $q, Modal, ShipmentService, Branch, Sound, $rootScope, DataCounter, DateUtil) {
    (0, _classCallCheck3.default)(this, RouteThrowController);

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.ScanService = ScanService;
    this.Sound = Sound;
    this.$q = $q;
    this.Modal = Modal;
    this.ShipmentService = ShipmentService;
    this.$rootScope = $rootScope;
    this.Branch = Branch;
    this.DataCounter = DataCounter;
    this.DateUtil = DateUtil;
    this.UsersService = UsersService;
    this.model = {
      loading: false,
      fromTanker: '',
      toTanker: '',
      bagId: '',
      branchId: ''
    };

    this.lastBagScanned = null;
    this.lastBagScannedErrorCode = null;
    this.hasTanker = false;
    this.routeThrowDate = null;
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();
    this.nextVaultDate = null;
    this.vaultDate = null;
    this.errorCodes = ['92813', '91706', '92203', '92204', '92811', '92207', '92205', '92208'];
    this.showForceHoldBtn = false;
    this.routeId = null;
    this.$rootScope.$broadcast('routeChange', '/app/route-throw');
    this.routeDetails = '';
    this.loggedInUser = this.User.getUser().id;
    this.isAlreadyThrown = false;
    this.assignedTankerId = null;
  }

  (0, _createClass3.default)(RouteThrowController, [{
    key: 'focusElementById',
    value: function focusElementById(id) {
      setTimeout(function () {
        document.getElementById(id).focus();
      }, 500);
    }
  }, {
    key: 'convertToDate',
    value: function convertToDate(date) {
      var ISOString = moment(date).toISOString();
      var DATE_STRING_LENGTH = 10; // length of 'YYYY-MM-DD' format

      var dateString = ISOString.substr(0, DATE_STRING_LENGTH);
      return moment(dateString).toDate();
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      var self = this;
      this.focusElementById('bagId');
      this.model.branchId = this.User.getUser().branchId;
      this.routeDetails = this.DataCounter.getData();

      this.Branch.getBranchDetails(this.model.branchId).then(function (branchDetails) {
        self.currentVaultDate = self.convertToDate(branchDetails.currentVaultDate);
        self.vaultDate = moment.utc(branchDetails.currentVaultDate).format('YYYY-MM-DD');
        self.minVaultDate = {
          minDate: self.currentVaultDate
        };

        if (self.routeDetails && self.routeDetails.isRedirected) {
          self.nextVaultDate = self.routeDetails.vaultDate;
        } else {
          self.nextVaultDate = moment(self.currentVaultDate).add(1, 'days').toDate();
        }
        self.prefixes = branchDetails.prefixes;
        self.isCoinCheckOut = branchDetails.coinCheckOut;
      }).then(function () {
        _this.resetRedirectionData();
      });
    }
  }, {
    key: 'fromTankerScanned',
    value: function fromTankerScanned() {
      var _this2 = this;

      if (this.model.fromTanker) {
        var searchObj = {
          queryJSON: {
            rules: [{
              field: 'locationType',
              condition: '=',
              data: 'TANKER'
            }, {
              field: 'id',
              condition: '=',
              data: this.model.fromTanker
            }],
            operator: 'AND'
          }
        };

        this.LocationService.all(searchObj, 0, 1).then(function (res) {
          if (res.results && res.results.length) {
            _this2.hasTanker = true;
            _this2.focusElementById('bagId');
          }
        });
      }
    }
  }, {
    key: 'toTankerScanned',
    value: function toTankerScanned() {
      var _this3 = this;

      this.routeThrowDate = moment(this.nextVaultDate).format('YYYY-MM-DD');

      if (!this.model.toTanker) {
        return;
      }

      var defer = this.$q.defer();

      delete this.lastStatusUpdate;
      this.isError = false;

      if (this.prefixes && this.prefixes.tanker) {
        if (this.model.toTanker.startsWith(this.prefixes.tanker[0])) {
          var finalToTankerData = this.model.toTanker.slice(this.prefixes.tanker[0].length);
          this.model.toTanker = finalToTankerData;
        }
      }

      this.shipmentRoute = this.model.shipment.routeId;

      this.loading = true;
      this.ShipmentService.throwTanker(this.model.branchId, this.model.bagId, this.model.toTanker, this.routeThrowDate, this.loggedInUser).then(function () {
        _this3.isError = false;
        _this3.loading = false;
        _this3.lastStatusUpdate = new Date();
        _this3.bagRouteThrowMessage = _this3.$translate.instant('routeThrow.itemAddedSuccessfully');

        _this3.isAlreadyThrown = true;
        _this3.assignedTankerId = _this3.model.toTanker;

        _this3.Sound.playSuccessBeep("#success_beep");
        defer.resolve();
      }).then(function () {
        if (_this3.model.shipment) _this3.throwCount(_this3.model.shipment.routeId, _this3.model.branchId, _this3.routeThrowDate);
      }).catch(function (err) {
        _this3.Sound.PlayErrorBeep("#scanner_beep");
        _this3.focusElementById('toTanker');
        _this3.loading = false;

        if (err.data.message === '92208') {
          _this3.getRouteAssignment().then(function (data) {
            var date = moment(_this3.routeThrowDate);
            // console.log("date", date);
            var dow = date.day() + 1;
            // console.log("dow", dow);
            var tanker = data[dow];
            // console.log("tanker", tanker);
            _this3.bagRouteThrowError = _this3.$translate.instant('error.' + err.data.message, {
              routeId: _this3.shipmentRoute,
              tankerId: tanker
            });
          });
        }

        if (err.data.message === '92811') {
          _this3.RouteService.getRouteTanker(_this3.shipmentRoute, _this3.vaultDate).then(function (routeTanker) {
            _this3.bagRouteThrowError = _this3.$translate.instant('error.' + err.data.message, {
              routeId: _this3.shipmentRoute,
              tankerId: routeTanker.tankerId
            });
          }).catch(function (e) {
            _this3.Modal.errorModal(e.data.message);
          });
        }

        if (err.data.message && _this3.errorCodes.indexOf(err.data.message) > -1) {
          _this3.showForceHoldBtn = err.data.message === "92205" ? true : false;
          _this3.model.bagId = null;
          _this3.model.shipment = null;
          _this3.focusElementById('bagId');
        }

        _this3.model.toTanker = '';
        _this3.isError = true;
        _this3.lastStatusUpdate = new Date();
        _this3.lastBagScannedErrorCode = err.data.message;
        // this.bagRouteThrowError = this.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        _this3.bagRouteThrowError = _this3.$translate.instant('error.' + err.data.message, {
          trackingId: _this3.lastBagScanned
        }) || 'Error: ' + err.data.message;
        _this3.scanItem = _this3.$translate.instant('routeThrow.scan');
        _this3.scanAgain = _this3.$translate.instant('routeThrow.again');
        defer.reject();
      });
      return defer.promise.then(function () {
        // return this.setRouteAssignment()
        //   .then(() => {
        _this3.clearScan(true);
        // })
      });
    }
  }, {
    key: 'bagScanned',
    value: function bagScanned() {
      var _this4 = this;

      this.showForceHoldBtn = false;
      this.routeThrowDate = moment(this.nextVaultDate).format('YYYY-MM-DD');

      if (!this.model.bagId) {
        return;
      }

      if (this.errorCodes.indexOf(this.lastBagScannedErrorCode) > -1) {
        if (this.lastBagScanned && this.lastBagScanned !== this.model.bagId) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.isError = true;
          this.model.bagId = null;
          this.model.shipment = null;
          this.lastStatusUpdate = new Date();
          this.bagRouteThrowError = this.$translate.instant('error.rescanLastItemId');
          return;
        }
      }
      delete this.lastStatusUpdate;
      this.lastBagScanned = this.model.bagId;
      this.isError = false;
      this.isAlreadyThrown = false;
      this.assignedTankerId = null;
      this.model.loading = true;
      return this.ScanService.verifyRouteThrowShipment(this.model.branchId, this.model.bagId, this.routeThrowDate).then(function (response) {
        _this4.model.loading = false;
        var route = response.route,
            shipments = response.shipments;


        if (route.fuzzyMatching) {
          _this4.Modal.routeThrowShipmentSelectionModal(null, shipments, function (_ref) {
            var modal = _ref.modal,
                selected = _ref.selected;

            _this4.model.bagId = selected.trackingId;
            _this4.bagScanned();
            modal.close();
          }, function (_ref2) {
            var modal = _ref2.modal;

            modal.close();
          });
        } else if (shipments && shipments[0]) {
          var shipment = shipments[0];

          if (shipment) {
            _this4.model.shipment = shipment;
            _this4.shipmentDeliveryDate = moment.utc(shipment.deliveryDate).format('YYYY-MM-DD');
            _this4.model.route = route;
            _this4.routeId = shipment.routeId;
            _this4.Sound.playSuccessBeep("#success_beep");
            _this4.focusElementById('toTanker');

            _this4.isAlreadyThrown = !!shipment.tankerId;
            _this4.assignedTankerId = shipment.tankerId;

            if (!_this4.isAlreadyThrown) {
              if (route && route.tankerId) {
                _this4.lastToTankerScanned = route.tankerId;
              } else {
                _this4.RouteService.getRouteTanker(_this4.routeId, _this4.routeThrowDate).then(function (routeTanker) {
                  if (routeTanker && routeTanker.tankerId) {
                    _this4.lastToTankerScanned = routeTanker.tankerId;
                  }
                }).catch(function () {});
              }
            }
          }
        } else {
          _this4.model.bagId = null;
          _this4.Sound.PlayErrorBeep("#scanner_beep");
          _this4.isError = true;
          _this4.lastStatusUpdate = new Date();
          _this4.bagRouteThrowError = _this4.$translate.instant('error.shipmentNotFound');
        }

        if (_this4.errorCodes.indexOf(_this4.lastBagScannedErrorCode) > -1) {
          if (_this4.lastBagScanned && _this4.lastBagScanned == _this4.model.bagId) {
            _this4.focusElementById('bagId');
            _this4.model.bagId = null;
            _this4.model.shipment = null;
            _this4.Sound.playSuccessBeep("#success_beep");
          }
        }
        _this4.lastBagScannedErrorCode = '';
      }).then(function () {
        if (_this4.model.shipment) _this4.throwCount(_this4.model.shipment.routeId, _this4.model.branchId, _this4.routeThrowDate);
      }).catch(function (err) {
        _this4.focusElementById('bagId');
        _this4.Sound.PlayErrorBeep("#scanner_beep");
        _this4.model.bagId = null;
        _this4.model.shipment = null;
        _this4.isError = true;
        _this4.model.loading = false;
        _this4.lastStatusUpdate = new Date();
        _this4.lastBagScannedErrorCode = err.data.message;
        _this4.bagRouteThrowError = _this4.$translate.instant('error.' + err.data.message, {
          trackingId: _this4.lastBagScanned
        }) || 'Error: ' + err.data.message;

        if (err.data.message === '91705' || err.data.message === '92811') {
          _this4.ShipmentService.getShipmentTrakingDetail(_this4.lastBagScanned).then(function (trackingData) {
            if (trackingData && trackingData.length > 0) {
              var shipment = trackingData.find(function (s) {
                return s.branchId === _this4.model.branchId && moment(s.deliveryDate).format('YYYY-MM-DD') === _this4.routeThrowDate;
              });
              if (shipment) {
                _this4.model.shipment = shipment;
                _this4.model.shipment.toLocationName = shipment.toLocation ? shipment.toLocation.name : '';
                _this4.model.shipment.toAddress = shipment.toLocation ? shipment.toLocation.address + (shipment.toLocation.city ? ', ' + shipment.toLocation.city : '') + (shipment.toLocation.state ? ', ' + shipment.toLocation.state : '') + (shipment.toLocation.zip ? ' ' + shipment.toLocation.zip : '') : '';
                _this4.isAlreadyThrown = !!shipment.tankerId;
                _this4.assignedTankerId = shipment.tankerId;
                _this4.routeId = shipment.routeId;
                _this4.throwCount(_this4.routeId, _this4.model.branchId, _this4.routeThrowDate);
              }
            }
          });
        }
      });
    }
  }, {
    key: 'throwCount',
    value: function throwCount(routeId, branchId, date) {
      var _this5 = this;

      this.ScanService.shipmentThrowCount(routeId, branchId, date, this.isCoinCheckOut).then(function (res) {
        _this5.model.notThrown = res.notThrown;
        _this5.model.thrownShipments = res.thrownShipments;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'showThrownShipmentsModal',
    value: function showThrownShipmentsModal() {
      var _this6 = this;

      if (!this.model.shipment) return;
      this.ScanService.shipmentThrowList(this.model.shipment.routeId, this.model.branchId, this.routeThrowDate, this.isCoinCheckOut).then(function (res) {
        _this6.Modal.routeThrowShipmentListModal(_this6.$translate.instant('routeThrow.thrown') + ' Shipments', res.thrown, true);
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'showRemainingShipmentsModal',
    value: function showRemainingShipmentsModal() {
      var _this7 = this;

      if (!this.model.shipment) return;
      this.ScanService.shipmentThrowList(this.model.shipment.routeId, this.model.branchId, this.routeThrowDate, this.isCoinCheckOut).then(function (res) {
        _this7.Modal.routeThrowShipmentListModal(_this7.$translate.instant('routeThrow.remaining') + ' Shipments', res.notThrown, false);
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'keyPressed',
    value: function keyPressed(controlId, $event) {
      var ESC_KEY_CODE = 27;
      if (controlId === 'bagId') {
        if ($event.keyCode === ESC_KEY_CODE) {
          this.model.bagId = '';
        }
      }
    }
  }, {
    key: 'endScan',
    value: function endScan() {
      this.model = {
        fromTanker: '',
        toTanker: '',
        bagId: ''
      };

      this.hasTanker = false;
      this.focusElementById('fromTanker');
    }
  }, {
    key: 'clearScan',
    value: function clearScan(clearOnlyInputs) {
      var obj = {
        bagId: null,
        toTanker: null
      };
      if (!clearOnlyInputs) {
        obj.shipment = null;
        obj.route = null;
        this.shipmentRoute = null;
        this.isAlreadyThrown = false;
        this.assignedTankerId = null;
      }

      this.model = (0, _assign2.default)(this.model, obj);

      this.focusElementById('bagId');
    }
  }, {
    key: 'itemForceHold',
    value: function itemForceHold() {
      var _this8 = this;

      delete this.lastStatusUpdate;

      this.UsersService.checkSupervisor(this.loggedInUser).then(function (userInfo) {
        _this8.Modal.holdReason(_this8.lastBagScanned, !userInfo.supervisor, function (_ref3) {
          var supervisorId = _ref3.supervisorId,
              reason = _ref3.reason,
              modal = _ref3.modal;

          modal.close();
          _this8.showForceHoldBtn = false;
          _this8.ShipmentService.holdShipment(_this8.model.branchId, _this8.lastBagScanned, _this8.routeId, moment(_this8.nextVaultDate).format('YYYY-MM-DD'), userInfo.supervisor ? userInfo.id : supervisorId, reason).then(function (response) {
            _this8.isError = false;
            _this8.lastStatusUpdate = new Date();
            _this8.Sound.playSuccessBeep("#success_beep");
            _this8.bagRouteThrowMessage = _this8.$translate.instant('routeThrow.itemaddedtohold');
          }).catch(function (err) {
            _this8.isError = true;
            _this8.Sound.PlayErrorBeep("#scanner_beep");
            _this8.lastStatusUpdate = new Date();
            _this8.bagRouteThrowError = _this8.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
          });
        });
      }).catch(function (err) {
        _this8.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: 'clearBagId',
    value: function clearBagId() {
      this.model.bagId = '';
    }
  }, {
    key: 'clearTankerId',
    value: function clearTankerId() {
      this.model.toTanker = '';
    }
  }, {
    key: 'getRouteAssignment',
    value: function getRouteAssignment() {
      var defer = this.$q.defer();
      this.RouteService.getTankerAssignments(this.model.shipment.routeId).then(function (res) {
        defer.resolve(res);
      }).catch(function (err) {
        console.log(err);
        defer.reject();
      });
      return defer.promise;
    }
  }, {
    key: 'resetRedirectionData',
    value: function resetRedirectionData() {
      if (this.routeDetails) {
        this.routeDetails.isRedirected = false;
        this.routeDetails = this.DataCounter.setData();
      }
    }

    // setRouteAssignment() {
    //   const defer = this.$q.defer();
    //   const date = moment(this.routeThrowDate)
    //   const dow = date.day() + 1;
    //   const routeTanker = { [dow]: this.model.toTanker };
    //   console.log("routeTanker", routeTanker);
    //   this.RouteService.setTankerAssignments(this.model.shipment.routeId, routeTanker)
    //     .then((res) => {
    //       defer.resolve(res);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       defer.reject();
    //     })
    //   return defer.promise;
    // }

  }]);
  return RouteThrowController;
}();

exports.default = RouteThrowController; /**/
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routesAll = __webpack_require__(2026);

var _routesAll2 = _interopRequireDefault(_routesAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routesallModule = angular.module('routesall', []).component('routesall', _routesAll2.default).name;

exports.default = routesallModule;

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routesAll = __webpack_require__(2773);

var _routesAll2 = _interopRequireDefault(_routesAll);

var _routesAll3 = __webpack_require__(2027);

var _routesAll4 = _interopRequireDefault(_routesAll3);

__webpack_require__(3053);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routesallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _routesAll2.default,
  controller: _routesAll4.default
};

exports.default = routesallComponent;

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _routesBase = __webpack_require__(270);

var _routesBase2 = _interopRequireDefault(_routesBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoutesallController = function (_RoutesBaseController) {
  RoutesallController.$inject = ["Auth", "$state", "User", "Modal", "RouteService", "$translate", "$stateParams", "$scope", "$q", "$location", "SetupService", "DateUtil"];
  (0, _inherits3.default)(RoutesallController, _RoutesBaseController);

  /*@ngInject*/
  function RoutesallController(Auth, $state, User, Modal, RouteService, $translate, $stateParams, $scope, $q, $location, SetupService, DateUtil) {
    (0, _classCallCheck3.default)(this, RoutesallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RoutesallController.__proto__ || (0, _getPrototypeOf2.default)(RoutesallController)).call(this, Auth, $state, User, RouteService, Modal, $translate, $stateParams, $location));

    _this.$q = $q;
    _this.SetupService = SetupService;
    _this.DateUtil = DateUtil;
    _this.id = 'route.all';
    _this.loading = false;
    _this.routes = [];
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.hasACL = {};
    _this._status = 'all';
    _this.userStatus = [{
      label: 'All',
      value: 'all'
    }, {
      label: 'Hold',
      value: 'hold'
    }, {
      label: 'Regular',
      value: 'regular'
    }];
    _this._activeStatus = 'active';
    _this.activeStatusList = [{
      label: 'All',
      value: 'all'
    }, {
      label: 'Active',
      value: 'active'
    }, {
      label: 'Suspended',
      value: 'suspended'
    }];
    _this.searchText = '';
    _this.$location = $location;
    _this.days = [{ label: _this.$translate.instant('location.sun'), value: 'Sun' }, { label: _this.$translate.instant('location.mon'), value: 'Mon' }, { label: _this.$translate.instant('location.tues'), value: 'Tue' }, { label: _this.$translate.instant('location.wed'), value: 'Wed' }, { label: _this.$translate.instant('location.thurs'), value: 'Thu' }, { label: _this.$translate.instant('location.fri'), value: 'Fri' }, { label: _this.$translate.instant('location.sat'), value: 'Sat' }, { label: _this.$translate.instant('location.hol'), value: 'Hol' }];
    _this.selectedDay = 'Mon';
    _this.loadingRouteSequence = false;
    _this.fullList = [];
    _this.branch = User.getUser().branchId;
    _this.valutDate = '';
    _this.routeUpdateHistory = {};
    _this.uiProcessSection = {};
    _this.pagination = {
      page: 1,
      total: 0,
      pageLimit: 10,
      maxPages: 10
    };
    _this.pendingRouteChanges = {};
    return _this;
  }

  (0, _createClass3.default)(RoutesallController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }

      var dateDefer = this.$q.defer();

      this.SetupService.get(this.branch).then(function (setup) {
        var date = _this2.DateUtil.convertToDate(setup.currentVaultDate);
        dateDefer.resolve(date);
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this2.Modal.errorModal('error.' + err.data.message);
        }
      });

      dateDefer.promise.then(function (date) {
        _this2.valutDate = date;
        var today = _this2.valutDate.getDay();
        _this2.selectedDay = _this2.days[today].value;
        return _this2.loadData();
      }).finally(function () {
        _this2.loading = false;
      });
    }
  }, {
    key: 'edit',
    value: function edit(route) {
      this.$state.go('routes.edit', {
        id: route.id,
        day: this.selectedDay
      });
    }
  }, {
    key: 'delete',
    value: function _delete(route) {
      var _this3 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + route.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this3.Service.remove(route.id, _this3.branch).then(function (data) {
            _this3.allowOnlyOnce = false;
            modal.close();
            _this3.refresh();
          }).catch(function (err) {
            $scope.isLoading = false;
            $scope.loading = false;
            _this3.allowOnlyOnce = false;
            if (err && err.data && err.data.message) {
              return _this3.Modal.errorModal('route.reference_error');
            }
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this3.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.branch
          }],
          operator: 'AND'
        }
      };

      if (this.searchText) {
        var searchFields = ['id', 'name'];
        var trimmedSearchText = this.searchText.trim();
        var searchWords = trimmedSearchText.split(/[^a-zA-Z0-9]+/).filter(function (word) {
          return (/[a-zA-Z0-9]/.test(word)
          );
        });

        if (!searchWords.length && trimmedSearchText) {
          searchWords = [trimmedSearchText];
        }

        if (searchWords.length) {
          searchObj.queryJSON.rules.push({
            group: {
              operator: 'AND',
              rules: searchWords.map(function (word) {
                return {
                  group: {
                    operator: 'OR',
                    rules: searchFields.map(function (field) {
                      return {
                        field: field,
                        condition: 'like',
                        data: '%' + word + '%'
                      };
                    })
                  }
                };
              })
            }
          });
        }
      }

      return searchObj;
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this4 = this;

      var searchObj = this.generateSearchObj();

      switch (this._status) {
        case 'hold':
          {
            searchObj.queryJSON.rules.push({
              field: 'holdRoute',
              condition: '=',
              data: 1
            });
            break;
          }
        case 'regular':
          {
            searchObj.queryJSON.rules.push({
              field: 'holdRoute',
              condition: '=',
              data: 0
            });
            break;
          }
        case 'all':
        default:
          {
            break;
          }
      }

      switch (this._activeStatus) {
        case 'active':
          {
            searchObj.queryJSON.rules.push({
              field: 'active',
              condition: '=',
              data: true
            });
            break;
          }
        case 'suspended':
          {
            searchObj.queryJSON.rules.push({
              field: 'active',
              condition: '=',
              data: false
            });
            break;
          }
        case 'all':
          {
            searchObj.includeInactive = true;
            break;
          }
        default:
          {
            break;
          }
      }

      this.loading = true;
      return this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this4.total = data.total;

        _this4.loading = false;
        _this4.fullList = data.results;
        _this4.routes = _this4.fullList.slice();
      }).then(function () {
        return _this4.dayChanged();
      }).catch(function (err) {
        _this4.loading = false;
        _this4.error = err.message;
      });
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(route) {
      route.expand = !route.expand;
    }
  }, {
    key: 'selectDay',
    value: function selectDay(day) {
      this.selectedDay = day.value;
      this.dayChanged();
    }
  }, {
    key: 'dayChanged',
    value: function dayChanged() {
      var _this5 = this;

      this.loadingRouteSequence = true;
      return this.$q.all(this.routes.map(function (route) {
        _this5.loadingRouteSequence = true;
        return _this5.Service.getRouteSequenceCount(route.id, route.branchId, _this5.selectedDay);
      })).then(function (data) {
        _this5.routes.forEach(function (route, index) {
          _this5.loadingRouteSequence = false;
          route.locationsOnRoute = data[index];
        });
      }).catch(function (err) {
        _this5.loadingRouteSequence = false;
        console.log(err);
      }).finally(function () {
        _this5.loadingRouteSequence = false;
      });
    }
  }, {
    key: 'setPage',
    value: function setPage(isExpanded, routeId) {
      if (!isExpanded) return;
      this.uiProcessSection[routeId] = { page: 1 };
    }
  }, {
    key: 'getRouteUpdateHistory',
    value: function getRouteUpdateHistory(isExpanded, routeId) {
      var _this6 = this;

      document.getElementById('expand-btn-' + routeId).blur();
      if (!isExpanded) return;

      this.uiProcessSection[routeId].process = true;

      this.Service.getRouteUpdateHistory(routeId, this.pagination.pageLimit, (this.uiProcessSection[routeId].page - 1) * this.pagination.pageLimit).then(function (history) {
        return _this6.getPendingRouteChanges(routeId).then(function (pendingChanges) {
          return [history, pendingChanges];
        });
      }).then(function (_ref3) {
        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
            history = _ref4[0],
            pendingChanges = _ref4[1];

        _this6.routeUpdateHistory[routeId] = { details: history };
        _this6.pendingRouteChanges[routeId] = { details: pendingChanges };
        _this6.routeUpdateHistory[routeId].details.pageLimit = _this6.pagination.pageLimit;
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this6.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this6.uiProcessSection[routeId].process = false;
      });
    }
  }, {
    key: 'isArray',
    value: function isArray(key) {
      return Array.isArray(key);
    }
  }, {
    key: 'getPendingRouteChanges',
    value: function getPendingRouteChanges(routeId) {
      return this.Service.getPendingRouteChanges(routeId).then(function (data) {
        return data;
      });
    }
  }, {
    key: 'translateMessage',
    value: function translateMessage(key) {
      if (!key) return;
      return this.$translate.instant('route.' + key);
    }
  }]);
  return RoutesallController;
}(_routesBase2.default);

exports.default = RoutesallController;

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routesCreate = __webpack_require__(2029);

var _routesCreate2 = _interopRequireDefault(_routesCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routesCreateModule = angular.module('routescreate', []).component('routescreate', _routesCreate2.default).name;

exports.default = routesCreateModule;

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routesCreate = __webpack_require__(2774);

var _routesCreate2 = _interopRequireDefault(_routesCreate);

var _routesCreate3 = __webpack_require__(2030);

var _routesCreate4 = _interopRequireDefault(_routesCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routescreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _routesCreate2.default,
  controller: _routesCreate4.default
};

exports.default = routescreateComponent;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _routesBase = __webpack_require__(270);

var _routesBase2 = _interopRequireDefault(_routesBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoutesCreateController = function (_RoutesBaseController) {
	RoutesCreateController.$inject = ["Auth", "$state", "User", "RouteService", "Modal", "$translate", "BranchService", "SetupService", "$scope", "TruckService", "LocationService", "AppConstants"];
	(0, _inherits3.default)(RoutesCreateController, _RoutesBaseController);

	/*@ngInject*/
	function RoutesCreateController(Auth, $state, User, RouteService, Modal, $translate, BranchService, SetupService, $scope, TruckService, LocationService, AppConstants) {
		(0, _classCallCheck3.default)(this, RoutesCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (RoutesCreateController.__proto__ || (0, _getPrototypeOf2.default)(RoutesCreateController)).call(this, Auth, $state, User, RouteService, Modal, $translate, TruckService));

		_initialiseProps.call(_this);

		_this.$scope = $scope;
		_this.TruckService = TruckService;
		_this.SetupService = SetupService;
		_this.LocationService = LocationService;
		_this.AppConstants = AppConstants;
		_this.defaultModel = {
			id: '',
			name: '',
			shortName: '',
			active: true,
			loadTruck: false,
			holdRoute: false,
			beginTime: '',
			branch: User.getUser().branchId,
			description: '',
			requireDriver: true,
			requireGuard: false,
			loggedInUser: User.getUser().id,
			specialFlag: false,
			uploadOnEndRouteOnly: true,
			autoOptimize: false,
			autoOpenATMs: false,
			bagoutFlag: false,
			requireLoadedAmount: false,
			requireResidualScan: false,
			requireBranchScan: false,
			requireThrow: true,
			eventRoute: false,
			shuttleRoute: false,
			liabilityLimit: null,
			autoCheckIn: false,
			autoCheckOut: false,
			checkOutByTanker: false,
			autoCheckInUpdate: false,
			autoThrowOnPack: false,
			NFCScan: false,
			NFCTagId: null,
			requireTruckScan: true,
			bagoutOnTruck: false,
			routeCutOff: false,
			routeCutOffTime: null,
			restrictToTruck: false,
			restrictTruck: null,
			optimizeAfterStop: false,
			autoSendPickupManifest: false,
			pickupManifestRecipientEmail: '',
			origination: 'BRANCH',
			routeMon: false,
			routeTue: false,
			routeWed: false,
			routeThu: false,
			routeFri: false,
			routeSat: false,
			routeSun: false,
			routeHol: false,
			sendRouteSheet: false,
			routeSheetRecipients: '',
			autoTransferAndClose: false,
			scanUserItems: false,
			maxRouteTime: null,
			maxMileage: null,
			estimatedRouteSpeed: null,
			lunch: false,
			lunchMinutes: '',
			lunchInTruck: false,
			break: false,
			breakMinutes: '',
			breakInTruck: false,
			rescheduleDeliveries: false,
			rescheduleHoldLocationId: null
		};

		_this.weekdays = [{
			label: _this.$translate.instant('location.mon'),
			value: 'Mon',
			day: 2
		}, {
			label: _this.$translate.instant('location.tues'),
			value: 'Tue',
			day: 3
		}, {
			label: _this.$translate.instant('location.wed'),
			value: 'Wed',
			day: 4
		}, {
			label: _this.$translate.instant('location.thurs'),
			value: 'Thu',
			day: 5
		}, {
			label: _this.$translate.instant('location.fri'),
			value: 'Fri',
			day: 6
		}, {
			label: _this.$translate.instant('location.sat'),
			value: 'Sat',
			day: 7
		}, {
			label: _this.$translate.instant('location.sun'),
			value: 'Sun',
			day: 1
		}];

		_this.day = {
			routeId: []
		};

		_this.branch = [];
		_this.BranchService = BranchService;
		_this.$translate = $translate;
		_this.model = angular.copy(_this.defaultModel);
		_this.assignedTankers = {};
		_this.contractDays = [];

		_this.truckOptions = {
			options: [],
			totalRecords: 0
		};
		_this.restrictTruckAddress = null;

		_this.originationOptions = [{
			label: 'Branch',
			value: 'BRANCH'
		}, {
			label: 'Truck',
			value: 'TRUCK'
		}, {
			label: 'User',
			value: 'USER'
		}];

		_this.routeDays = ["routeSun", "routeMon", "routeTue", "routeWed", "routeThu", "routeFri", "routeSat", "routeHol"];
		_this.dayKeys = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat", "Hol"];
		_this.internalLocationsObj = {
			results: [],
			totalRecords: 0
		};
		return _this;
	}

	(0, _createClass3.default)(RoutesCreateController, [{
		key: '$onInit',
		value: function $onInit() {
			// this.loading = true;
			this.getAssignableTankersAtBranch('', 0);
			this.getAllTrucks();
			this.createRouteObjects();
			this.getSetupDetails(this.defaultModel.branch);
			this.loadInternalLocations();
		}
	}, {
		key: 'getSetupDetails',
		value: function getSetupDetails(branch) {
			var _this2 = this;

			this.SetupService.get(branch).then(function (setup) {
				_this2.model.branchTimezone = setup.timezone;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			var _this3 = this;

			this.weekdays.forEach(function (day, index) {
				if (_this3.model[day.value].tankerId) {
					_this3.model[day.value].tankerId = null;
				}
			});
			this.assignedTankers = {};
			this.model = angular.copy(this.defaultModel);
			this.clearErrors();
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this4 = this;

			if (this.loading) {
				return;
			}

			this.loading = true;
			this.upsertTankerAssignment();
			this.routeDays.forEach(function (route) {
				return _this4.model[route.value] = route.tick;
			});

			this.Service.create({
				id: this.model.id,
				name: this.model.name,
				shortName: this.model.shortName,
				active: this.model.active,
				loadTruck: this.model.loadTruck,
				beginTime: this.model.beginTime ? moment(this.model.beginTime).format('HH:mm:ss') : null,
				branchId: this.model.branch,
				description: this.model.description,
				holdRoute: this.model.holdRoute,
				requireDriver: this.model.requireDriver,
				requireGuard: this.model.requireGuard,
				specialFlag: this.model.specialFlag,
				uploadOnEndRouteOnly: this.model.uploadOnEndRouteOnly,
				autoOptimize: this.model.autoOptimize,
				autoOpenATMs: this.model.autoOpenATMs,
				bagoutFlag: this.model.bagoutFlag,
				assignedTankers: this.assignedTankers,
				requireLoadedAmount: this.model.requireLoadedAmount,
				requireResidualScan: this.model.requireResidualScan,
				requireBranchScan: this.model.requireBranchScan,
				requireThrow: this.model.requireThrow,
				eventRoute: this.model.eventRoute,
				shuttleRoute: this.model.shuttleRoute,
				liabilityLimit: this.model.liabilityLimit || null,
				autoCheckIn: this.model.autoCheckIn,
				autoCheckOut: this.model.autoCheckOut,
				checkOutByTanker: this.model.checkOutByTanker,
				autoCheckInUpdate: this.model.autoCheckInUpdate,
				autoThrowOnPack: this.model.autoThrowOnPack,
				NFCScan: this.model.NFCScan,
				NFCTagId: this.model.NFCScan ? this.model.NFCTagId : null,
				requireTruckScan: this.model.requireTruckScan,
				bagoutOnTruck: this.model.bagoutOnTruck,
				routeCutOff: this.model.routeCutOff,
				routeCutOffTime: this.model.routeCutOff && this.model.routeCutOffTime ? moment(this.model.routeCutOffTime).format('HH:mm:ss') : null,
				restrictToTruck: this.model.restrictToTruck,
				restrictTruckId: this.model.restrictToTruck && this.model.restrictTruck ? this.model.restrictTruck.id : null,
				optimizeAfterStop: this.model.optimizeAfterStop,
				autoSendPickupManifest: this.model.autoSendPickupManifest,
				pickupManifestRecipientEmail: this.model.pickupManifestRecipientEmail,
				origination: this.model.origination,
				routeMon: this.model.routeMon,
				routeTue: this.model.routeTue,
				routeWed: this.model.routeWed,
				routeThu: this.model.routeThu,
				routeFri: this.model.routeFri,
				routeSat: this.model.routeSat,
				routeSun: this.model.routeSun,
				routeHol: this.model.routeHol,
				sendRouteSheet: this.model.sendRouteSheet,
				routeSheetRecipients: this.model.sendRouteSheet ? this.model.routeSheetRecipients : null,
				timezone: this.model.branchTimezone,
				scanUserItems: this.model.scanUserItems,
				maxRouteTime: this.model.maxRouteTime ? moment(this.model.maxRouteTime).format('HH:mm:ss') : null,
				maxMileage: this.model.maxMileage,
				estimatedRouteSpeed: this.model.estimatedRouteSpeed,
				lunch: this.model.lunch,
				lunchMinutes: this.model.lunch && this.model.lunchMinutes ? moment(this.model.lunchMinutes).format('00:mm:ss') : null,
				lunchInTruck: this.model.lunch ? this.model.lunchInTruck : false,
				break: this.model.break,
				breakMinutes: this.model.break && this.model.breakMinutes ? moment(this.model.breakMinutes).format('00:mm:ss') : null,
				breakInTruck: this.model.break ? this.model.breakInTruck : false,
				rescheduleDeliveries: this.model.rescheduleDeliveries,
				autoTransferAndClose: this.model.autoTransferAndClose,
				rescheduleHoldLocationId: this.model.rescheduleDeliveries && this.model.rescheduleHoldLocationId ? this.model.rescheduleHoldLocationId.Value : null
			}).then(function (data) {
				_this4.loading = false;
				_this4.askCreate().then(function () {
					return _this4.createRouteObjects();
				});
			}).catch(function (err) {
				_this4.loading = false;
				var errorPath = err && err.data && err.data.errors && err.data.errors[0].path;

				if (errorPath === 'ROUTE.NFCTagId') {
					_this4.errorMessage = _this4.$translate.instant('common.unique_nfc_tag_id');
				} else if (err && err.data && err.data.message) {
					_this4.errorMessage += err.data.message + '<br/>';
				} else {
					err.data.errors.map(function (e) {
						_this4.errorMessage += e.message + '<br/>';
					});
				}
			});
		}
	}, {
		key: 'getAssignableTankersAtBranch',
		value: function getAssignableTankersAtBranch(searchKey, offset) {
			var _this5 = this;

			this.dayArray = [], this.total = [];
			this.BranchService.getTankersAvailable(this.model.branch).then(function (res) {
				_this5.model.tankers = res;
				_this5.weekdays.forEach(function (d, index) {
					if (offset == 0 || offset == undefined) {
						_this5.total.push((0, _defineProperty3.default)({}, d.value, {
							total: res[d.day].length
						}));
						_this5.dayArray.push((0, _defineProperty3.default)({}, d.value, _this5.mapRouteTankers(res[d.day], searchKey, d.day)));
					}
				});
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'mapRouteTankers',
		value: function mapRouteTankers(mapArray, searchKey, day) {
			return mapArray.map(function (obj) {
				return {
					Key: obj.tankerId + ' | ' + obj.name,
					Value: obj.tankerId,
					Selected: obj.selected,
					dayOfWeek: day
				};
			});
		}
	}, {
		key: 'sameForAll',
		value: function sameForAll() {
			var _this6 = this;

			this.contractDays = [];

			this.weekdays.forEach(function (data) {
				_this6.contractDays[data.value] = data;
			});

			if (this.model.sameForAll) {
				this.assignedTankers = {};
				for (var day in this.contractDays) {
					if (this.contractDays[day]) {
						for (var key in this.model[day]) {
							this.model[day][key] = '';
						}
					}
				}
			}
		}
	}, {
		key: 'updateAll',
		value: function updateAll(selectedDay, opt, weekday) {
			var _this7 = this;

			this.assignedTankers = {};
			if (this.model.sameForAll) {
				if (this.contractDays[selectedDay]) {
					var _loop = function _loop(day) {
						if (_this7.contractDays[day] && _this7.model[selectedDay][opt]) {
							_this7.dayArray.filter(function (d) {
								if (_.find(d[day], { Value: _this7.model[selectedDay][opt].Value })) {
									_this7.model[day].tankerId = _this7.model[selectedDay][opt];
								}
							});
						}
					};

					for (var day in this.contractDays) {
						_loop(day);
					}
				}
			}
			this.weekdays.forEach(function (day, index) {
				if (_this7.model[day.value].tankerId) {
					_this7.model[day.value].tankerId.dayOfWeek = day.day;
					_this7.model[day.value].tankerId.Selected = 1;

					_this7.dayArray.filter(function (d) {
						if (_.find(d[day.value], { Value: _this7.model[day.value].tankerId.Value })) {
							_this7.assignedTankers[_this7.model[day.value].tankerId.dayOfWeek] = _this7.model[day.value].tankerId.Value;
						}
					});
				}
			});
		}
	}, {
		key: 'assignTankers',
		value: function assignTankers() {
			var _this8 = this;

			this.weekdays.forEach(function (day, index) {
				if (_this8.model[day.value].tankerId) {
					_this8.assignedTankers[_this8.model[day.value].tankerId.dayOfWeek] = _this8.model[day.value].tankerId.Value;
				}
			});
			// console.log(this.assignedTankers);
		}

		// (remove below two functions if you want new logic as per card #3451)

	}, {
		key: 'upsertTankerAssignment',
		value: function upsertTankerAssignment() {
			if (this.model.requireThrow) this.assignTankers();else this.assignedTankers = {};
		}
	}, {
		key: 'resetTankerAssignment',
		value: function resetTankerAssignment() {
			var _this9 = this;

			this.weekdays.forEach(function (d, index) {
				if (_this9.model[d.value]) _this9.model[d.value].tankerId = null;
			});
		}

		// (uncomment a below two functions if you want new logic as per card #3451)
		// upsertTankerAssignment() {
		// 	if (this.model.requireThrow || this.model.checkOutByTanker) this.assignTankers();
		// 	else this.assignedTankers = {};
		// }

		// resetTankerAssignment() {
		// 	if (!this.model.requireThrow && !this.model.checkOutByTanker) {
		// 		this.weekdays.forEach((d, index) => {
		// 			if (this.model[d.value]) this.model[d.value].tankerId = null;
		// 		})
		// 	}
		// }

	}, {
		key: 'validateToggles',
		value: function validateToggles() {
			this.model.autoThrowOnPack = this.model.requireThrow ? this.model.autoThrowOnPack : false;
		}
	}, {
		key: 'getAllTrucks',
		value: function getAllTrucks() {
			var _this10 = this;

			this.TruckService.getRestrictTrucks('', this.model.branch, null, 1000, 0).then(function (data) {
				_this10.truckOptions.totalRecords = data.total;
				_this10.truckOptions.options = _this10.mappingTruckData(data.results, '');
			});
		}
	}, {
		key: 'createRouteObjects',
		value: function createRouteObjects() {
			var _this11 = this;

			this.routeDays = this.routeDays.map(function (route, index) {
				return {
					key: _this11.$translate.instant('location.' + _this11.dayKeys[index].toLowerCase()),
					value: route,
					tick: false
				};
			});
		}
	}, {
		key: 'isDaySelected',
		value: function isDaySelected(day) {
			day.tick = !day.tick;
		}
	}, {
		key: 'loadInternalLocations',
		value: function loadInternalLocations(searchKey, offset) {
			var _this12 = this;

			searchKey = searchKey || '';

			var locationSearchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: '=',
						data: this.model.branch
					}, {
						field: 'locationType',
						condition: '=',
						data: 'INTERNAL'
					}, {
						field: 'active',
						condition: '=',
						data: true
					}, {
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'name',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};

			this.isLoadingInternalLocations = true;
			this.LocationService.getAllLocation(locationSearchObj, offset, this.AppConstants.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this12.internalLocationsObj.totalRecords = data.total;
					_this12.internalLocationsObj.results = _this12.locMapping(data.results);
				} else {
					var locations = _this12.locMapping(data.results);
					_this12.internalLocationsObj.results = _this12.internalLocationsObj.results.concat(locations);
				}
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this12.isLoadingInternalLocations = false;
			});
		}
	}, {
		key: 'locMapping',
		value: function locMapping(locations) {
			return locations.map(function (l) {
				return {
					Key: l.id + " | " + l.name,
					Value: l.id
				};
			});
		}
	}, {
		key: 'restrictToTruckChanged',
		value: function restrictToTruckChanged() {
			if (!this.model.restrictToTruck) {
				this.model.restrictTruck = null;
				this.restrictTruckAddress = null;
			} else {
				this.restrictTruckChanged();
			}
		}
	}, {
		key: 'restrictTruckChanged',
		value: function restrictTruckChanged() {
			var _this13 = this;

			this.restrictTruckAddress = null;
			var restrictTruck = this.model.restrictTruck;
			if (restrictTruck && (typeof restrictTruck === 'string' || typeof restrictTruck === 'number')) {
				restrictTruck = _.find(this.truckOptions.options, { Value: restrictTruck }) || _.find(this.truckOptions.options, { id: restrictTruck });
			}
			if (restrictTruck && restrictTruck.locationId) {
				this.LocationService.get(restrictTruck.locationId).then(function (location) {
					if (location.address || location.city || location.state || location.zip) {
						_this13.restrictTruckAddress = (location.address || '') + ', ' + (location.city || '') + ', ' + (location.state || '') + ' ' + (location.zip || '');
					} else {
						_this13.restrictTruckAddress = null;
					}
				}).catch(function (err) {
					console.log(err);
				});
			}
		}
	}]);
	return RoutesCreateController;
}(_routesBase2.default);

var _initialiseProps = function _initialiseProps() {
	var _this14 = this;

	this.ismeridian = true;

	this.toggleMode = function () {
		$scope.ismeridian = !$scope.ismeridian;
	};

	this.mappingTruckData = function (trucks, searchKey) {
		var truckArray = [];
		trucks.map(function (truck) {
			truck.Key = truck.id + " | " + truck.make;
			truck.Value = truck.id;
			if (!searchKey) {
				if (_this14.model.restrictTruck) {
					if (truck.id !== _this14.model.restrictTruck) {
						truckArray.push(truck);
					}
				} else {
					truckArray.push(truck);
				}
			} else {
				truckArray.push(truck);
			}
		});
		return truckArray;
	};
};

exports.default = RoutesCreateController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _routesEdit = __webpack_require__(2032);

var _routesEdit2 = _interopRequireDefault(_routesEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routesEditModule = angular.module('routesedit', []).component('routesedit', _routesEdit2.default).name;

exports.default = routesEditModule;

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routesEdit = __webpack_require__(2775);

var _routesEdit2 = _interopRequireDefault(_routesEdit);

var _routesEdit3 = __webpack_require__(2033);

var _routesEdit4 = _interopRequireDefault(_routesEdit3);

__webpack_require__(3054);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeseditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _routesEdit2.default,
  controller: _routesEdit4.default
};

exports.default = routeseditComponent;

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _routesBase = __webpack_require__(270);

var _routesBase2 = _interopRequireDefault(_routesBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoutesEditController = function (_RoutesBaseController) {
	RoutesEditController.$inject = ["Auth", "$state", "User", "RouteService", "Modal", "$translate", "$stateParams", "BranchService", "$scope", "DateUtil", "SetupService", "UserBranchService", "$q", "TruckService", "LocationService", "AppConstants", "RouteDetailService"];
	(0, _inherits3.default)(RoutesEditController, _RoutesBaseController);

	/*@ngInject*/
	function RoutesEditController(Auth, $state, User, RouteService, Modal, $translate, $stateParams, BranchService, $scope, DateUtil, SetupService, UserBranchService, $q, TruckService, LocationService, AppConstants, RouteDetailService) {
		(0, _classCallCheck3.default)(this, RoutesEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (RoutesEditController.__proto__ || (0, _getPrototypeOf2.default)(RoutesEditController)).call(this, Auth, $state, User, RouteService, Modal, $translate, $stateParams, TruckService));

		_this.getDate = function (time) {
			if (!time) {
				return time;
			}

			time = time.split(':');

			var d = new Date();

			d.setHours(+time[0]);
			d.setMinutes(time[1]);
			d.setSeconds(0);
			d.setMilliseconds(0);

			return d;
		};

		_this.getDateWithSeconds = function (time) {
			if (!time) {
				return time;
			}

			time = time.split(':');

			var d = new Date();

			d.setHours(+time[0]);
			d.setMinutes(time[1]);
			d.setSeconds(+time[2]);
			d.setMilliseconds(0);

			return d;
		};

		_this.getUTCDate = function (time) {
			if (!time) return time;

			var _time$split$map = time.split(':').map(Number),
			    _time$split$map2 = (0, _slicedToArray3.default)(_time$split$map, 2),
			    h = _time$split$map2[0],
			    m = _time$split$map2[1];

			var d = new Date(Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate(), h, m, 0, 0));

			return d;
		};

		_this.mappingTruckData = function (trucks) {
			trucks.map(function (truck) {
				truck.Key = truck.id + " | " + truck.make;
				truck.Value = truck.id;
			});
			return trucks;
		};

		_this.TruckService = TruckService;
		_this.BranchService = BranchService;
		_this.RouteDetailService = RouteDetailService;
		_this.model.id = '';
		_this.model.day = '';
		_this.model.name = '';
		_this.model.shortName = '';
		_this.model.branch = null;
		_this.branchId = User.getUser().branchId;
		_this.model.loggedInUser = User.getUser().id;
		_this.branch = [];
		_this.loading = false;
		_this.loadingRouteSequence = false;
		_this.loadRoutes = [];
		_this.markerPosition = [];
		_this.originationMarker = null;
		_this.branchOrigination = null;
		_this.originationLocationRequest = 0;
		_this.hasACL = {};
		_this.DateUtil = DateUtil;
		_this.SetupService = SetupService;
		_this.UserBranchService = UserBranchService;
		_this.LocationService = LocationService;
		_this.AppConstants = AppConstants;
		_this.map = null;
		_this.Modal = Modal;
		_this.internalLocationsObj = {
			results: [],
			totalRecords: 0
		};
		_this.$scope = $scope;
		_this.$q = $q;
		_this.days = [{ label: _this.$translate.instant('location.sun'), value: 'Sun' }, { label: _this.$translate.instant('location.mon'), value: 'Mon' }, { label: _this.$translate.instant('location.tues'), value: 'Tue' }, { label: _this.$translate.instant('location.wed'), value: 'Wed' }, { label: _this.$translate.instant('location.thurs'), value: 'Thu' }, { label: _this.$translate.instant('location.fri'), value: 'Fri' }, { label: _this.$translate.instant('location.sat'), value: 'Sat' }, { label: _this.$translate.instant('location.hol'), value: 'Hol' }];

		_this.weekdays = [{
			label: _this.$translate.instant('location.mon'),
			value: 'Mon',
			day: 2
		}, {
			label: _this.$translate.instant('location.tues'),
			value: 'Tue',
			day: 3
		}, {
			label: _this.$translate.instant('location.wed'),
			value: 'Wed',
			day: 4
		}, {
			label: _this.$translate.instant('location.thurs'),
			value: 'Thu',
			day: 5
		}, {
			label: _this.$translate.instant('location.fri'),
			value: 'Fri',
			day: 6
		}, {
			label: _this.$translate.instant('location.sat'),
			value: 'Sat',
			day: 7
		}, {
			label: _this.$translate.instant('location.sun'),
			value: 'Sun',
			day: 1
		}];

		_this.day = {
			routeId: []
		};

		_this.selectedDay = 'Mon';

		_this.routeSequenceLocations = [];
		_this.routeSequenceLocationData = [];
		_this.routeSequenceData = [];
		_this.sequenceInput = [];
		_this.actualLong = "";
		_this.actualLat = "";
		_this.locationInfo = "";
		_this.valutDate = "";
		_this.currrentSelectedDay = "";
		_this.centerLattitude = "";
		_this.centerLongitude = "";
		_this.isInitialized = true;
		_this.unshiftSelected = true;
		_this.assignedTankers = {};
		_this.contractDays = [];
		_this.currentlyAssignedTankers = {};
		_this.isTankerAssignmentChanged = false;
		_this.updatedTankerAssignment = {};
		_this.previouslyAssignedTanker = {};
		_this.newAssignedTanker = {};
		_this.selectedLocations = [];
		_this.truckOptions = {
			options: [],
			totalRecords: 0
		};
		_this.originationOptions = [{
			label: 'Branch',
			value: 'BRANCH'
		}, {
			label: 'Truck',
			value: 'TRUCK'
		}, {
			label: 'User',
			value: 'USER'
		}];
		_this.routeDays = ["routeSun", "routeMon", "routeTue", "routeWed", "routeThu", "routeFri", "routeSat", "routeHol"];
		_this.dayKeys = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat", "Hol"];
		return _this;
	}

	(0, _createClass3.default)(RoutesEditController, [{
		key: 'loadImage',
		value: function loadImage(image) {
			this.icon = {
				'REGULAR': 'regular.png',
				'ATM': 'atm.png',
				'BANK': 'bank.png',
				'NO_SHIP_NO_GO': 'nsng.png',
				'INTERNAL': 'internal.png',
				'TRUCK': 'truck.png',
				'TANKER': 'tanker.png',
				'WINDOW': 'window.png',
				'CARRIER': 'carrier.png',
				'ON_CALL': 'oncall.png',
				'LOCKER': 'locker.png',
				'VAULT': 'vault.png',
				'DELIVERY': 'delivery.png'
			};

			var imgURL = this.icon[image];
			return __webpack_require__(51)("./" + imgURL);
		}
	}, {
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			var branchDefer = this.$q.defer();
			this.loading = true;
			this.selectedDay = this.$stateParams.day;

			this.$q.all([this.Service.get(this.$stateParams.id), this.UserBranchService.getUserBranches(this.model.loggedInUser), this.getPendingRouteChanges()]).then(function (data) {
				_this2.loading = false;
				_this2.defaultModel = data[0];
				_this2.rawId = data[0].id;
				_this2.model.id = data[0].id;
				_this2.model.name = data[0].name;
				_this2.model.shortName = data[0].shortName;
				_this2.model.active = data[0].active;
				_this2.model.loadTruck = data[0].loadTruck;
				_this2.model.beginTime = _this2.getDate(data[0].beginTime);
				_this2.model.branch = data[0].branchId;
				_this2.model.description = data[0].description;
				_this2.model.holdRoute = data[0].holdRoute;
				_this2.model.requireDriver = data[0].requireDriver;
				_this2.model.requireGuard = data[0].requireGuard;
				_this2.model.specialFlag = data[0].specialFlag;
				_this2.model.uploadOnEndRouteOnly = data[0].uploadOnEndRouteOnly;
				_this2.model.autoOptimize = data[0].autoOptimize;
				_this2.model.autoOpenATMs = data[0].autoOpenATMs;
				_this2.model.bagoutFlag = data[0].bagoutFlag;
				_this2.model.requireLoadedAmount = data[0].requireLoadedAmount;
				_this2.model.requireResidualScan = data[0].requireResidualScan;
				_this2.model.requireBranchScan = data[0].requireBranchScan;
				_this2.model.requireThrow = data[0].requireThrow;
				_this2.model.eventRoute = data[0].eventRoute;
				_this2.model.shuttleRoute = data[0].shuttleRoute;
				_this2.model.liabilityLimit = data[0].liabilityLimit;
				_this2.model.sameForAll = false;
				_this2.model.autoCheckIn = data[0].autoCheckIn;
				_this2.model.autoCheckOut = data[0].autoCheckOut;
				_this2.model.checkOutByTanker = data[0].checkOutByTanker || false;
				_this2.model.autoCheckInUpdate = data[0].autoCheckInUpdate;
				_this2.model.autoThrowOnPack = data[0].autoThrowOnPack;
				_this2.model.NFCScan = data[0].NFCScan;
				_this2.model.NFCTagId = data[0].NFCTagId;
				_this2.model.requireTruckScan = data[0].requireTruckScan;
				_this2.model.bagoutOnTruck = data[0].bagoutOnTruck;
				_this2.model.routeCutOff = data[0].routeCutOff;
				_this2.model.routeCutOffTime = _this2.getDate(data[0].routeCutOffTime);
				_this2.model.restrictToTruck = data[0].restrictToTruck, _this2.model.restrictTruck = data[0].restrictTruckId ? {
					Key: data[0].restrictTruck.id + ' | ' + data[0].restrictTruck.make,
					Value: data[0].restrictTruckId,
					locationId: data[0].restrictTruck.locationId
				} : null;
				_this2.restrictTruckChanged();
				_this2.model.optimizeAfterStop = data[0].optimizeAfterStop;
				_this2.model.autoSendPickupManifest = data[0].autoSendPickupManifest || false;
				_this2.model.pickupManifestRecipientEmail = data[0].pickupManifestRecipientEmail;
				_this2.model.origination = data[0].origination;
				_this2.model.sendRouteSheet = data[0].sendRouteSheet || false;
				_this2.model.routeSheetRecipients = data[0].routeSheetRecipients;
				_this2.model.scanUserItems = data[0].scanUserItems || false;
				_this2.model.maxRouteTime = _this2.getDate(data[0].maxRouteTime);
				_this2.model.maxMileage = data[0].maxMileage;
				_this2.model.estimatedRouteSpeed = data[0].estimatedRouteSpeed;
				_this2.model.lunch = data[0].lunch;
				_this2.model.lunchMinutes = _this2.getDateWithSeconds(data[0].lunchMinutes);
				_this2.model.lunchInTruck = data[0].lunchInTruck;
				_this2.model.break = data[0].break;
				_this2.model.breakMinutes = _this2.getDateWithSeconds(data[0].breakMinutes);
				_this2.model.breakInTruck = data[0].breakInTruck;
				_this2.model.rescheduleDeliveries = data[0].rescheduleDeliveries;
				_this2.model.autoTransferAndClose = data[0].autoTransferAndClose || false;
				_this2.model.rescheduleHoldLocationId = data[0].rescheduleDeliveries && data[0].rescheduleHoldLocation ? { Key: data[0].rescheduleHoldLocation.id + ' | ' + data[0].rescheduleHoldLocation.name, Value: data[0].rescheduleHoldLocation.id } : null;
				data[1].results.map(function (b) {
					return _this2.branch.push(b.branchId);
				});
				branchDefer.resolve(_this2.model.branch);
			}).then(function () {
				_this2.loadRouteSequence();
				_this2.getAllTrucks();
				_this2.createRouteObjects();
				_this2.loadInternalLocations();
			}).catch(function (err) {
				console.log(err);
			});

			branchDefer.promise.then(function (branch) {
				_this2.getSetupDetails(branch);
				_this2.getAvailableTankers('', 0);
			}).finally(function () {
				_this2.loading = false;
			});
		}
	}, {
		key: 'getSetupDetails',
		value: function getSetupDetails(branch) {
			var _this3 = this;

			this.SetupService.get(branch).then(function (setup) {
				var date = _this3.DateUtil.convertToDate(setup.currentVaultDate);
				_this3.model.branchTimezone = setup.timezone;
				_this3.valutDate = moment(date).format('YYYY-MM-DD');
				_this3.branchOrigination = _this3.getOriginationPoint(setup, {
					id: branch,
					name: branch,
					address: setup.address,
					city: setup.city,
					state: setup.state,
					zip: setup.zip,
					lat: setup.gpsLat,
					long: setup.gpsLong
				});
				_this3.refreshOriginationMarker();
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'getBranchTime',
		value: function getBranchTime(input, targetTz) {
			var utcMoment = void 0;
			if (!input) return input;
			if (input instanceof Date) {
				utcMoment = moment.utc(input);
			} else if (typeof input === 'string' && input.includes('GMT')) {
				utcMoment = moment.utc(new Date(input));
			} else {
				var todayUtc = moment.utc().format('YYYY-MM-DD');
				utcMoment = moment.utc(todayUtc + 'T' + input + 'Z');
			}

			return utcMoment.tz(targetTz).toDate();
		}
	}, {
		key: 'loadRouteSequence',
		value: function loadRouteSequence() {
			var _this4 = this;

			this.loadingRouteSequence = true;
			this.routePosition = 0;
			this.lat = 0;
			this.long = 0;
			this.totalLatLongLocations = 0;
			this.selectedLocations = [];
			var selectedDay = 'defRouteSeq' + this.selectedDay;

			this.Service.getRouteSequence(this.rawId, this.model.branch, this.selectedDay).then(function (routeSequenceLocations) {
				_this4.loadingRouteSequence = false;
				_this4.routeSequenceData = routeSequenceLocations;
				if (_this4.routeSequenceData.length) {
					_this4.routeSequenceData.sort(function (a, b) {
						return a[selectedDay] - b[selectedDay];
					}).forEach(function (data) {
						_this4.selectedLocations.push({
							locationId: data.id,
							locationName: data.name
						});
						if (data.lat && data.long) {
							_this4.totalLatLongLocations += 1;
							_this4.lat += data.lat;
							_this4.long += data.long;
						}
					});
				}
			}).then(function () {
				_this4.refreshSequenceInputs();
				_this4.getRouteSequenceData(_this4.routeSequenceData);
			}).catch(function (err) {
				_this4.loadingRouteSequence = false;
				console.log(err);
			}).finally(function () {
				_this4.loadingRouteSequence = false;
			});
		}
	}, {
		key: 'getRouteSequenceData',
		value: function getRouteSequenceData(routeSequenceData) {
			var _this5 = this;

			this.routePosition = 0;
			this.centerLattitude = this.lat / this.totalLatLongLocations || 39.68649209557518;
			this.centerLongitude = this.long / this.totalLatLongLocations || -101.48273981764913;

			if (this.isInitialized) {
				this.map = L.map('map', {
					center: [this.centerLattitude, this.centerLongitude],
					zoom: 11
				});
				L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
					attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				}).addTo(this.map);
			} else {
				this.markerPosition.forEach(function (id) {
					_this5.map.removeLayer(id);
				});
				this.markerPosition = [];
			}

			routeSequenceData.forEach(function (sequenceData) {
				if (sequenceData && sequenceData.lat && sequenceData.long) {
					_this5.routePosition = _.findIndex(routeSequenceData, { id: sequenceData.id }) + 1;
					_this5.actualLat = sequenceData.lat;
					_this5.actualLong = sequenceData.long;
					_this5.locationInfo = '<strong>' + sequenceData.name + '</strong>' + '<br>' + sequenceData.address + ' - ' + sequenceData.zip + '<br>' + sequenceData.city + ', ' + sequenceData.state;

					var id = L.marker([_this5.actualLat, _this5.actualLong], {
						icon: new L.AwesomeNumberMarkers({
							number: _this5.routePosition,
							markerColor: "blue"
						})
					}).addTo(_this5.map).bindPopup(_this5.locationInfo);

					id.on('mouseover', function () {
						id.openPopup();
					});

					id.on('mouseout', function () {
						id.closePopup();
					});

					_this5.markerPosition.push(id);
				}
			});
			this.refreshOriginationMarker();
		}
	}, {
		key: 'refreshSequenceInputs',
		value: function refreshSequenceInputs() {
			this.sequenceInput = this.routeSequenceData.map(function (location, position) {
				return position + 1;
			});
		}
	}, {
		key: 'routeSequenceLocationMoved',
		value: function routeSequenceLocationMoved(index) {
			this.isInitialized = false;
			this.routeSequenceData.splice(index, 1);
			this.refreshSequenceInputs();
			this.getRouteSequenceData(this.routeSequenceData);
		}
	}, {
		key: 'moveLocationToIndex',
		value: function moveLocationToIndex(index, targetIndex) {
			var list = this.routeSequenceData;

			if (targetIndex < 0 || targetIndex >= list.length || targetIndex === index) {
				return this.refreshSequenceInputs();
			}

			this.isInitialized = false;
			list.splice(targetIndex, 0, list.splice(index, 1)[0]);
			this.refreshSequenceInputs();
			this.getRouteSequenceData(list);
		}
	}, {
		key: 'moveLocation',
		value: function moveLocation(index, offset) {
			this.moveLocationToIndex(index, index + offset);
		}
	}, {
		key: 'sequenceTyped',
		value: function sequenceTyped(index) {
			var typed = this.sequenceInput[index];

			if (typeof typed !== 'number' || isNaN(typed)) return this.refreshSequenceInputs();

			this.moveLocationToIndex(index, Math.round(typed) - 1);
		}
	}, {
		key: 'selectDay',
		value: function selectDay(day) {
			this.reInitializeMap();
			this.selectedDay = day.value;
			this.currrentSelectedDay = 'defRouteSeq' + day.value;
			this.loadRouteSequence();
		}
	}, {
		key: 'editLocation',
		value: function editLocation(location) {
			this.$state.go('location.edit', {
				id: location.id
			});
		}
	}, {
		key: 'getSelectedDay',
		value: function getSelectedDay() {
			var _this6 = this;

			var selectedDayLabel = '';
			this.days.some(function (day) {
				if (day.value === _this6.selectedDay) {
					selectedDayLabel = day.label;
					return true;
				}
			});
			return selectedDayLabel;
		}
	}, {
		key: 'routeTransferView',
		value: function routeTransferView() {
			var _this7 = this;

			this.isLoading = true;
			this.Modal.routeTransfer(this.$stateParams.id, this.$stateParams.day, this.valutDate, function (_ref) {
				var modal = _ref.modal,
				    routeChangeData = _ref.routeChangeData,
				    routeChangeSequence = _ref.routeChangeSequence,
				    routeDay = _ref.routeDay,
				    routeSequence = _ref.routeSequence;

				_this7.Service.routeLocTransfer(routeChangeData).then(function (data) {
					_this7.markerPosition.forEach(function (id) {
						_this7.map.removeLayer(id);
					});
				}).then(function () {
					_this7.updateRoutePosition(routeSequence, routeChangeSequence, routeDay);
					_this7.reInitializeMap();
					_this7.isLoading = false;
				}).catch(function (err) {
					console.log(err);
					_this7.isLoading = false;
				});
			}, function (_ref2) {
				var modal = _ref2.modal;

				if (modal) modal.close();
				_this7.isLoading = false;
			});
		}
	}, {
		key: 'updateRoutePosition',
		value: function updateRoutePosition(routeSequence, routeChangeSequence, routeDay) {
			var _this8 = this;

			this.Service.update(this.$stateParams.id, {
				day: routeDay,
				routeSequenceLocation: routeSequence.map(function (location) {
					return location.id;
				}),
				routeSequenceLocationTwo: routeChangeSequence.map(function (location) {
					return location.id;
				})
			}).then(function (data) {
				_this8.loadRouteSequence();
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.getAvailableTankers('', 0);
			this.model = angular.copy(this.defaultModel);
			this.model.branch = this.User.getUser().branchId;
			this.model.loggedInUser = this.User.getUser().id;
			this.model.beginTime = this.getDate(this.model.beginTime);
			this.model.routeCutOffTime = this.getDate(this.model.routeCutOffTime);
			this.model.maxRouteTime = this.getDate(this.model.maxRouteTime);
			this.model.lunchMinutes = this.getDate(this.model.lunchMinutes);
			this.model.breakMinutes = this.getDate(this.model.breakMinutes);
			this.model.restrictTruck = this.defaultModel.restrictTruckId ? {
				Key: this.defaultModel.restrictTruck.id + ' | ' + this.defaultModel.restrictTruck.make,
				Value: this.defaultModel.restrictTruckId,
				locationId: this.defaultModel.restrictTruck.locationId
			} : null;
			this.currentlyAssignedTankers = {};
			this.isTankerAssignmentChanged = false;
			this.updatedTankerAssignment = {};
			this.model.rescheduleHoldLocationId = this.defaultModel.rescheduleHoldLocationId ? {
				Key: this.defaultModel.rescheduleHoldLocation.id + ' | ' + this.defaultModel.rescheduleHoldLocation.name,
				Value: this.defaultModel.rescheduleHoldLocationId
			} : null;
			this.refreshOriginationMarker();
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this9 = this;

			this.upsertTankerAssignment();
			this.loading = true;
			this.routeDays.forEach(function (route) {
				return _this9.model[route.value] = route.tick;
			});

			this.Service.update(this.rawId, {
				id: this.rawId,
				name: this.model.name,
				shortName: this.model.shortName,
				active: this.model.active,
				beginTime: this.model.beginTime ? moment(this.model.beginTime).format('HH:mm:ss') : null,
				branchId: this.model.branch,
				holdRoute: this.model.holdRoute,
				loadTruck: this.model.loadTruck,
				description: this.model.description,
				requireDriver: this.model.requireDriver,
				requireGuard: this.model.requireGuard,
				specialFlag: this.model.specialFlag,
				uploadOnEndRouteOnly: this.model.uploadOnEndRouteOnly,
				autoOptimize: this.model.autoOptimize,
				autoOpenATMs: this.model.autoOpenATMs,
				bagoutFlag: this.model.bagoutFlag,
				requireLoadedAmount: this.model.requireLoadedAmount,
				requireResidualScan: this.model.requireResidualScan,
				requireBranchScan: this.model.requireBranchScan,
				requireThrow: this.model.requireThrow,
				eventRoute: this.model.eventRoute,
				shuttleRoute: this.model.shuttleRoute,
				liabilityLimit: this.model.liabilityLimit || null,
				day: this.selectedDay,
				routeSequenceLocation: this.routeSequenceData.map(function (location) {
					return location.id;
				}),
				routeSequenceLocationTwo: [],
				vaultDate: this.valutDate,
				assignedTankers: this.assignedTankers,
				previouslyAssignedTanker: this.previouslyAssignedTanker,
				newAssignedTanker: this.newAssignedTanker,
				isTankerAssignmentChanged: this.isTankerAssignmentChanged,
				autoCheckIn: this.model.autoCheckIn,
				autoCheckOut: this.model.autoCheckOut,
				checkOutByTanker: this.model.checkOutByTanker,
				autoCheckInUpdate: this.model.autoCheckInUpdate,
				autoThrowOnPack: this.model.autoThrowOnPack,
				NFCScan: this.model.NFCScan,
				NFCTagId: this.model.NFCScan ? this.model.NFCTagId : null,
				requireTruckScan: this.model.requireTruckScan,
				bagoutOnTruck: this.model.bagoutOnTruck,
				routeCutOff: this.model.routeCutOff,
				routeCutOffTime: this.model.routeCutOff && this.model.routeCutOffTime ? moment(this.model.routeCutOffTime).format('HH:mm:ss') : null,
				restrictToTruck: this.model.restrictToTruck,
				restrictTruckId: this.model.restrictToTruck && this.model.restrictTruck ? this.model.restrictTruck.id : null,
				optimizeAfterStop: this.model.optimizeAfterStop,
				autoSendPickupManifest: this.model.autoSendPickupManifest,
				pickupManifestRecipientEmail: this.model.pickupManifestRecipientEmail,
				origination: this.model.origination,
				routeMon: this.model.routeMon,
				routeTue: this.model.routeTue,
				routeWed: this.model.routeWed,
				routeThu: this.model.routeThu,
				routeFri: this.model.routeFri,
				routeSat: this.model.routeSat,
				routeSun: this.model.routeSun,
				routeHol: this.model.routeHol,
				sendRouteSheet: this.model.sendRouteSheet,
				routeSheetRecipients: this.model.sendRouteSheet ? this.model.routeSheetRecipients : null,
				timezone: this.model.branchTimezone,
				scanUserItems: this.model.scanUserItems,
				maxRouteTime: this.model.maxRouteTime ? moment(this.model.maxRouteTime).format('HH:mm:ss') : null,
				maxMileage: this.model.maxMileage,
				estimatedRouteSpeed: this.model.estimatedRouteSpeed,
				lunch: this.model.lunch,
				lunchMinutes: this.model.lunch && this.model.lunchMinutes ? moment(this.model.lunchMinutes).format('00:mm:ss') : null,
				lunchInTruck: this.model.lunch ? this.model.lunchInTruck : false,
				break: this.model.break,
				breakMinutes: this.model.break && this.model.breakMinutes ? moment(this.model.breakMinutes).format('00:mm:ss') : null,
				breakInTruck: this.model.break ? this.model.breakInTruck : false,
				rescheduleDeliveries: this.model.rescheduleDeliveries,
				autoTransferAndClose: this.model.autoTransferAndClose,
				rescheduleHoldLocationId: this.model.rescheduleDeliveries && this.model.rescheduleHoldLocationId ? this.model.rescheduleHoldLocationId.Value : null
			}).then(function (data) {
				_this9.loading = false;
				// this.$state.go('routeControl')
				window.history.go(-1);
			}).catch(function (err) {
				_this9.loading = false;
				var errorPath = err && err.data && err.data.errors && err.data.errors[0].path;

				if (errorPath === 'ROUTE.NFCTagId') {
					_this9.errorMessage = _this9.$translate.instant('common.unique_nfc_tag_id');
				} else if (err && err.data && err.data.message) {
					_this9.errorMessage += err.data.message + '<br/>';
				} else {
					err.data.errors.map(function (e) {
						_this9.errorMessage += e.message + '<br/>';
					});
				}
			});
		}
	}, {
		key: 'getAvailableTankers',
		value: function getAvailableTankers(searchKey, offset) {
			var _this10 = this;

			this.dayArray = [], this.total = [];
			this.Service.getTankersAvailable(this.rawId).then(function (res) {
				_this10.model.tankers = res;
				_this10.weekdays.forEach(function (d, index) {
					if (offset == 0 || offset == undefined) {
						_this10.total.push((0, _defineProperty3.default)({}, d.value, {
							total: res[d.day].length
						}));
						_this10.dayArray.push((0, _defineProperty3.default)({}, d.value, _this10.mapRouteTankers(res[d.day], searchKey, d.day)));
						_this10.dayArray[index][d.value].filter(function (data) {
							if (data.Selected) {
								_this10.model[d.value].tankerId = data;
								(0, _assign2.default)(_this10.currentlyAssignedTankers, new Object((0, _defineProperty3.default)({}, d.value, _this10.model[d.value].tankerId.Value)));
							}
						});
					}
				});
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'mapRouteTankers',
		value: function mapRouteTankers(mapArray, searchKey, day) {
			return mapArray.map(function (obj) {
				return {
					Key: obj.tankerId + ' | ' + obj.name,
					Value: obj.tankerId,
					Selected: obj.selected,
					dayOfWeek: day
				};
			});
		}
	}, {
		key: 'sameForAll',
		value: function sameForAll() {
			var _this11 = this;

			this.contractDays = [];
			this.weekdays.forEach(function (data) {
				_this11.contractDays[data.value] = data;
			});

			if (this.model.sameForAll) {
				this.assignedTankers = {};
				for (var day in this.contractDays) {
					if (this.contractDays[day]) {
						for (var key in this.model[day]) {
							this.model[day][key] = '';
						}
					}
				}
			}
			this.findTankerAssignmentChange();
		}
	}, {
		key: 'updateAll',
		value: function updateAll(selectedDay, opt, weekday) {
			var _this12 = this;

			this.assignedTankers = {};
			if (this.model.sameForAll) {
				if (this.contractDays[selectedDay]) {
					var _loop = function _loop(day) {
						if (_this12.contractDays[day] && _this12.model[selectedDay][opt]) {
							_this12.dayArray.filter(function (d) {
								if (_.find(d[day], { Value: _this12.model[selectedDay][opt].Value })) {
									_this12.model[day].tankerId = _this12.model[selectedDay][opt];
								}
							});
						}
					};

					for (var day in this.contractDays) {
						_loop(day);
					}
				}
			}
			this.weekdays.forEach(function (day, index) {
				if (_this12.model[day.value].tankerId) {
					_this12.model[day.value].tankerId.dayOfWeek = day.day;
					_this12.model[day.value].tankerId.Selected = 1;

					_this12.dayArray.filter(function (d) {
						if (_.find(d[day.value], { Value: _this12.model[day.value].tankerId.Value })) {
							_this12.assignedTankers[_this12.model[day.value].tankerId.dayOfWeek] = _this12.model[day.value].tankerId.Value;
						}
					});
				}
			});
			this.findTankerAssignmentChange();
		}
	}, {
		key: 'assignTankers',
		value: function assignTankers() {
			var _this13 = this;

			this.weekdays.forEach(function (day, index) {
				if (_this13.model[day.value].tankerId) {
					_this13.assignedTankers[_this13.model[day.value].tankerId.dayOfWeek] = _this13.model[day.value].tankerId.Value;
				}
			});
			// console.log(this.assignedTankers);
		}

		// (remove below two functions if you want new logic as per card #3451)

	}, {
		key: 'upsertTankerAssignment',
		value: function upsertTankerAssignment() {
			if (this.model.requireThrow) {
				this.assignTankers();
				this.findTankerAssignmentChange();
			} else this.assignedTankers = {};
		}
	}, {
		key: 'resetTankerAssignment',
		value: function resetTankerAssignment() {
			var _this14 = this;

			this.weekdays.forEach(function (d, index) {
				if (_this14.model[d.value]) _this14.model[d.value].tankerId = null;
			});
		}

		// (uncomment a below two functions if you want new logic as per card #3451)
		// upsertTankerAssignment() {
		// 	if (this.model.requireThrow || this.model.checkOutByTanker) {
		// 		this.assignTankers();
		// 		this.findTankerAssignmentChange();
		// 	}
		// 	else this.assignedTankers = {};
		// }

		// resetTankerAssignment() {
		// 	if (!this.model.requireThrow && !this.model.checkOutByTanker) {
		// 		this.weekdays.forEach((d, index) => {
		// 			if (this.model[d.value]) this.model[d.value].tankerId = null;
		// 		})
		// 	}
		// }

	}, {
		key: 'reInitializeMap',
		value: function reInitializeMap() {
			var _this15 = this;

			this.removeOriginationMarker();
			this.map.remove();
			this.isInitialized = true;
			this.markerPosition.forEach(function (id) {
				_this15.map.removeLayer(id);
			});
			this.markerPosition = [];
		}
	}, {
		key: 'findDifference',
		value: function findDifference(object, base) {
			var _this16 = this;

			return _.transform(object, function (result, value, key) {
				if (!_.isEqual(value, base[key])) {
					result[key] = _.isObject(value) && _.isObject(base[key]) ? _this16.findDifference(value, base[key]) : value;
				}
			});
		}
	}, {
		key: 'findTankerAssignmentChange',
		value: function findTankerAssignmentChange() {
			var _this17 = this;

			this.updatedTankerAssignment = {};
			this.createRecords = [];
			this.updateRecords = [];
			this.deleteRecords = [];
			this.dayOfWeekObj = { 'Sun': 1, 'Mon': 2, 'Tue': 3, 'Wed': 4, 'Thu': 5, 'Fri': 6, 'Sat': 7 };

			this.weekdays.forEach(function (day, index) {
				if (_this17.model[day.value].tankerId) (0, _assign2.default)(_this17.updatedTankerAssignment, new Object((0, _defineProperty3.default)({}, day.value, _this17.model[day.value].tankerId.Value)));
			});

			this.previouslyAssignedTanker = this.findDifference(this.currentlyAssignedTankers, this.updatedTankerAssignment);
			this.newAssignedTanker = this.findDifference(this.updatedTankerAssignment, this.currentlyAssignedTankers);

			if (!_.isEmpty(this.previouslyAssignedTanker) || !_.isEmpty(this.newAssignedTanker)) this.isTankerAssignmentChanged = true;else this.isTankerAssignmentChanged = false;

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(this.newAssignedTanker)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
					    newKey = _step$value[0],
					    newValue = _step$value[1];

					if (this.previouslyAssignedTanker[newKey] === undefined) {
						this.createRecords.push({ dayOfWeek: this.dayOfWeekObj[newKey], tankerId: newValue });
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(this.previouslyAssignedTanker)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
					    oldKey = _step2$value[0],
					    oldValue = _step2$value[1];

					if (this.newAssignedTanker[oldKey] === undefined) {
						this.deleteRecords.push({ dayOfWeek: this.dayOfWeekObj[oldKey], tankerId: oldValue });
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = (0, _getIterator3.default)((0, _entries2.default)(this.previouslyAssignedTanker)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
					    oldKey = _step3$value[0],
					    oldValue = _step3$value[1];

					var _iteratorNormalCompletion6 = true;
					var _didIteratorError6 = false;
					var _iteratorError6 = undefined;

					try {
						for (var _iterator6 = (0, _getIterator3.default)((0, _entries2.default)(this.newAssignedTanker)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
							var _step6$value = (0, _slicedToArray3.default)(_step6.value, 2),
							    newKey = _step6$value[0],
							    newValue = _step6$value[1];

							if (oldKey === newKey && this.previouslyAssignedTanker[oldKey] != this.newAssignedTanker[newKey]) {
								this.updateRecords.push({ dayOfWeek: this.dayOfWeekObj[newKey], tankerId: newValue });
							}
						}
					} catch (err) {
						_didIteratorError6 = true;
						_iteratorError6 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion6 && _iterator6.return) {
								_iterator6.return();
							}
						} finally {
							if (_didIteratorError6) {
								throw _iteratorError6;
							}
						}
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = (0, _getIterator3.default)((0, _entries2.default)(this.newAssignedTanker)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
					    newKey = _step4$value[0],
					    newValue = _step4$value[1];

					(0, _assign2.default)(this.newAssignedTanker, new Object((0, _defineProperty3.default)({}, newKey, newValue + ' | ' + newKey)));
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = (0, _getIterator3.default)((0, _entries2.default)(this.previouslyAssignedTanker)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var _step5$value = (0, _slicedToArray3.default)(_step5.value, 2),
					    oldKey = _step5$value[0],
					    oldValue = _step5$value[1];

					(0, _assign2.default)(this.previouslyAssignedTanker, new Object((0, _defineProperty3.default)({}, oldKey, oldValue + ' | ' + oldKey)));
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}
		}
	}, {
		key: 'saveLater',
		value: function saveLater() {
			var _this18 = this;

			this.findTankerAssignmentChange();

			var tankerAssignment = {
				previouslyAssignedTanker: (0, _values2.default)(this.previouslyAssignedTanker),
				newAssignedTanker: (0, _values2.default)(this.newAssignedTanker),
				isTankerAssignmentChanged: this.isTankerAssignmentChanged,
				// assignedTankers: this.assignedTankers,
				key: 'update_tanker_assignment',
				createRecords: this.createRecords,
				updateRecords: this.updateRecords,
				deleteRecords: this.deleteRecords
			};

			var extraDetails = {
				branchId: this.model.branch,
				routeName: this.model.name,
				userId: this.model.loggedInUser,
				username: this.User.getUser().firstName.concat(' ', this.User.getUser().lastName)
			};

			this.Modal.saveRouteChangesLaterModal(tankerAssignment, this.rawId, function (_ref7) {
				var modal = _ref7.modal,
				    duration = _ref7.duration,
				    dateTime = _ref7.dateTime;

				tankerAssignment.executeAt = tankerAssignment.isTankerAssignmentChanged ? dateTime : null;
				var routeDetailsObj = tankerAssignment.isTankerAssignmentChanged ? tankerAssignment : {};

				_this18.Service.saveRouteChanges(_this18.rawId, routeDetailsObj, extraDetails, duration).then(function () {
					return window.history.go(-1);
				}).catch(function (err) {
					console.log(err);
					_this18.Modal.errorModal(err.data.message);
				});
			}, function (_ref8) {
				var modal = _ref8.modal;

				if (modal) modal.close();
			});
		}
	}, {
		key: 'getPendingRouteChanges',
		value: function getPendingRouteChanges() {
			var _this19 = this;

			return this.Service.getPendingRouteChanges(this.$stateParams.id).then(function (data) {
				_this19.pendingRouteChanges = data;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'removeRouteChanges',
		value: function removeRouteChanges(jobId) {
			var _this20 = this;

			return this.Service.removeRouteChanges(jobId).then(function () {
				_this20.getPendingRouteChanges();
			}).catch(function (err) {
				console.log(err);
				if (err && err.data && err.data.message) {
					_this20.Modal.errorModal(err.data.message);
				}
			});
		}
	}, {
		key: 'confirmDelete',
		value: function confirmDelete(jobId) {
			var _this21 = this;

			this.Modal.confirm({
				header: this.$translate.instant('common.confirm_delete_title'),
				message: this.$translate.instant('common.confirm_delete_message'),
				callback: function callback(_ref9) {
					var modal = _ref9.modal;

					_this21.removeRouteChanges(jobId);
					modal.close();
				},
				negative: function negative(_ref10) {
					var modal = _ref10.modal;

					modal.close();
				},
				type: 'danger'
			});
		}
	}, {
		key: 'translateMessage',
		value: function translateMessage(key) {
			if (!key) return;
			return this.$translate.instant('route.' + key);
		}
	}, {
		key: 'validateToggles',
		value: function validateToggles() {
			this.model.autoThrowOnPack = this.model.requireThrow ? this.model.autoThrowOnPack : false;
		}
	}, {
		key: 'printLocationBarcodes',
		value: function printLocationBarcodes() {
			var obj = {
				selectedLocations: this.selectedLocations
			};

			var path = this.$state.href('printLocationBarcodes');
			window.w = window.open(path, '_blank');
			window.w.printData = obj;
		}
	}, {
		key: 'getAllTrucks',
		value: function getAllTrucks() {
			var _this22 = this;

			this.TruckService.getRestrictTrucks('', this.model.branch, null, 1000, 0).then(function (data) {
				_this22.truckOptions.totalRecords = data.total;
				_this22.truckOptions.options = _this22.mappingTruckData(data.results, '');
			});
		}
	}, {
		key: 'getOriginationPoint',
		value: function getOriginationPoint(source) {
			var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			if (!source) return null;

			var lat = source.lat !== undefined && source.lat !== null ? source.lat : source.gpsLat !== undefined && source.gpsLat !== null ? source.gpsLat : fallback.lat;
			var long = source.long !== undefined && source.long !== null ? source.long : source.gpsLong !== undefined && source.gpsLong !== null ? source.gpsLong : fallback.long;

			if (lat === null || lat === undefined || long === null || long === undefined) {
				return null;
			}

			return {
				id: source.id || fallback.id,
				name: source.name || fallback.name,
				address: source.address || fallback.address || '',
				city: source.city || fallback.city || '',
				state: source.state || fallback.state || '',
				zip: source.zip || fallback.zip || '',
				lat: Number(lat),
				long: Number(long)
			};
		}
	}, {
		key: 'getTargetDate',
		value: function getTargetDate() {
			var dayOfWeekMap = {
				'Sun': 0,
				'Mon': 1,
				'Tue': 2,
				'Wed': 3,
				'Thu': 4,
				'Fri': 5,
				'Sat': 6
			};

			if (this.selectedDay && this.selectedDay in dayOfWeekMap) {
				var date = moment(this.valutDate, 'YYYY-MM-DD').day(dayOfWeekMap[this.selectedDay]).format('YYYY-MM-DD');
				return this.$q.resolve(date);
			}

			return this.$q.resolve(this.valutDate);
		}
	}, {
		key: 'removeOriginationMarker',
		value: function removeOriginationMarker() {
			if (this.map && this.originationMarker) {
				this.map.removeLayer(this.originationMarker);
			}

			this.originationMarker = null;
		}
	}, {
		key: 'getRouteBounds',
		value: function getRouteBounds() {
			var originationLocation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			var points = [];

			this.routeSequenceData.forEach(function (location) {
				if (location && location.lat !== null && location.lat !== undefined && location.long !== null && location.long !== undefined) {
					points.push([Number(location.lat), Number(location.long)]);
				}
			});

			if (originationLocation) {
				points.push([Number(originationLocation.lat), Number(originationLocation.long)]);
			}

			return points.length ? L.latLngBounds(points) : null;
		}
	}, {
		key: 'updateMapBounds',
		value: function updateMapBounds() {
			var originationLocation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (!this.map) {
				return;
			}

			var bounds = this.getRouteBounds(originationLocation);
			if (!bounds) {
				return;
			}

			if (bounds.isValid()) {
				this.map.fitBounds(bounds, { padding: [30, 30] });
			}
		}
	}, {
		key: 'addOriginationMarker',
		value: function addOriginationMarker(location, label) {
			if (!this.map || !location) {
				return;
			}

			this.removeOriginationMarker();

			var cityState = [location.city, location.state].filter(Boolean).join(', ');
			var details = [location.address, location.zip].filter(Boolean).join(' - ');
			var popupParts = ['<strong>' + label + ': ' + (location.name || location.id) + '</strong>'];

			if (details) {
				popupParts.push(details);
			}

			if (cityState) {
				popupParts.push(cityState);
			}

			this.originationMarker = L.marker([location.lat, location.long], {
				icon: new L.AwesomeNumberMarkers({
					number: label.charAt(0).toUpperCase(),
					markerColor: "black"
				})
			}).addTo(this.map).bindPopup(popupParts.join('<br>'));

			this.originationMarker.on('mouseover', function () {
				this.openPopup();
			});

			this.originationMarker.on('mouseout', function () {
				this.closePopup();
			});

			this.updateMapBounds(location);
		}
	}, {
		key: 'refreshOriginationMarker',
		value: function refreshOriginationMarker() {
			var _this23 = this;

			if (!this.map) {
				return;
			}

			if (this.model.origination === 'BRANCH') {
				this.addOriginationMarker(this.branchOrigination, 'Branch');
				return;
			}

			if (this.model.origination === 'USER') {
				if (this.selectedDay === 'Hol') {
					if (this.branchOrigination) {
						this.addOriginationMarker(this.branchOrigination, 'Branch');
					} else {
						this.removeOriginationMarker();
						this.updateMapBounds();
					}
					return;
				}

				if (!this.valutDate) {
					this.removeOriginationMarker();
					this.updateMapBounds();
					return;
				}

				var requestId = ++this.originationLocationRequest;
				this.getTargetDate().then(function (targetDate) {
					if (requestId !== _this23.originationLocationRequest) return;

					var routeSearchObj = {
						queryJSON: {
							rules: [{ field: "branchId", condition: "=", data: _this23.model.branch }, { field: "routeId", condition: "=", data: _this23.$stateParams.id }, { field: "routeDate", condition: "=", data: targetDate }],
							operator: 'AND'
						}
					};

					return _this23.RouteDetailService.all(routeSearchObj, 0, 1).then(function (data) {
						if (requestId !== _this23.originationLocationRequest) return;
						var messenger = data && data.results && data.results[0] && data.results[0].messenger;
						var isUserOriginMismatch = messenger && messenger.userOrigin && messenger.userOrigin !== 'USER';
						var userOrigination = messenger && !isUserOriginMismatch ? _this23.getOriginationPoint(messenger, {
							name: messenger.firstName + ' ' + messenger.lastName
						}) : null;

						if (userOrigination) {
							_this23.addOriginationMarker(userOrigination, 'User');
						} else {
							// Fallback to branch marker if messenger is not assigned on this day or mismatch exists
							if (_this23.branchOrigination) {
								_this23.addOriginationMarker(_this23.branchOrigination, 'Branch');
							} else {
								_this23.removeOriginationMarker();
								_this23.updateMapBounds();
							}
						}
					});
				}).catch(function (err) {
					console.log(err);
					if (requestId === _this23.originationLocationRequest) {
						// Fallback to branch marker on error
						if (_this23.branchOrigination) {
							_this23.addOriginationMarker(_this23.branchOrigination, 'Branch');
						} else {
							_this23.removeOriginationMarker();
							_this23.updateMapBounds();
						}
					}
				});
				return;
			}

			if (this.model.origination === 'TRUCK') {
				var restrictTruck = this.model.restrictTruck;
				// Handle case where restrictTruck might be just the ID (string/number)
				if (restrictTruck && (typeof restrictTruck === 'string' || typeof restrictTruck === 'number')) {
					restrictTruck = _.find(this.truckOptions.options, { Value: restrictTruck }) || _.find(this.truckOptions.options, { id: restrictTruck });
				}

				if (!this.model.restrictToTruck || !restrictTruck || !restrictTruck.locationId) {
					this.removeOriginationMarker();
					this.updateMapBounds();
					return;
				}
				var _requestId = ++this.originationLocationRequest;
				this.LocationService.get(restrictTruck.locationId).then(function (location) {
					if (_requestId !== _this23.originationLocationRequest) {
						return;
					}

					var truckOrigination = _this23.getOriginationPoint(location, {
						id: restrictTruck.id || restrictTruck.Value,
						name: restrictTruck.make || restrictTruck.Key,
						lat: restrictTruck.lat || restrictTruck.gpsLat,
						long: restrictTruck.long || restrictTruck.gpsLong
					});

					if (truckOrigination) {
						_this23.addOriginationMarker(truckOrigination, 'Truck');
					} else {
						_this23.removeOriginationMarker();
						_this23.updateMapBounds();
					}
				}).catch(function (err) {
					if (_requestId === _this23.originationLocationRequest) {
						var truckOrigination = _this23.getOriginationPoint(restrictTruck);
						if (truckOrigination) {
							_this23.addOriginationMarker(truckOrigination, 'Truck');
						} else {
							_this23.removeOriginationMarker();
							_this23.updateMapBounds();
						}
					}
				});
				return;
			}

			// Fallback for null / undefined / None
			this.removeOriginationMarker();
			this.updateMapBounds();
		}
	}, {
		key: 'createRouteObjects',
		value: function createRouteObjects() {
			var _this24 = this;

			this.routeDays = this.routeDays.map(function (route, index) {
				return {
					key: _this24.$translate.instant('location.' + _this24.dayKeys[index].toLowerCase()),
					value: route,
					tick: _this24.defaultModel[route]
				};
			});
		}
	}, {
		key: 'isDaySelected',
		value: function isDaySelected(day) {
			day.tick = !day.tick;
		}
	}, {
		key: 'loadInternalLocations',
		value: function loadInternalLocations(searchKey, offset) {
			var _this25 = this;

			searchKey = searchKey || '';

			var locationSearchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: '=',
						data: this.model.branch
					}, {
						field: 'locationType',
						condition: '=',
						data: 'INTERNAL'
					}, {
						field: 'active',
						condition: '=',
						data: true
					}, {
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'name',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};

			this.isLoadingInternalLocations = true;
			this.LocationService.getAllLocation(locationSearchObj, offset, this.AppConstants.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this25.internalLocationsObj.totalRecords = data.total;
					_this25.internalLocationsObj.results = _this25.locMapping(data.results);
				} else {
					var locations = _this25.locMapping(data.results);
					_this25.internalLocationsObj.results = _this25.internalLocationsObj.results.concat(locations);
				}
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this25.isLoadingInternalLocations = false;
			});
		}
	}, {
		key: 'locMapping',
		value: function locMapping(locations) {
			return locations.map(function (l) {
				return {
					Key: l.id + " | " + l.name,
					Value: l.id
				};
			});
		}
	}, {
		key: 'resetRescheduleHoldLocation',
		value: function resetRescheduleHoldLocation() {
			this.model.rescheduleHoldLocationId = null;
		}
	}, {
		key: 'branchChanged',
		value: function branchChanged() {
			this.resetRescheduleHoldLocation();
			this.loadInternalLocations('', 0);
			this.getSetupDetails(this.model.branch);
		}
	}, {
		key: 'restrictToTruckChanged',
		value: function restrictToTruckChanged() {
			this.refreshOriginationMarker();
			if (!this.model.restrictToTruck) {
				this.model.restrictTruck = null;
				this.restrictTruckAddress = null;
			} else {
				this.restrictTruckChanged();
			}
		}
	}, {
		key: 'originationChanged',
		value: function originationChanged() {
			this.refreshOriginationMarker();
		}
	}, {
		key: 'restrictTruckChanged',
		value: function restrictTruckChanged() {
			var _this26 = this;

			this.refreshOriginationMarker();
			this.restrictTruckAddress = null;
			var restrictTruck = this.model.restrictTruck;
			if (restrictTruck && (typeof restrictTruck === 'string' || typeof restrictTruck === 'number')) {
				restrictTruck = _.find(this.truckOptions.options, { Value: restrictTruck }) || _.find(this.truckOptions.options, { id: restrictTruck });
			}
			if (restrictTruck && restrictTruck.locationId) {
				this.LocationService.get(restrictTruck.locationId).then(function (location) {
					if (location.address || location.city || location.state || location.zip) {
						_this26.restrictTruckAddress = (location.address || '') + ', ' + (location.city || '') + ', ' + (location.state || '') + ' ' + (location.zip || '');
					} else {
						_this26.restrictTruckAddress = null;
					}
				}).catch(function (err) {
					console.log(err);
				});
			}
		}
	}]);
	return RoutesEditController;
}(_routesBase2.default);

exports.default = RoutesEditController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routes = __webpack_require__(2035);

var _routes2 = _interopRequireDefault(_routes);

var _create = __webpack_require__(2028);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2031);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2025);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routesModule = angular.module('routes', [_create2.default, _edit2.default, _all2.default]).component('routes', _routes2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('routes.edit', {
    url: '/edit/:id/:day',
    component: 'routesedit'
    // data: {
    //   requireACL: 'setting-routes.edit'
    // }
  }).state('routes.create', {
    url: '/create',
    component: 'routescreate',
    data: {
      requireACL: 'setting-routes.create'
    }
  }).state('routes.all', {
    url: '/all/:page',
    component: 'routesall',
    data: {
      requireACL: 'setting-routes.view'
    }
  });
}]).name;

exports.default = routesModule;

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routes = __webpack_require__(2776);

var _routes2 = _interopRequireDefault(_routes);

var _routes3 = __webpack_require__(2036);

var _routes4 = _interopRequireDefault(_routes3);

__webpack_require__(3055);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routesComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _routes2.default,
  controller: _routes4.default
};

exports.default = routesComponent;

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RoutesController = function (_SettingBase) {
  RoutesController.$inject = ["$state"];
  (0, _inherits3.default)(RoutesController, _SettingBase);

  /*@ngInject*/
  function RoutesController($state) {
    (0, _classCallCheck3.default)(this, RoutesController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RoutesController.__proto__ || (0, _getPrototypeOf2.default)(RoutesController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'routes';
    _this.$state = $state;
    _this.hasACL = {};
    return _this;
  }

  (0, _createClass3.default)(RoutesController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(RoutesController.prototype.__proto__ || (0, _getPrototypeOf2.default)(RoutesController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['setting-routes']) {
        this.hasACL[this.acl['setting-routes'][key]] = true;
      }
    }
  }]);
  return RoutesController;
}(_SettingBase3.default);

exports.default = RoutesController;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_settingsAll = __webpack_require__(2038);

var _service_settingsAll2 = _interopRequireDefault(_service_settingsAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceSettingsAllModule = angular.module('serviceSettingsAll', []).component('serviceSettingsAll', _service_settingsAll2.default).name;

exports.default = serviceSettingsAllModule;

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_settingsAll = __webpack_require__(2777);

var _service_settingsAll2 = _interopRequireDefault(_service_settingsAll);

var _service_settingsAll3 = __webpack_require__(2039);

var _service_settingsAll4 = _interopRequireDefault(_service_settingsAll3);

__webpack_require__(3056);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceSettingsAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template: _service_settingsAll2.default,
    controller: _service_settingsAll4.default
};

exports.default = serviceSettingsAllComponent;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceSettingsAllController = function () {
    /*@ngInject*/
    ServiceSettingsAllController.$inject = ["Auth", "User", "$state", "$translate", "Modal", "ActionCodeService", "ServiceActionPrioritiesService", "LocationService"];
    function ServiceSettingsAllController(Auth, User, $state, $translate, Modal, ActionCodeService, ServiceActionPrioritiesService, LocationService) {
        (0, _classCallCheck3.default)(this, ServiceSettingsAllController);

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.ActionCodeService = ActionCodeService;
        this.ServiceActionPrioritiesService = ServiceActionPrioritiesService;
        this.LocationService = LocationService;

        this.model = {
            currentBranch: this.User.getUser().branchId,
            actionCodes: [],
            searchText: '',
            loading: true,
            actionCodeResponse: [],
            actionCodeData: {},
            _loading: false
        };
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };
        this.actionCodeObj = {};
        this.responseCodes = {};
        this.rootCauseCodes = {};
        this.errorMessage = '';
        this.thresholdList = ['redThreshold', 'orangeThreshold', 'yellowThreshold', 'otherThreshold'];
        this.isDuplicate = false;
        this.categoryList = [{ label: 'FLM', value: 'FLM' }, { label: 'SLM', value: 'SLM' }];
        this.pmSchedulesList = [];
    }

    (0, _createClass3.default)(ServiceSettingsAllController, [{
        key: '$onInit',
        value: function $onInit() {
            // console.log("call");
            this.loadData();
            this.loadPriorities();
            this.loadPM();
        }
    }, {
        key: 'loadPM',
        value: function loadPM() {
            this.loadPreventativeMaintenances('', 0);
        }
    }, {
        key: 'loadPreventativeMaintenances',
        value: function loadPreventativeMaintenances(searchKey, offset) {
            var _this = this;

            searchKey = searchKey || '';
            return this.LocationService.getPreventativeMaintenanceList(10, offset, searchKey).then(function (data) {
                var pmList = (data.results || []).map(function (pm) {
                    return {
                        Key: pm.title + (pm.status === 'Suspended' ? ' (suspended)' : ''),
                        Value: pm.id,
                        isSuspended: pm.status === 'Suspended'
                    };
                });
                if (offset === 0 || offset === undefined) {
                    _this.totalPMRecords = data.total || 0;
                    _this.pmSearchList = pmList;
                } else {
                    _this.pmSearchList = _this.pmSearchList.concat(pmList);
                }
            }).catch(function (err) {
                return console.error(err);
            });
        }
    }, {
        key: 'isPMSuspended',
        value: function isPMSuspended(val) {
            if (!val) return false;
            if (val && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' && val.isSuspended !== undefined) {
                return val.isSuspended;
            }
            var id = val && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' ? val.Value : val;
            var pm = (this.pmSearchList || []).find(function (p) {
                return p.Value === id;
            });
            return pm && pm.isSuspended;
        }
    }, {
        key: 'loadPriorities',
        value: function loadPriorities() {
            var _this2 = this;

            this.ServiceActionPrioritiesService.all('', 0, 1000).then(function (data) {
                _this2.prioritiesList = data.results.filter(function (p) {
                    return p.active;
                });
            }).catch(function (err) {
                return console.error(err);
            });
        }
    }, {
        key: 'createActionCodeModal',
        value: function createActionCodeModal() {
            var _this3 = this;

            this.Modal.createActionCode(this.prioritiesList, this.pmSchedulesList, function (_ref) {
                var modal = _ref.modal,
                    actionCodeLabel = _ref.actionCodeLabel,
                    actionCode = _ref.actionCode,
                    minResponse = _ref.minResponse,
                    maxResponse = _ref.maxResponse,
                    minRootCause = _ref.minRootCause,
                    maxRootCause = _ref.maxRootCause,
                    thresholds = _ref.thresholds,
                    partsCapture = _ref.partsCapture,
                    resolveCodes = _ref.resolveCodes,
                    rootCauses = _ref.rootCauses,
                    redThreshold = _ref.redThreshold,
                    orangeThreshold = _ref.orangeThreshold,
                    yellowThreshold = _ref.yellowThreshold,
                    otherThreshold = _ref.otherThreshold,
                    requirePicture = _ref.requirePicture,
                    openRequired = _ref.openRequired,
                    category = _ref.category,
                    serviceType = _ref.serviceType,
                    expectedCompletionTime = _ref.expectedCompletionTime,
                    autoAssignable = _ref.autoAssignable,
                    serviceActionPriorityId = _ref.serviceActionPriorityId,
                    preventativeMaintenanceId = _ref.preventativeMaintenanceId;


                _this3.ActionCodeService.createServiceOrderActionCodes(actionCodeLabel, actionCode, minResponse, maxResponse, minRootCause, maxRootCause, thresholds, partsCapture, resolveCodes, rootCauses, redThreshold, orangeThreshold, yellowThreshold, otherThreshold, _this3.model.currentBranch, requirePicture, openRequired, category, serviceType, expectedCompletionTime, autoAssignable, serviceActionPriorityId, preventativeMaintenanceId).then(function () {
                    setTimeout(function () {
                        _this3.loadData();
                    });
                    modal.close();
                }).catch(function (err) {
                    _this3.Modal.errorModal(err.data.message);
                });
            }, function (_ref2) {
                var modal = _ref2.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'createActionCode',
        value: function createActionCode(actionCodeLabel, actionCode, minResponse, maxResponse, minRootCause, maxRootCause, thresholds, partsCapture, requirePicture, openRequired, category, serviceType, expectedCompletionTime, autoAssignable, serviceActionPriorityId, preventativeMaintenanceId) {
            var _this4 = this;

            return this.ActionCodeService.create({
                label: actionCodeLabel,
                code: actionCode,
                minResponseSelect: minResponse,
                maxResponseSelect: maxResponse,
                minRootCauseSelect: minRootCause,
                maxRootCauseSelect: maxRootCause,
                thresholds: thresholds, partsCapture: partsCapture, requirePicture: requirePicture, openRequired: openRequired,
                category: category, serviceType: serviceType, expectedCompletionTime: expectedCompletionTime === '' ? null : expectedCompletionTime, autoAssignable: autoAssignable, serviceActionPriorityId: serviceActionPriorityId, preventativeMaintenanceId: preventativeMaintenanceId
            }, this.model.currentBranch).then(function () {}).catch(function (err) {
                _this4.errorMessage = '';
                err.data.errors.map(function (e) {
                    _this4.errorMessage += e.message + '<br/>';
                });
                _this4.Modal.errorModal(_this4.errorMessage);
            });
        }
    }, {
        key: 'generateSearchObj',
        value: function generateSearchObj() {
            return {
                queryText: '%' + this.model.searchText + '%',
                isQuery: false
            };
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var _this5 = this;

            this.model.loading = true;
            this.ActionCodeService.all(this.generateSearchObj(), (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit).then(function (data) {
                _this5.pagination.total = data.total;
                _this5.model.actionCodes = data.results;
            }).catch(function (err) {
                _this5.error = err.message;
            }).finally(function () {
                _this5.model.loading = false;
            });
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.loadData();
        }
    }, {
        key: 'getActionCodeResponse',
        value: function getActionCodeResponse(data) {
            var _this6 = this;

            this.actionCodeObj[data.id] = { process: true };

            if (data.panelExpanded) {
                this.ActionCodeService.getActionCodes(data.id).then(function (actionCodeInfo) {
                    _this6.model.actionCodeData[data.id] = { details: actionCodeInfo.results };

                    var pmId = actionCodeInfo.results.preventativeMaintenanceId;
                    if (pmId) {
                        _this6.LocationService.getPreventativeMaintenance(pmId).then(function (pm) {
                            _this6.model.actionCodeData[data.id].details.preventativeMaintenanceId = {
                                Key: pm.title + (pm.status === 'Suspended' || pm.status === false ? ' (suspended)' : ''),
                                Value: pm.id,
                                isSuspended: pm.status === 'Suspended' || pm.status === false
                            };
                        }).catch(function (err) {
                            return console.error(err);
                        });
                    } else {
                        _this6.model.actionCodeData[data.id].details.preventativeMaintenanceId = null;
                    }

                    _this6.model.actionCodeData[data.id].details.redThreshold = _this6.model.actionCodeData[data.id].details.redThreshold ? _this6.getTime(_this6.model.actionCodeData[data.id].details.redThreshold) : null;
                    _this6.model.actionCodeData[data.id].details.orangeThreshold = _this6.model.actionCodeData[data.id].details.orangeThreshold ? _this6.getTime(_this6.model.actionCodeData[data.id].details.orangeThreshold) : null;
                    _this6.model.actionCodeData[data.id].details.yellowThreshold = _this6.model.actionCodeData[data.id].details.yellowThreshold ? _this6.getTime(_this6.model.actionCodeData[data.id].details.yellowThreshold) : null;
                    _this6.model.actionCodeData[data.id].details.otherThreshold = _this6.model.actionCodeData[data.id].details.otherThreshold ? _this6.getTime(_this6.model.actionCodeData[data.id].details.otherThreshold) : null;
                    _this6.model.actionCodeData[data.id].details.expectedCompletionTime = _this6.model.actionCodeData[data.id].details.expectedCompletionTime ? _this6.getTime(_this6.model.actionCodeData[data.id].details.expectedCompletionTime) : null;

                    if (_this6.model.actionCodeData[data.id].details.serviceActionPriorityId) {
                        var exists = _this6.prioritiesList.find(function (p) {
                            return p.id === _this6.model.actionCodeData[data.id].details.serviceActionPriorityId;
                        });
                        if (!exists) {
                            _this6.model.actionCodeData[data.id].details.serviceActionPriorityId = null;
                        }
                    }

                    _this6.responseCodes[data.id] = JSON.parse((0, _stringify2.default)(actionCodeInfo.results.responses));
                    _this6.rootCauseCodes[data.id] = JSON.parse((0, _stringify2.default)(actionCodeInfo.results.rootCauses));
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        _this6.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this6.actionCodeObj[data.id].process = false;
                });
            }
        }
    }, {
        key: 'addNewServiceResponse',
        value: function addNewServiceResponse(index) {
            this.model.actionCodeData[index].details.responses.push({
                id: '',
                label: '',
                sortOrder: this.model.actionCodeData[index].details.responses.length + 1
            });
        }
    }, {
        key: 'addNewRootCause',
        value: function addNewRootCause(index) {
            this.model.actionCodeData[index].details.rootCauses.push({
                id: "",
                label: "",
                sortOrder: this.model.actionCodeData[index].details.rootCauses.length + 1
            });
        }
    }, {
        key: 'removeServiceResponse',
        value: function removeServiceResponse(actionId, index) {
            if (this.model.actionCodeData[actionId].details.responses[index].id) {
                if (this.model.actionCodeData[actionId].details.itemRemove && Array.isArray(this.model.actionCodeData[actionId].details.itemRemove)) {
                    this.model.actionCodeData[actionId].details.itemRemove.push(this.model.actionCodeData[actionId].details.responses[index]);
                } else {
                    this.model.actionCodeData[actionId].details.itemRemove = [this.model.actionCodeData[actionId].details.responses[index]];
                }

                this.model.actionCodeData[actionId].details.responses.splice(index, 1);
            } else {
                this.model.actionCodeData[actionId].details.responses.splice(index, 1);
            }
        }
    }, {
        key: 'removeRootCause',
        value: function removeRootCause(actionId, index) {
            if (this.model.actionCodeData[actionId].details.rootCauses[index].id) {
                if (this.model.actionCodeData[actionId].details.rootCauseRemove && Array.isArray(this.model.actionCodeData[actionId].details.rootCauseRemove)) {
                    this.model.actionCodeData[actionId].details.rootCauseRemove.push(this.model.actionCodeData[actionId].details.rootCauses[index]);
                } else {
                    this.model.actionCodeData[actionId].details.rootCauseRemove = [this.model.actionCodeData[actionId].details.rootCauses[index]];
                }

                this.model.actionCodeData[actionId].details.rootCauses.splice(index, 1);
            } else {
                this.model.actionCodeData[actionId].details.rootCauses.splice(index, 1);
            }
        }
    }, {
        key: 'removeRootCause',
        value: function removeRootCause(actionId, index) {
            if (this.model.actionCodeData[actionId].details.rootCauses[index].id) {
                if (this.model.actionCodeData[actionId].details.rootCauseRemove && Array.isArray(this.model.actionCodeData[actionId].details.rootCauseRemove)) {
                    this.model.actionCodeData[actionId].details.rootCauseRemove.push(this.model.actionCodeData[actionId].details.rootCauses[index]);
                } else {
                    this.model.actionCodeData[actionId].details.rootCauseRemove = [this.model.actionCodeData[actionId].details.rootCauses[index]];
                }

                this.model.actionCodeData[actionId].details.rootCauses.splice(index, 1);
            } else {
                this.model.actionCodeData[actionId].details.rootCauses.splice(index, 1);
            }
        }
    }, {
        key: 'disableCodeUpdate',
        value: function disableCodeUpdate(actionId) {
            var _this7 = this;

            if (!actionId || !this.model.actionCodeData || !this.model.actionCodeData[actionId]) return true;
            var isEmpty = this.model.actionCodeData[actionId].details.responses && this.model.actionCodeData[actionId].details.responses.length ? this.model.actionCodeData[actionId].details.responses.filter(function (item) {
                return !item.label;
            }) : false;
            var isRootCauseEmpty = this.model.actionCodeData[actionId].details.rootCauses && this.model.actionCodeData[actionId].details.rootCauses.length ? this.model.actionCodeData[actionId].details.rootCauses.filter(function (item) {
                return !item.label;
            }) : false;
            var thresholds = this.thresholdList.map(function (d) {
                return _this7.model.actionCodeData[actionId].details[d] ? moment(_this7.model.actionCodeData[actionId].details[d]).format('HH:mm:00') : null;
            });
            var duplicate = thresholds.reduce(function (acc, currentValue, index, array) {
                if (currentValue) if (array.indexOf(currentValue) != index && !acc.includes(currentValue)) acc.push(currentValue);
                return acc;
            }, []);
            this.isDuplicate = this.model.actionCodeData[actionId].details.thresholds && duplicate.length;
            return isEmpty.length || isRootCauseEmpty.length || this.isDuplicate ? true : false;
        }
    }, {
        key: 'comparerArrayDiff',
        value: function comparerArrayDiff(otherArray) {
            return function (current) {
                return otherArray.filter(function (other) {
                    return other.label == current.label && other.sortOrder == current.sortOrder && other.category == current.category;
                }).length == 0;
            };
        }
    }, {
        key: 'compareRootCauseArrayDiff',
        value: function compareRootCauseArrayDiff(otherArray) {
            return function (current) {
                return otherArray.filter(function (other) {
                    return other.label == current.label && other.sortOrder == current.sortOrder;
                }).length == 0;
            };
        }
    }, {
        key: 'updateServiceItem',
        value: function updateServiceItem(index) {
            var _this8 = this;

            if (!this.hasACL['edit']) return;

            this.model.loading = true;
            var data = JSON.parse((0, _stringify2.default)(this.model.actionCodeData[index].details));
            data['responses'] = data.responses.filter(this.comparerArrayDiff(this.responseCodes[index]));
            data["rootCauses"] = data.rootCauses.filter(this.compareRootCauseArrayDiff(this.rootCauseCodes[index]));
            data['redThreshold'] = data['redThreshold'] ? moment(data['redThreshold']).format('HH:mm:00') : null;
            data['orangeThreshold'] = data['orangeThreshold'] ? moment(data['orangeThreshold']).format('HH:mm:00') : null;
            data['yellowThreshold'] = data['yellowThreshold'] ? moment(data['yellowThreshold']).format('HH:mm:00') : null;
            data['otherThreshold'] = data['otherThreshold'] ? moment(data['otherThreshold']).format('HH:mm:00') : null;
            data['expectedCompletionTime'] = data['expectedCompletionTime'] ? moment(data['expectedCompletionTime']).format('HH:mm:00') : null;
            data['preventativeMaintenanceId'] = data['preventativeMaintenanceId'] ? data['preventativeMaintenanceId'].Value : null;

            this.ActionCodeService.updateCodeResponse(data).then(function (res) {
                if (res.success) {
                    if (res.actionResponses && res.actionResponses.length) {
                        _this8.model.actionCodeData[index].details.responses = res.actionResponses;
                        _this8.model.actionCodeData[index].details.rootCauses = res.actionRootCauses;
                    }

                    var actionCode = _this8.model.actionCodes.find(function (item) {
                        return item.id === index;
                    });
                    if (actionCode) {
                        actionCode.label = data.label;
                    }
                    _this8.model.actionCodeData[index].details.itemRemove = [];
                    _this8.model.actionCodeData[index].details.rootCauseRemove = [];
                }
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this8.errorMessage += e.message + '<br/>';
                });
                _this8.Modal.errorModal(_this8.errorMessage);
            }).finally(function () {
                _this8.model.loading = false;
            });
        }
    }, {
        key: 'getTime',
        value: function getTime(time) {
            if (!time) {
                return time;
            }

            time = time.split(':');

            var d = new Date();

            d.setHours(+time[0]);
            d.setMinutes(time[1]);
            d.setSeconds(0);
            d.setMilliseconds(0);

            return d;
        }
    }]);
    return ServiceSettingsAllController;
}();

exports.default = ServiceSettingsAllController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atmMakes = __webpack_require__(2778);

var _atmMakes2 = _interopRequireDefault(_atmMakes);

var _atmMakes3 = __webpack_require__(2041);

var _atmMakes4 = _interopRequireDefault(_atmMakes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtmMakesComponent = {
    bindings: {},
    template: _atmMakes2.default,
    controller: _atmMakes4.default
};

exports.default = AtmMakesComponent;

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = __webpack_require__(76);

var _map2 = _interopRequireDefault(_map);

var _freeze = __webpack_require__(189);

var _freeze2 = _interopRequireDefault(_freeze);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtmMakesController = function () {
    /*@ngInject*/
    AtmMakesController.$inject = ["AtmMakesService", "Modal", "DateUtil"];
    function AtmMakesController(AtmMakesService, Modal, DateUtil) {
        (0, _classCallCheck3.default)(this, AtmMakesController);

        this.AtmMakesService = AtmMakesService;
        this.Modal = Modal;
        this.DateUtil = DateUtil;

        this.model = {
            atmMakes: [],
            originalAtmMakes: [],
            searchText: '',
            loading: true,
            saving: false
        };
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };
    }

    (0, _createClass3.default)(AtmMakesController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loadData();
        }
    }, {
        key: 'addAtmMake',
        value: function addAtmMake() {
            var _this = this;

            this.Modal.createAtmMake(function (_ref) {
                var modal = _ref.modal,
                    atmMake = _ref.atmMake;

                _this.model.saving = true;
                _this.AtmMakesService.create(atmMake).then(function () {
                    modal.close();
                    _this.loadData();
                }).catch(function (err) {
                    _this.Modal.errorModal(err.data ? err.data.message : 'Error creating ATM Make');
                }).finally(function () {
                    _this.model.saving = false;
                });
            }, function (_ref2) {
                var modal = _ref2.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'removeAtmMake',
        value: function removeAtmMake(index) {
            this.model.atmMakes.splice(index, 1);
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var _this2 = this;

            this.model.loading = true;
            this.AtmMakesService.all(this.model.searchText, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit).then(function (data) {
                _this2.pagination.total = data.total;
                _this2.model.atmMakes = angular.copy(data.results);
                _this2.model.originalAtmMakes = (0, _freeze2.default)(angular.copy(data.results));
            }).catch(function (err) {
                _this2.Modal.errorModal(err.message);
            }).finally(function () {
                _this2.model.loading = false;
            });
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.loadData();
        }
    }, {
        key: 'disableUpdate',
        value: function disableUpdate() {
            if (!this.model.atmMakes) return true;
            var emptyRecords = this.model.atmMakes.filter(function (i) {
                return !i.vendorName;
            });
            return emptyRecords.length > 0;
        }
    }, {
        key: 'compareArrays',
        value: function compareArrays(originalArray, changedArray) {
            var changed = [];
            var removed = [];
            var originalMap = new _map2.default();

            originalArray.forEach(function (item) {
                return originalMap.set(item.id, item);
            });
            changedArray.forEach(function (item) {
                var originalItem = originalMap.get(item.id);
                if (!originalItem) {
                    changed.push(item);
                    return;
                };

                if (item.vendorName !== originalItem.vendorName || item.active !== originalItem.active) {
                    changed.push(item);
                }
                originalMap.delete(item.id);
            });

            removed.push.apply(removed, (0, _toConsumableArray3.default)(originalMap.values()));
            if (changed.length === 0 && removed.length === 0) {
                return null;
            }
            return { changed: changed, removed: removed };
        }
    }, {
        key: 'updateAtmMakes',
        value: function updateAtmMakes() {
            var _this3 = this;

            this.model.saving = true;
            var diff = this.compareArrays(this.model.originalAtmMakes, this.model.atmMakes);
            if (!diff) {
                this.model.saving = false;
                return;
            }

            var promises = [];
            if (diff.changed && diff.changed.length) {
                diff.changed.forEach(function (item) {
                    if (item.id) {
                        promises.push(_this3.AtmMakesService.update(item.id, item));
                    } else {
                        promises.push(_this3.AtmMakesService.create(item));
                    }
                });
            }
            if (diff.removed && diff.removed.length) {
                diff.removed.forEach(function (item) {
                    if (item.id) promises.push(_this3.AtmMakesService.remove(item.id));
                });
            }

            _promise2.default.all(promises).then(function () {
                _this3.loadData();
            }).catch(function (err) {
                _this3.Modal.errorModal(err.data ? err.data.message : 'Error updating ATM Makes');
            }).finally(function () {
                _this3.model.saving = false;
            });
        }
    }, {
        key: 'getStatusLabel',
        value: function getStatusLabel(item) {
            return item && item.active ? 'Active' : 'Inactive';
        }
    }, {
        key: 'getUpdatedByLabel',
        value: function getUpdatedByLabel(item) {
            if (!item || !item.updatedByUser) return 'N/A';
            var _item$updatedByUser = item.updatedByUser,
                id = _item$updatedByUser.id,
                firstName = _item$updatedByUser.firstName,
                lastName = _item$updatedByUser.lastName;

            var fullName = [firstName, lastName].filter(Boolean).join(' ');
            return id ? id + ' | ' + (fullName || 'N/A') : fullName || 'N/A';
        }
    }]);
    return AtmMakesController;
}();

exports.default = AtmMakesController;

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _atmMakes = __webpack_require__(2040);

var _atmMakes2 = _interopRequireDefault(_atmMakes);

__webpack_require__(3057);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var atmMakesModule = _angular2.default.module('serviceSettingsAtmMakes', []).component('serviceSettingsAtmMakes', _atmMakes2.default).name;

exports.default = atmMakesModule;

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_settings = __webpack_require__(2050);

var _service_settings2 = _interopRequireDefault(_service_settings);

var _all = __webpack_require__(2037);

var _all2 = _interopRequireDefault(_all);

var _serviceChecklist = __webpack_require__(2047);

var _serviceChecklist2 = _interopRequireDefault(_serviceChecklist);

var _atmMakes = __webpack_require__(2042);

var _atmMakes2 = _interopRequireDefault(_atmMakes);

var _serviceActionPriorities = __webpack_require__(2044);

var _serviceActionPriorities2 = _interopRequireDefault(_serviceActionPriorities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceSettingsModule = angular.module('serviceSettings', [_all2.default, _serviceChecklist2.default, _atmMakes2.default, _serviceActionPriorities2.default]).component('serviceSettings', _service_settings2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('service-settings.all', {
        url: '/all/:page',
        component: 'serviceSettingsAll'
    }).state('service-settings.checklist', {
        url: '/checklist',
        component: 'serviceSettingsChecklist'
    }).state('service-settings.atmMakes', {
        url: '/atm-makes',
        component: 'serviceSettingsAtmMakes'
    }).state('service-settings.actionPriorities', {
        url: '/service-action-priorities',
        component: 'serviceActionPriorities'
    });
}]).name;

exports.default = serviceSettingsModule;

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _serviceActionPriorities = __webpack_require__(2045);

var _serviceActionPriorities2 = _interopRequireDefault(_serviceActionPriorities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceActionPrioritiesModule = angular.module('serviceActionPriorities', []).component('serviceActionPriorities', _serviceActionPriorities2.default).name;

exports.default = serviceActionPrioritiesModule;

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _serviceActionPriorities = __webpack_require__(2779);

var _serviceActionPriorities2 = _interopRequireDefault(_serviceActionPriorities);

var _serviceActionPriorities3 = __webpack_require__(2046);

var _serviceActionPriorities4 = _interopRequireDefault(_serviceActionPriorities3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceActionPrioritiesComponent = {
    bindings: {},
    template: _serviceActionPriorities2.default,
    controller: _serviceActionPriorities4.default
};

exports.default = serviceActionPrioritiesComponent;

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = __webpack_require__(76);

var _map2 = _interopRequireDefault(_map);

var _freeze = __webpack_require__(189);

var _freeze2 = _interopRequireDefault(_freeze);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceActionPrioritiesController = function () {
    /*@ngInject*/
    ServiceActionPrioritiesController.$inject = ["ServiceActionPrioritiesService", "Modal", "DateUtil"];
    function ServiceActionPrioritiesController(ServiceActionPrioritiesService, Modal, DateUtil) {
        (0, _classCallCheck3.default)(this, ServiceActionPrioritiesController);

        this.ServiceActionPrioritiesService = ServiceActionPrioritiesService;
        this.Modal = Modal;
        this.DateUtil = DateUtil;

        this.model = {
            priorities: [],
            originalPriorities: [],
            searchText: '',
            loading: true,
            saving: false
        };
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };
    }

    (0, _createClass3.default)(ServiceActionPrioritiesController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loadData();
        }
    }, {
        key: 'addPriority',
        value: function addPriority() {
            var _this = this;

            this.Modal.createServiceActionPriority(function (_ref) {
                var modal = _ref.modal,
                    priorityItem = _ref.priorityItem;

                _this.model.saving = true;
                _this.ServiceActionPrioritiesService.create(priorityItem).then(function () {
                    modal.close();
                    _this.loadData();
                }).catch(function (err) {
                    _this.Modal.errorModal(err.data ? err.data.message : 'Error creating Service Action Priority');
                }).finally(function () {
                    _this.model.saving = false;
                });
            }, function (_ref2) {
                var modal = _ref2.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'removePriority',
        value: function removePriority(index) {
            this.model.priorities.splice(index, 1);
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var _this2 = this;

            this.model.loading = true;
            this.ServiceActionPrioritiesService.all(this.model.searchText, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit).then(function (data) {
                _this2.pagination.total = data.total;
                _this2.model.priorities = angular.copy(data.results);
                _this2.model.originalPriorities = (0, _freeze2.default)(angular.copy(data.results));
            }).catch(function (err) {
                _this2.Modal.errorModal(err.message);
            }).finally(function () {
                _this2.model.loading = false;
            });
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.loadData();
        }
    }, {
        key: 'disableUpdate',
        value: function disableUpdate() {
            if (!this.model.priorities) return true;
            var emptyRecords = this.model.priorities.filter(function (i) {
                return !i.priority;
            });
            return emptyRecords.length > 0;
        }
    }, {
        key: 'compareArrays',
        value: function compareArrays(originalArray, changedArray) {
            var changed = [];
            var removed = [];
            var originalMap = new _map2.default();

            originalArray.forEach(function (item) {
                return originalMap.set(item.id, item);
            });
            changedArray.forEach(function (item) {
                var originalItem = originalMap.get(item.id);
                if (!originalItem) {
                    changed.push(item);
                    return;
                };

                if (item.priority !== originalItem.priority || item.description !== originalItem.description || item.active !== originalItem.active) {
                    changed.push(item);
                }
                originalMap.delete(item.id);
            });

            removed.push.apply(removed, (0, _toConsumableArray3.default)(originalMap.values()));
            if (changed.length === 0 && removed.length === 0) {
                return null;
            }
            return { changed: changed, removed: removed };
        }
    }, {
        key: 'updatePriorities',
        value: function updatePriorities() {
            var _this3 = this;

            this.model.saving = true;
            var diff = this.compareArrays(this.model.originalPriorities, this.model.priorities);
            if (!diff) {
                this.model.saving = false;
                return;
            }

            var promises = [];
            if (diff.changed && diff.changed.length) {
                diff.changed.forEach(function (item) {
                    if (item.id) {
                        promises.push(_this3.ServiceActionPrioritiesService.update(item.id, item));
                    } else {
                        promises.push(_this3.ServiceActionPrioritiesService.create(item));
                    }
                });
            }
            if (diff.removed && diff.removed.length) {
                diff.removed.forEach(function (item) {
                    if (item.id) promises.push(_this3.ServiceActionPrioritiesService.remove(item.id));
                });
            }

            _promise2.default.all(promises).then(function () {
                _this3.loadData();
            }).catch(function (err) {
                _this3.Modal.errorModal(err.data && err.data.message ? err.data.message : 'Error updating Service Action Priorities');
            }).finally(function () {
                _this3.model.saving = false;
            });
        }
    }, {
        key: 'getUpdatedByLabel',
        value: function getUpdatedByLabel(item) {
            if (!item || !item.updatedByUser) return 'N/A';
            var _item$updatedByUser = item.updatedByUser,
                id = _item$updatedByUser.id,
                firstName = _item$updatedByUser.firstName,
                lastName = _item$updatedByUser.lastName;

            var fullName = [firstName, lastName].filter(Boolean).join(' ');
            return id ? id + ' | ' + (fullName || 'N/A') : fullName || 'N/A';
        }
    }]);
    return ServiceActionPrioritiesController;
}();

exports.default = ServiceActionPrioritiesController;

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_settingsChecklist = __webpack_require__(2049);

var _service_settingsChecklist2 = _interopRequireDefault(_service_settingsChecklist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceSettingsChecklistModule = angular.module('serviceSettingsChecklist', []).component('serviceSettingsChecklist', _service_settingsChecklist2.default).name;

exports.default = serviceSettingsChecklistModule;

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = __webpack_require__(76);

var _map2 = _interopRequireDefault(_map);

var _freeze = __webpack_require__(189);

var _freeze2 = _interopRequireDefault(_freeze);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceSettingsChecklistController = function () {
    /*@ngInject*/
    ServiceSettingsChecklistController.$inject = ["Auth", "User", "$state", "$translate", "Modal", "ServiceChecklistService", "BranchService"];
    function ServiceSettingsChecklistController(Auth, User, $state, $translate, Modal, ServiceChecklistService, BranchService) {
        (0, _classCallCheck3.default)(this, ServiceSettingsChecklistController);

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.ServiceChecklistService = ServiceChecklistService;
        this.BranchService = BranchService;

        this.model = {
            currentBranch: this.User.getUser().branchId,
            serviceChecklist: [],
            originalChecklist: [],
            searchText: '',
            loading: true,
            _loading: false,
            isServiceChecklist: false
        };
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };

        this.errorMessage = '';
    }

    (0, _createClass3.default)(ServiceSettingsChecklistController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loadPermission();
            this.checkforServiceChecklist();
            this.loadData();
        }
    }, {
        key: 'loadPermission',
        value: function loadPermission() {
            var _this = this;

            this.acl = {};
            this.hasServiceCheckListACL = {};

            ['setting-service-checklist'].forEach(function (permissionKey) {
                _this.acl[permissionKey] = _this.User.getACL(permissionKey);
                _this.acl[permissionKey].forEach(function (permission) {
                    _this.hasServiceCheckListACL[permission] = true;
                });
            });
        }
    }, {
        key: 'createServiceChecklist',
        value: function createServiceChecklist() {
            var _this2 = this;

            this.Modal.createServiceChecklist(this.pagination.total, function (_ref) {
                var modal = _ref.modal,
                    serviceChecklist = _ref.serviceChecklist;

                _this2.ServiceChecklistService.create((0, _extends3.default)({}, serviceChecklist, { branchId: _this2.model.currentBranch })).then(function () {
                    setTimeout(function () {
                        _this2.loadData();
                    });
                    modal.close();
                }).catch(function (err) {
                    _this2.Modal.errorModal(err.data.message);
                });
            }, function (_ref2) {
                var modal = _ref2.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'generateSearchObj',
        value: function generateSearchObj() {
            return {
                queryText: '%' + this.model.searchText + '%',
                isQuery: false
            };
        }
    }, {
        key: 'checkforServiceChecklist',
        value: function checkforServiceChecklist() {
            var _this3 = this;

            if (this.model.isServiceChecklist) return;
            this.model.loading = true;
            this.BranchService.getBranchSetup(this.model.currentBranch).then(function (data) {
                _this3.model.isServiceChecklist = data.serviceChecklist;
            }).catch(function (err) {
                _this3.error = err.message;
            }).finally(function () {
                _this3.model.loading = false;
            });
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var _this4 = this;

            this.model.loading = true;
            this.ServiceChecklistService.all(this.generateSearchObj(), (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit).then(function (data) {
                _this4.pagination.total = data.total;
                _this4.model.serviceChecklist = angular.copy(data.results); // Mutable array for user changes
                _this4.model.originalChecklist = (0, _freeze2.default)(angular.copy(data.results)); // Immutable array for original data
            }).catch(function (err) {
                _this4.error = err.message;
            }).finally(function () {
                _this4.model.loading = false;
            });
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            this.loadData();
        }
    }, {
        key: 'updateSortOrder',
        value: function updateSortOrder(index) {
            var nextIndexStart = (this.pagination.page - 1) * 10;
            this.model.serviceChecklist.splice(index, 1);
            this.model.serviceChecklist.forEach(function (item, idx) {
                item.sortOrder = nextIndexStart + idx + 1;
            });
        }
    }, {
        key: 'removeServiceChecklist',
        value: function removeServiceChecklist(index) {
            if (this.model.serviceChecklist[index].id) {
                this.model.serviceChecklist.splice(index, 1);
            } else {
                this.model.serviceChecklist.splice(index, 1);
            }
        }
    }, {
        key: 'disableCodeUpdate',
        value: function disableCodeUpdate() {
            var isEmpty = this.model.serviceChecklist.filter(function (item) {
                return !item.label || !item.daySelection;
            });
            return isEmpty.length ? true : false;
        }
    }, {
        key: 'compareArrays',
        value: function compareArrays(originalArray, changedArray) {
            var changed = [];
            var removed = [];
            var originalMap = new _map2.default();

            originalArray.forEach(function (item) {
                return originalMap.set(item.id, item);
            });
            changedArray.forEach(function (item) {
                var originalItem = originalMap.get(item.id);
                if (!originalItem) return;

                if (item.label !== originalItem.label || item.sortOrder !== originalItem.sortOrder || item.daySelection !== originalItem.daySelection) {
                    changed.push(item);
                }
                originalMap.delete(item.id);
            });

            removed.push.apply(removed, (0, _toConsumableArray3.default)(originalMap.values()));
            if (changed.length === 0 && removed.length === 0) {
                return null;
            }
            return { changed: changed, removed: removed };
        }
    }, {
        key: 'updateServiceChecklist',
        value: function updateServiceChecklist(index) {
            var _this5 = this;

            if (!this.hasACL['edit']) return;

            this.model.loading = true;
            var serviceChecklist = this.compareArrays(this.model.originalChecklist, this.model.serviceChecklist);
            if (!serviceChecklist) {
                this.model.loading = false;
                return;
            }

            this.ServiceChecklistService.updateServiceChecklist({ serviceChecklist: serviceChecklist.changed, itemRemove: serviceChecklist.removed }).then(function (res) {
                _this5.loadData();
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this5.errorMessage += e.message + '<br/>';
                });
                _this5.Modal.errorModal(_this5.errorMessage);
            }).finally(function () {
                _this5.model.loading = false;
            });
        }
    }]);
    return ServiceSettingsChecklistController;
}();

exports.default = ServiceSettingsChecklistController;

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_checklists = __webpack_require__(2780);

var _service_checklists2 = _interopRequireDefault(_service_checklists);

var _service_checklists3 = __webpack_require__(2048);

var _service_checklists4 = _interopRequireDefault(_service_checklists3);

__webpack_require__(3058);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceSettingsComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _service_checklists2.default,
    controller: _service_checklists4.default
};

exports.default = serviceSettingsComponent;

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_settings = __webpack_require__(2781);

var _service_settings2 = _interopRequireDefault(_service_settings);

var _service_settings3 = __webpack_require__(2051);

var _service_settings4 = _interopRequireDefault(_service_settings3);

__webpack_require__(3059);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceSettingsComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _service_settings2.default,
    controller: _service_settings4.default
};

exports.default = serviceSettingsComponent;

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceSettingsController = function (_SettingBase) {
    ServiceSettingsController.$inject = ["$state"];
    (0, _inherits3.default)(ServiceSettingsController, _SettingBase);

    /*@ngInject*/
    function ServiceSettingsController($state) {
        (0, _classCallCheck3.default)(this, ServiceSettingsController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceSettingsController.__proto__ || (0, _getPrototypeOf2.default)(ServiceSettingsController)).call(this));

        _this.$state = $state;
        _this.id = "service-settings";
        _this.ssid = "service-checklist";
        _this.acl = {};
        _this.hasACL = {};
        _this.hasServiceCheckListACL = {};
        return _this;
    }

    (0, _createClass3.default)(ServiceSettingsController, [{
        key: "$onInit",
        value: function $onInit() {
            (0, _get3.default)(ServiceSettingsController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ServiceSettingsController.prototype), "$onInit", this).call(this);
            for (var key in this.acl['setting-' + this.id]) {
                this.hasACL[this.acl['setting-' + this.id][key]] = true;
            }

            for (var _key in this.acl['setting-' + this.ssid]) {
                this.hasServiceCheckListACL[this.acl['setting-' + this.ssid][_key]] = true;
            }
        }
    }]);
    return ServiceSettingsController;
}(_SettingBase3.default);

exports.default = ServiceSettingsController;

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_ticket_partsAll = __webpack_require__(2053);

var _service_ticket_partsAll2 = _interopRequireDefault(_service_ticket_partsAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceTicketPartsAllModule = angular.module('serviceTicketPartsAll', []).component('serviceTicketPartsAll', _service_ticket_partsAll2.default).name;

exports.default = serviceTicketPartsAllModule;

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_ticket_partsAll = __webpack_require__(2782);

var _service_ticket_partsAll2 = _interopRequireDefault(_service_ticket_partsAll);

var _service_ticket_partsAll3 = __webpack_require__(2054);

var _service_ticket_partsAll4 = _interopRequireDefault(_service_ticket_partsAll3);

__webpack_require__(3060);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceTicketPartsAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _service_ticket_partsAll2.default,
    controller: _service_ticket_partsAll4.default
};

exports.default = serviceTicketPartsAllComponent;

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _service_ticket_partsBase = __webpack_require__(271);

var _service_ticket_partsBase2 = _interopRequireDefault(_service_ticket_partsBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceTicketPartsAllController = function (_BaseController) {
    ServiceTicketPartsAllController.$inject = ["Auth", "$state", "User", "ServiceTicketPartsService", "Modal", "$translate", "$location", "$stateParams"];
    (0, _inherits3.default)(ServiceTicketPartsAllController, _BaseController);

    /*@ngInject*/
    function ServiceTicketPartsAllController(Auth, $state, User, ServiceTicketPartsService, Modal, $translate, $location, $stateParams) {
        (0, _classCallCheck3.default)(this, ServiceTicketPartsAllController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceTicketPartsAllController.__proto__ || (0, _getPrototypeOf2.default)(ServiceTicketPartsAllController)).call(this, Auth, $state, User, ServiceTicketPartsService, Modal, $translate));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.Modal = Modal;
        _this.$location = $location;
        _this.$stateParams = $stateParams;
        _this.page = 1;

        _this.model = {
            currentBranch: _this.User.getUser().branchId,
            searchText: '',
            serviceOrderPartsObj: {
                results: [],
                totalRecords: 0,
                loading: false,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                }
            }
        };
        return _this;
    }

    (0, _createClass3.default)(ServiceTicketPartsAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var pageId = this.$stateParams.page;
            if (pageId > 0) {
                this.page = pageId;
            }
            this.loadData();
        }
    }, {
        key: 'edit',
        value: function edit(part) {
            this.$state.go('service-ticket-parts.edit', {
                id: part.id
            });
        }
    }, {
        key: 'delete',
        value: function _delete(part) {
            var _this2 = this;

            if (this.allowOnlyOnce) return;
            this.allowOnlyOnce = true;
            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_delete_title'),
                message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + part.id + '</strong>?'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    $scope.loading = true;
                    _this2.Service.remove(part.id, part.label, part.serialNumber, _this2.model.currentBranch).then(function (data) {
                        _this2.allowOnlyOnce = false;
                        modal.close();
                        _this2.refresh();
                    });
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    _this2.allowOnlyOnce = false;
                    modal.close();
                },
                type: 'danger'
            });
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.loadData();
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'generateSearchObj',
        value: function generateSearchObj() {
            var obj = {
                queryJSON: {
                    rules: [{
                        field: 'id',
                        condition: 'like',
                        data: '%' + this.model.searchText + '%'
                    }, {
                        field: 'label',
                        condition: 'like',
                        data: '%' + this.model.searchText + '%'
                    }],
                    operator: 'OR'
                }
            };
            return obj.queryJSON.rules.length ? obj : null;
        }
    }, {
        key: 'search',
        value: function search() {
            this.page = 1;
            this.model.serviceOrderPartsObj.pagination.page = 1;
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var _this3 = this;

            var searchObj = this.generateSearchObj();

            this.model.serviceOrderPartsObj.loading = true;
            this.Service.all(searchObj, (this.model.serviceOrderPartsObj.pagination.page - 1) * this.model.serviceOrderPartsObj.pagination.pageLimit, this.model.serviceOrderPartsObj.pagination.pageLimit).then(function (data) {
                _this3.model.serviceOrderPartsObj.totalRecords = data.total;
                _this3.model.serviceOrderPartsObj.results = data.results;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this3.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this3.model.serviceOrderPartsObj.loading = false;
            });
        }
    }]);
    return ServiceTicketPartsAllController;
}(_service_ticket_partsBase2.default);

exports.default = ServiceTicketPartsAllController;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_ticket_partsCreate = __webpack_require__(2056);

var _service_ticket_partsCreate2 = _interopRequireDefault(_service_ticket_partsCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceTicketPartsCreateModule = angular.module('serviceTicketPartsCreate', []).component('serviceTicketPartsCreate', _service_ticket_partsCreate2.default).name;

exports.default = serviceTicketPartsCreateModule;

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_ticket_partsCreate = __webpack_require__(2783);

var _service_ticket_partsCreate2 = _interopRequireDefault(_service_ticket_partsCreate);

var _service_ticket_partsCreate3 = __webpack_require__(2057);

var _service_ticket_partsCreate4 = _interopRequireDefault(_service_ticket_partsCreate3);

__webpack_require__(3061);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceTicketsPartsCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _service_ticket_partsCreate2.default,
    controller: _service_ticket_partsCreate4.default
};

exports.default = serviceTicketsPartsCreateComponent;

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _service_ticket_partsBase = __webpack_require__(271);

var _service_ticket_partsBase2 = _interopRequireDefault(_service_ticket_partsBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceTicketsPartsCreateController = function (_BaseController) {
    ServiceTicketsPartsCreateController.$inject = ["Auth", "$state", "User", "ServiceTicketPartsService", "Modal", "$translate"];
    (0, _inherits3.default)(ServiceTicketsPartsCreateController, _BaseController);

    /*@ngInject*/
    function ServiceTicketsPartsCreateController(Auth, $state, User, ServiceTicketPartsService, Modal, $translate) {
        (0, _classCallCheck3.default)(this, ServiceTicketsPartsCreateController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceTicketsPartsCreateController.__proto__ || (0, _getPrototypeOf2.default)(ServiceTicketsPartsCreateController)).call(this, Auth, $state, User, ServiceTicketPartsService, Modal, $translate));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.Modal = Modal;
        _this.ServiceTicketPartsService = ServiceTicketPartsService;

        _this.defaultModel = {
            currentBranch: _this.User.getUser().branchId,
            label: null,
            serialNumber: null,
            sortOrder: 1,
            partCharge: null
        };

        _this.model = angular.copy(_this.defaultModel);

        _this.serviceOrderParts = {
            results: [],
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            }
        };
        return _this;
    }

    (0, _createClass3.default)(ServiceTicketsPartsCreateController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
        }
    }, {
        key: 'create',
        value: function create() {
            var _this2 = this;

            this.model.isCreate = true;
            this.Service.create({
                branchId: this.model.currentBranch,
                label: this.model.label,
                serialNumber: this.model.serialNumber,
                sortOrder: this.model.sortOrder,
                partCharge: this.model.partCharge
            }).then(function () {
                _this2.askCreate();
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this2.model.errorMessage = e.message;
                });
            }).finally(function () {
                _this2.model.isCreate = false;
            });
        }
    }]);
    return ServiceTicketsPartsCreateController;
}(_service_ticket_partsBase2.default);

exports.default = ServiceTicketsPartsCreateController;

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_ticket_partsEdit = __webpack_require__(2059);

var _service_ticket_partsEdit2 = _interopRequireDefault(_service_ticket_partsEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceTicketPartsEditModule = angular.module('serviceTicketPartsEdit', []).component('serviceTicketPartsEdit', _service_ticket_partsEdit2.default).name;

exports.default = serviceTicketPartsEditModule;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_ticket_partsEdit = __webpack_require__(2784);

var _service_ticket_partsEdit2 = _interopRequireDefault(_service_ticket_partsEdit);

var _service_ticket_partsEdit3 = __webpack_require__(2060);

var _service_ticket_partsEdit4 = _interopRequireDefault(_service_ticket_partsEdit3);

__webpack_require__(3062);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceTicketsPartsEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _service_ticket_partsEdit2.default,
    controller: _service_ticket_partsEdit4.default
};

exports.default = serviceTicketsPartsEditComponent;

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _service_ticket_partsBase = __webpack_require__(271);

var _service_ticket_partsBase2 = _interopRequireDefault(_service_ticket_partsBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceTicketsPartsEditController = function (_BaseController) {
    ServiceTicketsPartsEditController.$inject = ["Auth", "$state", "User", "ServiceTicketPartsService", "Modal", "$translate", "$q", "$stateParams"];
    (0, _inherits3.default)(ServiceTicketsPartsEditController, _BaseController);

    /*@ngInject*/
    function ServiceTicketsPartsEditController(Auth, $state, User, ServiceTicketPartsService, Modal, $translate, $q, $stateParams) {
        (0, _classCallCheck3.default)(this, ServiceTicketsPartsEditController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceTicketsPartsEditController.__proto__ || (0, _getPrototypeOf2.default)(ServiceTicketsPartsEditController)).call(this, Auth, $state, User, ServiceTicketPartsService, Modal, $translate));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.Modal = Modal;
        _this.$q = $q;
        _this.$stateParams = $stateParams;

        _this.model = {
            currentBranch: _this.User.getUser().branchId,
            loading: false
        };
        return _this;
    }

    (0, _createClass3.default)(ServiceTicketsPartsEditController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.model.loading = true;
            this.$q.all([this.Service.get(this.$stateParams.id)]).then(function (data) {
                _this2.serviceOrderPartsObj = data[0];
                _this2.defaultModel = _this2.serviceOrderPartsObj;
                _this2.rawId = _this2.serviceOrderPartsObj.id;
                _this2.model.label = _this2.serviceOrderPartsObj.label;
                _this2.model.serialNumber = _this2.serviceOrderPartsObj.serialNumber;
                _this2.model.sortOrder = _this2.serviceOrderPartsObj.sortOrder;
                _this2.model.partCharge = _this2.serviceOrderPartsObj.partCharge;
            }).catch(function (err) {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this2.errorMessage += e.message + '<br/>';
                    });
                } else {
                    _this2.errorMessage = err.data.message;
                }
            }).finally(function () {
                _this2.model.loading = false;
            });
        }
    }, {
        key: 'update',
        value: function update() {
            var _this3 = this;

            this.model.isUpdating = true;
            this.Service.update(this.rawId, {
                partId: this.rawId,
                branchId: this.model.currentBranch,
                label: this.model.label,
                serialNumber: this.model.serialNumber,
                sortOrder: this.model.sortOrder,
                partCharge: this.model.partCharge
            }).then(function () {
                window.history.go(-1);
            }).catch(function (err) {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this3.errorMessage += e.message + '<br/>';
                    });
                } else {
                    _this3.errorMessage = err.data.message;
                }
            }).finally(function () {
                _this3.model.isUpdating = false;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.clearErrors();
        }
    }]);
    return ServiceTicketsPartsEditController;
}(_service_ticket_partsBase2.default);

exports.default = ServiceTicketsPartsEditController;

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_ticket_parts = __webpack_require__(2062);

var _service_ticket_parts2 = _interopRequireDefault(_service_ticket_parts);

var _create = __webpack_require__(2055);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2058);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2052);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceTicketPartsModule = angular.module('serviceTicketParts', [_create2.default, _edit2.default, _all2.default]).component('serviceTicketParts', _service_ticket_parts2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('service-ticket-parts.edit', {
        url: '/edit/:id',
        component: 'serviceTicketPartsEdit'
    }).state('service-ticket-parts.create', {
        url: '/create',
        component: 'serviceTicketPartsCreate'
    }).state('service-ticket-parts.all', {
        url: '/all/:page',
        component: 'serviceTicketPartsAll'
    });
}]).name;

exports.default = serviceTicketPartsModule;

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_ticket_parts = __webpack_require__(2785);

var _service_ticket_parts2 = _interopRequireDefault(_service_ticket_parts);

var _service_ticket_parts3 = __webpack_require__(2063);

var _service_ticket_parts4 = _interopRequireDefault(_service_ticket_parts3);

__webpack_require__(3063);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceTicketPartsComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _service_ticket_parts2.default,
    controller: _service_ticket_parts4.default
};

exports.default = serviceTicketPartsComponent;

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceTicketPartsController = function (_SettingBase) {
    ServiceTicketPartsController.$inject = ["$state"];
    (0, _inherits3.default)(ServiceTicketPartsController, _SettingBase);

    /*@ngInject*/
    function ServiceTicketPartsController($state) {
        (0, _classCallCheck3.default)(this, ServiceTicketPartsController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceTicketPartsController.__proto__ || (0, _getPrototypeOf2.default)(ServiceTicketPartsController)).call(this));

        _this.$state = $state;
        _this.id = "service-ticket-parts";
        _this.acl = {};
        _this.hasACL = {};
        return _this;
    }

    (0, _createClass3.default)(ServiceTicketPartsController, [{
        key: '$onInit',
        value: function $onInit() {
            (0, _get3.default)(ServiceTicketPartsController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ServiceTicketPartsController.prototype), '$onInit', this).call(this);
            for (var key in this.acl['setting-' + this.id]) {
                this.hasACL[this.acl['setting-' + this.id][key]] = true;
            }
        }
    }]);
    return ServiceTicketPartsController;
}(_SettingBase3.default);

exports.default = ServiceTicketPartsController;

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_tickets = __webpack_require__(2065);

var _service_tickets2 = _interopRequireDefault(_service_tickets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceTicketsModule = angular.module('serviceTickets', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/service-tickets');

    $stateProvider.state('serviceTickets', {
        url: '/service-tickets?encounterId',
        params: {
            encounterId: {
                dynamic: true
            }
        },
        component: 'serviceTickets',
        data: {
            requireLogin: true,
            requireACL: 'service_tickets.all'
        },
        parent: 'app'
    });
}]).component('serviceTickets', _service_tickets2.default).name;

exports.default = serviceTicketsModule;

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_tickets = __webpack_require__(2786);

var _service_tickets2 = _interopRequireDefault(_service_tickets);

var _service_tickets3 = __webpack_require__(2066);

var _service_tickets4 = _interopRequireDefault(_service_tickets3);

__webpack_require__(3064);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceTicketsComponent = {
    restrict: 'E',
    bindings: {},
    template: _service_tickets2.default,
    controller: _service_tickets4.default
};

exports.default = serviceTicketsComponent;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__(628);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _USA = __webpack_require__(1541);

var _USA2 = _interopRequireDefault(_USA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceTicketsController = function () {
    /*@ngInject*/
    ServiceTicketsController.$inject = ["Auth", "$rootScope", "UserBranchService", "User", "LocationService", "RouteService", "ServiceOrderService", "Modal", "DateUtil", "Navigation", "$translate", "SetupService", "$q", "$state", "UsersService", "CommonLayoutService", "DataCounter"];
    function ServiceTicketsController(Auth, $rootScope, UserBranchService, User, LocationService, RouteService, ServiceOrderService, Modal, DateUtil, Navigation, $translate, SetupService, $q, $state, UsersService, CommonLayoutService, DataCounter) {
        (0, _classCallCheck3.default)(this, ServiceTicketsController);

        this.Auth = Auth;
        this.$rootScope = $rootScope;
        this.UserBranchService = UserBranchService;
        this.LocationService = LocationService;
        this.RouteService = RouteService;
        this.ServiceOrderService = ServiceOrderService;
        this.Modal = Modal;
        this.User = User;
        this.DateUtil = DateUtil;
        this.Navigation = Navigation;
        this.$translate = $translate;
        this.SetupService = SetupService;
        this.$q = $q;
        this.$state = $state;
        this.DataCounter = DataCounter;
        this.UsersService = UsersService;
        this.$rootScope.$broadcast('routeChange', '/app/service-tickets');
        this.CommonLayoutService = CommonLayoutService;

        this.model = {
            loggedInUser: User.getUser().id,
            selectedBranch: '',
            selectedLocation: '',
            selectedRoute: '',
            selectedStatus: '',
            selectedUser: '',
            selectedAction: '',
            searchKey: null,
            mapStatus: true,
            serviceOrderData: [],
            isLoadingServiceOrder: false,
            serviceHistoryData: {},
            currentBranch: User.getUser().branchId,
            branchVaultDate: '',
            dateRangeOptions: {},
            dateRangPickerOptions: {},
            dateRangPickerOptionsfor: {},
            selectedServiceZone: '',
            selectedCustomer: ''
            // serviceRequestInfo: [],
            // serviceOrderInfo: []
        };

        this.acl = {};
        this.hasACL = {};

        this.totalBranches = 0;
        this.userBranchList = [];
        this.totalLocations = 0;
        this.locationList = [];
        this.totalRoutes = 0;
        this.routeList = [];
        this.totalUsers = 0;
        this.userList = [];
        this.totalStatus = 0;
        this.status = [];
        this.totalActions = 0;
        this.actions = [];
        this.totalLatLongLocations = 0;
        this.lat = 0;
        this.long = 0;
        this.centerLatitude = '';
        this.centerLongitude = '';
        this.markerPosition = [];
        this.serviceHistory = {};
        this.serviceOrderError = '';
        this.isValid = false;
        this.buckets = [];
        this.statusUpdate = {};
        this.assignTo = {};
        this.locationLatLong = [];
        this.bucketsExpand = {};
        this.sortOrderData = {};
        this.sortColumn = "encounterId";
        this.reverseSort = false;
        this.serviceZoneList = [];
        this.customerList = [];
        this.totalCustomer = 0;
        this.statusList = [{ label: 'Complete', value: 'COMPLETE' },
        // { label: 'Invalid', value: 'INVALID' },
        { label: 'Incomplete', value: 'INCOMPLETED' }, { label: 'Accepted', value: 'ACCEPTED' }, { label: 'Assigned', value: 'ASSIGNED' }, { label: 'On-Route', value: 'ON_ROUTE' }, { label: 'On-Site', value: 'ON_SITE' }, { label: 'Hold', value: 'HOLD' }, { label: 'Hold-Parts', value: 'HOLD_PARTS' }, { label: 'Cancelled', value: 'CANCELLED' }, { label: 'Unaccepted', value: 'UNACCEPTED' }];

        this.actionList = [{ label: 'Install', value: 'install' }, { label: 'De-Install', value: 'de-install' }, { label: 'General', value: 'general' }, { label: 'Connectivity-Unreachable', value: 'connectivity-unreachable' }, { label: 'Wireless-Replace', value: 'wireless-replace' }, { label: 'Connectivity-Poor', value: 'connectivity-poor' }, { label: 'Dispenser', value: 'dispenser' }, { label: 'Dispenser-Replace', value: 'dispenser-replace' }, { label: 'Screen', value: 'screen' }, { label: 'Paper', value: 'paper' }, { label: 'Card-Reader', value: 'card-reader' }, { label: 'Card-Reader-Replace', value: 'card-reader-replace' }, { label: 'Printer', value: 'printer' }, { label: 'Printer-Replace', value: 'printer-replace' }, { label: 'Cassette', value: 'cassette' }, { label: 'Keypad', value: 'keypad' }, { label: 'Keypad-Replace', value: 'keypad-replace' }, { label: 'Keypad-Reload-Keys', value: 'keypad-reload-keys' }, { label: 'Lock-Battery', value: 'lock-battery' }, { label: 'Lock-Replace', value: 'lock-replace' }, { label: 'Upgrade-Software', value: 'upgrade-software' }, { label: 'Mainboard-Replace', value: 'mainboard-replace' }, { label: 'Power-Supply-Replace', value: 'power-supply-replace' }, { label: 'Vault-Door', value: 'vault-door' }, { label: 'Function-Keys-Replace', value: 'function-keys-replace' }, { label: 'Cleaning', value: 'cleaning' }];

        this.toggleSwitchUI = {
            size: 'small',
            onColor: 'success',
            offColor: 'danger'

            // 'red', 'darkred', 'orange', 'green', 'darkgreen', 'blue', 'purple', 'darkpurple', 'cadetblue'
        };this.markerColorMapping = {
            'COMPLETE': 'green',
            'ACCEPTED': 'darkgreen',
            'ASSIGNED': 'blue',
            'UNASSIGNED': 'red',
            'ON_ROUTE': 'cadetblue',
            'ON_SITE': 'pink',
            'HOLD': 'orange',
            'CANCELLED': 'lightgray',
            // 'ASSIGNED_PENDING_CHECKOUT': 'purple',
            'CANT_COMPLETE_BUCKET': 'lightred',
            'ASSIGNED_PENDING_MESSENGER_ACCEPT': 'purple',
            'UNACCEPTED': 'darkred',
            'PENDING_ASSIGN': 'darkpurple'
        };

        this.defaultDisalbleMapButton = ['CANCELLED', 'COMPLETE', 'ASSIGNED', 'HOLD', 'ON_ROUTE'];
        this.localLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: this.$translate.instant('common.selectBranch') //default-label is deprecated and replaced with this.
        };
        this.dateRangeForBucket = ['CANCELLED', 'COMPLETE'];
        this.disabledResetBtn = false;
        this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
        this.isCustomer = this.User.getUser().customerUser;
        this.currentLoggedInUserInfo = this.User.getUser();
        this.externalProcessorObj = {};
        this.isCompletedIsUndo = false;
        this.canRunAutoAssignNow = this.isAutoAssignTestUser();
        this.isRunningAutoAssignNow = false;
    }

    (0, _createClass3.default)(ServiceTicketsController, [{
        key: 'loadPermission',
        value: function loadPermission() {
            var _this = this;

            this.acl = {};
            this.hasACL = {};
            ['service_tickets'].forEach(function (permissionKey) {
                _this.acl = _this.User.getACL(permissionKey);

                _this.hasACL = {};

                _this.acl.forEach(function (permission) {
                    _this.hasACL[permission] = true;
                });
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.$q.all([this.SetupService.get(this.model.currentBranch), this.getUserBranches(), this.loadPermission()]).then(function (data) {
                _this2.branchInfo = data[0];
                _this2.setDefaultBranch();
                _this2.model.branchVaultDate = data[0].currentVaultDate; // branch vaultDate without conversion
            }).then(function () {
                var today = moment().startOf('day').format();
                _this2.dateRangeForBucket.forEach(function (bucket) {
                    _this2.model.dateRangeOptions[bucket] = { startDate: null, endDate: null };
                    _this2.setDateRangeOptions(today, _this2.model.dateRangeOptions[bucket], 'dateRangPickerOptionsfor');
                    _this2.model.dateRangeOptions[bucket].startDate = moment(today).subtract(1, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
                    _this2.model.dateRangeOptions[bucket].endDate = moment(today).endOf('day').format('YYYY-MM-DD HH:mm:ss');
                });
                var obj = _this2.DataCounter.getData();
                if (obj) {
                    _this2.model.searchKey = obj.encounterId;
                }
                if (_this2.$state.params && _this2.$state.params.encounterId) {
                    _this2.model.searchKey = _this2.$state.params.encounterId;
                }
                _this2.replaceURL();
                _this2.loadData();
            });
        }
    }, {
        key: 'replaceURL',
        value: function replaceURL() {
            if (this.model.searchKey) {
                this.$state.transitionTo('serviceTickets', { id: this.model.searchKey });
            }
        }
    }, {
        key: 'serviceTicketSort',
        value: function serviceTicketSort(column, bucket) {
            if (!this.sortOrderData[bucket]) this.sortOrderData[bucket] = {};

            if (this.sortOrderData[bucket] && this.sortOrderData[bucket][this.sortColumn]) {
                this.sortOrderData[bucket][this.reverseSort] = this.sortOrderData[bucket][this.sortColumn] === column ? !this.sortOrderData[bucket][this.reverseSort] : false;
            } else this.sortOrderData[bucket][this.reverseSort] = false;

            this.sortOrderData[bucket][this.sortColumn] = column;
        }
    }, {
        key: 'bucketSort',
        value: function bucketSort(column, bucket) {
            if (!this.sortOrderData[bucket]) this.sortOrderData[bucket] = {};

            if (this.sortOrderData[bucket] && this.sortOrderData[bucket][this.sortColumn]) {
                this.sortOrderData[bucket][this.reverseSort] = this.sortOrderData[bucket][this.sortColumn] === column ? !this.sortOrderData[bucket][this.reverseSort] : false;
            } else this.sortOrderData[bucket][this.reverseSort] = false;

            this.sortOrderData[bucket][this.sortColumn] = column;
            if (bucket === 'COMPLETE' || bucket === 'CANCELLED') {
                this.bucketPageChange(bucket);
            }
        }

        // load user branches

    }, {
        key: 'getUserBranches',
        value: function getUserBranches(searchKey, offset) {
            var _this3 = this;

            searchKey = searchKey || '';

            return this.ServiceOrderService.getUserBranchList(this.model.loggedInUser).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this3.totalBranches = data.results.length;
                    _this3.userBranchList = _this3.userBranchMap(data.results);
                } else {
                    var branches = _this3.userBranchMap(data.results);
                    _this3.userBranchList = _this3.userBranchList.concat(branches);
                }
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'userBranchMap',
        value: function userBranchMap(branches) {
            return branches.map(function (branch) {
                return {
                    Key: branch.branchId,
                    Value: branch.branchId,
                    branchVaultDate: branch.currentVaultDate
                };
            });
        }
    }, {
        key: 'resetLocations',
        value: function resetLocations() {
            this.model.selectedLocation = '';
        }
    }, {
        key: 'resetRoutes',
        value: function resetRoutes() {
            this.model.selectedRoute = '';
        }
    }, {
        key: 'resetUsers',
        value: function resetUsers() {
            this.model.selectedUser = '';
        }
    }, {
        key: 'resetActions',
        value: function resetActions() {
            this.model.selectedAction = '';
        }
    }, {
        key: 'resetServiceZones',
        value: function resetServiceZones() {
            this.model.selectedServiceZone = '';
        }
    }, {
        key: 'resetCustomer',
        value: function resetCustomer() {
            this.model.selectedCustomer = '';
        }
    }, {
        key: 'resetDateFilter',
        value: function resetDateFilter() {
            var _this4 = this;

            this.dateRangeForBucket.forEach(function (bucket) {
                _this4.model.dateRangeOptions[bucket].startDate = moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
                _this4.model.dateRangeOptions[bucket].endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
            });
        }
    }, {
        key: 'loadStatus',
        value: function loadStatus() {
            this.totalStatus = this.statusList.length;
            var status = this.mappingStatus(this.statusList);
            this.status = this.status.concat(status);
        }
    }, {
        key: 'mappingStatus',
        value: function mappingStatus(data) {
            return data.map(function (status) {
                return {
                    Key: status.label,
                    Value: status.value
                };
            });
        }
    }, {
        key: 'loadActions',
        value: function loadActions() {
            this.actions = [];
            // this.totalActions = this.actionList.length;
            var action = this.mappingAction(this.actionList);
            this.actions = this.actions.concat(action);
            this.totalActions = this.actions.length;
        }
    }, {
        key: 'mappingAction',
        value: function mappingAction(data) {
            return data.map(function (action) {
                return {
                    Key: action.label,
                    Value: action.value || action.actionCodeId
                };
            });
        }
    }, {
        key: 'loadMap',
        value: function loadMap() {
            var _this5 = this;

            this.centerLatitude = this.lat ? this.lat / this.totalLatLongLocations : 39.68649209557518;
            this.centerLongitude = this.long ? this.long / this.totalLatLongLocations : -101.48273981764913;

            setTimeout(function () {
                _this5.map = L.map('map', {});

                var osm = new L.TileLayer.BoundaryCanvas("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                    boundary: _USA2.default,
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                });

                _this5.map.addLayer(osm);
                _this5.map.fitBounds(_this5.locationLatLong.length ? _this5.locationLatLong : [[_this5.branchInfo.gpsLat, _this5.branchInfo.gpsLong]]);

                _this5.buckets.forEach(function (d) {
                    _this5.model.serviceOrderData[d.bucket].items.forEach(function (data) {
                        if (data && data.lat && data.long && d.isShow) {
                            _this5.locationInfo = '<strong>' + data.locationName + '</strong>' + '<br>' + data.address + ' - ' + data.zip + '<br>' + data.city + ', ' + data.state;

                            var id = L.marker([data.lat, data.long], {
                                icon: new L.AwesomeNumberMarkers({
                                    number: data.encounterId,
                                    markerColor: _this5.markerColorMapping[d.bucket]
                                }),
                                zIndexOffset: d.bucket === 'COMPLETE' ? -1000 : d.bucket === 'CANCELLED' ? -2000 : 0
                            }).addTo(_this5.map).bindPopup(_this5.locationInfo);

                            id.on('mouseover', function () {
                                id.openPopup();
                            });

                            id.on('mouseout', function () {
                                id.closePopup();
                            });
                        }
                    });
                });
            }, 500);
        }
    }, {
        key: 'reloadMap',
        value: function reloadMap() {
            if (this.model.mapStatus) return this.loadMap();
        }
    }, {
        key: 'isAutoAssignTestUser',
        value: function isAutoAssignTestUser() {
            var firstName = (this.User.getUser().firstName || '').toUpperCase();
            var lastName = (this.User.getUser().lastName || '').toUpperCase();

            return firstName === 'COORWORKS' && lastName === 'ADMIN' || firstName === 'ADMIN' && lastName === 'COORWORKS' || firstName === 'HANK' && lastName === 'WRIGHT' || firstName === 'WRIGHT' && lastName === 'HANK';
        }
    }, {
        key: 'runAutoAssignNow',
        value: function runAutoAssignNow() {
            var _this6 = this;

            if (this.isRunningAutoAssignNow) return;
            this.isRunningAutoAssignNow = true;

            this.ServiceOrderService.runAutoAssignNow().then(function () {
                _this6.Modal.alert({
                    header: 'Success',
                    message: 'Auto-assign job has been triggered.',
                    type: 'success',
                    callback: function callback(_ref) {
                        var modal = _ref.modal;
                        modal.close();
                    }
                });
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this6.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this6.isRunningAutoAssignNow = false;
            });
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            this.disabledResetBtn = true;
            this.resetMultiBranchSelection();
            this.model.selectedBranch = [];
            this.model.selectedStatus = '';
            this.model.selectedUser = '';
            this.model.selectedAction = '';
            this.model.searchKey = '';
            this.totalLocations = 0;
            this.totalRoutes = 0;
            this.totalUsers = 0;
            this.totalServiceZone = 0;
            this.totalCustomer = 0;
            this.model.mapStatus = true;
            this.bucketsExpand = {};

            this.resetLocations();
            this.resetRoutes();
            this.resetUsers();
            this.resetActions();
            this.resetDateFilter();
            this.resetServiceZones();
            this.setDefaultBranch();
            this.resetCustomer();

            this.model.selectedBranch = [{
                Key: this.model.currentBranch,
                Value: this.model.currentBranch,
                branchVaultDate: this.model.branchVaultDate
            }];

            if (this.map) {
                this.map = undefined;
            }

            this.loadData();
        }
    }, {
        key: 'getServiceOrders',
        value: function getServiceOrders() {
            var _this7 = this;

            this.model.isLoadingServiceOrder = true;

            var locationId = this.model.selectedLocation ? this.model.selectedLocation.Value : null;
            var routeId = this.model.selectedRoute ? this.model.selectedRoute.Value : null;
            var userId = this.model.selectedUser ? this.model.selectedUser.Value : null;
            var actionId = this.model.selectedAction ? this.model.selectedAction.Value : null;
            var branchIds = this.model.selectedBranch ? this.model.selectedBranch.map(function (branch) {
                return branch.Value;
            }) : [];
            var serviceZoneId = this.model.selectedServiceZone ? this.model.selectedServiceZone.Value : null;
            var customerId = this.model.selectedCustomer ? this.model.selectedCustomer.Value : null;
            var bucketName = '';
            var filter = {
                pageLimit: _app2.default.defaultPageLimit,
                pageOffset: 0,
                searchKey: this.model.searchKey ? this.model.searchKey : null,
                dateRange: {}
            };

            this.dateRangeForBucket.forEach(function (bucket) {
                filter.dateRange[bucket] = { startDate: null, endDate: null };
                filter.dateRange[bucket].startDate = moment(_this7.model.dateRangeOptions[bucket].startDate).format('YYYY-MM-DD HH:mm:ss');
                filter.dateRange[bucket].endDate = moment(_this7.model.dateRangeOptions[bucket].endDate).format('YYYY-MM-DD HH:mm:ss');
                filter.dateRange[bucket].columnName = _this7.sortColumn;
                filter.dateRange[bucket].sortAsc = _this7.reverseSort;
            });

            this.buckets = [];
            this.serviceOrderError = '';
            this.locationLatLong = [];
            this.userList = [];

            return this.ServiceOrderService.getServiceOrder(branchIds, locationId, routeId, userId, actionId, bucketName, filter, moment.tz.guess(), customerId, serviceZoneId).then(function (data) {
                _this7.model.serviceOrderData = data.results;
                _this7.model.totalServiceOrders = data.totalRecords;
                _this7.totalCompletedAndCancelledServiceTickets = data.totalCompletedAndCancelledServiceTickets;
                _this7.actionList = data.actionCodes;
                _this7.browserTimezone = moment.tz.guess();
                var keys = (0, _keys2.default)(_this7.model.serviceOrderData);
                _this7.setFilterData(data);
                for (var k in _this7.model.serviceOrderData) {
                    if (k === 'HOLD') {
                        var items = _this7.model.serviceOrderData[k].items;
                        items.map(function (item) {
                            item.timeToHold = _this7.calculateDuration(item.acceptedOn, item.statusTimestamp);
                        });
                    }
                    if (k === 'ASSIGNED' || k === 'ASSIGNED_PENDING_MESSENGER_ACCEPT') {
                        var _items = _this7.model.serviceOrderData[k].items;
                        _items.map(function (item) {
                            item.timeToAssigned = _this7.calculateDuration(item.acceptedOn, item.firstAssignOn);
                        });
                    }
                    if (k === 'ON_ROUTE') {
                        var _items2 = _this7.model.serviceOrderData[k].items;
                        _items2.map(function (item) {
                            item.timeToOnRoute = _this7.calculateDuration(item.acceptedOn, item.firstOnRouteOn);
                        });
                    }
                    if (k === 'ON_SITE') {
                        var _items3 = _this7.model.serviceOrderData[k].items;
                        _items3.map(function (item) {
                            item.timeToOnSite = _this7.calculateDuration(item.acceptedOn, item.firstOnSiteOn);
                        });
                    }
                }
                setTimeout(function () {
                    keys.map(function (key) {
                        if (_this7.model.serviceOrderData[key] && _this7.model.serviceOrderData[key].items.length || key == 'COMPLETE' || key == 'CANCELLED') _this7.buckets.push({ bucket: key });
                    });

                    _this7.buckets.forEach(function (d, i) {
                        if (_this7.bucketsExpand) {
                            _this7.bucketsExpand[d.bucket] = {
                                isExpanded: _this7.bucketsExpand[d.bucket] && _this7.bucketsExpand[d.bucket].isExpanded ? _this7.bucketsExpand[d.bucket].isExpanded : false,
                                bucketName: d.bucket,
                                child: _this7.bucketsExpand[d.bucket] && _this7.bucketsExpand[d.bucket].child ? _this7.bucketsExpand[d.bucket].child : {},
                                // isShow: (this.bucketsExpand[d.bucket] && (typeof this.bucketsExpand[d.bucket].isShow) !== 'undefined') ? this.bucketsExpand[d.bucket].isShow : this.defaultDisalbleMapButton.indexOf(d.bucket) >= 0 ? false : true
                                isShow: _this7.bucketsExpand[d.bucket] && typeof _this7.bucketsExpand[d.bucket].isShow !== 'undefined' ? _this7.bucketsExpand[d.bucket].isShow : d.bucket === 'CANCELLED' || d.bucket === 'COMPLETE' ? false : true
                            };
                            d.bucketExpanded = _this7.bucketsExpand[d.bucket].isExpanded || false;
                        }

                        _this7.model.serviceOrderData[d.bucket].page = _this7.model.serviceOrderData[d.bucket].page || 1;
                        _this7.model.serviceOrderData[d.bucket].pageLimit = _this7.model.serviceOrderData[d.bucket].pageLimit || _app2.default.defaultPageLimit;
                        _this7.model.serviceOrderData[d.bucket].pageOffset = _this7.model.serviceOrderData[d.bucket].pageOffset || 0;

                        if (_this7.model.serviceOrderData[d.bucket] && _this7.model.serviceOrderData[d.bucket].items.length) {
                            _this7.isValid = true;
                            _this7.model.serviceOrderData[d.bucket].items.forEach(function (info, index) {
                                _this7.decorateServiceTicket(info);
                                if (info.lat && info.long) {
                                    _this7.locationLatLong.push(new Array(info.lat, info.long));
                                    _this7.totalLatLongLocations += 1; // locations which have lat, long value counted as totalLatLongLocations
                                    _this7.lat += info.lat; // sum of Lattitude value of location
                                    _this7.long += info.long; //  sum of Longitude value of location
                                }
                                _this7.model.serviceOrderData[d.bucket].items[index].expanded = _this7.bucketsExpand[d.bucket].child[info.encounterId] || false;
                            });
                        }

                        _this7.bucketItem = _this7.model.serviceOrderData[d.bucket].items;
                        _this7.serviceTicketSort(_this7.sortColumn, d.bucket);
                    });

                    if (!_this7.buckets.length || !data.locations.length || !data.routes.length) _this7.isValid = false;else if (_this7.buckets.length || data.locations.length || data.routes.length) _this7.isValid = true;

                    _this7.validateMap();
                    _this7.calculateThresholds();
                    _this7.getLastUpdatedTime();

                    if (_this7.model.mapStatus && _this7.isValid) {
                        _this7.loadMap();
                    }
                    _this7.model.isLoadingServiceOrder = false;
                }, 1);
            }).catch(function (err) {
                console.log(err);
                _this7.model.isLoadingServiceOrder = false;
                _this7.serviceOrderError = err.data.message;
            });
        }
    }, {
        key: 'loadOrderHistoryData',
        value: function loadOrderHistoryData(data, event) {
            if (data.expanded) {
                this.getServiceOrderHistory(data, event);
            } else {
                delete this.model.serviceHistoryData[data.serviceOrderId];
            }
            // window.onscroll = function () { window.scrollBy(0, 0); };
            // window.scrollTo({ top: 0, behavior: 'smooth' });
            document.getElementById('expand-btn-' + data.serviceOrderId).blur();
        }
    }, {
        key: 'getServiceOrderHistory',
        value: function getServiceOrderHistory(data, event) {
            var _this8 = this;

            this.serviceHistory[data.serviceOrderId] = { process: true };
            return this.ServiceOrderService.serviceOrderHistory(data.encounterId, data.serviceOrderId, data.externalProcessorId).then(function (history) {
                _this8.model.serviceHistoryData[data.serviceOrderId] = { details: history };
                if (!data.externalProcessorId) {
                    var result = [].concat((0, _toConsumableArray3.default)(_this8.model.serviceHistoryData[data.serviceOrderId].details.serviceOrderUpdateHistory), (0, _toConsumableArray3.default)(_this8.model.serviceHistoryData[data.serviceOrderId].details.supervisorUpdateLogs));

                    _this8.updateHistory = _this8.sortData(result);
                    _this8.model.serviceHistoryData[data.serviceOrderId].details.serviceOrderUpdateHistory = _this8.mergeUpdateHistory(_this8.updateHistory);
                }
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this8.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this8.serviceHistory[data.serviceOrderId].process = false;
            });
            if (event) event.preventDefault();
        }
    }, {
        key: 'openUpdateServiceHistory',
        value: function openUpdateServiceHistory(updateHistory, serviceOrder) {
            var _this9 = this;

            if (!updateHistory || !updateHistory.length) return;
            var firstItem = updateHistory[0];
            var shouldRefreshMainList = false;
            var refParams = {};
            if (serviceOrder) {
                refParams = {
                    serviceOrderId: serviceOrder.serviceOrderId,
                    encounterId: serviceOrder.encounterId,
                    externalProcessorId: serviceOrder.externalProcessorId
                };
            } else {
                refParams = {
                    serviceOrderId: firstItem.serviceOrderId,
                    encounterId: firstItem.encounterId || firstItem.entryData && firstItem.entryData.encounterId,
                    externalProcessorId: firstItem.externalProcessorId
                };
            }

            this.Modal.updateServiceHistory(updateHistory, function (_ref2) {
                var modal = _ref2.modal,
                    history = _ref2.history,
                    isSingleAction = _ref2.isSingleAction,
                    onSuccess = _ref2.onSuccess,
                    $scope = _ref2.$scope;

                $scope.model.isLoading = true;
                if (!history || !history.length) {
                    if (!isSingleAction) modal.close();
                    return;
                }

                _this9.ServiceOrderService.updateServiceHistory(history, _this9.browserTimezone, _this9.model.currentBranch).then(function (res) {
                    if (onSuccess) onSuccess(res.results);
                    if (isSingleAction) {
                        var item = history[0];
                        var isDeleted = item && item.isDeletedFlag;
                        if (isDeleted || item && (item.isFirstAccepted || item.isLastCompleted)) shouldRefreshMainList = true;

                        _this9.Modal.alert({
                            header: 'Success',
                            message: isDeleted ? 'Status deleted successfully' : 'Status updated successfully',
                            type: 'success',
                            callback: function callback(_ref3) {
                                var alertModal = _ref3.modal;
                                alertModal.close();
                            }
                        });
                        // this.getServiceOrderHistory(refParams);
                    }
                    if (!isSingleAction) {
                        modal.close();
                        if (history.some(function (item) {
                            return item.isDeletedFlag || item.isFirstAccepted || item.isLastCompleted;
                        })) {
                            shouldRefreshMainList = true;
                        }
                        _this9.getServiceOrderHistory(refParams);
                        if (shouldRefreshMainList) {
                            _this9.getServiceOrders();
                        }
                    }
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        _this9.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    $scope.model.isLoading = false;
                });
            }, function (_ref4) {
                var modal = _ref4.modal;

                if (modal) modal.close();
                _this9.getServiceOrderHistory(refParams);
                if (shouldRefreshMainList) {
                    _this9.getServiceOrders();
                }
            });
        }
    }, {
        key: 'mergeUpdateHistory',
        value: function mergeUpdateHistory(updateHistory) {
            var _this10 = this;

            // 'service-tickets-assign-to-user'
            this.isCompletedIsUndo = false;
            var statusCodeList = ['ACCEPTED', 'ASSIGNED', 'ON_ROUTE', 'ON_SITE', 'HOLD', 'HOLD_PARTS', 'INCOMPLETED', 'COMPLETE', 'CANCELLED'];
            var statusLogMapping = {
                'ACCEPTED': ['create-service-order'],
                'ASSIGNED': ['service-tickets-assign-to-route', 'send-assign-notification'],
                'ON_ROUTE': ['service-ticket-on-route'],
                'ON_SITE': ['service-ticket-on-site'],
                'HOLD': ['service-ticket-hold', 'service-ticket-hold-parts'],
                'HOLD_PARTS': ['service-ticket-hold-parts'],
                'COMPLETE': ['service-ticket-completed', 'mark-service-order-completed', 'service-ticket-undo-completed'],
                'CANCELLED': ['service-ticket-cancelled', 'service-ticket-undo-cancelled'],
                'INCOMPLETED': ['service-ticket-incomplete']
            };
            var finalResults = [];

            var _loop = function _loop(index) {
                var history = updateHistory[index];
                if (statusCodeList.includes(history.status)) {
                    var matchingLogIndex = _.findIndex(updateHistory, function (record, i) {
                        var match = i > index && record.entryType && statusLogMapping[history.status] && statusLogMapping[history.status].includes(record.entryType);
                        return match;
                    });

                    if (matchingLogIndex !== -1) {
                        var logRecord = updateHistory[matchingLogIndex];
                        logRecord.statusUpdate = _this10.getBucketName(history.status).concat(' ((', _this10.translateEntryType(logRecord.entryType), ')').split(' (');

                        var merged = (0, _extends3.default)({}, logRecord, history);
                        merged.logId = logRecord.id;
                        if (merged.entryData && merged.serviceOrderStatusNote) {
                            merged.entryData.note = merged.serviceOrderStatusNote;
                        }
                        finalResults.push(merged);
                        updateHistory.splice(matchingLogIndex, 1);
                    } else {
                        var lastResult = finalResults[finalResults.length - 1];
                        if (lastResult && lastResult.entryType && statusLogMapping[history.status] && statusLogMapping[history.status].includes(lastResult.entryType)) {
                            var _merged = (0, _extends3.default)({}, lastResult, history);
                            _merged.logId = lastResult.id;
                            _merged.statusUpdate = _this10.getBucketName(history.status).concat(' ((', _this10.translateEntryType(lastResult.entryType), ')').split(' (');
                            if (_merged.entryData && _merged.serviceOrderStatusNote) {
                                _merged.entryData.note = _merged.serviceOrderStatusNote;
                            }
                            finalResults[finalResults.length - 1] = _merged;
                        } else {
                            finalResults.push(history);
                        }
                    }
                } else {
                    finalResults.push(history);
                }
            };

            for (var index = 0; index < updateHistory.length; index++) {
                _loop(index);
            }

            var userIndex = _.findIndex(finalResults, { entryType: 'service-tickets-assign-to-user' });
            if (userIndex !== -1) {
                var assignedIndex = _.findIndex(finalResults, { status: 'ASSIGNED', timestamp: finalResults[userIndex].timestamp });
                if (assignedIndex !== -1) {
                    var _finalResults$splice = finalResults.splice(userIndex, 1),
                        _finalResults$splice2 = (0, _slicedToArray3.default)(_finalResults$splice, 1),
                        userItem = _finalResults$splice2[0];

                    var newIndex = userIndex < assignedIndex ? assignedIndex : assignedIndex + 1;
                    finalResults.splice(newIndex, 0, userItem);
                }
            }

            var editableStatuses = ['ACCEPTED', 'ASSIGNED', 'ON_ROUTE', 'ON_SITE', 'COMPLETE'];
            editableStatuses.forEach(function (status) {
                var lastStatus = _.findLast(finalResults, { status: status });
                if (lastStatus) lastStatus.isLatest = true;
            });

            var lastOnSite = _.findLast(finalResults, { status: 'ON_SITE' });
            var lastComplete = _.findLast(finalResults, { status: 'COMPLETE' });
            if (lastOnSite) lastOnSite.isLatest = true;
            var lastOnSiteIndex = lastOnSite ? finalResults.indexOf(lastOnSite) : -1;
            var lastCompleteIndex = lastComplete ? finalResults.indexOf(lastComplete) : -1;

            if (lastComplete && lastCompleteIndex > lastOnSiteIndex) {
                lastComplete.isLatest = true;
            } else {
                this.isCompletedIsUndo = true;
            }

            var firstAccepted = _.find(finalResults, { status: 'ACCEPTED' });
            if (firstAccepted) firstAccepted.isFirstAccepted = true;

            return finalResults;
        }
    }, {
        key: 'sortData',
        value: function sortData(data) {
            return data.sort(function (a, b) {
                return new Date(a.timestamp) - new Date(b.timestamp) || (b.entryType || '').includes('undo') - (a.entryType || '').includes('undo');
            });
        }
    }, {
        key: 'checkBrowserDiff',
        value: function checkBrowserDiff(date) {
            var browserTimezone = moment.tz.guess(),
                startTime = moment.tz(date, browserTimezone).format(),
                currentTime = moment().format();
            return moment(currentTime).diff(startTime);
        }
    }, {
        key: 'convertToMillisecond',
        value: function convertToMillisecond(date) {
            var browserTimezone = moment.tz.guess(); // get the browsers current time zone.
            var convertDate = moment.tz(date, browserTimezone).format(); // convert date to specific timezone
            return moment(convertDate).valueOf(); // convert date in milliseconds
        }
    }, {
        key: 'uniqueLocations',
        value: function uniqueLocations() {
            var _this11 = this;

            var data = [];
            this.locationList = [];
            this.buckets.forEach(function (d) {
                if (_this11.model.serviceOrderData[d.bucket].items && _this11.model.serviceOrderData[d.bucket].items.length) data.push.apply(data, (0, _toConsumableArray3.default)(_this11.model.serviceOrderData[d.bucket].items));
            });
            var locationGroup = _.groupBy(data, 'locationId');
            var keys = (0, _keys2.default)(locationGroup);
            keys.map(function (key) {
                var location = key.concat(" | ", locationGroup[key][0].locationName);
                _this11.locationList.push({ Key: location, Value: key });
            });
            this.totalLocations = this.locationList.length;
        }
    }, {
        key: 'uniqueRoutes',
        value: function uniqueRoutes() {
            var _this12 = this;

            var data = [];
            this.routeList = [];
            this.buckets.forEach(function (d) {
                if (_this12.model.serviceOrderData[d.bucket] && _this12.model.serviceOrderData[d.bucket].items.length) data.push.apply(data, (0, _toConsumableArray3.default)(_this12.model.serviceOrderData[d.bucket].items));
            });
            var routeGroup = _.groupBy(data, 'routeId');
            var keys = (0, _keys2.default)(routeGroup);
            keys.map(function (key) {
                var route = key.concat(" | ", routeGroup[key][0].routeName);
                _this12.routeList.push({ Key: route, Value: key });
            });
            this.totalRoutes = this.routeList.length;
        }
    }, {
        key: 'uniqueUsers',
        value: function uniqueUsers() {
            var _this13 = this;

            var bucketKeys = (0, _keys2.default)(this.model.serviceOrderData);
            var users = [];
            if (bucketKeys && bucketKeys.length) {
                bucketKeys.map(function (key) {
                    if (_this13.model.serviceOrderData[key] && _this13.model.serviceOrderData[key].items.length) {
                        _this13.model.serviceOrderData[key].items.map(function (order, j) {
                            if (order.statusCode == 'ASSIGNED' && order.userId && order.username) {
                                users.push({
                                    Key: order.userId + " | " + order.username,
                                    Value: order.userId
                                });
                            }
                        });
                    }
                });
            }
            this.userList = _.orderBy(_.uniqBy(users, 'Value'));
            this.totalUsers = this.userList.length;
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var _this14 = this;

            setTimeout(function () {
                _this14.getServiceOrders().then(function () {
                    _this14.disabledResetBtn = false;
                    _this14.loadActions();
                }).then(function () {
                    _this14.DataCounter.setData();
                });
            });
        }
    }, {
        key: 'validateMap',
        value: function validateMap() {
            var _this15 = this;

            this.buckets.map(function (data) {
                if (_this15.model.mapStatus && _this15.model.serviceOrderData[data.bucket] && _this15.model.serviceOrderData[data.bucket].items.length) {
                    return data.isShow = _this15.model.mapStatus ? _this15.bucketsExpand[data.bucket] && typeof _this15.bucketsExpand[data.bucket].isShow != 'undefined' ? _this15.bucketsExpand[data.bucket].isShow : true : false;
                }
                if (!_this15.model.mapStatus && _this15.model.serviceOrderData[data.bucket] && _this15.model.serviceOrderData[data.bucket].items.length) {
                    return data.isShow = _this15.model.mapStatus ? _this15.bucketsExpand[data.bucket] && typeof _this15.bucketsExpand[data.bucket].isShow != 'undefined' ? _this15.bucketsExpand[data.bucket].isShow : false : false;
                }
            });
        }
    }, {
        key: 'validateMarkers',
        value: function validateMarkers(data) {
            if (this.map) {
                this.map.remove();
                this.map = undefined;
                this.loadMap();
            }
        }
    }, {
        key: 'details',
        value: function details(data) {
            this.Modal.serviceOrderDetail(data, function (_ref5) {
                var modal = _ref5.modal;
            }, function (_ref6) {
                var modal = _ref6.modal;

                modal.close();
            });
        }
    }, {
        key: 'redirectToServiceHistory',
        value: function redirectToServiceHistory(locationId) {
            this.Navigation.goToServiceHistory(locationId, null, true, null);
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(serviceOrder) {
            var _this16 = this;

            if (this.model.currentBranch === serviceOrder.branchId) {
                this.redirectToServiceHistory(serviceOrder.locationId);
            } else {
                this.shiftBranch(this.model.loggedInUser, serviceOrder.branchId).then(function () {
                    _this16.redirectToServiceHistory(serviceOrder.locationId);
                });
            }
        }

        // Update Service Order Note

    }, {
        key: 'serviceOrderNotes',
        value: function serviceOrderNotes(data, bucket, event) {
            var _this17 = this;

            var vaultDate = this.formatVaultDate(data.branchCurrentVaultDate);
            var openNotesModal = function openNotesModal() {
                var updatedHistory = _this17.model.serviceHistoryData[data.serviceOrderId].details.serviceOrderUpdateHistory;
                _this17.Modal.serviceOrderNotes(data, updatedHistory, function (_ref7) {
                    var modal = _ref7.modal,
                        serviceOrderUserNote = _ref7.serviceOrderUserNote,
                        serviceOrderNote = _ref7.serviceOrderNote,
                        serviceOrderUserNotes = _ref7.serviceOrderUserNotes,
                        $scope = _ref7.$scope;

                    $scope.model.loading = true;
                    _this17.ServiceOrderService.updateServiceOrderNoteList(data.encounterId, data.serviceOrderId, data.branchId, serviceOrderNote, vaultDate, data.routeId, data.statusCode, serviceOrderUserNotes).then(function () {
                        modal.close();
                        var serviceOrder = _.find(_this17.model.serviceOrderData[bucket].items, { 'encounterId': data.encounterId });
                        serviceOrder.serviceOrderUserNote = serviceOrderUserNote;
                        serviceOrder.serviceOrderNote = serviceOrderNote;
                        if (serviceOrderUserNotes && serviceOrderUserNotes.length) {
                            serviceOrderUserNotes.forEach(function (note) {
                                var history = _.find(updatedHistory, { id: note.id });
                                if (history) {
                                    history.serviceOrderStatusNote = note.note;
                                }
                            });
                        }
                    }).catch(function (err) {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            _this17.Modal.errorModal(err.data.message);
                        }
                    }).finally(function () {
                        $scope.model.loading = false;
                    });
                });
            };

            if (this.model.serviceHistoryData[data.serviceOrderId] && this.model.serviceHistoryData[data.serviceOrderId].details && this.model.serviceHistoryData[data.serviceOrderId].details.serviceOrderUpdateHistory && (!this.serviceHistory[data.serviceOrderId] || !this.serviceHistory[data.serviceOrderId].process)) {
                openNotesModal();
            } else {
                this.getServiceOrderHistory(data, event).then(function () {
                    openNotesModal();
                });
            }
        }
    }, {
        key: 'getBucketName',
        value: function getBucketName(status) {
            switch (status) {
                case 'INCOMPLETED':
                    return this.$translate.instant('serviceTickets.incomplete');
                case status:
                    return this.$translate.instant('serviceTickets.status_' + status);
                default:
                    return;
            }
        }

        // Auto Close (Service Actions) table when bucket is closed

    }, {
        key: 'autoCloseTable',
        value: function autoCloseTable(data) {
            if (this.model.serviceOrderData[data.bucket] && this.model.serviceOrderData[data.bucket].items && this.model.serviceOrderData[data.bucket].items.length) {
                this.model.serviceOrderData[data.bucket].items.forEach(function (serviceOrder) {
                    if (!data.bucketExpanded) {
                        if (serviceOrder.expanded) {
                            serviceOrder.expanded = false;
                        }
                    }
                });
            }
        }

        // Update service order status

    }, {
        key: 'serviceOrderStatusUpdateModal',
        value: function serviceOrderStatusUpdateModal(serviceOrder) {
            var _this18 = this;

            if (this.statusUpdate[serviceOrder.encounterId] && this.statusUpdate[serviceOrder.encounterId].process) return;
            this.statusUpdate[serviceOrder.encounterId] = { process: true };

            this.UsersService.checkSupervisor(this.model.loggedInUser).then(function (userInfo) {
                _this18.Modal.serviceOrderStatusUpdate(serviceOrder, _this18.isCustomer ? false : !userInfo.supervisor, _this18.customerId, _this18.currentLoggedInUserInfo, function (_ref8) {
                    var modal = _ref8.modal,
                        note = _ref8.note,
                        status = _ref8.status,
                        supervisorId = _ref8.supervisorId;

                    var supId = userInfo.supervisor ? userInfo.id : supervisorId;
                    // if selected status is `ASSIGNED` then call assign modal so branch operator can assign `route` or `user` to service tickets
                    if (status === 'ASSIGNED') {
                        return _this18.serviceOrderAssignModal(serviceOrder, note).then(function () {
                            modal.close();
                            _this18.statusUpdate[serviceOrder.encounterId].process = false;
                        });
                    } else if (status === 'COMPLETE') {
                        _this18.ServiceOrderService.getLastArrivalTime(serviceOrder.serviceOrderId).then(function (data) {
                            serviceOrder.lastArrivalTime = data.lastArrivalTime || null;
                            return _this18.serviceOrderActionsModal(serviceOrder, note, supId).then(function () {
                                modal.close();
                                _this18.statusUpdate[serviceOrder.encounterId].process = false;
                            });
                        }).catch(function () {
                            console.log(err);
                            _this18.Modal.errorModal(err.data.message);
                        });
                    } else {
                        return _this18.updateServiceOrderStatus(serviceOrder, status, supId, note, modal);
                    }
                }, function (_ref9) {
                    var modal = _ref9.modal;

                    if (modal) modal.close();
                    _this18.statusUpdate[serviceOrder.encounterId].process = false;
                });
            }).catch(function (err) {
                _this18.Modal.errorModal(err.data.message);
            });
        }
    }, {
        key: 'updateServiceOrderStatus',
        value: function updateServiceOrderStatus(serviceOrder, status, supervisorId, note, modal) {
            var _this19 = this;

            var vaultDate = this.formatVaultDate(serviceOrder.branchCurrentVaultDate);

            return this.ServiceOrderService.updateServiceOrderStatus(serviceOrder.routeId, status, serviceOrder.encounterId, supervisorId, note, serviceOrder.branchId, serviceOrder.serviceOrderId, vaultDate).then(function () {
                _this19.loadData(); // refresh data after status update
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_SERVICEORDERSTATUS_LIFECYCLE_ENDED') {
                        _this19.Modal.errorModal('serviceTickets.lifeCycleEnded');
                    } else {
                        _this19.Modal.errorModal(err.data.message);
                    }
                }
            }).finally(function () {
                if (modal) modal.close();
                _this19.statusUpdate[serviceOrder.encounterId].process = false;
            });
        }

        // assign service tickets to route or user or externalProcessor

    }, {
        key: 'serviceOrderAssignModal',
        value: function serviceOrderAssignModal(serviceOrder) {
            var _this20 = this;

            var note = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var encounterId = serviceOrder.encounterId;

            if (this.assignTo[encounterId] && this.assignTo[encounterId].process) return;
            this.assignTo[encounterId] = { process: true };

            var defer = this.$q.defer();
            var vaultDate = this.formatVaultDate(serviceOrder.branchCurrentVaultDate);

            this.ServiceOrderService.validateServiceOrderAssign(serviceOrder.serviceOrderId).then(function () {
                return _this20.Modal.serviceOrderAssign(serviceOrder, vaultDate, function (_ref10) {
                    var modal = _ref10.modal,
                        routeId = _ref10.routeId,
                        userId = _ref10.userId,
                        externalProcessorCode = _ref10.externalProcessorCode,
                        currentStats = _ref10.currentStats;

                    var route = currentStats === 'route' ? routeId : null; // pass routeId if service tickets assign to route (for this case pass userId as null)
                    var user = currentStats === 'user' ? userId.toString() : null; // pass userId if service tickets assign to user (for this case pass routeId as null)
                    if (externalProcessorCode) {
                        _this20.ServiceOrderService.transferUnassignedToExternal(encounterId, externalProcessorCode, serviceOrder.branchId, _this20.model.loggedInUser).then(function () {
                            _this20.loadData();
                        }).catch(function (err) {
                            console.log(err);
                            _this20.Modal.errorModal(err.data.message);
                        });
                    } else {
                        return _this20.assignToRouteOrUserByEncounterId(serviceOrder.serviceOrderId, encounterId, user, route, note, serviceOrder.branchId, vaultDate, serviceOrder.userId).then(function () {
                            return defer.resolve();
                        });
                    }
                }, function (_ref11) {
                    var modal = _ref11.modal;

                    if (modal) modal.close();
                });
            }).catch(function (err) {
                defer.reject();
                _this20.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this20.assignTo[encounterId].process = false;
            });

            return defer.promise;
        }
    }, {
        key: 'assignToRouteOrUserByEncounterId',
        value: function assignToRouteOrUserByEncounterId(serviceOrderId, encounterId, user, route, note, branchId, branchVaultDate, serviceTicketUserId) {
            var _this21 = this;

            return this.ServiceOrderService.assignToRouteOrUser(serviceOrderId, encounterId, user, route, note, branchId, branchVaultDate, serviceTicketUserId).then(function () {
                _this21.loadData();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_SERVICEORDERSTATUS_LIFECYCLE_ENDED') {
                        _this21.Modal.errorModal('serviceTickets.lifeCycleEnded');
                    } else {
                        _this21.Modal.errorModal(err.data.message);
                    }
                }
            }).finally(function () {
                // modal.close();
                _this21.assignTo[encounterId].process = false;
            });
        }
    }, {
        key: 'goToRouteTab',
        value: function goToRouteTab(serviceOrder) {
            var _this22 = this;

            if (this.model.currentBranch === serviceOrder.branchId) {
                this.redirectToRouteTab(serviceOrder.routeId, serviceOrder.branchCurrentVaultDate);
            } else {
                this.shiftBranch(this.model.loggedInUser, serviceOrder.branchId).then(function () {
                    _this22.redirectToRouteTab(serviceOrder.routeId, serviceOrder.branchCurrentVaultDate);
                });
            }
        }
    }, {
        key: 'redirectToRouteTab',
        value: function redirectToRouteTab(routeId, branchVaultDate) {
            return this.Navigation.goToRouteTab(routeId, branchVaultDate, true, null);
        }
    }, {
        key: 'goToUserTab',
        value: function goToUserTab(order) {
            this.Navigation.goToUserTab(order.userId);
        }
    }, {
        key: 'shiftBranch',
        value: function shiftBranch(userId, selectedBranch) {
            var _this23 = this;

            var obj = {
                id: userId,
                branchId: selectedBranch
            };
            var defer = this.$q.defer();
            this.UsersService.updateUserBranch(obj.id, obj).then(function (data) {
                _this23.User.setUser(data);
                defer.resolve();
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this23.errorMessage += e.message + '<br/>';
                });
                _this23.Modal.errorModal(_this23.errorMessage);
            });
            return defer.promise;
        }

        // calculate hours, minutes, seconds between two date

    }, {
        key: 'calculateDuration',
        value: function calculateDuration(startDate, endDate) {
            var start = moment(startDate).valueOf();
            var end = moment(endDate).valueOf();

            if (start && end && end < start) {
                // reverse the date order
                var t = startDate;
                startDate = endDate;
                endDate = t;
            }

            var ms = moment(endDate).diff(startDate);
            var duration = moment.duration(ms);
            return Math.floor(duration.asHours()) + moment.utc(ms).format(":mm:ss");
        }

        // branchCurrentVaultDate() {
        //     return this.model.selectedBranch ? this.DateUtil.getUTCDate(this.model.selectedBranch.branchVaultDate) : null;
        // }

    }, {
        key: 'formatVaultDate',
        value: function formatVaultDate(branchVaultDate) {
            return this.DateUtil.getUTCDate(branchVaultDate);
        }
    }, {
        key: 'translateEntryType',
        value: function translateEntryType(type) {
            return this.$translate.instant('entry_type.' + type);
        }
    }, {
        key: 'undoServiceOrder',
        value: function undoServiceOrder(data) {
            var _this24 = this;

            if (this.allowOnlyOnce) return;
            this.allowOnlyOnce = true;

            var title = void 0,
                message = void 0,
                status = void 0;
            if (data.statusCode === 'COMPLETE' || data.completed) {
                title = this.$translate.instant('serviceTickets.undo_completed_title');
                message = this.$translate.instant('serviceTickets.undo_completed_message');
                status = 'COMPLETE';
            }
            if (data.statusCode === 'CANCELLED' || data.cancelled) {
                title = this.$translate.instant('serviceTickets.undo_cancelled_title');
                message = this.$translate.instant('serviceTickets.undo_cancelled_message');
                status = 'CANCELLED';
            }

            this.Modal.confirm({
                header: title,
                message: message + (' <strong>' + data.serviceOrderId + '</strong>?'),
                callback: function callback(_ref12) {
                    var modal = _ref12.modal,
                        $scope = _ref12.$scope;

                    _this24.ServiceOrderService.undoServiceOrder(status, data.encounterId, data.serviceOrderId, data.branchId, data.routeId).then(function () {
                        _this24.loadData();
                    }).catch(function (err) {
                        if (err && err.data && err.data.message) {
                            _this24.Modal.errorModal(err.data.message);
                        }
                    }).finally(function () {
                        modal.close();
                        _this24.allowOnlyOnce = false;
                    });
                },
                negative: function negative(_ref13) {
                    var modal = _ref13.modal;

                    _this24.allowOnlyOnce = false;
                    modal.close();
                },
                type: 'danger'
            });
        }
    }, {
        key: 'formatJsonObj',
        value: function formatJsonObj(obj) {
            var status = obj.status,
                note = obj.note,
                rest = (0, _objectWithoutProperties3.default)(obj, ['status', 'note']);

            var orderedObj = {};
            if (status) orderedObj.status = status;
            if (note) orderedObj.note = note;
            (0, _assign2.default)(orderedObj, rest);

            delete orderedObj.notes;
            delete orderedObj.serviceOrderStatusNote;
            delete orderedObj.serviceOrderStatusNotes;

            var details = (0, _stringify2.default)(orderedObj);
            var addPipe = details.replace(/,/g, ' | ');
            var removeCurlyBraces = addPipe.replace(/[{}]/g, "");
            var finalObj = removeCurlyBraces.replace(/:/g, ": ");
            return finalObj.replace(/\"/g, "");
        }
    }, {
        key: 'getUpdateNoteHistory',
        value: function getUpdateNoteHistory(data) {
            var _ref14 = data || {},
                serviceOrderStatusNotes = _ref14.serviceOrderStatusNotes,
                rest = (0, _objectWithoutProperties3.default)(_ref14, ['serviceOrderStatusNotes']);

            return {
                info: this.formatJsonObj(rest),
                notes: serviceOrderStatusNotes || []
            };
        }

        // Reset Multi-Branch selection

    }, {
        key: 'resetMultiBranchSelection',
        value: function resetMultiBranchSelection() {
            var _this25 = this;

            if (this.model.selectedBranch && this.model.selectedBranch.length) {
                this.model.selectedBranch.forEach(function (selectedBranch) {
                    _this25.userBranchList.filter(function (branch) {
                        if (branch.branchId == selectedBranch.branchId) {
                            branch.ticked = false;
                        }
                    });
                });
            }
        }
    }, {
        key: 'serviceOrderActionsModal',
        value: function serviceOrderActionsModal(serviceOrder, serviceOrderStatusNote, userId) {
            var _this26 = this;

            var defer = this.$q.defer();

            this.Modal.serviceOrderActions(serviceOrder, function (_ref15) {
                var modal = _ref15.modal,
                    actionCodeData = _ref15.actionCodeData,
                    $scope = _ref15.$scope,
                    completedByUserId = _ref15.completedByUserId,
                    completedDate = _ref15.completedDate,
                    completedTime = _ref15.completedTime,
                    arrivedDate = _ref15.arrivedDate,
                    arrivedTime = _ref15.arrivedTime;

                var completedDateTime = completedDate.concat(' ', completedTime);
                var completedAt = moment(completedDateTime).utc().format();
                var arrivedDateTime = arrivedDate.concat(' ', arrivedTime);
                var arrivedAt = moment(arrivedDateTime).utc().format();

                _this26.ServiceOrderService.markServiceOrderCompleted(actionCodeData, serviceOrder.branchId, serviceOrder.routeId, serviceOrder.serviceOrderId, serviceOrder.encounterId, serviceOrderStatusNote, userId, completedByUserId, completedAt, arrivedAt).then(function () {
                    _this26.loadData(); // refresh data after status update
                    modal.close();
                    defer.resolve();
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        // if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_NULL_COMPLETEDBYUSERID') {
                        //     $scope.model.errorMessage = this.$translate.instant('serviceTickets.null_completed_by_userId');
                        //     this.getBranchServiceUser(serviceOrder.branchId, $scope)
                        // }
                        if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_SOA_TOO_FEW_RESPONSES') {
                            $scope.model.errorMessage = _this26.$translate.instant('serviceTickets.too_few_responses');
                        } else {
                            $scope.model.errorMessage = err.data.message;
                        }
                    }
                }).finally(function () {
                    $scope.model.isUpdate = false;
                });
            }, function (_ref16) {
                var modal = _ref16.modal;

                if (modal) modal.close();
            });
            return defer.promise;
        }
    }, {
        key: 'calculateAssignAndAcceptTime',
        value: function calculateAssignAndAcceptTime(assignTime, acceptTime) {
            return moment(assignTime).isSameOrAfter(acceptTime);
        }
    }, {
        key: 'showChildBucket',
        value: function showChildBucket(val, bucketName, bucketIndex, orders) {
            // this.model.serviceOrderData[bucketName][orders.encounterId].expanded = val;
            this.bucketsExpand[bucketName].child[orders.encounterId] = val;
        }
    }, {
        key: 'setStatusExpanded',
        value: function setStatusExpanded(bucketName) {
            this.bucketsExpand[bucketName].isExpanded = !this.bucketsExpand[bucketName].isExpanded;
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.getServiceOrders();
        }
    }, {
        key: 'bucketPageChange',
        value: function bucketPageChange(bucketName) {
            var _this27 = this;

            if (!this.sortOrderData[bucketName]) this.sortOrderData[bucketName] = {};
            this.model.serviceOrderData[bucketName].process = true;
            var locationId = this.model.selectedLocation ? this.model.selectedLocation.Value : null;
            var routeId = this.model.selectedRoute ? this.model.selectedRoute.Value : null;
            // let status = this.model.selectedStatus ? this.model.selectedStatus.Value : null;
            var userId = this.model.selectedUser ? this.model.selectedUser.Value : null;
            var actionId = this.model.selectedAction ? this.model.selectedAction.Value : null;
            var branchIds = this.model.selectedBranch ? this.model.selectedBranch.map(function (branch) {
                return branch.Value;
            }) : [];
            var serviceZoneId = this.model.selectedServiceZone ? this.model.selectedServiceZone.Value : null;
            var customerId = this.model.selectedCustomer ? this.model.selectedCustomer.Value : null;
            var filter = {
                searchKey: this.model.searchKey ? this.model.searchKey : null,
                pageLimit: this.model.serviceOrderData[bucketName].pageLimit || _app2.default.defaultPageLimit,
                pageOffset: this.model.serviceOrderData[bucketName].page - 1 ? (this.model.serviceOrderData[bucketName].page - 1) * this.model.serviceOrderData[bucketName].pageLimit : 0,
                dateRange: {}
            };
            filter.dateRange[bucketName] = { startDate: null, endDate: null };
            filter.dateRange[bucketName].startDate = moment(this.model.dateRangeOptions[bucketName].startDate).format('YYYY-MM-DD HH:mm:ss');
            filter.dateRange[bucketName].endDate = moment(this.model.dateRangeOptions[bucketName].endDate).format('YYYY-MM-DD HH:mm:ss');
            filter.dateRange[bucketName].columnName = this.sortOrderData[bucketName][this.sortColumn];
            filter.dateRange[bucketName].sortAsc = this.sortOrderData[bucketName][this.reverseSort];

            this.serviceOrderError = '';
            return this.ServiceOrderService.getServiceOrder(branchIds, locationId, routeId, userId, actionId, bucketName, filter, moment.tz.guess(), customerId, serviceZoneId).then(function (data) {
                if (data['COMPLETE'] && data['COMPLETE'].users) {
                    _this27.userList = _.orderBy(_.uniqBy([].concat((0, _toConsumableArray3.default)(_this27.userList), (0, _toConsumableArray3.default)(data['COMPLETE'].users)), 'Value'));
                }
                _this27.totalUsers = _this27.userList.length;
                _this27.model.serviceOrderData[bucketName].items = data[bucketName].items || [];
                _this27.model.serviceOrderData[bucketName].totalCount = data[bucketName].totalCount || 0;
                if (_this27.model.serviceOrderData[bucketName] && _this27.model.serviceOrderData[bucketName].items.length) {
                    _this27.isValid = true;
                    _this27.model.serviceOrderData[bucketName].items.forEach(function (info, index) {
                        _this27.decorateServiceTicket(info);

                        if (info.lat && info.long) {
                            _this27.locationLatLong.push(new Array(info.lat, info.long));
                            _this27.totalLatLongLocations += 1; // locations which have lat, long value counted as totalLatLongLocations
                            _this27.lat += info.lat; // sum of Lattitude value of location
                            _this27.long += info.long; //  sum of Longitude value of location
                        }
                        _this27.model.serviceOrderData[bucketName].items[index].expanded = _this27.bucketsExpand[bucketName].child[info.encounterId] || false;
                    });
                }
                //  else {
                // this.showBuckets();
                // }
                if (_this27.buckets.length <= 0) _this27.isValid = false;
            }).then(function () {
                if (_this27.model.mapStatus && _this27.isValid) _this27.validateMarkers();
                _this27.getLastUpdatedTime();
            }).catch(function (err) {
                console.log(err);
                // this.serviceOrderError = this.$translate.instant('error.' + err.data.message);
                _this27.serviceOrderError = err.data.message;
            }).finally(function () {
                _this27.model.serviceOrderData[bucketName].process = false;
            });
        }
    }, {
        key: 'showBuckets',
        value: function showBuckets() {
            var _this28 = this;

            var bucketItems = this.buckets.filter(function (key) {
                return _this28.model.serviceOrderData[key.bucket] && _this28.model.serviceOrderData[key.bucket].items && _this28.model.serviceOrderData[key.bucket].items.length;
            });
            this.isValid = !!bucketItems.length;
            if (!bucketItems.length) {
                this.buckets = [];
            }
            return !!bucketItems.length;
        }
    }, {
        key: 'getBranchServiceUser',
        value: function getBranchServiceUser(branchId, $scope) {
            var _this29 = this;

            this.ServiceOrderService.getServiceUser(branchId).then(function (data) {
                $scope.model.serviceUserList = data.results;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this29.Modal.errorModal(err.data.message);
                }
            });
        }
    }, {
        key: 'setDateRangeOptions',
        value: function setDateRangeOptions(date, dateRangeOption, modelVal) {
            var _this30 = this;

            this.model[modelVal] = {
                autoApply: true,
                //   minDate: moment().subtract(14, 'days').startOf('day').format('YYYY-MM-DD'),
                opens: "left",
                drops: "auto",
                cancelOnOutsideClick: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this30.model.serviceOrderData[_this30.selectedBucket].page = 1;
                        _this30.bucketPageChange(_this30.selectedBucket);
                    }
                    // 'show.daterangepicker': (ev, picker) => {
                    //     console.log(picker, ev)
                    //     // ev.opts.drops =  this.model.mapStatus ? 'up' : 'auto';
                    //     // return ev
                    // },
                },
                ranges: {
                    'Last 2 Days': [moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: 'getSelectedBucket',
        value: function getSelectedBucket(bucket) {
            this.selectedBucket = bucket;
            return this.selectedBucket;
        }
    }, {
        key: 'setFilterData',
        value: function setFilterData(data) {
            if (!this.totalLocations) {
                this.locationList = data.locations || [];
                this.updatedLocationList = data.locations;
                this.totalLocations = this.locationList.length;
            }

            if (!this.totalRoutes) {
                this.routeList = data.routes || [];
                this.totalRoutes = this.routeList.length;
            }

            // if (!this.totalUsers) {
            this.userList = data.users;
            this.totalUsers = this.userList.length;
            // }

            if (!this.totalServiceZone) {
                this.serviceZoneList = data.serviceZone || [];
                this.totalServiceZone = this.serviceZoneList.length;
            }

            if (!this.totalCustomer) {
                this.customerList = data.customer || [];
                this.updatedcustomerList = data.customer;
                this.totalCustomer = this.customerList.length;
                if (this.totalCustomer === 1 && !this.model.selectedCustomer && this.customerId) {
                    this.model.selectedCustomer = this.customerList[0];
                }
            }
        }
    }, {
        key: 'onBranchChange',
        value: function onBranchChange() {
            this.totalLocations = 0;
            this.totalRoutes = 0;
            this.totalUsers = 0;
            this.totalServiceZone = 0;
            this.totalCustomer = 0;
            this.model.searchKey = null;
            this.resetLocations();
            this.resetRoutes();
            this.resetUsers();
            this.resetActions();
            this.resetServiceZones();
            this.resetDateFilter();
            this.resetCustomer();
        }
    }, {
        key: 'showBucketSearch',
        value: function showBucketSearch() {
            return (this.model.selectedBranch || this.model.selectedLocation || this.model.selectedRoute || this.model.selectedStatus || this.model.selectedUser || this.model.selectedAction || this.model.selectedServiceZone || this.model.selectedCustomer) && true;
        }

        // Calculate NOW() - (service order createdAt) time in milliseconds

    }, {
        key: 'calculateHours',
        value: function calculateHours(date) {
            var startDate = new Date();
            var endDate = new Date(date);
            var diff = moment(startDate).diff(endDate);
            return diff;
        }
    }, {
        key: 'getTime',
        value: function getTime(time) {
            var ms = moment.duration(time).valueOf();
            return ms;
        }
    }, {
        key: 'getPriorityDurationHours',
        value: function getPriorityDurationHours(requestedTimeframe) {
            var priorityHours = {
                '24HR': 24,
                '48HR': 48,
                '72HR': 72
            };

            return priorityHours[requestedTimeframe] || null;
        }
    }, {
        key: 'getPriorityReferenceTime',
        value: function getPriorityReferenceTime(serviceTicket) {
            return serviceTicket.createdAt;
        }
    }, {
        key: 'formatPriorityRemaining',
        value: function formatPriorityRemaining(ms) {
            var overdueLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Overdue';

            var absoluteMs = Math.abs(ms);
            var duration = moment.duration(absoluteMs);
            var totalMinutes = Math.max(Math.floor(duration.asMinutes()), 0);
            var hours = Math.floor(totalMinutes / 60);
            var minutes = totalMinutes % 60;
            var compactDuration = hours > 0 ? hours + 'h ' + minutes + 'm' : minutes + 'm';

            return ms < 0 ? overdueLabel + ' ' + compactDuration : compactDuration + ' left';
        }
    }, {
        key: 'decoratePriorityDetails',
        value: function decoratePriorityDetails(serviceTicket) {
            var branchTimezone = serviceTicket.branchTimezone || this.branchInfo && this.branchInfo.timezone || moment.tz.guess();
            var requestedTimeframe = serviceTicket.requestedTimeframe || null;
            var referenceTime = this.getPriorityReferenceTime(serviceTicket);
            // Use branch timezone for comparison to show "Time Left" correctly (Now vs Deadline)
            var comparisonTime = moment().tz(branchTimezone);

            var effectiveRequestedTimeframe = requestedTimeframe;
            var priorityRemaining = null;
            var isOverdue = false;

            if (requestedTimeframe === 'SCHEDULED' && serviceTicket.targetTime) {
                // Treat as Branch Local
                var targetMoment = moment.tz(serviceTicket.targetTime, branchTimezone);
                var remainingMs = targetMoment.diff(comparisonTime);
                isOverdue = remainingMs <= 0;
                priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : this.formatPriorityRemaining(remainingMs);

                // Already in branch timezone
                serviceTicket.targetTimeDisplay = targetMoment.format('MM/DD/YYYY | HH:mm:ss');
            } else {
                var priorityHours = this.getPriorityDurationHours(requestedTimeframe);

                if (priorityHours && referenceTime) {
                    // Treat as Branch Local
                    var deadlineMoment = moment.tz(referenceTime, branchTimezone).add(priorityHours, 'hours');
                    var _remainingMs = deadlineMoment.diff(comparisonTime);
                    isOverdue = _remainingMs <= 0;

                    priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : this.formatPriorityRemaining(_remainingMs);

                    // Already in branch timezone
                    serviceTicket.targetTimeDisplay = deadlineMoment.format('MM/DD/YYYY | HH:mm:ss');
                    serviceTicket.targetTime = deadlineMoment.toISOString();
                } else if (requestedTimeframe === 'ASAP') {
                    if (referenceTime) {
                        var asapMoment = moment.tz(referenceTime, branchTimezone);
                        var _remainingMs2 = asapMoment.diff(comparisonTime);
                        priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : this.formatPriorityRemaining(_remainingMs2);

                        serviceTicket.targetTimeDisplay = asapMoment.format('MM/DD/YYYY | HH:mm:ss');
                        serviceTicket.targetTime = asapMoment.toISOString();
                    } else {
                        priorityRemaining = serviceTicket.completed || serviceTicket.cancelled ? null : 'Immediate';
                    }
                }
            }

            if (isOverdue && ['24HR', '48HR', '72HR', 'SCHEDULED'].includes(requestedTimeframe)) {
                effectiveRequestedTimeframe = 'ASAP';
            }

            serviceTicket.displayRequestedTimeframe = effectiveRequestedTimeframe;
            serviceTicket.priorityRemaining = priorityRemaining;
            serviceTicket.priorityEscalated = requestedTimeframe !== 'ASAP' && effectiveRequestedTimeframe === 'ASAP';
            serviceTicket.isPriorityAlert = effectiveRequestedTimeframe === 'ASAP' || requestedTimeframe === '24HR';
        }
    }, {
        key: 'decorateServiceTicket',
        value: function decorateServiceTicket(serviceTicket) {
            if (serviceTicket.completed) {
                var timeDiff = moment(serviceTicket.completedAt).diff(serviceTicket.createdAt);
                var duration = moment.duration(timeDiff);
                var timePending = Math.floor(duration.asHours());
                serviceTicket.timeOpen = timePending + ':' + moment.utc(duration.asMilliseconds()).format('mm:ss');
            }

            if (serviceTicket.cancelled) {
                var _timeDiff = moment(serviceTicket.cancelledAt).diff(serviceTicket.createdAt);
                var _duration = moment.duration(_timeDiff);
                var _timePending = Math.floor(_duration.asHours());
                serviceTicket.timeOpen = _timePending + ':' + moment.utc(_duration.asMilliseconds()).format('mm:ss');
            }

            this.decoratePriorityDetails(serviceTicket);
        }
    }, {
        key: 'calculateThresholds',
        value: function calculateThresholds() {
            var _this31 = this;

            this.serviceOrderThresolds = {};
            this.indexMap = {};

            this.buckets.forEach(function (b) {
                if (b.bucket !== 'COMPLETE' && b.bucket !== 'CANCELLED') {
                    _this31.serviceOrderThresolds[b.bucket] = {
                        totalRedThreshold: 0, totalOrangeThreshold: 0, totalYellowThreshold: 0, redThresholdIds: [],
                        orangeThresholdIds: [], yellowThresholdIds: []
                    };
                }

                if (_this31.model.serviceOrderData[b.bucket].items.length && b.bucket !== 'COMPLETE' && b.bucket !== 'CANCELLED') {
                    _this31.model.serviceOrderData[b.bucket].items.forEach(function (serviceTickets) {
                        if (serviceTickets.thresholds && serviceTickets.thresholds.length) {
                            serviceTickets.thresholds.forEach(function (threshold) {
                                if (threshold.redThreshold) {
                                    if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.redThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('06:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].redThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalRedThreshold++;
                                        }
                                    } else if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.redThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('04:00:00') && _this31.calculateHours(serviceTickets.createdAt) < _this31.getTime('06:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].orangeThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalOrangeThreshold++;
                                        }
                                    } else if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.redThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('02:00:00') && _this31.calculateHours(serviceTickets.createdAt) < _this31.getTime('04:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].yellowThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalYellowThreshold++;
                                        }
                                    }
                                }
                                if (threshold.orangeThreshold) {
                                    if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.orangeThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('06:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].redThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalRedThreshold++;
                                        }
                                    } else if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.orangeThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('04:00:00') && _this31.calculateHours(serviceTickets.createdAt) < _this31.getTime('06:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].orangeThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalOrangeThreshold++;
                                        }
                                    } else if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.orangeThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('02:00:00') && _this31.calculateHours(serviceTickets.createdAt) < _this31.getTime('04:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].yellowThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalYellowThreshold++;
                                        }
                                    }
                                }
                                if (threshold.yellowThreshold) {
                                    if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.yellowThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('06:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].redThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalRedThreshold++;
                                        }
                                    } else if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.yellowThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('04:00:00') && _this31.calculateHours(serviceTickets.createdAt) < _this31.getTime('06:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].orangeThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalOrangeThreshold++;
                                        }
                                    } else if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.yellowThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('02:00:00') && _this31.calculateHours(serviceTickets.createdAt) < _this31.getTime('04:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].yellowThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalYellowThreshold++;
                                        }
                                    }
                                }
                                if (threshold.otherThreshold) {
                                    if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.otherThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('06:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].redThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalRedThreshold++;
                                        }
                                    } else if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.otherThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('04:00:00') && _this31.calculateHours(serviceTickets.createdAt) < _this31.getTime('06:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].orangeThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalOrangeThreshold++;
                                        }
                                    } else if (_this31.calculateHours(serviceTickets.createdAt) > _this31.getTime(threshold.otherThreshold) && _this31.calculateHours(serviceTickets.createdAt) > _this31.getTime('02:00:00') && _this31.calculateHours(serviceTickets.createdAt) < _this31.getTime('04:00:00')) {
                                        if (!_this31.indexMap.hasOwnProperty(serviceTickets.encounterId)) {
                                            _this31.indexMap[serviceTickets.encounterId] = serviceTickets.thresholds.length;
                                            _this31.serviceOrderThresolds[b.bucket].yellowThresholdIds.push(serviceTickets.encounterId);
                                            _this31.serviceOrderThresolds[b.bucket].totalYellowThreshold++;
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }
    }, {
        key: 'getLastUpdatedTime',
        value: function getLastUpdatedTime() {
            this.lastUpdatedTime = moment().format('DD/MM/YYYY | hh:mm:ss A');
        }
    }, {
        key: 'setDefaultBranch',
        value: function setDefaultBranch() {
            var _this32 = this;

            this.userBranchList.filter(function (branch) {
                if (branch.Value == _this32.model.currentBranch) branch.ticked = true;
            });
        }
    }, {
        key: 'formatAddress',
        value: function formatAddress(data) {
            var locationAddress = '';
            if (data.address) {
                locationAddress = locationAddress.concat(data.address, ', ');
            }
            if (data.city) {
                locationAddress = locationAddress.concat(data.city, ', ');
            }
            if (data.state) {
                locationAddress = locationAddress.concat(data.state, ', ');
            }
            if (data.zip) {
                locationAddress = locationAddress.concat(data.zip);
            }
            return locationAddress;
        }
    }, {
        key: 'showCreateModal',
        value: function showCreateModal() {
            var _this33 = this;

            var branchIds = this.model.selectedBranch ? this.model.selectedBranch.map(function (branch) {
                return branch.Value;
            }) : [];
            this.Modal.createServiceTicket({ branch: branchIds, customerId: this.customerId }, function (_ref17) {
                var modal = _ref17.modal,
                    data = _ref17.data,
                    assignData = _ref17.assignData;

                _this33.ServiceOrderService.create(data).then(function (res) {
                    var hasAssignment = assignData && (assignData.routeId || assignData.userId || assignData.externalProcessorCode);

                    if (hasAssignment && res.data.encounterId) {
                        var encounterId = res.data.encounterId;
                        var branchId = data.branchId || _this33.User.getUser().branchId;
                        var vaultDate = _this33.formatVaultDate(_this33.model.branchVaultDate);

                        if (assignData.externalProcessorCode) {
                            return _this33.ServiceOrderService.transferUnassignedToExternal(encounterId, assignData.externalProcessorCode, branchId, _this33.model.loggedInUser).then(function () {
                                modal.close();
                                _this33.showCreateSuccessModal(res.data.message);
                            });
                        } else {
                            var route = assignData.currentStats === 'route' ? assignData.routeId : null;
                            var user = assignData.currentStats === 'user' ? assignData.userId.toString() : null;

                            return _this33.ServiceOrderService.assignToRouteOrUser(res.data.serviceOrderId, encounterId, user, route, null, branchId, vaultDate, null).then(function () {
                                modal.close();
                                _this33.showCreateSuccessModal(res.data.message);
                            });
                        }
                    } else {
                        modal.close();
                        _this33.showCreateSuccessModal(res.data.message);
                    }
                }).catch(function (err) {
                    _this33.Modal.errorModal(err.data.message);
                }).finally(function () {
                    data.$scope.formSubmited = false;
                });
            }, function (_ref18) {
                var modal = _ref18.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'showCreateSuccessModal',
        value: function showCreateSuccessModal(message) {
            var _this34 = this;

            this.Modal.confirm({
                header: this.$translate.instant('successModal.title'),
                message: message,
                callback: function callback(_ref19) {
                    var modal = _ref19.modal;

                    _this34.$onInit();
                    modal.close();
                },
                negative: function negative(_ref20) {
                    var modal = _ref20.modal;

                    _this34.$onInit();
                    modal.close();
                },
                type: 'success',
                buttons: ['common.ok']
            });
        }

        // Update external service order status

    }, {
        key: 'externalServiceOrderStatusUpdateModal',
        value: function externalServiceOrderStatusUpdateModal(serviceOrder) {
            var _this35 = this;

            if (this.statusUpdate[serviceOrder.encounterId] && this.statusUpdate[serviceOrder.encounterId].process) return;
            this.statusUpdate[serviceOrder.encounterId] = { process: true };

            this.UsersService.checkSupervisor(this.model.loggedInUser).then(function (userInfo) {
                _this35.Modal.serviceOrderStatusUpdate(serviceOrder, !userInfo.supervisor, _this35.customerId, _this35.currentLoggedInUserInfo, function (_ref21) {
                    var modal = _ref21.modal,
                        note = _ref21.note,
                        status = _ref21.status,
                        supervisorId = _ref21.supervisorId;

                    var supId = userInfo.supervisor ? userInfo.id : supervisorId;
                    if (status === 'COMPLETE') {
                        return _this35.externalServiceOrderActionsModal(serviceOrder, note, supId).then(function () {
                            modal.close();
                            _this35.statusUpdate[serviceOrder.encounterId].process = false;
                        });
                    } else {
                        return _this35.updateExternalServiceOrderStatus(serviceOrder, status, note, modal);
                    }
                }, function (_ref22) {
                    var modal = _ref22.modal;

                    if (modal) modal.close();
                    _this35.statusUpdate[serviceOrder.encounterId].process = false;
                });
            }).catch(function (err) {
                _this35.Modal.errorModal(err.data.message);
            });
        }
    }, {
        key: 'updateExternalServiceOrderStatus',
        value: function updateExternalServiceOrderStatus(serviceOrder, status, note, modal) {
            var _this36 = this;

            return this.ServiceOrderService.updateExternalServiceOrderStatus(status, serviceOrder.encounterId, note, serviceOrder.branchId, serviceOrder.serviceOrderId, serviceOrder.externalProcessorId).then(function () {
                _this36.loadData(); // refresh data after status update
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_SERVICEORDERSTATUS_LIFECYCLE_ENDED') {
                        _this36.Modal.errorModal('serviceTickets.lifeCycleEnded');
                    } else {
                        _this36.Modal.errorModal(err.data.message);
                    }
                }
            }).finally(function () {
                if (modal) modal.close();
                _this36.statusUpdate[serviceOrder.encounterId].process = false;
            });
        }
    }, {
        key: 'externalServiceOrderActionsModal',
        value: function externalServiceOrderActionsModal(serviceOrder, serviceOrderStatusNote, userId) {
            var _this37 = this;

            var defer = this.$q.defer();

            this.Modal.serviceOrderActions(serviceOrder, function (_ref23) {
                var modal = _ref23.modal,
                    actionCodeData = _ref23.actionCodeData,
                    $scope = _ref23.$scope,
                    completedByUserId = _ref23.completedByUserId,
                    completedDate = _ref23.completedDate,
                    completedTime = _ref23.completedTime;

                var completedDateTime = completedDate.concat(' ', completedTime);
                var completedAt = moment(completedDateTime).utc().format();
                _this37.ServiceOrderService.markExternalServiceOrderCompleted(actionCodeData, serviceOrder.branchId, serviceOrder.routeId, serviceOrder.serviceOrderId, serviceOrder.encounterId, serviceOrderStatusNote, completedByUserId, completedAt, serviceOrder.externalProcessorId).then(function () {
                    _this37.loadData(); // refresh data after status update
                    modal.close();
                    defer.resolve();
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        if (err.data.message === 'ER_SIGNAL_EXCEPTION: E_SOA_TOO_FEW_RESPONSES') {
                            $scope.model.errorMessage = _this37.$translate.instant('serviceTickets.too_few_responses');
                        } else {
                            $scope.model.errorMessage = err.data.message;
                        }
                    }
                }).finally(function () {
                    $scope.model.isUpdate = false;
                });
            }, function (_ref24) {
                var modal = _ref24.modal;

                if (modal) modal.close();
            });
            return defer.promise;
        }
    }, {
        key: 'serviceTicketResolveImage',
        value: function serviceTicketResolveImage(pictures, encounterId, index) {
            var obj = {
                pictures: pictures, encounterId: encounterId
            };
            document.getElementById('service-ticket-resolve-image-' + index).blur();
            this.Modal.serviceTicketResolveImage(obj, function (_ref25) {
                var modal = _ref25.modal;
            }, function (_ref26) {
                var modal = _ref26.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'viewServiceTicketImages',
        value: function viewServiceTicketImages(orders, event) {
            var _this38 = this;

            if (event && event.currentTarget) {
                event.currentTarget.blur();
            }
            orders.loadingImages = true;
            this.ServiceOrderService.getServiceOrderImages(orders.serviceOrderId).then(function (res) {
                var files = (res.images || []).map(function (imageObj) {
                    return {
                        fileName: imageObj.name,
                        imageUrl: '/api/' + imageObj.url
                    };
                });
                _this38.Modal.previewTicketPictures(files, null, null, null, false);
            }).catch(function (err) {
                console.error('Error fetching service order images:', err);
            }).finally(function () {
                orders.loadingImages = false;
            });
        }
    }, {
        key: 'resendExternalServiceTickets',
        value: function resendExternalServiceTickets(data) {
            var _this39 = this;

            this.externalProcessorObj[data.serviceOrderId] = { process: false };

            this.Modal.confirm({
                header: this.$translate.instant('serviceTickets.resend_external_service_request'),
                message: this.$translate.instant('serviceTickets.resend_external_service_request_message'),
                callback: function callback(_ref27) {
                    var modal = _ref27.modal,
                        $scope = _ref27.$scope;

                    _this39.externalProcessorObj[data.serviceOrderId].process = true;
                    _this39.ServiceOrderService.resendExternalServiceTickets(data.externalProcessorId, data.serviceOrderId, _this39.model.loggedInUser, data.branchId).then(function () {
                        _this39.loadData();
                    }).catch(function (err) {
                        if (err && err.data && err.data.message) {
                            _this39.Modal.errorModal(err.data.message);
                        }
                    }).finally(function () {
                        modal.close();
                        _this39.externalProcessorObj[data.serviceOrderId].process = false;
                    });
                },
                negative: function negative(_ref28) {
                    var modal = _ref28.modal;

                    modal.close();
                },
                type: 'success'
            });
        }
    }, {
        key: 'sortTime',
        value: function sortTime(bucket, column) {
            var _this40 = this;

            this.model.serviceOrderData[bucket].items = this.model.serviceOrderData[bucket].items.sort(function (a, b) {

                var timeToSeconds = function timeToSeconds(time) {
                    if (!time) return NaN;

                    var _time$split$map = time.split(':').map(Number),
                        _time$split$map2 = (0, _slicedToArray3.default)(_time$split$map, 3),
                        hours = _time$split$map2[0],
                        minutes = _time$split$map2[1],
                        seconds = _time$split$map2[2];

                    return hours * 3600 + minutes * 60 + seconds;
                };

                var timeA = timeToSeconds(a[column]);
                var timeB = timeToSeconds(b[column]);

                if (isNaN(timeA) && isNaN(timeB)) return 0;
                if (isNaN(timeA)) return 1;
                if (isNaN(timeB)) return -1;
                return _this40.sortOrderData[bucket][_this40.reverseSort] ? timeB - timeA : timeA - timeB;
            });
        }
    }, {
        key: 'isTimeFormat',
        value: function isTimeFormat(str) {
            var timeRegex = /^([01]?\d|2[0-3]):[0-5]?\d:[0-5]?\d$/;
            return timeRegex.test(str);
        }
    }, {
        key: 'containsTimeKeyword',
        value: function containsTimeKeyword(str) {
            var keywordRegex = /time/i;
            return keywordRegex.test(str);
        }
    }]);
    return ServiceTicketsController;
}();

exports.default = ServiceTicketsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _settings = __webpack_require__(2787);

var _settings2 = _interopRequireDefault(_settings);

var _settings3 = __webpack_require__(2068);

var _settings4 = _interopRequireDefault(_settings3);

__webpack_require__(3065);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var settingsComponent = {
  restrict: 'E',
  bindings: {
    acl: '='
  },
  template: _settings2.default,
  controller: _settings4.default
};

exports.default = settingsComponent;

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsController = function () {
  /*@ngInject*/
  SettingsController.$inject = ["$state", "$timeout", "$rootScope", "$window"];
  function SettingsController($state, $timeout, $rootScope, $window) {
    (0, _classCallCheck3.default)(this, SettingsController);

    this.$timeout = $timeout;
    this.$state = $state;
    this.$rootScope = $rootScope;
    $state.bool = false;
    this.window = $window;
    this.acl = {};
  }

  (0, _createClass3.default)(SettingsController, [{
    key: 'getStateDiff',
    value: function getStateDiff(array) {
      var diff = [];
      var index = 0;
      for (var i = 0; i < array.length; i++) {
        var key = 'setting-' + array[i];
        if (!(key in this.acl)) {
          diff[index++] = array[i];
        }
        // else if(this.acl[key].indexOf('view') < 0){
        //   diff[index++] = array[i]
        // to rescue user without view permission }
      }
      return diff;
    }
  }, {
    key: 'hasAcl',
    value: function hasAcl(key) {
      key = 'setting-' + key;
      if (this.acl[key] && this.acl[key].indexOf('view') >= 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      // let toDeregister = this.getStateDiff(this.$state.get('settings').children)
      // for (let i = 0; i < toDeregister.length; i++) {
      //   if (this.$state.get(toDeregister[i])) {
      //     this.$state.router.stateRegistry.deregister(toDeregister[i])
      //   }
      // }
      var defaultState = void 0;
      for (var key in this.acl) {
        if (this.acl[key].indexOf('view') >= 0) {
          defaultState = key;
          break;
        }
      }
      if (this.$state.current.name == 'settings' && defaultState) {
        if (defaultState === 'setting-preventative-maintenance') {
          this.window.open('/v2/index.html#/preventative-maintenance', '_self');
        } else {
          this.$state.go(defaultState.replace('setting-', ''));
        }
      }
      this.$rootScope.$broadcast('routeChange', null);
    }
  }, {
    key: 'go',
    value: function go(url) {
      this.window.open(url, "_blank");
    }
  }]);
  return SettingsController;
}();

exports.default = SettingsController;

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shipment_batch = __webpack_require__(2073);

var _shipment_batch2 = _interopRequireDefault(_shipment_batch);

var _shipment_record = __webpack_require__(2075);

var _shipment_record2 = _interopRequireDefault(_shipment_record);

var _print = __webpack_require__(2070);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shipmentBatchModule = angular.module('shipmentBatch', [_shipment_record2.default, _print2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/shipmentBatch');

  $stateProvider.state('shipmentBatch', {
    url: '/shipment-batch',
    component: 'shipmentBatch',
    data: {
      requireLogin: true,
      requireACL: 'shipment_batch.all'
    },
    parent: 'app'
  });
}]).component('shipmentBatch', _shipment_batch2.default).name;

exports.default = shipmentBatchModule;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _print_batch = __webpack_require__(2071);

var _print_batch2 = _interopRequireDefault(_print_batch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printBatchModule = angular.module('printBatch', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/shipmentBatch');

    $stateProvider.state('printBatch', {
        url: '/print-batch',
        component: 'printBatch',
        data: {
            requireLogin: true,
            requireACL: 'shipment_batch.all'
        }
    });
}]).component("printBatch", _print_batch2.default).name;

exports.default = printBatchModule;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _print_batch = __webpack_require__(2788);

var _print_batch2 = _interopRequireDefault(_print_batch);

var _print_batch3 = __webpack_require__(2072);

var _print_batch4 = _interopRequireDefault(_print_batch3);

__webpack_require__(3066);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printBatchComponent = {
    restrict: 'E',
    bindings: {},
    template: _print_batch2.default,
    controller: _print_batch4.default
};

exports.default = printBatchComponent;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintBatchController = function () {
    /*@ngInject*/
    PrintBatchController.$inject = ["Auth", "$state", "$translate", "$scope", "User", "ShipmentService"];
    function PrintBatchController(Auth, $state, $translate, $scope, User, ShipmentService) {
        (0, _classCallCheck3.default)(this, PrintBatchController);

        this.$translate = $translate;
        this.$state = $state;
        this.Auth = Auth;
        this.$scope = $scope;
        this.ShipmentService = ShipmentService;
        this.printData = [];
        this.printData = undefined;
        this.tracingIds = [];
        this.model = {
            shipmentDetails: [],
            barcodeOptions: {
                format: 'CODE128', lineColor: '#030303', width: 3, height: 110, displayValue: true,
                font: 'monospace', textAlign: 'center', textPosition: 'bottom', textMargin: 0, fontSize: 25,
                marginTop: 0, marginBottom: 0
            }
        };
        this.printCompletedShipmentData = [];
        this.printCompletedShipmentData = undefined;
        this.currentStat = null;
        // this.pickupDate = "";
        // this.deliveryDate = "";
    }

    (0, _createClass3.default)(PrintBatchController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (window.opener && window.opener.w && window.opener.w.printCompletedShipmentData) {

                this.printCompletedShipmentData = window.opener.w.printCompletedShipmentData;
                this.currentStat = 'completedStat';

                this.batchId = printCompletedShipmentData.batchId;
                this.locationId = printCompletedShipmentData.locationId;

                return this.ShipmentService.printCompletedShipments(this.batchId, this.locationId).then(function (res) {
                    _this.printCompletedShipmentData = res.results;
                    var rowsPerColumn = 30;
                    var columns = Math.ceil(_this.printCompletedShipmentData.length / rowsPerColumn);

                    // Create the column data
                    var columnData = [];
                    for (var i = 0; i < columns; i++) {
                        var startIndex = i * rowsPerColumn;
                        var endIndex = startIndex + rowsPerColumn;
                        columnData.push(_this.printCompletedShipmentData.slice(startIndex, endIndex));
                    }

                    // Use the columnData array in your template
                    _this.model.columnn = columnData;
                    setTimeout(function () {
                        window.print();
                    }, 1500);
                }).catch(function (err) {
                    console.log(err);
                });
            }

            if (window.opener && window.opener.w && window.opener.w.printData) {
                this.printData = window.opener.w.printData;
                this.tracingIds = printData.trackingIds;
                this.currentStat = 'DeliveryManifestStat';

                if (printData.shipmentDetails) {
                    this.currentStat = 'pendingStat';
                    this.model.shipmentDetails = printData.shipmentDetails;

                    var rowsPerColumn = 30;
                    var columns = Math.ceil(this.model.shipmentDetails.length / rowsPerColumn);

                    // Create the column data
                    var columnData = [];
                    for (var i = 0; i < columns; i++) {
                        var startIndex = i * rowsPerColumn;
                        var endIndex = startIndex + rowsPerColumn;
                        columnData.push(this.model.shipmentDetails.slice(startIndex, endIndex));
                    }

                    // Use the columnData array in your template
                    this.model.columnData = columnData;
                }

                // this.pickupDate = printData.pickupDate;
                // this.deliveryDate = printData.deliveryDate;

                return this.ShipmentService.batchRecords(this.tracingIds).then(function (res) {
                    _this.printData = res.results;
                    setTimeout(function () {
                        window.print();
                    }, 1500);
                }).catch(function (err) {
                    console.log(err);
                });
            }
        }
    }]);
    return PrintBatchController;
}();

exports.default = PrintBatchController;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shipment_batch = __webpack_require__(2789);

var _shipment_batch2 = _interopRequireDefault(_shipment_batch);

var _shipment_batch3 = __webpack_require__(2074);

var _shipment_batch4 = _interopRequireDefault(_shipment_batch3);

__webpack_require__(3067);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shipmentBatchComponent = {
  restrict: 'E',
  template: _shipment_batch2.default,
  controller: _shipment_batch4.default
};

exports.default = shipmentBatchComponent;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _keys2 = __webpack_require__(10);

var _keys3 = _interopRequireDefault(_keys2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIMIT = 10;
var MAXLIMIT = 1000;

var ShipmentBatchController = function () {
	/*@ngInject*/
	ShipmentBatchController.$inject = ["Auth", "$state", "User", "BatchService", "DateUtil", "Modal", "$translate", "HolidayService", "CustomerService", "ShipmentService", "$q", "LocationService", "LocationBranchService", "ShiptypeService", "RouteService", "BranchService", "$scope", "SetupService", "$rootScope", "DenominationService", "OrderViewService", "IdStoreService"];
	function ShipmentBatchController(Auth, $state, User, BatchService, DateUtil, Modal, $translate, HolidayService, CustomerService, ShipmentService, $q, LocationService, LocationBranchService, ShiptypeService, RouteService, BranchService, $scope, SetupService, $rootScope, DenominationService, OrderViewService, IdStoreService) {
		var _this = this;

		(0, _classCallCheck3.default)(this, ShipmentBatchController);

		this.isDateChanged = function (currentDate, mode) {
			if (this.model.pickupDate > this.model.deliveryDate) {
				this.model.deliveryDate = this.model.pickupDate;
			} else if (this.model.pickupDate == null) {
				this.model.deliveryDate = null;
			}
			this.deliveryDateOptions = {
				minDate: this.model.pickupDate
			};
		};

		this.sortData = function (column) {
			_this.model.reverseSort = _this.model.sortColumn == column ? !_this.model.reverseSort : true;
			_this.model.sortColumn = column;
			_this.completedShipment();
		};

		this.CustomerService = CustomerService;
		this.BatchService = BatchService;
		this.DateUtil = DateUtil;
		this.ShipmentService = ShipmentService;
		this.Modal = Modal;
		this.$translate = $translate;
		this.$q = $q;
		this.User = User;
		this.LocationService = LocationService;
		this.ShiptypeService = ShiptypeService;
		this.RouteService = RouteService;
		this.BranchService = BranchService;
		this.SetupService = SetupService;
		this.HolidayService = HolidayService;
		this.$scope = $scope;
		this.LocationBranchService = LocationBranchService;
		this.$rootScope = $rootScope;
		this.$state = $state;
		this.DenominationService = DenominationService;
		this.OrderViewService = OrderViewService;
		this.IdStoreService = IdStoreService;
		window.$q = $q;

		this.areShipmentsValid = false;
		this.vaultDate = null;

		this.model = {
			branchId: this.User.getUser().branchId,
			batchMaster: '',
			location: '',
			inputType: '',
			pickupDate: null,
			deliveryDate: null,
			description: '',
			shipments: [],
			selectedFile: '',
			vaultDate: null,
			vaultDates: null,
			orderNo: null,
			duplicateTrackingIds: [],
			bankLocationDDToggle: false,
			amountToggle: false,
			autoGenerateTrackIdToggle: true,
			date: '',
			searchText: null,
			sortColumn: "batchId",
			reverseSort: false,
			coinOnlyBatch: false,
			branches: [{ Value: this.User.getUser().branchId }]
		};

		this.shipment = [];
		this.pagination = {
			page: 1,
			total: 0,
			pageLimit: _app2.default.defaultPageLimit,
			maxPages: 10
		};

		this.bankLocationsObj = {
			offset: 0,
			limit: 1000,
			totalLocationRecords: 0,
			list: [],
			search: '',
			loadMore: this.loadMoreBankDeliverLocations
		};
		this.dateOptions = {
			deliveryDate: {
				minDate: new Date().setDate(new Date().getDate() - 1)
			}
		};
		this.routes = {
			defaultRoute: ''
		};
		this.shipmentData = [];
		this.locations = [];
		this.branches = [];
		this.batchMasters = [];
		this.uploadedFiles = [];
		this.shipTotals = [];
		this.shipmentsData = [];
		this.holidayRoutes = '';
		this.isHoliday = '';
		this.holidayStartDate = '';
		this.holidayEndDate = '';
		this.batchSourceIds;
		this.table = {
			locId: '',
			refId: '',
			currency: '',
			trackingId: '',
			coin1: '',
			coin5: '',
			coin10: '',
			coin25: '',
			coin50: '',
			coin1$: '',
			coinMisc: '',
			defaultBranch: '',
			scanLimit: '',
			routeIds: [],
			locationBranches: [],
			currentCoinNumber: null
		};
		this.minTable = 1;

		this.allowUnitValues = {
			currency: false,
			coin: false,
			misc: false
		};

		this.coinValues = {};

		this.denominationTypeMapping = {
			'PENNY': {
				category: '01',
				categoryName: 'coin1',
				template: null,
				coinFlag: true,
				sortOrder: 1
			},
			'NICKEL': {
				category: '05',
				categoryName: 'coin5',
				template: null,
				coinFlag: true,
				sortOrder: 2
			},
			'DIMES': {
				category: '10',
				categoryName: 'coin10',
				template: null,
				coinFlag: true,
				sortOrder: 3
			},
			'QUARTER': {
				category: '25',
				categoryName: 'coin25',
				template: null,
				coinFlag: true,
				sortOrder: 4
			},
			'HALF_US_DOLLAR': {
				category: '50',
				categoryName: 'coin50',
				template: null,
				coinFlag: true,
				sortOrder: 5
			},
			'ONE_US_DOLLAR': {
				category: '1$',
				categoryName: 'coin1$',
				template: null,
				coinFlag: true,
				sortOrder: 6
			},
			'COIN_MISC': {
				sortOrder: 7
			}
		};

		this.coinTypes = {};
		this.releaseError = [];
		this.storageMode = false;
		this.HOLD_ROUTE = '';
		this.offset = 0;
		this.routeLocations = [];
		this.allRouteLocations = [];
		this.scanLimit = "";
		this.denominationTypeData = [];
		this.$rootScope.$broadcast('routeChange', '/app/shipment-batch');
		self = this;

		this.stats = {
			deliveryShipment: 'deliveryShipment',
			atmLoads: 'atmLoads',
			completedShipment: 'completedShipment'
		};
		this.currentStats = this.stats.deliveryShipment;
		this.atmLoadModel = {
			atmLoadShipment: []
		};
		this.loggedInUserId = this.User.getUser().id;
		this.deletedTrackingId = [];
	}

	(0, _createClass3.default)(ShipmentBatchController, [{
		key: 'commitDisabled',


		//disabled commit button when total or trackingID null or zero
		value: function commitDisabled() {
			var _this2 = this;

			var disableButton = this.model.shipments.map(function (cr) {
				cr.refId = cr.refIdObj && !cr.refId ? cr.refIdObj.Value : cr.refId;
				var hasAmountErrors = cr.amountErrors && (0, _keys3.default)(cr.amountErrors).length > 0;

				if (_this2.model.coinOnlyBatch) {
					return cr.total > 0 && cr.refId && !hasAmountErrors || 'isEmpty';
				}

				return cr.total >= 0 && cr.trackingId && cr.refId && !hasAmountErrors && !(cr.checkScanLimit && cr.trackingId.length > cr.scanLimit) || 'isEmpty';
			}).indexOf('isEmpty') !== -1;

			return disableButton;
		}

		// fromLocationChanged() {
		// 	const selectedBatchType = this.batchMasters.find((batchMaster) => {
		// 		return batchMaster.batchSourceId === $scope.model.location.id;
		// 	});

		// 	if (this.model.batchMaster !== selectedBatchType.inputType) {
		// 		this.model.batchMaster = selectedBatchType.inputType;
		// 	}
		// }

	}, {
		key: 'performReset',
		value: function performReset() {
			var _this3 = this;

			this.Modal.confirm({
				header: this.$translate.instant('common.reset'),
				message: this.$translate.instant('shipmentBatch.resetData'),
				callback: function callback(_ref) {
					var modal = _ref.modal;

					_this3.resetData();
					modal.close();
				},
				type: 'danger'
			});
		}
	}, {
		key: 'resetData',
		value: function resetData() {
			var _this4 = this;

			var storageKey = this.getLocalStorageKey();
			var coinOnlyBatch = !!this.model.coinOnlyBatch;
			this.storageMode = coinOnlyBatch;

			if (this.model.selectedFile) {
				this.RouteService.unlockFile(this.model.selectedFile).then(function () {
					return _this4.RouteService.getUploadedFiles();
				}).then(function (data) {
					_this4.uploadedFiles = data.results;
				});
			}

			this.model = {
				branchId: this.User.getUser().branchId,
				batchMaster: '',
				customer: '',
				inputType: '',
				pickupDate: moment(this.vaultDate).add(1, 'second').toDate(),
				deliveryDate: moment(this.vaultDate).add(1, 'day').toDate(),
				description: '',
				shipments: [],
				selectedFile: '',
				duplicateTrackingIds: [],
				bankLocationDDToggle: false,
				amountToggle: false,
				coinOnlyBatch: coinOnlyBatch,
				autoGenerateTrackIdToggle: true,
				branches: [{ Value: this.User.getUser().branchId }]
				// trackingId: this.model.autoGenerateTrackIdToggle === false ? null:this.currentNumber
			};
			this.bankLocationsObj = {
				offset: 0,
				limit: 1000,
				totalLocationRecords: 0,
				list: [],
				search: '',
				loadMore: this.loadMoreBankDeliverLocations
			};
			localStorage.removeItem(storageKey);
			this.isRoutesSet = false;
			this.getAllBranchesList('', 0);
			this.areShipmentsValid = false;
			this.currentStats = this.stats.deliveryShipment;
			this.deletedTrackingId = [];
			for (var i = 0; i < this.minTable; i++) {
				this.add();
				if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
					this.getPreviewId().then(function () {
						for (var _i = 0; _i < _this4.model.shipments.length; _i++) {
							var data = _this4.model.shipments[_i];
							data.trackingId = _this4.setupData.trackingIdPrefix + _this4.currentNumberArray[_i];
						}
					});
				} else if (this.model.coinOnlyBatch) {
					this.IdStoreService.getPreviewNextId('COINONLYBATCH', this.model.shipments.length + 1).then(function (data) {
						_this4.model.shipments.forEach(function (shipment, index) {
							shipment.trackingId = (data.start + index).toString();
						});
						_this4.model.currentCoinNumber = (data.start + _this4.model.shipments.length).toString();
					});
				}
			}
			this.branchChanged();
			this.fromLocationChanged();
			this.isRoutesSet = false;
		}

		// load locationType == INTERNAL, BANK data based on BranchID With Search value

	}, {
		key: 'loadLocationData',
		value: function loadLocationData() {
			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: '=',
						data: this.model.branches.map(function (ele) {
							return ele.Value;
						})
						// data: this.model.branchId
					}, {
						group: {
							rules: [{
								field: 'locationType',
								condition: '=',
								data: 'INTERNAL'
							}, {
								group: {
									rules: [{
										field: 'locationType',
										condition: '=',
										data: 'BANK'
									}, {
										field: 'centralBank',
										condition: '=',
										data: true
									}],
									operator: 'AND'
								}
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};
			return searchObj ? searchObj : null;
		}

		// load locationType == INTERNAL, BANK data based on BranchID With Search value

	}, {
		key: 'loadLocationDataWithSearch',
		value: function loadLocationDataWithSearch(searchKey) {
			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: '=',
						// data: this.model.branchId
						data: this.model.branches.map(function (ele) {
							return ele.Value;
						})
					}, {
						group: {
							rules: [{
								field: 'locationType',
								condition: '=',
								data: 'INTERNAL'
							}, {
								group: {
									rules: [{
										field: 'locationType',
										condition: '=',
										data: 'BANK'
									}, {
										field: 'centralBank',
										condition: '=',
										data: true
									}],
									operator: 'AND'
								}
							}],
							operator: 'OR'
						}
					}, {
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "name",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: 'AND'
				}
			};
			return searchObj.queryJSON.rules.length ? searchObj : null;
		}
	}, {
		key: '$onInit',
		value: function $onInit(reset) {
			var _this5 = this;

			//
			this.loading = true;
			var batchSearchObj = {
				branchId: this.model.branchId,
				queryText: '%%'
			};

			this.data = JSON.parse(localStorage.getItem(this.getLocalStorageKey()));

			var searchObj = this.model.branchId ? {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: '=',
						data: this.model.branchId
					}],
					operator: 'AND'
				}
			} : null;

			var denomSearchObj = {
				queryJSON: {
					rules: [{
						field: 'currencyId',
						condition: '=',
						data: 'USD'
					}],
					operator: 'AND'
				}
			};

			this.$q.all([this.BatchService.all(batchSearchObj, 0, MAXLIMIT), this.ShiptypeService.all(null, 0, MAXLIMIT), this.RouteService.getUploadedFiles(), this.BranchService.getBranchSetup(this.data && this.data.model.location ? this.data.model.location.branchId : this.model.branchId), this.SetupService.get(this.data && this.data.model.location ? this.data.model.location.branchId : this.model.branchId), this.HolidayService.getGrouped(searchObj, 0, MAXLIMIT), this.DenominationService.all(denomSearchObj, 0, 1000), this.OrderViewService.generateOrderNumber()]).then(function (data) {
				_this5.shiptypeList = data[1].results;
				_this5.batchSourceIds = data[0].results.filter(function (batch) {
					return !!batch.batchSourceId;
				}).map(function (batch) {
					return batch.batchSourceId;
				});

				_this5.locations = _this5.mappingLocationDatas(data[0].results.map(function (res) {
					return res.batchSource;
				})).filter(function (location) {
					return _this5.batchSourceIds.includes(location.id) && location.centralBank;
				});
				// this.totalLocationRecords = data[0].total;

				// this.locations = this.mappingLocationDatas(data[0].results).filter((location) => this.batchSourceIds.includes(location.id));
				_this5.shiptypeList.forEach(function (s) {
					if (_this5.denominationTypeMapping[s.denominationType]) {
						_this5.coinTypes = (0, _assign2.default)(_this5.coinTypes, (0, _defineProperty3.default)({}, s.denominationType, {
							denomList: [],
							isOpen: false,
							template: 'coin-selection.html',
							selected: null,
							category: null,
							categoryName: null
						}));
					}
				});

				_this5.shiptypeList.forEach(function (s) {
					if (_this5.denominationTypeMapping[s.denominationType]) {
						_this5.coinTypes[s.denominationType].denomList.push({
							icon: s.id
						});
						_this5.coinTypes[s.denominationType].coinFlag = true;
						_this5.coinTypes[s.denominationType].category = _this5.denominationTypeMapping[s.denominationType].category;
						_this5.coinTypes[s.denominationType].categoryName = _this5.denominationTypeMapping[s.denominationType].categoryName;
						_this5.coinTypes[s.denominationType].selected = _this5.coinTypes[s.denominationType].denomList[0].icon;
						_this5.coinTypes[s.denominationType].sortOrder = _this5.denominationTypeMapping[s.denominationType].sortOrder;
					}
				});

				(0, _keys3.default)(_this5.coinTypes).map(function (key) {
					_this5.denominationTypeData.push({
						group: key,
						sortOrder: _this5.coinTypes[key].sortOrder
					});
				});
				_this5.denominationTypeData = _lodash2.default.orderBy(_this5.denominationTypeData, ['sortOrder'], ['ASC']);

				_this5.batchMasters = data[0].results;
				_this5.coinValues = {};

				if (_this5.shiptypeList) {
					_this5.shiptypeList.map(function (shiptype) {
						_this5.coinValues[shiptype.id] = {
							amountFlag: shiptype.amountFlag,
							unitValue: shiptype.unitValue,
							amount: shiptype.amount
						};
					});
				}

				_this5.uploadedFiles = data[2].results;

				_this5.HOLD_ROUTE = data[3].holdRouteId;

				_this5.holidayRoutes = data[4].useHolidayRoutes;

				_this5.isHoliday = data[5].results;
				_this5.vaultDate = _this5.DateUtil.convertToDate(data[4].currentVaultDate);
				_this5.scanLimit = data[4].packCharLength;
				_this5.atmLoadModel.denominations = data[6].results.filter(function (d) {
					return d.shiptypeId == 'C';
				});
				_this5.atmLoadModel.nextOrderNumber = data[7].nextOrderNumber;

				_this5.setupData = data[4];
				_this5.autoGenerateToggle = _this5.setupData.autoGenerateTrackingId;
				setTimeout(function () {
					if (_this5.model.autoGenerateTrackIdToggle === true && _this5.autoGenerateToggle && !_this5.model.coinOnlyBatch) {
						_this5.getPreviewId().then(function () {
							for (var i = 0; i < _this5.model.shipments.length; i++) {
								var _data = _this5.model.shipments[i];
								_data.trackingId = _this5.setupData.trackingIdPrefix + _this5.currentNumberArray[i];
							}
						});
					}
					if (!_this5.autoGenerateToggle) {
						_this5.model.shipments.forEach(function (data) {
							_this5.trackingId = data.trackingId;
						});
					}
					_this5.$scope.$apply();
				});
				_this5.getAllLocation('', 0);
				_this5.getAllBranchesList('', 0);
			}).catch(function (err) {
				_this5.error = err.message;
			}).finally(function () {
				// Initial loading
				_this5.loading = false;

				if (localStorage.getItem(_this5.getLocalStorageKey()) === null) {
					_this5.storageMode = !!_this5.model.coinOnlyBatch;
					_this5.resetData();
				} else {
					try {
						var storedData = JSON.parse(localStorage.getItem(_this5.getLocalStorageKey()));
						if (!storedData || !storedData.model) {
							_this5.resetData();
						} else {
							_this5.storageMode = !!storedData.model.coinOnlyBatch;
							_this5.model = (0, _extends3.default)({}, storedData.model, {
								coinOnlyBatch: !!storedData.model.coinOnlyBatch
							});
							_this5.isRoutesSet = !!storedData.isRoutesSet;
							if (storedData.coinTypes) {
								_this5.coinTypes = storedData.coinTypes;
							}
							_this5.normalizeShipmentsForMode(_this5.storageMode);
							_this5.bankLocationToggleChange();
						}
					} catch (error) {
						console.error('Error parsing local storage:', error);
						_this5.resetData();
					}
				}

				// Handle shipments
				if (_this5.model.shipments && Array.isArray(_this5.model.shipments)) {
					_this5.model.shipments.forEach(function (data) {
						_this5.trackingId = data.trackingId;
						_this5.locId = data.locId;
						_this5.refId = data.refId;
						_this5.total = data.total;
						_this5.shipmentsData = data;
						data.scanLimit = _this5.scanLimit;
						data.checkScanLimit = _this5.scanLimit > 0;
					});
				}

				// Set dates if no shipment data exists
				if (!_this5.trackingId && !_this5.locId && !_this5.refId && !_this5.total) {
					_this5.model.pickupDate = moment(_this5.vaultDate).add(1, 'second').toDate();
					_this5.model.deliveryDate = moment(_this5.vaultDate).add(1, 'days').toDate();
				}

				_this5.vltDate = moment(_this5.vaultDate).add(1, 'second').toDate();

				_this5.pickupDateOptions = {
					minDate: _this5.vltDate
				};

				_this5.deliveryDateOptions = {
					minDate: _this5.model.pickupDate
				};

				// Watch for changes and update localStorage
				_this5.$scope.$watch(function () {
					var obj = {
						model: (0, _extends3.default)({}, _this5.model, {
							coinOnlyBatch: _this5.storageMode
						}),
						isRoutesSet: _this5.isRoutesSet,
						coinTypes: _this5.coinTypes
					};

					return (0, _stringify2.default)(obj, null, 1);
				}, function (newVal, oldVal) {
					if (newVal && newVal !== oldVal) {
						_this5.persistToLocalStorage(_this5.storageMode);
					}
				});
			});

			this.obj = JSON.parse(localStorage.getItem(this.getLocalStorageKey()));
		}
	}, {
		key: 'mappingLocationDatas',
		value: function mappingLocationDatas(locations) {
			return locations.map(function (location) {
				return _lodash2.default.merge({
					Key: location.id + " | " + location.name,
					Value: location.id
				}, location);
			});
		}
	}, {
		key: 'mappingBranches',
		value: function mappingBranches(branches) {
			return branches.map(function (branch) {
				return _lodash2.default.merge({
					Key: branch.id,
					Value: branch.id
				}, branch);
			});
		}
	}, {
		key: 'batchMasterChanged',
		value: function batchMasterChanged() {
			var _this6 = this;

			if (!this.model.batchMaster) {
				return;
			}

			var selectedBatchMaster = this.model.batchMaster;
			var setCoins = function setCoins(coinTypes, version) {
				if (!coinTypes || !coinTypes.length || !version) {
					return;
				}

				coinTypes.forEach(function (key) {
					var coinType = _this6.coinTypes[key];
					if (coinType.category) {
						coinType.selected = coinType.selected.substr(0, coinType.selected.length - 1) + version;
					}
				});
			};

			switch (selectedBatchMaster[1]) {
				case 'L':
					{
						var keys = (0, _keys3.default)(this.coinTypes);
						setCoins(keys, 'L');
						break;
					}
				case 'H':
					{
						var coinHKeys = ['coin10'];
						setCoins(coinHKeys, 'H');

						break;
					}
				default:
					{
						var _keys = (0, _keys3.default)(this.coinTypes);
						setCoins(_keys, 'B');
						break;
					}
			}

			this.allowUnitValues = {
				currency: selectedBatchMaster[0] === 'U',
				coin: selectedBatchMaster[1] === 'U',
				misc: selectedBatchMaster[2] === 'U'
			};
		}
	}, {
		key: 'onAmountToggleChange',
		value: function onAmountToggleChange() {
			this.model.shipments.forEach(function (shipment) {
				shipment.amountErrors = {};
			});
		}
	}, {
		key: 'getLocalStorageKey',
		value: function getLocalStorageKey() {
			var prefix = this.model && this.model.coinOnlyBatch ? 'shipment-batch-coin-' : 'shipment-batch-cash-';
			return prefix + this.User.getUser().branchId;
		}
	}, {
		key: 'getLocalStorageKeyByMode',
		value: function getLocalStorageKeyByMode(coinOnlyBatch) {
			var prefix = coinOnlyBatch ? 'shipment-batch-coin-' : 'shipment-batch-cash-';
			return prefix + this.User.getUser().branchId;
		}
	}, {
		key: 'persistToLocalStorage',
		value: function persistToLocalStorage() {
			var coinOnlyBatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.storageMode;

			try {
				var obj = {
					model: (0, _extends3.default)({}, this.model, {
						branchId: this.User.getUser().branchId,
						coinOnlyBatch: coinOnlyBatch
					}),
					isRoutesSet: this.isRoutesSet,
					coinTypes: this.coinTypes
				};
				localStorage.setItem(this.getLocalStorageKeyByMode(coinOnlyBatch), (0, _stringify2.default)(obj));
			} catch (error) {
				console.error('Error updating localStorage:', error);
			}
		}
	}, {
		key: 'refreshCoinOnlyTrackingIds',
		value: function refreshCoinOnlyTrackingIds() {
			var _this7 = this;

			return this.IdStoreService.getPreviewNextId('COINONLYBATCH', this.model.shipments.length + 1).then(function (data) {
				_this7.model.shipments.forEach(function (shipment, index) {
					shipment.trackingId = (data.start + index).toString();
				});
				_this7.model.currentCoinNumber = (data.start + _this7.model.shipments.length).toString();
			});
		}
	}, {
		key: 'normalizeShipmentsForMode',
		value: function normalizeShipmentsForMode() {
			var _this8 = this;

			var coinOnlyBatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.model && this.model.coinOnlyBatch;

			if (!this.model || !Array.isArray(this.model.shipments)) {
				return;
			}

			this.model.shipments.forEach(function (shipment, index) {
				if (coinOnlyBatch) {
					shipment.total = _this8.getCoinSum(shipment);
					shipment.currency = 0;
					return;
				}

				shipment.currency = _this8.getCurrency(index);
			});
		}
	}, {
		key: 'getCoinSum',
		value: function getCoinSum(s) {
			var _this9 = this;

			var coinsTotal = 0;
			var coinKeys = (0, _keys3.default)(this.coinTypes);
			coinKeys.forEach(function (coinKey) {
				if (!_this9.coinTypes[coinKey]) return;
				var coinType = _this9.coinTypes[coinKey].selected;
				var categoryName = _this9.coinTypes[coinKey].categoryName;
				if (s[categoryName]) {
					coinsTotal += s[categoryName] * _this9.getCoinValue(coinType);
				}
			});
			return coinsTotal;
		}
	}, {
		key: 'onCoinOnlyBatchToggle',
		value: function onCoinOnlyBatchToggle() {
			var _this10 = this;

			var selectedMode = !!this.model.coinOnlyBatch;
			var previousMode = this.storageMode;
			var newKey = this.getLocalStorageKeyByMode(selectedMode);

			this.persistToLocalStorage(previousMode);
			var storedData = JSON.parse(localStorage.getItem(newKey));

			if (storedData && storedData.model) {
				this.storageMode = selectedMode;
				this.model = (0, _extends3.default)({}, storedData.model, {
					coinOnlyBatch: selectedMode
				});
				this.isRoutesSet = !!storedData.isRoutesSet;
				if (storedData.coinTypes) {
					this.coinTypes = storedData.coinTypes;
				}
				this.normalizeShipmentsForMode(selectedMode);
				if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
					this.autoGenerateTrackingToggleChange();
				}
			} else {
				this.storageMode = selectedMode;
				this.model.shipments = [];
				this.isRoutesSet = false;
				this.add();

				if (this.model.coinOnlyBatch) {
					this.IdStoreService.getPreviewNextId('COINONLYBATCH', this.model.shipments.length + 1).then(function (data) {
						_this10.model.shipments.forEach(function (s, i) {
							s.trackingId = (data.start + i).toString();
						});
						_this10.model.currentCoinNumber = data.end.toString();
						_this10.normalizeShipmentsForMode(true);
					});
				} else {
					this.autoGenerateTrackingToggleChange();
					this.normalizeShipmentsForMode(false);
				}
			}
		}
	}, {
		key: 'confirmRemove',
		value: function confirmRemove(index) {
			var _this11 = this;

			if (this.model.shipments.length === 1) {
				return this.Modal.alert({
					type: 'danger',
					header: this.$translate.instant('shipmentBatch.alertModalTitle'),
					message: this.$translate.instant('shipmentBatch.alertModalMessage'),
					callback: function callback(_ref2) {
						var modal = _ref2.modal;
						modal.close();
					}
				});
			}

			this.Modal.confirm({
				header: this.$translate.instant('common.confirm_delete_title'),
				message: this.$translate.instant('shipmentBatch.delete_message'),
				callback: function callback(_ref3) {
					var modal = _ref3.modal,
					    $scope = _ref3.$scope;

					_this11.remove(index);
					modal.close();
				},
				type: 'danger'
			});
		}
	}, {
		key: 'deliveryDateChanged',
		value: function deliveryDateChanged() {
			this.isRoutesSet = false;

			this.model.shipments.forEach(function (shipment) {
				shipment.routeIds = [];
				shipment.routeId = null;
			});
		}
	}, {
		key: 'pickupDateChanged',
		value: function pickupDateChanged() {
			if (this.model.pickupDate > this.model.deliveryDate) {
				this.model.deliveryDate = moment(this.model.pickupDate).add(1, 'days').toDate();
			}
		}
	}, {
		key: 'add',
		value: function add() {
			var newShipment = angular.copy(this.table);
			this.isRoutesSet = false;
			newShipment.routeIds = [];
			newShipment.scanLimit = '';
			newShipment.checkScanLimit = '';
			// newShipment.total = 0;

			if (this.routes.defaultRoute) {
				newShipment.routeIds.push(this.routes.defaultRoute);
			}

			if (this.HOLD_ROUTE) {
				newShipment.routeIds.push('HOLD');
			}
			newShipment.routeId = newShipment.routeIds[0];
			newShipment.scanLimit = this.scanLimit;
			newShipment.checkScanLimit = newShipment.scanLimit > 0;

			if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
				newShipment.trackingId = this.setupData.trackingIdPrefix + this.currentNumber; //this.incrementNumber
			} else if (this.model.coinOnlyBatch && this.model.currentCoinNumber) {
				newShipment.trackingId = this.model.currentCoinNumber;
			} else {
				newShipment.trackingId = null;
			}

			this.model.shipments.push(newShipment);
			setTimeout(function () {
				var locationInput = document.querySelectorAll('#showBankLocationDdInp');

				if (locationInput && locationInput[locationInput.length - 1]) {
					locationInput[locationInput.length - 1].focus();
				}
				locationInput[locationInput.length - 1].focus();
			}, 100);
		}
	}, {
		key: 'addOnTab',
		value: function addOnTab(index) {
			var _this12 = this;

			if (index === this.model.shipments.length - 1) {
				if (!this.model.bankLocationDDToggle && this.model.shipments[index].refId) {
					var parts = this.model.shipments[index].refId.split(' | ');
					this.fetchLocationDetails(parts[0]).then(function (data) {
						if (!data.results) return;
						_this12.model.shipments[index].refIdObj = (0, _extends3.default)({}, data.results, {
							Key: 'None',
							Value: 'None',
							parentLocation: _this12.model.location
						});
					});
				}
				if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
					if (this.deletedTrackingId && this.deletedTrackingId.length) {
						this.getPreviewId().then(function () {
							return _this12.add();
						});
					} else if (this.model.cursor == 0 || this.model.cursor) {
						this.getAutoGeneratedTrackingId(this.model.cursor++).then(function () {
							return _this12.add();
						});
					} else {
						this.getAutoGeneratedTrackingId(this.model.shipments.length).then(function () {
							return _this12.add();
						});
					}
				} else if (this.model.coinOnlyBatch) {
					this.getAutoGeneratedCoinId(this.model.shipments.length).then(function () {
						return _this12.add();
					});
				} else {
					this.add();
				}
			}
			setTimeout(function () {
				var locationInput = document.querySelectorAll('#showBankLocationDdInp');

				if (locationInput && locationInput[index + 1]) {
					locationInput[index + 1].focus();
				}
				locationInput[locationInput.length - 1].focus();
			}, 100);
		}
	}, {
		key: 'addOnButton',
		value: function addOnButton() {
			var _this13 = this;

			if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
				if (this.deletedTrackingId && this.deletedTrackingId.length) {
					this.getPreviewId().then(function () {
						return _this13.add();
					});
				} else if (this.model.cursor == 0 || this.model.cursor) {
					this.getAutoGeneratedTrackingId(this.model.cursor++).then(function () {
						return _this13.add();
					});
				} else {
					this.getAutoGeneratedTrackingId(this.model.shipments.length).then(function () {
						return _this13.add();
					});
				}
			} else if (this.model.coinOnlyBatch) {
				this.getAutoGeneratedCoinId(this.model.shipments.length).then(function () {
					return _this13.add();
				});
			} else {
				this.add();
			}
		}
	}, {
		key: 'remove',
		value: function remove(index) {
			this.deletedTrackingId.push(this.model.shipments[index].trackingId);
			this.model.shipments.splice(index, 1);
		}
	}, {
		key: 'getCoinValue',
		value: function getCoinValue(coinType) {
			var batchMasterCharIndex = -1;

			if (coinType === 'total') {
				return 1;
			}

			if (coinType === 'coinMisc') {
				batchMasterCharIndex = 2;
			} else {
				batchMasterCharIndex = 1;
			}

			return this.coinValues[coinType].amountFlag && this.coinValues[coinType].amount > 0 ? this.coinValues[coinType].amount : this.coinValues[coinType].unitValue;
		}
	}, {
		key: 'getCurrency',
		value: function getCurrency(index) {
			var _this14 = this;

			var coinsTotal = 0;
			var coinKeys = (0, _keys3.default)(this.coinTypes);
			coinKeys.forEach(function (coinKey) {
				if (!_this14.coinTypes[coinKey]) return;
				var coinType = _this14.coinTypes[coinKey].selected;
				var categoryName = _this14.coinTypes[coinKey].categoryName;
				if (_this14.model.shipments[index][categoryName]) {
					coinsTotal += _this14.model.shipments[index][categoryName] * _this14.getCoinValue(coinType);
				}
			});

			return this.model.shipments[index].total ? this.model.shipments[index].total - coinsTotal : -coinsTotal;
		}
	}, {
		key: 'getTotalByName',
		value: function getTotalByName(coinKey) {
			var _this15 = this;

			var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			var total = 0;
			this.model.shipments.forEach(function (shipmentBatchRecord) {
				if (shipmentBatchRecord[coinKey]) {
					if (coinKey === 'total') {
						total += shipmentBatchRecord[coinKey];
					} else {
						var coinType = _this15.coinTypes[type].selected;
						total += shipmentBatchRecord[coinKey] * (coinKey === 'total' ? 1 : _this15.getCoinValue(coinType));
					}
				}
			});

			return total;
		}
	}, {
		key: 'getCurrencyTotal',
		value: function getCurrencyTotal() {
			var _this16 = this;

			var total = 0;
			this.areShipmentsValid = true;

			this.model.shipments.forEach(function (shipmentBatchRecord, index) {
				var currency = _this16.getCurrency(index);

				if (currency < 0) {
					_this16.areShipmentsValid = false;
				}

				total += currency;
			});

			return total;
		}
	}, {
		key: 'getLocation',
		value: function getLocation(refId) {
			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'refNumber',
						condition: '=',
						data: refId
					}, {
						field: 'id',
						condition: '=',
						data: refId
					}, {
						field: 'idBatchImport',
						condition: '=',
						data: refId
					}],
					operator: 'OR'
				}
			};

			//fetch location which has refNumber equal to refId
			return this.LocationService.all(searchObj, 0, 1);
		}
	}, {
		key: 'loadRoutes',
		value: function loadRoutes() {
			var _this17 = this;

			var routeSearchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: '=',
						data: this.model.location.branchId
						// data: this.model.branchId
					}],
					operator: 'AND'
				}
			};

			return this.RouteService.all(routeSearchObj, 0, MAXLIMIT).then(function (data) {
				_this17.model.holdRouteId = null;
				_this17.routes = data.results;
			}).catch(function (error) {
				console.log(error);
			});
		}
	}, {
		key: 'getlocationBranches',
		value: function getlocationBranches(locationId) {
			var locationSearchObj = {
				queryJSON: {
					rules: [{
						field: 'locationId',
						condition: '=',
						data: locationId
					}],
					operator: 'AND'
				}
			};

			return this.LocationBranchService.all(locationSearchObj, 0, 100);
		}
	}, {
		key: 'setRoutes',
		value: function setRoutes(indexesToCheck) {
			var _this18 = this;

			var INDEX_NOT_MENTIONED = 'index not mentioned';
			this.errorCheck = 0;
			this.errorCount = 0;
			this.errorNotFound = 0;
			this.errorNotFoundCount = 0;
			var day = moment(this.model.deliveryDate).day();

			var weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

			var routeIdField = 'defRoute' + weekDays[day] + 'Id';
			var routeField = 'defRoute' + weekDays[day];
			var holidayRouteId = 'defRouteHolId';
			var HolidayRoutes = 'defRouteHol';

			this.model.vaultDates = moment(this.vaultDate).day();

			// check for Holidays
			this.isHoliday.forEach(function (holidays) {
				_this18.holidayStartDate = moment(holidays.holidayDate).day();
				_this18.holidayEndDate = moment(holidays.holidayEnd).day();
			});

			// check if holidayToggle true or false
			var useHolidays = this.holidayRoutes;

			// check for routeId associate with different branch OR not && also check for Holiday Routes
			if (this.model.vaultDates == day && this.model.vaultDates == this.holidayStartDate && this.model.location[HolidayRoutes] !== null && this.model.location[HolidayRoutes].branchId === this.model.branchId && useHolidays == true) {
				this.routes.defaultRoute = this.model.location[holidayRouteId];
			} else if (day == this.holidayEndDate && this.holidayEndDate == this.model.vaultDates && this.model.location[HolidayRoutes] !== null && this.model.location[HolidayRoutes].branchId === this.model.branchId && useHolidays == true) {
				this.routes.defaultRoute = this.model.location[holidayRouteId];
			} else if (this.model.location[routeField] !== null && this.model.location[routeField].branchId === this.model.branchId) {
				this.routes.defaultRoute = this.model.location[routeIdField];
			} else {
				this.routes.defaultRoute = 'HOLD';
			}

			// this.routes.defaultRoute = this.model.location[routeIdField];

			return this.$q.all(this.model.shipments.map(function (shipment, index) {
				if (indexesToCheck && indexesToCheck.length && !indexesToCheck.includes(index)) {
					return _this18.$q.when(INDEX_NOT_MENTIONED);
				}

				if (shipment.location) {
					return _this18.$q.when(shipment.location);
				}

				if (shipment.refId && shipment.trackingId && shipment.total > 0) {
					return _this18.$q.all([_this18.getLocation(shipment.refId), _this18.getlocationBranches(shipment.refId)]).then(function (data) {
						_this18.shipmentData = data[0].results;
						_this18.multiBranches = _this18.shiptypeList.map(function (data) {
							return data.branchId;
						});
						shipment.locationBranches = _this18.multiBranches;
						if (_this18.shipmentData.length) {
							_this18.shipmentData.forEach(function (data) {
								shipment.defaultBranch = data.branchId;
								shipment.isFromOtherBranch = true;
								_this18.isTrue = shipment.locationBranches.includes(_this18.model.location.branchId);
								// this.isTrue = shipment.locationBranches.includes(this.model.branchId);
								if (!_this18.isTrue) {
									_this18.shipmentData = null;
									_this18.errorCheck++;
								}
								if (_this18.errorCheck >= 1 && _this18.errorCount == 0) {
									_this18.errorCount = 1;
									return _this18.Modal.errorModal("error." + 90222);
								}
							});
						} else {
							shipment.isFromOtherBranch = false;
							_this18.shipmentData = null;
							_this18.errorNotFound++;
							if (_this18.errorNotFound >= 1 && _this18.errorNotFoundCount == 0) {
								_this18.errorNotFoundCount = 1;
								_this18.Modal.errorModal("location.noLocations");
							}
						}
						shipment.location = _this18.shipmentData ? _this18.shipmentData[0] : null;
						return shipment.location;
					});
				}
			})).then(function (locations) {
				return locations.map(function (fetchedLocation) {

					_this18.fetchedLocations = fetchedLocation;

					if (fetchedLocation === null || fetchedLocation === INDEX_NOT_MENTIONED) {
						return fetchedLocation;
					}
					// check for routeId associate with different branch OR not && also check for Holiday
					if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null && _this18.model.vaultDates == _this18.holidayStartDate && fetchedLocation[HolidayRoutes].branchId === _this18.model.branchId && _this18.model.vaultDates == day && useHolidays == true) {
						return fetchedLocation[holidayRouteId];
					} else if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null && day == _this18.holidayEndDate && _this18.holidayEndDate == _this18.model.vaultDates && fetchedLocation[HolidayRoutes].branchId === _this18.model.branchId && useHolidays == true) {
						return fetchedLocation[holidayRouteId];
					} else if (fetchedLocation != null && fetchedLocation[routeField] !== null && fetchedLocation[routeField].branchId === _this18.model.branchId) {
						return fetchedLocation[routeIdField];
					}
				});
			}).then(function (routeIds) {
				_this18.model.shipments.forEach(function (shipmentBatchRecord, index) {
					if (routeIds[index] === INDEX_NOT_MENTIONED) {
						return;
					}

					var shipmentRoute = routeIds[index];

					shipmentBatchRecord.routeIds = [];

					if (_this18.routes.defaultRoute) {
						shipmentBatchRecord.routeIds.push(_this18.routes.defaultRoute);
						shipmentBatchRecord.routeId = _this18.routes.defaultRoute;
					}

					if (_this18.HOLD_ROUTE || _this18.fetchedLocations != null && _this18.fetchedLocations[routeField] !== null && _this18.fetchedLocations[routeField].branchId !== _this18.model.branchId) {
						shipmentBatchRecord.routeIds.push('HOLD');
						shipmentBatchRecord.routeId = 'HOLD';
					}
					if (shipmentRoute) {
						shipmentBatchRecord.routeIds.push(shipmentRoute);
						shipmentBatchRecord.routeId = shipmentRoute;
					}

					//remove dupes
					shipmentBatchRecord.routeIds = shipmentBatchRecord.routeIds.filter(function (routeId, index, array) {
						return array.indexOf(routeId) === index;
					});
				});
			}).catch(function (err) {
				console.error(err);
			}).finally(function () {
				_this18.isRoutesSet = _this18.model.shipments.every(function (shipmentRecord) {
					return !!shipmentRecord.location;
				});
			});
		}
	}, {
		key: 'checkHoldAndCallSupervisor',
		value: function checkHoldAndCallSupervisor(shipments) {
			var defer = this.$q.defer();

			var needSupervisor = false;
			shipments.forEach(function (s) {
				if (s.routeId === 'HOLD') {
					needSupervisor = true;
				}
			});

			if (needSupervisor) {
				this.Modal.confirmSupervisor('put-on-hold', null, function (_ref4) {
					var modal = _ref4.modal,
					    supId = _ref4.supId;

					modal.close();
					defer.resolve({ needSupervisor: needSupervisor, supId: supId });
				}, function (_ref5) {
					var modal = _ref5.modal;

					modal.close();
					defer.reject({ needSupervisor: needSupervisor });
				});
			} else {
				defer.resolve({ needSupervisor: needSupervisor });
			}

			return defer.promise;
		}
	}, {
		key: 'commit',
		value: function commit() {
			var _this19 = this;

			var shipments = [];
			var currentDate = moment();
			var areAllShipmentsValid = this.model.shipments.every(function (shipmentRecord) {
				return !!shipmentRecord.location;
			});
			this.releaseError = [];
			this.model.duplicateTrackingIds = [];

			if (!areAllShipmentsValid) {
				return console.error('some shipments does not have valid refIds');
			}

			var idStorePromise = this.$q.when();
			if (this.model.coinOnlyBatch) {
				idStorePromise = this.IdStoreService.incrementKey('COINONLYBATCH', this.model.shipments.length);
			}

			return idStorePromise.then(function (idStoreData) {
				_this19.model.shipments.forEach(function (shipmentBatchRecord, index) {
					var baseTrackingId = shipmentBatchRecord.trackingId;
					if (_this19.model.coinOnlyBatch && idStoreData) {
						var currentIdValue = parseInt(idStoreData.start) + index;
						baseTrackingId = currentIdValue.toString();
					}

					var uniqueShipmentFields = (0, _keys3.default)(_this19.coinTypes);
					var days = {
						0: 'Sun',
						1: 'Mon',
						2: 'Tue',
						3: 'Wed',
						4: 'Thu',
						5: 'Fri',
						6: 'Sat'
					};
					var selectedDay = days[moment(_this19.model.deliveryDate).day()];
					var seqKey = 'defRouteSeq' + selectedDay;

					uniqueShipmentFields.forEach(function (field) {
						if (typeof shipmentBatchRecord[field] === 'number' && shipmentBatchRecord[field] > 0) {
							var shiptypeId = _this19.coinTypes[field].selected;
							var coinFlag = !!_this19.coinTypes[field].coinFlag;
							shipments.push({
								pickupDate: moment(_this19.model.pickupDate).format('YYYY-MM-DD'),
								deliveryDate: moment(_this19.model.deliveryDate).format('YYYY-MM-DD'),
								vaultDate: moment(_this19.model.deliveryDate).format('YYYY-MM-DD'),
								fromLocationId: shipmentBatchRecord.refIdObj.parentLocation.id,
								// fromLocationId: this.model.location.id,
								toLocationId: shipmentBatchRecord.location.id,
								routeSeq: shipmentBatchRecord.location[seqKey] || 0,
								routeId: shipmentBatchRecord.routeId,
								batchId: 'B1-' + currentDate.toDate().getTime(),
								branchId: _this19.model.location.branchId,
								// branchId: this.model.branchId,
								coinFlag: coinFlag,
								trackingId: baseTrackingId + '-' + shiptypeId,
								amount: shipmentBatchRecord[field] * _this19.getCoinValue(shiptypeId),
								qty: shipmentBatchRecord[field],
								shiptypeId: shiptypeId,
								// orderNo: shipmentBatchRecord.trackingId,
								pickupFlag: false,
								packedFlag: true
							});
						}
					});

					//shipment for currency
					var cashAmount = _this19.getCurrency(index);

					if (typeof cashAmount === 'number' && cashAmount > 0) {
						shipments.push({
							pickupDate: moment(_this19.model.pickupDate).format('YYYY-MM-DD'),
							deliveryDate: moment(_this19.model.deliveryDate).format('YYYY-MM-DD'),
							vaultDate: moment(_this19.model.deliveryDate).format('YYYY-MM-DD'),
							fromLocationId: shipmentBatchRecord.refIdObj.parentLocation.id,
							// fromLocationId: this.model.location.id,
							toLocationId: shipmentBatchRecord.location.id,
							routeSeq: shipmentBatchRecord.location[seqKey] || 0,
							routeId: shipmentBatchRecord.routeId,
							batchId: 'B1-' + currentDate.toDate().getTime(),
							branchId: _this19.model.location.branchId,
							// branchId: this.model.branchId,
							trackingId: baseTrackingId,
							qty: 1,
							amount: cashAmount,
							shiptypeId: 'C',
							// orderNo: shipmentBatchRecord.trackingId,
							pickupFlag: false,
							packedFlag: true
						});
					}
				});

				return _this19.checkHoldAndCallSupervisor(shipments).then(function (_ref6) {
					var needSupervisor = _ref6.needSupervisor,
					    supId = _ref6.supId;

					return _this19.$q.all(shipments.map(function (shipment) {
						if (shipment.routeId === 'HOLD') {
							shipment.routeId = _this19.HOLD_ROUTE;
							shipment.holdFlag = true;

							var holdDetails = {
								status: 'ON_HOLD',
								reason: "No Route Available/Selected",
								holdDate: moment(currentDate).format('YYYY-MM-DD'),
								supvHoldId: supId
							};

							return _this19.ShipmentService.create(shipment).then(function (shipment) {
								return _this19.ShipmentService.createHold((0, _assign2.default)({}, shipment, holdDetails));
							});
						} else {
							return _this19.ShipmentService.create(shipment);
						}
					}));
				}).then(function () {
					if (_this19.model.selectedFile) {
						return _this19.RouteService.removeUploadFile(_this19.model.selectedFile).catch(function (err) {
							console.error(err);
						});
					} else {
						return _this19.$q.when();
					}
				}).then(function (data) {
					var successMessage = _this19.$translate.instant('commitSuccessModal.message');
					_this19.Modal.commitSuccessModal(_this19.getTotalByName('total'), 0, currentDate, successMessage, null, function (_ref7) {
						var modal = _ref7.modal;

						modal.close();
						var releaseRoutes = _lodash2.default.chain(shipments).map(function (item) {
							return item.routeId;
						}).uniq().value();
						_this19.executeReleaseRoutes(releaseRoutes, _this19.model.deliveryDate).then(function () {}).catch(function (err) {
							if (_this19.releaseError.length > 0) {
								var errorRoute = '';
								_this19.releaseError.map(function (err) {
									if (errorRoute == '') {
										errorRoute = err.routeId;
									} else {
										errorRoute += ', ' + err.routeId;
									}
									return;
								});
								_this19.Modal.errorModal(_this19.releaseError[0].message + ' ' + errorRoute);
							}
						});
						_this19.resetData();
					});
				}).catch(function (err) {
					if (err && err.data && err.data.errors) {
						_this19.Modal.errorModal("error." + err.data.errors[0].path);
					} else if (err && err.data && err.data.message) {
						_this19.Modal.errorModal(err.data.message);
					}
					// console.error(err);
				});
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			for (var key in this.model) {
				this.model[key] = '';
			}
			this.clearErrors();
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this20 = this;

			if (!this.validate()) {
				return;
			}

			this.loading = true;
			this.Service.create({
				id: this.model.id,
				description: this.model.description,
				inputType: this.model.inputType,
				batchSourceId: this.model.batchSourceId
			}).then(function (data) {
				_this20.loading = false;
				_this20.askCreate();
			}).catch(function (err) {
				_this20.loading = false;
				err.data.errors.map(function (e) {
					_this20.errorMessage += e.message + '<br/>';
				});
			});
		}
	}, {
		key: 'processFileData',
		value: function processFileData(model) {
			var _this21 = this;

			var previousShipments = angular.copy(this.model.shipments);
			// this.model.deliveryDate = new Date(model.selectedFile.fileData.deliveryDate);
			// this.model.pickupDate = new Date(model.selectedFile.fileData.pickupDate);
			this.model.deliveryDate = new Date(model.deliveryDate);
			this.model.pickupDate = new Date(model.pickupDate);
			this.model.location = model.location;
			this.model.batchMaster = model.batchMaster;
			this.model.selectedFile = model.selectedFile.fileName;
			this.model.description = this.model.selectedFile;
			this.deliveryDateOptions = {
				minDate: this.model.pickupDate
			};
			this.model.shipments = [];
			this.model.duplicateTrackingIds = [];

			var previewIdPromise = this.$q.when();
			var nextCoinTrackingId = null;
			if (this.model.coinOnlyBatch) {
				if (previousShipments && previousShipments.length && previousShipments[0].trackingId && !isNaN(parseInt(previousShipments[0].trackingId, 10))) {
					nextCoinTrackingId = parseInt(previousShipments[0].trackingId, 10);
				} else {
					nextCoinTrackingId = parseInt(this.model.currentCoinNumber, 10);
				}
				if (isNaN(nextCoinTrackingId)) {
					previewIdPromise = this.IdStoreService.getPreviewNextId('COINONLYBATCH', model.selectedFile.fileData.shipments.length + 1);
				}
			}

			return previewIdPromise.then(function (idStoreData) {
				model.selectedFile.fileData.shipments.forEach(function (shipmentData, index) {
					// at least one shipment entry should get created
					var firstCashBag = shipmentData.cashBags && shipmentData.cashBags[0];
					var cashSum = firstCashBag && firstCashBag.value || 0;
					var coinMappings = [{ modelField: 'coin1', fileField: 'pennyBagCount', category: 'PENNY' }, { modelField: 'coin5', fileField: 'nickelBagCount', category: 'NICKEL' }, { modelField: 'coin10', fileField: 'dimesBagCount', category: 'DIMES' }, { modelField: 'coin25', fileField: 'quarterBagCount', category: 'QUARTER' }, { modelField: 'coin1$', fileField: 'dollarBagCount', category: 'ONE_US_DOLLAR' }];

					//perform coin calculation only for the first cash bag
					var coinSum = coinMappings.reduce(function (partialSum, coinMapping) {
						if (_this21.coinTypes[coinMapping.category]) {
							var coinType = _this21.coinTypes[coinMapping.category].selected;
							var coinValue = _this21.getCoinValue(coinType);
							var bagCount = shipmentData[coinMapping.fileField];

							return partialSum + (!!bagCount ? bagCount * coinValue : 0);
						}
					}, 0);

					if (_this21.model.coinOnlyBatch && coinSum === 0) {
						return;
					}

					var trackingId = null;
					if (_this21.model.coinOnlyBatch) {
						if (isNaN(nextCoinTrackingId) && idStoreData) {
							nextCoinTrackingId = parseInt(idStoreData.start, 10);
						}
						trackingId = nextCoinTrackingId.toString();
						nextCoinTrackingId++;
					} else {
						trackingId = firstCashBag && firstCashBag.label || shipmentData.location.id;
					}

					// if (cashSum > 0) {
					_this21.model.shipments.push({
						refId: shipmentData.location.id,
						locationName: shipmentData.location.name,
						locationAddress: shipmentData.location.address,
						total: _this21.model.coinOnlyBatch ? coinSum : cashSum,
						cashCoinTotal: _this21.model.coinOnlyBatch ? coinSum : cashSum,
						cashAmount: _this21.model.coinOnlyBatch ? 0 : cashSum,
						trackingId: trackingId,

						routeIds: [],

						coin1: shipmentData.pennyBagCount || null,
						coin5: shipmentData.nickelBagCount || null,
						coin10: shipmentData.dimesBagCount || null,
						coin25: shipmentData.quarterBagCount || null,
						coin1$: shipmentData.dollarBagCount || null,

						currency: _this21.model.coinOnlyBatch ? 0 : cashSum,
						scanLimit: _this21.scanLimit,
						amountErrors: {},
						checkScanLimit: _this21.scanLimit > 0
					});
					// }
					if (_this21.model.coinOnlyBatch) {
						return;
					}

					// remove first cash bag as it is already processed above
					var remainingCashBags = shipmentData.cashBags ? shipmentData.cashBags.slice(1) : [];
					remainingCashBags.forEach(function (cashBag) {
						if (cashBag.label) {
							_this21.model.shipments.push({
								refId: shipmentData.location.id,
								locationName: shipmentData.location.name,
								locationAddress: shipmentData.location.address,
								total: _this21.model.coinOnlyBatch ? 0 : cashBag.value,
								cashCoinTotal: cashBag.value,
								cashAmount: cashBag.value,
								trackingId: cashBag.label,

								routeIds: [],

								// in case of multiple cash-bags ignore coins
								coin1: null,
								coin5: null,
								coin10: null,
								coin25: null,
								coin1$: null,

								currency: cashBag.value,
								scanLimit: _this21.scanLimit,
								amountErrors: {},
								checkScanLimit: _this21.scanLimit > 0
							});
						}
					});
				});

				if (_this21.model.coinOnlyBatch) {
					if (!isNaN(nextCoinTrackingId)) {
						_this21.model.currentCoinNumber = nextCoinTrackingId.toString();
					} else if (idStoreData) {
						_this21.model.currentCoinNumber = idStoreData.end.toString();
					}
				}

				if (!_this21.model.shipments.length) {
					if (_this21.model.coinOnlyBatch && previousShipments && previousShipments.length) {
						_this21.model.shipments = previousShipments;
					} else {
						_this21.add();
					}
				}

				// this.fromLocationChanged();

				_this21.model.expectedTotal = Math.round(model.selectedFile.fileData.totalAmount);
				_this21.model.cursor = model.selectedFile.fileData.autoGeneratedCursor;
				return _this21.setNewRoutes();
			});
		}
	}, {
		key: 'selectUploadFile',
		value: function selectUploadFile() {
			var _this22 = this;

			if (this.isDisabled) return;
			this.isDisabled = true;
			this.Modal.uploadedFileSelection(this.model.location, this.locations.filter(function (loc) {
				return loc.id === _this22.model.location.id;
			}), this.batchMasters, this.model.branches, function (_ref8) {
				var modal = _ref8.modal,
				    $scope = _ref8.$scope;

				_this22.processFileData($scope.model).then(function () {
					return _this22.RouteService.getUploadedFiles();
				}).then(function (data) {
					_this22.uploadedFiles = data.results;
				}).catch(function (err) {
					if (err && err.data && err.data.message) {
						_this22.Modal.errorModal(err.data.message);
					} else {
						console.error(err);
					}
				}).finally(function () {
					_this22.isDisabled = false;
					modal.close();
				});
			}, function (_ref9) {
				var modal = _ref9.modal;

				_this22.isDisabled = false;
				if (modal) modal.close();
			}, this.model.selectedFile);
		}
	}, {
		key: 'changeType',
		value: function changeType(event, type, coin) {
			this.coinTypes[type].selected = coin;
			this.coinTypes[type].isOpen = false;
		}
	}, {
		key: 'isFirstShipmentCompleted',
		value: function isFirstShipmentCompleted() {
			var firstShipmentRecord = this.model.shipments && this.model.shipments[0];

			return firstShipmentRecord && firstShipmentRecord.refId && firstShipmentRecord.trackingId && firstShipmentRecord.total && firstShipmentRecord.routeId;
		}
	}, {
		key: 'fromLocationChanged',
		value: function fromLocationChanged() {
			var _this23 = this;

			if (this.model.location) {
				var selectedBatchType = this.batchMasters.find(function (batchMaster) {
					return batchMaster.batchSourceId === _this23.model.location.id;
				});

				if (this.model.batchMaster !== selectedBatchType.inputType) {
					this.model.batchMaster = selectedBatchType.inputType;
					// this.batchMasterChanged();
				}
				this.SetupService.get(this.model.location.branchId).then(function (res) {
					_this23.setupData = res;
					_this23.autoGenerateToggle = _this23.setupData.autoGenerateTrackingId;
					setTimeout(function () {
						if (_this23.model.autoGenerateTrackIdToggle === true && _this23.autoGenerateToggle && !_this23.model.coinOnlyBatch) {
							_this23.getPreviewId().then(function () {
								for (var i = 0; i < _this23.model.shipments.length; i++) {
									var data = _this23.model.shipments[i];
									data.trackingId = _this23.setupData.trackingIdPrefix + _this23.currentNumberArray[i];
								}
							});
						}
						if (!_this23.autoGenerateToggle) {
							_this23.model.shipments.forEach(function (data) {
								_this23.trackingId = data.trackingId;
							});
						}
						_this23.$scope.$apply();
					});
				});
			}

			if (this.model.location) {
				this.model.shipments.forEach(function (s) {
					// const locBranches =  s.refIdObj && s.refIdObj.locationBranches ? s.refIdObj.locationBranches.map((br) => br.branchId) : [];
					// const branchIdExists = s.refIdObj && 
					// s.refIdObj.branchId === this.model.location.branchId || 
					// locBranches.includes(this.model.location.branchId);
					var branchIdExists = s.refIdObj && s.refIdObj.branchId === _this23.model.location.branchId;
					if (!branchIdExists) {
						s.refIdObj = null;
						s.refId = null;
						s.location = '';
						if (_this23.isRoutesSet || s.refIdObj) s.location = '';
					}
				});
			}
			this.bankLocationToggleChange();
		}
	}, {
		key: 'createLocation',
		value: function createLocation(index) {
			var _this24 = this;

			var shipmentRecord = this.model.shipments[index];

			var locationModel = {
				id: shipmentRecord.refId,
				refId: shipmentRecord.refId,
				name: shipmentRecord.locationName,
				_address: shipmentRecord.locationAddress,
				branch: this.model.location.branchId
				// branch: this.model.branchId
			};

			this.Modal.addLocation(locationModel, function (_ref10) {
				var modal = _ref10.modal,
				    data = _ref10.data;

				//close modal
				modal.close();

				//fetch route for selected record
				var dupplicatItemIndex = [];
				_this24.model.shipments.map(function (item, i) {
					if (item.refId == _this24.model.shipments[index].refId) {
						dupplicatItemIndex.push(i);
					}
				});
				_this24.setNewRoutes(dupplicatItemIndex);

				//hide popover for selected record if user has not change the refNumber
				if (shipmentRecord.refId == data.id || shipmentRecord.refId == data.refNumber) {
					_this24.model.shipments[index].popoverStatus = false;
				}
			}, function (_ref11) {
				var modal = _ref11.modal,
				    err = _ref11.err;

				if (err && err.data.errors.length) {
					modal.close();
					err.data.errors.map(function (e) {
						_this24.Modal.errorModal("error.locationCreateError");
					});
				} else {
					modal.close();
				}
			});
		}
	}, {
		key: 'updateLocation',
		value: function updateLocation(index, val) {
			var _this25 = this;

			var shipmentRecord = this.model.shipments[index];
			this.LocationService.update(shipmentRecord.suspendLocations.id, {
				id: shipmentRecord.suspendLocations.id,
				active: val ? 1 : 0
			}).then(function (data) {
				_this25.setNewRoutes();
				_this25.model.shipments[index].popoverStatus = true;
				if (shipmentRecord.refId == data.id || shipmentRecord.refId == data.refNumber) {
					_this25.model.shipments[index].popoverStatus = false;
				}
			}).catch(function (error) {
				console.log(error);
			});
		}
	}, {
		key: 'getAllLocation',
		value: function getAllLocation(searchKey, offset) {
			var _this26 = this;

			return;
			var loadLocationDatas = '';
			if (searchKey) {
				this.offset = 0;
				loadLocationDatas = this.loadLocationDataWithSearch(searchKey);
			} else {
				if (offset == 0) {
					this.offset = 0;
				}
				loadLocationDatas = this.loadLocationData();
			}

			this.LocationService.getAllLocation(loadLocationDatas, this.offset, LIMIT).then(function (data) {
				if (_this26.offset === 0) {
					_this26.totalLocationRecords = data.total;
					_this26.locations = _this26.mappingLocationDatas(data.results).filter(function (location) {
						return _this26.batchSourceIds.includes(location.id);
					});
					_this26.offset += 10;
					if (_this26.locations.length <= 10 && !searchKey) {
						_this26.changeOffsetFlag = false;
						_this26.getAllLocation('', _this26.offset);
					}
				} else {
					var locations = _this26.mappingLocationDatas(data.results).filter(function (location) {
						return _this26.batchSourceIds.includes(location.id);
					});;
					_this26.locations = _this26.locations.concat(locations);
					_this26.offset += 10;
					if (_this26.locations.length <= 10) {
						_this26.changeOffsetFlag = false;
						if (_this26.totalLocationRecords > _this26.offset) {
							_this26.getAllLocation('', _this26.offset);
						}
					} else _this26.changeOffsetFlag = true;
				}
			}).catch(function (error) {
				console.log(error);
			});
		}
	}, {
		key: 'getAllBranchesList',
		value: function getAllBranchesList(searchKey, offset) {
			var _this27 = this;

			this.BranchService.all(searchKey, offset, MAXLIMIT).then(function (data) {
				var branches = _this27.mappingBranches(data.results);

				if (offset === 0) {
					_this27.totalBranchesRecords = data.total;
					_this27.branches = branches;
				} else {
					_this27.branches = [].concat((0, _toConsumableArray3.default)(_this27.branches), (0, _toConsumableArray3.default)(branches));
				}

				_this27.branches.forEach(function (branch) {
					var selectedBranches = _this27.model.branches.map(function (selectedbranch) {
						return selectedbranch.Value;
					});
					if (!selectedBranches.length) {
						if (branch.id === _this27.model.branchId) {
							branch.ticked = true;
						}
						_this27.branchChanged();
						return;
					}
					if (selectedBranches.includes(branch.Value)) {
						branch.ticked = true;
					}
				});
				_this27.model.branches = _this27.branches.filter(function (branch) {
					return branch.ticked;
				});
				_this27.branchChanged();
			}).catch(function (err) {
				console.error("Error fetching branches:", err);
			});
		}
	}, {
		key: 'executeReleaseRoutes',
		value: function executeReleaseRoutes(routes, vaultDate) {
			var _this28 = this;

			var releaseRoutes = _lodash2.default.chain(this.model.shipments).map(function (item) {
				return item.routeId;
			}).uniq().value();
			this.releaseError = [];
			var formattedDate = moment(this.model.deliveryDate).format('YYYY-MM-DD');

			return releaseRoutes.reduce(function (p, route) {
				var nextIteration = _this28.$q.defer();
				p.then(function () {
					if (route !== 'HOLD') {
						//route !== this.HOLD_ROUTE // replace this when using old commit()
						_this28.RouteService.releaseRoute(route, formattedDate).then(function (res) {
							nextIteration.resolve();
						}).catch(function (err) {
							var releaseRouteErrors = JSON.parse(err.data.message);
							releaseRouteErrors.routeId = route;
							_this28.releaseError.push(releaseRouteErrors);
							if (_this28.releaseError.length > 0) {
								var errorRoute = '';
								_this28.releaseError.map(function (err) {
									if (err.routeId !== 'HOLD') {
										if (errorRoute == '') {
											errorRoute = err.routeId;
										} else {
											errorRoute += ', ' + err.routeId;
										}
									}
									return;
								});
								if (releaseRouteErrors.message == 'E_ROUTEDETAIL_DISABLED_MULTICHECKOUT' && releaseRouteErrors.errorCode == '90000') {
									var errMessage = _this28.$translate.instant('error.disabled_multi_checkout');
									_this28.Modal.errorModal(errorRoute + ' ' + errMessage);
								} else {
									_this28.Modal.errorModal(_this28.releaseError[0].message + ' ' + errorRoute);
								}
							}
						});
					} else {
						nextIteration.resolve();
					}
				});
				return nextIteration.promise;
			}, this.$q.when()).then(function () {
				return _this28.newCommit();
			});
		}
	}, {
		key: 'setNewRoutes',
		value: function setNewRoutes() {
			var _this29 = this;

			this.isRouteDisabled = true;
			this.routeLocations = [];
			this.allRouteLocations = [];
			var INDEX_NOT_MENTIONED = 'index not mentioned';
			this.errorCheck = 0;
			this.errorCount = 0;
			this.errorNotFound = 0;
			this.errorNotFoundCount = 0;
			this.errorLocSuspended = 0;
			this.errorLocSuspendedCount = 0;
			this.model.duplicateTrackingIds = [];
			var day = moment(this.model.deliveryDate).day();

			var weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

			var routeIdField = 'defRoute' + weekDays[day] + 'Id';
			var routeField = 'defRoute' + weekDays[day];
			var holidayRouteId = 'defRouteHolId';
			var HolidayRoutes = 'defRouteHol';

			this.model.vaultDates = moment(this.vaultDate).day();

			// check for Holidays
			this.isHoliday.forEach(function (holidays) {
				_this29.holidayStartDate = moment(holidays.holidayDate).day();
				_this29.holidayEndDate = moment(holidays.holidayEnd).day();
			});

			// check if holidayToggle true or false
			var useHolidays = this.holidayRoutes;

			// check for routeId associate with different branch OR not && also check for Holiday Routes
			// if (this.model.vaultDates == day && this.model.vaultDates == this.holidayStartDate
			// 	&& this.model.location[HolidayRoutes] !== null
			// 	&& this.model.location[HolidayRoutes].branchId === this.model.branchId && useHolidays == true) {
			// 	this.routes.defaultRoute = this.model.location[holidayRouteId];
			// }
			// else if (day == this.holidayEndDate && this.holidayEndDate == this.model.vaultDates
			// 	&& this.model.location[HolidayRoutes] !== null
			// 	&& this.model.location[HolidayRoutes].branchId === this.model.branchId && useHolidays == true) {
			// 	this.routes.defaultRoute = this.model.location[holidayRouteId];
			// }
			// else if (this.model.location[routeField] && this.model.location[routeField].branchId === this.model.branchId) {
			// 	this.routes.defaultRoute = this.model.location[routeIdField];
			// }
			// else {
			// 	this.routes.defaultRoute = 'HOLD';
			// }
			if (this.model.vaultDates == day && this.model.vaultDates == this.holidayStartDate && this.model.location[HolidayRoutes] !== null && this.model.location[HolidayRoutes].branchId === this.model.location.branchId && useHolidays == true) {
				this.routes.defaultRoute = this.model.location[holidayRouteId];
			} else if (day == this.holidayEndDate && this.holidayEndDate == this.model.vaultDates && this.model.location[HolidayRoutes] !== null && this.model.location[HolidayRoutes].branchId === this.model.location.branchId && useHolidays == true) {
				this.routes.defaultRoute = this.model.location[holidayRouteId];
			} else if (this.model.location[routeField] && this.model.location[routeField].branchId === this.model.location.branchId) {
				this.routes.defaultRoute = this.model.location[routeIdField];
			} else {
				this.routes.defaultRoute = 'HOLD';
			}

			this.model.shipments.map(function (shipment, index) {
				if (!shipment.location && shipment.refId && (shipment.trackingId || _this29.model.coinOnlyBatch) && shipment.total >= 0) {
					var parts = shipment.refId.split(' | ');
					_this29.routeLocations.push({
						'refId': parts[0].trim(),
						'branchId': shipment.refIdObj && shipment.refIdObj.parentLocation ? shipment.refIdObj.parentLocation.branchId : _this29.model.location.branchId
						// 'branchId': this.model.branchId
					});
				}
				if (shipment.refId && (shipment.trackingId || _this29.model.coinOnlyBatch) && shipment.total >= 0) {
					var _parts = shipment.refId.split(' | ');
					_this29.allRouteLocations.push({
						'refId': _parts[0].trim(),
						'branchId': shipment.refIdObj && shipment.refIdObj.parentLocation ? shipment.refIdObj.parentLocation.branchId : _this29.model.location.branchId
						// 'branchId': this.model.branchId
					});
				}
			});

			if (!this.routeLocations.length) {
				this.routeLocations = this.allRouteLocations;
				this.model.shipments.forEach(function (item) {
					delete item.locations;
				});
			}

			if (this.routeLocations.length) {
				return this.LocationService.shipmentRoutes(this.routeLocations).then(function (locationResponse) {
					var locations = [];
					// this.isRouteDisabled = false;
					if (_this29.model.shipments.length && locationResponse.length) {
						var newIndex = 0;
						_this29.model.shipments.map(function (shipment, index) {
							if (!shipment.refIdObj) {
								shipment.refIdObj = (0, _extends3.default)({}, shipment.refIdObj, locationResponse[0], shipment.refIdObj ? {} : { parentLocation: _this29.model.location });
							}
							shipment.isSuspended = false;
							if (shipment.refId && (shipment.trackingId || _this29.model.coinOnlyBatch) && shipment.total >= 0) {
								if (shipment.location) {
									//already scan
									_this29.shipmentData = shipment.location;
									shipment.defaultBranch = shipment.branchId;
									shipment.isFromOtherBranch = true;
								} else if (locationResponse[newIndex] && !locationResponse[newIndex].active) {
									shipment.isSuspended = true;
									shipment.suspendStatus = false;
									shipment.defaultBranch = '';
									_this29.shipmentData = null;
									shipment.suspendLocations = locationResponse[newIndex];
									shipment.isFromOtherBranch = false;
									if (_this29.errorLocSuspendedCount == 0) {
										_this29.errorLocSuspendedCount = 1;
										_this29.Modal.errorModal("shipmentBatch.locationSuspended");
									}
									newIndex++;
								} else if (locationResponse[newIndex]) {
									_this29.shipmentData = locationResponse[newIndex];
									shipment.defaultBranch = locationResponse[newIndex].branchId;
									shipment.isFromOtherBranch = true;
									shipment.locObj = shipment.refId + ' | ' + _this29.shipmentData.name;
									shipment.refId = shipment.locObj;
									if (locationResponse[newIndex].locationBranches.length && !locationResponse[newIndex].locationBranches.includes(_this29.model.location.branchId)) {
										// if (locationResponse[newIndex].locationBranches.length && !locationResponse[newIndex].locationBranches.includes(this.model.branchId)) {
										_this29.shipmentData = null;
										_this29.errorCheck++;
										if (_this29.errorCheck >= 1 && _this29.errorCount == 0) {
											_this29.errorCount = 1;
											_this29.Modal.errorModal("error." + 90222);
										}
									}
									newIndex++;
								} else {
									newIndex++;
									shipment.defaultBranch = '';
									_this29.shipmentData = null;
									shipment.isFromOtherBranch = false;
									_this29.errorNotFound++;
									if (_this29.errorNotFound >= 1 && _this29.errorNotFoundCount == 0) {
										_this29.errorNotFoundCount = 1;
										_this29.Modal.errorModal("location.noLocations");
									}
								}
								shipment.location = _this29.shipmentData;
								locations.push(_this29.shipmentData);
							}
						});
					} else {
						_this29.model.shipments[0].isFromOtherBranch = false;
						_this29.shipmentData = null;
						_this29.model.shipments[0].location = null;
						locations.push(_this29.shipmentData);
						_this29.errorNotFound++;
						if (_this29.errorNotFound >= 1 && _this29.errorNotFoundCount == 0) {
							_this29.errorNotFoundCount = 1;
							_this29.Modal.errorModal("location.noLocations");
						}
					}
					return locations;
				}).then(function (locations) {
					// this.isRouteDisabled = false;
					return locations.map(function (fetchedLocation) {

						_this29.fetchedLocations = fetchedLocation;

						if (fetchedLocation === null || fetchedLocation === INDEX_NOT_MENTIONED) {
							return fetchedLocation;
						}
						// check for routeId associate with different branch OR not && also check for Holiday
						// if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null &&
						// 	this.model.vaultDates == this.holidayStartDate &&
						// 	fetchedLocation[HolidayRoutes].branchId === this.model.branchId &&
						// 	this.model.vaultDates == day && useHolidays == true) {
						// 	return fetchedLocation[holidayRouteId];
						// }
						// else if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null &&
						// 	day == this.holidayEndDate && this.holidayEndDate == this.model.vaultDates &&
						// 	fetchedLocation[HolidayRoutes].branchId === this.model.branchId &&
						// 	useHolidays == true) {
						// 	return fetchedLocation[holidayRouteId];
						// }
						// else if (fetchedLocation != null && fetchedLocation[routeField] !== null &&
						// 	fetchedLocation[routeField].branchId === this.model.branchId) {
						// 	return fetchedLocation[routeIdField];
						// }
						if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null && _this29.model.vaultDates == _this29.holidayStartDate && fetchedLocation[HolidayRoutes].branchId === _this29.model.location.branchId && _this29.model.vaultDates == day && useHolidays == true) {
							return fetchedLocation[holidayRouteId];
						} else if (fetchedLocation != null && fetchedLocation[HolidayRoutes] !== null && day == _this29.holidayEndDate && _this29.holidayEndDate == _this29.model.vaultDates && fetchedLocation[HolidayRoutes].branchId === _this29.model.location.branchId && useHolidays == true) {
							return fetchedLocation[holidayRouteId];
						} else if (fetchedLocation != null && fetchedLocation[routeField] !== null && fetchedLocation[routeField].branchId === _this29.model.location.branchId) {
							return fetchedLocation[routeIdField];
						}
					});
				}).then(function (routeIds) {
					var routes = [];
					_this29.RouteService.getAllBranchRoutes(_this29.model.location.branchId, moment(_this29.model.deliveryDate).format('YYYY-MM-DD')).then(function (res) {
						_this29.isRouteDisabled = false;
						res.filter(function (field) {
							routes.push(field.routeId);
						});
						_this29.model.shipments.forEach(function (shipmentBatchRecord, index) {
							if (routeIds[index] === INDEX_NOT_MENTIONED) {
								return;
							}

							var shipmentRoute = routeIds[index];

							shipmentBatchRecord.routeIds = [];

							if (_this29.routes.defaultRoute) {
								shipmentBatchRecord.routeIds.push(_this29.routes.defaultRoute);
								shipmentBatchRecord.routeId = _this29.routes.defaultRoute;
							}
							if (!_this29.HOLD_ROUTE || _this29.fetchedLocations != null && _this29.fetchedLocations[routeField] === null && shipmentBatchRecord.location && shipmentBatchRecord.location.locationScheduleRecurringData.length > 0) {
								for (var i = 0; i < shipmentBatchRecord.location.locationScheduleRecurringData.length; i++) {
									for (var j = 0; j < shipmentBatchRecord.location.locationScheduleRecurringData[i].nextOccurrence.length; j++) {
										_this29.routeId = shipmentBatchRecord.location.locationScheduleRecurringData[i].routeId;

										_this29.date1Ocurrence = moment(shipmentBatchRecord.location.locationScheduleRecurringData[i].nextOccurrence[j].next1Occurrence).utc().format('YYYY-MM-DD');
										_this29.date2Ocurrence = moment(shipmentBatchRecord.location.locationScheduleRecurringData[i].nextOccurrence[j].next2Occurrence).utc().format('YYYY-MM-DD');
										_this29.date3Ocurrence = moment(shipmentBatchRecord.location.locationScheduleRecurringData[i].nextOccurrence[j].next3Occurrence).utc().format('YYYY-MM-DD');
										var deliveryDate = moment.parseZone(_this29.model.deliveryDate).format('YYYY-MM-DD');
										if (deliveryDate == _this29.date1Ocurrence || deliveryDate == _this29.date2Ocurrence || deliveryDate == _this29.date3Ocurrence) {
											shipmentBatchRecord.routeIds.push(_this29.routeId);
											shipmentBatchRecord.routeId = _this29.routeId;
											break;
										}
									}
								}
							} else if (_this29.HOLD_ROUTE || _this29.fetchedLocations != null && _this29.fetchedLocations[routeField] !== null && _this29.fetchedLocations[routeField].branchId !== _this29.model.location.branchId) {
								shipmentBatchRecord.routeIds.push('HOLD');
								shipmentBatchRecord.routeId = 'HOLD';
							}
							if (shipmentRoute) {
								shipmentBatchRecord.routeIds.push(shipmentRoute);
								shipmentBatchRecord.routeId = shipmentRoute;
							}
							shipmentBatchRecord.routeIds = shipmentBatchRecord.routeIds.concat(routes);
							//remove dupes
							shipmentBatchRecord.routeIds = shipmentBatchRecord.routeIds.filter(function (routeId, index, array) {
								return array.indexOf(routeId) === index;
							});
						});
					});
				}).catch(function (err) {
					_this29.isRouteDisabled = false;
					console.error(err);
					if (err && err.data && err.data.message) {
						_this29.Modal.errorModal(err.data.message);
					}
				}).finally(function () {
					// this.isRouteDisabled = false;
					_this29.isRoutesSet = _this29.model.shipments.every(function (shipmentRecord) {
						return !!shipmentRecord.location;
					});
				});
			} else {
				this.isRouteDisabled = false;
				this.isRoutesSet = this.model.shipments.every(function (shipmentRecord) {
					return !!shipmentRecord.location;
				});
			}
		}
	}, {
		key: 'newCommit',
		value: function newCommit() {
			var _this30 = this;

			if (this.isCommitDisabled) return;
			var shipments = [];
			var currentDate = moment();
			var areAllShipmentsValid = this.model.shipments.every(function (shipmentRecord) {
				return !!shipmentRecord.location;
			});
			this.releaseError = [];
			this.model.duplicateTrackingIds = [];

			if (!areAllShipmentsValid) {
				return console.error('some shipments does not have valid refIds');
			}
			this.isCommitDisabled = true;

			var promise = this.$q.when();
			if (this.model.coinOnlyBatch) {
				promise = this.IdStoreService.incrementKey('COINONLYBATCH', this.model.shipments.length).then(function (res) {
					_this30.model.shipments.forEach(function (s, i) {
						s.trackingId = (res.start + i).toString();
					});
				});
			}

			return promise.then(function () {
				_this30.model.shipments.forEach(function (shipmentBatchRecord, index) {
					var uniqueShipmentFields = (0, _keys3.default)(_this30.coinTypes);
					var days = {
						0: 'Sun',
						1: 'Mon',
						2: 'Tue',
						3: 'Wed',
						4: 'Thu',
						5: 'Fri',
						6: 'Sat'
					};
					var selectedDay = days[moment(_this30.model.deliveryDate).day()];
					var seqKey = 'defRouteSeq' + selectedDay;

					uniqueShipmentFields.forEach(function (field) {
						var type = _this30.coinTypes[field].categoryName;
						if (typeof shipmentBatchRecord[type] === 'number' && shipmentBatchRecord[type] > 0) {
							var shiptypeId = _this30.coinTypes[field].selected;
							var coinFlag = !!_this30.coinTypes[field].coinFlag;
							shipments.push({
								pickupDate: moment(_this30.model.pickupDate).format('YYYY-MM-DD'),
								deliveryDate: moment(_this30.model.deliveryDate).format('YYYY-MM-DD'),
								vaultDate: moment(_this30.model.deliveryDate).format('YYYY-MM-DD'),
								// fromLocationId: this.model.location.id,
								fromLocationId: shipmentBatchRecord.refIdObj.parentLocation.id,
								toLocationId: shipmentBatchRecord.location.id,
								routeSeq: shipmentBatchRecord.location[seqKey] || 0,
								routeId: shipmentBatchRecord.routeId,
								batchId: 'B1-' + currentDate.toDate().getTime(),
								branchId: _this30.model.location.branchId,
								coinFlag: coinFlag,
								trackingId: shipmentBatchRecord.trackingId + '-' + shiptypeId,
								amount: shipmentBatchRecord[type] * _this30.getCoinValue(shiptypeId),
								qty: shipmentBatchRecord[type],
								shiptypeId: shiptypeId,
								// orderNo: shipmentBatchRecord.trackingId,
								pickupFlag: false,
								packedFlag: true
							});
						}
					});

					//shipment for currency
					var cashAmount = _this30.getCurrency(index);

					if (!_this30.model.coinOnlyBatch && typeof cashAmount === 'number' && cashAmount > 0) {

						shipments.push({
							pickupDate: moment(_this30.model.pickupDate).format('YYYY-MM-DD'),
							deliveryDate: moment(_this30.model.deliveryDate).format('YYYY-MM-DD'),
							vaultDate: moment(_this30.model.deliveryDate).format('YYYY-MM-DD'),
							fromLocationId: shipmentBatchRecord.refIdObj.parentLocation.id,
							// fromLocationId: this.model.location.id,
							toLocationId: shipmentBatchRecord.location.id,
							routeSeq: shipmentBatchRecord.location[seqKey] || 0,
							routeId: shipmentBatchRecord.routeId,
							batchId: 'B1-' + currentDate.toDate().getTime(),
							branchId: _this30.model.location.branchId,
							// branchId: this.model.branchId,
							trackingId: shipmentBatchRecord.trackingId,
							qty: 1,
							amount: cashAmount,
							shiptypeId: 'C',
							// orderNo: shipmentBatchRecord.trackingId,
							pickupFlag: false,
							packedFlag: true
						});
					}
				});

				return _this30.checkHoldAndCallSupervisor(shipments).then(function (_ref12) {
					var needSupervisor = _ref12.needSupervisor,
					    supId = _ref12.supId;

					// let totalCursor = this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle ? this.trackingIdCursor  + this.model.shipments.length:''
					var totalCursor = void 0;
					if (_this30.model.autoGenerateTrackIdToggle === true && _this30.autoGenerateToggle) {
						if (_this30.model.cursor > 0) totalCursor = _this30.trackingIdCursor + _this30.model.cursor;else if (_this30.model.cursor === 0) totalCursor = _this30.trackingIdCursor;else totalCursor = _this30.trackingIdCursor + _this30.model.shipments.length;
					}
					// else totalCursor = ''
					var autoGenerateTrackIdToggle = _this30.autoGenerateToggle === true ? true : false;
					return _this30.ShipmentService.createShipments(shipments, supId, _this30.HOLD_ROUTE, _this30.model.location.branchId, autoGenerateTrackIdToggle, totalCursor);
					// return this.ShipmentService.createShipments(shipments, supId, this.HOLD_ROUTE, this.model.branchId, autoGenerateTrackIdToggle, totalCursor)
				}).then(function () {
					if (_this30.model.selectedFile) {
						return _this30.RouteService.removeUploadFile(_this30.model.selectedFile).catch(function (err) {
							console.error(err);
						});
					} else {
						return _this30.$q.when();
					}
				}).then(function (data) {
					_this30.isCommitDisabled = false;
					var successMessage = _this30.$translate.instant('commitSuccessModal.message');
					_this30.Modal.commitSuccessModal(_this30.getTotalByName('total'), 0, currentDate, successMessage, null, function (_ref13) {
						var modal = _ref13.modal;

						_this30.printBatch(shipments);
						modal.close();
						_this30.resetData();
					});
				}).catch(function (err) {
					_this30.isCommitDisabled = false;
					if (_this30.model.coinOnlyBatch) {
						_this30.refreshCoinOnlyTrackingIds().catch(function (refreshErr) {
							console.error(refreshErr);
						});
					}
					if (err && err.data && err.data.errors) {
						_this30.Modal.errorModal("error." + err.data.errors[0].path);
					} else if (err && err.data && err.data.message) {
						if (err.data.message.startsWith('The tracking id provided <b>')) {
							var trackingIds = /<b>(.*?)<\/b>/g.exec(err.data.message)[1].trim().split(',');
							_this30.model.duplicateTrackingIds = trackingIds;
						}
						_this30.Modal.errorModal(err.data.message);
					}
				});
			});
		}
	}, {
		key: 'printBatch',
		value: function printBatch(shipments) {
			var url = this.$state.href('printBatch');
			window.w = window.open(url, '_blank');
			window.w.printData = {
				trackingIds: shipments.map(function (d) {
					return d.trackingId;
				})
				// pickupDate: moment(this.model.pickupDate).format('YYYY-MM-DD'),
				// deliveryDate:  moment(this.model.deliveryDate).format('YYYY-MM-DD')
			};
		}
	}, {
		key: 'bankLocationToggleChange',
		value: function bankLocationToggleChange() {
			if (this.model.bankLocationDDToggle && this.model.location && this.model.location.Value) {
				this.getBankDeliverLocations();
			} else {
				this.bankLocationsObj = {
					offset: 0,
					limit: 5000,
					totalLocationRecords: 0,
					list: [],
					search: '',
					loadMore: this.loadMoreBankDeliverLocations
				};
			}
		}
	}, {
		key: 'getBankDeliverLocations',
		value: function getBankDeliverLocations() {
			var _this31 = this;

			if (!this.model.location) {
				this.bankLocationToggleChange();
			} else {
				this.LocationService.getBankDeliverLocations(this.bankLocationsObj.search || '', this.model.location.branchId, this.model.location.Value, (this.bankLocationsObj.offset - 1) * this.bankLocationsObj.limit, this.bankLocationsObj.limit, null, true).then(function (res) {
					if (!_this31.bankLocationsObj.offset) {
						_this31.bankLocationsObj.list = _this31.mappingLocationDatas(res.locations);
						_this31.bankLocationsObj.totalLocationRecords = res.totalRecords;
					} else {
						var locations = _this31.mappingLocationDatas(res.locations);
						_this31.bankLocationsObj.list = _this31.bankLocationsObj.list.concat(locations);
					}
					_this31.bankLocationsObj.list.forEach(function (record) {
						record.parentLocation = _this31.model.location;
					});
				}).catch(function (err) {
					console.log(err);
					if (err && err.data && err.data.errors) {
						_this31.Modal.errorModal("error." + err.data.errors[0].path);
					}
				});
			}
		}
	}, {
		key: 'loadMoreBankDeliverLocations',
		value: function loadMoreBankDeliverLocations(search, offset) {
			self.bankLocationsObj.search = search || '';
			self.bankLocationsObj.offset = offset || 0;
			self.getBankDeliverLocations();
		}
	}, {
		key: 'uploadBatchFile',
		value: function uploadBatchFile() {
			var _this32 = this;

			this.Modal.uploadFiles(function (_ref14) {
				var modal = _ref14.modal,
				    data = _ref14.data;

				_this32.ShipmentService.uploadBatchFiles(data).then(function () {
					_this32.RouteService.getUploadedFiles().then(function (data) {
						_this32.uploadedFiles = data.results;
					});
				}).catch(function (err) {
					if (err && err.data && err.data.message) {
						_this32.Modal.errorModal(err.data.message);
					}
				}).finally(function () {
					modal.close();
				});
			}, function (_ref15) {
				var modal = _ref15.modal;

				if (modal) modal.close();
			});
		}
	}, {
		key: 'tabSelection',
		value: function tabSelection(selectedValue) {
			this.model.currentStats = selectedValue;
			if (selectedValue === this.stats.completedShipment) {
				this.model.date = moment().format('YYYY-MM-DD');
				this.model.searchText = null;
				this.completedShipment();
			}
		}
	}, {
		key: 'newAtmLoads',
		value: function newAtmLoads() {
			var _this33 = this;

			var lastRecord = _lodash2.default.last(this.atmLoadModel.atmLoadShipment);
			var nextOrderNo = void 0;

			if (!lastRecord) nextOrderNo = this.atmLoadModel.nextOrderNumber;else if (lastRecord) nextOrderNo = this.addOne(lastRecord.orderNo);

			this.Modal.atmLoadShipment(null, nextOrderNo, this.vaultDate, 'create', function (_ref16) {
				var modal = _ref16.modal,
				    fundingSource = _ref16.fundingSource,
				    orderNo = _ref16.orderNo,
				    location = _ref16.location,
				    route = _ref16.route,
				    vaultDate = _ref16.vaultDate,
				    orderType = _ref16.orderType,
				    denominations = _ref16.denominations;

				_this33.atmLoadModel.atmLoadShipment.push({
					fundingSource: fundingSource, orderNo: orderNo, location: location, route: route, vaultDate: vaultDate, orderType: orderType, denominations: denominations
				});
				modal.close();
			}, function (_ref17) {
				var modal = _ref17.modal;

				if (modal) modal.close();
			});
		}
	}, {
		key: 'addOne',
		value: function addOne(orderNo) {
			var newOrderNumber = '';
			var continueAdding = true;
			for (var i = orderNo.length - 1; i >= 0; i--) {
				if (continueAdding) {
					var num = parseInt(orderNo[i], 10) + 1;
					if (num < 10) {
						newOrderNumber += num;
						continueAdding = false;
					} else {
						newOrderNumber += '0';
					}
				} else {
					newOrderNumber += orderNo[i];
				}
			}
			return newOrderNumber.split("").reverse().join("");
		}
	}, {
		key: 'editAtmLoad',
		value: function editAtmLoad(shipments, index) {
			var _this34 = this;

			this.Modal.atmLoadShipment(shipments, shipments.orderNo, this.vaultDate, 'edit', function (_ref18) {
				var modal = _ref18.modal,
				    fundingSource = _ref18.fundingSource,
				    orderNo = _ref18.orderNo,
				    location = _ref18.location,
				    route = _ref18.route,
				    vaultDate = _ref18.vaultDate,
				    orderType = _ref18.orderType,
				    denominations = _ref18.denominations;

				_this34.atmLoadModel.atmLoadShipment[index] = {
					fundingSource: fundingSource, orderNo: orderNo, location: location, route: route, vaultDate: vaultDate, orderType: orderType, denominations: denominations
				};
				modal.close();
			}, function (_ref19) {
				var modal = _ref19.modal;

				if (modal) modal.close();
			});
		}
	}, {
		key: 'getOrderType',
		value: function getOrderType(type) {
			switch (type) {
				case type:
					return this.$translate.instant('atm_residual.order_type_' + type);
				default:
					return '';
			}
		}
	}, {
		key: 'resetAtmLoads',
		value: function resetAtmLoads() {
			var _this35 = this;

			this.Modal.confirm({
				header: this.$translate.instant('common.reset'),
				message: this.$translate.instant('shipmentBatch.resetData'),
				callback: function callback(_ref20) {
					var modal = _ref20.modal;

					_this35.atmLoadModel.atmLoadShipment = [];
					modal.close();
				},
				type: 'danger'
			});
		}
	}, {
		key: 'deleteAtmLoad',
		value: function deleteAtmLoad(shipment, index) {
			var _this36 = this;

			this.Modal.confirm({
				header: this.$translate.instant('common.confirm_delete_title'),
				message: this.$translate.instant('shipmentBatch.delete_message'),
				callback: function callback(_ref21) {
					var modal = _ref21.modal,
					    $scope = _ref21.$scope;

					_this36.atmLoadModel.atmLoadShipment.splice(index, 1);
					modal.close();
				},
				type: 'danger'
			});
		}
	}, {
		key: 'createAtmLoads',
		value: function createAtmLoads() {
			var _this37 = this;

			var shipments = [],
			    totalAmount = 0;
			this.atmLoadModel.atmLoadShipment.forEach(function (data) {
				var keys = [],
				    denoms = [];
				keys = (0, _keys3.default)(data.denominations);
				keys.forEach(function (key) {
					totalAmount += data.denominations[key].amount;
					denoms.push(data.denominations[key]);
				});

				shipments.push({
					fundingSourceId: data.fundingSource.Value,
					orderNo: data.orderNo,
					locationId: data.location.Value,
					routeId: data.route.Value,
					deliveryDate: moment(data.vaultDate).format('YYYY-MM-DD'),
					vaultDate: moment(data.vaultDate).format('YYYY-MM-DD'),
					orderType: data.orderType,
					denominations: denoms,
					createdByUserId: _this37.loggedInUserId,
					branchId: _this37.model.branchId,
					// branchId: this.model.branchId,
					fromLocationId: data.fundingSource.dataObj['locationId'],
					sourceName: data.fundingSource.dataObj['sourceName']
				});
			});

			this.atmLoadModel.isCreatingAtmOrders = true;
			this.OrderViewService.createAtmLoadShipments(shipments).then(function (res) {
				_this37.Modal.commitSuccessModal(totalAmount, null, new Date(), 'Shipment Successfully Created', null, function (_ref22) {
					var modal = _ref22.modal;

					modal.close();
					_this37.atmLoadModel.atmLoadShipment = [];
				});
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this37.Modal.errorModal(err.data.message);
				}
			}).finally(function () {
				_this37.atmLoadModel.isCreatingAtmOrders = false;
			});
		}
	}, {
		key: 'getAutoGeneratedTrackingId',
		value: function getAutoGeneratedTrackingId(cursor) {
			var _this38 = this;

			this.model.isGenerateTrackingIdLoading = true;
			var branchId = this.model.location ? this.model.location.branchId : this.model.branchId;
			return this.SetupService.getAutoGeneratedTrackingId(branchId, cursor)
			// return this.SetupService.getAutoGeneratedTrackingId(this.model.branchId, cursor)
			.then(function (data) {
				_this38.currentNumber = data.currentTrackingIdNumber;
				_this38.incrementNumber = data.incrementTrackingIdNumber;
				_this38.trackingIdCursor = data.trackingIdCursor;
				_this38.currentNumberArray = data.currentNumberArray;
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this38.model.isGenerateTrackingIdLoading = false;
			});
		}
	}, {
		key: 'getAutoGeneratedCoinId',
		value: function getAutoGeneratedCoinId(amount) {
			var _this39 = this;

			var currentCoinIds = (this.model.shipments || []).map(function (shipment) {
				return parseInt(shipment.trackingId, 10);
			}).filter(function (trackingId) {
				return !isNaN(trackingId);
			});

			if (currentCoinIds.length) {
				this.model.currentCoinNumber = (Math.max.apply(null, currentCoinIds) + 1).toString();
				return this.$q.when();
			}

			this.model.isGenerateTrackingIdLoading = true;
			return this.IdStoreService.getPreviewNextId('COINONLYBATCH', amount + 1).then(function (data) {
				_this39.model.currentCoinNumber = data.end.toString();
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this39.model.isGenerateTrackingIdLoading = false;
			});
		}
	}, {
		key: 'getPreviewId',
		value: function getPreviewId() {
			var cursor = void 0;
			if (this.autoGenerateToggle) {
				if (this.deletedTrackingId && this.deletedTrackingId.length == 1) {
					cursor = this.model.shipments.length + 1;
				} else if (this.deletedTrackingId && this.deletedTrackingId.length > 1) {
					cursor = this.deletedTrackingId.length + this.model.shipments.length;
				} else {
					cursor = this.model.shipments.length - 1;
				}

				return this.getAutoGeneratedTrackingId(cursor);
			}
		}
	}, {
		key: 'autoGenerateTrackingToggleChange',
		value: function autoGenerateTrackingToggleChange() {
			var _this40 = this;

			if (this.model.autoGenerateTrackIdToggle === true && this.autoGenerateToggle && !this.model.coinOnlyBatch) {
				this.getPreviewId().then(function () {
					var trackingIdPrefix = _this40.setupData.trackingIdPrefix;
					var trackingIdNumber = _this40.currentNumber;

					_this40.currentTrackingNumber = trackingIdPrefix + trackingIdNumber;

					for (var i = 0; i < _this40.model.shipments.length; i++) {
						var data = _this40.model.shipments[i];
						data.trackingId = trackingIdPrefix + _this40.currentNumberArray[i];
					}
				}).catch(function (err) {
					console.log(err);
				});
			}
		}
	}, {
		key: 'printLabels',
		value: function printLabels() {
			var _this41 = this;

			this.shipmentDetails = [];
			this.model.shipments.forEach(function (d) {
				_this41.shipmentDetails.push({
					trackingId: d.trackingId,
					locationId: d.refId && d.refIdObj ? d.refIdObj.Value : d.refId ? d.refId.split('|')[0].trim() : d.refIdObj ? d.refIdObj.Value : null,
					branchId: d.refIdObj ? d.refIdObj.branchId : null,
					locationType: _this41.model.bankLocationDDToggle === true ? d.refIdObj ? d.refIdObj.locationType === 'ON_CALL' ? 'ONC' : d.refIdObj.locationType === 'REGULAR' ? 'REG' : d.refIdObj.locationType : null : d.location && d.location.locationType === 'ON_CALL' ? 'ONC' : d.location && d.location.locationType === 'REGULAR' ? 'REG' : d.location && d.location.locationType,
					locationName: _this41.model.bankLocationDDToggle === true ? d.refIdObj ? d.refIdObj.name : null : d.location && d.location.name,
					// locationAddress: d.location ? d.location.address + ", " + d.location.city + ", " + d.location.state + ", " + d.location.zip : '',
					routeId: d.routeId,
					total: d.total,
					deliveryDate: moment(_this41.model.deliveryDate).format('DD-MMM-YYYY')
				});
			});

			var obj = {
				shipmentDetails: this.shipmentDetails
			};

			var path = this.$state.href('printBatch');
			window.w = window.open(path, '_blank');
			window.w.printData = obj;
		}
	}, {
		key: 'dateChange',
		value: function dateChange() {
			this.model.searchText = '';
			this.pagination.page = 1;
			this.completedShipment();
		}
	}, {
		key: 'pageChange',
		value: function pageChange() {
			this.completedShipment();
		}
	}, {
		key: 'search',
		value: function search() {
			this.pagination.page = 1;
			this.completedShipment();
		}
	}, {
		key: 'completedShipment',
		value: function completedShipment() {
			var _this42 = this;

			setTimeout(function () {
				_this42.model.loading = true;
				var searchText = _this42.model.searchText;
				return _this42.ShipmentService.completedShipments(_this42.model.branchId, moment(_this42.model.date).format('YYYY-MM-DD'), (_this42.pagination.page - 1) * _this42.pagination.pageLimit, _this42.pagination.pageLimit, searchText, _this42.model.reverseSort, _this42.model.sortColumn)
				// return this.ShipmentService.completedShipments(this.model.branchId, moment(this.model.date).format('YYYY-MM-DD'), (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit, searchText, this.model.reverseSort, this.model.sortColumn)
				.then(function (data) {
					_this42.pagination.loading = false;
					_this42.shipment = data;
					_this42.pagination.total = data.total.totalRecord;
				}).catch(function (err) {
					console.log(err);
					if (err && err.data && err.data.message) {
						_this42.Modal.errorModal(err.data.message);
					}
				}).finally(function () {
					_this42.model.loading = false;
				});
			}, 100);
		}
	}, {
		key: 'printCompleteShipmentLabels',
		value: function printCompleteShipmentLabels(batchId, locationId) {
			var url = this.$state.href('printBatch');
			window.w = window.open(url, '_blank');
			window.w.printCompletedShipmentData = {
				batchId: batchId,
				locationId: locationId
			};
		}
	}, {
		key: 'selectAllBranches',
		value: function selectAllBranches() {
			this.model.branches = this.branches;
			this.branchChanged();
		}
	}, {
		key: 'branchChanged',
		value: function branchChanged() {
			var _this43 = this;

			var branches = this.model.branches ? this.model.branches.map(function (ele) {
				return ele.Value;
			}) : [this.model.branchId];
			if (this.model.location) {

				if (!branches || !branches.length) {
					this.model.location = null;
					this.locations = [];
					this.fromLocationChanged();
					return;
				}

				var branchExists = branches.some(function (branchId) {
					return branchId === _this43.model.location.branchId;
				});

				if (!branchExists) {
					this.model.location = null;
					this.fromLocationChanged();
				}
			}

			if (!branches.length) {
				this.locations = [];
				return;
			}

			var batchSearchObj = {
				branchId: branches,
				queryText: '%%'
			};

			this.fetchBatchServiceData(batchSearchObj).then(function (res) {
				_this43.batchSourceIds = res.results.filter(function (batch) {
					return !!batch.batchSourceId;
				}).map(function (batch) {
					return batch.batchSourceId;
				});

				_this43.locations = _this43.mappingLocationDatas(res.results.map(function (res) {
					return res.batchSource;
				})).filter(function (location) {
					return _this43.batchSourceIds.includes(location.id) && location.centralBank;
				});
				_this43.batchMasters = res.results;
			});

			setTimeout(function () {
				_this43.getAllLocation('', 0);
			}, 200);

			this.getBankDeliverLocations();
		}
	}, {
		key: 'fetchBatchServiceData',
		value: function fetchBatchServiceData(searchObj) {
			return this.BatchService.all(searchObj, 0, MAXLIMIT);
		}
	}, {
		key: 'fetchLocationDetails',
		value: function fetchLocationDetails(locationId) {
			return this.ShipmentService.getShipmentLocationDetails(locationId);
		}
	}]);
	return ShipmentBatchController;
}();

exports.default = ShipmentBatchController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shipment_record = __webpack_require__(2076);

var _shipment_record2 = _interopRequireDefault(_shipment_record);

var _shipment_route = __webpack_require__(2078);

var _shipment_route2 = _interopRequireDefault(_shipment_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shipmentRecordModule = angular.module('shipmentRecord', []).directive('shipmentRecord', _shipment_record2.default).filter('shipmentRouteFilter', _shipment_route2.default).name;

exports.default = shipmentRecordModule;

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shipment_record = __webpack_require__(2790);

var _shipment_record2 = _interopRequireDefault(_shipment_record);

var _shipment_record3 = __webpack_require__(2077);

var _shipment_record4 = _interopRequireDefault(_shipment_record3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shipmentRecordComponent = [function () {
  return {
    restrict: 'EA',

    scope: {
      model: '=recordModel',
      currency: '=',
      currenctTotal: '=',
      onTab: '&',
      onRemove: '&',
      onCreateLocation: '&',
      onUpdateLocation: '&',
      batchMaster: '=',
      isRoutesSet: '=',
      duplicateTrackingIds: '=',
      showBankLocationDd: '=',
      bankLocations: '=bankLocations',
      denominationTypeObj: '=denominationTypeObj',
      amountToggle: '=',
      coinValues: '=',
      coinOnlyBatch: '=',
      isGenerateTrackingIdLoading: '='
    },
    template: _shipment_record2.default,
    link: _shipment_record4.default
  };
}];

exports.default = shipmentRecordComponent;

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var link = function link(scope, element, attrs) {
    var TAB_KEY_CODE = 9;

    scope.executeOnTab = function ($event) {
        if ($event.keyCode === TAB_KEY_CODE) {
            scope.onTab();
        }
    };
    scope.setRefId = function () {
        if (scope.model.refIdObj && scope.model.refIdObj.id) {
            scope.model.refId = scope.model.refIdObj.id;
            scope.model.locationType = scope.model.refIdObj.locationType;
        }
    };

    scope.amountModel = {};
    scope.activeField = null;

    scope.getCoinValue = function (group) {
        if (!scope.coinValues || !scope.denominationTypeObj || !scope.denominationTypeObj.coinTypes[group]) return 0;
        var selected = scope.denominationTypeObj.coinTypes[group].selected;
        var val = scope.coinValues[selected];
        if (!val) return 0;
        return val.amountFlag && val.amount > 0 ? val.amount : val.unitValue;
    };

    scope.syncAmountModel = function () {
        if (!scope.model || !scope.denominationTypeObj) return;
        scope.denominationTypeObj.denomTypes.forEach(function (key) {
            var catName = scope.denominationTypeObj.coinTypes[key.group].categoryName;
            if (scope.activeField === catName) return;

            var unitValue = scope.getCoinValue(key.group);
            var unitCount = scope.model[catName];

            if (unitCount != null && unitCount !== '') {
                scope.amountModel[catName] = (unitCount * unitValue).toFixed(2);
                if (unitCount % 1 !== 0) {
                    if (!scope.model.amountErrors) scope.model.amountErrors = {};
                    scope.model.amountErrors[catName] = true;
                } else if (scope.model.amountErrors) {
                    delete scope.model.amountErrors[catName];
                }
            } else if (!scope.model.amountErrors || !scope.model.amountErrors[catName]) {
                scope.amountModel[catName] = null;
            }
        });
    };

    scope.calculateCoinOnlyTotal = function () {
        if (!scope.coinOnlyBatch || !scope.model || !scope.denominationTypeObj) return;
        var total = 0;
        scope.denominationTypeObj.denomTypes.forEach(function (key) {
            var catName = scope.denominationTypeObj.coinTypes[key.group].categoryName;
            var unitValue = scope.getCoinValue(key.group);
            var unitCount = scope.model[catName];
            if (unitCount != null && unitCount !== '') {
                total += unitCount * unitValue;
            }
        });
        scope.model.total = total;
    };

    scope.onAmountFocus = function (catName) {
        scope.activeField = catName;
    };

    scope.onAmountBlur = function () {
        scope.activeField = null;
        scope.syncAmountModel();
    };

    scope.$watch('model', function (newVal, oldVal) {
        scope.syncAmountModel();
        if (scope.coinOnlyBatch) {
            scope.calculateCoinOnlyTotal();
        }
    }, true);
    scope.$watch('amountToggle', scope.syncAmountModel);
    scope.$watch('denominationTypeObj', scope.syncAmountModel, true);

    scope.onAmountChange = function (catName, group) {
        var unitValue = parseFloat(scope.getCoinValue(group));
        var amtStr = scope.amountModel[catName];

        if (amtStr !== null && amtStr !== undefined && amtStr !== '') {
            var val = parseFloat(amtStr);
            if (!isNaN(val) && unitValue > 0) {
                var remainder = Math.abs(val / unitValue - Math.round(val / unitValue));
                if (remainder < 0.0001) {
                    scope.model[catName] = Math.round(val / unitValue);
                    if (scope.model.amountErrors) delete scope.model.amountErrors[catName];
                } else {
                    scope.model[catName] = null;
                    if (!scope.model.amountErrors) scope.model.amountErrors = {};
                    scope.model.amountErrors[catName] = true;
                }
            } else {
                scope.model[catName] = null;
                if (!scope.model.amountErrors) scope.model.amountErrors = {};
                scope.model.amountErrors[catName] = true;
            }
        } else {
            scope.model[catName] = null;
            if (scope.model.amountErrors) delete scope.model.amountErrors[catName];
        }
    };
};

exports.default = link;

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return function (routeIds, shipmentRecord) {
        if (!routeIds || !shipmentRecord) {
            return [];
        }

        if (!shipmentRecord.refId || !shipmentRecord.trackingId || typeof shipmentRecord.total !== 'number' || shipmentRecord.total < 0) {
            return [];
        } else {
            return routeIds.slice();
        }
    };
};

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billable_eventsAll = __webpack_require__(2791);

var _billable_eventsAll2 = _interopRequireDefault(_billable_eventsAll);

var _billable_eventsAll3 = __webpack_require__(2080);

var _billable_eventsAll4 = _interopRequireDefault(_billable_eventsAll3);

__webpack_require__(3068);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billableEventsAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _billable_eventsAll2.default,
    controller: _billable_eventsAll4.default
};

exports.default = billableEventsAllComponent;

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _billable_eventsBase = __webpack_require__(272);

var _billable_eventsBase2 = _interopRequireDefault(_billable_eventsBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillableEventsAllController = function () {
    /*@ngInject*/
    BillableEventsAllController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "BillableEventsService"];
    function BillableEventsAllController(Auth, User, $state, $translate, $stateParams, $location, Modal, BillableEventsService) {
        (0, _classCallCheck3.default)(this, BillableEventsAllController);

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.BillableEventsService = BillableEventsService;

        this.model = {
            billableEventObj: {
                totalRecords: 0,
                eventList: [],
                loading: false
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            allowOnlyOnce: false,
            errorMessage: '',
            branchId: User.getUser().branchId,
            searchText: ''
            // billingCategoryObj: {
            //     TRANSPORT: 'Transport',
            //     DEPOSIT: 'Deposit',
            //     CHANGE_ORDER: 'Change Order'
            // }
        };
    }

    (0, _createClass3.default)(BillableEventsAllController, [{
        key: "$onInit",
        value: function $onInit() {
            this.loadData();
        }
    }, {
        key: "searchObj",
        value: function searchObj() {
            var obj = {
                queryJSON: {
                    rules: [{
                        group: {
                            rules: [{
                                field: 'type',
                                condition: 'like',
                                data: '%' + this.model.searchText + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };
            return obj.queryJSON.rules.length ? obj : null;
        }
    }, {
        key: "loadAllEvents",
        value: function loadAllEvents() {
            var _this = this;

            this.model.billableEventObj.loading = true;

            this.BillableEventsService.all(this.searchObj(), (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit).then(function (data) {
                _this.model.billableEventObj.eventList = data.results;
                _this.model.billableEventObj.totalRecords = data.total;
            }).catch(function (err) {
                _this.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this.model.billableEventObj.loading = false;
            });
        }
    }, {
        key: "pageChange",
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.model.pagination.page);
            this.$stateParams.page = this.model.pagination.page;
            this.$location.path(newUrl);
            this.loadAllEvents();
        }
    }, {
        key: "delete",
        value: function _delete(event) {
            var _this2 = this;

            if (this.model.allowOnlyOnce) return;
            this.model.allowOnlyOnce = true;

            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_delete_title'),
                message: this.$translate.instant('billableEvents.billable_event_info_message', { billingEvent: "<b>(" + this.translateMessage(event.type) + ")</b>" }),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    $scope.loading = false;
                    return _this2.BillableEventsService.remove(event.id, event.billingCategory.name, _this2.translateMessage(event.type), _this2.model.branchId).then(function () {
                        _this2.loadData();
                    }).catch(function (err) {
                        _this2.Modal.errorModal(err.data.message);
                    }).finally(function () {
                        _this2.model.allowOnlyOnce = false;
                        modal.close();
                    });
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    _this2.model.allowOnlyOnce = false;
                    modal.close();
                },
                type: 'danger'
            });
        }
    }, {
        key: "translateMessage",
        value: function translateMessage(key) {
            if (!key) return;
            return this.$translate.instant('entry_type.' + key);
        }
    }, {
        key: "loadData",
        value: function loadData() {
            this.model.pagination.page = 1;
            this.loadAllEvents();
        }
    }, {
        key: "search",
        value: function search() {
            this.pageChange();
        }
    }, {
        key: "edit",
        value: function edit(billableEvent) {
            this.$state.go('billable_events.edit', {
                id: billableEvent.id
            });
        }
    }]);
    return BillableEventsAllController;
}();

exports.default = BillableEventsAllController;

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billable_eventsAll = __webpack_require__(2079);

var _billable_eventsAll2 = _interopRequireDefault(_billable_eventsAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billableEventsAllModule = angular.module('billableEventsAll', []).component('billableEventsAll', _billable_eventsAll2.default).name;

exports.default = billableEventsAllModule;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billable_events = __webpack_require__(2792);

var _billable_events2 = _interopRequireDefault(_billable_events);

var _billable_events3 = __webpack_require__(2083);

var _billable_events4 = _interopRequireDefault(_billable_events3);

__webpack_require__(3069);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billableEventsComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _billable_events2.default,
    controller: _billable_events4.default
};

exports.default = billableEventsComponent;

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTBillingBase2 = __webpack_require__(108);

var _TNTBillingBase3 = _interopRequireDefault(_TNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillableEventsController = function (_TNTBillingBase) {
  BillableEventsController.$inject = ["$state"];
  (0, _inherits3.default)(BillableEventsController, _TNTBillingBase);

  /*@ngInject*/
  function BillableEventsController($state) {
    (0, _classCallCheck3.default)(this, BillableEventsController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BillableEventsController.__proto__ || (0, _getPrototypeOf2.default)(BillableEventsController)).call(this));

    _this.$state = $state;
    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'billable_events';
    return _this;
  }

  (0, _createClass3.default)(BillableEventsController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(BillableEventsController.prototype.__proto__ || (0, _getPrototypeOf2.default)(BillableEventsController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_billing_' + this.id]) {
        this.hasACL[this.acl['tnt_billing_' + this.id][key]] = true;
      }
    }
  }]);
  return BillableEventsController;
}(_TNTBillingBase3.default); // import AppConstants from "../../../../../config/app.constants";

exports.default = BillableEventsController;

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billable_eventsCreate = __webpack_require__(2793);

var _billable_eventsCreate2 = _interopRequireDefault(_billable_eventsCreate);

var _billable_eventsCreate3 = __webpack_require__(2085);

var _billable_eventsCreate4 = _interopRequireDefault(_billable_eventsCreate3);

__webpack_require__(3070);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billableEventsCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _billable_eventsCreate2.default,
    controller: _billable_eventsCreate4.default
};

exports.default = billableEventsCreateComponent;

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _billable_eventsBase = __webpack_require__(272);

var _billable_eventsBase2 = _interopRequireDefault(_billable_eventsBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillableEventsCreateController = function (_BillableEventsBaseCo) {
    BillableEventsCreateController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "BillableEventsService"];
    (0, _inherits3.default)(BillableEventsCreateController, _BillableEventsBaseCo);

    /*@ngInject*/
    function BillableEventsCreateController(Auth, User, $state, $translate, $stateParams, $location, Modal, BillableEventsService) {
        (0, _classCallCheck3.default)(this, BillableEventsCreateController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BillableEventsCreateController.__proto__ || (0, _getPrototypeOf2.default)(BillableEventsCreateController)).call(this, Auth, $state, User, BillableEventsService, Modal, $translate, $stateParams));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.Modal = Modal;
        _this.BillableEventsService = BillableEventsService;

        _this.defaultModel = {
            entryTypeObj: {
                totalRecords: 0,
                entryTypes: [],
                loading: false
            },
            isCreate: false,
            branchId: User.getUser().branchId,
            entryType: null,
            billingCategory: null,
            description: null,
            errorMessage: '',
            billingCategoryObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            billableEventObj: {
                totalRecords: 0,
                eventList: [],
                loading: false
            },
            generalLedgerCode: null,
            createdByOptions: null,
            inventoryType: null
        };
        _this.model = angular.copy(_this.defaultModel);
        _this.billableEventList = [{
            label: 'Pre Bill',
            value: 'pre-bill'
        }, {
            label: 'Post Bill',
            value: 'post-bill'
        }, {
            label: 'Shipment Delivery',
            value: 'shipment-delivered'
        }, {
            label: 'Shipment Pickup',
            value: 'shipment-pickup'
        }, {
            label: 'ATM Load Service',
            value: 'atm-load-service'
        }, {
            label: 'ATM Residual Count',
            value: 'atm-residual-count'
        }, {
            label: 'ATM Order Pack',
            value: 'atm-order-pack'
        }, {
            label: 'ATM Residual Deposit',
            value: 'atm-residual-deposit'
        }, {
            label: 'Delivery Order Pack',
            value: 'delivery-order-pack'
        }, {
            label: 'Pickup Deposit',
            value: 'pickup-deposit'
        }, {
            label: 'Service Ticket Completed',
            value: 'service-ticket-completed'
        }, {
            label: 'Part Charge',
            value: 'part-charge'
        }, {
            label: 'ATM Deposit Pickup',
            value: 'atm-deposit-pickup'
        }, {
            label: 'ATM Deposit Count',
            value: 'atm-deposit-count'
        }, {
            label: 'ATM Load Can\'t',
            value: 'atm-load-cant'
        }, {
            label: 'Shipment Delivery Can\'t',
            value: 'shipment-delivery-cant'
        }, {
            label: 'Coin Pickup',
            value: 'coin-pickup'
        }, {
            label: 'Coin Delivery',
            value: 'coin-delivery'
        }, {
            label: 'Service Ticket Incomplete',
            value: 'service-ticket-incomplete'
        }, {
            label: 'Service Ticket Cancelled',
            value: 'service-ticket-cancelled'
        }, {
            label: 'ATM Cash Delivery',
            value: 'atm-cash-delivery'
        }, {
            label: 'ATM Cash Pickup',
            value: 'atm-cash-pickup'
        }, {
            label: 'Deposit Count',
            value: 'deposit-count'
        }, {
            label: 'Stop Completed',
            value: 'stop-completed'
        }, {
            label: 'Coin Conversion',
            value: 'coin-conversion'
        }, {
            label: 'Order Create',
            value: 'order-create'
        }];
        _this.createdByOptions = [{ label: 'Customer User', value: 'CUSTOMER_USER' }, { label: 'Web User', value: 'WEB_USER' }];
        _this.inventoryTypeOptions = [{ label: 'Regular', value: 'REGULAR' }, { label: 'Emergency', value: 'EMERGENCY' }];
        return _this;
    }

    (0, _createClass3.default)(BillableEventsCreateController, [{
        key: "$onInit",
        value: function $onInit() {
            this.loadData();
            this.getBillingCategory('', 0);
        }

        // getAllEntryTypes(searchKey, offset) {
        //     searchKey = searchKey || '';

        //     this.model.entryTypeObj.loading = true;
        //     this.Service.getAllEntryTypes(searchKey, AppConstants.defaultPageLimit, offset)
        //         .then((data) => {
        //             if (offset === 0 || offset == undefined) {
        //                 this.model.entryTypeObj.totalRecords = data.total;
        //                 this.model.entryTypeObj.entryTypes = this.eventMap(data.results);
        //             }
        //             else {
        //                 const entryTypes = this.eventMap(data.results);
        //                 this.model.entryTypeObj.entryTypes = this.model.entryTypeObj.entryTypes.concat(entryTypes);
        //             }
        //         })
        //         .catch((err) => {
        //             this.Modal.errorModal(err.data.message);
        //         })
        //         .finally(() => {
        //             this.model.entryTypeObj.loading = false;
        //         })
        // }

        // eventMap(events) {
        //     return events.map((data) => {
        //         return {
        //             Key: this.translateMessage(data.entryType),
        //             Value: data.entryType
        //         }
        //     });
        // }

    }, {
        key: "eventMap",
        value: function eventMap(events) {
            var _this2 = this;

            return events.map(function (data) {
                return {
                    Key: _this2.translateMessage(data.value),
                    Value: data.value
                };
            });
        }
    }, {
        key: "isOrderCreateEvent",
        value: function isOrderCreateEvent() {
            return this.model.entryType && this.model.entryType.Value === 'order-create';
        }
    }, {
        key: "submit",
        value: function submit() {
            var _this3 = this;

            this.model.isCreate = true;
            delete this.model.errorMessage;

            this.Service.create({
                type: this.model.entryType.Value,
                billingCategoryId: this.model.billingCategory.Value,
                description: this.model.description,
                branchId: this.model.branchId,
                event: this.model.entryType.Key,
                createdBy: this.model.createdBy,
                inventoryType: this.model.inventoryType,
                generalLedgerCode: this.model.generalLedgerCode
            }).then(function () {
                _this3.askCreate().then(function () {
                    return _this3.loadData();
                });
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this3.model.errorMessage = e.message;
                });
            }).finally(function () {
                _this3.model.isCreate = false;
            });
        }
    }, {
        key: "translateMessage",
        value: function translateMessage(key) {
            if (!key) return;
            return this.$translate.instant('entry_type.' + key);
        }
    }, {
        key: "loadData",
        value: function loadData() {
            this.loadAllEvents();
        }
    }, {
        key: "reset",
        value: function reset() {
            // this.model = angular.copy(this.defaultModel);
            this.model.entryType = null;
            this.model.billingCategory = null;
            this.model.description = null;
            this.model.createdBy = null;
            this.model.inventoryType = null;
            this.model.errorMessage = '';
            this.clearErrors();
        }
    }, {
        key: "getBillingCategory",
        value: function getBillingCategory(searchKey, offset) {
            var _this4 = this;

            searchKey = searchKey || '';

            this.model.billingCategoryObj.loading = true;
            this.Service.getBillingCategory(searchKey, _app2.default.defaultPageLimit, offset).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this4.model.billingCategoryObj.totalRecords = data.total;
                    _this4.model.billingCategoryObj.results = _this4.billingCategoryMap(data.results);
                } else {
                    var results = _this4.billingCategoryMap(data.results);
                    _this4.model.billingCategoryObj.results = _this4.model.billingCategoryObj.results.concat(results);
                }
            }).catch(function (err) {
                _this4.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this4.model.billingCategoryObj.loading = false;
            });
        }
    }, {
        key: "billingCategoryMap",
        value: function billingCategoryMap(events) {
            return events.map(function (data) {
                return {
                    Key: data.categoryName,
                    Value: data.billingCategoryId
                };
            });
        }
    }, {
        key: "loadAllEvents",
        value: function loadAllEvents() {
            var _this5 = this;

            this.model.billableEventObj.loading = true;

            this.BillableEventsService.all(null, 0, 100).then(function (data) {
                _this5.model.billableEventObj.eventList = data.results;
                _this5.model.billableEventObj.totalRecords = data.total;

                var _loop = function _loop(i) {
                    _this5.billableEventList = _this5.billableEventList.filter(function (item) {
                        return _this5.model.billableEventObj.eventList[i].type != item.value;
                    });
                };

                for (var i = 0; i < _this5.model.billableEventObj.totalRecords; i++) {
                    _loop(i);
                }

                _this5.model.entryTypeObj.totalRecords = _this5.billableEventList.length;
                _this5.model.entryTypeObj.entryTypes = _this5.eventMap(_this5.billableEventList);
            }).catch(function (err) {
                _this5.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this5.model.billableEventObj.loading = false;
            });
        }
    }]);
    return BillableEventsCreateController;
}(_billable_eventsBase2.default);

exports.default = BillableEventsCreateController;

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billable_eventsCreate = __webpack_require__(2084);

var _billable_eventsCreate2 = _interopRequireDefault(_billable_eventsCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billableEventsCreateModule = angular.module('billableEventsCreate', []).component('billableEventsCreate', _billable_eventsCreate2.default).name;

exports.default = billableEventsCreateModule;

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billable_eventsEdit = __webpack_require__(2794);

var _billable_eventsEdit2 = _interopRequireDefault(_billable_eventsEdit);

var _billable_eventsEdit3 = __webpack_require__(2088);

var _billable_eventsEdit4 = _interopRequireDefault(_billable_eventsEdit3);

__webpack_require__(3071);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billableEventsEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _billable_eventsEdit2.default,
    controller: _billable_eventsEdit4.default
};

exports.default = billableEventsEditComponent;

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _billable_eventsBase = __webpack_require__(272);

var _billable_eventsBase2 = _interopRequireDefault(_billable_eventsBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillableEventsEditController = function (_BillableEventsBaseCo) {
    BillableEventsEditController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "BillableEventsService", "$q"];
    (0, _inherits3.default)(BillableEventsEditController, _BillableEventsBaseCo);

    /*@ngInject*/
    function BillableEventsEditController(Auth, User, $state, $translate, $stateParams, $location, Modal, BillableEventsService, $q) {
        (0, _classCallCheck3.default)(this, BillableEventsEditController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BillableEventsEditController.__proto__ || (0, _getPrototypeOf2.default)(BillableEventsEditController)).call(this, Auth, $state, User, BillableEventsService, Modal, $translate, $stateParams));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.Modal = Modal;
        _this.BillableEventsService = BillableEventsService;
        _this.$q = $q;

        _this.defaultModel = {
            isUpdating: false,
            branchId: User.getUser().branchId,
            entryType: null,
            billingCategory: null,
            description: null,
            errorMessage: '',
            billingCategoryObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            generalLedgerCode: null,
            isOrderCreate: false,
            createdBy: null,
            inventoryType: null
        };
        _this.createdByOptions = [{ label: 'Customer User', value: 'CUSTOMER_USER' }, { label: 'Web User', value: 'WEB_USER' }];
        _this.inventoryTypeOptions = [{ label: 'Regular', value: 'REGULAR' }, { label: 'Emergency', value: 'EMERGENCY' }];
        _this.model = angular.copy(_this.defaultModel);
        return _this;
    }

    (0, _createClass3.default)(BillableEventsEditController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this2 = this;

            this.$q.all([this.Service.get(this.$stateParams.id), this.getBillingCategory('', 0)]).then(function (data) {
                _this2.defaultModel = data[0];
                _this2.rawId = data[0].id;
                _this2.model.id = data[0].id;
                _this2.model.entryType = _this2.translateMessage(data[0].type);
                _this2.model.description = data[0].description;
                _this2.model.isOrderCreate = data[0].type === 'order-create';
                _this2.model.inventoryType = data[0].inventoryType;
                _this2.model.createdBy = data[0].createdBy;
                if (data[0].billingCategoryId) {
                    data[0].billingCategory.Key = data[0].billingCategory.name;
                    data[0].billingCategory.Value = data[0].billingCategory.id;
                }
                _this2.model.billingCategory = data[0].billingCategory;
                _this2.model.generalLedgerCode = data[0].generalLedgerCode;
            });
        }
    }, {
        key: "reset",
        value: function reset() {
            this.model.billingCategory = this.defaultModel.billingCategory;
            this.model.description = this.defaultModel.description;
            this.model.createdBy = this.defaultModel.createdBy;
            this.model.inventoryType = this.defaultModel.inventoryType;
            // this.model = angular.copy(this.defaultModel);
        }
    }, {
        key: "update",
        value: function update() {
            var _this3 = this;

            this.model.isUpdating = true;
            delete this.model.errorMessage;

            this.Service.update(this.$stateParams.id, {
                event: this.model.entryType,
                billingCategoryId: this.model.billingCategory.Value,
                description: this.model.description,
                branchId: this.model.branchId,
                generalLedgerCode: this.model.generalLedgerCode,
                createdBy: this.model.createdBy,
                inventoryType: this.model.inventoryType
            }).then(function () {
                window.history.go(-1);
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this3.model.errorMessage = e.message;
                });
            }).finally(function () {
                _this3.model.isUpdating = false;
            });
        }
    }, {
        key: "translateMessage",
        value: function translateMessage(key) {
            if (!key) return;
            return this.$translate.instant('entry_type.' + key);
        }
    }, {
        key: "getBillingCategory",
        value: function getBillingCategory(searchKey, offset) {
            var _this4 = this;

            searchKey = searchKey || '';

            this.model.billingCategoryObj.loading = true;
            this.Service.getBillingCategory(searchKey, _app2.default.defaultPageLimit, offset).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this4.model.billingCategoryObj.totalRecords = data.total;
                    _this4.model.billingCategoryObj.results = _this4.billingCategoryMap(data.results);
                } else {
                    var results = _this4.billingCategoryMap(data.results);
                    _this4.model.billingCategoryObj.results = _this4.model.billingCategoryObj.results.concat(results);
                }
            }).catch(function (err) {
                _this4.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this4.model.billingCategoryObj.loading = false;
            });
        }
    }, {
        key: "billingCategoryMap",
        value: function billingCategoryMap(events) {
            return events.map(function (data) {
                return {
                    Key: data.categoryName,
                    Value: data.billingCategoryId
                };
            });
        }
    }]);
    return BillableEventsEditController;
}(_billable_eventsBase2.default);

exports.default = BillableEventsEditController;

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billable_eventsEdit = __webpack_require__(2087);

var _billable_eventsEdit2 = _interopRequireDefault(_billable_eventsEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billableEventsEditModule = angular.module('billableEventsEdit', []).component('billableEventsEdit', _billable_eventsEdit2.default).name;

exports.default = billableEventsEditModule;

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billable_events = __webpack_require__(2082);

var _billable_events2 = _interopRequireDefault(_billable_events);

var _all = __webpack_require__(2081);

var _all2 = _interopRequireDefault(_all);

var _create = __webpack_require__(2086);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2089);

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billableEventsModule = angular.module('billableEvents', [_all2.default, _create2.default, _edit2.default]).component('billableEvents', _billable_events2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    'ngInject';

    $stateProvider.state('billable_events.all', {
        url: '/all/:page',
        component: 'billableEventsAll',
        data: {
            requireLogin: true,
            requireACL: 'tnt_billing_billable_events.view'
        }
    }).state('billable_events.create', {
        url: '/create',
        component: 'billableEventsCreate'
        // parent: 'tntBilling',
    }).state('billable_events.edit', {
        url: '/edit/:id',
        component: 'billableEventsEdit'
    });
}]).name;

exports.default = billableEventsModule;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billing_categoryAll = __webpack_require__(2795);

var _billing_categoryAll2 = _interopRequireDefault(_billing_categoryAll);

var _billing_categoryAll3 = __webpack_require__(2092);

var _billing_categoryAll4 = _interopRequireDefault(_billing_categoryAll3);

__webpack_require__(3072);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billingCategoryAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _billing_categoryAll2.default,
    controller: _billing_categoryAll4.default
};

exports.default = billingCategoryAllComponent;

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingCategoryAllController = function () {
    /*@ngInject*/
    BillingCategoryAllController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "BillingCategoryService"];
    function BillingCategoryAllController(Auth, User, $state, $translate, $stateParams, $location, Modal, BillingCategoryService) {
        (0, _classCallCheck3.default)(this, BillingCategoryAllController);

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.BillingCategoryService = BillingCategoryService;

        this.model = {
            billingCategoryObj: {
                totalRecords: 0,
                categoryList: [],
                loading: false
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            allowOnlyOnce: false,
            errorMessage: '',
            branchId: User.getUser().branchId,
            searchText: ''
        };
    }

    (0, _createClass3.default)(BillingCategoryAllController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loadData();
        }
    }, {
        key: 'searchObj',
        value: function searchObj() {
            var obj = {
                queryJSON: {
                    rules: [{
                        group: {
                            rules: [{
                                field: 'name',
                                condition: 'like',
                                data: '%' + this.model.searchText + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };
            return obj.queryJSON.rules.length ? obj : null;
        }
    }, {
        key: 'loadAllCategory',
        value: function loadAllCategory() {
            var _this = this;

            this.model.billingCategoryObj.loading = true;

            this.BillingCategoryService.all(this.searchObj(), (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit).then(function (data) {
                _this.model.billingCategoryObj.categoryList = data.results;
                _this.model.billingCategoryObj.totalRecords = data.total;
            }).catch(function (err) {
                _this.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this.model.billingCategoryObj.loading = false;
            });
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.model.pagination.page);
            this.$stateParams.page = this.model.pagination.page;
            this.$location.path(newUrl);
            this.loadAllCategory();
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            this.model.pagination.page = 1;
            this.loadAllCategory();
        }
    }, {
        key: 'search',
        value: function search() {
            this.pageChange();
        }
    }, {
        key: 'edit',
        value: function edit(billingCategory) {
            this.$state.go('billing_category.edit', {
                id: billingCategory.id
            });
        }
    }]);
    return BillingCategoryAllController;
}();

exports.default = BillingCategoryAllController;

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billing_categoryAll = __webpack_require__(2091);

var _billing_categoryAll2 = _interopRequireDefault(_billing_categoryAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billingCategoryAllModule = angular.module('billingCategoryAll', []).component('billingCategoryAll', _billing_categoryAll2.default).name;

exports.default = billingCategoryAllModule;

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billing_category = __webpack_require__(2796);

var _billing_category2 = _interopRequireDefault(_billing_category);

var _billing_category3 = __webpack_require__(2095);

var _billing_category4 = _interopRequireDefault(_billing_category3);

__webpack_require__(3073);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billingCategoryComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _billing_category2.default,
    controller: _billing_category4.default
};

exports.default = billingCategoryComponent;

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTBillingBase2 = __webpack_require__(108);

var _TNTBillingBase3 = _interopRequireDefault(_TNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingCategoryController = function (_TNTBillingBase) {
    BillingCategoryController.$inject = ["$state"];
    (0, _inherits3.default)(BillingCategoryController, _TNTBillingBase);

    /*@ngInject*/
    function BillingCategoryController($state) {
        (0, _classCallCheck3.default)(this, BillingCategoryController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BillingCategoryController.__proto__ || (0, _getPrototypeOf2.default)(BillingCategoryController)).call(this));

        _this.$state = $state;
        _this.id = "billing_category";
        _this.acl = {};
        _this.hasACL = {};
        return _this;
    }

    (0, _createClass3.default)(BillingCategoryController, [{
        key: "$onInit",
        value: function $onInit() {
            (0, _get3.default)(BillingCategoryController.prototype.__proto__ || (0, _getPrototypeOf2.default)(BillingCategoryController.prototype), "$onInit", this).call(this);
            for (var key in this.acl['tnt_billing_' + this.id]) {
                this.hasACL[this.acl['tnt_billing_' + this.id][key]] = true;
            }
        }
    }]);
    return BillingCategoryController;
}(_TNTBillingBase3.default);

exports.default = BillingCategoryController;

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billing_categoryCreate = __webpack_require__(2797);

var _billing_categoryCreate2 = _interopRequireDefault(_billing_categoryCreate);

var _billing_categoryCreate3 = __webpack_require__(2097);

var _billing_categoryCreate4 = _interopRequireDefault(_billing_categoryCreate3);

__webpack_require__(3074);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billingCategoryCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _billing_categoryCreate2.default,
    controller: _billing_categoryCreate4.default
};

exports.default = billingCategoryCreateComponent;

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _billing_categoryBase = __webpack_require__(527);

var _billing_categoryBase2 = _interopRequireDefault(_billing_categoryBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingCategoryCreateController = function (_BillingCategoryBaseC) {
    BillingCategoryCreateController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "BillingCategoryService"];
    (0, _inherits3.default)(BillingCategoryCreateController, _BillingCategoryBaseC);

    /*@ngInject*/
    function BillingCategoryCreateController(Auth, User, $state, $translate, $stateParams, $location, Modal, BillingCategoryService) {
        (0, _classCallCheck3.default)(this, BillingCategoryCreateController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BillingCategoryCreateController.__proto__ || (0, _getPrototypeOf2.default)(BillingCategoryCreateController)).call(this, Auth, $state, User, BillingCategoryService, Modal, $translate, $stateParams));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.Modal = Modal;
        _this.BillingCategoryService = BillingCategoryService;

        _this.defaultModel = {
            isCreate: false,
            branchId: User.getUser().branchId,
            name: null,
            description: null,
            status: true,
            errorMessage: '',
            generalLedgerCode: null
        };

        _this.model = angular.copy(_this.defaultModel);
        return _this;
    }

    (0, _createClass3.default)(BillingCategoryCreateController, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "submit",
        value: function submit() {
            var _this2 = this;

            this.model.isCreate = true;
            delete this.model.errorMessage;

            this.Service.create({
                name: this.model.name,
                description: this.model.description,
                status: this.model.status,
                branchId: this.model.branchId,
                generalLedgerCode: this.model.generalLedgerCode
            }).then(function () {
                _this2.askCreate();
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this2.model.errorMessage = e.message;
                });
            }).finally(function () {
                _this2.model.isCreate = false;
            });
        }
    }, {
        key: "reset",
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.clearErrors();
        }
    }]);
    return BillingCategoryCreateController;
}(_billing_categoryBase2.default);

exports.default = BillingCategoryCreateController;

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billing_categoryCreate = __webpack_require__(2096);

var _billing_categoryCreate2 = _interopRequireDefault(_billing_categoryCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billingCategoryCreateModule = angular.module('billingCategoryCreate', []).component('billingCategoryCreate', _billing_categoryCreate2.default).name;

exports.default = billingCategoryCreateModule;

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billing_categoryEdit = __webpack_require__(2798);

var _billing_categoryEdit2 = _interopRequireDefault(_billing_categoryEdit);

var _billing_categoryEdit3 = __webpack_require__(2100);

var _billing_categoryEdit4 = _interopRequireDefault(_billing_categoryEdit3);

__webpack_require__(3075);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billingCategoryEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _billing_categoryEdit2.default,
    controller: _billing_categoryEdit4.default
};

exports.default = billingCategoryEditComponent;

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _billing_categoryBase = __webpack_require__(527);

var _billing_categoryBase2 = _interopRequireDefault(_billing_categoryBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingCategoryEditController = function (_BillingCategoryBaseC) {
    BillingCategoryEditController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "BillingCategoryService", "$q"];
    (0, _inherits3.default)(BillingCategoryEditController, _BillingCategoryBaseC);

    /*@ngInject*/
    function BillingCategoryEditController(Auth, User, $state, $translate, $stateParams, $location, Modal, BillingCategoryService, $q) {
        (0, _classCallCheck3.default)(this, BillingCategoryEditController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BillingCategoryEditController.__proto__ || (0, _getPrototypeOf2.default)(BillingCategoryEditController)).call(this, Auth, $state, User, BillingCategoryService, Modal, $translate, $stateParams));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.Modal = Modal;
        _this.BillingCategoryService = BillingCategoryService;
        _this.$q = $q;

        _this.defaultModel = {
            isCreate: false,
            branchId: User.getUser().branchId,
            name: null,
            description: null,
            status: true,
            errorMessage: '',
            generalLedgerCode: null
        };

        _this.model = angular.copy(_this.defaultModel);
        return _this;
    }

    (0, _createClass3.default)(BillingCategoryEditController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this2 = this;

            this.Service.get(this.$stateParams.id).then(function (data) {
                _this2.defaultModel = data;
                _this2.rawId = data.id;
                _this2.model.id = data.id;
                _this2.model.name = data.name;
                _this2.model.description = data.description;
                _this2.model.status = data.status;
                _this2.model.generalLedgerCode = data.generalLedgerCode;
            });
        }
    }, {
        key: "reset",
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
        }
    }, {
        key: "update",
        value: function update() {
            var _this3 = this;

            this.model.isUpdating = true;
            delete this.model.errorMessage;

            this.Service.update(this.$stateParams.id, {
                name: this.model.name,
                description: this.model.description,
                status: this.model.status,
                branchId: this.model.branchId,
                generalLedgerCode: this.model.generalLedgerCode
            }).then(function () {
                window.history.go(-1);
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this3.model.errorMessage = e.message;
                });
            }).finally(function () {
                _this3.model.isUpdating = false;
            });
        }
    }]);
    return BillingCategoryEditController;
}(_billing_categoryBase2.default);

exports.default = BillingCategoryEditController;

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billing_categoryEdit = __webpack_require__(2099);

var _billing_categoryEdit2 = _interopRequireDefault(_billing_categoryEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billingCategoryEditModule = angular.module('billingCategoryEdit', []).component('billingCategoryEdit', _billing_categoryEdit2.default).name;

exports.default = billingCategoryEditModule;

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _billing_category = __webpack_require__(2094);

var _billing_category2 = _interopRequireDefault(_billing_category);

var _all = __webpack_require__(2093);

var _all2 = _interopRequireDefault(_all);

var _create = __webpack_require__(2098);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2101);

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var billingCategoryModule = angular.module('billingCategory', [_all2.default, _create2.default, _edit2.default]).component('billingCategory', _billing_category2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    'ngInject';

    $stateProvider.state('billing_category.all', {
        url: '/all/:page',
        component: 'billingCategoryAll'
    });

    $stateProvider.state('billing_category.create', {
        url: '/create',
        component: 'billingCategoryCreate'
    });

    $stateProvider.state('billing_category.edit', {
        url: '/edit/:id',
        component: 'billingCategoryEdit'
    });
}]).name;

exports.default = billingCategoryModule;

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contractAll = __webpack_require__(2799);

var _contractAll2 = _interopRequireDefault(_contractAll);

var _contractAll3 = __webpack_require__(2104);

var _contractAll4 = _interopRequireDefault(_contractAll3);

__webpack_require__(3076);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _contractAll2.default,
  controller: _contractAll4.default
};

exports.default = contractallComponent;

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _contractBase = __webpack_require__(273);

var _contractBase2 = _interopRequireDefault(_contractBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractallController = function (_ContractBaseControll) {
  ContractallController.$inject = ["Auth", "$state", "User", "Modal", "ContractService", "$translate", "$stateParams", "$scope", "$location", "DataCounter", "Navigation"];
  (0, _inherits3.default)(ContractallController, _ContractBaseControll);

  /*@ngInject*/
  function ContractallController(Auth, $state, User, Modal, ContractService, $translate, $stateParams, $scope, $location, DataCounter, Navigation) {
    (0, _classCallCheck3.default)(this, ContractallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ContractallController.__proto__ || (0, _getPrototypeOf2.default)(ContractallController)).call(this, Auth, $state, User, ContractService, Modal, $translate, $stateParams, $location));

    _this.id = 'contract.all';
    _this.loading = true;
    _this.contracts = [];
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.hasACL = {};
    _this.searchText = '';
    _this._status = 'active';
    _this.$location = $location;
    _this.DataCounter = DataCounter;
    _this.Navigation = Navigation;
    _this.branchId = _this.User.getUser().branchId;
    _this.uncoveredOnCallLocationCount = null;
    _this.uncoveredOnCallLocationCountLoading = false;
    _this.uncoveredOnCallLocationCountError = '';

    _this.contractStatus = [{
      label: $translate.instant('location_types.All'),
      value: null
    }, {
      label: $translate.instant('common.active'),
      value: 'active'
    }, {
      label: $translate.instant('common.inactive'),
      value: 'inactive'
    }];

    _this.customerHistoryObj = {
      totalRecords: 0,
      results: [],
      loading: false,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      allowOnlyOnce: false,
      errorMessage: '',
      searchText: '',
      history: {},
      extraDetails: {}
    };

    _this.sortColumn = '';
    _this.reverseSort = true;
    _this.currentStats = {};

    _this.contractHistoryStats = {
      customers: 'customers'
    };
    return _this;
  }

  (0, _createClass3.default)(ContractallController, [{
    key: '$onInit',
    value: function $onInit() {
      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
      this.loadUncoveredOnCallLocationCount();
    }
  }, {
    key: 'loadUncoveredOnCallLocationCount',
    value: function loadUncoveredOnCallLocationCount() {
      var _this2 = this;

      this.uncoveredOnCallLocationCountLoading = true;
      this.uncoveredOnCallLocationCountError = '';

      this.Service.getUncoveredOnCallLocations(undefined, undefined, true).then(function (data) {
        _this2.uncoveredOnCallLocationCount = data.totalRecords;
      }).catch(function (err) {
        _this2.uncoveredOnCallLocationCountError = err && err.data && err.data.message ? err.data.message : err.message;
      }).finally(function () {
        _this2.uncoveredOnCallLocationCountLoading = false;
      });
    }
  }, {
    key: 'showUncoveredOnCallLocations',
    value: function showUncoveredOnCallLocations() {
      this.Modal.uncoveredLocations();
    }
  }, {
    key: 'edit',
    value: function edit(contract) {
      this.$state.go('contract.edit', {
        id: contract.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(contract) {
      var _this3 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + contract.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this3.Service.remove(contract.id, _this3.branchId).then(function (data) {
            _this3.allowOnlyOnce = false;
            modal.close();
            _this3.refresh();
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this3.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
      this.loadUncoveredOnCallLocationCount();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }

    // generateSearchObj() {
    //   return {
    //     queryText: '%' + this.searchObj + '%',
    //     isQuery: false
    //   };
    // }

  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      var searchObj = {
        queryJSON: {
          rules: [{
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + this.searchText + '%'
              }, {
                field: 'contractName',
                condition: 'like',
                data: '%' + this.searchText + '%'
              }, {
                field: 'billingIncrement',
                condition: 'like',
                data: '%' + this.searchText + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      switch (this._status) {
        case 'active':
          {
            searchObj.queryJSON.rules.push({
              field: 'status',
              condition: '=',
              data: true
            });
            break;
          }
        case 'inactive':
          {
            searchObj.queryJSON.rules.push({
              field: 'status',
              condition: '=',
              data: false
            });
            break;
          }
      }
      return searchObj;
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this4 = this;

      var searchObj = this.generateSearchObj();

      this.loading = true;
      this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this4.total = data.total;
        _this4.loading = false;
        _this4.contracts = data.results;
      }).catch(function (err) {
        _this4.loading = false;
        _this4.error = err.message;
      });
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(contract) {
      contract.expand = !contract.expand;
      this.currentStats[contract.id] = this.contractHistoryStats.customers;
    }
  }, {
    key: 'getCurrentStats',
    value: function getCurrentStats(obj, value) {
      if (!obj.expanded) return;
      this.currentStats[obj.id] = value;
    }

    // ------------------------------------------ Customer history logic section start ------------------------------------------ //

  }, {
    key: 'setCustomerHistoryPage',
    value: function setCustomerHistoryPage(isExpanded, customerId) {
      if (!isExpanded) return;
      this.customerHistoryObj.extraDetails[customerId] = { page: 1 };
    }
  }, {
    key: 'getCustomerHistory',
    value: function getCustomerHistory(data, event) {
      var _this5 = this;

      var customerId = data.id;

      document.getElementById('expand-btn-' + customerId).blur();
      if (!data.expanded) return;

      this.customerHistoryObj.history[customerId] = { process: true };

      this.Service.getCustomerHistory(this.customerHistoryObj.extraDetails[customerId].searchText, customerId, this.reverseSort, this.sortColumn, (this.customerHistoryObj.extraDetails[customerId].page - 1) * this.customerHistoryObj.pagination.pageLimit, this.customerHistoryObj.pagination.pageLimit).then(function (history) {
        _this5.customerHistoryObj.history[customerId].details = history;
        _this5.customerHistoryObj.history[customerId].details.pageLimit = _this5.customerHistoryObj.pagination.pageLimit;
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this5.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this5.customerHistoryObj.history[customerId].process = false;
      });
    }
  }, {
    key: 'sortData',
    value: function sortData(column, obj, event) {
      this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
      this.sortColumn = column;
      this.loadCustomerHistory(obj, event);
    }
  }, {
    key: 'goToLocationTab',
    value: function goToLocationTab(customerObj) {
      var obj = {
        customerId: customerObj.customerId,
        isRedirected: true
      };

      this.DataCounter.setData(obj);
      this.Navigation.goToAllLocationTab();
    }
  }, {
    key: 'goToCustomerTab',
    value: function goToCustomerTab(customerObj) {
      this.$state.go('customer.edit', {
        id: customerObj.customerId
      });
    }
  }, {
    key: 'searchCustomerHistory',
    value: function searchCustomerHistory(data, event) {
      this.customerHistoryObj.extraDetails[data.id].page = 1;
      this.getCustomerHistory(data, event);
    }
  }, {
    key: 'customerHistoryFn',
    value: function customerHistoryFn(obj, event) {
      this.resetSearchText(obj);
      this.getCurrentStats(obj, this.contractHistoryStats.customers);
      this.setCustomerHistoryPage(obj.expanded, obj.id);
      this.loadCustomerHistory(obj, event);
    }
  }, {
    key: 'resetSearchText',
    value: function resetSearchText(obj) {
      var contractId = obj.id;
      this.customerHistoryObj.extraDetails[contractId] = { searchText: '' };
      this.customerHistoryObj.extraDetails[contractId].searchText = '';
    }
  }, {
    key: 'loadCustomerHistory',
    value: function loadCustomerHistory(obj, event) {
      if (this.currentStats[obj.id] === this.contractHistoryStats.customers) this.getCustomerHistory(obj, event);
    }

    // ------------------------------------------ Customer history logic section end ------------------------------------------ //

  }]);
  return ContractallController;
}(_contractBase2.default);

exports.default = ContractallController;

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contractAll = __webpack_require__(2103);

var _contractAll2 = _interopRequireDefault(_contractAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractallModule = angular.module('contractall', []).component('contractall', _contractAll2.default).name;

exports.default = contractallModule;

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contract = __webpack_require__(2800);

var _contract2 = _interopRequireDefault(_contract);

var _contract3 = __webpack_require__(2107);

var _contract4 = _interopRequireDefault(_contract3);

__webpack_require__(3077);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _contract2.default,
  controller: _contract4.default
};

exports.default = contractComponent;

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTBillingBase2 = __webpack_require__(108);

var _TNTBillingBase3 = _interopRequireDefault(_TNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractController = function (_TNTBillingBase) {
  ContractController.$inject = ["$state"];
  (0, _inherits3.default)(ContractController, _TNTBillingBase);

  /*@ngInject*/
  function ContractController($state) {
    (0, _classCallCheck3.default)(this, ContractController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ContractController.__proto__ || (0, _getPrototypeOf2.default)(ContractController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'contract';
    _this.$state = $state;

    return _this;
  }

  (0, _createClass3.default)(ContractController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(ContractController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ContractController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_billing_contract']) {
        this.hasACL[this.acl['tnt_billing_contract'][key]] = true;
      }
    }
  }]);
  return ContractController;
}(_TNTBillingBase3.default);

exports.default = ContractController;

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contractCreate = __webpack_require__(2801);

var _contractCreate2 = _interopRequireDefault(_contractCreate);

var _contractCreate3 = __webpack_require__(2109);

var _contractCreate4 = _interopRequireDefault(_contractCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _contractCreate2.default,
  controller: _contractCreate4.default
};

exports.default = contractcreateComponent;

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _contractBase = __webpack_require__(273);

var _contractBase2 = _interopRequireDefault(_contractBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import ServiceOptionController from '../../customer/common/service_options/service_option.controller';

var ContractCreateController = function (_ContractBaseControll) {
	ContractCreateController.$inject = ["Auth", "$state", "User", "ContractService", "Modal", "$translate", "$scope", "$timeout", "$filter", "BillableEventsService", "CommonLayoutService", "LocationDistanceService", "DateUtil", "ContractTypeService"];
	(0, _inherits3.default)(ContractCreateController, _ContractBaseControll);

	/*@ngInject*/
	function ContractCreateController(Auth, $state, User, ContractService, Modal, $translate, $scope, $timeout, $filter, BillableEventsService, CommonLayoutService, LocationDistanceService, DateUtil, ContractTypeService) {
		(0, _classCallCheck3.default)(this, ContractCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (ContractCreateController.__proto__ || (0, _getPrototypeOf2.default)(ContractCreateController)).call(this, Auth, $state, User, ContractService, Modal, $translate, $scope, $timeout));

		_this.isDisabledDate = function (currentDate, mode) {
			if (this.model.contractEndDate !== null) {
				if (this.model.contractStartDate > this.model.contractEndDate) {
					this.model.contractEndDate = this.model.contractStartDate;
				} else if (this.model.contractStartDate == null) {
					this.model.contractEndDate = null;
				}
			}
			this.startMinDate = {
				minDate: this.model.contractStartDate
			};
			this.contractDatesChanged();
		};

		_this.$scope = $scope;
		_this.DateUtil = DateUtil;
		_this.defaultModel = {
			contractId: '',
			contractName: '',
			status: true,
			selectedBillingDuration: '',
			description: '',
			contractStartDate: null,
			contractEndDate: null,
			useCustomerOnBillingRules: false,
			bailmentInterest: null,
			contractTypeId: '',
			locationList: [],
			customerObj: {
				loading: false,
				totalRecords: 0,
				results: [],
				pagination: {
					page: 1,
					total: 0,
					pageLimit: 10,
					maxPages: 10
				}
			},
			contractTypeObj: {
				loading: false,
				totalRecords: 0,
				results: [],
				pagination: {
					page: 1,
					total: 0,
					pageLimit: 10,
					maxPages: 10
				}
			}
		};

		_this.model = angular.copy(_this.defaultModel);
		_this.billingIncrementList = [{ label: _this.$translate.instant('contract.daily'), value: 'DAILY' }, { label: _this.$translate.instant('contract.weekly'), value: 'WEEKLY' }, { label: _this.$translate.instant('contract.bi_weekly'), value: 'BI_WEEKLY' }, { label: _this.$translate.instant('contract.monthly'), value: 'MONTHLY' }, { label: _this.$translate.instant('contract.quarterly'), value: 'QUARTERLY' }, { label: _this.$translate.instant('contract.annually'), value: 'ANNUALLY' }];

		_this.branchId = _this.User.getUser().branchId;
		_this.contractRules = [];
		_this.billingRulesOptions = [];
		_this.showAllFlag = false;
		_this.$filter = $filter;
		_this.BillableEventsService = BillableEventsService;
		_this.CommonLayoutService = CommonLayoutService;
		_this.LocationDistanceService = LocationDistanceService;
		_this.ContractTypeService = ContractTypeService;
		_this.loggedInUserId = _this.User.getUser().id;
		// this.billingEventOptions = [
		// 	{
		// 		label: 'Shipment Delivery',
		// 		value: 'shipment-delivered'
		// 	},
		// 	{
		// 		label: 'Shipment Pickup',
		// 		value: 'shipment-pickup'
		// 	},
		// 	{
		// 		label: 'ATM Load Service',
		// 		value: 'atm-load-service'
		// 	},
		// 	{
		// 		label: 'ATM Residual Count',
		// 		value: 'atm-residual-count'
		// 	},
		// 	{
		// 		label: 'ATM Order Pack',
		// 		value: 'atm-order-pack'
		// 	},
		// 	{
		// 		label: 'ATM Residual Deposit',
		// 		value: 'atm-residual-deposit'
		// 	},
		// 	{
		// 		label: 'Delivery Order Pack',
		// 		value: 'delivery-order-pack'
		// 	},
		// 	{
		// 		label: 'Pickup Deposit',
		// 		value: 'pickup-deposit'
		// 	},
		// 	{
		// 		label: 'Service Ticket Completed',
		// 		value: 'service-ticket-completed'
		// 	},
		// 	{
		// 		label: 'Part Charge',
		// 		value: 'part-charge'
		// 	}
		// ];

		_this.locationTypeOptions = {
			'ATM': [{
				label: 'ATM',
				value: 'atm'
			}],
			'other': [{
				label: 'Any',
				value: 'any'
			}, {
				label: 'Unscheduled',
				value: 'unscheduled'
			}, {
				label: 'Regular',
				value: 'regular'
			}, {
				label: 'NSNG',
				value: 'nsng'
			}, {
				label: 'On Call',
				value: 'on_call'
			}, {
				label: 'Bank',
				value: 'bank'
			}]
		};

		_this.serviceTypeOptions = {
			'regular': [{
				label: 'Scheduled',
				value: 'regular'
			}],
			'flm': [{
				label: 'FLM',
				value: 'flm'
			}],
			'slm': [{
				label: 'SLM',
				value: 'slm'
			}],
			'other': [{
				label: 'Any',
				value: 'any'
			}, {
				label: 'Unscheduled',
				value: 'unscheduled'
			}, {
				label: 'Scheduled',
				value: 'regular'
			}],
			'atmLoad': [{
				label: 'Any',
				value: 'any'
			}, {
				label: 'Unscheduled',
				value: 'unscheduled'
			}, {
				label: 'Scheduled',
				value: 'regular'
			}, {
				label: 'Emergency',
				value: 'emergency'
			}],
			'none': [{
				label: 'none',
				value: 'none'
			}]
		};

		_this.scheduleTypeOptions = [{
			label: 'Any',
			value: 'any'
		}, {
			label: 'Scheduled',
			value: 'scheduled'
		}, {
			label: 'Unscheduled',
			value: 'unscheduled'
		}];

		_this.orderTypeOptions = {
			'cash_coin': [{
				label: 'Cash & Coin',
				value: 'cash_and_coin'
			}],
			'cash_only': [{
				label: 'Cash',
				value: 'cash'
			}],
			'coin_only': [{
				label: 'Coin',
				value: 'coin'
			}],
			'ATM': [{
				label: 'ATM-Any',
				value: 'atm_any'
			}, {
				label: 'ATM-Add',
				value: 'atm_add'
			}, {
				label: 'ATM-Swap',
				value: 'atm_swap'
			}, {
				label: 'ATM-ICL',
				value: 'atm_icl'
			}, {
				label: 'ATM-CCL',
				value: 'atm_ccl'
			}, {
				label: 'ATM-Recash',
				value: 'atm_recash'
			}, {
				label: 'ATM-Decash',
				value: 'atm_decash'
			}],
			'services': [{
				label: 'Service Order',
				value: 'service_order'
			}],
			'other': [{
				label: 'none',
				value: 'none'
			}]
		};

		_this.billingTypeOptions = _this.CommonLayoutService.billingTypeOptions();
		_this.serviceTimeOptions = _this.CommonLayoutService.serviceTimeTypes();
		_this.serviceTimeTypes = _this.CommonLayoutService.serviceTimeTypes();
		_this.disableOtherOptions = {};
		_this.disableScheduleTypeOptions = {};
		_this.showBillingWarning = false;
		_this.stats = {
			pre: 'PRE',
			post: 'POST'
		};

		_this.allowScheduleTypeBillingEvents = ['atm-deposit-count', 'delivery-order-pack', 'service-ticket-cancelled', 'service-ticket-incomplete', 'atm-residual-deposit', 'atm-order-pack', 'atm-residual-count', 'part-charge', 'service-ticket-completed', 'residual-deposit', 'pickup-deposit', 'order-packing-pack', 'atm-service'];
		_this.requiredStartDate = false;
		_this.requiredStartDateErrorMsg = 'As this contract does not have a start date, it will not generate pre/post bill records if any pre/post bill rules are defined.';

		_this.contractLocationListObj = {
			pagination: {
				page: 1,
				total: 0,
				pageLimit: 200,
				maxPages: 10
			}
		};

		_this.contractRulesStatus = {
			active: true,
			suspended: false
		};

		_this.staticBillingEvents = ['pre-bill', 'post-bill'];
		return _this;
	}

	(0, _createClass3.default)(ContractCreateController, [{
		key: '$onInit',
		value: function $onInit() {
			this.getBillableEvents();
			this.locationDistanceList();
			this.getContractLocationList();
			this.getCustomerList();
			this.getContractTypeList('', 0);
			this.startDateErrorMessage = this.requiredStartDateErrorMsg;
			this.startMaxDate = {
				minDate: new Date()
			};
			this.ruleStartDateOptions = (0, _extends3.default)({
				minDate: moment(this.model.contractStartDate || new Date())
			}, this.model.contractEndDate && { maxDate: moment(this.model.contractEndDate) });
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.model = angular.copy(this.defaultModel);
			this.contractRules = [];
			this.billingRulesOptions = [];
			this.requiredStartDate = false;
			this.clearErrors();
			this.model.locationList = this.cloneContractLocationListLObj.locationList;
			this.model.totalLocations = this.cloneContractLocationListLObj.totalLocations;
			this.model.customerObj.totalRecords = this.cloneCustomerListLObj.totalCustomers;
			this.model.customerObj.results = this.cloneCustomerListLObj.customerList;
			this.model.contractTypeId = this.model.contractType;
			this.getContractTypeList('', 0);
			this.locationDistanceList();
			this.contractDatesChanged();
		}
	}, {
		key: 'isBailmentInterestValid',
		value: function isBailmentInterestValid() {
			var bailmentInterestRegex = /^(?:100(?:\.0{1,2})?|([1-9][0-9]?|0)(?:\.[0-9]{1,2})?)%?$/;
			return this.model.bailmentInterest === null || this.model.bailmentInterest === '' || bailmentInterestRegex.test(this.model.bailmentInterest);
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this2 = this;

			setTimeout(function () {
				_this2.generateBillingRules('value');
				_this2.Service.create({
					id: _this2.model.contractId,
					contractName: _this2.model.contractName,
					status: _this2.model.status,
					billingIncrement: _this2.model.selectedBillingDuration,
					description: _this2.model.description,
					contractRules: _this2.contractRules,
					contractStartDate: _this2.model.contractStartDate ? moment(_this2.model.contractStartDate).format('YYYY-MM-DD') : null,
					contractEndDate: _this2.model.contractEndDate ? moment(_this2.model.contractEndDate).format('YYYY-MM-DD') : null,
					useCustomerOnBillingRules: _this2.model.useCustomerOnBillingRules,
					createdByUserId: _this2.loggedInUserId,
					modifiedByUserId: _this2.loggedInUserId,
					bailmentInterest: _this2.model.bailmentInterest ? _this2.convertStr(_this2.model.bailmentInterest) : null,
					contractTypeId: _this2.model.contractTypeId ? _this2.model.contractTypeId.Value : null
				}, _this2.branchId).then(function (data) {
					_this2.askCreate().then(function () {
						_this2.contractRules = [];
					});
				}).catch(function (err) {
					if (err.data.errors) {
						err.data.errors.map(function (e) {
							_this2.errorMessage += e.message + ',';
						});
					} else {
						_this2.errorMessage = err.data.message;
					}
				}).finally(function () {
					_this2.loading = false;
				});
			}, 200);
		}
	}, {
		key: 'selectBillingIncrement',
		value: function selectBillingIncrement(obj) {
			this.model.selectedBillingDuration = obj.value;
		}

		// billingContractRulesModal(data) {
		// 	this.Modal.billingContractRulesModal(data, false, this.model.contractRules = this.generateContractRules(), ({ contractRulesOptions, modal }) => {
		// 		contractRulesOptions.forEach((rules) => {
		// 			this.contractRules.push(rules);
		// 		})
		// 		modal.close();
		// 	}, ({ modal }) => {
		// 		if (modal) modal.close();
		// 	})
		// }

		// editBillingContract(data, index) {
		// 	this.Modal.billingContractRulesModal(data, false, this.model.contractRules = this.generateContractRules(), ({ contractRulesOptions, modal }) => {
		// 		this.contractRules.splice(index, 1);
		// 		contractRulesOptions.forEach((rules) => {
		// 			this.contractRules.splice(index, 0, rules);
		// 		})
		// 		modal.close();
		// 	}, ({ modal }) => {
		// 		if (modal) modal.close();
		// 	})
		// }

	}, {
		key: 'getTime',
		value: function getTime(time) {
			var billingType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			if (!time) {
				return time;
			}

			time = moment(time).format('HH:mm:ss');

			time = time.split(':');

			var d = new Date();

			d.setHours(+time[0]);
			d.setMinutes(time[1]);
			d.setSeconds(time[2]);
			// d.setMilliseconds(0);
			var timeFormat = billingType == 'service_ticket_overage_time_charge' ? 'HH:mm:ss' : '00:mm:ss';
			return moment(d).format(timeFormat);
		}

		// generateContractRules() {
		// 	if (!this.contractRules.length) return [];
		// 	const rules = [];

		// 	this.contractRules.forEach((obj) => {
		// 		rules.push({
		// 			billingEvent: obj.billingEvent.key,
		// 			locationType: obj.locationType.value,
		// 			orderType: obj.orderType.value,
		// 			billingType: obj.billingTypeObj.billingType.value,
		// 			minQty: obj.billingTypeObj.min || null,
		// 			maxQty: obj.billingTypeObj.max || null,
		// 			minAmount: obj.billingTypeObj.minAmount || null,
		// 			maxAmount: obj.billingTypeObj.maxAmount || null,
		// 			beginTime: obj.billingTypeObj.beginTime ? moment(obj.billingTypeObj.beginTime).format('00:mm:ss') : null,
		// 			endTime: obj.billingTypeObj.endTime ? moment(obj.billingTypeObj.endTime).format('00:mm:ss') : null,
		// 			billingRate: obj.billingRateObj.rate,
		// 			currencyId: obj.billingRateObj.currency
		// 		})
		// 	})
		// 	return rules;
		// }

	}, {
		key: 'addBillingRules',
		value: function addBillingRules(event) {
			this.billingRulesOptions.push({
				name: null,
				description: null,
				generalLedgerCode: null,
				status: true,
				isValidBillingRules: false,
				billingEventObj: {
					billingEvent: null,
					billingEventOptions: null,
					preBillingEventOptions: _.cloneDeep(this.preBillingEventOptions),
					postBillingEventOptions: _.cloneDeep(this.postBillingEventOptions)
				},
				locationTypeObj: {
					locationType: null,
					locationTypeOptions: []
				},
				serviceTypeObj: {
					serviceType: null,
					serviceTypeOptions: []
				},
				scheduleTypeObj: {
					scheduleType: null,
					scheduleTypeOptions: this.scheduleTypeOptions
				},
				orderTypeObj: {
					orderType: null,
					orderTypeOptions: []
				},
				billingTypeObj: {
					billingType: null,
					billingTypeOptions: this.billingTypeOptions
				},
				dollarRate: null,
				percentageRate: null,
				dollarRateAbove: null,
				percentageRateAbove: null,
				dollarRateBelow: null,
				percentageRateBelow: null,
				itemThreshold: null,
				valueThreshold: null,
				timeThreshold: null,
				itemIncrement: null,
				valueIncrement: null,
				timeIncrement: null,
				isEdit: true,
				applyWrapFee: false,
				wrapFee: null,
				billingTime: 'POST',
				locationDistanceId: null,
				rateFirstHour: null,
				rateFifteenMinutes: null,
				serviceTimeTypeObj: {
					serviceTimeType: []
				},
				locationList: [],
				customerList: [],
				billToCustomerId: null,
				contractRulesLocations: [],
				billableEventId: null,
				billingCategoryId: null,
				billingCategoryObj: {
					billingCategory: null,
					billingCategoryOptions: _.cloneDeep(this.billingCategoryOptions)
				},
				overageRate: null,
				locationOptions: [],
				startDate: this.model.contractStartDate ? this.model.contractStartDate : new Date(),
				endDate: null
			});
			this.getContractLocationList('', null, 1, this.billingRulesOptions.length - 1);

			event.preventDefault();
		}
	}, {
		key: 'validateBillingRuleFormControl',
		value: function validateBillingRuleFormControl() {
			var _this3 = this;

			var disableButton = this.billingRulesOptions.map(function (data) {
				_this3.isValidFormControl = true;
				_this3.isValidFormControl = _this3.isValidFormControl && data.isValidBillingRules;
				return _this3.isValidFormControl;
			});
			if (disableButton.indexOf(false) >= 0 && this.billingRulesOptions.length > 0) return false;else return true;
		}
	}, {
		key: 'removeBillingRules',
		value: function removeBillingRules(index) {
			var _this4 = this;

			this.Modal.confirm({
				header: this.$translate.instant('common.confirm_delete_title'),
				message: this.$translate.instant('common.confirm_delete_message') + '?',
				callback: function callback(_ref) {
					var modal = _ref.modal,
					    $scope = _ref.$scope;

					_this4.billingRulesOptions.splice(index, 1);
					_this4.billingRulesOptions.forEach(function (cr, index) {
						_this4.disableOtherOptions = {};
						setTimeout(function () {
							if (cr.billingEventObj.billingEvent && _this4.staticBillingEvents.includes(cr.billingEventObj.billingEvent.value)) {
								_this4.disableOtherOptions[index] = {
									disabled: true
								};
								_this4.requiredStartDate = true;
							} else {
								_this4.disableOtherOptions[index] = {
									disabled: false
								};
								_this4.requiredStartDate = false;
							}
							_this4.isAllowScheduleType(cr, index);
						}, 100);
					});
					modal.close();
					// if(this.billingRulesOptions.length == 0 ) return this.requiredStartDate = false;
					_this4.isStartDateIsRequired();
				},
				negative: function negative(_ref2) {
					var modal = _ref2.modal;

					modal.close();
				},
				type: 'danger'
			});
		}
	}, {
		key: 'locationTypeOptionChoice',
		value: function locationTypeOptionChoice(obj) {
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (['shipment-delivered', 'shipment-pickup', 'delivery-order-pack', 'pickup-deposit', 'shipment-delivery-cant', 'coin-pickup', 'deposit-count', 'stop-completed'].indexOf(selectedBillingEvent) > -1) {
				obj.locationTypeObj.locationTypeOptions = this.locationTypeOptions['other'];
			} else if (['coin-delivery'].indexOf(selectedBillingEvent) > -1) {
				obj.locationTypeObj.locationTypeOptions = [].concat((0, _toConsumableArray3.default)(this.locationTypeOptions['other']), (0, _toConsumableArray3.default)(this.locationTypeOptions['ATM']));
			} else if (selectedBillingEvent == 'coin-conversion') {
				var option = { label: 'Any', value: 'any' };
				obj.locationTypeObj.locationTypeOptions = [option];
				obj.locationTypeObj.locationType = option;
			} else {
				obj.locationTypeObj.locationTypeOptions = this.locationTypeOptions['ATM'];
			}
		}
	}, {
		key: 'serviceTypeOptionChoice',
		value: function serviceTypeOptionChoice(obj, index) {
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
				obj.serviceTypeObj.serviceTypeOptions = [this.serviceTypeOptions['other'][0]].concat((0, _toConsumableArray3.default)(this.serviceTypeOptions['regular']), (0, _toConsumableArray3.default)(this.serviceTypeOptions['flm']), (0, _toConsumableArray3.default)(this.serviceTypeOptions['slm']));
				this.isDisableServiceTypeOptions = false;
			} else if (['stop-completed', 'atm-cash-delivery', 'coin-pickup', 'coin-delivery', 'shipment-delivery-cant', 'shipment-pickup', 'shipment-delivered', 'atm-cash-pickup', 'atm-deposit-pickup'].indexOf(selectedBillingEvent) > -1) {
				obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['other'];
				this.isDisableServiceTypeOptions = false;
			} else if (['atm-load-service', 'atm-load-cant'].indexOf(selectedBillingEvent) > -1) {
				obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['atmLoad'];
				this.isDisableServiceTypeOptions = false;
			} else {
				obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['none'];
				obj.serviceTypeObj.serviceType = this.serviceTypeOptions['none'][0];
				if (['deposit-count', 'atm-order-pack', 'pickup-deposit', 'atm-residual-deposit', 'delivery-order-pack', 'atm-residual-count', 'atm-deposit-count'].indexOf(selectedBillingEvent) > -1) {
					this.isDisableServiceTypeOptions = true;
				}
			}
		}
	}, {
		key: 'orderTypeOptionChoice',
		value: function orderTypeOptionChoice(obj) {
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (['shipment-delivered', 'shipment-pickup', 'delivery-order-pack', 'pickup-deposit', 'shipment-delivery-cant', 'deposit-count'].indexOf(selectedBillingEvent) > -1) {
				obj.orderTypeObj.orderTypeOptions = [].concat((0, _toConsumableArray3.default)(this.orderTypeOptions['cash_coin']), (0, _toConsumableArray3.default)(this.orderTypeOptions['cash_only']), (0, _toConsumableArray3.default)(this.orderTypeOptions['coin_only']));
			} else if (['atm-residual-count', 'atm-load-service', 'atm-order-pack', 'atm-residual-deposit', 'atm-deposit-pickup', 'atm-deposit-count', 'atm-load-cant', 'atm-cash-delivery', 'atm-cash-pickup'].indexOf(selectedBillingEvent) > -1) {
				obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['ATM'];
			} else if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
				obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['services'];
			} else if (['coin-pickup', 'coin-delivery'].indexOf(selectedBillingEvent) > -1) {
				obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['coin_only'];
			} else if (['stop-completed', 'coin-conversion'].indexOf(selectedBillingEvent) > -1) {
				var option = { label: 'Any', value: 'none' };
				obj.orderTypeObj.orderTypeOptions = [option];
				obj.orderTypeObj.orderType = option;
			} else {
				obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['other'];
			}
		}
	}, {
		key: 'validateBillingType',
		value: function validateBillingType(obj, index) {
			obj.dollarRate = null;
			obj.percentageRate = null;
			obj.dollarRateAbove = null;
			obj.percentageRateAbove = null;
			obj.dollarRateBelow = null;
			obj.percentageRateBelow = null;
			obj.itemThreshold = null;
			obj.valueThreshold = null;
			obj.timeThreshold = null;
			obj.itemIncrement = null;
			obj.valueIncrement = null;
			obj.timeIncrement = null;
			obj.applyWrapFee = false;
			obj.wrapFee = null;
			obj.billingTime = obj.billingEventObj.billingEvent && this.staticBillingEvents.includes(obj.billingEventObj.billingEvent.value) && obj.billingTypeObj.billingType.value === 'fixed' && obj.billingEventObj.billingEvent.value === 'pre-bill' ? obj.billingTime = 'PRE' : 'POST';
			obj.locationDistanceId = null;
			obj.rateFirstHour = null;
			obj.rateFifteenMinutes = null;
			obj.overageRate = null;
			// obj.serviceTimeTypeObj = {};
			if (obj.billingTypeObj.billingType.value !== 'drive_distance') {
				if (this.model.useCustomerOnBillingRules === true) this.getContractLocationList('', null, 1, index);
			}
		}
	}, {
		key: 'resetLocationAndServiceType',
		value: function resetLocationAndServiceType(obj) {
			obj.serviceTypeObj.serviceTypeOptions = [];
			obj.locationTypeObj.locationTypeOptions = [];
		}
	}, {
		key: 'generateBillingRules',
		value: function generateBillingRules(type) {
			var _this5 = this;

			if (!this.billingRulesOptions.length) return [];
			this.contractRules = [];

			this.billingRulesOptions.forEach(function (obj) {
				_this5.contractRules.push({
					name: obj.name,
					description: obj.description,
					generalLedgerCode: obj.generalLedgerCode,
					status: obj.status,
					billingEvent: obj.billingEventObj.billingEvent[type],
					billingEventLabel: obj.billingEventObj.billingEvent.label,
					locationType: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType[type] : 'NONE',
					locationTypeLabel: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType.label : 'NONE',
					serviceType: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType[type] : 'NONE',
					serviceTypeLabel: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType.label : 'NONE',
					scheduleType: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType[type] : 'NONE',
					scheduleTypeLabel: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType.label : 'NONE',
					orderType: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType[type] : 'NONE',
					orderTypeLabel: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType.label : 'NONE',
					billingType: obj.billingTypeObj.billingType[type],
					billingTypeLabel: obj.billingTypeObj.billingType.label,
					dollarRate: obj.dollarRate >= 0 ? obj.dollarRate : null,
					percentageRate: obj.percentageRate >= 0 ? obj.percentageRate : null,
					dollarRateAbove: obj.dollarRateAbove >= 0 ? obj.dollarRateAbove : null,
					percentageRateAbove: obj.percentageRateAbove >= 0 ? obj.percentageRateAbove : null,
					dollarRateBelow: obj.dollarRateBelow >= 0 ? obj.dollarRateBelow : null,
					percentageRateBelow: obj.percentageRateBelow >= 0 ? obj.percentageRateBelow : null,
					itemThreshold: obj.itemThreshold >= 0 ? obj.itemThreshold : null,
					itemIncrement: obj.itemIncrement >= 0 ? obj.itemIncrement : null,
					valueThreshold: obj.valueThreshold >= 0 ? obj.valueThreshold : null,
					valueIncrement: obj.valueIncrement >= 0 ? obj.valueIncrement : null,
					timeThreshold: obj.timeThreshold ? _this5.getTime(obj.timeThreshold, obj.billingTypeObj.billingType[type]) : null,
					timeIncrement: obj.timeIncrement ? _this5.getTime(obj.timeIncrement) : null,
					currencyId: 'USD',
					applyWrapFee: obj.applyWrapFee,
					wrapFee: obj.wrapFee,
					billingTime: obj.billingTypeObj.billingType[type] === 'fixed' ? obj.billingTime : null,
					locationDistanceId: obj.locationDistanceId,
					rateFirstHour: obj.rateFirstHour,
					rateFifteenMinutes: obj.rateFifteenMinutes,
					serviceTimeType: obj.serviceTimeTypeObj.serviceTimeType.map(function (d) {
						return d.value;
					}).toString(),
					billToCustomerId: obj.billToCustomerId ? obj.billToCustomerId.Value : null,
					contractRulesLocations: obj.contractRulesLocations,
					preBillingEvents: obj.billingEventObj.preBillingEvents,
					postBillingEvents: obj.billingEventObj.postBillingEvents,
					sequence: _this5.contractRules.length + 1,
					billableEventId: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent.id : null,
					billingCategoryId: obj.billingCategoryObj && obj.billingCategoryObj.billingCategory ? obj.billingCategoryObj.billingCategory.billingCategoryId : null,
					overageRate: obj.overageRate,
					startDate: obj.startDate ? moment(obj.startDate).format('YYYY-MM-DD') : null,
					endDate: obj.endDate ? moment(obj.endDate).format('YYYY-MM-DD') : null

				});
			});
		}
	}, {
		key: 'setEditFlag',
		value: function setEditFlag(obj) {
			obj.isEdit = false;
		}
	}, {
		key: 'saveBillingRules',
		value: function saveBillingRules(obj, event) {
			event.preventDefault();
			obj.isValidBillingRules = true;
			this.showAllFlag = false;
			this.isStartDateIsRequired();
		}
	}, {
		key: 'percentageMask',
		value: function percentageMask(input, decimals) {
			return this.$filter('number')(input, decimals) + '%';
		}
	}, {
		key: 'editBillingRules',
		value: function editBillingRules(obj) {
			obj.isEdit = true;
			obj.isValidBillingRules = false;
		}
	}, {
		key: 'isInvalidForm',
		value: function isInvalidForm() {
			return !this.model.contractName || !this.model.selectedBillingDuration || !this.model.contractStartDate && this.requiredStartDate || !this.model.contractStartDate;
		}
	}, {
		key: 'ifUndefined',
		value: function ifUndefined(v, mixed) {
			return typeof v === 'undefined' || v === null ? mixed : v;
		}
	}, {
		key: 'getBillableEvents',
		value: function getBillableEvents() {
			var _this6 = this;

			this.preBillingEventOptions = [];
			this.postBillingEventOptions = [];
			this.billingCategoryOptions = [];

			this.BillableEventsService.all(null, 0, 100).then(function (events) {
				events.results.forEach(function (d) {
					_this6.preBillingEventOptions.push({
						id: d.id,
						label: _this6.$translate.instant('entry_type.' + d.type),
						value: d.type
					});
				});
				_this6.preBillingEventOptions = _.sortBy(_this6.preBillingEventOptions, ['label', 'ASC']);
				_this6.postBillingEventOptions = _.sortBy(_this6.preBillingEventOptions, ['label', 'ASC']);

				var billableEvents = events.results.reduce(function (acc, result) {
					var categoryName = result.billingCategory.name;
					acc[categoryName] = acc[categoryName] || {
						billingEvents: [],
						billingCategoryId: result.billingCategoryId
					};
					acc[categoryName].billingEvents.push({
						id: result.id,
						label: _this6.$translate.instant('entry_type.' + result.type),
						value: result.type
					});
					return acc;
				}, {});

				_this6.billingCategoryOptions = (0, _keys2.default)(billableEvents).map(function (key) {
					return {
						label: key,
						billingCategoryId: billableEvents[key].billingCategoryId,
						billingEvents: billableEvents[key].billingEvents
					};
				});
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this6.loading = false;
			});
		}
	}, {
		key: 'getBillingEventsByCategory',
		value: function getBillingEventsByCategory(contractRuleObj, index) {
			this.resetLocationAndServiceType(contractRuleObj);
			contractRuleObj.billingEventObj.billingEventOptions = contractRuleObj.billingCategoryObj.billingCategory.billingEvents;
		}
	}, {
		key: 'locationDistanceList',
		value: function locationDistanceList() {
			var _this7 = this;

			this.LocationDistanceService.all(null, 0, 100).then(function (data) {
				_this7.model.locationDistanceOptions = data.results;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'updateLocationDistance',
		value: function updateLocationDistance(contractRules, locationDistanceId, index) {
			var _this8 = this;

			contractRules.locationDistance = _.find(this.model.locationDistanceOptions, { 'id': locationDistanceId });
			this.showAllFlag = false;
			if (this.model.useCustomerOnBillingRules === true) this.getContractLocationList('', contractRules.locationDistanceId, 1, index);
			setTimeout(function () {
				var applicableLocations = _this8.model.locationList;

				var filteredLocations = applicableLocations.filter(function (ele) {
					return _this8.billingRulesOptions[index].contractRulesLocations.includes(ele.value);
				}).map(function (ele) {
					return ele.value;
				});

				_this8.billingRulesOptions[index].contractRulesLocations = filteredLocations.length > 0 ? filteredLocations : [];
				_this8.$scope.$apply();
			}, 500);
		}
	}, {
		key: 'preOrPostBillCfg',
		value: function preOrPostBillCfg(obj, index) {
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (this.staticBillingEvents.includes(selectedBillingEvent)) {
				this.disableOtherOptions[index] = {
					disabled: true
				};
				obj.locationTypeObj.locationType = null;
				obj.serviceTypeObj.serviceType = null;
				obj.scheduleTypeObj.scheduleType = null;
				obj.orderTypeObj.orderType = null;
				obj.billingTypeObj.billingType = {
					label: 'Fixed',
					value: 'fixed'
				};
				obj.billingTime = selectedBillingEvent === 'pre-bill' ? 'PRE' : 'POST';
				obj.dollarRate = null;
				obj.percentageRate = null;
				obj.dollarRateAbove = null;
				obj.percentageRateAbove = null;
				obj.dollarRateBelow = null;
				obj.percentageRateBelow = null;
				obj.itemThreshold = null;
				obj.valueThreshold = null;
				obj.timeThreshold = null;
				obj.itemIncrement = null;
				obj.valueIncrement = null;
				obj.timeIncrement = null;
				obj.isEdit = true;
				obj.applyWrapFee = false;
				obj.wrapFee = null;
				obj.locationDistanceId = null;
				obj.rateFirstHour = null;
				obj.rateFifteenMinutes = null;
				obj.overageRate = null;
				this.model.selectedBillingDuration = 'MONTHLY';
				this.model.disableBillingIncrement = true;
				this.requiredStartDate = true;
			} else {
				this.model.disableBillingIncrement = false;
				this.disableOtherOptions[index] = {
					disabled: false
				};
				obj.billingTime = 'POST';
				this.requiredStartDate = false;
				obj.billingTypeObj.billingType = null;
				setTimeout(function () {
					obj.billingEventObj.preBillingEvents = [];
					obj.billingEventObj.preBillingEventOptions.forEach(function (pbe) {
						pbe.ticked = false;
					});

					obj.billingEventObj.postBillingEvents = [];
					obj.billingEventObj.postBillingEventOptions.forEach(function (pbe) {
						pbe.ticked = false;
					});
				});
			}

			this.isStartDateIsRequired();
		}
	}, {
		key: 'isAllowScheduleType',
		value: function isAllowScheduleType(obj, index) {
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (this.allowScheduleTypeBillingEvents.includes(selectedBillingEvent)) {
				this.disableScheduleTypeOptions[index] = {
					disabled: true
				};
				obj.scheduleTypeObj.scheduleType = null;
			} else {
				this.disableScheduleTypeOptions[index] = {
					disabled: false
				};
			}
		}
	}, {
		key: 'isStartDateIsRequired',
		value: function isStartDateIsRequired() {
			var _this9 = this;

			if (!this.billingRulesOptions.length) this.requiredStartDate = false;

			this.billingRulesOptions.forEach(function (br) {
				if (br.billingEventObj.billingEvent && br.billingEventObj.billingEvent.value == "pre-bill") _this9.requiredStartDate = true;
			});
		}
	}, {
		key: 'bulkImportLocationModal',
		value: function bulkImportLocationModal(data, index) {
			data.contractId = this.model.contractId;
			data.useCustomerOnBillingRules = this.model.useCustomerOnBillingRules;
			data.showAll = this.showAllFlag;
			this.Modal.bulkImportLocation(data, function (_ref3) {
				var locationList = _ref3.locationList,
				    modal = _ref3.modal;

				if (locationList && locationList.length > 0) {
					locationList.forEach(function (l1) {
						data.contractRulesLocations.push(l1);
					});
				}
				modal.close();
			}, function (_ref4) {
				var modal = _ref4.modal;

				if (modal) modal.close();
			});
		}
	}, {
		key: 'billingTypeOptionChoice',
		value: function billingTypeOptionChoice(obj) {
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (!selectedBillingEvent) return;

			if (this.staticBillingEvents.includes(selectedBillingEvent)) {
				var fixedOption = this.billingTypeOptions.find(function (bt) {
					return bt.label === 'Fixed';
				});
				obj.billingTypeObj.billingTypeOptions = [fixedOption];
			} else if (selectedBillingEvent === 'stop-completed') {
				var options = this.billingTypeOptions.filter(function (bt) {
					return ['fixed', 'per_item'].includes(bt.value);
				});
				obj.billingTypeObj.billingTypeOptions = options;
			} else if (selectedBillingEvent === 'coin-conversion') {
				var perItemOption = this.billingTypeOptions.find(function (bt) {
					return bt.value === 'per_item';
				});
				obj.billingTypeObj.billingTypeOptions = [perItemOption];
				obj.billingTypeObj.billingType = { label: "Per Item", value: "per_item" };
			} else if (selectedBillingEvent === 'atm-residual-count') {
				var _options = this.billingTypeOptions.filter(function (bt) {
					return ['fixed', 'per_item', 'percentage_fee'].includes(bt.value);
				});
				obj.billingTypeObj.billingTypeOptions = _options;
			} else {
				obj.billingTypeObj.billingTypeOptions = this.billingTypeOptions;
			}
		}
	}, {
		key: 'resetBillToCustomers',
		value: function resetBillToCustomers() {
			var _this10 = this;

			this.billingRulesOptions.forEach(function (obj) {
				obj.billToCustomerId = null;
				obj.contractRulesLocations = [];
				if (_this10.model.useCustomerOnBillingRules === true) _this10.getContractLocationList('', obj.locationDistanceId, 1);
			});
		}
	}, {
		key: 'getCustomerList',
		value: function getCustomerList(searchKey, offset) {
			var _this11 = this;

			this.model.customerObj.loading = true;
			this.Service.getCustomerList(searchKey, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this11.model.customerObj.totalRecords = data.totalRecords;
					_this11.model.customerObj.results = _this11.dataMapping(data.results, 'key', 'value');
				} else {
					var customers = _this11.dataMapping(data.results, 'key', 'value');
					_this11.model.customerObj.results = _this11.model.customerObj.results.concat(customers);
				}

				_this11.cloneCustomerListLObj = {
					customerList: _this11.model.customerObj.results,
					totalCustomers: _this11.model.customerObj.totalRecords
				};
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this11.model.customerObj.loading = false;
			});
		}
	}, {
		key: 'dataMapping',
		value: function dataMapping(data, key, value) {
			return data.map(function (obj) {
				return {
					Key: obj[key],
					Value: obj[value]
				};
			});
		}
	}, {
		key: 'getContractLocationList',
		value: function getContractLocationList() {
			var searchKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
			var locationDistanceId = arguments[1];
			var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

			var _this12 = this;

			var index = arguments[3];
			var selectAllFlag = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

			setTimeout(function () {
				var queryDataLimit = selectAllFlag ? _this12.model.totalLocations || _this12.contractLocationListObj.pagination.pageLimit : _this12.contractLocationListObj.pagination.pageLimit;
				_this12.Service.contractLocationList(searchKey, locationDistanceId, (page - 1) * _this12.contractLocationListObj.pagination.pageLimit, queryDataLimit).then(function (res) {
					if (res.results) {
						if (page == 1) {
							_this12.model.locationList = [];
							if (index != null && _this12.billingRulesOptions[index]) {
								_this12.billingRulesOptions[index].locationOptions = [];
							}
						}
						if (_this12.billingRulesOptions[index] && _this12.billingRulesOptions[index].locationOptions) {
							_this12.billingRulesOptions[index].locationOptions = _.uniqBy(_this12.billingRulesOptions[index].locationOptions.concat(res.results), 'value');
						}
						_this12.model.locationList = _.uniqBy(_this12.model.locationList.concat(res.results), 'value');
						_this12.model.totalLocations = res.totalRecords;
						_this12.cloneContractLocationListLObj = {
							locationList: _this12.model.locationList,
							totalLocations: _this12.model.totalLocations
						};
						if (index !== null && _this12.billingRulesOptions[index]) {
							_this12.billingRulesOptions[index].contractLocationsDistance = new Array(res.totalRecords).fill('');
						}
					}
				}).catch(function (err) {
					console.log(err);
				});
			});
		}
	}, {
		key: 'filterChange',
		value: function filterChange(contractRules) {
			// console.log(contractRules.contractRulesLocations)
		}
	}, {
		key: 'clear',
		value: function clear() {
			this.model.contractEndDate = null;
		}
	}, {
		key: 'updateContractRuleStatus',
		value: function updateContractRuleStatus(index, isActive) {
			setTimeout(function () {
				var id = isActive ? 'active-btn-' + index : 'inactive-btn-' + index;
				return document.getElementById(id).blur();
			});
		}
	}, {
		key: 'validateRecordOnSequenceChange',
		value: function validateRecordOnSequenceChange() {
			var _this13 = this;

			setTimeout(function () {
				_this13.disableOtherOptions = {};
				_this13.billingRulesOptions.forEach(function (cr, index) {
					if (cr.billingEventObj.billingEvent && _this13.staticBillingEvents.includes(cr.billingEventObj.billingEvent.value)) {
						_this13.disableOtherOptions[index] = {
							disabled: true
						};
						_this13.requiredStartDate = true;
					} else {
						_this13.disableOtherOptions[index] = {
							disabled: false
						};
						_this13.requiredStartDate = false;
					}
					_this13.isAllowScheduleType(cr, index);
				}, 100);
			});
		}
	}, {
		key: 'duplicateBillingRule',
		value: function duplicateBillingRule(obj) {
			var records = _.cloneDeep(obj);
			this.getContractLocationList('', obj.locationDistanceId ? obj.locationDistanceId : null, 1, this.billingRulesOptions.length);
			this.billingRulesOptions.push(records);
			this.validatePreOrPostBillingOptions();
		}
	}, {
		key: 'validatePreOrPostBillingOptions',
		value: function validatePreOrPostBillingOptions() {
			var _this14 = this;

			setTimeout(function () {
				_this14.disableOtherOptions = {};
				_this14.billingRulesOptions.forEach(function (cr, index) {
					if (cr.billingEventObj.billingEvent && _this14.staticBillingEvents.includes(cr.billingEventObj.billingEvent.value)) {
						_this14.disableOtherOptions[index] = {
							disabled: true
						};
						_this14.requiredStartDate = true;
					} else {
						_this14.disableOtherOptions[index] = {
							disabled: false
						};
						_this14.requiredStartDate = false;
					}
					_this14.isAllowScheduleType(cr, index);
				});
				_this14.$scope.$apply();
			}, 100);
		}
	}, {
		key: 'onDrop',
		value: function onDrop(event, index, item, external, type) {
			var updatedOptions = angular.copy(this.billingRulesOptions);
			var itemIndex = updatedOptions.findIndex(function (opt) {
				return opt.sequence === item.sequence;
			});

			if (itemIndex === -1) return false;

			var removedItem = updatedOptions.splice(itemIndex, 1)[0];
			var newIndex = itemIndex < index ? index - 1 : index;
			removedItem.sequence = newIndex;
			updatedOptions.splice(newIndex, 0, removedItem);

			updatedOptions.forEach(function (opt, idx) {
				opt.sequence = idx;
			});

			this.billingRulesOptions = updatedOptions;
			this.validateRecordOnSequenceChange();

			return true;
		}
	}, {
		key: 'getContractTypeList',
		value: function getContractTypeList(searchKey, offset) {
			var _this15 = this;

			setTimeout(function () {

				searchKey = searchKey || '';

				var obj = {
					queryJSON: {
						rules: [{
							group: {
								rules: [{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								}, {
									field: "type",
									condition: "like",
									data: "%" + searchKey + "%"
								}],
								operator: "OR"
							}
						}],
						operator: "AND"
					}
				};

				_this15.model.contractTypeObj.loading = true;
				return _this15.ContractTypeService.all(obj, offset, _app2.default.defaultPageLimit).then(function (data) {
					if (offset === 0 || offset == undefined) {
						_this15.model.contractTypeObj.totalRecords = data.total;
						_this15.model.contractTypeObj.results = _this15.mapContractData(data.results);
					} else {
						var contractType = _this15.mapContractData(data.results);
						_this15.model.contractTypeObj.results = _this15.model.contractTypeObj.results.concat(contractType);
					}
				}).catch(function (err) {
					console.log(err);
				}).finally(function () {
					_this15.model.contractTypeObj.loading = false;
				});
			});
		}
	}, {
		key: 'mapContractData',
		value: function mapContractData(mapArray) {
			return mapArray.map(function (obj) {
				return {
					Key: obj.type,
					Value: obj.id
				};
			});
		}
	}, {
		key: 'convertStr',
		value: function convertStr(str) {
			if (!str) return;
			return Number(str.replace('%', ''));
		}
	}, {
		key: 'ngPercentage',
		value: function ngPercentage() {
			if (this.model.bailmentInterest && !this.model.bailmentInterest.endsWith('%')) {
				return this.model.bailmentInterest = this.model.bailmentInterest + '%';
			}
		}
	}, {
		key: 'removePercentageSign',
		value: function removePercentageSign() {
			if (this.model.bailmentInterest && this.model.bailmentInterest.endsWith('%')) {
				return this.model.bailmentInterest = this.model.bailmentInterest.replace('%', '');
			}
		}
	}, {
		key: 'contractDatesChanged',
		value: function contractDatesChanged() {
			var _model = this.model,
			    contractStartDate = _model.contractStartDate,
			    contractEndDate = _model.contractEndDate;


			this.ruleStartDateOptions = (0, _extends3.default)({
				minDate: moment(contractStartDate)
			}, contractEndDate && { maxDate: moment(contractEndDate) });

			this.showBillingWarning = this.billingRulesOptions.some(function (rule, index) {
				var ruleStartDate = moment(rule.startDate);
				var ruleEndDate = rule.endDate ? moment(rule.endDate) : null;

				var contractStart = moment(contractStartDate);
				var contractEnd = contractEndDate ? moment(contractEndDate) : null;

				if (!contractStartDate) return false;

				var isInvalidStart = ruleStartDate.isValid() && !(ruleStartDate.isSameOrAfter(contractStart, "day") && (contractEnd ? ruleStartDate.isSameOrBefore(contractEnd, "day") : true));

				var isInvalidEnd = ruleEndDate && ruleEndDate.isValid() && !(ruleEndDate.isSameOrAfter(contractStart, "day") && (contractEnd ? ruleEndDate.isSameOrBefore(contractEnd, "day") : true));

				var isRuleInvalid = isInvalidStart || isInvalidEnd;
				return isRuleInvalid;
			});
		}
	}]);
	return ContractCreateController;
}(_contractBase2.default);

exports.default = ContractCreateController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contractCreate = __webpack_require__(2108);

var _contractCreate2 = _interopRequireDefault(_contractCreate);

__webpack_require__(3078);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractCreateModule = angular.module('contractcreate', []).component('contractcreate', _contractCreate2.default).name;

exports.default = contractCreateModule;

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contractEdit = __webpack_require__(2802);

var _contractEdit2 = _interopRequireDefault(_contractEdit);

var _contractEdit3 = __webpack_require__(2112);

var _contractEdit4 = _interopRequireDefault(_contractEdit3);

__webpack_require__(3079);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contracteditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _contractEdit2.default,
  controller: _contractEdit4.default
};

exports.default = contracteditComponent;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _extends3 = __webpack_require__(28);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _contractBase = __webpack_require__(273);

var _contractBase2 = _interopRequireDefault(_contractBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractEditController = function (_ContractBaseControll) {
	ContractEditController.$inject = ["Auth", "$state", "User", "ContractService", "Modal", "$translate", "$stateParams", "$q", "$filter", "BillableEventsService", "CommonLayoutService", "LocationDistanceService", "ContractTypeService", "DateUtil", "$scope"];
	(0, _inherits3.default)(ContractEditController, _ContractBaseControll);

	/*@ngInject*/
	function ContractEditController(Auth, $state, User, ContractService, Modal, $translate, $stateParams, $q, $filter, BillableEventsService, CommonLayoutService, LocationDistanceService, ContractTypeService, DateUtil, $scope) {
		(0, _classCallCheck3.default)(this, ContractEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (ContractEditController.__proto__ || (0, _getPrototypeOf2.default)(ContractEditController)).call(this, Auth, $state, User, ContractService, Modal, $translate, $stateParams));

		_this.isDisabledDate = function (currentDate, mode) {
			if (this.model.contractEndDate !== null) {
				if (this.model.contractStartDate > this.model.contractEndDate) {
					this.model.contractEndDate = this.model.contractStartDate;
				} else if (this.model.contractStartDate == null) {
					this.model.contractEndDate = null;
				}
			}
			this.startMinDate = {
				minDate: this.model.contractStartDate
			};
			this.contractDatesChanged();
		};

		_this.mainFormChanged = false;
		_this.$q = $q;
		_this.$filter = $filter;
		_this.isExporting = false;
		_this.BillableEventsService = BillableEventsService;
		_this.CommonLayoutService = CommonLayoutService;
		_this.LocationDistanceService = LocationDistanceService;
		_this.ContractTypeService = ContractTypeService;
		_this.DateUtil = DateUtil;
		_this.$scope = $scope;
		_this.contractLogs = [];
		_this.page = 1;
		_this.total = 0;
		_this.pageLimit = 10;
		_this.maxPages = 10;
		_this.searchText = '';
		_this.logsOf = '';
		_this.customers = [];
		_this.contractRulesLocationSearchText = '';
		_this.showAllFlag = false;
		_this.defaultModel = {
			contractId: '',
			contractName: '',
			status: true,
			selectedBillingDuration: '',
			description: '',
			contractStartDate: null,
			contractEndDate: null,
			useCustomerOnBillingRules: false,
			locationList: [],
			deletedContractRules: [],
			bailmentInterest: null,
			contractTypeId: '',
			dateRange: {
				startDate: '',
				endDate: ''
			}
		};
		_this.model = angular.copy(_this.defaultModel);
		_this.formValues = {};
		_this.billingIncrementList = [{ label: _this.$translate.instant('contract.daily'), value: 'DAILY' }, { label: _this.$translate.instant('contract.weekly'), value: 'WEEKLY' }, { label: _this.$translate.instant('contract.bi_weekly'), value: 'BI_WEEKLY' }, { label: _this.$translate.instant('contract.monthly'), value: 'MONTHLY' }, { label: _this.$translate.instant('contract.quarterly'), value: 'QUARTERLY' }, { label: _this.$translate.instant('contract.annually'), value: 'ANNUALLY' }];
		_this.selectedTab = 'rules';
		_this.filterByValue = "active";
		_this.branchId = _this.User.getUser().branchId;
		_this.loading = true;
		_this.contractRulesLocationLoading = false;
		_this.contractRules = [];
		_this.billingRulesOptions = [];
		_this.entryTypes = [];
		_this.contractRulesRecordStats = {
			active: 0,
			inactive: 0
		};
		_this.showBillingWarning = false;
		_this.locationTypeOptions = {
			'ATM': [{
				label: 'ATM',
				value: 'atm'
			}],
			'other': [{
				label: 'Any',
				value: 'any'
			}, {
				label: 'Regular',
				value: 'regular'
			}, {
				label: 'NSNG',
				value: 'nsng'
			}, {
				label: 'On Call',
				value: 'on_call'
			}, {
				label: 'Bank',
				value: 'bank'
			}]
		};

		_this.serviceTypeOptions = {
			'regular': [{
				label: 'Scheduled',
				value: 'regular'
			}],
			'flm': [{
				label: 'FLM',
				value: 'flm'
			}],
			'slm': [{
				label: 'SLM',
				value: 'slm'
			}],
			'other': [{
				label: 'Any',
				value: 'any'
			}, {
				label: 'Unscheduled',
				value: 'unscheduled'
			}, {
				label: 'Scheduled',
				value: 'regular'
			}],
			'atmLoad': [{
				label: 'Any',
				value: 'any'
			}, {
				label: 'Unscheduled',
				value: 'unscheduled'
			}, {
				label: 'Scheduled',
				value: 'regular'
			}, {
				label: 'Emergency',
				value: 'emergency'
			}],
			'none': [{
				label: 'none',
				value: 'none'
			}]
		};

		_this.scheduleTypeOptions = [{
			label: 'Any',
			value: 'any'
		}, {
			label: 'Scheduled',
			value: 'scheduled'
		}, {
			label: 'Unscheduled',
			value: 'unscheduled'
		}];

		_this.orderTypeOptions = {
			'cash_coin': [{
				label: 'Cash & Coin',
				value: 'cash_and_coin'
			}],
			'cash_only': [{
				label: 'Cash',
				value: 'cash'
			}],
			'coin_only': [{
				label: 'Coin',
				value: 'coin'
			}],
			'ATM': [{
				label: 'ATM-Any',
				value: 'atm_any'
			}, {
				label: 'ATM-Add',
				value: 'atm_add'
			}, {
				label: 'ATM-Swap',
				value: 'atm_swap'
			}, {
				label: 'ATM-ICL',
				value: 'atm_icl'
			}, {
				label: 'ATM-CCL',
				value: 'atm_ccl'
			}, {
				label: 'ATM-Recash',
				value: 'atm_recash'
			}, {
				label: 'ATM-Decash',
				value: 'atm_decash'
			}],
			'services': [{
				label: 'Service Order',
				value: 'service_order'
			}],
			'other': [{
				label: 'none',
				value: 'none'
			}]
		};

		_this.billingTypeOptions = _this.CommonLayoutService.billingTypeOptions();
		_this.serviceTimeOptions = _this.CommonLayoutService.serviceTimeTypes();
		_this.serviceTimeTypes = _this.CommonLayoutService.serviceTimeTypes();

		_this.stats = {
			pre: 'PRE',
			post: 'POST'
		};

		_this.existingBillingRules = {};
		_this.disableOtherOptions = {};
		_this.isDisableServiceTypeOptions = {};
		_this.disableScheduleTypeOptions = {};
		_this.allowScheduleTypeBillingEvents = ['atm-deposit-count', 'delivery-order-pack', 'service-ticket-cancelled', 'service-ticket-incomplete', 'atm-residual-deposit', 'atm-order-pack', 'atm-residual-count', 'part-charge', 'service-ticket-completed', 'residual-deposit', 'pickup-deposit', 'order-packing-pack', 'atm-service'];
		_this.requiredStartDate = false;
		_this.requiredStartDateErrorMsg = 'As this contract does not have a start date, it will not generate pre/post bill records if any pre/post bill rules are defined.';

		_this.contractLocationListObj = {
			pagination: {
				page: 1,
				total: 0,
				pageLimit: 200,
				maxPages: 10
			}
		};

		_this.locationObj = {
			results: [],
			totalLocations: 0,
			pageLimit: 200
		};

		_this.associateLocationObj = {
			results: [],
			totalLocations: 0,
			pageLimit: 200
		};

		_this.customerObj = {
			loading: false,
			totalRecords: 0,
			results: [],
			pagination: {
				page: 1,
				total: 0,
				pageLimit: 10,
				maxPages: 10
			}
		};

		_this.contractRulesStatus = {
			active: true,
			suspended: false
		};

		_this.contractTypeObj = {
			loading: false,
			totalRecords: 0,
			results: [],
			pagination: {
				page: 1,
				total: 0,
				pageLimit: 10,
				maxPages: 10
			}
		};

		_this.staticBillingEvents = ['pre-bill', 'post-bill'];
		return _this;
	}

	(0, _createClass3.default)(ContractEditController, [{
		key: 'setDateRange',
		value: function setDateRange(date) {
			var _this2 = this;

			this.loading = true;
			var currentVaultDate = date || moment();
			this.model.dateRangPickerOptions = {
				autoApply: true,
				eventHandlers: {
					'apply.daterangepicker': function applyDaterangepicker() {
						_this2.page = 1;
						_this2.loadData(_this2.model.dateRange);
					}
				},
				ranges: {
					'Today': [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
					'Current Week': [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')],
					'Current Month': [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]
				}
			};
		}
	}, {
		key: '$onInit',
		value: function $onInit() {
			var _this3 = this;

			this.loading = true;
			this.$q.all([this.Service.get(this.$stateParams.id)]).then(function (data) {
				_this3.model.dateRange.startDate = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
				_this3.model.dateRange.endDate = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
				var contractData = data[0];
				_this3.rawId = contractData.id;
				_this3.defaultModel = (0, _extends4.default)({}, contractData, {
					dateRange: {
						startDate: '',
						endDate: ''
					}
				});
				_this3.model.contractId = contractData.id;
				_this3.model.contractName = contractData.contractName;
				_this3.model.status = contractData.status;
				_this3.model.description = contractData.description;
				_this3.model.selectedBillingDuration = contractData.billingIncrement;
				_this3.contractRules = contractData.contractRulesData;
				_this3.generalLedgerCode = contractData.generalLedgerCode;
				_this3.model.contractStartDate = contractData.contractStartDate ? _this3.DateUtil.convertToDate(contractData.contractStartDate) : null;
				_this3.model.contractEndDate = contractData.contractEndDate ? _this3.DateUtil.convertToDate(contractData.contractEndDate) : null;
				_this3.model.useCustomerOnBillingRules = contractData.useCustomerOnBillingRules;
				_this3.model.bailmentInterest = contractData.bailmentInterest ? contractData.bailmentInterest + '%' : null;
				_this3.model.contractTypeId = contractData.contractType, _this3.formValues = angular.copy(_this3.model);
				_this3.startMinDate = {
					minDate: _this3.model.contractStartDate
				};
				_this3.filePrefix = '' + ('ContractRuleHistory_' + _this3.model.contractName);
				_this3.startMaxDate = {
					minDate: new Date()
				};
				_this3.ruleStartDateOptions = (0, _extends4.default)({
					minDate: moment(_this3.model.contractStartDate)
				}, _this3.model.contractEndDate && { maxDate: moment(_this3.model.contractEndDate) });
				_this3.updateContractStats(contractData.contractRulesData);

				if (contractData.contractRulesData.length) {
					contractData.contractRulesData.forEach(function (cr, index) {
						if (_this3.staticBillingEvents.includes(cr.billingEvent)) {
							_this3.model.disableBillingIncrement = true;
							cr.billingTime = cr.billingEvent === 'pre-bill' ? _this3.stats.pre : _this3.stats.post;
							cr.scheduleType = null;
							_this3.disableOtherOptions[index] = {
								disabled: true
							};
							_this3.requiredStartDate = true;
						} else {
							cr.billingTime = _this3.stats.post;
							_this3.disableOtherOptions[index] = {
								disabled: false
							};
							_this3.requiredStartDate = false;
						}
						if (_this3.allowScheduleTypeBillingEvents.includes(cr.billingEvent)) {
							_this3.disableScheduleTypeOptions[index] = {
								disabled: true
							};
							cr.scheduleType = null;
						} else {
							_this3.disableScheduleTypeOptions[index] = {
								disabled: false
							};
						}
					});
				}
				_this3.startDateErrorMessage = _this3.requiredStartDateErrorMsg;
				_this3.currentVaultDate = _this3.DateUtil.convertToDate(_this3.DateUtil.convertToDate(contractData.contractStartDate));
				_this3.vaultDate = moment().format('YYYY-MM-DD');
				_this3.setDateRange(_this3.vaultDate);
				// this.loadData();
			}).then(function () {
				_this3.getBillableEvents();
				_this3.locationDistanceList();
				_this3.getContractLocationList();
				_this3.getCustomerLocationList();
				_this3.getCustomerList('', 0);
				_this3.getContractTypeList('', 0);
			}).catch(function (err) {
				_this3.error = err.message;
			}).finally(function () {
				_this3.loading = false;
			});
		}
	}, {
		key: 'loadData',
		value: function loadData() {
			var _this4 = this;

			this.loading = true;
			var searchObj = this.generateSearchObj();
			this.contractLogs = [];

			this.Service.getContractLogs(this.$stateParams.id, searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
				_this4.contractLogs = data.results.map(function (log) {
					log.readableEntryType = _this4.$translate.instant('entry_type.' + log.entryType);
					if (log.entryData) {
						log.extraDetails = (0, _entries2.default)(log.entryData).map(function (_ref) {
							var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
							    key = _ref2[0],
							    value = _ref2[1];

							return {
								key: key,
								value: (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' ? (0, _stringify2.default)(value) : value
							};
						});
					}
					return log;
				});

				_this4.total = data.total;

				if (data.allEntryTypes.length > 0 && !_this4.entryType) {
					_this4.entryTypes = data.allEntryTypes.map(function (entryType) {
						return {
							label: _this4.$translate.instant('entry_type.' + entryType),
							value: entryType
						};
					});
				}
			}).catch(function (error) {
				console.error('Error loading contract logs:', error);
				// Handle error appropriately (e.g., show user-friendly message)
			}).finally(function () {
				_this4.loading = false;
			});
		}
	}, {
		key: 'search',
		value: function search() {
			this.page = 1;
			this.loading = true;
			this.loadData();
		}
	}, {
		key: 'refresh',
		value: function refresh() {
			this.loading = true;
			this.loadData();
		}
	}, {
		key: 'pageChange',
		value: function pageChange() {
			this.loading = true;
			this.loadData();
		}
	}, {
		key: 'generateSearchObj',
		value: function generateSearchObj() {
			return {
				logsOf: this.logsOf,
				entryType: this.entryType,
				queryText: this.searchText,
				isQuery: false,
				startDate: moment(this.model.dateRange.startDate).startOf('day').format('YYYY-MM-DD 00:00:00'),
				endDate: moment(this.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
			};
		}
	}, {
		key: 'getContractDetails',
		value: function getContractDetails() {
			var _this5 = this;

			this.model.contractRules = [];
			this.contractRules = [];

			this.Service.get(this.$stateParams.id).then(function (data) {
				var contractData = data;
				_this5.contractRules = contractData.contractRulesData;
				_this5.model.contractRules = contractData.contractRulesData;
				_this5.model.contractStartDate = contractData.contractStartDate ? _this5.DateUtil.convertToDate(contractData.contractStartDate) : null;
				_this5.model.contractEndDate = contractData.contractEndDate ? _this5.DateUtil.convertToDate(contractData.contractEndDate) : null;
				_this5.updateContractStats(contractData.contractRulesData);
			}).then(function () {}).catch(function (err) {
				_this5.error = err.message;
			}).finally(function () {
				_this5.loading = false;
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			var _this6 = this;

			this.model = angular.copy(this.defaultModel);
			this.model.contractId = this.defaultModel.id;
			this.model.selectedBillingDuration = this.defaultModel.billingIncrement;
			this.model.contractStartDate = this.defaultModel.contractStartDate ? this.DateUtil.convertToDate(this.defaultModel.contractStartDate) : null;
			this.model.contractEndDate = this.defaultModel.contractEndDate ? this.DateUtil.convertToDate(this.defaultModel.contractEndDate) : null;
			this.formValues = angular.copy(this.model);
			this.model.bailmentInterest = this.defaultModel.bailmentInterest ? this.defaultModel.bailmentInterest + '%' : null;
			this.model.contractTypeId = this.defaultModel.contractType;
			this.model.dateRange.startDate = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
			this.model.dateRange.endDate = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
			// this.billingRulesOptions = [];
			// this.clearErrors();
			// this.getBillableEvents();

			if (this.formValues.contractRulesData && this.formValues.contractRulesData.length > 0) {
				this.billingRulesOptions.forEach(function (rule, index) {
					if (_this6.formValues.contractRulesData[index]) {
						rule.contractRulesLocations = _this6.formValues.contractRulesData[index].locationApplicable;
						setTimeout(function () {
							rule.locationDistanceId = _this6.formValues.contractRulesData[index].locationDistanceId;
							rule.locationDistance = _this6.formValues.contractRulesData[index].locationDistance ? _this6.formValues.contractRulesData[index].locationDistance : null;
						});
					}
				});
			}
			if (this.contractRulesLocationSearchText) {
				this.contractRulesLocationSearchText = '';
				this.getContractRulesLocation();
			}
			setTimeout(function () {
				_this6.billingRulesOptions.forEach(function (obj, index) {
					_this6.isAllowScheduleType(obj, index);
				});
			}, 1000);
			this.locationDistanceList();
			this.contractDatesChanged();
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this7 = this;

			// this.loading = true;

			setTimeout(function () {
				_this7.model.contractStartDate = _this7.model.contractStartDate ? moment(_this7.model.contractStartDate).format('YYYY-MM-DD') : null;
				_this7.model.contractEndDate = _this7.model.contractEndDate ? moment(_this7.model.contractEndDate).format('YYYY-MM-DD') : null;
				_this7.generateBillingRules('value');
				var contractRules = _this7.findDifferences(_this7.contractBillingRules, _this7.contractRules);
				_this7.model.billingIncrement = _this7.model.selectedBillingDuration;
				_this7.model.contractRules = contractRules;
				_this7.model.createdByUserId = _this7.User.getUser().id;
				_this7.model.modifiedByUserId = _this7.User.getUser().id;
				_this7.model.bailmentInterest = _this7.model.bailmentInterest ? _this7.convertStr(_this7.model.bailmentInterest) : null;
				_this7.model.contractTypeId = _this7.model.contractTypeId ? _this7.model.contractTypeId.Value : null;

				_this7.Service.update(_this7.rawId, _this7.model, _this7.branchId).then(function (data) {
					window.history.go(-1);
				}).catch(function (err) {
					if (err.data.errors) {
						err.data.errors.map(function (e) {
							_this7.errorMessage += e.message + '<br/>';
						});
					} else {
						_this7.errorMessage = err.data.message;
					}
				}).finally(function () {
					_this7.loading = false;
				});
			}, 200);
		}
	}, {
		key: 'selectBillingIncrement',
		value: function selectBillingIncrement(obj) {
			this.model.selectedBillingDuration = obj.value;
		}

		// billingContractRulesModal(data) {
		// 	this.Modal.billingContractRulesModal(data, true, this.model.contractRules = this.generateContractRules(), ({ contractRulesOptions, modal }) => {
		// 		contractRulesOptions.forEach((rules) => {
		// 			this.contractRules.push(rules);
		// 		})
		// 		modal.close();
		// 	}, ({ modal }) => {
		// 		if (modal) modal.close();
		// 	})
		// }

		// editBillingContract(data, index) {
		// 	this.Modal.billingContractRulesModal(data, true, this.model.contractRules = this.generateContractRules(), ({ contractRulesOptions, modal }) => {
		// 		this.contractRules.splice(index, 1);
		// 		contractRulesOptions.forEach((rules) => {
		// 			this.contractRules.splice(index, 0, rules);
		// 		})
		// 		modal.close();
		// 	}, ({ modal }) => {
		// 		if (modal) modal.close();
		// 	})
		// }

		// isObject(data) {
		// 	return typeof data === 'object'
		// }

	}, {
		key: 'removeBillingContract',
		value: function removeBillingContract(billingRuleObj, index) {
			var _this8 = this;

			this.Modal.confirm({
				header: this.$translate.instant('common.confirm_delete_title'),
				message: this.$translate.instant('common.confirm_delete_message'),
				callback: function callback(_ref3) {
					var modal = _ref3.modal,
					    $scope = _ref3.$scope;

					_this8.contractRules.splice(index, 1);
					_this8.billingRulesOptions.splice(index, 1);
					var dataObj = {
						contractName: _this8.model.contractName, description: billingRuleObj.description,
						contractId: _this8.model.contractId, contractRuleId: billingRuleObj.contractRulesId,
						contractRulesLocations: billingRuleObj.contractRulesLocations
					};
					setTimeout(function () {
						if (dataObj.contractRuleId === undefined || dataObj.contractRuleId === null) return;

						_this8.model.contractStartDate = _this8.model.contractStartDate ? moment(_this8.model.contractStartDate).format('YYYY-MM-DD') : null;
						_this8.model.contractEndDate = _this8.model.contractEndDate ? moment(_this8.model.contractEndDate).format('YYYY-MM-DD') : null;
						_this8.generateBillingRules('value');
						_this8.model.billingIncrement = _this8.model.selectedBillingDuration;
						_this8.model.createdByUserId = _this8.User.getUser().id;
						_this8.model.modifiedByUserId = _this8.User.getUser().id;
						_this8.loading = true;
						_this8.Service.deleteContractRule(_this8.rawId, dataObj, _this8.branchId).then(function (data) {
							_this8.generateContractBillingRules();
							_this8.generateBillingRules('value');
							_this8.getContractDetails();
						}).catch(function (err) {
							if (err.data.errors) {
								err.data.errors.map(function (e) {
									_this8.errorMessage += e.message + '<br/>';
								});
							} else {
								_this8.errorMessage = err.data.message;
							}
						}).finally(function () {
							_this8.loading = false;
						});
					}, 200);
					modal.close();
					// if(this.billingRulesOptions.length == 0 ) return this.requiredStartDate = false;
					_this8.isStartDateIsRequired();
					_this8.validateStaticBillingOptions();
					_this8.updateContractStats(_this8.billingRulesOptions);
				},
				negative: function negative(_ref4) {
					var modal = _ref4.modal;

					modal.close();
				},
				type: 'danger'
			});
		}
	}, {
		key: 'getTime',
		value: function getTime(time) {
			var billingType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			if (!time) {
				return time;
			}

			time = moment(time).format('HH:mm:ss');

			time = time.split(':');

			var d = new Date();

			d.setHours(+time[0]);
			d.setMinutes(time[1]);
			d.setSeconds(time[2]);
			// d.setMilliseconds(0);
			var timeFormat = billingType == 'service_ticket_overage_time_charge' ? 'HH:mm:ss' : '00:mm:ss';
			return moment(d).format(timeFormat);
		}

		// generateContractRules() {
		// 	if (!this.contractRules.length) return [];
		// 	const rules = [];

		// 	this.contractRules.forEach((obj) => {
		// 		if (obj.id) {
		// 			rules.push({
		// 				billingEvent: obj.billingEvent,
		// 				locationType: obj.locationType,
		// 				orderType: obj.orderType,
		// 				billingType: obj.billingType,
		// 				minQty: obj.minQty || null,
		// 				maxQty: obj.maxQty || null,
		// 				minAmount: obj.minAmount || null,
		// 				maxAmount: obj.maxAmount || null,
		// 				beginTime: obj.beginTime,
		// 				endTime: obj.endTime,
		// 				billingRate: obj.billingRate,
		// 				currencyId: obj.currencyId
		// 			})
		// 		}
		// 		else {
		// 			rules.push({
		// 				billingEvent: obj.billingEvent.key,
		// 				locationType: obj.locationType.value,
		// 				orderType: obj.orderType.value,
		// 				billingType: obj.billingTypeObj.billingType.value,
		// 				minQty: obj.billingTypeObj.min || null,
		// 				maxQty: obj.billingTypeObj.max || null,
		// 				minAmount: obj.billingTypeObj.minAmount || null,
		// 				maxAmount: obj.billingTypeObj.maxAmount || null,
		// 				beginTime: obj.billingTypeObj.beginTime ? moment(obj.billingTypeObj.beginTime).format('00:mm:ss') : null,
		// 				endTime: obj.billingTypeObj.endTime ? moment(obj.billingTypeObj.endTime).format('00:mm:ss') : null,
		// 				billingRate: obj.billingRateObj.rate,
		// 				currencyId: obj.billingRateObj.currency
		// 			})
		// 		}
		// 	})
		// 	return rules;
		// }

	}, {
		key: 'translateMessage',
		value: function translateMessage(prefix, key) {
			if (!key) return;else if (key === 'shipment-delivered') return this.$translate.instant('itemHolds.shipment_delivery');
			return this.$translate.instant(prefix.concat(key));
		}
	}, {
		key: 'formatTime',
		value: function formatTime(time) {
			var billingType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			if (!time) return;
			return moment(time, ["HH:mm:ss"]).format(billingType === 'SERVICE_TICKET_OVERAGE_TIME_CHARGE' ? 'HH:mm:ss' : '00:mm:ss');
		}
	}, {
		key: 'addBillingRules',
		value: function addBillingRules(event) {
			this.billingRulesOptions.push({
				name: null,
				description: null,
				generalLedgerCode: null,
				status: true,
				isValidBillingRules: false,
				billingEventObj: {
					billingEvent: null,
					billingEventOptions: null,
					preBillingEventOptions: _.cloneDeep(this.preBillingEventOptions),
					postBillingEventOptions: _.cloneDeep(this.postBillingEventOptions)
				},
				locationTypeObj: {
					locationType: null,
					locationTypeOptions: []
				},
				serviceTypeObj: {
					serviceType: null,
					serviceTypeOptions: []
				},
				scheduleTypeObj: {
					scheduleType: null,
					scheduleTypeOptions: this.scheduleTypeOptions
				},
				orderTypeObj: {
					orderType: null,
					orderTypeOptions: []
				},
				billingTypeObj: {
					billingType: null,
					billingTypeOptions: this.billingTypeOptions
				},
				dollarRate: null,
				percentageRate: null,
				dollarRateAbove: null,
				percentageRateAbove: null,
				dollarRateBelow: null,
				percentageRateBelow: null,
				itemThreshold: null,
				valueThreshold: null,
				timeThreshold: null,
				itemIncrement: null,
				valueIncrement: null,
				timeIncrement: null,
				isEdit: true,
				isNew: true,
				applyWrapFee: false,
				wrapFee: null,
				billingTime: 'POST',
				locationDistanceId: null,
				rateFirstHour: null,
				rateFifteenMinutes: null,
				serviceTimeTypeObj: {
					serviceTimeType: []
				},
				contractRulesLocations: [],
				locationList: [],
				sequence: this.billingRulesOptions.length + 1,
				customerList: [],
				billableEventId: null,
				billingCategoryId: null,
				billingCategoryObj: {
					billingCategory: null,
					billingCategoryOptions: _.cloneDeep(this.billingCategoryOptions)
				},
				overageRate: null,
				contractLocationsDistance: [],
				locationOptions: [],
				startDate: this.model.contractStartDate ? moment(this.model.contractStartDate) : new Date(),
				endDate: null
			});
			if (this.model.useCustomerOnBillingRules == true) {
				this.getContractLocationList('', undefined, 1, this.billingRulesOptions.length - 1);
			} else {
				this.getCustomerLocationList('', undefined, 1, false, this.billingRulesOptions.length - 1);
			}
			event.preventDefault();
		}
	}, {
		key: 'validateBillingRuleFormControl',
		value: function validateBillingRuleFormControl() {
			var _this9 = this;

			var disableButton = this.billingRulesOptions.map(function (data) {
				_this9.isValidFormControl = true;
				_this9.isValidFormControl = _this9.isValidFormControl && data.isValidBillingRules;
				return _this9.isValidFormControl;
			});
			if (disableButton.indexOf(false) >= 0 && this.billingRulesOptions.length > 0) return false;else return true;
		}

		// removeBillingRules(index) {
		// 	this.Modal.confirm({
		// 		header: this.$translate.instant('common.confirm_delete_title'),
		// 		message: this.$translate.instant('common.confirm_delete_message'),
		// 		callback: (({
		// 			modal,
		// 			$scope
		// 		}) => {
		// 			this.billingRulesOptions.splice(index, 1);
		// 			modal.close();
		// 		}),
		// 		negative: (({
		// 			modal,
		// 		}) => {
		// 			modal.close();
		// 		}),
		// 		type: 'danger'
		// 	})
		// }

	}, {
		key: 'locationTypeOptionChoice',
		value: function locationTypeOptionChoice(obj) {
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (['shipment-delivered', 'shipment-pickup', 'delivery-order-pack', 'pickup-deposit', 'shipment-delivery-cant', 'coin-pickup', 'deposit-count', 'stop-completed'].indexOf(selectedBillingEvent) > -1) {
				obj.locationTypeObj.locationTypeOptions = this.locationTypeOptions['other'];
			} else if (['coin-delivery'].indexOf(selectedBillingEvent) > -1) {
				obj.locationTypeObj.locationTypeOptions = [].concat((0, _toConsumableArray3.default)(this.locationTypeOptions['other']), (0, _toConsumableArray3.default)(this.locationTypeOptions['ATM']));
			} else if (selectedBillingEvent == 'coin-conversion') {
				var option = { label: 'Any', value: 'any' };
				obj.locationTypeObj.locationTypeOptions = [option];
				obj.locationTypeObj.locationType = option;
			} else {
				obj.locationTypeObj.locationTypeOptions = this.locationTypeOptions['ATM'];
			}
		}
	}, {
		key: 'serviceTypeOptionChoice',
		value: function serviceTypeOptionChoice(obj, index) {
			this.isDisableServiceTypeOptions[index] = { disabled: false };
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
				obj.serviceTypeObj.serviceTypeOptions = [this.serviceTypeOptions['other'][0]].concat((0, _toConsumableArray3.default)(this.serviceTypeOptions['regular']), (0, _toConsumableArray3.default)(this.serviceTypeOptions['flm']), (0, _toConsumableArray3.default)(this.serviceTypeOptions['slm']));
				this.isDisableServiceTypeOptions[index].disabled = false;
			} else if (['stop-completed', 'atm-cash-delivery', 'coin-pickup', 'coin-delivery', 'shipment-delivery-cant', 'shipment-pickup', 'shipment-delivered', 'atm-cash-pickup', 'atm-deposit-pickup'].indexOf(selectedBillingEvent) > -1) {
				obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['other'];
				this.isDisableServiceTypeOptions[index].disabled = false;
			} else if (['atm-load-service', 'atm-load-cant'].indexOf(selectedBillingEvent) > -1) {
				obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['atmLoad'];
				this.isDisableServiceTypeOptions[index].disabled = false;
			} else {
				obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['none'];
				obj.serviceTypeObj.serviceType = this.serviceTypeOptions['none'][0];
				if (['deposit-count', 'atm-order-pack', 'pickup-deposit', 'atm-residual-deposit', 'delivery-order-pack', 'atm-residual-count', 'atm-deposit-count'].indexOf(selectedBillingEvent) > -1) {
					this.isDisableServiceTypeOptions[index].disabled = true;
				}
			}
		}
	}, {
		key: 'orderTypeOptionChoice',
		value: function orderTypeOptionChoice(obj) {
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (['shipment-delivered', 'shipment-pickup', 'delivery-order-pack', 'pickup-deposit', 'shipment-delivery-cant', 'deposit-count'].indexOf(selectedBillingEvent) > -1) {
				obj.orderTypeObj.orderTypeOptions = [].concat((0, _toConsumableArray3.default)(this.orderTypeOptions['cash_coin']), (0, _toConsumableArray3.default)(this.orderTypeOptions['cash_only']), (0, _toConsumableArray3.default)(this.orderTypeOptions['coin_only']));
			} else if (['atm-residual-count', 'atm-load-service', 'atm-order-pack', 'atm-residual-deposit', 'atm-deposit-pickup', 'atm-deposit-count', 'atm-load-cant', 'atm-cash-delivery', 'atm-cash-pickup'].indexOf(selectedBillingEvent) > -1) {
				obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['ATM'];
			} else if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
				obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['services'];
			} else if (['coin-pickup', 'coin-delivery'].indexOf(selectedBillingEvent) > -1) {
				obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['coin_only'];
			} else if (['stop-completed', 'coin-conversion'].indexOf(selectedBillingEvent) > -1) {
				var option = { label: 'Any', value: 'none' };
				obj.orderTypeObj.orderTypeOptions = [option];
				obj.orderTypeObj.orderType = option;
			} else {
				obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['other'];
			}
		}
	}, {
		key: 'validateBillingType',
		value: function validateBillingType(obj, index) {
			obj.dollarRate = null;
			obj.percentageRate = null;
			obj.dollarRateAbove = null;
			obj.percentageRateAbove = null;
			obj.dollarRateBelow = null;
			obj.percentageRateBelow = null;
			obj.itemThreshold = null;
			obj.valueThreshold = null;
			obj.timeThreshold = null;
			obj.itemIncrement = null;
			obj.valueIncrement = null;
			obj.timeIncrement = null;
			obj.applyWrapFee = false;
			obj.wrapFee = null;
			obj.billingTime = obj.billingEventObj.billingEvent && obj.billingEventObj.billingEvent.value === 'pre-bill' && obj.billingTypeObj.billingType.value === 'fixed' ? obj.billingTime = 'PRE' : 'POST';
			obj.locationDistanceId = null;
			obj.rateFirstHour = null;
			obj.rateFifteenMinutes = null;
			obj.serviceTimeTypeObj = {
				serviceTimeType: []
			}, obj.overageRate = null;
			if (obj.billingTypeObj.billingType.value !== 'drive_distance') {
				this.model.useCustomerOnBillingRules === true ? this.getContractLocationList('', undefined, 1, index) : this.getCustomerLocationList('', undefined, 1, false, index);
			}
		}
	}, {
		key: 'resetLocationAndServiceType',
		value: function resetLocationAndServiceType(obj) {
			obj.serviceTypeObj.serviceTypeOptions = [];
			obj.locationTypeObj.locationTypeOptions = [];
		}
	}, {
		key: 'generateBillingRules',
		value: function generateBillingRules(type) {
			var _this10 = this;

			if (!this.billingRulesOptions.length) return [];
			this.contractRules = [];

			this.billingRulesOptions.forEach(function (obj) {
				_this10.contractRules.push({
					name: obj.name,
					description: obj.description,
					generalLedgerCode: obj.generalLedgerCode || null,
					status: obj.status,
					billingEvent: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent[type] : null,
					billingEventLabel: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent.label : null,
					locationType: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType[type] : 'NONE',
					locationTypeLabel: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType.label : 'NONE',
					serviceType: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType[type] : 'NONE',
					serviceTypeLabel: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType.label : 'NONE',
					scheduleType: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType[type] : 'NONE',
					scheduleTypeLabel: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType.label : 'NONE',
					orderType: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType[type] : 'NONE',
					orderTypeLabel: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType.label : 'NONE',
					billingType: obj.billingTypeObj && obj.billingTypeObj.billingType ? obj.billingTypeObj.billingType[type] : null,
					billingTypeLabel: obj.billingTypeObj && obj.billingTypeObj.billingType ? obj.billingTypeObj.billingType.label : null,
					dollarRate: obj.dollarRate >= 0 ? obj.dollarRate : null,
					percentageRate: obj.percentageRate >= 0 ? obj.percentageRate : null,
					dollarRateAbove: obj.dollarRateAbove >= 0 ? obj.dollarRateAbove : null,
					percentageRateAbove: obj.percentageRateAbove >= 0 ? obj.percentageRateAbove : null,
					dollarRateBelow: obj.dollarRateBelow >= 0 ? obj.dollarRateBelow : null,
					percentageRateBelow: obj.percentageRateBelow >= 0 ? obj.percentageRateBelow : null,
					itemThreshold: obj.itemThreshold >= 0 ? obj.itemThreshold : null,
					itemIncrement: obj.itemIncrement >= 0 ? obj.itemIncrement : null,
					valueThreshold: obj.valueThreshold >= 0 ? obj.valueThreshold : null,
					valueIncrement: obj.valueIncrement >= 0 ? obj.valueIncrement : null,
					timeThreshold: _this10.ifUndefined(obj.timeThreshold) ? obj.timeThreshold : null,
					timeIncrement: _this10.ifUndefined(obj.timeIncrement) ? obj.timeIncrement : null,
					currencyId: 'USD',
					applyWrapFee: obj.applyWrapFee,
					wrapFee: obj.wrapFee,
					billingTime: obj.billingTypeObj && obj.billingTypeObj.billingType && obj.billingTypeObj.billingType[type] === 'fixed' ? obj.billingTime : null,
					locationDistanceId: obj.locationDistanceId,
					rateFirstHour: obj.rateFirstHour,
					rateFifteenMinutes: obj.rateFifteenMinutes,
					serviceTimeType: obj.serviceTimeTypeObj.serviceTimeType.map(function (d) {
						return d.value;
					}).toString(),
					billToCustomerId: obj.billToCustomerId ? obj.billToCustomerId.Value : null,
					contractRulesLocations: obj.contractRulesLocations,
					preBillingEvents: obj.billingEventObj.preBillingEvents,
					postBillingEvents: obj.billingEventObj.postBillingEvents,
					contractRulesId: obj.contractRulesId,
					sequence: _this10.contractRules.length + 1,
					billableEventId: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent.id : null,
					billingCategoryId: obj.billingCategoryObj && obj.billingCategoryObj.billingCategory ? obj.billingCategoryObj.billingCategory.billingCategoryId : null,
					overageRate: obj.overageRate,
					customerLocationsDistance: obj.customerLocationsDistance,
					contractLocationsDistance: obj.contractLocationsDistance,
					startDate: obj.startDate,
					endDate: obj.endDate ? obj.endDate : null
				});
			});
		}
	}, {
		key: 'setEditFlag',
		value: function setEditFlag(obj) {
			obj.isEdit = false;
		}
	}, {
		key: 'saveBillingRules',
		value: function saveBillingRules(obj, index) {
			var _this11 = this;

			this.loading = true;
			obj.isValidBillingRules = true;
			obj.timeThreshold = obj.timeThreshold ? this.getTime(obj.timeThreshold, obj.billingTypeObj.billingType['value']) : null;
			obj.timeIncrement = obj.timeIncrement ? this.getTime(obj.timeIncrement) : null;

			setTimeout(function () {
				_this11.model.contractStartDate = _this11.model.contractStartDate ? moment(_this11.model.contractStartDate).format('YYYY-MM-DD') : null;
				_this11.model.contractEndDate = _this11.model.contractEndDate ? moment(_this11.model.contractEndDate).format('YYYY-MM-DD') : null;
				var ruleEndDate = _this11.contractRules[index] && _this11.contractRules[index].endDate ? moment(_this11.contractRules[index].endDate).format('YYYY-MM-DD') : null;
				var ruleStartDate = _this11.contractRules[index] && _this11.contractRules[index].startDate ? moment(_this11.contractRules[index].startDate).format('YYYY-MM-DD') : null;
				_this11.generateBillingRules('value');
				var contractRules = [];

				var type = 'value';

				new Array(_this11.billingRulesOptions[index]).forEach(function (obj) {
					contractRules.push({
						name: obj.name,
						description: obj.description,
						generalLedgerCode: obj.generalLedgerCode || null,
						status: obj.status,
						billingEvent: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent[type] : null,
						billingEventLabel: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent.label : null,
						locationType: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType[type] : 'NONE',
						locationTypeLabel: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType.label : 'NONE',
						serviceType: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType[type] : 'NONE',
						serviceTypeLabel: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType.label : 'NONE',
						scheduleType: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType[type] : 'NONE',
						scheduleTypeLabel: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType.label : 'NONE',
						orderType: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType[type] : 'NONE',
						orderTypeLabel: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType.label : 'NONE',
						billingType: obj.billingTypeObj.billingType[type],
						billingTypeLabel: obj.billingTypeObj.billingType.label,
						dollarRate: obj.dollarRate >= 0 ? obj.dollarRate : null,
						percentageRate: obj.percentageRate >= 0 ? obj.percentageRate : null,
						dollarRateAbove: obj.dollarRateAbove >= 0 ? obj.dollarRateAbove : null,
						percentageRateAbove: obj.percentageRateAbove >= 0 ? obj.percentageRateAbove : null,
						dollarRateBelow: obj.dollarRateBelow >= 0 ? obj.dollarRateBelow : null,
						percentageRateBelow: obj.percentageRateBelow >= 0 ? obj.percentageRateBelow : null,
						itemThreshold: obj.itemThreshold >= 0 ? obj.itemThreshold : null,
						itemIncrement: obj.itemIncrement >= 0 ? obj.itemIncrement : null,
						valueThreshold: obj.valueThreshold >= 0 ? obj.valueThreshold : null,
						valueIncrement: obj.valueIncrement >= 0 ? obj.valueIncrement : null,
						timeThreshold: _this11.ifUndefined(obj.timeThreshold) ? obj.timeThreshold : null,
						timeIncrement: _this11.ifUndefined(obj.timeIncrement) ? obj.timeIncrement : null,
						currencyId: 'USD',
						applyWrapFee: obj.applyWrapFee,
						wrapFee: obj.wrapFee,
						billingTime: obj.billingTypeObj.billingType[type] === 'fixed' ? obj.billingTime : null,
						locationDistanceId: obj.locationDistanceId,
						rateFirstHour: obj.rateFirstHour,
						rateFifteenMinutes: obj.rateFifteenMinutes,
						serviceTimeType: obj.serviceTimeTypeObj.serviceTimeType.map(function (d) {
							return d.value;
						}).toString(),
						billToCustomerId: obj.billToCustomerId ? obj.billToCustomerId.Value : null,
						contractRulesLocations: obj.contractRulesLocations,
						preBillingEvents: obj.billingEventObj.preBillingEvents,
						postBillingEvents: obj.billingEventObj.postBillingEvents,
						contractRulesId: obj.contractRulesId,
						sequence: obj.sequence,
						billableEventId: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent.id : null,
						billingCategoryId: obj.billingCategoryObj && obj.billingCategoryObj.billingCategory ? obj.billingCategoryObj.billingCategory.billingCategoryId : null,
						recordStatus: !obj.contractRulesId ? 'new' : 'update',
						overageRate: obj.overageRate,
						customerLocationsDistance: obj.customerLocationsDistance,
						contractLocationsDistance: obj.contractLocationsDistance,
						startDate: obj.startDate ? moment(obj.startDate).format('YYYY-MM-DD') : null,
						endDate: obj.endDate ? moment(obj.endDate).format('YYYY-MM-DD') : null
					});
				});
				if (_this11.billingRulesOptions[index].contractRulesId) {
					var contractRulesData = null;
					if (_this11.contractRules) {
						contractRulesData = _this11.contractRules[index];
					}

					var contractBillingRules = _this11.contractBillingRules[index];
					// const preBillingEvents = contractBillingRules.preBillingEvents ? contractBillingRules.preBillingEvents : [];
					var preBillingEvents = contractBillingRules.preBillingEvents ? contractBillingRules.preBillingEvents.map(function (e) {
						return e.id;
					}) : [];
					var postBillingEvents = contractBillingRules.postBillingEvents ? contractBillingRules.postBillingEvents.map(function (e) {
						return e.id;
					}) : [];

					var contractRulesPreBillingEvents = [];
					var contractRulesPostBillingEvents = [];
					if (contractRulesData) {
						if (contractRulesData.preBillingEvents) {
							contractRulesPreBillingEvents = contractRulesData.preBillingEvents.map(function (e) {
								return e.id;
							});
						}
						if (contractRulesData.postBillingEvents) {
							contractRulesPostBillingEvents = contractRulesData.postBillingEvents.map(function (e) {
								return e.id;
							});
						}
					}

					var diff = _this11.findDifferencesWithReturn((0, _extends4.default)({}, contractBillingRules, {
						preBillingEvents: preBillingEvents,
						postBillingEvents: postBillingEvents,
						startDate: ruleStartDate,
						endDate: ruleEndDate
					}), (0, _extends4.default)({}, contractRulesData, {
						preBillingEvents: contractRulesPreBillingEvents,
						postBillingEvents: contractRulesPostBillingEvents,
						startDate: _this11.billingRulesOptions[index].startDate ? moment(_this11.billingRulesOptions[index].startDate).format('YYYY-MM-DD') : null,
						endDate: _this11.billingRulesOptions[index].endDate ? moment(_this11.billingRulesOptions[index].endDate).format('YYYY-MM-DD') : null
					}));

					_this11.model.changedObj = diff;
				}

				_this11.model.contractRules = contractRules;
				_this11.contractRules.push(contractRules);

				_this11.model.billingIncrement = _this11.model.selectedBillingDuration;
				_this11.model.createdByUserId = _this11.User.getUser().id;
				_this11.model.modifiedByUserId = _this11.User.getUser().id;

				_this11.Service.updateContractRule(_this11.rawId, _this11.model, _this11.branchId).then(function (data) {
					obj.isEdit = false;
					delete _this11.model.changedObj;
					data.results.forEach(function (info) {
						_this11.billingRulesOptions[index].contractRulesId = info.id;
						_this11.defaultModel.contractRulesData.push(info);
					});
					_this11.billingRulesOptions[index].isNew = false;
					_this11.generateContractBillingRules();
					if (!_this11.mainFormChanged) {
						_this11.getContractDetails();
					}
					_this11.generateBillingRules('value');
					_this11.getContractRulesLocation();
				}).catch(function (err) {
					obj.isEdit = true;
					if (err.data.errors) {
						err.data.errors.map(function (e) {
							_this11.errorMessage += e.message + '<br/>';
						});
					} else {
						_this11.errorMessage = err.data.message;
					}
				}).finally(function () {
					_this11.loading = false;
				});
			}, 200);

			return false;
		}
	}, {
		key: 'closeFormEdit',
		value: function closeFormEdit(obj, i) {
			obj.isEdit = false;
			obj.isValidBillingRules = true;
			this.showAllFlag = false;
			this.billingRulesOptions[i] = (0, _extends4.default)({}, this.tempEditValue[i], { isEdit: false, isValidBillingRules: true });
			delete this.tempEditValue[i];
		}
	}, {
		key: 'percentageMask',
		value: function percentageMask(input, decimals) {
			return this.$filter('number')(input, decimals) + '%';
		}
	}, {
		key: 'editBillingRules',
		value: function editBillingRules(obj, index) {

			var clonedObj = _.cloneDeep(obj);
			clonedObj.isEdit = true;
			obj.isEdit = clonedObj.isEdit;
			clonedObj.isValidBillingRules = false;
			obj.timeThreshold = obj.timeThreshold ? this.convertTimeThresholdValue(obj.timeThreshold) : null;
			obj.timeIncrement = obj.timeIncrement ? this.convertTimeThresholdValue(obj.timeIncrement) : null;
			this.tempEditValue = (0, _extends4.default)({}, this.tempEditValue, (0, _defineProperty3.default)({}, index, clonedObj));
			//load filtered customerLocationDistance
			if (this.model.useCustomerOnBillingRules === false) {
				if (clonedObj.customerLocationsDistance && _.isEmpty(clonedObj.contractRulesLocations)) {
					this.locationDistance = clonedObj.locationDistanceId;
				} else if (_.isEmpty(clonedObj.customerLocationsDistance) && clonedObj.contractRulesLocations) {
					clonedObj.contractRulesLocations = [];
					this.locationDistance = clonedObj.locationDistanceId;
				} else if (clonedObj.contractRulesLocations.length !== clonedObj.customerLocationsDistance.length || !_.isEqual(clonedObj.contractRulesLocations, clonedObj.customerLocationsDistance)) {

					if (clonedObj.contractRulesLocations.every(function (location) {
						return clonedObj.customerLocationsDistance.includes(location);
					})) {
						this.locationDistance = clonedObj.locationDistanceId;
					} else {
						clonedObj.contractRulesLocations = [];
						this.locationDistance = null;
					}
				} else {
					this.locationDistance = clonedObj.locationDistanceId;
				}
				this.getCustomerLocationList('', clonedObj.locationDistanceId ? clonedObj.locationDistanceId : null, 1, false, index);
			}

			if (this.model.useCustomerOnBillingRules === true) {
				if (clonedObj.contractLocationsDistance && _.isEmpty(clonedObj.contractRulesLocations)) {
					this.contractLocationDistance = clonedObj.locationDistanceId;
				} else if (_.isEmpty(clonedObj.contractLocationsDistance) && clonedObj.contractRulesLocations) {
					clonedObj.contractRulesLocations = [];
					this.contractLocationDistance = clonedObj.locationDistanceId;
				} else if (clonedObj.contractRulesLocations.length !== clonedObj.contractLocationsDistance.length || !_.isEqual(clonedObj.contractRulesLocations, clonedObj.contractLocationsDistance)) {

					if (clonedObj.contractRulesLocations.every(function (location) {
						return clonedObj.contractLocationsDistance.includes(location);
					})) {
						this.contractLocationDistance = clonedObj.locationDistanceId;
					} else {
						clonedObj.contractRulesLocations = [];
						this.contractLocationDistance = null;
					}
				} else {
					this.contractLocationDistance = clonedObj.locationDistanceId;
				}
				this.getContractLocationList('', clonedObj.locationDistanceId ? clonedObj.locationDistanceId : null, 1, index);
			}
		}
	}, {
		key: 'duplicateBillingRule',
		value: function duplicateBillingRule(obj) {
			var records = _.cloneDeep(obj);
			records.contractRulesId = null;
			records.isNew = true;
			records.sequence = this.billingRulesOptions.length + 1;
			this.editBillingRules(records);
			this.model.useCustomerOnBillingRules ? this.getContractLocationList('', obj.locationDistanceId ? obj.locationDistanceId : null, 1, this.billingRulesOptions.length) : this.getCustomerLocationList('', obj.locationDistanceId ? obj.locationDistanceId : null, 1, false, this.billingRulesOptions.length);
			this.billingRulesOptions.push(records);
			this.validateStaticBillingOptions();
		}
	}, {
		key: 'convertTimeThresholdValue',
		value: function convertTimeThresholdValue(time) {
			if (!time) {
				return time;
			}

			if (time instanceof Date) {
				time = moment(time).format('HH:mm:ss');
			}

			time = time.split(':');

			var d = new Date();

			d.setHours(+time[0]);
			d.setMinutes(time[1]);
			d.setSeconds(time[2]);
			d.setMilliseconds(0);

			return d;
		}
	}, {
		key: 'isInvalidForm',
		value: function isInvalidForm() {
			return !this.model.contractId || !this.model.contractName || !this.model.selectedBillingDuration || !this.model.contractStartDate && this.requiredStartDate || !this.model.contractStartDate;
		}
	}, {
		key: 'isBailmentInterestValid',
		value: function isBailmentInterestValid() {
			var bailmentInterestRegex = /^(?:100(?:\.0{1,2})?|([1-9][0-9]?|0)(?:\.[0-9]{1,2})?)%?$/;
			return this.model.bailmentInterest === null || this.model.bailmentInterest === '' || bailmentInterestRegex.test(this.model.bailmentInterest);
		}
	}, {
		key: 'resetBillingRules',
		value: function resetBillingRules(index) {
			this.billingRulesOptions[index] = this.existingBillingRules[index];
		}
	}, {
		key: 'cloneExistingBillingRules',
		value: function cloneExistingBillingRules(obj, index) {
			this.existingBillingRules[index] = {};
			this.existingBillingRules[index] = _.cloneDeep(obj);
		}
	}, {
		key: 'ifUndefined',
		value: function ifUndefined(v, mixed) {
			return typeof v === 'undefined' || v === null ? mixed : v;
		}
	}, {
		key: 'getBillableEvents',
		value: function getBillableEvents() {
			var _this12 = this;

			this.billingEventOptions = [], this.contractBillingRules = [];this.preBillingEventOptions = [];this.postBillingEventOptions = [];
			this.BillableEventsService.all(null, 0, 100).then(function (events) {
				events.results.forEach(function (d) {
					_this12.preBillingEventOptions.push({
						id: d.id,
						label: _this12.$translate.instant('entry_type.' + d.type),
						value: d.type
					});
				});
				_this12.preBillingEventOptions = _.sortBy(_this12.preBillingEventOptions, ['label', 'ASC']);
				_this12.postBillingEventOptions = _.sortBy(_this12.preBillingEventOptions, ['label', 'ASC']);

				var billableEvents = events.results.reduce(function (acc, result) {
					var categoryName = result.billingCategory.name;
					acc[categoryName] = acc[categoryName] || {
						billingEvents: [],
						billingCategoryId: result.billingCategoryId
					};
					acc[categoryName].billingEvents.push({
						id: result.id,
						label: _this12.$translate.instant('entry_type.' + result.type),
						value: result.type
					});
					return acc;
				}, {});

				_this12.billingCategoryOptions = (0, _keys2.default)(billableEvents).map(function (key) {
					return {
						label: key,
						billingCategoryId: billableEvents[key].billingCategoryId,
						billingEvents: billableEvents[key].billingEvents
					};
				});

				// this.billingEventOptions = _.sortBy(this.billingEventOptions, ['label', 'ASC']);
				// TODO: better solution for this
				_this12.contractRules.forEach(function (cr, index) {

					if (cr.serviceTimeType) {
						var serviceTimeType = cr.serviceTimeType.split(',');
						_this12.serviceTimeTypes.forEach(function (stt) {
							serviceTimeType.forEach(function (v) {
								if (stt.value === v) {
									stt.ticked = true;
								}
							});
						});
					}

					_this12.billingRulesOptions.push({
						name: cr.name,
						description: cr.description,
						generalLedgerCode: cr.generalLedgerCode,
						status: cr.status,
						isValidBillingRules: true,
						billingEventObj: {
							billingEvent: null,
							billingEventOptions: null,
							preBillingEventOptions: _.cloneDeep(_this12.preBillingEventOptions),
							postBillingEventOptions: _.cloneDeep(_this12.postBillingEventOptions)
						},
						scheduleTypeObj: {
							scheduleType: cr.scheduleType ? _.find(_this12.scheduleTypeOptions, { 'value': cr.scheduleType.toLowerCase() }) : null,
							scheduleTypeOptions: _this12.scheduleTypeOptions
						},
						billingTypeObj: {
							billingType: cr.billingType ? _.find(_this12.billingTypeOptions, { 'value': cr.billingType.toLowerCase() }) : null,
							billingTypeOptions: _this12.billingTypeOptions
						},
						dollarRate: cr.dollarRate,
						percentageRate: cr.percentageRate,
						dollarRateAbove: cr.dollarRateAbove,
						percentageRateAbove: cr.percentageRateAbove,
						dollarRateBelow: cr.dollarRateBelow,
						percentageRateBelow: cr.percentageRateBelow,
						itemThreshold: cr.itemThreshold,
						valueThreshold: cr.valueThreshold,
						timeThreshold: _this12.formatTime(cr.timeThreshold, cr.billingType),
						itemIncrement: cr.itemIncrement,
						valueIncrement: cr.valueIncrement,
						timeIncrement: _this12.formatTime(cr.timeIncrement),
						isEdit: false,
						contractRulesId: cr.id,
						applyWrapFee: cr.applyWrapFee,
						wrapFee: cr.wrapFee,
						billingTime: cr.billingTime,
						locationDistanceId: cr.locationDistanceId,
						locationDistance: cr.locationDistance,
						rateFirstHour: cr.rateFirstHour,
						rateFifteenMinutes: cr.rateFifteenMinutes,
						serviceTimeTypeObj: {
							serviceTimeType: []
						},
						locationList: [],
						customerList: [],
						contractRulesLocations: _.cloneDeep(cr.locationApplicable),
						billToCustomerId: cr.customerId && cr.customer.isEnabled ? {
							Key: cr.customer.id + ' | ' + cr.customer.name,
							Value: cr.customer.id
						} : null,
						preBillingEvents: _.cloneDeep(cr.preBillingEvents),
						postBillingEvents: _.cloneDeep(cr.postBillingEvents),
						sequence: cr.sequence,
						billableEventId: cr.billableEventId,
						billingCategoryId: cr.billingCategoryId,
						billingCategoryObj: {
							billingCategory: {
								label: cr.billingCategory ? cr.billingCategory.name : null,
								billingCategoryId: cr.billingCategory ? cr.billingCategory.id : null,
								billingEvents: cr.billingCategory ? _this12.billingCategoryOptions.filter(function (d) {
									return d.billingCategoryId === cr.billingCategory.id;
								}).map(function (c) {
									return c.billingEvents;
								}) : []
							},
							billingCategoryOptions: _.cloneDeep(_this12.billingCategoryOptions)
						},
						extraDetails: {
							billingType: cr.billingType,
							billingEvent: cr.billingEvent,
							locationType: cr.locationType,
							serviceType: cr.serviceType,
							orderType: cr.orderType
						},
						overageRate: cr.overageRate,
						customerLocationsDistance: _.cloneDeep(cr.customerLocationsDistance),
						contractLocationsDistance: _.cloneDeep(cr.contractLocationsDistance),
						locationOptions: [],
						startDate: cr.startDate ? _this12.DateUtil.convertToDate(cr.startDate) : null,
						endDate: cr.endDate ? _this12.DateUtil.convertToDate(cr.endDate) : null
					});
				});

				_this12.billingRulesOptions.forEach(function (br, index) {
					var preBillingEvents = [],
					    postBillingEvents = [];
					if (br.extraDetails.billingType) _this12.billingTypeOptionChoice(br);

					br.billingEventObj.preBillingEventOptions.forEach(function (pbe) {
						if (br.preBillingEvents.includes(pbe.id)) {
							preBillingEvents.push(pbe);
							pbe.ticked = true;
						}
					});

					br.billingEventObj.postBillingEventOptions.forEach(function (pbe) {
						if (br.postBillingEvents.includes(pbe.id)) {
							postBillingEvents.push(pbe);
							pbe.ticked = true;
						}
					});

					br.billingEventObj.billingEventOptions = br.billingCategoryObj.billingCategory.billingEvents && br.billingCategoryObj.billingCategory.billingEvents.length > 0 ? br.billingCategoryObj.billingCategory.billingEvents[0] : [];

					var billingEvent = br.extraDetails.billingEvent ? _.find(br.billingEventObj.billingEventOptions, { 'value': br.extraDetails.billingEvent }) : null;

					br.billingEventObj.billingEvent = billingEvent;
					br.billingEventObj.preBillingEvents = preBillingEvents;
					br.billingEventObj.postBillingEvents = postBillingEvents;

					var selectedBillingEvent = void 0;
					if (billingEvent) {
						selectedBillingEvent = billingEvent.value;
					} else {
						selectedBillingEvent = br.extraDetails.billingEvent;
					}
					var locationTypeOptions = selectedBillingEvent === 'coin-delivery' ? [].concat((0, _toConsumableArray3.default)(_this12.locationTypeOptions['other']), (0, _toConsumableArray3.default)(_this12.locationTypeOptions['ATM'])) : selectedBillingEvent === 'coin-conversion' ? [_this12.locationTypeOptions.other[0]] : br.extraDetails.locationType && ['any', 'regular', 'nsng', 'on_call', 'bank'].includes(br.extraDetails.locationType.toLowerCase()) ? _this12.locationTypeOptions['other'] : _this12.locationTypeOptions['ATM'];

					var serviceTypeOptions = _this12.loadServiceTypeOptionChoice(selectedBillingEvent, br.extraDetails.serviceType, index);

					if (selectedBillingEvent === 'coin-conversion') {
						var perItemOption = _this12.billingTypeOptions.find(function (bt) {
							return bt.value === 'per_item';
						});
						br.billingTypeObj.billingTypeOptions = [perItemOption];
						br.billingTypeObj.billingType = { label: "Per Item", value: "per_item" };
					} else if (selectedBillingEvent === 'atm-residual-count') {
						var options = _this12.billingTypeOptions.filter(function (bt) {
							return ['fixed', 'per_item', 'percentage_fee'].includes(bt.value);
						});
						br.billingTypeObj.billingTypeOptions = options;
					}

					var orderTypeOptions = [];

					br.locationTypeObj = {
						locationType: br.extraDetails.locationType ? _.find(locationTypeOptions, { 'value': br.extraDetails.locationType.toLowerCase() }) : null,
						locationTypeOptions: locationTypeOptions
					};
					br.serviceTypeObj = {
						serviceType: br.extraDetails.serviceType ? _.find(serviceTypeOptions, { 'value': br.extraDetails.serviceType.toLowerCase() }) : null,
						serviceTypeOptions: serviceTypeOptions
					};

					if (br.extraDetails.orderType) {
						if (['shipment-delivered', 'shipment-pickup', 'delivery-order-pack', 'pickup-deposit', 'shipment-delivery-cant', 'deposit-count'].indexOf(selectedBillingEvent) > -1) {
							orderTypeOptions = [].concat((0, _toConsumableArray3.default)(_this12.orderTypeOptions['cash_coin']), (0, _toConsumableArray3.default)(_this12.orderTypeOptions['cash_only']), (0, _toConsumableArray3.default)(_this12.orderTypeOptions['coin_only']));
						} else if (['atm-residual-count', 'atm-load-service', 'atm-order-pack', 'atm-residual-deposit', 'atm-deposit-pickup', 'atm-deposit-count', 'atm-load-cant', 'atm-cash-delivery', 'atm-cash-pickup'].indexOf(selectedBillingEvent) > -1) {
							orderTypeOptions = _this12.orderTypeOptions['ATM'];
						} else if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
							orderTypeOptions = _this12.orderTypeOptions['services'];
						} else if (['coin-pickup', 'coin-delivery'].indexOf(selectedBillingEvent) > -1) {
							orderTypeOptions = _this12.orderTypeOptions['coin_only'];
						} else if (['stop-completed', 'coin-conversion'].indexOf(selectedBillingEvent) > -1) {
							var option = { label: 'Any', value: 'none' };
							orderTypeOptions = [option];
						} else {
							orderTypeOptions = _this12.orderTypeOptions['other'];
						}
					}

					br.orderTypeObj = {
						orderType: br.extraDetails.orderType ? _.find(orderTypeOptions, { 'value': br.extraDetails.orderType.toLowerCase() }) : null,
						orderTypeOptions: orderTypeOptions
					};
				});

				_this12.billingRulesOptions.forEach(function (br) {
					_this12.contractBillingRules.push({
						name: br.name,
						description: br.description,
						generalLedgerCode: br.generalLedgerCode || null,
						status: br.status,
						billingEvent: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent['value'] : null,
						billingEventLabel: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent.label : null,
						locationType: br.locationTypeObj.locationType ? br.locationTypeObj.locationType['value'] : 'NONE',
						locationTypeLabel: br.locationTypeObj.locationType ? br.locationTypeObj.locationType.label : 'NONE',
						serviceType: br.serviceTypeObj.serviceType ? br.serviceTypeObj.serviceType['value'] : 'NONE',
						serviceTypeLabel: br.serviceTypeObj.serviceType ? br.serviceTypeObj.serviceType.label : 'NONE',
						scheduleType: br.scheduleTypeObj.scheduleType ? br.scheduleTypeObj.scheduleType['value'] : 'NONE',
						scheduleTypeLabel: br.scheduleTypeObj.scheduleType ? br.scheduleTypeObj.scheduleType.label : 'NONE',
						orderType: br.orderTypeObj.orderType ? br.orderTypeObj.orderType['value'] : 'NONE',
						orderTypeLabel: br.orderTypeObj.orderType ? br.orderTypeObj.orderType.label : 'NONE',
						billingType: br.billingTypeObj.billingType['value'],
						billingTypeLabel: br.billingTypeObj.billingType.label,
						dollarRate: br.dollarRate >= 0 ? br.dollarRate : null,
						percentageRate: br.percentageRate >= 0 ? br.percentageRate : null,
						dollarRateAbove: br.dollarRateAbove >= 0 ? br.dollarRateAbove : null,
						percentageRateAbove: br.percentageRateAbove >= 0 ? br.percentageRateAbove : null,
						dollarRateBelow: br.dollarRateBelow >= 0 ? br.dollarRateBelow : null,
						percentageRateBelow: br.percentageRateBelow >= 0 ? br.percentageRateBelow : null,
						itemThreshold: br.itemThreshold >= 0 ? br.itemThreshold : null,
						itemIncrement: br.itemIncrement >= 0 ? br.itemIncrement : null,
						valueThreshold: br.valueThreshold >= 0 ? br.valueThreshold : null,
						valueIncrement: br.valueIncrement >= 0 ? br.valueIncrement : null,
						timeThreshold: _this12.ifUndefined(br.timeThreshold) ? br.timeThreshold : null,
						timeIncrement: _this12.ifUndefined(br.timeIncrement) ? br.timeIncrement : null,
						currencyId: 'USD',
						applyWrapFee: br.applyWrapFee,
						wrapFee: br.wrapFee,
						billingTime: br.billingTypeObj.billingType['value'] === 'fixed' ? br.billingTime : null,
						locationDistanceId: br.locationDistanceId,
						rateFirstHour: br.rateFirstHour,
						rateFifteenMinutes: br.rateFifteenMinutes,
						serviceTimeType: br.serviceTimeTypeObj.serviceTimeType.map(function (d) {
							return d.value;
						}).toString(),
						billToCustomerId: br.billToCustomerId ? br.billToCustomerId.Value : null,
						contractRulesLocations: br.contractRulesLocations,
						preBillingEvents: br.billingEventObj.preBillingEvents,
						postBillingEvents: br.billingEventObj.postBillingEvents,
						contractRulesId: br.contractRulesId,
						sequence: br.sequence,
						billableEventId: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent.id : null,
						billingCategoryId: br.billingCategoryObj && br.billingCategoryObj.billingCategory ? br.billingCategoryObj.billingCategory.billingCategoryId : null,
						overageRate: br.overageRate,
						customerLocationsDistance: br.customerLocationsDistance,
						contractLocationsDistance: br.contractLocationsDistance,
						startDate: br.startDate,
						endDate: br.endDate
					});
				});
				_this12.validateStaticBillingOptions();
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				// this.loading = false;
				_this12.contractDatesChanged();
			});
		}
	}, {
		key: 'getBillingEventsByCategory',
		value: function getBillingEventsByCategory(contractRuleObj, index) {
			this.resetLocationAndServiceType(contractRuleObj);
			contractRuleObj.billingEventObj.billingEventOptions = contractRuleObj.billingCategoryObj.billingCategory.billingEvents;
		}
	}, {
		key: 'locationDistanceList',
		value: function locationDistanceList() {
			var _this13 = this;

			this.LocationDistanceService.all(null, 0, 100).then(function (data) {
				_this13.model.locationDistanceOptions = data.results;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'updateLocationDistance',
		value: function updateLocationDistance(contractRules, locationDistanceId, index) {
			var _this14 = this;

			setTimeout(function () {
				var page = 1;
				var selectAllFlag = false;

				contractRules.locationDistance = _.find(_this14.model.locationDistanceOptions, { 'id': locationDistanceId });
				_this14.showAllFlag = false;

				if (_this14.model.useCustomerOnBillingRules) {
					_this14.getContractLocationList('', contractRules.locationDistanceId, page, index);
				} else {
					_this14.getCustomerLocationList('', contractRules.locationDistanceId, page, selectAllFlag, index);
				}

				setTimeout(function () {
					var applicableLocations = _this14.model.useCustomerOnBillingRules ? _this14.locationObj.results : _this14.associateLocationObj.results;

					var filteredLocations = void 0;
					if (_this14.billingRulesOptions[index].isNew == true) {
						filteredLocations = applicableLocations.filter(function (ele) {
							return _this14.billingRulesOptions[index].contractRulesLocations.includes(ele.value);
						}).map(function (ele) {
							return ele.value;
						});
					} else {
						filteredLocations = applicableLocations.filter(function (ele) {
							return _this14.contractRules[index].locationApplicable.includes(ele.value);
						}).map(function (ele) {
							return ele.value;
						});
					}

					_this14.billingRulesOptions[index].contractRulesLocations = filteredLocations.length > 0 ? filteredLocations : [];
					_this14.$scope.$apply();
				}, 500);
			});
		}
	}, {
		key: 'preOrPostBillCfg',
		value: function preOrPostBillCfg(obj, index) {
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (this.staticBillingEvents.includes(selectedBillingEvent)) {
				this.disableOtherOptions[index] = {
					disabled: true
				};
				obj.locationTypeObj.locationType = null;
				obj.serviceTypeObj.serviceType = null;
				obj.scheduleTypeObj.scheduleType = null;
				obj.orderTypeObj.orderType = null;
				obj.billingTypeObj.billingType = {
					label: 'Fixed',
					value: 'fixed'
				};
				obj.billingTime = selectedBillingEvent === 'pre-bill' ? 'PRE' : 'POST';
				obj.dollarRate = null;
				obj.percentageRate = null;
				obj.dollarRateAbove = null;
				obj.percentageRateAbove = null;
				obj.dollarRateBelow = null;
				obj.percentageRateBelow = null;
				obj.itemThreshold = null;
				obj.valueThreshold = null;
				obj.timeThreshold = null;
				obj.itemIncrement = null;
				obj.valueIncrement = null;
				obj.timeIncrement = null;
				obj.isEdit = true;
				obj.applyWrapFee = false;
				obj.wrapFee = null;
				obj.locationDistanceId = null;
				obj.rateFirstHour = null;
				obj.rateFifteenMinutes = null;
				obj.overageRate = null;
				this.model.selectedBillingDuration = 'MONTHLY';
				this.model.disableBillingIncrement = true;
				this.requiredStartDate = true;
			} else {
				this.model.disableBillingIncrement = false;
				this.disableOtherOptions[index] = {
					disabled: false
				};
				obj.billingTime = 'POST';
				this.requiredStartDate = false;
				obj.billingTypeObj.billingType = null;
				setTimeout(function () {
					obj.billingEventObj.preBillingEvents = [];
					obj.billingEventObj.preBillingEventOptions.forEach(function (pbe) {
						pbe.ticked = false;
					});

					obj.billingEventObj.postBillingEvents = [];
					obj.billingEventObj.postBillingEventOptions.forEach(function (pbe) {
						pbe.ticked = false;
					});
				});
			}

			this.isStartDateIsRequired();
		}
	}, {
		key: 'isAllowScheduleType',
		value: function isAllowScheduleType(obj, index) {
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (this.allowScheduleTypeBillingEvents.includes(selectedBillingEvent)) {
				this.disableScheduleTypeOptions[index] = {
					disabled: true
				};
				obj.scheduleTypeObj.scheduleType = null;
			} else {
				this.disableScheduleTypeOptions[index] = {
					disabled: false
				};
			}
		}
	}, {
		key: 'isStartDateIsRequired',
		value: function isStartDateIsRequired() {
			var _this15 = this;

			if (!this.billingRulesOptions.length) this.requiredStartDate = false;

			this.billingRulesOptions.forEach(function (br) {
				if (br.billingEventObj.billingEvent && br.billingEventObj.billingEvent.value == "pre-bill") _this15.requiredStartDate = true;
			});
		}
	}, {
		key: 'resetBillToCustomers',
		value: function resetBillToCustomers() {
			var _this16 = this;

			var filterEdits = this.billingRulesOptions.filter(function (obj) {
				return obj.isEdit === true;
			});
			this.billingRulesOptions.forEach(function (obj) {
				obj.billToCustomerId = null;
				obj.contractRulesLocations = [];
				obj.locationOptions = [];
				obj.isEdit = false;
			});
			this.formValues = angular.copy(this.model);
			if (filterEdits.length) {
				filterEdits.map(function (ele) {
					_this16.editBillingRules(ele, ele.sequence - 1);
				});
			}
		}
	}, {
		key: 'billingTypeOptionChoice',
		value: function billingTypeOptionChoice(obj) {
			if (!obj.billingEventObj.billingEvent) return;

			var selectedBillingEvent = obj.billingEventObj.billingEvent.value;

			if (!selectedBillingEvent) return;

			if (this.staticBillingEvents.includes(selectedBillingEvent)) {
				var fixedOption = this.billingTypeOptions.find(function (bt) {
					return bt.label === 'Fixed';
				});
				obj.billingTypeObj.billingTypeOptions = [fixedOption];
			} else if (selectedBillingEvent === 'stop-completed') {
				var options = this.billingTypeOptions.filter(function (bt) {
					return ['fixed', 'per_item'].includes(bt.value);
				});
				obj.billingTypeObj.billingTypeOptions = options;
			} else if (selectedBillingEvent === 'coin-conversion') {
				var perItemOption = this.billingTypeOptions.find(function (bt) {
					return bt.value === 'per_item';
				});
				obj.billingTypeObj.billingTypeOptions = [perItemOption];
				obj.billingTypeObj.billingType = { label: "Per Item", value: "per_item" };
			} else if (selectedBillingEvent === 'atm-residual-count') {
				var _options = this.billingTypeOptions.filter(function (bt) {
					return ['fixed', 'per_item', 'percentage_fee'].includes(bt.value);
				});
				obj.billingTypeObj.billingTypeOptions = _options;
			} else {
				obj.billingTypeObj.billingTypeOptions = this.billingTypeOptions;
			}
		}
	}, {
		key: 'bulkImportLocationModal',
		value: function bulkImportLocationModal(data, index) {
			data.contractId = this.model.contractId;
			data.useCustomerOnBillingRules = this.model.useCustomerOnBillingRules;
			data.showAll = this.showAllFlag;
			this.Modal.bulkImportLocation(data, function (_ref5) {
				var locationList = _ref5.locationList,
				    modal = _ref5.modal;

				if (locationList && locationList.length > 0) {
					locationList.forEach(function (l1) {
						data.contractRulesLocations.push(l1);
					});
				}
				modal.close();
			}, function (_ref6) {
				var modal = _ref6.modal;

				if (modal) modal.close();
			});
		}
	}, {
		key: 'getCustomerList',
		value: function getCustomerList(searchKey, offset) {
			var _this17 = this;

			this.customerObj.loading = true;
			this.Service.getCustomerList(searchKey, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this17.customerObj.totalRecords = data.totalRecords;
					_this17.customerObj.results = _this17.dataMapping(data.results, 'key', 'value');
				} else {
					var customers = _this17.dataMapping(data.results, 'key', 'value');
					_this17.customerObj.results = _this17.customerObj.results.concat(customers);
				}
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this17.customerObj.loading = false;
			});
		}
	}, {
		key: 'dataMapping',
		value: function dataMapping(data, key, value) {
			return data.map(function (obj) {
				return {
					Key: obj[key],
					Value: obj[value]
				};
			});
		}
	}, {
		key: 'getContractLocationList',
		value: function getContractLocationList() {
			var searchKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
			var locationDistanceId = arguments[1];
			var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

			var _this18 = this;

			var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
			var selectAllFlag = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

			setTimeout(function () {
				var queryDataLimit = selectAllFlag ? _this18.locationObj.totalLocations || _this18.contractLocationListObj.pagination.pageLimit : _this18.contractLocationListObj.pagination.pageLimit;
				_this18.Service.contractLocationList(searchKey, locationDistanceId, (page - 1) * _this18.contractLocationListObj.pagination.pageLimit, queryDataLimit).then(function (res) {
					if (page == 1) {
						_this18.locationObj.results = [];
						if (index !== null) {
							_this18.billingRulesOptions[index].locationOptions = [];
						}
					}
					if (_this18.billingRulesOptions[index] && _this18.billingRulesOptions[index].locationOptions) {
						_this18.billingRulesOptions[index].locationOptions = _.cloneDeep(_.uniqBy(_this18.billingRulesOptions[index].locationOptions.concat(res.results), 'value'));
					}

					_this18.locationObj.results = _.uniqBy(_this18.locationObj.results.concat(res.results), 'value');
					_this18.locationObj.totalLocations = res.totalRecords;

					if (index !== null && _this18.billingRulesOptions[index]) {
						_this18.billingRulesOptions[index].contractLocationsDistance = new Array(res.totalRecords).fill('');
					}
				}).catch(function (err) {
					console.log(err);
				});
			});
		}
	}, {
		key: 'getCustomerLocationList',
		value: function getCustomerLocationList() {
			var searchKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
			var locationDistanceId = arguments[1];
			var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

			var _this19 = this;

			var selectAllFlag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
			var index = arguments[4];

			setTimeout(function () {
				var queryDataLimit = selectAllFlag ? _this19.associateLocationObj.totalLocations : _this19.contractLocationListObj.pagination.pageLimit;
				_this19.Service.getCustomerLocationList(_this19.model.contractId, locationDistanceId, searchKey, (page - 1) * _this19.contractLocationListObj.pagination.pageLimit, queryDataLimit).then(function (res) {
					if (res.results) {
						if (page == 1) {
							_this19.associateLocationObj.results = [];
							if (index !== null && _this19.billingRulesOptions[index]) {
								_this19.billingRulesOptions[index].locationOptions = [];
							}
						}

						_this19.associateLocationObj.results = _.uniqBy(_this19.associateLocationObj.results.concat(res.results), 'value');
						_this19.associateLocationObj.totalLocations = res.totalRecords;

						setTimeout(function () {
							if (selectAllFlag && index >= 0 && _this19.contractRules[index] && _this19.contractRules[index].isNew === false) {
								_this19.contractRules[index].locationApplicable = _this19.associateLocationObj.results.map(function (el) {
									return el.value;
								});
								// this.billingRulesOptions[index].locationApplicable = this.associateLocationObj.results.map(el => el.value)
							}
						}, 500);
						if (_this19.billingRulesOptions[index] && _this19.billingRulesOptions[index].locationOptions) {
							_this19.billingRulesOptions[index].locationOptions = _.cloneDeep(_.uniqBy(_this19.billingRulesOptions[index].locationOptions.concat(res.results), 'value'));
						}

						if (index >= 0) {
							_this19.billingRulesOptions[index].customerLocationsDistance = new Array(res.totalRecords).fill('');
						}
					}
				}).catch(function (err) {
					console.log(err);
				});
			});
		}
	}, {
		key: 'filterChange',
		value: function filterChange(contractRules) {
			// console.log(contractRules.contractRulesLocations)
		}
	}, {
		key: 'clear',
		value: function clear() {
			this.model.contractEndDate = null;
		}
	}, {
		key: 'findDifferences',
		value: function findDifferences(obj1Array, obj2Array) {
			var resultObjects = [];
			function compareObjects(obj1, obj2) {
				for (var key in obj1) {
					if (obj1.hasOwnProperty(key)) {
						if ((0, _typeof3.default)(obj1[key]) === 'object' && obj1[key] !== null && obj2[key] !== null) {
							if ((0, _stringify2.default)(obj1[key]) !== (0, _stringify2.default)(obj2[key])) {
								return true; // Object properties differ
							}
						} else if (obj1[key] !== obj2[key]) {
							return true; // Primitive values differ
						}
					}
				}
				return false;
			}

			obj2Array.forEach(function (obj2) {
				var obj1 = obj1Array.find(function (o) {
					return o.contractRulesId === obj2.contractRulesId;
				});
				if (obj1) {
					var isUpdated = compareObjects(obj1, obj2);
					var updatedObject = (0, _extends4.default)({}, obj2, { recordStatus: isUpdated ? 'update' : 'noChange' });
					resultObjects.push(updatedObject);
				} else {
					resultObjects.push((0, _extends4.default)({}, obj2, { recordStatus: 'new' }));
				}
			});

			return resultObjects;
		}
	}, {
		key: 'updateContractRuleStatus',
		value: function updateContractRuleStatus(index, isActive) {
			setTimeout(function () {
				var id = isActive ? 'active-btn-' + index : 'inactive-btn-' + index;
				return document.getElementById(id).blur();
			});
			if (this.billingRulesOptions[index].isNew || this.billingRulesOptions[index].isEdit) return;
			this.updateContractStats(this.billingRulesOptions);
		}
	}, {
		key: 'validateRecordOnSequenceChange',
		value: function validateRecordOnSequenceChange() {
			var _this20 = this;

			setTimeout(function () {
				_this20.disableOtherOptions = {};
				_this20.billingRulesOptions.forEach(function (cr, index) {
					if (cr.billingEventObj.billingEvent && _this20.staticBillingEvents.includes(cr.billingEventObj.billingEvent.value)) {
						_this20.disableOtherOptions[index] = {
							disabled: true
						};
						_this20.requiredStartDate = true;
					} else {
						_this20.disableOtherOptions[index] = {
							disabled: false
						};
						_this20.requiredStartDate = false;
					}
					_this20.isAllowScheduleType(cr, index);
				}, 100);
			});
		}
	}, {
		key: 'validateStaticBillingOptions',
		value: function validateStaticBillingOptions() {
			var _this21 = this;

			setTimeout(function () {
				_this21.disableOtherOptions = {};
				_this21.billingRulesOptions.forEach(function (cr, index) {
					if (cr.billingEventObj.billingEvent && _this21.staticBillingEvents.includes(cr.billingEventObj.billingEvent.value)) {
						_this21.disableOtherOptions[index] = {
							disabled: true
						};
						_this21.requiredStartDate = true;
					} else {
						_this21.disableOtherOptions[index] = {
							disabled: false
						};
						_this21.requiredStartDate = false;
					}
					_this21.isAllowScheduleType(cr, index);
				});
				_this21.$scope.$apply();
			}, 100);
		}
	}, {
		key: 'handleFormChange',
		value: function handleFormChange() {
			var _this22 = this;

			var keys = ['contractName', 'status', 'selectedBillingDuration', 'contractStartDate', 'contractEndDate', 'useCustomerOnBillingRules', "selectedBillingDuration"];

			var formTemp = {};
			var modalTemp = {};

			keys.forEach(function (key) {
				if (['contractStartDate', 'contractEndDate'].includes(key)) {
					formTemp[key] = _this22.formValues[key] ? moment(_this22.formValues[key]).startOf('day').toDate() : null;
					modalTemp[key] = _this22.model[key] ? moment(_this22.model[key]).startOf('day').toDate() : null;
				} else {
					formTemp[key] = _this22.formValues[key];
					modalTemp[key] = _this22.model[key];

					if (key === 'useCustomerOnBillingRules' && _this22.formValues[key]) {
						_this22.billingRulesOptions.forEach(function (crl) {
							crl.contractRulesLocations = [];
						});
					}
					if (_this22.model.useCustomerOnBillingRules === true) {
						_this22.billingRulesOptions.forEach(function (crl, index) {
							if (_this22.contractRules[index]) {
								crl.contractRulesLocations = _this22.contractRules[index].locationApplicable;
							}
						});
					}
				}
			});
			this.mainFormChanged = !angular.equals(formTemp, modalTemp);
		}
	}, {
		key: 'changeSeq',
		value: function changeSeq() {
			var _this23 = this;

			this.model.contractStartDate = this.model.contractStartDate ? moment(this.model.contractStartDate).format('YYYY-MM-DD') : null;
			this.model.contractEndDate = this.model.contractEndDate ? moment(this.model.contractEndDate).format('YYYY-MM-DD') : null;
			this.generateBillingRules('value');
			var contractRules = void 0;
			contractRules = this.findDifferences(this.contractBillingRules, this.contractRules);
			var formattedContractRules = contractRules.map(function (item) {
				return (0, _extends4.default)({}, item, {
					startDate: item.startDate ? moment(item.startDate).format('YYYY-MM-DD') : null,
					endDate: item.endDate ? moment(item.endDate).format('YYYY-MM-DD') : null
				});
			});
			this.model.contractRules = formattedContractRules;
			this.model.billingIncrement = this.model.selectedBillingDuration;
			this.model.createdByUserId = this.User.getUser().id;
			this.model.modifiedByUserId = this.User.getUser().id;
			this.loading = true;
			this.Service.updateContractRule(this.rawId, this.model, this.branchId).then(function (data) {
				_this23.getContractDetails();
			}).catch(function (err) {
				if (err.data.errors) {
					err.data.errors.map(function (e) {
						_this23.errorMessage += e.message + '<br/>';
					});
				} else {
					_this23.errorMessage = err.data.message;
				}
			}).finally(function () {
				_this23.loading = false;
			});
		}
	}, {
		key: 'onDrop',
		value: function onDrop(event, index, item, external, type) {
			// Create a copy of the billingRulesOptions array
			var updatedOptions = angular.copy(this.billingRulesOptions);

			// Remove the item from its original position
			var itemIndex = updatedOptions.findIndex(function (opt) {
				return opt.contractRulesId === item.contractRulesId;
			});
			updatedOptions.splice(itemIndex, 1);

			// Reinsert the item at the new position
			updatedOptions.splice(index, 0, item);

			// Update the sequence field for all items in the updatedOptions array
			updatedOptions.forEach(function (opt, i) {
				opt.sequence = i + 1;
			});

			this.generateContractBillingRules();

			// Update the billingRulesOptions array with the new changes
			this.billingRulesOptions = updatedOptions;

			this.validateRecordOnSequenceChange();
			this.changeSeq();
			// this.serviceTypeOptionChoice(item, index);

			return true;
		}
	}, {
		key: 'checkIsEdit',
		value: function checkIsEdit() {
			return this.billingRulesOptions.some(function (ele, i) {
				return ele.isEdit === true;
			});
		}
	}, {
		key: 'print',
		value: function print() {
			var _this24 = this;

			var searchObj = this.generateSearchObj();

			this.Service.getContractLogs(this.$stateParams.id, searchObj, 0, 10000).then(function (data) {
				var printLogsData = void 0;
				printLogsData = data.results.map(function (log) {
					log.readableEntryType = _this24.$translate.instant('entry_type.' + log.entryType);
					if (log.entryData) {
						log.extraDetails = (0, _entries2.default)(log.entryData).map(function (_ref7) {
							var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
							    key = _ref8[0],
							    value = _ref8[1];

							return {
								key: key,
								value: (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' ? (0, _stringify2.default)(value) : value
							};
						});
					}
					return log;
				});
				var obj = {
					results: printLogsData,
					contractDetails: {
						contractName: _this24.model.contractName,
						contractId: _this24.model.contractId
					}
				};
				var url = _this24.$state.href('printHistory');
				window.w = window.open(url, '_blank');
				window.w.printData = obj;
			}).catch(function (error) {
				console.error('Error loading contract logs:', error);
			}).finally(function () {
				_this24.loading = false;
			});
		}
	}, {
		key: 'exportToCsv',
		value: function exportToCsv() {
			var _this25 = this;

			this.isExporting = true;
			var searchObj = this.generateSearchObj();
			this.Service.exportDataToCSV(this.model.contractId, searchObj).then(function (data) {
				var date = moment.utc().format('DDMMYY');
				_this25.fileName = _this25.filePrefix.concat('_', date, '.csv');
				var a = document.createElement("a");
				document.body.appendChild(a);
				var file = new Blob([data.results], { type: 'application/csv' });
				var fileURL = window.URL.createObjectURL(file);
				a.href = fileURL;
				a.download = _this25.fileName;
				a.click();
				_this25.isExporting = false;
			});
		}
	}, {
		key: 'getContractTypeList',
		value: function getContractTypeList(searchKey, offset) {
			var _this26 = this;

			searchKey = searchKey || '';

			var obj = {
				queryJSON: {
					rules: [{
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "type",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};

			this.contractTypeObj.loading = true;
			return this.ContractTypeService.all(obj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this26.contractTypeObj.totalRecords = data.total;
					_this26.contractTypeObj.results = _this26.mapContractData(data.results);
				} else {
					var contaractType = _this26.mapContractData(data.results);
					_this26.contractTypeObj.results = _this26.contractTypeObj.results.concat(contaractType);
				}
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this26.contractTypeObj.loading = false;
			});
		}
	}, {
		key: 'mapContractData',
		value: function mapContractData(mapArray) {
			return mapArray.map(function (obj) {
				return {
					Key: obj.type,
					Value: obj.id
				};
			});
		}
	}, {
		key: 'convertStr',
		value: function convertStr(str) {
			if (!str) return;
			return Number(str.replace('%', ''));
		}
	}, {
		key: 'ngPercentage',
		value: function ngPercentage() {
			if (this.model.bailmentInterest && !this.model.bailmentInterest.endsWith('%')) {
				return this.model.bailmentInterest = this.model.bailmentInterest + '%';
			}
		}
	}, {
		key: 'removePercentageSign',
		value: function removePercentageSign() {
			if (this.model.bailmentInterest && this.model.bailmentInterest.endsWith('%')) {
				return this.model.bailmentInterest = this.model.bailmentInterest.replace('%', '');
			}
		}
	}, {
		key: 'findDifferencesWithReturn',
		value: function findDifferencesWithReturn(objA, objB) {

			function compareObjects(obj1, obj2) {
				var diff = {};
				diff.name = obj1.name;

				for (var key in obj1) {
					if (obj1.hasOwnProperty(key)) {
						if ((0, _typeof3.default)(obj1[key]) === 'object' && obj1[key] !== null && obj2[key] !== null) {
							if (Array.isArray(obj1[key])) {
								// Sort the arrays before comparing
								obj1[key].sort();
								obj2[key].sort();

								if ((0, _stringify2.default)(obj1[key]) !== (0, _stringify2.default)(obj2[key])) {
									diff[key] = {
										"Old Value": obj1[key],
										"Updated Value": obj2[key]
									};
								}
							} else if (obj2[key] !== undefined && obj1[key] !== undefined) {
								var nestedDiff = compareObjects(obj1[key], obj2[key]);
								if ((0, _keys2.default)(nestedDiff).length > 0) {
									diff[key] = nestedDiff;
								}
							}
						} else if (obj1[key] !== obj2[key] && obj2[key] !== undefined && obj1[key] !== undefined) {
							if (key === 'status') {
								diff[key] = {
									"Old Value": obj1[key] ? "Active" : "Suspended",
									"Updated Value": obj2[key] ? "Active" : "Suspended"
								};
							} else {
								diff[key] = {
									"Old Value": obj1[key],
									"Updated Value": obj2[key]
								};
							}
						}
					}
				}

				(0, _keys2.default)(diff).map(function (k) {
					if (['billingEventLabel', 'locationTypeLabel', 'orderTypeLabel', 'billingTypeLabel', 'serviceTypeLabel', 'sequence', 'contractLocationsDistance'].includes(k)) {
						delete diff[k];
					}
				});

				return diff;
			}

			return compareObjects(objA, objB);
		}
	}, {
		key: 'resetLogsOptions',
		value: function resetLogsOptions() {
			this.page = 1;
			this.searchText = '';
			this.entryType = undefined;
			this.model.dateRange.startDate = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
			this.model.dateRange.endDate = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
			this.contractRulesLocationSearchText = '';
			this.getContractRulesLocation();
		}
	}, {
		key: 'generateContractBillingRules',
		value: function generateContractBillingRules() {
			var _this27 = this;

			this.contractBillingRules = [];
			this.billingRulesOptions.forEach(function (br) {
				_this27.contractBillingRules.push({
					name: br.name,
					description: br.description,
					generalLedgerCode: br.generalLedgerCode || null,
					status: br.status,
					billingEvent: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent['value'] : null,
					billingEventLabel: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent.label : null,
					locationType: br.locationTypeObj.locationType ? br.locationTypeObj.locationType['value'] : 'NONE',
					locationTypeLabel: br.locationTypeObj.locationType ? br.locationTypeObj.locationType.label : 'NONE',
					serviceType: br.serviceTypeObj.serviceType ? br.serviceTypeObj.serviceType['value'] : 'NONE',
					serviceTypeLabel: br.serviceTypeObj.serviceType ? br.serviceTypeObj.serviceType.label : 'NONE',
					scheduleType: br.scheduleTypeObj.scheduleType ? br.scheduleTypeObj.scheduleType['value'] : 'NONE',
					scheduleTypeLabel: br.scheduleTypeObj.scheduleType ? br.scheduleTypeObj.scheduleType.label : 'NONE',
					orderType: br.orderTypeObj.orderType ? br.orderTypeObj.orderType['value'] : 'NONE',
					orderTypeLabel: br.orderTypeObj.orderType ? br.orderTypeObj.orderType.label : 'NONE',
					billingType: br.billingTypeObj.billingType ? br.billingTypeObj.billingType['value'] : 'NONE',
					billingTypeLabel: br.billingTypeObj.billingType ? br.billingTypeObj.billingType.label : 'NONE',
					dollarRate: br.dollarRate >= 0 ? br.dollarRate : null,
					percentageRate: br.percentageRate >= 0 ? br.percentageRate : null,
					dollarRateAbove: br.dollarRateAbove >= 0 ? br.dollarRateAbove : null,
					percentageRateAbove: br.percentageRateAbove >= 0 ? br.percentageRateAbove : null,
					dollarRateBelow: br.dollarRateBelow >= 0 ? br.dollarRateBelow : null,
					percentageRateBelow: br.percentageRateBelow >= 0 ? br.percentageRateBelow : null,
					itemThreshold: br.itemThreshold >= 0 ? br.itemThreshold : null,
					itemIncrement: br.itemIncrement >= 0 ? br.itemIncrement : null,
					valueThreshold: br.valueThreshold >= 0 ? br.valueThreshold : null,
					valueIncrement: br.valueIncrement >= 0 ? br.valueIncrement : null,
					timeThreshold: _this27.ifUndefined(br.timeThreshold) ? br.timeThreshold : null,
					timeIncrement: _this27.ifUndefined(br.timeIncrement) ? br.timeIncrement : null,
					currencyId: 'USD',
					applyWrapFee: br.applyWrapFee,
					wrapFee: br.wrapFee,
					billingTime: br.billingTypeObj.billingType ? br.billingTypeObj.billingType['value'] === 'fixed' ? br.billingTime : null : 'NONE',
					locationDistanceId: br.locationDistanceId,
					rateFirstHour: br.rateFirstHour,
					rateFifteenMinutes: br.rateFifteenMinutes,
					serviceTimeType: br.serviceTimeTypeObj.serviceTimeType.map(function (d) {
						return d.value;
					}).toString(),
					billToCustomerId: br.billToCustomerId ? br.billToCustomerId.Value : null,
					contractRulesLocations: br.contractRulesLocations,
					preBillingEvents: br.billingEventObj.preBillingEvents,
					postBillingEvents: br.billingEventObj.postBillingEvents,
					contractRulesId: br.contractRulesId,
					sequence: br.sequence,
					billableEventId: br.billingEventObj && br.billingEventObj.billingEvent ? br.billingEventObj.billingEvent.id : null,
					billingCategoryId: br.billingCategoryObj && br.billingCategoryObj.billingCategory ? br.billingCategoryObj.billingCategory.billingCategoryId : null,
					overageRate: br.overageRate,
					customerLocationsDistance: br.customerLocationsDistance,
					contractLocationsDistance: br.contractLocationsDistance,
					startDate: br.startDate,
					endDate: br.endDate
				});
			});
		}
	}, {
		key: 'getContractRulesLocation',
		value: function getContractRulesLocation() {
			var _this28 = this;

			this.contractRulesLocationLoading = true;
			this.billingRulesOptions = [];
			this.Service.getContractRulesLocation(this.model.contractId, this.contractRulesLocationSearchText).then(function (data) {
				_this28.contractRules = data.contractRulesData;
				_this28.getBillableEvents();
				_this28.updateContractStats(data.contractRulesData);
				// this.contractRulesRecordStats.active = data.contractRulesData.filter((rule) => rule.status === true).length
				// this.contractRulesRecordStats.inactive = data.contractRulesData.filter((rule) => rule.status === false).length
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this28.contractRulesLocationLoading = false;
			});
		}
	}, {
		key: 'onShowAll',
		value: function onShowAll() {}
	}, {
		key: 'shouldDisplayRule',
		value: function shouldDisplayRule(rule) {
			if (rule.isNew === true || rule.isEdit === true) return true;
			if (this.filterByValue === 'all') {
				return true;
			} else if (this.filterByValue === 'active') {
				return rule.status === true;
			} else if (this.filterByValue === 'inactive') {
				return rule.status === false;
			}
			return false;
		}
	}, {
		key: 'updateContractStats',
		value: function updateContractStats(rules) {
			this.contractRulesRecordStats.active = rules.filter(function (rule) {
				return rule.status === true;
			}).length;
			this.contractRulesRecordStats.inactive = rules.filter(function (rule) {
				return rule.status === false;
			}).length;
		}
	}, {
		key: 'contractDatesChanged',
		value: function contractDatesChanged() {
			var _this29 = this;

			var isRule = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
			var _model = this.model,
			    contractStartDate = _model.contractStartDate,
			    contractEndDate = _model.contractEndDate;


			setTimeout(function () {
				_this29.ruleStartDateOptions = (0, _extends4.default)({
					minDate: moment(contractStartDate)
				}, contractEndDate && { maxDate: moment(contractEndDate) });
			}, 100);

			this.showBillingWarning = this.billingRulesOptions.some(function (rule, index) {
				var ruleStartDate = rule.startDate ? moment(rule.startDate) : null;
				var ruleEndDate = rule.endDate ? moment(rule.endDate) : null;

				var contractStart = moment(contractStartDate);
				var contractEnd = contractEndDate ? moment(contractEndDate) : null;

				var isInvalidStart = ruleStartDate && ruleStartDate.isValid() && !(ruleStartDate.isSameOrAfter(contractStart, "day") && (contractEnd ? ruleStartDate.isSameOrBefore(contractEnd, "day") : true));

				var isInvalidEnd = ruleEndDate && ruleEndDate.isValid() && !(ruleEndDate.isSameOrAfter(contractStart, "day") && (contractEnd ? ruleEndDate.isSameOrBefore(contractEnd, "day") : true));

				var isRuleInvalid = isInvalidStart || isInvalidEnd;

				return isRuleInvalid;
			});

			if (this.showBillingWarning && !isRule) {
				this.billingRulesOptions.forEach(function (rule) {
					rule.isEdit = false;
				});
			}
		}
	}, {
		key: 'hasNonNewBillingRules',
		value: function hasNonNewBillingRules() {
			return this.billingRulesOptions.some(function (rule) {
				return rule.isNew === true;
			});
		}
	}, {
		key: 'loadServiceTypeOptionChoice',
		value: function loadServiceTypeOptionChoice(selectedBillingEvent, serviceType, index) {
			this.isDisableServiceTypeOptions[index] = { disabled: false };
			if (!selectedBillingEvent) return;

			if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
				this.isDisableServiceTypeOptions[index].disabled = false;
				return [this.serviceTypeOptions['other'][0]].concat((0, _toConsumableArray3.default)(this.serviceTypeOptions['regular']), (0, _toConsumableArray3.default)(this.serviceTypeOptions['flm']), (0, _toConsumableArray3.default)(this.serviceTypeOptions['slm']));
			} else if (['stop-completed', 'atm-cash-delivery', 'coin-pickup', 'coin-delivery', 'shipment-delivery-cant', 'shipment-pickup', 'shipment-delivered', 'atm-cash-pickup', 'atm-deposit-pickup'].indexOf(selectedBillingEvent) > -1) {
				this.isDisableServiceTypeOptions[index].disabled = false;
				return this.serviceTypeOptions['other'];
			} else if (['atm-load-service', 'atm-load-cant'].indexOf(selectedBillingEvent) > -1) {
				this.isDisableServiceTypeOptions[index].disabled = false;
				return this.serviceTypeOptions['atmLoad'];
			} else {
				if (['deposit-count', 'atm-order-pack', 'pickup-deposit', 'atm-residual-deposit', 'delivery-order-pack', 'atm-residual-count', 'atm-deposit-count'].indexOf(selectedBillingEvent) > -1) {

					if (serviceType && serviceType.toUpperCase() !== 'NONE') {
						this.isDisableServiceTypeOptions[index].disabled = false;
					} else {
						this.isDisableServiceTypeOptions[index].disabled = true;
					}
				}
				return this.serviceTypeOptions['none'];
			}
		}
	}]);
	return ContractEditController;
}(_contractBase2.default);

exports.default = ContractEditController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contractEdit = __webpack_require__(2111);

var _contractEdit2 = _interopRequireDefault(_contractEdit);

var _print = __webpack_require__(2114);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractEditModule = angular.module('contractedit', [_print2.default]).component('contractedit', _contractEdit2.default).name;

exports.default = contractEditModule;

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _print_history = __webpack_require__(2115);

var _print_history2 = _interopRequireDefault(_print_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printHistoryModule = angular.module('printHistory', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/contract.edit');

    $stateProvider.state('printHistory', {
        url: '/print-contract-rules-update-history',
        component: 'printHistory',
        data: {
            requireLogin: true,
            requireACL: 'tnt_billing_contract.edit'
        }
    });
}]).component('printHistory', _print_history2.default).name;

exports.default = printHistoryModule;

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print_history = __webpack_require__(2803);

var _print_history2 = _interopRequireDefault(_print_history);

var _print_history3 = __webpack_require__(2116);

var _print_history4 = _interopRequireDefault(_print_history3);

__webpack_require__(3080);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var printHistoryComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _print_history2.default,
  controller: _print_history4.default
};

exports.default = printHistoryComponent;

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintHistoryController = function () {
    function PrintHistoryController($translate, $scope) {
        (0, _classCallCheck3.default)(this, PrintHistoryController);

        this.$translate = $translate;
        this.$scope = $scope;
        this.model = {
            history: []
        };
    }

    (0, _createClass3.default)(PrintHistoryController, [{
        key: '$onInit',
        value: function $onInit() {
            this.model.history = window.opener.w.printData;
            this.print();
        }
    }, {
        key: 'print',
        value: function print() {
            setTimeout(function () {
                window.print();
            }, 500);
        }
    }, {
        key: 'convertArrayToObject',
        value: function convertArrayToObject(arr) {
            arr = arr.filter(function (e) {
                return e.value != 'null';
            });
            var result = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    result[item.key] = item.value;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return result;
        }
    }, {
        key: 'flexibleObjectParser',
        value: function flexibleObjectParser(input) {
            // Helper function to check if a string is valid JSON
            function isJSON(str) {
                try {
                    JSON.parse(str);
                    return true;
                } catch (e) {
                    return false;
                }
            }

            // Helper function to parse JSON safely
            function safeJSONParse(str) {
                try {
                    return JSON.parse(str);
                } catch (e) {
                    return str;
                }
            }

            // Main parsing logic
            function parseValue(value) {
                if (typeof value === 'string' && isJSON(value)) {
                    return parseValue(safeJSONParse(value));
                } else if (Array.isArray(value)) {
                    return value.map(parseValue);
                } else if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && value !== null) {
                    var result = {};
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(value)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
                                key = _step2$value[0],
                                val = _step2$value[1];

                            result[key] = parseValue(val);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    return result;
                } else {
                    return value;
                }
            }

            // Start the parsing process
            return this.convertArrayToObject(parseValue(input));
        }
    }, {
        key: 'translateEntryType',
        value: function translateEntryType(type) {
            return this.$translate.instant('entry_type.' + type);
        }
    }]);
    return PrintHistoryController;
}();

PrintHistoryController.$inject = ['$translate', '$scope'];
exports.default = PrintHistoryController;

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contract = __webpack_require__(2106);

var _contract2 = _interopRequireDefault(_contract);

var _create = __webpack_require__(2110);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2113);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2105);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractModule = angular.module('contract', [_create2.default, _edit2.default, _all2.default]).component('contract', _contract2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('contract.edit', {
    url: '/edit/:id',
    component: 'contractedit',
    data: {
      requireACL: 'tnt_billing_contract.edit'
    }
  }).state('contract.create', {
    url: '/create',
    component: 'contractcreate',
    data: {
      requireACL: 'tnt_billing_contract.create'
    }
  }).state('contract.all', {
    url: '/all/:page',
    component: 'contractall',
    data: {
      requireACL: 'tnt_billing_contract.view'
    }
  }).state('contract.edit.print_history', {
    url: '/print-contract-rules-update-history',
    component: 'printhistory',
    data: {
      requireACL: 'tnt_billing_contract.edit'
    }
  });
}]).name;

exports.default = contractModule;

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contract_typeAll = __webpack_require__(2804);

var _contract_typeAll2 = _interopRequireDefault(_contract_typeAll);

var _contract_typeAll3 = __webpack_require__(2119);

var _contract_typeAll4 = _interopRequireDefault(_contract_typeAll3);

__webpack_require__(3081);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractTypeAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _contract_typeAll2.default,
    controller: _contract_typeAll4.default
};

exports.default = contractTypeAllComponent;

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractTypeAllController = function () {
    /*@ngInject*/
    ContractTypeAllController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "ContractTypeService"];
    function ContractTypeAllController(Auth, User, $state, $translate, $stateParams, $location, Modal, ContractTypeService) {
        (0, _classCallCheck3.default)(this, ContractTypeAllController);

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.ContractTypeService = ContractTypeService;

        this.model = {
            contractTypeObj: {
                totalRecords: 0,
                contractTypeList: [],
                loading: false
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            errorMessage: '',
            branchId: User.getUser().branchId,
            searchText: ''
        };
    }

    (0, _createClass3.default)(ContractTypeAllController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loadData();
        }
    }, {
        key: 'searchObj',
        value: function searchObj() {
            var obj = {
                queryJSON: {
                    rules: [{
                        group: {
                            rules: [{
                                field: 'type',
                                condition: 'like',
                                data: '%' + this.model.searchText + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };
            return obj.queryJSON.rules.length ? obj : null;
        }
    }, {
        key: 'loadAllContractType',
        value: function loadAllContractType() {
            var _this = this;

            this.model.contractTypeObj.loading = true;

            this.ContractTypeService.all(this.searchObj(), (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit).then(function (data) {
                _this.model.contractTypeObj.contractTypeList = data.results;
                _this.model.contractTypeObj.totalRecords = data.total;
            }).catch(function (err) {
                _this.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this.model.contractTypeObj.loading = false;
            });
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.model.pagination.page);
            this.$stateParams.page = this.model.pagination.page;
            this.$location.path(newUrl);
            this.loadAllContractType();
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            this.model.pagination.page = 1;
            this.loadAllContractType();
        }
    }, {
        key: 'search',
        value: function search() {
            this.pageChange();
        }
    }, {
        key: 'edit',
        value: function edit(contractType) {
            this.$state.go('contract_type.edit', {
                id: contractType.id
            });
        }
    }]);
    return ContractTypeAllController;
}();

exports.default = ContractTypeAllController;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contract_typeAll = __webpack_require__(2118);

var _contract_typeAll2 = _interopRequireDefault(_contract_typeAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractTypeAllModule = angular.module('contractTypeAll', []).component('contractTypeAll', _contract_typeAll2.default).name;

exports.default = contractTypeAllModule;

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contract_type = __webpack_require__(2805);

var _contract_type2 = _interopRequireDefault(_contract_type);

var _contract_type3 = __webpack_require__(2122);

var _contract_type4 = _interopRequireDefault(_contract_type3);

__webpack_require__(3082);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractTypeComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _contract_type2.default,
    controller: _contract_type4.default
};

exports.default = contractTypeComponent;

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTBillingBase2 = __webpack_require__(108);

var _TNTBillingBase3 = _interopRequireDefault(_TNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractTypeController = function (_TNTBillingBase) {
    ContractTypeController.$inject = ["$state"];
    (0, _inherits3.default)(ContractTypeController, _TNTBillingBase);

    /*@ngInject*/
    function ContractTypeController($state) {
        (0, _classCallCheck3.default)(this, ContractTypeController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ContractTypeController.__proto__ || (0, _getPrototypeOf2.default)(ContractTypeController)).call(this));

        _this.$state = $state;
        _this.id = "contract_type";
        _this.acl = {};
        _this.hasACL = {};
        return _this;
    }

    (0, _createClass3.default)(ContractTypeController, [{
        key: "$onInit",
        value: function $onInit() {
            (0, _get3.default)(ContractTypeController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ContractTypeController.prototype), "$onInit", this).call(this);
            for (var key in this.acl['tnt_billing_' + this.id]) {
                this.hasACL[this.acl['tnt_billing_' + this.id][key]] = true;
            }
        }
    }]);
    return ContractTypeController;
}(_TNTBillingBase3.default);

exports.default = ContractTypeController;

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contract_typeCreate = __webpack_require__(2806);

var _contract_typeCreate2 = _interopRequireDefault(_contract_typeCreate);

var _contract_typeCreate3 = __webpack_require__(2124);

var _contract_typeCreate4 = _interopRequireDefault(_contract_typeCreate3);

__webpack_require__(3083);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractTypeCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _contract_typeCreate2.default,
    controller: _contract_typeCreate4.default
};

exports.default = contractTypeCreateComponent;

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _contract_typeBase = __webpack_require__(528);

var _contract_typeBase2 = _interopRequireDefault(_contract_typeBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractTypeCreateController = function (_ContractTypeBaseCont) {
    ContractTypeCreateController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "ContractTypeService"];
    (0, _inherits3.default)(ContractTypeCreateController, _ContractTypeBaseCont);

    /*@ngInject*/
    function ContractTypeCreateController(Auth, User, $state, $translate, $stateParams, $location, Modal, ContractTypeService) {
        (0, _classCallCheck3.default)(this, ContractTypeCreateController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ContractTypeCreateController.__proto__ || (0, _getPrototypeOf2.default)(ContractTypeCreateController)).call(this, Auth, $state, User, ContractTypeService, Modal, $translate, $stateParams));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.Modal = Modal;
        _this.ContractTypeService = ContractTypeService;

        _this.defaultModel = {
            type: null,
            description: null
        };

        _this.model = angular.copy(_this.defaultModel);
        return _this;
    }

    (0, _createClass3.default)(ContractTypeCreateController, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "submit",
        value: function submit() {
            var _this2 = this;

            this.model.isCreate = true;
            delete this.model.errorMessage;

            this.Service.create({
                type: this.model.type,
                description: this.model.description
            }).then(function () {
                _this2.askCreate();
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this2.model.errorMessage = e.message;
                });
            }).finally(function () {
                _this2.model.isCreate = false;
            });
        }
    }, {
        key: "reset",
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.clearErrors();
        }
    }]);
    return ContractTypeCreateController;
}(_contract_typeBase2.default);

exports.default = ContractTypeCreateController;

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contract_typeCreate = __webpack_require__(2123);

var _contract_typeCreate2 = _interopRequireDefault(_contract_typeCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractTypeCreateModule = angular.module('contractTypeCreate', []).component('contractTypeCreate', _contract_typeCreate2.default).name;

exports.default = contractTypeCreateModule;

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contract_typeEdit = __webpack_require__(2807);

var _contract_typeEdit2 = _interopRequireDefault(_contract_typeEdit);

var _contract_typeEdit3 = __webpack_require__(2127);

var _contract_typeEdit4 = _interopRequireDefault(_contract_typeEdit3);

__webpack_require__(3084);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractTypeEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _contract_typeEdit2.default,
    controller: _contract_typeEdit4.default
};

exports.default = contractTypeEditComponent;

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _contract_typeBase = __webpack_require__(528);

var _contract_typeBase2 = _interopRequireDefault(_contract_typeBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractTypeEditController = function (_ContractTypeBaseCont) {
    ContractTypeEditController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "ContractTypeService", "$q"];
    (0, _inherits3.default)(ContractTypeEditController, _ContractTypeBaseCont);

    /*@ngInject*/
    function ContractTypeEditController(Auth, User, $state, $translate, $stateParams, $location, Modal, ContractTypeService, $q) {
        (0, _classCallCheck3.default)(this, ContractTypeEditController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ContractTypeEditController.__proto__ || (0, _getPrototypeOf2.default)(ContractTypeEditController)).call(this, Auth, $state, User, ContractTypeService, Modal, $translate, $stateParams));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.Modal = Modal;
        _this.ContractTypeService = ContractTypeService;
        _this.$q = $q;

        _this.defaultModel = {
            type: null,
            description: null
        };

        _this.model = angular.copy(_this.defaultModel);
        return _this;
    }

    (0, _createClass3.default)(ContractTypeEditController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this2 = this;

            this.loading = true;
            this.Service.get(this.$stateParams.id).then(function (data) {
                _this2.defaultModel = data;
                _this2.rawId = data.id;
                _this2.model.id = data.id;
                _this2.model.type = data.type;
                _this2.model.description = data.description;
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this2.loading = false;
            });
        }
    }, {
        key: "reset",
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
        }
    }, {
        key: "update",
        value: function update() {
            var _this3 = this;

            this.model.isUpdating = true;
            delete this.model.errorMessage;

            this.Service.update(this.$stateParams.id, {
                type: this.model.type,
                description: this.model.description
            }).then(function () {
                window.history.go(-1);
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this3.model.errorMessage = e.message;
                });
            }).finally(function () {
                _this3.model.isUpdating = false;
            });
        }
    }]);
    return ContractTypeEditController;
}(_contract_typeBase2.default);

exports.default = ContractTypeEditController;

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contract_typeEdit = __webpack_require__(2126);

var _contract_typeEdit2 = _interopRequireDefault(_contract_typeEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractTypeEditModule = angular.module('contractTypeEdit', []).component('contractTypeEdit', _contract_typeEdit2.default).name;

exports.default = contractTypeEditModule;

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contract_type = __webpack_require__(2121);

var _contract_type2 = _interopRequireDefault(_contract_type);

var _all = __webpack_require__(2120);

var _all2 = _interopRequireDefault(_all);

var _create = __webpack_require__(2125);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2128);

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractTypeModule = angular.module('contractType', [_all2.default, _create2.default, _edit2.default]).component('contractType', _contract_type2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    'ngInject';

    $stateProvider.state('contract_type.all', {
        url: '/all/:page',
        component: 'contractTypeAll'
    });

    $stateProvider.state('contract_type.create', {
        url: '/create',
        component: 'contractTypeCreate'
    });

    $stateProvider.state('contract_type.edit', {
        url: '/edit/:id',
        component: 'contractTypeEdit'
    });
}]).name;

exports.default = contractTypeModule;

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customerAll = __webpack_require__(2808);

var _customerAll2 = _interopRequireDefault(_customerAll);

var _customerAll3 = __webpack_require__(2131);

var _customerAll4 = _interopRequireDefault(_customerAll3);

__webpack_require__(3085);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _customerAll2.default,
  controller: _customerAll4.default
};

exports.default = customerallComponent;

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _customerBase = __webpack_require__(178);

var _customerBase2 = _interopRequireDefault(_customerBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerallController = function (_CustomerBaseControll) {
  CustomerallController.$inject = ["Auth", "$state", "User", "Modal", "CustomerService", "$translate", "$stateParams", "$scope", "$location", "Navigation"];
  (0, _inherits3.default)(CustomerallController, _CustomerBaseControll);

  /*@ngInject*/
  function CustomerallController(Auth, $state, User, Modal, CustomerService, $translate, $stateParams, $scope, $location, Navigation) {
    (0, _classCallCheck3.default)(this, CustomerallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomerallController.__proto__ || (0, _getPrototypeOf2.default)(CustomerallController)).call(this, Auth, $state, User, CustomerService, Modal, $translate, $stateParams, $location));

    _this.loadLocationTypeImage = function (image) {
      var imgURL = this.locationTypeIcon[image];
      return __webpack_require__(51)("./" + imgURL);
    };

    _this.id = 'customer.all';
    _this.loading = true;
    _this.customers = [];
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.hasACL = {};
    _this._status = 'active';
    _this.customerTypeList = ['all', 'types', 'active', 'inactive'];
    _this.Navigation = Navigation;
    _this.userStatus = _this.customerTypeList.map(function (list) {
      return {
        value: list,
        label: $translate.instant('customer_types.' + list)
      };
    });
    _this.searchText = '';
    _this.$location = $location;
    _this.branchId = _this.User.getUser().branchId;
    _this.customerHistoryStats = {
      locations: 'locations',
      contracts: 'contracts'
    };
    _this.currentStats = {};

    _this.weekDays = {
      'serviceScheduleSun': 'Sun',
      'serviceScheduleMon': 'Mon',
      'serviceScheduleTue': 'Tue',
      'serviceScheduleWed': 'Wed',
      'serviceScheduleThu': 'Thu',
      'serviceScheduleFri': 'Fri',
      'serviceScheduleSat': 'Sat',
      'serviceScheduleHol': 'Hol'
    };

    _this.customerLocationHistoryObj = {
      totalRecords: 0,
      results: [],
      loading: false,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      allowOnlyOnce: false,
      errorMessage: '',
      searchText: '',
      history: {},
      extraDetails: {}
      // sortColumn: 'locationId',
      // reverseSort: true
    };

    _this.customerContractHistoryObj = {
      totalRecords: 0,
      results: [],
      loading: false,
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      allowOnlyOnce: false,
      errorMessage: '',
      searchText: '',
      history: {},
      extraDetails: {}
      // sortColumn: 'locationId',
      // reverseSort: true
    };

    _this.sortColumn = '';
    _this.reverseSort = true;

    _this.locationTypeIcon = {
      'REGULAR': 'regular.png',
      'ATM': 'atm.png',
      'BANK': 'bank.png',
      'NO_SHIP_NO_GO': 'nsng.png',
      'INTERNAL': 'internal.png',
      'TRUCK': 'truck.png',
      'TANKER': 'tanker.png',
      'WINDOW': 'window.png',
      'ON_CALL': 'oncall.png',
      'CARRIER': 'carrier.png',
      'LOCKER': 'locker.png',
      'VAULT': 'vault.png',
      'DELIVERY': 'delivery.png'
    };
    return _this;
  }

  (0, _createClass3.default)(CustomerallController, [{
    key: '$onInit',
    value: function $onInit() {
      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
    }
  }, {
    key: 'edit',
    value: function edit(customer) {
      this.$state.go('customer.edit', {
        id: customer.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(customer) {
      var _this2 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + customer.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this2.Service.remove(customer.id, _this2.branchId).then(function (data) {
            _this2.allowOnlyOnce = false;
            modal.close();
            _this2.refresh();
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this2.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      var searchObj = {
        queryJSON: {
          rules: [{
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + this.searchText + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + this.searchText + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };
      switch (this._status) {
        case 'active':
          {
            searchObj.queryJSON.rules.push({
              field: 'isEnabled',
              condition: '=',
              data: true
            });
            break;
          }
        case 'inactive':
          {
            searchObj.queryJSON.rules.push({
              field: 'isEnabled',
              condition: '=',
              data: false
            });
            break;
          }
      }
      return searchObj;
    }
  }, {
    key: 'loadData',
    value: function loadData(searchText) {
      var _this3 = this;

      var searchObj = this.generateSearchObj();

      this.loading = true;
      this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this3.total = data.total;

        _this3.loading = false;
        _this3.customers = data.results;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.error = err.message;
      });
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(customer) {
      customer.expand = !customer.expand;
      this.currentStats[customer.id] = this.customerHistoryStats.locations;
    }
  }, {
    key: 'getCurrentStats',
    value: function getCurrentStats(obj, value) {
      if (!obj.expanded) return;
      this.currentStats[obj.id] = value;
    }

    // ------------------------------------------ Customer location history logic section start ------------------------------------------ //

  }, {
    key: 'setLocationHistoryPage',
    value: function setLocationHistoryPage(isExpanded, customerId) {
      if (!isExpanded) return;
      this.customerLocationHistoryObj.extraDetails[customerId] = { page: 1 };
    }
  }, {
    key: 'getCustomerLocationHistory',
    value: function getCustomerLocationHistory(data, event) {
      var _this4 = this;

      var customerId = data.id;
      var serviceDays = [];

      document.getElementById('expand-btn-' + customerId).blur();
      if (!data.expanded) return;

      this.customerLocationHistoryObj.history[customerId] = { process: true };

      this.Service.getCustomerLocationHistory(this.customerLocationHistoryObj.extraDetails[customerId].searchText, customerId, this.reverseSort, this.sortColumn, (this.customerLocationHistoryObj.extraDetails[customerId].page - 1) * this.customerLocationHistoryObj.pagination.pageLimit, this.customerLocationHistoryObj.pagination.pageLimit).then(function (history) {
        _this4.customerLocationHistoryObj.history[customerId].details = history;
        _this4.customerLocationHistoryObj.history[customerId].details.pageLimit = _this4.customerLocationHistoryObj.pagination.pageLimit;

        _this4.customerLocationHistoryObj.history[customerId].details.results.forEach(function (history) {
          (0, _keys2.default)(_this4.weekDays).forEach(function (key) {
            if (history[key]) serviceDays.push(_this4.weekDays[key]);
          });
          history.serviceDays = serviceDays;
          serviceDays = [];
        });
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this4.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this4.customerLocationHistoryObj.history[customerId].process = false;
      });
    }
  }, {
    key: 'sortData',
    value: function sortData(column, obj, event) {
      this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
      this.sortColumn = column;
      this.loadCustomerHistory(obj, event);
    }
  }, {
    key: 'goToServiceHistory',
    value: function goToServiceHistory(locationId) {
      this.Navigation.goToServiceHistory(locationId, null, true, null);
    }
  }, {
    key: 'searchLocationHistory',
    value: function searchLocationHistory(data, event) {
      this.customerLocationHistoryObj.extraDetails[data.id].page = 1;
      this.getCustomerLocationHistory(data, event);
    }

    // ------------------------------------------ Customer location history logic section end ------------------------------------------ //

  }, {
    key: 'resetSearchText',
    value: function resetSearchText(obj) {
      var customerId = obj.id;

      this.customerLocationHistoryObj.extraDetails[customerId] = { searchText: '' };
      this.customerContractHistoryObj.extraDetails[customerId] = { searchText: '' };

      this.customerLocationHistoryObj.extraDetails[customerId].searchText = '';
      this.customerContractHistoryObj.extraDetails[customerId].searchText = '';
    }
  }, {
    key: 'loadCustomerHistory',
    value: function loadCustomerHistory(obj, event) {
      if (this.currentStats[obj.id] === this.customerHistoryStats.locations) this.getCustomerLocationHistory(obj, event);else if (this.currentStats[obj.id] === this.customerHistoryStats.contracts) this.getCustomerContractHistory(obj, event);
    }
  }, {
    key: 'locationHistoryFn',
    value: function locationHistoryFn(obj, event) {
      this.resetSearchText(obj);
      this.getCurrentStats(obj, this.customerHistoryStats.locations);
      this.setLocationHistoryPage(obj.expanded, obj.id);
      this.loadCustomerHistory(obj, event);
    }

    // ------------------------------------------ Customer contract history logic section start ------------------------------------------ //

  }, {
    key: 'setContractHistoryPage',
    value: function setContractHistoryPage(isExpanded, customerId) {
      if (!isExpanded) return;
      this.customerContractHistoryObj.extraDetails[customerId] = { page: 1 };
    }
  }, {
    key: 'getCustomerContractHistory',
    value: function getCustomerContractHistory(data, event) {
      var _this5 = this;

      var customerId = data.id;

      document.getElementById('expand-btn-' + customerId).blur();
      if (!data.expanded) return;

      this.customerContractHistoryObj.history[customerId] = { process: true };

      this.Service.getCustomerContractHistory(this.customerContractHistoryObj.extraDetails[customerId].searchText, customerId, this.reverseSort, this.sortColumn, (this.customerContractHistoryObj.extraDetails[customerId].page - 1) * this.customerContractHistoryObj.pagination.pageLimit, this.customerContractHistoryObj.pagination.pageLimit).then(function (history) {
        _this5.customerContractHistoryObj.history[customerId].details = history;
        _this5.customerContractHistoryObj.history[customerId].details.pageLimit = _this5.customerContractHistoryObj.pagination.pageLimit;
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this5.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this5.customerContractHistoryObj.history[customerId].process = false;
      });
    }
  }, {
    key: 'searchContractHistory',
    value: function searchContractHistory(data, event) {
      this.customerContractHistoryObj.extraDetails[data.id].page = 1;
      this.getCustomerContractHistory(data, event);
    }
  }, {
    key: 'goToContractHistory',
    value: function goToContractHistory(contractId) {
      this.$state.go('contract.edit', {
        id: contractId
      });
    }
  }, {
    key: 'contractHistoryFn',
    value: function contractHistoryFn(obj, event) {
      this.resetSearchText(obj);
      this.getCurrentStats(obj, 'contracts');
      this.setContractHistoryPage(obj.expanded, obj.id);
      this.loadCustomerHistory(obj, event);
    }

    // ------------------------------------------ Customer contract history logic section end ------------------------------------------ //

  }, {
    key: 'exportCustomerLocationHistory',
    value: function exportCustomerLocationHistory(customer) {
      var _this6 = this;

      var customerId = customer.id;

      this.customerLocationHistoryObj.extraDetails[customerId].isExport = true;
      var reportPrefix = 'Customer_Location(' + customer.name + ')';

      this.Service.exportCustomerLocationHistory(customerId, this.customerLocationHistoryObj.extraDetails[customerId].searchText, this.reverseSort, this.sortColumn).then(function (data) {
        _this6.downloadFile(customerId, reportPrefix, data.reportData);
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this6.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this6.customerLocationHistoryObj.extraDetails[customerId].isExport = false;
      });
    }
  }, {
    key: 'downloadFile',
    value: function downloadFile(customerId, reportPrefix, reportData) {
      var fileName = reportPrefix.concat('.csv');
      var a = document.createElement("a");
      document.body.appendChild(a);
      var file = new Blob([reportData], { type: 'application/csv' });
      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    }
  }, {
    key: 'exportCustomerLocationBillingRule',
    value: function exportCustomerLocationBillingRule(customer) {
      var _this7 = this;

      var customerId = customer.id;
      var contractId = customer.billToContractTransportId;

      this.customerLocationHistoryObj.extraDetails[customerId].isExportCustomerBillingRule = true;
      var reportPrefix = 'Customer_Location_Billing_Rules_Detail(' + customer.name + ')';

      this.Service.exportCustomerLocationBillingRule(customerId, contractId).then(function (data) {
        if (customer.totalContracts === 0) {
          _this7.Modal.errorModal('No Contract Rules Are Associated With Contract <b>' + contractId + '</b>');
          return;
        } else if (_.isEmpty(data)) {
          _this7.Modal.errorModal('Contract <b>' + contractId + '</b> Is Having Contract Rules Are Not Associated With Any Location.');
          return;
        } else _this7.downloadFile(customerId, reportPrefix, data.reportData);
      }).catch(function (err) {
        console.log(err);
        if (err && err.data && err.data.message) {
          _this7.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this7.customerLocationHistoryObj.extraDetails[customerId].isExportCustomerBillingRule = false;
      });
    }
  }]);
  return CustomerallController;
}(_customerBase2.default);

exports.default = CustomerallController;

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customerAll = __webpack_require__(2130);

var _customerAll2 = _interopRequireDefault(_customerAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerallModule = angular.module('customerall', []).component('customerall', _customerAll2.default).name;

exports.default = customerallModule;

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service_option = __webpack_require__(2809);

var _service_option2 = _interopRequireDefault(_service_option);

var _service_option3 = __webpack_require__(529);

var _service_option4 = _interopRequireDefault(_service_option3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serviceOptionComponent = {
  restrict: 'E',
  bindings: {
    model: '=ngModel'
  },
  template: _service_option2.default,
  controller: _service_option4.default
};

exports.default = serviceOptionComponent;

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customerCreate = __webpack_require__(2810);

var _customerCreate2 = _interopRequireDefault(_customerCreate);

var _customerCreate3 = __webpack_require__(2135);

var _customerCreate4 = _interopRequireDefault(_customerCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customercreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _customerCreate2.default,
  controller: _customerCreate4.default
};

exports.default = customercreateComponent;

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _customerBase = __webpack_require__(178);

var _customerBase2 = _interopRequireDefault(_customerBase);

var _service_option = __webpack_require__(529);

var _service_option2 = _interopRequireDefault(_service_option);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIMIT = 10;
var MAXLIMIT = 1000;

var CustomerCreateController = function (_CustomerBaseControll) {
	CustomerCreateController.$inject = ["Auth", "$state", "User", "CustomerService", "Modal", "$translate", "ContractService", "$q", "$scope", "CommonLayoutService", "ContractTypeService", "BillableEventsService"];
	(0, _inherits3.default)(CustomerCreateController, _CustomerBaseControll);

	/*@ngInject*/
	function CustomerCreateController(Auth, $state, User, CustomerService, Modal, $translate, ContractService, $q, $scope, CommonLayoutService, ContractTypeService, BillableEventsService) {
		(0, _classCallCheck3.default)(this, CustomerCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (CustomerCreateController.__proto__ || (0, _getPrototypeOf2.default)(CustomerCreateController)).call(this, Auth, $state, User, CustomerService, Modal, $translate, $scope));

		_this.isDisabledDate = function (currentDate, mode) {
			if (this.model.expirationDate !== null) {
				if (this.model.effectiveDate > this.model.expirationDate) {
					this.model.expirationDate = this.model.effectiveDate;
				} else if (this.model.effectiveDate == null) {
					this.model.expirationDate = null;
				}
			}

			this.effectiveMinDate = {
				minDate: this.model.effectiveDate
			};
		};

		_this.CustomerService = CustomerService;
		_this.ContractService = ContractService;
		_this.$q = $q;
		_this.ContractTypeService = ContractTypeService;
		_this.CommonLayoutService = CommonLayoutService;
		_this.BillableEventsService = BillableEventsService;
		_this.billingEventOptions = [];

		_this.defaultModel = {
			// id: '',
			name: '',
			accountingId: '',
			status: true,
			_address: '',
			_address2: '',
			_city: '',
			_state: null,
			_zip: '',
			_POC: '',
			_phone: '',
			_email: '',
			effectiveDate: null,
			expirationDate: null,
			today: moment.utc().format(),
			billingStatus: false,
			servicePriority: false,
			onDemandPickup: false,
			orderCutoff: false,
			orderCutoffDays: null,
			orderCutoffTime: null,
			serviceEmail: '',
			billToContractTransportId: null,
			billToContractDepositId: null,
			billToContractChangeOrderId: null,
			billToContractATMServiceId: null,
			billToContractCashHandlingId: null,
			billToContractMaintenanceId: null,
			sameForAll: false,
			billToContractTransportStatus: true,
			billToContractDepositStatus: true,
			billToContractChangeOrderStatus: true,
			billToContractATMServiceStatus: true,
			billToContractCashHandlingStatus: true,
			billToContractMaintenanceStatus: true,
			selectedFiles: [],
			annualIncrease: null,
			contractPocName: '',
			contractPocEmail: '',
			contractAddress: '',
			contractCity: '',
			contractState: null,
			contractZip: '',
			contractPocPhone: '',
			contractTypeObj: {
				totalRecords: 0,
				results: [],
				loading: false
			},
			contractPaymentMethod: '',
			contractType: null,
			surcharges: _this.buildDefaultSurcharges()
		};

		_this.model = angular.copy(_this.defaultModel);
		_this.model.customerContracts = [];
		_this.customers = [];
		_this.contracts = [];

		_this.statuses = [{
			label: 'Active',
			value: 'active'
		}, {
			label: 'Inactive',
			value: 'inactive'
		}];

		_this.toggleSwitchUI = {
			size: 'small',
			label: {
				on: _this.$translate.instant('common.yes'),
				off: _this.$translate.instant('common.no')
			},
			onColor: 'success',
			offColor: 'danger'
		};

		_this.serviceSchedule = [{
			label: _this.$translate.instant('location.mon'),
			model: 'serviceScheduleMon'
		}, {
			label: _this.$translate.instant('location.tues'),
			model: 'serviceScheduleTue'
		}, {
			label: _this.$translate.instant('location.wed'),
			model: 'serviceScheduleWed'
		}, {
			label: _this.$translate.instant('location.thurs'),
			model: 'serviceScheduleThu'
		}, {
			label: _this.$translate.instant('location.fri'),
			model: 'serviceScheduleFri'
		}, {
			label: _this.$translate.instant('location.sat'),
			model: 'serviceScheduleSat'
		}, {
			label: _this.$translate.instant('location.sun'),
			model: 'serviceScheduleSun'
		}, {
			label: _this.$translate.instant('location.hol'),
			model: 'serviceScheduleHol'
		}];

		_this.states = ["Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District Of Columbia", "Federated States Of Micronesia", "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"];

		_this.branchId = _this.User.getUser().branchId;
		_this.languageId = _this.User.getUser().languageId;
		_this.billingCategoryObj = {};
		_this.loggedInUser = _this.User.getUser().id;
		_this.paymentMethodList = CommonLayoutService.paymentMethod();

		_this.contractIdKeyObj = {
			transport: 'Transport',
			deposit: 'Deposit',
			changeOrder: 'ChangeOrder',
			ATMService: 'ATMService',
			cashHandling: 'CashHandling',
			maintenance: 'Maintenance'
		};
		return _this;
	}

	(0, _createClass3.default)(CustomerCreateController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.$q.all([this.ContractService.all(null, 0, LIMIT), this.getContractType('', 0), this.getBillingEventOptions()]).then(function (data) {
				_this2.contracts = _this2.mappingContractDatas(data[0].results);
				_this2.totalContract = data[0].total;
				_this2.billingEventOptions = data[2];
				_this2.applySurchargeOptions(_this2.model.surcharges, _this2.billingEventOptions);

				_this2.todayMinDate = {
					minDate: _this2.model.today
				};
				_this2.effectiveMinDate = {
					minDate: _this2.model.effectiveDate
				};
			}).catch(function (err) {
				_this2.error = err.message;
			}).finally(function () {
				_this2.loading = false;
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.model = angular.copy(this.defaultModel);
			this.getContractType('', 0);
			this.applySurchargeOptions(this.model.surcharges, this.billingEventOptions);
			this.clearErrors();
		}
	}, {
		key: 'delete',
		value: function _delete(index) {
			var contract = this.model.customerContracts[index];
			this.confirmDelete(contract, index);
		}
	}, {
		key: 'confirmDelete',
		value: function confirmDelete(contract, index) {
			var _this3 = this;

			this.Modal.confirm({
				header: this.$translate.instant(this.id + '.delete_title'),
				message: this.$translate.instant(this.id + '.delete_message'),
				callback: function callback(_ref) {
					var modal = _ref.modal;

					_this3.model.customerContracts.splice(index, 1);
					modal.close();
				},
				negative: function negative(_ref2) {
					var modal = _ref2.modal;

					modal.close();
				},
				type: 'primary',
				buttons: ['common.yes', 'common.no']
			});
		}
	}, {
		key: 'toggleDay',
		value: function toggleDay(day) {
			this.model[day.model] = !this.model[day.model];
		}
	}, {
		key: 'resetCustomerOrderLeadData',
		value: function resetCustomerOrderLeadData() {
			if (!this.model.orderCutoff) {
				this.model.orderCutoffDays = null;
				this.model.orderCutoffTime = null;
			}
		}
	}, {
		key: 'isDaySelected',
		value: function isDaySelected(day) {
			return this.model[day.model];
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this4 = this;

			this.loading = true;

			var _mapSurchargesForSubm = this.mapSurchargesForSubmit(this.model.surcharges),
			    customerFields = _mapSurchargesForSubm.customerFields,
			    surchargeBillingEvents = _mapSurchargesForSubm.surchargeBillingEvents;

			this.Service.create((0, _extends3.default)({}, customerFields, {
				name: this.model.name,
				contact: this.model.contact,
				accountingId: this.model.accountingId,
				isEnabled: this.model.status,
				billingAddress: this.model._address,
				billingAddress2: this.model._address2,
				billingState: this.model._state,
				billingCity: this.model._city,
				billingZip: this.model._zip,
				billingPhone: this.model._phone,
				billingEmail: this.model._email,
				billingPOC: this.model._POC,
				billingStatus: this.model.billingStatus,
				servicePriority: this.model.servicePriority,
				onDemandPickup: this.model.onDemandPickup,
				orderCutoff: this.model.orderCutoff,
				orderCutoffDays: this.model.orderCutoff && this.model.orderCutoffDays !== null && this.model.orderCutoffDays !== '' ? parseInt(this.model.orderCutoffDays, 10) : null,
				orderCutoffTime: this.model.orderCutoff && this.model.orderCutoffTime ? moment(this.model.orderCutoffTime).format('HH:mm:ss') : null,
				serviceEmail: this.model.serviceEmail,
				effectiveDate: this.model.effectiveDate ? this.model.effectiveDate : null,
				expirationDate: this.model.expirationDate ? this.model.expirationDate : null,
				serviceScheduleMon: this.model.serviceScheduleMon,
				serviceScheduleTue: this.model.serviceScheduleTue,
				serviceScheduleWed: this.model.serviceScheduleWed,
				serviceScheduleThu: this.model.serviceScheduleThu,
				serviceScheduleFri: this.model.serviceScheduleFri,
				serviceScheduleSat: this.model.serviceScheduleSat,
				serviceScheduleSun: this.model.serviceScheduleSun,
				serviceScheduleHol: this.model.serviceScheduleHol,
				billToContractTransportId: this.model.billToContractTransportId ? this.model.billToContractTransportId.value : null,
				billToContractDepositId: this.model.billToContractDepositId ? this.model.billToContractDepositId.value : null,
				billToContractChangeOrderId: this.model.billToContractChangeOrderId ? this.model.billToContractChangeOrderId.value : null,
				billToContractATMServiceId: this.model.billToContractATMServiceId ? this.model.billToContractATMServiceId.value : null,
				billToContractCashHandlingId: this.model.billToContractCashHandlingId ? this.model.billToContractCashHandlingId.value : null,
				billToContractMaintenanceId: this.model.billToContractMaintenanceId ? this.model.billToContractMaintenanceId.value : null,
				contractDocuments: this.model.selectedFiles.filter(function (d) {
					return delete d._file;
				}),
				annualIncrease: this.model.annualIncrease ? this.convertStr(this.model.annualIncrease) : null,
				POCName: this.model.contractPocName,
				address: this.model.contractAddress,
				city: this.model.contractCity,
				state: this.model.contractState,
				zip: this.model.contractZip,
				POCEmail: this.model.contractPocEmail,
				POCPhone: this.model.contractPocPhone,
				paymentMethod: this.model.paymentMethod,
				contractTypeId: this.model.contractType,
				surchargeBillingEvents: surchargeBillingEvents
			}), this.branchId, this.loggedInUser).then(function (data) {
				if (_this4.model.createNewLocation) {
					var locationModel = {
						customer: _this4.model.id,
						_address: _this4.model._address,
						_city: _this4.model._city,
						_state: _this4.model._state,
						_zip: _this4.model._zip,
						_poc: _this4.model._POC,
						pocPhone: _this4.model._phone,
						pocEmail: _this4.model._email
					};
					_this4.createLocation(locationModel);
				} else {
					_this4.loading = false;
					_this4.askCreate();
				}
			}).catch(function (err) {
				if (err && err.data && err.data.errors) {
					err.data.errors.map(function (e) {
						_this4.errorMessage += e.message + '<br/>';
					});
				} else {
					_this4.errorMessage += err.data.message + '<br/>';
				}
			}).finally(function () {
				_this4.loading = false;
			});
		}
	}, {
		key: 'createLocation',
		value: function createLocation(locationModel) {
			var _this5 = this;

			this.Modal.addLocation(locationModel, function (_ref3) {
				var modal = _ref3.modal,
				    data = _ref3.data;

				//close modal
				modal.close();
				_this5.loading = false;
				_this5.askCreate();
			}, function (_ref4) {
				var modal = _ref4.modal;

				modal.close();
				_this5.loading = false;
				_this5.askCreate();
			});
		}
	}, {
		key: 'mappingContractDatas',
		value: function mappingContractDatas(contracts) {
			return contracts.map(function (contract) {
				return {
					value: contract.id,
					title: contract.id,
					names: contract.contractName,
					Key: contract.id + ' | ' + contract.contractName,
					Value: contract.id
				};
			});
		}
	}, {
		key: 'loadContractData',
		value: function loadContractData(searchKey, offset) {
			var _this6 = this;

			var loadDatas = null;
			if (searchKey) {
				var searchObj = {
					queryText: '%' + searchKey + '%',
					isQuery: false
				};
				loadDatas = searchObj;
			}

			this.ContractService.all(loadDatas, offset, LIMIT).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this6.contracts = _this6.mappingContractDatas(data.results);
					_this6.totalContract = data.total;
				} else {
					var contracts = _this6.mappingContractDatas(data.results);
					_this6.contracts = _this6.contracts.concat(contracts);
					_this6.totalContract = data.total;
				}
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'resetBillingCategory',
		value: function resetBillingCategory(type) {
			if (!this.model['billToContract' + type + 'status']) this.model['billToContract' + type + 'Id'] = null;
		}
	}, {
		key: 'sameForAll',
		value: function sameForAll(value) {
			var _this7 = this;

			if (this.model.sameForAll) {
				(0, _values2.default)(this.contractIdKeyObj).forEach(function (key) {
					_this7.model['billToContract' + key + 'Id'] = value;
				});
			}
		}
	}, {
		key: 'getBillingRulesInfo',
		value: function getBillingRulesInfo(type) {
			var _this8 = this;

			var contractId = this.model['billToContract' + type + 'Id'];
			var contractInfo = [];

			if (!contractId) return;

			if (this.model.sameForAll) {
				(0, _values2.default)(this.contractIdKeyObj).forEach(function (key) {
					_this8.billingCategoryObj['billToContract' + key + 'Id'] = { process: true };
					contractInfo.push({
						type: key,
						contractId: contractId.value
					});
				});
			} else {
				this.billingCategoryObj['billToContract' + type + 'Id'] = { process: true };
				contractInfo.push({
					type: type,
					contractId: contractId.value
				});
			}

			this.Service.getBillingRulesInfo(this.languageId, contractInfo).then(function (data) {
				if (_this8.model.sameForAll) {
					(0, _values2.default)(_this8.contractIdKeyObj).forEach(function (key) {
						_this8.billingCategoryObj['billToContract' + key + 'Id'].details = data[type];
					});
				} else _this8.billingCategoryObj['billToContract' + type + 'Id'].details = data[type];
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				if (_this8.model.sameForAll) {
					(0, _values2.default)(_this8.contractIdKeyObj).forEach(function (key) {
						_this8.billingCategoryObj['billToContract' + key + 'Id'].process = false;
					});
				} else _this8.billingCategoryObj['billToContract' + type + 'Id'].process = false;
			});
		}
	}, {
		key: 'uploadContractDocuments',
		value: function uploadContractDocuments(stat) {
			var _this9 = this;

			this.Modal.uploadContractDocuments(stat, _.cloneDeep(this.model.selectedFiles), function (_ref5) {
				var modal = _ref5.modal,
				    data = _ref5.data,
				    $scope = _ref5.$scope;

				$scope.model.loading = false;
				_this9.model.selectedFiles = data;
				modal.close();
			}, function (_ref6) {
				var modal = _ref6.modal,
				    data = _ref6.data;

				_this9.model.selectedFiles = data;
				if (modal) modal.close();
			});
		}
	}, {
		key: 'ngPercentage',
		value: function ngPercentage() {
			if (this.model.annualIncrease && !this.model.annualIncrease.endsWith('%')) {
				return this.model.annualIncrease = this.model.annualIncrease + '%';
			}
		}
	}, {
		key: 'removePrecentageSign',
		value: function removePrecentageSign() {
			if (this.model.annualIncrease && this.model.annualIncrease.endsWith('%')) {
				return this.model.annualIncrease = this.model.annualIncrease.replace('%', '');
			}
		}
	}, {
		key: 'convertStr',
		value: function convertStr(str) {
			if (!str) return;
			return Number(str.replace('%', ''));
		}
	}, {
		key: 'getContractType',
		value: function getContractType(searchKey, offset) {
			var _this10 = this;

			searchKey = searchKey || '';

			var obj = {
				queryJSON: {
					rules: [{
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "type",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};

			this.model.contractTypeObj.loading = true;
			this.ContractTypeService.all(obj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this10.model.contractTypeObj.totalRecords = data.total;
					_this10.model.contractTypeObj.results = _this10.contractTypeMap(data.results);
				} else {
					var results = _this10.contractTypeMap(data.results);
					_this10.model.contractTypeObj.results = _this10.model.contractTypeObj.results.concat(results);
				}
			}).catch(function (err) {
				_this10.Modal.errorModal(err.data.message);
			}).finally(function () {
				_this10.model.contractTypeObj.loading = false;
			});
		}
	}, {
		key: 'contractTypeMap',
		value: function contractTypeMap(events) {
			return events.map(function (data) {
				return {
					Key: data.type,
					Value: data.id
				};
			});
		}
	}]);
	return CustomerCreateController;
}(_customerBase2.default);

exports.default = CustomerCreateController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customerCreate = __webpack_require__(2134);

var _customerCreate2 = _interopRequireDefault(_customerCreate);

__webpack_require__(3086);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerCreateModule = angular.module('customercreate', []).component('customercreate', _customerCreate2.default).name;

exports.default = customerCreateModule;

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customer = __webpack_require__(2811);

var _customer2 = _interopRequireDefault(_customer);

var _customer3 = __webpack_require__(2138);

var _customer4 = _interopRequireDefault(_customer3);

__webpack_require__(3087);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _customer2.default,
  controller: _customer4.default
};

exports.default = customerComponent;

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTBillingBase2 = __webpack_require__(108);

var _TNTBillingBase3 = _interopRequireDefault(_TNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerController = function (_TNTBillingBase) {
  CustomerController.$inject = ["$state"];
  (0, _inherits3.default)(CustomerController, _TNTBillingBase);

  /*@ngInject*/
  function CustomerController($state) {
    (0, _classCallCheck3.default)(this, CustomerController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomerController.__proto__ || (0, _getPrototypeOf2.default)(CustomerController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'customer';
    _this.$state = $state;
    _this.hasACL = {};
    return _this;
  }

  (0, _createClass3.default)(CustomerController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(CustomerController.prototype.__proto__ || (0, _getPrototypeOf2.default)(CustomerController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_billing_customer']) {
        this.hasACL[this.acl['tnt_billing_customer'][key]] = true;
      }
    }
  }]);
  return CustomerController;
}(_TNTBillingBase3.default);

exports.default = CustomerController;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customerEdit = __webpack_require__(2812);

var _customerEdit2 = _interopRequireDefault(_customerEdit);

var _customerEdit3 = __webpack_require__(2140);

var _customerEdit4 = _interopRequireDefault(_customerEdit3);

__webpack_require__(3088);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customereditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _customerEdit2.default,
  controller: _customerEdit4.default
};

exports.default = customereditComponent;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _customerBase = __webpack_require__(178);

var _customerBase2 = _interopRequireDefault(_customerBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerEditController = function (_CustomerBaseControll) {
	CustomerEditController.$inject = ["Auth", "$state", "User", "CustomerService", "Modal", "$translate", "$stateParams", "ContractService", "$q", "CommonLayoutService", "ContractTypeService", "BillableEventsService"];
	(0, _inherits3.default)(CustomerEditController, _CustomerBaseControll);

	/*@ngInject*/
	function CustomerEditController(Auth, $state, User, CustomerService, Modal, $translate, $stateParams, ContractService, $q, CommonLayoutService, ContractTypeService, BillableEventsService) {
		(0, _classCallCheck3.default)(this, CustomerEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (CustomerEditController.__proto__ || (0, _getPrototypeOf2.default)(CustomerEditController)).call(this, Auth, $state, User, CustomerService, Modal, $translate, $stateParams));
		// _= billing


		_this.isDisabledDate = function (currentDate, mode) {
			if (this.model.expirationDate !== null) {
				if (this.model.effectiveDate > this.model.expirationDate) {
					this.model.expirationDate = this.model.effectiveDate;
				} else if (this.model.effectiveDate == null) {
					this.model.expirationDate = null;
				}
			}
			this.effectiveMinDate = {
				minDate: this.model.effectiveDate
			};
		};

		_this.CustomerService = CustomerService;
		_this.ContractService = ContractService;
		_this.CommonLayoutService = CommonLayoutService;
		_this.ContractTypeService = ContractTypeService;
		_this.BillableEventsService = BillableEventsService;
		_this.$q = $q;
		_this.model = {
			id: '',
			name: '',
			accountingId: '',
			status: false,
			_address: '',
			_address2: '',
			_city: '',
			_state: '',
			_zip: '',
			_POC: '',
			_phone: '',
			_email: '',
			effectiveDate: new Date(),
			expirationDate: null,
			today: moment().hour(0).minutes(0).second(0).toDate(),
			billingStatus: false,
			servicePriority: false,
			onDemandPickup: false,
			orderCutoff: false,
			orderCutoffDays: null,
			orderCutoffTime: null,
			serviceEmail: '',
			billToContractTransportId: null,
			billToContractDepositId: null,
			billToContractChangeOrderId: null,
			billToContractATMServiceId: null,
			billToContractCashHandlingId: null,
			billToContractMaintenanceId: null,
			sameForAll: false,
			billToContractTransportStatus: true,
			billToContractDepositStatus: true,
			billToContractChangeOrderStatus: true,
			billToContractATMServiceStatus: true,
			billToContractCashHandlingStatus: true,
			billToContractMaintenanceStatus: true,
			annualIncrease: null,
			contractPocName: '',
			contractPocEmail: '',
			contractAddress: '',
			contractCity: '',
			contractState: null,
			contractZip: '',
			contractPocPhone: '',
			contractTypeObj: {
				totalRecords: 0,
				results: [],
				loading: false
			},
			contractPaymentMethod: '',
			contractType: '',
			surcharges: _this.buildDefaultSurcharges()
		};

		_this.pageName = "customer";

		_this.toggleSwitchUI = {
			size: 'small',
			label: {
				on: _this.$translate.instant('common.yes'),
				off: _this.$translate.instant('common.no')
			},
			onColor: 'success',
			offColor: 'danger'
		};

		_this.serviceSchedule = [{
			label: _this.$translate.instant('location.mon'),
			model: 'serviceScheduleMon'
		}, {
			label: _this.$translate.instant('location.tues'),
			model: 'serviceScheduleTue'
		}, {
			label: _this.$translate.instant('location.wed'),
			model: 'serviceScheduleWed'
		}, {
			label: _this.$translate.instant('location.thurs'),
			model: 'serviceScheduleThu'
		}, {
			label: _this.$translate.instant('location.fri'),
			model: 'serviceScheduleFri'
		}, {
			label: _this.$translate.instant('location.sat'),
			model: 'serviceScheduleSat'
		}, {
			label: _this.$translate.instant('location.sun'),
			model: 'serviceScheduleSun'
		}, {
			label: _this.$translate.instant('location.hol'),
			model: 'serviceScheduleHol'
		}];

		_this.states = ["Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District Of Columbia", "Federated States Of Micronesia", "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"];

		_this.branchId = _this.User.getUser().branchId;
		_this.languageId = _this.User.getUser().languageId;
		_this.loggedInUser = _this.User.getUser().id;
		_this.paymentMethodList = CommonLayoutService.paymentMethod();
		_this.billingCategoryObj = {};

		_this.contractMap = {
			'billToContractTransportId': 'Transport',
			'billToContractDepositId': 'Deposit',
			'billToContractChangeOrderId': 'ChangeOrder',
			'billToContractATMServiceId': 'ATMService',
			'billToContractCashHandlingId': 'CashHandling',
			'billToContractMaintenanceId': 'Maintenance'
		};

		_this.contractIdKeyObj = {
			transport: 'Transport',
			deposit: 'Deposit',
			changeOrder: 'ChangeOrder',
			ATMService: 'ATMService',
			cashHandling: 'CashHandling',
			maintenance: 'Maintenance'
		};
		return _this;
	}

	(0, _createClass3.default)(CustomerEditController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.$q.all([this.ContractService.all(null, 0, _app2.default.defaultPageLimit), this.Service.get(this.$stateParams.id), this.getContractType('', 0), this.getBillingEventOptions()]).then(function (data) {
				_this2.rawId = data[1].id;
				_this2.model.id = data[1].id;
				_this2.model.name = data[1].name;
				_this2.model.accountingId = data[1].accountingId;
				_this2.model.contact = data[1].contact;
				_this2.model.customerContracts = data[1].customerContracts || [];
				_this2.model.status = !!data[1].isEnabled;
				_this2.model._address = data[1].billingAddress;
				_this2.model._address2 = data[1].billingAddress2;
				_this2.model._state = data[1].billingState;
				_this2.model._city = data[1].billingCity;
				_this2.model._zip = data[1].billingZip;
				_this2.model._phone = data[1].billingPhone;
				_this2.model._email = data[1].billingEmail;
				_this2.model._POC = data[1].billingPOC;
				_this2.model.billingStatus = data[1].billingStatus;
				_this2.model.servicePriority = data[1].servicePriority;
				_this2.model.onDemandPickup = data[1].onDemandPickup;
				_this2.model.orderCutoff = data[1].orderCutoff;
				_this2.model.orderCutoffDays = data[1].orderCutoffDays;
				_this2.model.orderCutoffTime = data[1].orderCutoffTime ? moment(data[1].orderCutoffTime, 'HH:mm:ss').toDate() : null;
				_this2.model.serviceEmail = data[1].serviceEmail;
				_this2.model.billToContractTransportId = _this2.mappingContractRecord(data[1].billToContractTransport);
				_this2.model.billToContractDepositId = _this2.mappingContractRecord(data[1].billToContractDeposit);
				_this2.model.billToContractChangeOrderId = _this2.mappingContractRecord(data[1].billToContractChangeOrder);
				_this2.model.billToContractATMServiceId = _this2.mappingContractRecord(data[1].billToContractATMService);
				_this2.model.billToContractCashHandlingId = _this2.mappingContractRecord(data[1].billToContractCashHandling);
				_this2.model.billToContractMaintenanceId = _this2.mappingContractRecord(data[1].billToContractMaintenance);
				_this2.model.serviceScheduleMon = data[1].serviceScheduleMon;
				_this2.model.serviceScheduleTue = data[1].serviceScheduleTue;
				_this2.model.serviceScheduleWed = data[1].serviceScheduleWed;
				_this2.model.serviceScheduleThu = data[1].serviceScheduleThu;
				_this2.model.serviceScheduleFri = data[1].serviceScheduleFri;
				_this2.model.serviceScheduleSat = data[1].serviceScheduleSat;
				_this2.model.serviceScheduleSun = data[1].serviceScheduleSun;
				_this2.model.serviceScheduleHol = data[1].serviceScheduleHol;
				_this2.model.effectiveDate = data[1].effectiveDate ? new Date(data[1].effectiveDate) : null;
				_this2.model.expirationDate = data[1].expirationDate ? new Date(data[1].expirationDate) : null;
				_this2.model.totalContractDocuments = data[1].totalContractDocuments;
				_this2.contracts = _this2.mappingContractDatas(data[0].results);
				_this2.totalContract = data[0].total;
				_this2.model.annualIncrease = data[1].annualIncrease ? data[1].annualIncrease + '%' : null;
				_this2.model.customerContractId = data[1].customerContractId ? data[1].customerContractId : null;
				_this2.model.contractPocName = data[1].customerContractData ? data[1].customerContractData.POCName : null;
				_this2.model.contractPocEmail = data[1].customerContractData ? data[1].customerContractData.POCEmail : null;
				_this2.model.contractPocPhone = data[1].customerContractData ? data[1].customerContractData.POCPhone : null;
				_this2.model.contractAddress = data[1].customerContractData ? data[1].customerContractData.address : null;
				_this2.model.contractCity = data[1].customerContractData ? data[1].customerContractData.city : null;
				_this2.model.contractState = data[1].customerContractData ? data[1].customerContractData.state : null;
				_this2.model.contractZip = data[1].customerContractData ? data[1].customerContractData.zip : null;
				_this2.model.contractPaymentMethod = data[1].customerContractData ? data[1].customerContractData.paymentMethod : null;
				_this2.model.contractType = data[1].contractType ? data[1].contractType : null;

				_this2.applySurchargeOptions(_this2.model.surcharges, data[3]);
				_this2.applySurchargeData(_this2.model.surcharges, data[1]);

				_this2.todayMinDate = {
					minDate: _this2.model.today
				};

				_this2.effectiveMinDate = {
					minDate: _this2.model.effectiveDate
				};
			}).then(function () {
				var list = [];
				_this2.contractIds = (0, _keys2.default)(_this2.contractMap);

				_this2.contractIds.forEach(function (id) {
					if (_this2.model[id]) {
						list.push({
							type: _this2.contractMap[id],
							contractId: _this2.model[id].value
						});
						_this2.billingCategoryObj['billToContract' + _this2.contractMap[id] + 'Id'] = { process: true };
					}
				});

				_this2.Service.getBillingRulesInfo(_this2.languageId, list).then(function (data) {
					_this2.contractIds.forEach(function (id) {
						if (_this2.model[id]) {
							_this2.billingCategoryObj['billToContract' + _this2.contractMap[id] + 'Id'].details = data[_this2.contractMap[id]];
						}
					});
				}).catch(function (err) {
					console.log(err);
				}).finally(function () {
					_this2.contractIds.forEach(function (id) {
						if (_this2.model[id]) {
							_this2.billingCategoryObj['billToContract' + _this2.contractMap[id] + 'Id'].process = false;
						}
					});
				});
			}).catch(function (err) {
				_this2.error = err.message;
			}).finally(function () {
				_this2.loading = false;
			});
		}
	}, {
		key: 'mappingContractRecord',
		value: function mappingContractRecord(contract) {
			if (contract == null) return contract;

			contract.value = contract.id;
			contract.title = contract.id;
			contract.names = contract.contractName;
			contract.Key = contract.id + ' | ' + contract.contractName;
			contract.Value = contract.id;
			return contract;
		}
	}, {
		key: 'delete',
		value: function _delete(index) {
			var contract = this.model.customerContracts[index];
			this.confirmDelete(contract, index);
		}
	}, {
		key: 'confirmDelete',
		value: function confirmDelete(contract, index) {
			var _this3 = this;

			this.Modal.confirm({
				header: this.$translate.instant(this.id + '.delete_title'),
				message: this.$translate.instant(this.id + '.delete_message'),
				callback: function callback(_ref) {
					var modal = _ref.modal;

					if (contract.isNew) {
						_this3.model.customerContracts.splice(index, 1);
					} else {
						_this3.ContractService.remove(contract.id).then(function () {
							_this3.model.customerContracts.splice(index, 1);
						});
					}
					modal.close();
				},
				negative: function negative(_ref2) {
					var modal = _ref2.modal;

					modal.close();
				},
				type: 'primary',
				buttons: ['common.yes', 'common.no']
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.$onInit();
			// this.Service.get(this.$stateParams.id)
			// 	.then((data) =>{
			// 		this.$onInit();
			// 	})
		}
	}, {
		key: 'toggleDay',
		value: function toggleDay(day) {
			this.model[day.model] = !this.model[day.model];
		}
	}, {
		key: 'isDaySelected',
		value: function isDaySelected(day) {
			return this.model[day.model];
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this4 = this;

			if (!this.validate()) {
				return;
			}
			this.loading = true;

			var _mapSurchargesForSubm = this.mapSurchargesForSubmit(this.model.surcharges),
			    customerFields = _mapSurchargesForSubm.customerFields,
			    surchargeBillingEvents = _mapSurchargesForSubm.surchargeBillingEvents;

			this.Service.update(this.rawId, (0, _extends3.default)({
				id: this.rawId
			}, customerFields, {
				name: this.model.name,
				contact: this.model.contact,
				accountingId: this.model.accountingId,
				isEnabled: this.model.status,
				billingAddress: this.model._address,
				billingAddress2: this.model._address2,
				billingState: this.model._state,
				billingCity: this.model._city,
				billingZip: this.model._zip,
				billingPhone: this.model._phone,
				billingEmail: this.model._email,
				billingPOC: this.model._POC,
				billingStatus: this.model.billingStatus,
				servicePriority: this.model.servicePriority,
				onDemandPickup: this.model.onDemandPickup,
				orderCutoff: this.model.orderCutoff,
				orderCutoffDays: this.model.orderCutoff && this.model.orderCutoffDays !== null && this.model.orderCutoffDays !== '' ? parseInt(this.model.orderCutoffDays, 10) : null,
				orderCutoffTime: this.model.orderCutoff && this.model.orderCutoffTime ? moment(this.model.orderCutoffTime).format('HH:mm:ss') : null,
				serviceEmail: this.model.serviceEmail,
				effectiveDate: this.model.effectiveDate ? this.model.effectiveDate : null,
				expirationDate: this.model.expirationDate ? this.model.expirationDate : null,
				serviceScheduleMon: this.model.serviceScheduleMon,
				serviceScheduleTue: this.model.serviceScheduleTue,
				serviceScheduleWed: this.model.serviceScheduleWed,
				serviceScheduleThu: this.model.serviceScheduleThu,
				serviceScheduleFri: this.model.serviceScheduleFri,
				serviceScheduleSat: this.model.serviceScheduleSat,
				serviceScheduleSun: this.model.serviceScheduleSun,
				serviceScheduleHol: this.model.serviceScheduleHol,
				billToContractTransportId: this.model.billToContractTransportId ? this.model.billToContractTransportId.value : null,
				billToContractDepositId: this.model.billToContractDepositId ? this.model.billToContractDepositId.value : null,
				billToContractChangeOrderId: this.model.billToContractChangeOrderId ? this.model.billToContractChangeOrderId.value : null,
				billToContractATMServiceId: this.model.billToContractATMServiceId ? this.model.billToContractATMServiceId.value : null,
				billToContractCashHandlingId: this.model.billToContractCashHandlingId ? this.model.billToContractCashHandlingId.value : null,
				billToContractMaintenanceId: this.model.billToContractMaintenanceId ? this.model.billToContractMaintenanceId.value : null,
				annualIncrease: this.model.annualIncrease ? this.convertStr(this.model.annualIncrease) : null,
				customerContractId: this.model.customerContractId,
				contractTypeId: this.model.contractType,
				POCName: this.model.contractPocName,
				POCEmail: this.model.contractPocEmail,
				POCPhone: this.model.contractPocPhone,
				address: this.model.contractAddress,
				city: this.model.contractCity,
				state: this.model.contractState,
				zip: this.model.contractZip,
				paymentMethod: this.model.contractPaymentMethod,
				surchargeBillingEvents: surchargeBillingEvents
			}), this.branchId, this.loggedInUser).then(function (data) {
				_this4.loading = false;
				window.history.go(-1);
			}).catch(function (err) {
				if (err && err.data && err.data.errors) {
					err.data.errors.map(function (e) {
						_this4.errorMessage += e.message + '<br/>';
					});
				} else {
					_this4.errorMessage += err.data.message + '<br/>';
				}
			}).finally(function () {
				_this4.loading = false;
			});
		}
	}, {
		key: 'mappingContractDatas',
		value: function mappingContractDatas(contracts) {
			return contracts.map(function (contract) {
				return {
					value: contract.id,
					title: contract.id,
					names: contract.contractName,
					Key: contract.id + ' | ' + contract.contractName,
					Value: contract.id
				};
			});
		}
	}, {
		key: 'loadContractData',
		value: function loadContractData(searchKey, offset) {
			var _this5 = this;

			var loadDatas = null;
			if (searchKey) {
				var searchObj = {
					queryText: '%' + searchKey + '%',
					isQuery: false
				};
				loadDatas = searchObj;
			}

			this.ContractService.all(loadDatas, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this5.contracts = _this5.mappingContractDatas(data.results);
					_this5.totalContract = data.total;
				} else {
					var contracts = _this5.mappingContractDatas(data.results);
					_this5.contracts = _this5.contracts.concat(contracts);
					_this5.totalContract = data.total;
				}
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'resetBillingCategory',
		value: function resetBillingCategory(type) {
			if (!this.model['billToContract' + type + 'status']) this.model['billToContract' + type + 'Id'] = null;
		}
	}, {
		key: 'sameForAll',
		value: function sameForAll(value) {
			var _this6 = this;

			if (this.model.sameForAll) {
				(0, _values2.default)(this.contractIdKeyObj).forEach(function (key) {
					_this6.model['billToContract' + key + 'Id'] = value;
				});
			}
		}
	}, {
		key: 'getBillingRulesInfo',
		value: function getBillingRulesInfo(type) {
			var _this7 = this;

			var contractId = this.model['billToContract' + type + 'Id'];
			var contractInfo = [];

			if (!contractId) return;

			if (this.model.sameForAll) {
				(0, _values2.default)(this.contractIdKeyObj).forEach(function (key) {
					_this7.billingCategoryObj['billToContract' + key + 'Id'] = { process: true };
					contractInfo.push({
						type: key,
						contractId: contractId.value
					});
				});
			} else {
				this.billingCategoryObj['billToContract' + type + 'Id'] = { process: true };
				contractInfo.push({
					type: type,
					contractId: contractId.value
				});
			}

			this.Service.getBillingRulesInfo(this.languageId, contractInfo).then(function (data) {
				if (_this7.model.sameForAll) {
					(0, _values2.default)(_this7.contractIdKeyObj).forEach(function (key) {
						_this7.billingCategoryObj['billToContract' + key + 'Id'].details = data[type];
					});
				} else _this7.billingCategoryObj['billToContract' + type + 'Id'].details = data[type];
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				if (_this7.model.sameForAll) {
					(0, _values2.default)(_this7.contractIdKeyObj).forEach(function (key) {
						_this7.billingCategoryObj['billToContract' + key + 'Id'].process = false;
					});
				} else _this7.billingCategoryObj['billToContract' + type + 'Id'].process = false;
			});
		}
	}, {
		key: 'uploadContractDocuments',
		value: function uploadContractDocuments(stat) {
			var _this8 = this;

			this.Modal.uploadContractDocuments(stat, [], function (_ref3) {
				var modal = _ref3.modal,
				    data = _ref3.data,
				    $scope = _ref3.$scope;

				_this8.CustomerService.uploadContractDocument(data, _this8.rawId, _this8.branchId).then(function (data) {
					_this8.model.totalContractDocuments = data.totalFiles;
				}).catch(function (err) {
					if (err && err.data && err.data.message) {
						_this8.Modal.errorModal(err.data.message);
					}
				}).finally(function () {
					$scope.model.loading = false;
					modal.close();
				});
			}, function (_ref4) {
				var modal = _ref4.modal;

				if (modal) modal.close();
			});
		}
	}, {
		key: 'openSurchargeHistory',
		value: function openSurchargeHistory() {
			var _this9 = this;

			if (this.surchargeHistoryLoading) return;
			this.surchargeHistoryLoading = true;

			this.Service.getSurchargeHistory(this.rawId).then(function (rows) {
				var eventLabels = {};
				(_this9.model.surcharges[_this9.surchargeTypeList[0]].billingEventOptions || []).forEach(function (option) {
					eventLabels[option.id] = option.label;
				});
				_this9.Modal.surchargeHistory({
					customerName: _this9.model.name,
					rows: rows,
					labelKeys: _this9.surchargeLabelKeys,
					eventLabels: eventLabels
				});
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this9.Modal.errorModal(err.data.message);
				}
			}).finally(function () {
				_this9.surchargeHistoryLoading = false;
			});
		}
	}, {
		key: 'viewContractDocuments',
		value: function viewContractDocuments() {
			var _this10 = this;

			this.Modal.viewContractDocuments(this.rawId, function (_ref5) {
				var modal = _ref5.modal,
				    data = _ref5.data;

				_this10.model.totalContractDocuments = data.length;
			}, function (_ref6) {
				var modal = _ref6.modal,
				    data = _ref6.data;

				if (data) {
					_this10.model.totalContractDocuments = data.length;
				}
				if (modal) modal.close();
			});
		}
	}, {
		key: 'ngPercentage',
		value: function ngPercentage() {
			if (this.model.annualIncrease && !this.model.annualIncrease.endsWith('%')) {
				return this.model.annualIncrease = this.model.annualIncrease + '%';
			}
		}
	}, {
		key: 'removePrecentageSign',
		value: function removePrecentageSign() {
			if (this.model.annualIncrease && this.model.annualIncrease.endsWith('%')) {
				return this.model.annualIncrease = this.model.annualIncrease.replace('%', '');
			}
		}
	}, {
		key: 'convertStr',
		value: function convertStr(str) {
			if (!str) return;
			return Number(str.replace('%', ''));
		}
	}, {
		key: 'getContractType',
		value: function getContractType(searchKey, offset) {
			var _this11 = this;

			searchKey = searchKey || '';

			var obj = {
				queryJSON: {
					rules: [{
						group: {
							rules: [{
								field: "id",
								condition: "like",
								data: "%" + searchKey + "%"
							}, {
								field: "type",
								condition: "like",
								data: "%" + searchKey + "%"
							}],
							operator: "OR"
						}
					}],
					operator: "AND"
				}
			};

			this.model.contractTypeObj.loading = true;
			this.ContractTypeService.all(obj, offset, _app2.default.defaultPageLimit).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this11.model.contractTypeObj.totalRecords = data.total;
					_this11.model.contractTypeObj.results = _this11.contractTypeMap(data.results);
				} else {
					var results = _this11.contractTypeMap(data.results);
					_this11.model.contractTypeObj.results = _this11.model.contractTypeObj.results.concat(results);
				}
			}).catch(function (err) {
				_this11.Modal.errorModal(err.data.message);
			}).finally(function () {
				_this11.model.contractTypeObj.loading = false;
			});
		}
	}, {
		key: 'contractTypeMap',
		value: function contractTypeMap(events) {
			return events.map(function (data) {
				return {
					Key: data.type,
					Value: data.id
				};
			});
		}
	}, {
		key: 'handleCustomerContractData',
		value: function handleCustomerContractData(contractType) {
			var _this12 = this;

			if (contractType && contractType.Value) {
				this.Service.getCustomerContractData(contractType.Value, this.rawId).then(function (data) {
					if (data && data.length > 0) {
						_this12.model.contractPocName = data[0].POCName;
						_this12.model.contractPocEmail = data[0].POCEmail;
						_this12.model.contractPocPhone = data[0].POCPhone;
						_this12.model.contractAddress = data[0].address;
						_this12.model.contractCity = data[0].city;
						_this12.model.contractState = data[0].state;
						_this12.model.contractZip = data[0].zip;
						_this12.model.contractPaymentMethod = data[0].paymentMethod;
					} else _this12.setCustomerContractDataNull();
				}).catch(function (err) {
					console.log("err", err);
				});
			} else this.setCustomerContractDataNull();
		}
	}, {
		key: 'setCustomerContractDataNull',
		value: function setCustomerContractDataNull() {
			this.model.contractPocName = null;
			this.model.contractPocEmail = null;
			this.model.contractPocPhone = null;
			this.model.contractAddress = null;
			this.model.contractCity = null;
			this.model.contractState = null;
			this.model.contractZip = null;
			this.model.contractPaymentMethod = null;
		}
	}]);
	return CustomerEditController;
}(_customerBase2.default);

exports.default = CustomerEditController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customerEdit = __webpack_require__(2139);

var _customerEdit2 = _interopRequireDefault(_customerEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerEditModule = angular.module('customeredit', []).component('customeredit', _customerEdit2.default).name;

exports.default = customerEditModule;

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customer = __webpack_require__(2137);

var _customer2 = _interopRequireDefault(_customer);

var _create = __webpack_require__(2136);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2141);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2132);

var _all2 = _interopRequireDefault(_all);

var _service_option = __webpack_require__(2133);

var _service_option2 = _interopRequireDefault(_service_option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerModule = angular.module('customer', [_create2.default, _edit2.default, _all2.default]).component('customer', _customer2.default).component('serviceOption', _service_option2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('customer.edit', {
    url: '/edit/:id',
    component: 'customeredit',
    data: {
      requireACL: 'tnt_billing_customer.edit'
    }
  }).state('customer.create', {
    url: '/create',
    component: 'customercreate',
    data: {
      requireACL: 'tnt_billing_customer.create'
    }
  }).state('customer.all', {
    url: '/all/:page',
    component: 'customerall',
    data: {
      requireACL: 'tnt_billing_customer.view'
    }
  });
}]).name;

exports.default = customerModule;

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fuel_surchargesAll = __webpack_require__(2813);

var _fuel_surchargesAll2 = _interopRequireDefault(_fuel_surchargesAll);

var _fuel_surchargesAll3 = __webpack_require__(2144);

var _fuel_surchargesAll4 = _interopRequireDefault(_fuel_surchargesAll3);

__webpack_require__(3089);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fuelSurchargesAllComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _fuel_surchargesAll2.default,
  controller: _fuel_surchargesAll4.default
};

exports.default = fuelSurchargesAllComponent;

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FuelSurchagesAllController = function () {
	/*@ngInject*/
	FuelSurchagesAllController.$inject = ["Auth", "$state", "$stateParams", "User", "UsersService", "Modal", "$translate", "$location", "FuelSurchargeService", "UserService", "BranchService", "$q", "$scope"];
	function FuelSurchagesAllController(Auth, $state, $stateParams, User, UsersService, Modal, $translate, $location, FuelSurchargeService, UserService, BranchService, $q, $scope) {
		var _this = this;

		(0, _classCallCheck3.default)(this, FuelSurchagesAllController);

		this.goToCustomer = function (customerId) {
			_this.$state.go('customer.edit', {
				id: customerId
			});
		};

		this.Auth = Auth;
		this.User = User;
		this.Modal = Modal;
		this.FuelSurchargeService = FuelSurchargeService;
		this.UserService = UserService;
		this.BranchService = BranchService;
		this.$q = $q;
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$location = $location;
		this.permissions = this.Auth.permission();

		this.loading = false; //true
		this.fuelSurcharges = [];
		this.page = 1;
		this.total = 0;
		this.pageLimit = 10;
		this.maxPages = 10;
		this.hasACL = {};
		// this.pagination = {
		// 	page: 1,
		// 	total: 0,
		// 	pageLimit: 10,
		// 	maxPages: 10
		// }
		this.sortColumn = "customerName";
		this.reverseSort = false;

		this.searchObj = {
			searchText: '',
			status: null
		};

		this.statusList = [{
			label: $translate.instant('location_types.All'),
			value: null
		}, {
			label: $translate.instant('common.active'),
			value: 1
		}, {
			label: $translate.instant('common.inactive'),
			value: 0
		}];
	}

	(0, _createClass3.default)(FuelSurchagesAllController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			var pageId = this.$stateParams.page;
			if (pageId > 0) {
				this.page = pageId;
			}

			var fuelSurchargesACL = this.User.getACL("fuel_surcharges");
			if (fuelSurchargesACL && fuelSurchargesACL.length) {
				fuelSurchargesACL.forEach(function (key) {
					_this2.hasACL[key] = true;
				});
			}
			this.loadData();
		}
	}, {
		key: 'applyFilter',
		value: function applyFilter() {
			this.page = 1;
			this.loadData();
		}
	}, {
		key: 'pageChange',
		value: function pageChange() {
			var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
			this.$stateParams.page = this.page;
			this.$location.path(newUrl);
			this.loadData();
		}
	}, {
		key: 'loadData',
		value: function loadData() {
			var _this3 = this;

			this.loading = true;
			this.fuelSurcharges = [];
			this.FuelSurchargeService.all(this.searchObj.searchText, this.searchObj.status, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (_ref) {
				var data = _ref.data,
				    count = _ref.count;

				_this3.total = count;
				_this3.fuelSurcharges = data;
				_this3.loading = false;
			}).catch(function (err) {
				_this3.loading = false;
				_this3.error = err.message;
			});
		}
	}, {
		key: 'edit',
		value: function edit(fuelSurcharg) {
			this.$state.go('fuel_surcharges.edit', {
				id: fuelSurcharg.id
			});
		}
	}, {
		key: 'onCustomerPageChange',
		value: function onCustomerPageChange(fuelSurcharge) {
			this.getFuelSurchargeCustomers(fuelSurcharge);
		}
	}, {
		key: 'sortData',
		value: function sortData(column, fuelSurcharge) {
			this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
			this.sortColumn = column;

			fuelSurcharge.customerFilter.sortingKey = column;
			fuelSurcharge.customerFilter.sortingDir = this.reverseSort;
			this.getFuelSurchargeCustomers(fuelSurcharge);
		}
	}, {
		key: 'expandFuelSurchageCustomer',
		value: function expandFuelSurchageCustomer(fuelSurcharge) {
			fuelSurcharge.expanded = !fuelSurcharge.expanded;
		}
	}, {
		key: 'getFuelSurchargeCustomers',
		value: function getFuelSurchargeCustomers(fuelSurcharge) {
			if (fuelSurcharge.expanded) {
				var defaultFilter = {
					fuelSurchargeId: fuelSurcharge.id,
					sortingKey: this.sortColumn, //'fuelSurchargeId',
					sortingDir: this.reverseSort,
					limit: 10,
					page: 1
				};
				if (!fuelSurcharge.customerFilter) {
					fuelSurcharge.customerFilter = defaultFilter;
				}
				fuelSurcharge.customerFilter.offset = (fuelSurcharge.customerFilter.page - 1) * fuelSurcharge.customerFilter.limit;

				fuelSurcharge.isCustomerLoading = true;
				this.FuelSurchargeService.fuelSurchageCustomers({
					'fuelSurchargeId': fuelSurcharge.id,
					'sortingKey': fuelSurcharge.customerFilter.sortingKey,
					'sortingDir': fuelSurcharge.customerFilter.sortingDir,
					'limit': fuelSurcharge.customerFilter.limit,
					'offset': fuelSurcharge.customerFilter.offset
				}).then(function (_ref2) {
					var data = _ref2.data,
					    count = _ref2.count;

					fuelSurcharge.isCustomerLoading = false;
					fuelSurcharge.totalCustomers = count;
					fuelSurcharge.customerList = data;
				}).catch(function (err) {
					fuelSurcharge.isCustomerLoading = false;
					fuelSurcharge.customerError = err.message;
				});
			} else {
				fuelSurcharge.customerFilter.page = 1;
			}
		}
	}, {
		key: 'expandFuelSurchageLocation',
		value: function expandFuelSurchageLocation(fuelSurcharge) {
			fuelSurcharge.expandedLocation = !fuelSurcharge.expandedLocation;
		}
	}, {
		key: 'getFuelSurchargeLocations',
		value: function getFuelSurchargeLocations(fuelSurcharge) {
			if (fuelSurcharge.expandedLocation) {
				var defaultFilter = {
					fuelSurchargeId: fuelSurcharge.id,
					sortingKey: 'fuelSurchargeId',
					sortingDir: false,
					limit: 10,
					page: 1
				};
				if (!fuelSurcharge.locationFilter) {
					fuelSurcharge.locationFilter = defaultFilter;
				}
				fuelSurcharge.locationFilter.offset = (fuelSurcharge.locationFilter.page - 1) * fuelSurcharge.locationFilter.limit;

				fuelSurcharge.isLocationLoading = true;
				this.FuelSurchargeService.fuelSurchargeLocations({
					'fuelSurchargeId': fuelSurcharge.id,
					'sortingKey': fuelSurcharge.locationFilter.sortingKey,
					'sortingDir': fuelSurcharge.locationFilter.sortingDir,
					'limit': fuelSurcharge.locationFilter.limit,
					'offset': fuelSurcharge.locationFilter.offset
				}).then(function (_ref3) {
					var data = _ref3.data,
					    count = _ref3.count;

					fuelSurcharge.isLocationLoading = false;
					fuelSurcharge.totalLocations = count;
					fuelSurcharge.locationList = data;
				}).catch(function (err) {
					fuelSurcharge.isLocationLoading = false;
					fuelSurcharge.locationError = err.message;
				});
			} else {
				fuelSurcharge.locationFilter.page = 1;
			}
		}
	}, {
		key: 'showLocations',
		value: function showLocations(fuelSurcharg, customerId) {
			var _this4 = this;

			this.Modal.FuelSurchargeLocations(fuelSurcharg, customerId, function (_ref4) {
				var modal = _ref4.modal;

				modal.close();
			}, function (_ref5) {
				var modal = _ref5.modal;

				_this4.isLoading = false;
				if (modal) modal.close();
			});
		}
	}]);
	return FuelSurchagesAllController;
}();

exports.default = FuelSurchagesAllController;

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fuel_surchargesAll = __webpack_require__(2143);

var _fuel_surchargesAll2 = _interopRequireDefault(_fuel_surchargesAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fuelSurchargesAllModule = angular.module('fuelsurchargesall', []).component('fuelsurchargesall', _fuel_surchargesAll2.default).name;

exports.default = fuelSurchargesAllModule;

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fuel_surchargesCreate = __webpack_require__(2814);

var _fuel_surchargesCreate2 = _interopRequireDefault(_fuel_surchargesCreate);

var _fuel_surchargesCreate3 = __webpack_require__(2147);

var _fuel_surchargesCreate4 = _interopRequireDefault(_fuel_surchargesCreate3);

__webpack_require__(3090);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fuelSurchargesCreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _fuel_surchargesCreate2.default,
  controller: _fuel_surchargesCreate4.default
};

exports.default = fuelSurchargesCreateComponent;

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FuelSurchagesCreateController = function () {
	/*@ngInject*/
	FuelSurchagesCreateController.$inject = ["Auth", "$state", "User", "FuelSurchargeService", "Modal", "$translate", "UserService", "BranchService", "SetupService", "$q", "$scope"];
	function FuelSurchagesCreateController(Auth, $state, User, FuelSurchargeService, Modal, $translate, UserService, BranchService, SetupService, $q, $scope) {
		var _this = this;

		(0, _classCallCheck3.default)(this, FuelSurchagesCreateController);

		this.goToCustomer = function (customerId) {
			_this.$state.go('customer.edit', {
				id: customerId
			});
		};

		this.Auth = Auth;
		this.Modal = Modal;
		this.User = User;
		this.$state = $state;
		this.FuelSurchargeService = FuelSurchargeService;
		this.UserService = UserService;
		this.BranchService = BranchService;
		this.SetupService = SetupService;
		this.$q = $q;
		this.$scope = $scope;
		this.$translate = $translate;
		this.permissions = this.Auth.permission();
		this.branchId = this.User.getUser().branchId;
		this.branchesList = [];
		this.appliedList = [{
			label: this.$translate.instant('fuel_surcharge.applied_monthly'),
			value: 'MONTHLY'
		}, {
			label: this.$translate.instant('fuel_surcharge.applied_bi_weekly'),
			value: 'BI_WEEKLY'
		}, {
			label: this.$translate.instant('fuel_surcharge.applied_weekly'),
			value: 'WEEKLY'
		}];
		this.localLang = {
			selectAll: this.$translate.instant('common.selectall'),
			selectNone: this.$translate.instant('common.selectnone'),
			reset: this.$translate.instant('shipmentBatch.reset'),
			search: this.$translate.instant('common.search'),
			nothingSelected: this.$translate.instant('common.noneselected') //default-label is deprecated and replaced with this.
		};

		this.defaultModel = {
			id: '',
			name: '',
			status: true,
			appliedRange: null,
			branchIds: [],
			branches: [],
			description: '',
			surcharges: [],
			customers: [],
			branchId: this.branchId
		};

		this.model = angular.copy(this.defaultModel);
	}

	(0, _createClass3.default)(FuelSurchagesCreateController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			if (!this.model.surcharges.length) {
				this.addNewSurcharge();
			}

			this.$q.all([this.BranchService.all(null, 0, 1000)]).then(function (data) {
				_this2.branches = data[0].results;
			}).catch(function (err) {
				if (err.data && err.data.errors) {
					err.data.errors.map(function (e) {
						_this2.errorMessage += e.message + '<br/>';
					});
				} else {
					_this2.errorMessage = err.message || err;
				}
			});
		}
	}, {
		key: 'setSurcharges',
		value: function setSurcharges() {
			this.model.surcharges.push({
				priceRange: {
					from: this.model.surcharges.length ? parseFloat(this.model.surcharges[this.model.surcharges.length - 1].priceRange.to) + 0.01 : 0.00,
					to: null
				},
				surcharge: ''
			});
		}
	}, {
		key: 'addNewSurcharge',
		value: function addNewSurcharge() {
			if (this.model.surcharges.length) {
				var currentIndex = this.model.surcharges[this.model.surcharges.length - 1];
				if (currentIndex.priceRange.to) {
					this.setSurcharges();
				}
			} else {
				this.setSurcharges();
			}
		}
	}, {
		key: 'isSurchargeValid',
		value: function isSurchargeValid() {
			if (this.model.surcharges.length) {
				var invalidList = this.model.surcharges.filter(function (item) {
					return !item.priceRange.to || !item.priceRange.to || !item.surcharge;
				});
				return invalidList && invalidList.length ? false : true;
			} else {
				return false;
			}
		}
	}, {
		key: 'onSurchargeChange',
		value: function onSurchargeChange(e, i) {
			var _this3 = this;

			if (this.model.surcharges && this.model.surcharges.length) {
				this.model.surcharges.forEach(function (ele, index) {
					if (_this3.model.surcharges[index + 1] && (!_this3.model.surcharges[index + 1].priceRange.from || _this3.model.surcharges[index].priceRange.to > _this3.model.surcharges[index + 1].priceRange.from)) {
						_this3.model.surcharges[index + 1].priceRange.from = parseFloat(_this3.model.surcharges[index].priceRange.to) + 0.01;
					}
				});
			}
		}
	}, {
		key: 'removeSurcharge',
		value: function removeSurcharge(index) {
			this.model.surcharges.splice(index, 1);
		}
	}, {
		key: 'removeCustomer',
		value: function removeCustomer(index) {
			this.model.customers.splice(index, 1);
		}
	}, {
		key: 'addNewCustomer',
		value: function addNewCustomer() {
			var _this4 = this;

			this.Modal.FuelSurchargeCustomer({}, function (_ref) {
				var customer = _ref.customer,
				    modal = _ref.modal;

				modal.close();
				_this4.model.customers.push(customer);
				_this4.model.customers = _.uniqBy(_this4.model.customers, 'id');
			}, function (_ref2) {
				var modal = _ref2.modal;

				_this4.isLoading = false;
				if (modal) modal.close();
			});
		}
	}, {
		key: 'ngPercentage',
		value: function ngPercentage(index) {
			if (this.model.surcharges[index].surcharge) {
				var str = this.model.surcharges[index].surcharge.toString();
				return this.model.surcharges[index].surcharge = str ? str.endsWith('%') ? str : str + '%' : null;
			}
		}
	}, {
		key: 'removePrecentageSign',
		value: function removePrecentageSign(index) {
			if (this.model.surcharges[index].surcharge && this.model.surcharges[index].surcharge.length) {
				var str = this.model.surcharges[index].surcharge || '';
				return this.model.surcharges[index].surcharge = str.endsWith('%') ? str.replace('%', '') : str;
			}
		}
	}, {
		key: 'askCreate',
		value: function askCreate() {
			var _this5 = this;

			this.Modal.confirm({
				header: this.$translate.instant('item.create_another_title'),
				message: this.$translate.instant('item.create_another_message'),
				callback: function callback(_ref3) {
					var modal = _ref3.modal,
					    $scope = _ref3.$scope;

					_this5.reset();
					modal.close();
				},
				negative: function negative(_ref4) {
					var modal = _ref4.modal,
					    $scope = _ref4.$scope;

					modal.close();
					window.history.go(-1);
				},
				type: 'primary',
				buttons: ['common.yes', 'common.no']
			});
		}
	}, {
		key: 'submit',
		value: function submit() {
			var _this6 = this;

			this.errorMessage = '';
			var newFuelSurcharge = (0, _assign2.default)({}, this.model);
			if (newFuelSurcharge.branchIds && newFuelSurcharge.branchIds.length) {
				newFuelSurcharge.branches = newFuelSurcharge.branchIds.map(function (branchObj) {
					return branchObj.id;
				}).join(",");
			}
			if (newFuelSurcharge.surcharges && newFuelSurcharge.surcharges.length) {
				newFuelSurcharge.surcharges.map(function (surchargeObj) {
					var str = surchargeObj.surcharge;
					return surchargeObj.surcharge = str.endsWith('%') ? str.replace('%', '') : str;
				});
			}
			newFuelSurcharge = _.pick(newFuelSurcharge, (0, _keys2.default)(this.defaultModel));
			this.loading = true;
			this.FuelSurchargeService.create(newFuelSurcharge).then(function (data) {
				_this6.askCreate();
				_this6.loading = false;
			}).catch(function (err) {
				_this6.loading = false;
				if (err.data && err.data.errors && err.data.errors.length) {
					err.data.errors.map(function (e) {
						_this6.errorMessage += e.message + '<br/>';
					});
				} else {
					_this6.errorMessage = err.data.message ? err.data.message : err;
				}
			});
		}

		// addMultipleBranchs() {
		// 	const branches = this.model.branchIds.map((b) => b.id)
		// 	return new Promise((resolve, reject) => {
		// 		this.UserService.createBranchGrouped({ userId: this.model.id, branches: branches })
		// 			.then(() => {
		// 				resolve();
		// 			})
		// 			.catch((err) => {
		// 				reject(err);
		// 			});
		// 	})
		// }

	}, {
		key: 'autoSelectSameForAll',
		value: function autoSelectSameForAll() {
			if (this.model.branchIds.length > 1) return this.model.sameForAll = true;else return this.model.sameForAll = false;
		}
	}, {
		key: 'removeSelection',
		value: function removeSelection() {
			this.model.sameForAll = false;
		}
	}, {
		key: 'resetMultiBranchSelection',
		value: function resetMultiBranchSelection() {
			var _this7 = this;

			if (this.model.branchIds && this.model.branchIds.length) {
				this.model.branchIds.forEach(function (selectedBranch) {
					_this7.branches.filter(function (branch) {
						if (branch.branchId == selectedBranch.branchId) {
							branch.ticked = false;
						}
					});
				});
			}
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.resetMultiBranchSelection();
			this.model = {
				id: '',
				name: '',
				status: true,
				appliedRange: '',
				branchIds: [],
				branches: [],
				description: '',
				surcharges: [],
				customers: []
			};
			this.addNewSurcharge();
		}
	}, {
		key: 'showLocations',
		value: function showLocations(customerId) {
			this.Modal.FuelSurchargeLocations(this.model, customerId, function (_ref5) {
				var modal = _ref5.modal;

				modal.close();
			}, function (_ref6) {
				var modal = _ref6.modal;

				if (modal) modal.close();
			});
		}
	}]);
	return FuelSurchagesCreateController;
}();

exports.default = FuelSurchagesCreateController;

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fuel_surchargesCreate = __webpack_require__(2146);

var _fuel_surchargesCreate2 = _interopRequireDefault(_fuel_surchargesCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fuelSurchargesCreateModule = angular.module('fuelsurchargescreate', []).component('fuelsurchargescreate', _fuel_surchargesCreate2.default).name;

exports.default = fuelSurchargesCreateModule;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customer_not_associated = __webpack_require__(2815);

var _customer_not_associated2 = _interopRequireDefault(_customer_not_associated);

var _customer_not_associated3 = __webpack_require__(2150);

var _customer_not_associated4 = _interopRequireDefault(_customer_not_associated3);

__webpack_require__(3091);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerNotAssociatedComponent = {
  restrict: 'E',
  template: _customer_not_associated2.default,
  controller: _customer_not_associated4.default
};

exports.default = CustomerNotAssociatedComponent;

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerNotAssociatedController = function () {
	/*@ngInject*/
	CustomerNotAssociatedController.$inject = ["Auth", "$state", "$stateParams", "User", "Modal", "$translate", "$location", "UserService", "BranchService", "$q", "$scope", "FuelSurchargeService"];
	function CustomerNotAssociatedController(Auth, $state, $stateParams, User, Modal, $translate, $location, UserService, BranchService, $q, $scope, FuelSurchargeService) {
		var _this = this;

		(0, _classCallCheck3.default)(this, CustomerNotAssociatedController);

		this.goToCustomer = function (customerId) {
			_this.$state.go('customer.edit', {
				id: customerId
			});
		};

		this.Auth = Auth;
		this.User = User;
		this.Modal = Modal;
		this.UserService = UserService;
		this.BranchService = BranchService;
		this.$q = $q;
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$location = $location;
		this.permissions = this.Auth.permission();
		this.loading = false;
		this.customers = [];
		this.FuelSurchargeService = FuelSurchargeService;
		this.sortColumn = 'name';
		this.reverseSort = 0;
		this.page = 1;
		this.total = 0;
		this.pageLimit = 10;
		this.maxPages = 10;
		this._objectKeys = _keys2.default;
		this.searchText = '';
		this.weekDays = {
			'serviceScheduleSun': 'Sun',
			'serviceScheduleMon': 'Mon',
			'serviceScheduleTue': 'Tue',
			'serviceScheduleWed': 'Wed',
			'serviceScheduleThu': 'Thu',
			'serviceScheduleFri': 'Fri',
			'serviceScheduleSat': 'Sat',
			'serviceScheduleHol': 'Hol'
		};
	}

	(0, _createClass3.default)(CustomerNotAssociatedController, [{
		key: '$onInit',
		value: function $onInit() {
			this.loadDataList();
		}
	}, {
		key: 'search',
		value: function search() {
			this.page = 1;
			this.loadDataList();
		}
	}, {
		key: 'refresh',
		value: function refresh() {
			this.loadDataList();
		}
	}, {
		key: 'loadDataList',
		value: function loadDataList() {
			var _this2 = this;

			this.loading = true;
			this.customers = [];
			this.FuelSurchargeService.fuelSurchagePendingCustomersFilters(this.searchText, (this.page - 1) * this.pageLimit, this.pageLimit, this.sortColumn, this.reverseSort).then(function (_ref) {
				var data = _ref.data,
				    count = _ref.count;

				_this2.total = count;
				_this2.customers = data;
				if (_this2.customers && _this2.customers.length) {
					_this2.customers.reduce(function (prev, item) {
						return prev.then(function () {
							item.serviceDays = [];
							(0, _keys2.default)(_this2.weekDays).map(function (key) {
								if (item[key]) {
									item.serviceDays.push(_this2.weekDays[key]);
								}
							});
							return item;
						});
					}, _promise2.default.resolve()).then(function () {
						_this2.loading = false;
					});
				} else {
					_this2.loading = false;
				}
			}).catch(function (err) {
				_this2.loading = false;
				_this2.error = err.message;
			});
		}
	}, {
		key: 'sortData',
		value: function sortData(column) {
			this.page = 1;
			this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
			this.sortColumn = column;
			this.loadDataList();
		}
	}]);
	return CustomerNotAssociatedController;
}();

exports.default = CustomerNotAssociatedController;

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customer_not_associated = __webpack_require__(2149);

var _customer_not_associated2 = _interopRequireDefault(_customer_not_associated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customerNotAssociatedModule = angular.module('customernotassociated', []).component('customernotassociated', _customer_not_associated2.default).name;

exports.default = customerNotAssociatedModule;

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fuel_surchargesEdit = __webpack_require__(2816);

var _fuel_surchargesEdit2 = _interopRequireDefault(_fuel_surchargesEdit);

var _fuel_surchargesEdit3 = __webpack_require__(2153);

var _fuel_surchargesEdit4 = _interopRequireDefault(_fuel_surchargesEdit3);

__webpack_require__(3092);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fuelSurchargesEditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _fuel_surchargesEdit2.default,
  controller: _fuel_surchargesEdit4.default
};

exports.default = fuelSurchargesEditComponent;

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FuelSurchagesEditController = function () {
	/*@ngInject*/
	FuelSurchagesEditController.$inject = ["Auth", "$state", "$stateParams", "User", "FuelSurchargeService", "Modal", "$translate", "UserService", "BranchService", "SetupService", "$q", "$scope"];
	function FuelSurchagesEditController(Auth, $state, $stateParams, User, FuelSurchargeService, Modal, $translate, UserService, BranchService, SetupService, $q, $scope) {
		var _this = this;

		(0, _classCallCheck3.default)(this, FuelSurchagesEditController);

		this.goToCustomer = function (customerId) {
			_this.$state.go('customer.edit', {
				id: customerId
			});
		};

		this.Auth = Auth;
		this.Modal = Modal;
		this.User = User;
		this.FuelSurchargeService = FuelSurchargeService;
		this.UserService = UserService;
		this.BranchService = BranchService;
		this.SetupService = SetupService;
		this.$q = $q;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$scope = $scope;
		this.$translate = $translate;
		this.permissions = this.Auth.permission();
		this.branchesList = [];
		this.branchId = this.User.getUser().branchId;
		this.errorMessage = '';
		this.appliedList = [{
			label: this.$translate.instant('fuel_surcharge.applied_monthly'),
			value: 'MONTHLY'
		}, {
			label: this.$translate.instant('fuel_surcharge.applied_bi_weekly'),
			value: 'BI_WEEKLY'
		}, {
			label: this.$translate.instant('fuel_surcharge.applied_weekly'),
			value: 'WEEKLY'
		}];
		this.removedFSCIds = [];
		this.localLang = {
			selectAll: this.$translate.instant('common.selectall'),
			selectNone: this.$translate.instant('common.selectnone'),
			reset: this.$translate.instant('shipmentBatch.reset'),
			search: this.$translate.instant('common.search'),
			nothingSelected: this.$translate.instant('common.noneselected') //default-label is deprecated and replaced with this.
		};

		this.defaultModel = {
			id: '',
			name: '',
			status: true,
			appliedRange: '',
			branchIds: [],
			branches: [],
			description: '',
			surcharges: [],
			customers: [],
			branchId: this.branchId
		};

		this.model = angular.copy(this.defaultModel);
	}

	(0, _createClass3.default)(FuelSurchagesEditController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.$q.all([this.BranchService.all(null, 0, 1000), this.FuelSurchargeService.get(this.$stateParams.id)]).then(function (data) {
				var selectedBranches = data[1] && data[1].branches ? data[1].branches.split(",") : [];
				// const branchesWithExistingFuelSurchargeRecord = data[1].results.map((setupRecord) => {
				// 	return setupRecord.branchId;
				// });
				_this2.branches = data[0].results;
				// 	.filter((branch) => branchesWithExistingFuelSurchargeRecord.includes(branch.id));

				if (data[1] && data[1].id) {

					_this2.rawId = data[1].id;
					_this2.model.id = data[1].id;
					_this2.model.name = data[1].name;
					_this2.model.status = data[1].status;
					_this2.model.appliedRange = data[1].appliedRange;
					_this2.model.branchIds = selectedBranches;
					_this2.model.description = data[1].description;
					_this2.model.surcharges = [];
					_this2.model.customers = [];
					if (data[1].surcharges && data[1].surcharges.length) {
						data[1].surcharges.forEach(function (element) {
							element.surcharge = element.surcharge ? element.surcharge + '%' : null;
							_this2.model.surcharges.push(element);
						});
					} else {
						_this2.addNewSurcharge();
					}
					if (data[1].fuelSurchargeCustomers && data[1].fuelSurchargeCustomers.length) {
						data[1].fuelSurchargeCustomers.forEach(function (customer) {
							_this2.model.customers.push(customer);
						});
					}
					selectedBranches.forEach(function (selectedBranch) {
						_this2.branches.filter(function (branch) {
							if (branch.id == selectedBranch) {
								branch.ticked = true;
							}
						});
					});
					_this2.defaultModel = JSON.parse((0, _stringify2.default)(_this2.model));
				}
			}).catch(function (err) {
				if (err.data && err.data.errors) {
					err.data.errors.map(function (e) {
						_this2.errorMessage += e.message + '<br/>';
					});
				} else {
					_this2.errorMessage = err.data.message ? err.data.message : err;
				}
			});
		}
	}, {
		key: 'addNewSurcharge',
		value: function addNewSurcharge() {
			this.model.surcharges.push({
				priceRange: {
					from: this.model.surcharges.length ? parseFloat(this.model.surcharges[this.model.surcharges.length - 1].priceRange.to) + 0.01 : 0.00,
					to: null
				},
				surcharge: ''
			});
		}
	}, {
		key: 'onSurchargeChange',
		value: function onSurchargeChange(e, i) {
			var _this3 = this;

			if (this.model.surcharges && this.model.surcharges.length) {
				this.model.surcharges.forEach(function (ele, index) {
					if (_this3.model.surcharges[index + 1] && (!_this3.model.surcharges[index + 1].priceRange.from || _this3.model.surcharges[index].priceRange.to > _this3.model.surcharges[index + 1].priceRange.from)) {
						_this3.model.surcharges[index + 1].priceRange.from = parseFloat(_this3.model.surcharges[index].priceRange.to) + 0.01;
					}
				});
			}
		}
	}, {
		key: 'removeSurcharge',
		value: function removeSurcharge(index) {
			this.model.surcharges.splice(index, 1);
		}
	}, {
		key: 'removeCustomer',
		value: function removeCustomer(index) {
			this.model.customers[index].isRemoved = true;
			// this.model.customers.splice(index, 1)
			// if (this.model.customers[index] && this.model.customers[index].fuelSurchargeCustomerId) {
			// 	this.removedFSCIds.push(this.model.customers[index].fuelSurchargeCustomerId)
			// }
		}
	}, {
		key: 'getCustomerCount',
		value: function getCustomerCount() {
			var activeCustomers = this.model.customers.filter(function (item) {
				return !item.isRemoved;
			});
			return activeCustomers.length;
		}
	}, {
		key: 'isSurchargeValid',
		value: function isSurchargeValid() {
			if (this.model.surcharges.length) {
				var invalidList = this.model.surcharges.filter(function (item) {
					return !item.priceRange.to || !item.priceRange.to || !item.surcharge;
				});
				return invalidList && invalidList.length ? false : true;
			} else {
				return false;
			}
		}
	}, {
		key: 'addNewCustomer',
		value: function addNewCustomer() {
			var _this4 = this;

			this.Modal.FuelSurchargeCustomer({}, function (_ref) {
				var customer = _ref.customer,
				    modal = _ref.modal;

				modal.close();
				_this4.model.customers.push(customer);
				_this4.model.customers = _.uniqBy(_this4.model.customers, 'id');
			}, function (_ref2) {
				var modal = _ref2.modal;

				_this4.isLoading = false;
				if (modal) modal.close();
			});
		}
	}, {
		key: 'ngPercentage',
		value: function ngPercentage(index) {
			if (this.model.surcharges[index].surcharge) {
				var str = this.model.surcharges[index].surcharge.toString();
				return this.model.surcharges[index].surcharge = str ? str.endsWith('%') ? str : str + '%' : null;
			}
		}
	}, {
		key: 'removePrecentageSign',
		value: function removePrecentageSign(index) {
			if (this.model.surcharges[index].surcharge && this.model.surcharges[index].surcharge.length) {
				var str = this.model.surcharges[index].surcharge || '';
				return this.model.surcharges[index].surcharge = str.endsWith('%') ? str.replace('%', '') : str;
			}
		}
	}, {
		key: 'submit',
		value: function submit() {
			var _this5 = this;

			var fuelSurcharge = (0, _assign2.default)({}, this.model);
			if (fuelSurcharge.branchIds && fuelSurcharge.branchIds.length) {
				fuelSurcharge.branches = fuelSurcharge.branchIds.map(function (branchObj) {
					return branchObj.id;
				}).join(",");
			}
			if (fuelSurcharge.surcharges && fuelSurcharge.surcharges.length) {
				fuelSurcharge.surcharges.map(function (surchargeObj) {
					var str = surchargeObj.surcharge;
					return surchargeObj.surcharge = str.endsWith('%') ? str.replace('%', '') : str;
				});
			}
			fuelSurcharge = _.pick(fuelSurcharge, (0, _keys2.default)(this.defaultModel));
			this.loading = true;
			// fuelSurcharge.removedFSCIds = this.removedFSCIds;
			this.FuelSurchargeService.update(this.rawId, fuelSurcharge).then(function (data) {
				_this5.loading = false;
				_this5.removedFSCIds = [];
				window.history.go(-1);
			}).catch(function (err) {
				_this5.loading = false;
				if (err.data && err.data.errors) {
					err.data.errors.map(function (e) {
						_this5.errorMessage += e.message + '<br/>';
					});
				} else {
					_this5.errorMessage = err.data.message ? err.data.message : err;
				}
			});
		}
	}, {
		key: 'autoSelectSameForAll',
		value: function autoSelectSameForAll() {
			if (this.model.branchIds.length > 1) return this.model.sameForAll = true;else return this.model.sameForAll = false;
		}
	}, {
		key: 'removeSelection',
		value: function removeSelection() {
			this.model.sameForAll = false;
		}
	}, {
		key: 'resetMultiBranchSelection',
		value: function resetMultiBranchSelection() {
			var _this6 = this;

			if (this.model.branchIds && this.model.branchIds.length) {
				this.branches.forEach(function (listBranch) {
					if (_this6.model.branchIds.indexOf(listBranch.id) >= 0) {
						listBranch.ticked = true;
					} else {
						listBranch.ticked = false;
					}
				});
			} else {
				this.branches.forEach(function (listBranch) {
					listBranch.ticked = false;
				});
			}
		}
	}, {
		key: 'reset',
		value: function reset() {
			var _this7 = this;

			this.model = JSON.parse((0, _stringify2.default)(this.defaultModel));
			this.model.surcharges = [];
			this.model.customers = [];
			this.defaultModel.surcharges.forEach(function (element) {
				_this7.model.surcharges.push(element);
			});
			if (this.defaultModel.customers && this.defaultModel.customers.length) {
				this.defaultModel.customers.forEach(function (customer) {
					_this7.model.customers.push(customer);
				});
			}
			this.resetMultiBranchSelection();
		}
	}, {
		key: 'showLocations',
		value: function showLocations(customerId) {
			this.Modal.FuelSurchargeLocations(this.model, customerId, function (_ref3) {
				var modal = _ref3.modal;

				modal.close();
			}, function (_ref4) {
				var modal = _ref4.modal;

				if (modal) modal.close();
			});
		}
	}]);
	return FuelSurchagesEditController;
}();

exports.default = FuelSurchagesEditController;

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fuel_surchargesEdit = __webpack_require__(2152);

var _fuel_surchargesEdit2 = _interopRequireDefault(_fuel_surchargesEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fuelSurchargesEditModule = angular.module('fuelsurchargesedit', []).component('fuelsurchargesedit', _fuel_surchargesEdit2.default).name;

exports.default = fuelSurchargesEditModule;

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fuel_surcharges = __webpack_require__(2817);

var _fuel_surcharges2 = _interopRequireDefault(_fuel_surcharges);

var _fuel_surcharges3 = __webpack_require__(2156);

var _fuel_surcharges4 = _interopRequireDefault(_fuel_surcharges3);

__webpack_require__(3093);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FuelSurchargesComponent = {
    restrict: 'E',
    template: _fuel_surcharges2.default,
    controller: _fuel_surcharges4.default
};

exports.default = FuelSurchargesComponent;

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTBillingBase2 = __webpack_require__(108);

var _TNTBillingBase3 = _interopRequireDefault(_TNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FuelSurchargesController = function (_TNTBillingBase) {
    FuelSurchargesController.$inject = ["Auth", "$state", "User", "$translate", "$location", "$rootScope"];
    (0, _inherits3.default)(FuelSurchargesController, _TNTBillingBase);

    /*@ngInject*/
    function FuelSurchargesController(Auth, $state, User, $translate, $location, $rootScope) {
        'ngInject';

        (0, _classCallCheck3.default)(this, FuelSurchargesController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FuelSurchargesController.__proto__ || (0, _getPrototypeOf2.default)(FuelSurchargesController)).call(this));

        _this.hasACL = {};
        _this.acl = {};
        _this.$rootScope = $rootScope;
        _this.id = 'fuel_surcharges';
        _this.$state = $state;
        _this.$location = $location;
        _this.$translate = $translate;
        _this.Auth = Auth;
        _this.User = User;

        // this.$rootScope.$broadcast('routeChange', '/app/fuel-surcharges');
        return _this;
    }

    (0, _createClass3.default)(FuelSurchargesController, [{
        key: '$onInit',
        value: function $onInit() {
            (0, _get3.default)(FuelSurchargesController.prototype.__proto__ || (0, _getPrototypeOf2.default)(FuelSurchargesController.prototype), '$onInit', this).call(this);
            for (var key in this.acl['tnt_billing_' + this.id]) {
                this.hasACL[this.acl['tnt_billing_' + this.id][key]] = true;
            }
            this.loadPermission();
        }
    }, {
        key: 'loadPermission',
        value: function loadPermission() {
            var _this2 = this;

            // this.acl = {};
            // this.hasACL = {};
            ['fuel_surcharges', 'price_point'].forEach(function (permissionKey) {
                _this2.acl[permissionKey] = _this2.User.getACL(permissionKey);

                _this2.hasACL[permissionKey] = {};
                if (_this2.acl[permissionKey] && _this2.acl[permissionKey].length > 0) {
                    _this2.acl[permissionKey].forEach(function (permission) {
                        _this2.hasACL[permissionKey][permission] = true;
                    });
                }
                var currentUrl = _this2.$location.url();
                if (currentUrl.endsWith('/fuel-surcharges')) {
                    _this2.$state.go('fuelSurcharges.all', {
                        page: 1
                    });
                }
            });
        }
    }, {
        key: 'goToAll',
        value: function goToAll() {

            this.$state.go(this.id + '.all', {
                page: 1
            });
        }
    }]);
    return FuelSurchargesController;
}(_TNTBillingBase3.default);

exports.default = FuelSurchargesController;

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fuel_surcharges = __webpack_require__(2155);

var _fuel_surcharges2 = _interopRequireDefault(_fuel_surcharges);

var _create = __webpack_require__(2148);

var _create2 = _interopRequireDefault(_create);

var _all = __webpack_require__(2145);

var _all2 = _interopRequireDefault(_all);

var _edit = __webpack_require__(2154);

var _edit2 = _interopRequireDefault(_edit);

var _price_point = __webpack_require__(2161);

var _price_point2 = _interopRequireDefault(_price_point);

var _customer_not_associated = __webpack_require__(2151);

var _customer_not_associated2 = _interopRequireDefault(_customer_not_associated);

var _location_not_associated = __webpack_require__(2158);

var _location_not_associated2 = _interopRequireDefault(_location_not_associated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FuelSurchargesComponentModule = angular.module('fuelSurcharges', [_all2.default, _create2.default, _edit2.default, _price_point2.default, _customer_not_associated2.default, _location_not_associated2.default]).component('fuelSurcharges', _fuel_surcharges2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/fuel-surcharges');

    $stateProvider
    // .state('fuelSurcharges', {
    //     url: '/fuel-surcharges',
    //     component: 'fuelSurcharges',
    //     data: {
    //         requireLogin: true,
    //         requireACL: 'fuel_surcharges.view'
    //     },
    //     parent: 'app'
    // })

    .state('fuel_surcharges.all', {
        url: '/all/:page',
        component: 'fuelsurchargesall',
        data: {
            requireLogin: true,
            requireACL: 'tnt_billing_fuel_surcharges.view'
        }
    }).state('fuel_surcharges.create', {
        url: '/create',
        component: 'fuelsurchargescreate',
        data: {
            requireLogin: true,
            requireACL: 'tnt_billing_fuel_surcharges.create'
        }
    }).state('fuel_surcharges.edit', {
        url: '/edit/:id',
        component: 'fuelsurchargesedit',
        data: {
            requireLogin: true,
            requireACL: 'tnt_billing_fuel_surcharges.edit'
        }
    }).state('fuel_surcharges.pricePoint', {
        url: '/price-point',
        component: 'pricepoint',
        data: {
            requireLogin: true,
            requireACL: 'tnt_billing_fuel_surcharges.view'
        }
    }).state('fuel_surcharges.customernotassociated', {
        url: '/customer-not-associate',
        component: 'customernotassociated'

    }).state('fuel_surcharges.locationnotassociated', {
        url: '/location-not-associate',
        component: 'locationnotassociated'

    });
}]).name;

exports.default = FuelSurchargesComponentModule;

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location_not_associated = __webpack_require__(2159);

var _location_not_associated2 = _interopRequireDefault(_location_not_associated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationNotAssociatedModule = angular.module('locationnotassociated', []).component('locationnotassociated', _location_not_associated2.default).name;

exports.default = locationNotAssociatedModule;

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location_not_associated = __webpack_require__(2818);

var _location_not_associated2 = _interopRequireDefault(_location_not_associated);

var _location_not_associated3 = __webpack_require__(2160);

var _location_not_associated4 = _interopRequireDefault(_location_not_associated3);

__webpack_require__(3094);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationNotAssociatedComponent = {
  restrict: 'E',
  template: _location_not_associated2.default,
  controller: _location_not_associated4.default
};

exports.default = LocationNotAssociatedComponent;

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationNotAssociatedController = function () {
	/*@ngInject*/
	LocationNotAssociatedController.$inject = ["Auth", "$state", "$stateParams", "User", "Modal", "$translate", "$location", "UserService", "BranchService", "$q", "$scope", "FuelSurchargeService", "Navigation"];
	function LocationNotAssociatedController(Auth, $state, $stateParams, User, Modal, $translate, $location, UserService, BranchService, $q, $scope, FuelSurchargeService, Navigation) {
		var _this = this;

		(0, _classCallCheck3.default)(this, LocationNotAssociatedController);
		this.icon = {
			'REGULAR': 'regular.png',
			'ATM': 'atm.png',
			'BANK': 'bank.png',
			'NO_SHIP_NO_GO': 'nsng.png',
			'INTERNAL': 'internal.png',
			'TRUCK': 'truck.png',
			'TANKER': 'tanker.png',
			'WINDOW': 'window.png',
			'ON_CALL': 'oncall.png',
			'CARRIER': 'carrier.png',
			'LOCKER': 'locker.png',
			'VAULT': 'vault.png',
			'DELIVERY': 'delivery.png'
		};

		this.loadImage = function (image) {
			var imgURL = this.icon[image];
			// return require('../../../assets/images/' + imgURL);
			return __webpack_require__(51)("./" + imgURL);
		};

		this.goToLocation = function (locationId) {
			_this.Navigation.goToLocationTab(locationId);
		};

		this.goToCustomer = function (customerId) {
			_this.$state.go('customer.edit', {
				id: customerId
			});
		};

		this.Auth = Auth;
		this.User = User;
		this.Modal = Modal;
		this.UserService = UserService;
		this.BranchService = BranchService;
		this.$q = $q;
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.permissions = this.Auth.permission();
		this.loading = false;
		this.locations = [];
		this.FuelSurchargeService = FuelSurchargeService;
		this.sortColumn = 'locationName';
		this.reverseSort = 0;
		this.page = 1;
		this.total = 0;
		this.pageLimit = 10;
		this.maxPages = 10;
		this._objectKeys = _keys2.default;
		this.searchText = '';
		this.Navigation = Navigation;
	}

	(0, _createClass3.default)(LocationNotAssociatedController, [{
		key: '$onInit',
		value: function $onInit() {
			this.loadLocations();
		}
	}, {
		key: 'search',
		value: function search() {
			this.page = 1;
			this.loadLocations();
		}
	}, {
		key: 'refresh',
		value: function refresh() {
			this.loadLocations();
		}
	}, {
		key: 'sortData',
		value: function sortData(column) {
			this.page = 1;
			this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
			this.sortColumn = column;
			this.loadLocations();
		}
	}, {
		key: 'loadLocations',
		value: function loadLocations() {
			var _this2 = this;

			this.loading = true;
			this.locations = [];
			this.FuelSurchargeService.fuelSurchagePendingLocationsFilters(this.searchText, (this.page - 1) * this.pageLimit, this.pageLimit, this.sortColumn, this.reverseSort).then(function (_ref) {
				var data = _ref.data,
				    count = _ref.count;

				_this2.total = count;
				_this2.locations = data;
				_this2.loading = false;
			}).catch(function (err) {
				_this2.loading = false;
				_this2.error = err.message;
			});
		}
	}]);
	return LocationNotAssociatedController;
}();

exports.default = LocationNotAssociatedController;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _price_point = __webpack_require__(2162);

var _price_point2 = _interopRequireDefault(_price_point);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricePointModule = angular.module('pricepoint', []).component('pricepoint', _price_point2.default).name;

exports.default = PricePointModule;

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _price_point = __webpack_require__(2819);

var _price_point2 = _interopRequireDefault(_price_point);

var _price_point3 = __webpack_require__(2163);

var _price_point4 = _interopRequireDefault(_price_point3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricePointComponent = {
  restrict: 'E',
  // bindings: {
  //   hasACL: '='
  // },
  template: _price_point2.default,
  controller: _price_point4.default
};

exports.default = PricePointComponent;

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricePointController = function () {
	/*@ngInject*/
	PricePointController.$inject = ["Auth", "$state", "User", "PricePointService", "Modal", "$translate", "UserService", "BranchService", "SetupService", "$q", "$scope"];
	function PricePointController(Auth, $state, User, PricePointService, Modal, $translate, UserService, BranchService, SetupService, $q, $scope) {
		(0, _classCallCheck3.default)(this, PricePointController);

		this.Auth = Auth;
		this.Modal = Modal;
		this.User = User;
		this.PricePointService = PricePointService;
		this.UserService = UserService;
		this.BranchService = BranchService;
		this.SetupService = SetupService;
		this.$q = $q;
		this.$scope = $scope;
		this.$translate = $translate;
		this.branchId = this.User.getUser().branchId;
		this.hasACL = {};
		this.pricePoints = [];
		this.total = 0;
		this.moment = moment;
		this.errorMessage = '';
		this.sortColumn = "date";
		this.reverseSort = true;

		this.rawId = null;
		this.page = 1;
		this.filter = {
			sortingKey: this.sortColumn,
			sortingDir: this.reverseSort,
			limit: 10,
			page: this.page
		};

		this.minVaultDate = {
			minDate: moment().startOf('day').format('YYYY-MM-DD hh:mm a')
		};

		this.periodList = [{
			label: this.$translate.instant('fuel_surcharge.applied_monthly'),
			value: 'MONTHLY'
		}];

		this.defaultModel = {
			branchId: this.branchId,
			date: '',
			pricePoint: '',
			period: 'MONTHLY',
			periodApplied: '',
			comment: ''
		};

		this.model = angular.copy(this.defaultModel);
	}

	(0, _createClass3.default)(PricePointController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			var fuelSurchargesACL = this.User.getACL("price_point");
			if (fuelSurchargesACL && fuelSurchargesACL.length) {
				fuelSurchargesACL.forEach(function (key) {
					_this.hasACL[key] = true;
				});
			}
			this.loadPricePointList();
		}
	}, {
		key: 'sortData',
		value: function sortData(column) {
			this.reverseSort = this.sortColumn == column ? !this.reverseSort : false;
			this.sortColumn = column;
			this.page = 1;
			this.loadPricePointList();
		}
	}, {
		key: 'loadPricePointList',
		value: function loadPricePointList() {
			var _this2 = this;

			this.errorMessage = '';
			this.loading = true;
			this.PricePointService.all((this.page - 1) * this.filter.limit, this.filter.limit, this.sortColumn, this.reverseSort).then(function (_ref) {
				var total = _ref.total,
				    results = _ref.results;

				_this2.total = total;
				_this2.pricePoints = results;
				_this2.loading = false;
			}).catch(function (err) {
				err.data.errors.map(function (e) {
					_this2.errorMessage += e.message + '<br/>';
				});
				_this2.loading = false;
			});
		}
	}, {
		key: 'onDateChange',
		value: function onDateChange() {
			if (this.model.date) {
				this.model.periodApplied = this.moment(this.model.date).startOf('month').format('YYYY-MM-DD');
				this.model.periodAppliedWord = this.moment(this.model.date).startOf('month').format('MMMM YYYY');
			}
		}
	}, {
		key: 'askCreate',
		value: function askCreate() {
			var _this3 = this;

			this.Modal.confirm({
				header: this.$translate.instant('item.create_another_title'),
				message: this.$translate.instant('item.create_another_message'),
				callback: function callback(_ref2) {
					var modal = _ref2.modal,
					    $scope = _ref2.$scope;

					_this3.reset();
					modal.close();
				},
				negative: function negative(_ref3) {
					var modal = _ref3.modal,
					    $scope = _ref3.$scope;

					_this3.reset();
					modal.close();
				},
				type: 'primary',
				buttons: ['common.yes', 'common.no']
			});
		}
	}, {
		key: 'submit',
		value: function submit() {
			var _this4 = this;

			this.loading = true;
			this.errorMessage = null;
			this.model.date = this.moment(this.model.date).startOf('day').format('YYYY-MM-DD');
			this.PricePointService.create(this.model).then(function (data) {
				_this4.loading = false;
				_this4.askCreate();
			}).catch(function (err) {
				_this4.loading = false;
				if (err.data && err.data.errors && err.data.errors.length) {
					err.data.errors.map(function (e) {
						_this4.errorMessage += e.message + '<br/>';
					});
				} else {
					_this4.errorMessage = err.data.message || err;
				}
			});
		}
	}, {
		key: 'update',
		value: function update() {
			var _this5 = this;

			this.loading = true;
			this.errorMessage = null;
			this.model.date = this.moment(this.model.date).startOf('day').format('YYYY-MM-DD');
			this.PricePointService.update(this.rawId, this.model).then(function (data) {
				_this5.loading = false;
				_this5.reset(true);
				_this5.loadPricePointList();
			}).catch(function (err) {
				_this5.loading = false;
				if (err.data && err.data.errors && err.data.errors.length) {
					err.data.errors.map(function (e) {
						_this5.errorMessage += e.message + '<br/>';
					});
				} else {
					_this5.errorMessage = err.data.message || err;
				}
			});
		}
	}, {
		key: 'edit',
		value: function edit(pricePointObj) {
			this.rawId = pricePointObj.id;
			this.defaultModel = pricePointObj;
			this.defaultModel.branchId = this.branchId;
			this.model = angular.copy(this.defaultModel);
		}
	}, {
		key: 'reset',
		value: function reset(forceClear) {
			if (forceClear) {
				this.rawId = null;
				this.defaultModel = {
					branchId: this.branchId,
					date: '',
					pricePoint: '',
					period: 'MONTHLY',
					periodApplied: '',
					comment: ''
				};
			}
			this.model = angular.copy(this.defaultModel);
			this.loadPricePointList();
		}
	}, {
		key: 'isPastDate',
		value: function isPastDate(date) {
			return this.moment().isSameOrAfter(moment(date));
		}
	}]);
	return PricePointController;
}();

exports.default = PricePointController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_distanceAll = __webpack_require__(2165);

var _location_distanceAll2 = _interopRequireDefault(_location_distanceAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationDistanceAllModule = angular.module('locationDistanceAll', []).component('locationDistanceAll', _location_distanceAll2.default).name;

exports.default = locationDistanceAllModule;

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_distanceAll = __webpack_require__(2820);

var _location_distanceAll2 = _interopRequireDefault(_location_distanceAll);

var _location_distanceAll3 = __webpack_require__(2166);

var _location_distanceAll4 = _interopRequireDefault(_location_distanceAll3);

__webpack_require__(3095);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationDistanceAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _location_distanceAll2.default,
    controller: _location_distanceAll4.default
};

exports.default = locationDistanceAllComponent;

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _location_distanceBase = __webpack_require__(274);

var _location_distanceBase2 = _interopRequireDefault(_location_distanceBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationDistanceAllController = function () {
    /*@ngInject*/
    LocationDistanceAllController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "LocationDistanceService"];
    function LocationDistanceAllController(Auth, User, $state, $translate, $stateParams, $location, Modal, LocationDistanceService) {
        (0, _classCallCheck3.default)(this, LocationDistanceAllController);

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.LocationDistanceService = LocationDistanceService;

        this.model = {
            locationDistanceObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            errorMessage: '',
            branchId: User.getUser().branchId,
            searchText: ''
        };
    }

    (0, _createClass3.default)(LocationDistanceAllController, [{
        key: "$onInit",
        value: function $onInit() {
            this.loadData();
        }
    }, {
        key: "searchObj",
        value: function searchObj() {
            var obj = {
                queryJSON: {
                    rules: [{
                        group: {
                            rules: [{
                                field: 'label',
                                condition: 'like',
                                data: '%' + this.model.searchText + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };
            return obj.queryJSON.rules.length ? obj : null;
        }
    }, {
        key: "loadLocationDistance",
        value: function loadLocationDistance() {
            var _this = this;

            this.model.locationDistanceObj.loading = true;

            this.LocationDistanceService.all(this.searchObj(), (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit).then(function (data) {
                _this.model.locationDistanceObj.results = data.results;
                _this.model.locationDistanceObj.totalRecords = data.total;
            }).catch(function (err) {
                _this.Modal.errorModal(err.data.message);
            }).finally(function () {
                _this.model.locationDistanceObj.loading = false;
            });
        }
    }, {
        key: "pageChange",
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.model.pagination.page);
            this.$stateParams.page = this.model.pagination.page;
            this.$location.path(newUrl);
            this.loadLocationDistance();
        }
    }, {
        key: "loadData",
        value: function loadData() {
            this.model.pagination.page = 1;
            this.loadLocationDistance();
        }
    }, {
        key: "search",
        value: function search() {
            this.pageChange();
        }
    }, {
        key: "edit",
        value: function edit(locationDistanceObj) {
            this.$state.go('location_distance.edit', {
                id: locationDistanceObj.id
            });
        }
    }]);
    return LocationDistanceAllController;
}();

exports.default = LocationDistanceAllController;

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_distanceCreate = __webpack_require__(2168);

var _location_distanceCreate2 = _interopRequireDefault(_location_distanceCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationDistanceCreateModule = angular.module('locationDistanceCreate', []).component('locationDistanceCreate', _location_distanceCreate2.default).name;

exports.default = locationDistanceCreateModule;

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_distanceCreate = __webpack_require__(2821);

var _location_distanceCreate2 = _interopRequireDefault(_location_distanceCreate);

var _location_distanceCreate3 = __webpack_require__(2169);

var _location_distanceCreate4 = _interopRequireDefault(_location_distanceCreate3);

__webpack_require__(3096);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationDistanceCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _location_distanceCreate2.default,
    controller: _location_distanceCreate4.default
};

exports.default = locationDistanceCreateComponent;

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _location_distanceBase = __webpack_require__(274);

var _location_distanceBase2 = _interopRequireDefault(_location_distanceBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationDistanceCreateController = function (_LocationDistanceBase) {
    LocationDistanceCreateController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "LocationDistanceService"];
    (0, _inherits3.default)(LocationDistanceCreateController, _LocationDistanceBase);

    /*@ngInject*/
    function LocationDistanceCreateController(Auth, User, $state, $translate, $stateParams, $location, Modal, LocationDistanceService) {
        (0, _classCallCheck3.default)(this, LocationDistanceCreateController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LocationDistanceCreateController.__proto__ || (0, _getPrototypeOf2.default)(LocationDistanceCreateController)).call(this, Auth, $state, User, LocationDistanceService, Modal, $translate, $stateParams));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.Modal = Modal;
        _this.LocationDistanceService = LocationDistanceService;

        _this.defaultModel = {
            locationDistanceObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            errorMessage: '',
            branchId: User.getUser().branchId,
            searchText: '',
            label: null,
            mileRange: null,
            minRange: null,
            maxRange: null
        };

        _this.model = angular.copy(_this.defaultModel);
        return _this;
    }

    (0, _createClass3.default)(LocationDistanceCreateController, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "search",
        value: function search() {
            this.pageChange();
        }
    }, {
        key: "edit",
        value: function edit(billableEvent) {
            this.$state.go('location_distance.edit', {
                id: billableEvent.id
            });
        }
    }, {
        key: "submit",
        value: function submit() {
            var _this2 = this;

            this.model.isCreate = true;
            delete this.model.errorMessage;

            this.Service.create({
                label: this.model.label,
                mileRange: this.model.mileRange,
                branchId: this.model.branchId,
                minRange: this.model.minRange,
                maxRange: this.model.maxRange
            }).then(function () {
                _this2.askCreate();
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this2.model.errorMessage = err.data.message;
                } else {
                    err.data.errors.map(function (e) {
                        _this2.model.errorMessage += e.message + '<br/>';
                    });
                }
            }).finally(function () {
                _this2.model.isCreate = false;
            });
        }
    }, {
        key: "reset",
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.validateRange();
            this.clearErrors();
        }
    }, {
        key: "validateRange",
        value: function validateRange() {
            var minRange = parseFloat(this.model.minRange);
            var maxRange = parseFloat(this.model.maxRange);

            if (minRange === maxRange) this.rangeError = this.$translate.instant('locationDistance.mileage_equal_distance_error');else if (maxRange < minRange) this.rangeError = this.$translate.instant('locationDistance.mileage_error');else this.rangeError = null;
        }
    }]);
    return LocationDistanceCreateController;
}(_location_distanceBase2.default);

exports.default = LocationDistanceCreateController;

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_distanceEdit = __webpack_require__(2171);

var _location_distanceEdit2 = _interopRequireDefault(_location_distanceEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationDistanceEditModule = angular.module('locationDistanceEdit', []).component('locationDistanceEdit', _location_distanceEdit2.default).name;

exports.default = locationDistanceEditModule;

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_distanceEdit = __webpack_require__(2822);

var _location_distanceEdit2 = _interopRequireDefault(_location_distanceEdit);

var _location_distanceEdit3 = __webpack_require__(2172);

var _location_distanceEdit4 = _interopRequireDefault(_location_distanceEdit3);

__webpack_require__(3097);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationDistanceEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _location_distanceEdit2.default,
    controller: _location_distanceEdit4.default
};

exports.default = locationDistanceEditComponent;

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _location_distanceBase = __webpack_require__(274);

var _location_distanceBase2 = _interopRequireDefault(_location_distanceBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationDistanceEditController = function (_LocationDistanceBase) {
    LocationDistanceEditController.$inject = ["Auth", "User", "$state", "$translate", "$stateParams", "$location", "Modal", "LocationDistanceService"];
    (0, _inherits3.default)(LocationDistanceEditController, _LocationDistanceBase);

    /*@ngInject*/
    function LocationDistanceEditController(Auth, User, $state, $translate, $stateParams, $location, Modal, LocationDistanceService) {
        (0, _classCallCheck3.default)(this, LocationDistanceEditController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LocationDistanceEditController.__proto__ || (0, _getPrototypeOf2.default)(LocationDistanceEditController)).call(this, Auth, $state, User, LocationDistanceService, Modal, $translate, $stateParams));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.$stateParams = $stateParams;
        _this.$location = $location;
        _this.Modal = Modal;
        _this.LocationDistanceService = LocationDistanceService;

        _this.defaultModel = {
            locationDistanceObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            errorMessage: '',
            branchId: User.getUser().branchId,
            searchText: '',
            lable: null,
            mileRange: null,
            minRange: null,
            maxRange: null
        };
        _this.model = angular.copy(_this.defaultModel);
        _this.directionList = _this.model.directionList;
        return _this;
    }

    (0, _createClass3.default)(LocationDistanceEditController, [{
        key: "$onInit",
        value: function $onInit() {
            var _this2 = this;

            this.Service.get(this.$stateParams.id).then(function (data) {
                _this2.defaultModel = data;
                _this2.model.id = data.id;
                _this2.model.label = data.label;
                _this2.model.mileRange = data.mileRange;
                _this2.model.minRange = data.minRange;
                _this2.model.maxRange = data.maxRange;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this2.model.errorMessage = err.data.message;
                } else {
                    err.data.errors.map(function (e) {
                        _this2.model.errorMessage += e.message + '<br/>';
                    });
                }
            });
        }
    }, {
        key: "reset",
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.model.directionList = this.directionList;
            this.validateRange();
        }
    }, {
        key: "update",
        value: function update() {
            var _this3 = this;

            this.model.isUpdating = true;
            delete this.model.errorMessage;

            this.Service.update(this.$stateParams.id, {
                label: this.model.label,
                mileRange: this.model.mileRange,
                branchId: this.model.branchId,
                minRange: this.model.minRange,
                maxRange: this.model.maxRange
            }).then(function () {
                window.history.go(-1);
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this3.model.errorMessage = err.data.message;
                } else {
                    err.data.errors.map(function (e) {
                        _this3.model.errorMessage += e.message + '<br/>';
                    });
                }
            }).finally(function () {
                _this3.model.isUpdating = false;
            });
        }
    }, {
        key: "search",
        value: function search() {
            this.pageChange();
        }
    }, {
        key: "edit",
        value: function edit(billableEvent) {
            this.$state.go('location_distance.edit', {
                id: billableEvent.id
            });
        }
    }, {
        key: "validateRange",
        value: function validateRange() {
            var minRange = parseFloat(this.model.minRange);
            var maxRange = parseFloat(this.model.maxRange);

            if (minRange === maxRange) this.rangeError = this.$translate.instant('locationDistance.mileage_equal_distance_error');else if (maxRange < minRange) this.rangeError = this.$translate.instant('locationDistance.mileage_error');else this.rangeError = null;
        }
    }]);
    return LocationDistanceEditController;
}(_location_distanceBase2.default);

exports.default = LocationDistanceEditController;

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_distance = __webpack_require__(2174);

var _location_distance2 = _interopRequireDefault(_location_distance);

var _all = __webpack_require__(2164);

var _all2 = _interopRequireDefault(_all);

var _create = __webpack_require__(2167);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2170);

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationDistanceModule = angular.module('locationDistance', [_all2.default, _create2.default, _edit2.default]).component('locationDistance', _location_distance2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    'ngInject';

    $stateProvider.state('location_distance.all', {
        url: '/all/:page',
        component: 'locationDistanceAll',
        data: {
            requireLogin: true,
            requireACL: 'tnt_billing_location_distance.view'
        }
    }).state('location_distance.create', {
        url: '/create',
        component: 'locationDistanceCreate',
        data: {
            requireLogin: true,
            requireACL: 'tnt_billing_location_distance.create'
        }
    }).state('location_distance.edit', {
        url: '/edit/:id',
        component: 'locationDistanceEdit',
        data: {
            requireLogin: true,
            requireACL: 'tnt_billing_location_distance.edit'
        }
    });
}]).name;

exports.default = locationDistanceModule;

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_distance = __webpack_require__(2823);

var _location_distance2 = _interopRequireDefault(_location_distance);

var _location_distance3 = __webpack_require__(2175);

var _location_distance4 = _interopRequireDefault(_location_distance3);

__webpack_require__(3098);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationDistanceComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _location_distance2.default,
    controller: _location_distance4.default
};

exports.default = locationDistanceComponent;

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTBillingBase2 = __webpack_require__(108);

var _TNTBillingBase3 = _interopRequireDefault(_TNTBillingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationDistanceController = function (_TNTBillingBase) {
  LocationDistanceController.$inject = ["$state"];
  (0, _inherits3.default)(LocationDistanceController, _TNTBillingBase);

  /*@ngInject*/
  function LocationDistanceController($state) {
    (0, _classCallCheck3.default)(this, LocationDistanceController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LocationDistanceController.__proto__ || (0, _getPrototypeOf2.default)(LocationDistanceController)).call(this));

    _this.$state = $state;
    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'location_distance';
    return _this;
  }

  (0, _createClass3.default)(LocationDistanceController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(LocationDistanceController.prototype.__proto__ || (0, _getPrototypeOf2.default)(LocationDistanceController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_billing_' + this.id]) {
        this.hasACL[this.acl['tnt_billing_' + this.id][key]] = true;
      }
    }
  }]);
  return LocationDistanceController;
}(_TNTBillingBase3.default); // import AppConstants from "../../../../../config/app.constants";


exports.default = LocationDistanceController;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tnt_billing = __webpack_require__(2177);

var _tnt_billing2 = _interopRequireDefault(_tnt_billing);

var _billable_events = __webpack_require__(2090);

var _billable_events2 = _interopRequireDefault(_billable_events);

var _billing_category = __webpack_require__(2102);

var _billing_category2 = _interopRequireDefault(_billing_category);

var _contract = __webpack_require__(2117);

var _contract2 = _interopRequireDefault(_contract);

var _customer = __webpack_require__(2142);

var _customer2 = _interopRequireDefault(_customer);

var _location_distance = __webpack_require__(2173);

var _location_distance2 = _interopRequireDefault(_location_distance);

var _fuel_surcharges = __webpack_require__(2157);

var _fuel_surcharges2 = _interopRequireDefault(_fuel_surcharges);

var _contract_type = __webpack_require__(2129);

var _contract_type2 = _interopRequireDefault(_contract_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tntBillingModule = angular.module('tntBilling', [_billable_events2.default, _billing_category2.default, _contract2.default, _customer2.default, _location_distance2.default, _fuel_surcharges2.default, _contract_type2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('billable_events', {
    url: '/billable-event',
    component: 'billableEvents',
    parent: 'tntBilling',
    data: {
      requireLogin: true,
      requireACL: 'tnt_billing_billable_events.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('billing_category', {
    url: '/billing-category',
    component: 'billingCategory',
    parent: 'tntBilling',
    data: {
      requireLogin: true
      // requireACL: 'billingCategory'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('contract', {
    url: '/contract',
    component: 'contract',
    parent: 'tntBilling',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('customer', {
    url: '/customer',
    component: 'customer',
    parent: 'tntBilling',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('location_distance', {
    url: '/location-distance',
    component: 'locationDistance',
    parent: 'tntBilling',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('fuel_surcharges', {
    url: '/fuel-surcharges',
    component: 'fuelSurcharges',
    parent: 'tntBilling',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('contract_type', {
    url: '/contract-type',
    component: 'contractType',
    parent: 'tntBilling',
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  });
}]).component('tntBilling', _tnt_billing2.default).name;

exports.default = tntBillingModule;

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tnt_billing = __webpack_require__(2824);

var _tnt_billing2 = _interopRequireDefault(_tnt_billing);

var _tnt_billing3 = __webpack_require__(2178);

var _tnt_billing4 = _interopRequireDefault(_tnt_billing3);

__webpack_require__(3099);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tntBillingComponent = {
  restrict: 'E',
  bindings: {},
  template: _tnt_billing2.default,
  controller: _tnt_billing4.default
};

exports.default = tntBillingComponent;

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TNTBillingController = function () {
  /*@ngInject*/
  TNTBillingController.$inject = ["Auth", "$state", "User", "UserService", "$translate", "$location", "Modal", "DataCounter", "$q", "HoldService", "HoldLocationService", "$rootScope"];
  function TNTBillingController(Auth, $state, User, UserService, $translate, $location, Modal, DataCounter, $q, HoldService, HoldLocationService, $rootScope) {
    (0, _classCallCheck3.default)(this, TNTBillingController);


    this.$state = $state;

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.$location = $location;
    this.HoldLocationService = HoldLocationService;
    this.HoldService = HoldService;
    this.Modal = Modal;
    this.DataCounter = DataCounter;
    this.holdServiceData = [];
    this.itemHoldServiceData = [];
    this.$rootScope = $rootScope;
    this.currentBranch = User.getUser().branchId;
    this.tabConfig = {
      'tnt_billing_billable_events': {
        title: 'billableEvents.menu.title',
        state: 'billable_events'
      },
      'tnt_billing_billing_category': {
        title: 'billingCategory.menu.title',
        state: 'billing_category'
      },
      'tnt_billing_contract': {
        title: 'contract.contract',
        state: 'contract'
      },
      'tnt_billing_contract_type': {
        title: 'contractType.menu.title',
        state: 'contract_type'
      },
      'tnt_billing_customer': {
        title: 'Customer',
        state: 'customer'
      },
      'tnt_billing_location_distance': {
        title: 'locationDistance.menu.title',
        state: 'location_distance'
      },
      'tnt_billing_fuel_surcharges': {
        title: 'common.side_menu.fuel_surcharges',
        state: 'fuel_surcharges'
      }
    };
    this.acl = User.getACL('tntBilling');
    // this.hasACL = {}
    this.tabs = [];
    // this.$rootScope.$broadcast('routeChange', null);
  }

  // loadPermission() {
  //   this.acl = {};
  //   this.hasACL = {};

  //   [
  //     'tnt_billing',
  //     'tnt_billing_billable_events',
  //     'tnt_billing_billing_category',
  //     'tnt_billing_contract',
  //     'tnt_billing_customer',
  //   ].forEach((permissionKey) => {
  //     this.acl[permissionKey] = this.User.getACL(permissionKey)

  //     this.hasACL[permissionKey] = {};
  //     if (this.acl[permissionKey] && this.acl[permissionKey].length > 0) {
  //       this.acl[permissionKey].forEach((permission) => {
  //         this.hasACL[permissionKey][permission] = true;
  //       });
  //     }
  //   });
  // }


  (0, _createClass3.default)(TNTBillingController, [{
    key: 'getStateDiff',
    value: function getStateDiff(array) {
      var diff = [];
      var index = 0;
      for (var i = 0; i < array.length; i++) {
        var key = array[i];
        if (!(key in this.acl)) {
          diff[index++] = array[i];
        }
      }
      return diff;
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      var toDeregister = this.getStateDiff((0, _keys2.default)(this.tabConfig));
      for (var i = 0; i < toDeregister.length; i++) {
        if (this.$state.get(toDeregister[i])) {
          this.$state.router.stateRegistry.deregister(toDeregister[i]);
        }
      }
      // for (let key in Object.keys(this.tabConfig)) {
      _lodash2.default.forEach((0, _keys2.default)(this.tabConfig), function (key, i) {
        if (_this.acl[key] && _this.acl[key].indexOf('view') >= 0) {
          var tabConfig = _this.tabConfig[key];
          if (tabConfig) {
            var obj = (0, _assign2.default)(tabConfig, { key: key });
            _this.tabs.push(obj);
          }
        }
      });
      if (this.$state.current.name == 'tntBilling' && this.tabs.length) {
        this.$state.go(this.tabs[0].state);
      }

      this.$rootScope.$broadcast('routeChange', null);
      // });
      // // by default select the first available tab if user has just entered this page
      // const currentUrl = this.$location.url();
      // if (currentUrl.endsWith('/tnt-billing') && this.tabs && this.tabs.length) {
      //   this.$state.go(this.tabs[0].state);
      //   this.$rootScope.$broadcast('routeChange', null);
      // }
    }
  }, {
    key: 'hasAcl',
    value: function hasAcl(key) {
      if (this.acl[key] && this.acl[key].indexOf('view') >= 0) {
        return true;
      } else {
        return false;
      }
    }
  }]);
  return TNTBillingController;
}();

exports.default = TNTBillingController;

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atm_load_profileAll = __webpack_require__(2825);

var _atm_load_profileAll2 = _interopRequireDefault(_atm_load_profileAll);

var _atm_load_profileAll3 = __webpack_require__(2180);

var _atm_load_profileAll4 = _interopRequireDefault(_atm_load_profileAll3);

__webpack_require__(3100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileAllComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _atm_load_profileAll2.default,
  controller: _atm_load_profileAll4.default
};

exports.default = ATMLoadProfileAllComponent;

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _atm_load_profileBase = __webpack_require__(275);

var _atm_load_profileBase2 = _interopRequireDefault(_atm_load_profileBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileAllController = function (_ATMLoadProfileBaseCo) {
    ATMLoadProfileAllController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "$stateParams", "$location"];
    (0, _inherits3.default)(ATMLoadProfileAllController, _ATMLoadProfileBaseCo);

    /*@ngInject*/
    function ATMLoadProfileAllController(Auth, $state, User, Modal, $translate, $stateParams, $location) {
        (0, _classCallCheck3.default)(this, ATMLoadProfileAllController);

        // super(Auth, $state, User, ATMLoadProfileService, Modal, $translate, $stateParams, $location)
        var _this = (0, _possibleConstructorReturn3.default)(this, (ATMLoadProfileAllController.__proto__ || (0, _getPrototypeOf2.default)(ATMLoadProfileAllController)).call(this));

        _this.hasAcl = {};
        _this.$stateParams = $stateParams;
        _this.User = User;
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(ATMLoadProfileAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var pageId = this.$stateParams.page;
            if (pageId > 0) {
                this.page = pageId;
            }
        }
    }, {
        key: 'edit',
        value: function edit(atm_load_profile) {
            this.$state.go('atm_load_profile.edit', {
                id: atm_load_profile.id
            });
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.loadData();
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'search',
        value: function search() {
            this.page = 1;
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'loadData',
        value: function loadData() {}
    }]);
    return ATMLoadProfileAllController;
}(_atm_load_profileBase2.default);

exports.default = ATMLoadProfileAllController;

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atm_load_profileAll = __webpack_require__(2179);

var _atm_load_profileAll2 = _interopRequireDefault(_atm_load_profileAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileAllModule = angular.module('atmLoadProfileAll', []).component('atmLoadProfileAll', _atm_load_profileAll2.default).name;

exports.default = ATMLoadProfileAllModule;

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atm_load_profile = __webpack_require__(2826);

var _atm_load_profile2 = _interopRequireDefault(_atm_load_profile);

var _atm_load_profile3 = __webpack_require__(2183);

var _atm_load_profile4 = _interopRequireDefault(_atm_load_profile3);

__webpack_require__(3101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _atm_load_profile2.default,
  controller: _atm_load_profile4.default
};

exports.default = ATMLoadProfileComponent;

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileController = function (_TNTControlBase) {
  ATMLoadProfileController.$inject = ["$state"];
  (0, _inherits3.default)(ATMLoadProfileController, _TNTControlBase);

  /*@ngInject*/
  function ATMLoadProfileController($state) {
    (0, _classCallCheck3.default)(this, ATMLoadProfileController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ATMLoadProfileController.__proto__ || (0, _getPrototypeOf2.default)(ATMLoadProfileController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'atm_load_profile';
    _this.$state = $state;

    return _this;
  }

  (0, _createClass3.default)(ATMLoadProfileController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(ATMLoadProfileController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ATMLoadProfileController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_control_' + this.id]) {
        this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
      }
    }
  }]);
  return ATMLoadProfileController;
}(_TNTControlBase3.default);

exports.default = ATMLoadProfileController;

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atm_load_profileCreate = __webpack_require__(2827);

var _atm_load_profileCreate2 = _interopRequireDefault(_atm_load_profileCreate);

var _atm_load_profileCreate3 = __webpack_require__(2185);

var _atm_load_profileCreate4 = _interopRequireDefault(_atm_load_profileCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileCreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _atm_load_profileCreate2.default,
  controller: _atm_load_profileCreate4.default
};

exports.default = ATMLoadProfileCreateComponent;

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _atm_load_profileBase = __webpack_require__(275);

var _atm_load_profileBase2 = _interopRequireDefault(_atm_load_profileBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileCreateController = function (_ATMLoadProfileBaseCo) {
    ATMLoadProfileCreateController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "$stateParams", "$q"];
    (0, _inherits3.default)(ATMLoadProfileCreateController, _ATMLoadProfileBaseCo);

    /*@ngInject*/
    function ATMLoadProfileCreateController(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        (0, _classCallCheck3.default)(this, ATMLoadProfileCreateController);

        // super(Auth, $state, User, ATMLoadProfileService, Modal, $translate, $stateParams)
        var _this = (0, _possibleConstructorReturn3.default)(this, (ATMLoadProfileCreateController.__proto__ || (0, _getPrototypeOf2.default)(ATMLoadProfileCreateController)).call(this));

        _this.$q = $q;
        _this.User = User;
        _this.hasACL = {};

        _this.defaultModel = {
            id: '',
            name: '',
            faceValue: '',
            currencyId: null,
            shiptypeId: null,
            icon: '',
            sortOrder: 1
        };
        _this.loading = false;
        _this.model = angular.copy(_this.defaultModel);
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(ATMLoadProfileCreateController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.clearErrors();
        }
    }, {
        key: 'submit',
        value: function submit() {}
    }]);
    return ATMLoadProfileCreateController;
}(_atm_load_profileBase2.default);

exports.default = ATMLoadProfileCreateController;

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atm_load_profileCreate = __webpack_require__(2184);

var _atm_load_profileCreate2 = _interopRequireDefault(_atm_load_profileCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileCreateModule = angular.module('atmLoadProfileCreate', []).component('atmLoadProfileCreate', _atm_load_profileCreate2.default).name;

exports.default = ATMLoadProfileCreateModule;

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atm_load_profileEdit = __webpack_require__(2828);

var _atm_load_profileEdit2 = _interopRequireDefault(_atm_load_profileEdit);

var _atm_load_profileEdit3 = __webpack_require__(2188);

var _atm_load_profileEdit4 = _interopRequireDefault(_atm_load_profileEdit3);

__webpack_require__(3102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileEditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _atm_load_profileEdit2.default,
  controller: _atm_load_profileEdit4.default
};

exports.default = ATMLoadProfileEditComponent;

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _atm_load_profileBase = __webpack_require__(275);

var _atm_load_profileBase2 = _interopRequireDefault(_atm_load_profileBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileEditController = function (_ATMLoadProfileBaseCo) {
    ATMLoadProfileEditController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "$stateParams", "$q"];
    (0, _inherits3.default)(ATMLoadProfileEditController, _ATMLoadProfileBaseCo);

    /*@ngInject*/
    function ATMLoadProfileEditController(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        (0, _classCallCheck3.default)(this, ATMLoadProfileEditController);

        // super(Auth, $state, User, ATMLoadProfileService, Modal, $translate, $stateParams)
        var _this = (0, _possibleConstructorReturn3.default)(this, (ATMLoadProfileEditController.__proto__ || (0, _getPrototypeOf2.default)(ATMLoadProfileEditController)).call(this));

        _this.$stateParams = $stateParams;
        _this.$q = $q;
        _this.User = User;
        _this.hasACL = {};
        _this.rawId = '';

        _this.defaultModel = {};
        _this.loading = false;
        _this.model = angular.copy(_this.defaultModel);
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(ATMLoadProfileEditController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'reset',
        value: function reset() {}
    }, {
        key: 'submit',
        value: function submit() {}
    }]);
    return ATMLoadProfileEditController;
}(_atm_load_profileBase2.default);

exports.default = ATMLoadProfileEditController;

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atm_load_profileEdit = __webpack_require__(2187);

var _atm_load_profileEdit2 = _interopRequireDefault(_atm_load_profileEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileEditModule = angular.module('atmLoadProfileEdit', []).component('atmLoadProfileEdit', _atm_load_profileEdit2.default).name;

exports.default = ATMLoadProfileEditModule;

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atm_load_profile = __webpack_require__(2182);

var _atm_load_profile2 = _interopRequireDefault(_atm_load_profile);

var _create = __webpack_require__(2186);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2189);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2181);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATMLoadProfileModule = angular.module('atmLoadProfile', [_create2.default, _edit2.default, _all2.default]).component('atmLoadProfile', _atm_load_profile2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('atm_load_profile.edit', {
    url: '/edit/:id',
    component: 'atmLoadProfileEdit',
    data: {
      requireACL: 'tnt_control_atm_load_profile.edit'
    }
  }).state('atm_load_profile.create', {
    url: '/create',
    component: 'atmLoadProfileCreate',
    data: {
      requireACL: 'tnt_control_atm_load_profile.create'
    }
  }).state('atm_load_profile.all', {
    url: '/all/:page',
    component: 'atmLoadProfileAll',
    data: {
      requireACL: 'tnt_control_atm_load_profile.view'
    }
  });
}]).name;

exports.default = ATMLoadProfileModule;

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _configuration = __webpack_require__(2829);

var _configuration2 = _interopRequireDefault(_configuration);

var _configuration3 = __webpack_require__(2192);

var _configuration4 = _interopRequireDefault(_configuration3);

__webpack_require__(3103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configurationComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _configuration2.default,
    controller: _configuration4.default
};

exports.default = configurationComponent;

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfigurationController = function (_TNTControlBase) {
  ConfigurationController.$inject = ["$state"];
  (0, _inherits3.default)(ConfigurationController, _TNTControlBase);

  /*@ngInject*/
  function ConfigurationController($state) {
    (0, _classCallCheck3.default)(this, ConfigurationController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ConfigurationController.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationController)).call(this));

    _this.$state = $state;
    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'configuration';
    return _this;
  }

  (0, _createClass3.default)(ConfigurationController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(ConfigurationController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_control_' + this.id]) {
        this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
      }
    }
  }]);
  return ConfigurationController;
}(_TNTControlBase3.default); // import AppConstants from "../../../../../config/app.constants";

exports.default = ConfigurationController;

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _configuration = __webpack_require__(2191);

var _configuration2 = _interopRequireDefault(_configuration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configurationModule = angular.module('configuration', []).component('configuration', _configuration2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    'ngInject';
    // $stateProvider
    // .state('billable_events.all', {
    //     url: '/all/:page',
    //     component: 'configurationAll',
    //     data: {
    //         requireLogin: true,
    //         requireACL: 'tnt_billing_billable_events.view'
    //     },
    // })
}]).name;

exports.default = configurationModule;

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cost_centerAll = __webpack_require__(2830);

var _cost_centerAll2 = _interopRequireDefault(_cost_centerAll);

var _cost_centerAll3 = __webpack_require__(2195);

var _cost_centerAll4 = _interopRequireDefault(_cost_centerAll3);

__webpack_require__(3104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template: _cost_centerAll2.default,
    controller: _cost_centerAll4.default
};

exports.default = CostCenterAllComponent;

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _cost_centerBase = __webpack_require__(276);

var _cost_centerBase2 = _interopRequireDefault(_cost_centerBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterAllController = function (_CostCenterBaseContro) {
    CostCenterAllController.$inject = ["Auth", "$state", "User", "CostCenterService", "Modal", "$location", "$stateParams"];
    (0, _inherits3.default)(CostCenterAllController, _CostCenterBaseContro);

    /*@ngInject*/
    function CostCenterAllController(Auth, $state, User, CostCenterService, Modal, $location, $stateParams) {
        (0, _classCallCheck3.default)(this, CostCenterAllController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CostCenterAllController.__proto__ || (0, _getPrototypeOf2.default)(CostCenterAllController)).call(this, Auth, $state, User, CostCenterService, Modal, $location, $stateParams));

        _this.id = 'cost_center.all';
        _this.loading = true;
        _this.costcenters = [];
        _this.page = 1;
        _this.total = 0;
        _this.pageLimit = 10;
        _this.maxPages = 10;
        _this.hasACL = {};
        _this.searchText = '';
        _this.$location = $location;
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(CostCenterAllController, [{
        key: 'loadData',
        value: function loadData() {
            var _this2 = this;

            var searchObj = this.generateSearchObj();

            this.loading = true;
            this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
                _this2.total = data.total;
                _this2.costcenters = data.results;
                _this2.loading = false;
            }).catch(function (err) {
                _this2.loading = false;
                _this2.error = err.message;
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var pageId = this.$stateParams.page;
            if (pageId > 0) {
                this.page = pageId;
            }
            this.loadData();
        }
    }, {
        key: 'edit',
        value: function edit(costCenter) {
            this.$state.go('cost_center.edit', {
                id: costCenter.id
            });
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.loadData();
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'generateSearchObj',
        value: function generateSearchObj() {
            var searchObj = {
                queryJSON: {
                    rules: [{
                        group: {
                            rules: [{
                                field: 'name',
                                condition: 'like',
                                data: '%' + this.searchText + '%'
                            }, {
                                field: 'description',
                                condition: 'like',
                                data: '%' + this.searchText + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };
            return searchObj;
        }
    }, {
        key: 'search',
        value: function search() {
            this.page = 1;
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }]);
    return CostCenterAllController;
}(_cost_centerBase2.default);

exports.default = CostCenterAllController;

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cost_centerAll = __webpack_require__(2194);

var _cost_centerAll2 = _interopRequireDefault(_cost_centerAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterAllModule = angular.module('costCenterAll', []).component('costCenterAll', _cost_centerAll2.default).name;

exports.default = CostCenterAllModule;

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cost_center = __webpack_require__(2831);

var _cost_center2 = _interopRequireDefault(_cost_center);

var _cost_center3 = __webpack_require__(2198);

var _cost_center4 = _interopRequireDefault(_cost_center3);

__webpack_require__(3105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _cost_center2.default,
    controller: _cost_center4.default
};

exports.default = CostCenterComponent;

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterController = function (_TNTControlBase) {
    CostCenterController.$inject = ["$state"];
    (0, _inherits3.default)(CostCenterController, _TNTControlBase);

    /*@ngInject*/
    function CostCenterController($state) {
        (0, _classCallCheck3.default)(this, CostCenterController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CostCenterController.__proto__ || (0, _getPrototypeOf2.default)(CostCenterController)).call(this));

        _this.acl = {};
        _this.hasACL = {};
        _this.id = 'cost_center';
        _this.$state = $state;

        return _this;
    }

    (0, _createClass3.default)(CostCenterController, [{
        key: '$onInit',
        value: function $onInit() {
            (0, _get3.default)(CostCenterController.prototype.__proto__ || (0, _getPrototypeOf2.default)(CostCenterController.prototype), '$onInit', this).call(this);
            for (var key in this.acl['tnt_control_' + this.id]) {
                this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
            }
        }
    }]);
    return CostCenterController;
}(_TNTControlBase3.default);

exports.default = CostCenterController;

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cost_centerCreate = __webpack_require__(2832);

var _cost_centerCreate2 = _interopRequireDefault(_cost_centerCreate);

var _cost_centerCreate3 = __webpack_require__(2200);

var _cost_centerCreate4 = _interopRequireDefault(_cost_centerCreate3);

__webpack_require__(3106);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterCreateComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template: _cost_centerCreate2.default,
    controller: _cost_centerCreate4.default
};

exports.default = CostCenterCreateComponent;

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _cost_centerBase = __webpack_require__(276);

var _cost_centerBase2 = _interopRequireDefault(_cost_centerBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterCreateController = function (_CostCenterBaseContro) {
    CostCenterCreateController.$inject = ["Auth", "$state", "User", "CostCenterService", "Modal", "$translate", "$stateParams", "CommonLayoutService"];
    (0, _inherits3.default)(CostCenterCreateController, _CostCenterBaseContro);

    /*@ngInject*/
    function CostCenterCreateController(Auth, $state, User, CostCenterService, Modal, $translate, $stateParams, CommonLayoutService) {
        (0, _classCallCheck3.default)(this, CostCenterCreateController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CostCenterCreateController.__proto__ || (0, _getPrototypeOf2.default)(CostCenterCreateController)).call(this, Auth, $state, User, CostCenterService, Modal, $translate, $stateParams));

        _this.Auth = Auth;
        _this.$state = $state;
        _this.User = User;
        _this.CommonLayoutService = CommonLayoutService;
        _this.defaultModel = {
            status: true,
            name: null,
            description: null,
            customerFlag: false
        };
        _this.branchId = _this.User.getUser().branchId;
        _this.model = angular.copy(_this.defaultModel);
        _this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: _this.$translate.instant('common.yes'),
                off: _this.$translate.instant('common.no')
            },
            onColor: 'success',
            offColor: 'danger'
        };
        return _this;
    }

    (0, _createClass3.default)(CostCenterCreateController, [{
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.clearErrors();
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this2 = this;

            this.loading = true;
            this.Service.create({
                name: this.model.name,
                description: this.model.description,
                status: this.model.status,
                customerFlag: this.model.customerFlag
            }, this.branchId).then(function () {
                _this2.loading = false;
                _this2.askCreate();
            }).catch(function (err) {
                _this2.loading = false;
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this2.errorMessage += e.message + '<br/>';
                    });
                } else {
                    _this2.errorMessage = err.data.message;
                }
            });
        }
    }]);
    return CostCenterCreateController;
}(_cost_centerBase2.default);

exports.default = CostCenterCreateController;

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cost_centerCreate = __webpack_require__(2199);

var _cost_centerCreate2 = _interopRequireDefault(_cost_centerCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterCreateModule = angular.module('costCenterCreate', []).component('costCenterCreate', _cost_centerCreate2.default).name;

exports.default = CostCenterCreateModule;

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cost_centerEdit = __webpack_require__(2833);

var _cost_centerEdit2 = _interopRequireDefault(_cost_centerEdit);

var _cost_centerEdit3 = __webpack_require__(2203);

var _cost_centerEdit4 = _interopRequireDefault(_cost_centerEdit3);

__webpack_require__(3107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var costCenterEditComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template: _cost_centerEdit2.default,
    controller: _cost_centerEdit4.default
};

exports.default = costCenterEditComponent;

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _cost_centerBase = __webpack_require__(276);

var _cost_centerBase2 = _interopRequireDefault(_cost_centerBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterEditController = function (_CostCenterBaseContro) {
    CostCenterEditController.$inject = ["Auth", "$state", "User", "CostCenterService", "Modal", "$translate", "$stateParams", "CommonLayoutService"];
    (0, _inherits3.default)(CostCenterEditController, _CostCenterBaseContro);

    /*@ngInject*/
    function CostCenterEditController(Auth, $state, User, CostCenterService, Modal, $translate, $stateParams, CommonLayoutService) {
        (0, _classCallCheck3.default)(this, CostCenterEditController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CostCenterEditController.__proto__ || (0, _getPrototypeOf2.default)(CostCenterEditController)).call(this, Auth, $state, User, CostCenterService, Modal, $translate, $stateParams));

        _this.pageName = 'costCenter';
        _this.Auth = Auth;
        _this.$state = $state;
        _this.User = User;
        _this.CommonLayoutService = CommonLayoutService;
        _this.message = 'CostCenter Create';
        _this.rawId = '';
        _this.defaultModel = {
            status: true,
            name: null,
            description: null,
            customerFlag: false
        };
        _this.model = angular.copy(_this.defaultModel);
        _this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: _this.$translate.instant('common.yes'),
                off: _this.$translate.instant('common.no')
            },
            onColor: 'success',
            offColor: 'danger'
        };
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(CostCenterEditController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.loading = true;
            this.Service.get(this.$stateParams.id).then(function (data) {
                _this2.defaultModel = data;
                _this2.rawId = data.id;
                _this2.model.id = data.id;
                _this2.model.name = data.name;
                _this2.model.status = data.status;
                _this2.model.description = data.description;
                _this2.model.customerFlag = data.customerFlag;
            }).catch(function (err) {
                err.data.errors.map(function (e) {
                    _this2.errorMessage += e.message + '<br/>';
                });
            }).finally(function () {
                _this2.loading = false;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
        }
    }, {
        key: 'submit',
        value: function submit(evt) {
            var _this3 = this;

            this.loading = true;
            this.Service.update(this.rawId, {
                id: this.rawId,
                name: this.model.name,
                status: this.model.status,
                description: this.model.description,
                customerFlag: this.model.customerFlag
            }, this.branchId).then(function (data) {
                _this3.loading = false;
                window.history.go(-1);
            }).catch(function (err) {
                _this3.loading = false;
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this3.errorMessage += e.message + '<br/>';
                    });
                } else {
                    _this3.errorMessage = err.data.message;
                }
            });
        }
    }, {
        key: 'askToChange',
        value: function askToChange() {
            var _this4 = this;

            if (!this.model.status) {
                this.model.status = !this.model.status;
                this.Modal.confirm({
                    header: this.$translate.instant(this.pageName + '.suspend_' + this.pageName),
                    message: this.$translate.instant(this.pageName + '.suspend_' + this.pageName + '_message'),
                    callback: function callback(_ref) {
                        var modal = _ref.modal,
                            $scope = _ref.$scope;

                        _this4.model.status = !_this4.model.status;
                        modal.close();
                    },
                    negative: function negative(_ref2) {
                        var modal = _ref2.modal,
                            $scope = _ref2.$scope;

                        modal.close();
                    },
                    type: 'danger',
                    buttons: [this.$translate.instant('common.yes'), this.$translate.instant('common.yes')]
                });
            }
        }
    }]);
    return CostCenterEditController;
}(_cost_centerBase2.default);

exports.default = CostCenterEditController;

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cost_centerEdit = __webpack_require__(2202);

var _cost_centerEdit2 = _interopRequireDefault(_cost_centerEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var costCenterEditModule = angular.module('costCenterEdit', []).component('costCenterEdit', _cost_centerEdit2.default).name;

exports.default = costCenterEditModule;

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cost_center = __webpack_require__(2197);

var _cost_center2 = _interopRequireDefault(_cost_center);

var _create = __webpack_require__(2201);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2204);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2196);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterModule = angular.module('costCenter', [_create2.default, _edit2.default, _all2.default]).component('costCenter', _cost_center2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('cost_center.edit', {
        url: '/edit/:id',
        component: 'costCenterEdit',
        data: {
            requireACL: 'tnt_control_cost_center.edit'
        }
    }).state('cost_center.create', {
        url: '/create',
        component: 'costCenterCreate',
        data: {
            requireACL: 'tnt_control_cost_center.create'
        }
    }).state('cost_center.all', {
        url: '/all/:page',
        component: 'costCenterAll',
        data: {
            requireACL: 'tnt_control_cost_center.view'
        }
    });
}]).name;

exports.default = CostCenterModule;

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _currencyAll = __webpack_require__(2834);

var _currencyAll2 = _interopRequireDefault(_currencyAll);

var _currencyAll3 = __webpack_require__(2207);

var _currencyAll4 = _interopRequireDefault(_currencyAll3);

__webpack_require__(3108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencyAllComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _currencyAll2.default,
  controller: _currencyAll4.default
};

exports.default = currencyAllComponent;

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrencyAllController = function () {
    /*@ngInject*/
    CurrencyAllController.$inject = ["Auth", "$state", "User", "CurrencyService", "Modal", "$translate", "$stateParams", "$location"];
    function CurrencyAllController(Auth, $state, User, CurrencyService, Modal, $translate, $stateParams, $location) {
        (0, _classCallCheck3.default)(this, CurrencyAllController);

        this.Auth = Auth;
        this.$state = $state;
        this.User = User;
        this.Service = CurrencyService;
        this.Modal = Modal;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;

        this.loading = true;
        this.currencies = [];
        this.hasACL = {};
        this.page = 1;
        this.total = 0;
        this.pageLimit = 10;
        this.maxPages = 10;
        this.searchText = '';
        this.branchId = this.User.getUser().branchId;
    }

    (0, _createClass3.default)(CurrencyAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var pageId = this.$stateParams.page;
            if (pageId > 0) {
                this.page = pageId;
            }
            this.loadData();
        }
    }, {
        key: 'edit',
        value: function edit(currency) {
            this.$state.go('currency.edit', {
                id: currency.id
            });
        }
    }, {
        key: 'delete',
        value: function _delete(currency) {
            var _this = this;

            if (this.allowOnlyOnce) return;
            this.allowOnlyOnce = true;
            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_delete_title'),
                message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + currency.id + '</strong>?'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    $scope.loading = true;
                    _this.Service.remove(currency.id).then(function (data) {
                        _this.allowOnlyOnce = false;
                        modal.close();
                        _this.refresh();
                    }).catch(function (err) {
                        _this.allowOnlyOnce = false;
                        modal.close();
                        _this.Modal.errorModal(err.data.message);
                    });
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    _this.allowOnlyOnce = false;
                    modal.close();
                },
                type: 'danger'
            });
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.loadData();
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'generateSearchObj',
        value: function generateSearchObj() {
            return {
                queryText: '%' + this.searchText + '%',
                isQuery: false
            };
        }
    }, {
        key: 'search',
        value: function search() {
            this.page = 1;
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }

        // Load All Currencies

    }, {
        key: 'loadData',
        value: function loadData() {
            var _this2 = this;

            var searchObj = this.generateSearchObj();

            this.loading = true;
            this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
                _this2.total = data.total;
                _this2.currencies = data.results;
                _this2.loading = false;
            }).catch(function (err) {
                _this2.loading = false;
                _this2.error = err.message;
            });
        }
    }]);
    return CurrencyAllController;
}();

exports.default = CurrencyAllController;

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _currencyAll = __webpack_require__(2206);

var _currencyAll2 = _interopRequireDefault(_currencyAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('currency.all', []).component('currencyall', _currencyAll2.default).name;

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _currencyCreate = __webpack_require__(2835);

var _currencyCreate2 = _interopRequireDefault(_currencyCreate);

var _currencyCreate3 = __webpack_require__(2210);

var _currencyCreate4 = _interopRequireDefault(_currencyCreate3);

__webpack_require__(3109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencycreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _currencyCreate2.default,
  controller: _currencyCreate4.default
};

exports.default = currencycreateComponent;

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrencyCreateController = function () {
  /*@ngInject*/
  CurrencyCreateController.$inject = ["Auth", "$state", "User", "CurrencyService", "Modal", "$translate", "$stateParams"];
  function CurrencyCreateController(Auth, $state, User, CurrencyService, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, CurrencyCreateController);

    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.Service = CurrencyService;
    this.Modal = Modal;
    this.$translate = $translate;
    this.$stateParams = $stateParams;
    this.hasACL = {};

    this.defaultModel = {
      id: "",
      name: "",
      symbol: "",
      decimals: 2,
      sortOrder: 1
    };
    this.loading = false;
    this.model = angular.copy(this.defaultModel);
    this.branchId = this.User.getUser().branchId;
  }

  (0, _createClass3.default)(CurrencyCreateController, [{
    key: "$onInit",
    value: function $onInit() {
      // Initialize any required data
    }
  }, {
    key: "reset",
    value: function reset() {
      this.model = angular.copy(this.defaultModel);
      this.clearErrors();
    }
  }, {
    key: "clearErrors",
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = "";
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this = this;

      this.loading = true;
      this.clearErrors();

      this.Service.create({
        id: this.model.id,
        name: this.model.name,
        symbol: this.model.symbol,
        decimals: this.model.decimals,
        sortOrder: this.model.sortOrder
      }).then(function (data) {
        _this.loading = false;
        _this.askCreate();
      }).catch(function (err) {
        _this.loading = false;
        if (err && err.data && err.data.errors) {
          err.data.errors.forEach(function (e) {
            _this.errorMessage += e.message + "<br/>";
          });
        } else if (err && err.data && err.data.error) {
          // Handle single error message from API
          _this.errorMessage = err.data.error;
        } else if (err && err.data && err.data.message) {
          _this.errorMessage = _this.$translate.instant(err.data.message);
        } else {
          _this.errorMessage = _this.$translate.instant('common.error_occurred');
        }
      });
    }
  }, {
    key: "askCreate",
    value: function askCreate() {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant("currency.create_another_title"),
        message: this.$translate.instant("currency.create_another_message"),
        callback: function callback(_ref) {
          var modal = _ref.modal;

          modal.close();
          _this2.reset();
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          modal.close();
          _this2.$state.go('currency.all', { page: 1 });
        },
        type: "success"
      });
    }
  }]);
  return CurrencyCreateController;
}();

exports.default = CurrencyCreateController;

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _currencyCreate = __webpack_require__(2209);

var _currencyCreate2 = _interopRequireDefault(_currencyCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('currency.create', []).component('currencycreate', _currencyCreate2.default).name;

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _currency = __webpack_require__(2836);

var _currency2 = _interopRequireDefault(_currency);

var _currency3 = __webpack_require__(2213);

var _currency4 = _interopRequireDefault(_currency3);

__webpack_require__(3110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencyComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _currency2.default,
  controller: _currency4.default
};

exports.default = currencyComponent;

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrencyController = function (_TNTControlBase) {
  CurrencyController.$inject = ["$state"];
  (0, _inherits3.default)(CurrencyController, _TNTControlBase);

  /*@ngInject*/
  function CurrencyController($state) {
    (0, _classCallCheck3.default)(this, CurrencyController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CurrencyController.__proto__ || (0, _getPrototypeOf2.default)(CurrencyController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'currency';
    _this.$state = $state;
    return _this;
  }

  (0, _createClass3.default)(CurrencyController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(CurrencyController.prototype.__proto__ || (0, _getPrototypeOf2.default)(CurrencyController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_control_' + this.id]) {
        this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
      }
    }
  }]);
  return CurrencyController;
}(_TNTControlBase3.default);

exports.default = CurrencyController;

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _currencyEdit = __webpack_require__(2837);

var _currencyEdit2 = _interopRequireDefault(_currencyEdit);

var _currencyEdit3 = __webpack_require__(2215);

var _currencyEdit4 = _interopRequireDefault(_currencyEdit3);

__webpack_require__(3111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencyeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _currencyEdit2.default,
  controller: _currencyEdit4.default
};

exports.default = currencyeditComponent;

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrencyEditController = function () {
  /*@ngInject*/
  CurrencyEditController.$inject = ["Auth", "$state", "User", "CurrencyService", "Modal", "$translate", "$stateParams"];
  function CurrencyEditController(Auth, $state, User, CurrencyService, Modal, $translate, $stateParams) {
    (0, _classCallCheck3.default)(this, CurrencyEditController);

    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.Service = CurrencyService;
    this.Modal = Modal;
    this.$translate = $translate;
    this.$stateParams = $stateParams;
    this.hasACL = {};

    this.model = {
      id: "",
      name: "",
      symbol: "",
      decimals: 2,
      sortOrder: 1,
      loading: true
    };
    this.loading = false;
    this.originalId = "";
    this.branchId = this.User.getUser().branchId;
  }

  (0, _createClass3.default)(CurrencyEditController, [{
    key: "$onInit",
    value: function $onInit() {
      this.loadCurrencyDetails();
    }
  }, {
    key: "loadCurrencyDetails",
    value: function loadCurrencyDetails() {
      var _this = this;

      var currencyId = this.$stateParams.id;
      this.originalId = currencyId;

      this.Service.details(currencyId).then(function (data) {
        _this.model = (0, _extends3.default)({}, data, {
          loading: false
        });
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        _this.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.loadCurrencyDetails();
      this.clearErrors();
    }
  }, {
    key: "clearErrors",
    value: function clearErrors() {
      this.errors = {};
      this.errorMessage = "";
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;

      this.loading = true;
      this.clearErrors();

      this.Service.update(this.originalId, {
        id: this.model.id,
        name: this.model.name,
        symbol: this.model.symbol,
        decimals: this.model.decimals,
        sortOrder: this.model.sortOrder
      }).then(function (data) {
        _this2.loading = false;
        _this2.$state.go("currency.all", { page: 1 });
      }).catch(function (err) {
        _this2.loading = false;
        if (err && err.data && err.data.errors) {
          err.data.errors.forEach(function (e) {
            _this2.errorMessage += e.message + "<br/>";
          });
        } else if (err && err.data && err.data.error) {
          // Handle single error message from API
          _this2.errorMessage = err.data.error;
        } else if (err && err.data && err.data.message) {
          _this2.errorMessage = _this2.$translate.instant(err.data.message);
        } else {
          _this2.errorMessage = _this2.$translate.instant("common.error_occurred");
        }
      });
    }
  }]);
  return CurrencyEditController;
}();

exports.default = CurrencyEditController;

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _currencyEdit = __webpack_require__(2214);

var _currencyEdit2 = _interopRequireDefault(_currencyEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('currency.edit', []).component('currencyedit', _currencyEdit2.default).name;

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _currency = __webpack_require__(2212);

var _currency2 = _interopRequireDefault(_currency);

var _create = __webpack_require__(2211);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2216);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2208);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencyModule = angular.module('currency', [_create2.default, _edit2.default, _all2.default]).component('currency', _currency2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('currency.edit', {
    url: '/edit/:id',
    component: 'currencyedit',
    data: {
      requireACL: 'tnt_control_currency.edit'
    }
  }).state('currency.create', {
    url: '/create',
    component: 'currencycreate',
    data: {
      requireACL: 'tnt_control_currency.create'
    }
  }).state('currency.all', {
    url: '/all/:page',
    component: 'currencyall',
    data: {
      requireACL: 'tnt_control_currency.view'
    }
  });

  // Default route for currency module
  $urlRouterProvider.when('/currency', '/currency/all/1');
}]).name;

exports.default = currencyModule;

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _denominationAll = __webpack_require__(2838);

var _denominationAll2 = _interopRequireDefault(_denominationAll);

var _denominationAll3 = __webpack_require__(2219);

var _denominationAll4 = _interopRequireDefault(_denominationAll3);

__webpack_require__(3112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var denominationallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _denominationAll2.default,
  controller: _denominationAll4.default
};

exports.default = denominationallComponent;

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _denominationBase = __webpack_require__(277);

var _denominationBase2 = _interopRequireDefault(_denominationBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DenominationAllController = function (_DenominationBaseCont) {
    DenominationAllController.$inject = ["Auth", "$state", "User", "DenominationService", "Modal", "$translate", "$stateParams", "$location"];
    (0, _inherits3.default)(DenominationAllController, _DenominationBaseCont);

    /*@ngInject*/
    function DenominationAllController(Auth, $state, User, DenominationService, Modal, $translate, $stateParams, $location) {
        (0, _classCallCheck3.default)(this, DenominationAllController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DenominationAllController.__proto__ || (0, _getPrototypeOf2.default)(DenominationAllController)).call(this, Auth, $state, User, DenominationService, Modal, $translate, $stateParams, $location));

        _this.loading = true;
        _this.denominations = [];
        _this.hasAcl = {};
        _this.page = 1;
        _this.total = 0;
        _this.pageLimit = 10;
        _this.maxPages = 10;
        _this.searchText = '';
        _this.$location = $location;
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(DenominationAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var pageId = this.$stateParams.page;
            if (pageId > 0) {
                this.page = pageId;
            }
            this.loadData();
        }
    }, {
        key: 'edit',
        value: function edit(denomination) {
            this.$state.go('denomination.edit', {
                id: denomination.id
            });
        }
    }, {
        key: 'delete',
        value: function _delete(denomination) {
            var _this2 = this;

            if (this.allowOnlyOnce) return;
            this.allowOnlyOnce = true;
            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_delete_title'),
                message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + denomination.id + '</strong>?'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    $scope.loading = true;
                    _this2.Service.remove(denomination.id, _this2.branchId).then(function (data) {
                        _this2.allowOnlyOnce = false;
                        modal.close();
                        _this2.refresh();
                    });
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    _this2.allowOnlyOnce = false;
                    modal.close();
                },
                type: 'danger'
            });
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.loadData();
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'generateSearchObj',
        value: function generateSearchObj() {
            return {
                queryText: '%' + this.searchText + '%',
                isQuery: false
            };
        }
    }, {
        key: 'search',
        value: function search() {
            this.page = 1;
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }

        // Load All Denominations

    }, {
        key: 'loadData',
        value: function loadData() {
            var _this3 = this;

            var searchObj = this.generateSearchObj();

            this.loading = true;
            this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
                _this3.total = data.total;
                _this3.denominations = data.results;
                _this3.loading = false;
            }).catch(function (err) {
                _this3.loading = false;
                _this3.error = err.message;
            });
        }
    }]);
    return DenominationAllController;
}(_denominationBase2.default);

exports.default = DenominationAllController;

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _denominationAll = __webpack_require__(2218);

var _denominationAll2 = _interopRequireDefault(_denominationAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var denominationallModule = angular.module('denominationall', []).component('denominationall', _denominationAll2.default).name;

exports.default = denominationallModule;

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _denominationCreate = __webpack_require__(2839);

var _denominationCreate2 = _interopRequireDefault(_denominationCreate);

var _denominationCreate3 = __webpack_require__(2222);

var _denominationCreate4 = _interopRequireDefault(_denominationCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var denominationcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _denominationCreate2.default,
  controller: _denominationCreate4.default
};

exports.default = denominationcreateComponent;

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _denominationBase = __webpack_require__(277);

var _denominationBase2 = _interopRequireDefault(_denominationBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DenominationCreateController = function (_DenominationBaseCont) {
    DenominationCreateController.$inject = ["Auth", "$state", "User", "DenominationService", "Modal", "$translate", "$stateParams", "$q", "ShiptypeService", "CurrencyService", "SetupService", "$scope"];
    (0, _inherits3.default)(DenominationCreateController, _DenominationBaseCont);

    /*@ngInject*/
    function DenominationCreateController(Auth, $state, User, DenominationService, Modal, $translate, $stateParams, $q, ShiptypeService, CurrencyService, SetupService, $scope) {
        (0, _classCallCheck3.default)(this, DenominationCreateController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DenominationCreateController.__proto__ || (0, _getPrototypeOf2.default)(DenominationCreateController)).call(this, Auth, $state, User, DenominationService, Modal, $translate, $stateParams));

        _this.CurrencyService = CurrencyService;
        _this.ShiptypeService = ShiptypeService;
        _this.SetupService = SetupService;
        _this.$q = $q;
        _this.$scope = $scope;
        _this.hasACL = {};
        _this.shiptypeMismatch = false;

        _this.defaultModel = {
            id: '',
            name: '',
            faceValue: '',
            currencyId: null,
            shiptypeId: null,
            icon: '',
            coinFlag: false,
            sortOrder: 1,
            strapCount: 100,
            bundleCount: 10,
            loadDetectThreshold: null,
            coinPackaging: null,
            multiDenomPackable: false,
            unfit: false,
            individualDenominationId: null,
            selectedFiles: []
        };
        _this.loading = false;
        _this.model = angular.copy(_this.defaultModel);
        _this.branchId = _this.User.getUser().branchId;

        _this.$scope.$watchGroup([function () {
            return _this.model.id;
        }, function () {
            return _this.model.shiptypeId;
        }, function () {
            return _this.model.coinFlag;
        }], function () {
            return _this.validateShiptypeMatch();
        });
        return _this;
    }

    (0, _createClass3.default)(DenominationCreateController, [{
        key: 'validateShiptypeMatch',
        value: function validateShiptypeMatch() {
            var MISMATCH_MESSAGE = 'Denomination ID and Shiptype ID must be set to the same value';
            this.shiptypeMismatch = !!(this.model.coinFlag && this.model.id && this.model.shiptypeId && this.model.shiptypeId.Value && this.model.shiptypeId.Value !== this.model.id);

            if (this.shiptypeMismatch) {
                this.errorMessage = MISMATCH_MESSAGE;
            } else if (this.errorMessage === MISMATCH_MESSAGE) {
                this.errorMessage = '';
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.$q.all([this.loadshiptype('', 0), this.loadDenomination('', 0), this.CurrencyService.all(null, 0, 100), this.SetupService.get(this.branchId)]).then(function (data) {
                // this.shiptypeData = data[0].results;
                var availableCurrencyIds = data[3].availableCurrencyIds ? data[3].availableCurrencyIds : [];
                _this2.currencyData = data[2].results.filter(function (currency) {
                    return availableCurrencyIds.includes(currency.id);
                });
            }).catch(function (err) {
                console.log(err);
            });
        }

        // load all shiptype

    }, {
        key: 'loadshiptype',
        value: function loadshiptype(searchKey, offset) {
            var _this3 = this;

            searchKey = searchKey || '';

            var shiptypeSearchObj = {
                queryJSON: {
                    rules: [{
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'description',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };

            this.ShiptypeService.all(shiptypeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this3.totalRecords = data.total;
                    _this3.shiptypeList = _this3.mappingShiptypeData(data.results);
                } else {
                    var shiptype = _this3.mappingShiptypeData(data.results);
                    _this3.shiptypeList = _this3.shiptypeList.concat(shiptype);
                }
            });
        }
    }, {
        key: 'mappingShiptypeData',
        value: function mappingShiptypeData(shiptype) {
            return shiptype.map(function (shiptypes) {
                return {
                    Key: shiptypes.id + " | " + shiptypes.description,
                    Value: shiptypes.id
                };
            });
        }
    }, {
        key: 'loadDenomination',
        value: function loadDenomination(searchKey, offset) {
            var _this4 = this;

            searchKey = searchKey || '';

            var denominationSearchObj = {
                queryJSON: {
                    rules: [{
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };

            this.Service.all(denominationSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this4.totalDenominationRecords = data.total;
                    _this4.denominationList = _this4.mappingDenominationData(data.results);
                } else {
                    var denomination = _this4.mappingDenominationData(data.results);
                    _this4.denominationList = _this4.denominationList.concat(denomination);
                }
            });
        }
    }, {
        key: 'mappingDenominationData',
        value: function mappingDenominationData(denominations) {
            return denominations.map(function (denom) {
                return {
                    Key: denom.id + " | " + denom.name,
                    Value: denom.id
                };
            });
        }
    }, {
        key: 'isMultiDenomPackableAllowed',
        value: function isMultiDenomPackableAllowed() {
            if (!this.model.coinFlag) {
                return true;
            }
            if (this.model.coinPackaging && ['INDIVIDUAL', 'ROLLED'].includes(this.model.coinPackaging)) {
                return true;
            }
            return false;
        }
    }, {
        key: 'onCoinPackagingChange',
        value: function onCoinPackagingChange() {
            if (!this.isMultiDenomPackableAllowed()) {
                this.model.multiDenomPackable = false;
            }
        }
    }, {
        key: 'onCoinFlagChange',
        value: function onCoinFlagChange() {
            if (!this.model.coinFlag) {
                return;
            }
            if (!this.isMultiDenomPackableAllowed()) {
                this.model.multiDenomPackable = false;
            }
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.clearErrors();
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this5 = this;

            this.loading = true;
            var denominationIcon = [];
            if (this.model.selectedFiles && this.model.selectedFiles.length) {
                this.model.selectedFiles.forEach(function (d) {
                    denominationIcon.push({ base64String: d.base64Data, fileName: _this5.rawId + '.png' });
                });
            }
            this.Service.create({
                id: this.model.id,
                name: this.model.name,
                faceValue: this.model.faceValue,
                icon: this.model.icon ? this.model.icon : null,
                sortOrder: this.model.sortOrder,
                currencyId: this.model.currencyId,
                shiptypeId: this.model.shiptypeId.Value,
                strapCount: this.model.coinFlag || this.model.strapCount === '' || this.model.strapCount === undefined ? 0 : Number(this.model.strapCount),
                bundleCount: this.model.coinFlag || this.model.bundleCount === '' || this.model.bundleCount === undefined ? 0 : Number(this.model.bundleCount),
                loadDetectThreshold: this.model.loadDetectThreshold || 0,
                coinFlag: this.model.coinFlag,
                coinPackaging: this.model.coinFlag ? this.model.coinPackaging : null,
                multiDenomPackable: this.isMultiDenomPackableAllowed() ? this.model.multiDenomPackable || false : false,
                unfit: this.model.unfit || false,
                individualDenominationId: this.model.individualDenominationId && this.model.individualDenominationId.Value && this.model.coinFlag && this.model.coinPackaging !== 'INDIVIDUAL' ? this.model.individualDenominationId.Value : null,
                denominationIcon: denominationIcon
            }, this.branchId).then(function (data) {
                _this5.loading = false;
                _this5.askCreate();
            }).catch(function (err) {
                _this5.loading = false;
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this5.errorMessage += e.message + '<br/>';
                    });
                } else {
                    _this5.errorMessage = _this5.$translate.instant(err.data.message);
                }
            });
        }
    }, {
        key: 'calculateCount',
        value: function calculateCount(type) {
            if (type === 'strapCount') {
                this.model.strapCount = this.model.bundleCount * 10;
            } else {
                this.model.bundleCount = this.model.strapCount / 10;
            }
        }
    }]);
    return DenominationCreateController;
}(_denominationBase2.default);

exports.default = DenominationCreateController;

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _denominationCreate = __webpack_require__(2221);

var _denominationCreate2 = _interopRequireDefault(_denominationCreate);

__webpack_require__(3113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var denominationCreateModule = angular.module('denominationcreate', []).component('denominationcreate', _denominationCreate2.default).name;

exports.default = denominationCreateModule;

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _denomination = __webpack_require__(2840);

var _denomination2 = _interopRequireDefault(_denomination);

var _denomination3 = __webpack_require__(2225);

var _denomination4 = _interopRequireDefault(_denomination3);

__webpack_require__(3114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var denominationComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _denomination2.default,
  controller: _denomination4.default
};

exports.default = denominationComponent;

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DenominationController = function (_TNTControlBase) {
  DenominationController.$inject = ["$state"];
  (0, _inherits3.default)(DenominationController, _TNTControlBase);

  /*@ngInject*/
  function DenominationController($state) {
    (0, _classCallCheck3.default)(this, DenominationController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DenominationController.__proto__ || (0, _getPrototypeOf2.default)(DenominationController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'denomination';
    _this.$state = $state;

    return _this;
  }

  (0, _createClass3.default)(DenominationController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(DenominationController.prototype.__proto__ || (0, _getPrototypeOf2.default)(DenominationController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_control_' + this.id]) {
        this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
      }
    }
  }]);
  return DenominationController;
}(_TNTControlBase3.default);

exports.default = DenominationController;

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _denominationEdit = __webpack_require__(2841);

var _denominationEdit2 = _interopRequireDefault(_denominationEdit);

var _denominationEdit3 = __webpack_require__(2227);

var _denominationEdit4 = _interopRequireDefault(_denominationEdit3);

__webpack_require__(537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var denominationeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _denominationEdit2.default,
  controller: _denominationEdit4.default
};

exports.default = denominationeditComponent;

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _denominationBase = __webpack_require__(277);

var _denominationBase2 = _interopRequireDefault(_denominationBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DenominationEditController = function (_DenominationBaseCont) {
    DenominationEditController.$inject = ["Auth", "$state", "User", "DenominationService", "Modal", "$translate", "$stateParams", "$q", "ShiptypeService", "CurrencyService", "SetupService", "$scope"];
    (0, _inherits3.default)(DenominationEditController, _DenominationBaseCont);

    /*@ngInject*/
    function DenominationEditController(Auth, $state, User, DenominationService, Modal, $translate, $stateParams, $q, ShiptypeService, CurrencyService, SetupService, $scope) {
        (0, _classCallCheck3.default)(this, DenominationEditController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DenominationEditController.__proto__ || (0, _getPrototypeOf2.default)(DenominationEditController)).call(this, Auth, $state, User, DenominationService, Modal, $translate, $stateParams));

        _this.CurrencyService = CurrencyService;
        _this.ShiptypeService = ShiptypeService;
        _this.SetupService = SetupService;
        _this.$stateParams = $stateParams;
        _this.$q = $q;
        _this.$scope = $scope;
        _this.hasACL = {};
        _this.rawId = '';
        _this.shiptypeMismatch = false;

        _this.defaultModel = {
            id: '',
            name: '',
            faceValue: '',
            currencyId: null,
            shiptypeId: null,
            icon: '',
            coinFlag: false,
            sortOrder: '',
            strapCount: '',
            bundleCount: '',
            loadDetectThreshold: 0,
            coinPackaging: null,
            multiDenomPackable: false,
            unfit: false,
            individualDenominationId: null,
            selectedFiles: []
        };
        _this.loading = false;
        _this.model = angular.copy(_this.defaultModel);
        _this.branchId = _this.User.getUser().branchId;

        _this.$scope.$watchGroup([function () {
            return _this.model.shiptypeId;
        }, function () {
            return _this.model.coinFlag;
        }], function () {
            return _this.validateShiptypeMatch();
        });
        return _this;
    }

    (0, _createClass3.default)(DenominationEditController, [{
        key: 'validateShiptypeMatch',
        value: function validateShiptypeMatch() {
            var MISMATCH_MESSAGE = 'Denomination ID and Shiptype ID must be set to the same value';
            this.shiptypeMismatch = !!(this.model.coinFlag && this.model.shiptypeId && this.model.shiptypeId.Value && this.model.shiptypeId.Value !== this.rawId);

            if (this.shiptypeMismatch) {
                this.errorMessage = MISMATCH_MESSAGE;
            } else if (this.errorMessage === MISMATCH_MESSAGE) {
                this.errorMessage = '';
            }
        }
    }, {
        key: 'isMultiDenomPackableAllowed',
        value: function isMultiDenomPackableAllowed() {
            if (!this.model.coinFlag) {
                return true;
            }
            if (this.model.coinPackaging && ['INDIVIDUAL', 'ROLLED'].includes(this.model.coinPackaging)) {
                return true;
            }
            return false;
        }
    }, {
        key: 'onCoinPackagingChange',
        value: function onCoinPackagingChange() {
            if (!this.isMultiDenomPackableAllowed()) {
                this.model.multiDenomPackable = false;
            }
        }
    }, {
        key: 'onCoinFlagChange',
        value: function onCoinFlagChange() {
            if (!this.model.coinFlag) {
                return;
            }
            if (!this.isMultiDenomPackableAllowed()) {
                this.model.multiDenomPackable = false;
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.model.loading = true;
            this.$q.all([this.CurrencyService.all(null, 0, 100), this.Service.get(this.$stateParams.id), this.SetupService.get(this.branchId)]).then(function (data) {
                var availableCurrencyIds = data[2].availableCurrencyIds ? data[2].availableCurrencyIds : [];
                _this2.currencyData = data[0].results.filter(function (currency) {
                    return availableCurrencyIds.includes(currency.id);
                });
                _this2.denominationData = data[1].results;
                _this2.defaultModel = data[1];
                _this2.rawId = data[1].id;
                _this2.model.id = data[1].id;
                _this2.model.name = data[1].name;
                _this2.model.faceValue = Math.abs(data[1].faceValue).toFixed(2);
                _this2.originalFaceValue = Math.abs(data[1].faceValue).toFixed(2);
                _this2.ledgerUsage = data[1].ledgerUsage || null;
                _this2.model.currencyId = data[1].currencyId;
                _this2.model.shiptypeId = data[1].shiptypeId;
                _this2.model.icon = data[1].icon;
                _this2.model.coinFlag = data[1].coinFlag;
                _this2.model.coinPackaging = data[1].coinPackaging;
                _this2.model.multiDenomPackable = data[1].multiDenomPackable;
                _this2.model.unfit = data[1].unfit;
                _this2.model.sortOrder = data[1].sortOrder;
                _this2.model.strapCount = data[1].strapCount;
                _this2.model.bundleCount = data[1].bundleCount;
                _this2.model.loadDetectThreshold = data[1].loadDetectThreshold;
                _this2.model.isIconExists = data[1].isIconExists;
                // this.model.imageData = data[1].imageData;
                if (!_this2.isMultiDenomPackableAllowed()) {
                    _this2.model.multiDenomPackable = false;
                }

                if (data[1].shiptype) {
                    data[1].shiptype.Key = data[1].shiptype.id + " | " + data[1].shiptype.description;
                    data[1].shiptype.Value = data[1].shiptype.id;
                }

                _this2.model.shiptypeId = data[1].shiptype;
                _this2.getAllShiptype('', 0);
                if (data[1].individualDenomination) {
                    data[1].individualDenomination.Key = data[1].individualDenomination.id + " | " + data[1].individualDenomination.name;
                    data[1].individualDenomination.Value = data[1].individualDenomination.id;
                }
                _this2.model.individualDenominationId = data[1].individualDenomination;
                _this2.getAllDenominations('', 0);
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this2.model.loading = false;
            });
        }

        // load all shiptype

    }, {
        key: 'loadshiptype',
        value: function loadshiptype(searchKey, offset) {

            searchKey = searchKey || '';

            var shiptypeSearchObj = {
                queryJSON: {
                    rules: [{
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'description',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };

            return shiptypeSearchObj.queryJSON.rules.length ? shiptypeSearchObj : null;
        }

        // get all shiptype

    }, {
        key: 'getAllShiptype',
        value: function getAllShiptype(searchKey, offset) {
            var _this3 = this;

            var loadShiptypeDatas = this.loadshiptype(searchKey);
            if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
                offset = offset - 1;
            }
            this.ShiptypeService.all(loadShiptypeDatas, offset, _app2.default.defaultPageLimit).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this3.totalRecords = data.total;
                    _this3.shiptypeList = _this3.mappingShiptypeData(data.results, searchKey);
                    if (!searchKey && _this3.model.shiptypeId) {
                        _this3.shiptypeList.unshift(_this3.model.shiptypeId);
                    }
                } else {
                    var shiptype = _this3.mappingShiptypeData(data.results, searchKey);
                    _this3.shiptypeList = _this3.shiptypeList.concat(shiptype);
                }
            });
        }
    }, {
        key: 'mappingShiptypeData',
        value: function mappingShiptypeData(shiptypes, searchKey) {
            var _this4 = this;

            var shiptypeData = [];
            shiptypes.map(function (shiptype) {
                if (!searchKey) {
                    var currentShiptypeId = _this4.model && _this4.model.shiptypeId ? _this4.model.shiptypeId.id : null;
                    if (!currentShiptypeId || shiptype.id !== currentShiptypeId) {
                        shiptype.Key = shiptype.id + " | " + shiptype.description;
                        shiptype.Value = shiptype.id;
                        shiptypeData.push(shiptype);
                    }
                } else {
                    shiptype.Key = shiptype.id + " | " + shiptype.description;
                    shiptype.Value = shiptype.id;
                    shiptypeData.push(shiptype);
                }
            });
            return shiptypeData;
        }
    }, {
        key: 'loadDenomination',
        value: function loadDenomination(searchKey, offset) {

            searchKey = searchKey || '';

            var denominationSearchObj = {
                queryJSON: {
                    rules: [{
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }, {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }],
                            operator: 'OR'
                        }
                    }],
                    operator: 'AND'
                }
            };

            return denominationSearchObj.queryJSON.rules.length ? denominationSearchObj : null;
        }
    }, {
        key: 'getAllDenominations',
        value: function getAllDenominations(searchKey, offset) {
            var _this5 = this;

            var loadDenominationDatas = this.loadDenomination(searchKey);
            if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
                offset = offset - 1;
            }
            this.Service.all(loadDenominationDatas, offset, _app2.default.defaultPageLimit).then(function (data) {
                if (offset === 0 || offset == undefined) {
                    _this5.totalDenominationRecords = data.total;
                    _this5.denominationList = _this5.mappingDenominationData(data.results, searchKey);
                    if (!searchKey && _this5.model.individualDenominationId) {
                        if (!_this5.denominationList.find(function (x) {
                            return x.Value === _this5.model.individualDenominationId.Value;
                        })) {
                            _this5.denominationList.unshift(_this5.model.individualDenominationId);
                        }
                    }
                } else {
                    var denomination = _this5.mappingDenominationData(data.results, searchKey);
                    _this5.denominationList = _this5.denominationList.concat(denomination);
                }
            });
        }
    }, {
        key: 'mappingDenominationData',
        value: function mappingDenominationData(denominations, searchKey) {
            var _this6 = this;

            var denomData = [];
            denominations.map(function (denom) {
                if (!searchKey) {
                    var currentId = _this6.model && _this6.model.individualDenominationId ? _this6.model.individualDenominationId.id : null;
                    if (!currentId || denom.id !== currentId) {
                        denom.Key = denom.id + " | " + denom.name;
                        denom.Value = denom.id;
                        denomData.push(denom);
                    }
                } else {
                    denom.Key = denom.id + " | " + denom.name;
                    denom.Value = denom.id;
                    denomData.push(denom);
                }
            });
            return denomData;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.model.shiptypeId = this.defaultModel.shiptype;
            this.model.individualDenominationId = this.defaultModel.individualDenomination;
            this.clearErrors();
        }
    }, {
        key: 'isFaceValueChanged',
        value: function isFaceValueChanged() {
            if (this.originalFaceValue === undefined || this.originalFaceValue === null) return false;
            var newFaceValue = Number(this.model.faceValue);
            if (!isFinite(newFaceValue) || this.model.faceValue === '' || this.model.faceValue === null) return false;
            return newFaceValue !== Number(this.originalFaceValue);
        }
    }, {
        key: 'hasLedgerHistory',
        value: function hasLedgerHistory() {
            return !!(this.ledgerUsage && this.ledgerUsage.hasLedgerHistory);
        }
    }, {
        key: 'showFaceValueWarning',
        value: function showFaceValueWarning() {
            return this.isFaceValueChanged() && this.hasLedgerHistory();
        }
    }, {
        key: 'formatNoteCount',
        value: function formatNoteCount(count) {
            return (Number(count) || 0).toLocaleString('en-US');
        }
    }, {
        key: 'submit',
        value: function submit() {
            if (this.showFaceValueWarning()) {
                return this.confirmFaceValueChange();
            }
            return this.saveDenomination();
        }
    }, {
        key: 'confirmFaceValueChange',
        value: function confirmFaceValueChange() {
            var _this7 = this;

            this.Modal.confirm({
                header: this.$translate.instant('denomination.face_value_change_title'),
                message: this.$translate.instant('denomination.face_value_change_confirm'),
                type: 'warning',
                callback: function callback(_ref) {
                    var modal = _ref.modal;

                    modal.close();
                    _this7.saveDenomination();
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    modal.close();
                }
            });
        }
    }, {
        key: 'saveDenomination',
        value: function saveDenomination() {
            var _this8 = this;

            this.loading = true;
            var denominationIcon = [];
            if (this.model.selectedFiles && this.model.selectedFiles.length && this.model.selectedFiles[0].hasOwnProperty('base64Data')) {
                this.model.selectedFiles.forEach(function (d) {
                    denominationIcon.push({ base64String: d.base64Data, fileName: _this8.rawId + '.png' });
                });
            }
            this.Service.update(this.rawId, {
                id: this.rawId,
                name: this.model.name,
                faceValue: this.model.faceValue,
                currencyId: this.model.currencyId,
                shiptypeId: this.model.shiptypeId.Value,
                icon: this.model.icon || null,
                coinFlag: this.model.coinFlag || false,
                sortOrder: this.model.sortOrder,
                strapCount: this.model.coinFlag || this.model.strapCount === '' || this.model.strapCount === undefined ? 0 : Number(this.model.strapCount),
                bundleCount: this.model.coinFlag || this.model.bundleCount === '' || this.model.bundleCount === undefined ? 0 : Number(this.model.bundleCount),
                loadDetectThreshold: this.model.loadDetectThreshold || 0,
                coinPackaging: this.model.coinFlag ? this.model.coinPackaging : null,
                multiDenomPackable: this.isMultiDenomPackableAllowed() ? this.model.multiDenomPackable : false,
                unfit: this.model.unfit || false,
                individualDenominationId: this.model.individualDenominationId && this.model.individualDenominationId.Value && this.model.coinFlag && this.model.coinPackaging !== 'INDIVIDUAL' ? this.model.individualDenominationId.Value : null,
                denominationIcon: denominationIcon
            }, this.branchId).then(function (data) {
                _this8.loading = false;
                window.history.go(-1);
            }).catch(function (err) {
                _this8.loading = false;
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this8.errorMessage += e.message + '<br/>';
                    });
                } else {
                    _this8.errorMessage = _this8.$translate.instant(err.data.message);
                }
            });
        }
    }, {
        key: 'calculateCount',
        value: function calculateCount(type) {
            if (type === 'strapCount') {
                this.model.strapCount = this.model.bundleCount * 10;
            } else {
                this.model.bundleCount = this.model.strapCount / 10;
            }
        }
    }]);
    return DenominationEditController;
}(_denominationBase2.default);

exports.default = DenominationEditController;

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _denominationEdit = __webpack_require__(2226);

var _denominationEdit2 = _interopRequireDefault(_denominationEdit);

__webpack_require__(537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var denominationEditModule = angular.module('denominationedit', []).component('denominationedit', _denominationEdit2.default).name;

exports.default = denominationEditModule;

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _denomination = __webpack_require__(2224);

var _denomination2 = _interopRequireDefault(_denomination);

var _create = __webpack_require__(2223);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2228);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2220);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var denominationModule = angular.module('denomination', [_create2.default, _edit2.default, _all2.default]).component('denomination', _denomination2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('denomination.edit', {
    url: '/edit/:id',
    component: 'denominationedit',
    data: {
      requireACL: 'tnt_control_denomination.edit'
    }
  }).state('denomination.create', {
    url: '/create',
    component: 'denominationcreate',
    data: {
      requireACL: 'tnt_control_denomination.create'
    }
  }).state('denomination.all', {
    url: '/all/:page',
    component: 'denominationall',
    data: {
      requireACL: 'tnt_control_denomination.view'
    }
  });
  $urlRouterProvider.when('/denomination', '/denomination/all/1');
}]).name;

exports.default = denominationModule;

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _environment_configAll = __webpack_require__(2842);

var _environment_configAll2 = _interopRequireDefault(_environment_configAll);

var _environment_configAll3 = __webpack_require__(2231);

var _environment_configAll4 = _interopRequireDefault(_environment_configAll3);

__webpack_require__(538);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var environmentConfigAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _environment_configAll2.default,
    controller: _environment_configAll4.default
};

exports.default = environmentConfigAllComponent;

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _environment_configBase = __webpack_require__(278);

var _environment_configBase2 = _interopRequireDefault(_environment_configBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnvironmentConfigAllController = function (_BaseController) {
    EnvironmentConfigAllController.$inject = ["Auth", "$state", "User", "EnvironmentConfigService", "Modal", "$translate", "$location", "$stateParams", "CommonLayoutService", "Configs", "Idle"];
    (0, _inherits3.default)(EnvironmentConfigAllController, _BaseController);

    /*@ngInject*/
    function EnvironmentConfigAllController(Auth, $state, User, EnvironmentConfigService, Modal, $translate, $location, $stateParams, CommonLayoutService, Configs, Idle) {
        (0, _classCallCheck3.default)(this, EnvironmentConfigAllController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EnvironmentConfigAllController.__proto__ || (0, _getPrototypeOf2.default)(EnvironmentConfigAllController)).call(this, Auth, $state, User, EnvironmentConfigService, Modal, $translate));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.Modal = Modal;
        _this.$location = $location;
        _this.$stateParams = $stateParams;
        _this.CommonLayoutService = CommonLayoutService;
        _this.Configs = Configs;
        _this.page = 1;
        _this.Idle = Idle;
        _this.permissionErrors = {};

        _this.defaultModel = {
            currentBranch: _this.User.getUser().branchId,
            otcConfig: [],
            googleMapFrontEndKey: null,
            googleMapBackEndKey: null,
            ETADistanceKey: null,
            routificApiKey: null,
            enableRoutific: false,
            pageTitle: null,
            webUrl: null,
            companyName: null,
            companyLogo: [],
            printLogo: [],
            selectedFiles: [],
            printFromLocationName: null,
            printFromLocationAddress: null,
            printLogoMetaData: {},
            companyLogoMetaData: {},
            generateXMLFile: false,
            generateCSVFile: false,
            communicationPassword: null,
            cryptographyPassword: null,
            masterPassword: null,
            OTCUserSync: false,
            enable2FA: false,
            maintainDriveDistance: false,
            companyAddress: null,
            companyPhoneNumber: null,
            companyEmail: null,
            footerText: null,
            atmCodesPermission: {},
            settingsPermission: {},
            tntBypassCodePermission: {},
            environmentConfigPermission: {},
            vaultOperationsPermission: {},
            userEditPermission: {},
            bulkCashPermission: {},
            noSessionExpirationPermission: {},
            softDeleteShipmentPermission: {},
            changeVaultDatePermission: {},
            automatedRoutingControlPermission: {},
            bulkUpdateUserPermission: {},
            enableRouteProgressTracking: false,
            sessionLength: null,
            autoReassign: false,
            routeOptimizationEngine: null,
            autoCreatePackableShipment: false,
            autoAssignServiceTickets: false,
            fuelRateImportConfig: {},
            bagOutScanLimit: null,
            promptBluetoothScanner: false
        };
        _this.model = angular.copy(_this.defaultModel);

        _this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: _this.$translate.instant('common.yes'),
                off: _this.$translate.instant('common.no')
            },
            onColor: 'success',
            offColor: 'danger'
        };

        _this.routeOptimizationEngine = [{ value: 'routific', label: 'Routific' }, { value: 'google_maps', label: 'Google Maps' }];

        _this.passWdIcon = {};
        _this.passwordStats = ['NFC', 'OTC'];
        _this.stats = {
            active: 'active',
            suspended: 'suspended'
        };
        return _this;
    }

    (0, _createClass3.default)(EnvironmentConfigAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            var pageId = this.$stateParams.page;
            if (pageId > 0) {
                this.page = pageId;
            }
            this.passwordStats.forEach(function (stat) {
                if (stat === 'OTC') _this2.passWdIcon[stat] = {};
            });
            this.loadData();
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.loadData();
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.permissionErrors = {};
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var _this3 = this;

            this.loading = true;
            this.permissionErrors = {};

            this.model.otcConfig = [];
            this.Service.details().then(function (data) {
                _this3.environmentConfig = data.results;
                if (!_this3.environmentConfig) return;

                var otcConfig = _this3.environmentConfig.OTCAnywhere;
                if (!_.isEmpty(otcConfig)) {
                    var otcCompanyName = (0, _keys2.default)(_this3.environmentConfig.OTCAnywhere);

                    otcCompanyName.forEach(function (company) {
                        // this.setPasswordMap(null, company);
                        _this3.passwordStats.forEach(function (stat) {
                            if (stat === 'NFC') _this3.passWdIcon[stat] = { communicationPassword: false, cryptographyPassword: false, masterPassword: null };
                            if (stat === 'OTC') {
                                _this3.passWdIcon[stat][company] = { viewPass: false };
                            }
                        });

                        _this3.model.otcConfig.push({
                            companyName: otcConfig[company].company,
                            user: otcConfig[company].user,
                            password: otcConfig[company].passwd,
                            secure: otcConfig[company].options ? otcConfig[company].options.secure : null,
                            hostName: otcConfig[company].options ? otcConfig[company].options.hostname : null,
                            disableLockStatus: otcConfig[company].disableLockStatus
                        });
                    });
                }

                _this3.model.googleMapBackEndKey = _this3.environmentConfig.googleMapKeys && _this3.environmentConfig.googleMapKeys.maps ? _this3.environmentConfig.googleMapKeys.maps.backend.key : null;
                _this3.model.googleMapFrontEndKey = _this3.environmentConfig.googleMapKeys && _this3.environmentConfig.googleMapKeys.maps ? _this3.environmentConfig.googleMapKeys.maps.frontend.key : null;
                _this3.model.ETADistanceKey = _this3.environmentConfig.googleMapKeys && _this3.environmentConfig.googleMapKeys.maps && _this3.environmentConfig.googleMapKeys.maps.ETADistanceKey && _this3.environmentConfig.googleMapKeys.maps.ETADistanceKey.key ? _this3.environmentConfig.googleMapKeys.maps.ETADistanceKey.key : null;
                _this3.model.enableRoutific = _this3.environmentConfig.routific ? _this3.environmentConfig.routific.enable : null;
                _this3.model.routificApiKey = _this3.environmentConfig.routific ? _this3.environmentConfig.routific.token : null;
                _this3.model.pageTitle = _this3.environmentConfig.assets ? _this3.environmentConfig.assets.pageTitle : null;
                _this3.model.companyName = _this3.environmentConfig.assets ? _this3.environmentConfig.assets.companyName : null;
                _this3.model.printFromLocationName = _this3.environmentConfig.assets ? _this3.environmentConfig.assets.printFromLocationName : null;
                _this3.model.printFromLocationAddress = _this3.environmentConfig.assets ? _this3.environmentConfig.assets.printFromLocationAddress : null;
                _this3.model.companyLogo = _this3.environmentConfig.companyLogo ? _this3.environmentConfig.companyLogo.data : null;
                _this3.model.printLogo = _this3.environmentConfig.printLogo ? _this3.environmentConfig.printLogo.data : null;
                _this3.model.printLogoMetaData = _this3.environmentConfig.printLogoMetaData;
                _this3.model.companyLogoMetaData = _this3.environmentConfig.companyLogoMetaData;
                _this3.model.generateXMLFile = _this3.environmentConfig.bagoutManifestConfig ? _this3.environmentConfig.bagoutManifestConfig.generateXMLFile : false;
                _this3.model.generateCSVFile = _this3.environmentConfig.bagoutManifestConfig ? _this3.environmentConfig.bagoutManifestConfig.generateCSVFile : false;
                _this3.model.bagOutScanLimit = _this3.environmentConfig.bagoutManifestConfig ? _this3.environmentConfig.bagoutManifestConfig.bagOutScanLimit : null;
                _this3.model.communicationPassword = _this3.environmentConfig.NFCConfig ? _this3.environmentConfig.NFCConfig.communicationPassword : null;
                _this3.model.cryptographyPassword = _this3.environmentConfig.NFCConfig ? _this3.environmentConfig.NFCConfig.cryptographyPassword : null;
                _this3.model.masterPassword = _this3.environmentConfig.NFCConfig ? _this3.environmentConfig.NFCConfig.masterPassword : null;
                _this3.model.OTCUserSync = _this3.environmentConfig.cronSchedulerConfig && _this3.environmentConfig.cronSchedulerConfig.OTCUserSync ? _this3.environmentConfig.cronSchedulerConfig.OTCUserSync : false;
                _this3.model.enable2FA = _this3.environmentConfig.enable2FA;
                _this3.model.maintainDriveDistance = _this3.environmentConfig.googleMapKeys && _this3.environmentConfig.googleMapKeys.maps && _this3.environmentConfig.googleMapKeys.maps.hasOwnProperty('maintainDriveDistance') ? _this3.environmentConfig.googleMapKeys.maps.maintainDriveDistance : false;
                _this3.model.companyAddress = _this3.environmentConfig.assets ? _this3.environmentConfig.assets.companyAddress : null;
                _this3.model.companyPhoneNumber = _this3.environmentConfig.assets ? _this3.environmentConfig.assets.companyPhoneNumber : null;
                _this3.model.companyEmail = _this3.environmentConfig.assets ? _this3.environmentConfig.assets.companyEmail : null;
                _this3.model.footerText = _this3.environmentConfig.assets ? _this3.environmentConfig.assets.footerText : null;
                _this3.model.paths = _this3.environmentConfig.paths;
                _this3.model.atmCodesPermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.atmCodes ? _this3.environmentConfig.permissions.atmCodes.users : null;
                _this3.model.settingsPermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.settings ? _this3.environmentConfig.permissions.settings.users : null;
                _this3.model.tntBypassCodePermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.tntBypassCode ? _this3.environmentConfig.permissions.tntBypassCode.users : null;
                _this3.model.environmentConfigPermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.environmentConfig ? _this3.environmentConfig.permissions.environmentConfig.users : null;
                _this3.model.vaultOperationsPermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.valutOprations ? _this3.environmentConfig.permissions.valutOprations.users : null;
                _this3.model.userEditPermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.userEdit ? _this3.environmentConfig.permissions.userEdit.users : null;
                _this3.model.bulkCashPermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.bulkCash ? _this3.environmentConfig.permissions.bulkCash.users : null;
                _this3.model.noSessionExpirationPermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.noSessionExpiration ? _this3.environmentConfig.permissions.noSessionExpiration.users : null;
                _this3.model.softDeleteShipmentPermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.softDeleteShipment ? _this3.environmentConfig.permissions.softDeleteShipment.users : null;
                _this3.model.changeVaultDatePermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.changeVaultDate ? _this3.environmentConfig.permissions.changeVaultDate.users : null;
                _this3.model.automatedRoutingControlPermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.automatedRoutingControl ? _this3.environmentConfig.permissions.automatedRoutingControl.users : null;
                _this3.model.bulkUpdateUserPermission = _this3.environmentConfig.permissions && _this3.environmentConfig.permissions.bulkUpdateUser ? _this3.environmentConfig.permissions.bulkUpdateUser.users : null;
                _this3.model.enableRouteProgressTracking = _this3.environmentConfig.enableRouteProgressTracking;
                _this3.model.autoReassign = _this3.environmentConfig.autoReassign;
                _this3.model.sessionLength = _this3.environmentConfig.sessionLength;
                _this3.model.routeOptimizationEngine = _this3.environmentConfig.routeOptimizationEngine;
                _this3.model.autoCreatePackableShipment = _this3.environmentConfig.cronSchedulerConfig && _this3.environmentConfig.cronSchedulerConfig.autoCreatePackableShipment ? _this3.environmentConfig.cronSchedulerConfig.autoCreatePackableShipment : false;
                _this3.model.autoAssignServiceTickets = _this3.environmentConfig.cronSchedulerConfig && _this3.environmentConfig.cronSchedulerConfig.autoAssignServiceTickets ? _this3.environmentConfig.cronSchedulerConfig.autoAssignServiceTickets : false;
                _this3.model.fuelRateImportStatus = _this3.environmentConfig.fuelRateImportConfig && _this3.environmentConfig.fuelRateImportConfig.status ? _this3.environmentConfig.fuelRateImportConfig.status : 'suspended';
                _this3.model.fuelRateImportDataURL = _this3.environmentConfig.fuelRateImportConfig && _this3.environmentConfig.fuelRateImportConfig.url ? _this3.environmentConfig.fuelRateImportConfig.url : null;
                _this3.model.promptBluetoothScanner = _this3.environmentConfig.promptBluetoothScanner;

                _this3.rawId = _this3.environmentConfig.id;
                _this3.defaultModel = _this3.model;
                _this3.model = angular.copy(_this3.defaultModel);
                _this3.CommonLayoutService.setUIConfig(_this3.environmentConfig.assets);

                if (_this3.model.companyLogo && _this3.model.companyLogo.length) {
                    var companyLogoObjectURL = _this3.CommonLayoutService.generateObjectURL(_this3.model.companyLogo);
                    document.getElementById('navbar_company_logo').src = companyLogoObjectURL;
                    _this3.CommonLayoutService.updateFavicon(_this3.model.companyLogo);
                }
                _this3.Configs.setEnvironmentConfig(_this3.environmentConfig);
                _this3.validatePermissions();
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this3.errorMessage += e.message + '<br/>';
                    });
                } else {
                    _this3.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this3.loading = false;
            });
        }
    }, {
        key: 'setPasswordMap',
        value: function setPasswordMap(stat, type) {
            if (stat === 'OTC') {
                this.passWdIcon[stat][type] = { viewPass: false };
            }
        }

        // showPassword(type, company) {
        //     this.passWdIcon[company].viewPass = !this.passWdIcon[company].viewPass;
        // }

    }, {
        key: 'update',
        value: function update() {
            var _this4 = this;

            if (!this.validatePermissions()) {
                return;
            }

            var OtcConfig = {},
                googleMapConfig = { maps: {} },
                routific = {},
                assets = {},
                companyLogo = [],
                printLogo = [],
                bagoutManifestConfig = {},
                NFCConfig = {},
                cronSchedulerConfig = {},
                permissions = {},
                fuelRateImportConfig = {};

            this.isUpdating = true;
            this.model.otcConfig.forEach(function (otc) {
                OtcConfig = (0, _assign2.default)(OtcConfig, (0, _defineProperty3.default)({}, otc.companyName, {
                    company: otc.companyName,
                    user: otc.user,
                    passwd: otc.password,
                    disableLockStatus: otc.disableLockStatus,
                    options: {
                        secure: otc.secure,
                        hostname: otc.hostName
                    }
                }));
            });

            googleMapConfig.maps = {
                backend: {
                    key: this.model.googleMapBackEndKey
                },
                frontend: {
                    key: this.model.googleMapFrontEndKey
                },
                maintainDriveDistance: this.model.maintainDriveDistance,
                ETADistanceKey: {
                    key: this.model.ETADistanceKey
                }
            };

            routific = {
                enable: this.model.enableRoutific,
                token: this.model.routificApiKey
            };

            assets = {
                pageTitle: this.model.pageTitle,
                companyName: this.model.companyName,
                printFromLocationName: this.model.printFromLocationName,
                printFromLocationAddress: this.model.printFromLocationAddress,
                companyAddress: this.model.companyAddress,
                companyPhoneNumber: this.model.companyPhoneNumber,
                companyEmail: this.model.companyEmail,
                footerText: this.model.footerText
            };

            bagoutManifestConfig = {
                generateXMLFile: this.model.generateXMLFile,
                generateCSVFile: this.model.generateCSVFile,
                bagOutScanLimit: this.model.bagOutScanLimit
            };

            NFCConfig = {
                communicationPassword: this.model.communicationPassword,
                cryptographyPassword: this.model.cryptographyPassword,
                masterPassword: this.model.masterPassword
            };

            cronSchedulerConfig = {
                OTCUserSync: this.model.OTCUserSync,
                autoCreatePackableShipment: this.model.autoCreatePackableShipment,
                autoAssignServiceTickets: this.model.autoAssignServiceTickets
            };

            permissions = {
                atmCodes: { users: this.model.atmCodesPermission },
                settings: { users: this.model.settingsPermission },
                tntBypassCode: { users: this.model.tntBypassCodePermission },
                environmentConfig: { users: this.model.environmentConfigPermission },
                valutOprations: { users: this.model.vaultOperationsPermission },
                userEdit: { users: this.model.userEditPermission },
                bulkCash: { users: this.model.bulkCashPermission },
                noSessionExpiration: { users: this.model.noSessionExpiration },
                softDeleteShipment: { users: this.model.softDeleteShipmentPermission },
                changeVaultDate: { users: this.model.changeVaultDatePermission },
                automatedRoutingControl: { users: this.model.automatedRoutingControlPermission },
                bulkUpdateUser: { users: this.model.bulkUpdateUserPermission }
            };

            fuelRateImportConfig = {
                url: this.model.fuelRateImportDataURL,
                status: this.model.fuelRateImportStatus
            };

            if (this.model.companyLogo && this.model.companyLogo.length && this.model.companyLogo[0].hasOwnProperty('base64Data')) {
                this.model.companyLogo.forEach(function (d) {
                    _this4.model.companyLogoMetaData = {
                        lastModified: d._file.lastModified,
                        lastModifiedDate: d._file.lastModifiedDate,
                        name: d._file.name,
                        size: d._file.size,
                        type: d._file.type
                    };
                    companyLogo.push({ base64String: d.base64Data, fileName: d.fileName });
                });
            }

            if (this.model.printLogo && this.model.printLogo.length && this.model.printLogo[0].hasOwnProperty('base64Data')) {
                this.model.printLogo.forEach(function (d) {
                    _this4.model.printLogoMetaData = {
                        lastModified: d._file.lastModified,
                        lastModifiedDate: d._file.lastModifiedDate,
                        name: d._file.name,
                        size: d._file.size,
                        type: d._file.type
                    };
                    printLogo.push({ base64String: d.base64Data, fileName: d.fileName });
                });
            }
            var payload = {
                OTCAnywhere: OtcConfig,
                googleMapKeys: googleMapConfig,
                routific: routific,
                assets: assets,
                companyLogo: companyLogo,
                companyLogoMetaData: this.model.companyLogoMetaData,
                printLogo: printLogo,
                printLogoMetaData: this.model.printLogoMetaData,
                printFromLocationName: this.model.printFromLocationName,
                printFromLocationAddress: this.model.printFromLocationAddress,
                id: this.rawId,
                branchId: this.model.currentBranch,
                bagoutManifestConfig: bagoutManifestConfig,
                NFCConfig: NFCConfig,
                cronSchedulerConfig: cronSchedulerConfig,
                enable2FA: this.model.enable2FA,
                permissions: permissions,
                enableRouteProgressTracking: this.model.enableRouteProgressTracking,
                sessionLength: this.model.sessionLength,
                autoReassign: this.model.autoReassign,
                routeOptimizationEngine: this.model.routeOptimizationEngine,
                fuelRateImportConfig: fuelRateImportConfig,
                promptBluetoothScanner: this.model.promptBluetoothScanner
            };

            var envConfClone = (0, _assign2.default)({}, this.environmentConfig);

            delete envConfClone.createdAt;
            delete envConfClone.updatedAt;
            delete envConfClone.printLogo;
            delete envConfClone.companyLogo;
            envConfClone.branchId = this.model.currentBranch;
            envConfClone.printFromLocationAddress = this.environmentConfig.assets.printFromLocationAddress;
            envConfClone.printFromLocationName = this.environmentConfig.assets.printFromLocationName;
            var payloadClone = (0, _assign2.default)({}, payload);
            payloadClone.paths = this.environmentConfig.paths;
            delete payloadClone.printLogo;
            delete payloadClone.companyLogo;
            payloadClone.printFromLocationAddress = payload.assets.printFromLocationAddress;
            payloadClone.printFromLocationName = payload.assets.printFromLocationName;
            var changeValues = this.diffObjects(envConfClone, payloadClone);
            var userId = this.User.getUser().id;
            this.Service.update((0, _extends3.default)({}, payload, { changedObj: changeValues, modifiedByUserId: userId })).then(function () {
                _this4.loadData();
                if (_this4.model.sessionLength) {
                    _this4.Idle.watch();
                    _this4.Idle.setIdle(_this4.model.sessionLength * 60);
                    localStorage.setItem('sessionLength', (0, _stringify2.default)(_this4.model.sessionLength));
                } else {
                    _this4.Idle.unwatch();
                    localStorage.removeItem('sessionLength');
                }
            }).catch(function (err) {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this4.errorMessage += e.message + '<br/>';
                    });
                } else if (err && err.data && err.data.message) {
                    _this4.Modal.errorModal(err.data.message);
                } else {
                    console.log(err);
                }
            }).finally(function () {
                _this4.isUpdating = false;
            });
        }
    }, {
        key: 'addOTCConfig',
        value: function addOTCConfig() {
            this.model.otcConfig.push({
                companyName: null,
                user: null,
                password: null,
                secure: true,
                hostName: null,
                disableLockStatus: false
            });
            this.validateOTCConfig();
        }
    }, {
        key: 'removeOTCConfig',
        value: function removeOTCConfig(index) {
            this.model.otcConfig.splice(index, 1);
            this.validateOTCConfig();
        }
    }, {
        key: 'validateOTCConfig',
        value: function validateOTCConfig() {
            var _this5 = this;

            this.model.otcConfig = _.map(this.model.otcConfig, function (obj, index) {
                obj.isDuplicate = false;
                var match = _.find(_this5.model.otcConfig, function (compairObject, compairObjIndex) {
                    if (index > compairObjIndex) return compairObject.companyName == obj.companyName;
                });
                if (match) {
                    obj.isDuplicate = true;
                    return obj;
                } else {
                    return obj;
                }
            });
            var isValidDirective = this.model.otcConfig.map(function (obj) {
                if (obj.isDuplicate) return true;
            });
            this.isValid = isValidDirective.indexOf(true) >= 0 ? false : true;
        }
    }, {
        key: 'validatePermissions',
        value: function validatePermissions() {
            var _this6 = this;

            var permissionFields = ['atmCodesPermission', 'settingsPermission', 'tntBypassCodePermission', 'environmentConfigPermission', 'vaultOperationsPermission', 'bulkCashPermission', 'userEditPermission', 'softDeleteShipmentPermission', 'changeVaultDatePermission', 'automatedRoutingControlPermission', 'bulkUpdateUserPermission'];

            this.permissionErrors = {};
            var hasDuplicates = false;

            permissionFields.forEach(function (field) {
                var value = _this6.model[field];
                if (value && typeof value === 'string') {
                    var users = value.split(',').map(function (u) {
                        return u.trim();
                    }).filter(function (u) {
                        return u;
                    });
                    var uniqueUsers = new _set2.default(users);

                    if (users.length !== uniqueUsers.size) {
                        var duplicateUser = users.find(function (user, index) {
                            return users.indexOf(user) !== index;
                        });
                        _this6.permissionErrors[field] = _this6.$translate.instant('environmentConfig.duplicate_users_not_allowed_message', { user: duplicateUser });
                        hasDuplicates = true;
                    } else {
                        _this6.permissionErrors[field] = null;
                    }
                } else {
                    _this6.permissionErrors[field] = null;
                }
            });

            return !hasDuplicates;
        }
    }, {
        key: 'hasPermissionErrors',
        value: function hasPermissionErrors() {
            return (0, _values2.default)(this.permissionErrors).some(function (error) {
                return error !== null;
            });
        }
    }, {
        key: 'viewAppLogo',
        value: function viewAppLogo(data, stat) {
            this.Modal.viewAppLogo(data, stat, function (_ref) {
                var modal = _ref.modal;
            }, function (_ref2) {
                var modal = _ref2.modal;

                modal.close();
            });
        }
    }, {
        key: 'viewPassword',
        value: function viewPassword(stat, type, field) {
            this.CommonLayoutService.viewPassword(stat, type, field, this.passWdIcon);
        }
    }, {
        key: 'isValidLength',
        value: function isValidLength() {
            if (this.model.sessionLength === null) return true;
            // Check if the value is undefined or null
            if (this.model.sessionLength === undefined) {
                return false;
            }

            // Convert the value to a number and check if it's a valid number
            var sessionLength = Number(this.model.sessionLength);
            if (isNaN(sessionLength) || sessionLength < 1) {
                return false;
            }

            // Check if the value is a positive integer
            return (/^[1-9]\d*$/.test(this.model.sessionLength.toString())
            );
        }
    }, {
        key: 'diffObjects',
        value: function diffObjects(obj1, obj2) {
            var diff = {};

            // Iterate through the keys in obj1
            for (var key in obj1) {
                // If the key doesn't exist in obj2, add it to the diff object
                if (!(key in obj2)) {
                    diff[key] = { "Old Value": obj1[key], "Updated Value": undefined };
                } else {
                    // If the value is an object, recursively compare them
                    if ((0, _typeof3.default)(obj1[key]) === 'object' && (0, _typeof3.default)(obj2[key]) === 'object') {
                        var nestedDiff = this.diffObjects(obj1[key], obj2[key]);
                        if ((0, _keys2.default)(nestedDiff).length > 0) {
                            diff[key] = nestedDiff;
                        }
                    } else if (obj1[key] !== obj2[key]) {
                        diff[key] = { "Old Value": obj1[key], "Updated Value": obj2[key] };
                    }
                }
            }

            // Iterate through the keys in obj2 that are not in obj1
            for (var _key in obj2) {
                if (!(_key in obj1)) {
                    diff[_key] = { "Old Value": undefined, "Updated Value": obj2[_key] };
                }
            }

            return diff;
        }
    }, {
        key: 'tabSelection',
        value: function tabSelection(selectedValue) {
            this.model.fuelRateImportStatus = selectedValue;
        }
    }]);
    return EnvironmentConfigAllController;
}(_environment_configBase2.default);

exports.default = EnvironmentConfigAllController;

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _environment_configAll = __webpack_require__(2230);

var _environment_configAll2 = _interopRequireDefault(_environment_configAll);

__webpack_require__(538);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var environmentConfigAllModule = angular.module('environmentConfigAll', []).component('environmentConfigAll', _environment_configAll2.default).name;

exports.default = environmentConfigAllModule;

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _environment_configCreate = __webpack_require__(2843);

var _environment_configCreate2 = _interopRequireDefault(_environment_configCreate);

var _environment_configCreate3 = __webpack_require__(2234);

var _environment_configCreate4 = _interopRequireDefault(_environment_configCreate3);

__webpack_require__(3115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var environmentConfigCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _environment_configCreate2.default,
    controller: _environment_configCreate4.default
};

exports.default = environmentConfigCreateComponent;

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _environment_configBase = __webpack_require__(278);

var _environment_configBase2 = _interopRequireDefault(_environment_configBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnvironmentConfigCreateController = function (_BaseController) {
    EnvironmentConfigCreateController.$inject = ["Auth", "$state", "User", "EnvironmentConfigService", "Modal", "$translate", "CommonLayoutService", "Idle"];
    (0, _inherits3.default)(EnvironmentConfigCreateController, _BaseController);

    /*@ngInject*/
    function EnvironmentConfigCreateController(Auth, $state, User, EnvironmentConfigService, Modal, $translate, CommonLayoutService, Idle) {
        (0, _classCallCheck3.default)(this, EnvironmentConfigCreateController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EnvironmentConfigCreateController.__proto__ || (0, _getPrototypeOf2.default)(EnvironmentConfigCreateController)).call(this, Auth, $state, User, EnvironmentConfigService, Modal, $translate));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.Modal = Modal;
        _this.EnvironmentConfigService = EnvironmentConfigService;
        _this.CommonLayoutService = CommonLayoutService;
        _this.Idle = Idle;

        _this.defaultModel = {
            currentBranch: _this.User.getUser().branchId,
            otcConfig: [],
            googleMapFrontEndKey: null,
            googleMapBackEndKey: null,
            ETADistanceKey: null,
            routificApiKey: null,
            enableRoutific: false,
            pageTitle: null,
            webUrl: null,
            companyName: null,
            companyLogo: [],
            printLogo: [],
            selectedFiles: [],
            printFromLocationName: null,
            printFromLocationAddress: null,
            generateXMLFile: false,
            generateCSVFile: false,
            communicationPassword: null,
            cryptographyPassword: null,
            masterPassword: null,
            OTCUserSync: false,
            enable2FA: false,
            maintainDriveDistance: false,
            companyAddress: null,
            companyPhoneNumber: null,
            companyEmail: null,
            footerText: null,
            sessionLength: null,
            routeOptimizationEngine: null,
            bagOutScanLimit: null
        };

        _this.model = angular.copy(_this.defaultModel);

        _this.serviceOrderParts = {
            results: [],
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            }
        };

        _this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: _this.$translate.instant('common.yes'),
                off: _this.$translate.instant('common.no')
            },
            onColor: 'success',
            offColor: 'danger'
        };

        _this.routeOptimizationEngine = [{ value: 'routific', label: 'Routific' }, { value: 'google_maps', label: 'Google Maps' }];

        _this.passWdIcon = {};
        _this.passwordStats = ['NFC', 'OTC'];
        return _this;
    }

    (0, _createClass3.default)(EnvironmentConfigCreateController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.loadData();
            this.passwordStats.forEach(function (stat) {
                if (stat === 'NFC') _this2.passWdIcon[stat] = { communicationPassword: false, cryptographyPassword: false, masterPassword: false };else if (stat === 'OTC') _this2.passWdIcon[stat] = {};
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
        }
    }, {
        key: 'create',
        value: function create() {
            var _this3 = this;

            var OtcConfig = {},
                googleMapConfig = { maps: {} },
                routific = {},
                assets = {},
                companyLogo = [],
                printLogo = [],
                bagoutManifestConfig = {},
                NFCConfig = {},
                cronSchedulerConfig = {};

            this.loading = true;
            this.model.otcConfig.forEach(function (otc) {
                OtcConfig = (0, _assign2.default)(OtcConfig, (0, _defineProperty3.default)({}, otc.companyName, {
                    company: otc.companyName,
                    user: otc.user,
                    passwd: otc.password,
                    disableLockStatus: otc.disableLockStatus,
                    options: {
                        secure: otc.secure,
                        hostname: otc.hostName
                    }
                }));
            });

            googleMapConfig.maps = {
                backend: {
                    key: this.model.googleMapBackEndKey
                },
                frontend: {
                    key: this.model.googleMapFrontEndKey
                },
                maintainDriveDistance: this.model.maintainDriveDistance,
                ETADistanceKey: {
                    key: this.model.ETADistanceKey
                }
            };

            routific = {
                enable: this.model.enableRoutific,
                token: this.model.routificApiKey
            };

            assets = {
                pageTitle: this.model.pageTitle,
                companyName: this.model.companyName,
                printFromLocationName: this.model.printFromLocationName,
                printFromLocationAddress: this.model.printFromLocationAddress,
                companyAddress: this.model.companyAddress,
                companyPhoneNumber: this.model.companyPhoneNumber,
                companyEmail: this.model.companyEmail,
                footerText: this.model.footerText
            };

            bagoutManifestConfig = {
                generateXMLFile: this.model.generateXMLFile,
                generateCSVFile: this.model.generateCSVFile,
                bagOutScanLimit: this.model.bagOutScanLimit
            };

            NFCConfig = {
                communicationPassword: this.model.communicationPassword,
                cryptographyPassword: this.model.cryptographyPassword,
                masterPassword: this.model.masterPassword
            };

            cronSchedulerConfig = {
                OTCUserSync: this.model.OTCUserSync
            };

            if (this.model.companyLogo && this.model.companyLogo.length) {
                this.model.companyLogo.forEach(function (d) {
                    _this3.model.companyLogoMetaData = {
                        lastModified: d._file.lastModified,
                        lastModifiedDate: d._file.lastModifiedDate,
                        name: d._file.name,
                        size: d._file.size,
                        type: d._file.type
                    };
                    companyLogo.push({ base64String: d.base64Data, fileName: d.fileName });
                });
            }

            if (this.model.printLogo && this.model.printLogo.length) {
                this.model.printLogo.forEach(function (d) {
                    _this3.model.printLogoMetaData = {
                        lastModified: d._file.lastModified,
                        lastModifiedDate: d._file.lastModifiedDate,
                        name: d._file.name,
                        size: d._file.size,
                        type: d._file.type
                    };
                    printLogo.push({ base64String: d.base64Data, fileName: d.fileName });
                });
            }

            this.Service.create({
                OTCAnywhere: OtcConfig,
                googleMapKeys: googleMapConfig,
                routific: routific,
                assets: assets,
                companyLogo: companyLogo,
                companyLogoMetaData: this.model.companyLogoMetaData,
                printLogo: printLogo,
                printLogoMetaData: this.model.printLogoMetaData,
                companyName: companyName,
                branchId: this.model.currentBranch,
                bagoutManifestConfig: bagoutManifestConfig,
                NFCConfig: NFCConfig,
                cronSchedulerConfig: cronSchedulerConfig,
                enable2FA: this.model.enable2FA,
                sessionLength: this.model.sessionLength,
                routeOptimizationEngine: this.model.routeOptimizationEngine
            }).then(function () {
                _this3.CommonLayoutService.setUIConfig(assets);
                window.history.go(-1);
                if (_this3.model.sessionLength) {
                    _this3.Idle.watch();
                    _this3.Idle.setIdle(_this3.model.sessionLength * 60);
                    localStorage.setItem('sessionLength', (0, _stringify2.default)(_this3.model.sessionLength));
                } else {
                    _this3.Idle.unwatch();
                    localStorage.removeItem('sessionLength');
                }
            }).catch(function (err) {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this3.errorMessage += e.message + '<br/>';
                    });
                } else {
                    _this3.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this3.loading = false;
            });
        }
    }, {
        key: 'setPasswordMap',
        value: function setPasswordMap(stat, type) {
            if (stat === 'OTC') {
                this.passWdIcon[stat][type] = { viewPass: false };
            }
        }
    }, {
        key: 'viewPassword',
        value: function viewPassword(stat, type, field) {
            this.CommonLayoutService.viewPassword(stat, type, field, this.passWdIcon);
        }
    }, {
        key: 'addOTCConfig',
        value: function addOTCConfig() {
            this.model.otcConfig.push({
                companyName: null,
                user: null,
                password: null,
                secure: true,
                hostName: null,
                disableLockStatus: false
            });
            this.validateOTCConfig();
        }
    }, {
        key: 'removeOTCConfig',
        value: function removeOTCConfig(index) {
            this.model.otcConfig.splice(index, 1);
            this.validateOTCConfig();
        }
    }, {
        key: 'validateOTCConfig',
        value: function validateOTCConfig() {
            var _this4 = this;

            this.model.otcConfig = _.map(this.model.otcConfig, function (obj, index) {
                obj.isDuplicate = false;
                var match = _.find(_this4.model.otcConfig, function (compairObject, compairObjIndex) {
                    if (index > compairObjIndex) return compairObject.companyName == obj.companyName;
                });
                if (match) {
                    obj.isDuplicate = true;
                    return obj;
                } else {
                    return obj;
                }
            });
            var isValidDirective = this.model.otcConfig.map(function (obj) {
                if (obj.isDuplicate) return true;
            });
            this.isValid = isValidDirective.indexOf(true) >= 0 ? false : true;
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var _this5 = this;

            this.gettingDetails = true;
            this.Service.details().then(function (data) {
                _this5.environmentConfig = data.results;
            }).catch(function (err) {
                if (err && err.data && err.data.errors) {
                    _this5.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this5.gettingDetails = false;
            });
        }
    }, {
        key: 'viewAppLogo',
        value: function viewAppLogo(data, stat) {
            this.Modal.viewAppLogo(data, stat, function (_ref) {
                var modal = _ref.modal;
            }, function (_ref2) {
                var modal = _ref2.modal;

                modal.close();
            });
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            if (this.model.sessionLength === null) return true;
            // Check if the value is undefined or null
            if (this.model.sessionLength === undefined) {
                return false;
            }

            // Convert the value to a number and check if it's a valid number
            var sessionLength = Number(this.model.sessionLength);
            if (isNaN(sessionLength) || sessionLength < 1) {
                return false;
            }

            // Check if the value is a positive integer
            return (/^[1-9]\d*$/.test(this.model.sessionLength.toString())
            );
        }
    }]);
    return EnvironmentConfigCreateController;
}(_environment_configBase2.default);

exports.default = EnvironmentConfigCreateController;

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _environment_configCreate = __webpack_require__(2233);

var _environment_configCreate2 = _interopRequireDefault(_environment_configCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var environmentConfigCreateModule = angular.module('environmentConfigCreate', []).component('environmentConfigCreate', _environment_configCreate2.default).name;

exports.default = environmentConfigCreateModule;

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _environment_configEdit = __webpack_require__(2844);

var _environment_configEdit2 = _interopRequireDefault(_environment_configEdit);

var _environment_configEdit3 = __webpack_require__(2237);

var _environment_configEdit4 = _interopRequireDefault(_environment_configEdit3);

__webpack_require__(3116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var environmentConfigEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _environment_configEdit2.default,
    controller: _environment_configEdit4.default
};

exports.default = environmentConfigEditComponent;

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _environment_configBase = __webpack_require__(278);

var _environment_configBase2 = _interopRequireDefault(_environment_configBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnvironmentConfigEditController = function (_BaseController) {
    EnvironmentConfigEditController.$inject = ["Auth", "$state", "User", "EnvironmentConfigService", "Modal", "$translate", "$q", "$stateParams"];
    (0, _inherits3.default)(EnvironmentConfigEditController, _BaseController);

    /*@ngInject*/
    function EnvironmentConfigEditController(Auth, $state, User, EnvironmentConfigService, Modal, $translate, $q, $stateParams) {
        (0, _classCallCheck3.default)(this, EnvironmentConfigEditController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EnvironmentConfigEditController.__proto__ || (0, _getPrototypeOf2.default)(EnvironmentConfigEditController)).call(this, Auth, $state, User, EnvironmentConfigService, Modal, $translate));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.Modal = Modal;
        _this.$q = $q;
        _this.$stateParams = $stateParams;
        _this.model = {};
        return _this;
    }

    (0, _createClass3.default)(EnvironmentConfigEditController, [{
        key: '$onInit',
        value: function $onInit() {}
    }]);
    return EnvironmentConfigEditController;
}(_environment_configBase2.default);

exports.default = EnvironmentConfigEditController;

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _environment_configEdit = __webpack_require__(2236);

var _environment_configEdit2 = _interopRequireDefault(_environment_configEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var environmentConfigEditModule = angular.module('environmentConfigEdit', []).component('environmentConfigEdit', _environment_configEdit2.default).name;

exports.default = environmentConfigEditModule;

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _environment_config = __webpack_require__(2845);

var _environment_config2 = _interopRequireDefault(_environment_config);

var _environment_config3 = __webpack_require__(2240);

var _environment_config4 = _interopRequireDefault(_environment_config3);

__webpack_require__(3117);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var environmentConfigComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _environment_config2.default,
    controller: _environment_config4.default
};

exports.default = environmentConfigComponent;

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnvironmentConfigController = function (_SettingBase) {
    EnvironmentConfigController.$inject = ["$state"];
    (0, _inherits3.default)(EnvironmentConfigController, _SettingBase);

    /*@ngInject*/
    function EnvironmentConfigController($state) {
        (0, _classCallCheck3.default)(this, EnvironmentConfigController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EnvironmentConfigController.__proto__ || (0, _getPrototypeOf2.default)(EnvironmentConfigController)).call(this));

        _this.$state = $state;
        _this.id = "environment_config";
        _this.acl = {};
        _this.hasACL = {};
        return _this;
    }

    (0, _createClass3.default)(EnvironmentConfigController, [{
        key: '$onInit',
        value: function $onInit() {
            (0, _get3.default)(EnvironmentConfigController.prototype.__proto__ || (0, _getPrototypeOf2.default)(EnvironmentConfigController.prototype), '$onInit', this).call(this);
            for (var key in this.acl['tnt_control_' + this.id]) {
                this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
            }
        }
    }]);
    return EnvironmentConfigController;
}(_SettingBase3.default);

exports.default = EnvironmentConfigController;

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _environment_config = __webpack_require__(2239);

var _environment_config2 = _interopRequireDefault(_environment_config);

var _create = __webpack_require__(2235);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2238);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2232);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var environmentConfigModule = angular.module('environmentConfig', [_create2.default, _edit2.default, _all2.default]).component('environmentConfig', _environment_config2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('environment_config.edit', {
        url: '/edit/:id',
        component: 'environmentConfigEdit',
        data: {
            requireACL: 'tnt_control_environment_config.edit'
        }
    }).state('environment_config.create', {
        url: '/create',
        component: 'environmentConfigCreate',
        data: {
            requireACL: 'tnt_control_environment_config.create'
        }
    }).state('environment_config.all', {
        url: '/all/:page',
        component: 'environmentConfigAll',
        data: {
            requireACL: 'tnt_control_environment_config.view'
        }
    });
}]).name;

exports.default = environmentConfigModule;

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_zoneAll = __webpack_require__(2243);

var _location_zoneAll2 = _interopRequireDefault(_location_zoneAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationZoneAllModule = angular.module('locationZoneAll', []).component('locationZoneAll', _location_zoneAll2.default).name;

exports.default = locationZoneAllModule;

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_zoneAll = __webpack_require__(2846);

var _location_zoneAll2 = _interopRequireDefault(_location_zoneAll);

var _location_zoneAll3 = __webpack_require__(2244);

var _location_zoneAll4 = _interopRequireDefault(_location_zoneAll3);

__webpack_require__(3118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationZoneAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _location_zoneAll2.default,
    controller: _location_zoneAll4.default
};

exports.default = locationZoneAllComponent;

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _location_zoneBase = __webpack_require__(279);

var _location_zoneBase2 = _interopRequireDefault(_location_zoneBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationZoneAllController = function (_BaseController) {
    LocationZoneAllController.$inject = ["Auth", "$state", "User", "LocationZoneService", "Modal", "$translate", "$location", "$stateParams"];
    (0, _inherits3.default)(LocationZoneAllController, _BaseController);

    /*@ngInject*/
    function LocationZoneAllController(Auth, $state, User, LocationZoneService, Modal, $translate, $location, $stateParams) {
        (0, _classCallCheck3.default)(this, LocationZoneAllController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LocationZoneAllController.__proto__ || (0, _getPrototypeOf2.default)(LocationZoneAllController)).call(this, Auth, $state, User, LocationZoneService, Modal, $translate));

        _this.id = 'location_zone.all';
        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.Modal = Modal;
        _this.$location = $location;
        _this.$stateParams = $stateParams;
        _this.page = 1;

        _this.model = {
            currentBranch: _this.User.getUser().branchId,
            searchText: '',
            locationZoneObj: {
                results: [],
                totalRecords: 0,
                loading: false,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                }
            }
        };
        return _this;
    }

    (0, _createClass3.default)(LocationZoneAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var pageId = this.$stateParams.page;
            if (pageId > 0) {
                this.page = pageId;
            }
            this.loadData();
        }
    }, {
        key: 'edit',
        value: function edit(zone) {
            this.$state.go('location_zone.edit', {
                id: zone.id
            });
        }
    }, {
        key: 'generateSearchObj',
        value: function generateSearchObj() {
            var obj = {
                queryJSON: {
                    rules: [{
                        field: 'id',
                        condition: 'like',
                        data: '%' + this.model.searchText + '%'
                    }, {
                        field: 'name',
                        condition: 'like',
                        data: '%' + this.model.searchText + '%'
                    }, {
                        field: 'type',
                        condition: 'like',
                        data: '%' + this.model.searchText + '%'
                    }],
                    operator: 'OR'
                }
            };
            return obj.queryJSON.rules.length ? obj : null;
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var _this2 = this;

            var searchObj = this.generateSearchObj();

            this.model.locationZoneObj.loading = true;
            this.Service.all(searchObj, (this.model.locationZoneObj.pagination.page - 1) * this.model.locationZoneObj.pagination.pageLimit, this.model.locationZoneObj.pagination.pageLimit).then(function (data) {
                _this2.model.locationZoneObj.totalRecords = data.total;
                _this2.model.locationZoneObj.results = data.results;
            }).catch(function (err) {
                if (err && err.data && err.data.message) {
                    _this2.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this2.model.locationZoneObj.loading = false;
            });
        }
    }, {
        key: 'search',
        value: function search() {
            this.page = 1;
            this.model.locationZoneObj.pagination.page = 1;
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.loadData();
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'delete',
        value: function _delete(zone) {
            var _this3 = this;

            if (this.allowOnlyOnce) return;
            this.allowOnlyOnce = true;
            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_delete_title'),
                message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + zone.id + '</strong>?'),
                callback: function callback(_ref) {
                    var modal = _ref.modal,
                        $scope = _ref.$scope;

                    $scope.loading = true;
                    _this3.Service.remove(zone.id, zone.name, zone.description, _this3.model.currentBranch).then(function () {
                        modal.close();
                        _this3.refresh();
                    }).catch(function () {}).finally(function () {
                        _this3.allowOnlyOnce = false;
                        $scope.loading = false;
                    });
                },
                negative: function negative(_ref2) {
                    var modal = _ref2.modal;

                    _this3.allowOnlyOnce = false;
                    modal.close();
                },
                type: 'danger'
            });
        }
    }]);
    return LocationZoneAllController;
}(_location_zoneBase2.default); // import AppConstant from '../../../config/app.constants';


;

exports.default = LocationZoneAllController;

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_zoneCreate = __webpack_require__(2246);

var _location_zoneCreate2 = _interopRequireDefault(_location_zoneCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationzoneCreateModule = angular.module('locationZoneCreate', []).component('locationZoneCreate', _location_zoneCreate2.default).name;

exports.default = locationzoneCreateModule;

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_zoneCreate = __webpack_require__(2847);

var _location_zoneCreate2 = _interopRequireDefault(_location_zoneCreate);

var _location_zoneCreate3 = __webpack_require__(2247);

var _location_zoneCreate4 = _interopRequireDefault(_location_zoneCreate3);

__webpack_require__(3119);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationZoneCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _location_zoneCreate2.default,
    controller: _location_zoneCreate4.default
};

exports.default = locationZoneCreateComponent;

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _location_zoneBase = __webpack_require__(279);

var _location_zoneBase2 = _interopRequireDefault(_location_zoneBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationZoneCreateController = function (_BaseController) {
    LocationZoneCreateController.$inject = ["Auth", "$state", "User", "LocationZoneService", "Modal", "$translate", "$q", "CommonLayoutService", "UserBranchService"];
    (0, _inherits3.default)(LocationZoneCreateController, _BaseController);

    /*@ngInject*/
    function LocationZoneCreateController(Auth, $state, User, LocationZoneService, Modal, $translate, $q, CommonLayoutService, UserBranchService) {
        (0, _classCallCheck3.default)(this, LocationZoneCreateController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LocationZoneCreateController.__proto__ || (0, _getPrototypeOf2.default)(LocationZoneCreateController)).call(this, Auth, $state, User, LocationZoneService, Modal, $translate));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.Modal = Modal;
        _this.$q = $q;
        _this.LocationZoneService = LocationZoneService;
        _this.CommonLayoutService = CommonLayoutService;
        _this.UserBranchService = UserBranchService;
        _this.branch = [];

        _this.defaultModel = {
            loading: false,
            name: '',
            type: null,
            description: '',
            branchId: _this.User.getUser().branchId,
            loggedInUserId: _this.User.getUser().id
        };
        _this.model = angular.copy(_this.defaultModel);
        _this.locationZoneTypes = _this.CommonLayoutService.locationZoneTypes();
        return _this;
    }

    (0, _createClass3.default)(LocationZoneCreateController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.model.loading = true;
            this.$q.all([this.UserBranchService.getUserBranches(this.defaultModel.loggedInUserId)]).then(function (data) {
                data[0].results.map(function (b) {
                    return _this2.branch.push(b.branchId);
                });
            }).catch(function (err) {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this2.errorMessage += e.message + '<br/>';
                    });
                } else if (err && err.data && err.data.message) {
                    _this2.errorMessage = err.data.message;
                } else {
                    _this2.errorMessage = err;
                }
            }).finally(function () {
                _this2.model.loading = false;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.clearErrors();
        }
    }, {
        key: 'submit',
        value: function submit(evt) {
            var _this3 = this;

            this.loading = true;
            this.Service.create({
                name: this.model.name,
                type: this.model.type,
                description: this.model.description,
                createdByUserId: this.model.loggedInUserId,
                modifiedByUserId: this.model.loggedInUserId,
                branchId: this.model.branchId
            }).then(function (data) {
                _this3.loading = false;
                _this3.askCreate();
            }).catch(function (err) {
                _this3.loading = false;
                err.data.errors.map(function (e) {
                    _this3.errorMessage += e.message + '<br/>';
                });
            });
        }
    }]);
    return LocationZoneCreateController;
}(_location_zoneBase2.default);

exports.default = LocationZoneCreateController;

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_zoneEdit = __webpack_require__(2249);

var _location_zoneEdit2 = _interopRequireDefault(_location_zoneEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationZoneEditModule = angular.module('locationZoneEdit', []).component('locationZoneEdit', _location_zoneEdit2.default).name;

exports.default = locationZoneEditModule;

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_zoneEdit = __webpack_require__(2848);

var _location_zoneEdit2 = _interopRequireDefault(_location_zoneEdit);

var _location_zoneEdit3 = __webpack_require__(2250);

var _location_zoneEdit4 = _interopRequireDefault(_location_zoneEdit3);

__webpack_require__(3120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationZoneEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _location_zoneEdit2.default,
    controller: _location_zoneEdit4.default
};

exports.default = locationZoneEditComponent;

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _location_zoneBase = __webpack_require__(279);

var _location_zoneBase2 = _interopRequireDefault(_location_zoneBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationZoneEditController = function (_BaseController) {
    LocationZoneEditController.$inject = ["Auth", "$state", "User", "LocationZoneService", "Modal", "$translate", "$q", "$stateParams", "CommonLayoutService", "UserBranchService"];
    (0, _inherits3.default)(LocationZoneEditController, _BaseController);

    /*@ngInject*/
    function LocationZoneEditController(Auth, $state, User, LocationZoneService, Modal, $translate, $q, $stateParams, CommonLayoutService, UserBranchService) {
        (0, _classCallCheck3.default)(this, LocationZoneEditController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LocationZoneEditController.__proto__ || (0, _getPrototypeOf2.default)(LocationZoneEditController)).call(this, Auth, $state, User, LocationZoneService, Modal, $translate));

        _this.Auth = Auth;
        _this.User = User;
        _this.$state = $state;
        _this.$translate = $translate;
        _this.Modal = Modal;
        _this.$q = $q;
        _this.$stateParams = $stateParams;
        _this.CommonLayoutService = CommonLayoutService;
        _this.UserBranchService = UserBranchService;
        _this.branch = [];

        _this.model = {
            currentBranch: _this.User.getUser().branchId,
            LoggedInUser: _this.User.getUser().id,
            loading: false,
            name: null,
            description: null,
            defaultBranch: null
        };
        _this.locationZoneTypes = _this.CommonLayoutService.locationZoneTypes();
        return _this;
    }

    (0, _createClass3.default)(LocationZoneEditController, [{
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.clearErrors();
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.model.loading = true;
            this.$q.all([this.Service.get(this.$stateParams.id), this.UserBranchService.getUserBranches(this.model.LoggedInUser)]).then(function (data) {
                _this2.locationZoneObj = data[0].results;
                _this2.rawId = _this2.locationZoneObj.id;
                _this2.model.name = _this2.locationZoneObj.name;
                _this2.model.description = _this2.locationZoneObj.description;
                _this2.model.type = _this2.locationZoneObj.type;
                _this2.model.branchId = _this2.locationZoneObj.branchId;
                _this2.model.createdAt = moment(_this2.locationZoneObj.createdAt).format('DD-MM-YYYY | hh:mm A');
                _this2.model.createdByUserId = _this2.concatUserName(_this2.locationZoneObj.createdByUserId, _this2.locationZoneObj.createdByUserId ? _this2.locationZoneObj.createdByUser.firstName : null, _this2.locationZoneObj.createdByUserId ? _this2.locationZoneObj.createdByUser.lastName : null);
                _this2.model.updatedAt = moment(_this2.locationZoneObj.updatedAt).format('DD-MM-YYYY | hh:mm A');
                _this2.model.modifiedByUserId = _this2.concatUserName(_this2.locationZoneObj.modifiedByUserId, _this2.locationZoneObj.modifiedByUserId ? _this2.locationZoneObj.modifiedByUser.firstName : null, _this2.locationZoneObj.modifiedByUserId ? _this2.locationZoneObj.modifiedByUser.lastName : null);
                _this2.defaultModel = _this2.model;
                data[1].results.map(function (b) {
                    return _this2.branch.push(b.branchId);
                });
            }).catch(function (err) {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this2.errorMessage += e.message + '<br/>';
                    });
                } else if (err && err.data && err.data.message) {
                    _this2.errorMessage = err.data.message;
                } else {
                    _this2.errorMessage = err;
                }
            }).finally(function () {
                _this2.model.loading = false;
            });
        }
    }, {
        key: 'concatUserName',
        value: function concatUserName(id, firstName, lastName) {
            if (!id) return 'N/A';
            return id + ' | ' + firstName + ' ' + lastName;
        }
    }, {
        key: 'update',
        value: function update() {
            var _this3 = this;

            this.model.isUpdating = true;
            this.Service.update(this.rawId, {
                id: this.rawId,
                branchId: this.model.branchId,
                name: this.model.name,
                description: this.model.description,
                type: this.model.type,
                modifiedByUserId: this.model.LoggedInUser
            }).then(function () {
                window.history.go(-1);
            }).catch(function (err) {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map(function (e) {
                        _this3.errorMessage += e.message + '<br/>';
                    });
                } else {
                    _this3.errorMessage = err.data.message;
                }
            }).finally(function () {
                _this3.model.isUpdating = false;
            });
        }
    }]);
    return LocationZoneEditController;
}(_location_zoneBase2.default); //import AppConstant from '../../../config/app.constants';


exports.default = LocationZoneEditController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_zone = __webpack_require__(2252);

var _location_zone2 = _interopRequireDefault(_location_zone);

var _create = __webpack_require__(2245);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2248);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2242);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationZoneModule = angular.module('locationZone', [_create2.default, _edit2.default, _all2.default]).component('locationZone', _location_zone2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('location_zone.edit', {
        url: '/edit/:id',
        component: 'locationZoneEdit',
        data: {
            requireACL: 'tnt_control_location_zone.edit'
        }
    }).state('location_zone.create', {
        url: '/create',
        component: 'locationZoneCreate',
        data: {
            requireACL: 'tnt_control_location_zone.create'
        }
    }).state('location_zone.all', {
        url: '/all/:page',
        component: 'locationZoneAll',
        data: {
            requireACL: 'tnt_control_location_zone.view'
        }
    });
}]).name;

exports.default = locationZoneModule;

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _location_zone = __webpack_require__(2849);

var _location_zone2 = _interopRequireDefault(_location_zone);

var _location_zone3 = __webpack_require__(2253);

var _location_zone4 = _interopRequireDefault(_location_zone3);

__webpack_require__(3121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationZoneComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _location_zone2.default,
    controller: _location_zone4.default
};

exports.default = locationZoneComponent;

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationZoneController = function (_TNTControlBase) {
    LocationZoneController.$inject = ["$state"];
    (0, _inherits3.default)(LocationZoneController, _TNTControlBase);

    /*@ngInject*/
    function LocationZoneController($state) {
        (0, _classCallCheck3.default)(this, LocationZoneController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LocationZoneController.__proto__ || (0, _getPrototypeOf2.default)(LocationZoneController)).call(this));

        _this.$state = $state;
        _this.id = "location_zone";
        _this.acl = {};
        _this.hasACL = {};
        return _this;
    }

    (0, _createClass3.default)(LocationZoneController, [{
        key: '$onInit',
        value: function $onInit() {
            (0, _get3.default)(LocationZoneController.prototype.__proto__ || (0, _getPrototypeOf2.default)(LocationZoneController.prototype), '$onInit', this).call(this);
            for (var key in this.acl['tnt_control_' + this.id]) {
                this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
            }
        }
    }]);
    return LocationZoneController;
}(_TNTControlBase3.default);

exports.default = LocationZoneController;

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messageAll = __webpack_require__(2255);

var _messageAll2 = _interopRequireDefault(_messageAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messageallModule = angular.module('messageall', []).component('messageall', _messageAll2.default).name;

exports.default = messageallModule;

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messageAll = __webpack_require__(2850);

var _messageAll2 = _interopRequireDefault(_messageAll);

var _messageAll3 = __webpack_require__(2256);

var _messageAll4 = _interopRequireDefault(_messageAll3);

__webpack_require__(3122);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messageallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _messageAll2.default,
  controller: _messageAll4.default
};

exports.default = messageallComponent;

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _messageBase = __webpack_require__(280);

var _messageBase2 = _interopRequireDefault(_messageBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageallController = function (_MessageBaseControlle) {
  MessageallController.$inject = ["Auth", "$state", "$stateParams", "User", "UserService", "MessageService", "$translate", "Modal", "$location"];
  (0, _inherits3.default)(MessageallController, _MessageBaseControlle);

  /*@ngInject*/
  function MessageallController(Auth, $state, $stateParams, User, UserService, MessageService, $translate, Modal, $location) {
    (0, _classCallCheck3.default)(this, MessageallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MessageallController.__proto__ || (0, _getPrototypeOf2.default)(MessageallController)).call(this, Auth, $state, User, MessageService, Modal, $translate, $stateParams, $location));

    _this.message = 'Message all';

    _this.hasAcl = {};

    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.searchText = null;
    _this.$location = $location;
    _this.loggedInUser = _this.User.getUser();
    _this.Modal = Modal;
    _this.msgsOf = 'all';
    _this.messages = [];
    _this.duplicateMsgs = [];
    _this.pendingMegs = [];

    _this.types = ['M', 'T', 'R', 'SM', 'NP', 'UI', 'H', 'D_R', 'CNT', 'D_CNT', 'NDR', 'IM', 'DS'];
    _this.messageType = null;
    _this.messageTypes = _this.types.map(function (messageType) {
      return {
        value: messageType,
        label: $translate.instant('message.types.' + messageType)
      };
    });
    _this.branchId = _this.User.getUser().branchId;
    _this.model = {
      searchText: null,
      languageId: null,
      loadBuckets: false,
      errorMessage: null,
      buckets: [],
      languageList: {
        english: 'E',
        spanish: 'S'
      },
      stats: 'E',
      messageTypeList: {},
      bucketList: {
        'M': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'T': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'R': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'SM': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'NP': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'UI': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'H': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'D_R': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'CNT': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'D_CNT': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'NDR': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'IM': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        },
        'DS': {
          results: [],
          loading: false,
          totalRecords: 0,
          searchKey: null,
          errorMessage: null,
          pagination: {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
          }
        }
      }
    };
    _this.stats = {
      english: 'E',
      spanish: 'S'
    };
    _this.model.selectedLanguage = _this.loggedInUser.languageId === "E" ? _this.model.languageList.english : _this.model.languageList.spanish;
    return _this;
  }

  (0, _createClass3.default)(MessageallController, [{
    key: '$onInit',
    value: function $onInit() {
      this.loadData();
    }
  }, {
    key: 'delete',
    value: function _delete(messagesObj, bucketObj) {
      var _this2 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      var lang = messagesObj.languageName;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + messagesObj.messageId + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          var langId = messagesObj.languageId;
          _this2.Service.remove(langId, messagesObj.id, messagesObj.messageId, messagesObj.type, _this2.branchId).then(function (data) {
            _this2.allowOnlyOnce = false;
            modal.close();
            _this2.searchLanguageMessages(bucketObj).then(function () {
              var buckets = _.find(_this2.model.buckets.results, { 'messageType': messagesObj.type });
              buckets.total = _this2.model.bucketList[bucketObj.messageType].totalRecords;
            });
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this2.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'tabSelection',
    value: function tabSelection(selectedValue) {
      this.model.stats = selectedValue;
      this.model.selectedLanguage = selectedValue;
      var id = selectedValue === 'english' ? 'english' : 'spanish';
      document.getElementById(id).blur();
      this.loadData();
    }
  }, {
    key: 'getMessageTypeBuckets',
    value: function getMessageTypeBuckets() {
      var _this3 = this;

      this.model.loadBuckets = true;
      this.Service.getMessageTypeBuckets(this.model.serchText, this.model.selectedLanguage).then(function (data) {
        _this3.model.buckets = data;
      }).catch(function (err) {
        _this3.model.errorMessage = err.data.message;
      }).finally(function () {
        _this3.model.loadBuckets = false;
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      this.resetSeachText();
      this.getMessageTypeBuckets();
    }
  }, {
    key: 'translateMessageType',
    value: function translateMessageType(messageType) {
      if (!messageType) return;
      return this.$translate.instant('message.types.' + messageType);
    }
  }, {
    key: 'setPage',
    value: function setPage(isExpanded, messageType) {
      if (!isExpanded) return;
      this.model.messageTypeList[messageType] = { page: 1 };
    }
  }, {
    key: 'getLanguageMessages',
    value: function getLanguageMessages(obj) {
      var _this4 = this;

      if (!obj.bucketExpanded) {
        this.model.bucketList[obj.messageType].searchKey = null;
        return;
      }

      this.model.bucketList[obj.messageType].loading = true;

      return this.Service.getLanguageMessages(this.model.bucketList[obj.messageType].searchKey, this.model.selectedLanguage, obj.messageType, this.model.bucketList[obj.messageType].pagination.pageLimit, (this.model.messageTypeList[obj.messageType].page - 1) * this.model.bucketList[obj.messageType].pagination.pageLimit).then(function (data) {
        _this4.model.bucketList[obj.messageType].results = data.results;
        _this4.model.bucketList[obj.messageType].totalRecords = data.total;
      }).catch(function (err) {
        _this4.model.bucketList[obj.messageType].errorMessage = err.data.message;
      }).finally(function () {
        _this4.model.bucketList[obj.messageType].loading = false;
        setTimeout(function () {
          var el = document.getElementById(obj.messageType + '-bucketSearch');
          if (el) el.focus();
        }, 100);
      });
    }
  }, {
    key: 'searchLanguageMessages',
    value: function searchLanguageMessages(obj) {
      this.model.messageTypeList[obj.messageType].page = 1;
      return this.getLanguageMessages(obj);
    }
  }, {
    key: 'pageChange',
    value: function pageChange(obj) {
      this.getLanguageMessages(obj);
    }
  }, {
    key: 'resetSeachText',
    value: function resetSeachText() {
      var _this5 = this;

      this.types.forEach(function (messageType) {
        return messageType && _this5.model.bucketList[messageType] ? _this5.model.bucketList[messageType].searchKey = null : void undefined;
      });
    }
  }, {
    key: 'updateLanguageMessageModal',
    value: function updateLanguageMessageModal(messagesObj, bucketObj) {
      var _this6 = this;

      this.Modal.translateMessage(messagesObj.messageId, messagesObj.type, function (_ref3) {
        var updatedMessages = _ref3.updatedMessages,
            modal = _ref3.modal;

        _this6.Service.updateLanguageMessage(messagesObj.languageId, updatedMessages).then(function () {
          _this6.getLanguageMessages(bucketObj);
          modal.close();
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            errorModal(err.data.message);
          }
        });
        modal.close();
      }, function (_ref4) {
        var modal = _ref4.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'createLanguageMessage',
    value: function createLanguageMessage(bucketObj) {
      var _this7 = this;

      this.Modal.createLanguageMessage(bucketObj, this.messageTypes, this.model.selectedLanguage, bucketObj.messageType, function (_ref5) {
        var modal = _ref5.modal;

        var buckets = _.find(_this7.model.buckets.results, { 'messageType': bucketObj.messageType });
        if (bucketObj.bucketExpanded) {
          _this7.getLanguageMessages(bucketObj).then(function () {
            buckets.total = _this7.model.bucketList[bucketObj.messageType].totalRecords;
            modal.close();
          });
        } else {
          buckets.total = buckets.total + 1;
          modal.close();
        }
      }, function (_ref6) {
        var modal = _ref6.modal;

        if (modal) modal.close();
      });
    }
  }]);
  return MessageallController;
}(_messageBase2.default);

exports.default = MessageallController;

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messageCreate = __webpack_require__(2258);

var _messageCreate2 = _interopRequireDefault(_messageCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messageCreateModule = angular.module('messagecreate', []).component('messagecreate', _messageCreate2.default).name;

exports.default = messageCreateModule;

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messageCreate = __webpack_require__(2851);

var _messageCreate2 = _interopRequireDefault(_messageCreate);

var _messageCreate3 = __webpack_require__(2259);

var _messageCreate4 = _interopRequireDefault(_messageCreate3);

__webpack_require__(3123);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messageCreateComponent = {
  restrict: 'E',
  bindings: {},
  template: _messageCreate2.default,
  controller: _messageCreate4.default
};

exports.default = messageCreateComponent;

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _messageBase = __webpack_require__(280);

var _messageBase2 = _interopRequireDefault(_messageBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageCreateController = function (_MessageBaseControlle) {
  MessageCreateController.$inject = ["Auth", "$state", "User", "MessageService", "Modal", "$translate", "$stateParams", "UserService", "LanguageService"];
  (0, _inherits3.default)(MessageCreateController, _MessageBaseControlle);

  /*@ngInject*/
  function MessageCreateController(Auth, $state, User, MessageService, Modal, $translate, $stateParams, UserService, LanguageService) {
    (0, _classCallCheck3.default)(this, MessageCreateController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MessageCreateController.__proto__ || (0, _getPrototypeOf2.default)(MessageCreateController)).call(this, Auth, $state, User, MessageService, Modal, $translate, $stateParams));

    _this.LanguageService = LanguageService;

    _this.message = 'Message create';
    _this.languages = [];
    _this.messageTypes = [];
    _this.loggedInUser = _this.User.getUser();

    _this.loading = false;

    _this.model = {
      defaultSelection: false
    };
    _this.branchId = _this.User.getUser().branchId;

    return _this;
  }

  (0, _createClass3.default)(MessageCreateController, [{
    key: 'reset',
    value: function reset() {
      for (var key in this.model) {
        this.model[key] = "";
        this.clearErrors();
      }
      this.model.description = {};
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      // this.reset();
      this.model.description = {};
      this.LanguageService.all().then(function (response) {
        _this2.languages = response.results;

        _this2.languages.map(function (language) {
          _this2.model.description[language.id] = '';
        });
      });

      this.types = ['M', 'T', 'R', 'SM', 'NP', 'UI', 'H', 'D_R', 'CNT', 'D_CNT', 'NDR', 'IM', 'DS'];
      this.messageTypes = this.types.map(function (type) {
        return {
          label: type + ' | ' + _this2.$translate.instant('message.types.' + type),
          value: type
        };
      });
    }
  }, {
    key: 'submit',
    value: function submit() {
      var _this3 = this;

      this.loading = true;

      this.Service.create(this.loggedInUser.languageId, this.model, this.branchId).then(function (response) {
        _this3.askCreate();
      }).catch(function (err) {
        if (err && err.data && err.data.errors && err.data.errors.length) {
          err.data.errors.map(function (e) {
            _this3.errorMessage += e.message + '<br/>';
          });
        } else {
          console.error(err);
        }
      }).finally(function () {
        _this3.loading = false;
      });
    }
  }]);
  return MessageCreateController;
}(_messageBase2.default);

exports.default = MessageCreateController;

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _duplicate_message = __webpack_require__(2852);

var _duplicate_message2 = _interopRequireDefault(_duplicate_message);

var _duplicate_message3 = __webpack_require__(2261);

var _duplicate_message4 = _interopRequireDefault(_duplicate_message3);

__webpack_require__(3124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var duplicateMessageComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _duplicate_message2.default,
  controller: _duplicate_message4.default
};

exports.default = duplicateMessageComponent;

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var duplicateMessageController = function () {
  /*@ngInject*/
  duplicateMessageController.$inject = ["Auth", "$state", "$stateParams", "User", "MessageService", "$translate", "Modal"];
  function duplicateMessageController(Auth, $state, $stateParams, User, MessageService, $translate, Modal) {
    (0, _classCallCheck3.default)(this, duplicateMessageController);


    this.hasAcl = {};
    this.Auth = Auth;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.User = User;
    this.MessageService = MessageService;
    this.$translate = $translate;
    this.page = 1;
    this.total = 0;
    this.pageLimit = 10;
    this.maxPages = 10;
    this.searchText = null;
    this.loggedInUser = this.User.getUser();
    this.Modal = Modal;
    this.messages = [];
    this.duplicateMsgs = [];
    this.pendingMegs = [];
    this.branchId = this.User.getUser().branchId;

    this.types = ['M', 'T', 'R', 'SM', 'NP', 'UI', 'H', 'D_R', 'CNT', 'D_CNT', 'NDR', 'IM', 'DS'];
    this.messageType = null;
    this.messageTypes = this.types.map(function (messageType) {
      return {
        value: messageType,
        label: $translate.instant('message.types.' + messageType)
      };
    });

    this.model = {
      languageList: {
        english: 'E',
        spanish: 'S'
      },
      stats: 'E'
    };
    this.model.selectedLanguage = this.loggedInUser.languageId === "E" ? this.model.languageList.english : this.model.languageList.spanish;
    this.stats = {
      english: 'E',
      spanish: 'S'
    };
  }

  (0, _createClass3.default)(duplicateMessageController, [{
    key: '$onInit',
    value: function $onInit() {
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      this.duplicateMsgList();
    }
  }, {
    key: 'duplicateMsgList',
    value: function duplicateMsgList() {
      var _this = this;

      this.loading = true;
      this.MessageService.getDuplicateMsg(this.model.selectedLanguage, this.searchText, this.messageType, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this.duplicateMsgs = data.results;
        _this.totalDuplicateRecords = data.total;
      }).catch(function (err) {
        _this.error = err.data.message;
      }).finally(function () {
        _this.loading = false;
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.duplicateMsgList();
    }
  }, {
    key: 'tabSelection',
    value: function tabSelection(selectedValue) {
      this.model.stats = selectedValue;
      this.model.selectedLanguage = selectedValue;
      var id = selectedValue === 'english' ? 'english' : 'spanish';
      document.getElementById(id).blur();
      this.loadData();
    }
  }, {
    key: 'updateLanguageMessageModal',
    value: function updateLanguageMessageModal(messagesObj) {
      var _this2 = this;

      this.Modal.translateMessage(messagesObj.messageId, messagesObj.type, function (_ref) {
        var updatedMessages = _ref.updatedMessages,
            modal = _ref.modal;

        _this2.MessageService.updateLanguageMessage(_this2.model.selectedLanguage, updatedMessages).then(function () {
          _this2.page = 1;
          _this2.refresh();
          modal.close();
        }).catch(function (err) {
          if (err && err.data && err.data.message) {
            errorModal(err.data.message);
          }
        });
        modal.close();
      }, function (_ref2) {
        var modal = _ref2.modal;

        if (modal) modal.close();
      });
    }
  }, {
    key: 'translateMessageType',
    value: function translateMessageType(messageType) {
      if (!messageType) return;
      return this.$translate.instant('message.types.' + messageType);
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      this.duplicateMsgList();
    }
  }]);
  return duplicateMessageController;
}();

exports.default = duplicateMessageController;

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _duplicate_message = __webpack_require__(2260);

var _duplicate_message2 = _interopRequireDefault(_duplicate_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var duplicateMessageModule = angular.module('duplicateMessage', []).component('duplicateMessage', _duplicate_message2.default).name;

exports.default = duplicateMessageModule;

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messageEdit = __webpack_require__(2264);

var _messageEdit2 = _interopRequireDefault(_messageEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messageEditModule = angular.module('messageedit', []).component('messageedit', _messageEdit2.default).name;

exports.default = messageEditModule;

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messageEdit = __webpack_require__(2853);

var _messageEdit2 = _interopRequireDefault(_messageEdit);

var _messageEdit3 = __webpack_require__(2265);

var _messageEdit4 = _interopRequireDefault(_messageEdit3);

__webpack_require__(3125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messageEditComponent = {
  restrict: 'E',
  bindings: {},
  template: _messageEdit2.default,
  controller: _messageEdit4.default
};

exports.default = messageEditComponent;

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _messageBase = __webpack_require__(280);

var _messageBase2 = _interopRequireDefault(_messageBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageEditController = function (_MessageBaseControlle) {
  MessageEditController.$inject = ["Auth", "$state", "User", "MessageService", "Modal", "$translate", "$stateParams", "UserService"];
  (0, _inherits3.default)(MessageEditController, _MessageBaseControlle);

  /*@ngInject*/
  function MessageEditController(Auth, $state, User, MessageService, Modal, $translate, $stateParams, UserService) {
    (0, _classCallCheck3.default)(this, MessageEditController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MessageEditController.__proto__ || (0, _getPrototypeOf2.default)(MessageEditController)).call(this, Auth, $state, User, MessageService, Modal, $translate, $stateParams));

    _this.message = 'Message create';
    _this.languages = [];
    _this.messageTypes = [];
    _this.loggedInUser = _this.User.getUser();
    _this.$translate = $translate;

    _this.loading = false;

    _this.model = {};
    _this.branchId = _this.User.getUser().branchId;

    return _this;
  }

  (0, _createClass3.default)(MessageEditController, [{
    key: 'reset',
    value: function reset() {
      this.$onInit();
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.Service.get(this.loggedInUser.languageId, this.$stateParams.id).then(function (response) {
        _this2.model = response;
      }).catch(function (err) {
        console.log(err);
      });

      this.types = ['M', 'T', 'R', 'SM', 'NP', 'UI', 'H'];
      this.messageTypes = this.types.map(function (type) {
        return {
          label: type + ' | ' + _this2.$translate.instant('message.types.' + type),
          value: type
        };
      });
    }
  }, {
    key: 'submit',
    value: function submit() {
      var _this3 = this;

      this.loading = true;

      this.Service.update(this.loggedInUser.languageId, this.model.id, this.model, this.branchId).then(function (response) {
        window.history.go(-1);
      }).catch(function (err) {
        if (err && err.data && err.data.errors && err.data.errors.length) {
          err.data.errors.map(function (e) {
            _this3.errorMessage += e.message + '<br/>';
          });
        } else {
          console.error(err);
        }
      }).finally(function () {
        _this3.loading = false;
      });
    }
  }]);
  return MessageEditController;
}(_messageBase2.default);

exports.default = MessageEditController;

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _message = __webpack_require__(2267);

var _message2 = _interopRequireDefault(_message);

var _all = __webpack_require__(2254);

var _all2 = _interopRequireDefault(_all);

var _create = __webpack_require__(2257);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2263);

var _edit2 = _interopRequireDefault(_edit);

var _duplicate_message = __webpack_require__(2262);

var _duplicate_message2 = _interopRequireDefault(_duplicate_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messageModule = angular.module('message', [_all2.default, _create2.default, _edit2.default, _duplicate_message2.default]).component('message', _message2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('message.all', {
    url: '/all/:page',
    component: 'messageall'
  }).state('message.create', {
    url: '/create',
    component: 'messagecreate'
  }).state('message.edit', {
    url: '/edit/:id',
    component: 'messageedit'
  }).state('message.duplicateMessage', {
    url: '/duplicate-message',
    component: 'duplicateMessage'
  });
}]).name;

exports.default = messageModule;

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _message = __webpack_require__(2854);

var _message2 = _interopRequireDefault(_message);

var _message3 = __webpack_require__(2268);

var _message4 = _interopRequireDefault(_message3);

__webpack_require__(3126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messageComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '=',
    acl: '='
  },
  template: _message2.default,
  controller: _message4.default
};

exports.default = messageComponent;

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageController = function (_TNTControlBase) {
  MessageController.$inject = ["$state"];
  (0, _inherits3.default)(MessageController, _TNTControlBase);

  /*@ngInject*/
  function MessageController($state) {
    (0, _classCallCheck3.default)(this, MessageController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MessageController.__proto__ || (0, _getPrototypeOf2.default)(MessageController)).call(this));

    _this.id = 'message';
    _this.$state = $state;
    _this.acl = {};
    _this.hasACL = {};
    return _this;
  }

  (0, _createClass3.default)(MessageController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(MessageController.prototype.__proto__ || (0, _getPrototypeOf2.default)(MessageController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_control_' + this.id]) {
        this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
      }
    }
  }]);
  return MessageController;
}(_TNTControlBase3.default);

exports.default = MessageController;

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mobile_appAll = __webpack_require__(2270);

var _mobile_appAll2 = _interopRequireDefault(_mobile_appAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mobileAppAllModule = angular.module('mobileAppAll', []).component('mobileAppAll', _mobile_appAll2.default).name;

exports.default = mobileAppAllModule;

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mobile_appAll = __webpack_require__(2855);

var _mobile_appAll2 = _interopRequireDefault(_mobile_appAll);

var _mobile_appAll3 = __webpack_require__(2271);

var _mobile_appAll4 = _interopRequireDefault(_mobile_appAll3);

__webpack_require__(3127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mobileAppAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template: _mobile_appAll2.default,
    controller: _mobile_appAll4.default
};

exports.default = mobileAppAllComponent;

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileAppAllController = function () {
    /*@ngInject*/

    MobileAppAllController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "BranchService", "$q", "$scope", "MobileAppService"];
    function MobileAppAllController(Auth, $state, User, Modal, $translate, BranchService, $q, $scope, MobileAppService) {
        (0, _classCallCheck3.default)(this, MobileAppAllController);

        this.MobileAppService = MobileAppService;
        this.apps = [];
    }

    (0, _createClass3.default)(MobileAppAllController, [{
        key: "$onInit",
        value: function $onInit() {
            this.loadData();
        }
    }, {
        key: "loadData",
        value: function loadData() {
            var _this = this;

            this.loading = true;
            this.MobileAppService.getAll().then(function (data) {
                _this.apps = data;
                _this.loading = false;
                if (_this.apps && _this.apps.android) {
                    _this.androidData = _this.apps.android;
                }
                // if (this.apps && this.apps.ios) {
                //     this.iosData = this.apps.ios;
                // }
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this.loading = false;
            });
        }
    }]);
    return MobileAppAllController;
}();

exports.default = MobileAppAllController;

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mobile_appCreate = __webpack_require__(2273);

var _mobile_appCreate2 = _interopRequireDefault(_mobile_appCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mobileAppCreateModule = angular.module('mobileAppCreate', []).component('mobileAppCreate', _mobile_appCreate2.default).name;

exports.default = mobileAppCreateModule;

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mobile_appCreate = __webpack_require__(2856);

var _mobile_appCreate2 = _interopRequireDefault(_mobile_appCreate);

var _mobile_appCreate3 = __webpack_require__(2274);

var _mobile_appCreate4 = _interopRequireDefault(_mobile_appCreate3);

__webpack_require__(3128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mobileAppCreateComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template: _mobile_appCreate2.default,
    controller: _mobile_appCreate4.default
};

exports.default = mobileAppCreateComponent;

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileAppCreateController = function () {
    /*@ngInject*/
    MobileAppCreateController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "BranchService", "$q", "$scope", "MobileAppService"];
    function MobileAppCreateController(Auth, $state, User, Modal, $translate, BranchService, $q, $scope, MobileAppService) {
        (0, _classCallCheck3.default)(this, MobileAppCreateController);

        this.MobileAppService = MobileAppService;
        this.User = User;

        this.model = {
            platform: 'android',
            version: '',
            downloadLink: '',
            branchId: User.getUser().branchId
        };
    }

    (0, _createClass3.default)(MobileAppCreateController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'submit',
        value: function submit() {
            var _this = this;

            this.loading = true;
            this.MobileAppService.saveApp({
                platform: this.model.platform,
                version: this.model.version,
                downloadLink: this.model.downloadLink,
                branchId: this.model.branchId
            }).then(function (data) {
                _this.loading = false;
                window.history.go(-1);
            }).catch(function (err) {
                console.log(err);
            }).finally(function () {
                _this.loading = false;
            });
        }
    }]);
    return MobileAppCreateController;
}();

exports.default = MobileAppCreateController;

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mobile_app = __webpack_require__(2276);

var _mobile_app2 = _interopRequireDefault(_mobile_app);

var _all = __webpack_require__(2269);

var _all2 = _interopRequireDefault(_all);

var _create = __webpack_require__(2272);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mobileAppModule = angular.module('mobileApp', [_all2.default, _create2.default]).component('mobileApp', _mobile_app2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('mobile_app.all', {
        url: '/all/:page',
        component: 'mobileAppAll',
        data: {
            requireACL: 'tnt_control_mobile_app.view'
        }
    }).state('mobile_app.create', {
        url: '/create',
        component: 'mobileAppCreate',
        data: {
            requireACL: 'tnt_control_mobile_app.create'
        }
    });
}]).name;

exports.default = mobileAppModule;

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mobile_app = __webpack_require__(2857);

var _mobile_app2 = _interopRequireDefault(_mobile_app);

var _mobile_app3 = __webpack_require__(2277);

var _mobile_app4 = _interopRequireDefault(_mobile_app3);

__webpack_require__(3129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mobileAppComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _mobile_app2.default,
    controller: _mobile_app4.default
};

exports.default = mobileAppComponent;

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileAppController = function (_TNTControlBase) {
  MobileAppController.$inject = ["$state"];
  (0, _inherits3.default)(MobileAppController, _TNTControlBase);

  /*@ngInject*/
  function MobileAppController($state) {
    (0, _classCallCheck3.default)(this, MobileAppController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MobileAppController.__proto__ || (0, _getPrototypeOf2.default)(MobileAppController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'mobile_app';
    _this.$state = $state;
    _this.hasACL = {};
    return _this;
  }

  (0, _createClass3.default)(MobileAppController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(MobileAppController.prototype.__proto__ || (0, _getPrototypeOf2.default)(MobileAppController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_control_' + this.id]) {
        this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
      }
    }
  }]);
  return MobileAppController;
}(_TNTControlBase3.default);

exports.default = MobileAppController;

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notification_managementAll = __webpack_require__(2279);

var _notification_managementAll2 = _interopRequireDefault(_notification_managementAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementAllModule = angular.module('notificationManagementAll', []).component('notificationManagementAll', _notification_managementAll2.default).name;

exports.default = NotificationManagementAllModule;

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification_managementAll = __webpack_require__(2858);

var _notification_managementAll2 = _interopRequireDefault(_notification_managementAll);

var _notification_managementAll3 = __webpack_require__(2280);

var _notification_managementAll4 = _interopRequireDefault(_notification_managementAll3);

__webpack_require__(3130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementAllComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _notification_managementAll2.default,
  controller: _notification_managementAll4.default
};

exports.default = NotificationManagementAllComponent;

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _notification_managementBase = __webpack_require__(281);

var _notification_managementBase2 = _interopRequireDefault(_notification_managementBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementAllController = function (_NotificationManageme) {
    NotificationManagementAllController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "$stateParams", "$location"];
    (0, _inherits3.default)(NotificationManagementAllController, _NotificationManageme);

    /*@ngInject*/
    function NotificationManagementAllController(Auth, $state, User, Modal, $translate, $stateParams, $location) {
        (0, _classCallCheck3.default)(this, NotificationManagementAllController);

        // super(Auth, $state, User, NotificationManagementService, Modal, $translate, $stateParams, $location)
        var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationManagementAllController.__proto__ || (0, _getPrototypeOf2.default)(NotificationManagementAllController)).call(this));

        _this.hasAcl = {};
        _this.$stateParams = $stateParams;
        _this.User = User;
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(NotificationManagementAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var pageId = this.$stateParams.page;
            if (pageId > 0) {
                this.page = pageId;
            }
        }
    }, {
        key: 'edit',
        value: function edit(notification_management) {
            this.$state.go('notification_management.edit', {
                id: notification_management.id
            });
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.loadData();
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'search',
        value: function search() {
            this.page = 1;
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'loadData',
        value: function loadData() {}
    }]);
    return NotificationManagementAllController;
}(_notification_managementBase2.default);

exports.default = NotificationManagementAllController;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification_managementCreate = __webpack_require__(2282);

var _notification_managementCreate2 = _interopRequireDefault(_notification_managementCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementCreateModule = angular.module('notificationManagementCreate', []).component('notificationManagementCreate', _notification_managementCreate2.default).name;

exports.default = NotificationManagementCreateModule;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification_managementCreate = __webpack_require__(2859);

var _notification_managementCreate2 = _interopRequireDefault(_notification_managementCreate);

var _notification_managementCreate3 = __webpack_require__(2283);

var _notification_managementCreate4 = _interopRequireDefault(_notification_managementCreate3);

__webpack_require__(3131);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementCreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _notification_managementCreate2.default,
  controller: _notification_managementCreate4.default
};

exports.default = NotificationManagementCreateComponent;

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _notification_managementBase = __webpack_require__(281);

var _notification_managementBase2 = _interopRequireDefault(_notification_managementBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementCreateController = function (_NotificationManageme) {
    NotificationManagementCreateController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "$stateParams", "$q"];
    (0, _inherits3.default)(NotificationManagementCreateController, _NotificationManageme);

    /*@ngInject*/
    function NotificationManagementCreateController(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        (0, _classCallCheck3.default)(this, NotificationManagementCreateController);

        // super(Auth, $state, User, NotificationManagementService, Modal, $translate, $stateParams)
        var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationManagementCreateController.__proto__ || (0, _getPrototypeOf2.default)(NotificationManagementCreateController)).call(this));

        _this.$q = $q;
        _this.User = User;
        _this.hasACL = {};

        _this.defaultModel = {};
        _this.loading = false;
        _this.model = angular.copy(_this.defaultModel);
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(NotificationManagementCreateController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.clearErrors();
        }
    }, {
        key: 'submit',
        value: function submit() {}
    }]);
    return NotificationManagementCreateController;
}(_notification_managementBase2.default);

exports.default = NotificationManagementCreateController;

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification_managementEdit = __webpack_require__(2285);

var _notification_managementEdit2 = _interopRequireDefault(_notification_managementEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementEditModule = angular.module('notificationManagementEdit', []).component('notificationManagementEdit', _notification_managementEdit2.default).name;

exports.default = NotificationManagementEditModule;

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification_managementEdit = __webpack_require__(2860);

var _notification_managementEdit2 = _interopRequireDefault(_notification_managementEdit);

var _notification_managementEdit3 = __webpack_require__(2286);

var _notification_managementEdit4 = _interopRequireDefault(_notification_managementEdit3);

__webpack_require__(3132);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementEditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _notification_managementEdit2.default,
  controller: _notification_managementEdit4.default
};

exports.default = NotificationManagementEditComponent;

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _notification_managementBase = __webpack_require__(281);

var _notification_managementBase2 = _interopRequireDefault(_notification_managementBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notificationManagementEditController = function (_NotificationManageme) {
    notificationManagementEditController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "$stateParams", "$q"];
    (0, _inherits3.default)(notificationManagementEditController, _NotificationManageme);

    /*@ngInject*/
    function notificationManagementEditController(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        (0, _classCallCheck3.default)(this, notificationManagementEditController);

        // super(Auth, $state, User, NotificationManagementService, Modal, $translate, $stateParams)
        var _this = (0, _possibleConstructorReturn3.default)(this, (notificationManagementEditController.__proto__ || (0, _getPrototypeOf2.default)(notificationManagementEditController)).call(this));

        _this.$stateParams = $stateParams;
        _this.$q = $q;
        _this.User = User;
        _this.hasACL = {};
        _this.rawId = '';

        _this.defaultModel = {};
        _this.loading = false;
        _this.model = angular.copy(_this.defaultModel);
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(notificationManagementEditController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'reset',
        value: function reset() {}
    }, {
        key: 'submit',
        value: function submit() {}
    }]);
    return notificationManagementEditController;
}(_notification_managementBase2.default);

exports.default = notificationManagementEditController;

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification_management = __webpack_require__(2288);

var _notification_management2 = _interopRequireDefault(_notification_management);

var _create = __webpack_require__(2281);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2284);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2278);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementModule = angular.module('notificationManagement', [_create2.default, _edit2.default, _all2.default]).component('notificationManagement', _notification_management2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('notification_management.edit', {
    url: '/edit/:id',
    component: 'notificationManagementEdit',
    data: {
      requireACL: 'tnt_control_notification_management.edit'
    }
  }).state('notification_management.create', {
    url: '/create',
    component: 'notificationManagementCreate',
    data: {
      requireACL: 'tnt_control_notification_management.create'
    }
  }).state('notification_management.all', {
    url: '/all/:page',
    component: 'notificationManagementAll',
    data: {
      requireACL: 'tnt_control_notification_management.view'
    }
  });
}]).name;

exports.default = NotificationManagementModule;

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification_management = __webpack_require__(2861);

var _notification_management2 = _interopRequireDefault(_notification_management);

var _notification_management3 = __webpack_require__(2289);

var _notification_management4 = _interopRequireDefault(_notification_management3);

__webpack_require__(3133);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _notification_management2.default,
  controller: _notification_management4.default
};

exports.default = NotificationManagementComponent;

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationManagementController = function (_TNTControlBase) {
  NotificationManagementController.$inject = ["$state"];
  (0, _inherits3.default)(NotificationManagementController, _TNTControlBase);

  /*@ngInject*/
  function NotificationManagementController($state) {
    (0, _classCallCheck3.default)(this, NotificationManagementController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationManagementController.__proto__ || (0, _getPrototypeOf2.default)(NotificationManagementController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'notification_management';
    _this.$state = $state;

    return _this;
  }

  (0, _createClass3.default)(NotificationManagementController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(NotificationManagementController.prototype.__proto__ || (0, _getPrototypeOf2.default)(NotificationManagementController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_control_' + this.id]) {
        this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
      }
    }
  }]);
  return NotificationManagementController;
}(_TNTControlBase3.default);

exports.default = NotificationManagementController;

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _service_assignment_rulesAll = __webpack_require__(2291);

var _service_assignment_rulesAll2 = _interopRequireDefault(_service_assignment_rulesAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesAllModule = angular.module('serviceAssignmentRulesAll', []).component('serviceAssignmentRulesAll', _service_assignment_rulesAll2.default).name;

exports.default = ServiceAssignmentRulesAllModule;

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service_assignment_rulesAll = __webpack_require__(2862);

var _service_assignment_rulesAll2 = _interopRequireDefault(_service_assignment_rulesAll);

var _service_assignment_rulesAll3 = __webpack_require__(2292);

var _service_assignment_rulesAll4 = _interopRequireDefault(_service_assignment_rulesAll3);

__webpack_require__(3134);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesAllComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _service_assignment_rulesAll2.default,
  controller: _service_assignment_rulesAll4.default
};

exports.default = ServiceAssignmentRulesAllComponent;

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _service_assignment_rulesBase = __webpack_require__(282);

var _service_assignment_rulesBase2 = _interopRequireDefault(_service_assignment_rulesBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesAllController = function (_ServiceAssignmentRul) {
    ServiceAssignmentRulesAllController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "$stateParams", "$location"];
    (0, _inherits3.default)(ServiceAssignmentRulesAllController, _ServiceAssignmentRul);

    /*@ngInject*/
    function ServiceAssignmentRulesAllController(Auth, $state, User, Modal, $translate, $stateParams, $location) {
        (0, _classCallCheck3.default)(this, ServiceAssignmentRulesAllController);

        // super(Auth, $state, User, ServiceAssignmentRulesService, Modal, $translate, $stateParams, $location)
        var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceAssignmentRulesAllController.__proto__ || (0, _getPrototypeOf2.default)(ServiceAssignmentRulesAllController)).call(this));

        _this.hasAcl = {};
        _this.$stateParams = $stateParams;
        _this.User = User;
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(ServiceAssignmentRulesAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var pageId = this.$stateParams.page;
            if (pageId > 0) {
                this.page = pageId;
            }
        }
    }, {
        key: 'edit',
        value: function edit(service_assignment_rules) {
            this.$state.go('service_assignment_rules.edit', {
                id: service_assignment_rules.id
            });
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.loadData();
        }
    }, {
        key: 'pageChange',
        value: function pageChange() {
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'search',
        value: function search() {
            this.page = 1;
            var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
            this.$stateParams.page = this.page;
            this.$location.path(newUrl);
            this.loadData();
        }
    }, {
        key: 'loadData',
        value: function loadData() {}
    }]);
    return ServiceAssignmentRulesAllController;
}(_service_assignment_rulesBase2.default);

exports.default = ServiceAssignmentRulesAllController;

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service_assignment_rulesCreate = __webpack_require__(2294);

var _service_assignment_rulesCreate2 = _interopRequireDefault(_service_assignment_rulesCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesCreateModule = angular.module('serviceAssignmentRulesCreate', []).component('serviceAssignmentRulesCreate', _service_assignment_rulesCreate2.default).name;

exports.default = ServiceAssignmentRulesCreateModule;

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service_assignment_rulesCreate = __webpack_require__(2863);

var _service_assignment_rulesCreate2 = _interopRequireDefault(_service_assignment_rulesCreate);

var _service_assignment_rulesCreate3 = __webpack_require__(2295);

var _service_assignment_rulesCreate4 = _interopRequireDefault(_service_assignment_rulesCreate3);

__webpack_require__(3135);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesCreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _service_assignment_rulesCreate2.default,
  controller: _service_assignment_rulesCreate4.default
};

exports.default = ServiceAssignmentRulesCreateComponent;

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _service_assignment_rulesBase = __webpack_require__(282);

var _service_assignment_rulesBase2 = _interopRequireDefault(_service_assignment_rulesBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesCreateController = function (_ServiceAssignmentRul) {
    ServiceAssignmentRulesCreateController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "$stateParams", "$q"];
    (0, _inherits3.default)(ServiceAssignmentRulesCreateController, _ServiceAssignmentRul);

    /*@ngInject*/
    function ServiceAssignmentRulesCreateController(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        (0, _classCallCheck3.default)(this, ServiceAssignmentRulesCreateController);

        // super(Auth, $state, User, ServiceAssignmentRulesService, Modal, $translate, $stateParams)
        var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceAssignmentRulesCreateController.__proto__ || (0, _getPrototypeOf2.default)(ServiceAssignmentRulesCreateController)).call(this));

        _this.$q = $q;
        _this.User = User;
        _this.hasACL = {};

        _this.defaultModel = {};
        _this.loading = false;
        _this.model = angular.copy(_this.defaultModel);
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(ServiceAssignmentRulesCreateController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'reset',
        value: function reset() {
            this.model = angular.copy(this.defaultModel);
            this.clearErrors();
        }
    }, {
        key: 'submit',
        value: function submit() {}
    }]);
    return ServiceAssignmentRulesCreateController;
}(_service_assignment_rulesBase2.default);

exports.default = ServiceAssignmentRulesCreateController;

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service_assignment_rulesEdit = __webpack_require__(2297);

var _service_assignment_rulesEdit2 = _interopRequireDefault(_service_assignment_rulesEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesEditModule = angular.module('serviceAssignmentRulesEdit', []).component('serviceAssignmentRulesEdit', _service_assignment_rulesEdit2.default).name;

exports.default = ServiceAssignmentRulesEditModule;

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service_assignment_rulesEdit = __webpack_require__(2864);

var _service_assignment_rulesEdit2 = _interopRequireDefault(_service_assignment_rulesEdit);

var _service_assignment_rulesEdit3 = __webpack_require__(2298);

var _service_assignment_rulesEdit4 = _interopRequireDefault(_service_assignment_rulesEdit3);

__webpack_require__(3136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesEditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _service_assignment_rulesEdit2.default,
  controller: _service_assignment_rulesEdit4.default
};

exports.default = ServiceAssignmentRulesEditComponent;

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _service_assignment_rulesBase = __webpack_require__(282);

var _service_assignment_rulesBase2 = _interopRequireDefault(_service_assignment_rulesBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesEditController = function (_ServiceAssignmentRul) {
    ServiceAssignmentRulesEditController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "$stateParams", "$q"];
    (0, _inherits3.default)(ServiceAssignmentRulesEditController, _ServiceAssignmentRul);

    /*@ngInject*/
    function ServiceAssignmentRulesEditController(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        (0, _classCallCheck3.default)(this, ServiceAssignmentRulesEditController);

        // super(Auth, $state, User, ServiceAssignmentRulesService, Modal, $translate, $stateParams)
        var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceAssignmentRulesEditController.__proto__ || (0, _getPrototypeOf2.default)(ServiceAssignmentRulesEditController)).call(this));

        _this.$stateParams = $stateParams;
        _this.$q = $q;
        _this.User = User;
        _this.hasACL = {};
        _this.rawId = '';

        _this.defaultModel = {};
        _this.loading = false;
        _this.model = angular.copy(_this.defaultModel);
        _this.branchId = _this.User.getUser().branchId;
        return _this;
    }

    (0, _createClass3.default)(ServiceAssignmentRulesEditController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'reset',
        value: function reset() {}
    }, {
        key: 'submit',
        value: function submit() {}
    }]);
    return ServiceAssignmentRulesEditController;
}(_service_assignment_rulesBase2.default);

exports.default = ServiceAssignmentRulesEditController;

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service_assignment_rules = __webpack_require__(2300);

var _service_assignment_rules2 = _interopRequireDefault(_service_assignment_rules);

var _create = __webpack_require__(2293);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2296);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2290);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesModule = angular.module('serviceAssignmentRules', [_create2.default, _edit2.default, _all2.default]).component('serviceAssignmentRules', _service_assignment_rules2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('service_assignment_rules.edit', {
    url: '/edit/:id',
    component: 'serviceAssignmentRulesEdit',
    data: {
      requireACL: 'tnt_control_service_assignment_rules.edit'
    }
  }).state('service_assignment_rules.create', {
    url: '/create',
    component: 'serviceAssignmentRulesCreate',
    data: {
      requireACL: 'tnt_control_service_assignment_rules.create'
    }
  }).state('service_assignment_rules.all', {
    url: '/all/:page',
    component: 'serviceAssignmentRulesAll',
    data: {
      requireACL: 'tnt_control_service_assignment_rules.view'
    }
  });
}]).name;

exports.default = ServiceAssignmentRulesModule;

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _service_assignment_rules = __webpack_require__(2865);

var _service_assignment_rules2 = _interopRequireDefault(_service_assignment_rules);

var _service_assignment_rules3 = __webpack_require__(2301);

var _service_assignment_rules4 = _interopRequireDefault(_service_assignment_rules3);

__webpack_require__(3137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _service_assignment_rules2.default,
  controller: _service_assignment_rules4.default
};

exports.default = ServiceAssignmentRulesComponent;

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceAssignmentRulesController = function (_TNTControlBase) {
  ServiceAssignmentRulesController.$inject = ["$state"];
  (0, _inherits3.default)(ServiceAssignmentRulesController, _TNTControlBase);

  /*@ngInject*/
  function ServiceAssignmentRulesController($state) {
    (0, _classCallCheck3.default)(this, ServiceAssignmentRulesController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceAssignmentRulesController.__proto__ || (0, _getPrototypeOf2.default)(ServiceAssignmentRulesController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'service_assignment_rules';
    _this.$state = $state;

    return _this;
  }

  (0, _createClass3.default)(ServiceAssignmentRulesController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(ServiceAssignmentRulesController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ServiceAssignmentRulesController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_control_' + this.id]) {
        this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
      }
    }
  }]);
  return ServiceAssignmentRulesController;
}(_TNTControlBase3.default);

exports.default = ServiceAssignmentRulesController;

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setupAll = __webpack_require__(2303);

var _setupAll2 = _interopRequireDefault(_setupAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupallModule = angular.module('setupall', []).component('setupall', _setupAll2.default).name;

exports.default = setupallModule;

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setupAll = __webpack_require__(2866);

var _setupAll2 = _interopRequireDefault(_setupAll);

var _setupAll3 = __webpack_require__(2304);

var _setupAll4 = _interopRequireDefault(_setupAll3);

__webpack_require__(3138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _setupAll2.default,
  controller: _setupAll4.default
};

exports.default = setupallComponent;

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _setupBase = __webpack_require__(179);

var _setupBase2 = _interopRequireDefault(_setupBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupallController = function (_SetupBaseController) {
  setupallController.$inject = ["Auth", "$state", "User", "Modal", "SetupService", "$translate", "$stateParams", "$location"];
  (0, _inherits3.default)(setupallController, _SetupBaseController);

  /*@ngInject*/
  function setupallController(Auth, $state, User, Modal, SetupService, $translate, $stateParams, $location) {
    (0, _classCallCheck3.default)(this, setupallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (setupallController.__proto__ || (0, _getPrototypeOf2.default)(setupallController)).call(this, Auth, $state, User, SetupService, Modal, $translate, $stateParams, $location));

    _this.loading = true;
    _this.setups = [];
    _this.hasAcl = {};
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.searchText = '';
    _this.$location = $location;
    return _this;
  }

  (0, _createClass3.default)(setupallController, [{
    key: '$onInit',
    value: function $onInit() {
      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
    }
  }, {
    key: 'edit',
    value: function edit(setup) {
      this.$state.go('setup.edit', {
        id: setup.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(setup) {
      var _this2 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + ' ' + this.$translate.instant('setup.setupFor') + (' <strong>' + setup.branchId + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this2.Service.remove(setup.id, setup.branchId).then(function (data) {
            _this2.allowOnlyOnce = false;
            modal.close();
            _this2.refresh();
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this2.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      return {
        queryText: '%' + this.searchText + '%',
        isQuery: false
      };
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      var searchObj = this.generateSearchObj();

      this.loading = true;
      this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this3.total = data.total;
        _this3.setups = data.results;
      }).catch(function (err) {
        _this3.error = err.message;
      }).finally(function () {
        _this3.loading = false;
      });
    }
  }]);
  return setupallController;
}(_setupBase2.default);

exports.default = setupallController;

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefixTable = __webpack_require__(2867);

var _prefixTable2 = _interopRequireDefault(_prefixTable);

var _prefixTable3 = __webpack_require__(530);

var _prefixTable4 = _interopRequireDefault(_prefixTable3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrefixTableComponent = {
  bindings: {
    prefixes: '=',
    modelValue: '='
  },
  template: _prefixTable2.default,
  controller: _prefixTable4.default
};

exports.default = PrefixTableComponent;

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setupCreate = __webpack_require__(2307);

var _setupCreate2 = _interopRequireDefault(_setupCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupCreateModule = angular.module('setupcreate', []).component('setupcreate', _setupCreate2.default).name;

exports.default = setupCreateModule;

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setupCreate = __webpack_require__(2868);

var _setupCreate2 = _interopRequireDefault(_setupCreate);

var _setupCreate3 = __webpack_require__(2308);

var _setupCreate4 = _interopRequireDefault(_setupCreate3);

__webpack_require__(3139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupcreateComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _setupCreate2.default,
  controller: _setupCreate4.default
};

exports.default = setupcreateComponent;

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _setupBase = __webpack_require__(179);

var _setupBase2 = _interopRequireDefault(_setupBase);

var _prefixTable = __webpack_require__(530);

var _prefixTable2 = _interopRequireDefault(_prefixTable);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SetupCreateController = function (_SetupBaseController) {
  SetupCreateController.$inject = ["Auth", "$state", "User", "SetupService", "Modal", "DateUtil", "$translate", "$stateParams", "BranchService", "VaultService", "$q", "LocationService", "RouteService", "$timeout", "CurrencyService", "UsersService", "WindowService"];
  (0, _inherits3.default)(SetupCreateController, _SetupBaseController);

  /*@ngInject*/
  function SetupCreateController(Auth, $state, User, SetupService, Modal, DateUtil, $translate, $stateParams, BranchService, VaultService, $q, LocationService, RouteService, $timeout, CurrencyService, UsersService, WindowService) {
    (0, _classCallCheck3.default)(this, SetupCreateController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SetupCreateController.__proto__ || (0, _getPrototypeOf2.default)(SetupCreateController)).call(this, Auth, $state, User, SetupService, Modal, $translate, $stateParams));

    _this.setPrimaryCurrency = function (currencyId) {
      this.model.currencyId = currencyId;
    };

    _this.BranchService = BranchService;
    _this.VaultService = VaultService;
    _this.LocationService = LocationService;
    _this.RouteService = RouteService;
    _this.SetupService = SetupService;
    _this.DateUtil = DateUtil;
    _this.CurrencyService = CurrencyService;
    _this.UsersService = UsersService;
    _this.WindowService = WindowService;
    _this.$q = $q;
    _this.$timeout = $timeout;
    _this.hasACL = {};
    _this.errors = {};
    _this.loadPrefixDirective = false;

    _this.defaultModel = {
      description: '',
      address: '',
      city: '',
      state: null,
      zip: '',
      telno: '',
      exitPassword: '',
      confirmExitPassword: '',
      dataToServer: '',
      dataFromServer: '',
      toHHTProtocol: null,
      fromHHTProtocol: null,
      transmitMsgFiles: false,
      verify: true,
      keyVerify: true,
      showCoinTotal: true,
      noPrintDelivery: false,
      noPrintPickup: false,
      coinCheckIn: false,
      coinCheckOut: false,
      currentVaultDate: null,
      reqMessengerStopScan: false,
      atLocationScan: true,
      maxItemsPerBagout: null,
      branchId: null,
      vaultId: null,
      // startAt: null,
      // max: null,
      defaultLanguageId: null,
      requireDriver: true,
      requireGuard: false,
      useHolidayRoutes: false,
      allowBulkHoldVerify: false,
      locationRequiresCustomer: false,
      packingRequired: false,
      prefixes: [],
      currency: null,
      branch: _this.$stateParams.branch || _this.User.getUser().branchId,
      limitPerATMDeposit: null,
      fromLocationId: null,
      tankerId: null,
      virtualTankerId: null,
      holdRouteId: null,
      defaultSupervisorId: null,
      supervisorScan: true,
      unassignedRouteId: null,
      enableGeoCoding: false,
      packCharLength: null,
      timezone: null,
      gpsLat: 0.0,
      gpsLong: 0.0,
      limitPerRoute: null,
      // limitPerEventRoute: null
      serviceTickets: true,
      ATMTransfer: false,
      bagoutFromCompany: '',
      autoDeleteBagouts: false,
      deletePickups: false,
      pickupIdLength: false,
      charactersRequired: 0,
      bypassLocation: false,
      bypassItem: false,
      bypassDelivery: false,
      bypassPickup: false,
      editPickupId: false,
      OTCCencon: false,
      OTCLMS: false,
      OTCTDS: false,
      OTCCenconCheckoutMode: null,
      OTCCenconRouteMode: null,
      OTCCenconServiceMode: null,
      OTCLMSCheckoutDur: null,
      OTCLMSRouteDur: null,
      OTCLMSServiceDur: null,
      ignorePackRequirement: false,
      billingEnabled: false,
      addBagToCheckout: false,
      vaultLiability: '',
      alertThreshold: null,
      alertRecipientEmail: '',
      printPackLabel: false,
      printPrePack: true,
      verifyPickupUnique: false,
      notDeliveredResolution: false,
      defaultToTankerId: null,
      defaultFromTankerId: null,
      defaultWindowId: null,
      enableAutoCheckInCheckOut: false,
      enableAutoSubmit: false,
      additionalPickup: false,
      serviceOrderTruckScan: false,
      bagoutBranchId: null,
      isNonUSLocation: false,
      loadTruck: false,
      checkInTanker: false,
      bypassCantCloseATM: false,
      requireSignatureName: false,
      enforceStrongPassword: false,
      minimumPasswordLength: null,
      lowercaseCharacterLength: null,
      uppercaseCharacterLength: null,
      numericCharacterLength: null,
      specialCharacterLength: null,
      forceChangePasswordDays: null,
      cantScanLocation: false,
      loadBreakdown: false,
      packSlip: false,
      cantScanTruck: false,
      cantScanBag: false,
      routeNFC: false,
      truckNFC: false,
      cantScanNFC: false,
      autoAssignServiceTicket: false,
      disableCopyPaste: false,
      disableTrackingIdTyping: false,
      assignServiceZone: false,
      serviceLocationTypes: ['ATM'],
      unassignOnVaultClose: false,
      serviceChecklist: false,
      checkoutTruckLiability: false,
      autoGenerateTrackingId: false,
      trackingIdPrefix: '',
      trackingIdNumber: null,
      cancelSupervisorChallenge: false,
      unassignOnDayClose: false,
      autoCloseVault: false,
      convertToPickup: false,
      availableCurrencyIds: [],
      currencyId: null,
      // multiDayRoutes: false
      undeliveredAnytimeFlag: false,
      branchCounters: [],
      virtualTankers: false,
      autoDetectScannerCode: true,
      barcodeType: null,
      enforceChecksum: false,
      locationOnHold: false,
      checksumDigits: null
    };

    _this.states = ["Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District Of Columbia", "Federated States Of Micronesia", "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"];

    // this.timezoneList = [
    //   { label: 'EST', value: 'EST' },
    //   { label: 'EDT', value: 'EDT' },
    //   { label: 'CST', value: 'CST' },
    //   { label: 'CDT', value: 'CDT' },
    //   { label: 'MST', value: 'MST' },
    //   { label: 'MDT', value: 'MDT' },
    //   { label: 'PST', value: 'PST' },
    //   { label: 'PDT', value: 'PDT' },
    //   { label: 'EST5EDT', value: 'EST5EDT' }
    // ];

    _this.locationLists = [];
    _this.tankerList = [];
    _this.holdRouteList = [];
    _this.unassignedRoutes = [];
    _this.virtualTankerList = [];

    _this.HHTProtocolValues = [{ label: 'W', value: 'W' }, { label: 'D', value: 'D' }];
    _this.languages = [{ value: 'E', label: "English" },
    // { value: 'F', label: 'French' }
    { value: 'S', label: 'Spanish' }];

    _this.defaultServiceTicketAssignment = [{ value: 'ROUTE', label: 'Route' }, { value: 'USER', label: 'User' }, { value: 'EXTERNAL', label: 'External' }];
    _this.serviceLocationTypeOptions = [{ name: 'ATM', label: 'ATM' }, { name: 'REGULAR', label: 'Regular' }, { name: 'BANK', label: 'Bank' }, { name: 'ON_CALL', label: 'On Call' }, { name: 'NO_SHIP_NO_GO', label: 'No Ship No Go' }];
    _this.model = angular.copy(_this.defaultModel);
    _this.syncServiceLocationTypes = function () {
      if (!Array.isArray(_this.model.serviceLocationTypes) || !_this.model.serviceLocationTypes.length) {
        _this.model.serviceLocationTypes = ['ATM'];
      }
      _this.serviceLocationTypeOptions.forEach(function (option) {
        option.ticked = _this.model.serviceLocationTypes.includes(option.name);
      });
      _this.selectedServiceLocationTypes = _this.serviceLocationTypeOptions.filter(function (option) {
        return option.ticked;
      });
    };
    _this.syncServiceLocationTypes();
    _this.updateServiceLocationTypes = function () {
      _this.selectedServiceLocationTypes = _this.serviceLocationTypeOptions.filter(function (option) {
        return option.ticked;
      });
      _this.model.serviceLocationTypes = _this.selectedServiceLocationTypes.map(function (option) {
        return option.name;
      });
    };
    _this.selectNoneServiceLocationTypes = function () {
      _this.$timeout(function () {
        var atmOption = _this.serviceLocationTypeOptions.find(function (option) {
          return option.name === 'ATM';
        });
        _this.serviceLocationTypeOptions.forEach(function (option) {
          option.ticked = option === atmOption;
        });
        _this.selectedServiceLocationTypes = [atmOption];
        _this.model.serviceLocationTypes = ['ATM'];
      });
    };

    _this.branches = [];
    _this.vaults = [];
    _this.valutDate = "";
    _this.currencys = [];
    _this.currencyOptions = [];
    _this.supervisors = [];
    _this.passWdIcon = {
      exitPassword: false,
      confirmExitPassword: false
    };

    _this.cenconLockOptions = [{ label: 'RTE Mode', value: 'RTE' }, { label: 'FLM Mode', value: 'FLM' }];

    _this.LMSLockOptions = [{ label: 'Next Available', value: 'NA' }, { label: '4 Hours', value: '4' }, { label: '8 Hours', value: '8' }, { label: '12 Hours', value: '12' }, { label: 'Midnight', value: 'MN' }];

    _this.barCodeTypes = [{ label: 'CODE_128', value: 'CODE_128' }, { label: 'CODE_39', value: 'CODE_39' }, { label: 'CODABAR', value: 'CODABAR' }, { label: 'DATA_MATRIX', value: 'DATA_MATRIX' }, { label: 'EAN_13', value: 'EAN_13' }, { label: 'EAN_8', value: 'EAN_8' }, { label: 'ITF', value: 'ITF' }, { label: 'QR_CODE', value: 'QR_CODE' }, { label: 'UPC_A', value: 'UPC_A' }, { label: 'UPC_E', value: 'UPC_E' }, { label: 'PDF417', value: 'PDF417' }, { label: 'AZTEC', value: 'AZTEC' }];

    _this.fromTankerObj = {
      results: [],
      totalRecords: 0
    };

    _this.toTankerObj = {
      results: [],
      totalRecords: 0
    };

    _this.windowObj = {
      results: [],
      totalRecords: 0
    };

    _this.branchCost = [];
    _this.counters = [{ name: '', serialNumber: '' }];
    _this.timezoneList = [];
    return _this;
  }

  (0, _createClass3.default)(SetupCreateController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.isDuplicateBranchCost = true;
      this.isValidDistance = false;

      this.$q.all([this.BranchService.all(null, 0, 1000), this.VaultService.all(null, 0, 1000), this.Service.all(null, 0, 1000), this.SetupService.get(this.model.branch), this.CurrencyService.all(null, 0, _app2.default.defaultPageSize), this.getBranchSupervisors()]).then(function (data) {
        var date = _this2.DateUtil.getUTCDate(data[3].currentVaultDate || undefined);
        _this2.valutDate = moment(date).format('YYYY-MM-DD');
        _this2.model = _this2.defaultModel;
        _this2.syncServiceLocationTypes();
        _this2.model.currentVaultDate = moment(_this2.valutDate).toDate();

        _this2.dates = _this2.DateUtil.getUTCDate(data[3].currentVaultDate || undefined);
        var branchesWithExistingSetupRecord = data[2].results.map(function (setupRecord) {
          return setupRecord.branchId;
        });

        _this2.branches = data[0].results.filter(function (branch) {
          return !branchesWithExistingSetupRecord.includes(branch.id);
        }).map(function (branch) {
          return branch.id;
        });

        _this2.currencys = data[4].results.map(function (currency) {
          return currency.id;
        });
        _this2.vaults = data[1].results.map(function (vault) {
          return vault.id;
        });
        _this2.loadPrefixDirective = true;
        _this2.loadBranchData();
        _this2.momentTimeZone();
        _this2.prefixes = (0, _assign2.default)({ messenger: ["D"] }, _this2.model.prefixes);

        // Then create currencyOptions with correct ticked values
        _this2.currencyOptions = data[4].results.map(function (currency) {
          return {
            id: currency.id,
            ticked: _this2.model.availableCurrencyIds && _this2.model.availableCurrencyIds.includes(currency.id)
          };
        });
      });
    }
  }, {
    key: 'momentTimeZone',
    value: function momentTimeZone() {
      var timezone = this.mappingTimezone();
      this.timezoneList = this.timezoneList.concat(timezone);
      this.totalTimezones = this.timezoneList.length;
    }
  }, {
    key: 'mappingTimezone',
    value: function mappingTimezone() {
      return moment.tz.names().map(function (item) {
        return { Key: item, Value: item };
      });
    }
  }, {
    key: 'prioritizeTimezone',
    value: function prioritizeTimezone(timezone) {
      if (!timezone) return;

      var existingIndex = this.timezoneList.findIndex(function (item) {
        return item.Value === timezone;
      });

      if (existingIndex > -1) {
        this.timezoneList.splice(existingIndex, 1);
      }

      this.model.timezone = {
        Key: timezone,
        Value: timezone
      };

      this.timezoneList.unshift(this.model.timezone);
      this.totalTimezones = this.timezoneList.length;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.loadPrefixDirective = false;
      this.$onInit();
      this.model = angular.copy(this.defaultModel);
      this.syncServiceLocationTypes();
      this.branchCost = [];
      this.counters = [{ name: '', serialNumber: '' }];
      this.model.availableCurrencyIds = [];
      this.model.currencyId = null;
    }
  }, {
    key: 'searchSupervisorQuery',
    value: function searchSupervisorQuery() {
      var searchObj = {
        queryJSON: {
          rules: [{
            field: "supervisor",
            condition: "=",
            data: true
          }],
          operator: "AND"
        }
      };
      return searchObj.queryJSON.rules.length ? searchObj : null;
    }
  }, {
    key: 'getBranchSupervisors',
    value: function getBranchSupervisors() {
      var _this3 = this;

      this.Service.supervisorList(this.model.branchId).then(function (data) {
        _this3.supervisors = data.results;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'submit',
    value: function submit(evt) {
      var _this4 = this;

      // if (!this.validate()) {
      // 	return
      // }
      this.errors = {};
      this.loading = true;
      var DEFAULT_MAX_ITEMS_PER_BAGOUT = 40,
          DEFAULT_MAX_PACK_CHAR_LENGTH = 0;

      this.model.maxItemsPerBagout = this.model.maxItemsPerBagout || DEFAULT_MAX_ITEMS_PER_BAGOUT;
      this.model.packCharLength = this.model.packCharLength || DEFAULT_MAX_PACK_CHAR_LENGTH;

      if (this.model.exitPassword !== this.model.confirmExitPassword) {
        this.loading = false;
        this.errors['password'] = this.$translate.instant('setup.exitPasswordMismatch');
        return;
      }

      if (this.model.defaultFromTankerId && this.model.defaultToTankerId && this.model.defaultFromTankerId.Value === this.model.defaultToTankerId.Value) {
        this.loading = false;
        this.Modal.errorModal(this.$translate.instant('setup.tanker_error'));
        return;
      }

      if (!this.validateCounters()) {
        this.loading = false;
        return;
      }

      var branchCost = [];
      this.branchCost.forEach(function (bc) {
        bc.name = bc.name;
        bc.startDistance = bc.startDistance;
        bc.endDistance = bc.endDistance;
        bc.standardLoad = bc.standardLoad;
        bc.ecLoad = bc.ecLoad;
        bc.setupId = bc.setupId;
        bc.branchId = bc.branchId;
        bc.createdByUserId = bc.createdByUserId;
        bc.modifiedByUserId = bc.modifiedByUserId;
        delete bc.isDuplicate;
        delete bc.isValid;
        branchCost.push(_.cloneDeep(bc));
      });

      this.model.currentVaultDate = moment(this.model.currentVaultDate).format('YYYY-MM-DD');
      this.model.fromLocationId = this.model.fromLocationId.Value;
      this.model.tankerId = this.model.tankerId ? this.model.tankerId.Value : null;
      this.model.virtualTankerId = this.model.virtualTankerId ? this.model.virtualTankerId.Value : null;
      this.model.holdRouteId = this.model.holdRouteId ? this.model.holdRouteId.Value : null;
      this.model.limitPerATMDeposit = this.model.limitPerATMDeposit ? this.model.limitPerATMDeposit : null;
      this.model.defaultSupervisorId = this.model.defaultSupervisorId.id ? this.model.defaultSupervisorId.id : null;
      this.model.unassignedRouteId = this.model.unassignedRouteId ? this.model.unassignedRouteId.Value : null;
      this.model.gpsLat = this.model.gpsLat ? parseFloat(this.model.gpsLat) : 0.0;
      this.model.gpsLong = this.model.gpsLong ? parseFloat(this.model.gpsLong) : 0.0;
      this.model.limitPerRoute = this.model.limitPerRoute ? this.model.limitPerRoute : null;
      this.model.alertThreshold = this.model.alertThreshold ? this.convertStr(this.model.alertThreshold) : null;
      this.model.defaultWindowId = this.model.defaultWindowId ? this.model.defaultWindowId.Value : null;
      this.model.defaultFromTankerId = this.model.defaultFromTankerId ? this.model.defaultFromTankerId.Value : null;
      this.model.defaultToTankerId = this.model.defaultToTankerId ? this.model.defaultToTankerId.Value : null;
      this.model.country = this.model.isNonUSLocation ? this.model.country : 'US', this.model.charactersRequired = this.model.pickupIdLength ? this.model.charactersRequired : 0;
      this.model.barcodeType = !this.model.autoDetectScannerCode ? this.model.barcodeType : null;
      this.model.checksumDigits = this.model.enforceChecksum ? this.model.checksumDigits : null;
      this.model.timezone = this.model.timezone ? this.model.timezone.Value : null;
      this.model.locationOnHold = this.model.locationOnHold ? this.model.locationOnHold : null;
      this.model.serviceLocationTypes = this.selectedServiceLocationTypes.map(function (option) {
        return option.name;
      });
      var validCounters = this.counters.filter(function (c) {
        var name = (c.name || '').trim();
        var serial = (c.serialNumber || '').trim();
        return name && serial;
      });
      this.model.branchCounters = validCounters;

      this.model.branchCost = branchCost;
      this.model.userId = this.User.getUser().id;

      var payload = (0, _extends3.default)({}, this.model);
      payload.availableCurrencyIds = Array.isArray(this.model.availableCurrencyIds) ? this.model.availableCurrencyIds.map(function (o) {
        return o.id;
      }) : [];
      this.Service.create(payload).then(function (data) {
        _this4.askCreate();
      }).catch(function (err) {
        _this4.Modal.errorModal(err.data.message);
      }).finally(function () {
        _this4.loading = false;
      });
    }
  }, {
    key: 'loadBranchData',
    value: function loadBranchData() {
      this.getAllLocation();
      this.loadTanker();
      // this.loadRoutes();
      this.loadUnassignedRoutes();
      this.loadHoldRoutes();
      this.loadVirtual();
      this.getBranchWindow('', 0);
      this.loadFromTanker('', 0);
      this.loadToTanker('', 0);
      this.getBranchSupervisors();
      this.model.fromLocationId = '';
      this.model.tankerId = '';
      this.model.holdRouteId = '';
      this.model.virtualTankerId = '';
    }
  }, {
    key: 'getAllLocation',
    value: function getAllLocation(searchKey, offset) {
      var _this5 = this;

      searchKey = searchKey || '';
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          }, {
            field: 'locationType',
            condition: '=',
            data: 'INTERNAL'
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      this.LocationService.getAllLocation(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this5.totalLocatin = data.total;
          _this5.locationLists = _this5.mapData(data.results);
        } else {
          var locations = _this5.mapData(data.results);
          _this5.locationLists = _this5.locationLists.concat(locations);
        }
      });
    }
  }, {
    key: 'getRoutes',
    value: function getRoutes(searchKey, offset) {
      searchKey = searchKey || '';
      var routeSearchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      var routeDefer = this.$q.defer();
      this.RouteService.all(routeSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        routeDefer.resolve(data);
        // this.model.holdRouteId = null;
        // this.routes = data.results;

        // if (offset === 0 || offset == undefined) {
        //   this.totalHoldRoutes = data.total;
        //   this.totalUnassignedRoutes = data.total;
        //   this.holdRouteList = this.mapData(data.results);
        //   this.unassignedRoutes = this.mapData(data.results);
        // } else {
        //   const routes = this.mapData(data.results);
        //   this.holdRouteList = this.holdRouteList.concat(routes);
        //   this.unassignedRoutes = this.unassignedRoutes.concat(routes);
        // }
      }).catch(function (err) {
        routeDefer.reject(err);
      });
      return routeDefer.promise;
    }
  }, {
    key: 'loadHoldRoutes',
    value: function loadHoldRoutes(searchKey, offset) {
      var _this6 = this;

      this.getRoutes(searchKey, offset).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this6.totalHoldRoutes = data.total;
          _this6.holdRouteList = _this6.mapData(data.results);
        } else {
          var routes = _this6.mapData(data.results);
          _this6.holdRouteList = _this6.holdRouteList.concat(routes);
        }
      });
    }
  }, {
    key: 'loadUnassignedRoutes',
    value: function loadUnassignedRoutes(searchKey, offset) {
      var _this7 = this;

      this.getRoutes(searchKey, offset).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this7.totalUnassignedRoutes = data.total;
          _this7.unassignedRoutes = _this7.mapData(data.results);
        } else {
          var routes = _this7.mapData(data.results);
          _this7.unassignedRoutes = _this7.unassignedRoutes.concat(routes);
        }
      });
    }

    // get tanker data

  }, {
    key: 'loadVirtual',
    value: function loadVirtual(searchKey, offset) {
      var _this8 = this;

      this.getTanker(searchKey, offset).then(function (virtualData) {
        if (offset === 0 || offset == undefined) {
          _this8.totalVtanker = virtualData.total;
          _this8.virtualTankerList = _this8.mapData(virtualData.results);
        } else {
          var tankers = _this8.mapData(virtualData.results);
          _this8.virtualTankerList = _this8.virtualTankerList.concat(tankers);
        }
      });
    }
  }, {
    key: 'loadTanker',
    value: function loadTanker(searchKey, offset) {
      var _this9 = this;

      this.getTanker(searchKey, offset).then(function (tankerData) {
        if (offset === 0 || offset == undefined) {
          _this9.totaltanker = tankerData.total;
          _this9.tankerList = _this9.mapData(tankerData.results);
        } else {
          var tankers = _this9.mapData(tankerData.results);
          _this9.tankerList = _this9.tankerList.concat(tankers);
        }
      });
    }
  }, {
    key: 'getTanker',
    value: function getTanker(searchKey, offset) {
      searchKey = searchKey || '';
      var tankerSearchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          }, {
            field: 'locationType',
            condition: '=',
            data: 'TANKER'
          }, {
            field: 'active',
            condition: '=',
            data: true
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: "AND"
        }
      };
      var deferred = this.$q.defer();
      this.LocationService.getAllLocation(tankerSearchObj, offset, _app2.default.defaultPageLimit).then(function (tankerData) {
        // this.model.tankerId = null;
        // this.model.virtualTankerId = null;
        // this.tankers = tankerData.results;
        deferred.resolve(tankerData);
      }).catch(function (e) {
        return deferred.reject(e);
      });
      return deferred.promise;
    }
  }, {
    key: 'mapData',
    value: function mapData(mapArray) {
      return mapArray.map(function (obj) {
        return {
          Key: obj.id + " | " + obj.name,
          Value: obj.id
        };
      });
    }
  }, {
    key: 'showPassword',
    value: function showPassword(type) {
      this.passWdIcon[type] = !this.passWdIcon[type];
    }
  }, {
    key: 'ngPercentage',
    value: function ngPercentage() {
      if (this.model.alertThreshold && !this.model.alertThreshold.endsWith('%')) {
        return this.model.alertThreshold = this.model.alertThreshold + '%';
      }
    }
  }, {
    key: 'convertStr',
    value: function convertStr(str) {
      if (!str) return;
      return Number(str.replace('%', ''));
    }
  }, {
    key: 'removePrecentageSign',
    value: function removePrecentageSign() {
      if (this.model.alertThreshold && this.model.alertThreshold.endsWith('%')) {
        return this.model.alertThreshold = this.model.alertThreshold.replace('%', '');
      }
    }
  }, {
    key: 'onPrintPack',
    value: function onPrintPack() {
      // this.model.printPrePack = !this.model.printPackLabel;
      if (this.model.printPackLabel && !this.model.printPrePack) {
        this.model.printPrePack = true;
      } else this.model.printPackLabel = this.model.printPackLabel;
    }
  }, {
    key: 'onPrePrintPack',
    value: function onPrePrintPack() {
      // this.model.printPackLabel = !this.model.printPrePack;
      if (this.model.printPrePack && !this.model.printPackLabel) {
        this.model.printPackLabel = true;
      } else this.model.printPrePack = this.model.printPrePack;
    }
  }, {
    key: 'getBranchWindow',
    value: function getBranchWindow(searchKey, offset) {
      var _this10 = this;

      searchKey = searchKey || '';

      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          }, {
            field: 'locationType',
            condition: '=',
            data: 'WINDOW'
          }, {
            field: 'active',
            condition: '=',
            data: true
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      return this.LocationService.getAllLocation(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this10.windowObj.results = _this10.mapData(data.results);
          _this10.windowObj.totalRecords = data.total;
        } else {
          var locations = _this10.mapData(data.results);
          _this10.windowObj.results = _this10.windowObj.results.concat(locations);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'loadFromTanker',
    value: function loadFromTanker(searchKey, offset) {
      var _this11 = this;

      this.getTanker(searchKey, offset).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this11.fromTankerObj.results = _this11.mapData(data.results);
          _this11.fromTankerObj.totalRecords = data.total;
        } else {
          var tankers = _this11.mapData(data.results);
          _this11.fromTankerObj.results = _this11.fromTankerObj.results.concat(tankers);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'loadToTanker',
    value: function loadToTanker(searchKey, offset) {
      var _this12 = this;

      this.getTanker(searchKey, offset).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this12.toTankerObj.results = _this12.mapData(data.results);
          _this12.toTankerObj.totalRecords = data.total;
        } else {
          var tankers = _this12.mapData(data.results);
          _this12.toTankerObj.results = _this12.toTankerObj.results.concat(tankers);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'resetText',
    value: function resetText() {
      this.model.state = null;
      this.model.country = null;
    }
  }, {
    key: 'addNewCost',
    value: function addNewCost(event) {
      this.branchCost.push({
        name: null,
        startDistance: null,
        endDistance: null,
        standardLoad: null,
        ecLoad: null,
        setupId: null,
        branchId: this.model.branchId,
        createdByUserId: this.User.getUser().id,
        modifiedByUserId: this.User.getUser().id
      });
      event.preventDefault();
    }
  }, {
    key: 'removeCost',
    value: function removeCost(index) {
      this.branchCost.splice(index, 1);
      this.validateDistance();
      this.validateBranchCost();
    }
  }, {
    key: 'validateDistance',
    value: function validateDistance() {
      this.branchCost.forEach(function (bc) {
        return bc.isValid = false;
      });

      for (var i = 0; i < this.branchCost.length; i++) {
        var currentCost = this.branchCost[i];
        var startDistance = parseFloat(currentCost.startDistance);
        var endDistance = parseFloat(currentCost.endDistance);

        currentCost.isValid = startDistance >= endDistance;
      }
      this.isValidDistance = this.branchCost.some(function (bc) {
        return bc.isValid;
      });
    }
  }, {
    key: 'validateBranchCost',
    value: function validateBranchCost() {
      var _this13 = this;

      this.branchCost = _.map(this.branchCost, function (mainObj, mainObjIndex) {
        mainObj.isDuplicate = false;
        var eq = _.find(_this13.branchCost, function (compairObject, compairObjIndex) {
          if (mainObjIndex > compairObjIndex) {
            return compairObject.startDistance === mainObj.startDistance && compairObject.endDistance === mainObj.endDistance;
          }
        });
        if (eq) {
          mainObj.isDuplicate = true;
          return mainObj;
        } else {
          return mainObj;
        }
      });

      var isValid = this.branchCost.map(function (obj) {
        if (obj.isDuplicate) return true;
      });

      this.isDuplicateBranchCost = isValid.indexOf(true) >= 0 ? false : true;
    }
  }, {
    key: 'isAllDataFilled',
    value: function isAllDataFilled() {
      return this.branchCost.every(function (bc) {
        return bc.name && bc.startDistance !== null && bc.startDistance !== undefined && bc.startDistance !== "" && bc.endDistance !== null && bc.endDistance !== undefined && bc.endDistance !== "" && bc.standardLoad !== null && bc.standardLoad !== undefined && bc.standardLoad !== "" && bc.ecLoad !== null && bc.ecLoad !== undefined && bc.ecLoad !== "";
      });
    }
  }, {
    key: 'addCounter',
    value: function addCounter() {
      this.counters.push({
        name: '',
        serialNumber: ''
      });
    }
  }, {
    key: 'removeCounter',
    value: function removeCounter(index) {
      this.counters.splice(index, 1);
    }
  }, {
    key: 'checkDuplicateSerials',
    value: function checkDuplicateSerials() {
      this.counters = this.counters || [];
      var serialSet = new _set2.default();

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.counters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var c = _step.value;

          var name = (c.name || '').trim();
          var serial = (c.serialNumber || '').trim();

          if (name && serial) {
            var serialLower = serial.toLowerCase();
            if (serialSet.has(serialLower)) {
              return true;
            }
            serialSet.add(serialLower);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  }, {
    key: 'validateCounters',
    value: function validateCounters() {
      if (this.checkDuplicateSerials()) {
        this.Modal.errorModal(this.$translate.instant('setup.duplicateSerial'));
        return false;
      }
      return true;
    }
  }, {
    key: 'onAvailableCurrenciesChange',
    value: function onAvailableCurrenciesChange() {
      var _this14 = this;

      if (this.model.availableCurrencyIds.length === 1) {
        this.model.currencyId = this.model.availableCurrencyIds[0].id;
        return;
      }

      var currentCurrencyExists = this.model.availableCurrencyIds.some(function (curr) {
        return curr.id === _this14.model.currencyId;
      });
      if (!currentCurrencyExists) {
        this.model.currencyId = this.model.availableCurrencyIds[0].id;
      }
    }
  }]);
  return SetupCreateController;
}(_setupBase2.default);

exports.default = SetupCreateController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setupEdit = __webpack_require__(2310);

var _setupEdit2 = _interopRequireDefault(_setupEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupEditModule = angular.module('setupedit', []).component('setupedit', _setupEdit2.default).name;

exports.default = setupEditModule;

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setupEdit = __webpack_require__(2869);

var _setupEdit2 = _interopRequireDefault(_setupEdit);

var _setupEdit3 = __webpack_require__(2311);

var _setupEdit4 = _interopRequireDefault(_setupEdit3);

__webpack_require__(3140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupeditComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _setupEdit2.default,
  controller: _setupEdit4.default
};

exports.default = setupeditComponent;

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _set = __webpack_require__(46);

var _set2 = _interopRequireDefault(_set);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _setupBase = __webpack_require__(179);

var _setupBase2 = _interopRequireDefault(_setupBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SetupEditController = function (_SetupBaseController) {
  SetupEditController.$inject = ["Auth", "$state", "User", "DateUtil", "SetupService", "Modal", "$translate", "$stateParams", "BranchService", "VaultService", "$q", "LocationService", "RouteService", "CurrencyService", "UsersService", "HomeService", "$rootScope", "WindowService", "Configs", "$timeout"];
  (0, _inherits3.default)(SetupEditController, _SetupBaseController);

  /*@ngInject*/
  function SetupEditController(Auth, $state, User, DateUtil, SetupService, Modal, $translate, $stateParams, BranchService, VaultService, $q, LocationService, RouteService, CurrencyService, UsersService, HomeService, $rootScope, WindowService, Configs, $timeout) {
    (0, _classCallCheck3.default)(this, SetupEditController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SetupEditController.__proto__ || (0, _getPrototypeOf2.default)(SetupEditController)).call(this, Auth, $state, User, SetupService, Modal, $translate, $stateParams));

    _this.setPrimaryCurrency = function (currencyId) {
      this.model.currencyId = currencyId;
    };

    _this.BranchService = BranchService;
    _this.VaultService = VaultService;
    _this.LocationService = LocationService;
    _this.RouteService = RouteService;
    _this.SetupService = SetupService;
    _this.UsersService = UsersService;
    _this.DateUtil = DateUtil;
    _this.CurrencyService = CurrencyService;
    _this.$q = $q;
    _this.HomeService = HomeService;
    _this.$rootScope = $rootScope;
    _this.WindowService = WindowService;
    _this.Configs = Configs;
    _this.$timeout = $timeout;

    _this.hasACL = {};
    _this.errors = {};
    _this.defaultModel = {
      branch: _this.$stateParams.branch || _this.User.getUser().branchId,
      isNonUSLocation: false,
      convertToPickup: false,
      availableCurrencyIds: [],
      branchCounters: [],
      serviceLocationTypes: ['ATM']
    };
    _this.rawId = _this.$stateParams.id;

    _this.states = ["Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District Of Columbia", "Federated States Of Micronesia", "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"];

    _this.HHTProtocolValues = [{
      label: 'W',
      value: 'W'
    }, {
      label: 'D',
      value: 'D'
    }];
    _this.languages = [{
      value: 'E',
      label: "English"
    }, {
      value: 'S',
      label: 'Spanish'
    }];

    _this.defaultServiceTicketAssignment = [{ value: 'ROUTE', label: 'Route' }, { value: 'USER', label: 'User' }, { value: 'EXTERNAL', label: 'External' }];
    _this.serviceLocationTypeOptions = [{ name: 'ATM', label: 'ATM' }, { name: 'REGULAR', label: 'Regular' }, { name: 'BANK', label: 'Bank' }, { name: 'ON_CALL', label: 'On Call' }, { name: 'NO_SHIP_NO_GO', label: 'No Ship No Go' }];
    _this.selectedServiceLocationTypes = [];
    _this.updateServiceLocationTypes = function () {
      _this.selectedServiceLocationTypes = _this.serviceLocationTypeOptions.filter(function (option) {
        return option.ticked;
      });
      _this.model.serviceLocationTypes = _this.selectedServiceLocationTypes.map(function (option) {
        return option.name;
      });
    };
    _this.selectNoneServiceLocationTypes = function () {
      _this.$timeout(function () {
        var atmOption = _this.serviceLocationTypeOptions.find(function (option) {
          return option.name === 'ATM';
        });
        _this.serviceLocationTypeOptions.forEach(function (option) {
          option.ticked = option === atmOption;
        });
        _this.selectedServiceLocationTypes = [atmOption];
        _this.model.serviceLocationTypes = ['ATM'];
      });
    };

    _this.model = angular.copy(_this.defaultModel);
    _this.branches = [];
    _this.vaults = [];
    _this.locations = [];
    _this.locationsScrollFlag = false;
    _this.tankers = [];
    _this.virtualTankers = [];
    _this.routes = [];
    _this.unassignedRoutes = [];
    _this.currencys = [];
    _this.currencyOptions = [];
    _this.supervisors = [];
    _this.isVaultDateChanged = false;
    _this.setupData = {
      currentVaultDate: ""
    };

    _this.passWdIcon = {
      exitPassword: false,
      confirmExitPassword: false
    };

    _this.cenconLockOptions = [{ label: 'RTE Mode', value: 'RTE' }, { label: 'FLM Mode', value: 'FLM' }];

    _this.LMSLockOptions = [{ label: 'Next Available', value: 'NA' }, { label: '4 Hours', value: '4' }, { label: '8 Hours', value: '8' }, { label: '12 Hours', value: '12' }, { label: 'Midnight', value: 'MN' }];

    _this.barCodeTypes = [{ label: 'CODE_128', value: 'CODE_128' }, { label: 'CODE_39', value: 'CODE_39' }, { label: 'CODABAR', value: 'CODABAR' }, { label: 'DATA_MATRIX', value: 'DATA_MATRIX' }, { label: 'EAN_13', value: 'EAN_13' }, { label: 'EAN_8', value: 'EAN_8' }, { label: 'ITF', value: 'ITF' }, { label: 'QR_CODE', value: 'QR_CODE' }, { label: 'UPC_A', value: 'UPC_A' }, { label: 'UPC_E', value: 'UPC_E' }, { label: 'PDF417', value: 'PDF417' }, { label: 'AZTEC', value: 'AZTEC' }];

    _this.userInfo = _this.User.getUser();
    _this.isVaultLiabilityChange = false;

    _this.fromTankerObj = {
      results: [],
      totalRecords: 0
    };

    _this.toTankerObj = {
      results: [],
      totalRecords: 0
    };

    _this.windowObj = {
      results: [],
      totalRecords: 0
    };

    _this.gettingSetupDetails = false;
    _this.branchCost = [];
    _this.deletedBranchCost = [];
    _this.timezoneList = [];
    return _this;
  }

  (0, _createClass3.default)(SetupEditController, [{
    key: 'mappingObjKeyVal',
    value: function mappingObjKeyVal(obj) {
      if (obj == null) return obj;
      obj.Key = obj.id + ' | ' + obj.name;
      obj.Value = obj.id;
      return obj;
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.loadDirective = false;
      this.gettingSetupDetails = true;
      this.isDuplicateBranchCost = true;
      this.isValidDistance = false;

      this.$q.all([this.Service.get(this.rawId), this.BranchService.all(null, 0, 100), this.VaultService.all(null, 0, 100), this.Service.all(null, 0, 100), this.CurrencyService.all(null, 0, _app2.default.defaultPageSize), this.momentTimeZone()]).then(function (data) {
        _this2.defaultModel = data[0];
        _this2.model.defaultSupervisorId = _this2.mappingUserDatas([data[0].defaultSupervisor]);
        _this2.defaultModel.currentVaultDate = _this2.DateUtil.convertToDate(_this2.defaultModel.currentVaultDate);
        _this2.model = angular.copy(_this2.defaultModel);
        _this2.model.serviceLocationTypes = Array.isArray(_this2.model.serviceLocationTypes) && _this2.model.serviceLocationTypes.length ? _this2.model.serviceLocationTypes : ['ATM'];
        _this2.serviceLocationTypeOptions.forEach(function (option) {
          option.ticked = _this2.model.serviceLocationTypes.includes(option.name);
        });
        _this2.selectedServiceLocationTypes = _this2.serviceLocationTypeOptions.filter(function (option) {
          return option.ticked;
        });
        _this2.setupData.currentVaultDate = _this2.model.currentVaultDate;
        _this2.model.fromLocationId = _this2.mappingObjKeyVal(_this2.defaultModel.fromLocation);
        _this2.model.tankerId = _this2.mappingObjKeyVal(_this2.defaultModel.tanker);
        _this2.model.virtualTankerId = _this2.mappingObjKeyVal(_this2.defaultModel.virtualTanker);
        _this2.model.holdRouteId = _this2.mappingObjKeyVal(_this2.defaultModel.holdRoute);
        _this2.model.unassignedRouteId = _this2.mappingObjKeyVal(_this2.defaultModel.unassignedRoute);
        _this2.model.confirmExitPassword = _this2.model.exitPassword ? _this2.model.exitPassword : null;
        _this2.model.alertThreshold = _this2.model.alertThreshold ? _this2.model.alertThreshold + '%' : null;
        _this2.model.defaultWindowId = _this2.mappingObjKeyVal(_this2.defaultModel.defaultWindow);
        _this2.model.defaultFromTankerId = _this2.mappingObjKeyVal(_this2.defaultModel.defaultFromTanker);
        _this2.model.defaultToTankerId = _this2.mappingObjKeyVal(_this2.defaultModel.defaultToTanker);
        _this2.prefixes = (0, _assign2.default)({ messenger: ["D"] }, _this2.model.prefixes);
        _this2.model.isNonUSLocation = _this2.model.country !== 'US' ? true : false;
        _this2.model.charactersRequired = _this2.model.pickupIdLength ? _this2.model.charactersRequired : 0, _this2.loadDirective = true;
        _this2.branchCost = _this2.defaultModel.branchCost;
        _this2.prioritizeTimezone(_this2.model.timezone);
        _this2.branchCostData = _.cloneDeep(_this2.defaultModel.branchCost);
        _this2.model.locationOnHold = _this2.model.locationOnHold ? _this2.model.locationOnHold : false;
        var branchesWithExistingSetupRecord = data[3].results.map(function (setupRecord) {
          return setupRecord.branchId;
        });

        _this2.branches = data[1].results.filter(function (branch) {
          return !branchesWithExistingSetupRecord.includes(branch.id) || _this2.defaultModel.branchId.includes(branch.id);
        }).map(function (branch) {
          return branch.id;
        });

        _this2.currencys = data[4].results.map(function (currency) {
          return currency.id;
        });
        _this2.vaults = data[2].results.map(function (vault) {
          return vault.id;
        });

        _this2.counters = (_this2.defaultModel.branchCounters || []).map(function (c) {
          return {
            id: c.id,
            name: c.name,
            serialNumber: c.serialNumber,
            originalName: c.name,
            originalSerial: c.serialNumber
          };
        });
        _this2.newCounters = [];
        _this2.updatedCounters = [];
        _this2.deletedCounterIds = [];

        if (!Array.isArray(_this2.model.availableCurrencyIds) || !_this2.model.availableCurrencyIds.length) {
          _this2.model.availableCurrencyIds = [_this2.model.currencyId || _this2.currencys[0]];
        }

        _this2.currencyOptions = data[4].results.map(function (currency) {
          return {
            id: currency.id,
            ticked: _this2.model.availableCurrencyIds && _this2.model.availableCurrencyIds.includes(currency.id)
          };
        });
      }).then(function () {
        _this2.loadBranchData();
        _this2.getBranchSupervisors();
      }).finally(function () {
        _this2.gettingSetupDetails = false;
      });
    }
  }, {
    key: 'momentTimeZone',
    value: function momentTimeZone() {
      var timezone = this.mappingTimezone();
      this.timezoneList = this.timezoneList.concat(timezone);
      this.totalTimezones = this.timezoneList.length;
    }
  }, {
    key: 'mappingTimezone',
    value: function mappingTimezone() {
      return moment.tz.names().map(function (item) {
        return { Key: item, Value: item };
      });
    }
  }, {
    key: 'prioritizeTimezone',
    value: function prioritizeTimezone(timezone) {
      if (!timezone) return;

      var existingIndex = this.timezoneList.findIndex(function (item) {
        return item.Value === timezone;
      });

      if (existingIndex > -1) {
        this.timezoneList.splice(existingIndex, 1);
      }

      this.model.timezone = {
        Key: timezone,
        Value: timezone
      };

      this.timezoneList.unshift(this.model.timezone);
      this.totalTimezones = this.timezoneList.length;
    }
  }, {
    key: 'searchSupervisorQuery',
    value: function searchSupervisorQuery() {
      var searchObj = {
        queryJSON: {
          rules: [{
            field: "supervisor",
            condition: "=",
            data: true
          }],
          operator: "AND"
        }
      };
      return searchObj.queryJSON.rules.length ? searchObj : null;
    }
  }, {
    key: 'getBranchSupervisors',
    value: function getBranchSupervisors() {
      var _this3 = this;

      this.Service.supervisorList(this.model.branchId).then(function (data) {
        _this3.supervisors = _this3.mappingUserDatas(data.results);
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'mappingUserDatas',
    value: function mappingUserDatas(users) {
      return users.map(function (user) {
        return {
          Key: user.userId + " | " + user.username,
          Value: user.userId
        };
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.$onInit();
      delete this.errors['password'];
      this.isVaultDateChanged = false;
      if (!Array.isArray(this.model.availableCurrencyIds) || !this.model.availableCurrencyIds.length) {
        this.model.availableCurrencyIds = [this.model.currencyId || this.currencys[0]];
      }
    }
  }, {
    key: 'submit',
    value: function submit(evt) {
      var _this4 = this;

      this.loading = true;

      this.errors = {};
      if (this.model.exitPassword && this.model.exitPassword !== this.model.confirmExitPassword) {
        this.errors['password'] = this.$translate.instant('setup.exitPasswordMismatch');
        return;
      }

      if (this.model.defaultFromTankerId && this.model.defaultToTankerId && this.model.defaultFromTankerId.Value === this.model.defaultToTankerId.Value) {
        this.loading = false;
        this.Modal.errorModal(this.$translate.instant('setup.tanker_error'));
        return;
      }

      if (!this.validateCounters()) {
        this.loading = false;
        return;
      }

      var branchCost = [];

      this.branchCost.forEach(function (bc) {
        bc.name = bc.name;
        bc.startDistance = bc.startDistance;
        bc.endDistance = bc.endDistance;
        bc.standardLoad = bc.standardLoad;
        bc.ecLoad = bc.ecLoad;
        bc.setupId = bc.setupId;
        bc.branchId = bc.branchId;
        bc.createdByUserId = bc.createdByUserId;
        delete bc.isDuplicate;
        delete bc.isValid;
        branchCost.push(_.cloneDeep(bc));
      });

      var bc = this.findDifferences(this.branchCostData, branchCost);

      this.model.fromLocationId = this.model.fromLocationId.Value;
      this.model.tankerId = this.model.tankerId ? this.model.tankerId.Value : null;
      this.model.virtualTankerId = this.model.virtualTankerId ? this.model.virtualTankerId.Value : null;
      this.model.holdRouteId = this.model.holdRouteId ? this.model.holdRouteId.Value : null;
      this.model.unassignedRouteId = this.model.unassignedRouteId ? this.model.unassignedRouteId.Value : null;
      this.model.currentVaultDate = moment(this.model.currentVaultDate).format('YYYY-MM-DD');
      this.model.limitPerATMDeposit = this.model.limitPerATMDeposit ? this.model.limitPerATMDeposit : null;
      this.model.packCharLength = this.model.packCharLength || 0;
      this.model.isVaultDateChanged = this.isVaultDateChanged;
      this.model.oldVaultDate = moment(this.setupData.currentVaultDate).format('YYYY-MM-DD');
      this.model.gpsLat = this.model.gpsLat ? parseFloat(this.model.gpsLat) : 0.0;
      this.model.gpsLong = this.model.gpsLong ? parseFloat(this.model.gpsLong) : 0.0;
      this.model.limitPerRoute = this.model.limitPerRoute ? this.model.limitPerRoute : null;
      this.model.alertThreshold = this.model.alertThreshold ? this.convertStr(this.model.alertThreshold) : null;
      this.model.vaultLiability = this.model.vaultLiability ? this.model.vaultLiability : null;
      this.model.defaultWindowId = this.model.defaultWindowId ? this.model.defaultWindowId.Value : null;
      this.model.defaultFromTankerId = this.model.defaultFromTankerId ? this.model.defaultFromTankerId.Value : null;
      this.model.defaultToTankerId = this.model.defaultToTankerId ? this.model.defaultToTankerId.Value : null;
      this.model.country = this.model.isNonUSLocation ? this.model.country : 'US', this.model.branchCost = bc;
      this.model.deletedBranchCost = this.deletedBranchCost;
      this.model.userId = this.User.getUser().id;
      this.model.barcodeType = !this.model.autoDetectScannerCode ? this.model.barcodeType : null;
      this.model.checksumDigits = this.model.enforceChecksum ? this.model.checksumDigits : null;
      this.model.locationOnHold = this.model.locationOnHold ? this.model.locationOnHold : false;
      this.model.branchCost.forEach(function (d) {
        d.modifiedByUserId = _this4.User.getUser().id;
      });
      this.model.timezone = this.model.timezone ? this.model.timezone.Value : null;

      var validCounters = [];
      var newCounters = [];
      var updatedCounters = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.counters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var c = _step.value;

          var name = (c.name || '').trim();
          var serial = (c.serialNumber || '').trim();

          if (name && serial) {
            validCounters.push(c);

            if (!c.id) {
              newCounters.push(c);
            } else {
              var nameChanged = name !== (c.originalName || '').trim();
              var serialChanged = serial !== (c.originalSerial || '').trim();
              if (nameChanged || serialChanged) {
                updatedCounters.push(c);
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.model.newCounters = newCounters;
      this.model.updatedCounters = updatedCounters;
      this.model.deletedCounterIds = this.deletedCounterIds;

      var payload = (0, _extends3.default)({}, this.model);
      payload.serviceLocationTypes = this.selectedServiceLocationTypes.map(function (option) {
        return option.name;
      });

      payload.availableCurrencyIds = Array.isArray(this.model.availableCurrencyIds) ? this.model.availableCurrencyIds.map(function (o) {
        return o.id;
      }) : [];

      this.Service.update(this.rawId, payload).then(function (data) {
        var liabilityObj = {
          isVaultLiabilityChange: _this4.isVaultLiabilityChange,
          vaultLiability: _this4.calculateLability(_this4.model.vaultLiability, _this4.model.alertThreshold),
          branchId: _this4.model.branchId
        };
        _this4.$rootScope.$broadcast('updateBranchLiability', liabilityObj);
        window.history.go(-1);
      }).catch(function (err) {
        _this4.Modal.errorModal(err.data.message);
      }).finally(function () {
        _this4.loading = false;
      });
    }
  }, {
    key: 'loadBranchData',
    value: function loadBranchData() {
      this.loadInternalLocations('', 0);
      this.loadTanker('', 0);
      this.loadUnassignedRoutes('', 0);
      this.loadHoldRoutes('', 0);
      this.loadVirtualTanker('', 0);
      this.getBranchWindow('', 0);
      this.loadFromTanker('', 0);
      this.loadToTanker('', 0);
    }
  }, {
    key: 'addCounter',
    value: function addCounter() {
      this.counters = this.counters || [];
      this.counters.push({ name: '', serialNumber: '' });
    }
  }, {
    key: 'removeCounter',
    value: function removeCounter(index) {
      var c = this.counters[index];
      if (c && c.id) this.deletedCounterIds.push(c.id);
      this.counters.splice(index, 1);
    }
  }, {
    key: 'checkDuplicateSerials',
    value: function checkDuplicateSerials() {
      this.counters = this.counters || [];
      var serialSet = new _set2.default();

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.counters), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var c = _step2.value;

          var name = (c.name || '').trim();
          var serial = (c.serialNumber || '').trim();

          if (name && serial) {
            var serialLower = serial.toLowerCase();
            if (serialSet.has(serialLower)) {
              return true;
            }
            serialSet.add(serialLower);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    }
  }, {
    key: 'validateCounters',
    value: function validateCounters() {
      if (this.checkDuplicateSerials()) {
        this.Modal.errorModal(this.$translate.instant('setup.duplicateSerial'));
        return false;
      }
      return true;
    }
  }, {
    key: 'loadInternalLocations',
    value: function loadInternalLocations(searchKey, offset) {
      var _this5 = this;

      searchKey = searchKey || '';

      var locationSearchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          }, {
            field: 'locationType',
            condition: '=',
            data: 'INTERNAL'
          }, {
            field: 'active',
            condition: '=',
            data: true
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };
      if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
        offset = offset - 1;
      }

      this.LocationService.getAllLocation(locationSearchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        var selectedVal = _this5.model.fromLocationId ? _this5.model.fromLocationId.Value : '';
        if (offset === 0 || offset == undefined) {
          _this5.totalLocation = data.total;
          _this5.locations = _this5.mapData(data.results, searchKey, selectedVal);
          if (!searchKey && selectedVal) {
            _this5.locations.unshift(_this5.model.fromLocationId);
          }
        } else {
          var locations = _this5.mapData(data.results, searchKey, selectedVal);
          _this5.locations = _this5.locations.concat(locations);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'getRoutes',
    value: function getRoutes(searchKey, offset) {
      searchKey = searchKey || '';
      var routeSearchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      var routeDefer = this.$q.defer();
      this.RouteService.all(routeSearchObj, offset, _app2.default.defaultPageLimit).then(function (routes) {
        routeDefer.resolve(routes);
      }).catch(function (err) {
        routeDefer.reject(err);
      });
      return routeDefer.promise;
    }
  }, {
    key: 'loadHoldRoutes',
    value: function loadHoldRoutes(searchKey, offset) {
      var _this6 = this;

      if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
        offset = offset - 1;
      }

      this.getRoutes(searchKey, offset).then(function (data) {
        var selectedVal = _this6.model.holdRouteId ? _this6.model.holdRouteId.Value : '';
        if (offset === 0 || offset == undefined) {
          _this6.totalRoute = data.total;
          _this6.routes = _this6.mapData(data.results, searchKey, selectedVal);
          if (!searchKey && selectedVal) {
            _this6.routes.unshift(_this6.model.holdRouteId);
          }
        } else {
          var routes = _this6.mapData(data.results, searchKey, selectedVal);
          _this6.routes = _this6.routes.concat(routes);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'loadUnassignedRoutes',
    value: function loadUnassignedRoutes(searchKey, offset) {
      var _this7 = this;

      if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
        offset = offset - 1;
      }

      this.getRoutes(searchKey, offset).then(function (data) {
        var selectedVal = _this7.model.unassignedRouteId ? _this7.model.unassignedRouteId.Value : '';
        if (offset === 0 || offset == undefined) {
          _this7.totalUnassignedRoute = data.total;
          _this7.unassignedRoutes = _this7.mapData(data.results, searchKey, selectedVal);
          if (!searchKey && selectedVal) {
            _this7.unassignedRoutes.unshift(_this7.model.unassignedRouteId);
          }
        } else {
          var routes = _this7.mapData(data.results, searchKey, selectedVal);
          _this7.unassignedRoutes = _this7.unassignedRoutes.concat(routes);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }

    // get tanker data

  }, {
    key: 'loadTanker',
    value: function loadTanker(searchKey, offset) {
      var _this8 = this;

      if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
        offset = offset - 1;
      }

      this.getTanker(searchKey, offset).then(function (tankerData) {
        var selectedVal = _this8.model.tankerId ? _this8.model.tankerId.Value : '';
        if (offset === 0 || offset == undefined) {
          _this8.totalTanker = tankerData.total;
          _this8.tankers = _this8.mapData(tankerData.results, searchKey, selectedVal);
          if (!searchKey && selectedVal) {
            _this8.tankers.unshift(_this8.model.tankerId);
          }
        } else {
          var tankers = _this8.mapData(tankerData.results, searchKey, selectedVal);
          _this8.tankers = _this8.tankers.concat(tankers);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'loadVirtualTanker',
    value: function loadVirtualTanker(searchKey, offset) {
      var _this9 = this;

      if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
        offset = offset - 1;
      }
      this.getTanker(searchKey, offset).then(function (tankerData) {
        var selectedVal = _this9.model.virtualTankerId ? _this9.model.virtualTankerId.Value : '';
        if (offset === 0 || offset == undefined) {
          _this9.totalVirtualTanker = tankerData.total;
          _this9.virtualTankers = _this9.mapData(tankerData.results, searchKey, selectedVal);
          if (!searchKey && selectedVal) {
            _this9.virtualTankers.unshift(_this9.model.virtualTankerId);
          }
        } else {
          var tankers = _this9.mapData(tankerData.results, searchKey, selectedVal);
          _this9.virtualTankers = _this9.virtualTankers.concat(tankers);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'getTanker',
    value: function getTanker(searchKey, offset) {
      searchKey = searchKey || '';
      var tankerSearchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          }, {
            field: 'locationType',
            condition: '=',
            data: 'TANKER'
          }, {
            field: 'active',
            condition: '=',
            data: true
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: "AND"
        }
      };

      var deferred = this.$q.defer();
      this.LocationService.getAllLocation(tankerSearchObj, offset, _app2.default.defaultPageLimit).then(function (tankerData) {
        deferred.resolve(tankerData);
      }).catch(function (e) {
        return deferred.reject(e);
      });
      return deferred.promise;
    }
  }, {
    key: 'mapData',
    value: function mapData(mapArray, searchKey, originalVal) {
      var newArray = [];
      mapArray.map(function (obj) {
        if (!searchKey && originalVal) {
          if (obj.id !== originalVal) {
            obj.Key = obj.id + " | " + obj.name;
            obj.Value = obj.id;
            newArray.push(obj);
          }
        } else {
          obj.Key = obj.id + " | " + obj.name;
          obj.Value = obj.id;
          newArray.push(obj);
        }
      });
      return newArray;
    }
  }, {
    key: 'vaultDateChanged',
    value: function vaultDateChanged() {
      var _this10 = this;

      var keys = ['currentVaultDate'];
      this.isVaultDateChanged = keys.some(function (key) {
        return moment(_this10.setupData[key]).format('YYYY-MM-DD') !== moment(_this10.model[key]).format('YYYY-MM-DD');
      });
    }
  }, {
    key: 'showPassword',
    value: function showPassword(type) {
      this.passWdIcon[type] = !this.passWdIcon[type];
    }
  }, {
    key: 'isAllowToChangeVaultSDate',
    value: function isAllowToChangeVaultSDate() {
      var config = this.Configs.getEnvironmentConfig();
      var usersString = config && config.permissions && config.permissions.changeVaultDate ? config.permissions.changeVaultDate.users : '';
      var hasConfigPerm = false;
      if (usersString) {
        var userList = usersString.split(',').map(function (u) {
          return u.trim().toLowerCase();
        });
        var firstName = this.User.getUser().firstName ? this.User.getUser().firstName.trim().toLowerCase() : '';
        var lastName = this.User.getUser().lastName ? this.User.getUser().lastName.trim().toLowerCase() : '';

        var nameFormat1 = firstName + ' ' + lastName;
        var nameFormat2 = lastName + ' ' + firstName;
        hasConfigPerm = userList.includes(nameFormat1) || userList.includes(nameFormat2);
      }
      return hasConfigPerm;
    }
  }, {
    key: 'ngPercentage',
    value: function ngPercentage() {
      if (this.model.alertThreshold && !this.model.alertThreshold.endsWith('%')) {
        return this.model.alertThreshold = this.model.alertThreshold + '%';
      }
    }
  }, {
    key: 'convertStr',
    value: function convertStr(str) {
      if (!str || typeof str !== 'string') return;
      return Number(str.replace('%', ''));
    }
  }, {
    key: 'removePrecentageSign',
    value: function removePrecentageSign() {
      if (this.model.alertThreshold && this.model.alertThreshold.endsWith('%')) {
        return this.model.alertThreshold = this.model.alertThreshold.replace('%', '');
      }
    }
  }, {
    key: 'validateVaultLiability',
    value: function validateVaultLiability() {
      var currentLiability = this.defaultModel.vaultLiability;
      var currentAlertThreshold = this.defaultModel.alertThreshold;

      var updatedVaultLiability = this.model.vaultLiability ? this.model.vaultLiability : null;
      var updatedAlertThreshold = this.model.alertThreshold ? this.convertStr(this.model.alertThreshold) : null;

      if (currentLiability !== updatedVaultLiability || currentAlertThreshold !== updatedAlertThreshold) {
        this.isVaultLiabilityChange = true;
      } else this.isVaultLiabilityChange = false;
    }
  }, {
    key: 'calculateLability',
    value: function calculateLability(vaultLiability, alertThreshold) {
      if (!vaultLiability) return 0;else if (vaultLiability >= 0 && !alertThreshold) return vaultLiability;else if (!vaultLiability && !alertThreshold) return 0;else return Math.abs((vaultLiability / 100 * alertThreshold).toFixed(2));
    }
  }, {
    key: 'onPrintPack',
    value: function onPrintPack() {
      // this.model.printPrePack = !this.model.printPackLabel;
      if (this.model.printPackLabel && !this.model.printPrePack) {
        this.model.printPrePack = true;
      } else this.model.printPackLabel = this.model.printPackLabel;
    }
  }, {
    key: 'onPrePrintPack',
    value: function onPrePrintPack() {
      // this.model.printPackLabel = !this.model.printPrePack;
      if (this.model.printPrePack && !this.model.printPackLabel) {
        this.model.printPackLabel = true;
      } else this.model.printPrePack = this.model.printPrePack;
    }
  }, {
    key: 'getBranchWindow',
    value: function getBranchWindow(searchKey, offset) {
      var _this11 = this;

      searchKey = searchKey || '';

      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          }, {
            field: 'locationType',
            condition: '=',
            data: 'WINDOW'
          }, {
            field: 'active',
            condition: '=',
            data: true
          }, {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }, {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };

      return this.LocationService.getAllLocation(searchObj, offset, _app2.default.defaultPageLimit).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this11.windowObj.results = _this11.mapData(data.results);
          _this11.windowObj.totalRecords = data.total;
        } else {
          var locations = _this11.mapData(data.results);
          _this11.windowObj.results = _this11.windowObj.results.concat(locations);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'loadFromTanker',
    value: function loadFromTanker(searchKey, offset) {
      var _this12 = this;

      this.getTanker(searchKey, offset).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this12.fromTankerObj.results = _this12.mapData(data.results);
          _this12.fromTankerObj.totalRecords = data.total;
        } else {
          var tankers = _this12.mapData(data.results);
          _this12.fromTankerObj.results = _this12.fromTankerObj.results.concat(tankers);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'loadToTanker',
    value: function loadToTanker(searchKey, offset) {
      var _this13 = this;

      this.getTanker(searchKey, offset).then(function (data) {
        if (offset === 0 || offset == undefined) {
          _this13.toTankerObj.results = _this13.mapData(data.results);
          _this13.toTankerObj.totalRecords = data.total;
        } else {
          var tankers = _this13.mapData(data.results);
          _this13.toTankerObj.results = _this13.toTankerObj.results.concat(tankers);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'resetText',
    value: function resetText() {
      this.model.state = null;
      this.model.country = null;
    }
  }, {
    key: 'addNewCost',
    value: function addNewCost(event) {
      this.branchCost.push({
        name: null,
        startDistance: null,
        endDistance: null,
        standardLoad: null,
        ecLoad: null,
        setupId: this.rawId,
        branchId: this.model.branchId,
        createdByUserId: this.User.getUser().id,
        modifiedByUserId: this.User.getUser().id,
        status: 'Create'
      });
      event.preventDefault();
    }
  }, {
    key: 'removeCost',
    value: function removeCost(index) {
      this.deletedBranchCost.push(this.branchCost[index].id);
      this.branchCost.splice(index, 1);
      this.validateDistance();
      this.validateBranchCost();
    }
  }, {
    key: 'validateDistance',
    value: function validateDistance() {
      this.branchCost.forEach(function (bc) {
        return bc.isValid = false;
      });

      for (var i = 0; i < this.branchCost.length; i++) {
        var currentCost = this.branchCost[i];
        var startDistance = parseFloat(currentCost.startDistance);
        var endDistance = parseFloat(currentCost.endDistance);

        currentCost.isValid = startDistance >= endDistance;
      }

      this.isValidDistance = this.branchCost.some(function (bc) {
        return bc.isValid;
      });
    }
  }, {
    key: 'validateBranchCost',
    value: function validateBranchCost() {
      var _this14 = this;

      this.branchCost = _.map(this.branchCost, function (mainObj, mainObjIndex) {
        mainObj.isDuplicate = false;
        var eq = _.find(_this14.branchCost, function (compairObject, compairObjIndex) {
          if (mainObjIndex > compairObjIndex) {
            return compairObject.startDistance === mainObj.startDistance && compairObject.endDistance === mainObj.endDistance;
          }
        });
        if (eq) {
          mainObj.isDuplicate = true;
          return mainObj;
        } else {
          return mainObj;
        }
      });

      var isValid = this.branchCost.map(function (obj) {
        if (obj.isDuplicate) return true;
      });

      this.isDuplicateBranchCost = isValid.indexOf(true) >= 0 ? false : true;
    }
  }, {
    key: 'findDifferences',
    value: function findDifferences(obj1Array, obj2Array) {
      var _this15 = this;

      var resultObjects = [];

      obj2Array.forEach(function (obj2) {
        var obj1 = obj1Array.find(function (o) {
          return o.id === obj2.id;
        });
        if (obj1) {
          var isUpdated = _this15.compareObjects(obj1, obj2);
          var updatedObject = (0, _extends3.default)({}, obj2, { status: isUpdated ? 'Update' : 'no Change' });
          resultObjects.push(updatedObject);
        } else {
          resultObjects.push((0, _extends3.default)({}, obj2, { status: 'Create' }));
        }
      });

      return resultObjects;
    }
  }, {
    key: 'compareObjects',
    value: function compareObjects(obj1, obj2) {
      for (var key in obj1) {
        if (obj1.hasOwnProperty(key)) {
          if ((0, _typeof3.default)(obj1[key]) === 'object' && obj1[key] !== null && obj2[key] !== null) {
            if ((0, _stringify2.default)(obj1[key]) !== (0, _stringify2.default)(obj2[key])) {
              return true;
            }
          } else if (obj1[key] !== obj2[key]) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: 'isAllDataFilled',
    value: function isAllDataFilled() {
      return this.branchCost.every(function (bc) {
        return bc.name && bc.startDistance !== null && bc.startDistance !== undefined && bc.startDistance !== "" && bc.endDistance !== null && bc.endDistance !== undefined && bc.endDistance !== "" && bc.standardLoad !== null && bc.standardLoad !== undefined && bc.standardLoad !== "" && bc.ecLoad !== null && bc.ecLoad !== undefined && bc.ecLoad !== "";
      });
    }
  }, {
    key: 'onAvailableCurrenciesChange',
    value: function onAvailableCurrenciesChange() {
      var _this16 = this;

      // Defensive: handle undefined or non-array
      if (!Array.isArray(this.model.availableCurrencyIds)) {
        this.model.availableCurrencyIds = [];
      }
      if (this.model.availableCurrencyIds.length === 1) {
        this.model.currencyId = this.model.availableCurrencyIds[0].id;
        return;
      }
      var currentCurrencyExists = this.model.availableCurrencyIds.some(function (curr) {
        return curr.id === _this16.model.currencyId;
      });
      if (!currentCurrencyExists && this.model.availableCurrencyIds.length > 0) {
        this.model.currencyId = this.model.availableCurrencyIds[0].id;
      }
    }
  }]);
  return SetupEditController;
}(_setupBase2.default);

exports.default = SetupEditController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setup = __webpack_require__(2313);

var _setup2 = _interopRequireDefault(_setup);

var _create = __webpack_require__(2306);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2309);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2302);

var _all2 = _interopRequireDefault(_all);

var _prefixTable = __webpack_require__(2305);

var _prefixTable2 = _interopRequireDefault(_prefixTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupModule = angular.module('route', [_create2.default, _edit2.default, _all2.default]).component('setup', _setup2.default).component('prefixTable', _prefixTable2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('setup.edit', {
    url: '/edit/:id',
    component: 'setupedit',
    data: {
      requireACL: 'tnt_control_branch_setup.edit'
    }
  }).state('setup.create', {
    url: '/create',
    component: 'setupcreate',
    data: {
      requireACL: 'tnt_control_branch_setup.create'
    }
  }).state('setup.all', {
    url: '/all/:page',
    component: 'setupall',
    data: {
      // requireACL: 'tnt_control_branch_setup.view'
    }
  });
}]).name;

exports.default = setupModule;

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setup = __webpack_require__(2870);

var _setup2 = _interopRequireDefault(_setup);

var _setup3 = __webpack_require__(2314);

var _setup4 = _interopRequireDefault(_setup3);

__webpack_require__(3141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setupComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _setup2.default,
  controller: _setup4.default
};

exports.default = setupComponent;

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SetupController = function (_TNTControlBase) {
  SetupController.$inject = ["$state"];
  (0, _inherits3.default)(SetupController, _TNTControlBase);

  /*@ngInject*/
  function SetupController($state) {
    (0, _classCallCheck3.default)(this, SetupController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SetupController.__proto__ || (0, _getPrototypeOf2.default)(SetupController)).call(this));

    _this.$state = $state;
    _this.id = "setup";
    _this._id = 'branch_setup';
    _this.acl = {};
    _this.hasACL = {};

    return _this;
  }

  (0, _createClass3.default)(SetupController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(SetupController.prototype.__proto__ || (0, _getPrototypeOf2.default)(SetupController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_control_' + this._id]) {
        this.hasACL[this.acl['tnt_control_' + this._id][key]] = true;
      }
    }
  }]);
  return SetupController;
}(_TNTControlBase3.default);

exports.default = SetupController;

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shiptypeAll = __webpack_require__(2316);

var _shiptypeAll2 = _interopRequireDefault(_shiptypeAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shiptypeallModule = angular.module('shiptypeall', []).component('shiptypeall', _shiptypeAll2.default).name;

exports.default = shiptypeallModule;

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shiptypeAll = __webpack_require__(2871);

var _shiptypeAll2 = _interopRequireDefault(_shiptypeAll);

var _shiptypeAll3 = __webpack_require__(2317);

var _shiptypeAll4 = _interopRequireDefault(_shiptypeAll3);

__webpack_require__(3142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shiptypeallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _shiptypeAll2.default,
  controller: _shiptypeAll4.default
};

exports.default = shiptypeallComponent;

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _shiptypeBase = __webpack_require__(283);

var _shiptypeBase2 = _interopRequireDefault(_shiptypeBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiptypeallController = function (_ShiptypeBaseControll) {
  ShiptypeallController.$inject = ["Auth", "$state", "User", "Modal", "ShiptypeService", "$translate", "$stateParams", "$scope", "$location"];
  (0, _inherits3.default)(ShiptypeallController, _ShiptypeBaseControll);

  /*@ngInject*/
  function ShiptypeallController(Auth, $state, User, Modal, ShiptypeService, $translate, $stateParams, $scope, $location) {
    (0, _classCallCheck3.default)(this, ShiptypeallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShiptypeallController.__proto__ || (0, _getPrototypeOf2.default)(ShiptypeallController)).call(this, Auth, $state, User, ShiptypeService, Modal, $translate, $stateParams, $location));

    _this.id = 'shiptype.all';
    _this.loading = true;
    _this.shiptypes = [];
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.hasACL = {};
    _this.searchText = '';
    _this._status = 'all';
    _this.shipTypeList = ['all', 'active', 'inActive', 'types'];
    _this.userStatus = _this.shipTypeList.map(function (list) {
      return {
        value: list,
        label: $translate.instant('ship_types.' + list)
      };
    });
    _this.$location = $location;
    _this.branchId = _this.User.getUser().branchId;
    return _this;
  }

  (0, _createClass3.default)(ShiptypeallController, [{
    key: '$onInit',
    value: function $onInit() {
      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
    }
  }, {
    key: 'edit',
    value: function edit(shiptype) {
      this.$state.go('shiptype.edit', {
        id: shiptype.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(shiptype) {
      var _this2 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + shiptype.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this2.Service.remove(shiptype.id, _this2.branchId).then(function (data) {
            _this2.allowOnlyOnce = false;
            modal.close();
            _this2.refresh();
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this2.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData(search) {
      var _this3 = this;

      var searchObj = this.generateSearchObj();

      this.loading = true;
      this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this3.total = data.total;
        _this3.loading = false;
        _this3.shiptypes = data.results;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.error = err.message;
      });
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      var searchObj = {
        queryJSON: {
          rules: [{
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + this.searchText + '%'
              }, {
                field: 'description',
                condition: 'like',
                data: '%' + this.searchText + '%'
              }],
              operator: 'OR'
            }
          }],
          operator: 'AND'
        }
      };
      switch (this._status) {
        case 'active':
          {
            searchObj.queryJSON.rules.push({
              field: 'status',
              condition: '=',
              data: true
            });
            break;
          }
        case 'inActive':
          {
            searchObj.queryJSON.rules.push({
              field: 'status',
              condition: '=',
              data: false
            });
            break;
          }
      }
      return searchObj;
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(shiptype) {
      shiptype.expand = !shiptype.expand;
    }
  }]);
  return ShiptypeallController;
}(_shiptypeBase2.default);

exports.default = ShiptypeallController;

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shiptypeCreate = __webpack_require__(2319);

var _shiptypeCreate2 = _interopRequireDefault(_shiptypeCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shiptypeCreateModule = angular.module('shiptypecreate', []).component('shiptypecreate', _shiptypeCreate2.default).name;

exports.default = shiptypeCreateModule;

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shiptypeCreate = __webpack_require__(2872);

var _shiptypeCreate2 = _interopRequireDefault(_shiptypeCreate);

var _shiptypeCreate3 = __webpack_require__(2320);

var _shiptypeCreate4 = _interopRequireDefault(_shiptypeCreate3);

__webpack_require__(3143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shiptypeCreateComponent = {
  restrict: 'E',
  bindings: {},
  template: _shiptypeCreate2.default,
  controller: _shiptypeCreate4.default
};

exports.default = shiptypeCreateComponent;

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _shiptypeBase = __webpack_require__(283);

var _shiptypeBase2 = _interopRequireDefault(_shiptypeBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiptypeCreateController = function (_ShiptypeBaseControll) {
  ShiptypeCreateController.$inject = ["Auth", "$state", "User", "ShiptypeService", "Modal", "$translate", "$stateParams", "CommonLayoutService"];
  (0, _inherits3.default)(ShiptypeCreateController, _ShiptypeBaseControll);

  /*@ngInject*/
  function ShiptypeCreateController(Auth, $state, User, ShiptypeService, Modal, $translate, $stateParams, CommonLayoutService) {
    (0, _classCallCheck3.default)(this, ShiptypeCreateController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShiptypeCreateController.__proto__ || (0, _getPrototypeOf2.default)(ShiptypeCreateController)).call(this, Auth, $state, User, ShiptypeService, Modal, $translate, $stateParams));

    _this.Auth = Auth;
    _this.$state = $state;
    _this.User = User;
    _this.CommonLayoutService = CommonLayoutService;
    _this.message = 'Shiptype create';
    _this.defaultModel = {
      id: '',
      status: true,
      description: '',
      amountFlag: true,
      unitValue: '',
      amount: '',
      coinFlag: false,
      hhtFlag: true,
      batchField: '',
      sortOrder: 1,
      denominationType: null,
      countable: false,
      daysToCount: null,
      selectedFiles: []
    };
    _this.branchId = _this.User.getUser().branchId;

    _this.model = angular.copy(_this.defaultModel);

    _this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: _this.$translate.instant('common.yes'),
        off: _this.$translate.instant('common.no')
      },
      onColor: 'success',
      offColor: 'danger'
    };
    _this.denominationTypes = _this.CommonLayoutService.denominationTypes();
    return _this;
  }

  (0, _createClass3.default)(ShiptypeCreateController, [{
    key: 'reset',
    value: function reset() {
      this.model = angular.copy(this.defaultModel);
      this.clearErrors();
    }
  }, {
    key: 'submit',
    value: function submit(evt) {
      var _this2 = this;

      this.loading = true;

      var shiptypeIcon = [];
      if (this.model.selectedFiles && this.model.selectedFiles.length && this.model.selectedFiles[0].hasOwnProperty('base64Data')) {
        this.model.selectedFiles.forEach(function (d) {
          shiptypeIcon.push({ base64String: d.base64Data, fileName: _this2.rawId + '.png' });
        });
      }

      this.Service.create({
        id: this.model.id,
        status: this.model.status,
        description: this.model.description,
        amountFlag: this.model.amountFlag,
        amount: this.model.amountFlag ? this.model.amount : 0,
        unitValue: this.model.unitValue,
        coinFlag: this.model.coinFlag,
        hhtFlag: this.model.hhtFlag,
        batchField: this.model.batchField,
        sortOrder: this.model.sortOrder,
        denominationType: this.model.denominationType,
        countable: this.model.countable,
        daysToCount: this.model.daysToCount === '' ? null : this.model.daysToCount,
        shiptypeIcon: shiptypeIcon
      }, this.branchId).then(function (data) {
        _this2.loading = false;
        _this2.askCreate();
      }).catch(function (err) {
        _this2.loading = false;
        err.data.errors.map(function (e) {
          _this2.errorMessage += e.message + '<br/>';
        });
      });
    }
  }]);
  return ShiptypeCreateController;
}(_shiptypeBase2.default);

exports.default = ShiptypeCreateController;

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shiptypeEdit = __webpack_require__(2322);

var _shiptypeEdit2 = _interopRequireDefault(_shiptypeEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shiptypeEditModule = angular.module('shiptypeedit', []).component('shiptypeedit', _shiptypeEdit2.default).name;

exports.default = shiptypeEditModule;

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shiptypeEdit = __webpack_require__(2873);

var _shiptypeEdit2 = _interopRequireDefault(_shiptypeEdit);

var _shiptypeEdit3 = __webpack_require__(2323);

var _shiptypeEdit4 = _interopRequireDefault(_shiptypeEdit3);

__webpack_require__(3144);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shiptypeeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _shiptypeEdit2.default,
  controller: _shiptypeEdit4.default
};

exports.default = shiptypeeditComponent;

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _shiptypeBase = __webpack_require__(283);

var _shiptypeBase2 = _interopRequireDefault(_shiptypeBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiptypeEditController = function (_ShiptypeBaseControll) {
	ShiptypeEditController.$inject = ["Auth", "$state", "User", "ShiptypeService", "Modal", "$translate", "$stateParams", "CommonLayoutService"];
	(0, _inherits3.default)(ShiptypeEditController, _ShiptypeBaseControll);

	/*@ngInject*/
	function ShiptypeEditController(Auth, $state, User, ShiptypeService, Modal, $translate, $stateParams, CommonLayoutService) {
		(0, _classCallCheck3.default)(this, ShiptypeEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (ShiptypeEditController.__proto__ || (0, _getPrototypeOf2.default)(ShiptypeEditController)).call(this, Auth, $state, User, ShiptypeService, Modal, $translate, $stateParams));

		_this.pageName = 'shiptype';
		_this.Auth = Auth;
		_this.$state = $state;
		_this.User = User;
		_this.CommonLayoutService = CommonLayoutService;
		_this.message = 'Shiptype create';
		_this.rawId = '';
		_this.defaultModel = {
			id: '',
			description: '',
			status: true,
			amountFlag: false,
			unitValue: '',
			amount: '',
			coinFlag: false,
			hhtFlag: true,
			batchField: '',
			sortOrder: 1,
			denominationType: null,
			countable: false,
			daysToCount: null,
			selectedFiles: []
		};
		_this.model = angular.copy(_this.defaultModel);
		_this.toggleSwitchUI = {
			size: 'small',
			label: {
				on: _this.$translate.instant('common.yes'),
				off: _this.$translate.instant('common.no')
			},
			onColor: 'success',
			offColor: 'danger'
		};
		_this.branchId = _this.User.getUser().branchId;
		_this.denominationTypes = _this.CommonLayoutService.denominationTypes();
		return _this;
	}

	(0, _createClass3.default)(ShiptypeEditController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.model.loading = true;
			this.Service.get(this.$stateParams.id).then(function (data) {
				_this2.defaultModel = data;
				_this2.rawId = data.id;
				_this2.model.id = data.id;
				_this2.model.status = data.status;
				_this2.model.description = data.description;
				_this2.model.amountFlag = data.amountFlag;
				_this2.model.amount = _this2.model.amountFlag || data.amount ? data.amount : null;
				_this2.model.unitValue = data.unitValue;
				_this2.model.coinFlag = data.coinFlag;
				_this2.model.hhtFlag = data.hhtFlag;
				_this2.model.batchField = data.batchField;
				_this2.model.sortOrder = data.sortOrder;
				_this2.model.denominationType = data.denominationType;
				_this2.model.countable = data.countable;
				_this2.model.daysToCount = data.daysToCount;
				_this2.model.isIconExists = data.isIconExists;
				// this.model.imageData = data.imageData;
			}).catch(function (err) {
				console.log(err);
			}).finally(function () {
				_this2.model.loading = false;
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.model = angular.copy(this.defaultModel);
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this3 = this;

			this.loading = true;
			var shiptypeIcon = [];
			if (this.model.selectedFiles && this.model.selectedFiles.length && this.model.selectedFiles[0].hasOwnProperty('base64Data')) {
				this.model.selectedFiles.forEach(function (d) {
					shiptypeIcon.push({ base64String: d.base64Data, fileName: _this3.rawId + '.png' });
				});
			}
			var changedObj = this.findDifferencesWithReturn(this.defaultModel, this.model);
			this.Service.update(this.rawId, {
				id: this.rawId,
				status: this.model.status,
				description: this.model.description,
				amountFlag: this.model.amountFlag,
				amount: this.model.amountFlag ? this.model.amount : 0,
				unitValue: this.model.unitValue,
				coinFlag: this.model.coinFlag,
				hhtFlag: this.model.hhtFlag,
				batchField: this.model.batchField,
				sortOrder: this.model.sortOrder,
				denominationType: this.model.denominationType,
				countable: this.model.countable,
				daysToCount: this.model.daysToCount === '' ? null : this.model.daysToCount,
				shiptypeIcon: shiptypeIcon
			}, this.branchId, changedObj).then(function (data) {
				_this3.loading = false;
				window.history.go(-1);
			}).catch(function (err) {
				_this3.loading = false;
				err.data.errors.map(function (e) {
					_this3.errorMessage += e.message + '<br/>';
				});
			});
		}
	}, {
		key: 'findDifferencesWithReturn',
		value: function findDifferencesWithReturn(objA, objB) {
			function compareObjects(obj1, obj2) {
				var diff = {};

				for (var key in obj1) {
					if (obj1.hasOwnProperty(key)) {

						if (['locationDenomination', 'locationScheduleRecurringData', 'scheduledLocations'].includes(key)) {
							continue; // Skip these keys
						}

						if ((0, _typeof3.default)(obj1[key]) === 'object' && obj1[key] !== null && obj2[key] !== null) {
							if (Array.isArray(obj1[key])) {
								if ((0, _stringify2.default)(obj1[key]) !== (0, _stringify2.default)(obj2[key])) {
									diff[key] = {
										"Old Value": obj1[key],
										"Updated Value": obj2[key]
									};
								}
							} else if (obj2[key] !== undefined && obj1[key] !== undefined) {
								var nestedDiff = compareObjects(obj1[key], obj2[key]);
								if ((0, _keys2.default)(nestedDiff).length > 0) {
									diff[key] = nestedDiff;
								}
							}
						} else if (obj1[key] !== obj2[key] && obj2[key] !== undefined && obj1[key] !== undefined) {
							if (key === 'status') {
								diff[key] = {
									"Old Value": obj1[key] ? "Active" : "Suspended",
									"Updated Value": obj2[key] ? "Active" : "Suspended"
								};
							} else {
								diff[key] = {
									"Old Value": obj1[key],
									"Updated Value": obj2[key]
								};
							}
						}
					}
				}
				return diff;
			}
			return compareObjects(objA, objB);
		}
	}, {
		key: 'askToChange',
		value: function askToChange() {
			var _this4 = this;

			if (!this.model.status) {
				this.model.status = !this.model.status;
				this.Modal.confirm({
					header: this.$translate.instant(this.pageName + '.suspend_' + this.pageName),
					message: this.$translate.instant(this.pageName + '.suspend_' + this.pageName + '_message'),
					callback: function callback(_ref) {
						var modal = _ref.modal,
						    $scope = _ref.$scope;

						_this4.model.status = !_this4.model.status;
						modal.close();
					},
					negative: function negative(_ref2) {
						var modal = _ref2.modal,
						    $scope = _ref2.$scope;

						modal.close();
					},
					type: 'danger',
					buttons: [this.$translate.instant('common.yes'), this.$translate.instant('common.no')]
				});
			}
		}
	}]);
	return ShiptypeEditController;
}(_shiptypeBase2.default);

exports.default = ShiptypeEditController;

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shiptype = __webpack_require__(2325);

var _shiptype2 = _interopRequireDefault(_shiptype);

var _create = __webpack_require__(2318);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2321);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2315);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shiptypeModule = angular.module('shiptype', [_create2.default, _edit2.default, _all2.default]).component('shiptype', _shiptype2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('shiptype.edit', {
    url: '/edit/:id',
    component: 'shiptypeedit',
    data: {
      requireACL: 'tnt_control_shiptype.edit'
    }
  }).state('shiptype.create', {
    url: '/create',
    component: 'shiptypecreate',
    data: {
      requireACL: 'tnt_control_shiptype.create'
    }
  }).state('shiptype.all', {
    url: '/all/:page',
    component: 'shiptypeall',
    data: {
      requireACL: 'tnt_control_shiptype.view'
    }
  });
}]).name;

exports.default = shiptypeModule;

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shiptype = __webpack_require__(2874);

var _shiptype2 = _interopRequireDefault(_shiptype);

var _shiptype3 = __webpack_require__(2326);

var _shiptype4 = _interopRequireDefault(_shiptype3);

__webpack_require__(3145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shiptypeComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _shiptype2.default,
  controller: _shiptype4.default
};

exports.default = shiptypeComponent;

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiptypeController = function (_TNTControlBase) {
  ShiptypeController.$inject = ["$state"];
  (0, _inherits3.default)(ShiptypeController, _TNTControlBase);

  /*@ngInject*/
  function ShiptypeController($state) {
    (0, _classCallCheck3.default)(this, ShiptypeController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShiptypeController.__proto__ || (0, _getPrototypeOf2.default)(ShiptypeController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'shiptype';
    _this.$state = $state;

    return _this;
  }

  (0, _createClass3.default)(ShiptypeController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(ShiptypeController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ShiptypeController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_control_' + this.id]) {
        this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
      }
    }
  }]);
  return ShiptypeController;
}(_TNTControlBase3.default);

exports.default = ShiptypeController;

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _user_permission_reportAll = __webpack_require__(2328);

var _user_permission_reportAll2 = _interopRequireDefault(_user_permission_reportAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userPermissionReportAllModule = angular.module('userPermissionReportAll', []).component('userPermissionReportAll', _user_permission_reportAll2.default).name;

exports.default = userPermissionReportAllModule;

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _user_permission_reportAll = __webpack_require__(2875);

var _user_permission_reportAll2 = _interopRequireDefault(_user_permission_reportAll);

var _user_permission_reportAll3 = __webpack_require__(2329);

var _user_permission_reportAll4 = _interopRequireDefault(_user_permission_reportAll3);

__webpack_require__(3146);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userPermissionReportAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template: _user_permission_reportAll2.default,
    controller: _user_permission_reportAll4.default
};

exports.default = userPermissionReportAllComponent;

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserPermissionReportAllController = function () {
    /*@ngInject*/

    UserPermissionReportAllController.$inject = ["Auth", "$state", "User", "Modal", "$translate", "UserBranchService", "$q", "UsersService", "$scope"];
    function UserPermissionReportAllController(Auth, $state, User, Modal, $translate, UserBranchService, $q, UsersService, $scope) {
        (0, _classCallCheck3.default)(this, UserPermissionReportAllController);

        this.$q = $q;
        this.UserBranchService = UserBranchService;
        this.UsersService = UsersService;
        this.Modal = Modal;
        this.$translate = $translate;
        this.$scope = $scope;

        this.model = {
            userPermissionsObj: {
                loading: false,
                totalRecords: 0,
                results: []
            },
            userListObj: {
                loading: false,
                totalRecords: 0,
                results: []
            },
            loggedInUser: User.getUser().id,
            branchId: User.getUser().branchId,
            userBranchList: [],
            userSubjectIds: []
        };
    }

    (0, _createClass3.default)(UserPermissionReportAllController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.model.loading = true;
            this.$q.all([this.UserBranchService.getUserBranches(this.model.loggedInUser)]).then(function (data) {
                _this.model.userBranchList = data[0].results;
                _this.model.userBranchList.filter(function (branch) {
                    if (branch.branchId == _this.model.branchId) {
                        branch.ticked = true;
                    }
                });
            }).then(function () {
                _this.getUsers().then(function () {
                    _this.model.userListObj.results.filter(function (u) {
                        if (u.userId == _this.model.loggedInUser) {
                            u.ticked = true;
                        }
                    });
                    _this.getUsersPermission();
                });
            }).catch(function (err) {
                console.log(err);
                if (err && err.data && err.data.message) {
                    _this.Modal.errorModal(err.data.message);
                }
            }).finally(function () {
                _this.model.loading = false;
            });
        }
    }, {
        key: 'getUsers',
        value: function getUsers() {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    var branches = _this2.getSelectedBranches();
                    _this2.model.userListObj.loading = true;
                    _this2.UsersService.userList(branches).then(function (data) {
                        _this2.model.userListObj.results = data.results;
                    }).catch(function (err) {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            _this2.Modal.errorModal(err.data.message);
                        }
                    }).finally(function () {
                        _this2.model.userListObj.loading = false;
                        resolve();
                    });
                });
            });
        }
    }, {
        key: 'getSelectedBranches',
        value: function getSelectedBranches() {
            return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map(function (branch) {
                return branch.branchId;
            }) : null;
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers() {
            return Array.isArray(this.model.selectedUsers) ? this.model.selectedUsers.map(function (user) {
                return user;
            }) : null;
        }
    }, {
        key: 'getUsersPermission',
        value: function getUsersPermission() {
            var _this3 = this;

            setTimeout(function () {
                var branches = _this3.getSelectedBranches();
                var users = _this3.getSelectedUsers();
                var indexMap = {},
                    finalResults = [];

                branches.forEach(function (branch) {
                    users.forEach(function (user) {
                        if (!indexMap.hasOwnProperty(user.userId)) {
                            indexMap[user.userId] = finalResults.length;
                            finalResults.push({ userId: user.userId, userName: user.userName, branches: [] });
                        }

                        var branches = finalResults[indexMap[user.userId]].branches;

                        branches.push(branch);
                    });
                });

                _this3.model.userPermissionsObj.loading = true;
                _this3.UsersService.userPermissions(finalResults).then(function (data) {
                    _this3.model.userPermissionsObj.results = data.results;
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this3.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this3.model.userPermissionsObj.loading = false;
                });
            });
        }
    }, {
        key: 'translateHeader',
        value: function translateHeader(key) {
            if (!key) return;

            if (key === 'other') return 'Other';else if (key === 'setting') return this.$translate.instant('common.side_menu.settings');else if (key === 'price_point') return this.$translate.instant('price_point.price_point');else if (key === 'scheduled_shipment') return this.$translate.instant('scheduled_shipment.title');
            return this.$translate.instant('common.side_menu.' + key);
        }
    }, {
        key: 'iconMap',
        value: function iconMap(key) {
            if (!key) return;

            var icon = {
                'branch_mgmt': 'glyphicon glyphicon-map-marker',
                'fuel_surcharges': 'glyphicon glyphicon-usd',
                'other': 'glyphicon glyphicon-info-sign',
                'setting': 'glyphicon glyphicon-cog',
                'tnt_billing': 'glyphicon glyphicon-calendar',
                'tnt_control': 'glyphicon glyphicon-asterisk',
                'price_point': 'glyphicon glyphicon-usd'
            };
            return icon[key];
        }
    }, {
        key: 'generateUniqueId',
        value: function generateUniqueId(branchId, userId, key) {
            if (!branchId || !key || !userId) return;
            var branch = branchId.replace(/\s/g, "-");
            return branch + '_' + userId + '_' + key;
        }
    }, {
        key: 'translatePageName',
        value: function translatePageName(key) {
            var commonKeys = ['fuel_surcharges', 'route_throw', 'bag_out', 'route_sheet', 'bulk_cash_management', 'atm_count', 'coin_pull_report', 'check_out', 'check_in', 'shipment_batch', 'route_progress', 'master_cash_schedule', 'service_tickets', 'route_stats', 'vault_operations', 'master_cash_schedule', 'deposit_packing', 'vault_close', 'route_control', 'order_packing', 'tnt_billing', 'tnt_control'];

            var branchMgmtKeys = ['tankers', 'restore_route_assignments', 'location_holds', 'final_residual_count_commit', 'monthly_report', 'deleted_shipments', 'tnt_bypass_code', 'physical_cash_count', 'customer_pickup_reports', 'lock_open_errors', 'items', 'daily_balance_sheet', 'stop_performance', 'cash_transactions', 'orders', 'bypass_code', 'bagouts', 'billing_approval', 'routes', 'count_variances', 'branch_performance', 'cancelled_shipments', 'item_holds'];

            var mapping = {
                contract: this.$translate.instant('contract.contract'),
                customer: this.$translate.instant('customer.contact'),
                billable_events: this.$translate.instant('billableEvents.menu.title'),
                billing_category: this.$translate.instant('billableEvents.billing_category'),
                mobile_app: this.$translate.instant('mobileApp.menu.title'),
                shiptype: this.$translate.instant('denomination.shiptype'),
                user_permission_report: this.$translate.instant('userPermissionReport.menu.title'),
                branch_setup: this.$translate.instant('branch_setup.menu.title'),
                denomination: this.$translate.instant('transaction_log.denomination'),
                message: this.$translate.instant('common.message'),
                locations: this.$translate.instant('fuel_surcharge.locations'),
                'setting-service-ticket-parts': this.$translate.instant('serviceTicketParts.menu.title'),
                'setting-truck': this.$translate.instant('branch_mgmt.route_truck'),
                'setting-routes': this.$translate.instant('branch_mgmt.routes.title'),
                'setting-batch': this.$translate.instant('addBagModal.batch'),
                'setting-location': this.$translate.instant('fuel_surcharge.locations'),
                'setting-branch': this.$translate.instant('bagout.branch'),
                'setting-setup': this.$translate.instant('common.side_menu.setup'),
                'setting-branch-funding-source-holiday': this.$translate.instant('branchFundingSourceHoliday.menu.title'),
                'setting-holiday': this.$translate.instant('holiday.menu.title'),
                'setting-items': this.$translate.instant('item.items'),
                'setting-branch-funding-source': this.$translate.instant('branchFundingSource.menu.title'),
                'setting-carrier': this.$translate.instant('addBagModal.carrier'),
                'environment-config': this.$translate.instant('environment_config.menu.title'),
                'setting-service-settings': this.$translate.instant('serviceSettings.menu.title'),
                'setting-log': this.$translate.instant('log.menu.title'),
                'setting-service-checklist': this.$translate.instant('serviceSettings.checklist.title'),
                'setting-users': this.$translate.instant('users.menu.title'),
                'setting-reset-atm-code': this.$translate.instant('resetAtmCode.menu.title'),
                'setting-delivery-region-routing': this.$translate.instant('deliveryRegionRouting.menu.title'),
                price_point: this.$translate.instant('price_point.price_point'),
                scheduled_shipment: this.$translate.instant('scheduled_shipment.title'),
                atm_codes_management: this.$translate.instant('navbar.atm_codes_management')
            };

            if (commonKeys.includes(key)) return this.$translate.instant('common.side_menu.' + key);else if (branchMgmtKeys.includes(key)) return this.$translate.instant('branch_mgmt.' + key + '.title');else if (!mapping[key]) return key;

            return mapping[key];
        }
    }, {
        key: 'resetData',
        value: function resetData() {
            this.model.userPermissionsObj.results = [];
        }
    }, {
        key: 'getTooltip',
        value: function getTooltip(key) {
            if (!key) return;
            key = key.charAt(0).toUpperCase() + key.slice(1);
            return this.$translate.instant('common.' + key);
        }
    }, {
        key: 'userPermissionReport',
        value: function userPermissionReport() {
            var _this4 = this;

            setTimeout(function () {
                var branches = _this4.getSelectedBranches(),
                    users = _this4.getSelectedUsers(),
                    finalResults = [],
                    reportPrefix = 'User_Permission_Report';

                branches.forEach(function (branch) {
                    users.forEach(function (user) {
                        finalResults.push({ branchId: branch, userId: user.userId, userSubjectId: 'user:' + user.userId + branch,
                            userName: user.userName });
                    });
                });

                _this4.model.isExporting = true;
                _this4.UsersService.userPermissionReport(finalResults).then(function (data) {
                    _this4.downloadFile(reportPrefix, data.reportData);
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this4.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this4.model.isExporting = false;
                });
            });
        }
    }, {
        key: 'downloadFile',
        value: function downloadFile(reportPrefix, reportData) {
            var fileName = reportPrefix.concat('.csv');
            var a = document.createElement("a");
            document.body.appendChild(a);
            var file = new Blob([reportData], { type: 'application/csv' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }
    }]);
    return UserPermissionReportAllController;
}();

exports.default = UserPermissionReportAllController;

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _user_permission_report = __webpack_require__(2331);

var _user_permission_report2 = _interopRequireDefault(_user_permission_report);

var _all = __webpack_require__(2327);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userPermissionReportModule = angular.module('userPermissionReport', [_all2.default]).component('userPermissionReport', _user_permission_report2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('user_permission_report.all', {
        url: '/all',
        component: 'userPermissionReportAll',
        data: {
            requireACL: 'tnt_control_user_permission_report.view'
        }
    });
}]).name;

exports.default = userPermissionReportModule;

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _user_permission_report = __webpack_require__(2876);

var _user_permission_report2 = _interopRequireDefault(_user_permission_report);

var _user_permission_report3 = __webpack_require__(2332);

var _user_permission_report4 = _interopRequireDefault(_user_permission_report3);

__webpack_require__(3147);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userPermissionReportComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template: _user_permission_report2.default,
    controller: _user_permission_report4.default
};

exports.default = userPermissionReportComponent;

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _TNTControlBase2 = __webpack_require__(50);

var _TNTControlBase3 = _interopRequireDefault(_TNTControlBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserPermissionReportController = function (_TNTControlBase) {
  UserPermissionReportController.$inject = ["$state"];
  (0, _inherits3.default)(UserPermissionReportController, _TNTControlBase);

  /*@ngInject*/
  function UserPermissionReportController($state) {
    (0, _classCallCheck3.default)(this, UserPermissionReportController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserPermissionReportController.__proto__ || (0, _getPrototypeOf2.default)(UserPermissionReportController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'user_permission_report';
    _this.$state = $state;
    _this.hasACL = {};
    return _this;
  }

  (0, _createClass3.default)(UserPermissionReportController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(UserPermissionReportController.prototype.__proto__ || (0, _getPrototypeOf2.default)(UserPermissionReportController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['tnt_control_' + this.id]) {
        this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
      }
    }
  }]);
  return UserPermissionReportController;
}(_TNTControlBase3.default);

exports.default = UserPermissionReportController;

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tnt_control = __webpack_require__(2334);

var _tnt_control2 = _interopRequireDefault(_tnt_control);

var _configuration = __webpack_require__(2193);

var _configuration2 = _interopRequireDefault(_configuration);

var _setup = __webpack_require__(2312);

var _setup2 = _interopRequireDefault(_setup);

var _shiptype = __webpack_require__(2324);

var _shiptype2 = _interopRequireDefault(_shiptype);

var _denomination = __webpack_require__(2229);

var _denomination2 = _interopRequireDefault(_denomination);

var _currency = __webpack_require__(2217);

var _currency2 = _interopRequireDefault(_currency);

var _message = __webpack_require__(2266);

var _message2 = _interopRequireDefault(_message);

var _mobile_app = __webpack_require__(2275);

var _mobile_app2 = _interopRequireDefault(_mobile_app);

var _user_permission_report = __webpack_require__(2330);

var _user_permission_report2 = _interopRequireDefault(_user_permission_report);

var _atm_load_profile = __webpack_require__(2190);

var _atm_load_profile2 = _interopRequireDefault(_atm_load_profile);

var _cost_center = __webpack_require__(2205);

var _cost_center2 = _interopRequireDefault(_cost_center);

var _environment_config = __webpack_require__(2241);

var _environment_config2 = _interopRequireDefault(_environment_config);

var _location_zone = __webpack_require__(2251);

var _location_zone2 = _interopRequireDefault(_location_zone);

var _notification_management = __webpack_require__(2287);

var _notification_management2 = _interopRequireDefault(_notification_management);

var _service_assignment_rules = __webpack_require__(2299);

var _service_assignment_rules2 = _interopRequireDefault(_service_assignment_rules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tntControlModule = angular.module('tntControl', [_configuration2.default, _setup2.default, _shiptype2.default, _denomination2.default, _currency2.default, _message2.default, _mobile_app2.default, _user_permission_report2.default, _atm_load_profile2.default, _cost_center2.default, _environment_config2.default, _location_zone2.default, _notification_management2.default, _service_assignment_rules2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('configuration', {
    url: '/configuration',
    component: 'configuration',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_configuration.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('setup', {
    url: '/branch-setup',
    component: 'setup',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_branch_setup.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('shiptype', {
    url: '/shiptype',
    component: 'shiptype',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_shiptype.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('denomination', {
    url: '/denomination',
    component: 'denomination',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_denomination.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('currency', {
    url: '/currency',
    component: 'currency',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_currency.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('message', {
    url: '/message',
    component: 'message',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_message.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('mobile_app', {
    url: '/mobile-app',
    component: 'mobileApp',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_mobile_app.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('user_permission_report', {
    url: '/user-permission-report',
    component: 'userPermissionReport',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_user_permission_report.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('atm_load_profile', {
    url: '/atm-load-profile',
    component: 'atmLoadProfile',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_atm_load_profile.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('cost_center', {
    url: '/cost-center',
    component: 'costCenter',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_cost_center.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('environment_config', {
    url: '/environment-config',
    component: 'environmentConfig',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_environment_config.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('location_zone', {
    url: '/location-zone',
    component: 'locationZone',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_location_zone.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('notification_management', {
    url: '/notification-management',
    component: 'notificationManagement',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_notification_management.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  }).state('service_assignment_rules', {
    url: '/service-assignment-rules',
    component: 'serviceAssignmentRules',
    parent: 'tntControl',
    data: {
      requireLogin: true,
      requireACL: 'tnt_control_service_assignment_rules.view'
    },
    resolve: {
      hasACL: function hasACL() {
        return {};
      }
    }
  });
}]).component('tntControl', _tnt_control2.default).name;

exports.default = tntControlModule;

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tnt_control = __webpack_require__(2877);

var _tnt_control2 = _interopRequireDefault(_tnt_control);

var _tnt_control3 = __webpack_require__(2335);

var _tnt_control4 = _interopRequireDefault(_tnt_control3);

__webpack_require__(3148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tntControlComponent = {
  restrict: 'E',
  bindings: {},
  template: _tnt_control2.default,
  controller: _tnt_control4.default
};

exports.default = tntControlComponent;

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(23);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TNTControlController = function () {
  /*@ngInject*/
  TNTControlController.$inject = ["Auth", "$state", "User", "$translate", "$location", "Modal", "DataCounter", "$q", "HoldService", "HoldLocationService", "$rootScope", "UsersService", "CommonLayoutService"];
  function TNTControlController(Auth, $state, User, $translate, $location, Modal, DataCounter, $q, HoldService, HoldLocationService, $rootScope, UsersService, CommonLayoutService) {
    (0, _classCallCheck3.default)(this, TNTControlController);


    this.$state = $state;

    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.$location = $location;
    this.HoldLocationService = HoldLocationService;
    this.HoldService = HoldService;
    this.Modal = Modal;
    this.DataCounter = DataCounter;
    this.holdServiceData = [];
    this.itemHoldServiceData = [];
    this.$rootScope = $rootScope;
    this.UsersService = UsersService;
    this.CommonLayoutService = CommonLayoutService;
    this.currentBranch = User.getUser().branchId;
    this.tabConfig = {
      'tnt_control_branch_setup': {
        title: 'branch_setup.menu.title',
        state: 'setup'
      },
      'tnt_control_shiptype': {
        title: 'shiptype.menu.title',
        state: 'shiptype'
      },
      'tnt_control_denomination': {
        title: 'denomination.menu.title',
        state: 'denomination'
      },
      'tnt_control_currency': {
        title: 'currency.menu.title',
        state: 'currency'
      },
      'tnt_control_message': {
        title: 'message.menu.title',
        state: 'message'
      },
      'tnt_control_mobile_app': {
        title: 'mobileApp.menu.title',
        state: 'mobile_app'
      },
      'tnt_control_user_permission_report': {
        title: 'userPermissionReport.menu.title',
        state: 'user_permission_report'
      },
      'tnt_control_atm_load_profile': {
        title: 'atmLoadProfile.menu.title',
        state: 'atm_load_profile'
      },
      'tnt_control_cost_center': {
        title: 'costCenter.menu.title',
        state: 'cost_center'
      },
      'tnt_control_environment_config': {
        title: 'environment_config.menu.title',
        state: 'environment_config'
      },
      'tnt_control_location_zone': {
        title: 'locationZone.menu.title',
        state: 'location_zone'
      },
      'tnt_control_notification_management': {
        title: 'notificationManagement.menu.title',
        state: 'notification_management'
      },
      'tnt_control_service_assignment_rules': {
        title: 'serviceAssignmentRules.menu.title',
        state: 'service_assignment_rules'
      }
    };

    this.acl = User.getACL('tntControl');
    this.tabs = [];
  }

  (0, _createClass3.default)(TNTControlController, [{
    key: 'getStateDiff',
    value: function getStateDiff(array) {
      var diff = [];
      var index = 0;
      for (var i = 0; i < array.length; i++) {
        var key = array[i];
        if (!(key in this.acl)) {
          diff[index++] = array[i];
        }
      }
      return diff;
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      var firstName = this.User.getUser().firstName;
      var lastName = this.User.getUser().lastName;

      this.$q.all([this.UsersService.validateUserPermissions(firstName, lastName)]).then(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
            permission = _ref2[0];

        if (!permission.hasEnvironmentConfigPermission && !_this.CommonLayoutService.isAllowToAccessPages()) {
          delete _this.tabConfig['tnt_control_environment_config'];

          if (_this.validateUserPermissionsAndState('/environment-config')) {
            return _this.$state.go('home');
          }
        }

        var toDeregister = _this.getStateDiff((0, _keys2.default)(_this.tabConfig));
        for (var i = 0; i < toDeregister.length; i++) {
          if (_this.$state.get(toDeregister[i])) {
            _this.$state.router.stateRegistry.deregister(toDeregister[i]);
          }
        }

        _lodash2.default.forEach((0, _keys2.default)(_this.tabConfig), function (key, i) {
          if (_this.acl[key] && _this.acl[key].indexOf('view') >= 0) {
            var tabConfig = _this.tabConfig[key];
            if (tabConfig) {
              var obj = (0, _assign2.default)(tabConfig, { key: key });
              _this.tabs.push(obj);
            }
          }
        });

        if (_this.$state.current.name == 'tntControl' && _this.tabs.length) {
          _this.$state.go(_this.tabs[0].state);
        }

        _this.$rootScope.$broadcast('routeChange', null);
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'hasAcl',
    value: function hasAcl(key) {
      if (this.acl[key] && this.acl[key].indexOf('view') >= 0) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'validateUserPermissionsAndState',
    value: function validateUserPermissionsAndState(wordToCheck) {
      var currentStateUrl = this.$state.href(this.$state.current);
      return currentStateUrl.toLowerCase().includes(wordToCheck);
    }
  }]);
  return TNTControlController;
}();

exports.default = TNTControlController;

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tnt_react_app = __webpack_require__(2337);

var _tnt_react_app2 = _interopRequireDefault(_tnt_react_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TNTReactAppModule = angular.module("tntReactApp", []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise("/tntReactApp");

  $stateProvider.state("tntReactApp", {
    url: "/v2/index.html#/dashboard",
    component: "tntReactApp",
    data: {
      requireLogin: true,
      requireACL: "tnt_react_app.all"
    }
  });
}]).component("tntReactApp", _tnt_react_app2.default).name;

exports.default = TNTReactAppModule;

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(3149);

var TNTReactAppComponent = {
  restrict: "E",
  bindings: {}
};

exports.default = TNTReactAppComponent;

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _truckAll = __webpack_require__(2339);

var _truckAll2 = _interopRequireDefault(_truckAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var truckallModule = angular.module('truckall', []).component('truckall', _truckAll2.default).name;

exports.default = truckallModule;

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _truckAll = __webpack_require__(2878);

var _truckAll2 = _interopRequireDefault(_truckAll);

var _truckAll3 = __webpack_require__(2340);

var _truckAll4 = _interopRequireDefault(_truckAll3);

__webpack_require__(3150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var truckallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _truckAll2.default,
  controller: _truckAll4.default
};

exports.default = truckallComponent;

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _truckBase = __webpack_require__(284);

var _truckBase2 = _interopRequireDefault(_truckBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var truckallController = function (_TruckBaseController) {
  truckallController.$inject = ["Auth", "$state", "User", "Modal", "TruckService", "$translate", "$stateParams", "$location"];
  (0, _inherits3.default)(truckallController, _TruckBaseController);

  /*@ngInject*/
  function truckallController(Auth, $state, User, Modal, TruckService, $translate, $stateParams, $location) {
    (0, _classCallCheck3.default)(this, truckallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (truckallController.__proto__ || (0, _getPrototypeOf2.default)(truckallController)).call(this, Auth, $state, User, TruckService, Modal, $translate, $stateParams, $location));

    _this.loading = true;
    _this.trucks = [];
    _this.hasAcl = {};
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.searchText = '';
    _this.$location = $location;
    _this.branch = User.getUser().branchId;
    _this.model.filterByAllBranch = false;
    _this.filterByValue = null;
    return _this;
  }

  (0, _createClass3.default)(truckallController, [{
    key: '$onInit',
    value: function $onInit() {
      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
    }
  }, {
    key: 'edit',
    value: function edit(truck) {
      this.$state.go('truck.edit', {
        id: truck.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(truck) {
      var _this2 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + truck.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this2.Service.remove(truck.id, _this2.branch).then(function (data) {
            _this2.allowOnlyOnce = false;
            modal.close();
            _this2.refresh();
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this2.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      return {
        queryText: '%' + this.searchText + '%',
        isQuery: false,
        branch: this.branch,
        filterByAllBranch: this.model.filterByAllBranch
      };
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      var searchObj = this.generateSearchObj();

      this.loading = true;
      this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this3.total = data.total;
        _this3.loading = false;
        _this3.trucks = data.results;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.error = err.message;
        _this3.Modal.errorModal(err.data.message);
      });
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(truck) {
      truck.expand = !truck.expand;
    }
  }, {
    key: 'filterByBranch',
    value: function filterByBranch(value) {
      this.page = 1;
      this.filterByValue = this.filterByValue === value ? undefined : value;
      this.model.filterByAllBranch = this.filterByValue ? true : false;
      this.loadData();
    }
  }]);
  return truckallController;
}(_truckBase2.default);

exports.default = truckallController;

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _truckCreate = __webpack_require__(2342);

var _truckCreate2 = _interopRequireDefault(_truckCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var truckCreateModule = angular.module('truckcreate', []).component('truckcreate', _truckCreate2.default).name;

exports.default = truckCreateModule;

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _truckCreate = __webpack_require__(2879);

var _truckCreate2 = _interopRequireDefault(_truckCreate);

var _truckCreate3 = __webpack_require__(2343);

var _truckCreate4 = _interopRequireDefault(_truckCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var truckcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _truckCreate2.default,
  controller: _truckCreate4.default
};

exports.default = truckcreateComponent;

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _truckBase = __webpack_require__(284);

var _truckBase2 = _interopRequireDefault(_truckBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TruckCreateController = function (_TruckBaseController) {
	TruckCreateController.$inject = ["Auth", "$state", "User", "TruckService", "Modal", "$translate", "$stateParams", "LocationService", "VehicleLockerService", "CommonLayoutService"];
	(0, _inherits3.default)(TruckCreateController, _TruckBaseController);

	/*@ngInject*/
	function TruckCreateController(Auth, $state, User, TruckService, Modal, $translate, $stateParams, LocationService, VehicleLockerService, CommonLayoutService) {
		(0, _classCallCheck3.default)(this, TruckCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (TruckCreateController.__proto__ || (0, _getPrototypeOf2.default)(TruckCreateController)).call(this, Auth, $state, User, TruckService, Modal, $translate, $stateParams));

		_this.LocationService = LocationService;
		_this.VehicleLockerService = VehicleLockerService;
		_this.CommonLayoutService = CommonLayoutService;
		_this.hasACL = {};
		_this.defaultModel = {
			id: '',
			make: '',
			status: true,
			model: '',
			year: '',
			vinnum: '',
			platenum: '',
			branch: User.getUser().branchId,
			lockers: false,
			truckLockers: [],
			liability: false,
			liabilityLimit: null,
			truckLiability: false,
			NFCScan: false,
			NFCTagId: null,
			fuelType: 'UNLEADED'
		};
		_this.model = angular.copy(_this.defaultModel);
		_this.locations = [];
		_this.locationsToIgnore = [];
		_this.offset = 0;
		_this.changeOffsetFlag = false;
		_this.loading = false;
		_this.totalLocations = 0;
		_this.locationData = [];
		_this.isValid = true;
		_this.isLoading = false;
		_this.stateList = _this.CommonLayoutService.locationStateMapping();
		_this.fuelTypeList = _this.CommonLayoutService.fuelTypeMapping();
		return _this;
	}

	(0, _createClass3.default)(TruckCreateController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.Service.all(null, 0, 100).then(function (trucks) {
				return trucks.results.map(function (data) {
					return data.locationId;
				});
			}).then(function (locationsToIgnore) {
				_this2.locationsToIgnore = locationsToIgnore;
				_this2.getAllLocation();
				// this.loadLockerLocations('', 0);
			});
		}

		// get all location

	}, {
		key: 'getAllLocation',
		value: function getAllLocation() {
			var _this3 = this;

			this.Service.loadRemainingTrucks(this.model.branch, 'TRUCK').then(function (res) {
				_this3.totalRecord = res.length;
				var locations = _this3.mappingLocationData(res);
				_this3.locations = _this3.locations.concat(locations);
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'mappingLocationData',
		value: function mappingLocationData(location) {
			var _this4 = this;

			return location.map(function (loc) {
				return {
					Key: loc.id + " | " + loc.name,
					Value: loc.id,
					address: loc.address ? loc.address : '',
					city: loc.city ? loc.city : '',
					state: loc.state ? _this4.stateList[loc.state] : '',
					zip: loc.zip ? loc.zip : ''
				};
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.model = angular.copy(this.defaultModel);
			this.model.truckLockers = [];
			this.clearErrors();
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this5 = this;

			this.loading = true;
			this.Service.create({
				id: this.model.id,
				locationId: this.model.locationId.Value,
				make: this.model.make,
				model: this.model.model,
				year: this.model.year,
				vinnum: this.model.vinnum,
				platenum: this.model.platenum,
				status: this.model.status,
				lockers: this.model.lockers,
				truckLockers: this.model.truckLockers.map(function (info) {
					if (_this5.model.liability) info.maxShipment = null;else info.maxLiability = null;
					return info;
				}),
				liability: this.model.liability,
				liabilityLimit: this.model.liabilityLimit,
				truckLiability: this.model.truckLiability,
				NFCScan: this.model.NFCScan,
				NFCTagId: this.model.NFCScan ? this.model.NFCTagId : null,
				fuelType: this.model.fuelType
			}, this.model.branch).then(function (data) {
				_this5.loading = false;
				_this5.askCreate();
			}).then(function () {
				_this5.locations = [];
				_this5.getAllLocation();
			}).catch(function (err) {
				_this5.loading = false;
				var errorPath = err && err.data && err.data.errors && err.data.errors[0].path;

				if (errorPath === 'VEHICLE.NFCTagId') {
					_this5.errorMessage = _this5.$translate.instant('common.unique_nfc_tag_id');
				} else if (err && err.data && err.data.message) {
					_this5.errorMessage += err.data.message + '<br/>';
				} else {
					err.data.errors.map(function (e) {
						_this5.errorMessage += e.message + '<br/>';
					});
				}
			});
		}
	}, {
		key: 'locationSearchObj',
		value: function locationSearchObj(searchKey) {
			searchKey = searchKey || '';
			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: '=',
						data: this.model.branch
					}, {
						field: 'locationType',
						condition: '=',
						data: 'LOCKER'
					}, {
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'name',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};
			return searchObj.queryJSON.rules.length ? searchObj : null;
		}
	}, {
		key: 'loadLockerLocations',
		value: function loadLockerLocations(searchKey, offset) {
			var _this6 = this;

			// var searchObj = this.locationSearchObj(searchKey);
			searchKey = searchKey || null;

			return this.VehicleLockerService.getLockerLocations(null, searchKey, this.model.branch, _app2.default.defaultPageLimit, offset).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this6.totalLocations = data.total;
					_this6.locationData = _this6.locationMap(data.results);
				} else {
					var loc = _this6.locationMap(data.results);
					_this6.locationData = _this6.locationData.concat(loc);
				}
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this6.errorMessage = err.data.message;
				}
			});
		}
	}, {
		key: 'locationMap',
		value: function locationMap(locations) {
			return locations.map(function (obj) {
				return {
					Key: obj.locationId + ' | ' + obj.locationName,
					Value: obj.locationId
				};
			});
		}
	}, {
		key: 'addTruckLockers',
		value: function addTruckLockers(searchKey, offset) {
			var _this7 = this;

			// var searchObj = this.locationSearchObj('');
			searchKey = searchKey || null;
			this.isLoading = true;

			this.VehicleLockerService.getLockerLocations(null, searchKey, this.model.branch, _app2.default.defaultPageLimit, offset).then(function (data) {
				_this7.totalLocations = data.total;
				_this7.locationData = _this7.locationMap(data.results);
				_this7.model.truckLockers.push({
					label: null,
					maxShipment: 1,
					maxLiability: null,
					location: null,
					locationId: null,
					isDuplicate: false
				});
				if (_this7.model.truckLockers.length > 1) {
					_this7.validateLocker();
				}
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this7.errorMessage = err.data.message;
				}
			}).finally(function () {
				_this7.isLoading = false;
			});
		}
	}, {
		key: 'removeLockers',
		value: function removeLockers(index) {
			this.model.truckLockers.splice(index, 1);
			this.validateLocker();
		}
	}, {
		key: 'validateLocker',
		value: function validateLocker() {
			var _this8 = this;

			this.model.truckLockers = _.map(this.model.truckLockers, function (obj, index) {
				obj.isDuplicate = false;
				obj.locationId = obj.location ? obj.location.Value : null;
				var match = _.find(_this8.model.truckLockers, function (compairObject, compairObjIndex) {
					compairObject.locationId = compairObject.location ? compairObject.location.Value : null;
					if (index > compairObjIndex) return compairObject.locationId == obj.locationId;
				});
				if (match) {
					obj.isDuplicate = true;
					return obj;
				} else {
					return obj;
				}
			});
			var isValidDirective = this.model.truckLockers.map(function (obj) {
				if (obj.isDuplicate) return true;
			});
			this.isValid = isValidDirective.indexOf(true) >= 0 ? false : true;
		}
	}, {
		key: 'resetLockers',
		value: function resetLockers() {
			if (!this.model.lockers) this.model.truckLockers = [];
		}
	}, {
		key: 'validateLiability',
		value: function validateLiability() {
			if (!this.model.truckLiability || !this.model.liability) return;

			var lockerLiability = 0;
			this.isLiabilityExceed = false;
			this.liabilityError;

			this.model.truckLockers.forEach(function (locker, index) {
				lockerLiability += locker.maxLiability;
			});
			if (this.model.liabilityLimit && lockerLiability > this.model.liabilityLimit) {
				this.isLiabilityExceed = true;
				this.liabilityError = this.$translate.instant('truck.liability_error');
			} else {
				this.isLiabilityExceed = false;
				delete this.liabilityError;
			}
		}
	}, {
		key: 'resetLiability',
		value: function resetLiability() {
			if (!this.model.truckLiability) this.model.liabilityLimit = null;
		}
	}, {
		key: 'setVehicleId',
		value: function setVehicleId() {
			if (this.model.locationId) {
				this.model.id = this.model.locationId.Value;
			} else {
				this.model.id = null;
			}
		}
	}]);
	return TruckCreateController;
}(_truckBase2.default);

exports.default = TruckCreateController;

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _truckEdit = __webpack_require__(2345);

var _truckEdit2 = _interopRequireDefault(_truckEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var truckEditModule = angular.module('truckedit', []).component('truckedit', _truckEdit2.default).name;

exports.default = truckEditModule;

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _truckEdit = __webpack_require__(2880);

var _truckEdit2 = _interopRequireDefault(_truckEdit);

var _truckEdit3 = __webpack_require__(2346);

var _truckEdit4 = _interopRequireDefault(_truckEdit3);

__webpack_require__(3151);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var truckeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _truckEdit2.default,
  controller: _truckEdit4.default
};

exports.default = truckeditComponent;

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _truckBase = __webpack_require__(284);

var _truckBase2 = _interopRequireDefault(_truckBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TruckEditController = function (_TruckBaseController) {
	TruckEditController.$inject = ["Auth", "$state", "User", "TruckService", "Modal", "$translate", "$stateParams", "LocationService", "VehicleLockerService", "CommonLayoutService"];
	(0, _inherits3.default)(TruckEditController, _TruckBaseController);

	/*@ngInject*/
	function TruckEditController(Auth, $state, User, TruckService, Modal, $translate, $stateParams, LocationService, VehicleLockerService, CommonLayoutService) {
		(0, _classCallCheck3.default)(this, TruckEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (TruckEditController.__proto__ || (0, _getPrototypeOf2.default)(TruckEditController)).call(this, Auth, $state, User, TruckService, Modal, $translate, $stateParams));

		_this.LocationService = LocationService;
		_this.VehicleLockerService = VehicleLockerService;
		_this.CommonLayoutService = CommonLayoutService;
		_this.defaultModel = {
			id: '',
			locationId: '',
			make: '',
			status: true,
			model: '',
			year: '',
			vinnum: '',
			platenum: '',
			lockers: false,
			liability: false,
			liabilityLimit: null,
			truckLiability: false,
			NFCScan: false,
			NFCTagId: null,
			fuelType: null
		};
		_this.model = angular.copy(_this.defaultModel);
		_this.pageName = 'truck';
		_this.locationList = [];
		_this.totalRecord = '';
		_this.branch = User.getUser().branchId;
		_this.locationsToIgnore = [];
		_this.allTrucks = [];
		_this.offset = 0;
		_this.changeOffsetFlag = false;
		_this.locations = [];
		_this.loading = false;
		_this.isValid = true;
		_this.lockerLocations = [];
		_this.totalLocations = 0;
		_this.itemsToDelete = [];
		_this.defaultLockers = [];
		_this.locationIds = [];
		_this.stateList = _this.CommonLayoutService.locationStateMapping();
		_this.fuelTypeList = _this.CommonLayoutService.fuelTypeMapping();
		return _this;
	}

	(0, _createClass3.default)(TruckEditController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.Service.get(this.$stateParams.id).then(function (data) {
				_this2.defaultModel = data;
				_this2.model = angular.copy(_this2.defaultModel);
				_this2.rawId = data.id;
				_this2.model.id = data.id;
				_this2.model.status = data.status;
				_this2.model.make = data.make;
				_this2.model.model = data.model;
				_this2.model.year = data.year;
				_this2.model.vinnum = data.vinnum;
				_this2.model.platenum = data.platenum;
				_this2.model.truckLockers = data.truckLockers;
				_this2.model.liability = data.liability;
				_this2.model.liabilityLimit = data.liabilityLimit;
				_this2.model.truckLiability = data.truckLiability;
				_this2.locationIds = _this2.model.truckLockers.map(function (d) {
					return d.locationId;
				});
				if (data.location) {
					data.location.Key = data.location.id + " | " + data.location.name;
					data.location.Value = data.location.id;
					data.location.address = data.location.address ? data.location.address : '';
					data.location.city = data.location.city ? data.location.city : '';
					data.location.state = data.location.state ? _this2.stateList[data.location.state] : '';
					data.location.zip = data.location.zip ? data.location.zip : '';
				}
				_this2.model.locationId = data.location;
				_this2.model.NFCScan = data.NFCScan;
				_this2.model.NFCTagId = data.NFCTagId;
				_this2.model.fuelType = data.fuelType;
			}).then(function () {
				_this2.getAllLocation();
				_this2.lockerInfo().then(function () {
					return _this2.validateLocker();
				});
			}).catch(function (err) {
				console.error(err);
				_this2.errorMessage = err.data.message;
			});
		}

		// get all location

	}, {
		key: 'getAllLocation',
		value: function getAllLocation() {
			var _this3 = this;

			this.locations = [];
			this.Service.loadRemainingTrucks(this.branch, 'TRUCK').then(function (res) {
				_this3.totalRecord = res.length + 1;
				var locations = _this3.mappingLocationData(res);
				_this3.locations = _this3.locations.concat(locations);
				if (_this3.model.locationId) {
					_this3.locations.unshift(_this3.model.locationId);
				}
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'mappingLocationData',
		value: function mappingLocationData(location) {
			var _this4 = this;

			return location.map(function (loc) {
				return {
					Key: loc.id + " | " + loc.name,
					Value: loc.id,
					address: loc.address ? loc.address : '',
					city: loc.city ? loc.city : '',
					state: loc.state ? _this4.stateList[loc.state] : '',
					zip: loc.zip ? loc.zip : ''
				};
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			var _this5 = this;

			this.model = angular.copy(this.defaultModel);
			this.model.locationId = this.defaultModel.location;
			this.itemsToDelete = [];
			if (this.model.truckLockers.length) {
				this.model.truckLockers.forEach(function (data, index) {
					if (!data.id) _this5.model.truckLockers.splice(index, 1);
				});
			}
			this.validateLocker();
			this.getAllLocation();
		}
	}, {
		key: 'askToChange',
		value: function askToChange() {
			var _this6 = this;

			if (!this.model.status) {
				this.model.status = !this.model.status;
				this.Modal.confirm({
					header: this.$translate.instant(this.pageName + '.suspend_' + this.pageName),
					message: this.$translate.instant(this.pageName + '.suspend_' + this.pageName + '_message'),
					callback: function callback(_ref) {
						var modal = _ref.modal,
						    $scope = _ref.$scope;

						_this6.model.status = !_this6.model.status;
						modal.close();
					},
					negative: function negative(_ref2) {
						var modal = _ref2.modal,
						    $scope = _ref2.$scope;

						modal.close();
					},
					type: 'danger',
					buttons: ['common.yes', 'common.no']
				});
			}
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this7 = this;

			this.loading = true;
			var truckLockers = this.vehicleLockerData();

			this.Service.update(this.rawId, {
				id: this.model.id,
				locationId: this.model.locationId.Value,
				make: this.model.make,
				status: this.model.status,
				model: this.model.model,
				year: this.model.year,
				vinnum: this.model.vinnum,
				platenum: this.model.platenum,
				lockers: this.model.lockers,
				truckLockers: truckLockers.map(function (info) {
					if (_this7.model.liability) info.maxShipment = null;else info.maxLiability = null;
					return info;
				}),
				liability: this.model.liability,
				liabilityLimit: this.model.liabilityLimit,
				truckLiability: this.model.truckLiability,
				NFCScan: this.model.NFCScan,
				NFCTagId: this.model.NFCScan ? this.model.NFCTagId : null,
				fuelType: this.model.fuelType
			}, this.branch).then(function (data) {
				_this7.loading = false;
				window.history.go(-1);
			}).catch(function (err) {
				_this7.loading = false;
				var errorPath = err && err.data && err.data.errors && err.data.errors[0].path;

				if (errorPath === 'VEHICLE.NFCTagId') {
					_this7.errorMessage = _this7.$translate.instant('common.unique_nfc_tag_id');
				} else if (err && err.data && err.data.message) {
					_this7.errorMessage = err.data.message;
				} else if (err && err.data && err.data.errors) {
					err.data.errors.map(function (e) {
						_this7.errorMessage += e.message + '<br/>';
					});
				}
			});
		}
	}, {
		key: 'locationSearchObj',
		value: function locationSearchObj(searchKey) {
			searchKey = searchKey || '';
			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: '=',
						data: this.branch
					}, {
						field: 'locationType',
						condition: '=',
						data: 'LOCKER'
					}, {
						group: {
							rules: [{
								field: 'id',
								condition: 'like',
								data: '%' + searchKey + '%'
							}, {
								field: 'name',
								condition: 'like',
								data: '%' + searchKey + '%'
							}],
							operator: 'OR'
						}
					}],
					operator: 'AND'
				}
			};
			return searchObj.queryJSON.rules.length ? searchObj : null;
		}
	}, {
		key: 'getLockerLocations',
		value: function getLockerLocations(searchKey, offset) {
			var _this8 = this;

			// var searchObj = this.locationSearchObj(searchKey);
			searchKey = searchKey || null;
			return this.VehicleLockerService.getLockerLocations(this.locationIds, searchKey, this.branch, _app2.default.defaultPageLimit, offset).then(function (data) {
				if (offset === 0 || offset == undefined) {
					_this8.totalLocations = data.total;
					_this8.lockerLocations = _this8.locationMap(data.results, searchKey, null);
				} else {
					var loc = _this8.locationMap(data.results, searchKey, null);
					_this8.lockerLocations = _this8.lockerLocations.concat(loc);
				}
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this8.errorMessage = err.data.message;
				}
			});
		}
	}, {
		key: 'loadLockerLocations',
		value: function loadLockerLocations(searchKey, offset, index) {
			var _this9 = this;

			// var searchObj = this.locationSearchObj(searchKey);
			searchKey = searchKey || null;
			if (offset !== 0 && this.model.truckLockers && !searchKey && Math.abs(offset % 2) == 1) {
				offset = offset - 1;
			}
			return this.VehicleLockerService.getLockerLocations(this.locationIds, searchKey, this.branch, _app2.default.defaultPageLimit, offset).then(function (data) {

				var selectedVal = _this9.model.truckLockers[index].location ? _this9.model.truckLockers[index].location.Value : '';
				var location = _this9.model.truckLockers[index].location ? _this9.model.truckLockers[index].location.Key : '';

				if (offset === 0) {
					_this9.model.truckLockers[index].totalLocations = data.total;
					_this9.model.truckLockers[index].lockerLocations = _this9.locationMap(data.results, searchKey, selectedVal);
					if (!searchKey && selectedVal && location) {
						_this9.model.truckLockers[index].lockerLocations.unshift({
							Key: location,
							Value: selectedVal
						});
					}
				} else {
					var loc = _this9.locationMap(data.results, searchKey, selectedVal);
					_this9.model.truckLockers[index].lockerLocations = _this9.model.truckLockers[index].lockerLocations.concat(loc);
				}
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this9.errorMessage = err.data.message;
				}
			});
		}
	}, {
		key: 'locationMap',
		value: function locationMap(locations, searchKey, originalVal) {
			var data = [];
			locations.map(function (obj) {
				obj.Key = obj.locationId + ' | ' + obj.locationName;
				obj.Value = obj.locationId;

				if (!searchKey && originalVal) {
					if (obj.Value !== originalVal) {
						data.push(obj);
					}
				} else {
					data.push(obj);
				}
			});
			return data;
		}
	}, {
		key: 'addTruckLockers',
		value: function addTruckLockers(searchKey, offset) {
			var _this10 = this;

			// var searchObj = this.locationSearchObj('');
			searchKey = searchKey || null;
			this.isLoading = true;

			this.VehicleLockerService.getLockerLocations(this.locationIds, searchKey, this.branch, _app2.default.defaultPageLimit, offset).then(function (data) {
				var lockerLocations = _this10.locationMap(data.results, '', null);
				_this10.model.truckLockers.push({
					label: null,
					maxShipment: 1,
					maxLiability: null,
					location: null,
					locationId: null,
					isDuplicate: false,
					totalLocations: data.total,
					lockerLocations: lockerLocations,
					sequence: _this10.model.truckLockers.length + 1,
					status: 'Create'
				});
				if (_this10.model.truckLockers.length > 1) {
					_this10.validateLocker();
				}
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this10.errorMessage = err.data.message;
				}
			}).finally(function () {
				_this10.isLoading = false;
			});
		}
	}, {
		key: 'removeLockers',
		value: function removeLockers(index) {
			if (this.model.truckLockers[index].id) {
				this.model.truckLockers[index].status = 'Delete';
				this.itemsToDelete.push(this.model.truckLockers[index]);
			}
			this.model.truckLockers.splice(index, 1);
			this.validateLocker();
		}
	}, {
		key: 'validateLocker',
		value: function validateLocker() {
			var _this11 = this;

			this.model.truckLockers = _.map(this.model.truckLockers, function (obj, index) {
				obj.isDuplicate = false;
				obj.locationId = obj.location ? obj.location.Value : null;
				var match = _.find(_this11.model.truckLockers, function (compairObject, compairObjIndex) {
					compairObject.locationId = compairObject.location ? compairObject.location.Value : null;
					if (index > compairObjIndex) return compairObject.locationId == obj.locationId;
				});
				if (match) {
					obj.isDuplicate = true;
					return obj;
				} else {
					return obj;
				}
			});
			var isValidDirective = this.model.truckLockers.map(function (obj) {
				if (obj.isDuplicate) return true;
			});
			this.isValid = isValidDirective.indexOf(true) >= 0 ? false : true;
		}
	}, {
		key: 'vehicleLockerData',
		value: function vehicleLockerData() {
			var data = [];
			if (this.model.truckLockers.length) {
				this.model.truckLockers.forEach(function (info) {
					data.push({
						id: info.id ? info.id : null,
						label: info.label,
						maxShipment: info.maxShipment,
						maxLiability: info.maxLiability,
						locationId: info.locationId,
						sequence: info.sequence,
						status: info.status
					});
				});
			}
			if (this.itemsToDelete.length) {
				this.itemsToDelete.forEach(function (info) {
					data.push({
						id: info.id,
						label: info.label,
						maxShipment: info.maxShipment,
						maxLiability: info.maxLiability,
						locationId: info.locationId,
						sequence: info.sequence,
						status: info.status
					});
				});
			}
			return data.filter(this.getDifference(this.defaultLockers));
		}
	}, {
		key: 'getDifference',
		value: function getDifference(defaultLockers) {
			return function (current) {
				return defaultLockers.filter(function (previous) {
					return previous.label == current.label && previous.locationId == current.locationId && previous.maxShipment == current.maxShipment && previous.maxLiability == current.maxLiability && current.status != 'Delete';
				}).length == 0;
			};
		}
	}, {
		key: 'lockerInfo',
		value: function lockerInfo() {
			var _this12 = this;

			return this.getLockerLocations('', 0).then(function () {
				if (_this12.model.truckLockers.length) {
					_this12.model.truckLockers.map(function (loc, index) {
						loc.location = {
							Key: loc.location.id + " | " + loc.location.name,
							Value: loc.location.id
						};
						loc.totalLocations = _this12.totalLocations;
						loc.lockerLocations = _this12.locationMap(_this12.lockerLocations, '', loc.location.Value);
						loc.lockerLocations.unshift(loc.location);
						loc.duplicate = false;
						loc.status = 'Update';
						return loc;
					});
					_this12.defaultLockers = JSON.parse((0, _stringify2.default)(_this12.model.truckLockers));
				}
			});
		}
	}, {
		key: 'resetLockers',
		value: function resetLockers() {
			var _this13 = this;

			if (!this.model.lockers) {
				return this.Service.get(this.$stateParams.id).then(function (data) {
					_this13.model.truckLockers = data.truckLockers;
					_this13.lockerInfo().then(function () {
						return _this13.validateLocker();
					});
				});
			}
		}
	}, {
		key: 'validateLiability',
		value: function validateLiability() {
			if (!this.model.truckLiability || !this.model.liability) return;

			var lockerLiability = 0;
			this.isLiabilityExceed = false;
			this.liabilityError;

			this.model.truckLockers.forEach(function (locker, index) {
				lockerLiability += locker.maxLiability;
			});
			if (this.model.liabilityLimit && lockerLiability > this.model.liabilityLimit) {
				this.isLiabilityExceed = true;
				this.liabilityError = this.$translate.instant('truck.liability_error');
			} else {
				this.isLiabilityExceed = false;
				delete this.liabilityError;
			}
		}
	}, {
		key: 'resetLiability',
		value: function resetLiability() {
			if (!this.model.truckLiability) this.model.liabilityLimit = null;
		}
	}]);
	return TruckEditController;
}(_truckBase2.default);

exports.default = TruckEditController;

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _truck = __webpack_require__(2348);

var _truck2 = _interopRequireDefault(_truck);

var _create = __webpack_require__(2341);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2344);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2338);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var truckModule = angular.module('truck', [_create2.default, _edit2.default, _all2.default]).component('truck', _truck2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('truck.edit', {
    url: '/edit/:id',
    component: 'truckedit'
  }).state('truck.create', {
    url: '/create',
    component: 'truckcreate'
  }).state('truck.all', {
    url: '/all/:page',
    component: 'truckall'
  });
}]).name;

exports.default = truckModule;

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _truck = __webpack_require__(2881);

var _truck2 = _interopRequireDefault(_truck);

var _truck3 = __webpack_require__(2349);

var _truck4 = _interopRequireDefault(_truck3);

__webpack_require__(3152);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var truckComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _truck2.default,
  controller: _truck4.default
};

exports.default = truckComponent;

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TruckController = function (_SettingBase) {
  TruckController.$inject = ["$state"];
  (0, _inherits3.default)(TruckController, _SettingBase);

  /*@ngInject*/
  function TruckController($state) {
    (0, _classCallCheck3.default)(this, TruckController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TruckController.__proto__ || (0, _getPrototypeOf2.default)(TruckController)).call(this));

    _this.$state = $state;
    _this.id = "truck";
    _this.acl = {};
    _this.hasACL = {};

    return _this;
  }

  (0, _createClass3.default)(TruckController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(TruckController.prototype.__proto__ || (0, _getPrototypeOf2.default)(TruckController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['setting-' + this.id]) {
        this.hasACL[this.acl['setting-' + this.id][key]] = true;
      }
    }
  }]);
  return TruckController;
}(_SettingBase3.default);

exports.default = TruckController;

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _user_profile = __webpack_require__(2351);

var _user_profile2 = _interopRequireDefault(_user_profile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userProfileModule = angular.module('userprofile', []).component('userprofile', _user_profile2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('app.userProfile', {
    url: '/user-profile',
    component: 'userprofile'
  });
}]).name;

exports.default = userProfileModule;

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _user_profile = __webpack_require__(2882);

var _user_profile2 = _interopRequireDefault(_user_profile);

var _user_profile3 = __webpack_require__(2352);

var _user_profile4 = _interopRequireDefault(_user_profile3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userprofileComponent = {
  restrict: 'E',
  template: _user_profile2.default,
  controller: _user_profile4.default
};

exports.default = userprofileComponent;

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersProfileController = function () {
	/*@ngInject*/
	UsersProfileController.$inject = ["Auth", "$state", "User", "UsersService", "$translate", "BranchService", "$q", "$rootScope"];
	function UsersProfileController(Auth, $state, User, UsersService, $translate, BranchService, $q, $rootScope) {
		(0, _classCallCheck3.default)(this, UsersProfileController);

		this.User = User;
		this.BranchService = BranchService;
		this.UsersService = UsersService;
		this.$rootScope = $rootScope;
		this.model = {};
		this.defaultModel = {};
		this.language = [{ value: 'E', label: "English" },
		// { value: 'F', label: 'French' },
		{ value: 'S', label: 'Spanish' }];
	}

	(0, _createClass3.default)(UsersProfileController, [{
		key: 'isLangSelected',
		value: function isLangSelected(language) {
			return language.value == this.model.languageId;
		}
	}, {
		key: 'toggle',
		value: function toggle(language) {
			this.model.languageId = language.value;
		}
	}, {
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			this.defaultModel = this.User.getUser();
			this.reset();

			this.UsersService.get(this.defaultModel.id).then(function (data) {
				_this.rawId = data.id;
				_this.model.id = data.id;
				_this.model.firstName = data.firstName;
				_this.model.lastName = data.lastName;
				_this.model.email = data.email;
				_this.model.languageId = data.languageId;
				_this.model.supervisor = data.supervisor;
				_this.model.branchId = data.branchId;
				_this.model.downloadToHHT = data.downloadToHHT;
				_this.model.isWebUser = !!data.email;
				_this.model.isCustomerUser = data.customerUser;
			});

			this.BranchService.all(null, 0, 100).then(function (data) {
				_this.branches = data.results.map(function (branch) {
					return branch.id;
				});
			});
			this.$rootScope.$broadcast('routeChange', '/app/user-profile');
		}
	}, {
		key: 'submit',
		value: function submit() {
			var _this2 = this;

			this.loading = true;
			this.UsersService.update(this.model.id, {
				id: this.model.id,
				firstName: this.model.firstName,
				lastName: this.model.lastName,
				email: this.model.email,
				languageId: this.model.languageId,
				supervisor: this.model.supervisor,
				password: this.model.password,
				branchId: this.model.branchId
			}).then(function (data) {
				_this2.User.setUser(data);
				_this2.defaultModel = _this2.User.getUser();

				_this2.reset();
			}).catch(function (err) {
				err.data.errors.map(function (e) {
					_this2.errorMessage += e.message + '<br/>';
				});
			}).finally(function () {
				_this2.loading = false;
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.model = angular.copy(this.defaultModel);
			this.model.supervisor = !!this.model.supervisor;
			this.cnfPassword = '';
		}
	}]);
	return UsersProfileController;
}();

exports.default = UsersProfileController;

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _usersAll = __webpack_require__(2354);

var _usersAll2 = _interopRequireDefault(_usersAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersallModule = angular.module('usersall', []).run(['$rootScope', '$uibModalStack', function ($rootScope, $uibModalStack) {
    // close the opened modal on browser back button
    $rootScope.$on('$locationChangeStart', function ($event) {
        var openedModal = $uibModalStack.getTop();
        if (openedModal) {
            if (!!$event.preventDefault) {
                $event.preventDefault();
            }
            if (!!$event.stopPropagation) {
                $event.stopPropagation();
            }
            $uibModalStack.dismiss(openedModal.key);
            // window.history.back();
        }
    });
}]).component('usersall', _usersAll2.default).name;
exports.default = usersallModule;

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _usersAll = __webpack_require__(2883);

var _usersAll2 = _interopRequireDefault(_usersAll);

var _usersAll3 = __webpack_require__(2355);

var _usersAll4 = _interopRequireDefault(_usersAll3);

__webpack_require__(3153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _usersAll2.default,
  controller: _usersAll4.default
};

exports.default = usersallComponent;

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _usersBase = __webpack_require__(285);

var _usersBase2 = _interopRequireDefault(_usersBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersallController = function (_UsersBaseController) {
  UsersallController.$inject = ["Auth", "$state", "User", "Modal", "UsersService", "CommonLayoutService", "$translate", "$stateParams", "$scope", "$window", "$location"];
  (0, _inherits3.default)(UsersallController, _UsersBaseController);

  /*@ngInject*/
  function UsersallController(Auth, $state, User, Modal, UsersService, CommonLayoutService, $translate, $stateParams, $scope, $window, $location) {
    (0, _classCallCheck3.default)(this, UsersallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UsersallController.__proto__ || (0, _getPrototypeOf2.default)(UsersallController)).call(this, Auth, $state, User, UsersService, Modal, $translate, $stateParams, $location));

    _this.$state = $state;
    _this.$window = $window;
    _this.UsersService = UsersService;
    _this.CommonLayoutService = CommonLayoutService;
    _this.id = 'users.all';
    _this.loading = true;
    _this.users = [];
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.hasACL = {};
    _this.searchText = '';
    _this.User = User;
    _this.hasUserEditPermission = true;
    _this.hasBulkUpdateUserPermission = true;
    _this.branch = User.getUser().branchId, _this.loggedInUser = User.getUser().id, _this.leader = {};
    _this._status = 'all';
    _this.userStatus = [{
      label: 'All',
      value: 'all'
    },
    // {
    //   label: 'Active',
    //   value: 'active'
    // }, {
    //   label: 'Inactive',
    //   value: 'inactive'
    // }, 
    {
      label: _this.$translate.instant('users.webUser'),
      value: 'web'
    }, {
      label: _this.$translate.instant('users.handheldUser'),
      value: 'hht'
    }, {
      label: _this.$translate.instant('users.service_user'),
      value: 'serviceUser'
    }, {
      label: _this.$translate.instant('users.customer_user'),
      value: 'customerUser'
    }, {
      label: _this.$translate.instant('users.supervisor'),
      value: 'supervisor'
    }];
    _this.$location = $location;
    _this.userStats = 'active';
    _this.filterByValue = null;
    _this.model.filterByAllBranch = false;
    return _this;
  }

  (0, _createClass3.default)(UsersallController, [{
    key: 'isMe',
    value: function isMe(id) {
      return id === this.User.getUser().id;
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
      this.UsersService.validateUserPermissions(this.User.getUser().firstName, this.User.getUser().lastName).then(function (permission) {
        _this2.hasUserEditPermission = permission.hasUserEditPermission || _this2.CommonLayoutService.isAllowToAccessPages();
        _this2.hasBulkUpdateUserPermission = permission.hasBulkUpdateUserPermission || _this2.CommonLayoutService.isAllowToAccessPages();
      });
      // this.userLogEntry();
    }
  }, {
    key: 'edit',
    value: function edit(user) {
      this.$state.go('users.edit', {
        id: user.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(user) {
      var _this3 = this;

      if (this.allowOnlyOnce) return;
      this.allowOnlyOnce = true;
      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + user.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this3.Service.remove(user.id, _this3.branch).then(function (data) {
            _this3.allowOnlyOnce = false;
            modal.close();
            _this3.refresh();
          });
        },
        negative: function negative(_ref2) {
          var modal = _ref2.modal;

          _this3.allowOnlyOnce = false;
          modal.close();
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this4 = this;

      var searchObj = this.generateSearchObj();

      this.loading = true;
      this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this4.total = data.total;
        _this4.loading = false;
        _this4.users = data.results;
        _this4.userInfo = data;
      }).catch(function (err) {
        _this4.loading = false;
        _this4.error = err.message;
      });
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      var searchObj = {
        queryJSON: {
          rules: [{
            field: 'branchId',
            condition: '=',
            data: this.branch
          }],
          operator: 'AND'
        }
      };

      if (this.searchText) {
        var searchFields = ['firstName', 'lastName', 'id'];
        var trimmedSearchText = this.searchText.trim();
        var searchWords = trimmedSearchText.split(/[^a-zA-Z0-9]+/).filter(function (word) {
          return (/[a-zA-Z0-9]/.test(word)
          );
        });

        if (!searchWords.length && trimmedSearchText) {
          searchWords = [trimmedSearchText];
        }

        if (searchWords.length) {
          searchObj.queryJSON.rules.push({
            group: {
              operator: 'AND',
              rules: searchWords.map(function (word) {
                return {
                  group: {
                    operator: 'OR',
                    rules: searchFields.map(function (field) {
                      return {
                        field: field,
                        condition: 'like',
                        data: '%' + word + '%'
                      };
                    })
                  }
                };
              })
            }
          });
        }
      }

      switch (this._status) {
        // case 'active': {
        //   searchObj.queryJSON.rules.push({
        //     field: 'disabled',
        //     condition: '=',
        //     data: false
        //   });
        //   break;
        // }
        // case 'inactive': {
        //   searchObj.queryJSON.rules.push({
        //     field: 'disabled',
        //     condition: '=',
        //     data: true
        //   });
        //   break;
        // }
        case 'web':
          {
            searchObj.queryJSON.rules.push({
              field: 'email',
              condition: '!=',
              data: null
            });
            break;
          }
        case 'hht':
          {
            searchObj.queryJSON.rules.push({
              // field: 'email',
              // condition: '=',
              // data: null
              field: 'downloadToHHT',
              condition: '=',
              data: true
            });
            break;
          }
        case 'serviceUser':
          {
            searchObj.queryJSON.rules.push({
              field: 'serviceUser',
              condition: '=',
              data: true
            });
            break;
          }
        case 'customerUser':
          {
            searchObj.queryJSON.rules.push({
              field: 'customerUser',
              condition: '=',
              data: true
            });
            break;
          }
        case 'supervisor':
          {
            searchObj.queryJSON.rules.push({
              field: 'supervisor',
              condition: '=',
              data: true
            });
            break;
          }
      }

      switch (this.userStats) {
        case 'active':
          {
            searchObj.queryJSON.rules.push({
              "group": {
                "rules": [{
                  "field": 'downloadToHHT',
                  "condition": '=',
                  "data": true
                }, {
                  "field": 'email',
                  "condition": '!=',
                  "data": null
                }, {
                  "field": 'supervisor',
                  "condition": '=',
                  "data": true
                }, {
                  "field": 'serviceUser',
                  "condition": '=',
                  "data": true
                }],
                "operator": "OR"
              }
            });
            break;
          }
        case 'inactive':
          {
            searchObj.queryJSON.rules.push({
              field: 'downloadToHHT',
              condition: '=',
              data: false
            }, {
              field: 'email',
              condition: '=',
              data: null
            }, {
              field: 'supervisor',
              condition: '=',
              data: false
            }, {
              field: 'serviceUser',
              condition: '=',
              data: false
            });
            break;
          }
      }

      searchObj.extraDetails = {
        searchText: this.searchText,
        status: this._status,
        branchId: this.branch,
        filterByAllBranch: this.model.filterByAllBranch
      };

      return searchObj;
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      var newUrl = window.location.pathname.replace('/' + this.$stateParams.page, '/' + this.page);
      this.$stateParams.page = this.page;
      this.$location.path(newUrl);
      this.loadData();
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(user) {
      user.expand = !user.expand;
    }
  }, {
    key: 'userLogEntry',
    value: function userLogEntry() {
      var _this5 = this;

      this.Service.getLatestLogEntry(this.loggedInUser).then(function (logs) {
        _this5.lastLoginDate = logs && logs.createdAt ? logs.createdAt : null;
        _this5.lastLoginSource = logs && logs.entryData ? logs.entryData.loginSource : null;
        _this5.userId = logs.userId;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'getUserStats',
    value: function getUserStats(value) {
      // this._status = 'all';
      this.page = 1;
      this.userStats = this.userStats === value ? undefined : value;
      var id = value === 'active' ? 'active-user' : 'inactive-user';
      document.getElementById(id).blur();
      this.loadData();
    }
  }, {
    key: 'filterByBranch',
    value: function filterByBranch(value) {
      this.page = 1;
      this.filterByValue = this.filterByValue === value ? undefined : value;
      this.model.filterByAllBranch = this.filterByValue ? true : false;
      this.loadData();
    }
  }, {
    key: 'updateCustomerUserPermissions',
    value: function updateCustomerUserPermissions() {
      var _this6 = this;

      this.updatingCustomerUserPermissions = true;
      this.UsersService.updateCustomerUserPermissions().then(function (res) {
        _this6.Modal.confirm({
          header: _this6.$translate.instant('successModal.title'),
          message: _this6.$translate.instant('Customer Users, Branch, password and permissions updated.'),
          callback: function callback(_ref3) {
            var modal = _ref3.modal;

            modal.close();
          },
          buttons: ['common.ok'],
          type: 'success'
        });
      }).catch(function (err) {
        if (err && err.data && err.data.message) {
          _this6.Modal.errorModal(err.data.message);
        }
      }).finally(function () {
        _this6.updatingCustomerUserPermissions = false;
      });
    }
  }, {
    key: 'bulkUpdateUserPermissions',
    value: function bulkUpdateUserPermissions() {
      var _this7 = this;

      this.Modal.bulkUpdateUserPermissionsModal(function (payload) {
        if (!payload) return;
        _this7.updatingCustomerUserPermissions = true;
        _this7.UsersService.bulkUpdateCustomerUsers(payload).then(function () {
          var msg = payload.isCustomerUser ? 'Customer user details update successfully.' : 'Web user details update successfully.';
          _this7.Modal.confirm({
            header: _this7.$translate.instant('successModal.title'),
            message: _this7.$translate.instant(msg),
            callback: function callback(_ref4) {
              var modal = _ref4.modal;

              modal.close();
              _this7.refresh();
            },
            buttons: ['common.ok'],
            type: 'success'
          });
        }).catch(function (err) {
          _this7.Modal.alert({
            header: 'Error',
            message: err.data ? err.data.message : err.message || 'An error occurred',
            type: 'danger'
          });
        }).finally(function () {
          _this7.updatingCustomerUserPermissions = false;
        });
      }, function () {}, this.branch);
    }
  }]);
  return UsersallController;
}(_usersBase2.default);

exports.default = UsersallController;

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _usersCreate = __webpack_require__(2357);

var _usersCreate2 = _interopRequireDefault(_usersCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersCreateModule = angular.module('userscreate', []).component('userscreate', _usersCreate2.default).name;

exports.default = usersCreateModule;

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _usersCreate = __webpack_require__(2884);

var _usersCreate2 = _interopRequireDefault(_usersCreate);

var _usersCreate3 = __webpack_require__(2358);

var _usersCreate4 = _interopRequireDefault(_usersCreate3);

__webpack_require__(3154);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userscreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _usersCreate2.default,
  controller: _usersCreate4.default
};

exports.default = userscreateComponent;

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _usersBase = __webpack_require__(285);

var _usersBase2 = _interopRequireDefault(_usersBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersCreateController = function (_UsersBaseController) {
	UsersCreateController.$inject = ["Auth", "$state", "User", "UsersService", "Modal", "$translate", "UserService", "BranchService", "$q", "SetupService", "$scope", "BranchFundingSourceService", "UserBranchFundingSourceService", "TimezoneList", "CustomerService", "CommonLayoutService", "LocationZoneService", "AtmMakesService", "Configs"];
	(0, _inherits3.default)(UsersCreateController, _UsersBaseController);

	/*@ngInject*/
	function UsersCreateController(Auth, $state, User, UsersService, Modal, $translate, UserService, BranchService, $q, SetupService, $scope, BranchFundingSourceService, UserBranchFundingSourceService, TimezoneList, CustomerService, CommonLayoutService, LocationZoneService, AtmMakesService, Configs) {
		(0, _classCallCheck3.default)(this, UsersCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (UsersCreateController.__proto__ || (0, _getPrototypeOf2.default)(UsersCreateController)).call(this, Auth, $state, User, UsersService, Modal, $translate));

		_this.Configs = Configs;
		_this.UserService = UserService;
		_this.BranchService = BranchService;
		_this.SetupService = SetupService;
		_this.CustomerService = CustomerService;
		_this.$q = $q;
		_this.$scope = $scope;
		_this.BranchFundingSourceService = BranchFundingSourceService;
		_this.UserBranchFundingSourceService = UserBranchFundingSourceService;
		_this.TimezoneList = TimezoneList;
		_this.CommonLayoutService = CommonLayoutService;
		_this.LocationZoneService = LocationZoneService;
		_this.AtmMakesService = AtmMakesService;
		_this.defaultModel = {
			firstName: '',
			lastName: '',
			email: '',
			supervisor: false,
			languageId: 'E',
			password: '',
			branchId: null,
			downloadToHHT: false,
			isWebUser: true,
			// kabaKeyId: '',
			// SGKeyId: '',
			defaultAppView: 'List',
			hhtPassword: null,
			phone: null,
			// routeKeyId: '',
			// tecnoDevId: '',
			// OTCCompanyName: null,
			loggedInUser: User.getUser().branchId,
			serviceUser: false,
			timezone: null,
			customerUser: false,
			autoCheckIn: false,
			autoCheckOut: false,
			sameForAll: true,
			payrollId: null,
			limitToServiceZone: false,
			rejectTickets: false,
			shipmentTransfer: false,
			selfAssignServiceTicket: false,
			userAssignServiceTicket: false,
			addActions: false,
			createTickets: false,
			serviceLevel: null,
			userOrigin: null,
			address: null,
			city: null,
			state: null,
			zip: null,
			country: null,
			isNonUSLocation: false,
			lat: null,
			long: null,
			make: [],
			schedule: {}
		};

		_this.scheduleDays = [{ key: 'Mon', label: 'Monday', shortLabel: 'Monday', startKey: 'startTimeMon', endKey: 'endTimeMon', active: false }, { key: 'Tue', label: 'Tuesday', shortLabel: 'Tuesday', startKey: 'startTimeTue', endKey: 'endTimeTue', active: false }, { key: 'Wed', label: 'Wednesday', shortLabel: 'Wednesday', startKey: 'startTimeWed', endKey: 'endTimeWed', active: false }, { key: 'Thu', label: 'Thursday', shortLabel: 'Thursday', startKey: 'startTimeThu', endKey: 'endTimeThu', active: false }, { key: 'Fri', label: 'Friday', shortLabel: 'Friday', startKey: 'startTimeFri', endKey: 'endTimeFri', active: false }, { key: 'Sat', label: 'Saturday', shortLabel: 'Saturday', startKey: 'startTimeSat', endKey: 'endTimeSat', active: false }, { key: 'Sun', label: 'Sunday', shortLabel: 'Sunday', startKey: 'startTimeSun', endKey: 'endTimeSun', active: false }, { key: 'Holiday', label: 'Holiday', shortLabel: 'Holiday', startKey: 'startTimeHoliday', endKey: 'endTimeHoliday', active: false }];
		_this.scheduleErrors = {};

		_this.serviceLevelList = [{ label: '(None)', value: null }, { label: 'FLM', value: 'FLM' }, { label: 'SLM', value: 'SLM' }];

		_this.userOriginList = [{ label: '(None)', value: null }, { label: 'Branch', value: 'BRANCH' }, { label: 'Vehicle', value: 'VEHICLE' }, { label: 'User', value: 'USER' }];
		_this.atmMakesList = [];

		_this.defaultAppView = [{
			label: 'List View',
			value: 'List'
		}, {
			label: 'All Map View',
			value: 'All'
		}, {
			label: 'Next Map View',
			value: 'Next'
		}, {
			label: 'Next 3 Map View',
			value: 'Next3'
		}];

		_this.OTCCompanyNameList = [];
		_this.branch = [];
		_this.language = [{
			value: 'E',
			label: "English"
		},
		// {
		// 	value: 'F',
		// 	label: 'French'
		// }
		{
			value: 'S',
			label: 'Spanish'
		}];
		_this.cnfPassword = '';
		_this.branches = [];
		_this.serviceZoneData = [];
		_this.permissions = _this.Auth.permission();
		_this.permissionsToAssign = {};
		_this.localLang = {
			selectAll: _this.$translate.instant('common.selectall'),
			selectNone: _this.$translate.instant('common.selectnone'),
			reset: _this.$translate.instant('shipmentBatch.reset'),
			search: _this.$translate.instant('common.search'),
			nothingSelected: _this.$translate.instant('common.noneselected') //default-label is deprecated and replaced with this.
		};
		_this.model = angular.copy(_this.defaultModel);
		_this.OTCKeys = {};
		_this.company = {};
		_this.timezoneList = _this.TimezoneList.getTimezoneList();
		_this.countStationList = [];
		_this.customerList = [];
		_this.totalCustomer = 0;
		// this.lockSystem = [
		// 	{
		// 		label: 'KABA FLM',
		// 		value: 'kabaKeyId'
		// 	},
		// 	{
		// 		label: 'KABA Route',
		// 		value: 'routeKeyId'
		// 	},
		// 	{
		// 		label: 'S&G',
		// 		value: 'SGKeyId'
		// 	},
		// 	{
		// 		label: 'Witz',
		// 		value: 'witzKeyId'
		// 	}
		// ];
		return _this;
	}

	(0, _createClass3.default)(UsersCreateController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.Configs.getConfigs().then(function (data) {
				_this2.googleMapConfig = data.googleMap;
				_this2.apiKey = '//maps.google.com/maps/api/js?key=' + _this2.googleMapConfig.key + '&libraries=places';
				setTimeout(function () {
					_this2.render = true;
				}, 100);
			});

			this.$q.all([this.BranchService.all(null, 0, 1000), this.SetupService.all(null, 0, 1000), this.SetupService.get(this.model.loggedInUser)]).then(function (data) {
				_this2.OTCCompanies = data[2].companies;
				_this2.allSetup = data[1].results;
				var branchesWithExistingSetupRecord = data[1].results.map(function (setupRecord) {
					return setupRecord.branchId;
				});
				_this2.branches = data[0].results.filter(function (branch) {
					return branchesWithExistingSetupRecord.includes(branch.id);
				});

				_this2.branches.filter(function (branch) {
					return branch.id === _this2.model.branch;
				}).map(function (branch) {
					branch.ticked = true;
					return branch;
				});
			}).then(function () {
				_this2.setOtcKeys();
				_this2.OTCCompanyMap();
				_this2.getCustomer('', 0);
				_this2.validateAutoChekInChekOut();
				_this2.loadAtmMakes();
			}).catch(function (err) {});
		}
	}, {
		key: 'toggle',
		value: function toggle(language) {
			this.model.languageId = language.value;
		}
	}, {
		key: 'format',
		value: function format(key, parentKey) {
			if (parentKey === 'branch_mgmt_orders' && key === 'all') {
				return this.$translate.instant('common.View');
			}
			if (typeof key == 'string') {
				key = key.replace('_', '-');
				key = key !== 'assign' && key !== 'export' ? key.charAt(0).toUpperCase() + key.slice(1) : key;
				key = this.$translate.instant('common.' + key);
			}
			return key;
		}
	}, {
		key: 'togglePerm',
		value: function togglePerm(key, parentKey) {
			var _this3 = this;

			if (parentKey === 'cash_activity' && !this.hasPerm(key, parentKey)) {
				var otherKey = key === 'customer' ? 'funding_source' : 'customer';
				if (this.hasPerm(otherKey, parentKey)) {
					this.permissionsToAssign[parentKey] = this.permissionsToAssign[parentKey].filter(function (k) {
						return k !== otherKey;
					});
				}
			}

			var permissionObj = this.permissionsToAssign[parentKey];

			if (this.hasPerm(key, parentKey)) {
				this.permissionsToAssign[parentKey] = permissionObj.filter(function (p) {
					return p !== key;
				});
				var nextPermObj = this.permissionsToAssign[parentKey];

				var activePerms = nextPermObj.filter(function (p) {
					return p !== 'default_redirect';
				});
				if (activePerms.length === 0) {
					var hadRedirect = nextPermObj.includes('default_redirect');
					delete this.permissionsToAssign[parentKey];
					if (hadRedirect) {
						var parentCategory = this.getParentCategoryKey(parentKey);
						if (parentCategory) {
							if (!this.permissionsToAssign[parentCategory]) {
								this.permissionsToAssign[parentCategory] = [];
							}
							if (!this.permissionsToAssign[parentCategory].includes('default_redirect')) {
								this.permissionsToAssign[parentCategory] = [].concat((0, _toConsumableArray3.default)(this.permissionsToAssign[parentCategory]), ['default_redirect']);
							}
						}
					}
				}

				if (!nextPermObj.length || activePerms.length === 0) {
					if (parentKey == 'setting') {
						var settingChild = this.permissions.setting.child;
						var resources = (0, _keys2.default)(settingChild);
						resources.map(function (resource) {
							if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
							delete _this3.permissionsToAssign[resource];
						});
					} else if (parentKey == 'branch_mgmt') {
						var branchMgmtChild = this.permissions.branch_mgmt.child;
						var _resources = (0, _keys2.default)(branchMgmtChild);
						_resources.forEach(function (resource) {
							if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
							delete _this3.permissionsToAssign[resource];
						});
					} else if (parentKey == 'branch_mgmt_billing_approval') {
						var branchMgmtBillChild = this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.child;
						var _resources2 = (0, _keys2.default)(branchMgmtBillChild);
						_resources2.forEach(function (resource) {
							if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
							delete _this3.permissionsToAssign[resource];
						});
					} else if (parentKey == 'tnt_billing_fuel_surcharges') {
						var tntBillingFuelsurchargeChild = this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.child;
						var _resources3 = (0, _keys2.default)(tntBillingFuelsurchargeChild);
						_resources3.forEach(function (resource) {
							if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
							delete _this3.permissionsToAssign[resource];
						});
					} else if (['tnt_billing', 'tnt_control', 'reporting', 'order_packing', 'bulk_transfer'].indexOf(parentKey) >= 0) {
						var child = this.permissions[parentKey].child;
						var _resources4 = (0, _keys2.default)(child);
						_resources4.forEach(function (resource) {
							if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
							delete _this3.permissionsToAssign[resource];
						});
					}
					delete this.permissionsToAssign[parentKey];
				}
			} else {
				if (permissionObj) {
					permissionObj.push(key);
				} else {
					this.permissionsToAssign[parentKey] = [key];

					// if (parentKey == 'setting') {
					// 	const settingChild = this.permissions.setting.child;
					// 	const resources = Object.keys(settingChild);
					// 	resources.map((resource) => {
					// 		if (resource == 'setting-log')
					// 			this.permissionsToAssign[resource] = ["view"];
					// 		else if (resource == 'setting-location')
					// 			this.permissionsToAssign[resource] = ["edit", "delete", "view", "create", "importLocations"];
					// 		else
					// 			this.permissionsToAssign[resource] = ["edit", "delete", "view", "create"];
					// 	})
					// } else 
					if (parentKey == 'branch_mgmt') {
						var _branchMgmtChild = this.permissions.branch_mgmt.child;
						var _resources5 = (0, _keys2.default)(_branchMgmtChild);
						_resources5.forEach(function (resource) {
							if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
							_this3.permissionsToAssign[resource] = ["all"];
						});
					} else if (parentKey == 'branch_mgmt_billing_approval') {
						var _branchMgmtBillChild = this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.child;
						var _resources6 = (0, _keys2.default)(_branchMgmtBillChild);
						_resources6.forEach(function (resource) {
							if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
							_this3.permissionsToAssign[resource] = ["allow"];
						});
					} else if (parentKey == 'tnt_billing_fuel_surcharges') {
						var _tntBillingFuelsurchargeChild = this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.child;
						var childPermisions = [];
						if (_tntBillingFuelsurchargeChild['edit']) childPermisions.push('edit');
						if (_tntBillingFuelsurchargeChild['view']) childPermisions.push('view');
						if (_tntBillingFuelsurchargeChild['create']) childPermisions.push('create');

						var _resources7 = (0, _keys2.default)(_tntBillingFuelsurchargeChild);
						_resources7.forEach(function (resource) {
							if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
							_this3.permissionsToAssign[resource] = childPermisions; //Object.keys(childPermission[resource].permission);
						});
					} else if (['setting', 'tnt_billing', 'tnt_control', 'reporting', 'order_packing', 'bulk_transfer'].indexOf(parentKey) >= 0) {
						var _child = this.permissions[parentKey].child;
						var _resources8 = (0, _keys2.default)(_child);
						_resources8.forEach(function (resource) {
							if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
							if (_this3.model.customerUser && resource == 'setting-location') {
								_this3.permissionsToAssign[resource] = ["view", "edit"];
							} else {
								_this3.permissionsToAssign[resource] = (0, _keys2.default)(_child[resource].permission).filter(function (p) {
									return p !== 'default_redirect';
								});
							}
						});
					}
				}
			}

			this.cleanupOrphanedDefaultRedirects();
		}
	}, {
		key: 'allowSettings',
		value: function allowSettings(key, parentKey) {
			this.permissionsToAssign['setting'] = ["all"];
		}
	}, {
		key: 'hasPerm',
		value: function hasPerm(key, parentKey) {
			var permissionObj = this.permissionsToAssign[parentKey];

			if (permissionObj) {
				return permissionObj.includes(key);
			} else {
				return false;
			}
		}
	}, {
		key: 'findResourceNode',
		value: function findResourceNode(resource) {
			if (this.permissions[resource]) return this.permissions[resource];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = (0, _getIterator3.default)((0, _values2.default)(this.permissions)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var topVal = _step.value;

					if (topVal.child && topVal.child[resource]) return topVal.child[resource];
					if (topVal.child) {
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;

						try {
							for (var _iterator2 = (0, _getIterator3.default)((0, _values2.default)(topVal.child)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var childVal = _step2.value;

								if (childVal.child && childVal.child[resource]) return childVal.child[resource];
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return null;
		}
	}, {
		key: 'hasAnyPerm',
		value: function hasAnyPerm(resource) {
			var _this4 = this;

			var permissionObj = this.permissionsToAssign[resource];
			if (Array.isArray(permissionObj) && permissionObj.some(function (p) {
				return p !== 'default_redirect';
			})) {
				return true;
			}
			var node = this.findResourceNode(resource);
			if (node && node.child) {
				return (0, _keys2.default)(node.child).some(function (childKey) {
					return _this4.hasAnyPerm(childKey);
				});
			}
			return false;
		}
	}, {
		key: 'cleanupOrphanedDefaultRedirects',
		value: function cleanupOrphanedDefaultRedirects() {
			var _this5 = this;

			(0, _keys2.default)(this.permissionsToAssign).forEach(function (resource) {
				var perms = _this5.permissionsToAssign[resource];
				if (Array.isArray(perms) && perms.includes('default_redirect') && !_this5.hasAnyPerm(resource)) {
					_this5.permissionsToAssign[resource] = perms.filter(function (p) {
						return p !== 'default_redirect';
					});
					if (_this5.permissionsToAssign[resource].length === 0) {
						delete _this5.permissionsToAssign[resource];
					}
				}
			});
		}
	}, {
		key: 'hasChildDefaultRedirect',
		value: function hasChildDefaultRedirect(parentKey) {
			var _this6 = this;

			var parentPerm = this.permissions[parentKey];
			if (!parentPerm || !parentPerm.child) return false;
			return (0, _keys2.default)(parentPerm.child).some(function (childKey) {
				return _this6.hasPerm('default_redirect', childKey);
			});
		}
	}, {
		key: 'getParentCategoryKey',
		value: function getParentCategoryKey(resource) {
			if (resource.startsWith('setting-')) return 'setting';
			if (resource.startsWith('branch_mgmt_')) return 'branch_mgmt';
			if (resource.startsWith('tnt_billing_')) return 'tnt_billing';
			if (resource.startsWith('tnt_control_')) return 'tnt_control';
			if (resource.startsWith('reporting_')) return 'reporting';
			return null;
		}
	}, {
		key: 'toggleDefaultRedirect',
		value: function toggleDefaultRedirect(resource) {
			var _this7 = this;

			var isCurrentlyChecked = this.hasPerm('default_redirect', resource) || this.hasChildDefaultRedirect(resource);

			// 1. Find all resources that currently have default_redirect
			var resourcesToClear = (0, _keys2.default)(this.permissionsToAssign).filter(function (res) {
				return _this7.hasPerm('default_redirect', res);
			});

			// 2. Update local state synchronously immediately
			resourcesToClear.forEach(function (res) {
				if (Array.isArray(_this7.permissionsToAssign[res])) {
					_this7.permissionsToAssign[res] = _this7.permissionsToAssign[res].filter(function (p) {
						return p !== 'default_redirect';
					});
					if (_this7.permissionsToAssign[res].length === 0) {
						delete _this7.permissionsToAssign[res];
					}
				}
			});

			var nextResourceToSet = null;
			if (!isCurrentlyChecked) {
				nextResourceToSet = resource;
			} else {
				// If we uncheck a child/grandchild redirect, shift it back to parent category
				var parentCategory = this.getParentCategoryKey(resource);
				if (parentCategory) {
					nextResourceToSet = parentCategory;
				}
			}

			if (nextResourceToSet) {
				if (!this.permissionsToAssign[nextResourceToSet]) {
					this.permissionsToAssign[nextResourceToSet] = [];
				}
				if (!this.permissionsToAssign[nextResourceToSet].includes('default_redirect')) {
					this.permissionsToAssign[nextResourceToSet] = [].concat((0, _toConsumableArray3.default)(this.permissionsToAssign[nextResourceToSet]), ['default_redirect']);
				}
			}
		}
	}, {
		key: 'toggleExpand',
		value: function toggleExpand(perm) {
			// this.permissions[perm].expand = !this.permissions[perm].expand
			if (perm === 'branch_mgmt_billing_approval' && this.permissions.branch_mgmt && this.permissions.branch_mgmt.child && this.permissions.branch_mgmt.child.branch_mgmt_billing_approval) {
				this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand = !this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand;
			}

			if (perm === 'tnt_billing_fuel_surcharges' && this.permissions.tnt_billing && this.permissions.tnt_billing.child && this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges) {
				this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand = !this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand;
			}

			if (this.permissions[perm]) {
				this.permissions[perm].expand = !this.permissions[perm].expand;
			}
		}
	}, {
		key: 'expand',
		value: function expand(parentKey) {
			// return !!this.permissions[parentKey].expand;
			if (parentKey === 'branch_mgmt_billing_approval' && this.permissions.branch_mgmt && this.permissions.branch_mgmt.child && this.permissions.branch_mgmt.child.branch_mgmt_billing_approval) {
				return !!this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand;
			}

			if (parentKey === 'tnt_billing_fuel_surcharges' && this.permissions.tnt_billing && this.permissions.tnt_billing.child && this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges) {
				return !!this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand;
			}

			if (this.permissions[parentKey]) {
				return !!this.permissions[parentKey].expand;
			}
			return false;
		}
	}, {
		key: 'isLangSelected',
		value: function isLangSelected(language) {
			return language.value == this.model.languageId;
		}

		// Reset Multi-Branch selection

	}, {
		key: 'resetMultiBranchSelection',
		value: function resetMultiBranchSelection() {
			var _this8 = this;

			if (this.model.branch && this.model.branch.length) {
				this.model.branch.forEach(function (selectedBranch) {
					_this8.branches.filter(function (branch) {
						if (branch.branchId == selectedBranch.branchId) {
							branch.ticked = false;
						}
					});
				});
			}
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.resetMultiBranchSelection();
			this.clearErrors();
			this.cnfPassword = '';
			this.permissionsToAssign = {};
			this.OTCKeys = {};
			this.setOtcKeys();
			this.model = angular.copy(this.defaultModel);
			this.loadSchedule(null);
		}
	}, {
		key: 'resetWebUserData',
		value: function resetWebUserData() {
			for (var key in this.model) {
				if (key == 'isWebUser') {} else {
					this.model["email"] = null;
					this.model["password"] = null;
					this.cnfPassword = null;
				}
			}
			this.undoChanges();
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this9 = this;

			// console.log(this.OTCKeys);
			if (!this.validate()) {
				return;
			}

			this.loading = true;

			if (!(this.model.isWebUser || this.model.customerUser)) {
				this.model.email = this.model.password = null;
			}

			var serviceZoneData = [];
			if (this.model.limitToServiceZone && this.model.selectedZones.length > 0) {
				serviceZoneData = this.model.selectedZones.map(function (lz) {
					return {
						locationZoneId: lz.zoneId, userId: _this9.model.id
					};
				});
			}

			this.Service.create({
				id: this.model.id,
				firstName: this.model.firstName,
				lastName: this.model.lastName,
				email: this.model.email,
				supervisor: this.model.supervisor,
				languageId: this.model.languageId,
				branchId: this.model.branchId,
				password: this.model.password,
				downloadToHHT: this.model.downloadToHHT,
				// kabaKeyId: (this.model.kabaKeyId && this.model.downloadToHHT) ? this.model.kabaKeyId : null,
				// SGKeyId: (this.model.SGKeyId && this.model.downloadToHHT) ? this.model.SGKeyId : null,
				defaultAppView: this.model.downloadToHHT || this.model.serviceUser ? this.model.defaultAppView : null,
				hhtPassword: this.model.hhtPassword ? this.model.hhtPassword : null,
				phone: this.model.phone ? this.model.phone : null,
				// routeKeyId: (this.model.routeKeyId && this.model.downloadToHHT) ? this.model.routeKeyId : null,
				// tecnoDevId: (this.model.tecnoDevId && this.model.downloadToHHT) ? this.model.tecnoDevId : null,
				// OTCCompanyName: this.model.OTCCompanyName,
				OTCKeys: this.OTCKeys,
				serviceUser: this.model.serviceUser,
				timezone: this.model.timezone,
				customerUser: this.model.customerUser,
				customerId: this.model.customer ? this.model.customer.Value : null,
				autoCheckIn: this.enableAutoCheckInCheckOut && this.model.downloadToHHT ? this.model.autoCheckIn || false : false,
				autoCheckOut: this.enableAutoCheckInCheckOut && this.model.downloadToHHT ? this.model.autoCheckOut || false : false,
				payrollId: this.model.payrollId ? this.model.payrollId : null,
				limitToServiceZone: this.model.serviceUser ? this.model.limitToServiceZone || false : false,
				rejectTickets: this.model.serviceUser || this.model.downloadToHHT ? this.model.rejectTickets : false,
				selfAssignServiceTicket: this.model.serviceUser ? this.model.selfAssignServiceTicket : false,
				userAssignServiceTicket: this.model.serviceUser ? this.model.userAssignServiceTicket : false,
				addActions: this.model.serviceUser ? this.model.addActions : false,
				createTickets: this.model.serviceUser ? this.model.createTickets : false,
				serviceZoneData: serviceZoneData,
				shipmentTransfer: this.model.shipmentTransfer || false,
				branchCounterId: this.model.isWebUser ? this.model.branchCounterId : null,
				serviceLevel: this.model.serviceUser ? this.model.serviceLevel : null,
				userOrigin: this.model.serviceUser ? this.model.userOrigin : null,
				address: this.model.address || null,
				city: this.model.city || null,
				state: this.model.state || null,
				zip: this.model.zip || null,
				country: this.model.isNonUSLocation ? this.model.country : this.model.address ? 'US' : null,
				lat: this.model.lat || null,
				long: this.model.long || null,
				make: this.model.serviceUser ? this.parseMakeValues(this.model.make) : [],
				schedule: this.model.downloadToHHT || this.model.serviceUser || this.model.isWebUser ? this.formatScheduleForSave() : null
			}).then(function (data) {
				_this9.loading = false;
				if (data['id']) {
					var id = data['id'];
					var branchId = data['branchId'];
					var resources = (0, _keys2.default)(_this9.permissionsToAssign);
					if (_this9.model.branch.length && _this9.model.sameForAll) {
						var branchIds = _this9.model.branch.map(function (b) {
							return b.id;
						});
						var defer = _this9.$q.defer();
						_this9.createUserPermission(resources, branchIds, id).then(function (res) {
							defer.resolve();
						}).catch(function (err) {
							defer.reject(err);
						});
						return defer.promise;
						// })
						// return this.$q.all(promise)
					} else {
						return _this9.createUserPermission(resources, [branchId], id);
					}
				}
			}).then(function (res) {
				_this9.addMultipleBranchs();
				_this9.createUserFundingSourceGroup();
				_this9.askCreate();
			}).catch(function (err) {
				_this9.loading = false;
				if (err && err.data && err.data.message) {
					_this9.errorMessage += err.data.message + '<br/>';
				} else if (err.data.errors && err.data.errors[0].path == 'PRIMARY') {
					_this9.errorMessage = _this9.$translate.instant('users.userId_error');
				} else {
					err.data.errors.map(function (e) {
						_this9.errorMessage += e.message + '<br/>';
					});
				}
			});
		}
	}, {
		key: 'undoChanges',
		value: function undoChanges() {
			// undo user permissions if not webUser
			if (!this.model.isWebUser) {
				this.permissionsToAssign = {};
				this.model.sameForAll = false;
				this.model.branchPermission = null;
			}
		}
	}, {
		key: 'createUserPermission',
		value: function createUserPermission(resources, branchIds, userId) {
			var _this10 = this;

			return new _promise2.default(function (resolve, reject) {
				_this10.UserService.addRole(userId, branchIds).then(function (data) {
					_this10.$q.all(resources.map(function (resource) {
						var obj = {
							role: 'user:' + userId, //this role is dependent on role passed in UserService.addRole()
							resource: resource,
							permission: _this10.permissionsToAssign[resource],
							user: userId,
							branchIds: branchIds
						};
						return _this10.UserService.updateAcl(obj, true);
					})).then(resolve).catch(reject);
				}).catch(function (err) {
					console.log(err);
					reject(err);
				});
			});
		}

		// reset value of kabaKeyId & SGKeyId

	}, {
		key: 'resetKeyId',
		value: function resetKeyId() {
			if (!this.model.downloadToHHT) {
				// this.model.kabaKeyId = null;
				// this.model.SGKeyId = null;
				// this.model.routeKeyId = null;
				// this.model.tecnoDevId = null;
				this.model.make = [];
				this.loadAtmMakes();
				this.OTCKeys = {};
				this.setOtcKeys();
				this.model.OTCCompanyName = null;
				this.model.autoCheckIn = false;
				this.model.autoCheckOut = false;
				this.isDisabledSupervisor = false;
			}
		}

		//  add multiple branch

	}, {
		key: 'addMultipleBranchs',
		value: function addMultipleBranchs() {
			var _this11 = this;

			var branches = this.model.branch.map(function (b) {
				return b.id;
			});
			return new _promise2.default(function (resolve, reject) {
				_this11.UserService.createBranchGrouped({ userId: _this11.model.id, branches: branches }).then(function () {
					resolve();
				}).catch(function (err) {
					reject(err);
				});
			});
		}
	}, {
		key: 'autoSelectSameForAll',
		value: function autoSelectSameForAll() {
			// this.$scope.$watch(() => {
			// 	return this.model.branch
			// }, (branches) => {
			// 	if (branches.length > 1) return this.model.sameForAll = true;
			// 	else return this.model.sameForAll = false;
			// })
			if (this.model.branch.length > 1) return this.model.sameForAll = true;else return this.model.sameForAll = false;
		}
	}, {
		key: 'removeSelection',
		value: function removeSelection() {
			this.model.sameForAll = false;
		}
	}, {
		key: 'loadServiceZone',
		value: function loadServiceZone() {
			var _this12 = this;

			setTimeout(function () {
				var selectedBranch = Array.isArray(_this12.model.branch) ? _this12.model.branch.map(function (branch) {
					return branch.id;
				}) : [];
				var searchObj = {
					queryJSON: {
						rules: [{ field: 'branchId', condition: 'IN', data: selectedBranch }],
						operator: 'AND'
					}
				};
				var selectedIds = (_this12.model.selectedZones || []).map(function (zone) {
					return zone.zoneId;
				});
				_this12.LocationZoneService.all(searchObj, 0, 1000).then(function (data) {
					_this12.serviceZoneData = _this12.serviceZoneMap(data.results || [], selectedIds);
					_this12.model.selectedZones = _this12.serviceZoneData.filter(function (zone) {
						return zone && zone.zoneId != null && zone.ticked;
					});
				});
			});
		}
	}, {
		key: 'serviceZoneMap',
		value: function serviceZoneMap(records, preserve) {
			var DAY_ORDER = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY', 'HOLIDAY'];
			var byBranch = _.groupBy(records || [], 'branchId');

			var grouped = [];
			(0, _keys2.default)(byBranch).sort().forEach(function (branchId) {
				grouped.push({ label: '<strong>' + branchId + '</strong>', msGroup: true });
				var byDay = _.groupBy(byBranch[branchId], 'dayOfWeek');
				DAY_ORDER.filter(function (d) {
					return byDay[d];
				}).forEach(function (day) {
					grouped.push({ label: '<strong>' + day + '</strong>', msGroup: true });
					byDay[day].forEach(function (z) {
						var info = z.id + ' | ' + z.name + ' (' + z.branchId + ', ' + z.dayOfWeek + ')';
						grouped.push({
							zoneName: z.name, zoneId: z.id, zoneInfo: info,
							label: z.id + ' | ' + z.name, ticked: preserve.includes(z.id)
						});
					});
					grouped.push({ msGroup: false });
				});
				grouped.push({ msGroup: false });
			});
			return grouped;
		}
	}, {
		key: 'setOtcKeys',
		value: function setOtcKeys() {
			this.company = this.CommonLayoutService.setOTCKeys(this.OTCCompanies).company;
			this.OTCKeys = this.CommonLayoutService.setOTCKeys(this.OTCCompanies).OTCKeys;
		}
	}, {
		key: 'OTCCompanyMap',
		value: function OTCCompanyMap() {
			this.OTCCompanyNameList = this.CommonLayoutService.OTCCompanyMapping(this.OTCCompanies);
		}

		// setPermissionBranch() {
		// 	this.model.branchPermission = this.model.branchId;
		// }

	}, {
		key: 'getFundingSource',
		value: function getFundingSource() {
			var _this13 = this;

			setTimeout(function () {
				var selectedBranch = Array.isArray(_this13.model.branch) ? _this13.model.branch.map(function (branch) {
					return branch.id;
				}) : _this13.model.branch.split();

				var searchObj = {
					queryJSON: {
						rules: [{
							field: 'branchId',
							condition: 'IN',
							data: selectedBranch
						}],
						operator: 'AND'
					}
				};

				_this13.loadFundingSource = true;
				_this13.BranchFundingSourceService.all(searchObj, 0, 1000, null).then(function (data) {
					_this13.branchFundingSourceData = data.results;
					_this13.branchFundingSourceGrouped = [];
					var grouped = _.groupBy(_this13.branchFundingSourceData, 'branchId');
					var keys = (0, _keys2.default)(grouped);
					var indexMap2 = {};
					var indexMap = {},
					    addHeader = {};

					keys.forEach(function (k) {
						delete indexMap2[k];
						grouped[k].forEach(function (g) {
							if (!addHeader.hasOwnProperty('header')) {
								addHeader['header'] = true;
								_this13.branchFundingSourceGrouped.push({
									label: '<strong>All Branch Funding Source</strong>',
									msGroup: true
								});
							}
							if (!indexMap.hasOwnProperty(g.branchId)) {
								indexMap[g.branchId] = grouped[k].length;
								_this13.branchFundingSourceGrouped.push({
									label: '<strong>' + k + '</strong>',
									msGroup: true
								});
							}
							_this13.branchFundingSourceGrouped.push({
								name: g.sourceName,
								branch: g.branchId,
								fundingSourceId: g.id,
								label: g.sourceName + ' | ' + '(' + g.locationId + ')',
								ticked: false
							});
						});
						if (!indexMap2.hasOwnProperty(k)) {
							indexMap2[k] = 0;
							_this13.branchFundingSourceGrouped.push({
								msGroup: false
							});
						}
					});
					_this13.branchFundingSourceGrouped.push({ msGroup: false });
				}).catch(function (err) {
					console.log(err);
				}).finally(function () {
					_this13.loadFundingSource = false;
				});
			});
		}
	}, {
		key: 'isServiceOnlyUser',
		value: function isServiceOnlyUser() {
			return this.model.serviceUser && !this.model.isWebUser && !this.model.supervisor && !this.model.downloadToHHT;
		}
	}, {
		key: 'createUserFundingSourceGroup',
		value: function createUserFundingSourceGroup() {
			var fundingSource = this.isServiceOnlyUser() ? [] : this.selectedFundingSource || [];
			return this.UserBranchFundingSourceService.createUserFundingSourceGroup(this.model.id, fundingSource).then(function () {
				return void undefined;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'setCustomerUser',
		value: function setCustomerUser(flag) {
			if (flag && this.model.customerUser) {
				this.model.serviceUser = false;
				this.model.supervisor = false;
				this.model.downloadToHHT = false;
				this.model.isWebUser = false;
				this.selectedFundingSource = [];
				this.removeAssignPermissions();
			} else if (!flag && (this.model.serviceUser || this.model.supervisor || this.model.downloadToHHT || this.model.isWebUser)) {
				this.model.customerUser = false;
				this.model.customer = '';
			} else if (!this.model.isWebUser && !this.model.customerUser) {
				this.removeAssignPermissions();
			}
		}
	}, {
		key: 'removeAssignPermissions',
		value: function removeAssignPermissions() {
			var _this14 = this;

			if (!this.model.isWebUser) {
				var parentAssignKeys = (0, _keys2.default)(this.permissionsToAssign);
				if (parentAssignKeys && parentAssignKeys.length) {
					parentAssignKeys.map(function (key) {
						if (_this14.model.customerUser && 0 > _this14.customerPermissions.indexOf(key)) {
							delete _this14.permissionsToAssign[key];
						} else if (!_this14.model.customerUser && !_this14.model.isWebUser) {
							delete _this14.permissionsToAssign[key];
						}
					});
				}
			}
		}
	}, {
		key: 'hasActiveAncestors',
		value: function hasActiveAncestors(resource) {
			if (this.permissions[resource]) {
				return true;
			}

			var parentKey = null;
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = (0, _getIterator3.default)((0, _entries2.default)(this.permissions)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
					    topKey = _step3$value[0],
					    topVal = _step3$value[1];

					if (topVal.child && topVal.child[resource]) {
						parentKey = topKey;
						break;
					}
					if (topVal.child) {
						var _iteratorNormalCompletion4 = true;
						var _didIteratorError4 = false;
						var _iteratorError4 = undefined;

						try {
							for (var _iterator4 = (0, _getIterator3.default)((0, _entries2.default)(topVal.child)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
								var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
								    childKey = _step4$value[0],
								    childVal = _step4$value[1];

								if (childVal.child && childVal.child[resource]) {
									parentKey = childKey;
									break;
								}
							}
						} catch (err) {
							_didIteratorError4 = true;
							_iteratorError4 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion4 && _iterator4.return) {
									_iterator4.return();
								}
							} finally {
								if (_didIteratorError4) {
									throw _iteratorError4;
								}
							}
						}

						if (parentKey) break;
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			if (!parentKey) return true;

			if (!this.hasAnyPerm(parentKey)) {
				return false;
			}

			return this.hasActiveAncestors(parentKey);
		}
	}, {
		key: 'disabledPermissions',
		value: function disabledPermissions(parent, child) {
			if (parent == 'branch_mgmt_restore_route_assignments') {
				return true;
			}

			if (this.model.customerUser) {
				if (child) {
					// if (child == 'create' && parent == 'service_tickets') {
					// 	return true;
					// }
					if (parent == 'setting-location' && ['create', 'importLocations', 'clone', 'editCustomer'].indexOf(child) >= 0) return true;
					if (parent == 'bulk_cash_management' && child !== 'view' && child !== 'export') return true;
				}
				return 0 > this.customerPermissions.indexOf(parent);
			} else if (this.model.isWebUser) {
				return false;
			} else {
				return true;
			}
		}
	}, {
		key: 'customerSearchPaginate',
		value: function customerSearchPaginate(searchKey, idKey, nameKey) {
			return {
				queryJSON: {
					rules: [{
						field: idKey,
						condition: 'like',
						data: '%' + searchKey + '%'
					}, {
						field: nameKey,
						condition: 'like',
						data: '%' + searchKey + '%'
					}],
					operator: 'OR'
				}
			};
		}
	}, {
		key: 'getCustomer',
		value: function getCustomer(searchKey, offset) {
			var _this15 = this;

			searchKey = searchKey || '';
			var costomerSearchObj = this.customerSearchPaginate(searchKey, 'id', 'name');
			if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
				offset = offset - 1;
			}
			this.CustomerService.all(costomerSearchObj, offset, _app2.default.defaultPageLimit).then(function (res) {
				if (offset === 0 || offset == undefined) {
					_this15.totalCustomer = res.total;
					_this15.customerList = _.uniqBy(_this15.mappingCustomerDatas(res.results), 'Value');
				} else {
					var customers = _this15.mappingCustomerDatas(res.results);
					_this15.customerList = _.uniqBy(_this15.customerList.concat(customers), 'Value');
				}
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this15.errorMessage = err.data.message;
				}
			});
		}
	}, {
		key: 'mappingCustomerDatas',
		value: function mappingCustomerDatas(customers) {
			return customers.map(function (customer) {
				var customerObj = {
					Key: customer.id + ' | ' + customer.name,
					Value: customer.id
				};

				return customerObj;
			});
		}
	}, {
		key: 'validateAutoChekInChekOut',
		value: function validateAutoChekInChekOut() {
			if (!this.model.branchId) return;
			var selectedBranch = _.find(this.allSetup, { branchId: this.model.branchId });
			this.enableAutoCheckInCheckOut = selectedBranch.enableAutoCheckInCheckOut;
		}
	}, {
		key: 'forceSupervisorToSetOn',
		value: function forceSupervisorToSetOn() {
			if (this.model.downloadToHHT && (this.model.autoCheckIn || this.model.autoCheckOut)) {
				this.isDisabledSupervisor = true;
				this.model.supervisor = true;
			} else {
				// this.model.supervisor = false;
				this.isDisabledSupervisor = false;
			}
		}
	}, {
		key: 'resetServiceZone',
		value: function resetServiceZone() {
			var _this16 = this;

			if (!this.model.serviceUser || !this.model.limitToServiceZone) {
				if (!this.model.serviceUser) {
					this.model.limitToServiceZone = false;
				}
				setTimeout(function () {
					_this16.model.selectedZones = [];
					_this16.serviceZoneData.forEach(function (zone) {
						zone.ticked = false;
					});
				});
			}
		}
	}, {
		key: 'clearFundingSourceIfServiceOnly',
		value: function clearFundingSourceIfServiceOnly() {
			if (this.isServiceOnlyUser()) {
				this.selectedFundingSource = [];
				(this.branchFundingSourceGrouped || []).forEach(function (bfs) {
					bfs.ticked = false;
				});
			}
		}
	}, {
		key: 'parseMakeValues',
		value: function parseMakeValues(makeValue) {
			if (Array.isArray(makeValue)) {
				return makeValue.map(function (item) {
					if (!item) return null;
					if (typeof item === 'string') {
						var _vendorName = item.trim();
						return _vendorName ? { atmMakeId: null, vendorName: _vendorName } : null;
					}
					var vendorName = (item.vendorName || item.Value || item.value || item.Key || item.label || '').trim();
					var atmMakeId = item.atmMakeId || item.id || item.atmMake && item.atmMake.id || null;
					return vendorName ? { atmMakeId: atmMakeId, vendorName: vendorName } : null;
				}).filter(Boolean);
			}

			if (!makeValue) return [];

			return String(makeValue).split(',').map(function (item) {
				return item.trim();
			}).filter(Boolean).map(function (vendorName) {
				return { atmMakeId: null, vendorName: vendorName };
			});
		}
	}, {
		key: 'serializeMakeValues',
		value: function serializeMakeValues(makeValue) {
			var values = this.parseMakeValues(makeValue);
			return values.length ? values.map(function (item) {
				return item.vendorName;
			}).join(', ') : null;
		}
	}, {
		key: 'buildAtmMakeOptions',
		value: function buildAtmMakeOptions(results, selectedMakes) {
			var selectedValues = this.parseMakeValues(selectedMakes);
			var selectedById = selectedValues.map(function (item) {
				return item.atmMakeId;
			}).filter(Boolean);
			var selectedByName = selectedValues.map(function (item) {
				return item.vendorName;
			}).filter(Boolean);
			var options = (results || []).filter(function (item) {
				return item.active;
			}).map(function (item) {
				return {
					Key: item.vendorName,
					Value: item.vendorName,
					id: item.id,
					atmMakeId: item.id,
					vendorName: item.vendorName,
					ticked: selectedById.includes(item.id) || selectedByName.includes(item.vendorName)
				};
			});

			selectedValues.forEach(function (selectedItem) {
				if (options.findIndex(function (item) {
					return item.atmMakeId === selectedItem.atmMakeId || item.Value === selectedItem.vendorName;
				}) === -1) {
					options.push({
						Key: selectedItem.vendorName,
						Value: selectedItem.vendorName,
						id: selectedItem.atmMakeId || selectedItem.vendorName,
						atmMakeId: selectedItem.atmMakeId,
						vendorName: selectedItem.vendorName,
						ticked: true
					});
				}
			});

			return options;
		}
	}, {
		key: 'loadAtmMakes',
		value: function loadAtmMakes() {
			var _this17 = this;

			var selectedMakes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.model.make;

			return this.AtmMakesService.all('', 0, 1000).then(function (_ref) {
				var results = _ref.results;

				_this17.atmMakesList = _this17.buildAtmMakeOptions(results, selectedMakes);
				_this17.model.make = _this17.parseMakeValues(selectedMakes);
			}).catch(function (err) {
				console.log(err);
				_this17.atmMakesList = [];
				_this17.model.make = [];
			});
		}
	}, {
		key: 'loadSchedule',
		value: function loadSchedule(schedule) {
			var _this18 = this;

			this.model.schedule = {};
			this.scheduleErrors = {};
			if (schedule) {
				this.scheduleDays.forEach(function (day) {
					_this18.model.schedule[day.startKey] = _this18.parseTimeString(schedule[day.startKey]) || null;
					_this18.model.schedule[day.endKey] = _this18.parseTimeString(schedule[day.endKey]) || null;
					day.active = !!schedule[day.startKey];
				});
			} else {
				this.scheduleDays.forEach(function (day) {
					_this18.model.schedule[day.startKey] = null;
					_this18.model.schedule[day.endKey] = null;
					day.active = false;
				});
			}
		}
	}, {
		key: 'toggleScheduleDay',
		value: function toggleScheduleDay(day) {
			day.active = !day.active;
			if (!day.active) {
				this.model.schedule[day.startKey] = null;
				this.model.schedule[day.endKey] = null;
				delete this.scheduleErrors[day.key + 'Order'];
			}
			this.validateScheduleDay(day);
		}
	}, {
		key: 'validateScheduleDay',
		value: function validateScheduleDay(day) {
			delete this.scheduleErrors[day.key + 'Order'];

			if (day.active) {
				if (this.model.schedule[day.startKey] && this.model.schedule[day.endKey]) {
					var start = this.formatTimeOnly(this.model.schedule[day.startKey]);
					var end = this.formatTimeOnly(this.model.schedule[day.endKey]);
					if (start && end && start >= end) {
						this.scheduleErrors[day.key + 'Order'] = true;
					}
				}
			}
		}
	}, {
		key: 'hasScheduleErrors',
		value: function hasScheduleErrors() {
			return (0, _keys2.default)(this.scheduleErrors).length > 0;
		}
	}, {
		key: 'formatScheduleForSave',
		value: function formatScheduleForSave() {
			var _this19 = this;

			var schedule = {};
			this.scheduleDays.forEach(function (day) {
				schedule[day.startKey] = _this19.formatTimeOnly(_this19.model.schedule[day.startKey]);
				schedule[day.endKey] = _this19.formatTimeOnly(_this19.model.schedule[day.endKey]);
			});
			return schedule;
		}
	}, {
		key: 'formatTimeOnly',
		value: function formatTimeOnly(val) {
			if (!val) return null;
			if (typeof val === 'string' && /^\d{2}:\d{2}(:\d{2})?$/.test(val)) return val;
			var d = new Date(val);
			if (isNaN(d.getTime())) return null;
			var h = String(d.getHours()).padStart(2, '0');
			var m = String(d.getMinutes()).padStart(2, '0');
			return h + ':' + m;
		}
	}, {
		key: 'parseTimeString',
		value: function parseTimeString(timeString) {
			if (!timeString) return null;

			var _timeString$split = timeString.split(':'),
			    _timeString$split2 = (0, _slicedToArray3.default)(_timeString$split, 2),
			    hours = _timeString$split2[0],
			    minutes = _timeString$split2[1];

			var d = new Date();
			d.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
			return d;
		}
	}, {
		key: 'getBranchCounters',
		value: function getBranchCounters() {
			var _this20 = this;

			if (this.model.branchId) {
				return this.UserService.getBranchCounters(this.model.branchId).then(function (data) {
					var counters = data.branchCounters || [];
					_this20.countStationList = counters.map(function (cs) {
						return {
							label: cs.name || cs.label || cs.id,
							value: cs.id
						};
					});
				});
			}
		}
	}]);
	return UsersCreateController;
}(_usersBase2.default);

exports.default = UsersCreateController;

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _usersEdit = __webpack_require__(2360);

var _usersEdit2 = _interopRequireDefault(_usersEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersEditModule = angular.module('usersedit', []).component('usersedit', _usersEdit2.default).name;

exports.default = usersEditModule;

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _usersEdit = __webpack_require__(2885);

var _usersEdit2 = _interopRequireDefault(_usersEdit);

var _usersEdit3 = __webpack_require__(2361);

var _usersEdit4 = _interopRequireDefault(_usersEdit3);

__webpack_require__(3155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userseditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _usersEdit2.default,
  controller: _usersEdit4.default
};

exports.default = userseditComponent;

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(32);

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(41);

var _entries2 = _interopRequireDefault(_entries);

var _assign = __webpack_require__(19);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _values = __webpack_require__(45);

var _values2 = _interopRequireDefault(_values);

var _getIterator2 = __webpack_require__(35);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _usersBase = __webpack_require__(285);

var _usersBase2 = _interopRequireDefault(_usersBase);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersEditController = function (_UsersBaseController) {
	UsersEditController.$inject = ["Auth", "$state", "User", "UsersService", "$q", "Modal", "$translate", "$stateParams", "UserService", "BranchService", "$scope", "SetupService", "LogService", "BranchFundingSourceService", "UserBranchFundingSourceService", "TimezoneList", "CustomerService", "CommonLayoutService", "LocationZoneService", "AtmMakesService", "Configs"];
	(0, _inherits3.default)(UsersEditController, _UsersBaseController);

	/*@ngInject*/
	function UsersEditController(Auth, $state, User, UsersService, $q, Modal, $translate, $stateParams, UserService, BranchService, $scope, SetupService, LogService, BranchFundingSourceService, UserBranchFundingSourceService, TimezoneList, CustomerService, CommonLayoutService, LocationZoneService, AtmMakesService, Configs) {
		(0, _classCallCheck3.default)(this, UsersEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (UsersEditController.__proto__ || (0, _getPrototypeOf2.default)(UsersEditController)).call(this, Auth, $state, User, UsersService, Modal, $translate, $stateParams, $scope));

		_this.toggle = function (language) {
			_this.model.languageId = language.value;
		};

		_this.isLangSelected = function (language) {
			return language.value == _this.model.languageId;
		};

		_this.Configs = Configs;
		_this.UserService = UserService;
		_this.BranchService = BranchService;
		_this.SetupService = SetupService;
		_this.logService = LogService;
		_this.Modal = Modal;
		_this.$q = $q;
		_this.$scope = $scope;
		_this.UsersService = UsersService;
		_this.permissions = _this.Auth.permission();
		_this.aclPermissions = [];
		_this.BranchFundingSourceService = BranchFundingSourceService;
		_this.UserBranchFundingSourceService = UserBranchFundingSourceService;
		_this.TimezoneList = TimezoneList;
		_this.CustomerService = CustomerService;
		_this.CommonLayoutService = CommonLayoutService;
		_this.LocationZoneService = LocationZoneService;
		_this.AtmMakesService = AtmMakesService;
		_this.User = User;
		_this.model = {
			id: '',
			firstName: '',
			lastName: '',
			email: '',
			supervisor: false,
			languageId: '',
			branchId: '',
			password: null,
			downloadToHHT: false,
			isWebUser: false,
			kabaKeyId: '',
			SGKeyId: '',
			sameForAll: false,
			defaultAppView: null,
			hhtPassword: null,
			phone: null,
			routeKeyId: '',
			tecnoDevId: '',
			OTCCompanyName: null,
			serviceUser: false,
			ATMTransfer: false,
			shipmentTransfer: false,
			timezone: null,
			customerUser: false,
			customer: '',
			payrollId: null,
			addActions: false,
			createTickets: false,
			serviceLevel: null,
			userOrigin: null,
			address: null,
			city: null,
			state: null,
			zip: null,
			country: null,
			isNonUSLocation: false,
			lat: null,
			long: null,
			make: [],
			schedule: {}
		};

		_this.scheduleDays = [{ key: 'Mon', label: 'Monday', shortLabel: 'Monday', startKey: 'startTimeMon', endKey: 'endTimeMon', active: false }, { key: 'Tue', label: 'Tuesday', shortLabel: 'Tuesday', startKey: 'startTimeTue', endKey: 'endTimeTue', active: false }, { key: 'Wed', label: 'Wednesday', shortLabel: 'Wednesday', startKey: 'startTimeWed', endKey: 'endTimeWed', active: false }, { key: 'Thu', label: 'Thursday', shortLabel: 'Thursday', startKey: 'startTimeThu', endKey: 'endTimeThu', active: false }, { key: 'Fri', label: 'Friday', shortLabel: 'Friday', startKey: 'startTimeFri', endKey: 'endTimeFri', active: false }, { key: 'Sat', label: 'Saturday', shortLabel: 'Saturday', startKey: 'startTimeSat', endKey: 'endTimeSat', active: false }, { key: 'Sun', label: 'Sunday', shortLabel: 'Sunday', startKey: 'startTimeSun', endKey: 'endTimeSun', active: false }, { key: 'Holiday', label: 'Holiday', shortLabel: 'Holiday', startKey: 'startTimeHoliday', endKey: 'endTimeHoliday', active: false }];
		_this.scheduleErrors = {};

		_this.serviceLevelList = [{ label: '(None)', value: null }, { label: 'FLM', value: 'FLM' }, { label: 'SLM', value: 'SLM' }];

		_this.userOriginList = [{ label: '(None)', value: null }, { label: 'Branch', value: 'BRANCH' }, { label: 'Vehicle', value: 'VEHICLE' }, { label: 'User', value: 'USER' }];
		_this.atmMakesList = [];

		_this.defaultAppView = [{
			label: 'List View',
			value: 'List'
		}, {
			label: 'All Map View',
			value: 'All'
		}, {
			label: 'Next Map View',
			value: 'Next'
		}, {
			label: 'Next 3 Map View',
			value: 'Next3'
		}];

		_this.OTCCompanyNameList = [];
		_this.branch = [];
		_this.role = {
			admin: false,
			user: false
		};
		_this.aclRole = '';
		_this.language = [{
			value: 'E',
			label: 'English'
		},
		// {
		// 	value: 'F',
		// 	label: 'French'
		// },
		{
			value: 'S',
			label: 'Spanish'
		}];
		_this.cnfPassword = '';
		_this.leader = {};
		_this.existingBranch = [];
		_this.localLang = {
			selectAll: _this.$translate.instant('common.selectall'),
			selectNone: _this.$translate.instant('common.selectnone'),
			reset: _this.$translate.instant('shipmentBatch.reset'),
			search: _this.$translate.instant('common.search'),
			nothingSelected: _this.$translate.instant('common.noneselected') //default-label is deprecated and replaced with this.
		};
		_this.lastUpdated = null;
		_this.branchData = [];
		_this.hasACL = {};
		_this.defaultBranch = '';
		_this.userData = [];
		_this.OTCKeys = {};
		_this.company = {};
		_this.timezoneList = _this.TimezoneList.getTimezoneList();
		_this.customerList = [];
		_this.totalCustomer = 0;
		_this.serviceZoneData = [];
		// this.model = angular.copy(this.defaultModel)	
		// this.lockSystem = [
		// 	{
		// 		label: 'KABA FLM',
		// 		value: 'kabaKeyId'
		// 	},
		// 	{
		// 		label: 'KABA Route',
		// 		value: 'routeKeyId'
		// 	},
		// 	{
		// 		label: 'S&G',
		// 		value: 'SGKeyId'
		// 	},
		// 	{
		// 		label: 'Witz',
		// 		value: 'witzKeyId'
		// 	}
		// ];
		return _this;
	}

	(0, _createClass3.default)(UsersEditController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.loading = true;

			var validatePermissions = function validatePermissions() {
				return new _promise2.default(function (resolve, reject) {
					_this2.UsersService.validateUserPermissions(_this2.User.getUser().firstName, _this2.User.getUser().lastName).then(function (permissions) {
						if (!_this2.CommonLayoutService.isAllowToAccessPages() && !permissions.hasUserEditPermission) {
							_this2.$state.go('home');
							reject('User does not have sufficient permissions.');
						} else {
							resolve();
						}
					}).catch(function (err) {
						reject('Error validating permissions: ' + err);
					});
				});
			};

			validatePermissions().then(function () {
				_this2.Configs.getConfigs().then(function (data) {
					_this2.googleMapConfig = data.googleMap;
					_this2.apiKey = '//maps.google.com/maps/api/js?key=' + _this2.googleMapConfig.key + '&libraries=places';
					setTimeout(function () {
						_this2.render = true;
					}, 100);
				});

				_this2.moment = moment;
				if (!_this2.model.isWebUser) {
					_this2.model.email = '';
					_this2.model.password = null;
					_this2.model.cnfPassword = '';
				}

				var userId = _this2.$stateParams.id;

				_this2.$q.all([_this2.BranchService.all(null, 0, 1000), _this2.SetupService.all(null, 0, 1000), _this2.logService.getLogInfo('update-user', userId), _this2.Service.get(userId), _this2.UserService.getUserBranchGroup(userId)]).then(function (data) {
					_this2.OTCCompanies = data[3].companies;
					_this2.setOtcKeys();
					_this2.OTCCompanyMap();
					_this2.defaultModel = data[3];
					_this2.rawId = data[3].id;
					_this2.model.id = data[3].id;
					_this2.model.firstName = data[3].firstName;
					_this2.model.lastName = data[3].lastName;
					_this2.model.email = data[3].email;
					_this2.model.languageId = data[3].languageId;
					_this2.model.supervisor = data[3].supervisor;
					_this2.model.branchId = data[3].branchId;
					_this2.defaultBranch = data[3].branchId;
					_this2.model.downloadToHHT = data[3].downloadToHHT;
					_this2.model.isWebUser = !data[3].customerUser && !!data[3].email;
					_this2.model.branchPermission = data[3].branchId;
					_this2.model.kabaKeyId = data[3].kabaKeyId;
					_this2.model.SGKeyId = data[3].SGKeyId;
					_this2.model.defaultAppView = data[3].defaultAppView || null;
					_this2.model.hhtPassword = data[3].hhtPassword;
					_this2.model.phone = data[3].phone;
					_this2.model.routeKeyId = data[3].routeKeyId;
					_this2.model.tecnoDevId = data[3].tecnoDevId;
					_this2.model.OTCCompanyName = data[3].OTCCompanyName;
					_this2.OTCKeys = data[3].OTCKeys || _this2.OTCKeys;
					_this2.model.serviceUser = data[3].serviceUser;
					_this2.model.ATMTransfer = data[3].ATMTransfer;
					_this2.model.shipmentTransfer = data[3].shipmentTransfer;
					_this2.model.timezone = data[3].timezone;
					_this2.model.customerUser = data[3].customerUser;
					_this2.model.customer = data[3] && data[3].customer ? _this2.mappingCustomerKeyVal(data[3].customer) : null;
					_this2.model.autoCheckIn = data[3].downloadToHHT ? data[3].autoCheckIn || false : false;
					_this2.model.autoCheckOut = data[3].downloadToHHT ? data[3].autoCheckOut || false : false;
					_this2.model.payrollId = data[3].payrollId;
					_this2.model.limitToServiceZone = data[3].serviceUser ? data[3].limitToServiceZone || false : false;
					_this2.model.rejectTickets = data[3].serviceUser || data[3].downloadToHHT ? data[3].rejectTickets : false;
					_this2.model.selfAssignServiceTicket = data[3].serviceUser ? data[3].selfAssignServiceTicket : false;
					_this2.model.userAssignServiceTicket = data[3].serviceUser ? data[3].userAssignServiceTicket : false;
					_this2.model.addActions = data[3].serviceUser ? data[3].addActions || false : false;
					_this2.model.createTickets = data[3].serviceUser ? data[3].createTickets || false : false;
					_this2.model.branchCounterId = data[3].branchCounterId || null;
					_this2.model.serviceLevel = data[3].serviceLevel || null;
					_this2.model.userOrigin = data[3].userOrigin || null;
					_this2.model.address = data[3].address || null;
					_this2.model.city = data[3].city || null;
					_this2.model.state = data[3].state || null;
					_this2.model.zip = data[3].zip || null;
					_this2.model.country = data[3].country || null;
					_this2.model.isNonUSLocation = data[3].country && data[3].country !== 'US' ? true : false;
					_this2.model.lat = data[3].lat || null;
					_this2.model.long = data[3].long || null;
					_this2.loadSchedule(data[3].schedule);
					_this2.loadAtmMakes(data[3].make);
					if (!data[3].hasAtmCodesPermission && !_this2.CommonLayoutService.isAllowToAccessPages()) {
						delete _this2.permissions.atm_codes_management;
					}

					if (!data[3].hasSettingsPermission && !_this2.CommonLayoutService.isAllowToAccessPages()) {
						delete _this2.permissions.setting;
					}

					if (!data[3].hasTntBypassCodePermission && !_this2.CommonLayoutService.isAllowToAccessPages()) {
						delete _this2.permissions.branch_mgmt.child.branch_mgmt_tnt_bypass_code;
					}

					if (!data[3].hasEnvironmentConfigPermission && !_this2.CommonLayoutService.isAllowToAccessPages()) {
						delete _this2.permissions.tnt_control.child.tnt_control_environment_config;
					}

					if (!data[3].vaultOpartionPermission && !_this2.CommonLayoutService.isAllowToAccessPages()) {
						delete _this2.permissions.vault_operations;
					}

					_this2.UserService.acl(_this2.rawId, _this2.model.branchId).then(function (data) {
						_this2.aclPermissions = data;
						_this2.sanitizeCashActivityPermissions(_this2.aclPermissions);
					});
					_this2.UserService.role(_this2.rawId, _this2.model.branchId).then(function (data) {
						_this2.aclRole = data;
						_this2.role.user = _this2.aclRole.find(function (role) {
							return role !== 'admin';
						});
					});

					_this2.lastUpdated = data[2].results || null;
					_this2.setupInfo = data[1].results;

					var branchesWithExistingSetupRecord = _this2.setupInfo.map(function (setupRecord) {
						return setupRecord.branchId;
					});

					_this2.branchData = data[0].results.filter(function (branch) {
						return branchesWithExistingSetupRecord.includes(branch.id);
					});

					_this2.branchData.filter(function (branch) {
						return branch.id === _this2.model.branch;
					});

					_this2.existingBranch = data[4];
					data[4].forEach(function (selectedBranch) {
						_this2.branchData.filter(function (branch) {
							if (branch.id == selectedBranch.branchId) {
								branch.ticked = true;
							}
						});
					});

					_this2.defaultModel.usersBranches = _this2.branchData.map(function (b) {
						if (b.ticked) return b.id;
					}).filter(function (n) {
						return n !== undefined;
					});
					_this2.defaultModel.OTCKeys = _.cloneDeep(_this2.OTCKeys);
					var savedZoneIds = _this2.model.limitToServiceZone ? (data[3].serviceZoneData || []).map(function (zone) {
						return zone.zoneId;
					}) : [];
					_this2.loadServiceZone(_this2.existingBranch.map(function (branch) {
						return branch.branchId;
					}), savedZoneIds).then(function () {
						_this2.defaultModel.serviceZoneData = _this2.serviceZoneData.filter(function (zone) {
							return zone && zone.zoneId != null && zone.ticked;
						}).map(function (zone) {
							return { locationZoneId: zone.zoneId, userId: _this2.model.id };
						});
					});

					_this2.getCustomer('', 0);
					_this2.getSetupDetails();
					_this2.validateAutoChekInChekOut();
					_this2.forceSupervisorToSetOn();
					_this2.getBranchCounters();
				}).then(function () {
					_this2.getUserbranchFundingSource().then(function () {
						return _this2.getFundingSource(_this2.existingBranch);
					}).catch();
				}).catch(function (err) {
					console.log(err);
				}).finally(function () {
					_this2.loading = false;
				});
			});
		}
	}, {
		key: 'sanitizeCashActivityPermissions',
		value: function sanitizeCashActivityPermissions(permissions) {
			if (permissions && permissions['cash_activity']) {
				var cashAct = permissions['cash_activity'];

				if (cashAct.includes('customer') && cashAct.includes('funding_source')) {
					if (this.model.customerUser) {
						permissions['cash_activity'] = ['customer'];
						this.UserService.updateAcl({
							role: 'user:' + this.rawId,
							resource: 'cash_activity',
							permission: ['funding_source'],
							user: this.rawId,
							branchIds: [this.model.branchPermission || this.model.branchId]
						}, false);
					} else {
						permissions['cash_activity'] = ['funding_source'];
						this.UserService.updateAcl({
							role: 'user:' + this.rawId,
							resource: 'cash_activity',
							permission: ['customer'],
							user: this.rawId,
							branchIds: [this.model.branchPermission || this.model.branchId]
						}, false);
					}
				}
			}
		}
	}, {
		key: 'hasAclRole',
		value: function hasAclRole() {
			return this.aclRole.length > 0;
		}
	}, {
		key: 'format',
		value: function format(key, parentKey) {
			if (parentKey === 'branch_mgmt_orders' && key === 'all') {
				return this.$translate.instant('common.View');
			}
			if (typeof key == 'string') {
				key = key.replace('_', '-');
				key = key !== 'assign' && key !== 'export' ? key.charAt(0).toUpperCase() + key.slice(1) : key;
				key = this.$translate.instant('common.' + key);
			}
			return key;
		}
	}, {
		key: 'togglePerm',
		value: function togglePerm(key, parentKey) {
			var _this3 = this;

			var allow = false;
			if (this.hasPerm(key, parentKey)) allow = false;else allow = true;

			if (allow && parentKey === 'cash_activity') {
				var otherKey = key === 'customer' ? 'funding_source' : 'customer';
				if (this.hasPerm(otherKey, parentKey)) {
					this.togglePerm(otherKey, parentKey);
				}
			}

			if (parentKey === 'cash_activity') {
				if (allow) {
					if (!this.aclPermissions) {
						this.aclPermissions = {};
					}
					var hadRedirect = this.hasPerm('default_redirect', parentKey);
					this.aclPermissions[parentKey] = hadRedirect ? [key, 'default_redirect'] : [key];
				} else {
					if (this.aclPermissions && this.aclPermissions[parentKey]) {
						this.aclPermissions[parentKey] = this.aclPermissions[parentKey].filter(function (k) {
							return k !== key;
						});
					}
				}
			}

			var obj = {
				role: !allow ? 'user:' + this.rawId : '',
				resource: parentKey,
				permission: [key],
				user: this.rawId,
				branchIds: [this.model.branchPermission]
			};

			this.$q.when().then(function () {
				if (!allow && !_this3.role.user) {
					var defer = _this3.$q.defer();
					_this3.UserService.role(_this3.rawId, _this3.model.branchPermission).then(function (data) {
						_this3.aclRole = data;
						_this3.role.user = _this3.aclRole.find(function (role) {
							return role !== 'admin';
						});
						obj.role = _this3.role.user;
						defer.resolve();
					});
					return defer.promise;
				}
			}).then(function () {
				_this3.updateAclPermission(obj, allow, key, parentKey);
				// if (parentKey == 'setting') {
				// 	const settingChild = this.permissions.setting.child;
				// 	const resources = Object.keys(settingChild);
				// 	resources.map((resource) => {
				// 		let branchMgmtObj = {
				// 			role: !allow ? ('user:' + this.rawId) : '',
				// 			resource: resource,
				// 			permission: ["edit", "delete", "view", "create"],
				// 			user: this.rawId,
				// 			branchIds: [this.model.branchPermission]
				// 		}
				// 		if (resource == 'setting-log')
				// 			branchMgmtObj.permission = ["view"];
				// 		else if (resource == 'setting-location')
				// 			branchMgmtObj.permission = ["edit", "delete", "view", "create", "importLocations"];
				// 		else
				// 			branchMgmtObj.permission = ["edit", "delete", "view", "create"];
				// 		this.updateAclPermission(branchMgmtObj, allow, branchMgmtObj.permission, resource)
				// 	})
				// } else 
				if (parentKey == 'branch_mgmt') {
					var branchMgmtChild = _this3.permissions.branch_mgmt.child;
					var resources = (0, _keys2.default)(branchMgmtChild);
					resources.forEach(function (resource) {
						if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
						var branchMgmtObj = {
							role: !allow ? 'user:' + _this3.rawId : '',
							resource: resource,
							permission: ['all'],
							user: _this3.rawId,
							branchIds: [_this3.model.branchPermission]
						};
						_this3.updateAclPermission(branchMgmtObj, allow, 'all', resource);
					});
				} else if (['branch_mgmt_deposit_reports', 'branch_mgmt_bin_manifest'].includes(parentKey)) {
					var resourcesToUpdate = ['tnt_react_app'];

					resourcesToUpdate.forEach(function (resource) {
						var permObj = {
							role: !allow ? 'user:' + _this3.rawId : '',
							resource: resource,
							permission: [key],
							user: _this3.rawId,
							branchIds: [_this3.model.branchPermission]
						};

						_this3.updateAclPermission(permObj, allow, key, resource);
					});
				} else if (parentKey == 'branch_mgmt_billing_approval') {
					var childPermission = _this3.permissions.branch_mgmt.child.branch_mgmt_billing_approval.child;
					var _resources = (0, _keys2.default)(childPermission);
					_resources.forEach(function (resource) {
						if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
						var branchMgmtObj = {
							role: !allow ? 'user:' + _this3.rawId : '',
							resource: resource,
							permission: ['allow'],
							user: _this3.rawId,
							branchIds: [_this3.model.branchPermission]
						};
						_this3.updateAclPermission(branchMgmtObj, allow, 'allow', resource);
					});
				} else if (parentKey == 'tnt_billing_fuel_surcharges') {
					var _childPermission = _this3.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.child;
					var _resources2 = (0, _keys2.default)(_childPermission);
					var childPermisions = [];
					if (allow && _childPermission['edit']) childPermisions.push('edit');
					if (allow && _childPermission['view']) childPermisions.push('view');
					if (allow && _childPermission['create']) childPermisions.push('create');

					_resources2.forEach(function (resource) {
						if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
						var branchMgmtObj = {
							role: !allow ? 'user:' + _this3.rawId : '',
							resource: resource,
							permission: childPermisions,
							user: _this3.rawId,
							branchIds: [_this3.model.branchPermission]
						};
						_this3.updateAclPermission(branchMgmtObj, allow, childPermisions, resource);
					});
				} else if (['setting', 'branch_mgmt', 'tnt_billing', 'tnt_control', 'reporting', 'branch_mgmt_billing_approval', 'order_packing', 'bulk_transfer'].indexOf(parentKey) >= 0) {
					var _childPermission2 = _this3.permissions[parentKey].child;
					var _resources3 = (0, _keys2.default)(_childPermission2);
					_resources3.forEach(function (resource) {
						if (_this3.model.customerUser && _this3.customerPermissions.indexOf(resource) < 0) return;
						var permissionKeys = (0, _keys2.default)(_childPermission2[resource].permission).filter(function (p) {
							return p !== 'default_redirect';
						});
						var branchMgmtObj = {
							role: !allow ? 'user:' + _this3.rawId : '',
							resource: resource,
							permission: permissionKeys,
							user: _this3.rawId,
							branchIds: [_this3.model.branchPermission]
						};
						if (_this3.model.customerUser && allow) {
							if (resource == 'setting-location') {
								branchMgmtObj.permission = ["view", "edit"];
							}
							// If editing Billing Approval as a customer user, keep it view-only
							if (parentKey === 'branch_mgmt_billing_approval') {
								branchMgmtObj.permission = ['allow'];
							}
						}
						_this3.updateAclPermission(branchMgmtObj, allow, branchMgmtObj.permission, resource);
					});
				}
			}).catch(function (err) {
				console.log('Error Updating permissions');
				console.log(err);
			});
		}
	}, {
		key: 'allowSettings',
		value: function allowSettings(key, parentKey) {
			var allow = false;
			if (this.hasPerm(key, parentKey)) allow = false;else allow = true;

			var hasSetting = this.aclPermissions['setting'],
			    settingChild = this.permissions.setting.child,
			    resources = (0, _keys2.default)(settingChild),
			    isSelected = resources.find(function (d) {
				return d === parentKey;
			});

			if (isSelected && !hasSetting) {
				var permissionObj = {
					role: !allow ? 'user:' + this.rawId : '',
					resource: 'setting',
					permission: ["all"],
					user: this.rawId,
					branchIds: [this.model.branchPermission]
				};
				this.updateAclPermission(permissionObj, true, 'all', 'setting');
			}
		}
	}, {
		key: 'hasPerm',
		value: function hasPerm(key, parentKey) {
			var permissionObj = this.aclPermissions[parentKey];
			if (Array.isArray(permissionObj)) {
				return permissionObj.includes(key);
			} else {
				return false;
			}
		}
	}, {
		key: 'findResourceNode',
		value: function findResourceNode(resource) {
			if (this.permissions[resource]) return this.permissions[resource];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = (0, _getIterator3.default)((0, _values2.default)(this.permissions)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var topVal = _step.value;

					if (topVal.child && topVal.child[resource]) return topVal.child[resource];
					if (topVal.child) {
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;

						try {
							for (var _iterator2 = (0, _getIterator3.default)((0, _values2.default)(topVal.child)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var childVal = _step2.value;

								if (childVal.child && childVal.child[resource]) return childVal.child[resource];
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return null;
		}
	}, {
		key: 'hasAnyPerm',
		value: function hasAnyPerm(resource) {
			var _this4 = this;

			var permissionObj = this.aclPermissions[resource];
			if (Array.isArray(permissionObj) && permissionObj.some(function (p) {
				return p !== 'default_redirect';
			})) {
				return true;
			}
			var node = this.findResourceNode(resource);
			if (node && node.child) {
				return (0, _keys2.default)(node.child).some(function (childKey) {
					return _this4.hasAnyPerm(childKey);
				});
			}
			return false;
		}
	}, {
		key: 'hasChildDefaultRedirect',
		value: function hasChildDefaultRedirect(parentKey) {
			var _this5 = this;

			var parentPerm = this.permissions[parentKey];
			if (!parentPerm || !parentPerm.child) return false;
			return (0, _keys2.default)(parentPerm.child).some(function (childKey) {
				return _this5.hasPerm('default_redirect', childKey);
			});
		}
	}, {
		key: 'getParentCategoryKey',
		value: function getParentCategoryKey(resource) {
			if (resource.startsWith('setting-')) return 'setting';
			if (resource.startsWith('branch_mgmt_')) return 'branch_mgmt';
			if (resource.startsWith('tnt_billing_')) return 'tnt_billing';
			if (resource.startsWith('tnt_control_')) return 'tnt_control';
			if (resource.startsWith('reporting_')) return 'reporting';
			return null;
		}
	}, {
		key: 'cleanupOrphanedDefaultRedirects',
		value: function cleanupOrphanedDefaultRedirects() {
			var _this6 = this;

			(0, _keys2.default)(this.aclPermissions).forEach(function (resource) {
				var perms = _this6.aclPermissions[resource];
				if (Array.isArray(perms) && perms.includes('default_redirect') && !_this6.hasAnyPerm(resource)) {
					_this6.aclPermissions[resource] = perms.filter(function (p) {
						return p !== 'default_redirect';
					});
					if (_this6.aclPermissions[resource].length === 0) {
						delete _this6.aclPermissions[resource];
					}
					var obj = {
						role: 'user:' + _this6.rawId,
						resource: resource,
						permission: ['default_redirect'],
						user: _this6.rawId,
						branchIds: [_this6.model.branchPermission]
					};
					_this6.UserService.updateAcl(obj, false).catch(function (err) {
						return console.error('Error clearing orphaned redirect ACL:', err);
					});
				}
			});
		}
	}, {
		key: 'toggleDefaultRedirect',
		value: function toggleDefaultRedirect(resource) {
			var _this7 = this;

			var isCurrentlyChecked = this.hasPerm('default_redirect', resource) || this.hasChildDefaultRedirect(resource);

			// 1. Find all resources that currently have default_redirect
			var resourcesToClear = (0, _keys2.default)(this.aclPermissions).filter(function (res) {
				return _this7.hasPerm('default_redirect', res);
			});

			// 2. Update local state synchronously immediately
			resourcesToClear.forEach(function (res) {
				if (Array.isArray(_this7.aclPermissions[res])) {
					_this7.aclPermissions[res] = _this7.aclPermissions[res].filter(function (p) {
						return p !== 'default_redirect';
					});
					if (_this7.aclPermissions[res].length === 0) {
						delete _this7.aclPermissions[res];
					}
				}
			});

			// 3. Sync with the database asynchronously in the background
			resourcesToClear.forEach(function (res) {
				var obj = {
					role: 'user:' + _this7.rawId,
					resource: res,
					permission: ['default_redirect'],
					user: _this7.rawId,
					branchIds: [_this7.model.branchPermission]
				};
				_this7.UserService.updateAcl(obj, false).catch(function (err) {
					return console.error('Error clearing redirect ACL:', err);
				});
			});

			var nextResourceToSet = null;
			if (!isCurrentlyChecked) {
				nextResourceToSet = resource;
			} else {
				// If we uncheck a child/grandchild redirect, shift it back to parent category
				var parentCategory = this.getParentCategoryKey(resource);
				if (parentCategory) {
					nextResourceToSet = parentCategory;
				}
			}

			if (nextResourceToSet) {
				if (!this.aclPermissions[nextResourceToSet]) {
					this.aclPermissions[nextResourceToSet] = [];
				}
				if (!this.aclPermissions[nextResourceToSet].includes('default_redirect')) {
					this.aclPermissions[nextResourceToSet] = [].concat((0, _toConsumableArray3.default)(this.aclPermissions[nextResourceToSet]), ['default_redirect']);
				}

				var obj = {
					role: '',
					resource: nextResourceToSet,
					permission: ['default_redirect'],
					user: this.rawId,
					branchIds: [this.model.branchPermission]
				};
				this.UserService.updateAcl(obj, true).catch(function (err) {
					return console.error('Error setting redirect ACL:', err);
				});
			}
		}
	}, {
		key: 'updateAclPermission',
		value: function updateAclPermission(obj, allow, key, parentKey) {
			var self = this;
			if (this.model.sameForAll) {
				var defer = this.$q.defer();
				var branchIds = this.model.branch.map(function (data) {
					return data.id;
				});
				var newObj = {
					role: !allow ? 'user:' + this.rawId : '',
					permission: obj.permission,
					resource: obj.resource,
					user: this.rawId,
					branchIds: branchIds
					// console.log('newObj', newObj);
				};updatePermission(newObj).then(function (res) {
					return defer.resolve();
				});
				return defer.promise;
			} else {
				// console.log("obj", obj);
				updatePermission(obj);
			}

			function updatePermission(permissionObj) {
				var q = self.$q.defer();
				self.UserService.updateAcl(permissionObj, allow).then(function (data) {
					if (data == 'OK') {
						if (allow) {
							if (self.aclPermissions.hasOwnProperty(parentKey)) {
								var l = self.aclPermissions[parentKey].length;
								if (key instanceof Array) self.aclPermissions[parentKey] = key;else {
									if (!self.aclPermissions[parentKey].includes(key)) self.aclPermissions[parentKey][l] = key;
								}
							} else {
								if (parentKey.includes('tnt_billing') || parentKey.includes('tnt_control') || parentKey.includes('reporting') || parentKey.includes('order_packing') || parentKey.includes('bulk_transfer')) self.aclPermissions[parentKey] = key instanceof Array ? key : [key];else if (parentKey.includes('setting-')) {
									if (self.model.customerUser && parentKey == 'setting-location') {
										self.aclPermissions[parentKey] = ["view", "edit"];
									} else {
										self.aclPermissions[parentKey] = key instanceof Array ? key : [key];
									}
									// console.log(self.aclPermissions[parentKey])
								} else {
									self.aclPermissions[parentKey] = key instanceof Array ? key : [key];
								}
							}
						} else {
							if (['setting', 'tnt_billing', 'tnt_control', 'reporting', 'order_packing', 'bulk_transfer'].indexOf(parentKey) >= 0) {
								delete self.aclPermissions[parentKey];
								var tntBillingChild = self.permissions[parentKey].child;
								var resources = (0, _keys2.default)(tntBillingChild);
								resources.map(function (resource) {
									delete self.aclPermissions[resource];
								});
							} else {
								if (self.aclPermissions[parentKey]) {
									self.aclPermissions[parentKey] = self.aclPermissions[parentKey].filter(function (k) {
										return k && k !== key;
									});
									var hasRedirect = self.aclPermissions[parentKey] && self.aclPermissions[parentKey].includes('default_redirect');
									if (self.aclPermissions[parentKey] && self.aclPermissions[parentKey].length === 0) {
										delete self.aclPermissions[parentKey];
									}

									if (key !== 'default_redirect' && hasRedirect) {
										var active = self.aclPermissions[parentKey] ? self.aclPermissions[parentKey].filter(function (k) {
											return k && k !== 'default_redirect';
										}) : [];
										if (active.length === 0) {
											var _obj = {
												role: 'user:' + self.rawId,
												resource: parentKey,
												permission: ['default_redirect'],
												user: self.rawId,
												branchIds: [self.model.branchPermission]
											};
											self.UserService.updateAcl(_obj, false).then(function () {
												if (self.aclPermissions[parentKey]) {
													self.aclPermissions[parentKey] = self.aclPermissions[parentKey].filter(function (k) {
														return k && k !== 'default_redirect';
													});
													if (self.aclPermissions[parentKey].length === 0) {
														delete self.aclPermissions[parentKey];
													}
												}
												// Shift redirect back to parent category
												var parentCategory = self.getParentCategoryKey(parentKey);
												if (parentCategory) {
													if (!self.aclPermissions[parentCategory]) {
														self.aclPermissions[parentCategory] = [];
													}
													if (!self.aclPermissions[parentCategory].includes('default_redirect')) {
														self.aclPermissions[parentCategory] = [].concat((0, _toConsumableArray3.default)(self.aclPermissions[parentCategory]), ['default_redirect']);
													}
													var parentObj = {
														role: '',
														resource: parentCategory,
														permission: ['default_redirect'],
														user: self.rawId,
														branchIds: [self.model.branchPermission]
													};
													self.UserService.updateAcl(parentObj, true).catch(function (err) {
														return console.error('Error shifting redirect:', err);
													});
												}
											});
										}
									}
								}
							}
							self.cleanupOrphanedDefaultRedirects();
						}
						q.resolve();
					}
				}).catch(function (err) {
					console.log('Error Updating permissions');
					console.log(err);
					q.resolve();
				});
				return q.promise;
			}
		}
	}, {
		key: 'resetMultiBranchSelection',


		// Reset Multi-Branch selection
		value: function resetMultiBranchSelection() {
			var _this8 = this;

			var usersBranches = this.existingBranch.map(function (data) {
				return data.branchId;
			});
			if (this.model.branch && this.model.branch.length) {
				this.existingBranch.forEach(function (selectedBranch) {
					_this8.branchData.filter(function (branch) {
						var isIncludes = usersBranches.includes(branch.id);
						if (branch.id == selectedBranch.branchId) {
							branch.ticked = true;
						}
						if (!isIncludes) {
							branch.ticked = false;
						}
					});
				});
			}
		}
	}, {
		key: 'reset',
		value: function reset(e) {
			var _this9 = this;

			// this.model = angular.copy(this.defaultModel)
			// this.model.branchId = this.defaultBranch;
			// this.model.branchPermission = this.defaultBranch;
			// console.log(this.model.branchPermission, this.model.branchId);
			// console.log(this.model);
			this.resetMultiBranchSelection();
			this.Service.get(this.$stateParams.id).then(function (data) {
				_this9.rawId = data.id;
				_this9.model.id = data.id;
				_this9.model.firstName = data.firstName;
				_this9.model.lastName = data.lastName;
				_this9.model.email = data.email;
				_this9.model.languageId = data.languageId;
				_this9.model.supervisor = data.supervisor;
				_this9.model.branchId = data.branchId;
				_this9.model.downloadToHHT = data.downloadToHHT;
				_this9.model.isWebUser = !!data.email;
				_this9.model.branchPermission = data.branchId;
				_this9.model.kabaKeyId = data.kabaKeyId;
				_this9.model.SGKeyId = data.SGKeyId;
				_this9.model.defaultAppView = data.defaultAppView || null;
				_this9.model.hhtPassword = data.hhtPassword;
				_this9.model.phone = data.phone;
				_this9.model.routeKeyId = data.routeKeyId;
				_this9.model.tecnoDevId = data.tecnoDevId;
				_this9.model.OTCCompanyName = data.OTCCompanyName;
				_this9.OTCKeys = data.OTCKeys;
				_this9.model.serviceUser = data.serviceUser;
				_this9.model.ATMTransfer = data.ATMTransfer;
				_this9.model.shipmentTransfer = data.shipmentTransfer;
				_this9.model.timezone = data.timezone;
				_this9.model.customerUser = data.customerUser;
				_this9.model.customer = _this9.mappingCustomerKeyVal(data.customer);
				_this9.model.autoCheckIn = _this9.enableAutoCheckInCheckOut && data.downloadToHHT ? data.autoCheckIn || false : false;
				_this9.model.autoCheckOut = _this9.enableAutoCheckInCheckOut && data.downloadToHHT ? data.autoCheckOut || false : false;
				_this9.model.payrollId = data.payrollId;
				_this9.model.serviceLevel = data.serviceLevel || null;
				_this9.model.userOrigin = data.userOrigin || null;
				_this9.model.address = data.address || null;
				_this9.model.city = data.city || null;
				_this9.model.state = data.state || null;
				_this9.model.zip = data.zip || null;
				_this9.model.country = data.country || null;
				_this9.model.isNonUSLocation = data.country && data.country !== 'US' ? true : false;
				_this9.model.lat = data.lat || null;
				_this9.model.long = data.long || null;
				_this9.model.limitToServiceZone = _this9.model.serviceUser ? data.limitToServiceZone || false : false;
				_this9.model.rejectTickets = _this9.model.serviceUser || _this9.model.downloadToHHT ? data.rejectTickets : false;
				_this9.model.selfAssignServiceTicket = _this9.model.serviceUser ? data.selfAssignServiceTicket : false;
				_this9.model.userAssignServiceTicket = _this9.model.serviceUser ? data.userAssignServiceTicket : false;
				_this9.model.addActions = _this9.model.serviceUser ? data.addActions || false : false;
				_this9.model.createTickets = _this9.model.serviceUser ? data.createTickets || false : false;
				_this9.loadSchedule(data.schedule);
			}).then(function () {
				_this9.autoSelectSameForAll();
			}).catch(function (e) {
				console.log(e);
			});
		}
	}, {
		key: 'resetWebUserData',
		value: function resetWebUserData() {
			for (var key in this.model) {
				if (key == 'isWebUser') {} else {
					this.model["email"] = null;
					this.model["password"] = null;
					this.cnfPassword = null;
				}
			}
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this10 = this;

			if (!this.validate()) {
				return;
			}
			if (this.hasScheduleErrors()) {
				return;
			}

			if (!(this.model.isWebUser || this.model.customerUser)) {
				this.model.email = this.model.password = null;
			}

			var serviceZoneData = [];
			if (this.model.limitToServiceZone && this.model.selectedZones.length > 0) {
				serviceZoneData = this.model.selectedZones.map(function (zone) {
					return {
						locationZoneId: zone.zoneId, userId: _this10.model.id
					};
				}).filter(function (n) {
					return n !== undefined;
				});
			}

			this.loading = true;
			var savedata = {
				id: this.model.id,
				firstName: this.model.firstName,
				lastName: this.model.lastName,
				email: this.model.email,
				languageId: this.model.languageId,
				supervisor: this.model.supervisor,
				password: this.model.password,
				branchId: this.model.branchId,
				downloadToHHT: this.model.downloadToHHT,
				kabaKeyId: this.model.kabaKeyId && this.model.downloadToHHT ? this.model.kabaKeyId : null,
				SGKeyId: this.model.SGKeyId && this.model.downloadToHHT ? this.model.SGKeyId : null,
				defaultAppView: this.model.downloadToHHT || this.model.serviceUser ? this.model.defaultAppView : null,
				// hhtPassword: this.model.hhtPassword ? this.model.hhtPassword : null,
				phone: this.model.phone ? this.model.phone : null,
				routeKeyId: this.model.routeKeyId && this.model.downloadToHHT ? this.model.routeKeyId : null,
				tecnoDevId: this.model.tecnoDevId && this.model.downloadToHHT ? this.model.tecnoDevId : null,
				OTCCompanyName: this.model.OTCCompanyName,
				OTCKeys: this.OTCKeys,
				serviceUser: this.model.serviceUser,
				ATMTransfer: this.model.ATMTransfer,
				shipmentTransfer: this.model.shipmentTransfer,
				timezone: this.model.timezone,
				customerUser: this.model.customerUser,
				customerId: this.model.customer ? this.model.customer.Value : null,
				autoCheckIn: this.enableAutoCheckInCheckOut && this.model.downloadToHHT ? this.model.autoCheckIn || false : false,
				autoCheckOut: this.enableAutoCheckInCheckOut && this.model.downloadToHHT ? this.model.autoCheckOut || false : false,
				payrollId: this.model.payrollId ? this.model.payrollId : null,
				limitToServiceZone: this.model.serviceUser ? this.model.limitToServiceZone || false : false,
				rejectTickets: this.model.serviceUser || this.model.downloadToHHT ? this.model.rejectTickets : false,
				selfAssignServiceTicket: this.model.serviceUser ? this.model.selfAssignServiceTicket : false,
				userAssignServiceTicket: this.model.serviceUser ? this.model.userAssignServiceTicket : false,
				addActions: this.model.serviceUser ? this.model.addActions : false,
				createTickets: this.model.serviceUser ? this.model.createTickets : false,
				serviceZoneData: serviceZoneData,
				usersBranches: this.model.branch.map(function (b) {
					if (b.ticked) return b.id;
				}).filter(function (n) {
					return n !== undefined;
				}),
				companies: this.defaultModel.companies,
				selectedBranchFundingSource: this.branchFundingSourceGrouped.map(function (bfs) {
					if (bfs.ticked) return bfs.fundingSourceId;
				}).filter(function (n) {
					return n !== undefined;
				}),
				branchCounterId: this.model.isWebUser ? this.model.branchCounterId : null,
				serviceLevel: this.model.serviceUser ? this.model.serviceLevel : null,
				userOrigin: this.model.serviceUser ? this.model.userOrigin : null,
				address: this.model.address || null,
				city: this.model.city || null,
				state: this.model.state || null,
				zip: this.model.zip || null,
				country: this.model.isNonUSLocation ? this.model.country : this.model.address ? 'US' : null,
				lat: this.model.lat || null,
				long: this.model.long || null,
				make: this.model.serviceUser ? this.parseMakeValues(this.model.make) : [],
				schedule: this.model.downloadToHHT || this.model.serviceUser || this.model.isWebUser ? this.formatScheduleForSave() : null
			};

			savedata.changedObject = this.findDifferences(this.defaultModel, savedata);

			this.Service.update(this.rawId, savedata).then(function (data) {
				var currentLoggedInUser = _this10.User.getUser();
				if (currentLoggedInUser.id === _this10.model.id) {
					_this10.User.setUser(data);
				}
				_this10.updateUserBranch();
				_this10.updateUserFundingSourceGroup();
				if (currentLoggedInUser.id === data.id && currentLoggedInUser.branchId !== data.branchId) {
					_this10.$state.go('home');
					setTimeout(function () {
						this.window.location.reload();
					}, 100);
				} else {
					_this10.$state.go('users.all', {
						page: 1
					}, { reload: true });
				}
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this10.Modal.errorModal(err.data.message);
				} else if (err && err.data && err.data.errors) {
					_this10.Modal.errorModal(err.data.errors[0].path);
				} else {
					_this10.Modal.errorModal(err);
				}
			}).finally(function () {
				_this10.loading = false;
			});
		}
	}, {
		key: 'toggleExpand',
		value: function toggleExpand(perm) {
			// this.permissions[perm].expand = !this.permissions[perm].expand
			if (perm === 'branch_mgmt_billing_approval' && this.permissions.branch_mgmt && this.permissions.branch_mgmt.child && this.permissions.branch_mgmt.child.branch_mgmt_billing_approval) {
				this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand = !this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand;
			}

			if (perm === 'tnt_billing_fuel_surcharges' && this.permissions.tnt_billing && this.permissions.tnt_billing.child && this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges) {
				this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand = !this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand;
			}

			if (this.permissions[perm]) {
				this.permissions[perm].expand = !this.permissions[perm].expand;
			}
		}
	}, {
		key: 'expand',
		value: function expand(parentKey) {
			//return !!this.permissions[parentKey].expand;
			if (parentKey === 'branch_mgmt_billing_approval' && this.permissions.branch_mgmt && this.permissions.branch_mgmt.child && this.permissions.branch_mgmt.child.branch_mgmt_billing_approval) {
				return !!this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand;
			}

			if (parentKey === 'tnt_billing_fuel_surcharges' && this.permissions.tnt_billing && this.permissions.tnt_billing.child && this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges) {
				return !!this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand;
			}

			if (this.permissions[parentKey]) {
				return !!this.permissions[parentKey].expand;
			}
			// return false; 
		}
	}, {
		key: 'remove',
		value: function remove(array, element) {
			return array.filter(function (e) {
				return e !== element;
			});
		}

		// reset value of kabaKeyId & SGKeyId

	}, {
		key: 'resetKeyId',
		value: function resetKeyId() {
			if (!this.model.downloadToHHT) {
				// this.model.kabaKeyId = null;
				// this.model.SGKeyId = null;
				// this.model.routeKeyId = null;
				// this.model.tecnoDevId = null;
				// this.model.OTCCompanyName = null;
				this.model.make = [];
				this.loadAtmMakes();
				this.OTCKeys = {};
				this.setOtcKeys();
				this.model.autoCheckIn = false;
				this.model.autoCheckOut = false;
				this.isDisabledSupervisor = false;
			}
		}

		// update branch data

	}, {
		key: 'updateUserBranch',
		value: function updateUserBranch() {
			this.model.branch = this.model.branch.map(function (branchObj) {
				return branchObj.id;
			});
			this.UserService.updateBranchGrouped({
				userId: this.model.id,
				branchs: this.model.branch
			}).then(function (res) {}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'getBranchPermission',
		value: function getBranchPermission() {
			var _this11 = this;

			this.UserService.acl(this.rawId, this.model.branchPermission).then(function (data) {
				_this11.aclPermissions = data;
				_this11.sanitizeCashActivityPermissions(_this11.aclPermissions);
			});
			this.UserService.role(this.rawId, this.model.branchPermission).then(function (data) {
				_this11.aclRole = data;
				_this11.role.user = _this11.aclRole.find(function (role) {
					return role !== 'admin';
				});
			});
		}
	}, {
		key: 'dropdownBranchPermission',
		value: function dropdownBranchPermission() {
			this.model.branchPermission = this.model.branchId;
			this.getBranchPermission();
		}
	}, {
		key: 'changePassword',
		value: function changePassword(isWebPassword) {
			var modelData = (0, _assign2.default)(this.model, { 'isWebPassword': isWebPassword || false });
			this.Modal.changePassword(modelData, function (_ref) {
				var modal = _ref.modal;

				modal.close();
			}, function (_ref2) {
				var modal = _ref2.modal;

				modal.close();
			});
		}
	}, {
		key: 'autoSelectSameForAll',
		value: function autoSelectSameForAll() {
			// this.$scope.$watch(() => {
			// 	return this.model.branch
			// }, (branches) => {
			// 	console.log(branches.length);
			// 	if (branches.length > 1) return this.model.sameForAll = true;
			// 	else return this.model.sameForAll = false;
			// })
			if (this.model.branch.length > 1) return this.model.sameForAll = true;else return this.model.sameForAll = false;
		}
	}, {
		key: 'loadServiceZone',
		value: function loadServiceZone(branchIds, preserveIds) {
			var _this12 = this;

			return this.$q(function (resolve) {
				setTimeout(function () {
					var selectedBranch = branchIds && branchIds.length ? branchIds : Array.isArray(_this12.model.branch) ? _this12.model.branch.map(function (branch) {
						return branch.id;
					}) : [];
					var preserve = preserveIds || (_this12.model.selectedZones || []).map(function (zone) {
						return zone.zoneId;
					});
					var searchObj = {
						queryJSON: {
							rules: [{ field: 'branchId', condition: 'IN', data: selectedBranch }],
							operator: 'AND'
						}
					};
					_this12.LocationZoneService.all(searchObj, 0, 1000).then(function (data) {
						_this12.serviceZoneData = _this12.serviceZoneMap(data.results || [], preserve);
						_this12.model.selectedZones = _this12.serviceZoneData.filter(function (zone) {
							return zone && zone.zoneId != null && zone.ticked;
						});
						resolve();
					});
				});
			});
		}
	}, {
		key: 'serviceZoneMap',
		value: function serviceZoneMap(records, preserve) {
			var _this13 = this;

			var DAY_ORDER = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY', 'HOLIDAY'];
			var byBranch = _.groupBy(records || [], 'branchId');

			var grouped = [];
			(0, _keys2.default)(byBranch).sort().forEach(function (branchId) {
				grouped.push({ label: '<strong>' + branchId + '</strong>', msGroup: true });
				var byDay = _.groupBy(byBranch[branchId], 'dayOfWeek');
				DAY_ORDER.filter(function (d) {
					return byDay[d];
				}).forEach(function (day) {
					grouped.push({ label: '<strong>' + day + '</strong>', msGroup: true });
					byDay[day].forEach(function (z) {
						var info = z.id + ' | ' + z.name + ' (' + z.branchId + ', ' + z.dayOfWeek + ')';
						grouped.push({
							zoneName: z.name, zoneId: z.id, zoneInfo: info,
							label: z.id + ' | ' + z.name, userId: _this13.model.id,
							ticked: preserve.includes(z.id)
						});
					});
					grouped.push({ msGroup: false });
				});
				grouped.push({ msGroup: false });
			});
			return grouped;
		}
	}, {
		key: 'syncWithOTC',
		value: function syncWithOTC(company) {
			var _this14 = this;

			var name = this.model.firstName.concat(' ', this.model.lastName);

			this.isSyncWithOTC = {};
			this.userData = [];
			this.isSyncWithOTC[company] = { process: true };
			this.userData.push({ phone: this.model.phone, OTCCompanyName: company, name: name });

			this.Service.updateUserKeys(this.userData).then(function (res) {
				// if (res && res.result && res.result[0].result == 0) {
				// }
				if (res && res.result && res.result[0].result == 1) {
					_this14.Modal.errorModal(res.result[0].message);
				}
				setTimeout(function () {
					_this14.loadData(company); // reLoad Data after syncWithOTC
				}, 1000);
			}).catch(function (err) {
				console.log(err);
				if (err && err.data && err.data.message) {
					_this14.Modal.errorModal(err.data.message);
				}
			}).finally(function () {
				_this14.isSyncWithOTC[company].process = false;
			});
		}
	}, {
		key: 'loadData',
		value: function loadData(company) {
			var _this15 = this;

			this.Service.get(this.$stateParams.id).then(function (data) {
				_this15.OTCKeys[company] = data.OTCKeys[company];
			}).catch(function (e) {
				console.log(e);
			});
		}
	}, {
		key: 'setOtcKeys',
		value: function setOtcKeys() {
			this.company = this.CommonLayoutService.setOTCKeys(this.OTCCompanies).company;
			this.OTCKeys = this.CommonLayoutService.setOTCKeys(this.OTCCompanies).OTCKeys;
		}
	}, {
		key: 'assignPermissions',
		value: function assignPermissions() {
			var _this16 = this;

			var obj = {
				user: this.rawId,
				branchIds: this.model.branch.map(function (data) {
					return data.id;
				})
			};
			if (this.model.sameForAll = !this.model.sameForAll) {
				this.UserService.updatePermissions(obj).then(function (data) {
					_this16.getBranchPermission(); // reload permission after apply same for all branch
				}).catch(function (err) {
					console.log(err);
				});
			}
		}
	}, {
		key: 'OTCCompanyMap',
		value: function OTCCompanyMap() {
			this.OTCCompanyNameList = this.CommonLayoutService.OTCCompanyMapping(this.OTCCompanies);
		}
	}, {
		key: 'getFundingSource',
		value: function getFundingSource(branches) {
			var _this17 = this;

			setTimeout(function () {
				var selectedBranch = [];
				if (branches && branches.length) selectedBranch = Array.isArray(branches) ? branches.map(function (branch) {
					return branch.branchId;
				}) : branches.split();else selectedBranch = Array.isArray(_this17.model.branch) ? _this17.model.branch.map(function (branch) {
					return branch.id;
				}) : _this17.model.branch.split();

				var searchObj = {
					queryJSON: {
						rules: [{
							field: 'branchId',
							condition: 'IN',
							data: selectedBranch
						}],
						operator: 'AND'
					}
				};

				_this17.loadFundingSource = true;
				_this17.BranchFundingSourceService.all(searchObj, 0, 1000, null).then(function (data) {
					_this17.branchFundingSourceData = data.results;
					_this17.branchFundingSourceGrouped = [];
					var grouped = _.groupBy(_this17.branchFundingSourceData, 'branchId');
					var keys = (0, _keys2.default)(grouped);
					var indexMap2 = {};
					var indexMap = {},
					    addHeader = {};

					keys.forEach(function (k) {
						delete indexMap2[k];
						grouped[k].forEach(function (g) {
							if (!addHeader.hasOwnProperty('header')) {
								addHeader['header'] = true;
								_this17.branchFundingSourceGrouped.push({
									label: '<strong>All Branch Funding Source</strong>',
									msGroup: true
								});
							}
							if (!indexMap.hasOwnProperty(g.branchId)) {
								indexMap[g.branchId] = grouped[k].length;
								_this17.branchFundingSourceGrouped.push({
									label: '<strong>' + k + '</strong>',
									msGroup: true
								});
							}
							_this17.branchFundingSourceGrouped.push({
								name: g.sourceName,
								branch: g.branchId,
								fundingSourceId: g.id,
								label: g.sourceName + ' | ' + '(' + g.locationId + ')',
								ticked: false
							});
						});
						if (!indexMap2.hasOwnProperty(k)) {
							indexMap2[k] = 0;
							_this17.branchFundingSourceGrouped.push({
								msGroup: false
							});
						}
					});
					_this17.branchFundingSourceGrouped.push({ msGroup: false });
					_this17.branchFundingSourceGrouped.forEach(function (bfs) {
						_this17.userBranchFundingSourceData.forEach(function (data) {
							if (data) {
								if (data.branchFundingSourceId === bfs.fundingSourceId) {
									bfs.ticked = true;
								}
							}
						});
					});
					_this17.defaultModel.selectedBranchFundingSource = _this17.branchFundingSourceGrouped.map(function (bfs) {
						if (bfs.ticked) return bfs.fundingSourceId;
					}).filter(function (n) {
						return n !== undefined;
					});
					// return delegates.map(function (delegate) { return delegate.replace("undefined", "") }).join(",");
				}).catch(function (err) {
					console.log(err);
				}).finally(function () {
					_this17.loadFundingSource = false;
				});
			});
		}
	}, {
		key: 'getUserbranchFundingSource',
		value: function getUserbranchFundingSource() {
			var _this18 = this;

			var searchObj = {
				queryJSON: {
					rules: [{
						field: 'userId',
						condition: '=',
						data: this.model.id
					}],
					operator: 'AND'
				}
			};

			return this.UserBranchFundingSourceService.all(searchObj, 0, 1000).then(function (data) {
				_this18.userBranchFundingSourceData = data.results;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'isServiceOnlyUser',
		value: function isServiceOnlyUser() {
			return this.model.serviceUser && !this.model.isWebUser && !this.model.supervisor && !this.model.downloadToHHT;
		}
	}, {
		key: 'updateUserFundingSourceGroup',
		value: function updateUserFundingSourceGroup() {
			var fundingSource = this.isServiceOnlyUser() ? [] : this.selectedFundingSource || [];
			return this.UserBranchFundingSourceService.updateUserFundingSourceGroup(this.model.id, fundingSource).then(function () {
				return void undefined;
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'getSetupDetails',
		value: function getSetupDetails() {
			this.usersDefaultBranch = _.find(this.setupInfo, { branchId: this.model.branchId });
		}
	}, {
		key: 'setCustomerUser',
		value: function setCustomerUser(flag) {
			if (flag && this.model.customerUser) {
				this.model.serviceUser = false;
				this.model.supervisor = false;
				this.model.downloadToHHT = false;
				this.model.isWebUser = false;
				this.selectedFundingSource = [];
				this.removeAssignPermissions();
			} else if (!flag && (this.model.serviceUser || this.model.supervisor || this.model.downloadToHHT || this.model.isWebUser)) {
				this.model.customerUser = false;
				this.model.customer = null;
			} else if (flag && !(this.model.serviceUser || this.model.supervisor || this.model.downloadToHHT || this.model.isWebUser)) {
				this.model.customer = null;
			}
			this.removeAssignPermissions();
		}
	}, {
		key: 'hasActiveAncestors',
		value: function hasActiveAncestors(resource) {
			if (this.permissions[resource]) {
				return true;
			}

			var parentKey = null;
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = (0, _getIterator3.default)((0, _entries2.default)(this.permissions)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var _step3$value = (0, _slicedToArray3.default)(_step3.value, 2),
					    topKey = _step3$value[0],
					    topVal = _step3$value[1];

					if (topVal.child && topVal.child[resource]) {
						parentKey = topKey;
						break;
					}
					if (topVal.child) {
						var _iteratorNormalCompletion4 = true;
						var _didIteratorError4 = false;
						var _iteratorError4 = undefined;

						try {
							for (var _iterator4 = (0, _getIterator3.default)((0, _entries2.default)(topVal.child)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
								var _step4$value = (0, _slicedToArray3.default)(_step4.value, 2),
								    childKey = _step4$value[0],
								    childVal = _step4$value[1];

								if (childVal.child && childVal.child[resource]) {
									parentKey = childKey;
									break;
								}
							}
						} catch (err) {
							_didIteratorError4 = true;
							_iteratorError4 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion4 && _iterator4.return) {
									_iterator4.return();
								}
							} finally {
								if (_didIteratorError4) {
									throw _iteratorError4;
								}
							}
						}

						if (parentKey) break;
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			if (!parentKey) return true;

			if (!this.hasAnyPerm(parentKey)) {
				return false;
			}

			return this.hasActiveAncestors(parentKey);
		}
	}, {
		key: 'disabledPermissions',
		value: function disabledPermissions(parent, child) {
			if (parent == 'branch_mgmt_restore_route_assignments') {
				return true;
			}

			if (this.model.customerUser) {
				if (child) {
					// 	if (child == 'create' && parent == 'service_tickets') {
					// 		return true;
					// 	}
					if (parent == 'setting-location' && ['create', 'importLocations', 'clone', 'editCustomer'].indexOf(child) >= 0) return true;
					if (parent == 'bulk_cash_management' && child !== 'view' && child !== 'export') return true;
				}
				return 0 > this.customerPermissions.indexOf(parent);
			} else if (this.model.isWebUser) {
				return false;
			} else {
				return true;
			}
		}
	}, {
		key: 'removeAssignPermissions',
		value: function removeAssignPermissions() {
			var _this19 = this;

			if (!this.model.isWebUser) {
				var parentKeys = (0, _keys2.default)(this.aclPermissions);
				parentKeys.map(function (parentKey) {
					if (_this19.model.customerUser && 0 > _this19.customerPermissions.indexOf(parentKey)) {
						_this19.aclPermissions[parentKey].forEach(function (permission) {
							_this19.togglePerm(permission, parentKey);
						});
					} else if (!_this19.model.customerUser && !_this19.model.isWebUser) {
						_this19.aclPermissions[parentKey].forEach(function (permission) {
							_this19.togglePerm(permission, parentKey);
						});
					}
				});
			}
		}
	}, {
		key: 'customerSearchPaginate',
		value: function customerSearchPaginate(searchKey, idKey, nameKey) {
			return {
				queryJSON: {
					rules: [{
						field: idKey,
						condition: 'like',
						data: '%' + searchKey + '%'
					}, {
						field: nameKey,
						condition: 'like',
						data: '%' + searchKey + '%'
					}],
					operator: 'OR'
				}
			};
		}
	}, {
		key: 'getCustomer',
		value: function getCustomer(searchKey, offset) {
			var _this20 = this;

			searchKey = searchKey || '';
			var costomerSearchObj = this.customerSearchPaginate(searchKey, 'id', 'name');
			if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
				offset = offset - 1;
			}
			return this.CustomerService.all(costomerSearchObj, offset, _app2.default.defaultPageLimit).then(function (res) {
				var selectedVal = _this20.model.customer ? _this20.model.customer.Value : '';
				if (offset === 0 || offset == undefined) {
					_this20.totalCustomer = res.total;
					var customers = _this20.mappingCustomerDatas(res.results);
					if (!searchKey && selectedVal) {
						customers.unshift(_this20.model.customer);
					}
					_this20.customerList = _.uniqBy(customers, 'Value');
				} else {
					var _customers = _this20.mappingCustomerDatas(res.results);
					_this20.customerList = _.uniqBy(_this20.customerList.concat(_customers), 'Value');
				}
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this20.errorMessage = err.data.message;
				}
			});
		}
	}, {
		key: 'mappingCustomerKeyVal',
		value: function mappingCustomerKeyVal(obj) {
			if (obj == null) return obj;
			obj.Key = obj.id + ' | ' + obj.name, obj.Value = obj.id;
			return obj;
		}
	}, {
		key: 'mappingCustomerDatas',
		value: function mappingCustomerDatas(customers) {
			return customers.map(function (customer) {
				var customerObj = {
					Key: customer.id + ' | ' + customer.name,
					Value: customer.id
				};

				return customerObj;
			});
		}
	}, {
		key: 'validateAutoChekInChekOut',
		value: function validateAutoChekInChekOut() {
			if (!this.model.branchId) return;
			var selectedBranch = _.find(this.setupInfo, { branchId: this.model.branchId });
			this.enableAutoCheckInCheckOut = selectedBranch.enableAutoCheckInCheckOut;
		}
	}, {
		key: 'forceSupervisorToSetOn',
		value: function forceSupervisorToSetOn() {
			if (this.model.downloadToHHT && (this.model.autoCheckIn || this.model.autoCheckOut)) {
				this.isDisabledSupervisor = true;
				this.model.supervisor = true;
			} else {
				// this.model.supervisor = false;
				this.isDisabledSupervisor = false;
			}
		}
	}, {
		key: 'resetServiceZone',
		value: function resetServiceZone() {
			var _this21 = this;

			if (!this.model.serviceUser || !this.model.limitToServiceZone) {
				if (!this.model.serviceUser) {
					this.model.limitToServiceZone = false;
				}
				setTimeout(function () {
					_this21.model.selectedZones = [];
					_this21.serviceZoneData.forEach(function (zone) {
						zone.ticked = false;
					});
				});
			}
		}
	}, {
		key: 'clearFundingSourceIfServiceOnly',
		value: function clearFundingSourceIfServiceOnly() {
			if (this.isServiceOnlyUser()) {
				this.selectedFundingSource = [];
				(this.branchFundingSourceGrouped || []).forEach(function (bfs) {
					bfs.ticked = false;
				});
			}
		}
	}, {
		key: 'findDifferences',
		value: function findDifferences(objA, objB) {
			function compareObjects(obj1, obj2) {
				var diff = {};

				for (var key in obj1) {
					if (obj1.hasOwnProperty(key)) {
						if ((0, _typeof3.default)(obj1[key]) === 'object' && obj1[key] !== null && obj2[key] !== null) {
							if (Array.isArray(obj1[key])) {
								if ((0, _stringify2.default)(obj1[key]) !== (0, _stringify2.default)(obj2[key])) {
									diff[key] = {
										"Old Value": obj1[key],
										"Updated Value": obj2[key]
									};
								}
							} else if (obj2[key] !== undefined && obj1[key] !== undefined) {
								var nestedDiff = compareObjects(obj1[key], obj2[key]);
								if ((0, _keys2.default)(nestedDiff).length > 0) {
									diff[key] = nestedDiff;
								}
							}
						} else if (obj1[key] !== obj2[key] && obj2[key] !== undefined && obj1[key] !== undefined) {
							diff[key] = {
								"Old Value": obj1[key],
								"Updated Value": obj2[key]
							};
						}
					}
				}

				return diff;
			}

			return compareObjects(objA, objB);
		}
	}, {
		key: 'parseMakeValues',
		value: function parseMakeValues(makeValue) {
			if (Array.isArray(makeValue)) {
				return makeValue.map(function (item) {
					if (!item) return null;
					if (typeof item === 'string') {
						var _vendorName = item.trim();
						return _vendorName ? { atmMakeId: null, vendorName: _vendorName } : null;
					}
					var vendorName = (item.vendorName || item.Value || item.value || item.Key || item.label || '').trim();
					var atmMakeId = item.atmMakeId || item.id || item.atmMake && item.atmMake.id || null;
					return vendorName ? { atmMakeId: atmMakeId, vendorName: vendorName } : null;
				}).filter(Boolean);
			}

			if (!makeValue) return [];

			return String(makeValue).split(',').map(function (item) {
				return item.trim();
			}).filter(Boolean).map(function (vendorName) {
				return { atmMakeId: null, vendorName: vendorName };
			});
		}
	}, {
		key: 'serializeMakeValues',
		value: function serializeMakeValues(makeValue) {
			var values = this.parseMakeValues(makeValue);
			return values.length ? values.map(function (item) {
				return item.vendorName;
			}).join(', ') : null;
		}
	}, {
		key: 'buildAtmMakeOptions',
		value: function buildAtmMakeOptions(results, selectedMakes) {
			var selectedValues = this.parseMakeValues(selectedMakes);
			var selectedById = selectedValues.map(function (item) {
				return item.atmMakeId;
			}).filter(Boolean);
			var selectedByName = selectedValues.map(function (item) {
				return item.vendorName;
			}).filter(Boolean);
			var options = (results || []).filter(function (item) {
				return item.active;
			}).map(function (item) {
				return {
					Key: item.vendorName,
					Value: item.vendorName,
					id: item.id,
					atmMakeId: item.id,
					vendorName: item.vendorName,
					ticked: selectedById.includes(item.id) || selectedByName.includes(item.vendorName)
				};
			});

			selectedValues.forEach(function (selectedItem) {
				if (options.findIndex(function (item) {
					return item.atmMakeId === selectedItem.atmMakeId || item.Value === selectedItem.vendorName;
				}) === -1) {
					options.push({
						Key: selectedItem.vendorName,
						Value: selectedItem.vendorName,
						id: selectedItem.atmMakeId || selectedItem.vendorName,
						atmMakeId: selectedItem.atmMakeId,
						vendorName: selectedItem.vendorName,
						ticked: true
					});
				}
			});

			return options;
		}
	}, {
		key: 'loadAtmMakes',
		value: function loadAtmMakes() {
			var _this22 = this;

			var selectedMakes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.model.make;

			return this.AtmMakesService.all('', 0, 1000).then(function (_ref3) {
				var results = _ref3.results;

				_this22.atmMakesList = _this22.buildAtmMakeOptions(results, selectedMakes);
				_this22.model.make = _this22.parseMakeValues(selectedMakes);
			}).catch(function (err) {
				console.log(err);
				_this22.atmMakesList = [];
				_this22.model.make = [];
			});
		}
	}, {
		key: 'loadSchedule',
		value: function loadSchedule(schedule) {
			var _this23 = this;

			this.model.schedule = {};
			this.scheduleErrors = {};
			if (schedule) {
				this.scheduleDays.forEach(function (day) {
					_this23.model.schedule[day.startKey] = _this23.parseTimeString(schedule[day.startKey]) || null;
					_this23.model.schedule[day.endKey] = _this23.parseTimeString(schedule[day.endKey]) || null;
					day.active = !!schedule[day.startKey];
				});
			} else {
				this.scheduleDays.forEach(function (day) {
					_this23.model.schedule[day.startKey] = null;
					_this23.model.schedule[day.endKey] = null;
					day.active = false;
				});
			}
		}
	}, {
		key: 'toggleScheduleDay',
		value: function toggleScheduleDay(day) {
			day.active = !day.active;
			if (!day.active) {
				this.model.schedule[day.startKey] = null;
				this.model.schedule[day.endKey] = null;
				delete this.scheduleErrors[day.key + 'Order'];
			}
			this.validateScheduleDay(day);
		}
	}, {
		key: 'validateScheduleDay',
		value: function validateScheduleDay(day) {
			delete this.scheduleErrors[day.key + 'Order'];

			if (day.active) {
				if (this.model.schedule[day.startKey] && this.model.schedule[day.endKey]) {
					var start = this.formatTimeOnly(this.model.schedule[day.startKey]);
					var end = this.formatTimeOnly(this.model.schedule[day.endKey]);
					if (start && end && start >= end) {
						this.scheduleErrors[day.key + 'Order'] = true;
					}
				}
			}
		}
	}, {
		key: 'hasScheduleErrors',
		value: function hasScheduleErrors() {
			return (0, _keys2.default)(this.scheduleErrors).length > 0;
		}
	}, {
		key: 'formatScheduleForSave',
		value: function formatScheduleForSave() {
			var _this24 = this;

			var schedule = {};
			this.scheduleDays.forEach(function (day) {
				schedule[day.startKey] = _this24.formatTimeOnly(_this24.model.schedule[day.startKey]);
				schedule[day.endKey] = _this24.formatTimeOnly(_this24.model.schedule[day.endKey]);
			});
			return schedule;
		}
	}, {
		key: 'parseTimeString',
		value: function parseTimeString(timeStr) {
			if (!timeStr || typeof timeStr !== 'string') return null;

			var _timeStr$split = timeStr.split(':'),
			    _timeStr$split2 = (0, _slicedToArray3.default)(_timeStr$split, 2),
			    hours = _timeStr$split2[0],
			    minutes = _timeStr$split2[1];

			var d = new Date();
			d.setHours(parseInt(hours, 10));
			d.setMinutes(parseInt(minutes, 10));
			d.setSeconds(0);
			d.setMilliseconds(0);
			return d;
		}
	}, {
		key: 'formatTimeOnly',
		value: function formatTimeOnly(val) {
			if (!val) return null;
			if (typeof val === 'string' && /^\d{2}:\d{2}(:\d{2})?$/.test(val)) return val;
			var d = new Date(val);
			if (isNaN(d.getTime())) return null;
			var h = String(d.getHours()).padStart(2, '0');
			var m = String(d.getMinutes()).padStart(2, '0');
			return h + ':' + m;
		}
	}, {
		key: 'getBranchCounters',
		value: function getBranchCounters() {
			var _this25 = this;

			if (this.model.branchId) {
				return this.UserService.getBranchCounters(this.model.branchId).then(function (data) {
					var counters = data.branchCounters || [];
					_this25.countStationList = counters.map(function (cs) {
						return {
							label: cs.name || cs.label || cs.id,
							value: cs.id
						};
					});
				});
			}
		}
	}]);
	return UsersEditController;
}(_usersBase2.default);

exports.default = UsersEditController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _users = __webpack_require__(2363);

var _users2 = _interopRequireDefault(_users);

var _create = __webpack_require__(2356);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2359);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2353);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersModule = angular.module('users', [_create2.default, _edit2.default, _all2.default]).component('users', _users2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $stateProvider.state('users.edit', {
    url: '/edit/:id',
    component: 'usersedit'
    // data: {
    //   requireACL: 'setting-users.edit'
    // }
  }).state('users.create', {
    url: '/create',
    component: 'userscreate',
    data: {
      requireACL: 'setting-users.create'
    }
  }).state('users.all', {
    url: '/all/:page',
    component: 'usersall',
    data: {
      requireACL: 'setting-users.view'
    }
  });
}]).name;

exports.default = usersModule;

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _users = __webpack_require__(2886);

var _users2 = _interopRequireDefault(_users);

var _users3 = __webpack_require__(2364);

var _users4 = _interopRequireDefault(_users3);

__webpack_require__(3156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _users2.default,
  controller: _users4.default
};

exports.default = usersComponent;

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersController = function (_SettingBase) {
  UsersController.$inject = ["$state"];
  (0, _inherits3.default)(UsersController, _SettingBase);

  function UsersController($state) {
    'ngInject';

    (0, _classCallCheck3.default)(this, UsersController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UsersController.__proto__ || (0, _getPrototypeOf2.default)(UsersController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'users';
    _this.$state = $state;

    return _this;
  }

  (0, _createClass3.default)(UsersController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(UsersController.prototype.__proto__ || (0, _getPrototypeOf2.default)(UsersController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['setting-users']) {
        this.hasACL[this.acl['setting-users'][key]] = true;
      }
    }
  }]);
  return UsersController;
}(_SettingBase3.default);

UsersController.$inject = ['$state'];

exports.default = UsersController;

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vaultAll = __webpack_require__(2366);

var _vaultAll2 = _interopRequireDefault(_vaultAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultallModule = angular.module('vaultall', []).component('vaultall', _vaultAll2.default).name;

exports.default = vaultallModule;

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vaultAll = __webpack_require__(2887);

var _vaultAll2 = _interopRequireDefault(_vaultAll);

var _vaultAll3 = __webpack_require__(2367);

var _vaultAll4 = _interopRequireDefault(_vaultAll3);

__webpack_require__(3157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template: _vaultAll2.default,
  controller: _vaultAll4.default
};

exports.default = vaultallComponent;

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _vaultBase = __webpack_require__(286);

var _vaultBase2 = _interopRequireDefault(_vaultBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VaultallController = function (_VaultBaseController) {
  VaultallController.$inject = ["Auth", "$state", "User", "Modal", "VaultService", "$translate", "$stateParams", "$scope"];
  (0, _inherits3.default)(VaultallController, _VaultBaseController);

  /*@ngInject*/
  function VaultallController(Auth, $state, User, Modal, VaultService, $translate, $stateParams, $scope) {
    (0, _classCallCheck3.default)(this, VaultallController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VaultallController.__proto__ || (0, _getPrototypeOf2.default)(VaultallController)).call(this, Auth, $state, User, VaultService, Modal, $translate, $stateParams));

    _this.id = 'vault.all';
    _this.loading = true;
    _this.vaultes = [];
    _this.page = 1;
    _this.total = 0;
    _this.pageLimit = 10;
    _this.maxPages = 10;
    _this.hasACL = [];
    _this.searchText = '';
    return _this;
  }

  (0, _createClass3.default)(VaultallController, [{
    key: '$onInit',
    value: function $onInit() {
      var pageId = this.$stateParams.page;
      if (pageId > 0) {
        this.page = pageId;
      }
      this.loadData();
    }
  }, {
    key: 'edit',
    value: function edit(vault) {
      this.$state.go('vault.edit', {
        id: vault.id
      });
    }
  }, {
    key: 'delete',
    value: function _delete(vault) {
      var _this2 = this;

      this.Modal.confirm({
        header: this.$translate.instant('common.confirm_delete_title'),
        message: this.$translate.instant('common.confirm_delete_message') + (' <strong>' + vault.id + '</strong>?'),
        callback: function callback(_ref) {
          var modal = _ref.modal,
              $scope = _ref.$scope;

          $scope.loading = true;
          _this2.Service.remove(vault.id).then(function (data) {
            modal.close();
            _this2.refresh();
          });
        },
        type: 'danger'
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.loadData();
    }
  }, {
    key: 'pageChange',
    value: function pageChange() {
      this.loadData();
    }
  }, {
    key: 'generateSearchObj',
    value: function generateSearchObj() {
      return {
        queryText: '%' + this.searchText + '%',
        isQuery: false
      };
    }
  }, {
    key: 'search',
    value: function search() {
      this.page = 1;
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this3 = this;

      var searchObj = this.generateSearchObj();

      this.loading = true;
      this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit).then(function (data) {
        _this3.total = data.total;

        _this3.loading = false;
        _this3.vaultes = data.results;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.error = err.message;
      });
    }
  }, {
    key: 'toggleExpand',
    value: function toggleExpand(vault) {
      vault.expand = !vault.expand;
    }
  }]);
  return VaultallController;
}(_vaultBase2.default);

exports.default = VaultallController;

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vaultCreate = __webpack_require__(2369);

var _vaultCreate2 = _interopRequireDefault(_vaultCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultCreateModule = angular.module('vaultcreate', []).component('vaultcreate', _vaultCreate2.default).name;

exports.default = vaultCreateModule;

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vaultCreate = __webpack_require__(2888);

var _vaultCreate2 = _interopRequireDefault(_vaultCreate);

var _vaultCreate3 = __webpack_require__(2370);

var _vaultCreate4 = _interopRequireDefault(_vaultCreate3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _vaultCreate2.default,
  controller: _vaultCreate4.default
};

exports.default = vaultcreateComponent;

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _vaultBase = __webpack_require__(286);

var _vaultBase2 = _interopRequireDefault(_vaultBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VaultCreateController = function (_VaultBaseController) {
	VaultCreateController.$inject = ["Auth", "$state", "User", "VaultService", "Modal", "$translate"];
	(0, _inherits3.default)(VaultCreateController, _VaultBaseController);

	/*@ngInject*/
	function VaultCreateController(Auth, $state, User, VaultService, Modal, $translate) {
		(0, _classCallCheck3.default)(this, VaultCreateController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (VaultCreateController.__proto__ || (0, _getPrototypeOf2.default)(VaultCreateController)).call(this, Auth, $state, User, VaultService, Modal, $translate));

		_this.model.id = '';
		_this.model.description = '';
		return _this;
	}

	(0, _createClass3.default)(VaultCreateController, [{
		key: 'reset',
		value: function reset() {
			for (var key in this.model) {
				this.model[key] = '';
			}

			this.clearErrors();
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this2 = this;

			if (!this.validate()) {
				return;
			}

			this.loading = true;
			this.Service.create({
				id: this.model.id,
				description: this.model.description
			}).then(function (data) {
				_this2.loading = false;
				_this2.askCreate();
			}).catch(function (err) {
				_this2.loading = false;
				err.data.errors.map(function (e) {
					_this2.errorMessage += e.message + '<br/>';
				});
			});
		}
	}]);
	return VaultCreateController;
}(_vaultBase2.default);

exports.default = VaultCreateController;

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vaultEdit = __webpack_require__(2372);

var _vaultEdit2 = _interopRequireDefault(_vaultEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultEditModule = angular.module('vaultedit', []).component('vaultedit', _vaultEdit2.default).name;

exports.default = vaultEditModule;

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vaultEdit = __webpack_require__(2889);

var _vaultEdit2 = _interopRequireDefault(_vaultEdit);

var _vaultEdit3 = __webpack_require__(2373);

var _vaultEdit4 = _interopRequireDefault(_vaultEdit3);

__webpack_require__(3158);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaulteditComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template: _vaultEdit2.default,
  controller: _vaultEdit4.default
};

exports.default = vaulteditComponent;

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _vaultBase = __webpack_require__(286);

var _vaultBase2 = _interopRequireDefault(_vaultBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VaultEditController = function (_VaultBaseController) {
	VaultEditController.$inject = ["Auth", "$state", "User", "VaultService", "Modal", "$translate", "$stateParams"];
	(0, _inherits3.default)(VaultEditController, _VaultBaseController);

	/*@ngInject*/
	function VaultEditController(Auth, $state, User, VaultService, Modal, $translate, $stateParams) {
		(0, _classCallCheck3.default)(this, VaultEditController);

		var _this = (0, _possibleConstructorReturn3.default)(this, (VaultEditController.__proto__ || (0, _getPrototypeOf2.default)(VaultEditController)).call(this, Auth, $state, User, VaultService, Modal, $translate, $stateParams));

		_this.model.id = '';
		_this.model.description = '';
		return _this;
	}

	(0, _createClass3.default)(VaultEditController, [{
		key: '$onInit',
		value: function $onInit() {
			var _this2 = this;

			this.Service.get(this.$stateParams.id).then(function (data) {
				_this2.rawId = data.id;
				_this2.model.id = data.id;
				_this2.model.description = data.description;
			});
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.model.description = '';
			this.clearErrors();
		}
	}, {
		key: 'submit',
		value: function submit(evt) {
			var _this3 = this;

			if (!this.validate()) {
				return;
			}

			this.loading = true;
			this.Service.update(this.rawId, {
				id: this.model.id,
				description: this.model.description
			}).then(function (data) {
				_this3.loading = false;
				window.history.go(-1);
			}).catch(function (err) {
				_this3.loading = false;
				err.data.errors.map(function (e) {
					_this3.errorMessage += e.message + '<br/>';
				});
			});
		}
	}]);
	return VaultEditController;
}(_vaultBase2.default);

exports.default = VaultEditController;

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vault = __webpack_require__(2375);

var _vault2 = _interopRequireDefault(_vault);

var _create = __webpack_require__(2368);

var _create2 = _interopRequireDefault(_create);

var _edit = __webpack_require__(2371);

var _edit2 = _interopRequireDefault(_edit);

var _all = __webpack_require__(2365);

var _all2 = _interopRequireDefault(_all);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultModule = angular.module('vault', [_create2.default, _edit2.default, _all2.default]).component('vault', _vault2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  // $stateProvider
  //   .state('vault.edit', {
  //     url: '/edit/:id',
  //     component: 'vaultedit'
  //   })

  //   .state('vault.create', {
  //     url: '/create',
  //     component: 'vaultcreate'
  //   })

  //   .state('vault.all', {
  //     url: '/all/:page',
  //     component: 'vaultall',
  //   })
}]).name;

exports.default = vaultModule;

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vault = __webpack_require__(2890);

var _vault2 = _interopRequireDefault(_vault);

var _vault3 = __webpack_require__(2376);

var _vault4 = _interopRequireDefault(_vault3);

__webpack_require__(3159);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template: _vault2.default,
  controller: _vault4.default
};

exports.default = vaultComponent;

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(13);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingBase2 = __webpack_require__(34);

var _SettingBase3 = _interopRequireDefault(_SettingBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VaultController = function (_SettingBase) {
  VaultController.$inject = ["$state"];
  (0, _inherits3.default)(VaultController, _SettingBase);

  /*@ngInject*/
  function VaultController($state) {
    (0, _classCallCheck3.default)(this, VaultController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VaultController.__proto__ || (0, _getPrototypeOf2.default)(VaultController)).call(this));

    _this.acl = {};
    _this.hasACL = {};
    _this.id = 'vault';
    _this.$state = $state;

    return _this;
  }

  (0, _createClass3.default)(VaultController, [{
    key: '$onInit',
    value: function $onInit() {
      (0, _get3.default)(VaultController.prototype.__proto__ || (0, _getPrototypeOf2.default)(VaultController.prototype), '$onInit', this).call(this);
      for (var key in this.acl['setting-vault']) {
        this.hasACL[this.acl['setting-vault'][key]] = true;
      }
    }
  }]);
  return VaultController;
}(_SettingBase3.default);

exports.default = VaultController;

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vault_balance = __webpack_require__(2378);

var _vault_balance2 = _interopRequireDefault(_vault_balance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultBalanceModule = angular.module('vaultBalance', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/vault-balance');

    $stateProvider.state('vaultBalance', {
        url: '/vault-balance',
        component: 'vaultBalance',
        data: {
            requireLogin: true,
            requireACL: 'vault_balance.all'
        },
        parent: 'app'
    });
}]).component('vaultBalance', _vault_balance2.default).name;

exports.default = vaultBalanceModule;

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vault_balance = __webpack_require__(2891);

var _vault_balance2 = _interopRequireDefault(_vault_balance);

var _vault_balance3 = __webpack_require__(2379);

var _vault_balance4 = _interopRequireDefault(_vault_balance3);

__webpack_require__(3160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultBalanceComponent = {
    restrict: 'E',
    template: _vault_balance2.default,
    controller: _vault_balance4.default
};

exports.default = vaultBalanceComponent;

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VaultBalanceController = function () {

    /*@ngInject*/
    VaultBalanceController.$inject = ["$state", "$q", "$window"];
    function VaultBalanceController($state, $q, $window) {
        (0, _classCallCheck3.default)(this, VaultBalanceController);

        this.$q = $q;
        this.$state = $state;
        this.$window = $window;

        this.model = {};
    }

    (0, _createClass3.default)(VaultBalanceController, [{
        key: '$onInit',
        value: function $onInit() {}
    }]);
    return VaultBalanceController;
}();

exports.default = VaultBalanceController;

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vault_close = __webpack_require__(2381);

var _vault_close2 = _interopRequireDefault(_vault_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultCloseModule = angular.module('vaultClose', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/vault-close');

  $stateProvider.state('vaultClose', {
    url: '/vault-close',
    component: 'vaultClose',
    data: {
      requireLogin: true,
      requireACL: 'vault_close.all'
    },
    parent: 'app'
  });
}]).component('vaultClose', _vault_close2.default).name;

exports.default = vaultCloseModule;

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vault_close = __webpack_require__(2892);

var _vault_close2 = _interopRequireDefault(_vault_close);

var _vault_close3 = __webpack_require__(2382);

var _vault_close4 = _interopRequireDefault(_vault_close3);

__webpack_require__(3161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultCloseComponent = {
  restrict: 'E',
  template: _vault_close2.default,
  controller: _vault_close4.default
};

exports.default = vaultCloseComponent;

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VaultCloseController = function () {
	/*@ngInject*/
	VaultCloseController.$inject = ["Auth", "$state", "User", "Modal", "DateUtil", "$translate", "$q", "$scope", "SetupService", "BranchService", "UsersService", "BagoutService", "$location", "$rootScope", "ShipmentService", "DataCounter", "Navigation", "$window"];
	function VaultCloseController(Auth, $state, User, Modal, DateUtil, $translate, $q, $scope, SetupService, BranchService, UsersService, BagoutService, $location, $rootScope, ShipmentService, DataCounter, Navigation, $window) {
		(0, _classCallCheck3.default)(this, VaultCloseController);

		this.Modal = Modal;
		this.$translate = $translate;
		this.$q = $q;
		this.User = User;
		this.DateUtil = DateUtil;
		this.SetupService = SetupService;
		this.BranchService = BranchService;
		this.UsersService = UsersService;
		this.$scope = $scope;
		this.$state = $state;
		this.BagoutService = BagoutService;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.ShipmentService = ShipmentService;
		this.DataCounter = DataCounter;
		this.Navigation = Navigation;
		this.window = $window;
		this.allMsg = [];
		this.userData = [];
		this.usrData = [];
		this.model = {
			branch: this.User.getUser().branchId,
			loggedInUser: this.User.getUser(),
			vaultDate: null,
			verifyErrors: [],
			searchText: "",
			errorMessageList: [],
			errorMessages: [],
			originLocationList: [],
			originLocations: [],
			destinationLocationList: [],
			destinationLocations: []
		};
		this.loading = false;
		this.showReset = false;
		this.$rootScope.$broadcast('routeChange', '/app/vault-close');
		this.days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	}

	(0, _createClass3.default)(VaultCloseController, [{
		key: 'getUserData',
		value: function getUserData() {
			var _this = this;

			this.UsersService.get(this.model.loggedInUser.id).then(function (data) {
				_this.userData = data;
			});
		}

		// REMOVE data from Table

	}, {
		key: 'truncateAllData',
		value: function truncateAllData() {
			this.BranchService.truncateRoute(this.model.branch).then(function (data) {}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'verifyCloseVault',
		value: function verifyCloseVault() {
			var _this2 = this;

			if (this.loading) return;
			this.loading = true;
			this.BranchService.verifyCloseVault(this.model.branch, this.model.loggedInUser.id, moment.tz.guess()).then(function (res) {
				if (res && res.result && res.result.length) {
					var message = _this2.$translate.instant('closeVault.verify_vault_close_message', {
						date1: _this2.model.vaultDate,
						date2: moment(_this2.model.vaultDate).add(1, 'day').format('YYYY-MM-DD')
					});
					_this2.Modal.confirm({
						header: _this2.$translate.instant('closeVault.verify_vault_close_title'),
						message: message,
						callback: function callback(_ref) {
							var modal = _ref.modal,
							    $scope = _ref.$scope;

							modal.close();
							_this2.closeVault();
						},
						negative: function negative(_ref2) {
							var modal = _ref2.modal,
							    $scope = _ref2.$scope;

							modal.close();
							_this2.loading = false;
						},
						type: 'primary',
						buttons: ['common.confirm_title', 'common.cancel']
					});
				} else {
					_this2.closeVault();
				}
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					var msg = err.data.message;
					_this2.Modal.errorModal(msg);
				}
				_this2.loading = false;
				console.error(err);
			});
		}
	}, {
		key: 'closeVault',
		value: function closeVault() {
			var _this3 = this;

			this.loading = true;
			this.BranchService.closeVault(this.model.branch, this.model.loggedInUser.id, this.model.vaultDate).then(function () {
				//show message
				return _this3.loadCurrentVaultDate();
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					var msg = err.data.message;
					if (msg.includes('bank report(s) failed to be published.')) {
						_this3.formatString(msg, 40, '</br>');
					} else {
						_this3.Modal.errorModal(msg);
					}
				}
				console.error(err);
			}).finally(function () {
				_this3.loading = false;
			});
		}
	}, {
		key: 'loadCurrentVaultDate',
		value: function loadCurrentVaultDate() {
			var _this4 = this;

			return this.SetupService.get(this.model.branch).then(function (setup) {
				if (setup && setup.currentVaultDate) {
					_this4.model.vaultDate = _this4.DateUtil.getUTCDate(setup.currentVaultDate);
				}
			}).then(function () {
				_this4.verifyVaultClose(_this4.model.vaultDate).then(function () {
					_this4.uniqueErrorMessages();
					_this4.uniqueOriginLocations();
					_this4.uniqueDestinationLocations();
				});
			}).catch(function (err) {
				_this4.error = err.message;
			});
		}
	}, {
		key: 'verifyVaultClose',
		value: function verifyVaultClose(vaultDate) {
			var _this5 = this;

			this.model.loading = true;
			this.model.isError = false;
			return this.BranchService.verifyVault(this.model.branch, vaultDate).then(function (data) {
				_this5.model.verifyErrors = data;
				_this5.bagOutError = _this5.$translate.instant('closeVault.BAGOUT_NOT_CLOSED');
				data.forEach(function (element) {
					element.translateMessage = _this5.$translate.instant('closeVault.' + element.message);
					element.message = element.message;
				});
				_this5.model.isError = false;
			}).catch(function (err) {
				_this5.model.isError = true;
				if (err && err.data && err.data.message) {
					_this5.Modal.errorModal('error.' + err.data.message);
				}
			}).finally(function () {
				_this5.model.loading = false;
			});
		}

		// redirect to bagout close screen

	}, {
		key: 'bagOutClose',
		value: function bagOutClose(bagoutId) {
			var _this6 = this;

			if (bagoutId) {
				this.$rootScope.$broadcast('routeChange', null);
				return this.BagoutService.getShipments(bagoutId).then(function (res) {
					_this6.$location.url('/app/bag-out-print?bagout=' + bagoutId);
				});
			}
		}
	}, {
		key: '$onInit',
		value: function $onInit() {
			this.$q.all([this.loadCurrentVaultDate(), this.getUserData()]).then(function (data) {
				// console.log(data)
			}).catch(function (err) {
				console.log(err);
			});
		}
	}, {
		key: 'redirectTo',
		value: function redirectTo(data) {
			this.$rootScope.$broadcast('routeChange', null);
			if (data.message === 'DELIVERY_NOT_PACKED') return this.$state.go('orderPacking');else if (data.message === 'DELIVERY_NOT_THROWN') return this.$state.go('routeThrow');else if (data.message === 'DELIVERY_NOT_CHECKED_OUT') return this.$state.go('checkout');else if (data.message === 'DELIVERY_NOT_DELIVERED') return this.$state.go('checkin');else if (data.message === 'PICKUP_NOT_CHECKED_IN') return this.$state.go('checkin');else if (data.message === 'PICKUP_NOT_BAGGED_OUT' || data.message === 'SHIPMENT_NOT_BAGGED_OUT') return this.$state.go('checkout');else if (data.message === 'HOLD_NOT_VERIFIED') return this.$state.go('branchManagement.itemHolds');else if (data.message === 'BAGOUT_NOT_CLOSED') return this.bagOutClose(data.trackingId);else if (data.message === 'BULK_TRANSFER_NOT_CLOSED') {
				return this.window.open('/v2/index.html#/bulk-transfer/active?trackingId=' + encodeURIComponent(data.trackingId || ''), '_self');
			} else if (data.message === 'DEPOSIT_NOT_RELEASED') return this.$state.go('depositPacking');else if (data.message === 'CRV_NOT_COUNTED') {
				var obj = {
					trackingId: data.trackingId,
					isRedirected: true,
					fundingSourceId: null,
					destinationLocationId: data.destinationLocationId
				};
				this.DataCounter.setData(obj);
				this.$state.go('atmCount');
			} else if (data.message === 'RESIDUAL_NOT_APPROVED') return this.goToFinalResidualCount(data);else if (data.message === 'BALANCECHECK_MISSING' || data.message === 'BALANCE_CHECK_VARIANCE') return this.goToPhysicalCashCount(data);else if (data.message === 'BULK_DEPOSIT_COUNT_NOT_COMPLETED') {
				var _obj = {
					trackingId: data.trackingId,
					isRedirected: true,
					fundingSourceId: null,
					destinationLocationId: data.destinationLocationId
				};
				this.DataCounter.setData(_obj);
				this.$state.go('atmCount');
			}
		}
	}, {
		key: 'moveShipments',
		value: function moveShipments(data) {
			var _this7 = this;

			this.Modal.moveShipmentModal(data, this.model.branch, function (_ref3) {
				var modal = _ref3.modal,
				    toRoute = _ref3.toRoute,
				    date = _ref3.date,
				    supervisorId = _ref3.supervisorId;

				var comment = _this7.bagRouteThrowError = _this7.$translate.instant('closeVault.shipment_moved', {
					fromRouteId: data.routeId,
					toRouteId: toRoute.Value
				});
				_this7.ShipmentService.holdRelease(data.trackingId, data.routeId, toRoute.Value, date, supervisorId, comment, _this7.model.branch).then(function (data) {
					modal.close();
					_this7.verifyVaultClose(_this7.model.vaultDate);
				}).catch(function (err) {
					modal.close();
					if (err && err.data && err.data.message) {
						return _this7.Modal.errorModal('error.' + err.data.message);
					}
				});
			}, function (_ref4) {
				var modal = _ref4.modal;

				modal.close();
			});
		}
	}, {
		key: 'sendToHold',
		value: function sendToHold(data) {
			var _this8 = this;

			var reason = '',
			    comments = 'send to hold';

			var defer = this.$q.defer();
			this.Modal.confirmSupervisor('send-to-hold', function (_ref5) {
				var modal = _ref5.modal,
				    supId = _ref5.supId;

				_this8.ShipmentService.holdShipment(data.branchId, data.trackingId, data.routeId, data.vaultDate, supId, reason, comments).then(function () {
					modal.close();
					defer.resolve();
				}).catch(function (err) {
					modal.close();
					if (err && err.data && err.data.message) {
						return _this8.Modal.errorModal("error." + err.data.message);
					}
					defer.reject();
				});
			}, function (_ref6) {
				var modal = _ref6.modal;

				modal.close();
			});
			defer.promise.then(function () {
				return _this8.verifyVaultClose(_this8.model.vaultDate);
			});
		}
	}, {
		key: 'redirectToServiceHistory',
		value: function redirectToServiceHistory(locationId) {
			this.$rootScope.$broadcast('routeChange', null);
			var obj = {
				locationId: locationId,
				isRedirected: true
			};
			this.DataCounter.setData(obj);
			this.$location.url('/app/branch-management/locations-history');
		}
	}, {
		key: 'redirectToItemTab',
		value: function redirectToItemTab(trackingId) {
			this.$rootScope.$broadcast('routeChange', null);
			this.$state.go('branchManagement.items', {
				id: trackingId
			});
		}
	}, {
		key: 'uniqueErrorMessages',
		value: function uniqueErrorMessages() {
			var _this9 = this;

			var messageGroup = _.groupBy(this.model.verifyErrors, 'message');
			var keys = (0, _keys2.default)(messageGroup);
			keys.map(function (data) {
				var translateMessage = messageGroup[data][0].translateMessage;
				_this9.model.errorMessageList.push({ message: data, translateMessage: translateMessage, ticked: false });
			});
		}
	}, {
		key: 'uniqueOriginLocations',
		value: function uniqueOriginLocations() {
			var _this10 = this;

			var originLocationGroup = _.groupBy(this.model.verifyErrors, 'originLocationId');
			var keys = (0, _keys2.default)(originLocationGroup);
			keys.map(function (data) {
				if (data !== 'null') {
					var originLocation = data.concat(" | ", originLocationGroup[data][0].originLocationName);
					_this10.model.originLocationList.push({ originLocationId: data, originLocation: originLocation, ticked: false });
				}
			});
		}
	}, {
		key: 'uniqueDestinationLocations',
		value: function uniqueDestinationLocations() {
			var _this11 = this;

			var destinationLocationGroup = _.groupBy(this.model.verifyErrors, 'destinationLocationId');
			var keys = (0, _keys2.default)(destinationLocationGroup);
			keys.map(function (data) {
				if (data !== 'null') {
					var destinationLocation = data.concat(" | ", destinationLocationGroup[data][0].destinationLocationName);
					_this11.model.destinationLocationList.push({ destinationLocationId: data, destinationLocation: destinationLocation, ticked: false });
				}
			});
		}
	}, {
		key: 'filterData',
		value: function filterData() {
			var errorMessages = this.model.errorMessages;
			var originLocations = this.model.originLocations;
			var trackingId = this.model.searchText;
			var destinationLocations = this.model.destinationLocations;

			return function (row) {

				function searchMessage() {
					if (errorMessages.length) return errorMessages.some(function (data) {
						return row['message'].indexOf(data.message) > -1;
					});else return row['message'].indexOf('') > -1;
				}

				function searchOriginLocation() {
					if (originLocations.length) return originLocations.some(function (loc) {
						return row['originLocationId'] && row['originLocationId'].indexOf(loc.originLocationId) > -1;
					});else return row;
				}

				function searchDestinationLocation() {
					if (destinationLocations.length) return destinationLocations.some(function (loc) {
						return row['destinationLocationId'] && row['destinationLocationId'].indexOf(loc.destinationLocationId) > -1;
					});else return row;
				}

				function searchTrackingId() {
					if (trackingId) return row['trackingId'] && row['trackingId'].toUpperCase().indexOf(trackingId.toUpperCase()) > -1;else return row;
				}

				return searchMessage() && searchTrackingId() && searchOriginLocation() && searchDestinationLocation();
			};
		}
	}, {
		key: 'formatString',
		value: function formatString(str, width, brk) {
			// console.log(str, width, brk);

			// brk = brk || 'n';
			// width = width || 75;

			// if (!str) { return str; }

			// var regex = '.{1,' + width + '}(\  |- )' + ('|.{' + width + '}|.+$');

			// let opt = str.match(RegExp(regex, 'g')).join(brk);
			// return this.Modal.errorModal(opt.toString().replace(/-/, '</br>').replace('-', '--'))

			var output = str.toString().replace(/-/, '<br><br>').replace(/1. Error/, '<br>');
			return this.Modal.errorModal(output.split(": ").join("1. Error: ").replace('-', '--'));
		}
	}, {
		key: 'routeCheckIn',
		value: function routeCheckIn(data) {
			var _this12 = this;

			var formattedDate = moment.utc(data.routeDate).format('YYYY-MM-DD');

			this.BranchService.validateRouteCheckIn(data.routeId, formattedDate, this.model.branch, this.model.loggedInUser.id).then(function () {
				_this12.verifyVaultClose(_this12.model.vaultDate);
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this12.Modal.errorModal('error.' + err.data.message);
				}
			});
		}
	}, {
		key: 'goToRouteTab',
		value: function goToRouteTab(data) {
			this.Navigation.goToRouteTab(data.routeId, data.routeDate, true, null);
		}
	}, {
		key: 'goToFinalResidualCount',
		value: function goToFinalResidualCount(data) {
			// this.$rootScope.$broadcast('routeChange', null);
			var obj = {
				fundingSourceLocation: data.destinationLocationId,
				isRedirected: true
			};
			this.DataCounter.setData(obj);
			this.$state.go('branchManagement.finalResidualCountCommit');
		}
	}, {
		key: 'capitalizeFirstLetter',
		value: function capitalizeFirstLetter(name) {
			if (typeof name !== 'string') return;else return name.charAt(0).toUpperCase() + name.slice(1);
		}
	}, {
		key: 'goToItemTab',
		value: function goToItemTab() {
			this.$state.go('items.all', {
				page: 1
			});
		}
	}, {
		key: 'goToATMCountTab',
		value: function goToATMCountTab() {
			this.$state.go('atmCount');
		}
	}, {
		key: 'cancelShipmentTransfer',
		value: function cancelShipmentTransfer(data) {
			var _this13 = this;

			var shipments = [{
				shipmentId: data.shipmentId,
				trackingId: data.trackingId,
				fromLocationId: data.originLocationId,
				toLocationId: data.destinationLocationId,
				routeId: data.routeId,
				branchId: this.model.branch,
				vaultDate: moment.utc(data.routeDate).format('YYYY-MM-DD')
			}];

			this.isCancelTransferLoading = true;
			this.BranchService.cancelShipmentTransfer(shipments, 'single', this.model.branch).then(function () {
				_this13.verifyVaultClose(_this13.model.vaultDate);
			}).catch(function (err) {
				if (err && err.data && err.data.message) {
					_this13.Modal.errorModal('error.' + err.data.message);
				}
			}).finally(function () {
				_this13.isCancelTransferLoading = false;
			});
		}
	}, {
		key: 'goToPhysicalCashCount',
		value: function goToPhysicalCashCount(data) {
			this.$state.go('branchManagement.physicalCashCount');
		}
	}]);
	return VaultCloseController;
}();

exports.default = VaultCloseController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vault_operations = __webpack_require__(2384);

var _vault_operations2 = _interopRequireDefault(_vault_operations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultOperationsModule = angular.module('vaultOperations', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider.otherwise('/vault-operations');

    $stateProvider.state('vaultOperations', {
        url: '/vault-operations',
        component: 'vaultOperations',
        data: {
            requireLogin: true,
            requireACL: 'vault_operations.all'
        },
        parent: 'app'
    });
}]).component('vaultOperations', _vault_operations2.default).name;

exports.default = vaultOperationsModule;

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vault_operations = __webpack_require__(2893);

var _vault_operations2 = _interopRequireDefault(_vault_operations);

var _vault_operations3 = __webpack_require__(2385);

var _vault_operations4 = _interopRequireDefault(_vault_operations3);

__webpack_require__(3162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vaultOperationsComponent = {
    restrict: 'E',
    bindings: {},
    template: _vault_operations2.default,
    controller: _vault_operations4.default
};

exports.default = vaultOperationsComponent;

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VaultOperationsController = function () {
    /*@ngInject*/
    VaultOperationsController.$inject = ["Auth", "User", "Modal", "SetupService", "Navigation", "$q", "$translate", "DateUtil", "$rootScope", "TimezoneList", "UsersService", "VaultOperationsService", "DataCounter", "$state", "RouteDetailService", "ShipmentService", "HoldService", "UserBranchService", "CommonLayoutService"];
    function VaultOperationsController(Auth, User, Modal, SetupService, Navigation, $q, $translate, DateUtil, $rootScope, TimezoneList, UsersService, VaultOperationsService, DataCounter, $state, RouteDetailService, ShipmentService, HoldService, UserBranchService, CommonLayoutService) {
        (0, _classCallCheck3.default)(this, VaultOperationsController);

        this.Auth = Auth;
        this.User = User;
        this.Modal = Modal;
        this.SetupService = SetupService;
        this.Navigation = Navigation;
        this.$q = $q;
        this.$translate = $translate;
        this.DateUtil = DateUtil;
        this.$rootScope = $rootScope;
        this.TimezoneList = TimezoneList;
        this.UsersService = UsersService;
        this.VaultOperationsService = VaultOperationsService;
        this.DataCounter = DataCounter;
        this.$state = $state;
        this.RouteDetailService = RouteDetailService;
        this.ShipmentService = ShipmentService;
        this.HoldService = HoldService;
        this.UserBranchService = UserBranchService;
        this.CommonLayoutService = CommonLayoutService;
        this.initialSearchFocusApplied = false;

        this.model = {
            branchObj: {
                results: [],
                totalRecords: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                gettingBranch: false,
                searchText: null
            },
            routesObj: {
                results: [],
                totalRecords: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                gettingRoutes: false,
                searchText: null,
                sortColumn: 'routeDate',
                reverseSort: true
            },
            loadShipmentObj: {
                results: [],
                totalRecords: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                gettingLoadShipment: false,
                searchText: null,
                sortColumn: 'vaultDate',
                reverseSort: true
            },
            residualShipmentObj: {
                results: [],
                totalRecords: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                gettingResidualShipment: false,
                searchText: null,
                sortColumn: 'vaultDate',
                reverseSort: true
            },
            loggedInUser: User.getUser().id,
            currentBranch: User.getUser().branchId,
            loading: false,
            dateRangeOptions: {
                startDate: null,
                endDate: null
            },
            dateRangPickerOptions: {},
            dateRangPickerOptionsfor: {},
            timezone: null,
            timezoneList: this.TimezoneList.getTimezoneList(),
            browserTimezone: moment.tz.guess(),
            selectedBranch: '',
            userBranchList: []
        };

        this.$rootScope.$broadcast('routeChange', '/app/vault-operations');
    }

    (0, _createClass3.default)(VaultOperationsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$q.all([this.SetupService.get(this.model.currentBranch), this.UsersService.getUserFieldData(this.model.loggedInUser), this.UserBranchService.getUserBranches(this.model.loggedInUser), this.getSoftDeleteShipmentPermission()]).then(function (data) {
                _this.model.setupDetails = data[0];
                _this.model.userDetails = data[1];
                _this.model.branchObj.results = data[2].results;
                _this.model.branchObj.results.forEach(function (branch) {
                    if (branch.branchId == _this.model.currentBranch) {
                        branch.ticked = true;
                    }
                });
                _this.currentVaultDate = _this.DateUtil.getUTCDate(_this.model.setupDetails.currentVaultDate);
                _this.model.timezone = _this.model.userDetails && _this.model.userDetails.timezone ? _this.model.userDetails.timezone : _this.model.browserTimezone;;

                _this.setDateRangeOptions('dateRangPickerOptionsfor');
                _this.model.dateRangeOptions.startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                _this.model.dateRangeOptions.endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
            }).then(function () {
                _this.loadData();
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'setDateRangeOptions',
        value: function setDateRangeOptions(modelValue) {
            var _this2 = this;

            this.model[modelValue] = {
                autoApply: true,
                eventHandlers: {
                    'apply.daterangepicker': function applyDaterangepicker() {
                        _this2.loadData();
                    }
                },
                ranges: {
                    'Previous Week': [moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'), moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')],
                    'Today': [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Week': [moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')],
                    'Current Month': [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')],
                    'Last 60 Days': [moment().subtract('59', 'days').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                }
            };
        }
    }, {
        key: 'getStartDate',
        value: function getStartDate() {
            return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD') : null;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate() {
            return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD') : null;
        }

        // -------------------------------------------route List Logic section Start------------------------------------------------ //

    }, {
        key: 'getRouteList',
        value: function getRouteList() {
            var _this3 = this;

            setTimeout(function () {
                var startDate = _this3.getStartDate();
                var endDate = _this3.getEndDate();
                var branches = _this3.getSelectedBranches();
                var getRoutesOnVaultDate = null;

                _this3.model.routesObj.gettingRoutes = true;
                _this3.VaultOperationsService.getRouteList(_this3.model.routesObj.searchText, startDate, endDate, (_this3.model.routesObj.pagination.page - 1) * _this3.model.routesObj.pagination.pageLimit, _this3.model.routesObj.pagination.pageLimit, _this3.model.routesObj.reverseSort, _this3.model.routesObj.sortColumn, _this3.model.timezone, getRoutesOnVaultDate, branches).then(function (data) {
                    _this3.model.routesObj.pagination.total = data.totalRecords;
                    _this3.model.routesObj.results = data.results;
                    _this3.model.routesObj.totalRecords = data.totalRecords;
                }).catch(function (err) {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        _this3.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this3.model.routesObj.gettingRoutes = false;
                    _this3.focusFirstAvailableSearch();
                });
            });
        }
    }, {
        key: 'focusFirstAvailableSearch',
        value: function focusFirstAvailableSearch() {
            if (this.initialSearchFocusApplied) return;
            if (this.model.routesObj.gettingRoutes || this.model.loadShipmentObj.gettingLoadShipment || this.model.residualShipmentObj.gettingResidualShipment) {
                return;
            }
            this.initialSearchFocusApplied = true;

            var targetId = 'routeSearchText';
            if (this.model.routesObj.results && this.model.routesObj.results.length) {
                targetId = 'routeSearchText';
            } else if (this.model.loadShipmentObj.results && this.model.loadShipmentObj.results.length) {
                targetId = 'loadShipmentSearchText';
            } else if (this.model.residualShipmentObj.results && this.model.residualShipmentObj.results.length) {
                targetId = 'residualShipmentSearchText';
            }

            setTimeout(function () {
                var el = document.getElementById(targetId);
                if (el) el.focus();
            }, 300);
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            this.model.routesObj.pagination.page = 1;
            this.model.loadShipmentObj.pagination.page = 1;
            this.model.residualShipmentObj.pagination.page = 1;

            this.getRouteList();
            this.getDeliveryShipmentList();
            this.getPickupShipmentList();
        }
    }, {
        key: 'goToRouteTab',
        value: function goToRouteTab(data) {
            var _this4 = this;

            var date = data.hasOwnProperty('routeDate') ? data.routeDate : data.vaultDate;

            if (this.model.currentBranch === data.branchId) {
                this.redirectToRouteTab(data.routeId, date);
            } else {
                this.shiftBranch(this.model.loggedInUser, data.branchId).then(function () {
                    setTimeout(function () {
                        _this4.redirectToRouteTab(data.routeId, date);
                    }, 500);
                }).catch(function (err) {
                    err.data.errors.map(function (e) {
                        _this4.errorMessage += e.message + '<br/>';
                    });
                    _this4.Modal.errorModal(_this4.errorMessage);
                });
            }
        }
    }, {
        key: 'redirectToRouteTab',
        value: function redirectToRouteTab(routeId, branchVaultDate) {
            return this.Navigation.goToRouteTab(routeId, branchVaultDate, true, null);
        }
    }, {
        key: 'pageChange',
        value: function pageChange(stats) {
            if (stats === 'routes') return this.getRouteList();else if (stats === 'loadShipments') return this.getDeliveryShipmentList();else if (stats === 'pickupShipments') return this.getPickupShipmentList();
        }
    }, {
        key: 'goToUserTab',
        value: function goToUserTab(userId) {
            if (!userId) return;
            this.Navigation.goToUserTab(userId, null);
        }
    }, {
        key: 'goToVehicleTab',
        value: function goToVehicleTab(vehicleId) {
            if (!vehicleId) return;
            this.Navigation.goToVehicleTab(vehicleId, null);
        }
    }, {
        key: 'sortRouteData',
        value: function sortRouteData(column, event) {
            this.model.routesObj.reverseSort = this.model.routesObj.sortColumn == column ? !this.model.routesObj.reverseSort : false;
            this.model.routesObj.sortColumn = column;
            this.getRouteList();
            event.preventDefault();
        }
    }, {
        key: 'editRouteDetails',
        value: function editRouteDetails(routeObj) {
            var _this5 = this;

            if (this.isLoading) return;
            this.isLoading = true;

            var date = this.DateUtil.getUTCDate(routeObj.routeDate);
            // const timezone = this.model.timezone || this.model.setupDetails.timezone;
            // routeObj.timezone = timezone;

            this.Modal.routesInfoModal(routeObj, true, function (_ref) {
                var truck = _ref.truck,
                    messenger = _ref.messenger,
                    modal = _ref.modal,
                    leaveTime = _ref.leaveTime,
                    arriveTime = _ref.arriveTime,
                    complTime = _ref.complTime,
                    begMiles = _ref.begMiles,
                    endMiles = _ref.endMiles,
                    supervisorId = _ref.supervisorId;

                _this5.VaultOperationsService.updateRouteDetails(routeObj.branchId, routeObj.routeId, date, truck, messenger, null, null, leaveTime, arriveTime, complTime, begMiles, endMiles, _this5.model.timezone, supervisorId).then(function () {
                    _this5.getRouteList();
                    _this5.isLoading = false;
                    modal.close();
                }).catch(function (err) {
                    _this5.isLoading = false;
                    modal.close();
                    if (err && err.data && err.data.message) {
                        return _this5.Modal.errorModal("error." + err.data.message);
                    }
                });
            }, function (_ref2) {
                var modal = _ref2.modal;

                _this5.isLoading = false;
                modal.close();
            });
        }
    }, {
        key: 'resetData',
        value: function resetData() {}
    }, {
        key: 'filterRouteList',
        value: function filterRouteList() {
            this.model.routesObj.pagination.page = 1;
            this.getRouteList();
        }
    }, {
        key: 'goToItemHistory',
        value: function goToItemHistory(data) {
            var _this6 = this;

            if (this.model.currentBranch === data.branchId) {
                this.redirectToItemHistory(data.trackingId);
            } else {
                this.shiftBranch(this.model.loggedInUser, data.branchId).then(function () {
                    setTimeout(function () {
                        _this6.redirectToItemHistory(data.trackingId);
                    }, 500);
                }).catch(function (err) {
                    err.data.errors.map(function (e) {
                        _this6.errorMessage += e.message + '<br/>';
                    });
                    _this6.Modal.errorModal(_this6.errorMessage);
                });
            }
        }
    }, {
        key: 'redirectToItemHistory',
        value: function redirectToItemHistory(trackingId) {
            this.$state.go('branchManagement.items', {
                id: trackingId
            });
        }

        // -------------------------------------------route List Logic section End------------------------------------------------ //

        // -------------------------------------------Delivery Shipment Logic section Start------------------------------------------------ //

    }, {
        key: 'getDeliveryShipmentList',
        value: function getDeliveryShipmentList() {
            var _this7 = this;

            setTimeout(function () {
                var startDate = _this7.getStartDate();
                var endDate = _this7.getEndDate();
                var branches = _this7.getSelectedBranches();

                _this7.model.loadShipmentObj.gettingLoadShipment = true;

                _this7.VaultOperationsService.getDeliveryShipmentList(_this7.model.loadShipmentObj.searchText, startDate, endDate, (_this7.model.loadShipmentObj.pagination.page - 1) * _this7.model.loadShipmentObj.pagination.pageLimit, _this7.model.loadShipmentObj.pagination.pageLimit, _this7.model.loadShipmentObj.reverseSort, _this7.model.loadShipmentObj.sortColumn, _this7.model.timezone, branches).then(function (data) {
                    _this7.model.loadShipmentObj.pagination.total = data.totalRecords;
                    _this7.model.loadShipmentObj.results = data.results;
                    _this7.model.loadShipmentObj.totalRecords = data.totalRecords;
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        _this7.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this7.model.loadShipmentObj.gettingLoadShipment = false;
                    _this7.focusFirstAvailableSearch();
                });
            });
        }
    }, {
        key: 'goToServiceHistory',
        value: function goToServiceHistory(locationId) {
            return this.Navigation.goToServiceHistory(locationId, null, true, null);
        }
    }, {
        key: 'getOrderType',
        value: function getOrderType(type) {
            if (!type) return;
            return this.ShipmentService.getOrderType(type);
        }
    }, {
        key: 'translateStatus',
        value: function translateStatus(statusCode) {
            return this.$translate.instant(statusCode);
        }
    }, {
        key: 'sortDeliveryShipmentData',
        value: function sortDeliveryShipmentData(column, event) {
            this.model.loadShipmentObj.reverseSort = this.model.loadShipmentObj.sortColumn == column ? !this.model.loadShipmentObj.reverseSort : false;
            this.model.loadShipmentObj.sortColumn = column;
            this.getDeliveryShipmentList();
            event.preventDefault();
        }
    }, {
        key: 'filterDeliveries',
        value: function filterDeliveries() {
            this.model.loadShipmentObj.pagination.page = 1;
            this.getDeliveryShipmentList();
        }
    }, {
        key: 'markAsDelivered',
        value: function markAsDelivered(shipment, stats) {
            var _this8 = this;

            if (this.loading) return;
            this.loading = true;

            var date = this.DateUtil.getUTCDate(shipment.vaultDate);

            this.Modal.markAsDelivered(shipment, date, this.model.timezone, function (_ref3) {
                var modal = _ref3.modal,
                    supervisorId = _ref3.supervisorId,
                    comment = _ref3.comment,
                    loadedAmount = _ref3.loadedAmount,
                    date = _ref3.date,
                    time = _ref3.time;

                _this8.HoldService.shipmentDelivery(shipment.trackingId, shipment.routeId, supervisorId, comment, shipment.branchId, loadedAmount, date, time, _this8.model.timezone, shipment.orderType, shipment.amount).then(function () {
                    modal.close();
                    if (stats === 'Pickups') {
                        _this8.filterPickupShipment();
                    } else {
                        _this8.getDeliveryShipmentList();
                    }
                }).catch(function (err) {
                    modal.close();
                    _this8.Modal.errorModal('error.' + err.data.message);
                }).finally(function () {
                    _this8.loading = false;
                });
            }, function (_ref4) {
                var modal = _ref4.modal;

                if (modal) modal.close();
                _this8.loading = false;
            });
        }
    }, {
        key: 'sendToHold',
        value: function sendToHold(shipment) {
            var _this9 = this;

            var reason = '',
                comments = 'send to hold';

            var date = this.DateUtil.getUTCDate(shipment.vaultDate);

            this.Modal.confirmSupervisor('send-to-hold', { trackingId: shipment.trackingId }, function (_ref5) {
                var modal = _ref5.modal,
                    supId = _ref5.supId;

                _this9.ShipmentService.holdShipment(shipment.branchId, shipment.trackingId, shipment.routeId, date, supId, reason, comments).then(function () {
                    modal.close();
                    _this9.getDeliveryShipmentList();
                    if (_this9.isParentResidualPickup(shipment)) _this9.getPickupShipmentList();
                }).catch(function (err) {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        return _this9.Modal.errorModal("error." + err.data.message);
                    }
                });
            }, function (_ref6) {
                var modal = _ref6.modal;

                modal.close();
            });
        }
    }, {
        key: 'editLoadShipmentModal',
        value: function editLoadShipmentModal(shipmentObj) {
            var _this10 = this;

            var branchTimezone = this.model.timezone || this.model.setupDetails.timezone;
            this.Modal.editDeliveryShipment(shipmentObj, branchTimezone, function (_ref7) {
                var modal = _ref7.modal,
                    shipments = _ref7.shipments,
                    updateState = _ref7.updateState,
                    $scope = _ref7.$scope;


                delete shipments.amount;
                delete shipments.deliveryTime;
                delete shipments.deliveryDate;
                delete shipments.vaultDate;
                delete shipments.loadedAmount;
                delete shipments.selectedRoute;
                shipments.currentTimezone = _this10.model.timezone;

                $scope.model.loading = true;
                if (shipments.status === "shipment.hold" && updateState === "mark_delivered") {
                    _this10.VaultOperationsService.markHoldAsDelivered(shipments).then(function () {
                        modal.close();
                        _this10.getDeliveryShipmentList();
                    }).catch(function (err) {
                        modal.close();
                        _this10.Modal.errorModal('error.' + err.data.message);
                    }).finally(function () {
                        $scope.model.loading = false;
                    });
                } else {
                    _this10.VaultOperationsService.updateDeliveryShipment(shipments).then(function () {
                        modal.close();
                        _this10.getDeliveryShipmentList();
                    }).catch(function (err) {
                        modal.close();
                        _this10.Modal.errorModal('error.' + err.data.message);
                    }).finally(function () {
                        $scope.model.loading = false;
                    });
                }
            }, function (_ref8) {
                var modal = _ref8.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'convertToCrv',
        value: function convertToCrv(shipment) {
            var _this11 = this;

            this.UsersService.checkSupervisor(this.model.loggedInUser).then(function (userInfo) {
                _this11.Modal.convertToCrv(shipment, !userInfo.supervisor, true, function (_ref9) {
                    var supervisor = _ref9.supervisor,
                        trackingIdResidual = _ref9.trackingIdResidual,
                        modal = _ref9.modal;

                    if (trackingIdResidual) {
                        return _this11.HoldService.convertToCRV(shipment.branchId, shipment.trackingId, trackingIdResidual, userInfo.supervisor ? userInfo.id : supervisor).then(function () {
                            _this11.getDeliveryShipmentList();
                        }).catch(function (err) {
                            if (err && err.data && err.data.message) {
                                _this11.Modal.errorModal('error.' + err.data.message);
                            }
                        }).finally(function () {
                            modal.close();
                        });
                    } else {
                        if (modal) modal.close();
                    }
                }, function (_ref10) {
                    var modal = _ref10.modal;

                    if (modal) modal.close();
                });
            }).catch(function (err) {
                _this11.Modal.errorModal(err.data.message);
            });
        }
    }, {
        key: 'convertToCrvPackableOrder',
        value: function convertToCrvPackableOrder(shipment) {
            var _this12 = this;

            if (this.isLoading) return;
            this.isLoading = true;
            this.Modal.confirm({
                header: 'Confirm CRV Conversion',
                message: 'Are you sure you want to convert this Shipment to CRV?',
                callback: function callback(_ref11) {
                    var modal = _ref11.modal,
                        $scope = _ref11.$scope;

                    modal.close();
                    _this12.UsersService.checkSupervisor(_this12.model.loggedInUser).then(function (userInfo) {
                        _this12.Modal.confirmSupervisor('shipment-hold-convert-CRV', { trackingId: shipment.trackingId }, function (_ref12) {
                            var supModal = _ref12.modal,
                                supId = _ref12.supId;

                            supModal.close();
                            var defer = _this12.$q.defer();
                            _this12.HoldService.convertToCrvPackableOrder(shipment.branchId, shipment.trackingId, shipment.packableOrderShipmentId, supId).then(function (data) {
                                var totals = _this12.DataCounter.getCounterForItemHold();
                                _this12.DataCounter.setCounterForItemHold(totals - 1);
                                defer.resolve(data);
                            }).catch(function (err) {
                                if (err && err.data && err.data.message) {
                                    _this12.isLoading = false;
                                    _this12.Modal.errorModal('error.' + err.data.message);
                                }
                            });

                            defer.promise.then(function () {
                                _this12.isLoading = false;
                                _this12.loadData();
                            });
                        }, function (_ref13) {
                            var supModal = _ref13.modal;

                            supModal.close();
                            _this12.isLoading = false;
                        });
                    }).catch(function (err) {
                        _this12.Modal.errorModal(err.data.message);
                        _this12.isLoading = false;
                    });
                },
                negative: function negative(_ref14) {
                    var modal = _ref14.modal,
                        $scope = _ref14.$scope;

                    modal.close();
                    _this12.isLoading = false;
                }
            });
        }
    }, {
        key: 'removeHoldShipment',
        value: function removeHoldShipment(shipment, stats) {
            var _this13 = this;

            this.isRemovingFromHold = true;
            this.Modal.confirmSupervisor('remove-from-hold', { trackingId: shipment.trackingId }, function (_ref15) {
                var modal = _ref15.modal,
                    supId = _ref15.supId;

                _this13.VaultOperationsService.removeHoldShipment(shipment.trackingId, supId, shipment.branchId).then(function () {
                    if (stats === 'Deliveries') {
                        _this13.filterDeliveries();
                    } else if (stats === 'Pickups') {
                        _this13.filterPickupShipment();
                    }
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        return _this13.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this13.isRemovingFromHold = false;
                    modal.close();
                });
            }, function (_ref16) {
                var modal = _ref16.modal;

                if (modal) modal.close();
                _this13.isRemovingFromHold = false;
            });
        }
    }, {
        key: 'convertToBagoutablePickup',
        value: function convertToBagoutablePickup(shipment) {
            var _this14 = this;

            if (this.isConvertingToBagout) return;
            this.isConvertingToBagout = true;

            this.Modal.confirmSupervisor('send-to-bagout', { trackingId: shipment.trackingId }, function (_ref17) {
                var modal = _ref17.modal,
                    supId = _ref17.supId;

                _this14.VaultOperationsService.convertToBagoutablePickup(shipment.trackingId).then(function () {
                    modal.close();
                    _this14.getDeliveryShipmentList();
                    _this14.getPickupShipmentList();
                }).catch(function (err) {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        _this14.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this14.isConvertingToBagout = false;
                });
            }, function (_ref18) {
                var modal = _ref18.modal;

                if (modal) modal.close();
                _this14.isConvertingToBagout = false;
            });
        }
    }, {
        key: 'convertToPickup',
        value: function convertToPickup(shipment) {
            var _this15 = this;

            if (this.isConvertingToPickup) return;
            this.isConvertingToPickup = true;

            this.Modal.confirmSupervisor('convert-to-pickup', { trackingId: shipment.trackingId }, function (_ref19) {
                var modal = _ref19.modal,
                    supId = _ref19.supId;

                _this15.VaultOperationsService.convertToPickup(shipment.trackingId, shipment.branchId, shipment.routeId, supId, _this15.formatDate(shipment.vaultDate)).then(function () {
                    modal.close();
                    _this15.getDeliveryShipmentList();
                    _this15.getPickupShipmentList();
                }).catch(function (err) {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        _this15.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this15.isConvertingToPickup = false;
                });
            }, function (_ref20) {
                var modal = _ref20.modal;

                if (modal) modal.close();
                _this15.isConvertingToPickup = false;
            });
        }
    }, {
        key: 'branchTransfer',
        value: function branchTransfer(shipment, stats) {
            var _this16 = this;

            var defer = this.$q.defer();
            this.Modal.branchTransferModal(shipment, function (_ref21) {
                var modal = _ref21.modal,
                    selectedBranch = _ref21.selectedBranch,
                    comment = _ref21.comment,
                    supervisorId = _ref21.supervisorId,
                    selectedRoute = _ref21.selectedRoute,
                    selectedDate = _ref21.selectedDate,
                    fromBranchId = _ref21.fromBranchId;

                _this16.ShipmentService.branchTransfer(selectedBranch, shipment.trackingId, shipment.routeId, shipment.vaultDate, supervisorId, comment, selectedRoute, selectedDate, fromBranchId).then(function (data) {
                    if (stats === 'Deliveries') {
                        _this16.getDeliveryShipmentList();
                    } else if (stats === 'Pickups') {
                        _this16.getPickupShipmentList();
                    }
                    defer.resolve();
                    modal.close();
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        _this16.Modal.errorModal('error.' + err.data.message);
                    }
                    defer.reject();
                    modal.close();
                });
            }, function (_ref22) {
                var modal = _ref22.modal;

                modal.close();
            });
            return defer.promise;
        }

        // -------------------------------------------Delivery Shipment Logic section End------------------------------------------------ //

        // -------------------------------------------Pickup/Residual Shipment Logic section Start------------------------------------------------ //

    }, {
        key: 'getPickupShipmentList',
        value: function getPickupShipmentList() {
            var _this17 = this;

            setTimeout(function () {
                var startDate = _this17.getStartDate();
                var endDate = _this17.getEndDate();
                var branches = _this17.getSelectedBranches();

                _this17.model.residualShipmentObj.gettingResidualShipment = true;

                _this17.VaultOperationsService.getPickupShipmentList(_this17.model.residualShipmentObj.searchText, startDate, endDate, (_this17.model.residualShipmentObj.pagination.page - 1) * _this17.model.residualShipmentObj.pagination.pageLimit, _this17.model.residualShipmentObj.pagination.pageLimit, _this17.model.residualShipmentObj.reverseSort, _this17.model.residualShipmentObj.sortColumn, _this17.model.timezone, branches).then(function (data) {
                    _this17.model.residualShipmentObj.pagination.total = data.totalRecords;
                    _this17.model.residualShipmentObj.results = data.results;
                    _this17.model.residualShipmentObj.totalRecords = data.totalRecords;
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        _this17.Modal.errorModal(err.data.message);
                    }
                }).finally(function () {
                    _this17.model.residualShipmentObj.gettingResidualShipment = false;
                    _this17.focusFirstAvailableSearch();
                });
            });
        }
    }, {
        key: 'sortPickupShipmentData',
        value: function sortPickupShipmentData(column, event) {
            this.model.residualShipmentObj.reverseSort = this.model.residualShipmentObj.sortColumn == column ? !this.model.residualShipmentObj.reverseSort : false;
            this.model.residualShipmentObj.sortColumn = column;
            this.getPickupShipmentList();
            event.preventDefault();
        }
    }, {
        key: 'filterPickupShipment',
        value: function filterPickupShipment() {
            this.model.residualShipmentObj.pagination.page = 1;
            this.getPickupShipmentList();
        }
    }, {
        key: 'makeDeliverablePickup',
        value: function makeDeliverablePickup(shipment) {
            var _this18 = this;

            shipment.date = shipment.vaultDate;
            this.Modal.makeDeliverable(shipment, function (_ref23) {
                var modal = _ref23.modal,
                    routeId = _ref23.routeId,
                    vaultDate = _ref23.vaultDate;

                _this18.ShipmentService.makeDeliverable(shipment.trackingId, routeId, vaultDate, _this18.User.getUser().id, shipment.branchId).then(function () {
                    modal.close();
                    _this18.getPickupShipmentList();
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        _this18.Modal.errorModal(err.data.message);
                    }
                });
            }, function (_ref24) {
                var modal = _ref24.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'transferPickupToRoute',
        value: function transferPickupToRoute(shipment) {
            var _this19 = this;

            this.Modal.shipmentNotPickedUp(shipment, function (_ref25) {
                var modal = _ref25.modal;

                modal.close();
                _this19.getPickupShipmentList();
            }, function (_ref26) {
                var modal = _ref26.modal;

                if (modal) modal.close();
            }, true);
        }
    }, {
        key: 'markAsCheckedIn',
        value: function markAsCheckedIn(shipment) {
            var _this20 = this;

            this.Modal.confirmSupervisor('mark-as-checked-in', shipment.trackingId, function (_ref27) {
                var modal = _ref27.modal,
                    supId = _ref27.supId;

                _this20.HoldService.shipmentHoldMarkCheckedIn(shipment.trackingId, supId, shipment.branchId, shipment.routeId).then(function () {
                    modal.close();
                    _this20.filterPickupShipment();
                }).catch(function (err) {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        return _this20.Modal.errorModal('error.' + err.data.message);
                    }
                });
            }, function (_ref28) {
                var modal = _ref28.modal;

                modal.close();
            });
        }
    }, {
        key: 'shiftBranch',
        value: function shiftBranch(userId, selectedBranch) {
            var _this21 = this;

            var obj = {
                id: userId,
                branchId: selectedBranch
            };

            return this.UsersService.updateUserBranch(obj.id, obj).then(function (data) {
                _this21.User.setUser(data);
            });
        }
    }, {
        key: 'markUndelivered',
        value: function markUndelivered(shipmentObj) {
            var _this22 = this;

            this.Modal.confirmSupervisor('mark-as-undelivered', shipmentObj.trackingId, function (_ref29) {
                var modal = _ref29.modal,
                    supId = _ref29.supId;

                _this22.VaultOperationsService.shipmentMarkUndelivered(shipmentObj.trackingId, shipmentObj.routeId, supId, shipmentObj.branchId, shipmentObj.loadedAmount, shipmentObj.amount).then(function () {
                    modal.close();
                    _this22.filterDeliveries();
                }).catch(function (err) {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        return _this22.Modal.errorModal('error.' + err.data.message);
                    }
                });
            }, function (_ref30) {
                var modal = _ref30.modal;

                modal.close();
            });
        }
    }, {
        key: 'editPickupShipmentModal',
        value: function editPickupShipmentModal(shipmentObj) {
            var _this23 = this;

            var branchTimezone = this.model.timezone || this.model.setupDetails.timezone;

            this.Modal.editPickupShipment(shipmentObj, branchTimezone, function (_ref31) {
                var modal = _ref31.modal,
                    shipments = _ref31.shipments,
                    $scope = _ref31.$scope;


                delete shipments.amount;
                delete shipments.deliveryTime;
                delete shipments.deliveryDate;
                delete shipments.vaultDate;
                delete shipments.loadedAmount;
                delete shipments.selectedRoute;
                delete shipments.selectedShipType;
                delete shipments.pickupDate;
                delete shipments.pickupTime;

                shipments.currentTimezone = _this23.model.timezone;

                $scope.model.loading = true;
                _this23.VaultOperationsService.updatePickupShipment(shipments).then(function () {
                    modal.close();
                    _this23.getPickupShipmentList();
                }).catch(function (err) {
                    modal.close();
                    _this23.Modal.errorModal('error.' + err.data.message);
                }).finally(function () {
                    $scope.model.loading = false;
                });
            }, function (_ref32) {
                var modal = _ref32.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'shipmentCheckIn',
        value: function shipmentCheckIn(shipment) {
            var _this24 = this;

            var trackingId = shipment.trackingId;
            this.Modal.confirmSupervisor('shipment-check-in', { trackingId: trackingId }, function (_ref33) {
                var modal = _ref33.modal,
                    supId = _ref33.supId;

                modal.close();

                _this24.Modal.confirm({
                    header: _this24.$translate.instant('common.confirm_title'),
                    message: _this24.$translate.instant('vaultOperations.confirm_shipment_check_in', { trackingId: trackingId }),
                    callback: function callback(_ref34) {
                        var modal = _ref34.modal;

                        return _this24.VaultOperationsService.shipmentCheckIn(shipment.branchId, trackingId, shipment.routeId, supId, _this24.formatDate(shipment.vaultDate)).then(function () {
                            modal.close();
                            _this24.filterPickupShipment();
                        }).catch(function (err) {
                            modal.close();
                            if (err && err.data && err.data.message) {
                                return _this24.Modal.errorModal('error.' + err.data.message);
                            }
                        });
                    },
                    type: 'success'
                });
            }, function (_ref35) {
                var modal = _ref35.modal;

                modal.close();
            });
        }
    }, {
        key: 'shipmentCheckInDelivery',
        value: function shipmentCheckInDelivery(shipment) {
            var _this25 = this;

            var trackingId = shipment.trackingId;
            this.Modal.confirmSupervisor('shipment-check-in-delivery', { trackingId: trackingId, showConvertToPickup: true }, function (_ref36) {
                var modal = _ref36.modal,
                    supId = _ref36.supId,
                    convertToPickup = _ref36.convertToPickup;

                modal.close();

                _this25.Modal.confirm({
                    header: _this25.$translate.instant('common.confirm_title'),
                    message: _this25.$translate.instant('vaultOperations.confirm_shipment_check_in', { trackingId: trackingId }),
                    callback: function callback(_ref37) {
                        var modal = _ref37.modal;

                        return _this25.VaultOperationsService.shipmentCheckInDelivery(shipment.branchId, trackingId, shipment.routeId, supId, _this25.formatDate(shipment.vaultDate), convertToPickup).then(function () {
                            modal.close();
                            _this25.filterDeliveries();
                            if (convertToPickup) {
                                _this25.filterPickupShipment();
                            }
                        }).catch(function (err) {
                            modal.close();
                            _this25.loadingDeliveries = false;
                            _this25.filterDeliveries();
                            return _this25.Modal.errorModal(err.data.message);
                        });
                    },
                    type: 'success'
                });
            }, function (_ref38) {
                var modal = _ref38.modal;

                modal.close();
            });
        }
    }, {
        key: 'isManualCheckoutBlocked',
        value: function isManualCheckoutBlocked(shipment) {
            var isBatchShipment = shipment && shipment.batchId && !shipment.orderNo;
            return !!(shipment && shipment.coinFlag && !shipment.coinDebited && !isBatchShipment);
        }
    }, {
        key: 'shipmentCheckOut',
        value: function shipmentCheckOut(shipment) {
            var _this26 = this;

            if (this.isManualCheckoutBlocked(shipment)) {
                return this.Modal.errorModal('error.E_COIN_MANUAL_CHECKOUT_NOT_ALLOWED');
            }

            var trackingId = shipment.trackingId;
            this.Modal.confirmSupervisor('shipment-check-out', { trackingId: trackingId }, function (_ref39) {
                var modal = _ref39.modal,
                    supId = _ref39.supId;

                modal.close();

                _this26.Modal.confirm({
                    header: _this26.$translate.instant('common.confirm_title'),
                    message: _this26.$translate.instant('vaultOperations.confirm_shipment_check_out', { trackingId: trackingId }),
                    callback: function callback(_ref40) {
                        var modal = _ref40.modal;

                        return _this26.VaultOperationsService.shipmentCheckOut(shipment.branchId, shipment.trackingId, shipment.routeId, supId, _this26.formatDate(shipment.vaultDate)).then(function () {
                            modal.close();
                            _this26.filterDeliveries();
                        }).catch(function (err) {
                            modal.close();
                            if (err && err.data && err.data.message) {
                                return _this26.Modal.errorModal('error.' + err.data.message);
                            }
                        });
                    },
                    type: 'success'
                });
            }, function (_ref41) {
                var modal = _ref41.modal;

                modal.close();
            });
        }
    }, {
        key: 'formatDate',
        value: function formatDate(date) {
            if (!date) return;
            return this.DateUtil.getUTCDate(date);
        }
    }, {
        key: 'releaseItem',
        value: function releaseItem(shipment, stats) {
            var _this27 = this;

            var trackingId = shipment.trackingId;

            this.UsersService.checkSupervisor(this.model.loggedInUser).then(function (userInfo) {
                _this27.Modal.holdReleases(shipment, !userInfo.supervisor, function (_ref42) {
                    var supervisorId = _ref42.supervisorId,
                        comment = _ref42.comment,
                        shipmentAssignedTo = _ref42.shipmentAssignedTo,
                        selectedDate = _ref42.selectedDate,
                        routeInfo = _ref42.routeInfo,
                        modal = _ref42.modal;

                    var date = moment(selectedDate).format('YYYY-MM-DD');

                    _this27.ShipmentService.holdRelease(trackingId, shipment.routeId, shipmentAssignedTo, date, userInfo.supervisor ? userInfo.id : supervisorId, comment, shipment.branchId).then(function () {
                        modal.close();
                        if (stats === 'Deliveries') {
                            _this27.filterDeliveries();
                        } else if (stats === 'Pickups') {
                            _this27.filterPickupShipment();
                        }
                    }).catch(function (err) {
                        if (err && err.data && err.data.message) {
                            return _this27.Modal.errorModal("error." + err.data.message);
                        }
                    }).finally(function () {
                        modal.close();
                    });
                }, function (_ref43) {
                    var modal = _ref43.modal;

                    if (modal) modal.close();
                });
            }).catch(function (err) {
                _this27.Modal.errorModal(err.data.message);
            });
        }
    }, {
        key: 'getSelectedBranches',
        value: function getSelectedBranches() {
            return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map(function (branch) {
                return branch.branchId;
            }) : null;
        }
    }, {
        key: 'canReleaseForCount',
        value: function canReleaseForCount(shipment) {
            return !!(shipment && shipment.holdFlag && shipment.canReleaseForCount === 1);
        }
    }, {
        key: 'isParentResidualPickup',
        value: function isParentResidualPickup(shipment) {
            return !!(shipment && !shipment.bagSeal && !shipment.isRequiredPickup && !shipment.isParentDelivery && shipment.orderNo);
        }
    }, {
        key: 'releaseForCount',
        value: function releaseForCount(shipment) {
            var _this28 = this;

            if (this.model.loading) return;
            this.model.loading = true;

            this.Modal.confirmSupervisor('release-for-count', shipment.trackingId, function (_ref44) {
                var modal = _ref44.modal,
                    supId = _ref44.supId;

                var defaultComment = 'Released for count';
                _this28.HoldService.releaseForCount(shipment.trackingId, shipment.routeId, supId, defaultComment).then(function () {
                    modal.close();
                    _this28.filterPickupShipment();
                    _this28.model.loading = false;
                }).catch(function (err) {
                    modal.close();
                    _this28.model.loading = false;
                    if (err && err.data && err.data.message) {
                        return _this28.Modal.errorModal('error.' + err.data.message);
                    }
                });
            }, function (_ref45) {
                var modal = _ref45.modal;

                if (modal) modal.close();
                _this28.model.loading = false;
            });
        }

        // -------------------------------------------Pickup/Residual Shipment Logic section End------------------------------------------------ //

    }, {
        key: 'restrictShipmentUpdate',
        value: function restrictShipmentUpdate(shipmentVaultDate, branchCurrentVaultDate) {
            return moment(shipmentVaultDate).isBefore(branchCurrentVaultDate);
        }
    }, {
        key: 'softDeleteShipment',
        value: function softDeleteShipment(shipment, stats) {
            var _this29 = this;

            if (this.isSoftDeleting) return;
            this.isSoftDeleting = true;

            this.Modal.deletedReason(shipment, function (_ref46) {
                var supervisorId = _ref46.supervisorId,
                    reason = _ref46.reason,
                    modal = _ref46.modal;

                _this29.ShipmentService.softDeleteShipment(shipment.shipmentId, shipment.branchId, reason, supervisorId).then(function () {
                    modal.close();
                    if (stats === 'Deliveries') _this29.filterDeliveries();else if (stats === 'Pickups') _this29.filterPickupShipment();
                }).catch(function (err) {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        _this29.Modal.errorModal('error.' + err.data.message);
                    }
                }).finally(function () {
                    _this29.isSoftDeleting = false;
                });
            }, function (_ref47) {
                var modal = _ref47.modal;

                if (modal) modal.close();
                _this29.isSoftDeleting = false;
            });
        }
    }, {
        key: 'markUndeliveredWithCRV',
        value: function markUndeliveredWithCRV(shipmentObj) {
            var _this30 = this;

            if (!shipmentObj.orderType) {
                this.Modal.confirmSupervisor('mark-as-undelivered', { trackingId: shipmentObj.trackingId }, function (_ref48) {
                    var modal = _ref48.modal,
                        supId = _ref48.supId;

                    modal.close();

                    // Process undelivered directly for COD
                    _this30.VaultOperationsService.shipmentMarkUndelivered(shipmentObj.trackingId, shipmentObj.routeId, supId, shipmentObj.branchId, shipmentObj.loadedAmount, shipmentObj.amount, shipmentObj.reason, shipmentObj.fromLocationId, shipmentObj.toLocationId, shipmentObj.qty, shipmentObj.shiptypeId).then(function () {
                        _this30.getDeliveryShipmentList();
                    }).catch(function (err) {
                        if (err && err.data && err.data.message) {
                            return _this30.Modal.errorModal('error.' + err.data.message);
                        }
                    });
                }, function (_ref49) {
                    var modal = _ref49.modal;

                    modal.close();
                });
                return;
            }

            this.Modal.markUndeliveredWithCRV(shipmentObj, function (_ref50) {
                var modal = _ref50.modal,
                    convertToCRV = _ref50.convertToCRV,
                    $scope = _ref50.$scope,
                    reason = _ref50.reason;

                shipmentObj.reason = reason;
                _this30.checkAndCallSupervisor(shipmentObj, convertToCRV).then(function (obj) {
                    if (!convertToCRV) {
                        return _this30.markShipmentAsUndelivered(shipmentObj, obj.supId).then(function () {
                            modal.close();
                            _this30.getDeliveryShipmentList();
                        });
                    }

                    return _this30.converToCRVAndMarkAsUndelivered(shipmentObj, modal);
                }).catch(function (err) {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        return _this30.Modal.errorModal('error.' + err.data.message);
                    }
                });
            }, function (_ref51) {
                var modal = _ref51.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'markShipmentAsUndelivered',
        value: function markShipmentAsUndelivered(shipmentObj, supId) {
            return this.VaultOperationsService.shipmentMarkUndelivered(shipmentObj.trackingId, shipmentObj.routeId, supId, shipmentObj.branchId, shipmentObj.loadedAmount, shipmentObj.amount, shipmentObj.reason, shipmentObj.fromLocationId, shipmentObj.toLocationId, shipmentObj.qty, shipmentObj.shiptypeId);
        }
    }, {
        key: 'converToCRVAndMarkAsUndelivered',
        value: function converToCRVAndMarkAsUndelivered(shipmentObj, markUndeliveredWithCRVModal) {
            var _this31 = this;

            this.Modal.convertToCrv(shipmentObj, true, false, function (_ref52) {
                var supervisor = _ref52.supervisor,
                    trackingIdResidual = _ref52.trackingIdResidual,
                    modal = _ref52.modal;

                return _this31.markShipmentAsUndelivered(shipmentObj, supervisor).then(function () {
                    return _this31.HoldService.convertToCRV(shipmentObj.branchId, shipmentObj.trackingId, trackingIdResidual, supervisor);
                }).catch(function (err) {
                    if (err && err.data && err.data.message) {
                        _this31.Modal.errorModal('error.' + err.data.message);
                    }
                }).finally(function () {
                    modal.close();
                    if (markUndeliveredWithCRVModal) markUndeliveredWithCRVModal.close();
                    _this31.getDeliveryShipmentList();
                });
            }, function (_ref53) {
                var modal = _ref53.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'checkAndCallSupervisor',
        value: function checkAndCallSupervisor(shipments, convertToCRV) {
            var defer = this.$q.defer();

            var needSupervisor = true;
            if (convertToCRV) needSupervisor = false;

            if (needSupervisor) {
                this.Modal.confirmSupervisor('mark-as-undelivered', { trackingId: shipments.trackingId }, function (_ref54) {
                    var modal = _ref54.modal,
                        supId = _ref54.supId;

                    modal.close();
                    defer.resolve({ needSupervisor: needSupervisor, supId: supId });
                }, function (_ref55) {
                    var modal = _ref55.modal;

                    modal.close();
                    defer.reject({ needSupervisor: needSupervisor });
                });
            } else {
                defer.resolve({ needSupervisor: needSupervisor });
            }

            return defer.promise;
        }
    }, {
        key: 'isPastVaultDate',
        value: function isPastVaultDate(routeDate, branchCurrentVaultDate) {
            return moment(routeDate).isSame(branchCurrentVaultDate);
        }
    }, {
        key: 'undoCheckInTime',
        value: function undoCheckInTime(obj) {
            var _this32 = this;

            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_title'),
                message: this.$translate.instant('vaultOperations.confirm_undo_check_in_time', { routeId: obj.routeId }),
                callback: function callback(_ref56) {
                    var modal = _ref56.modal;

                    _this32.VaultOperationsService.undoCheckInTime(obj.routeId, _this32.formatDate(obj.routeDate), obj.branchId).then(function () {
                        modal.close();
                        _this32.getRouteList();
                    }).catch(function (err) {
                        modal.close();
                        if (err && err.data && err.data.message) {
                            _this32.Modal.errorModal(err.data.message);
                        }
                    });
                },
                type: 'danger'
            }, function (_ref57) {
                var modal = _ref57.modal;

                modal.close();
            });
        }
    }, {
        key: 'getSoftDeleteShipmentPermission',
        value: function getSoftDeleteShipmentPermission() {
            var _this33 = this;

            this.UsersService.validateUserPermissions(this.User.getUser().firstName, this.User.getUser().lastName).then(function (permissions) {
                _this33.hasSoftDeleteShipmentPermission = permissions.hasSoftDeleteShipmentPermission || _this33.CommonLayoutService.isAllowToAccessPages();
            }).catch(function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'isShipmentCounted',
        value: function isShipmentCounted(shipment) {
            return shipment && shipment.countCompletedAt;
        }
    }, {
        key: 'rescheduleDeliveries',
        value: function rescheduleDeliveries(routeObj) {
            var _this34 = this;

            this.Modal.rescheduleDeliveries(routeObj, function (_ref58) {
                var modal = _ref58.modal,
                    routeId = _ref58.routeId,
                    vaultDate = _ref58.vaultDate,
                    shipments = _ref58.shipments,
                    supervisorId = _ref58.supervisorId;

                _this34.VaultOperationsService.rescheduleRouteDeliveries(routeObj.routeId, _this34.formatDate(routeObj.routeDate), routeId, vaultDate, routeObj.branchId, 'Rescheduled Delivery to Route ' + routeId + ' on ' + vaultDate, shipments, supervisorId).then(function (res) {
                    modal.close();
                    if (res.status) {
                        _this34.Modal.successModal({
                            header: 'Success',
                            message: res.message,
                            buttons: ['common.ok'],
                            callback: function callback(_ref59) {
                                var successModal = _ref59.modal;

                                successModal.close();
                                _this34.getRouteList();
                            },
                            negative: function negative(_ref60) {
                                var successModal = _ref60.modal;

                                successModal.close();
                                _this34.getRouteList();
                            }
                        });
                    } else {
                        _this34.Modal.errorModal('error.' + res.message);
                    }
                }).catch(function (err) {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        _this34.Modal.errorModal('error.' + err.data.message);
                    }
                });
            }, function (_ref61) {
                var modal = _ref61.modal;

                if (modal) modal.close();
            });
        }
    }, {
        key: 'markAllDelivered',
        value: function markAllDelivered(routeObj) {
            var _this35 = this;

            this.Modal.markAllDeliveredListModal(routeObj.routeId, this.formatDate(routeObj.routeDate), routeObj.branchId, this.VaultOperationsService, function (_ref62) {
                var listModal = _ref62.modal,
                    shipments = _ref62.shipments;

                listModal.close();

                _this35.Modal.confirmSupervisor('mark-all-delivered', { routeId: routeObj.routeId }, function (_ref63) {
                    var supervisorModal = _ref63.modal,
                        supId = _ref63.supId;

                    _this35.loading = true;
                    _this35.VaultOperationsService.markAllDelivered(routeObj.branchId, routeObj.routeId, _this35.formatDate(routeObj.routeDate), supId).then(function () {
                        _this35.getRouteList();
                        _this35.getDeliveryShipmentList();
                        supervisorModal.close();
                    }).catch(function (err) {
                        if (err && err.data && err.data.message) {
                            _this35.Modal.errorModal('error.' + err.data.message);
                        } else {
                            _this35.Modal.errorModal('An error occurred while marking all as delivered.');
                        }
                        supervisorModal.close();
                    }).finally(function () {
                        _this35.loading = false;
                    });
                }, function (_ref64) {
                    var supervisorModal = _ref64.modal;

                    if (supervisorModal) supervisorModal.close();
                });
            }, function (_ref65) {
                var listModal = _ref65.modal;

                if (listModal) listModal.close();
            });
        }
    }]);
    return VaultOperationsController;
}();

exports.default = VaultOperationsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _verify_2FA_code = __webpack_require__(2387);

var _verify_2FA_code2 = _interopRequireDefault(_verify_2FA_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var verify2FACodeModule = angular.module('verify2FACode', []).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/verify');

  $stateProvider.state('verify_2FA_code', {
    url: '/verify',
    component: 'verify2FACode',
    data: {
      requireLogin: false
    },
    params: {
      userId: null
    }
  });
}]).component('verify2FACode', _verify_2FA_code2.default).name;

exports.default = verify2FACodeModule;

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _verify_2FA_code = __webpack_require__(2894);

var _verify_2FA_code2 = _interopRequireDefault(_verify_2FA_code);

var _verify_2FA_code3 = __webpack_require__(2388);

var _verify_2FA_code4 = _interopRequireDefault(_verify_2FA_code3);

__webpack_require__(3163);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var verify2FACodeComponent = {
  restrict: 'E',
  bindings: {},
  template: _verify_2FA_code2.default,
  controller: _verify_2FA_code4.default
};

exports.default = verify2FACodeComponent;

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(10);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginController = function () {
  /*@ngInject*/
  LoginController.$inject = ["Auth", "User", "$state", "$stateParams", "$location", "$translate", "UsersService", "$cookies"];
  function LoginController(Auth, User, $state, $stateParams, $location, $translate, UsersService, $cookies) {
    (0, _classCallCheck3.default)(this, LoginController);

    this.Auth = Auth;
    this.User = User;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.UsersService = UsersService;
    this.$cookies = $cookies;

    if (Auth.isAuthenticated()) {
      this.$state.go('home');
    }
    this.$translate = $translate;

    this.model = {
      successMessage: null,
      errorMessage: null
    };
  }

  (0, _createClass3.default)(LoginController, [{
    key: '$onInit',
    value: function $onInit() {
      if (!this.$stateParams.userId) {
        return this.$state.go('login');
      }
      this.send2FACode();
    }
  }, {
    key: 'send2FACode',
    value: function send2FACode() {
      var _this = this;

      this.model.loading = true;
      this.model.code = null;
      this.UsersService.send2FACode(this.$stateParams.userId).then(function (data) {
        delete _this.model.errorMessage;
        _this.model.successMessage = data.message;
      }).catch(function (err) {
        delete _this.model.successMessage;
        _this.model.errorMessage = err.data.message;
      }).finally(function () {
        _this.model.loading = false;
        document.getElementById('code2FA').focus();
      });
    }
  }, {
    key: 'verify2FACode',
    value: function verify2FACode() {
      var _this2 = this;

      this.model.loading = true;
      this.UsersService.verify2FACode(this.$stateParams.userId, this.model.code).then(function (data) {
        _this2.$cookies.putObject('user', data);
        localStorage.setItem('user', data.id);
        localStorage.setItem('loginTime', new Date().getTime());
        localStorage.setItem('email', data.email);
        localStorage.setItem('name', data.name);
        _this2.User.setUser(data);
        _this2.$translate.use(data.languageId.id || data.languageId);

        if ((0, _keys2.default)(_this2.User.getPrevState()).length > 0) {
          var _data = _this2.User.getPrevState();
          var url = _data['hash'];
          _this2.User.setPrevState('');
          _this2.$location.path(url.substr(2));
        } else {
          _this2.$state.go('home');
        }
      }).catch(function (err) {
        delete _this2.model.successMessage;
        _this2.model.errorMessage = err.data.message;
      }).finally(function () {
        _this2.model.loading = false;
      });
    }
  }]);
  return LoginController;
}();

exports.default = LoginController;

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AppConfig.$inject = ["$httpProvider", "$stateProvider", "$locationProvider", "$urlRouterProvider", "$translateProvider", "cfpLoadingBarProvider", "IdleProvider", "KeepaliveProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth = __webpack_require__(2391);

var _auth2 = _interopRequireDefault(_auth);

var _language = __webpack_require__(531);

var _language2 = _interopRequireDefault(_language);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AppConfig($httpProvider, $stateProvider, $locationProvider, $urlRouterProvider, $translateProvider, cfpLoadingBarProvider, IdleProvider, KeepaliveProvider) {
  'ngInject';

  cfpLoadingBarProvider.includeSpinner = false;
  cfpLoadingBarProvider.includeBar = true;

  $locationProvider.html5Mode(true);
  $httpProvider.interceptors.push(_auth2.default);

  var languageMapping = {
    en: 'E',
    es: 'S'
  };

  // $stateProvider
  // .state('app', {
  //   abstract: true,
  //   templateUrl: 'layout/app-view.html',
  //   resolve: {
  //     auth: function(User) {
  //       debugger;
  //       return User.verifyAuth();
  //     }
  //   }
  // })

  $urlRouterProvider.otherwise('/app/home');

  // Install all the languages
  $translateProvider.useLoader('LanguageLoaderService');
  $translateProvider.forceAsyncReload(true);
  $translateProvider.useSanitizeValueStrategy('');

  // Detect Browser language and set as default
  var browserLanguage = navigator.language || navigator.browserLanguage;

  if (browserLanguage) {
    browserLanguage = browserLanguage.split('-')[0];
    $translateProvider.preferredLanguage(languageMapping[browserLanguage]);
  } else {
    $translateProvider.preferredLanguage(languageMapping.en);
  }

  IdleProvider.timeout(10);
  IdleProvider.autoResume(true);
  KeepaliveProvider.interval(10);

  var sessionLength = JSON.parse(localStorage.getItem('sessionLength'));
  if (sessionLength) {
    IdleProvider.idle(sessionLength * 60);
  }
}

exports.default = AppConfig;

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AppRun.$inject = ["AppConstants", "$rootScope", "$transitions", "$location", "$cookies", "User", "$uiRouter", "$translate", "cfpLoadingBar", "UserService", "Auth", "Configs", "Idle", "Keepalive", "Modal", "$state", "UsersService", "$timeout"];
Object.defineProperty(exports, "__esModule", {
  value: true
});


function AppRun(AppConstants, $rootScope, $transitions, $location, $cookies, User, $uiRouter, $translate, cfpLoadingBar, UserService, Auth, Configs, Idle, Keepalive, Modal, $state, UsersService, $timeout) {
  'ngInject';

  $transitions.onStart({}, function (transition) {
    cfpLoadingBar.start();
  });

  $transitions.onSuccess({}, function (transition) {
    cfpLoadingBar.complete();
  });

  $transitions.onSuccess({}, function (transition) {
    $timeout(function () {
      var searchInput = document.querySelector('.navbar-form.navbar-right input[type="text"].form-control');
      if (searchInput) {
        searchInput.focus();
      }
    }, 100);
  });

  document.addEventListener('click', function (e) {
    setTimeout(function () {
      var openLayer = document.querySelector('.checkboxLayer.show');
      if (!openLayer) return;
      if (openLayer.contains(e.target)) return;
      var openFilter = openLayer.querySelector('.inputFilter');
      if (openFilter && document.activeElement !== openFilter) {
        openFilter.focus();
      }
    }, 50);
  }, true);

  var requiredAuthCriteria = {
    to: function to(state) {
      return state.data && state.data.requireLogin;
    }
  };

  var hasACLCriteria = {
    to: function to(state) {
      return state.data && state.data.requireACL;
    }
  };

  var redirectToLogin = function redirectToLogin(transition) {
    var AuthService = transition.injector().get('Auth');
    var $state = transition.router.stateService;
    var User = transition.injector().get('User');
    if (!AuthService.isAuthenticated()) {
      User.setPrevState(angular.copy(window.location));
      return $state.target('login', undefined);
    }
  };

  var invalidACL = function invalidACL(transition) {

    var acl = transition.to().data.requireACL;

    var User = transition.injector().get('User');
    var UserService = transition.injector().get('UserService');
    var BranchService = transition.injector().get('BranchService');
    var ScanConfigService = transition.injector().get('ScanConfigService');

    var $state = transition.router.stateService;
    var $q = transition.injector().get('$q');
    var requiredACL = transition.to().data.requireACL;

    if (Auth.isAuthenticated()) {
      var userObj = User.getUser();

      if (userObj && userObj.branchId) {
        BranchService.getBranchSetup(userObj.branchId).then(function (data) {
          ScanConfigService.setScanConfig(data.prefixes);
          Configs.setEnvironmentConfig(data.environmentConfig);
        }).catch(function (err) {
          console.log(err);
        });
      }

      if (!User.hasACL()) {
        // const userObj = User.getUser();
        return $q.all([UserService.acl()]
        // BranchService.getBranchSetup(userObj.branchId)
        ).then(function (data) {
          // ScanConfigService.setScanConfig(data[1].prefixes)
          return User.setACL(data[0]);
        }).then(function () {
          if (!User.isAccessible(requiredACL)) {
            return $state.target('access_denied');
          }
        }).catch(function () {
          return $state.target('access_denied');
        });
      } else {
        if (!User.isAccessible(requiredACL)) {
          return $state.target('access_denied');
        }
      }
    }
  };

  $transitions.onBefore(requiredAuthCriteria, redirectToLogin, {
    priority: 10
  });

  $transitions.onBefore(hasACLCriteria, invalidACL, {
    priority: 1
  });

  $rootScope.globals = {
    user: $cookies.getObject('user')
  };

  $rootScope.$on('userChanged', function (evt, user) {
    if (user) {
      $cookies.putObject('user', user);
    } else {
      $cookies.remove('user');
    }
  });
  if ($rootScope.globals.user) {
    User.setUser($rootScope.globals.user);

    UsersService.get($rootScope.globals.user.id).then(function (profile) {
      User.setUser(profile);
      $rootScope.globals.user = profile;
      $cookies.putObject('user', profile);
    }).catch(function (err) {
      console.log("Failed to sync profile status:", err);
    });

    // console.log('user\'s language', $rootScope.globals.user.languageId);
    // If user exist, check user preferred language
    setTimeout(function () {
      $translate.use($rootScope.globals.user.languageId);
    }, 0);
  }
  var sessionLength = JSON.parse(localStorage.getItem('sessionLength'));

  if (sessionLength && Auth.isAuthenticated()) {
    Idle.watch();
  }
  $rootScope.$on('IdleStart', function () {
    Modal.timeoutCountdown('', function (_ref) {
      var modal = _ref.modal;

      modal.close();
    }, function (_ref2) {
      var modal = _ref2.modal;

      if (modal) modal.close();
    });
  });

  $rootScope.$on('IdleTimeout', function () {
    localStorage.removeItem('user');
    localStorage.removeItem('loginTime');
    localStorage.removeItem('email');
    localStorage.removeItem('name');
    localStorage.removeItem('sessionLength');
    $cookies.remove('user');
    User.clearUser();
    Idle.unwatch();
    Auth.logout();
    window.location.href = '/login';
  });

  $rootScope.$on('Keepalive', function () {
    //Keep alive event
  });
}

exports.default = AppRun;

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


authInterceptor.$inject = ["AppConstants", "$window", "$q", "$state", "$cookies", "$rootScope"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
function authInterceptor(AppConstants, $window, $q, $state, $cookies, $rootScope) {
  'ngInject';

  return {
    request: function request(config) {
      return config;
    },

    responseError: function responseError(rejection) {
      // console.log('====', $window.location, rejection )
      if (rejection.status === 401) {
        $window.location.reload();
      } else if (rejection.status === 403) {
        localStorage.clear();
        $cookies.remove("user");
        $cookies.remove("ranger-session");
        $state.go('login');
      } else if (rejection.status === 404 || rejection.status <= 0) {
        $rootScope.$broadcast("ServerError", rejection.status);
      }

      return $q.reject(rejection);
    }

  };
}

exports.default = authInterceptor;

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

var _flat = __webpack_require__(1534);

var _flat2 = _interopRequireDefault(_flat);

var _language = __webpack_require__(531);

var _language2 = _interopRequireDefault(_language);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LanguageLoaderService = function LanguageLoaderService($http, $q, MessageService, User, LanguageService, $translate, ConfigService, Modal, Configs, UsersService, Idle) {

  var DEFAULT_LANGUAGE = 'E';

  return function (options) {
    console.log('fetch language ' + options.key);

    return ConfigService.getConfig().then(function (data) {
      var pageTitle = data.config.pageTitle;
      var companyName = data.config.companyName;
      var printFromLocationName = data.config.printFromLocationName;
      var printFromLocationAddress = data.config.printFromLocationAddress;
      Configs.setEnvironmentConfig(data.config.environmentConfig);
      document.getElementById('pageTitle').innerHTML = pageTitle;

      if (data.config.environmentConfig && data.config.environmentConfig.sessionLength > 0) {
        localStorage.setItem('sessionLength', (0, _stringify2.default)(data.config.environmentConfig.sessionLength));
        if (User.getUser() && User.isSignedIn()) {
          Idle.watch();
          Idle.setIdle(data.config.environmentConfig.sessionLength * 60);
        }
      } else {
        localStorage.removeItem('sessionLength');
        Idle.unwatch();
      }

      if (User.getUser()) {
        var defer = $q.defer();

        $q.all([LanguageService.getAllUIMessages(options.key), UsersService.validateUserPermissions(User.getUser().firstName, User.getUser().lastName)]).then(function (details) {
          var messages = details[0];
          var permissions = details[1];
          Configs.setPermissionConfig(permissions);

          if (!messages || !messages.length) {
            defer.resolve();
            return $translate.use(DEFAULT_LANGUAGE);
          }

          if (!messages || !messages.length) {
            defer.resolve();
            return $translate.use(DEFAULT_LANGUAGE);
          }

          var translation = {};

          messages.forEach(function (message) {
            translation[message.messageId] = message.description;
          });

          return _flat2.default.unflatten(translation);
        }).then(function (translationObj) {
          translationObj['common']['app_name'] = companyName;
          translationObj['bagout_print']['fromLocationName'] = printFromLocationName;
          translationObj['shipmentBatch']['fromLocationName'] = printFromLocationName;
          translationObj['bagout_print']['fromLocationAddress'] = printFromLocationAddress;
          defer.resolve(translationObj);
        }).catch(function (err) {
          defer.reject(err);
          $translate.use(DEFAULT_LANGUAGE);
        });

        return defer.promise;
      } else {
        return $q.when(_language2.default[options.key] || _language2.default[DEFAULT_LANGUAGE]);
      }
    }).catch(function (err) {
      Modal.errorModal(err.data.message);
    });
  };
};

LanguageLoaderService.$inject = ['$http', '$q', 'MessageService', 'User', 'LanguageService', '$translate', 'ConfigService', 'Modal', 'Configs', 'UsersService', 'Idle'];

exports.default = LanguageLoaderService;

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _login, _en;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var en = (_en = {
    //need to edit some of contents

    common: {
        app_name: 'PAI',

        save: 'Save',
        reset: 'Reset',
        id: 'ID',
        description: 'Description',
        ok: 'Ok',
        cancel: 'Cancel',
        yes: 'Yes',
        no: 'No',
        next: 'Next',
        previous: 'Previous',
        search: 'Search',
        delete: 'Delete',

        confirm_delete_title: 'Confirm Delete',
        confirm_delete_message: 'Are you sure you want to delete',

        profile: 'Profile',
        logout: 'Logout',
        none: 'None',
        select: 'select',
        all: 'All',

        side_menu: {
            route_mgmt: 'Route Management',
            route_control: 'Route Control',
            route_throw: 'Route Throw',
            check_in: 'Check In',
            check_out: 'Check Out',
            bag_out: 'Bag Out',
            settings: 'Settings',
            route_sheet: 'Route Sheet',
            route_release: 'Route Release',
            shipment_batch: 'Shipment Batch',
            coin_pull_report: 'Coin Pull Report',
            setup: 'Setup'
        }
    },
    home: {},
    routeSheet: {
        route: 'Route ',
        date: 'Date',
        show: 'Show',
        print: "Print",

        routePlaceHolder: 'Select a route...'
    },
    routeControl: {
        adHocCheckinNoUnassignedRoute: 'No unassigned route found for this branch. Please configure an Unassigned Route in Setup.',
        adHocCheckinTitle: 'Ad-Hoc Check-In | ',
        checkInAction: 'Check In'
    },
    login: (_login = {
        button: 'Login',
        remember_me: 'Remember Me',
        remember_me_message: 'Do not enable this option if you are on a public computer.',
        email: 'Email',
        password: 'Password',

        forgot_password: 'Forgot Password?',
        change_password: 'Change Password?',
        email_placeholder: 'Your e-mail or user name',
        password_placeholder: 'Your password',

        forgot_email_placeholder: 'Enter your e-mail',
        code: 'Code',
        reset_code_placeholder: 'Enter Code'
    }, (0, _defineProperty3.default)(_login, 'password_placeholder', 'Enter password'), (0, _defineProperty3.default)(_login, 'confirm_password', 'Confirm Password'), (0, _defineProperty3.default)(_login, 'confirm_password_placeholder', 'Enter confirm password'), (0, _defineProperty3.default)(_login, 'reset_request_success', 'Password reset successfully, Please try to login now!'), (0, _defineProperty3.default)(_login, 'forgot_password_label', 'Forgot Password'), (0, _defineProperty3.default)(_login, 'change_password_label', 'Change Password'), (0, _defineProperty3.default)(_login, 'reset_password_label', 'Change/Reset Password'), (0, _defineProperty3.default)(_login, 'reset_password_request_code', 'Your forgot password code shared on the registered email address. Please check your inbox'), (0, _defineProperty3.default)(_login, 'force_change_password_message', 'You need to update your password. your password has expired. password will expire every'), (0, _defineProperty3.default)(_login, 'password_policy_criteria_message', 'Your current password does not satisfy the password policy criteria. Please reset your password to continue.'), (0, _defineProperty3.default)(_login, 'duplicate_password_warning', 'Your new password should not be same as your current password.'), (0, _defineProperty3.default)(_login, 'resend_code', 'Resend code'), (0, _defineProperty3.default)(_login, 'login_2FA__code_placeholder', 'Enter the 6-digit code sent to your email to complete the login process.'), _login),
    batch: {
        menu: {
            title: 'Batches',
            create: 'New Batch',
            all: 'All Batches'
        },

        batches: 'Batches',
        all_batches: 'All Batches',
        create_batch: 'New Batch',
        edit_batch: 'Edit Batch',
        inputType: 'Input Type',
        batchSourceId: 'Batch Source ID',
        tooltip_delete: 'Delete Batch',
        tooltip_edit: 'Edit Batch',
        tooltip_reload: 'Refresh',
        tooltip_del: 'Delete',
        create_another_title: 'Create Batch',
        create_another_message: 'Do you want to create another Batch?',
        location: 'Location',
        tooltip_info: 'Show data of location type INTERNAL and BANK',
        noBatches: 'No Batches Found'
    },
    users: {
        menu: {
            title: 'Users',
            create: 'New User',
            all: 'All Users'
        },
        branchId: 'Branch',
        role: 'Roles',
        permission: 'Permissions',
        users: 'User',
        all_users: 'All Users',
        create_users: 'New User',
        edit_users: 'Edit User',
        name: 'Name',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        languageId: 'Language',
        supervisor: 'Supervisor',
        user: 'User',
        password: 'Password',
        cnfpassword: 'Confirm Password',
        E: 'English',
        F: 'French',
        S: 'Spenish',
        handheldUser: 'Handheld User',
        webUser: 'Web User',
        tooltip_delete: 'Delete User',
        tooltip_edit: 'Edit User',
        tooltip_reload: 'Refresh',
        confirm_password_error: "password mismatch",
        create_another_title: 'Create User',
        create_another_message: 'Do you want to create another User?',
        noUsers: 'No Users Found'
    },
    route: {
        menu: {
            title: 'Routes',
            create: 'New Route',
            all: 'All Routes'
        },

        route: 'Route',
        name: 'Name',
        shortName: 'Short Name',
        loadTruck: 'Load Truck',
        holdRoute: 'Hold Route',
        beginTime: 'Begin Time',
        branchId: 'Branch',
        all_routes: 'Routes',
        tag: 'Delivery Routes used by Ranger American',

        create_route: 'New Route',
        edit_route: 'Edit Route',

        tooltip_delete: 'Delete Route',
        tooltip_edit: 'Edit Route',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Route',
        create_another_message: 'Do you want to create another Route?',

        routeSequence: 'Route Sequence',
        noRouteSequenceLocation: 'No Location is using this route on',

        noRoutes: 'No Routes Found'
    },
    shiptype: {
        menu: {
            title: 'Shiptypes',
            create: 'New Shiptype',
            all: 'All Shiptypes'
        },
        status: 'Status',
        shiptype: 'Shiptype',
        all_shiptype: 'All Shiptypes',
        create_shiptype: 'New Shiptypes',
        edit_shiptype: 'Edit Shiptypes',
        id: 'Ship Type ID',
        description: 'Description',
        unitValue: 'Unit Value',
        coin: 'Coin',
        useAmount: 'Use Amount',
        amount: 'Amount',
        handheld: 'Handheld',
        batchDisplay: 'Batch Display',
        shipmentID: 'Shipment IDs',
        tooltip_delete: 'Delete Shiptype',
        tooltip_edit: 'Edit Shiptype',
        tooltip_reload: 'Refresh',

        suspend_shiptype: 'Confirm',
        suspend_shiptype_message: 'Are you sure you want to make this Shipment in In-Active ?',
        create_another_title: 'Create Shiptype',
        create_another_message: 'Do you want to create another Shiptype ?',

        noShiptypes: 'No Shiptypes Found',
        sortOrder: 'Sort Order'
    },
    location: {
        menu: {
            title: 'Locations',
            create: 'New Location',
            all: 'All Locations'
        },

        location: 'Location Name',
        id: 'Location ID',
        name: 'Name',
        all_locations: 'All Locations',
        create_location: 'New Location',
        edit_location: 'Edit Location',

        tooltip_delete: 'Delete Location',
        tooltip_edit: 'Edit Location',
        tooltip_reload: 'Refresh',

        suspend_location: 'Confirm',
        suspend_location_message: 'Are you sure you want to Suspend this Location ?',
        create_another_title: 'Create Location',
        create_another_message: 'Do you want to create another Location?',
        status: 'Status',
        customer: 'Customer',
        branch: 'Branch',
        _address: 'Location Address',
        _city: 'Location City',
        _state: 'Location State',
        _zip: 'Location Zip',
        refId: 'Reference ID',
        _poc: 'Location POC',
        pocPhone: 'POC Phone',
        pocEmail: 'POC Email',
        deliveries: 'Deliveries',
        pickups: 'Pickups',
        day: {
            routeId: 'Route ID',
            stops: 'Stops',
            options: 'Options'
        },
        seasonStart: 'Season Start',
        seasonEnd: 'Season End',
        startTime: 'Start Time',
        endTime: 'End Time',
        locationType: 'Location Type',
        keyId: 'Key ID',
        maxDepositAmount: 'Max Deposit Amount ($0 = no limit)',
        roundedDeposits: 'Rounded Deposits',
        codAllow: 'COD Allowed',
        allowMulti: 'Multi-Stop Allowed',
        individualBagout: 'Individual Bagout',
        deliveryLoc1: '1st Delivery Option',
        deliveryLoc2: '2nd Delivery Option',
        deliveryLocCoin: 'Coin Delivery',
        deliveryLocCod: 'COD Delivery',
        lastTransaction: 'Last Transaction',
        _leave: 'Location Leave',
        atmCassette: 'ATM Cassette',
        maxCassettes: 'Max Cassettes',
        TRdeliveries: 'Deliveries',
        TRpickups: 'Pickups',
        latitude: 'Lattitude',
        longitude: 'Longitude',
        general: 'General',
        routeNotification: 'Route Notification',
        routeAssignment: 'Route Assignment',
        deliveryBackoutTimes: 'Delivery Backout Times',
        deliveryLocations: 'Delivery Locations',
        routeOptions: 'Route Options',
        transactionRequirements: 'Transaction Requirements',
        sameForAll: 'Same For All',
        _type: 'Location Type',
        transactionRequirments: 'Transaction Requirments',
        scan: 'Scan',
        receipts: 'Receipts',
        GPSlocation: 'GPS Location',
        mon: 'Monday',
        tues: 'Tuesday',
        wed: 'Wednesday',
        thurs: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
        sun: 'Sunday',
        hol: 'Holiday',
        contract: 'Contract',
        weekday: 'Weekday',
        route: 'Route',
        stop: 'Stop (before)',
        when: 'Frequency',
        scan_bagout_pieces: 'Scan Bagout Pieces',
        packCoinSeparately: 'Pack Coin Separately',
        tooltip_info: 'Enable only for location type INTERNAL and TRUCK',
        noLocations: 'No Locations Found'
    },
    carrier: {
        menu: {
            title: 'Carriers',
            create: 'New Carrier',
            all: 'All Carriers'
        },
        name: 'Carrier Name',
        POCEmail: 'POC Email',
        POCPhone: 'POC Phone',
        POCName: 'POC Name',
        carrier: 'Carrier',
        all_carriers: 'All Carriers',
        create_carrier: 'New Carrier',
        edit_carrier: 'Edit Carrier',

        tooltip_delete: 'Delete Carrier',
        tooltip_edit: 'Edit Carrier',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Carrier',
        create_another_message: 'Do you want to create another Carrier?',

        noCarriers: 'No Carriers Found'
    },
    message: {
        menu: {
            title: 'Messages',
            create: 'New Message',
            all: 'All Messagees'
        },
        all: 'All',
        types: {
            M: 'Message',
            T: 'Field Tag',
            R: 'Refusal / No Pickup',
            SM: 'Shipment Missing',
            NP: 'No Pickup',
            UI: 'UI'
        },

        messages: 'Messages',
        all_messages: 'All Messages',
        create_message: 'New Message',
        edit_message: 'Edit Message',

        tooltip_delete: 'Delete Message',
        tooltip_edit: 'Edit Message',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Message',
        create_another_message: 'Do you want to create another Message?',

        messageId: 'Message Id',
        type: 'Type',
        descriptionIn: 'Description In',

        noMessages: 'No Messages Found'
    },
    item: {
        menu: {
            title: 'Items',
            create: 'New Item',
            all: 'All Items'
        },

        items: 'Items',
        all_items: 'All Items',
        create_item: 'New Item',
        edit_item: 'Edit Item',

        tooltip_delete: 'Delete Item',
        tooltip_edit: 'Edit Item',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Item',
        create_another_message: 'Do you want to create another Item?',

        name: 'Name',
        type: 'Type',
        location: 'Location',
        noItems: 'No Items Found'
    },
    branch: {
        menu: {
            title: 'Branches',
            create: 'New Branch',
            all: 'All Branches'
        },

        branches: 'Branches',
        all_branches: 'All Branches',
        create_branch: 'New Branch',
        edit_branch: 'Edit Branch',

        tooltip_delete: 'Delete Branch',
        tooltip_edit: 'Edit Branch',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Branch',
        create_another_message: 'Do you want to create another Branch?',
        windows: 'Windows',
        tooltip_window_delete: 'Delete Window',
        tooltip_window_save: 'Save Window',
        confirm: 'Confirm',
        confirm_delete_message: 'Are you sure you want to delete this Window ?',

        noBranches: 'No Branches Found'
    },
    vault: {
        menu: {
            title: 'Vaults',
            create: 'New Vault',
            all: 'All Vaults'
        },

        vaults: 'Vaults',
        all_vaults: 'All Vaults',
        create_vault: 'New Vault',
        edit_vault: 'Edit Vault',

        tooltip_delete: 'Delete Vault',
        tooltip_edit: 'Edit Vault',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Vault',
        create_another_message: 'Do you want to create another Vault?'
    },
    customer: {
        menu: {
            title: 'Customers',
            create: 'New Customer',
            all: 'All Customers'
        },

        name: 'Name',
        contact: 'Contact',
        accountingId: 'Accounting ID',
        delete_title: 'Delete Contract',
        delete_message: 'Do you want to delete this contract?',
        customers: 'Customers',
        all_customers: 'All Customers',
        create_customer: 'New Customer',
        edit_customer: 'Edit Customer',

        tooltip_delete: 'Delete Customer',
        tooltip_edit: 'Edit Customer',
        tooltip_reload: 'Refresh',
        tooltip_delete_contract: 'Delete Contract',
        create_another_title: 'Create Customer',
        create_another_message: 'Do you want to create another Customer?',
        suspend_customer: 'Confirm',
        suspend_customer_message: 'Are you sure you want to Suspend this Customer ?',

        status: 'Status',
        billing: 'Billing',
        address: 'Address',
        city: 'City',
        state: 'State',
        zip: 'Zip',
        POC: 'POC',
        phone: 'Phone',
        email: 'Email',
        contracts: 'Contracts',

        billToContract: 'Bill To Contract',
        billToCustomer: 'Bill To Customer',
        transport: 'Transport',
        deposit: 'Deposit',
        changeOrder: 'Change Order',
        serviceSchedule: 'Service Schedule',
        contractOverrides: 'Contract Overrides',
        startDate: 'Start Date',
        endDate: 'End Date',
        orderBasis: 'Order Basis',
        orderRate: 'Order Rate',
        standardCoins: 'Standard Coins',
        serviceOption: 'Service Option',
        unitBasis: 'Unit Basis',
        unitRate: 'Unit Rate',
        billToCategory: 'Bill To Category',
        actions: 'Actions',
        contractDetails: 'Contract Details',
        noCustomers: 'No Customers Found'
    },

    truck: {
        menu: {
            title: 'Trucks',
            create: 'New Truck',
            all: 'All Trucks'
        },
        make: 'Make',
        model: 'Model',
        year: 'Year',
        vinnum: 'VIN Number',
        platenum: 'Plate Number',
        trucks: 'Trucks',
        all_trucks: 'All Trucks',
        create_truck: 'New Truck',
        edit_truck: 'Edit Truck',

        tooltip_delete: 'Delete Truck',
        tooltip_edit: 'Edit Truck',
        tooltip_reload: 'Refresh',

        create_another_title: 'Create Truck',
        create_another_message: 'Do you want to create another Truck?',
        suspend_truck: 'Confirm',
        suspend_truck_message: 'Are you sure you want to Suspend this Truck ?',
        tooltip_info: 'Show data of location type TRUCK',
        noTrucks: 'No Trucks Found'
    },

    checkin: {
        title: 'Check In',

        waitForMessenger: 'Waiting on Messenger ID Scan',
        waitForRoute: 'Waiting on Route Scan',
        waitForWindow: 'Waiting on Window ID Scan',

        successfullyCheckedin: 'Successfully Checked In',
        successfullySaved: 'Shipment Changes Saved',

        branch: 'Branch',
        route: 'Route',
        window: 'Window',
        truck: 'Truck',
        force_close: 'Force Close',
        close_route: 'Close Route',
        override: 'Override',
        save_override: 'Save Override',

        remainingItems: 'Remaining Items',

        item: 'Item',
        customer: 'Customer',
        location: 'From',
        type: 'Type',
        amount: 'Amount',
        quantity: 'Quantity',
        destination: 'Destination',
        scan: 'Scan',

        checkedin: 'Checked In',
        putOnHold: 'Item successfully put on hold',
        shipper: 'Shipper'
    },
    checkout: {
        selectRoute: 'Select Route',
        waitForRoute: 'Wait For Route',
        waitForFromTanker: 'Wait for From Tanker Scan',
        waitForToTanker: 'Wait for To Tanker Scan'
    },
    contract: {
        menu: {
            title: 'Contracts',
            create: 'New Contract',
            all: 'All Contracts'
        },
        all_contracts: 'All Contracts',
        edit_contract: 'Edit Contract',
        billToCategory: 'Bill to Category',
        billToInformation: 'Bill To Information',
        contact: 'Contact',
        changeOrder: 'Change Order',
        deposits: 'Deposits',
        transport: 'Transport',

        contractDetails: 'Contact Details',
        contractId: 'Contract ID',
        contractName: 'Contract Name',
        contractCustomer: 'Customer',
        contractStatus: 'Contract Status',

        contractStartDate: 'Start Date',
        contractEndDate: 'End Date',
        contract: 'Contract',
        serviceSchedule: 'Service Schedule',
        orderBasis: 'Order Basis',
        orderRate: 'Order Rate',

        seasonStartDate: 'Season Start',
        seasonEndDate: 'Season End',

        holidayService: 'Holiday Service',
        standardCoins: 'Standard Coin',

        serviceOption: 'Service Option',
        unitBasis: 'Unit Basis',
        unitRate: 'Unit Rate',
        actions: 'Actions',

        tooltip_delete: 'Delete Contract',
        tooltip_edit: 'Edit Contract',
        tooltip_reload: 'Refresh',
        create_another_title: 'Create Contract',
        create_another_message: 'Do you want to create another Contract?',

        noContracts: 'No Contracts Found'
    },
    shipmentBatch: {
        refId: 'RefId',
        currency: 'Currency',
        tracking_id: 'Tracking Id',
        description: 'Description/Notes',
        action: 'Action',
        add: 'Add',
        total: 'Total',
        commit: 'Commit',
        batch_master: 'Batch Master',
        customer: 'Customer',
        pickupDate: 'Pickup Date',
        deliveryDate: 'Delivery Date',
        tooltip_del: 'Delete',
        route: 'Route',
        location: 'From Location',
        reset: 'Reset',

        delete_message: 'Do you Want to Remove This Shipment?',
        invalidLocationMessage: 'RefId has no associated Location',

        alertModalTitle: 'Invalid Operation',
        alertModalMessage: 'Batch should have at least one shipment',

        locationPlaceholder: 'Select a location...',
        tooltip_info: 'Show data of location type INTERNAL and BANK',
        uploadedFiles: 'Files'
    }
}, (0, _defineProperty3.default)(_en, 'routeControl', {
    menu: {
        title: 'Route Control'
    },
    release: 'Release Route',
    route: 'Route',
    printRoute: 'Route',
    printCoin: 'Coin',

    branch: 'Branch',
    routeDate: 'Route Date',
    all: 'All',
    stops: 'Stops',
    shipments: 'Shipments',
    totalCash: 'Total Cash',
    controls: 'Controls',
    lastReleased: 'Last Released',

    branchPlaceholder: 'Select a Branch...',

    getRoutes: 'Refresh',
    noRoutesFound: 'No Routes Found',

    routeReleasedSuccessfully: 'Route {{routeName}} released successfully.',
    routeReleaseFailed: 'Error occurred while releasing route {{routeName}}.',
    routesReleasedSuccessfully: 'Routes released successfully.',
    routesReleaseFailed: 'Error occurred while releasing routes.'
}), (0, _defineProperty3.default)(_en, 'routeThrow', {
    title: 'Route Shipments',

    waitForTanker: 'Wait for Tanker Scan',

    item: 'Item',
    end: 'End',
    clear: 'Clear',
    fromTanker: 'From Tanker',
    contents: 'Contents'
}), (0, _defineProperty3.default)(_en, 'coinPullReport', {
    route: 'Route',
    title: 'Coin Pull Report',
    date: 'Date',
    show: 'Show',
    print: 'Print',
    coin: 'Coin',
    total: 'Total',
    noDesitnationFound: "No destinations found",

    routePlaceHolder: 'Select a Route...'
}), (0, _defineProperty3.default)(_en, 'holiday', {
    menu: {
        title: 'Holidays'
    },

    addHoliday: 'Add Holiday',
    createHoliday: 'Create Holiday',
    editHoliday: 'Edit Holiday',
    branch: 'Branch',
    startDate: 'Start Date',
    endDate: 'End Date',
    title: 'Title',
    name: 'Name'
}), (0, _defineProperty3.default)(_en, 'checkinSelectionModal', {
    title: 'Bag Not Found | Possible Alternatives',
    forceBag: 'Add Item',
    select: 'Select'
}), (0, _defineProperty3.default)(_en, 'confirmSupervisorModal', {
    title: 'Scan Supervisor',
    password: 'Supervisor Password',
    idMissing: 'Supervisor ID can\'t be empty',
    passwordMissing: 'Supervisor Password can\'t be empty',
    supervisor: 'Supervisor ID'
}), (0, _defineProperty3.default)(_en, 'addBagModal', {
    title: 'Add Item | ',
    trackingId: 'Tracking ID',
    scanSupervisor: 'Scan Supervisor',

    fromLocation: 'From Location',
    all: 'All',
    search: 'Search',
    destination: 'Destination',

    quantity: 'Quantity',
    shiptype: 'Ship Type',
    amount: 'Amount',

    requiredFieldsError: 'Please fill all required fields',
    divisibleByDenomError: 'Amount should be divisible by denomination face value',
    addItem: 'Add Item',
    bagSeal: 'Bag Seal',
    carrier: 'Carrier',
    batch: 'Batch',
    pleaseSelect: 'Please Select'
}), (0, _defineProperty3.default)(_en, 'forceCheckinModal', {
    title: 'Bag Not On Route',
    forceCheckin: 'Force Checkin'
}), (0, _defineProperty3.default)(_en, 'closeRouteModal', {
    title: 'Close Route',
    bag: 'Bag',
    pickupLocation: 'Pickup Location',
    locationType: 'Location Type',
    reasonCode: 'Reason Code'
}), (0, _defineProperty3.default)(_en, 'selectDeliveryLocationModal', {
    title: 'Select Delivery Location'
}), (0, _defineProperty3.default)(_en, 'routeVerifyResultModal', {
    title: 'Route Verify Result'
}), (0, _defineProperty3.default)(_en, 'forceCLoseRouteModal', {
    title: 'Force Close Checkin',
    saveAndClose: 'Save & Close',
    not_checked_in: "Not Checked In",
    not_checked_out: "Not Checked Out",
    not_delivered: "Not Delivered",
    not_picked: "Not Picked Up",
    n_a: "N/A",
    please_select: "Select Reason"
}), (0, _defineProperty3.default)(_en, 'itemNotDeliveredModal', {
    title: 'Item Not Delivered',
    pleaseSelect: 'Please Select'
}), (0, _defineProperty3.default)(_en, 'closeBagoutModal', {
    bagoutClosed: 'Bagout {{bagout.id}} closed successfully',
    view: 'View'
}), (0, _defineProperty3.default)(_en, 'commitSuccessModal', {
    title: 'Success',
    message: 'Batch Successfully Committed',
    total: 'Total'
}), (0, _defineProperty3.default)(_en, 'bagout', {
    title: 'Bag Out',

    waitForBag: 'Waiting for Bagout Seal Scan',
    lastScan: 'Last Scan',

    wrongDestination: 'Wrong Destination',
    addedToBagout: 'Added to Bagout',
    bagNotFound: 'Not Found',
    mismatchDestination: 'Mismatch Destination',
    bagAlreadyAdded: 'Already Scanned',
    previouslyAdded: 'Previously Added',
    shipmentNotCheckedIn: 'Shipment Not Checked In',
    notCheckedIn: 'Not Checked In',
    onhold: 'On Hold',
    shipmentOnHold: 'Item is on Hold',

    branch: 'Branch',
    bagoutSeal: 'Bagout Seal',
    route: 'Route',
    closePrint: 'Close & Print',
    deliveryDate: 'Delivery Date',
    item: 'Item',
    destination: 'Destination',
    location: 'Location',
    amount: 'Amount',
    type: 'Type',
    customer: 'Customer',
    fromCustomer: 'From Customer',
    fromLocation: 'From Location',
    toLocation: 'To Location',
    trackingId: 'Tracking ID',

    //print view
    from: 'From',
    fromLocationName: 'From Location Name',
    fromLocationId: 'From Location ID',
    goToBagout: 'Return To Bagout',
    closeBagout: 'Close Bagout',
    bagoutClosed: 'Bagout Closed',
    confirmCloseBagoutTitle: 'Confirm Bagout Close',
    confirmCloseBagoutMessage: 'Are you sure you want to close bagout',
    totalBags: 'Total Bags',
    totalAmount: 'Total Amount',
    verify: 'Verify',

    success: 'Success',
    fail: 'Fail',
    bagout: 'Bagout',
    totalItems: 'Total Items',
    added: 'added',
    delivery: 'Delivery'
}), (0, _defineProperty3.default)(_en, 'errorModal', {
    title: 'Error'
}), (0, _defineProperty3.default)(_en, 'uploadedFileSelectionModal', {
    title: 'Uploaded File Selection',

    fromLocation: "From Location",
    file: 'File',
    carrier: 'Carrier',
    totalAmount: 'Total Amount',
    totalBags: 'Total Bags',
    deliveryDate: 'Delivery Date',
    arrivalDate: 'Arrival Date',
    load: 'Load',

    fileLockMessage: "If you load the file and don't commit the changes, the file will be locked for minimum of 15 minutes before it can be accessed again",

    pickupDateError: 'Selected file has an invalid pickup date',
    deliveryDateError: 'Selected file has delivery date earlier than pickup date'
}), (0, _defineProperty3.default)(_en, 'error', {
    8000: 'Invalid XML content found',

    90000: 'Invalid Vault Date passed',
    90001: 'Invalid Route ID',
    90002: 'Invalid Route ID',

    90100: 'Invalid Route ID',
    90101: 'Invalid Vault Date',
    90102: 'Invalid Truck ID',
    90103: 'Begining Mileage has invalid value',
    90104: 'Begining Load Time has invalid value',
    90105: 'End Load Time has invalid value',
    90106: 'End Load Time cannot be before Begin Load Time',
    90107: 'Invalid Leave Time',
    90108: 'Leave Time cannot be before End Load Time',
    90109: 'Invalid Driver ID',
    90110: 'Invalid Messenger ID',
    90111: 'Driver ID and Messenger ID cannot be same',
    90112: 'Invalid Route ID',
    90113: 'Route is already Checked Out',
    90114: 'Invalid Truck ID',
    90115: 'Begin Miles has invalid value',
    90116: 'Invalid Driver ID',
    90117: 'Invalid Messenger ID',

    90200: 'Invalid Route ID',
    90201: 'Invalid Vault Date',
    90202: 'Invalid User ID',
    90203: 'Invalid User ID',
    90204: 'Invalid Supervisor ID',
    90205: 'Invalid Window ID',
    90206: 'Invalid Window ID',
    90207: 'Invalid Route ID',
    90208: 'Route is not Checked out',

    90300: 'Invalid Route ID',
    90301: 'Invalid Vault Date',
    90302: 'Invalid GPS latitude',
    90303: 'Invalid GPS latitude',
    90304: 'Invalid GPS longitude',
    90305: 'Invalid GPS longitude',
    90306: 'Invalid Route ID',
    90307: 'Route not Checked Out',

    90400: 'Invalid supervisor ID',

    90500: 'Invalid Messenger ID',
    90501: 'Invalid Vault Date',
    90502: 'Invalid Messenger ID',
    90503: 'Route Messenger ID not found',

    90600: 'Invalid Tracking ID',
    90601: 'Route is not available or not scheduled for Checkin',
    90602: 'Invalid Vault Date',
    90603: 'Invalid User ID',
    90604: 'Invalid Window ID',
    90605: 'Invalid Window ID',
    90606: 'No match found for Shipment ID',
    90607: 'Shipment Already Checked In',
    90608: 'Window not allowed',
    90609: 'Shipment has no delivery location',
    90610: 'Transaction Failed',

    90700: 'Invalid Shipment ID entered',
    90701: 'Invalid Location ID entered',
    90702: 'Invalid Bagout ID entered',
    90703: 'Bagout is already closed',
    90704: "Wrong Destination <br/> {{trackingId}} | Mismatch Destination <br/> Bagout {{bagoutId}}",
    90705: 'Shipment Already Scanned to Bagout',
    90706: 'Max number of shipments are added to Bagout',
    90707: 'From Location Id is not set in Setup record',

    90900: 'Invalid Tracking ID',
    90901: 'Invalid Vault Date',
    90902: 'Route Not Found. Please Retry',
    // 90901: 'This route ID has not been previously checked out',
    90903: 'Invalid Route Selected',
    90904: 'Invalid Window ID',
    90905: 'Item Not Found',
    90906: 'Shipment Already Checked In',
    90907: 'Cash Not Allowed at This Window',
    90908: 'Item Not Delivered',
    90909: 'Coin Not Allowed at This Window',
    90910: 'Route already Checked In',

    901000: "Shipment {{trackingId}} not delivered",
    901001: "Item showing Pickup and Delivery",
    901002: "Item Not Picked up",
    901003: "Item set for pickup, but Delivered",
    901004: "Item not Checked-in (user must exit and scan item)",
    901005: "Item set for Delivery but Picked-up",
    901006: "Item was not Checked out",
    901007: "Location has shipments",
    901008: "Location has no scheduled pickup",
    901009: "No Pickup for Scheduled Location",
    901010: "Location is on Hold",

    91201: "Shipment Not Found",
    91202: "Invalid Shipment ID",
    91203: "Invalid Amount",
    91204: "Amount can't be Negative",
    91205: "Amount can't be zero",
    91206: "Invalid Quantity",
    91207: "Quantity can't be Negative",
    91208: "Quantity can't be zero",

    91101: "Invalid Shipment ID",
    91102: "Invalid Destination Location",

    90612: "Invalid Tanker ID",
    95008: 'Duplicate Tracking ID',

    11000: 'Please select a valid Window'
}), (0, _defineProperty3.default)(_en, 'window', {
    allowCash: 'Allow Cash',
    allowCoin: 'Allow Coin',
    location: 'Location'
}), (0, _defineProperty3.default)(_en, 'setup', {
    menu: {
        title: 'Setup',
        all: 'All Setups',
        create: 'Create Setup'
    },
    setups: 'Setups',
    all_setups: 'All Setups',
    create_setup: 'New Setup',
    edit_setup: 'Edit Setup',

    tooltip_delete: 'Delete Setup',
    tooltip_edit: 'Edit Setup',
    tooltip_reload: 'Refresh',

    create_another_title: 'Create Setup',
    create_another_message: 'Do you want to create another Setup?',
    suspend_setup: 'Confirm',
    suspend_setup_message: 'Are you sure you want to Suspend this Setup ?',

    noSetups: 'No Setups Found',

    address: 'Address',

    setupFor: 'setup for',

    state: 'State',
    city: 'City',
    zip: 'Zip',
    telno: 'Telephone Number',

    fromLocation: 'Bagout From Location',
    holdRoute: 'Hold Route',
    exitPassword: 'Exit Password',
    confirmExitPassword: 'Confirm Exit Password',
    dataFromServer: 'Data From Server',
    dataToServer: 'Data To Server',
    fromHHTProtocol: 'From HHT Protocol',
    toHHTProtocol: 'To HHT Protocol',
    transmitMsgFiles: 'Transmit Message Files',
    verify: 'Verify',
    prefix: 'Prefix',
    action: 'Actions',
    scannerPrefixes: 'Scanner Prefixes',
    new: 'New',
    type: 'Type',
    keyVerify: 'Key Verify',
    showCoinTotal: 'Show Coin Total',
    noPrintDelivery: 'No Print Delivery',
    noPrintPickup: 'No Print Pickup',
    coinCheckIn: 'Coin Check In',
    currentVaultDate: 'Current Vault Date',
    imageDirectory: 'Image Directory',
    bagoutManifest: 'Bagout Manifest',
    branch: 'Branch',
    vault: 'Vault',
    language: 'Language',
    exitPasswordMismatch: 'Exit Password and Confirm Exit Password must match',
    directoryPathWarning: 'Make sure that the paths entered above exists',
    maxItemsPerBagout: 'Max. Items Per Bagout',
    new_label: 'New'
}), (0, _defineProperty3.default)(_en, 'log', {
    menu: {
        title: 'Logs',
        all: 'All Logs'
    },

    tooltip_reload: 'Refresh',
    noLogs: 'No Logs Found',
    extraData: 'Extra Data',
    by: 'by',
    on: 'on',
    key: 'Key',
    value: 'Value',
    supervisors: 'Supervisors',
    users: 'Users'
}), (0, _defineProperty3.default)(_en, 'connectionStatus', {
    messageConnected: 'You are successfully connected to internet.',
    messageDisconnected: 'You are not connected to internet.',

    refreshNow: 'Refresh Now'
}), _en);

exports.default = en;

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(36);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _login, _es;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var es = (_es = {
    common: {
        app_name: 'Ranger American',
        save: 'Salvar',
        reset: 'Eliminar',
        id: 'ID',
        description: 'Descripción',
        ok: 'Ok',
        cancel: 'Cancelar',
        yes: 'Si',
        no: 'No',
        next: 'Siguiente',
        previous: 'Previo',
        search: 'Buscar',
        delete: 'Borrar',
        confirm_delete_title: 'Confirmar eliminar titulo',
        confirm_delete_message: '¿Está seguro que quiere eliminarlo?',
        profile: 'Perfil',
        logout: 'Ingresar',
        none: 'Ninguna',
        select: 'Seleccionar',
        side_menu: {
            route_mgmt: 'Gestión de rutas',
            route_control: 'Liberación de la ruta',
            check_in: 'registrarse',
            check_out: 'revisa',
            bag_out: 'Bolsa hacia fuera',
            settings: 'Ajustes',
            route_sheet: 'Hoja de ruta',
            route_release: 'Liberación de la ruta',
            shipment_batch: 'Lote de envío',
            coin_pull_report: 'Reporte de monedas',
            setup: 'Preparar'
        },

        all: ''
    },
    home: {},
    routeSheet: {
        route: 'Ruta',
        date: 'Día',
        show: 'Mostrar',
        print: "Imprimir",
        routePlaceHolder: 'Marcador de ruta'
    },
    routeControl: {
        adHocCheckinNoUnassignedRoute: 'No se encontró una ruta no asignada para esta sucursal. Configure una ruta no asignada en la configuración.',
        adHocCheckinTitle: 'Registro Ad-Hoc | ',
        checkInAction: 'Registrar'
    },
    login: (_login = {
        button: 'Ingresar',
        remember_me: 'Recordar',
        remember_me_message: 'No abilitar esta opción si esta en una computadora publica.',
        email: 'Correo',
        password: 'Contraseña',
        forgot_password: '¿Olvidé la contraseña?',
        change_password: '¿Cambiar contraseña?',
        email_placeholder: 'Tu correo o Nombre de usuario',
        password_placeholder: 'Contraseña',
        forgot_email_placeholder: 'Enter your e-mail',
        code: 'Code',
        reset_code_placeholder: 'Enter Code'
    }, (0, _defineProperty3.default)(_login, 'password_placeholder', 'Enter your password'), (0, _defineProperty3.default)(_login, 'confirm_password', 'Confirm password'), (0, _defineProperty3.default)(_login, 'confirm_password_placeholder', 'Enter your confirm password'), (0, _defineProperty3.default)(_login, 'reset_request_success', 'Password reset successfully, Please try to login now!'), (0, _defineProperty3.default)(_login, 'forgot_password_label', 'Forgot Password'), (0, _defineProperty3.default)(_login, 'change_password_label', 'Change Password'), (0, _defineProperty3.default)(_login, 'reset_password_label', 'Reset Password'), (0, _defineProperty3.default)(_login, 'reset_password_request_code', 'Your forgot password code shared on the registered email address. Please check your inbox'), (0, _defineProperty3.default)(_login, 'force_change_password_message', 'You need to update your password. your password has expired. password will expire every'), (0, _defineProperty3.default)(_login, 'password_policy_criteria_message', 'Your current password does not satisfy the password policy criteria. Please reset your password to continue.'), (0, _defineProperty3.default)(_login, 'duplicate_password_warning', 'Your new password should not be same as your current password.'), (0, _defineProperty3.default)(_login, 'resend_code', 'Resend code'), (0, _defineProperty3.default)(_login, 'login_2FA__code_placeholder', 'Enter the 6-digit code sent to your email to complete the login process.'), _login),
    batch: {
        menu: {
            title: 'Lote',
            create: 'Nuevo lote',
            all: 'Todos los Lotes'
        },
        batches: 'Lote',
        all_batches: 'Todos los lotes',
        create_batch: 'Nuevo lote',
        edit_batch: 'Editar lote',
        inputType: 'Tipo de entrada',
        batchSourceId: 'ID Fuente de lote',
        tooltip_delete: 'Eliminar lote',
        tooltip_edit: 'Editar lote',
        tooltip_reload: 'Refrescar',
        tooltip_del: 'Eliminar',
        create_another_title: 'Crear lote',
        create_another_message: 'Desea crear otro lote?',
        location: 'Ubicación',
        tooltip_info: '',
        noBatches: 'Sin lotes'
    },
    users: {
        menu: {
            title: 'Usuarios',
            create: 'Nuevo Usuario',
            all: 'Todos los usuarios'
        },
        branchId: 'Sucursal',
        role: 'Roles',
        permission: 'Permitir',
        users: 'Usuario',
        all_users: 'Todos los usuarios',
        create_users: 'Nuevo usuario',
        edit_users: 'Editar usuario',
        name: 'Nombre',
        firstName: 'Primer nombre',
        lastName: 'Apellido',
        email: 'Correo',
        languageId: 'Lenguaje',
        supervisor: 'Supervisor',
        user: 'Usuario',
        password: 'Contraseña',
        cnfpassword: 'Confirmar contraseña',
        E: 'Ingles',
        F: 'Frances',
        S: 'Español',
        tooltip_delete: 'Eliminar usuario',
        tooltip_edit: 'Editar Usuario',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Usuario',
        create_another_message: '¿Deseá crear otro usuario?',
        noUsers: 'Sin usuarios',
        handheldUser: 'Usuario de mano',
        webUser: 'Usuario web',
        confirm_password_error: ""
    },
    route: {
        menu: {
            title: 'Ruta',
            create: 'Nueva Ruta',
            all: 'Todas las Rutas'
        },

        route: 'Ruta',
        name: 'Nombre',
        shortName: 'Abreviación',
        loadTruck: 'Camion de carga',
        beginTime: 'Iniciar ahora',
        branchId: 'Sucursal',
        all_routes: 'Ruta',
        tag: 'Rutas de entraga utuilazadas por Ranger American',
        create_route: 'Nueva ruta',
        edit_route: 'Editar Ruta',
        tooltip_delete: 'Eliminar Ruta',
        tooltip_edit: 'Editar Ruta',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Ruta',
        create_another_message: '¿Desea crear otra ruta?',
        routeSequence: 'Secuencia de Ruta',
        noRouteSequenceLocation: 'No hay ubicación que use esta ruta',
        noRoutes: 'Sin rutas',
        holdRoute: 'Mantener rutas'
    },
    shiptype: {
        menu: {
            title: 'Entrega',
            create: 'Nueva Entrega',
            all: 'Todas las entrgas'
        },
        status: 'Estado',
        shiptype: 'Entrega',
        all_shiptype: 'Todas las entregas',
        create_shiptype: 'Nueva Entrega',
        edit_shiptype: 'Editar Entrega',
        id: 'ID de Entrega',
        description: 'Descripción',
        unitValue: 'Valor unitario',
        coin: 'Moneda',
        useAmount: 'Cantidad en uso ',
        amount: 'Monto',
        handheld: 'Portatil',
        batchDisplay: 'Visualización por lotes',
        shipmentID: 'IDs de Entrega',
        tooltip_delete: 'Eliminar Entrega',
        tooltip_edit: 'Editar Entrega',
        tooltip_reload: 'Refrescar',
        suspend_shiptype: 'Confirmar',
        suspend_shiptype_message: '¿Está seguro que desea realizar este envío inactivo?',
        create_another_title: 'Crear Entrega',
        create_another_message: '¿Deseá crear otro tipo de entrega?',
        noShiptypes: 'No hay barcos'
    },
    location: {
        menu: {
            title: 'Ubicación',
            create: 'Nueva Ubicación',
            all: 'todas las Ubicaciones'
        },
        location: 'Ubicación',
        id: 'ID',
        all_locations: 'todas las Ubicaciones',
        create_location: 'Nueva Ubicación',
        edit_location: 'Editar Ubicación',
        tooltip_delete: 'Eliminar Ubicación',
        tooltip_edit: 'Editar ubicación',
        tooltip_reload: 'Refrescar',
        suspend_location: 'Confirmar',
        suspend_location_message: '¿Está seguro que desea suspender esta Ubicación?',
        create_another_title: 'Crear Ubicación',
        create_another_message: '¿Desea crear otra Ubicación?',
        status: 'Estado',
        customer: 'Cliente',
        branch: 'Sucursal',
        _address: 'Dirección exacta',
        _city: 'Ciudad',
        _state: 'Estado',
        _zip: 'Ubicación Zip',
        refId: 'ID de Referencia',
        _poc: 'Ubicación PDC',
        pocPhone: 'Telefono PDC',
        pocEmail: 'Correo PDC',
        deliveries: 'Entregas',
        pickups: 'Recolecciones',
        day: {
            routeId: 'ID de Ruta',
            stops: 'Paradas',
            options: 'Opciones'
        },
        seasonStart: 'Inicio de Temporada',
        seasonEnd: 'Final de Temporada',
        startTime: 'Hora de inicio',
        endTime: 'Hora de Finalización',
        locationType: 'Tipo de Ubicación',
        keyId: 'Clave de ID',
        maxDepositAmount: 'Cantidad de Deposito Maximo',
        roundedDeposits: 'Deposito Redondeado',
        codAllow: 'COD Permitido',
        allowMulti: 'Paradas multiples Permitidas',
        individualBagout: 'Bolsa Individual',
        deliveryLoc1: '1ra Opción de Distribución',
        deliveryLoc2: '2da Opción de Distribución',
        deliveryLocCoin: 'Distribución de monedas',
        deliveryLocCod: 'COD Distribución',
        lastTransaction: 'Ultima Transacción',
        _leave: 'Salir Localización',
        atmCassette: 'Cinta ATM',
        maxCassettes: 'Máximo de Casetes',
        TRdeliveries: 'Entregas',
        TRpickups: 'Recolecciones',
        latitude: 'Latitud',
        longitude: 'Longitud',
        general: 'General',
        routeNotification: 'Notificaiones de Ruta',
        routeAssignment: 'Ruta Asignada',
        deliveryBackoutTimes: 'Plazo de entrega',
        deliveryLocations: 'Ubicación de entrega',
        routeOptions: 'Opción de ruta',
        transactionRequirements: 'Transacción requerida',
        sameForAll: 'Lo mismo para todos',
        _type: 'Tipo de locación',
        transactionRequirments: 'Transacción requerida',
        scan: 'Escanear',
        receipts: 'Recibos',
        GPSlocation: 'Localización GPS',
        mon: 'Lunes',
        tues: 'Martes',
        wed: 'Miercoles',
        thurs: 'Jueves',
        fri: 'Viernes',
        sat: 'Sabado',
        sun: 'Domingo',
        hol: 'Feriado',
        contract: 'Contrato',
        weekday: 'Día laborable',
        route: 'Ruta',
        stop: 'Parada',
        when: 'Cuando',
        scan_bagout_pieces: 'Escanear bolsas',
        packCoinSeparately: 'Empaquetar moneda por separado',
        tooltip_info: '',
        noLocations: 'Sin ubicaciones',
        name: 'Nombre'
    },
    carrier: {
        menu: {
            title: 'Mensajero',
            create: 'Nuevo Mensajero',
            all: 'Todos los Mensajeros'
        },
        name: 'Nombre de Transportista',
        POCEmail: 'Correo PDC',
        POCPhone: 'Telefono PDC',
        POCName: 'Nombre PDC',
        carrier: 'Mensajero',
        all_carriers: 'todos Mensajeros',
        create_carrier: 'Nuevo Mensajero',
        edit_carrier: 'Editar Mensajero',
        tooltip_delete: 'Eliminar Mensajero',
        tooltip_edit: 'Editar Mensajero',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Mensajero',
        create_another_message: '¿Desea crear otra Mensajero?',
        noCarriers: 'Ninguna compañía'
    },
    message: {
        menu: {
            title: 'Mensaje',
            create: 'Nuevo Mensaje',
            all: 'todos los mensajes'
        },
        types: {
            N: 'N',
            M: 'Mensajes',
            T: 'Etiqueta de campo',
            R: 'Refusal / No Pickup',
            SM: 'Envio Perdido',
            NP: 'No Recoger'
        },
        messages: 'Mensajes',
        all_messages: 'todos los Mensajes',
        create_message: 'Nuevo Mensaje',
        edit_message: 'Editar Mensaje',
        tooltip_delete: 'Eliminar Mensaje',
        tooltip_edit: 'Editar Mensaje',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Mensaje',
        create_another_message: '¿Deseá crear otro Mensaje?',
        messageId: 'ID de mensaje',
        type: 'Tipo',
        descriptionIn: 'Descripción en',
        noMessages: 'Ningún mensaje',
        all: 'Todas'
    },
    item: {
        menu: {
            title: 'Artículo',
            create: 'Nuevo Artículo',
            all: 'Todos los Artículos'
        },
        items: 'Artículo',
        all_items: 'Todos los artículos',
        create_item: 'Nuevo Artículo',
        edit_item: 'Editar Artículo',
        tooltip_delete: 'Eliminar Artículo',
        tooltip_edit: 'Editar Artículo',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Artículo',
        create_another_message: 'Crear otro mensaje',
        location: 'Ubicación',
        name: 'Nombre',
        noItems: 'Ninguna articulo',
        type: 'Tipo'
    },
    branch: {
        menu: {
            title: 'Sucursal',
            create: 'Nueva Sucursal',
            all: 'Todas las sucursales'
        },
        branches: 'Sucursales',
        all_branches: 'Todas las Sucursales',
        create_branch: 'Nueva Sucursal',
        edit_branch: 'Editar Sucursal',
        tooltip_delete: 'Eliminar Sucursal',
        tooltip_edit: 'Editar Sucursal',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Sucursal',
        create_another_message: '¿Deseá Crear otra Sucursal?',
        windows: 'Ventanas',
        tooltip_window_delete: 'Eliminar Ventana',
        tooltip_window_save: 'Salvar Ventana',
        confirm: 'Confirmar',
        confirm_delete_message: '¿Está seguro de querer eliminar ventana?',
        noBranches: 'Sin ramas'
    },
    vault: {
        menu: {
            title: 'Bóveda',
            create: 'Nueva Bóveda',
            all: 'Todas las Bóvedas'
        },
        vaults: 'Bóvedas',
        all_vaults: 'Todas las Bóvedas',
        create_vault: 'Nueva Bóveda',
        edit_vault: 'Editar Bóveda',
        tooltip_delete: 'Eliminar Bóveda',
        tooltip_edit: 'Editar Bóveda',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Bóveda',
        create_another_message: '¿Deseá crear otra Bóveda?'
    },
    customer: {
        menu: {
            title: 'Clientes',
            create: 'Nuevo Cliente',
            all: 'todos los Clientes'
        },
        name: 'Nombre',
        contact: 'Contacto',
        delete_title: 'Eliminar Contrato',
        delete_message: '¿Deseá eliminar este contrato?',
        customers: 'Clientes',
        all_customers: 'Todos los Clientes',
        create_customer: 'Nuevo Cliente',
        edit_customer: 'Editar Cliente',
        tooltip_delete: 'eliminar Cliente',
        tooltip_edit: 'Editar Cleinte',
        tooltip_reload: 'Refrescar',
        tooltip_delete_contract: 'Eliminar Contrato',
        create_another_title: 'Crear Cliente',
        create_another_message: '¿Deseá crear otro cliente?',
        suspend_customer: 'Confirmar',
        suspend_customer_message: '¿Está seguro de suspender este cleinte?',
        status: 'Estado',
        billing: 'Facturación',
        address: 'Dirección',
        city: 'Ciudad',
        state: 'Estado',
        zip: 'Zip',
        POC: 'PDC',
        phone: 'Telefono',
        email: 'Correo',
        contracts: 'Contratos',
        billToContract: 'Factura para Contrato',
        billToCustomer: 'factura para el cliente',
        transport: 'Transporte',
        deposit: 'Depósito',
        changeOrder: 'Cambiar orden',
        serviceSchedule: 'Horario de Servicio',
        contractOverrides: 'Anulaciones de Contrato',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha final',
        orderBasis: 'Base del pedido',
        orderRate: 'Tarifa de orden',
        standardCoins: 'Moneda estandar',
        serviceOption: 'Opción de Servicio',
        unitBasis: 'Unidad base',
        unitRate: 'Unidad de medida',
        billToCategory: 'Proyecto de ley a la categoría',
        actions: 'Comportamiento',
        noCustomers: 'Sin clientes',
        contractDetails: 'Contract Details',
        accountingId: 'ID de contabilidad'
    },

    truck: {
        menu: {
            title: 'Camiones',
            create: 'Nuevo Camion',
            all: 'Todas los Camiones'
        },
        make: 'Marca',
        model: 'Modelo',
        year: 'Año',
        vinnum: 'Numero VIN',
        platenum: 'Placa Vehicular',
        trucks: 'Camiones',
        all_trucks: 'Todos los Camiones',
        create_truck: 'Nuevo Camion',
        edit_truck: 'Editar Camion',
        tooltip_delete: 'Eliminar Camion',
        tooltip_edit: 'Editar camion',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear camion',
        create_another_message: '¿Deseá crear otro camion?',
        suspend_truck: 'Confirmar',
        suspend_truck_message: '¿Está seguro que desea suspender este camion?',
        tooltip_info: '',
        noTrucks: 'no camonines'
    },

    checkin: {
        title: 'Titulo',
        waitForMessenger: 'Espere por mensaje',
        waitForRoute: 'Espere por la ruta',
        waitForWindow: 'Espere por la ventana',
        successfullyCheckedin: 'Entrada exitosa',
        successfullySaved: 'Guardado exitosamente',
        branch: 'Sucursal',
        route: 'Ruta',
        window: 'Ventana',
        truck: 'Camion',
        close_route: 'Cerrar Ruta',
        override: 'Anular',
        save_override: 'Salvar anulación',
        item: 'Artículo',
        customer: 'Cliente',
        location: 'Locación',
        type: 'Tipo',
        amount: 'Valor',
        destination: 'Destino',
        scan: 'Escanear',
        checkedin: 'Entrada',
        putOnHold: 'Puesto en espera',
        force_close: 'Cerrada forzosa',
        quantity: 'Cantidad',
        remainingItems: 'No articulo restantes',
        shipper: 'Expedidor'
    },
    contract: {
        menu: {
            title: 'Contratos',
            create: 'Nuevo Contrato',
            all: 'todos los Contratos'
        },
        all_contracts: 'Todos los Contratos',
        edit_contract: 'Editar Contrato',
        billToCategory: 'Categoria de factura',
        billToInformation: 'Información de factura',
        contact: 'Contacto',
        changeOrder: 'Cambiar Orden',
        deposits: 'Depositos',
        transport: 'Transporte',
        contractDetails: 'Detalle de Contacto',
        contractId: 'ID de contrato',
        contractName: 'Nombre de contrato',
        contractCustomer: 'Customer',
        contractStatus: 'estado de contrato',
        contractStartDate: 'Fecha de Inicio',
        contractEndDate: 'Fecha Final',
        contract: 'Contrato',
        serviceSchedule: 'Horario de Servicio',
        orderBasis: 'Base de Pedidos',
        orderRate: 'Tarifa de Orden',
        seasonStartDate: 'Inicio de Temporada',
        seasonEndDate: 'Final de Temporada',
        holidayService: 'Servicio de Vacaciones',
        standardCoins: 'Moneda Estandar',
        serviceOption: 'Opción de Servicio',
        unitBasis: 'Unidad de Base',
        unitRate: 'Unidad de Medida',
        actions: 'Comportamiento',
        tooltip_delete: 'Eliminar Contrato',
        tooltip_edit: 'Editar Contrato',
        tooltip_reload: 'Refrescar',
        create_another_title: 'Crear Contrato',
        create_another_message: '¿Deseá crear otro Contrato?',
        noContracts: 'no contratos'
    },
    shipmentBatch: {
        refId: 'ID destino de Referencia',
        currency: 'Efectivo',
        tracking_id: 'ID de Rastreo',
        description: 'Descripción/Notas',
        action: 'Acción',
        add: 'Agregar',
        total: 'Total',
        commit: 'Hacer',
        batch_master: 'Lote Maestro',
        customer: 'Cliente',
        deliveryDate: 'Día de entrega',
        tooltip_del: 'Eliminar',
        route: 'ruta',
        location: 'ubicación',
        reset: 'restaurar',
        delete_message: 'eliminar mensaje',
        invalidLocationMessage: 'Ubicación de mensaje invalida',
        alertModalTitle: 'Título modal de alerta',
        alertModalMessage: 'Mensaje modal de alerta',
        locationPlaceholder: 'Ubicación',
        uploadedFiles: 'Subir Archivos',
        tooltip_info: ''
    }
}, (0, _defineProperty3.default)(_es, 'routeControl', {
    menu: {
        title: 'Control de Ruta'
    },
    release: 'Emisión',
    route: 'Ruta',
    branch: 'Sucursal',
    routeDate: 'Fecha de la Ruta',
    all: 'Todo',
    stops: 'Paradas',
    totalCash: 'Efectivo Total',
    controls: 'Inspecciones',
    branchPlaceholder: 'Select a Branch...',
    getRoutes: 'Traer rutas',
    noRoutesFound: 'No rutas encontradas',
    printCoin: 'Imprimir moneda',
    printRoute: 'imprimir ruta',
    routeReleaseFailed: 'liberation de ruta fracasado',
    routeReleasedSuccessfully: 'Liberation de ruta exitosa',
    routesReleaseFailed: 'liberación de ruta fracasado',
    routesReleasedSuccessfully: 'liberation de rutas exitosa.',
    shipments: 'Envíos'
}), (0, _defineProperty3.default)(_es, 'setup', {
    menu: {
        all: 'Todos',
        create: 'Crear',
        title: 'Titulo'
    },
    all_setups: 'Todas la configuraciones',
    setups: 'Instauraciones',
    create_setup: 'Crear instauracion',
    edit_setup: 'editar instauracion',
    tooltip_delete: 'Herramienta eliminada',
    tooltip_edit: 'Editar Herramienta',
    tooltip_reload: 'Recargar Herramienta',
    create_another_message: 'Crear otro mensaje',
    create_another_title: 'Crear otro titulo',
    suspend_setup: 'Suspender la instauracion',
    suspend_setup_message: 'Suspender',
    noSetups: 'No Instauraciones',
    address: 'Direccion',
    setupFor: 'Instauracion para ',
    state: 'Estado',
    city: 'Ciudad',
    zip: 'zip',
    telno: 'número de teléfono',
    fromLocation: 'Desde la ubicación',
    holdRoute: 'Mantener la ruta',
    exitPassword: 'contraseñas de salida',
    confirmExitPassword: 'confirma contraseña de salida',
    dataFromServer: 'Información de el Servidor',
    dataToServer: 'Información para el Servidor',
    fromHHTProtocol: 'De el  HTT Protocolo',
    toHHTProtocol: 'Para HTT Protocol',
    transmitMsgFiles: 'Trasmitir archivos de mensaje',
    keyVerify: 'clave de verificación',
    verify: 'Verificar',
    showCoinTotal: 'Muestra total de monedas',
    noPrintDelivery: 'No impression de la entrega',
    noPrintPickup: 'No impression de el levante',
    coinCheckIn: 'Moneda Registrada',
    currentVaultDate: 'fecha actual de la boveda',
    imageDirectory: 'Imagen de el Directorio',
    bagoutManifest: 'Salida manifestada',
    branch: 'Sucursal',
    vault: 'Boveda',
    language: 'lenguaje',
    directoryPathWarning: 'advertencia de el camino a directorio',
    exitPasswordMismatch: 'Contraseñas de salida no son iguales',
    maxItemsPerBagout: 'Max. Items Per Bagout', // need fix
    new_label: 'New' // need fix
}), (0, _defineProperty3.default)(_es, 'log', {
    menu: {
        title: '',
        all: ''
    },

    tooltip_reload: '',
    noLogs: '',
    extraData: '',
    by: '',
    on: '',
    key: '',
    value: '',
    supervisors: '',
    users: ''
}), (0, _defineProperty3.default)(_es, 'holiday', {
    menu: {
        title: 'Titulo'
    },
    addHoliday: 'Agregar Dia Festivo',
    createHoliday: 'Crear Dia Festivo',
    editHoliday: 'Editar Dia Festivo',
    branch: 'Sucursal',
    startDate: 'Fecha de Comienzo',
    endDate: 'Fecha de Termino',
    title: 'Titulo',
    name: 'Nombre'
}), (0, _defineProperty3.default)(_es, 'checkinSelectionModal', {
    title: 'Bolsa no encontrada | Seleccionar Alternativa',
    forceBag: 'Forzar Bolsa',
    select: 'Selecionar'
}), (0, _defineProperty3.default)(_es, 'checkout', {
    selectRoute: 'Seleccioné Ruta',
    waitForFromTanker: 'Espere por..',
    waitForRoute: 'Espere por Ruta',
    waitForToTanker: 'Espere por..'
}), (0, _defineProperty3.default)(_es, 'routeThrow', {
    title: 'Contratos',
    waitForTanker: 'Espera por el petrolero',
    item: 'It',
    end: 'Fin',
    clear: 'Claro',
    fromTanker: 'De petrolero',
    contents: 'Contenido'
}), (0, _defineProperty3.default)(_es, 'coinPullReport', {
    coin: 'Moneda',
    date: 'Fecha',
    noDesitnationFound: 'No Destino Encontrado',
    print: 'Imprimir',
    route: 'Ruta',
    routePlaceHolder: 'Ruta en espera',
    show: 'Mostrar',
    title: 'Titulo',
    total: 'Total'
}), (0, _defineProperty3.default)(_es, 'confirmSupervisorModal', {
    title: 'Supervisor de escaneo',
    password: '',
    idMissing: '',
    passwordMissing: '',
    supervisor: 'Supervisor'
}), (0, _defineProperty3.default)(_es, 'addBagModal', {
    title: 'Agregar bolsa',
    trackingId: 'ID de Ratreo',
    scanSupervisor: 'Supervisor de escaneo',
    fromLocation: 'De Ubicación',
    all: 'Todos',
    search: '',
    destination: 'Destino',
    quantity: 'Cantidad',
    shiptype: 'Tipo de Envio',
    amount: 'Cantidad',
    requiredFieldsError: 'Erros en Campos Requeridos',
    addItem: 'Agregar Articulo',
    bagSeal: 'Sellado de Bolsa',
    carrier: 'Portador',
    batch: 'Lote',
    pleaseSelect: 'Por favor Selecione'
}), (0, _defineProperty3.default)(_es, 'forceCheckinModal', {
    title: 'Bolsa no esta en ruta',
    forceCheckin: 'Inspección inmediata'
}), (0, _defineProperty3.default)(_es, 'closeRouteModal', {
    title: 'Cerra Ruta',
    bag: 'Bolsa',
    pickupLocation: 'localizacion de recibido',
    locationType: 'tipo Locación',
    reasonCode: 'Codigo de Causa'
}), (0, _defineProperty3.default)(_es, 'selectDeliveryLocationModal', {
    title: 'Titulo'
}), (0, _defineProperty3.default)(_es, 'routeVerifyResultModal', {
    title: 'Titulo'
}), (0, _defineProperty3.default)(_es, 'forceCLoseRouteModal', {
    title: 'Titulo',
    saveAndClose: 'Cerrar y Guardar',
    not_checked_in: 'No regitrado',
    not_checked_out: 'Sin Salir',
    not_delivered: 'No Deliverado',
    not_picked: 'No Recojido',
    n_a: 'no aplica',
    please_select: 'Por favor Selecione..'
}), (0, _defineProperty3.default)(_es, 'itemNotDeliveredModal', {
    title: 'Titulo',
    pleaseSelect: 'Por favor Selecione'
}), (0, _defineProperty3.default)(_es, 'closeBagoutModal', {
    bagoutClosed: 'Bolsa de Salida Cerrada',
    view: 'Mostrar'
}), (0, _defineProperty3.default)(_es, 'commitSuccessModal', {
    title: 'Titulo',
    message: 'Mensaje',
    total: 'Total'
}), (0, _defineProperty3.default)(_es, 'bagout', {
    title: 'Bolsa',
    waitForBag: 'Espere por La Bolsa',
    lastScan: 'Ultimo Escaneo',
    wrongDestination: 'Destino Equivicado',
    addedToBagout: 'Aderido a La Bolsa de salida',
    bagNotFound: 'Niguna bolsa encontrada',
    mismatchDestination: 'destino incompatible',
    bagAlreadyAdded: 'Bolsa Aderida',
    previouslyAdded: 'Previamente aderida',
    shipmentNotCheckedIn: 'Envío no Registrado',
    notCheckedIn: 'No Registrado',
    onhold: 'En espera',
    shipmentOnHold: 'Envio en Espera',
    closePrint: 'Cierre de Imprecion',
    branch: 'Sucursal',
    bagoutSeal: 'Sello de Bolsa',
    route: 'Ruta',
    deliveryDate: 'Fecha de Entrega',
    item: 'Articulo',
    destination: 'Destino',
    location: 'Locación',
    amount: 'Monto',
    type: 'Tipo',
    customer: 'Cliente',
    fromCustomer: 'Del cliente',
    fromLocation: 'Desde el Origen',
    toLocation: 'Al Destino',
    trackingId: 'ID de Seguimiento',
    from: 'De',
    fromLocationName: 'Nombre de Ubicación',
    fromLocationId: 'ID De Ubicacion',
    goToBagout: 'Para Bolsa de Salida',
    closeBagout: 'Cerrar Bolsa De Salida',
    bagoutClosed: 'Bolsa de Salida Cerrada',
    confirmCloseBagoutTitle: 'Confirmar Titulo De bolsa de Salida',
    confirmCloseBagoutMessage: 'Confirmar mensaje de bolsa de Salida',
    totalBags: '',
    totalAmount: '',
    verify: '',
    totalItems: '',
    success: 'Exito',
    fail: 'Fallo',
    bagout: 'Bolsa de salida',
    added: 'Aderido',
    delivery: 'Entrega'
}), (0, _defineProperty3.default)(_es, 'errorModal', {
    title: 'Error'
}), (0, _defineProperty3.default)(_es, 'uploadedFileSelectionModal', {
    title: 'Titulo',
    fromLocation: 'De Ubicación',
    file: 'Titulo',
    carrier: 'Portador',
    totalAmount: 'Monto Total',
    totalBags: 'Total De bolsas',
    deliveryDate: 'Fecha de Entrega',
    arrivalDate: 'Fecha de Llegada',
    load: 'Carga',
    fileLockMessage: "Si cargas los archivos y no haces  los cambios, el archivo sera bloqueado por un mínimo de 15 minutos antes de que pueda ser acezado nuevamente.",
    dateError: 'Error de fecha'
}), (0, _defineProperty3.default)(_es, 'error', { //translate-this:
    8000: 'Contenido XML no válido encontrado',
    90000: 'Invalido Fecha de Boveda Pasado',
    90001: 'Invalido ID de Ruta',
    90002: 'Invalido ID de Ruta ',
    90100: 'Invalido ID de Ruta',
    90101: 'Invalido Fecha de Boveda',
    90102: 'Invalido ID de Camion',
    90103: 'Millas de Comienzo Tiene un Caracter Invalido',
    90104: 'Tiempo de Comienzo de Carga Tiene Caracteres Invalidos',
    90105: 'Tiempo de Finalizacion de Carge Tiene Invalidos Caracteres',
    90106: 'Tiempo de Finalizacion de Carga no Puede Ser Antes de Comienzo de Carga',
    90107: 'Tiempo de Salida es Invalido',
    90108: 'Tiempo de Salida no Puede Ser Antes de Tiempo de Finalzacion de Carga',
    90109: 'Invalido ID de Operador',
    90110: 'Invalido ID de Mensajero',
    90111: 'ID de Operador y ID de Mensajero no Puede Ser el Mismo',
    90112: 'Invalido ID de Ruta',
    90113: 'Esta Ruta ya ha Sido Tomada',
    90114: 'Invalido ID de Camion',
    90115: 'Millas de Comienzo Tiene un Caracter Invalido',
    90116: 'invalido ID de Operador',
    90117: 'Invalido ID de Mensajero',
    90200: 'Invalido ID de Ruta',
    90201: 'Invalido Fecha de Boveda',
    90202: 'Invalido ID de Usuario',
    90203: 'Invalido ID de Usuario',
    90204: 'Invalido ID de Supervisor',
    90205: 'Invalido ID de Ventana',
    90206: 'Invalido ID de Ventana',
    90207: 'Invalido ID de Ruta',
    90208: 'Routa no ha Sido Tomada',
    90300: 'Invalido ID de Ruta',
    90301: 'Invalido Fecha de Boveda',
    90302: 'Invalida GPS latitud',
    90303: 'Invalida GPS latitud',
    90304: 'Invalida GPS longitud',
    90305: 'Invalida GPS longitud',
    90306: 'Invalido ID de Ruta',
    90307: 'Routa no ha Sido Tomada',
    90400: 'Invalido ID de Supervisor',
    90500: 'Invalido ID de Mensajero',
    90501: 'Invalido Fecha de Boveda',
    90502: 'Invalido ID de Mensajero',
    90503: 'ID de Mensajero de Ruta no Encontrado',
    90600: 'Invalido ID de Rastreo',
    90601: 'Routa no Esta Lista o no ha Sido Puesta Para Registrar',
    90602: 'Invalido Fecha de Boveda',
    90603: 'Invalido ID de Usuario',
    90604: 'Invalido ID de Ventana',
    90605: 'Invalido ID de Ventana',
    90606: 'ID de Envarque no ha Sido Encontrado',
    90607: 'Envarque ya ha Sido Registrado',
    90608: 'Ventana no Permitido',
    90609: 'Envarco no Tiene Ubicacion de Entrega',
    90610: 'Transaccion ha Fallado',
    90700: 'Invalido ID de Envarco Ingresado',
    90701: 'Invalido ID de Envarco Ingresado',
    90702: 'Invalido ID bolsa de salida Ingresado',
    90703: 'Bolsa de salida ya ha sido cerrada',
    90704: "Detinacion equivocada <br/> {{trackingId}} | Mismatch Destination <br/> Bagout {{bagoutId}}",
    90705: 'Envarque ya Fue Escaneado Para Bolsa de Salida',
    90706: 'Maximo numero de evarques aderidos a la bolsa de salida',
    90707: 'Este Ubicacion ID no a Sido Preparado en Registro',
    90900: 'Invalido ID de Rastreo',
    90901: 'Invalido Fecha de Boveda',
    90902: 'Routa No Encontrada Porfavor Intente de Nuevo',
    90903: 'Invalida Ruta Seleccionada',
    90904: 'Invalido ID de Ventana',
    90905: 'Articulo no Encontrado',
    90906: 'Envarque ya ha Sido Registrado',
    90907: 'Efectivo no Permitido en Esta Ventana',
    90908: 'Articulo no Deliverado',
    90909: 'Monedas no Permitidas en Esta Ventana',
    90910: 'Ruta ya ha Sido Tomada',
    901000: "Envio {{trackingId}} no deliveredo",
    901001: "Articulo Muestra Levante y Entrega",
    901002: "Articulo no Fue Recogido",
    901003: "Articulo Esta Listo Para Recoger, Pero no Deliveredo",
    901004: "Articulo no Registrado (Usuario Tiene que Salir y Escanear el Articulo)",
    901005: "Articulos Puesto Para Entrega, Pero no Recogido",
    901006: "Articulo no Fue Sacado",
    901007: "Ubicacion Tiene Envios",
    901008: "Ubicacion no Tiene Registros Para Recojer",
    901009: "No Levantamientos regitrados para esta ubicacion",
    901010: "Ubicacion Esta En Espera",
    91201: "Envion no Encontrado",
    91202: "Invalido ID de Rastreo",
    91203: "Invalido Monto",
    91204: "Monto No Puede Ser Negativo",
    91205: "Monto No Puede Ser Cero",
    91206: "Invalido Cantidad",
    91207: "Cantidad no Puede Ser Negativo",
    91208: "Cantidad no Puede Ser Cero",
    91101: "Invalido ID de Rastreo",
    91102: "Invalido Ubicacion de Destino",
    90612: "ID de tanque no válido",
    95008: 'ID de rastreo duplicado',
    11000: 'Porfavor Seleccione una Valida Ventana'
}), (0, _defineProperty3.default)(_es, 'window', {
    allowCash: 'Permitir Efectivo',
    allowCoin: 'Permitir Monedas'
}), (0, _defineProperty3.default)(_es, 'connectionStatus', {
    messageConnected: 'Mensaje Conectado',
    messageDisconnected: 'Mensaje Desconectado',

    refreshNow: 'Refrescar ahora'
}), _es);

exports.default = es;

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _footer = __webpack_require__(2896);

var _footer2 = _interopRequireDefault(_footer);

var _footer3 = __webpack_require__(2396);

var _footer4 = _interopRequireDefault(_footer3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var footerComponent = {
  restrict: 'E',
  bindings: {},
  template: _footer2.default,
  controller: _footer4.default
};

exports.default = footerComponent;

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterController = function FooterController() {
  'ngInject';

  (0, _classCallCheck3.default)(this, FooterController);
  this.appName = "Rangers";
  this.date = new Date();
};

FooterController.$inject = [];

exports.default = FooterController;

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = __webpack_require__(2897);

var _header2 = _interopRequireDefault(_header);

var _header3 = __webpack_require__(2398);

var _header4 = _interopRequireDefault(_header3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headerComponent = {
  restrict: 'E',
  bindings: {},
  template: _header2.default,
  controller: _header4.default
};

exports.default = headerComponent;

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderController = function HeaderController() {
  'ngInject';

  (0, _classCallCheck3.default)(this, HeaderController);
  this.header = "Rangers";
};

HeaderController.$inject = [];

exports.default = HeaderController;

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _header = __webpack_require__(2397);

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__(2395);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var layoutModule = _angular2.default.module('app.layout', []);

layoutModule.component('appHeader', _header2.default);

layoutModule.component('appFooter', _footer2.default);

exports.default = layoutModule;

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCodeService = function ActionCodeService($http, $q) {

    var create = function create(data, branch) {
        return $http.post(_app2.default.api + "/action-code/create", {
            data: data,
            branch: branch
        }).then(function (res) {
            return res.data;
        });
    };

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + "/action-code", {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getActionCodes = function getActionCodes(actionCodeId) {
        return $http.get(_app2.default.api + "/action-code/get-action-codes", {
            params: { actionCodeId: actionCodeId }
        }).then(function (res) {
            return res.data;
        });
    };

    var updateCodeResponse = function updateCodeResponse(data) {
        return $http.post(_app2.default.api + "/action-code/update-code-response", data).then(function (res) {
            return res.data;
        });
    };

    var createServiceOrderActionCodes = function createServiceOrderActionCodes(actionCodeLabel, actionCode, minResponse, maxResponse, minRootCause, maxRootCause, thresholds, partsCapture, resolveCodes, rootCauses, redThreshold, orangeThreshold, yellowThreshold, otherThreshold, branch, requirePicture, openRequired, category, serviceType, expectedCompletionTime, autoAssignable, serviceActionPriorityId, preventativeMaintenanceId) {
        return $http.post(_app2.default.api + "/action-code/create-service-order-action-codes", {
            actionCodeLabel: actionCodeLabel, actionCode: actionCode, minResponse: minResponse, maxResponse: maxResponse, minRootCause: minRootCause, maxRootCause: maxRootCause, thresholds: thresholds, partsCapture: partsCapture, resolveCodes: resolveCodes, rootCauses: rootCauses,
            redThreshold: redThreshold, orangeThreshold: orangeThreshold, yellowThreshold: yellowThreshold, otherThreshold: otherThreshold, branch: branch, requirePicture: requirePicture, openRequired: openRequired, category: category, serviceType: serviceType, expectedCompletionTime: expectedCompletionTime, autoAssignable: autoAssignable, serviceActionPriorityId: serviceActionPriorityId, preventativeMaintenanceId: preventativeMaintenanceId
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        create: create,
        all: all,
        getActionCodes: getActionCodes,
        updateCodeResponse: updateCodeResponse,
        createServiceOrderActionCodes: createServiceOrderActionCodes
    };
};

ActionCodeService.$inject = ["$http", "$q"];

exports.default = ActionCodeService;

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtmCodesManagementService = function AtmCodesManagementService($http, $q) {

    var getVaultDateRoutes = function getVaultDateRoutes(branch, vaultDate) {
        return $http.post(_app2.default.api + '/atm-codes-management/vault-date-routes', {
            branch: branch,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var getRouteLocation = function getRouteLocation(selectedDay, selectedRoute, branchId, vaultDate) {
        return $http.post(_app2.default.api + '/atm-codes-management/get-route-location', {
            selectedDay: selectedDay,
            selectedRoute: selectedRoute,
            branchId: branchId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/atm-codes-management/create', data).then(function (res) {
            return res.data;
        });
    };

    var autoOpenLocks = function autoOpenLocks(routeId, branchId, vaultDate, isAutoOpenATMs, messengerId, performedById) {
        return $http.post(_app2.default.api + '/atm-codes-management/auto-open-locks', {
            routeId: routeId,
            branchId: branchId,
            vaultDate: vaultDate,
            isAutoOpenATMs: isAutoOpenATMs,
            messengerId: messengerId,
            performedById: performedById
        }).then(function (res) {
            return res.data;
        });
    };

    var getLockStatus = function getLockStatus(routeId, branchId, vaultDate, isAutoOpenATMs) {
        return $http.post(_app2.default.api + '/atm-codes-management/get-lock-status', {
            routeId: routeId,
            branchId: branchId,
            vaultDate: vaultDate,
            isAutoOpenATMs: isAutoOpenATMs
        }).then(function (res) {
            return res.data;
        });
    };

    var removeCharacter = function removeCharacter(message) {
        if (!message) return message;
        return message.replace(/&quot;/g, '');
    };

    var autoOpenATMLocksProgress = function autoOpenATMLocksProgress(routeId, vaultDate, messengerId) {
        return $http.get(_app2.default.api + '/atm-codes-management/auto-open-atm-locks-progress', {
            params: { routeId: routeId, vaultDate: vaultDate, messengerId: messengerId }
        }).then(function (res) {
            return res.data;
        });
    };

    var reassignLock = function reassignLock(lockType, toKeyId, locationId, company, performedById, routeId, messengerId, vaultDate, branchId) {
        return $http.post(_app2.default.api + '/atm-codes-management/reassign-lock', {
            lockType: lockType, toKeyId: toKeyId, locationId: locationId, company: company, performedById: performedById, routeId: routeId, messengerId: messengerId, vaultDate: vaultDate, branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getVaultDateRoutes: getVaultDateRoutes,
        getRouteLocation: getRouteLocation,
        create: create,
        autoOpenLocks: autoOpenLocks,
        getLockStatus: getLockStatus,
        removeCharacter: removeCharacter,
        autoOpenATMLocksProgress: autoOpenATMLocksProgress,
        reassignLock: reassignLock
    };
};

AtmCodesManagementService.$inject = ['$http', '$q'];

exports.default = AtmCodesManagementService;

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtmMakesService = function AtmMakesService($http, $q) {

    var all = function all(query, offset, limit, active) {
        return $http.get(_app2.default.api + '/atm-makes', {
            params: {
                query: query,
                offset: offset,
                limit: limit,
                active: active
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/atm-makes', data).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.put(_app2.default.api + ('/atm-makes/' + id), data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id) {
        return $http.delete(_app2.default.api + ('/atm-makes/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        update: update,
        remove: remove
    };
};

AtmMakesService.$inject = ['$http', '$q'];

exports.default = AtmMakesService;

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtmResidualDepositService = function AtmResidualDepositService($http, $q) {

    // let all = (search, offset, limit) => {
    //     return $http
    //         .get(AppConstants.api + `/atm-residual-deposit`, {
    //             params: {
    //                 search,
    //                 offset,
    //                 limit
    //             }
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // };

    // let getPendingDeposit = (branchId, fundingSourceId, currencyId, account, vaultDate) => {
    //     return $http
    //         .post(AppConstants.api + `/atm-residual-deposit/get-pending-deposit`, {
    //             branchId,
    //             fundingSourceId,
    //             currencyId,
    //             account,
    //             vaultDate,
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // };

    // let commitDeposit = (branchId, fundingSourceId, bulkCashData, orderNumber, trackingId, vaultDate, totalAmount, carrierId, userId, currencyId) => {
    //     return $http
    //         .post(AppConstants.api + `/atm-residual-deposit/commit-atm-deposit`, {
    //             branchId,
    //             fundingSourceId,
    //             bulkCashData,
    //             orderNumber,
    //             trackingId,
    //             vaultDate,
    //             totalAmount,
    //             carrierId,
    //             userId,
    //             currencyId
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // };

    // let getPackedResidualDeposit = (search, offset, limit) => {
    //     return $http
    //         .get(AppConstants.api + `/atm-residual-deposit/get-packed-deposit`, {
    //             params: {
    //                 search,
    //                 offset,
    //                 limit
    //             }
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // }

    // let getShipmentsDenomination = (branchId, account, toLocationId) => {
    //     return $http
    //         .post(AppConstants.api + `/atm-residual-deposit/get-shipments-denomination`, {
    //             branchId,
    //             account,
    //             toLocationId
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // };

    // let shipDepositPacking = (shippingData) => {
    //     return $http
    //         .post(AppConstants.api + `/atm-residual-deposit/ship-deposit-packing`, {
    //             shippingData
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // };

    // let getPendingResidualDeposit = (search, offset, limit) => {
    //     return $http
    //         .get(AppConstants.api + `/atm-residual-deposit/pending-residual-deposit`, {
    //             params: {
    //                 search,
    //                 offset,
    //                 limit
    //             }
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // }

    var getPendingResidualDeposit = function getPendingResidualDeposit(branchId, fundingLocationId, fundingSourceId, currencyId, limit, offset) {
        return $http.get(_app2.default.api + '/atm-residual-deposit/residuals-pending', {
            params: {
                branchId: branchId,
                fundingLocationId: fundingLocationId,
                fundingSourceId: fundingSourceId,
                currencyId: currencyId,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var commitDeposit = function commitDeposit(branchId, fundingLocationId, fundingSourceId, currencyId, trackingId, account, carrierId, userId, residualIds, toLocationId, routeId, deliveryDate) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/pack', {
            branchId: branchId,
            fundingLocationId: fundingLocationId,
            fundingSourceId: fundingSourceId,
            currencyId: currencyId,
            trackingId: trackingId,
            account: account,
            carrierId: carrierId,
            userId: userId,
            residualIds: residualIds,
            toLocationId: toLocationId,
            routeId: routeId,
            deliveryDate: deliveryDate
        }).then(function (res) {
            return res.data;
        });
    };

    var residualPackPreview = function residualPackPreview(branchId, fundingLocationId, fundingSourceId, currencyId, trackingId, residualIds) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/pack-preview', {
            branchId: branchId,
            fundingLocationId: fundingLocationId,
            fundingSourceId: fundingSourceId,
            currencyId: currencyId,
            trackingId: trackingId,
            residualIds: residualIds
        }).then(function (res) {
            return res.data;
        });
    };

    var getPendingRelease = function getPendingRelease(branchId, fundingLocationId, currencyId, account, carrierId, limit, offset) {
        return $http.get(_app2.default.api + '/atm-residual-deposit/pending-release', {
            params: {
                branchId: branchId,
                fundingLocationId: fundingLocationId,
                currencyId: currencyId,
                account: account,
                carrierId: carrierId,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var contents = function contents(depositId, limit, offset) {
        return $http.get(_app2.default.api + '/atm-residual-deposit/contents', {
            params: {
                depositId: depositId,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var release = function release(depositId, isResidualDeposit, branchId, depositTrackingId, carrierId, carrierName, userId) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/release', {
            depositId: depositId,
            isResidualDeposit: isResidualDeposit,
            branchId: branchId,
            depositTrackingId: depositTrackingId,
            carrierId: carrierId,
            carrierName: carrierName,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    var released = function released(branchId, fundingLocationId, currencyId, account, carrierId, startDate, endDate, limit, offset) {
        return $http.get(_app2.default.api + '/atm-residual-deposit/released', {
            params: {
                branchId: branchId,
                fundingLocationId: fundingLocationId,
                currencyId: currencyId,
                account: account,
                carrierId: carrierId,
                startDate: startDate,
                endDate: endDate,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var emergencyPackPreview = function emergencyPackPreview(branchId, fundingLocationId, currencyId) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/pack-preview/emergency', {
            branchId: branchId,
            fundingLocationId: fundingLocationId,
            currencyId: currencyId
        }).then(function (res) {
            return res.data;
        });
    };

    var commitEmergencyDeposit = function commitEmergencyDeposit(branchId, fundingLocationId, currencyId, trackingId, carrierId, userId, toLocationId, routeId, deliveryDate) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/pack/emergency', {
            branchId: branchId,
            fundingLocationId: fundingLocationId,
            currencyId: currencyId,
            trackingId: trackingId,
            carrierId: carrierId,
            userId: userId,
            toLocationId: toLocationId,
            routeId: routeId,
            deliveryDate: deliveryDate
        }).then(function (res) {
            return res.data;
        });
    };

    var exportPendingPackData = function exportPendingPackData(branchId, fundingLocationId, fundingSourceId, currencyId, currencySymbol, limit, offset) {
        return $http.get(_app2.default.api + '/atm-residual-deposit/export-pending-pack', {
            params: {
                branchId: branchId,
                fundingLocationId: fundingLocationId,
                fundingSourceId: fundingSourceId,
                currencyId: currencyId,
                currencySymbol: currencySymbol,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportPackedResidualData = function exportPackedResidualData(branchId, fundingLocationId, currencyId, currencySymbol, account, carrierId, limit, offset) {
        return $http.get(_app2.default.api + '/atm-residual-deposit/export-packed-residual', {
            params: {
                branchId: branchId,
                fundingLocationId: fundingLocationId,
                currencyId: currencyId,
                currencySymbol: currencySymbol,
                account: account,
                carrierId: carrierId,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportReleasedResidualData = function exportReleasedResidualData(branchId, fundingLocationId, currencyId, currencySymbol, account, carrierId, startDate, endDate, limit, offset) {
        return $http.get(_app2.default.api + '/atm-residual-deposit/export-released-residual', {
            params: {
                branchId: branchId,
                fundingLocationId: fundingLocationId,
                currencyId: currencyId,
                currencySymbol: currencySymbol,
                account: account,
                carrierId: carrierId,
                startDate: startDate,
                endDate: endDate,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var undoDepositPack = function undoDepositPack(depositId, force) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/undo', {
            depositId: depositId,
            force: force
        }).then(function (res) {
            return res.data;
        });
    };

    var adHocPackPreview = function adHocPackPreview(branchId, fundingLocationId, currencyId, account, amounts) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/pack-preview/adhoc', {
            branchId: branchId,
            fundingLocationId: fundingLocationId,
            currencyId: currencyId,
            account: account,
            amounts: amounts
        }).then(function (res) {
            return res.data;
        });
    };

    var adHocPack = function adHocPack(branchId, fundingLocationId, currencyId, account, carrierId, userId, deposits, toLocationId, routeId, deliveryDate) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/pack/adhoc', {
            branchId: branchId,
            fundingLocationId: fundingLocationId,
            currencyId: currencyId,
            account: account,
            carrierId: carrierId,
            userId: userId,
            deposits: deposits,
            toLocationId: toLocationId,
            routeId: routeId,
            deliveryDate: deliveryDate
        }).then(function (res) {
            return res.data;
        });
    };

    var ledgerDenomBalance = function ledgerDenomBalance(branchId, account, fundingLocationId) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/ledger-denom-balance', {
            branchId: branchId,
            account: account,
            fundingLocationId: fundingLocationId
        }).then(function (res) {
            return res.data;
        });
    };

    var ledgerDenomBalanceFundingSource = function ledgerDenomBalanceFundingSource(branchId, account, fundingLocationId) {
        var params = {
            branchId: branchId,
            account: account
        };

        // Add fundingLocationId if provided for BFS filtering
        if (fundingLocationId) {
            params.fundingLocationId = fundingLocationId;
        }

        return $http.post(_app2.default.api + '/atm-residual-deposit/ledger-denom-balance-funding-source', params).then(function (res) {
            return res.data;
        });
    };

    var exportReleasedDeposit = function exportReleasedDeposit(depositId) {
        return $http.get(_app2.default.api + '/atm-residual-deposit/export-released-deposit', {
            params: {
                depositId: depositId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var commitDepositCount = function commitDepositCount(fundingSource, trackingId, comment, denomsData, branchId, pickupDate, pickupTime, branchTimeZone, countedByUserId, declaredTotalAmount, countedVariance, supervisorId, browserTimezone, monthlySupervisorId, monthlyCashCountLimitAmount, totalCountedThisMonth, newCountAmount, notes) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/deposit-count-commit', {
            fundingSource: fundingSource,
            trackingId: trackingId,
            comment: comment,
            notes: notes,
            denomsData: denomsData,
            branchId: branchId,
            pickupDate: pickupDate,
            pickupTime: pickupTime,
            branchTimeZone: branchTimeZone,
            countedByUserId: countedByUserId,
            declaredTotalAmount: declaredTotalAmount,
            countedVariance: countedVariance,
            supervisorId: supervisorId,
            browserTimezone: browserTimezone,
            monthlySupervisorId: monthlySupervisorId,
            monthlyCashCountLimitAmount: monthlyCashCountLimitAmount,
            totalCountedThisMonth: totalCountedThisMonth,
            newCountAmount: newCountAmount
        }).then(function (res) {
            return res.data;
        });
    };

    var editDepositCount = function editDepositCount(fundingSource, trackingId, comment, denomsData, branchId, pickupDate, pickupTime, branchTimeZone, countedByUserId, depositId, declaredTotalAmount, countedVariance, supervisorId, browserTimezone, monthlySupervisorId, monthlyCashCountLimitAmount, totalCountedThisMonth, newCountAmount, notes) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/deposit-count-edit', {
            fundingSource: fundingSource,
            trackingId: trackingId,
            comment: comment,
            notes: notes,
            denomsData: denomsData,
            branchId: branchId,
            pickupDate: pickupDate,
            pickupTime: pickupTime,
            branchTimeZone: branchTimeZone,
            countedByUserId: countedByUserId,
            depositId: depositId,
            declaredTotalAmount: declaredTotalAmount,
            countedVariance: countedVariance,
            supervisorId: supervisorId,
            browserTimezone: browserTimezone,
            monthlySupervisorId: monthlySupervisorId,
            monthlyCashCountLimitAmount: monthlyCashCountLimitAmount, totalCountedThisMonth: totalCountedThisMonth, newCountAmount: newCountAmount
        }).then(function (res) {
            return res.data;
        });
    };

    var getDepositShipmentRecord = function getDepositShipmentRecord(trackingId, fundingSource) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/get-deposit-shipment', {
            trackingId: trackingId
        }).then(function (res) {
            return res.data;
        });
    };

    var createResidualDepositShipment = function createResidualDepositShipment(residualTrackingId) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/create-residual-deposit-shipment', {
            residualTrackingId: residualTrackingId
        }).then(function (res) {
            return res.data;
        });
    };

    var getBulkDepositShipmentRecord = function getBulkDepositShipmentRecord(trackingId, fundingSource) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/get-bulk-deposit-shipment', {
            trackingId: trackingId,
            fundingSource: fundingSource
        }).then(function (res) {
            return res.data;
        });
    };

    var createIndividualBagShipment = function createIndividualBagShipment(bulkDepositTrackingId, bagTrackingId, declaredAmount, userId) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/create-individual-bag-shipment', {
            bulkDepositTrackingId: bulkDepositTrackingId,
            bagTrackingId: bagTrackingId,
            declaredAmount: declaredAmount,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    var finalizeBulkDeposit = function finalizeBulkDeposit(trackingId, userId) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/finalize-bulk-deposit', {
            trackingId: trackingId,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    var reopenBulkDeposit = function reopenBulkDeposit(trackingId, userId) {
        return $http.post(_app2.default.api + '/atm-residual-deposit/reopen-bulk-deposit', {
            trackingId: trackingId,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    var getMonthlyCountCheck = function getMonthlyCountCheck(locationId, newCountAmount, branchId, month, shiptype) {
        return $http.get(_app2.default.api + '/atm-residual-deposit/monthly-count-check', {
            params: {
                locationId: locationId,
                newCountAmount: Number((newCountAmount || 0).toFixed(2)),
                branchId: branchId,
                month: month,
                shiptype: shiptype
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        // all,
        // getPendingDeposit,
        // getPackedResidualDeposit,
        // getShipmentsDenomination,
        residualPackPreview: residualPackPreview,
        getPendingResidualDeposit: getPendingResidualDeposit,
        commitDeposit: commitDeposit,
        getPendingRelease: getPendingRelease,
        contents: contents,
        release: release,
        released: released,
        emergencyPackPreview: emergencyPackPreview,
        commitEmergencyDeposit: commitEmergencyDeposit,
        exportPendingPackData: exportPendingPackData,
        exportPackedResidualData: exportPackedResidualData,
        exportReleasedResidualData: exportReleasedResidualData,
        undoDepositPack: undoDepositPack,
        adHocPackPreview: adHocPackPreview,
        adHocPack: adHocPack,
        ledgerDenomBalance: ledgerDenomBalance,
        exportReleasedDeposit: exportReleasedDeposit,
        ledgerDenomBalanceFundingSource: ledgerDenomBalanceFundingSource,
        commitDepositCount: commitDepositCount,
        getDepositShipmentRecord: getDepositShipmentRecord,
        createResidualDepositShipment: createResidualDepositShipment,
        getBulkDepositShipmentRecord: getBulkDepositShipmentRecord,
        createIndividualBagShipment: createIndividualBagShipment,
        finalizeBulkDeposit: finalizeBulkDeposit,
        editDepositCount: editDepositCount,
        reopenBulkDeposit: reopenBulkDeposit,
        getMonthlyCountCheck: getMonthlyCountCheck
    };
};

AtmResidualDepositService.$inject = ['$http', '$q'];

exports.default = AtmResidualDepositService;

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AtmResidualService = function AtmResidualService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/atm-residual', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var ResidualCountCommit = function ResidualCountCommit(fundingSourceId, branchId, pickupDate, pickupTime, branchTimeZone, countedByUserId, children, parentResidual, supervisorId, unfitDenomsData, monthlySupervisorId, monthlyCashCountLimitAmount, totalCountedThisMonth, newCountAmount) {
        return $http.post(_app2.default.api + '/atm-residual/residual-count-commit', {
            fundingSourceId: fundingSourceId,
            branchId: branchId,
            pickupDate: pickupDate,
            pickupTime: pickupTime,
            branchTimeZone: branchTimeZone,
            countedByUserId: countedByUserId,
            children: children,
            parentResidual: parentResidual,
            supervisorId: supervisorId,
            unfitDenomsData: unfitDenomsData,
            monthlySupervisorId: monthlySupervisorId,
            monthlyCashCountLimitAmount: monthlyCashCountLimitAmount,
            totalCountedThisMonth: totalCountedThisMonth,
            newCountAmount: newCountAmount
        }).then(function (res) {
            return res.data;
        });
    };

    var getResidualShipments = function getResidualShipments(trackingId, toLocationId) {
        return $http.post(_app2.default.api + '/atm-residual/get-residual-shipment', {
            trackingId: trackingId,
            toLocationId: toLocationId
        }).then(function (res) {
            return res.data;
        });
    };

    var getResidualBagCount = function getResidualBagCount(fundingSourceId, branchId) {
        return $http.post(_app2.default.api + '/atm-residual/remaining-residual-bag', {
            fundingSourceId: fundingSourceId,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var findAtmResidualRecord = function findAtmResidualRecord(orderNo, deliveryShipmentId, residualShipmentId) {
        return $http.post(_app2.default.api + '/atm-residual/update-order-type', {
            orderNo: orderNo,
            deliveryShipmentId: deliveryShipmentId,
            residualShipmentId: residualShipmentId
        }).then(function (res) {
            return res.data;
        });
    };

    var orderHistory = function orderHistory(branch, startDate, endDate, fundingSource, customerId, searchText, offset, limit) {
        var currencyId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;

        return $http.post(_app2.default.api + '/atm-residual/get-counted-residuals', {
            branch: branch,
            startDate: startDate,
            endDate: endDate,
            fundingSource: fundingSource,
            customerId: customerId,
            searchText: searchText,
            offset: offset,
            limit: limit,
            currencyId: currencyId
        }).then(function (res) {
            return res.data;
        });
    };

    var ResidualCountEdit = function ResidualCountEdit(branchId, countedByUserId, children, parentResidual, branchFundingSourceId, unfitDenomsData, monthlySupervisorId, monthlyCashCountLimitAmount, totalCountedThisMonth, newCountAmount) {
        return $http.post(_app2.default.api + '/atm-residual/residual-count-edit', {
            branchId: branchId,
            countedByUserId: countedByUserId,
            children: children,
            parentResidual: parentResidual,
            branchFundingSourceId: branchFundingSourceId,
            unfitDenomsData: unfitDenomsData,
            monthlySupervisorId: monthlySupervisorId,
            monthlyCashCountLimitAmount: monthlyCashCountLimitAmount,
            totalCountedThisMonth: totalCountedThisMonth,
            newCountAmount: newCountAmount
        }).then(function (res) {
            return res.data;
        });
    };

    var errorShipmentList = function errorShipmentList(branchId, fundingSourceId, startDate, endDate, searchText, offset, limit) {
        var currencyId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

        return $http.post(_app2.default.api + '/atm-residual/shipment-request-error', {
            branchId: branchId,
            fundingSourceId: fundingSourceId,
            startDate: startDate,
            endDate: endDate,
            searchText: searchText,
            offset: offset,
            limit: limit,
            currencyId: currencyId
        }).then(function (res) {
            return res.data;
        });
    };

    var unpackedShipmentList = function unpackedShipmentList(branchId, startDate, endDate, fundingSourceId, customerId, searchText, limit, offset) {
        var currencyId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;

        return $http.post(_app2.default.api + '/atm-residual/unpacked-shipments', {
            branchId: branchId,
            startDate: startDate,
            endDate: endDate,
            fundingSourceId: fundingSourceId,
            customerId: customerId,
            searchText: searchText,
            limit: limit,
            offset: offset,
            currencyId: currencyId
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentInProcess = function shipmentInProcess(branch, startDate, endDate, fundingSource, customerId, searchText, offset, limit) {
        var currencyId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;

        return $http.post(_app2.default.api + '/atm-residual/shipment-in-process', {
            branch: branch,
            startDate: startDate,
            endDate: endDate,
            fundingSource: fundingSource,
            customerId: customerId,
            searchText: searchText,
            offset: offset,
            limit: limit,
            currencyId: currencyId
        }).then(function (res) {
            return res.data;
        });
    };

    var getVaultDate = function getVaultDate(branchId, trackingId) {
        return $http.get(_app2.default.api + '/atm-residual/get-vault-date', {
            params: {
                branchId: branchId,
                trackingId: trackingId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getResidualsCountCommit = function getResidualsCountCommit(searchText, fundingSourceId, startDate, endDate, denoms, user, offset, limit) {
        return $http.get(_app2.default.api + '/atm-residual/get-residual-count-commit', {
            params: {
                searchText: searchText,
                fundingSourceId: fundingSourceId,
                startDate: startDate,
                endDate: endDate,
                denoms: denoms,
                user: user
                // offset,
                // limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getCountedUsers = function getCountedUsers(branchId, fundingSourceId, startDate, endDate, searchText, offset, limit, status) {
        return $http.get(_app2.default.api + '/atm-residual/get-counted-users', {
            params: {
                branchId: branchId,
                fundingSourceId: fundingSourceId,
                startDate: startDate,
                endDate: endDate,
                searchText: searchText,
                offset: offset,
                limit: limit,
                status: status
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var authorizeResidualCount = function authorizeResidualCount(fundingSourceId, branchId, userId) {
        return $http.post(_app2.default.api + '/atm-residual/authorize-residual-count', {
            fundingSourceId: fundingSourceId,
            branchId: branchId,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    var authorizeDepositsCount = function authorizeDepositsCount(fundingSourceId, branchId, userId, searchText, startDate, endDate, user, denoms) {
        return $http.post(_app2.default.api + '/atm-residual/authorize-deposits-count', {
            fundingSourceId: fundingSourceId,
            branchId: branchId,
            userId: userId,
            searchText: searchText,
            startDate: startDate,
            endDate: endDate,
            user: user,
            denoms: denoms
        }).then(function (res) {
            return res.data;
        });
    };

    var getResidualsCompletedApproval = function getResidualsCompletedApproval(searchText, fundingSourceId, timezone, startDate, endDate, denoms, user, offset, limit) {
        return $http.get(_app2.default.api + '/atm-residual/get-residuals-completed-approval', {
            params: {
                searchText: searchText,
                fundingSourceId: fundingSourceId,
                timezone: timezone,
                startDate: startDate,
                endDate: endDate,
                denoms: denoms,
                user: user,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getDepositsCompletedApproval = function getDepositsCompletedApproval(searchText, fundingSourceId, timezone, startDate, endDate, user, denoms, offset, limit) {
        return $http.get(_app2.default.api + '/atm-residual/get-deposits-completed-approval', {
            params: {
                searchText: searchText,
                fundingSourceId: fundingSourceId,
                timezone: timezone,
                startDate: startDate,
                endDate: endDate,
                user: user,
                denoms: denoms,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportResidualsCompletedApproval = function exportResidualsCompletedApproval(searchText, fundingSourceId, timezone, startDate, endDate, denoms, user, offset, limit) {
        return $http.get(_app2.default.api + '/atm-residual/export-residuals-completed-approval', {
            params: {
                searchText: searchText,
                fundingSourceId: fundingSourceId,
                timezone: timezone,
                startDate: startDate,
                endDate: endDate,
                denoms: denoms,
                user: user,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportDepositsResidualsCompletedApproval = function exportDepositsResidualsCompletedApproval(searchText, fundingSourceId, timezone, startDate, endDate, user, denoms, offset, limit) {
        return $http.get(_app2.default.api + '/atm-residual/export-deposits-residuals-completed-approval', {
            params: {
                searchText: searchText,
                fundingSourceId: fundingSourceId,
                timezone: timezone,
                startDate: startDate,
                endDate: endDate,
                user: user,
                denoms: denoms,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportRemainingResiduals = function exportRemainingResiduals(route, vaultDate, messengerId, fundingSourceId, branchId, customerIds) {
        return $http.get(_app2.default.api + '/atm-residual/export-remaining-residuals', {
            params: {
                route: route,
                vaultDate: vaultDate,
                messengerId: messengerId,
                fundingSourceId: fundingSourceId,
                branchId: branchId,
                customerIds: customerIds === null ? null : customerIds.join(',')
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var convertToCRV = function convertToCRV(branchId, routeId, trackingId, supervisorId) {
        return $http.post(_app2.default.api + '/atm-residual/convert-to-crv', {
            branchId: branchId,
            routeId: routeId,
            trackingId: trackingId,
            supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    var getBagoutContent = function getBagoutContent(bagSeal) {
        return $http.get(_app2.default.api + '/atm-residual/get-bagout-content', {
            params: { bagSeal: bagSeal }
        }).then(function (res) {
            return res.data;
        });
    };

    var updateShipmentBagseal = function updateShipmentBagseal(trackingIds, bagId, overrideUserId, fundingSource, userId, routeId) {
        return $http.post(_app2.default.api + '/atm-residual/update-shipment-bagseal', { trackingIds: trackingIds, bagId: bagId, overrideUserId: overrideUserId, fundingSource: fundingSource, userId: userId, routeId: routeId }).then(function (res) {
            return res.data;
        });
    };

    var getExistingUnfitDenominations = function getExistingUnfitDenominations(orderNo, shipmentIds, account) {
        return $http.post(_app2.default.api + '/atm-residual/get-existing-unfit-denominations', { orderNo: orderNo, shipmentIds: shipmentIds, account: account }).then(function (res) {
            return res.data;
        });
    };

    var getDepositDenominationBreakdown = function getDepositDenominationBreakdown(orderNo, trackingId, fromLocationId, countVaultDate) {
        return $http.get(_app2.default.api + '/atm-residual/get-deposit-denomination-breakdown', { params: { orderNo: orderNo, trackingId: trackingId, fromLocationId: fromLocationId, countVaultDate: countVaultDate } }).then(function (res) {
            return res.data;
        });
    };

    var getExpectedResidual = function getExpectedResidual(branchId, trackingId, shipment, fundingSourceId, orderNo) {
        return $http.get(_app2.default.api + '/atm-residual/get-expected-residual', { params: { branchId: branchId, trackingId: trackingId, shipment: shipment, fundingSourceId: fundingSourceId, orderNo: orderNo } }).then(function (res) {
            return res.data;
        });
    };

    var exportOrdersCSV = function exportOrdersCSV(tab, branch, startDate, endDate, fundingSource, customerId, searchText) {
        var currencyId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

        return $http.post(_app2.default.api + '/atm-residual/export-orders-csv', {
            tab: tab,
            branch: branch,
            startDate: startDate,
            endDate: endDate,
            fundingSource: fundingSource,
            customerId: customerId,
            searchText: searchText,
            currencyId: currencyId
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        ResidualCountCommit: ResidualCountCommit,
        getResidualShipments: getResidualShipments,
        getResidualBagCount: getResidualBagCount,
        findAtmResidualRecord: findAtmResidualRecord,
        orderHistory: orderHistory,
        ResidualCountEdit: ResidualCountEdit,
        errorShipmentList: errorShipmentList,
        unpackedShipmentList: unpackedShipmentList,
        shipmentInProcess: shipmentInProcess,
        getVaultDate: getVaultDate,
        getResidualsCountCommit: getResidualsCountCommit,
        getCountedUsers: getCountedUsers,
        authorizeResidualCount: authorizeResidualCount,
        getResidualsCompletedApproval: getResidualsCompletedApproval,
        exportResidualsCompletedApproval: exportResidualsCompletedApproval,
        exportDepositsResidualsCompletedApproval: exportDepositsResidualsCompletedApproval,
        exportRemainingResiduals: exportRemainingResiduals,
        convertToCRV: convertToCRV,
        getBagoutContent: getBagoutContent,
        updateShipmentBagseal: updateShipmentBagseal,
        getExistingUnfitDenominations: getExistingUnfitDenominations,
        getExpectedResidual: getExpectedResidual,
        authorizeDepositsCount: authorizeDepositsCount,
        getDepositsCompletedApproval: getDepositsCompletedApproval,
        getDepositDenominationBreakdown: getDepositDenominationBreakdown,
        exportOrdersCSV: exportOrdersCSV
    };
};

AtmResidualService.$inject = ['$http', '$q'];

exports.default = AtmResidualService;

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutomatedRoutingStopsService = function AutomatedRoutingStopsService($http, $q) {
    var assignAutomatedRoutes = function assignAutomatedRoutes(routeIds, vaultDate, branchId) {
        return $http.post(_app2.default.api + '/automated-routing-control/assign-routes', {
            routes: routeIds, vaultDate: vaultDate, branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };
    var getRouteEstimatedReturnTimes = function getRouteEstimatedReturnTimes(routeIds, vaultDate) {
        return $http.get(_app2.default.api + '/automated-routing-control/get-route-estimated-time', {
            params: { routeIds: routeIds.join(','), date: vaultDate }
        }).then(function (res) {
            return res.data;
        });
    };
    return {
        assignAutomatedRoutes: assignAutomatedRoutes,
        getRouteEstimatedReturnTimes: getRouteEstimatedReturnTimes
    };
};
AutomatedRoutingStopsService.$inject = ['$http', '$q'];

exports.default = AutomatedRoutingStopsService;

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BagoutService = function BagoutService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/bagout', {
            params: {
                "search": search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var closeBagout = function closeBagout(bagoutId, branchId, routeId, date, carrierId, carrierName, supervisorId, shipmentData) {
        return $http.post(_app2.default.api + ('/bagout/' + bagoutId + '/close'), {
            branchId: branchId,
            routeId: routeId,
            date: date,
            carrierId: carrierId,
            carrierName: carrierName,
            supervisorId: supervisorId,
            shipmentData: shipmentData
        }).then(function (res) {
            return res.data;
        });
    };

    var getShipments = function getShipments(bagoutId) {
        return $http.get(_app2.default.api + ('/bagout/' + bagoutId + '/shipments')).then(function (res) {
            return res.data;
        });
    };

    var getBagsealData = function getBagsealData(bagSeal) {
        return $http.get(_app2.default.api + '/bagout/bagseal-data', {
            params: {
                bagSeal: bagSeal
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var undoBagout = function undoBagout(bagSealId, branchId) {
        return $http.post(_app2.default.api + '/bagout/undo-bagout', {
            bagSealId: bagSealId,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var getDeliveryRoutes = function getDeliveryRoutes(id, date) {
        return $http.get(_app2.default.api + ('/bagout/' + id + '/delivery-date-routes?date=' + date)).then(function (res) {
            return res.data;
        });
    };

    var getBagoutData = function getBagoutData(searchText, startDate, endDate, customerId, offset, limit) {
        return $http.post(_app2.default.api + '/bagout/bagout-history', {
            searchText: searchText,
            startDate: startDate,
            endDate: endDate,
            customerId: customerId,
            offset: offset,
            limit: limit
        }).then(function (res) {
            return res.data;
        });
    };

    var exportBagoutHistory = function exportBagoutHistory(searchText, startDate, endDate, offset, limit) {
        return $http.post(_app2.default.api + '/bagout/export-bagout-history', {
            searchText: searchText,
            startDate: startDate,
            endDate: endDate,
            offset: offset,
            limit: limit
        }).then(function (res) {
            return res.data;
        });
    };

    var getRemainingBagoutCount = function getRemainingBagoutCount(branchId, destinationLocationId) {
        return $http.get(_app2.default.api + '/bagout/get-remaining-bagout-count', {
            params: {
                branchId: branchId,
                destinationLocationId: destinationLocationId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getTotalItemsInBagoutCount = function getTotalItemsInBagoutCount(bagSeal) {
        return $http.get(_app2.default.api + '/bagout/get-included-bagout-count', {
            params: {
                bagSeal: bagSeal
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getRemainingBagoutList = function getRemainingBagoutList(branchId, destinationLocationId, offset, limit) {
        return $http.get(_app2.default.api + '/bagout/get-remaining-bagout-list', {
            params: {
                branchId: branchId,
                destinationLocationId: destinationLocationId,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getTotalItemsInBagoutList = function getTotalItemsInBagoutList(bagSeal, offset, limit) {
        return $http.get(_app2.default.api + '/bagout/get-included-bagout-list', {
            params: {
                bagSeal: bagSeal,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var fetchBagSeals = function fetchBagSeals(searchText, startDate, endDate, limit, offset) {
        return $http.get(_app2.default.api + '/bagout/fetch-bag-seals', {
            params: {
                searchText: searchText, startDate: startDate, endDate: endDate, limit: limit, offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var removeTrackingIdFromBagout = function removeTrackingIdFromBagout(trackingId, branchId, bagSealId, fromLocationId, toLocationId, vaultDate) {
        return $http.post(_app2.default.api + '/bagout/remove-tracking-id-from-bagout', { trackingId: trackingId, branchId: branchId, bagSealId: bagSealId, fromLocationId: fromLocationId, toLocationId: toLocationId, vaultDate: vaultDate }).then(function (res) {
            return res.data;
        });
    };

    var deleteBagout = function deleteBagout(bagoutId) {
        return $http.post(_app2.default.api + ('/bagout/' + bagoutId + '/delete'), {}).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        closeBagout: closeBagout,
        getShipments: getShipments,
        getBagsealData: getBagsealData,
        undoBagout: undoBagout,
        getDeliveryRoutes: getDeliveryRoutes,
        getBagoutData: getBagoutData,
        exportBagoutHistory: exportBagoutHistory,
        getRemainingBagoutCount: getRemainingBagoutCount,
        getTotalItemsInBagoutCount: getTotalItemsInBagoutCount,
        getRemainingBagoutList: getRemainingBagoutList,
        getTotalItemsInBagoutList: getTotalItemsInBagoutList,
        fetchBagSeals: fetchBagSeals,
        removeTrackingIdFromBagout: removeTrackingIdFromBagout,
        deleteBagout: deleteBagout
    };
};

BagoutService.$inject = ['$http', '$q'];

exports.default = BagoutService;

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BatchService = function BatchService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/batch', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data, branchId) {
        return $http.post(_app2.default.api + '/batch/create', {
            data: data,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + ('/batch/' + id), {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data, branchId) {
        return $http.post(_app2.default.api + ('/batch/' + id), {
            data: data,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/batch/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get
    };
};

BatchService.$inject = ['$http', '$q'];

exports.default = BatchService;

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillableEventsService = function BillableEventsService($http, $q) {

    var getAllEntryTypes = function getAllEntryTypes(searchText, limit, offset) {
        return $http.get(_app2.default.api + '/billable-events/get-all-entry-types', {
            params: {
                searchText: searchText,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/billable-events/create-billable-events', data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, billingCategory, event, branchId) {
        return $http.delete(_app2.default.api + '/billable-events/delete-billable-events', {
            params: {
                id: id,
                billingCategory: billingCategory,
                event: event,
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/billable-events', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/billable-events/' + id + '/update'), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/billable-events/' + id + '/details')).then(function (res) {
            return res.data;
        });
    };

    var getBillingCategory = function getBillingCategory(searchText, limit, offset) {
        return $http.get(_app2.default.api + '/billable-events/get-billing-category', {
            params: {
                searchText: searchText,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getAllEntryTypes: getAllEntryTypes,
        create: create,
        remove: remove,
        all: all,
        update: update,
        get: get,
        getBillingCategory: getBillingCategory
    };
};

BillableEventsService.$inject = ['$http', '$q'];

exports.default = BillableEventsService;

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingCategoryService = function BillingCategoryService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/billing-category', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/billing-category/create-billing-category', data).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/billing-category/' + id + '/update'), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/billing-category/' + id + '/details')).then(function (res) {
            return res.data;
        });
    };

    return {
        create: create,
        all: all,
        update: update,
        get: get
    };
};

BillingCategoryService.$inject = ['$http', '$q'];

exports.default = BillingCategoryService;

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingRecordsService = function BillingRecordsService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + "/billing-records", {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getBillableCustomer = function getBillableCustomer(searchText, currentStat, offset, limit, startDate, endDate, branchId, billableEvents, billingCategory, customer) {
        return $http.get(_app2.default.api + "/billing-records/get-billable-customer", {
            params: {
                searchText: searchText,
                currentStat: currentStat,
                offset: offset,
                limit: limit,
                startDate: startDate,
                endDate: endDate,
                branchId: branchId,
                billableEvents: billableEvents,
                billingCategory: billingCategory,
                customer: customer
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getBillingRecords = function getBillingRecords(searchText, customerId, sortASC, sortColumn, currentStat, offset, limit, startDate, endDate, branchId, billableEvents, billingCategory, customer) {
        return $http.get(_app2.default.api + "/billing-records/get-billing-records", {
            params: {
                searchText: searchText,
                customerId: customerId,
                sortASC: sortASC,
                sortColumn: sortColumn,
                currentStat: currentStat,
                offset: offset,
                limit: limit,
                startDate: startDate,
                endDate: endDate,
                branchId: branchId,
                billableEvents: billableEvents,
                billingCategory: billingCategory,
                customer: customer
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var approveBillingRecords = function approveBillingRecords(billingRecords, userId, isApproveAllRecords, startDate, endDate, customerId, locationId, billingCategoryId) {
        return $http.post(_app2.default.api + "/billing-records/approve-billing-records", {
            billingRecords: billingRecords,
            userId: userId,
            isApproveAllRecords: isApproveAllRecords,
            startDate: startDate,
            endDate: endDate,
            customerId: customerId,
            locationId: locationId,
            billingCategoryId: billingCategoryId
        }).then(function (res) {
            return res.data;
        });
    };

    var surchargePreview = function surchargePreview(billingRecordIds, isApproveAllRecords, startDate, endDate, customerId, locationId, billingCategoryId) {
        return $http.post(_app2.default.api + "/billing-records/surcharge-preview", {
            billingRecordIds: billingRecordIds,
            isApproveAllRecords: isApproveAllRecords,
            startDate: startDate,
            endDate: endDate,
            customerId: customerId,
            locationId: locationId,
            billingCategoryId: billingCategoryId
        }).then(function (res) {
            return res.data;
        });
    };

    var updateBillingRecords = function updateBillingRecords(billingRecordId, rate, amountDue, branchId, billingCategory, billingType, locationId, customerId, status, startDate, endDate, isApproved, userId, searchText, selectedBillingCategoryId, selectedCustomerId, selectedBillableEvent, billableEventId, billableEvent) {
        return $http.post(_app2.default.api + "/billing-records/update-billing-records", {
            billingRecordId: billingRecordId,
            rate: rate,
            amountDue: amountDue,
            branchId: branchId,
            billingCategory: billingCategory,
            billingType: billingType,
            status: status,
            customerId: customerId,
            locationId: locationId,
            startDate: startDate,
            endDate: endDate,
            isApproved: isApproved,
            userId: userId,
            searchText: searchText,
            selectedBillingCategoryId: selectedBillingCategoryId,
            selectedCustomerId: selectedCustomerId,
            selectedBillableEvent: selectedBillableEvent,
            billableEventId: billableEventId,
            billableEvent: billableEvent
        }).then(function (res) {
            return res.data;
        });
    };

    var billableEventLogDetails = function billableEventLogDetails(searchText, entryType, branchId, startDate, endDate) {
        return $http.get(_app2.default.api + "/billing-records/billable-event-log-details", {
            params: {
                searchText: searchText,
                entryType: entryType,
                branchId: branchId,
                startDate: startDate,
                endDate: endDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportBillingReport = function exportBillingReport(startDate, endDate, currentStat, customerList, childStat, searchText, branchId, billableEvents, billingCategory, customer) {
        return new _promise2.default(function (resolve, reject) {
            var url = _app2.default.api + "/billing-records/export-billing-report";
            var xhr = new XMLHttpRequest();

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = {
                startDate: startDate,
                endDate: endDate,
                currentStat: currentStat,
                customerList: customerList,
                childStat: childStat,
                searchText: searchText,
                branchId: branchId,
                billableEvents: billableEvents,
                billingCategory: billingCategory,
                customer: customer
            };

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" });
                    var a = document.createElement('a');
                    var reportPrefix = 'Billing_Approval';
                    var date = moment.utc(startDate).format('YYYY-MM-DD') + '_To_' + moment.utc(endDate).format('YYYY-MM-DD');

                    var sheetName = void 0;
                    if (currentStat == 'unassigned') {
                        sheetName = reportPrefix.concat("_(" + currentStat + ")_" + childStat + "_", date, '.xlsx');
                    } else {
                        sheetName = reportPrefix.concat("_(" + currentStat + ")_", date, '.xlsx');
                    }

                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    return resolve();
                } else {
                    return reject();
                }
            };
            xhr.send((0, _stringify2.default)(data));
        });
    };

    var generateStaticBillingRecord = function generateStaticBillingRecord(billingEventType) {
        return $http.post(_app2.default.api + "/billing-records/generate-static-billing-report", {
            billingEventType: billingEventType
        }).then(function (res) {
            return res.data;
        });
    };

    var getStaticBillingEventsRecords = function getStaticBillingEventsRecords(staticBillingCategory, vaultDate, contractId, contractRuleId, locationId, limit, offset, currentStat) {
        return $http.get(_app2.default.api + "/billing-records/get-static-billing-events-records", {
            params: { staticBillingCategory: staticBillingCategory, vaultDate: vaultDate, contractId: contractId, contractRuleId: contractRuleId, locationId: locationId, limit: limit, offset: offset, currentStat: currentStat }
        }).then(function (res) {
            return res.data;
        });
    };

    var deleteBillingRecord = function deleteBillingRecord(data) {
        return $http.post(_app2.default.api + "/billing-records/delete-billing-record", data).then(function (res) {
            return res.data;
        });
    };

    var createPostBillingRecords = function createPostBillingRecords(month, contractId) {
        return $http.post(_app2.default.api + "/billing-records/create-post-billing-records", { month: month, contractId: contractId }).then(function (res) {
            return res.data;
        });
    };

    var undoApproveBillingRecords = function undoApproveBillingRecords(data) {
        return $http.post(_app2.default.api + "/billing-records/undo-approve-billing-records", { data: data }).then(function (res) {
            return res.data;
        });
    };

    var findCustomerContractByLocation = function findCustomerContractByLocation(locationId) {
        return $http.get(_app2.default.api + "/billing-records/find-customer-contract-by-location", { params: { locationId: locationId } }).then(function (res) {
            return res.data;
        });
    };

    var createBillingRecords = function createBillingRecords(data) {
        return $http.post(_app2.default.api + "/billing-records/create-billing-records", data).then(function (res) {
            return res.data;
        });
    };

    var manuallyCreatedBillingRecordsLog = function manuallyCreatedBillingRecordsLog(billingRecordId) {
        return $http.get(_app2.default.api + "/billing-records/manually-created-billing-records-log", {
            params: { billingRecordId: billingRecordId }
        }).then(function (res) {
            return res.data;
        });
    };

    var getEventLogs = function getEventLogs(entryType, locationId, vaultDate, branchId) {
        return $http.get(_app2.default.api + "/billing-records/get-event-logs", {
            params: { entryType: entryType, locationId: locationId, vaultDate: vaultDate, branchId: branchId }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        getBillableCustomer: getBillableCustomer,
        getBillingRecords: getBillingRecords,
        approveBillingRecords: approveBillingRecords,
        surchargePreview: surchargePreview,
        updateBillingRecords: updateBillingRecords,
        billableEventLogDetails: billableEventLogDetails,
        exportBillingReport: exportBillingReport,
        generateStaticBillingRecord: generateStaticBillingRecord,
        getStaticBillingEventsRecords: getStaticBillingEventsRecords,
        deleteBillingRecord: deleteBillingRecord,
        createPostBillingRecords: createPostBillingRecords,
        undoApproveBillingRecords: undoApproveBillingRecords,
        findCustomerContractByLocation: findCustomerContractByLocation,
        createBillingRecords: createBillingRecords,
        manuallyCreatedBillingRecordsLog: manuallyCreatedBillingRecordsLog,
        getEventLogs: getEventLogs
    };
};

BillingRecordsService.$inject = ['$http', '$q'];

exports.default = BillingRecordsService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceHolidayService = function BranchFundingSourceHolidayService($http, $q) {

    var all = function all(search, branchId, offset, limit) {
        return $http.get(_app2.default.api + '/branch-funding-source-holiday', {
            params: {
                search: search,
                branchId: branchId,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/branch-funding-source-holiday/create', data).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/branch-funding-source-holiday/' + id + '/update'), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/branch-funding-source-holiday/' + id + '/detail')).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchFundingSourceId, branchId) {
        return $http.delete(_app2.default.api + ('/branch-funding-source-holiday/' + id + '/delete'), {
            params: {
                branchId: branchId,
                branchFundingSourceId: branchFundingSourceId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get
    };
};

BranchFundingSourceHolidayService.$inject = ['$http', '$q'];

exports.default = BranchFundingSourceHolidayService;

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceOrderProfileService = function BranchFundingSourceOrderProfileService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/branch-funding-source-order-profile', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/branch-funding-source-order-profile/create', {
            data: data
        }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/branch-funding-source-order-profile/' + id + '/update'), {
            data: data
        }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/branch-funding-source-order-profile/' + id + '/detail')).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + ('/branch-funding-source-order-profile/' + id + '/delete'), {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get
    };
};

BranchFundingSourceOrderProfileService.$inject = ['$http', '$q'];

exports.default = BranchFundingSourceOrderProfileService;

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchFundingSourceService = function BranchFundingSourceService($http, $q) {

    var all = function all(search, offset, limit, customerId) {
        return $http.get(_app2.default.api + '/branch-funding-source', {
            params: {
                search: search,
                offset: offset,
                limit: limit,
                customerId: customerId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/branch-funding-source/create', data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        var query = '';
        if (id) {
            query = '?branchFundingSourceId=' + id;
        }
        return $http.get(_app2.default.api + '/branch-funding-source/getBranchFunding' + query).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/branch-funding-source/' + id + '/update'), data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + '/branch-funding-source/delete-funding-source', {
            params: {
                id: id,
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var fundingSourceLocation = function fundingSourceLocation(locationId, searchText, branchId, limit, offset) {
        return $http.post(_app2.default.api + '/branch-funding-source/funding-source-location', {
            locationId: locationId,
            searchText: searchText,
            branchId: branchId,
            limit: limit,
            offset: offset
        }).then(function (res) {
            return res.data;
        });
    };

    var getFundingSourceHolidayCount = function getFundingSourceHolidayCount(branchFundingSourceId, startDate, endDate) {
        return $http.get(_app2.default.api + ('/branch-funding-source/' + branchFundingSourceId + '/funding-source-holiday-count'), {
            params: {
                branchFundingSourceId: branchFundingSourceId,
                startDate: startDate,
                endDate: endDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getDenominations = function getDenominations() {
        return $http.get(_app2.default.api + '/branch-funding-source/get-denominations').then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        get: get,
        update: update,
        remove: remove,
        fundingSourceLocation: fundingSourceLocation,
        getFundingSourceHolidayCount: getFundingSourceHolidayCount,
        getDenominations: getDenominations
    };
};

BranchFundingSourceService.$inject = ['$http', '$q'];

exports.default = BranchFundingSourceService;

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchPerformanceService = function BranchPerformanceService($http, $q) {

    var getRouteMessenger = function getRouteMessenger(startDate, endDate, branchIds, eventRoute) {
        return $http.post(_app2.default.api + "/branch-performance/get-route-messenger", {
            startDate: startDate,
            endDate: endDate,
            branchIds: branchIds,
            eventRoute: eventRoute
        }).then(function (res) {
            return res.data;
        });
    };

    var getRouteStats = function getRouteStats(startDate, endDate, branchIds, eventRoute, messengerId) {
        return $http.post(_app2.default.api + "/branch-performance/get-routes-stats", {
            startDate: startDate,
            endDate: endDate,
            branchIds: branchIds,
            eventRoute: eventRoute,
            messengerId: messengerId
        }).then(function (res) {
            return res.data;
        });
    };

    var getOrderStats = function getOrderStats(startDate, endDate, branchIds, orderType, account, status) {
        return $http.post(_app2.default.api + "/branch-performance/get-orders-stats", {
            startDate: startDate,
            endDate: endDate,
            branchIds: branchIds,
            orderType: orderType,
            account: account,
            status: status
        }).then(function (res) {
            return res.data;
        });
    };

    var getServiceOrderAction = function getServiceOrderAction() {
        return $http.post(_app2.default.api + "/branch-performance/get-service-order-actions", {}).then(function (res) {
            return res.data;
        });
    };

    var getServiceTicketStats = function getServiceTicketStats(startDate, endDate, branchIds, status, actionCode) {
        return $http.post(_app2.default.api + "/branch-performance/get-service-tickets-stats", {
            startDate: startDate,
            endDate: endDate,
            branchIds: branchIds,
            status: status,
            actionCode: actionCode
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getRouteMessenger: getRouteMessenger,
        getRouteStats: getRouteStats,
        getOrderStats: getOrderStats,
        getServiceOrderAction: getServiceOrderAction,
        getServiceTicketStats: getServiceTicketStats
    };
};

BranchPerformanceService.$inject = ["$http", "$q"];

exports.default = BranchPerformanceService;

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchService = function BranchService($http, $q) {
    //don't need this $q 

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/branch', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/branch/create', data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id) {
        return $http.delete(_app2.default.api + ('/branch/' + id)).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/branch/' + id), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/branch/' + id)).then(function (res) {
            return res.data;
        });
    };

    var getReleaseRoutes = function getReleaseRoutes(id, date, coinCheckOut) {
        return $http.get(_app2.default.api + ('/branch/' + id + '/route-list?date=' + date + '&coinCheckOut=' + coinCheckOut)).then(function (res) {
            return res.data;
        });
    };

    var getBranchSetup = function getBranchSetup(id) {
        return $http.get(_app2.default.api + ('/branch/' + id + '/setup')).then(function (res) {
            return res.data;
        });
    };

    var verifyCloseVault = function verifyCloseVault(id, userId, userTimeZone) {
        return $http.post(_app2.default.api + ('/branch/' + id + '/verify-close-vault'), { userId: userId, userTimeZone: userTimeZone }).then(function (res) {
            return res.data;
        });
    };

    var closeVault = function closeVault(id, userId, vaultDate) {
        return $http.post(_app2.default.api + ('/branch/' + id + '/close-vault'), { userId: userId, vaultDate: vaultDate }).then(function (res) {
            return res.data;
        });
    };

    var verifyVault = function verifyVault(id, date) {
        return $http.get(_app2.default.api + ('/branch/' + id + '/verify-vault?date=' + date)).then(function (res) {
            return res.data;
        });
    };

    var truncateRoute = function truncateRoute(id) {
        return $http.post(_app2.default.api + ('/branch/' + id + '/truncate-route')).then(function (res) {
            return res.data;
        });
    };

    var getTankersAvailable = function getTankersAvailable(id) {
        return $http.get(_app2.default.api + ('/branch/' + id + '/tankers-available')).then(function (res) {
            return res.data;
        });
    };

    var validateRouteCheckIn = function validateRouteCheckIn(routeId, vaultDate, branchId, userId) {
        return $http.post(_app2.default.api + ('/branch/' + branchId + '/validate-route-checkIn'), {
            routeId: routeId,
            vaultDate: vaultDate,
            branchId: branchId,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    var cancelShipmentTransfer = function cancelShipmentTransfer(shipmentDetails, cancelTransferState, branchId) {
        return $http.post(_app2.default.api + ('/branch/' + branchId + '/cancel-shipment-transfer'), { shipmentDetails: shipmentDetails, cancelTransferState: cancelTransferState }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get,
        getReleaseRoutes: getReleaseRoutes,
        getBranchSetup: getBranchSetup,
        verifyCloseVault: verifyCloseVault,
        closeVault: closeVault,
        truncateRoute: truncateRoute,
        verifyVault: verifyVault,
        getTankersAvailable: getTankersAvailable,
        validateRouteCheckIn: validateRouteCheckIn,
        cancelShipmentTransfer: cancelShipmentTransfer
    };
};

BranchService.$inject = ['$http', '$q'];

exports.default = BranchService;

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BulkCashService = function BulkCashService($http, $q) {

    var commitBulkCash = function commitBulkCash(branchId, fundingSourceId, bulkCashData, comment, isBulkCash, performedFrom, isDebit, adjustment) {
        return $http.post(_app2.default.api + '/bulk-cash/add-bulk-cash', {
            branchId: branchId,
            fundingSourceId: fundingSourceId,
            bulkCashData: bulkCashData,
            comment: comment,
            isBulkCash: isBulkCash,
            performedFrom: performedFrom,
            isDebit: isDebit,
            adjustment: adjustment
        }).then(function (res) {
            return res.data;
        });
    };

    var ledgerTransactionLog = function ledgerTransactionLog(transactionId, branchId) {
        return $http.get(_app2.default.api + '/bulk-cash/transaction-log', {
            params: {
                transactionId: transactionId,
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var updateBulkCashFlag = function updateBulkCashFlag(ledgerTransactionId, bulkCash) {
        return $http.post(_app2.default.api + '/bulk-cash/update-bulk-cash-flag', {
            ledgerTransactionId: ledgerTransactionId,
            bulkCash: bulkCash
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        commitBulkCash: commitBulkCash,
        ledgerTransactionLog: ledgerTransactionLog,
        updateBulkCashFlag: updateBulkCashFlag
    };
};

BulkCashService.$inject = ['$http', '$q'];

exports.default = BulkCashService;

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BypassCodeService = function BypassCodeService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/bypass-code-usage', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/bypass-code-usage/create', data).then(function (res) {
            return res.data;
        });
    };

    var generateBypassCode = function generateBypassCode(codeType, branchId, routeId, userId, vaultDate, locationId) {
        return $http.get(_app2.default.api + '/bypass-code-usage/generate-bypass-code', {
            params: {
                codeType: codeType,
                branchId: branchId,
                routeId: routeId,
                userId: userId,
                vaultDate: vaultDate,
                locationId: locationId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var closeLock = function closeLock(data) {
        return $http.post(_app2.default.api + '/bypass-code-usage/close-lock', data).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        generateBypassCode: generateBypassCode,
        closeLock: closeLock
    };
};

BypassCodeService.$inject = ['$http', '$q'];

exports.default = BypassCodeService;

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarrierBranchService = function CarrierBranchService($http, $q) {

    var createBranchGroup = function createBranchGroup(carrierId, branches) {
        return $http.post(_app2.default.api + '/carrier-branch/create-carrier-branch', {
            carrierId: carrierId,
            branches: branches
        }).then(function (res) {
            return res.data;
        });
    };

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/carrier-branch', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var updateBranchGroup = function updateBranchGroup(carrierId, branches) {
        return $http.post(_app2.default.api + '/carrier-branch/update-carrier-branch', {
            carrierId: carrierId,
            branches: branches
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        createBranchGroup: createBranchGroup,
        all: all,
        updateBranchGroup: updateBranchGroup
    };
};

CarrierBranchService.$inject = ['$http', '$q'];

exports.default = CarrierBranchService;

/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarrierService = function CarrierService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/carrier', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/carrier/create', data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id) {
        return $http.delete(_app2.default.api + ('/carrier/' + id)).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/carrier/' + id), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/carrier/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get
    };
};

CarrierService.$inject = ['$http', '$q'];

exports.default = CarrierService;

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CashDeliveriesService = function CashDeliveriesService($http, $q) {

    var cashDeliveries = function cashDeliveries(searchText, fromLocationId, branchId, startDate, endDate, offset, limit, sortASC, sortColumn, timezone, customerId, filterByDeliveryDate, filterByVaultDate) {
        return $http.get(_app2.default.api + "/cash-deliveries/cash-deliveries", {
            params: {
                searchText: searchText,
                fromLocationId: fromLocationId,
                branchId: branchId,
                startDate: startDate,
                endDate: endDate,
                offset: offset,
                limit: limit,
                sortASC: sortASC,
                sortColumn: sortColumn,
                timezone: timezone,
                customerId: customerId,
                filterByDeliveryDate: filterByDeliveryDate,
                filterByVaultDate: filterByVaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportCashDeliveries = function exportCashDeliveries(searchText, fromLocationId, branchId, startDate, endDate, sortASC, sortColumn, timezone, customerId, filterByDeliveryDate, filterByVaultDate) {
        return $http.post(_app2.default.api + "/cash-deliveries/export-cash-deliveries", {
            searchText: searchText,
            fromLocationId: fromLocationId,
            branchId: branchId,
            startDate: startDate,
            endDate: endDate,
            sortASC: sortASC,
            sortColumn: sortColumn,
            timezone: timezone,
            customerId: customerId,
            filterByDeliveryDate: filterByDeliveryDate,
            filterByVaultDate: filterByVaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var cashPickups = function cashPickups(searchText, toLocationId, branchId, startDate, endDate, offset, limit, sortASC, sortColumn, timezone, customerId, filterByPickupDate, filterByVaultDate) {
        return $http.get(_app2.default.api + "/cash-deliveries/cash-pickups", {
            params: {
                searchText: searchText,
                toLocationId: toLocationId,
                branchId: branchId,
                startDate: startDate,
                endDate: endDate,
                limit: limit,
                offset: offset,
                sortASC: sortASC,
                sortColumn: sortColumn,
                timezone: timezone,
                customerId: customerId,
                filterByPickupDate: filterByPickupDate,
                filterByVaultDate: filterByVaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportCashPickups = function exportCashPickups(searchText, toLocationId, branchId, startDate, endDate, sortASC, sortColumn, timezone, customerId, filterByPickupDate, filterByVaultDate) {
        return $http.post(_app2.default.api + "/cash-deliveries/export-cash-pickups", {
            searchText: searchText,
            toLocationId: toLocationId,
            branchId: branchId,
            startDate: startDate,
            endDate: endDate,
            sortASC: sortASC,
            sortColumn: sortColumn,
            timezone: timezone,
            customerId: customerId,
            filterByPickupDate: filterByPickupDate,
            filterByVaultDate: filterByVaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var cashPickupLocations = function cashPickupLocations(branchId, startDate, endDate, limit, offset, sortASC, customerId, filterByPickupDate, filterByVaultDate) {
        return $http.get(_app2.default.api + "/cash-deliveries/cash-pickup-locations", {
            params: {
                branchId: branchId,
                startDate: startDate,
                endDate: endDate,
                limit: limit,
                offset: offset,
                sortASC: sortASC,
                customerId: customerId,
                filterByPickupDate: filterByPickupDate,
                filterByVaultDate: filterByVaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var cashDeliveryLocations = function cashDeliveryLocations(branchId, startDate, endDate, limit, offset, sortASC, customerId, filterByDeliveryDate, filterByVaultDate) {
        return $http.get(_app2.default.api + "/cash-deliveries/cash-delivery-locations", {
            params: {
                branchId: branchId,
                startDate: startDate,
                endDate: endDate,
                limit: limit,
                offset: offset,
                sortASC: sortASC,
                customerId: customerId,
                filterByDeliveryDate: filterByDeliveryDate,
                filterByVaultDate: filterByVaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportCashTransactions = function exportCashTransactions(searchText, currentStat, fromLocationId, toLocationId, branchId, startDate, endDate, sortASC, sortColumn, timezone, customerId, filterByDeliveryDate, filterByPickupDate, filterByVaultDate) {
        return new _promise2.default(function (resolve, reject) {
            var url = _app2.default.api + "/cash-deliveries/export-cash-transactions";
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = {
                searchText: searchText, currentStat: currentStat, fromLocationId: fromLocationId, toLocationId: toLocationId, branchId: branchId, startDate: startDate, endDate: endDate, sortASC: sortASC, sortColumn: sortColumn, timezone: timezone, customerId: customerId,
                filterByDeliveryDate: filterByDeliveryDate, filterByPickupDate: filterByPickupDate, filterByVaultDate: filterByVaultDate
            };

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" });
                    var a = document.createElement('a');
                    var reportPrefix = 'Cash_Transactions_';
                    var dt = moment(startDate).format('DDMMYY') + '_To_' + moment(endDate).format('DDMMYY');
                    sheetName = reportPrefix.concat(dt, '_', '(', branchId, ')', '.xlsx');
                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                } else reject();
            };

            return xhr.send((0, _stringify2.default)(data));
        });
    };

    return {
        cashDeliveries: cashDeliveries,
        exportCashDeliveries: exportCashDeliveries,
        cashPickups: cashPickups,
        exportCashPickups: exportCashPickups,
        cashPickupLocations: cashPickupLocations,
        cashDeliveryLocations: cashDeliveryLocations,
        exportCashTransactions: exportCashTransactions
    };
};

CashDeliveriesService.$inject = ['$http', '$q'];

exports.default = CashDeliveriesService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonLayoutService = function CommonLayoutService($http, $q, $translate, User) {

  var orderTypes = function orderTypes() {
    return [{
      key: 'ADD',
      value: 'A'
    }, {
      key: 'SWAP',
      value: 'S'
    }, {
      key: 'ICL',
      value: 'I'
    }, {
      key: 'CCL',
      value: 'C'
    }, {
      key: 'RECASH',
      value: 'R'
    }, {
      key: 'Permanent Decash',
      value: 'P'
    }, {
      key: 'Temp Decash',
      value: 'T'
    }, {
      key: 'TEMP DECASH & RECASH',
      value: 'T&R'
    }, {
      key: 'Cash',
      value: 'X'
    }];
  };

  var lockTypes = function lockTypes() {
    return [{
      label: 'S&G High Security',
      value: 'LMS'
    }, {
      label: 'Cencon - Route Mode',
      value: 'RTE'
    }, {
      label: 'Cencon - FLM',
      value: 'FLM'
    },
    // {
    //   label: 'TDS',
    //   value: 'witz'
    // },
    {
      label: 'TDS API',
      value: 'TDS'
    }, {
      label: 'Static',
      value: 'static'
    }];
  };

  var stopProcessList = function stopProcessList() {
    return [{
      label: $translate.instant('location.atm_load'),
      value: 'L'
    }, {
      label: $translate.instant('location.atm_cash_delivery'),
      value: 'A'
    }, {
      label: $translate.instant('location.delivery_pickup'),
      value: 'D'
    }, {
      label: $translate.instant('location.bin_exchange'),
      value: 'B'
    }];
  };

  var OTCCompanyMapping = function OTCCompanyMapping(OTCCompanies) {
    var OTCCompanyNameList = [];

    if (OTCCompanies && OTCCompanies.length) {
      OTCCompanies.forEach(function (company) {
        OTCCompanyNameList.push({
          label: $translate.instant('location.' + company),
          value: company
        });
      });
    }
    return OTCCompanyNameList;
  };

  var setOTCKeys = function setOTCKeys(OTCCompanies) {
    var company = {},
        OTCKeys = {};

    if (OTCCompanies && OTCCompanies.length) {
      OTCCompanies.forEach(function (c) {
        company[c] = {
          lockSystem: [{
            label: 'KABA FLM',
            value: 'kabaKeyId'
          }, {
            label: 'KABA Route',
            value: 'routeKeyId'
          }, {
            label: 'S&G',
            value: 'SGKeyId'
          }, {
            label: 'TDS',
            value: 'witzKeyId'
          }]
        };
        OTCKeys[c] = {
          'kabaKeyId': '',
          'routeKeyId': '',
          'SGKeyId': '',
          'witzKeyId': ''
        };
      });
    }

    return { company: company, OTCKeys: OTCKeys };
  };

  var denominationTypes = function denominationTypes() {
    return [{
      label: 'Penny',
      value: 'PENNY'
    }, {
      label: 'Nickel',
      value: 'NICKEL'
    }, {
      label: 'Dimes',
      value: 'DIMES'
    }, {
      label: 'Quarter',
      value: 'QUARTER'
    }, {
      label: 'Half US Dollar',
      value: 'HALF_US_DOLLAR'
    }, {
      label: '1 US Dollar',
      value: 'ONE_US_DOLLAR'
    }, {
      label: 'Coin Misc',
      value: 'COIN_MISC'
    }];
  };

  var loadLocationTypeIcon = function loadLocationTypeIcon(locationType) {
    if (!locationType) return;

    var icon = {
      'REGULAR': 'regular.png',
      'ATM': 'atm.png',
      'BANK': 'bank.png',
      'NO_SHIP_NO_GO': 'nsng.png',
      'INTERNAL': 'internal.png',
      'TRUCK': 'truck.png',
      'TANKER': 'tanker.png',
      'WINDOW': 'window.png',
      'ON_CALL': 'oncall.png',
      'CARRIER': 'carrier.png',
      'LOCKER': 'locker.png',
      'VAULT': 'vault.png',
      'DELIVERY': 'delivery.png'
    };
    return icon[locationType];
  };

  var getWeekDays = function getWeekDays() {
    return [{ label: $translate.instant('location.sun'), value: 'Sun' }, { label: $translate.instant('location.mon'), value: 'Mon' }, { label: $translate.instant('location.tues'), value: 'Tue' }, { label: $translate.instant('location.wed'), value: 'Wed' }, { label: $translate.instant('location.thurs'), value: 'Thu' }, { label: $translate.instant('location.fri'), value: 'Fri' }, { label: $translate.instant('location.sat'), value: 'Sat' }, { label: $translate.instant('location.hol'), value: 'Hol' }];
  };

  var priorityList = function priorityList() {
    return [{
      label: '1st',
      value: 1
    }, {
      label: '2nd',
      value: 2
    }, {
      label: '3rd',
      value: 3
    }, {
      label: '4th',
      value: 4
    }, {
      label: '5th',
      value: 5
    }];
  };

  var multiSelectLangTranslation = function multiSelectLangTranslation() {
    return {
      selectAll: $translate.instant('common.selectall'),
      selectNone: $translate.instant('common.selectnone'),
      reset: $translate.instant('shipmentBatch.reset'),
      search: $translate.instant('common.search'),
      nothingSelected: $translate.instant('branch.all_branches')
    };
  };

  var setUIConfig = function setUIConfig(assets) {
    if (!assets) return;
    setTimeout(function () {
      document.getElementById('pageTitle').innerHTML = assets.pageTitle;
      document.getElementById('company_name').innerHTML = assets.companyName;
    });
  };

  var base64toBlob = function base64toBlob(base64Data) {
    var sliceSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;

    var byteArrays = [];

    for (var offset = 0; offset < base64Data.length; offset += sliceSize) {
      var slice = base64Data.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new File(byteArrays, "");
  };

  var generateObjectURL = function generateObjectURL(arrayBuffer) {
    var base64 = window.atob(Buffer.from(arrayBuffer, 'binary').toString('base64'));
    var blob = base64toBlob(base64);
    var objectURL = URL.createObjectURL(blob);
    return objectURL;
  };

  var updateFavicon = function updateFavicon(arrayBuffer) {
    var objectURL = generateObjectURL(arrayBuffer);
    document.querySelector("link[rel='icon']").setAttribute('href', objectURL);
  };

  var viewPassword = function viewPassword(stat, type, field, passWdIcon) {
    if (!type) passWdIcon[stat][field] = !passWdIcon[stat][field];else passWdIcon[stat][type][field] = !passWdIcon[stat][type][field];
  };

  var ordinalSuffixOf = function ordinalSuffixOf(number) {
    if (!number) return;
    var j = number % 10,
        k = number % 12;
    if (j == 1 && k != 11) {
      return "Every";
    }
    if (j == 2 && k != 12) {
      return "Every " + number + "nd";
    }
    if (j == 3 && k != 13) {
      return "Every " + number + "rd";
    }
    if (number > 0) return number + "th";
    return number;
  };

  var ordinalSuffixOfStopPriority = function ordinalSuffixOfStopPriority(number) {
    var j = number % 10,
        k = number % 100;
    if (j == 1 && k != 11) {
      return number + "st";
    }
    if (j == 2 && k != 12) {
      return number + "nd";
    }
    if (j == 3 && k != 13) {
      return number + "rd";
    }
    if (number > 0) return number + "th";
    return number;
  };

  var formatFileSize = function formatFileSize(bytes, decimalPoint) {
    if (bytes == 0) return '0 Bytes';
    var k = 1000,
        dm = decimalPoint || 2,
        sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

  var locationZoneTypes = function locationZoneTypes() {
    return [{
      label: 'Service',
      value: 'SERVICE'
    }, {
      label: 'Route',
      value: 'ROUTE'
    }];
  };

  var billingTypeOptions = function billingTypeOptions() {
    return [{
      label: 'Fixed',
      value: 'fixed'
    }, {
      label: 'Per Item',
      value: 'per_item'
    }, {
      label: 'Item Threshold',
      value: 'item_threshold'
    }, {
      label: 'Value Threshold',
      value: 'value_threshold'
    }, {
      label: 'Time Threshold',
      value: 'time_threshold'
    }, {
      label: 'Percentage Fee',
      value: 'percentage_fee'
    }, {
      label: 'Drive Distance',
      value: 'drive_distance'
    }, {
      label: 'Combined Time',
      value: 'combined_time'
    }, {
      label: 'Hourly Rate',
      value: 'hourly_rate'
    }, {
      label: 'Part Markup',
      value: 'part_markup'
    }, {
      label: 'Service Ticket Overage Time Charge',
      value: 'service_ticket_overage_time_charge'
    }];
  };

  var serviceTimeTypes = function serviceTimeTypes() {
    return [{
      label: 'Drive Time To',
      value: 'DRIVE_TIME_TO'
    }, {
      label: 'Drive Time From',
      value: 'DRIVE_TIME_FROM'
    }];
  };

  var intervalList = function intervalList() {
    return [{
      label: 'Daily',
      value: 'DAILY'
    }, {
      label: 'Weekly',
      value: 'WEEKLY'
    }, {
      label: 'Monthly',
      value: 'MONTHLY'
    }, {
      label: 'Quarterly',
      value: 'QUARTERLY'
    }, {
      label: 'Yearly',
      value: 'YEARLY'
    }];
  };

  var bankReportTypes = function bankReportTypes() {
    return [{
      label: 'None',
      value: 'NONE'
    }, {
      label: 'Cash Connect',
      value: 'CASHCONNECT'
    }, {
      label: '5TH3RD',
      value: '5TH3RD'
    }, {
      label: 'US Bank',
      value: 'USBANK'
    }];
  };

  var configuration = function configuration() {
    // Route Checkout
    return [{
      label: 'Messenger',
      value: 'messenger'
    }, {
      label: 'Messenger/Driver',
      value: 'messenger_driver'
    }, {
      label: 'Messenger/Driver/Guard',
      value: 'messenger_driver_guard'
    }];
  };

  var maskingString = function maskingString(str) {
    if (!str) return str;

    var start = 0;
    var end = 0;

    if (str.length == 1 || str.length == 2) end = 1;
    if (str.length == 3 || str.length == 4) end = 2;
    if (str.length === 5 || str.length === 6) end = 3;
    if (str.length > 6) end = 4;

    if (start < 0 || start >= str.length || end < 0 || end > str.length || start >= end) {
      return str;
    }

    var maskLength = end - start;
    var maskedStr = str.substring(0, start) + "*".repeat(maskLength) + str.substring(end);
    return maskedStr;
  };

  var translateItemHistoryMessage = function translateItemHistoryMessage(entryType) {
    if (!entryType) return;else if (entryType === 'HOLD') return $translate.instant('shipment.hold');else if (entryType === 'HOLD_RELEASE') return $translate.instant('shipment.HOLD_RELEASE');else if (entryType === 'CHECK_IN') return $translate.instant('checkin.title');else if (entryType === 'CHECK_OUT') return $translate.instant('shipment.CHECKOUT');else if (entryType === 'ASSIGNED') return $translate.instant('shipment.assigned');else if (entryType === 'UNASSIGNED') return $translate.instant('shipment.UNASSIGNED');else if (entryType === 'LOST') return $translate.instant('shipment.lost');else if (entryType === 'DELETED') return $translate.instant('shipment.deleted');else if (entryType === 'RETURNED_AVAILABLE') return $translate.instant('item.return_to_available');
  };

  var bankWeekList = function bankWeekList() {
    return [{
      label: '1st',
      value: 1
    }, {
      label: '2nd',
      value: 2
    }, {
      label: '3rd',
      value: 3
    }, {
      label: '4th',
      value: 4
    }];
  };

  var frequency = function frequency() {
    return [{
      label: 'Weekly',
      value: 'WEEKLY'
    }, {
      label: 'Bi-Weekly',
      value: 'BI_WEEKLY'
    }, {
      label: 'Monthly',
      value: 'MONTHLY'
    }, {
      label: 'Bi-Monthly',
      value: 'BI_MONTHLY'
    }, {
      label: '2 Times Weekly',
      value: '2_TIMES_WEEKLY'
    }, {
      label: '3 Times Weekly',
      value: '3_TIMES_WEEKLY'
    }, {
      label: '7 Days',
      value: '7_DAYS'
    }, {
      label: '21 Days',
      value: '21_DAYS'
    }, {
      label: '28 Days',
      value: '28_DAYS'
    }, {
      label: '56 Days',
      value: '56_DAYS'
    }];
  };

  var dayOfWeek = function dayOfWeek() {
    return [{
      label: 'Sunday',
      value: 'SUNDAY'
    }, {
      label: 'Monday',
      value: 'MONDAY'
    }, {
      label: 'Tuesday',
      value: 'TUESDAY'
    }, {
      label: 'Wednesday',
      value: 'WEDNESDAY'
    }, {
      label: 'Thursday',
      value: 'THURSDAY'
    }, {
      label: 'Friday',
      value: 'FRIDAY'
    }, {
      label: 'Saturday',
      value: 'SATURDAY'
    }, {
      label: 'Holiday',
      value: 'HOLIDAY'
    }];
  };

  var combinedRouteIntervals = function combinedRouteIntervals() {
    return [{
      frequency: 1,
      interval: "WEEKLY",
      label: $translate.instant('location.first_week')
    }, {
      frequency: 2,
      interval: "WEEKLY",
      label: $translate.instant('location.second_week')
    }, {
      frequency: 3,
      interval: "WEEKLY",
      label: $translate.instant('location.third_week')
    }, {
      frequency: 4,
      interval: "WEEKLY",
      label: $translate.instant('location.fourth_week')
    }, {
      frequency: 5,
      interval: "WEEKLY",
      label: $translate.instant('location.fifth_week')
    }, {
      frequency: 6,
      interval: "WEEKLY",
      label: $translate.instant('location.sixth_week')
    }, {
      frequency: 7,
      interval: "WEEKLY",
      label: $translate.instant('location.seventh_week')
    }, {
      frequency: 8,
      interval: "WEEKLY",
      label: $translate.instant('location.eighth_week')
    }, {
      frequency: 9,
      interval: "WEEKLY",
      label: $translate.instant('location.nineth_week')
    }, {
      frequency: 1,
      interval: "MONTHOC",
      label: $translate.instant('location.first_occurrence')
    }, {
      frequency: 2,
      interval: "MONTHOC",
      label: $translate.instant('location.second_occurrence')
    }, {
      frequency: 3,
      interval: "MONTHOC",
      label: $translate.instant('location.third_occurrence')
    }, {
      frequency: 4,
      interval: "MONTHOC",
      label: $translate.instant('location.fourth_occurrence')
    }, {
      frequency: 5,
      interval: "MONTHOC",
      label: $translate.instant('location.fifth_occurrence')
    }];
  };

  var dayMap = function dayMap() {
    return {
      'Sun': 0,
      'Mon': 1,
      'Tue': 2,
      'Wed': 3,
      'Thu': 4,
      'Fri': 5,
      'Sat': 6
    };
  };

  var paymentMethod = function paymentMethod() {
    return [{
      label: 'Ach',
      value: 'ACH'
    }, {
      label: 'Check',
      value: 'CHECK'
    }];
  };

  var isAllowToAccessPages = function isAllowToAccessPages() {
    var firstName = User.getUser().firstName;
    var lastName = User.getUser().lastName;
    var userId = User.getUser().id;
    return (firstName.toUpperCase() === 'COORWORKS' && lastName.toUpperCase() === 'ADMIN' || firstName.toUpperCase() === 'ADMIN' && lastName.toUpperCase() === 'COORWORKS') && userId === 1000;
  };

  var forecastingMethod = function forecastingMethod() {
    return [{
      label: 'Disabled',
      value: 'DISABLED'
    }, {
      label: 'Fixed',
      value: 'FIXED'
    }, {
      label: 'Dynamic',
      value: 'DYNAMIC'
    }];
  };

  var atmEmptyAtCalculationMethod = function atmEmptyAtCalculationMethod() {
    return [{
      label: 'Percent Change',
      value: 'PERCENT_CHANGE'
    }, {
      label: 'Weighted Avg',
      value: 'WEIGHTED_AVG'
    }, {
      label: 'Single',
      value: 'SINGLE'
    }];
  };

  var locationStateMapping = function locationStateMapping() {
    return {
      AL: 'Alabama',
      AK: 'Alaska',
      AS: 'American Samoa',
      AZ: 'Arizona',
      AR: 'Arkansas',
      CA: 'California',
      CO: 'Colorado',
      CT: 'Connecticut',
      DE: 'Delaware',
      DC: 'District Of Columbia',
      FL: 'Florida',
      GA: 'Georgia',
      GU: 'Guam',
      HI: 'Hawaii',
      ID: 'Idaho',
      IL: 'Illinois',
      IN: 'Indiana',
      IA: 'Iowa',
      KS: 'Kansas',
      KY: 'Kentucky',
      LA: 'Louisiana',
      ME: 'Maine',
      MH: 'Marshall Islands',
      MD: 'Maryland',
      MA: 'Massachusetts',
      MI: 'Michigan',
      MN: 'Minnesota',
      MS: 'Mississippi',
      MO: 'Missouri',
      MT: 'Montana',
      NE: 'Nebraska',
      NV: 'Nevada',
      NH: 'New Hampshire',
      NJ: 'New Jersey',
      NM: 'New Mexico',
      NY: 'New York',
      NC: 'North Carolina',
      ND: 'North Dakota',
      MP: 'Northern Mariana Islands',
      OH: 'Ohio',
      OK: 'Oklahoma',
      OR: 'Oregon',
      PW: 'Palau',
      PA: 'Pennsylvania',
      PR: 'Puerto Rico',
      RI: 'Rhode Island',
      SC: 'South Carolina',
      SD: 'South Dakota',
      TN: 'Tennessee',
      TX: 'Texas',
      UT: 'Utah',
      VT: 'Vermont',
      VI: 'Virgin Islands',
      VA: 'Virginia',
      WA: 'Washington',
      WV: 'West Virginia',
      WI: 'Wisconsin',
      WY: 'Wyoming'
    };
  };

  var formatAmount = function formatAmount(val) {
    var num = Number(val || 0);
    return num.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  var fuelTypeMapping = function fuelTypeMapping() {
    return [{ name: 'Unleaded', value: 'UNLEADED' }, { name: 'Diesel', value: 'DIESEL' }];
  };

  return {
    orderTypes: orderTypes,
    lockTypes: lockTypes,
    stopProcessList: stopProcessList,
    OTCCompanyMapping: OTCCompanyMapping,
    setOTCKeys: setOTCKeys,
    denominationTypes: denominationTypes,
    loadLocationTypeIcon: loadLocationTypeIcon,
    getWeekDays: getWeekDays,
    priorityList: priorityList,
    multiSelectLangTranslation: multiSelectLangTranslation,
    setUIConfig: setUIConfig,
    generateObjectURL: generateObjectURL,
    updateFavicon: updateFavicon,
    viewPassword: viewPassword,
    ordinalSuffixOf: ordinalSuffixOf,
    ordinalSuffixOfStopPriority: ordinalSuffixOfStopPriority,
    formatFileSize: formatFileSize,
    locationZoneTypes: locationZoneTypes,
    billingTypeOptions: billingTypeOptions,
    serviceTimeTypes: serviceTimeTypes,
    intervalList: intervalList,
    bankReportTypes: bankReportTypes,
    configuration: configuration,
    maskingString: maskingString,
    translateItemHistoryMessage: translateItemHistoryMessage,
    bankWeekList: bankWeekList,
    frequency: frequency,
    dayOfWeek: dayOfWeek,
    combinedRouteIntervals: combinedRouteIntervals,
    dayMap: dayMap,
    paymentMethod: paymentMethod,
    isAllowToAccessPages: isAllowToAccessPages,
    forecastingMethod: forecastingMethod,
    atmEmptyAtCalculationMethod: atmEmptyAtCalculationMethod,
    locationStateMapping: locationStateMapping,
    formatAmount: formatAmount,
    fuelTypeMapping: fuelTypeMapping
  };
};

CommonLayoutService.$inject = ['$http', '$q', '$translate', 'User'];

exports.default = CommonLayoutService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(540).Buffer))

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfigService = function ConfigService($http, $q) {

    var getConfig = function getConfig() {
        return $http.get(_app2.default.api + '/config/get-config').then(function (res) {
            return res.data;
        });
    };

    return {
        getConfig: getConfig
    };
};

ConfigService.$inject = ['$http', '$q'];

exports.default = ConfigService;

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactRequestService = function ContactRequestService($http, $q) {

    var contactRequest = function contactRequest(branchId, routeId, locationId, startDate, endDate, isCompleted, offset, limit) {
        return $http.get(_app2.default.api + '/contact-request/contact-request', {
            params: { branchId: branchId, routeId: routeId, locationId: locationId, startDate: startDate, endDate: endDate, isCompleted: isCompleted, limit: limit, offset: offset }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportContactRequest = function exportContactRequest(branchId, routeId, locationId, startDate, endDate, isCompleted) {
        return $http.post(_app2.default.api + '/contact-request/export-contact-request', {
            branchId: branchId, routeId: routeId, locationId: locationId, startDate: startDate, endDate: endDate, isCompleted: isCompleted
        }).then(function (res) {
            return res.data;
        });
    };

    var routesAndLocationList = function routesAndLocationList(branchId) {
        return $http.get(_app2.default.api + '/contact-request/routes-and-location-list', {
            params: { branchId: branchId }
        }).then(function (res) {
            return res.data;
        });
    };

    var markCompleteContactRequest = function markCompleteContactRequest(contactRequestId, completedByUserId) {
        return $http.post(_app2.default.api + '/contact-request/mark-complete-contact-request', {
            contactRequestId: contactRequestId, completedByUserId: completedByUserId
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        contactRequest: contactRequest,
        exportContactRequest: exportContactRequest,
        routesAndLocationList: routesAndLocationList,
        markCompleteContactRequest: markCompleteContactRequest
    };
};

ContactRequestService.$inject = ['$http', '$q'];

exports.default = ContactRequestService;

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractTypeService = function ContractTypeService($http, $q) {
    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/contract-type', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/contract-type/create', { data: data }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/contract-type/' + id + '/update'), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/contract-type/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        update: update,
        get: get
    };
};

ContractTypeService.$inject = ['$http', '$q'];

exports.default = ContractTypeService;

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContractService = function ContractService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/contract', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data, branchId) {
        return $http.post(_app2.default.api + '/contract/create', {
            data: data,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + ('/contract/' + id), {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data, branchId) {
        return $http.post(_app2.default.api + ('/contract/' + id), {
            data: data,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/contract/' + id)).then(function (res) {
            return res.data;
        });
    };

    var getCustomerHistory = function getCustomerHistory(searchText, contractId, sortASC, sortColumn, offset, limit) {
        return $http.get(_app2.default.api + ('/contract/' + contractId + '/get-customer-history'), {
            params: {
                searchText: searchText,
                contractId: contractId,
                sortASC: sortASC,
                sortColumn: sortColumn,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getCustomerList = function getCustomerList(searchText, offset, limit) {
        return $http.get(_app2.default.api + '/contract/get-customer-list', {
            params: { searchText: searchText, offset: offset, limit: limit }
        }).then(function (res) {
            return res.data;
        });
    };

    var contractLocationList = function contractLocationList(searchText, locationDistanceId, offset, limit) {
        return $http.get(_app2.default.api + '/contract/get-contract-location-list', {
            params: { searchText: searchText, locationDistanceId: locationDistanceId, offset: offset, limit: limit }
        }).then(function (res) {
            return res.data;
        });
    };

    var getCustomerLocationList = function getCustomerLocationList(contractId, locationDistanceId, searchText, offset, limit) {
        return $http.get(_app2.default.api + '/contract/get-customer-location-list', {
            params: { contractId: contractId, locationDistanceId: locationDistanceId, searchText: searchText, offset: offset, limit: limit }
        }).then(function (res) {
            return res.data;
        });
    };

    var assertLocationIds = function assertLocationIds(locationIds, contractId, useCustomerOnBillingRules, locationDistanceId) {
        return $http.post(_app2.default.api + '/contract/assert-location-ids', { locationIds: locationIds, contractId: contractId, useCustomerOnBillingRules: useCustomerOnBillingRules, locationDistanceId: locationDistanceId }).then(function (res) {
            return res.data;
        });
    };

    var updateContractRule = function updateContractRule(id, data, branchId) {
        return $http.post(_app2.default.api + ('/contract/' + id + '/update-contract-rule'), {
            data: data,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var deleteContractRule = function deleteContractRule(id, data, branchId) {
        var payload = {
            data: data,
            branchId: branchId
        };

        return $http.post(_app2.default.api + ('/contract/' + id + '/delete-contract-rule'), payload).then(function (res) {
            return res.data;
        });
    };

    var getContractLogs = function getContractLogs(contractId, search, offset, limit) {
        return $http.get(_app2.default.api + ('/contract/' + contractId + '/logs'), {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportDataToCSV = function exportDataToCSV(contractId, search) {
        return $http.get(_app2.default.api + ('/contract/' + contractId + '/export-to-csv'), {
            params: {
                search: search
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getContractRulesLocation = function getContractRulesLocation(contractId, searchText) {
        return $http.get(_app2.default.api + '/contract/get-contract-rules-location', {
            params: { contractId: contractId, searchText: searchText }
        }).then(function (res) {
            return res.data;
        });
    };

    var getUncoveredOnCallLocations = function getUncoveredOnCallLocations(offset, limit) {
        var isCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        return $http.get(_app2.default.api + '/contract/uncovered-on-call-locations', {
            params: { isCount: isCount, offset: offset, limit: limit }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get,
        getCustomerHistory: getCustomerHistory,
        contractLocationList: contractLocationList,
        getCustomerList: getCustomerList,
        getCustomerLocationList: getCustomerLocationList,
        assertLocationIds: assertLocationIds,
        updateContractRule: updateContractRule,
        deleteContractRule: deleteContractRule,
        getContractLogs: getContractLogs,
        exportDataToCSV: exportDataToCSV,
        getContractRulesLocation: getContractRulesLocation,
        getUncoveredOnCallLocations: getUncoveredOnCallLocations
    };
};

ContractService.$inject = ['$http', '$q'];

exports.default = ContractService;

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CostCenterService = function CostCenterService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/cost-center', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data, branchId) {
        return $http.post(_app2.default.api + '/cost-center/create', { data: data, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/cost-center/' + id + '/update'), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/cost-center/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        update: update,
        get: get
    };
};

CostCenterService.$inject = ['$http', '$q'];

exports.default = CostCenterService;

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountVariancesService = function CountVariancesService($http, $q) {

    var countVariances = function countVariances(searchText, branchId, startDate, endDate, offset, limit, sortASC, sortColumn, timezone) {
        return $http.get(_app2.default.api + '/count-variances/get-count-variances', {
            params: {
                searchText: searchText,
                branchId: branchId,
                startDate: startDate,
                endDate: endDate,
                offset: offset,
                limit: limit,
                sortASC: sortASC,
                sortColumn: sortColumn,
                timezone: timezone
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportCountVariances = function exportCountVariances(searchText, branchId, startDate, endDate, sortASC, sortColumn, timezone) {
        return $http.post(_app2.default.api + '/count-variances/export-count-variances', {
            searchText: searchText,
            branchId: branchId,
            startDate: startDate,
            endDate: endDate,
            sortASC: sortASC,
            sortColumn: sortColumn,
            timezone: timezone
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        countVariances: countVariances,
        exportCountVariances: exportCountVariances
    };
};

CountVariancesService.$inject = ['$http', '$q'];

exports.default = CountVariancesService;

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrencyService = function CurrencyService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/currency', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/currency/create', { data: data }).then(function (res) {
            return res.data;
        });
    };

    var details = function details(id) {
        return $http.get(_app2.default.api + ('/currency/' + id)).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/currency/' + id), { data: data }).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id) {
        return $http.delete(_app2.default.api + ('/currency/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        details: details,
        update: update,
        remove: remove
    };
};

CurrencyService.$inject = ['$http', '$q'];

exports.default = CurrencyService;

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerService = function CustomerService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/customer', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data, branchId, userId) {
        return $http.post(_app2.default.api + '/customer/create', { data: data, branchId: branchId, userId: userId }).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + ('/customer/' + id), {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data, branchId, userId) {
        return $http.post(_app2.default.api + ('/customer/' + id), { data: data, branchId: branchId, userId: userId }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/customer/' + id)).then(function (res) {
            return res.data;
        });
    };

    var getSurchargeConfigBulk = function getSurchargeConfigBulk(customerIds) {
        return $http.get(_app2.default.api + '/customer/surcharge-config-bulk', {
            params: {
                customerIds: (customerIds || []).join(',')
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getSurchargeHistory = function getSurchargeHistory(customerId) {
        return $http.get(_app2.default.api + ('/customer/' + customerId + '/surcharge-history')).then(function (res) {
            return res.data;
        });
    };

    var getCustomerLocationHistory = function getCustomerLocationHistory(searchText, customerId, sortASC, sortColumn, offset, limit) {
        return $http.get(_app2.default.api + ('/customer/' + customerId + '/get-customer-location-history'), {
            params: {
                searchText: searchText,
                customerId: customerId,
                sortASC: sortASC,
                sortColumn: sortColumn,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getCustomerContractHistory = function getCustomerContractHistory(searchText, customerId, sortASC, sortColumn, offset, limit) {
        return $http.get(_app2.default.api + ('/customer/' + customerId + '/get-customer-contract-history'), {
            params: {
                searchText: searchText,
                customerId: customerId,
                sortASC: sortASC,
                sortColumn: sortColumn,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getBillingRulesInfo = function getBillingRulesInfo(languageId, contractInfo) {
        return $http.get(_app2.default.api + '/customer/get-billing-rules-info', {
            params: {
                languageId: languageId,
                contractInfo: contractInfo
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var customerPickupReport = function customerPickupReport(searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId, offset, limit) {
        return $http.get(_app2.default.api + '/customer/customer-pickup-report', {
            params: {
                searchText: searchText, shiptypeId: shiptypeId, startDate: startDate, endDate: endDate, routeId: routeId, customerId: customerId, locationId: locationId, limit: limit, offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportCustomerPickupReport = function exportCustomerPickupReport(searchText, shiptypeId, startDate, endDate, routeId, customerId, locationId, branchTimeZone) {
        return $http.post(_app2.default.api + '/customer/export-customer-pickup-report', {
            searchText: searchText, shiptypeId: shiptypeId, startDate: startDate, endDate: endDate, routeId: routeId, customerId: customerId, locationId: locationId, branchTimeZone: branchTimeZone
        }).then(function (res) {
            return res.data;
        });
    };

    var uploadContractDocument = function uploadContractDocument(files, customerId, branchId) {
        return $http.post(_app2.default.api + '/customer/upload-contract-document', { files: files, customerId: customerId, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var getUploadedDocument = function getUploadedDocument(customerId) {
        return $http.get(_app2.default.api + '/customer/get-contract-files', {
            params: {
                customerId: customerId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var downloadContractDocument = function downloadContractDocument(customerId, fileName) {
        return new _promise2.default(function (resolve, reject) {
            var url = _app2.default.api + '/customer/download-contract-document';
            var xhr = new XMLHttpRequest();

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = { customerId: customerId, fileName: fileName };

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response]);
                    var a = document.createElement('a');
                    a.href = URL.createObjectURL(blob);
                    a.download = fileName;
                    a.click();
                    resolve();
                } else reject();
            };

            return xhr.send((0, _stringify2.default)(data));
        });
    };

    var deleteContractDocument = function deleteContractDocument(customerId, fileName, branchId) {
        return $http.post(_app2.default.api + '/customer/delete-contract-document', { customerId: customerId, fileName: fileName, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var viewContractDocument = function viewContractDocument(customerId, fileName) {
        return new _promise2.default(function (resolve, reject) {
            var url = _app2.default.api + '/customer/view-contract-document';
            var xhr = new XMLHttpRequest();

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = { customerId: customerId, fileName: fileName };

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/pdf" });
                    var windowURL = URL.createObjectURL(blob);
                    window.w = window.open(windowURL, '_blank');
                    resolve();
                } else reject();
            };

            return xhr.send((0, _stringify2.default)(data));
        });
    };

    var exportCustomerLocationHistory = function exportCustomerLocationHistory(customerId, searchText, sortASC, sortColumn) {
        return $http.post(_app2.default.api + '/customer/export-customer-location-history', {
            customerId: customerId, searchText: searchText, sortASC: sortASC, sortColumn: sortColumn
        }).then(function (res) {
            return res.data;
        });
    };

    var exportCustomerLocationBillingRule = function exportCustomerLocationBillingRule(customerId, contractId) {
        return $http.post(_app2.default.api + '/customer/export-customer-location-billing-rule', {
            customerId: customerId, contractId: contractId
        }).then(function (res) {
            return res.data;
        });
    };

    var getCustomerContractData = function getCustomerContractData(contractTypeId, customerId) {
        return $http.get(_app2.default.api + '/customer/get-customer-contract-data', {
            params: { contractTypeId: contractTypeId, customerId: customerId }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get,
        getSurchargeConfigBulk: getSurchargeConfigBulk,
        getSurchargeHistory: getSurchargeHistory,
        getCustomerLocationHistory: getCustomerLocationHistory,
        getCustomerContractHistory: getCustomerContractHistory,
        getBillingRulesInfo: getBillingRulesInfo,
        customerPickupReport: customerPickupReport,
        exportCustomerPickupReport: exportCustomerPickupReport,
        uploadContractDocument: uploadContractDocument,
        getUploadedDocument: getUploadedDocument,
        downloadContractDocument: downloadContractDocument,
        deleteContractDocument: deleteContractDocument,
        viewContractDocument: viewContractDocument,
        exportCustomerLocationHistory: exportCustomerLocationHistory,
        exportCustomerLocationBillingRule: exportCustomerLocationBillingRule,
        getCustomerContractData: getCustomerContractData
    };
};

CustomerService.$inject = ['$http', '$q'];

exports.default = CustomerService;

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DailyBalanceSheetService = function DailyBalanceSheetService($http, $q) {

    var getVaultBalance = function getVaultBalance(branchId, fundingSourceId, account, currencyId, vaultDate, manualDeposit) {
        return $http.post(_app2.default.api + "/daily-balance-sheet/daily-vault-balance", {
            branchId: branchId,
            fundingSourceId: fundingSourceId,
            account: account,
            currencyId: currencyId,
            vaultDate: vaultDate,
            manualDeposit: manualDeposit
        }).then(function (res) {
            return res.data;
        });
    };

    var vaultReport = function vaultReport(branchId, fundingSourceId, account, currencyId, vaultDate, branchTimezone, currencySymbol) {
        return new _promise2.default(function (resolve, reject) {
            var url = _app2.default.api + "/daily-balance-sheet/vault-report";
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = {
                branchId: branchId,
                fundingSourceId: fundingSourceId,
                account: account,
                currencyId: currencyId,
                vaultDate: vaultDate,
                branchTimezone: branchTimezone,
                currencySymbol: currencySymbol || '$'
            };

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" });
                    var a = document.createElement('a');
                    var reportPrefix = branchId;
                    var date = moment(vaultDate).format('DDMMYY');
                    if (account === 'regular') sheetName = reportPrefix + "_vault_report_" + date + ".xlsx";else sheetName = reportPrefix + "_vault_report_" + date + "_emergency.xlsx";

                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                } else {
                    var reader = new FileReader();
                    reader.onload = function () {
                        reject(reader.result);
                    };
                    reader.readAsText(new Blob([xhr.response]));
                }
            };

            xhr.send((0, _stringify2.default)(data));
        });
    };

    var allDVBDetails = function allDVBDetails(branchId, fundingSourceId, currencyId, denominationId, account, vaultDate, infoFor) {
        return $http.post(_app2.default.api + "/daily-balance-sheet/dvb-details", {
            branchId: branchId,
            fundingSourceId: fundingSourceId,
            currencyId: currencyId,
            denominationId: denominationId,
            account: account,
            vaultDate: vaultDate,
            infoFor: infoFor
        }).then(function (res) {
            return res.data;
        });
    };

    var exportData = function exportData(branchId, fundingSourceId, currencyId, denominationId, account, vaultDate, infoFor) {
        return $http.post(_app2.default.api + "/daily-balance-sheet/export-details", {
            branchId: branchId,
            fundingSourceId: fundingSourceId,
            currencyId: currencyId,
            denominationId: denominationId,
            account: account,
            vaultDate: vaultDate,
            infoFor: infoFor
        }, ['receivedBulkCash', 'actualDepositsCounted'].includes(infoFor) ? { responseType: 'arraybuffer' } : {}).then(function (res) {
            return res.data;
        });
    };

    var getEarliestVaultDate = function getEarliestVaultDate(branchId) {
        return $http.get(_app2.default.api + "/daily-balance-sheet/get-earliest-vaultDate", {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var emailVaultBalanceReport = function emailVaultBalanceReport(branchId, vaultDate, fundingSourceId) {
        return $http.post(_app2.default.api + "/daily-balance-sheet/email-vault-balance-report", {
            branchId: branchId,
            vaultDate: vaultDate,
            fundingSourceId: fundingSourceId
        }).then(function (res) {
            return res.data;
        });
    };

    var getVaultReportPrintData = function getVaultReportPrintData(branchId, fundingSourceId, currencyId, vaultDate, branchTimezone) {
        return $http.post(_app2.default.api + "/daily-balance-sheet/vault-report-print-data", {
            branchId: branchId,
            fundingSourceId: fundingSourceId,
            currencyId: currencyId,
            vaultDate: vaultDate,
            branchTimezone: branchTimezone
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getVaultBalance: getVaultBalance,
        vaultReport: vaultReport,
        allDVBDetails: allDVBDetails,
        exportData: exportData,
        getEarliestVaultDate: getEarliestVaultDate,
        emailVaultBalanceReport: emailVaultBalanceReport,
        getVaultReportPrintData: getVaultReportPrintData
    };
};

DailyBalanceSheetService.$inject = ['$http', '$q'];

exports.default = DailyBalanceSheetService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DailyStatService = function DailyStatService($http, $q) {

    var getDailyStats = function getDailyStats(startDate, endDate, branchId) {
        return $http.get(_app2.default.api + '/daily-stats', {
            params: {
                startDate: startDate,
                endDate: endDate,
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getDailyStats: getDailyStats
    };
};

DailyStatService.$inject = ['$http', '$q'];

exports.default = DailyStatService;

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DenominationService = function DenominationService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/denomination', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data, branchId) {
        return $http.post(_app2.default.api + '/denomination/create', { data: data, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/denomination/' + id)).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data, branchId) {
        return $http.post(_app2.default.api + ('/denomination/' + id), { data: data, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + ('/denomination/' + id), {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var denominationsPromise = null;

    var getName = function getName(id) {
        if (!denominationsPromise) {
            denominationsPromise = all(null, 0, 1000).then(function (res) {
                return res.results;
            });
        }
        return denominationsPromise.then(function (denominationsCache) {
            if (denominationsCache) {
                var denom = denominationsCache.find(function (d) {
                    return d.id === id;
                });
                return denom ? denom.name : id;
            }
            return id;
        }).catch(function (err) {
            return id;
        });
    };

    return {
        all: all,
        create: create,
        get: get,
        update: update,
        remove: remove,
        getName: getName
    };
};

DenominationService.$inject = ['$http', '$q'];

exports.default = DenominationService;

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnvironmentConfigService = function EnvironmentConfigService($http, $q) {

    var create = function create(data) {
        return $http.post(_app2.default.api + "/environment-config/create", data).then(function (res) {
            return res.data;
        });
    };

    var details = function details(fields) {
        return $http.get(_app2.default.api + "/environment-config/details", { params: { fields: fields } }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(data) {
        return $http.post(_app2.default.api + "/environment-config/update", data).then(function (res) {
            return res.data;
        });
    };

    var getUIConfigs = function getUIConfigs() {
        return $http.get(_app2.default.api + "/ui-configs/configs").then(function (res) {
            return res.data;
        });
    };

    return {
        create: create,
        details: details,
        update: update,
        getUIConfigs: getUIConfigs
    };
};

EnvironmentConfigService.$inject = ["$http", "$q"];

exports.default = EnvironmentConfigService;

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FuelSurchargeService = function FuelSurchargeService($http, $q) {

    var all = function all(searchText, status, offset, limit) {
        return $http.get(_app2.default.api + '/fuel-surcharge', {
            params: {
                searchText: searchText,
                status: status,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };
    var fuelSurchagePendingCustomers = function fuelSurchagePendingCustomers() {
        return $http.get(_app2.default.api + '/fuel-surcharge/fuel-surchage-pending-customers').then(function (res) {
            return res.data;
        });
    };
    var fuelSurchagePendingCustomersFilters = function fuelSurchagePendingCustomersFilters(searchText, offset, limit, sortColumn, sortDir) {
        return $http.get(_app2.default.api + '/fuel-surcharge/filter-pending-customers', {
            params: {
                searchText: searchText,
                offset: offset,
                limit: limit,
                sortColumn: sortColumn,
                sortDir: sortDir
            }
        }).then(function (res) {
            return res.data;
        });
    };
    var fuelSurchagePendingLocationsFilters = function fuelSurchagePendingLocationsFilters(searchText, offset, limit, sortColumn, sortDir) {
        return $http.get(_app2.default.api + '/fuel-surcharge/filter-pending-locations', {
            params: {
                searchText: searchText,
                offset: offset,
                limit: limit,
                sortColumn: sortColumn,
                sortDir: sortDir
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var fuelSurchageCustomers = function fuelSurchageCustomers(filter) {
        return $http.get(_app2.default.api + '/fuel-surcharge/fuel-surchage-customers', {
            params: {
                fuelSurchargeId: filter.fuelSurchargeId,
                sortingKey: filter.sortingKey,
                sortingDir: filter.sortingDir,
                limit: filter.limit,
                offset: filter.offset
            }
        }).then(function (res) {
            return res.data;
        });
    };
    var fuelSurchargeLocations = function fuelSurchargeLocations(filter) {
        return $http.get(_app2.default.api + '/fuel-surcharge/fuel-surchage-locations', {
            params: {
                fuelSurchargeId: filter.fuelSurchargeId,
                customerId: filter.customerId,
                sortingKey: filter.sortingKey,
                sortingDir: filter.sortingDir,
                limit: filter.limit,
                offset: filter.offset
            }
        }).then(function (res) {
            return res.data;
        });
    };
    var create = function create(data) {
        return $http.post(_app2.default.api + '/fuel-surcharge/create-fuel-surcharge', data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/fuel-surcharge/' + id)).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/fuel-surcharge/' + id), data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + '/fuel-surcharge/delete', {
            params: {
                id: id,
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    // let fundingSourceLocation = (locationId, searchText, branchId, limit, offset) => {
    //     return $http
    //         .post(AppConstants.api + `/branch-funding-source/funding-source-location`, {
    //             locationId,
    //             searchText,
    //             branchId,
    //             limit,
    //             offset
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // }

    return {
        all: all,
        create: create,
        fuelSurchagePendingCustomers: fuelSurchagePendingCustomers,
        fuelSurchagePendingCustomersFilters: fuelSurchagePendingCustomersFilters,
        fuelSurchagePendingLocationsFilters: fuelSurchagePendingLocationsFilters,
        fuelSurchageCustomers: fuelSurchageCustomers,
        fuelSurchargeLocations: fuelSurchargeLocations,
        get: get,
        update: update
        // remove
    };
};

FuelSurchargeService.$inject = ['$http', '$q'];

exports.default = FuelSurchargeService;

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HoldLocationService = function HoldLocationService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/hold-location', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var release = function release(supId, locationId, comment, branchId) {
        return $http.post(_app2.default.api + '/hold-location/release', {
            supervisorId: supId,
            locationId: locationId,
            comment: comment,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var holdLocationCount = function holdLocationCount(branchId) {
        return $http.get(_app2.default.api + '/hold-location/hold-location-count', {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getHoldLocation = function getHoldLocation(searchText, branchId, status, limit, offset) {
        return $http.get(_app2.default.api + '/hold-location/get-hold-location', {
            params: {
                searchText: searchText,
                branchId: branchId,
                status: status,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        release: release,
        holdLocationCount: holdLocationCount,
        getHoldLocation: getHoldLocation
    };
};

HoldLocationService.$inject = ['$http', '$q'];

exports.default = HoldLocationService;

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HoldVerifyService = function HoldVerifyService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/hold-verify', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/hold-verify/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        get: get
    };
};

HoldVerifyService.$inject = ['$http', '$q'];

exports.default = HoldVerifyService;

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HoldService = function HoldService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/hold', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var verify = function verify(trackingId, date) {
        return $http.post(_app2.default.api + ('/hold/' + trackingId + '/verify'), {
            date: date
        }).then(function (_ref) {
            var data = _ref.data;
            return data;
        });
    };

    var forceClose = function forceClose(forceCloseShipments) {
        return $http.post(_app2.default.api + '/hold/force-close', { forceCloseShipments: forceCloseShipments }).then(function (_ref2) {
            var data = _ref2.data;
            return data;
        });
    };

    var verifyHoldshipment = function verifyHoldshipment(branchId, trackingId, comments, supervisorUserId, vaultDate, bulkVerify) {
        return $http.post(_app2.default.api + '/hold/verifyShipment', {
            branchId: branchId,
            trackingId: trackingId,
            comments: comments,
            supervisorUserId: supervisorUserId,
            vaultDate: vaultDate,
            bulkVerify: bulkVerify
        }).then(function (res) {
            return res.data;
        });
    };

    var verifyAtmResidual = function verifyAtmResidual(trackingId) {
        return $http.get(_app2.default.api + '/hold/verifyAtmResidual', {
            params: {
                trackingId: trackingId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getResidualShipment = function getResidualShipment(trackingId, branchId) {
        return $http.post(_app2.default.api + '/hold/get-residual-shipment', {
            trackingId: trackingId,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var softDeleteShipment = function softDeleteShipment(trackingId, supervisorId, reason, shipmentId, branchId) {
        return $http.post(_app2.default.api + '/hold/soft-delete-shipment', {
            trackingId: trackingId,
            supervisorId: supervisorId,
            reason: reason,
            shipmentId: shipmentId,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var markToDelivered = function markToDelivered(supervisorUserId, bagSealId) {
        return $http.post(_app2.default.api + '/hold/mark-to-delivered', {
            supervisorUserId: supervisorUserId,
            bagSealId: bagSealId
        }).then(function (res) {
            return res.data;
        });
    };

    var bulkVerify = function bulkVerify(trackingId) {
        return $http.post(_app2.default.api + '/hold/bulk-verify', {
            trackingId: trackingId
        }).then(function (res) {
            return res.data;
        });
    };

    var holdItemCount = function holdItemCount(search, offset, limit) {
        return $http.get(_app2.default.api + '/hold/hold-item-count', {
            params: {
                search: search
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var holdItems = function holdItems(search, offset, limit) {
        return $http.get(_app2.default.api + '/hold/get-item-holds', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var convertToCRV = function convertToCRV(branchId, trackingLoad, trackingResidual, supvUserId, singleDenomTrackingIds) {
        return $http.post(_app2.default.api + '/hold/convert-to-crv', {
            branchId: branchId,
            trackingLoad: trackingLoad,
            trackingResidual: trackingResidual,
            supvUserId: supvUserId,
            singleDenomTrackingIds: singleDenomTrackingIds
        }).then(function (res) {
            return res.data;
        });
    };

    var convertToCrvPackableOrder = function convertToCrvPackableOrder(branchId, trackingLoad, packableOrderShipmentId, supvUserId) {
        return $http.post(_app2.default.api + '/hold/convert-to-crv-packable-order', {
            branchId: branchId,
            trackingLoad: trackingLoad,
            packableOrderShipmentId: packableOrderShipmentId,
            supvUserId: supvUserId
        }).then(function (res) {
            return res.data;
        });
    };

    var getAllRoutes = function getAllRoutes(branchId, vaultDate) {
        return $http.post(_app2.default.api + '/hold/get-all-routes', {
            branchId: branchId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var updateRouteDetail = function updateRouteDetail(routeId) {
        return $http.post(_app2.default.api + '/hold/update-route-detail', {
            routeId: routeId
        }).then(function (res) {
            return res.data;
        });
    };

    var verifyItemHoldData = function verifyItemHoldData(branch, status, verifiedDate) {
        return $http.post(_app2.default.api + '/hold/verify-item-hold-data', {
            branch: branch,
            status: status,
            verifiedDate: verifiedDate
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentDelivery = function shipmentDelivery(trackingId, routeId, supervisorId, comments, branchId, loadedAmount, date, time, branchTimeZone, orderType, shipmentAmount) {
        var sendDeliveryReceipt = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : false;

        return $http.post(_app2.default.api + '/hold/shipment-delivery', {
            trackingId: trackingId,
            routeId: routeId,
            supervisorId: supervisorId,
            comments: comments,
            branchId: branchId,
            loadedAmount: loadedAmount,
            date: date,
            time: time,
            branchTimeZone: branchTimeZone,
            orderType: orderType,
            shipmentAmount: shipmentAmount,
            sendDeliveryReceipt: sendDeliveryReceipt
        }).then(function (res) {
            return res.data;
        });
    };

    var holdShipmentList = function holdShipmentList(routeId, vaultDate, branch) {
        return $http.post(_app2.default.api + '/hold/hold-shipment-list', {
            routeId: routeId,
            vaultDate: vaultDate,
            branch: branch
        }).then(function (res) {
            return res.data;
        });
    };

    var exportItemHoldData = function exportItemHoldData(search, offset, limit) {
        return $http.get(_app2.default.api + '/hold/export-item-hold', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentHoldMarkCheckedIn = function shipmentHoldMarkCheckedIn(trackingId, supervisorId, branchId, routeId) {
        return $http.post(_app2.default.api + '/hold/mark-as-checked-in', {
            trackingId: trackingId,
            supervisorId: supervisorId,
            branchId: branchId,
            routeId: routeId
        }).then(function (res) {
            return res.data;
        });
    };

    var softDeleteBagoutsOnHold = function softDeleteBagoutsOnHold(branchId, supvUserId, reason) {
        return $http.post(_app2.default.api + '/hold/soft-delete-bagouts-on-hold', {
            branchId: branchId,
            supvUserId: supvUserId,
            reason: reason
        }).then(function (res) {
            return res.data;
        });
    };

    var getBagoutsOnHold = function getBagoutsOnHold(branchId) {
        return $http.get(_app2.default.api + '/hold/get-bagouts-on-hold', {
            params: { branchId: branchId }
        }).then(function (res) {
            return res.data;
        });
    };

    var pickupHoldRelease = function pickupHoldRelease(trackingId, origRouteId, destRouteId, destRouteDate, supervisorId, comments, branchId, locationId) {
        return $http.post(_app2.default.api + '/hold/pickup-hold-release', {
            trackingId: trackingId, origRouteId: origRouteId, destRouteId: destRouteId,
            destRouteDate: destRouteDate, supervisorId: supervisorId, comments: comments,
            branchId: branchId, locationId: locationId
        }).then(function (res) {
            return res.data;
        });
    };

    var convertShipmentHoldToPickup = function convertShipmentHoldToPickup(trackingId, routeId, supervisorId, branchId, fromLocationId, toLocationId) {
        return $http.post(_app2.default.api + '/hold/convert-shipment-hold-to-pickup', {
            trackingId: trackingId, routeId: routeId, supervisorId: supervisorId, branchId: branchId, fromLocationId: fromLocationId, toLocationId: toLocationId
        }).then(function (res) {
            return res.data;
        });
    };

    var releaseForCount = function releaseForCount(trackingId, routeId, supervisorId, comments) {
        return $http.post(_app2.default.api + '/hold/release-for-count', {
            trackingId: trackingId, routeId: routeId, supervisorId: supervisorId, comments: comments
        }).then(function (_ref3) {
            var data = _ref3.data;
            return data;
        });
    };

    return {
        all: all,
        verify: verify,
        forceClose: forceClose,
        verifyHoldshipment: verifyHoldshipment,
        verifyAtmResidual: verifyAtmResidual,
        getResidualShipment: getResidualShipment,
        softDeleteShipment: softDeleteShipment,
        markToDelivered: markToDelivered,
        bulkVerify: bulkVerify,
        holdItemCount: holdItemCount,
        holdItems: holdItems,
        convertToCRV: convertToCRV,
        convertToCrvPackableOrder: convertToCrvPackableOrder,
        getAllRoutes: getAllRoutes,
        updateRouteDetail: updateRouteDetail,
        verifyItemHoldData: verifyItemHoldData,
        shipmentDelivery: shipmentDelivery,
        holdShipmentList: holdShipmentList,
        exportItemHoldData: exportItemHoldData,
        shipmentHoldMarkCheckedIn: shipmentHoldMarkCheckedIn,
        softDeleteBagoutsOnHold: softDeleteBagoutsOnHold,
        getBagoutsOnHold: getBagoutsOnHold,
        pickupHoldRelease: pickupHoldRelease,
        convertShipmentHoldToPickup: convertShipmentHoldToPickup,
        releaseForCount: releaseForCount
    };
};

HoldService.$inject = ['$http', '$q'];

exports.default = HoldService;

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HolidayService = function HolidayService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/holiday', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getGrouped = function getGrouped(search, offset, limit) {
        return $http.get(_app2.default.api + '/holiday/grouped', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/holiday/create', data).then(function (res) {
            return res.data;
        });
    };

    var createGrouped = function createGrouped(data) {
        return $http.post(_app2.default.api + '/holiday/grouped', data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id) {
        return $http.delete(_app2.default.api + ('/holiday/' + id)).then(function (res) {
            return res.data;
        });
    };

    var removeGrouped = function removeGrouped(_ref) {
        var name = _ref.name,
            branch = _ref.branch;

        return $http.delete(_app2.default.api + ('/holiday/grouped/' + branch + '/' + name)).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/holiday/' + id), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/holiday/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        getGrouped: getGrouped,
        create: create,
        createGrouped: createGrouped,
        remove: remove,
        removeGrouped: removeGrouped,
        update: update,
        get: get
    };
};

HolidayService.$inject = ['$http', '$q'];

exports.default = HolidayService;

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeService = function HomeService($http, $q) {

    var dashboard = function dashboard(date, branch, loggedInUserId) {
        return $http.get(_app2.default.api + '/home/home-screen-details', {
            params: {
                date: date,
                branch: branch,
                loggedInUserId: loggedInUserId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var configs = function configs() {
        return $http.get(_app2.default.api + '/home/configs', {}).then(function (res) {
            return res.data;
        });
    };

    var getBranchLiability = function getBranchLiability(branchId) {
        return $http.get(_app2.default.api + '/home/get-branch-liability', {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var updateVaultLiability = function updateVaultLiability(branchId, vaultLiability) {
        return $http.post(_app2.default.api + '/home/update-vault-liability', {
            branchId: branchId,
            vaultLiability: vaultLiability
        }).then(function (res) {
            return res.data;
        });
    };

    var branchStats = function branchStats(branchId, startDate, endDate, loggedInUserId) {
        return $http.get(_app2.default.api + '/home/branch-stats', {
            params: { branchId: branchId, startDate: startDate, endDate: endDate, loggedInUserId: loggedInUserId }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        dashboard: dashboard,
        configs: configs,
        getBranchLiability: getBranchLiability,
        updateVaultLiability: updateVaultLiability,
        branchStats: branchStats
    };
};

HomeService.$inject = ['$http', '$q'];

exports.default = HomeService;

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IdStoreService = function IdStoreService($http, $q) {

    // Preview next available Id for location
    var getPreviewNextId = function getPreviewNextId(key, amount) {
        return $http.get(_app2.default.api + '/id-store/preview', {
            params: {
                key: key,
                amount: amount
            }
        }).then(function (res) {
            return res.data;
        });
    };

    // Increment next available Id for location
    var incrementKey = function incrementKey(key, amount) {
        return $http.post(_app2.default.api + '/id-store/increment', {
            key: key,
            amount: amount
        }).then(function (res) {
            return res.data;
        });
    };

    // Prefix for branchId
    var branchIdPrefix = function branchIdPrefix(branchId) {
        if (typeof branchId !== 'string') return undefined;
        return 'BRANCH-' + branchId;
    };

    return {
        getPreviewNextId: getPreviewNextId,
        branchIdPrefix: branchIdPrefix,
        incrementKey: incrementKey
    };
};

IdStoreService.$inject = ['$http', '$q'];

exports.default = IdStoreService;

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImportFileViewService = function ImportFileViewService($http, $q) {

    var importFiles = function importFiles(startDate, endDate, status, fileAdapter, limit, offset) {
        return $http.get(_app2.default.api + '/import-files/get-import-files', {
            params: {
                startDate: startDate, endDate: endDate, status: status, fileAdapter: fileAdapter, limit: limit, offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var evertecBatchFiles = function evertecBatchFiles(searchText, status, limit, offset) {
        return $http.get(_app2.default.api + '/import-files/get-evertec-batch-files', {
            params: {
                searchText: searchText, status: status, limit: limit, offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getFileAdapterTypes = function getFileAdapterTypes() {
        return $http.get(_app2.default.api + '/import-files/get-file-adapter-types').then(function (res) {
            return res.data;
        });
    };

    return {
        importFiles: importFiles, evertecBatchFiles: evertecBatchFiles, getFileAdapterTypes: getFileAdapterTypes
    };
};

ImportFileViewService.$inject = ['$http', '$q'];

exports.default = ImportFileViewService;

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(12);

var _angular2 = _interopRequireDefault(_angular);

var _user = __webpack_require__(2486);

var _user2 = _interopRequireDefault(_user);

var _branch = __webpack_require__(2415);

var _branch2 = _interopRequireDefault(_branch);

var _customer = __webpack_require__(2429);

var _customer2 = _interopRequireDefault(_customer);

var _truck = __webpack_require__(2483);

var _truck2 = _interopRequireDefault(_truck);

var _vault = __webpack_require__(2489);

var _vault2 = _interopRequireDefault(_vault);

var _batch = __webpack_require__(2407);

var _batch2 = _interopRequireDefault(_batch);

var _route = __webpack_require__(2471);

var _route2 = _interopRequireDefault(_route);

var _location = __webpack_require__(2452);

var _location2 = _interopRequireDefault(_location);

var _users = __webpack_require__(2487);

var _users2 = _interopRequireDefault(_users);

var _contract = __webpack_require__(2425);

var _contract2 = _interopRequireDefault(_contract);

var _shiptype = __webpack_require__(2480);

var _shiptype2 = _interopRequireDefault(_shiptype);

var _window = __webpack_require__(2491);

var _window2 = _interopRequireDefault(_window);

var _carrier = __webpack_require__(2419);

var _carrier2 = _interopRequireDefault(_carrier);

var _scan = __webpack_require__(2473);

var _scan2 = _interopRequireDefault(_scan);

var _shipment = __webpack_require__(2479);

var _shipment2 = _interopRequireDefault(_shipment);

var _message = __webpack_require__(2455);

var _message2 = _interopRequireDefault(_message);

var _language = __webpack_require__(2445);

var _language2 = _interopRequireDefault(_language);

var _bagout = __webpack_require__(2406);

var _bagout2 = _interopRequireDefault(_bagout);

var _prefix = __webpack_require__(2461);

var _prefix2 = _interopRequireDefault(_prefix);

var _holidays = __webpack_require__(2438);

var _holidays2 = _interopRequireDefault(_holidays);

var _routeDetail = __webpack_require__(2467);

var _routeDetail2 = _interopRequireDefault(_routeDetail);

var _setup = __webpack_require__(2478);

var _setup2 = _interopRequireDefault(_setup);

var _item = __webpack_require__(2444);

var _item2 = _interopRequireDefault(_item);

var _log = __webpack_require__(2454);

var _log2 = _interopRequireDefault(_log);

var _scanConfig = __webpack_require__(2472);

var _scanConfig2 = _interopRequireDefault(_scanConfig);

var _hold = __webpack_require__(2437);

var _hold2 = _interopRequireDefault(_hold);

var _holdLocation = __webpack_require__(2435);

var _holdLocation2 = _interopRequireDefault(_holdLocation);

var _bypassCode = __webpack_require__(2417);

var _bypassCode2 = _interopRequireDefault(_bypassCode);

var _idStoreService = __webpack_require__(2440);

var _idStoreService2 = _interopRequireDefault(_idStoreService);

var _home = __webpack_require__(2439);

var _home2 = _interopRequireDefault(_home);

var _transaction = __webpack_require__(2482);

var _transaction2 = _interopRequireDefault(_transaction);

var _holdVerify = __webpack_require__(2436);

var _holdVerify2 = _interopRequireDefault(_holdVerify);

var _dailyStat = __webpack_require__(2431);

var _dailyStat2 = _interopRequireDefault(_dailyStat);

var _locationDelivery = __webpack_require__(2449);

var _locationDelivery2 = _interopRequireDefault(_locationDelivery);

var _currency = __webpack_require__(2428);

var _currency2 = _interopRequireDefault(_currency);

var _denomination = __webpack_require__(2432);

var _denomination2 = _interopRequireDefault(_denomination);

var _branchFundingSource = __webpack_require__(2413);

var _branchFundingSource2 = _interopRequireDefault(_branchFundingSource);

var _bulkCash = __webpack_require__(2416);

var _bulkCash2 = _interopRequireDefault(_bulkCash);

var _userBranch = __webpack_require__(2485);

var _userBranch2 = _interopRequireDefault(_userBranch);

var _orderPacking = __webpack_require__(2458);

var _orderPacking2 = _interopRequireDefault(_orderPacking);

var _ledger = __webpack_require__(2447);

var _ledger2 = _interopRequireDefault(_ledger);

var _ledgerTransaction = __webpack_require__(2446);

var _ledgerTransaction2 = _interopRequireDefault(_ledgerTransaction);

var _atmResidual = __webpack_require__(2404);

var _atmResidual2 = _interopRequireDefault(_atmResidual);

var _locationBranch = __webpack_require__(2448);

var _locationBranch2 = _interopRequireDefault(_locationBranch);

var _atmResidualDeposit = __webpack_require__(2403);

var _atmResidualDeposit2 = _interopRequireDefault(_atmResidualDeposit);

var _dailyBalanceSheet = __webpack_require__(2430);

var _dailyBalanceSheet2 = _interopRequireDefault(_dailyBalanceSheet);

var _monthlyReport = __webpack_require__(2457);

var _monthlyReport2 = _interopRequireDefault(_monthlyReport);

var _atmCodesManagement = __webpack_require__(2401);

var _atmCodesManagement2 = _interopRequireDefault(_atmCodesManagement);

var _mobileApp = __webpack_require__(2456);

var _mobileApp2 = _interopRequireDefault(_mobileApp);

var _routeStop = __webpack_require__(2470);

var _routeStop2 = _interopRequireDefault(_routeStop);

var _resetAtmCode = __webpack_require__(2465);

var _resetAtmCode2 = _interopRequireDefault(_resetAtmCode);

var _routeProgress = __webpack_require__(2468);

var _routeProgress2 = _interopRequireDefault(_routeProgress);

var _carrierBranch = __webpack_require__(2418);

var _carrierBranch2 = _interopRequireDefault(_carrierBranch);

var _serviceOrder = __webpack_require__(2476);

var _serviceOrder2 = _interopRequireDefault(_serviceOrder);

var _actionCode = __webpack_require__(2400);

var _actionCode2 = _interopRequireDefault(_actionCode);

var _vehicleLockers = __webpack_require__(2490);

var _vehicleLockers2 = _interopRequireDefault(_vehicleLockers);

var _userBranchFundingSource = __webpack_require__(2484);

var _userBranchFundingSource2 = _interopRequireDefault(_userBranchFundingSource);

var _branchPerformance = __webpack_require__(2414);

var _branchPerformance2 = _interopRequireDefault(_branchPerformance);

var _cashDeliveries = __webpack_require__(2420);

var _cashDeliveries2 = _interopRequireDefault(_cashDeliveries);

var _report = __webpack_require__(2464);

var _report2 = _interopRequireDefault(_report);

var _physicalCashCount = __webpack_require__(2460);

var _physicalCashCount2 = _interopRequireDefault(_physicalCashCount);

var _config = __webpack_require__(2422);

var _config2 = _interopRequireDefault(_config);

var _lockOpenErrors = __webpack_require__(2453);

var _lockOpenErrors2 = _interopRequireDefault(_lockOpenErrors);

var _billableEvents = __webpack_require__(2408);

var _billableEvents2 = _interopRequireDefault(_billableEvents);

var _billingCategory = __webpack_require__(2409);

var _billingCategory2 = _interopRequireDefault(_billingCategory);

var _billingRecords = __webpack_require__(2410);

var _billingRecords2 = _interopRequireDefault(_billingRecords);

var _fuelSurcharge = __webpack_require__(2434);

var _fuelSurcharge2 = _interopRequireDefault(_fuelSurcharge);

var _pricePoint = __webpack_require__(2462);

var _pricePoint2 = _interopRequireDefault(_pricePoint);

var _countVariances = __webpack_require__(2427);

var _countVariances2 = _interopRequireDefault(_countVariances);

var _vaultOperations = __webpack_require__(2488);

var _vaultOperations2 = _interopRequireDefault(_vaultOperations);

var _routeStats = __webpack_require__(2469);

var _routeStats2 = _interopRequireDefault(_routeStats);

var _branchFundingSourceHoliday = __webpack_require__(2411);

var _branchFundingSourceHoliday2 = _interopRequireDefault(_branchFundingSourceHoliday);

var _branchFundingSourceOrderProfile = __webpack_require__(2412);

var _branchFundingSourceOrderProfile2 = _interopRequireDefault(_branchFundingSourceOrderProfile);

var _commonLayout = __webpack_require__(2421);

var _commonLayout2 = _interopRequireDefault(_commonLayout);

var _orderView = __webpack_require__(2459);

var _orderView2 = _interopRequireDefault(_orderView);

var _regionRouting = __webpack_require__(2463);

var _regionRouting2 = _interopRequireDefault(_regionRouting);

var _restoreRouteAssignment = __webpack_require__(2466);

var _restoreRouteAssignment2 = _interopRequireDefault(_restoreRouteAssignment);

var _serviceTicketParts = __webpack_require__(2477);

var _serviceTicketParts2 = _interopRequireDefault(_serviceTicketParts);

var _environmentConfig = __webpack_require__(2433);

var _environmentConfig2 = _interopRequireDefault(_environmentConfig);

var _contactRequest = __webpack_require__(2423);

var _contactRequest2 = _interopRequireDefault(_contactRequest);

var _importFileView = __webpack_require__(2441);

var _importFileView2 = _interopRequireDefault(_importFileView);

var _stopScheduling = __webpack_require__(2481);

var _stopScheduling2 = _interopRequireDefault(_stopScheduling);

var _costCenter = __webpack_require__(2426);

var _costCenter2 = _interopRequireDefault(_costCenter);

var _locationZone = __webpack_require__(2451);

var _locationZone2 = _interopRequireDefault(_locationZone);

var _locationDistance = __webpack_require__(2450);

var _locationDistance2 = _interopRequireDefault(_locationDistance);

var _serviceChecklist = __webpack_require__(2475);

var _serviceChecklist2 = _interopRequireDefault(_serviceChecklist);

var _itemType = __webpack_require__(2443);

var _itemType2 = _interopRequireDefault(_itemType);

var _contractType = __webpack_require__(2424);

var _contractType2 = _interopRequireDefault(_contractType);

var _atmMakes = __webpack_require__(2402);

var _atmMakes2 = _interopRequireDefault(_atmMakes);

var _automatedRoutingStops = __webpack_require__(2405);

var _automatedRoutingStops2 = _interopRequireDefault(_automatedRoutingStops);

var _serviceActionPriorities = __webpack_require__(2474);

var _serviceActionPriorities2 = _interopRequireDefault(_serviceActionPriorities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import MobileApiService from './mobile-api.service'
var servicesModule = _angular2.default.module('app.services', []).factory('UserService', _user2.default).factory('BranchService', _branch2.default).factory('CustomerService', _customer2.default).factory('TruckService', _truck2.default).factory('VaultService', _vault2.default).factory('BatchService', _batch2.default).factory('RouteService', _route2.default).factory('LocationService', _location2.default).factory('UsersService', _users2.default).factory('ContractService', _contract2.default).factory('ShiptypeService', _shiptype2.default).factory('WindowService', _window2.default).factory('CarrierService', _carrier2.default).factory('ScanService', _scan2.default).factory('ShipmentService', _shipment2.default).factory('MessageService', _message2.default).factory('LanguageService', _language2.default).factory('BagoutService', _bagout2.default).factory('PrefixService', _prefix2.default).factory('HolidayService', _holidays2.default).factory('IdStoreService', _idStoreService2.default).factory('RouteDetailService', _routeDetail2.default).factory('SetupService', _setup2.default).factory('ItemService', _item2.default).factory('HoldService', _hold2.default).factory('HoldLocationService', _holdLocation2.default).factory('BypassCodeService', _bypassCode2.default).factory('HomeService', _home2.default).factory('LogService', _log2.default).factory('ScanConfigService', _scanConfig2.default).factory('TransactionService', _transaction2.default).factory('HoldVerifyService', _holdVerify2.default).factory('LocationDeliveryService', _locationDelivery2.default).factory('DailyStatService', _dailyStat2.default).factory('CurrencyService', _currency2.default).factory('DenominationService', _denomination2.default).factory('BranchFundingSourceService', _branchFundingSource2.default).factory('BulkCashService', _bulkCash2.default).factory('UserBranchService', _userBranch2.default).factory('OrderPackingService', _orderPacking2.default).factory('LedgerService', _ledger2.default).factory('LedgerTransactionService', _ledgerTransaction2.default).factory('AtmResidualService', _atmResidual2.default).factory('LocationBranchService', _locationBranch2.default).factory('AtmResidualDepositService', _atmResidualDeposit2.default).factory('DailyBalanceSheetService', _dailyBalanceSheet2.default).factory('MonthlyReportService', _monthlyReport2.default).factory('AtmCodesManagementService', _atmCodesManagement2.default).factory('MobileAppService', _mobileApp2.default).factory('RouteStopService', _routeStop2.default)

// .factory('AccountsService', AccountsService)

.factory('ResetAtmCodeService', _resetAtmCode2.default)

// .factory('MobileApiService', MobileApiService)

.factory('RouteProgressService', _routeProgress2.default).factory('CarrierBranchService', _carrierBranch2.default).factory('ServiceOrderService', _serviceOrder2.default).factory('ActionCodeService', _actionCode2.default).factory('ServiceChecklistService', _serviceChecklist2.default).factory('VehicleLockerService', _vehicleLockers2.default).factory('UserBranchFundingSourceService', _userBranchFundingSource2.default).factory('BranchPerformanceService', _branchPerformance2.default).factory('CashDeliveriesService', _cashDeliveries2.default).factory('ReportService', _report2.default).factory('PhysicalCashCountService', _physicalCashCount2.default).factory('ConfigService', _config2.default).factory('LockOpenErrorService', _lockOpenErrors2.default).factory('BillableEventsService', _billableEvents2.default).factory('BillingCategoryService', _billingCategory2.default).factory('BillingRecordsService', _billingRecords2.default).factory('FuelSurchargeService', _fuelSurcharge2.default).factory('PricePointService', _pricePoint2.default).factory('CountVariancesService', _countVariances2.default).factory('VaultOperationsService', _vaultOperations2.default).factory('RouteStatsService', _routeStats2.default).factory('BranchFundingSourceHolidayService', _branchFundingSourceHoliday2.default).factory('BranchFundingSourceOrderProfileService', _branchFundingSourceOrderProfile2.default).factory('CommonLayoutService', _commonLayout2.default).factory('OrderViewService', _orderView2.default).factory('RegionRoutingService', _regionRouting2.default).factory('RestoreRouteAssignmentService', _restoreRouteAssignment2.default).factory('ServiceTicketPartsService', _serviceTicketParts2.default).factory('EnvironmentConfigService', _environmentConfig2.default).factory('ContactRequestService', _contactRequest2.default).factory('ImportFileViewService', _importFileView2.default).factory('StopSchedulingService', _stopScheduling2.default).factory('CostCenterService', _costCenter2.default).factory('LocationZoneService', _locationZone2.default).factory('LocationDistanceService', _locationDistance2.default).factory('ItemTypeService', _itemType2.default).factory('ContractTypeService', _contractType2.default).factory('AtmMakesService', _atmMakes2.default).factory('AutomatedRoutingStopsService', _automatedRoutingStops2.default).factory('ServiceActionPrioritiesService', _serviceActionPriorities2.default).name;
// import AccountsService from './accounts.service'
exports.default = servicesModule;

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemTypeService = function ItemTypeService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/item-type', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/item-type/create', data).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/item-type/' + id + '/update'), { data: data }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/item-type/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        create: create,
        all: all,
        update: update,
        get: get
    };
};

ItemTypeService.$inject = ['$http', '$q'];

exports.default = ItemTypeService;

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemService = function ItemService($http, $q) {

    var create = function create(data) {
        return $http.post(_app2.default.api + '/item/create', data).then(function (res) {
            return res.data;
        });
    };

    var getItemTypes = function getItemTypes(typeId, searchText, limit, offset) {
        return $http.get(_app2.default.api + '/item/get-item-types', { params: { typeId: typeId, searchText: searchText, limit: limit, offset: offset } }).then(function (res) {
            return res.data;
        });
    };

    var getItemList = function getItemList(branchId, searchText, limit, offset, sortASC, sortColumn, selectedItemStatus) {
        return $http.get(_app2.default.api + '/item/get-item-list', { params: { branchId: branchId, searchText: searchText, limit: limit, offset: offset, sortASC: sortASC, sortColumn: sortColumn, selectedItemStatus: selectedItemStatus } }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/item/' + id), { data: data }).then(function (res) {
            return res.data;
        });
    };

    var getItem = function getItem(id) {
        return $http.get(_app2.default.api + ('/item/' + id)).then(function (res) {
            return res.data;
        });
    };

    var logisticItemAssign = function logisticItemAssign(branchId, barcode, userId, routeId, notes, keepRouteAssignment, userKey, itemId, entryType) {
        return $http.post(_app2.default.api + '/item/logistic-item-assign', { branchId: branchId, barcode: barcode, userId: userId, routeId: routeId, notes: notes, keepRouteAssignment: keepRouteAssignment, userKey: userKey, itemId: itemId, entryType: entryType }).then(function (res) {
            return res.data;
        });
    };

    var logisticItemHold = function logisticItemHold(branchId, barcode, userId) {
        return $http.post(_app2.default.api + '/item/logistic-item-hold', { branchId: branchId, barcode: barcode, userId: userId }).then(function (res) {
            return res.data;
        });
    };

    var logisticItemDelete = function logisticItemDelete(branchId, barcode, userId) {
        return $http.post(_app2.default.api + '/item/logistic-item-delete', { branchId: branchId, barcode: barcode, userId: userId }).then(function (res) {
            return res.data;
        });
    };

    var availableRoutes = function availableRoutes(branchId) {
        return $http.get(_app2.default.api + '/item/available-routes', {
            params: { branchId: branchId }
        }).then(function (res) {
            return res.data;
        });
    };

    var logisticItemHoldRelease = function logisticItemHoldRelease(branchId, barcode, userId, routeId, note) {
        return $http.post(_app2.default.api + '/item/logistic-item-hold-release', { branchId: branchId, barcode: barcode, userId: userId, routeId: routeId, note: note }).then(function (res) {
            return res.data;
        });
    };

    var logisticItemCheckOut = function logisticItemCheckOut(branchId, barcode, userId) {
        return $http.post(_app2.default.api + '/item/logistic-item-check-out', { branchId: branchId, barcode: barcode, userId: userId }).then(function (res) {
            return res.data;
        });
    };

    var logisticItemCheckIn = function logisticItemCheckIn(branchId, barcode, userId, keepRouteAssignment) {
        return $http.post(_app2.default.api + '/item/logistic-item-check-in', { branchId: branchId, barcode: barcode, userId: userId, keepRouteAssignment: keepRouteAssignment }).then(function (res) {
            return res.data;
        });
    };

    var logisticItemBulkHold = function logisticItemBulkHold(routeId, branchId, vaultDate, userId, itemList) {
        return $http.post(_app2.default.api + '/item/logistic-item-bulk-hold', { routeId: routeId, branchId: branchId, vaultDate: vaultDate, userId: userId, itemList: itemList }).then(function (res) {
            return res.data;
        });
    };

    var logisticItemReAssign = function logisticItemReAssign(branchId, barcode, userId, routeId, notes, itemAssignmentId, userKey, itemId, entryType) {
        return $http.post(_app2.default.api + '/item/logistic-item-re-assign', { branchId: branchId, barcode: barcode, userId: userId, routeId: routeId, notes: notes, itemAssignmentId: itemAssignmentId, userKey: userKey, itemId: itemId, entryType: entryType }).then(function (res) {
            return res.data;
        });
    };

    var logisticItemForceAdd = function logisticItemForceAdd(branchId, barcode, userId, routeId, notes, keepRouteAssignment, userKey) {
        return $http.post(_app2.default.api + '/item/logistic-item-force-add', { branchId: branchId, barcode: barcode, userId: userId, routeId: routeId, notes: notes, keepRouteAssignment: keepRouteAssignment, userKey: userKey }).then(function (res) {
            return res.data;
        });
    };

    var undoItemAssignment = function undoItemAssignment(branchId, barcode, userId, routeId, itemAssignmentId, userKey, itemId, entryType) {
        return $http.post(_app2.default.api + '/item/undo-item-assignment', { branchId: branchId, barcode: barcode, userId: userId, routeId: routeId, itemAssignmentId: itemAssignmentId, userKey: userKey, itemId: itemId, entryType: entryType }).then(function (res) {
            return res.data;
        });
    };

    var getItemHistory = function getItemHistory(itemId, limit, offset, sortASC, sortColumn) {
        return $http.get(_app2.default.api + '/item/get-item-history', { params: { itemId: itemId, limit: limit, offset: offset, sortASC: sortASC, sortColumn: sortColumn } }).then(function (res) {
            return res.data;
        });
    };

    var exportItemHistory = function exportItemHistory(itemId, sortASC, sortColumn) {
        return $http.post(_app2.default.api + '/item/export-item-history', { itemId: itemId, sortASC: sortASC, sortColumn: sortColumn }).then(function (res) {
            return res.data;
        });
    };

    var logisticItemLost = function logisticItemLost(branchId, barcode, userId, itemId, entryType, routeId, userKey) {
        return $http.post(_app2.default.api + '/item/logistic-item-lost', { branchId: branchId, barcode: barcode, userId: userId, itemId: itemId, entryType: entryType, routeId: routeId, userKey: userKey }).then(function (res) {
            return res.data;
        });
    };

    var logisticItemReturnAvailable = function logisticItemReturnAvailable(branchId, barcode, userId, itemId, entryType, routeId, userKey) {
        return $http.post(_app2.default.api + '/item/logistic-item-return-available', { branchId: branchId, barcode: barcode, userId: userId, itemId: itemId, entryType: entryType, routeId: routeId, userKey: userKey }).then(function (res) {
            return res.data;
        });
    };

    return {
        create: create, getItemTypes: getItemTypes, getItemList: getItemList, update: update, getItem: getItem, availableRoutes: availableRoutes,
        logisticItemAssign: logisticItemAssign, logisticItemHold: logisticItemHold, logisticItemDelete: logisticItemDelete,
        logisticItemHoldRelease: logisticItemHoldRelease, logisticItemCheckOut: logisticItemCheckOut, logisticItemCheckIn: logisticItemCheckIn,
        logisticItemBulkHold: logisticItemBulkHold, logisticItemReAssign: logisticItemReAssign, logisticItemForceAdd: logisticItemForceAdd,
        undoItemAssignment: undoItemAssignment, getItemHistory: getItemHistory, exportItemHistory: exportItemHistory, logisticItemLost: logisticItemLost, logisticItemReturnAvailable: logisticItemReturnAvailable
    };
};

ItemService.$inject = ['$http', '$q'];

exports.default = ItemService;

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LanguageService = function LanguageService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/language', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/language', data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id) {
        return $http.delete(_app2.default.api + ('/language/' + id)).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/language/' + id), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/language/' + id)).then(function (res) {
            return res.data;
        });
    };

    var getAllUIMessages = function getAllUIMessages(key) {
        return $http.get(_app2.default.api + '/language/ui-messages?key=' + key).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get,
        getAllUIMessages: getAllUIMessages
    };
};

LanguageService.$inject = ['$http', '$q'];

exports.default = LanguageService;

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LedgerTransactionService = function LedgerTransactionService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + "/ledger-transaction", {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getLedgerDenomination = function getLedgerDenomination(search, offset, limit, orderNo, startDate, endDate, fundingSourceId) {
        return $http.get(_app2.default.api + "/ledger-transaction/getLedgerDenomination", {
            params: {
                search: search,
                offset: offset,
                limit: limit,
                orderNo: orderNo,
                startDate: startDate,
                endDate: endDate,
                fundingSourceId: fundingSourceId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getLedgerAmountAndDenomBalance = function getLedgerAmountAndDenomBalance(branchId, fundingSrcId, denominationId, account, vaultDate, currencyId) {
        return $http.post(_app2.default.api + "/ledger-transaction/ledger-amount-and-denom-balance", {
            // params: {
            branchId: branchId,
            fundingSrcId: fundingSrcId,
            denominationId: denominationId,
            account: account,
            vaultDate: vaultDate,
            currencyId: currencyId
            // }
        }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ("/ledger-transaction/get-ledger-transaction/" + id)).then(function (res) {
            return res.data;
        });
    };

    var getLedgerDenomTotal = function getLedgerDenomTotal(branchId, account, denominationId, fundingSourceId) {
        return $http.post(_app2.default.api + "/ledger-transaction/get-ledger-denom-amount", {
            branchId: branchId,
            account: account,
            denominationId: denominationId,
            fundingSourceId: fundingSourceId
        }).then(function (res) {
            return res.data;
        });
    };

    var exportBulkCashHistoryExcel = function exportBulkCashHistoryExcel(payload, fundingSourceName) {
        return $q(function (resolve, reject) {
            var url = _app2.default.api + "/ledger-transaction/exportBulkCashHistory";
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" });
                    var a = document.createElement('a');

                    var safeFundingSourceName = (fundingSourceName || "").replace(/[<>:"/\\|?*]+/g, '_').trim();
                    sheetName = 'Bulk_Cash_History_' + safeFundingSourceName + '.xlsx';

                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                } else {
                    reject();
                }
            };

            xhr.send((0, _stringify2.default)(payload));
        });
    };

    return {
        all: all,
        getLedgerDenomination: getLedgerDenomination,
        getLedgerAmountAndDenomBalance: getLedgerAmountAndDenomBalance,
        get: get,
        getLedgerDenomTotal: getLedgerDenomTotal,
        exportBulkCashHistoryExcel: exportBulkCashHistoryExcel
    };
};

LedgerTransactionService.$inject = ['$http', '$q'];

exports.default = LedgerTransactionService;

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LedgerService = function LedgerService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/ledger', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/ledger/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        get: get
    };
};

LedgerService.$inject = ['$http', '$q'];

exports.default = LedgerService;

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationBranchService = function LocationBranchService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/location-branch', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    // create multiple branch for location
    var createLocationBranchGroup = function createLocationBranchGroup(data) {
        return $http.post(_app2.default.api + '/location-branch/branchGroup', data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/location-branch/' + encodeURIComponent(id))).then(function (res) {
            return res.data;
        });
    };

    var updateLocationBranchGroup = function updateLocationBranchGroup(data) {
        return $http.post(_app2.default.api + '/location-branch/updateBranchGroup', data).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        createLocationBranchGroup: createLocationBranchGroup,
        get: get,
        updateLocationBranchGroup: updateLocationBranchGroup
    };
};

LocationBranchService.$inject = ['$http', '$q'];

exports.default = LocationBranchService;

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationDeliveryService = function LocationDeliveryService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/location-delivery', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getLocationDeliveryDetails = function getLocationDeliveryDetails(locationId) {
        return $http.get(_app2.default.api + ('/location-delivery/' + encodeURIComponent(locationId))).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        getLocationDeliveryDetails: getLocationDeliveryDetails
    };
};

LocationDeliveryService.$inject = ['$http', '$q'];

exports.default = LocationDeliveryService;

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationDistanceService = function LocationDistanceService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/location-distance', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/location-distance/create', { data: data }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/location-distance/' + id + '/update'), { data: data }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/location-distance/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        update: update,
        get: get
    };
};

LocationDistanceService.$inject = ['$http', '$q'];

exports.default = LocationDistanceService;

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationZoneService = function LocationZoneService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/location-zone', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/location-zone/' + id)).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, name, description, branchId) {
        return $http.delete(_app2.default.api + ('/location-zone/' + id), {
            params: {
                id: id, name: name, description: description, branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/location-zone/create', { data: data }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/location-zone/' + id + '/update'), { data: data }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        get: get,
        remove: remove,
        create: create,
        update: update
    };
};

LocationZoneService.$inject = ['$http', '$q'];

exports.default = LocationZoneService;

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationService = function LocationService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/location', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/location/create', data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + ('/location/' + id), { params: { branchId: branchId } }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/location/' + encodeURIComponent(id)), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/location/' + encodeURIComponent(id))).then(function (res) {
            return res.data;
        });
    };

    var holdLocation = function holdLocation(locationId, routeId, date, reason, comments, supervisorId) {
        return $http.post(_app2.default.api + ('/location/' + locationId + '/hold'), {
            routeId: routeId,
            date: date,
            reason: reason,
            comments: comments,
            supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    var getVisitingRoutes = function getVisitingRoutes(locationId, day) {
        return $http.get(_app2.default.api + ('/location/' + locationId + '/visiting-routes?day=' + day)).then(function (res) {
            return res.data;
        });
    };

    var getCoveringZones = function getCoveringZones(locationId, branchIds) {
        return $http.get(_app2.default.api + ('/location/' + encodeURIComponent(locationId) + '/covering-zones'), {
            params: { branchIds: (branchIds || []).join(',') }
        }).then(function (res) {
            return res.data;
        });
    };

    var getPickupRequestTimes = function getPickupRequestTimes() {
        return $http.get(_app2.default.api + '/pickup-request/getRequestTimeStatus').then(function (res) {
            return {
                status: true,
                data: res.data.results || res.data
            };
        });
    };

    var getBagoutData = function getBagoutData(locationId, startDate, endDate) {
        return $http.get(_app2.default.api + ('/location/bagOutData/' + locationId + '?startDate=' + startDate + '&endDate=' + endDate)).then(function (res) {
            return res.data;
        });
    };

    var getAllLocation = function getAllLocation(search, offset, limit) {
        return $http.get(_app2.default.api + '/location', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var centralBankLocation = function centralBankLocation(branch) {
        return $http.get(_app2.default.api + '/location/central-bank-location', {
            params: {
                branch: branch
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentRoutes = function shipmentRoutes(locations) {
        return $http.get(_app2.default.api + '/location/shipment-routes', {
            params: {
                locations: locations
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var bulkHoldLocations = function bulkHoldLocations(data, branchId) {
        if (!data.length) return [];
        return $http.post(_app2.default.api + '/location/bulk-hold', {
            data: data,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var fixGeocoding = function fixGeocoding(branchId, locationIds) {
        return $http.post(_app2.default.api + '/location/fix-geocoding', {
            branchId: branchId,
            locationIds: locationIds
        }).then(function (res) {
            return res.data;
        });
    };

    var exportLocations = function exportLocations(searchText, locationType, status, branch, customerId, filterByAllBranch, userId) {
        return $http.post(_app2.default.api + '/location/export-locations', {
            searchText: searchText,
            locationType: locationType,
            status: status,
            branch: branch,
            customerId: customerId,
            filterByAllBranch: filterByAllBranch,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    var getLocationUpdateHistory = function getLocationUpdateHistory(locationId, limit, offset) {
        return $http.get(_app2.default.api + '/location/get-location-update-history', {
            params: {
                locationId: locationId,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var saveLocationChanges = function saveLocationChanges(extraDetails, routeAssignment, deliveryToLocation, duration, status, allBranches, defaultBranch, batchImport, bagoutExport, handleAtmLikeRegular, recurringRouteAssignment, denomination, scheduleRecurringLoad, fundingSource) {
        return $http.post(_app2.default.api + '/location/save-location-changes', {
            extraDetails: extraDetails,
            routeAssignment: routeAssignment,
            deliveryToLocation: deliveryToLocation,
            duration: duration,
            status: status,
            allBranches: allBranches,
            defaultBranch: defaultBranch,
            batchImport: batchImport,
            bagoutExport: bagoutExport,
            handleAtmLikeRegular: handleAtmLikeRegular,
            recurringRouteAssignment: recurringRouteAssignment,
            denomination: denomination,
            scheduleRecurringLoad: scheduleRecurringLoad,
            fundingSource: fundingSource
        }).then(function (res) {
            return res.data;
        });
    };

    var getPendingLocationChanges = function getPendingLocationChanges(id) {
        return $http.get(_app2.default.api + '/location/get-pending-location-changes', {
            params: {
                id: id
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var removeLocationChanges = function removeLocationChanges(jobId) {
        return $http.post(_app2.default.api + '/location/remove-location-changes', { jobId: jobId }).then(function (res) {
            return res.data;
        });
    };

    var getPendingLocationChangesIds = function getPendingLocationChangesIds() {
        return $http.get(_app2.default.api + '/location/get-location-ids').then(function (res) {
            return res.data;
        });
    };

    var getBankDeliverLocations = function getBankDeliverLocations(searchText, branchId, destinationLocation, offset, limit, customerId, useBatchId) {
        return $http.get(_app2.default.api + '/location/get-bank-delivered-location', {
            params: {
                searchText: searchText,
                branchId: branchId,
                destinationLocation: destinationLocation,
                offset: offset,
                limit: limit,
                customerId: customerId,
                useBatchId: useBatchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getBranchLocationList = function getBranchLocationList(searchText, branchId, customerId, offset, limit) {
        return $http.get(_app2.default.api + '/location/get-branch-locations', {
            params: {
                searchText: searchText,
                branchId: branchId,
                customerId: customerId,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var hasCustomerLocation = function hasCustomerLocation(locationId, customerId, branchId) {
        return $http.get(_app2.default.api + '/location/has-customer-location', {
            params: {
                locationId: locationId, customerId: customerId, branchId: branchId
            }
        }).then(function (res) {
            res.data;
        });
    };

    var sendDeliveryOrPickupReceipt = function sendDeliveryOrPickupReceipt(trackingId, locationId, branchId, routeId, vaultDate, emails, selectedDepositAmountValue, timezone, tranType) {
        return $http.post(_app2.default.api + '/location/send-delivery-or-pickup-receipt', {
            trackingId: trackingId, locationId: locationId, branchId: branchId, routeId: routeId, vaultDate: vaultDate, emails: emails, selectedDepositAmountValue: selectedDepositAmountValue, timezone: timezone, tranType: tranType
        }).then(function (res) {
            return res.data;
        });
    };

    var sendOrderReceipt = function sendOrderReceipt(orderNo, locationId, branchId, routeId, vaultDate, emails) {
        return $http.post(_app2.default.api + '/location/send-order-receipt', {
            orderNo: orderNo, locationId: locationId, branchId: branchId, routeId: routeId, vaultDate: vaultDate, emails: emails
        }).then(function (res) {
            return res.data;
        });
    };

    var getLocationDrivingDistance = function getLocationDrivingDistance(locationAddress, branchAddress) {
        return $http.get(_app2.default.api + '/location/get-location-driving-distance', {
            params: { locationAddress: locationAddress, branchAddress: branchAddress }
        }).then(function (res) {
            return res.data;
        });
    };

    var updateLocationDrivingDistance = function updateLocationDrivingDistance(filterByAllBranch, branchId) {
        return $http.post(_app2.default.api + '/location/update-location-driving-distance', {
            filterByAllBranch: filterByAllBranch, branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var getCombinedLocationRecurring = function getCombinedLocationRecurring(id) {
        return $http.get(_app2.default.api + ('/location/getCombinedLocationRecurring/' + encodeURIComponent(id))).then(function (res) {
            return res.data;
        });
    };

    var bulkUpdateLocationDistance = function bulkUpdateLocationDistance(branchId) {
        return $http.post(_app2.default.api + '/location/bulk-update-location-distance', { branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var calculateDayOccurrences = function calculateDayOccurrences(locationId, dayOfWeek, anchorDate, interval, frequency, sequence, branchId) {
        return $http.get(_app2.default.api + ('/location/' + locationId + '/calculate-day-occurrences'), {
            params: {
                dayOfWeek: dayOfWeek, anchorDate: anchorDate, interval: interval, frequency: frequency, sequence: sequence, branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getBillingRulesByLocationId = function getBillingRulesByLocationId(locationId, offset, limit, startDate, endDate) {
        return $http.get(_app2.default.api + ('/location/' + locationId + '/get-billing-rules-by-location'), {
            params: {
                limit: limit,
                offset: offset,
                locationId: locationId,
                startDate: startDate,
                endDate: endDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getBillingHistory = function getBillingHistory(locationId, offset, limit, startDate, endDate) {
        return $http.get(_app2.default.api + ('/location/' + locationId + '/get-billing-history'), {
            params: {
                limit: limit,
                offset: offset,
                locationId: locationId,
                startDate: startDate,
                endDate: endDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportBillingRulesByLocationId = function exportBillingRulesByLocationId(locationId, startDate, endDate) {
        return $http.get(_app2.default.api + ('/location/' + locationId + '/export-billing-rules-by-location'), {
            params: {
                locationId: locationId,
                startDate: startDate,
                endDate: endDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportBillingHistory = function exportBillingHistory(locationId, startDate, endDate) {
        return $http.get(_app2.default.api + ('/location/' + locationId + '/export-billing-history'), {
            params: {
                locationId: locationId,
                startDate: startDate,
                endDate: endDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getLocationServiceZone = function getLocationServiceZone(branchId, locationId) {
        return $http.get(_app2.default.api + '/location/get-location-service-zone', {
            params: {
                branchId: branchId,
                locationId: locationId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getLocationLogs = function getLocationLogs(locationId, search, offset, limit) {
        return $http.get(_app2.default.api + ('/location/' + locationId + '/get-location-logs'), {
            params: {
                locationId: locationId, search: search, offset: offset, limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getShipmentDestinations = function getShipmentDestinations(branchId, fromLocationId, searchKey, offset, limit) {
        return $http.get(_app2.default.api + '/location/get-shipment-destinations', {
            params: { branchId: branchId, fromLocationId: fromLocationId, searchKey: searchKey, offset: offset, limit: limit }
        }).then(function (res) {
            return res.data;
        });
    };

    var getNextValutDateOfLocation = function getNextValutDateOfLocation(locationId, branchId) {
        return $http.get(_app2.default.api + '/location/get-next-vault-date', {
            params: { locationId: locationId, branchId: branchId }
        }).then(function (res) {
            return res.data;
        });
    };

    var getNextVaultDateRoute = function getNextVaultDateRoute(locationId, branchId, vaultDate) {
        return $http.get(_app2.default.api + '/pickup-request-management/get-next-vault-date-and-route', {
            params: { locationId: locationId, branchId: branchId, vaultDate: vaultDate }
        }).then(function (res) {
            return res.data;
        });
    };

    var cloneLocation = function cloneLocation(data) {
        return $http.post(_app2.default.api + '/location/clone', data).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return _promise2.default.reject(err);
        });
    };

    var validateLocationIds = function validateLocationIds(locationIds) {
        return $http.post(_app2.default.api + '/location/validate-ids', { locationIds: locationIds }).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return _promise2.default.reject(err);
        });
    };

    var getDeliveryToLocationsAndShiptypes = function getDeliveryToLocationsAndShiptypes(locationId, searchKey) {
        return $http.get(_app2.default.api + '/location/get-delivery-locations-and-shiptypes', {
            params: {
                locationId: locationId, searchKey: searchKey
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getPreventativeMaintenanceList = function getPreventativeMaintenanceList(limit, offset, searchText) {
        return $http.get(_app2.default.api + '/preventative-maintenance', {
            params: { limit: limit, offset: offset, searchText: searchText }
        }).then(function (res) {
            return res.data;
        });
    };
    var getPreventativeMaintenance = function getPreventativeMaintenance(id) {
        return $http.get(_app2.default.api + '/preventative-maintenance/' + id).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get,
        holdLocation: holdLocation,
        getVisitingRoutes: getVisitingRoutes,
        getCoveringZones: getCoveringZones,
        getPickupRequestTimes: getPickupRequestTimes,
        getBagoutData: getBagoutData,
        getAllLocation: getAllLocation,
        centralBankLocation: centralBankLocation,
        shipmentRoutes: shipmentRoutes,
        bulkHoldLocations: bulkHoldLocations,
        fixGeocoding: fixGeocoding,
        exportLocations: exportLocations,
        getLocationUpdateHistory: getLocationUpdateHistory,
        saveLocationChanges: saveLocationChanges,
        getPendingLocationChanges: getPendingLocationChanges,
        removeLocationChanges: removeLocationChanges,
        getPendingLocationChangesIds: getPendingLocationChangesIds,
        getBankDeliverLocations: getBankDeliverLocations,
        getBranchLocationList: getBranchLocationList,
        hasCustomerLocation: hasCustomerLocation,
        sendDeliveryOrPickupReceipt: sendDeliveryOrPickupReceipt,
        sendOrderReceipt: sendOrderReceipt,
        getLocationDrivingDistance: getLocationDrivingDistance,
        updateLocationDrivingDistance: updateLocationDrivingDistance,
        getCombinedLocationRecurring: getCombinedLocationRecurring,
        calculateDayOccurrences: calculateDayOccurrences,
        bulkUpdateLocationDistance: bulkUpdateLocationDistance,
        getBillingRulesByLocationId: getBillingRulesByLocationId,
        getBillingHistory: getBillingHistory,
        exportBillingRulesByLocationId: exportBillingRulesByLocationId,
        exportBillingHistory: exportBillingHistory,
        getLocationServiceZone: getLocationServiceZone,
        getLocationLogs: getLocationLogs,
        getShipmentDestinations: getShipmentDestinations,
        getNextValutDateOfLocation: getNextValutDateOfLocation,
        getNextVaultDateRoute: getNextVaultDateRoute,
        cloneLocation: cloneLocation,
        validateLocationIds: validateLocationIds,
        getDeliveryToLocationsAndShiptypes: getDeliveryToLocationsAndShiptypes,
        getPreventativeMaintenanceList: getPreventativeMaintenanceList,
        getPreventativeMaintenance: getPreventativeMaintenance
    };
};

LocationService.$inject = ['$http', '$q'];

exports.default = LocationService;

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LockOpenErrorService = function LockOpenErrorService($http, $q) {

    var getFailedToOpenLocks = function getFailedToOpenLocks(branchId, startDate, endDate) {
        return $http.get(_app2.default.api + '/lock-open-errors/get-failed-to-open-locks', {
            params: {
                branchId: branchId,
                startDate: startDate,
                endDate: endDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportFailedToOpenLock = function exportFailedToOpenLock(branchId, startDate, endDate) {
        return $http.post(_app2.default.api + '/lock-open-errors/export-failed-to-open-locks', { branchId: branchId, startDate: startDate, endDate: endDate }).then(function (res) {
            return res.data;
        });
    };

    return {
        getFailedToOpenLocks: getFailedToOpenLocks,
        exportFailedToOpenLock: exportFailedToOpenLock
    };
};

LockOpenErrorService.$inject = ['$http', '$q'];

exports.default = LockOpenErrorService;

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogService = function LogService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/logs', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/logs/' + id)).then(function (res) {
            return res.data;
        });
    };

    var recentActivity = function recentActivity(branchId, entryType) {
        return $http.get(_app2.default.api + '/logs/recent', {
            params: {
                branchId: branchId, entryType: entryType
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getLogInfo = function getLogInfo(entryType, userId) {
        return $http.get(_app2.default.api + '/logs/get-log-info', {
            params: { entryType: entryType, userId: userId }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        get: get,
        recentActivity: recentActivity,
        getLogInfo: getLogInfo
    };
};

LogService.$inject = ['$http', '$q'];

exports.default = LogService;

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageService = function MessageService($http, $q) {

    var all = function all(languageId, search, offset, limit) {
        return $http.get(_app2.default.api + ('/language/' + languageId + '/message'), {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(languageId, data, branchId) {
        return $http.post(_app2.default.api + ('/language/' + languageId + '/message/create'), { data: data, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(languageId, id, messageId, type, branchId) {
        return $http.delete(_app2.default.api + ('/language/' + languageId + '/message/' + id), {
            params: {
                messageId: messageId,
                type: type,
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(languageId, id, data, branchId) {
        return $http.post(_app2.default.api + ('/language/' + languageId + '/message/' + id), { data: data, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(languageId, id) {
        return $http.get(_app2.default.api + ('/language/' + languageId + '/message/' + id)).then(function (res) {
            return res.data;
        });
    };

    var getDuplicateMsg = function getDuplicateMsg(languageId, searchText, messageType, offset, limit) {
        return $http.get(_app2.default.api + ('/language/' + languageId + '/message/duplicate-msg'), {
            params: {
                languageId: languageId,
                searchText: searchText,
                messageType: messageType,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getReasons = function getReasons(languageId, routeVerifyData) {
        return $http.post(_app2.default.api + ('/language/' + languageId + '/message/route-reasons'), routeVerifyData).then(function (res) {
            return res.data;
        });
    };

    var updateLanguageMessage = function updateLanguageMessage(languageId, data) {
        return $http.post(_app2.default.api + ('/language/' + languageId + '/message/update-language-message'), { data: data }).then(function (res) {
            return res.data;
        });
    };

    var getPendingMessage = function getPendingMessage(languageId) {
        return $http.get(_app2.default.api + ('/language/' + languageId + '/message/pending-msg')).then(function (res) {
            return res.data;
        });
    };

    var getMessageTypeBuckets = function getMessageTypeBuckets(searchText, languageId) {
        return $http.get(_app2.default.api + ('/language/' + languageId + '/message/get-message-type-buckets'), {
            params: {
                searchText: searchText,
                languageId: languageId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getLanguageMessages = function getLanguageMessages(searchText, languageId, messageType, limit, offset) {
        return $http.get(_app2.default.api + ('/language/' + languageId + '/message/get-language-message'), {
            params: {
                searchText: searchText,
                languageId: languageId,
                messageType: messageType,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getMessageByMessageId = function getMessageByMessageId(languageId, messageId, messageType) {
        return $http.get(_app2.default.api + ('/language/' + languageId + '/message/get-message-by-message-id'), {
            params: {
                messageId: messageId,
                messageType: messageType
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentDeleteReason = function shipmentDeleteReason(type, languageId) {
        return $http.get(_app2.default.api + ('/language/' + languageId + '/message/shipment-delete-reason'), {
            params: { type: type, languageId: languageId }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get,
        getDuplicateMsg: getDuplicateMsg,
        getReasons: getReasons,
        updateLanguageMessage: updateLanguageMessage,
        getPendingMessage: getPendingMessage,
        getMessageTypeBuckets: getMessageTypeBuckets,
        getLanguageMessages: getLanguageMessages,
        getMessageByMessageId: getMessageByMessageId,
        shipmentDeleteReason: shipmentDeleteReason
    };
};

MessageService.$inject = ['$http', '$q'];

exports.default = MessageService;

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileAppService = function MobileAppService($http, $q) {

    var saveApp = function saveApp(data) {
        return $http.post(_app2.default.api + '/mobile-app/save-app', data).then(function (res) {
            return res.data;
        });
    };

    var getAll = function getAll() {
        return $http.get(_app2.default.api + '/mobile-app/get-app').then(function (res) {
            return res.data;
        });
    };

    return {
        saveApp: saveApp,
        getAll: getAll
    };
};

MobileAppService.$inject = ['$http', '$q'];

exports.default = MobileAppService;

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MonthlyReportService = function MonthlyReportService($http, $q) {

    var getMonthlyReport = function getMonthlyReport(startDate, endDate, searchText, offset, limit) {
        return $http.post(_app2.default.api + '/monthly-report/get-monthly-report', {
            startDate: startDate,
            endDate: endDate,
            searchText: searchText,
            offset: offset,
            limit: limit
        }).then(function (res) {
            return res.data;
        });
    };

    var exportDataToCSV = function exportDataToCSV(searchText, startDate, endDate, offset, limit) {
        return $http.post(_app2.default.api + '/monthly-report/export-to-csv', {
            searchText: searchText,
            startDate: startDate,
            endDate: endDate,
            offset: offset,
            limit: limit
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getMonthlyReport: getMonthlyReport,
        exportDataToCSV: exportDataToCSV
    };
};

MonthlyReportService.$inject = ['$http', '$q'];

exports.default = MonthlyReportService;

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderPackingService = function OrderPackingService($http, $q) {

    var orderPackingList = function orderPackingList(branchId, locationId) {
        return $http.post(_app2.default.api + '/order-packing/order-packing-list', {
            branchId: branchId,
            locationId: locationId
        }).then(function (res) {
            return res.data;
        });
    };

    var packableOrderPack = function packableOrderPack(branchFundingSourceId, orderNo, supervisorId, routeId, routeSeq, labels, deliveryToShipmentTypes, vaultDate) {
        var labelSeparator = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;

        return $http.post(_app2.default.api + '/order-packing/packable-order-pack', {
            branchFundingSourceId: branchFundingSourceId,
            orderNo: orderNo,
            supervisorId: supervisorId,
            routeId: routeId,
            routeSeq: routeSeq,
            labels: labels,
            deliveryToShipmentTypes: deliveryToShipmentTypes,
            vaultDate: vaultDate,
            labelSeparator: labelSeparator
        }).then(function (res) {
            return res.data;
        });
    };

    var orderPackingPack = function orderPackingPack(fundingSourceId, shipmentId, trackingIdDelivery, trackingIdResidual, routeId, toLocationId, amount, denominationId, account, branchId, orderNo, supervisorId, vaultDate, deliveryDate, deliveryToShipTypes, singleDenomShipments) {
        return $http.post(_app2.default.api + '/order-packing/order-packing-pack', {
            fundingSourceId: fundingSourceId,
            shipmentId: shipmentId,
            trackingIdDelivery: trackingIdDelivery,
            trackingIdResidual: trackingIdResidual,
            routeId: routeId,
            toLocationId: toLocationId,
            amount: amount,
            denominationId: denominationId,
            account: account,
            branchId: branchId,
            orderNo: orderNo,
            supervisorId: supervisorId,
            vaultDate: vaultDate,
            deliveryDate: deliveryDate,
            // TODO: LIMIT THE PAYLOAD
            deliveryToShipTypes: deliveryToShipTypes,
            singleDenomShipments: singleDenomShipments
        }).then(function (res) {
            return res.data;
        });
    };

    var getOrderCassetteUsage = function getOrderCassetteUsage(orderNo, toLocationId) {
        return $http.post(_app2.default.api + '/order-packing/order-cassette-usage', {
            orderNo: orderNo,
            toLocationId: toLocationId
        }).then(function (res) {
            return res.data;
        });
    };

    var verifyTrackingIds = function verifyTrackingIds(trackingIds, packableOrderId) {
        return $http.post(_app2.default.api + '/order-packing/verify-tracking-ids', {
            trackingIds: trackingIds
        });
    };

    var orderPackingCancel = function orderPackingCancel(shipmentId, branchId) {
        return $http.post(_app2.default.api + '/order-packing/order-packing-cancel', {
            shipmentId: shipmentId,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var orderPackingCompleteList = function orderPackingCompleteList(branchId, vaultDate) {
        return $http.post(_app2.default.api + '/order-packing/order-packing-complete-list', {
            branchId: branchId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var getcurBalanceByDenom = function getcurBalanceByDenom(branchId, account, denomination, fundingSourceId) {
        return $http.post(_app2.default.api + '/order-packing/get-current-balance', {
            branchId: branchId,
            account: account,
            denomination: denomination,
            fundingSourceId: fundingSourceId
        }).then(function (res) {
            return res.data;
        });
    };

    var softDelete = function softDelete(trackingId, branchId, reason, supervisorId) {
        return $http.post(_app2.default.api + '/order-packing/soft-delete', {
            trackingId: trackingId,
            branchId: branchId,
            reason: reason,
            supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    var softDeleteOrder = function softDeleteOrder(orderNo, supervisorId, branchId) {
        return $http.post(_app2.default.api + '/order-packing/soft-delete-order', {
            orderNo: orderNo,
            supervisorId: supervisorId,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var getLastOrderInformation = function getLastOrderInformation(locationId, date) {
        return $http.post(_app2.default.api + '/order-packing/last-order-info', {
            locationId: locationId,
            date: date
        }).then(function (res) {
            return res.data;
        });
    };

    var getPendingPackShipmentsOnHold = function getPendingPackShipmentsOnHold(branchId, date) {
        return $http.get(_app2.default.api + '/order-packing/get-pending-pack-shipments-on-hold', {
            params: {
                branchId: branchId,
                date: date
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getPackedShipments = function getPackedShipments(branchId, vaultDate, offset, limit, bfsId) {
        var params = {
            branchId: branchId,
            vaultDate: vaultDate,
            offset: offset,
            limit: limit
        };

        // Add bfsId if provided for currency filtering
        if (bfsId) {
            params.bfsId = bfsId;
        }

        return $http.get(_app2.default.api + '/order-packing/get-packed-shipments', { params: params }).then(function (res) {
            return res.data;
        });
    };

    var getPackedOrders = function getPackedOrders(branchId, locationId) {
        return $http.post(_app2.default.api + '/order-packing/get-packed-orders', {
            branchId: branchId,
            locationId: locationId
        }).then(function (res) {
            return res.data;
        });
    };

    var exportPackedShipments = function exportPackedShipments(branchId, date, sortColumn, sortASC, orderType, route, searchText, bfsId, currencySymbol, customerId) {
        return new _promise2.default(function (resolve, reject) {
            var url = _app2.default.api + '/order-packing/export-packed-shipments';
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = {
                branchId: branchId,
                date: date,
                sortColumn: sortColumn,
                sortASC: sortASC,
                orderType: orderType,
                route: route,
                searchText: searchText,
                bfsId: bfsId,
                currencySymbol: currencySymbol || '$',
                customerId: customerId
            };

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" });
                    var a = document.createElement('a');
                    var reportPrefix = branchId;
                    var dt = moment(date).format('DDMMYY');
                    sheetName = reportPrefix.concat(' Packed_Shipment_', dt, '.xlsx');
                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                } else reject();
            };

            return xhr.send((0, _stringify2.default)(data));
        });
    };

    var exportPendingPackShipmentsAndOrders = function exportPendingPackShipmentsAndOrders(fundingSourceId, fundingSource, branchId, orderType, route, searchText, date, currencySymbol, filterDate, customerId) {
        return new _promise2.default(function (resolve, reject) {
            var url = _app2.default.api + '/order-packing/export-pending-pack-shipments-and-orders';
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = {
                fundingSourceId: fundingSourceId,
                fundingSource: fundingSource,
                branchId: branchId,
                orderType: orderType,
                route: route,
                searchText: searchText,
                date: date,
                currencySymbol: currencySymbol || '$',
                filterDate: filterDate,
                customerId: customerId
            };

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" });
                    var a = document.createElement('a');
                    var reportPrefix = branchId;
                    var dt = moment(date).format('DDMMYY');
                    sheetName = reportPrefix.concat(' Pending_Pack_Shipment_', dt, '.xlsx');
                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                } else reject();
            };

            return xhr.send((0, _stringify2.default)(data));
        });
    };

    var getOrderPackRoutes = function getOrderPackRoutes(branchId, vaultDate) {
        return $http.get(_app2.default.api + '/order-packing/get-order-pack-routes', {
            params: {
                branchId: branchId,
                vaultDate: vaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var printPackedShipments = function printPackedShipments(branchId, date, sortColumn, sortASC, orderType, route, searchText, bfsId, currencySymbol, customerId) {
        return $http.post(_app2.default.api + '/order-packing/print-packed-shipments', {
            branchId: branchId,
            date: date,
            sortColumn: sortColumn,
            sortASC: sortASC,
            orderType: orderType,
            route: route,
            searchText: searchText,
            bfsId: bfsId,
            currencySymbol: currencySymbol || '$',
            customerId: customerId
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        orderPackingList: orderPackingList,
        orderPackingPack: orderPackingPack,
        getOrderCassetteUsage: getOrderCassetteUsage,
        orderPackingCancel: orderPackingCancel,
        orderPackingCompleteList: orderPackingCompleteList,
        getcurBalanceByDenom: getcurBalanceByDenom,
        packableOrderPack: packableOrderPack,
        softDelete: softDelete,
        softDeleteOrder: softDeleteOrder,
        getLastOrderInformation: getLastOrderInformation,
        getPendingPackShipmentsOnHold: getPendingPackShipmentsOnHold,
        getPackedShipments: getPackedShipments,
        getPackedOrders: getPackedOrders,
        exportPackedShipments: exportPackedShipments,
        exportPendingPackShipmentsAndOrders: exportPendingPackShipmentsAndOrders,
        getOrderPackRoutes: getOrderPackRoutes,
        verifyTrackingIds: verifyTrackingIds,
        printPackedShipments: printPackedShipments
    };
};

OrderPackingService.$inject = ['$http', '$q'];

exports.default = OrderPackingService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderViewService = function OrderViewService($http, $q) {

    var getAtmOrders = function getAtmOrders(searchText, branchId, startDate, endDate, orderStat, fundingSourceId, customerId, locationId, orderType, routeId, status, denominationId) {
        return $http.get(_app2.default.api + '/order-view/get-atm-orders', {
            params: {
                searchText: searchText,
                branchId: branchId,
                startDate: startDate,
                endDate: endDate,
                orderStat: orderStat,
                fundingSourceId: fundingSourceId,
                customerId: customerId,
                locationId: locationId,
                orderType: orderType,
                routeId: routeId,
                status: status,
                denominationId: denominationId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var findLocationRoute = function findLocationRoute(locationId, date) {
        return $http.get(_app2.default.api + '/order-view/find-location-route', {
            params: {
                locationId: locationId,
                date: date
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var createAtmOrders = function createAtmOrders(data) {
        return $http.post(_app2.default.api + '/order-view/create-atm-orders', data).then(function (res) {
            return res.data;
        });
    };

    // let updateShipment = (orderNo, locationId, orderType, vaultDate, routeId, branchId, cashOrderId, denominations ) => {
    //     return $http
    //         .post(AppConstants.api + `/order-view/update-shipment`, {
    //             orderNo, locationId, orderType, vaultDate, routeId, branchId, cashOrderId, denominations 
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // }

    var cancelAtmOrder = function cancelAtmOrder(cashOrderId, branchId, userId) {
        return $http.post(_app2.default.api + '/order-view/cancel-atm-order', { cashOrderId: cashOrderId, branchId: branchId, userId: userId }).then(function (res) {
            return res.data;
        });
    };

    var updateScheduledShipment = function updateScheduledShipment(denominations, locationId, locationScheduleRecurringId) {
        return $http.post(_app2.default.api + '/order-view/update-scheduled-shipment', { denominations: denominations, locationId: locationId, locationScheduleRecurringId: locationScheduleRecurringId }).then(function (res) {
            return res.data;
        });
    };

    var updatePendingPackShipment = function updatePendingPackShipment(denominations, vaultDate, locationId, routeId, orderNo, orderType, amount, branchId, denominationId, supervisorId) {
        return $http.post(_app2.default.api + '/order-view/update-pending-pack-shipment', {
            denominations: denominations, vaultDate: vaultDate, locationId: locationId, routeId: routeId, orderNo: orderNo, orderType: orderType, amount: amount, branchId: branchId, denominationId: denominationId, supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    var generateOrderNumber = function generateOrderNumber() {
        return $http.get(_app2.default.api + '/order-view/generate-order-number', {}).then(function (res) {
            return res.data;
        });
    };

    var createAtmLoadShipments = function createAtmLoadShipments(shipments) {
        return $http.post(_app2.default.api + '/order-view/create-atm-load-shipments', { shipments: shipments }).then(function (res) {
            return res.data;
        });
    };

    var getLocationOrdersSinceSwap = function getLocationOrdersSinceSwap(locationId) {
        return $http.get(_app2.default.api + '/order-view/get-location-orders-since-swap', {
            params: {
                locationId: locationId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var createRecurringATMLoadShipment = function createRecurringATMLoadShipment(shipments) {
        return $http.post(_app2.default.api + '/order-view/create-recurring-atm-load-shipment', { shipments: shipments }).then(function (res) {
            return res.data;
        });
    };

    var cancelRecurringATMLoadShipment = function cancelRecurringATMLoadShipment(jobKey, denominationId) {
        return $http.post(_app2.default.api + '/order-view/cancel-recurring-atm-load-shipment', { jobKey: jobKey, denominationId: denominationId }).then(function (res) {
            return res.data;
        });
    };

    var updatePackedCashBag = function updatePackedCashBag(trackingId, vaultDate, routeId, branchId, coinShipments, cashShipmentAmount) {
        return $http.post(_app2.default.api + '/order-view/update-packed-cash-bag', {
            trackingId: trackingId, vaultDate: vaultDate, routeId: routeId, branchId: branchId, coinShipments: coinShipments, cashShipmentAmount: cashShipmentAmount
        }).then(function (res) {
            return res.data;
        });
    };

    var getFundingSourceDenomination = function getFundingSourceDenomination(branchFundingSourceId) {
        var locationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var params = { branchFundingSourceId: branchFundingSourceId };
        if (locationId) {
            params.locationId = locationId;
        }
        return $http.get(_app2.default.api + '/order-view/get-funding-source-denomination', {
            params: params
        }).then(function (res) {
            return res.data;
        });
    };

    var getFundingSourceDenominationUnpack = function getFundingSourceDenominationUnpack(branchFundingSourceId) {
        return $http.get(_app2.default.api + '/order-view/get-funding-source-denomination-unpack', {
            params: { branchFundingSourceId: branchFundingSourceId }
        }).then(function (res) {
            return res.data;
        });
    };

    var createPackableOrder = function createPackableOrder(obj) {
        return $http.post(_app2.default.api + '/order-view/create-packable-order', obj).then(function (res) {
            return res.data;
        });
    };

    var updatePendingPackOrder = function updatePendingPackOrder(denominations, vaultDate, locationId, routeId, orderNo, orderType, amount, branchId, denominationId, supervisorId) {
        return $http.post(_app2.default.api + '/order-view/update-pending-pack-order', {
            denominations: denominations, vaultDate: vaultDate, locationId: locationId, routeId: routeId, orderNo: orderNo, orderType: orderType, amount: amount, branchId: branchId, denominationId: denominationId, supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    var updateRecurrinRoute = function updateRecurrinRoute(combinedRoutes, deletedRecurringStops, locationId, branchId) {
        return $http.post(_app2.default.api + '/order-view/update-recurring-route', { combinedRoutes: combinedRoutes, deletedRecurringStops: deletedRecurringStops, locationId: locationId, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var convertScheduledOrderToPackableOrder = function convertScheduledOrderToPackableOrder(fundingSourceId, locationId, recurringDate, userId, branchId) {
        return $http.post(_app2.default.api + '/order-view/convert-scheduled-order-to-packable-order', { fundingSourceId: fundingSourceId, locationId: locationId, recurringDate: recurringDate, userId: userId, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    return {
        getAtmOrders: getAtmOrders,
        findLocationRoute: findLocationRoute,
        createAtmOrders: createAtmOrders,
        updatePendingPackShipment: updatePendingPackShipment,
        updatePendingPackOrder: updatePendingPackOrder,
        cancelAtmOrder: cancelAtmOrder,
        generateOrderNumber: generateOrderNumber,
        createAtmLoadShipments: createAtmLoadShipments,
        getLocationOrdersSinceSwap: getLocationOrdersSinceSwap,
        createRecurringATMLoadShipment: createRecurringATMLoadShipment,
        cancelRecurringATMLoadShipment: cancelRecurringATMLoadShipment,
        updatePackedCashBag: updatePackedCashBag,
        getFundingSourceDenominationUnpack: getFundingSourceDenominationUnpack,
        createPackableOrder: createPackableOrder,
        getFundingSourceDenomination: getFundingSourceDenomination,
        updateRecurrinRoute: updateRecurrinRoute,
        updateScheduledShipment: updateScheduledShipment,
        convertScheduledOrderToPackableOrder: convertScheduledOrderToPackableOrder
    };
};

OrderViewService.$inject = ['$http', '$q'];

exports.default = OrderViewService;

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhysicalCashCountService = function PhysicalCashCountService($http, $q) {

    var getFundingSource = function getFundingSource(branchId) {
        return $http.get(_app2.default.api + '/physical-cash-count/get-funding-source', {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var commitPhysicalCashCount = function commitPhysicalCashCount(cashCountDetails, branchId, userId, currencyId, notes, vaultDate) {
        return $http.post(_app2.default.api + '/physical-cash-count/commit-physical-cash-count', {
            cashCountDetails: cashCountDetails,
            branchId: branchId,
            userId: userId,
            currencyId: currencyId,
            notes: notes,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var findRequirementOrBalanceCount = function findRequirementOrBalanceCount(branchId, fundingSourceData, vaultDate) {
        return $http.get(_app2.default.api + '/physical-cash-count/find-requirements-or-balance-count', {
            params: {
                branchId: branchId,
                fundingSourceData: fundingSourceData,
                vaultDate: vaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var editPhysicalCashCount = function editPhysicalCashCount(cashCountDetails, balanceCheckIds, userId, branchId, currencyId, vaultDate) {
        return $http.post(_app2.default.api + '/physical-cash-count/edit-physical-cash-count', {
            cashCountDetails: cashCountDetails,
            balanceCheckIds: balanceCheckIds,
            userId: userId,
            branchId: branchId,
            currencyId: currencyId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var checkForVariance = function checkForVariance(data) {
        return $http.post(_app2.default.api + '/physical-cash-count/check-for-variance', {
            data: data
        }).then(function (res) {
            return res.data;
        });
    };

    var approvePhysicalCashCount = function approvePhysicalCashCount(vaultDate, fundingSourceId, branchId, userId, totalAmount, variance, denominations) {
        return $http.post(_app2.default.api + '/physical-cash-count/approve-physical-cash-count', {
            vaultDate: vaultDate, fundingSourceId: fundingSourceId, branchId: branchId, userId: userId, totalAmount: totalAmount, variance: variance, denominations: denominations
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getFundingSource: getFundingSource,
        commitPhysicalCashCount: commitPhysicalCashCount,
        findRequirementOrBalanceCount: findRequirementOrBalanceCount,
        editPhysicalCashCount: editPhysicalCashCount,
        checkForVariance: checkForVariance,
        approvePhysicalCashCount: approvePhysicalCashCount
    };
};

PhysicalCashCountService.$inject = ['$http', '$q'];

exports.default = PhysicalCashCountService;

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PrefixService = function PrefixService() {

    var addPrefix = function addPrefix(value, type) {
        if (!type || !value) {
            return value;
        }

        var prefixChar = type[0].toUpperCase();
        var regex = new RegExp("^" + prefixChar);

        return (regex.test(value) ? '' : prefixChar) + value;
    };

    return {
        addPrefix: addPrefix
    };
};

PrefixService.$inject = [];

exports.default = PrefixService;

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricePointService = function PricePointService($http, $q) {

    var all = function all(offset, limit, sortingKey, sortingDir) {
        return $http.get(_app2.default.api + '/price-point', {
            params: {
                offset: offset,
                limit: limit,
                sortingKey: sortingKey,
                sortingDir: sortingDir
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/price-point', data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/price-point/' + id)).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/price-point/' + id), data).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        get: get,
        update: update
    };
};

PricePointService.$inject = ['$http', '$q'];

exports.default = PricePointService;

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(28);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegionRoutingService = function RegionRoutingService($http, $q) {

    var getLocations = function getLocations(title, latDetails, longDetails, branch, searchText, limit, offset, zonePolygon) {
        return $http.get(_app2.default.api + '/region-routing/get-locations/', {
            params: {
                title: title,
                latDetails: latDetails,
                longDetails: longDetails,
                branch: branch,
                searchText: searchText,
                limit: limit,
                offset: offset,
                zonePolygon: zonePolygon ? (0, _stringify2.default)(zonePolygon) : null
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getAllLocations = function getAllLocations(limit, offset) {
        return $http.get(_app2.default.api + '/region-routing/get-all-locations/', {
            params: {
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var createLocationZone = function createLocationZone(loggedInUser, branch, title, /* type, */latDetails, longDetails, dayOfWeek, shape, locationData, limit, offset) {
        return $http.post(_app2.default.api + '/region-routing/create-location-zone/', {
            loggedInUser: loggedInUser,
            branch: branch,
            title: title,
            // type,
            latDetails: latDetails,
            longDetails: longDetails,
            dayOfWeek: dayOfWeek,
            shape: shape,
            locationData: locationData,
            limit: limit,
            offset: offset
        }).then(function (res) {
            return res.data;
        });
    };

    var updateLocationZone = function updateLocationZone(loggedInUser, branch, title, id, /* type, */latDetails, longDetails, dayOfWeek, shape, locationData, limit, offset) {
        return $http.post(_app2.default.api + '/region-routing/update-location-zone/', {
            loggedInUser: loggedInUser,
            branch: branch,
            title: title,
            id: id,
            // type,
            latDetails: latDetails,
            longDetails: longDetails,
            dayOfWeek: dayOfWeek,
            shape: shape,
            locationData: locationData,
            limit: limit,
            offset: offset
        }).then(function (res) {
            return res.data;
        });
    };

    var getDayWiseLocationZone = function getDayWiseLocationZone(branch, day) {
        return $http.get(_app2.default.api + '/region-routing/get-day-wise-location-zone/', {
            params: { branch: branch, day: day }
        }).then(function (res) {
            return res.data;
        });
    };

    var deleteLocationZone = function deleteLocationZone(id, name, branchId) {
        return $http.delete(_app2.default.api + ('/region-routing/' + id), {
            params: {
                id: id, name: name, branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getLocationZoneCount = function getLocationZoneCount(branch) {
        return $http.get(_app2.default.api + '/region-routing/get-location-zone-count/', {
            params: { branch: branch }
        }).then(function (res) {
            return res.data;
        });
    };

    var syncZoneLocations = function syncZoneLocations(locationZoneId) {
        return $http.post(_app2.default.api + ('/region-routing/' + locationZoneId + '/sync-zone-locations')).then(function (res) {
            return res.data;
        });
    };

    var getLocationZoneRules = function getLocationZoneRules(locationZoneId, limit, offset) {
        return $http.get(_app2.default.api + ('/region-routing/location-zone-rules/' + locationZoneId), {
            params: { limit: limit, offset: offset }
        }).then(function (res) {
            return res.data;
        });
    };

    var getAssignableUsersForZone = function getAssignableUsersForZone(locationZoneId, search, limit, offset) {
        return $http.get(_app2.default.api + ('/region-routing/location-zone-rules/' + locationZoneId + '/assignable-users'), {
            params: { search: search, limit: limit, offset: offset }
        }).then(function (res) {
            return res.data;
        });
    };

    var getAssignableCustomersForZone = function getAssignableCustomersForZone(locationZoneId, search, limit, offset) {
        return $http.get(_app2.default.api + ('/region-routing/location-zone-rules/' + locationZoneId + '/assignable-customers'), {
            params: { search: search, limit: limit, offset: offset }
        }).then(function (res) {
            return res.data;
        });
    };

    var createLocationZoneRule = function createLocationZoneRule(locationZoneId, payload) {
        return $http.post(_app2.default.api + ('/region-routing/location-zone-rules/' + locationZoneId), payload).then(function (res) {
            return res.data;
        });
    };

    var updateLocationZoneRule = function updateLocationZoneRule(locationZoneId, ruleId, payload) {
        return $http.post(_app2.default.api + ('/region-routing/location-zone-rules/' + locationZoneId + '/' + ruleId + '/update'), payload).then(function (res) {
            return res.data;
        });
    };

    var deleteLocationZoneRule = function deleteLocationZoneRule(locationZoneId, ruleId) {
        return $http.delete(_app2.default.api + ('/region-routing/location-zone-rules/' + locationZoneId + '/' + ruleId)).then(function (res) {
            return res.data;
        });
    };

    var reorderLocationZoneRules = function reorderLocationZoneRules(locationZoneId, rules) {
        return $http.post(_app2.default.api + ('/region-routing/location-zone-rules/' + locationZoneId + '/reorder'), { rules: rules }).then(function (res) {
            return res.data;
        });
    };

    var bulkAllDaySaveLocationZones = function bulkAllDaySaveLocationZones(payload) {
        return $http.post(_app2.default.api + '/region-routing/bulk-all-days-save-location-zones/', (0, _extends3.default)({}, payload)).then(function (res) {
            return res.data;
        });
    };
    return {
        getAllLocations: getAllLocations,
        getLocations: getLocations,
        createLocationZone: createLocationZone,
        updateLocationZone: updateLocationZone,
        getDayWiseLocationZone: getDayWiseLocationZone,
        deleteLocationZone: deleteLocationZone,
        getLocationZoneCount: getLocationZoneCount,
        syncZoneLocations: syncZoneLocations,
        getLocationZoneRules: getLocationZoneRules,
        getAssignableUsersForZone: getAssignableUsersForZone,
        getAssignableCustomersForZone: getAssignableCustomersForZone,
        createLocationZoneRule: createLocationZoneRule,
        updateLocationZoneRule: updateLocationZoneRule,
        deleteLocationZoneRule: deleteLocationZoneRule,
        reorderLocationZoneRules: reorderLocationZoneRules,
        bulkAllDaySaveLocationZones: bulkAllDaySaveLocationZones
    };
};

RegionRoutingService.$inject = ['$http', '$q'];

exports.default = RegionRoutingService;

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportService = function ReportService($http, $q) {

    var routePerformance = function routePerformance(startDate, endDate, groupInterval, reverseSort, branch, route, groupBy, limit, offset) {
        return $http.get(_app2.default.api + "/report/route-performance", {
            params: {
                startDate: startDate,
                endDate: endDate,
                groupInterval: groupInterval,
                reverseSort: reverseSort,
                branch: branch,
                route: route,
                groupBy: groupBy,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var routeLocationPerformance = function routeLocationPerformance(startDate, endDate, groupInterval, reverseSort, branch, location, groupBy, limit, offset) {
        return $http.get(_app2.default.api + "/report/route-location-performance", {
            params: {
                startDate: startDate,
                endDate: endDate,
                groupInterval: groupInterval,
                reverseSort: reverseSort,
                branch: branch,
                location: location,
                groupBy: groupBy,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var ledgerActivityReport = function ledgerActivityReport(startDate, endDate, groupInterval, groupBy, account, branch, fundingSource, currency, denomination, limit, offset) {
        return $http.get(_app2.default.api + "/report/ledger-activity", {
            params: {
                startDate: startDate,
                endDate: endDate,
                groupInterval: groupInterval,
                groupBy: groupBy,
                account: account,
                branch: branch,
                fundingSource: fundingSource,
                currency: currency,
                denomination: denomination,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var loadCompletedActivity = function loadCompletedActivity(startDate, endDate, groupInterval, groupBy, branch, route, fundingSource, location, currency, denomination, limit, offset) {
        return $http.get(_app2.default.api + "/report/load-completed-activity", {
            params: {
                startDate: startDate,
                endDate: endDate,
                groupInterval: groupInterval,
                groupBy: groupBy,
                branch: branch,
                route: route,
                fundingSource: fundingSource,
                location: location,
                currency: currency,
                denomination: denomination,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var deliveryCompletedActivity = function deliveryCompletedActivity(startDate, endDate, groupInterval, groupBy, branch, route, fromLocation, toLocation, shiptype, limit, offset) {
        return $http.get(_app2.default.api + "/report/delivery-completed-activity", {
            params: {
                startDate: startDate,
                endDate: endDate,
                groupInterval: groupInterval,
                groupBy: groupBy,
                branch: branch,
                route: route,
                fromLocation: fromLocation,
                toLocation: toLocation,
                shiptype: shiptype,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var residualCompletedActivity = function residualCompletedActivity(startDate, endDate, groupInterval, groupBy, branch, route, fundingSource, location, currency, denomination, limit, offset) {
        return $http.get(_app2.default.api + "/report/residual-completed-activity", {
            params: {
                startDate: startDate,
                endDate: endDate,
                groupInterval: groupInterval,
                groupBy: groupBy,
                branch: branch,
                route: route,
                fundingSource: fundingSource,
                location: location,
                currency: currency,
                denomination: denomination,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var pickupCompletedActivity = function pickupCompletedActivity(startDate, endDate, groupInterval, groupBy, branch, route, fromLocation, toLocation, shiptype, limit, offset) {
        return $http.get(_app2.default.api + "/report/pickup-completed-activity", {
            params: {
                startDate: startDate,
                endDate: endDate,
                groupInterval: groupInterval,
                groupBy: groupBy,
                branch: branch,
                route: route,
                fromLocation: fromLocation,
                toLocation: toLocation,
                shiptype: shiptype,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var bagoutCompletedActivity = function bagoutCompletedActivity(startDate, endDate, groupInterval, groupBy, branch, carrier, fromLocation, toLocation, shiptype, limit, offset) {
        return $http.get(_app2.default.api + "/report/bagout-completed-activity", {
            params: {
                startDate: startDate,
                endDate: endDate,
                groupInterval: groupInterval,
                groupBy: groupBy,
                branch: branch,
                carrier: carrier,
                fromLocation: fromLocation,
                toLocation: toLocation,
                shiptype: shiptype,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var serviceOrderCompletedActivity = function serviceOrderCompletedActivity(startDate, endDate, groupInterval, groupBy, branch, location, route, user, externalProcessor, limit, offset) {
        return $http.get(_app2.default.api + "/report/serviceorder-completed-activity", {
            params: {
                startDate: startDate,
                endDate: endDate,
                groupInterval: groupInterval,
                groupBy: groupBy,
                branch: branch,
                location: location,
                route: route,
                user: user,
                externalProcessor: externalProcessor,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var serviceOrderCancelledActivity = function serviceOrderCancelledActivity(startDate, endDate, groupInterval, groupBy, branch, location, route, user, externalProcessor, limit, offset) {
        return $http.get(_app2.default.api + "/report/serviceorder-cancelled-activity", {
            params: {
                startDate: startDate,
                endDate: endDate,
                groupInterval: groupInterval,
                groupBy: groupBy,
                branch: branch,
                location: location,
                route: route,
                user: user,
                externalProcessor: externalProcessor,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var userList = function userList(searchText, branch, offset, limit) {
        return $http.get(_app2.default.api + "/report/supervisor-user-list", {
            params: { searchText: searchText, branch: branch, offset: offset, limit: limit }
        }).then(function (res) {
            return res.data;
        });
    };

    var onHoldReport = function onHoldReport(searchText, startDate, endDate, routeId, branchId, userId, offset, limit) {
        return $http.get(_app2.default.api + "/report/on-hold-report", {
            params: { searchText: searchText, startDate: startDate, endDate: endDate, routeId: routeId, branchId: branchId, userId: userId, offset: offset, limit: limit }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportHoldReport = function exportHoldReport(searchText, startDate, endDate, routeId, branchId) {
        return $http.post(_app2.default.api + "/report/export-on-hold-report", {
            searchText: searchText, startDate: startDate, endDate: endDate, routeId: routeId, branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        routePerformance: routePerformance,
        routeLocationPerformance: routeLocationPerformance,
        ledgerActivityReport: ledgerActivityReport,
        loadCompletedActivity: loadCompletedActivity,
        residualCompletedActivity: residualCompletedActivity,
        deliveryCompletedActivity: deliveryCompletedActivity,
        pickupCompletedActivity: pickupCompletedActivity,
        bagoutCompletedActivity: bagoutCompletedActivity,
        serviceOrderCompletedActivity: serviceOrderCompletedActivity,
        serviceOrderCancelledActivity: serviceOrderCancelledActivity,
        userList: userList,
        onHoldReport: onHoldReport,
        exportHoldReport: exportHoldReport
    };
};

ReportService.$inject = ["$http", "$q"];

exports.default = ReportService;

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetAtmCodeService = function ResetAtmCodeService($http, $q) {

    var getAllKeys = function getAllKeys(cacheKey, date) {
        return $http.get(_app2.default.api + '/reset-atm-code/get-all-keys', {
            params: {
                cacheKey: cacheKey,
                date: date
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var deleteAtmCode = function deleteAtmCode(cacheKey, branchId) {
        return $http.post(_app2.default.api + '/reset-atm-code/delete-atm-codes', {
            cacheKey: cacheKey,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var getAtmCode = function getAtmCode(cacheKey) {
        return $http.get(_app2.default.api + '/reset-atm-code/get-atm-code', {
            params: {
                cacheKey: cacheKey
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getAllKeys: getAllKeys,
        deleteAtmCode: deleteAtmCode,
        getAtmCode: getAtmCode
    };
};

ResetAtmCodeService.$inject = ['$http', '$q'];

exports.default = ResetAtmCodeService;

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RestoreRouteAssignmentService = function RestoreRouteAssignmentService($http, $q) {

    var getLocationRouteChange = function getLocationRouteChange(searchText, branchId, offset, limit) {
        return $http.get(_app2.default.api + '/restore-route-assignments/get-location-route-change', {
            params: {
                searchText: searchText,
                branchId: branchId,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var undoLocationRouteChange = function undoLocationRouteChange(data, branchId, userId) {
        return $http.post(_app2.default.api + '/restore-route-assignments/undo-location-route-change', {
            data: data,
            branchId: branchId,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getLocationRouteChange: getLocationRouteChange,
        undoLocationRouteChange: undoLocationRouteChange
    };
};

RestoreRouteAssignmentService.$inject = ['$http', '$q'];

exports.default = RestoreRouteAssignmentService;

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteDetailService = function RouteDetailService($http, $q) {

    var getRoutesForBranch = function getRoutesForBranch(branchId, date, completed) {
        return $http.get(_app2.default.api + ('/route-detail/' + branchId), {
            params: {
                date: date,
                completed: completed
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var routeUpdateDetails = function routeUpdateDetails(branchId, routeId, vaultDate, vehicleId, messengerId, driverId, guardId, leaveTime, arriveTime, begMiles, endMiles) {
        return $http.post(_app2.default.api + '/route-detail/route-update-detail', {
            branchId: branchId,
            routeId: routeId,
            vaultDate: vaultDate,
            vehicleId: vehicleId,
            messengerId: messengerId,
            driverId: driverId,
            guardId: guardId,
            leaveTime: leaveTime,
            arriveTime: arriveTime,
            begMiles: begMiles,
            endMiles: endMiles
        }).then(function (res) {
            return res.data;
        });
    };

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/route-detail', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var pickupDeliveryShipments = function pickupDeliveryShipments(branchId, routeId, vaultDate, flagType) {
        return $http.get(_app2.default.api + ('/route-detail/' + branchId + '/pickup-delivery-shipments'), {
            params: { routeId: routeId, vaultDate: vaultDate, flagType: flagType, branchId: branchId }
        }).then(function (res) {
            return res.data;
        });
    };

    var updateMessenger = function updateMessenger(branchId, routeId, vaultDate, messengerId) {
        return $http.post(_app2.default.api + '/route-detail/update-messenger', {
            branchId: branchId,
            routeId: routeId,
            vaultDate: vaultDate,
            messengerId: messengerId
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getRoutesForBranch: getRoutesForBranch,
        routeUpdateDetails: routeUpdateDetails,
        updateMessenger: updateMessenger,
        all: all,
        pickupDeliveryShipments: pickupDeliveryShipments
    };
};

RouteDetailService.$inject = ['$http', '$q'];

exports.default = RouteDetailService;

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteProgressService = function RouteProgressService($http, $q) {

    var getRouteStops = function getRouteStops(routeId, date, branch) {
        return $http.get(_app2.default.api + '/route-progress/get-route-stops', {
            params: {
                routeId: routeId,
                date: date,
                branch: branch
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getRouteOriginationCoordinates = function getRouteOriginationCoordinates(routeId, date) {
        return $http.get(_app2.default.api + '/route-progress/get-route-origination-coordinates', {
            params: {
                routeId: routeId,
                date: date
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getStopComments = function getStopComments(routeId, vaultDate, locationId) {
        return $http.get(_app2.default.api + '/route-progress/get-stop-comments', {
            params: {
                routeId: routeId,
                vaultDate: vaultDate,
                locationId: locationId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportRouteStops = function exportRouteStops(routeId, date, branch) {
        return $http.post(_app2.default.api + '/route-progress/export-route-stops', { routeId: routeId, date: date, branch: branch }).then(function (res) {
            return res.data;
        });
    };

    var getEstimatedRouteMileage = function getEstimatedRouteMileage(payload) {
        return $http.post(_app2.default.api + '/on-call-routing/get-route-mileage', payload).then(function (res) {
            return res.data;
        });
    };

    return {
        getRouteStops: getRouteStops,
        getStopComments: getStopComments,
        exportRouteStops: exportRouteStops,
        getEstimatedRouteMileage: getEstimatedRouteMileage,
        getRouteOriginationCoordinates: getRouteOriginationCoordinates
    };
};

RouteProgressService.$inject = ['$http', '$q'];

exports.default = RouteProgressService;

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteStatsService = function RouteStatsService($http, $q) {

    var getRouteShipmentDetail = function getRouteShipmentDetail(vaultDate, routeId, locationId) {
        var messengerId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        return $http.get(_app2.default.api + '/route-stats/get-route-shipment-detail', {
            params: {
                vaultDate: vaultDate, routeId: routeId, locationId: locationId, messengerId: messengerId
            }
        }).then(function (res) {
            return res.data;
        });
    };
    var getShipmentTransactionHistory = function getShipmentTransactionHistory(trackingId, routeId, locationId) {
        return $http.get(_app2.default.api + '/route-stats/get-transaction-history', {
            params: {
                trackingId: trackingId, routeId: routeId, locationId: locationId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getRouteShipmentDetail: getRouteShipmentDetail,
        getShipmentTransactionHistory: getShipmentTransactionHistory
    };
};

RouteStatsService.$inject = ['$http', '$q'];

exports.default = RouteStatsService;

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteStopService = function RouteStopService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/route-stop', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var updateRouteStop = function updateRouteStop(routeSequence, branchId) {
        return $http.post(_app2.default.api + '/route-stop/update-route-stop', {
            routeSequence: routeSequence,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var autoOptimizeRouteStops = function autoOptimizeRouteStops(routeDate, routeId) {
        return $http.post(_app2.default.api + '/route-stop/optimize-route-stop', {
            routeDate: routeDate,
            routeId: routeId
        }).then(function (res) {
            return res.data;
        });
    };

    var routeStopList = function routeStopList(routeId, routeDate, branchId) {
        return $http.post(_app2.default.api + '/route-stop/get-route-stop-list', {
            routeId: routeId,
            routeDate: routeDate,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var stopPerformance = function stopPerformance(searchText, startTime, endTime, branchId, sortASC, sortColumn, routeId, timezone, offset, limit, startDate, endDate) {
        return $http.get(_app2.default.api + '/stop-performance/stop-performance', {
            params: {
                searchText: searchText, startTime: startTime, endTime: endTime, branchId: branchId, sortASC: sortASC, sortColumn: sortColumn, routeId: routeId, timezone: timezone, offset: offset, limit: limit, startDate: startDate, endDate: endDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportStopPerformance = function exportStopPerformance(searchText, startTime, endTime, branchId, sortASC, sortColumn, routeId, timezone, offset, limit, startDate, endDate) {
        return $http.post(_app2.default.api + '/stop-performance/export-stop-performance', {
            searchText: searchText, startTime: startTime, endTime: endTime, branchId: branchId, sortASC: sortASC, sortColumn: sortColumn, routeId: routeId, timezone: timezone, offset: offset, limit: limit, startDate: startDate, endDate: endDate
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        updateRouteStop: updateRouteStop,
        autoOptimizeRouteStops: autoOptimizeRouteStops,
        routeStopList: routeStopList,
        stopPerformance: stopPerformance,
        exportStopPerformance: exportStopPerformance
    };
};

RouteStopService.$inject = ['$http', '$q'];

exports.default = RouteStopService;

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteService = function RouteService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + "/route", {
            params: {
                "search": search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var filterRoutes = function filterRoutes(filter) {
        return $http.get(_app2.default.api + "/route", {
            params: {
                filter: filter
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + "/route/create", data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + ("/route/" + id), {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ("/route/" + id), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ("/route/" + id)).then(function (res) {
            return res.data;
        });
    };

    var sheet = function sheet(id, date, branch) {
        // Example, ID=TR1, DATE=2017-01-01
        return $http.get(_app2.default.api + ("/route/" + id + "/sheet?date=" + date + "&branch=" + branch)).then(function (res) {
            return res.data;
        });
    };

    var getRouteSequence = function getRouteSequence(id, branch, day) {
        return $http.get(_app2.default.api + ("/route/" + id + "/sequence?day=" + day + "&branch=" + branch)).then(function (res) {
            return res.data;
        });
    };

    var closeRoute = function closeRoute(branchId, id, date, windowId) {
        return $http.post(_app2.default.api + ("/route/" + id + "/close"), {
            branchId: branchId,
            date: date,
            windowId: windowId
        }).then(function (res) {
            return res.data;
        });
    };

    var coinPullReport = function coinPullReport(id, date) {
        return $http.get(_app2.default.api + ("/route/" + id + "/coin-pull-report?date=" + date)).then(function (res) {
            return res.data;
        });
    };

    var getUploadedFiles = function getUploadedFiles() {
        return $http.get(_app2.default.api + "/route/upload-files").then(function (res) {
            return res.data;
        });
    };

    var getUploadFile = function getUploadFile(fileName, branchId) {
        return $http.get(_app2.default.api + ("/route/upload-file?file=" + fileName + "&branchId=" + branchId)).then(function (res) {
            return res.data;
        });
    };

    var removeUploadFile = function removeUploadFile(fileName) {
        return $http.post(_app2.default.api + "/route/delete-upload-file", { fileName: fileName }).then(function (res) {
            return res.data;
        });
    };

    var unlockFile = function unlockFile(fileName) {
        return $http.post(_app2.default.api + "/route/unlock-file", { fileName: fileName }).then(function (res) {
            return res.data;
        });
    };

    var lockFile = function lockFile(fileName) {
        return $http.post(_app2.default.api + "/route/lock-file", { fileName: fileName }).then(function (res) {
            return res.data;
        });
    };

    var releaseRoute = function releaseRoute(route, date, branchId, routeReleaseFrom) {
        return $http.post(_app2.default.api + "/route/release", { route: route, date: date, branchId: branchId, routeReleaseFrom: routeReleaseFrom }).then(function (res) {
            return res.data;
        });
    };

    var releaseRoutes = function releaseRoutes(routes, date) {
        return $http.post(_app2.default.api + "/route/release", { routes: routes, date: date }).then(function (res) {
            return res.data;
        });
    };

    var routeCheckout = function routeCheckout(branchId, id, date, fromTanker, toTanker, window, messengerId, routeDetailConfigurationValue) {
        return $http.post(_app2.default.api + ("/route/" + id + "/checkout"), { branchId: branchId, date: date, fromTanker: fromTanker, toTanker: toTanker, window: window, messengerId: messengerId, routeDetailConfigurationValue: routeDetailConfigurationValue }).then(function (res) {
            return res.data;
        });
    };

    var routeStatus = function routeStatus(routeId, vaultDate, branchId) {
        return $http.get(_app2.default.api + ("/route/route-status/" + routeId + "?vaultDate=" + vaultDate + "&branchId=" + branchId)).then(function (res) {
            return res.data;
        });
    };

    var routeLocTransfer = function routeLocTransfer(data) {
        return $http.post(_app2.default.api + "/route/route-transfer", data).then(function (res) {
            return res.data;
        });
    };

    var getRouteSequenceCount = function getRouteSequenceCount(id, branch, day) {
        return $http.get(_app2.default.api + ("/route/" + id + "/sequence-count?day=" + day + "&branch=" + branch)).then(function (res) {
            return res.data;
        });
    };

    var getActiveRouteSequence = function getActiveRouteSequence(id, branch, day) {
        return $http.get(_app2.default.api + ("/route/" + id + "/active-route-sequence?day=" + day + "&branch=" + branch)).then(function (res) {
            return res.data;
        });
    };

    var exportCSV = function exportCSV(routeId, vaultDate, flag, timezone) {
        return $http.get(_app2.default.api + ("/route/export-route-csv/" + routeId + "?vaultDate=" + vaultDate + "&flag=" + flag + "&timezone=" + encodeURIComponent(timezone))).then(function (res) {
            return res.data;
        });
    };

    var routeStopList = function routeStopList(fromRouteId, toRouteId, date, branch) {
        return $http.post(_app2.default.api + "/route/route-stop-list", {
            fromRouteId: fromRouteId,
            toRouteId: toRouteId,
            date: date,
            branch: branch
        }).then(function (res) {
            return res.data;
        });
    };

    var routeStopTransferList = function routeStopTransferList(fromRouteId, toRouteId, fromVaultDate, toVaultDate, branch) {
        return $http.post(_app2.default.api + "/route/route-stop-transfer-list", {
            fromRouteId: fromRouteId,
            toRouteId: toRouteId,
            fromVaultDate: fromVaultDate,
            toVaultDate: toVaultDate,
            branch: branch
        }).then(function (res) {
            return res.data;
        });
    };

    var routeStopTransfered = function routeStopTransfered(routes, branchId) {
        return $http.post(_app2.default.api + "/route/route-stop-transfered", {
            routes: routes,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var updateStopsAndShipments = function updateStopsAndShipments(transferredStops, stops, branchId, override, destinationRouteSequence) {
        return $http.post(_app2.default.api + "/route/update-stops-and-shipments", {
            transferredStops: transferredStops,
            stops: stops,
            branchId: branchId,
            override: override,
            destinationRouteSequence: destinationRouteSequence
        }).then(function (res) {
            return res.data;
        });
    };

    var getAllBranchRoutes = function getAllBranchRoutes(branch, date) {
        return $http.post(_app2.default.api + "/route/get-all-branch-routes", {
            branch: branch,
            date: date
        }).then(function (res) {
            return res.data;
        });
    };

    var getBranchRoutes = function getBranchRoutes(branch, date) {
        return $http.post(_app2.default.api + "/route/get-branch-routes", {
            branch: branch,
            date: date
        }).then(function (res) {
            return res.data;
        });
    };

    var getActiveRoutes = function getActiveRoutes(branchId, date) {
        return $http.get(_app2.default.api + "/route/get-active-routes", {
            params: {
                branchId: branchId,
                date: date
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getRoutes = function getRoutes(branchId, vaultDate) {
        return $http.post(_app2.default.api + "/route/get-routes", {
            branchId: branchId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var getTankerAssignments = function getTankerAssignments(routeId) {
        return $http.get(_app2.default.api + ("/route/" + routeId + "/tankers")).then(function (res) {
            return res.data;
        });
    };

    var setTankerAssignments = function setTankerAssignments(routeId, data) {
        return $http.post(_app2.default.api + ("/route/" + routeId + "/tankers"), data).then(function (res) {
            return res.data;
        });
    };

    var getTankersAvailable = function getTankersAvailable(routeId) {
        return $http.get(_app2.default.api + ("/route/" + routeId + "/tankers-available")).then(function (res) {
            return res.data;
        });
    };

    var getRouteTanker = function getRouteTanker(routeId, routeDate) {
        return $http.get(_app2.default.api + ("/route/get-route-tanker/" + routeId + "?routeDate=" + routeDate)).then(function (res) {
            return res.data;
        });
    };

    var getRouteUpdateHistory = function getRouteUpdateHistory(routeId, limit, offset) {
        return $http.get(_app2.default.api + ("/route/get-route-update-history/" + routeId + "?limit=" + limit + "&offset=" + offset)).then(function (res) {
            return res.data;
        });
    };

    var saveRouteChanges = function saveRouteChanges(routeId, assignedTankers, extraDetails, duration) {
        return $http.post(_app2.default.api + "/route/save-route-changes", {
            routeId: routeId,
            assignedTankers: assignedTankers,
            extraDetails: extraDetails,
            duration: duration
        }).then(function (res) {
            return res.data;
        });
    };

    var getPendingRouteChanges = function getPendingRouteChanges(routeId) {
        return $http.get(_app2.default.api + ("/route/get-pending-route-changes/" + routeId)).then(function (res) {
            return res.data;
        });
    };

    var removeRouteChanges = function removeRouteChanges(jobId) {
        return $http.post(_app2.default.api + "/route/remove-route-changes", { jobId: jobId }).then(function (res) {
            return res.data;
        });
    };

    var sendDeliveryPickupReports = function sendDeliveryPickupReports(routeId, vaultDate, timezone, sendDeliveryReports, sendPickupReports) {
        return $http.post(_app2.default.api + ("/route/" + routeId + "/send-delivery-pickup-reports"), {
            vaultDate: vaultDate,
            timezone: timezone,
            sendDeliveryReports: sendDeliveryReports,
            sendPickupReports: sendPickupReports
        }).then(function (res) {
            return res.data;
        });
    };

    var branchCoinPullReport = function branchCoinPullReport(branch, vaultDate) {
        return $http.get(_app2.default.api + "/route/branch-coin-pull-report", {
            params: {
                branch: branch, vaultDate: vaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportAllRouteStops = function exportAllRouteStops(branchId, routeId, vaultDate, timezone) {
        return new _promise2.default(function (resolve, reject) {
            var url = _app2.default.api + "/route/export-all-route-stops";
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = { branchId: branchId, routeId: routeId, vaultDate: vaultDate, timezone: timezone };

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" }),
                        a = document.createElement('a'),
                        reportPrefix = 'Route_Stops_',
                        dt = moment(vaultDate).format('DDMMYY');

                    sheetName = reportPrefix.concat(dt, '_', '(', branchId, ')', '.xlsx');
                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                } else reject();
            };

            return xhr.send((0, _stringify2.default)(data));
        });
    };

    var getScheduledRouteByLocationId = function getScheduledRouteByLocationId(vaultDate, locationId) {
        var branchId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        return $http.get(_app2.default.api + "/route/get-scheduled-routes-by-location", {
            params: {
                vaultDate: vaultDate,
                locationId: locationId,
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var emailManifest = function emailManifest(routeId, data) {
        return $http.post(_app2.default.api + ("/route/" + routeId + "/email-manifest"), data).then(function (res) {
            return res.data;
        });
    };
    var pickupReportEmail = function pickupReportEmail(emailData) {
        return $http.post(_app2.default.api + "/route/pickup-report-email", emailData).then(function (res) {
            return res.data;
        });
    };

    var emailRouteSheet = function emailRouteSheet(routeId, data) {
        return $http.post(_app2.default.api + ("/route/" + routeId + "/email-route-sheet"), data).then(function (res) {
            return res.data;
        });
    };

    var getAvailableRoutes = function getAvailableRoutes(branchId, vaultDate, offset, limit, searchKey, shuttleRoute) {
        return $http.post(_app2.default.api + "/route/get-available-routes", {
            branchId: branchId,
            vaultDate: vaultDate,
            offset: offset,
            limit: limit,
            searchKey: searchKey,
            shuttleRoute: shuttleRoute
        }).then(function (res) {
            return res.data;
        });
    };

    var validateLedgerBalanceAgainstRouteCoinHandler = function validateLedgerBalanceAgainstRouteCoinHandler(routeId, vaultDate) {
        return $http.get(_app2.default.api + "/route/validate-ledger-balance-against-route-coin-handler", { params: { routeId: routeId, vaultDate: vaultDate } }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get,
        sheet: sheet,
        emailManifest: emailManifest,
        getRouteSequence: getRouteSequence,
        filterRoutes: filterRoutes,
        closeRoute: closeRoute,
        coinPullReport: coinPullReport,
        getUploadedFiles: getUploadedFiles,
        getUploadFile: getUploadFile,
        unlockFile: unlockFile,
        removeUploadFile: removeUploadFile,
        pickupReportEmail: pickupReportEmail,
        lockFile: lockFile,
        releaseRoute: releaseRoute,
        releaseRoutes: releaseRoutes,
        routeCheckout: routeCheckout,
        routeStatus: routeStatus,
        routeLocTransfer: routeLocTransfer,
        getRouteSequenceCount: getRouteSequenceCount,
        getActiveRouteSequence: getActiveRouteSequence,
        exportCSV: exportCSV,
        routeStopList: routeStopList,
        routeStopTransferList: routeStopTransferList,
        routeStopTransfered: routeStopTransfered,
        updateStopsAndShipments: updateStopsAndShipments,
        getAllBranchRoutes: getAllBranchRoutes,
        getBranchRoutes: getBranchRoutes,
        getActiveRoutes: getActiveRoutes,
        getRoutes: getRoutes,
        getTankerAssignments: getTankerAssignments,
        setTankerAssignments: setTankerAssignments,
        getTankersAvailable: getTankersAvailable,
        getRouteTanker: getRouteTanker,
        getRouteUpdateHistory: getRouteUpdateHistory,
        saveRouteChanges: saveRouteChanges,
        getPendingRouteChanges: getPendingRouteChanges,
        removeRouteChanges: removeRouteChanges,
        sendDeliveryPickupReports: sendDeliveryPickupReports,
        branchCoinPullReport: branchCoinPullReport,
        exportAllRouteStops: exportAllRouteStops,
        getScheduledRouteByLocationId: getScheduledRouteByLocationId,
        emailRouteSheet: emailRouteSheet,
        getAvailableRoutes: getAvailableRoutes,
        validateLedgerBalanceAgainstRouteCoinHandler: validateLedgerBalanceAgainstRouteCoinHandler
    };
};

RouteService.$inject = ['$http', '$q'];

exports.default = RouteService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ScanConfigService = function ScanConfigService() {
  var _this = this;

  this.scanConfig = null;

  var getScanConfig = function getScanConfig() {
    return _this.scanConfig;
  };

  var setScanConfig = function setScanConfig(scanConfig) {
    _this.scanConfig = scanConfig;
  };

  return {
    getScanConfig: getScanConfig,
    setScanConfig: setScanConfig
  };
};

ScanConfigService.$inject = [];

exports.default = ScanConfigService;

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScanService = function ScanService($http, $q) {

    var scanRoute = function scanRoute(branchId, id, date, isCheckin, isCheckout, requireRouteDetail) {
        return $http.post(_app2.default.api + '/scan/route', {
            id: id,
            branchId: branchId,
            date: date,
            isCheckin: isCheckin,
            isCheckout: isCheckout,
            requireRouteDetail: requireRouteDetail
        }).then(function (res) {
            return res.data;
        });
    };

    var scanMessenger = function scanMessenger(branchId, routeId, messengerId, vaultDate, requireRtDetail) {
        return $http.post(_app2.default.api + '/scan/messenger', {
            branchId: branchId,
            routeId: routeId,
            messengerId: messengerId,
            vaultDate: vaultDate,
            requireRtDetail: requireRtDetail
        }).then(function (res) {
            return res.data;
        });
    };

    var scanFromTanker = function scanFromTanker(routeId, routeDate) {
        return $http.post(_app2.default.api + '/scan/fromTanker', {
            routeId: routeId,
            routeDate: routeDate
        }).then(function (res) {
            return res.data;
        });
    };

    var scanTruckId = function scanTruckId(truckId) {
        return $http.post(_app2.default.api + '/scan/truckId', {
            truckId: truckId
        }).then(function (res) {
            return res.data;
        });
    };

    var scanSupervisor = function scanSupervisor(id, password, event, branch, details) {
        return $http.post(_app2.default.api + '/scan/supervisor', {
            id: id,
            password: password,
            event: event,
            branch: branch,
            details: details
        }).then(function (res) {
            return res.data;
        });
    };

    var routeCheckinVerify = function routeCheckinVerify(branchId, id, date, userId) {
        return $http.post(_app2.default.api + '/scan/route-checkin-verify', {
            branchId: branchId,
            id: id,
            date: date,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    var routeCheckoutVerify = function routeCheckoutVerify(branchId, id, date, userId) {
        return $http.post(_app2.default.api + '/scan/route-checkout-verify', {
            branchId: branchId,
            id: id,
            date: date,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    var verifyRouteThrowShipment = function verifyRouteThrowShipment(branchId, trackingId, deliveryDate) {
        return $http.post(_app2.default.api + '/scan/route-throw-shipment-verify', {
            branchId: branchId,
            trackingId: trackingId,
            deliveryDate: deliveryDate
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentCheckInCheckOutData = function shipmentCheckInCheckOutData(branchId, routeId, vaultDate) {
        return $http.get(_app2.default.api + '/scan/checkin-checkout-data', {
            params: {
                branchId: branchId, routeId: routeId, vaultDate: vaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var validateTotanker = function validateTotanker(tankerId) {
        return $http.get(_app2.default.api + '/scan/validate-to-tanker', {
            params: {
                tankerId: tankerId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getShipmentTanker = function getShipmentTanker(branch, vaultDate) {
        return $http.get(_app2.default.api + '/scan/shipment-tanker', {
            params: {
                branch: branch,
                vaultDate: vaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentVerify = function shipmentVerify(route, date, isCoinCheckOut, branch) {
        return $http.post(_app2.default.api + '/scan/shipment-verify', {
            route: route,
            date: date,
            isCoinCheckOut: isCoinCheckOut,
            branch: branch
        }).then(function (res) {
            return res.data;
        });
    };

    var updateTrackingId = function updateTrackingId(oldTrackingId, newTrackingId, comment, supervisorId, branchId) {
        return $http.post(_app2.default.api + '/scan/update-tracking-id', {
            oldTrackingId: oldTrackingId,
            newTrackingId: newTrackingId,
            comment: comment,
            supervisorId: supervisorId,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentThrowCount = function shipmentThrowCount(routeId, branchId, date, isCoinCheckOut) {
        return $http.post(_app2.default.api + '/scan/throw-count', {
            routeId: routeId,
            branchId: branchId,
            date: date,
            isCoinCheckOut: isCoinCheckOut
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentThrowList = function shipmentThrowList(routeId, branchId, date, isCoinCheckOut) {
        return $http.post(_app2.default.api + '/scan/throw-list', {
            routeId: routeId,
            branchId: branchId,
            date: date,
            isCoinCheckOut: isCoinCheckOut
        }).then(function (res) {
            return res.data;
        });
    };

    var verifyCoin = function verifyCoin(routeId, vaultDate) {
        return $http.post(_app2.default.api + '/scan/verify-coin', {
            routeId: routeId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };
    var getCurrentDenomLedgerBalance = function getCurrentDenomLedgerBalance(branchId, account, allCoins, routeId, vaultDate) {
        return $http.post(_app2.default.api + '/scan/get-current-balance', {
            branchId: branchId,
            account: account,
            allCoins: allCoins,
            routeId: routeId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var verifyRouteCoin = function verifyRouteCoin(routeId, vaultDate, branchId, coinIds) {
        return $http.post(_app2.default.api + '/scan/route-coin-verify', {
            routeId: routeId,
            vaultDate: vaultDate,
            branchId: branchId,
            coinIds: coinIds
        }).then(function (res) {
            return res.data;
        });
    };

    var updateRouteCheckoutStartTime = function updateRouteCheckoutStartTime(routeId, routeDate) {
        return $http.post(_app2.default.api + '/scan/update-route-checkout-start-time', {
            routeId: routeId,
            routeDate: routeDate
        }).then(function (res) {
            return res.data;
        });
    };

    var getCheckoutUserAssignedItems = function getCheckoutUserAssignedItems(routeId, branchId, userId) {
        return $http.post(_app2.default.api + '/scan/get-checkout-user-assigned-items', {
            routeId: routeId,
            branchId: branchId,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    var getCheckinUserAssignedItems = function getCheckinUserAssignedItems(routeId, branchId, userId) {
        return $http.post(_app2.default.api + '/scan/get-checkin-user-assigned-items', {
            routeId: routeId,
            branchId: branchId,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        scanRoute: scanRoute,
        scanMessenger: scanMessenger,
        scanFromTanker: scanFromTanker,
        scanSupervisor: scanSupervisor,
        routeCheckinVerify: routeCheckinVerify,
        routeCheckoutVerify: routeCheckoutVerify,
        verifyRouteThrowShipment: verifyRouteThrowShipment,
        shipmentCheckInCheckOutData: shipmentCheckInCheckOutData,
        validateTotanker: validateTotanker,
        getShipmentTanker: getShipmentTanker,
        shipmentVerify: shipmentVerify,
        updateTrackingId: updateTrackingId,
        shipmentThrowCount: shipmentThrowCount,
        shipmentThrowList: shipmentThrowList,
        verifyCoin: verifyCoin,
        verifyRouteCoin: verifyRouteCoin,
        updateRouteCheckoutStartTime: updateRouteCheckoutStartTime,
        getCurrentDenomLedgerBalance: getCurrentDenomLedgerBalance,
        scanTruckId: scanTruckId,
        getCheckoutUserAssignedItems: getCheckoutUserAssignedItems,
        getCheckinUserAssignedItems: getCheckinUserAssignedItems
    };
};

ScanService.$inject = ['$http', '$q'];

exports.default = ScanService;

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ServiceActionPrioritiesService = function ServiceActionPrioritiesService($http, $q) {
    var apiUrl = '/api/service-action-priorities';

    var all = function all() {
        var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

        return $http.get('' + apiUrl, {
            params: { query: query, offset: offset, limit: limit }
        }).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return $q.reject(err);
        });
    };

    var create = function create(data) {
        return $http.post(apiUrl, data).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return $q.reject(err);
        });
    };

    var update = function update(id, data) {
        return $http.put(apiUrl + '/' + id, data).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return $q.reject(err);
        });
    };

    var remove = function remove(id) {
        return $http.delete(apiUrl + '/' + id).then(function (res) {
            return res.data;
        }).catch(function (err) {
            return $q.reject(err);
        });
    };

    return {
        all: all,
        create: create,
        update: update,
        remove: remove
    };
};

ServiceActionPrioritiesService.$inject = ['$http', '$q'];

exports.default = ServiceActionPrioritiesService;

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceChecklistService = function ServiceChecklistService($http, $q) {

    var create = function create(data) {
        return $http.post(_app2.default.api + "/service-checklist", {
            data: data
        }).then(function (res) {
            return res.data;
        });
    };

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + "/service-checklist", {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var updateServiceChecklist = function updateServiceChecklist(data) {
        return $http.post(_app2.default.api + "/service-checklist/update-service-checklist", data).then(function (res) {
            return res.data;
        });
    };

    return {
        create: create,
        all: all,
        updateServiceChecklist: updateServiceChecklist
    };
};

ServiceChecklistService.$inject = ["$http", "$q"];

exports.default = ServiceChecklistService;

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceOrderService = function ServiceOrderService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/service-order', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            actionCode = _ref.actionCode,
            actionCodeNotes = _ref.actionCodeNotes,
            branchId = _ref.branchId,
            encounterId = _ref.encounterId,
            locationId = _ref.locationId,
            lockType = _ref.lockType,
            stopPriority = _ref.stopPriority,
            model = _ref.model,
            note = _ref.note,
            serialNumber = _ref.serialNumber,
            requestedTimeframe = _ref.requestedTimeframe,
            status = _ref.status,
            targetTime = _ref.targetTime,
            billingReviewRequire = _ref.billingReviewRequire,
            selectedFiles = _ref.selectedFiles;

        var payload = {
            actionCode: actionCode || null,
            actionCodeNotes: actionCodeNotes || '',
            branchId: branchId || '',
            encounterId: encounterId || '',
            locationId: locationId || '',
            lockType: lockType || '',
            stopPriority: stopPriority || '',
            model: model || '',
            note: note || '',
            requestedTimeframe: requestedTimeframe || '',
            serialNumber: serialNumber || '',
            status: status || '',
            targetTime: targetTime || '',
            billingReviewRequire: billingReviewRequire !== undefined ? billingReviewRequire : false
        };

        var fd = new FormData();

        fd.append('jsonData', (0, _stringify2.default)(payload));

        if (selectedFiles && selectedFiles.length) {
            selectedFiles.forEach(function (file) {
                if (file._file) {
                    fd.append('files', file._file, file.fileName);
                }
            });
        }

        return $http.post(_app2.default.api + '/service-order', fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    };

    var getServiceOrder = function getServiceOrder(branchIds, locationId, routeId, userId, actionCodeId, bucketName, filter, timezone, customerId, serviceZoneId) {
        return $http.post(_app2.default.api + '/service-order/get-service-order', {
            branchIds: branchIds,
            locationId: locationId,
            routeId: routeId,
            userId: userId,
            actionCodeId: actionCodeId,
            bucketName: bucketName,
            filter: filter,
            timezone: timezone,
            customerId: customerId,
            serviceZoneId: serviceZoneId
        }).then(function (res) {
            return res.data;
        });
    };

    var serviceOrderHistory = function serviceOrderHistory(encounterId, serviceOrderId, externalProcessorId) {
        return $http.post(_app2.default.api + '/service-order/service-order-history', {
            encounterId: encounterId,
            serviceOrderId: serviceOrderId,
            externalProcessorId: externalProcessorId
        }).then(function (res) {
            return res.data;
        });
    };

    var updateServiceOrderNote = function updateServiceOrderNote(encounterId, serviceOrderId, branchId, serviceOrderUserNote, serviceOrderNote, vaultDate, routeId, status) {
        return $http.post(_app2.default.api + '/service-order/update-note', {
            encounterId: encounterId,
            serviceOrderId: serviceOrderId,
            branchId: branchId,
            serviceOrderUserNote: serviceOrderUserNote,
            serviceOrderNote: serviceOrderNote,
            vaultDate: vaultDate,
            routeId: routeId,
            status: status
        }).then(function (res) {
            return res.data;
        });
    };

    var updateServiceOrderNoteList = function updateServiceOrderNoteList(encounterId, serviceOrderId, branchId, serviceOrderNote, vaultDate, routeId, status, serviceOrderUserNotes) {
        return $http.post(_app2.default.api + '/service-order/update-note-list', {
            encounterId: encounterId,
            serviceOrderId: serviceOrderId,
            branchId: branchId,
            serviceOrderNote: serviceOrderNote,
            vaultDate: vaultDate,
            routeId: routeId,
            status: status,
            serviceOrderUserNotes: serviceOrderUserNotes
        }).then(function (res) {
            return res.data;
        });
    };

    var updateServiceOrderStatus = function updateServiceOrderStatus(routeId, status, encounterId, userId, notes, branchId, serviceOrderId, branchVaultDate) {
        return $http.post(_app2.default.api + '/service-order/update-status', {
            routeId: routeId,
            status: status,
            encounterId: encounterId,
            userId: userId,
            notes: notes,
            branchId: branchId,
            serviceOrderId: serviceOrderId,
            branchVaultDate: branchVaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var branchActiveRouteAndServiceUser = function branchActiveRouteAndServiceUser(branchId, vaultDate, timezone) {
        return $http.post(_app2.default.api + '/service-order/branch-active-route-service-user', {
            branchId: branchId,
            vaultDate: vaultDate,
            timezone: timezone
        }).then(function (res) {
            return res.data;
        });
    };

    var getRouteStatus = function getRouteStatus(routeId, vaultDate) {
        return $http.post(_app2.default.api + '/service-order/get-route-status', {
            routeId: routeId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var serviceOrderDetails = function serviceOrderDetails(userId, routeId, branchId, vaultDate) {
        return $http.post(_app2.default.api + '/service-order/service-order-details', {
            userId: userId,
            routeId: routeId,
            branchId: branchId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var assignToRouteOrUser = function assignToRouteOrUser(serviceOrderId, encounterId, userId, routeId, notes, branchId, vaultDate, serviceTicketUserId) {
        return $http.post(_app2.default.api + '/service-order/assign-to-route-or-user', {
            serviceOrderId: serviceOrderId,
            encounterId: encounterId,
            userId: userId,
            routeId: routeId,
            notes: notes,
            branchId: branchId,
            vaultDate: vaultDate,
            serviceTicketUserId: serviceTicketUserId
        }).then(function (res) {
            return res.data;
        });
    };

    var getUserBranchList = function getUserBranchList(userId) {
        return $http.get(_app2.default.api + '/service-order/get-user-branch-list', {
            params: {
                userId: userId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var undoServiceOrder = function undoServiceOrder(status, encounterId, serviceOrderId, branchId, routeId) {
        return $http.post(_app2.default.api + '/service-order/undo-service-order', {
            status: status,
            encounterId: encounterId,
            serviceOrderId: serviceOrderId,
            branchId: branchId,
            routeId: routeId
        }).then(function (res) {
            return res.data;
        });
    };

    var getServiceOrderActionCodes = function getServiceOrderActionCodes(encounterId) {
        return $http.get(_app2.default.api + '/service-order/get-service-order-action-codes', {
            params: {
                encounterId: encounterId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var markServiceOrderCompleted = function markServiceOrderCompleted(actionCodes, branchId, routeId, serviceOrderId, encounterId, serviceOrderStatusNote, userId, completedByUserId, completedDateTime, arrivedDateTime) {
        return $http.post(_app2.default.api + '/service-order/mark-service-order-completed', {
            actionCodes: actionCodes,
            branchId: branchId,
            routeId: routeId,
            serviceOrderId: serviceOrderId,
            encounterId: encounterId,
            // serviceOrderNote,
            serviceOrderStatusNote: serviceOrderStatusNote,
            userId: userId,
            completedByUserId: completedByUserId,
            completedDateTime: completedDateTime,
            arrivedDateTime: arrivedDateTime
        }).then(function (res) {
            return res.data;
        });
    };

    var getServiceUser = function getServiceUser(branchId) {
        return $http.get(_app2.default.api + '/service-order/get-service-user', {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getCompletedServiceTickets = function getCompletedServiceTickets(locationId, limit, offset, startDate, endDate, timezone, customerId, bucketName, sortASC, sortColumn) {
        return $http.get(_app2.default.api + '/service-order/get-completed-service-tickets', {
            params: {
                locationId: locationId,
                limit: limit,
                offset: offset,
                startDate: startDate,
                endDate: endDate,
                timezone: timezone,
                customerId: customerId,
                bucketName: bucketName,
                sortASC: sortASC,
                sortColumn: sortColumn
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getExternalProcessorCode = function getExternalProcessorCode(branchId) {
        return $http.get(_app2.default.api + '/service-order/get-external-processor-code', {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var transferUnassignedToExternal = function transferUnassignedToExternal(encounterId, externalProcessorCode, branchId, userId) {
        return $http.post(_app2.default.api + '/service-order/transfer-unassigned-to-external', {
            encounterId: encounterId,
            externalProcessorCode: externalProcessorCode,
            branchId: branchId,
            userId: userId
        }).then(function (res) {
            return res.data;
        });
    };

    var updateExternalServiceOrderStatus = function updateExternalServiceOrderStatus(status, encounterId, notes, branchId, serviceOrderId, externalProcessorId) {
        return $http.post(_app2.default.api + '/service-order/update-external-service-order-status', {
            status: status,
            encounterId: encounterId,
            notes: notes,
            branchId: branchId,
            serviceOrderId: serviceOrderId,
            externalProcessorId: externalProcessorId
        }).then(function (res) {
            return res.data;
        });
    };

    var markExternalServiceOrderCompleted = function markExternalServiceOrderCompleted(actionCodes, branchId, routeId, serviceOrderId, encounterId, serviceOrderStatusNote, completedByUserId, completedDateTime, externalProcessorId) {
        return $http.post(_app2.default.api + '/service-order/mark-complete-external-service-tickets', {
            actionCodes: actionCodes,
            branchId: branchId,
            routeId: routeId,
            serviceOrderId: serviceOrderId,
            encounterId: encounterId,
            serviceOrderStatusNote: serviceOrderStatusNote,
            completedByUserId: completedByUserId,
            completedDateTime: completedDateTime,
            externalProcessorId: externalProcessorId
        }).then(function (res) {
            return res.data;
        });
    };

    var validateServiceOrderAssign = function validateServiceOrderAssign(serviceOrderId) {
        return $http.get(_app2.default.api + '/service-order/validate-service-order-assign', {
            params: { serviceOrderId: serviceOrderId }
        }).then(function (res) {
            return res.data;
        });
    };

    var resendExternalServiceTickets = function resendExternalServiceTickets(externalProcessorId, serviceOrderId, userId, branchId) {
        return $http.post(_app2.default.api + '/service-order/resend-external-service-tickets', {
            externalProcessorId: externalProcessorId, serviceOrderId: serviceOrderId, userId: userId, branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var getServiceTicketReport = function getServiceTicketReport(startDate, endDate, branchId, searchText, locationId, userId, actionCodeId, limit, offset) {
        return $http.get(_app2.default.api + '/service-order/get-service-ticket-report', {
            params: {
                startDate: startDate, endDate: endDate, branchId: branchId, searchText: searchText, locationId: locationId, userId: userId, actionCodeId: actionCodeId, limit: limit, offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var printServiceTicketReport = function printServiceTicketReport(startDate, endDate, branchId, searchText, locationId, userId, actionCodeId) {
        return $http.get(_app2.default.api + '/service-order/print-service-ticket-report', {
            params: {
                startDate: startDate, endDate: endDate, branchId: branchId, searchText: searchText, locationId: locationId, userId: userId, actionCodeId: actionCodeId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportServiceTicketReport = function exportServiceTicketReport(startDate, endDate, branchId, searchText, locationId, userId, actionCodeId) {
        return $http.post(_app2.default.api + '/service-order/export-service-ticket-report', {
            startDate: startDate, endDate: endDate, branchId: branchId, searchText: searchText, locationId: locationId, userId: userId, actionCodeId: actionCodeId
        }).then(function (res) {
            return res.data;
        });
    };

    var getLastArrivalTime = function getLastArrivalTime(serviceOrderId) {
        return $http.get(_app2.default.api + '/service-order/get-last-arrival-time', {
            params: { serviceOrderId: serviceOrderId }
        }).then(function (res) {
            return res.data;
        });
    };

    var resendServiceTicketAssignment = function resendServiceTicketAssignment(encounterId, vaultDate, serviceTicketUserId) {
        return $http.post(_app2.default.api + '/service-order/resend-service-ticket-assignment', { encounterId: encounterId, vaultDate: vaultDate, serviceTicketUserId: serviceTicketUserId }).then(function (res) {
            return res.data;
        });
    };

    var getServiceOrderImages = function getServiceOrderImages(serviceOrderId) {
        return $http.post(_app2.default.api + '/service-order/get-service-order-images', { serviceOrderId: serviceOrderId }).then(function (res) {
            return res.data;
        });
    };

    var updateServiceOrderStatusHistory = function updateServiceOrderStatusHistory(id, timestamp, notes, serviceOrderId, isExternal, status, timezone, branchId) {
        return $http.post(_app2.default.api + '/service-order/update-status-history', {
            id: id, timestamp: timestamp, notes: notes, serviceOrderId: serviceOrderId, isExternal: isExternal, status: status, timezone: timezone, branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var updateServiceHistory = function updateServiceHistory(history, timezone, branchId) {
        return $http.post(_app2.default.api + '/service-order/update-history', {
            history: history, timezone: timezone, branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var runAutoAssignNow = function runAutoAssignNow() {
        return $http.post(_app2.default.api + '/service-order/run-auto-assign-now', {}).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        getServiceOrder: getServiceOrder,
        serviceOrderHistory: serviceOrderHistory,
        updateServiceOrderNote: updateServiceOrderNote,
        updateServiceOrderNoteList: updateServiceOrderNoteList,
        updateServiceOrderStatus: updateServiceOrderStatus,
        updateServiceOrderStatusHistory: updateServiceOrderStatusHistory,
        updateServiceHistory: updateServiceHistory,
        branchActiveRouteAndServiceUser: branchActiveRouteAndServiceUser,
        getRouteStatus: getRouteStatus,
        serviceOrderDetails: serviceOrderDetails,
        assignToRouteOrUser: assignToRouteOrUser,
        getUserBranchList: getUserBranchList,
        undoServiceOrder: undoServiceOrder,
        getServiceOrderActionCodes: getServiceOrderActionCodes,
        markServiceOrderCompleted: markServiceOrderCompleted,
        getServiceUser: getServiceUser,
        getCompletedServiceTickets: getCompletedServiceTickets,
        getExternalProcessorCode: getExternalProcessorCode,
        transferUnassignedToExternal: transferUnassignedToExternal,
        updateExternalServiceOrderStatus: updateExternalServiceOrderStatus,
        markExternalServiceOrderCompleted: markExternalServiceOrderCompleted,
        validateServiceOrderAssign: validateServiceOrderAssign,
        resendExternalServiceTickets: resendExternalServiceTickets,
        getServiceTicketReport: getServiceTicketReport,
        printServiceTicketReport: printServiceTicketReport,
        exportServiceTicketReport: exportServiceTicketReport,
        getLastArrivalTime: getLastArrivalTime,
        resendServiceTicketAssignment: resendServiceTicketAssignment,
        getServiceOrderImages: getServiceOrderImages,
        runAutoAssignNow: runAutoAssignNow
    };
};

ServiceOrderService.$inject = ['$http', '$q'];

exports.default = ServiceOrderService;

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceTicketPartsService = function ServiceTicketPartsService($http) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + "/service-ticket-parts", {
            params: { search: search, offset: offset, limit: limit }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data, branchId) {
        return $http.post(_app2.default.api + "/service-ticket-parts/create", { data: data, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ("/service-ticket-parts/" + id + "/update"), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ("/service-ticket-parts/" + id + "/details")).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, label, serialNumber, branchId) {
        return $http.delete(_app2.default.api + ("/service-ticket-parts/" + id + "/delete"), {
            params: {
                id: id, label: label, serialNumber: serialNumber, branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        update: update,
        get: get,
        remove: remove
    };
};

ServiceTicketPartsService.$inject = ['$http'];

exports.default = ServiceTicketPartsService;

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SetupService = function SetupService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/setup', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/setup/create', data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + ('/setup/' + id), {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/setup/' + id), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/setup/' + id)).then(function (res) {
            return res.data;
        });
    };

    var supervisorList = function supervisorList(branchId) {
        return $http.get(_app2.default.api + '/setup/supervisor-list', {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getAutoGeneratedTrackingId = function getAutoGeneratedTrackingId(branchId, cursor) {
        return $http.get(_app2.default.api + '/setup/get-auto-generated-tracking-id', {
            params: {
                branchId: branchId, cursor: cursor
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get,
        supervisorList: supervisorList,
        getAutoGeneratedTrackingId: getAutoGeneratedTrackingId
    };
};

SetupService.$inject = ['$http', '$q'];

exports.default = SetupService;

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShipmentService = function ShipmentService($http, $q, $translate) {
    var get = function get(id) {
        return $http.get(_app2.default.api + ('/shipment/' + id)).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/shipment/create', data).then(function (res) {
            return res.data;
        });
    };
    var createHold = function createHold(data) {
        return $http.post(_app2.default.api + '/shipment/create-hold', data).then(function (res) {
            return res.data;
        });
    };

    var verifyShipment = function verifyShipment(branchId, trackingId, routeId, date, windowId, fromTankerId, toTankerId) {
        return $http.post(_app2.default.api + '/shipment/verify', {
            branchId: branchId,
            trackingId: trackingId,
            routeId: routeId,
            date: date,
            windowId: windowId,
            fromTankerId: fromTankerId,
            toTankerId: toTankerId
        }).then(function (res) {
            return res.data;
        });
    };

    var verifyCheckoutShipment = function verifyCheckoutShipment(branchId, trackingId, routeId, date, windowId, fromTankerId, toTankerId) {
        return $http.post(_app2.default.api + '/shipment/checkout-verify', {
            branchId: branchId,
            trackingId: trackingId,
            routeId: routeId,
            date: date,
            windowId: windowId,
            fromTankerId: fromTankerId,
            toTankerId: toTankerId
        }).then(function (res) {
            return res.data;
        });
    };

    var checkinShipment = function checkinShipment(branchId, trackingId, routeId, date, windowId, fromTankerId, toTankerId, fromLocationId, isManuallyAddedShipment) {
        return $http.post(_app2.default.api + '/shipment/checkin', {
            branchId: branchId,
            trackingId: trackingId,
            routeId: routeId,
            date: date,
            windowId: windowId,
            fromTankerId: fromTankerId,
            toTankerId: toTankerId,
            fromLocationId: fromLocationId,
            isManuallyAddedShipment: isManuallyAddedShipment
        }).then(function (res) {
            return res.data;
        });
    };

    var adhocCheckIn = function adhocCheckIn(data) {
        return $http.post(_app2.default.api + '/shipment/adhoc-checkin', data).then(function (res) {
            return res.data;
        });
    };

    var checkoutShipment = function checkoutShipment(branchId, trackingId, routeId, date, windowId, fromTankerId, toTankerId) {
        return $http.post(_app2.default.api + '/shipment/checkout', {
            branchId: branchId,
            trackingId: trackingId,
            routeId: routeId,
            date: date,
            windowId: windowId,
            fromTankerId: fromTankerId,
            toTankerId: toTankerId
        }).then(function (res) {
            return res.data;
        });
    };

    var addToBag = function addToBag(trackingId, deliveryLocationId, bagSealId, branchId) {
        return $http.post(_app2.default.api + '/shipment/add-to-bag', {
            trackingId: trackingId,
            deliveryLocationId: deliveryLocationId,
            bagSealId: bagSealId,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var holdShipment = function holdShipment(branchId, trackingId, routeId, date, supervisorId, reason, comments) {
        return $http.post(_app2.default.api + '/shipment/hold', {
            branchId: branchId,
            trackingId: trackingId,
            routeId: routeId,
            date: date,
            supervisorId: supervisorId,
            reason: reason,
            comments: comments
        }).then(function (res) {
            return res.data;
        });
    };

    var holdMultipleShipments = function holdMultipleShipments(branchId, shipments, routeId, date, supervisorId, reason, comments) {
        return $http.post(_app2.default.api + '/shipment/hold-multiple', {
            branchId: branchId,
            shipments: shipments,
            routeId: routeId,
            date: date,
            supervisorId: supervisorId,
            reason: reason,
            comments: comments
        }).then(function (res) {
            return res.data;
        });
    };

    var changeShipmentDestination = function changeShipmentDestination(trackingId, routeId, date, destinationId) {
        return $http.post(_app2.default.api + '/shipment/change-destination', {
            trackingId: trackingId,
            routeId: routeId,
            date: date,
            destinationId: destinationId
        }).then(function (res) {
            return res.data;
        });
    };

    var changeShipmentAmount = function changeShipmentAmount(id, trackingId, routeId, date, shiptypeId, quantity, amount, branchId, oldAmount, supervisorId) {
        return $http.post(_app2.default.api + '/shipment/change-amount', {
            id: id, trackingId: trackingId, routeId: routeId, date: date, shiptypeId: shiptypeId, quantity: quantity, amount: amount,
            branchId: branchId, oldAmount: oldAmount, supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    var getShipmentRoutes = function getShipmentRoutes(refId, date) {
        return $http.get(_app2.default.api + ('/shipment/shipment-routes?date=' + date + '&') + (refId ? 'refId=' + refId : '')).then(function (res) {
            return res.data;
        });
    };

    var throwTanker = function throwTanker(branchId, trackingId, tankerId, deliveryDate, performedByUserId) {
        return $http.post(_app2.default.api + '/shipment/throw-tanker', {
            branchId: branchId,
            trackingId: trackingId,
            tankerId: tankerId,
            deliveryDate: deliveryDate,
            performedByUserId: performedByUserId
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentReturn = function shipmentReturn(fromTankerId, trackingId, origRouteId, destRouteId, destRouteDate, supervisorId, comments, branchId) {
        return $http.post(_app2.default.api + '/shipment/shipment-return', {
            fromTankerId: fromTankerId,
            trackingId: trackingId,
            origRouteId: origRouteId,
            destRouteId: destRouteId,
            destRouteDate: destRouteDate,
            supervisorId: supervisorId,
            comments: comments,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var holdRelease = function holdRelease(trackingId, origRouteId, destRouteId, destRouteDate, supervisorId, comments, branchId) {
        return $http.post(_app2.default.api + '/shipment/release-item', {
            trackingId: trackingId,
            origRouteId: origRouteId,
            destRouteId: destRouteId,
            destRouteDate: destRouteDate,
            supervisorId: supervisorId,
            comments: comments,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var locationNextRoute = function locationNextRoute(branchId, locationId, afterDate, maxResults) {
        return $http.post(_app2.default.api + '/shipment/location-next-routes', {
            branchId: branchId,
            locationId: locationId,
            afterDate: afterDate,
            maxResults: maxResults
        }).then(function (res) {
            return res.data;
        });
    };

    var ServiceItemHistory = function ServiceItemHistory(fromLocationId, startDate, endDate, offset, limit, sortColumn, sortASC) {
        return $http.post(_app2.default.api + '/shipment/get-serviceitem-history', {
            fromLocationId: fromLocationId,
            startDate: startDate,
            endDate: endDate,
            offset: offset,
            limit: limit,
            sortColumn: sortColumn,
            sortASC: sortASC
        }).then(function (res) {
            return res.data;
        });
    };

    var LocationsItemHistory = function LocationsItemHistory(toLocationId, startDate, endDate, offset, limit) {
        return $http.post(_app2.default.api + '/shipment/get-locationitem-history', {
            toLocationId: toLocationId,
            startDate: startDate,
            endDate: endDate,
            offset: offset,
            limit: limit
        }).then(function (res) {
            return res.data;
        });
    };

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/shipment', {
            params: {
                "search": search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getShipmentTrakingDetail = function getShipmentTrakingDetail(trackingId) {
        return $http.get(_app2.default.api + ('/shipment/get-shipment-tracking-detail/' + trackingId)).then(function (res) {
            return res.data;
        });
    };

    var updateShipmentTankerId = function updateShipmentTankerId(trackingId, tanker, branchId) {
        return $http.post(_app2.default.api + '/shipment/update-shipment-tankerid', {
            trackingId: trackingId,
            tanker: tanker,
            branchId: branchId
        }).then(function (_ref) {
            var data = _ref.data;
            return data;
        });
    };

    var updateDeliveredShipment = function updateDeliveredShipment(trackingId) {
        return $http.post(_app2.default.api + ('/shipment/update-delivered-shipment/' + trackingId)).then(function (res) {
            return res.data;
        });
    };

    var getDestinationLocations = function getDestinationLocations(locationId, shiptypeId, inclOrigin) {
        return $http.post(_app2.default.api + '/shipment/get-destination-locations', {
            locationId: locationId,
            shiptypeId: shiptypeId,
            inclOrigin: inclOrigin
        }).then(function (res) {
            return res.data;
        });
    };

    var getCheckoutManifestData = function getCheckoutManifestData(branchId, routeId, vaultDate) {
        return $http.get(_app2.default.api + '/shipment/get-checkout-manifest', {
            params: {
                branchId: branchId,
                routeId: routeId,
                vaultDate: vaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getCheckinManifestData = function getCheckinManifestData(branchId, routeId, vaultDate) {
        return $http.get(_app2.default.api + '/shipment/get-checkin-manifest', {
            params: {
                branchId: branchId,
                routeId: routeId,
                vaultDate: vaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var isValideTanker = function isValideTanker(tankerId, vaultDate) {
        return $http.get(_app2.default.api + '/shipment/get-valide-tanker', {
            params: {
                tankerId: tankerId,
                vaultDate: vaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var createShipments = function createShipments(shipments, supId, holdRoute, branchId, autoGenerateToggle, totalCursor) {
        return $http.post(_app2.default.api + '/shipment/create-shipments', {
            shipments: shipments,
            supId: supId,
            holdRoute: holdRoute,
            branchId: branchId,
            autoGenerateToggle: autoGenerateToggle,
            totalCursor: totalCursor
        }).then(function (res) {
            return res.data;
        });
    };

    var getShipmentFromLocations = function getShipmentFromLocations(search, offset, limit) {
        return $http.get(_app2.default.api + '/shipment/get-from-locations', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getShipmentToLocations = function getShipmentToLocations(search, offset, limit) {
        return $http.get(_app2.default.api + '/shipment/get-to-locations', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var bulkHoldShipment = function bulkHoldShipment(data) {
        if (!data.length) return [];
        return $http.post(_app2.default.api + '/shipment/bulk-shipment-hold', { data: data }).then(function (res) {
            return res.data;
        });
    };

    var bulkUpdateDeliveredShipment = function bulkUpdateDeliveredShipment(data, branchId) {
        if (!data.length) return [];
        return $http.post(_app2.default.api + '/shipment/bulk-update-delivered-shipment', { data: data, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var chechTrackingIds = function chechTrackingIds(ids, shipmentId) {
        return $http.get(_app2.default.api + '/shipment/check-shipments', {
            params: {
                trackingId: ids,
                shipmentId: shipmentId
            }
        }).then(function (res) {
            return res.data;
        });
    };
    var getCoinShiptypes = function getCoinShiptypes(route, date) {
        return $http.get(_app2.default.api + '/shipment/get-coin-shiptypes', {
            params: {
                route: route,
                date: date
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getItemStatus = function getItemStatus(trackingId) {
        return $http.post(_app2.default.api + '/shipment/get-item-status', {
            trackingId: trackingId
            // branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var remainingToThrowShipments = function remainingToThrowShipments(routeId, vaultDate, branchId, isCoinCheckOut) {
        return $http.post(_app2.default.api + '/shipment/remaining-to-throw', {
            routeId: routeId,
            vaultDate: vaultDate,
            branchId: branchId,
            isCoinCheckOut: isCoinCheckOut
        }).then(function (res) {
            return res.data;
        });
    };

    var remainingToPackShipments = function remainingToPackShipments(routeId, vaultDate, branchId, isCoinCheckOut) {
        return $http.post(_app2.default.api + '/shipment/remaining-to-pack', {
            routeId: routeId,
            vaultDate: vaultDate,
            branchId: branchId,
            isCoinCheckOut: isCoinCheckOut
        }).then(function (res) {
            return res.data;
        });
    };

    var branchTransfer = function branchTransfer(branchId, trackingId, routeId, vaultDate, userId, comments, newRouteId, newVaultDate, fromBranchId) {
        return $http.post(_app2.default.api + '/shipment/branch-transfer', {
            branchId: branchId,
            trackingId: trackingId,
            routeId: routeId,
            vaultDate: vaultDate,
            userId: userId,
            comments: comments,
            newRouteId: newRouteId,
            newVaultDate: newVaultDate,
            fromBranchId: fromBranchId
        }).then(function (res) {
            return res.data;
        });
    };

    var internalDelivery = function internalDelivery(branchId, trackingId, routeId, locationId, vaultDate, userId, comments) {
        return $http.post(_app2.default.api + '/shipment/internal-delivery', {
            branchId: branchId,
            trackingId: trackingId,
            routeId: routeId,
            locationId: locationId,
            vaultDate: vaultDate,
            userId: userId,
            comments: comments
        }).then(function (res) {
            return res.data;
        });
    };
    var updateFromLocation = function updateFromLocation(branchId, trackingId, locationId, userId, comments) {
        return $http.post(_app2.default.api + '/shipment/update-from-location', {
            branchId: branchId,
            trackingId: trackingId,
            locationId: locationId,
            userId: userId,
            comments: comments
        }).then(function (res) {
            return res.data;
        });
    };

    var getOrderType = function getOrderType(type) {
        switch (type) {
            case type:
                return $translate.instant('shipment.order_type_' + type);
            default:
                return '';
        }
    };

    var convertTime = function convertTime(microSeconds) {
        var ms = microSeconds / 1000; // convert microSeconds in miliseconds
        // 1- Convert to seconds:
        var seconds = ms / 1000;
        // 2- Extract hours:
        var hours = parseInt(seconds / 3600); // 3,600 seconds in 1 hour
        seconds = seconds % 3600; // seconds remaining after extracting hours
        // 3- Extract minutes:
        var minutes = parseInt(seconds / 60); // 60 seconds in 1 minute
        // 4- Keep only seconds not extracted to minutes:
        seconds = seconds % 60;
        // if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        return minutes + ':' + seconds;
    };

    var updateShipmentTrackingId = function updateShipmentTrackingId(shipmentId, oldTrackingId, newTrackingId, branchId, comment) {
        return $http.post(_app2.default.api + '/shipment/update-shipment-trackingId', {
            shipmentId: shipmentId,
            oldTrackingId: oldTrackingId,
            newTrackingId: newTrackingId,
            branchId: branchId,
            comment: comment
        }).then(function (res) {
            return res.data;
        });
    };

    var batchRecords = function batchRecords(trackingIds) {
        return $http.post(_app2.default.api + '/shipment/batch-records', {
            trackingIds: trackingIds
        }).then(function (res) {
            return res.data;
        });
    };

    var deliveryManifestAll = function deliveryManifestAll(routeId, vaultDate) {
        return $http.get(_app2.default.api + '/shipment/delivery-manifest-all', {
            params: {
                routeId: routeId,
                vaultDate: vaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportServiceHistoryData = function exportServiceHistoryData(fromLocationId, startDate, endDate, offset, limit) {
        return $http.post(_app2.default.api + '/shipment/export-service-history', {
            fromLocationId: fromLocationId,
            startDate: startDate,
            endDate: endDate,
            offset: offset,
            limit: limit
        }).then(function (res) {
            return res.data;
        });
    };

    var getUniqueRecords = function getUniqueRecords(branch) {
        return $http.post(_app2.default.api + '/shipment/unique-records', {
            branch: branch
        }).then(function (res) {
            return res.data;
        });
    };

    var orderPackingUndo = function orderPackingUndo(branchId, shipmentId, supervisorId, reason, deleteShipment) {
        return $http.post(_app2.default.api + '/shipment/undo-packed-order', {
            branchId: branchId,
            shipmentId: shipmentId,
            supervisorId: supervisorId,
            reason: reason,
            deleteShipment: deleteShipment
        }).then(function (res) {
            return res.data;
        });
    };

    var softDeleteShipment = function softDeleteShipment(shipmentId, branchId, reason, supervisorId) {
        return $http.post(_app2.default.api + '/shipment/soft-delete-shipment', {
            shipmentId: shipmentId,
            branchId: branchId,
            reason: reason,
            supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    var softDeleteWholeShipment = function softDeleteWholeShipment(orderNo, branchId, supervisorId) {
        return $http.post(_app2.default.api + '/shipment/soft-delete-whole-shipment', {
            orderNo: orderNo,
            branchId: branchId,
            supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    var deleteOrderDenom = function deleteOrderDenom(orderNo, fundingSourceId, denominationId, reason, supervisorId) {
        return $http.post(_app2.default.api + '/shipment/delete-order-denom', {
            orderNo: orderNo,
            fundingSourceId: fundingSourceId,
            denominationId: denominationId,
            reason: reason,
            supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    var undoSoftDeleteShipment = function undoSoftDeleteShipment(shipmentId, branchId, trackingId) {
        return $http.post(_app2.default.api + '/shipment/undo-soft-delete-shipment', {
            shipmentId: shipmentId,
            branchId: branchId,
            trackingId: trackingId
        }).then(function (res) {
            return res.data;
        });
    };

    var getShipmentsOnRoute = function getShipmentsOnRoute(routeId, vaultDate, coinCheckOut) {
        return $http.post(_app2.default.api + '/shipment/get-shipments-on-route', {
            routeId: routeId,
            vaultDate: vaultDate,
            coinCheckOut: coinCheckOut
        }).then(function (res) {
            return res.data;
        });
    };

    var changeDestination = function changeDestination(trackingId, branchId, routeId, destinationId, comment) {
        return $http.post(_app2.default.api + '/shipment/change-shipment-destination', {
            trackingId: trackingId,
            branchId: branchId,
            routeId: routeId,
            destinationId: destinationId,
            comment: comment
        }).then(function (res) {
            return res.data;
        });
    };

    var getPendingCancelShipments = function getPendingCancelShipments(branchId, offset, limit, routeId, vaultDate) {
        return $http.get(_app2.default.api + '/shipment/get-pending-cancel-shipments', {
            params: {
                branchId: branchId,
                offset: offset,
                limit: limit,
                routeId: routeId,
                vaultDate: vaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getCancelledShipments = function getCancelledShipments(branchId, offset, limit) {
        return $http.get(_app2.default.api + '/shipment/get-cancelled-shipments', {
            params: {
                branchId: branchId,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getDeliveryServiceHistory = function getDeliveryServiceHistory(locationId, branchId, startDate, endDate, offset, limit, searchText, sortColumn, sortASC) {
        return $http.get(_app2.default.api + '/shipment/get-delivery-service-history', {
            params: {
                locationId: locationId,
                branchId: branchId,
                startDate: startDate,
                endDate: endDate,
                offset: offset,
                limit: limit,
                searchText: searchText,
                sortColumn: sortColumn,
                sortASC: sortASC
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getPickupServiceHistory = function getPickupServiceHistory(locationId, branchId, startDate, endDate, offset, limit, searchText, sortColumn, sortASC, timezone) {
        return $http.get(_app2.default.api + '/shipment/get-pickup-service-history', {
            params: {
                locationId: locationId,
                branchId: branchId,
                startDate: startDate,
                endDate: endDate,
                offset: offset,
                limit: limit,
                searchText: searchText,
                sortColumn: sortColumn,
                sortASC: sortASC,
                timezone: timezone
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var printPickupServiceHistory = function printPickupServiceHistory(locationId, startDate, endDate, timezone, searchText, sortColumn, sortASC) {
        return $http.get(_app2.default.api + '/shipment/print-pickup-service-history', {
            params: {
                locationId: locationId,
                startDate: startDate,
                endDate: endDate,
                timezone: timezone,
                searchText: searchText,
                sortColumn: sortColumn,
                sortASC: sortASC

            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportPickupServiceHistory = function exportPickupServiceHistory(locationId, startDate, endDate, timezone, searchText, selectedDepositAmountValue, sortColumn, sortASC) {
        return $http.post(_app2.default.api + '/shipment/export-pickup-service-history', {
            locationId: locationId,
            startDate: startDate,
            endDate: endDate,
            timezone: timezone,
            searchText: searchText,
            selectedDepositAmountValue: selectedDepositAmountValue,
            sortColumn: sortColumn,
            sortASC: sortASC
        }).then(function (res) {
            return res.data;
        });
    };

    var printDeliveryServiceHistory = function printDeliveryServiceHistory(locationId, startDate, endDate, timezone, searchText, sortColumn, sortASC) {
        return $http.get(_app2.default.api + '/shipment/print-delivery-service-history', {
            params: {
                locationId: locationId,
                startDate: startDate,
                endDate: endDate,
                timezone: timezone,
                searchText: searchText,
                sortColumn: sortColumn,
                sortASC: sortASC
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportDeliveryServiceHistory = function exportDeliveryServiceHistory(locationId, startDate, endDate, timezone, searchText, sortColumn, sortASC) {
        return $http.post(_app2.default.api + '/shipment/export-delivery-service-history', {
            locationId: locationId,
            startDate: startDate,
            endDate: endDate,
            timezone: timezone,
            searchText: searchText,
            sortColumn: sortColumn,
            sortASC: sortASC
        }).then(function (res) {
            return res.data;
        });
    };

    var holdShipmentNotDelivered = function holdShipmentNotDelivered(branchId, trackingId, routeId, date, supervisorId, reason, deliveryResolution, note, notDeliveredResolution, holdType, updatedTrackingId, originalTrackingId, amount, qty, destinationId, fromLocationId, shiptypeId) {
        return $http.post(_app2.default.api + '/shipment/hold-not-delivered', {
            branchId: branchId,
            trackingId: trackingId,
            routeId: routeId,
            date: date,
            supervisorId: supervisorId,
            reason: reason,
            deliveryResolution: deliveryResolution,
            note: note,
            notDeliveredResolution: notDeliveredResolution,
            holdType: holdType,
            updatedTrackingId: updatedTrackingId,
            originalTrackingId: originalTrackingId,
            amount: amount,
            qty: qty,
            destinationId: destinationId,
            fromLocationId: fromLocationId,
            shiptypeId: shiptypeId
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentReRoute = function shipmentReRoute(branchId, trackingId, routeId, destRouteId, destRouteDate, supervisorId, reason, deliveryResolution, note, updatedTrackingId, originalTrackingId, amount, qty, destinationId, fromLocationId, shiptypeId) {
        return $http.post(_app2.default.api + '/shipment/shipment-re-route', {
            branchId: branchId, trackingId: trackingId, routeId: routeId, destRouteId: destRouteId, destRouteDate: destRouteDate, supervisorId: supervisorId, reason: reason, deliveryResolution: deliveryResolution, note: note, updatedTrackingId: updatedTrackingId, originalTrackingId: originalTrackingId, amount: amount, qty: qty, destinationId: destinationId, fromLocationId: fromLocationId, shiptypeId: shiptypeId
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentPickupsReRoute = function shipmentPickupsReRoute(branchId, trackingId, routeId, destRouteId, destRouteDate, supervisorId, note) {
        return $http.post(_app2.default.api + '/shipment/pickups-re-route', {
            branchId: branchId, trackingId: trackingId, routeId: routeId, destRouteId: destRouteId, destRouteDate: destRouteDate, supervisorId: supervisorId, note: note
        }).then(function (res) {
            return res.data;
        });
    };

    var hasCustomerShipment = function hasCustomerShipment(trackingId, customerId, branchId) {
        return $http.get(_app2.default.api + '/shipment/is-customer-shipment', {
            params: {
                trackingId: trackingId, customerId: customerId, branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var uploadBatchFiles = function uploadBatchFiles(files) {
        return $http.post(_app2.default.api + '/shipment/upload-batch-files', { files: files }).then(function (res) {
            return res.data;
        });
    };

    var getBatchTemplateFile = function getBatchTemplateFile() {
        return $http.get(_app2.default.api + '/shipment/get-batch-template-file').then(function (res) {
            return res.data;
        });
    };

    var makeDeliverable = function makeDeliverable(trackingId, routeId, vaultDate, userId, branchId) {
        return $http.post(_app2.default.api + '/shipment/make-deliverable', { trackingId: trackingId, routeId: routeId, vaultDate: vaultDate, userId: userId, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var printStopReceipt = function printStopReceipt(trackingId, selectedDepositAmountValue) {
        return $http.post(_app2.default.api + '/shipment/print-stop-receipt', { trackingId: trackingId, selectedDepositAmountValue: selectedDepositAmountValue }).then(function (res) {
            return res.data;
        });
    };

    var changeShiptype = function changeShiptype(trackingId, branchId, shiptype) {
        return $http.post(_app2.default.api + '/shipment/change-shiptype', {
            trackingId: trackingId,
            branchId: branchId,
            shiptype: shiptype
        }).then(function (res) {
            return res.data;
        });
    };

    var verifyTruckLiability = function verifyTruckLiability(routeId, vaultDate, truckLiability) {
        var shipmentAmount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        return $http.post(_app2.default.api + '/shipment/verify-truck-liability', {
            routeId: routeId, vaultDate: vaultDate, truckLiability: truckLiability
        }).then(function (res) {
            var isWithinLiability = res.data.totalAmount + shipmentAmount < truckLiability;
            return { isWithinLiability: isWithinLiability };
        });
    };

    var deliveryManifestCombined = function deliveryManifestCombined(routeId, vaultDate) {
        return $http.get(_app2.default.api + '/shipment/delivery-manifest-combined', {
            params: {
                routeId: routeId,
                vaultDate: vaultDate
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var bulkUpdateNoPickupStop = function bulkUpdateNoPickupStop(data, branchId) {
        return $http.post(_app2.default.api + '/shipment/bulk-update-no-pickup-stop', { data: data, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var completedShipments = function completedShipments(branchId, vaultDate, offset, limit, searchText, sortASC, sortColumn) {
        return $http.get(_app2.default.api + '/shipment/completed-shipments', {
            params: { branchId: branchId, vaultDate: vaultDate, offset: offset, limit: limit, searchText: searchText, sortASC: sortASC, sortColumn: sortColumn }
        }).then(function (res) {
            return res.data;
        });
    };

    var printCompletedShipments = function printCompletedShipments(batchId, locationId) {
        return $http.get(_app2.default.api + '/shipment/print-completed-shipments', {
            params: { batchId: batchId, locationId: locationId }
        }).then(function (res) {
            return res.data;
        });
    };

    var createCheckinManifest = function createCheckinManifest(fromLocationId, vaultDate, routeId, totalBagCount, manifestID, userIdCompleted) {
        return $http.post(_app2.default.api + '/shipment/checkin-manifests', {
            fromLocationId: fromLocationId, vaultDate: vaultDate, routeId: routeId, totalBagCount: totalBagCount, manifestID: manifestID, userIdCompleted: userIdCompleted
        }).then(function (res) {
            return res.data;
        });
    };

    var updateShipmentCountStatus = function updateShipmentCountStatus(trackingId, toLocationId, fundingSourceId) {
        return $http.post(_app2.default.api + '/shipment/update-count-status', {
            trackingId: trackingId,
            toLocationId: toLocationId,
            fundingSourceId: fundingSourceId
        }).then(function (res) {
            return res.data;
        });
    };

    var getShipmentLocationDetails = function getShipmentLocationDetails(locationId) {
        return $http.get(_app2.default.api + ('/shipment/get-shipment-location/' + locationId)).then(function (res) {
            return res.data;
        });
    };

    var getDeliveryServiceTransaction = function getDeliveryServiceTransaction(locationId, branchId, vaultDate, trackingId) {
        return $http.get(_app2.default.api + '/shipment/get-delivery-service-transaction', {
            params: {
                locationId: locationId,
                branchId: branchId,
                vaultDate: vaultDate,
                trackingId: trackingId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var putShipmentOnHold = function putShipmentOnHold(branchId, trackingId, routeId, date, supervisorId, reason, comments, updatedTrackingId, originalTrackingId, amount, qty, destinationId, fromLocationId, shiptypeId) {
        return $http.post(_app2.default.api + '/shipment/put-shipment-on-hold', {
            branchId: branchId, trackingId: trackingId, routeId: routeId, date: date, supervisorId: supervisorId, reason: reason, comments: comments, updatedTrackingId: updatedTrackingId, originalTrackingId: originalTrackingId, amount: amount, qty: qty, destinationId: destinationId, fromLocationId: fromLocationId, shiptypeId: shiptypeId
        }).then(function (res) {
            return res.data;
        });
    };

    var getChangeDestinationLocations = function getChangeDestinationLocations(trackingId, branchId, searchKey, offset, limit) {
        return $http.get(_app2.default.api + '/shipment/get-change-destination-locations', {
            params: {
                trackingId: trackingId,
                branchId: branchId,
                searchKey: searchKey,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var pendingShipmentTransferDetails = function pendingShipmentTransferDetails(routeId, routeDate, branchId) {
        return $http.get(_app2.default.api + '/shipment/pending-shipment-transfer-details', {
            params: {
                routeId: routeId,
                routeDate: routeDate,
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var resendShipmentTransfer = function resendShipmentTransfer(trackingIds, transferOutUserId, transferInUserId, transferOutRouteId, transferInRouteId, transferOutBranchId, transferInBranchId, transferOutTruckId, transferInTruckId, comment, transferInVaultDate, transferOutVaultDate, shipmentTransferIds) {
        return $http.post(_app2.default.api + '/shipment/resend-shipment-transfer', {
            trackingIds: trackingIds,
            transferOutUserId: transferOutUserId,
            transferInUserId: transferInUserId,
            transferOutRouteId: transferOutRouteId,
            transferInRouteId: transferInRouteId,
            transferOutBranchId: transferOutBranchId,
            transferInBranchId: transferInBranchId,
            transferOutTruckId: transferOutTruckId,
            transferInTruckId: transferInTruckId,
            comment: comment,
            transferInVaultDate: transferInVaultDate,
            transferOutVaultDate: transferOutVaultDate,
            shipmentTransferIds: shipmentTransferIds
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        get: get,
        create: create,
        createHold: createHold,
        verifyShipment: verifyShipment,
        checkinShipment: checkinShipment,
        checkoutShipment: checkoutShipment,
        addToBag: addToBag,
        holdShipment: holdShipment,
        verifyTruckLiability: verifyTruckLiability,
        changeShipmentDestination: changeShipmentDestination,
        changeShipmentAmount: changeShipmentAmount,
        getShipmentRoutes: getShipmentRoutes,
        verifyCheckoutShipment: verifyCheckoutShipment,
        throwTanker: throwTanker,
        shipmentReturn: shipmentReturn,
        holdRelease: holdRelease,
        locationNextRoute: locationNextRoute,
        LocationsItemHistory: LocationsItemHistory,
        ServiceItemHistory: ServiceItemHistory,
        all: all,
        getShipmentTrakingDetail: getShipmentTrakingDetail,
        updateShipmentTankerId: updateShipmentTankerId,
        updateDeliveredShipment: updateDeliveredShipment,
        getDestinationLocations: getDestinationLocations,
        getCheckoutManifestData: getCheckoutManifestData,
        getCheckinManifestData: getCheckinManifestData,
        isValideTanker: isValideTanker,
        createShipments: createShipments,
        getShipmentFromLocations: getShipmentFromLocations,
        getShipmentToLocations: getShipmentToLocations,
        bulkHoldShipment: bulkHoldShipment,
        bulkUpdateDeliveredShipment: bulkUpdateDeliveredShipment,
        chechTrackingIds: chechTrackingIds,
        getCoinShiptypes: getCoinShiptypes,
        getItemStatus: getItemStatus,
        remainingToThrowShipments: remainingToThrowShipments,
        remainingToPackShipments: remainingToPackShipments,
        branchTransfer: branchTransfer,
        internalDelivery: internalDelivery,
        getOrderType: getOrderType,
        convertTime: convertTime,
        updateShipmentTrackingId: updateShipmentTrackingId,
        batchRecords: batchRecords,
        deliveryManifestAll: deliveryManifestAll,
        exportServiceHistoryData: exportServiceHistoryData,
        getUniqueRecords: getUniqueRecords,
        orderPackingUndo: orderPackingUndo,
        softDeleteShipment: softDeleteShipment,
        softDeleteWholeShipment: softDeleteWholeShipment,
        deleteOrderDenom: deleteOrderDenom,
        undoSoftDeleteShipment: undoSoftDeleteShipment,
        getShipmentsOnRoute: getShipmentsOnRoute,
        changeDestination: changeDestination,
        getPendingCancelShipments: getPendingCancelShipments,
        getCancelledShipments: getCancelledShipments,
        getDeliveryServiceHistory: getDeliveryServiceHistory,
        getPickupServiceHistory: getPickupServiceHistory,
        printPickupServiceHistory: printPickupServiceHistory,
        exportPickupServiceHistory: exportPickupServiceHistory,
        printDeliveryServiceHistory: printDeliveryServiceHistory,
        exportDeliveryServiceHistory: exportDeliveryServiceHistory,
        holdShipmentNotDelivered: holdShipmentNotDelivered,
        shipmentReRoute: shipmentReRoute,
        hasCustomerShipment: hasCustomerShipment,
        uploadBatchFiles: uploadBatchFiles,
        getBatchTemplateFile: getBatchTemplateFile,
        makeDeliverable: makeDeliverable,
        printStopReceipt: printStopReceipt,
        changeShiptype: changeShiptype,
        deliveryManifestCombined: deliveryManifestCombined,
        bulkUpdateNoPickupStop: bulkUpdateNoPickupStop,
        completedShipments: completedShipments,
        printCompletedShipments: printCompletedShipments,
        createCheckinManifest: createCheckinManifest,
        updateShipmentCountStatus: updateShipmentCountStatus,
        getShipmentLocationDetails: getShipmentLocationDetails,
        getDeliveryServiceTransaction: getDeliveryServiceTransaction,
        holdMultipleShipments: holdMultipleShipments,
        putShipmentOnHold: putShipmentOnHold,
        getChangeDestinationLocations: getChangeDestinationLocations,
        pendingShipmentTransferDetails: pendingShipmentTransferDetails,
        resendShipmentTransfer: resendShipmentTransfer,
        shipmentPickupsReRoute: shipmentPickupsReRoute,
        adhocCheckIn: adhocCheckIn,
        updateFromLocation: updateFromLocation
    };
};

ShipmentService.$inject = ['$http', '$q', '$translate'];

exports.default = ShipmentService;

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShiptypeService = function ShiptypeService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/shiptype', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data, branchId) {
        return $http.post(_app2.default.api + '/shiptype/create', { data: data, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + ('/shiptype/' + id), {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data, branchId, changedObj) {
        return $http.post(_app2.default.api + ('/shiptype/' + id), { data: data, branchId: branchId, changedObj: changedObj }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/shiptype/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get
    };
};

ShiptypeService.$inject = ['$http', '$q'];

exports.default = ShiptypeService;

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StopSchedulingService = function StopSchedulingService($http) {

    var createStopScheduling = function createStopScheduling(data) {
        return $http.post(_app2.default.api + "/stop-scheduling/create-stop-scheduling", { data: data }).then(function (res) {
            return res.data;
        });
    };

    var getPendingChanges = function getPendingChanges(startDate, endDate, branchId, searchText) {
        return $http.get(_app2.default.api + "/stop-scheduling/get-pending-changes", {
            params: { startDate: startDate, endDate: endDate, branchId: branchId, searchText: searchText }
        }).then(function (res) {
            return res.data;
        });
    };

    var cancelScheduledStops = function cancelScheduledStops(jobKey) {
        return $http.post(_app2.default.api + "/stop-scheduling/cancel-scheduled-stop", { jobKey: jobKey }).then(function (res) {
            return res.data;
        });
    };
    return {
        createStopScheduling: createStopScheduling, getPendingChanges: getPendingChanges, cancelScheduledStops: cancelScheduledStops
    };
};
StopSchedulingService.$inject = ['$http'];

exports.default = StopSchedulingService;

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransactionService = function TransactionService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/transaction', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/transaction/create', data).then(function (res) {
            return res.data;
        });
    };

    var transactionHistory = function transactionHistory(trackingId, limit, offset) {
        return $http.post(_app2.default.api + '/transaction/transaction-history', {
            trackingId: trackingId,
            limit: limit,
            offset: offset
        }).then(function (res) {
            return res.data;
        });
    };

    var currentContent = function currentContent(search, offset, limit) {
        return $http.get(_app2.default.api + '/transaction/current-content', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var exportNoPickupTransactionHistory = function exportNoPickupTransactionHistory(locationId, startDate, endDate, timezone, sortColumn, sortASC) {
        return $http.post(_app2.default.api + '/transaction/export-no-pickup-transaction-history', {
            locationId: locationId, startDate: startDate, endDate: endDate, timezone: timezone, sortColumn: sortColumn, sortASC: sortASC
        }).then(function (res) {
            return res.data;
        });
    };

    var printNoPickupTransactionHistory = function printNoPickupTransactionHistory(locationId, startDate, endDate, timezone, sortColumn, sortASC) {
        return $http.get(_app2.default.api + '/transaction/print-no-pickup-transaction-history', {
            params: { locationId: locationId, startDate: startDate, endDate: endDate, timezone: timezone, sortColumn: sortColumn, sortASC: sortASC }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        transactionHistory: transactionHistory,
        currentContent: currentContent,
        exportNoPickupTransactionHistory: exportNoPickupTransactionHistory,
        printNoPickupTransactionHistory: printNoPickupTransactionHistory
    };
};

TransactionService.$inject = ['$http', '$q'];

exports.default = TransactionService;

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TruckService = function TruckService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/vehicle', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data, branchId) {
        return $http.post(_app2.default.api + '/vehicle/create', { data: data, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + ('/vehicle/' + id), {
            params: {
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data, branchId) {
        return $http.post(_app2.default.api + ('/vehicle/' + id), { data: data, branchId: branchId }).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/vehicle/' + id)).then(function (res) {
            return res.data;
        });
    };

    var setTruckForRoute = function setTruckForRoute(id, route, date, branchId) {
        return $http.post(_app2.default.api + ('/vehicle/' + id + '/set-truck'), {
            route: route,
            date: date,
            branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var getAllTrucks = function getAllTrucks(searchText, branch, routeId, vaultDate, limit, offset) {
        return $http.get(_app2.default.api + '/vehicle/multi-branch-truck', {
            params: {
                searchText: searchText, branch: branch, routeId: routeId, vaultDate: vaultDate, limit: limit, offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var loadRemainingTrucks = function loadRemainingTrucks(branch, locationType) {
        return $http.get(_app2.default.api + '/vehicle/load-remaining-trucks', {
            params: {
                branch: branch,
                locationType: locationType
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getRestrictTrucks = function getRestrictTrucks(searchText, branch, routeId, limit, offset) {
        return $http.get(_app2.default.api + '/vehicle/get-restrict-trucks', {
            params: {
                searchText: searchText, branch: branch, routeId: routeId, limit: limit, offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get,
        setTruckForRoute: setTruckForRoute,
        getAllTrucks: getAllTrucks,
        loadRemainingTrucks: loadRemainingTrucks,
        getRestrictTrucks: getRestrictTrucks
    };
};

TruckService.$inject = ['$http', '$q'];

exports.default = TruckService;

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserBranchFundingSourceService = function UserBranchFundingSourceService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/user-branch-funding-source', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var createUserFundingSourceGroup = function createUserFundingSourceGroup(userId, fundingSourceData) {
        return $http.post(_app2.default.api + '/user-branch-funding-source/create-user-funding-source-group', {
            userId: userId,
            fundingSourceData: fundingSourceData
        }).then(function (res) {
            return res.data;
        });
    };

    var updateUserFundingSourceGroup = function updateUserFundingSourceGroup(userId, fundingSourceData) {
        return $http.post(_app2.default.api + '/user-branch-funding-source/update-user-funding-source-group', {
            userId: userId,
            fundingSourceData: fundingSourceData
        }).then(function (res) {
            return res.data;
        });
    };

    var getBranchFundingSource = function getBranchFundingSource(userId, branchId) {
        return $http.get(_app2.default.api + '/user-branch-funding-source/get-branch-funding-source', {
            params: {
                userId: userId,
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        createUserFundingSourceGroup: createUserFundingSourceGroup,
        updateUserFundingSourceGroup: updateUserFundingSourceGroup,
        getBranchFundingSource: getBranchFundingSource
    };
};

UserBranchFundingSourceService.$inject = ['$http', '$q'];

exports.default = UserBranchFundingSourceService;

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserBranchService = function UserBranchService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/user-branch', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getUserBranches = function getUserBranches(userId) {
        var query = '';
        if (userId) {
            query = '?user=' + userId;
        }
        return $http.get(_app2.default.api + '/user-branch/getBranchGroup' + query).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        getUserBranches: getUserBranches
    };
};

UserBranchService.$inject = ['$http', '$q'];

exports.default = UserBranchService;

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserService = function UserService($http, $q) {

    var profile = function profile() {
        return $http.post(_app2.default.api + '/user/profile').then(function (res) {
            return res.data;
        });
    };

    var acl = function acl(userId, branchId) {
        var query = '';
        if (userId) {
            query = '?user=' + userId + '&branchId=' + branchId;
        }
        return $http.get(_app2.default.api + '/acl/user-resources' + query).then(function (res) {
            return res.data;
        });
    };
    var updateAcl = function updateAcl(obj, allow) {
        var url = allow ? 'allow' : 'revoke';
        return $http.post(_app2.default.api + ('/acl/' + url), obj).then(function (res) {
            return res.data;
        });
    };
    var role = function role(userId, branchId) {
        var query = '';
        if (userId) {
            query = '?user=' + userId + '&branchId=' + branchId;
        }
        return $http.get(_app2.default.api + '/acl/user-roles' + query).then(function (res) {
            return res.data;
        });
    };
    var addRole = function addRole(id, branchIds) {
        var role = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        var data = {
            role: ''
        };
        data['role'] = role.length > 0 ? role : 'user:' + id;
        if (id > 0) {
            //if true : role will be allocated to current user
            data['user'] = id;
        }
        if (branchIds) {
            //if true : role will be allocated to current user
            data['branchIds'] = branchIds;
        }
        return $http.post(_app2.default.api + '/acl/add-roles-user', data).then(function (res) {
            return res;
        });
    };

    var createBranchGrouped = function createBranchGrouped(data) {
        return $http.post(_app2.default.api + '/user/grouped', data).then(function (res) {
            return res.data;
        });
    };

    var getUserBranchGroup = function getUserBranchGroup(userId) {
        var query = '';
        if (userId) {
            query = '?user=' + userId;
        }
        return $http.get(_app2.default.api + '/user/getBranchGroup' + query).then(function (res) {
            return res.data;
        });
    };

    var updateBranchGrouped = function updateBranchGrouped(data) {
        return $http.post(_app2.default.api + '/user/updateBranchGroup', data).then(function (res) {
            return res.data;
        });
    };

    var updatePermissions = function updatePermissions(data) {
        return $http.post(_app2.default.api + '/acl/update-permissions', data).then(function (res) {
            return res.data;
        });
    };

    var getBranchCounters = function getBranchCounters(branchId) {
        return $http.get(_app2.default.api + ('/users/get-branch-counters/' + branchId)).then(function (res) {
            return res.data;
        });
    };

    return {
        profile: profile,
        acl: acl,
        updateAcl: updateAcl,
        role: role,
        addRole: addRole,
        createBranchGrouped: createBranchGrouped,
        getUserBranchGroup: getUserBranchGroup,
        updateBranchGrouped: updateBranchGrouped,
        updatePermissions: updatePermissions,
        getBranchCounters: getBranchCounters
    };
};

UserService.$inject = ['$http', '$q'];

exports.default = UserService;

/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersService = function UsersService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/users', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/users/create', data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id, branchId) {
        return $http.delete(_app2.default.api + ('/users/' + id), { params: { branchId: branchId } }).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/users/' + id), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/users/' + id)).then(function (res) {
            return res.data;
        });
    };

    var getLatestLogEntry = function getLatestLogEntry(id) {
        return $http.get(_app2.default.api + ('/users/latest-log-entry/' + id)).then(function (res) {
            return res.data;
        });
    };

    var updateUserKeys = function updateUserKeys(userData) {
        return $http.post(_app2.default.api + '/users/update-user-key', { userData: userData }).then(function (res) {
            return res.data;
        });
    };

    var updateUserBranch = function updateUserBranch(id, data) {
        return $http.post(_app2.default.api + ('/users/update-user-branch/' + id), data).then(function (res) {
            return res.data;
        });
    };

    var checkSupervisor = function checkSupervisor(id) {
        return $http.get(_app2.default.api + ('/users/check-supervisor/' + id)).then(function (res) {
            return res.data;
        });
    };

    var getUserFieldData = function getUserFieldData(id) {
        return $http.get(_app2.default.api + ('/users/get-user-details/' + id)).then(function (res) {
            return res.data;
        });
    };

    var userList = function userList(branch) {
        return $http.get(_app2.default.api + '/users/user-list', {
            params: { branch: branch }
        }).then(function (res) {
            return res.data;
        });
    };

    var userPermissions = function userPermissions(userList) {
        return $http.post(_app2.default.api + '/users/user-permissions', { userList: userList }).then(function (res) {
            return res.data;
        });
    };

    var userPermissionReport = function userPermissionReport(userList) {
        return $http.post(_app2.default.api + '/users/user-permission-report', { userList: userList }).then(function (res) {
            return res.data;
        });
    };

    var changeWebPassword = function changeWebPassword(loggedInUser, loggedInUsersBranch, userId, password) {
        return $http.post(_app2.default.api + '/user/change-web-password', { loggedInUser: loggedInUser, loggedInUsersBranch: loggedInUsersBranch, userId: userId, password: password }).then(function (res) {
            return res.data;
        });
    };

    var send2FACode = function send2FACode(emailOrUserId) {
        return $http.post(_app2.default.api + '/user/send-2FA-code', { emailOrUserId: emailOrUserId }).then(function (res) {
            return res.data;
        });
    };

    var verify2FACode = function verify2FACode(emailOrUserId, code) {
        return $http.post(_app2.default.api + '/user/verify-2FA-code', { emailOrUserId: emailOrUserId, code: code }).then(function (res) {
            return res.data;
        });
    };

    var validateUserPermissions = function validateUserPermissions(firstName, lastName) {
        return $http.get(_app2.default.api + '/users/validate-user-permissions', {
            params: { firstName: firstName, lastName: lastName }
        }).then(function (res) {
            return res.data;
        });
    };

    var updateCustomerUserPermissions = function updateCustomerUserPermissions() {
        return $http.post(_app2.default.api + '/users/update-customer-user-permissions').then(function (res) {
            return res.data;
        });
    };

    var bulkUpdateCustomerUsers = function bulkUpdateCustomerUsers(data) {
        return $http.post(_app2.default.api + '/users/bulk-update-customer-users', data).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        bulkUpdateCustomerUsers: bulkUpdateCustomerUsers,
        update: update,
        get: get,
        getLatestLogEntry: getLatestLogEntry,
        updateUserKeys: updateUserKeys,
        updateUserBranch: updateUserBranch,
        checkSupervisor: checkSupervisor,
        getUserFieldData: getUserFieldData,
        userList: userList,
        userPermissions: userPermissions,
        userPermissionReport: userPermissionReport,
        changeWebPassword: changeWebPassword,
        send2FACode: send2FACode,
        verify2FACode: verify2FACode,
        validateUserPermissions: validateUserPermissions,
        updateCustomerUserPermissions: updateCustomerUserPermissions
    };
};

UsersService.$inject = ['$http', '$q'];

exports.default = UsersService;

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VaultOperationsService = function VaultOperationsService($http, $q) {

    var getRouteList = function getRouteList(searchText, startDate, endDate, offset, limit, sortASC, sortColumn, timezone, vaultDateRoutes, branch, routeId) {
        return $http.get(_app2.default.api + '/vault-operations/get-route-list', {
            params: {
                searchText: searchText,
                startDate: startDate,
                endDate: endDate,
                offset: offset,
                limit: limit,
                sortASC: sortASC,
                sortColumn: sortColumn,
                timezone: timezone,
                vaultDateRoutes: vaultDateRoutes,
                branch: branch,
                routeId: routeId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getDeliveryShipmentList = function getDeliveryShipmentList(searchText, startDate, endDate, offset, limit, sortASC, sortColumn, timezone, branch) {
        return $http.get(_app2.default.api + '/vault-operations/get-delivery-shipment-list', {
            params: {
                searchText: searchText,
                startDate: startDate,
                endDate: endDate,
                offset: offset,
                limit: limit,
                sortASC: sortASC,
                sortColumn: sortColumn,
                timezone: timezone,
                branch: branch
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getPickupShipmentList = function getPickupShipmentList(searchText, startDate, endDate, offset, limit, sortASC, sortColumn, timezone, branch) {
        return $http.get(_app2.default.api + '/vault-operations/get-pickup-shipment-list', {
            params: {
                searchText: searchText,
                startDate: startDate,
                endDate: endDate,
                offset: offset,
                limit: limit,
                sortASC: sortASC,
                sortColumn: sortColumn,
                timezone: timezone,
                branch: branch
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentMarkUndelivered = function shipmentMarkUndelivered(trackingId, routeId, supervisorId, branchId, loadedAmount, shipmentAmount, reason, fromLocationId, toLocationId, qty, shiptypeId) {
        return $http.post(_app2.default.api + '/vault-operations/shipment-mark-undelivered', {
            trackingId: trackingId,
            routeId: routeId,
            supervisorId: supervisorId,
            branchId: branchId,
            loadedAmount: loadedAmount,
            shipmentAmount: shipmentAmount,
            reason: reason,
            fromLocationId: fromLocationId,
            toLocationId: toLocationId,
            qty: qty,
            shiptypeId: shiptypeId

        }).then(function (res) {
            return res.data;
        });
    };

    var updateDeliveryShipment = function updateDeliveryShipment(shipmentObj) {
        return $http.post(_app2.default.api + '/vault-operations/update-delivery-shipment', {
            shipmentObj: shipmentObj
        }).then(function (res) {
            return res.data;
        });
    };

    var markHoldAsDelivered = function markHoldAsDelivered(shipmentObj) {
        return $http.post(_app2.default.api + '/vault-operations/shipment-hold-mark-delivered', {
            shipmentObj: shipmentObj
        }).then(function (res) {
            return res.data;
        });
    };

    var updatePickupShipment = function updatePickupShipment(shipmentObj) {
        return $http.post(_app2.default.api + '/vault-operations/update-pickup-shipment', {
            shipmentObj: shipmentObj
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentCheckIn = function shipmentCheckIn(branchId, trackingId, routeId, userId, vaultDate) {
        return $http.post(_app2.default.api + '/vault-operations/shipment-check-in', {
            branchId: branchId,
            trackingId: trackingId,
            routeId: routeId,
            userId: userId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentCheckInDelivery = function shipmentCheckInDelivery(branchId, trackingId, routeId, userId, vaultDate, convertToPickup) {
        return $http.post(_app2.default.api + '/vault-operations/convert-immediate-delivery-to-pickup', {
            branchId: branchId,
            trackingId: trackingId,
            routeId: routeId,
            userId: userId,
            vaultDate: vaultDate,
            convertToPickup: convertToPickup
        }).then(function (res) {
            return res.data;
        });
    };

    var shipmentCheckOut = function shipmentCheckOut(branchId, trackingId, routeId, userId, vaultDate) {
        return $http.post(_app2.default.api + '/vault-operations/shipment-check-out', {
            branchId: branchId,
            trackingId: trackingId,
            routeId: routeId,
            userId: userId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var removeHoldShipment = function removeHoldShipment(trackingId, userId, branchId) {
        return $http.post(_app2.default.api + '/vault-operations/remove-hold-shipment', {
            trackingId: trackingId,
            userId: userId,
            branchId: branchId
        });
    };

    var updateRouteDetails = function updateRouteDetails(branchId, routeId, vaultDate, vehicleId, messengerId, driverId, guardId, leaveTime, arriveTime, complTime, begMiles, endMiles, browserTimezone, supervisorId) {
        return $http.post(_app2.default.api + '/vault-operations/update-route-details', {
            branchId: branchId,
            routeId: routeId,
            vaultDate: vaultDate,
            vehicleId: vehicleId,
            messengerId: messengerId,
            driverId: driverId,
            guardId: guardId,
            leaveTime: leaveTime,
            arriveTime: arriveTime,
            complTime: complTime,
            begMiles: begMiles,
            endMiles: endMiles,
            browserTimezone: browserTimezone,
            supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    var undoCheckInTime = function undoCheckInTime(routeId, routeDate, branchId) {
        return $http.post(_app2.default.api + '/vault-operations/undo-check-in-time', {
            routeId: routeId, routeDate: routeDate, branchId: branchId
        }).then(function (res) {
            return res.data;
        });
    };

    var getFilterRouteList = function getFilterRouteList(startDate, endDate, branch, vaultDateRoutes, searchText, limit, offset) {
        return $http.get(_app2.default.api + '/vault-operations/get-filter-route-list', {
            params: {
                startDate: startDate,
                endDate: endDate,
                branch: branch,
                vaultDateRoutes: vaultDateRoutes,
                searchText: searchText,
                limit: limit,
                offset: offset
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var convertToBagoutablePickup = function convertToBagoutablePickup(trackingId) {
        return $http.post(_app2.default.api + '/vault-operations/convert-to-bagoutable-pickup', {
            trackingId: trackingId
        }).then(function (res) {
            return res.data;
        });
    };

    var convertToPickup = function convertToPickup(trackingId, branchId, routeId, userId, vaultDate) {
        return $http.post(_app2.default.api + '/vault-operations/convert-to-pickup', {
            trackingId: trackingId,
            branchId: branchId,
            routeId: routeId,
            userId: userId,
            vaultDate: vaultDate
        }).then(function (res) {
            return res.data;
        });
    };

    var rescheduleRouteDeliveries = function rescheduleRouteDeliveries(fromRouteId, fromVaultDate, toRouteId, toVaultDate, branchId, comments, shipments, supervisorId) {
        return $http.post(_app2.default.api + '/vault-operations/reschedule-route-deliveries', {
            fromRouteId: fromRouteId,
            fromVaultDate: fromVaultDate,
            toRouteId: toRouteId,
            toVaultDate: toVaultDate,
            branchId: branchId,
            comments: comments,
            shipments: shipments,
            supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    var getNotDeliveredShipments = function getNotDeliveredShipments(routeId, vaultDate, branchId) {
        return $http.get(_app2.default.api + '/vault-operations/get-not-delivered-shipments', {
            params: {
                routeId: routeId,
                vaultDate: vaultDate,
                branchId: branchId
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var markAllDelivered = function markAllDelivered(branchId, routeId, vaultDate, supervisorId) {
        return $http.post(_app2.default.api + '/vault-operations/mark-all-delivered', {
            branchId: branchId,
            routeId: routeId,
            vaultDate: vaultDate,
            supervisorId: supervisorId
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        getRouteList: getRouteList,
        getDeliveryShipmentList: getDeliveryShipmentList,
        getPickupShipmentList: getPickupShipmentList,
        shipmentMarkUndelivered: shipmentMarkUndelivered,
        updateDeliveryShipment: updateDeliveryShipment,
        updatePickupShipment: updatePickupShipment,
        shipmentCheckIn: shipmentCheckIn,
        shipmentCheckInDelivery: shipmentCheckInDelivery,
        shipmentCheckOut: shipmentCheckOut,
        removeHoldShipment: removeHoldShipment,
        updateRouteDetails: updateRouteDetails,
        undoCheckInTime: undoCheckInTime,
        getFilterRouteList: getFilterRouteList,
        markHoldAsDelivered: markHoldAsDelivered,
        convertToBagoutablePickup: convertToBagoutablePickup,
        convertToPickup: convertToPickup,
        rescheduleRouteDeliveries: rescheduleRouteDeliveries,
        getNotDeliveredShipments: getNotDeliveredShipments,
        markAllDelivered: markAllDelivered
    };
};

VaultOperationsService.$inject = ['$http', '$q'];

exports.default = VaultOperationsService;

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VaultService = function VaultService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/vault', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/vault/create', data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id) {
        return $http.delete(_app2.default.api + ('/vault/' + id)).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/vault/' + id), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/vault/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get
    };
};

VaultService.$inject = ['$http', '$q'];

exports.default = VaultService;

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleLockerService = function VehicleLockerService($http, $q) {

    var all = function all(search, offset, limit) {
        return $http.get(_app2.default.api + '/vehicle-locker', {
            params: {
                search: search,
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var getLockerLocations = function getLockerLocations(locationIds, searchText, branchId, limit, offset) {
        return $http.post(_app2.default.api + '/vehicle-locker/get-locker-locations', {
            locationIds: locationIds,
            searchText: searchText,
            branchId: branchId,
            limit: limit,
            offset: offset
        }).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        getLockerLocations: getLockerLocations
    };
};

VehicleLockerService.$inject = ['$http', '$q'];

exports.default = VehicleLockerService;

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(5);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WindowService = function WindowService($http, $q) {

    var all = function all(offset, limit) {
        return $http.get(_app2.default.api + '/window', {
            params: {
                offset: offset,
                limit: limit
            }
        }).then(function (res) {
            return res.data;
        });
    };

    var create = function create(data) {
        return $http.post(_app2.default.api + '/window/create', data).then(function (res) {
            return res.data;
        });
    };

    var remove = function remove(id) {
        return $http.delete(_app2.default.api + ('/window/' + id)).then(function (res) {
            return res.data;
        });
    };

    var update = function update(id, data) {
        return $http.post(_app2.default.api + ('/window/' + id), data).then(function (res) {
            return res.data;
        });
    };

    var get = function get(id) {
        return $http.get(_app2.default.api + ('/window/' + id)).then(function (res) {
            return res.data;
        });
    };

    return {
        all: all,
        create: create,
        remove: remove,
        update: update,
        get: get
    };
};

WindowService.$inject = ['$http', '$q'];

exports.default = WindowService;

/***/ }),
/* 2492 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"connection-status-container\">\n<div class=\"alert alert-success\" ng-if=\"connectionStatus === 'online'\" ng-mouseover=\"cancelClearTimer()\" ng-mouseleave=\"startClearTimer()\">\n{{'connectionStatus.messageConnected' | translate}}\n<span style=\"text-decoration: underline\" class=\"cursor-pointer\" ng-click=\"refresh()\">\n{{'connectionStatus.refreshNow' | translate}}\n</span>\n</div>\n<div class=\"alert alert-danger\" ng-if=\"connectionStatus === 'offline'\">\n{{'connectionStatus.messageDisconnected' | translate}}\n<span style=\"text-decoration: underline\" class=\"cursor-pointer\" ng-click=\"refresh()\">\n{{'connectionStatus.refreshNow' | translate}}\n</span>\n</div>\n</div>";
var id1="connection-status.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2493 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-4 remove-left-pad text-left file-upload-directive-style\">\n<span class=\"fileUpload btn btn-primary\">\n<span class=\"upl upload-btn\">{{'shipmentBatch.select_file_btn_label' | translate}}</span>\n<input type=\"file\" class=\"upload up\" multiple=\"multiple\" accept=\".csv,.pdf,.doc,.docx,.xls,.xlsx\"/>\n</span>\n</div>";
var id1="file-upload.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2494 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<nav class=\"navbar-branch-list-scroll-section navbar navbar-default\" role=\"navigation\" ng-if=\"$ctrl.isUserLoggedIn\">\n<audio id=\"scanner_beep\" ng-src=\"{{$ctrl.audio}}\" preload=\"auto\"></audio>\n<audio id=\"success_beep\" ng-src=\"{{$ctrl.successAudio}}\" preload=\"auto\"></audio>\n<div class=\"container-fluid\">\n<div class=\"navbar-header\">\n<button type=\"button\" class=\"navbar-toggle\" data-toggle=\"collapse\" data-target=\"#navbar-brand-centered\">\n<span class=\"sr-only\">Toggle navigation</span>\n<span class=\"icon-bar\"></span>\n<span class=\"icon-bar\"></span>\n<span class=\"icon-bar\"></span>\n</button>\n<div class=\"navbar-brand navbar-brand-centered\">\n<a class=\"navbar-brand_ navbar-app-name\" ui-sref=\"home\">\n<img stream-company-logo set-preview-text=\"true\" id=\"navbar_company_logo\" style=\"float: left;height: 30px;margin-right: 5px;margin-top: -5px;\">\n<span id=\"company_name\"></span>\n</a>\n</div>\n<div class=\"pull-left\">\n<ul class=\"nav navbar-nav left-nav-section\" ng-if=\"$ctrl.userBranches.length > 1 && !$ctrl.hideBranchDD\">\n<li class=\"dropdown\">\n<a class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">{{$ctrl.userInfo.branch.description}}\n<span class=\"caret\"></span>\n</a>\n<ul class=\"dropdown-menu navbar-branch-list\">\n<li ng-repeat=\"userBranch in $ctrl.userBranches track by $index\">\n<a ng-class=\"{'branch-active': userBranch.branchId==$ctrl.userInfo.branchId}\" ng-click=\"$ctrl.shiftBranch(userBranch)\">\n<span translate=\"{{userBranch.branch.description}}\"></span>\n</a>\n</li>\n</ul>\n</li>\n<li ng-if=\"$ctrl.userBranches.length == 1\">\n<a>\n<span translate=\"{{$ctrl.userBranches[0].branch.description}}\"></span>\n</a>\n</li>\n<li ng-if=\"!$ctrl.loading && $ctrl.userInfo.branchLiability.vault_liability > 0\" ng-class=\"{'text-color-red': $ctrl.userInfo.branchLiability.current_liability > $ctrl.userInfo.branchLiability.vault_liability}\" class=\"alert-icon-section\">\n<span ng-if=\"$ctrl.userInfo.branchLiability.current_liability > $ctrl.userInfo.branchLiability.vault_liability\">\n<img ng-src=\"assets/images/red-alert.png\" class=\"alert-icon-width\" uib-tooltip=\"{{'navbar.current_liabilities_of' | translate}} {{$ctrl.userInfo.branchLiability.current_liability | currency}} {{'navbar.has_exceeded' | translate}} {{$ctrl.userInfo.branchLiability.vault_liability | currency}}.\" tooltip-placement=\"bottom-right\"/>\n</span>\n</li>\n</ul>\n</div>\n<div class=\"navbar-nav navbar-center\">\n<strong> <span translate=\"{{$ctrl.pageHeader}}\"></span></strong>\n</div>\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n<span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\" id=\"navbar-brand-centered\">\n<div id=\"bs-example-navbar-collapse-1\">\n<ul class=\"nav navbar-nav navbar-right\">\n<li class=\"dropdown\">\n<a class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">{{$ctrl.userInfo.firstName +' '+ $ctrl.userInfo.lastName}}\n<span class=\"caret\"></span>\n</a>\n<ul class=\"dropdown-menu\">\n<li>\n<a ng-click=\"$ctrl.menuItemClicked({state: 'app.userProfile'})\">\n<span class=\"glyphicon glyphicon-user\"></span> {{ 'common.profile' | translate }} </a>\n</li>\n<li role=\"separator\" class=\"divider\"></li>\n<li ng-repeat=\"p in $ctrl.permissions track by $index\">\n<p role=\"separator\" class=\"divider\" ng-if=\"p == 'divider'\"></p>\n<a ng-if=\"p.title_key\" ng-click=\"$ctrl.menuItemClicked(p)\">\n<span ng-class=\"p.icon\"></span>\n<span translate=\"{{p.title_key}}\"></span>\n</a>\n</li>\n<li role=\"separator\" class=\"divider\"></li>\n<li>\n<a ng-click=\"$ctrl.logout()\">\n<span class=\"glyphicon glyphicon-log-out\"></span> {{ 'common.logout' | translate }}\n</a>\n</li>\n</ul>\n</li>\n</ul>\n</div>\n</div>\n</div>\n</nav>";
var id1="navbar.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2495 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"paginated-search-and-select-dd\" style=\"position: relative; outline: none;\" tabindex=\"-1\" ng-blur=\"onBlurHandler()\" ng-class=\"{ 'div-disabled': isDisabled}\">\n<div ng-class=\"{expanded: isExpanded}\" class=\"input-group\">\n<div ng-hide=\"hideLabel\" ng-click=\"toggleSelector()\" ng-class=\"{'ng-required': required, 'ng-touched': isTouched(), 'ng-invalid': !isValid(), 'ng-valid': isValid() }\" class=\"form-control\">\n<span ng-bind-html=\"currentLabel()\" class=\"caption\"></span>\n</div>\n<div ng-click=\"toggleSelector()\" class=\"input-group-addon\">\n<span ng-if=\"toggleCount && totalSelected\">{{totalSelected}} /</span>\n<span ng-if=\"toggleCount\"> {{totalCount || 0}}</span>\n<span ng-if=\"!toggleCount\" ng-class=\"{'glyphicon-chevron-down': !isExpanded, 'glyphicon-chevron-up': isExpanded}\" class=\"glyphicon\"></span>\n</div>\n</div>\n<div ng-show=\"isExpanded\" class=\"well multi-select-options\">\n<div ng-show=\"search\" style=\"margin-bottom: 4px;\">\n<div>\n<label class=\"display-none\" for=\"{{labelName}}_search\">{{labelName}}</label>\n<input type=\"text\" ng-model=\"searchKey\" id=\"{{labelName}}_search\" class=\"form-control\" placeholder=\"Search...\" ng-model-options=\"{debounce: 1000}\" ng-change=\"searchBy(searchKey)\" ng-show=\"options.length || searchKey.length\" ng-blur=\"_onBlurHandler()\">\n<input type=\"text\" id=\"{{labelName}}_search\" class=\"form-control\" placeholder=\"Search...\" ng-show=\"!options.length && !searchKey.length\" disabled=\"disabled\">\n</div>\n</div>\n<div ng-if=\"allValue\" class=\"list-group all-item-group\">\n<label ng-class=\"{active: enabledItems[allValue], 'disabled': !options || !options.length}\" class=\"list-group-item\">\n<input ng-if=\"options && options.length\" type=\"checkbox\" ng-model=\"enabledItems[allValue]\" ng-blur=\"onBlurHandler()\"/>\n<input ng-if=\" !options.length\" type=\"checkbox\" ng-model=\"enabledItems[allValue]\" ng-blur=\"onBlurHandler()\" disabled=\"disabled\" ng-class=\"{'disabled': !options || !options.length}\"/>\nSelect All\n</label>\n</div>\n<div class=\"row\">\n<div class=\"col-md-6\">\n<p class=\"pagination-text remove-white-space\">Showing records {{options.length ? 1 : 0}} to {{options.length}} of {{totalCount}}</p>\n</div>\n<div class=\"col-md-6 text-right select-btn-section\">\n<button class=\"btn btn-xs btn-primary ignore-validation-css\" ng-class=\"\" ng-hide=\"searchKey\" ng-if=\"billingType\" ng-click=\"showAllLocation()\" ng-disabled=\"selectAllLoading\">\n{{'common.showall' | translate}}\n</button>\n<button class=\"btn btn-xs btn-success ignore-validation-css\" ng-if=\"options.length > 0\" ng-class=\"\" ng-click=\"selectAll()\" ng-disabled=\"selectAllLoading || isAllSelected()\">\n<span ng-if=\"selectAllLoading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'common.selectall' | translate}}\n</button>\n<button class=\"btn btn-xs btn-primary ignore-validation-css\" ng-if=\"options.length > 0\" ng-click=\"selectNone()\" ng-disabled=\"selectAllLoading\">\n{{'common.selectnone' | translate}}\n</button>\n</div>\n</div>\n<ul class=\"bind-cst-scroll list-group margin-top-05\">\n<li class=\"inner-item text-align-left\" ng-if=\"options.length\" ng-repeat=\"item in options | orderBy:sortShowFirst track by $index\">\n<label class=\"list-group-item\" ng-class=\"{active: itemIsActive(item), disabled: itemDisabled(item)}\">\n<input type=\"checkbox\" ng-if=\"!allowSingleSelect\" ng-model=\"enabledItems[item.value]\" ng-blur=\"onBlurHandler()\" ng-disabled=\"itemDisabled(item)\"/>\n<input type=\"checkbox\" ng-if=\"allowSingleSelect\" ng-model=\"enabledItems[item.Value]\" ng-click=\"itemClicked(item)\" ng-blur=\"onBlurHandler()\" ng-disabled=\"itemDisabled(item)\"/>\n{{item[key]}} <span ng-if=\"item.customerKey\"> ({{item.customerKey}})</span>\n</label>\n</li>\n<li ng-if=\"options.length == 0\" class=\"list-group-item\">\nNot Found\n</li>\n</ul>\n<div class=\"clearfix\"></div>\n<div class=\"d-flex justify-content-end mt-1\" ng-if=\"showFilterAction\">\n<button ng-click=\"_resetAction()\" class=\"btn btn-xs btn-danger mr-2\">{{'common.reset' | translate}}</button>\n<button ng-click=\"_applyAction()\" class=\"btn btn-xs btn-success\">Apply</button>\n</div>\n</div>\n</div>";
var id1="paginated-search-and-select.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2496 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-attr-tabindex=\"{{disabled ? -1 : 0}}\" ng-focus=\"show()\" class=\"searchandselect\" ng-class=\"{ active: showList, 'disabled-state': disabled, 'is-highlighted': isHighlighted }\" id=\"{{focusDropdownId}}\">\n<div class=\"header word-ellipsis selected-text-width\" ng-click=\"show()\" ng-class=\"{'ng-required': required, 'invalid': !isValid(), 'valid': isValid() }\">\n<span ng-bind-html=\"currentLabel()\" class=\"caption\"></span>\n<i class=\"caret pull-right\" ng:class=\"{true:'', false:'caret'}[showList]\"></i>\n</div>\n<ul class=\"dropdownone\" ng-show=\"dropdownVisible\" ng-class=\"{ 'dd-width': longDdWidthFlag, 'search-select-dd-width': extendDdWidth }\">\n<div class=\"search\">\n<div>\n<input id=\"{{focusDropdownSearch}}\" type=\"text\" ng-model=\"searchKey\" class=\"form-control\" ng-model-options=\"{debounce: 1000}\" placeholder=\"{{'common.searchPlaceHolder' | translate}}\" ng-change=\"textChanged(searchKey)\">\n</div>\n<div ng-if=\"!hideCount\" class=\"text-right nomargin nopadding\"><small>{{ 'common.showingRecord' | translate }} {{filteredValues.length ? 1 : 0 }} {{'common.to' | translate | lowercase}} {{filteredValues.length || 0}} {{ 'common.Of' | translate }} {{totalrecords || 0}}</small></div>\n</div>\n<div class=\"inner-item\">\n<li ng-if=\"filteredValues && filteredValues.length\" ng-repeat=\"item in filteredValues track by $index\" class=\"child\" ng-class=\"{'row-active' : isActive(item), 'option' : !isActive(item), 'highlight-row': $index == focusedIdx }\" ng-click=\"selectItem(item)\" ng-mousedown=\"$event.preventDefault()\" ng-mouseenter=\"setActive($index)\">\n<i class=\"margin-top2 glyphicon glyphicon-ok\" ng-show=\"isActive(item)\"></i>\n<div class=\"width-per95\">\n<span>{{item[key]}} </span>\n</div>\n</li>\n</div>\n<li ng-if=\"!filteredValues || filteredValues.length == 0\">\n{{ 'common.noRecords' | translate}}\n</li>\n</ul>\n</div>\n";
var id1="search-and-select.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2497 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'setup.changePassword' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row\">\n<div class=\"_form-group col-sm-6\">\n<label for=\"password\">{{'users.password' | translate }}</label>\n<input type=\"password\" class=\"form-control\" id=\"read_password\" placeholder=\"\" ng-model=\"$ctrl.model.password\" ng-attr-id=\"{{ $ctrl.modelDetails.isWebPassword ? 'password' : 'read_password'}}\" ng-attr-type=\"{{ $ctrl.passIcon.pass ? 'text' : 'password'}}\" required>\n<div class=\"password-icon\" ng-click=\"$ctrl.showPassword('pass')\">\n<span class=\"glyphicon\" ng-class=\"$ctrl.passIcon.pass ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></span>\n</div>\n<span ng-if=\"$ctrl.errors.password\" class=\"text-danger\">{{$ctrl.errors['password']}}</span>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"cnfpassword\">{{'users.cnfpassword' | translate }}</label>\n<input type=\"password\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.cnfPassword\" ng-attr-type=\"{{ $ctrl.passIcon.cpass ? 'text' : 'password'}}\" required>\n<div class=\"password-icon\" ng-click=\"$ctrl.showPassword('cpass')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passIcon.cpass ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n<span ng-show=\"$ctrl.model.password!=$ctrl.model.cnfPassword\" class=\"text-danger\">password mismatch</span>\n</div>\n</div>\n<div class=\"margin-top-10 row remove-pad alert alert-info remove-margin-bottom\" ng-if=\"$ctrl.model.passwordPolicy.isForceChangePassword && $ctrl.model.passwordPolicy.isCurrentPassSameAsPrevious\">\n<ul>\n<li id=\"forceChangePasswordDays\" translate=\"login.duplicate_password_warning\"></li>\n</ul>\n</div>\n<div class=\"row margin-top-10 remove-pad alert alert-info remove-margin-bottom\" ng-if=\"$ctrl.model.passwordPolicy.errors.length > 0\">\n<ul>\n<li ng-repeat=\"error in $ctrl.model.passwordPolicy.errors\">\n{{error.message}}\n</li>\n</ul>\n</div>\n</div>\n<hr class=\"modal-footer remove-top-margin\">\n<button type=\"button\" class=\"btn btn-primary\" event=\"event\" style=\"margin-top: -50px;margin-left: 75%\" ng-click=\"$ctrl.changePassword()\" ng-disabled=\"!$ctrl.model.password || !$ctrl.model.cnfPassword || $ctrl.model.password!=$ctrl.model.cnfPassword\" ng-class=\"{'disabled': loading}\" ng-if=\"!$ctrl.modelDetails.isWebPassword\">\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-primary\" event=\"event\" style=\"margin-top: -50px;margin-left: 75%\" ng-click=\"$ctrl.changeWebPassword()\" ng-disabled=\"!$ctrl.model.password || !$ctrl.model.cnfPassword || $ctrl.model.password!=$ctrl.model.cnfPassword\" ng-class=\"{'disabled': loading}\" ng-if=\"$ctrl.modelDetails.isWebPassword\">\n{{'common.save' | translate}}\n</button>\n<script>\nvar nAgt = navigator.userAgent;\n    var browserName = navigator.appName;\n    var nameOffset, verOffset;\n\n    // In Opera, the true version is after \"Opera\" or after \"Version\"\n    if ((verOffset = nAgt.indexOf(\"Opera\")) != -1) {\n        browserName = \"Opera\";\n        $('#password').get(0).type = 'password';\n        $('#cnfpassword').get(0).type = 'password';\n    }\n    // In MSIE, the true version is after \"MSIE\" in userAgent\n    else if ((verOffset = nAgt.indexOf(\"MSIE\")) != -1) {\n        browserName = \"Microsoft Internet Explorer\";\n        $('#password').get(0).type = 'password';\n        $('#cnfpassword').get(0).type = 'password';\n    }\n    // In Chrome, the true version is after \"Chrome\" \n    else if ((verOffset = nAgt.indexOf(\"Chrome\")) != -1) {\n        browserName = \"Chrome\";\n        $(\"#password\").css(\"-webkit-text-security\", \"disc\");\n        $(\"#cnfpassword\").css(\"-webkit-text-security\", \"disc\");\n    }\n    // In Safari, the true version is after \"Safari\" or after \"Version\" \n    else if ((verOffset = nAgt.indexOf(\"Safari\")) != -1) {\n        browserName = \"Safari\";\n        $(\"#password\").css(\"-webkit-text-security\", \"disc\");\n        $(\"#cnfpassword\").css(\"-webkit-text-security\", \"disc\");\n    }\n    // In Firefox, the true version is after \"Firefox\" \n    else if ((verOffset = nAgt.indexOf(\"Firefox\")) != -1) {\n        browserName = \"Firefox\";\n        $('#password').get(0).type = 'password';\n        $('#cnfpassword').get(0).type = 'password';\n    }\n    // In most other browsers, \"name/version\" is at the end of userAgent \n    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {\n        browserName = nAgt.substring(nameOffset, verOffset);\n        if (browserName.toLowerCase() == browserName.toUpperCase()) {\n            browserName = navigator.appName;\n        }\n        $('#password').get(0).type = 'password';\n        $('#cnfpassword').get(0).type = 'password';\n    }\n</script>";
var id1="changePassword.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2498 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'confirmSupervisorModal.title' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row\">\n<div class=\"_form-group col-sm-6\">\n<label for=\"sup-id\">{{'confirmSupervisorModal.supervisor' | translate}}</label>\n<input autocomplete=\"off\" id=\"sup-id\" type=\"text\" class=\"form-control\" strip-prefix scan-type=\"'messenger'\" ng-model=\"$ctrl.model.id\" ng-keyup=\"$event.keyCode === 13 && $ctrl.confirmSupervisor()\" ng-disabled=\"$ctrl.loading\" required/>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"sup-password\">{{'confirmSupervisorModal.password' | translate}} </label>\n<input autocomplete=\"off\" id=\"sup-password\" type=\"text\" class=\"form-control\" ng-keyup=\"$event.keyCode === 13 && !$ctrl.loading && $ctrl.confirmSupervisor()\" ng-model=\"$ctrl.model.password\" ng-disabled=\"$ctrl.loading\" required/>\n</div>\n<div class=\"margin-10 col-sm-12\" ng-if=\"$ctrl.errorMessage\">\n<div class=\"remove-bottom-pad alert alert-danger\">\n<span>{{$ctrl.errorMessage}}</span>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.details.showConvertToPickup\">\n<div class=\"col-sm-12 margin-top-20\">\n<label class=\"checkbox-inline\" style=\"font-weight: bold;\">\n<input type=\"checkbox\" ng-model=\"$ctrl.model.convertToPickup\" style=\"margin-top: 2px;\"> Convert to Pickup\n</label>\n</div>\n</div>\n</div>\n<hr class=\"modal-footer remove-margin\">\n<button type=\"button\" class=\"btn btn-primary save-btn\" ng-class=\"{'margin-left-02' : $ctrl.buttonText, 'margin-left-88' : $ctrl.buttonStyle == 'marginleft88'}\" event=\"event\" ng-click=\"$ctrl.confirmSupervisor()\" ng-disabled=\"$ctrl.loading || confirmSupervisorForm.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-if=\"!$ctrl.buttonText\">{{'common.save' | translate}}</span>\n<span ng-if=\"$ctrl.buttonText\">{{$ctrl.buttonText}}</span>\n</button>\n<script>\nvar nAgt = navigator.userAgent;\n        var browserName = navigator.appName;\n        var nameOffset, verOffset;\n\n        // In Opera, the true version is after \"Opera\" or after \"Version\"\n        if ((verOffset = nAgt.indexOf(\"Opera\")) != -1) {\n            browserName = \"Opera\";\n            $('#sup-id').get(0).type = 'password';\n            $('#sup-password').get(0).type = 'password';\n        }\n        // In MSIE, the true version is after \"MSIE\" in userAgent\n        else if ((verOffset = nAgt.indexOf(\"MSIE\")) != -1) {\n            browserName = \"Microsoft Internet Explorer\";\n            $('#sup-id').get(0).type = 'password';\n            $('#sup-password').get(0).type = 'password';\n        }\n        // In Chrome, the true version is after \"Chrome\" \n        else if ((verOffset = nAgt.indexOf(\"Chrome\")) != -1) {\n            browserName = \"Chrome\";\n            $(\"#sup-id\").css(\"-webkit-text-security\", \"disc\");\n            $(\"#sup-password\").css(\"-webkit-text-security\", \"disc\");\n        }\n        // In Safari, the true version is after \"Safari\" or after \"Version\" \n        else if ((verOffset = nAgt.indexOf(\"Safari\")) != -1) {\n            browserName = \"Safari\";\n            $(\"#sup-id\").css(\"-webkit-text-security\", \"disc\");\n            $(\"#sup-password\").css(\"-webkit-text-security\", \"disc\");\n        }\n        // In Firefox, the true version is after \"Firefox\" \n        else if ((verOffset = nAgt.indexOf(\"Firefox\")) != -1) {\n            browserName = \"Firefox\";\n            $('#sup-id').get(0).type = 'password';\n            $('#sup-password').get(0).type = 'password';\n        }\n        // In most other browsers, \"name/version\" is at the end of userAgent \n        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {\n            browserName = nAgt.substring(nameOffset, verOffset);\n            if (browserName.toLowerCase() == browserName.toUpperCase()) {\n                browserName = navigator.appName;\n            }\n            $('#sup-id').get(0).type = 'password';\n            $('#sup-password').get(0).type = 'password';\n        }\n</script>\n<style>\n.margin-left-88 {\n            margin-left: 88% !important;\n        }\n\n        .save-btn {\n            margin-left: 75%;\n            margin-top: -50px;\n        }\n</style>\n";
var id1="confirmSupervisor.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2499 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{header}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<span ng-bind-html=\"message\"></span>\n<div ng-if=\"errorMessage\">\n{{errorMessage}}\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-{{type}}\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-disabled=\"isLoading\" ng-click=\"ok()\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loading}\"></span> {{ buttons[0] | translate }}\n</button>\n<button ng-if=\"buttons.length == 2\" class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">\n{{ buttons[1] | translate }}\n</button>\n</div> ";
var id1="modal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2500 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"padding-20-10\">\n<locationcreate model=\"model\" success=\"ok\" error=\"cancel\"/>\n</div>";
var id1="addLocation.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2501 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"logoModal\" class=\"form-validate\" novalidate ng-click=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\"><b>{{model.header}}</b></h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"text-align-center remove-bottom-margin\">\n<img ng-src=\"{{base64String}}\" width=\"150\"/>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="appLogo.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2502 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"approveBillingRecordsTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'branch_mgmt.billing_approval.approval_title' | translate}} | {{model.customer}}</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading\" class=\"list-group margin-bottom-5\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"_form-group col-sm-12\" style=\"margin-bottom: 5px;\" ng-hide=\"model.surchargeLoading\" ng-bind-html=\"model.approvalMessage\"></div>\n<div class=\"_form-group col-sm-12 text-align-center\" ng-if=\"model.surchargeLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 40px\"></span>\n</div>\n<div class=\"_form-group col-sm-12\" ng-if=\"!model.surchargeLoading && model.hasSurcharge\">\n<table class=\"remove-bottom-margin table table-bordered table-condensed\">\n<thead>\n<tr>\n<th>{{'surchargeDetailsModal.surcharge' | translate}}</th>\n<th>{{'customer.surcharge_interval' | translate}}</th>\n<th>{{'surchargeDetailsModal.fee' | translate}}</th>\n<th class=\"text-right\">{{'surchargeDetailsModal.amount' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"surcharge in model.surchargeBreakdown\">\n<td>{{surcharge.labelKey | translate}}</td>\n<td>\n<span ng-if=\"surcharge.intervalLabelKey\">{{surcharge.intervalLabelKey | translate}}</span>\n<span ng-if=\"!surcharge.intervalLabelKey\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"surcharge.percentage\">{{surcharge.percentage | currency:'':2}}%</span>\n<span ng-if=\"surcharge.percentage && surcharge.maxPercentage && surcharge.maxPercentage !== surcharge.percentage\"> - {{surcharge.maxPercentage | currency:'':2}}%</span>\n<span ng-if=\"!surcharge.percentage\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-right\">{{surcharge.amount | currency}}</td>\n</tr>\n</tbody>\n<tfoot>\n<tr>\n<td colspan=\"3\">{{'branch_mgmt.billing_approval.total_billing' | translate}}</td>\n<td class=\"text-right\">{{(model.totalAmount || 0) | currency}}</td>\n</tr>\n<tr>\n<td colspan=\"3\">{{'branch_mgmt.billing_approval.total_surcharge' | translate}}</td>\n<td class=\"text-right\">{{model.totalSurcharge | currency}}</td>\n</tr>\n<tr>\n<th colspan=\"3\">{{'branch_mgmt.total_amount' | translate}}</th>\n<th class=\"text-right\">{{((model.totalAmount || 0) + model.totalSurcharge) | currency}}</th>\n</tr>\n</tfoot>\n</table>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{'common.cancel' | translate}}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"approveBillingRecordsTemplate.$invalid || model.loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>\n{{'common.ok' | translate}}\n</button>\n</div>\n</form>";
var id1="approveBillingRecords.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2503 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"atmCodesInfoTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'resetAtmCode.info' | translate}}</b></h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.atmCodeValue && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">\n<b>{{'resetAtmCode.code' | translate}}</b>\n</th>\n<th class=\"text-center\">\n<b>{{'resetAtmCode.call_status' | translate}}</b>\n</th>\n<th class=\"text-center\">\n<b>{{'bypassCode.messengerID' | translate}}</b>\n</th>\n<th class=\"text-center\">\n<b>{{'resetAtmCode.created_date' | translate}}</b>\n</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr>\n<td>{{ model.atmCodeValue.code }}</td>\n<td>\n<span ng-if=\"model.atmCodeValue.callStatus\">{{ model.atmCodeValue.callStatus}}</span>\n<span ng-if=\"!model.atmCodeValue.callStatus\">{{ 'common.n_a' | translate }}</span>\n</td>\n<td>\n<span ng-if=\"model.atmCodeValue.messengerId\">{{ model.atmCodeValue.messengerId}}</span>\n<span ng-if=\"!model.atmCodeValue.messengerId\">{{ 'common.n_a' | translate }}</span>\n</td>\n<td>{{ model.atmCodeValue.createdAt | date : 'MM-dd-yyyy | hh:mm a' }}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.atmCodeValue && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.atmCodeValue}\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="atmCodesInfo.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2504 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<a popover-is-open=\"denominations.isOpen\" role=\"button\" \n                    ng-repeat=\"denominations in model.remainingDenominations track by $index\" \n                    ng-click=\"changeDenomType($event, $parent.$index, denominations)\">\n                    <denom-icon denom-id=\"denominations.id\" icon-size=\"22\"> </denom-icon>\n                </a>\n";
var id1="atm-loads-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
var v2="<form name=\"ATMLoadsCreateForm\" novalidate class=\"form-validate\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<span ng-if=\"model.stats === 'create'\">{{'master_cash_schedule.create_atm_load' | translate}}</span>\n<span ng-if=\"model.stats === 'edit'\">{{'master_cash_schedule.edit_atm_load' | translate}} | </span>\n<b ng-if=\"model.shipment.orderNo\">{{model.shipment.orderNo}}</b></h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row\" ng-if=\"model.loading\">\n<div class=\"col-sm-12 text-align-center\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n</div>\n<div class=\"row modal-body remove-pad\" id=\"modal-body\" style=\"width: 100%; max-height: 350px;\" ng-if=\"!model.loading\">\n<div class=\"cash-schedule-form\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-left\">\n<label>{{'branch_mgmt.orders_selectATMs' | translate}}</label>\n<search-and-select ng-model=\"model.fundingSource\" values=\"model.fundingSourceObj.branchFundingSource\" key=\"Key\" totalrecords=\"model.fundingSourceObj.totalBranchFundingSource\" onscroll=\"getAllFundingSource(searchKey, offset)\" none-selected=\"'bulkCash.selectFundingSource'\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\">\n<label>{{'master_cash_schedule.orderNo' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"orderNo\" ng-model=\"model.orderNo\" required ng-pattern=\"/^[0-9]*$/\" placeholder=\"{{'master_cash_schedule.orderNo' | translate}}\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-left\">\n<label>{{'master_cash_schedule.location' | translate}}</label>\n<search-and-select ng-model=\"model.toLocation\" values=\"model.locationObj.locationList\" key=\"Key\" totalrecords=\"model.locationObj.totalLocation\" onscroll=\"loadLocation(searchKey, offset)\" none-selected=\"'common.select_location'\" on-click=\"getLocationNextRoute()\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\">\n<label>{{'master_cash_schedule.route' | translate}}</label>\n<search-and-select ng-model=\"model.routeId\" values=\"model.routeObj.routeList\" key=\"Key\" totalrecords=\"model.routeObj.totalRoutes\" common-search-flag=\"true\" ng-disabled=\"model.isGettingLocationRoutes\" none-selected=\"'master_cash_schedule.route'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 deposit-pack-date-picker remove-pad-left\">\n<label>{{'master_cash_schedule.date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"model.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" date-options=\"minVaultDate\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\">\n<label>{{'master_cash_schedule.orderType' | translate}}</label>\n<select class=\"form-control\" ng-model=\"model.orderType\" required ng-options=\"orderType.value as orderType.key for orderType in model.orderTypes\" ng-change=\"validateBillCount();\">\n<option value=\"\" disabled=\"disabled\">({{'common.select_OrderType' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad-left remove-pad-right form-denom-list\">\n<div class=\"col-sm-3 remove-pad-left remove-pad-right\" ng-repeat=\"denomination in model.denominations track by $index\">\n<div class=\"w-100 text-center\" ng-class=\"{\n                                    'remove-pad-left_': $index < model.denominations.length ,\n                                    'remove-pad-right_': model.denominations.length == $index+1\n                                }\">\n<div class=\"_form-group denom-controls\">\n<button class=\"btn btn-xs\" type=\"button\" ng-click=\"turnOffDenom(denomination, $index)\" ng-class=\"denomination.isEnabled ? 'btn-warning' : 'btn-default'\">\n{{$index + 1}}</button>\n<button class=\"btn btn-xs btn-success\" type=\"button\" ng-if=\"!denomination.isEnabled\" ng-click=\"handleDenomination(denomination)\">\n<span class=\"glyphicon-plus\"></span>\n</button>\n<span class=\"w-100 input-group-addon border-radius-05\" ng-show=\"denomination.isEnabled\">\n<a role=\"button\" uib-popover-template=\"denomination.template\" popover-is-open=\"denomination.isOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\">\n<denom-icon denom-id=\"denomination.icon\" icon-size=\"22\"> </denom-icon>\n</a>\n</span>\n<input ng-show=\"denomination.isEnabled\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !model.denominations[$index].isValid, \n                                    'ng-valid' : model.denominations[$index].isValid || model.denominations[$index].amount}\" ng-model=\"model.denominations[$index].billCount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" ng-change=\"checkAmount($index, model.denominations[$index].billCount, denomination.faceValue);\n                                               validateATMOrderCreateBtn()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"0\" min=\"0\" currency-symbol=\"\" ng-required=\"denomination.isEnabled\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad atm-load-alert-section margin-top-05\" ng-if=\"!model.isValidBillCount\">\n<span class=\"col-sm-12 alert alert-danger text-align-center\">\n{{'addBagModal.requiredAmountError' | translate}}\n</span>\n</div>\n\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" ng-disabled=\"model.loading || ATMLoadsCreateForm.$invalid || validateATMOrderCreateBtn()\" type=\"button\" ng-click=\"ok()\">\n<span ng-if=\"model.stats === 'create'\">{{ 'shipmentBatch.add' | translate }}</span>\n<span ng-if=\"model.stats === 'edit'\">{{ 'common.update' | translate }}</span>\n</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">{{ 'common.cancel' | translate }}</button>\n</div>\n</form>\n<style>\n.denom-controls {\n        display: flex;\n        flex-direction: column;\n        gap: 5px;\n    }\n\n    .form-denom-list {\n        display: flex;\n        gap: 6px;\n    }\n\n    .atm-load-alert-section .alert {\n        padding: 10px !important;\n        margin-bottom: 10px !important;\n    }\n</style>\n";
var id2="atmLoadShipment.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id2,v2);}
else{ngModule.run(["$templateCache",function(c){c.put(id2,v2)}]);}
module.exports=v2;

/***/ }),
/* 2505 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"atmResidualReceiptModal\" class=\"form-validate\" novalidate ng-click=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\"><b>{{'atm_residual.receiptPic' | translate}}</b> | {{model.trackingId}}</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div style=\"position: relative; height: 500px; width: 100%; overflow: auto;\" ng-if=\"!loading\">\n<div class=\"text-align-center\" style=\"display: flex; justify-content: center; align-items: center; height: 100%;\">\n<img ng-src=\"{{model.shipmentData.pickupImageName}}\" ng-style=\"{'width': zoomLevel + 'px', 'height': 'auto', 'max-width': 'none'}\"/>\n</div>\n<div style=\"position: absolute; top: 10px; right: 10px; display: flex; flex-direction: column; gap: 10px;\" ng-if=\"model.shipmentData.pickupImageName\">\n<button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"zoomIn(); $event.stopPropagation()\">+</button>\n<button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"zoomOut(); $event.stopPropagation()\">-</button>\n</div>\n</div>\n<div class=\"modal-footer\">\n<a class=\"btn btn-primary pull-left\" class=\"btn btn-primary\" target=\"_blank\" href=\"{{model.shipmentData.pickupImageName}}\">\n{{ 'common.download' | translate }}\n</a>\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="atmResidualReceipt.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2506 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"autoOpenLocksTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'atm_codes_mgmt.auto_open_locks' | translate}}</b> | {{model.routeId}}</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"auto-open-locks\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div ng-if=\"!model.loading\">\n<span>\n<img class=\"icon-height-60\" ng-src=\"assets/images/Check.png\">\n<b class=\"info-font-style\">{{model.totalOpened}} {{'common.Of' | translate}} {{model.autoOpenLocksResult.length}} {{'atm_codes_mgmt.opened_successfully' | translate}}</b>\n</span>\n</div>\n<div ng-if=\"!model.loading\">\n<span>\n<img class=\"icon-height-60\" ng-src=\"assets/images/scan_error.png\">\n<b class=\"info-font-style\"> {{model.failedToOpen}} {{'common.Of' | translate}} {{model.autoOpenLocksResult.length}} {{'checkout.failed_to_open' | translate}}</b>\n</span>\n</div>\n<table class=\"table table-hover table-bordered margin-top-05 remove-bottom-margin\" ng-if=\"model.autoOpenLocksResult && model.autoOpenLocksResult.length\">\n<thead>\n<tr class=\"header-row\">\n<th>{{'common.location' | translate}}</th>\n<th>{{'atm_codes_mgmt.lock_type' | translate}}</th>\n<th>{{'common.error' | translate}}</th>\n<th>{{'common.key' | translate}}</th>\n<th class=\"date-time-width-17\">{{'resetAtmCode.date' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.autoOpenLocksResult track by $index\">\n<td>\n<span ng-if=\"data.requestLockType\">{{data.serialNo}}</span>\n<span ng-if=\"!data.requestLockType\">{{data.lockName}}</span>\n</td>\n<td>{{data.requestLockType || data.lockType}}</td>\n<td>{{removeCharacter(data.message)}}</td>\n<td ng-if=\"data.keyId\">{{data.keyId}}</td>\n<td ng-if=\"!data.keyId\">{{'common.n_a' | translate}}</td>\n<td>{{model.currentDate | date : 'yyyy-MM-dd | hh:mm a' }}</td>\n</tr>\n</tbody>\n</table>\n<div class=\"margin-top-05\" ng-if=\"!model.loading && !model.autoOpenLocksResult.length && model.isAutoOpenATMs\">\n<div class=\"col-sm-12 alert text-center remove-bottom-margin\" ng-class=\"{'alert-danger': !model.autoOpenLocksResult.length}\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n<div class=\"margin-top-05\" ng-if=\"!model.loading && !model.isAutoOpenATMs\">\n<div class=\"col-sm-12 alert text-center remove-bottom-margin\" ng-class=\"{'alert-danger': !model.isAutoOpenATMs}\">\n{{'atm_codes_mgmt.auto_open_ATMs_not_enabled' | translate}}\n</div>\n</div>\n</div>\n<div class=\"margin-top-10 modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="autoOpenLocks.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2507 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\" ng-if=\"!isSupervisorConfirmed\">\n<h4 class=\"modal-title\">{{'error.91322' | translate}} | {{model.data.bagId}}</h4>\n</div>\n<form class=\"form-validate\" ng-if=\"!isSupervisorConfirmed\">\n<confirm-supervisor event=\"'add-bag'\" button-text=\"'Remove'\" on-confirm=\"supervisorConfirmed\" on-error=\"supervisorCancelled\">\n</confirm-supervisor>\n<button ng-if=\"model.data.cancelSupervisorChallenge\" style=\"margin-top: -49px\" class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</form>";
var id1="bagRemoveConfirmation.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2508 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"bagoutListTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<span ng-if=\"model.infoFor === 'remainingBagout'\"><b>{{'bagout.ramining_deliver_to_items' | translate}}</b> | {{model.destinationLocation}}</span>\n<span ng-if=\"model.infoFor === 'includedBagout'\"><b>{{'bagout.included_items' | translate}}</b> | {{shipment.bagout | translate}} {{model.bagOutId}}</span>\n</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.bagoutList.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>{{'common.tracking_id' | translate}}</th>\n<th>{{'bagout.fromLocation' | translate}}</th>\n<th>{{'denomination.shiptype' | translate}}</th>\n<th>{{'branch_mgmt.amount' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.bagoutList track by $index\">\n<td><a href=\"#\" ng-click=\"goToItemHistory(data.trackingId)\"> {{data.trackingId}}</a></td>\n<td>\n<a href=\"#\" ng-click=\"goToServiceHistory(data.fromLocationId)\">{{data.fromLocationId}}</a> | {{data.fromLocationName}}\n</td>\n<td>{{data.shiptypeId}}</td>\n<td>{{data.amount | currency}}</td>\n</tr>\n</tbody>\n</table>\n<div class=\"margin-10\" ng-if=\"model.totalRecords > 10 && !model.loading\">\n<ul class=\"remove-bottom-margin\" uib-pagination total-items=\"model.totalRecords\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"pagination.page\" ng-change=\"pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n<div ng-if=\"!model.bagoutList.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.bagoutList.length}\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="bagoutList.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2509 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'branch_mgmt.item_holds.bagouts_on_hold' | translate}} | {{model.branchId}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row\" ng-if=\"model.loading\">\n<div class=\"col-sm-12 text-align-center\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n</div>\n<div class=\"modal-body remove-pad\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.bagoutData.length && !model.loading\">\n<thead>\n<tr>\n<th><b>{{'verifyHoldShipments.item' | translate}}</b></th>\n<th><b>{{'branch_mgmt.item_holds.vaultDate' | translate}}</b></th>\n<th><b>{{'bagout.fromLocation' | translate}}</b></th>\n<th><b>{{'bagout.toLocation' | translate}}</b></th>\n<th><b>{{'common.reason' | translate}}</b></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in model.bagoutData\">\n<td>{{shipment.trackingId}}</td>\n<td>{{shipment.vaultDate | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td>{{shipment.fromLocationId}} | {{shipment.fromLocationName}}</td>\n<td>{{shipment.toLocationId}} | {{shipment.toLocationName}}</td>\n<td class=\"text-danger\">{{shipment.reason}}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.bagoutData.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center alert-danger remove-bottom-margin\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" ng-disabled=\"model.loading || !model.bagoutData.length\" type=\"button\" ng-click=\"ok()\">{{ 'common.update' | translate }}</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">{{ 'common.cancel' | translate }}</button>\n</div>";
var id1="bagoutsOnHoldList.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'branch_mgmt.daily_balance_sheet.title' | translate}} | {{label}} </h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"row\">\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 text-align-center\" ng-if=\"!loading && model.data.infoFor !== 'receivedBulkCash' && model.data.infoFor !== 'beginPosition' && model.data.infoFor !== 'endPosition' && model.data.infoFor !== 'actualDepositsCounted'\">\n<div class=\"card card-margin\" ng-repeat=\"sheetInfo in model.sheetInfo\" ng-if=\"sheetInfo.value && sheetInfo.value !== 0\">\n<div class=\"card-body\">\n<img ng-if=\"!sheetInfo.notCaptured && sheetInfo.denominationId !== '1'\" ng-src=\"assets/images/{{sheetInfo.denominationId}}.png\" class=\"custom-icon img-width\"/>\n<img ng-if=\"!sheetInfo.notCaptured && sheetInfo.denominationId == '1'\" src=\"" + __webpack_require__(68) + "\" class=\"custom-icon img-width\"/>\n<img ng-if=\"sheetInfo.notCaptured\" ng-src=\"assets/images/Doller.png\" class=\"custom-icon img-width\" title=\"{{'branch_mgmt.daily_balance_sheet.denomNotCaptured' | translate}}\" alt=\"{{'branch_mgmt.daily_balance_sheet.denomNotCaptured' | translate}}\"/>\n</div>\n<div class=\"img_paddding\" style=\"border-top: 1px solid #e0e0e0;\" ng-class=\"{'dvb-credit-amount-color': sheetInfo.value > 0, 'dvb-debit-amount-color': sheetInfo.value < 0}\">\n<p class=\"card-text padding-left-right remove-bottom-margin\" ng-if=\"!sheetInfo.coinFlag\">\n{{ sheetInfo.value | currency: (sheetInfo.symbol || currency): 2}}\n</p>\n<p class=\"card-text padding-left-right remove-bottom-margin\" ng-if=\"sheetInfo.coinFlag\">\n{{ sheetInfo.value | currency: (sheetInfo.symbol || currency): 2}}\n</p>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 text-align-center\" ng-if=\"!loading && (model.data.infoFor === 'beginPosition' || model.data.infoFor === 'endPosition' || model.data.infoFor === 'actualDepositsCounted')\">\n<div class=\"card card-margin\" ng-repeat=\"sheetInfo in model.sheetInfo | orderBy:['sortOrder', 'faceValue'] track by $index\" ng-if=\"sheetInfo.value && sheetInfo.value !== 0\">\n<div class=\"card-body\">\n<denom-icon denom-id=\"sheetInfo.denominationId\" icon-size=\"30\"></denom-icon>\n</div>\n<div class=\"img_paddding\" style=\"border-top: 1px solid #e0e0e0;\" ng-class=\"{'dvb-credit-amount-color': sheetInfo.value > 0, 'dvb-debit-amount-color': sheetInfo.value < 0}\">\n<p class=\"card-text padding-left-right remove-bottom-margin\" ng-if=\"!sheetInfo.coinFlag\">\n{{ sheetInfo.value | currency: (sheetInfo.symbol || currency): 2}}\n</p>\n<p class=\"card-text padding-left-right remove-bottom-margin\" ng-if=\"sheetInfo.coinFlag\">\n{{ sheetInfo.value | currency: (sheetInfo.symbol || currency): 2}}\n</p>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 text-align-center\" ng-if=\"!loading && model.data.infoFor === 'receivedBulkCash'\">\n<div class=\"card card-margin\" ng-repeat=\"data in model.dvbDetails\">\n<div class=\"card-body\">\n<img ng-if=\"data.denominationId !== '1'\" ng-src=\"assets/images/{{data.denominationId}}.png\" class=\"custom-icon img-width\"/>\n<img ng-if=\"data.denominationId == '1'\" src=\"" + __webpack_require__(68) + "\" class=\"custom-icon img-width\"/>\n</div>\n<div class=\"img_paddding\" style=\"border-top: 1px solid #e0e0e0;\" ng-class=\"{'dvb-credit-amount-color': data.amount > 0, 'dvb-debit-amount-color': data.amount < 0}\">\n<p class=\"card-text padding-left-right remove-bottom-margin\" ng-if=\"!data.coinFlag\">\n{{ data.amount | currency: (data.symbol || currency): 2}}\n</p>\n<p class=\"card-text padding-left-right remove-bottom-margin\" ng-if=\"data.coinFlag\">\n{{ data.amount | currency: (data.symbol || currency): 2}}\n</p>\n</div>\n</div>\n</div>\n</div>\n<span ng-if=\"!loading && (model.data.infoFor === 'beginPosition' || model.data.infoFor === 'endPosition')\"><hr></span>\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"!loading && (model.data.infoFor === 'beginPosition' || model.data.infoFor === 'endPosition')\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'transaction_log.denomination' | translate}}</th>\n<th class=\"text-center\">{{'atm_residual.amount' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"sheetInfo in model.sheetInfo | orderBy:['sortOrder', 'faceValue'] track by $index\" ng-if=\"sheetInfo.value && sheetInfo.value !== 0\">\n<td class=\"text-center\">\n<denom-icon denom-id=\"sheetInfo.denominationId\" icon-size=\"26\"></denom-icon>\n</td>\n<td class=\"text-center\">\n{{ sheetInfo.value | currency: (sheetInfo.symbol || currency): 2}}\n</td>\n</tr>\n</tbody>\n</table>\n<span ng-if=\"model.dvbDetails.length && !loading && ['depositsPendingCount', 'pendingResidualCount', 'receivedBulkCash'].indexOf(model.data.infoFor) == -1\"><hr></span>\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.dvbDetails.length && !loading && !['depositsPendingRelease', 'receivedBulkCash', 'actualDepositsCounted'].includes(model.data.infoFor)\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\" ng-if=\"model.showLocId\">{{'atm_codes_mgmt.location_id' | translate}}</th>\n<th class=\"text-center\">{{'common.tracking_id' | translate}}</th>\n<th class=\"text-center\">{{'itemHolds.orderNo' | translate}}</th>\n<th class=\"text-center\" ng-if=\"['packableOrdersPacked', 'packableOrdersPackedAlltime'].indexOf(model.data.infoFor) >= 0\">\n{{'transaction_log.denomination' | translate}}\n</th>\n<th class=\"text-center\">{{'atm_residual.amount' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"data in model.dvbDetails track by $index\">\n<td ng-if=\"data.locationId\">\n<a href=\"#\" ng-click=\"goToServiceHistory(data.locationId)\">{{data.locationId}}</a>\n</td>\n<td>\n<a href=\"#\" ng-click=\"goToItemOrDepositPackHistory(data.trackingId)\">{{data.trackingId}}</a>\n</td>\n<td>\n<a href=\"#\" ng-click=\"goToOrderHistory(data.orderNo)\" ng-if=\"data.orderNo\">{{data.orderNo}}</a>\n<span ng-if=\"!data.orderNo\">{{'common.n_a' | translate}}</span>\n</td>\n<td ng-if=\"['packableOrdersPacked', 'packableOrdersPackedAlltime'].indexOf(model.data.infoFor) >= 0\">{{data.denominationId}}</td>\n<td>{{ findAmount(data) | currency: (data.symbol || currency) }}</td>\n</tr>\n</tbody>\n</table>\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.dvbDetails.length && !loading && model.data.infoFor === 'actualDepositsCounted'\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\" ng-if=\"model.showLocId\">{{'atm_codes_mgmt.location_id' | translate}}</th>\n<th class=\"text-center\">{{'common.tracking_id' | translate}}</th>\n<th class=\"text-center\">{{'common.total' | translate}}</th>\n<th class=\"text-center\">{{'transaction_log.denomination' | translate}}</th>\n<th class=\"text-center\">{{'atm_residual.amount' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"data in model.dvbDetails track by $index\">\n<td ng-if=\"data.locationId && data.showGroupCells\" rowspan=\"{{data.groupRowSpan}}\">\n<a href=\"#\" ng-click=\"goToServiceHistory(data.locationId)\">{{data.locationId}}</a>\n</td>\n<td ng-if=\"data.showGroupCells\" rowspan=\"{{data.groupRowSpan}}\">\n<a href=\"#\" ng-click=\"goToItemOrDepositPackHistory(data.trackingId)\">{{data.trackingId}}</a>\n</td>\n<td ng-if=\"data.showGroupCells\" rowspan=\"{{data.groupRowSpan}}\">{{ data.depositTotalAmount | currency: (data.symbol || currency) }}</td>\n<td>\n<denom-icon denom-id=\"data.denominationId\" icon-size=\"26\"></denom-icon>\n</td>\n<td>{{ findAmount(data) | currency: (data.symbol || currency) }}</td>\n</tr>\n</tbody>\n</table>\n<span ng-if=\"model.dvbDetails.length && !loading && model.data.infoFor === 'receivedBulkCash'\"><hr></span>\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.dvbDetails.length && !loading && model.data.infoFor === 'receivedBulkCash'\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'transaction_log.denomination' | translate}}</th>\n<th class=\"text-center\">{{'atm_residual.amount' | translate}}</th>\n<th class=\"text-center\">{{'common.total' | translate}}</th>\n<th class=\"text-center\">{{'common.comment' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"data in model.dvbDetails track by $index\">\n<td>\n<denom-icon denom-id=\"data.denominationId\" icon-size=\"26\"></denom-icon>\n</td>\n<td>{{ findAmount(data) | currency: (data.symbol || currency) }}</td>\n<td ng-if=\"data.showGroupCells\" rowspan=\"{{data.groupRowSpan}}\">{{ data.transactionTotalValue | currency: (data.symbol || currency) }}</td>\n<td ng-if=\"data.showGroupCells\" rowspan=\"{{data.groupRowSpan}}\">{{ data.comment || ('common.n_a' | translate) }}</td>\n</tr>\n</tbody>\n</table>\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.dvbDetails.length > 0 && !loading && model.data.infoFor === 'depositsPendingRelease'\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'branch_mgmt.daily_balance_sheet.deposit_id' | translate}}</th>\n<th class=\"text-center vault-date-column-width\">{{'common.vault_date' | translate}}</th>\n<th class=\"text-center vault-date-column-width\">{{'common.vault_date' | translate}} {{'routeControl.released' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.daily_balance_sheet.released_at' | translate}}</th>\n<th class=\"text-center\">{{'atm_residual.amount' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"data in model.dvbDetails track by $index\">\n<td>{{data.id}} </td>\n<td>{{data.vaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</td>\n<td>{{data.vaultDateReleased | date: 'yyyy-MM-dd' : 'UTC'}}</td>\n<td>{{data.releasedAt | date: 'yyyy-MM-dd | hh:mm a'}}</td>\n<td>{{ findAmount(data) | currency: (data.symbol || currency) }}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"(model.dvbDetails.length == 0 && ['depositsPendingCount', 'pendingResidualCount'].indexOf(model.data.infoFor) >= 0) && !loading\">\n<div class=\"col-sm-12 alert text-center alert-danger remove-bottom-margin\">\n{{'location.no_record_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success pull-left\" type=\"button\" ng-click=\"exportData()\" ng-if=\"model.isExist\" ng-disabled=\"exporting || (model.dvbDetails.length == 0 && ['depositsPendingCount', 'pendingResidualCount'].indexOf(model.data.infoFor) >= 0)\">\n{{ 'branch_mgmt.daily_balance_sheet.export' | translate }}\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': exporting}\"></span>\n</button>\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\">{{ 'common.close' | translate }}\n</button>\n</div>\n";
var id1="balanceSheetInfo.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2511 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"billableEventLogTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{ 'log.menu.title' | translate }} |\n<span ng-if=\"!model.searchText.trackingId && !model.searchText.encounterId && !model.searchText.billingId\">{{model.locationId}}</span>\n<a href=\"#\" ng-click=\"goToItemHistory(model.searchText)\">{{model.searchText.trackingId || model.searchText.encounterId || model.searchText.billingId}}</a></h4>\n</div>\n<div class=\"text-align-center margin-top-10\" ng-class=\"{'margin-bottom-10': model.loading}\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" ng-class=\"{'remove-pad': model.loading}\">\n<div class=\"panel panel-default margin-bottom-20\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\" ng-if=\"!model.loading && model.billingRecordDetails.customerContractId\">\n<div class=\"panel-heading cust-panel-color\" data-toggle=\"collapse\" aria-expanded=\"true\" ng-class=\"{ 'log-warning': log.flagged }\" ng-if=\" model.billingRecordDetails.customerContractId\">\n<h4 class=\"panel-title cursor-pointer\">\n<a class=\"accordion-toggle\">\n<strong>{{'customer.contractDetails' | translate}} </strong>\n</a>\n</h4>\n</div>\n<div class=\"panel-collapse multi-collapse collapse in\" aria-expanded=\"true\">\n<div class=\"panel-body\">\n<table class=\"table table-bordered table-striped remove-bottom-pad\">\n<tr>\n<td>{{'contract.contractId' | translate}}</td>\n<td><a href=\"#\" ng-click=\"goToContractRuleTab(model.billingRecordDetails.customerContractId)\">{{model.billingRecordDetails.customerContractId}}</a></td>\n</tr>\n<tr>\n<td>{{'contract.contractName' | translate}}</td>\n<td>{{model.billingRecordDetails.contractName}}</td>\n</tr>\n<tr>\n<td>{{'contract.billing_rule' | translate}}</td>\n<td>{{model.billingRecordDetails.contractRuleName}}</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n<div class=\"panel panel-default margin-bottom-10\" ng-repeat=\"log in model.logDetails track by $index\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"panel-heading cust-panel-color\" data-toggle=\"collapse\" aria-expanded=\"true\" ng-class=\"{ 'log-warning': log.flagged }\">\n<h4 class=\"panel-title cursor-pointer\">\n<a class=\"accordion-toggle\">\n<strong>{{log.readableEntryType + ' '}} </strong>\n<span ng-if=\"log.userId\">{{'log.by' | translate}}</span>\n{{' ' + log.firstName + ' ' + log.lastName + ' '}}\n<span ng-if=\"log.message\"> | <span class=\"message-color\">{{log.message}}</span></span>\n<span class=\"pull-right\">{{log.createdAt | date: 'short'}}</span>\n</a>\n</h4>\n</div>\n<div class=\"panel-collapse multi-collapse collapse in\" aria-expanded=\"true\">\n<div class=\"panel-body\">\n<table class=\"table table-bordered table-striped remove-pad-bottom\">\n<tr ng-repeat=\"detail in log.extraDetails\">\n<td>{{detail.key}}</td>\n<td class=\"wrap-text\">\n<span ng-if=\"(detail.key !== 'pickupImageName' && detail.key !== 'deliveryImageName')\">{{detail.value}}</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value !=='null') || (detail.key === 'deliveryImageName' && detail.value !=='null')\">Captured</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value =='null') || (detail.key === 'deliveryImageName' && detail.value =='null')\">\n{{'common.n_a'| translate}}\n</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value !=='null') || (detail.key === 'deliveryImageName' && detail.value !=='null')\">\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"showShipmentReceipt(log.extraDetails, detail.key == 'pickupImageName' ? 'pickup': 'delivery')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n<div class=\"text-align-center\" ng-if=\"!model.loading && model.errorMsg\">\n<div class=\"alert alert-danger remove-bottom-pad _margin-10\">\n{{ model.errorMsg | translate}}\n</div>\n</div>\n<div class=\"text-align-center\" ng-if=\"!model.loading && !model.logDetails.length && !model.errorMsg\">\n<div class=\"alert alert-danger remove-bottom-pad _margin-10\">\n{{ 'log.noLogs' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'branch_mgmt.item_holds.close' | translate }}\n</button>\n</div>\n</form>\n";
var id1="billableEventLog.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2512 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"billingContractRulesModal\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'contract.contract' | translate}}</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!model.loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"_form-group col-sm-12\">\n<table class=\"remove-bottom-margin table table-striped table-bordered\">\n<thead>\n<th>{{'billableEvents.billing_events' | translate}}</th>\n<th>{{'location.locationType' | translate }}</th>\n<th>{{'branch_mgmt.item_orderType' | translate }}</th>\n<th>{{'billableEvents.billing_type' | translate}}</th>\n<th>{{'billableEvents.billing_rate' | translate}}</th>\n</thead>\n<tbody>\n<tr ng-repeat=\"contractRule in model.contractRulesOptions\">\n<td>\n<div>\n<select class=\"form-control\" ng-model=\"contractRule.billingEvent\" ng-options=\"item as item.label for item in model.billingEventOptions track by item.key\" ng-change=\"orderTypeOptionChanged(contractRule, $index)\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">{{'common.none' | translate }}</option>\n</select>\n</div>\n</td>\n<td>\n<select class=\"form-control\" ng-model=\"contractRule.locationType\" ng-change=\"validateItemRange()\" ng-options=\"item as item.label for item in model.locationTypeOptions track by item.value\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">{{'common.select' | translate }}</option>\n</select>\n</td>\n<td>\n<select class=\"form-control\" ng-model=\"contractRule.orderType\" ng-change=\"validateItemRange()\" ng-options=\"option as option.label for option in contractRule.options\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">{{'common.select' | translate }}</option>\n</select>\n</td>\n<td class=\"col-sm-3\">\n<select class=\"form-control\" ng-model=\"contractRule.billingTypeObj.billingType\" ng-options=\"option as option.label for option in contractRule.billingTypeOptions\" ng-change=\"billingRateOptionChanged(contractRule, $index)\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">{{'common.select' | translate }}</option>\n</select>\n<div class=\"margin-top-05\" ng-if=\"contractRule.billingTypeObj.billingType.value === 'ITEM_RANGE' || \n                                        contractRule.billingTypeObj.billingType.value === 'VALUE_LIMIT'\">\n<div>\n<input type=\"number\" min=\"1\" class=\"form-control\" placeholder=\"{{'common.min' | translate}}\" ng-class=\"{'invalid-field-section': model.billingRangeError || model.itemRangeError}\" ng-model=\"contractRule.billingTypeObj.min\" ng-change=\"validateBillingTypeRange(contractRule, $index); validateItemRange()\" required>\n</div>\n<div class=\"margin-top-05\">\n<input type=\"number\" min=\"1\" class=\"form-control\" placeholder=\"{{'common.max' | translate}}\" ng-model=\"contractRule.billingTypeObj.max\" ng-change=\"validateBillingTypeRange(contractRule, $index)\" required>\n</div>\n</div>\n<div class=\"margin-top-05\" ng-if=\"contractRule.billingTypeObj.billingType.value === 'TIME_RANGE'\">\n<div>\n<time-picker ng-model=\"contractRule.billingTypeObj.beginTime\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"validateBillingTypeRange(contractRule, $index)\" required placeholder=\"Begin Time\" is-meridian=\"false\" show-spinners=\"false\" ng-class=\"{'invalid-field-section': model.billingRangeError}\" show-seconds=\"true\" display-time-format=\"false\">\n</time-picker>\n</div>\n<div class=\"margin-top-05\">\n<time-picker ng-model=\"contractRule.billingTypeObj.endTime\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"validateBillingTypeRange(contractRule, $index)\" required placeholder=\"End Time\" show-seconds=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n</div>\n<div class=\"margin-top-05\" ng-if=\"contractRule.billingTypeObj.billingType.value === 'AMOUNT_RANGE'\">\n<div>\n<input type=\"text\" ng-currency required class=\"form-control\" placeholder=\"{{'common.min' | translate}}\" ng-change=\"validateBillingTypeRange(contractRule, $index)\" ng-model=\"contractRule.billingTypeObj.minAmount\" ng-class=\"{'invalid-field-section': model.billingRangeError}\">\n</div>\n<div class=\"margin-top-05\">\n<input type=\"text\" ng-currency required class=\"form-control\" placeholder=\"{{'common.max' | translate}}\" ng-change=\"validateBillingTypeRange(contractRule, $index)\" ng-model=\"contractRule.billingTypeObj.maxAmount\">\n</div>\n</div>\n</td>\n<td class=\"col-sm-2\">\n<div class=\"_margin-top-05\">\n<div>\n<input type=\"text\" ng-currency required class=\"form-control\" placeholder=\"$0.00\" ng-model=\"contractRule.billingRateObj.rate\">\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"remove-pad col-sm-12\" ng-if=\"model.billingRangeError\">\n<div class=\"margin-10 text-center alert alert-danger remove-bottom-margin\">{{model.billingRangeError}}</div>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-if=\"model.itemRangeError && !model.billingRangeError\">\n<div class=\"margin-10 text-center alert alert-danger remove-bottom-margin\">{{model.itemRangeError}}</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"billingContractRulesModal.$invalid || model.billingRangeError\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>\n<style>\n.uib-timepicker .hours .ng-valid {\n        pointer-events: none;\n        background: gainsboro;\n        /* display: none; */\n    }\n\n    .uib-timepicker .hours .ng-invalid {\n        pointer-events: none;\n        background: gainsboro;\n        /* display: none; */\n    }\n\n    /* .horizontal-padding-10 {\n        padding: 0px 29px;\n    } */\n</style>";
var id1="billingContractRules.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2513 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'orderPacking.denominations' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 450px; overflow-y: auto;\">\n<div class=\"row\" style=\"margin-bottom: 15px; padding: 10px; background-color: #f8f9fa; border-radius: 5px;\" ng-show=\"!loading && hasDenominations()\">\n<div class=\"col-sm-12\">\n<div class=\"form-check\">\n<input class=\"form-check-input\" type=\"checkbox\" id=\"selectAllCheckbox\" ng-model=\"selectAll\" ng-change=\"toggleSelectAll()\" style=\"transform: scale(1.2);\">\n<label class=\"form-check-label\" for=\"selectAllCheckbox\" style=\"margin-left: 8px; font-size: 16px;\">\n<strong>{{'denomination.select_all_deselect_all' | translate}}</strong>\n</label>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"!loading && !hasDenominations()\">\n<div class=\"col-sm-12\">\n<div class=\"alert alert-info text-center\" style=\"margin: 20px 0;\">\n<i class=\"glyphicon glyphicon-info-sign\" style=\"margin-right: 8px;\"></i>\n<strong>{{'denomination.no_denominations_available' | translate}}</strong>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"text-align-center\" ng-show=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 text-align-center _remove-pad\" ng-show=\"!loading && hasDenominations()\">\n<div class=\"card bfs-denom-card-section _card-margin\" ng-repeat=\"(key, val) in model.denominationObj.results\">\n<div class=\"denomination-key-section\">{{key}}</div>\n<div class=\"card bfs-denom-card-section _card-margin\" ng-repeat=\"denom in val\">\n<input class=\"form-check-input\" type=\"checkbox\" id=\"flexCheckChecked\" ng-model=\"denom.isDenomSelected\" ng-change=\"validateMultiDenom(denom); updateSelectAllState()\">\n<div class=\"_card-body icon-height-50 col-sm-12 padding-10\" ng-if=\"denom.isIconExists\">\n<img ng-src=\"assets/images/{{denom.id}}.png\" class=\"custom-icon img-width\">\n</div>\n<div class=\"_card-body icon-height-50 col-sm-12 padding-15\" ng-if=\"!denom.isIconExists\">\n<span class=\"custom-icon img-width\">{{denom.id}}</span>\n</div>\n<div style=\"border-top: 1px solid #e0e0e0; display: flex; flex-direction: column; gap: 4px; padding: 4px;\">\n<button id=\"multiDenomAllowed\" type=\"button\" class=\"btn btn-xs\" ng-disabled=\"!denom.isDenomSelected || !isMultiDenomAllowed(denom)\" ng-class=\"{'btn-default': !denom.multiDenomAllowed, 'btn-success': denom.multiDenomAllowed}\" ng-click=\"toggleMultiDenom(denom)\">{{'denomination.multi_denom_button' | translate}}</button>\n<button id=\"customerOrderable\" type=\"button\" class=\"btn btn-xs\" ng-disabled=\"!denom.isDenomSelected\" ng-class=\"{'btn-default': !denom.customerOrderable, 'btn-primary': denom.customerOrderable}\" ng-click=\"toggleCustomerOrderable(denom)\">{{'denomination.cust_order' | translate}}</button>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"loading || !hasDenominations()\">{{ 'common.ok' | translate }}</button>\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\">{{ 'common.close' | translate }}</button>\n</div>\n";
var id1="branchFundingSourceDenominations.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2514 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"branchMgmtBagoutCloseTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"chkTitle\">{{'bagout.closeBagout' | translate}} | <b>{{model.bagoutObj.bagoutId}}</b></h4>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 modal-body\" id=\"modal-body\">\n<div class=\"col-sm-6\">\n<label>{{'bagout.route' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"model.routeId\" ng-options=\"route.name as route.id for route in model.routeList\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">{{'checkinSelectionModal.select' | translate}}</option>\n</select>\n</div>\n<div class=\"col-sm-6 common-date-picker-section\">\n<label for=\"deliveryDate\">{{'routeThrow.deliveryDate' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"delivery-date\" ng-model=\"model.deliveryDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.deliveryDate}\" ng-keydown=\"$event.preventDefault()\" date-options=\"minVaultDate\">\n</datetimepicker>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"model.loading || branchMgmtBagoutCloseTemplate.$invalid\">\n{{'common.ok' | translate}}\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n</div>\n</form>";
var id1="branchMgmtCloseBagout.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2515 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"branchTransferTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'branch_mgmt.branch_transfer' | translate }}</strong> <span ng-if=\"model.shipmentData\">| {{ model.shipmentData.trackingId }}</span>\n</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!model.loading\" class=\"list-group\" style=\"width: 100%; max-height: 450px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group col-sm-12\" ng-if=\"model.allBranch.length\" style=\"margin-bottom: 0px;\">\n<label>{{ 'common.branch_id' | translate }} *</label>\n<select class=\"form-control\" ng-model=\"model.selectedBranch\" ng-change=\"onBranchChange()\" ng-options=\"branch.id as branch.id for branch in model.allBranch\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-12\" style=\"margin-bottom: 0;margin-top: 10px;\" ng-if=\"model.selectedBranch\">\n<label>{{ 'common.vault_date' | translate }} *</label>\n<datetimepicker class=\"datetimepicker-input common-date-picker-section\" id=\"start-date\" name=\"date\" ng-model=\"model.date\" date-format=\"dd-MMM-yyyy\" ng-change=\"onVaultDateChange()\" hidden-time=\"true\" date-options=\"minVaultDate\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.date}\" ng-keydown=\"$event.preventDefault()\" ng-required=\"true\" datepicker-append-to-body=\"true\" dropdown-append-to-body=\"true\" append-to-body=\"true\" show-button-bar=\"false\" ng-disabled=\"model.isGettingRoutes || model.isGettingLocationRoutes || model.loading\">\n</datetimepicker>\n</div>\n<div class=\"form-group col-sm-12\" style=\"margin-bottom: 0;margin-top: 10px;\" ng-if=\"model.selectedBranch\">\n<label>{{ 'checkout.route' | translate }} *</label>\n<search-and-select ng-model=\"model.routeId\" values=\"model.routeList\" key=\"Key\" totalrecords=\"model.routeTotalRecords\" onscroll=\"reloadRouteData(searchKey, offset)\" none-selected=\"'common.none'\" required ng-disabled=\"model.isGettingRoutes || model.isGettingLocationRoutes || model.loading\"></search-and-select>\n</div>\n<div class=\"_form-group col-sm-12 margin-top-10\">\n<label>{{ 'locationHold.comment' | translate }}</label>\n<textarea class=\"form-control\" rows=\"3\" ng-model=\"model.comment\" style=\"border-radius: 5px\"></textarea>\n</div>\n<div class=\"col-sm-12\" ng-if=\"model.sameTransferError\">\n<div class=\"alert alert-danger\" style=\"margin-bottom: 10px;margin-top: 20px;\">\n{{'branch_mgmt.same_transfer_error' | translate}}\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"branchTransferTemplate.$invalid || model.loading || model.isGettingRoutes || model.isGettingLocationRoutes || model.sameTransferError\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>\n{{'common.transfer' | translate }}\n</button>\n</div>\n</form>";
var id1="branchTransfer.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2516 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"bulkCashAdjustCommentFrom\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\"><strong></strong>{{'common.comment' | translate}}</h4>\n</div>\n<div ng-if=\"!loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group col-sm-12 remove-bottom-margin\">\n<label>{{'bulkCash.please_enter_comment' | translate}} *</label>\n<textarea class=\"form-control\" id=\"bulk-cash-adjust-comment\" rows=\"3\" ng-model=\"model.comment\" style=\"border-radius: 5px\" required></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"bulkCashAdjustCommentFrom.$invalid || model.loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>\n{{'common.commit' | translate}}\n</button>\n</div>\n</form>";
var id1="bulkCashAdjustComment.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2517 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"bulkImportLocationTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'location.menu.import_locations' | translate }}\n<span ng-if=\"model.contractName\"> | {{model.contractName}}</span>\n</h4>\n</div>\n<div class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"_form-group col-sm-12\">\n<div class=\"alert alert-info remove-bottom-margin\">\n<i class=\"glyphicon glyphicon-info-sign\"></i> <span> Add comma separated string (e.g \"RT0001, RT0002, RT0003\")\n</span>\n</div>\n<textarea class=\"form-control margin-10\" rows=\"5\" ng-model=\"model.locations\" style=\"border-radius: 5px\" ng-pattern='/^\"([a-z0-9\\s]+,)*([a-z0-9\\s]+)\"{1}$/i'></textarea>\n</div>\n<div class=\"col-sm-12 margin-10\" ng-if=\"model.errorMessage && !model.loading\">\n<div class=\"col-sm-12 alert text-center alert-danger remove-bottom-margin\">\n{{model.errorMessage}}\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"bulkImportLocationTemplate.$invalid || !model.locations\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>\n";
var id1="bulkImportLocation.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2518 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\">\n<h4 class=\"modal-title\" id=\"modal-title-top\">{{'users.update_user' | translate}}</h4>\n</div>\n<style>\n.dropdown-overlay .multi-select-options {\n        position: absolute;\n        z-index: 1000;\n        width: 100%;\n        background: white;\n        border: 1px solid #ccc;\n        box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n    }\n</style>\n<div class=\"modal-body\" id=\"modal-body-top\" style=\"overflow: visible;\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"\">{{'common.user' | translate}}</label><br/>\n<div class=\"btn-group\">\n<label class=\"btn btn-default\" ng-class=\"{'btn-primary': model.isCustomerUser}\" ng-model=\"model.isCustomerUser\" uib-btn-radio=\"true\" ng-click=\"setUserType(true)\">{{'users.customer_user' | translate}}</label>\n<label class=\"btn btn-default\" ng-class=\"{'btn-primary': !model.isCustomerUser}\" ng-model=\"model.isCustomerUser\" uib-btn-radio=\"false\" ng-click=\"setUserType(false)\">{{'users.webUser' | translate}}</label>\n</div>\n</div>\n</div>\n</div>\n<div class=\"form-validate\">\n<div class=\"row\">\n<div class=\"col-sm-3\">\n<div class=\"form-group checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"model.selectPermission\" ng-change=\"onSelectPermissionChange()\"/>\n<strong>{{'users.selectPermission' | translate}}</strong>\n</label>\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"model.updatePassword\" ng-change=\"onUpdatePasswordChange()\"/>\n<strong>{{'users.updatePassword' | translate}}</strong>\n</label>\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"model.updateFundingSource\" ng-change=\"onUpdateFundingSourceChange()\"/>\n<strong>{{'users.updateFundingSource' | translate}}</strong>\n</label>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-6\" ng-if=\"!model.selectPermission && !isOnlyPasswordUpdate() && (!model.updateFundingSource || (model.cloneFromUserId && model.cloneFromUserId.id))\">\n<div class=\"form-group\" style=\"margin-bottom: 0;\">\n<label for=\"cloneFromUser\">{{'users.cloneFromUser' | translate}}</label>\n<search-and-select ng-model=\"model.cloneFromUserId\" values=\"fromUsersObj.results\" key=\"Key\" totalrecords=\"fromUsersObj.totalRecords\" onscroll=\"getFromUsersList(searchKey, offset);\" ng-disabled=\"fromUsersObj.loading\" none-selected=\"'common.none'\" on-click=\"onCloneFromUserChange()\" ng-required=\"!model.selectPermission\">\n</search-and-select>\n<i class=\"fa fa-spinner fa-spin text-primary\" ng-if=\"fromUsersObj.loading\" style=\"position: absolute; right: 25px; top: 32px;\"></i>\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\" style=\"margin-bottom: 0;\">\n<label for=\"cloneToUsers\">{{ (model.cloneFromUserId && model.cloneFromUserId.id ? 'users.cloneToUsers' : (model.selectPermission || isOnlyPasswordUpdate() || model.updateFundingSource ? 'users.applyToUsers' : 'users.cloneToUsers')) | translate}}</label>\n<paginated-search-and-select page-limit=\"toUsersObj.pageLimit\" ng-model=\"model.cloneToUsers\" key=\"Key\" total-count=\"toUsersObj.totalRecords\" display-label=\"'Key'\" options=\"toUsersObj.results\" search=\"true\" onscroll=\"getToUsersList(searchKey, offset)\" none-selected=\"\" selected-prefix=\"''\" is-loading=\"toUsersObj.loading\" all-label=\"'Select'\" label-name=\"Key\" toggle-count=\"true\" ng-change=\"onToUsersChange()\" mode=\"'edit'\" class=\"dropdown-overlay\" disabled=\"{{(model.selectPermission || (model.cloneFromUserId && model.cloneFromUserId.id) || isOnlyPasswordUpdate() || model.updateFundingSource) ? '' : 'true'}}\" ng-required=\"model.selectPermission || (model.cloneFromUserId && model.cloneFromUserId.id) || isOnlyPasswordUpdate() || model.updateFundingSource\">\n</paginated-search-and-select>\n</div>\n</div>\n</div>\n</div>\n<ng-form name=\"UserForm\" class=\"form-validate\" style=\"max-height: 55vh; overflow-y: auto; overflow-x: hidden; padding: 5px;\">\n<div class=\"row\" ng-if=\"!isOnlyPasswordUpdate()\">\n<div class=\"col-sm-6\">\n<label for=\"\">{{ 'users.all_branches' | translate }} *</label>\n<div class=\"form-group\">\n<div class=\"multi-select user-multi-select-dd\" ng-class=\"{\n                        'invalid-multi-select-value': model.branch.length == 0,\n                        'valid-multi-select-value': model.branch.length > 0\n                    }\" isteven-multi-select max-labels=\"2\" input-model=\"branchData\" output-model=\"model.branch\" button-label=\"id\" item-label=\"id\" search-property=\"id\" tick-property=\"ticked\" directive-id=\"multi-select-button\" translation=\"localLang\" on-item-click=\"autoSelectSameForAll();\" on-select-all=\"autoSelectSameForAll();\" on-select-none=\"autoSelectSameForAll();\" on-reset=\"autoSelectSameForAll();\" required>\n</div>\n</div>\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"branch\">{{ 'users.default_branches' | translate }} *</label>\n<select id=\"branchId\" class=\"form-control\" required ng-model=\"model.branchId\" ng-options=\"branch.id as branch.id for branch in model.branch\" ng-change=\"model.branchPermission = model.branchId; getBranchPermission(); getSetupDetails(); validateAutoChekInChekOut(); getBranchCounters()\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"row\" ng-if=\"model.updatePassword\">\n<div class=\"form-group col-sm-6\" ng-class=\"{ 'remove-bottom-margin' : isOnlyPasswordUpdate() }\">\n<label for=\"password\">{{'users.password' | translate }} *</label>\n<input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"\" ng-model=\"model.password\" ng-required=\"model.updatePassword\">\n</div>\n<div class=\"form-group col-sm-6\" ng-class=\"{ 'remove-bottom-margin' : isOnlyPasswordUpdate() }\">\n<label for=\"cnfpassword\">{{'users.cnfpassword' | translate }} *</label>\n<input type=\"password\" class=\"form-control\" placeholder=\"\" ng-model=\"model.cnfPassword\" ng-required=\"model.updatePassword\">\n<span ng-show=\"model.password!=model.cnfPassword\" class=\"text-danger\">password mismatch</span>\n</div>\n</div>\n<div class=\"row\" ng-show=\"model.updateFundingSource\">\n<div class=\"col-sm-6\" ng-show=\"model.isCustomerUser\">\n<div class=\"form-group\">\n<label for=\"\">{{'users.customer_title' | translate}} *</label>\n<search-and-select ng-model=\"model.customer\" values=\"customerList\" key=\"Key\" on-click=\"getFundingSource();\" totalrecords=\"totalCustomer\" onscroll=\"getCustomer(searchKey, offset)\" none-selected=\"'common.none'\" ng-required=\"model.isCustomerUser && model.updateFundingSource\">\n</search-and-select>\n</div>\n</div>\n<div ng-class=\"model.isCustomerUser ? 'col-sm-6' : 'col-sm-12'\" ng-if=\"model.branch.length > 0\">\n<div class=\"form-group\">\n<label for=\"\">{{'users.funding_source_title' | translate}}</label>\n<div class=\"multi-select valid-multi-select-value branch-funding-src-dd\" isteven-multi-select max-labels=\"1\" input-model=\"branchFundingSourceGrouped\" output-model=\"model.selectedFundingSource\" button-label=\"name\" item-label=\"label\" search-property=\"name\" tick-property=\"ticked\" group-property=\"msGroup\" directive-id=\"multi-select-button\" translation=\"localLang\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"(model.selectPermission || (model.cloneFromUserId && model.cloneFromUserId.id)) && !isOnlyPasswordUpdate()\">\n<div class=\"col-sm-12\">\n<label class=\"pull-left\" for=\"\">{{ 'users.permission' | translate }} * <i class=\"fa fa-spinner fa-spin text-primary\" ng-if=\"permissionLoading\"></i></label>\n<div class=\"form-group checkbox pull-right\" style=\"margin-top: 0px !important;\" ng-if=\"model.branch.length > 1\">\n<label>\n<input type=\"checkbox\" ng-model=\"model.sameForAll\" ng-click=\"assignPermissions()\"/>\n<strong>{{'users.sameForAllBranch' | translate }}</strong>\n</label>\n</div>\n<div class=\"form-group checkbox pull-right\" style=\"margin-top: 0px !important;margin-right: 10px;\">\n<label>\n<input type=\"checkbox\" ng-model=\"model.applySamePermission\"/>\n<strong>{{'users.applySamePermission' | translate }}</strong>\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'users.applySamePermissionInfo' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n</div>\n<select id=\"branchPermission\" class=\"form-control\" ng-model=\"model.branchPermission\" ng-class=\"{\n                        'invalid-multi-select-value': !model.branchPermission,\n                        'valid-multi-select-value': model.branchPermission\n                    }\" ng-options=\"branch.id as branch.id for branch in model.branch\" ng-change=\"getBranchPermission()\" ng-required=\"(model.selectPermission || (model.cloneFromUserId && model.cloneFromUserId.id)) && !isOnlyPasswordUpdate()\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n<div style=\"max-height: 400px; overflow-y: auto;\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"(parentKey,perm) in permissions\" ng-if=\"!model.isCustomerUser || customerPermissions.indexOf(parentKey) >= 0\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-4 permission-item-container\">\n<input type=\"checkbox\" ng-if=\"model.isCustomerUser && customerPermissions.indexOf(parentKey) >= 0\" ng-checked=\"hasPerm('default_redirect', parentKey) || hasChildDefaultRedirect(parentKey)\" ng-disabled=\"(!hasAnyPerm(parentKey) && !hasChildDefaultRedirect(parentKey)) || (model.cloneFromUserId && model.cloneFromUserId.id)\" ng-click=\"toggleDefaultRedirect(parentKey)\" class=\"default-redirect-checkbox\" uib-tooltip=\"{{ 'users.default_redirect_tooltip' | translate }}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"/>\n<span style=\"vertical-align: middle;\">{{perm.title_key | translate}}</span>\n</div>\n<div class=\"col-sm-8\">\n<div class=\"btn-group pull-right\">\n<button ng-repeat=\"(key,val) in perm.permission\" type=\"button\" class=\"btn btn-sm\" ng-click=\"togglePerm(key,parentKey)\" ng-class=\"{'btn-primary': hasPerm(key,parentKey),'btn-default': !hasPerm(key,parentKey)}\" ng-if=\"!disabledPermissions(parentKey, key) && key !== 'default_redirect'\" ng-disabled=\"model.cloneFromUserId && model.cloneFromUserId.id\">\n<span>{{format(key)}}</span>\n</button>\n</div>\n<button type=\"button\" ng-show=\"perm.child||false\" class=\"btn btn-sm btn-default pull-right margin-right-10\" ng-click=\"toggleExpand(parentKey)\">\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-plus': !expand(parentKey), 'glyphicon-minus':expand(parentKey)}\"></span>\n</button>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n<div class=\"row\" ng-show=\"expand(parentKey)\">\n<div class=\"col-sm-12\">\n<hr/>\n<div class=\"col-sm-12 remove-pad-left remove-pad-right\">\n<ul class=\"remove-bottom-margin list-group\">\n<li class=\"list-group-item\" ng-repeat=\"(childKey,childPermissions) in perm.child\" ng-if=\"!model.isCustomerUser || customerPermissions.indexOf(childKey) >= 0\">\n<div class=\"row align-right-vertically\">\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-5 pull-left remove-pad-left permission-item-container\">\n<input type=\"checkbox\" ng-if=\"model.isCustomerUser && customerPermissions.indexOf(childKey) >= 0\" ng-checked=\"hasPerm('default_redirect', childKey)\" ng-disabled=\"!hasAnyPerm(childKey) || !hasActiveAncestors(childKey) || (model.cloneFromUserId && model.cloneFromUserId.id)\" ng-click=\"toggleDefaultRedirect(childKey)\" class=\"default-redirect-checkbox\" uib-tooltip=\"{{ 'users.default_redirect_tooltip' | translate }}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"/>\n<span style=\"vertical-align: middle;\">{{childPermissions.title_key | translate}}</span>\n</div>\n<div class=\"col-sm-7 remove-right-pad\">\n<div class=\"btn-group pull-right\">\n<button ng-repeat=\"(key,val) in childPermissions.permission\" type=\"button\" class=\"btn btn-sm\" ng-click=\"togglePerm(key,childKey); allowSettings(key,childKey)\" ng-class=\"{'btn-primary': hasPerm(key,childKey),'btn-default': !hasPerm(key,childKey)}\" ng-if=\"!disabledPermissions(childKey, key) && key !== 'default_redirect'\" ng-disabled=\"model.cloneFromUserId && model.cloneFromUserId.id\">\n<span>{{format(key)}}</span>\n</button>\n</div>\n<button type=\"button\" ng-show=\"childPermissions.child || false\" class=\"btn btn-sm btn-default pull-right margin-right-10\" ng-click=\"toggleExpand(childKey)\">\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-plus': !expand(childKey), 'glyphicon-minus':expand(childKey)}\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-show=\"expand(childKey)\">\n<hr/>\n<div class=\"col-sm-12\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"(grandChildKey,grandChildPermissions) in childPermissions.child\" ng-if=\"!model.isCustomerUser || customerPermissions.indexOf(grandChildKey) >= 0\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-6 permission-item-container\">\n<input type=\"checkbox\" ng-if=\"model.isCustomerUser && customerPermissions.indexOf(grandChildKey) >= 0 && grandChildPermissions.permission.hasOwnProperty('default_redirect')\" ng-checked=\"hasPerm('default_redirect', grandChildKey)\" ng-disabled=\"!hasAnyPerm(grandChildKey) || !hasActiveAncestors(grandChildKey) || (model.cloneFromUserId && model.cloneFromUserId.id)\" ng-click=\"toggleDefaultRedirect(grandChildKey)\" class=\"default-redirect-checkbox\" uib-tooltip=\"{{ 'users.default_redirect_tooltip' | translate }}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"/>\n<span style=\"vertical-align: middle;\">{{grandChildPermissions.title_key | translate}}</span>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"btn-group pull-right\">\n<button ng-repeat=\"(key,val) in grandChildPermissions.permission\" type=\"button\" class=\"btn btn-sm\" ng-click=\"togglePerm(key,grandChildKey); allowSettings(key,grandChildKey)\" ng-class=\"{'btn-primary': hasPerm(key,grandChildKey),'btn-default': !hasPerm(key,grandChildKey)}\" ng-if=\"!disabledPermissions(grandChildKey, key) && key !== 'default_redirect'\" ng-disabled=\"model.cloneFromUserId && model.cloneFromUserId.id\">\n<span>{{format(key)}}</span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n</div>\n</ng-form>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"UserForm.$invalid || (model.updatePassword && model.password!=model.cnfPassword) || (!model.cloneToUsers || model.cloneToUsers.length == 0) || (!model.selectPermission && !isOnlyPasswordUpdate() && !model.updateFundingSource && (!model.cloneFromUserId || !model.cloneFromUserId.id))\">{{'common.save' | translate}}</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">{{'common.cancel' | translate}}</button>\n</div>\n";
var id1="bulkUpdateUserPermissions.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2519 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"verifyHoldShipmentsModal\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'verifyHoldShipments.title' | translate}} | {{ 'verifyHoldShipments.comment' | translate }}</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"_form-group col-sm-12\">\n<label>{{ 'verifyHoldShipments.comment' | translate }}</label>\n<textarea class=\"form-control\" rows=\"3\" ng-model=\"model.comment\" style=\"border-radius: 5px\"></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"verifyHoldShipmentsModal.$invalid\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>\n";
var id1="bulkVerifyComment.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2520 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"changeDestinationTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{'shipment.change_destination' | translate}}</strong> <span ng-if=\"model.shipmentData\">\n| {{ model.shipmentData.trackingId }}</span></h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!model.loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group col-sm-12\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branch_mgmt.items.central_bank_tooltip' | translate}}\" tooltip-placement=\"right\"></span>\n<label>{{ 'branch_mgmt.items.locations' | translate }} *</label>\n<search-and-select ng-model=\"model.location\" values=\"model.locationList\" key=\"Key\" totalrecords=\"model.totalLocation\" onscroll=\"getCentralBankLocation(searchKey, offset)\" is-edit=\"true\" none-selected=\"'common.none'\" on-click=\"validateDestination()\" required>\n</search-and-select>\n</div>\n<div class=\"_form-group col-sm-12\">\n<label>{{ 'common.comment' | translate }}</label>\n<textarea class=\"form-control\" rows=\"3\" ng-model=\"model.comment\" style=\"border-radius: 5px\"></textarea>\n</div>\n<div class=\"col-sm-12 margin-top-20\" ng-if=\"model.errorMsg\">\n<div class=\"alert alert-danger remove-bottom-margin\">{{model.errorMsg}}</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"changeDestinationTemplate.$invalid || model.loading || model.errorMsg\">\n{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>\n";
var id1="changeDestination.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2521 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form class=\"form-validate\" name=\"changePasswordForm\" novalidate>\n<change-password event=\"event\" model-details=\"modelDetails\" on-confirm=\"ok\" on-error=\"cancel\"></change-password>\n<button class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" style=\"margin-top: -50px;\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</form>";
var id1="changePassword.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2522 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"changeShiptypeTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'branch_mgmt.items.changeShipType' | translate }}</strong>\n<span ng-if=\"model.shipmentData\">\n| {{ model.shipmentData.trackingId }}</span>\n</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!model.loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"_form-group col-sm-12\">\n<label>{{ 'common.select_shiptype' | translate }}</label>\n<search-and-select ng-model=\"model.shiptype\" values=\"model.shiptypeList\" key=\"Key\" totalrecords=\"model.totalShiptypes\" onscroll=\"loadShipType(searchKey, offset)\" is-edit=\"true\" none-selected=\"'common.none'\" required>\n</search-and-select>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"changeShiptypeTemplate.$invalid || model.loading\">\n{{ 'common.save' | translate }}\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.cancel' | translate }}\n</button>\n</div>\n</form>";
var id1="changeShiptype.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2523 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"chkTitle\">{{ 'routeControl.adHocCheckin' | translate }}<span ng-if=\"bag.trackingId\"> | {{bag.trackingId}}</span></h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" ng-keydown=\"keyPressed($event)\">\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<form ng-submit=\"ok()\" name=\"adHocCheckinForm\" ng-if=\"isSupervisorConfirmed && !loading\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"form-group col-sm-6\">\n<label>{{'addBagModal.trackingId' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"bag.trackingId\" required>\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'addBagModal.shiptype' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"bag.shiptype\" ng-options=\"shiptype as shiptype.title for shiptype in shiptypes\" ng-change=\"shiptypeChanged()\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">(select)</option>\n</select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label>{{'addBagModal.quantity' | translate}} *</label>\n<input type=\"number\" ng-change=\"quantityChanged()\" class=\"form-control\" ng-model=\"bag.qty\" ng-required=\"!bag.shiptype.amountFlag\" ng-disabled=\"!bag.shiptype.coinFlag || !bag.shiptype\" min=\"1\">\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label>{{'addBagModal.amount' | translate}}</label>\n<input id=\"shiptype-amount\" type=\"text\" ng-required=\"bag.shiptype.amountFlag\" ng-currency class=\"form-control\" min=\"0\" ng-model=\"bag.amount\" placeholder=\"$0.00\" ng-disabled=\"bag.shiptype.coinFlag\" ng-keydown=\"$event.keyCode === 13 && (bag.amount) && focusOntoLocation('fromLocation')\" autofocus>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<label for=\"pickupDate\">{{'shipmentBatch.pickupDate' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"pickup-date\" ng-model=\"bag.pickupDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !bag.pickupDate}\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6\">\n<label for=\"pickupTime\">{{'itemHolds.pickupTime' | translate}} *</label>\n<input type=\"time\" class=\"form-control\" ng-model=\"bag.pickupTime\" required>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"row align-center-vertically\">\n<div class=\"form-group col-xs-10 margin-bottom-10\" style=\"padding-right: 0px;\">\n<label>\n{{'addBagModal.fromLocation' | translate}} *\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loadingLocations.fromLocation}\"></span>\n</label>\n<search-and-select ng-if=\"!showAllFromLocations\" ng-model=\"bag.fromLocationId\" values=\"locationLists\" key=\"Key\" totalrecords=\"totalRecords\" ng-click=\"reloadDestinations()\" selected-item=\"reloadDestinations()\" common-search-flag=\"true\" ng-disabled=\"loadingLocations.fromLocation || !bag.shiptype\" none-selected=\"'common.none'\" focus-dropdown-id=\"fromLocation\" ng-keydown=\"$event.keyCode === 13 && focusOntoLocation('toLocation');reloadDestinations($event)\" required>\n</search-and-select>\n<search-and-select ng-if=\"showAllFromLocations\" ng-model=\"bag.fromLocationId\" values=\"allLocationLists\" key=\"Key\" totalrecords=\"alltotalRecords\" onscroll=\"reloadData(searchKey, offset)\" ng-click=\"reloadDestinations()\" selected-item=\"reloadDestinations()\" ng-disabled=\"loadingLocations.fromLocation || !bag.shiptype\" none-selected=\"'common.none'\" focus-dropdown-id=\"fromLocation\" ng-keydown=\"$event.keyCode === 13 && focusOntoLocation('toLocation');reloadDestinations($event);\" required>\n</search-and-select>\n</div>\n<div class=\"col-xs-2 all-toggle-button\">\n<button class=\"btn btn-xs btn-block\" type=\"button\" ng-class=\"{'btn-success': showAllFromLocations, 'btn-default': !showAllFromLocations}\" ng-click=\"toggleAllFromLocations()\">\n{{'addBagModal.all' | translate}}\n</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row align-center-vertically\">\n<div class=\"form-group col-xs-10 margin-bottom-10\" style=\"padding-right: 0px;\">\n<label>\n{{'addBagModal.destination' | translate}} *\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loadingLocations.destination}\"></span>\n</label>\n<search-and-select ng-if=\"!showAllDestinationLocations\" ng-model=\"bag.toLocationId\" values=\"destinationLocationList\" key=\"Key\" totalrecords=\"totalDestinationLocation\" common-search-flag=\"true\" ng-disabled=\"!bag.fromLocationId || loadingLocations.destination\" none-selected=\"'common.none'\" focus-dropdown-id=\"toLocation\" ng-keydown=\"$event.keyCode === 13 && bag.toLocationId && focusOntoLocation('add-bag')\" required>\n</search-and-select>\n<search-and-select ng-if=\"showAllDestinationLocations\" ng-model=\"bag.toLocationId\" values=\"destinationAllLocationList\" totalrecords=\"totalAllDestinationLocation\" key=\"Key\" onscroll=\"reloadDestinationData(searchKey, offset)\" common-search-flag=\"true\" ng-disabled=\"!bag.fromLocationId || loadingLocations.destination\" none-selected=\"'common.none'\" focus-dropdown-id=\"toLocation\" ng-keydown=\"$event.keyCode === 13 && bag.toLocationId && focusOntoLocation('add-bag')\" required>\n</search-and-select>\n</div>\n<div class=\"col-xs-2 all-toggle-button\">\n<button class=\"btn btn-xs btn-block\" type=\"button\" ng-class=\"{'btn-success': showAllDestinationLocations, 'btn-default': !showAllDestinationLocations}\" ng-click=\"toggleAllDestinationLocations()\" ng-disabled=\"!bag.fromLocationId || loadingLocations.destination\">\n{{'addBagModal.all' | translate}}\n</button>\n</div>\n</div>\n</form>\n<div ng-if=\"errorMessage\" class=\"alert alert-danger\" role=\"alert\">\n{{errorMessage}}\n</div>\n</div>\n<form class=\"form-validate\" ng-if=\"!isSupervisorConfirmed\" style=\"margin-top: -29px;\">\n<confirm-supervisor event=\"'add-bag'\" on-confirm=\"supervisorConfirmed\" on-error=\"supervisorCancelled\" button-style=\"!isCancelSupervisorChallange ? 'marginleft88' : ''\">\n</confirm-supervisor>\n<button style=\"margin-top: -49px\" class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\" ng-if=\"isCancelSupervisorChallange\">{{'Cancel' | translate }}\n</button>\n</form>\n<div class=\"modal-footer\" ng-if=\"isSupervisorConfirmed\">\n<button ng-if=\"isSupervisorConfirmed\" class=\"btn btn-primary\" ng-disabled=\"!bag.shiptype || !bag.qty || !bag.fromLocationId || !bag.toLocationId || (bag.shiptype.amountFlag && !bag.amount) || !bag.pickupTime\" ng-class=\"{'disabled': loading || adHocCheckinForm.$invalid}\" type=\"button\" id=\"add-bag\" ng-click=\"ok()\">{{ 'addBagModal.checkIn' | translate }}</button>\n<button ng-if=\"isSupervisorConfirmed\" class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</div>\n";
var id1="checkedInAdHocCheckin.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2524 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"chkTitle\">{{'addBagModal.title' | translate}} {{bag.trackingId}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" ng-keydown=\"keyPressed($event)\">\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<form ng-submit=\"ok()\" name=\"addBagFormForCheckedin\" ng-if=\"isSupervisorConfirmed && !loading\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"form-group col-sm-6\">\n<label>{{'addBagModal.trackingId' | translate}}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"bag.trackingId\" required disabled=\"disabled\">\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'addBagModal.shiptype' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"bag.shiptype\" ng-options=\"shiptype as shiptype.title for shiptype in shiptypes\" ng-change=\"shiptypeChanged()\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">(select)</option>\n</select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label>{{'addBagModal.quantity' | translate}} *</label>\n<input type=\"number\" ng-change=\"quantityChanged()\" class=\"form-control\" ng-model=\"bag.qty\" ng-required=\"!bag.shiptype.amountFlag\" ng-disabled=\"!bag.shiptype.coinFlag || !bag.shiptype\" min=\"1\">\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label>{{'addBagModal.amount' | translate}}</label>\n<input id=\"shiptype-amount\" type=\"text\" ng-required=\"bag.shiptype.amountFlag\" ng-currency class=\"form-control\" min=\"0\" ng-model=\"bag.amount\" placeholder=\"$0.00\" ng-disabled=\"bag.shiptype.coinFlag\" ng-keydown=\"$event.keyCode === 13 && (bag.amount) && focusOntoLocation('fromLocation')\" autofocus>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<label for=\"pickupDate\">{{'shipmentBatch.pickupDate' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"pickup-date\" ng-model=\"bag.pickupDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !bag.pickupDate}\" ng-keydown=\"$event.preventDefault()\" date-options=\"minVaultDate\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6\">\n<label for=\"pickupTime\">{{'itemHolds.pickupTime' | translate}} *</label>\n<input type=\"time\" class=\"form-control\" ng-model=\"bag.pickupTime\" required>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"row align-center-vertically\">\n<div class=\"form-group col-xs-10 margin-bottom-10\" style=\"padding-right: 0px;\">\n<label>\n{{'addBagModal.fromLocation' | translate}} *\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loadingLocations.fromLocation}\"></span>\n</label>\n<search-and-select ng-if=\"!showAllFromLocations\" ng-model=\"bag.fromLocationId\" values=\"locationLists\" key=\"Key\" totalrecords=\"totalRecords\" ng-click=\"reloadDestinations()\" common-search-flag=\"true\" ng-disabled=\"loadingLocations.fromLocation || !bag.shiptype\" none-selected=\"'common.none'\" focus-dropdown-id=\"fromLocation\" ng-keydown=\"$event.keyCode === 13 && focusOntoLocation('toLocation');reloadDestinations($event)\" required>\n</search-and-select>\n<search-and-select ng-if=\"showAllFromLocations\" ng-model=\"bag.fromLocationId\" values=\"allLocationLists\" key=\"Key\" totalrecords=\"alltotalRecords\" onscroll=\"reloadData(searchKey, offset)\" ng-click=\"reloadDestinations()\" ng-disabled=\"loadingLocations.fromLocation || !bag.shiptype\" none-selected=\"'common.none'\" focus-dropdown-id=\"fromLocation\" ng-keydown=\"$event.keyCode === 13 && focusOntoLocation('toLocation');reloadDestinations($event);\" required>\n</search-and-select>\n</div>\n<div class=\"col-xs-2 all-toggle-button\">\n<button class=\"btn btn-xs btn-block\" type=\"button\" ng-class=\"{'btn-success': showAllFromLocations, 'btn-default': !showAllFromLocations}\" ng-click=\"toggleAllFromLocations()\">\n{{'addBagModal.all' | translate}}\n</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row align-center-vertically\">\n<div class=\"form-group col-xs-10 margin-bottom-10\" style=\"padding-right: 0px;\">\n<label>\n{{'addBagModal.destination' | translate}} *\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loadingLocations.destination}\"></span>\n</label>\n<search-and-select ng-if=\"!showAllDestinationLocations\" ng-model=\"bag.toLocationId\" values=\"destinationLocationList\" key=\"Key\" totalrecords=\"totalDestinationLocation\" common-search-flag=\"true\" ng-disabled=\"!bag.fromLocationId || loadingLocations.destination\" none-selected=\"'common.none'\" focus-dropdown-id=\"toLocation\" ng-keydown=\"$event.keyCode === 13 && bag.toLocationId && focusOntoLocation('add-bag')\" required>\n</search-and-select>\n<search-and-select ng-if=\"showAllDestinationLocations\" ng-model=\"bag.toLocationId\" values=\"destinationAllLocationList\" totalrecords=\"totalAllDestinationLocation\" key=\"Key\" onscroll=\"reloadDestinationData(searchKey, offset)\" common-search-flag=\"true\" ng-disabled=\"!bag.fromLocationId || loadingLocations.destination\" none-selected=\"'common.none'\" focus-dropdown-id=\"toLocation\" ng-keydown=\"$event.keyCode === 13 && bag.toLocationId && focusOntoLocation('add-bag')\" required>\n</search-and-select>\n</div>\n<div class=\"col-xs-2 all-toggle-button\">\n<button class=\"btn btn-xs btn-block\" type=\"button\" ng-class=\"{'btn-success': showAllDestinationLocations, 'btn-default': !showAllDestinationLocations}\" ng-click=\"toggleAllDestinationLocations()\" ng-disabled=\"!bag.fromLocationId || loadingLocations.destination\">\n{{'addBagModal.all' | translate}}\n</button>\n</div>\n</div>\n</form>\n<div ng-if=\"errorMessage\" class=\"alert alert-danger\" role=\"alert\">\n{{errorMessage}}\n</div>\n</div>\n<form class=\"form-validate\" ng-if=\"!isSupervisorConfirmed\" style=\"margin-top: -29px;\">\n<confirm-supervisor event=\"'add-bag'\" on-confirm=\"supervisorConfirmed\" on-error=\"supervisorCancelled\" button-style=\"!isCancelSupervisorChallange ? 'marginleft88' : ''\">\n</confirm-supervisor>\n<button style=\"margin-top: -49px\" class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\" ng-if=\"isCancelSupervisorChallange\">{{'Cancel' | translate }}\n</button>\n</form>\n<div class=\"modal-footer\" ng-if=\"isSupervisorConfirmed\">\n<button ng-if=\"isSupervisorConfirmed\" class=\"btn btn-primary\" ng-disabled=\"!bag.shiptype || !bag.qty || !bag.fromLocationId || !bag.toLocationId || (bag.shiptype.amountFlag && !bag.amount) || !bag.pickupTime\" ng-class=\"{'disabled': loading || addBagFormForCheckedin.$invalid}\" type=\"button\" id=\"add-bag\" ng-click=\"ok()\">{{ 'addBagModal.addItem' | translate }}</button>\n<button ng-if=\"isSupervisorConfirmed\" class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</div>\n";
var id1="checkedInAddBag.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2525 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"chkTitle\">{{'addBagModal.title' | translate}} {{bag.trackingId}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" ng-keydown=\"keyPressed($event)\">\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<form ng-submit=\"ok()\" name=\"addBagFormForCheckedOut\" novalidate ng-if=\"isSupervisorConfirmed && !loading\" class=\"form-validate\">\n<div class=\"row\">\n<div class=\"form-group col-sm-6\">\n<label>{{'addBagModal.trackingId' | translate}}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"bag.trackingId\" required disabled=\"disabled\">\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'addBagModal.shiptype' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"bag.shiptype\" ng-options=\"shiptype as shiptype.title for shiptype in shiptypes\" ng-change=\"shiptypeChanged()\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">(select)</option>\n</select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label>{{'addBagModal.quantity' | translate}} *</label>\n<input type=\"number\" ng-change=\"quantityChanged()\" class=\"form-control\" ng-model=\"bag.qty\" ng-required=\"!bag.shiptype.amountFlag\" ng-disabled=\"!bag.shiptype.coinFlag || !bag.shiptype\" min=\"1\">\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label>{{'addBagModal.amount' | translate}}</label>\n<input id=\"shiptype-amount\" type=\"text\" ng-required=\"bag.shiptype.amountFlag\" ng-currency class=\"form-control\" ng-model=\"bag.amount\" min=\"1\" placeholder=\"$0.00\" ng-disabled=\"bag.shiptype.coinFlag\" ng-keydown=\"$event.keyCode === 13 && (bag.amount) && focusOntoLocation('fromLocation')\">\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"row align-center-vertically\">\n<div class=\"form-group col-xs-10 margin-bottom-10\" style=\"padding-right: 0px;\">\n<label>\n{{'addBagModal.fromLocation' | translate}} *\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loadingLocations.fromLocation}\"></span>\n</label>\n<search-and-select ng-if=\"!showAllFromLocations\" ng-model=\"bag.fromLocationId\" values=\"fromLocations\" key=\"Key\" totalrecords=\"originTotalRecords\" ng-disabled=\"loadingLocations.fromLocation || !bag.shiptype\" onscroll=\"reloadOriginData(searchKey, offset)\" on-click=\"autoSelectDestination()\" none-selected=\"'common.none'\" focus-dropdown-id=\"fromLocation\" ng-keydown=\"$event.keyCode === 13 && focusOntoLocation('toLocation'); autoSelectDestination($event)\" common-search-flag=\"true\" required></search-and-select>\n<search-and-select ng-if=\"showAllFromLocations\" ng-model=\"bag.fromLocationId\" values=\"fromLocations\" key=\"Key\" totalrecords=\"originTotalRecords\" ng-disabled=\"loadingLocations.fromLocation || !bag.shiptype\" onscroll=\"reloadOriginData(searchKey, offset)\" on-click=\"autoSelectDestination()\" common-search-flag=\"true\" ng-keydown=\"$event.keyCode === 13 && focusOntoLocation('toLocation'); autoSelectDestination($event)\" none-selected=\"'common.none'\" common-search-flag=\"true\" focus-dropdown-id=\"fromLocation\" required></search-and-select>\n</div>\n<div class=\"col-xs-2 all-toggle-button\">\n<button class=\"btn btn-xs btn-block\" type=\"button\" ng-class=\"{'btn-success': showAllFromLocations, 'btn-default': !showAllFromLocations}\" ng-click=\"toggleAllFromLocations()\">\n{{'addBagModal.all' | translate}}\n</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row align-center-vertically\">\n<div class=\"form-group col-xs-10 margin-bottom-10\" style=\"padding-right: 0px;\">\n<label>\n{{'addBagModal.destination' | translate}} *\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loadingLocations.destination}\"></span>\n</label>\n<search-and-select ng-if=\"!showAllDestinationLocations\" ng-model=\"bag.toLocationId\" values=\"destinations\" key=\"Key\" totalrecords=\"totalRecords\" ng-disabled=\"!bag.fromLocationId || loadingLocations.destination\" common-search-flag=\"true\" none-selected=\"'common.none'\" focus-dropdown-id=\"toLocation\" ng-keydown=\"$event.keyCode === 13 && bag.toLocationId && focusOntoLocation('addBag');\" required></search-and-select>\n<search-and-select ng-if=\"showAllDestinationLocations\" ng-model=\"bag.toLocationId\" values=\"allDestinations\" key=\"Key\" totalrecords=\"totalAllRecords\" onscroll=\"reloadDestinationData(searchKey, offset)\" ng-disabled=\"!bag.fromLocationId || loadingLocations.destination\" none-selected=\"'common.none'\" focus-dropdown-id=\"toLocation\" ng-keydown=\"$event.keyCode === 13 && bag.toLocationId && focusOntoLocation('addBag');\" required></search-and-select>\n</div>\n<div class=\"col-xs-2 all-toggle-button\">\n<button class=\"btn btn-xs btn-block\" type=\"button\" ng-class=\"{'btn-success': showAllDestinationLocations, 'btn-default': !showAllDestinationLocations}\" ng-click=\"toggleAllDestinationLocations()\" ng-disabled=\"!bag.fromLocationId || loadingLocations.destination\">\n{{'addBagModal.all' | translate}}\n</button>\n</div>\n</div>\n</form>\n<div ng-if=\"errorMessage\" class=\"alert alert-danger\" role=\"alert\">\n{{errorMessage}}\n</div>\n</div>\n<form class=\"form-validate\" ng-if=\"!isSupervisorConfirmed\" style=\"margin-top: -29px;\">\n<confirm-supervisor event=\"'add-bag'\" on-confirm=\"supervisorConfirmed\" on-error=\"supervisorCancelled\" button-style=\"!isCancelSupervisorChallange ? 'marginleft88' : ''\"></confirm-supervisor>\n<button style=\"margin-top: -49px\" class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\" ng-if=\"isCancelSupervisorChallange\">{{'Cancel' | translate }}\n</button>\n</form>\n<div class=\"modal-footer\" ng-if=\"isSupervisorConfirmed\">\n<button ng-if=\"isSupervisorConfirmed\" class=\"btn btn-primary\" ng-disabled=\"loading || !bag.shiptype || !bag.qty || !bag.fromLocationId || !bag.toLocationId || (bag.shiptype.amountFlag && !bag.amount)\" ng-class=\"{'disabled': loading || addBagForm.$invalid}\" type=\"button\" ng-click=\"ok()\" id=\"addBag\">{{ 'addBagModal.addItem' | translate }}</button>\n<button ng-if=\"isSupervisorConfirmed\" class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</div>";
var id1="checkedoutAddBag.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2526 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"forceCloseRouteForm\" class=\"form-validate\" novalidate ng-submit=\"!loading && ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'forceCLoseRouteModal.title' | translate}} | {{currentrouteId}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading\" class=\"list-group remove-bottom-margin\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"list-group-item col-sm-12 align-center-vertically display-flex\" ng-repeat=\"routeVerifyResult in model.routeVerifyResults\">\n<div class=\"col-sm-7\">\n<strong> {{$index+1}} |</strong>\n<span ng-if=\"routeVerifyResult.trackingId\">{{maskingString(routeVerifyResult.trackingId)}}\n<span ng-if=\"!(routeVerifyResult.pickupDate && routeVerifyResult.deliveryDate)\">\n<button type=\"button\" class=\"btn btn-xs btn-default force-close-edit-btn\" ng-click=\"updateTrackingId(routeVerifyResult)\" style=\"padding: 2px;\">\n<span class=\"glyphicon glyphicon-edit edit-icon-size\" uib-tooltip=\"{{'branch_mgmt.items.editTrackingId' | translate}}\" tooltip-placement=\"right\"></span>\n</button>\n</span>\n</span>\n<span ng-if=\"routeVerifyResult.trackingId\">|</span>\n<span ng-if=\"!routeVerifyResult.trackingId && routeVerifyResult.message === 'MISSING_PICKUP'\">\n<span class=\"text-danger\">Missing Pickup | {{routeVerifyResult.shiptypeId}} |</span>\n</span>\n<span ng-if=\"!routeVerifyResult.trackingId\">{{routeVerifyResult.locationId}} |</span>\n<span ng-if=\"!routeVerifyResult.trackingId && routeVerifyResult.message === 'MISSING_PICKUP'\">{{routeVerifyResult.locationName}}</span>\n<span ng-if=\"routeVerifyResult.message == 'E_DELIVERY_NOT_ON_HOLD'\">{{'forceCLoseRouteModal.not_on_hold' | translate}}</span>\n<span ng-if=\"routeVerifyResult.message == 'E_PICKUP_NOT_CHECKED_IN'\">{{'forceCLoseRouteModal.not_checked_in' | translate}} | <span ng-if=\"routeVerifyResult.locationId\">{{ routeVerifyResult.locationId }} | </span> {{ routeVerifyResult.locationName }}</span>\n<span ng-if=\"routeVerifyResult.message == 'E_DELIVERY_NOT_CHECKED_OUT'\">{{'forceCLoseRouteModal.not_checked_out' | translate}} |</span>\n<span ng-if=\"routeVerifyResult.message == 'E_DELIVERY_NOT_DELIVERED'\">{{'forceCLoseRouteModal.not_delivered' | translate}} | <span ng-if=\"routeVerifyResult.locationId\">{{ routeVerifyResult.locationId }} | </span> {{ routeVerifyResult.locationName }}</span>\n<span ng-if=\"routeVerifyResult.message == 'E_LOCATION_NOT_ON_HOLD'\">{{'forceCLoseRouteModal.not_picked' | translate}} |\n<span ng-if=\"routeVerifyResult.locationName\">{{ routeVerifyResult.locationName }} </span>\n<span ng-if=\"routeVerifyResult.toLocationName\">{{routeVerifyResult.toLocationName}} |</span>\n<span ng-if=\"routeVerifyResult.fromLocationName\">{{routeVerifyResult.fromLocationName}} </span>\n</span>\n</div>\n<div class=\"col-sm-5 remove-pad\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12\" ng-if=\"routeVerifyResult.isError == 1 && routeVerifyResult.isOverridable == 0\">\n<span class=\"glyphicon glyphicon-exclamation-sign\" tooltip-placement=\"left\" uib-tooltip=\"Please contact System Admin\"></span>\n</div>\n<div class=\"col-sm-3\" ng-if=\"allowScan(routeVerifyResult) && !(routeVerifyResult.isRequiredPickup && !routeVerifyResult.orderNo && !routeVerifyResult.verified)\">\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"goToScan(routeVerifyResult)\">\n{{ 'checkin.scan' | translate }}\n</button>\n</div>\n<div class=\"col-sm-12 text-right\" ng-if=\"routeVerifyResult.isRequiredPickup && !routeVerifyResult.orderNo && !routeVerifyResult.verified\">\n<button type=\"button\" class=\"btn btn-warning\" ng-click=\"reroute(routeVerifyResult)\" ng-class=\"{'margin-left-5': allowScan(routeVerifyResult) && !(routeVerifyResult.message === 'E_PICKUP_NOT_CHECKED_IN' && routeVerifyResult.isRequiredPickup)}\">\n{{ 'itemNotDeliveredModal.reRoute' | translate }}\n</button>\n</div>\n<div ng-class=\"{\n                                'col-sm-9': allowScan(routeVerifyResult), \n                                'col-sm-12': !allowScan(routeVerifyResult)\n                            }\">\n<select class=\"form-control\" ng-if=\"routeVerifyResult.isOverridable == 1 && !(routeVerifyResult.isRequiredPickup && !routeVerifyResult.orderNo && !routeVerifyResult.verified)\" ng-model=\"routeVerifyResult.selectedReason\" ng-options=\"message.description as message.description for message in routeVerifyResult.reasons\" required autofocus>\n<option value=\"\" selected=\"selected\">({{'forceCLoseRouteModal.please_select' | translate}})</option>\n</select>\n</div>\n<div class=\"margin-top-05\" ng-class=\"{'col-sm-9': allowScan(routeVerifyResult), 'col-sm-12': !allowScan(routeVerifyResult)}\" ng-if=\"routeVerifyResult.message === 'MISSING_PICKUP'\">\n<textarea class=\"form-control\" ng-model=\"routeVerifyResult.noPickupComment\" placeholder=\"{{'verifyHoldShipments.comment' | translate}}\" rows=\"2\" required>\n                            </textarea>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"!loading && model.remainingItemList.length > 0\" class=\"list-group remove-bottom-margin\" ng-class=\"{'margin-top-15': model.routeVerifyResults.length}\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"list-group-item col-sm-12 align-center-vertically display-flex\" ng-repeat=\"item in model.remainingItemList\">\n<div class=\"col-sm-7\">\n<strong> {{$index+1}} |</strong>\n<span>{{item.barcode}} | </span>\n<span>{{item.label}} </span>\n</div>\n<div class=\"col-sm-5 text-center\">\n<div class=\"col-sm-12 remove-pad\">\n<select class=\"form-control\" ng-model=\"item.reason\" ng-options=\"message.description as message.description for message in item.reasons\" required autofocus>\n<option value=\"\" selected=\"selected\">({{'forceCLoseRouteModal.please_select' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"model.error\" class=\"remove-bottom-pad alert alert-danger\">\n<strong>Error</strong>: {{model.error}}\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" ng-disabled=\"(forceCloseRouteForm.$invalid || loading || hasRerouteItems())\" type=\"submit\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loading}\"></span> {{ 'checkin.force_close' | translate }}\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"loading\">\n{{ 'common.cancel' | translate }}\n</button>\n</div>\n</form>\n";
var id1="checkinForceClose.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2527 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"checkoutAddItemsTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'checkout.checkout_item' | translate}}</b></h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-2\" style=\"text-align: right;\">\n<label for=\"contact\">{{'checkout.item' | translate}}</label>\n</div>\n<div class=\"col-sm-9\">\n<input type=\"text\" id=\"item\" class=\"form-control input-lg\" autocomplete=\"off\" ng-model=\"model.trackingId\" style=\"margin: 0 auto;\" required/>\n</div>\n<div class=\"col-sm-1 padding-zero\">\n<button type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-success pull-left\" ng-click=\"clearScan()\">{{'common.clear' | translate}}</button>\n</div>\n</div>\n<div class=\"row margin-top-20 align-center-vertically\">\n<div class=\"col-sm-2\" style=\"text-align: right;\">\n<label for=\"contact\">{{'checkout.description' | translate}}</label>\n</div>\n<div class=\"col-sm-9\">\n<input type=\"text\" id=\"item\" class=\"form-control input-lg\" autocomplete=\"off\" ng-model=\"model.description\" style=\"margin: 0 auto;\" required/>\n</div>\n</div>\n<div class=\"row margin-top-20 align-center-vertically\">\n<div class=\"col-sm-2\" style=\"text-align: right;\">\n<label for=\"contact\">{{'checkout.comments' | translate}}</label>\n</div>\n<div class=\"col-sm-9\">\n<textarea class=\"form-control\" rows=\"4\" cols=\"50\" ng-model=\"model.comment\"></textarea>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"checkoutAddItemsTemplate.$invalid\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{'checkout.btn_checkout' | translate}}\n</button>\n</div>\n</form>";
var id1="checkoutAddItems.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2528 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<button type=\"button\" class=\"close\" ng-click=\"cancel('Close button pressed')\">&times;</button>\n<h4 class=\"modal-title\" id=\"modal-title\">{{'bagout.closePrint' | translate}}</h4>\n</div>\n<div class=\"modal-body row\" id=\"modal-body\">\n<form class=\"form-validate\" novalidate>\n<div class=\"form-group col-sm-12\">\n<label for=\"scan-bagout-seal\">{{'bagout.title' | translate}} *</label>\n<input id=\"scan-bagout-seal\" class=\"form-control input-lg\" type=\"text\" autocomplete=\"off\" ng-model=\"model.bagout.id\" strip-prefix on-press-enter=\"bagoutScanned()\" scan-type=\"'bagout'\" ng-pattern=\"/^[a-zA-Z0-9- ]*$/\" ng-disabled=\"loading\" required/>\n</div>\n</form>\n<div class=\"col-sm-12\" ng-if=\"model.message\">\n<div class=\"col-sm-12 alert\" ng-class=\"{'alert-danger': model.isError, 'alert-success': !model.isError}\">\n{{model.message}}\n</div>\n</div>\n<div class=\"col-sm-12 align-center-horizontally margin-top-20\">\n<button class=\"btn btn-success\" ng-disabled=\"!model.bagout.id || isLoading\" ng-click=\"view()\">{{'closeBagoutModal.view' | translate}}</button>\n</div>\n</div>";
var id1="closeBagout.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2529 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form class=\"form-validate\" name=\"closeRouteForm\" novalidate>\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'closeRouteModal.title' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div ng-if=\"!isSupervisorConfirmed\">\n<confirm-supervisor event=\"'close-route'\" on-confirm=\"supervisorConfirmed\" on-error=\"supervisorCancelled\"></confirm-supervisor>\n</div>\n<div ng-if=\"isSupervisorConfirmed\">\n<table class=\"table table-hover\">\n<thead>\n<tr>\n<th>{{'closeRouteModal.bag' | translate}}</th>\n<th>{{'closeRouteModal.pickupLocation' | translate}}</th>\n<th>{{'closeRouteModal.locationType' | translate}}</th>\n<th>{{'closeRouteModal.reasonCode' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"item in remainingItems\">\n<td>{{item.id}}</td>\n<td>{{item.location.name}}</td>\n<td>{{item.location.type}}</td>\n<td>\n<select ng-model=\"item.reasonCode\" class=\"form-control\" required ng-options=\"reasonCode for reasonCode in reasonCodes\">\n<option value=\"\" disabled=\"disabled\">(none)</option>\n</select>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"form-group\">\n<label for=\"\">{{'common.description' | translate}}</label>\n<textarea cols=\"30\" rows=\"5\" ng-model=\"model.description\" class=\"form-control\" required></textarea>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n<button ng-if=\"isSupervisorConfirmed\" class=\"btn btn-primary\" ng-disabled=\"closeRouteForm.$invalid\" ng-class=\"{'disabled': loading}\" ng-click=\"ok()\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loading}\"></span> {{'Ok' | translate}}\n</button>\n</div>\n</form>\n";
var id1="closeRoute.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2530 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"coinShiptypeListModal\" class=\"form-validate\" novalidate>\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\"><b>{{'checkout.verify_coin_to_route' | translate}}</b></h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"form-group align-center-vertically align-end-horizontally\" ng-if=\"!model.loading && model.shipTypeList.length\" style=\"margin-bottom: 0;\">\n<table class=\"table margin-zero\">\n<tr>\n<td ng-repeat=\"data in model.shipTypeList\" class=\"bordered-cell\" align=\"center\">\n<img ng-src=\"assets/images/{{data.shiptypeId}}.png\" height=\"30\">\n<input class=\"form-control margin-top-05 text-center\" type=\"text\" ng-model=\"model.shiptype[data.shiptypeId].qty\" ng-change=\"verifyCoin()\" ng-style=\"incorrectCoins[data.shiptypeId] && {'background-color': '#F9E3E3', 'border-color': '#F4C6C6'}\" required/>\n</td>\n</tr></table>\n</div>\n<div ng-if=\"!model.shipTypeList.length && !model.loading && !model.coinVerifiedMsg\">\n<div class=\"alert alert-danger text-center\" ng-class=\"{'text-danger': !model.shipTypeList.length}\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div ng-if=\"model.coinVerifiedMsg && !model.loading\">\n<div class=\"alert alert-success text-center\" ng-class=\"{'text-success': model.coinVerifiedMsg}\" style=\"margin-bottom: 0px;\">\n{{model.coinVerifiedMsg}}\n</div>\n</div>\n<div class=\"margin-top-05\" ng-if=\"!model.loading && coinShiptypeListModal.$valid && !isValid && !model.coinVerifiedMsg && model.shipTypeList.length\">\n<div class=\"alert alert-danger text-center text-danger\" style=\"margin-bottom: 0px;\">\n{{'checkout.coin_verify_error' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" ng-if=\"!model.coinVerifiedMsg && model.shipTypeList.length\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"model.loading || coinShiptypeListModal.$invalid || !isValid\">\n{{'checkout.add_to_checkout' | translate}}\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n";
var id1="coinShiptypeList.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2531 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form class=\"form-validate\" name=\"confirmSupervisorForm\" novalidate>\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'commitSuccessModal.title' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row align-center-horizontally\">\n<div class=\"col-sm-4\">\n<span class=\"glyphicon glyphicon-ok text-success\" style=\"font-size: 100px;\"></span>\n</div>\n<div class=\"col-sm-7 text-align-left margin-top-20\">\n<div class=\"text-success\"><b>{{model.successMessage}}</b></div>\n<div class=\"text-success\" ng-if=\"model.totalDollerAmount >= 0\">{{'commitSuccessModal.total' | translate}} = {{model.totalDollerAmount | currency:(model.currencySymbol || '$')}}\n<span ng-if=\"model.transactionType === 'Credit'\"> ({{'bulkCash.credit' | translate}})</span>\n<span ng-if=\"model.transactionType === 'Debit'\"> ({{'bulkCash.debit' | translate}})</span>\n</div>\n<div class=\"text-success\" ng-if=\"model.totalEuroAmount\">{{'commitSuccessModal.total' | translate}} = {{model.totalEuroAmount | currency:'€'}}</div>\n<div class=\"text-success\">{{model.date}}</div>\n<div class=\"text-success\">{{model.time}}</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">{{ 'common.ok' | translate }}</button>\n</div>\n</form>\n";
var id1="commitSuccess.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2532 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<form class=\"form-validate\" name=\"confirmSupervisorForm\" novalidate ng-keydown=\"keyPressed($event)\">\n<confirm-supervisor event=\"event\" details=\"details\" on-confirm=\"ok\" on-error=\"cancel\"></confirm-supervisor>\n<button class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" style=\"margin-top: -50px;\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</form>";
var id1="confirmSupervisor.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2533 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"orderPackModal\" class=\"form-validate\" novalidate>\n<div class=\"modal-header model-title bg-{{type}}\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'itemHolds.converttocrvresidual' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row form-group\">\n<div class=\"col-sm-3 total-fontSize\">\n{{ model.shipmentData.amount | currency:(model.shipmentData.symbol || (model.shipmentData.denomination && model.shipmentData.denomination.symbol) || '$'):2 }}\n</div>\n<div class=\"col-sm-1 margin-top-5\">\n{{model.shipmentData.id}}\n</div>\n<div class=\"col-sm-4 margin-top-5\" ng-if=\"model.shipmentData.fromLocation.address && model.shipmentData.fromLocation.city && model.shipmentData.fromLocation.state && model.shipmentData.fromLocation.zip\">\n<span ng-if=\"model.shipmentData.fromLocation.address\">{{model.shipmentData.fromLocation.address}},</span>\n<span ng-if=\"model.shipmentData.fromLocation.city\">{{model.shipmentData.fromLocation.city}},</span>\n<span ng-if=\"model.shipmentData.fromLocation.state\">{{model.shipmentData.fromLocation.state}},</span>\n<span ng-if=\"model.shipmentData.fromLocation.zip\">{{model.shipmentData.fromLocation.zip}}</span>\n</div>\n<div class=\"col-sm-4 margin-top-5\" ng-if=\"!model.shipmentData.fromLocation.address && !model.shipmentData.fromLocation.city && !model.shipmentData.fromLocation.state && !model.shipmentData.fromLocation.zip\">\n{{'common.n_a' | translate}}\n</div>\n<div class=\"col-sm-4 margin-top-5\" ng-if=\"model.shipmentData.toLocation.address && model.shipmentData.toLocation.city && model.shipmentData.toLocation.state && model.shipmentData.toLocation.zip\">\n<span ng-if=\"model.shipmentData.toLocation.address\">{{model.shipmentData.toLocation.address}},</span>\n<span ng-if=\"model.shipmentData.toLocation.city\">{{model.shipmentData.toLocation.city}},</span>\n<span ng-if=\"model.shipmentData.toLocation.state\">{{model.shipmentData.toLocation.state}},</span>\n<span ng-if=\"model.shipmentData.toLocation.zip\">{{model.shipmentData.toLocation.zip}}</span>\n</div>\n<div class=\"col-sm-4 margin-top-5\" ng-if=\"!model.shipmentData.toLocation.address && !model.shipmentData.toLocation.city && !model.shipmentData.toLocation.state && !model.shipmentData.toLocation.zip\">\n{{'common.n_a' | translate}} - {{model.shipmentData.toLocation}}\n</div>\n</div>\n<div class=\"border-order-packing form-validate\">\n<div class=\"row div-pack\">\n<div class=\"col-sm-6 pack-padding\" style=\"margin-top: 5px;\">\n<span>\n{{ 'orderPacking.packRequirements' | translate }}\n</span>\n</div>\n<div class=\"col-sm-6 pack-padding\">\n<div class=\"text-right\">\n<img ng-src=\"assets/images/arrow-inbound.png\" class=\"custom-icon img-width\"/>\n</div>\n</div>\n</div>\n<div class=\"row margin0\" style=\"border-bottom:  1px solid #d8d6d6;\">\n<div class=\"col-sm-3 padding6\">\n<img ng-src=\"assets/images/{{model.shipmentData.denomination.id}}.png\" class=\"custom-icon img-width\"/>\n<span class=\"pack-value\">{{ model.shipmentData.amount | currency:(model.shipmentData.symbol || (model.shipmentData.denomination && model.shipmentData.denomination.symbol) || '$'):2 }}</span>\n</div>\n<div class=\"col-sm-4 col-sm-offset-5\">\n<div class=\"padding6\" style=\"display: -webkit-inline-box;\">\n<img ng-src=\"assets/images/bag-residual.png\" class=\"custom-icon img-width\"/>\n<input type=\"text\" id=\"residual-trackingId\" ng-model=\"model.trackingIdResidual\" class=\"form-control\" style=\"width: 81%;\" required/>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}\n</button>\n<button class=\"btn btn-primary\" type=\"submit\" ng-class=\"{'disabled': loading}\" ng-disabled=\"orderPackModal.$invalid || isLoading\" ng-click=\"validateSupervisorScan()\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loading}\"></span> {{'itemHolds.converttocrv' | translate}}\n</button>\n</div>\n</form>\n";
var id1="convertToCrv.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2534 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"createActionCodeForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'serviceSettings.create_action_code' | translate}}</b></h4>\n</div>\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; height: 100px;\">\n<div class=\"form-group col-sm-6\">\n<label for=\"actionCodeLabel\">{{'serviceSettings.action_code_label' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"model.actionCodeLabel\" required>\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"actonCode\">{{'serviceSettings.action_code' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"model.actionCode\" required>\n</div>\n<div class=\"form-group col-sm-12\">\n<label>{{'location.preventativeMaintenance' | translate}}</label>\n<div class=\"margin-top-02\">\n<search-and-select ng-model=\"model.preventativeMaintenanceId\" set-id=\"preventativeMaintenanceCreate\" values=\"model.pmSearchList\" key=\"Key\" totalrecords=\"model.totalPMRecords\" onscroll=\"model.loadPreventativeMaintenances(searchKey, offset)\" class=\"dd-z-index\" none-selected=\"'common.none'\" common-search-flag=\"false\" ng-style=\"model.isPMSuspended(model.preventativeMaintenanceId) && {'background-color': '#F9E3E3'}\">\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"minResponse\">{{'serviceSettings.resolve_required' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"model.minResponse\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"actonCode\">{{'serviceSettings.multiple_resolve_codes' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"model.maxResponse\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"thresholds\">{{'serviceSettings.thresholds' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"model.thresholds\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"thresholds\">Parts Capture</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"model.partsCapture\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"requirePicture\">{{'serviceSettings.require_picture' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"model.requirePicture\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"requirePicture\">{{'serviceSettings.require_root_cause' | translate}}</label>\n<br/>\n<input type=\"checkbox\" bs-switch ng-model=\"model.minRootCause\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"requirePicture\">{{'serviceSettings.multiple_root_cause' | translate}}</label>\n<br/>\n<input type=\"checkbox\" bs-switch ng-model=\"model.maxRootCause\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"openRequired\">{{'serviceSettings.open_required' | translate}}</label>\n<br/>\n<input type=\"checkbox\" bs-switch ng-model=\"model.openRequired\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad margin-bottom-10\">\n<div class=\"form-group col-sm-3\">\n<label for=\"priority\">{{'serviceSettings.priority' | translate}}</label>\n<select class=\"form-control\" ng-options=\"priority.id as priority.priority for priority in model.prioritiesList\" ng-model=\"model.serviceActionPriorityId\">\n<option value=\"\">(None)</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'serviceSettings.service_type' | translate}}</label><br>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm\" ng-repeat=\"stype in ['FLM', 'SLM']\" ng-click=\"model.serviceType = stype\" ng-class=\"{'btn-success': model.serviceType === stype, 'btn-default': model.serviceType !== stype}\">\n&nbsp;{{stype}}&nbsp;\n</button>\n</div>\n</div>\n<div class=\"form-group col-sm-5\">\n<label for=\"expectedTime\">{{'serviceSettings.expected_time_to_complete' | translate}}</label>\n<time-picker class=\"time-picker-width\" ng-model=\"model.expectedCompletionTime\" format=\"hh:mm a\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" is-meridian=\"false\" display-time-format=\"false\">\n</time-picker>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"autoAssignable\">Auto Assignable</label>\n<br/>\n<input type=\"checkbox\" bs-switch ng-model=\"model.autoAssignable\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 d-a-flex\" ng-if=\"model.hasACL['create']\">\n<h4>{{'serviceSettings.resolve_codes' | translate}}</h4>\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn pull-right\" ng-click=\"addNewServiceResponse()\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n</div>\n<div class=\"col-sm-12 _form-group\">\n<ul dnd-list=\"model.actionCodeData.details.responses\" dnd-allowed-types=\"move\" class=\"w-60\">\n<li ng-repeat=\"item in model.actionCodeData.details.responses\" dnd-draggable=\"item\" dnd-effect-allowed=\"move\" dnd-moved=\"model.actionCodeData.details.responses.splice($index, 1); {{model.actionCodeData.details.responses[$index].sortOrder = $index+1}}\" dnd-selected=\"models.selected = item\" ng-class=\"{selected: models.selected === item}\" style=\"padding-bottom: 30px;\">\n<div class=\"margin-top-10 col-sm-9\">\n<div class=\"col-sm-12 d-flex remove-left-pad remove-pad-right\">\n<input readonly=\"readonly\" class=\"form-control text-center response-no-input cursor-pointer\" type=\"text\" ng-model=\"model.actionCodeData.details.responses[$index].sortOrder\" required/>\n<input class=\"form-control\" type=\"text\" ng-model=\"model.actionCodeData.details.responses[$index].label\" required/>\n<div ng-if=\"model.hasACL['create']\">\n<div class=\"ml-5 margin-top-02\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"removeResolveCodes($index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"margin-top-10 remove-left-pad col-sm-3\">\n<select class=\"form-control\" ng-options=\"category.value as category.label for category in model.categoryList\" ng-model=\"model.actionCodeData.details.responses[$index].category\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-12 margin-top-10 d-a-flex\" ng-if=\"model.hasACL['create']\">\n<h4>{{'serviceSettings.root_causes' | translate}}</h4>\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn pull-right\" ng-click=\"addNewRootCause()\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}\n</button>\n</div>\n<div class=\"col-sm-12 _form-group\">\n<ul dnd-list=\"model.actionCodeData.details.rootCauses\" dnd-allowed-types=\"move\" class=\"w-60\">\n<li ng-repeat=\"item in model.actionCodeData.details.rootCauses\" dnd-draggable=\"item\" dnd-effect-allowed=\"move\" dnd-moved=\"model.actionCodeData.details.rootCauses.splice($index, 1); {{model.actionCodeData.details.rootCauses[$index].sortOrder = $index+1}}\" dnd-selected=\"models.selected = item\" ng-class=\"{selected: models.selected === item}\" style=\"padding-bottom: 30px\">\n<div class=\"margin-top-10 col-sm-12\">\n<div class=\"col-sm-12 d-flex remove-left-pad remove-pad-right\">\n<input readonly=\"readonly\" class=\"form-control text-center response-no-input cursor-pointer\" type=\"text\" ng-model=\"model.actionCodeData.details.rootCauses[$index].sortOrder\" required/>\n<input class=\"form-control\" type=\"text\" ng-model=\"model.actionCodeData.details.rootCauses[$index].label\" required/>\n<div ng-if=\"model.hasACL['create']\">\n<div class=\"ml-5 margin-top-02\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"removeRootCauses($index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</div>\n</div>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"model.thresholds\">\n<div class=\"col-sm-12 remove-pad\">\n<br/>\n<div class=\"col-sm-3\">\n<time-picker class=\"time-picker-width\" ng-model=\"model.redThreshold\" format=\"hh:mm a\" ng-change=\"disableCodeUpdate()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" is-meridian=\"false\" display-time-format=\"false\">\n</time-picker>\n</div>\n<div class=\"col-sm-3\">\n<time-picker class=\"orange-thres-hold time-picker-width\" ng-model=\"model.orangeThreshold\" format=\"hh:mm a\" ng-change=\"disableCodeUpdate()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" is-meridian=\"false\" display-time-format=\"false\">\n</time-picker>\n</div>\n<div class=\"col-sm-3\">\n<time-picker class=\"yellow-thres-hold time-picker-width\" ng-model=\"model.yellowThreshold\" format=\"hh:mm a\" ng-change=\"disableCodeUpdate()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" is-meridian=\"false\" display-time-format=\"false\">\n</time-picker>\n</div>\n<div class=\"col-sm-3\">\n<time-picker class=\"blue-thres-hold time-picker-width\" ng-model=\"model.otherThreshold\" format=\"hh:mm a\" ng-change=\"disableCodeUpdate()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" is-meridian=\"false\" display-time-format=\"false\">\n</time-picker>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad align-center-horizontally\" ng-if=\"model.isDuplicate\">\n<span class=\"alert alert-danger text-center remove-bottom-pad threshold-error\">{{'serviceSettings.duplicate_thresholds' | translate}}</span>\n</div>\n<div class=\"col-sm-12 margin-10\">\n<button type=\"button\" ng-click=\"updateServiceItem(actions.id)\" ng-if=\"hasACL['create']\" ng-disabled=\"(model.isDuplicate || !model.actionCodeData.details.label || loading)\" class=\"btn btn-primary ng-binding pull-right\">\n<span ng-class=\"{ 'glyphicon glyphicon-refresh fast-right-spinner': loading} \"></span> {{'common.save' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!model.actionCodeData.details.responses.length && model.minResponse && !loading\">\n<div class=\"col-sm-12 alert text-center alert-danger\">\n{{'serviceSettings.require_resolve_codes' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!model.actionCodeData.details.rootCauses.length && model.minRootCause && !loading\">\n<div class=\"col-sm-12 alert text-center alert-danger\">{{'serviceSettings.require_root_causes' | translate}}</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-scondary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"createActionCodeForm.$invalid || (hasACL['create'] && !model.actionCodeData.details.responses.length) || (hasACL['create'] && !model.actionCodeData.details.rootCauses.length) || disableCodeUpdate() ||\n                             (!model.actionCodeData.details.responses.length && model.minResponse) || (!model.actionCodeData.details.rootCauses.length && model.minRootCause)\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\"> {{ 'common.Create' | translate }}\n</button>\n</div>\n</form>\n";
var id1="createActionCode.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2535 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"createAtmMakeForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>Create ATM Make</b>\n</h4>\n</div>\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-9 _form-group margin-bottom-10\">\n<div class=\"col-sm-12 remove-pad\">\n<label for=\"atm-make-name\">Make *</label>\n<input id=\"atm-make-name\" class=\"form-control\" type=\"text\" ng-model=\"model.atmMakeData.details.vendorName\" required/>\n</div>\n</div>\n<div class=\"col-sm-3 _form-group margin-bottom-10 remove-pad\">\n<label class=\"display-block\">Status</label>\n<input bs-switch switch-size=\"small\" ng-model=\"model.atmMakeData.details.active\" type=\"checkbox\" switch-on-text=\"Active\" switch-off-text=\"Inactive\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer margin-top-10\">\n<button class=\"btn btn-scondary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"createAtmMakeForm.$invalid || disableCodeUpdate()\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\">\n{{ 'common.Create' | translate }}\n</button>\n</div>\n</form>\n";
var id1="createAtmMake.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2536 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"postBillingRecordTemplate\" class=\"form-validate\" novalidate>\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'entry_type.create-billing-records' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%;\">\n<div class=\"row\">\n<div class=\"col-sm-12 text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!model.loading\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label>{{'billableEvents.billing_type' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"model.billingStatus\" required ng-options=\"status.Value as status.Key for status in model.billingStatusList\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n<div class=\"form-group col-sm-6 atm-codes-date-picker-section\">\n<label>{{'closeVault.currentVaultDate' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"vault-date\" ng-model=\"model.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.vaultDate}\" date-options=\"model.currentMonthDateOptions\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label>{{'branch_mgmt.billing_approval.bill_category' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"model.selectedBillingCategory\" required ng-change=\"billingTypeOptionChoice(model); setBillingType(model); getBillingEventsByCategory(model.selectedBillingCategory)\" ng-options=\"category.label for category in model.billingCategoryOptions\" ng-disabled=\"model.billingCategoryObj.loading\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'billableEvents.menu.title' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"model.selectedbillableEvent\" required ng-options=\"item.id as item.label for item in model.billableEventObj.results\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-6\">\n<label>{{'branch_mgmt.billing_approval.bill_type' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"model.billingType\" required ng-options=\"billingType.value as billingType.label for billingType in billingTypeList\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'contract.schedule_type' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"model.scheduleType\" required ng-options=\"scheduleType.value as scheduleType.label for scheduleType in model.scheduleTypeOptions\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label for=\"deliveryDate\">{{'common.location' | translate}} *</label>\n<search-and-select ng-model=\"model.locationObj.selectedLocation\" values=\"model.locationObj.results\" key=\"Key\" totalrecords=\"model.locationObj.totalRecords\" none-selected=\"'common.none'\" onscroll=\"getLocationList(searchKey, offset)\" on-click=\"findCustomerContractByLocation(); resetData();\" ng-disabled=\"model.locationObj.loading\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6\">\n<label>{{ 'location.contract' | translate }} *</label>\n<search-and-select ng-model=\"model.contractObj.selectedContract\" values=\"model.contractObj.results\" key=\"Key\" totalrecords=\"model.contractObj.totalRecords\" none-selected=\"'common.none'\" common-search-flag=\"true\" on-click=\"findContractRuleAndCustomerByContractId(); getCustomerList(searchKey, offset);\" ng-disabled=\"model.contractObj.loading\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label for=\"deliveryDate\">{{'contract.contractRule' | translate}} *</label>\n<search-and-select ng-model=\"model.contractRuleObj.selectedContractRule\" values=\"model.contractRuleObj.results\" key=\"Key\" totalrecords=\"model.contractRuleObj.totalRecords\" none-selected=\"'common.none'\" on-click=\"applyContractRuleRate()\" common-search-flag=\"true\" ng-disabled=\"model.contractObj.loading\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6\">\n<label>{{ 'customer.customers' | translate }} *</label>\n<search-and-select ng-model=\"model.customerObj.selectedCustomer\" values=\"model.customerObj.results\" key=\"Key\" totalrecords=\"model.customerObj.totalRecords\" none-selected=\"'common.none'\" ng-disabled=\"model.contractObj.loading\" common-search-flag=\"true\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} *</label>\n<input class=\"form-control\" type=\"test\" ng-model=\"model.rate\" ng-currency required ng-change=\"model.rateFromRule = false; model.amountDue = model.rate\">\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'branch_mgmt.billing_approval.amount_due' | translate}} *</label>\n<input class=\"form-control\" type=\"test\" ng-model=\"model.amountDue\" ng-currency required>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" ng-disabled=\"isLoading || postBillingRecordTemplate.$invalid || !model.vaultDate\" type=\"button\" ng-click=\"ok()\">\n{{ 'common.ok' | translate }}\n<span ng-if=\"isLoading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">{{ 'common.cancel' | translate }}</button>\n</div>\n</form>";
var id1="createBillingRecords.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2537 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"fuelSurchargeCustomerForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'fuel_surcharge.cutomer_title' | translate}}</b>\n</h4>\n</div>\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; height: 100px;\">\n<div class=\"form-group col-sm-6\">\n<label for=\"actionCodeLabel\">{{'fuel_surcharge.customer' | translate}} *</label>\n<select class=\"form-control\" required ng-model=\"model.customer\" ng-options=\"option.label for option in customers\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'|translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-12\" ng-if=\"model.customer.id\">\n<table class=\"table-pad-3 table table-condensed table-bordered inner-tbl-margin-bottom\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'fuel_surcharge.customer' | translate}}</th>\n<th class=\"text-center\">{{'fuel_surcharge.locations' | translate}}</th>\n<th class=\"text-center\">{{'fuel_surcharge.branches' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"(key, customer) in [model.customer]\" ng-if=\"model.customer.id\">\n<td class=\"text-center\"> {{customer.label}} </td>\n<td class=\"text-center\"> {{customer.location}} </td>\n<td class=\"text-center\"> {{customer.branch}} </td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-scondary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"fuelSurchargeCustomerForm.$invalid\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\"> {{ 'common.Create' | translate }}\n</button>\n</div>\n</form>";
var id1="createFuelSurchageCustomer.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2538 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"createLanguageMessageModal\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'message.create_message' | translate}}</b>\n</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row\" ng-if=\"!model.loading\">\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; height: 100px;\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"message-id\">{{'message.messageId' | translate}} *</label>\n<input type=\"text\" id=\"message-id\" ng-model=\"model.languageMessageObj.messageId\" class=\"form-control\" required/>\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"message-id\">{{'message.type' | translate}} *</label>\n<select ng-model=\"model.languageMessageObj.type\" ng-options=\"type.value as type.label for type in model.messageTypes\" class=\"form-control\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-repeat=\"language in model.languages\">\n<div class=\"form-group\">\n<label for=\"\" ng-if=\"language.id == 'E'\">{{'message.descriptionInEng' | translate}} *</label>\n<label for=\"\" ng-if=\"language.id == 'S'\">{{'message.descriptionInSpn' | translate}} *</label>\n<textarea cols=\"30\" rows=\"2\" ng-model=\"model.languageMessageObj.description[language.id]\" class=\"form-control\" required></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-scondary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"createLanguageMessageModal.$invalid || model.isCreate\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\"> {{ 'common.Create' | translate }}\n<span ng-if=\"model.isCreate\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n</div>\n</form>";
var id1="createLanguageMessage.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2539 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"createServiceActionPriorityForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>Create Action Priority</b>\n</h4>\n</div>\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 _form-group margin-bottom-10\">\n<label for=\"priority-name\">Priority *</label>\n<input id=\"priority-name\" class=\"form-control\" type=\"text\" ng-model=\"model.priorityData.details.priority\" required/>\n</div>\n<div class=\"col-sm-6 _form-group margin-bottom-10\">\n<label class=\"display-block\" style=\"display: block;\">Status</label>\n<input bs-switch switch-size=\"small\" ng-model=\"model.priorityData.details.active\" type=\"checkbox\" switch-on-text=\"Active\" switch-off-text=\"Inactive\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"col-sm-12 _form-group margin-bottom-10\">\n<div class=\"col-sm-12 remove-pad\">\n<label for=\"priority-desc\">Description</label>\n<textarea id=\"priority-desc\" class=\"form-control\" rows=\"2\" ng-model=\"model.priorityData.details.description\" style=\"resize: vertical;\"></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer margin-top-10\">\n<button class=\"btn btn-secondary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"createServiceActionPriorityForm.$invalid || disableCodeUpdate()\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\">\n{{ 'common.Create' | translate }}\n</button>\n</div>\n</form>\n";
var id1="createServiceActionPriority.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2540 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"createServiceChecklistForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'serviceSettings.create_service_checklist' | translate}}</b>\n</h4>\n</div>\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 _form-group margin-bottom-10\">\n<div class=\"col-sm-12 d-flex remove-left-pad remove-pad-right\">\n<div class=\"remove-left-pad col-sm-10\">\n<label for=\"label\">{{'serviceSettings.service_checklist_label_label' | translate}} *</label>\n<input id=\"service-check-list-name\" class=\"form-control\" type=\"text\" ng-model=\"model.serviceChecklistData.details.label\" required/>\n</div>\n<div class=\"remove-pad col-sm-2\">\n<label for=\"daySelection\">{{'serviceSettings.service_checklist_day_label' | translate}} *</label>\n<input class=\"form-control text-center _response-no-input\" type=\"number\" min=\"1\" ng-model=\"model.serviceChecklistData.details.daySelection\" required/>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer margin-top-10\">\n<button class=\"btn btn-scondary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"createServiceChecklistForm.$invalid || disableCodeUpdate()\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\"> {{ 'common.Create' | translate }}\n</button>\n</div>\n</form>";
var id1="createServiceChecklist.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2541 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"deletedReasonModal\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'deletedReason.delete_shipment' | translate}} | {{ model.trackingId }}</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group col-sm-12\">\n<label for=\"reason\">{{'common.reason' | translate }} </label>\n<select class=\"form-control\" ng-model=\"model.selectedReasonCode\" ng-options=\"message.description as message.description for message in model.reasons\" autofocus>\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"_form-group col-sm-12\">\n<label>{{ 'common.comment' | translate }}</label>\n<textarea id=\"comment\" class=\"form-control\" rows=\"3\" ng-model=\"model.reason\" style=\"border-radius: 5px\" required></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"deletedReasonModal.$invalid || isLoading\">\n{{ 'common.ok' | translate }}\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>\n</button>\n</div>\n</form>";
var id1="deletedReason.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2542 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"deliveryServiceTransactionTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{ 'transaction_log.title' | translate}}</b> | {{model.locationId}}\n</h4>\n</div>\n<div class=\"text-align-center margin-10 margin-bottom-10\" ng-if=\"model.loading && !model.errorMessage\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\" ng-if=\"!model.loading\">\n<table class=\"table table-hover table-bordered remove-pad table-pad-5\" ng-if=\"model.transactionDetails.length && !model.errorMessage\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">#</th>\n<th class=\"text-center\">{{'billableEvents.event' | translate}}</th>\n<th class=\"text-center contents-no-wrap\">{{'common.tracking_id' | translate}}</th>\n<th class=\"text-center\">{{'bulkCash.amount' | translate}}</th>\n<th class=\"text-center contents-no-wrap\">{{'users.user' | translate}}</th>\n<th class=\"text-center contents-no-wrap\">{{'common.dateTime' | translate}}</th>\n<th class=\"text-center\">{{'bypassCode.comments' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"data in model.transactionDetails track by $index\">\n<td>{{$index + 1}}</td>\n<td class=\"contents-no-wrap text-danger\">{{translateTransactionType(data.tranType)}}</td>\n<td class=\"contents-no-wrap\"><a href=\"#\" ng-click=\"goToItemHistory(data.trackingId)\">\n{{data.trackingId}}</a></td>\n<td class=\"contents-no-wrap\">\n<span ng-if=\"data.amount !== null\">{{data.amount | currency:fraction:\"0\"}}</span>\n<span ng-if=\"data.amount == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{data.performedById}} | {{data.firstName}} {{data.lastName}}</td>\n<td>{{data.transactionDate | date: 'MM-dd-yyyy | hh:mm a'}}</td>\n<td>{{data.comments}}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.transactionDetails.length && !model.errorMessage\">\n<div class=\"col-sm-12 alert alert-danger text-center\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div ng-if=\"model.errorMessage\">\n<div class=\"col-sm-12 alert alert-danger text-center\" style=\"margin-bottom: 0px;\">\n{{model.errorMessage}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="deliveryServiceTransaction.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2543 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">Denomination Details - {{ items.orderNo }}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 450px; overflow-y: auto;\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"margin-bottom-10\" ng-if=\"items.locationId\">\n<b>Location:</b> {{ items.locationId }} | <b>Date:</b> {{ items.countVaultDate | date : 'yyyy-MM-dd' : 'UTC' }}\n</div>\n<table class=\"table table-hover table-striped table-bordered font-12 margin-bottom-0\">\n<thead>\n<tr>\n<th class=\"text-center\">Denomination</th>\n<th class=\"text-center\">Counted Amount</th>\n<th class=\"text-center\">Variance</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"item in items.denomData\">\n<td class=\"text-center\">\n<div class=\"d-flex align-items-center justify-content-center\">\n<img ng-src=\"assets/images/{{item.denominationId}}.png\" style=\"height: 30px; margin-right: 10px;\" onerror=\"this.style.display='none'\">\n|\n<b style=\"margin-left: 10px;\">{{item.denominationId}}</b>\n</div>\n</td>\n<td class=\"text-center\">\n{{item.amountCounted | currency}}\n</td>\n<td class=\"text-center\" ng-class=\"{'variance-bg-color': items.countedVariance && items.countedVariance !== 0}\">\n{{ items.denomData.length === 1 ? (items.countedVariance | currency) : '-' }}\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\">{{ 'common.close' | translate }}</button>\n</div>\n";
var id1="denominationBreakdown.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2544 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"depositPackingInfoTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'atm_deposit_packing.contents' | translate}}</b> | {{model.trackingId}}\n<span class=\"pull-right\" ng-if=\"model.contents.totalRecords\"><b>{{'atm_deposit_packing.total' | translate}}</b> : {{model.contents.totalRecords}}</span>\n</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 500px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.contents.records.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>{{'common.tracking_id' | translate}}</th>\n<th>{{'common.locationId' | translate}}</th>\n<th>{{'atm_deposit_packing.counted_date' | translate}}</th>\n<th>{{'atm_deposit_packing.denom' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"record in model.contents.records track by $index\">\n<td>\n<a href=\"#\" ng-click=\"goToItemHistory(record.trackingId)\">\n{{record.trackingId}}\n</a>\n</td>\n<td>\n<a href=\"#\" ng-click=\"goToServiceHistory(record)\">\n{{record.locationId}}\n</a>\n</td>\n<td>{{record.countedDate | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td>{{record.denominationId}} | {{record.amount | currency:(record.symbol || '$'):0}}</td>\n</tr>\n</tbody>\n</table>\n<div class=\"row col-sm-12 margin-top-10 remove-bottom-margin-10\" ng-if=\"model.contents.totalRecords > 10 && !model.loading\">\n<ul uib-pagination total-items=\"model.contents.totalRecords\" ng-hide=\"{{(model.contents.totalRecords<=pagination.pageLimit)&&(pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"pagination.page\" ng-change=\"pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div ng-if=\"!model.contents.records.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.contents.records.length}\" style=\"margin-bottom: 0px;\">\n{{'atm_deposit_packing.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n";
var id1="depositPackingInfo.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2545 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"duplicateStopsForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'location.duplicate_stops' | translate}}</b> | {{model.routeId}}\n</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table-pad-5 table table-hover table-bordered remove-pad\" ng-if=\"model.stops.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'itemHolds.routeSequence' | translate}}.</th>\n<th>{{'window.location' | translate}}</th>\n<th>{{'common.address' | translate}}</th>\n<th>{{'location.associated_routes' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.stops track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{data.sequence}}</td>\n<td>\n<img ng-src=\"/assets/images/{{loadLocationTypeIcon(data.locationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{data.locationType}}\"/>\n<a href=\"#\" ng-click=\"goToServiceHistory(data)\">{{data.locationId}} </a> | {{data.locationName}}\n</td>\n<td>{{data.address}}</td>\n<td>\n<div ng-repeat=\"routeId in data.routeIds track by $index\">\n<b>{{routeId}}<span ng-if=\"$index + 1 !== data.routeIds.length\">,</span></b>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.stops.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center remove-bottom-margin\" ng-class=\"{'alert-danger': !model.stops.length}\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="duplicateStopsInfo.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2546 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"editDeliveryShipmentForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>Edit Delivery Shipment</b></h4>\n</div>\n<div class=\"text-align-center margin-top-10 margin-bottom-10\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row\" ng-if=\"!model.loading\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label>{{ 'branch_mgmt.items.oldTrackingId' | translate }}</label>\n<input type=\"text\" id=\"old-tracking-id\" class=\"form-control\" ng-model=\"model.shipmentUpdateObj.oldTrackingId\" disabled=\"disabled\" required/>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label>{{ 'branch_mgmt.items.newTrackingId' | translate }} *</label>\n<input type=\"text\" id=\"new-tracking-id\" class=\"form-control\" ng-model=\"model.shipmentUpdateObj.newTrackingId\" strip-whitespace ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" ng-disabled=\"model.shipment.checkedOut || model.shipment.checkedIn || model.shipment.deliveredFlag || model.shipment.deleted\" required/>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label>{{'bagout.fromLocation' | translate}} </label>\n<search-and-select ng-model=\"model.shipmentUpdateObj.fromLocationId\" values=\"model.locationListObj.locationList\" key=\"Key\" totalrecords=\"model.locationListObj.totalRecords\" onscroll=\"getLocationList(searchKey, offset)\" none-selected=\"'common.none'\" ng-disabled=\"model.locationListObj.loading\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6\">\n<label>{{ 'bagout.toLocation' | translate }} </label>\n<search-and-select ng-model=\"model.shipmentUpdateObj.toLocationId\" values=\"model.locationListObj.locationList\" key=\"Key\" totalrecords=\"model.locationListObj.totalRecords\" onscroll=\"getLocationList(searchKey, offset)\" none-selected=\"'common.none'\" ng-disabled=\"model.locationListObj.loading\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group col-sm-6\">\n<label for=\"deliveryDate\">{{'branch_mgmt.daily_balance_sheet.vaultDate' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"vault-date\" ng-model=\"model.shipmentUpdateObj.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.shipmentUpdateObj.vaultDate,\n                        'disabled': model.shipment.checkedOut || model.shipment.checkedIn || model.shipment.deliveredFlag }\" ng-keydown=\"$event.preventDefault()\" date-options=\"model.minVaultDate\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6\">\n<label>{{ 'checkout.routeId' | translate }} *</label>\n<search-and-select ng-model=\"model.shipmentUpdateObj.selectedRoute\" values=\"model.routeListObj.routeList\" key=\"Key\" totalrecords=\"model.routeListObj.totalRecords\" common-search-flag=\"true\" none-selected=\"'common.none'\" ng-disabled=\"model.shipment.checkedOut || model.shipment.checkedIn || model.shipment.deliveredFlag\" required></search-and-select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group col-sm-6 remove-bottom-margin\">\n<label for=\"deliveryDate\">{{'shipmentBatch.deliveryDate' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"delivery-date\" ng-model=\"model.shipmentUpdateObj.deliveryDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" date-options=\"model.minDeliveryDate\" ng-change=\"validateDeliveryDateTime()\">\n</datetimepicker>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"deliveryTime\">{{'itemHolds.deliveryTime' | translate}} *</label>\n<input type=\"time\" class=\"form-control\" required ng-model=\"model.shipmentUpdateObj.deliveryTime\" ng-change=\"validateDeliveryDateTime()\">\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group col-sm-6\" ng-class=\"{'form-group': model.shipment.coinFlag && model.shipment.shiptypeId !== 'C'}\">\n<label for=\"shipmentAmount\">{{'checkin.amount' | translate}} *</label>\n<input id=\"shipment-amount\" type=\"text\" ng-currency class=\"form-control\" ng-model=\"model.shipmentUpdateObj.amount\" ng-change=\"validateLoadedAmount()\" placeholder=\"$0.00\" ng-disabled=\"model.shipment.coinFlag && model.shipment.shiptypeId !== 'C'\" required/>\n</div>\n<div class=\"_form-group col-sm-6\" ng-class=\"{'form-group': model.shipment.coinFlag && model.shipment.shiptypeId !== 'C'}\">\n<label for=\"loadedAmount\">{{'branch_mgmt.mark_as_delivered.delivered_amount' | translate}} *</label>\n<input id=\"loaded-amount\" type=\"text\" ng-currency class=\"form-control\" ng-model=\"model.shipmentUpdateObj.loadedAmount\" ng-change=\"validateLoadedAmount()\" placeholder=\"$0.00\"/>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-if=\"model.shipment.coinFlag && model.shipment.shiptypeId !== 'C'\">\n<div class=\"col-sm-6\">\n<label>{{ 'denomination.shiptype' | translate }} *</label>\n<search-and-select ng-model=\"model.shipmentUpdateObj.selectedShipType\" values=\"model.shipTypeListObj.shipTypeList\" key=\"Key\" totalrecords=\"model.shipTypeListObj.totalRecords\" common-search-flag=\"true\" ng-change=\"validateLoadedAmount()\" none-selected=\"'common.none'\" ng-disabled=\"((model.shipment.shiptypeId || '').toLowerCase() === 'bulktransfer')\" required></search-and-select>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"shipmentQty\">{{'addBagModal.quantity' | translate}} *</label>\n<input id=\"shipment-qty\" type=\"text\" class=\"form-control\" ng-model=\"model.shipmentUpdateObj.qty\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"validateLoadedAmount()\" placeholder=\"0\" required/>\n</div>\n</div>\n<div class=\"form-group margin-10 col-sm-12\">\n<label>{{ 'location.comment' | translate }} *</label>\n<textarea class=\"form-control\" rows=\"2\" ng-model=\"model.shipmentUpdateObj.comments\" style=\"border-radius: 5px\" required></textarea>\n</div>\n<div class=\"form-group col-sm-12\" ng-if=\"model.amountExceeds\">\n<div class=\"alert alert-danger text-center text-danger\" style=\"margin-bottom: 0px;\">\n{{'shipment.loadAmountExceedError' | translate}}\n</div>\n</div>\n<div class=\"form-group col-sm-12\" ng-if=\"model.deliveryDateTimeRequired\">\n<div class=\"alert alert-danger text-center text-danger\" style=\"margin-bottom: 0px;\">\n{{'shipment.deliveryDateTimeRequiredError' | translate}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<div class=\"form-group form-checbox remove-bottom-margin\">\n<input type=\"checkbox\" name=\"fancy-checkbox-default\" ng-model=\"model.shipmentUpdateObj.undoDelivery\" id=\"fancy-checkbox-default\" autocomplete=\"off\" ng-click=\"removeDeliveryDate()\" ng-disabled=\"model.loading\"/>\n<div class=\"btn-group btn-checkbox-group\" ng-if=\"model.shipment.status == 'shipment.delivered'\">\n<label for=\"fancy-checkbox-default\" class=\"btn btn-default\">\n<span class=\"glyphicon glyphicon-ok\"></span>\n<span> </span>\n</label>\n<label for=\"fancy-checkbox-default\" class=\"btn btn-warning\">\n{{'shipment.undo_delivery' | translate}}\n</label>\n</div>\n<button ng-disabled=\"validateEditDeliveryForm() || model.amountExceeds || model.loading || model.shipmentUpdateObj.loadedAmount === '' || model.shipmentUpdateObj.loadedAmount === null\" ng-if=\"model.shipment.status === 'shipment.hold'\" class=\"btn btn-success\" type=\"button\" ng-click=\"ok('mark_delivered')\" ng-disabled=\"model.loading\">\n{{ 'itemHolds.mark_as_delivered' | translate }}\n</button>\n<button class=\"btn btn-scondary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"validateEditDeliveryForm() || model.amountExceeds || model.loading\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok('update')\">\n{{ 'common.update' | translate }}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"model.loading\"></span>\n</button>\n</div>\n</div>\n</form>\n";
var id1="editDeliveryShipment.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2547 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"editPickupShipmentForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'vaultOperations.edit_pickup_shipment' | translate}}</b></h4>\n</div>\n<div class=\"text-align-center margin-top-10 margin-bottom-10\" ng-if=\"model.routeListObj.loadRoutes || model.shipTypeListObj.loadShipTypes\n               || model.locationListObj.loadLocations\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-if=\"!model.routeListObj.loadRoutes && !model.shipTypeListObj.loadShipTypes \n                && !model.locationListObj.loadLocations\">\n<div class=\"modal-body remove-left-pad remove-right-pad\" id=\"modal-body\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label>{{ 'branch_mgmt.items.oldTrackingId' | translate }}</label>\n<input type=\"text\" id=\"old-tracking-id\" class=\"form-control\" ng-model=\"model.shipmentUpdateObj.oldTrackingId\" disabled=\"disabled\" required/>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label>{{ 'branch_mgmt.items.newTrackingId' | translate }} *</label>\n<input type=\"text\" id=\"new-tracking-id\" class=\"form-control\" ng-model=\"model.shipmentUpdateObj.newTrackingId\" strip-whitespace ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" ng-disabled=\"model.shipment.checkedOut || model.shipment.checkedIn || model.shipment.pickupFlag || model.shipment.deleted\" required/>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label>{{'bagout.fromLocation' | translate}} </label>\n<search-and-select ng-model=\"model.shipmentUpdateObj.fromLocationId\" values=\"model.locationListObj.locationList\" key=\"Key\" totalrecords=\"model.locationListObj.totalRecords\" onscroll=\"getLocationList(searchKey, offset)\" none-selected=\"'common.none'\" ng-disabled=\"model.locationListObj.loading\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6\">\n<label>{{ 'bagout.toLocation' | translate }} </label>\n<search-and-select ng-model=\"model.shipmentUpdateObj.toLocationId\" values=\"model.locationListObj.locationList\" key=\"Key\" totalrecords=\"model.locationListObj.totalRecords\" onscroll=\"getLocationList(searchKey, offset)\" none-selected=\"'common.none'\" ng-disabled=\"model.locationListObj.loading\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group col-sm-6\">\n<label for=\"vaultDate\">{{'branch_mgmt.daily_balance_sheet.vaultDate' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"vault-date\" ng-model=\"model.shipmentUpdateObj.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.shipmentUpdateObj.vaultDate,\n                        'disabled': model.shipment.checkedOut || model.shipment.checkedIn || model.shipment.pickupFlag }\" ng-keydown=\"$event.preventDefault()\" date-options=\"model.minVaultDate\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6\">\n<label>{{ 'checkout.routeId' | translate }} *</label>\n<search-and-select ng-model=\"model.shipmentUpdateObj.selectedRoute\" values=\"model.routeListObj.routeList\" key=\"Key\" totalrecords=\"model.routeListObj.totalRecords\" common-search-flag=\"true\" none-selected=\"'common.none'\" ng-disabled=\"model.shipment.checkedOut || model.shipment.checkedIn || model.shipment.pickupFlag\" required></search-and-select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group col-sm-6 remove-bottom-margin\">\n<label for=\"pickupDate\">{{'shipmentBatch.pickupDate' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"pickup-date\" ng-model=\"model.shipmentUpdateObj.pickupDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.shipmentUpdateObj.pickupDate}\" ng-keydown=\"$event.preventDefault()\" date-options=\"model.minPickupDate\">\n</datetimepicker>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"pickupTime\">{{'itemHolds.pickupTime' | translate}} *</label>\n<input type=\"time\" class=\"form-control\" ng-model=\"model.shipmentUpdateObj.pickupTime\" required>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-6\">\n<label>{{ 'denomination.shiptype' | translate }} *</label>\n<search-and-select ng-model=\"model.shipmentUpdateObj.selectedShipType\" values=\"model.shipTypeListObj.shipTypeList\" key=\"Key\" totalrecords=\"model.shipTypeListObj.totalRecords\" common-search-flag=\"true\" none-selected=\"'common.none'\" ng-disabled=\"model.shipment.checkedOut || model.shipment.orderNo || ((model.shipment.shiptypeId || '').toLowerCase() === 'bulktransfer')\" disabled=\"disabled\" required></search-and-select>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"shipmentAmount\">{{'checkin.amount' | translate}} *</label>\n<input id=\"shipment-amount\" type=\"text\" ng-currency class=\"form-control\" ng-model=\"model.shipmentUpdateObj.amount\" ng-change=\"validateLoadedAmount()\" placeholder=\"$0.00\" required/>\n</div>\n</div>\n<div class=\"form-group margin-10 col-sm-12\">\n<label>{{ 'location.comment' | translate }} *</label>\n<textarea class=\"form-control\" rows=\"2\" ng-model=\"model.shipmentUpdateObj.comments\" style=\"border-radius: 5px\" required></textarea>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-scondary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"validateEditPickupForm() || model.loading\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\">\n{{ 'common.ok' | translate }}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"model.loading\"></span>\n</button>\n</div>\n</form>";
var id1="editPickupShipment.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2548 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"nextScheduledOccurencesTemplate\" class=\"form-validate\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4>{{'location.combined_route_assignment' | translate}} | {{model.data.toLocationId}}</h4>\n<h4 id=\"modal-title\"></h4>\n</div>\n<div class=\"row\" ng-if=\"!model.loading\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"text-align-center margin-top-10 margin-bottom-10\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"margin-bottom-10 col-sm-12 week-day-section recurring-stop-section\" ng-if=\"!loading\">\n<table class=\"table table-striped weekdays-table table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th>{{'location.day.routeId' | translate}}</th>\n<th>{{'branchFundingSource.interval' | translate}}</th>\n<th>{{'routeProgress.sequence' | translate}}</th>\n<th>{{'customer.startDate' | translate}}</th>\n<th></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"route in model.combinedRoutes track by $index\" ng-if=\"$index < 7\">\n<th class=\"col-xs-1\">{{route.day.label | translate}}</th>\n<td class=\"location-route-assignment-section col-sm-3\">\n<search-and-select ng-required=\"((route.anchorDate || route.interval) ? !route.route : false)\" ng-model=\"route.route\" set-id=\"route-{{route.day.value}}\" values=\"model.dayArray[$index][route.day.value]\" key=\"Key\" totalrecords=\"model.total[$index][route.day.value].total\" onscroll=\"loadDaysRoutes(searchKey, offset, $index, route.day.value)\" none-selected=\"'common.none'\" long-dd-width-flag=\"true\" ng-disabled=\"!route.hasRouteAssignment && route.route.Value !== model.data.routeId\">\n</search-and-select>\n</td>\n<td ng-if=\"route.isVisible\" class=\"location-route-assignment-section\">\n<select class=\"form-control\" ng-model=\"route.interval\" required=\"false\" ng-options=\"interval.label for interval in route.combinedRouteIntervals\" ng-required=\"((route.anchorDate || route.route) ? !route.interval : false)\" ng-change=\"validateRouteAssignment();\" ng-disabled=\"!route.hasRouteAssignment && route.route.Value !== model.data.routeId\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</td>\n<td ng-if=\"route.isVisible\" class=\"location-route-assignment-section col-xs-1\">\n<input type=\"number\" class=\"form-control\" ng-model=\"route.sequence\" min=\"1\" ng-change=\"validateRouteAssignment();\" ng-disabled=\"!route.hasRouteAssignment && route.route.Value !== model.data.routeId\" ng-required=\"((route.anchorDate || route.route || route.interval) ? !route.sequence : false)\">\n</td>\n<td ng-if=\"route.isVisible\" class=\"atm-codes-date-picker-section col-sm-3\" ng-class=\"{'edit-schedule-route-section': !route.hasRouteAssignment && route.route.Value !== model.data.routeId}\">\n<datetimepicker class=\"datetimepicker-input\" key=\"{{$index}}\" id=\"{{$index}}\" ng-model=\"route.anchorDate\" ng-class=\"{'disabled': !route.hasRouteAssignment && route.route.Value !== model.data.routeId}\" date-format=\"dd-MMM-yyyy\" ng-click=\"loadRoutes()\" hidden-time=\"true\" show-button-bar=\"false\" date-disabled=\"disableDays(date, mode, route.day)\" ng-change=\"recheckMonthlyOccurences(route.anchorDate, route.day, $index); validateRouteAssignment();\" timezone=\"UTC\" ng-required=\"((route.route || route.interval) ? !route.anchorDate : false)\" ng-class=\"{'required-datetimepicker': ((route.route || route.interval) ? !route.anchorDate : false)}\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</td>\n<td ng-if=\"route.isVisible\" class=\"d-flex gap-5\">\n<button type=\"button\" ng-click=\"showNextScheduledOccurences(route)\" class=\"btn btn-primary\" ng-disabled=\"!route.interval || !route.anchorDate || !route.day || !route.interval.label || model.locationDetails.status ||\n                               !route.hasRouteAssignment && route.route.Value !== model.data.routeId\">\n<span class=\"glyphicon glyphicon-refresh\" uib-tooltip=\"{{'routeAssugment.view_next_occurences' | translate}}\" tooltip-placement=\"top\">\n</span>\n</button>\n<button type=\"button\" class=\"btn btn-danger\" ng-click=\"deleteCombinedRoute(route); validateRouteAssignment();\" ng-disabled=\"!route.id || !route.hasRouteAssignment && route.route.Value !== model.data.routeId\">\n<span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"{{'common.Delete' | translate}}\" tooltip-placement=\"top\">\n</span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button ng-disabled=\"model.isUpdating || loading\" class=\"btn btn-success\" type=\"button\" ng-click=\"ok()\">\n{{ 'common.update' | translate }}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"model.isUpdating\"></span>\n</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.isUpdating || loading\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="editScheduledOrders.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2549 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"editTrackingIdTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'forceCLoseRouteModal.edit_tracking_id' | translate }}</strong> <span>| {{model.oldTrackingId}}</span></h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!model.loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group col-sm-12\">\n<label>{{ 'common.trackingId' | translate }} *</label>\n<input type=\"text\" id=\"tracking-id\" class=\"form-control\" ng-model=\"model.trackingId\" required/>\n</div>\n<div class=\"form-group col-sm-12\">\n<label>{{ 'common.comment' | translate }} *</label>\n<textarea class=\"form-control\" rows=\"3\" ng-model=\"model.comment\" style=\"border-radius: 5px\" required></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"editTrackingIdTemplate.$invalid || model.loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>\n{{ 'common.update' | translate }}\n</button>\n</div>\n</form>";
var id1="editTrackingId.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2550 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'forceCheckinModal.title' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<form class=\"form-validate margin-bottom-20\" ng-if=\"model.isBagAdded\" ng-submit=\"fetchDetails()\">\n<div class=\"form-group\">\n<label for=\"bag-id\">{{'checkin.item' | translate}}</label>\n<input id=\"bag-id\" type=\"text\" required ng-model=\"model.scannedBagId\" required class=\"form-control\">\n</div>\n</form>\n<div class=\"align-center-horizontally margin-bottom-20\">\n<button class=\"btn btn-md btn-success\" ng-click=\"showAddBagModal()\">{{'checkinSelectionModal.forceBag' | translate}}</button>\n</div>\n<div ng-if=\"model.error\" class=\"alert alert-danger\" role=\"alert\">\n{{model.error}}\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</div>\n";
var id1="forceCheckin.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2551 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"forceCloseHoldForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'forceCloseHold.title' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"list-group-item col-sm-12 align-center-vertically display-flex\" ng-repeat=\"shipment in model.holdShipments\">\n<div class=\"col-sm-7\">\n<span>\n<span ng-if=\"shipment.trackingId\">{{maskingString(shipment.trackingId)}} |</span>\n<span ng-if=\"shipment.message\">{{shipment.message}}</span>\n<span ng-if=\"shipment.toLocationId\">{{shipment.toLocationId}} <span ng-if=\"shipment.toLocationName\"> {{shipment.toLocationName}}</span></span>\n</span>\n</div>\n<div class=\"col-sm-5\" style=\"text-align: center;\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<select class=\"form-control\" ng-model=\"shipment.selectedReason\" ng-options=\"message.description as message.description for message in shipment.reasons\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">{{'forceCloseHold.please_select' | translate}}</option>\n</select>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"model.error\" class=\"alert alert-danger\">\n<strong>{{ 'common.error' | translate }}</strong>: {{model.error}}\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" ng-disabled=\"forceCloseHoldForm.$invalid || model.loading\" type=\"submit\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span> {{ 'checkin.force_close' | translate }}\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n</div>\n</form>\n";
var id1="forceCloseHold.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2552 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"forceCloseRouteForm\" class=\"form-validate\" novalidate ng-submit=\"!loading && ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'forceCLoseRouteModal.title' | translate}} | {{currentrouteId}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading && model.coinCheckOut\" class=\"list-group remove-bottom-margin\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"list-group-item col-sm-12 align-center-vertically display-flex\" ng-repeat=\"routeVerifyResult in model.routeVerifyResults\">\n<div class=\"col-sm-7\">\n<span>\n<strong> {{$index+1}} |</strong>\n<span ng-if=\"routeVerifyResult.trackingId\">{{routeVerifyResult.trackingId}}\n<span ng-if=\"!(routeVerifyResult.pickupDate && routeVerifyResult.deliveryDate)\">\n<button type=\"button\" class=\"btn btn-xs btn-default force-close-edit-btn\" ng-click=\"updateTrackingId(routeVerifyResult)\" style=\"padding: 2px;\">\n<span class=\"glyphicon glyphicon-edit edit-icon-size\" uib-tooltip=\"{{'common.Edit' | translate}}\" tooltip-placement=\"left\"></span>\n</button>\n</span>\n| </span>\n<span ng-if=\"!routeVerifyResult.trackingId\">{{routeVerifyResult.locationId}} |</span>\n<span ng-if=\"routeVerifyResult.message == 'E_DELIVERY_NOT_ON_HOLD'\">{{'forceCLoseRouteModal.not_on_hold' | translate}}</span>\n<span ng-if=\"routeVerifyResult.message == 'E_PICKUP_NOT_CHECKED_IN'\">{{'forceCLoseRouteModal.not_checked_in' | translate}} | <span ng-if=\"routeVerifyResult.locationId\">{{ routeVerifyResult.locationId }} | </span>\n{{ routeVerifyResult.locationName }}</span>\n<span ng-if=\"routeVerifyResult.message == 'E_DELIVERY_NOT_CHECKED_OUT'\">{{'forceCLoseRouteModal.not_checked_out' | translate}} |</span>\n<span ng-if=\"routeVerifyResult.message == 'E_DELIVERY_NOT_DELIVERED'\">{{'forceCLoseRouteModal.not_delivered' | translate}} | <span ng-if=\"routeVerifyResult.locationId\">{{ routeVerifyResult.locationId }} | </span>\n{{ routeVerifyResult.locationName }}</span>\n<span ng-if=\"routeVerifyResult.message == 'E_LOCATION_NOT_ON_HOLD'\">{{'forceCLoseRouteModal.not_picked' | translate}} | <span ng-if=\"routeVerifyResult.locationName\">{{ routeVerifyResult.locationName }}\n<span ng-if=\"routeVerifyResult.toLocationName\">{{routeVerifyResult.toLocationName}} |</span>\n<span ng-if=\"routeVerifyResult.fromLocationName\">{{routeVerifyResult.fromLocationName}}\n</span>\n</span>\n</span></span></div>\n<div class=\"col-sm-5\" style=\"text-align: center;\">\n<div class=\"row\">\n<div class=\"col-sm-12\" ng-if=\"routeVerifyResult.isError == 1 && routeVerifyResult.isOverridable == 0\">\n<span class=\"glyphicon glyphicon-exclamation-sign\" tooltip-placement=\"left\" uib-tooltip=\"Please contact System Admin\"></span>\n</div>\n<div class=\"col-sm-3\" ng-if=\"allowScan(routeVerifyResult)\">\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"goToScan(routeVerifyResult)\">{{ 'checkin.scan' | translate }}</button>\n</div>\n<div ng-class=\"{\n                                    'col-sm-9': allowScan(routeVerifyResult), \n                                    'col-sm-12': !allowScan(routeVerifyResult)\n                                }\">\n<select class=\"form-control\" ng-if=\"routeVerifyResult.isOverridable == 1\" ng-model=\"routeVerifyResult.selectedReason\" ng-options=\"message.description as message.description for message in routeVerifyResult.reasons\" required autofocus>\n<option value=\"\" selected=\"selected\">({{'forceCLoseRouteModal.please_select' | translate}})\n</option>\n</select>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"!loading && !model.coinCheckOut\" class=\"list-group remove-bottom-margin\" ng-class=\"{'margin-top-15': model.routeVerifyResults.length}\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"list-group-item col-sm-12 align-center-vertically display-flex\" ng-repeat=\"routeVerifyResult in model.routeVerifyResults\">\n<div class=\"col-sm-7\">\n<span>\n<strong> {{$index+1}} |</strong>\n<span ng-if=\"routeVerifyResult.trackingId\">{{routeVerifyResult.trackingId}}\n<span ng-if=\"!(routeVerifyResult.pickupDate && routeVerifyResult.deliveryDate)\">\n<button type=\"button\" class=\"btn btn-xs btn-default force-close-edit-btn\" ng-click=\"updateTrackingId(routeVerifyResult)\" style=\"padding: 2px;\">\n<span class=\"glyphicon glyphicon-edit edit-icon-size\" uib-tooltip=\"{{'common.Edit' | translate}}\" tooltip-placement=\"left\"></span>\n</button>\n</span>\n| </span>\n<span ng-if=\"!routeVerifyResult.trackingId\">{{routeVerifyResult.locationId}} |</span>\n<span ng-if=\"routeVerifyResult.message == 'E_DELIVERY_NOT_ON_HOLD'\">{{'forceCLoseRouteModal.not_on_hold' | translate}}</span>\n<span ng-if=\"routeVerifyResult.message == 'E_PICKUP_NOT_CHECKED_IN'\">{{'forceCLoseRouteModal.not_checked_in' | translate}} | <span ng-if=\"routeVerifyResult.locationId\">{{ routeVerifyResult.locationId }} | </span>\n{{ routeVerifyResult.locationName }}</span>\n<span ng-if=\"routeVerifyResult.message == 'E_DELIVERY_NOT_CHECKED_OUT'\">{{'forceCLoseRouteModal.not_checked_out' | translate}} |</span>\n<span ng-if=\"routeVerifyResult.message == 'E_DELIVERY_NOT_DELIVERED'\">{{'forceCLoseRouteModal.not_delivered' | translate}} | <span ng-if=\"routeVerifyResult.locationId\">{{ routeVerifyResult.locationId }} | </span>\n{{ routeVerifyResult.locationName }}</span>\n<span ng-if=\"routeVerifyResult.message == 'E_LOCATION_NOT_ON_HOLD'\">{{'forceCLoseRouteModal.not_picked' | translate}} | <span ng-if=\"routeVerifyResult.locationName\">{{ routeVerifyResult.locationName }}\n<span ng-if=\"routeVerifyResult.toLocationName\">{{routeVerifyResult.toLocationName}} |</span>\n<span ng-if=\"routeVerifyResult.fromLocationName\">{{routeVerifyResult.fromLocationName}}\n</span>\n</span>\n</span></span></div>\n<div class=\"col-sm-5\" style=\"text-align: center;\">\n<div class=\"row\">\n<div class=\"col-sm-12\" ng-if=\"routeVerifyResult.isError == 1 && routeVerifyResult.isOverridable == 0\">\n<span class=\"glyphicon glyphicon-exclamation-sign\" tooltip-placement=\"left\" uib-tooltip=\"Please contact System Admin\"></span>\n</div>\n<div class=\"col-sm-3\" ng-if=\"allowScan(routeVerifyResult)\">\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"goToScan(routeVerifyResult)\">{{ 'checkin.scan' | translate }}</button>\n</div>\n<div ng-class=\"{\n                                    'col-sm-9': allowScan(routeVerifyResult), \n                                    'col-sm-12': !allowScan(routeVerifyResult)\n                                }\">\n<select class=\"form-control\" ng-if=\"routeVerifyResult.isOverridable == 1\" ng-model=\"routeVerifyResult.selectedReason\" ng-options=\"message.description as message.description for message in routeVerifyResult.reasons\" required autofocus>\n<option value=\"\" selected=\"selected\">({{'forceCLoseRouteModal.please_select' | translate}})\n</option>\n</select>\n</div>\n</div>\n</div>\n</div>\n<div class=\"list-group-item col-sm-12 align-center-vertically display-flex margin-10\" ng-if=\"!model.isAllCoinVerified\">\n<div class=\"col-sm-7\"><strong>{{model.remainingToCoinCheckout}}</strong> {{'common.Of' | translate}}\n<strong>{{model.totalCoinShipmentOnRoute}}</strong>\n{{'forceCLoseRouteModal.remaining_to_checkout' | translate}}</div>\n<div class=\"col-sm-5\" style=\"text-align: center;\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<select class=\"form-control\" ng-model=\"model.selectedReasonForCoin\" ng-change=\"selectedCoinReason()\" ng-options=\"message.description as message.description for message in model.reasonList\" required autofocus>\n<option value=\"\" selected=\"selected\">({{'forceCLoseRouteModal.please_select' | translate}})\n</option>\n</select>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"!loading && model.remainingItemList.length > 0\" class=\"list-group remove-bottom-margin\" ng-class=\"{'margin-top-15': model.routeVerifyResults.length}\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"list-group-item col-sm-12 align-center-vertically display-flex\" ng-repeat=\"item in model.remainingItemList\">\n<div class=\"col-sm-7\">\n<strong> {{$index+1}} |</strong>\n<span>{{item.barcode}} | </span>\n<span>{{item.label}} </span>\n</div>\n<div class=\"col-sm-5 text-center\">\n<div class=\"row\">\n<div class=\"col-sm-3\">\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"goToScan(item)\">{{ 'checkin.scan' | translate }}</button>\n</div>\n<div class=\"col-sm-9\">\n<select class=\"form-control\" ng-model=\"item.reason\" ng-options=\"message.description as message.description for message in item.reasons\" required autofocus>\n<option value=\"\" selected=\"selected\">({{'forceCLoseRouteModal.please_select' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"model.error\" class=\"alert alert-danger\">\n<strong>Error</strong>: {{model.error}}\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" ng-disabled=\"forceCloseRouteForm.$invalid || loading\" type=\"submit\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loading}\"></span>\n{{ 'checkin.force_close' | translate }}\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"loading\">\n{{ 'common.cancel' | translate }}\n</button>\n</div>\n</form>";
var id1="forceCloseRoute.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2553 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'fuel_surcharge.location_title' | translate}}\n<span ng-if=\"model.fuelSurcharge && model.fuelSurcharge.name\">| {{model.fuelSurcharge.name}}</span>\n</b>\n</h4>\n</div>\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; height: 100px;\">\n<div class=\"col-sm-12\" ng-if=\"!model.isLoading\">\n<div>\n<table class=\"table-pad-3 table table-condensed table-bordered inner-tbl-margin-bottom\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center table-label-font-section\" ng-click=\"sortData('name')\">\n<b>{{'fuel_surcharge.locations' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{ 'reverse': !reverseSort,  'active' : sortColumn === 'name'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"sortData('address')\">\n<b>{{'fuel_surcharge.address' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{ 'reverse': !reverseSort,  'active' : sortColumn === 'address'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"sortData('branchId')\">\n<b>{{'fuel_surcharge.branch' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{ 'reverse': !reverseSort,  'active' : sortColumn === 'branchId'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"sortData('locationType')\">\n<b>{{'fuel_surcharge.locationType' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{ 'reverse': !reverseSort,  'active' : sortColumn === 'locationType'}\"></span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-if=\"locations && locations.length\" ng-repeat=\"fuelSurchargeLocation in locations track by $index\">\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"gotoLocation(fuelSurchargeLocation.id)\">\n{{fuelSurchargeLocation.name}}\n</a>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"!fuelSurchargeLocation.address\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"fuelSurchargeLocation.address\">{{fuelSurchargeLocation.address}}</span>\n</td>\n<td class=\"text-center\">{{fuelSurchargeLocation.branchId}}</td>\n<td class=\"text-center\">\n<img ng-src=\"{{loadImage(fuelSurchargeLocation.locationType)}} \" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{fuelSurchargeLocation.locationType}}\"/>\n</td>\n</tr>\n<tr ng-if=\"!locations || !locations.length\">\n<td class=\"text-align-center alert alert-danger\" colspan=\"4\">\n<span>{{'fuel_surcharge.noFuelSurchargeLocations' | translate}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n<ul uib-pagination total-items=\"totalLocations\" ng-hide=\"{{(totalLocations<=10)&&(filter.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"filter.page\" ng-change=\"loadLocations()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div class=\"text-center col-sm-12\" ng-if=\"model.isLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-scondary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>";
var id1="fuelSurchargeLocations.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2554 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"forceToHoldModal\" class=\"form-validate\" novalidate ng-submit=\"validateSupervisorScan()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'routeThrow.reasontitle' | translate}}</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group col-sm-12\">\n<label>{{ 'routeThrow.reasoncomment' | translate }} *</label>\n<textarea class=\"form-control\" rows=\"3\" ng-model=\"model.reasonToClose\" style=\"border-radius: 5px\" required></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"forceToHoldModal.$invalid\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>\n";
var id1="holdReason.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2555 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"holdShipmentsTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'routeControl.hold_shipment' | translate}}</b> | {{model.routeId}}</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.holdShipments.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'common.tracking_id' | translate}}</th>\n<th>{{'common.vault_date' | translate}}</th>\n<th>{{'common.branch_id' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.holdShipments track by $index\">\n<td>{{$index + 1}}</td>\n<td><a href=\"#\" ng-click=\"goToItemHistory(data.trackingId)\"> {{data.trackingId}}</a></td>\n<td>{{ data.vaultDate | date:'yyyy-MM-dd': 'UTC' }}</td>\n<td>{{ data.branchId }}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.holdShipments.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.holdShipments.length}\" style=\"margin-bottom: 0px;\">\n{{'routeControl.no_items_on_hold' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button ng-if=\"model.holdShipments.length && !model.loading\" class=\"btn btn-success pull-left\" type=\"button\" ng-click=\"redirectToHold()\">\n{{ 'routeControl.item_hold' | translate }}\n</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="holdShipmentList.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2556 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"internalDeliveryTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'branch_mgmt.edit_from' | translate }}</strong> <span ng-if=\"model.shipmentData\">| {{ model.shipmentData.trackingId }}</span></h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!model.loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group col-sm-12\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{ 'branch_mgmt.items.internal_location' | translate }}\" tooltip-placement=\"right\"></span>\n<label>{{ 'branch_mgmt.items.locations' | translate }} *</label>\n<search-and-select ng-model=\"model.location\" values=\"model.locations\" key=\"Key\" totalrecords=\"model.totalLocation\" onscroll=\"loadInternalLocations(searchKey, offset)\" is-edit=\"true\" none-selected=\"'common.none'\" required>\n</search-and-select>\n</div>\n<div class=\"_form-group col-sm-12\">\n<label>{{ 'common.comment' | translate }}</label>\n<textarea class=\"form-control\" rows=\"3\" ng-model=\"model.comment\" style=\"border-radius: 5px\"></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"internalDeliveryTemplate.$invalid || model.loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>\n{{ 'common.save' | translate }}\n</button>\n</div>\n</form>";
var id1="internalDelivery.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2557 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"itemHistoryTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong> {{ 'branch_mgmt.items.history' | translate }} | {{model.itemLabel}} </strong>\n</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.result.results.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th ng-click=\"sortData('entryType')\">\n<b>{{'common.entry_type' | translate }}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !model.reverseSort, 'active' : model.sortColumn === 'entryType'}\"></span>\n</th>\n<th ng-click=\"sortData('createdAt')\">\n<b>{{'common.created' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !model.reverseSort, 'active' : model.sortColumn === 'createdAt'}\"></span>\n</th>\n<th ng-click=\"sortData('createdByUserId')\">\n<b>{{'branch_mgmt.itemHistoryPrId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !model.reverseSort, 'active' : model.sortColumn === 'createdByUserId'}\"></span>\n</th>\n<th ng-click=\"sortData('branchId')\">\n<b>{{'bagout.branch' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !model.reverseSort, 'active' : model.sortColumn === 'branchId'}\"></span>\n</th>\n<th ng-click=\"sortData('routeId')\">\n<b>{{'dashboard.routeId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !model.reverseSort, 'active' : model.sortColumn === 'routeId'}\"></span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.result.results\">\n<td>{{translateItemHistoryMsg(data.entryType)}}</td>\n<td class=\"remove-white-space\">{{data.createdAt | date: 'MM-dd-yyyy | hh:mm a' }}</td>\n<td>{{data.createdByUserId}} | {{data.firstName}} {{data.lastName}}</td>\n<td>{{data.branchId}}</td>\n<td>\n<span ng-if=\"data.routeId\">{{data.routeId | uppercase}}</span>\n<span ng-if=\"!data.routeId\">{{'common.n_a' | translate}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"row col-sm-12 margin-top-10 remove-bottom-margin-10\" ng-if=\"model.result.totalRecords > 10 && !model.loading\">\n<ul uib-pagination total-items=\"model.result.totalRecords\" ng-hide=\"{{(model.result.totalRecords<=pagination.pageLimit)&&(pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"pagination.page\" ng-change=\"pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div ng-if=\"!model.result.results.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.result.results.length}\" style=\"margin-bottom: 0px;\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" ng-click=\"exportItemHistoryData()\" ng-if=\"model.result.results.length\" ng-disabled=\"exportLoading || model.loading\">\n<span class=\"glyphicon glyphicon glyphicon-download\"></span>\n{{'common.export'|translate }}\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': exportLoading}\"></span>\n</button>\n<button class=\"btn btn-success\" ng-disabled=\"model.loading\" ng-click=\"generateItemHistoryPrint()\" ng-if=\"model.result.results.length\">\n<span class=\"glyphicon glyphicon-print\"></span> {{'coinPullReport.print'|translate }}\n</button>\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'branch_mgmt.item_holds.close' | translate }}\n</button>\n</div>\n</form>";
var id1="itemHistory.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2558 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"itemHoldVerifyDetails\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{ 'branch_mgmt.item_holds.logDetails' | translate }} | {{id}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"table-responsive\" ng-if=\"model.holdVerifyData\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"remove-bottom-margin table table-hover table-striped table-bordered\">\n<thead>\n<tr class=\"header-row\">\n<th>\n<b>{{ 'branch_mgmt.item_holds.vaultDate' | translate }}</b>\n</th>\n<th>\n<b>{{ 'branch_mgmt.item_holds.bulkVerified' | translate }}</b>\n</th>\n<th>\n<b>{{ 'branch_mgmt.item_holds.comments' | translate }}</b>\n</th>\n<th>\n<b>{{ 'branch_mgmt.item_holds.verifyDate' | translate }}</b>\n</th>\n<th>\n<b>{{ 'branch_mgmt.item_holds.holdId' | translate }}</b>\n</th>\n<th>\n<b>{{ 'branch_mgmt.item_holds.supvApproveId' | translate }}</b>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>{{model.holdVerifyData.vaultDate | date: 'MM-dd-yyyy' }}</td>\n<td>{{ ((model.holdVerifyData.bulkVerified).toString()).charAt(0).toUpperCase() + ((model.holdVerifyData.bulkVerified).toString()).slice(1)}}</td>\n<td ng-if=\"model.holdVerifyData.comments\">{{model.holdVerifyData.comments}}</td>\n<td ng-if=\"!model.holdVerifyData.comments\">{{ 'forceCloseHold.n_a' | translate }}</td>\n<td>{{model.holdVerifyData.verifyDate | date: 'MM-dd-yyyy | hh:mm a' }}</td>\n<td>{{model.holdVerifyData.holdId}} | {{model.holdVerifyData.hold.trackingId}}</td>\n<td>{{model.holdVerifyData.supvApproveId}} | {{model.holdVerifyData.supvApprove.firstName}} {{model.holdVerifyData.supvApprove.lastName}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.errorCode\">\n<div class=\"alert alert-danger margin-zero\">\n{{ model.errorCode | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'branch_mgmt.item_holds.close' | translate }}\n</button>\n</div>\n</form>";
var id1="itemHoldLog.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2559 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form class=\"form-validate\" name=\"itemNotDeliveredForm\" novalidate>\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'itemNotDeliveredModal.title' | translate}}</h4>\n</div>\n<div class=\"text-align-center margin-top-10 margin-bottom-10\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" ng-if=\"!model.loading\">\n<div class=\"row\">\n<div class=\"form-group\" ng-class=\"{'col-sm-4': model.shipTypeObj.shiptypeId && model.shipTypeObj.shiptypeId.coinFlag,\n      'col-sm-6': model.shipTypeObj.shiptypeId && !model.shipTypeObj.shiptypeId.coinFlag,}\">\n<label>{{'itemNotDeliveredModal.tracking_id' | translate}} *</label>\n<input class=\"form-control\" ng-model=\"model.updatedTrackingId\" required/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"model.shipTypeObj.shiptypeId && model.shipTypeObj.shiptypeId.coinFlag\">\n<label>{{'itemNotDeliveredModal.amount' | translate}} *</label>\n<input id=\"amountCoin\" type=\"text\" ng-currency class=\"form-control\" ng-model=\"model.amount\" ng-change=\"validateLoadedAmount()\" placeholder=\"$0.00\" ng-disabled=\"true\" required/>\n</div>\n<div class=\"form-group col-sm-6\" ng-if=\"model.shipTypeObj.shiptypeId && !model.shipTypeObj.shiptypeId.coinFlag\">\n<label>{{'itemNotDeliveredModal.amount' | translate}} *</label>\n<input id=\"amountCash\" type=\"text\" class=\"form-control\" ng-model=\"model.amount\" ng-currency required/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"model.shipTypeObj.shiptypeId && model.shipTypeObj.shiptypeId.coinFlag\">\n<label>{{'itemNotDeliveredModal.quantity' | translate}} *</label>\n<input type=\"number\" class=\"form-control\" ng-model=\"model.qty\" required min=\"0\" ng-change=\"validateLoadedAmount()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"/>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-12\">\n<label>{{'itemNotDeliveredModal.destination' | translate}} *</label>\n<search-and-select ng-model=\"model.toLocationListObj.destinationId\" values=\"model.toLocationListObj.toLocationOptions\" key=\"Key\" value=\"Value\" totalrecords=\"model.toLocationListObj.totalRecords\" onscroll=\"getShipmentDestinations(searchKey, offset)\" none-selected=\"'common.none'\" ng-disabled=\"model.toLocationListObj.loading\" ng-change=\"getNextVaultDate()\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-6\">\n<label>{{'itemNotDeliveredModal.ship_type' | translate}} *</label>\n<search-and-select ng-model=\"model.shipTypeObj.shiptypeId\" values=\"model.shipTypeObj.shipTypeList\" key=\"Key\" value=\"Value\" totalrecords=\"model.shipTypeObj.totalShipTypes\" onscroll=\"loadShipType(searchKey, offset)\" none-selected=\"'common.none'\" ng-disabled=\"model.shipTypeObj.loading\" ng-change=\"validateLoadedAmount()\" required>\n</search-and-select>\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'itemNotDeliveredModal.fromLocation' | translate}} *</label>\n<search-and-select ng-model=\"model.fromLocationListObj.fromLocationId\" values=\"model.fromLocationListObj.fromLocationOptions\" key=\"Key\" value=\"Value\" totalrecords=\"model.fromLocationListObj.totalRecords\" onscroll=\"getLocationList(searchKey, offset)\" none-selected=\"'common.none'\" ng-disabled=\"model.fromLocationListObj.loading\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-6\">\n<label>{{ 'itemNotDeliveredModal.not_delivered_reason' | translate }} *</label>\n<select class=\"form-control\" ng-model=\"model.selectedReason\" ng-options=\"message.description as message.description for message in model.reasons\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">{{'itemNotDeliveredModal.pleaseSelect' | translate}}</option>\n</select>\n</div>\n<div class=\"form-group col-sm-6\" ng-if=\"model.notDeliveredResolution\">\n<label>{{ 'itemNotDeliveredModal.delivery_resolution' | translate }} *</label>\n<select class=\"form-control\" ng-model=\"model.deliveryResolution\" ng-change=\"getNextVaultDate()\" ng-options=\"message.description as message.description for message in model.deliveryResolutions\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">{{'itemNotDeliveredModal.pleaseSelect' | translate}}</option>\n</select>\n</div>\n</div>\n<div class=\"row\" ng-if=\"model.notDeliveredResolution && model.isReRoute\">\n<div class=\"form-group col-sm-6\" style=\"margin-bottom: 0 !important;\">\n<label>{{ 'common.vault_date' | translate }} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"model.date\" date-format=\"dd-MMM-yyyy\" ng-change=\"loadRoutes()\" hidden-time=\"true\" date-options=\"minVaultDate\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.date}\" timezone=\"UTC\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n<div class=\"form-group col-sm-6 mb-0\">\n<label>{{ 'checkout.route' | translate }} *</label>\n<select class=\"form-control\" ng-model=\"model.routeId\" ng-change=\"routeSequenceChanged()\" required ng-options=\"route.routeId as route.routeName for route in model.routeList\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"row\" ng-if=\"model.notDeliveredResolution\">\n<div class=\"form-group col-sm-12\">\n<label>{{ 'itemNotDeliveredModal.resolution_notes' | translate }}</label>\n<textarea class=\"form-control\" ng-model=\"model.note\"></textarea>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" ng-class=\"{'disabled': itemNotDeliveredForm.$invalid || model.loading}\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"model.loading\">\n<span ng-show=\"model.isReRoute == false\"> {{'itemNotDeliveredModal.sendToHold' | translate}}</span>\n<span ng-show=\"model.isReRoute\"> {{'itemNotDeliveredModal.reRoute' | translate}}</span>\n<span ng-show=\"model.isReRoute == null\">{{ 'common.save' | translate }}</span>\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"model.loading\"></span>\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">{{ 'common.cancel' | translate }}</button>\n</div>\n</form>\n";
var id1="itemNotDelivered.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"lastOrderInfoTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}} modal.dialog\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'orderPacking.last_order_details' | translate}}</b> | {{model.shipment.toLocationId}}</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad font-12\" ng-if=\"model.lastOrderDetails.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>{{'atm_residual.orderNo' | translate}}</th>\n<th>{{'orderPacking.load_tracking_id' | translate}}</th>\n<th>{{'orderPacking.load_denom_id' | translate}}</th>\n<th>{{'orderPacking.load_delivery_date' | translate}}</th>\n<th>{{'orderPacking.load_amount' | translate}}</th>\n<th>{{'orderPacking.residual_tracking_id' | translate}}</th>\n<th>{{'orderPacking.residual_denom_id' | translate}}</th>\n<th>{{'orderPacking.residual_amount' | translate}}</th>\n<th>{{'orderPacking.is_counted' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.lastOrderDetails track by $index\">\n<td>\n<a href=\"#\" ng-click=\"goToOrderHistory(data)\">\n{{data.orderNo}}\n</a>\n</td>\n<td>{{data.loadTrackingId}}</td>\n<td class=\"text-center\"><img ng-src=\"assets/images/{{data.loadDenominationId}}.png\" class=\"img-width\"/></td>\n<td class=\"remove-white-space\">{{data.loadDeliveryDate | date:'yyyy-MM-dd | hh:mm a'}}</td>\n<td>{{data.loadAmount | currency:\"$\"}}</td>\n<td>{{data.residualTrackingId}}</td>\n<td class=\"text-center\"><img ng-src=\"assets/images/{{data.residualDenominationId}}.png\" class=\"img-width\"/></td>\n<td>{{data.residualAmount | currency:\"$\"}}</td>\n<td class=\"text-center\" ng-if=\"data.residualIsCounted\"><img src=\"" + __webpack_require__(89) + "\" class=\"img-width\"/></td>\n<td class=\"text-center\" ng-if=\"!data.residualIsCounted\"><img src=\"" + __webpack_require__(69) + "\" class=\"img-width\"/></td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.lastOrderDetails.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.lastOrderDetails.length}\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n<style>\n.modal-dialog {\n        width: 85%\n    }\n</style>";
var id1="lastOrderInfo.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2561 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"ledgerTransactionLogTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{'transaction_log.title' | translate}}</strong>\n</h4>\n</div>\n<div class=\"text-align-center margin-top-10\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"table-responsive\">\n<table class=\"table table-hover table-bordered remove-pad font-12\" ng-if=\"model.logs.ledgerTransaction && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'transaction_log.transaction_id' | translate}}</th>\n<th class=\"text-center\">{{'transaction_log.account' | translate}}</th>\n<th class=\"text-center\">{{'transaction_log.funding_source' | translate}}</th>\n<th class=\"text-center\">{{'common.comment' | translate}}</th>\n<th class=\"text-center\">{{'transaction_log.order_no' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr>\n<td>{{ model.logs.ledgerTransaction.id }}</td>\n<td>{{ model.logs.ledgerTransaction.account }}</td>\n<td>{{ model.logs.ledgerTransaction.sourceName }}</td>\n<td ng-if=\"model.logs.ledgerTransaction.comment\">\n<div ng-if=\"model.logs.ledgerTransaction.isPackable && model.logs.ledgerTransaction.orderNo\">\n<span>Order Pack | </span>\n<a href=\"#\" ng-click=\"goToOrderHistory(model.logs.ledgerTransaction)\">{{model.logs.ledgerTransaction.orderNo}}</a>\n</div>\n<div ng-if=\"!model.logs.ledgerTransaction.isPackable && model.isValid\">\n<span>{{splitString[0].split(':')[0]}}:</span>\n<a href=\"#\" ng-click=\"goToAtmCount()\">\n{{trackingId}}\n</a>\n<span>{{splitString[1]}}</span>\n</div>\n<span ng-if=\"!model.logs.ledgerTransaction.isPackable && !model.isValid\">\n{{model.logs.ledgerTransaction.comment}}\n</span>\n</td>\n<td ng-if=\"!model.logs.ledgerTransaction.comment\">{{'common.n_a' | translate}}</td>\n<td ng-if=\"model.logs.ledgerTransaction.orderNo\">\n<a href=\"#\" ng-click=\"goToOrderHistory(model.logs.ledgerTransaction)\">\n{{model.logs.ledgerTransaction.orderNo}}\n</a>\n</td>\n<td ng-if=\"!model.logs.ledgerTransaction.orderNo\">{{'common.n_a' | translate}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"table-responsive\">\n<table class=\"table table-hover table-bordered remove-pad margin-top-10 font-12\" ng-if=\"model.logs.results.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'transaction_log.denomination' | translate}}</th>\n<th class=\"text-center\">{{'transaction_log.starting_balance' | translate}}</th>\n<th class=\"text-center\">{{'transaction_log.amount' | translate}}</th>\n<th class=\"text-center\">{{'transaction_log.date_time' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"log in model.logs.results\" ng-if=\"log.denominationId\">\n<td>{{ log.denominationId }}</td>\n<td>{{ model.ledgerEntry.prevBalance | currency:(log.symbol || (model.logs.ledgerTransaction.currency && model.logs.ledgerTransaction.currency.symbol) || '$') }}</td>\n<td>{{ log.amount | currency:(log.symbol || (model.logs.ledgerTransaction.currency && model.logs.ledgerTransaction.currency.symbol) || '$') }}</td>\n<td>{{ log.timestamp | date : 'MM-dd-yyyy | hh:mm a' }}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"!model.logs.results.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.logs.results.length}\" style=\"margin-bottom: 0px;\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n</div>\n</form>";
var id1="ledgerTransactionLog.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2562 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"locationHoldReleaseModal\" class=\"form-validate\" novalidate ng-submit=\"validateSupervisorScan()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'locationHold.title' | translate }}</strong> <span ng-if=\"model.locationId\">| {{ model.locationId }}</span></h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group col-sm-12\" ng-if=\"model.locationId\">\n<label>{{ 'locationHold.reasonCode' | translate }} *</label>\n<select class=\"form-control\" ng-model=\"model.selectedReason\" ng-options=\"message for message in results\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"_form-group col-sm-12\">\n<label>{{ 'locationHold.comment' | translate }} *</label>\n<textarea class=\"form-control\" rows=\"3\" ng-model=\"model.comment\" style=\"border-radius: 5px\" required></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"locationHoldReleaseModal.$invalid || model.loading || isLoading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span> {{ 'locationHold.title' | translate }}\n</button>\n</div>\n</form>";
var id1="locationHoldRelease.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2563 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'location.location_logs' | translate}}</b> | {{model.lid}}\n</h4>\n<div class=\"margin-top-05 col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"navbar-collapse col-sm-12\">\n<form class=\"navbar-form d-flex\">\n<div>\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"model.searchText\">\n</div>\n<div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"refresh()\" uib-tooltip=\"{{ 'log.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</div>\n<div class=\"form-group\">\n<select class=\"form-control\" ng-options=\"entryType.value as entryType.label for entryType in model.entryTypes | orderBy:'label'\" ng-model=\"model.entryType\" ng-change=\"model.page = 1; loadData();\">\n<option value=\"\">({{'common.All' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"model.dateRange\" ng-change=\"loadData(model.dateRange)\" ng-if=\"model.dateRange.startDate\" options=\"model.dateRangPickerOptions\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<button class=\"btn btn-success\" ng-click=\"$ctrl.print()\" ng-if=\"$ctrl.contractLogs && $ctrl.contractLogs.length && !$ctrl.loading\"> <i class=\"glyphicon glyphicon-print\"></i> {{'routeSheet.print' | translate}}</button>\n<button class=\"btn btn-primary\" ng-disabled=\"$ctrl.isExporting\" ng-click=\"$ctrl.exportToCsv()\" ng-if=\"$ctrl.contractLogs && $ctrl.contractLogs.length && !$ctrl.loading\">{{'branch_mgmt.daily_balance_sheet.export' | translate}} <span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isExporting\"></span></button>\n</form>\n</div>\n</div>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div ng-class=\"{'form-group': model.locationLogs.length  || model.locationLogsLoading}\">\n<div ng-if=\"!model.locationLogsLoading\">\n<div ng-if=\"model.locationLogs && model.locationLogs.length\">\n<div class=\"col-sm-12 panel-group list-group remove-right-pad\" id=\"accordion\">\n<div class=\"panel panel-default margin-left-10 margin-right-10\" ng-repeat=\"log in model.locationLogs track by log.id\">\n<div class=\"panel-heading cust-panel-color\" data-toggle=\"collapse\" data-target=\"#{{log.id}}\" aria-expanded=\"false\" aria-controls=\"{{log.id}}\" ng-class=\"{ 'log-warning': log.flagged }\">\n<h4 class=\"panel-title cursor-pointer\">\n<a class=\"accordion-toggle\">\n<strong>{{log.readableEntryType + ' '}} </strong>\n<span ng-if=\"log.userId\">{{'log.by' | translate}}</span>\n{{' ' + log.user.firstName + ' ' + log.user.lastName + ' '}}\n<span ng-if=\"log.message\"> | <span class=\"message-color\">{{log.message}}</span></span>\n<span class=\"pull-right\">{{log.createdAt | date: 'short'}}</span>\n</a>\n</h4>\n</div>\n<div id=\"{{log.id}}\" class=\"panel-collapse collapse multi-collapse\">\n<div class=\"panel-body\">\n<table class=\"table table-bordered table-striped remove-pad-bottom\">\n<tr ng-repeat=\"detail in log.extraDetails\">\n<td>{{detail.key}}</td>\n<td class=\"wrap-text\">{{detail.value}}</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n<div class=\"margin-top-10 margin-left-10 margin-bottom-10\">\n<ul uib-pagination total-items=\"model.total\" ng-if=\"model.total>=model.pageLimit\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" items-per-page=\"model.pageLimit\" ng-model=\"model.page\" ng-change=\"pageChange()\" rotate=\"false\" max-size=\"model.maxPages\"></ul>\n</div>\n</div>\n</div>\n<div class=\"margin-05 col-sm-12\" ng-if=\"!model.locationLogs || !model.locationLogs.length\">\n<div class=\"alert alert-danger text-center text-danger\" style=\"margin-bottom: 10px;\">\n{{'log.noLogs' | translate}}\n</div>\n</div>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.locationLogsLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n";
var id1="locationLogs.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2564 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"lockStatusTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>Lock Status</b> | {{model.routeId}} | {{model.date}}</h4>\n</div>\n<div class=\"text-align-center margin-top-10\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad remove-bottom-margin\" ng-if=\"model.lockStatusData.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"locid-width-150\">{{'atm_codes_mgmt.location_id' | translate}}</th>\n<th class=\"loc-status-width-100\">{{'atm_codes_mgmt.lock_type' | translate}}</th>\n<th class=\"loc-status-width-100\">{{'atm_codes_mgmt.lock_name' | translate}}</th>\n<th class=\"loc-status-width-100\">{{'atm_codes_mgmt.key_id' | translate}}</th>\n<th class=\"loc-status-width-100\">{{'atm_codes_mgmt.status' | translate}}</th>\n<th>{{'atm_codes_mgmt.error_message' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.lockStatusData track by $index\">\n<td>{{ data.lockname || data.serialNo || data.serno }}</td>\n<td>{{ data.locktype || data.lockType }}</td>\n<td>\n<span ng-if=\"data.locktype && data.locktype === 'TDS'\">{{data.serialNo}}</span>\n<span ng-if=\"data.lockName && data.locktype !== 'TDS'\">{{data.lockName}}</span>\n<span ng-if=\"!data.lockName\">{{'common.n_a' | translate}}</span>\n</td>\n<td ng-if=\"data.keyId\">{{ data.keyId }}</td>\n<td ng-if=\"!data.keyId\">\n<span ng-if=\"(data.locktype === 'LMS' && model.userData.OTCKeys && model.userData.OTCKeys[data.company].SGKeyId)\">{{model.userData.OTCKeys[data.company].SGKeyId}}</span>\n<span ng-if=\"(data.locktype === 'LMS' && model.userData.OTCKeys && !model.userData.OTCKeys[data.company].SGKeyId)\">{{ 'common.n_a' | translate }}</span>\n<span ng-if=\"(data.locktype === 'FLM' && model.userData.OTCKeys && model.userData.OTCKeys[data.company].kabaKeyId)\">{{model.userData.OTCKeys[data.company].kabaKeyId}}</span>\n<span ng-if=\"(data.locktype === 'FLM' && model.userData.OTCKeys && !model.userData.OTCKeys[data.company].kabaKeyId)\">{{ 'common.n_a' | translate }}</span>\n<span ng-if=\"(data.locktype === 'RTE' && model.userData.OTCKeys && model.userData.OTCKeys[data.company].routeKeyId)\">{{model.userData.OTCKeys[data.company].routeKeyId}}</span>\n<span ng-if=\"(data.locktype === 'RTE' && model.userData.OTCKeys && !model.userData.OTCKeys[data.company].routeKeyId)\">{{ 'common.n_a' | translate }}</span>\n<span ng-if=\"((data.locktype === 'witz' || data.locktype === 'TDS') && model.userData.OTCKeys && model.userData.OTCKeys[data.company].witzKeyId)\">{{model.userData.OTCKeys[data.company].witzKeyId}}</span>\n<span ng-if=\"((data.locktype === 'witz' || data.locktype === 'TDS') && model.userData.OTCKeys && !model.userData.OTCKeys[data.company].witzKeyId)\">{{ 'common.n_a' | translate }}</span>\n</td>\n<td>\n<span>{{data.status || data.lockStatus || 'common.n_a' | translate}}</span>\n</td>\n<td ng-if=\"data.message.length\">{{ data.message }}</td>\n<td ng-if=\"!data.message.length\">{{ 'common.n_a' | translate }}</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!model.lockStatusData.length && !model.loading\">\n<div class=\"alert alert-danger text-center remove-bottom-margin\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" ng-disabled=\"model.loading\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="lockStatus.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2565 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"logisticItemAssignTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>Assign</strong> <span>| {{ model.barcode }}</span>\n</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!model.loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group col-sm-12\">\n<label>{{ 'common.route' | translate }} <span ng-if=\"!model.userKey\">*</span></label>\n<search-and-select ng-model=\"model.route\" values=\"model.allRoutes\" key=\"Key\" totalrecords=\"model.totalRecord\" onscroll=\"loadRoutes(searchKey, offset)\" none-selected=\"'common.none'\" ng-click=\"itemAssignmentChanged(model, $index, 'route')\" ng-required=\"!model.userKey\">\n</search-and-select>\n</div>\n<div class=\"form-group col-sm-12\">\n<label>{{ 'users.user' | translate }} <span ng-if=\"!model.route\">*</span></label>\n<search-and-select ng-model=\"model.userKey\" values=\"model.userList\" key=\"Key\" totalrecords=\"model.totalUsers\" onscroll=\"loadUsers(searchKey, offset)\" none-selected=\"'common.none'\" ng-click=\"itemAssignmentChanged(model, $index, 'user')\" ng-required=\"!model.route\">\n</search-and-select>\n</div>\n<div class=\"_form-group col-sm-12\">\n<label>{{ 'common.comment' | translate }}</label>\n<textarea class=\"form-control\" rows=\"2\" ng-model=\"model.notes\" style=\"border-radius: 5px\"></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"logisticItemAssignTemplate.$invalid || model.loading\">\n{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>";
var id1="logisticItemAssign.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2566 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"logisticItemHoldReleaseTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{'shipment.HOLD_RELEASE' | translate}}</strong> <span>| {{ model.barcode }}</span>\n</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!model.loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"_form-group col-sm-12\">\n<label>{{ 'common.comment' | translate }}</label>\n<textarea class=\"form-control\" rows=\"2\" ng-model=\"model.notes\" required style=\"border-radius: 5px\"></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"logisticItemHoldReleaseTemplate.$invalid || model.loading\">\n{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>";
var id1="logisticItemHoldRelease.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2567 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"logisticItemListTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<span ng-if=\"model.stat === 'remaining'\"><b>{{'checkout.remainingItems'| translate}}</b></span>\n<span ng-if=\"model.stat === 'checkedOut'\"><b>{{'atm_codes_mgmt.checked_out' | translate}}</b></span>\n<span ng-if=\"model.stat === 'checkedIn'\"><b>{{'atm_codes_mgmt.check_in' | translate}}</b></span>\n<span ng-if=\"model.stat === 'available'\"><b>Available Items</b></span>\n| {{model.routeId}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-striped table-bordered table-pad-5 remove-bottom-margin\" ng-if=\"model.itemList.length\">\n<thead class=\"text-center\">\n<tr class=\"header-row\">\n<td><strong>{{'item.items' | translate}}</strong></td>\n<td><strong>{{'atm_residual.trackingId' | translate}}</strong></td>\n<td><strong>{{'common.notes' | translate}}</strong></td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in model.itemList track by $index\">\n<td>{{data.label}}</td>\n<td>{{data.barcode}}</td>\n<td>\n<span ng-if=\"data.notes\">{{data.notes}}</span>\n<span ng-if=\"!data.notes\">{{'common.n_a' | translate}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.itemList.length\">\n<div class=\"col-sm-12 alert text-center alert-danger remove-bottom-margin\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="logisticItemList.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2568 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"makeDeliverableTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"chkTitle\">{{'branch_mgmt.make_deliverable' | translate}} | <b>{{model.trackingId}}</b></h4>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 modal-body\" id=\"modal-body\">\n<div class=\"col-sm-6\">\n<label for=\"route\">{{'closeVault.route' | translate}} *</label>\n<search-and-select ng-model=\"model.route\" values=\"model.routeObj.results\" key=\"Key\" totalrecords=\"model.routeObj.totalRecords\" onscroll=\"loadRoutes(searchKey, offset)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div class=\"col-sm-6 common-date-picker-section\">\n<label for=\"vaultDate\">{{'softDeletedShipments.vault_date' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"delivery-date\" ng-model=\"model.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.vaultDate}\" ng-keydown=\"$event.preventDefault()\" date-options=\"minVaultDate\">\n</datetimepicker>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"model.loading || makeDeliverableTemplate.$invalid\">\n{{'common.ok' | translate}}\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n</div>\n</form>";
var id1="makeDeliverable.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2569 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"markAllDeliveredListForm\" class=\"form-validate\" novalidate ng-submit=\"confirm()\">\n<div class=\"modal-header\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{ 'vaultOperations.mark_all_delivered' | translate }}</b> | Route: {{routeId}}\n</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"text-align-center margin-top-20 margin-bottom-20\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading && errorMessage\" class=\"alert alert-danger text-center\">\n{{errorMessage}}\n</div>\n<div ng-if=\"!loading && !shipments.length && !errorMessage\" class=\"alert alert-warning text-center\">\nNo pending deliveries found on this route.\n</div>\n<div ng-if=\"!loading && shipments.length\">\n<p style=\"font-weight: bold; margin-bottom: 10px;\">The following shipments will be marked as delivered:</p>\n<table class=\"table table-hover table-bordered remove-pad\">\n<thead>\n<tr class=\"header-row\">\n<td><b>{{ 'common.trackingId' | translate }}</b></td>\n<td><b>{{ 'addBagModal.destination' | translate }}</b></td>\n<td><b>{{ 'addBagModal.amount' | translate }}</b></td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in shipments\">\n<td>\n<a href=\"#\" ng-click=\"goToItemHistory(shipment.trackingId)\">\n{{shipment.trackingId}}\n</a>\n</td>\n<td>\n<a href=\"#\" ng-click=\"goToServiceHistory(shipment.toLocationId)\">\n{{shipment.toLocationId}}\n</a> | {{shipment.toLocationName}}\n</td>\n<td>{{shipment.amount | currency:\"$\"}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" type=\"submit\" ng-if=\"!loading && shipments.length\">\n{{ 'Confirm' | translate }}\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">\n<span ng-if=\"loading || shipments.length\">{{ 'Cancel' | translate }}</span>\n<span ng-if=\"!loading && !shipments.length\">{{ 'Close' | translate }}</span>\n</button>\n</div>\n</form>\n";
var id1="markAllDeliveredList.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2570 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"markAsDeliveredFrom\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'itemHolds.shipment_delivery' | translate}}</b><span> | {{model.shipment.trackingId}}</span></h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; height: 100px;\">\n<div class=\"form-group col-sm-6 remove-bottom-margin\">\n<label for=\"deliveryDate\">{{'shipmentBatch.deliveryDate' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"model.date\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.date}\" ng-keydown=\"$event.preventDefault()\" date-options=\"minVaultDate\">\n</datetimepicker>\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"deliveryTime\">{{'itemHolds.deliveryTime' | translate}} *</label>\n<input type=\"time\" class=\"form-control\" ng-model=\"model.time\" required>\n</div>\n<div class=\"form-group col-sm-12\">\n<label for=\"amount\">{{'branch_mgmt.mark_as_delivered.delivered_amount' | translate}} *</label>\n<input id=\"loaded-amount\" type=\"text\" ng-currency class=\"form-control\" ng-model=\"model.loadedAmount\" ng-change=\"validateLoadedAmount()\" placeholder=\"$0.00\" required/>\n</div>\n<div class=\"form-group col-sm-12\">\n<label>{{ 'location.comment' | translate }} *</label>\n<textarea class=\"form-control\" rows=\"3\" ng-model=\"model.comment\" style=\"border-radius: 5px\" required></textarea>\n</div>\n<div class=\"form-group col-sm-12\" ng-if=\"model.amountExceeds\">\n<div class=\"alert alert-danger text-center text-danger\" style=\"margin-bottom: 0px;\">\n{{'shipment.loadAmountExceedError' | translate}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-scondary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"markAsDeliveredFrom.$invalid || model.amountExceeds\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\">\n{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>";
var id1="markAsDelivered.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2571 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"markUndeliveredWithCRV\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'vaultOperations.bagout.mark_undeliver' | translate}} | {{model.shipments.trackingId}}</h4>\n</div>\n<div ng-if=\"!loading\" class=\"list-group remove-bottom-margin\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group form-checbox remove-bottom-margin\" ng-if=\"model.shipments.isFundingSourceTied && model.shipments.orderType\">\n<input type=\"checkbox\" name=\"fancy-checkbox-default\" ng-model=\"model.convertToCRV\" ng-click=\"setFocus()\" id=\"fancy-checkbox-default\" autocomplete=\"off\"/>\n<div class=\"btn-group btn-checkbox-group\">\n<label for=\"fancy-checkbox-default\" class=\"btn btn-default\">\n<span class=\"glyphicon glyphicon-ok\"></span>\n<span> </span>\n</label>\n<label for=\"fancy-checkbox-default\" class=\"btn btn-warning\">\n{{'itemHolds.converttocrv' | translate}}\n</label>\n</div>\n</div>\n<div class=\"form-group\" ng-style=\"{'margin-top': model.shipments.isFundingSourceTied ? '16px' : '0'}\" ng-if=\"!model.shipments.isFundingSourceTied\">\n<label for=\"reason\">{{'common.reason' | translate}}</label> <span style=\"color: red\">*</span>\n<textarea id=\"reason\" name=\"reason\" class=\"form-control\" ng-model=\"model.reason\" required rows=\"3\"></textarea>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-secondary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">{{'common.cancel' | translate}}</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"markUndeliveredWithCRV.$invalid || model.loading\">\n{{'common.ok' | translate}} <span ng-if=\"model.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n</div>\n</form>\n";
var id1="markUndeliveredWithCRV.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2572 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header d-flex justify-content-between align-items-center\">\n<h4 class=\"modal-title\" id=\"modal-title-top\">\n{{formattedDate}} | <b>{{count}}</b> Orders | <b>{{totalAmount | currency:'$':2}}</b>\n</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body-top\" style=\"width: 100%; max-height: 450px; overflow-y: auto;\">\n<div class=\"row margin-bottom-20\">\n<div class=\"col-sm-12 text-center\" style=\"display: flex; justify-content: center; flex-wrap: wrap;\">\n<div class=\"d-inline-flex align-items-center margin-right-20\" ng-repeat=\"denom in denomTotals\" style=\"margin: 10px;\">\n<denom-icon denom-id=\"denom.id\" icon-size=\"30\"></denom-icon>\n<span style=\"font-size: 16px; margin-left: 10px;\">{{denom.amount | currency:'$':2}}</span>\n</div>\n</div>\n</div>\n<div class=\"table-responsive\">\n<table class=\"table table-bordered table-striped text-align-center\" id=\"order-details-table\">\n<thead>\n<tr>\n<th class=\"text-align-center\" style=\"min-width: 200px;\">Tracking ID</th>\n<th class=\"text-align-center\">Location</th>\n<th class=\"text-align-center\" style=\"min-width: 120px;\">Order Type</th>\n<th class=\"text-align-center contents-no-wrap\" style=\"min-width: 120px;\">Order No.</th>\n<th class=\"text-align-center\">Amount</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"order in orders\">\n<td>\n<div ng-if=\"order.parentTrackingId\"><a href ng-click=\"goToShipment(order.parentTrackingId)\">{{order.parentTrackingId}}</a></div>\n<div ng-if=\"!order.parentTrackingId && order.trackingIds && order.trackingIds.length > 0\" ng-repeat=\"trackingId in order.trackingIds track by $index\">\n<a href ng-click=\"goToShipment(trackingId)\">{{trackingId}}</a>\n</div>\n<div ng-if=\"!order.parentTrackingId && (!order.trackingIds || order.trackingIds.length === 0)\">N/A</div>\n</td>\n<td>\n<a href ng-click=\"goToLocation(order.toLocationId)\">{{order.toLocationId}}</a> | <span>{{order.toLocationName}}</span>\n</td>\n<td>\n<div ng-if=\"order.orderType\">{{ ('atm_residual.order_type_' + order.orderType) | translate }}</div>\n<div ng-if=\"!order.orderType && !order.shiptypeId\">{{ 'common.n_a' | translate }}</div>\n<div ng-if=\"!order.orderType && order.shiptypeId\">{{ order.shiptypeId | translate }}</div>\n</td>\n<td>\n<div ng-if=\"order.orderNo\"><a href ng-click=\"goToOrderHistory(order.orderNo, order.fundingSourceId)\">{{order.orderNo}}</a></div>\n<div ng-if=\"!order.orderNo\">N/A</div>\n</td>\n<td>\n<strong>{{order.amount | currency:'$':2}}</strong>\n<div class=\"margin-top-5 small\" ng-if=\"order.denominations && order.denominations.length > 0\">\n<span ng-repeat=\"denom in order.denominations\" class=\"margin-right-10\" style=\"display: inline-flex; align-items: center; margin-top: 5px;\">\n<denom-icon denom-id=\"denom.id\" icon-size=\"20\"></denom-icon>\n<span style=\"margin-left: 5px;\">{{denom.amount | currency:'$':2}}</span>\n</span>\n</div>\n</td>\n</tr>\n<tr ng-if=\"orders.length === 0\">\n<td colspan=\"4\">No orders available.</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"printData()\">Print</button>\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"exportData()\">Export</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Close</button>\n</div>\n<style>\n.master-cash-orders-modal .modal-dialog {\n        width: 1000px;\n    }\n</style>\n";
var id1="masterCashOrderDetails.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2573 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"moveShipmentFrom\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'closeVault.move_shipment' | translate}}</b><span> | {{model.shipmentData.trackingId}}</span></h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; height: 100px;\">\n<div class=\"form-group col-sm-6\">\n<label for=\"vaultdate\">{{'closeVault.vault_date' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"model.date\" date-format=\"dd-MMM-yyyy\" ng-click=\"loadRoutes()\" hidden-time=\"true\" date-options=\"minVaultDate\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.date}\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"route\">{{'closeVault.route' | translate}} *</label>\n<search-and-select ng-model=\"model.route\" values=\"model.allRoutes\" key=\"Key\" totalrecords=\"model.totalRecord\" onscroll=\"loadRoutes(searchKey, offset)\" none-selected=\"'common.none'\" common-search-flag=\"true\" required></search-and-select>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-scondary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"model.loading || !model.route\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\">\n{{ 'closeVault.move' | translate }}\n</button>\n</div>\n</form>";
var id1="moveShipment.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2574 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"nextScheduledOccurencesTemplate\" class=\"form-validate\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title upcoming-routes-title\" id=\"modal-title\">{{'routeAssugment.upcoming_scheduled_routes' | translate }}</h4>\n</div>\n<div class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body modal-padding-0-16\" id=\"modal-body\">\n<div class=\"upcoming-routes-container\">\n<span class=\"upcoming-routes-heading\">{{ 'common.locationId' | translate }}:</span>\n<span>\n{{model.data.locationId}}\n</span> |\n<span class=\"upcoming-routes-heading\">{{ 'location.day.routeId' | translate }}:</span>\n<span>\n{{model.data.route.Value}}\n</span>\n</div>\n<div class=\"recurring-stop-table-bordered upcoming-routes-px-4\">\n<table class=\"remove-bottom-margin table-pad-3 table table-condensed table-bordered inner-tbl-margin-bottom\">\n<tbody ng-repeat=\"history in model.nextOccurrence track by $index\">\n<tr>\n<th class=\"text-center\">\n{{'location.first_occurrence' | translate}}</th>\n<th class=\"text-center\">\n{{'location.second_occurrence' | translate}}</th>\n<th class=\"text-center\">\n{{'location.third_occurrence' | translate}}</th>\n</tr>\n<tr class=\"_future-location-changes-bg-color\">\n<td class=\"text-center\">\n{{history.next1Occurrence | date: 'fullDate' : 'UTC'}}</td>\n<td class=\"text-center\">\n{{history.next2Occurrence | date: 'fullDate' : 'UTC'}}</td>\n<td class=\"text-center\">\n{{history.next3Occurrence | date: 'fullDate' : 'UTC'}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="nextScheduledOccurences.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2575 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"notDeliveredResolutionTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'message.types.NDR' | translate}}</b> | {{model.trackingId}}\n</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.data\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">\n<b>{{'branch_mgmt.routes.manager_reason' | translate}}</b>\n</th>\n<th class=\"text-center\">\n<b>{{'branch_mgmt.routes.plan_for_resolution' | translate}}</b>\n</th>\n<th class=\"text-center\">\n<b>{{'serviceTickets.note' | translate}}</b>\n</th>\n<th class=\"text-center\">\n<b>{{'branch_mgmt.routes.created_by_user' | translate}}</b>\n</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr>\n<td>{{ model.data.managerReason }}</td>\n<td>{{ model.data.planForResolution }}</td>\n<td>\n<span ng-if=\"model.data.note\">{{ model.data.note }}</span>\n<span ng-if=\"!model.data.note\">{{ 'common.n_a' | translate }}</span>\n</td>\n<td>{{ model.data.createdByUser.id }} | {{ model.data.createdByUser.firstName }} {{ model.data.createdByUser.lastName }}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.data\">\n<div class=\"col-sm-12 alert text-center alert-danger\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="notDeliveredResolution.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2576 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<a role=\"button\"\n                                   ng-repeat=\"denomItem in model.atmSingleDenomShipments\"\n                                   ng-click=\"selectAtmCassetteRowDenom(row, denomItem)\">\n                                    <denom-icon denom-id=\"denomItem.denomIcon\" icon-size=\"22\"></denom-icon>\n                                </a>\n";
var id1="atm-cassette-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
var v2="<form name=\"orderPackModal\" class=\"form-validate\" novalidate>\n<div class=\"modal-header model-title bg-{{type}}\" ng-class=\"{'atm-cassette-header': model.useAtmCassetteMode && model.maxCassettes}\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n{{'orderPacking.menu.title' | translate}}<span ng-if=\"model.orderTypeLabel\"> | {{model.orderTypeLabel}}</span>\n</h4>\n<div class=\"atm-max-cassettes-wrap\" ng-if=\"model.useAtmCassetteMode && model.maxCassettes\">\n<span class=\"atm-max-cassettes-label\">{{'orderPacking.maxCassetteCount' | translate}}</span>\n<span class=\"atm-max-cassettes-badge\">{{ model.usedCassettes || 0 }} / {{ model.maxCassettes }}</span>\n</div>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row form-group\">\n<div class=\"col-sm-3 margin-top-5\">\n{{ model.orderNo }}\n</div>\n<div class=\"col-sm-2 padding-left-right margin-top-5\">\n{{ toLocationId }}\n</div>\n<div class=\"col-sm-3 padding-left-right margin-top-5\">\n{{ model.toLocation }}\n</div>\n<div class=\"col-sm-4 padding-left-right margin-top-5\">\n<span ng-if=\"model.shipmentData.address\">{{model.shipmentData.address}},</span>\n<span ng-if=\"model.shipmentData.city\">{{model.shipmentData.city}},</span>\n<span ng-if=\"model.shipmentData.state\">{{model.shipmentData.state}},</span>\n<span ng-if=\"model.shipmentData.zip\">{{model.shipmentData.zip}}</span>\n<span ng-if=\"!model.shipmentData.address && !model.shipmentData.city && !model.shipmentData.state && !model.shipmentData.zip\">\n{{'common.n_a' | translate}}\n</span>\n</div>\n</div>\n<div class=\"border-order-packing form-validate\">\n<div class=\"row div-pack\">\n<div class=\"col-sm-4 pack-padding\" style=\"margin-top: 5px;\">\n<span>\n{{ 'orderPacking.packRequirements' | translate }}\n</span>\n</div>\n<div ng-class=\"{'col-sm-3': model.gettingRoutes, 'col-sm-4': !model.gettingRoutes}\" class=\"pack-padding\">\n<div class=\"text-center\" ng-if=\"model.hasACL[model.permissionKey]['editRoute']\">\n<select class=\"form-control\" ng-model=\"model.routeId\" ng-options=\"route.routeId as (route.routeId + ' | ' + route.routeName) for route in model.routeList\" ng-disabled=\"model.gettingRoutes\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"remove-left-pad col-sm-1 margin-10\" ng-if=\"model.gettingRoutes\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-20\"></span>\n</div>\n<div class=\"col-sm-3 pack-padding\">\n<div class=\"text-center\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"model.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-disabled=\"model.gettingRoutes\" ng-change=\"onVaultDateChange()\" date-options=\"minVaultDate\" datepicker-append-to-body=\"true\" ng-class=\"{'required-datetimepicker': !model.vaultDate}\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"col-sm-1 pack-padding\">\n<div class=\"pull-right\">\n<img ng-src=\"assets/images/arrow-inbound.png\" class=\"custom-icon img-width\"/>\n</div>\n</div>\n</div>\n<div class=\"row margin0\" ng-class=\"{'p-2': !model.useAtmCassetteMode}\" style=\"border-bottom:  1px solid #d8d6d6;\">\n<div class=\"col-sm-5 remove-left-pad remove-right-pad\">\n<div class=\"row margin0\" style=\"border: 1px solid #d8d6d6;\" ng-repeat=\"denom in model.multipleDenoms\">\n<div class=\"padding6 d-flex align-items-center flex-wrap gap-10\">\n<span>\n<img ng-src=\"assets/images/{{denom.id}}.png\" class=\"custom-icon img-width\"/>\n<span class=\"pack-value\">{{ denom.amount | currency:model.currencySymbol:2 }}</span>\n</span>\n<span ng-if=\"denom.multiDenomPackable && model.sourceType === 'PackableOrder'\" class=\"btn btn-success btn-sm\" style=\"padding: 2px 3px;\">Multi Denom</span>\n<span ng-if=\"denom.willDebitOnPack\" class=\"btn btn-warning btn-sm\" style=\"padding: 2px 3px;\">{{'orderPacking.debitedOnPack' | translate}}</span>\n</div>\n</div>\n</div>\n<div class=\"bags-container\" ng-class=\"{'atm-cassette-bags-full': model.useAtmCassetteMode}\" ng-if=\"!$ctrl.loading\">\n<div ng-if=\"model.sourceType === 'PackableOrder'\">\n<div class=\"padding6 mb-3\" style=\"display: flex;\n                align-items: center;\" ng-if=\"model.multiDenomPackableDenoms.length > 0\">\n<div style=\"width: 44%;\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"custom-icon img-width\"/>\n</div>\n<input type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"model.multiDenomTrackingId\" ng-change=\"checkDuplicateTrackingIds()\" ng-keydown=\"scanLimit(model.multiDenomTrackingId, $event)\" class=\"form-control\" style=\"margin-left: 10px\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(model.multiDenomTrackingId)}\" placeholder=\"{{(model.packCoinSeparately && model.hasCoinMultiDenom && model.hasCashMultiDenom ? 'orderPacking.multiDenom_cash_tracking' : 'orderPacking.multiDenom_tracking') | translate}}\" required capitalize/>\n</div>\n<div class=\"padding6 mb-3\" style=\"display: flex;\n                align-items: center;\" ng-if=\"model.packCoinSeparately && model.hasCoinMultiDenom && model.hasCashMultiDenom\">\n<div style=\"width: 44%;\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"custom-icon img-width\"/>\n</div>\n<input type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"model.multiDenomCoinTrackingId\" ng-change=\"checkDuplicateTrackingIds()\" ng-keydown=\"scanLimit(model.multiDenomCoinTrackingId, $event)\" class=\"form-control\" style=\"margin-left: 10px\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(model.multiDenomCoinTrackingId)}\" placeholder=\"{{'orderPacking.multiDenom_coin_tracking' | translate}}\" required capitalize/>\n</div>\n<div class=\"padding6 mb-3\" style=\"display: flex;\n                align-items: center;\" ng-repeat=\"denom in model.singleDenomPackableDenoms\" ng-if=\"!denom.willDebitOnPack\">\n<div style=\"width: 44%;\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"custom-icon img-width\"/>\n</div>\n<input type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"denom.trackingId\" ng-change=\"checkDuplicateTrackingIds()\" ng-keydown=\"scanLimit(denom.trackingId, $event)\" class=\"form-control\" style=\"margin-left: 10px\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(denom.trackingId)}\" placeholder=\"{{'orderPacking.singleDenom_tracking' | translate}}\" required capitalize/>\n</div>\n<div class=\"padding6 mb-3\" style=\"display: flex; align-items: center;\" ng-repeat=\"shipmentType in model.deliveryToShipmentTypes\">\n<div style=\"width: 44%;\">\n<span class=\"bold-font\" style=\"font-size: 13px;\">{{shipmentType.shiptype.description}}</span>\n</div>\n<input id=\"trackingId{{shipmentType.id}}\" type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"shipmentType.trackingId\" ng-change=\"checkDuplicateTrackingIds();\" placeholder=\"{{shipmentType.shiptype.description}} Tracking ID\" class=\"form-control\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(shipmentType.trackingId)}\" style=\"margin-left: 10px; width: 100%;\" required capitalize/>\n</div>\n</div>\n<div ng-if=\"model.sourceType !== 'PackableOrder'\">\n<div class=\"padding6 mb-3\" style=\"display: flex; align-items: center;\" ng-if=\"!(model.sourceType === 'ATMLoad' && model.isAtmSingleDenomOnly)\">\n<div style=\"width: 44%;\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"custom-icon img-width\"/>\n</div>\n<input id=\"trackingIdDelivery\" type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"model.trackingIdDelivery\" ng-change=\"autoGenerateResidualId(model.trackingIdDelivery); checkDuplicateTrackingIds();\" ng-keydown=\"scanLimit(model.trackingIdDelivery, $event); focusToDeliveryId($event);\" class=\"form-control\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(model.trackingIdDelivery)}\" style=\"margin-left: 10px;\" placeholder=\"Load Tracking Id\" ng-disabled=\"model.isAutoGenerateLoadId || model.gettingRoutes\" required capitalize/>\n</div>\n<div class=\"padding6 mb-3\" style=\"display: flex; align-items: center;\" ng-if=\"!(model.sourceType === 'ATMLoad' && model.isAtmSingleDenomOnly)\">\n<div style=\"width: 44%;\">\n<img ng-src=\"assets/images/bag-residual.png\" class=\"custom-icon img-width\"/>\n</div>\n<input id=\"trackingIdResidual\" type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"model.trackingIdResidual\" ng-change=\"autoGenerateLoadId(model.trackingIdResidual); checkDuplicateTrackingIds();\" ng-keydown=\"scanLimit(model.trackingIdResidual, $event); focusToDeliveryId($event);\" class=\"form-control\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(model.trackingIdResidual)}\" style=\"margin-left: 10px;\" placeholder=\"Residual Tracking Id\" ng-disabled=\"model.isAutoGenerateResidualId || model.gettingRoutes\" required capitalize/>\n</div>\n<div ng-if=\"model.sourceType === 'ATMLoad' && model.atmSingleDenomShipments && model.atmSingleDenomShipments.length\">\n<div class=\"alert alert-danger text-align-center\" ng-if=\"model.useAtmCassetteMode && model.noCassettesAvailable\">\nNo cassettes are available for packing. Cassette capacity for this order has already been fully used ({{ model.usedCassettes || 0 }} / {{ model.maxCassettes }}).\n</div>\n<div class=\"alert alert-danger text-align-center\" ng-if=\"model.atmCassetteCapacityError && !model.noCassettesAvailable && model.maxCassettes >= 6\">\n{{'orderPacking.atmCassetteCapacityExceededAtMax' | translate}}\n</div>\n<div class=\"alert alert-danger text-align-center\" ng-if=\"model.atmCassetteCapacityError && !model.noCassettesAvailable && model.maxCassettes < 6\">\n{{'orderPacking.atmCassetteCapacityExceeded' | translate}}\n</div>\n<div class=\"alert alert-danger text-align-center\" ng-if=\"model.useAtmCassetteMode && !model.atmCassetteCapacityError\" ng-repeat=\"denomLabel in atmCassetteDenomErrors()\">\n{{ denomLabel }} {{'orderPacking.atmCassetteDenomMaxLoadExceeded' | translate}}\n</div>\n<div ng-if=\"model.useAtmCassetteMode\">\n<div class=\"atm-cassette-block\" ng-repeat=\"row in model.atmCassetteRows\">\n<div class=\"atm-cassette-row\">\n<div class=\"atm-cassette-amount-col\">\n<div class=\"input-group atm-cassette-amount-group\">\n<span class=\"input-group-addon atm-cassette-denom-picker\">\n<a role=\"button\" uib-popover-template=\"'atm-cassette-denomination-selection.html'\" popover-is-open=\"row.denomPopoverOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\">\n<denom-icon ng-if=\"getAtmCassetteRowDenom(row)\" denom-id=\"getAtmCassetteRowDenom(row).denomIcon\" icon-size=\"22\"></denom-icon>\n<span ng-if=\"!getAtmCassetteRowDenom(row)\" class=\"glyphicon glyphicon-plus-sign atm-cassette-denom-placeholder\"></span>\n</a>\n</span>\n<input type=\"text\" class=\"form-control atm-cassette-amount-input\" ng-model=\"row.amount\" min=\"0\" fraction=\"2\" ng-currency currency-symbol=\"{{model.currencySymbol || '$'}}\" ng-change=\"onAtmCassetteAmountChange(row)\" ng-disabled=\"model.gettingRoutes || model.atmCassetteCapacityError || !row.denominationId || model.shipment.orderType === 'P' || model.shipment.orderType === 'T'\" placeholder=\"{{'common.amount' | translate}}\"/>\n</div>\n</div>\n<div class=\"atm-cassette-tracking-col\">\n<div class=\"atm-cassette-tracking-row\">\n<div class=\"atm-cassette-tracking-icon\">\n<img ng-if=\"getAtmCassetteRowDenom(row)\" ng-src=\"assets/images/{{getAtmCassetteRowDenom(row).denomIcon}}.png\" class=\"custom-icon img-width\"/>\n</div>\n<input type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"row.trackingId\" ng-change=\"onAtmSingleDenomSplitLoadChange(row); checkDuplicateTrackingIds();\" ng-keydown=\"scanLimit(row.trackingId, $event); focusToDeliveryId($event);\" class=\"form-control atm-cassette-tracking-input\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(row.trackingId)}\" placeholder=\"{{'orderPacking.singleDenom_tracking' | translate}}\" ng-disabled=\"!isAtmCassetteSplitActive(row) || model.isAutoGenerateLoadId || model.gettingRoutes\" ng-required=\"isAtmCassetteSplitActive(row)\" capitalize/>\n</div>\n<div class=\"atm-cassette-tracking-row\">\n<div class=\"atm-cassette-tracking-icon\">\n<img ng-src=\"assets/images/bag-residual.png\" class=\"custom-icon img-width\"/>\n</div>\n<input type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"row.trackingIdResidual\" ng-change=\"onAtmCassetteResidualChange(row); checkDuplicateTrackingIds();\" ng-keydown=\"scanLimit(row.trackingIdResidual, $event); focusToDeliveryId($event);\" class=\"form-control atm-cassette-tracking-input\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(row.trackingIdResidual)}\" placeholder=\"{{'orderPacking.singleDenom_residual_tracking' | translate}}\" ng-disabled=\"!isAtmCassetteSplitActive(row) || model.gettingRoutes\" ng-required=\"isAtmCassetteSplitActive(row)\" capitalize/>\n</div>\n</div>\n</div>\n</div>\n\n</div>\n<div ng-if=\"!model.useAtmCassetteMode\" ng-repeat=\"item in model.atmSingleDenomShipments\">\n<div ng-repeat=\"split in item.splits\">\n<div style=\"display: flex; align-items: center; margin-bottom: 6px;\">\n<div style=\"width: 44%;\">\n<img ng-if=\"item.denomIcon\" ng-src=\"assets/images/{{item.denomIcon}}.png\" class=\"custom-icon img-width\"/>\n</div>\n<input type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"split.trackingId\" ng-change=\"onAtmSingleDenomSplitLoadChange(split); checkDuplicateTrackingIds();\" ng-keydown=\"scanLimit(split.trackingId, $event); focusToDeliveryId($event);\" class=\"form-control\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(split.trackingId)}\" style=\"margin-left: 10px; width: 100%;\" placeholder=\"{{'orderPacking.singleDenom_tracking' | translate}}\" ng-disabled=\"model.isAutoGenerateLoadId || model.gettingRoutes\" required capitalize/>\n</div>\n<div style=\"display: flex; align-items: center; margin-bottom: 6px;\">\n<div style=\"width: 44%;\">\n<img ng-src=\"assets/images/bag-residual.png\" class=\"custom-icon img-width\"/>\n</div>\n<input type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"split.trackingIdResidual\" ng-change=\"checkDuplicateTrackingIds();\" ng-keydown=\"scanLimit(split.trackingIdResidual, $event); focusToDeliveryId($event);\" class=\"form-control\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(split.trackingIdResidual)}\" style=\"margin-left: 10px; width: 100%;\" placeholder=\"{{'orderPacking.singleDenom_residual_tracking' | translate}}\" ng-disabled=\"model.gettingRoutes\" required capitalize/>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"model.useAtmCassetteMode\" class=\"atm-cassette-deposit-align mb-3\" ng-repeat=\"shipmentType in model.deliveryToShipmentTypes\">\n<div class=\"atm-cassette-row\">\n<div class=\"atm-cassette-amount-col\"></div>\n<div class=\"atm-cassette-tracking-col\">\n<div class=\"atm-cassette-tracking-row\">\n<div class=\"atm-cassette-tracking-icon\">\n<span class=\"bold-font\" style=\"font-size: 13px;\">{{shipmentType.shiptype.description}}</span>\n</div>\n<input id=\"trackingId{{shipmentType.id}}\" type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"shipmentType.trackingId\" ng-change=\"validateTrackingId(shipmentType.trackingId); checkDuplicateTrackingIds();\" placeholder=\"{{shipmentType.shiptype.description}} Tracking ID\" class=\"form-control atm-cassette-tracking-input\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(shipmentType.trackingId)}\" required capitalize/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"padding6 mb-3\" style=\"display: flex; align-items: center;\" ng-if=\"!model.useAtmCassetteMode\" ng-repeat=\"shipmentType in model.deliveryToShipmentTypes\">\n<div style=\"width: 44%;\">\n<span class=\"bold-font\" style=\"font-size: 13px;\">{{shipmentType.shiptype.description}}</span>\n</div>\n<input id=\"trackingId{{shipmentType.id}}\" type=\"text\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-model=\"shipmentType.trackingId\" ng-change=\"validateTrackingId(shipmentType.trackingId); checkDuplicateTrackingIds();\" placeholder=\"{{shipmentType.shiptype.description}} Tracking ID\" class=\"form-control\" ng-class=\"{'ng-invalid': duplicateTrackingIds.includes(shipmentType.trackingId)}\" style=\"margin-left: 10px; width: 100%;\" required capitalize/>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"alert alert-danger text-align-center remove-bottom-margin\" ng-if=\"bagScanError\">\n{{bagScanError}}\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}\n</button>\n<button ng-hide=\"model.routeId === model.unassignedRouteId\" id=\"pack-btn\" class=\"btn btn-primary\" type=\"button\" ng-class=\"{'disabled': loading}\" ng-disabled=\"orderPackModal.$invalid || (!model.isPackableOrder && !(model.sourceType === 'ATMLoad' && model.isAtmSingleDenomOnly) && model.trackingIdDelivery == model.trackingIdResidual) || isPack || model.gettingRoutes || hasDuplicateTrackingIds() || (model.useAtmCassetteMode && !isAtmCassettePackReady())\" ng-click=\"pack()\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loading}\"></span> {{'orderPacking.pack' | translate}}\n</button>\n<button id=\"packAndHoldBtn\" class=\"btn btn-primary\" type=\"button\" ng-class=\"{'disabled': loading}\" ng-disabled=\"orderPackModal.$invalid ||  (!model.isPackableOrder && !(model.sourceType === 'ATMLoad' && model.isAtmSingleDenomOnly) && model.trackingIdDelivery == model.trackingIdResidual) || isPack || model.gettingRoutes || hasDuplicateTrackingIds() || (model.useAtmCassetteMode && !isAtmCassettePackReady())\" ng-click=\"packAndHold()\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loading}\"></span>\n{{'orderPacking.packAndHold' | translate}}\n</button>\n<button id=\"pack-and-print\" class=\"btn btn-primary\" type=\"button\" ng-class=\"{'disabled': loading}\" ng-if=\"model.printPackLabel\" ng-disabled=\"orderPackModal.$invalid || (!model.isPackableOrder && !(model.sourceType === 'ATMLoad' && model.isAtmSingleDenomOnly) && model.trackingIdDelivery == model.trackingIdResidual) || isPack || model.gettingRoutes || hasDuplicateTrackingIds() || (model.useAtmCassetteMode && !isAtmCassettePackReady())\" ng-click=\"packAndPrint()\">\n{{'orderPacking.pack_print' | translate}}\n</button>\n</div>\n</form>\n<style>\n/* .modal-dialog {\n        min-width: 60vw;\n        max-width: 50vw\n    } */\n    .form-validate {\n        .ng-invalid {\n            background-color: #F9E3E3 !important;\n        }\n    }\n\n    /* Keep orderPack modal height fixed and scroll contents when inputs grow */\n    #modal-body {\n        max-height: 70vh;\n        overflow-y: auto;\n    }\n\n    .modal-header.model-title.atm-cassette-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .modal-header.model-title .modal-title {\n        text-align: left;\n    }\n\n    .atm-max-cassettes-wrap {\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n        white-space: nowrap;\n        margin-left: auto;\n    }\n\n    .atm-max-cassettes-label {\n        font-weight: 600;\n        font-size: 13px;\n        line-height: 1;\n    }\n\n    .atm-max-cassettes-badge {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        min-width: 28px;\n        padding: 4px 12px;\n        background: #f0ad4e;\n        color: #fff;\n        font-weight: 600;\n        font-size: 13px;\n        line-height: 1;\n        text-align: center;\n        border-radius: 2px;\n    }\n\n    .atm-cassette-bags-full {\n        width: 100%;\n        float: none;\n        display: block;\n        clear: both;\n        padding-left: 0;\n        padding-right: 0;\n        margin-left: 0;\n        margin-right: 0;\n        box-sizing: border-box;\n    }\n\n    .atm-cassette-block {\n        border: 1px solid #d8d6d6;\n        border-radius: 0;\n        padding: 10px;\n        margin: 0 0 12px 0;\n        background: #fff;\n        width: 100%;\n        box-sizing: border-box;\n    }\n\n    /* Match cassette block inset so deposit/pickup tracking lines up with cassette inputs */\n    .atm-cassette-deposit-align {\n        border: 1px solid transparent;\n        padding: 0 10px;\n        margin: 0 0 12px 0;\n        width: 100%;\n        box-sizing: border-box;\n    }\n\n    .atm-cassette-row {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        width: 100%;\n    }\n\n    .atm-cassette-amount-col {\n        width: 38%;\n        min-width: 180px;\n    }\n\n    .atm-cassette-amount-group {\n        width: 100%;\n        display: flex;\n    }\n\n    .atm-cassette-amount-group .input-group-addon.atm-cassette-denom-picker {\n        flex: 0 0 auto;\n        width: auto !important;\n        height: 34px;\n        min-height: 34px;\n        max-height: 34px;\n        padding: 0 10px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid #ccc;\n        border-right: 0;\n        border-radius: 4px 0 0 4px !important;\n        background-color: #eee;\n        box-sizing: border-box;\n        overflow: hidden;\n    }\n\n    .atm-cassette-amount-group .atm-cassette-denom-picker .denom-icon-wrapper,\n    .atm-cassette-amount-group .atm-cassette-denom-picker a {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        line-height: 0;\n    }\n\n    .atm-cassette-amount-group .atm-cassette-denom-picker .denom-icon-sm {\n        max-height: 22px;\n        width: auto !important;\n        display: block;\n    }\n\n    .atm-cassette-amount-group .atm-cassette-amount-input {\n        flex: 1 1 auto;\n        width: 100%;\n        min-height: 34px;\n        height: 34px;\n        font-size: 14px;\n        font-weight: 400;\n        text-align: left;\n        padding: 6px 10px;\n        border: 1px solid #ccc;\n        border-radius: 0 4px 4px 0 !important;\n    }\n\n    .atm-cassette-currency-icon {\n        height: 28px;\n        width: auto;\n        max-width: 48px;\n        flex-shrink: 0;\n    }\n\n    .atm-cassette-denom-label {\n        font-size: 12px;\n        font-weight: 600;\n        margin-bottom: 4px;\n        color: #333;\n    }\n\n    .atm-cassette-denom-picker a {\n        text-decoration: none;\n    }\n\n    .atm-cassette-denom-placeholder {\n        font-size: 14px;\n        line-height: 1;\n        color: #999;\n    }\n\n    .atm-cassette-tracking-col {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        min-width: 0;\n    }\n\n    .atm-cassette-tracking-row {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        margin-bottom: 6px;\n    }\n\n    .atm-cassette-tracking-icon {\n        width: 44%;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n    }\n\n    .atm-cassette-tracking-icon .custom-icon {\n        max-height: 32px;\n    }\n\n    .atm-cassette-tracking-input {\n        margin-left: 10px;\n        width: 100%;\n        min-height: 34px;\n        height: 34px;\n    }\n</style>\n";
var id2="orderPack.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id2,v2);}
else{ngModule.run(["$templateCache",function(c){c.put(id2,v2)}]);}
module.exports=v2;

/***/ }),
/* 2577 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"orderPackHoldTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'orderPacking.put_on_hold' | translate}}</b> | {{model.trackingId}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<h3>Order Pack Hold</h3>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>";
var id1="orderPackHold.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2578 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"orderPackReturnTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'orderPacking.return_item' | translate}}</b> | {{model.trackingId}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<h3>Order Pack Return</h3>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>";
var id1="orderPackReturn.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2579 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"pendingCancelShipmentsTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'branch_mgmt.pending_cancel' | translate}}</b> | {{model.routeId}}</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.shipments.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<td>\n<b>{{ 'common.trackingId' | translate }}</b>\n</td>\n<td>\n<b>{{ 'location.id' | translate}}</b>\n</td>\n<td>\n<b>{{'bagout.amount' | translate}}</b>\n</td>\n<td>\n<b>{{ 'itemHolds.orderNo' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in model.shipments\">\n<td>\n<a href=\"#\" ng-click=\"goToItemHistory(shipment.trackingId)\">\n{{shipment.trackingId}}\n</a>\n</td>\n<td>\n<a href=\"#\" ng-click=\"goToServiceHistory(shipment.locationId)\">\n{{shipment.locationId}}\n</a> | {{shipment.locationName}}\n</td>\n<td>{{shipment.amount | currency:\"$\"}}</td>\n<td>\n<a href=\"#\" ng-click=\"goToOrderHistory(shipment)\">\n{{shipment.orderNo}}\n</a>\n</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.shipments.length && !model.loading && !model.errorMessage\">\n<div class=\"col-sm-12 alert text-center alert-danger\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div ng-if=\"!model.loading && model.errorMessage\">\n<div class=\"col-sm-12 alert text-center alert-danger\" style=\"margin-bottom: 0px;\">\n{{model.errorMessage}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="pendingCancelShipments.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2580 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"remainingToPackTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'routeControl.pending_pack' | translate}}</b> | {{model.routeId}}</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.pendingPack.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'common.tracking_id' | translate}}</th>\n<th>{{'routeControl.order_number' | translate}}</th>\n<th>{{'common.vault_date' | translate}}</th>\n<th>{{'common.branch_id' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.pendingPack track by $index\">\n<td>{{$index + 1}}</td>\n<td ng-if=\"data.trackingId\">{{ data.trackingId }}</td>\n<td ng-if=\"!data.trackingId\">{{ 'common.n_a' | translate }}</td>\n<td ng-if=\"data.orderNo\">{{ data.orderNo }}</td>\n<td ng-if=\"!data.orderNo\">{{ 'common.n_a' | translate }}</td>\n<td class=\"remove-white-space\">{{ data.vaultDate | date:'yyyy-MM-dd': 'UTC' }}</td>\n<td class=\"remove-white-space\">{{ data.branchId }}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.pendingPack.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.pendingPack.length}\" style=\"margin-bottom: 0px;\">\n{{'error.noShipmentToBePacked' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button ng-if=\"model.pendingPack.length && !model.loading\" class=\"btn btn-success pull-left\" type=\"button\" ng-click=\"redirectToOrderPack()\">\n{{ 'routeControl.order_pack' | translate }}\n</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="pendingPack.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2581 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<form name=\"pendingShipmentTransferTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>Pending Shipment Transfer</b></h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"col-sm-12 remove-pad\" ng-if=\"model.pendingShipmentTransfer.length && !model.loading\">\n<b>Last Transfer Sent At:</b> <b class=\"crimson-color\"> {{model.extraDetails.lastTransferSentAt | date:'dd-MMM-yyyy | hh:mm a'}}</b>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-top-5\" ng-if=\"model.pendingShipmentTransfer.length && !model.loading\">\n<div class=\"col-sm-6 remove-left-pad\">\n<div><b>Transfer Out</b></div>\n<div class=\"panel panel-default margin-bottom-20\">\n<div>\n<table class=\"table table-bordered table-striped remove-bottom-pad\">\n<tr>\n<td>{{'location.route' | translate}}</td>\n<td>{{model.extraDetails.transferOutRouteDetails.routeId}} | {{model.extraDetails.transferOutRouteDetails.transferOutRouteName}}</td>\n</tr>\n<tr>\n<td>{{'route.branchId' | translate}}</td>\n<td>{{model.extraDetails.transferOutRouteDetails.branchId}}</td>\n</tr>\n<tr>\n<td>{{'branchFundingSource.user' | translate}}</td>\n<td>{{model.extraDetails.transferOutRouteDetails.userId}} | {{model.extraDetails.transferOutRouteDetails.transferOutUserName}}</td>\n</tr>\n<tr>\n<td>{{'vaultOperations.vehicle' | translate}}</td>\n<td>{{model.extraDetails.transferOutRouteDetails.vehicleId}} | {{model.extraDetails.transferOutRouteDetails.transferOutTruckName}}</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n<div class=\"col-sm-6 remove-right-pad\">\n<div><b>Transfer In</b></div>\n<div class=\"panel panel-default margin-bottom-20\">\n<div>\n<table class=\"table table-bordered table-striped remove-bottom-pad\">\n<tr>\n<td>{{'location.route' | translate}}</td>\n<td>{{model.extraDetails.transferInRouteDetails.routeId}} | {{model.extraDetails.transferInRouteDetails.transferInRouteName}}</td>\n</tr>\n<tr>\n<td>{{'route.branchId' | translate}}</td>\n<td>{{model.extraDetails.transferInRouteDetails.branchId}}</td>\n</tr>\n<tr>\n<td>{{'branchFundingSource.user' | translate}}</td>\n<td>{{model.extraDetails.transferInRouteDetails.userId}} | {{model.extraDetails.transferInRouteDetails.transferInUserName}}</td>\n</tr>\n<tr>\n<td>{{'vaultOperations.vehicle' | translate}}</td>\n<td>{{model.extraDetails.transferInRouteDetails.vehicleId}} | {{model.extraDetails.transferInRouteDetails.transferInTruckName}}</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n</div>\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.pendingShipmentTransfer.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'common.tracking_id' | translate}}</th>\n<th>{{'denomination.shiptype' | translate}}</th>\n<th>{{'branch_mgmt.amount' | translate}}</th>\n<th>{{'bagout.fromLocation' | translate}}</th>\n<th>{{'bagout.toLocation' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.pendingShipmentTransfer track by $index\">\n<td>{{$index + 1}}</td>\n<td><a href=\"#\" ng-click=\"goToItemHistory(data.trackingId)\"> {{data.trackingId}}</a></td>\n<td>{{ data.shiptypeId }}</td>\n<td>{{ data.amount | currency:\"$\" }}</td>\n<td>\n<a href=\"#\" ng-click=\"goToServiceHistory(data.fromLocationId)\">{{data.fromLocationId}}</a> | {{data.fromLocationName}}\n</td>\n<td>\n<a href=\"#\" ng-click=\"goToServiceHistory(data.toLocationId)\">{{data.toLocationId}}</a> | {{data.toLocationName}}\n</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.pendingShipmentTransfer.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.pendingShipmentTransfer.length}\" style=\"margin-bottom: 0px;\">\nNo shipment transfer is pending\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button ng-if=\"model.pendingShipmentTransfer.length && !model.loading \n                        && model.extraDetails.transferInRouteDetails.routeId !== model.unassignedRouteId\" class=\"btn btn-success\" type=\"button\" ng-click=\"resendShipmentTransfer()\" ng-disabled=\"model.isSending\">\nResend Transfer <span ng-if=\"model.isSending\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n<button ng-if=\"model.pendingShipmentTransfer.length && !model.loading\" class=\"btn btn-danger\" type=\"button\" ng-click=\"cancelShipmentTransfer()\" ng-disabled=\"model.isCancelTransferLoading\">\nCancel Transfer <span ng-if=\"model.isCancelTransferLoading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="pendingShipmentTransfer.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2582 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"pickupShipmentTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b ng-if=\"model.flagType === 'pickup'\">{{'branch_mgmt.route_pickups' | translate}}</b>\n<b ng-if=\"model.flagType === 'delivered'\">{{'branch_mgmt.route_deliveries' | translate}}</b>\n| {{model.routeId}}</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.pickupShipmentList.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'common.tracking_id' | translate}}</th>\n<th>{{'checkout.fromLocationName' | translate}}</th>\n<th>{{'denomination.shiptype' | translate}}</th>\n<th>{{'bulkCash.amount' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.pickupShipmentList track by $index\" ng-class=\"{'immidiate-delivery-row-color': data.individuallyDeliverable}\">\n<td>{{$index + 1}}</td>\n<td class=\"d-flex\">\n<a href=\"#\" ng-click=\"goToItemHistory(data.trackingId)\"> {{data.trackingId}}</a>\n<span ng-if=\"model.flagType === 'pickup' && !(data.verified === 1)\" style=\"color:#D9534F;\">\n&nbsp;({{'pickupDeliveryShipment.pending' | translate}})\n</span>\n<span ng-if=\"data.individuallyDeliverable\" class=\"immidiate-delivery-icon margin-left-05 cursor-pointer\" uib-tooltip=\"{{'location.immediately_deliverable' | translate}}\"> ID\n</span>\n</td>\n<td>\n<a href=\"#\" ng-click=\"goToServiceHistory(data.fromLocationId, data.serviceDate)\">\n{{data.fromLocationId}}</a> | {{data.fromLocationName}}\n</td>\n<td>{{data.shiptypeId}}</td>\n<td>{{data.amountFlag ? data.formattedAmount : (data.qty != null ? data.qty : 'N/A')}}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.pickupShipmentList.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center alert-danger remove-bottom-margin\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n";
var id1="pickupDeliveryShipment.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2583 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"pickupHoldReleaseForm\" class=\"form-validate\" novalidate ng-submit=\"validateSupervisorScan()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'itemHolds.modalTitle' | translate}} ({{'branch_mgmt.items_pickupaction' | translate}})</strong> | {{ model.trackingId }}\n</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"col-sm-12 align-center-vertically\">\n<table class=\"table table-hover table-bordered\" ng-if=\"model.loadRouteList == true\">\n<thead>\n<tr class=\"header-row\">\n<th>{{'itemHolds.itemReleaseRoute' | translate}}</th>\n<th>{{'itemHolds.nextAvailableRoute' | translate}}</th>\n<th>{{'location.deliveryToLocations' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"col-xs-4\">\n<select class=\"form-control\" ng-model=\"model.routeId\" ng-change=\"routeSequenceChanged()\" required ng-options=\"route.routeId as route.routeName for route in model.routeList\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</td>\n<td class=\"col-xs-4 atm-codes-date-picker-section\">\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"model.date\" date-format=\"dd-MMM-yyyy\" ng-click=\"loadRoutes()\" hidden-time=\"true\" date-options=\"minVaultDate\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.date}\" timezone=\"UTC\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</td>\n<td class=\"col-xs-4\">\n<search-and-select ng-model=\"model.location\" values=\"model.locations\" key=\"Key\" totalrecords=\"model.totalLocation\" onscroll=\"loadLocations(searchKey, offset)\" is-edit=\"true\" none-selected=\"'common.none'\" required>\n</search-and-select>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"form-group col-sm-12 text-align-center\" ng-if=\"errorMessage && errCode != '91902'\">\n<div class=\"alert alert-danger margin-zero\">\n{{ errorMessage | translate}}\n</div>\n</div>\n<div class=\"_form-group col-sm-12\">\n<label>{{ 'itemHolds.comments' | translate }}</label>\n<textarea class=\"form-control\" rows=\"2\" ng-model=\"model.comment\" style=\"border-radius: 5px\"></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"pickupHoldReleaseForm.$invalid || (errCode && errCode != '91902') || isLoading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>\n{{'atm_deposit_packing.release' | translate }}\n</button>\n</div>\n</form>";
var id1="pickupHoldRelease.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2584 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"postBillingRecordTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">Monthly Post-Billing Record Generation</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%;\">\n<div class=\"row\">\n<div class=\"col-sm-12 text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!model.loading\">\n<div class=\"form-group\">\n<label for=\"contract\">Select Contract</label>\n<search-and-select ng-model=\"model.selectedContract\" set-id=\"contract\" values=\"model.contractList\" key=\"Key\" totalrecords=\"model.totalRecords\" onscroll=\"loadContract(searchKey, offset)\" none-selected=\"'common.none'\">\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!model.loading\">\n<div> <label>Select Month</label></div>\n<div class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"month in model.month\" ng-click=\"toggleMonth(month)\" ng-class=\"{'btn-primary': model.selectedMonth === month.value,'btn-default': model.selectedMonth !== month.value}\">\n{{month.label}}\n</a>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" ng-disabled=\"isLoading || !model.selectedMonth\" type=\"button\" ng-click=\"ok()\">{{ 'common.ok' | translate}}\n<span ng-if=\"isLoading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">{{ 'common.cancel' | translate }}</button>\n</div>\n</form>";
var id1="postBillingRecord.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2585 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"previewTicketPicturesForm\" class=\"form-validate\" novalidate>\n<div class=\"modal-header\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\"><b>{{'serviceTicket.preview_pictures' | translate}} ({{model.results.length}})</b></h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 450px; overflow-y: auto; padding: 15px;\">\n<div class=\"row preview-pictures-row\">\n<div class=\"text-center preview-pictures-col\" ng-class=\"model.results.length === 1 ? 'col-xs-12' : 'col-xs-6'\" ng-repeat=\"image in model.results track by $index\">\n<div class=\"preview-pictures-img-container\">\n<img ng-src=\"{{getImageSrc(image)}}\" class=\"preview-pictures-img\"/>\n<button type=\"button\" ng-click=\"remove($index)\" class=\"preview-pictures-remove-btn\" title=\"Remove\" ng-if=\"showRemove\">\n&times;\n</button>\n</div>\n<div style=\"margin-top: 8px;\" ng-if=\"image.imageUrl\">\n<button type=\"button\" class=\"btn btn-xs btn-info\" ng-click=\"download(image)\" title=\"Download\">\n<span class=\"glyphicon glyphicon-download-alt\"></span> Download\n</button>\n</div>\n<div class=\"preview-pictures-filename\" uib-tooltip=\"{{image.fileName}}\">\n{{image.fileName}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"close()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n";
var id1="previewTicketPictures.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2586 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"remainingResidualTemplate\" class=\"form-validate remaining_residuals_table\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'atm_residual.pending_count' | translate}}</b> | {{model.locationId.Value}}\n<span class=\"pull-right\" ng-if=\"model.shipment.length\">\n<span>{{'common.total' | translate}} : {{model.shipment.length}}</span>\n<span class=\"padding-left-10\">{{'bulkCash.amount' | translate}} : {{model.amount | currency:fractionSize:0}}</span>\n</span>\n</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"scroll-tab\">\n<table class=\"table table-hover table-bordered remove-bottom-margin fixed_header\" ng-if=\"model.shipment && model.shipment.length\">\n<thead class=\"scroll-table-head\">\n<tr class=\"header-row\">\n<th>#</th>\n<th ng-click=\"sortData('fromLocationId')\">{{'common.locationId' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': model.reverseSort, 'active' : model.sortColumn === 'fromLocationId'}\"></span>\n</th>\n<th ng-click=\"sortData('trackingId')\">{{'atm_residual.trackingId' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': model.reverseSort, 'active' : model.sortColumn === 'trackingId'}\"></span>\n</th>\n<th ng-click=\"sortData('orderNo')\">{{'atm_residual.orderNo' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': model.reverseSort, 'active' : model.sortColumn === 'orderNo'}\"></span>\n</th>\n<th ng-click=\"sortData('type')\">{{'message.type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': model.reverseSort, 'active' : model.sortColumn === 'type'}\"></span>\n</th>\n<th>\n<div class=\"multi-select pending-count-customer-dd\" isteven-multi-select max-labels=\"1\" input-model=\"model.customerList\" output-model=\"model.selectedCustomers\" button-label=\"customerLabel\" item-label=\"customerLabel\" search-property=\"customerLabel\" tick-property=\"ticked\" directive-id=\"customer-multi-select-button\" helper-elements=\"all none filter\" on-select-all=\"selectAllCustomers()\" on-select-none=\"selectNoCustomers()\">\n</div>\n</th>\n<th>\n<select id=\"routes\" class=\"form-control dd-height-30\" ng-model=\"model.route\" ng-options=\"route for route in model.routeList\">\n<option value=\"\" selected=\"selected\">({{'route.menu.all' |translate}})</option>\n</select>\n</th>\n<th width=\"13%\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"model.vaultDate\" date-format=\"dd-MMM-yyyy\" datepicker-append-to-body=\"false\" show-button-bar=\"true\" date-options=\"dateOptions\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\"/>\n</th>\n<th>\n<select id=\"messengerIds\" class=\"form-control dd-height-30\" ng-model=\"model.messengerId\" ng-options=\"messengerId for messengerId in model.messengerIdList\">\n<option value=\"\" selected=\"selected\">({{'bypassCode.messengerID' |translate}})</option>\n</select>\n</th>\n</tr>\n</thead>\n<tbody class=\"scroll-table-body\">\n<tr ng-repeat=\"data in model.shipment | orderBy:model.sortColumn:model.reverseSort | filter: filterData()\">\n<td>{{$index + 1}}</td>\n<td>\n<a href=\"#\" ng-click=\"goToServiceHistory(data)\">\n{{ data.fromLocationId }}\n</a>\n</td>\n<td><span>{{maskingString(data.trackingId)}}</span>\n</td>\n<td>\n<a href=\"#\" ng-click=\"goToOrderHistory(data)\">\n{{data.orderNo}}\n</a>\n</td>\n<td>\n<span>{{ getOrderType(data.shiptype, data.orderType) }}</span>\n</td>\n<td>\n<span ng-if=\"data.customerId\">\n<a href=\"#\" ng-click=\"goToCustomerTab(data.customerId)\">{{data.customerId}}</a> | {{data.customerName}}\n</span>\n<span ng-if=\"!data.customerId\">{{data.customerName || ('common.n_a' | translate)}}</span>\n</td>\n<td>\n<a href=\"#\" ng-click=\"goToRouteTab(data)\">{{data.routeId}}</a>\n</td>\n<td>{{data.vaultDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"goToUserTab(data.messengerId)\">{{data.messengerId}}</a>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"!model.shipment.length\">\n<div class=\"alert text-center\" ng-class=\"{'alert-danger': !model.shipment.length}\" style=\"margin-bottom: 0px;\">\n{{'error.noResidualToBeCounted' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" ng-click=\"exportRemainingResiduals()\" ng-if=\"model.shipment.length\" ng-disabled=\"exportLoading || !hasFilteredData()\">\n<span class=\"glyphicon glyphicon glyphicon-download\"></span>\n{{'common.export'|translate }}\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': exportLoading}\"></span>\n</button>\n<button class=\"btn btn-success\" ng-click=\"generatePrint()\" ng-if=\"model.shipment.length\" ng-disabled=\"!hasFilteredData()\">\n<span class=\"glyphicon glyphicon-print\"></span> {{'coinPullReport.print'|translate }}\n</button>\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n<style>\n.modal-dialog {\n        width: 1250px;\n    }\n</style>\n";
var id1="remainingResidual.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2587 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"remainingToThrowTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'routeControl.remaining_to_throw' | translate}}</b> | {{model.routeId}}</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.remainingToThrow.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'common.tracking_id' | translate}}</th>\n<th>{{'common.vault_date' | translate}}</th>\n<th>{{'common.branch_id' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.remainingToThrow track by $index\">\n<td>{{$index + 1}}</td>\n<td><a href=\"#\" ng-click=\"goToItemHistory(data.trackingId)\"> {{data.trackingId}}</a></td>\n<td>{{ data.vaultDate | date:'yyyy-MM-dd': 'UTC' }}</td>\n<td>{{ data.branchId }}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.remainingToThrow.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.remainingToThrow.length}\" style=\"margin-bottom: 0px;\">\n{{'error.noShipmentToBeThrow' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button ng-if=\"model.remainingToThrow.length && !model.loading\" class=\"btn btn-success pull-left\" type=\"button\" ng-click=\"redirectToRouteThrow()\">\n{{ 'routeControl.route_throw' | translate }}\n</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="remainingToThrow.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2588 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"rescheduleDeliveriesForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"chkTitle\">{{'vaultOperations.reschedule_deliveries' | translate}} |\n<b>{{model.fromRouteId}}</b>\n</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row\">\n<div class=\"col-sm-12 text-center margin-top-20 margin-bottom-20\" ng-if=\"model.fetchingShipments\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!model.fetchingShipments && !model.shipments.length\">\n<div class=\"alert text-center alert-danger margin-top-10\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!model.fetchingShipments && model.shipments.length\">\n<div class=\"row margin-bottom-10\">\n<div class=\"col-sm-4 col-sm-offset-8\">\n<div class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-click=\"setShuttleRoute(true)\" ng-class=\"{'btn-primary': model.shuttleRoute, 'btn-default': !model.shuttleRoute}\">{{'common.shuttle' | translate}}</a>\n<a class=\"btn\" ng-click=\"setShuttleRoute(false)\" ng-class=\"{'btn-primary': !model.shuttleRoute, 'btn-default': model.shuttleRoute}\">{{'common.regular' | translate}}</a>\n</div>\n</div>\n</div>\n<div class=\"row margin-bottom-10\">\n<div class=\"col-sm-6 common-date-picker-section\">\n<label for=\"vaultDate\">{{'softDeletedShipments.vault_date' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"delivery-date\" ng-model=\"model.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.vaultDate}\" ng-keydown=\"$event.preventDefault()\" date-options=\"minVaultDate\" ng-change=\"onVaultDateChange()\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6\">\n<label for=\"route\">{{'closeVault.route' | translate}} *</label>\n<search-and-select ng-model=\"model.route\" values=\"model.routeObj.results\" key=\"Key\" totalrecords=\"model.routeObj.totalRecords\" onscroll=\"loadRoutes(searchKey, offset)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"table-responsive\" style=\"max-height: 400px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered table-padding-5 font-12 margin-bottom-0\">\n<thead>\n<tr>\n<th class=\"text-center\">#</th>\n<th class=\"text-center\">{{'common.trackingId' | translate}}</th>\n<th class=\"text-center\">{{'common.vault_date' | translate}}</th>\n<th class=\"text-center\">{{'bagout.fromLocation' | translate}}</th>\n<th class=\"text-center\">{{'bagout.toLocation' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"shipment in model.shipments\">\n<td>{{$index + 1}}</td>\n<td><a href=\"\" ng-click=\"goToItemHistory(shipment.trackingId)\">{{shipment.trackingId}}</a></td>\n<td>{{shipment.vaultDate | date:'yyyy-MM-dd':'UTC'}}</td>\n<td><a href=\"\" ng-click=\"goToServiceHistory(shipment.fromLocationId)\">{{shipment.fromLocationId}}</a>\n| {{shipment.fromLocationName}}</td>\n<td><a href=\"\" ng-click=\"goToServiceHistory(shipment.toLocationId)\">{{shipment.toLocationId}}</a>\n| {{shipment.toLocationName}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">{{'common.cancel' | translate}}</button>\n<button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"rescheduleDeliveriesForm.$invalid || !model.shipments.length\">{{'common.ok' | translate}}</button>\n</div>\n</form>\n";
var id1="rescheduleDeliveries.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2589 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"residualCommentModal\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\"><strong>{{'atm_residual.trackingId' | translate}}</strong> | {{ model.trackingId }}</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"_form-group col-sm-12\">\n<label>{{'atm_residual.comments' | translate}} *</label>\n<textarea class=\"form-control\" id=\"variance-comment\" rows=\"3\" ng-model=\"model.comment\" style=\"border-radius: 5px\" required></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"residualCommentModal.$invalid || model.loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>\n{{'common.commit' | translate}}\n</button>\n</div>\n</form>";
var id1="residualComment.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2590 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"routeCheckinInfoTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<span ng-if=\"!model.isShpCheckedIn\"><b>{{'checkin.remaining_to_checkin' | translate}}</b> | {{model.routeId}}</span></h4>\n<span ng-if=\"model.isShpCheckedIn\"><h4><b>{{'checkin.checked_in' | translate}}</b> | {{model.routeId}}</h4></span>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.shipmentInfo.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th class=\"remove-white-space\">{{'common.tracking_id' | translate}}</th>\n<th>{{'common.from' | translate}}</th>\n<th>{{'common.to' | translate}}</th>\n</tr>\n</thead>\n<tbody ng-if=\"model.isShpCheckedIn\">\n<tr ng-repeat=\"data in model.shipmentInfo track by $index\">\n<td>{{$index + 1}}</td>\n<td class=\"remove-white-space\">{{data.trackingId}}</td>\n<td>{{data.fromLocation.id}} | {{data.fromLocation.name}}</td>\n<td>{{data.toLocation.id}} | {{data.toLocation.name}}</td>\n</tr>\n</tbody>\n<tbody ng-if=\"!model.isShpCheckedIn\">\n<tr ng-repeat=\"data in model.shipmentInfo track by $index\">\n<td>{{$index + 1}}</td>\n<td class=\"remove-white-space\">{{data.trackingId}}</td>\n<td>{{data.fromLocationId}} | {{data.fromLocationName}}</td>\n<td>{{data.toLocationId}} | {{data.toLocationName}}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.shipmentInfo.length && !model.loading\">\n<div class=\"col-sm-12 alert text-align-center\" ng-class=\"{'alert-danger': !model.shipmentInfo.length}\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="routeCheckinInfo.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2591 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"routeCheckoutInfoTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<span ng-if=\"!model.isShpCheckedOut && !model.status\"><b>{{'checkout.remainingItems' | translate}}</b> | {{model.routeId}}</span></h4>\n<span ng-if=\"model.status == 'remaining'\"><h4><b>{{'checkout.remainingItems' | translate}}</b> | {{model.routeId}}</h4></span>\n<span ng-if=\"model.isShpCheckedOut && !model.status\"><h4><b>{{'common.completed' | translate}}</b> | {{model.routeId}}</h4></span>\n<span ng-if=\"model.status == 'completed'\"><h4><b>{{'itemHolds.verified' | translate}}</b> | {{model.routeId}}</h4></span>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.shipmentInfo.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th class=\"remove-white-space\">{{'common.tracking_id' | translate}}</th>\n<th>{{'common.from' | translate}}</th>\n<th>{{'common.to' | translate}}</th>\n</tr>\n</thead>\n<tbody ng-if=\"model.isShpCheckedOut\">\n<tr ng-repeat=\"data in model.shipmentInfo track by $index\">\n<td>{{$index + 1}}</td>\n<td class=\"remove-white-space\">{{data.trackingId}}</td>\n<td>{{data.fromLocation.id}} | {{data.fromLocation.name}}</td>\n<td>{{data.toLocation.id}} | {{data.toLocation.name}}</td>\n</tr>\n</tbody>\n<tbody ng-if=\"!model.isShpCheckedOut\">\n<tr ng-repeat=\"data in model.shipmentInfo track by $index\">\n<td>{{$index + 1}}</td>\n<td class=\"remove-white-space\">{{data.trackingId}}</td>\n<td>{{data.fromLocationId}} | {{data.fromLocationName}}</td>\n<td>{{data.toLocationId}} | {{data.toLocationName}}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.shipmentInfo.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.shipmentInfo.length}\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="routeCheckoutInfo.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2592 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\"> {{title}} | {{routeId}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"max-height: 700px; overflow-y: scroll\">\n<div class=\"row\">\n<div class=\"col-sm-12 text-align-center\">\n<table class=\"remove-bottom-margin table table-responsive table-striped table-bordered route-table\">\n<thead>\n<tr class=\"header-row nowrap\">\n<th width=\"15%\">{{ 'branch_mgmt.tracking_Id' | translate}}</th>\n<th width=\"5%\">{{ 'addBagModal.amount' | translate}}</th>\n<th width=\"35%\">{{ 'bagout.fromLocation' | translate}}</th>\n<th width=\"35%\">{{ 'bagout.toLocation' | translate}}</th>\n<th width=\"10%\" ng-if=\"flag === 'delivery'\">{{ 'bagout.deliveryDate' | translate }}</th>\n<th width=\"10%\" ng-if=\"flag === 'pickups'\">{{ 'shipmentBatch.pickupDate' | translate }}</th>\n<th width=\"10%\" ng-if=\"(flag === 'holdPickups') || (flag === 'holdDeliveries')\">{{'branch_mgmt.item_status' | translate}}</th>\n</tr>\n</thead>\n<tbody style=\"max-height: 500px; overflow-y: scroll\">\n<tr ng-repeat=\"item in model.routesInfo\">\n<td><a href=\"#\" ng-click=\"goToItemHistory(item.trackingId)\">{{item.trackingId}}</a></td>\n<td>{{item.amount | currency:\"$\"}}</td>\n<td>\n<span ng-if=\"(flag === 'pickups') || (flag === 'holdPickups')\">\n<a href=\"#\" ng-click=\"goToServiceHistory(item.fromLocationId)\">\n{{item.fromLocationId}}\n</a> | {{item.from_location_info}}\n</span>\n<span ng-if=\"(flag !== 'pickups' ) && (flag !== 'holdPickups')\">{{item.fromLocationId}} | {{item.from_location_info}}</span>\n</td>\n<td>\n<span ng-if=\"(flag === 'delivery') || (flag === 'holdDeliveries')\">\n<a href=\"#\" ng-click=\"goToServiceHistory(item.toLocationId)\">\n{{item.toLocationId}}\n</a> | {{item.to_location_info}}\n</span>\n<span ng-if=\"(flag !== 'delivery') && (flag !== 'holdDeliveries')\">{{item.toLocationId}} | {{item.to_location_info}}</span>\n</td>\n<td>\n<span ng-if=\"flag === 'delivery' && item.delivery_date\">\n{{item.delivery_date | date: 'MM-dd-yyyy | hh:mm a' : model.timezone }}\n</span>\n<span ng-if=\"flag === 'delivery' && !item.delivery_date\">\n{{'itemHolds.n_a' | translate}}\n</span>\n<span ng-if=\"flag === 'pickups' && item.pickup_date\">\n{{item.pickup_date | date: 'MM-dd-yyyy | hh:mm a' : model.timezone }}\n</span>\n<span ng-if=\"flag === 'pickups' && !item.pickup_date\">\n{{'itemHolds.n_a' | translate}}\n</span>\n<span ng-if=\"(flag === 'holdPickups') || (flag === 'holdDeliveries')\">\n<a href=\"#\" ng-click=\"goToItemHold(item.trackingId)\">\n{{'common.hold' | translate}}\n</a>\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<span class=\"btn-group email-dropdown\" ng-show=\"flag === 'pickups' || flag === 'delivery' || flag === 'holdDeliveries'\">\n<button class=\"btn btn-primary dropdown-toggle\" type=\"button\" id=\"emailMenuButton\" ng-disabled=\"sending\" data-toggle=\"dropdown\">\n<i class=\"glyphicon\" ng-class=\"{\n                   'glyphicon-refresh fast-right-spinner': sending,\n                   'glyphicon-envelope': !sending\n               }\"></i>\n{{'common.email' | translate}}\n</button>\n<ul class=\"dropdown-menu\">\n<li>\n<div class=\"form-group\">\n<label>{{'common.enter_email' | translate}}</label>\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"Press Enter after typing an email to add multiple emails before sending.\" tooltip-placement=\"top\">\n</span>\n<input type=\"email\" class=\"form-control email-input\" ng-model=\"newEmail\" placeholder=\"{{'common.enter_email' | translate}}\" ng-disabled=\"sending\" ng-keypress=\"($event.keyCode === 13) && addEmail()\">\n<div class=\"email-tags\" ng-if=\"emailList.length > 0\">\n<span class=\"email-tag\" ng-repeat=\"email in emailList\">\n{{email}}\n<i class=\"glyphicon glyphicon-remove\" ng-click=\"removeEmail($index, $event)\" ng-mousedown=\"$event.stopPropagation()\"></i>\n</span>\n</div>\n</div>\n<div class=\"email-actions\">\n<button class=\"btn btn-primary\" ng-click=\"sendEmail()\" ng-disabled=\"!emailList.length || sending\">\n<span class=\"glyphicon glyphicon-send\"></span>\n{{'common.send' | translate}}\n</button>\n</div>\n</li>\n</ul>\n</span>\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"print()\" style=\"margin-left: 5px\">\n{{'routeSheet.print' | translate }}\n</button>\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"exportToCSV()\" ng-disabled=\"loading\">\n{{'branch_mgmt.monthly_report.export_to_csv' | translate }}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"loading\"></span>\n</button>\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\">\n{{'common.close' | translate }}\n</button>\n</div>\n";
var id1="routeDelivriesInfoTemplate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2593 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"routeDetailsForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"toggles-style modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<div class=\"modal-header-text-align\">\n<h4 class=\"modal-title pull-left\" id=\"modal-title\">\n<strong>{{ 'routeControl.routeDetail' | translate }}</strong> | {{ model.routeId }}</h4>\n<h4 class=\"modal-title pull-left\" id=\"modal-title\">\n<strong>{{ 'closeVault.currentVaultDate' | translate }}</strong> | {{ model.routeDate }}</h4>\n<h4 class=\"modal-title pull-left\" id=\"modal-title\">\n<strong>{{ 'routeControl.updatedDate' | translate }}</strong>: {{ model.lastReleasedDate | date: 'MM-dd-yyyy | hh:mm a' }}</h4>\n</div>\n</div>\n<div class=\"margin-10 margin-bottom-10 text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading\" class=\"list-group remove-bottom-margin\" style=\"width: 100%; max-height: 380px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"remove-pad col-sm-12 form-group\">\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{ 'routeControl.vehicleID' | translate }}</label>\n<search-and-select ng-model=\"model.truck\" values=\"truckData\" key=\"Key\" totalrecords=\"totalRecord\" onscroll=\"getTruckData(searchKey, offset)\" is-edit=\"true\" ng-required=\"!model.truck && model.leaveTime\" ng-disabled=\"model.restrictToTruck\" is-highlighted=\"model.restrictToTruck\" long-dd-width-flag=\"true\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{ 'routeControl.messengerID' | translate }}</label>\n<search-and-select ng-model=\"model.messenger\" values=\"messangerData\" key=\"Key\" totalrecords=\"messangerTotalRecord\" onscroll=\"getMessangerData(searchKey, offset)\" is-edit=\"true\" long-dd-width-flag=\"true\" none-selected=\"'common.none'\" ng-click=\"messengerSelected()\">\n</search-and-select>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{ 'routeControl.deriverID' | translate }}</label>\n<search-and-select ng-disabled=\"model.messenger == null || !model.routeData.requireDriver\" ng-model=\"model.driver\" values=\"driverData\" key=\"Key\" totalrecords=\"driverTotalRecord\" onscroll=\"getDriverData(searchKey, offset)\" is-edit=\"true\" long-dd-width-flag=\"true\" none-selected=\"'common.none'\" ng-required=\"model.requireDriver\"></search-and-select>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{ 'routeControl.guardID' | translate }} </label>\n<search-and-select ng-disabled=\"model.messenger == null || !model.routeData.requireGuard\" ng-model=\"model.guard\" values=\"guardData\" key=\"Key\" totalrecords=\"guardTotalRecord\" onscroll=\"getGuardData(searchKey, offset)\" is-edit=\"true\" long-dd-width-flag=\"true\" none-selected=\"'common.none'\" ng-required=\"model.requireGuard\"></search-and-select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-6 margin-bottom-14\">\n<label for=\"checkoutDate\">{{'routeControl.checkout_date' | translate}}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"model.checkOutDate\" placeholder=\"Checkout Date\" disabled=\"disabled\"/>\n</div>\n<div class=\"col-sm-6 margin-bottom-14\">\n<label for=\"checkoutTime\">{{'routeControl.checkout_time' | translate}}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"model.checkOutTime\" placeholder=\"Checkout Time\" disabled=\"disabled\"/>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-4\">\n<label for=\"deliveryTime\">{{'routeControl.leave_date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"model.leaveDate\" date-format=\"dd-MMM-yyyy\" ng-class=\"{'disabled': !model.curCheckoutTime}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" ng-change=\"validateArriveTime(); validateLeaveDate();\" date-options=\"maxDate\" ng-required=\"model.leaveTime\"/>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"deliveryTime\">{{'routeControl.leave_time' | translate}}</label>\n<input type=\"time\" class=\"form-control\" id=\"leave-time\" ng-model=\"model.leaveTime\" ng-disabled=\"!model.curCheckoutTime || !model.leaveDate\" ng-change=\"validateArriveTime(); validateLeaveTime();\" ng-required=\"model.leaveDate\">\n</div>\n<div class=\"col-sm-4\">\n<label>{{ 'routeControl.beginning_mileage' | translate }}</label>\n<input type=\"number\" min=\"0\" class=\"form-control\" id=\"beg-miles\" ng-disabled=\"(!model.curCheckoutTime) && model.curBegMiles >= 0\" ng-model=\"model.begMiles\" ng-required=\"model.endMiles\">\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-4\">\n<label for=\"deliveryTime\">{{'routeControl.arrive_date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"model.arriveDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" ng-model=\"model.arriveDate\" ng-change=\"validateLeaveTime(); validateArriveDate();\" date-options=\"maxDate\" ng-required=\"model.arriveTime\"/>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"deliveryTime\">{{'routeControl.arrive_time' | translate}}</label>\n<input type=\"time\" class=\"form-control\" id=\"arrive-time\" ng-model=\"model.arriveTime\" ng-change=\"validateLeaveTime(); validateArriveTime();\" ng-required=\"model.arriveDate\" ng-disabled=\"!model.arriveDate\">\n</div>\n<div class=\"col-sm-4\">\n<label>{{ 'routeControl.end_mileage' | translate }}</label>\n<input type=\"number\" min=\"1\" class=\"form-control\" id=\"end-miles\" ng-model=\"model.endMiles\" ng-change=\"validateMileage();\" ng-required=\"model.arriveDate && model.arriveTime && model.begMiles\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div ng-if=\"model.truckMismatch\" style=\"margin-bottom:6px; padding:6px 10px; background-color:#fff3cd; border:1px solid #e67e22; border-radius:4px; font-size:12px; color:#7d4e00;\">\n<span class=\"glyphicon glyphicon-info-sign\" style=\"margin-right:5px; color:#e67e22;\"></span>\nTruck Restriction is enabled for this route. Vehicle <strong>{{ model.restrictTruck.id }}</strong> has been automatically assigned and cannot be modified. Please save to confirm.\n</div>\n</div>\n<div class=\"col-sm-12 _remove-pad\" ng-if=\"leaveTimeError || arriveTimeError || mileageError || leaveDateError || arriveDateError\">\n<div class=\"alert text-center alert-danger margin-bottom-10\">\n{{leaveTimeError || arriveTimeError || mileageError || leaveDateError || arriveDateError}}\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"validateRouteDetailForm() || isLoading || isError() || loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>\n";
var id1="routeDetails.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2594 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"routeMessengerForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"toggles-style modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<div class=\"modal-header-text-align\">\n<h4 class=\"modal-title pull-left\" id=\"modal-title\">\n<strong>Assign Messenger</strong> | {{ model.routeId }}</h4>\n</div>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"padding: 20px;\">\n<div class=\"form-group\">\n<label>{{ 'routeControl.messengerID' | translate }}</label>\n<search-and-select ng-model=\"model.messenger\" values=\"messangerData\" key=\"Key\" totalrecords=\"messangerTotalRecord\" onscroll=\"getMessangerData(searchKey, offset)\" is-edit=\"true\" long-dd-width-flag=\"true\" none-selected=\"'common.none'\" ng-click=\"messengerSelected()\">\n</search-and-select>\n</div>\n<div class=\"margin-top-15\" ng-if=\"model.messenger && getMessengerAddress()\">\n<div class=\"alert alert-info\" style=\"margin-bottom: 0; border-radius: 4px; padding: 10px 15px;\">\n<div>\n<strong>{{'routeControl.messenger' | translate}} Address:</strong> {{getMessengerAddress()}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loading}\"></span>{{ 'common.save' | translate }}\n</button>\n</div>\n</form>\n";
var id1="routeMessenger.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2595 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"routeSequenceModal\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">Route Sequence | {{model.route}} | {{model.currentDay}}</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"w-100 route-seq-modal-section\" ng-if=\"!model.loading\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"alert alert-danger\" ng-if=\"model.originationError\" style=\"margin-bottom: 10px;\">\n{{model.originationError | translate}}\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div id=\"map\" class=\"border-radius-05 leaf-map margin-05\">\n<div class=\"leaflet-bottom leaflet-right margin-bottom-10\">\n<button class=\"btn btn-primary leaflet-control btn-pointer\" type=\"button\" ng-click=\"autoOptimizeRouteStop()\" ng-disabled=\"loading || !model.routeStopList.length || model.updatingLocGeoCode || model.originationError\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loading}\"></span>{{'route.autoOptimize' | translate}}\n</button>\n</div>\n</div>\n<div class=\"alert alert-info route-seq-info margin-10\" ng-if=\"model.routeStopList.length > 1\">\n<span class=\"glyphicon glyphicon-info-sign\"></span>\n{{'route.sequenceReorderInfo' | translate}}\n</div>\n<div class=\"form-group margin-10\">\n<ul ng-if=\"model.routeStopList\" dnd-list=\"model.routeStopList\" class=\"list-group location-sequence\">\n<li class=\"list-group-item display-flex\" ng-repeat=\"seq in model.routeStopList\" dnd-draggable=\"seq\" dnd-moved=\"locationMoved($index)\" dnd-effect-allowed=\"move\">\n<div class=\"col-sm-1\" ng-if=\"model.routeStopList.length === 1\">\n<strong>{{$index+1}}</strong>\n</div>\n<div class=\"col-sm-2 remove-pad route-seq-order\" dnd-nodrag ng-if=\"model.routeStopList.length > 1\">\n<input type=\"number\" class=\"form-control route-seq-input no-spinner\" min=\"1\" max=\"{{model.routeStopList.length}}\" ng-model=\"model.sequenceInput[$index]\" ng-model-options=\"{ debounce: 1000, allowInvalid: true }\" ng-change=\"sequenceTyped($index)\">\n<span class=\"route-seq-move\">\n<button type=\"button\" class=\"btn btn-xs btn-default\" ng-disabled=\"$index === 0\" ng-click=\"moveStop($index, -1)\">\n<span class=\"glyphicon glyphicon-chevron-up\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-default\" ng-disabled=\"$index === model.routeStopList.length - 1\" ng-click=\"moveStop($index, 1)\">\n<span class=\"glyphicon glyphicon-chevron-down\"></span>\n</button>\n</span>\n</div>\n<div class=\"location-address-section\" ng-class=\"model.routeStopList.length > 1 ? 'col-sm-10' : 'col-sm-11'\">\n<div class=\"col-sm-9\">\n<strong>{{seq.location.name}} | {{seq.location.address}}, {{seq.location.city}}</strong>\n</div>\n<div class=\"remove-white-space col-sm-2\">\n<img ng-src=\"{{loadImage(seq.location.locationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{seq.location.locationType}}\"/>\n<strong class=\"padding-left-5\">{{seq.location.id}}</strong>\n</div>\n</div>\n</li>\n</ul>\n<div class=\"text-center\">\n<strong ng-show=\"!model.routeStopList || !model.routeStopList.length\" class=\"text-muted\">\n{{'route.noRouteSequenceLocation' | translate}}\n</strong>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-secondary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"loading || model.loading || model.updatingLocGeoCode\">\n{{ 'common.close' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"button\" ng-disabled=\"loading || model.loading || !model.routeStopList.length || model.updatingLocGeoCode\" ng-click=\"fixLocationGeoCode()\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.updatingLocGeoCode}\"></span>{{'location.fix_locations_geoCode' | translate}}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"loading || model.loading || !model.routeStopList.length || model.updatingLocGeoCode\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{ 'common.save' | translate }}\n</button>\n</div>\n</form>\n<style>\n.route-seq-modal-section {\n        width: 100%; \n        max-height: 700px; \n        overflow-y: auto;\n    }\n    \n    .lock-type-loc-id-section {\n        display: flex;\n        gap: 10px;\n    }\n\n    .location-address-section {\n        display: flex;\n        justify-content: center;\n    }\n\n    .route-seq-info {\n        padding: 8px 12px;\n        margin-bottom: 10px;\n    }\n\n    .route-seq-info .glyphicon {\n        margin-right: 5px;\n    }\n\n    .route-seq-order {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n    }\n\n    .route-seq-input {\n        width: 52px;\n        height: 28px;\n        padding: 2px 4px;\n        text-align: center;\n        font-weight: bold;\n    }\n\n    .route-seq-move {\n        display: inline-flex;\n        flex-direction: column;\n    }\n\n    .route-seq-move .btn {\n        padding: 0 5px;\n        line-height: 1.1;\n        font-size: 10px;\n    }\n</style>\n";
var id1="routeSequence.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2596 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title pull-left\" id=\"modal-title\">\n<span class=\"glyphicon glyphicon-tag\"></span>\n<b>{{'serviceTickets.service_tickets_assigned' | translate}}</b>\n<span class=\"badge\" ng-if=\"model.tickets.length\" style=\"background-color: #2d78b9 !important;\">{{model.tickets.length}}</span>\n</h4>\n</div>\n<div class=\"modal-body\" style=\"max-height: 400px; overflow-y: auto;\">\n<div class=\"text-align-center margin-top-20 margin-bottom-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 40px;\"></span>\n</div>\n<div ng-if=\"!model.loading && model.tickets.length === 0\">\n<div class=\"alert alert-info text-center\">\n{{'serviceTickets.no_tickets_assigned' | translate}}\n</div>\n</div>\n<table class=\"table table-hover table-bordered table-condensed\" ng-if=\"!model.loading && model.tickets.length > 0\" style=\"margin-bottom: 0px;\">\n<thead>\n<tr class=\"text-center\">\n<th ng-click=\"sortBy('encounterId')\" class=\"remove-white-space cursor-pointer text-center\" style=\"white-space: nowrap;\">\n{{'serviceTickets.ticket' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': reverseSort, 'active': sortColumn === 'encounterId'}\"></span>\n</th>\n<th ng-click=\"sortBy('priority')\" class=\"remove-white-space cursor-pointer text-center\" style=\"white-space: nowrap;width: 22%;\">\n{{'serviceTickets.priority' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': reverseSort, 'active': sortColumn === 'priority'}\"></span>\n</th>\n<th ng-click=\"sortBy('statusCode')\" class=\"remove-white-space cursor-pointer text-center\" style=\"white-space: nowrap;\">\n{{'common.status' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': reverseSort, 'active': sortColumn === 'statusCode'}\"></span>\n</th>\n<th ng-click=\"sortBy('locationId')\" class=\"remove-white-space cursor-pointer text-center\" style=\"white-space: nowrap;\">\n{{'serviceTickets.location' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': reverseSort, 'active': sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"remove-white-space text-center\" style=\"white-space: nowrap;\">\n{{'common.action' | translate}}\n</th>\n<th ng-click=\"sortBy('timeOpenMs')\" class=\"remove-white-space cursor-pointer text-center\" style=\"white-space: nowrap;\">\n{{'serviceTickets.time_open' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': reverseSort, 'active': sortColumn === 'timeOpenMs'}\"></span>\n</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"ticket in model.tickets | orderBy:sortColumn:reverseSort track by $index\" ng-class=\"{'priority-alert-row': ticket.isPriorityAlert, \n                           'priority-48hr-row': ticket.requestedTimeframe === '48HR' && !ticket.isPriorityAlert,\n                           'priority-72hr-row': ticket.requestedTimeframe === '72HR' && !ticket.isPriorityAlert}\">\n<td ng-class=\"{'thres-hold-red': serviceOrderThresolds.routeTickets && serviceOrderThresolds.routeTickets.redThresholdIds.indexOf(ticket.encounterId) > -1, \n                               'thres-hold-orange': serviceOrderThresolds.routeTickets && serviceOrderThresolds.routeTickets.orangeThresholdIds.indexOf(ticket.encounterId) > -1, \n                               'thres-hold-yellow': serviceOrderThresolds.routeTickets && serviceOrderThresolds.routeTickets.yellowThresholdIds.indexOf(ticket.encounterId) > -1}\">\n<a ng-href=\"{{getServiceTicketUrl(ticket.encounterId)}}\" target=\"_blank\" class=\"btn-link\" ng-class=\"{'forced-txt-white': (serviceOrderThresolds.routeTickets && serviceOrderThresolds.routeTickets.redThresholdIds.indexOf(ticket.encounterId) > -1) || (serviceOrderThresolds.routeTickets && serviceOrderThresolds.routeTickets.orangeThresholdIds.indexOf(ticket.encounterId) > -1)}\">\n{{ticket.encounterId}}\n</a>\n</td>\n<td style=\"text-align: center;\">\n<div class=\"ticket-priority-meta\">\n{{ticket.priority}}\n<span ng-if=\"ticket.displayRequestedTimeframe && (!ticket.completed && !ticket.cancelled)\">\n|\n<span class=\"ticket-priority-pill\" ng-class=\"{'ticket-priority-pill-alert': ticket.isPriorityAlert,\n                                                                         'ticket-priority-pill-48hr': ticket.requestedTimeframe === '48HR' && !ticket.isPriorityAlert,\n                                                                         'ticket-priority-pill-72hr': ticket.requestedTimeframe === '72HR' && !ticket.isPriorityAlert}\">\n{{ticket.displayRequestedTimeframe}}\n</span>\n</span>\n</div>\n<div class=\"ticket-priority-subtext\" ng-if=\"ticket.targetTime\">\n<b>Target:</b> {{DateUtil.convetToBrowserTimezone(ticket.targetTime)}}\n</div>\n<div class=\"ticket-priority-subtext\" ng-if=\"ticket.priorityRemaining\" ng-class=\"{'ticket-priority-overdue': ticket.priorityRemaining.includes('Overdue')}\">\n<b ng-if=\"!ticket.priorityRemaining.includes('Overdue')\">{{ticket.priorityRemaining}}</b>\n<span ng-if=\"ticket.priorityRemaining.includes('Overdue')\">{{ticket.priorityRemaining}}</span>\n</div>\n</td>\n<td>\n{{getBucketName(ticket.statusCode)}}\n</td>\n<td>\n<a ng-href=\"{{getLocationUrl(ticket)}}\" ng-click=\"onLocationClick($event, ticket)\">{{ticket.locationId}}</a> | {{ticket.locationName}}\n</td>\n<td class=\"text-danger\">\n<span ng-if=\"ticket.thresholds && ticket.thresholds.length\">\n{{ticket.thresholds.length}} |\n<span ng-repeat=\"ac in ticket.thresholds track by $index\">{{ac.label}}<span ng-if=\"!$last\">,\n</span></span>\n</span>\n</td>\n<td ng-class=\"{'thres-hold-red': serviceOrderThresolds.routeTickets && serviceOrderThresolds.routeTickets.redThresholdIds.indexOf(ticket.encounterId) > -1, \n                               'thres-hold-orange': serviceOrderThresolds.routeTickets && serviceOrderThresolds.routeTickets.orangeThresholdIds.indexOf(ticket.encounterId) > -1, \n                               'thres-hold-yellow': serviceOrderThresolds.routeTickets && serviceOrderThresolds.routeTickets.yellowThresholdIds.indexOf(ticket.encounterId) > -1}\">\n<span ng-class=\"{'forced-txt-white': (serviceOrderThresolds.routeTickets && serviceOrderThresolds.routeTickets.redThresholdIds.indexOf(ticket.encounterId) > -1) || (serviceOrderThresolds.routeTickets && serviceOrderThresolds.routeTickets.orangeThresholdIds.indexOf(ticket.encounterId) > -1), \n                                     'open-time-color': serviceOrderThresolds.routeTickets && serviceOrderThresolds.routeTickets.yellowThresholdIds.indexOf(ticket.encounterId) === -1 && serviceOrderThresolds.routeTickets.redThresholdIds.indexOf(ticket.encounterId) === -1 && serviceOrderThresolds.routeTickets.orangeThresholdIds.indexOf(ticket.encounterId) === -1}\">\n<strong ng-class=\"{'text-danger': ticket.isOverdue && (!serviceOrderThresolds.routeTickets || (serviceOrderThresolds.routeTickets.redThresholdIds.indexOf(ticket.encounterId) === -1 && serviceOrderThresolds.routeTickets.orangeThresholdIds.indexOf(ticket.encounterId) === -1 && serviceOrderThresolds.routeTickets.yellowThresholdIds.indexOf(ticket.encounterId) === -1))}\">{{ticket.timeOpenDisplay}}</strong>\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n";
var id1="routeServiceTickets.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2597 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"routeStopListForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'routeControl.stops' | translate}}</b> | {{model.routeId}}</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table _table-hover table-bordered remove-pad\" ng-if=\"model.stops.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'routeProgress.seq' | translate}}.</th>\n<th class=\"contents-no-wrap\">{{'location.stop_priority' | translate}}</th>\n<th>{{'window.location' | translate}}</th>\n<th>{{'common.address' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.stops track by $index\" ng-class=\"{'future-location-changes-bg-color': data.status === 'scheduled'}\">\n<td>{{$index + 1}}</td>\n<td>{{data.sequence}}</td>\n<td>\n<span ng-if=\"data.stopPriority\">\n{{stopPriorityOrdinalSuffix(data.stopPriority)}} </span>\n<span ng-if=\"!data.stopPriority\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<img ng-src=\"/assets/images/{{loadLocationTypeIcon(data.locationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{data.locationType}}\"/>\n<a ng-href=\"{{getLocationUrl(data)}}\" ng-click=\"onLocationClick($event, data)\">{{data.locationId}} </a> | {{data.locationName}}\n</td>\n<td>{{data.address}}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.stops.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center remove-bottom-margin\" ng-class=\"{'alert-danger': !model.stops.length}\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n";
var id1="routeStopList.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2598 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\">\n<h4 class=\"modal-title\" id=\"modal-title-top\">{{ title | translate }}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body-top\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<table class=\"table table-bordered table-striped remove-bottom-margin\" ng-if=\"shipments.length > 0\">\n<thead>\n<tr>\n<th class=\"text-center\">{{'common.trackingId' | translate}}</th>\n<th class=\"text-center\">{{'common.location' | translate}}</th>\n<th class=\"text-center\" ng-if=\"isThrown\">{{'location_types.Tanker' | translate}}</th>\n<th class=\"text-center\">{{'routeThrow.deliveryDate' | translate}}</th>\n<th class=\"text-center\">{{'shiptype.amount' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in shipments\">\n<td class=\"text-center\">\n<a href=\"\" ng-click=\"goToShipment(shipment.trackingId)\">{{shipment.trackingId}}</a>\n</td>\n<td class=\"text-center\" uib-tooltip=\"{{shipment.toAddress}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">\n<a ng-href=\"{{getLocationUrl(shipment)}}\" ng-click=\"onLocationClick($event, shipment)\">\n{{shipment.toLocationId}}\n</a> | {{shipment.toLocationName}}\n</td>\n<td class=\"text-center\" ng-if=\"isThrown\">{{shipment.tankerId || 'N/A'}}</td>\n<td class=\"text-center\">{{shipment.deliveryDate ? (shipment.deliveryDate | date:'yyyy-MM-dd':'UTC') : 'N/A'}}</td>\n<td class=\"text-center\">{{shipment.amount | currency}}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"shipments.length === 0\" class=\"col-sm-12 alert alert-danger text-center remove-bottom-margin\">\n{{'location.no_record_found' | translate}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"close()\">{{'common.close' | translate}}</button>\n</div>\n";
var id1="routeThrowShipmentList.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2599 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"connection-status-container\" style=\"top: 3px;\">\n<div class=\"alert alert-danger\" ng-if=\"isLocDuplicate.isDuplicate\">\n{{isLocDuplicate.message}} {{ 'error.moveDuplicateLocation' | translate}}\n</div>\n</div>\n<form name=\"routeDetailsForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}} modal-dialog\" style=\"margin: 0px; width: 100%\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'route.transfer' | translate }}</strong>\n</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"w-100\" style=\"width: 100%; max-height: 750px; overflow-y: auto;\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"remove-left-pad col-sm-6 route-right-vertical-line\">\n<select class=\"form-control margin-bottom-10\" ng-model=\"model.rawId\" ng-change=\"loadRouteSequence(model.rawId, model.branch, model.selectedDay)\" ng-options=\"route.id as (route.id + ' | ' + route.name) for route in model.routesList.results\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n<div id=\"mapOne\" class=\"border-radius-05 leaf-map margin-bottom-10\"></div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"day-selection\">{{'route.route_day' | translate}}</label>\n<div class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"day in model.days\" ng-disabled=\"day.label === lastReleasedDayName || loadingRouteSequence\" ng-click=\"selectDay(day)\" ng-class=\"{'btn-primary': model.selectedDay === day.value,'btn-default': model.selectedDay !== day.value}\">\n<i class=\"glyphicon\" ng-class=\"{\n                                         'glyphicon-refresh fast-right-spinner': loadingRouteSequence,\n                                         'disabled': loadingRouteSequence\n                                    }\"></i>{{day.label}}\n</a>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"\">{{'route.routeSequence' | translate}}\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loadingRouteSequence}\"></span>\n</label>\n<ul ng-class=\"{'cst-padding': model.routeSequenceData.length==0 }\" ng-if=\"model.routeSequenceData\" ng-if=\"model.routeSequenceData\" dnd-list=\"model.routeSequenceData\" class=\"list-group location-sequence\">\n<li class=\"list-group-item display-flex\" ng-repeat=\"location in model.routeSequenceData\" dnd-draggable=\"location\" dnd-moved=\"routeSequenceLocationMoved($index, model.routeSequenceData, model.routePosition, actualLat, actualLong,\n                                locationInfo, mapOne, model.locationListForMap, 'one')\" dnd-effect-allowed=\"move\">\n<div class=\"col-sm-1 align-center-vertically\" ng-class=\"{'inactive-location' : !location.active}\">\n<strong>{{$index+1}}</strong>\n</div>\n<div class=\"col-sm-11 align-center-vertically\">\n<div class=\"col-sm-7\">\n<span ng-class=\"{'inactive-location' : !location.active}\">\n<span ng-if=\"!location.active\"><strong>({{'route.inactive_location' | translate}})</strong></span>\n<strong>{{location.name}} | {{location.address}}, {{location.city}}</strong>\n</span>\n</div>\n<div class=\"col-sm-1\">\n<img ng-src=\"{{$ctrl.loadImage(location.locationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"\"/>\n</div>\n<div class=\"col-sm-4 align-center-vertically\" ng-class=\"{'inactive-location' : !location.active}\">\n<strong>{{location.id}}</strong>\n</div>\n<div class=\"col-sm-2 align-center-vertically small\" ng-class=\"{'inactive-location' : !location.active}\">\n<span><b>{{location.branchId}}</b></span>\n</div>\n</div>\n</li>\n</ul>\n<div class=\"text-center\">\n<strong ng-show=\"!model.routeSequenceData || !model.routeSequenceData.length\" class=\"text-muted\">\n{{'route.noRouteSequenceLocation' | translate}} {{$ctrl.getSelectedDay()}}\n</strong>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"remove-right-pad col-sm-6 route-left-vertical-line\">\n<select class=\"form-control margin-bottom-10\" ng-model=\"model.route\" ng-change=\"routeChange(model.route, model.branch, model.selectedDayForMapTwo)\" ng-options=\"route.id as (route.id + ' | ' + route.name) for route in model.routesList.results\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n<div id=\"mapTwo\" class=\"border-radius-05 leaf-map margin-bottom-10\"></div>\n<div class=\"row\" ng-if=\"model.route\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"day-selection\">{{'route.route_day' | translate}}</label>\n<div class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"routeDay in model.routeDay\" ng-disabled=\"routeDay.label === lastReleasedDayName || loadingRouteSequence\" ng-click=\"selectDayForMapTwo(routeDay)\" ng-class=\"{'btn-primary': model.selectedDayForMapTwo === routeDay.value,'btn-default': model.selectedDayForMapTwo !== routeDay.value}\">\n<i class=\"glyphicon\" ng-class=\"{\n\t\t\t\t\t\t\t            \t\t'glyphicon-refresh fast-right-spinner': loadingRouteSequence,\n\t\t\t\t\t\t\t            \t\t'disabled': loadingRouteSequence\n\t\t\t\t\t   \t\t            }\"></i>{{routeDay.label}}\n</a>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"!model.route\">\n<div class=\"remove-pad col-sm-12 align-center-horizontally\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': !model.route}\" style=\"text-align: center; width:100%\">\n<span>{{'route.route_select' | translate}}</span>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"model.route\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"\">{{'route.routeSequence' | translate}}\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': loadingRouteSequence}\"></span>\n</label>\n<ul ng-class=\"{'cst-padding': model.routeSequenceLocData.length==0}\" ng-if=\"model.routeSequenceLocData\" dnd-list=\"model.routeSequenceLocData\" class=\"list-group location-sequence\">\n<li class=\"list-group-item display-flex\" ng-repeat=\"location in model.routeSequenceLocData\" dnd-draggable=\"location\" dnd-moved=\"routeSequenceLocationMoved($index, model.routeSequenceLocData,model.routePositionForSecondMap, actualLatitude, actualLongitute, locationInfoForSecondMap,\n                                mapTwo, model.locationListForSecondMap, 'two')\" dnd-effect-allowed=\"move\">\n<div class=\"col-sm-1 align-center-vertically\">\n<strong>{{$index+1}}</strong>\n</div>\n<div class=\"col-sm-11 align-center-vertically\">\n<div class=\"col-sm-7\">\n<span ng-class=\"{'inactive-location' : !location.active}\">\n<span ng-if=\"!location.active\"><strong>({{'route.inactive_location' | translate}})</strong></span>\n<strong>{{location.name}} | {{location.address}}, {{location.city}}</strong>\n</span>\n</div>\n<div class=\"col-sm-1\">\n<img ng-src=\"{{$ctrl.loadImage(location.locationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"\"/>\n</div>\n<div class=\"col-sm-4 align-center-vertically\" ng-class=\"{'inactive-location' : !location.active}\">\n<strong>{{location.id}}</strong>\n</div>\n<div class=\"col-sm-2 align-center-vertically small\" ng-class=\"{'inactive-location' : !location.active}\">\n<span><b>{{location.branchId}}</b></span>\n</div>\n</div>\n</li>\n</ul>\n<div class=\"text-center\">\n<strong ng-show=\"!model.routeSequenceLocData || !model.routeSequenceLocData.length\" class=\"text-muted\">\n{{'route.noRouteSequenceLocation' | translate}}\n</strong>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"routeDetailsForm.$invalid\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>\n<style>\n.modal-dialog {\n        width: 90%\n    }\n</style>";
var id1="routeTransfer.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2600 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"routeDetailsForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"toggles-style modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<div class=\"modal-header-text-align\">\n<h4 class=\"modal-title pull-left\" id=\"modal-title\">\n<strong>{{ 'serviceTickets.update' | translate }}</strong> | {{ model.routeId }}</h4>\n<h4 class=\"modal-title pull-left\" id=\"modal-title\">\n<strong>{{ 'closeVault.currentVaultDate' | translate }}</strong> | {{ model.routeDate }}</h4>\n<h4 class=\"modal-title pull-left\" id=\"modal-title\">\n<strong>{{ 'routeControl.lastReleased' | translate }}</strong>\n<span ng-if=\"model.lastReleasedDate\">: {{ model.lastReleasedDate | date: 'MM-dd-yyyy | hh:mm a' }}</span>\n<span ng-if=\"!model.lastReleasedDate\">: {{'common.n_a' | translate}}</span>\n</h4>\n</div>\n</div>\n<div class=\"margin-10 margin-bottom-10 text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 _remove-pad\" ng-if=\"!model.lastReleasedDate && !loading\">\n<div class=\"margin-10 alert text-center alert-info margin-bottom-10\">\n<span class=\"glyphicon glyphicon-info-sign\"></span> {{'routeControl.route_not_released' | translate}}\n</div>\n</div>\n<div ng-if=\"!loading\" class=\"list-group remove-bottom-margin w-100\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"remove-pad col-sm-12 form-group\">\n<div id=\"inline\" class=\"form-group col-sm-6\">\n<label>{{ 'routeControl.vehicleID' | translate }}</label>\n<search-and-select ng-model=\"model.truck\" values=\"truckData\" key=\"Key\" ng-required=\"!model.truck && model.leaveTime\" ng-disabled=\"model.restrictToTruck || model.curComplTime\" is-highlighted=\"model.restrictToTruck\" totalrecords=\"totalRecord\" onscroll=\"getTruckData(searchKey, offset)\" is-edit=\"true\" long-dd-width-flag=\"true\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-6\">\n<label>{{ 'routeControl.messengerID' | translate }}</label>\n<search-and-select ng-model=\"model.messenger\" values=\"messangerData\" key=\"Key\" totalrecords=\"messangerTotalRecord\" common-search-flag=\"true\" is-edit=\"true\" long-dd-width-flag=\"true\" none-selected=\"'common.none'\" ng-click=\"messengerSelected()\" ng-disabled=\"model.curComplTime\">\n</search-and-select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-6 margin-bottom-14\">\n<label for=\"checkoutDate\">{{'routeControl.checkout_date' | translate}}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"model.checkOutDate\" placeholder=\"Checkout Date\" disabled=\"disabled\"/>\n</div>\n<div class=\"col-sm-6 margin-bottom-14\">\n<label for=\"checkoutTime\">{{'routeControl.checkout_time' | translate}}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"model.checkOutTime\" placeholder=\"Checkout Time\" disabled=\"disabled\"/>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-4\">\n<div style=\"display:flex; align-items:center; justify-content:space-between;\">\n<label for=\"deliveryTime\">{{'routeControl.leave_date' | translate}}</label>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-if=\"(model.leaveDate || model.leaveTime) && !model.curComplTime\" ng-click=\"clearLeaveFields()\">\nClear\n</button>\n</div>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"model.leaveDate\" date-format=\"dd-MMM-yyyy\" ng-class=\"{'disabled': !model.curCheckoutTime || model.curComplTime}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" ng-change=\"validateArriveTime(); validateArriveDate(); validateLeaveDate();\" date-options=\"maxDate\" ng-required=\"model.leaveTime\"/>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"deliveryTime\">{{'routeControl.leave_time' | translate}}</label>\n<input type=\"time\" class=\"form-control\" id=\"leave-time\" ng-model=\"model.leaveTime\" ng-disabled=\"!model.curCheckoutTime || !model.leaveDate || model.curComplTime\" ng-change=\"validateArriveTime(); validateArriveDate(); validateLeaveTime();\" ng-required=\"model.leaveDate\">\n</div>\n<div class=\"col-sm-4\">\n<label>{{ 'routeControl.beginning_mileage' | translate }}</label>\n<input type=\"number\" min=\"0\" class=\"form-control\" id=\"beg-miles\" ng-disabled=\"(!model.curCheckoutTime) && model.curBegMiles >= 0\" ng-model=\"model.begMiles\" ng-change=\"validateMileage();\" ng-required=\"model.endMiles\">\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-4\">\n<div style=\"display:flex; align-items:center; justify-content:space-between;\">\n<label for=\"deliveryTime\">{{'routeControl.arrive_date' | translate}}</label>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-if=\"(model.arriveDate || model.arriveTime) && !model.curComplTime\" ng-click=\"clearArriveFields()\">\nClear\n</button>\n</div>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"model.arriveDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'disabled': !model.curCheckoutTime || model.curComplTime}\" ng-keydown=\"$event.preventDefault()\" ng-change=\"validateLeaveTime(); validateArriveDate();\" date-options=\"maxDate\" ng-required=\"model.arriveTime\"/>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"deliveryTime\">{{'routeControl.arrive_time' | translate}}</label>\n<input type=\"time\" class=\"form-control\" id=\"arrive-time\" ng-model=\"model.arriveTime\" ng-change=\"validateLeaveTime(); validateArriveTime();\" ng-required=\"model.arriveDate\" ng-disabled=\"!model.arriveDate || !model.curCheckoutTime || model.curComplTime\">\n</div>\n<div class=\"col-sm-4\">\n<label>{{ 'routeControl.end_mileage' | translate }}</label>\n<input type=\"number\" min=\"1\" class=\"form-control\" id=\"end-miles\" ng-model=\"model.endMiles\" ng-change=\"validateMileage();\" ng-disabled=\"!model.curCheckoutTime\" ng-required=\"model.arriveDate && model.arriveTime && !model.endMiles || model.begMiles\">\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-6\">\n<label for=\"checkInTime\">{{'vaultOperations.check_in_date' | translate}}</label>\n<datetimepicker id=\"checkin-date-picker\" class=\"datetimepicker-input\" ng-model=\"model.complDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-disabled=\"!model.curCheckoutTime || model.curComplTime\" ng-class=\"{'disabled': !model.curCheckoutTime || model.curComplTime}\" ng-keydown=\"$event.preventDefault()\" ng-change=\"validateArriveTime(); validateComplDate();\" date-options=\"maxDate\" ng-required=\"model.complTime\"/>\n</div>\n<div class=\"col-sm-6\">\n<label for=\"checkInTime\">{{'vaultOperations.check_in_time' | translate}}</label>\n<input type=\"time\" class=\"form-control\" id=\"check-in-time\" ng-model=\"model.complTime\" ng-change=\"validateArriveTime(); validateComplTime();\" ng-required=\"model.complDate\" ng-disabled=\"!model.complDate || !model.curCheckoutTime || model.curComplTime\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div ng-if=\"model.truckMismatch\" style=\"margin-bottom:6px; padding:6px 10px; background-color:#fff3cd; border:1px solid #e67e22; border-radius:4px; font-size:12px; color:#7d4e00;\">\n<span class=\"glyphicon glyphicon-info-sign\" style=\"margin-right:5px; color:#e67e22;\"></span>\nTruck Restriction is enabled for this route. Vehicle <strong>{{ model.restrictTruck.id }}</strong> has been automatically assigned and cannot be modified. Please save to confirm.\n</div>\n</div>\n<div class=\"col-sm-12 _remove-pad\" ng-if=\"leaveTimeError || arriveTimeError || mileageError || leaveDateError || arriveDateError || complDateError || complTimeError\">\n<div class=\"alert text-center alert-danger margin-bottom-10\">\n{{leaveTimeError || arriveTimeError || mileageError || leaveDateError || arriveDateError || complDateError || complTimeError}}\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"validateRouteDetailForm() || isLoading || isError() || loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span>{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>\n<style>\n#checkin-date-picker.disabled input, #checkin-date-picker.disabled .form-control {\n            background-color: #eeeeee !important;\n            border-color: #cccccc !important;\n            color: #555555 !important;\n            cursor: not-allowed !important;\n        }\n</style>";
var id1="routesInfo.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2601 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"saveLaterLocationTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'location.save_later' | translate}}</b> | {{model.locationId}}\n</h4>\n</div>\n<div class=\"save-location-later-tbl-section location-history-remove-bottom-pad modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 50vh; overflow-y: auto;\">\n<label ng-if=\"model.locationStatus.isLocationStatus\" class=\"font-size-18\">{{'location.status' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.locationStatus.isLocationStatus\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.locationStatus.previouslyAssignedLocationStatus.length\" ng-repeat=\"previouslyAssignedLocationStatus in model.locationStatus.previouslyAssignedLocationStatus track by $index\">\n<div>{{previouslyAssignedLocationStatus}}\n<span ng-if=\"$index + 1 !== model.locationStatus.previouslyAssignedLocationStatus.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.locationStatus.previouslyAssignedLocationStatus.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.locationStatus.newAssignedLocationStatus.length\" ng-repeat=\"newAssignedLocationStatus in model.locationStatus.newAssignedLocationStatus track by $index\">\n<div>{{newAssignedLocationStatus}}\n<span ng-if=\"$index + 1 !== model.locationStatus.newAssignedLocationStatus.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.locationStatus.newAssignedLocationStatus.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.locationBranch.isAllBranchesChanged\" class=\"font-size-18\">{{'branch.branches' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.locationBranch.isAllBranchesChanged\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.locationBranch.previouslyAssignedAllBranches.length\">\n<span ng-repeat=\"previouslyAssignedAllBranches in model.locationBranch.previouslyAssignedAllBranches track by $index\">\n{{previouslyAssignedAllBranches}}\n<span ng-if=\"!$last\">, </span>\n</span>\n</span>\n<span ng-if=\"!model.locationBranch.previouslyAssignedAllBranches.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.locationBranch.newAssignedAllBranches.length\">\n<span ng-repeat=\"newAssignedAllBranches in model.locationBranch.newAssignedAllBranches track by $index\">\n{{newAssignedAllBranches}}\n<span ng-if=\"!$last\">, </span>\n</span>\n</span>\n<span ng-if=\"!model.locationBranch.newAssignedAllBranches.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.defaultBranch.isDefaultBranchChanged\" class=\"font-size-18\">{{'users.default_branches' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.defaultBranch.isDefaultBranchChanged\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.defaultBranch.previouslyAssignedDefaultBranch.length\" ng-repeat=\"previouslyAssignedDefaultBranch in model.defaultBranch.previouslyAssignedDefaultBranch track by $index\">\n<div>{{previouslyAssignedDefaultBranch}}\n<span ng-if=\"$index + 1 !== model.defaultBranch.previouslyAssignedDefaultBranch.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.defaultBranch.previouslyAssignedDefaultBranch.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.defaultBranch.newAssignedDefaultBranch.length\" ng-repeat=\"newAssignedDefaultBranch in model.defaultBranch.newAssignedDefaultBranch track by $index\">\n<div>{{newAssignedDefaultBranch}}\n<span ng-if=\"$index + 1 !== model.defaultBranch.newAssignedDefaultBranch.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.defaultBranch.newAssignedDefaultBranch.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.fundingSource.isBankSourceChanged\" class=\"font-size-18\">{{'location.update_funding_source' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.fundingSource.isBankSourceChanged\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.fundingSource.previouslyAssignedFundingSource.length\" ng-repeat=\"previouslyAssignedFundingSource in model.fundingSource.previouslyAssignedFundingSource track by $index\">\n<div>{{previouslyAssignedFundingSource}}\n<span ng-if=\"$index + 1 !== model.fundingSource.previouslyAssignedFundingSource.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.fundingSource.previouslyAssignedFundingSource.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.fundingSource.newAssignedFundingSource.length\" ng-repeat=\"newAssignedFundingSource in model.fundingSource.newAssignedFundingSource track by $index\">\n<div>{{newAssignedFundingSource}}\n<span ng-if=\"$index + 1 !== model.fundingSource.newAssignedFundingSource.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.fundingSource.newAssignedFundingSource.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.fundingSource.isSwapRatioChanged\" class=\"font-size-18\">{{'location.addToSwapRatio' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.fundingSource.isSwapRatioChanged\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.fundingSource.previouslyAssignedSwapRatio.length\" ng-repeat=\"previouslyAssignedSwapRatio in model.fundingSource.previouslyAssignedSwapRatio track by $index\">\n<div>{{previouslyAssignedSwapRatio}}\n<span ng-if=\"$index + 1 !== model.fundingSource.previouslyAssignedSwapRatio.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.fundingSource.previouslyAssignedSwapRatio.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.fundingSource.newAssignedSwapRatio.length\" ng-repeat=\"newAssignedSwapRatio in model.fundingSource.newAssignedSwapRatio track by $index\">\n<div>{{newAssignedSwapRatio}}\n<span ng-if=\"$index + 1 !== model.fundingSource.newAssignedSwapRatio.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.fundingSource.newAssignedSwapRatio.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.bagoutExport.isBagoutExportChanged\" class=\"font-size-18\">{{'location.bagout_export' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.bagoutExport.isBagoutExportChanged\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.bagoutExport.previouslyAssignedBagoutExport.length\" ng-repeat=\"previouslyAssignedBagoutExport in model.bagoutExport.previouslyAssignedBagoutExport track by $index\">\n<div>{{previouslyAssignedBagoutExport}}\n<span ng-if=\"$index + 1 !== model.bagoutExport.previouslyAssignedBagoutExport.length\">,</span>\n</div>\n</span>\n<span ng-if=\"model.bagoutExport.previouslyAssignedBagoutExport[0] === null\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.bagoutExport.newAssignedBagoutExport.length\" ng-repeat=\"newAssignedBagoutExport in model.bagoutExport.newAssignedBagoutExport track by $index\">\n<div>{{newAssignedBagoutExport}}\n<span ng-if=\"$index + 1 !== model.bagoutExport.newAssignedBagoutExport.length\">,</span>\n</div>\n</span>\n<span ng-if=\"model.bagoutExport.newAssignedBagoutExport[0] === null\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.batchImport.isBatchImportChanged\" class=\"font-size-18\">{{'location.batch_import' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.batchImport.isBatchImportChanged\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.batchImport.previouslyAssignedBatchImport.length\" ng-repeat=\"previouslyAssignedBatchImport in model.batchImport.previouslyAssignedBatchImport track by $index\">\n<div>{{previouslyAssignedBatchImport}}\n<span ng-if=\"$index + 1 !== model.batchImport.previouslyAssignedBatchImport.length\">,</span>\n</div>\n</span>\n<span ng-if=\"model.batchImport.previouslyAssignedBatchImport[0] === null\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.batchImport.newAssignedBatchImport.length\" ng-repeat=\"newAssignedBatchImport in model.batchImport.newAssignedBatchImport track by $index\">\n<div>{{newAssignedBatchImport}}\n<span ng-if=\"$index + 1 !== model.batchImport.newAssignedBatchImport.length\">,</span>\n</div>\n</span>\n<span ng-if=\"model.batchImport.newAssignedBatchImport[0] === null\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.routeLikeRegular.isHandleAtmLikeRegular\" class=\"font-size-18\">{{'location.route_like_regular' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.routeLikeRegular.isHandleAtmLikeRegular\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.routeLikeRegular.previouslyAssignedHandleAtmLikeRegular.length\" ng-repeat=\"previouslyAssignedHandleAtmLikeRegular in model.routeLikeRegular.previouslyAssignedHandleAtmLikeRegular track by $index\">\n<div>{{previouslyAssignedHandleAtmLikeRegular}}\n<span ng-if=\"$index + 1 !== model.routeLikeRegular.previouslyAssignedHandleAtmLikeRegular.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.routeLikeRegular.previouslyAssignedHandleAtmLikeRegular.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.routeLikeRegular.newAssignedHandleAtmLikeRegular.length\" ng-repeat=\"newAssignedHandleAtmLikeRegular in model.routeLikeRegular.newAssignedHandleAtmLikeRegular track by $index\">\n<div>{{newAssignedHandleAtmLikeRegular}}\n<span ng-if=\"$index + 1 !== model.routeLikeRegular.newAssignedHandleAtmLikeRegular.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.routeLikeRegular.newAssignedHandleAtmLikeRegular.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.deliveryToLocation.isDeliveryToLocationUpdated\" class=\"font-size-18\">{{'location.deliveryToLocations' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.deliveryToLocation.isDeliveryToLocationUpdated\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.deliveryToLocation.previouslyAssignedDeliveryToLocation.length\" ng-repeat=\"previouslyAssignedDeliveryToLocation in model.deliveryToLocation.previouslyAssignedDeliveryToLocation track by $index\">\n<div>{{previouslyAssignedDeliveryToLocation}}\n<span ng-if=\"$index + 1 !== model.deliveryToLocation.previouslyAssignedDeliveryToLocation.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.deliveryToLocation.previouslyAssignedDeliveryToLocation.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.deliveryToLocation.newAssignedDeliveryToLocation.length\" ng-repeat=\"newAssignedDeliveryToLocation in model.deliveryToLocation.newAssignedDeliveryToLocation track by $index\">\n<div>{{newAssignedDeliveryToLocation}}\n<span ng-if=\"$index + 1 !== model.deliveryToLocation.newAssignedDeliveryToLocation.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.deliveryToLocation.newAssignedDeliveryToLocation.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.routeAssignment.isRouteAssignmentChanged\" class=\"font-size-18\">{{'location.routeAssignment' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.routeAssignment.isRouteAssignmentChanged\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.routeAssignment.previouslyAssignedRoutes.length\" ng-repeat=\"previouslyAssignedRoutes in model.routeAssignment.previouslyAssignedRoutes track by $index\">\n<div>{{previouslyAssignedRoutes}}<span ng-if=\"$index + 1 !== model.routeAssignment.previouslyAssignedRoutes.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.routeAssignment.previouslyAssignedRoutes.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.routeAssignment.newAssignedRoutes.length\" ng-repeat=\"newAssignedRoutes in model.routeAssignment.newAssignedRoutes track by $index\">\n<div>{{newAssignedRoutes}}<span ng-if=\"$index + 1 !== model.routeAssignment.newAssignedRoutes.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.routeAssignment.newAssignedRoutes.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.recurringRouteAssignment.isRecurringRouteAssignmentChanged\" class=\"font-size-18\">{{'location.update_recurring_route_assignment' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.recurringRouteAssignment.isRecurringRouteAssignmentChanged\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.recurringRouteAssignment.previouslyAssignedRecurringRoutes.length\" ng-repeat=\"previouslyAssignedRecurringRoutes in model.recurringRouteAssignment.previouslyAssignedRecurringRoutes track by $index\">\n<div>{{previouslyAssignedRecurringRoutes}}<span ng-if=\"$index + 1 !== model.recurringRouteAssignment.previouslyAssignedRecurringRoutes.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.recurringRouteAssignment.previouslyAssignedRecurringRoutes.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.recurringRouteAssignment.newAssignedRecurringRoutes.length\" ng-repeat=\"newAssignedRecurringRoutes in model.recurringRouteAssignment.newAssignedRecurringRoutes track by $index\">\n<div>{{newAssignedRecurringRoutes}}<span ng-if=\"$index + 1 !== model.recurringRouteAssignment.newAssignedRecurringRoutes.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.recurringRouteAssignment.newAssignedRecurringRoutes.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.denomination.isDenominationChanged\" class=\"font-size-18\">{{'location.update_denomination' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.denomination.isDenominationChanged\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.denomination.previouslyAssignedDenominations.length\" ng-repeat=\"previouslyAssignedDenominations in model.denomination.previouslyAssignedDenominations track by $index\">\n<div>{{previouslyAssignedDenominations}}<span ng-if=\"$index + 1 !== model.denomination.previouslyAssignedDenominations.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.denomination.previouslyAssignedDenominations.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.denomination.newAssignedDenominations.length\" ng-repeat=\"newAssignedDenominations in model.denomination.newAssignedDenominations track by $index\">\n<div>{{newAssignedDenominations}}<span ng-if=\"$index + 1 !== model.denomination.newAssignedDenominations.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.denomination.newAssignedDenominations.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<label ng-if=\"model.scheduleRecurringLoad.isScheduleRecurringLoadChanged\" class=\"font-size-18\">{{'location.update_schedule_recurring_load' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.scheduleRecurringLoad.isScheduleRecurringLoadChanged\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.scheduleRecurringLoad.previouslyAssignedScheduleRecurringLoad.length\" ng-repeat=\"previouslyAssignedScheduleRecurringLoad in model.scheduleRecurringLoad.previouslyAssignedScheduleRecurringLoad track by $index\">\n<div>{{previouslyAssignedScheduleRecurringLoad}}<span ng-if=\"$index + 1 !== model.scheduleRecurringLoad.previouslyAssignedScheduleRecurringLoad.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.scheduleRecurringLoad.previouslyAssignedScheduleRecurringLoad.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.scheduleRecurringLoad.newAssignedScheduleRecurringLoad.length\" ng-repeat=\"newAssignedScheduleRecurringLoad in model.scheduleRecurringLoad.newAssignedScheduleRecurringLoad track by $index\">\n<div>{{newAssignedScheduleRecurringLoad}}<span ng-if=\"$index + 1 !== model.scheduleRecurringLoad.newAssignedScheduleRecurringLoad.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.scheduleRecurringLoad.newAssignedScheduleRecurringLoad.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 margin-10\" ng-if=\"model.routeAssignment.isRouteAssignmentChanged || model.deliveryToLocation.isDeliveryToLocationUpdated || model.locationStatus.isLocationStatus ||\n                        model.locationBranch.isAllBranchesChanged || model.defaultBranch.isDefaultBranchChanged ||  model.batchImport.isBatchImportChanged || model.bagoutExport.isBagoutExportChanged || model.routeLikeRegular.isHandleAtmLikeRegular || model.recurringRouteAssignment.isRecurringRouteAssignmentChanged || model.denomination.isDenominationChanged || model.scheduleRecurringLoad.isScheduleRecurringLoadChanged || model.fundingSource.isFundingSourceChanged\">\n<div class=\"remove-left-pad col-sm-6 uib-date-picker-section\" ng-if=\"model.routeAssignment.isRouteAssignmentChanged || model.deliveryToLocation.isDeliveryToLocationUpdated || model.locationStatus.isLocationStatus ||\n                        model.locationBranch.isAllBranchesChanged || model.defaultBranch.isDefaultBranchChanged ||  model.batchImport.isBatchImportChanged || model.bagoutExport.isBagoutExportChanged || model.routeLikeRegular.isHandleAtmLikeRegular || model.recurringRouteAssignment.isRecurringRouteAssignmentChanged || model.denomination.isDenominationChanged || model.scheduleRecurringLoad.isScheduleRecurringLoadChanged || model.fundingSource.isFundingSourceChanged\">\n<label for=\"date\">{{'routeSheet.date' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"model.date\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.date}\" ng-keydown=\"$event.preventDefault()\" date-options=\"minVaultDate\" ng-change=\"validateDate()\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6 remove-right-pad\" ng-if=\"model.routeAssignment.isRouteAssignmentChanged || model.deliveryToLocation.isDeliveryToLocationUpdated || model.locationStatus.isLocationStatus ||\n                        model.locationBranch.isAllBranchesChanged || model.defaultBranch.isDefaultBranchChanged || model.batchImport.isBatchImportChanged || model.bagoutExport.isBagoutExportChanged || model.routeLikeRegular.isHandleAtmLikeRegular || model.recurringRouteAssignment.isRecurringRouteAssignmentChanged || model.denomination.isDenominationChanged || model.scheduleRecurringLoad.isScheduleRecurringLoadChanged || model.fundingSource.isFundingSourceChanged\n                        \">\n<label for=\"time\">Time *</label>\n<input type=\"time\" class=\"form-control\" ng-model=\"model.time\" ng-change=\"validateDate()\" required>\n</div>\n</div>\n<div class=\"margin-05 col-sm-12\" ng-if=\"(model.routeAssignment.isRouteAssignmentChanged || model.deliveryToLocation.isDeliveryToLocationUpdated || model.locationStatus.isLocationStatus ||\n                        model.locationBranch.isAllBranchesChanged || model.defaultBranch.isDefaultBranchChanged || model.batchImport.isBatchImportChanged || model.bagoutExport.isBagoutExportChanged || model.routeLikeRegular.isHandleAtmLikeRegular || model.recurringRouteAssignment.isRecurringRouteAssignmentChanged || model.denomination.isDenominationChanged || model.scheduleRecurringLoad.isScheduleRecurringLoadChanged || model.fundingSource.isFundingSourceChanged\n                        ) && model.dateError\">\n<div class=\"alert alert-danger text-center text-danger\" style=\"margin-bottom: 10px;\">\n{{model.dateError}}\n</div>\n</div>\n<div class=\"margin-05 col-sm-12\" ng-if=\"!model.routeAssignment.isRouteAssignmentChanged && !model.deliveryToLocation.isDeliveryToLocationUpdated && !model.locationStatus.isLocationStatus &&\n                        !model.locationBranch.isAllBranchesChanged && !model.defaultBranch.isDefaultBranchChanged && !model.batchImport.isBatchImportChanged && !model.bagoutExport.isBagoutExportChanged &&\n                         !model.routeLikeRegular.isHandleAtmLikeRegular && !model.recurringRouteAssignment.isRecurringRouteAssignmentChanged &&\n                         !model.denomination.isDenominationChanged && !model.scheduleRecurringLoad.isScheduleRecurringLoadChanged &&\n                         !model.fundingSource.isFundingSourceChanged\">\n<div class=\"alert alert-danger text-center text-danger\" style=\"margin-bottom: 10px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 margin-bottom-05\" ng-if=\"model.routeAssignment.isRouteAssignmentChanged || model.deliveryToLocation.isDeliveryToLocationUpdated || model.locationStatus.isLocationStatus ||\n                model.locationBranch.isAllBranchesChanged || model.defaultBranch.isDefaultBranchChanged ||  model.batchImport.isBatchImportChanged || model.bagoutExport.isBagoutExportChanged || model.routeLikeRegular.isHandleAtmLikeRegular || model.recurringRouteAssignment.isRecurringRouteAssignmentChanged || model.denomination.isDenominationChanged || model.scheduleRecurringLoad.isScheduleRecurringLoadChanged || model.fundingSource.isFundingSourceChanged\">\n<hr class=\"cash-variances-line-section\">\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-secondary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"(!model.routeAssignment.isRouteAssignmentChanged && !model.deliveryToLocation.isDeliveryToLocationUpdated && !model.locationStatus.isLocationStatus &&\n            !model.locationBranch.isAllBranchesChanged && !model.defaultBranch.isDefaultBranchChanged && !model.batchImport.isBatchImportChanged && !model.bagoutExport.isBagoutExportChanged && \n            !model.routeLikeRegular.isHandleAtmLikeRegular && !model.recurringRouteAssignment.isRecurringRouteAssignmentChanged &&\n            !model.denomination.isDenominationChanged && !model.scheduleRecurringLoad.isScheduleRecurringLoadChanged &&\n            !model.fundingSource.isFundingSourceChanged) || (!model.date || !model.time) || model.dateError\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\">\n{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>\n";
var id1="saveLocationLater.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2602 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"saveRouteChangesLaterTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'location.save_later' | translate}}</b> | {{model.routeId}}\n</h4>\n</div>\n<div class=\"save-location-later-tbl-section location-history-remove-bottom-pad modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<label ng-if=\"model.tankerAssignment.isTankerAssignmentChanged\" class=\"font-size-18\">{{'route.tankerAssignment' | translate}}</label>\n<table class=\"table-pad-3 table table-hover table-bordered\" ng-if=\"model.tankerAssignment.isTankerAssignmentChanged\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"text-center\">\n<span ng-if=\"model.tankerAssignment.previouslyAssignedTanker.length\" ng-repeat=\"previouslyAssignedTanker in model.tankerAssignment.previouslyAssignedTanker track by $index\">\n<div>{{previouslyAssignedTanker}}<span ng-if=\"$index + 1 !== model.tankerAssignment.previouslyAssignedTanker.length\">,</span>\n</div>\n</span>\n<span ng-if=\"!model.tankerAssignment.previouslyAssignedTanker.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"model.tankerAssignment.newAssignedTanker.length\" ng-repeat=\"newAssignedTanker in model.tankerAssignment.newAssignedTanker track by $index\">\n<div>{{newAssignedTanker}}<span ng-if=\"$index + 1 !== model.tankerAssignment.newAssignedTanker.length\">,</span></div>\n</span>\n<span ng-if=\"!model.tankerAssignment.newAssignedTanker.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"remove-left-pad col-sm-6 uib-date-picker-section\" ng-if=\"model.tankerAssignment.isTankerAssignmentChanged\">\n<label for=\"date\">{{'routeSheet.date' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"model.date\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.date}\" ng-keydown=\"$event.preventDefault()\" date-options=\"minVaultDate\" ng-change=\"validateDate()\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6 remove-right-pad\" ng-if=\"model.tankerAssignment.isTankerAssignmentChanged\">\n<label for=\"time\">Time *</label>\n<input type=\"time\" class=\"form-control\" ng-model=\"model.time\" ng-change=\"validateDate()\" required>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-if=\"model.tankerAssignment.isTankerAssignmentChanged && model.dateError\">\n<div class=\"alert alert-danger text-center text-danger\" style=\"margin-bottom: 10px;\">\n{{model.dateError}}\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-if=\"!model.tankerAssignment.isTankerAssignmentChanged\">\n<div class=\"alert alert-danger text-center text-danger\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-secondary\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"!model.tankerAssignment.isTankerAssignmentChanged || (!model.date || !model.time) || model.dateError\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\">\n{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>";
var id1="saveRouteChangesLater.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2603 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'selectDeliveryLocationModal.title' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row\">\n<div class=\"col-sm-12 text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!loading\">\n<div class=\"list-group\">\n<div ng-repeat=\"deliveryLocation in deliveryLocations\" class=\"list-group-item cursor-pointer\" ng-class=\"{'active': deliveryLocation.id === selectedLocationId}\" ng-click=\"setSelected(deliveryLocation)\">\n<span>\n{{deliveryLocation.id}} {{deliveryLocation.name && ' | ' + deliveryLocation.name}} {{deliveryLocation.address && ' | ' + deliveryLocation.address}}\n</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" ng-class=\"{'disabled': loading || selectedIndex === -1}\" type=\"button\" ng-click=\"ok()\">\n{{ 'Ok' | translate }}\n</button>\n<button class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</div> ";
var id1="selectDeliveryLocation.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2604 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"sendStopReceiptTemplate\" class=\"form-validate\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'common.confirm_title' | translate }}</strong>\n</h4>\n</div>\n<div class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group col-sm-12\">\n<label>{{ 'location.confirm_re_send_receipt' | translate }} </label>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<label class=\"col-sm-1 col-form-label margin-top-05\">{{ 'customer.email' | translate }}: </label>\n<div class=\"col-sm-11\">\n<input type=\"text\" id=\"email\" class=\"form-control\" ng-model=\"model.providedEmail\" ng-pattern=\"/^(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+\\s?,)*(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+)$/\" ng-disabled=\"model.loading\"/>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"model.loading\">\n{{ 'common.ok' | translate }}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"model.loading\"></span>\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n</div>\n</form>";
var id1="sendStopReceipt.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2605 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"serviceOrderActionsTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" ng-class=\"{'alert-danger' : model.errorMessage}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<span ng-if=\"!model.errorMessage\"><b>{{'serviceSettings.service_order_actions' | translate}}</b></span>\n<span ng-if=\"model.errorMessage\"><b>{{'serviceTickets.update_error' | translate}}</b></span>\n</h4>\n</div>\n<div class=\"text-align-center margin-top-20 margin-bottom-10\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"location-history-remove-bottom-pad modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 450px; overflow-y: auto;\" ng-if=\"!model.loading\">\n<div class=\"col-sm-12 alert errLblPos text-center alert-danger\" ng-if=\"model.errorMessage\">\n<span>{{model.errorMessage}}</span>\n</div>\n<div class=\"col-sm-12\" ng-if=\"model.errorMessage\">\n<hr class=\"remove-margin\"/>\n</div>\n<div class=\"col-sm-12 alert errLblPos text-center\" ng-class=\"{'alert-danger': model.requireResolveCodesFor}\" ng-if=\"model.requireResolveCodesFor\">\n<span>A service ticket cannot be completed because the action code (<b>{{model.requireResolveCodesFor}}</b>) does not have a resolve code. To complete the service ticket, please add a resolve code.\n</span>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-6 remove-bottom-margin\">\n<label for=\"arrivedDate\">{{'serviceTickets.arrived_date' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"arrived-date\" ng-model=\"model.arrivedDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.arrivedDate}\" ng-keydown=\"$event.preventDefault()\" date-options=\"minVaultDate\" ng-change=\"validateArrivedTime(); validateCompletedAt();\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6\">\n<label for=\"arrivedTime\">{{'serviceTickets.arrived_time' | translate}} *</label>\n<input type=\"time\" class=\"form-control\" input type=\"time\" ng-model=\"model.arrivedTime\" ng-change=\"validateArrivedTime(); validateCompletedAt();\" required>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<label>{{'serviceTickets.completing_user' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"model.userId\" ng-options=\"user.userId as (user.userId + ' | ' + user.username) for user in model.serviceUserList\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.select_user' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4 remove-bottom-margin\">\n<label for=\"completedDate\">{{'serviceTickets.completed_date' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"completed-date\" ng-model=\"model.completedDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.completedDate}\" ng-keydown=\"$event.preventDefault()\" date-options=\"minVaultDate\" ng-change=\"validateCompletedAt(); validateArrivedTime();\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"completedTime\">{{'serviceTickets.completed_time' | translate}} *</label>\n<input type=\"time\" class=\"form-control\" input type=\"time\" ng-model=\"model.completedTime\" ng-change=\"validateCompletedAt(); validateArrivedTime();\" required>\n</div>\n</div>\n<span class=\"col-sm-12 alert errLblPos text-center alert-danger remove-top-margin\" ng-if=\"model.completedDateError\">\n<span>{{model.completedDateError}}</span>\n</span>\n<span class=\"col-sm-12 alert errLblPos text-center alert-danger remove-top-margin\" ng-if=\"model.arrivedDateError\">\n<span>{{model.arrivedDateError}}</span>\n</span>\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\" ng-if=\"model.actionCodes.length\">\n<div class=\"row\" ng-repeat=\"data in model.actionCodes track by $index\">\n<div class=\"form-group col-sm-5\">\n<label for=\"currentStatus\" style=\"margin-top: 7px;\">Resolve Code : </label>\n</div>\n<div class=\"form-group col-sm-7\">\n<div class=\"multi-select action-codes-dd\" ng-class=\"{\n                                'invalid-multi-select-value': data.minResponses === 1 && !model.selectedResponses[data.serviceOrderActionId].responseCode.length,\n                                'valid-multi-select-value': (data.minResponses === 0 && !model.selectedResponses[data.serviceOrderActionId].responseCode.length) || model.selectedResponses[data.serviceOrderActionId].responseCode.length\n                            }\" isteven-multi-select max-labels=\"1\" input-model=\"data.responses\" output-model=\"model.selectedResponses[data.serviceOrderActionId].responseCode\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"validateUpdateButton()\" on-select-all=\"validateUpdateButton()\" on-select-none=\"validateUpdateButton()\" on-reset=\"validateUpdateButton()\" selection-mode=\"{{model.selectedResponses[data.serviceOrderActionId].selectionMode}}\">\n</div>\n</div>\n<div class=\"form-group col-sm-5\" ng-show=\"data.minRootCauses\">\n<label for=\"currentStatus\" style=\"margin-top: 7px;\">Root Cause : </label>\n</div>\n<div class=\"form-group col-sm-7\" ng-show=\"data.minRootCauses\">\n<div class=\"multi-select action-codes-dd\" ng-class=\"{\n                                'invalid-multi-select-value': !model.selectedResponses[data.serviceOrderActionId].rootCauseCode.length,\n                                'valid-multi-select-value': model.selectedResponses[data.serviceOrderActionId].rootCauseCode.length\n                            }\" isteven-multi-select max-labels=\"1\" input-model=\"data.rootCauses\" output-model=\"model.selectedResponses[data.serviceOrderActionId].rootCauseCode\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"validateUpdateButton()\" on-select-all=\"validateUpdateButton()\" on-select-none=\"validateUpdateButton()\" on-reset=\"validateUpdateButton()\" selection-mode=\"{{model.selectedResponses[data.serviceOrderActionId].rootCauseSelectionMode}}\">\n</div>\n</div>\n<div class=\"col-lg-12 remove-pad\" ng-if=\"data.partsCapture\">\n<div class=\"form-group col-sm-5\">\n<label for=\"currentStatus\" class=\"add-btn-margin-7 padding-left-17\">Parts :</label>\n</div>\n<div class=\"form-group col-sm-7\">\n<div class=\"multi-select action-codes-dd valid-multi-select-value\" isteven-multi-select max-labels=\"2\" input-model=\"model.serviceTicketPartList\" output-model=\"model.selectedResponses[data.serviceOrderActionId].selectedParts\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"$index\" directive-id=\"multi-select-button\" on-item-click=\"validateUpdateButton()\" on-select-all=\"validateUpdateButton()\" on-select-none=\"validateUpdateButton()\" on-reset=\"validateUpdateButton()\">\n</div>\n</div>\n</div>\n<div class=\"form-group col-sm-12\">\n<label>{{'serviceTickets.action_note' | translate}}</label>\n<br>\n<textarea class=\"form-control\" rows=\"3\" ng-model=\"model.selectedResponses[data.serviceOrderActionId].note\" style=\"border-radius: 5px\" disabled=\"disabled\"></textarea>\n</div>\n<div class=\"form-group col-sm-12\">\n<label>{{'serviceTickets.user_notes' | translate}}</label>\n<br>\n<textarea class=\"form-control\" rows=\"3\" ng-model=\"model.selectedResponses[data.serviceOrderActionId].userNote\" style=\"border-radius: 5px\" required ng-change=\"validateUpdateButton();\"></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 alert errLblPos text-center remove-bottom-margin\" ng-class=\"{'alert-danger': !model.actionCodes.length}\" ng-if=\"!model.actionCodes.length\">\n<span>{{'serviceTickets.no_actions_found' | translate}}</span>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger pull-left\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"model.loading \n                || model.isUpdate || !model.isValid || model.completedDateError || model.arrivedDateError\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.isUpdate}\"></span>\n{{ 'common.update' | translate }}\n</button>\n</div>\n</form>";
var id1="serviceOrderActions.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2606 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<div class=\"margin-top-05\">\n<h4 class=\"modal-title pull-left\" id=\"modal-title\">\n<b>{{'common.assign' | translate}}</b>\n</h4>\n</div>\n<div class=\"btn-group pull-right\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"model.stats\" uib-btn-radio=\"model.statsObj.route\" ng-click=\"tabSelection('route')\" ng-class=\"{'btn-success': model.stats === model.statsObj.route}\">\n{{ 'checkin.route' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"model.stats\" uib-btn-radio=\"model.statsObj.user\" ng-click=\"tabSelection('user')\" ng-class=\"{'btn-success': model.stats === model.statsObj.user}\">\n{{ 'branchFundingSource.user' | translate }}\n</label>\n</div>\n<div class=\"btn-group\" ng-if=\"!model.details.externalProcessorId && model.details.statusCode === 'ACCEPTED'\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"model.stats\" uib-btn-radio=\"model.statsObj.external\" ng-click=\"tabSelection('external')\" ng-class=\"{'btn-success': model.stats === model.statsObj.external}\">\n{{ 'serviceTickets.external' | translate }}\n</label>\n</div>\n</div>\n</div>\n<div class=\"text-align-center margin-top-20 margin-bottom-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 40px;\"></span>\n</div>\n<form name=\"serviceOrderAssignTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\" ng-if=\"model.stats === model.statsObj.route && !model.loading\">\n<div ng-class=\"{'form-group' : !model.routeId && !model.loadingRouteStatus}\">\n<div>\n<select class=\"form-control\" ng-model=\"model.routeId\" ng-change=\"routeStatus()\" ng-options=\"route.routeId as (route.routeId + ' | ' + route.routeName) for route in model.routeList\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"text-align-center margin-top-40\" ng-if=\"model.loadingRouteStatus\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 40px;\"></span>\n</div>\n<div class=\"margin-top-20\" ng-if=\"model.routeStatusInfo && model.routeId && !model.loadingRouteStatus\">\n<table class=\"table table-hover table-bordered remove-pad\">\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'customer.status' | translate}}</b></th>\n<td ng-if=\"model.routeStatusInfo.status\">{{model.routeStatusInfo.status | translate}}</td>\n<td ng-if=\"!model.routeStatusInfo.status\">{{'common.n_a' | translate}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'routeControl.stops' | translate}}</b></th>\n<td>{{model.routeStatusInfo.totalRouteStops}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'common.completed' | translate}}</b></th>\n<td>{{model.routeStatusInfo.totalCompletedStops}} | {{model.routeStatusInfo.totalRouteStops}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'routeSheet.messenger' | translate}}</b></th>\n<td ng-if=\"model.routeStatusInfo.messengerId\">{{model.routeStatusInfo.messengerId}} | {{model.routeStatusInfo.messengerName}}</td>\n<td ng-if=\"!model.routeStatusInfo.messengerId\">{{'common.n_a' | translate}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'branch_mgmt.location_truck' | translate}}</b></th>\n<td ng-if=\"model.routeStatusInfo.vehicleId\">{{model.routeStatusInfo.vehicleId}}</td>\n<td ng-if=\"!model.routeStatusInfo.vehicleId\">{{'common.n_a' | translate}}</td>\n</tr>\n</table>\n</div>\n</div>\n<div class=\"align-center-horizontally\" ng-if=\"!model.routeId && !model.loadingRouteStatus\">\n<div class=\"alert remove-bottom-margin\" ng-class=\"{'alert-danger': !model.routeId}\" style=\"text-align: center; width:100%\">\n<span>{{'route.route_select' | translate}}</span>\n</div>\n</div>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\" ng-if=\"model.stats === model.statsObj.user && !model.loading\">\n<div ng-class=\"{'form-group' : !model.serviceUserId && !model.loadingServiceOrderDetails}\">\n<div ng-if=\"model.details.assignServiceZone == 1\">\n<label for=\"\">{{'serviceTickets.matching_service_zone_users' | translate }} </label><br>\n<select class=\"form-control\" ng-model=\"model.serviceZoneUserId\" ng-change=\"serviceOrderDetails()\" ng-options=\"user.userId as (user.userId + ' | ' + user.username) for user in model.serviceZoneUserList\" ng-disabled=\"model.serviceUserId\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div ng-class=\"{'margin-top-15': model.details.assignServiceZone == 1}\">\n<label for=\"\">{{'serviceTickets.available_service_users' | translate }} </label><br>\n<select class=\"form-control\" ng-model=\"model.serviceUserId\" ng-change=\"serviceOrderDetails();\" ng-options=\"user.userId as user.key for user in model.serviceUserList\" ng-disabled=\"model.serviceZoneUserId\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"text-align-center margin-top-40\" ng-if=\"model.loadingServiceOrderDetails\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 40px;\"></span>\n</div>\n<div class=\"margin-top-20\" ng-if=\"(model.serviceUserId || model.serviceZoneUserId) && !model.loadingServiceOrderDetails\">\n<table class=\"table table-hover table-bordered remove-pad\">\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'serviceTickets.status_ASSIGNED' | translate}} ({{'branch.all_branches' | translate}})</b></th>\n<td>{{model.serviceOrderinfo.assignedTickets}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'shipment.hold' | translate}} ({{'branch.all_branches' | translate}})</b></th>\n<td>{{model.serviceOrderinfo.totalOnHold}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'branch_mgmt.location_truck' | translate}}</b></th>\n<td ng-if=\"model.serviceOrderinfo.vehicleId\">{{model.serviceOrderinfo.vehicleId}}</td>\n<td ng-if=\"!model.serviceOrderinfo.vehicleId\">{{'common.n_a' | translate}}</td>\n</tr>\n</table>\n</div>\n</div>\n<div class=\"align-center-horizontally\" ng-if=\"!model.serviceUserId && !model.loadingServiceOrderDetails && !model.serviceZoneUserId\">\n<div class=\"alert remove-bottom-margin\" ng-class=\"{'alert-danger': !model.serviceUserId}\" style=\"text-align: center; width:100%\">\n<span>{{'serviceTickets.select_user' | translate}}</span>\n</div>\n</div>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\" ng-if=\"model.stats === model.statsObj.external && !model.loading\">\n<div ng-class=\"{'form-group' : !model.externalProcessorCode && !model.loadingExternalProcessorCode}\">\n<div class=\"text-align-center margin-top-40\" ng-if=\"model.loadingExternalProcessorCode\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 40px;\"></span>\n</div>\n<div>\n<select class=\"form-control\" ng-model=\"model.externalProcessorCode\" ng-options=\"externalProcessor.code as (externalProcessor.id + ' | ' + externalProcessor.code) for externalProcessor in model.externalProcessorCodeList\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"align-center-horizontally\" ng-if=\"!model.externalProcessorCode && !model.loadingExternalProcessorCode\">\n<div class=\"alert remove-bottom-margin alert-danger\" style=\"text-align: center; width:100%\">\n<span>{{'serviceTickets.select_external_processor_code' | translate}}</span>\n</div>\n</div>\n</div>\n<div class=\"modal-footer text-center btn-pad-10\">\n<button class=\"btn btn-danger pull-left\" type=\"button\" ng-click=\"cancel()\">{{ 'common.close' | translate }}</button>\n<button class=\"btn btn-primary pull-right\" type=\"submit\" ng-disabled=\"serviceOrderAssignTemplate.$invalid || model.loadingRouteStatus || model.updateInProcess || model.loadingServiceOrderDetails || model.loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.updateInProcess}\"></span> {{'common.assign' | translate}}\n</button>\n<button class=\"btn btn-success pull-right\" type=\"button\" ng-if=\"model.stats === model.statsObj.user && (model.serviceUserId || model.serviceZoneUserId) && model.details.statusCode === 'ASSIGNED'\" ng-click=\"resendServiceTicketAssignment()\" ng-disabled=\"serviceOrderAssignTemplate.$invalid || model.loadingRouteStatus || model.updateInProcess || model.loadingServiceOrderDetails || model.loading || model.isSendingNotification\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.isSendingNotification}\"></span>Resend Assignment\n</button>\n</div>\n</form>\n";
var id1="serviceOrderAssign.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2607 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<div class=\"margin-top-05\">\n<h4 class=\"modal-title pull-left\" id=\"modal-title\">\n<b>{{'serviceTickets.createServiceTicket' | translate}}</b>\n</h4>\n</div>\n<div class=\"btn-group pull-right billing-review-container\">\n<label for=\"billingReviewRequire\">\n{{'serviceTickets.billing_review_required' | translate}}\n</label>\n<input type=\"checkbox\" id=\"billingReviewRequire\" bs-switch ng-model=\"model.billingReviewRequire\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"text-align-center margin-top-20 margin-bottom-20\" ng-if=\"isLocationLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px;\"></span>\n</div>\n<form name=\"serviceOrderForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-body\" id=\"modal-body\" ng-if=\"!isLocationLoading\" style=\"width: 100%; max-height: 673px; overflow-y: auto;\">\n<div class=\"row\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-6\">\n<label for=\"locationId\">{{'branch_mgmt.items.locations' | translate}}</label>\n<search-and-select ng-model=\"model.locationId\" values=\"locationList\" totalrecords=\"totalLocation\" key=\"Key\" hide-count=\"false\" onscroll=\"loadBranchLocation(searchKey, offset)\" none-selected=\"'common.none'\" on-click=\"autoPopulateLocationData();\" required>\n</search-and-select>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label>{{'location.stop_priority' | translate}}</label>\n<select class=\"form-control\" ng-model=\"model.stopPriority\" ng-options=\"priority.value as priority.label for priority in stopPriorityList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-12\">\n<label for=\"locationZone\">{{'location.location_zone' | translate}}</label>\n<div class=\"service-zone-container\" ng-if=\"model.locationZonesList && model.locationZonesList.length > 0\">\n<span ng-repeat=\"zone in model.locationZonesList\" class=\"service-zone-tag\">\n{{ zone.dayShort }} | {{ zone.locationZoneName }}\n</span>\n</div>\n<textarea ng-if=\"!model.locationZonesList || model.locationZonesList.length === 0\" class=\"form-control\" disabled=\"disabled\">N/A</textarea>\n</div>\n</div>\n<div class=\"form-group col-sm-12\">\n<label for=\"make\">{{'truck.make' | translate}}</label>\n<div class=\"service-zone-container\" ng-if=\"model.make && model.make.trim()\">\n<span ng-repeat=\"m in model.make.split(',')\" class=\"service-zone-tag\">\n{{ m.trim() }}\n</span>\n</div>\n<textarea ng-if=\"!model.make || !model.make.trim()\" class=\"form-control\" disabled=\"disabled\">N/A</textarea>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\" ng-if=\"locationType === 'ATM'\">\n<label for=\"model\">{{'truck.model' | translate}}</label>\n<input class=\"form-control\" ng-model=\"model.model\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"locationType === 'ATM'\">\n<label for=\"serialNumber\">{{'serviceTickets.serialNumber' | translate}}</label>\n<input class=\"form-control\" ng-model=\"model.serialNumber\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"locationType === 'ATM'\">\n<label for=\"lockType\">{{'serviceTickets.lockType' | translate}}</label>\n<select class=\"form-control\" ng-model=\"model.lockType\" ng-options=\"lockType.value as lockType.label for lockType in lockTypes\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"locationType === 'ATM'\">\n<label for=\"make\">{{'location.machine_owner' | translate}}</label>\n<input class=\"form-control\" ng-model=\"model.machineOwner\" disabled=\"disabled\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"locationType === 'ATM'\">\n<label for=\"make\">{{'common.FLM' | translate}}</label>\n<input class=\"form-control\" ng-model=\"model.FLMProvider\" disabled=\"disabled\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"locationType === 'ATM'\">\n<label for=\"make\">{{'location.SLM' | translate}}</label>\n<input class=\"form-control\" ng-model=\"model.SLMProvider\" disabled=\"disabled\"/>\n</div>\n</div>\n<div class=\"form-group col-sm-12\">\n<label for=\"note\">{{'serviceTickets.service_ticket_notes' | translate}}</label>\n<textarea ng-model=\"model.note\" class=\"form-control\" required></textarea>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-6\">\n<label for=\"actionCode\">{{'serviceSettings.action_code' | translate}}</label>\n<div class=\"multi-select action-code-dd-min-width action-codes-dd\" ng-class=\"{\n                            'invalid-multi-select-value': !model.actionCode.length,\n                            'valid-multi-select-value': model.actionCode.length\n                        }\" isteven-multi-select max-labels=\"5\" input-model=\"actionCodeList\" output-model=\"model.actionCode\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"validateUpdateButton()\" on-select-all=\"validateUpdateButton()\" on-select-none=\"validateUpdateButton()\" on-reset=\"validateUpdateButton()\">\n</div>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"actionCodeNote\">{{'serviceTickets.actionCodeNote' | translate}}</label>\n<textarea class=\"form-control\" rows=\"1\" ng-model=\"model.actionCodeNotes\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-6\">\n<label for=\"requestedTimeframe\">{{'serviceTickets.ticketPriority' | translate}}</label>\n<select class=\"form-control\" id=\"requestedTimeframe\" ng-model=\"model.requestedTimeframe\" ng-change=\"model.targetScheduleDate = null; model.targetScheduleTime = null; model.targetTime = null\" ng-options=\"requestedTimeframe.value as requestedTimeframe.label for requestedTimeframe in requestedTimeframeOptions\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\" ng-if=\"model.requestedTimeframe === scheduledPriorityValue\">\n<label for=\"targetScheduleDate\">{{'serviceTickets.targetDate' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"target-schedule-date\" name=\"targetScheduleDate\" ng-model=\"model.targetScheduleDate\" ng-required=\"model.requestedTimeframe === scheduledPriorityValue\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.targetScheduleDate}\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n<div class=\"form-group col-sm-3\" ng-if=\"model.requestedTimeframe === scheduledPriorityValue\">\n<label for=\"targetScheduleTime\">{{'serviceTickets.targetTime' | translate}}</label>\n<input type=\"time\" class=\"form-control\" id=\"target-schedule-time\" name=\"targetScheduleTime\" ng-model=\"model.targetScheduleTime\" ng-required=\"model.requestedTimeframe === scheduledPriorityValue\">\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'serviceTickets.add_picture' | translate}}</label>\n<div class=\"add-picture-container\">\n<input-file ng-model=\"model.selectedFiles\" multiple=\"true\" btn-class=\"btn-add-picture\" file-types=\"image/*\" selected-files=\"model.selectedFiles\" compress=\"true\">\n</input-file>\n<div ng-if=\"model.selectedFiles.length > 0\">\n<a href=\"#\" class=\"btn btn-info btn-md btn-preview-pictures\" ng-click=\"viewServiceTicketPictures(model.selectedFiles, 'Add Picture', $event)\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n<span class=\"preview-pictures-count\">{{model.selectedFiles.length}}</span>\n</a>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"hasAssignPermission && !isLocationLoading\">\n<hr>\n</div>\n<div class=\"col-sm-12 remove-pad\" id=\"assign-section\" ng-if=\"hasAssignPermission && !isLocationLoading\">\n<div class=\"clearfix\">\n<h4 class=\"pull-left\" style=\"margin-top: 0;\"><b>{{'common.assign' | translate}}</b></h4>\n<div class=\"btn-group pull-right\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default btn-sm ignore-validation-css\" ng-model=\"assign.stats\" uib-btn-radio=\"assign.statsObj.route\" ng-click=\"assignTabSelection('route')\" ng-class=\"{'btn-success': assign.stats === assign.statsObj.route}\">\n{{ 'checkin.route' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default btn-sm ignore-validation-css\" ng-model=\"assign.stats\" uib-btn-radio=\"assign.statsObj.user\" ng-click=\"assignTabSelection('user')\" ng-class=\"{'btn-success': assign.stats === assign.statsObj.user}\">\n{{ 'branchFundingSource.user' | translate }}\n</label>\n</div>\n<div class=\"btn-group\" ng-if=\"assign.showExternal\">\n<label class=\"btn btn-default btn-sm ignore-validation-css\" ng-model=\"assign.stats\" uib-btn-radio=\"assign.statsObj.external\" ng-click=\"assignTabSelection('external')\" ng-class=\"{'btn-success': assign.stats === assign.statsObj.external}\">\n{{ 'serviceTickets.external' | translate }}\n</label>\n</div>\n</div>\n</div>\n<div class=\"text-align-center margin-top-20 margin-bottom-20\" ng-if=\"assign.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px;\"></span>\n</div>\n<div class=\"margin-top-10\" ng-if=\"assign.stats === assign.statsObj.route && !assign.loading\">\n<select class=\"form-control\" ng-model=\"assign.routeId\" ng-change=\"assignRouteStatus()\" ng-options=\"route.routeId as (route.routeId + ' | ' + route.routeName) for route in assign.routeList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n<div class=\"text-align-center margin-top-20\" ng-if=\"assign.loadingRouteStatus\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px;\"></span>\n</div>\n<div class=\"margin-top-20\" ng-if=\"assign.routeStatusInfo && assign.routeId && !assign.loadingRouteStatus && assign.stats === assign.statsObj.route\">\n<table class=\"table table-hover table-bordered remove-pad\">\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'customer.status' | translate}}</b></th>\n<td ng-if=\"assign.routeStatusInfo.status\">{{assign.routeStatusInfo.status | translate}}</td>\n<td ng-if=\"!assign.routeStatusInfo.status\">{{'common.n_a' | translate}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'routeControl.stops' | translate}}</b></th>\n<td>{{assign.routeStatusInfo.totalRouteStops}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'common.completed' | translate}}</b></th>\n<td>{{assign.routeStatusInfo.totalCompletedStops}} | {{assign.routeStatusInfo.totalRouteStops}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'routeSheet.messenger' | translate}}</b></th>\n<td ng-if=\"assign.routeStatusInfo.messengerId\">{{assign.routeStatusInfo.messengerId}} | {{assign.routeStatusInfo.messengerName}}</td>\n<td ng-if=\"!assign.routeStatusInfo.messengerId\">{{'common.n_a' | translate}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'branch_mgmt.location_truck' | translate}}</b></th>\n<td ng-if=\"assign.routeStatusInfo.vehicleId\">{{assign.routeStatusInfo.vehicleId}}</td>\n<td ng-if=\"!assign.routeStatusInfo.vehicleId\">{{'common.n_a' | translate}}</td>\n</tr>\n</table>\n</div>\n<div class=\"margin-top-10\" ng-if=\"(assign.serviceUserId || assign.serviceZoneUserId) && !assign.loadingRouteStatus && assign.stats !== assign.statsObj.route\">\n<table class=\"table table-hover table-bordered table-condensed remove-pad\">\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'customer.status' | translate}}</b></th>\n<td ng-if=\"assign.routeStatusInfo.status\">{{assign.routeStatusInfo.status | translate}}</td>\n<td ng-if=\"!assign.routeStatusInfo.status\">{{'common.n_a' | translate}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'routeControl.stops' | translate}}</b></th>\n<td>{{assign.routeStatusInfo.totalRouteStops}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'routeSheet.messenger' | translate}}</b></th>\n<td ng-if=\"assign.routeStatusInfo.messengerId\">{{assign.routeStatusInfo.messengerId}} | {{assign.routeStatusInfo.messengerName}}</td>\n<td ng-if=\"!assign.routeStatusInfo.messengerId\">{{'common.n_a' | translate}}</td>\n</tr>\n</table>\n</div>\n</div>\n<div ng-if=\"assign.stats === assign.statsObj.user && !assign.loading\">\n<div ng-if=\"assign.assignServiceZone\">\n<label>{{'serviceTickets.matching_service_zone_users' | translate}}</label>\n<select class=\"form-control\" ng-model=\"assign.serviceZoneUserId\" ng-change=\"assignServiceOrderDetails()\" ng-options=\"user.userId as (user.userId + ' | ' + user.username) for user in assign.serviceZoneUserList\" ng-disabled=\"assign.serviceUserId\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div ng-class=\"{'margin-top-10': assign.assignServiceZone}\">\n<label>{{'serviceTickets.available_service_users' | translate}}</label>\n<select class=\"form-control\" ng-model=\"assign.serviceUserId\" ng-change=\"assignServiceOrderDetails()\" ng-options=\"user.userId as user.key for user in assign.serviceUserList\" ng-disabled=\"assign.serviceZoneUserId\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"assign.loadingServiceOrderDetails\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px;\"></span>\n</div>\n<div class=\"margin-top-10\" ng-if=\"(assign.serviceUserId || assign.serviceZoneUserId) && !assign.loadingServiceOrderDetails\">\n<table class=\"table table-hover table-bordered table-condensed remove-pad\">\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'serviceTickets.status_ASSIGNED' | translate}} ({{'branch.all_branches' | translate}})</b></th>\n<td>{{assign.serviceOrderinfo.assignedTickets}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'shipment.hold' | translate}} ({{'branch.all_branches' | translate}})</b></th>\n<td>{{assign.serviceOrderinfo.totalOnHold}}</td>\n</tr>\n<tr>\n<th class=\"table-row-width-50\" scope=\"row\"><b>{{'branch_mgmt.location_truck' | translate}}</b></th>\n<td ng-if=\"assign.serviceOrderinfo.vehicleId\">{{assign.serviceOrderinfo.vehicleId}}</td>\n<td ng-if=\"!assign.serviceOrderinfo.vehicleId\">{{'common.n_a' | translate}}</td>\n</tr>\n</table>\n</div>\n</div>\n<div class=\"margin-top-10\" ng-if=\"assign.stats === assign.statsObj.external && !assign.loading\">\n<select class=\"form-control\" ng-model=\"assign.externalProcessorCode\" ng-options=\"ep.code as (ep.id + ' | ' + ep.code) for ep in assign.externalProcessorCodeList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"modal-footer text-center btn-pad-10\">\n<div class=\"pull-right\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">{{ 'common.close' | translate }}</button>\n<button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"serviceOrderForm.$invalid || formSubmited || !model.actionCode.length\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': formSubmited}\"></span>\n{{'common.save' | translate}}\n</button>\n</div>\n</div>\n</form>\n";
var id1="serviceOrderCreate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2608 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"serviceOrderDetailTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'common.details' | translate}}</b>\n</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\">\n<tr>\n<th class=\"lbl-font-size-95 pr-2\" scope=\"row\"><b>{{'item.location' | translate}}</b></th>\n<td>\n<a href=\"#\" ng-click=\"goToServiceHistory()\">\n{{model.details.locationId}}\n</a> | {{model.details.locationName}}\n</td>\n</tr>\n<tr>\n<th class=\"lbl-font-size-95 pr-2\" scope=\"row\"><b>{{'common.address' | translate}}</b></th>\n<td>\n<span ng-if=\"model.details.address\">{{model.details.address}}, </span>\n<span ng-if=\"model.details.city\">{{model.details.city}}, </span>\n<span ng-if=\"model.details.state\">{{model.details.state}}, </span>\n<span ng-if=\"model.details.zip\">{{model.details.zip}}</span>\n</td>\n</tr>\n<tr>\n<th class=\"lbl-font-size-95 pr-2\" scope=\"row\"><b>{{'common.branch_id' | translate}}</b></th>\n<td>{{model.details.branchId}}</td>\n</tr>\n<tr>\n<th class=\"lbl-font-size-95 pr-2\" scope=\"row\"><b>{{'truck.model' | translate}}</b></th>\n<td>{{model.details.model}}</td>\n</tr>\n<tr>\n<th class=\"lbl-font-size-95 pr-2\" scope=\"row\"><b>{{'serviceTickets.serial' | translate}} #</b></th>\n<td>{{model.details.serialNumber}}</td>\n</tr>\n<tr>\n<th class=\"lbl-font-size-95 pr-2\" scope=\"row\"><b>{{'location.lockType' | translate}}</b></th>\n<td>{{model.details.lockType}}</td>\n</tr>\n<tr>\n<th class=\"lbl-font-size-95 pr-2\" scope=\"row\"><b>{{'serviceTickets.created_date' | translate}}</b></th>\n<td>{{convetToBrowserTimezone(model.details.createdAt)}}</td>\n</tr>\n</table>\n</div>\n<div class=\"modal-footer text-center btn-pad-10\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n";
var id1="serviceOrderDetails.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2609 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"serviceOrderNotesModal\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'common.notes' | translate}}</h4>\n</div>\n<div style=\"width: 100%; max-height: 500px;overflow-y: scroll;overflow-x: hidden;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"form-group col-sm-12\">\n<label>{{'serviceTickets.system_note' | translate}}</label>\n<br>\n<textarea id=\"system-note\" class=\"form-control\" rows=\"3\" ng-model=\"model.systemNote\" ng-disabled=\"model.details.externalProcessorId\" style=\"border-radius: 5px;\"></textarea>\n</div>\n<div class=\"form-group col-sm-12 remove-pad-bottom\">\n<label>{{'serviceTickets.user_notes' | translate}}</label>\n</div>\n<div class=\"form-group col-sm-12\" ng-repeat=\"history in model.serviceHistory\">\n<label class=\"badge\" ng-class=\"{'complete-bucket-color': (history.status === 'COMPLETE'),\n                                                                                                        'accepted-bucket-color':(history.status === 'ACCEPTED'),\n                                                                                                        'assigned-bucket-color': (history.status === 'ASSIGNED'),\n                                                                                                        'unassigned-bucket-color':(history.status === 'UNASSIGNED'),\n                                                                                                        'on-route-bucket-color':(history.status === 'ON_ROUTE'),\n                                                                                                        'on-site-bucket-color':(history.status === 'ON_SITE'),\n                                                                                                        'hold-bucket-color':(history.status === 'HOLD' || history.status === 'HOLD_PARTS'),\n                                                                                                        'pending-messenger-accept-bucket-color':(history.status === 'ASSIGNED_PENDING_MESSENGER_ACCEPT'),\n                                                                                                        'cant-completed-bucket-color':(history.status === 'INCOMPLETED'),\n                                                                                                        'cancelled-bucket-color':(history.status === 'CANCELLED'),\n                                                                                                        'unaccepted-bucket-color':(history.status === 'UNACCEPTED'),\n                                                                                                        'pending-assign-bucket-color':(history.status === 'PENDING_ASSIGN')}\">{{ getBucketName(history.status) }}{{ (history.performedById || history.userId) ? (' | ' + (history.performedById || history.userId)) : '' }}\n</label>\n<textarea class=\"form-control margin-top-5\" rows=\"2\" ng-model=\"history.serviceOrderStatusNote\" style=\"border-radius: 5px;margin-left: 20px; width: calc(100% - 20px);\" ng-disabled=\"model.details.externalProcessorId\" ng-change=\"history.isEdited = true\"></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer btn-pad-10\">\n<button class=\"btn btn-danger\" ng-class=\"{'pull-right': model.details.externalProcessorId, 'pull-left': !model.details.externalProcessorId}\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"serviceOrderNotesModal.$invalid\" ng-if=\"!model.details.externalProcessorId\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\" style=\"margin-left: 5px;\"></span> <span>{{ 'common.update' | translate }}</span>\n</button>\n</div>\n</form>\n";
var id1="serviceOrderNotes.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2610 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"serviceOrderStatusUpdateForm\" class=\"form-validate\" novalidate ng-submit=\"validateSupervisorScan()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'serviceTickets.status_update' | translate}}</h4>\n</div>\n<div style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"currentStatus\">{{'serviceTickets.currentStatus' | translate}} : </label> {{model.currentStatus}}\n</div>\n<div class=\"form-group\">\n<label for=\"status\">{{'common.select_status' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"model.newStatus\" required ng-options=\"status.value as status.label for status in model.statusList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group\">\n<label for=\"note\">{{'serviceTickets.note' | translate}} *</label>\n<textarea class=\"form-control\" rows=\"3\" ng-model=\"model.note\" style=\"border-radius: 5px;\" required></textarea>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer btn-pad-10\">\n<button class=\"btn btn-danger pull-left\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"serviceOrderStatusUpdateForm.$invalid || model.loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span> {{ 'common.update' | translate }}\n</button>\n</div>\n</form>";
var id1="serviceOrderStatusUpdate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2611 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"serviceTicketResolveImageTemplate\" class=\"form-validate\" novalidate>\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\"><b>Pictures</b> | {{model.picturesObj.encounterId}}</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 400px; overflow-y: auto;\">\n<div class=\"col-sm-12 margin-10 service-ticket-resolve-image-section remove-left-pad remove-right-pad\" ng-repeat=\"image in model.results track by $index\">\n<div class=\"col-sm-1 align-center-vertically\"><b>({{$index + 1}})</b></div>\n<div class=\"col-sm-11 service-ticket-resolve-image-border\">\n<div class=\"text-align-center margin-10\">\n<img ng-src=\"{{image.base64String}}\" width=\"250\" height=\"300\"/>\n</div>\n<div class=\"text-align-center margin-bottom-10 margin-10\">\n<button id=\"service-ticket-resolve-image-{{$index}}\" class=\"btn btn-success w-100\" type=\"button\" ng-click=\"download(image.base64String, image.name, $index)\" ng-disabled=\"model.loading\">\n<span class=\"glyphicon glyphicon-download\"></span>\n</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="serviceTicketResolveImageTemplate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2612 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"shipmentAssociateToTankerTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'routeControl.shipments' | translate}}</b> | {{model.tankerId}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.shipmentAssociateToTankerList.length\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'common.tracking_id' | translate}}</th>\n<th>{{'checkout.fromLocationName' | translate}}</th>\n<th>{{'bagout.toLocation' | translate}}</th>\n<th>{{'message.messages' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.shipmentAssociateToTankerList track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{data.trackingId}}</td>\n<td>{{data.fromLocationId}} | {{data.fromLocationName}}</td>\n<td>{{data.toLocationId}} | {{data.toLocationName}}</td>\n<td>\n<span ng-if=\"data.message == 'E_DELIVERY_NOT_ON_HOLD'\">{{'forceCLoseRouteModal.not_on_hold' | translate}}</span>\n<span ng-if=\"data.message == 'E_DELIVERY_NOT_CHECKED_OUT'\">{{'forceCLoseRouteModal.not_checked_out' | translate}}</span>\n<span ng-if=\"data.message == 'E_DELIVERY_NOT_DELIVERED'\">{{'forceCLoseRouteModal.not_delivered' | translate}}</span>\n<span ng-if=\"data.message == 'E_LOCATION_NOT_ON_HOLD'\">{{'forceCLoseRouteModal.not_picked' | translate}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.shipmentAssociateToTankerList.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': !model.shipmentAssociateToTankerList.length}\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button ng-if=\"model.shipmentAssociateToTankerList.length\" class=\"btn btn-success\" type=\"submit\" ng-disabled=\"model.loading\">\n{{ 'route.checkout' | translate }}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"model.loading\"></span>\n</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="shipmentAssociateToTanker.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2613 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"shipmentImageModal\" class=\"form-validate\" novalidate>\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>\n<span ng-if=\"model.stats === 'pickup'\">{{'branch_mgmt.pickup_image' | translate}}</span>\n<span ng-if=\"model.stats === 'delivery'\">{{'branch_mgmt.delivery_image' | translate}}</span>\n</b> | {{model.trackingId}}</h4>\n</div>\n<div style=\"position: relative; height: 500px; width: 100%; overflow: auto;\">\n<div class=\"text-align-center\" style=\"display: flex; justify-content: center; align-items: center; height: 100%;\">\n<img ng-src=\"{{model.image}}\" ng-style=\"{'width': zoomLevel + 'px', 'height': 'auto', 'max-width': 'none'}\" ng-click=\"ok()\"/>\n</div>\n<div style=\"position: absolute; top: 10px; right: 10px; display: flex; flex-direction: column; gap: 10px;\" ng-if=\"model.image\">\n<button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"zoomIn(); $event.stopPropagation()\">+</button>\n<button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"zoomOut(); $event.stopPropagation()\">-</button>\n</div>\n</div>\n<div class=\"modal-footer\">\n<a class=\"btn btn-primary pull-left\" target=\"_blank\" href=\"{{model.image}}\" ng-if=\"model.image\">\n{{ 'common.download' | translate }}\n</a>\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n";
var id1="shipmentImage.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2614 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"shipmentListForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'routeControl.shipments' | translate}}</b> | {{model.routeId}}</h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.shipments.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'common.tracking_id' | translate}}</th>\n<th>{{'bagout.fromLocation' | translate}}</th>\n<th>{{'bagout.toLocation' | translate}}</th>\n<th>{{'softDeletedShipments.amount' | translate}}</th>\n<th>{{'bagout.status' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.shipments track by $index\">\n<td>{{$index + 1}}</td>\n<td>\n<span class=\"history-link-btn\" ng-click=\"goToItemHistory(data)\">\n{{ data.trackingId }}\n</span>\n</td>\n<td>\n<img ng-src=\"assets/images/{{loadLocationTypeIcon(data.fromLocationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{data.fromLocationType}}\"/>\n{{data.fromLocationId}} | {{data.fromLocationName}}\n</td>\n<td>\n<img ng-src=\"assets/images/{{loadLocationTypeIcon(data.toLocationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{data.toLocationType}}\"/>\n<a ng-href=\"{{getLocationUrl(data)}}\" ng-click=\"onLocationClick($event, data)\">{{data.toLocationId}}</a> | {{data.toLocationName}}\n</td>\n<td>{{ data.amount | currency:\"$\" }}</td>\n<td class=\"text-danger\">{{translateMsg(data.status)}}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.shipments.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center remove-bottom-margin\" ng-class=\"{'alert-danger': !model.shipments.length}\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n";
var id1="shipmentList.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2615 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form class=\"form-validate\" name=\"Form\" novalidate>\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{(model.isImmediateDeliveryTransfer ? 'common.immediate_delivery_transfer' : 'checkin.shipment_not_picked_up') | translate}}</b>\n</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%;\">\n<table class=\"table table-hover table-bordered remove-pad\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th class=\"remove-white-space\">{{'common.tracking_id' | translate}}</th>\n<th>{{'common.from' | translate}}</th>\n<th>{{'common.to' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.shipmentInfo track by $index\">\n<td>{{$index + 1}}</td>\n<td class=\"remove-white-space\">{{data.trackingId}}</td>\n<td>{{data.fromLocationId}} | {{data.fromLocationName}}</td>\n<td>{{data.toLocationId}} | {{data.toLocationName}}</td>\n</tr>\n</tbody>\n</table>\n<div class=\"row margin-top-20\">\n<div class=\"form-group col-sm-6\" style=\"margin-bottom: 0;\">\n<label>{{ 'common.vault_date' | translate }} *</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" name=\"date\" ng-model=\"model.date\" date-format=\"dd-MMM-yyyy\" ng-change=\"onVaultDateChange()\" hidden-time=\"true\" date-options=\"minVaultDate\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.date}\" ng-keydown=\"$event.preventDefault()\" ng-required=\"true\" datepicker-append-to-body=\"true\" dropdown-append-to-body=\"true\" append-to-body=\"true\" show-button-bar=\"false\" ng-disabled=\"model.isGettingRoutes || model.isGettingLocationRoutes || model.loading\">\n</datetimepicker>\n</div>\n<div class=\"form-group col-sm-6\" style=\"margin-bottom: 0;\">\n<label>{{ 'checkout.route' | translate }} *</label>\n<search-and-select ng-model=\"model.routeId\" values=\"model.routeList\" key=\"Key\" totalrecords=\"model.routeTotalRecords\" onscroll=\"reloadRouteData(searchKey, offset)\" none-selected=\"'common.none'\" required ng-disabled=\"model.isGettingRoutes || model.isGettingLocationRoutes || model.loading\"></search-and-select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-12\" style=\"margin-bottom: 0;\">\n<label>{{ 'common.notes' | translate }}</label>\n<textarea class=\"form-control\" name=\"note\" ng-model=\"model.note\" rows=\"3\"></textarea>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"Form.$invalid || model.loading || model.isGettingRoutes || model.isGettingLocationRoutes\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"model.loading\"></span>\n<span>{{'itemNotDeliveredModal.reRoute' | translate}}</span>\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n</div>\n</form>\n";
var id1="shipmentNotPickedUp.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2616 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"chkTitle\">{{'checkinSelectionModal.title' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row\">\n<div class=\"col-sm-12\" id=\"shipmentModal\">\n<div class=\"list-group\">\n<div ng-repeat=\"choice in choices\" class=\"list-group-item cursor-pointer\" ng-class=\"{'active': $index === selectedIndex}\" ng-click=\"setSelected($index)\" id=\"tab{{$index}}\" tabindex=\"0\" style=\"outline: none;\">\n<span>\n{{choice.trackingId}} | {{choice.toLocationId}} - {{choice.toName}} | {{choice.fromLocationId}} - {{choice.fromName}} | {{choice.amount | currency:'$'}}\n</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<div class=\"pull-left\">\n<button class=\"btn btn-success\" ng-if=\"displayAddBagButton\" ng-click=\"showAddBagModal()\">{{'checkinSelectionModal.forceBag' | translate}}</button>\n</div>\n<button class=\"btn btn-primary\" ng-disabled=\"itemSelected\" ng-class=\"{'disabled': itemSelected || selectedIndex === -1}\" type=\"button\" ng-click=\"selectItem()\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': itemSelected}\"></span> {{ 'checkinSelectionModal.select' | translate }}\n</button>\n<button class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'common.cancel' | translate }}</button>\n</div> ";
var id1="shipmentSelection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2617 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"stopCommentsTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>Stop Comments</b> | {{model.locationId}}\n</h4>\n</div>\n<div class=\"text-align-center margin-10 margin-bottom-10\" ng-if=\"model.loading && !model.errorMessage\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\" ng-if=\"!model.loading\">\n<table class=\"table table-hover table-bordered remove-pad table-pad-5\" ng-if=\"model.transactionDetails.length && !model.errorMessage\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">#</th>\n<th class=\"text-center\">{{'billableEvents.event' | translate}}</th>\n<th class=\"text-center contents-no-wrap\">{{'common.tracking_id' | translate}}</th>\n<th class=\"text-center\">{{'bulkCash.amount' | translate}}</th>\n<th class=\"text-center contents-no-wrap\">{{'users.user' | translate}}</th>\n<th class=\"text-center contents-no-wrap\">{{'common.dateTime' | translate}}</th>\n<th class=\"text-center\">{{'bypassCode.comments' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"data in model.transactionDetails track by $index\">\n<td>{{$index + 1}}</td>\n<td class=\"contents-no-wrap text-danger\">{{translateTransactionType(data.tranType)}}</td>\n<td class=\"contents-no-wrap\"><a href=\"#\" ng-click=\"goToItemHistory(data.trackingId)\"> {{data.trackingId}}</a></td>\n<td class=\"contents-no-wrap\" ng-class=\"{'text-danger': data.tranType === 'SHORT_LOAD'}\">\n<span ng-if=\"data.shipmentAmount !== null\">{{data.shipmentAmount | currency:fraction:\"0\"}}</span>\n<span ng-if=\"data.shipmentAmount == null\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"data.tranType === 'SHORT_LOAD'\"> | {{data.loadedAmount | currency:fraction:\"0\"}} ({{data.loadedAmount - data.shipmentAmount | currency:fraction:\"0\"}})\n</span>\n</td>\n<td>{{data.performedById}} | {{data.firstName}} {{data.lastName}}</td>\n<td>{{data.transactionDate | date: 'MM-dd-yyyy | hh:mm a'}}</td>\n<td>{{data.comments}}</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.transactionDetails.length && !model.errorMessage\">\n<div class=\"col-sm-12 alert alert-danger text-center\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div ng-if=\"model.errorMessage\">\n<div class=\"col-sm-12 alert alert-danger text-center\" style=\"margin-bottom: 0px;\">\n{{model.errorMessage}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="stopComments.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2618 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<form name=\"stopTransferForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}} modal-dialog\" style=\"margin: 0px; width: 100%\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'routeControl.stop_transfer' | translate }} | {{model.currentDay}}</strong>\n</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"stop-transfer-modal-section\" ng-if=\"!model.loading\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"remove-left-pad col-sm-6 route-right-vertical-line\">\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<datetimepicker class=\"datetimepicker-input\" ng-class=\"{'required-datetimepicker': model.date}\" ng-model=\"model.fromRouteDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" date-options=\"minVaultDate\" ng-click=\"getSourceRoute()\"/>\n</div>\n<div class=\"col-sm-8\">\n<select class=\"form-control\" ng-model=\"model.fromRouteId\" ng-options=\"route.routeId as (route.routeId + ' | ' + route.routeName) for route in model.sourceRoutes\" ng-change=\"changeSourceRoutes()\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\" ng-if=\"model.fromRouteId\">\n<div id=\"mapOne\" class=\"border-radius-05 leaf-map dd-z-index\"></div>\n<div class=\"form-group margin-10\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-2 pull-left _remove-left-pad\">\n<label for=\"\">{{'route.routeStop' | translate}}</label>\n</div>\n<div class=\"col-sm-4 align-center\">\n<label for=\"\">{{'batch.location' | translate}}</label>\n</div>\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"\">{{'routeControl.shipments' | translate}}</label>\n</div>\n<div class=\"col-sm-2 align-center remove-left-pad\">\n<label for=\"\">{{'routeControl.transfer' | translate}}</label>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<ul ng-class=\"{'cst-padding': model.fromRouteStops.length==0 }\" ng-if=\"model.fromRouteStops\" dnd-list=\"model.fromRouteStops\" class=\"list-group location-sequence\">\n<li class=\"list-group-item display-flex\" ng-repeat=\"location in model.fromRouteStops\" dnd-draggable=\"location\" dnd-moved=\"locationMoved($index)\" dnd-effect-allowed=\"move\" dnd-disable-if=\"location.disabledStopTransfer || (model.toRouteId && !model.destinationRouteIsReleased) || model.isUpdating || model.isUpdateOptimizing || model.isOptimizing\" uib-tooltip=\"{{location.disableReason ? location.disableReason : ''}}\" ng-class=\"{'disable-stop-transfer': location.disabledStopTransfer || (model.toRouteId && !model.destinationRouteIsReleased)}\">\n<div class=\"col-sm-1 align-center-vertically\">\n<strong>{{$index+1}}</strong>\n</div>\n<div class=\"col-sm-10 align-center-vertically\">\n<div class=\"col-sm-1\">\n<img ng-src=\"{{loadImage(location.locationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"\"/>\n</div>\n<div class=\"col-sm-5 align-center-vertically\" uib-tooltip=\"{{location.locationName}} | {{location.address}}, {{location.city}}, {{location.zip}}\" tooltip-enable=\"!location.disableReason\">\n<strong>{{location.locationId}} | {{location.locationName}}</strong>\n</div>\n<div class=\"remove-right-pad col-sm-5\">\n<span ng-repeat=\"shipment in location.shipmentInfo track by $index\">\n<strong>{{shipment.trackingId}} <span ng-if=\"shipment.orderType\" class=\"text-danger\">({{shipment.orderType}})</span></strong>\n<span ng-if=\"$index + 1 !== location.shipmentInfo.length\">,</span>\n<span class=\"text-danger bold-font\" ng-if=\"!shipment.trackingId\">({{'common.n_a' | translate}})</span>\n</span>\n</div>\n</div>\n<div class=\"col-sm-1 align-center-vertically text-center remove-left-pad remove-right-pad\" dnd-nodrag>\n<button type=\"button\" class=\"btn btn-xs stop-transfer-arrow\" ng-if=\"!location.disabledStopTransfer\" ng-disabled=\"isTransferDisabled(location)\" ng-click=\"transferStop($index)\">\n<img ng-src=\"assets/images/arrow-inbound.png\" class=\"custom-icon img-width\"/>\n</button>\n</div>\n</li>\n</ul>\n</div>\n<div class=\"text-center\">\n<strong ng-show=\"!model.fromRouteStops || !model.fromRouteStops.length\" class=\"text-muted\">\n{{'route.noRouteSequenceLocation' | translate}}\n</strong>\n</div>\n<div class=\"text-center margin-top-10\" ng-if=\"model.fromRouteStops && model.fromRouteStops.length\">\n<button type=\"button\" class=\"btn btn-primary pull-left\" style=\"margin-bottom: 20px;\" ng-click=\"moveAllStops()\" ng-disabled=\"isMoveAllStopsDisabled() || model.isUpdating || model.isUpdateOptimizing || model.isOptimizing\">\nMove all Stops\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-horizontally\" ng-if=\"!model.fromRouteId\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': !model.fromRouteId}\" style=\"text-align: center; width:100%\">\n<span>{{'route.route_select' | translate}}</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-6 route-left-vertical-line remove-right-pad\">\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<datetimepicker class=\"datetimepicker-input\" ng-class=\"{'required-datetimepicker': model.date}\" ng-model=\"model.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" date-options=\"minVaultDate\" ng-click=\"loadNextdayRoutes()\"/>\n</div>\n<div class=\"col-sm-8\">\n<select class=\"form-control\" ng-model=\"model.toRouteId\" ng-options=\"route.routeId as (route.routeId + ' | ' + route.routeName) for route in model.allRoutes\" ng-change=\"changeRoute()\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\" ng-if=\"model.toRouteId\">\n<div id=\"mapTwo\" class=\"border-radius-05 leaf-map dd-z-index\"></div>\n<div class=\"form-group margin-10\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-2 pull-left _remove-left-pad\">\n<label for=\"\">{{'route.routeStop' | translate}}\n</label>\n</div>\n<div class=\"col-sm-5 align-center\">\n<label for=\"\">{{'batch.location' | translate}}</label>\n</div>\n<div class=\"col-sm-5 remove-left-pad\">\n<label for=\"\">{{'routeControl.shipments' | translate}}</label>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<ul ng-class=\"{'cst-padding': model.destinationRouteStops.length==0 }\" ng-if=\"model.destinationRouteStops\" dnd-list=\"(model.toRouteId && model.destinationRouteIsReleased) ? model.destinationRouteStops : null\" class=\"list-group location-sequence\">\n<li class=\"list-group-item display-flex\" ng-repeat=\"location in model.destinationRouteStops\">\n<div class=\"col-sm-1 align-center-vertically\" ng-if=\"!(model.destinationRouteIsReleased && model.destinationRouteStops.length > 1 && model.transferredStops.length > 0)\">\n<strong>{{$index+1}}</strong>\n</div>\n<div class=\"col-sm-2 remove-pad dest-seq-order align-center-vertically\" ng-if=\"model.destinationRouteIsReleased && model.destinationRouteStops.length > 1 && model.transferredStops.length > 0\">\n<input type=\"number\" class=\"form-control dest-seq-input no-spinner\" min=\"1\" max=\"{{model.destinationRouteStops.length}}\" ng-model=\"model.destSequenceInput[$index]\" ng-model-options=\"{ debounce: 1000, allowInvalid: true }\" ng-change=\"destSequenceTyped($index)\">\n<span class=\"dest-seq-move\">\n<button type=\"button\" class=\"btn btn-xs btn-default\" ng-disabled=\"$index === 0\" ng-click=\"moveDestStop($index, -1)\">\n<span class=\"glyphicon glyphicon-chevron-up\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-default\" ng-disabled=\"$index === model.destinationRouteStops.length - 1\" ng-click=\"moveDestStop($index, 1)\">\n<span class=\"glyphicon glyphicon-chevron-down\"></span>\n</button>\n</span>\n</div>\n<div class=\"align-center-vertically\" ng-class=\"(model.destinationRouteIsReleased && model.destinationRouteStops.length > 1 && model.transferredStops.length > 0) ? 'col-sm-10' : 'col-sm-11'\">\n<div class=\"col-sm-1\">\n<img ng-src=\"{{loadImage(location.locationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"\"/>\n</div>\n<div class=\"col-sm-5 align-center-vertically\" uib-tooltip=\"{{location.locationName}} | {{location.address}}, {{location.city}}, {{location.zip}}\">\n<strong>{{location.locationId}} | {{location.locationName}}</strong>\n</div>\n<div class=\"remove-right-pad col-sm-5\">\n<span ng-repeat=\"shipment in location.shipmentInfo track by $index\">\n<strong>{{shipment.trackingId}} <span ng-if=\"shipment.orderType\" class=\"text-danger\">({{shipment.orderType}})</span></strong>\n<span ng-if=\"$index + 1 !== location.shipmentInfo.length\">,</span>\n<span class=\"text-danger bold-font\" ng-if=\"!shipment.trackingId\">({{'common.n_a' | translate}})</span>\n</span>\n</div>\n</div>\n</li>\n</ul>\n</div>\n<div class=\"text-center\">\n<strong ng-show=\"!model.destinationRouteStops || !model.destinationRouteStops.length\" class=\"text-muted\">\n{{'route.noRouteSequenceLocation' | translate}}\n</strong>\n</div>\n<div class=\"text-center margin-top-10\" ng-if=\"model.toRouteId && !model.destinationRouteIsReleased\">\n<button class=\"btn btn-warning\" ng-disabled=\"model.releaseRouteStatus === 'processing' || model.isPreviousVaultDate\" ng-click=\"releaseDestinationRoute()\">\n<i class=\"glyphicon\" ng-class=\"{\n                                        'glyphicon-refresh fast-right-spinner': model.releaseRouteStatus === 'processing',\n                                        'glyphicon-ok': model.releaseRouteStatus === 'success',\n                                        'glyphicon-remove': model.releaseRouteStatus === 'error',\n                                    }\"></i>\n<span>{{'routeControl.release'|translate }}</span>\n</button>\n</div>\n<div class=\"text-center margin-top-10\" ng-if=\"model.destinationRouteStops && model.destinationRouteStops.length > 0 && model.toRouteId && model.destinationRouteIsReleased\">\n<button type=\"button\" class=\"btn btn-primary pull-left\" style=\"margin-bottom: 20px; margin-right: 10px;\" ng-disabled=\"!model.transferredStops.length || model.isUpdateOptimizing || model.isUpdating\" ng-click=\"update()\">\n<span>Update</span>\n<i class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-show=\"model.isUpdating\"></i>\n</button>\n<button type=\"button\" class=\"btn btn-primary pull-left\" style=\"margin-bottom: 20px; margin-right: 10px;\" ng-disabled=\"!model.transferredStops.length || model.isUpdateOptimizing || model.isUpdating\" ng-click=\"updateAndOptimize()\">\n<span>Update & Optimize</span>\n<i class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-show=\"model.isUpdateOptimizing\"></i>\n</button>\n<button type=\"button\" class=\"btn btn-primary pull-left\" style=\"margin-bottom: 20px;\" ng-disabled=\"model.transferredStops.length > 0 || model.isOptimizing || model.isUpdating || model.isUpdateOptimizing\" ng-click=\"optimizeRoute()\">\n<span>Route Optimize</span>\n<i class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-show=\"model.isOptimizing\"></i>\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-horizontally\" ng-if=\"!model.toRouteId\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': !model.toRouteId}\" style=\"text-align: center; width:100%\">\n<span>{{'route.route_select' | translate}}</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-secondary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading || model.isUpdateOptimizing || model.isOptimizing || model.isUpdating\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n<style>\n.modal-dialog {\n        width: 90%\n    }\n\n    .stop-transfer-modal-section {\n        width: 100%;\n        max-height: 700px;\n        min-height: 700px; \n        overflow-y: auto;\n    }\n\n    .dndDragging{\n        opacity: 1.5;\n        color:green\n    }\n\n    .stop-transfer-arrow {\n        background: transparent;\n        border: none;\n        box-shadow: none;\n        padding: 0;\n    }\n\n    .stop-transfer-arrow img {\n        width: 40px;\n    }\n\n    .stop-transfer-arrow:hover:not([disabled]) {\n        opacity: 0.8;\n    }\n\n    .stop-transfer-arrow[disabled] {\n        opacity: 0.4;\n        cursor: not-allowed;\n    }\n\n    .dest-seq-order {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n    }\n\n    .dest-seq-input {\n        width: 52px;\n        height: 28px;\n        padding: 2px 4px;\n        text-align: center;\n        font-weight: bold;\n    }\n\n    .dest-seq-move {\n        display: inline-flex;\n        flex-direction: column;\n    }\n\n    .dest-seq-move .btn {\n        padding: 0 5px;\n        line-height: 1.1;\n        font-size: 10px;\n    }\n</style>\n";
var id1="stopTransfer.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2619 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"chkTitle\">{{'surchargeDetailsModal.title' | translate}} {{customer.customerName}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<table class=\"remove-bottom-margin table table-bordered table-condensed\">\n<thead>\n<tr>\n<th>{{'surchargeDetailsModal.surcharge' | translate}}</th>\n<th>{{'surchargeDetailsModal.fee' | translate}}</th>\n<th class=\"text-right\">{{'surchargeDetailsModal.amount' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"surcharge in breakdown\">\n<td>{{surcharge.labelKey | translate}}</td>\n<td>\n<span>{{surcharge.minPercentage | currency:'':2}}%</span>\n<span ng-if=\"surcharge.maxPercentage !== surcharge.minPercentage\"> - {{surcharge.maxPercentage | currency:'':2}}%</span>\n</td>\n<td class=\"text-right\">{{surcharge.amount | currency}}</td>\n</tr>\n<tr ng-if=\"!breakdown.length\">\n<td colspan=\"3\" class=\"text-center\">{{'surchargeDetailsModal.noActiveSurcharge' | translate}}</td>\n</tr>\n</tbody>\n<tfoot ng-if=\"breakdown.length\">\n<tr>\n<th colspan=\"2\">{{'surchargeDetailsModal.totalSurcharge' | translate}}</th>\n<th class=\"text-right\">{{customer.storedSurcharge | currency}}</th>\n</tr>\n</tfoot>\n</table>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</div>\n";
var id1="storedSurchargeDetails.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2620 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"chkTitle\">{{'surchargeDetailsModal.title' | translate}} {{customer.customerName}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div ng-if=\"!filterAligned && !onTheseRecords\" class=\"alert alert-danger margin-bottom-5\">\n<i class=\"glyphicon glyphicon-warning-sign\"></i> <span>{{'surchargeDetailsModal.filterMismatch' | translate}}</span>\n</div>\n<div ng-if=\"widerWindowNote\" class=\"alert alert-info margin-bottom-5\">\n<i class=\"glyphicon glyphicon-info-sign\"></i> <span>{{widerWindowNote}}</span>\n</div>\n<table class=\"remove-bottom-margin table table-bordered table-condensed\">\n<thead>\n<tr>\n<th>{{'surchargeDetailsModal.surcharge' | translate}}</th>\n<th ng-if=\"!onTheseRecords\">{{'customer.surcharge_interval' | translate}}</th>\n<th>{{'surchargeDetailsModal.fee' | translate}}</th>\n<th ng-if=\"!onTheseRecords\">{{'surchargeDetailsModal.covers' | translate}}</th>\n<th ng-class=\"{'text-right': onTheseRecords}\">{{'surchargeDetailsModal.amount' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"surcharge in customer.surchargeBreakdown\">\n<td>{{surcharge.labelKey | translate}}</td>\n<td ng-if=\"!onTheseRecords\">\n<span ng-if=\"surcharge.intervalLabelKey\">{{surcharge.intervalLabelKey | translate}}</span>\n<span ng-if=\"!surcharge.intervalLabelKey\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"surcharge.percentage\">{{surcharge.percentage | currency:'':2}}%</span>\n<span ng-if=\"!surcharge.percentage\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"remove-white-space\" ng-if=\"!onTheseRecords\">\n<span ng-if=\"surcharge.coverageLabel\">{{surcharge.coverageLabel}}</span>\n<span ng-if=\"surcharge.coverageLabel\" class=\"label\" ng-class=\"surcharge.isFinal ? 'label-success' : 'label-info'\">\n{{(surcharge.isFinal ? 'surchargeDetailsModal.final' : 'surchargeDetailsModal.running') | translate}}\n</span>\n<span ng-if=\"!surcharge.coverageLabel\">{{'common.n_a' | translate}}</span>\n</td>\n<td ng-class=\"{'text-right': onTheseRecords}\">{{surcharge.displayAmount | currency}}</td>\n</tr>\n<tr ng-if=\"!customer.surchargeBreakdown.length\">\n<td ng-attr-colspan=\"{{onTheseRecords ? 3 : 5}}\" class=\"text-center\">{{'surchargeDetailsModal.noActiveSurcharge' | translate}}</td>\n</tr>\n</tbody>\n<tfoot ng-if=\"customer.surchargeBreakdown.length\">\n<tr>\n<th ng-attr-colspan=\"{{onTheseRecords ? 2 : 4}}\">{{'surchargeDetailsModal.totalSurcharge' | translate}}</th>\n<th ng-class=\"{'text-right': onTheseRecords}\">{{customer.totalSurcharge | currency}}</th>\n</tr>\n</tfoot>\n</table>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">{{ 'Cancel' | translate }}</button>\n</div>\n";
var id1="surchargeDetails.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2621 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"chkTitle\">{{'customer.surcharge_history' | translate}} | {{customerName}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"btn-group surcharge-history-filter\" ng-if=\"groups.length\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-class=\"{'active btn-primary': !selectedType}\" ng-click=\"selectType(null)\">\n{{'customer.surcharge_history_all' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-repeat=\"group in groups track by group.type\" ng-class=\"{'active btn-primary': selectedType === group.type}\" ng-click=\"selectType(group.type)\">\n{{group.labelKey | translate}} <span class=\"badge\">{{group.rows.length}}</span>\n</button>\n</div>\n<div ng-repeat=\"group in groups track by group.type\" ng-if=\"!selectedType || selectedType === group.type\">\n<h4><b>{{group.labelKey | translate}}</b></h4>\n<table class=\"table table-bordered table-condensed\">\n<thead>\n<tr>\n<th class=\"surcharge-history-nowrap\">{{'customer.surcharge_history_from' | translate}}</th>\n<th class=\"surcharge-history-nowrap\">{{'customer.surcharge_history_to' | translate}}</th>\n<th>{{'common.status' | translate}}</th>\n<th>%</th>\n<th class=\"surcharge-history-nowrap\">{{'customer.surcharge_interval' | translate}}</th>\n<th>{{'customer.surcharge_billing_events' | translate}}</th>\n<th class=\"surcharge-history-nowrap\">{{'customer.surcharge_history_changed_by' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"row in group.rows track by row.id\" ng-class=\"{'info': row.isCurrent}\">\n<td class=\"surcharge-history-nowrap\">{{row.fromLabel}}</td>\n<td class=\"surcharge-history-nowrap\">\n<span ng-if=\"!row.isCurrent\">{{row.toLabel}}</span>\n<span ng-if=\"row.isCurrent\" class=\"label label-success\">{{'customer.surcharge_history_current' | translate}}</span>\n</td>\n<td ng-class=\"{'surcharge-history-changed': row.changed.enabled}\">\n<span ng-if=\"!row.isCurrent\" class=\"label label-default\">{{'customer.surcharge_history_not_in_effect' | translate}}</span>\n<span ng-if=\"row.isCurrent\" class=\"label\" ng-class=\"row.enabled ? 'label-primary' : 'label-default'\">\n{{(row.enabled ? 'customer.surcharge_history_enabled' : 'common.disabled') | translate}}\n</span>\n</td>\n<td class=\"surcharge-history-nowrap\" ng-class=\"{'surcharge-history-changed': row.changed.percentage}\">\n<span ng-if=\"row.enabled && row.percentage !== null\">{{row.percentage | currency:'':2}}%</span>\n<span ng-if=\"!row.enabled || row.percentage === null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"surcharge-history-nowrap\" ng-class=\"{'surcharge-history-changed': row.changed.interval}\">\n<span ng-if=\"row.enabled && row.intervalLabelKey\">{{row.intervalLabelKey | translate}}</span>\n<span ng-if=\"!row.enabled || !row.intervalLabelKey\">{{'common.n_a' | translate}}</span>\n</td>\n<td ng-class=\"{'surcharge-history-changed': row.changed.events}\">\n<span ng-if=\"row.enabled && row.eventLabels.length\">{{row.eventLabels.join(', ')}}</span>\n<span ng-if=\"!row.enabled || !row.eventLabels.length\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"row.changedBy\">{{row.changedBy}}</span>\n<span ng-if=\"!row.changedBy\">{{'common.n_a' | translate}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"!groups.length\" class=\"text-center\">{{'customer.surcharge_history_empty' | translate}}</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">{{ 'common.close' | translate }}</button>\n</div>\n";
var id1="surchargeHistory.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2622 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<timeout-countdown event=\"event\" model-details=\"modelDetails\" on-confirm=\"ok\" on-error=\"cancel\"></timeout-countdown>\n</div>";
var id1="timeoutCountdown.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2623 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"translate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'message.update_message' | translate}}</b>\n</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!model.loading\" class=\"list-group remove-bottom-margin\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<div class=\"row\">\n<div id=\"inline\" class=\"col-sm-12\">\n<label for=\"message-id\">{{'message.messageId' | translate}} *</label>\n<input type=\"text\" id=\"message-id\" ng-model=\"model.message.messageId\" class=\"form-control\" required ng-disabled=\"true\"/>\n</div>\n<div class=\"col-sm-12\">\n<br>\n<label for=\"\">{{'message.descriptionInEng' | translate}} *</label>\n<textarea cols=\"30\" rows=\"3\" ng-model=\"model.message.englishMessagedescription\" class=\"form-control\" required></textarea>\n</div>\n<div class=\"col-sm-12\">\n<br>\n<label for=\"\">{{'message.descriptionInSpn' | translate}} *</label>\n<textarea cols=\"30\" rows=\"3\" ng-model=\"model.message.spanishMessagedescription\" class=\"form-control\" required></textarea>\n</div>\n<div class=\"col-sm-3\" style=\"margin-bottom: 5px;\">\n<br>\n<label for=\"defaultSelection\">{{'message.defaultSelection' | translate }}</label>\n<input bs-switch switch-size=\"{{ toggleSwitchUI.size }}\" switch-on-text=\"{{ toggleSwitchUI.label.on }}\" switch-off-text=\"{{ toggleSwitchUI.label.off }}\" switch-on-color=\"{{ toggleSwitchUI.onColor }}\" switch-off-color=\"{{ toggleSwitchUI.offColor }}\" ng-model=\"model.message.defaultSelection\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"translate.$invalid || model.loading\">\n{{ 'common.ok' | translate }}\n</button>\n</div>\n</form>\n";
var id1="translateMessage.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2624 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\">\n<h4 class=\"modal-title\">\n{{'contract.locations_not_covered' | translate}}\n<span class=\"badge\" style=\"background-color: #dc3545;\">{{totalRecords}}</span>\n</h4>\n</div>\n<div class=\"modal-body\">\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n<div class=\"alert alert-danger\" ng-if=\"!loading && error\">{{error}}</div>\n<div class=\"alert alert-info text-center\" ng-if=\"!loading && !error && !locations.length\">\n{{'common.no_data_found' | translate}}\n</div>\n<div class=\"table-responsive\" ng-if=\"!loading && !error && locations.length\">\n<table class=\"table table-condensed table-bordered table-striped remove-bottom-margin\">\n<thead>\n<tr>\n<th>{{'location.id' | translate}}</th>\n<th>{{'location.name' | translate}}</th>\n<th>{{'location.branch' | translate}}</th>\n<th>{{'location._address' | translate}}</th>\n<th>{{'location._city' | translate}}</th>\n<th>{{'location._state' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"location in locations track by location.id\">\n<td>\n<a href=\"#\" ng-click=\"goToLocation(location.id)\">\n{{location.id}}\n</a>\n</td>\n<td>{{location.name}}</td>\n<td>{{location.branchId}}</td>\n<td>{{location.address}}</td>\n<td>{{location.city}}</td>\n<td>{{location.state}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"modal-footer d-flex align-items-center\">\n<ul ng-show=\"totalRecords > pagination.pageLimit\" uib-pagination total-items=\"totalRecords\" items-per-page=\"pagination.pageLimit\" max-size=\"10\" force-ellipses=\"true\" ng-model=\"pagination.page\" ng-change=\"load()\" next-text=\"{{'common.next' | translate}}\" previous-text=\"{{'common.previous' | translate}}\">\n</ul>\n<button type=\"button\" class=\"btn btn-danger\" ng-click=\"close()\" style=\"margin-left: auto; flex-shrink: 0;\">\n{{'common.close' | translate}}\n</button>\n</div>";
var id1="uncoveredLocations.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2625 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"undoPackedOrderForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-danger\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'orderPacking.unpack_order' | translate}} | {{model.shipments.orderNo}}</h4>\n</div>\n<div ng-if=\"!loading\" class=\"list-group remove-bottom-margin\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"font-size-16\">{{'orderPacking.undo_warning' | translate}}</div>\n<div class=\"form-group form-checbox margin-10 remove-bottom-margin\">\n<input type=\"checkbox\" name=\"fancy-checkbox-default\" ng-model=\"model.deleteOrder\" ng-click=\"setFocus()\" id=\"fancy-checkbox-default\" autocomplete=\"off\"/>\n<div class=\"btn-group btn-checkbox-group\">\n<label for=\"fancy-checkbox-default\" class=\"btn btn-default\">\n<span class=\"glyphicon glyphicon-ok\"></span>\n<span> </span>\n</label>\n<label for=\"fancy-checkbox-default\" class=\"btn btn-danger\">\n{{'orderPacking.delete_order' | translate}}\n</label>\n</div>\n<div class=\"margin-10\" ng-if=\"model.deleteOrder\">\n<label>{{ 'common.reason' | translate }}</label>\n<textarea id=\"deleted-reason\" class=\"form-control\" rows=\"3\" ng-model=\"model.reason\" style=\"border-radius: 5px\"></textarea>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">{{'common.no' | translate}}</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"undoPackedOrderForm.$invalid || model.loading\">\n{{'common.yes' | translate}} <span ng-if=\"model.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n</div>\n</form>";
var id1="undoPackedOrder.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2626 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"updateBillingRecordForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'common.update' | translate}} | {{model.billingRecordId}}</b>\n</h4>\n</div>\n<div class=\"text-align-center margin-top-10 margin-bottom-10\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row\" ng-if=\"!model.loading\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-12\">\n<div class=\"alert alert-info margin-bottom-10\">\n<i class=\"glyphicon glyphicon-info-sign\"></i>\n<span>{{'surchargeDetailsModal.recalculateOnUpdate' | translate}}</span>\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label for=\"deliveryDate\">{{'common.location' | translate}} *</label>\n<search-and-select ng-model=\"model.locationObj.selectedLocation\" values=\"model.locationObj.results\" key=\"Key\" totalrecords=\"model.locationObj.totalRecords\" none-selected=\"'common.none'\" onscroll=\"getLocationList(searchKey, offset)\" on-click=\"autoPopulateLocationDetails()\" ng-disabled=\"model.locationObj.loading\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6\">\n<label>{{ 'customer.customers' | translate }} *</label>\n<search-and-select ng-model=\"model.customerObj.selectedCustomer\" values=\"model.customerObj.results\" key=\"Key\" totalrecords=\"model.customerObj.totalRecords\" none-selected=\"'common.none'\" onscroll=\"getCustomerList(searchKey, offset)\" required ng-disabled=\"model.currentStat !== 'unassigned' && model.locationObj.selectedLocation.Obj.customerObj.id\">\n</search-and-select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label>Billable Event</label>\n<select class=\"form-control\" ng-model=\"model.billableEvent\" ng-options=\"event.Key as event.Key for event in model.billableEventsObj.results\" ng-change=\"setBillingCatergory(); billingTypeOptionChoice(model); setBillingType(model);\" ng-disabled=\"model.billableEventsObj.loading\" ng-required=\"model.currentStat === 'unassigned'\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'branch_mgmt.billing_approval.bill_category' | translate}}</label>\n<select class=\"form-control\" ng-model=\"model.billingCategory\" ng-change=\"billingTypeOptionChoice(model); setBillingType(model);\" ng-options=\"category.Key as category.Key for category in model.billingCategoryObj.results\" disabled=\"disabled\" ng-required=\"model.currentStat === 'unassigned'\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group col-sm-6\">\n<label>{{'branch_mgmt.billing_approval.bill_type' | translate}}</label>\n<select class=\"form-control\" ng-model=\"model.billingType\" ng-options=\"billingType.value as billingType.label for billingType in billingTypeList\" ng-required=\"model.currentStat === 'unassigned'\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} *</label>\n<input class=\"form-control\" type=\"test\" ng-model=\"model.amount\" ng-currency required>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group col-sm-6 margin-bottom-10\">\n<label>{{'branch_mgmt.billing_approval.amount_due' | translate}} *</label>\n<input class=\"form-control\" type=\"test\" ng-model=\"model.amountDue\" ng-currency required>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" ng-class=\"{'pull-left': model.currentStat === 'unassigned'}\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n<button ng-disabled=\"updateBillingRecordForm.$invalid || model.loading\" class=\"btn btn-success pull-right\" type=\"button\" ng-click=\"ok()\" ng-if=\"model.currentStat !== 'unassigned'\">\n{{ 'common.ok' | translate }}\n</button>\n<button class=\"btn btn-success _pull-right\" ng-disabled=\"updateBillingRecordForm.$invalid || model.loading || isLoading\" type=\"button\" ng-click=\"update(); ok();\" ng-if=\"model.currentStat === 'unassigned'\">\n{{ 'common.update' | translate }}\n</button>\n<button ng-disabled=\"updateBillingRecordForm.$invalid || model.loading || isLoading\" class=\"btn btn-warning pull-right\" type=\"button\" ng-click=\"approved(); ok();\" ng-if=\"model.currentStat === 'unassigned'\">\n{{ 'common.approve' | translate }}\n</button>\n</div>\n</form>";
var id1="updateBillingRecords.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2627 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\" ng-submit=\"ok()\">\n<div class=\"modal-header\">\n<h4 class=\"modal-title\" id=\"modal-title-top\"><b>{{'serviceTickets.edit_update_history' | translate}}</b></h4>\n</div>\n<div class=\"modal-body\" style=\"max-height: 500px;overflow-y: scroll;\">\n<div class=\"scrollable-history-table\">\n<div class=\"table-responsive\">\n<table class=\"table table-condensed table-bordered inner-tbl-margin-bottom\">\n<thead>\n<tr class=\"tbl-header-color\">\n<th class=\"text-center\">#</th>\n<th class=\"text-center\">{{'serviceTickets.update' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.log_date_time' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.service_order_date_time' | translate}}</th>\n<th class=\"text-center history-details-section\">\n{{'serviceTickets.note_details' | translate}}\n</th>\n<th class=\"text-center\">\n{{ 'common.action' | translate }}\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"historyItem in model.serviceHistoryData\">\n<td class=\"text-center\" style=\"min-width: 20px;\">{{$index + 1}}</td>\n<td style=\"min-width: 170px;\" class=\"text-danger text-center\">\n<div ng-repeat=\"label in historyItem.displayLabel\">{{label}}</div>\n</td>\n<td style=\"min-width: 180px;\" class=\"text-center\">\n<span class=\"text-center\">{{ model.DateUtil.convetToBrowserTimezone(historyItem.timestamp, true)}}</span>\n</td>\n<td class=\"text-center\" style=\"min-width: 300px;\">\n<div class=\"row remove-pad margin-top-10\">\n<div class=\"col-sm-6 remove-right-pad\" ng-class=\"{'invalid-date-section': historyItem.isDateInvalid}\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"historyItem.tempDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" required ng-change=\"validateAll()\" datepicker-append-to-body=\"true\" dropdown-append-to-body=\"true\" append-to-body=\"true\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6 pos-relative\">\n<input type=\"time\" class=\"form-control\" step=\"2\" ng-model=\"historyItem.tempTime\" required ng-change=\"validateAll()\" ng-class=\"{'invalid-field-section': historyItem.isTimeInvalid}\">\n</div>\n</div>\n</td>\n<td style=\"min-width: 180px;\">\n<textarea class=\"form-control\" rows=\"2\" ng-model=\"historyItem.tempNotes\" style=\"border-radius: 5px\"></textarea>\n</td>\n<td class=\"text-center\" style=\"min-width: 80px;\">\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-disabled=\"hasErrors() || model.isLoading\" ng-click=\"saveHistoryItem(historyItem)\" uib-tooltip=\"{{'common.save' | translate}}\" tooltip-placement=\"top\">\n<span class=\"glyphicon glyphicon-ok\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-if=\"historyItem.status && showRemoveButton(historyItem, $index)\" ng-click=\"confirmAndRemoveHistoryItem(historyItem, $index)\" ng-disabled=\"hasErrors() || model.isLoading\" uib-tooltip=\"{{'common.Delete' | translate}}\" tooltip-placement=\"top\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger margin-left-10\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.isLoading\">\n{{ 'common.close' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"hasErrors() || model.isLoading\">\n{{ 'serviceTickets.save_all' | translate }}\n</button>\n</div>\n</form>\n<style>\n.update-service-history-modal .modal-dialog {\n        width: 65%;\n    }\n    .update-service-history-modal .invalid-date-section input {\n        background-color: #F9E3E3 !important;\n        border-color: #F4C6C6 !important;\n    }\n</style>\n";
var id1="updateServiceHistory.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2628 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"updateShipmentTrackingIdTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'forceCLoseRouteModal.edit_tracking_id' | translate }}</strong></h4>\n</div>\n<div class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"_form-group col-sm-6\">\n<label>{{ 'branch_mgmt.items.oldTrackingId' | translate }} *</label>\n<input type=\"text\" id=\"old-tracking-id\" class=\"form-control\" ng-model=\"model.oldTrackingId\" required disabled=\"disabled\"/>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label>{{ 'branch_mgmt.items.newTrackingId' | translate }} *</label>\n<input capitalize type=\"text\" id=\"new-tracking-id\" class=\"form-control\" ng-model=\"model.newTrackingId\" ng-change=\"assertTrackingId()\" required/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"updateShipmentTrackingIdTemplate.$invalid || model.isDuplicate\">\n{{ 'common.save' | translate }}\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.cancel' | translate }}\n</button>\n</div>\n</form>";
var id1="updateShipmentTrackingId.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2629 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"uploadContractDocument\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>{{'shipmentBatch.upload_file' | translate}}</b>\n</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"margin-10 table table-hover table-bordered remove-pad\" ng-if=\"model.selectedFiles.length\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'uploadedFileSelectionModal.file' | translate}}</th>\n<th>{{'branch_mgmt.bagout_lastUpdated' | translate}}</th>\n<th class=\"remove-white-space\">{{'branch_mgmt.import_file_view.file_size' | translate}}</th>\n<th>{{'bulkCash.action' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.selectedFiles track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{ data.fileName.replace('.pdf', '') }}</td>\n<td>{{ data.lastModifiedDate | date:'yyyy-MM-dd hh:mm a' }}</td>\n<td>{{ formatFileSize(data.size) }}</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"removeSelectedFiles($index)\">\n<span class=\"glyphicon glyphicon-trash\"></span></button>\n\n</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.selectedFiles.length\">\n<div class=\"col-sm-12 alert text-center remove-bottom-margin alert-danger\">\n{{'shipmentBatch.select_file' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<input-file ng-model=\"model.selectedFiles\" multiple=\"true\" btn-class=\"btn btn2\" file-types=\".pdf,.doc,.docx,.xls,.xlsx\" class=\"remove-left-pad remove-right-pad\" selected-files=\"model.selectedFiles\" required>\n</input-file>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"!model.selectedFiles.length || model.loading\">\n{{ model.stat === 'edit' ? 'location.upload' : 'common.save' | translate }}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"model.loading\"></span>\n</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="uploadContractDocument.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2630 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"uploadFilesTemplate\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>Upload File (CSV)</b>\n</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"margin-10 table table-hover table-bordered remove-pad\" ng-if=\"model.selectedFiles.length\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'uploadedFileSelectionModal.file' | translate}}</th>\n<th>{{'branch_mgmt.bagout_lastUpdated' | translate}}</th>\n<th></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.selectedFiles track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{ data.fileName.replace('.csv', '') }}</td>\n<td>{{ data.lastModifiedDate | date:'yyyy-MM-dd hh:mm a' }}</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"removeSelectedFiles($index)\">\n<span class=\"glyphicon glyphicon-trash\"></span></button>\n\n</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.selectedFiles.length\">\n<div class=\"col-sm-12 alert text-center remove-bottom-margin alert-danger\">\n{{'shipmentBatch.select_file' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<input-file ng-model=\"model.selectedFiles\" multiple=\"true\" btn-class=\"btn btn2\" file-types=\".csv\" class=\"remove-left-pad remove-right-pad\" selected-files=\"model.selectedFiles\" required>\n</input-file>\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"downloadFile();\" ng-disabled=\"model.isDownloading\">\n{{ 'deliveryRegionRouting.download_template' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"!model.selectedFiles.length\">\n{{ 'location.upload' | translate }}\n</button>\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"cancel()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="uploadFiles.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2631 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"fileSelectionForm\" novalidate class=\"form-validate\" ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'uploadedFileSelectionModal.title' | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"text-align-center\" ng-if=\"loadingData\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loadingData\">\n<div class=\"row\">\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{ 'shipmentBatch.tooltip_info' | translate }}\" tooltip-placement=\"right\"></span>\n<label>{{'shipmentBatch.location' | translate}}</label>\n<search-and-select ng-model=\"model.location\" values=\"data.locations\" key=\"Key\" totalrecords=\"totalLocationRecords\" long-dd-width-flag=\"true\" onscroll=\"getAllLocation(searchKey, offset)\" on-click=\"fromLocationChanged()\" hide-count=\"true\" none-selected=\"'shipmentBatch.locationPlaceholder'\" is-change-offset=\"changeOffsetFlag\" is-change-offset-value=\"offset\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-3\">\n<label for=\"batch-master\">{{'shipmentBatch.batch_master' | translate }}</label>\n<input class=\"form-control\" type=\"text\" disabled=\"disabled\" ng-model=\"model.batchMaster\"/>\n</div>\n<div class=\"col-sm-3\">\n<label for=\"\">{{'shipmentBatch.pickupDate' | translate }} </label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"model.pickupDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-change=\"dateChanged()\" show-button-bar=\"false\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-3\">\n<label for=\"\">{{'shipmentBatch.deliveryDate' | translate }} </label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"model.deliveryDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label>{{'uploadedFileSelectionModal.file' | translate}}</label>\n<search-and-select class=\"form-control remove-pad\" ng-model=\"model.batchFile\" values=\"data.uploadedFiles\" key=\"Key\" totalrecords=\"model.totalRecords\" common-search-flag=\"true\" on-click=\"loadFileData()\" required>\n</search-and-select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label>{{'uploadedFileSelectionModal.totalAmount' | translate}}</label>\n<input type=\"text\" class=\"form-control\" disabled=\"disabled\" ng-model=\"model.selectedFile.fileData.totalAmount\" ng-currency>\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label>{{'uploadedFileSelectionModal.totalBags' | translate}}</label>\n<input type=\"text\" class=\"form-control\" disabled=\"disabled\" ng-model=\"model.selectedFile.fileData.totalShipments\">\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"alert alert-info remove-bottom-margin\">\n<i class=\"glyphicon glyphicon-info-sign\"></i> <span> {{'uploadedFileSelectionModal.fileLockMessage' | translate}} </span>\n</div>\n<div ng-if=\"model.error\">\n<div class=\"margin-10 remove-bottom-margin alert alert-danger\">\n<span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span>\n<span>{{model.error}}</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" ng-disabled=\"loading || fileSelectionForm.$invalid || !model.location || model.error\" type=\"submit\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"loading\"></span> {{ 'uploadedFileSelectionModal.load' | translate }}\n</button>\n<button class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'common.cancel' | translate }}</button>\n</div>\n</form>";
var id1="uploadedFileSelection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2632 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"verifyBagoutCashCountTemplate\" class=\"form-validate\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\" ng-if=\"!model.loading\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<b>\n<center>{{'atm_residual.verify_bagout_shipments' | translate}}</center>\n</b>\n</h4>\n</div>\n<div class=\"text-align-center margin-top-10\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\" ng-if=\"!model.loading\">\n<div class=\"bagout-scan-tracking-id\">\n<input type=\"text\" id=\"scan-bagout-id\" class=\"form-control\" placeholder=\"{{'atm_residual.bag' | translate}}\" ng-keydown=\"$event.keyCode === 13 && scanBagoutTrackingId($event);\" scan-type=\"'bagout'\" disable-copy-paste required ng-model=\"model.bagoutId\" ng-pattern=\"/^[a-zA-Z0-9- ]*$/\">\n<div class=\"text-center alert-danger last-scanned-id\" ng-if=\"model.lastBagoutScanned && !model.isVerifiedMessage\">\n<span>{{'bagout.trackingId' | translate}}: <b>{{model.lastBagoutScanned}}</b> Is Incorrect</span>\n</div>\n<div class=\"text-center alert-danger last-scanned-id\" ng-if=\"model.lastBagoutScanned && model.isVerifiedMessage\">\n<span>{{'bagout.trackingId' | translate}}: <b>{{model.lastBagoutScanned}}</b> Is Already Verified</span>\n</div>\n</div>\n<div class=\"bagout-content\">\n<table class=\"table table-hover table-bordered remove-pad table-pad-5\" ng-if=\"model.bagoutContent && model.bagoutContent.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th colspan=\"3\">Bagout Count</th>\n<th class=\"contents-no-wrap\">{{'shipmentBatch.totalAmount' | translate}}</th>\n<th>{{model.amount | currency:fraction}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th>{{'bagout.trackingId' | translate}}</th>\n<th>{{'denomination.shiptype' | translate}}</th>\n<th>{{'bagout.fromLocation' | translate}}</th>\n<th>{{'addBagModal.amount' | translate}}</th>\n<th>{{'bagout.status' | translate}}</th>\n</tr>\n<tr ng-repeat=\"data in model.bagoutContent track by $index\">\n<td>{{data.trackingId}}</td>\n<td>{{data.shipType}}</td>\n<td>{{data.fromLocationId}} | {{data.fromLocationName}}</td>\n<td>{{data.amount | currency:fraction}}</td>\n<td ng-class=\"{'verified-status': data.status === 'Verified'}\">{{data.status}}</td>\n</tr>\n</tbody>\n</table>\n<div class=\"bagout-button-section\">\n<button class=\"btn btn-success bagout-complete-button\" type=\"button\" ng-click=\"completeBagoutShipments()\" ng-disabled=\"!bagoutStatusesVerified()\">\n{{'branch_mgmt.orders.completed'|translate }}\n</button>\n<button class=\"btn btn-warning\" ng-click=\"override()\" type=\"button\">\n{{'checkin.override'|translate }}\n</button>\n</div>\n<div ng-if=\"!model.bagoutContent.length\">\n<div class=\"col-sm-12 alert alert-danger text-center\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\" ng-if=\"!model.loading\">\n<div ng-if=\"(status && !bagoutStatusesVerified())\" class=\"col-sm-12 margin-5\">\n<span class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-info': (status && !bagoutStatusesVerified())}\" style=\"margin-bottom: 10px;\"> The Close button will be enabled once all shipments have been verified</span>\n</div>\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"status && !bagoutStatusesVerified()\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>\n<style>\n.bagout-content {\n        margin-top: 2%;\n    }\n\n    .bagout-scan-tracking-id {\n        margin-left: 35%;\n        margin-right: 34%;\n    }\n\n    .bagout-button-section {\n        margin-top: 2%;\n        margin-left: 40%;\n    }\n\n    .verified-status {\n        color: green;\n    }\n\n    .bagout-complete-button {\n        margin-right: 4%;\n    }\n</style>";
var id1="verifyBagoutCashCount.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2633 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"forceCloseHoldForm\" class=\"form-validate\" novalidate ng-submit=\"validateSupervisorScan()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'itemHolds.modalTitle' | translate}}</strong> | {{ model.trackingId }}</h4>\n</div>\n<div class=\"text-align-center padding-14\" ng-if=\"loading || model.fetchRouteStops\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"padding-14\" ng-if=\"model.canShowMap && !model.fetchRouteStops\">\n<div id=\"release-hold-map\" class=\"release-hold-map\"></div>\n</div>\n<div ng-if=\"!loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"col-sm-12 align-center-vertically\">\n<table class=\"table table-hover table-bordered\" ng-if=\"model.loadRouteList == true\">\n<thead>\n<tr class=\"header-row\">\n<th>{{'itemHolds.nextAvailableRoute' | translate}}</th>\n<th>{{'itemHolds.itemReleaseRoute' | translate}}</th>\n<th>{{'itemHolds.routeSequence' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"col-xs-4 atm-codes-date-picker-section\">\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"model.date\" date-format=\"dd-MMM-yyyy\" ng-click=\"loadRoutes()\" hidden-time=\"true\" date-options=\"minVaultDate\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.date}\" timezone=\"UTC\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</td>\n<td class=\"col-xs-4\">\n<select class=\"form-control\" ng-model=\"model.routeId\" ng-change=\"removeMap(); routeSequenceChanged()\" required ng-options=\"route.routeId as route.routeName for route in model.routeList\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</td>\n<td ng-if=\"model.routeId\" class=\"col-xs-4\"><div><b>{{'itemHolds.manually_sequence' | translate}}</b></div></td>\n<td ng-if=\"!model.routeId\"></td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"form-group col-sm-12 text-align-center\" ng-if=\"errorMessage && errCode != '91902'\">\n<div class=\"alert alert-danger margin-zero\">\n{{ errorMessage | translate}}\n</div>\n</div>\n<div class=\"_form-group col-sm-12\">\n<label>{{ 'itemHolds.comments' | translate }}</label>\n<textarea class=\"form-control\" rows=\"2\" ng-model=\"model.comment\" style=\"border-radius: 5px\"></textarea>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"model.error\" class=\"alert alert-danger\">\n<strong>Error</strong>: {{model.error}}\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"forceCloseHoldForm.$invalid || (errCode && errCode != '91902') || isLoading || !model.date || !model.routeId\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span> {{ 'atm_deposit_packing.release' | translate }}\n</button>\n</div>\n</form>\n";
var id1="verifyHoldRelease.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'verifyHoldShipments.title' | translate}} | {{'itemHolds.tanker' | translate}} {{model.tankerId}} | {{model.currentDate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row\" ng-if=\"loading\">\n<div class=\"col-sm-12 text-align-center\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n</div>\n<div class=\"row\" ng-if=\"!loading\">\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-6\">\n<form ng-submit=\"verifyShipment()\">\n<input id=\"tracking-id\" type=\"text\" class=\"form-control input-lg\" ng-model=\"model.trackingId\" ng-disabled=\"model.verifying || !model.holdShipmentsCount\" capitalize disable-copy-paste disable-tracking-id-typing/>\n</form>\n</div>\n<div class=\"col-sm-6 align-center-vertically align-end-horizontally\">\n<div class=\"pull-right margin-right-10\">\n<img src=\"" + __webpack_require__(177) + "\" class=\"img-80\" alt=\"shipments\"/>\n</div>\n<div class=\"pull-right\">\n<span class=\"font-size-50 text-success\">{{model.verifiedCount}}</span>\n<span class=\"font-size-50\">|</span>\n<span class=\"font-size-50\">{{model.holdShipmentsCount}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-20\" ng-if=\"model.errorCode\">\n<div class=\"alert alert-danger margin-zero\">\n{{'error.'+model.errorCode | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 table-responsive margin-top-20\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-bordered table-hover table-striped remove-bottom-margin\">\n<thead>\n<tr>\n<td><b>{{'verifyHoldShipments.item' | translate}}</b></td>\n<td><b>{{'verifyHoldShipments.from' | translate}}</b></td>\n<td><b>{{'verifyHoldShipments.lastProcessed' | translate}}</b></td>\n<td><b>{{'verifyHoldShipments.supervisor' | translate}}</b></td>\n</tr>\n</thead>\n<tbody>\n<tr ng-if=\"model.verifiedShipments && model.verifiedShipments.length\" ng-repeat=\"shipment in model.verifiedShipments\">\n<td>{{shipment.trackingId}}</td>\n<td>{{shipment.fromLocationId + ' | ' + shipment.fromLocationName}}</td>\n<td>{{shipment.lastProcessed}}</td>\n<td>{{supervisorIds.id}} | {{supervisorIds.name}}</td>\n</tr>\n<tr ng-if=\"!model.verifiedShipments || !model.verifiedShipments.length\">\n<td colspan=\"4\" align=\"center\">\n{{'verifyHoldShipments.noShipmentsVerified' | translate}}\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\" ng-if=\"!loading\">\n<button class=\"btn btn-success pull-left\" ng-if=\"model.holdShipmentsCount\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"forceClose()\">\n{{ 'verifyHoldShipments.forceClose' | translate }}\n<span class=\"badge\">{{model.holdShipmentsCount}}</span>\n</button>\n<button class=\"btn btn-success\" ng-disabled=\"loading || model.holdShipmentsCount || !model.verifiedShipments.length\" type=\"button\" ng-click=\"ok()\">{{ 'common.ok' | translate }}</button>\n<button class=\"btn btn-success\" ng-disabled=\"!model.holdShipmentsCount || model.bulkVerified || model.loading\" type=\"button\" ng-click=\"bulkVerify()\" ng-if=\"model.allowBulkHoldVerify\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading }\"></span> {{ 'verifyHoldShipments.bulkVerify' | translate }}\n</button>\n<button class=\"btn btn-danger\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'common.cancel' | translate }}</button>\n</div>";
var id1="verifyHoldShipments.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2635 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"forceCloseHoldForm\" class=\"form-validate\" novalidate ng-submit=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">\n<strong>{{ 'itemHolds_return.modalTitle' | translate}}</strong> | {{ model.trackingId }}</h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!loading\" class=\"list-group\" style=\"width: 100%; max-height: 350px;\">\n<div class=\"row\">\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"col-sm-12 align-center-vertically margin-top-10\">\n<table class=\"table table-hover table-bordered\" ng-if=\"model.loadRouteList == true\">\n<thead>\n<tr class=\"header-row\">\n<th>{{'itemHolds.nextAvailableRoute' | translate}}</th>\n<th>{{'itemHolds.itemReleaseRoute' | translate}}</th>\n<th>{{'itemHolds.routeSequence' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td class=\"col-xs-4\">\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"model.date\" date-format=\"dd-MMM-yyyy\" ng-click=\"loadRoutes()\" hidden-time=\"true\" date-options=\"minVaultDate\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !model.date}\" timezone=\"UTC\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</td>\n<td class=\"col-xs-4\">\n<select class=\"form-control margin-bottom-20\" ng-model=\"model.routeId\" ng-change=\"routeSequenceChanged()\" required ng-options=\"route.routeId as route.routeName for route in model.routeList\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</td>\n<td class=\"col-xs-4\" ng-if=\"model.routeId\"><div class=\"margin-bottom-20\">{{ model.routeSequence }}</div></td>\n<td ng-if=\"!model.routeId\"></td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"form-group col-sm-12 text-align-center\" ng-if=\"errorMessage && errCode != '91902'\">\n<div class=\"alert alert-danger margin-zero\">\n{{ errorMessage | translate}}\n</div>\n</div>\n<div class=\"_form-group col-sm-12\">\n<label>{{ 'itemHolds.comments' | translate }}</label>\n<textarea class=\"form-control\" ng-model=\"model.comment\" style=\"border-radius: 5px\" rows=\"3\"></textarea>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"model.error\" class=\"alert alert-danger\">\n<strong>Error</strong>: {{model.error}}\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.cancel' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"isLoading || forceCloseHoldForm.$invalid || (errCode && errCode != '91902')\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': model.loading}\"></span> {{ 'itemHolds.returnItem' | translate }}\n</button>\n</div>\n</form>";
var id1="verifyItemReturn.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2636 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"DocumentFileSelectionForm\" novalidate class=\"form-validate\" ng-submit=\"ok()\"><span ng-disabled=\"model.loading\"></span>\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\"><b>{{'customer.view_document' | translate}}</b></h4>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" style=\"width: 100%; max-height: 350px; overflow-y: auto;\">\n<table class=\"table table-hover table-bordered remove-pad\" ng-if=\"model.uploadedFiles.length && !model.loading\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{'uploadedFileSelectionModal.file' | translate}}</th>\n<th>{{'message.type' | translate}}</th>\n<th>{{'resetAtmCode.created_date' | translate}}</th>\n<th class=\"remove-white-space\">{{'branch_mgmt.import_file_view.file_size' | translate}}</th>\n<th>{{'bulkCash.action' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in model.uploadedFiles track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{ data.fileName.replace(data.fileExtension, '') }}</td>\n<td>{{ data.fileExtension.replace('.', '') }}</td>\n<td>{{ data.createdAt | date:'yyyy-MM-dd hh:mm a' }}</td>\n<td class=\"remove-white-space text-center\">{{formatFileSize(data.size)}}</td>\n<td class=\"remove-white-space text-center\">\n<button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"displaySelectedFiles(data.fileName)\" ng-if=\"data.fileExtension == '.pdf'\">\n<span class=\"glyphicon glyphicon-print\" ng-disabled=\"model.isPrint\" uib-tooltip=\"{{'customer.print_file' | translate}}\"></span></button>\n\n<button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"downloadSelectedFiles(data.fileName)\">\n<span class=\"glyphicon glyphicon-download\" ng-disabled=\"model.isDownloading\" uib-tooltip=\"{{'customer.download_file' | translate}}\"></span></button>\n\n<button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"removeSelectedFiles(data.fileName, $index)\">\n<span class=\"glyphicon glyphicon-trash\" ng-disabled=\"model.isDeleting\" uib-tooltip=\"{{'batch.tooltip_del' | translate}}\">\n</span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"!model.uploadedFiles.length && !model.loading\">\n<div class=\"col-sm-12 alert text-center remove-bottom-margin alert-danger\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-danger\" ng-class=\"{'disabled': model.loading}\" type=\"button\" ng-click=\"cancel()\">{{'common.cancel' | translate }}</button>\n</div>\n</form>";
var id1="viewContractDocument.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2637 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div uib-dropdown auto-close=\"outsideClick\" class=\"time-picker-input\">\n<div class=\"input-group\">\n<span uib-dropdown-toggle class=\"form-control time-picker-value\">\n{{displayTime}}\n</span>\n<span class=\"input-group-btn\">\n<button class=\"btn btn-danger\" type=\"button\" ng-click=\"clear()\" ng-disabled=\"!ngModel\">\n<span class=\"glyphicon glyphicon-remove-sign\"></span>\n</button>\n</span>\n</div>\n<ul class=\"dropdown-menu\" uib-dropdown-menu>\n<li class=\"horizontal-padding-10\">\n<div uib-timepicker ng-class=\"{'hide-hours-column': hideHours === true}\" ng-model=\"ngModel\" ng-change=\"handleTimeChange(); setAllowOnceValue();\" show-meridian=\"(isMeridian || isMeridian === undefined) ? true : false\" show-seconds=\"(showSeconds || showSeconds !== undefined) ? true : false\" show-spinners=\"(showSpinners === undefined || showSpinners) ? true : false\"></div>\n</li>\n</ul>\n</div>";
var id1="time-picker.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2638 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-danger\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'countdown.title' | translate}}</h4>\n</div>\n<div class=\"modal-body modal_body\" id=\"modal-body\">\n<div>\n{{$ctrl.message}}\n</div>\n</div>";
var id1="timeoutCountdown.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2639 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<h1>Access Denied</h1>\n</div>\n</div>\n</div>";
var id1="access_denied.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<form novalidate class=\"col-sm-12 form-validate remove-pad\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"atm-codes-date-picker-section col-md-3 col-sm-3 remove-pad\" novalidate>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" ng-class=\"{'required-datetimepicker': !$ctrl.model.date}\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.minVaultDate\" ng-click=\"$ctrl.allRoutes()\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"col-md-3 col-sm-3\">\n<search-and-select ng-model=\"$ctrl.model.route\" values=\"$ctrl.model.allRoutes\" key=\"Key\" totalrecords=\"$ctrl.model.totalRecords\" common-search-flag=\"true\" none-selected=\"'route.route_select'\" on-click=\"$ctrl.resetData(); $ctrl.getATMLocations();\" ng-disabled=\"$ctrl.isLoadingRoutes\" required></search-and-select>\n</div>\n<div class=\"col-sm-6 atm-code-info-section remove-pad\">\n<div>\n<input type=\"text\" id=\"routeStatus\" class=\"form-control\" disabled=\"disabled\" ng-model=\"$ctrl.model.routeStatus\" placeholder=\"{{'atm_codes_mgmt.route_status' | translate}}\"/>\n</div>\n<div>\n<input type=\"text\" id=\"messenger\" placeholder=\"{{'atm_codes_mgmt.messenger' | translate}}\" class=\"form-control\" disabled=\"disabled\" ng-model=\"$ctrl.model.messenger\"/>\n</div>\n<div class=\"margin-top-02\">\n<button type=\"button\" class=\"btn btn-sm btn-success\" ng-disabled=\"$ctrl.model.isDisabled || $ctrl.autoOpenLockProcess || $ctrl.loading || !$ctrl.model.route\" placeholder=\"{{'atm_codes_mgmt.route_status' | translate}}\" ng-click=\"$ctrl.autoOpenLocks()\">\n{{'atm_codes_mgmt.auto_open_locks' | translate}}\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.autoOpenLockProcess}\"></i>\n</button>\n<button type=\"button\" class=\"btn btn-sm btn-primary\" ng-disabled=\"$ctrl.model.isDisabled || $ctrl.gettingLockStatus || $ctrl.loading || !$ctrl.model.route\" placeholder=\"{{'atm_codes_mgmt.route_status' | translate}}\" ng-click=\"$ctrl.getLockStatus()\">\n{{'atm_codes_mgmt.lock_status' | translate}}\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.gettingLockStatus}\"></i>\n</button>\n</div>\n</div>\n</div>\n<div class=\"progress-bar-color col-sm-12 margin-10 remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.loadingOpenLockStats && $ctrl.model.route && $ctrl.model.messengerId && $ctrl.model.autoOpenATMLocksProgressInfo.message === 'running'\">\n<div id=\"myProgressbar\" class=\"progress routes-progress-bar-height\">\n<uib-progress class=\"routes-progress-bar-height\" max=\"$ctrl.totalLocations\">\n<uib-bar ng-repeat=\"bar in $ctrl.openLockStack track by $index\" value=\"bar.value\" type=\"{{bar.type}}\">\n<div class=\"route-stops-bar-section\" uib-tooltip=\"{{bar.message}}\">\n<span ng-if=\"bar.value\">{{bar.value}}</span>\n</div>\n</uib-bar>\n</uib-progress>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div class=\"col-sm-12 margin-top-15 remove-padding\" ng-if=\"!$ctrl.loading && $ctrl.model.routeSequence.length && $ctrl.model.route\">\n<table class=\"table table-striped table-bordered\">\n<thead>\n<tr>\n<td class=\"text-center\">\n<strong>{{'atm_codes_mgmt.SEQ' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_codes_mgmt.location' | translate}}</strong>\n</td>\n<td class=\"text-center\">\n<strong>{{'atm_codes_mgmt.lock_type' | translate}}</strong>\n</td>\n<td class=\"text-center\">\n<strong>{{'atm_codes_mgmt.key_id' | translate}}</strong>\n</td>\n<td class=\"text-center\">\n<strong>{{'atm_codes_mgmt.otc_company' | translate}}</strong>\n</td>\n<td class=\"text-align-center\">\n<strong>{{'atm_codes_mgmt.open_code' | translate}}</strong>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.routeSequence track by $index\">\n<td rowspan=\"2\" class=\"font-size-16 text-center\" ng-if=\"data.isMatch && !data.secondaryLock\">{{data.seq+1}}</td>\n<td class=\"font-size-16 text-center\" ng-if=\"!data.isMatch && !data.secondaryLock\">{{data.seq+1}}</td>\n<td class=\"font-size-16\">{{data.locationId}}\n<a href=\"#\" ng-if=\"!data.secondaryLock\" ng-click=\"$ctrl.redirectToLocation(data.originLockId)\" style=\"font-size: 16px; margin-bottom: 2px\">\n| {{data.locationName}}\n</a>\n<a href=\"#\" ng-if=\"data.secondaryLock\" ng-click=\"$ctrl.redirectToLocation(data.originLockId)\" style=\"font-size: 16px; margin-bottom: 2px\">\n| ({{'location.secondary_lock' | translate}})\n</a>\n<div class=\"margin-top-05\" ng-if=\"data.code.message\">\n<img src=\"" + __webpack_require__(176) + "\" style=\"height: 20px;\">\n<span class=\"text-danger msg-font-size\">{{$ctrl.removeCharacter(data.code.message)}}</span>\n<span class=\"msg-font-size\">| {{ data.code.createdAt | date : 'MM-dd-yyyy | hh:mm a' }}</span>\n</div>\n<div class=\"margin-top-05\" ng-if=\"!data.OTCCompanyName && !data.code && data.lockType !== 'static'\">\n<img src=\"" + __webpack_require__(176) + "\" style=\"height: 20px;\">\n<span class=\"text-danger msg-font-size\">{{'atm_codes_mgmt.config_error' | translate}}</span>\n</div>\n<div class=\"margin-top-05\" ng-if=\"data.code.lockStatusError\">\n<img src=\"" + __webpack_require__(176) + "\" style=\"height: 20px;\">\n<span class=\"text-danger msg-font-size\">{{data.code.lockStatusError}}</span>\n<span class=\"msg-font-size\">| {{ data.code.createdAt | date : 'MM-dd-yyyy | hh:mm a' }}</span>\n</div>\n<div class=\"margin-top-05\" ng-if=\"data.code && data.code.isAlreadyOpened\">\n<span class=\"text-danger msg-font-size\">{{'atm_codes_mgmt.lock_already_open' | translate}}</span>\n<span class=\"msg-font-size\">| {{'location.keyId' | translate}} {{ data.code.keyId}}</span>\n<span ng-if=\"data.lockType == 'RTE'\">\n| <button type=\"button\" class=\"btn btn-xs btn-warning\" ng-disabled=\"$ctrl.reassignLockObj[data.locationId].isDisabled\" ng-click=\"$ctrl.reassignLock(data)\">\n{{'atm_codes_mgmt.reassign' | translate}}\n<span ng-if=\"!$ctrl.reassignLockObj[data.locationId].loadingReassignLock\" class=\"glyphicon glyphicon-refresh\"></span>\n<span ng-if=\"$ctrl.reassignLockObj[data.locationId].loadingReassignLock\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n</span>\n</div>\n</td>\n<td class=\"font-size-16 text-center\">\n<span ng-if=\"data.lockType == 'witz'\">{{'atm_codes_mgmt.lock_type_tds' | translate}}</span>\n<span ng-if=\"data.lockType == 'static'\">Static</span>\n<span ng-if=\"data.lockType !== 'witz' && data.lockType !== 'static'\">{{data.lockType}}</span>\n</td>\n<td class=\"font-size-16 text-center\" ng-if=\"($ctrl.getKeys(data) && data.lockType === 'LMS')\">{{ $ctrl.getKeys(data) }}</td>\n<td class=\"font-size-16 text-center\" ng-if=\"($ctrl.getKeys(data) && data.lockType === 'FLM')\">{{ $ctrl.getKeys(data) }}</td>\n<td class=\"font-size-16 text-center\" ng-if=\"($ctrl.getKeys(data) && data.lockType === 'RTE')\">{{ $ctrl.getKeys(data) }}</td>\n<td class=\"font-size-16 text-center\" ng-if=\"($ctrl.getKeys(data) && data.lockType === 'witz') || ($ctrl.getKeys(data) && data.lockType === 'TDS')\">\n{{ $ctrl.getKeys(data) }}</td>\n<td class=\"font-size-16 text-center\" ng-if=\"(((!$ctrl.getKeys(data) && data.lockType === 'LMS') || ($ctrl.getKeys(data) && data.lockType !== 'LMS') || (!$ctrl.getKeys(data) && data.lockType !== 'LMS')) \n                                                        && ((!$ctrl.getKeys(data) && data.lockType === 'FLM') || ($ctrl.getKeys(data) && data.lockType !== 'FLM') || (!$ctrl.getKeys(data) && data.lockType !== 'FLM')) \n                                                        && ((!$ctrl.getKeys(data) && data.lockType === 'RTE') || ($ctrl.getKeys(data) && data.lockType !== 'RTE') || (!$ctrl.getKeys(data) && data.lockType !== 'RTE'))\n                                                        && ((!$ctrl.getKeys(data) && data.lockType === 'witz') || ($ctrl.getKeys(data) && data.lockType !== 'witz') || (!$ctrl.getKeys(data) && data.lockType !== 'witz'))\n                                                        && ((!$ctrl.getKeys(data) && data.lockType === 'TDS') || ($ctrl.getKeys(data) && data.lockType !== 'TDS') || (!$ctrl.getKeys(data) && data.lockType !== 'TDS')))\">\n{{'common.n_a' | translate }}\n</td>\n<td class=\"font-size-16 text-center\">\n<span ng-if=\"data.OTCCompanyName\">{{data.OTCCompanyName}}</span>\n<span ng-if=\"!data.OTCCompanyName\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-align-center\">\n<div ng-if=\"(data.code && data.code.code != '' && !data.code.isAlreadyOpened)\">\n<div>\n<img class=\"image-height-50\" src=\"" + __webpack_require__(89) + "\">\n</div>\n<div style=\"color: #58af46\">\n<span><b>{{'atm_codes_mgmt.opened' | translate}}</b></span>\n<span ng-if=\"(data.code.callStatus === 'auto')\"> <b>({{'atm_codes_mgmt.auto' | translate}})</b></span>\n<span ng-if=\"(data.code.callStatus === 'manual')\"> <b>({{'atm_codes_mgmt.manual' | translate}})</b></span>\n</div>\n<div ng-if=\"data.code\">\n<span>{{data.code.createdAt | date:'MM/dd/yyyy hh:mm:ss a'}}</span>\n</div>\n</div>\n<div ng-if=\"(!data.code || data.code.code == '' || data.code.isAlreadyOpened) && !$ctrl.model.routeSequence[$index].isSave\">\n<div class=\"text-align-right\" ng-if=\"!data.isOTCLockId\">\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-disabled=\"!$ctrl.model.routeSequence[$index].atmCode\" ng-click=\"$ctrl.saveCode(data, $index)\">\n<span class=\"glyphicon glyphicon-floppy-saved\"></span>\n</button>\n</div>\n<div class=\"display-inline-block\">\n<input type=\"text\" id=\"atm-code-{{$index}}\" ng-pattern=\"/^[0-9-]*$/\" placeholder=\"\" class=\"atm-code-box form-control margin-top-05\" required ng-model=\"$ctrl.model.routeSequence[$index].atmCode\" ng-keydown=\"$event.keyCode === 13 && $ctrl.autoCommit(data, $index, $event)\"/>\n</div>\n<div style=\"color: #d9534f\" class=\"margin-top-05\">\n<span><b>{{'atm_codes_mgmt.noOpenCode' | translate}}</b></span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.routeSequence[$index].isSave\">\n<div>\n<img class=\"image-height-50\" src=\"" + __webpack_require__(89) + "\">\n</div>\n<div style=\"color: #58af46\">\n<span><b>{{'atm_codes_mgmt.manuallyEntered' | translate}}</b></span>\n</div>\n<div>\n<span><b>{{$ctrl.model.firstName}} {{$ctrl.model.lastName}} | {{$ctrl.model.loggedInUser}}</b></span>\n</div>\n<div>\n<span>{{$ctrl.currentDateTime}}</span>\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-top-15\" ng-if=\"!$ctrl.loading && (!$ctrl.model.routeSequence || !$ctrl.model.routeSequence.length) || !$ctrl.model.route\">\n<div class=\"alert alert-danger text-align-center\">{{'common.noDataFound' | translate}}</div>\n</div>\n</form>\n</div>";
var id1="atm_codes_management.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid form-validate\">\n<style>\n.disabled-row {\n            opacity: 0.5;\n            pointer-events: none;\n        }\n        .disabled-row input,\n        .disabled-row button {\n            cursor: not-allowed;\n        }\n</style>\n<audio id=\"scanner_beep\" ng-src=\"{{$ctrl.audio}}\" preload=\"auto\"></audio>\n<audio id=\"success_beep\" ng-src=\"{{$ctrl.successAudio}}\" preload=\"auto\"></audio>\n<div class=\"row\">\n<div class=\"col-sm-offset-4 col-sm-4\">\n<div class=\"text-center margin-bottom-10 font-size-20\">\n<b>{{'branch_mgmt.cash_count' | translate}}</b>\n</div>\n<div class=\"row form-group align-center-vertically\" ng-if=\"$ctrl.model.branch && $ctrl.model.hasCounters\">\n<select class=\"form-control\" required ng-model=\"$ctrl.model.selectedBranchCounter\" ng-change=\"$ctrl.onCounterSelected()\" ng-disabled=\"$ctrl.disableCounterSelection\" ng-options=\"c as (c.name + ' | ' + c.sn) for c in $ctrl.model.branchCounters track by c.id\">\n<option value=\"\" disabled=\"disabled\">Count Station</option>\n</select>\n</div>\n<div class=\"row form-group align-center-vertically\" ng-class=\"{'has-error': !$ctrl.canUseCounter()}\">\n<search-and-select ng-model=\"$ctrl.model.locationId\" values=\"$ctrl.locationLists\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" common-search-flag=\"true\" none-selected=\"'(Bank)'\" on-click=\"$ctrl.resetData(); $ctrl.bagCount(true);\" required ng-disabled=\"!$ctrl.canUseCounter()\"></search-and-select>\n</div>\n<div class=\"row form-group align-center-vertically\">\n<input type=\"text\" id=\"trackingId\" class=\"form-control input-lg\" placeholder=\"{{'atm_residual.bag' | translate}}\" ng-keyup=\"($event.keyCode == 13 && !$ctrl.shipmentLoading && $ctrl.canUseCounter()) ? $ctrl.loadShipmentByTrackingId() : null\" required id=\"bagId\" placeholder=\"\" ng-model=\"$ctrl.model.bagId\" capitalize disable-copy-paste disable-tracking-id-typing ng-disabled=\"!$ctrl.canUseCounter()\">\n</div>\n</div>\n<div class=\"col-sm-4 margin-top-10 align-right-vertically\" ng-if=\"$ctrl.model.locationId\">\n<div class=\"row align-center\" ng-click=\"$ctrl.residualBag()\">\n<div class=\"col-sm-7 text-center\"></div>\n<div class=\"col-sm-5 text-center margin-right-10 table-bordered\">\n<div class=\"text-center font-size-15\">\n<b>{{'atm_residual.remainingBag' | translate}}</b>\n</div>\n<a href=\"\"><img src=\"" + __webpack_require__(387) + "\" style=\"height: 80px\"></a>\n<b class=\"font-size-15 bag-color total-bag-font\">{{$ctrl.remainingResidualBag}}</b>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.shiptype === 'residual' && !$ctrl.isBagout\">\n<div ng-if=\"$ctrl.shipmentData.length && $ctrl.model.locationId && !$ctrl.isBagout\">\n<div class=\"col-sm-12 text-center padding-18\">\n<div class=\"col-sm-3 text-left font-size-15\">\n<span>\n{{'atm_residual.atmId' | translate}} |\n</span>\n<a href=\"#\" ng-click=\"$ctrl.redirectToLocation($ctrl.fromLocationId)\" style=\"font-size: 16px\">\n{{ $ctrl.fromLocationId }}\n</a>\n</div>\n<div class=\"col-sm-6 text-center font-size-15\">\n<span>\n{{'atm_residual.locationName' | translate}} | {{ $ctrl.fromLocationName }}\n</span>\n</div>\n<div class=\"col-sm-3 font-size-15\">\n<div class=\"text-right\">\n<label>{{'atm_residual.orderType' | translate}} | </label>\n<span ng-class=\"{'text-success' : $ctrl.orderType}\" ng-if=\"$ctrl.orderType\">\n{{$ctrl.getOrderType($ctrl.orderType)}}\n</span>\n<span ng-class=\"{'text-danger' : !$ctrl.orderType}\" ng-if=\"!$ctrl.orderType\">\n{{'common.n_a' | translate}}\n</span>\n</div>\n<div class=\"text-right\" ng-if=\"$ctrl.isEmergencyType\">\n<span class=\"text-success\">({{'common.emergency' | translate}})</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 text-center\">\n<div class=\"col-sm-3 text-right margin-top-10\">\n<label for=\"dateTime\"> {{'atm_residual.dateTime' | translate}} |</label>\n</div>\n<div class=\"col-sm-3 text-center\">\n<datetimepicker ng-class=\"{'required-datetimepicker': !$ctrl.pickupDate}\" class=\"datetimepicker-input\" ng-model=\"$ctrl.pickupDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.minVaultDate\"/>\n</div>\n<div class=\"col-sm-3 text-left\">\n<input type=\"time\" class=\"form-control\" ng-model=\"$ctrl.model.beginTime\" required>\n</div>\n</div>\n</div>\n<div class=\"row pull-right text-right mb-1\">\n<div class=\"col-sm-12 remove-right-pad\">\n<div class=\"pull-left mr-1\" ng-if=\"$ctrl.atmResidualRecord.comment\">\n<button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.getComments($ctrl.atmResidualRecord.comment);\" uib-tooltip=\"{{'checkout.comments' | translate}}\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"flex-center\">\n<div class=\"row w-90\">\n<div class=\"col-sm-10\" ng-if=\"$ctrl.shipmentData.length && $ctrl.model.locationId && $ctrl.parentShipment\">\n<table class=\"table table-hover table-striped table-bordered table-padding-2\">\n<thead>\n<tr>\n<td class=\"text-center denomination-width\">\n<b>{{'atm_residual.denomination' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'atm_residual.receipt' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'atm_residual.requestLoad' | translate}}</b>\n</td>\n<td class=\"text-center col-md-2\">\n<b>{{'atm_residual.actualLoad' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'atm_residual.crv' | translate}}</b>\n</td>\n<td class=\"text-center col-md-3\">\n<b>{{'atm_residual.expectedResidual' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'atm_residual.statedResidual' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"scroll-content\">\n<tr>\n<td class=\"text-center\">\n<span uib-tooltip=\"{{ $ctrl.parentShipment.trackingId }}\">\n<img ng-src=\"../../assets/images/bag-off.png\" class=\"img-width\"/>\n</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.parentShipment.pickupImageName\">\n<button type=\"button\" class=\"btn btn-link\" ng-click=\"$ctrl.showResidualReceipt($ctrl.parentShipment)\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</td>\n<td ng-if=\"!$ctrl.parentShipment.pickupImageName\"></td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-change=\"$ctrl.calculateAmountForParent()\" ng-model=\"$ctrl.model.parentAtmResidual.requestLoad\" disabled=\"disabled\" ng-currency currency-symbol=\"{{$ctrl.model.parentAtmResidual.denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control text-box-radius-left\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-change=\"$ctrl.calculateAmountForParent()\" ng-model=\"$ctrl.model.parentAtmResidual.actualLoad\" placeholder=\"{{'atm_residual.amount' | translate}}\" disabled=\"disabled\" ng-currency currency-symbol=\"{{$ctrl.model.parentAtmResidual.denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" fraction=\"2\" required/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" disabled=\"disabled\" ng-model=\"$ctrl.model.parentAtmResidual.crv\" ng-currency currency-symbol=\"{{$ctrl.model.parentAtmResidual.denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/>\n</td>\n<td>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" class=\"form-control text-box-radius-left\" disabled=\"disabled\" ng-change=\"$ctrl.calculateAmountForParent()\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" placeholder=\"{{'atm_residual.amount' | translate}}\" ng-model=\"$ctrl.model.parentAtmResidual.expectedResidual\" ng-currency currency-symbol=\"{{$ctrl.model.parentAtmResidual.denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" fraction=\"2\" required/>\n</div>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" ng-pattern=\"/^[0-9 _ ,]*(\\.[0-9]{1,2})?$/\" round-to2-decimals class=\"form-control text-box-radius-right\" ng-change=\"$ctrl.calculateAmountForParent()\" ng-model=\"$ctrl.model.parentAtmResidual.denomExpectedResidual\" required disabled=\"disabled\"/>\n</div>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" disabled=\"disabled\" ng-model=\"$ctrl.model.parentAtmResidual.parentStatedAmount\" ng-currency currency-symbol=\"{{$ctrl.model.parentAtmResidual.denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-2\" ng-if=\"$ctrl.shipmentData.length && $ctrl.model.locationId && $ctrl.parentShipment\">\n<div style=\"margin-top: 5px;\">\n<div class=\"text-left\" style=\"margin-bottom: 5px;\">\n<b>{{'atm_residual.divertedAmount' | translate}}</b>\n</div>\n<input type=\"text\" class=\"form-control\" style=\"width: 100%;\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-model=\"$ctrl.model.parentAtmResidual.divertedAmount\" placeholder=\"{{$ctrl.currencySymbol}}0\" ng-disabled=\"$ctrl.disableRow(0) && !$ctrl.isEdit\" ng-currency currency-symbol=\"{{$ctrl.model.parentAtmResidual.denominationSymbol || $ctrl.currencySymbol}}\"/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"remove-z-index col-sm-12 align-center remove-pad\" style=\"display: flex; flex-wrap: wrap; align-items: flex-start;\" ng-if=\"$ctrl.expectedResidualDetails.length > 0 && !$ctrl.shipmentLoading && $ctrl.shipmentData.length > 0 && !$ctrl.model.parentAtmResidual.madeCRV\">\n<span class=\"remaining-amt-lbl\" style=\"flex: 0 0 auto; min-width: 180px; white-space: nowrap;\">\n<label>{{'atm_residual.prior_load_amount' | translate}} |</label>\n</span>\n<div class=\"col-sm-2 col-md-2 no-padding margin5 min-width-10\" ng-repeat=\"denomination in $ctrl.expectedResidualDetails\">\n<div class=\"input-group atm-count-prior-load-toggle-container fixed-height-group\" ng-class=\"{'is-editing': (denomination.isEditablePriorLoad || ($ctrl.finishedAt && $ctrl.isEdit)) && denomination.actualPriorLoad === 0}\">\n<div class=\"input-group-addon padding5\">\n<img ng-src=\"assets/images/{{denomination.denominationId}}.png\" class=\"img-currency\"/>\n</div>\n<div class=\"form-control text-right\" ng-show=\"denomination.actualPriorLoad > 0 && !denomination.hasManuallySetPriorLoad\">\n{{ denomination.actualPriorLoad | currency:(denomination.symbol || $ctrl.currencySymbol):2 }}\n</div>\n<div class=\"form-control text-right view-mode-label\" ng-hide=\"denomination.isEditablePriorLoad || $ctrl.isEdit || denomination.actualPriorLoad > 0\">\n{{ denomination.manualPriorLoadAmount | currency:(denomination.symbol || $ctrl.currencySymbol):2 }}\n</div>\n<div ng-show=\"((denomination.isEditablePriorLoad) || ($ctrl.finishedAt && $ctrl.isEdit)) && (denomination.actualPriorLoad === 0 || denomination.hasManuallySetPriorLoad)\">\n<input type=\"text\" class=\"form-control edit-mode-input\" ng-disabled=\"($ctrl.finishedAt && !$ctrl.isEdit) || (denomination.orderType == 'A' && denomination.madeCRV === 0)\" ng-change=\"$ctrl.validateManuallyPriorLoadedAmount(denomination)\" ng-class=\"{'invalid-prior-load-amount': !denomination.isValidAmount}\" ng-model=\"denomination.manualPriorLoadAmount\" ng-currency currency-symbol=\"{{denomination.symbol || $ctrl.currencySymbol}}\" min=\"0\" required fraction=\"2\"/>\n</div>\n<div class=\"input-group-btn\" ng-show=\"denomination.actualPriorLoad === 0 && !denomination.isEditablePriorLoad && !$ctrl.finishedAt && !$ctrl.isEdit &&\n                                (denomination.orderType !== 'A' || (denomination.orderType == 'A' && denomination.madeCRV === 1))\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"denomination.isEditablePriorLoad = true\" uib-tooltip=\"{{'common.Edit' | translate}}\">\n<i class=\"glyphicon glyphicon-pencil\"></i>\n</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 text-center remove-left-pad remove-right-pad text-danger\" ng-if=\"$ctrl.manualPriorLoadDenominations.length && $ctrl.finishedAt && $ctrl.model.locationId && $ctrl.shipmentData.length > 0\">\n<span>\nThe prior load amount for ({{$ctrl.manualPriorLoadDenominations.join(', ')}}) was manually adjusted when counted/edited.\n</span>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.shipmentLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row\" ng-if=\"!$ctrl.shipmentLoading\">\n<div ng-if=\"$ctrl.shipmentData.length && $ctrl.model.locationId\">\n<div class=\"margin-bottom-10 font-size-18 col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<b>{{'atm_residual.included_denominations' | translate}}</b>\n</div>\n<div class=\"pull-right\" ng-if=\"$ctrl.model.atmResidual[0].finishedAt && !$ctrl.isEdit\" style=\"color: green\">\n<b>{{ 'atm_residual.committed' | translate }}</b> :\n<span>{{ $ctrl.model.atmResidual[0].finishedAt | date:'yyyy-MM-dd | h:mm a' }}</span>\n</div>\n</div>\n<table class=\"table table-hover table-striped table-bordered table-padding-2\">\n<thead>\n<tr>\n<td class=\"text-center denomination-width\">\n<b>{{'atm_residual.denomination' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>RCPT</b>\n</td>\n<td class=\"text-center col-width-08\">\n<b>Req. Load</b>\n</td>\n<td class=\"text-center _col-md-2 col-width-14\">\n<b>{{'atm_residual.actualLoad' | translate}}</b>\n</td>\n<td class=\"text-center _col-md-1 col-width-08\">\n<b>{{'atm_residual.crv' | translate}}</b>\n</td>\n<td class=\"text-center _col-md-2 col-width-14\">\n<b>{{'atm_residual.transferred' | translate}}</b>\n</td>\n<td class=\"text-center _col-md-2 col-width-14\">\n<b>{{'atm_residual.dispensed' | translate}}</b>\n</td>\n<td class=\"text-center _col-md-2 col-width-14\">\n<b>{{'atm_residual.expectedResidual' | translate}}</b>\n</td>\n<td class=\"text-center _col-md-2 col-width-14\">\n<b>{{'atm_residual.countedResidual' | translate}}</b>\n<div style=\"margin-top:4px\" ng-if=\"$ctrl.canShowAutoCountButton()\">\n<button type=\"button\" class=\"btn btn-xs btn-default\" ng-click=\"$ctrl.autoCountFromCounter()\" ng-disabled=\"$ctrl.autoCounting\">\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.autoCounting}\"></span>\nAuto Count\n</button>\n</div>\n</td>\n<td class=\"text-center col-width-07\">\n<b>{{'atm_residual.variance' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"scroll-content atm-residual-amount-col\">\n<tr ng-repeat=\"shipments in $ctrl.childShipmentData track by $index\">\n<td class=\"text-center\">\n<span uib-tooltip=\"{{shipments.trackingId}}\">\n<img ng-src=\"../../assets/images/{{shipments.denominationId}}.png\" class=\"img-width\"/>\n</span>\n</td>\n<td class=\"text-center\" ng-if=\"shipments.pickupImageName\">\n<button type=\"button\" class=\"btn btn-link\" ng-click=\"$ctrl.showResidualReceipt(shipments)\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</td>\n<td ng-if=\"!shipments.pickupImageName\"></td>\n<td> <input type=\"text\" class=\"form-control\" ng-change=\"$ctrl.calculateAmount($index)\" ng-model=\"$ctrl.model.atmResidual[$index].requestLoad\" disabled=\"disabled\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/></td>\n<td>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" class=\"form-control text-box-radius-left\" ng-if=\"!$ctrl.model.atmResidual[$index].coinFlag\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-change=\"$ctrl.calculateAmount($index)\" ng-class=\"{'actual-load-exceeds-request-load': $ctrl.isActualLoadExceedsRequestLoad($ctrl.model.atmResidual[$index])}\" ng-model=\"$ctrl.model.atmResidual[$index].actualLoad\" placeholder=\"{{'atm_residual.amount' | translate}}\" ng-disabled=\"$ctrl.disableRow($index) && !$ctrl.isEdit || (['T', 'P'].includes($ctrl.model.atmResidual[$index].orderType) && $ctrl.model.atmResidual[$index].requestLoad == 0)\" ng-pattern=\"/^$|^(\\$|€|CA\\$|C\\$|J\\$)?\\s*[\\d,]+(?:\\.00)?$/\" denomination-multiple=\"$ctrl.model.atmResidual[$index].faceValue\" coin-packaging=\"$ctrl.model.atmResidual[$index].coinPackaging\" unit-value=\"$ctrl.model.atmResidual[$index].unitValue\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" fraction=\"2\" required/>\n<input type=\"text\" class=\"form-control text-box-radius-left\" ng-if=\"$ctrl.model.atmResidual[$index].coinFlag\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-change=\"$ctrl.calculateAmount($index)\" ng-class=\"{'actual-load-exceeds-request-load': $ctrl.isActualLoadExceedsRequestLoad($ctrl.model.atmResidual[$index])}\" ng-model=\"$ctrl.model.atmResidual[$index].actualLoad\" placeholder=\"{{'atm_residual.amount' | translate}}\" ng-disabled=\"$ctrl.disableRow($index) && !$ctrl.isEdit || (['T', 'P'].includes($ctrl.model.atmResidual[$index].orderType) && $ctrl.model.atmResidual[$index].requestLoad == 0)\" ng-pattern=\"/^$|^([$]|€|CA[$]|C[$]|J[$])?[ ]*(?:(?:[0-9,]+(?:[.][0-9]{0,2})?)|(?:[.][0-9]{1,2}))$/\" denomination-multiple=\"$ctrl.model.atmResidual[$index].faceValue\" coin-packaging=\"$ctrl.model.atmResidual[$index].coinPackaging\" unit-value=\"$ctrl.model.atmResidual[$index].unitValue\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" fraction=\"2\" required/>\n</div>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" ng-pattern=\"/^[0-9_,]*$/\" class=\"form-control text-box-radius-right\" ng-class=\"{'actual-load-exceeds-request-load': $ctrl.isActualLoadExceedsRequestLoad($ctrl.model.atmResidual[$index])}\" ng-change=\"$ctrl.calculateFromBillCount($index, 'denomActualLoad', 'actualLoad')\" ng-model=\"$ctrl.model.atmResidual[$index].denomActualLoad\" required ng-disabled=\"$ctrl.disableRow($index) && !$ctrl.isEdit || (['T', 'P'].includes($ctrl.model.atmResidual[$index].orderType) && $ctrl.model.atmResidual[$index].requestLoad == 0)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\"/>\n</div>\n</td>\n<td><input type=\"text\" class=\"form-control\" disabled=\"disabled\" ng-model=\"$ctrl.model.atmResidual[$index].crv\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/></td>\n<td>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" class=\"form-control text-box-radius-left\" ng-if=\"$ctrl.model.atmResidual[$index].coinFlag\" ng-disabled=\"($ctrl.disableRow($index) && !$ctrl.isEdit) || ['I', 'R'].includes($ctrl.model.atmResidual[$index].orderType)\" ng-change=\"$ctrl.calculateAmount($index)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" placeholder=\"{{'atm_residual.amount' | translate}}\" ng-model=\"$ctrl.model.atmResidual[$index].transferredAmount\" ng-pattern=\"/^$|^([$]|€|CA[$]|C[$]|J[$])?[ ]*(?:(?:[0-9,]+(?:[.][0-9]{0,2})?)|(?:[.][0-9]{1,2}))$/\" denomination-multiple=\"$ctrl.model.atmResidual[$index].faceValue\" coin-packaging=\"$ctrl.model.atmResidual[$index].coinPackaging\" unit-value=\"$ctrl.model.atmResidual[$index].unitValue\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" fraction=\"2\" required/>\n<input type=\"text\" class=\"form-control text-box-radius-left\" ng-if=\"!$ctrl.model.atmResidual[$index].coinFlag\" ng-disabled=\"($ctrl.disableRow($index) && !$ctrl.isEdit) || ['I', 'R'].includes($ctrl.model.atmResidual[$index].orderType)\" ng-change=\"$ctrl.calculateAmount($index)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" placeholder=\"{{'atm_residual.amount' | translate}}\" ng-model=\"$ctrl.model.atmResidual[$index].transferredAmount\" ng-pattern=\"/^$|^(\\$|€|CA\\$|C\\$|J\\$)?\\s*[\\d,]+(?:\\.00)?$/\" denomination-multiple=\"$ctrl.model.atmResidual[$index].faceValue\" coin-packaging=\"$ctrl.model.atmResidual[$index].coinPackaging\" unit-value=\"$ctrl.model.atmResidual[$index].unitValue\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" fraction=\"2\" required/>\n</div>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" ng-pattern=\"/^[0-9_,]*$/\" class=\"form-control text-box-radius-right\" ng-change=\"$ctrl.calculateFromBillCount($index, 'denomTransferredAmount', 'transferredAmount')\" ng-model=\"$ctrl.model.atmResidual[$index].denomTransferredAmount\" required ng-disabled=\"($ctrl.disableRow($index) && !$ctrl.isEdit) || ['I', 'R'].includes($ctrl.model.atmResidual[$index].orderType)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\"/>\n</div>\n</td>\n<td>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" class=\"form-control text-box-radius-left\" ng-if=\"$ctrl.model.atmResidual[$index].coinFlag\" ng-disabled=\"($ctrl.disableRow($index) && !$ctrl.isEdit) || ['I', 'R'].includes($ctrl.model.atmResidual[$index].orderType)\" ng-change=\"$ctrl.calculateAmount($index)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" placeholder=\"{{'atm_residual.amount' | translate}}\" ng-model=\"$ctrl.model.atmResidual[$index].dispensedAmount\" ng-pattern=\"/^$|^([$]|€|CA[$]|C[$]|J[$])?[ ]*(?:(?:[0-9,]+(?:[.][0-9]{0,2})?)|(?:[.][0-9]{1,2}))$/\" denomination-multiple=\"$ctrl.model.atmResidual[$index].faceValue\" coin-packaging=\"$ctrl.model.atmResidual[$index].coinPackaging\" unit-value=\"$ctrl.model.atmResidual[$index].unitValue\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" fraction=\"2\" required/>\n<input type=\"text\" class=\"form-control text-box-radius-left\" ng-if=\"!$ctrl.model.atmResidual[$index].coinFlag\" ng-disabled=\"($ctrl.disableRow($index) && !$ctrl.isEdit) || ['I', 'R'].includes($ctrl.model.atmResidual[$index].orderType)\" ng-change=\"$ctrl.calculateAmount($index)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" placeholder=\"{{'atm_residual.amount' | translate}}\" ng-model=\"$ctrl.model.atmResidual[$index].dispensedAmount\" ng-pattern=\"/^$|^(\\$|€|CA\\$|C\\$|J\\$)?\\s*[\\d,]+(?:\\.00)?$/\" denomination-multiple=\"$ctrl.model.atmResidual[$index].faceValue\" coin-packaging=\"$ctrl.model.atmResidual[$index].coinPackaging\" unit-value=\"$ctrl.model.atmResidual[$index].unitValue\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" fraction=\"2\" required/>\n</div>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" ng-pattern=\"/^[0-9_,]*$/\" class=\"form-control text-box-radius-right\" ng-change=\"$ctrl.calculateFromBillCount($index, 'denomDispensedAmount', 'dispensedAmount')\" ng-model=\"$ctrl.model.atmResidual[$index].denomDispensedAmount\" required ng-disabled=\"($ctrl.disableRow($index) && !$ctrl.isEdit) || ['I', 'R'].includes($ctrl.model.atmResidual[$index].orderType)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\"/>\n</div>\n</td>\n<td>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" class=\"form-control text-box-radius-left\" disabled=\"disabled\" ng-change=\"$ctrl.calculateAmount($index)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" placeholder=\"{{'atm_residual.amount' | translate}}\" ng-model=\"$ctrl.model.atmResidual[$index].expectedResidual\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" fraction=\"2\" required/>\n</div>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" ng-pattern=\"/^[0-9 _ ,]*(\\.[0-9]{1,2})?$/\" round-to2-decimals class=\"form-control text-box-radius-right atm_error\" ng-change=\"$ctrl.calculateAmount($index)\" ng-model=\"$ctrl.model.atmResidual[$index].denomExpectedResidual\" required disabled=\"disabled\"/>\n</div>\n</td>\n<td>\n<div class=\"col-sm-6 padding-zero\">\n<input id=\"counted-residual\" type=\"text\" class=\"form-control text-box-radius-left\" ng-if=\"$ctrl.model.atmResidual[$index].coinFlag\" ng-disabled=\"$ctrl.disableRow($index) && !$ctrl.isEdit\" ng-change=\"$ctrl.calculateAmount($index)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" placeholder=\"{{'atm_residual.amount' | translate}}\" ng-keydown=\"$event.keyCode === 13 && $ctrl.setFocus($event)\" ng-model=\"$ctrl.model.atmResidual[$index].countedResidual\" ng-pattern=\"/^$|^([$]|€|CA[$]|C[$]|J[$])?[ ]*(?:(?:[0-9,]+(?:[.][0-9]{0,2})?)|(?:[.][0-9]{1,2}))$/\" denomination-multiple=\"$ctrl.model.atmResidual[$index].faceValue\" coin-packaging=\"$ctrl.model.atmResidual[$index].coinPackaging\" unit-value=\"$ctrl.model.atmResidual[$index].unitValue\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" disabled=\"disabled\" required fraction=\"2\"/>\n<input id=\"counted-residual\" type=\"text\" class=\"form-control text-box-radius-left\" ng-if=\"!$ctrl.model.atmResidual[$index].coinFlag\" ng-disabled=\"$ctrl.disableRow($index) && !$ctrl.isEdit\" ng-change=\"$ctrl.calculateAmount($index)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" placeholder=\"{{'atm_residual.amount' | translate}}\" ng-keydown=\"$event.keyCode === 13 && $ctrl.setFocus($event)\" ng-model=\"$ctrl.model.atmResidual[$index].countedResidual\" ng-pattern=\"/^$|^(\\$|€|CA\\$|C\\$|J\\$)?\\s*[\\d,]+(?:\\.00)?$/\" denomination-multiple=\"$ctrl.model.atmResidual[$index].faceValue\" coin-packaging=\"$ctrl.model.atmResidual[$index].coinPackaging\" unit-value=\"$ctrl.model.atmResidual[$index].unitValue\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" disabled=\"disabled\" required fraction=\"2\"/>\n</div>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" ng-pattern=\"/^[0-9_,]*$/\" class=\"form-control text-box-radius-right\" ng-change=\"$ctrl.calculateFromBillCount($index, 'denomCountedResidual', 'countedResidual')\" ng-model=\"$ctrl.model.atmResidual[$index].denomCountedResidual\" required ng-disabled=\"$ctrl.disableRow($index) && !$ctrl.isEdit\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\"/>\n</div>\n</td>\n<td><input type=\"text\" disabled=\"disabled\" class=\"form-control ng-valid\" ng-model=\"$ctrl.model.atmResidual[$index].variance\" ng-class=\"{'variance-background' : $ctrl.model.atmResidual[$index].variance > 0}\" ng-currency currency-symbol=\"{{$ctrl.model.atmResidual[$index].denominationSymbol || $ctrl.currencySymbol}}\" required fraction=\"2\" hide-zero/>\n</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td class=\"blank-row-size\" colspan=\"9\">&nbsp;</td>\n</tr>\n</tbody>\n<tbody class=\"atm-residual-amount-col\">\n<tr>\n<td class=\"text-center col-width-05 _col-width-6\"><b class=\"text-total-color\">{{'common.total' | translate}}</b></td>\n<td></td>\n<td> <input type=\"text\" class=\"form-control\" ng-init=\"$ctrl.totalAmount()\" disabled=\"disabled\" ng-model=\"$ctrl.model.requestLoadTotal\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/></td>\n<td><input type=\"text\" class=\"form-control\" ng-init=\"$ctrl.totalAmount()\" disabled=\"disabled\" ng-model=\"$ctrl.model.actualLoadTotal\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/></td>\n<td><input type=\"text\" class=\"form-control\" ng-init=\"$ctrl.totalAmount()\" disabled=\"disabled\" ng-model=\"$ctrl.model.crvTotal\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/></td>\n<td><input type=\"text\" class=\"form-control\" ng-init=\"$ctrl.totalAmount()\" disabled=\"disabled\" ng-model=\"$ctrl.model.transferredAmountTotal\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/></td>\n<td><input type=\"text\" class=\"form-control\" ng-init=\"$ctrl.totalAmount()\" disabled=\"disabled\" ng-model=\"$ctrl.model.dispensedAmountTotal\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/></td>\n<td><input type=\"text\" class=\"form-control\" ng-init=\"$ctrl.totalAmount()\" disabled=\"disabled\" ng-model=\"$ctrl.model.expectedResidualTotal\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/></td>\n<td><input type=\"text\" class=\"form-control\" ng-init=\"$ctrl.totalAmount()\" disabled=\"disabled\" ng-model=\"$ctrl.model.countedResidualTotalDisplay\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\" required/></td>\n<td><input type=\"text\" class=\"form-control ng-valid\" ng-init=\"$ctrl.totalAmount()\" disabled=\"disabled\" ng-model=\"$ctrl.model.varianceTotal\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" required hide-zero fraction=\"2\"/></td>\n</tr>\n</tbody>\n</table>\n<div class=\"atm-count-unfit-notes\" ng-class=\"{'has-unfit': $ctrl.hasUnfitDenoms()}\">\n<div class=\"atm-count-unfit\" ng-if=\"$ctrl.hasUnfitDenoms() && $ctrl.shiptype === 'residual'\">\n<div class=\"margin-bottom-10 font-size-18 col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<b>{{'denomination.unfit_denominations' | translate}}</b>\n</div>\n</div>\n<table class=\"table table-hover table-striped table-bordered table-padding-2\">\n<thead>\n<tr>\n<td class=\"text-center denomination-width\">\n<b>{{'atm_residual.denomination' | translate}}</b>\n</td>\n<td class=\"text-center col-width-10\">\n<b>{{'atm_residual.countedResidual' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"scroll-content\">\n<tr ng-repeat=\"unfitDenom in $ctrl.getViewUnfitDenominations() track by $index\">\n<td class=\"text-center\">\n<span uib-tooltip=\"{{unfitDenom.id + '-' + unfitDenom.faceValue}}\">\n<img ng-src=\"../../assets/images/{{unfitDenom.id}}.png\" class=\"img-width\"/>\n</span>\n</td>\n<td>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" class=\"form-control text-box-radius-left\" ng-disabled=\"$ctrl.disableRow($index) && !$ctrl.isEdit\" ng-change=\"$ctrl.calculateUnfitAmount($index)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" placeholder=\"{{'atm_residual.amount' | translate}}\" ng-model=\"unfitDenom.totalCashCounted\" ng-currency currency-symbol=\"{{unfitDenom.denominationSymbol || $ctrl.currencySymbol}}\" min=\"0\" ng-pattern=\"$ctrl.residualCoinAmountPattern\" fraction=\"2\" required/>\n</div>\n<div class=\"col-sm-6 padding-zero\">\n<input type=\"text\" ng-pattern=\"/^[0-9 _ ,]*(\\.[0-9]{1,2})?$/\" round-to2-decimals class=\"form-control text-box-radius-right atm_error\" ng-class=\"{'variance-background': unfitDenom.isInvalidAmount}\" ng-change=\"$ctrl.calculateUnfitAmount($index)\" ng-model=\"unfitDenom.denomTotalCashCounted\" required disabled=\"disabled\"/>\n</div>\n</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td class=\"blank-row-size\" colspan=\"2\">&nbsp;</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td class=\"text-center col-width-05\"><b class=\"text-total-color\">{{'common.total' | translate}}</b></td>\n<td>\n<input type=\"text\" class=\"form-control\" disabled=\"disabled\" ng-model=\"$ctrl.model.unfitTotalCashCounted\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero fraction=\"2\"/>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"atm-count-notes\">\n<div class=\"margin-bottom-10 font-size-18\">\n<b>{{'common.notes' | translate}}</b>\n</div>\n<textarea id=\"atmCountNotes\" class=\"form-control\" rows=\"3\" ng-model=\"$ctrl.atmResidualRecord.notes\" ng-disabled=\"$ctrl.disableRow(0) && !$ctrl.isEdit\" autocomplete=\"off\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12 text-center\" style=\"margin: 15px 0px; gap: 10px;\">\n<button id=\"residual-commit\" type=\"button\" class=\"btn btn-md btn-primary btn-icon\" ng-disabled=\"$ctrl.isCommit || !$ctrl.model.bagId || $ctrl.shipmentData.length == 1 ||\n                                     $ctrl.model.parentAtmResidual.expectedResidual == null || $ctrl.gettingExpectedResidual || $ctrl.isDisableExpectedResidual()\" ng-click=\"$ctrl.getExpectedResidual(shipments)\">\n<span class=\"glyphicon glyphicon-refresh\" ng-class=\"{'fast-right-spinner': $ctrl.gettingExpectedResidual}\"></span>\n<b>{{'atm_residual.expected_residual' | translate}}</b>\n</button>\n<button id=\"residual-commit\" type=\"button\" class=\"btn btn-md btn-success btn-icon\" ng-if=\"!$ctrl.finishedAt\" ng-disabled=\"$ctrl.commitDisabled(0) || $ctrl.isCommit || !$ctrl.model.bagId || $ctrl.gettingExpectedResidual ||\n                                     $ctrl.model.parentAtmResidual.expectedResidual == null || !$ctrl.isPressExpectedResidualButton\" ng-click=\"$ctrl.commitResidualShipment(shipments)\">\n<b>{{'common.commit' | translate}}</b>\n&nbsp;\n<span class=\"glyphicon glyphicon-arrow-right\"></span>\n</button>\n<button id=\"residual-commit-add-deposit\" type=\"button\" class=\"btn btn-md btn-success btn-icon\" ng-if=\"!$ctrl.finishedAt\" ng-disabled=\"$ctrl.commitDisabled(0) || $ctrl.isCommit || !$ctrl.model.bagId || $ctrl.gettingExpectedResidual ||\n                                     $ctrl.model.parentAtmResidual.expectedResidual == null || !$ctrl.isPressExpectedResidualButton\" ng-click=\"$ctrl.commitResidualShipment(0, true)\">\n<b>{{'common.commit_add_deposit' | translate}}</b>\n</button>\n<button id=\"edit-residual-commit\" type=\"button\" class=\"btn btn-success btn-icon btn-md\" ng-class=\"{'disabled' : !$ctrl.isSameVaultDate}\" ng-click=\"$ctrl.editResidualCommit()\" ng-disabled=\"($ctrl.isEdit && $ctrl.commitDisabled(0)) || $ctrl.isCommit || ($ctrl.isEdit && !$ctrl.model.bagId) || $ctrl.model.parentAtmResidual.expectedResidual == null\" ng-if=\"$ctrl.shipmentData.length && $ctrl.model.locationId && $ctrl.hasACL['atm_count']['editCommitted'] && $ctrl.finishedAt\">\n<span class=\"glyphicon glyphicon-edit\"></span>\n<b>{{'common.Edit' | translate}}</b>\n</button>\n<button id=\"cancel-edit\" type=\"button\" class=\"btn btn-danger btn-icon btn-md\" ng-click=\"$ctrl.cancelEdit()\" ng-if=\"$ctrl.shipmentData.length && $ctrl.model.locationId && $ctrl.hasACL['atm_count']['editCommitted'] && $ctrl.finishedAt && $ctrl.isEdit\">\n<span class=\"glyphicon glyphicon-remove-circle\"></span>\n<b>{{'common.cancel' | translate}}</b>\n</button>\n</div>\n</div>\n</div>\n<div ng-if=\"!$ctrl.shipmentData.length && !$ctrl.isError\">\n<div class=\"align-center-horizontally row hide-in-print\" ng-show=\"!$ctrl.shipmentData.length && !$ctrl.isError\">\n<div class=\"col-sm-12 text-center alert alert-danger\" ng-class=\"{'alert-danger': !$ctrl.shipmentData.length}\">\n{{'atm_residual.noMatchFound' | translate}}\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.isLoadShipmentIsOnHold && !$ctrl.model.loading\">\n<div class=\"row alert text-center\" ng-class=\"{'alert-danger': $ctrl.isLoadShipmentIsOnHold}\" style=\"margin-bottom: 0px;\">\n{{'atm_residual.loadShipmentOnHoldErr' | translate}}\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n</div>\n<div ng-if=\"$ctrl.shiptype === 'deposit' && $ctrl.model.depositRecord.depositShipment && !$ctrl.isBagout\">\n<div ng-if=\"$ctrl.model.depositRecord.depositShipment && $ctrl.model.locationId && !$ctrl.isBagout\">\n<div class=\"col-sm-12 text-center padding-18\">\n<div class=\"col-sm-3 text-left font-size-15\">\n<span>\n{{'atm_residual.atmId' | translate}} |\n</span>\n<a href=\"#\" ng-click=\"$ctrl.redirectToLocation($ctrl.fromLocationId)\" style=\"font-size: 16px\">\n{{ $ctrl.fromLocationId }}\n</a>\n</div>\n<div class=\"col-sm-6 text-center font-size-15\">\n<span>\n{{'atm_residual.locationName' | translate}} | {{ $ctrl.fromLocationName }}\n</span>\n</div>\n</div>\n<div class=\"col-sm-12 text-center\">\n<div class=\"col-sm-3 text-right margin-top-10\">\n<label for=\"dateTime\"> {{'atm_residual.dateTime' | translate}} |</label>\n</div>\n<div class=\"col-sm-3 text-center\">\n<datetimepicker ng-class=\"{'required-datetimepicker': !$ctrl.pickupDate}\" class=\"datetimepicker-input\" ng-model=\"$ctrl.pickupDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.minVaultDate\"/>\n</div>\n<div class=\"col-sm-3 text-left\">\n<input type=\"time\" class=\"form-control\" ng-model=\"$ctrl.model.beginTime\" required>\n</div>\n</div>\n</div>\n<div class=\"row pull-right text-right mb-1\">\n<div class=\"col-sm-12 remove-right-pad\">\n<div class=\"pull-left mr-1\" ng-if=\"$ctrl.model.depositRecord.depositRecord && $ctrl.model.depositRecord.depositRecord.comment\">\n<button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.getComments($ctrl.model.depositRecord.depositRecord.comment);\" uib-tooltip=\"{{'checkout.comments' | translate}}\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</div>\n</div>\n</div>\n<table class=\"atm-count-table flex-center\" style=\"width: 100% !important;\">\n<tr>\n<th ng-if=\"$ctrl.model.depositRecord.depositShipment.pickupImageName\">{{'atm_residual.receipt' | translate}}</th>\n<th>{{'atm_residual.stated_total' | translate}}</th>\n<th>{{'atm_residual.declared_total' | translate}}</th>\n<th>{{'atm_residual.counted_total' | translate}}</th>\n<th>{{'atm_residual.counted_variance' | translate}}</th>\n<th ng-if=\"$ctrl.finishedAt && !$ctrl.isEdit\"></th>\n</tr>\n<tr>\n<td class=\"receipt-cell\" ng-if=\"$ctrl.model.depositRecord.depositShipment.pickupImageName\">\n<button type=\"button\" class=\"btn btn-link\" ng-click=\"$ctrl.showResidualReceipt($ctrl.model.depositRecord.depositShipment)\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</td>\n<td>\n<input type=\"text\" disabled=\"disabled\" class=\"form-control\" ng-model=\"$ctrl.model.depositRecord.statedTotalAmount\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.depositRecord.declaredTotalAmount\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-change=\"$ctrl.depositCountTotal()\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" ng-disabled=\"!$ctrl.isEdit\" required fraction=\"2\"/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.depositRecord.totalAmount\" disabled=\"disabled\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero/>\n</td>\n<td class=\"total-variance\">\n<input type=\"text\" disabled=\"disabled\" class=\"form-control\" ng-model=\"$ctrl.model.depositRecord.countedVariance\" ng-class=\"{'variance-background' : $ctrl.model.depositRecord.countedVariance > 0}\" disabled=\"disabled\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" required hide-zero/>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.finishedAt && !$ctrl.isEdit\" style=\"color: green\">\n<b>{{ 'atm_residual.committed' | translate }}</b>\n<br>\n<span> {{ $ctrl.finishedAt | date:'yyyy-MM-dd | h:mm a' }}</span>\n</td>\n</tr>\n</table>\n<div class=\"atm-count-notes\">\n<div class=\"margin-bottom-10 font-size-18\">\n<b>{{'common.notes' | translate}}</b>\n</div>\n<textarea id=\"depositCountNotes\" class=\"form-control\" rows=\"3\" ng-model=\"$ctrl.model.depositRecord.notes\" ng-disabled=\"!$ctrl.isEdit\" autocomplete=\"off\"></textarea>\n</div>\n<div class=\"toggle-buttons flex-center\" style=\"gap: 5px;\">\n<button ng-class=\"{'btn-success': $ctrl.showCash, 'btn-secondary': !$ctrl.showCash}\" class=\"btn\" ng-click=\"$ctrl.toggleTab('cash')\">{{ 'common.cash' | translate }}</button>\n<button ng-class=\"{'btn-success': $ctrl.showCoins, 'btn-secondary': !$ctrl.showCoins}\" class=\"btn\" ng-click=\"$ctrl.toggleTab('coin')\">{{ 'common.coin' | translate }}</button>\n<button ng-if=\"$ctrl.hasUnfitDenoms()\" ng-class=\"{'btn-success': $ctrl.showUnfit, 'btn-secondary': !$ctrl.showUnfit}\" class=\"btn\" ng-click=\"$ctrl.toggleTab('unfit')\">{{ 'denomination.unfit' | translate }}</button>\n</div>\n<div class=\"denoms-coins-table\">\n<div ng-if=\"$ctrl.showCash\" class=\"denom-section\">\n<h4>{{ 'atm_residual.cash_denoms' | translate }}</h4>\n<table class=\"table denoms-table atm-count-table\">\n<thead>\n<tr>\n<th>{{ 'common.cash' | translate }}</th>\n<th>{{ 'atm_residual.bills' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"denom in $ctrl.model.depositRecord.denominations | filter:$ctrl.codCashFilter track by denom.id\">\n<td class=\"face-value\">\n<img ng-if=\"denom.id !== '1'\" ng-src=\"../../assets/images/{{denom.id}}.png\" class=\"custom-icon\"/>\n<img ng-if=\"denom.id == '1'\" src=\"" + __webpack_require__(68) + "\" class=\"custom-icon\"/>\n</td>\n<td>\n<div class=\"input-group-responsive\">\n<input type=\"text\" class=\"form-control input-count\" ng-disabled=\"!$ctrl.isEdit\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.depositDenomChange(denom.id)\" ng-model=\"denom.totalCounted\" min=\"0\" required/>\n<input type=\"text\" class=\"form-control input-value\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPattern\" ng-model=\"denom.totalValue\" min=\"0\" required fraction=\"0\" ng-currency currency-symbol=\"{{denom.symbol || $ctrl.currencySymbol}}\"/>\n</div>\n</td>\n</tr>\n<tr>\n<td></td>\n<td>\n<div class=\"total-input-wrapper\">\n<input type=\"text\" class=\"form-control total-value-input\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPattern\" ng-model=\"$ctrl.model.depositRecord.childTotalDeposit\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" value=\"{{ $ctrl.model.depositRecord.childTotalDeposit }}\" fraction=\"0\"/>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"$ctrl.showCoins\" class=\"denom-section\">\n<h4>{{ 'atm_residual.coin_denoms' | translate }}</h4>\n<table class=\"table denoms-table atm-count-table\">\n<thead>\n<tr>\n<th>{{ 'common.coin' | translate }}</th>\n<th>{{ 'common.unit' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"denom in $ctrl.model.depositRecord.denominations | filter:$ctrl.codCoinFilter track by denom.id\">\n<td class=\"face-value\">\n<img ng-if=\"denom.id !== '1'\" ng-src=\"../../assets/images/{{denom.id}}.png\" class=\"custom-icon\"/>\n<img ng-if=\"denom.id == '1'\" src=\"" + __webpack_require__(68) + "\" class=\"custom-icon\"/>\n</td>\n<td>\n<div class=\"input-group-responsive\">\n<input type=\"text\" class=\"form-control input-count\" ng-disabled=\"!$ctrl.isEdit\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.depositDenomChange(denom.id)\" ng-model=\"denom.totalCounted\" min=\"0\" required/>\n<input type=\"text\" class=\"form-control input-value\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPatternStrict\" ng-model=\"denom.totalValue\" min=\"0\" required ng-currency currency-symbol=\"{{denom.symbol || $ctrl.currencySymbol}}\"/>\n</div>\n</td>\n</tr>\n<tr>\n<td></td>\n<td>\n<div class=\"total-input-wrapper\">\n<input type=\"text\" class=\"form-control total-value-input\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPattern\" ng-model=\"$ctrl.model.depositRecord.coinTotalDeposit\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" value=\"{{ $ctrl.model.depositRecord.coinTotalDeposit }}\"/>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"$ctrl.showUnfit && $ctrl.hasUnfitDenoms()\" class=\"denom-section\">\n<h4>{{ 'denomination.unfit_denominations' | translate }}</h4>\n<table class=\"table denoms-table atm-count-table\">\n<thead>\n<tr>\n<th>{{ 'denomination.unfit_mutilated' | translate }}</th>\n<th>{{ 'atm_deposit_packing.bills' | translate }}/{{ 'atm_deposit_packing.unit' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"denom in $ctrl.model.depositRecord.denominations | filter:$ctrl.codUnfitFilter track by denom.id\">\n<td class=\"face-value\">\n<img ng-if=\"denom.id !== '1'\" ng-src=\"../../assets/images/{{denom.id}}.png\" class=\"custom-icon\"/>\n<img ng-if=\"denom.id == '1'\" src=\"" + __webpack_require__(68) + "\" class=\"custom-icon\"/>\n</td>\n<td>\n<div class=\"input-group-responsive\">\n<input type=\"text\" class=\"form-control input-count\" ng-disabled=\"!$ctrl.isEdit\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.depositDenomChange(denom.id)\" ng-model=\"denom.totalCounted\" min=\"0\" required/>\n<input type=\"text\" class=\"form-control input-value\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPatternStrict\" ng-model=\"denom.totalValue\" min=\"0\" required ng-currency currency-symbol=\"{{denom.symbol || $ctrl.currencySymbol}}\"/>\n</div>\n</td>\n</tr>\n<tr>\n<td></td>\n<td>\n<div class=\"total-input-wrapper\">\n<input type=\"text\" class=\"form-control total-value-input\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPattern\" ng-model=\"$ctrl.model.depositRecord.unfitTotalDeposit\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" value=\"{{ $ctrl.model.depositRecord.unfitTotalDeposit }}\"/>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"text-center\" style=\"margin: 25px 0px;\">\n<button ng-if=\"!$ctrl.finishedAt\" ng-disabled=\"$ctrl.isCommit || $ctrl.depositCommitDisabled() || !$ctrl.showDepositCommit() || !$ctrl.isEdit || ($ctrl.model.depositRecord.depositRecord.countedAt && !$ctrl.isEdit) || !$ctrl.model.depositRecord.declaredTotalAmount\" class=\"btn btn-success\" ng-click=\"$ctrl.commitDeposit()\">\n{{'common.commit' | translate}}\n</button>\n<button id=\"edit-residual-commit\" type=\"button\" class=\"btn btn-success btn-icon btn-sm\" ng-class=\"{'disabled' : !$ctrl.isSameVaultDate}\" ng-click=\"$ctrl.editDepositCommit()\" ng-disabled=\"$ctrl.isEditDepositButtonDisabled()\" ng-if=\"$ctrl.showEditDepositButton()\">\n<span class=\"glyphicon glyphicon-edit\"></span>\n<b>{{'common.Edit' | translate}}</b>\n</button>\n<button id=\"cancel-deposit-count-edit\" type=\"button\" class=\"btn btn-danger btn-icon btn-sm\" ng-click=\"$ctrl.cancelDepositCountEdit()\" ng-if=\"$ctrl.model.depositRecord.depositShipment && $ctrl.model.locationId && $ctrl.hasACL['atm_count']['editCommitted'] && $ctrl.finishedAt && $ctrl.isEdit\">\n<span class=\"glyphicon glyphicon-remove-circle\"></span>\n<b>{{'common.cancel' | translate}}</b>\n</button>\n</div>\n</div>\n<div ng-if=\"$ctrl.shiptype === 'bulkdeposit' && $ctrl.isBulkDeposit && !$ctrl.isBagout\">\n<div>\n<div class=\"col-sm-12 text-center padding-18\">\n<div class=\"col-sm-3 text-left font-size-15\">\n<span>\n{{'atm_residual.atmId' | translate}} |\n</span>\n<a href=\"#\" ng-click=\"$ctrl.redirectToLocation($ctrl.fromLocationId)\" style=\"font-size: 16px\">\n{{ $ctrl.fromLocationId }}\n</a>\n</div>\n<div class=\"col-sm-6 text-center font-size-15\">\n<span>\n{{'atm_residual.locationName' | translate}} | {{ $ctrl.fromLocationName }}\n</span>\n</div>\n</div>\n<div class=\"col-sm-12 text-center\">\n<div class=\"col-sm-3 text-right margin-top-10\">\n<label for=\"dateTime\"> {{'atm_residual.dateTime' | translate}} |</label>\n</div>\n<div class=\"col-sm-3 text-center\">\n<datetimepicker ng-class=\"{'required-datetimepicker': !$ctrl.pickupDate}\" class=\"datetimepicker-input\" ng-model=\"$ctrl.pickupDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.minVaultDate\"/>\n</div>\n<div class=\"col-sm-3 text-left\">\n<input type=\"time\" class=\"form-control\" ng-model=\"$ctrl.model.beginTime\" required>\n</div>\n</div>\n</div>\n<table class=\"atm-count-table flex-center\" style=\"width: 100% !important;\">\n<tr>\n<th>{{'atm_residual.stated_total' | translate}}</th>\n<th>{{'atm_residual.declared_total' | translate}}</th>\n<th>{{'atm_residual.counted_total' | translate}}</th>\n<th>{{'atm_residual.counted_variance' | translate}}</th>\n<th ng-if=\"$ctrl.finishedAt && !$ctrl.isEdit\"></th>\n</tr>\n<tr>\n<td>\n<input type=\"text\" disabled=\"disabled\" class=\"form-control\" ng-model=\"$ctrl.bulkDepositData.statedTotal\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.bulkDepositData.declaredTotal\" ng-change=\"$ctrl.onBulkDepositDeclaredTotalChange()\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" ng-disabled=\"$ctrl.isBulkDepositDeleted()\" required fraction=\"0\"/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.bulkDepositData.countedTotal\" disabled=\"disabled\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" required hide-zero/>\n</td>\n<td class=\"total-variance\">\n<input type=\"text\" disabled=\"disabled\" class=\"form-control\" ng-model=\"$ctrl.bulkDepositData.countedVariance\" ng-class=\"{'variance-background' : $ctrl.bulkDepositData.countedVariance > 0}\" disabled=\"disabled\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" required hide-zero/>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.finishedAt && !$ctrl.isEdit\" style=\"color: green\">\n<b>{{ 'atm_residual.committed' | translate }}</b>\n<br>\n<span> {{ $ctrl.finishedAt | date:'yyyy-MM-dd | h:mm a' }}</span>\n</td>\n</tr>\n</table>\n<div class=\"col-sm-12 margin-top-10\" ng-if=\"$ctrl.bulkDepositData.shipment\">\n<div class=\"margin-bottom-10 d-flex gap-1 align-items-center\" style=\"justify-content: space-between;\">\n<b>{{ $ctrl.getCountedBagsCount() }} of {{ $ctrl.getTotalBagsCount() }} Counted</b>\n<div ng-if=\"$ctrl.bulkDepositData.shipment && $ctrl.allBagsCommitted() && !$ctrl.isBulkDepositDeleted()\">\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.closeBulkDepositCount()\" ng-disabled=\"$ctrl.bulkDepositData.metadata.isClosingBulkDeposit\">\n<b>Close Count</b>\n</button>\n</div>\n<div ng-if=\"$ctrl.isBulkDepositDeleted()\">\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.reopenBulkDepositCount()\">\n<b>Reopen</b>\n</button>\n</div>\n</div>\n<table class=\"table table-hover table-bordered table-pad-5\">\n<thead>\n<tr class=\"text-center\">\n<td style=\"width: 50px;\">\n<b>#</b>\n</td>\n<td>\n<b>Tracking ID</b>\n</td>\n<td>\n<b>Declared Amount</b>\n</td>\n<td>\n<b>Counted Amount</b>\n</td>\n<td>\n<b>Counted Variance</b>\n</td>\n<td style=\"width: 120px;\">\n<b>Action</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat-start=\"bagIndex in $ctrl.getBagsArray() track by bagIndex\" ng-init=\"bag = $ctrl.getBagByIndex(bagIndex)\">\n<td>\n<b>{{ $index + 1 }}</b>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"bag.trackingId\" ng-change=\"$ctrl.updateBagTrackingId(bagIndex, bag.trackingId)\" ng-disabled=\"bag.status === 'counted' || bag.shipmentId || $ctrl.isBulkDepositDeleted() || $ctrl.isBagLocked(bagIndex)\" placeholder=\"Enter tracking ID\" capitalize required/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"bag.declaredAmount\" ng-change=\"$ctrl.updateBagDeclaredAmount(bagIndex, bag.declaredAmount); $ctrl.calculateBulkDepositTotals()\" ng-disabled=\"(bag.status === 'counted' && !$ctrl.isBagInEditMode(bagIndex)) || $ctrl.isBulkDepositDeleted() || $ctrl.isBagLocked(bagIndex)\" placeholder=\"Enter amount\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" fraction=\"0\" required/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"bag.countedAmount\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" min=\"0\" disabled=\"disabled\" hide-zero/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"bag.countedVariance\" ng-class=\"{'variance-background': bag.countedVariance > 0}\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" disabled=\"disabled\" hide-zero/>\n</td>\n<td>\n<div ng-if=\"bag.status === 'pending' && !bag.shipmentId\">\n<button class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.startBagCount(bagIndex)\" ng-disabled=\"!$ctrl.canStartBagCount(bagIndex) || $ctrl.isBulkDepositDeleted() || $ctrl.isBagLocked(bagIndex)\" uib-tooltip=\"Count this bag\">\n<span class=\"glyphicon glyphicon-play\"></span> Count\n</button>\n<button class=\"btn btn-sm btn-danger\" ng-click=\"$ctrl.removeBulkDepositBag(bagIndex)\" ng-disabled=\"$ctrl.isBulkDepositDeleted() || $ctrl.isBagLocked(bagIndex)\" uib-tooltip=\"Remove this bag\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n<div ng-if=\"bag.status === 'counting'\">\n<button class=\"btn btn-sm btn-info\" ng-click=\"$ctrl.toggleBagCollapse(bagIndex)\" ng-disabled=\"$ctrl.isBagCollapseDisabled(bagIndex)\" uib-tooltip=\"{{ $ctrl.isBagExpanded(bagIndex) ? 'Collapse' : 'Expand' }}\">\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-chevron-down': !$ctrl.isBagExpanded(bagIndex), 'glyphicon-chevron-up': $ctrl.isBagExpanded(bagIndex)}\"></i>\n</button>\n</div>\n<div ng-if=\"bag.status === 'counted'\">\n<div ng-if=\"$ctrl.isBulkDepositDeleted()\">\n<button class=\"btn btn-sm btn-info\" ng-click=\"$ctrl.toggleBagCollapse(bagIndex)\" uib-tooltip=\"{{ $ctrl.isBagExpanded(bagIndex) ? 'Collapse' : 'Expand to view details' }}\">\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-chevron-down': !$ctrl.isBagExpanded(bagIndex), 'glyphicon-chevron-up': $ctrl.isBagExpanded(bagIndex)}\"></i>\n</button>\n</div>\n<div ng-if=\"!$ctrl.isBulkDepositDeleted() && !$ctrl.canEditBag(bagIndex)\">\n<button class=\"btn btn-sm btn-info\" ng-click=\"$ctrl.toggleBagCollapse(bagIndex)\" uib-tooltip=\"{{ $ctrl.isBagExpanded(bagIndex) ? 'Collapse' : 'View details' }}\">\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-chevron-down': !$ctrl.isBagExpanded(bagIndex), 'glyphicon-chevron-up': $ctrl.isBagExpanded(bagIndex)}\"></i>\n</button>\n</div>\n<div ng-if=\"!$ctrl.isBulkDepositDeleted() && $ctrl.canEditBag(bagIndex)\">\n<button ng-if=\"$ctrl.isBagExpanded(bagIndex)\" class=\"btn btn-sm btn-warning\" ng-click=\"$ctrl.toggleBagCollapse(bagIndex)\" uib-tooltip=\"Close details\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n<button ng-if=\"!$ctrl.isBagExpanded(bagIndex)\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.toggleBagCollapse(bagIndex)\" uib-tooltip=\"View details\">\nEdit\n</button>\n</div>\n<div ng-if=\"bag.countCompletedAt || (bag.depositRecord && bag.depositRecord.countedAt)\" class=\"text-center\" style=\"margin-top: 8px; font-size: 11px; color: #5cb85c;\">\n<b>Committed:</b><br>\n<span>{{ (bag.countCompletedAt || (bag.depositRecord && bag.depositRecord.countedAt)) | date:'yyyy-MM-dd | h:mm a' }}</span>\n</div>\n</div>\n</td>\n</tr>\n<tr ng-repeat-end ng-if=\"(bag.status === 'counting' || bag.status === 'counted' || bag.shipmentId) && $ctrl.isBagExpanded(bagIndex)\">\n<td colspan=\"7\">\n<div class=\"panel panel-default\" style=\"margin-bottom: 0px;\">\n<div class=\"panel-body\">\n<div class=\"toggle-buttons flex-center\" style=\"gap: 5px; margin-bottom: 15px;\">\n<button ng-class=\"{'btn-success': $ctrl.showCash, 'btn-secondary': !$ctrl.showCash}\" class=\"btn\" ng-click=\"$ctrl.toggleTab('cash')\">{{ 'common.cash' | translate }}</button>\n<button ng-class=\"{'btn-success': $ctrl.showCoins, 'btn-secondary': !$ctrl.showCoins}\" class=\"btn\" ng-click=\"$ctrl.toggleTab('coin')\">{{ 'common.coin' | translate }}</button>\n<button ng-if=\"$ctrl.hasUnfitDenoms()\" ng-class=\"{'btn-success': $ctrl.showUnfit, 'btn-secondary': !$ctrl.showUnfit}\" class=\"btn\" ng-click=\"$ctrl.toggleTab('unfit')\">{{ 'denomination.unfit' | translate }}</button>\n</div>\n<div class=\"denoms-coins-table\">\n<div ng-if=\"$ctrl.showCash\" class=\"denom-section\">\n<h4>{{ 'atm_residual.cash_denoms' | translate }}</h4>\n<table class=\"table denoms-table atm-count-table\">\n<thead>\n<tr>\n<th>{{ 'common.cash' | translate }}</th>\n<th>{{ 'atm_residual.bills' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"denom in $ctrl.activeBagData.depositData.denominations | filter:$ctrl.codCashFilter track by denom.id\">\n<td class=\"face-value\">\n<img ng-if=\"denom.id !== '1'\" ng-src=\"../../assets/images/{{denom.id}}.png\" class=\"custom-icon\"/>\n<img ng-if=\"denom.id == '1'\" src=\"" + __webpack_require__(68) + "\" class=\"custom-icon\"/>\n</td>\n<td>\n<div class=\"input-group-responsive\">\n<input type=\"text\" class=\"form-control input-count\" ng-disabled=\"(bag.status === 'counted' && (!$ctrl.isBagInEditMode(bagIndex) || !$ctrl.canEditBag(bagIndex))) || $ctrl.isBulkDepositDeleted()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.activeBagDenomChange(denom.id)\" ng-model=\"denom.totalCounted\" min=\"0\" required/>\n<input type=\"text\" class=\"form-control input-value\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPattern\" ng-model=\"denom.totalValue\" min=\"0\" required fraction=\"0\" ng-currency currency-symbol=\"{{denom.symbol || $ctrl.currencySymbol}}\"/>\n</div>\n</td>\n</tr>\n<tr>\n<td></td>\n<td>\n<div class=\"total-input-wrapper\">\n<input type=\"text\" class=\"form-control total-value-input\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPattern\" ng-model=\"$ctrl.activeBagData.depositData.childTotalDeposit\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" fraction=\"0\"/>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"$ctrl.showCoins\" class=\"denom-section\">\n<h4>{{ 'atm_residual.coin_denoms' | translate }}</h4>\n<table class=\"table denoms-table atm-count-table\">\n<thead>\n<tr>\n<th>{{ 'common.coin' | translate }}</th>\n<th>{{ 'common.unit' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"denom in $ctrl.activeBagData.depositData.denominations | filter:$ctrl.codCoinFilter track by denom.id\">\n<td class=\"face-value\">\n<img ng-if=\"denom.id !== '1'\" ng-src=\"../../assets/images/{{denom.id}}.png\" class=\"custom-icon\"/>\n<img ng-if=\"denom.id == '1'\" src=\"" + __webpack_require__(68) + "\" class=\"custom-icon\"/>\n</td>\n<td>\n<div class=\"input-group-responsive\">\n<input type=\"text\" class=\"form-control input-count\" ng-disabled=\"(bag.status === 'counted' && (!$ctrl.isBagInEditMode(bagIndex) || !$ctrl.canEditBag(bagIndex))) || $ctrl.isBulkDepositDeleted()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.activeBagDenomChange(denom.id)\" ng-model=\"denom.totalCounted\" min=\"0\" required/>\n<input type=\"text\" class=\"form-control input-value\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPatternStrict\" ng-model=\"denom.totalValue\" min=\"0\" required ng-currency currency-symbol=\"{{denom.symbol || $ctrl.currencySymbol}}\"/>\n</div>\n</td>\n</tr>\n<tr>\n<td></td>\n<td>\n<div class=\"total-input-wrapper\">\n<input type=\"text\" class=\"form-control total-value-input\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPattern\" ng-model=\"$ctrl.activeBagData.depositData.coinTotalDeposit\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\"/>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"$ctrl.showUnfit && $ctrl.hasUnfitDenoms()\" class=\"denom-section\">\n<h4>{{ 'denomination.unfit_denominations' | translate }}</h4>\n<table class=\"table denoms-table atm-count-table\">\n<thead>\n<tr>\n<th>{{ 'denomination.unfit_mutilated' | translate }}</th>\n<th>{{ 'atm_deposit_packing.bills' | translate }}/{{ 'atm_deposit_packing.unit' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"denom in $ctrl.activeBagData.depositData.denominations | filter:$ctrl.codUnfitFilter track by denom.id\">\n<td class=\"face-value\">\n<img ng-if=\"denom.id !== '1'\" ng-src=\"../../assets/images/{{denom.id}}.png\" class=\"custom-icon\"/>\n<img ng-if=\"denom.id == '1'\" src=\"" + __webpack_require__(68) + "\" class=\"custom-icon\"/>\n</td>\n<td>\n<div class=\"input-group-responsive\">\n<input type=\"text\" class=\"form-control input-count\" ng-disabled=\"(bag.status === 'counted' && (!$ctrl.isBagInEditMode(bagIndex) || !$ctrl.canEditBag(bagIndex))) || $ctrl.isBulkDepositDeleted()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.activeBagDenomChange(denom.id)\" ng-model=\"denom.totalCounted\" min=\"0\" required/>\n<input type=\"text\" class=\"form-control input-value\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPatternStrict\" ng-model=\"denom.totalValue\" min=\"0\" required ng-currency currency-symbol=\"{{denom.symbol || $ctrl.currencySymbol}}\"/>\n</div>\n</td>\n</tr>\n<tr>\n<td></td>\n<td>\n<div class=\"total-input-wrapper\">\n<input type=\"text\" class=\"form-control total-value-input\" disabled=\"disabled\" ng-pattern=\"$ctrl.currencyPattern\" ng-model=\"$ctrl.activeBagData.depositData.unfitTotalDeposit\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\"/>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"text-center margin-top-20\" ng-if=\"!$ctrl.isBulkDepositDeleted()\">\n<button ng-if=\"bag.status === 'counting'\" class=\"btn btn-success\" ng-click=\"$ctrl.commitActiveBagCount()\" ng-disabled=\"$ctrl.isBulkDepositCommit \n                                                             || !$ctrl.activeBagData.depositData.totalAmount \n                                                             || !$ctrl.activeBagData.depositData.declaredTotalAmount \n                                                             || $ctrl.activeBagData.depositData.declaredTotalAmount <= 0\n                                                             || !$ctrl.pickupDate\n                                                             || !$ctrl.model.beginTime\">\n{{ 'common.commit' | translate }}\n</button>\n<div ng-if=\"bag.status === 'counted' && $ctrl.canEditBag(bagIndex)\">\n<button ng-if=\"!$ctrl.isBagInEditMode(bagIndex)\" class=\"btn btn-success\" ng-click=\"$ctrl.editBag(bagIndex)\">\n<span class=\"glyphicon glyphicon-edit\"></span>\n{{ 'common.Edit' | translate }}\n</button>\n<button ng-if=\"$ctrl.isBagInEditMode(bagIndex)\" class=\"btn btn-success\" ng-click=\"$ctrl.commitActiveBagCount()\" ng-disabled=\"$ctrl.isBulkDepositCommit \n                                                                 || $ctrl.bulkDepositCommitDisabled() \n                                                                 || !$ctrl.activeBagData.depositData.totalAmount \n                                                                 || !$ctrl.activeBagData.depositData.declaredTotalAmount \n                                                                 || $ctrl.activeBagData.depositData.declaredTotalAmount <= 0\n                                                                 || !$ctrl.pickupDate\n                                                                 || !$ctrl.model.beginTime\">\n{{ 'common.commit' | translate }}\n</button>\n<button ng-if=\"$ctrl.isBagInEditMode(bagIndex)\" class=\"btn btn-danger\" ng-click=\"$ctrl.cancelBagEdit()\">\n<span class=\"glyphicon glyphicon-remove-circle\"></span>\n{{ 'common.cancel' | translate }}\n</button>\n</div>\n<div ng-if=\"bag.status === 'counted' && !$ctrl.canEditBag(bagIndex) && !$ctrl.isBulkDepositDeleted()\" class=\"alert\" style=\"margin-top: 10px; margin-bottom: 0;\">\n<span class=\"glyphicon glyphicon-info-sign\"></span>\n<strong>{{ $ctrl.getBagEditRestrictionMessage(bagIndex) }}</strong>\n</div>\n</div>\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n<tbody ng-if=\"!$ctrl.isBulkDepositDeleted()\">\n<tr>\n<td colspan=\"7\" align=\"left\" style=\"padding: 2px;\">\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.addBulkDepositBag()\" ng-disabled=\"$ctrl.hasCountingBag() || $ctrl.isBulkDepositDeleted()\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n";
var id1="atm_count.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2642 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row text-center\">\n<div class=\"align-center-horizontally\">\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<h4>{{'atm_residual_print.title' | translate}}</h4>\n<div id=\"print-section\">\n<div class=\"col-sm-12 text-align-left margin-top-20 print-margin-top-30\">\n<strong class=\"margin-left-10\">{{'carrier.branch' | translate}}:</strong>\n<span>{{$ctrl.branchId}}</span>\n<strong ng-if=\"$ctrl.routeId\" class=\"margin-left-10\">{{'checkout.routeId' | translate}}:</strong>\n<span ng-if=\"$ctrl.routeId\">{{$ctrl.routeId}}</span>\n<strong class=\"margin-left-10\">{{'branch_mgmt.orders_selectATMs' | translate}}:</strong>\n<span>{{$ctrl.fundingSource}}</span>\n<span class=\"pull-right\" ng-if=\"$ctrl.pendingATMResidualCount.length\">\n<strong>{{'common.total' | translate}} : {{$ctrl.pendingATMResidualCount.length}}</strong>\n<strong class=\"padding-left-10\">{{'bulkCash.amount' | translate}} : {{$ctrl.amount | currency:fractionSize:0}}</strong>\n</span>\n</div>\n<div class=\"col-sm-12 margin-top-20\">\n<table class=\"table table-striped table-bordered\">\n<thead class=\"header-row\">\n<tr>\n<th class=\"text-center\">#</th>\n<th class=\"text-center\">{{'common.locationId' | translate}}</th>\n<th class=\"text-center\">{{'atm_residual.trackingId' | translate}}</th>\n<th class=\"text-center\">{{'atm_residual.orderNo' | translate}}</th>\n<th class=\"text-center\">{{'message.type' | translate}}</th>\n<th class=\"text-center\">{{'location.customer' | translate}}</th>\n<th class=\"text-center\" ng-if=\"!$ctrl.routeId\">{{'dashboard.routeId' | translate}}</th>\n<th class=\"text-center\">{{'closeVault.currentVaultDate' | translate}}</th>\n<th class=\"text-center\">{{'routeControl.messengerID' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.pendingATMResidualCount\">\n<td>{{$index + 1}}</td>\n<td>{{data.fromLocationId}}</td>\n<td>{{data.trackingId}}</td>\n<td>{{data.orderNo}}</td>\n<td>{{$ctrl.getOrderType(data.shiptype, data.orderType)}}</td>\n<td>{{data.customerId ? (data.customerId + ' | ' + data.customerName) : (data.customerName || ('common.n_a' | translate))}}</td>\n<td ng-if=\"!$ctrl.routeId\">{{data.routeId}}</td>\n<td>{{data.vaultDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td>{{data.messengerId}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>";
var id1="atm_count_print.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<form class=\"form-validate\" name=\"bagoutForm\" novalidate>\n<div class=\"row_\">\n<div class=\"align-center col-sm-12\">\n<div class=\"col-sm-4\">\n<search-and-select ng-model=\"$ctrl.model.toLocation\" values=\"$ctrl.locationList\" key=\"Key\" totalrecords=\"$ctrl.totalLocations\" onscroll=\"$ctrl.loadDeliverToLocation(searchKey, offset)\" none-selected=\"'bagout.select_destination'\" on-click=\"$ctrl.resetData(); $ctrl.getRemainingBagoutCount('bagout-id')\" required>\n</search-and-select>\n<div class=\"last-scanned-id\" ng-if=\"$ctrl.lastBagoutScanned\"></div>\n</div>\n<div class=\"col-sm-1 bagout-right-arrow\">\n<span class=\"glyphicon glyphicon-arrow-right\"></span>\n<div class=\"last-scanned-id\" ng-if=\"$ctrl.lastBagoutScanned\"></div>\n</div>\n<div class=\"col-sm-4\">\n<input id=\"bagout-id\" class=\"form-control\" type=\"text\" ng-model=\"$ctrl.model.bagout.id\" ng-keydown=\"$event.keyCode === 13 && $ctrl.loadOrAddBagouts($event);\" placeholder=\"{{'bagout.scan_bagout_id' | translate}}\" scan-type=\"'bagout'\" ng-pattern=\"/^[a-zA-Z0-9- ]*$/\" ng-disabled=\"($ctrl.bagoutScanDisable && $ctrl.loading) || ($ctrl.loadBagouts || (!$ctrl.model.toLocation))\" required>\n<div class=\"text-center alert-success last-scanned-id\" ng-if=\"$ctrl.lastBagoutScanned\">\n<span>{{'bagout.last_bagout_scan' | translate}}: <b>{{$ctrl.lastBagoutScanned.id}}</b></span>\n</div>\n</div>\n<div class=\"col-sm-2\">\n<button class=\"btn btn-success btn-block\" type=\"button\" ng-click=\"$ctrl.closePrint();\" ng-disabled=\"($ctrl.bagScanDisable) || ($ctrl.bagoutScanDisable && $ctrl.loading) || (!$ctrl.model.bagout.id) || (!$ctrl.model.toLocation)\">\n{{'bagout.closePrint' | translate}}\n</button>\n<div class=\"last-scanned-id\" ng-if=\"$ctrl.lastBagoutScanned\"></div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-10 align-center\">\n<div class=\"col-sm-4 margin-10\">\n<input id=\"bag-id\" class=\"form-control bagout-input-height\" autocomplete=\"off\" type=\"text\" ng-model=\"$ctrl.model.bag.trackingId\" ng-keydown=\"$event.keyCode === 13 && $ctrl.addBagout($event)\" placeholder=\"{{'bagout.scan_item_id' | translate}}\" ng-disabled=\"($ctrl.bagScanDisable) || (!$ctrl.model.bagout.id || !$ctrl.model.toLocation || $ctrl.loadRemainingBagouts || $ctrl.loadBagouts) || ($ctrl.bagoutScanDisable && $ctrl.loading)\" ng-pattern=\"/^[a-zA-Z0-9-$_ ]*$/\" required disable-copy-paste disable-tracking-id-typing>\n<div class=\"text-center alert-success last-scanned-id\" ng-if=\"$ctrl.lastBagScanned\">\n<span>{{'bagout.last_item_scan' | translate}}: <b>{{$ctrl.lastBagScanned.trackingId}}</b></span>\n</div>\n</div>\n<div class=\"margin-bottom-10\" ng-if=\"($ctrl.bagScanDisable) || ($ctrl.bagoutScanDisable && $ctrl.loading)\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 25px; margin-top: 3px;\"></span>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-20\">\n<div class=\"align-center card-style\">\n<div class=\"col-sm-3\">\n<div class=\"card bag-seal-info\">\n<div class=\"text-align-center font-size-50 margin-top-30\" ng-if=\"$ctrl.loadRemainingBagouts\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"cursor-pointer\" ng-if=\"!$ctrl.loadRemainingBagouts\" ng-click=\"$ctrl.getBagoutList('remainingBagout');\">\n<div class=\"text-center margin-10 font-size-30\">\n{{$ctrl.remainingBagoutInfo.remainingBagouts || 0 | currency:'':0}}\n</div>\n<div class=\"text-center margin-top-40 font-size-20\">\n{{$ctrl.remainingBagoutInfo.amount || 0 | currency:fractionSize:2}}\n</div>\n</div>\n</div>\n<div class=\"text-center font-size-20\">\n{{'routeThrow.remaining' | translate}}\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"card bag-seal-info\">\n<div class=\"text-align-center font-size-50 margin-top-30\" ng-if=\"$ctrl.loadBagouts\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"row pull-right\" ng-if=\"$ctrl.BagoutInfo.totalItems > 0\">\n<img class=\"bag-included-icon\" src=\"" + __webpack_require__(89) + "\"/>\n</div>\n<div class=\"cursor-pointer\" ng-if=\"!$ctrl.loadBagouts\" ng-click=\"$ctrl.getBagoutList('includedBagout');\">\n<div class=\"text-center margin-10 font-size-30\">\n{{$ctrl.BagoutInfo.totalItems || 0 | currency:'':0}}\n</div>\n<div class=\"text-center margin-top-40 font-size-20\">\n{{$ctrl.BagoutInfo.amount || 0 | currency:fractionSize:2}}\n</div>\n</div>\n</div>\n<div class=\"text-center font-size-20\">\n{{'bagout.included' | translate}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 align-center\">\n<div class=\"col-sm-9 bagout-scan-error text-center margin-top-30\" ng-show=\"$ctrl.lastBagScanned || $ctrl.lastBagoutScanned\" ng-class=\"{'alert-danger': $ctrl.isError === true, 'alert-success': $ctrl.isError === false}\">\n<span>\n<img src=\"" + __webpack_require__(89) + "\" class=\"scan-img\" alt=\"success\" ng-if=\"$ctrl.isError === false\">\n<img src=\"" + __webpack_require__(69) + "\" class=\"scan-img\" alt=\"error\" ng-if=\"$ctrl.isError === true\">\n</span>\n<span class=\"font-size-17\">\n<span ng-class=\"{'text-success': $ctrl.isError === false, 'text-danger': $ctrl.isError === true}\">\n<span class=\"text-align-left\">\n<strong ng-bind-html=\"$ctrl.message\"></strong>\n</span>\n<span class=\"text-align-left\" ng-if=\"$ctrl.bagScanError\">\n<strong ng-bind-html=\"$ctrl.bagScanError\"></strong>\n</span>\n<span ng-if=\"$ctrl.isError === false\" class=\"text-success text-align-left font-size-17\">\n<span>{{$ctrl.lastBagoutScanned.scannedDate}}</span>\n<span>{{$ctrl.lastBagoutScanned.scannedTime}}</span>\n</span>\n</span>\n</span>\n</div>\n</div>\n</div>\n</form>\n";
var id1="bagout.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2644 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\" style=\"text-align: center;\">\n<div class=\"col-sm-12\">\n<div>\n<h2 class=\"hide-in-print\">{{'bagout.title' | translate}}</h2>\n<div class=\"row hide-in-print\">\n<div class=\"col-sm-6 padding-zero\">\n<div class=\"col-sm-12 margin-bottom-10\">\n<button class=\"btn btn-success btn-sm pull-left\" ng-click=\"$ctrl.goToBagout()\">\n<i class=\"glyphicon glyphicon-chevron-left\"></i> {{'bagout.goToBagout' | translate}}\n</button>\n</div>\n<div class=\"col-sm-6\">\n<form>\n<input id=\"bagout-scan-id\" class=\"form-control input-lg\" type=\"text\" autocomplete=\"off\" ng-model=\"$ctrl.model.bagout.id\" ng-pattern=\"/^[a-zA-Z0-9- ]*$/\" strip-prefix on-press-enter=\"$ctrl.bagoutScanned()\" scan-type=\"'bagout'\"/>\n</form>\n</div>\n<div class=\"col-sm-12\" ng-show=\"$ctrl.model.message && $ctrl.model.isError\">\n<div class=\"col-sm-6 alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.isError}\">\n{{$ctrl.model.message}}\n</div>\n</div>\n</div>\n<div class=\"col-sm-6 padding-zero\" style=\"margin-top: 40px;\">\n<div class=\"col-sm-12\">\n<button ng-click=\"$ctrl.confirmPrint()\" ng-disabled=\"!$ctrl.isBagoutSelected || !$ctrl.model.bagout.id || $ctrl.isPutOnHold || $ctrl.isLoading\" class=\"btn btn-lg btn-success pull-right\">{{'routeSheet.print' | translate}}</button>\n<button type=\"button\" ng-if=\"$ctrl.model.bagout.shipments.length > 0\" class=\"btn btn-warning btn-lg pull-right margin-right-10\" ng-class=\"{'btn-warning': !$ctrl.model.bagout.closed}\" ng-click=\"$ctrl.closeBagout()\" ng-disabled=\"!$ctrl.model.bagout || !$ctrl.model.bagout.id || $ctrl.model.bagout.closed || !$ctrl.model.route || $ctrl.isLoading\">\n{{$ctrl.model.bagout.closed ? 'bagout.bagoutClosed' : 'bagout.closeBagout' | translate}}\n</button>\n<button ng-click=\"$ctrl.deleteBagout()\" ng-if=\"$ctrl.model.bagout.shipments.length == 0\" ng-disabled=\"!$ctrl.isBagoutSelected || !$ctrl.model.bagout.id || $ctrl.isPutOnHold || $ctrl.isLoading\" class=\"btn btn-lg btn-danger pull-right margin-right-10\">Delete Bagout</button>\n</div>\n</div>\n</div>\n<div ng-show=\"$ctrl.isBagoutSelected\" id=\"print-section\">\n<div class=\"col-sm-12 show-only-in-print pad-20\">\n<img stream-print-logo style=\"height: 85px;\">\n</div>\n<div class=\"row col-sm-12 text-align-left margin-top-20 print-header-margin\">\n<div class=\"col-sm-3 col-print-3\">\n<div>\n{{'bagout.from' | translate}}:\n</div>\n<div>\n<h3 class=\"margin-zero\">\n<strong>{{$ctrl.model.bagout.fromLocation.name}}</strong>\n</h3>\n</div>\n<div>\n<h4>{{$ctrl.model.bagout.fromLocation.address}}</h4>\n</div>\n</div>\n<div class=\"col-sm-3 col-print-3\">\n<div>\n{{'bagout.destination' | translate}}:\n</div>\n<div>\n<h3 class=\"margin-zero\">\n<strong>{{$ctrl.model.bagout.location.name}}</strong>\n</h3>\n</div>\n<div>\n<h4>{{$ctrl.model.bagout.location.address}}</h4>\n</div>\n</div>\n<div class=\"col-sm-3 col-print-3 show-only-in-print txtSize bagSealPos\">\n<strong>\n{{'bagout.bagSeal' | translate}}\n</strong>\n<div class=\"bagSealPos\">\n<h3 class=\"margin-zero\">\n<span>{{$ctrl.bagSealId}}</span>\n</h3>\n</div>\n</div>\n<div class=\"col-sm-3 col-print-3 show-only-in-print txtSize bagSealPos\">\n<div class=\"bagSealPos\">\n<h3 class=\"margin-zero\">\n<span>\n<angular-barcode ng-model=\"$ctrl.bagSealId\" bc-options=\"$ctrl.barcodeOptions\" bc-class=\"barcode\" bc-type=\"image\"></angular-barcode>\n</span>\n</h3>\n</div>\n</div>\n<div class=\"col-sm-3 hide-in-print\" ng-hide=\"!$ctrl.model.bagout || !$ctrl.model.bagout.id || $ctrl.model.bagout.closed\">\n{{'bagout.route' | translate}}:\n<ui-select ng-model=\"$ctrl.model.route\" ng-class=\"{'valid': $ctrl.model.route, 'invalid': !$ctrl.model.route}\" theme=\"bootstrap\" ng-disabled=\"$ctrl.model.gettingRoutes\">\n<ui-select-match placeholder=\"{{'routeSheet.routePlaceHolder' | translate }}\">{{$select.selected.name}}</ui-select-match>\n<ui-select-choices repeat=\"route in $ctrl.routes | filter: $select.search\">\n<div ng-bind-html=\"route.name | highlight: $select.search\"></div>\n<small ng-bind-html=\"route.shortName | highlight: $select.search\"></small>\n</ui-select-choices>\n</ui-select>\n</div>\n<div class=\"hide-in-print col-sm-3\" ng-hide=\"!$ctrl.model.bagout || !$ctrl.model.bagout.id || $ctrl.model.bagout.closed\">\n<div>\n{{'bagout.delivery' | translate}}:\n</div>\n<div class=\"form-group form-validate\">\n<datetimepicker class=\"datetimepicker-input\" ng-class=\"{'required-datetimepicker': !$ctrl.model.deliveryDate}\" ng-model=\"$ctrl.model.deliveryDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.finalVaultDate\" ng-change=\"$ctrl.dateChanged()\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 show-only-in-print bagout-details\">\n<strong ng-if=\"$ctrl.model.route.id\">\n{{ 'bagout.route' | translate }}:\n</strong>\n<span ng-if=\"$ctrl.model.route.id\">{{$ctrl.model.route.id}} | {{$ctrl.model.route.name}}</span>\n&nbsp;&nbsp;&nbsp;\n<strong>\n{{'bagout.totalBags' | translate}}:\n</strong>\n<span>{{$ctrl.model.bagout.totalBags}}</span>\n&nbsp;&nbsp;&nbsp;\n<strong>\n{{'bagout.totalAmount' | translate}}:\n</strong>\n{{$ctrl.model.bagout.totalAmount | currency: '$'}} &nbsp;&nbsp;&nbsp;\n<strong>\n({{'bagout.set_to_contain' | translate}})\n</strong>\n<strong class=\"pull-right\">\n{{ 'bagout.deliveryDate' | translate }}: {{$ctrl.vaultDate | date: 'longDate'}}\n</strong>\n</div>\n<div class=\"col-sm-12 margin-top-20\">\n<table class=\"table table-striped table-bordered table-pad-3\">\n<thead class=\"header-row\">\n<tr>\n<td>\n<strong>#</strong>\n</td>\n<td>\n<strong>{{'bagout.trackingId' | translate}}</strong>\n</td>\n<td>\n<strong>{{'bagout.fromLocationName' | translate}}</strong>\n</td>\n<td>\n<strong>{{'bagout.fromLocationId' | translate}}</strong>\n</td>\n<td>\n<strong>{{'bagout.type' | translate}}</strong>\n</td>\n<td>\n<strong>{{'bagout.amount' | translate}}</strong>\n</td>\n<td class=\"show-only-in-print\">\n<strong>{{'bagout.verify' | translate}}</strong>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"bag in $ctrl.model.bagout.shipments | orderBy : 'trackingId' \">\n<td>{{$index+1}}</td>\n<td>{{bag.trackingId }}</td>\n<td>{{bag.fromLocation.name}}</td>\n<td>{{bag.fromLocation.id}}</td>\n<td>{{bag.shiptypeId}}</td>\n<td>{{bag.amount | currency:'$'}}</td>\n<td class=\"show-only-in-print\">&nbsp;</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"show-only-in-print\">\n<div class=\"signPos\">\n<span class=\"bagout-contents\">{{ 'bagout.userContent' | translate }}</span>\n</div>\n<div class=\"col-print-12 signPos bagout-contents\">\n<div class=\"col-print-4 textPoss bagout-contents\">\n<span>{{ 'bagout.fullName' | translate }}: <span class=\"lineColor\">__________________________</span>\n</span></div>\n<div class=\"col-print-4 textPoss bagout-contents\">\n<span>|&nbsp;{{'bagout.userSignature' | translate}}: <span class=\"lineColor\">_________________________</span>&nbsp;</span>\n</div>\n<div class=\"col-print-4 textPoss bagout-contents\">\n<span>|&nbsp;{{ 'bagout.cntDate' | translate }}: <span class=\"lineColor\">___________________________</span></span>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="bagout-print.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2645 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'batch.all_batches' | translate}}\n</h4>\n</div>\n<div class=\"navbar-form navbar-left remove-left-pad\">\n<button id=\"filter-by\" type=\"button\" class=\"btn btn-xs margin-top-06\" ng-class=\"{'btn-default': $ctrl.filterByValue !== 'all', 'btn-success': $ctrl.filterByValue === 'all'}\" ng-click=\"$ctrl.filterByBranch('all')\">\n{{'common.All' | translate}}\n</button>\n</div>\n<div class=\"col-sm-1 remove-left-pad settings-batch-loader\">\n<span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" ng-click=\"$ctrl.search()\" class=\"btn btn-default\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'batch.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.batches && $ctrl.batches.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"batch in $ctrl.batches track by $index\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{batch.batchSource.id + ' | ' + batch.batchSource.name + ' | ' + batch.inputType}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(batch)\" uib-tooltip=\"{{ 'batch.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"batch.expand\">\n<div class=\"col-sm-12\">\n<hr/>\n<div>\nExtra details here\n<br>\n<br>\n<br>\n<br> Extra Details\n</div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-model=\"$ctrl.page\" items-per-page=\"$ctrl.pageLimit\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div class=\"alert alert-danger text-center\" ng-if=\"(!$ctrl.batches || !$ctrl.batches.length) && !$ctrl.loading\">\n<span>{{'batch.noBatches' | translate}}</span>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-model=\"$ctrl.page\" items-per-page=\"$ctrl.pageLimit\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>";
var id1="batch.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2646 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ng-click=\"$ctrl.goToAll()\" ui-sref=\"batch.all\">\n<a translate=\"batch.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"batch.create\">\n<a translate=\"batch.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n<ui-view>\n</ui-view></ui-view></div>\n</div>\n</div>";
var id1="batch.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2647 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"batch.create_batch\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{ 'batch.tooltip_info' | translate }}\" tooltip-placement=\"top\"></span>\n<label for=\"location\">{{'batch.location' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.batchSourceId\" key=\"Key\" values=\"$ctrl.locations\" onscroll=\"$ctrl.getAllLocation(searchKey, offset)\" totalrecords=\"$ctrl.totalLocationRecords\" none-selected=\"'common.select'\" hide-count=\"true\" is-change-offset=\"$ctrl.changeOffsetFlag\" is-change-offset-value=\"$ctrl.offset\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"input-type\">{{'batch.inputType' | translate}} *</label>\n<select class=\"form-control\" id=\"input-type\" ng-options=\"inputType for inputType in $ctrl.inputTypes\" ng-model=\"$ctrl.model.inputType\" ng-disabled=\"!$ctrl.model.batchSourceId\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<textarea name=\"\" placeholder=\"{{'common.description' | translate}}\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"$ctrl.model.description\"></textarea>\n</div>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</form>\n</div>";
var id1="batch.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2648 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"batch.edit_batch\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{ 'batch.tooltip_info' | translate }}\" tooltip-placement=\"top\"></span>\n<label for=\"location\">{{'batch.location' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.batchName\" disabled=\"disabled\"/>\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"input-type\">{{'batch.inputType' | translate}} *</label>\n<select class=\"form-control\" id=\"input-type\" ng-options=\"inputType for inputType in $ctrl.inputTypes\" ng-model=\"$ctrl.model.inputType\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<textarea name=\"\" placeholder=\"{{'common.description' | translate}}\" cols=\"30\" rows=\"5\" class=\"form-control\" ng-model=\"$ctrl.model.description\"></textarea>\n</div>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</form>\n</div>";
var id1="batch.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2649 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'branch.all_branches' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'branch.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.branches && $ctrl.branches.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"branch in $ctrl.branches track by branch.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{branch.id}} | {{branch.description}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(branch)\" uib-tooltip=\"{{ 'branch.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"branch.expand\">\n<div class=\"col-sm-12\">\n<hr/>\n<div>\nExtra details here\n<br>\n<br>\n<br>\n<br> Extra Details\n</div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.branches || !$ctrl.branches.length) && !$ctrl.loading\">\n<span>{{'branch.noBranches' | translate}}</span>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>";
var id1="branch.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2650 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"branch.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"branch.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"branch.create\">\n<a translate=\"branch.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="branch.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2651 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n<div class=\"row\">\n<div ng-class=\"{'col-sm-4': $ctrl.branch, 'col-sm-6': !$ctrl.branch}\">\n<div class=\"form-group\">\n<label for=\"window-id\">{{'common.id' | translate}} *</label>\n<input ng-disabled=\"$ctrl.isEditing && $ctrl.model.branchId\" ng-change=\"$ctrl.valueChanged()\" id=\"window-id\" type=\"text\" ng-model=\"$ctrl.model.id\" class=\"form-control\" required>\n</div>\n</div>\n<div class=\"col-sm-4\" ng-if=\"$ctrl.branch\">\n<div class=\"form-group\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"Show data of location type WINDOW\" tooltip-placement=\"top\"></span>\n<label for=\"window-id\">{{'window.location' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.locationId\" ng-change=\"$ctrl.valueChanged()\" ng-options=\"location.id as (location.id + ' | ' + location.name) for location in $ctrl.locations\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div ng-class=\"{'col-sm-2': $ctrl.branch, 'col-sm-3': !$ctrl.branch}\">\n<div class=\"form-group\">\n<label for=\"window-checkin-type\">{{'window.allowCash' | translate}}</label>\n<br/>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.allowCash\" ng-change=\"$ctrl.valueChanged()\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div ng-class=\"{'col-sm-2': $ctrl.branch, 'col-sm-3': !$ctrl.branch}\">\n<div class=\"form-group\">\n<label for=\"window-checkin-type\">{{'window.allowCoin' | translate}}</label>\n<br/>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.allowCoin\" ng-change=\"$ctrl.valueChanged()\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}} *</label>\n<textarea ng-change=\"$ctrl.valueChanged()\" required id=\"description\" cols=\"30\" rows=\"5\" ng-model=\"$ctrl.model.description\" class=\"form-control\"></textarea>\n</div>\n</div>\n</div>\n</div>";
var id1="window.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2652 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"branch.create_branch\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"form-group\">\n<label for=\"exampleInputEmail1\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" id=\"exampleInputEmail1\" required placeholder=\"\" ng-model=\"$ctrl.model.id\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group\">\n<label for=\"exampleInputPassword1\">{{'common.description' | translate }} *</label>\n<textarea class=\"form-control\" rows=\"3\" required ng-model=\"$ctrl.model.description\"></textarea>\n<span ng-if=\"$ctrl.errors.description\" class=\"text-danger\">{{$ctrl.errors['description']}}</span>\n</div>\n<div class=\"form-group\">\n<label>Business Days</label>\n<div class=\"btn-group btn-group-justified\" id=\"businessDays\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.businessDays\" ng-click=\"$ctrl.toggleDay(day)\" ng-class=\"{'btn-primary': $ctrl.isDaySelected(day), 'btn-default': !$ctrl.isDaySelected(day)}\">\n{{day.label}}\n</a>\n</div>\n</div>\n<div class=\"form-group row\">\n<h4 class=\"col-sm-2\">{{'branch.windows' | translate }}</h4>\n<div class=\"col-sm-10\">\n<div class=\"pull-right\">\n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.addWindow()\">{{'window.addwindow' | translate}}</button>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-show=\"$ctrl.model.windows.length\">\n<div class=\"list-group\">\n<div class=\"list-group-item\" ng-repeat=\"window in $ctrl.model.windows\">\n<div class=\"display-flex pull-right\">\n<div class=\"margin-right-10\">\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.toggleExpand(window)\">\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-plus': !window.expand, 'glyphicon-minus': window.expand}\"></span>\n</button>\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.deleteWindow($index)\" uib-tooltip=\"{{'branch.tooltip_window_delete' | translate }}\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n<div class=\"list-group-item-text\">\n<h4 class=\"wrap-text\">{{window.id || '&nbsp;'}}</h4>\n</div>\n<div ng-show=\"window.expand\">\n<hr>\n<window ng-model=\"window\" is-editing=\"false\"></window>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<div class=\"row col-sm-12 margin-bottom-10\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"reset\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>\n";
var id1="branch.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2653 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"branch.edit_branch\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"form-group\">\n<label for=\"id\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" id=\"id\" placeholder=\"\" ng-model=\"$ctrl.model.id\" disabled=\"\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate }} *</label>\n<textarea class=\"form-control\" rows=\"3\" id=\"description\" ng-model=\"$ctrl.model.description\" required></textarea>\n<span ng-if=\"$ctrl.errors.description\" class=\"text-danger\">{{$ctrl.errors['description']}}</span>\n</div>\n<div class=\"form-group\">\n<label>Business Days</label>\n<div class=\"btn-group btn-group-justified\" id=\"businessDays\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.businessDays\" ng-click=\"$ctrl.toggleDay(day)\" ng-class=\"{'btn-primary': $ctrl.isDaySelected(day), 'btn-default': !$ctrl.isDaySelected(day)}\">\n{{day.label}}\n</a>\n</div>\n</div>\n<div class=\"form-group row\">\n<h4 class=\"col-sm-2\">{{'branch.windows' | translate }}</h4>\n<div class=\"col-sm-10\">\n<div class=\"pull-right\">\n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.addWindow()\">{{'window.addwindow' | translate}}</button>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-show=\"$ctrl.model.windows.length\">\n<div class=\"list-group\">\n<div class=\"list-group-item\" ng-repeat=\"window in $ctrl.model.windows\">\n<div class=\"display-flex pull-right\">\n<div class=\"margin-right-10\">\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.toggleExpand(window)\">\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-plus': !window.expand, 'glyphicon-minus': window.expand}\"></span>\n</button>\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" ng-if=\"window.expand\" class=\"btn btn-primary\" ng-click=\"$ctrl.saveWindow($index)\" uib-tooltip=\"{{'branch.tooltip_window_save' | translate }}\" ng-disabled=\"!window.id || !window.locationId || !window.description\">\n<span class=\"glyphicon glyphicon-floppy-disk\"></span>\n</button>\n</div>\n</div>\n<div class=\"list-group-item-text\">\n<h4 class=\"wrap-text\">{{window.id || '&nbsp;'}}</h4>\n</div>\n<div ng-show=\"window.expand\">\n<hr>\n<window ng-model=\"window\" branch=\"$ctrl.model.id\"></window>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<div class=\"row col-sm-12 margin-bottom-10\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>\n";
var id1="branch.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2654 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'branchFundingSource.all_branchFundingSource' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.branchFundingSourceData && $ctrl.branchFundingSourceData.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"branchFundingSource in $ctrl.branchFundingSourceData track by branchFundingSource.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{branchFundingSource.id}} | {{branchFundingSource.sourceName}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(branchFundingSource)\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.branchFundingSourceData || !$ctrl.branchFundingSourceData.length) && !$ctrl.loading\">\n{{'branchFundingSource.noData' | translate}}\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>";
var id1="branch_funding_source.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2655 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"branch-funding-source.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"branchFundingSource.menu_all_title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"branch-funding-source.create\">\n<a translate=\"branchFundingSource.menu_create_title\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="branch_funding_source.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2656 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"\">{{'branchFundingSource.new_funding' | translate}}</h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"form-group col-sm-6\">\n<label for=\"branchFundingSourceName\">{{'branchFundingSource.sourceName'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"branchFundingSourceName\" placeholder=\"\" ng-model=\"$ctrl.model.sourceName\">\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"shiptypeId\">{{'branchFundingSource.shiptype' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.shiptypeId\" values=\"$ctrl.shiptypeList\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" onscroll=\"$ctrl.loadshiptype(searchKey, offset)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"row bfs-create-d-flex\">\n<div class=\"form-group col-sm-6\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_info' | translate }}\" tooltip-placement=\"top\"></span>\n<label for=\"locationId\">{{'branchFundingSource.location' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.locationId\" values=\"$ctrl.locationList\" key=\"Key\" totalrecords=\"$ctrl.totalRecord\" onscroll=\"$ctrl.loadLocations(searchKey, offset)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div class=\"form-group\" ng-show=\"$ctrl.model.residualDeposit\" ng-class=\"{'col-sm-6': $ctrl.model.residualDeposit && !$ctrl.model.multiDenomPack, 'col-sm-3': $ctrl.model.residualDeposit && $ctrl.model.multiDenomPack}\">\n<label for=\"maxResidualDeposit\" class=\"font-12\">{{'branchFundingSource.maxDeposit'| translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"maxResidualDeposit\" placeholder=\"$0.00\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"$ctrl.model.maxResidualDeposit\">\n</div>\n<div class=\"form-group\" ng-show=\"$ctrl.model.multiDenomPack\" ng-class=\"{'col-sm-6': !$ctrl.model.residualDeposit && $ctrl.model.multiDenomPack, 'col-sm-3': $ctrl.model.residualDeposit && $ctrl.model.multiDenomPack}\">\n<label for=\"multiDenomBillLimit\" class=\"font-12\">{{'branchFundingSource.multi_denom_bill_limit'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"multiDenomBillLimit\" ng-currency currency-symbol=\"\" fraction=\"0\" hide-zero min=\"1\" ng-required=\"$ctrl.model.multiDenomPack\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"$ctrl.model.multiDenomBillLimit\">\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"branchFundingpocEmail\">{{'location.pocEmail' | translate }}</label>\n<input type=\"text\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\" class=\"form-control\" id=\"branchFundingpocEmail\" placeholder=\"\" ng-model=\"$ctrl.model.pocEmail\">\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"shiptypeId\">{{'setup.currency' | translate}} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.currencyId\" ng-change=\"$ctrl.onCurrencyChange()\" ng-options=\"currency.id as (currency.id + ' | ' + currency.name) for currency in $ctrl.currencyData\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'|translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-2\">\n<label for=\"averageBalanceFee\" class=\"font-12\">\n{{'branchFundingSource.averageBalanceFee' | translate}}\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.averageBalanceFee\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-2\" ng-if=\"$ctrl.model.averageBalanceFee\">\n<label for=\"contractedRate\" class=\"font-12\">{{'branchFundingSource.contractedRate'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"contractedRate\" placeholder=\"$0.00\" ng-model=\"$ctrl.model.contractedRate\" ng-currency fraction=\"6\" ng-required=\"$ctrl.model.averageBalanceFee\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-padding remove-right-pad\">\n<div class=\"header-section h4\"><label>{{'setup.operationsControl' | translate}}</label></div>\n<hr class=\"funding-source-line-section\">\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex justify-space-between\">\n<div class=\"form-group custome-width-15\">\n<label for=\"manualDeposit\" class=\"font-12\">\n{{'branchFundingSource.deposit_model' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{$ctrl.model.residualDeposit ? ('branchFundingSource.deposit_model_residual_info' | translate) : ('branchFundingSource.deposit_model_manual_info' | translate)}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.residualDeposit\" switch-size=\"small\" switch-on-text=\"{{'branchFundingSource.counted' | translate}}\" switch-off-text=\"{{'branchFundingSource.inventory' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.validateManualDeposit(); $ctrl.resetDeposit();\"/>\n<span ng-if=\"$ctrl.errors.residualDeposit\" class=\"text-danger\">{{$ctrl.errors['residualDeposit']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-hide=\"true\">\n<label for=\"residualDeposit\" class=\"font-12\">{{'branchFundingSource.residual_deposit' | translate }}\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.manualDeposit\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.validateResidualDeposit(); $ctrl.resetDeposit();\"/>\n<span ng-if=\"$ctrl.errors.manualDeposit\" class=\"text-danger\">{{$ctrl.errors['residualDeposit']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"enforceBalanceCheckOnVaultClose\" class=\"font-12\">\n{{'branchFundingSource.daily_cash_count' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.daily_cash_count_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.enforceBalanceCheckOnVaultClose\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.enforceBalanceCheckOnVaultClose\" class=\"text-danger\">{{$ctrl.errors['enforceBalanceCheckOnVaultClose']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"partialECDeposit\" class=\"font-12\">\n{{'branchFundingSource.partial_EC_deposit' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.partial_EC_deposit_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.partialECDeposit\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.partialECDeposit\" class=\"text-danger\">{{$ctrl.errors['partialECDeposit']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"editCountAnytime\" class=\"font-12\">\n{{'branchFundingSource.edit_count_anytime' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.edit_count_anytime_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<div ng-class=\"{'disabled': !$ctrl.model.editCountAnytime}\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.editCountAnytime\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-disabled=\"!$ctrl.model.editCountAnytime\"/>\n</div>\n<span ng-if=\"$ctrl.errors.editCountAnytime\" class=\"text-danger\">{{$ctrl.errors['editCountAnytime']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"manualDeposit\" class=\"font-12\">\n{{'branchFundingSource.enable_bank_report' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.enable_bank_report_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.enableBankReport\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetBankReportData();\"/>\n<span ng-if=\"$ctrl.errors.enableBankReport\" class=\"text-danger\">{{$ctrl.errors['enableBankReport']}}</span>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex justify-space-between\">\n<div class=\"form-group custome-width-15\">\n<label for=\"enableOrderMgmt\" class=\"font-12\">\n{{'branchFundingSource.order_management' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.enableOrderMgmt\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetOrderMgmt();\"/>\n<span ng-if=\"$ctrl.errors.enableOrderMgmt\" class=\"text-danger\">{{$ctrl.errors['enableOrderMgmt']}}</span>\n</div>\n<div class=\"form-group custome-width-16\">\n<label for=\"enableVaultReport\" class=\"font-12\">\n{{'branchFundingSource.enable_vault_report' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.enable_vault_report_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.enableVaultReport\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetBankReportData();\"/>\n<span ng-if=\"$ctrl.errors.enableVaultReport\" class=\"text-danger\">{{$ctrl.errors['enableVaultReport']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"deliveryReport\" class=\"font-12\">\n{{'branchFundingSource.delivery_report' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.delivery_report_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.deliveryReport\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.deliveryReport\" class=\"text-danger\">{{$ctrl.errors['deliveryReport']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"editAmount\" class=\"font-12\">\n{{'branchFundingSource.edit_amount' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.edit_amount_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.editAmount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.editAmount\" class=\"text-danger\">{{$ctrl.errors['editAmount']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"requireCountCommit\" class=\"font-12 remove-white-space\">\n{{'branchFundingSource.require_count_commit' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"Control that makes the Final Residual Count Commit required for Vault Close.\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireCountCommit\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex\" ng-class=\"{'justify-space-between': $ctrl.model.autoOrdering, 'bfs-toggle-section':  !$ctrl.model.autoOrdering}\">\n<div class=\"form-group custome-width-15\">\n<label for=\"autoOrdering\" class=\"font-12\">\n{{'branchFundingSource.auto_ordering' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.auto_ordering_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoOrdering\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetAutoOrderingData();\"/>\n<span ng-if=\"$ctrl.errors.autoOrdering\" class=\"text-danger\">{{$ctrl.errors['autoOrdering']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"$ctrl.model.autoOrdering\">\n<label for=\"networkData\" class=\"font-12\">\n{{'branchFundingSource.network_data' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.networkData\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.networkData\" class=\"text-danger\">{{$ctrl.errors['networkData']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"$ctrl.model.autoOrdering\">\n<label for=\"autoReconcile\" class=\"font-12\">\n{{'branchFundingSource.auto_reconcile' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoReconcile\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoReconcile\" class=\"text-danger\">{{$ctrl.errors['autoReconcile']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"$ctrl.model.autoOrdering\">\n<label for=\"allowECLoad\" class=\"font-12\">\n{{'branchFundingSource.allow_ec_load' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.allowECLoad\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n<span ng-if=\"$ctrl.errors.allowECLoad\" class=\"text-danger\">{{$ctrl.errors['allowECLoad']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"enforceStraps\" class=\"font-12\">\n{{'branchFundingSource.enforce_straps' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.enforce_straps_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.enforceStraps\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n<span ng-if=\"$ctrl.errors.enforceStraps\" class=\"text-danger\">{{$ctrl.errors['enforceStraps']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"!$ctrl.model.autoOrdering\">\n<label for=\"multiDenomPack\" class=\"font-12\">\n{{'branchFundingSource.multi_denom_pack' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.multi_denom_pack_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.multiDenomPack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n<span ng-if=\"$ctrl.errors.multiDenomPack\" class=\"text-danger\">{{$ctrl.errors['multiDenomPack']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"!$ctrl.model.autoOrdering\">\n<label for=\"atmForcasting\" class=\"font-12\">\n{{'branchFundingSource.atmForecasting' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.atmForecasting_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.atmForecasting\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"!$ctrl.model.autoOrdering\">\n<label for=\"varianceCheckEnabled\" class=\"font-12\">\n{{'branchFundingSource.variance' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.variance_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.varianceCheckEnabled\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"!$ctrl.model.autoOrdering\">\n<div class=\"col-sm-12 d-flex bfs-toggle-section\">\n<div class=\"form-group remove-left-pad custome-width-15 _col-sm-3\" ng-show=\"$ctrl.model.varianceCheckEnabled\">\n<label for=\"varianceThreshold\" class=\"font-12\">\n{{'branchFundingSource.threshold'| translate}}</label>\n<input type=\"text\" class=\"form-control\" ng-required=\"$ctrl.model.varianceCheckEnabled\" id=\"varianceThreshold\" placeholder=\"\" ng-model=\"$ctrl.model.varianceThreshold\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n</div>\n<div class=\"form-group\">\n<label for=\"autoCreateShipments\" class=\"font-12 remove-white-space\">\n{{'branchFundingSource.auto_create_shipments' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.auto_create_shipments_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoCreateShipments\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group\">\n<label for=\"bagoutForCount\" class=\"font-12 remove-white-space\">{{'branchFundingSource.bagout_for_count' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bagoutForCount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"inventoryBulkCoin\" class=\"font-12 remove-white-space\">{{'branchFundingSource.inventory_bulk_coin' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.inventoryBulkCoin\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"debitBulkCoinOnPack\" class=\"font-12 remove-white-space\">{{'branchFundingSource.debit_bulk_coin_on_pack' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.debitBulkCoinOnPack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.model.autoOrdering\">\n<div class=\"d-flex bfs-toggle-section col-sm-12\">\n<div class=\"form-group custome-width-15\">\n<label for=\"multiDenomPack\" class=\"font-12\">{{'branchFundingSource.multi_denom_pack' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.multi_denom_pack_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.multiDenomPack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<span ng-if=\"$ctrl.errors.multiDenomPack\" class=\"text-danger\">{{$ctrl.errors['multiDenomPack']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"atmForcasting\" class=\"font-12\">{{'branchFundingSource.atmForecasting' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.atmForecasting_info' | translate}}\" tooltip-placement=\"top\"></span></label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.atmForecasting\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"varianceCheckEnabled\" class=\"font-12\">{{'branchFundingSource.variance' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.variance_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.varianceCheckEnabled\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"_form-group custome-width-15\" ng-show=\"$ctrl.model.varianceCheckEnabled\">\n<label for=\"varianceThreshold\" class=\"font-12\">\n{{'branchFundingSource.threshold'| translate}}\n</label>\n<input type=\"text\" class=\"form-control\" ng-required=\"$ctrl.model.varianceCheckEnabled\" id=\"varianceThreshold\" placeholder=\"\" ng-model=\"$ctrl.model.varianceThreshold\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"autoCreateShipments\" class=\"font-12 remove-white-space\">{{'branchFundingSource.auto_create_shipments' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.auto_create_shipments_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoCreateShipments\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group\" ng-if=\"!$ctrl.model.varianceCheckEnabled\">\n<label for=\"bagoutForCount\" class=\"font-12 remove-white-space\">{{'branchFundingSource.bagout_for_count' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"Scan of bag to verify possession of all bags in bagout.\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bagoutForCount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n</div>\n<div class=\"d-flex bfs-toggle-section col-sm-12\" ng-if=\"$ctrl.model.varianceCheckEnabled\">\n<div class=\"form-group custome-width-15\">\n<label for=\"bagoutForCount\" class=\"font-12 remove-white-space\">{{'branchFundingSource.bagout_for_count' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.bagout_for_count_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bagoutForCount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"inventoryBulkCoin\" class=\"font-12 remove-white-space\">{{'branchFundingSource.inventory_bulk_coin' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.inventoryBulkCoin\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"debitBulkCoinOnPack\" class=\"font-12 remove-white-space\">{{'branchFundingSource.debit_bulk_coin_on_pack' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.debitBulkCoinOnPack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n</div>\n</div>\n<div class=\"d-flex bfs-toggle-section col-sm-12\" ng-if=\"$ctrl.model.autoOrdering && !$ctrl.model.varianceCheckEnabled\" style=\"margin-left: -15px; margin-right: -15px\">\n<div class=\"form-group\">\n<label for=\"inventoryBulkCoin\" class=\"font-12 remove-white-space\">{{'branchFundingSource.inventory_bulk_coin' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.inventoryBulkCoin\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group\">\n<label for=\"debitBulkCoinOnPack\" class=\"font-12 remove-white-space\">{{'branchFundingSource.debit_bulk_coin_on_pack' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.debitBulkCoinOnPack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<hr class=\"funding-source-line-section\">\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex bfs-toggle-section\">\n<div class=\"form-group custome-width-15\">\n<label for=\"customerOrderLeadTime\" class=\"font-12 remove-white-space\">{{'branchFundingSource.customer_order_lead_time' | translate}}</label>\n<div class=\"margin-top-02 lead-time-control\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.customerOrderLeadTime\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetCustomerOrderLeadData()\">\n</div>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"$ctrl.model.customerOrderLeadTime\">\n<label for=\"orderLeadDays\" class=\"font-12 remove-white-space\">{{'branchFundingSource.order_lead_days' | translate}}</label>\n<div class=\"margin-top-02 lead-time-control\">\n<input type=\"number\" class=\"form-control textbox-custom\" id=\"orderLeadDays\" onwheel=\"event.preventDefault()\" placeholder=\"Days\" min=\"1\" step=\"1\" ng-model=\"$ctrl.model.orderLeadDays\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-required=\"$ctrl.model.customerOrderLeadTime\">\n</div>\n</div>\n<div class=\"form-group custome-width-15 lead-time-cutoff-field\" ng-if=\"$ctrl.model.customerOrderLeadTime\">\n<label for=\"orderLeadCutoff\" class=\"font-12 remove-white-space\">{{'branchFundingSource.order_lead_cutoff' | translate}}</label>\n<div class=\"margin-top-02 lead-time-control\" style=\"width: 100%;\">\n<br>\n<time-picker ng-model=\"$ctrl.model.orderLeadCutoff\" style=\"display: block; height: 34px;\" ng-required=\"$ctrl.model.customerOrderLeadTime\"></time-picker>\n</div>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"allowAmount\" class=\"font-12\">\n{{'branchFundingSource.allow_amount' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.allow_amount_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.allowAmount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.allowAmount\" class=\"text-danger\">{{$ctrl.errors['allowAmount']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"adHocDeposit\" class=\"font-12\">\n{{'branchFundingSource.ad_hoc_deposit' | translate}}\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.adHocDeposit\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.adHocDeposit\" class=\"text-danger\">{{$ctrl.errors['adHocDeposit']}}</span>\n</div>\n</div>\n</div>\n<hr class=\"funding-source-line-section\">\n<div class=\"col-sm-12 remove-left-padding remove-right-pad margin-top-05 bfs-ach-model-section\">\n<div class=\"header-section h4\">\n<label>{{'branchFundingSource.ach_model' | translate}}</label>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex bfs-ach-toggle-row\" style=\"flex-wrap: wrap; column-gap: 50px;\" ng-class=\"{'bfs-ach-all-off': !($ctrl.model.customerACH || $ctrl.model.bankOrder || $ctrl.model.autoSendAccounting || $ctrl.model.autoSendCustomerCount || $ctrl.model.autoSendCustomerACH)}\">\n<div class=\"d-flex bfs-ach-toggle-group\" style=\"flex-wrap: wrap; gap: 30px;\">\n<div class=\"form-group bfs-ach-toggle-width\">\n<label for=\"customerAch\" class=\"font-12 remove-white-space\">{{'branchFundingSource.customer_ach' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.customerACH\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetCustomerAchData()\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.customerACH\">\n<label for=\"achOrderLeadDays\" class=\"font-12\">{{'branchFundingSource.order_lead_days' | translate}}</label>\n<input type=\"number\" class=\"form-control\" id=\"achOrderLeadDays\" placeholder=\"Days\" min=\"1\" step=\"1\" ng-model=\"$ctrl.model.customerACHOrderLeadDays\" onwheel=\"event.preventDefault()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-required=\"$ctrl.model.customerACH\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.customerACH\">\n<label for=\"achCountSettlementDays\" class=\"font-12\">{{'branchFundingSource.count_settlement_days' | translate}}</label>\n<input type=\"number\" class=\"form-control\" id=\"achCountSettlementDays\" placeholder=\"Days\" min=\"1\" step=\"1\" ng-model=\"$ctrl.model.customerACHSettlementDays\" onwheel=\"event.preventDefault()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-required=\"$ctrl.model.customerACH\">\n</div>\n</div>\n<div class=\"d-flex bfs-ach-toggle-group\" style=\"flex-wrap: wrap; gap: 30px;\">\n<div class=\"form-group bfs-ach-toggle-width\">\n<label for=\"bankOrder\" class=\"font-12 remove-white-space\">{{'branchFundingSource.bank_order' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bankOrder\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetBankOrderData()\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.bankOrder\">\n<label for=\"bankOrderLeadDays\" class=\"font-12\">{{'branchFundingSource.order_lead_days' | translate}}</label>\n<input type=\"number\" class=\"form-control\" id=\"bankOrderLeadDays\" placeholder=\"Days\" min=\"1\" step=\"1\" ng-model=\"$ctrl.model.bankOrderLeadDays\" onwheel=\"event.preventDefault()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-required=\"$ctrl.model.bankOrder\">\n</div>\n</div>\n<div class=\"d-flex bfs-ach-toggle-group\" style=\"flex-wrap: wrap; gap: 30px;\">\n<div class=\"form-group bfs-ach-toggle-width\">\n<label for=\"achSendAccounting\" class=\"font-12 remove-white-space\">{{'branchFundingSource.auto_send_accounting' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoSendAccounting\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetAchSendAccountingData()\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.autoSendAccounting\">\n<label for=\"achSendAccountingTime\" class=\"font-12\">{{'branchFundingSource.auto_send_accounting_time' | translate}}</label>\n<time-picker ng-model=\"$ctrl.model.autoSendAccountingTime\" style=\"display: block; height: 34px;\" ng-required=\"$ctrl.model.autoSendAccounting\"></time-picker>\n</div>\n<div class=\"form-group bfs-ach-email-width\" ng-if=\"$ctrl.model.autoSendAccounting\">\n<label for=\"achSendAccountingEmails\" class=\"font-12\">{{'branchFundingSource.emails' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"achSendAccountingEmails\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\" ng-model=\"$ctrl.model.autoSendAccountingEmails\" ng-required=\"$ctrl.model.autoSendAccounting\">\n</div>\n</div>\n<div class=\"d-flex bfs-ach-toggle-group\" style=\"flex-wrap: wrap; gap: 30px;\">\n<div class=\"form-group bfs-ach-toggle-width\">\n<label for=\"autoSendCustCount\" class=\"font-12 remove-white-space\">{{'branchFundingSource.auto_send_cust_count' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoSendCustomerCount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetAutoSendCustCountData()\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.autoSendCustomerCount\">\n<label for=\"autoSendCustCountTime\" class=\"font-12\">{{'branchFundingSource.auto_send_cust_count_time' | translate}}</label>\n<time-picker ng-model=\"$ctrl.model.autoSendCustomerCountTime\" style=\"display: block; height: 34px;\" ng-required=\"$ctrl.model.autoSendCustomerCount\"></time-picker>\n</div>\n</div>\n<div class=\"d-flex bfs-ach-toggle-group\" style=\"flex-wrap: wrap; gap: 30px;\">\n<div class=\"form-group bfs-ach-toggle-width\">\n<label for=\"autoSendCustACH\" class=\"font-12 remove-white-space\">{{'branchFundingSource.auto_send_cust_ach' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoSendCustomerACH\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetAutoSendCustACHData()\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.autoSendCustomerACH\">\n<label for=\"autoSendCustACHTime\" class=\"font-12\">{{'branchFundingSource.auto_send_cust_ach_time' | translate}}</label>\n<time-picker ng-model=\"$ctrl.model.autoSendCustomerACHTime\" style=\"display: block; height: 34px;\" ng-required=\"$ctrl.model.autoSendCustomerACH\"></time-picker>\n</div>\n</div>\n</div>\n</div>\n<div class=\"form-group remove-left-padding remove-right-pad col-sm-12 margin-top-05\">\n<div>\n<label for=\"businessDays\">{{'branchFundingSource.business_days' | translate }}</label>\n</div>\n<div id=\"businessDays\" class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.businessDays\" ng-click=\"$ctrl.toggleDay(day)\" ng-class=\"{'btn-primary': $ctrl.isDaySelected(day),'btn-default': !$ctrl.isDaySelected(day)}\">\n{{day.label}}\n</a>\n</div>\n</div>\n<hr class=\"funding-source-line-section\">\n</div>\n<div class=\"_form-group remove-left-padding remove-right-pad col-sm-12 margin-top-05\">\n<div class=\"header-section h4\">\n<label>{{'orderPacking.denominations' | translate}}</label>\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.branchFundingSourceDenominationsModal()\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'common.add' | translate}}\n</button>\n<div class=\"pull-right bfs-exp-residual-toggle\">\n<label for=\"expectedResidual\" class=\"font-12\">{{'branchFundingSource.expected_residual' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.expected_residual_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<input type=\"checkbox\" bs-switch id=\"expectedResidual\" ng-model=\"$ctrl.model.expectedResidual\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n</div>\n<hr class=\"funding-source-line-section\" ng-if=\"$ctrl.model.denominations.length > 0\">\n<div class=\"row\">\n<div class=\"col-sm-12 text-align-center\" ng-if=\"$ctrl.isLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 text-align-center remove-pad\" ng-if=\"!$ctrl.isLoading\">\n<div class=\"card _card-margin bfs-denom-card-section\" ng-repeat=\"(key, val) in $ctrl.model.denominations\">\n<div class=\"denomination-key-section\" ng-if=\"val.length > 0\">{{key}}</div>\n<div class=\"card _card-margin bfs-denom-card-section\" ng-repeat=\"denom in val\" ng-if=\"val.length > 0\">\n<span type=\"button\" ng-click=\"$ctrl.removeDenomination(key, $index)\" class=\"text-danger cursor-pointer\">\n<span class=\"glyphicon glyphicon-remove-circle\"></span>\n</span>\n<div class=\"_card-body icon-height-50 col-sm-12 padding-10\" ng-if=\"denom.isIconExists\">\n<img ng-src=\"assets/images/{{denom.id}}.png\" class=\"custom-icon img-width\">\n</div>\n<div class=\"_card-body icon-height-50 col-sm-12 padding-15\" ng-if=\"!denom.isIconExists\">\n<span class=\"custom-icon img-width\">{{denom.id}}</span>\n</div>\n<div style=\"border-top: 1px solid #e0e0e0; display: flex; flex-direction: column; gap: 4px; padding: 4px;\">\n<button id=\"multiDenomAllowed\" type=\"button\" class=\"btn btn-xs\" ng-disabled=\"!denom.isDenomSelected || !$ctrl.isMultiDenomAllowed(denom)\" ng-class=\"{'btn-default': !denom.multiDenomAllowed, 'btn-success': denom.multiDenomAllowed}\" ng-click=\"$ctrl.toggleMultiDenom(denom)\">{{'denomination.multi_denom_button' | translate}}</button>\n<button id=\"customerOrderable\" type=\"button\" class=\"btn btn-xs\" ng-disabled=\"!denom.isDenomSelected\" ng-class=\"{'btn-default': !denom.customerOrderable, 'btn-primary': denom.customerOrderable}\" ng-click=\"$ctrl.toggleCustomerOrderable(denom)\">{{'denomination.cust_order' | translate}}</button>\n<input type=\"text\" class=\"form-control bfs-exp-residual-input\" name=\"expectedResidual_{{denom.id}}\" ng-if=\"$ctrl.model.expectedResidual && $ctrl.isExpectedResidualDenom(denom)\" ng-model=\"denom.expectedResidualPercentage\" ng-required=\"true\" ng-focus=\"$ctrl.removeResidualPercentSign(denom)\" ng-blur=\"$ctrl.addResidualPercentSign(denom)\" placeholder=\"{{'denomination.exp_residual' | translate}}\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\">\n</div>\n</div>\n</div>\n</div>\n</div>\n<hr class=\"funding-source-line-section\" ng-if=\"$ctrl.model.denominations.length > 0\">\n</div>\n<div class=\"col-sm-12 remove-left-padding remove-right-pad\" ng-if=\"$ctrl.model.autoOrdering\">\n<div class=\"header-section h4\"><label>{{'branchFundingSource.order_control' | translate}}</label></div>\n<hr class=\"funding-source-line-section\">\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex justify-space-between\">\n<div class=\"form-group col-sm-2_\">\n<label for=\"orderLeadTimeVal\" class=\"font-12\">{{'branchFundingSource.order_lead_time' | translate}}</label>\n<input type=\"number\" class=\"margin-top-02 form-control textbox-custom\" id=\"orderLeadDay\" placeholder=\"Days\" min=\"0\" ng-model=\"$ctrl.model.orderLeadDay\" ng-required=\"$ctrl.model.autoOrdering\">\n</div>\n<div class=\"form-group col-sm-2_\">\n<label for=\"ecOrderTime\" class=\"font-12\">{{'branchFundingSource.ec_order_lead_time' | translate}}</label>\n<input type=\"number\" class=\"margin-top-02 form-control textbox-custom\" id=\"ecOrderLeadTime\" placeholder=\"Days\" min=\"0\" ng-model=\"$ctrl.model.ecOrderLeadTime\" ng-required=\"$ctrl.model.autoOrdering\">\n</div>\n<div class=\"form-group col-sm-4_\">\n<div class=\"col-sm-6\">\n<label for=\"orderCutoffTimeVal\" class=\"font-12\">{{'branchFundingSource.order_cutoff_time' | translate}}</label>\n<br>\n<time-picker ng-model=\"$ctrl.model.orderCutoffTime\" ng-required=\"$ctrl.model.autoOrdering\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div class=\"col-sm-6\">\n<label for=\"timezone\" class=\"font-12\">{{'setup.timezone' | translate}}</label>\n<br>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.timezone\" ng-options=\"timezone.value as timezone.label for timezone in $ctrl.timezoneList\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"form-group col-sm-2_\">\n<label for=\"depositProcessingTime\" class=\"font-12\">\n{{'branchFundingSource.deposit_processing_time' | translate}}</label>\n<input type=\"number\" class=\"margin-top-02 form-control textbox-custom\" id=\"depositProcessingTime\" placeholder=\"Days\" ng-model=\"$ctrl.model.depositProcessingTime\" min=\"0\" ng-required=\"$ctrl.model.autoOrdering\">\n</div>\n<div class=\"form-group col-sm-2_\">\n<label for=\"maxOrders\" class=\"font-12\">\n{{'branchFundingSource.max_b_w_loads_days' | translate}}</label>\n<input type=\"number\" class=\"margin-top-02 form-control textbox-custom\" id=\"maxOrders\" placeholder=\"Days\" min=\"0\" ng-model=\"$ctrl.model.maxOrders\" ng-required=\"$ctrl.model.autoOrdering\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"orderIdSequencing\" class=\"font-12\">{{'branchFundingSource.order_id_sequencing' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.orderIdSequencing\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.orderIdSequencing\" class=\"text-danger\">{{$ctrl.errors.orderIdSequencing}}</span>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"orderSequenceStart\" class=\"font-12\">{{'branchFundingSource.order_sequence_start'| translate}}</label>\n<input type=\"text\" class=\"form-control\" ng-required=\"$ctrl.model.orderIdSequencing\" id=\"orderSequenceStart\" placeholder=\"\" ng-model=\"$ctrl.model.orderSequenceStart\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n</div>\n<div class=\"form-group col-sm-3 text-center\">\n<label for=\"autoOrderApproval\" class=\"font-12\">\n{{'branchFundingSource.auto_order_approval' | translate }}\n</label>\n<br>\n<input class=\"margin-top-02\" type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoOrderApproval\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetBankReportData();\"/>\n<span ng-if=\"$ctrl.errors.autoOrderApproval\" class=\"text-danger\">{{$ctrl.errors['autoOrderApproval']}}</span>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"orderApprovalThreshold\" class=\"font-12\">\n{{'branchFundingSource.order_approval_threshold'| translate}}\n</label>\n<input type=\"text\" class=\"form-control\" ng-required=\"$ctrl.model.autoOrderApproval\" id=\"orderApprovalThreshold\" placeholder=\"\" ng-model=\"$ctrl.model.orderApprovalThreshold\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"_form-group col-sm-4\">\n<div class=\"form-group\">\n<label for=\"orderInterest\" class=\"font-12\">\n{{'branchFundingSource.order_interest' | translate}}\n</label>\n<br>\n<div class=\"d-flex gap-5\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.orderInterest\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" ng-change=\"$ctrl.model.orderInterestPercentage = $ctrl.model.orderInterest ? $ctrl.model.orderInterestPercentage : 0\" switch-off-color=\"danger\"/>\n<div ng-if=\"$ctrl.model.orderInterest\" class=\"d-flex gap-5\">\n<input type=\"text\" class=\"form-control textbox-custom\" id=\"orderInterestPercentage\" ng-model=\"$ctrl.model.orderInterestPercentage\" ng-blur=\"$ctrl.ngPercentage('orderInterestPercentage')\" ng-focus=\"$ctrl.removePrecentageSign('orderInterestPercentage')\" ng-required=\"$ctrl.model.autoOrdering && $ctrl.model.orderInterest\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\">\n<label class=\"label-border-info\" ng-if=\"$ctrl.model.orderLeadDay\">\n{{$ctrl.model.orderLeadDay || 0}} {{'branchFundingSource.days' | translate}}\n</label>\n</div>\n</div>\n<span ng-if=\"$ctrl.errors.orderInterest\" class=\"text-danger\">{{$ctrl.errors['orderInterest']}}</span>\n</div>\n</div>\n<div class=\"_form-group col-sm-4\">\n<div class=\"form-group\">\n<label for=\"loadedInterest\" class=\"font-12\">\n{{'branchFundingSource.loaded_interest' | translate}}</label>\n<br/>\n<div class=\"d-flex gap-5\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.loadedInterest\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" ng-change=\"$ctrl.model.loadedInterestPercentage = $ctrl.model.loadedInterest ? $ctrl.model.loadedInterestPercentage : 0\" switch-off-color=\"danger\"/>\n<div ng-if=\"$ctrl.model.loadedInterest\" class=\"d-flex gap-5\">\n<input type=\"text\" class=\"form-control textbox-custom\" id=\"loadedInterestPercentage\" ng-model=\"$ctrl.model.loadedInterestPercentage\" ng-blur=\"$ctrl.ngPercentage('loadedInterestPercentage')\" ng-focus=\"$ctrl.removePrecentageSign('loadedInterestPercentage')\" ng-required=\"$ctrl.model.autoOrdering && $ctrl.model.loadedInterest\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\">\n<label class=\"label-border-info\" ng-if=\"$ctrl.model.orderLeadDay\">\n{{$ctrl.model.orderLeadDay || 0}} {{'branchFundingSource.days' | translate}}\n</label>\n</div>\n</div>\n<span ng-if=\"$ctrl.errors.loadedInterest\" class=\"text-danger\">{{$ctrl.errors['loadedInterest']}}</span>\n</div>\n</div>\n<div class=\"_form-group col-sm-4\">\n<div class=\"form-group\">\n<label for=\"residualInterest\" class=\"font-12\">\n{{'branchFundingSource.residual_interest' | translate}}\n</label>\n<br>\n<div class=\"d-flex gap-5\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.residualInterest\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" ng-change=\"$ctrl.model.residualInterestPercentage = $ctrl.model.residualInterest ? $ctrl.model.residualInterestPercentage : 0\" switch-off-color=\"danger\"/>\n<div ng-if=\"$ctrl.model.residualInterest\" class=\"d-flex gap-5\">\n<input type=\"text\" class=\"form-control textbox-custom\" id=\"residualInterestPercentage\" ng-model=\"$ctrl.model.residualInterestPercentage\" ng-blur=\"$ctrl.ngPercentage('residualInterestPercentage')\" ng-focus=\"$ctrl.removePrecentageSign('residualInterestPercentage')\" ng-required=\"$ctrl.model.autoOrdering && $ctrl.model.residualInterest\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\">\n<label class=\"label-border-info\" ng-if=\"$ctrl.model.orderLeadDay\">\n{{$ctrl.model.orderLeadDay || 0}} {{'branchFundingSource.days' | translate}}\n</label>\n</div>\n</div>\n</div>\n<span ng-if=\"$ctrl.errors.residualInterest\" class=\"text-danger\">{{$ctrl.errors['residualInterest']}}</span>\n</div>\n</div>\n</div>\n<hr class=\"funding-source-line-section\">\n</div>\n<div class=\"row\" ng-if=\"$ctrl.model.enableBankReport\">\n<div class=\"col-sm-12 _remove-left-padding\">\n<h4>{{'branchFundingSource.bank_report' | translate}}</h4>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"host\">{{'branchFundingSource.host'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"host\" placeholder=\"\" ng-model=\"$ctrl.model.bankReportFTPHost\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"port\">{{'branchFundingSource.port'| translate}} *</label>\n<input type=\"number\" class=\"form-control\" required id=\"port\" placeholder=\"\" ng-model=\"$ctrl.model.bankReportFTPPort\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"user\">{{'branchFundingSource.user'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"user\" placeholder=\"\" ng-model=\"$ctrl.model.bankReportFTPUser\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label class=\"radio-inline\">\n<input type=\"radio\" ng-model=\"$ctrl.model.key\" value=\"password\" checked=\"checked\">\n<b>{{'branchFundingSource.password' | translate}}</b>\n</label>\n<label class=\"radio-inline\">\n<input type=\"radio\" ng-model=\"$ctrl.model.key\" value=\"privateKey\">\n<b>{{'branchFundingSource.privateKey' | translate}}</b>\n</label>\n<div ng-if=\"$ctrl.model.key === 'password'\">\n<input type=\"password\" class=\"form-control\" id=\"passwd\" placeholder=\"\" ng-model=\"$ctrl.model.bankReportFTPPassword\" required>\n</div>\n<div ng-if=\"$ctrl.model.key === 'privateKey'\">\n<textarea class=\"form-control\" id=\"privateKey\" rows=\"2\" ng-model=\"$ctrl.model.bankReportFTPPrivateKey\" style=\"border-radius: 5px\" required></textarea>\n</div>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"FTPDirectory\">{{'branchFundingSource.ftp_directory'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"FTPDirectory\" placeholder=\"\" ng-pattern=\"/^\\/([A-z0-9-_+]+\\/)*([A-z0-9-]+)?$/\" ng-model=\"$ctrl.model.bankReportFTPDirectory\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"fileName\">{{'branchFundingSource.file_name_format'| translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"fileName\" placeholder=\"\" ng-model=\"$ctrl.model.bankReportFilenameFormat\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"bankReportType\">{{'branchFundingSource.bankReportType'| translate}} *</label>\n<select class=\"form-control margin-top-05\" id=\"bank-report-type\" required ng-model=\"$ctrl.model.bankReportType\" ng-options=\"bankReportType.value as bankReportType.label for bankReportType in $ctrl.bankReportTypes\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankReportType === 'USBANK'\">\n<label for=\"regularInventoryId\">{{'branchFundingSource.regularInventoryId'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"regularInventoryId\" placeholder=\"\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-model=\"$ctrl.model.regularInventoryId\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankReportType === 'USBANK'\">\n<label for=\"emergencyInventoryId\">{{'branchFundingSource.emergencyInventoryId'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"emergencyInventoryId\" placeholder=\"\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-model=\"$ctrl.model.emergencyInventoryId\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankReportType === 'CASHCONNECT'\">\n<label for=\"unifiedInventoryId\">{{'branchFundingSource.unifiedInventoryId'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"unifiedInventoryId\" placeholder=\"\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-model=\"$ctrl.model.unifiedInventoryId\" required>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.model.enableVaultReport\">\n<div class=\"col-sm-12 remove-left-padding\">\n<h4>{{'branchFundingSource.vault_report' | translate}}</h4>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"recipientName\">\n{{'branchFundingSource.vault_report_recipient_name'| translate}} *\n</label>\n<input type=\"text\" class=\"form-control\" required id=\"recipientName\" placeholder=\"\" ng-model=\"$ctrl.model.vaultReportRecipientName\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"recipientEmail\">\n{{'branchFundingSource.vault_report_recipient_email'| translate}} *\n</label>\n<input type=\"text\" class=\"form-control\" required id=\"recipientEmail\" placeholder=\"\" ng-class=\"{'ng-invalid': !$ctrl.hasValidEmails($ctrl.model.vaultReportRecipientEmail), 'ng-valid': $ctrl.hasValidEmails($ctrl.model.vaultReportRecipientEmail)}\" ng-model=\"$ctrl.model.vaultReportRecipientEmail\" ng-change=\"$ctrl.emailValidation = $ctrl.hasValidEmails($ctrl.model.vaultReportRecipientEmail)\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"vaultReportFileType\">\n{{'branchFundingSource.vault_report_file_type'| translate}} *\n</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.vaultReportFileType\" ng-options=\"type.value as type.label for type in $ctrl.vaultReportFileTypes\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'|translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"remove-bottom-margin col-sm-12 margin-10 form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n<div class=\"col-sm-12 margin-bottom-20 margin-10 remove-left-pad\">\n<button type=\"button\" ng-click=\"$ctrl.submit()\" class=\"btn btn-primary\" ng-disabled=\"(this.model.enableVaultReport && !$ctrl.emailValidation) || Form.$invalid || $ctrl.loading\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div></form>\n</div>\n";
var id1="branch_funding_source.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2657 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"\">{{'branchFundingSource.edit_funding' | translate}}</h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-12 text-align-center\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<form name=\"Form\" novalidate class=\"form-validate\" ng-if=\"!$ctrl.model.loading\">\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"branchFundingSourceId\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" disabled=\"disabled\" required id=\"branchFundingSourceId\" placeholder=\"\" ng-model=\"$ctrl.model.id\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"branchFundingSourceName\">{{'branchFundingSource.sourceName'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"branchFundingSourceName\" placeholder=\"\" ng-model=\"$ctrl.model.sourceName\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"branchId\">{{'branchFundingSource.branch' | translate}} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.branchId\" ng-change=\"$ctrl.loadBranchLocations()\" ng-options=\"branch for branch in $ctrl.branch\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'|translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"shiptypeId\">{{'branchFundingSource.shiptype' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.shiptypeId\" values=\"$ctrl.shiptypeList\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" onscroll=\"$ctrl.getAllShiptype(searchKey, offset)\" is-edit=\"true\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div class=\"form-group col-sm-4\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_info' | translate }}\" tooltip-placement=\"top\"></span>\n<label for=\"locationId\">{{'branchFundingSource.location' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.locationId\" values=\"$ctrl.locationList\" key=\"Key\" totalrecords=\"$ctrl.totalRecord\" onscroll=\"$ctrl.getAllLocation(searchKey, offset)\" is-edit=\"true\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.residualDeposit\">\n<label for=\"maxResidualDeposit\" class=\"font-12\">{{'branchFundingSource.maxDeposit'| translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"maxResidualDeposit\" placeholder=\"$0.00\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"$ctrl.model.maxResidualDeposit\">\n</div>\n<div class=\"form-group col-sm-4\" ng-show=\"!$ctrl.model.residualDeposit && $ctrl.model.multiDenomPack\">\n<label for=\"multiDenomBillLimit\" class=\"font-12\">{{'branchFundingSource.multi_denom_bill_limit'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"multiDenomBillLimit\" ng-currency currency-symbol=\"\" fraction=\"0\" hide-zero min=\"1\" ng-required=\"$ctrl.model.multiDenomPack\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"$ctrl.model.multiDenomBillLimit\">\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"!$ctrl.model.multiDenomPack &&  !$ctrl.model.residualDeposit\">\n<label for=\"branchFundingpocEmail\">{{'location.pocEmail' | translate }}</label>\n<input type=\"text\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\" class=\"form-control\" id=\"branchFundingpocEmail\" placeholder=\"\" ng-model=\"$ctrl.model.pocEmail\">\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-4\" ng-if=\"!$ctrl.model.multiDenomPack && !$ctrl.model.residualDeposit\">\n<label for=\"shiptypeId\">{{'setup.currency' | translate}} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.currencyId\" ng-change=\"$ctrl.onCurrencyChange()\" ng-options=\"currency.id as (currency.id + ' | ' + currency.name) for currency in $ctrl.currencyData\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'|translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-4\" ng-show=\"$ctrl.model.multiDenomPack && $ctrl.model.residualDeposit\">\n<label for=\"multiDenomBillLimit\" class=\"font-12\">{{'branchFundingSource.multi_denom_bill_limit'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"multiDenomBillLimit\" ng-currency currency-symbol=\"\" fraction=\"0\" hide-zero min=\"1\" ng-required=\"$ctrl.model.multiDenomPack\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"$ctrl.model.multiDenomBillLimit\">\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.multiDenomPack || $ctrl.model.residualDeposit\">\n<label for=\"branchFundingpocEmail\">{{'location.pocEmail' | translate }}</label>\n<input type=\"text\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\" class=\"form-control\" id=\"branchFundingpocEmail\" placeholder=\"\" ng-model=\"$ctrl.model.pocEmail\">\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.multiDenomPack || $ctrl.model.residualDeposit\">\n<label for=\"shiptypeId\">{{'setup.currency' | translate}} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.currencyId\" ng-change=\"$ctrl.onCurrencyChange()\" ng-options=\"currency.id as (currency.id + ' | ' + currency.name) for currency in $ctrl.currencyData\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'|translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-2 remove-right-pad\">\n<label for=\"averageBalanceFee\" class=\"font-12\">\n{{'branchFundingSource.averageBalanceFee' | translate}}\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.averageBalanceFee\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-2 remove-left-pad\" ng-if=\"$ctrl.model.averageBalanceFee\">\n<label for=\"contractedRate\" class=\"font-12\">{{'branchFundingSource.contractedRate'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"contractedRate\" placeholder=\"$0.00\" ng-model=\"$ctrl.model.contractedRate\" ng-currency fraction=\"6\" ng-required=\"$ctrl.model.averageBalanceFee\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-padding remove-right-pad\">\n<div class=\"header-section h4\"><label>{{'setup.operationsControl' | translate}}</label></div>\n<hr class=\"funding-source-line-section\">\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex justify-space-between\">\n<div class=\"form-group custome-width-15\">\n<label for=\"manualDeposit\" class=\"font-12\">\n{{'branchFundingSource.deposit_model' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{$ctrl.model.residualDeposit ? ('branchFundingSource.deposit_model_residual_info' | translate) : ('branchFundingSource.deposit_model_manual_info' | translate)}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.residualDeposit\" switch-size=\"small\" switch-on-text=\"{{'branchFundingSource.counted' | translate}}\" switch-off-text=\"{{'branchFundingSource.inventory' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.validateManualDeposit(); $ctrl.resetDeposit();\"/>\n<span ng-if=\"$ctrl.errors.residualDeposit\" class=\"text-danger\">{{$ctrl.errors['residualDeposit']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-hide=\"true\">\n<label for=\"residualDeposit\" class=\"font-12\">\n{{'branchFundingSource.residual_deposit' | translate}}\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.manualDeposit\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.validateResidualDeposit(); $ctrl.resetDeposit();\"/>\n<span ng-if=\"$ctrl.errors.manualDeposit\" class=\"text-danger\">{{$ctrl.errors['residualDeposit']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"enforceBalanceCheckOnVaultClose\" class=\"font-12\">\n{{'branchFundingSource.daily_cash_count' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.daily_cash_count_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.enforceBalanceCheckOnVaultClose\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.enforceBalanceCheckOnVaultClose\" class=\"text-danger\">{{$ctrl.errors['enforceBalanceCheckOnVaultClose']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"partialECDeposit\" class=\"font-12\">\n{{'branchFundingSource.partial_EC_deposit' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.partial_EC_deposit_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.partialECDeposit\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.partialECDeposit\" class=\"text-danger\">{{$ctrl.errors['partialECDeposit']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"editCountAnytime\" class=\"font-12\">\n{{'branchFundingSource.edit_count_anytime' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.edit_count_anytime_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<div ng-class=\"{'disabled': !$ctrl.model.editCountAnytime}\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.editCountAnytime\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-disabled=\"!$ctrl.model.editCountAnytime\"/>\n</div>\n<span ng-if=\"$ctrl.errors.editCountAnytime\" class=\"text-danger\">{{$ctrl.errors['editCountAnytime']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"manualDeposit\" class=\"font-12\">\n{{'branchFundingSource.enable_bank_report' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.enable_bank_report_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.enableBankReport\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetBankReportData();\"/>\n<span ng-if=\"$ctrl.errors.enableBankReport\" class=\"text-danger\">{{$ctrl.errors['enableBankReport']}}</span>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex justify-space-between\">\n<div class=\"form-group custome-width-15\">\n<label for=\"enableOrderMgmt\" class=\"font-12\">\n{{'branchFundingSource.order_management' | translate}}\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.enableOrderMgmt\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetOrderMgmt();\"/>\n<span ng-if=\"$ctrl.errors.enableOrderMgmt\" class=\"text-danger\">{{$ctrl.errors['enableOrderMgmt']}}</span>\n</div>\n<div class=\"form-group custome-width-16\">\n<label for=\"enableVaultReport\" class=\"font-12\">\n{{'branchFundingSource.enable_vault_report' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.enable_vault_report_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.enableVaultReport\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetBankReportData();\"/>\n<span ng-if=\"$ctrl.errors.enableVaultReport\" class=\"text-danger\">{{$ctrl.errors['enableVaultReport']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"deliveryReport\" class=\"font-12\">\n{{'branchFundingSource.delivery_report' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.delivery_report_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.deliveryReport\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.deliveryReport\" class=\"text-danger\">{{$ctrl.errors['deliveryReport']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"editAmount\" class=\"font-12\">\n{{'branchFundingSource.edit_amount' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.edit_amount_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.editAmount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.editAmount\" class=\"text-danger\">{{$ctrl.errors['editAmount']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"requireCountCommit\" class=\"font-12 remove-white-space\">\n{{'branchFundingSource.require_count_commit' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"Control that makes the Final Residual Count Commit required for Vault Close.\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireCountCommit\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex\" ng-class=\"{'justify-space-between': $ctrl.model.autoOrdering, 'bfs-toggle-section':  !$ctrl.model.autoOrdering}\">\n<div class=\"form-group custome-width-15\">\n<label for=\"autoOrdering\" class=\"font-12\">\n{{'branchFundingSource.auto_ordering' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.auto_ordering_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoOrdering\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetAutoOrderingData();\"/>\n<span ng-if=\"$ctrl.errors.autoOrdering\" class=\"text-danger\">{{$ctrl.errors['autoOrdering']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"$ctrl.model.autoOrdering\">\n<label for=\"networkData\" class=\"font-12\">{{'branchFundingSource.network_data' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.networkData\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.networkData\" class=\"text-danger\">{{$ctrl.errors['networkData']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"$ctrl.model.autoOrdering\">\n<label for=\"autoReconcile\" class=\"font-12\">{{'branchFundingSource.auto_reconcile' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoReconcile\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoReconcile\" class=\"text-danger\">{{$ctrl.errors['autoReconcile']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"$ctrl.model.autoOrdering\">\n<label for=\"allowECLoad\" class=\"font-12\">{{'branchFundingSource.allow_ec_load' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.allowECLoad\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n<span ng-if=\"$ctrl.errors.allowECLoad\" class=\"text-danger\">{{$ctrl.errors['allowECLoad']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"enforceStraps\" class=\"font-12\">{{'branchFundingSource.enforce_straps' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.enforce_straps_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.enforceStraps\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n<span ng-if=\"$ctrl.errors.enforceStraps\" class=\"text-danger\">{{$ctrl.errors['enforceStraps']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"!$ctrl.model.autoOrdering\">\n<label for=\"multiDenomPack\" class=\"font-12\">{{'branchFundingSource.multi_denom_pack' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.multi_denom_pack_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.multiDenomPack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<span ng-if=\"$ctrl.errors.multiDenomPack\" class=\"text-danger\">{{$ctrl.errors['multiDenomPack']}}</span>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"!$ctrl.model.autoOrdering\">\n<label for=\"atmForcasting\" class=\"font-12\">{{'branchFundingSource.atmForecasting' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.atmForecasting_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.atmForecasting\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"!$ctrl.model.autoOrdering\">\n<label for=\"varianceCheckEnabled\" class=\"font-12\">{{'branchFundingSource.variance' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.variance_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.varianceCheckEnabled\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"!$ctrl.model.autoOrdering\">\n<div class=\"col-sm-12 d-flex bfs-toggle-section\">\n<div class=\"form-group remove-left-pad custome-width-15 _col-sm-3\" ng-show=\"$ctrl.model.varianceCheckEnabled\">\n<label for=\"varianceThreshold\" class=\"font-12\">\n{{'branchFundingSource.threshold'| translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.variance_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<input type=\"text\" class=\"form-control\" ng-required=\"$ctrl.model.varianceCheckEnabled\" id=\"varianceThreshold\" placeholder=\"\" ng-model=\"$ctrl.model.varianceThreshold\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n</div>\n<div class=\"form-group\">\n<label for=\"autoCreateShipments\" class=\"font-12 remove-white-space\">{{'branchFundingSource.auto_create_shipments' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.auto_create_shipments_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoCreateShipments\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group\">\n<label for=\"bagoutForCount\" class=\"font-12 remove-white-space\">{{'branchFundingSource.bagout_for_count' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.bagout_for_count_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bagoutForCount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"inventoryBulkCoin\" class=\"font-12 remove-white-space\">{{'branchFundingSource.inventory_bulk_coin' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.inventoryBulkCoin\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"debitBulkCoinOnPack\" class=\"font-12 remove-white-space\">{{'branchFundingSource.debit_bulk_coin_on_pack' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.debitBulkCoinOnPack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.model.autoOrdering\">\n<div class=\"d-flex bfs-toggle-section col-sm-12\">\n<div class=\"form-group custome-width-15\">\n<label for=\"multiDenomPack\" class=\"font-12\">{{'branchFundingSource.multi_denom_pack' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.multi_denom_pack_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.multiDenomPack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<span ng-if=\"$ctrl.errors.multiDenomPack\" class=\"text-danger\">{{$ctrl.errors['multiDenomPack']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"atmForcasting\" class=\"font-12\">{{'branchFundingSource.atmForecasting' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.atmForecasting_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.atmForecasting\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"varianceCheckEnabled\" class=\"font-12\">{{'branchFundingSource.variance' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.variance_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.varianceCheckEnabled\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"_form-group custome-width-15\" ng-show=\"$ctrl.model.varianceCheckEnabled\">\n<label for=\"varianceThreshold\" class=\"font-12\">\n{{'branchFundingSource.threshold'| translate}}\n</label>\n<input type=\"text\" class=\"form-control\" ng-required=\"$ctrl.model.varianceCheckEnabled\" id=\"varianceThreshold\" placeholder=\"\" ng-model=\"$ctrl.model.varianceThreshold\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"autoCreateShipments\" class=\"font-12 remove-white-space\">{{'branchFundingSource.auto_create_shipments' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.auto_create_shipments_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoCreateShipments\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group\" ng-if=\"!$ctrl.model.varianceCheckEnabled\">\n<label for=\"bagoutForCount\" class=\"font-12 remove-white-space\">{{'branchFundingSource.bagout_for_count' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.bagout_for_count_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bagoutForCount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n</div>\n<div class=\"d-flex bfs-toggle-section col-sm-12\" ng-if=\"$ctrl.model.varianceCheckEnabled\">\n<div class=\"form-group custome-width-15\">\n<label for=\"bagoutForCount\" class=\"font-12 remove-white-space\">{{'branchFundingSource.bagout_for_count' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.bagout_for_count_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bagoutForCount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"inventoryBulkCoin\" class=\"font-12 remove-white-space\">{{'branchFundingSource.inventory_bulk_coin' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.inventoryBulkCoin\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"debitBulkCoinOnPack\" class=\"font-12 remove-white-space\">{{'branchFundingSource.debit_bulk_coin_on_pack' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.debitBulkCoinOnPack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n</div>\n<div class=\"d-flex bfs-toggle-section col-sm-12\" ng-if=\"!$ctrl.model.varianceCheckEnabled\">\n<div class=\"form-group custome-width-15\">\n<label for=\"inventoryBulkCoin\" class=\"font-12 remove-white-space\">{{'branchFundingSource.inventory_bulk_coin' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.inventoryBulkCoin\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"debitBulkCoinOnPack\" class=\"font-12 remove-white-space\">{{'branchFundingSource.debit_bulk_coin_on_pack' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.debitBulkCoinOnPack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex bfs-toggle-section\">\n<div class=\"form-group custome-width-15\">\n<label for=\"customerOrderLeadTime\" class=\"font-12 remove-white-space\">{{'branchFundingSource.customer_order_lead_time' | translate}}</label>\n<div class=\"margin-top-02 lead-time-control\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.customerOrderLeadTime\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetCustomerOrderLeadData()\">\n</div>\n</div>\n<div class=\"form-group custome-width-15\" ng-if=\"$ctrl.model.customerOrderLeadTime\">\n<label for=\"orderLeadDays\" class=\"font-12 remove-white-space\">{{'branchFundingSource.order_lead_days' | translate}}</label>\n<div class=\"margin-top-02 lead-time-control\">\n<input type=\"number\" class=\"form-control textbox-custom\" id=\"orderLeadDays\" placeholder=\"Days\" min=\"1\" step=\"1\" ng-model=\"$ctrl.model.orderLeadDays\" onwheel=\"event.preventDefault()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-required=\"$ctrl.model.customerOrderLeadTime\">\n</div>\n</div>\n<div class=\"form-group custome-width-15 lead-time-cutoff-field\" ng-if=\"$ctrl.model.customerOrderLeadTime\">\n<label for=\"orderLeadCutoff\" class=\"font-12 remove-white-space\">{{'branchFundingSource.order_lead_cutoff' | translate}}</label>\n<div class=\"margin-top-02 lead-time-control\" style=\"width: 100%;\">\n<br>\n<time-picker ng-model=\"$ctrl.model.orderLeadCutoff\" style=\"display: block; height: 34px;\" ng-required=\"$ctrl.model.customerOrderLeadTime\"></time-picker>\n</div>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"allowAmount\" class=\"font-12\">\n{{'branchFundingSource.allow_amount' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.allow_amount_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.allowAmount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.allowAmount\" class=\"text-danger\">{{$ctrl.errors['allowAmount']}}</span>\n</div>\n<div class=\"form-group custome-width-15\">\n<label for=\"adHocDeposit\" class=\"font-12 remove-white-space\">\n{{'branchFundingSource.ad_hoc_deposit' | translate}}\n</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.adHocDeposit\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.adHocDeposit\" class=\"text-danger\">{{$ctrl.errors['adHocDeposit']}}</span>\n</div>\n</div>\n</div>\n<hr class=\"funding-source-line-section\">\n</div>\n<div class=\"col-sm-12 remove-left-padding remove-right-pad margin-top-05 bfs-ach-model-section\">\n<div class=\"header-section h4\">\n<label>{{'branchFundingSource.ach_model' | translate}}</label>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex bfs-ach-toggle-row\" style=\"flex-wrap: wrap; column-gap: 50px;\" ng-class=\"{'bfs-ach-all-off': !($ctrl.model.customerACH || $ctrl.model.bankOrder || $ctrl.model.autoSendAccounting || $ctrl.model.autoSendCustomerCount || $ctrl.model.autoSendCustomerACH)}\">\n<div class=\"d-flex bfs-ach-toggle-group\" style=\"flex-wrap: wrap; gap: 30px;\">\n<div class=\"form-group bfs-ach-toggle-width\">\n<label for=\"customerAch\" class=\"font-12 remove-white-space\">{{'branchFundingSource.customer_ach' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.customerACH\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetCustomerAchData()\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.customerACH\">\n<label for=\"achOrderLeadDays\" class=\"font-12\">{{'branchFundingSource.order_lead_days' | translate}}</label>\n<input type=\"number\" class=\"form-control\" id=\"achOrderLeadDays\" placeholder=\"Days\" min=\"1\" step=\"1\" ng-model=\"$ctrl.model.customerACHOrderLeadDays\" onwheel=\"event.preventDefault()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-required=\"$ctrl.model.customerACH\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.customerACH\">\n<label for=\"achCountSettlementDays\" class=\"font-12\">{{'branchFundingSource.count_settlement_days' | translate}}</label>\n<input type=\"number\" class=\"form-control\" id=\"achCountSettlementDays\" placeholder=\"Days\" min=\"1\" step=\"1\" ng-model=\"$ctrl.model.customerACHSettlementDays\" onwheel=\"event.preventDefault()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-required=\"$ctrl.model.customerACH\">\n</div>\n</div>\n<div class=\"d-flex bfs-ach-toggle-group\" style=\"flex-wrap: wrap; gap: 30px;\">\n<div class=\"form-group bfs-ach-toggle-width\">\n<label for=\"bankOrder\" class=\"font-12 remove-white-space\">{{'branchFundingSource.bank_order' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bankOrder\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetBankOrderData()\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.bankOrder\">\n<label for=\"bankOrderLeadDays\" class=\"font-12\">{{'branchFundingSource.order_lead_days' | translate}}</label>\n<input type=\"number\" class=\"form-control\" id=\"bankOrderLeadDays\" placeholder=\"Days\" min=\"1\" step=\"1\" ng-model=\"$ctrl.model.bankOrderLeadDays\" onwheel=\"event.preventDefault()\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-required=\"$ctrl.model.bankOrder\">\n</div>\n</div>\n<div class=\"d-flex bfs-ach-toggle-group\" style=\"flex-wrap: wrap; gap: 30px;\">\n<div class=\"form-group bfs-ach-toggle-width\">\n<label for=\"achSendAccounting\" class=\"font-12 remove-white-space\">{{'branchFundingSource.auto_send_accounting' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoSendAccounting\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetAchSendAccountingData()\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.autoSendAccounting\">\n<label for=\"achSendAccountingTime\" class=\"font-12\">{{'branchFundingSource.auto_send_accounting_time' | translate}}</label>\n<time-picker ng-model=\"$ctrl.model.autoSendAccountingTime\" style=\"display: block; height: 34px;\" ng-required=\"$ctrl.model.autoSendAccounting\"></time-picker>\n</div>\n<div class=\"form-group bfs-ach-email-width\" ng-if=\"$ctrl.model.autoSendAccounting\">\n<label for=\"achSendAccountingEmails\" class=\"font-12\">{{'branchFundingSource.emails' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"achSendAccountingEmails\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\" ng-model=\"$ctrl.model.autoSendAccountingEmails\" ng-required=\"$ctrl.model.autoSendAccounting\">\n</div>\n</div>\n<div class=\"d-flex bfs-ach-toggle-group\" style=\"flex-wrap: wrap; gap: 30px;\">\n<div class=\"form-group bfs-ach-toggle-width\">\n<label for=\"autoSendCustCount\" class=\"font-12 remove-white-space\">{{'branchFundingSource.auto_send_cust_count' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoSendCustomerCount\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetAutoSendCustCountData()\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.autoSendCustomerCount\">\n<label for=\"autoSendCustCountTime\" class=\"font-12\">{{'branchFundingSource.auto_send_cust_count_time' | translate}}</label>\n<time-picker ng-model=\"$ctrl.model.autoSendCustomerCountTime\" style=\"display: block; height: 34px;\" ng-required=\"$ctrl.model.autoSendCustomerCount\"></time-picker>\n</div>\n</div>\n<div class=\"d-flex bfs-ach-toggle-group\" style=\"flex-wrap: wrap; gap: 30px;\">\n<div class=\"form-group bfs-ach-toggle-width\">\n<label for=\"autoSendCustACH\" class=\"font-12 remove-white-space\">{{'branchFundingSource.auto_send_cust_ach' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoSendCustomerACH\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetAutoSendCustACHData()\">\n</div>\n<div class=\"form-group bfs-ach-field-width\" ng-if=\"$ctrl.model.autoSendCustomerACH\">\n<label for=\"autoSendCustACHTime\" class=\"font-12\">{{'branchFundingSource.auto_send_cust_ach_time' | translate}}</label>\n<time-picker ng-model=\"$ctrl.model.autoSendCustomerACHTime\" style=\"display: block; height: 34px;\" ng-required=\"$ctrl.model.autoSendCustomerACH\"></time-picker>\n</div>\n</div>\n</div>\n</div>\n<div class=\"form-group remove-left-padding remove-right-pad col-sm-12 margin-10\">\n<div>\n<label for=\"businessDays\">{{'branchFundingSource.business_days' | translate }}</label>\n</div>\n<div id=\"businessDays\" class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.businessDays\" ng-click=\"$ctrl.toggleDay(day)\" ng-class=\"{'btn-primary': $ctrl.isDaySelected(day),'btn-default': !$ctrl.isDaySelected(day)}\">\n{{day.label}}\n<span class=\"badge location-history-badge funding-source-holiday-badge-color\" ng-if=\"$ctrl.model.businessDayHol && day.label == 'Holiday'\">\n{{$ctrl.totalFundingSourceHoliday}}\n</span>\n</a>\n</div>\n</div>\n<hr class=\"funding-source-line-section\">\n</div>\n<div class=\"_form-group remove-left-padding remove-right-pad col-sm-12 margin-top-05\">\n<div class=\"header-section h4\">\n<label>{{'orderPacking.denominations' | translate}}</label>\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.branchFundingSourceDenominationsModal()\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'common.add' | translate}}\n</button>\n<div class=\"pull-right bfs-exp-residual-toggle\">\n<label for=\"expectedResidual\" class=\"font-12\">{{'branchFundingSource.expected_residual' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'branchFundingSource.expected_residual_info' | translate}}\" tooltip-placement=\"top\"></span>\n</label>\n<input type=\"checkbox\" bs-switch id=\"expectedResidual\" ng-model=\"$ctrl.model.expectedResidual\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\">\n</div>\n</div>\n<hr class=\"funding-source-line-section\" ng-if=\"$ctrl.model.denominations.length > 0\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 text-align-center\" ng-if=\"$ctrl.isLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 text-align-center remove-pad\" ng-if=\"!$ctrl.isLoading\">\n<div class=\"card _card-margin bfs-denom-card-section\" ng-repeat=\"(key, val) in $ctrl.model.denominations\">\n<div class=\"denomination-key-section\" ng-if=\"val.length > 0\">{{key}}</div>\n<div class=\"card _card-margin bfs-denom-card-section\" ng-repeat=\"denom in val\" ng-if=\"val.length > 0\">\n<span type=\"button\" ng-click=\"$ctrl.removeDenomination(key, $index)\" class=\"text-danger cursor-pointer\">\n<span class=\"glyphicon glyphicon-remove-circle\"></span>\n</span>\n<div class=\"_card-body icon-height-50 col-sm-12 padding-10\" ng-if=\"denom.isIconExists\">\n<img ng-src=\"assets/images/{{denom.id}}.png\" class=\"custom-icon img-width\">\n</div>\n<div class=\"_card-body icon-height-50 col-sm-12 padding-15\" ng-if=\"!denom.isIconExists\">\n<span class=\"custom-icon img-width\">{{denom.id}}</span>\n</div>\n<div style=\"border-top: 1px solid #e0e0e0; display: flex; flex-direction: column; gap: 4px; padding: 4px;\">\n<button id=\"multiDenomAllowed\" type=\"button\" class=\"btn btn-xs\" ng-disabled=\"!denom.isDenomSelected || !$ctrl.isMultiDenomAllowed(denom)\" ng-class=\"{'btn-default': !denom.multiDenomAllowed, 'btn-success': denom.multiDenomAllowed}\" ng-click=\"$ctrl.toggleMultiDenom(denom)\">{{'denomination.multi_denom_button' | translate}}</button>\n<button id=\"customerOrderable\" type=\"button\" class=\"btn btn-xs\" ng-disabled=\"!denom.isDenomSelected\" ng-class=\"{'btn-default': !denom.customerOrderable, 'btn-primary': denom.customerOrderable}\" ng-click=\"$ctrl.toggleCustomerOrderable(denom)\">{{'denomination.cust_order' | translate}}</button>\n<input type=\"text\" class=\"form-control bfs-exp-residual-input\" name=\"expectedResidual_{{denom.id}}\" ng-if=\"$ctrl.model.expectedResidual && $ctrl.isExpectedResidualDenom(denom)\" ng-model=\"denom.expectedResidualPercentage\" ng-required=\"true\" ng-focus=\"$ctrl.removeResidualPercentSign(denom)\" ng-blur=\"$ctrl.addResidualPercentSign(denom)\" placeholder=\"{{'denomination.exp_residual' | translate}}\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\">\n</div>\n</div>\n</div>\n</div>\n</div>\n<hr class=\"funding-source-line-section\" ng-if=\"$ctrl.model.denominations.length > 0\">\n</div>\n<div class=\"col-sm-12 remove-left-padding remove-right-pad\" ng-if=\"$ctrl.model.autoOrdering\">\n<div class=\"header-section h4\"><label>{{'branchFundingSource.order_control' | translate}}</label></div>\n<hr class=\"funding-source-line-section\">\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex justify-space-between\">\n<div class=\"form-group col-sm-2_\">\n<label for=\"orderLeadTimeVal\" class=\"font-12\">{{'branchFundingSource.order_lead_time' | translate}}</label>\n<input type=\"number\" class=\"margin-top-02 form-control textbox-custom\" id=\"orderLeadDay\" placeholder=\"Days\" min=\"0\" ng-model=\"$ctrl.model.orderLeadDay\" ng-required=\"$ctrl.model.autoOrdering\">\n</div>\n<div class=\"form-group col-sm-2_\">\n<label for=\"ecOrderTime\" class=\"font-12\">{{'branchFundingSource.ec_order_lead_time' | translate}}</label>\n<input type=\"number\" class=\"margin-top-02 form-control textbox-custom\" id=\"ecOrderLeadTime\" placeholder=\"Days\" min=\"0\" ng-model=\"$ctrl.model.ecOrderLeadTime\" ng-required=\"$ctrl.model.autoOrdering\">\n</div>\n<div class=\"form-group col-sm-4_\">\n<div class=\"col-sm-6\">\n<label for=\"orderCutoffTimeVal\" class=\"font-12\">{{'branchFundingSource.order_cutoff_time' | translate}}</label>\n<br>\n<time-picker ng-model=\"$ctrl.model.orderCutoffTime\" ng-required=\"$ctrl.model.autoOrdering\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div class=\"col-sm-6\">\n<label for=\"timezone\" class=\"font-12\">{{'setup.timezone' | translate}}</label>\n<br>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.timezone\" ng-change=\"$ctrl.convertDateTime()\" ng-options=\"timezone.value as timezone.label for timezone in $ctrl.timezoneList\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"form-group col-sm-2_\">\n<label for=\"depositProcessingTime\" class=\"font-12\">\n{{'branchFundingSource.deposit_processing_time' | translate}}</label>\n<input type=\"number\" class=\"margin-top-02 form-control textbox-custom\" id=\"depositProcessingTime\" placeholder=\"Days\" ng-required=\"$ctrl.model.autoOrdering\" ng-model=\"$ctrl.model.depositProcessingTime\" min=\"0\">\n</div>\n<div class=\"form-group col-sm-2_\">\n<label for=\"maxOrders\" class=\"font-12\">\n{{'branchFundingSource.max_b_w_loads_days' | translate}}</label>\n<input type=\"number\" class=\"margin-top-02 form-control textbox-custom\" id=\"maxOrders\" placeholder=\"Days\" min=\"0\" ng-required=\"$ctrl.model.autoOrdering\" ng-model=\"$ctrl.model.maxOrders\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"orderIdSequencing\" class=\"font-12\">{{'branchFundingSource.order_id_sequencing' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.orderIdSequencing\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.orderIdSequencing\" class=\"text-danger\">{{$ctrl.errors.orderIdSequencing}}</span>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"orderSequenceStart\" class=\"font-12\">{{'branchFundingSource.order_sequence_start'| translate}}</label>\n<input type=\"text\" class=\"form-control\" ng-required=\" $ctrl.model.orderIdSequencing\" id=\"orderSequenceStart\" placeholder=\"\" ng-model=\"$ctrl.model.orderSequenceStart\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n</div>\n<div class=\"form-group col-sm-3 text-center\">\n<label for=\"autoOrderApproval\" class=\"font-12\">\n{{'branchFundingSource.auto_order_approval' | translate }}\n</label>\n<br>\n<input class=\"margin-top-02\" type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoOrderApproval\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetBankReportData();\"/>\n<span ng-if=\"$ctrl.errors.autoOrderApproval\" class=\"text-danger\">{{$ctrl.errors['autoOrderApproval']}}</span>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"orderApprovalThreshold\" class=\"font-12\">\n{{'branchFundingSource.order_approval_threshold'| translate}}\n</label>\n<input type=\"text\" class=\"form-control\" ng-required=\"$ctrl.model.autoOrderApproval\" id=\"orderApprovalThreshold\" placeholder=\"\" ng-model=\"$ctrl.model.orderApprovalThreshold\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"_form-group col-sm-4\">\n<div class=\"form-group\">\n<label for=\"orderInterest\" class=\"font-12\">\n{{'branchFundingSource.order_interest' | translate}}\n</label>\n<br>\n<div class=\"d-flex gap-5\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.orderInterest\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" ng-change=\"$ctrl.model.orderInterestPercentage = $ctrl.model.orderInterest ? $ctrl.model.orderInterestPercentage : 0\" switch-off-color=\"danger\"/>\n<div ng-if=\"$ctrl.model.orderInterest\" class=\"d-flex gap-5\">\n<input type=\"text\" class=\"form-control textbox-custom\" id=\"orderInterestPercentage\" ng-model=\"$ctrl.model.orderInterestPercentage\" ng-blur=\"$ctrl.ngPercentage('orderInterestPercentage')\" ng-focus=\"$ctrl.removePrecentageSign('orderInterestPercentage')\" ng-required=\"$ctrl.model.autoOrdering && $ctrl.model.orderInterest\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\">\n<label class=\"label-border-info\" ng-if=\"$ctrl.model.orderLeadDay\">\n{{$ctrl.model.orderLeadDay || 0}} {{'branchFundingSource.days' | translate}}\n</label>\n</div>\n</div>\n<span ng-if=\"$ctrl.errors.orderInterest\" class=\"text-danger\">{{$ctrl.errors['orderInterest']}}</span>\n</div>\n</div>\n<div class=\"_form-group col-sm-4\">\n<div class=\"form-group\">\n<label for=\"loadedInterest\" class=\"font-12\">\n{{'branchFundingSource.loaded_interest' | translate}}</label>\n<br/>\n<div class=\"d-flex gap-5\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.loadedInterest\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" ng-change=\"$ctrl.model.loadedInterestPercentage = $ctrl.model.loadedInterest ? $ctrl.model.loadedInterestPercentage : 0\" switch-off-color=\"danger\"/>\n<div ng-if=\"$ctrl.model.loadedInterest\" class=\"d-flex gap-5\">\n<input type=\"text\" class=\"form-control textbox-custom\" id=\"loadedInterestPercentage\" ng-model=\"$ctrl.model.loadedInterestPercentage\" ng-blur=\"$ctrl.ngPercentage('loadedInterestPercentage')\" ng-focus=\"$ctrl.removePrecentageSign('loadedInterestPercentage')\" ng-required=\"$ctrl.model.autoOrdering && $ctrl.model.loadedInterest\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\">\n<label class=\"label-border-info\" ng-if=\"$ctrl.model.orderLeadDay\">\n{{$ctrl.model.orderLeadDay || 0}} {{'branchFundingSource.days' | translate}}\n</label>\n</div>\n</div>\n<span ng-if=\"$ctrl.errors.loadedInterest\" class=\"text-danger\">{{$ctrl.errors['loadedInterest']}}</span>\n</div>\n</div>\n<div class=\"_form-group col-sm-4\">\n<div class=\"form-group\">\n<label for=\"residualInterest\" class=\"font-12\">\n{{'branchFundingSource.residual_interest' | translate}}\n</label>\n<br>\n<div class=\"d-flex gap-5\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.residualInterest\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" ng-change=\"$ctrl.model.residualInterestPercentage = $ctrl.model.residualInterest ? $ctrl.model.residualInterestPercentage : 0\" switch-off-color=\"danger\"/>\n<div ng-if=\"$ctrl.model.residualInterest\" class=\"d-flex gap-5\">\n<input type=\"text\" class=\"form-control textbox-custom\" id=\"residualInterestPercentage\" ng-model=\"$ctrl.model.residualInterestPercentage\" ng-blur=\"$ctrl.ngPercentage('residualInterestPercentage')\" ng-focus=\"$ctrl.removePrecentageSign('residualInterestPercentage')\" ng-required=\"$ctrl.model.autoOrdering && $ctrl.model.residualInterest\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\">\n<label class=\"label-border-info\" ng-if=\"$ctrl.model.orderLeadDay\">\n{{$ctrl.model.orderLeadDay || 0}} {{'branchFundingSource.days' | translate}}\n</label>\n</div>\n</div>\n</div>\n<span ng-if=\"$ctrl.errors.residualInterest\" class=\"text-danger\">{{$ctrl.errors['residualInterest']}}</span>\n</div>\n</div>\n</div>\n<hr class=\"funding-source-line-section\">\n</div>\n<div class=\"row\" ng-if=\"$ctrl.model.enableBankReport\">\n<div class=\"col-sm-12 _remove-left-padding\">\n<h4>{{'branchFundingSource.bank_report' | translate}}</h4>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"host\">{{'branchFundingSource.host'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"host\" placeholder=\"\" ng-model=\"$ctrl.model.bankReportFTPHost\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"port\">{{'branchFundingSource.port'| translate}} *</label>\n<input type=\"number\" class=\"form-control\" required id=\"port\" placeholder=\"\" ng-model=\"$ctrl.model.bankReportFTPPort\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"user\">{{'branchFundingSource.user'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"user\" placeholder=\"\" ng-model=\"$ctrl.model.bankReportFTPUser\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<div>\n<label class=\"radio-inline\">\n<input type=\"radio\" ng-model=\"$ctrl.model.key\" value=\"password\">\n<b>{{'branchFundingSource.password' | translate}}</b>\n</label>\n<label class=\"radio-inline\">\n<input type=\"radio\" ng-model=\"$ctrl.model.key\" value=\"privateKey\">\n<b>{{'branchFundingSource.privateKey' | translate}}</b>\n</label>\n</div>\n<div class=\"margin-top-04\" ng-if=\"$ctrl.model.key === 'password'\">\n<input type=\"password\" class=\"form-control\" id=\"passwd\" placeholder=\"\" ng-model=\"$ctrl.model.bankReportFTPPassword\" required>\n</div>\n<div class=\"margin-top-04\" ng-if=\"$ctrl.model.key === 'privateKey'\">\n<textarea class=\"form-control\" id=\"privateKey\" rows=\"2\" ng-model=\"$ctrl.model.bankReportFTPPrivateKey\" style=\"border-radius: 5px\" required></textarea>\n</div>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"FTPDirectory\">{{'branchFundingSource.ftp_directory'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"FTPDirectory\" placeholder=\"\" ng-pattern=\"/^\\/([A-z0-9-_+]+\\/)*([A-z0-9-]+)?$/\" ng-model=\"$ctrl.model.bankReportFTPDirectory\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"fileName\">{{'branchFundingSource.file_name_format'| translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"fileName\" placeholder=\"\" ng-model=\"$ctrl.model.bankReportFilenameFormat\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"bankReportType\">{{'branchFundingSource.bankReportType'| translate}} *</label>\n<select class=\"form-control margin-top-05\" id=\"bank-report-type\" required ng-model=\"$ctrl.model.bankReportType\" ng-options=\"bankReportType.value as bankReportType.label for bankReportType in $ctrl.bankReportTypes\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankReportType === 'USBANK'\">\n<label for=\"regularInventoryId\">{{'branchFundingSource.regularInventoryId'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"regularInventoryId\" placeholder=\"\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-model=\"$ctrl.model.regularInventoryId\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankReportType === 'USBANK'\">\n<label for=\"emergencyInventoryId\">{{'branchFundingSource.emergencyInventoryId'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"emergencyInventoryId\" placeholder=\"\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-model=\"$ctrl.model.emergencyInventoryId\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankReportType === 'CASHCONNECT'\">\n<label for=\"unifiedInventoryId\">{{'branchFundingSource.unifiedInventoryId'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"unifiedInventoryId\" placeholder=\"\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-model=\"$ctrl.model.unifiedInventoryId\" required>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.model.enableVaultReport\">\n<div class=\"col-sm-12 remove-left-padding\">\n<h4>{{'branchFundingSource.vault_report' | translate}}</h4>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"recipientName\">\n{{'branchFundingSource.vault_report_recipient_name'| translate}} *\n</label>\n<input type=\"text\" class=\"form-control\" required id=\"recipientName\" placeholder=\"\" ng-model=\"$ctrl.model.vaultReportRecipientName\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"recipientEmail\">\n{{'branchFundingSource.vault_report_recipient_email'| translate}} *\n</label>\n<input type=\"text\" class=\"form-control\" required id=\"recipientEmail\" placeholder=\"\" ng-class=\"{'ng-invalid': !$ctrl.hasValidEmails($ctrl.model.vaultReportRecipientEmail), 'ng-valid': $ctrl.hasValidEmails($ctrl.model.vaultReportRecipientEmail)}\" ng-model=\"$ctrl.model.vaultReportRecipientEmail\" ng-change=\"$ctrl.emailValidation = $ctrl.hasValidEmails($ctrl.model.vaultReportRecipientEmail)\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"vaultReportFileType\">\n{{'branchFundingSource.vault_report_file_type'| translate}} *\n</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.vaultReportFileType\" ng-options=\"type.value as type.label for type in $ctrl.vaultReportFileTypes\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'|translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"remove-bottom-margin col-sm-12 margin-10 form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n<div class=\"col-sm-12 margin-bottom-20 margin-10 remove-left-pad\">\n<button type=\"button\" ng-click=\"$ctrl.submit()\" class=\"btn btn-primary\" ng-disabled=\"!$ctrl.emailValidation || Form.$invalid || $ctrl.loading\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>\n";
var id1="branch_funding_source.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2658 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'branchFundingSourceHoliday.all_branch_funding_source_holiday' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.branchFundingSourceHolidayData && $ctrl.branchFundingSourceHolidayData.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"branchFundingSourceHolidayObj in $ctrl.branchFundingSourceHolidayData track by branchFundingSourceHolidayObj.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{branchFundingSourceHolidayObj.id}} | {{branchFundingSourceHolidayObj.name}} | {{branchFundingSourceHolidayObj.holidayDate | date:'yyyy-MM-dd': 'UTC'}} | {{branchFundingSourceHolidayObj.branchFundingSource.sourceName}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(branchFundingSourceHolidayObj)\" uib-tooltip=\"{{ 'common.Edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['delete']\" ng-click=\"$ctrl.delete(branchFundingSourceHolidayObj)\" uib-tooltip=\"{{ 'common.Delete' | translate }}\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"col-sm-12 text-align-center alert alert-danger\" ng-if=\"(!$ctrl.branchFundingSourceHolidayData || !$ctrl.branchFundingSourceHolidayData.length) && !$ctrl.loading\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>";
var id1="branch_funding_source_holiday.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2659 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"branch-funding-source-holiday.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"branchFundingSourceHoliday.menu_all_title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"branch-funding-source-holiday.create\">\n<a translate=\"branchFundingSourceHoliday.menu_create_title\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="branch_funding_source_holiday.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2660 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n<h4 translate=\"branchFundingSourceHoliday.new_branch_funding_source_holiday\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"name\">{{'common.name' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.name\">\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label>{{'branchFundingSourceHoliday.repeat' | translate}}</label>\n<br>\n<input id=\"repeat\" class=\"margin-top-05\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.repeat\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6\">\n<label>{{'location.hol' | translate}} {{'resetAtmCode.date' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.holidayDate\" date-format=\"dd-MMM-yyyy\" ng-class=\"{'required-datetimepicker': !$ctrl.model.holidayDate, 'disabled': $ctrl.loading}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"col-sm-6\">\n<label>{{'branchFundingSource.menu.title' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.selectedFundingSource\" values=\"$ctrl.model.branchFundingSourceObj.results\" key=\"Key\" class=\"funding-source-dd-height\" totalrecords=\"$ctrl.model.branchFundingSourceObj.totalRecords\" ng-disabled=\"$ctrl.model.branchFundingSourceObj.loading || $ctrl.model.isCreate\" onscroll=\"$ctrl.getAllFundingSource(searchKey, offset)\" none-selected=\"'checkinSelectionModal.select'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || Form.$invalid || $ctrl.model.isCreate || $ctrl.model.branchFundingSourceObj.loading\">\n<span ng-if=\"$ctrl.model.isCreate\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || $ctrl.model.isCreate || $ctrl.model.branchFundingSourceObj.loading\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</div>\n</form>\n</div>";
var id1="branch_funding_source_holiday.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2661 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"remove-pad col-sm-12\">\n<h4 translate=\"branchFundingSourceHoliday.edit_branch_funding_source_holiday\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"id\">{{'common.id' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required disabled=\"disabled\" placeholder=\"\" ng-model=\"$ctrl.rawId\">\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"name\">{{'common.name' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.name\">\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label>{{'branchFundingSourceHoliday.repeat' | translate}}</label>\n<br>\n<input id=\"repeat\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.repeat\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6\">\n<label>{{'location.hol' | translate}} {{'resetAtmCode.date' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.holidayDate\" date-format=\"dd-MMM-yyyy\" ng-class=\"{'required-datetimepicker': !$ctrl.model.holidayDate, 'disabled': $ctrl.loading}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"col-sm-6\">\n<label>{{'branchFundingSource.menu.title' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.selectedFundingSource\" values=\"$ctrl.model.branchFundingSourceObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.branchFundingSourceObj.totalRecords\" class=\"funding-source-dd-height\" ng-disabled=\"$ctrl.model.branchFundingSourceObj.loading || $ctrl.model.isCreate\" onscroll=\"$ctrl.getAllFundingSource(searchKey, offset)\" none-selected=\"'checkinSelectionModal.select'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"button\" ng-click=\"$ctrl.update(this)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.model.branchFundingSourceObj.loading || Form.$invalid || $ctrl.model.isCreate || $ctrl.model.branchFundingSourceObj.loading\">\n<span ng-if=\"$ctrl.model.isCreate\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-disabled=\"$ctrl.model.branchFundingSourceObj.loading || $ctrl.model.isCreate || $ctrl.model.branchFundingSourceObj.loading\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</div>\n</form>\n</div>";
var id1="branch_funding_source_holiday.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2662 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<ul class=\"nav nav-tabs hide-in-print\" ng-if=\"!$ctrl.loading\">\n<li ng-repeat=\"tab in $ctrl.tabs\" role=\"presentation\" ui-sref-active=\"active\">\n<a class=\"branch-mgmt-badge\" ui-sref=\"{{tab.state}}\" ng-click=\"['branchManagement.binManifest', 'branchManagement.depositReports', 'branchManagement.averageDailyBalance','branchManagement.mileageReport'].includes(tab.state) && $ctrl.gotoReactUrl(tab.state, $event)\">\n{{tab.title | translate}}\n<span ng-if=\"tab.extra.LocationHoldcount\" class=\"badge\">{{$ctrl.DataCounter.getCounterForLocationHold()}}</span>\n<span ng-if=\"tab.extra.itemHoldcount\" class=\"badge\">{{$ctrl.DataCounter.getCounterForItemHold()}}</span>\n</a>\n</li>\n</ul>\n<div class=\"text-align-center font-size-50\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"remove-pad\">\n<div class=\"mt-20\">\n<ui-view></ui-view>\n</div>\n</div>\n</div>\n";
var id1="branch_management.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2663 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h2>Average Daily Vault Balance Page</h2>\n</div>\n";
var id1="average_daily_vault_balance.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2664 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\">\n<div>\n<div class=\"col-sm-12 form-validate\" novalidate>\n<div class=\"row hide-in-print\">\n<div class=\"col-sm-12 align-center-horizontally\">\n<div class=\"col-sm-7 bagout-history-dd-section\">\n<search-and-select ng-model=\"$ctrl.model.bagout\" set-id=\"bagout\" values=\"$ctrl.model.bagoutObj.results\" key=\"Key\" on-click=\"$ctrl.loadDataOfBagoutHistory()\" totalrecords=\"$ctrl.model.bagoutObj.totalRecords\" onscroll=\"$ctrl.getBagSealData(searchKey, offset)\" none-selected=\"'bagout.select_bagout'\" ng-disabled=\"$ctrl.model.bagoutObj.loading\" required></search-and-select>\n</div>\n<div class=\"col-sm-3 bagout-history-dt-picker-section\" ng-if=\"$ctrl.model.dateRange.startDate\">\n<input date-range-picker id=\"dtpc\" class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRange\" options=\"$ctrl.model.dateRangPickerOptions\"/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"row_\" ng-if=\"$ctrl.shipmentData.length && !$ctrl.loading\">\n<div class=\"col-sm-12 margin-bottom-5 margin-top-25 remove-padding\">\n<span class=\"pull-left font-size-20 font-15\">\n<strong>{{ 'bagout.history' | translate }} </strong> |\n<span ng-if=\"!$ctrl.bagOutData.closed\" ng-class=\"{'text-success': !$ctrl.bagOutData.closed}\">\n{{ $ctrl.bagOutClosed }}</span>\n<span ng-if=\"$ctrl.bagOutData.closed\"><b>{{'bagout.status_closed' | translate}}:</b>\n{{$ctrl.closedDate}}</span>\n<span ng-if=\"!$ctrl.bagOutData.closed\">| <b>{{'branch_mgmt.tankers.create' | translate}}:</b>\n{{$ctrl.createdAt}} | <b>{{'branch_mgmt.bagout_lastUpdated' | translate}}:</b>\n{{$ctrl.updatedAt}}</span>\n</span>\n<div class=\"col-sm-6 remove-pad pull-right bagout-history-btn-section\" ng-if=\"$ctrl.bagOutData.closed\">\n<div class=\"_col-sm-3\" ng-if=\"$ctrl.shipmentData.length\">\n<button class=\"btn btn-success pull-right\" ng-click=\"$ctrl.print()\">\n{{'routeSheet.print' | translate}}\n</button>\n</div>\n<div class=\"_col-sm-3\">\n<button class=\"btn btn-success pull-right\" ng-click=\"$ctrl.markAsDelivered()\" ng-disabled=\"$ctrl.isShipmentDelivered\">\n{{'branch_mgmt.bagout.mark_as_deliver' | translate}}\n</button>\n</div>\n<div class=\"_col-sm-3\">\n<button class=\"btn btn-warning pull-right\" ng-click=\"$ctrl.confirmUndoBagouts()\" ng-disabled=\"$ctrl.isShipmentDelivered\">\n{{'bagout.undo_bagout' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-2 remove-pad pull-right bagout-history-btn-section\" ng-if=\"!$ctrl.bagOutData.closed\">\n<div class=\"_col-sm-3\" ng-if=\"$ctrl.shipmentData.length\">\n<button class=\"btn btn-success pull-right\" ng-click=\"$ctrl.closebag()\">\n{{'bagout.closeBagout' | translate}}\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding\">\n<div ng-if=\"$ctrl.msg\">\n<div class=\"alert\" ng-class=\"$ctrl.isError ? 'alert-danger' : 'alert-success'\">\n{{$ctrl.msg}}\n</div>\n</div>\n<table class=\"table table-striped table-bordered\">\n<thead class=\"text-center\">\n<tr>\n<td>\n<strong>#</strong>\n</td>\n<td>\n<strong>{{'bagout.trackingId' | translate}}</strong>\n</td>\n<td>\n<strong>{{'bagout.fromLocationId' | translate}}</strong>\n</td>\n<td>\n<strong>{{'bagout.fromLocationName' | translate}}</strong>\n</td>\n<td>\n<strong>{{'bagout.type' | translate}}</strong>\n</td>\n<td>\n<strong>{{'bagout.amount' | translate}}</strong>\n</td>\n<td ng-if=\"$ctrl.bagOutClosed=='Open'\">\n<strong>{{'common.action' | translate}}</strong>\n</td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"bag in $ctrl.shipmentData | orderBy : 'trackingId' \">\n<td>{{$index+1}}</td>\n<td><a href=\"#\" ng-click=\"$ctrl.goToItemHistory(bag.trackingId)\">{{bag.trackingId}}</a></td>\n<td><a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(bag.fromLocationId)\">{{bag.fromLocationId}}</a></td>\n<td>{{bag.fromLocationName}}</td>\n<td>{{bag.shipType}}</td>\n<td>{{bag.amount | currency:'$'}}</td>\n<td ng-if=\"$ctrl.bagOutClosed=='Open'\">\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.removeTrackingIdFromBagout(bag)\">\n<span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"{{'common.Delete' | translate}}\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad bagout-err-margin-20 align-center-horizontally row hide-in-print errMsg\" ng-if=\"$ctrl.model.noItems && !$ctrl.loading\">\n<div class=\"alert errLblPos alert-danger text-center w-100\">\n<span>{{$ctrl.model.noItemDisplayed}}</span>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading && !$ctrl.shipmentData.length && !$ctrl.model.noDataFound && $ctrl.model.bagout\" class=\"col-sm-12 remove-pad bagout-err-margin-20 align-center-horizontally row hide-in-print errMsg\">\n<div class=\"alert errLblPos text-center w-100 alert-danger\">\n<span>{{$ctrl.model.noDataFound}}</span>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="bagouts.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2665 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad branch-mgmt-bagout-css-section\">\n<div class=\"text-align-center col-sm-12 bagout-spinner-section\" ng-if=\"!$ctrl.loadCompanyLogo\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12\" ng-if=\"$ctrl.loadCompanyLogo\">\n<div class=\"col-sm-12 companyLogo\" ng-if=\"$ctrl.loadCompanyLogo\">\n<img stream-print-logo class=\"bagout-company-logo-section\">\n</div>\n<div class=\"row col-sm-12 bagout-main-section print-header-margin\">\n<div class=\"col-sm-3 col-print-3\">\n<div>{{'bagout.from' | translate}}:</div>\n<div>\n<h3 class=\"margin-zero\"> <strong>{{$ctrl.model.bagout.fromLocationName}}</strong></h3>\n</div>\n<div>\n<h4>{{$ctrl.model.bagout.fromLocationAddress}}</h4>\n</div>\n</div>\n<div class=\"col-sm-3 col-print-3\">\n<div>{{'bagout.destination' | translate}}:</div>\n<div>\n<h3 class=\"margin-zero\"><strong>{{$ctrl.model.bagout.toLocationName}}</strong></h3>\n</div>\n<div>\n<h4>{{$ctrl.model.bagout.toLocationAddress}}</h4>\n</div>\n</div>\n<div class=\"col-sm-3 col-print-3 _show-only-in-print txtSize bagSealPos\">\n<strong> {{'bagout.bagSeal' | translate}}</strong>\n<div class=\"bagSealPos\">\n<h3 class=\"margin-zero\">\n<span>{{$ctrl.model.bagout.bagSealId}}</span>\n</h3>\n</div>\n</div>\n<div class=\"col-sm-3 col-print-3 _show-only-in-print txtSize bagSealPos\">\n<div class=\"bagSealPos\">\n<h3 class=\"margin-zero\">\n<span>\n<angular-barcode ng-model=\"$ctrl.model.bagout.bagSealId\" bc-options=\"$ctrl.barcodeOptions\" bc-class=\"barcode\" bc-type=\"image\"></angular-barcode>\n</span>\n</h3>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 _show-only-in-print margin-top-15 text-left _bagout-print-align-section\">\n<strong ng-if=\"$ctrl.model.bagout.routeId\"> {{ 'bagout.route' | translate }}: </strong>\n<span ng-if=\"$ctrl.model.bagout.routeId\">{{$ctrl.model.bagout.routeId}} | {{$ctrl.model.bagout.routeName}}</span>\n&nbsp;&nbsp;&nbsp;\n<strong>{{'bagout.totalBags' | translate}}:</strong>\n<span>{{$ctrl.model.bagout.totalBags}}</span>\n&nbsp;&nbsp;&nbsp;\n<strong>{{'bagout.totalAmount' | translate}}:</strong>\n{{$ctrl.model.bagout.totalAmount | currency: '$'}} &nbsp;&nbsp;&nbsp;\n<strong>({{'bagout.set_to_contain' | translate}})</strong>\n<strong class=\"pull-right\">\n{{ 'bagout.deliveryDate' | translate }}: {{$ctrl.model.bagout.vaultDate | date: 'longDate'}}\n</strong>\n</div>\n<div class=\"col-sm-12 margin-top-20\">\n<table class=\"table table-striped table-bordered table-pad-3\">\n<thead class=\"header-row text-align-center\">\n<tr>\n<td> <strong>#</strong> </td>\n<td> <strong>{{'bagout.trackingId' | translate}}</strong> </td>\n<td> <strong>{{'bagout.fromLocationName' | translate}}</strong> </td>\n<td> <strong>{{'bagout.fromLocationId' | translate}}</strong> </td>\n<td> <strong>{{'bagout.type' | translate}}</strong> </td>\n<td> <strong>{{'bagout.amount' | translate}}</strong> </td>\n<td class=\"_show-only-in-print\"> <strong>{{'bagout.verify' | translate}}</strong> </td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"bag in $ctrl.model.bagout.results | orderBy : 'trackingId' \">\n<td>{{$index+1}}</td>\n<td>{{bag.trackingId }}</td>\n<td>{{bag.fromLocationName}}</td>\n<td>{{bag.fromLocationId}}</td>\n<td>{{bag.shipType}}</td>\n<td>{{bag.amount | currency:'$'}}</td>\n<td class=\"_show-only-in-print\">&nbsp;</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"_show-only-in-print\">\n<div class=\"signPos\">\n<span class=\"bagout-contents\">{{ 'bagout.userContent' | translate }}</span>\n</div>\n<div class=\"col-print-12 signPos bagout-contents\">\n<div class=\"col-print-4 textPoss bagout-contents\">\n<span>{{ 'bagout.fullName' | translate }}: <span class=\"lineColor\">__________________________</span>\n\n</span></div>\n<div class=\"col-print-4 textPoss bagout-contents\">\n<span>|&nbsp;{{'bagout.userSignature' | translate}}: <span class=\"lineColor\">_________________________</span>&nbsp;</span>\n</div>\n<div class=\"col-print-4 textPoss bagout-contents\">\n<span>|&nbsp;{{ 'bagout.cntDate' | translate }}: <span class=\"lineColor\">___________________________</span></span>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="bagouts.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2666 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<table class=\"table table-bordered table-condensed remove-bottom-margin\">\n            <thead>\n                <tr>\n                    <th>{{'surchargeDetailsModal.surcharge' | translate}}</th>\n                    <th>{{'surchargeDetailsModal.fee' | translate}}</th>\n                    <th class=\"text-right\">{{'surchargeDetailsModal.amount' | translate}}</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat=\"surcharge in billingRecord.storedSurchargeBreakdown\">\n                    <td>{{$ctrl.surchargeLabelKeys[surcharge.type] | translate}}</td>\n                    <td>{{surcharge.percentage | currency:'':2}}%</td>\n                    <td class=\"text-right\">{{surcharge.amount | currency}}</td>\n                </tr>\n            </tbody>\n            <tfoot>\n                <tr>\n                    <th colspan=\"2\">{{'surchargeDetailsModal.totalSurcharge' | translate}}</th>\n                    <th class=\"text-right\">{{billingRecord.storedSurcharge | currency}}</th>\n                </tr>\n            </tfoot>\n        </table>\n";
var id1="recordSurchargeTooltip.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
var v2="<div class=\"col-sm-12 container billing-approval-page\">\n\n<form name=\"approveBillingRecords\" class=\"form-validate\" novalidate>\n<div class=\"remove-pad col-md-12\">\n<div class=\"col-sm-12\" ng-if=\"!$ctrl.model.billableCustomerObj.customerHistory.process\">\n<div class=\"margin-left-10\">\n<button type=\"button\" id=\"export-btn-other\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.createBillingRecords()\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_create_billing_record']['allow']\">\n{{'entry_type.create-billing-records' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10\" ng-if=\"!$ctrl.model.billableCustomerObj.customerHistory.process\">\n<hr class=\"cash-variances-line-section\">\n</div>\n<div class=\"billing-approval-status-section col-sm-12 pull-top\" ng-if=\"!$ctrl.model.billableCustomerObj.customerHistory.process\">\n<div class=\"unassigned-tab-color billing-approval-status-border-radius billing-approval-badge billing-approval-box col-sm-2 btn-default cursor-pointer\" ng-class=\"{'selected-tab-section current-bucket-border-color' : $ctrl.model.currentStats === $ctrl.model.stats.unassigned }\" ng-model=\"$ctrl.model.currentStats\" ng-click=\"$ctrl.tabSelection('unassigned')\">\n<div class=\"billing-approval-box-flex\">\n<div class=\"_text-amount\"><b>{{$ctrl.model.billableCustomerObj.totalUnassignedAmount | currency}}</b> &nbsp;</div>\n<div class=\"billing-approval-title\"><b>{{'serviceTickets.status_UNASSIGNED' | translate}}</b></div>\n</div>\n<div class=\"badge badge-primary badge-fixed\">\n{{$ctrl.model.billableCustomerObj.customerAssignedTotalRecords + $ctrl.model.unAssignedCustomersBillingRecordsObj.totalRecords}}\n</div>\n</div>\n<div class=\"billing-review-tab-color billing-approval-status-border-radius billing-approval-badge billing-approval-box col-sm-2 btn-default cursor-pointer\" ng-class=\"{'selected-tab-section current-bucket-border-color' : $ctrl.model.currentStats === $ctrl.model.stats.review }\" ng-model=\"$ctrl.model.currentStats\" ng-click=\"$ctrl.tabSelection('review')\">\n<div class=\"billing-approval-box-flex\">\n<div class=\"_text-amount\"><b>{{$ctrl.model.billableCustomerObj.totalReviewAmount | currency}}</b> &nbsp;</div>\n<div class=\"billing-approval-title\"><b>{{'branch_mgmt.billing_approval.needs_review' | translate}}</b></div>\n</div>\n<div class=\"badge badge-primary badge-fixed\">\n{{$ctrl.model.billableCustomerObj.totalReviewRecords}}\n</div>\n</div>\n<div class=\"pending-tab-color billing-approval-status-border-radius billing-approval-badge billing-approval-box col-sm-2 btn-default cursor-pointer\" ng-model=\"$ctrl.model.currentStats\" ng-class=\"{'selected-tab-section current-bucket-border-color' : $ctrl.model.currentStats === $ctrl.model.stats.pending }\" ng-click=\"$ctrl.reset(); $ctrl.tabSelection('pending');\">\n<div class=\"billing-approval-box-flex\">\n<div class=\"_text-amount\"><b>{{$ctrl.model.billableCustomerObj.totalPendingAmount | currency}}</b> &nbsp;</div>\n<div class=\"billing-approval-title\"><b>{{'branch_mgmt.routes.bucket_PENDING' | translate}}</b></div>\n</div>\n<div class=\"badge badge-primary badge-fixed\">{{$ctrl.model.billableCustomerObj.totalPendingRecords}}</div>\n</div>\n<div class=\"billing-approval-badge billing-approval-status-border-radius billing-approval-status-border-radius billing-approval-box col-sm-2 btn-default cursor-pointer approved-tab-color\" ng-model=\"$ctrl.model.currentStats\" ng-class=\"{'selected-tab-section current-bucket-border-color' : $ctrl.model.currentStats === $ctrl.model.stats.approved }\" ng-click=\"$ctrl.reset(); $ctrl.tabSelection('approved');\">\n<div class=\"billing-approval-box-flex\">\n<div class=\"_text-amount\"><b>{{$ctrl.model.billableCustomerObj.totalApprovedAmount | currency}}</b> &nbsp;</div>\n<div class=\"billing-approval-title\"><b>{{'branch_mgmt.billing_approval.approved' | translate}}</b></div>\n</div>\n<div class=\"badge badge-primary badge-fixed\">{{$ctrl.model.billableCustomerObj.totalApprovedRecords}}</div>\n</div>\n<div class=\"billing-approval-badge billing-approval-status-border-radius billing-approval-box col-sm-2 btn-default cursor-pointer rejected-tab-color\" ng-model=\"$ctrl.model.currentStats\" ng-class=\"{'selected-tab-section current-bucket-border-color' : $ctrl.model.currentStats === $ctrl.model.stats.deleted }\" ng-click=\"$ctrl.reset(); $ctrl.tabSelection('deleted');\">\n<div class=\"billing-approval-box-flex\">\n<div class=\"_text-amount\"><b>{{$ctrl.model.rejectedBillingRecordsObj.totalAmount | currency}}</b> &nbsp;</div>\n<div class=\"billing-approval-title\"><b>{{'branch_mgmt.billing_approval.rejected' | translate}}</b></div>\n</div>\n<div class=\"badge badge-danger badge-fixed\">{{$ctrl.model.rejectedBillingRecordsObj.totalRecords}}</div>\n</div>\n<div class=\"billing-no-activity-tab-color billing-approval-status-border-radius billing-approval-badge billing-approval-box col-sm-2 btn-default cursor-pointer\" ng-class=\"{'selected-tab-section current-bucket-border-color' : $ctrl.model.currentStats === $ctrl.model.stats.no_activity }\" ng-model=\"$ctrl.model.currentStats\" ng-click=\"$ctrl.reset(); $ctrl.tabSelection('no_activity');\">\n<div class=\"billing-approval-box-flex\">\n<div class=\"_text-amount\"><b>{{$ctrl.model.billableCustomerObj.totalNoActivityAmount | currency}}</b> &nbsp;</div>\n<div class=\"billing-approval-title\"><b>{{'branch_mgmt.billing_approval.no_activity' | translate}}</b></div>\n</div>\n<div class=\"badge badge-primary badge-fixed\">\n{{$ctrl.model.billableCustomerObj.totalNoActivityRecords}}\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-hide=\"$ctrl.model.currentStats === $ctrl.model.stats.unassigned || $ctrl.model.billableCustomerObj.customerHistory.process\"><hr class=\"cash-variances-line-section\"></div>\n<div class=\"col-md-12 row remove-left-pad remove-right-pad align-center margin-10 margin-bottom-10\" ng-if=\"!$ctrl.model.billableCustomerObj.customerHistory.process\">\n<div class=\"remove-right-pad col-sm-3\" style=\"position: relative;z-index: 10;\" ng-hide=\"$ctrl.model.currentStats === $ctrl.model.stats.unassigned\">\n<search-and-select ng-model=\"$ctrl.model.customerId\" values=\"$ctrl.model.customerListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.customerListObj.totalRecords\" on-click=\"$ctrl.loadData();\" onscroll=\"$ctrl.getCustomerList(searchKey, offset);\" ng-disabled=\"$ctrl.model.customerListObj.loading || $ctrl.isCustomerUser\" none-selected=\"'common.select_customer'\"></search-and-select>\n</div>\n<div class=\"col-sm-3 remove-right-pad\" ng-hide=\"$ctrl.model.currentStats === $ctrl.model.stats.unassigned || $ctrl.model.currentStats === $ctrl.model.stats.approved\">\n<input type=\"text\" strip-prefix class=\"form-control\" ng-model=\"$ctrl.model.searchText\" name=\"searchText\" on-press-enter=\"$ctrl.loadData();\" placeholder=\"{{'common.locationId' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9 -]*$/\" ng-class=\"{'disabled': $ctrl.model.billableCustomerObj.loading}\"/>\n</div>\n<div class=\"col-sm-3 remove-right-pad\" ng-hide=\"$ctrl.model.currentStats === $ctrl.model.stats.unassigned\">\n<search-and-select ng-model=\"$ctrl.model.billingCategory\" values=\"$ctrl.model.billingCategoryObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.billingCategoryObj.totalRecords\" on-click=\"$ctrl.loadData();\" onscroll=\"$ctrl.getBillingCategory(searchKey, offset);\" ng-disabled=\"$ctrl.model.billingCategoryObj.loading\" none-selected=\"'(Select Billing Category)'\"></search-and-select>\n</div>\n<div class=\"col-sm-3 billing-unassigned-date-picker\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" options=\"$ctrl.model.dateRangPickerOptionsfor\" ng-change=\"$ctrl.loadData();\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled': $ctrl.model.billableCustomerObj.loading}\" ng-hide=\"$ctrl.model.currentStats === $ctrl.model.stats.unassigned\"/>\n</div>\n<div ng-if=\"$ctrl.model.billableCustomerObj.results.length\">\n<button type=\"button\" id=\"export-btn-other\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportBillingRecords()\" ng-hide=\"$ctrl.model.currentStats === $ctrl.model.stats.unassigned || $ctrl.model.currentStats === $ctrl.model.stats.deleted\" ng-disabled=\"$ctrl.model.billableCustomerObj.loading\">\n<span id=\"export-btn-loading-other\"></span>\n{{'common.export' | translate}}</button>\n</div>\n<div ng-if=\"$ctrl.model.currentStats === $ctrl.model.stats.deleted && $ctrl.model.rejectedBillingRecordsObj.totalRecords > 0\">\n<button type=\"button\" id=\"export-btn-other\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportRejectedBillingRecords()\" ng-disabled=\"$ctrl.model.rejectedBillingRecordsObj.loading\">\n<span id=\"export-btn-loading-other\"></span>\n{{'common.export' | translate}}</button>\n</div>\n<div class=\"margin-left-10\" ng-if=\"$ctrl.isAllowToTestStaticBill() && $ctrl.hasACL['branch_mgmt_billing_approval_create_billing_record']['allow']\">\n<button type=\"button\" id=\"export-btn-other\" class=\"btn btn-primary font-size-20 pull-right\" ng-click=\"$ctrl.generateStaticBillingRecord('pre-bill')\" ng-disabled=\"$ctrl.model.generatingStaticBillingRecord['pre-bill'].status\">\nPre Bill (Test)\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.generatingStaticBillingRecord['pre-bill'].status\"></span>\n</button>\n</div>\n<div class=\"margin-left-10\" ng-if=\"$ctrl.isAllowToTestStaticBill() && $ctrl.hasACL['branch_mgmt_billing_approval_create_billing_record']['allow']\">\n<button type=\"button\" id=\"export-btn-other\" class=\"btn btn-primary font-size-20 pull-right\" ng-click=\"$ctrl.generateStaticBillingRecord('post-bill')\" ng-disabled=\"$ctrl.model.generatingStaticBillingRecord['post-bill'].status\">\nPost Bill (Test)\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.generatingStaticBillingRecord['post-bill'].status\"></span>\n</button>\n</div>\n<div class=\"margin-left-10\" ng-if=\"$ctrl.isAllowToTestStaticBill() && $ctrl.hasACL['branch_mgmt_billing_approval_create_billing_record']['allow']\">\n<button type=\"button\" id=\"export-btn-other\" class=\"btn btn-primary font-size-20 pull-right\" ng-click=\"$ctrl.postBillingRecordModal('manualPostBill')\" ng-disabled=\"$ctrl.model.generatingStaticBillingRecord['post-bill'].status\">\nPost Bill (Monthly)\n</button>\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-25 _panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.stats.pending\">\n<div class=\"text-align-center col-sm-12\" ng-if=\"$ctrl.model.billableCustomerObj.customerHistory.process\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<table class=\"table table-pad-4 table-striped table-hover table-bordered remove-bottom-pad margin-10\" ng-if=\"!$ctrl.model.billableCustomerObj.customerHistory.process && $ctrl.model.billableCustomerObj.results.length\">\n<thead>\n<tr>\n<th class=\"text-center\"></th>\n<th class=\"text-center\">{{'bagout.customer' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.location_serviced' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.billing_events' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.total_billing' | translate}}</th>\n<th class=\"text-center projected-surcharge-col\" ng-if=\"$ctrl.model.hasActiveSurcharge\">{{'branch_mgmt.billing_approval.projected_surcharge' | translate}}</th>\n<th class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{'branch_mgmt.billing_approval.total_surcharge' | translate}}</th>\n<th class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{'branch_mgmt.billing_approval.total_pending' | translate}}\n<span class=\"glyphicon glyphicon-info-sign total-pending-info\" uib-tooltip=\"{{'branch_mgmt.billing_approval.total_pending_info' | translate}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"></span>\n</th>\n<th class=\"text-center\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_approve_billing_record']['allow']\">{{'shipmentBatch.action' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat-start=\"customer in $ctrl.model.billableCustomerObj.results track by $index\">\n<td class=\"text-center check-box-col-width\"><input type=\"checkbox\" ng-model=\"customer.isSelected\" ng-click=\"customer.isSelected = !customer.isSelected; $ctrl.selectAllBillingRecords(customer, $index)\">\n</td>\n<td>\n<span class=\"col-sm-1 remove-left-pad\">\n<button id=\"expand-btn-{{customer.customerId}}\" class=\"btn btn-xs btn-secondary\" ng-click=\"customer.expanded = !customer.expanded; $ctrl.setPage(customer.expanded, customer.customerId); $ctrl.getBillingRecords(customer, $event)\" expand>\n<span ng-if=\"customer.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!customer.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</span>\n<span class=\"col-sm-10 text-center _remove-left-pad\">{{customer.customerId}} | {{customer.customerName}}</span>\n</td>\n<td class=\"text-center\">{{customer.totalLocationServiced}}</td>\n<td class=\"text-center\">{{customer.totalBillableEvents}}</td>\n<td class=\"text-center\">\n<span ng-if=\"customer.totalAmount !== null\">{{customer.totalAmount | currency}}</span>\n<span ng-if=\"customer.totalAmount == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center projected-surcharge-col\" ng-if=\"$ctrl.model.hasActiveSurcharge\">\n<a href ng-if=\"customer.surchargeBreakdown.length\" ng-click=\"$ctrl.showSurchargeDetails(customer)\">{{customer.totalSurcharge | currency}}</a>\n<span ng-if=\"!customer.surchargeBreakdown.length\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">\n<a href ng-if=\"customer.storedSurchargeBreakdown.length\" ng-click=\"$ctrl.showStoredSurchargeDetails(customer)\">{{customer.storedSurcharge | currency}}</a>\n<span ng-if=\"!customer.storedSurchargeBreakdown.length && customer.surchargeBreakdown.length\">{{customer.storedSurcharge | currency}}</span>\n<span ng-if=\"!customer.storedSurchargeBreakdown.length && !customer.surchargeBreakdown.length\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{(customer.totalAmount * 1 || 0) + (customer.storedSurcharge || 0) | currency}}</td>\n<td class=\"text-center\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_approve_billing_record']['allow']\">\n<button id=\"approve-all-{{customer.customerId}}\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.billingRecordApproval(customer)\" ng-disabled=\"(!customer.expanded || !$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected ||\n                                             $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected === 1) && !customer.isSelected\">\n<span class=\"glyphicon glyphicon glyphicon-ok\"></span>\n<span ng-if=\"($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected === \n                                              $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords) || \n                                             (!$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected ||\n                                             $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected === 1) ||\n                                             ($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected && customer.isSelected)\">\n{{'branch_mgmt.billing_approval.approve_all' | translate}}\n</span>\n<span ng-if=\"($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected !== \n                                              $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords && !customer.isSelected) && \n                                             ($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected > 1)\">\n{{'common.approve' | translate}}\n<span>({{$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected}})</span>\n</span>\n</button>\n</td>\n</tr>\n<tr class=\"text-center\" ng-repeat-end ng-show=\"customer.expanded\">\n<td colspan=\"10\" ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].process\">\n<div class=\"text-align-center col-sm-12\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</td>\n<td colspan=\"10\" class=\"remove-pad\" ng-if=\"!$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].process\">\n<div>\n<table class=\"table table-condensed table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th colspan=\"2\" class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortData('vaultDate', customer, $event)\">\n{{'common.vault_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'vaultDate'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('routeId', customer, $event)\">\n{{'branch_mgmt.billing_approval.branch_route' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeId'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('locationId', customer, $event)\">\n{{'item.location' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortData('billableEventType', customer, $event)\">\n{{'billableEvents.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billableEventType'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortData('billingCategory', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_category' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingCategory'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('billingType', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingType'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('scheduleType', customer, $event)\">\n{{'branch_mgmt.billing_approval.schedule_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'scheduleType'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('amountDue', customer, $event)\">\n{{'branch_mgmt.billing_approval.amount_due' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountDue'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{'surchargeDetailsModal.surcharge' | translate}}</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('locationDistanceName',customer,$event)\">\n{{'locationDistance.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationDistanceName'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('trackingId', customer, $event)\">\n{{'log.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'trackingId'}\"></span>\n</th>\n<th class=\"text-center billing-approval-col-w-12\" ng-class=\"{'billing-approval-col-w-9' : !billingRecord.isEdit, 'billing-approval-col-w-12' : billingRecord.isEdit}\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_approve_billing_record']['allow'] || \n                                            $ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow'] || \n                                            $ctrl.hasACL['branch_mgmt_billing_approval_delete_billing_record']['allow']\">\n{{'shipmentBatch.action' | translate}}\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-class=\"{'manual-billing-records-color' : billingRecord.type === 'MANUAL'}\" ng-repeat-start=\"billingRecord in $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.results\">\n<td class=\"text-center _check-box-col-width expand-btn-section\">\n<input type=\"checkbox\" ng-model=\"billingRecord.isSelected\" ng-click=\"billingRecord.isSelected = !billingRecord.isSelected; $ctrl.validateBillingRecordSelection(billingRecord, customer)\">\n<button id=\"expand-btn-{{billingRecord.billingRecordId}}\" class=\"btn btn-xs btn-secondary expand-btn-margin-bottom-03\" ng-click=\"billingRecord.expanded = !billingRecord.expanded; $ctrl.setStaticBillingEventsRecordsPage(billingRecord.expanded, billingRecord.billingRecordId); \n                                                              $ctrl.getStaticBillingEventsRecords(billingRecord, billingRecord.billableEventType)\" ng-show=\"['pre-bill', 'post-bill'].indexOf(billingRecord.billableEventType) > -1 && billingRecord.type !== 'MANUAL'\" expand>\n<span ng-if=\"billingRecord.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!billingRecord.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</td>\n<td class=\"remove-white-space\">{{billingRecord.vaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</td>\n<td>\n<span ng-if=\"!billingRecord.branchId\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"billingRecord.branchId\">\n{{billingRecord.branchId}}\n</span>\n<span ng-if=\"billingRecord.routeId\"> |\n<a href=\"#\" ng-click=\"$ctrl.goToRouteTab(billingRecord.routeId, billingRecord.vaultDate)\">{{billingRecord.routeId}}</a>\n</span>\n</td>\n<td>\n<span ng-if=\"!billingRecord.locationId\">{{'common.n_a' | translate}}</span>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(billingRecord.locationId)\">{{billingRecord.locationId}}</a>\n</td>\n<td>{{$ctrl.translateMessage('entry_type.', billingRecord.billableEventType)}}\n<span ng-if=\"billingRecord.contractRuleDescription\">| <b>{{billingRecord.contractRuleDescription}}</b></span>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.serviceOrderNotes(billingRecord)\" uib-tooltip=\"{{'common.notes' | translate}}\" ng-if=\"billingRecord.serviceOrderId\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"!billingRecord.isEdit\">{{billingRecord.billingCategoryObj.Key}}</span>\n<span class=\"billing-category-dd-padding\" ng-if=\"billingRecord.isEdit\">\n<select class=\"form-control\" ng-model=\"billingRecord.billingCategoryObj.Key\" ng-options=\"category.Key as category.Key for category in $ctrl.model.billingCategoryObj.results\" ng-disabled=\"$ctrl.model.billingCategoryObj.loading\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"!billingRecord.isEdit\">\n{{$ctrl.translateMessage('billableEvents.', billingRecord.billingType)}}\n</span>\n<span class=\"billing-category-dd-padding\" ng-if=\"billingRecord.isEdit\">\n<select class=\"form-control\" ng-model=\"billingRecord.billingType\" ng-options=\"billingType.value as billingType.label for billingType in $ctrl.model.billingTypeList\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</span>\n</td>\n<td class=\"item-date-width-10\">\n<span class=\"text-center\" ng-if=\"billingRecord.scheduleType == 'ANY'\">ANY</span>\n<span class=\"text-center\" ng-if=\"billingRecord.scheduleType == 'NONE'\">{{'common.n_a' | translate}}</span>\n<span class=\"text-success text-center\" ng-if=\"billingRecord.scheduleType == 'SCHEDULED'\">{{'common.scheduled' | translate}}</span>\n<span class=\"text-danger text-center\" ng-if=\"billingRecord.scheduleType == 'UNSCHEDULED'\">{{'billableEvents.UNSCHEDULED' | translate}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"billingRecord.amountDue !== null\">{{billingRecord.amountDue | currency}}</span>\n<span ng-if=\"billingRecord.amountDue == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">\n<span ng-if=\"billingRecord.storedSurcharge != null\" class=\"surcharge-tooltip-trigger\" uib-tooltip-template=\"'recordSurchargeTooltip.html'\" tooltip-enable=\"billingRecord.storedSurchargeBreakdown.length > 0\" tooltip-class=\"surcharge-tooltip\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{billingRecord.storedSurcharge | currency}}<span class=\"glyphicon glyphicon-info-sign surcharge-tooltip-icon\" ng-if=\"billingRecord.storedSurchargeBreakdown.length > 0\"></span></span>\n<span ng-if=\"billingRecord.storedSurcharge == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td ng-if=\"billingRecord.billingType !== 'COMBINED_TIME'\">\n<span ng-if=\"billingRecord.locationDistanceId\">{{billingRecord.locationDistanceName}}</span>\n<span ng-if=\"billingRecord.locationDistanceId === null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\" ng-if=\"billingRecord.billingType === 'COMBINED_TIME'\">\n<span>{{billingRecord.combinedServiceTime}}\n<span ng-if=\"billingRecord.locationDistanceId\">({{billingRecord.locationDistanceName}})</span>\n</span>\n</td>\n<td>\n<span ng-if=\"billingRecord.billableEventType == 'coin-conversion'\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.billingRecordId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.coinConversionBillingRecordsLog(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n<span ng-if=\"billingRecord.trackingId || billingRecord.serviceOrderId\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.trackingId || billingRecord.serviceOrderId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.billableEventLogDetails(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId && (!billingRecord.type || billingRecord.type === 'AUTO') && !['stop-completed', 'coin-conversion'].includes(billingRecord.billableEventType)\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId && billingRecord.billableEventType === 'stop-completed'\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.locationId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.billableEventLogDetails(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId && billingRecord.type === 'MANUAL'\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.billingRecordId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.manuallyCreatedBillingRecordsLog(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n</td>\n<td class=\"remove-white-space\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_approve_billing_record']['allow'] || \n                                            $ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow'] || \n                                            $ctrl.hasACL['branch_mgmt_billing_approval_delete_billing_record']['allow']\">\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.billingRecordApproval(customer, billingRecord)\" ng-disabled=\"($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected > 1) || \n                                                        ($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected === 1 && !billingRecord.isSelected || customer.isSelected) \" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_approve_billing_record']['allow']\">\n<span class=\"glyphicon glyphicon glyphicon-ok\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-disabled=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].isUpdate\" ng-click=\"$ctrl.updateBillingRecords(billingRecord, customer)\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow']\">\n<span class=\"glyphicon glyphicon-edit\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_delete_billing_record']['allow']\" ng-click=\"$ctrl.deleteBillingRecords(billingRecord, 'PENDING', customer)\" ng-disabled=\"$ctrl.deleteBillingRecordsObj[billingRecord.billingRecordId].loading\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</td>\n</tr>\n<tr class=\"text-center\" ng-repeat-end ng-show=\"billingRecord.expanded && ['pre-bill', 'post-bill'].indexOf(billingRecord.billableEventType) > -1\">\n<td colspan=\"13\" ng-if=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].process\">\n<div class=\"text-align-center col-sm-12\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</td>\n<td colspan=\"13\" class=\"remove-pad\" ng-if=\"!$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].process\">\n<div>\n<div class=\"error-msg-padding col-sm-12 alert alert-danger text-center remove-bottom-margin\" ng-if=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.results.length == 0\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n<table class=\"table table-condensed table-bordered remove-bottom-margin _pre-billing-events-history-section\" ng-if=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.results.length > 0\">\n<thead>\n<tr>\n<th class=\"billing-approval-col-w-12 text-center\">\n{{'common.vault_date' | translate}}\n</th>\n<th class=\"text-center remove-white-space\">\n{{'branch_mgmt.billing_approval.branch_route' | translate}}\n</th>\n<th class=\"text-center remove-white-space\">\n{{'item.location' | translate}}\n</th>\n<th class=\"_billing-approval-col-w-12 text-center\">\n{{'billableEvents.menu.title' | translate}}\n</th>\n<th class=\"billing-approval-col-w-12 text-center\">\n{{'branch_mgmt.billing_approval.bill_category' | translate}}\n</th>\n<th class=\"text-center\">\n{{'branch_mgmt.billing_approval.schedule_type' | translate}}\n</th>\n<th class=\"text-center remove-white-space\">\n{{'log.menu.title' | translate}}\n</th>\n<th class=\"text-center remove-white-space\">{{'shipmentBatch.action' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"staticBillingEventsRecord in $ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.results\" ng-class=\"{'manual-billing-records-color' : staticBillingEventsRecord.type === 'MANUAL', 'pre-billing-events-history-section' : staticBillingEventsRecord.type !== 'MANUAL'}\">\n<td>{{staticBillingEventsRecord.vaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</td>\n<td>\n<span ng-if=\"!staticBillingEventsRecord.branchId\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"staticBillingEventsRecord.branchId\">{{staticBillingEventsRecord.branchId}}</span>\n<span ng-if=\"staticBillingEventsRecord.routeId\"> |\n<a href=\"#\" ng-click=\"$ctrl.goToRouteTab(staticBillingEventsRecord.routeId, staticBillingEventsRecord.vaultDate)\">{{staticBillingEventsRecord.routeId}}</a>\n</span>\n</td>\n<td>\n<span ng-if=\"!staticBillingEventsRecord.locationId\">{{'common.n_a' | translate}}</span>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(staticBillingEventsRecord.locationId)\">{{staticBillingEventsRecord.locationId}}</a>\n</td>\n<td>{{$ctrl.translateMessage('entry_type.', staticBillingEventsRecord.billableEventType)}}\n<span ng-if=\"staticBillingEventsRecord.contractRuleDescription\">|\n<b>{{staticBillingEventsRecord.contractRuleDescription}}</b></span>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.serviceOrderNotes(staticBillingEventsRecord)\" uib-tooltip=\"{{'common.notes' | translate}}\" ng-if=\"staticBillingEventsRecord.serviceOrderId\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span>{{staticBillingEventsRecord.billingCategoryObj.Key}}</span>\n</td>\n<td class=\"item-date-width-10\">\n<span class=\"text-center\" ng-if=\"staticBillingEventsRecord.scheduleType == 'NONE'\">{{'common.n_a' | translate}}</span>\n<span class=\"text-center\" ng-if=\"staticBillingEventsRecord.scheduleType == 'ANY'\">ANY</span>\n<span class=\"text-success text-center\" ng-if=\"staticBillingEventsRecord.scheduleType == 'SCHEDULED'\">{{'common.scheduled' | translate}}</span>\n<span class=\"text-danger text-center\" ng-if=\"staticBillingEventsRecord.scheduleType == 'UNSCHEDULED'\">{{'billableEvents.UNSCHEDULED' | translate}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\" ng-if=\"staticBillingEventsRecord.billingType === 'COMBINED_TIME'\">\n<span>{{staticBillingEventsRecord.combinedServiceTime}}</span>\n</td>\n<td>\n<span ng-if=\"staticBillingEventsRecord.trackingId || staticBillingEventsRecord.serviceOrderId\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{staticBillingEventsRecord.trackingId || staticBillingEventsRecord.serviceOrderId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.billableEventLogDetails(staticBillingEventsRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n<span ng-if=\"!staticBillingEventsRecord.trackingId && !staticBillingEventsRecord.serviceOrderId  && (!staticBillingEventsRecord.type || staticBillingEventsRecord.type === 'AUTO')\">\n{{'common.n_a' | translate}}\n</span>\n<span ng-if=\"!staticBillingEventsRecord.trackingId && !staticBillingEventsRecord.serviceOrderId && staticBillingEventsRecord.type === 'MANUAL'\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{staticBillingEventsRecord.billingRecordId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.manuallyCreatedBillingRecordsLog(staticBillingEventsRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n</td>\n<td>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_delete_billing_record']['allow']\" ng-click=\"$ctrl.deleteBillingRecords(staticBillingEventsRecord, 'PENDING', customer)\" ng-disabled=\"$ctrl.deleteBillingRecordsObj[staticBillingEventsRecord.billingRecordId].loading\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n<tbody>\n<tr ng-if=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.totalRecords > $ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.pageLimit\">\n<td class=\"location-history-pagination-section\" colspan=\"10\">\n<div class=\"hide-in-print\">\n<ul ng-model=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].page\" uib-pagination total-items=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.totalRecords\" ng-hide=\"{{($ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.totalRecords<=$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.getStaticBillingEventsRecords(billingRecord, billingRecord.billableEventType)\" max-size=\"10\"></ul>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</td>\n</tr>\n</tbody>\n<tbody>\n<tr ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords > $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.pageLimit\">\n<td class=\"location-history-pagination-section\" colspan=\"10\">\n<div class=\"hide-in-print\">\n<ul ng-model=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].page\" uib-pagination total-items=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords\" ng-hide=\"{{($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords<=$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.resetData(customer); $ctrl.getBillingRecords(customer, $event)\" max-size=\"10\"></ul>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10\" ng-if=\"$ctrl.model.pendingCustomerObj.totalPendingBillableCustomers > 10 && $ctrl.model.billableCustomerObj.results.length && !$ctrl.model.billableCustomerObj.customerHistory.process\">\n<ul class=\"margin-bottom-10\" uib-pagination total-items=\"$ctrl.model.pendingCustomerObj.totalPendingBillableCustomers\" ng-hide=\"{{($ctrl.model.pendingCustomerObj.totalPendingBillableCustomers<=$ctrl.model.billableCustomerObj.pagination.pageLimit)&&($ctrl.model.billableCustomerObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.billableCustomerObj.pagination.page\" ng-change=\"$ctrl.billableCustomer()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div ng-if=\"!$ctrl.model.billableCustomerObj.results.length && !$ctrl.model.billableCustomerObj.customerHistory.process\">\n<div class=\"col-sm-12 alert text-center alert-danger\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-25 _panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.stats.approved\">\n<div class=\"text-align-center col-sm-12\" ng-if=\"$ctrl.model.billableCustomerObj.customerHistory.process\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<table class=\"table table-pad-4 table-striped table-hover table-bordered remove-bottom-pad\" ng-if=\"!$ctrl.model.billableCustomerObj.customerHistory.process && $ctrl.model.billableCustomerObj.results.length\">\n<thead>\n<tr>\n<th class=\"check-box-col-width text-center\"></th>\n<th class=\"text-center\">{{'bagout.customer' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.location_serviced' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.billing_events' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.total_billing' | translate}}</th>\n<th class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{'branch_mgmt.billing_approval.total_surcharge' | translate}}</th>\n<th class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{'branch_mgmt.total_amount' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat-start=\"customer in $ctrl.model.billableCustomerObj.results track by $index\">\n<td>\n<button id=\"expand-btn-{{customer.customerId}}\" class=\"btn btn-xs btn-secondary\" ng-click=\"customer.expanded = !customer.expanded; $ctrl.setPage(customer.expanded, customer.customerId); $ctrl.getBillingRecords(customer, $event)\" expand>\n<span ng-if=\"customer.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!customer.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</td>\n<td class=\"text-center\">\n{{customer.customerId}} | {{customer.customerName}}\n</td>\n<td class=\"text-center\">{{customer.totalLocationServiced}}</td>\n<td class=\"text-center\">{{customer.totalBillableEvents}}</td>\n<td class=\"text-center\">\n<span ng-if=\"customer.totalAmount !== null\">{{customer.totalAmount | currency}}</span>\n<span ng-if=\"customer.totalAmount == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">\n<a href ng-if=\"customer.storedSurchargeBreakdown.length\" ng-click=\"$ctrl.showStoredSurchargeDetails(customer)\">{{customer.storedSurcharge | currency}}</a>\n<span ng-if=\"!customer.storedSurchargeBreakdown.length && customer.surchargeBreakdown.length\">{{customer.storedSurcharge | currency}}</span>\n<span ng-if=\"!customer.storedSurchargeBreakdown.length && !customer.surchargeBreakdown.length\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{(customer.totalAmount * 1 || 0) + (customer.storedSurcharge || 0) | currency}}</td>\n</tr>\n<tr class=\"text-center\" ng-repeat-end ng-show=\"customer.expanded\">\n<td colspan=\"10\" ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].process\">\n<div class=\"text-align-center col-sm-12\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</td>\n<td colspan=\"10\" class=\"remove-pad\" ng-if=\"!$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].process\">\n<div>\n<table class=\"table table-condensed table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th colspan=\"1\" class=\"billing-approval-col-w-12 text-center\" ng-click=\"$ctrl.sortData('vaultDate', customer, $event)\">\n{{'common.vault_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'vaultDate'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('routeId', customer, $event)\">\n{{'branch_mgmt.billing_approval.branch_route' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeId'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('locationId', customer, $event)\">\n{{'item.location' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center\" ng-click=\"$ctrl.sortData('billableEventType', customer, $event)\">\n{{'billableEvents.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billableEventType'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center\" ng-click=\"$ctrl.sortData('billingCategory', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_category' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingCategory'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('billingType', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingType'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('scheduleType', customer, $event)\">\n{{'branch_mgmt.billing_approval.schedule_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'scheduleType'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('amountDue', customer, $event)\">\n{{'branch_mgmt.billing_approval.amount_due' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountDue'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{'surchargeDetailsModal.surcharge' | translate}}</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('locationDistanceName',customer,$event)\">\n{{'locationDistance.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationDistanceName'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('trackingId', customer, $event)\">\n{{'log.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'trackingId'}\"></span>\n</th>\n<th ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow']\" class=\"text-center\"><span>{{'common.action' | translate}}</span></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-class=\"{'manual-billing-records-color' : billingRecord.type === 'MANUAL'}\" ng-repeat-start=\"billingRecord in $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.results\">\n<td class=\"text-center _check-box-col-width expand-btn-section\">\n<span class=\"col-sm-1\" ng-show=\"['pre-bill', 'post-bill'].indexOf(billingRecord.billableEventType) > -1 && billingRecord.type !== 'MANUAL'\">\n<button id=\"expand-btn-{{billingRecord.billingRecordId}}\" class=\"btn btn-xs btn-secondary expand-btn-margin-bottom-03\" ng-click=\"billingRecord.expanded = !billingRecord.expanded; \n                                                                  $ctrl.setStaticBillingEventsRecordsPage(billingRecord.expanded, billingRecord.billingRecordId); \n                                                                  $ctrl.getStaticBillingEventsRecords(billingRecord,billingRecord.billableEventType)\" expand>\n<span ng-if=\"billingRecord.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!billingRecord.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</span>\n<span>{{billingRecord.vaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</span>\n</td>\n<td>\n<span ng-if=\"!billingRecord.branchId\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"billingRecord.branchId\">\n{{billingRecord.branchId}}\n</span>\n<span ng-if=\"billingRecord.routeId\"> |\n<a href=\"#\" ng-click=\"$ctrl.goToRouteTab(billingRecord.routeId, billingRecord.vaultDate)\">{{billingRecord.routeId}}</a>\n</span>\n</td>\n<td>\n<span ng-if=\"!billingRecord.locationId\">{{'common.n_a' | translate}}</span>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(billingRecord.locationId)\">{{billingRecord.locationId}}</a>\n</td>\n<td>{{$ctrl.translateMessage('entry_type.', billingRecord.billableEventType)}}\n<span ng-if=\"billingRecord.contractRuleDescription\">| <b>{{billingRecord.contractRuleDescription}}</b></span>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.serviceOrderNotes(billingRecord)\" uib-tooltip=\"{{'common.notes' | translate}}\" ng-if=\"billingRecord.serviceOrderId\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n{{billingRecord.billingCategoryObj.Key}}\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n{{$ctrl.translateMessage('billableEvents.', billingRecord.billingType)}}\n</td>\n<td class=\"item-date-width-10\">\n<span class=\"text-center\" ng-if=\"billingRecord.scheduleType == 'NONE'\">{{'common.n_a' | translate}}</span>\n<span class=\"text-center\" ng-if=\"billingRecord.scheduleType == 'ANY'\">ANY</span>\n<span class=\"text-success text-center\" ng-if=\"billingRecord.scheduleType == 'SCHEDULED'\">{{'common.scheduled' | translate}}</span>\n<span class=\"text-danger text-center\" ng-if=\"billingRecord.scheduleType == 'UNSCHEDULED'\">{{'billableEvents.UNSCHEDULED' | translate}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"billingRecord.amountDue !== null\">{{billingRecord.amountDue | currency}}</span>\n<span ng-if=\"billingRecord.amountDue == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">\n<span ng-if=\"billingRecord.storedSurcharge != null\" class=\"surcharge-tooltip-trigger\" uib-tooltip-template=\"'recordSurchargeTooltip.html'\" tooltip-enable=\"billingRecord.storedSurchargeBreakdown.length > 0\" tooltip-class=\"surcharge-tooltip\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{billingRecord.storedSurcharge | currency}}<span class=\"glyphicon glyphicon-info-sign surcharge-tooltip-icon\" ng-if=\"billingRecord.storedSurchargeBreakdown.length > 0\"></span></span>\n<span ng-if=\"billingRecord.storedSurcharge == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"billingRecord.locationDistanceId\">{{billingRecord.locationDistanceName}}</span>\n<span ng-if=\"billingRecord.locationDistanceId === null\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"billingRecord.billableEventType == 'coin-conversion'\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.billingRecordId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.coinConversionBillingRecordsLog(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n<span ng-if=\"billingRecord.trackingId || billingRecord.serviceOrderId\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.trackingId || billingRecord.serviceOrderId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.billableEventLogDetails(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId \n                                                            && (!billingRecord.type || billingRecord.type === 'AUTO') && billingRecord.billableEventType !== 'coin-conversion'\">\n{{'common.n_a' | translate}}\n</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId \n                                                            && billingRecord.type === 'MANUAL'\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.billingRecordId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.manuallyCreatedBillingRecordsLog(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n</td>\n<td class=\"remove-white-space\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow']\">\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-disabled=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].isUpdate\" ng-click=\"$ctrl.updateBillingRecords(billingRecord, customer)\">\n<span class=\"glyphicon glyphicon-edit\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.undoApprovedBillingRecords(billingRecord, 'APPROVED', customer)\" ng-disabled=\"$ctrl.undoApprovedBillingRecordsObj[billingRecord.billingRecordId].loading\" uib-tooltip=\"Unapprove\">\n<span class=\"glyphicon glyphicon-repeat\"></span>\n</button>\n</td>\n</tr>\n<tr class=\"text-center\" ng-repeat-end ng-show=\"billingRecord.expanded && ['pre-bill', 'post-bill'].indexOf(billingRecord.billableEventType) > -1\">\n<td colspan=\"12\" ng-if=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].process\">\n<div class=\"text-align-center col-sm-12\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</td>\n<td colspan=\"12\" class=\"remove-pad\" ng-if=\"!$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].process\">\n<div>\n<div class=\"error-msg-padding col-sm-12 alert alert-danger text-center remove-bottom-margin\" ng-if=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.results.length == 0\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n<table class=\"table table-condensed table-bordered remove-bottom-margin _pre-billing-events-history-section\" ng-if=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.results.length > 0\">\n<thead>\n<tr>\n<th class=\"billing-approval-col-w-12 text-center\">\n{{'common.vault_date' | translate}}\n</th>\n<th class=\"text-center remove-white-space\">\n{{'branch_mgmt.billing_approval.branch_route' | translate}}\n</th>\n<th class=\"text-center remove-white-space\">\n{{'item.location' | translate}}\n</th>\n<th class=\"_billing-approval-col-w-12 text-center\">\n{{'billableEvents.menu.title' | translate}}\n</th>\n<th class=\"billing-approval-col-w-12 text-center\">\n{{'branch_mgmt.billing_approval.bill_category' | translate}}\n</th>\n<th class=\"text-center\">\n{{'branch_mgmt.billing_approval.schedule_type' | translate}}\n</th>\n<th class=\"text-center remove-white-space\">\n{{'branch_mgmt.billing_approval.amount_due' | translate}}\n</th>\n<th class=\"text-center remove-white-space\">\n{{'log.menu.title' | translate}}\n</th>\n<th class=\"text-center\">{{'common.action' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"staticBillingEventsRecord in $ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.results\" ng-class=\"{'manual-billing-records-color' : staticBillingEventsRecord.type === 'MANUAL', 'pre-billing-events-history-section' : staticBillingEventsRecord.type !== 'MANUAL'}\">\n<td>{{staticBillingEventsRecord.vaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</td>\n<td>\n<span ng-if=\"!staticBillingEventsRecord.branchId\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"staticBillingEventsRecord.branchId\">{{staticBillingEventsRecord.branchId}}</span>\n<span ng-if=\"staticBillingEventsRecord.routeId\"> |\n<a href=\"#\" ng-click=\"$ctrl.goToRouteTab(staticBillingEventsRecord.routeId, staticBillingEventsRecord.vaultDate)\">{{staticBillingEventsRecord.routeId}}</a>\n</span>\n</td>\n<td>\n<span ng-if=\"!staticBillingEventsRecord.locationId\">{{'common.n_a' | translate}}</span>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(staticBillingEventsRecord.locationId)\">{{staticBillingEventsRecord.locationId}}</a>\n</td>\n<td>{{$ctrl.translateMessage('entry_type.', staticBillingEventsRecord.billableEventType)}}\n<span ng-if=\"staticBillingEventsRecord.contractRuleDescription\">|\n<b>{{staticBillingEventsRecord.contractRuleDescription}}</b></span>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.serviceOrderNotes(staticBillingEventsRecord)\" uib-tooltip=\"{{'common.notes' | translate}}\" ng-if=\"staticBillingEventsRecord.serviceOrderId\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span>{{staticBillingEventsRecord.billingCategoryObj.Key}}</span>\n</td>\n<td class=\"item-date-width-10\">\n<span class=\"text-center\" ng-if=\"staticBillingEventsRecord.scheduleType == 'NONE'\">{{'common.n_a' | translate}}</span>\n<span class=\"text-center\" ng-if=\"staticBillingEventsRecord.scheduleType == 'ANY'\">ANY</span>\n<span class=\"text-success text-center\" ng-if=\"staticBillingEventsRecord.scheduleType == 'SCHEDULED'\">{{'common.scheduled' | translate}}</span>\n<span class=\"text-danger text-center\" ng-if=\"staticBillingEventsRecord.scheduleType == 'UNSCHEDULED'\">{{'billableEvents.UNSCHEDULED' | translate}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\" ng-if=\"staticBillingEventsRecord.billingType === 'COMBINED_TIME'\">\n<span>{{staticBillingEventsRecord.combinedServiceTime}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"staticBillingEventsRecord.amountDue !== null\">{{staticBillingEventsRecord.amountDue | currency}}</span>\n<span ng-if=\"staticBillingEventsRecord.amountDue == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"staticBillingEventsRecord.trackingId || staticBillingEventsRecord.serviceOrderId\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{staticBillingEventsRecord.trackingId || staticBillingEventsRecord.serviceOrderId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.billableEventLogDetails(staticBillingEventsRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n<span ng-if=\"!staticBillingEventsRecord.trackingId && !staticBillingEventsRecord.serviceOrderId  && (!staticBillingEventsRecord.type || staticBillingEventsRecord.type === 'AUTO')\">\n{{'common.n_a' | translate}}\n</span>\n<span ng-if=\"!staticBillingEventsRecord.trackingId && !staticBillingEventsRecord.serviceOrderId && staticBillingEventsRecord.type === 'MANUAL'\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{staticBillingEventsRecord.billingRecordId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.manuallyCreatedBillingRecordsLog(staticBillingEventsRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n</td>\n<td class=\"remove-white-space\">\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-disabled=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].isUpdate\" ng-click=\"$ctrl.updateBillingRecords(staticBillingEventsRecord, customer)\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow']\">\n<span class=\"glyphicon glyphicon-edit\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n<tbody>\n<tr ng-if=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.totalRecords > $ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.pageLimit\">\n<td class=\"location-history-pagination-section\" colspan=\"10\">\n<div class=\"hide-in-print\">\n<ul ng-model=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].page\" uib-pagination total-items=\"$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.totalRecords\" ng-hide=\"{{($ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.totalRecords<=$ctrl.model.staticBillingEventRecordsObj.billingHistory[billingRecord.billingRecordId].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.getStaticBillingEventsRecords(billingRecord, billingRecord.billableEventType)\" max-size=\"10\">\n</ul>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</td>\n</tr>\n</tbody>\n<tbody>\n<tr ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords > $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.pageLimit\">\n<td class=\"location-history-pagination-section\" colspan=\"10\">\n<div class=\"hide-in-print\">\n<ul ng-model=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].page\" uib-pagination total-items=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords\" ng-hide=\"{{($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords<=$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.resetData(customer); $ctrl.getBillingRecords(customer, $event)\" max-size=\"10\"></ul>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10\" ng-if=\"$ctrl.model.approvedCustomerObj.totalApprovedBillablecustomers > 10 && $ctrl.model.billableCustomerObj.results.length && !$ctrl.model.billableCustomerObj.customerHistory.process\">\n<ul class=\"margin-bottom-10\" uib-pagination total-items=\"$ctrl.model.approvedCustomerObj.totalApprovedBillablecustomers\" ng-hide=\"{{($ctrl.model.approvedCustomerObj.totalApprovedBillablecustomers<=$ctrl.model.billableCustomerObj.pagination.pageLimit)&&($ctrl.model.billableCustomerObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.billableCustomerObj.pagination.page\" ng-change=\"$ctrl.billableCustomer()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div ng-if=\"!$ctrl.model.billableCustomerObj.results.length && !$ctrl.model.billableCustomerObj.customerHistory.process\">\n<div class=\"col-sm-12 alert text-center alert-danger\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 margin-bottom-25 _panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.stats.unassigned\">\n<div class=\"col-sm-12 align-center margin-15\" ng-if=\"!$ctrl.model.billableCustomerObj.customerHistory.process\">\n<div class=\"col-sm-4 display-contents btn-group z-index0\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentUnassignedStat\" uib-btn-radio=\"$ctrl.model.unassignedStats.customerAssigned\" ng-click=\"$ctrl.reset(); $ctrl.unassignedTabSelection('customerAssigned')\" ng-class=\"{'btn-success': $ctrl.model.currentUnassignedStat === $ctrl.model.unassignedStats.customerAssigned, \n                                   'remove-btn-grp-color': $ctrl.model.currentUnassignedStat === $ctrl.model.unassignedStats.customerNotAssigned}\">\n{{'branch_mgmt.billing_approval.customer_assigned' | translate}}\n<div class=\"margin-left-10 badge badge-primary count-badge-fixed\">{{$ctrl.model.billableCustomerObj.customerAssignedTotalRecords}}</div>\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentUnassignedStat\" uib-btn-radio=\"$ctrl.model.unassignedStats.customerNotAssigned\" ng-if=\"!$ctrl.isCustomerUser\" ng-click=\"$ctrl.reset(); $ctrl.unassignedTabSelection('customerNotAssigned')\" ng-class=\"{'btn-success': $ctrl.model.currentUnassignedStat === $ctrl.model.unassignedStats.customerNotAssigned, \n                                   'remove-btn-grp-color': $ctrl.model.currentUnassignedStat === $ctrl.model.unassignedStats.customerAssigned}\">\n{{'branch_mgmt.billing_approval.customer_not_assigned' | translate}}\n<div class=\"margin-left-10 badge badge-primary count-badge-fixed\">{{$ctrl.model.unAssignedCustomersBillingRecordsObj.totalRecords}}</div>\n</button>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-10\" ng-if=\"$ctrl.model.filterRecords\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad align-center margin-10\" ng-if=\"!$ctrl.model.unAssignedCustomersBillingRecordsObj.loading && !$ctrl.model.billableCustomerObj.customerHistory.process && !$ctrl.model.filterRecords\">\n<div class=\"remove-left-pad col-sm-3\" style=\"position: relative;z-index: 10;\" ng-if=\"$ctrl.model.currentUnassignedStat == $ctrl.model.unassignedStats.customerAssigned\">\n<search-and-select ng-model=\"$ctrl.model.customerId\" values=\"$ctrl.model.customerListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.customerListObj.totalRecords\" on-click=\"$ctrl.loadUnassignedTabRecords();\" onscroll=\"$ctrl.getCustomerList(searchKey, offset);\" ng-disabled=\"$ctrl.model.customerListObj.loading || $ctrl.isCustomerUser\" none-selected=\"'common.select_customer'\"></search-and-select>\n</div>\n<div class=\"col-sm-3 remove-left-pad\">\n<input type=\"text\" strip-prefix class=\"form-control\" ng-model=\"$ctrl.model.searchText\" name=\"searchText\" on-press-enter=\"$ctrl.loadUnassignedTabRecords();\" placeholder=\"{{'common.locationId' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9 -]*$/\" ng-disabled=\"$ctrl.model.unAssignedCustomersBillingRecordsObj.loading\"/>\n</div>\n<div class=\"col-sm-3 remove-left-pad\">\n<div class=\"multi-select location-branch-dd\" ng-class=\"{'invalid-multi-select-value': !$ctrl.model.branch.length, 'valid-multi-select-value': $ctrl.model.branch.length}\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.model.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.loadUnassignedTabRecords();\" on-select-all=\"$ctrl.loadUnassignedTabRecords();\" on-select-none=\"$ctrl.selectNone();\" on-reset=\"$ctrl.resetSelectedBranch();\" is-disabled=\"$ctrl.model.unAssignedCustomersBillingRecordsObj.loading\">\n</div>\n</div>\n<div class=\"col-sm-3 remove-left-pad\">\n<search-and-select ng-model=\"$ctrl.model.billingEvents\" values=\"$ctrl.model.billingEventListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.billingEventListObj.totalRecords\" on-click=\"$ctrl.loadUnassignedTabRecords();\" onscroll=\"$ctrl.getBillingEventsList(searchKey, offset);\" ng-disabled=\"$ctrl.model.billingEventListObj.loading\" none-selected=\"'(Select Billable Events)'\"></search-and-select>\n</div>\n<div class=\"col-sm-3 remove-left-pad\">\n<search-and-select ng-model=\"$ctrl.model.billingCategory\" values=\"$ctrl.model.billingCategoryObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.billingCategoryObj.totalRecords\" on-click=\"$ctrl.loadUnassignedTabRecords();\" onscroll=\"$ctrl.getBillingCategory(searchKey, offset);\" ng-disabled=\"$ctrl.model.billingCategoryObj.loading\" none-selected=\"'(Select Billing Category)'\"></search-and-select>\n</div>\n<div class=\"col-sm-3 remove-left-pad billing-unassigned-date-picker\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" options=\"$ctrl.model.dateRangPickerOptionsfor\" ng-change=\"$ctrl.loadUnassignedTabRecords();\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled': $ctrl.model.billableCustomerObj.loading}\"/>\n</div>\n<div ng-if=\"$ctrl.model.currentUnassignedStat === $ctrl.model.unassignedStats.customerAssigned && $ctrl.model.billableCustomerObj.results.length > 0\">\n<button type=\"button\" id=\"export-btn-unassigned\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportBillingRecords()\" ng-disabled=\"$ctrl.model.billableCustomerObj.loading\">\n<span id=\"export-btn-loading-unassigned\"></span>\n{{'common.export' | translate}}</button>\n</div>\n<div ng-if=\"$ctrl.model.currentUnassignedStat === $ctrl.model.unassignedStats.customerNotAssigned && $ctrl.model.unAssignedCustomersBillingRecordsObj.records.length > 0\">\n<button type=\"button\" id=\"export-btn-unassigned\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportBillingRecords()\" ng-disabled=\"$ctrl.model.billableCustomerObj.loading\">\n<span id=\"export-btn-loading-unassigned\"></span>\n{{'common.export' | translate}}</button>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.stats.unassigned && \n                    $ctrl.model.currentUnassignedStat === $ctrl.model.unassignedStats.customerAssigned &&\n                    !$ctrl.model.filterRecords\">\n<div class=\"text-align-center col-sm-12 margin-10\" ng-if=\"$ctrl.model.billableCustomerObj.customerHistory.process\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<table class=\"table table-pad-4 table-striped table-hover table-bordered remove-bottom-pad margin-10\" ng-if=\"!$ctrl.model.billableCustomerObj.customerHistory.process && $ctrl.model.billableCustomerObj.results.length\">\n<thead>\n<tr>\n<th class=\"text-center\">{{'bagout.customer' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.location_serviced' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.billing_events' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.total_billing' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat-start=\"customer in $ctrl.model.billableCustomerObj.results track by $index\">\n<td>\n<span class=\"col-sm-1 remove-left-pad\">\n<button id=\"expand-btn-{{customer.customerId}}\" class=\"btn btn-xs btn-secondary\" ng-click=\"customer.expanded = !customer.expanded; $ctrl.setPage(customer.expanded, customer.customerId); $ctrl.getBillingRecords(customer, $event)\" expand>\n<span ng-if=\"customer.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!customer.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</span>\n<span class=\"col-sm-10 text-center _remove-left-pad\">{{customer.customerId}} | {{customer.customerName}}</span>\n</td>\n<td class=\"text-center\">{{customer.totalLocationServiced}}</td>\n<td class=\"text-center\">{{customer.totalBillableEvents}}</td>\n<td class=\"text-center\">\n<span ng-if=\"customer.totalAmount !== null\">{{customer.totalAmount | currency}}</span>\n<span ng-if=\"customer.totalAmount == null\">{{'common.n_a' | translate}}</span>\n</td>\n</tr>\n<tr class=\"text-center\" ng-repeat-end ng-show=\"customer.expanded\">\n<td colspan=\"9\" ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].process\">\n<div class=\"text-align-center col-sm-12\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</td>\n<td colspan=\"10\" class=\"remove-pad\" ng-if=\"!$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].process\">\n<div>\n<table class=\"table table-condensed table-bordered remove-bottom-margin\" ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.results.length > 0\">\n<thead>\n<tr>\n<th colspan=\"1\" class=\"col-width-08 text-center remove-white-space\" ng-click=\"$ctrl.sortData('vaultDate', customer, $event)\">\n{{'common.vault_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'vaultDate'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('routeId', customer, $event)\">\n{{'branch_mgmt.billing_approval.branch_route' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeId'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('locationId', customer, $event)\">\n{{'item.location' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortData('billableEventType', customer, $event)\">\n{{'billableEvents.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billableEventType'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortData('billingCategory', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_category' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingCategory'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('billingType', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingType'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('scheduleType', customer, $event)\">\n{{'branch_mgmt.billing_approval.schedule_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'scheduleType'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('locationDistanceName',customer,$event)\">\n{{'locationDistance.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationDistanceName'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('amountDue', customer, $event)\">\n{{'branch_mgmt.billing_approval.amount_due' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountDue'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{'surchargeDetailsModal.surcharge' | translate}}</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('trackingId', customer, $event)\">\n{{'log.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'trackingId'}\"></span>\n</th>\n<th class=\"text-center w-10\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow']\">\n{{'shipmentBatch.action' | translate}}\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"billingRecord in $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.results\">\n<td>{{billingRecord.vaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</td>\n<td>{{billingRecord.branchId}}\n<span ng-if=\"billingRecord.routeId\"> |\n<a href=\"#\" ng-click=\"$ctrl.goToRouteTab(billingRecord.routeId, billingRecord.vaultDate)\">{{billingRecord.routeId}}</a>\n</span>\n</td>\n<td><a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(billingRecord.locationId)\">{{billingRecord.locationId}}</a></td>\n<td>{{$ctrl.translateMessage('entry_type.', billingRecord.billableEventType)}}\n<span ng-if=\"billingRecord.contractRuleDescription\">| <b>{{billingRecord.contractRuleDescription}}</b></span>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.serviceOrderNotes(billingRecord)\" uib-tooltip=\"{{'common.notes' | translate}}\" ng-if=\"billingRecord.serviceOrderId\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span>{{billingRecord.billingCategoryObj.Key}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"billingRecord.billingType\">\n{{$ctrl.translateMessage('billableEvents.', billingRecord.billingType)}}\n</span>\n<span class=\"text-center\" ng-if=\"!billingRecord.billingType\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"item-date-width-10\">\n<span class=\"text-center\" ng-if=\"billingRecord.scheduleType == 'NONE'\">{{'common.n_a' | translate}}</span>\n<span class=\"text-center\" ng-if=\"billingRecord.scheduleType == 'ANY'\">ANY</span>\n<span class=\"text-success text-center\" ng-if=\"billingRecord.scheduleType == 'SCHEDULED'\">{{'common.scheduled' | translate}}</span>\n<span class=\"text-danger text-center\" ng-if=\"billingRecord.scheduleType == 'UNSCHEDULED'\">{{'billableEvents.UNSCHEDULED' | translate}}</span>\n</td>\n<td class=\"remove-white-space\">\n<span ng-if=\"billingRecord.locationDistanceId\">{{billingRecord.locationDistanceName}}</span>\n<span ng-if=\"billingRecord.locationDistanceId === null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span>{{billingRecord.amountDue | currency}}</span>\n<span class=\"text-center\" ng-if=\"billingRecord.amountDue === null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">\n<span ng-if=\"billingRecord.storedSurcharge != null\" class=\"surcharge-tooltip-trigger\" uib-tooltip-template=\"'recordSurchargeTooltip.html'\" tooltip-enable=\"billingRecord.storedSurchargeBreakdown.length > 0\" tooltip-class=\"surcharge-tooltip\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{billingRecord.storedSurcharge | currency}}<span class=\"glyphicon glyphicon-info-sign surcharge-tooltip-icon\" ng-if=\"billingRecord.storedSurchargeBreakdown.length > 0\"></span></span>\n<span ng-if=\"billingRecord.storedSurcharge == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"billingRecord.billableEventType == 'coin-conversion'\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.billingRecordId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.coinConversionBillingRecordsLog(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n<span ng-if=\"billingRecord.trackingId || billingRecord.serviceOrderId\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.trackingId || billingRecord.serviceOrderId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.billableEventLogDetails(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId \n                                                             && (!billingRecord.type || billingRecord.type === 'AUTO') && billingRecord.billableEventType !== 'coin-conversion'\">\n{{'common.n_a' | translate}}\n</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId \n                                                             && billingRecord.type === 'MANUAL'\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.billingRecordId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.manuallyCreatedBillingRecordsLog(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n</td>\n<td class=\"remove-white-space\">\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow']\" ng-click=\"$ctrl.updateBillingRecords(billingRecord, customer)\">\n<span class=\"glyphicon glyphicon-edit\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_delete_billing_record']['allow']\" ng-click=\"$ctrl.deleteBillingRecords(billingRecord, 'ASSIGNED', customer)\" ng-disabled=\"$ctrl.deleteBillingRecordsObj[billingRecord.billingRecordId].loading\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n<tbody>\n<tr ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords > $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.pageLimit\">\n<td class=\"location-history-pagination-section\" colspan=\"10\">\n<div class=\"hide-in-print\">\n<ul ng-model=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].page\" uib-pagination total-items=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords\" ng-hide=\"{{($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords<=$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.resetData(customer); $ctrl.getBillingRecords(customer, $event)\" max-size=\"10\"></ul>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.results.length === 0 && \n                                          !$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].process\">\n<div class=\"col-sm-12 alert text-center alert-danger error-msg-padding _margin-10\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10\" ng-if=\"$ctrl.model.unassignedCustomerObj.totalUnAssignedBillableCustomers > 10 && !$ctrl.model.unAssignedCustomersBillingRecordsObj.loading && !$ctrl.model.billableCustomerObj.customerHistory.process\">\n<ul class=\"margin-bottom-10\" uib-pagination total-items=\"$ctrl.model.unassignedCustomerObj.totalUnAssignedBillableCustomers\" ng-hide=\"{{($ctrl.model.unassignedCustomerObj.totalUnAssignedBillableCustomers<=$ctrl.model.billableCustomerObj.pagination.pageLimit)&&($ctrl.model.billableCustomerObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.billableCustomerObj.pagination.page\" ng-change=\"$ctrl.filterRecords()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div ng-if=\"!$ctrl.model.billableCustomerObj.results.length && !$ctrl.model.billableCustomerObj.customerHistory.process\">\n<div class=\"col-sm-12 alert text-center alert-danger margin-10\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.unAssignedCustomersBillingRecordsObj.loading &&\n                        $ctrl.model.currentUnassignedStat == $ctrl.model.unassignedStats.customerNotAssigned\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding table-margin-top-10 table-responsive\" ng-if=\"$ctrl.model.currentUnassignedStat == $ctrl.model.unassignedStats.customerNotAssigned && $ctrl.model.unAssignedCustomersBillingRecordsObj.records.length > 0 &&\n                      !$ctrl.model.unAssignedCustomersBillingRecordsObj.loading\">\n<table class=\"table table-striped table-bordered billing-records-table-pad-4 customer-not-assigned-padding\">\n<thead>\n<tr>\n<th colspan=\"1\" class=\"col-width-08 text-center remove-white-space\" ng-click=\"$ctrl.sortUnassignedCustomerBillingRecords('vaultDate', customer, $event)\">\n{{'common.vault_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'vaultDate'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortUnassignedCustomerBillingRecords('routeId', customer, $event)\">\n{{'branch_mgmt.billing_approval.branch_route' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeId'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortUnassignedCustomerBillingRecords('locationId', customer, $event)\">\n{{'item.location' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortUnassignedCustomerBillingRecords('billableEventType', customer, $event)\">\n{{'billableEvents.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billableEventType'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortUnassignedCustomerBillingRecords('billingCategory', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_category' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingCategory'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortUnassignedCustomerBillingRecords('billingType', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingType'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortUnassignedCustomerBillingRecords('scheduleType', customer, $event)\">\n{{'branch_mgmt.billing_approval.schedule_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'scheduleType'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortUnassignedCustomerBillingRecords('locationDistanceName',customer,$event)\">\n{{'locationDistance.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationDistanceName'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortUnassignedCustomerBillingRecords('amountDue', customer, $event)\">\n{{'branch_mgmt.billing_approval.amount_due' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountDue'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortUnassignedCustomerBillingRecords('trackingId', customer, $event)\">\n{{'log.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'trackingId'}\"></span>\n</th>\n<th class=\"text-center col-width-08\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow']\">\n{{'shipmentBatch.action' | translate}}\n</th>\n</tr>\n</thead>\n<tbody class=\"billing-records-table-pad-4\">\n<tr ng-repeat=\"billingRecord in $ctrl.model.unAssignedCustomersBillingRecordsObj.records\">\n<td class=\"text-center remove-white-space\">{{billingRecord.vaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</td>\n<td class=\"text-center\">{{billingRecord.branchId}}\n<span ng-if=\"billingRecord.routeId\"> |\n<a href=\"#\" ng-click=\"$ctrl.goToRouteTab(billingRecord.routeId, billingRecord.vaultDate)\">{{billingRecord.routeId}}</a>\n</span>\n</td>\n<td class=\"text-center\"><a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(billingRecord.locationId)\">{{billingRecord.locationId}}</a></td>\n<td class=\"text-center\">{{$ctrl.translateMessage('entry_type.', billingRecord.billableEventType)}}\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.serviceOrderNotes(billingRecord)\" uib-tooltip=\"{{'common.notes' | translate}}\" ng-if=\"billingRecord.serviceOrderId\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10 text-center\">\n<span ng-if=\"!billingRecord.isEdit\">{{billingRecord.billingCategoryObj.Key}}</span>\n<span class=\"billing-category-dd-padding\" ng-if=\"billingRecord.isEdit\">\n<select class=\"form-control\" ng-model=\"billingRecord.billingCategoryObj.Key\" ng-options=\"category.Key as category.Key for category in $ctrl.model.billingCategoryObj.results\" ng-disabled=\"$ctrl.model.billingCategoryObj.loading\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10 text-center\">\n<span ng-if=\"!billingRecord.isEdit\">\n{{$ctrl.translateMessage('billableEvents.', billingRecord.billingType)}}\n</span>\n<span class=\"billing-category-dd-padding\" ng-if=\"billingRecord.isEdit\">\n<select class=\"form-control\" ng-model=\"billingRecord.billingType\" ng-options=\"billingType.value as billingType.label for billingType in $ctrl.model.billingTypeList\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</span>\n<span class=\"text-center\" ng-if=\"!billingRecord.billingType\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"item-date-width-10 text-center\">\n<span ng-if=\"billingRecord.scheduleType == 'NONE'\">{{'common.n_a' | translate}}</span>\n<span class=\"text-center\" ng-if=\"billingRecord.scheduleType == 'ANY'\">ANY</span>\n<span class=\"text-success\" ng-if=\"billingRecord.scheduleType == 'SCHEDULED'\">{{'common.scheduled' | translate}}</span>\n<span class=\"text-danger\" ng-if=\"billingRecord.scheduleType == 'UNSCHEDULED'\">{{'billableEvents.UNSCHEDULED' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"billingRecord.locationDistanceId\">{{billingRecord.locationDistanceName}}</span>\n<span ng-if=\"billingRecord.locationDistanceId === null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10 text-center\">\n<span ng-if=\"billingRecord.isEdit\">\n<input class=\"form-control\" type=\"test\" ng-model=\"billingRecord.amountDue\" ng-currency required>\n</span>\n<span ng-if=\"!billingRecord.isEdit\">{{billingRecord.amountDue | currency}}</span>\n<span class=\"text-center\" ng-if=\"billingRecord.amountDue === null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"billingRecord.billableEventType == 'coin-conversion'\">\n<a href=\"#\" ng-click=\"$ctrl.coinConversionBillingRecordsLog(billingRecord)\">\n<span>{{billingRecord.billingRecordId}}</span>\n</a>\n</span>\n<span ng-if=\"billingRecord.trackingId || billingRecord.serviceOrderId\">\n<a href=\"#\" ng-click=\"$ctrl.billableEventLogDetails(billingRecord)\">\n<span ng-if=\"billingRecord.trackingId\">{{billingRecord.trackingId}}</span>\n<span ng-if=\"billingRecord.serviceOrderId\">{{billingRecord.serviceOrderId}}</span>\n</a>\n</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId && (!billingRecord.type || billingRecord.type === 'AUTO') && billingRecord.billableEventType !== 'coin-conversion'\">\n{{'common.n_a' | translate}}\n</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId \n                                          && billingRecord.type === 'MANUAL'\">\n<a href=\"#\" ng-click=\"$ctrl.manuallyCreatedBillingRecordsLog(billingRecord)\">\n<span>{{billingRecord.billingRecordId}}</span>\n</a>\n</span>\n</td>\n<td class=\"text-center remove-white-space\">\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-disabled=\"$ctrl.model.billingRecordsObj.loading\" ng-click=\"$ctrl.updateCustomerNotAssignBillingRecords(billingRecord)\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow']\">\n<span class=\"glyphicon glyphicon-edit\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.deleteBillingRecords(billingRecord, 'NOT_ASSIGNED')\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.unAssignedCustomersBillingRecordsObj.totalRecords > 10 && \n                        $ctrl.model.currentUnassignedStat == $ctrl.model.unassignedStats.customerNotAssigned &&\n                        !$ctrl.model.unAssignedCustomersBillingRecordsObj.loading\">\n<ul uib-pagination total-items=\"$ctrl.model.unAssignedCustomersBillingRecordsObj.totalRecords\" ng-hide=\"{{($ctrl.model.unAssignedCustomersBillingRecordsObj.totalRecords<=$ctrl.model.unAssignedCustomersBillingRecordsObj.pagination.pageLimit)&&($ctrl.model.unAssignedCustomersBillingRecordsObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.unAssignedCustomersBillingRecordsObj.pagination.page\" ng-change=\"$ctrl.getUnassignedCustomerBillingRecords()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n<div class=\"margin-10\" ng-if=\"$ctrl.model.currentUnassignedStat == $ctrl.model.unassignedStats.customerNotAssigned &&\n                                 $ctrl.model.unAssignedCustomersBillingRecordsObj.records.length === 0 &&\n                                 !$ctrl.model.unAssignedCustomersBillingRecordsObj.loading\">\n<div class=\"col-sm-12 alert text-center alert-danger\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-25 _panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.stats.deleted\">\n<div class=\"text-align-center col-sm-12\" ng-if=\"$ctrl.model.rejectedBillingRecordsObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<table class=\"table table-condensed table-bordered remove-bottom-margin table-pad-5\" ng-if=\"$ctrl.model.rejectedBillingRecordsObj.records.length > 0 && !$ctrl.model.rejectedBillingRecordsObj.loading\">\n<thead>\n<tr>\n<th colspan=\"1\" class=\"billing-approval-col-w-8 text-center\" ng-click=\"$ctrl.sortRejectedBillingRecords('vaultDate', customer, $event)\">\n{{'common.vault_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'vaultDate'}\"></span>\n</th>\n<th colspan=\"1\" class=\"billing-approval-col-w-8 text-center billing-approval-col-w-12\" ng-click=\"$ctrl.sortRejectedBillingRecords('customerId', customer, $event)\">\n{{'checkin.customer' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'customerId'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortRejectedBillingRecords('branchId', customer, $event)\">\n{{'route.branchId' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'branchId'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortRejectedBillingRecords('locationId', customer, $event)\">\n{{'item.location' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center\" ng-click=\"$ctrl.sortRejectedBillingRecords('billableEventType', customer, $event)\">\n{{'billableEvents.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billableEventType'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center\" ng-click=\"$ctrl.sortRejectedBillingRecords('billingCategory', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_category' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingCategory'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortRejectedBillingRecords('billingType', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingType'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortRejectedBillingRecords('amountDue', customer, $event)\">\n{{'branch_mgmt.billing_approval.amount_due' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountDue'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortRejectedBillingRecords('deletedByUserId', customer, $event)\">\n{{'softDeletedShipments.deleted_by' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'deletedByUserId'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortRejectedBillingRecords('trackingId', customer, $event)\">\n{{'log.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'trackingId'}\"></span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-class=\"{'manual-billing-records-color' : billingRecord.type === 'MANUAL'}\" ng-repeat=\"billingRecord in $ctrl.model.rejectedBillingRecordsObj.records\">\n<td class=\"text-center _check-box-col-width expand-btn-section\">\n<span>{{billingRecord.vaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"!billingRecord.customerId\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"billingRecord.customerId\">{{billingRecord.customerId}} | {{billingRecord.customerName}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"!billingRecord.branchId\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"billingRecord.branchId\">{{billingRecord.branchId}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"!billingRecord.locationId\">{{'common.n_a' | translate}}</span>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(billingRecord.locationId)\">{{billingRecord.locationId}}</a>\n</td>\n<td class=\"text-center\">{{$ctrl.translateMessage('entry_type.', billingRecord.billableEventType)}}\n<span ng-if=\"billingRecord.contractRuleDescription\">| <b>{{billingRecord.contractRuleDescription}}</b></span>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.serviceOrderNotes(billingRecord)\" uib-tooltip=\"{{'common.notes' | translate}}\" ng-if=\"billingRecord.serviceOrderId\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10 text-center\">{{billingRecord.billingCategoryObj.Key}}</td>\n<td class=\"billing-rate-input-section item-date-width-10 text-center\">\n<span ng-if=\"billingRecord.billingType\">{{$ctrl.translateMessage('billableEvents.', billingRecord.billingType)}}</span>\n<span ng-if=\"!billingRecord.billingType\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10 text-center\">\n<span ng-if=\"billingRecord.amountDue !== null\">{{billingRecord.amountDue | currency}}</span>\n<span ng-if=\"billingRecord.amountDue == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span>{{billingRecord.deletedByUserId}} | {{billingRecord.deletedByUserName}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"billingRecord.trackingId || billingRecord.serviceOrderId\">\n<a href=\"#\" ng-click=\"$ctrl.billableEventLogDetails(billingRecord)\">\n<span ng-if=\"billingRecord.trackingId\">{{billingRecord.trackingId}}</span>\n<span ng-if=\"billingRecord.serviceOrderId\">{{billingRecord.serviceOrderId}}</span>\n</a>\n</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId \n                                     && (!billingRecord.type || billingRecord.type === 'AUTO')\">\n{{'common.n_a' | translate}}\n</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId \n                                      && billingRecord.type === 'MANUAL'\">\n<a href=\"#\" ng-click=\"$ctrl.manuallyCreatedBillingRecordsLog(billingRecord)\">\n<span>{{billingRecord.billingRecordId}}</span>\n</a>\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10\" ng-if=\"$ctrl.model.rejectedBillingRecordsObj.totalRecords > 10 && !$ctrl.model.rejectedBillingRecordsObj.loading\">\n<ul class=\"margin-bottom-10\" uib-pagination total-items=\"$ctrl.model.rejectedBillingRecordsObj.totalRecords\" ng-hide=\"{{($ctrl.model.rejectedBillingRecordsObj.totalRecords<=$ctrl.model.rejectedBillingRecordsObj.pagination.pageLimit)&&($ctrl.model.rejectedBillingRecordsObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.rejectedBillingRecordsObj.pagination.page\" ng-change=\"$ctrl.getRejectedRecords()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div ng-if=\"!$ctrl.model.rejectedBillingRecordsObj.totalRecords > 0 && !$ctrl.model.rejectedBillingRecordsObj.loading\">\n<div class=\"col-sm-12 alert text-center alert-danger\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-25 _panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.stats.review\">\n<div class=\"text-align-center col-sm-12\" ng-if=\"$ctrl.model.billableCustomerObj.customerHistory.process\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<table class=\"table table-pad-4 table-striped table-hover table-bordered remove-bottom-pad margin-10\" ng-if=\"!$ctrl.model.billableCustomerObj.customerHistory.process && $ctrl.model.billableCustomerObj.results.length\">\n<thead>\n<tr>\n<th class=\"text-center\"></th>\n<th class=\"text-center\">{{'bagout.customer' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.location_serviced' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.billing_events' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.total_billing' | translate}}</th>\n<th class=\"text-center projected-surcharge-col\" ng-if=\"$ctrl.model.hasActiveSurcharge\">{{'branch_mgmt.billing_approval.projected_surcharge' | translate}}</th>\n<th class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{'branch_mgmt.billing_approval.total_surcharge' | translate}}</th>\n<th class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{'branch_mgmt.billing_approval.total_pending' | translate}}\n<span class=\"glyphicon glyphicon-info-sign total-pending-info\" uib-tooltip=\"{{'branch_mgmt.billing_approval.total_pending_info' | translate}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"></span>\n</th>\n<th class=\"text-center\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_approve_billing_record']['allow']\">{{'shipmentBatch.action' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat-start=\"customer in $ctrl.model.billableCustomerObj.results track by $index\">\n<td class=\"text-center check-box-col-width\"><input type=\"checkbox\" ng-model=\"customer.isSelected\" ng-click=\"customer.isSelected = !customer.isSelected; $ctrl.selectAllBillingRecords(customer, $index)\">\n</td>\n<td>\n<span class=\"col-sm-1 remove-left-pad\">\n<button id=\"expand-btn-{{customer.customerId}}\" class=\"btn btn-xs btn-secondary\" ng-click=\"customer.expanded = !customer.expanded; $ctrl.setPage(customer.expanded, customer.customerId); $ctrl.getBillingRecords(customer, $event)\" expand>\n<span ng-if=\"customer.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!customer.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</span>\n<span class=\"col-sm-10 text-center _remove-left-pad\">{{customer.customerId}} | {{customer.customerName}}</span>\n</td>\n<td class=\"text-center\">{{customer.totalLocationServiced}}</td>\n<td class=\"text-center\">{{customer.totalBillableEvents}}</td>\n<td class=\"text-center\">\n<span ng-if=\"customer.totalAmount !== null\">{{customer.totalAmount | currency}}</span>\n<span ng-if=\"customer.totalAmount == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center projected-surcharge-col\" ng-if=\"$ctrl.model.hasActiveSurcharge\">\n<a href ng-if=\"customer.surchargeBreakdown.length\" ng-click=\"$ctrl.showSurchargeDetails(customer)\">{{customer.totalSurcharge | currency}}</a>\n<span ng-if=\"!customer.surchargeBreakdown.length\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">\n<a href ng-if=\"customer.storedSurchargeBreakdown.length\" ng-click=\"$ctrl.showStoredSurchargeDetails(customer)\">{{customer.storedSurcharge | currency}}</a>\n<span ng-if=\"!customer.storedSurchargeBreakdown.length && customer.surchargeBreakdown.length\">{{customer.storedSurcharge | currency}}</span>\n<span ng-if=\"!customer.storedSurchargeBreakdown.length && !customer.surchargeBreakdown.length\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{(customer.totalAmount * 1 || 0) + (customer.storedSurcharge || 0) | currency}}</td>\n<td class=\"text-center\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_approve_billing_record']['allow']\">\n<button id=\"approve-all-{{customer.customerId}}\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.billingRecordApproval(customer)\" ng-disabled=\"(!customer.expanded || !$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected ||\n                                             $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected === 1) && !customer.isSelected\">\n<span class=\"glyphicon glyphicon glyphicon-ok\"></span>\n<span ng-if=\"($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected === \n                                              $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords) || \n                                             (!$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected ||\n                                             $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected === 1) ||\n                                             ($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected && customer.isSelected)\">\n{{'branch_mgmt.billing_approval.approve_all' | translate}}\n</span>\n<span ng-if=\"($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected !== \n                                              $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords && !customer.isSelected) && \n                                             ($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected > 1)\">\n{{'common.approve' | translate}}\n<span>({{$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected}})</span>\n</span>\n</button>\n</td>\n</tr>\n<tr class=\"text-center\" ng-repeat-end ng-show=\"customer.expanded\">\n<td colspan=\"10\" ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].process\">\n<div class=\"text-align-center col-sm-12\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</td>\n<td colspan=\"10\" class=\"remove-pad\" ng-if=\"!$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].process\">\n<div>\n<table class=\"table table-condensed table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th colspan=\"2\" class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortData('vaultDate', customer, $event)\">\n{{'common.vault_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'vaultDate'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('routeId', customer, $event)\">\n{{'branch_mgmt.billing_approval.branch_route' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeId'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('locationId', customer, $event)\">\n{{'item.location' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortData('billableEventType', customer, $event)\">\n{{'billableEvents.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billableEventType'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortData('billingCategory', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_category' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingCategory'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('billingType', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingType'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('scheduleType', customer, $event)\">\n{{'branch_mgmt.billing_approval.schedule_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'scheduleType'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('amountDue', customer, $event)\">\n{{'branch_mgmt.billing_approval.amount_due' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountDue'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{'surchargeDetailsModal.surcharge' | translate}}</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('locationDistanceName',customer,$event)\">\n{{'locationDistance.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationDistanceName'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('serviceOrderId', customer, $event)\">\n{{'log.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'serviceOrderId'}\"></span>\n</th>\n<th class=\"text-center billing-approval-col-w-12\" ng-class=\"{'billing-approval-col-w-9' : !billingRecord.isEdit, 'billing-approval-col-w-12' : billingRecord.isEdit}\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_approve_billing_record']['allow'] || \n                                            $ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow'] || \n                                            $ctrl.hasACL['branch_mgmt_billing_approval_delete_billing_record']['allow']\">\n{{'shipmentBatch.action' | translate}}\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-class=\"{'manual-billing-records-color' : billingRecord.type === 'MANUAL'}\" ng-repeat-start=\"billingRecord in $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.results\">\n<td class=\"text-center _check-box-col-width expand-btn-section\">\n<input type=\"checkbox\" ng-model=\"billingRecord.isSelected\" ng-click=\"billingRecord.isSelected = !billingRecord.isSelected; $ctrl.validateBillingRecordSelection(billingRecord, customer)\">\n<button id=\"expand-btn-{{billingRecord.billingRecordId}}\" class=\"btn btn-xs btn-secondary expand-btn-margin-bottom-03\" ng-click=\"billingRecord.expanded = !billingRecord.expanded; $ctrl.setStaticBillingEventsRecordsPage(billingRecord.expanded, billingRecord.billingRecordId); \n                                                              $ctrl.getStaticBillingEventsRecords(billingRecord, billingRecord.billableEventType)\" ng-show=\"['pre-bill', 'post-bill'].indexOf(billingRecord.billableEventType) > -1 && billingRecord.type !== 'MANUAL'\" expand>\n<span ng-if=\"billingRecord.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!billingRecord.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</td>\n<td class=\"remove-white-space\">{{billingRecord.vaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</td>\n<td>\n<span ng-if=\"!billingRecord.branchId\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"billingRecord.branchId\">\n{{billingRecord.branchId}}\n</span>\n<span ng-if=\"billingRecord.routeId\"> |\n<a href=\"#\" ng-click=\"$ctrl.goToRouteTab(billingRecord.routeId, billingRecord.vaultDate)\">{{billingRecord.routeId}}</a>\n</span>\n</td>\n<td>\n<span ng-if=\"!billingRecord.locationId\">{{'common.n_a' | translate}}</span>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(billingRecord.locationId)\">{{billingRecord.locationId}}</a>\n</td>\n<td>{{$ctrl.translateMessage('entry_type.', billingRecord.billableEventType)}}\n<span ng-if=\"billingRecord.contractRuleDescription\">| <b>{{billingRecord.contractRuleDescription}}</b></span>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.serviceOrderNotes(billingRecord)\" uib-tooltip=\"{{'common.notes' | translate}}\" ng-if=\"billingRecord.serviceOrderId\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"!billingRecord.isEdit\">{{billingRecord.billingCategoryObj.Key}}</span>\n<span class=\"billing-category-dd-padding\" ng-if=\"billingRecord.isEdit\">\n<select class=\"form-control\" ng-model=\"billingRecord.billingCategoryObj.Key\" ng-options=\"category.Key as category.Key for category in $ctrl.model.billingCategoryObj.results\" ng-disabled=\"$ctrl.model.billingCategoryObj.loading\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"!billingRecord.isEdit\">\n{{$ctrl.translateMessage('billableEvents.', billingRecord.billingType)}}\n</span>\n<span class=\"billing-category-dd-padding\" ng-if=\"billingRecord.isEdit\">\n<select class=\"form-control\" ng-model=\"billingRecord.billingType\" ng-options=\"billingType.value as billingType.label for billingType in $ctrl.model.billingTypeList\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</span>\n</td>\n<td class=\"item-date-width-10\">\n<span class=\"text-center\" ng-if=\"billingRecord.scheduleType == 'NONE'\">{{'common.n_a' | translate}}</span>\n<span class=\"text-center\" ng-if=\"billingRecord.scheduleType == 'ANY'\">ANY</span>\n<span class=\"text-success text-center\" ng-if=\"billingRecord.scheduleType == 'SCHEDULED'\">{{'common.scheduled' | translate}}</span>\n<span class=\"text-danger text-center\" ng-if=\"billingRecord.scheduleType == 'UNSCHEDULED'\">{{'billableEvents.UNSCHEDULED' | translate}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"billingRecord.amountDue !== null\">{{billingRecord.amountDue | currency}}</span>\n<span ng-if=\"billingRecord.amountDue == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">\n<span ng-if=\"billingRecord.storedSurcharge != null\" class=\"surcharge-tooltip-trigger\" uib-tooltip-template=\"'recordSurchargeTooltip.html'\" tooltip-enable=\"billingRecord.storedSurchargeBreakdown.length > 0\" tooltip-class=\"surcharge-tooltip\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{billingRecord.storedSurcharge | currency}}<span class=\"glyphicon glyphicon-info-sign surcharge-tooltip-icon\" ng-if=\"billingRecord.storedSurchargeBreakdown.length > 0\"></span></span>\n<span ng-if=\"billingRecord.storedSurcharge == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td ng-if=\"billingRecord.billingType !== 'COMBINED_TIME'\">\n<span ng-if=\"billingRecord.locationDistanceId\">{{billingRecord.locationDistanceName}}</span>\n<span ng-if=\"billingRecord.locationDistanceId === null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\" ng-if=\"billingRecord.billingType === 'COMBINED_TIME'\">\n<span>{{billingRecord.combinedServiceTime}}\n<span ng-if=\"billingRecord.locationDistanceId\">({{billingRecord.locationDistanceName}})</span>\n</span>\n</td>\n<td>\n<span ng-if=\"billingRecord.trackingId || billingRecord.serviceOrderId\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.trackingId || billingRecord.serviceOrderId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.billableEventLogDetails(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId && (!billingRecord.type || billingRecord.type === 'AUTO')\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"!billingRecord.trackingId && !billingRecord.serviceOrderId && billingRecord.type === 'MANUAL'\">\n<a href=\"#\" class=\"billing-log-link\" uib-tooltip=\"{{billingRecord.billingRecordId}}\" tooltip-append-to-body=\"true\" ng-click=\"$ctrl.manuallyCreatedBillingRecordsLog(billingRecord)\">\n<span class=\"glyphicon glyphicon-file\"></span>\n</a>\n</span>\n</td>\n<td class=\"remove-white-space\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_approve_billing_record']['allow'] || \n                                            $ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow'] || \n                                            $ctrl.hasACL['branch_mgmt_billing_approval_delete_billing_record']['allow']\">\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.billingRecordApproval(customer, billingRecord)\" ng-disabled=\"($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected > 1) || \n                                                        ($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecordSelected === 1 && !billingRecord.isSelected || customer.isSelected) \" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_approve_billing_record']['allow']\">\n<span class=\"glyphicon glyphicon glyphicon-ok\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-disabled=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].isUpdate\" ng-click=\"$ctrl.updateBillingRecords(billingRecord, customer)\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_edit_billing_record']['allow']\">\n<span class=\"glyphicon glyphicon-edit\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-if=\"$ctrl.hasACL['branch_mgmt_billing_approval_delete_billing_record']['allow']\" ng-click=\"$ctrl.deleteBillingRecords(billingRecord, 'REVIEW', customer)\" ng-disabled=\"$ctrl.deleteBillingRecordsObj[billingRecord.billingRecordId].loading\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</td>\n</tr>\n<tr ng-repeat-end></tr>\n</tbody>\n<tbody>\n<tr ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords > $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.pageLimit\">\n<td class=\"location-history-pagination-section\" colspan=\"10\">\n<div class=\"hide-in-print\">\n<ul ng-model=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].page\" uib-pagination total-items=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords\" ng-hide=\"{{($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords<=$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.resetData(customer); $ctrl.getBillingRecords(customer, $event)\" max-size=\"10\"></ul>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10\" ng-if=\"$ctrl.model.reviewCustomerObj.totalReviewBillablecustomers > 10 && $ctrl.model.billableCustomerObj.results.length && !$ctrl.model.billableCustomerObj.customerHistory.process\">\n<ul class=\"margin-bottom-10\" uib-pagination total-items=\"$ctrl.model.reviewCustomerObj.totalReviewBillablecustomers\" ng-hide=\"{{($ctrl.model.reviewCustomerObj.totalReviewBillablecustomers<=$ctrl.model.billableCustomerObj.pagination.pageLimit)&&($ctrl.model.billableCustomerObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.billableCustomerObj.pagination.page\" ng-change=\"$ctrl.billableCustomer()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div ng-if=\"!$ctrl.model.billableCustomerObj.results.length && !$ctrl.model.billableCustomerObj.customerHistory.process\">\n<div class=\"col-sm-12 alert text-center alert-danger\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-25 _panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.stats.no_activity\">\n<div class=\"text-align-center col-sm-12\" ng-if=\"$ctrl.model.billableCustomerObj.customerHistory.process\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<table class=\"table table-pad-4 table-striped table-hover table-bordered remove-bottom-pad margin-10\" ng-if=\"!$ctrl.model.billableCustomerObj.customerHistory.process && $ctrl.model.billableCustomerObj.results.length\">\n<thead>\n<tr>\n<th class=\"text-center\">{{'bagout.customer' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.location_serviced' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.billing_events' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.billing_approval.total_billing' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat-start=\"customer in $ctrl.model.billableCustomerObj.results track by $index\">\n<td>\n<span class=\"col-sm-1 remove-left-pad\">\n<button id=\"expand-btn-{{customer.customerId}}\" class=\"btn btn-xs btn-secondary\" ng-click=\"customer.expanded = !customer.expanded; $ctrl.setPage(customer.expanded, customer.customerId); $ctrl.getBillingRecords(customer, $event)\" expand>\n<span ng-if=\"customer.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!customer.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</span>\n<span class=\"col-sm-10 text-center _remove-left-pad\">{{customer.customerId}} | {{customer.customerName}}</span>\n</td>\n<td class=\"text-center\">{{customer.totalLocationServiced}}</td>\n<td class=\"text-center\">{{customer.totalBillableEvents}}</td>\n<td class=\"text-center\">\n<span ng-if=\"customer.totalAmount !== null\">{{customer.totalAmount | currency}}</span>\n<span ng-if=\"customer.totalAmount == null\">{{'common.n_a' | translate}}</span>\n</td>\n</tr>\n<tr class=\"text-center\" ng-repeat-end ng-show=\"customer.expanded\">\n<td colspan=\"10\" ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].process\">\n<div class=\"text-align-center col-sm-12\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</td>\n<td colspan=\"10\" class=\"remove-pad\" ng-if=\"!$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].process\">\n<div>\n<table class=\"table table-condensed table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortData('vaultDate', customer, $event)\">\n{{'common.vault_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'vaultDate'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('branchId', customer, $event)\">\n{{'location.branch' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'branchId'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('locationId', customer, $event)\">\n{{'item.location' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('customerContractId', customer, $event)\">\n{{'contract.contract' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'customerContractId'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('contractRuleId', customer, $event)\">\n{{'location.contract_rule' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'contractRuleId'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortData('billableEventType', customer, $event)\">\n{{'billableEvents.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billableEventType'}\"></span>\n</th>\n<th class=\"billing-approval-col-w-12 text-center remove-white-space\" ng-click=\"$ctrl.sortData('billingCategory', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_category' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingCategory'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('billingType', customer, $event)\">\n{{'branch_mgmt.billing_approval.bill_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingType'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('amountDue', customer, $event)\">\n{{'branch_mgmt.billing_approval.amount_due' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountDue'}\"></span>\n</th>\n<th class=\"text-center remove-white-space\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">{{'surchargeDetailsModal.surcharge' | translate}}</th>\n<th class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('locationDistanceName',customer,$event)\">\n{{'locationDistance.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationDistanceName'}\"></span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat-start=\"billingRecord in $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.results\">\n<td class=\"remove-white-space\">{{billingRecord.vaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</td>\n<td class=\"remove-white-space\">\n<span ng-if=\"!billingRecord.branchId\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"billingRecord.branchId\">\n{{billingRecord.branchId}}\n</span>\n<span ng-if=\"billingRecord.routeId\"> |\n<a href=\"#\" ng-click=\"$ctrl.goToRouteTab(billingRecord.routeId, billingRecord.vaultDate)\">{{billingRecord.routeId}}</a>\n</span>\n</td>\n<td class=\"remove-white-space\">\n<span ng-if=\"!billingRecord.locationId\">{{'common.n_a' | translate}}</span>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(billingRecord.locationId)\">{{billingRecord.locationId}}</a>\n</td>\n<td>\n<span ng-if=\"!billingRecord.customerContractId\">{{'common.n_a' | translate}}</span>\n<a href=\"#\" ng-click=\"$ctrl.goToContractRuleTab(billingRecord.customerContractId)\">{{billingRecord.customerContractId}} | {{billingRecord.contractName}}</a>\n</td>\n<td>\n<span ng-if=\"!billingRecord.contractRuleId\">{{'common.n_a' | translate}}</span>\n<a href=\"#\" ng-click=\"$ctrl.goToContractRuleTab(billingRecord.customerContractId)\">{{billingRecord.contractRuleName}}</a>\n</td>\n<td>{{$ctrl.translateMessage('entry_type.', billingRecord.billableEventType)}}\n<span ng-if=\"billingRecord.contractRuleDescription\">|\n<b>{{billingRecord.contractRuleDescription}}</b></span>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.serviceOrderNotes(billingRecord)\" uib-tooltip=\"{{'common.notes' | translate}}\" ng-if=\"billingRecord.serviceOrderId\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"!billingRecord.isEdit\">{{billingRecord.billingCategoryObj.Key}}</span>\n<span class=\"billing-category-dd-padding\" ng-if=\"billingRecord.isEdit\">\n<select class=\"form-control\" ng-model=\"billingRecord.billingCategoryObj.Key\" ng-options=\"category.Key as category.Key for category in $ctrl.model.billingCategoryObj.results\" ng-disabled=\"$ctrl.model.billingCategoryObj.loading\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}})\n</option>\n</select>\n</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"!billingRecord.isEdit\">\n{{$ctrl.translateMessage('billableEvents.', billingRecord.billingType)}}\n</span>\n<span class=\"billing-category-dd-padding\" ng-if=\"billingRecord.isEdit\">\n<select class=\"form-control\" ng-model=\"billingRecord.billingType\" ng-options=\"billingType.value as billingType.label for billingType in $ctrl.model.billingTypeList\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}})\n</option>\n</select>\n</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\">\n<span ng-if=\"billingRecord.amountDue !== null\">{{billingRecord.amountDue | currency}}</span>\n<span ng-if=\"billingRecord.amountDue == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.model.hasActiveSurcharge || $ctrl.model.hasStoredSurcharge\">\n<span ng-if=\"billingRecord.storedSurcharge != null\" class=\"surcharge-tooltip-trigger\" uib-tooltip-template=\"'recordSurchargeTooltip.html'\" tooltip-enable=\"billingRecord.storedSurchargeBreakdown.length > 0\" tooltip-class=\"surcharge-tooltip\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{billingRecord.storedSurcharge | currency}}<span class=\"glyphicon glyphicon-info-sign surcharge-tooltip-icon\" ng-if=\"billingRecord.storedSurchargeBreakdown.length > 0\"></span></span>\n<span ng-if=\"billingRecord.storedSurcharge == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td ng-if=\"billingRecord.billingType !== 'COMBINED_TIME'\">\n<span ng-if=\"billingRecord.locationDistanceId\">{{billingRecord.locationDistanceName}}</span>\n<span ng-if=\"billingRecord.locationDistanceId === null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"billing-rate-input-section item-date-width-10\" ng-if=\"billingRecord.billingType === 'COMBINED_TIME'\">\n<span>{{billingRecord.combinedServiceTime}}\n<span ng-if=\"billingRecord.locationDistanceId\">({{billingRecord.locationDistanceName}})</span>\n</span>\n</td>\n</tr>\n<tr ng-repeat-end></tr>\n</tbody>\n<tbody>\n<tr ng-if=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords > $ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.pageLimit\">\n<td class=\"location-history-pagination-section\" colspan=\"10\">\n<div class=\"hide-in-print\">\n<ul ng-model=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].page\" uib-pagination total-items=\"$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords\" ng-hide=\"{{($ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.totalRecords<=$ctrl.model.billingRecordsObj.billingHistory[customer.customerId].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.resetData(customer); $ctrl.getBillingRecords(customer, $event)\" max-size=\"10\"></ul>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10\" ng-if=\"$ctrl.model.noActivityCustomerObj.totalNoActivityBillablecustomers > 10 && $ctrl.model.billableCustomerObj.results.length && !$ctrl.model.billableCustomerObj.customerHistory.process\">\n<ul class=\"margin-bottom-10\" uib-pagination total-items=\"$ctrl.model.noActivityCustomerObj.totalNoActivityBillablecustomers\" ng-hide=\"{{($ctrl.model.noActivityCustomerObj.totalNoActivityBillablecustomers<=$ctrl.model.billableCustomerObj.pagination.pageLimit)&&($ctrl.model.billableCustomerObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.billableCustomerObj.pagination.page\" ng-change=\"$ctrl.billableCustomer()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div ng-if=\"!$ctrl.model.billableCustomerObj.results.length && !$ctrl.model.billableCustomerObj.customerHistory.process\">\n<div class=\"col-sm-12 alert text-center alert-danger\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</form></div>\n";
var id2="billing_approval.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id2,v2);}
else{ngModule.run(["$templateCache",function(c){c.put(id2,v2)}]);}
module.exports=v2;

/***/ }),
/* 2667 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"bin-manifest-page\">\n<h2>Bin Manifest Page</h2>\n</div>\n";
var id1="bin_manifest.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2668 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"margin-bottom-10\">\n<div class=\"text-center\">\n<div class=\"btn-group margin-bottom-10\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.branch\" ng-click=\"$ctrl.stateSelection('branch')\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.branch}\">\n{{ 'common.branch_id' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.all\" ng-click=\"$ctrl.stateSelection('all')\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.all}\">\n{{ 'common.All' | translate }}\n</label>\n</div>\n</div>\n</div>\n<div class=\"remove-pad text-center margin-10\">\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.tab\" uib-btn-radio=\"$ctrl.tabs.routes\" ng-click=\"$ctrl.tabSelection('routes')\" ng-class=\"{'btn-success': $ctrl.model.tab === $ctrl.tabs.routes}\">\n{{ 'route.all_routes' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.tab\" uib-btn-radio=\"$ctrl.tabs.orders\" ng-click=\"$ctrl.tabSelection('orders')\" ng-class=\"{'btn-success': $ctrl.model.tab === $ctrl.tabs.orders}\">\nOrders\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.tab\" uib-btn-radio=\"$ctrl.tabs.services\" ng-click=\"$ctrl.tabSelection('services')\" ng-class=\"{'btn-success': $ctrl.model.tab === $ctrl.tabs.services}\">\nServices\n</label>\n</div>\n</div>\n</div>\n<div class=\"margin-10 form-validate col-sm-12 remove-left-pad remove-right-pad col-sm-offset-3\" ng-class=\"{'margin-bottom-10': $ctrl.model.tab === 'orders'}\">\n<div class=\"col-sm-3 remove-left-pad remove-right-pad\" ng-class=\"{'col-sm-4': $ctrl.model.tab === 'services'}\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOption\" ng-change=\"$ctrl.resetData(); $ctrl.loadData();\" options=\"$ctrl.model.dateRangPickerOptionsfor\" ng-if=\"$ctrl.model.dateRangeOption.startDate\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"col-sm-3 remove-right-pad\" ng-class=\"{'col-sm-4': $ctrl.model.tab === 'services'}\">\n<div class=\"multi-select user-branch-search-dd valid-multi-select-value\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"Value\" item-label=\"Value\" search-property=\"Value\" tick-property=\"ticked\" directive-id=\"multi-select-button\" selection-mode=\"single\" on-item-click=\"$ctrl.resetData(); $ctrl.loadData();\" on-reset=\"$ctrl.resetData(); $ctrl.loadData();\" on-select-all=\"$ctrl.resetData(); $ctrl.loadData();\" on-select-none=\"$ctrl.resetData(); $ctrl.loadData();\" translation=\"$ctrl.localLang\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-show=\"$ctrl.model.tab === 'routes'\">\n<div class=\"card-style\">\n<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 pad-left-10 remove-right-pad\">\n<div class=\"row_ panel panel-default margin-10 remove-bottom-pad\">\n<div class=\"cursor-pointer panel-heading\">\n<div class=\"row panel-title panel-title-center bucket_text_align_center remove-left-padd remove-right-padd\">\n<div class=\"col-sm-8 remove-left-padd remove-right-padd\" ng-click=\"$ctrl.validateBucket('routePerformance');\">\n<i class=\"glyphicon glyphicon-triangle-bottom\" ng-show=\"$ctrl.bucketObj['routePerformance'].bucketExpanded\"></i>\n<i class=\"glyphicon glyphicon-triangle-right\" ng-hide=\"$ctrl.bucketObj['routePerformance'].bucketExpanded\"></i>\n<strong class=\"f-14\">Route Performance</strong>\n</div>\n</div>\n</div>\n<div class=\"card-section branch-performance-card\" ng-show=\"$ctrl.bucketObj['routePerformance'].bucketExpanded\">\n<div class=\"britechart js-loading-container-route-performance card--chart\"></div>\n<div class=\"britechart js-stacked-bar-chart-tooltip-container-route-performance card--chart\"></div>\n<div class=\"margin-top-5 alert text-center alert-danger remove-bottom-margin\" ng-if=\"!$ctrl.isRoutePerformanceRecordFound\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"row_ panel panel-default margin-10 remove-bottom-pad\">\n<div class=\"cursor-pointer panel-heading\">\n<div class=\"row panel-title panel-title-center bucket_text_align_center remove-left-padd remove-right-padd\">\n<div class=\"col-sm-8 remove-left-padd remove-right-padd\" ng-click=\"$ctrl.validateBucket('routeLocationPerformance');\">\n<i class=\"glyphicon glyphicon-triangle-bottom\" ng-show=\"$ctrl.bucketObj['routeLocationPerformance'].bucketExpanded\"></i>\n<i class=\"glyphicon glyphicon-triangle-right\" ng-hide=\"$ctrl.bucketObj['routeLocationPerformance'].bucketExpanded\"></i>\n<strong class=\"f-14\">Route Location Performance</strong>\n</div>\n</div>\n</div>\n<div class=\"card-section branch-performance-card margin-10\" ng-show=\"$ctrl.bucketObj['routeLocationPerformance'].bucketExpanded\">\n<div class=\"britechart js-loading-container-route-location-performance card--chart\"></div>\n<div class=\"britechart js-stacked-bar-chart-tooltip-container-route-location-performance card--chart\"></div>\n<div class=\"margin-top-5 alert text-center alert-danger remove-bottom-margin\" ng-if=\"!$ctrl.isRouteLocationRecordFound\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.tab === 'orders'\">\n<div class=\"card-style\">\n<div class=\"row_ panel panel-default margin-10 remove-bottom-pad\" ng-repeat=\"graphItem in $ctrl.ordersGraphList track by $index\">\n<div class=\"cursor-pointer panel-heading\">\n<div class=\"row panel-title panel-title-center bucket_text_align_center remove-left-padd remove-right-padd\">\n<div class=\"col-sm-8 remove-left-padd remove-right-padd\" ng-click=\"$ctrl.validateBucket(graphItem.value);\">\n<i class=\"glyphicon glyphicon-triangle-bottom\" ng-show=\"$ctrl.bucketObj[graphItem.value].bucketExpanded\"></i>\n<i class=\"glyphicon glyphicon-triangle-right\" ng-hide=\"$ctrl.bucketObj[graphItem.value].bucketExpanded\"></i>\n<strong class=\"f-14\">{{graphItem.label}}</strong>\n</div>\n</div>\n</div>\n<div class=\"card-section branch-performance-card margin-10\" ng-show=\"$ctrl.bucketObj[graphItem.value].bucketExpanded\">\n<div class=\"britechart js-loading-container-{{graphItem.value}} card--chart\"></div>\n<div class=\"britechart js-stacked-bar-chart-tooltip-container-{{graphItem.value}} card--chart\"></div>\n<div class=\"margin-top-5 alert text-center alert-danger remove-bottom-margin\" ng-if=\"!graphItem.isRecordsFound\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.tab === 'services'\">\n<div class=\"card-style\">\n<div class=\"row_ panel panel-default margin-10 remove-bottom-pad\" ng-repeat=\"graphItem in $ctrl.serviceOrdersGraphList track by $index\">\n<div class=\"cursor-pointer panel-heading\">\n<div class=\"row panel-title panel-title-center bucket_text_align_center remove-left-padd remove-right-padd\">\n<div class=\"col-sm-8 remove-left-padd remove-right-padd\" ng-click=\"$ctrl.validateBucket(graphItem.value);\">\n<i class=\"glyphicon glyphicon-triangle-bottom\" ng-show=\"$ctrl.bucketObj[graphItem.value].bucketExpanded\"></i>\n<i class=\"glyphicon glyphicon-triangle-right\" ng-hide=\"$ctrl.bucketObj[graphItem.value].bucketExpanded\"></i>\n<strong class=\"f-14\">{{graphItem.label}}</strong>\n</div>\n</div>\n</div>\n<div class=\"card-section branch-performance-card margin-10\" ng-show=\"$ctrl.bucketObj[graphItem.value].bucketExpanded\">\n<div class=\"britechart js-loading-container-{{graphItem.value}} card--chart\"></div>\n<div class=\"britechart js-stacked-bar-chart-tooltip-container-{{graphItem.value}} card--chart\"></div>\n<div class=\"margin-top-5 alert text-center alert-danger remove-bottom-margin\" ng-if=\"!graphItem.isRecordsFound\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="branch_performance.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2669 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container_ remove-pad col-sm-12\">\n<div class=\"row_\">\n<div class=\"col-md-5_\">\n<h3>{{ 'branch_mgmt.location_bypass_code.title' | translate }}</h3>\n</div>\n</div>\n<form ng-submit=\"$ctrl.confirmSupervisor(this)\" name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row_ margin-18 form-horizontal remove-padding\">\n<div class=\"col-sm-6 right-vertical-line remove-left-pad\">\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label\" style=\"float: left; margin-top: 5px\">{{ 'branch_mgmt.bypass_code_issue.title' | translate }}</label>\n<div class=\"col-sm-8\">\n<select id=\"select\" class=\"form-control\" ng-model=\"$ctrl.model.issues\" ng-options=\"issues.value as issues.lable for issues in $ctrl.issues\" ng-change=\"$ctrl.loadData()\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n</div>\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label\" style=\"float: left; margin-top: 5px\">{{ 'branch_mgmt.bypass_code_branch.title' | translate }}</label>\n<div class=\"col-sm-8\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.branchId\" ng-options=\"branch.id as branch.id for branch in $ctrl.branches\" ng-disabled=\"!$ctrl.model.issues\" ng-change=\"$ctrl.branchChanged()\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n</div>\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label\" style=\"float: left; margin-top: 5px\">{{ 'branch_mgmt.bypass_code_route.title' | translate }}</label>\n<div class=\"col-sm-8\">\n<search-and-select ng-model=\"$ctrl.model.routeId\" values=\"$ctrl.routeLists\" key=\"Key\" totalrecords=\"$ctrl.totalRouteRecords\" common-search-flag=\"true\" on-click=\"$ctrl.getRouteStops()\" ng-disabled=\"!$ctrl.model.branchId\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label\" style=\"float: left; margin-top: 5px\">{{ 'branch_mgmt.bypass_code_user.title' | translate }}</label>\n<div class=\"col-sm-8\">\n<search-and-select ng-model=\"$ctrl.model.userId\" values=\"$ctrl.userLists\" key=\"Key\" totalrecords=\"$ctrl.totalUserRecord\" onscroll=\"$ctrl.getAllUsers(searchKey, offset)\" ng-disabled=\"!$ctrl.routeLists || !$ctrl.routeLists.length\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label\" style=\"float: left; margin-top: 5px\">{{ 'branch_mgmt.bypass_code_location.title' | translate }}</label>\n<div class=\"col-sm-8\">\n<search-and-select ng-model=\"$ctrl.model.locationId\" values=\"$ctrl.locationLists\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" onscroll=\"$ctrl.getAllLocation(searchKey, offset)\" ng-disabled=\"!$ctrl.userLists || !$ctrl.userLists.length\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label\" style=\"float: left; margin-top: 5px\">{{ 'branch_mgmt.bypass_code_comment.title' | translate }}</label>\n<div class=\"col-sm-10\">\n<textarea class=\"form-control\" rows=\"4\" cols=\"50\" ng-model=\"$ctrl.model.comments\"></textarea>\n</div>\n</div>\n<div class=\"form-group\">\n<div class=\"col-sm-2\"></div>\n<div class=\"col-sm-8\">\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"Form.$invalid || isLoading || loading\">\n{{'common.generate_code' | translate}}\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-6\" style=\"padding: 90px;\">\n<div class=\"col-sm-12\">\n<span class=\"text-muted\" style=\"color: black;font-weight: bold;\">\n{{ 'branch_mgmt.bypass_code.title' | translate }}:\n</span>\n</div>\n<div class=\"col-sm-12\">\n<span class=\"text-muted\" style=\"font-size: 37px; color: #70ad46;\">\n{{$ctrl.bypassCode || 0}}\n</span>\n</div>\n</div>\n</div>\n</form>\n</div>\n<div class=\"row_\">\n<div class=\"col-sm-12 margin-18 table-responsive remove-pad\">\n<p class=\"text-align-center font-size-70\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</p>\n<table class=\"table table-hover table-bordered font-12\" ng-if=\"!$ctrl.loading && $ctrl.allBypassCodeData && $ctrl.allBypassCodeData.length && $ctrl.model.branchId\">\n<tr class=\"header-row\">\n<th class=\"bypass-code-date-section\">{{'bypassCode.date' | translate}}</th>\n<th class=\"minWidth150\">{{'branch_mgmt.bypass_code_issue.title' | translate}}</th>\n<th>{{'common.locationId' | translate}}</th>\n<th>{{'bypassCode.route' | translate}}</th>\n<th>{{'bypassCode.bypassCode' | translate}}</th>\n<th>{{'bypassCode.supervisorID' | translate}}</th>\n<th>{{'bypassCode.messengerID' | translate}}</th>\n<th>{{'bypassCode.comments' | translate}}</th>\n</tr>\n<tr ng-if=\"filterBypassCodeData.length === 0\">\n<td colspan=\"7\">\n<strong class=\"align-center\">{{'error.noBypassCodeFound' | translate}}</strong>\n</td>\n</tr>\n<tr ng-if=\"filterBypassCodeData.length > 0\" ng-repeat=\"bypassCode in filterBypassCodeData = ($ctrl.allBypassCodeData | filter: {branchId : $ctrl.model.branchId})\">\n<td>{{bypassCode.createdAt | date: 'MM-dd-yyyy | hh:mm a'}}</td>\n<td>\n<span ng-if=\"bypassCode.type\">{{$ctrl.translateIssue(bypassCode.type)}}</span>\n<span ng-if=\"!$ctrl.translateIssue(bypassCode.type)\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{bypassCode.locationId}}</td>\n<td>{{bypassCode.routeId}}</td>\n<td>{{bypassCode.bypassCode}}</td>\n<td>{{bypassCode.supvApproveId}}</td>\n<td>{{bypassCode.userId}}</td>\n<td>{{bypassCode.comments}}</td>\n</tr>\n</table>\n</div>\n</div>";
var id1="bypass_code.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"row_ margin-top-10\">\n<div class=\"col-sm-12 margin-bottom-10\">\n<span class=\"row pull-left font-size-20\">\n<strong>{{'branch_mgmt.pending_cancel' | translate}}</strong>\n</span>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.getPendingCancelShp\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding table-responsive\">\n<table class=\"table table-hover table-striped table-bordered table-pad-7 font-12\" ng-if=\"$ctrl.model.pendingCancelShipments.length && !$ctrl.model.pendingCancelShipmentError && !$ctrl.model.getPendingCancelShp\">\n<thead>\n<tr>\n<td>\n<b>{{ 'common.trackingId' | translate }}</b>\n</td>\n<td>\n<b>{{ 'location.id' | translate}}</b>\n</td>\n<td>\n<b>{{'bagout.amount' | translate}}</b>\n</td>\n<td>\n<b>{{ 'common.vault_date' | translate }}</b>\n</td>\n<td>\n<b>{{ 'itemHolds.orderNo' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branchFundingSource.menu.title' | translate }}</b>\n</td>\n<td>\n<b>{{ 'shipmentBatch.action' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in $ctrl.model.pendingCancelShipments\">\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipment.trackingId)\">\n{{shipment.trackingId}}\n</a>\n</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipment.locationId)\">\n{{shipment.locationId}}\n</a> | {{shipment.locationName}}\n</td>\n<td>{{shipment.amount | currency:\"$\"}}</td>\n<td>{{shipment.vaultDate | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToOrderHistory(shipment)\">\n{{shipment.orderNo}}\n</a>\n</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToBulkCash(shipment)\">\n{{shipment.sourceName}}\n</a>\n</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-xs btn-warning remove-pad\" ng-click=\"$ctrl.orderPackingUndo(shipment)\" ng-class=\"{'disabled': ($ctrl.loading)}\">\n<img src=\"" + __webpack_require__(119) + "\" class=\"undo-icon-height-19\" uib-tooltip=\"{{'orderPacking.unpack_order' | translate}}\" tooltip-placement=\"top-right\">\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"row col-sm-12\" ng-if=\"$ctrl.pendingCancelShpPaginationObj.total > 10 && !$ctrl.model.getPendingCancelShp\">\n<ul uib-pagination total-items=\"$ctrl.pendingCancelShpPaginationObj.total\" ng-hide=\"{{($ctrl.pendingCancelShpPaginationObj.total<=$ctrl.pendingCancelShpPaginationObj.pageLimit)&&($ctrl.pendingCancelShpPaginationObj.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pendingCancelShpPaginationObj.page\" ng-change=\"$ctrl.getPendingCancelShipment()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"align-center-horizontally\" ng-if=\"!$ctrl.model.pendingCancelShipments.length && !$ctrl.model.pendingCancelShipmentError && !$ctrl.model.getPendingCancelShp\">\n<div class=\"col-sm-12 alert alert-danger errLblPos text-center\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<div class=\"align-center-horizontally\" ng-if=\"!$ctrl.model.getPendingCancelShp && $ctrl.model.pendingCancelShipmentError\">\n<div class=\"col-sm-12 alert alert-danger errLblPos text-center\">\n<span>{{$ctrl.model.pendingCancelShipmentError}}</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row_ margin-top-20\">\n<div class=\"col-sm-12 margin-bottom-10\">\n<span class=\"row pull-left font-size-20\">\n<strong>{{'common.cancelled' | translate}}</strong>\n</span>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.getCancelledShp\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding\">\n<table class=\"table table-hover table-striped table-bordered table-pad-7\" ng-if=\"$ctrl.model.cancelledShipments.length && !$ctrl.model.cancelledShipmentError && !$ctrl.model.getCancelledShp\">\n<thead>\n<tr>\n<td ng-click=\"$ctrl.sortData('trackingId')\">\n<b>{{ 'common.trackingId' | translate }}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'trackingId'}\"></span>\n</td>\n<td ng-click=\"$ctrl.sortData('locationId')\">\n<b>{{ 'location.id' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</td>\n<td ng-click=\"$ctrl.sortData('amount')\">\n<b>{{'bagout.amount' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amount'}\"></span>\n</td>\n<td ng-click=\"$ctrl.sortData('vaultDate')\">\n<b>{{ 'common.vault_date' | translate }}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'vaultDate'}\"></span>\n</td>\n<td ng-click=\"$ctrl.sortData('orderNo')\">\n<b>{{ 'itemHolds.orderNo' | translate }}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'orderNo'}\"></span>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in $ctrl.model.cancelledShipments | orderBy:$ctrl.sortColumn:$ctrl.reverseSort\">\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipment.trackingId)\">\n{{shipment.trackingId}}\n</a>\n</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipment.locationId)\">\n{{shipment.locationId}}\n</a> | {{shipment.locationName}}\n</td>\n<td>{{shipment.amount | currency:\"$\"}}</td>\n<td>{{shipment.vaultDate | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToOrderHistory(shipment)\">\n{{shipment.orderNo}}\n</a>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"row col-sm-12\" ng-if=\"$ctrl.cancelledShpPaginationObj.total > 10 && !$ctrl.model.getCancelledShp\">\n<ul uib-pagination total-items=\"$ctrl.cancelledShpPaginationObj.total\" ng-hide=\"{{($ctrl.cancelledShpPaginationObj.total<=$ctrl.cancelledShpPaginationObj.pageLimit)&&($ctrl.cancelledShpPaginationObj.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.cancelledShpPaginationObj.page\" ng-change=\"$ctrl.getCancelledShipments()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"align-center-horizontally\" ng-if=\"!$ctrl.model.cancelledShipments.length && !$ctrl.model.cancelledShipmentError && !$ctrl.model.getCancelledShp\">\n<div class=\"col-sm-12 alert alert-danger errLblPos text-center\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<div class=\"align-center-horizontally\" ng-if=\"!$ctrl.model.getCancelledShp && $ctrl.model.cancelledShipmentError\">\n<div class=\"col-sm-12 alert alert-danger errLblPos text-center\">\n<span>{{$ctrl.model.cancelledShipmentError}}</span>\n</div>\n</div>\n</div>\n</div>\n</form>";
var id1="cancelled_shipments.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2671 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-12 margin-10\">\n<div class=\"col-sm-4\"></div>\n<div class=\"col-sm-4 btn-group z-index0\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStats\" uib-btn-radio=\"$ctrl.stats.cashDeliveries\" ng-click=\"$ctrl.tabSelection('cashDeliveries')\" ng-class=\"{'btn-success': $ctrl.model.currentStats === $ctrl.stats.cashDeliveries, \n                               'remove-btn-grp-color': $ctrl.model.currentStats === $ctrl.stats.cashPickups}\">\n{{'branch_mgmt.cash_deliveries' | translate}}\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStats\" uib-btn-radio=\"$ctrl.stats.cashPickups\" ng-click=\"$ctrl.tabSelection('cashPickups');\" ng-class=\"{'btn-success': $ctrl.model.currentStats === $ctrl.stats.cashPickups, \n                               'remove-btn-grp-color': $ctrl.model.currentStats === $ctrl.stats.cashDeliveries}\">\n{{'branch_mgmt.cash_pickups' | translate}}\n</button>\n</div>\n<div class=\"col-sm-2 pull-right remove-pad\">\n<select class=\"form-control\" required ng-model=\"$ctrl.model.timezone\" ng-options=\"timezone.value as timezone.label for timezone in $ctrl.model.timezoneList\" ng-change=\"$ctrl.loadData();\" ng-disabled=\"(!$ctrl.model.cashDeliveriesData.length && $ctrl.model.currentStats === $ctrl.stats.cashDeliveries) ||\n                                 (!$ctrl.model.cashPickupsData.length && $ctrl.model.currentStats === $ctrl.stats.cashPickups)\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12\"><hr class=\"cash-transaction-line-section\"></div>\n<div class=\"col-sm-12 d-flex remove-left-pad remove-right-pad margin-10\" ng-class=\"{'cash-transaction-filter-section': ((!$ctrl.model.cashDeliveriesData.length) \n                                                && $ctrl.model.currentStats === $ctrl.stats.cashDeliveries) ||\n                                                (!$ctrl.model.cashPickupsData.length && $ctrl.model.currentStats === $ctrl.stats.cashPickups)}\">\n<div class=\"col-md-3 remove-left-pad\" ng-if=\"!$ctrl.model.loadCashDeliveries && !$ctrl.model.loadCashPickups && !$ctrl.model.loading\">\n<search-and-select class=\"funding-source-dd-height\" ng-if=\"$ctrl.model.currentStats === $ctrl.stats.cashDeliveries && !$ctrl.model.loading\" ng-model=\"$ctrl.model.selectedFromLocation\" values=\"$ctrl.model.cashDeliveryLocationsObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.cashDeliveryLocationsObj.totalRecords\" onscroll=\"$ctrl.getCashDeliveryLocations(searchKey, offset)\" none-selected=\"'bagout.fromLocation'\" on-click=\"$ctrl.loadData();\">\n</search-and-select>\n<search-and-select class=\"funding-source-dd-height\" ng-if=\"$ctrl.model.currentStats === $ctrl.stats.cashPickups && !$ctrl.model.loading\" ng-model=\"$ctrl.model.selectedToLocation\" values=\"$ctrl.model.cashPickupLocationsObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.cashPickupLocationsObj.totalRecords\" onscroll=\"$ctrl.getCashPickupLocations(searchKey, offset)\" none-selected=\"'bagout.toLocation'\" on-click=\"$ctrl.loadData();\">\n</search-and-select>\n</div>\n<div class=\"right-pad-07 cash-delivery-date-picker-w-18\" ng-if=\"!$ctrl.model.loadCashDeliveries && !$ctrl.model.loadCashPickups && !$ctrl.model.loading\" ng-click=\"$ctrl.validateFilterByDate('vaultDate');\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\" ng-change=\"$ctrl.loadData();\" options=\"$ctrl.model.dateRange\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"left-pad-07 cash-delivery-date-picker-w-18\" ng-if=\"!$ctrl.model.loadCashDeliveries && !$ctrl.model.loadCashPickups && !$ctrl.model.loading\" ng-click=\"$ctrl.validateFilterByDate($ctrl.model.currentStats === $ctrl.stats.cashDeliveries ? 'deliveryDate': 'pickupDate');\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.deliveryPickupDateRangeOptions\" ng-if=\"$ctrl.model.deliveryPickupDateRangeOptions.startDate\" ng-change=\"$ctrl.loadData();\" options=\"$ctrl.model.dateRange\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"col-sm-3\" ng-if=\"($ctrl.model.currentStats === $ctrl.stats.cashDeliveries || $ctrl.model.currentStats === $ctrl.stats.cashPickups) && !$ctrl.model.loading &&\n                        !$ctrl.model.loadCashDeliveries && !$ctrl.model.loadCashPickups\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.searchText\" name=\"searchText\" ng-model-options=\"{debounce: 1000}\" search-autofocus ng-change=\"$ctrl.loadData()\" placeholder=\"{{'common.locationId' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-disabled=\"$ctrl.model.loadCashDeliveries || $ctrl.model.loadCashPickups\"/>\n</div>\n<div class=\"pull-right export-btn-pad-5\" ng-if=\"$ctrl.model.cashDeliveriesData.length && !$ctrl.model.loadCashDeliveries \n                       && $ctrl.model.currentStats === $ctrl.stats.cashDeliveries\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportCashDeliveries()\" ng-disabled=\"$ctrl.model.isExportingCashDeliveries\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExportingCashDeliveries\"></span>\n{{'branch_mgmt.export_deliveries' | translate}}</button>\n</div>\n<div class=\"pull-right export-btn-pad-5\" ng-if=\"$ctrl.model.cashPickupsData.length && !$ctrl.model.loadCashPickups && $ctrl.model.currentStats === $ctrl.stats.cashPickups\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportCashPickups()\" ng-disabled=\"$ctrl.model.isExportingCashPickups\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExportingCashPickups\"></span>\n{{'branch_mgmt.export_pickups' | translate}}</button>\n</div>\n<div ng-if=\"($ctrl.model.cashDeliveriesData.length || $ctrl.model.cashPickupsData.length) && !$ctrl.model.loading && !$ctrl.model.loadCashDeliveries \n                                 && !$ctrl.model.loadCashPickups\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportCashTransactions()\">\n<span ng-if=\"$ctrl.model.currentStats === $ctrl.stats.cashDeliveries\">{{'branch_mgmt.export_delivery_pickups' | translate}}</span>\n<span ng-if=\"$ctrl.model.currentStats === $ctrl.stats.cashPickups\">{{'branch_mgmt.export_pickups_delivery' | translate}}</span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.loadCashDeliveries && $ctrl.model.currentStats === $ctrl.stats.cashDeliveries\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div ng-if=\"$ctrl.model.cashDeliveriesData.length && !$ctrl.model.loadCashDeliveries \n                         && $ctrl.model.currentStats === $ctrl.stats.cashDeliveries\">\n<div class=\"table-responsive w-100\">\n<table class=\"table table-hover table-striped table-bordered margin-top-20 font-12 table-pad-5\">\n<thead>\n<tr>\n<th class=\"text-center delivery-date-width table-label-font-section\" ng-click=\"$ctrl.sortData('processingDate')\">\n<b>{{'common.vault_date' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'processingDate'}\"></span>\n</th>\n<th class=\"text-center vault-date-width table-label-font-section\" ng-click=\"$ctrl.sortData('deliveryDate')\">\n<b>{{'shipmentBatch.deliveryDate' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'deliveryDate'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('deliveryTimes')\">\n<b>{{'itemHolds.deliveryTime' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'deliveryTimes'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('trackingIds')\">\n<b>{{'common.trackingId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'trackingIds'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('locationId')\">\n<b>{{'location.id' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('totalCash')\">\n<b>{{'routeControl.totalCash' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'totalCash'}\"></span>\n</th>\n<th class=\"text-center col-w-05 table-label-font-section\" ng-click=\"$ctrl.sortData('countCash')\">\n<b>{{'branch_mgmt.cash_count' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countCash'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('totalDeletedCash')\">\n<b>{{'branch_mgmt.total_deleted_cash' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'totalDeletedCash'}\"></span>\n</th>\n<th class=\"text-center col-w-05 table-label-font-section\" ng-click=\"$ctrl.sortData('countDeletedCash')\">\n<b>{{'branch_mgmt.count_deleted_cash' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countDeletedCash'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('totalCoin')\">\n<b>{{'checkout.totalCoin' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'totalCoin'}\"></span>\n</th>\n<th class=\"text-center col-w-05 table-label-font-section\" ng-click=\"$ctrl.sortData('countCoin')\">\n<b>{{'branch_mgmt.coin_count' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countCoin'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('totalDeletedCoin')\">\n<b>{{'branch_mgmt.total_deleted_coin' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'totalDeletedCoin'}\"></span>\n</th>\n<th class=\"text-center col-w-05 table-label-font-section\" ng-click=\"$ctrl.sortData('countDeletedCoin')\">\n<b>{{'branch_mgmt.count_deleted_coin' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countDeletedCoin'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('totalOrder')\">\n<b>{{'branch_mgmt.branch_performance.total_orders' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'totalOrder'}\"></span>\n</th>\n<th class=\"text-center col-w-05 table-label-font-section\" ng-click=\"$ctrl.sortData('countOrder')\">\n<b>{{'branch_mgmt.total_count' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countOrder'}\"></span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.cashDeliveriesData\">\n<td class=\"text-center\">{{data.processingDate}}</td>\n<td class=\"text-center\">{{data.deliveryDate}}</td>\n<td class=\"text-center\">{{data.deliveryTimes}}</td>\n<td class=\"delivery-tracking-id-section\">\n<div class=\"icon-padding-05\">\n<a href=\"#\" class=\"remove-underline\" ng-click=\"$ctrl.goToItemHistory(trackingId)\" ng-repeat=\"trackingId in data.trackingIds.split(',') track by $index\">\n{{trackingId}}<span ng-if=\"$index + 1 !== data.trackingIds.split(',').length\">,</span>\n</a>\n</div>\n</td>\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.locationId)\">{{data.locationId}}</a> | {{data.locationName}}\n</td>\n<td class=\"text-center\">{{data.totalCash | currency}}</td>\n<td class=\"text-center\">{{data.countCash}}</td>\n<td class=\"text-center\">{{data.totalDeletedCash | currency}}</td>\n<td class=\"text-center\">{{data.countDeletedCash}}</td>\n<td class=\"text-center\">{{data.totalCoin | currency}}</td>\n<td class=\"text-center\">{{data.countCoin}}</td>\n<td class=\"text-center\">{{data.totalDeletedCoin | currency}}</td>\n<td class=\"text-center\">{{data.countDeletedCoin}}</td>\n<td class=\"text-center\">{{data.totalOrder | currency}}</td>\n<td class=\"text-center\">{{data.countOrder}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"margin-bottom-10\">\n<ul uib-pagination total-items=\"$ctrl.model.pagination.total\" ng-hide=\"{{($ctrl.model.pagination.total<=$ctrl.model.pagination.pageLimit)&&($ctrl.model.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.cashDeliveriesData.length && !$ctrl.model.loadCashDeliveries && $ctrl.model.currentStats === $ctrl.stats.cashDeliveries\">\n<div class=\"text-center alert alert-danger margin-top-20\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.loadCashPickups && $ctrl.model.currentStats === $ctrl.stats.cashPickups\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div ng-if=\"$ctrl.model.cashPickupsData.length && !$ctrl.model.loadCashPickups && $ctrl.model.currentStats === $ctrl.stats.cashPickups\">\n<div class=\"table-responsive w-100\">\n<table class=\"table table-hover table-striped table-bordered margin-top-20 font-12 table-pad-5\">\n<thead>\n<tr>\n<th class=\"text-center delivery-date-width\" ng-click=\"$ctrl.sortData('processingDate')\">\n<b>{{'common.vault_date' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'processingDate'}\"></span>\n</th>\n<th class=\"text-center vault-date-width\" ng-click=\"$ctrl.sortData('pickupDate')\">\n<b>{{'shipmentBatch.pickupDate' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'pickupDate'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('pickupTimes')\">\n<b>{{'itemHolds.pickupTime' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'pickupTimes'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('trackingIds')\">\n<b>{{'common.trackingId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'trackingIds'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('locationId')\">\n<b>{{'location.id' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('totalCash')\">\n<b>{{'routeControl.totalCash' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'totalCash'}\"></span>\n</th>\n<th class=\"text-center col-w-05\" ng-click=\"$ctrl.sortData('countCash')\">\n<b>{{'branch_mgmt.cash_count' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countCash'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('totalDeletedCash')\">\n<b>{{'branch_mgmt.total_deleted_cash' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'totalDeletedCash'}\"></span>\n</th>\n<th class=\"text-center col-w-05\" ng-click=\"$ctrl.sortData('countDeletedCash')\">\n<b>{{'branch_mgmt.count_deleted_cash' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countDeletedCash'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('totalCoin')\">\n<b>{{'checkout.totalCoin' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'totalCoin'}\"></span>\n</th>\n<th class=\"text-center col-w-05\" ng-click=\"$ctrl.sortData('countCoin')\">\n<b>{{'branch_mgmt.coin_count' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countCoin'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('totalDeletedCoin')\">\n<b>{{'branch_mgmt.total_deleted_coin' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'totalDeletedCoin'}\"></span>\n</th>\n<th class=\"text-center col-w-05\" ng-click=\"$ctrl.sortData('countDeletedCoin')\">\n<b>{{'branch_mgmt.count_deleted_coin' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countDeletedCoin'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('totalOrder')\">\n<b>{{'branch_mgmt.branch_performance.total_orders' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'totalOrder'}\"></span>\n</th>\n<th class=\"text-center col-w-05\" ng-click=\"$ctrl.sortData('countOrder')\">\n<b>{{'branch_mgmt.total_count' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countOrder'}\"></span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.cashPickupsData\">\n<td class=\"text-center\">{{data.processingDate}}</td>\n<td class=\"text-center\">{{data.pickupDate}}</td>\n<td class=\"text-center pickup-time-section\">{{data.pickupTimes}}</td>\n<td class=\"delivery-tracking-id-section\">\n<div class=\"icon-padding-05\">\n<a href=\"#\" class=\"remove-underline\" ng-click=\"$ctrl.goToItemHistory(trackingId)\" ng-repeat=\"trackingId in data.trackingIds.split(',') track by $index\">\n{{trackingId}}<span ng-if=\"$index + 1 !== data.trackingIds.split(',').length\">,</span>\n</a>\n</div>\n</td>\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.locationId)\">{{data.locationId}}</a> | {{data.locationName}}\n</td>\n<td class=\"text-center\">{{data.totalCash | currency}}</td>\n<td class=\"text-center\">{{data.countCash}}</td>\n<td class=\"text-center\">{{data.totalDeletedCash | currency}}</td>\n<td class=\"text-center\">{{data.countDeletedCash}}</td>\n<td class=\"text-center\">{{data.totalCoin | currency}}</td>\n<td class=\"text-center\">{{data.countCoin}}</td>\n<td class=\"text-center\">{{data.totalDeletedCoin | currency}}</td>\n<td class=\"text-center\">{{data.countDeletedCoin}}</td>\n<td class=\"text-center\">{{data.totalOrder | currency}}</td>\n<td class=\"text-center\">{{data.countOrder}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"margin-bottom-10\">\n<ul uib-pagination total-items=\"$ctrl.model.pagination.total\" ng-hide=\"{{($ctrl.model.pagination.total<=$ctrl.model.pagination.pageLimit)&&($ctrl.model.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.cashPickupsData.length && !$ctrl.model.loadCashPickups && $ctrl.model.currentStats === $ctrl.stats.cashPickups\">\n<div class=\"text-center alert alert-danger margin-top-20\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</form>";
var id1="cash_deliveries.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2672 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12 contact-request-page-css remove-pad\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-12 align-center margin-10\">\n<div class=\"col-sm-2 btn-group z-index0\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStats\" uib-btn-radio=\"$ctrl.stats.pending\" ng-click=\"$ctrl.tabSelection('pending')\" ng-class=\"{'btn-success': $ctrl.model.currentStats === $ctrl.stats.pending, \n                                   'remove-btn-grp-color': $ctrl.model.currentStats === $ctrl.stats.completed}\">\n{{'common.pending' | translate}}\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStats\" uib-btn-radio=\"$ctrl.stats.completed\" ng-click=\"$ctrl.tabSelection('completed');\" ng-class=\"{'btn-success': $ctrl.model.currentStats === $ctrl.stats.completed, \n                                   'remove-btn-grp-color': $ctrl.model.currentStats === $ctrl.stats.pending}\">\n{{'common.completed' | translate}}\n</button>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\"><hr class=\"cash-variances-line-section\"></div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 cash-variances-search-section margin-10\" ng-if=\"!$ctrl.model.loading\">\n<div class=\"col-width-20\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" options=\"$ctrl.model.dateRange\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled': $ctrl.model.contactRequestObj.loading}\"/>\n</div>\n<div class=\"col-sm-3 remove-right-pad\">\n<div class=\"multi-select location-branch-dd\" ng-class=\"{'invalid-multi-select-value': !$ctrl.model.branchId.length, 'valid-multi-select-value': $ctrl.model.branchId.length}\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" translation=\"$ctrl.branchLocalLang\" on-item-click=\"$ctrl.reset(); $ctrl.resetLocationAndRoute(); $ctrl.routesAndLocationList(); $ctrl.loadData();\" on-select-all=\"$ctrl.reset(); $ctrl.resetLocationAndRoute(); $ctrl.routesAndLocationList(); $ctrl.loadData();\" on-select-none=\"$ctrl.reset(); $ctrl.resetLocationAndRoute(); $ctrl.routesAndLocationList(); $ctrl.loadData();\" on-reset=\"$ctrl.reset(); $ctrl.resetLocationAndRoute(); $ctrl.routesAndLocationList(); $ctrl.loadData();\" is-disabled=\"$ctrl.model.contactRequestObj.loading\">\n</div>\n</div>\n<div class=\"valid-multi-select-value col-sm-3 multi-select multi-select-dd\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.contactRequestObj.routeList\" output-model=\"$ctrl.model.routeId\" button-label=\"Value\" item-label=\"Key\" search-property=\"Value\" tick-property=\"ticked\" disable-property=\"$ctrl.model.routeListObj.loading\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.reset(); $ctrl.loadData();\" on-select-all=\"$ctrl.reset(); $ctrl.loadData();\" on-select-none=\"$ctrl.reset(); $ctrl.loadData();\" on-reset=\"$ctrl.reset(); $ctrl.loadData();\" translation=\"$ctrl.routeLocalLang\" is-disabled=\"$ctrl.model.contactRequestObj.loading\">\n</div>\n<div class=\"valid-multi-select-value remove-left-pad remove-right-pad col-sm-3 multi-select multi-select-dd\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.model.contactRequestObj.locationList\" output-model=\"$ctrl.model.locationId\" button-label=\"Value\" item-label=\"Key\" search-property=\"Value\" tick-property=\"ticked\" disable-property=\"$ctrl.model.locationListObj.loading\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.reset(); $ctrl.loadData();\" on-select-all=\"$ctrl.reset(); $ctrl.loadData();\" on-select-none=\"$ctrl.reset(); $ctrl.loadData();\" on-reset=\"$ctrl.reset(); $ctrl.loadData();\" translation=\"$ctrl.locationLocalLang\" is-disabled=\"$ctrl.model.contactRequestObj.loading\">\n</div>\n<div class=\"pull-right export-btn-pad-5 ml-5\" ng-if=\"$ctrl.model.contactRequestObj.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportReports()\" ng-disabled=\"$ctrl.model.contactRequestObj.loading || $ctrl.model.isExporting\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExporting\"></span>\n{{'common.export' | translate}}</button>\n</div>\n<div class=\"pull-right export-btn-pad-5\" ng-if=\"$ctrl.model.contactRequestObj.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.printReport()\" ng-disabled=\"$ctrl.model.contactRequestObj.loading || $ctrl.model.isPrint\">\n{{'coinPullReport.print' | translate}}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isPrint\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-validate remove-padding\" novalidate>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.contactRequestObj.loading || $ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"!$ctrl.model.contactRequestObj.loading && $ctrl.model.contactRequestObj.results.length\">\n<div class=\"col-sm-12 remove-padding table-margin-top-10 table-responsive\">\n<table class=\"table table-striped table-bordered table-pad-7\">\n<thead class=\"text-center\">\n<tr>\n<td><strong>{{'common.location' | translate}}</strong></td>\n<td><strong>{{'common.route' | translate}}</strong></td>\n<td><strong>{{'routeSheet.messenger' | translate}}</strong></td>\n<td><strong>{{'common.branch_id' | translate}}</strong></td>\n<td><strong>{{'routeProgress.vault_date' | translate}}</strong></td>\n<td><strong>{{'branch_mgmt.contact_request.person_name' | translate}}</strong></td>\n<td><strong>{{'customer.phone' | translate}}</strong></td>\n<td class=\"custome-width-15\"><strong>{{'serviceTickets.note' | translate}}</strong></td>\n<td ng-if=\"$ctrl.model.isCompleted\"><strong>{{'branch_mgmt.contact_request.completed_at' | translate}}</strong></td>\n<td ng-if=\"$ctrl.model.isCompleted\"><strong>{{'branch_mgmt.contact_request.completed_by' | translate}}</strong></td>\n<td ng-if=\"!$ctrl.model.isCompleted\"><strong>Action</strong></td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in $ctrl.model.contactRequestObj.results\">\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.locationId)\">{{data.locationId}}</a>\n</td>\n<td>\n<span ng-if=\"data.routeId\">\n<a href=\"#\" ng-click=\"$ctrl.goToRouteTab(data.routeId, data.vaultDate)\">{{data.routeId}}</a>\n</span>\n<span ng-if=\"!data.routeId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{data.messengerId}} | {{data.messengerName}}</td>\n<td>{{data.branchId}}</td>\n<td class=\"contents-no-wrap\">{{data.vaultDate | date:'yyyy-MM-dd': 'UTC' }}</td>\n<td>{{data.personName}}</td>\n<td>{{data.phone}}</td>\n<td>{{data.note}}</td>\n<td ng-if=\"$ctrl.model.isCompleted\">\n<span ng-if=\"data.completedAt\">{{data.completedAt | date:'yyyy-MM-dd | hh:mm:ss'}}</span>\n<span ng-if=\"!data.completedAt\">{{'common.n_a' | translate}}</span>\n</td>\n<td ng-if=\"$ctrl.model.isCompleted\">\n<span ng-if=\"data.completedByUserId\">{{data.completedByUserId}} | {{data.completedByUserName}}</span>\n<span ng-if=\"!data.completedByUserId\">{{'common.n_a' | translate}}</span>\n</td>\n<td ng-if=\"!$ctrl.model.isCompleted\"><button type=\"button\" class=\"btn btn-xs btn-success glyphicon glyphicon-check\" ng-click=\"$ctrl.markCompleteContactRequest(data.id)\" ng-disabled=\"$ctrl.model.markComplete\" tooltip-placement=\"top-right\" uib-tooltip=\"{{'branch_mgmt.contact_request.mark_complete' | translate}}\"></button></td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.contactRequestObj.pagination.total > 10\">\n<ul uib-pagination total-items=\"$ctrl.model.contactRequestObj.pagination.total\" ng-hide=\"{{($ctrl.model.contactRequestObj.pagination.total<=$ctrl.model.contactRequestObj.pagination.pageLimit)&&($ctrl.model.contactRequestObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.contactRequestObj.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 margin-10 remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.model.contactRequestObj.loading && !$ctrl.model.contactRequestObj.results.length && !$ctrl.model.loading\">\n<span class=\"col-sm-12 alert alert-danger text-align-center\">\n{{'route_sheet.no_data_found' | translate}}\n</span>\n</div>\n</div>\n</div>\n</form>";
var id1="contact_request.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2673 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"remove-pad col-sm-12\">\n<div class=\"remove-left-pad remove-right-pad report-header-section col-sm-12 text-align-left margin-top-20 print-header-margin\">\n<div class=\"_col-sm-2 _col-print-2 _show-only-in-print _pad-20\">\n<img stream-print-logo style=\"height: 85px;\">\n</div>\n<div class=\"_col-sm-3 _col-print-3 _show-only-in-print txtSize bagSealPos margin-top-25\">\n<div class=\"bagSealPos\">\n<h3 class=\"margin-zero\">\n<strong ng-if=\"!$ctrl.model.contactRequestObj.isCompleted\">{{'branch_mgmt.contact_request.pending_contact_request' | translate}}</strong>\n<strong ng-if=\"$ctrl.model.contactRequestObj.isCompleted\">{{'branch_mgmt.contact_request.completed_contact_request' | translate}}</strong>\n</h3>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 text-right customer-report-info-section remove-left-pad remove-right-pad\">\n<strong>\n{{ 'bypassCode.date' | translate }}: {{$ctrl.model.contactRequestObj.startDate | date: 'longDate' : 'UTC'}} To {{$ctrl.model.contactRequestObj.endDate | date: 'longDate' : 'UTC'}}\n</strong>\n</div>\n<div class=\"col-sm-12 margin-10 print-margin-10 remove-left-pad remove-right-pad\">\n<table class=\"table table-striped table-bordered table-pad-7\">\n<thead class=\"text-center\">\n<tr>\n<td><strong>{{'common.location' | translate}}</strong></td>\n<td><strong>{{'common.route' | translate}}</strong></td>\n<td><strong>{{'routeSheet.messenger' | translate}}</strong></td>\n<td><strong>{{'common.branch_id' | translate}}</strong></td>\n<td><strong>{{'routeProgress.vault_date' | translate}}</strong></td>\n<td><strong>{{'branch_mgmt.contact_request.person_name' | translate}}</strong></td>\n<td><strong>{{'customer.phone' | translate}}</strong></td>\n<td class=\"custome-width-15\"><strong>{{'serviceTickets.note' | translate}}</strong></td>\n<td ng-if=\"$ctrl.model.contactRequestObj.isCompleted\"><strong>{{'branch_mgmt.contact_request.completed_at' | translate}}</strong></td>\n<td ng-if=\"$ctrl.model.contactRequestObj.isCompleted\"><strong>{{'branch_mgmt.contact_request.completed_by' | translate}}</strong></td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in $ctrl.model.contactRequestObj.results\">\n<td>{{data.locationId}}</td>\n<td>\n<span ng-if=\"data.routeId\">{{data.routeId}}</span>\n<span ng-if=\"!data.routeId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{data.messengerId}} | {{data.messengerName}}</td>\n<td>{{data.branchId}}</td>\n<td class=\"contents-no-wrap\">{{data.vaultDate | date:'yyyy-MM-dd': 'UTC' }}</td>\n<td>{{data.personName}}</td>\n<td>{{data.phone}}</td>\n<td>{{data.note}}</td>\n<td ng-if=\"$ctrl.model.contactRequestObj.isCompleted\">{{data.completedAt | date:'yyyy-MM-dd | hh:mm:ss'}}</td>\n<td ng-if=\"$ctrl.model.contactRequestObj.isCompleted\">{{data.completedByUserId}} | {{data.completedByUserName}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>";
var id1="contact_request_print.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2674 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"row_\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-offset-4 col-sm-4 font-size-20 text-center\">\n<b>{{'branch_mgmt.count_variances.title' | translate}}</b>\n<hr>\n</div>\n<div class=\"col-sm-12\"><hr class=\"cash-variances-line-section\"></div>\n<div class=\"col-sm-12 cash-variances-search-section remove-left-pad remove-right-pad margin-10\">\n<div class=\"col-sm-3\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.searchText\" name=\"searchText\" id=\"countVariancesSearch\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.loadData()\" placeholder=\"{{'common.locationId' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-disabled=\"$ctrl.model.loadCountVariances\"/>\n</div>\n<div class=\"cash-delivery-date-picker-w-18\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" ng-change=\"$ctrl.loadData();\" options=\"$ctrl.model.dateRange\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled': $ctrl.model.loadCountVariances}\"/>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"multi-select location-branch-dd\" ng-class=\"{'invalid-multi-select-value': !$ctrl.model.branch.length, 'valid-multi-select-value': $ctrl.model.branch.length}\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.model.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.loadData();\" on-select-all=\"$ctrl.loadData();\" on-select-none=\"$ctrl.loadData();\" on-reset=\"$ctrl.loadData();\" is-disabled=\"$ctrl.model.loadCountVariances\">\n</div>\n</div>\n<div class=\"col-sm-2 pull-right\">\n<select class=\"form-control\" required ng-model=\"$ctrl.model.timezone\" ng-options=\"timezone.value as timezone.label for timezone in $ctrl.model.timezoneList\" ng-change=\"$ctrl.loadData();\" ng-disabled=\"$ctrl.model.loadCountVariances\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"pull-right export-btn-pad-5\" ng-if=\"$ctrl.model.countVariancesObj.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportData()\" ng-disabled=\"$ctrl.model.loadCountVariances || $ctrl.model.isExporting\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExporting\"></span>\n{{'common.export' | translate}}</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-validate remove-padding\" novalidate>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.loadCountVariances\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div class=\"row\" ng-if=\"!$ctrl.model.loadCountVariances && $ctrl.model.countVariancesObj.results.length\">\n<div class=\"col-sm-12 table-margin-top-10 remove-padding table-responsive\">\n<table class=\"table table-hover table-striped table-bordered font-12 table-pad-5\">\n<thead>\n<tr>\n<td class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('tid')\">{{'bagout.toLocation' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'tid'}\"></span>\n</td>\n<td class=\"text-center created-date-width\" ng-click=\"$ctrl.sortData('branchId')\">{{'route.branchId'| translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'branchId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('loadDate')\">{{'orderPacking.load_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'loadDate'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('loaderId')\">{{'branch_mgmt.count_variances.loader' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'loaderId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('countedById')\">{{'branch_mgmt.count_variances.counted_by' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countedById'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('countedAt')\">{{'branch_mgmt.count_variances.counted_at' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countedAt'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('amountLoadRequested')\">{{'branch_mgmt.final_residual_count_commit.amount_requested' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountLoadRequested'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('amountLoadActual')\">{{'branch_mgmt.final_residual_count_commit.amount_loaded' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountLoadActual'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('amountExpected')\">{{'branch_mgmt.orders_expectedResidual' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountExpected'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('amountCRV')\">{{'branch_mgmt.final_residual_count_commit.amount_CRV' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountCRV'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('amountCounted')\">{{'branch_mgmt.final_residual_count_commit.amount_counted' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountCounted'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('amountVariance')\">{{'atm_residual.variance' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountVariance'}\"></span>\n</td>\n</tr></thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.countVariancesObj.results | orderBy:$ctrl.sortColumn:$ctrl.reverseSort\">\n<td class=\"text-center\"><a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.tid)\">{{data.tid}}</a></td>\n<td class=\"text-center\">{{data.branchId}}</td>\n<td class=\"text-center service-date-width\">{{data.loadDate}}</td>\n<td class=\"text-center\" ng-if=\"data.loaderId\">\n<a href=\"#\" ng-click=\"$ctrl.goToUserTab(data.loaderId)\">{{data.loaderId}}</a> | {{data.loaderName}}\n</td>\n<td class=\"text-center\" ng-if=\"!data.loaderId\">{{'common.n_a' | translate}}</td>\n<td class=\"text-center\" ng-if=\"data.countedById\">\n<a href=\"#\" ng-click=\"$ctrl.goToUserTab(data.countedById)\">{{data.countedById}}</a> | {{data.countedByName}}\n</td>\n<td class=\"text-center\" ng-if=\"!data.countedById\">{{'common.n_a' | translate}}</td>\n<td class=\"text-center\">{{data.countedAt}}</td>\n<td class=\"text-center\">{{data.amountLoadRequested | currency: '$'}}</td>\n<td class=\"text-center\">{{data.amountLoadActual | currency: '$'}}</td>\n<td class=\"text-center\">{{data.amountExpected | currency: '$'}}</td>\n<td class=\"text-center\">{{data.amountCRV | currency: '$'}}</td>\n<td class=\"text-center\">{{data.amountCounted | currency: '$'}}</td>\n<td class=\"text-center\">{{data.amountVariance | currency: '$'}}\n<div class=\"variance-actions\">\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.getComments(data);\" ng-if=\"data.comment\" uib-tooltip=\"{{'checkout.comments' | translate}}\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-link\" ng-if=\"data.residualPickupImageName || data.depositPickupImageName\" ng-click=\"$ctrl.showReceipt(data.residualPickupImageName || data.depositPickupImageName, data.tid)\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"row col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.pagination.total > 10\">\n<ul uib-pagination total-items=\"$ctrl.model.pagination.total\" ng-hide=\"{{($ctrl.model.pagination.total<=$ctrl.model.pagination.pageLimit)&&($ctrl.model.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.loadCountVariances && !$ctrl.model.countVariancesObj.results.length\" class=\"margin-top-20\">\n<span class=\"col-sm-12 matgin-top-20 alert alert-danger text-align-center\">\n{{'route_sheet.no_data_found' | translate}}\n</span>\n</div>\n</div>\n</div>\n</form>";
var id1="count_variances.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2675 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-offset-4 col-sm-4 font-size-20 text-center\">\n<b>Customer Pickup Reports</b>\n<hr>\n</div>\n<div class=\"remove-pad col-sm-12\"><hr class=\"cash-variances-line-section\"></div>\n<div class=\"col-sm-12 cash-variances-search-section remove-left-pad remove-right-pad margin-10\">\n<div class=\"col-width-20\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" options=\"$ctrl.model.dateRange\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled': $ctrl.model.customerPickupReportObj.loading}\"/>\n</div>\n<div class=\"valid-multi-select-value col-sm-3 multi-select vault-close-search-dd\" isteven-multi-select max-labels=\"4\" input-model=\"$ctrl.model.shiptypeObj.results\" output-model=\"$ctrl.model.shiptypeId\" button-label=\"Value\" item-label=\"Key\" search-property=\"Value\" tick-property=\"ticked\" disable-property=\"$ctrl.model.shiptypeObj.loading\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.customerPickupReport(); $ctrl.reset();\" on-select-all=\"$ctrl.customerPickupReport(); $ctrl.reset();\" on-select-none=\"$ctrl.customerPickupReport(); $ctrl.reset();\" on-reset=\"$ctrl.customerPickupReport(); $ctrl.reset();\" translation=\"$ctrl.shipTypeLocalLang\">\n</div>\n<div class=\"valid-multi-select-value remove-left-pad col-sm-3 multi-select vault-close-search-dd\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.routeListObj.results\" output-model=\"$ctrl.model.routeId\" button-label=\"Value\" item-label=\"Key\" search-property=\"Value\" tick-property=\"ticked\" disable-property=\"$ctrl.model.routeListObj.loading\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.customerPickupReport(); $ctrl.reset();\" on-select-all=\"$ctrl.customerPickupReport(); $ctrl.reset();\" on-select-none=\"$ctrl.customerPickupReport(); $ctrl.reset();\" on-reset=\"$ctrl.customerPickupReport(); $ctrl.reset();\" translation=\"$ctrl.routeLocalLang\">\n</div>\n<div class=\"remove-left-pad col-sm-3\" ng-if=\"!$ctrl.model.isCustomerUser\">\n<search-and-select ng-model=\"$ctrl.model.customerId\" values=\"$ctrl.model.customerListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.customerListObj.totalRecords\" on-click=\"$ctrl.reset(); $ctrl.resetLocation(); $ctrl.getLocationList(); $ctrl.customerPickupReport();\" onscroll=\"$ctrl.getCustomerList(searchKey, offset);\" ng-disabled=\"$ctrl.model.customerListObj.loading\" none-selected=\"'common.select_customer'\"></search-and-select>\n</div>\n<div class=\"valid-multi-select-value remove-left-pad remove-right-pad col-sm-3 multi-select vault-close-search-dd\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.model.locationListObj.results\" output-model=\"$ctrl.model.locationId\" button-label=\"Value\" item-label=\"Key\" search-property=\"Value\" tick-property=\"ticked\" disable-property=\"$ctrl.model.locationListObj.loading\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.customerPickupReport(); $ctrl.reset();\" on-select-all=\"$ctrl.customerPickupReport(); $ctrl.reset();\" on-select-none=\"$ctrl.customerPickupReport(); $ctrl.reset();\" on-reset=\"$ctrl.customerPickupReport(); $ctrl.reset();\" translation=\"$ctrl.locationLocalLang\">\n</div>\n<div class=\"pull-right export-btn-pad-5 ml-5\" ng-if=\"$ctrl.model.customerPickupReportObj.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportReports()\" ng-disabled=\"$ctrl.model.customerPickupReportObj.loading || $ctrl.model.isExporting\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExporting\"></span>\n{{'common.export' | translate}}</button>\n</div>\n<div class=\"pull-right export-btn-pad-5\" ng-if=\"$ctrl.model.customerPickupReportObj.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.printReport()\" ng-disabled=\"$ctrl.model.customerPickupReportObj.loading || $ctrl.model.isPrint\">\n{{'coinPullReport.print' | translate}}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isPrint\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-validate remove-padding\" novalidate>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.customerPickupReportObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"!$ctrl.model.customerPickupReportObj.loading && $ctrl.model.customerPickupReportObj.results.length\">\n<div class=\"col-sm-12 remove-padding table-margin-top-10 table-responsive\">\n<table class=\"table table-striped table-bordered\">\n<thead class=\"text-center\">\n<tr>\n<td><strong>{{'bagout.trackingId' | translate}}</strong></td>\n<td> <strong>{{'branch_mgmt.servicehistory.service_date' | translate}}</strong> </td>\n<td> <strong>{{'branch_mgmt.customer_pickup_reports_pickup_date' | translate}}</strong> </td>\n<td> <strong>{{'contract.contractCustomer' | translate}}</strong> </td>\n<td><strong>{{'checkout.fromLocationName' | translate}}</strong></td>\n<td><strong>{{'checkout.route' | translate}}</strong></td>\n<td><strong>{{'bagout.type' | translate}}</strong></td>\n<td><strong>{{'bagout.amount' | translate}}</strong></td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in $ctrl.model.customerPickupReportObj.results | orderBy : 'trackingId' track by $index\">\n<td><a href=\"#\" ng-click=\"$ctrl.goToItemHistory(data.trackingId)\">{{data.trackingId}}</a></td>\n<td> {{ data.pickupFlag && data.countCompletedAt ? $ctrl.formattedDate(data.pickupDate, true) : (data.vaultDate | date:'yyyy-MM-dd':'UTC')}}</td>\n<td>{{data.pickupDate ? $ctrl.formattedDate(data.pickupDate) : ('common.n_a' | translate)}}</td>\n<td>{{data.customerId}} | {{data.customerName}}</td>\n<td><a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.fromLocationId)\">{{data.fromLocationId}}</a> | {{data.fromLocationName}}</td>\n<td>{{data.routeName || data.routeId}}</td>\n<td>{{data.shiptypeDescription || data.shiptypeId}}</td>\n<td>{{data.amount | currency:'$'}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.customerPickupReportObj.pagination.total > 10\">\n<ul uib-pagination total-items=\"$ctrl.model.customerPickupReportObj.pagination.total\" ng-hide=\"{{($ctrl.model.customerPickupReportObj.pagination.total<=$ctrl.model.customerPickupReportObj.pagination.pageLimit)&&($ctrl.model.customerPickupReportObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.customerPickupReportObj.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 margin-10 remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.model.customerPickupReportObj.loading && !$ctrl.model.customerPickupReportObj.results.length\">\n<span class=\"col-sm-12 alert alert-danger text-align-center\">\n{{'route_sheet.no_data_found' | translate}}\n</span>\n</div>\n</div>\n</div>\n</form>\n";
var id1="customer_pickup_reports.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2676 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"remove-pad col-sm-12\" ng-repeat=\"dataObj in $ctrl.model.reportDataObj.results\">\n<div class=\"remove-left-pad remove-right-pad report-header-section col-sm-12 text-align-left margin-top-20 print-header-margin\">\n<div class=\"_col-sm-2 _col-print-2 _show-only-in-print _pad-20\">\n<img stream-print-logo style=\"height: 85px;\">\n</div>\n<div class=\"_col-sm-3 _col-print-3 _show-only-in-print txtSize bagSealPos margin-top-25\">\n<div class=\"bagSealPos\">\n<h3 class=\"margin-zero\">\n<strong> {{'contract.contractCustomer' | translate}}: </strong><span>{{dataObj.customer}}</span>\n</h3>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 text-right customer-report-info-section remove-left-pad remove-right-pad\">\n<span><strong>{{'common.total' | translate}}:</strong> {{dataObj.totalRecords}}</span>\n<span><strong>{{'bagout.totalAmount' | translate}}:</strong> {{dataObj.totalAmount | currency: '$'}}</span>\n<strong>\n{{ 'bypassCode.date' | translate }}: {{$ctrl.model.reportDataObj.startDate | date: 'longDate'}} To {{$ctrl.model.reportDataObj.endDate | date: 'longDate'}}\n</strong>\n</div>\n<div class=\"col-sm-12 margin-10 print-margin-10 remove-left-pad remove-right-pad\">\n<table class=\"table table-striped table-bordered table-pad-3\">\n<thead class=\"header-row text-align-center\">\n<tr>\n<td> <strong>#</strong> </td>\n<td> <strong>{{'bagout.trackingId' | translate}}</strong> </td>\n<td> <strong>{{'branch_mgmt.servicehistory.service_date' | translate}}</strong> </td>\n<td><strong>{{'branch_mgmt.customer_pickup_reports_pickup_date' | translate}}</strong></td>\n<td> <strong>{{'bagout.fromLocationName' | translate}}</strong> </td>\n<td> <strong>{{'bagout.fromLocationId' | translate}}</strong> </td>\n<td> <strong>{{'bagout.type' | translate}}</strong> </td>\n<td> <strong>{{'bagout.amount' | translate}}</strong> </td>\n<td class=\"_show-only-in-print\"> <strong>{{'bagout.verify' | translate}}</strong> </td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in dataObj.results | orderBy : 'trackingId' \">\n<td>{{$index+1}}</td>\n<td>{{data.trackingId}}</td>\n<td> {{ data.pickupFlag && data.countCompletedAt ? $ctrl.formattedDate(data.pickupDate, true) : (data.vaultDate | date:'yyyy-MM-dd':'UTC')}}</td>\n<td>{{data.pickupDate ? $ctrl.formattedDate(data.pickupDate) : ('common.n_a' | translate)}}</td>\n<td>{{data.fromLocationName}}</td>\n<td>{{data.fromLocationId}}</td>\n<td>{{data.shiptypeDescription || data.shiptypeId}}</td>\n<td>{{data.amount | currency:'$'}}</td>\n<td class=\"_show-only-in-print\">&nbsp;</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"remove-pad col-sm-12\">\n<span class=\"bagout-contents\">{{ 'bagout.userContent' | translate }}</span>\n</div>\n<div class=\"remove-pad col-print-12 signPos bagout-contents\">\n<div class=\"col-print-4 textPoss bagout-contents\">\n<span>{{ 'bagout.fullName' | translate }}: <span class=\"lineColor\">__________________________</span>\n\n</span></div>\n<div class=\"col-print-4 textPoss bagout-contents\">\n<span>|&nbsp;{{'bagout.userSignature' | translate}}: <span class=\"lineColor\">_________________________</span>&nbsp;</span>\n</div>\n<div class=\"col-print-4 textPoss bagout-contents\">\n<span>|&nbsp;{{ 'bagout.cntDate' | translate }}: <span class=\"lineColor\">___________________________</span></span>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n";
var id1="customer_report.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2677 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div novalidate>\n<div class=\"row form-validate\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" date-options=\"$ctrl.minVaultDate\" hidden-time=\"true\" show-button-bar=\"false\" ng-click=\"$ctrl.vaultBalance()\" ng-keydown=\"$event.preventDefault()\" required>\n</datetimepicker>\n</div>\n</div>\n<div class=\"col-sm-4 dd-z-index\">\n<div class=\"form-group\">\n<search-and-select ng-model=\"$ctrl.model.fundingSourceId\" values=\"$ctrl.locationLists\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" common-search-flag=\"true\" on-click=\"$ctrl.filterCurrenciesByBFS(); $ctrl.vaultBalance()\" none-selected=\"'orderPacking.selectFromLocation'\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<select id=\"selectCurrency\" class=\"form-control\" ng-model=\"$ctrl.model.currency\" ng-options=\"currency.id as currency.id for currency in $ctrl.filteredCurrency\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'branch_mgmt.daily_balance_sheet.selectCurrency' | translate}}) </option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 text-center\">\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.regular\" ng-click=\"$ctrl.tabSelection('regular')\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.regular}\">\n{{ 'common.regular' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.emergency\" ng-click=\"$ctrl.tabSelection('emergency')\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.emergency}\">\n{{ 'common.emergency' | translate }}\n</label>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.model.fundingSourceId && !$ctrl.isError && !$ctrl.model.loading\">\n<div class=\"align-center col-sm-12 margin-top-10\">\n<div class=\"text-center dvb-tiles-border-color\">\n<span class=\"total-liability\">{{'branch_mgmt.daily_balance_sheet.liability' | translate}}:</span>\n<span class=\"font-size-30\"><b> {{$ctrl.totalLiability | currency: $ctrl.currency }}</b></span>\n</div>\n</div>\n</div>\n<div class=\"text-align-center font-size-70\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner margin-top-40\"></span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.model.fundingSourceId && !$ctrl.isError && !$ctrl.model.loading\">\n<div class=\"card-style\">\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/Doller.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.cashPosition' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.beginPosition | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.beginPosition\" ng-click=\"$ctrl.sheetInfo('beginPosition', 'branch_mgmt.daily_balance_sheet.cashPosition')\"></i>\n</span>\n</div>\n<span class=\"balance-sheet-arrow\">\n<span class=\"glyphicon glyphicon-arrow-right\"></span>\n</span>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/spanish.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.bulkCashAdjustments' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.receivedBulkCash | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.receivedBulkCash\" ng-click=\"$ctrl.sheetInfo('receivedBulkCash', 'branch_mgmt.daily_balance_sheet.bulkCashAdjustments')\"></i>\n</span>\n</div>\n<span class=\"balance-sheet-arrow\">\n<span class=\"glyphicon glyphicon-arrow-right\"></span>\n</span>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/bag-off-green.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.actualResidual' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.actualResidualsCounted | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.actualResidualsCounted\" ng-click=\"$ctrl.sheetInfo('actualResidualsCounted', 'branch_mgmt.daily_balance_sheet.actualResidual')\"></i>\n</span>\n</div>\n<span class=\"balance-sheet-arrow\">\n<span class=\"glyphicon glyphicon-arrow-right\"></span>\n</span>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/bag-off-green.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.actualDeposits' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.actualDepositsCounted | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.actualDepositsCounted\" ng-click=\"$ctrl.sheetInfo('actualDepositsCounted', 'branch_mgmt.daily_balance_sheet.actualDeposits')\"></i>\n</span>\n</div>\n<span class=\"balance-sheet-arrow\">\n<span class=\"glyphicon glyphicon-arrow-right\"></span>\n</span>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/BagCount.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.cashLoaded' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.actualCashLoaded | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.actualCashLoaded\" ng-click=\"$ctrl.sheetInfo('actualCashLoaded', 'branch_mgmt.daily_balance_sheet.cashLoaded')\"></i>\n</span>\n</div>\n<span class=\"balance-sheet-arrow\">\n<span class=\"glyphicon glyphicon-arrow-right\"></span>\n</span>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/bag-off.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.cashDepositOut' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.residualsDeposited | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.residualsDeposited\" ng-click=\"$ctrl.sheetInfo('residualsDeposited', 'branch_mgmt.daily_balance_sheet.cashDepositOut')\"></i>\n</span>\n</div>\n<span class=\"balance-sheet-arrow\">\n<span class=\"glyphicon glyphicon-arrow-right\"></span>\n</span>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/MXD-route-sheet.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.endingCashPosition' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.endPosition | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.endPosition\" ng-click=\"$ctrl.sheetInfo('endPosition', 'branch_mgmt.daily_balance_sheet.endingCashPosition')\"></i>\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/alert.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.pendingResidual' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.pendingResidualCount | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\" $ctrl.balanceSheetData.vaultBalance.pendingResidualCount\" ng-click=\"$ctrl.sheetInfo('pendingResidualCount', 'branch_mgmt.daily_balance_sheet.pendingResidual')\"></i>\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\" ng-if=\"!$ctrl.model.fundingSourceId.manualDeposit\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center remove-bottom-padding\">\n<img ng-src=\"assets/images/alert.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.pendingDepositAllTime' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.pendingCrvDepositAlltime | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.pendingCrvDepositAlltime\" ng-click=\"$ctrl.sheetInfo('pendingCrvDepositAll', 'branch_mgmt.daily_balance_sheet.pendingDepositAllTime')\"></i>\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center remove-bottom-padding\">\n<img ng-src=\"assets/images/alert.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.deposits_pending_count' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.depositsPendingCount | currency:$ctrl.currency: 0}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.depositsPendingCount >= 0\" ng-click=\"$ctrl.sheetInfo('depositsPendingCount', 'branch_mgmt.daily_balance_sheet.deposits_pending_count')\"></i>\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center remove-bottom-padding\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.orderPack' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.ordersPacked | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.ordersPacked\" ng-click=\"$ctrl.sheetInfo('ordersPacked', 'branch_mgmt.daily_balance_sheet.orderPack')\"></i>\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center remove-bottom-padding\">\n<img ng-src=\"assets/images/P-icon.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.orderNotLoaded' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.ordersPackedAlltime | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.ordersPackedAlltime\" ng-click=\"$ctrl.sheetInfo('ordersPackedAlltime', 'branch_mgmt.daily_balance_sheet.orderNotLoaded')\"></i>\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card _dvb-tiles-border-color\">\n<div class=\"card-body text-center remove-bottom-padding\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.cashOrderPackedOnVaultDate' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.packableOrdersPacked | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.packableOrdersPacked\" ng-click=\"$ctrl.sheetInfo('packableOrdersPacked', 'branch_mgmt.daily_balance_sheet.cashOrderPackedOnVaultDate')\"></i>\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center remove-bottom-padding\">\n<img ng-src=\"assets/images/P-icon.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.cashOrderPackedNotOnRoute' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.packableOrdersPackedAllTime | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.packableOrdersPackedAllTime\" ng-click=\"$ctrl.sheetInfo('packableOrdersPackedAlltime', 'branch_mgmt.daily_balance_sheet.cashOrderPackedNotOnRoute')\"></i>\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-2\" style=\"width: 14%\" ng-if=\"$ctrl.model.fundingSourceId.manualDeposit\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center remove-bottom-padding\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.depositsOutPendingRelease' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.depositsPendingRelease | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.depositsPendingRelease\" ng-click=\"$ctrl.sheetInfo('depositsPendingRelease', 'branch_mgmt.daily_balance_sheet.depositsOutPendingRelease')\"></i>\n</span>\n</div>\n</div>\n</div>\n<div class=\"remove-left-pad col-sm-12 align-center\" ng-if=\"!$ctrl.model.fundingSourceId.manualDeposit\">\n<div class=\"remove-left-pad col-sm-2\" style=\"width: 13%\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center remove-bottom-padding\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"lbl-font-size-15\">{{'branch_mgmt.daily_balance_sheet.depositsOutPendingRelease' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"lbl-font-size-15\">{{ $ctrl.balanceSheetData.vaultBalance.depositsPendingRelease | currency:$ctrl.currency}}\n<i class=\"glyphicon glyphicon-info-sign info-icon pull-right\" ng-if=\"$ctrl.balanceSheetData.vaultBalance.depositsPendingRelease\" ng-click=\"$ctrl.sheetInfo('depositsPendingRelease', 'branch_mgmt.daily_balance_sheet.depositsOutPendingRelease')\"></i>\n</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"container-fluid\">\n<div class=\"row\">\n<div class=\"col-sm-offset-2 col-sm-6\">\n<div>\n<div class=\"panel-body\">\n<div class=\"britechart js-horizontal-bar-chart-container card--chart\"></div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-right-pad align-center margin-bottom-20\">\n<div class=\"col-sm-3\">\n<div class=\"text-center lbl-font-size-15\">\n<button class=\"btn btn-block btn-lg btn-success\" ng-click=\"$ctrl.printManifestReport()\">\n<span>{{'branch_mgmt.daily_balance_sheet.printReport' | translate}}</span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"text-center lbl-font-size-15\">\n<button class=\"btn btn-block btn-lg btn-primary\" ng-click=\"$ctrl.generateVaultReport()\">\n<span>{{'branch_mgmt.daily_balance_sheet.generateExport' | translate}}</span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-3 remove-right-pad\" ng-if=\"$ctrl.model.fundingSourceId.dataObj.enableVaultReport\">\n<div class=\"text-center lbl-font-size-15\">\n<button class=\"btn btn-block btn-lg btn-primary\" ng-click=\"$ctrl.emailVaultBalanceReport()\" ng-disabled=\"$ctrl.isSendingReport\">\n<span>{{'branch_mgmt.daily_balance_sheet.email_vault_balance_report' | translate}}</span>\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isSendingReport\"></span>\n</button>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="daily_balance_sheet.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2678 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid form-validate\" novalidate>\n<div class=\"col-sm-12 col-print-12\">\n<div class=\"col-print-4 col-sm-4\">\n<h3>{{$ctrl.branch}}</h3>\n</div>\n<div class=\"col-print-4 col-sm-4 text-center dvb-print-font-size-20\"> <img stream-print-logo class=\"print-logo-height-80\">\n</div>\n<div class=\"col-print-4 col-sm-4 text-right\">\n<div class=\"btn-group dashboard-grp-btn margin-top2\">\n<h3>{{$ctrl.vaultDate}}</h3>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 col-print-12 align-center margin-top-10\">\n<div class=\"col-sm-4 col-print-4 text-center dvb-tiles-border-color\">\n<span class=\"total-liability\">{{'branch_mgmt.daily_balance_sheet.liability' | translate}}:</span>\n<span class=\"dvb-print-font-size-30\"><b> {{$ctrl.totalLiability | currency: $ctrl.currency}}</b></span>\n</div>\n</div>\n<div class=\"col-sm-12 col-print-12 align-center\">\n<div class=\"col-sm-9 col-print-9 dvb-print-tiles-section\">\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/Doller.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.cashPosition' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.beginPosition | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/spanish.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.bulkCashAdjustments' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.receivedBulkCash | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/bag-off-green.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.actualResidual' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.actualResidualsCounted | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/bag-off-green.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.actualDeposits' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.actualDepositsCounted | currency:$ctrl.currency}}\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/BagCount.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.cashLoaded' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.actualCashLoaded | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/bag-off.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.cashDepositOut' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.residualsDeposited | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/MXD-route-sheet.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.endingCashPosition' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.endPosition | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/alert.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.pendingResidual' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.pendingResidualCount | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center remove-bottom-padding\">\n<img ng-src=\"assets/images/alert.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.deposits_pending_count' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.depositsPendingCount | currency:$ctrl.currency}}\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\" ng-if=\"!$ctrl.manualDeposit\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/alert.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.pendingDepositAllTime' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.pendingCrvDepositAlltime | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\" ng-if=\"$ctrl.manualDeposit\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.orderPack' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.ordersPacked | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\" ng-if=\"!$ctrl.manualDeposit\">\n<div class=\"card daily-balance-sheet-card\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.orderPack' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.ordersPacked | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/P-icon.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.orderNotLoaded' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.ordersPackedAlltime | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card _dvb-tiles-border-color\">\n<div class=\"card-body text-center remove-bottom-padding\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.cashOrderPackedOnVaultDate' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.packableOrdersPacked | currency:$ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center remove-bottom-padding\">\n<img ng-src=\"assets/images/P-icon.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.cashOrderPackedNotOnRoute' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.packableOrdersPackedAllTime | currency:$ctrl.currency}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4\">\n<div class=\"card daily-balance-sheet-card dvb-tiles-border-color\">\n<div class=\"card-body text-center\">\n<img ng-src=\"assets/images/bag-load.png\" class=\"balance-sheet-img-width\"/>\n</div>\n<div class=\"card-body text-center\">\n<span class=\"dvb-print-font-size-20\">{{'branch_mgmt.daily_balance_sheet.depositsOutPendingRelease' | translate}}</span>\n</div>\n<div class=\"card-footer text-center\">\n<span class=\"dvb-print-font-size-20\">{{ $ctrl.balanceSheetData.vaultBalance.depositsPendingRelease | currency: $ctrl.currency}}</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="daily_balance_sheet_print.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2679 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid form-validate daily-balance-sheet-report-print print-landscape\" novalidate>\n<div ng-if=\"$ctrl.loading\" class=\"text-center margin-top-80\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-50\"></span>\n</div>\n<div ng-if=\"!$ctrl.loading && $ctrl.reportData\" class=\"print-pages\">\n<div ng-repeat=\"(accountName, accountData) in $ctrl.reportData\" class=\"print-account-section\" ng-class=\"{'page-break-before': !$first}\">\n<div class=\"header-section text-center\" ng-if=\"$first\">\n<img stream-print-logo class=\"print-logo-height-80 margin-bottom-10\">\n</div>\n<div class=\"header-line\" ng-if=\"$first\">{{$ctrl.printData.branch}} | {{$ctrl.printData.fundingSourceName}} | {{$ctrl.printData.vaultDate}}</div>\n<div class=\"header-line margin-top-10\">{{accountName}}</div>\n<div class=\"section-title text-left\">Overview</div>\n<table class=\"report-table\">\n<thead>\n<tr>\n<th class=\"text-left\">Category</th>\n<th class=\"text-left\">Total</th>\n<th class=\"text-left\">Fit Cash</th>\n<th class=\"text-left\">Unfit Cash</th>\n<th class=\"text-left\">Bagged Coin</th>\n<th class=\"text-left\">Boxed Coin</th>\n<th class=\"text-left\">Rolled Coin</th>\n<th class=\"text-left\">Individual Coin</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"(label, key) in accountData._financialData.dataMap\">\n<td class=\"text-left\">{{label}}</td>\n<td class=\"text-left\">\n{{ key ? $ctrl.formatCurrency((accountData._summaryTotals['Fit Cash'][key] || 0) + (accountData._summaryTotals['Unfit Cash'][key] || 0) + (accountData._summaryTotals['Bagged Coin'][key] || 0) + (accountData._summaryTotals['Boxed Coin'][key] || 0) + (accountData._summaryTotals['Rolled Coin'][key] || 0) + (accountData._summaryTotals['Individual Coin'][key] || 0), accountData._currencySymbol) : '' }}\n</td>\n<td class=\"text-left\">{{ key ? $ctrl.formatCurrency(accountData._summaryTotals['Fit Cash'][key] || 0, accountData._currencySymbol) : '' }}</td>\n<td class=\"text-left\">{{ key ? $ctrl.formatCurrency(accountData._summaryTotals['Unfit Cash'][key] || 0, accountData._currencySymbol) : '' }}</td>\n<td class=\"text-left\">{{ key ? $ctrl.formatCurrency(accountData._summaryTotals['Bagged Coin'][key] || 0, accountData._currencySymbol) : '' }}</td>\n<td class=\"text-left\">{{ key ? $ctrl.formatCurrency(accountData._summaryTotals['Boxed Coin'][key] || 0, accountData._currencySymbol) : '' }}</td>\n<td class=\"text-left\">{{ key ? $ctrl.formatCurrency(accountData._summaryTotals['Rolled Coin'][key] || 0, accountData._currencySymbol) : '' }}</td>\n<td class=\"text-left\">{{ key ? $ctrl.formatCurrency(accountData._summaryTotals['Individual Coin'][key] || 0, accountData._currencySymbol) : '' }}</td>\n</tr>\n</tbody>\n</table>\n<div ng-repeat=\"(categoryName, categoryData) in accountData._financialData.categorizedResults\" class=\"page-break-before-always\">\n<div class=\"category-title\">{{categoryName}}</div>\n<table class=\"report-table\">\n<thead>\n<tr>\n<th class=\"text-left\">Category</th>\n<th class=\"text-left\">Total</th>\n<th class=\"text-left\" ng-repeat=\"denom in categoryData.uniqueDenominations\">{{denom}}\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"row in categoryData.financialData\">\n<td class=\"text-left\">{{row[0]}}</td>\n<td class=\"text-left\">{{row[1]}}</td>\n<td class=\"text-left\" ng-repeat=\"cell in row.slice(2) track by $index\">{{cell}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-init=\"tables = [\n                { title: 'Cash In From ATMs', details: accountData._actualResidualsCountDetails },\n                { title: 'Cash In From ATM Deposits', details: accountData._actualDepositsCountedDetails },\n                { title: 'Cash Out to ATMs', details: accountData._actualCashLoadedDetails },\n                { title: 'Cash In From Location', details: accountData._packableOrdersPackedDetails },\n                { title: 'Cash Out to Location', details: accountData._packableOrdersPackedAllTimeDetails }\n            ]\">\n<div ng-repeat=\"table in tables\" ng-if=\"table.details.excelData.length > 1\">\n<div class=\"page-break-before-always\">\n<div class=\"section-title\">\n{{table.title}}<span ng-if=\"table.details.excelData[table.details.excelData.length - 1][4]\">: {{table.details.excelData[table.details.excelData.length - 1][4]}}</span>\n</div>\n<div class=\"totals-grid margin-bottom-10\" ng-init=\"totalRow = table.details.excelData[table.details.excelData.length - 1]\">\n<div class=\"total-item\" ng-repeat=\"val in totalRow.slice(5) track by $index\" ng-if=\"val && val !== '' && val !== '$0.00'\">\n<strong>{{table.details.columns[$index + 5]}}:</strong> {{val}}\n</div>\n</div>\n<table class=\"transaction-table\">\n<thead>\n<tr>\n<th class=\"fixed-cols header-bg\">\n<div style=\"padding: 6px 3px;font-size: 11pt;\">Transaction Details</div>\n</th>\n<th class=\"denom-cols header-bg\">\n<div class=\"denom-row-header\">\n<div class=\"denom-col-left\">Denomination</div>\n<div class=\"denom-col-right text-right\">Amount</div>\n</div>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"row in table.details.excelData\" ng-if=\"$index < table.details.excelData.length - 1\">\n<td class=\"fixed-cols\">\n<div class=\"info-block\">\n<div><strong>{{table.details.columns[0]}}:</strong> {{row[0]}}</div>\n<div><strong>{{table.details.columns[1]}}:</strong> {{row[1]}}</div>\n<div><strong>{{table.details.columns[2]}}:</strong> {{row[2]}}</div>\n<div class=\"margin-bottom-8\">\n<strong>{{table.details.columns[3]}}:</strong>\n{{row[3]}}\n</div>\n<div class=\"total-box\">\n<strong>{{table.details.columns[4]}}:{{row[4]}}</strong></div>\n</div>\n</td>\n<td class=\"denom-cols\">\n<div class=\"denom-list\">\n<div class=\"denom-row\" ng-repeat=\"val in row.slice(5) track by $index\" ng-if=\"val && val !== '' && val !== '$0.00'\">\n<div class=\"denom-col-left\">{{table.details.columns[$index + 5]}}\n</div>\n<div class=\"denom-col-right text-right\">{{val}}</div>\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="daily_balance_sheet_report_print.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row col-sm-12 remove-padding\">\n<div class=\"remove-pad\">\n<div class=\"col-sm-4\">\n<input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.model.trackingId\" search-autofocus ng-keydown=\"$event.keyCode === 13 && $ctrl.getSoftDeletedShipments()\" placeholder=\"{{'common.trackingId' | translate}}\">\n</div>\n<div class=\"col-sm-4 remove-height\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" ng-click=\"$ctrl.getSoftDeletedShipments()\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" placeholder=\"{{'common.select_date' | translate}}\"/>\n</div>\n<div class=\"col-lg-4 col-md-4 col-sm-4 form-group\">\n<search-and-select ng-model=\"$ctrl.model.toLocation\" values=\"$ctrl.locationList\" key=\"Key\" on-click=\"$ctrl.getSoftDeletedShipments()\" totalrecords=\"$ctrl.totalLocations\" none-selected=\"'bagout.toLocation'\" common-search-flag=\"true\">\n</search-and-select>\n</div>\n</div>\n<div>\n<div class=\"col-lg-4 col-md-4 col-sm-4 form-group\">\n<search-and-select ng-model=\"$ctrl.model.selectedUser\" values=\"$ctrl.userList\" key=\"Key\" on-click=\"$ctrl.getSoftDeletedShipments()\" totalrecords=\"$ctrl.totalUsers\" none-selected=\"'branchFundingSource.user'\" common-search-flag=\"true\"></search-and-select>\n</div>\n<div class=\"col-lg-4 col-md-4 col-sm-4 form-group\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.selectedReason\" ng-options=\"deletedReason.reason for deletedReason in $ctrl.model.uniqueRecords.deletedReasons\" ng-change=\"$ctrl.getSoftDeletedShipments()\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"col-lg-1 col-md-1 col-sm-1 form-group\">\n<button type=\"button\" class=\"btn btn-md btn-primary\" ng-click=\"$ctrl.resetData();\">\n{{'common.reset' | translate}}\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"row remove-padding table-responsive\">\n<table class=\"table table-hover table-bordered table-padding-4 font-12\" ng-if=\"$ctrl.model.softDeletedShipments.length && !$ctrl.model.loading\">\n<thead>\n<tr>\n<td><b>{{'softDeletedShipments.tracking_id' | translate}}</b></td>\n<td><b>{{'softDeletedShipments.vault_date' | translate}}</b></td>\n<td><b>{{'softDeletedShipments.amount' | translate}}</b></td>\n<td><b>{{'softDeletedShipments.from' | translate}}</b></td>\n<td><b>{{'softDeletedShipments.to' | translate}}</b></td>\n<td><b>{{'softDeletedShipments.route' | translate}}</b></td>\n<td class=\"contents-no-wrap\"><b>{{'softDeletedShipments.deleted_by' | translate}}</b></td>\n<td><b>{{'softDeletedShipments.reason' | translate}}</b></td>\n<td class=\"deleted-width-10\"><b>{{'softDeletedShipments.deleted_at' | translate}}</b></td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in $ctrl.model.softDeletedShipments track by $index\">\n<td>\n<span class=\"history-link-btn\" ng-click=\"$ctrl.goToItemHistory(shipment)\">\n{{shipment.trackingId}}\n</span>\n</td>\n<td class=\"contents-no-wrap\">{{$ctrl.moment.utc(shipment.vaultDate).format('YYYY-MM-DD')}}</td>\n<td>{{shipment.amount | currency:'$'}}</td>\n<td>{{shipment.fromLocation.id}} | {{shipment.fromLocation.name}}</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipment)\">\n{{shipment.toLocation.id}}\n</a> | {{shipment.toLocation.name}}\n</td>\n<td>\n<span class=\"history-link-btn\" ng-click=\"$ctrl.goToRouteTab(shipment)\">\n{{shipment.routeId}}\n</span>\n</td>\n<td>\n<span ng-if=\"shipment.deletedByUser.id\">\n{{shipment.deletedByUser.id}} | {{shipment.deletedByUser.firstName}} | {{shipment.deletedByUser.lastName}}\n</span>\n<span ng-if=\"!shipment.deletedByUser.id\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td ng-if=\"shipment.deletedReason\">{{shipment.deletedReason}}</td>\n<td ng-if=\"!shipment.deletedReason\">{{'common.n_a' | translate}}</td>\n<td class=\"deleted-width-10\">\n<span>{{shipment.deletedAt | date : 'MM-dd-yyyy | hh:mm a' }}</span>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-warning text-decoration-none remove-pad\" ng-click=\"$ctrl.confirmUndoDelete(shipment)\" ng-class=\"{'disabled': $ctrl.loading}\">\n<img src=\"" + __webpack_require__(119) + "\" class=\"undo-icon-height-20\" uib-tooltip=\"{{'softDeletedShipments.undo_delete_title' | translate}}\" tooltip-placement=\"top-right\">\n</button>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"row margin-bottom-10\" ng-if=\"!$ctrl.model.loading\">\n<ul uib-pagination total-items=\"$ctrl.pagination.total\" force-ellipses=\"true\" max-size=\"$ctrl.pagination.maxPages\" ng-hide=\"(($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1))\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\"></ul>\n</div>\n<div ng-if=\"!$ctrl.model.softDeletedShipments.length && !$ctrl.model.loading\">\n<div class=\"row alert text-center\" ng-class=\"{'alert-danger': !$ctrl.model.softDeletedShipments.length}\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</form>";
var id1="deleted_shipments.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2681 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"bin-manifest-page\">\n<h2>Deposit Reports Page</h2>\n</div>\n";
var id1="deposit_reports.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2682 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<form name=\"Form\" novalidate class=\"form-validate branch-mgmt-final-residual-count-commit\" autocomplete=\"off\">\n<div>\n<div class=\"col-sm-12 font-size-20 text-center\">\n<b>{{'branch_mgmt.final_residual_count_commit.title' | translate}}</b>\n<hr>\n</div>\n<div class=\"align-center col-sm-12 remove-pad\">\n<div class=\"remove-left-pad col-sm-3\" ng-if=\"$ctrl.model.fundingSource\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOption\" ng-change=\"$ctrl.onDateRangeChange();\" options=\"$ctrl.model.dateRangPickerOptionsfor\" ng-if=\"$ctrl.model.dateRangeOption.startDate\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"col-sm-3 _align-center remove-left-pad\">\n<search-and-select ng-model=\"$ctrl.model.fundingSource\" values=\"$ctrl.model.fundingSourceList\" key=\"Key\" totalrecords=\"$ctrl.model.totalLocationRecords\" onscroll=\"$ctrl.getFundingSource(searchKey, offset)\" none-selected=\"'orderPacking.selectFromLocation'\" on-click=\"$ctrl.onFundingSourceChange();\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-3 remove-left-pad\" ng-if=\"$ctrl.model.fundingSource\">\n<search-and-select ng-model=\"$ctrl.model.user\" values=\"$ctrl.model.userList\" key=\"Key\" totalrecords=\"$ctrl.model.totalUsers\" onscroll=\"$ctrl.getResidualUsers(searchKey, offset)\" none-selected=\"'common.select_user'\" on-click=\"$ctrl.reset(); $ctrl.getResidualsCountCommit(); $ctrl.getResidualsCompletedApproval();\">\n</search-and-select>\n</div>\n<div class=\"col-sm-2 remove-left-pad\" ng-if=\"$ctrl.model.fundingSource && $ctrl.model.currentStats === $ctrl.model.statsObj.pending\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.searchText\" name=\"searchText\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.assertToggleSelection(); $ctrl.reset(); $ctrl.loadData(); $ctrl.assertDepositToggleSelection()\" placeholder=\"{{'branch_mgmt.final_residual_count_commit.search' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-disabled=\"$ctrl.model.gettingResidualShipment\"/>\n</div>\n<div class=\"col-sm-2 remove-left-pad\" ng-if=\"$ctrl.model.fundingSource && $ctrl.model.currentStats === $ctrl.model.statsObj.authorized\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.searchText\" name=\"searchText\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.reset(); $ctrl.loadData()\" placeholder=\"{{'branch_mgmt.final_residual_count_commit.search' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-disabled=\"$ctrl.model.gettingResidualCompletedApprovalList\"/>\n</div>\n<div class=\"col-sm-2 _remove-pad remove-left-pad remove-right-pad\" ng-if=\"$ctrl.model.fundingSource\">\n<div class=\"multi-select location-branch-dd\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.denomsList\" output-model=\"$ctrl.model.denoms\" button-label=\"Key\" item-label=\"Key\" search-property=\"Key\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.reset(); $ctrl.loadData();\" on-select-all=\"$ctrl.reset(); $ctrl.loadData();\" on-select-none=\"$ctrl.reset(); $ctrl.loadData();\" on-reset=\"$ctrl.reset(); $ctrl.loadData();\" is-disabled=\"$ctrl.model.loadCountVariances\">\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.fundingSource\">\n<div class=\"margin-top-20 col-sm-12 align-center remove-left-pad remove-right-pad\" style=\"position: relative;z-index: 0;\">\n<div class=\"btn-group pull-right\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStats\" uib-btn-radio=\"$ctrl.model.statsObj.pending\" ng-click=\"$ctrl.tabSelection('pending')\" ng-class=\"{'btn-success': $ctrl.model.currentStats === $ctrl.model.statsObj.pending, \n                                               'remove-group-btn-color': $ctrl.model.currentStats === $ctrl.model.statsObj.authorized}\">\n{{ 'common.pending' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStats\" uib-btn-radio=\"$ctrl.model.statsObj.authorized\" ng-click=\"$ctrl.tabSelection('authorized')\" ng-class=\"{'btn-success': $ctrl.model.currentStats === $ctrl.model.statsObj.authorized, \n                                              'remove-group-btn-color': $ctrl.model.currentStats === $ctrl.model.statsObj.pending}\">\n{{ 'common.authorized' | translate }}\n</label>\n</div>\n</div>\n</div>\n<div class=\"margin-top-20 margin-bottom-10 remove-left-pad remove-right-pad col-sm-12\">\n<div class=\"font-size-20\">\n<div class=\"pull-left remove-left-pad\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.pending\">\n<strong>{{'branch_mgmt.final_residual_count_commit.atm_residual' | translate}}</strong>\n<span ng-if=\"$ctrl.model.residualCountCommitList.results.length && !$ctrl.model.gettingResidualShipment\">\n<strong> | {{'branch_mgmt.final_residual_count_commit.total_amount_counted' | translate}}</strong>\n<span>: {{$ctrl.model.residualCountCommitList.totalAmountCounted | currency}} <strong style=\"padding-right: 5px;\">|</strong></span>\n</span>\n</div>\n<div class=\"pull-left remove-left-pad\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.authorized\">\n<strong>{{'branch_mgmt.final_residual_count_commit.atm_residual' | translate}}</strong>\n<span ng-if=\"$ctrl.model.residualsCompletedApprovalList.results.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<strong> | {{'branch_mgmt.final_residual_count_commit.total_amount_counted' | translate}}</strong>\n<span>: {{$ctrl.model.residualsCompletedApprovalList.totalAmountCounted | currency}} <strong style=\"padding-right: 5px;\">|</strong></span>\n</span>\n</div>\n<div class=\"col-sm-4 remove-right-pad remove-left-pad\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.pending\">\n<span ng-if=\"$ctrl.model.residualCountCommitList.results.length && !$ctrl.model.gettingResidualShipment\">\n<strong>{{'branch_mgmt.final_residual_count_commit.total_variance' | translate}}</strong>\n<span> : {{$ctrl.model.residualCountCommitList.totalVariance | currency}}</span>\n</span>\n</div>\n<div class=\"col-sm-4 remove-right-pad remove-left-pad\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.authorized\">\n<span ng-if=\"$ctrl.model.residualsCompletedApprovalList.results.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<strong>{{'branch_mgmt.final_residual_count_commit.total_variance' | translate}}</strong>\n<span> : {{$ctrl.model.residualsCompletedApprovalList.totalVariance | currency}}</span>\n</span>\n</div>\n<div class=\"col-sm-2 pull-right remove-right-pad text-align-right\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.pending && $ctrl.model.residualCountCommitList.results.length && !$ctrl.model.gettingResidualShipment\">\n<div class=\"bulk-residual-count-commit-btn\">\n<button class=\"btn btn-md btn-success\" ng-click=\"$ctrl.validateSupervisorScan('atm_residual')\" ng-disabled=\"$ctrl.model.authorizeCountCommit || $ctrl.model.residualTrackingIds.length !== $ctrl.model.residualCountCommitList.results.length\">\n<span>{{'branch_mgmt.final_residual_count_commit.bulk_authorize' | translate}}</span>\n<span ng-if=\"$ctrl.model.authorizeCountCommit\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-2 pull-right remove-right-pad text-align-right\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.authorized && $ctrl.model.depositsCompletedApprovalList.countedDeposits.length\">\n<button style=\"margin-right: 10px;\" type=\"button\" class=\"btn btn-success font-size-20 _pull-right\" ng-click=\"$ctrl.printAuthorizedResidual()\" ng-disabled=\"!$ctrl.model.residualsCompletedApprovalList.results.length || $ctrl.model.gettingResidualCompletedApprovalList\">\n{{'routeSheet.print' | translate}}</button>\n<button type=\"button\" class=\"btn btn-success font-size-20 _pull-right\" ng-click=\"$ctrl.exportResidualsCompletedApproval()\" ng-disabled=\"!$ctrl.model.residualsCompletedApprovalList.results.length || $ctrl.model.gettingResidualCompletedApprovalList || $ctrl.model.isExportingAuthorizedResidual\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExportingAuthorizedResidual\"></span>\n{{'common.export' | translate}}</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.gettingResidualShipment\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10 text-center padding5 denom-position-final-residual-count-commit\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.pending && $ctrl.model.residualCountCommitList.atmDenomSummary.length && !$ctrl.model.gettingResidualShipment\" style=\"gap: 0px;border: 1px solid;border-color: lightgray;\">\n<div ng-repeat=\"summary in $ctrl.model.residualCountCommitList.atmDenomSummary | orderBy:['sortOrder', 'faceValue']\" class=\"denom-width\" style=\"display: inline-flex; align-items: center;\">\n<denom-icon denom-id=\"summary.denominationId\" icon-size=\"35\"> </denom-icon>\n<b>{{summary.amount | currency}}</b>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10 text-center padding5 denom-position-final-residual-count-commit\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.authorized && $ctrl.model.residualsCompletedApprovalList.atmDenomSummary.length && !$ctrl.model.gettingResidualCompletedApprovalList\" style=\"gap: 0px;border: 1px solid;border-color: lightgray;\">\n<div ng-repeat=\"summary in $ctrl.model.residualsCompletedApprovalList.atmDenomSummary | orderBy:['sortOrder', 'faceValue']\" class=\"denom-width\" style=\"display: inline-flex; align-items: center;\">\n<denom-icon denom-id=\"summary.denominationId\" icon-size=\"35\"> </denom-icon>\n<b>{{summary.amount | currency}}</b>\n</div>\n</div>\n<div class=\"w-100\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.pending && !$ctrl.model.gettingResidualShipment\" style=\"overflow-y: auto;max-height: 600px;height:auto;position: relative;\" ng-class=\"{'margin-bottom-20': $ctrl.model.residualCountCommitList.results.length && !$ctrl.model.gettingResidualShipment}\">\n<div class=\"w-100 deposit-table-view\">\n<table class=\"table-pad-7 margin-bottom-10 table table-hover table-striped table-bordered font-12 margin-bottom-0\" ng-if=\"$ctrl.model.residualCountCommitList.results.length && !$ctrl.model.gettingResidualShipment\">\n<thead>\n<tr>\n<th ng-click=\"$ctrl.selectAllPendingResiduals()\" align=\"center\" class=\"cursor-pointer\">\n{{'location_types.All' | translate}}</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('row')\">\n<b>#</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'row'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('locationId')\">\n<b>{{'common.locationId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"text-center vault-date-width\" ng-click=\"$ctrl.sortData('serviceDate')\"><b>{{'branch_mgmt.servicehistory.service_date' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'serviceDate'}\"></span>\n</th>\n<th class=\"text-center vault-date-width\" ng-click=\"$ctrl.sortData('countVaultDate')\"><b>{{'atm_deposit_packing.loadDate' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countVaultDate'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('orderNo')\">\n<b>{{'atm_residual.orderNo' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'orderNo'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('denominationId')\">\n<b>{{'branch_mgmt.orders_denomination' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'denominationId'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('performedById')\">\n<b>{{'branch_mgmt.performed_by' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'performedById'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('amountLoadRequested')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_requested' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountLoadRequested'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('amountLoadActual')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_loaded' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountLoadActual'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('amountCRV')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_CRV' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountCRV'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('amountExpected')\">\n<b>{{'branch_mgmt.final_residual_count_commit.residual_expected' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountExpected'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('amountCounted')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_counted' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountCounted'}\"></span>\n</th>\n<th class=\"text-center variance-col-width-10\" ng-click=\"$ctrl.sortData('amountVariance')\">\n<b>{{'atm_residual.variance' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountVariance'}\"></span>\n</th>\n<th class=\"text-center\">\n<b>{{'atm_residual.action' | translate}}</b>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.residualCountCommitList.results | orderBy:$ctrl.sortColumn:$ctrl.reverseSort track by $index\">\n<td>\n<input type=\"checkbox\" ng-disabled=\"$ctrl.model.gettingResidualShipment\" ng-click=\"$ctrl.selectedResiduals($event, data, index)\" ng-model=\"data.isSelected\">\n</td>\n<td class=\"text-center\">{{data.row}}</td>\n<td class=\"text-center\"> <a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.locationId)\">{{data.locationId}}</a>\n</td>\n<td class=\"text-center\">{{data.serviceDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td class=\"text-center\">{{data.countVaultDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td class=\"text-center\"> <a href=\"#\" ng-click=\"$ctrl.goToOrderHistory(data)\">{{data.orderNo}}</a> </td>\n<td class=\"text-center\"><denom-icon denom-id=\"data.denominationId\" icon-size=\"35\"> </denom-icon></td>\n<td class=\"text-center\"> <a href=\"#\" ng-click=\"$ctrl.goToUserTab(data.performedById)\">{{data.performedById}}</a>\n</td><td class=\"text-center\">{{data.amountLoadRequested | currency}}</td>\n<td class=\"text-center\">{{data.amountLoadActual | currency}}</td>\n<td class=\"text-center\">{{data.amountCRV | currency}}</td>\n<td class=\"text-center\">{{data.amountExpected | currency}}</td>\n<td class=\"text-center\">{{data.amountCounted | currency}}</td>\n<td class=\"text-center\" ng-class=\"{'variance-bg-color': data.amountVariance !== 0}\">{{data.amountVariance | currency}}\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.getComments(data);\" ng-if=\"data.comment\" uib-tooltip=\"{{'checkout.comments' | translate}}\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-xs btn-success btn-icon btn-cst-height-22\" ng-click=\"$ctrl.goToATMCount(data)\">\n<span class=\"glyphicon glyphicon-arrow-right\" uib-tooltip=\"{{'branch_mgmt.final_residual_count_commit.ATMCount_history' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.residualCountCommitList.results.length && !$ctrl.model.gettingResidualShipment\">\n<div class=\"text-center alert alert-danger\" ng-class=\"{'margin-top-10': !$ctrl.model.fundingSource}\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n<div class=\"w-100\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.authorized\">\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.gettingResidualCompletedApprovalList\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"table-responsive w-100\" ng-class=\"{'margin-bottom-20': $ctrl.model.depositsCompletedApprovalList.countedDeposits.length}\">\n<table class=\"margin-bottom-10 table table-hover table-striped table-bordered font-12\" ng-if=\"$ctrl.model.residualsCompletedApprovalList.results.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<thead>\n<tr class=\"autorize-view-header\">\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('row')\">\n<b>#</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'row'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('locationId')\">\n<b>{{'common.locationId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"text-center vault-date-width\" ng-click=\"$ctrl.sortData('serviceDate')\"><b>{{'branch_mgmt.servicehistory.service_date' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'serviceDate'}\"></span>\n</th>\n<th class=\"text-center vault-date-width\" ng-click=\"$ctrl.sortData('countVaultDate')\"><b>{{'atm_deposit_packing.loadDate' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'countVaultDate'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('orderNo')\">\n<b>{{'atm_residual.orderNo' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'orderNo'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('denominationId')\">\n<b>{{'branch_mgmt.orders_denomination' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'denominationId'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('performedById')\">\n<b>{{'branch_mgmt.final_residual_count_commit.counter_messenger' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'performedById'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('amountLoadRequested')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_requested' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountLoadRequested'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('amountLoadActual')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_loaded' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountLoadActual'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('amountCRV')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_CRV' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountCRV'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('amountExpected')\">\n<b>{{'branch_mgmt.final_residual_count_commit.residual_expected' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountExpected'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortData('amountCounted')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_counted' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountCounted'}\"></span>\n</th>\n<th class=\"text-center variance-col-width-10\" ng-click=\"$ctrl.sortData('amountVariance')\">\n<b>{{'atm_residual.variance' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountVariance'}\"></span>\n</th>\n<th class=\"text-center\">\n<b>{{'atm_residual.action' | translate}}</b>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.residualsCompletedApprovalList.results | orderBy:$ctrl.sortColumn:$ctrl.reverseSort track by $index\">\n<td class=\"text-center\">{{data.row}}</td>\n<td class=\"text-center\"> <a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.locationId)\">{{data.locationId}}</a>\n</td>\n<td class=\"text-center\">{{data.serviceDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td class=\"text-center\">{{data.countVaultDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td class=\"text-center\"> <a href=\"#\" ng-click=\"$ctrl.goToOrderHistory(data)\">{{data.orderNo}}</a> </td>\n<td class=\"text-center\"><denom-icon denom-id=\"data.denominationId\" icon-size=\"35\"> </denom-icon></td>\n<td class=\"text-center\">\n<span><a href=\"#\" ng-click=\"$ctrl.goToUserTab(data.performedById)\">{{data.performedById}}</a></span>\n<span ng-if=\"data.messengerId\"> | <a href=\"#\" ng-click=\"$ctrl.goToUserTab(data.messengerId)\">{{data.messengerId}}</a></span>\n</td>\n<td class=\"text-center\">{{data.amountLoadRequested | currency}}</td>\n<td class=\"text-center\">{{data.amountLoadActual | currency}}</td>\n<td class=\"text-center\">{{data.amountCRV | currency}}</td>\n<td class=\"text-center\">{{data.amountExpected | currency}}</td>\n<td class=\"text-center\">{{data.amountCounted | currency}}</td>\n<td class=\"text-center\" ng-class=\"{'variance-bg-color': data.amountVariance !== 0}\">{{data.amountVariance | currency}}\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.getComments(data);\" ng-if=\"data.comment\" uib-tooltip=\"{{'checkout.comments' | translate}}\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-xs btn-success btn-icon btn-cst-height-22\" ng-click=\"$ctrl.goToATMCount(data)\">\n<span class=\"glyphicon glyphicon-arrow-right\" uib-tooltip=\"{{'branch_mgmt.final_residual_count_commit.ATMCount_history' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"remove-left-pad col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.fundingSource\">\n<ul uib-pagination total-items=\"$ctrl.model.pagination.total\" items-per-page=\"$ctrl.model.pagination.pageLimit\" ng-if=\"($ctrl.model.pagination.total>=$ctrl.model.pagination.pageLimit) && (!$ctrl.model.gettingResidualCompletedApprovalList)\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"$ctrl.model.pagination.maxPages\">\n</ul>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.residualsCompletedApprovalList.results.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<div class=\"text-center alert alert-danger\" ng-class=\"{'margin-top-10': !$ctrl.model.fundingSource}\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.fundingSource\">\n<div class=\"margin-bottom-10 remove-left-pad remove-right-pad col-sm-12\">\n<div class=\"font-size-20\">\n<div class=\"pull-left remove-left-pad\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.pending\">\n<strong>{{'branch_mgmt.final_residual_count_commit.deposit' | translate}}</strong>\n<span ng-if=\"$ctrl.model.residualCountCommitList.countedDeposits.length && !$ctrl.model.gettingResidualShipment\">\n<strong> | {{'branch_mgmt.final_residual_count_commit.total_amount_counted' | translate}}</strong>\n<span>: {{$ctrl.model.residualCountCommitList.totalCountedDepositsAmount | currency}} <strong style=\"padding-right: 5px;\">|</strong></span>\n</span>\n</div>\n<div class=\"pull-left remove-left-pad\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.authorized\">\n<strong>{{'branch_mgmt.final_residual_count_commit.deposit' | translate}}</strong>\n<span ng-if=\"$ctrl.model.depositsCompletedApprovalList.countedDeposits.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<strong> | {{'branch_mgmt.final_residual_count_commit.total_amount_counted' | translate}}</strong>\n<span>: {{$ctrl.model.depositsCompletedApprovalList.totalCountedDepositsAmount | currency}} <strong style=\"padding-right: 5px;\">|</strong></span>\n</span>\n</div>\n<div class=\"col-sm-4 remove-right-pad remove-left-pad\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.pending\">\n<span ng-if=\"$ctrl.model.residualCountCommitList.countedDeposits.length && !$ctrl.model.gettingResidualShipment\">\n<strong>{{'branch_mgmt.final_residual_count_commit.total_variance' | translate}}</strong>\n<span> : {{$ctrl.model.residualCountCommitList.totalCountedDepositsVariance | currency}}</span>\n</span>\n</div>\n<div class=\"col-sm-4 remove-right-pad remove-left-pad\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.authorized\">\n<span ng-if=\"$ctrl.model.depositsCompletedApprovalList.countedDeposits.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<strong>{{'branch_mgmt.final_residual_count_commit.total_variance' | translate}}</strong>\n<span> : {{$ctrl.model.depositsCompletedApprovalList.totalCountedDepositsVariance | currency}}</span>\n</span>\n</div>\n<div class=\"col-sm-2 pull-right remove-right-pad text-align-right\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.pending && $ctrl.model.residualCountCommitList.countedDeposits.length && !$ctrl.model.gettingResidualShipment\">\n<button class=\"btn btn-md btn-success\" ng-click=\"$ctrl.validateSupervisorScan('deposit')\" ng-disabled=\"$ctrl.model.authorizeCountCommit || $ctrl.model.depositTrackingIds.length !== $ctrl.model.residualCountCommitList.countedDeposits.length\">\n<span>{{'branch_mgmt.final_residual_count_commit.bulk_authorize' | translate}}</span>\n<span ng-if=\"$ctrl.model.authorizeCountCommit\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n</div>\n<div class=\"col-sm-2 pull-right remove-right-pad text-align-right\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.authorized && $ctrl.model.depositsCompletedApprovalList.countedDeposits.length\">\n<button style=\"margin-right: 10px;\" type=\"button\" class=\"btn btn-success font-size-20 _pull-right\" ng-click=\"$ctrl.printAuthorizedDepositsResidual()\" ng-disabled=\"!$ctrl.model.depositsCompletedApprovalList.countedDeposits.length || $ctrl.model.gettingResidualCompletedApprovalList\">\n{{'routeSheet.print' | translate}}</button>\n<button type=\"button\" class=\"btn btn-success font-size-20 _pull-right\" ng-click=\"$ctrl.exportDepositsResidualsCompletedApproval()\" ng-disabled=\"!$ctrl.model.depositsCompletedApprovalList.countedDeposits.length || $ctrl.model.gettingResidualCompletedApprovalList || $ctrl.model.isDepositsAuthorizedResidualExporting\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isDepositsAuthorizedResidualExporting\"></span>\n{{'common.export' | translate}}</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.gettingResidualShipment\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10 text-center padding5 denom-position-final-residual-count-commit\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.pending && $ctrl.model.residualCountCommitList.depositDenomSummary.length && !$ctrl.model.gettingResidualShipment\" style=\"gap: 0px;border: 1px solid;border-color: lightgray;\">\n<div ng-repeat=\"summary in $ctrl.model.residualCountCommitList.depositDenomSummary | orderBy:['sortOrder', 'faceValue']\" class=\"denom-width\" style=\"display: inline-flex; align-items: center;\">\n<denom-icon denom-id=\"summary.denominationId\" icon-size=\"35\"> </denom-icon>\n<b>{{summary.amount | currency}}</b>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10 text-center padding5 denom-position-final-residual-count-commit\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.authorized && $ctrl.model.depositsCompletedApprovalList.depositDenomSummary.length && !$ctrl.model.gettingResidualCompletedApprovalList\" style=\"gap: 0px;border: 1px solid;border-color: lightgray;\">\n<div ng-repeat=\"summary in $ctrl.model.depositsCompletedApprovalList.depositDenomSummary | orderBy:['sortOrder', 'faceValue']\" class=\"denom-width\" style=\"display: inline-flex; align-items: center;\">\n<denom-icon denom-id=\"summary.denominationId\" icon-size=\"35\"> </denom-icon>\n<b>{{summary.amount | currency}}</b>\n</div>\n</div>\n<div class=\"w-100\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.pending && !$ctrl.model.gettingResidualShipment\" style=\"overflow-y: auto;margin-bottom: 30px; max-height: 600px; position: relative;\">\n<div class=\"w-100 deposit-table-view\">\n<table class=\"table-pad-7 margin-bottom-10 table table-hover table-striped table-bordered font-12 margin-bottom-0\" ng-if=\"$ctrl.model.residualCountCommitList.countedDeposits.length && !$ctrl.model.gettingResidualShipment\">\n<thead class=\"remove-white-space\">\n<tr>\n<th ng-click=\"$ctrl.selectAllPendingDeposits()\" align=\"center\" class=\"cursor-pointer\">\n{{'location_types.All' | translate}}\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('row')\">\n<b>#</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'row'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('locationId')\">\n<b>{{'common.locationId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"text-center vault-date-width\" ng-click=\"$ctrl.sortDepositData('countVaultDate')\">\n<b>{{'atm_deposit_packing.countVaultDate' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'countVaultDate'}\"></span>\n</th>\n<th class=\"text-center vault-date-width\" ng-click=\"$ctrl.sortDepositData('countedAt')\">\n<b>{{'atm_deposit_packing.countedAt' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'countedAt'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('performedById')\">\n<b>{{'branch_mgmt.counted_by' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'performedById'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('totalDRDAmount')\">\n<b>{{'branch_mgmt.total_amount' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'totalDRDAmount'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('statedTotalAmount')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_stated' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'statedTotalAmount'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('amountCounted')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_counted' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'amountCounted'}\"></span>\n</th>\n<th class=\"text-center variance-col-width-10\" ng-click=\"$ctrl.sortDepositData('amountVariance')\">\n<b>{{'atm_residual.variance' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'amountVariance'}\"></span>\n</th>\n<th class=\"text-center\">\n<b>{{'atm_residual.action' | translate}}</b>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.residualCountCommitList.countedDeposits | orderBy:$ctrl.depositSortColumn:$ctrl.depositReverseSort track by $index\">\n<td>\n<input type=\"checkbox\" ng-disabled=\"$ctrl.model.gettingDepositShipment\" ng-click=\"$ctrl.selectedDepositResiduals($event, data, index)\" ng-model=\"data.isDepositSelected\">\n</td>\n<td class=\"text-center\">{{data.row}}</td>\n<td class=\"text-center\"> <a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.locationId)\">{{data.locationId}}</a>\n</td>\n<td class=\"text-center\">{{data.countVaultDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td class=\"text-center\">\n{{ (data.countedAt | date : \"yyyy-MM-dd\" : 'UTC') + ' | ' + (data.countedAt | date : \"HH:mm:ss\" : 'UTC') }}\n</td>\n<td class=\"text-center\">\n<span><a href=\"#\" ng-click=\"$ctrl.goToUserTab(data.performedById)\">{{data.performedById}}</a></span>\n<span ng-if=\"data.messengerId\"> | <a href=\"#\" ng-click=\"$ctrl.goToUserTab(data.messengerId)\">{{data.messengerId}}</a></span>\n</td>\n<td class=\"text-center\">{{data.totalDRDAmount | currency}}</td>\n<td class=\"text-center\">{{data.statedTotalAmount | currency}}</td>\n<td class=\"text-center\">{{data.amountCounted | currency}}</td>\n<td class=\"text-center\" ng-class=\"{'variance-bg-color': data.amountVariance !== 0}\">\n{{data.amountVariance | currency}}\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.getComments(data);\" ng-if=\"data.comment\" uib-tooltip=\"{{'checkout.comments' | translate}}\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-xs btn-icon btn-cst-height-22\" style=\"background-color: #7952b3; color: white;\" ng-click=\"$ctrl.showDenomBreakdown(data)\" uib-tooltip=\"Denomination Details\">\n<span class=\"glyphicon glyphicon-list\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success btn-icon btn-cst-height-22\" ng-click=\"$ctrl.goToATMCountOfDeposit(data)\">\n<span class=\"glyphicon glyphicon-arrow-right\" uib-tooltip=\"{{'branch_mgmt.final_residual_count_commit.ATMCount_history' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.model.fundingSource && !$ctrl.model.residualCountCommitList.countedDeposits.length && !$ctrl.model.gettingResidualShipment\">\n<div class=\"text-center alert alert-danger\" ng-class=\"{'margin-top-10': !$ctrl.model.fundingSource}\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n<div class=\"w-100 margin-bottom-20\" ng-if=\"$ctrl.model.currentStats === $ctrl.model.statsObj.authorized\">\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.gettingResidualCompletedApprovalList\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"table-responsive w-100\">\n<table class=\"margin-bottom-10 table table-hover table-striped table-bordered font-12\" ng-if=\"$ctrl.model.depositsCompletedApprovalList.countedDeposits.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<thead class=\"autorize-view-header remove-white-space\">\n<tr>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('row')\">\n<b>#</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'row'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('locationId')\">\n<b>{{'common.locationId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"text-center vault-date-width\" ng-click=\"$ctrl.sortDepositData('countVaultDate')\">\n<b>{{'atm_deposit_packing.countVaultDate' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'countVaultDate'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('performedById')\">\n<b>{{'branch_mgmt.counted_by' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'performedById'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('totalDRDAmount')\">\n<b>{{'branch_mgmt.total_amount' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'totalDRDAmount'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('statedTotalAmount')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_stated' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'statedTotalAmount'}\"></span>\n</th>\n<th class=\"text-center\" ng-click=\"$ctrl.sortDepositData('amountCounted')\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_counted' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'amountCounted'}\"></span>\n</th>\n<th class=\"text-center variance-col-width-10\" ng-click=\"$ctrl.sortDepositData('amountVariance')\">\n<b>{{'atm_residual.variance' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.depositReverseSort, 'active' : $ctrl.depositSortColumn === 'amountVariance'}\"></span>\n</th>\n<th class=\"text-center\">\n<b>{{'atm_residual.action' | translate}}</b>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.depositsCompletedApprovalList.countedDeposits | orderBy:$ctrl.depositSortColumn:$ctrl.depositReverseSort track by $index\">\n<td class=\"text-center\">{{data.row}}</td>\n<td class=\"text-center\"> <a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.locationId)\">{{data.locationId}}</a>\n</td>\n<td class=\"text-center\">{{data.countVaultDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td class=\"text-center\">\n<span><a href=\"#\" ng-click=\"$ctrl.goToUserTab(data.performedById)\">{{data.performedById}}</a></span>\n<span ng-if=\"data.messengerId\"> | <a href=\"#\" ng-click=\"$ctrl.goToUserTab(data.messengerId)\">{{data.messengerId}}</a></span>\n</td>\n<td class=\"text-center\">{{data.totalDRDAmount | currency}}</td>\n<td class=\"text-center\">{{data.statedTotalAmount | currency}}</td>\n<td class=\"text-center\">{{data.amountCounted | currency}}</td>\n<td class=\"text-center\" ng-class=\"{'variance-bg-color': data.amountVariance !== 0}\">\n{{data.amountVariance | currency}}\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.getComments(data);\" ng-if=\"data.comment\" uib-tooltip=\"{{'checkout.comments' | translate}}\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-xs btn-icon btn-cst-height-22\" style=\"background-color: #7952b3; color: white;\" ng-click=\"$ctrl.showDenomBreakdown(data)\" uib-tooltip=\"Denomination Details\">\n<span class=\"glyphicon glyphicon-list\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success btn-icon btn-cst-height-22\" ng-click=\"$ctrl.goToATMCountOfDeposit(data)\">\n<span class=\"glyphicon glyphicon-arrow-right\" uib-tooltip=\"{{'branch_mgmt.final_residual_count_commit.ATMCount_history' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"remove-left-pad col-sm-12 margin-bottom-20 margin-top-10\" ng-if=\"$ctrl.model.fundingSource && $ctrl.model.depositsCompletedApprovalList.countedDeposits.length\">\n<ul uib-pagination total-items=\"$ctrl.model.paginationDeposit.total\" items-per-page=\"$ctrl.model.paginationDeposit.pageLimit\" ng-if=\"($ctrl.model.paginationDeposit.total>=$ctrl.model.paginationDeposit.pageLimit) && (!$ctrl.model.gettingResidualCompletedApprovalList)\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.paginationDeposit.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"$ctrl.model.paginationDeposit.maxPages\">\n</ul>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.depositsCompletedApprovalList.countedDeposits.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<div class=\"text-center alert alert-danger\" ng-class=\"{'margin-top-10': !$ctrl.model.fundingSource}\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n</div>\n</form>\n";
var id1="final_residual_count_commit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2683 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"tab-content\">\n<div class=\"margin-top-10\" ng-if=\"$ctrl.model.currentStats === 'authorizedResidual' && $ctrl.model.sectionType === 'atm'\">\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.gettingResidualCompletedApprovalList\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"!$ctrl.model.gettingResidualCompletedApprovalList\">\n<div class=\"row margin-bottom-10\">\n<div class=\"col-sm-12 col-print-12 text-align-center\">\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n</div>\n<div class=\"col-sm-12 print-margin-top-20 margin-10 remove-right-pad remove-left-pad\">\n<div class=\"pull-left remove-left-pad\" ng-if=\"$ctrl.model.currentStats === 'authorizedResidual'\">\n<span class=\"font-size-18\" ng-if=\"$ctrl.model.residualsCompletedApprovalList.results.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<strong>{{'branch_mgmt.final_residual_count_commit.atm_residual' | translate}} | </strong>\n<strong>{{'branch_mgmt.final_residual_count_commit.total_amount_counted' | translate}}</strong>\n<span>:{{$ctrl.model.residualsCompletedApprovalList.totalAmountCounted | currency}} | </span>\n<strong>{{$ctrl.model.fundingSource.Key}} | </strong>\n<span class=\"font-size-18\" ng-if=\"$ctrl.model.residualsCompletedApprovalList.results.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<strong>{{'branch_mgmt.final_residual_count_commit.total_variance' | translate}}</strong>\n<span> : {{$ctrl.model.residualsCompletedApprovalList.totalVariance | currency}}</span>\n</span>\n</span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-right-pad remove-left-pad print-margin-top-10 margin-10\" ng-if=\"$ctrl.model.currentStats === 'authorizedResidual'\">\n<div class=\"table-responsive w-100\">\n<table class=\"margin-bottom-10 table table-hover table-striped table-bordered font-12\" ng-if=\"$ctrl.model.residualsCompletedApprovalList.results.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<thead>\n<tr>\n<th class=\"text-center\"><b>#</b></th>\n<th class=\"text-center\"><b>{{'common.locationId' | translate}}</b></th>\n<th class=\"text-center vault-date-width\"><b>{{'branch_mgmt.servicehistory.service_date' | translate}}</b></th>\n<th class=\"text-center vault-date-width\"><b>{{'atm_deposit_packing.loadDate' | translate}}</b></th>\n<th class=\"text-center\"><b>{{'atm_residual.orderNo' | translate}}</b> </th>\n<th class=\"text-center\"><b>{{'branch_mgmt.orders_denomination' | translate}}</b> </th>\n<th class=\"text-center\"><b>{{'branch_mgmt.final_residual_count_commit.counter_messenger' | translate}}</b></th>\n<th class=\"text-center\"><b>{{'branch_mgmt.final_residual_count_commit.amount_requested' | translate}}</b></th>\n<th class=\"text-center\"><b>{{'branch_mgmt.final_residual_count_commit.amount_loaded' | translate}}</b></th>\n<th class=\"text-center\"><b>{{'branch_mgmt.final_residual_count_commit.amount_CRV' | translate}}</b></th>\n<th class=\"text-center\"><b>{{'branch_mgmt.final_residual_count_commit.residual_expected' | translate}}</b></th>\n<th class=\"text-center\"><b>{{'branch_mgmt.final_residual_count_commit.amount_counted' | translate}}</b></th>\n<th class=\"text-center variance-col-width-10\"><b>{{'atm_residual.variance' | translate}}</b></th>\n<th class=\"text-center\"><b>{{'atm_residual.comments' | translate}}</b></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.residualsCompletedApprovalList.results | orderBy:data.countVaultDate track by $index\">\n<td class=\"text-center\">{{data.row}}</td>\n<td class=\"text-center\">{{data.locationId}}</td>\n<td class=\"text-center\">{{data.serviceDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td class=\"text-center\">{{data.countVaultDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td class=\"text-center\">{{data.orderNo}}</td>\n<td class=\"text-center\">{{data.denominationId}}</td>\n<td class=\"text-center\">\n<span>{{data.performedById}}</span>\n<span ng-if=\"data.messengerId\"> | {{data.messengerId}}</span>\n</td>\n<td class=\"text-center\">{{data.amountLoadRequested | currency}}</td>\n<td class=\"text-center\">{{data.amountLoadActual | currency}}</td>\n<td class=\"text-center\">{{data.amountCRV | currency}}</td>\n<td class=\"text-center\">{{data.amountExpected | currency}}</td>\n<td class=\"text-center\">{{data.amountCounted | currency}}</td>\n<td class=\"text-center\" ng-class=\"{'variance-bg-color': data.amountVariance !== 0}\">{{data.amountVariance | currency}}</td>\n<td class=\"text-center\">\n<span ng-if=\"data.comment\">{{data.comment}}</span>\n<span ng-if=\"!data.comment\">{{'common.n_a' | translate}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.residualsCompletedApprovalList.results.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<div class=\"text-center alert alert-danger\" ng-class=\"{'margin-top-10': !$ctrl.model.fundingSource}\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"margin-top-10\" ng-if=\"$ctrl.model.currentStats === 'authorizedResidual' && $ctrl.model.sectionType === 'deposit'\">\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.gettingResidualCompletedApprovalList\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"!$ctrl.model.gettingResidualCompletedApprovalList\">\n<div class=\"row margin-bottom-10\">\n<div class=\"col-sm-12 col-print-12 text-align-center\">\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n</div>\n<div class=\"col-sm-12 print-margin-top-20 margin-10 remove-right-pad remove-left-pad\">\n<div class=\"pull-left remove-left-pad\" ng-if=\"$ctrl.model.currentStats === 'authorizedResidual'\">\n<span class=\"font-size-18\" ng-if=\"$ctrl.model.residualsCompletedApprovalList.countedDeposits.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<strong>{{'branch_mgmt.final_residual_count_commit.deposit' | translate}} | </strong>\n<strong>{{'branch_mgmt.final_residual_count_commit.total_amount_counted' | translate}}</strong>\n<span>:{{$ctrl.model.residualsCompletedApprovalList.totalCountedDepositsAmount | currency}} |\n</span>\n<strong>{{$ctrl.model.fundingSource.Key}} | </strong>\n<span class=\"font-size-18\" ng-if=\"$ctrl.model.residualsCompletedApprovalList.countedDeposits.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<strong>{{'branch_mgmt.final_residual_count_commit.total_variance' | translate}}</strong>\n<span> : {{$ctrl.model.residualsCompletedApprovalList.totalCountedDepositsVariance | currency}}</span>\n</span>\n</span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-right-pad remove-left-pad print-margin-top-10 margin-10\" ng-if=\"$ctrl.model.currentStats === 'authorizedResidual'\">\n<div class=\"table-responsive w-100\">\n<table class=\"margin-bottom-10 table table-hover table-striped table-bordered font-12\" ng-if=\"$ctrl.model.residualsCompletedApprovalList.countedDeposits.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<thead>\n<tr>\n<th class=\"text-center\"><b>#</b></th>\n<th class=\"text-center\"><b>{{'common.locationId' | translate}}</b></th>\n<th class=\"text-center vault-date-width\">\n<b>{{'atm_deposit_packing.loadDate' | translate}}</b></th>\n<th class=\"text-center\">\n<b>{{'branch_mgmt.final_residual_count_commit.counter_messenger' | translate}}</b></th>\n<th class=\"text-center\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_stated' | translate}}</b></th>\n<th class=\"text-center\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_counted' | translate}}</b></th>\n<th class=\"text-center variance-col-width-10\"><b>{{'atm_residual.variance' | translate}}</b>\n</th>\n<th class=\"text-center\"><b>{{'atm_residual.comments' | translate}}</b></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.residualsCompletedApprovalList.countedDeposits | orderBy:data.countVaultDate track by $index\">\n<td class=\"text-center\">{{data.row}}</td>\n<td class=\"text-center\">{{data.locationId}}</td>\n<td class=\"text-center\">{{data.countVaultDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td class=\"text-center\">\n<span>{{data.performedById}}</span>\n<span ng-if=\"data.messengerId\"> | {{data.messengerId}}</span>\n</td>\n<td class=\"text-center\">{{data.statedTotalAmount | currency}}</td>\n<td class=\"text-center\">{{data.amountCounted | currency}}</td>\n<td class=\"text-center\" ng-class=\"{'variance-bg-color': data.amountVariance !== 0}\">\n{{data.amountVariance | currency}}</td>\n<td class=\"text-center\">\n<span ng-if=\"data.comment\">{{data.comment}}</span>\n<span ng-if=\"!data.comment\">{{'common.n_a' | translate}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.residualsCompletedApprovalList.countedDeposits.length && !$ctrl.model.gettingResidualCompletedApprovalList\">\n<div class=\"text-center alert alert-danger\" ng-class=\"{'margin-top-10': !$ctrl.model.fundingSource}\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="final_residual_count_commit_print.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2684 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12 remove-pad import-file-view-section\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-offset-4 col-sm-4 font-size-20 text-center\">\n<b>{{'branch_mgmt.import_files_view.import_files' | translate}}</b>\n<hr class=\"hr-line\">\n</div>\n<div class=\"col-sm-12 align-center\">\n<div class=\"_col-sm-2 _remove-pad btn-group\">\n<button class=\"btn btn-default\" ng-model=\"$ctrl.model.currentStat\" uib-btn-radio=\"$ctrl.model.stats.importFile\" ng-click=\"$ctrl.tabSelection('importFile')\" ng-class=\"{'btn-success': $ctrl.model.currentStat === $ctrl.model.stats.importFile, \n                                   'remove-btn-grp-color': $ctrl.model.currentStat === $ctrl.model.stats.evertecBatch}\">\n{{'branch_mgmt.import_files_view.import_files' | translate}}\n</button>\n<button class=\"btn btn-default\" ng-model=\"$ctrl.model.currentStat\" uib-btn-radio=\"$ctrl.model.stats.evertecBatch\" ng-click=\"$ctrl.tabSelection('evertecBatch');\" ng-class=\"{'btn-success': $ctrl.model.currentStat === $ctrl.model.stats.evertecBatch, \n                                   'remove-btn-grp-color': $ctrl.model.currentStat === $ctrl.model.stats.importFile}\">\n{{'branch_mgmt.import_file_view.evertec_batch' | translate}}\n</button>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<hr class=\"hr-line\">\n</div>\n<div class=\"col-sm-12 cash-variances-search-section remove-left-pad remove-right-pad\" ng-if=\"$ctrl.model.currentStat === $ctrl.model.stats.importFile\">\n<div class=\"remove-left-pad col-sm-3\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" options=\"$ctrl.model.dateRange\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled': $ctrl.model.importFileViewObj.loading}\"/>\n</div>\n<div class=\"remove-left-pad col-sm-3\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.importFileViewObj.status\" ng-options=\"status.value as status.label for status in $ctrl.model.importFileViewObj.statusList\" ng-change=\"$ctrl.filterImportFileView();\" ng-disabled=\"$ctrl.model.importFileViewObj.loading\">\n<option value=\"\" selected=\"selected\">({{'common.select_status' | translate}})</option>\n</select>\n</div>\n<div class=\"remove-left-pad col-sm-3\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.importFileViewObj.fileAdapter\" ng-options=\"fileAdapter for fileAdapter in $ctrl.model.importFileViewObj.fileAdapterList\" ng-change=\"$ctrl.filterImportFileView();\" ng-disabled=\"$ctrl.model.importFileViewObj.loading\">\n<option value=\"\" selected=\"selected\">({{'branch_mgmt.import_file_view.select_file_adapter' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 cash-variances-search-section remove-left-pad remove-right-pad\" ng-if=\"$ctrl.model.currentStat === $ctrl.model.stats.evertecBatch\">\n<div class=\"col-sm-3\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.evertecBatchFileObj.searchText\" name=\"searchText\" ng-model-options=\"{debounce: 1000}\" search-autofocus ng-change=\"$ctrl.filterEvertecBatchView()\" placeholder=\"{{'common.locationId' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-disabled=\"$ctrl.model.evertecBatchFileObj.loading\"/>\n</div>\n<div class=\"remove-left-pad col-sm-3\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.evertecBatchFileObj.status\" ng-options=\"status.value as status.label for status in $ctrl.model.evertecBatchFileObj.statusList\" ng-change=\"$ctrl.filterEvertecBatchView();\" ng-disabled=\"$ctrl.model.evertecBatchFileObj.loading\">\n<option value=\"\" selected=\"selected\">({{'common.select_status' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-validate remove-padding\" novalidate>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"$ctrl.model.currentStat === $ctrl.model.stats.importFile\">\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.importFileViewObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding table-margin-top-10 table-responsive\" ng-if=\"!$ctrl.model.importFileViewObj.loading && $ctrl.model.importFileViewObj.results.length\">\n<table class=\"table table-striped table-bordered\">\n<thead class=\"text-center\">\n<tr>\n<td><strong>{{'branch_mgmt.import_file_view.file_name' | translate}}</strong></td>\n<td><strong>{{'branch_mgmt.import_file_view.file_size' | translate}}</strong></td>\n<td><strong>{{'branch_mgmt.import_file_view.file_adapter' | translate}}</strong></td>\n<td><strong>{{'branch_mgmt.import_file_view.result' | translate}}</strong></td>\n<td> <strong>{{'branch_mgmt.orders_error_msg' | translate}}</strong> </td>\n<td><strong>{{'branch_mgmt.import_file_view.import_warnings' | translate}}</strong></td>\n<td><strong>{{'common.duration' | translate}}</strong></td>\n<td><strong>{{'bypassCode.date' | translate}}</strong></td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in $ctrl.model.importFileViewObj.results track by $index\">\n<td>{{data.fileName}}</td>\n<td>{{$ctrl.formatFileSize(data.fileSize)}}</td>\n<td>{{data.fileAdapter}}</td>\n<td ng-class=\"{'text-success': data.result == 'OK', 'text-danger': data.result == 'ERROR'}\">{{data.result}}</td>\n<td>\n<span ng-if=\"data.errorMessage\">{{data.errorMessage}}</span>\n<span ng-if=\"!data.errorMessage\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"data.importWarnings\">{{data.importWarnings}}</span>\n<span ng-if=\"!data.importWarnings\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{$ctrl.formatSeconds(data.duration)}}</td>\n<td>{{data.timestamp | date: 'yyyy-MM-dd | hh:mm:ss a'}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 margin-10 remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.model.importFileViewObj.loading && !$ctrl.model.importFileViewObj.results.length\">\n<span class=\"col-sm-12 alert alert-danger text-align-center\">\n{{'route_sheet.no_data_found' | translate}}\n</span>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.importFileViewObj.pagination.total > 10 && !$ctrl.model.importFileViewObj.loading\">\n<ul uib-pagination total-items=\"$ctrl.model.importFileViewObj.pagination.total\" ng-hide=\"{{($ctrl.model.importFileViewObj.pagination.total<=$ctrl.model.importFileViewObj.pagination.pageLimit)&&($ctrl.model.importFileViewObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.importFileViewObj.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"$ctrl.model.currentStat === $ctrl.model.stats.evertecBatch\">\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.evertecBatchFileObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding table-margin-top-10 table-responsive\" ng-if=\"!$ctrl.model.evertecBatchFileObj.loading && $ctrl.model.evertecBatchFileObj.results.length\">\n<table class=\"table table-striped table-bordered table-pad-5\">\n<thead class=\"text-center\">\n<tr>\n<td class=\"contents-no-wrap\"><strong>{{'item.location' | translate}}</strong></td>\n<td class=\"contents-no-wrap\"><strong>{{'location.location' | translate}}</strong></td>\n<td class=\"contents-no-wrap\"><strong>{{'location._address' | translate}}</strong></td>\n<td class=\"contents-no-wrap\"><strong>{{'common.orderId' | translate}}</strong></td>\n<td class=\"contents-no-wrap\"><strong>{{'branch_mgmt.import_file_view.result' | translate}}</strong></td>\n<td><strong>{{'branch_mgmt.orders_error_msg' | translate}}</strong></td>\n<td class=\"contents-no-wrap\"> <strong>{{'branch_mgmt.import_file_view.total_bag_count' | translate}}</strong> </td>\n<td class=\"contents-no-wrap\"><strong>{{'setup.currency' | translate}}</strong></td>\n<td class=\"contents-no-wrap\"><strong>{{'branch_mgmt.import_file_view.departure_date' | translate}}</strong></td>\n<td class=\"contents-no-wrap\"><strong>{{'uploadedFileSelectionModal.arrivalDate' | translate}}</strong></td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in $ctrl.model.evertecBatchFileObj.results track by $index\">\n<td>{{data.locationId}}</td>\n<td>\n<span ng-if=\"data.locationName\">{{data.locationName}}</span>\n<span ng-if=\"!data.locationName\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"data.locationAddress\">{{data.locationAddress}}</span>\n<span ng-if=\"!data.locationAddress\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{data.orderId}}</td>\n<td ng-class=\"{'text-success': data.result == 'OK', 'text-danger': data.result == 'ERROR'}\">{{data.result}}</td>\n<td>\n<span ng-if=\"data.errorMessage\">{{data.errorMessage}}</span>\n<span ng-if=\"!data.errorMessage\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{data.totalBagCount}}</td>\n<td>{{data.totalCurrency | currency:\"$\":0}}</td>\n<td>{{$ctrl.formatDate(data.departureDate)}}</td>\n<td>{{$ctrl.formatDate(data.arrivalDate)}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 margin-10 remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.model.evertecBatchFileObj.loading && !$ctrl.model.evertecBatchFileObj.results.length\">\n<span class=\"col-sm-12 alert alert-danger text-align-center\">\n{{'route_sheet.no_data_found' | translate}}\n</span>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.evertecBatchFileObj.pagination.total > 10 && !$ctrl.model.evertecBatchFileObj.loading\">\n<ul uib-pagination total-items=\"$ctrl.model.evertecBatchFileObj.pagination.total\" ng-hide=\"{{($ctrl.model.evertecBatchFileObj.pagination.total<=$ctrl.model.evertecBatchFileObj.pagination.pageLimit)&&($ctrl.model.evertecBatchFileObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.evertecBatchFileObj.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n</div>\n</div>\n</form>";
var id1="import_file_view.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row_ margin-top-20\">\n<div class=\"col-sm-12 align-center-horizontally\">\n<div class=\"col-sm-7\">\n<input ng-change=\"$ctrl.search()\" type=\"text\" ng-model-options=\"{debounce: 1000}\" placeholder=\"{{ 'branch_mgmt.tracking_Id' | translate }}\" class=\"input-lg form-control\" ng-model=\"$ctrl.model.search\" search-autofocus>\n</div>\n</div>\n<div class=\"clearfix\">&nbsp;</div>\n<div class=\"row_ align-center-horizontally remove-pad\">\n<div class=\"form-group col-sm-3 remove-left-pad\">\n<search-and-select ng-model=\"$ctrl.model.toLocation\" values=\"$ctrl.toLocations\" key=\"Key\" totalrecords=\"$ctrl.totalToLocation\" on-click=\"$ctrl.search()\" onscroll=\"$ctrl.loadToLocation(searchKey, offset)\" none-selected=\"'bagout.toLocation'\" required></search-and-select>\n</div>\n<div class=\"form-group col-sm-3\">\n<search-and-select ng-model=\"$ctrl.model.fromLocation\" values=\"$ctrl.fromLocations\" key=\"Key\" totalrecords=\"$ctrl.totalFromLocation\" on-click=\"$ctrl.search()\" onscroll=\"$ctrl.loadFromLocation(searchKey, offset)\" none-selected=\"'bagout.fromLocation'\" required></search-and-select>\n</div>\n<div class=\"form-group col-sm-3\">\n<search-and-select ng-model=\"$ctrl.model.supId\" values=\"$ctrl.supervisors\" key=\"Key\" totalrecords=\"$ctrl.totalSupervisor\" on-click=\"$ctrl.search()\" onscroll=\"$ctrl.loadSupervisors(searchKey, offset)\" none-selected=\"'bypassCode.supervisorID'\" required></search-and-select>\n</div>\n<div class=\"form-group col-sm-3 remove-right-pad\">\n<select id=\"category\" class=\"form-control\" ng-model=\"$ctrl.model.status\" ng-options=\"status.value as status.lable for status in $ctrl.statusList\" ng-change=\"$ctrl.search()\">\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad item-hold-margin-top-20\">\n<div class=\"row_\">\n<div class=\"col-sm-6 remove-left-pad margin-bottom-10\">\n<span class=\"pull-left font-size-20\">\n{{'itemHolds.itemsOnHold' | translate}} | {{'itemHolds.asOf' | translate}} {{$ctrl.model.lastChecked}}\n</span>\n</div>\n<div class=\"col-sm-6 pull-right margin-bottom-10 unset-pad\">\n<div class=\"unset-pad\" ng-if=\"!$ctrl.model.loading && $ctrl.shipments.length\">\n<button class=\"btn btn-warning pull-right margin-left-10\" ng-click=\"$ctrl.exportData()\" ng-disabled=\"$ctrl.model.loading || $ctrl.isExporting\">\n{{'common.export' | translate}}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isExporting\"></span>\n</button>\n</div>\n<div class=\"unset-pad\" ng-if=\"!$ctrl.model.loading && !!$ctrl.model.hasUnverifiedShipments\">\n<button class=\"btn btn-warning pull-right margin-left-10\" ng-click=\"$ctrl.validateSupervisorScan()\" ng-disabled=\"$ctrl.isLoading\">\n{{'itemHolds.verifyHolds' | translate}}\n</button>\n</div>\n<div class=\"unset-pad\" ng-if=\"!$ctrl.model.loading && $ctrl.setupInfo.autoDeleteBagouts\">\n<button class=\"btn btn-warning pull-right\" ng-click=\"$ctrl.softDeleteBagouts()\" ng-disabled=\"$ctrl.isSoftDeleting\">\n{{'branch_mgmt.item_holds.soft_delete_bagouts' | translate}}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isSoftDeleting\"></span>\n</button>\n</div>\n<div class=\"unset-pad pull-right\" style=\"margin-top: 3px\" ng-if=\"$ctrl.shipments.length\">\n<input id=\"mapStatus\" bs-switch switch-size=\"small\" switch-on-text=\"{{'serviceTickets.show_map' | translate }}\" switch-off-text=\"{{'serviceTickets.hide_map' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.showMapView\" ng-change=\"$ctrl.toggleMapView()\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"item-hold-map-container\" ng-class=\"{'margin-10': $ctrl.canShowMap}\" ng-if=\"$ctrl.canShowMap\">\n<div id=\"hold-map\" class=\"border-radius-05 leaf-map remove-z-index\"></div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row_ col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.loading && $ctrl.shipments && $ctrl.shipments.length\">\n<div class=\"table-responsive\">\n<table class=\"table table-hover table-striped table-bordered table-pad-3 font-12\">\n<thead>\n<tr>\n<td class=\"td-vertical-align\" ng-click=\"$ctrl.sortData('trackingId')\">\n<b>{{'itemHolds.item' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'trackingId'}\"></span>\n</td>\n<td class=\"td-vertical-align\" ng-click=\"$ctrl.sortData('verifiedOn')\">\n<b>{{'itemHolds.status' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'verifiedOn'}\"></span>\n</td>\n<td class=\"td-vertical-align\" ng-click=\"$ctrl.sortData('toLocationId')\">\n<b>{{'itemHolds.to' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'toLocationId'}\"></span>\n</td>\n<td class=\"td-vertical-align\" ng-click=\"$ctrl.sortData('shiptypeId')\">\n<b>{{'message.type' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'shiptypeId'}\"></span>\n</td>\n<td class=\"td-vertical-align\" ng-click=\"$ctrl.sortData('routeId')\">\n<b>{{'itemHolds.route_id' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeId'}\"></span>\n</td>\n<td class=\"td-vertical-align\" ng-click=\"$ctrl.sortData('orderNo')\">\n<b>{{'itemHolds.orderNo' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'orderNo'}\"></span>\n</td>\n<td class=\"td-vertical-align tanker-width\" ng-click=\"$ctrl.sortData('tankerId')\">\n<b>{{'itemHolds.tanker' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'tankerId'}\"></span>\n</td>\n<td class=\"td-vertical-align\" ng-click=\"$ctrl.sortData('reason')\">\n<b>{{'itemHolds.reason' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'reason'}\"></span>\n</td>\n<td class=\"td-vertical-align\" ng-click=\"$ctrl.sortData('supvHoldId')\">\n<b>{{'itemHolds.supervisor' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'supvHoldId'}\"></span>\n</td>\n<td class=\"td-vertical-align hold-date-width\" ng-click=\"$ctrl.sortData('holdDate')\">\n<b>{{'itemHolds.holdDateTime' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'holdDate'}\"></span>\n</td>\n<td class=\"td-vertical-align\">\n<b>{{'itemHolds.actions' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in $ctrl.shipments\">\n<td class=\"remove-white-space td-vertical-align\">\n<a href=\"#\" uib-tooltip=\"{{shipment.fromLocation.id}}\" tooltip-placement=\"top-left\" ng-click=\"$ctrl.goToItemHistory(shipment.trackingId)\">{{shipment.trackingId}}\n</a>\n</td>\n<td ng-if=\"$ctrl.moment.utc(shipment.verifiedOn).format('YYYY-MM-DD') == $ctrl.currentVaultDate\" class=\"icon-position text-success td-vertical-align\">\n<span class=\"glyphicon glyphicon-ok icon-position\"></span>\n<br/>\n<span ng-if=\"$ctrl.moment.utc(shipment.verifiedOn).format('YYYY-MM-DD') == $ctrl.currentVaultDate\">({{'itemHolds.verified' | translate}}\n<br>\n<span class=\"remove-white-space\">{{$ctrl.moment.utc(shipment.verifiedOn).format('YYYY-MM-DD')}})</span>\n</span>\n</td>\n<td ng-if=\"!shipment.verifiedOn || $ctrl.moment.utc(shipment.verifiedOn).format('YYYY-MM-DD') != $ctrl.currentVaultDate\" class=\"icon-position text-danger td-vertical-align\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</td>\n<td class=\"td-vertical-align\">\n<span ng-if=\"shipment.shipmentToLocationId\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipment.toLocationId)\">\n<span class=\"cursor-pointer\" uib-tooltip=\"{{$ctrl.formatAddress(shipment)}}\" tooltip-placement=\"top-left\">\n{{shipment.toLocation.id}}\n</span>\n</a> | {{shipment.toLocation.name}}\n</span>\n<span ng-if=\"!shipment.shipmentToLocationId\">{{ 'common.n_a' | translate }}</span>\n</td>\n<td class=\"td-vertical-align\">\n<span>{{$ctrl.getOrderType(shipment.shiptypeId, shipment.orderType)}}</span>\n</td>\n<td class=\"td-vertical-align\">{{shipment.routeId}}</td>\n<td class=\"td-vertical-align\">\n<span>\n<a ng-if=\"shipment.orderNo\" href=\"#\" ng-click=\"$ctrl.redirectToOrderTab(shipment)\">\n{{$ctrl.removeLeadingZero(shipment.orderNo)}}</a>\n</span>\n<span ng-if=\"!shipment.orderNo\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"td-vertical-align\">\n<span ng-if=\"shipment.tankerId\">{{shipment.tankerId}}</span>\n<span ng-if=\"!shipment.tankerId\">{{ 'forceCloseHold.n_a' | translate}}</span>\n</td>\n<td class=\"td-vertical-align\">\n{{shipment.reason}}\n<div ng-if=\"!$ctrl.isNullorEmptyString(shipment.comments)\" class=\"glyphicon glyphicon-comment cursor-pointer\" uib-tooltip=\"{{shipment.comments}}\" tooltip-placement=\"top-right\">\n</div>\n</td>\n<td class=\"td-vertical-align\">{{ shipment.supvHoldId }}</td>\n<td class=\"td-vertical-align\">{{$ctrl.moment.utc(shipment.holdDate).format('YYYY-MM-DD | hh:mm A')}}</td>\n<td align=\"center\" class=\"td-vertical-align\">\n<div class=\"btn-group\" ng-if=\"shipment.onHold\">\n<div class=\"btn-group\" ng-if=\"(shipment.packedFlag) || (!shipment.packedFlag && shipment.deliveryDate)\">\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.releaseItem(shipment)\">\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"{{'branch_mgmt.item_release_holds.title' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</div>\n<div class=\"btn-group\" ng-if=\"!shipment.packedFlag && shipment.pickupFlag\">\n<button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"$ctrl.releasePickupShipment(shipment)\">\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"{{'branch_mgmt.item_release_holds.title' | translate}} ({{'branch_mgmt.items_pickupaction' | translate}})\" tooltip-placement=\"top-right\"></span>\n</button>\n</div>\n<div class=\"btn-group\" ng-if=\"$ctrl.canReleaseForCount(shipment)\">\n<button type=\"button\" class=\"btn btn-xs btn-info\" ng-click=\"$ctrl.releaseForCount(shipment)\">\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"Release for Count\" tooltip-placement=\"top-right\"></span>\n</button>\n</div>\n<div class=\"btn-group\" ng-if=\"!shipment.packedFlag && !shipment.checkedIn && !shipment.deliveryDate\">\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.markAsCheckedIn(shipment)\">\n<span class=\"glyphicon glyphicon-ok\" uib-tooltip=\"{{'itemHolds.mark_as_checked_in' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</div>\n<div class=\"btn-group\" ng-if=\"!shipment.deliveredFlag && shipment.packedFlag && shipment.deliveryDate && shipment.checkedOut\">\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.markAsDelivered(shipment)\">\n<span class=\"glyphicon glyphicon-ok\" uib-tooltip=\"{{'itemHolds.mark_as_delivered' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</div>\n<div class=\"btn-group\" ng-if=\"shipment.holdverifies.length > 0\">\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.showLogById(shipment)\">\n<span class=\"glyphicon glyphicon-list-alt\" uib-tooltip=\"{{'branch_mgmt.item_holds.log' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</div>\n<div class=\"btn-group\" ng-if=\"shipment.canConvertToCRV && shipment.toLocation.locationType === 'ATM' && !shipment.packableOrderShipmentId && !shipment.deliveredFlag\">\n<button type=\"button\" ng-click=\"$ctrl.convertToCrv(shipment)\" class=\"btn btn-xs btn-warning\" uib-tooltip=\"{{'itemHolds.converttocrv' | translate}}\" ng-disabled=\"$ctrl.isLoading\" tooltip-placement=\"top-right\">\nC </button>\n</div>\n<div class=\"btn-group\" ng-if=\"shipment.canConvertToCRV && shipment.packableOrderShipmentId && !shipment.deliveredFlag\">\n<button type=\"button\" ng-click=\"$ctrl.convertToCrvPackableOrder(shipment)\" class=\"btn btn-xs btn-warning\" uib-tooltip=\"{{'itemHolds.converttocrv' | translate}}\" ng-disabled=\"$ctrl.isLoading\" tooltip-placement=\"top-right\">\nC </button>\n</div>\n<div class=\"btn-group\" ng-if=\"!shipment.orderNo && !shipment.deliveredFlag && !shipment.checkedIn && $ctrl.convertToPickup\">\n<button type=\"button\" ng-click=\"$ctrl.convertShipmentHoldToPickup(shipment)\" class=\"btn btn-xs btn-warning\" uib-tooltip=\"{{'branch_mgmt.item_holds.convert_to_pickup' | translate}}\" ng-disabled=\"$ctrl.isLoading\" tooltip-placement=\"left\">\nP </button>\n</div>\n<div class=\"btn-group\" ng-if=\"(shipment.orderNo && shipment.denominationId) \n                                                           && (shipment.orderType !== 'P' && shipment.orderType !== 'T') && (shipment.packedFlag)\">\n<button type=\"button\" class=\"btn btn-xs btn-warning remove-pad\" ng-click=\"$ctrl.orderPackingUndo(shipment)\" ng-class=\"{'disabled': ($ctrl.loading)}\" ng-disabled=\"!$ctrl.isAllowedToUnpack(shipment)\">\n<img src=\"" + __webpack_require__(119) + "\" class=\"undo-icon-height-20\" uib-tooltip=\"{{'orderPacking.unpack_order' | translate}}\" tooltip-placement=\"top-right\">\n</button>\n</div>\n<div class=\"btn-group\" ng-if=\"(((shipment.orderNo && shipment.denominationId && !shipment.packedFlag) && ((shipment.orderType === 'P' || shipment.orderType === 'T') || (!shipment.packedFlag && shipment.deliveryDate))) ||\n                                           (shipment.pickupFlag && !shipment.orderNo) || \n                                           (shipment.checkedOut && !shipment.deliveredFlag && !shipment.orderNo) ||\n                                           (!shipment.orderNo && !shipment.deliveredFlag && shipment.batchId)) && $ctrl.hasSoftDeleteShipmentPermission\">\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.removeShipment(shipment)\">\n<span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"{{'common.soft_delete' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-pad item-hold-pagination-margin-bottom\">\n<ul uib-pagination total-items=\"$ctrl.pagination.total\" ng-hide=\"{{($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.loading && (!$ctrl.shipments || !$ctrl.shipments.length)\" class=\"col-sm-12 margin-top-40 remove-pad\">\n<div class=\"col-sm-12 alert alert-danger text-align-center\">\n{{'itemHolds.noShipmentHeld' | translate}}\n</div>\n</div>\n</div>\n</div>\n";
var id1="item_holds.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2686 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"form-row d-flex-end hide-in-print\">\n<div class=\"text-input-section\">\n<div class=\"item-status-tracking-id-search\">\n<input ng-keydown=\"$event.keyCode === 13 && $ctrl.loadData();\n            $event.keyCode === 13 && $ctrl.replaceURL()\" placeholder=\"{{ 'branch_mgmt.tracking_Id' | translate }}\" type=\"text\" ng-model=\"$ctrl.model.search\" class=\"w-70 input-lg form-control\" capitalize search-autofocus>\n</div>\n</div>\n<div class=\"item-status-timezone-dd-section margin-top-5\">\n<div class=\"btn-div\">\n<select class=\"form-control\" required ng-model=\"$ctrl.model.timezone\" ng-options=\"timezone.value as timezone.label for timezone in $ctrl.model.timezoneList\" ng-disabled=\"(!$ctrl.itemStatus.length && !$ctrl.shipments.length)\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"remove-left-pad col-lg-12 col-sm-12\">\n<div class=\"show-only-in-print\">\n<div class=\"col-lg-12 col-sm-12 margin-bottom-20\">\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<span class=\"font-size-20 font-19 margin-top-20\">\n<strong>{{'branch_mgmt.item_itemHistory' | translate}}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.DateUtil.convertDateTime($ctrl.getLocalTime(), $ctrl.model.timezone, 'MM/DD/YY hh:mm a')}}</span>\n</span>\n<span class=\"font-size-20 pull-right\">\n<strong>\n{{ 'branch_mgmt.itemHistory.trackingId' | translate }}\n</strong>\n<span>\n: {{$ctrl.lastScanned}}\n</span>\n</span>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.message\" class=\"col-sm-12 remove-pad\">\n<div class=\"align-center-horizontally hide-in-print\" ng-if=\"$ctrl.model.errorMsg && $ctrl.model.noItemDisplay && !$ctrl.model.loading\">\n<div class=\"alert errLblPos col-sm-12\" ng-class=\"{'alert-danger': $ctrl.model.noItemDisplay}\" style=\"text-align: center; width:100%\">\n<span>{{$ctrl.model.errorMsg}}</span>\n</div>\n</div>\n</div>\n<div class=\"margin-10 w-100 hide-in-print\" ng-if=\"!$ctrl.model.loading && $ctrl.itemStatus && $ctrl.itemStatus.length\">\n<div class=\"remove-pad col-sm-12 pull-left remove-left-pad\" style=\"margin-bottom: 10px !important;\">\n<div class=\"pull-left font-size-20\">\n<strong>{{'branch_mgmt.item_shipmentStatus' | translate}}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.DateUtil.convertDateTime($ctrl.getLocalTime(), $ctrl.model.timezone, 'MM/DD/YY hh:mm a')}}</span>\n</div>\n</div>\n<hr class=\"col-sm-12 remove-pad m-0\" ng-if=\"!$ctrl.isShipmentCounted()\" style=\"margin-top: 5px; margin-bottom: 10px; border-top: 1px solid #ddd;\">\n<div class=\"col-sm-12 right-btn-section_ remove-right-pad remove-left-pad margin-top-10 margin-bottom-10\" ng-if=\"!$ctrl.isShipmentCounted()\">\n<div ng-if=\"!$ctrl.shipmentData.coinFlag\">\n<div ng-if=\"((($ctrl.shipmentData.orderNo && $ctrl.shipmentData.denominationId && !$ctrl.shipmentData.packedFlag) && (($ctrl.shipmentData.orderType === 'P' || $ctrl.shipmentData.orderType === 'T') ||\n                   (!$ctrl.shipmentData.packedFlag && $ctrl.shipmentData.deliveryDate)))\n                   || ($ctrl.shipmentData.pickupFlag && !$ctrl.shipmentData.isRequiredPickup && !$ctrl.shipmentData.orderNo)\n                   || ($ctrl.shipmentData.checkedOut && !$ctrl.shipmentData.isDelivered && !$ctrl.shipmentData.orderNo && $ctrl.shipmentData.isOnHold)) && $ctrl.hasSoftDeleteShipmentPermission\">\n<button type=\"button\" class=\"btn item-history-btn-section btn-danger btn-mob-small mr-1\" ng-click=\"$ctrl.softDeleteShipment($ctrl.shipmentData)\" ng-disabled=\"($ctrl.shipmentData.translatedStatus === 'Deleted') || ($ctrl.shipmentData.packedDate && $ctrl.shipmentData.orderNo) || ($ctrl.loading)\">\n<span class=\"glyphicon glyphicon-trash\"></span> {{'common.Delete' | translate}}\n</button>\n</div>\n</div>\n<div ng-if=\"$ctrl.hasSoftDeleteShipmentPermission && !$ctrl.shipmentData.coinFlag && $ctrl.shipmentData.pickupFlag && $ctrl.shipmentData.isRequiredPickup\">\n<button type=\"button\" class=\"btn item-history-btn-section btn-danger btn-mob-small mr-1\" ng-click=\"$ctrl.softDeleteShipment($ctrl.shipmentData)\" ng-disabled=\"$ctrl.loading || ($ctrl.shipmentData.translatedStatus === 'Deleted')\">\n<span class=\"glyphicon glyphicon-trash\"></span> {{'common.Delete' | translate}}\n</button>\n</div>\n<div ng-if=\"$ctrl.hasSoftDeleteShipmentPermission && $ctrl.shipmentData.coinFlag && $ctrl.shipmentData.orderNo && ((!$ctrl.shipmentData.coinDebited && $ctrl.shipmentData.checkedOut) || (!$ctrl.shipmentData.coinDebited && $ctrl.shipmentData.checkedIn ))\">\n<button type=\"button\" class=\"btn item-history-btn-section btn-danger btn-mob-small mr-1\" ng-click=\"$ctrl.softDeleteShipment($ctrl.shipmentData)\" ng-disabled=\"$ctrl.loading || ($ctrl.shipmentData.translatedStatus === 'Deleted')\">\n<span class=\"glyphicon glyphicon-trash\"></span> {{'common.Delete' | translate}}\n</button>\n</div>\n<div ng-if=\"!$ctrl.model.isSentToHold && \n                    !$ctrl.shipmentData.isOnHold &&\n                    !$ctrl.shipmentData.isDeleted &&\n                    !$ctrl.shipmentData.isLoadShpDelivered && \n                    !$ctrl.shipmentData.isResidualShpCheckedIn && \n                    !$ctrl.shipmentData.isDelivered && \n                    !$ctrl.isLoadShipmentCheckedOut && \n                    !$ctrl.shipmentData.bagSeal &&\n                    !($ctrl.shipmentData.status === 'shipment.onRoute' && !$ctrl.shipmentData.bagSeal && !$ctrl.shipmentData.isRequiredPickup && !$ctrl.shipmentData.isParentDelivery && $ctrl.shipmentData.orderNo) && \n                    !$ctrl.customerId\">\n<button type=\"button\" class=\"btn item-history-btn-section btn-warning btn-mob-small mr-1\" ng-if=\"$ctrl.hasBranchMgmtItemsEditPermission\" ng-click=\"$ctrl.sendToHold()\">\n{{ 'branch_mgmt.itemHistory.sendToHold' | translate }}\n</button>\n</div>\n<div ng-if=\"!$ctrl.shipmentData.isDelivered && $ctrl.shipmentData.packedFlag && $ctrl.shipmentData.deliveryDate && $ctrl.hasBranchMgmtItemsEditPermission\">\n<button type=\"button\" class=\"btn item-history-btn-section btn-success btn-mob-small mr-1\" ng-click=\"$ctrl.markAsDelivered($ctrl.shipmentData)\" ng-disabled=\"$ctrl.shipmentData.isDeleted || !$ctrl.shipmentData.checkedOut || $ctrl.loading\">\n<span class=\"glyphicon glyphicon-ok\"></span> {{'itemHolds.mark_as_delivered' | translate}}\n</button>\n</div>\n<div ng-if=\"($ctrl.model.isSentToHold || $ctrl.shipmentData.isOnHold) && ($ctrl.shipmentData.packedFlag) ||\n                (!$ctrl.shipmentData.packedFlag && $ctrl.shipmentData.deliveryDate)\">\n<button type=\"button\" class=\"btn item-history-btn-section btn-success btn-mob-small mr-1\" ng-click=\"$ctrl.releaseItem()\" ng-disabled=\"$ctrl.shipmentData.isDeleted\">\n<span class=\"glyphicon glyphicon-repeat\"></span> {{ 'itemHolds.releaseItem' | translate }}\n</button>\n</div>\n<div ng-if=\"!$ctrl.shipmentData.packedFlag && !$ctrl.shipmentData.shipmentCheckedIn && !$ctrl.shipmentData.deliveryDate \n                && $ctrl.shipmentData.isOnHold\">\n<button type=\"button\" class=\"btn item-history-btn-section btn-success btn-mob-small mr-1\" ng-click=\"$ctrl.markAsCheckedIn($ctrl.shipmentData)\" ng-disabled=\"$ctrl.shipmentData.isDeleted\">\n<span class=\"glyphicon glyphicon-ok\"></span> {{'itemHolds.mark_as_checked_in' | translate}}\n</button>\n</div>\n<div ng-if=\"(($ctrl.shipmentData.shipmentCheckedIn || $ctrl.shipmentData.pending || $ctrl.shipmentData.isOnHold) && !$ctrl.shipmentData.orderNo)\n                    || \n                    (\n                        $ctrl.shipmentData.isPackableOrder && !$ctrl.shipmentData.isDelivered &&\n                    ((\n                        $ctrl.shipmentData.totalCODCoinsOnRoute == 0\n                    )\n                    ||\n                    (\n                        $ctrl.shipmentData.totalCODCoinsOnRoute > 0 &&\n                        (\n                            (\n                                $ctrl.shipmentData.isCoinDebited == 1 &&\n                                (\n                                    $ctrl.shipmentData.isBulkInventoryOn == 1 ||\n                                    $ctrl.shipmentData.isDebitBulkCoinOnPack == 1\n                                )\n                            )\n                            ||\n                            (\n                                $ctrl.shipmentData.isBulkInventoryOn == 0 &&\n                                $ctrl.shipmentData.isDebitBulkCoinOnPack == 0\n                            )\n                        )\n                    ))\n                    )\">\n<button type=\"button\" class=\"btn item-history-btn-section btn-primary btn-mob-small mr-1\" ng-click=\"$ctrl.branchTransfer()\">\n{{ 'branch_mgmt.itemHistory.branch_transfer' | translate }}\n</button>\n</div>\n<div ng-if=\"($ctrl.shipmentData.shipmentCheckedIn || $ctrl.shipmentData.pending) && !$ctrl.shipmentData.orderNo && \n                              $ctrl.allowInternalDelivery($ctrl.shipmentData.fromLocationType);\">\n<button type=\"button\" class=\"btn item-history-btn-section btn-success btn-mob-small mr-1\" ng-click=\"$ctrl.internalDelivery()\" ng-disabled=\"$ctrl.shipmentData.orderNo\">\n{{ 'branch_mgmt.edit_from' | translate }}\n</button>\n</div>\n<div>\n<button type=\"button\" class=\"btn btn-success item-history-btn-section btn-mob-small mr-1\" ng-click=\"$ctrl.updateTrackingId()\" ng-if=\"$ctrl.hasBranchMgmtItemsEditPermission\" ng-disabled=\"($ctrl.shipmentData.isDeleted) || ($ctrl.isLoadShipmentCheckedOut || ($ctrl.isResidualshipmentCheckedIn && $ctrl.depositedAt))\">\n{{ 'branch_mgmt.items.editTrackingId' | translate }}\n</button>\n</div>\n<div ng-if=\"$ctrl.shipmentData.canConvertToCRV\">\n<button type=\"button\" class=\"btn item-history-btn-section btn-warning btn-mob-small mr-1\" ng-click=\"$ctrl.convertShipmentToCrv()\" ng-disabled=\"$ctrl.loading\">\n{{ 'itemHolds.converttocrv' | translate }}\n</button>\n</div>\n<div ng-if=\"(['shipment.counted', 'shipment.deleted', 'shipment.deleted', 'shipment.delivered', 'shipment.checkedIn'].indexOf($ctrl.shipmentData.status) === -1)\">\n<button type=\"button\" class=\"btn btn-success item-history-btn-section btn-mob-small mr-1\" ng-if=\"$ctrl.hasBranchMgmtItemsEditPermission\" ng-click=\"$ctrl.changeShiptype()\">\n{{ 'branch_mgmt.items.changeShipType' | translate }}\n</button>\n</div>\n<div ng-if=\"$ctrl.shipmentData.pickupFlag && !$ctrl.shipmentData.orderNo && !$ctrl.shipmentData.bagSeal || $ctrl.shipmentData.status === 'shipment.hold'\">\n<button type=\"button\" class=\"btn btn-success item-history-btn-section btn-mob-small mr-1\" ng-click=\"$ctrl.changeDestination()\" ng-disabled=\"$ctrl.shipmentData.isDeleted\" ng-if=\"$ctrl.hasBranchMgmtItemsEditPermission\" ng-class=\"{'disabled': ($ctrl.validateShpDestination)}\">\n{{'shipment.change_destination' | translate}}\n</button>\n</div>\n<div ng-if=\"$ctrl.shipmentData.pickupFlag && $ctrl.shipmentData.shipmentCheckedIn && !$ctrl.shipmentData.bagSeal && !$ctrl.shipmentData.countStartedAt\">\n<button type=\"button\" class=\"btn item-history-btn-section btn-success btn-mob-small mr-1\" ng-click=\"$ctrl.makeDeliverable()\">\n{{'branch_mgmt.make_deliverable' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad items-err-lbl-margin-top\" ng-if=\"$ctrl.msg\">\n<div class=\"alert alert-success text-align-center remove-bottom-margin\">\n{{$ctrl.msg}}\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-if=\"$ctrl.shipmentDeliveredMsg\">\n<div class=\"margin-10 remove-bottom-margin alert alert-success text-align-center\">\n{{$ctrl.shipmentDeliveredMsg}}\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-if=\"$ctrl.updateTrackingIdMsg\">\n<div class=\"margin-10 remove-bottom-margin alert alert-success text-align-center\">\n{{$ctrl.updateTrackingIdMsg}}\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding margin-05 table-responsive\">\n<table class=\"table table-hover table-bordered table-pad-7 font-12\">\n<thead>\n<tr>\n<td>\n<b>{{ 'branch_mgmt.item_holds.vaultDate' | translate }}</b>\n</td>\n<td>\n<b>{{ 'routeSheet.date' | translate }}</b>\n</td>\n<td>\n<b>{{'message.type' | translate}}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.item_orderNo' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.item_from.title' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.item_to.title' | translate }}</b>\n</td>\n<td>\n<b>{{ 'routeSheet.route' | translate }}</b>\n</td>\n<td>\n<b>{{ 'checkin.amount' | translate }}</b>\n</td>\n<td>\n<b>{{'master_cash_schedule.denoms' | translate}}</b>\n</td>\n<td>\n<b>{{'branch_mgmt.item_status' | translate}}</b>\n</td>\n<td ng-if=\"$ctrl.shipmentData.receivedByName\">\n<b>{{'branch_mgmt.received_by' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.itemStatus\">\n<td class=\"wd-09\">\n<a href=\"\" ng-click=\"$ctrl.goToDVB(data)\">{{data.vaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</a>\n</td>\n<td class=\"wd-09\">\n{{$ctrl.DateUtil.convertDateTime(data.updatedAt, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}\n</td>\n<td>\n<span>{{$ctrl.getOrderType(data.shiptypeId, data.orderType)}}</span>\n</td>\n<td>{{data.orderNo ? data.orderNo : 'N/A'}}</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory($event,data.fromLocationId, { param: 'value'})\">{{data.fromLocationId}}\n</a> | {{data.fromLocationName}}\n</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory($event, data.toLocationId, { param: 'value'})\">{{data.toLocationId}}\n</a> | {{data.toLocationName}}\n</td>\n<td><a href=\"#\" ng-click=\"$ctrl.goToRouteTab($event, data, { param: 'value'})\">{{data.routeId}}</a> | {{data.routeName}}</td>\n<td>\n<span ng-if=\"data.toLocationType === 'ATM' && data.loadedAmount != null\">{{ data.amountFlag ? (data.loadedAmount | currency) : (data.qty != null ? data.qty : 'N/A') }}</span>\n<span ng-if=\"data.toLocationType === 'ATM' && data.loadedAmount == null\">{{ data.amountFlag ? (data.amount | currency) : (data.qty != null ? data.qty : 'N/A') }}</span>\n<span ng-if=\"data.toLocationType !== 'ATM'\"> {{ data.amountFlag ? (data.amount | currency) : (data.qty != null ? data.qty : 'N/A') }}</span>\n</td>\n<td>\n<div class=\"d-flex\">\n<div ng-repeat=\"denom in data.denomArr track by $index\">\n<img ng-if=\"data.denomArr.length\" ng-src=\"assets/images/{{denom}}.png\" class=\"denom-image\" alt=\"{{ denom }}\" style=\"width:30px\"/>\n</div>\n<span ng-if=\"!data.denomArr.length\">{{ 'branch_mgmt.itemHistory.n_a' | translate }}</span>\n</div>\n</td>\n<td ng-class=\"{'text-danger': data.status}\">\n<div class=\"d-flex\">\n<span ng-if=\"data.status !== 'shipment.hold'\">\n{{$ctrl.translateItemStatus(data.status, data.orderNo, data.denominationId)}}\n<div ng-if=\"data.countCompletedAt\">({{(data.countedVaultDate || data.vaultDate) | date: 'yyyy-MM-dd' : 'UTC'}})</div>\n</span>\n<span ng-if=\"data.status === 'shipment.hold'\">\n<a href=\"#\" ng-click=\"$ctrl.itemHold(data.trackingId)\">{{'shipment.hold' | translate}}</a>\n</span>\n<button type=\"button\" class=\"btn btn-xs btn-success btn-icon btn-cst-height-22 denom-btn\" ng-if=\"data.status === 'shipment.counted'\" ng-click=\"$ctrl.redirectToATM(data)\">\n<span class=\"glyphicon glyphicon-arrow-right\"></span>\n</button>\n<span ng-if=\"data.status === 'shipment.bagout'\">&nbsp;({{data.bagSeal}})</span>\n<span ng-if=\"data.status === 'shipment.inRouteTanker'\">({{data.tankerId}})</span>\n<span ng-if=\"!data.status\">{{'common.n_a' | translate}}</span>\n</div>\n</td>\n<td ng-if=\"$ctrl.shipmentData.receivedByName\"><b>{{$ctrl.shipmentData.receivedByName}}</b></td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-if=\"$ctrl.branchTransferMsg\">\n<div class=\"alert alert-success text-align-center\">\n{{$ctrl.branchTransferMsg}}\n</div>\n</div>\n<div class=\"item-transaction\" ng-if=\"!$ctrl.model.loading && $ctrl.shipments && $ctrl.shipments.length\">\n<div class=\"col-sm-12 remove-right-pad item-transaction-align-center\">\n<div class=\"pull-left font-size-20 row hide-in-print font-15\">\n<strong>{{'branch_mgmt.item_itemHistory' | translate}}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.DateUtil.convertDateTime($ctrl.getLocalTime(), $ctrl.model.timezone, 'MM/DD/YY hh:mm a')}}</span>\n</div>\n<div class=\"hide-in-print col-sm-6 remove-right-pad\">\n<div class=\"pull-right\">\n<button class=\"btn btn-success\" ng-click=\"$ctrl.print()\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{ 'branch_mgmt.itemHistory.print' | translate }}\n</button>\n</div>\n<div class=\"pull-right right-pad-10\" ng-if=\"$ctrl.depositRecord && $ctrl.depositRecord.isVariance\">\n<select class=\"form-control\" ng-model=\"$ctrl.selectedDepositAmountValue\">\n<option value=\"totalAmount\">Counted Value</option>\n<option value=\"statedTotalAmount\">Stated Value</option>\n<option value=\"declaredTotalAmount\">Declared Value</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"_table-responsive col-sm-12 remove-right-padding remove-left-pad margin-top-5\">\n<table class=\"table table-hover table-bordered table-pad-7 font-12\">\n<thead class=\"no-wrap-table-header\">\n<tr>\n<td>\n<b>{{ 'branch_mgmt.item_holds.vaultDate' | translate }}</b>\n</td>\n<td>\n<b>{{ 'routeSheet.date' | translate }}</b>\n</td>\n<td>\n<b>{{ 'shipmentBatch.action' | translate}}</b>\n</td>\n<td>\n<b>{{'branch_mgmt.item_amount' | translate}}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.item_from.title' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.item_to.title' | translate }}</b>\n</td>\n<td>\n<b>{{ 'routeSheet.route' | translate }}</b>\n</td>\n<td>\n<b>{{ 'addBagModal.bagSeal' | translate }}</b>\n</td>\n<td>\n<b>{{'branch_mgmt.itemHistoryPrId' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.itemHistoryComment' | translate }}</b>\n</td>\n<td class=\"hide-in-print\">\n<b>{{ 'common.action' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in $ctrl.shipments\">\n<td class=\"wd-09\">{{shipment.transactionVaultDate | date: 'yyyy-MM-dd' : 'UTC'}}</td>\n<td class=\"wd-09\">\n{{$ctrl.DateUtil.convertDateTime(shipment.transactionDate, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}\n</td>\n<td ng-if=\"shipment.tranType\" ng-class=\"{'text-danger': shipment.tranType}\" class=\"text-center\">\n<span>{{$ctrl.translateTranType(shipment.tranType)}}</span>\n</td>\n<td>\n<span ng-if=\"!['DEPOSIT_COUNT', 'BULKCASH'].includes(shipment.tranType) || !$ctrl.depositRecord || !$ctrl.depositRecord.isVariance\">\n{{ shipment.amount | currency:\"$\" }}\n</span>\n<span ng-if=\"['DEPOSIT_COUNT', 'BULKCASH'].includes(shipment.tranType) && $ctrl.depositRecord && $ctrl.depositRecord.isVariance\">\n{{ $ctrl.depositRecord[$ctrl.selectedDepositAmountValue] | currency:\"$\" }}\n</span>\n<span ng-if=\"$ctrl.depositRecord && $ctrl.depositRecord.isVariance && ['DEPOSIT_COUNT', 'BULKCASH'].includes(shipment.tranType)\">\n<button class=\"glyphicon glyphicon-info-sign glyphicon-button hide-in-print\" popover-trigger=\"'mouseenter'\" uib-popover-html=\"$ctrl.depositPopover\" popover-placement=\"top\">\n</button>\n</span>\n</td>\n<td>{{shipment.fromLocation}}</td>\n<td>{{shipment.toLocation}}</td>\n<td>{{shipment.route}}</td>\n<td ng-if=\"shipment.bagSeal\">{{shipment.bagSeal}}</td>\n<td ng-if=\"!shipment.bagSeal\">{{ 'branch_mgmt.itemHistory.n_a' | translate }}</td>\n<td ng-if=\"shipment.performedBy\">{{shipment.performedBy}}</td>\n<td ng-if=\"!shipment.performedBy\">{{'common.n_a' | translate}}</td>\n<td>{{shipment.comments}}\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad hide-in-print\" ng-click=\"$ctrl.showReceipt(shipment, 'pickup')\" ng-if=\"(shipment.tranType === 'RESIDUAL' || shipment.tranType === 'PICKUP') && shipment.pickupImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad hide-in-print\" ng-click=\"$ctrl.showReceipt(shipment, 'delivery')\" ng-if=\"(shipment.tranType === 'LOAD' || shipment.tranType === 'DELIVERY' || (shipment.tranType === 'BAGOUT' && $ctrl.shipmentData.isBagoutDelivered)) && (shipment.deliveryImageName || $ctrl.shipmentData.bagoutDeliveryImageName)\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</td>\n<td class=\"remove-white-space text-center hide-in-print\">\n<div ng-if=\"shipment.tranType === 'PICKUP' || shipment.tranType === 'DELIVERY' || (shipment.tranType === 'BAGOUT' && $ctrl.shipmentData.isBagoutDelivered)\">\n<button type=\"button\" class=\"btn btn-success btn-xs\" uib-tooltip=\"{{'branch_mgmt.itemHistory.print' | translate}}\" tooltip-placement=\"top-right\" ng-click=\"$ctrl.printShipment(shipment, shipment.tranType)\" ng-disabled=\"$ctrl.model.isPrint\">\n<span class=\"glyphicon glyphicon-print\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-success btn-xs\" uib-tooltip=\"{{'location.resend_receipt' | translate}}\" tooltip-placement=\"top-right\" ng-click=\"$ctrl.sendDeliveryOrPickupReceipt((shipment.tranType === 'DELIVERY' || shipment.tranType === 'BAGOUT') ? 'delivery': 'pickup')\">\n<span class=\"glyphicon glyphicon-share-alt\"></span>\n</button>\n</div>\n<div ng-if=\"shipment.tranType !== 'PICKUP' && shipment.tranType !== 'DELIVERY' && !(shipment.tranType === 'BAGOUT' && $ctrl.shipmentData.isBagoutDelivered)\">{{'common.n_a' | translate}}</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"row hide-in-print col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.pagination.total > 10\">\n<ul uib-pagination total-items=\"$ctrl.pagination.total\" ng-hide=\"{{($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 align-center-horizontally row hide-in-print\" ng-if=\"$ctrl.model.message && $ctrl.model.isError\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.isError}\" style=\"text-align: center; width:100%\">\n<span>{{$ctrl.model.message}}</span>\n</div>\n</div>\n";
var id1="items.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2687 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"print-stop-receipt-section col-sm-12 margin-10 print-margin-top-10\">\n<table class=\"table remove-bottom-margin\" cellpadding=\"20\" cellspacing=\"2\">\n<thead>\n<tr>\n<td class=\"remove-left-pad bg-color\" valign=\"middle\">\n<div class=\"remove-left-pad header col-sm-12\" valign=\"middle\">\n<div class=\"logo\">\n<img stream-company-logo class=\"img-responsive\" width=\"200\">\n</div>\n</div></td>\n<td class=\"bg-color right-receipt-section\" valign=\"middle\" align=\"right\">\n<span class=\"text-bold\">{{$ctrl.model.item.results[0].vaultDate | date: 'MM/dd/yyyy'}} | {{'item.stop_receipt' | translate}}</span>\n</td>\n</tr>\n</thead>\n</table>\n<table class=\"table _table-hover table-bordered\" cellpadding=\"20\" cellspacing=\"2\">\n<div class=\"col-sm-12\">\n<tr class=\"table-row-height\">\n<td>{{'item.delivery_stop' | translate}}</td>\n<td ng-if=\"$ctrl.model.item.shipmentRecords.tranType==='DELIVERY' || $ctrl.model.item.shipmentRecords.tranType==='BAGOUT'\">\n<span>{{$ctrl.model.item.results[0].toLocation}}</span>\n</td>\n<td ng-if=\"$ctrl.model.item.shipmentRecords.tranType==='PICKUP'\">\n<span>{{$ctrl.model.item.results[0].fromLocation}}</span>\n</td>\n</tr>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.item.results[0].customerName\">\n<tr class=\"table-row-height\">\n<td>{{'item.customerName' | translate}}</td>\n<td>\n<span>{{$ctrl.model.item.results[0].customerName}}</span>\n</td>\n</tr>\n</div>\n<div class=\"col-sm-12\">\n<tr class=\"table-row-height\">\n<td>\n{{'location.deliveries' | translate}} ({{$ctrl.model.item.totalDeliveries}})</td>\n<td ng-if=\"$ctrl.model.item.shipmentRecords.tranType==='DELIVERY' || $ctrl.model.item.shipmentRecords.tranType==='BAGOUT'\">\n<span>{{$ctrl.model.item.results[0].trackingId}} | {{$ctrl.model.item.results[0].shiptype}} | {{$ctrl.formatAmount($ctrl.model.item.results[0].amount)}} | (<b>From:</b> {{$ctrl.model.item.results[0].fromLocation}}, <b>To:</b> {{$ctrl.model.item.results[0].toLocation}})</span>\n</td>\n</tr>\n</div>\n<div class=\"col-sm-12\">\n<tr class=\"table-row-height\">\n<td>{{'item.deliver_signature' | translate}}</td>\n<td>\n<img ng-if=\"$ctrl.model.item.results[0].deliveryImageName && $ctrl.model.item.totalDeliveries > 0\" ng-src=\"{{$ctrl.model.item.results[0].deliveryImageName}}\" width=\"120\">\n<span ng-if=\"!$ctrl.model.item.results[0].deliveryImageName && $ctrl.model.item.totalDeliveries > 0\"><i>Not available</i></span>\n</td>\n</tr>\n</div>\n<div class=\"col-sm-12\">\n<tr class=\"table-row-height\">\n<td>\n{{'branch_mgmt.items_pickupaction' | translate}} ({{$ctrl.model.item.totalPickups}})</td>\n<td ng-if=\"$ctrl.model.item.shipmentRecords.tranType==='PICKUP'\">\n<span>{{$ctrl.model.item.results[0].trackingId}} | {{$ctrl.model.item.results[0].shiptype}} | {{$ctrl.formatAmount($ctrl.model.item.results[0].amount)}} | (<b>From:</b> {{$ctrl.model.item.results[0].fromLocation}}, <b>To:</b> {{$ctrl.model.item.results[0].toLocation}})</span>\n</td>\n</tr>\n</div>\n<div class=\"col-sm-12\">\n<tr class=\"table-row-height\">\n<td>{{'item.pickup_signature' | translate}}</td>\n<td>\n<img ng-if=\"$ctrl.model.item.results[0].pickupImageName && $ctrl.model.item.totalPickups > 0\" ng-src=\"{{$ctrl.model.item.results[0].pickupImageName}}\" width=\"120\">\n<span ng-if=\"!$ctrl.model.item.results[0].pickupImageName && $ctrl.model.item.totalPickups > 0\"><i>Not available</i></span>\n</td>\n</tr>\n</div>\n<div class=\"col-sm-12\">\n<tr class=\"table-row-height\">\n<td>{{'bagout.route' | translate}}</td>\n<td>{{$ctrl.model.item.results[0].route}}</td>\n</tr>\n</div>\n<div class=\"col-sm-12\">\n<tr class=\"table-row-height\">\n<td>{{'branch_mgmt.route_messenger' | translate}}</td>\n<td>{{$ctrl.model.item.shipmentRecords.performedBy || $ctrl.model.item.results[0].messengerId}}</td>\n</tr>\n</div>\n<div class=\"col-sm-12\">\n<tr style=\"height: 5rem\">\n<td>{{'item.stop_date_time' | translate}}</td>\n<td><span class=\"text-bold\">{{$ctrl.model.item.stopDateTime}}</span></td>\n</tr>\n</div>\n</table>\n<div class=\"note-section\">\n<p class=\"text-justify font-12\">\n<b>{{'item.confidentiality_note' | translate}}:</b>\n</p><div class=\"col-sm-12\" ng-if=\"$ctrl.model.item.envConfigResults[0].assets.footerText\">\n<span>{{$ctrl.model.item.envConfigResults[0].assets.footerText}}</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyAddress && \n                                $ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber && \n                                $ctrl.model.item.envConfigResults[0].assets.companyEmail\">\nif you have received this transmission in error, please notify us by telephone at {{$ctrl.model.companyPhoneNumber}} or notify us at: {{$ctrl.model.item.envConfigResults[0].assets.companyAddress}} or {{$ctrl.model.item.envConfigResults[0].assets.companyEmail}}.\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber && \n                                $ctrl.model.item.envConfigResults[0].assets.companyEmail &&\n                                !$ctrl.model.item.envConfigResults[0].assets.companyAddress\">\nif you have received this transmission in error, please notify us by telephone at {{$ctrl.model.companyPhoneNumber}} or notify us at: {{$ctrl.model.item.envConfigResults[0].assets.companyEmail}}\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber &&\n                                $ctrl.model.item.envConfigResults[0].assets.companyAddress &&\n                                !$ctrl.model.item.envConfigResults[0].assets.companyEmail\">\nif you have received this transmission in error, please notify us by telephone at {{$ctrl.model.companyPhoneNumber}} or notify us at: {{$ctrl.model.item.envConfigResults[0].assets.companyAddress}}.\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyAddress && \n                                $ctrl.model.item.envConfigResults[0].assets.companyEmail &&\n                                !$ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber\">\nif you have received this transmission in error, please notify us at {{$ctrl.model.item.envConfigResults[0].assets.companyAddress}} or {{$ctrl.model.item.envConfigResults[0].assets.companyEmail}}.\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber &&\n                            !$ctrl.model.item.envConfigResults[0].assets.companyAddress &&\n                            !$ctrl.model.item.envConfigResults[0].assets.companyEmail\">\nif you have received this transmission in error, please notify us by telephone at {{$ctrl.model.companyPhoneNumber}}.\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyEmail && \n                            !$ctrl.model.item.envConfigResults[0].assets.companyAddress &&\n                            !$ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber\">\nif you have received this transmission in error, please notify us at {{$ctrl.model.item.envConfigResults[0].assets.companyEmail}}.\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyAddress && \n                            !$ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber &&\n                            !$ctrl.model.item.envConfigResults[0].assets.companyEmail\">\nif you have received this transmission in error, please notify us at {{$ctrl.model.item.envConfigResults[0].assets.companyAddress}}\n</span>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!$ctrl.model.item.envConfigResults[0].assets.footerText\">\n<span>\nThis message is intended only for the use of the individual or entity to whom it is addressed and may contain information that is privileged, confidential, and exempt from disclosure under applicable law. if the reader of this message is not the intended recipient, you are hereby notified that any dissemination, distribution or copying of this communication is strictly prohibited.\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyAddress && \n                    $ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber && \n                    $ctrl.model.item.envConfigResults[0].assets.companyEmail\">\nif you have received this transmission in error, please notify us by telephone at {{$ctrl.model.companyPhoneNumber}} or notify us at: {{$ctrl.model.item.envConfigResults[0].assets.companyAddress}} or {{$ctrl.model.item.envConfigResults[0].assets.companyEmail}}.\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber && \n                    $ctrl.model.item.envConfigResults[0].assets.companyEmail &&\n                    !$ctrl.model.item.envConfigResults[0].assets.companyAddress\">\nif you have received this transmission in error, please notify us by telephone at {{$ctrl.model.companyPhoneNumber}} or notify us at: {{$ctrl.model.item.envConfigResults[0].assets.companyEmail}}\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber &&\n                    $ctrl.model.item.envConfigResults[0].assets.companyAddress &&\n                    ! $ctrl.model.item.envConfigResults[0].assets.companyEmail\">\nif you have received this transmission in error, please notify us by telephone at {{$ctrl.model.companyPhoneNumber}} or notify us at: {{$ctrl.model.item.envConfigResults[0].assets.companyAddress}}.\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyAddress && \n                    $ctrl.model.item.envConfigResults[0].assets.companyEmail && \n                    ! $ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber\">\nif you have received this transmission in error, please notify us at {{$ctrl.model.item.envConfigResults[0].assets.companyAddress}} or {{$ctrl.model.item.envConfigResults[0].assets.companyEmail}}.\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber &&\n                    !$ctrl.model.item.envConfigResults[0].assets.companyAddress &&\n                    !$ctrl.model.item.envConfigResults[0].assets.companyEmail\">\nif you have received this transmission in error, please notify us by telephone at {{$ctrl.model.companyPhoneNumber}}.\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyEmail && \n                    !$ctrl.model.item.envConfigResults[0].assets.companyAddress &&\n                    !$ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber\">\nif you have received this transmission in error, please notify us at {{$ctrl.model.item.envConfigResults[0].assets.companyEmail}}.\n</span>\n<span ng-if=\"$ctrl.model.item.envConfigResults[0].assets.companyAddress && \n                    !$ctrl.model.item.envConfigResults[0].assets.companyPhoneNumber &&\n                    !$ctrl.model.item.envConfigResults[0].assets.companyEmail\">\nif you have received this transmission in error, please notify us at {{$ctrl.model.item.envConfigResults[0].assets.companyAddress}}\n</span>\n</div>\n<p></p>\n</div>\n</div>\n";
var id1="items.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2688 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row_ margin-top-20\">\n<div class=\"col-sm-12 align-center-horizontally\">\n<div class=\"col-sm-7\">\n<input ng-change=\"$ctrl.search()\" type=\"text\" placeholder=\"{{ 'location.id' | translate }}\" ng-model-options=\"{debounce: 1000}\" class=\"input-lg form-control\" ng-model=\"$ctrl.model.search\" search-autofocus>\n</div>\n<div class=\"col-sm-2\">\n<select id=\"select\" class=\"input-lg form-control\" ng-model=\"$ctrl._searchStatus\" ng-options=\"status.value as status.lable for status in $ctrl.statusList\" ng-change=\"$ctrl.search()\" required>\n</select>\n</div>\n<div class=\"col-sm-3 location-hold-dd-section remove-right-pad\">\n<div class=\"multi-select user-branch-search-dd valid-multi-select-value\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" selection-mode=\"single\" on-item-click=\"$ctrl.resetPagination(); $ctrl.loadData();\" translation=\"$ctrl.localLang\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-offset-4 col-sm-4\">\n<div class=\"row\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-20\">\n<div class=\"row margin-top-20\">\n<span class=\"pull-left font-size-20\">\n{{'locationHolds.locationsOnHold' | translate}} | {{'locationHolds.asOf' | translate}} {{$ctrl.model.lastChecked}}\n</span>\n<button class=\"btn btn-success pull-right\" ng-disabled=\"$ctrl.allowBulkRelease\" ng-click=\"$ctrl.bulkReleased()\">{{'locationHolds.bulkRelease' | translate}}</button>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!$ctrl.model.loading && $ctrl.locations && $ctrl.locations.length\">\n<div class=\"row table-responsive\">\n<table class=\"margin-10 table table-hover table-striped table-bordered cell-width-200 table-pad-7 font-12\">\n<tr>\n<td class=\"pointer\" ng-click=\"$ctrl.SortData('locationId')\">\n<b>{{'locationHolds.location' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</td>\n<td class=\"pointer\" ng-click=\"$ctrl.SortData('status')\">\n<b>{{'locationHolds.status' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'status'}\"></span>\n</td>\n<td class=\"pointer\" ng-click=\"$ctrl.SortData('reason')\">\n<b>{{'locationHolds.reasonCode' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'reason'}\"></span>\n</td>\n<td class=\"min-width-39\" ng-click=\"$ctrl.SortData('supvHoldId')\" style=\"width: 14%;\">\n<b>{{'locationHolds.supervisor' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'supvHoldId'}\"></span>\n</td>\n<td class=\"pointer date-time-width\" ng-click=\"$ctrl.SortData('createdAt')\">\n<b>{{'locationHolds.holdDateTime' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active': $ctrl.sortColumn === 'createdAt'}\"></span>\n</td>\n<td>\n<b>{{'locationHolds.comments' | translate}}</b>\n</td>\n<td class=\"min-width-39\">\n<b>{{'locationHolds.actions' | translate}}</b>\n</td>\n</tr>\n<tr ng-repeat=\"heldLocation in $ctrl.locations | orderBy:$ctrl.sortColumn:$ctrl.reverseSort\">\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(heldLocation.locationId)\">\n{{heldLocation.locationId }}\n</a> | {{heldLocation.locationName}}\n</td>\n<td>{{heldLocation.status}}</td>\n<td>{{heldLocation.reason}}</td>\n<td class=\"min-width-39\">{{heldLocation.supvHoldId}}</td>\n<td ng-if=\"heldLocation.status==='RELEASED'\"> {{heldLocation.releaseDate | date: 'MM-dd-yyyy | hh:mm a'}} </td>\n<td ng-if=\"heldLocation.status==='ON_HOLD'\"> {{heldLocation.createdAt | date: 'MM-dd-yyyy | hh:mm a'}} </td>\n<td>{{heldLocation.comments}}</td>\n<td align=\"center\" class=\"min-width-39\">\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<button ng-disabled=\"heldLocation.status==='RELEASED'\" type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.releaseLocation(heldLocation)\">\n<span class=\"glyphicon glyphicon-ok\"></span>\n</button>\n</div>\n</div>\n</td>\n</tr>\n</table>\n</div>\n<div class=\"row\">\n<ul uib-pagination total-items=\"$ctrl.pagination.total\" ng-hide=\"{{($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.loading && (!$ctrl.locations || !$ctrl.locations.length)\" class=\"row margin-top-10\">\n<div class=\"alert alert-danger text-align-center\">\n{{'locationHolds.noLocationsHeld' | translate}}\n</div>\n</div>\n</div>\n</div>";
var id1="location_holds.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<div class=\"form-validate margin-top-10 row_ hide-in-print\" ng-if=\"$ctrl.currentStats === 'ServiceHistory'\">\n<div class=\"form-row d-flex-end\">\n<div class=\"service-history-search-section\">\n<div class=\"margin-top-05 btn-group service-tab\" id=\"status\" data-toggle=\"buttons\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStatsOfServiceHistory\" uib-btn-radio=\"$ctrl.serviceHistoryStats.single\" ng-click=\"$ctrl.serviceHistoryTabSelection('single')\" ng-class=\"{'btn-success': $ctrl.model.currentStatsOfServiceHistory === $ctrl.serviceHistoryStats.single, \n                               'remove-btn-grp-color': $ctrl.model.currentStatsOfServiceHistory === $ctrl.serviceHistoryStats.all}\">\n{{'common.single' | translate}}\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStatsOfServiceHistory\" uib-btn-radio=\"$ctrl.serviceHistoryStats.all\" ng-click=\"$ctrl.serviceHistoryTabSelection('all');\" ng-class=\"{'btn-success': $ctrl.model.currentStatsOfServiceHistory === $ctrl.serviceHistoryStats.all, \n                               'remove-btn-grp-color': $ctrl.model.currentStatsOfServiceHistory === $ctrl.serviceHistoryStats.single}\">\n{{'common.All' | translate}}\n</button>\n</div>\n<div class=\"bagout-history-dd-section branch-mgmt-dd-or-search-section dd-z-index\" ng-show=\"$ctrl.model.currentStatsOfServiceHistory === $ctrl.serviceHistoryStats.single\">\n<input strip-prefix ng-change=\"$ctrl.clearData();\" on-press-enter=\"$ctrl.getLocationDetail();\" scan-type=\"'location'\" placeholder=\"{{ 'branch_mgmt.search' | translate }}\" type=\"text\" ng-keydown=\"$ctrl.replaceURL(); $ctrl.reset()\" ng-model=\"$ctrl.model.fromLocationId\" class=\"input-lg form-control\" id=\"serviceHistorySingleSearch\" search-autofocus>\n</div>\n<div class=\"bagout-history-dd-section branch-mgmt-dd-or-search-section dd-z-index\" ng-show=\"$ctrl.model.currentStatsOfServiceHistory === $ctrl.serviceHistoryStats.all\">\n<search-and-select ng-model=\"$ctrl.model.fromLocationId\" values=\"$ctrl.locationList\" key=\"Key\" totalrecords=\"$ctrl.totalRecord\" onscroll=\"$ctrl.loadLocations(searchKey, offset)\" none-selected=\"'common.none'\" on-click=\"$ctrl.onLocationSelected();\" ng-keydown=\"$event.keyCode === 13 && $ctrl.getLocationDetail();\" placeholder=\"'branch_mgmt.search' | translate'\" required></search-and-select>\n</div>\n<div class=\"margin-top-05\">\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.getLocationDetail(); $ctrl.replaceURL();\" ng-disabled=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n</div>\n</div>\n<div class=\"custome-width-15 item-status-timezone-dd-section\">\n<div>\n<select class=\"tz-list-dd-height form-control\" required ng-model=\"$ctrl.model.timezone\" ng-options=\"timezone.value as timezone.label for timezone in $ctrl.model.timezoneList\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-offset-4 col-sm-4\">\n<div class=\"row_\">\n<div class=\"col-sm-offset-2 col-sm-8 padding-zero\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" ng-change=\"$ctrl.getLocationDetail();\" options=\"$ctrl.model.dateRangPickerOptionsfor\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row_ margin-top-10 row_ hide-in-print\" ng-if=\"$ctrl.currentStats === 'BagoutHistory'\">\n<div class=\"col-sm-12 align-center-horizontally form-validate\">\n<div class=\"col-sm-7 bagout-history-dd-section dd-z-index\">\n<search-and-select focus-dropdown-search=\"bagoutHistoryDDSearch\" ng-model=\"$ctrl.model.fromLocationId\" values=\"$ctrl.locationList\" key=\"Key\" totalrecords=\"$ctrl.totalRecord\" onscroll=\"$ctrl.loadLocations(searchKey, offset)\" on-click=\"$ctrl.bagoutScanned($ctrl.model.dateRanges)\" none-selected=\"'common.none'\" placeholder=\"'branch_mgmt.search' | translate'\" ng-keydown=\"$event.keyCode === 13 && $ctrl.bagoutScanned($ctrl.model.dateRanges)\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-offset-4 col-sm-4\">\n<div class=\"row_\">\n<div class=\"col-sm-offset-2 col-sm-8 padding-zero\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\" ng-change=\"$ctrl.bagoutScanned($ctrl.model.dateRange)\" options=\"$ctrl.model.dateRangPickerOptionsfor\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row_ margin-top-10 row_ hide-in-print\" ng-if=\"$ctrl.currentStats === 'RepairHistory' && $ctrl.serviceTickets\">\n<div class=\"col-sm-12 align-center-horizontally\">\n<div class=\"col-sm-7 bagout-history-dd-section form-validate dd-z-index\">\n<search-and-select focus-dropdown-search=\"repairHistoryDDSearch\" ng-model=\"$ctrl.model.fromLocationId\" values=\"$ctrl.locationList\" key=\"Key\" totalrecords=\"$ctrl.totalRecord\" onscroll=\"$ctrl.loadLocations(searchKey, offset)\" on-click=\"$ctrl.getCompletedServiceTickets($ctrl.model.dateRanges);\" none-selected=\"'common.none'\" placeholder=\"'branch_mgmt.search' | translate'\" ng-keydown=\"$event.keyCode === 13 && $ctrl.getCompletedServiceTickets($ctrl.model.dateRanges);\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-offset-4 col-sm-4\">\n<div class=\"row_\">\n<div class=\"col-sm-offset-2 col-sm-8 padding-zero\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\" ng-change=\"$ctrl.getCompletedServiceTickets($ctrl.model.dateRange)\" options=\"$ctrl.model.dateRangPickerOptionsfor\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row_ margin-top-10 row_ hide-in-print\" ng-if=\"$ctrl.currentStats === 'BillingRule'\">\n<div class=\"col-sm-12 align-center-horizontally\">\n<div class=\"col-sm-7 bagout-history-dd-section form-validate dd-z-index\">\n<search-and-select focus-dropdown-search=\"repairHistoryDDSearch\" ng-model=\"$ctrl.model.fromLocationId\" values=\"$ctrl.locationList\" key=\"Key\" totalrecords=\"$ctrl.totalRecord\" onscroll=\"$ctrl.loadLocations(searchKey, offset)\" on-click=\"$ctrl.getBillingRules($ctrl.model.billingRulesDateRanges);\" none-selected=\"'common.none'\" placeholder=\"'branch_mgmt.search' | translate'\" ng-keydown=\"$event.keyCode === 13 && $ctrl.getBillingRules($ctrl.model.billingRulesDateRanges);\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-offset-4 col-sm-4\">\n<div class=\"row_\">\n<div class=\"col-sm-offset-2 col-sm-8 padding-zero\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.billingRulesDateRanges\" ng-if=\"$ctrl.model.billingRulesDateRanges.startDate\" ng-change=\"$ctrl.getBillingRules($ctrl.model.billingRulesDateRanges)\" options=\"$ctrl.model.dateRangPickerOptionsfor\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row_ margin-top-10 row_ hide-in-print\" ng-if=\"$ctrl.currentStats === 'BillingHistory'\">\n<div class=\"col-sm-12 align-center-horizontally\">\n<div class=\"col-sm-7 bagout-history-dd-section form-validate dd-z-index\">\n<search-and-select focus-dropdown-search=\"repairHistoryDDSearch\" ng-model=\"$ctrl.model.fromLocationId\" values=\"$ctrl.locationList\" key=\"Key\" totalrecords=\"$ctrl.totalRecord\" onscroll=\"$ctrl.loadLocations(searchKey, offset)\" on-click=\"$ctrl.getBillingHistory($ctrl.model.billingHistoryDateRanges);\" none-selected=\"'common.none'\" placeholder=\"'branch_mgmt.search' | translate'\" ng-keydown=\"$event.keyCode === 13 && $ctrl.getBillingHistory($ctrl.model.billingHistoryDateRanges);\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-offset-4 col-sm-4\">\n<div class=\"row_\">\n<div class=\"col-sm-offset-2 col-sm-8 padding-zero\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.billingHistoryDateRanges\" ng-if=\"$ctrl.model.billingHistoryDateRanges.startDate\" ng-change=\"$ctrl.getBillingHistory($ctrl.model.billingHistoryDateRanges)\" options=\"$ctrl.model.dateRangPickerOptionsfor\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"form-group nav-center pull-top hide-in-print margin-top-10\">\n<div class=\"btn-group\" id=\"status\" data-toggle=\"buttons\">\n<label id=\"service-history\" class=\"btn btn-default btn-on btn-sm active nav-bar-active\" ng-click=\"$ctrl.tabSelection('ServiceHistory', $ctrl.model.dateRangeOptions)\">\n<input type=\"radio\" value=\"ServiceHistory\" checked=\"checked\">{{ 'branch_mgmt.service_title' | translate }}</label>\n<label id=\"repair-history\" class=\"btn btn-default btn-off btn-sm nav-bar-active\" ng-if=\"$ctrl.serviceTickets\" ng-click=\"$ctrl.tabSelection('RepairHistory', $ctrl.model.dateRangeOptions)\">\n<input type=\"radio\" value=\"RepairHistory\">{{'branch_mgmt.repair_history' | translate}}</label>\n<label id=\"bagout-history\" class=\"btn btn-default btn-off btn-sm nav-bar-active\" ng-click=\"$ctrl.tabSelection('BagoutHistory', $ctrl.model.dateRangeOptions)\">\n<input type=\"radio\" value=\"BagoutHistory\">{{ 'branch_mgmt.bagout_title' | translate }}</label>\n<label id=\"billing-rule\" class=\"btn btn-default btn-off btn-sm nav-bar-active\" ng-if=\"!$ctrl.User.getUser().customerUser\" ng-click=\"$ctrl.tabSelection('BillingRule', $ctrl.model.dateRangeOptions)\">\n<input type=\"radio\" value=\"BillingRule\">{{ 'contract.billing_rule' | translate }}</label>\n<label id=\"billing-history\" class=\"btn btn-default btn-off btn-sm nav-bar-active\" ng-if=\"!$ctrl.User.getUser().customerUser\" ng-click=\"$ctrl.tabSelection('BillingHistory', $ctrl.model.dateRangeOptions)\">\n<input type=\"radio\" value=\"BillingHistory\">{{ 'branch_mgmt.billing_history' | translate }}</label>\n</div>\n</div>\n<div class=\"tab-content\">\n<div ng-if=\"$ctrl.currentStats === 'ServiceHistory'\">\n<div class=\"row_ margin-top-10\">\n<div class=\"col-sm-12 remove-padding\" ng-if=\"$ctrl.model.fromLocationId\">\n<div class=\"col-sm-12 hide-in-print remove-padding\">\n<div ng-if=\"$ctrl.model.fromLocationId && $ctrl.locationDetails.locationId && $ctrl.model.isData\">\n<h4>\n<a href=\"#\" ng-click=\"$ctrl.editLocation($ctrl.model.fromLocationId)\" style=\"font-size: 25px\" class=\"text-decoration-none remove-padding\">\n{{$ctrl.locationDetails.locationId}} | {{$ctrl.locationDetails.locationName}}\n</a>\n</h4>\n</div>\n<div ng-if=\"$ctrl.model.isData\">\n<div>\n<span class=\"pull-left font-size-20\">\n<strong>{{ 'branch_mgmt.servicehistory.title' | translate }}</strong>\n</span>\n</div>\n<div class=\"pull-right\" ng-if=\"!$ctrl.loading && $ctrl.serviceHistory.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.print()\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{ 'branch_mgmt.itemHistory.print' | translate }}</button>\n</div>\n<div class=\"pull-right export-btn-pad-5\" ng-if=\"!$ctrl.loading && $ctrl.serviceHistory.results.length && $ctrl.isAllow\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportServiceHistory()\" ng-disabled=\"$ctrl.isExporting\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isExporting\"></span>\n{{ 'common.export' | translate }}</button>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!$ctrl.loading && $ctrl.serviceHistory.results.length\">\n<div class=\"col-sm-12 remove-padding table-responsive\">\n<table class=\"margin-top-05 table table-hover table-striped table-bordered table-pad-5 font-12\">\n<thead>\n<tr>\n<td class=\"service-date-width remove-white-space\">\n<b>{{ 'branch_mgmt.servicehistory.service_date' | translate }}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{ 'branch_mgmt.servicehistory.order_no' | translate }}</b>\n</td>\n<td class=\"order-type-width remove-white-space\">\n<b>{{ 'branch_mgmt.servicehistory.order_type' | translate }}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{'bagout.status' | translate}}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{ 'branch_mgmt.servicehistory.load_tracking_id' | translate}}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{ 'branch_mgmt.servicehistory.residual_tracking_id' | translate}}</b>\n</td>\n<td class=\"remove-white-space\" ng-click=\"$ctrl.sortAtmServiceHistoryData('routeId', $event, $ctrl.model.dateRangeOptions)\">\n<b>{{'branch_mgmt.servicehistory.route_id' | translate }}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.atmServiceHistoryObj.reverseSort, 'active' : $ctrl.model.atmServiceHistoryObj.sortColumn === 'routeId'}\"></span>\n</td>\n<td class=\"remove-white-space\">\n<b>{{ 'branch_mgmt.servicehistory.delivered_loaded' | translate }} / {{'branch_mgmt.monthly_report.amount' | translate}}\n</b>\n</td>\n<td class=\"billing-approval-col-w-12 remove-white-space\">\n<b>{{ 'branch_mgmt.servicehistory.pickup_residual' | translate }}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{ 'branch_mgmt.servicehistory.counted_variance' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"serviceHistory in $ctrl.serviceHistory.results\">\n<td>{{serviceHistory.serviceDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.redirectToOrderPage(serviceHistory)\">{{serviceHistory.orderNo}}</a>\n</td>\n<td class=\"text-danger text-center\">\n<div>\n<span ng-repeat=\"denom in serviceHistory.denominations\">\n<img ng-src=\"assets/images/{{denom.denominationId}}.png\" alt=\"{{denom.denominationId}}\" class=\"denom-icon\"/>\n</span>\n<span ng-if=\"serviceHistory.isEC\"><img src=\"" + __webpack_require__(249) + "\" class=\"emergency-icon\" uib-tooltip=\"{{'common.emergency' | translate}}\"/></span>\n</div>\n<div>{{$ctrl.getOrderType(serviceHistory.orderType)}}</div>\n</td>\n<td ng-if=\"!serviceHistory.tranType\">\n<div ng-if=\"serviceHistory.status === 'shipment.counted'\">\n<span class=\"text-success\">{{ serviceHistory.status | translate }}</span>\n<div class=\"text-success\">({{serviceHistory.amountCounted | currency:\"$\"}})\n</div>\n</div>\n<div ng-if=\"serviceHistory.status === 'shipment.deleted'\">\n<span class=\"text-danger\">\n{{serviceHistory.status | translate}}\n</span>\n<div ng-if=\"serviceHistory.deletedReason\">({{serviceHistory.deletedReason}})</div>\n</div>\n<div ng-if=\"serviceHistory.status === 'shipment.hold'\">\n<span class=\"history-link-btn text-danger\" ng-click=\"$ctrl.goToItemHold(serviceHistory)\">\n{{serviceHistory.status | translate}}\n</span>\n</div>\n<div ng-if=\"(serviceHistory.packed === 0 || serviceHistory.packed === false) && \n                                                    serviceHistory.status !== 'shipment.deleted' && \n                                                    serviceHistory.status !== 'shipment.counted' && \n                                                    serviceHistory.status !== 'shipment.hold'\">\n<span class=\"history-link-btn\" ng-click=\"$ctrl.redirectToOrderPack(serviceHistory)\">\n{{ 'routeControl.pending_pack' | translate }}\n</span>\n</div>\n<div ng-if=\"serviceHistory.status !== 'shipment.deleted' && serviceHistory.status !== 'shipment.counted' &&\n                                                    serviceHistory.status !== 'shipment.hold' && \n                                                    serviceHistory.packed !== 0 && serviceHistory.packed !== false\">\n<span class=\"history-link-btn\" ng-class=\"{'text-success': serviceHistory.status === 'shipment.packed' ||\n                                                              serviceHistory.status === 'shipment.checkedIn' || serviceHistory.status === 'shipment.delivered' || \n                                                              serviceHistory.status === 'shipment.checkedOut' || serviceHistory.status === 'shipment.onRoute' ||\n                                                              serviceHistory.status === 'shipment.thrownToRoute' || serviceHistory.status === 'shipment.loadedToTruck'}\" ng-click=\"$ctrl.goToItemHistory(serviceHistory.loadTrackingId)\">\n{{$ctrl.translateItemStatus(serviceHistory.status)}}\n</span>\n</div>\n</td>\n<td class=\"text-danger\" ng-if=\"serviceHistory.tranType && serviceHistory.tranType !== 'SHORT_LOAD'\">\n<span>\n{{$ctrl.translateTransactionType(serviceHistory.tranType)}}\n</span>\n</td>\n<td class=\"text-danger\" ng-if=\"serviceHistory.tranType && serviceHistory.tranType === 'SHORT_LOAD' && (serviceHistory.loadedAmount < serviceHistory.deliveryAmount)\">\n<span>\n{{$ctrl.translateTransactionType(serviceHistory.tranType)}}\n</span>\n<span>\n({{serviceHistory.loadedAmount | currency:\"$\"}})\n</span>\n</td>\n<td class=\"text-danger\" ng-if=\"serviceHistory.tranType && serviceHistory.tranType === 'SHORT_LOAD' \n                                        && serviceHistory.loadedAmount === serviceHistory.deliveryAmount\">\n<span class=\"text-success\">{{serviceHistory.status | translate}}</span>\n<div class=\"text-success\">({{serviceHistory.amountCounted | currency:\"$\"}})\n</div>\n</td>\n<td>\n<span class=\"history-link-btn\" ng-click=\"$ctrl.redirectTo(serviceHistory)\" ng-if=\"serviceHistory.loadTrackingId\">{{serviceHistory.loadTrackingId}}</span>\n<span ng-if=\"!serviceHistory.loadTrackingId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<div>\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(serviceHistory.residualTrackingId)\">{{serviceHistory.residualTrackingId}}</a>\n<a href=\"#\" ng-if=\"serviceHistory.parentResidualShipmentDetails.pickupImageName\" ng-click=\"$ctrl.showResidualReceipt(serviceHistory.parentResidualShipmentDetails)\" style=\"padding: 0px;\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</a>\n</div>\n<span ng-if=\"!serviceHistory.residualTrackingId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span class=\"history-link-btn\" ng-click=\"$ctrl.redirectToRouteTab(serviceHistory.routeId, serviceHistory.serviceDate)\">{{serviceHistory.routeId}}</span>\n</td>\n<td>\n<span ng-if=\"!serviceHistory.finishedAt\">{{serviceHistory.parentLoadShipmentDetails.loadedAmount > 0 ? serviceHistory.parentLoadShipmentDetails.loadedAmount : serviceHistory.deliveryAmount | currency:\"$\"}}</span>\n<span ng-if=\"serviceHistory.finishedAt\">{{serviceHistory.loadedAmount | currency:\"$\"}}</span>\n</td>\n<td>\n<span ng-if=\"serviceHistory.residualTrackingId\">\n<a ng-if=\"serviceHistory.parentResidualShipmentDetails.checkedIn && serviceHistory.finishedAt\" href=\"#\" ng-click=\"$ctrl.redirectToAtmCount(serviceHistory)\">\n{{serviceHistory.residualAmount | currency:\"$\"}}\n</a>\n<span ng-if=\"!serviceHistory.finishedAt\">\n{{serviceHistory.parentResidualShipmentDetails.shipmentAmount | currency:\"$\"}}\n</span>\n<span ng-if=\"serviceHistory.amountVariance\">\n<img ng-src=\"assets/images/red-alert.png\" uib-tooltip=\"{{'atm_residual.variance' | translate}}\" class=\"variance-alert-icon cursor-pointer\" ng-click=\"$ctrl.redirectToAtmCount(serviceHistory)\"/>\n</span>\n</span>\n<span ng-if=\"!serviceHistory.residualTrackingId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{serviceHistory.amountCRV | currency:\"$\"}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"align-center-horizontally row_ hide-in-print\" ng-if=\"!$ctrl.loading && !$ctrl.model.isData || !$ctrl.model.fromLocationId\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.records}\" style=\"text-align: center; width:100%\">\n<span>{{$ctrl.model.records}}</span>\n</div>\n</div>\n<div class=\"align-center-horizontally row_ hide-in-print\" ng-if=\"!$ctrl.loading && $ctrl.model.isData && !$ctrl.serviceHistory.results.length && $ctrl.model.fromLocationId\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.unableToFind}\" style=\"text-align: center; width:100%\">\n<span>{{$ctrl.model.unableToFind}}</span>\n</div>\n</div>\n</div>\n<div class=\"row_ hide-in-print margin-bottom-10\" ng-if=\"$ctrl.serviceHistoryTotal > $ctrl.pagination.pageLimit && !$ctrl.loading && $ctrl.model.fromLocationId\">\n<ul uib-pagination total-items=\"$ctrl.serviceHistoryTotal\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChangeServiceHistory($ctrl.model.dateRangeOptions)\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n<div class=\"row_\" ng-if=\"$ctrl.model.fromLocationId && $ctrl.model.isDeliveryServiceHistory\">\n<div class=\"col-sm-12 hide-in-print remove-padding\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"pull-left font-size-20\">\n<strong>{{'branch_mgmt.delivery_service_history' | translate}}</strong>\n</div>\n<div class=\"pull-right\" ng-if=\"!$ctrl.model.loadDeliveryServiceHistory && $ctrl.model.deliveryServiceHistory.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.print('deliveryServiceHistory')\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{ 'branch_mgmt.itemHistory.print' | translate }}</button>\n</div>\n<div class=\"pull-right export-btn-pad-5\" ng-if=\"!$ctrl.model.loadDeliveryServiceHistory && $ctrl.model.deliveryServiceHistory.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportDeliveryServiceHistory()\" ng-disabled=\"$ctrl.model.isExportingDeliveryServiceHistory\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExportingDeliveryServiceHistory\"></span>\n{{ 'common.export' | translate }}</button>\n</div>\n<div class=\"pull-right location-search-pad-10\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.fromLocationSearchText\" name=\"searchText\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.getDeliveryServiceHistory();\" placeholder=\"{{'common.locationId' | translate}}\" ng-disabled=\"$ctrl.model.loadDeliveryServiceHistory\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"$ctrl.model.isDeliveryServiceHistory\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loadDeliveryServiceHistory && $ctrl.model.isDeliveryServiceHistory\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"margin-10 remove-padding table-responsive\" ng-if=\"!$ctrl.model.loadDeliveryServiceHistory && $ctrl.model.deliveryServiceHistory.length > 0\">\n<table class=\"table table-hover table-striped table-bordered table-pad-7 font-12\">\n<thead>\n<tr>\n<th><b>{{ 'branch_mgmt.servicehistory.service_date' | translate }}</b></th>\n<th><b>{{'routeThrow.deliveryDate' | translate }}</b></th>\n<th><b>{{'bagout.trackingId' | translate}}</b></th>\n<th ng-click=\"$ctrl.sortDeliveryServiceHistoryData('routeId', $event)\">\n<b>{{'branch_mgmt.servicehistory.route_id' | translate }}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.deliveryServiceHistoryObj.reverseSort, 'active' : $ctrl.model.deliveryServiceHistoryObj.sortColumn === 'routeId'}\"></span>\n</th>\n<th><b>{{'shiptype.shiptype' | translate}}</b></th>\n<th><b>{{'addBagModal.amount' | translate}}</b></th>\n<th><b>{{'master_cash_schedule.denoms' | translate}}</b></th>\n<th><b>{{ 'bagout.fromLocation' | translate }}</b></th>\n<th><b>{{'bagout.status' | translate}}</b></th>\n<th><b>{{'common.action' | translate}}</b></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"deliveyServiceHistory in $ctrl.model.deliveryServiceHistory\">\n<td>{{deliveyServiceHistory.serviceDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td>\n<span ng-if=\"deliveyServiceHistory.deliveredFlag || deliveyServiceHistory.status === 'shipment.deleted'\">\n{{$ctrl.DateUtil.convertDateTime(deliveyServiceHistory.deliveryDate, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}\n</span>\n<span ng-if=\"!deliveyServiceHistory.deliveredFlag && deliveyServiceHistory.status !== 'shipment.deleted'\">{{'branch_mgmt.routes.bucket_PENDING' | translate}}\n<span class=\"badge shipment-transaction-btn-color _transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.deliveryServiceTransactionModal(deliveyServiceHistory)\" uib-tooltip=\"{{'routeStats.transactions' | translate}}\" tooltip-placement=\"right-bottom\">\n<span>!</span>\n</span>\n</span>\n</td>\n<td>\n<span ng-if=\"deliveyServiceHistory.trackingId\" class=\"history-link-btn\" ng-click=\"$ctrl.goToItemHistory(deliveyServiceHistory.trackingId)\">\n{{deliveyServiceHistory.trackingId}}\n</span>\n<span ng-if=\"!deliveyServiceHistory.trackingId\">{{'common.n_a' | translate}}</span>\n<span class=\"padding5\">\n<a href=\"#\" ng-if=\"deliveyServiceHistory.deliveryImageName\" ng-click=\"$ctrl.showReceipt(deliveyServiceHistory, 'delivery')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</a>\n</span>\n</td>\n<td>\n<span class=\"history-link-btn\" ng-click=\"$ctrl.redirectToRouteTab(deliveyServiceHistory.routeId, deliveyServiceHistory.serviceDate)\">{{deliveyServiceHistory.routeId}}</span>\n</td>\n<td>{{deliveyServiceHistory.shiptypeId}} | {{deliveyServiceHistory.description}}</td>\n<td>\n<span ng-if=\"$ctrl.locationDetails.locationType === 'ATM'\">\n<span ng-if=\"$ctrl.setAmount(deliveyServiceHistory)\">{{$ctrl.setAmount(deliveyServiceHistory)}}</span>\n<span ng-if=\"!$ctrl.setAmount(deliveyServiceHistory)\">{{'common.n_a' | translate}}</span>\n</span>\n<span ng-if=\"$ctrl.locationDetails.locationType !== 'ATM'\">{{deliveyServiceHistory.formattedAmount}}</span>\n</td>\n<td>\n<div class=\"d-flex\">\n<div ng-repeat=\"denom in deliveyServiceHistory.denomArr track by $index\">\n<img ng-if=\"deliveyServiceHistory.denomArr.length\" ng-src=\"assets/images/{{denom}}.png\" class=\"denom-image\" alt=\"{{ denom }}\" style=\"width:30px\"/>\n</div>\n<span ng-if=\"!deliveyServiceHistory.denomArr.length\">{{ 'branch_mgmt.itemHistory.n_a' | translate }}</span>\n</div>\n</td>\n<td>\n<span ng-if=\"deliveyServiceHistory.fromLocationId\">{{deliveyServiceHistory.fromLocationId}} | {{deliveyServiceHistory.fromLocationName}}</span>\n<span ng-if=\"!deliveyServiceHistory.fromLocationId\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-danger\">\n<span>{{$ctrl.translateItemStatus(deliveyServiceHistory.status)}}</span>\n<button type=\"button\" class=\"btn btn-success btn-xs\" ng-disabled=\"$ctrl.isSending\" ng-if=\"deliveyServiceHistory.status === 'shipment.delivered'\" uib-tooltip=\"{{'location.resend_receipt' | translate}}\" tooltip-placement=\"top-right\" ng-click=\"$ctrl.sendDeliveryOrPickupReceipt(deliveyServiceHistory, 'delivery')\">\n<span class=\"glyphicon glyphicon-share-alt\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-warning btn-xs\" ng-disabled=\"$ctrl.isSending\" ng-if=\"deliveyServiceHistory.status === 'shipment.delivered' && deliveyServiceHistory.orderNo\" uib-tooltip=\"{{'location.resend_order_receipt' | translate}}\" tooltip-placement=\"top-right\" ng-click=\"$ctrl.sendOrderReceipt(deliveyServiceHistory)\">\n<span class=\"glyphicon glyphicon-share-alt\"></span>\n</button>\n</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-xs btn-warning\" ng-if=\"deliveyServiceHistory.canConvertToCRV && !deliveyServiceHistory.deliveredFlag\" uib-tooltip=\"{{'itemHolds.converttocrv' | translate}}\" ng-disabled=\"$ctrl.isLoading\" tooltip-placement=\"top-right\" ng-click=\"$ctrl.convertShipmentToCrv(deliveyServiceHistory)\">\nC\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-if=\"deliveyServiceHistory.status === 'shipment.pendingPack' &&\n                                               deliveyServiceHistory.status !== 'shipment.deleted' &&\n                                               deliveyServiceHistory.status !== 'shipment.counted' &&\n                                               deliveyServiceHistory.status !== 'shipment.hold'\" uib-tooltip=\"{{'routeControl.pending_pack' | translate}}\" tooltip-placement=\"top-right\" ng-click=\"$ctrl.redirectToOrderPack(deliveyServiceHistory)\">\n<span class=\"glyphicon glyphicon-new-window\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-horizontally row_ hide-in-print remove-pad\" ng-if=\"!$ctrl.model.loadDeliveryServiceHistory && !$ctrl.model.deliveryServiceHistory.length && $ctrl.model.fromLocationId && $ctrl.model.isPickupServiceHistory\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.records}\" style=\"text-align: center; width:100%\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<div class=\"row_ hide-in-print margin-bottom-10\" ng-if=\"$ctrl.deliveryHistoryObj.pagination.total > $ctrl.deliveryHistoryObj.pagination.pageLimit \n                   && !$ctrl.model.loadDeliveryServiceHistory && $ctrl.model.fromLocationId && $ctrl.model.isDeliveryServiceHistory\">\n<ul uib-pagination total-items=\"$ctrl.deliveryHistoryObj.pagination.total\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.deliveryHistoryObj.pagination.page\" ng-change=\"$ctrl.getDeliveryServiceHistory()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n<div class=\"row_ margin-top-10\" ng-if=\"$ctrl.model.fromLocationId && $ctrl.model.isPickupServiceHistory\">\n<div class=\"col-sm-12 hide-in-print remove-padding\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"pull-left font-size-20\">\n<strong>{{'branch_mgmt.pickup_service_history' | translate}}</strong>\n</div>\n<div class=\"pull-right\" ng-if=\"!$ctrl.model.loadPickupServiceHistory && $ctrl.model.pickupServiceHistory.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.print('pickupServiceHistory')\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{ 'branch_mgmt.itemHistory.print' | translate }}</button>\n</div>\n<div class=\"pull-right export-btn-pad-5\" ng-if=\"!$ctrl.model.loadPickupServiceHistory && $ctrl.model.pickupServiceHistory.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportPickupServiceHistory()\" ng-disabled=\"$ctrl.model.isExportingPickupServiceHistory\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExportingPickupServiceHistory\"></span>\n{{ 'common.export' | translate }}</button>\n</div>\n<div class=\"pull-right location-search-pad-10\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.toLocationSearchText\" name=\"searchText\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.getPickupServiceHistory();\" placeholder=\"{{'common.locationId' | translate}}\" ng-disabled=\"$ctrl.model.loadPickupServiceHistory.loading\"/>\n</div>\n<div class=\"pull-right right-pad-10\" ng-if=\"$ctrl.hasMatchingDepositRecord\">\n<select class=\"form-control\" ng-model=\"$ctrl.selectedDepositAmountValue\">\n<option value=\"totalAmount\">Counted Value</option>\n<option value=\"statedTotalAmount\">Stated Value</option>\n<option value=\"declaredTotalAmount\">Declared Value</option>\n</select>\n</div>\n</div>\n<div class=\"margin-bottom-10 text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loadPickupServiceHistory && $ctrl.model.isPickupServiceHistory\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"!$ctrl.model.loadPickupServiceHistory && $ctrl.model.pickupServiceHistory.length && $ctrl.model.fromLocationId && $ctrl.model.isPickupServiceHistory\">\n<div class=\"margin-10 col-sm-12 remove-padding _table-responsive\">\n<table class=\"table table-hover table-striped table-bordered table-pad-7 font-12\">\n<thead>\n<tr>\n<th ng-click=\"$ctrl.sortPickupServiceHistoryData('serviceDate', $event)\">\n<b>{{ 'branch_mgmt.servicehistory.service_date' | translate }}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.pickupServiceHistoryObj.reverseSort, 'active' : $ctrl.model.pickupServiceHistoryObj.sortColumn === 'serviceDate'}\"></span>\n</th>\n<th ng-click=\"$ctrl.sortPickupServiceHistoryData('pickupDate', $event)\">\n<b>{{'shipmentBatch.pickupDate' | translate }}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.pickupServiceHistoryObj.reverseSort, 'active' : $ctrl.model.pickupServiceHistoryObj.sortColumn === 'pickupDate'}\"></span>\n</th>\n<th ng-click=\"$ctrl.sortPickupServiceHistoryData('trackingId', $event)\">\n<b>{{'bagout.trackingId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.pickupServiceHistoryObj.reverseSort, 'active' : $ctrl.model.pickupServiceHistoryObj.sortColumn === 'trackingId'}\"></span>\n</th>\n<td class=\"remove-white-space\" ng-click=\"$ctrl.sortPickupServiceHistoryData('routeId', $event)\">\n<b>{{'branch_mgmt.servicehistory.route_id' | translate }}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.pickupServiceHistoryObj.reverseSort, 'active' : $ctrl.model.pickupServiceHistoryObj.sortColumn === 'routeId'}\"></span>\n</td>\n<th><b>{{'shiptype.shiptype' | translate}}</b></th>\n<th ng-click=\"$ctrl.sortPickupServiceHistoryData('amount', $event)\">\n<b>{{'addBagModal.amount' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.pickupServiceHistoryObj.reverseSort, 'active' : $ctrl.model.pickupServiceHistoryObj.sortColumn === 'amount'}\"></span>\n</th>\n<th><b>{{'checkout.ToLocationName' | translate }}</b></th>\n<th><b>{{'bagout.status' | translate}}</b></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"pickupServiceHistory in $ctrl.model.pickupServiceHistory\" ng-class=\"{'immidiate-delivery-row-color': pickupServiceHistory.individuallyDeliverable}\">\n<td>\n<span ng-if=\"pickupServiceHistory.pickupDate\">\n{{$ctrl.DateUtil.convertDateTime(pickupServiceHistory.pickupDate, $ctrl.model.timezone, 'MM-DD-YYYY')}}\n</span>\n<span ng-if=\"!pickupServiceHistory.pickupDate\">{{pickupServiceHistory.serviceDate | date : \"MM-dd-yyyy\": 'UTC'}}</span>\n</td>\n<td>\n<span ng-if=\"pickupServiceHistory.pickupDate\">\n{{$ctrl.DateUtil.convertDateTime(pickupServiceHistory.pickupDate, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}\n</span>\n<span ng-if=\"!pickupServiceHistory.pickupDate\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<div class=\"d-flex\">\n<span class=\"history-link-btn\" ng-click=\"$ctrl.goToItemHistory(pickupServiceHistory.trackingId)\">\n{{pickupServiceHistory.trackingId}}\n</span>\n<span ng-if=\"pickupServiceHistory.individuallyDeliverable\" class=\"immidiate-delivery-icon margin-left-05 cursor-pointer\" uib-tooltip=\"{{'location.immediately_deliverable' | translate}}\"> ID\n</span>\n<span class=\"padding-03 margin-left-02\">\n<a href=\"#\" ng-if=\"pickupServiceHistory.pickupImageName\" ng-click=\"$ctrl.showReceipt(pickupServiceHistory, 'pickup')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black paperclip-icon-width\"></span>\n</a>\n</span>\n</div>\n</td>\n<td>\n<span class=\"history-link-btn\" ng-click=\"$ctrl.goToRouteStatus(pickupServiceHistory)\">{{pickupServiceHistory.routeId}}</span>\n</td>\n<td>{{pickupServiceHistory.shiptypeId}} | {{pickupServiceHistory.description}}</td>\n<td>\n<span ng-if=\"!['DEPOSIT', 'BULKCASH'].includes(pickupServiceHistory.shiptypeId) || !pickupServiceHistory.isVariance\">\n{{pickupServiceHistory.formattedAmount}}\n</span>\n<span ng-if=\"['DEPOSIT', 'BULKCASH'].includes(pickupServiceHistory.shiptypeId) && pickupServiceHistory && pickupServiceHistory.isVariance\">\n{{pickupServiceHistory[$ctrl.selectedDepositAmountValue] | currency:\"$\" }}\n</span>\n<span ng-if=\"pickupServiceHistory && pickupServiceHistory.isVariance && ['DEPOSIT', 'BULKCASH'].includes(pickupServiceHistory.shiptypeId)\">\n<button class=\"glyphicon glyphicon-info-sign glyphicon-button hide-in-print\" popover-trigger=\"'mouseenter'\" uib-popover-html=\"$ctrl.depositPopover(pickupServiceHistory)\" popover-placement=\"top\">\n</button>\n</span>\n</td>\n<td>\n<span>{{pickupServiceHistory.toLocationId}} | {{pickupServiceHistory.toLocationName}}</span>\n</td>\n<td class=\"text-danger\">\n<span>\n{{$ctrl.translateItemStatus(pickupServiceHistory.status)}}\n<span ng-if=\"pickupServiceHistory.status === 'shipment.counted'\">({{pickupServiceHistory.serviceDate | date: 'yyyy-MM-dd' : 'UTC'}})</span>\n</span>\n<button type=\"button\" class=\"btn btn-success btn-xs\" ng-disabled=\"$ctrl.isSending\" uib-tooltip=\"{{'location.resend_receipt' | translate}}\" ng-if=\"pickupServiceHistory.status === 'shipment.checkedIn' || pickupServiceHistory.status === 'shipment.pickedUp'\" tooltip-placement=\"top-right\" ng-click=\"$ctrl.sendDeliveryOrPickupReceipt(pickupServiceHistory, 'pickup')\">\n<span class=\"glyphicon glyphicon-share-alt\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success btn-icon btn-cst-height-22 denom-btn\" ng-if=\"pickupServiceHistory.status === 'shipment.counted'\" ng-click=\"$ctrl.redirectToCashCount(pickupServiceHistory)\">\n<span class=\"glyphicon glyphicon-arrow-right\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-horizontally row_ hide-in-print remove-pad\" ng-if=\"!$ctrl.model.loadPickupServiceHistory && !$ctrl.model.pickupServiceHistory.length && $ctrl.model.fromLocationId && $ctrl.model.isPickupServiceHistory\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.records}\" style=\"text-align: center; width:100%\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<div class=\"hide-in-print margin-bottom-10\" ng-show=\"$ctrl.pickupHistoryObj.pagination.total > $ctrl.pickupHistoryObj.pagination.pageLimit &&\n                    !$ctrl.model.loadPickupServiceHistory && $ctrl.model.fromLocationId && $ctrl.model.isPickupServiceHistory\">\n<ul uib-pagination total-items=\"$ctrl.pickupHistoryObj.pagination.total\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pickupHistoryObj.pagination.page\" ng-change=\"$ctrl.getPickupServiceHistory()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div ng-if=\"$ctrl.currentStats === 'BagoutHistory'\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row_\" ng-if=\"$ctrl.bagOutData.length && !$ctrl.model.loading && $ctrl.model.fromLocationId\">\n<div class=\"col-sm-12 remove-padding\">\n<div class=\"col-sm-12 hide-in-print remove-padding\">\n<div>\n<span class=\"pull-left font-size-20\">\n<strong>{{ 'branch_mgmt.bagout_title' | translate }}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.localDateTime}}</span>\n</span>\n</div>\n<div class=\"form-group pull-right\">\n<button class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.print()\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{ 'branch_mgmt.itemHistory.print' | translate }}\n</button>\n</div>\n<div class=\"form-group pull-right export-btn-pad-5\" ng-if=\"$ctrl.isAllow\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportBagoutHistory()\" ng-disabled=\"$ctrl.isExporting\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isExporting\"></span>\n{{ 'common.export' | translate }}</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding\">\n<table class=\"table table-hover table-striped table-bordered\">\n<thead>\n<tr>\n<td>\n<b>{{ 'branch_mgmt.bagout_Id' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.tracking_Id' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.destinations' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.bagout_status' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.date_time' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"bagOutDetails in $ctrl.bagOutData\">\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(bagOutDetails.bagSeal)\">\n{{bagOutDetails.bagSeal}}\n</a>\n</td>\n<td ng-if=\"bagOutDetails.trackingId\">\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(bagOutDetails.trackingId)\">\n{{bagOutDetails.trackingId}}\n</a>\n</td>\n<td ng-if=\"!bagOutDetails.trackingId\">{{ 'common.n_a' | translate }}</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.setDateRange(); $ctrl.redirectToServiceHistory(bagOutDetails.shipmentToLocationId);\">\n{{bagOutDetails.shipmentToLocationId}}\n</a> | {{bagOutDetails.toLocationName}}\n</td>\n<td ng-if=\"bagOutDetails.closed\">{{ 'branch_mgmt.bagout_closed' | translate }}</td>\n<td ng-if=\"!bagOutDetails.closed\">{{ 'branch_mgmt.bagout_not_closed' | translate }}</td>\n<td>{{ bagOutDetails.createdAt | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div ng-if=\"!$ctrl.bagOutData.length && $ctrl.model.bagOutDetails && !$ctrl.model.loading\">\n<div class=\"row align-center-horizontally row_ hide-in-print\" ng-show=\"$ctrl.model.noDetailFound\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.noDetailFound}\" style=\"text-align: center; width:100%\">\n<span>{{$ctrl.model.noDetailFound}}</span>\n</div>\n</div>\n</div>\n<div class=\"row align-center-horizontally row_ hide-in-print\" ng-if=\"(!$ctrl.model.bagOutDetails && !$ctrl.bagOutData.length && !$ctrl.model.loading) || !$ctrl.model.fromLocationId\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': !$ctrl.model.bagOutDetails}\" style=\"text-align: center; width:100%\">\n<span>{{$ctrl.noDataFound}}</span>\n</div>\n</div>\n<div class=\"row_ hide-in-print\" ng-if=\"$ctrl.bagOutTotal > $ctrl.pagination.pageLimit && !$ctrl.model.loading\">\n<ul uib-pagination total-items=\"$ctrl.bagOutTotal\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChangeBagoutHistory($ctrl.model.dateRangeOptions)\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div class=\"margin-bottom-20\" ng-if=\"$ctrl.currentStats === 'RepairHistory' && $ctrl.serviceTickets\">\n<div class=\"align-center-horizontally\" ng-show=\"$ctrl.model.isLoadingCompletedServiceOrder\">\n<div class=\"text-align-center text-center no-data-margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 40px; margin: 10px\"></span>\n</div>\n</div>\n<div class=\"align-center-horizontally hide-in-print\" ng-if=\"$ctrl.model.completedServiceTicketsCount == 0 && !$ctrl.model.isLoadingCompletedServiceOrder && !$ctrl.model.fromLocationId\">\n<div class=\"alert errLblPos alert-danger no-data-margin-10\" style=\"text-align: center;\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<div class=\"row_ panel panel-default margin-10 remove-bottom-pad\" ng-repeat=\"status in $ctrl.buckets track by $index\" ng-if=\"(!$ctrl.model.isLoadingCompletedServiceOrder && $ctrl.model.completedServiceTickets[status.bucket].items && $ctrl.model.completedServiceTickets[status.bucket].items.length)\">\n<div class=\"cursor-pointer panel-heading\">\n<div class=\"row panel-title panel-title-center bucket_text_align_center remove-left-padd remove-right-padd\">\n<div class=\"col-sm-8 remove-left-padd remove-right-padd\" ng-click=\"status.bucketExpanded=!status.bucketExpanded; $ctrl.validateBucket($event); $ctrl.setStatusExpanded(status.bucket)\">\n<i class=\"glyphicon glyphicon-triangle-bottom\" ng-show=\"status.bucketExpanded\"></i>\n<i class=\"glyphicon glyphicon-triangle-right\" ng-hide=\"status.bucketExpanded\"></i>\n<strong class=\"f-14\">{{$ctrl.getBucketName(status.bucket)}}</strong>\n<span class=\"badge complete-bucket-color\">\n{{$ctrl.model.completedServiceTickets[status.bucket].totalCount || $ctrl.model.completedServiceTickets[status.bucket].items.length}}\n</span>\n</div>\n</div>\n</div>\n<div class=\"align-center-horizontally\" ng-show=\"status.bucketExpanded && $ctrl.model.completedServiceTickets[status.bucket].process\">\n<div class=\"text-align-center text-center no-data-margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 40px; margin: 10px\"></span>\n</div>\n</div>\n<div class=\"align-center-horizontally hide-in-print\" ng-show=\"!$ctrl.model.completedServiceTickets[status.bucket].process && status.bucketExpanded && !$ctrl.model.fromLocationId &&\n                     $ctrl.model.completedServiceTickets[status.bucket].item && !$ctrl.model.completedServiceTickets[status.bucket].item.length\">\n<div class=\"alert errLblPos alert-danger no-data-margin-10\" style=\"text-align: center;\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<div class=\"table-responsive\" ng-show=\"status.bucketExpanded && $ctrl.model.completedServiceTickets[status.bucket].items && $ctrl.model.completedServiceTickets[status.bucket].items.length && !$ctrl.model.completedServiceTickets[status.bucket].process\">\n<table class=\"table table-striped table-hover table-bordered remove-bottom-pad\" ng-if=\"!$ctrl.model.isLoadingCompletedServiceOrder\">\n<thead>\n<tr>\n<th class=\"expand-panel-width\"></th>\n<th>{{'serviceTickets.ticket' | translate}}</th>\n<th ng-click=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ?($ctrl.bucketSort('priority', status.bucket)) : ($ctrl.sortData('priority', status.bucket))\">{{'serviceTickets.priority' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.model.reverseSort]) : ($ctrl.sortOrderData[status.bucket][$ctrl.model.reverseSort]), 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.model.sortColumn] === 'priority'}\"></span>\n</th>\n<th ng-click=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ?($ctrl.bucketSort('locationId', status.bucket)) : ($ctrl.sortData('locationId', status.bucket))\">{{'serviceTickets.location' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.model.reverseSort]) : ($ctrl.sortOrderData[status.bucket][$ctrl.model.reverseSort]), 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.model.sortColumn] === 'locationId'}\"></span>\n</th>\n<th>{{'serviceTickets.status_ASSIGNED' | translate}}</th>\n<th ng-click=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ?($ctrl.bucketSort('status', status.bucket)) : ($ctrl.sortData('status', status.bucket))\">{{'serviceTickets.last_status' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.model.reverseSort]) : ($ctrl.sortOrderData[status.bucket][$ctrl.model.reverseSort]), 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.model.sortColumn] === 'status'}\"></span>\n</th>\n<th>{{'serviceTickets.time_open' | translate}}</th>\n<th ng-if=\"(status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket === 'ASSIGNED')\">{{'serviceTickets.time_to_assign' | translate}}</th>\n<th ng-if=\"status.bucket === 'CANT_COMPLETE_BUCKET'\">{{'serviceTickets.time_to_cant' | translate}}</th>\n<th ng-if=\"status.bucket === 'CANT_COMPLETE_BUCKET'\">{{'serviceTickets.time_from_cant' | translate}} </th>\n<th ng-if=\"status.bucket === 'ON_SITE'\">{{'serviceTickets.time_to_on_site' | translate}}</th>\n<th ng-if=\"status.bucket === 'ON_SITE'\">{{'serviceTickets.time_on_site' | translate}}</th>\n<th ng-if=\"status.bucket === 'ON_ROUTE'\">{{'serviceTickets.time_to_on_route' | translate}}</th>\n<th ng-if=\"status.bucket === 'ON_ROUTE'\">{{'serviceTickets.time_on_route' | translate}}</th>\n<th ng-if=\"status.bucket === 'HOLD'\">{{'serviceTickets.time_to_hold' | translate}}</th>\n<th ng-if=\"status.bucket === 'HOLD'\">{{'serviceTickets.time_on_hold' | translate}}</th>\n<th ng-if=\"status.bucket === 'COMPLETE'\" ng-click=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ?($ctrl.bucketSort('timeToComplete', status.bucket)) : ($ctrl.sortData('timeToComplete', status.bucket))\">{{'serviceTickets.time_to_complete' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.model.reverseSort]) : ($ctrl.sortOrderData[status.bucket][$ctrl.model.reverseSort]), 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.model.sortColumn] === 'timeToComplete'}\"></span>\n</th>\n<th ng-if=\"status.bucket === 'COMPLETE'\" ng-click=\"($ctrl.bucketSort('completedAt', status.bucket))\">{{'branch_mgmt.contact_request.completed_at' | translate}}\n<span class=\"sortorder\" ng-class=\"{\n                                              'reverse': (status.bucket === 'COMPLETE') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.model.reverseSort]): ($ctrl.sortOrderData[status.bucket][$ctrl.model.reverseSort]),\n                                              'active': $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.model.sortColumn] === 'completedAt'\n                                          }\">\n</span>\n</th>\n<th ng-if=\"status.bucket === 'CANCELLED'\">{{'common.cancelled' | translate}} </th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat-start=\"orders in (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? ($ctrl.model.completedServiceTickets[status.bucket].items) : ($ctrl.model.completedServiceTickets[status.bucket].items | orderBy: ($ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.model.sortColumn]):$ctrl.sortOrderData[status.bucket][$ctrl.model.reverseSort]) track by $index\">\n<td class=\"expand-btn-style\">\n<button id=\"expand-btn-{{orders.serviceOrderId}}\" class=\"btn btn-sm btn-secondary\" ng-click=\"orders.expanded = !orders.expanded; $ctrl.loadOrderHistoryData(orders, $event);\" expand>\n<span ng-if=\"orders.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!orders.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</td>\n<td>{{orders.encounterId}}\n<span ng-if=\"orders.externalProcessorId\">\n<label class=\"ex-lbl-section\" for=\"externalProcessorId\">{{'serviceTickets.EX' | translate}}</label>\n</span>\n</td>\n<td>{{orders.priority}}</td>\n<td class=\"service-location-width\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(orders)\">\n{{orders.locationId}}\n</a> |\n<div>{{orders.locationName}}</div>\n</td>\n<td>\n<div>\n<a href=\"#\" ng-click=\"$ctrl.goToRouteTab(orders)\">\n{{orders.routeId}}\n</a>\n</div>\n<div ng-if=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') && orders.userId\">\n<a href=\"#\" ng-click=\"$ctrl.goToUserTab(orders.userId)\">\n| {{orders.userId}}\n</a> {{orders.username}}\n</div>\n</td>\n<td class=\"text-danger\">{{$ctrl.getBucketName(orders.status)}}</td>\n<td>\n<span class=\"open-time-color\" ng-if=\"status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED'\">\n<strong ng-if=\"status.bucket === 'COMPLETE'\">\n{{orders.timeOpen}}\n</strong>\n<strong ng-if=\"status.bucket === 'CANCELLED'\">\n{{orders.timeOpen}}\n</strong>\n</span>\n<span class=\"open-time-color\" ng-if=\"status.bucket === 'UNASSIGNED' || status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket === 'ASSIGNED' ||\n                                                                                                        status.bucket === 'HOLD' || status.bucket === 'CANT_COMPLETE_BUCKET' || status.bucket === 'ON_ROUTE' || status.bucket === 'ON_SITE'\n                                                                                                        || status.bucket === 'UNACCEPTED' ||  status.bucket === 'PENDING_ASSIGN'\">\n<strong>{{orders.timeOpen}}</strong>\n</span>\n</td>\n<td ng-if=\"status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket === 'ASSIGNED' \">\n<div ng-if=\"$ctrl.calculateAssignAndAcceptTime(orders.firstAssignOn, orders.acceptedOn) && (status.bucket == 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket == 'ASSIGNED') && orders.acceptedOn && orders.firstAssignOn\">\n<span class=\"open-time-color\">\n<strong>{{$ctrl.calculateDuration(orders.acceptedOn, orders.firstAssignOn)}}</strong>\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'CANT_COMPLETE_BUCKET'\">\n<div ng-if=\"$ctrl.calculateAssignAndAcceptTime(orders.statusTimeStamp, orders.acceptedOn) && orders.acceptedOn && orders.statusTimeStamp\">\n<span class=\"open-time-color\">\n<strong>{{orders.timeToCant}}</strong>\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'CANT_COMPLETE_BUCKET'\">\n<div ng-if=\"orders.statusTimeStamp\">\n<span class=\"open-time-color\"><strong>{{orders.timeFromCant}}</strong></span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'ON_SITE'\">\n<div ng-if=\"$ctrl.calculateAssignAndAcceptTime(orders.firstOnSiteOn, orders.acceptedOn) && orders.acceptedOn && orders.firstOnSiteOn\">\n<span class=\"open-time-color\">\n<strong>{{$ctrl.calculateDuration(orders.acceptedOn, orders.firstOnSiteOn)}}</strong>\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'ON_SITE'\">\n<div ng-if=\"orders.statusTimeStamp\">\n<span class=\"open-time-color\"><strong>{{orders.timeOnSite}}</strong></span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'ON_ROUTE'\">\n<div ng-if=\"$ctrl.calculateAssignAndAcceptTime(orders.firstOnRouteOn, orders.acceptedOn) && orders.acceptedOn && orders.firstOnRouteOn\">\n<span class=\"open-time-color\">\n<strong>{{$ctrl.calculateDuration(orders.acceptedOn, orders.firstOnRouteOn)}}</strong>\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'ON_ROUTE'\">\n<div ng-if=\"orders.firstOnRouteOn\">\n<span class=\"open-time-color\"><strong>{{orders.timeOnRoute}}</strong></span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'HOLD'\">\n<div ng-if=\"$ctrl.calculateAssignAndAcceptTime(orders.statusTimeStamp, orders.acceptedOn) && orders.acceptedOn && orders.statusTimeStamp\">\n<span class=\"open-time-color\">\n<strong>{{$ctrl.calculateDuration(orders.acceptedOn, orders.statusTimeStamp)}}</strong>\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'HOLD'\">\n<span class=\"open-time-color\">\n<strong>{{orders.timeOnHold}}</strong>\n</span>\n</td>\n<td ng-if=\"status.bucket === 'COMPLETE'\">\n<span class=\"open-time-color\">\n<strong>{{$ctrl.DateUtil.calculateDuration(orders.createdAt, orders.completedAt)}}</strong>\n</span>\n</td>\n<td ng-if=\"status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED'\">\n<span class=\"open-time-color\">\n<strong ng-if=\"status.bucket === 'COMPLETE'\">\n<strong>{{$ctrl.DateUtil.convetToBrowserTimezone(orders.completedAt)}}</strong>\n</strong>\n<strong ng-if=\"status.bucket === 'CANCELLED'\">\n<strong>{{$ctrl.DateUtil.convetToBrowserTimezone(orders.cancelledAt)}}</strong>\n</strong>\n</span>\n</td>\n</tr>\n<tr ng-repeat-end ng-show=\"orders.expanded\">\n<td></td>\n<td colspan=\"8\" ng-if=\"$ctrl.serviceHistory[orders.serviceOrderId].process\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</td>\n<td colspan=\"9\" ng-if=\"!$ctrl.serviceHistory[orders.serviceOrderId].process\">\n<div>\n<table class=\"table table-condensed table-bordered inner-tbl-margin-bottom\">\n<thead>\n<tr class=\"tbl-header-color\">\n<th colspan=\"6\">{{'serviceTickets.service_actions' | translate}}\n<span class=\"badge badge-bg-color\">{{$ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderActionHistory.length}}</span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"text-center\">#</th>\n<th class=\"text-center\">{{'serviceTickets.action' | translate}}</th>\n<th class=\"text-center\">{{'common.status' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.userTime' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.resolve_codes' | translate}}\n</th>\n<th class=\"text-center\">{{'serviceTickets.note' | translate}}</th>\n</tr>\n<tr ng-repeat=\"data in $ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderActionHistory\">\n<td class=\"text-center\">{{$index + 1}}</td>\n<td class=\"text-center\">{{data.actionCode}}</td>\n<td class=\"text-center\">\n<span class=\"text-danger\" ng-if=\"data.completed\">{{'common.completed' | translate}}</span>\n<span class=\"text-danger\" ng-if=\"!data.completed\">{{'common.pending' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.completedByUserId\">{{data.username}} | </span>\n<span ng-if=\"data.completedAt\">{{$ctrl.DateUtil.convetToBrowserTimezone(data.completedAt)}}</span>\n</td>\n<td class=\"text-center\">\n<div ng-repeat=\"resolveCode in data.actionCodeResponse track by $index\">\n<span>\n{{resolveCode}}<span ng-if=\"$index + 1 !== data.actionCodeResponse.length\">,</span>\n</span>\n</div>\n</td>\n<td>\n<span>{{data.serviceOrderActionNote}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"margin-10\">\n<table class=\"table table-condensed table-bordered inner-tbl-margin-bottom\">\n<thead>\n<tr class=\"tbl-header-color\">\n<th colspan=\"6\">{{'serviceTickets.service_order_update_history' | translate}}\n<span class=\"badge badge-bg-color\">\n{{$ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderUpdateHistory.length}}\n</span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"text-center\">#</th>\n<th class=\"text-center\">{{'serviceTickets.update' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.date' | translate}}</th>\n<th class=\"text-center\" ng-if=\"!orders.externalProcessorId\">\n{{'serviceTickets.user' | translate}}</th>\n<th class=\"text-center\" ng-if=\"orders.externalProcessorId\">\n{{'serviceTickets.technician' | translate}}</th>\n<th class=\"text-center\" ng-if=\"orders.externalProcessorId\">\n{{'serviceTickets.external_processor' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.note' | translate}}</th>\n</tr>\n<tr ng-repeat=\"data in $ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderUpdateHistory\">\n<td class=\"text-center\">{{$index + 1}}</td>\n<td class=\"text-danger text-center\">\n{{$ctrl.$translate.instant('serviceTickets.status_' + data.status)}}\n</td>\n<td class=\"text-center\">\n{{$ctrl.DateUtil.convetToBrowserTimezone(data.timestamp)}}</td>\n<td class=\"text-center\">\n<span ng-if=\"data.userId\">\n{{data.userId}} | {{data.userName}}\n<span ng-if=\"data.vehicleId\"> | ({{data.vehicleId}})</span>\n</span>\n<span ng-if=\"!data.userId && !data.externalProcessorId\">{{'serviceTickets.system' | translate}}</span>\n<span ng-if=\"!data.userId && data.externalProcessorId\">{{data.technician}}\n<span ng-if=\"data.vehicleId\"> | ({{data.vehicleId}})</span>\n</span>\n</td>\n<td class=\"text-center\" ng-if=\"data.externalProcessorId\">\n{{data.externalProcessor}}</td>\n<td>\n<span ng-if=\"data.status === 'ACCEPTED'\">{{data.serviceOrderNote}}</span>\n<span ng-if=\"data.status === 'ASSIGNED' || data.status === 'HOLD' || data.status === 'HOLD_PARTS' ||\n                                                                         data.status === 'INCOMPLETED'\">{{data.serviceOrderUserNote}}\n</span>\n<span ng-if=\"data.status === 'ON_ROUTE' || data.status === 'ON_SITE'\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"data.status === 'COMPLETE'\">{{data.serviceOrderActionUserNote}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"margin-10\">\n<table class=\"table table-condensed table-bordered inner-tbl-margin-bottom\">\n<thead>\n<tr class=\"tbl-header-color\">\n<th colspan=\"5\">{{'serviceTickets.supervisor_update' | translate}}\n<span class=\"badge badge-bg-color\">\n{{$ctrl.model.serviceHistoryData[orders.serviceOrderId].details.supervisorUpdateLogs.length}}\n</span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"text-center\">#</th>\n<th class=\"text-center\">{{'common.update' | translate}}</th>\n<th class=\"text-center\">{{'branch_mgmt.performed_by' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.date' | translate}}</th>\n<th class=\"text-center log-details-width-35\">{{'common.details' | translate}}\n</th>\n</tr>\n<tr ng-repeat=\"data in $ctrl.model.serviceHistoryData[orders.serviceOrderId].details.supervisorUpdateLogs\">\n<td class=\"text-center\">{{$index + 1}}</td>\n<td class=\"text-danger text-center\">\n{{$ctrl.$translate.instant('entry_type.' + data.entryType)}}</td>\n<td class=\"text-center\">{{data.performedById}} | {{data.performedByName}}</td>\n<td class=\"text-center\">\n{{$ctrl.DateUtil.convetToBrowserTimezone(data.timestamp)}}</td>\n<td>{{$ctrl.formatJsonObj(data.entryData)}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</td>\n</tr>\n</tbody>\n<tfoot ng-if=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') && ($ctrl.model.completedServiceTickets[status.bucket].totalCount > $ctrl.model.completedServiceTickets[status.bucket].limit)\">\n<tr>\n<td colspan=\"9\" ng-if=\"!$ctrl.model.completedServiceTickets[status.bucket].proces\">\n<ul uib-pagination total-items=\"$ctrl.model.completedServiceTickets[status.bucket].totalCount\" items-per-page=\"$ctrl.model.completedServiceTickets[status.bucket].limit\" ng-hide=\"{{($ctrl.model.completedServiceTickets[status.bucket].totalCount<=$ctrl.model.completedServiceTickets[status.bucket].limit)&&($ctrl.model.completedServiceTickets[status.bucket].page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.completedServiceTickets[status.bucket].page\" ng-change=\"$ctrl.pageChange($ctrl.model.dateRangeOptions, status.bucket)\" rotate=\"false\" max-size=\"10\">\n</ul>\n</td>\n</tr>\n</tfoot>\n</table>\n</div>\n</div>\n</div>\n<div class=\"margin-bottom-20\" ng-if=\"$ctrl.currentStats === 'BillingRule'\">\n<div class=\"row_ margin-top-10\">\n<div class=\"col-sm-12 remove-padding\" ng-if=\"$ctrl.model.fromLocationId\">\n<div class=\"pull-right export-btn-pad-5\" ng-if=\"!$ctrl.model.billingRulesObj.results && $ctrl.billingRulesObj.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportBillingLocations()\">\n{{ 'common.export' | translate }}</button>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.billingRulesObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!$ctrl.billingRulesObj.loading && $ctrl.billingRulesObj.results.length\">\n<div class=\"col-sm-12 remove-padding table-responsive\">\n<table class=\"margin-top-05 table table-hover table-striped table-bordered table-pad-5 font-12\">\n<thead>\n<tr>\n<td class=\"service-date-width remove-white-space\">\n<b>{{'common.select_location_id' | translate}}</b>\n</td>\n<td class=\"service-date-width remove-white-space\">\n<b>{{'contract.contractId' | translate}}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{'location.contract_rule' | translate}}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{'branch_mgmt.billing_approval.rate' | translate}}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{'location.billing_event_type' | translate}}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{'bagout.branch' | translate}}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{'billableEvents.billing_category' | translate}}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{'common.created' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"billingRule in $ctrl.billingRulesObj.results\">\n<td>{{billingRule.id}}</td>\n<td>\n<span class=\"history-link-btn text-info\" ng-click=\"$ctrl.goToContract(billingRule.contractId)\">\n{{billingRule.contractId}}\n</span></td>\n<td>\n{{billingRule.contractRuleId}} | {{billingRule.contractRuleName}}\n</td>\n<td>${{billingRule.rate}}</td>\n<td>\n{{billingRule.billingEventType}}\n</td>\n<td>\n{{billingRule.branch}}\n</td>\n<td>\n{{billingRule.billingCategoryName}}\n</td>\n<td>{{billingRule.createdAt | date : \"yyyy-MM-dd | HH:mm:ss\": 'UTC'}}</td>\n</tr>\n</tbody>\n</table>\n<div class=\"hide-in-print margin-bottom-10\" ng-show=\"$ctrl.billingRulesObj.pagination.total > $ctrl.billingRulesObj.pagination.pageLimit && !$ctrl.billingRulesObj.loading\">\n<ul uib-pagination total-items=\"$ctrl.billingRulesObj.pagination.total\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.billingRulesObj.pagination.page\" ng-change=\"$ctrl.getBillingRules($ctrl.model.dateRangeOptions)\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n</div>\n</div>\n<div class=\"alert alert-danger text-center\" ng-if=\"!$ctrl.billingRulesObj.results.length && !$ctrl.billingRulesObj.loading || !$ctrl.model.fromLocationId\">\n{{'location.no_record_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"margin-bottom-20\" ng-if=\"$ctrl.currentStats === 'BillingHistory'\">\n<div class=\"_row margin-top-10\" ng-if=\"$ctrl.model.fromLocationId\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.billingHistoryObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 remove-right-pad remove-left-pad\" ng-if=\"!$ctrl.model.billingHistoryObj.results && $ctrl.billingHistoryObj.results.length  && !$ctrl.billingHistoryObj.loading\">\n<div class=\"pull-right export-btn-pad-5 row col-sm-12\" ng-if=\"!$ctrl.model.billingHistoryObj.results && $ctrl.billingHistoryObj.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportBillingHistory()\">\n{{ 'common.export' | translate }}</button>\n</div>\n<div class=\"panel-box panel-group list-group recent-activity-block col-sm-12\" id=\"accordion\">\n<div class=\"panel panel-default\" ng-repeat=\"log in $ctrl.billingHistoryObj.results track by log.id\">\n<div class=\"panel-heading cust-panel-color\" data-toggle=\"collapse\" data-target=\"#{{log.id}}\" aria-expanded=\"false\" aria-controls=\"{{log.id}}\" ng-class=\"{ 'log-warning': log.flagged }\">\n<h4 class=\"panel-title cursor-pointer\">\n<a class=\"accordion-toggle\">\n<strong>{{log.readableEntryType + ' '}} </strong> <span ng-if=\"log.userId\">{{'log.by' | translate}}</span> {{' ' + log.user.firstName + ' ' + log.user.lastName + ' '}}\n<span ng-if=\"log.message\"> | <span class=\"message-color\">{{log.message}}</span></span>\n<span class=\"pull-right\">{{log.createdAt | date: 'short'}}</span>\n</a>\n</h4>\n</div>\n<div id=\"{{log.id}}\" class=\"panel-collapse collapse multi-collapse\">\n<div class=\"panel-body\">\n<table class=\"table table-bordered table-striped remove-pad-bottom\">\n<tr ng-repeat=\"detail in log.extraDetails\">\n<td>{{detail.key}}</td>\n<td class=\"wrap-text\">\n<span ng-if=\"(detail.key !== 'pickupImageName' && detail.key !== 'deliveryImageName')\">{{detail.value}}</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value !=='null') || (detail.key === 'deliveryImageName' && detail.value !=='null')\">Captured</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value =='null') || (detail.key === 'deliveryImageName' && detail.value =='null')\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value !=='null') || (detail.key === 'deliveryImageName' && detail.value !=='null')\">\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showShipmentReceipt(log.extraDetails, detail.key == 'pickupImageName' ? 'pickup': 'delivery')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"hide-in-print margin-bottom-10 padding-left-10\" ng-show=\"$ctrl.billingHistoryObj.pagination.total > $ctrl.billingHistoryObj.pagination.pageLimit && !$ctrl.billingHistoryObj.loading\">\n<ul uib-pagination total-items=\"$ctrl.billingHistoryObj.pagination.total\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.billingHistoryObj.pagination.page\" ng-change=\"$ctrl.getBillingHistory($ctrl.model.dateRangeOptions)\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div class=\"alert alert-danger text-center\" ng-if=\"!$ctrl.billingHistoryObj.results.length && !$ctrl.billingHistoryObj.loading || !$ctrl.model.fromLocationId\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n<div class=\"table-responsive col-sm-12 remove-padding\" ng-if=\"$ctrl.model.fromLocationId && $ctrl.currentStats === 'ServiceHistory' && $ctrl.transactionHistoryObj.isNopuTransactionHistory\">\n<div class=\"col-sm-12 hide-in-print remove-padding\">\n<div class=\"remove-pad col-sm-12 margin-bottom-10\">\n<div class=\"pull-left font-size-20\">\n<strong>{{'branch_mgmt.nopu_service_history' | translate}}</strong>\n</div>\n<div class=\"pull-right\" ng-if=\"!$ctrl.transactionHistoryObj.loading && $ctrl.transactionHistoryObj.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.print('noPickupHistory')\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{ 'branch_mgmt.itemHistory.print' | translate }}</button>\n</div>\n<div class=\"pull-right export-btn-pad-5\" ng-if=\"!$ctrl.transactionHistoryObj.loading && $ctrl.transactionHistoryObj.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportNoPickupTransactionHistory()\" ng-disabled=\"$ctrl.transactionHistoryObj.isExporting\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.transactionHistoryObj.isExporting\"></span>\n{{ 'common.export' | translate }}</button>\n</div>\n</div>\n<div class=\"margin-bottom-10 text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.transactionHistoryObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"!$ctrl.transactionHistoryObj.loading && $ctrl.transactionHistoryObj.results.length\">\n<table class=\"table table-hover table-bordered table-pad-5 font-12 margin-10\">\n<thead>\n<tr>\n<th class=\"remove-white-space\"><b>{{'branch_mgmt.tankers.transactionDate' | translate}}</b></th>\n<th><b>{{'checkout.transactionType' | translate}}</b></th>\n<th class=\"remove-white-space\"><b>{{'bagout.trackingId' | translate}}</b></th>\n<th><b>{{'checkout.fromLocationName' | translate }}</b></th>\n<td ng-click=\"$ctrl.sortNoPickupServiceHistoryData('routeId', $event)\">\n<b>{{'dashboard.routeId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.noPickupServiceHistoryObj.reverseSort, 'active' : $ctrl.model.noPickupServiceHistoryObj.sortColumn === 'routeId'}\"></span>\n</td>\n<th><b>{{'branch_mgmt.performed_by' | translate}}</b></th>\n<th><b>{{'verifyHoldShipments.comment' | translate}}</b></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"transaction in $ctrl.transactionHistoryObj.results\">\n<td class=\"wd-09 remove-white-space\">\n{{$ctrl.DateUtil.convertDateTime(transaction.transactionDate, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}\n</td>\n<td class=\"text-danger\">{{'shipment.NO_PICKUP' | translate}}</td>\n<td>{{transaction.trackingId}} </td>\n<td>{{transaction.fromLocation.id}} | {{transaction.fromLocation.name}}</td>\n<td>\n{{transaction.route.id}}</td>\n<td>\n<span ng-if=\"transaction.performedBy\">{{transaction.performedBy.id}} | {{transaction.performedBy.firstName}} {{transaction.performedBy.lastName}}</span>\n<span ng-if=\"!transaction.performedBy\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{transaction.comments}}\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(transaction, 'pickup')\" ng-if=\"(transaction.tranType === 'RESIDUAL' || transaction.tranType === 'PICKUP') && transaction.pickupImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 align-center-horizontally row_ hide-in-print remove-pad\" ng-if=\"!$ctrl.transactionHistoryObj.loading && !$ctrl.transactionHistoryObj.results.length && $ctrl.model.fromLocationId\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.records}\" style=\"text-align: center; width:100%\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<div class=\"row _col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.transactionHistoryObj.pagination.total > 10 && !$ctrl.transactionHistoryObj.loading\">\n<ul uib-pagination total-items=\"$ctrl.transactionHistoryObj.pagination.total\" ng-hide=\"{{($ctrl.transactionHistoryObj.pagination.total<=$ctrl.transactionHistoryObj.pagination.pageLimit)&&\n                           ($ctrl.transactionHistoryObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.transactionHistoryObj.pagination.page\" ng-change=\"$ctrl.getNextNopuRecords()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n</div>\n";
var id1="locations.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2690 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"tab-content\">\n<div class=\"margin-top-10\" ng-if=\"$ctrl.currentStats === 'ServiceHistory'\">\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"!$ctrl.loading && $ctrl.serviceHistory.results.length\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10\">\n<div class=\"col-sm-8 col-print-8 remove-left-pad service-history-print-title-section\">\n<div>\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<div class=\"margin-top-20 font-size-20\">\n<strong>{{ 'branch_mgmt.servicehistory.title' | translate }}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.vaultDate}}</span>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4 remove-right-pad\">\n<div class=\"pull-right margin-top-20 font-size-20\">\n<span><strong>{{$ctrl.serviceHistory.locationId}} | {{$ctrl.serviceHistory.locationName}}</strong></span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding\">\n<table class=\"table table-hover table-striped table-bordered table-pad-7\">\n<thead>\n<tr>\n<td class=\"item-date-width-10\">\n<b>{{ 'branch_mgmt.servicehistory.service_date' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.servicehistory.order_no' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.servicehistory.order_type' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.servicehistory.load_tracking_id' | translate}}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.servicehistory.residual_tracking_id' | translate}}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.servicehistory.route_id' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.servicehistory.delivered_loaded' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.servicehistory.pickup_residual' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.servicehistory.counted_variance' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"serviceHistory in $ctrl.serviceHistory.results\">\n<td>{{serviceHistory.serviceDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td>{{serviceHistory.orderNo}}</td>\n<td class=\"text-danger text-center\">\n<div>\n<span ng-repeat=\"denom in serviceHistory.denominations\">\n<img ng-src=\"assets/images/{{denom.denominationId}}.png\" alt=\"{{denom.denominationId}}\" class=\"denom-icon\"/>\n</span>\n</div>\n<div>{{$ctrl.getOrderType(serviceHistory.orderType)}}</div>\n</td>\n<td>\n<span ng-if=\"!serviceHistory.loadTrackingId\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"serviceHistory.loadTrackingId\">{{serviceHistory.loadTrackingId}}</span>\n</td>\n<td>\n<span ng-if=\"serviceHistory.residualTrackingId\">{{serviceHistory.residualTrackingId}}</span>\n<span ng-if=\"!serviceHistory.residualTrackingId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{serviceHistory.routeId}}</td>\n<td>\n<span ng-if=\"!serviceHistory.finishedAt\">{{serviceHistory.parentLoadShipmentDetails.loadedAmount > 0 ? serviceHistory.parentLoadShipmentDetails.loadedAmount : serviceHistory.deliveryAmount | currency:\"$\"}}</span>\n<span ng-if=\"serviceHistory.finishedAt\">{{serviceHistory.loadedAmount | currency:\"$\"}}</span>\n</td>\n<td>\n<span ng-if=\"serviceHistory.residualTrackingId\">\n<span ng-if=\"serviceHistory.parentResidualShipmentDetails.checkedIn && serviceHistory.finishedAt\">\n{{serviceHistory.residualAmount | currency:\"$\"}}\n</span>\n<span ng-if=\"!serviceHistory.finishedAt\">\n{{serviceHistory.parentResidualShipmentDetails.shipmentAmount | currency:\"$\"}}\n</span>\n</span>\n<span ng-if=\"!serviceHistory.residualTrackingId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{serviceHistory.amountCRV | currency:\"$\"}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"margin-top-10\" ng-if=\"$ctrl.currentStats === 'ItemHistory'\">\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"!$ctrl.loading && $ctrl.itemHistory.results.length\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10\">\n<div class=\"col-sm-8 col-print-8 remove-left-pad service-history-print-title-section\">\n<div>\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<div class=\"margin-top-20 font-size-20\">\n<strong>{{ 'branch_mgmt.itemhistory.title' | translate }}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.vaultDate}}</span>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4 remove-right-pad\">\n<div class=\"pull-right margin-top-20 font-size-20\">\n<span><strong>{{$ctrl.itemhistory.locationId}} | {{$ctrl.itemhistory.locationName}}</strong></span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding\">\n<table class=\"table table-hover table-striped table-bordered table-pad-7\">\n<thead>\n<tr>\n<td>\n<b>{{ 'routeSheet.date' | translate }}</b>\n</td>\n<td>\n<b>{{ 'itemHolds.item' | translate }}</b>\n</td>\n<td>\n<b>{{ 'common.action' | translate }}</b>\n</td>\n<td>\n<b>{{ 'routeSheet.route' | translate }}</b>\n</td>\n<td>\n<b>{{ 'message.type' | translate }}</b>\n</td>\n<td>\n<b>{{ 'checkin.amount' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.itemHistoryQty' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.itemActivity.title' | translate}}</b>\n</td>\n<td class=\"remove-white-space\">\n<b>{{'branch_mgmt.itemHistoryPrId' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.itemHistoryComment' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"itemHistory in $ctrl.itemHistory.results\">\n<td class=\"remove-white-space\">{{itemHistory.transactionDate | date : \"MM-dd-yyyy | hh:mm a\"}}</td>\n<td> {{itemHistory.trackingId}}</td>\n<td class=\"text-danger\">{{itemHistory.tranType}}</td>\n<td>{{itemHistory.routeId}} | {{itemHistory.routeName}}</td>\n<td>{{itemHistory.shipType}}</td>\n<td>{{itemHistory.amount | currency:\"$\"}}</td>\n<td>{{itemHistory.qty}}</td>\n<td ng-if=\"itemHistory.action\" ng-class=\"{'text-danger': itemHistory.action}\">{{itemHistory.action | translate}}</td>\n<td ng-if=\"!itemHistory.action\">{{ 'branch_mgmt.itemHistory.n_a' | translate }}</td>\n<td>{{itemHistory.userId}} | {{itemHistory.firstName}} {{itemHistory.lastName}}</td>\n<td>{{itemHistory.comments}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"margin-top-10\" ng-if=\"$ctrl.currentStats === 'BagoutHistory'\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"$ctrl.bagOutData.length && !$ctrl.loading\">\n<div class=\"col-sm-12 remove-padding\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10\">\n<div class=\"col-sm-8 col-print-8 remove-left-pad service-history-print-title-section\">\n<div>\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<div class=\"margin-top-20 font-size-20\">\n<strong>{{ 'branch_mgmt.bagout_title' | translate }}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.vaultDate}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding\">\n<table class=\"table table-hover table-striped table-bordered\">\n<thead>\n<tr>\n<td>\n<b>{{ 'branch_mgmt.bagout_Id' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.tracking_Id' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.destinations' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.bagout_status' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.date_time' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"bagOutDetails in $ctrl.bagOutData\">\n<td>{{ bagOutDetails.bagSeal }}</td>\n<td ng-if=\"bagOutDetails.trackingId\">{{ bagOutDetails.trackingId }}</td>\n<td ng-if=\"!bagOutDetails.trackingId\">{{ 'common.n_a' | translate }}</td>\n<td>{{ bagOutDetails.shipmentToLocationId }} | {{ bagOutDetails.toLocationName}}</td>\n<td ng-if=\"bagOutDetails.closed\">{{ 'branch_mgmt.bagout_closed' | translate }}</td>\n<td ng-if=\"!bagOutDetails.closed\">{{ 'branch_mgmt.bagout_not_closed' | translate }}</td>\n<td>{{ bagOutDetails.createdAt | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-10 remove-padding\" ng-if=\"$ctrl.currentStats === 'deliveryServiceHistory'\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-print-12 col-sm-12 remove-padding\" ng-if=\"$ctrl.deliveryServiceHistoryData.results.length && !$ctrl.loading\">\n<div class=\"col-print-12 col-sm-12 remove-padding\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10\">\n<div class=\"col-sm-9 col-print-9 remove-left-pad service-history-print-title-section\">\n<div>\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<div class=\"margin-top-20 font-size-20\">\n<strong>{{ 'branch_mgmt.delivery_service_history' | translate }}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.vaultDate}}</span>\n</div>\n</div>\n<div class=\"col-sm-3 col-print-3 remove-right-pad\">\n<div class=\"pull-right margin-top-20 font-size-20\">\n<strong>{{$ctrl.deliveryServiceHistoryData.locationId}}</strong>\n| {{$ctrl.deliveryServiceHistoryData.locationName}}\n</div>\n</div>\n</div>\n<div class=\"remove-padding table-responsive col-sm-12 col-print-12 margin-10\">\n<table class=\"table table-hover table-striped table-bordered table-pad-7 font-12\">\n<thead>\n<tr>\n<th><b>{{ 'branch_mgmt.servicehistory.service_date' | translate }}</b></th>\n<th><b>{{'routeThrow.deliveryDate' | translate }}</b></th>\n<th><b>{{'bagout.trackingId' | translate}}</b></th>\n<th><b>{{'branch_mgmt.servicehistory.route_id' | translate }}</b></th>\n<th><b>{{'shiptype.shiptype' | translate}}</b></th>\n<th><b>{{'addBagModal.amount' | translate}}</b></th>\n<th><b>{{'master_cash_schedule.denoms' | translate}}</b></th>\n<th><b>{{ 'bagout.fromLocation' | translate }}</b></th>\n<th><b>{{'bagout.status' | translate}}</b></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"deliveyServiceHistory in $ctrl.deliveryServiceHistoryData.results\">\n<td>{{deliveyServiceHistory.serviceDate | date : \"yyyy-MM-dd\": 'UTC'}}</td>\n<td>\n<span ng-if=\"deliveyServiceHistory.deliveryDate\">\n{{$ctrl.DateUtil.convertDateTime(deliveyServiceHistory.deliveryDate, $ctrl.timezone, 'MM-DD-YYYY | hh:mm a')}}\n</span>\n<span ng-if=\"!deliveyServiceHistory.deliveryDate\">{{'branch_mgmt.routes.bucket_PENDING' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"deliveyServiceHistory.trackingId\">{{deliveyServiceHistory.trackingId}}</span>\n<span ng-if=\"!deliveyServiceHistory.trackingId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{deliveyServiceHistory.routeId}}</td>\n<td>{{deliveyServiceHistory.shiptypeId}} | {{deliveyServiceHistory.description}}</td>\n<td>\n<span ng-if=\"$ctrl.locationDetails.locationType === 'ATM'\">\n<span ng-if=\"$ctrl.setAmount(deliveyServiceHistory)\">{{$ctrl.setAmount(deliveyServiceHistory)}}</span>\n<span ng-if=\"!$ctrl.setAmount(deliveyServiceHistory)\">{{'common.n_a' | translate}}</span>\n</span>\n<span ng-if=\"$ctrl.locationDetails.locationType !== 'ATM'\">{{deliveyServiceHistory.formattedAmount}}</span>\n</td>\n<td>\n<div class=\"d-flex\">\n<div ng-repeat=\"denom in deliveyServiceHistory.denomArr track by $index\">\n<img ng-if=\"deliveyServiceHistory.denomArr.length\" ng-src=\"assets/images/{{denom}}.png\" class=\"denom-image\" alt=\"{{ denom }}\" style=\"width:30px\"/>\n</div>\n<span ng-if=\"!deliveyServiceHistory.denomArr.length\">{{ 'branch_mgmt.itemHistory.n_a' | translate }}</span>\n</div>\n</td>\n<td>\n<span ng-if=\"deliveyServiceHistory.fromLocationId\">{{deliveyServiceHistory.fromLocationId}} | {{deliveyServiceHistory.fromLocationName}}</span>\n<span ng-if=\"!deliveyServiceHistory.fromLocationId\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-danger\">{{$ctrl.translateItemStatus(deliveyServiceHistory.status)}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-10 remove-padding\" ng-if=\"$ctrl.currentStats === 'pickupServiceHistory'\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"$ctrl.pickupServiceHistoryData.results.length && !$ctrl.loading\">\n<div class=\"col-sm-12 remove-padding\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10\">\n<div class=\"col-sm-8 col-print-8 remove-left-pad service-history-print-title-section\">\n<div>\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<div class=\"margin-top-20 font-size-20\">\n<strong>{{ 'branch_mgmt.pickup_service_history' | translate }}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.vaultDate}}</span>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4 remove-right-pad\">\n<div class=\"pull-right margin-top-20 font-size-20\">\n<strong>{{$ctrl.pickupServiceHistoryData.locationId}}</strong>\n| {{$ctrl.pickupServiceHistoryData.locationName}}\n</div>\n</div>\n</div>\n<div class=\"remove-padding table-responsive col-sm-12 col-print-12 margin-10\">\n<table class=\"table table-hover table-striped table-bordered table-pad-7 font-12\">\n<thead>\n<tr>\n<th><b>{{ 'branch_mgmt.servicehistory.service_date' | translate }}</b></th>\n<th><b>{{'shipmentBatch.pickupDate' | translate }}</b></th>\n<th><b>{{'bagout.trackingId' | translate}}</b></th>\n<th><b>{{'branch_mgmt.servicehistory.route_id' | translate }}</b></th>\n<th><b>{{'shiptype.shiptype' | translate}}</b></th>\n<th><b>{{'addBagModal.amount' | translate}}</b></th>\n<th><b>{{'checkout.ToLocationName' | translate }}</b></th>\n<th><b>{{'bagout.status' | translate}}</b></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"pickupServiceHistory in $ctrl.pickupServiceHistoryData.results\">\n<td>{{pickupServiceHistory.serviceDate}}</td>\n<td>\n<span ng-if=\"pickupServiceHistory.pickupDate\">{{pickupServiceHistory.pickupDate}}</span>\n<span ng-if=\"!pickupServiceHistory.pickupDate\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{pickupServiceHistory.trackingId}}</td>\n<td>{{pickupServiceHistory.routeId}}</td>\n<td>{{pickupServiceHistory.shiptypeId}} | {{pickupServiceHistory.description}}</td>\n<td>\n<span ng-if=\"!['DEPOSIT', 'BULKCASH'].includes(pickupServiceHistory.shiptypeId) || !pickupServiceHistory.isVariance\">\n{{pickupServiceHistory.formattedAmount}}\n</span>\n<span ng-if=\"['DEPOSIT', 'BULKCASH'].includes(pickupServiceHistory.shiptypeId) && pickupServiceHistory && pickupServiceHistory.isVariance\">\n{{pickupServiceHistory[$ctrl.selectedDepositAmountValue] | currency:\"$\" }}\n</span>\n</td>\n\n<td>\n<span>{{pickupServiceHistory.toLocationId}} | {{pickupServiceHistory.toLocationName}}</span>\n</td>\n<td class=\"text-danger\">{{$ctrl.translateItemStatus(pickupServiceHistory.status)}}\n<span ng-if=\"pickupServiceHistory.countCompletedAt\">({{pickupServiceHistory.vaultDate | date : 'yyyy-MM-dd' : 'UTC'}})</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-10 remove-padding\" ng-if=\"$ctrl.currentStats === 'noPickupHistory'\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10\">\n<div class=\"col-sm-8 col-print-8 remove-left-pad service-history-print-title-section\">\n<div>\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<div class=\"margin-top-20 font-size-20\">\n<strong>{{ 'branch_mgmt.nopu_service_history' | translate }}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.vaultDate}}</span>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4 remove-right-pad\">\n<div class=\"pull-right margin-top-20 font-size-20\">\n<strong>{{$ctrl.noPickupServiceHistoryData.locationId}}</strong>\n| {{$ctrl.noPickupServiceHistoryData.locationName}}\n</div>\n</div>\n</div>\n<table class=\"table table-hover table-bordered table-pad-7 font-12 margin-10\">\n<thead>\n<tr>\n<th class=\"remove-white-space\"><b>{{'branch_mgmt.tankers.transactionDate' | translate}}</b></th>\n<th><b>{{'checkout.transactionType' | translate}}</b></th>\n<th><b>{{'bagout.trackingId' | translate}}</b></th>\n<th><b>{{'checkout.fromLocationName' | translate }}</b></th>\n<th><b>{{'dashboard.routeId' | translate}}</b></th>\n<th><b>{{'branch_mgmt.performed_by' | translate}}</b></th>\n<th><b>{{'verifyHoldShipments.comment' | translate}}</b></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"transaction in $ctrl.noPickupServiceHistoryData.results\">\n<td class=\"wd-09 remove-white-space\">{{transaction.transactionDate}}</td>\n<td class=\"text-danger\">{{'shipment.NO_PICKUP' | translate}}</td>\n<td>{{transaction.trackingId}} </td>\n<td>{{transaction.fromLocationId}} | {{transaction.fromLocationName}}</td>\n<td>{{transaction.routeId}}</td><td>\n<span ng-if=\"transaction.user\">{{transaction.user}}</span>\n<span ng-if=\"!transaction.user\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{transaction.comments}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n";
var id1="location-print.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2691 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-padding\">\n<div class=\"_lock-open-error-filter-section\">\n<div class=\"remove-left-pad col-sm-3 _lock-open-error-filter-dd-w-100\">\n<div class=\"multi-select lock-open-error-branch-search-dd valid-multi-select-value\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.branchObj.results\" output-model=\"$ctrl.model.branch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" selection-mode=\"multiple\" on-item-click=\"$ctrl.loadData();\" on-reset=\"$ctrl.resetBranchSelection(); $ctrl.loadData();\" on-select-all=\"$ctrl.loadData();\" on-select-none=\"$ctrl.loadData();\">\n</div>\n</div>\n<div class=\"col-sm-3 _lock-open-error-filter-dd-w-100\">\n<search-and-select ng-model=\"$ctrl.model.lockType\" values=\"$ctrl.model.lockTypeObj.results\" key=\"Key\" on-click=\"\" totalrecords=\"$ctrl.model.lockTypeObj.totalRecords\" none-selected=\"'location.lockType'\" common-search-flag=\"true\">\n</search-and-select>\n</div>\n<div class=\"col-sm-3 _lock-open-error-filter-dd-w-100\">\n<search-and-select ng-model=\"$ctrl.model.locationId\" values=\"$ctrl.model.locationIdObj.results\" key=\"Key\" on-click=\"\" totalrecords=\"$ctrl.model.locationIdObj.totalRecords\" none-selected=\"'common.select_location_id'\" common-search-flag=\"true\">\n</search-and-select>\n</div>\n<div class=\"remove-right-pad col-sm-3 _lock-open-error-filter-dd-w-100\">\n<search-and-select ng-model=\"$ctrl.model.error\" values=\"$ctrl.model.ErrorObj.results\" key=\"Key\" on-click=\"\" totalrecords=\"$ctrl.model.ErrorObj.totalRecords\" none-selected=\"'common.error'\" common-search-flag=\"true\">\n</search-and-select>\n</div>\n</div>\n<div class=\"form-group remove-left-pad col-sm-12 margin-10\">\n<div class=\"remove-left-pad col-sm-3\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOption\" ng-change=\"$ctrl.getATMCodes();\" options=\"$ctrl.model.dateRangPickerOptionsfor\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" placeholder=\"{{'common.select_date' | translate}}\"/>\n</div>\n<div class=\"ml-5 col-sm-1\">\n<button type=\"button\" class=\"btn btn-md btn-primary\" ng-click=\"$ctrl.resetData(); $ctrl.getATMCodes();\" ng-disabled=\"$ctrl.model.loading || $ctrl.model.isExporting\">\n{{'common.reset' | translate}}\n</button>\n</div>\n<div class=\"col-sm-1\">\n<button type=\"button\" class=\"btn btn-md btn-primary\" ng-click=\"$ctrl.exportData();\" ng-disabled=\"$ctrl.model.loading || $ctrl.model.isExporting || !$ctrl.model.atmCodeList.length\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExporting\"></span>\n{{'common.export' | translate}}\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"row remove-padding table-responsive\">\n<table class=\"table table-hover table-bordered table-padding-5 font-12\" ng-if=\"$ctrl.model.atmCodeList.length && !$ctrl.model.loading\">\n<thead>\n<tr>\n<td><b>{{'common.branch_id' | translate}}</b></td>\n<td><b>{{'common.locationId' | translate}}</b></td>\n<td><b>{{'location.lockType' | translate}}</b></td>\n<td><b>{{'serviceTickets.serialNumber' | translate}}</b></td>\n<td><b>{{'route.route' | translate}} | {{'closeVault.currentVaultDate' | translate}}</b></td>\n<td><b>{{'branch_mgmt.performed_by' | translate}}</b></td>\n<td><b>{{'branch_mgmt.lock_open_errors.otc_company' | translate}}</b></td>\n<td><b>{{'common.error' | translate}}</b></td>\n<td><b>{{'common.action' | translate}}</b></td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"atmCode in $ctrl.model.atmCodeList | filter: $ctrl.filterRecords(); track by $index\">\n<td>{{atmCode.branchId}}</td>\n<td>\n<span ng-if=\"atmCode.originLockId\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(atmCode.originLockId)\">{{atmCode.originLockId}}</a>\n</span>\n<span ng-if=\"!atmCode.originLockId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"atmCode.lockType\">{{atmCode.lockType}}</span>\n<span ng-if=\"!atmCode.lockType\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{atmCode.locationId}}</td>\n<td>{{atmCode.routeId}} | {{atmCode.vaultDate | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToUserTab(atmCode.performedById)\">{{atmCode.performedById}}</a>\n</td>\n<td>\n<span ng-if=\"atmCode.OTCCompanyName\">{{$ctrl.translateOTCCompanyName(atmCode.OTCCompanyName)}}</span>\n<span ng-if=\"!atmCode.OTCCompanyName\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{$ctrl.AtmCodesManagementService.removeCharacter(atmCode.message)}}</td>\n<td>\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.fixAtmCode(atmCode)\">\n{{'common.fixed' | translate}}\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"!$ctrl.model.atmCodeList.length && !$ctrl.model.loading\">\n<div class=\"row alert text-center alert-danger\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</form>";
var id1="lock_open_errors.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2692 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="";
var id1="mileage_report.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2693 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row_\">\n<div class=\"col-sm-12 form-validate remove-padding\" novalidate>\n<div class=\"col-sm-12 align-center-horizontally\">\n<div class=\"col-sm-7\">\n<input ng-change=\"$ctrl.search()\" type=\"text\" ng-model-options=\"{debounce: 1000}\" placeholder=\"{{ 'branch_mgmt.monthly_report.search' | translate }}\" class=\"input-lg form-control\" ng-model=\"$ctrl.model.search\" search-autofocus>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-offset-4 col-sm-4\">\n<div class=\"col-sm-offset-2 col-sm-8 padding-zero\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRange\" ng-change=\"$ctrl.generateReport($ctrl.model.dateRange)\" ng-if=\"$ctrl.model.dateRange.startDate\" options=\"$ctrl.model.dateRangPickerOptions\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row pull-right unset-pad margin-top-20\" ng-if=\"!$ctrl.model.loading && $ctrl.model.monthlyReport.length\">\n<button class=\"btn btn-warning\" ng-click=\"$ctrl.exportToCSV()\" ng-disabled=\"$ctrl.loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'branch_mgmt.monthly_report.export_to_csv'| translate}}\n</button>\n</div>\n<div class=\"row\" ng-if=\"!$ctrl.model.loading && $ctrl.model.monthlyReport.length\">\n<div class=\"col-sm-12 table-margin-top-10 remove-padding table-responsive\">\n<table class=\"table table-hover table-striped table-bordered font-12\">\n<thead>\n<tr>\n<td class=\"created-date-width\" ng-click=\"$ctrl.SortData('vaultDate')\">{{'branch_mgmt.monthly_report.createdAt' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'vaultDate'}\"></span>\n</td>\n<td class=\"remove-white-space\" ng-click=\"$ctrl.SortData('trackingId')\">{{'branch_mgmt.monthly_report.trackingId' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'trackingId'}\"></span>\n</td>\n<td ng-click=\"$ctrl.SortData('amount')\">{{'branch_mgmt.monthly_report.amount' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amount'}\"></span>\n</td>\n<td ng-click=\"$ctrl.SortData('fromLocationId')\">{{'branch_mgmt.monthly_report.fromLoc' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'fromLocationId'}\"></span>\n</td>\n<td ng-click=\"$ctrl.SortData('toLocationId')\">{{'branch_mgmt.monthly_report.toLoc' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'toLocationId'}\"></span>\n</td>\n</tr></thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.monthlyReport | orderBy:$ctrl.sortColumn:$ctrl.reverseSort\">\n<td>{{data.vaultDate | date : 'MM-dd-yyyy'}}</td>\n<td>{{data.trackingId}}</td>\n<td>{{data.amount | currency: '$'}}</td>\n<td>\n<span>{{data.fromLocationId}} | {{data.fromLocationName}}</span>\n<span ng-if=\"data.fromLocationAddress\">| {{data.fromLocationAddress}}</span>\n<span ng-if=\"data.fromLocationCity\">| {{data.fromLocationCity}}</span>\n</td>\n<td>\n<span>{{data.toLocationId}} | {{data.toLocationName}}</span>\n<span ng-if=\"data.toLocationAddress\">| {{data.toLocationAddress}}</span>\n<span ng-if=\"data.toLocationCity\">| {{data.toLocationCity}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"row col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.pagination.total > 10\">\n<ul uib-pagination total-items=\"$ctrl.pagination.total\" ng-hide=\"{{($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.loading && (!$ctrl.model.monthlyReport || !$ctrl.model.monthlyReport.length)\" class=\"col-sm-12 margin-top-20\">\n<div class=\"col-sm-12 alert alert-danger text-align-center\">\n{{'route_sheet.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="monthly_report.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2694 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"row_ col-sm-12\">\n<div class=\"col-sm-12 font-size-20 text-center\">\n<b>{{'branch_mgmt.orders_history' | translate}}</b>\n<hr>\n</div>\n<div class=\"col-sm-12 order-history-center-section\">\n<div class=\"col-md-3 col-sm-4\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" ng-change=\"$ctrl.loadData()\" options=\"$ctrl.model.dateRange\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"col-md-3 col-sm-4\">\n<search-and-select class=\"funding-source-dd-height\" ng-model=\"$ctrl.model.fundingSource\" values=\"$ctrl.locationLists\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" onscroll=\"$ctrl.getFundingSource(searchKey, offset)\" none-selected=\"'branch_mgmt.orders_selectATMs'\" on-click=\"$ctrl.clearSearch(); $ctrl.loadData();\" required></search-and-select>\n</div>\n<div class=\"col-md-3 col-sm-4\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.currencyFilter\" ng-change=\"$ctrl.loadData()\" ng-options=\"opt.id as opt.name for opt in $ctrl.currencyOptions\">\n<option value=\"ALL\">{{'common.all' | translate}}</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 btn-group z-index0 align-center margin-top-10\" style=\"display: flex;\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-default ignore-validation-css tab-btn-width\" ng-click=\"$ctrl.tabSelection('inProcess');\" ng-class=\"{'btn-success': $ctrl.model.stats.includes($ctrl.stats.inProcess)}\">\n{{ 'common.inProcess' | translate }}\n</button>\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-default ignore-validation-css tab-btn-width\" ng-click=\"$ctrl.tabSelection('completed');\" ng-class=\"{'btn-success': $ctrl.model.stats.includes($ctrl.stats.completed)}\">\n{{ 'common.completed' | translate }}\n</button>\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-default ignore-validation-css tab-btn-width\" ng-click=\"$ctrl.tabSelection('pending');\" ng-class=\"{'btn-success': $ctrl.model.stats.includes($ctrl.stats.pending)}\">\n{{ 'common.pending' | translate }}\n</button>\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-default ignore-validation-css tab-btn-width\" ng-click=\"$ctrl.tabSelection('errors');\" ng-class=\"{'btn-success': $ctrl.model.stats.includes($ctrl.stats.errors)}\">\n{{ 'common.errors' | translate }}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 text-center remove-pad order-d-flex\">\n<div class=\"w-60 order-w-46 margin-top-10\" ng-if=\"$ctrl.model.fundingSource\">\n<input ng-change=\"$ctrl.loadData()\" type=\"text\" ng-model-options=\"{debounce: 1000}\" placeholder=\"{{ 'branch_mgmt.orders_search' | translate }}\" class=\"input-lg form-control\" ng-model=\"$ctrl.model.search\" ng-disabled=\"$ctrl.loading\" search-autofocus>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 orders-no-data-container\" ng-if=\"!$ctrl.model.fundingSource\">\n<div class=\"alert alert-danger text-center margin-top-10\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n<div ng-repeat=\"stat in $ctrl.model.stats\" ng-if=\"$ctrl.model.fundingSource\">\n<div ng-if=\"stat === $ctrl.stats.errors\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row_ orders-section\" ng-if=\"!$ctrl.model.loading\">\n<div class=\"col-sm-12 margin-bottom-10 margin-top-10 order-section-header\">\n<div class=\"text-danger font-size-20\">\n<strong>{{'branch_mgmt.orders.shp_req_err' | translate}}</strong>\n</div>\n<div class=\"pull-right\" ng-if=\"$ctrl.errorShipments.length && $ctrl.hasACL['branch_mgmt_orders']['export_print']\">\n<button type=\"button\" class=\"btn btn-success margin-right-5\" ng-click=\"$ctrl.exportToCSV($ctrl.stats.errors)\" ng-disabled=\"$ctrl.exportLoading[$ctrl.stats.errors]\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.exportLoading[$ctrl.stats.errors]\"></span> Export\n</button>\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.print($ctrl.stats.errors)\">Print</button>\n</div>\n</div>\n<div ng-if=\"$ctrl.errorShipments.length\" class=\"table-responsive w-100\">\n<table class=\"table table-hover table-pad-4 table-responsive table-striped table-bordered margin-top-40_ font-12\">\n<thead>\n<tr>\n<td class=\"text-center residual-denom-width\">\n<b>{{'branch_mgmt.orders_denomination' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.orders_no' | translate}}</b>\n</td>\n<td class=\"col-width-10 text-center\">\n<b>{{'branch_mgmt.orders_date' | translate}}</b>\n</td>\n<td class=\"col-width-10 text-center\">\n<b>{{'branch_mgmt.orders_requestLoad' | translate}}</b>\n</td>\n<td class=\"text-center col-width-20\">\n<b>{{ 'branch_mgmt.item_to.title' | translate }}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.orders_error_msg' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{ 'common.user' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.errorShipments track by $index\">\n<td class=\"text-center col-width-10\">\n<denom-icon denom-id=\"data.denom1\" icon-size=\"30\"> </denom-icon>\n</td>\n<td class=\"text-center\">{{data.orderNo}}</td>\n<td class=\"order-date-width text-center\">{{ data.orderDate | date: 'yyyy-MM-dd'}}</td>\n<td class=\"text-center\">{{data.denomAmount1 | currency:fractionSize:0}}</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.tid)\">\n{{data.tid}}\n</a> | {{data.toLocationName}}\n</td>\n<td class=\"text-center\">{{data.errorMessage}}</td>\n<td class=\"col-width-100 text-center\">\n{{data.createdByUser}}\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"$ctrl.errorShipments.length\">\n<ul uib-pagination total-items=\"$ctrl.errorPagination.total\" ng-hide=\"{{($ctrl.errorPagination.total<=$ctrl.errorPagination.pageLimit)&&($ctrl.errorPagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.errorPagination.page\" ng-change=\"$ctrl.errorPageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n<div class=\"col-sm-12 orders-no-data-container\" ng-if=\"!$ctrl.errorShipments.length\">\n<div class=\"alert alert-danger text-center margin-top-10\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"stat === $ctrl.stats.completed\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row_ orders-section\" ng-if=\"!$ctrl.loading\">\n<div class=\"col-sm-12 margin-bottom-10 margin-top-10 order-section-header\">\n<div class=\"text-success font-size-20\">\n<strong>{{'branch_mgmt.orders.completed' | translate}}</strong>\n</div>\n<div class=\"pull-right\" ng-if=\"$ctrl.countedResidualShipments.length && $ctrl.hasACL['branch_mgmt_orders']['export_print']\">\n<button type=\"button\" class=\"btn btn-success margin-right-5\" ng-click=\"$ctrl.exportToCSV($ctrl.stats.completed)\" ng-disabled=\"$ctrl.exportLoading[$ctrl.stats.completed]\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.exportLoading[$ctrl.stats.completed]\"></span> Export\n</button>\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.print($ctrl.stats.completed)\">Print</button>\n</div>\n</div>\n<div ng-if=\"$ctrl.countedResidualShipments.length\" class=\"table-responsive w-100\">\n<table class=\"table table-hover table-pad-4 table-striped table-bordered margin-top-20_ font-12\">\n<thead>\n<tr>\n<td class=\"text-center shp-denom-width\">\n<b>{{'branch_mgmt.orders_denomination' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.orders_no' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.orders_date' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.item_status' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'common.trackingId' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{ 'branch_mgmt.item_from.title' | translate }}</b>\n</td>\n<td class=\"text-center\">\n<b>{{ 'branch_mgmt.item_to.title' | translate }}</b>\n</td>\n<td class=\"completed-shp-width text-center\">\n<b>{{'bulkCash.amount' | translate}}</b>\n</td>\n<td class=\"completed-shp-width text-center\">\n<b>{{'branch_mgmt.orders_requestLoad' | translate}}</b>\n</td>\n<td class=\"completed-shp-width text-center\">\n<b>{{'branch_mgmt.orders_actualLoad' | translate}}</b>\n</td>\n<td class=\"completed-shp-width text-center\">\n<b>{{'branch_mgmt.orders_crv' | translate}}</b>\n</td>\n<td class=\"completed-shp-width text-center\">\n<b>{{'branch_mgmt.orders_countedResidual' | translate}}</b>\n</td>\n<td class=\"text-center\" style=\"width: 123px;\">\n<b>{{'branch_mgmt.orders_variance' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{ 'common.user' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.countedResidualShipments track by $index\">\n<td class=\"text-center col-width-10\">\n<denom-icon ng-if=\"data.denominationId && !data.isPackableOrders\" denom-id=\"data.denominationId\" icon-size=\"30\"> </denom-icon>\n<span ng-if=\"data.denominationId && data.isPackableOrders\">\n<span ng-repeat=\"denom in data.denominationId.split(',')\"><denom-icon denom-id=\"denom\" icon-size=\"30\"> </denom-icon></span>\n</span>\n</td>\n<td class=\"col-width-100 text-center residual-shps-record\">{{data.orderNo}}</td>\n<td class=\"col-width-100 text-center\">\n<span ng-if=\"data.startedAt\">{{ data.startedAt | date:'yyyy-MM-dd': 'UTC'}}</span>\n<span ng-if=\"!data.startedAt\">{{ data.deliveryDate | date:'yyyy-MM-dd': 'UTC'}}</span>\n</td>\n<td class=\"col-width-100 text-danger text-center\">{{data.orderStatus | translate}}</td>\n<td class=\"col-width-100 text-center\">\n<span ng-if=\"!data.isPackableOrders\">\n<span><a href=\"#\" ng-click=\"$ctrl.goToItemHistory(data.trackingIdResidual)\">{{data.trackingIdResidual}}</a></span>\n<span> | </span>\n<span><a href=\"#\" ng-click=\"$ctrl.goToItemHistory(data.trackingIdLoad)\">{{data.trackingIdLoad}}</a></span>\n</span>\n<span ng-if=\"data.isPackableOrders\">\n<span><a href=\"#\" ng-click=\"$ctrl.goToItemHistory(data.trackingId)\">{{data.trackingId}}</a></span>\n</span>\n</td>\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.fromLocationId)\">{{data.fromLocationId}}</a>\n</td>\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.toLocationId)\">{{data.toLocationId}}</a>\n</td>\n<td class=\"col-width-100 text-center\">\n<span ng-if=\"data.totalAmount\">{{data.totalAmount | currency:fractionSize:0}}</span>\n<span ng-if=\"!data.totalAmount\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"col-width-100 text-center\">\n<span ng-if=\"data.amountLoadRequested\">{{data.amountLoadRequested | currency:fractionSize:0}}</span>\n<span ng-if=\"!data.amountLoadRequested\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"col-width-100 text-center\">\n<span ng-if=\"data.amountLoadActual\">{{data.amountLoadActual | currency:fractionSize:0}}</span>\n<span ng-if=\"!data.amountLoadActual\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"col-width-100 text-center\">\n<span ng-if=\"data.amountCRV\">{{data.amountCRV | currency:fractionSize:0}}</span>\n<span ng-if=\"!data.amountCRV\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"col-width-100 text-center\">\n<span ng-if=\"data.amountCounted\">{{data.amountCounted | currency:fractionSize:0}}</span>\n<span ng-if=\"!data.amountCounted\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"col-width-100 text-center\">\n<span ng-if=\"data.variance\">{{data.variance | currency:fractionSize:0}}</span>\n<span ng-if=\"!data.variance\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"col-width-100 text-center\">\n{{data.createdByUser}}\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"$ctrl.countedResidualShipments.length\">\n<ul uib-pagination total-items=\"$ctrl.completedPagination.total\" ng-hide=\"{{($ctrl.completedPagination.total<=$ctrl.completedPagination.pageLimit)&&($ctrl.completedPagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.completedPagination.page\" ng-change=\"$ctrl.completedPageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"col-sm-12 orders-no-data-container\" ng-if=\"!$ctrl.countedResidualShipments.length\">\n<div class=\"alert alert-danger text-center margin-top-10\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"stat === $ctrl.stats.pending\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.gettingUnPackedShp\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row_ orders-section\" ng-if=\"!$ctrl.gettingUnPackedShp\">\n<div class=\"col-sm-12 margin-bottom-10 margin-top-10 order-section-header\">\n<div class=\"text-success font-size-20\">\n<strong>{{'routeControl.pending_pack' | translate}}</strong>\n</div>\n<div class=\"pull-right\" ng-if=\"$ctrl.pendingPackShipments.results && $ctrl.pendingPackShipments.results.length && $ctrl.hasACL['branch_mgmt_orders']['export_print']\">\n<button type=\"button\" class=\"btn btn-success margin-right-5\" ng-click=\"$ctrl.exportToCSV($ctrl.stats.pending)\" ng-disabled=\"$ctrl.exportLoading[$ctrl.stats.pending]\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.exportLoading[$ctrl.stats.pending]\"></span> Export\n</button>\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.print($ctrl.stats.pending)\">Print</button>\n</div>\n</div>\n<div ng-if=\"$ctrl.pendingPackShipments.results && $ctrl.pendingPackShipments.results.length\" class=\"table-responsive w-100\">\n<table class=\"table table-hover table-responsive table-pad-4 table-striped table-bordered margin-top-20_ font-12\">\n<thead>\n<tr>\n<td class=\"text-center shp-denom-width\">\n<b>{{'branch_mgmt.orders_denomination' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.orders_no' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.orders_date' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'bagout.type' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'common.trackingId' | translate}}</b>\n</td>\n<td class=\"text-center from-loc-col-width\">\n<b>{{ 'branch_mgmt.item_from.title' | translate }}</b>\n</td>\n<td class=\"text-center\">\n<b>{{ 'branch_mgmt.item_to.title' | translate }}</b>\n</td>\n<td class=\"completed-shp-width text-center\">\n<b>{{'bulkCash.amount' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{ 'common.user' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.pendingPackShipments.results track by $index\">\n<td class=\"text-center col-width-10\">\n<denom-icon ng-if=\"data.denominationId && !data.isPackableOrders\" denom-id=\"data.denominationId\" icon-size=\"30\"> </denom-icon>\n<span ng-if=\"data.isPackableOrders\">\n<span ng-repeat=\"denom in data.denominationId.split(',')\"><denom-icon denom-id=\"denom\" icon-size=\"30\"> </denom-icon></span>\n</span>\n</td>\n<td class=\"col-width-100 text-center\">{{data.orderNo}}</td>\n<td class=\"col-width-100 text-center\">{{ data.startedAt | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td class=\"col-width-100 text-danger text-center\">{{data.orderStatus | translate}}</td>\n<td class=\"col-width-100 text-center residual-shps-record\">\n<span ng-if=\"!data.isPackableOrders\">\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(data.trackingId)\">{{data.trackingId}}</a>\n</span>\n<span ng-if=\"data.isPackableOrders\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.fromLocationId)\">\n{{data.fromLocationId}}\n</a> | {{data.fromLocationName}}\n</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.toLocationId)\">\n{{data.toLocationId}}\n</a> | {{data.toLocationName}}\n</td>\n<td class=\"col-width-100 text-center\">\n<span ng-if=\"data.amountLoadRequested\">{{data.amountLoadRequested | currency:fractionSize:0}}</span>\n<span ng-if=\"data.totalAmount\">{{data.totalAmount | currency:fractionSize:0}}</span>\n</td>\n<td class=\"text-center\">\n{{data.createdByUser}}\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"$ctrl.pendingPackShipments.results && $ctrl.pendingPackShipments.results.length\">\n<ul uib-pagination total-items=\"$ctrl.pendingPagination.total\" ng-hide=\"{{($ctrl.pendingPagination.total<=$ctrl.pendingPagination.pageLimit)&&($ctrl.pendingPagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pendingPagination.page\" ng-change=\"$ctrl.pendingPageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"col-sm-12 orders-no-data-container\" ng-if=\"!$ctrl.pendingPackShipments.results || !$ctrl.pendingPackShipments.results.length\">\n<div class=\"alert alert-danger text-center margin-top-10\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"stat === $ctrl.stats.inProcess\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.loadInProcessShpList\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row_ orders-section\" ng-if=\"!$ctrl.loadInProcessShpList\">\n<div class=\"col-sm-12 margin-bottom-10 margin-top-10 order-section-header\">\n<div class=\"text-success font-size-20\">\n<strong>{{'common.inProcess' | translate}}</strong>\n</div>\n<div class=\"pull-right\" ng-if=\"$ctrl.shipmentInProcessData.length && $ctrl.hasACL['branch_mgmt_orders']['export_print']\">\n<button type=\"button\" class=\"btn btn-success margin-right-5\" ng-click=\"$ctrl.exportToCSV($ctrl.stats.inProcess)\" ng-disabled=\"$ctrl.exportLoading[$ctrl.stats.inProcess]\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.exportLoading[$ctrl.stats.inProcess]\"></span> Export\n</button>\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.print($ctrl.stats.inProcess)\">Print</button>\n</div>\n</div>\n<div ng-if=\"$ctrl.shipmentInProcessData.length\" class=\"table-responsive w-100\">\n<table class=\"table table-hover table-pad-4 table-striped table-bordered margin-top-20_ font-12\">\n<thead>\n<tr>\n<td class=\"text-center shp-denom-width\">\n<b>{{'branch_mgmt.orders_denomination' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.orders_no' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.orders_date' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.item_status' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'common.trackingId' | translate}}</b>\n</td>\n<td class=\"text-center from-loc-col-width\">\n<b>{{ 'branch_mgmt.item_from.title' | translate }}</b>\n</td>\n<td class=\"text-center col-width-15\">\n<b>{{ 'branch_mgmt.item_to.title' | translate }}</b>\n</td>\n<td class=\"completed-shp-width text-center\">\n<b>{{'branch_mgmt.orders_requestLoad' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{ 'common.user' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.shipmentInProcessData track by $index\">\n<td class=\"text-center col-width-10\">\n<denom-icon ng-if=\"data.denominationId\" denom-id=\"data.denominationId\" icon-size=\"30\"> </denom-icon>\n<span ng-if=\"!data.denominationId\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"col-width-100 text-center\">{{data.orderNo}}</td>\n<td class=\"col-width-100 text-center\">{{ data.startedAt | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td class=\"col-width-100 text-danger text-center\">{{data.orderStatus | translate}}</td>\n<td class=\"col-width-100 text-center residual-shps-record\">\n<span> <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(data.trackingIdResidual)\">{{data.trackingIdResidual}}</a></span>\n<span> | </span>\n<span> <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(data.trackingIdLoad)\">{{data.trackingIdLoad}}</a></span>\n</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.fromLocationId)\">\n{{data.fromLocationId}}\n</a> | {{data.fromLocationName}}\n</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.toLocationId)\">\n{{data.toLocationId}}\n</a> | {{data.toLocationName}}\n</td>\n<td class=\"col-width-100 text-center\">{{data.amountLoadRequested | currency:fractionSize:0}}</td>\n<td class=\"col-width-100 text-center\">\n{{data.createdByUser}}\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"$ctrl.shipmentInProcessData.length\">\n<ul uib-pagination total-items=\"$ctrl.inProcessPagination.total\" ng-hide=\"{{($ctrl.inProcessPagination.total<=$ctrl.inProcessPagination.pageLimit)&&($ctrl.inProcessPagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.inProcessPagination.page\" ng-change=\"$ctrl.inProcessPageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"col-sm-12 orders-no-data-container\" ng-if=\"!$ctrl.shipmentInProcessData.length\">\n<div class=\"alert alert-danger text-center margin-top-10\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n</div>\n</div>\n</form>\n";
var id1="orders.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2695 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"orders-print-container\">\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10\">\n<div class=\"col-sm-12 remove-left-pad service-history-print-title-section\">\n<div>\n<img stream-print-logo load-from-db=\"true\" style=\"height: 80px;\">\n</div>\n<div class=\"margin-top-10\">\n<div class=\"font-size-20\">\n<strong>{{'branch_mgmt.orders_history' | translate}} - {{$ctrl.tabLabel}}</strong>\n</div>\n<div class=\"margin-top-5 font-size-14\" style=\"color: #555;\">\n<strong>Date:</strong> {{$ctrl.startDate}} to {{$ctrl.endDate}}\n<span style=\"margin-left: 15px; margin-right: 15px;\">|</span>\n<strong>Branch:</strong> {{$ctrl.branch}}\n<span style=\"margin-left: 15px; margin-right: 15px;\">|</span>\n<strong>Funding Source:</strong> {{$ctrl.fundingSourceKey}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding\">\n<table class=\"table table-hover table-striped table-bordered table-pad-3 font-11 completed-print-table\">\n<thead ng-if=\"$ctrl.tab === 'inProcess'\">\n<tr>\n<td class=\"print-completed-serial\"><b>#</b></td>\n<td class=\"print-denom-fixed\"><b>{{'branch_mgmt.orders_denomination' | translate}}</b></td>\n<td><b>{{'branch_mgmt.orders_no' | translate}}</b></td>\n<td><b>{{'branch_mgmt.orders_date' | translate}}</b></td>\n<td><b>{{'branch_mgmt.item_status' | translate}}</b></td>\n<td><b>{{'common.trackingId' | translate}}</b></td>\n<td><b>{{ 'branch_mgmt.item_from.title' | translate }}</b></td>\n<td><b>{{ 'branch_mgmt.item_to.title' | translate }}</b></td>\n<td><b>{{'branch_mgmt.orders_requestLoad' | translate}}</b></td>\n<td><b>{{ 'common.user' | translate }}</b></td>\n</tr>\n</thead>\n<tbody ng-if=\"$ctrl.tab === 'inProcess'\">\n<tr ng-repeat=\"row in $ctrl.results track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{row.denominationId}}</td>\n<td>{{row.orderNo}}</td>\n<td>{{row.startedAt | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td class=\"text-danger\">{{row.orderStatus | translate}}</td>\n<td>\n<span ng-if=\"row.trackingIdResidual && row.trackingIdLoad\">{{row.trackingIdResidual}} | {{row.trackingIdLoad}}</span>\n<span ng-if=\"row.trackingIdResidual && !row.trackingIdLoad\">{{row.trackingIdResidual}}</span>\n<span ng-if=\"!row.trackingIdResidual && row.trackingIdLoad\">{{row.trackingIdLoad}}</span>\n</td>\n<td>{{row.fromLocationId}} | {{row.fromLocationName}}</td>\n<td>{{row.toLocationId}} | {{row.toLocationName}}</td>\n<td>\n<span ng-if=\"row.amountLoadRequested\">{{row.amountLoadRequested | currency:fractionSize:0}}</span>\n<span ng-if=\"!row.amountLoadRequested\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{row.createdByUser}}</td>\n</tr>\n</tbody>\n<thead ng-if=\"$ctrl.tab === 'completed'\">\n<tr>\n<td class=\"print-completed-serial\"><b>#</b></td>\n<td class=\"print-completed-denom\"><b>{{'branch_mgmt.orders_denomination' | translate}}</b></td>\n<td class=\"print-completed-orderno\"><b>{{'branch_mgmt.orders_no' | translate}}</b></td>\n<td class=\"print-completed-date\"><b>{{'branch_mgmt.orders_date' | translate}}</b></td>\n<td class=\"print-completed-status\"><b>{{'branch_mgmt.item_status' | translate}}</b></td>\n<td class=\"print-completed-tracking\"><b>{{'common.trackingId' | translate}}</b></td>\n<td class=\"print-completed-loc\"><b>{{ 'branch_mgmt.item_from.title' | translate }}</b></td>\n<td class=\"print-completed-loc\"><b>{{ 'branch_mgmt.item_to.title' | translate }}</b></td>\n<td class=\"print-completed-amount\"><b>{{'bulkCash.amount' | translate}}</b></td>\n<td class=\"print-completed-requested-amount\"><b>{{'branch_mgmt.orders_requestLoad' | translate}}</b></td>\n<td class=\"print-completed-amount\"><b>{{'branch_mgmt.orders_actualLoad' | translate}}</b></td>\n<td class=\"print-completed-amount\"><b>{{'branch_mgmt.orders_crv' | translate}}</b></td>\n<td class=\"print-completed-amount\"><b>{{'branch_mgmt.orders_countedResidual' | translate}}</b></td>\n<td class=\"print-completed-amount\"><b>{{'branch_mgmt.orders_variance' | translate}}</b></td>\n<td class=\"print-completed-user\"><b>{{ 'common.user' | translate }}</b></td>\n</tr>\n</thead>\n<tbody ng-if=\"$ctrl.tab === 'completed'\">\n<tr ng-repeat=\"row in $ctrl.results track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{row.denominationId}}</td>\n<td>{{row.orderNo}}</td>\n<td>\n<span ng-if=\"row.startedAt\">{{row.startedAt | date:'yyyy-MM-dd': 'UTC'}}</span>\n<span ng-if=\"!row.startedAt\">{{row.deliveryDate | date:'yyyy-MM-dd': 'UTC'}}</span>\n</td>\n<td class=\"text-danger\">{{row.orderStatus | translate}}</td>\n<td>\n<span ng-if=\"!row.isPackableOrders\">\n<span ng-if=\"row.trackingIdResidual && row.trackingIdLoad\">{{row.trackingIdResidual}} | {{row.trackingIdLoad}}</span>\n<span ng-if=\"row.trackingIdResidual && !row.trackingIdLoad\">{{row.trackingIdResidual}}</span>\n<span ng-if=\"!row.trackingIdResidual && row.trackingIdLoad\">{{row.trackingIdLoad}}</span>\n</span>\n<span ng-if=\"row.isPackableOrders\">{{row.trackingId}}</span>\n</td>\n<td>{{row.fromLocationId}}</td>\n<td>{{row.toLocationId}}</td>\n<td>\n<span ng-if=\"row.totalAmount\">{{row.totalAmount | currency:fractionSize:0}}</span>\n<span ng-if=\"!row.totalAmount\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"row.amountLoadRequested\">{{row.amountLoadRequested | currency:fractionSize:0}}</span>\n<span ng-if=\"!row.amountLoadRequested\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"row.amountLoadActual\">{{row.amountLoadActual | currency:fractionSize:0}}</span>\n<span ng-if=\"!row.amountLoadActual\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"row.amountCRV\">{{row.amountCRV | currency:fractionSize:0}}</span>\n<span ng-if=\"!row.amountCRV\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"row.amountCounted\">{{row.amountCounted | currency:fractionSize:0}}</span>\n<span ng-if=\"!row.amountCounted\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"row.variance\">{{row.variance | currency:fractionSize:0}}</span>\n<span ng-if=\"!row.variance\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{row.createdByUser}}</td>\n</tr>\n</tbody>\n<thead ng-if=\"$ctrl.tab === 'pending'\">\n<tr>\n<td class=\"print-completed-serial\"><b>#</b></td>\n<td class=\"print-denom-fixed\"><b>{{'branch_mgmt.orders_denomination' | translate}}</b></td>\n<td><b>{{'branch_mgmt.orders_no' | translate}}</b></td>\n<td><b>{{'branch_mgmt.orders_date' | translate}}</b></td>\n<td><b>{{'bagout.type' | translate}}</b></td>\n<td><b>{{'common.trackingId' | translate}}</b></td>\n<td><b>{{ 'branch_mgmt.item_from.title' | translate }}</b></td>\n<td><b>{{ 'branch_mgmt.item_to.title' | translate }}</b></td>\n<td><b>{{'bulkCash.amount' | translate}}</b></td>\n<td><b>{{ 'common.user' | translate }}</b></td>\n</tr>\n</thead>\n<tbody ng-if=\"$ctrl.tab === 'pending'\">\n<tr ng-repeat=\"row in $ctrl.results track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{row.denominationId}}</td>\n<td>{{row.orderNo}}</td>\n<td>{{row.startedAt | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td class=\"text-danger\">{{row.orderStatus | translate}}</td>\n<td>{{row.trackingId || 'N/A'}}</td>\n<td>{{row.fromLocationId}} | {{row.fromLocationName}}</td>\n<td>{{row.toLocationId}} | {{row.toLocationName}}</td>\n<td>\n<span ng-if=\"row.amountLoadRequested\">{{row.amountLoadRequested | currency:fractionSize:0}}</span>\n<span ng-if=\"!row.amountLoadRequested && row.totalAmount\">{{row.totalAmount | currency:fractionSize:0}}</span>\n<span ng-if=\"!row.amountLoadRequested && !row.totalAmount\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{row.createdByUser}}</td>\n</tr>\n</tbody>\n<thead ng-if=\"$ctrl.tab === 'errors'\">\n<tr>\n<td class=\"print-completed-serial\"><b>#</b></td>\n<td class=\"print-denom-fixed\"><b>{{'branch_mgmt.orders_denomination' | translate}}</b></td>\n<td><b>{{'branch_mgmt.orders_no' | translate}}</b></td>\n<td><b>{{'branch_mgmt.orders_date' | translate}}</b></td>\n<td><b>{{'branch_mgmt.orders_requestLoad' | translate}}</b></td>\n<td><b>{{ 'branch_mgmt.item_to.title' | translate }}</b></td>\n<td><b>{{'branch_mgmt.orders_error_msg' | translate}}</b></td>\n<td><b>{{ 'common.user' | translate }}</b></td>\n</tr>\n</thead>\n<tbody ng-if=\"$ctrl.tab === 'errors'\">\n<tr ng-repeat=\"row in $ctrl.results track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{row.denom1}}</td>\n<td>{{row.orderNo}}</td>\n<td>{{row.orderDate | date:'yyyy-MM-dd'}}</td>\n<td>\n<span ng-if=\"row.denomAmount1\">{{row.denomAmount1 | currency:fractionSize:0}}</span>\n<span ng-if=\"!row.denomAmount1\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{row.tid}} | {{row.toLocationName}}</td>\n<td>{{row.errorMessage}}</td>\n<td>{{row.createdByUser}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n";
var id1="orders-print.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2696 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container_ remove-pad col-sm-12\">\n<div class=\"col-sm-12 font-size-20 text-center\">\n<b>{{'branch_mgmt.physical_cash_count.title' | translate}}</b>\n<hr class=\"remove-bottom-margin\">\n</div>\n<div class=\"col-sm-12 margin-top-20\" ng-repeat=\"data in $ctrl.model.physicalCashCountRecord track by $index\" ng-if=\"!$ctrl.model.loading && $ctrl.model.physicalCashCountRecord.length > 0\" ng-if=\"data.denominations.length !== 0\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 align-center _physical-cash-denom-row margin-top-05\">\n<div class=\"physical-cash-datetimepicker-section col-sm-2\" ng-class=\"{'col-sm-2' : data.status === 'Completed', 'cursor-not-allowed-section' : $ctrl.model.commitRecords || data.edit}\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" ng-click=\"$ctrl.getRequirementOrBalanceCount()\" ng-class=\"{'required-datetimepicker': !$ctrl.model.date, 'disabled': $ctrl.model.commitRecords || data.edit}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" date-options=\"$ctrl.model.maxVaultDate\"/>\n</div>\n<div class=\"col-sm-7\">\n<span class=\"lbl-height-section font-size-18 label label-default col-sm-12\" ng-class=\"{'info-section-color' : data.status === 'Pending',\n                                   'label-success': data.status === 'Completed',\n                                   'funding-source-font-color': data.status === 'Pending' }\">\n<span class=\"check-icon-section glyphicon glyphicon-ok-circle\" ng-if=\"data.status === 'Completed'\"></span>\n<span>{{data.fundingSourceId}} | {{data.fundingSourceName}} |</span>\n<span ng-if=\"data.status !== 'Completed' && !data.approved\">Pending</span>\n<span ng-if=\"data.status === 'Completed' && !data.approved\">Completed</span>\n<span ng-if=\"data.status === 'Completed' && data.approved\">Approved</span>\n<span ng-if=\"data.totalAmount >= 0\"> | {{data.totalAmount | currency:fractionSize:0}}</span>\n</span>\n</div>\n<div class=\"cash-count-btn-section col-sm-2\" ng-if=\"data.status === 'Completed'\">\n<div class=\"text-center physical-cash-print-btn-pad remove-right-pad\">\n<button type=\"button\" class=\"btn btn-md btn-success\" ng-click=\"$ctrl.print(data.fundingSourceId)\">\n{{'routeSheet.print' | translate}}\n</button>\n</div>\n<div class=\"physical-cash-print-btn-pad remove-right-pad remove-left-pad\" ng-if=\"$ctrl.model.hasACL[$ctrl.model.permissionKey]['edit'] && !$ctrl.model.isPriorVaultDate\">\n<button type=\"button\" class=\"btn btn-md btn-success\" ng-disabled=\"data.approved\" ng-click=\"!data.approved ? $ctrl.edit(data) : ''\">\n{{'common.Edit' | translate}}\n</button>\n</div>\n</div>\n<div class=\"physical-cash-print-btn-pad remove-right-pad remove-left-pad pull-right col-sm-1\" ng-if=\"$ctrl.model.isSupervisor && data.status === 'Completed' && !$ctrl.model.isPriorVaultDate\">\n<button id=\"approve\" type=\"button\" class=\"btn btn-md btn-warning\" ng-click=\"!data.approved ? $ctrl.approveWithSupervisor(data) : ''\" ng-disabled=\"data.approved || $ctrl.isApprovePhysicalCashCount\">\n{{'common.approve' | translate}}\n</button>\n</div>\n</div>\n<div class=\"margin-top-03 text-center finished-by-section col-sm-12\" ng-if=\"data.status === 'Completed'\">\n{{'branch_mgmt.counted_by' | translate}} : {{data.finishedByUserId}} | {{data.finishedByUserName}} | {{($ctrl.DateUtil.convetToBrowserTimezone(data.finishedAt))}}\n</div>\n<div class=\"margin-top-03 text-center approved-by-section col-sm-12\" ng-if=\"data.approved\">\n{{'branch_mgmt.billing_approval.approved' | translate}} {{'common.by' | translate}} : {{data.approvedByUserId}} | {{data.approvedByUserName}} | {{($ctrl.DateUtil.convetToBrowserTimezone(data.approvedAt))}}\n</div>\n</form>\n<div class=\"_font-size-20 col-sm-12 text-center margin-10 balance-exceed-error\" ng-if=\"data.commonBalanceError || data.regularBalanceError || data.emergencyBalanceError\">\n<div class=\"alert text-center alert-danger remove-bottom-margin col-sm-9\" ng-if=\"data.commonBalanceError\">\n{{data.commonBalanceError}}\n</div>\n<div class=\"alert text-center alert-danger remove-bottom-margin col-sm-9\" ng-if=\"!data.commonBalanceError && (data.regularBalanceError || data.emergencyBalanceError)\">\n{{data.regularBalanceError || data.emergencyBalanceError}}\n</div>\n</div>\n<div class=\"font-size-17 remove-left-pad col-sm-12 text-center margin-10\">\n<label class=\"physical-cash-count-label\" ng-if=\"$ctrl.model.fundingSourceDenoms[data.fundingSourceId]['regular'].hasDenominations\">{{'common.regular' | translate}}\n<span ng-if=\"data.edit\">({{'common.Edit' | translate}})</span>\n</label>\n</div>\n<div class=\"col-sm-12 physical-cash-denom-row\">\n<div class=\"card physical-cash-card-margin\" ng-repeat=\"denomination in data.denominations track by $index\" ng-if=\"denomination.account === 'regular'\">\n<div class=\"physical-cash-card-body\">\n<img ng-src=\"assets/images/{{denomination.denominationId}}.png\" class=\"custom-icon denom-img-width\"/>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0;\" ng-show=\"$ctrl.isFloat(denomination.faceValue)\">\n<input class=\"form-control text-center\" type=\"text\" ng-currency fraction=\"2\" currency-symbol=\"\" placeholder=\"{{'bulkCash.amount' | translate}}\" ng-class=\"{'color-red': !$ctrl.model.physicalCashCountRecord[$parent.$parent.$index].denominations[$index].isValid}\" ng-model=\"denomination.amount\" ng-keydown=\"$event.keyCode === 13\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" ng-change=\"$ctrl.calculateTotalAmount($parent.$parent.$index, denomination.amount); \n                                   $ctrl.validateDenomAmount($parent.$parent.$index, $index);\n                                   $ctrl.calculateAccountBalance($parent.$parent.$index,'regular', denomination.amount);\" ng-disabled=\"denomination.status === 'Completed' || $ctrl.model.commitRecords || $ctrl.model.isPriorVaultDate\">\n<span class=\"text-color-red\" ng-if=\"denomination.amount && !$ctrl.model.physicalCashCountRecord[$parent.$parent.$index].denominations[$index].isValid\">Invalid amount</span>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0;\" ng-show=\"!$ctrl.isFloat(denomination.faceValue)\">\n<input class=\"form-control text-center\" type=\"text\" ng-currency fraction=\"2\" currency-symbol=\"\" placeholder=\"{{'bulkCash.amount' | translate}}\" ng-class=\"{'color-red': !$ctrl.model.physicalCashCountRecord[$parent.$parent.$index].denominations[$index].isValid}\" ng-model=\"denomination.amount\" ng-keydown=\"$event.keyCode === 13\" ng-pattern=\"/^[0-9]*$/\" ng-change=\"$ctrl.calculateTotalAmount($parent.$parent.$index, denomination.amount); \n                                   $ctrl.validateDenomAmount($parent.$parent.$index, $index);\n                                   $ctrl.calculateAccountBalance($parent.$parent.$index,'regular', denomination.amount);\" ng-disabled=\"denomination.status === 'Completed' || $ctrl.model.commitRecords || $ctrl.model.isPriorVaultDate\">\n<span class=\"text-color-red\" ng-if=\"denomination.amount && !$ctrl.model.physicalCashCountRecord[$parent.$parent.$index].denominations[$index].isValid\">Invalid amount</span>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0;\" ng-if=\"denomination.amountVariance !== 0 && $ctrl.model.isSupervisor && data.finishedAt && !data.edit\">\n<span class=\"form-control text-center variance-icon-section\">{{$ctrl.amountVariance(denomination.amountVariance)}}</span>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0; height: 34px;\" ng-if=\"denomination.amountVariance === 0 && $ctrl.model.isSupervisor && data.finishedAt && !data.edit\">\n<span class=\"no-variance-icon-section glyphicon glyphicon-ok-circle padding5\"></span>\n</div>\n</div>\n</div>\n<div class=\"font-size-17 remove-left-pad col-sm-12 text-center margin-10\" ng-if=\"data.denominations.length !== 0 && $ctrl.model.fundingSourceDenoms[data.fundingSourceId]['emergency'].hasDenominations\">\n<label class=\"physical-cash-count-label\">{{'common.emergency' | translate}}\n<span ng-if=\"data.edit\">({{'common.Edit' | translate}})</span>\n</label>\n</div>\n<div class=\"col-sm-12 physical-cash-denom-row\">\n<div class=\"card physical-cash-card-margin\" ng-repeat=\"denomination in data.denominations track by $index\" ng-if=\"denomination.account === 'emergency' && denomination.denominationCoinFlag == 0\">\n<div class=\"physical-cash-card-body\">\n<img ng-src=\"assets/images/{{denomination.denominationId}}.png\" class=\"custom-icon denom-img-width\"/>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0;\" ng-show=\"$ctrl.isFloat(denomination.faceValue)\">\n<input class=\"form-control text-center\" type=\"text\" ng-currency fraction=\"2\" currency-symbol=\"\" placeholder=\"{{'bulkCash.amount' | translate}}\" ng-class=\"{'color-red': !$ctrl.model.physicalCashCountRecord[$parent.$parent.$index].denominations[$index].isValid}\" ng-model=\"denomination.amount\" ng-keydown=\"$event.keyCode === 13\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" ng-change=\"$ctrl.calculateTotalAmount($parent.$parent.$index, denomination.amount); \n                                   $ctrl.validateDenomAmount($parent.$parent.$index, $index);\n                                   $ctrl.calculateAccountBalance($parent.$parent.$index,'emergency', denomination.amount);\" ng-disabled=\"denomination.status === 'Completed' || $ctrl.model.commitRecords || $ctrl.model.isPriorVaultDate\">\n<span class=\"text-color-red\" ng-if=\"denomination.amount && !$ctrl.model.physicalCashCountRecord[$parent.$parent.$index].denominations[$index].isValid\">Invalid amount</span>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0;\" ng-show=\"!$ctrl.isFloat(denomination.faceValue)\">\n<input class=\"form-control text-center\" type=\"text\" ng-currency fraction=\"2\" currency-symbol=\"\" placeholder=\"{{'bulkCash.amount' | translate}}\" ng-class=\"{'color-red': !$ctrl.model.physicalCashCountRecord[$parent.$parent.$index].denominations[$index].isValid}\" ng-model=\"denomination.amount\" ng-keydown=\"$event.keyCode === 13\" ng-pattern=\"/^[0-9]*$/\" ng-change=\"$ctrl.calculateTotalAmount($parent.$parent.$index, denomination.amount); \n                                   $ctrl.validateDenomAmount($parent.$parent.$index, $index);\n                                   $ctrl.calculateAccountBalance($parent.$parent.$index,'emergency', denomination.amount);\" ng-disabled=\"denomination.status === 'Completed' || $ctrl.model.commitRecords || $ctrl.model.isPriorVaultDate\">\n<span class=\"text-color-red\" ng-if=\"denomination.amount && !$ctrl.model.physicalCashCountRecord[$parent.$parent.$index].denominations[$index].isValid\">Invalid amount</span>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0;\" ng-if=\"denomination.amountVariance !== 0 && $ctrl.model.isSupervisor && data.finishedAt && !data.edit\">\n<span class=\"form-control text-center variance-icon-section\">{{$ctrl.amountVariance(denomination.amountVariance)}}</span>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0; height: 34px;\" ng-if=\"denomination.amountVariance === 0 && $ctrl.model.isSupervisor && data.finishedAt && !data.edit\">\n<span class=\"no-variance-icon-section glyphicon glyphicon-ok-circle padding5\"></span>\n</div>\n</div>\n</div>\n<div class=\"_margin-10 col-sm-12 alert alert-danger text-align-center\" ng-if=\"data.denominations.length == 0\">\nNo denominations to be counted\n</div>\n</div>\n<div class=\"col-sm-12 text-align-center margin-top-40\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div class=\"margin-10 col-sm-12 alert alert-danger text-align-center\" ng-if=\"$ctrl.model.physicalCashCountRecord.length === 0 && !$ctrl.model.loading\">\n{{'branch_mgmt.physical_cash_count_error' | translate}}\n</div>\n<div class=\"col-sm-12 align-center margin-10 margin-bottom-20 btn-gap-20\">\n<div class=\"col-sm-3\" ng-if=\"$ctrl.model.physicalCashCountRecord.length > 0 && $ctrl.model.denominations.length > 0 && !$ctrl.showCancelEditButton()\">\n<button class=\"btn btn-success btn-lg text-center physical-cash-count-button\" type=\"button\" ng-disabled=\"Form.$invalid || $ctrl.model.commitRecords || $ctrl.commitDisabled() || $ctrl.model.loading || $ctrl.validBalanceDisabled() || $ctrl.isCheckForVariance || $ctrl.isApprovePhysicalCashCount\" ng-click=\"$ctrl.confirmSupervisor('create')\" ng-hide=\"$ctrl.hideCommitBtn() || $ctrl.model.loading\"> {{'branch_mgmt.record_physical_cash' | translate}}\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.model.commitRecords}\"></span>\n</button>\n</div>\n<div class=\"_col-sm-2\" ng-if=\"$ctrl.model.physicalCashCountRecord.length > 0 && $ctrl.showCancelEditButton() && !$ctrl.model.loading\">\n<button class=\"btn btn-success btn-lg pull-right\" type=\"button\" ng-click=\"$ctrl.confirmSupervisor('edit')\" ng-disabled=\"Form.$invalid || $ctrl.model.commitRecords || $ctrl.model.loading || $ctrl.commitDisabled() || $ctrl.validBalanceDisabled() || $ctrl.isCheckForVariance\">\n{{'branch_mgmt.physical_cash_count.save_edit' | translate}}\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.model.commitRecords || $ctrl.isCheckForVariance}\"></span>\n</button>\n</div>\n<div class=\"_col-sm-2\" ng-if=\"$ctrl.model.physicalCashCountRecord.length > 0 && $ctrl.showCancelEditButton() && !$ctrl.model.loading && !$ctrl.isCheckForVariance\">\n<button class=\"btn btn-success btn-lg text-center\" type=\"button\" ng-click=\"$ctrl.cancelEdit()\" ng-disabled=\"$ctrl.model.commitRecords || $ctrl.model.loading || $ctrl.isCheckForVariance\">\n{{'branch_mgmt.physical_cash_count.cancel_edit' | translate}}\n</button>\n</div>\n</div>\n</div>";
var id1="physical_cash_count.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2697 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"remove-left-pad remove-right-pad col-sm-12 col-print-12 physical-cash-count-print-css-section\">\n<div class=\"col-sm-12 col-print-12 margin-10\" ng-repeat=\"data in $ctrl.physicalCashCountData track by $index\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 col-print-12 physical-cash-denom-row margin-top-05\">\n<div class=\"col-sm-9 text-center\">\n<span class=\"lbl-height-section font-size-18 col-print-12 col-sm-12\">\n<span class=\"check-icon-section glyphicon glyphicon-ok-circle\"></span>\n{{data.fundingSourceName}} | {{data.status}} | {{data.totalAmount | currency:fractionSize:0}} ({{$ctrl.branch}})\n</span>\n<div class=\"finished-by-section margin-top-05 print-margin-top-05 text-center font-size-15 col-print-12 col-sm-12\">\n{{'branch_mgmt.counted_by' | translate}} : {{data.finishedByUserId}} | {{data.finishedByUserName}} | {{($ctrl.DateUtil.convetToBrowserTimezone(data.finishedAt))}}\n</div>\n<div class=\"margin-top-03 text-center approved-by-section col-print-12 col-sm-12\" ng-if=\"data.approved\">\n{{'branch_mgmt.billing_approval.approved' | translate}} {{'common.by' | translate}} : {{data.approvedByUserId}} | {{data.approvedByUserName}} | {{($ctrl.DateUtil.convetToBrowserTimezone(data.approvedAt))}}\n</div>\n</div>\n</div>\n</form>\n<div class=\"font-size-17 remove-left-pad col-print-12 col-sm-12 text-center margin-top-20\" ng-if=\"$ctrl.denomsForAccount['regular'].hasDenominations\">\n<label class=\"remove-bottom-margin\">{{'common.regular' | translate}}</label>\n</div>\n<div class=\"col-sm-12 col-print-12 physical-cash-denom-row\">\n<div class=\"card physical-cash-card-margin\" ng-repeat=\"denomination in data.denominations track by $index\" ng-if=\"denomination.account === 'regular'\">\n<div class=\"physical-cash-card-body\">\n<img ng-src=\"assets/images/{{denomination.denominationId}}.png\" class=\"custom-icon denom-img-width\"/>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0;\">\n<input class=\"form-control text-center\" type=\"text\" ng-currency fraction=\"2\" currency-symbol=\"\" placeholder=\"{{'bulkCash.amount' | translate}}\" ng-show=\"$ctrl.isFloat(denomination.faceValue)\" ng-model=\"denomination.amount\" ng-keydown=\"$event.keyCode === 13\" disabled=\"disabled\">\n<input class=\"form-control text-center\" type=\"text\" ng-currency fraction=\"2\" currency-symbol=\"\" placeholder=\"{{'bulkCash.amount' | translate}}\" ng-show=\"!$ctrl.isFloat(denomination.faceValue)\" ng-model=\"denomination.amount\" ng-keydown=\"$event.keyCode === 13\" disabled=\"disabled\">\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0;\" ng-if=\"denomination.amountVariance !== 0 && $ctrl.isSupervisor && data.finishedAt\">\n<span class=\"form-control text-center variance-icon-section\">{{$ctrl.amountVariance(denomination.amountVariance)}}</span>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0; height: 34px;\" ng-if=\"denomination.amountVariance === 0 && $ctrl.isSupervisor && data.finishedAt\">\n<span class=\"no-variance-icon-section glyphicon glyphicon-ok-circle padding5\"></span>\n</div>\n</div>\n</div>\n<div class=\"font-size-17 remove-left-pad col-sm-12 col-print-12 text-center margin-10\" ng-if=\"$ctrl.denomsForAccount['emergency'].hasDenominations\">\n<label class=\"remove-bottom-margin\">{{'common.emergency' | translate}}</label>\n</div>\n<div class=\"col-sm-12 col-print-12 physical-cash-denom-row\">\n<div class=\"card physical-cash-card-margin\" ng-repeat=\"denomination in data.denominations track by $index\" ng-if=\"denomination.account === 'emergency' && denomination.denominationCoinFlag == 0\">\n<div class=\"physical-cash-card-body\">\n<img ng-src=\"assets/images/{{denomination.denominationId}}.png\" class=\"custom-icon denom-img-width\"/>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0;\">\n<input class=\"form-control text-center\" type=\"text\" ng-currency fraction=\"2\" currency-symbol=\"\" placeholder=\"{{'bulkCash.amount' | translate}}\" ng-show=\"$ctrl.isFloat(denomination.faceValue)\" ng-model=\"denomination.amount\" ng-keydown=\"$event.keyCode === 13\" disabled=\"disabled\">\n<input class=\"form-control text-center\" type=\"text\" ng-currency fraction=\"2\" currency-symbol=\"\" placeholder=\"{{'bulkCash.amount' | translate}}\" ng-show=\"!$ctrl.isFloat(denomination.faceValue)\" ng-model=\"denomination.amount\" ng-keydown=\"$event.keyCode === 13\" disabled=\"disabled\">\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0;\" ng-if=\"denomination.amountVariance !== 0 && $ctrl.isSupervisor && data.finishedAt\">\n<span class=\"form-control text-center variance-icon-section\">{{$ctrl.amountVariance(denomination.amountVariance)}}</span>\n</div>\n<div class=\"remove-border\" style=\"border-top: 1px solid #e0e0e0; height: 34px;\" ng-if=\"denomination.amountVariance === 0 && $ctrl.isSupervisor && data.finishedAt\">\n<span class=\"no-variance-icon-section glyphicon glyphicon-ok-circle padding5\"></span>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="print_physical_cash_count.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2698 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad restore-route-assignment-css-section\">\n<div class=\"col-sm-12 text-center remove-left-pad remove-right-pad margin-top-10 margin-bottom-10\">\n<span class=\"total-fontSize\">{{'branch_mgmt.restore_route_assignments.title' | translate}}\n<span class=\"badge\">{{$ctrl.model.locRouteAssignmentObj.pagination.total}}</span>\n</span>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<hr class=\"remove-margin\"/>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.locRouteAssignmentObj.loading\">\n<div class=\"col-sm-3 pull-left remove-pad\">\n<button ng-if=\"$ctrl.model.locRouteAssignmentObj.results.length && !$ctrl.model.locRouteAssignmentObj.selectedLocRouteChangeIds.length\" type=\"button\" ng-disabled=\"$ctrl.model.locRouteAssignmentObj.loading || $ctrl.model.loading\" class=\"restore-all-btn btn btn-sm btn-success\" ng-click=\"$ctrl.undoLocationRouteChange();\">\n{{'branch_mgmt.restore_all' | translate}}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.locRouteAssignmentObj.loading || $ctrl.model.loading\"></span>\n</button>\n<button ng-if=\"$ctrl.model.locRouteAssignmentObj.selectedLocRouteChangeIds.length > 1\" type=\"button\" ng-disabled=\"$ctrl.model.locRouteAssignmentObj.loading || $ctrl.model.loading\" class=\"restore-all-btn btn btn-sm btn-success\" ng-click=\"$ctrl.undoLocationRouteChange();\">\n{{'branch_mgmt.restore_selected' | translate}} <b>({{$ctrl.model.locRouteAssignmentObj.selectedLocRouteChangeIds.length}})</b>\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.locRouteAssignmentObj.loading || $ctrl.model.loading\"></span>\n</button>\n</div>\n<div class=\"col-sm-6 align-center-horizontally\">\n<input type=\"text\" placeholder=\"{{ 'location.id' | translate }}\" ng-change=\"$ctrl.searchRecords();\" ng-model-options=\"{debounce: 1000}\" class=\"input-lg form-control\" ng-model=\"$ctrl.model.locRouteAssignmentObj.searchText\" search-autofocus>\n</div>\n<div class=\"col-sm-3 location-hold-dd-section remove-right-pad\">\n<div class=\"multi-select user-branch-search-dd valid-multi-select-value\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" selection-mode=\"single\" on-item-click=\"$ctrl.resetPagination(); $ctrl.findLocationRouteChange();\" translation=\"$ctrl.model.localLang\" is-disabled=\"$ctrl.model.locRouteAssignmentObj.loading\">\n</div>\n</div>\n</div>\n<div class=\"text-align-center font-size-70\" ng-if=\"$ctrl.model.locRouteAssignmentObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"table-responsive col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.locRouteAssignmentObj.loading && $ctrl.model.locRouteAssignmentObj.results.length\">\n<table class=\"table table-hover table-responsive table-striped table-bordered margin-top-10\">\n<thead>\n<tr>\n<th class=\"text-center cursor-pointer\" ng-click=\"$ctrl.selectAllLocations()\">Select</th>\n<th class=\"text-center\">{{'common.location' | translate}}</th>\n<th class=\"text-center\" colspan=\"8\">{{'branch_mgmt.original_routing_assignments' | translate}}</th>\n<th class=\"text-center\">{{'bulkCash.action' | translate}}</th>\n</tr>\n<tr class=\"text-center\">\n<th colspan=\"2\"></th>\n<th class=\"text-center\">{{'location.mon' | translate}}</th>\n<th class=\"text-center\">{{'location.tues' | translate}}</th>\n<th class=\"text-center\">{{'location.wed' | translate}}</th>\n<th class=\"text-center\">{{'location.thurs' | translate}}</th>\n<th class=\"text-center\">{{'location.fri' | translate}}</th>\n<th class=\"text-center\">{{'location.sat' | translate}}</th>\n<th class=\"text-center\">{{'location.sun' | translate}}</th>\n<th class=\"text-center\">{{'location.hol' | translate}}</th>\n<th></th>\n</tr>\n</thead>\n<tbody>\n<tr class=\"text-center\" ng-repeat=\"data in $ctrl.model.locRouteAssignmentObj.results track by $index\">\n<td><input type=\"checkbox\" ng-model=\"data.isSelected\" ng-click=\"data.isSelected = !data.isSelected; $ctrl.selectLocations(data, $index);\"></td>\n<td> <a href=\"#\" ng-click=\"$ctrl.goToLocation(data.locationId)\">{{data.locationId}}</a></td>\n<td>\n<span ng-if=\"data.routeMondayId\" class=\"text-success\">{{data.routeMondayId}}</span>\n<span ng-if=\"!data.routeMondayId\" class=\"_text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"data.routeTuesdayId\" class=\"text-success\">{{data.routeTuesdayId}}</span>\n<span ng-if=\"!data.routeTuesdayId\" class=\"_text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"data.routeWednesdayId\" class=\"text-success\">{{data.routeWednesdayId}}</span>\n<span ng-if=\"!data.routeWednesdayId\" class=\"_text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"data.routeThursdayId\" class=\"text-success\">{{data.routeThursdayId}}</span>\n<span ng-if=\"!data.routeThursdayId\" class=\"_text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"data.routeFridayId\" class=\"text-success\">{{data.routeFridayId}}</span>\n<span ng-if=\"!data.routeFridayId\" class=\"_text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"data.routeSaturdayId\" class=\"text-success\">{{data.routeSaturdayId}}</span>\n<span ng-if=\"!data.routeSaturdayId\" class=\"_text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"data.routeSundayId\" class=\"text-success\">{{data.routeSundayId}}</span>\n<span ng-if=\"!data.routeSundayId\" class=\"_text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"data.routeHolidayId\" class=\"text-success\">{{data.routeHolidayId}}</span>\n<span ng-if=\"!data.routeHolidayId\" class=\"_text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.undoLocationRouteChange();\" ng-disabled=\"$ctrl.model.locRouteAssignmentObj.loading || !data.isSelected || $ctrl.model.loading\" ng-hide=\"data.isSelected && $ctrl.model.locRouteAssignmentObj.selectedLocRouteChangeIds.length > 1\">\n{{'branch_mgmt.restore' | translate}}\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"margin-bottom-20\" ng-if=\"$ctrl.model.locRouteAssignmentObj.pagination.total > $ctrl.model.locRouteAssignmentObj.pagination.pageLimit\">\n<ul uib-pagination total-items=\"$ctrl.model.locRouteAssignmentObj.pagination.total\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.locRouteAssignmentObj.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.locRouteAssignmentObj.loading && !$ctrl.model.locRouteAssignmentObj.results.length\">\n<div class=\"text-center alert alert-danger margin-top-20\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>";
var id1="restore_route_assignments.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2699 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 margin-top-10 remove-padding\" ng-if=\"$ctrl.flag === 'cant' || $ctrl.flag === 'noPickup'\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-print-12 col-sm-12 remove-padding\">\n<div class=\"col-print-12 col-sm-12 remove-padding\">\n<div class=\"remove-padding col-print-12 col-sm-12 margin-bottom-10 margin-10\">\n<div class=\"remove-padding col-sm-1 col-print-1 logo-width\">\n<img class=\"margin-top-15\" ng-src=\"{{$ctrl.logoBase64}}\" style=\"height: 40px;\" ng-if=\"$ctrl.printData.email\"/>\n<img class=\"margin-top-15\" stream-print-logo style=\"height: 40px;\" ng-if=\"!$ctrl.printData.email\"/>\n</div>\n<div class=\"service-history-lbl remove-padding font-size-20 col-sm-6 col-print-6\">\n<strong class=\"margin-left-10\">{{$ctrl.title}}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.vaultDate}}</span>\n</div>\n<div class=\"pull-right col-sm-4 col-print-4 remove-padding service-history-lbl font-size-20\">\n<span class=\"pull-right\">\n<strong>Route</strong>\n| {{$ctrl.routeId}}\n</span>\n</div>\n</div>\n<div class=\"remove-padding table-responsive col-sm-12 col-print-12 margin-10\">\n<table class=\"table table-striped table-bordered\" ng-if=\"$ctrl.flag === 'cant'\">\n<thead>\n<tr class=\"header-row nowrap\">\n<th class=\"text-center\">{{ 'common.trackingId' | translate}}</th>\n<th class=\"text-center\">{{ 'addBagModal.amount' | translate}}</th>\n<th class=\"text-center\">{{ 'branchFundingSource.shiptype' | translate}}</th>\n<th class=\"text-center\">{{ 'common.locationId' | translate}}</th>\n<th class=\"text-center\">{{ 'location._type' | translate}}</th>\n<th class=\"text-center\">{{ 'setup.address' | translate}}</th>\n<th class=\"text-center\">{{ 'routeProgress.completed_time' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.routesInfo\">\n<td class=\"text-center\">\n<span ng-if=\"data.trackingId\">{{data.trackingId}}</span>\n<span ng-if=\"!data.trackingId\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.amount >= 0\">{{data.amount | currency:\"$\"}}</span>\n<span ng-if=\"data.amount == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.shipTypeId\">{{data.shipTypeId}}</span>\n<span ng-if=\"!data.shipTypeId\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">{{data.locationId}}</td>\n<td class=\"text-center\">{{data.locationType}}</td>\n<td class=\"text-center\">{{data.address}}</td>\n<td class=\"text-center\">{{data.completedTime | date: 'MM-dd-yyyy | hh:mm a' : $ctrl.timezone}}</td>\n</tr>\n</tbody>\n</table>\n<table class=\"table table-striped table-bordered\" ng-if=\"$ctrl.flag === 'noPickup'\">\n<thead>\n<tr class=\"header-row nowrap\">\n<th class=\"text-center\">{{ 'common.locationId' | translate}}</th>\n<th class=\"text-center\">{{ 'location._type' | translate}}</th>\n<th class=\"text-center\">{{ 'setup.address' | translate}}</th>\n<th class=\"text-center\">{{ 'routeProgress.completed_time' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.routesInfo\">\n<td class=\"text-center\">{{data.locationId}}</td>\n<td class=\"text-center\">{{data.locationType}}</td>\n<td class=\"text-center\">{{data.address}}</td>\n<td class=\"text-center\">{{data.completedTime | date: 'MM-dd-yyyy | hh:mm a' : $ctrl.timezone}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n<div class=\"remove-left-pad remove-right-pad margin-bottom-20 checkin_print col-sm-12 text-align-center\" ng-if=\" $ctrl.flag && ($ctrl.flag !== 'cant' && $ctrl.flag !== 'noPickup')\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"align-center-horizontally\">\n<img class=\"margin-top-10\" ng-src=\"{{$ctrl.logoBase64}}\" style=\"height: 40px;\" ng-if=\"$ctrl.printData.email\"/>\n<img stream-print-logo class=\"margin-top-10 print-logo-height-80\" ng-if=\"!$ctrl.printData.email\">\n</div>\n<h4>{{ 'checkin.checkinManifest' | translate }}</h4>\n<div class=\"remove-left-pad remove-right-pad col-sm-12\" id=\"print-section\">\n<div class=\"col-sm-12 text-align-left margin-top-10 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-6 col-print-6 remove-left-pad\">\n<div>\n<span class=\"fs-print-12\">{{ 'checkout.fromLocation' | translate}}:</span>\n</div>\n<div>\n<h3 class=\"margin-zero fs-print-40\">\n<strong>{{'bagout_print.fromLocationName' | translate}}</strong>\n</h3>\n</div>\n<div>\n<h4 class=\"fs-print-40 margin-0\">{{'bagout_print.fromLocationAddress' | translate}}</h4>\n</div>\n</div>\n<div class=\"col-sm-6 text-align-right remove-right-pad\">\n<div class=\"margin-zero text-align-right\">\n<span class=\"fs-print-12\">{{ 'checkout.toLocation' | translate }}</span>\n</div>\n<div ng-if=\"$ctrl.routeDetails.messengerId\">\n<h3 class=\"margin-zero fs-print-40\">\n<strong>\n{{ $ctrl.routeDetails.messenger}} | {{$ctrl.routeDetails.messengerId}}\n</strong>\n</h3>\n</div>\n<div ng-if=\"!$ctrl.routeDetails.messengerId\">\n<h3 class=\"margin-zero text-align-right\">\n<strong>\n{{ 'checkout.n_a' | translate }}\n</strong>\n</h3>\n</div>\n</div>\n</div>\n<div>\n<br><br><br>\n</div>\n<div class=\"col-sm-12 text-align-left margin-top-10 print-margin-top-05 remove-left-pad remove-right-pad\">\n<strong>\n{{ 'checkout.routeId' | translate }}:\n</strong>\n<span>{{ $ctrl.routeId }}</span>\n<strong class=\"padding-left-10\">\n{{ 'checkout.totalBags' | translate }}:\n</strong>\n<span>{{ $ctrl.totals.totalBag }}</span>\n<strong class=\"padding-left-10\">\n{{ 'checkout.totalCoin' | translate }}:\n</strong>\n<span>{{ $ctrl.totals.totalCoin }}</span>\n<strong class=\"padding-left-10\">\n{{ 'checkout.totalAmount' | translate}}:\n</strong>\n<span>{{ $ctrl.totals.totalAmount | currency: '$'}}</span>\n<span class=\"pull-right\">\n<strong>\n{{ 'checkout.deliveryDate' | translate }}:\n</strong>\n<span>{{ $ctrl.vaultDate | date: 'longDate'}}</span>\n</span>\n</div>\n<div class=\"col-sm-12 margin-top-10 remove-left-pad remove-right-pad\">\n<table class=\"table table-striped table-bordered\" ng-if=\"$ctrl.flag === 'pickups' || $ctrl.flag === 'delivery' || $ctrl.flag === 'holdPickups' || $ctrl.flag === 'holdDeliveries'\">\n<thead class=\"header-row\">\n<tr>\n<td>\n<strong>#</strong>\n</td>\n<td>\n<strong>{{ 'checkout.trackingId' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.fromLocationName' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.ToLocationName' | translate }}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.transactionType' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.amount' | translate}}</strong>\n</td>\n<td ng-if=\"$ctrl.flag !== 'holdPickups' && $ctrl.flag !== 'holdDeliveries'\">\n<strong>{{ 'checkout.verify' | translate}}</strong>\n</td>\n<td ng-if=\"($ctrl.flag === 'holdPickups') || ($ctrl.flag === 'holdDeliveries')\">\n{{'branch_mgmt.item_status' | translate}}\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"item in $ctrl.routesInfo\">\n<td>{{ $index+1 }}</td>\n<td>{{ item.trackingId }}\n</td>\n<td>{{ item.from_location_details}}</td>\n<td>{{ item.to_location_details}}</td>\n<td>{{ item.shipTypeId }}</td>\n<td>{{ item.amount | currency:'$' }}</td>\n<td ng-if=\"$ctrl.flag !== 'holdPickups' && $ctrl.flag !== 'holdDeliveries'\"></td>\n<td ng-if=\"($ctrl.flag === 'holdPickups') || ($ctrl.flag === 'holdDeliveries')\">\n{{'common.hold' | translate}}\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<center ng-if=\"$ctrl.flag === 'pickups' || $ctrl.flag === 'delivery' || $ctrl.flag === 'holdDeliveries' || $ctrl.flag === 'holdPickups'\">\n<div class=\"checkin-verify margin-top-20\">\n<div class=\"checkin-promise\">\n<h4 class=\"padding-left-50\">{{ 'checkout.promise' | translate }}</h4>\n</div>\n<div class=\"manifest-content\">\n<h4 class=\"padding-left-50 margin-bottom-0\">{{ 'checkout.fullName' | translate }}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"padding-left-50 content-position\">{{'checkout.signature' | translate}}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"padding-left-50 content-position padding-left-10\">{{ 'checkout.verifyDate' | translate }}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n</div>\n</div>\n</center>\n</div>\n</div>";
var id1="print_routes.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form class=\"col-sm-12 margin-top-40 remove-pad form-validate\" name=\"Form\" novalidate>\n<div class=\"form-row d-flex-end\">\n<div class=\"text-input-section\">\n<div class=\"branch-mgmt-dd-or-search-section\">\n<search-and-select ng-model=\"$ctrl.model.route\" set-id=\"route\" values=\"$ctrl.routes\" key=\"Key\" totalrecords=\"$ctrl.totalRoutes\" onscroll=\"$ctrl.loadRoutes()\" on-click=\"$ctrl.loadRouteData()\" common-search-flag=\"true\" none-selected=\"'common.select'\" required></search-and-select>\n</div>\n</div>\n<div class=\"item-status-timezone-dd-section\">\n<div class=\"btn-div\">\n<select class=\"form-control\" required ng-model=\"$ctrl.model.timezone\" ng-options=\"timezone.value as timezone.label for timezone in $ctrl.model.timezoneList\" ng-disabled=\"$ctrl.loading || !$ctrl.model.route\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-4\"></div>\n<div class=\"col-sm-4\">\n<div class=\"col-sm-2\"></div>\n<div class=\"col-sm-8 padding-zero\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" ng-class=\"{'required-datetimepicker': !$ctrl.model.date}\" hidden-time=\"true\" ng-click=\"$ctrl.loadRoutes(); $ctrl.loadRouteData();\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n</div>\n<div class=\"col-sm-2 margin-top-05 remove-right-pad cash-deliveries-section\">\n<button class=\"btn btn-primary btn-xs\" ng-click=\"$ctrl.loadRouteData()\" ng-class=\"{'disabled': Form.$invalid || $ctrl.loading}\">\n{{'common.refresh' | translate}}\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading ||  $ctrl.model.loading}\"></span>\n</button>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n</form>\n<div class=\"row\">\n<div class=\"col-sm-12 margin-top-20\" ng-if=\"$ctrl.showData == true && !$ctrl.loading\">\n<div class=\"col-sm-12\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-5 pull-left font-size-20\">\n<strong>{{ 'route.route' | translate }}\n<span class=\"history-link-btn\" ng-click=\"$ctrl.goToRouteTab($ctrl.model.route.Value)\">{{$ctrl.model.route.Value}}</span>\n</strong> |\n<span class=\"text-success\"><b>{{$ctrl.translateRouteStatus($ctrl.model.routeStatsObj.routeDetails.routeStatus)}}</b></span>\n</div>\n<div class=\"col-sm-7 route-status-btn-section\">\n<button type=\"button\" class=\"btn btn-success btn-sm font-size-20\" ng-click=\"$ctrl.exportAllRouteStops()\">\nExport Route Stops\n</button>\n<button class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.sendDeliveryPickupReports(true, false)\" ng-if=\"$ctrl.model.route.autoCheckInUpdate\" ng-disabled=\"$ctrl.reportsObj[$ctrl.model.route.Value].sendDeliveryReports\">\n<span>{{'route.update_deliveries_processed' | translate}}</span>\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.reportsObj[$ctrl.model.route.Value].sendDeliveryReports\"></span>\n</button>\n<button class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.sendDeliveryPickupReports(false, true)\" ng-if=\"$ctrl.model.route.autoCheckInUpdate\" ng-disabled=\"$ctrl.reportsObj[$ctrl.model.route.Value].sendPickupReports\">\n<span>{{'route.update_pickups_processed' | translate}}</span>\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.reportsObj[$ctrl.model.route.Value].sendPickupReports\"></span>\n</button>\n<button class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.checkInManifest()\" ng-if=\"$ctrl.model.routeStatsObj.routeDetails.complTime\">\n<span>{{'checkin.print_checkin_manifest' | translate}}</span>\n</button>\n</div>\n</div>\n<div class=\"_remove-pad col-sm-12\">\n<div class=\"margin-top-05 pull-left font-size-15\">\n<span ng-if=\"$ctrl.model.routeStatsObj.routeDetails && $ctrl.model.routeStatsObj.routeDetails.vehicleId !== null\">\n<strong>{{ 'branch_mgmt.route_truck' | translate }}:</strong>\n{{$ctrl.model.routeStatsObj.routeDetails.vehicleId}} |\n</span>\n<span ng-if=\"$ctrl.model.routeStatsObj.routeDetails && $ctrl.model.routeStatsObj.routeDetails.driverId !== null\">\n<strong>{{ 'branch_mgmt.route_driver' | translate }}:</strong>\n{{$ctrl.model.routeStatsObj.routeDetails.driver}} ({{ $ctrl.model.routeStatsObj.routeDetails.driverId }}) |\n</span>\n<span ng-if=\"$ctrl.model.routeStatsObj.routeDetails && $ctrl.model.routeStatsObj.routeDetails.messengerId !== null\">\n<strong>{{ 'branch_mgmt.route_messenger' | translate }}:</strong>\n{{$ctrl.model.routeStatsObj.routeDetails.messenger}} ({{$ctrl.model.routeStatsObj.routeDetails.messengerId}})\n</span>\n</div>\n</div>\n<div class=\"w-100 form-horizontal\" ng-class=\"{'mt-4R': '$ctrl.model.routeStatsObj.routeDetails && (!$ctrl.model.routeStatsObj.routeDetails.vehicleId && !$ctrl.model.routeStatsObj.routeDetails.driverId && !$ctrl.model.routeStatsObj.routeDetails.messengerId', \n                                       'mt-7R': $ctrl.model.routeStatsObj.routeDetails && ($ctrl.model.routeStatsObj.routeDetails.vehicleId || $ctrl.model.routeStatsObj.routeDetails.driverId || $ctrl.model.routeStatsObj.routeDetails.messengerId)}\" ng-if=\"$ctrl.model.routeStatsObj.delivery\">\n<div class=\"progress-section\">\n<div class=\"progress-row\">\n<div class=\"left-label-section\">\n<div class=\"col\">\n<span><b>{{'location.startTime' | translate}}</b></span>\n</div>\n<div class=\"col\">\n<span class=\"text-success\">\n<b>{{$ctrl.DateUtil.convertDateTime($ctrl.model.routeStatsObj.routeDetails.leaveTime, $ctrl.model.timezone, 'hh:mm a')}}</b>\n</span>\n</div>\n</div>\n<div class=\"progress-bar-color\">\n<div id=\"myProgressbar\" class=\"progress routes-progress-bar-height\">\n<uib-progress class=\"routes-progress-bar-height\" max=\"$ctrl.model.routeStatsObj.routeStops.totalRouteStop\">\n<uib-bar value=\"$ctrl.model.routeStatsObj.routeStops.totalStopProcessed\">\n<timer autostart=\"false\" ng-if=\"$ctrl.model.routeStatsObj.routeDetails.leaveTime && !$ctrl.model.routeStatsObj.routeDetails.complTime\" start-time=\"$ctrl.convertToMillisecond($ctrl.model.routeStatsObj.routeDetails.leaveTime);\" interval=\"1000\" max-time-unit=\"'hour'\" ng-if=\"$ctrl.model.routeStatsObj.routeDetails.leaveTime\">\n<div class=\"route-timer-section\">\n<span>{{hours}}:{{mminutes}}:{{sseconds}}</span>\n</div>\n</timer>\n<div class=\"route-timer-section\" ng-if=\"$ctrl.model.routeStatsObj.routeDetails.leaveTime && $ctrl.model.routeStatsObj.routeDetails.complTime\">\n{{$ctrl.calculateDuration($ctrl.model.routeStatsObj.routeDetails.leaveTime, $ctrl.model.routeStatsObj.routeDetails.complTime)}}\n</div>\n</uib-bar>\n</uib-progress>\n</div>\n</div>\n<div class=\"count-value\">\n<span class=\"label label-primary font-weight-400 font-size-route-15\">{{$ctrl.model.routeStatsObj.routeStops.totalRouteStop}}</span>\n</div>\n</div>\n<div class=\"progress-row\">\n<div class=\"left-label-section\">\n<div class=\"col\">\n<span></span>\n<span><b>{{'routeControl.stops' | translate}}</b></span>\n</div>\n</div>\n<div class=\"progress-bar-color\">\n<div id=\"myProgressbar\" class=\"progress routes-progress-bar-height\">\n<uib-progress class=\"routes-progress-bar-height\" max=\"$ctrl.model.routeStatsObj.routeStops.totalRouteStop\">\n<uib-bar ng-repeat=\"bar in $ctrl.routeStopStackData track by $index\" value=\"bar.value\" type=\"{{bar.type}}\">\n<div class=\"route-stops-bar-section\">\n<span ng-if=\"bar.value\">{{bar.value}}</span>\n</div>\n</uib-bar>\n</uib-progress>\n</div>\n</div>\n<div class=\"count-value\">\n<span class=\"label label-success font-weight-400 font-size-route-15\">\n{{$ctrl.model.routeStatsObj.routeStops.totalStopProcessed}} / {{$ctrl.model.routeStatsObj.routeStops.totalRouteStop}}\n</span>\n</div>\n</div>\n<div class=\"progress-row\">\n<div class=\"left-label-section\">\n<div class=\"col\">\n<span><b>{{'branch_mgmt.route_deliveries' | translate }}</b></span>\n</div>\n<div class=\"col\">\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<label class=\"radio-btn-height btn btn-xs ignore-validation-css grp-btn-height-18\" ng-model=\"$ctrl.model.selectedDeliveryShipmentStats\" ng-class=\"{'btn-success': $ctrl.model.selectedDeliveryShipmentStats === $ctrl.model.deliveryShipmentStats.deliveryAmount,\n                                            'remove-btn-grp-color': $ctrl.model.selectedDeliveryShipmentStats === $ctrl.model.deliveryShipmentStats.deliveryCount}\" uib-btn-radio=\"$ctrl.model.deliveryShipmentStats.deliveryAmount\" ng-click=\"$ctrl.deliveryStateSelection('deliveryAmount')\">\n$\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"radio-btn-height btn btn-xs ignore-validation-css grp-btn-height-18\" ng-model=\"$ctrl.model.selectedDeliveryShipmentStats\" ng-class=\"{'btn-success': $ctrl.model.selectedDeliveryShipmentStats === $ctrl.model.deliveryShipmentStats.deliveryCount,\n                                            'remove-btn-grp-color': $ctrl.model.selectedDeliveryShipmentStats === $ctrl.model.deliveryShipmentStats.deliveryAmount}\" uib-btn-radio=\"$ctrl.model.deliveryShipmentStats.deliveryCount\" ng-click=\"$ctrl.deliveryStateSelection('deliveryCount')\">\n#\n</label>\n</div>\n</div>\n</div>\n</div>\n<div class=\"progress-bar-color\" ng-if=\"$ctrl.model.selectedDeliveryShipmentStats === $ctrl.model.deliveryShipmentStats.deliveryCount\">\n<div id=\"myProgressbar\" class=\"progress routes-progress-bar-height\">\n<uib-progress class=\"routes-progress-bar-height\" max=\"$ctrl.model.routeStatsObj.delivery.totaldeliveries\">\n<uib-bar ng-repeat=\"bar in $ctrl.deliveriesStack track by $index\" value=\"bar.value\" type=\"{{bar.type}}\">\n<div class=\"route-stops-bar-section\">\n<span ng-if=\"bar.value\">{{bar.value}}</span>\n</div>\n</uib-bar>\n</uib-progress>\n</div>\n</div>\n<div class=\"progress-bar-color\" ng-if=\"$ctrl.model.selectedDeliveryShipmentStats === $ctrl.model.deliveryShipmentStats.deliveryAmount\">\n<div id=\"myProgressbar\" class=\"progress routes-progress-bar-height\">\n<uib-progress class=\"routes-progress-bar-height\" max=\"$ctrl.model.routeStatsObj.delivery.totaldeliveries\">\n<uib-bar ng-repeat=\"bar in $ctrl.deliveryAmountStack track by $index\" value=\"bar.value\" type=\"{{bar.type}}\">\n<div class=\"route-stops-bar-section\">\n<span ng-if=\"bar.value > 0\">{{$ctrl.currencyFilter(bar.amount)}}</span>\n</div>\n</uib-bar>\n</uib-progress>\n</div>\n</div>\n<div class=\"count-value\">\n<button class=\"btn btn-primary btn-xs pull-left mr-5 font-size-route-13\" ng-if=\"$ctrl.model.selectedDeliveryShipmentStats === $ctrl.model.deliveryShipmentStats.deliveryCount\" ng-click=\"$ctrl.routeInfo('delivery')\">\n{{ $ctrl.model.routeStatsObj.delivery.delivered + $ctrl.model.routeStatsObj.delivery.cantDelivered }} / {{ $ctrl.model.routeStatsObj.delivery.totaldeliveries }}\n</button>\n<button class=\"btn btn-warning btn-xs font-size-route-13\" ng-click=\"$ctrl.shipmentsOnHoldInfo('delivery', 'holdDeliveries')\" ng-if=\"$ctrl.model.routeStatsObj.delivery.deliveriesOnHold && $ctrl.model.selectedDeliveryShipmentStats === $ctrl.model.deliveryShipmentStats.deliveryCount\">\n{{$ctrl.model.routeStatsObj.delivery.deliveriesOnHold}} / {{$ctrl.model.routeStatsObj.delivery.totaldeliveries}}\n</button>\n<span class=\"label label-success font-weight-400 font-size-route-15\" ng-if=\"$ctrl.model.selectedDeliveryShipmentStats === $ctrl.model.deliveryShipmentStats.deliveryAmount\">\n{{$ctrl.currencyFilter($ctrl.model.routeStatsObj.delivery.totalDeliveryShipmentAmount)}}\n</span>\n</div>\n</div>\n<div class=\"progress-row\">\n<div class=\"left-label-section\">\n<div class=\"col\">\n<span><b>{{'branch_mgmt.route_pickups' | translate }}</b></span>\n</div>\n<div class=\"col\">\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<label class=\"radio-btn-height btn btn-xs ignore-validation-css grp-btn-height-18\" ng-model=\"$ctrl.model.selectedPickupShipmentStats\" ng-class=\"{'btn-success': $ctrl.model.selectedPickupShipmentStats === $ctrl.model.pickupShipmentStats.pickupAmount,\n                                            'remove-btn-grp-color': $ctrl.model.selectedPickupShipmentStats === $ctrl.model.pickupShipmentStats.pickupCount}\" uib-btn-radio=\"$ctrl.model.pickupShipmentStats.pickupAmount\" ng-click=\"$ctrl.pickupStateSelection('pickupAmount')\">\n$\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"radio-btn-height btn btn-xs ignore-validation-css grp-btn-height-18\" ng-model=\"$ctrl.model.selectedPickupShipmentStats\" ng-class=\"{'btn-success': $ctrl.model.selectedPickupShipmentStats === $ctrl.model.pickupShipmentStats.pickupCount,\n                                            'remove-btn-grp-color': $ctrl.model.selectedPickupShipmentStats === $ctrl.model.pickupShipmentStats.pickupAmount}\" uib-btn-radio=\"$ctrl.model.pickupShipmentStats.pickupCount\" ng-click=\"$ctrl.pickupStateSelection('pickupCount')\">\n#\n</label>\n</div>\n</div>\n</div>\n</div>\n<div class=\"progress-bar-color\" ng-if=\"$ctrl.model.selectedPickupShipmentStats === $ctrl.model.pickupShipmentStats.pickupCount\">\n<div id=\"myProgressbar\" class=\"progress routes-progress-bar-height remove-bottom-margin\">\n<uib-progress class=\"routes-progress-bar-height\" max=\"$ctrl.model.routeStatsObj.pickups.totalPickups\">\n<uib-bar ng-repeat=\"bar in $ctrl.pickupsStack track by $index\" value=\"bar.value\" type=\"{{bar.type}}\">\n<div class=\"route-stops-bar-section\">\n<span ng-if=\"bar.value\">{{bar.value}}</span>\n</div>\n</uib-bar>\n</uib-progress>\n</div>\n</div>\n<div class=\"progress-bar-color\" ng-if=\"$ctrl.model.selectedPickupShipmentStats === $ctrl.model.pickupShipmentStats.pickupAmount\">\n<div id=\"myProgressbar\" class=\"progress routes-progress-bar-height remove-bottom-margin\">\n<uib-progress class=\"routes-progress-bar-height\" max=\"$ctrl.model.routeStatsObj.pickups.totalPickupShipmentAmount\">\n<uib-bar value=\"$ctrl.model.routeStatsObj.pickups.totalpickedUpShipmentAmount\" type=\"success\">\n<div class=\"route-stops-bar-section\" ng-if=\"$ctrl.model.routeStatsObj.pickups.totalpickedUpShipmentAmount > 0\">\n<span>{{$ctrl.currencyFilter($ctrl.model.routeStatsObj.pickups.totalpickedUpShipmentAmount)}}</span>\n</div>\n</uib-bar>\n</uib-progress>\n</div>\n</div>\n<div class=\"count-value\">\n<button ng-if=\"$ctrl.model.selectedPickupShipmentStats === $ctrl.model.pickupShipmentStats.pickupCount\" class=\"btn btn-primary btn-xs pull-left mr-5 font-size-route-13\" ng-click=\"$ctrl.routeInfo('pickups')\">\n{{ $ctrl.model.routeStatsObj.pickups.pickedup }} / {{ $ctrl.model.routeStatsObj.pickups.totalPickups }}\n</button>\n<button ng-if=\"$ctrl.model.selectedPickupShipmentStats === $ctrl.model.pickupShipmentStats.pickupCount && $ctrl.model.routeStatsObj.pickups.pickupsOnHold\" class=\"btn btn-warning btn-xs font-size-route-13\" ng-click=\"$ctrl.shipmentsOnHoldInfo('pickups', 'holdPickups')\" ng-if=\"$ctrl.model.routeStatsObj.pickups.pickupsOnHold\">{{$ctrl.model.routeStatsObj.pickups.pickupsOnHold}} / {{$ctrl.model.routeStatsObj.pickups.totalPickups}}\n</button>\n<span class=\"label label-success font-weight-400 font-size-route-15\" ng-if=\"$ctrl.model.selectedPickupShipmentStats === $ctrl.model.pickupShipmentStats.pickupAmount\">\n{{$ctrl.currencyFilter($ctrl.model.routeStatsObj.pickups.totalPickupShipmentAmount)}}\n</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row margin-bottom-30 margin-10\">\n<div class=\"w-85 routes-margin-auto\" ng-show=\"$ctrl.showData == true && !$ctrl.loading\">\n<div class=\"panel panel-default margin-10 remove-bottom-pad routes-shipment-section\" ng-repeat=\"bucket in $ctrl.model.buckets track by $index\" ng-if=\"(!$ctrl.loading && $ctrl.model.routeStatsObj.buckets[bucket.title] && $ctrl.model.routeStatsObj.buckets[bucket.title].results.length ||\n            (bucket.title === 'DELIVERED' || bucket.title === 'PICKEDUP' || bucket.title === 'PENDING' || bucket.title === 'PENDING_PICKUP'))\">\n<div class=\"cursor-pointer panel-heading\">\n<div class=\"row panel-title panel-title-center bucket_text_align_center remove-left-padd remove-right-padd\">\n<div class=\"col-sm-10 remove-left-padd remove-right-padd\" ng-click=\"bucket.bucketExpanded=!bucket.bucketExpanded; $ctrl.autoCloseTable(bucket); $ctrl.setStatusExpanded(bucket.title)\">\n<i class=\"glyphicon glyphicon-triangle-bottom\" ng-show=\"bucket.bucketExpanded\"></i>\n<i class=\"glyphicon glyphicon-triangle-right\" ng-hide=\"bucket.bucketExpanded\"></i>\n<strong class=\"f-14\">{{$ctrl.getBucketName(bucket.title)}}</strong>\n<span class=\"badge\" ng-class=\"{'complete-bucket-color': (bucket.title === 'DELIVERED' || bucket.title === 'PICKEDUP'),\n                                                  'assigned-bucket-color': (bucket.title === 'PENDING' || bucket.title === 'PENDING_PICKUP'),\n                                                  'hold-bucket-color':(bucket.title === 'SHORT_LOAD' || bucket.title === 'CRV'),\n                                                  'cant-completed-bucket-color':(bucket.title === 'NOT_LOADED_OR_NOT_DELIVERED'),\n                                                  'cant-top-route-status-bucket-color':(bucket.title === 'CANT_STOP' || bucket.title === 'NOT_WORKED'),\n                                                  'hold-amount-color':(bucket.title === 'HOLD'),\n                                                  'shipment-transaction-btn-color': (bucket.title === 'NO_PICKUP')\n                                      }\">\n{{$ctrl.model.routeStatsObj.buckets[bucket.title].results.length || 0}}\n</span>\n</div>\n<div class=\"col-sm-2 tools-d-flex-end pull-right text-right remove-right-padd\" ng-if=\"bucket.title !== 'NO_PICKUP'\">\n<strong ng-class=\"{'delivered-shp-amount-color': (bucket.title === 'DELIVERED' || bucket.title === 'PICKEDUP'),\n                        'pending-shp-amount-color': (bucket.title === 'PENDING' || bucket.title === 'PENDING_PICKUP'),\n                        'short-load-shp-amount-color':(bucket.title === 'SHORT_LOAD' || bucket.title === 'CRV'),\n                        'not-delivered-amount-color':(bucket.title === 'NOT_LOADED_OR_NOT_DELIVERED'),\n                        'hold-shp-amount-color':(bucket.title === 'HOLD'),\n                        'cant-stop-amount-color': (bucket.title === 'CANT_STOP')}\">\n{{$ctrl.currencyFilter($ctrl.model.routeStatsObj.buckets[bucket.title].amount || 0)}}\n</strong>\n</div>\n<div class=\"right-pad-10 tools-d-flex-end pull-right text-right remove-right-padd\" ng-if=\"bucket.title === 'CANT_STOP'\">\n<button type=\"button\" class=\"btn btn-success btn-sm pull-right\" ng-click=\"$ctrl.print('Cant Stop', 'cant', $ctrl.model.routeStatsObj.buckets['CANT_STOP'].results)\">\n{{'branch_mgmt.itemHistory.print' | translate}}\n</button>\n</div>\n<div class=\"col-sm-2 tools-d-flex-end pull-right text-right remove-right-padd\" ng-if=\"bucket.title === 'NO_PICKUP'\">\n<button type=\"button\" class=\"btn btn-success btn-sm pull-right\" ng-click=\"$ctrl.print('No Pickup', 'noPickup', $ctrl.model.routeStatsObj.buckets['NO_PICKUP'].results)\">\n{{'branch_mgmt.itemHistory.print' | translate}}\n</button>\n</div>\n</div>\n</div>\n<div class=\"panel-body\">\n<div class=\"table-responsive\" ng-show=\"bucket.bucketExpanded && $ctrl.model.routeStatsObj.buckets[bucket.title] \n                             && $ctrl.model.routeStatsObj.buckets[bucket.title].results.length\">\n<table class=\"table table-striped table-hover table-bordered remove-bottom-pad table-pad-5\">\n<tbody>\n<tr ng-repeat=\"shipments in $ctrl.model.routeStatsObj.buckets['PENDING'].results | orderBy : 'routeSeq' track by $index\" ng-if=\"bucket.title === 'PENDING'\">\n<td rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div class=\"align-left col-sm-12\">\n<span>\n<img ng-src=\"{{$ctrl.loadImage(shipments.locationType)}}\" class=\"custom-icon loc-type-w\" uib-tooltip=\"{{shipments.locationType}}\" tooltip-placement=\"right-bottom\"/>\n</span>\n<span class=\"loc-type-section\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipments.toLocationId)\">{{shipments.toLocationId}}</a>\n<span>| {{shipments.toLocationName}}</span>\n<span ng-if=\"shipments.stopPriority\"> | ({{$ctrl.ordinalSuffixOf(shipments.stopPriority)}})</span>\n<span class=\"shipment-transaction-badge _transaction-count-badge\" ng-if=\"shipments.totalComments > 0\">\n<span class=\"badge shipment-transaction-btn-color _transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.stopCommentsModal(shipments)\" uib-tooltip=\"{{'routeProgress.stop_comments' | translate}}\" tooltip-placement=\"right-bottom\">\n<span>!</span>\n</span>\n</span>\n</span>\n</div>\n</td>\n<td>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"'MultiDenomCash'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{$ctrl.getOrderType(shipments.shipTypeId, shipments.orderType)}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n</span>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && !shipments.orderNo\">\n<denom-icon denom-id=\"'bag-off'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.cash' | translate}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && !shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n</td>\n<td class=\"text-center\" ng-class=\"{'next-stop-color': $index === 0}\" rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<span class=\"font-size-17\" ng-if=\"$index === 0 && shipments.routeSeq >= 0\">{{'common.next' | translate}}</span>\n<span class=\"font-size-17\" ng-if=\"$index !== 0 && shipments.routeSeq >= 0\">{{$ctrl.ordinalSuffixOf(shipments.routeSeq)}}</span>\n<span class=\"font-size-17\" ng-if=\"shipments.routeSeq < 0\">{{'common.n_a' | translate}}</span>\n</td>\n</tr>\n<tr ng-repeat=\"shipments in $ctrl.model.routeStatsObj.buckets['DELIVERED'].results track by $index\" ng-if=\"bucket.title === 'DELIVERED'\">\n<td rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div class=\"align-left col-sm-12\">\n<span>\n<img ng-src=\"{{$ctrl.loadImage(shipments.locationType)}}\" class=\"custom-icon loc-type-w\" uib-tooltip=\"{{shipments.locationType}}\" tooltip-placement=\"right-bottom\"/>\n</span>\n<span class=\"loc-type-section\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipments.toLocationId)\">{{shipments.toLocationId}}</a>\n<span> | {{shipments.toLocationName}}</span>\n<span ng-if=\"shipments.stopPriority\"> | ({{$ctrl.ordinalSuffixOf(shipments.stopPriority)}})</span>\n</span>\n<span class=\"shipment-transaction-badge _transaction-count-badge\" ng-if=\"shipments.totalComments > 0\">\n<span class=\"badge shipment-transaction-btn-color _transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.stopCommentsModal(shipments)\" uib-tooltip=\"{{'routeProgress.stop_comments' | translate}}\" tooltip-placement=\"right-bottom\">\n<span>!</span>\n</span>\n</span>\n</div>\n</td>\n<td>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"'MultiDenomCash'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{$ctrl.getOrderType(shipments.shipTypeId, shipments.orderType)}} |\n<span ng-class=\"{'text-danger': (shipments.loadedAmount > 0) && (shipments.loadedAmount != shipments.amount)}\">\n{{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }}\n<span ng-if=\"(shipments.loadedAmount > 0) && (shipments.loadedAmount != shipments.amount)\"> | {{$ctrl.currencyFilter(shipments.loadedAmount)}} {{ shipments.amountFlag ? shipments.loadedAmount - shipments.amount | currency:fraction:\"0\" : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }}\n</span>\n</span> |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipments, 'delivery')\" ng-if=\"shipments.deliveryImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && !shipments.orderNo\">\n<denom-icon denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{shipments.shipTypeId}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipments, 'delivery')\" ng-if=\"shipments.deliveryImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && !shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{shipments.description}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{shipments.description}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n</td>\n<td class=\"text-center\" rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div><img src=\"" + __webpack_require__(89) + "\" height=\"40\"></div>\n<div class=\"routes-font-size\">\n{{$ctrl.DateUtil.convertDateTime(shipments.deliveryDate, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}\n<span ng-if=\"shipments.receivedByName\"><b>({{shipments.receivedByName}})</b></span>\n</div>\n</td>\n</tr>\n<tr ng-repeat=\"shipments in $ctrl.model.routeStatsObj.buckets['SHORT_LOAD'].results track by $index\" ng-if=\"bucket.title === 'SHORT_LOAD'\">\n<td rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div class=\"align-left col-sm-12\">\n<span>\n<img ng-src=\"{{$ctrl.loadImage(shipments.locationType)}}\" class=\"custom-icon loc-type-w\" uib-tooltip=\"{{shipments.locationType}}\" tooltip-placement=\"right-bottom\"/>\n</span>\n<span class=\"loc-type-section\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipments.toLocationId)\">{{shipments.toLocationId}}</a>\n<span> | {{shipments.toLocationName}}</span>\n<span ng-if=\"shipments.stopPriority\"> | ({{$ctrl.ordinalSuffixOf(shipments.stopPriority)}})</span>\n</span>\n<span class=\"shipment-transaction-badge _transaction-count-badge\" ng-if=\"shipments.totalComments > 0\">\n<span class=\"badge shipment-transaction-btn-color _transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.stopCommentsModal(shipments)\" uib-tooltip=\"{{'routeProgress.stop_comments' | translate}}\" tooltip-placement=\"right-bottom\">\n<span>!</span>\n</span>\n</span>\n</div>\n</td>\n<td>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"'MultiDenomCash'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{$ctrl.getOrderType(shipments.shipTypeId, shipments.orderType)}} |\n<span class=\"text-danger\">\n{{$ctrl.currencyFilter(shipments.shipmentAmount)}} | {{$ctrl.currencyFilter(shipments.loadedAmount)}} ({{shipments.loadedAmount - shipments.shipmentAmount | currency:fraction:\"0\"}}) |\n</span>\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n</span>\n</td>\n<td class=\"text-center\" rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div><img class=\"img-rotation-270\" src=\"" + __webpack_require__(396) + "\" height=\"38\"></div>\n<div class=\"routes-font-size text-danger\">{{$ctrl.currencyFilter(shipments.loadedAmount)}}</div>\n</td>\n</tr>\n<tr ng-repeat=\"shipments in $ctrl.model.routeStatsObj.buckets['NOT_LOADED_OR_NOT_DELIVERED'].results track by $index\" ng-if=\"bucket.title === 'NOT_LOADED_OR_NOT_DELIVERED'\">\n<td rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div class=\"align-left col-sm-12\">\n<span>\n<img ng-src=\"{{$ctrl.loadImage(shipments.locationType)}}\" class=\"custom-icon loc-type-w\" uib-tooltip=\"{{shipments.locationType}}\" tooltip-placement=\"right-bottom\"/>\n</span>\n<span class=\"loc-type-section\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipments.toLocationId)\">{{shipments.toLocationId}}</a>\n<span> | {{shipments.toLocationName}}</span>\n<span ng-if=\"shipments.stopPriority\"> | ({{$ctrl.ordinalSuffixOf(shipments.stopPriority)}})</span>\n<span class=\"shipment-transaction-badge _transaction-count-badge\" ng-if=\"shipments.totalComments > 0\">\n<span class=\"badge shipment-transaction-btn-color _transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.stopCommentsModal(shipments)\" uib-tooltip=\"{{'routeProgress.stop_comments' | translate}}\" tooltip-placement=\"right-bottom\">\n<span>!</span>\n</span>\n</span>\n</span>\n</div>\n</td>\n<td>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"'MultiDenomCash'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{$ctrl.getOrderType(shipments.shipTypeId, shipments.orderType)}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.shipmentAmount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipments, 'delivery')\" ng-if=\"shipments.deliveredFlag && shipments.deliveryImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && !shipments.orderNo\">\n<denom-icon denom-id=\"'bag-off'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.cash' | translate}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.shipmentAmount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipments, 'delivery')\" ng-if=\"shipments.deliveredFlag && shipments.deliveryImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && !shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{shipments.description}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.shipmentAmount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n</td>\n<td class=\"text-center\">\n<div ng-if=\"!shipments.deliveredFlag\"><img src=\"" + __webpack_require__(69) + "\" height=\"40\"></div>\n<div ng-if=\"!shipments.deliveredFlag\" class=\"routes-font-size text-danger\">\n{{$ctrl.currencyFilter(shipments.shipmentAmount)}}</div>\n<div ng-if=\"shipments.deliveredFlag\"><img src=\"" + __webpack_require__(89) + "\" height=\"40\"></div>\n<div ng-if=\"shipments.deliveredFlag\" class=\"routes-font-size\">\n{{$ctrl.DateUtil.convertDateTime(shipments.deliveryDate, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}\n</div>\n</td>\n</tr>\n<tr ng-repeat=\"shipments in $ctrl.model.routeStatsObj.buckets['PICKEDUP'].results track by $index\" ng-if=\"bucket.title === 'PICKEDUP'\">\n<td rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div class=\"align-left col-sm-12\">\n<span>\n<img ng-src=\"{{$ctrl.loadImage(shipments.fromLocationType)}}\" class=\"custom-icon loc-type-w\" uib-tooltip=\"{{shipments.fromLocationType}}\" tooltip-placement=\"right-bottom\"/>\n</span>\n<span class=\"loc-type-section\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipments.fromLocationId)\">{{shipments.fromLocationId}}</a>\n<span> | {{shipments.fromLocationName}}</span>\n<span ng-if=\"shipments.stopPriority\"> | ({{$ctrl.ordinalSuffixOf(shipments.stopPriority)}})</span>\n</span>\n<span class=\"shipment-transaction-badge _transaction-count-badge\" ng-if=\"shipments.totalComments > 0\">\n<span class=\"badge shipment-transaction-btn-color _transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.stopCommentsModal(shipments)\" uib-tooltip=\"{{'routeProgress.stop_comments' | translate}}\" tooltip-placement=\"right-bottom\">\n<span>!</span>\n</span>\n</span>\n</div>\n</td>\n<td>\n<span class=\"pad-left-10-block\" ng-if=\"!shipments.coinFlag  && shipments.orderNo\">\n<div style=\"display: flex; align-items: center;\">\n<span style=\"flex-shrink: 0;\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"></denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"></denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"></denom-icon>\n</span>\n<span style=\"display: block;\">\n<span class=\"routes-font-size\"> | {{$ctrl.getOrderType(shipments.shipTypeId, shipments.orderType)}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipments, 'pickup')\" ng-if=\"shipments.pickupImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n</div>\n<div ng-if=\"shipments.childDenominationDetails && shipments.childDenominationDetails.length > 0\" class=\"child-denom-section\">\n<span class=\"child-denom-label\">STC |</span>\n<span class=\"child-denom-list\">\n<span ng-repeat-start=\"child in shipments.childDenominationDetails\" class=\"child-denom-item\">\n<denom-icon ng-if=\"child.denominationId\" denom-id=\"child.denominationId\" icon-size=\"27\"></denom-icon>\n<span class=\"child-denom-text\">${{child.amount | currency:\"\":0}}</span>\n</span>\n<br ng-repeat-end ng-if=\"($index + 1) % 4 === 0 && !$last\">\n</span>\n</div>\n</span>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && !shipments.orderNo\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{$ctrl.getOrderType(shipments.shipTypeId, shipments.orderType)}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipments, 'pickup')\" ng-if=\"shipments.pickupImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && !shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{shipments.description}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{shipments.description}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n</td>\n<td class=\"text-center\" rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div><img class=\"img-rotation-90\" src=\"" + __webpack_require__(243) + "\" height=\"38\"></div>\n<div class=\"routes-font-size\">{{$ctrl.DateUtil.convertDateTime(shipments.pickupDate, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}</div>\n</td>\n</tr>\n<tr ng-repeat=\"shipments in $ctrl.model.routeStatsObj.buckets['PENDING_PICKUP'].results track by $index\" ng-if=\"bucket.title === 'PENDING_PICKUP'\">\n<td rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div class=\"align-left col-sm-12\">\n<span>\n<img ng-src=\"{{$ctrl.loadImage(shipments.fromLocationType)}}\" class=\"custom-icon loc-type-w\" uib-tooltip=\"{{shipments.fromLocationType}}\" tooltip-placement=\"right-bottom\"/>\n</span>\n<span class=\"loc-type-section\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipments.fromLocationId)\">{{shipments.fromLocationId}}</a>\n<span> | {{shipments.fromLocationName}}</span>\n<span ng-if=\"shipments.stopPriority\"> | ({{$ctrl.ordinalSuffixOf(shipments.stopPriority)}})</span>\n</span>\n<span class=\"shipment-transaction-badge _transaction-count-badge\" ng-if=\"shipments.totalComments > 0\">\n<span class=\"badge shipment-transaction-btn-color _transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.stopCommentsModal(shipments)\" uib-tooltip=\"{{'routeProgress.stop_comments' | translate}}\" tooltip-placement=\"right-bottom\">\n<span>!</span>\n</span>\n</span>\n</div>\n</td>\n<td>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{$ctrl.getOrderType(shipments.shipTypeId, shipments.orderType)}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipments, 'pickup')\" ng-if=\"shipments.pickupImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && !shipments.orderNo\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{$ctrl.getOrderType(shipments.shipTypeId, shipments.orderType)}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipments, 'pickup')\" ng-if=\"shipments.pickupImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && !shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{shipments.description}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{shipments.description}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n</td>\n<td class=\"text-center\" rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div><img class=\"img-rotation-90\" src=\"" + __webpack_require__(243) + "\" height=\"38\"></div>\n<div class=\"routes-font-size\">\n{{$ctrl.DateUtil.convertDateTime(shipments.pickupDate, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}</div>\n</td>\n</tr>\n<tr ng-repeat=\"stop in $ctrl.model.routeStatsObj.buckets['NO_PICKUP'].results track by $index\" ng-if=\"bucket.title === 'NO_PICKUP'\">\n<td>\n<div class=\"align-left col-sm-12\">\n<span>\n<img ng-src=\"{{$ctrl.loadImage(stop.locationType)}}\" class=\"custom-icon loc-type-w\" uib-tooltip=\"{{stop.locationType}}\" tooltip-placement=\"right-bottom\"/>\n</span>\n<span class=\"loc-type-section\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(stop.locationId)\">{{stop.locationId}}</a>\n<span> | {{stop.locationName}}</span>\n<span ng-if=\"stop.stopPriority\"> | ({{$ctrl.ordinalSuffixOf(stop.stopPriority)}})</span>\n</span>\n<span class=\"shipment-transaction-badge _transaction-count-badge\">\n<span class=\"badge shipment-transaction-btn-color _transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.stopCommentsModal(stop)\" uib-tooltip=\"{{'routeProgress.stop_comments' | translate}}\" tooltip-placement=\"right-bottom\">\n<span>!</span>\n</span>\n</span>\n</div>\n</td>\n<td><span class=\"pad-left-10\">{{stop.address}}</span></td>\n<td class=\"text-center\">\n<div><img src=\"" + __webpack_require__(69) + "\" height=\"40\"></div>\n<span>{{$ctrl.DateUtil.convertDateTime(stop.completedTime, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}</span>\n</td>\n</tr>\n<tr ng-repeat=\"shipments in $ctrl.model.routeStatsObj.buckets['CANT_STOP'].results track by $index\" ng-if=\"bucket.title === 'CANT_STOP'\">\n<td rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div class=\"align-left col-sm-12\">\n<span>\n<img ng-src=\"{{$ctrl.loadImage(shipments.locationType)}}\" class=\"custom-icon loc-type-w\" uib-tooltip=\"{{shipments.locationType}}\" tooltip-placement=\"right-bottom\"/>\n</span>\n<span class=\"loc-type-section\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipments.locationId)\">{{shipments.locationId}}</a>\n<span> | {{shipments.locationName}}</span>\n<span ng-if=\"shipments.stopPriority\"> | ({{$ctrl.ordinalSuffixOf(shipments.stopPriority)}})</span>\n</span>\n<span class=\"shipment-transaction-badge _transaction-count-badge\" ng-if=\"shipments.totalComments > 0\">\n<span class=\"badge shipment-transaction-btn-color _transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.stopCommentsModal(shipments)\" uib-tooltip=\"{{'routeProgress.stop_comments' | translate}}\" tooltip-placement=\"right-bottom\">\n<span>!</span>\n</span>\n</span>\n<span class=\"margin-left-5\" ng-if=\"shipments.comments\">\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.getComments(shipments.comments)\" uib-tooltip=\"{{'checkout.comments' | translate}}\" tooltip-append-to-body=\"true\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</span>\n</div>\n</td>\n<td ng-if=\"shipments.shipmentId\">\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"'MultiDenomCash'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{$ctrl.getOrderType(shipments.shipTypeId, shipments.orderType)}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<span class=\"shipment-transaction-badge _transaction-count-badge\" ng-if=\"shipments.notDeliveredResolution\">\n<span class=\"badge shipment-transaction-btn-color _transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.notDeliveredResolutionModal(shipments.trackingId, shipments.notDeliveredResolution)\" uib-tooltip=\"{{'message.types.NDR' | translate}}\" tooltip-placement=\"right-bottom\">\n<span>!</span>\n</span>\n</span>\n</span>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && !shipments.orderNo\">\n<denom-icon denom-id=\"'bag-off'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.cash' | translate}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<span class=\"shipment-transaction-badge _transaction-count-badge\" ng-if=\"shipments.notDeliveredResolution\">\n<span class=\"badge shipment-transaction-btn-color _transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.notDeliveredResolutionModal(shipments.trackingId, shipments.notDeliveredResolution)\" uib-tooltip=\"{{'message.types.NDR' | translate}}\" tooltip-placement=\"right-bottom\">\n<span>!</span>\n</span>\n</span>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && !shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{shipments.description}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{shipments.description}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n</td>\n<td ng-if=\"!shipments.shipmentId\"><span class=\"pad-left-10\">{{shipments.address}}</span></td>\n<td class=\"text-center\" rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div><img src=\"" + __webpack_require__(69) + "\" height=\"40\"></div>\n<span>{{$ctrl.DateUtil.convertDateTime(shipments.completedTime, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}</span>\n</td>\n</tr>\n<tr ng-repeat=\"stop in $ctrl.model.routeStatsObj.buckets['NOT_WORKED'].results track by $index\" ng-if=\"bucket.title === 'NOT_WORKED' && $ctrl.model.routeStatsObj.routeDetails.complTime\">\n<td>\n<div class=\"align-left col-sm-12\">\n<span>\n<img ng-src=\"{{$ctrl.loadImage(stop.locationType)}}\" class=\"custom-icon loc-type-w\" uib-tooltip=\"{{stop.locationType}}\" tooltip-placement=\"right-bottom\"/>\n</span>\n<span class=\"loc-type-section\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(stop.locationId)\">{{stop.locationId}}</a>\n<span> | {{stop.locationName}}</span>\n<span ng-if=\"stop.stopPriority\"> | ({{$ctrl.ordinalSuffixOf(stop.stopPriority)}})</span>\n</span>\n</div>\n</td>\n<td><span class=\"pad-left-10\">{{stop.address}}</span></td>\n<td class=\"text-center\">\n<span ng-if=\"stop.completedTime\"> {{stop.completedTime | date : 'MM-dd-yyyy | hh:mm a'}}</span>\n</td>\n</tr>\n<tr ng-repeat=\"shipments in $ctrl.model.routeStatsObj.buckets['CRV'].results track by $index\" ng-if=\"bucket.title === 'CRV'\">\n<td rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div class=\"align-left col-sm-12\">\n<span>\n<img ng-src=\"{{$ctrl.loadImage(shipments.locationType)}}\" class=\"custom-icon loc-type-w\" uib-tooltip=\"{{shipments.locationType}}\" tooltip-placement=\"right-bottom\"/>\n</span>\n<span class=\"loc-type-section\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipments.locationId)\">{{shipments.locationId}}</a>\n<span> | {{shipments.locationName}}</span>\n<span ng-if=\"shipments.stopPriority\"> | ({{$ctrl.ordinalSuffixOf(shipments.stopPriority)}})</span>\n</span>\n</div>\n</td>\n<td ng-if=\"shipments.shipmentId\">\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"'MultiDenomCash'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{$ctrl.getOrderType(shipments.shipTypeId, shipments.orderType)}} | {{$ctrl.currencyFilter(shipments.amount)}} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<button type=\"button\" class=\"btn btn-xs btn-success btn-icon btn-cst-height-22 denom-btn\" ng-click=\"$ctrl.redirectToATMCount(shipments)\" uib-tooltip=\"{{'common.side_menu.atm_count' | translate}}\">\n<span class=\"glyphicon glyphicon-arrow-right\"></span>\n</button>\n</span>\n</td>\n<td class=\"text-center\" rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<span>{{$ctrl.DateUtil.convertDateTime(shipments.completedTime, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}</span>\n</td>\n</tr>\n<tr ng-repeat=\"shipments in $ctrl.model.routeStatsObj.buckets['HOLD'].results track by $index\" ng-if=\"bucket.title === 'HOLD'\">\n<td>\n<div class=\"align-left col-sm-12\">\n<span>\n<img ng-src=\"{{$ctrl.loadImage(shipments.locationType)}}\" class=\"custom-icon loc-type-w\" uib-tooltip=\"{{shipments.locationType}}\" tooltip-placement=\"right-bottom\"/>\n</span>\n<span class=\"loc-type-section\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(shipments.toLocationId)\">{{shipments.toLocationId}}</a>\n<span> | {{shipments.toLocationName}}</span>\n<span ng-if=\"shipments.stopPriority\"> | ({{$ctrl.ordinalSuffixOf(shipments.stopPriority)}})</span>\n</span>\n</div>\n</td>\n<td>\n<span class=\"pad-left-10-block\" ng-if=\"!shipments.coinFlag && shipments.orderNo\">\n<div style=\"display: flex; align-items: center;\">\n<span style=\"flex-shrink: 0;\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"></denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"></denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"></denom-icon>\n</span>\n<span style=\"display: block;\">\n<span class=\"routes-font-size\"> | {{$ctrl.getOrderType(shipments.shipTypeId, shipments.orderType)}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipments, 'pickup')\" ng-if=\"shipments.pickupImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n</div>\n<div ng-if=\"shipments.childDenominationDetails && shipments.childDenominationDetails.length > 0\" class=\"child-denom-section\">\n<span class=\"child-denom-label\">STC |</span>\n<span class=\"child-denom-list\">\n<span ng-repeat-start=\"child in shipments.childDenominationDetails\" class=\"child-denom-item\">\n<denom-icon ng-if=\"child.denominationId\" denom-id=\"child.denominationId\" icon-size=\"27\"></denom-icon>\n<span class=\"child-denom-text\">${{child.amount | currency:\"\":0}}</span>\n</span>\n<br ng-repeat-end ng-if=\"($index + 1) % 4 === 0 && !$last\">\n</span>\n</div>\n</span>\n<span class=\"pad-left-10\" ng-if=\"!shipments.coinFlag && !shipments.orderNo\">\n<denom-icon ng-if=\"shipments.denominationId\" denom-id=\"shipments.denominationId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && shipments.isBagout\" denom-id=\"'bag-off-green'\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"!shipments.denominationId && !shipments.isBagout\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.cash' | translate}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} |\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a>\n</span>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipments, 'pickup')\" ng-if=\"shipments.pickupImageName\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && !shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{shipments.description}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n<span class=\"pad-left-10\" ng-if=\"shipments.coinFlag && shipments.orderNo\">\n<denom-icon ng-if=\"shipments.shipTypeId !== 'M'\" denom-id=\"shipments.shipTypeId\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"shipments.shipTypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<span class=\"routes-font-size\"> | {{'common.coin' | translate}} |\n<span class=\"text-danger\" ng-if=\"shipments.amountFlag\">x{{shipments.qty}}</span>\n<span ng-if=\"shipments.amountFlag\"> | </span>\n{{shipments.description}} | {{ shipments.amountFlag ? $ctrl.currencyFilter(shipments.amount) : ((('branch_mgmt.routes.qty' | translate) + ': ') + (shipments.qty != null ? shipments.qty : 'N/A')) }} | <a href=\"#\" ng-click=\"$ctrl.goToItemHistory(shipments.trackingId)\">\n{{shipments.trackingId}}\n</a></span>\n</span>\n</td>\n<td class=\"text-center\" rowspan=\"{{shipments.cursor}}\" ng-if=\"!shipments.matchPreviousRow\">\n<div class=\"routes-font-size\">{{$ctrl.DateUtil.convertDateTime(shipments.holdCreatedAt, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm a')}}</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="routes.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2701 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"row_\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-offset-4 col-sm-4 font-size-20 text-center\">\n<b>{{'branch_mgmt.stop_performance.title' | translate}}</b>\n<hr>\n</div>\n<div class=\"col-sm-12\"><hr class=\"cash-variances-line-section\"></div>\n<div class=\"col-sm-12 cash-variances-search-section remove-left-pad remove-right-pad margin-10\">\n<div class=\"col-sm-3\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.searchText\" name=\"searchText\" id=\"stopPerformanceSearch\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.loadData()\" placeholder=\"{{'common.locationId' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-disabled=\"$ctrl.model.stopPerformanceObj.loading\"/>\n</div>\n<div class=\"vault-operation-date-picker-w-23\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" ng-change=\"$ctrl.loadData();\" options=\"$ctrl.model.dateRangPickerOptionsfor\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled': $ctrl.model.loadCountVariances}\"/>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"multi-select location-branch-dd\" ng-class=\"{'invalid-multi-select-value': !$ctrl.model.branch.length, 'valid-multi-select-value': $ctrl.model.branch.length}\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.model.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.getRouteList(searchKey, offset); $ctrl.loadData();\" on-select-all=\"$ctrl.getRouteList(searchKey, offset); $ctrl.loadData();\" on-select-none=\"$ctrl.resetData(); $ctrl.getRouteList(searchKey, offset); $ctrl.loadData();\" on-reset=\"$ctrl.resetData(); $ctrl.getRouteList(searchKey, offset); $ctrl.loadData();\" is-disabled=\"$ctrl.model.stopPerformanceObj.loading\">\n</div>\n</div>\n<div class=\"col-sm-3\">\n<search-and-select ng-model=\"$ctrl.model.routeId\" values=\"$ctrl.model.routeListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.routeListObj.totalRecords\" on-click=\"$ctrl.loadData()\" onscroll=\"$ctrl.getRouteList(searchKey, offset);\" ng-disabled=\"!$ctrl.model.selectedBranch || $ctrl.model.routeListObj.loading\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div class=\"col-sm-2 pull-right\">\n<select class=\"form-control\" required ng-model=\"$ctrl.model.timezone\" ng-options=\"timezone.value as timezone.label for timezone in $ctrl.model.timezoneList\" ng-change=\"$ctrl.loadData();\" ng-disabled=\"$ctrl.model.stopPerformanceObj.loading\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"pull-right export-btn-pad-5\" ng-if=\"$ctrl.model.stopPerformanceObj.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportData()\" ng-disabled=\"$ctrl.model.stopPerformanceObj.loading || $ctrl.model.isExporting\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExporting\"></span>\n{{'common.export' | translate}}</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-validate remove-padding\" novalidate>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.stopPerformanceObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div class=\"w-100\" ng-if=\"!$ctrl.model.stopPerformanceObj.loading && $ctrl.model.stopPerformanceObj.results.length\">\n<div class=\"col-sm-12 table-margin-top-10 remove-padding table-responsive\">\n<table class=\"table table-hover table-striped table-bordered font-12 table-pad-4\">\n<thead>\n<tr>\n<td class=\"text-center remove-white-space\" ng-click=\"$ctrl.sortData('locationId')\">{{'common.locationId' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('stopPriority')\">{{'location.stop_priority' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'stopPriority'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('routeMondayId')\">{{'location.mon' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeMondayId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('routeTuesdayId')\">{{'location.tues' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeTuesdayId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('routeWednesdayId')\">{{'location.wed' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeWednesdayId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('routeThursdayId')\">{{'location.thurs' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeThursdayId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('routeFridayId')\">{{'location.fri' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeFridayId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('routeSaturdayId')\">{{'location.sat' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeSaturdayId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('routeSundayId')\">{{'location.sun' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeSundayId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('numberOfPickups')\">{{'branch_mgmt.stop_performance.total_pickups' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'numberOfPickups'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('amountOfPickups')\">{{'branch_mgmt.stop_performance.pickup_amount' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountOfPickups'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('lastPickupDate')\">{{'branch_mgmt.stop_performance.last_pickup_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'lastPickupDate'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('numberOfDeliveries')\">{{'branch_mgmt.stop_performance.total_deliveries' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'numberOfDeliveries'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('amountOfDeliveries')\">{{'branch_mgmt.stop_performance.delivery_amount' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amountOfDeliveries'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortData('lastDeliveryDate')\">{{'branch_mgmt.stop_performance.last_delivery_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'lastDeliveryDate'}\"></span>\n</td>\n</tr></thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.stopPerformanceObj.results | orderBy:$ctrl.sortColumn:$ctrl.reverseSort\">\n<td class=\"text-center\"><a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.locationId)\">{{data.locationId}}</a></td>\n<td class=\"text-center\">\n<span ng-if=\"data.stopPriority !== null\">{{data.stopPriority}}</span>\n<span ng-if=\"data.stopPriority === null\" class=\"text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.routeMondayId\">{{data.routeMondayId}}</span>\n<span ng-if=\"!data.routeMondayId\" class=\"text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.routeTuesdayId\">{{data.routeTuesdayId}}</span>\n<span ng-if=\"!data.routeTuesdayId\" class=\"text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.routeWednesdayId\">{{data.routeWednesdayId}}</span>\n<span ng-if=\"!data.routeWednesdayId\" class=\"text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.routeThursdayId\">{{data.routeThursdayId}}</span>\n<span ng-if=\"!data.routeThursdayId\" class=\"text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.routeFridayId\">{{data.routeFridayId}}</span>\n<span ng-if=\"!data.routeFridayId\" class=\"text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.routeSaturdayId\">{{data.routeSaturdayId}}</span>\n<span ng-if=\"!data.routeSaturdayId\" class=\"text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.routeSundayId\">{{data.routeSundayId}}</span>\n<span ng-if=\"!data.routeSundayId\" class=\"text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">{{data.numberOfPickups | currency: \"\":0}}</td>\n<td class=\"text-center\">${{data.amountOfPickups}}</td>\n<td class=\"text-center\">\n<span ng-if=\"data.lastPickupDate\">{{data.lastPickupDate}}</span>\n<span ng-if=\"!data.lastPickupDate\" class=\"text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">{{data.numberOfDeliveries | currency: \"\":0}}</td>\n<td class=\"text-center\">${{data.amountOfDeliveries}}</td>\n<td class=\"text-center\">\n<span ng-if=\"data.lastDeliveryDate\">{{data.lastDeliveryDate}}</span>\n<span ng-if=\"!data.lastDeliveryDate\" class=\"text-danger\">{{'common.n_a' | translate}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"row col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.stopPerformanceObj.pagination.total > 10\">\n<ul uib-pagination total-items=\"$ctrl.model.stopPerformanceObj.pagination.total\" ng-hide=\"{{($ctrl.model.stopPerformanceObj.pagination.total<=$ctrl.model.stopPerformanceObj.pagination.pageLimit)&&($ctrl.model.stopPerformanceObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.stopPerformanceObj.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.stopPerformanceObj.loading && !$ctrl.model.stopPerformanceObj.results.length\" class=\"margin-top-20\">\n<span class=\"col-sm-12 matgin-top-20 alert alert-danger text-align-center\">\n{{'route_sheet.no_data_found' | translate}}\n</span>\n</div>\n</div>\n</div>\n</form>";
var id1="stop_performance.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2702 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"stops-scheduling remove-pad col-sm-12\">\n<div class=\"col-sm-12 font-size-20 text-center\">\n<b>{{'branch_mgmt.stop_scheduling.title' | translate}}</b>\n<hr class=\"remove-bottom-margin margin-10\">\n</div>\n<div class=\"remove-right-pad remove-left-pad col-sm-12 margin-top-20\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-6\">\n<div class=\"_col-sm-12 add-record-header-section remove-right-pad margin-bottom-10\">\n<span class=\"_form-group form-checbox\">\n<input type=\"checkbox\" name=\"fancy-checkbox-default\" ng-model=\"$ctrl.model.sameForAll\" ng-click=\"$ctrl.sameForAll()\" id=\"fancy-checkbox-default\" autocomplete=\"off\"/>\n<div class=\"btn-group btn-checkbox-group\">\n<label for=\"fancy-checkbox-default\" class=\"btn btn-default\">\n<span class=\"glyphicon glyphicon-ok\"></span>\n<span> </span>\n</label>\n<label for=\"fancy-checkbox-default\" class=\"btn btn-primary\">\n{{'location.sameForAll' | translate}}\n</label>\n</div>\n</span>\n<div>\n<button type=\"button\" class=\"btn btn-md btn-danger\" ng-click=\"$ctrl.resetData()\">\n{{'common.reset' | translate}}\n</button>\n</div>\n<div class=\"margin-top-02 pull-right\">\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.add();\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n</button>\n</div>\n</div>\n<div class=\"list-group margin-top-5 list-group-margin-bottom\">\n<div class=\"list-group-item scroll-view col-sm-12 remove-left-pad _remove-right-pad\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad add-records-section\" ng-repeat=\"stopObj in $ctrl.model.stopScheduling track by $index\">\n<div class=\"col-sm-5 remove-right-pad\">\n<search-and-select ng-model=\"stopObj.location\" values=\"$ctrl.model.locationObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.locationObj.totalLocation\" onscroll=\"$ctrl.loadLocation(searchKey, offset)\" none-selected=\"'common.select_location'\" ng-disabled=\"$ctrl.model.locationObj.loading\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-5 remove-right-pad\">\n<search-and-select ng-model=\"stopObj.route\" values=\"$ctrl.model.routeObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.routeObj.totalRoutes\" onscroll=\"$ctrl.loadRoutes(searchKey, offset)\" none-selected=\"'common.select_route'\" on-click=\"$ctrl.updateRoutes(stopObj.route);\" ng-disabled=\"$ctrl.model.routeObj.loading\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-2\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeRecords($index);\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"col-sm-12 margin-top-05\"><br/><br/></div>\n<div class=\"list-group margin-top-5 list-group-margin-bottom\">\n<div class=\"list-group-item col-sm-12 remove-left-pad _remove-right-pad\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 _remove-pad\">\n<div class=\"col-sm-6 remove-left-pad remove-right-pad margin-bottom-10 btn-group _btn-group-justified\">\n<a class=\"btn btn-xs\" ng-repeat=\"pattern in $ctrl.model.recurringPatternList\" ng-click=\"$ctrl.selectedPattern(pattern); $ctrl.resetRecurringData();\" ng-class=\"{'btn-primary': $ctrl.model.selectedPattern === pattern.value,\n                                                                                   'btn-default': $ctrl.model.selectedPattern !== pattern.value}\">\n{{pattern.label}}\n</a>\n</div>\n<div class=\"col-sm-5 scheduled margin-top-03 pull-right schedule-weeks-input remove-right-pad\" ng-if=\"$ctrl.model.selectedPattern === 'weekly'\">\n{{'master_cash_schedule.recur_every' | translate}}\n<input type=\"number\" min=\"1\" max=\"4\" required class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.recurWeeks\">\n{{'master_cash_schedule.weeks_on' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 daily-schedule-section-border scheduled _margin-top-03 daily-schedule-input\" ng-if=\"$ctrl.model.selectedPattern === 'daily'\">\n{{'master_cash_schedule.recur_every' | translate}}\n<input type=\"number\" min=\"1\" required class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.recurringDayInterval\"> {{'master_cash_schedule.days' | translate}}\n</div>\n<div class=\"scheduled-week-btn-section form-group _remove-left-pad _remove-right-pad col-sm-12 remove-bottom-margin\">\n<div id=\"service-schedule\" class=\"btn-group btn-group-justified\" ng-if=\"$ctrl.model.selectedPattern === 'weekly'\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.model.serviceSchedule\" ng-click=\"$ctrl.toggleDay(day)\" ng-class=\"{'btn-primary': $ctrl.isDaySelected(day),'btn-default': !$ctrl.isDaySelected(day)}\">\n{{day.label}}\n</a>\n</div>\n</div>\n<div class=\"col-sm-12 daily-schedule-section-border\" ng-if=\"$ctrl.model.selectedPattern === 'monthly'\">\n<div class=\"scheduled-week-btn-section _form-group remove-left-pad remove-right-pad col-sm-12\">\n<div id=\"service-schedule\" class=\"daily-schedule-input btn-group btn-group-justified\">\n<div class=\"col-sm-1 remove-pad\">\n<a class=\"btn btn-xs\" ng-click=\"$ctrl.getMonthlyPattern('day'); $ctrl.resetMothlyPattern();\" ng-class=\"{'btn-primary': $ctrl.selectedMonthlyPattern === 'day',\n                                                           'btn-default': $ctrl.selectedMonthlyPattern !== 'day'}\">\n{{'master_cash_schedule.day' | translate}}\n</a>\n</div>\n<input type=\"number\" min=\"1\" max=\"31\" ng-required=\"$ctrl.selectedMonthlyPattern === 'day'\" class=\"form-control\" placeholder=\"Day\" ng-model=\"$ctrl.model.recurringMonthObj.day.dayInterval\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'the'\">\n{{'master_cash_schedule.of_every' | translate}}\n<input type=\"number\" min=\"1\" max=\"12\" ng-required=\"$ctrl.selectedMonthlyPattern === 'day'\" class=\"form-control\" placeholder=\"Month\" ng-model=\"$ctrl.model.recurringMonthObj.day.monthInterval\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'the'\">\n{{'master_cash_schedule.months' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<hr class=\"monthly-schedule-line-section\"/>\n</div>\n<div class=\"the-month-padding _form-group remove-left-pad remove-right-pad col-sm-12 _margin-bottom-07\">\n<div id=\"service-schedule\" class=\"_daily-schedule-input btn-group btn-group-justified\">\n<div class=\"col-sm-1 remove-pad\">\n<a class=\"the-month-btn-padding btn btn-xs\" ng-click=\"$ctrl.getMonthlyPattern('the'); $ctrl.resetMothlyPattern();\" ng-class=\"{'btn-primary': $ctrl.selectedMonthlyPattern === 'the', \n                                                           'btn-default': $ctrl.selectedMonthlyPattern !== 'the'}\">\n{{'master_cash_schedule.the' | translate}}\n</a>\n</div>\n<div class=\"col-sm-3 remove-pad\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.recurringMonthObj.month.weekInterval\" ng-required=\"$ctrl.selectedMonthlyPattern === 'the'\" ng-options=\"week_interval.value as week_interval.lable for week_interval in $ctrl.model.recurringMonthObj.month.weekIntervalList\" ng-change=\"$ctrl.validateBillCount();\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'day'\">\n<option value=\"\" disabled=\"disabled\">({{'master_cash_schedule.select_week' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-3 remove-right-pad\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.recurringMonthObj.month.selectedWeekDay\" ng-required=\"$ctrl.selectedMonthlyPattern === 'the'\" ng-options=\"week_day.value as week_day.lable for week_day in $ctrl.model.recurringMonthObj.month.weekDayList\" ng-change=\"$ctrl.validateBillCount();\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'day'\">\n<option value=\"\" disabled=\"disabled\">({{'master_cash_schedule.select_weekDay' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-5 d-flex\">\n<span class=\"remove-white-space of-every-text-section\">{{'master_cash_schedule.of_every' | translate}}</span>\n<input type=\"number\" min=\"1\" max=\"12\" ng-required=\"$ctrl.selectedMonthlyPattern === 'the'\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.recurringMonthObj.month.monthInterval\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'day'\">\n<span class=\"months-text-section\">{{'master_cash_schedule.months' | translate}}</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 _remove-left-pad remove-right-pad margin-10\">\n<div class=\"col-sm-3 remove-left-pad\">\n<label>{{'master_cash_schedule.start_at' | translate}}</label>\n<datetimepicker class=\"edit-order-view-date-picker-section datetimepicker-input\" ng-model=\"$ctrl.model.recurringStartDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.validateEndDate();\" date-options=\"$ctrl.minRecurrStartDate\" ng-class=\"{'required-datetimepicker': !$ctrl.model.recurringStartDate}\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-3 remove-pad-right\">\n<label>{{'master_cash_schedule.end_by' | translate}}</label>\n<datetimepicker class=\"edit-order-view-date-picker-section datetimepicker-input\" ng-class=\"{'disabled': !$ctrl.model.recurringStartDate,\n                                               'required-datetimepicker': !$ctrl.model.recurringEndDate && !$ctrl.model.endRecurringAfter}\" ng-model=\"$ctrl.model.recurringEndDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.minRecurrDate\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6 d-flex margin-top-25\">\n<span class=\"remove-white-space of-every-text-section\">{{'master_cash_schedule.end_after' | translate}}</span>\n<input type=\"number\" min=\"1\" max=\"12\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.endRecurringAfter\" ng-required=\"!$ctrl.model.recurringEndDate && !$ctrl.model.endRecurringAfter\">\n<span class=\"months-text-section\">{{'master_cash_schedule.occurrences' | translate}}</span>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.confirmRecurring();\" ng-disabled=\"Form.$invalid\">\n{{'master_cash_schedule.make_recurring' | translate}}\n</button>\n</div>\n</div>\n</div>\n</div>\n</form>\n<div class=\"col-sm-12\">\n<hr class=\"remove-bottom-margin\">\n<div class=\"col-sm-12 font-size-20 text-center margin-10 margin-bottom-10\">\n<b class=\"ng-binding\">{{'location.pending_changes' | translate}}</b>\n</div>\n<form name=\"\" novalidate class=\"form-validate margin-10\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad pending-stops-list-section\">\n<div class=\"remove-left-pad col-sm-3\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.searchText\" name=\"searchText\" id=\"stopSchedulingSearch\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.getPendingChanges()\" placeholder=\"{{'common.search' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-disabled=\"$ctrl.pendingChangesObj.loading\"/>\n</div>\n<div class=\"remove-left-pad col-sm-3 remove-right-pad\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" options=\"$ctrl.model.dateRange\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled': $ctrl.pendingChangesObj.loading}\"/>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"multi-select location-branch-dd\" ng-class=\"{'invalid-multi-select-value': !$ctrl.model.selectedBranch.length, \n                                       'valid-multi-select-value': $ctrl.model.selectedBranch.length,\n                                       'disabled': $ctrl.pendingChangesObj.loading}\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.getPendingChanges();\" on-select-all=\"$ctrl.getPendingChanges();\" on-select-none=\"$ctrl.getPendingChanges();\" on-reset=\"$ctrl.getPendingChanges();\" selection-mode=\"single\" translation=\"$ctrl.localLang\">\n</div>\n</div>\n<div class=\"margin-top-01\">\n<button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.refreshPendingChanges($event)\" ng-disabled=\"$ctrl.pendingChangesObj.loading\">\n<span class=\"glyphicon glyphicon-refresh\" uib-tooltip=\"{{'common.refresh' | translate}}\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-padding table-margin-top-10 table-responsive margin-bottom-40\" ng-if=\"!$ctrl.pendingChangesObj.loading && $ctrl.pendingChangesObj.filteredResults.length > 0\">\n<table class=\"table table-striped table-bordered table-pad-4\">\n<thead class=\"text-center\">\n<tr>\n<td><strong>{{'location.when' | translate}}</strong></td>\n<td><strong>End After</strong></td>\n<td><strong>{{'common.vault_date' | translate}}</strong></td>\n<td><strong>{{'common.branch_id' | translate}}</strong></td>\n<td><strong>{{'common.location' | translate}}</strong></td>\n<td><strong>{{'bypassCode.route' | translate}}</strong></td>\n<td><strong>{{'routeProgress.sequence' | translate}}</strong></td>\n<td><strong>{{'common.action' | translate}}</strong></td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in $ctrl.pendingChangesObj.filteredResults track by $index\">\n<td ng-if=\"data.selectedPattern === 'daily'\">\n<span>{{data.recurringFrequency}}\n<span ng-if=\"data.recurringDayInterval\"><b>(Every {{data.recurringDayInterval}} days)</b></span>\n</span>\n<span ng-if=\"data.recurringDay\"><b>({{$ctrl.capitalizeFirstLetter(data.recurringDay)}})</b></span>\n</td>\n<td ng-if=\"data.selectedPattern === 'monthly'\">\n<span>{{data.recurringMonthObj.frequencyMonth}}</span>\n<span ng-if=\"data.recurringMonthObj.frequencyDay\"><b>({{data.recurringMonthObj.frequencyDay}})</b></span>\n<span ng-if=\"data.recurringMonthObj.frequencyWeek\"><b>({{data.recurringMonthObj.frequencyWeek}})</b></span>\n</td>\n<td ng-if=\"data.selectedPattern === 'weekly'\">\n<span>{{data.recurringFrequency}}</span>\n<span ng-if=\"data.weeklyRecurring.scheduleWeekDays\"><b>({{data.weeklyRecurring.scheduleWeekDays}})</b></span>\n</td>\n<td>\n<div ng-if=\"data.endRecurringAfter\">{{data.endRecurringAfter}} {{'common.recurring' | translate}}</div>\n<div ng-if=\"data.endDate\"><b>{{data.endDate | date:'yyyy-MM-dd'}}</b></div>\n</td>\n<td>{{data.vaultDate | date:'yyyy-MM-dd'}}</td>\n<td>{{data.branchId}}</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.editLocation(data.locationId)\" class=\"text-decoration-none remove-padding\">\n{{data.locationId}}\n</a> | {{$ctrl.splitKey(data.locationKey)}}\n</td>\n<td>{{data.routeKey}}</td>\n<td>{{data.sequence}}</td>\n<td>\n<button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"$ctrl.cancelScheduledStops(data.jobKey, $event)\">\n<span class=\"glyphicon glyphicon-trash\"></span></button>\n\n</td>\n</tr>\n</tbody>\n</table>\n<ul ng-if=\"$ctrl.pendingChangesObj.totalRecords > 10\" uib-pagination total-items=\"$ctrl.pendingChangesObj.totalRecords\" next-text=\"{{'common.next'| translate}}\" ng-hide=\"{{($ctrl.pendingChangesObj.totalRecords<=$ctrl.pendingChangesObj.pageLimit)&&($ctrl.page==1)}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pendingChangesObj.page\" ng-change=\"$ctrl.nextPage()\" rotate=\"false\" max-size=\"$ctrl.pendingChangesObj.maxPages\"></ul>\n</div>\n<div class=\"col-sm-12 margin-10 remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.pendingChangesObj.loading && $ctrl.pendingChangesObj.totalRecords == 0\">\n<span class=\"col-sm-12 alert alert-danger text-align-center\">\n{{'route_sheet.no_data_found' | translate}}\n</span>\n</div>\n<div class=\"col-sm-12 text-align-center margin-top-20\" ng-if=\"$ctrl.pendingChangesObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-50\"></span>\n</div>\n</form>\n</div>\n</div>\n</div>";
var id1="stop_scheduling.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2703 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\" style=\"text-align: center;\">\n<div class=\"col-sm-12 remove-pad\">\n<div>\n<div class=\"align-center-horizontally\">\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<h4>{{ 'branch_mgmt.tankers.tankercontent' | translate }} </h4>\n<div id=\"print-section\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.isLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 margin-top-20 remove-pad\" ng-if=\"!$ctrl.model.isLoading\">\n<table class=\"table table-striped table-bordered table-pad-5\">\n<thead class=\"header-row\">\n<tr>\n<td>\n<b>{{ 'shipmentBatch.tracking_id' | translate }}</b>\n</td>\n<td>\n<b>{{ 'verifyHoldShipments.status' | translate}}</b>\n</td>\n<td>\n<b>{{ 'shipmentBatch.location' | translate}}</b>\n</td>\n<td>\n<b>{{ 'bagout.toLocation' | translate }}</b>\n</td>\n<td style=\"width: 95px;\">\n<b>{{ 'branch_mgmt.tankers.transactionDate' | translate }}</b>\n</td>\n<td>\n<b>{{ 'routeSheet.route' | translate }}</b>\n</td>\n<td>\n<b>{{ 'message.type' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.itemHistoryQty' | translate }}</b>\n</td>\n<td>\n<b>{{ 'checkin.amount' | translate }}</b>\n</td>\n<td style=\"width: 95px;\">\n<b>{{ 'branch_mgmt.tankers.create' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"tanker in $ctrl.model.tankerList\">\n<td>{{tanker.trackingId}}</td>\n<td class=\"text-danger\">\n{{$ctrl.translateTranType(tanker.tranType)}}\n</td>\n<td>{{tanker.fromLocationId}} | {{tanker.fromLocationName}}</td>\n<td>{{tanker.toLocationId}} | {{tanker.toLocationName}}</td>\n<td>{{tanker.transactionDate | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n<td>\n<span ng-if=\"tanker.routeId\">{{tanker.routeId.toUpperCase()}}</span>\n<span ng-if=\"!tanker.routeId\">{{'common.n_a'| translate}}</span>\n</td>\n<td>{{tanker.shipTypeDescription}}</td>\n<td>{{tanker.qty}}</td>\n<td>{{tanker.amount | currency}}</td>\n<td>{{tanker.createdAt | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n</div>\n</div>";
var id1="print_tankers.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2704 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"nav-center pull-top hide-in-print\">\n<div class=\"btn-group z-index0\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.currentStats\" uib-btn-radio=\"$ctrl.stats.currentContents\" ng-click=\"$ctrl.tabSelection('currentContents')\" ng-class=\"{'btn-success': $ctrl.currentStats === $ctrl.stats.currentContents, \n                       'remove-btn-grp-color': $ctrl.currentStats === $ctrl.stats.contentsHistory}\">\n{{'branch_mgmt.tankers.current_contents_title' | translate}}\n<span ng-if=\"$ctrl.currentStats === 'currentContents' && !$ctrl.pagination.loading\" class=\"badge badge-current-contents\">{{$ctrl.totalCurrentTanker}}</span>\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.currentStats\" uib-btn-radio=\"$ctrl.stats.contentsHistory\" ng-click=\"$ctrl.tabSelection('contentsHistory');\" ng-class=\"{'btn-success': $ctrl.currentStats === $ctrl.stats.contentsHistory, \n                       'remove-btn-grp-color': $ctrl.currentStats === $ctrl.stats.currentContents}\">\n{{'branch_mgmt.tankers.contents_hostiry_title' | translate}}\n</button>\n</div>\n</div>\n<div class=\"tab-content branch-mgmt-tankers\">\n<div class=\"container-fluid\">\n<div class=\"row\">\n<div>\n<div ng-if=\"$ctrl.currentStats === 'currentContents'\">\n<div class=\"col-sm-12 form-validate\" novalidate>\n<div class=\"col-sm-12 align-center-horizontally\">\n<div id=\"inline\" class=\"frow margin-top-10 row hide-in-print ui-select-container col-sm-7\">\n<search-and-select ng-model=\"$ctrl.model.tanker.data\" set-id=\"tanker\" values=\"$ctrl.tankers\" key=\"Key\" on-click=\"$ctrl.loadCurrentContent()\" totalrecords=\"$ctrl.totalTanker\" onscroll=\"$ctrl.loadTanker(searchKey, offset)\" none-selected=\"'common.select'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-offset-4 col-sm-4\">\n<div class=\"row\">\n<div class=\"col-sm-offset-2 col-sm-8 padding-zero\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRange\" ng-change=\"$ctrl.loadCurrentContent()\" ng-if=\"$ctrl.model.dateRange.startDate\" options=\"$ctrl.model.dateRangPickerOptions\" ng-paste=\"$event.preventDefault()\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.messages && $ctrl.model.noItemDisplay && !$ctrl.model.loading\" class=\"row remove-padding\">\n<div class=\"col-sm-12 align-center-horizontally hide-in-print margin-10 remove-padding\" ng-if=\"$ctrl.model.errorMsg && $ctrl.model.isError\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.isError}\" style=\"text-align: center; width:100%\">\n<span>{{$ctrl.model.errorMsg}}</span>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.messages && $ctrl.model.noItemDisplay && !$ctrl.model.loading\" class=\"row remove-padding\">\n<div class=\"col-sm-12 align-center-horizontally remove-padding hide-in-print margin-10\" ng-if=\"$ctrl.model.messages && $ctrl.model.noItemDisplay\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.noItemDisplay}\" style=\"text-align: center; width:100%\">\n<span>{{$ctrl.model.messages}}</span>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.currentTankersData.length && !$ctrl.model.loading\">\n<div class=\"col-sm-12 margin-bottom-10 itemPos remove-padding\">\n<div class=\"pull-left font-size-20 hide-in-print\">\n<strong>{{ 'branch_mgmt.tankers.tankercontent' | translate }}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.localDateTime}}</span>\n<span>| {{$ctrl.getLocalTime()}} </span>\n</div>\n<div class=\"pull-right\">\n<button class=\"btn btn-success pull-right ng-binding\" ng-click=\"$ctrl.printTankerContent()\">{{'branch_mgmt.tankers.print' | translate}}</button>\n</div>\n</div>\n<div class=\"row_ remove-padding\">\n<table class=\"table table-hover margin-top-20 table-striped table-bordered table-pad-5 font-12\">\n<thead>\n<tr class=\"text-center\">\n<td>\n<b>{{ 'shipmentBatch.tracking_id' | translate }}</b>\n</td>\n<td>\n<b>{{ 'verifyHoldShipments.status' | translate}}</b>\n</td>\n<td>\n<b>{{ 'shipmentBatch.location' | translate}}</b>\n</td>\n<td>\n<b>{{ 'bagout.toLocation' | translate }}</b>\n</td>\n<td style=\"width: 95px;\">\n<b>{{ 'branch_mgmt.tankers.transactionDate' | translate }}</b>\n</td>\n<td>\n<b>{{ 'routeSheet.route' | translate }}</b>\n</td>\n<td>\n<b>{{ 'message.type' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.itemHistoryQty' | translate }}</b>\n</td>\n<td>\n<b>{{ 'checkin.amount' | translate }}</b>\n</td>\n<td style=\"width: 95px;\">\n<b>{{ 'branch_mgmt.tankers.create' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr class=\"text-center\" ng-repeat=\"tankerData in $ctrl.currentTankersData\">\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(tankerData.trackingId)\">{{tankerData.trackingId}}</a>\n</td>\n<td class=\"text-danger\">\n{{$ctrl.translateTranType(tankerData.tranType)}}\n</td>\n<td>{{tankerData.fromLocationId}} | {{tankerData.fromLocationName}}</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(tankerData.toLocationId)\"> {{tankerData.toLocationId}} </a>\n| {{tankerData.toLocationName}}\n</td>\n<td>{{tankerData.transactionDate | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n<td>\n<span ng-if=\"tankerData.routeId\">{{tankerData.routeId.toUpperCase()}}</span>\n<span ng-if=\"!tankerData.routeId\">{{'common.n_a'| translate}}</span>\n</td>\n<td>{{tankerData.shipTypeDescription}}</td>\n<td>{{tankerData.qty}}</td>\n<td>{{tankerData.amount | currency}}</td>\n<td>{{tankerData.createdAt | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n</tr>\n</tbody>\n</table>\n<div class=\"row_ hide-in-print margin-bottom-10\" ng-if=\"$ctrl.pagination.total > 10\">\n<ul uib-pagination total-items=\"$ctrl.pagination.total\" ng-hide=\"{{($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.currentStats === 'contentsHistory'\">\n<div class=\"col-sm-12 form-validate\" novalidate>\n<div class=\"col-sm-12 align-center-horizontally\">\n<div id=\"inline\" class=\"frow margin-top-10 row hide-in-print ui-select-container col-sm-7\">\n<search-and-select ng-model=\"$ctrl.model.tanker.data\" set-id=\"tanker\" values=\"$ctrl.tankers\" key=\"Key\" on-click=\"$ctrl.loadDataOfTankersHistory()\" totalrecords=\"$ctrl.totalTanker\" onscroll=\"$ctrl.loadTanker(searchKey, offset)\" none-selected=\"'common.select'\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-offset-4 col-sm-4\">\n<div class=\"row\">\n<div class=\"col-sm-offset-2 col-sm-8 padding-zero\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRange\" ng-change=\"$ctrl.loadDataOfTankersHistory()\" ng-if=\"$ctrl.model.dateRange.startDate\" options=\"$ctrl.model.dateRangPickerOptions\" ng-paste=\"$event.preventDefault()\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.messages && $ctrl.model.noItemDisplay && !$ctrl.model.loading\" class=\"row remove-padding\">\n<div class=\"col-sm-12 align-center-horizontally hide-in-print margin-10 remove-padding\" ng-if=\"$ctrl.model.errorMsg && $ctrl.model.isError\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.isError}\" style=\"text-align: center; width:100%\">\n<span>{{$ctrl.model.errorMsg}}</span>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.messages && $ctrl.model.noItemDisplay && !$ctrl.model.loading\" class=\"row remove-padding\">\n<div class=\"col-sm-12 align-center-horizontally remove-padding hide-in-print margin-10\" ng-if=\"$ctrl.model.messages && $ctrl.model.noItemDisplay\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.model.noItemDisplay}\" style=\"text-align: center; width:100%\">\n<span>{{$ctrl.model.messages}}</span>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.tankersData.length && !$ctrl.model.loading\">\n<div class=\"col-sm-12 margin-bottom-10 itemPos remove-padding\">\n<div class=\"pull-left font-size-20 hide-in-print\">\n<strong>{{ 'branch_mgmt.tankershistory' | translate }}</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.localDateTime}}</span>\n</div>\n</div>\n<div class=\"row_ remove-padding\">\n<table class=\"table table-hover margin-top-20 table-striped table-bordered table-pad-5 font-12\">\n<thead>\n<tr class=\"text-center\">\n<td>\n<b>{{ 'shipmentBatch.tracking_id' | translate }}</b>\n</td>\n<td>\n<b>{{ 'verifyHoldShipments.status' | translate}}</b>\n</td>\n<td>\n<b>{{ 'shipmentBatch.location' | translate}}</b>\n</td>\n<td>\n<b>{{ 'bagout.toLocation' | translate }}</b>\n</td>\n<td style=\"width: 95px;\">\n<b>{{ 'branch_mgmt.tankers.transactionDate' | translate }}</b>\n</td>\n<td>\n<b>{{ 'routeSheet.route' | translate }}</b>\n</td>\n<td>\n<b>{{ 'message.type' | translate }}</b>\n</td>\n<td>\n<b>{{ 'branch_mgmt.itemHistoryQty' | translate }}</b>\n</td>\n<td>\n<b>{{ 'checkin.amount' | translate }}</b>\n</td>\n<td style=\"width: 95px;\">\n<b>{{ 'branch_mgmt.tankers.create' | translate }}</b>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr class=\"text-center\" ng-repeat=\"tankerData in $ctrl.tankersData\">\n<td>{{tankerData.trackingId}}</td>\n<td class=\"text-danger\">\n{{$ctrl.translateTranType(tankerData.tranType)}}\n</td>\n<td>{{tankerData.fromLocationId}} | {{tankerData.fromLocation.name}}</td>\n<td>{{tankerData.toLocationId}} | {{tankerData.toLocation.name}}</td>\n<td>{{tankerData.transactionDate | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n<td>\n<span ng-if=\"tankerData.routeId\">{{tankerData.routeId.toUpperCase()}}</span>\n<span ng-if=\"!tankerData.routeId\">{{'common.n_a'| translate}}</span>\n</td>\n<td>{{tankerData.shiptype.description}}</td>\n<td>{{tankerData.qty}}</td>\n<td>{{tankerData.amount | currency}}</td>\n<td ng-if=\"shipment.bagSeal\">{{shipment.bagSeal}}</td>\n<td ng-if=\"!shipment.bagSeal\">{{tankerData.updatedAt | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n</tr>\n</tbody>\n</table>\n<div class=\"row_ hide-in-print margin-bottom-10\" ng-if=\"$ctrl.pagination.total > 10\">\n<ul uib-pagination total-items=\"$ctrl.pagination.total\" ng-hide=\"{{($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="tankers.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2705 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container_ remove-pad col-sm-12\">\n<div class=\"row_\">\n<div class=\"col-md-5_\">\n<h3>{{ 'branch_mgmt.location_bypass_code.title' | translate }}</h3>\n</div>\n</div>\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row_ margin-18 form-horizontal remove-padding\">\n<div class=\"col-sm-7 right-vertical-line remove-left-pad\">\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label margin-top-05\">{{'branch_mgmt.bypass_code_issue.title' | translate}}</label>\n<div class=\"col-sm-8\">\n<select id=\"select\" class=\"form-control\" ng-model=\"$ctrl.model.selectedIssue\" ng-options=\"issue.value as issue.lable for issue in $ctrl.model.issueList\" ng-change=\"$ctrl.resetLocationObj(); $ctrl.loadData()\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n</div>\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label margin-top-05\">{{'branch_mgmt.bypass_code_branch.title' | translate }}</label>\n<div class=\"col-sm-8\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.branchId\" ng-options=\"branch.id as branch.id for branch in $ctrl.model.branchList\" ng-disabled=\"!$ctrl.model.selectedIssue\" ng-change=\"$ctrl.branchChanged()\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n</div>\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label margin-top-05\">{{'branch_mgmt.bypass_code_route.title' | translate }}</label>\n<div class=\"col-sm-8\">\n<search-and-select ng-model=\"$ctrl.model.routeId\" values=\"$ctrl.model.routeListObj.routeList\" key=\"Key\" totalrecords=\"$ctrl.model.routeListObj.totalRecords\" common-search-flag=\"true\" on-click=\"$ctrl.resetLocationObj(); $ctrl.getRouteStopList()\" ng-disabled=\"!$ctrl.model.branchId\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label margin-top-05\">{{'branch_mgmt.bypass_code_user.title' | translate }}</label>\n<div class=\"col-sm-8\">\n<search-and-select ng-model=\"$ctrl.model.userId\" values=\"$ctrl.model.userListObj.userList\" key=\"Key\" totalrecords=\"$ctrl.model.userListObj.totalRecords\" onscroll=\"$ctrl.getAllUsers(searchKey, offset)\" ng-disabled=\"!$ctrl.model.routeListObj.routeList.length\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label margin-top-05\">{{'branch_mgmt.bypass_code_location.title' | translate }}</label>\n<div class=\"col-sm-8\">\n<search-and-select ng-model=\"$ctrl.model.locationId\" values=\"$ctrl.model.locationListObj.locationList\" key=\"Key\" totalrecords=\"$ctrl.model.locationListObj.totalRecords\" onscroll=\"$ctrl.getAllLocation(searchKey, offset)\" ng-disabled=\"!$ctrl.model.routeListObj.routeList.length\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.hasACL.overrideClose && $ctrl.model.selectedIssue === 'cant_close_atm'\">\n<label class=\"col-sm-2 col-form-label margin-top-05\">{{'branch_mgmt.bypass_code.close_code' | translate }}</label>\n<div class=\"col-sm-8\">\n<input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.model.closeCode\" required/>\n</div>\n</div>\n<div class=\"form-group\">\n<label class=\"col-sm-2 col-form-label margin-top-05\">{{'branch_mgmt.bypass_code_comment.title' | translate }}</label>\n<div class=\"col-sm-10\">\n<textarea class=\"form-control\" rows=\"4\" cols=\"50\" ng-model=\"$ctrl.model.comments\"></textarea>\n</div>\n</div>\n<div class=\"form-group\">\n<div class=\"col-sm-2\"></div>\n<div class=\"col-sm-8\">\n<button class=\"btn btn-success\" type=\"submit\" ng-disabled=\"Form.$invalid || $ctrl.model.generatingCode\" ng-click=\"$ctrl.confirmSupervisor();\">\n{{'common.generate_code' | translate}}\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-5 bypass-code-view-section\">\n<div class=\"col-sm-12\">\n<span class=\"text-muted bypass-code-title-section\">\n{{ 'branch_mgmt.tnt_bypass_code.title' | translate }}:\n</span>\n</div>\n<div class=\"col-sm-12\">\n<span class=\"text-muted bypass-code-section\">\n{{$ctrl.model.bypassCode || 0}}\n</span>\n</div>\n</div>\n</div>\n</form>\n</div>\n<div class=\"col-sm-12 margin-18 table-responsive remove-pad\">\n<p class=\"text-align-center font-size-70 margin-top-40\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</p>\n<div class=\"margin-top-20\">\n<table class=\"table table-hover table-bordered font-12\" ng-if=\"!$ctrl.model.loading && $ctrl.model.bypassCodeList.length\">\n<tr class=\"header-row\">\n<th class=\"bypass-code-date-section\">{{'bypassCode.date' | translate}}</th>\n<th class=\"minWidth150\">{{'branch_mgmt.bypass_code_issue.title' | translate}}</th>\n<th>{{'common.locationId' | translate}}</th>\n<th>{{'bypassCode.route' | translate}}</th>\n<th>{{'bypassCode.bypassCode' | translate}}</th>\n<th>{{'bypassCode.supervisorID' | translate}}</th>\n<th>{{'bypassCode.messengerID' | translate}}</th>\n<th>{{'bypassCode.comments' | translate}}</th>\n</tr>\n<tr ng-if=\"$ctrl.model.bypassCodeList === 0\">\n<td colspan=\"7\">\n<strong class=\"align-center\">{{'error.noBypassCodeFound' | translate}}</strong>\n</td>\n</tr>\n<tr ng-repeat=\"bypassCode in $ctrl.model.bypassCodeList\">\n<td>{{bypassCode.createdAt | date: 'MM-dd-yyyy | hh:mm a'}}</td>\n<td>\n<span ng-if=\"bypassCode.type\">{{$ctrl.translateIssue(bypassCode.type)}}</span>\n<span ng-if=\"!$ctrl.translateIssue(bypassCode.type)\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{bypassCode.locationId}}</td>\n<td>{{bypassCode.routeId}}</td>\n<td>{{bypassCode.bypassCode}}</td>\n<td>{{bypassCode.supvApproveId}}</td>\n<td>{{bypassCode.userId}}</td>\n<td>{{bypassCode.comments}}</td>\n</tr>\n</table>\n</div>\n<div class=\"col-sm-12 remove-left-pad margin-bottom-10\">\n<ul uib-pagination total-items=\"$ctrl.model.totalBypassCode\" ng-if=\"$ctrl.model.totalBypassCode > $ctrl.model.paginationObj.pageLimit\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.paginationObj.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>";
var id1="tnt_bypass_code.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2706 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<a class=\"bulk-cash-currency-trigger\" popover-is-open=\"$ctrl.currencyData.isOpen\" role=\"button\" \n                ng-repeat=\"currency in $ctrl.filteredCurrencyData track by $index\" ng-click=\"$ctrl.changeCurrencyType($event, currency.id, $parent.$index, $index)\">\n                    <span class=\"bulk-cash-popover-currency-symbol\" >{{ $ctrl.currencySymbol || currency.symbol }}</span>\n                </a>\n";
var id1="currencyType-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
var v2="\n<a  popover-is-open=\"$ctrl.denominations.isOpen\" role=\"button\" \n                            ng-repeat=\"denominations in newBulkCash.filterDenominationType track by $index\" ng-click=\"$ctrl.changeType($event, denominations.id, $parent.$parent.$parent.$index, $parent.$index, $index, denominations.faceValue, denomination.amount)\">\n                            <denom-icon denom-id=\"denominations.id\" icon-size=\"30\"></denom-icon>\n                        </a>\n                        </a>\n";
var id2="bulk-cash-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id2,v2);}
else{ngModule.run(["$templateCache",function(c){c.put(id2,v2)}]);}
var v3="\n<a class=\"bulk-cash-currency-trigger\" popover-is-open=\"$ctrl.currencyData.isOpen\" role=\"button\" \n                        ng-repeat=\"currency in $ctrl.filteredCurrencyData track by $index\" ng-click=\"$ctrl.changeCurrencyType($event, currency.id, $parent.$index, $index)\">\n                            <span class=\"bulk-cash-popover-currency-symbol\">{{ $ctrl.currencySymbol || currency.symbol }}</span>\n                        </a>\n";
var id3="currencyType-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id3,v3);}
else{ngModule.run(["$templateCache",function(c){c.put(id3,v3)}]);}
var v4="<div class=\"container-fluid form-validate\">\n<div class=\"row\">\n<div class=\"col-sm-2\" ng-class=\"{'col-sm-2': '$ctrl.hasCreditDebitPermissions', 'col-sm-4': !$ctrl.hasCreditDebitPermissions}\">\n</div>\n<div class=\"col-sm-4 dd-z-index margin-top-19\">\n<div class=\"form-group\">\n<search-and-select ng-model=\"$ctrl.model.locationId\" values=\"$ctrl.locationLists\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" ng-disabled=\"!$ctrl.model.branchId\" common-search-flag=\"true\" on-click=\"$ctrl.resetDenomSelection(); $ctrl.setFocus(); $ctrl.loadBulkCashHistory(); $ctrl.fundingSourceDenomination();\" none-selected=\"'bulkCash.selectFundingSource'\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4 margin-dd-20 margin-top-19\" ng-if=\"$ctrl.hasCreditDebitPermissions\">\n<div class=\"form-group\">\n<input id=\"trackingId\" type=\"text\" ng-model=\"$ctrl.model.orderNumber\" placeholder=\"{{ 'bulkCash.tracking_id' | translate }}\" class=\"form-control _tracking-id-input-height\" ng-required=\"!$ctrl.model.isDebit\" capitalize/>\n</div>\n</div>\n<div class=\"form-group pull-right\" ng-if=\"$ctrl.hasCreditDebitPermissions\">\n<label for=\"adjust-ledger\">{{'bagout.type' | translate }}</label>\n<br>\n<select id=\"select\" class=\"form-control\" ng-model=\"$ctrl.model.selectedAdjustmentType\" ng-options=\"type as type.lable for type in $ctrl.adjustmentTypes\" ng-change=\"$ctrl.findAdjustmentType($ctrl.model.selectedAdjustmentType)\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'common.select' | translate}}) </option>\n</select>\n</div>\n</div>\n<div class=\"row margin-bottom-10\" ng-if=\"$ctrl.hasCreditDebitPermissions\">\n<textarea class=\"form-control\" rows=\"2\" id=\"comments\" ng-model=\"$ctrl.model.comments\" autocomplete=\"off\" ng-required=\"$ctrl.model.isDebit\" placeholder=\"{{'common.comment' | translate}}\"></textarea>\n</div>\n<div class=\"row div-main-border\" ng-if=\"$ctrl.model.branchId && $ctrl.model.locationId && $ctrl.hasCreditDebitPermissions\" ng-repeat=\"newBulkCash in $ctrl.addBulkCash track by $index\">\n<div class=\"col-sm-2 col-md-2 padding12\">\n<div>\n<div class=\"text-center\">\n<span ng-if=\"!$ctrl.model.isDebit\"><img ng-src=\"assets/images/arrow-inbound.png\" class=\"custom-icon img-width\"/></span>\n<span ng-if=\"$ctrl.model.isDebit\"><img ng-src=\"assets/images/arrow-outbound-orange.png\" class=\"custom-icon img-width\"/></span>\n</div>\n<div class=\"input-group\">\n<span class=\"input-group-addon padding5\">\n<a class=\"bulk-cash-currency-trigger\" role=\"button\" uib-popover-template=\"newBulkCash.currencyTemplate\" popover-is-open=\"newBulkCash.currencyIsOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\">\n<span class=\"bulk-cash-currency-symbol\">{{ $ctrl.currencySymbol }}</span>\n</a>\n</span>\n<input type=\"text\" id=\"requireAmount-{{$index+1}}\" class=\"form-control\" ng-model=\"newBulkCash.requireAmount\" placeholder=\"{{ 'bulkCash.totalAmount' | translate }}\" fraction=\"2\" min=\"0\" ng-currency currency-symbol=\"{{$ctrl.currencySymbol}}\" ng-change=\"$ctrl.checkAmountWithRequireAmount($parent.$index, $index, newBulkCash.requireAmount); $ctrl.totalRequireAmount()\" required/>\n</div>\n\n<div class=\"margin-top-10\">\n<select id=\"select\" class=\"form-control\" ng-model=\"newBulkCash.ledger\" ng-options=\"ledger.value as ledger.lable for ledger in $ctrl.ledgers\" ng-change=\"$ctrl.loadLedgerData($parent.$index, $index)\" ng-disabled=\"$ctrl.model.isDebit\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\"> ({{'bulkCash.selectLedger' | translate}}) </option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-8 col-md-8 box2\">\n<div ng-repeat=\"denomination in newBulkCash.denominations track by $index\">\n<div class=\"col-sm-6 col-md-6 form-group box2-main-div\" ng-class=\"{'ng-duplicate': denomination.duplicate}\">\n<div class=\"col-sm-12 col-md-12 no-padding\">\n<div class=\"input-group\">\n<span class=\"input-group-addon padding5\">\n<a role=\"button\" uib-popover-template=\"denomination.template\" popover-is-open=\"denomination.isOpen\" popover-enable=\"newBulkCash.filterDenominationType.length !== 0\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\">\n<denom-icon denom-id=\"denomination.icon\" icon-size=\"22\"></denom-icon>\n</a>\n</span>\n<input ng-if=\"denomination.coinFlag\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" type=\"text\" class=\"form-control\" ng-model=\"denomination.units\" placeholder=\"{{ 'bulkCash.units' | translate }}\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-class=\"{'color-red' : !denomination.isValidate || !denomination.units || denomination.units <= 0, \n                                'color-green' : denomination.isValidate && denomination.units && denomination.units > 0}\" ng-change=\"$ctrl.checkAmountWithRequireAmount($parent.$index, $index, newBulkCash.requireAmount, denomination.units * denomination.faceValue, denomination.faceValue)\" required>\n<input ng-if=\"!denomination.coinFlag\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" ng-pattern=\"/^[0-9]\\d*(\\.\\d+)?$/\" type=\"text\" class=\"form-control\" ng-model=\"denomination.amount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-class=\"{'color-red' : !denomination.isValidate || !denomination.amount || denomination.amount <= 0, \n                                'color-green' : denomination.isValidate && denomination.amount && denomination.amount > 0}\" ng-change=\"$ctrl.checkAmountWithRequireAmount($parent.$index, $index, newBulkCash.requireAmount, denomination.amount, denomination.faceValue)\" ng-currency currency-symbol=\"\" fraction=\"2\" required>\n</div>\n</div>\n<div class=\"col-sm-2 col-md-2 text-right box2-remove-div\">\n<button class=\"btn btn-xs btn-danger btn-icon\" uib-tooltip=\"Close\" ng-click=\"$ctrl.removeDenomination($parent.$index, $index, newBulkCash.requireAmount)\" tooltip-append-to-body=\"true\">\n<i class=\"glyphicon glyphicon-remove\"></i>\n</button>\n</div>\n<div class=\"denom-error-tooltip-section\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'bulkCash.invalid_denom' | translate}}\" tooltip-placement=\"top-right\" ng-if=\"(!denomination.coinFlag) && denomination.amount && denomination.amount % denomination.faceValue > 0 && !denomination.isValidate\n                                   && denomination.amount <= newBulkCash.requireAmount\">\n</span>\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'bulkCash.invalid_amount' | translate}}\" tooltip-placement=\"top-right\" ng-if=\"(!denomination.coinFlag) && denomination.amount && denomination.amount > newBulkCash.requireAmount && !denomination.isValidate\">\n</span>\n</div>\n\n</div>\n</div>\n<div>\n<button id=\"addDenomination-{{$index+1}}\" class=\"btn btn-xs btn-success btn-icon commit\" uib-tooltip=\"Add\" ng-click=\"$ctrl.addDenomination($parent.$index, $index)\" tooltip-append-to-body=\"true\" ng-disabled=\"!$ctrl.addBulkCash[$index].filterDenominationType.length\">\n<i class=\"glyphicon glyphicon-plus\"></i>\n</button>\n</div>\n</div>\n<div class=\"col-sm-2 col-md-2 text-center padding12 margin-top-10\">\n<div>\n<span ng-if=\"!$ctrl.model.isDebit\"><img ng-src=\"assets/images/arrow-inbound.png\" class=\"custom-icon img-width\"/></span>\n<span ng-if=\"$ctrl.model.isDebit\"><img ng-src=\"assets/images/arrow-outbound-orange.png\" class=\"custom-icon img-width\"/></span>\n</div>\n<div class=\"padding8\">\n<span class=\"total-fontSize bulk-cash-received-amount\">\n{{ newBulkCash.totalreceivedAmount | currency:$ctrl.currencySymbol:2 }}\n</span>\n</div>\n</div>\n<div class=\"text-center remove-button\">\n<div>\n<button class=\"btn btn-xs btn-danger btn-icon\" uib-tooltip=\"Close\" ng-click=\"$ctrl.removeBulkCash($parent.$index)\" tooltip-append-to-body=\"true\">\n<i class=\"glyphicon glyphicon-remove\"></i>\n</button>\n</div>\n</div>\n</div>\n<div class=\"row div-add-cash\" ng-if=\"$ctrl.model.branchId && $ctrl.model.locationId && $ctrl.hasCreditDebitPermissions\">\n<div class=\"form-group\">\n<div class=\"col-sm-2 text-center\">\n</div>\n<div class=\"col-sm-8 text-left\">\n</div>\n<div class=\"col-sm-2 text-center\">\n<button class=\"btn btn-md btn-primary btn-icon commit\" ng-disabled=\"$ctrl.isCommited || $ctrl.commitDisabled() || ((!$ctrl.model.isDebit && !$ctrl.model.orderNumber) || ($ctrl.model.isDebit && !$ctrl.model.comments)) || $ctrl.isLimitExceed\" class=\"btn btn-primary\" ng-click=\"$ctrl.commit()\">\n{{'common.commit' | translate}}\n</button>\n<button class=\"btn btn-md btn-danger btn-icon commit\" ng-disabled=\"$ctrl.isPerformReset\" ng-click=\"$ctrl.performReset()\">{{'bulkCash.reset' | translate}}</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 text-center margin-top-10\">\n<div ng-if=\"$ctrl.limitExceededErr && $ctrl.model.isDebit\">\n<div class=\"row alert alert-danger text-align-center\">\n{{$ctrl.limitExceededErr}}\n</div>\n</div>\n<hr>\n<div class=\"col-sm-12 remove-pad denomination-position\">\n<span class=\"remaining-amt-lbl\" ng-if=\"$ctrl.denominations && $ctrl.denominations.length\"><label>{{'bulkCash.remaining' | translate}} |</label></span>\n<div ng-repeat=\"denomination in $ctrl.denominations | orderBy:['sortOrder', 'faceValue'] track by $index\" class=\"denom-width col-sm-2 remove-pad\" style=\"text-align: left !important;\">\n<div>\n<denom-icon denom-id=\"denomination.denominationId\" icon-size=\"22\"></denom-icon>\n<span class=\"text-amount\" ng-if=\"!denomination.coinFlag\">\n{{ denomination.totalAmount | currency:$ctrl.currencySymbol:0 }}\n</span>\n<span class=\"text-amount\" ng-if=\"denomination.coinFlag\">\n{{ denomination.totalAmount | currency:$ctrl.currencySymbol }}\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-md-12 margin-top-20\">\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.regular\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.regular}\" ng-click=\"$ctrl.accountChange()\">\n{{ 'common.regular' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.emergency\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.emergency}\" ng-click=\"$ctrl.accountChange()\">\n{{ 'common.emergency' | translate }}\n</label>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-10 remove-pad\">\n<div class=\"col-sm-8 no-padding\">\n<div class=\"col-sm-3 remove-pad\" ng-if=\"$ctrl.model.locationId\">\n<div class=\"input-group\">\n<span class=\"total-fontSize\">\n<b>{{ $ctrl.curBalance | currency:$ctrl.currencySymbol}}</b>\n</span>\n</div>\n</div>\n<div class=\"col-sm-offset-2 col-sm-4 date-ranger-picker-width\" ng-if=\"$ctrl.model.locationId\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" ng-change=\"$ctrl.loadBulkCashHistory(); $ctrl.getAmountByDenom()\" options=\"$ctrl.model.dateRange\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"remove-pad col-sm-3\" ng-if=\"$ctrl.model.locationId\">\n<input type=\"text\" placeholder=\"{{'bulkCash.search' | translate}}\" class=\"form-control\" id=\"searchtext\" ng-model=\"$ctrl.model.searchText\" ng-keydown=\"$event.keyCode === 13 && $ctrl.loadBulkCashHistory(); $event.keyCode === 13 && $ctrl.getAmountByDenom()\">\n</div>\n\n</div>\n<div class=\"col-sm-2 no-padding\" ng-if=\"$ctrl.model.locationId\">\n<div class=\"no-padding bulk-cash-denom-dd text-right\">\n<span class=\"denom-dd-width\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.denominationGroup\" output-model=\"$ctrl.dollorStats\" button-label=\"icon id\" item-label=\"icon id\" tick-property=\"ticked\" max-height=\"180px\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.loadBulkCashHistory(); $ctrl.getAmountByDenom()\" on-reset=\"$ctrl.resetLedgerData()\" selection-mode=\"single\" helper-elements=\"all none reset\">\n</span>\n</div>\n</div>\n<div class=\"col-sm-2\" ng-if=\"$ctrl.model.locationId && $ctrl.hasACL['bulk_cash_management']['export'] && (($ctrl.bulkCashHistorys && $ctrl.bulkCashHistorys.length > 0) || ($ctrl.denomBalance && $ctrl.denomBalance.length > 0))\">\n<div>\n<button type=\"button\" class=\"btn btn-success font-size-20\" ng-click=\"$ctrl.printBulkCash()\" style=\"margin-right: 5px;\" ng-disabled=\"$ctrl.isExporting\">\n{{'routeSheet.print' | translate}}</button>\n<button type=\"button\" class=\"btn btn-success font-size-20\" ng-click=\"$ctrl.exportToExcel()\" ng-disabled=\"$ctrl.isExporting\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isExporting\"></span>\n{{'common.export' | translate}}</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 text-center padding5 denom-position\" ng-if=\"$ctrl.model.locationId && $ctrl.denomBalance.length\" style=\"justify-content: left; margin: auto 5%;\">\n<div ng-repeat=\"data in $ctrl.denomBalance | orderBy:['sortOrder', 'faceValue'] track by $index\" class=\"denom-width\">\n<div class=\"text-left\" ng-if=\"data.balance !== 0\">\n<denom-icon denom-id=\"data.denominationId\" class=\"custom-icon\" icon-size=\"25\"> </denom-icon>\n<span class=\"text-amount\" ng-if=\"!data.coinFlag\">\n{{ data.balance | currency:(data.symbol || $ctrl.currencySymbol):2 }}\n</span>\n<span class=\"text-amount\" ng-if=\"data.coinFlag\">\n{{ data.balance | currency:(data.symbol || $ctrl.currencySymbol):2 }}\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-10 table-responsive remove-pad\" ng-if=\"$ctrl.model.locationId && $ctrl.bulkCashHistorys && $ctrl.bulkCashHistorys.length\">\n<table class=\"table table-bordered table-hover table-striped table-sortable text-align-center font12\">\n<thead>\n<td style=\"width:12%;\" class=\"pointer\" ng-click=\"$ctrl.sortRecord('startTimestamp')\">\n{{ 'common.dateTime' | translate }}\n<i ng-if=\"$ctrl.orderSort.datTime\" class=\"glyphicon glyphicon-triangle-top sort\"></i>\n<i ng-if=\"!$ctrl.orderSort.datTime\" class=\"glyphicon glyphicon-triangle-bottom sort\"></i>\n</td>\n<td style=\"width:13%;\" class=\"pointer\">\n{{ 'bulkCash.action' | translate }}\n</td>\n<td style=\"width:10%;\" class=\"pointer\">\n{{ \"bulkCash.fromLocation\" | translate }}\n</td>\n<td style=\"width:12%;\" class=\"pointer\">\n{{ \"bulkCash.toLocation\" | translate }}\n</td>\n<td style=\"width:10%;\">\n{{ 'orderPacking.startBalance' | translate }}\n</td>\n<td style=\"width:35%;\">\n{{ 'orderPacking.denominations' | translate }}\n</td>\n<td style=\"width:10%;\">\n{{ 'orderPacking.totalCash' | translate }}\n</td>\n<td style=\"width:10%;\">\n{{ 'orderPacking.endBalance' | translate }}\n</td>\n</thead>\n<tbody>\n<tr ng-repeat=\"bulkCashHistory in $ctrl.bulkCashHistorys track by $index\">\n<td>\n{{ bulkCashHistory.startTimestamp | date: 'MM/dd/yyyy' + \" | \" +'hh:mm a'}}\n</td>\n<td>\n<span class=\"cursor-pointer\" ng-if=\"bulkCashHistory.mainEntry.change > 0\" uib-tooltip=\"{{bulkCashHistory.comment}}\" ng-click=\"$ctrl.showLog(bulkCashHistory)\">\n<img ng-src=\"assets/images/arrow-inbound.png\" class=\"img-currency debit-credit-icon-width\"/>\n</span>\n<span class=\"glyphicon glyphicon-minus-sign minus-icon-style cursor-pointer\" ng-if=\"bulkCashHistory.mainEntry.change === 0\" uib-tooltip=\"{{bulkCashHistory.comment}}\" ng-click=\"$ctrl.showLog(bulkCashHistory)\">\n</span>\n<span class=\"cursor-pointer\" ng-if=\"bulkCashHistory.mainEntry.change < 0 && bulkCashHistory.comment && bulkCashHistory.comment.indexOf('Packable order pack') !== -1\" uib-tooltip=\"{{bulkCashHistory.comment}}\" ng-click=\"$ctrl.showLog(bulkCashHistory)\">\n<img ng-src=\"assets/images/arrow-outbound-orange.png\" class=\"img-currency debit-credit-icon-width\"/>\n</span>\n<span class=\"cursor-pointer\" ng-if=\"bulkCashHistory.mainEntry.change < 0 && (!bulkCashHistory.comment || bulkCashHistory.comment.indexOf('Packable order pack') === -1)\" uib-tooltip=\"{{bulkCashHistory.orderNo ? ((bulkCashHistory.comment && (bulkCashHistory.comment | lowercase) === 'coin shipment checkout') ? (bulkCashHistory.comment + ' (' + bulkCashHistory.orderNo + ')') : bulkCashHistory.orderNo) : bulkCashHistory.comment}}\" ng-click=\"$ctrl.showLog(bulkCashHistory)\">\n<img ng-if=\"!$ctrl.isManualAdjustment(bulkCashHistory)\" ng-src=\"assets/images/arrow-outbound-orange.png\" class=\"img-currency debit-credit-icon-width\"/>\n<img ng-if=\"$ctrl.isManualAdjustment(bulkCashHistory)\" ng-src=\"assets/images/red-alert.png\" class=\"img-currency debit-credit-icon-width\"/>\n</span>\n</td>\n<td>\n<span ng-if=\"bulkCashHistory.fromLocation\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(bulkCashHistory.fromLocation.id)\">\n{{ bulkCashHistory.fromLocation.id }}\n</a> | {{ bulkCashHistory.fromLocation.name }}\n</span>\n<span ng-if=\"!bulkCashHistory.fromLocation\">{{ bulkCashHistory.fromLocationName || \"N/A\" }}</span>\n</td>\n<td>\n<span ng-if=\"bulkCashHistory.toLocation\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(bulkCashHistory.toLocation.id)\">\n{{ bulkCashHistory.toLocation.id }}\n</a> | {{ bulkCashHistory.toLocation.name }}\n</span>\n<span ng-if=\"!bulkCashHistory.toLocation\">{{ bulkCashHistory.toLocationName || \"N/A\" }}</span>\n</td>\n<td ng-class=\"{'start-balance-bg-color': bulkCashHistory.isBalanceMismatched}\" ng-if=\"bulkCashHistory.mainEntry.prevBalance\">\n<b>{{ bulkCashHistory.mainEntry.prevBalance | currency:((bulkCashHistory.currency && bulkCashHistory.currency.symbol) || $ctrl.currencySymbol):2 }}</b>\n</td>\n<td ng-if=\"!bulkCashHistory.mainEntry.prevBalance\">\n<b>{{ 0 | currency:((bulkCashHistory.currency && bulkCashHistory.currency.symbol) || $ctrl.currencySymbol):2 }}</b>\n</td>\n<td>\n<div class=\"denom-history-wrap\">\n<div ng-repeat=\"denomination in bulkCashHistory.ledgers | orderBy:['denomination.sortOrder', 'denomination.faceValue']\" ng-if=\"denomination.denominationId\" class=\"denom-history-item\">\n<div class=\"input-group denom-history-input-group\">\n<span class=\"input-group-addon padding5 denom-history-icon\" uib-tooltip=\"{{denomination.orderId}}\">\n<denom-icon denom-id=\"denomination.denominationId\" icon-size=\"22\"></denom-icon>\n</span>\n<span class=\"form-control text-right z-index0 denom-history-amount\" ng-if=\"!denomination.denomination.coinFlag\">\n{{ denomination.change * denomination.denomination.faceValue | currency:((denomination.denomination.currency && denomination.denomination.currency.symbol) || $ctrl.currencySymbol):2 }}\n</span>\n<span class=\"form-control text-right z-index0 denom-history-amount\" ng-if=\"denomination.denomination.coinFlag\">\n{{ denomination.change * denomination.denomination.faceValue | currency:((denomination.denomination.currency && denomination.denomination.currency.symbol) || $ctrl.currencySymbol):2 }}\n</span>\n</div>\n</div>\n</div>\n</td>\n<td>\n<b ng-class=\"{'text-success': bulkCashHistory.mainEntry.change > 0, 'text-danger': bulkCashHistory.mainEntry.change < 0}\">\n{{ bulkCashHistory.mainEntry.change | currency:((bulkCashHistory.currency && bulkCashHistory.currency.symbol) || $ctrl.currencySymbol):2 }}\n</b>\n</td>\n<td>\n<b>{{ bulkCashHistory.mainEntry.curBalance | currency:((bulkCashHistory.currency && bulkCashHistory.currency.symbol) || $ctrl.currencySymbol):2 }}</b>\n</td>\n</tr>\n</tbody>\n</table>\n<ul ng-if=\"$ctrl.pagination.total > 10\" uib-pagination total-items=\"$ctrl.pagination.total\" ng-hide=\"{{($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div ng-if=\"(!$ctrl.bulkCashHistorys || !$ctrl.bulkCashHistorys.length)\">\n<div class=\"col-sm-12 alert alert-danger text-align-center div-margin-top\">\n{{'common.noRecords' | translate}}\n</div>\n</div>\n";
var id4="bulk_cash_management.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id4,v4);}
else{ngModule.run(["$templateCache",function(c){c.put(id4,v4)}]);}
module.exports=v4;

/***/ }),
/* 2707 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<style>\n.denom-icon-popover-window {\n        display: none !important;\n    }\n\n    denom-icon {\n        pointer-events: none;\n    }\n</style>\n<div class=\"container-fluid print-bulk-cash print-landscape\">\n<div class=\"row text-center\">\n<div class=\"align-center-horizontally\" ng-if=\"($ctrl.bulkCashHistorys && $ctrl.bulkCashHistorys.length > 0) || ($ctrl.denomBalance && $ctrl.denomBalance.length > 0)\">\n<img stream-print-logo load-from-db=\"true\" style=\"height: 80px;\">\n</div>\n<div id=\"print-section\">\n<div class=\"col-sm-12 text-align-left margin-top-20 print-margin-top-30 remove-pad-left\" style=\"margin-bottom: 20px;\" ng-if=\"($ctrl.bulkCashHistorys && $ctrl.bulkCashHistorys.length > 0) || ($ctrl.denomBalance && $ctrl.denomBalance.length > 0)\">\n<strong class=\"font-size-16\">{{'carrier.branch' | translate}}:</strong> <span class=\"font-size-16\">{{$ctrl.branchName}}</span>\n<strong class=\"margin-left-10 font-size-16\">{{'common.Funding-source' | translate}}:</strong> <span class=\"font-size-16\">{{$ctrl.locationName}}</span>\n<strong class=\"margin-left-10 font-size-16\">Total:</strong> <span class=\"font-size-16\">{{$ctrl.curBalance | currency:$ctrl.currencySymbol:2}}</span>\n<strong class=\"margin-left-10 font-size-16\">Account:</strong>\n<span ng-if=\"$ctrl.accountType === 'regular'\" class=\"font-size-16\">{{'common.regular' | translate}}</span>\n<span ng-if=\"$ctrl.accountType === 'emergency'\" class=\"font-size-16\">{{'common.emergency' | translate}}</span>\n<strong class=\"margin-left-10 font-size-16\">{{'common.date' | translate}}:</strong> <span class=\"font-size-16\">{{$ctrl.dateRange}}</span>\n</div>\n<div class=\"col-sm-12 text-center padding5 denom-position\" ng-if=\"$ctrl.denomBalance.length\" style=\"justify-content: left; margin-bottom: 20px; display: inline-block; width: 100%;\">\n<div ng-repeat=\"data in $ctrl.denomBalance | orderBy:['sortOrder', 'faceValue'] track by $index\" class=\"col-xs-3\" style=\"text-align: left; margin-bottom: 15px;\">\n<div class=\"text-left\" ng-if=\"data.balance !== 0\">\n<denom-icon denom-id=\"data.denominationId\" class=\"custom-icon\" icon-size=\"25\"> </denom-icon>\n<span class=\"text-amount\" ng-if=\"!data.coinFlag\">\n{{ data.balance | currency:(data.symbol || $ctrl.currencySymbol):2 }}\n</span>\n<span class=\"text-amount\" ng-if=\"data.coinFlag\">\n{{ data.balance | currency:(data.symbol || $ctrl.currencySymbol):2 }}\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-20 table-responsive remove-pad\">\n<table class=\"table table-bordered table-striped text-align-center font12 history-table-fixed\" ng-if=\"$ctrl.bulkCashHistorys && $ctrl.bulkCashHistorys.length > 0\">\n<thead>\n<tr>\n<th class=\"text-center\" style=\"width:10%;\">{{ 'common.dateTime' | translate }}</th>\n<th class=\"text-center\" style=\"width:10%;\">{{ 'bulkCash.action' | translate }}</th>\n<th class=\"text-center\" style=\"width:9%;\">{{ \"bulkCash.fromLocation\" | translate }}</th>\n<th class=\"text-center\" style=\"width:9%;\">{{ \"bulkCash.toLocation\" | translate }}</th>\n<th class=\"text-center\" style=\"width:15%;\">{{ 'orderPacking.startBalance' | translate }}\n</th>\n<th class=\"text-center\" style=\"width:25%;\">{{ 'orderPacking.denominations' | translate }}\n</th>\n<th class=\"text-center\" style=\"width:11%;\">{{ 'orderPacking.totalCash' | translate }}</th>\n<th class=\"text-center\" style=\"width:15%;\">{{ 'orderPacking.endBalance' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"bulkCashHistory in $ctrl.bulkCashHistorys track by $index\">\n<td>\n{{ bulkCashHistory.startTimestamp | date: 'MM/dd/yyyy' + \" | \" +'hh:mm a'}}\n</td>\n<td>\n<span ng-if=\"bulkCashHistory.mainEntry.change > 0\">\n<img ng-src=\"assets/images/arrow-inbound.png\" class=\"img-currency debit-credit-icon-width\"/>\n</span>\n<span class=\"glyphicon glyphicon-minus-sign minus-icon-style\" ng-if=\"bulkCashHistory.mainEntry.change === 0\">\n</span>\n<span ng-if=\"bulkCashHistory.mainEntry.change < 0\">\n<img ng-if=\"!$ctrl.isManualAdjustment(bulkCashHistory)\" ng-src=\"assets/images/arrow-outbound-orange.png\" class=\"img-currency debit-credit-icon-width\"/>\n<img ng-if=\"$ctrl.isManualAdjustment(bulkCashHistory)\" ng-src=\"assets/images/red-alert.png\" class=\"img-currency debit-credit-icon-width\"/>\n</span>\n</td>\n<td>\n<span ng-if=\"bulkCashHistory.fromLocation\">\n{{ bulkCashHistory.fromLocation.id }} | {{ bulkCashHistory.fromLocation.name }}\n</span>\n<span ng-if=\"!bulkCashHistory.fromLocation\">{{ bulkCashHistory.fromLocationName || \"N/A\" }}</span>\n</td>\n<td>\n<span ng-if=\"bulkCashHistory.toLocation\">\n{{ bulkCashHistory.toLocation.id }} | {{ bulkCashHistory.toLocation.name }}\n</span>\n<span ng-if=\"!bulkCashHistory.toLocation\">{{ bulkCashHistory.toLocationName || \"N/A\" }}</span>\n</td>\n<td>\n<b class=\"balance-amount-wrap\" ng-if=\"bulkCashHistory.mainEntry.prevBalance\">{{ bulkCashHistory.mainEntry.prevBalance | currency:((bulkCashHistory.currency && bulkCashHistory.currency.symbol) || $ctrl.currencySymbol):2 }}</b>\n<b class=\"balance-amount-wrap\" ng-if=\"!bulkCashHistory.mainEntry.prevBalance\">{{ 0 | currency:((bulkCashHistory.currency && bulkCashHistory.currency.symbol) || $ctrl.currencySymbol):2 }}</b>\n</td>\n<td>\n<div style=\"display: flex; flex-wrap: wrap; justify-content: flex-start; gap: 5px;\">\n<div ng-repeat=\"denomination in bulkCashHistory.ledgers | orderBy:['denomination.sortOrder', 'denomination.faceValue']\" ng-if=\"denomination.denominationId\" style=\"width: 100%; min-width: 100px;\">\n<div class=\"input-group\" style=\"display: flex !important; width: 100% !important;\">\n<span class=\"input-group-addon padding5\" style=\"display: flex !important; align-items: center; justify-content: center; width: 40px !important; flex-shrink: 0;\">\n<denom-icon denom-id=\"denomination.denominationId\" icon-size=\"22\"></denom-icon>\n</span>\n<span class=\"form-control text-right z-index0\" style=\"display: flex !important; align-items: center; justify-content: flex-end; flex-grow: 1 !important; width: auto !important; white-space: nowrap !important;\" ng-if=\"!denomination.denomination.coinFlag\">\n{{ denomination.change * denomination.denomination.faceValue | currency:((denomination.denomination.currency && denomination.denomination.currency.symbol) || $ctrl.currencySymbol):2 }}\n</span>\n<span class=\"form-control text-right z-index0\" style=\"display: flex !important; align-items: center; justify-content: flex-end; flex-grow: 1 !important; width: auto !important; white-space: nowrap !important;\" ng-if=\"denomination.denomination.coinFlag\">\n{{ denomination.change * denomination.denomination.faceValue | currency:((denomination.denomination.currency && denomination.denomination.currency.symbol) || $ctrl.currencySymbol):2 }}\n</span>\n</div>\n</div>\n</div>\n</td>\n<td>\n<b class=\"balance-amount-wrap\" ng-class=\"{'text-success': bulkCashHistory.mainEntry.change > 0, 'text-danger': bulkCashHistory.mainEntry.change < 0}\">{{ bulkCashHistory.mainEntry.change | currency:((bulkCashHistory.currency && bulkCashHistory.currency.symbol) || $ctrl.currencySymbol):2 }}</b>\n</td>\n<td>\n<b class=\"balance-amount-wrap\">{{ bulkCashHistory.mainEntry.curBalance | currency:((bulkCashHistory.currency && bulkCashHistory.currency.symbol) || $ctrl.currencySymbol):2 }}</b>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n";
var id1="print_bulk_cash.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2708 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'carrier.all_carriers' | translate}}\n</h4>\n<div class=\"navbar-form navbar-left remove-left-pad\">\n<button id=\"filter-by\" type=\"button\" class=\"btn btn-xs margin-top-06\" ng-class=\"{'btn-default': $ctrl.filterByValue !== 'all', 'btn-success': $ctrl.filterByValue === 'all'}\" ng-click=\"$ctrl.filterByBranch('all')\">\n{{'common.All' | translate}}\n</button>\n</div>\n<div class=\"col-sm-1 remove-left-pad settings-batch-loader\">\n<span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'carrier.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.carriers && $ctrl.carriers.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"carrier in $ctrl.carriers track by carrier.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{carrier.id}} | {{carrier.name}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(carrier)\" uib-tooltip=\"{{ 'carrier.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"carrier.expand\">\n<div class=\"col-sm-12\">\n<hr/>\n<div>\nExtra details here\n<br>\n<br>\n<br>\n<br> Extra Details\n</div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.carriers || !$ctrl.carriers.length) && !$ctrl.loading\">\n<span>{{'carrier.noCarriers' | translate}}</span>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>";
var id1="carrier.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2709 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"carrier.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"carrier.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"carrier.create\">\n<a translate=\"carrier.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="carrier.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2710 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"carrier.create_carrier\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"exampleInputEmail1\">{{'common.id' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"exampleInputEmail1\" placeholder=\"ID\" ng-model=\"$ctrl.model.id\">\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"name\">{{'carrier.name' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"name\" placeholder=\"Name\" ng-model=\"$ctrl.model.name\">\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div id=\"inline\" class=\"col-sm-6 form-group\">\n<label for=\"\">{{ 'carrier.branches' | translate }}* </label>\n<div>\n<div class=\"multi-select\" ng-class=\"{\n\t\t\t\t\t\t\t'invalid-multi-select-value': !$ctrl.model.branch.length,\n\t\t\t\t\t\t\t'valid-multi-select-value': $ctrl.model.branch.length\n\t\t\t\t\t\t}\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.model.allBranch\" output-model=\"$ctrl.model.branch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"branch\">{{ 'carrier.branch' | translate }} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.defaultBranch\" ng-options=\"branch.branchId as branch.branchId for branch in $ctrl.model.branch\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate }}</label>\n<textarea class=\"form-control\" name=\"\" cols=\"30\" rows=\"5\" ng-model=\"$ctrl.model.description\" placeholder=\"Description\"></textarea>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"contact\">{{'carrier.POCName' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"POCName\" placeholder=\"\" ng-model=\"$ctrl.model.POCName\">\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"contact\">{{'carrier.POCPhone' | translate }}</label>\n<input type=\"text\" class=\"form-control\" id=\"POCPhone\" placeholder=\"\" ng-model=\"$ctrl.model.POCPhone\" ui-us-phone-number>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"contact\">{{'carrier.POCEmail' | translate }} *</label>\n<input type=\"email\" required class=\"form-control\" id=\"POCEmail\" placeholder=\"\" ng-model=\"$ctrl.model.POCEmail\">\n</div>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</form>\n</div>";
var id1="carrier.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2711 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"carrier.edit_carrier\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"exampleInputEmail1\">{{'common.id' | translate }} *</label>\n<input disabled=\"disabled\" type=\"text\" required class=\"form-control\" id=\"exampleInputEmail1\" placeholder=\"ID\" ng-model=\"$ctrl.model.id\">\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"name\">{{'carrier.name' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"name\" placeholder=\"Name\" ng-model=\"$ctrl.model.name\">\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div id=\"inline\" class=\"col-sm-6 form-group\">\n<label for=\"\">{{ 'carrier.branches' | translate }}* </label>\n<div>\n<div class=\"multi-select\" ng-class=\"{\n\t\t\t\t\t\t\t'invalid-multi-select-value': !$ctrl.model.branch.length,\n\t\t\t\t\t\t\t'valid-multi-select-value': $ctrl.model.branch.length\n\t\t\t\t\t\t}\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.branchData\" output-model=\"$ctrl.model.branch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"branch\">{{ 'carrier.branch' | translate }} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.defaultBranch\" ng-options=\"branch.branchId as branch.branchId for branch in $ctrl.model.branch\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate }}</label>\n<textarea class=\"form-control\" name=\"\" cols=\"30\" rows=\"5\" ng-model=\"$ctrl.model.description\" placeholder=\"Description\"></textarea>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"contact\">{{'carrier.POCName' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"POCName\" placeholder=\"\" ng-model=\"$ctrl.model.POCName\">\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"contact\">{{'carrier.POCPhone' | translate }}</label>\n<input type=\"text\" class=\"form-control\" id=\"POCPhone\" placeholder=\"\" ng-model=\"$ctrl.model.POCPhone\" ui-us-phone-number>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"contact\">{{'carrier.POCEmail' | translate }} *</label>\n<input type=\"email\" required class=\"form-control\" id=\"POCEmail\" placeholder=\"\" ng-model=\"$ctrl.model.POCEmail\">\n</div>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</form>\n</div>";
var id1="carrier.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid remove-right-pad remove-left-pad\">\n<div class=\"col-sm-12 text-center remove-pad\">\n<div ng-if=\"$ctrl.showCheckin\" class=\"col-sm-12 remove-pad\">\n<div id=\"provisional-credit\" class=\"checkin-overlay-toast font-size-50\" ng-if=\"$ctrl.isProvisionalCredit\">\n{{'checkin.provisional_credit' | translate}}\n</div>\n<div class=\"col-sm-9 remove-pad\">\n<div class=\"align-center-vertically fivecolumns\">\n<div class=\"span2\">\n<div class=\"form-group\">\n<label for=\"contact\">{{'checkin.branch' | translate }}</label>\n<input type=\"text\" ng-if=\"!$ctrl.overridenBySupervisor\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.branch\" disabled=\"\">\n<select ng-if=\"$ctrl.overridenBySupervisor\" ng-options=\"branch.id as branch.id for branch in $ctrl.branches\" ng-model=\"$ctrl.model.branch\" ng-change=\"$ctrl.loadWindows()\" class=\"form-control\"></select>\n</div>\n</div>\n<div class=\"span2\">\n<div class=\"form-group\">\n<label for=\"\">{{'checkin.route' | translate }} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.route\" disabled=\"\">\n</div>\n</div>\n<div class=\"span2\">\n<div class=\"form-group\">\n<label for=\"\">{{'checkin.window' | translate }} </label>\n<input type=\"text\" ng-if=\"!$ctrl.overridenBySupervisor\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.window\" disabled=\"\">\n<select ng-if=\"$ctrl.overridenBySupervisor\" ng-options=\"window.id as window.id for window in $ctrl.windows\" ng-model=\"$ctrl.model.window\" class=\"form-control\"></select>\n</div>\n</div>\n<div class=\"span2\">\n<div class=\"form-group\">\n<label for=\"\">{{'checkin.fromTanker' | translate }} </label>\n<input type=\"text\" ng-if=\"!$ctrl.overridenBySupervisor\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.fromTanker\" disabled=\"\">\n<select ng-if=\"$ctrl.overridenBySupervisor\" ng-options=\"truck.id as truck.id for truck in $ctrl.trucks\" ng-model=\"$ctrl.model.fromTanker\" class=\"form-control\"></select>\n</div>\n</div>\n<div class=\"span2\">\n<div class=\"form-group\">\n<label for=\"\">{{'checkin.toTanker' | translate }} </label>\n<input type=\"text\" ng-if=\"!$ctrl.overridenBySupervisor\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.toTanker\" disabled=\"\">\n<select ng-if=\"$ctrl.overridenBySupervisor\" ng-options=\"truck.id as truck.id for truck in $ctrl.trucks\" ng-model=\"$ctrl.model.toTanker\" class=\"form-control\"></select>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-3 display-flex remove-pad\">\n<div class=\"col-sm-6 padding-zero form-group margin-right-10\" ng-if=\"$ctrl.overridenBySupervisor\">\n<label for=\"\">&nbsp;</label>\n<div>\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.saveOverride()\" ng-if=\"$ctrl.overridenBySupervisor\" ng-click=\"$ctrl.override()\">{{'checkin.save_override'|translate}}</button>\n</div>\n</div>\n<div class=\"padding-zero form-group\" ng-class=\"{'col-sm-6': $ctrl.overridenBySupervisor, 'col-sm-12': !$ctrl.overridenBySupervisor}\">\n<label for=\"\">&nbsp;</label>\n<div>\n<button type=\"button\" class=\"btn btn-primary\" ng-if=\"!$ctrl.routeVerifyData.errorCount\" ng-click=\"$ctrl.closeRoute()\">\n{{'checkin.close_route' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-primary\" ng-if=\"$ctrl.routeVerifyData.errorCount\" ng-disabled=\"isEventFired\" ng-click=\"$ctrl.forceClose()\">\n{{'checkin.force_close' | translate}}\n<span class=\"badge error-button-badge\">{{$ctrl.routeVerifyData.errorCount}}</span>\n</button>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<hr/>\n</div>\n<div class=\"row\" style=\"text-align: center;\" ng-if=\"!$ctrl.hasRoute\">\n<div class=\"col-sm-12 align-center-horizontally\" ng-if=\"$ctrl.closedRoute\">\n<div class=\"margin-right-30 align-center-vertically\">\n<span class=\"glyphicon glyphicon-ok text-success\" style=\"font-size: 100px;\"></span>\n</div>\n<div class=\"align-center-vertically\">\n<div class=\"text-align-left\">\n<div class=\"font-size-25\">\n<span class=\"text-success\"><b>{{'route.route' | translate}} {{$ctrl.closedRoute}}</b></span>\n</div>\n<div class=\"font-size-20\">\n<span class=\"text-success\">{{'checkin.successfullyCheckedin' | translate}} </span>\n</div>\n<div class=\"font-size-20\">\n<span class=\"text-success\">{{$ctrl.lastStatusUpdate | date:'hh:mm:ss a'}}</span>\n</div>\n<div>\n<button class=\"btn btn-success\" ng-click=\"$ctrl.printManifest();\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{'routeSheet.print'|translate }}\n</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 text-center\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 70px; margin: 0 auto;\">\n{{'checkin.waitForRoute' | translate}}\n</div>\n<div style=\"padding-top: 10px;\">\n<input autocomplete=\"off\" type=\"text\" class=\"form-control\" id=\"route-scan-id\" style=\"width: 200px; margin: 0 auto;\" ng-model=\"$ctrl.scannedRouteId\" strip-prefix on-press-enter=\"$ctrl.routeScanned()\" scan-type=\"'route'\">\n</div>\n</div>\n</div>\n<div class=\"row\" style=\"text-align: center;\" ng-if=\"$ctrl.hasRoute && !$ctrl.hasWindow\">\n<div class=\"col-sm-12 text-center\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 70px; margin: 0 auto;\">\n{{'checkin.waitForWindow' | translate}}\n</div>\n<div style=\"padding-top: 10px;\">\n<form>\n<input autocomplete=\"off\" type=\"text\" strip-prefix on-press-enter=\"$ctrl.windowScanned()\" scan-type=\"'window'\" class=\"form-control\" id=\"window-scan-id\" placeholder=\"\" ng-model=\"$ctrl.model.window\" style=\"width: 200px; margin: 0 auto;\">\n</form>\n</div>\n</div>\n</div>\n<div class=\"row\" style=\"text-align: center;\" ng-if=\"$ctrl.hasWindow && !$ctrl.hasMessenger\">\n<div class=\"col-sm-12 text-center\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 70px; margin: 0 auto;\">\n{{'checkin.waitForMessenger' | translate}}\n</div>\n<div style=\"padding-top: 10px;\">\n<form>\n<input autocomplete=\"off\" type=\"text\" class=\"form-control\" id=\"messengerId\" style=\"width: 200px; margin: 0 auto;\" ng-model=\"$ctrl.model.messengerId\" strip-prefix on-press-enter=\"$ctrl.messengerScanned()\" scan-type=\"'messenger'\" ng-blur=\"$ctrl.setFocus()\">\n</form>\n</div>\n</div>\n</div>\n<div class=\"row\" style=\"text-align: center;\" ng-if=\"$ctrl.hasMessenger && !$ctrl.hasFromTanker\">\n<div class=\"col-sm-12 text-center\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 70px; margin: 0 auto;\">\n{{'checkin.waitForTanker' | translate}}\n</div>\n<div style=\"padding-top: 10px;\">\n<form>\n<input autocomplete=\"off\" type=\"text\" class=\"form-control\" id=\"truckId\" style=\"width: 200px; margin: 0 auto;\" ng-model=\"$ctrl.model.fromTanker\" strip-prefix on-press-enter=\"$ctrl.fromTankerScanned()\" scan-type=\"'tanker'\" ng-blur=\"$ctrl.setFocus()\" capitalize>\n</form>\n</div>\n</div>\n</div>\n<div class=\"row\" style=\"text-align: center;\" ng-if=\"$ctrl.model.loadTruck && $ctrl.hasFromTanker && !$ctrl.hasToTanker\">\n<div class=\"col-sm-12 text-center\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 70px; margin: 0 auto;\">\n{{'checkin.waitForToTanker' | translate}}\n</div>\n<div style=\"padding-top: 10px;\">\n<form>\n<input autocomplete=\"off\" type=\"text\" class=\"form-control\" id=\"toTanker\" style=\"width: 200px; margin: 0 auto;\" ng-model=\"$ctrl.model.toTanker\" strip-prefix on-press-enter=\"$ctrl.toTankerScanned()\" scan-type=\"'tanker'\" ng-blur=\"$ctrl.setFocus()\" capitalize>\n</form>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad text-center\" ng-if=\"$ctrl.showCheckin\">\n<div class=\"col-sm-3 text-center\">\n<div class=\"col-sm-12\">\n<h4><strong>{{'checkin.remainingItems' | translate}}</strong></h4>\n</div>\n<div class=\"btn-group z-index0 col-sm-4s\" ng-if=\"!$ctrl.coinCheckOut\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentItemStat\" uib-btn-radio=\"$ctrl.itemStats.cash\" ng-click=\"$ctrl.tabSelection('cash'); $ctrl.checkInTabSelection('shipment');\" ng-class=\"{'btn-success': $ctrl.model.currentItemStat === $ctrl.itemStats.cash}\">\n{{ 'common.cash' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentItemStat\" uib-btn-radio=\"$ctrl.itemStats.items\" ng-click=\"$ctrl.tabSelection('items'); $ctrl.checkInTabSelection('items');\" ng-class=\"{'btn-success': $ctrl.model.currentItemStat === $ctrl.itemStats.items}\">\n{{ 'item.items' | translate }}\n<span class=\"badge error-button-badge\" ng-if=\"$ctrl.remainingToCheckoutItemCount > 0\">{{$ctrl.remainingToCheckoutItemCount}}</span>\n</label>\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-md btn-secondary\" ng-click=\"$ctrl.refreshData()\" ng-disabled=\"$ctrl.model.refreshItems\" uib-tooltip=\"{{'item.tooltip_reload' | translate}}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-right-pad margin-top-10\" style=\"border: 1px solid #dedede;\" ng-if=\"$ctrl.model.currentItemStat === $ctrl.itemStats.cash\">\n<img src=\"" + __webpack_require__(398) + "\" style=\"height: 150px\">\n<div class=\"margin-bottom-10 col-sm-12\">\n<br>\n<a href=\"\" class=\"checkin-item-count\"><span class=\"text-danger itemsFontSize\" ng-click=\"$ctrl.shipmentInfo(false)\" uib-tooltip=\"{{'checkin.itemsRemaining' | translate}}\" tooltip-placement=\"top\">{{$ctrl.remainingCheckinItemCount}}</span></a>\n&nbsp;\n<span class=\"fnt-size-25\">/</span>\n&nbsp;\n<a href=\"\" class=\"checkin-item-count\"><span class=\"text-success itemsFontSize\" ng-click=\"$ctrl.shipmentInfo(true)\" uib-tooltip=\"{{'checkin.items' | translate}}\" tooltip-placement=\"top\">{{$ctrl.checkedInItem}}</span></a>\n</div>\n</div>\n<div class=\"col-sm-12 margin-10\" style=\"border: 1px solid #dedede; padding: 10px\" ng-if=\"$ctrl.model.currentItemStat === $ctrl.itemStats.items\">\n<img src=\"" + __webpack_require__(253) + "\" style=\"height: 124px; opacity: 0.6;\">\n<div class=\"margin-top-05\">\n<a href=\"\" class=\"checkin-item-count\" uib-tooltip=\"{{'checkout.itemsRemaining' | translate}}\" tooltip-placement=\"top\" ng-click=\"$ctrl.remainingLogisticItemList()\">\n<span class=\"text-danger itemsFontSize\">{{$ctrl.logisticItemObj.remainingItemsCount}}</span>\n</a>\n</div>\n</div>\n<div class=\"margin-top-10 form-group col-sm-12\" ng-if=\"$ctrl.setupData.enableAutoSubmit\">\n<label for=\"autoSubmit\" class=\"font-12\">{{'checkin.auto_submit' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.autoSubmitItem\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"col-sm-7 text-center\">\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.currentCheckInTab\" uib-btn-radio=\"$ctrl.checkInScanTab.shipment\" ng-click=\"$ctrl.checkInTabSelection('shipment')\" ng-class=\"{'btn-success': $ctrl.currentCheckInTab === $ctrl.checkInScanTab.shipment}\">\n{{ 'routeControl.shipments' | translate }}\n<span class=\"badge error-button-badge\">{{$ctrl.remainingCheckinItemCount}}</span>\n</button>\n</div>\n<div class=\"btn-group\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.currentCheckInTab\" uib-btn-radio=\"$ctrl.checkInScanTab.items\" ng-click=\"$ctrl.checkInTabSelection('items')\" ng-class=\"{'btn-success': $ctrl.currentCheckInTab === $ctrl.checkInScanTab.items}\">\n{{ 'item.menu.title' | translate }}\n<span class=\"badge error-button-badge\">{{$ctrl.logisticItemObj.remainingItemsCount}}</span>\n</button>\n</div>\n</div>\n<div ng-if=\"$ctrl.currentCheckInTab === $ctrl.checkInScanTab.shipment\">\n<form ng-keydown=\"(!$ctrl.autoSubmitItem && $event.keyCode === 13 && $ctrl.bagScanned()) || ($ctrl.autoSubmitItem && $ctrl.setupData.enableAutoSubmit && $event.keyCode === 13 && $ctrl.autoSubmit())\">\n<div class=\"checkout-scan-section\">\n<div class=\"padding-10 col-sm-2\" style=\"text-align: right;\">\n<label for=\"contact\">{{'checkout.bag' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input id=\"bagId\" type=\"text\" class=\"form-control input-lg\" style=\"margin: 0 auto;\" autocomplete=\"off\" ng-model=\"$ctrl.model.bagId\" strip-whitespace ng-pattern=\"/^[a-zA-Z0-9-$_ ]*$/\" ng-keydown=\"$ctrl.keyPressed('bagId', $event)\" ng-disabled=\"$ctrl.overridenBySupervisor || $ctrl.disabledBag\" capitalize disable-copy-paste disable-tracking-id-typing>\n</div>\n<div class=\"padding-10 col-sm-1\">\n<button type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-success pull-left\" ng-click=\"$ctrl.clearScan(true)\">Clear</button>\n</div>\n</div>\n</form>\n<form ng-show=\"!!$ctrl.model.bagId && !$ctrl.lastStatusUpdate && !$ctrl.manifest.showManifestModal\">\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">{{'checkin.destination' | translate }}</label>\n</div>\n<div class=\"col-sm-8 btn-group\" uib-dropdown>\n<button style=\"min-height: 35px;\" type=\"button\" id=\"destinationSelection\" ng-keydown=\"$event.keyCode === 13 && $ctrl.stopPropagation($event)\" ng-keyup=\"$event.keyCode === 13 && (($ctrl.isDestinationChanged || $ctrl.isAmountChanged || $ctrl.isShipperChanged) ? $ctrl.saveChanges() : $ctrl.bagSubmitted())\" class=\"btn btn-default btn-block\" uib-dropdown-toggle keyboard-nav=\"true\" ng-disabled=\"!$ctrl.model.destination\">\n<div class=\"col-sm-12 padding-zero align-center-vertically\">\n<div class=\"text-align-left padding-zero col-sm-10\" ng-if=\"$ctrl.model.destination\">\n<div class=\"padding-zero h4\" style=\"white-space: normal;\">\n<strong ng-if=\"$ctrl.getAvailableDestination.length\">{{$ctrl.newValues.destination.name}}</strong>\n<strong ng-if=\"!$ctrl.getAvailableDestination.length\">{{$ctrl.newValues.destination.toLocationName}}</strong>\n</div>\n<div style=\"white-space: normal;\">\n<h5 class=\"padding-zero\" ng-if=\"$ctrl.getAvailableDestination.length\">\n{{$ctrl.newValues.destination.address}} {{$ctrl.newValues.destination.city}} {{$ctrl.newValues.destination.zip}} {{$ctrl.newValues.destination.state}} {{$ctrl.newValues.destination.country}}\n</h5>\n<h5 class=\"padding-zero\" ng-if=\"!$ctrl.getAvailableDestination.length\">\n{{$ctrl.newValues.destination.toAddress}}\n</h5>\n</div>\n</div>\n<div class=\"padding-zero\" ng-class=\"{'col-sm-2': $ctrl.model.destination, 'col-sm-12': !$ctrl.model.destination}\">\n<span class=\"caret pull-right\"></span>\n</div>\n</div>\n</button>\n<ul class=\"dropdown-menu check-in-destination\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\" ng-if=\"$ctrl.getAvailableDestination.length\">\n<li role=\"menuitem\" ng-repeat=\"destination in $ctrl.getAvailableDestination\">\n<a ng-click=\"$ctrl.setDestination(destination)\">\n<h4><strong>{{destination.name}}</strong></h4>\n<h5>\n<span ng-if=\"destination.address\">{{destination.address}}</span>\n<span ng-if=\"destination.city\">{{destination.city}},</span>\n<span ng-if=\"destination.zip\">{{destination.zip}},</span>\n<span ng-if=\"destination.state\">{{destination.state}},</span>\n<span ng-if=\"destination.country\">{{destination.country}}</span>\n</h5>\n</a>\n</li>\n</ul>\n<ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\" ng-if=\"!$ctrl.getAvailableDestination.length\">\n<li role=\"menuitem\">\n<a>\n<h4><strong>{{$ctrl.Shipmentresponse.toLocationName}}</strong></h4>\n<h5>\n<span ng-if=\"$ctrl.Shipmentresponse.toAddress\">{{$ctrl.Shipmentresponse.toAddress}}</span>\n</h5>\n</a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-1 padding-zero margin-top-10\" ng-if=\"$ctrl.gettingDestination\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</div>\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">{{'checkin.type' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<select class=\"form-control\" ng-model=\"$ctrl.newValues.shiptype\" ng-change=\"$ctrl.changeShipType($ctrl.newValues.shiptype, 'shiptype');\" ng-disabled=\"!$ctrl.model.destination || (($ctrl.model.shiptype || '').toLowerCase() === 'bulktransfer')\" ng-options=\"type.id as type.description for type in $ctrl.shiptypes\" ng-keydown=\"$event.keyCode === 13 && $ctrl.saveChanges()\"></select>\n</div>\n</div>\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">{{'checkin.quantity' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.newValues.quantity\" ng-disabled=\"!$ctrl.model.coinFlag || !$ctrl.newValues.shiptype\" min=\"1\" ng-change=\"$ctrl.shipmentAmountChanged('quantity')\" ng-keydown=\"$event.keyCode === 13 && $ctrl.saveChanges()\"/>\n</div>\n</div>\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">{{'checkin.amount' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input type=\"text\" class=\"form-control\" style=\"margin: 0 auto;\" ng-model=\"$ctrl.newValues.amount\" ng-currency ng-disabled=\"$ctrl.model.coinFlag || !$ctrl.newValues.shiptype\" ng-change=\"$ctrl.shipmentAmountChanged('amount')\" ng-keydown=\"$event.keyCode === 13 && $ctrl.saveChanges()\" ng-class=\"{'highlight-amount': $ctrl.newValues.amount !== null && $ctrl.newValues.amount <= 1 && $ctrl.newValues.amount !== ''}\">\n</div>\n</div>\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">{{'checkin.shipper' | translate }}</label>\n</div>\n<div class=\"col-sm-8 text-left\">\n<button ng-show=\"!$ctrl.isEditingShipper\" type=\"button\" class=\"btn btn-default btn-block checkin-shipper-display clearfix\" ng-click=\"$ctrl.editShipper($event)\" style=\"min-height: 35px; margin-bottom: 0; padding: 6px 12px; text-align: left;\" ng-disabled=\"!$ctrl.model.destination\">\n<div class=\"col-sm-12 padding-zero align-center-vertically\">\n<div class=\"text-align-left padding-zero col-sm-10\" ng-if=\"$ctrl.model.destination\">\n<div ng-if=\"$ctrl.model.shipper.name\">\n<div class=\"padding-zero h4\" style=\"white-space: normal;\">\n<strong>{{$ctrl.model.shipper.name}}</strong>\n</div>\n<div style=\"white-space: normal;\">\n<h5 class=\"padding-zero\">\n{{$ctrl.model.shipper.address}}\n</h5>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.shipper.name\">\n<div class=\"padding-zero h4\" style=\"white-space: normal;\">\n<span class=\"text-muted\">{{'common.select_location' | translate}}</span>\n</div>\n</div>\n</div>\n<div class=\"padding-zero\" ng-class=\"{'col-sm-2': ($ctrl.model.destination && $ctrl.model.shipper.name), 'col-sm-12': !($ctrl.model.destination && $ctrl.model.shipper.name)}\">\n<span class=\"caret pull-right\"></span>\n</div>\n</div>\n</button>\n<div ng-if=\"$ctrl.isEditingShipper\">\n<search-and-select focus-dropdown-id=\"shipperSelection\" ng-model=\"$ctrl.selectedShipperLocation\" values=\"$ctrl.shipperLocationObj.results\" key=\"Key\" totalrecords=\"$ctrl.shipperLocationObj.total\" onscroll=\"$ctrl.loadShipperLocations(searchKey, offset)\" on-click=\"$ctrl.onShipperSelected()\" none-selected=\"'common.select_location'\">\n</search-and-select>\n</div>\n</div>\n</div>\n<div class=\"checkout-scan-section\" ng-show=\"$ctrl.isDestinationChanged || $ctrl.isAmountChanged || $ctrl.isShipperChanged\">\n<div class=\"col-sm-3\">&nbsp;</div>\n<div class=\"col-sm-8\">\n<div class=\"pull-right\">\n<button type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-success padding-left-10\" ng-click=\"$ctrl.saveChanges()\">{{'common.save' | translate}}</button>\n<button type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-success padding-left-10\" ng-click=\"$ctrl.resetShipType();\">{{'common.reset' | translate}}</button>\n</div>\n</div>\n</div>\n</form>\n<form name=\"manifestModal\" id=\"manifestModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"manifestModalLabel\" aria-hidden=\"true\" backdrop=\"static\" keyboard=\"false\" ng-if=\"$ctrl.manifest.showManifestModal && $ctrl.model.bagId\" class=\"form-validate\">\n<div class=\"modal-dialog\" role=\"document\">\n<div class=\"modal-content\">\n<div class=\"modal-header\">\n<h5 class=\"modal-title\" id=\"manifestModalLabel\"><b>{{ 'checkin.checkinManifest' | translate }}</b></h5>\n</div>\n<div class=\"modal-body manifest-modal-body\">\n<div class=\"form-group\">\n<label for=\"totalBagCount\">{{'branch_mgmt.import_file_view.total_bag_count' | translate }}</label>\n<input type=\"number\" id=\"totalBagCount\" class=\"form-control\" ng-model=\"$ctrl.manifest.totalBagCount\" min=\"1\" required/>\n</div>\n<div class=\"form-group\">\n<label for=\"manifestID\">{{ 'checkin.manifest_id' | translate }}</label>\n<input type=\"text\" id=\"manifestID\" class=\"form-control\" ng-model=\"$ctrl.manifest.manifestID\"/>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"manifestModal.$invalid || $ctrl.manifest.isSubmitting || $ctrl.manifest.isCompleted\" ng-click=\"$ctrl.submitManifest()\">\n{{'Submit' | translate}}\n</button>\n</div>\n</div>\n</div>\n</form>\n<div style=\"padding-top: 20px\" ng-if=\"$ctrl.model.lastScan\">\n<strong>Last Scanned: {{$ctrl.model.lastScan}}</strong>\n</div>\n</div>\n<div ng-if=\"$ctrl.currentCheckInTab === $ctrl.checkInScanTab.items\">\n<form ng-keydown=\"(!$ctrl.autoSubmitItem && $event.keyCode === 13 && $ctrl.logisticItemScan($event)) || \n\t\t\t\t\t\t\t\t($ctrl.autoSubmitItem && $ctrl.setupData.enableAutoSubmit && $event.keyCode === 13 && $ctrl.autoSubmitItems())\">\n<div class=\"checkout-scan-section\">\n<div class=\"padding-10 col-sm-2\" style=\"text-align: right;\">\n<label for=\"contact\">{{'common.trackingId' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input type=\"text\" id=\"barcode\" autocomplete=\"off\" ng-pattern=\"/^[a-zA-Z0-9-$_ ]*$/\" ng-keydown=\"$ctrl.itemScanKeyPress($event)\" strip-whitespace class=\"form-control input-lg\" ng-class=\"{'disabled' : $ctrl.logisticItemObj.disableItemScan}\" ng-model=\"$ctrl.logisticItemObj.barcode\" ng-disabled=\"$ctrl.logisticItemObj.disableItemScan\" style=\"margin: 0 auto;\" capitalize/>\n</div>\n<div class=\"padding-10 col-sm-1\">\n<button type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-success pull-left\" ng-click=\"$ctrl.clearItemScan()\">{{'common.clear' | translate}}</button>\n</div>\n</div>\n</form>\n<form ng-show=\"!!$ctrl.logisticItemObj.barcode && !$ctrl.logisticItemObj.lastUpdated\">\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">Item</label>\n</div>\n<div class=\"col-sm-8\">\n<input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.logisticItemObj.itemDetails.label\" disabled=\"disabled\"/>\n</div>\n</div>\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">Note</label>\n</div>\n<div class=\"col-sm-8\">\n<input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.logisticItemObj.itemDetails.notes\" disabled=\"disabled\"/>\n</div>\n</div>\n</form>\n</div>\n</div>\n<div class=\"col-sm-2 remove-left-pad text-center\" ng-show=\"($ctrl.lastStatusUpdate || $ctrl.bagScanLimitExceed) && $ctrl.currentCheckInTab === $ctrl.checkInScanTab.shipment\">\n<div class=\"glyphicon glyphicon-ok text-success\" ng-show=\"!$ctrl.isError && !$ctrl.bagScanLimitExceed\" style=\"font-size: 100px;\"></div>\n<img src=\"" + __webpack_require__(69) + "\" class=\"img-120\" ng-show=\"$ctrl.isError || $ctrl.bagScanLimitExceed\" alt=\"error\">\n<div class=\"text-danger\" ng-if=\"$ctrl.isError && $ctrl.lastScanned || $ctrl.bagScanLimitExceed\"><b>{{ 'common.lastScan' | translate }} : {{$ctrl.lastScanned}}</b></div>\n<div class=\"text-danger\" ng-if=\"$ctrl.isError && $ctrl.bagCheckinError\"><b>{{$ctrl.bagCheckinError}}</b></div>\n<div class=\"text-success\" ng-if=\"!$ctrl.isError && $ctrl.bagCheckinMessage\"><b>{{$ctrl.bagCheckinMessage}}</b></div>\n<div class=\"text-danger\" ng-if=\"$ctrl.bagScanLimitExceed\"><b>{{$ctrl.bagScanError}}</b></div>\n<div class=\"text-success\" ng-if=\"!$ctrl.isError && $ctrl.shipmentChangeMessage\"><b>{{$ctrl.shipmentChangeMessage}}</b></div>\n<br>\n<span ng-class=\"{'text-danger': ($ctrl.isError || $ctrl.bagScanLimitExceed), 'text-success': (!$ctrl.isError || !$ctrl.bagScanLimitExceed)}\">{{$ctrl.lastStatusUpdate | date:'hh:mm:ss a'}}</span>\n<br>\n<div class=\"align-center-horizontally margin-top-20\" ng-if=\"!$ctrl.wasItemFound && !$ctrl.bagScanLimitExceed\">\n<button class=\"btn btn-primary\" ng-click=\"$ctrl.forceAddBag()\">{{'checkinSelectionModal.forceBag' | translate}}</button>\n</div>\n</div>\n<div class=\"col-sm-2 remove-left-pad text-center\" ng-show=\"($ctrl.logisticItemObj.lastUpdated || $ctrl.logisticItemObj.itemScanLimitExceed) && $ctrl.currentCheckInTab === $ctrl.checkInScanTab.items\">\n<div class=\"glyphicon glyphicon-ok text-success font-size-100\" ng-show=\"!$ctrl.logisticItemObj.isError && !$ctrl.logisticItemObj.itemScanLimitExceed\">\n</div>\n<img src=\"" + __webpack_require__(69) + "\" ng-show=\"$ctrl.logisticItemObj.isError || $ctrl.logisticItemObj.itemScanLimitExceed\" alt=\"error\" height=\"120\" width=\"120\">\n<div class=\"text-danger string-break\" ng-if=\"$ctrl.logisticItemObj.isError && ($ctrl.logisticItemObj.lastScannedItem || $ctrl.logisticItemObj.itemScanLimitExceed)\">\n<b>{{ 'common.lastScan' | translate }} : {{$ctrl.logisticItemObj.lastScannedItem}}</b>\n</div>\n<div class=\"text-danger\" ng-if=\"$ctrl.logisticItemObj.isError && $ctrl.logisticItemObj.itemCheckInError\">\n<b>{{$ctrl.logisticItemObj.itemCheckInError}}</b>\n</div>\n<div class=\"text-success\" ng-if=\"!$ctrl.logisticItemObj.isError && $ctrl.logisticItemObj.itemCheckInMessage && !$ctrl.logisticItemObj.itemScanLimitExceed\">\n<b>{{ 'checkout.trackingId' | translate }}: {{$ctrl.logisticItemObj.lastScannedItem}}</b>\n</div>\n<div class=\"text-success\" ng-if=\"!$ctrl.logisticItemObj.isError && $ctrl.logisticItemObj.itemCheckInMessage && !$ctrl.logisticItemObj.itemScanLimitExceed\">\n<b>{{$ctrl.logisticItemObj.itemCheckInMessage}}</b>\n</div>\n<div class=\"text-danger\" ng-if=\"$ctrl.logisticItemObj.itemScanLimitExceed\">\n<b>{{$ctrl.logisticItemObj.itemScanError}}</b>\n</div>\n<br>\n<span ng-class=\"{'text-danger': ($ctrl.logisticItemObj.isError || $ctrl.logisticItemObj.itemScanLimitExceed), \n\t\t\t\t\t\t\t\t'text-success': (!$ctrl.logisticItemObj.isError || !$ctrl.logisticItemObj.itemScanLimitExceed)}\">\n{{$ctrl.logisticItemObj.lastUpdated | date:'hh:mm:ss a'}}\n</span>\n</div>\n</div>\n</div>\n";
var id1="checkin.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"remove-left-pad remove-right-pad margin-bottom-20 checkin_print col-sm-12 text-align-center\" ng-if=\"!$ctrl.model.generateCheckinManifest\">\n<div class=\"align-center-horizontally\">\n<img stream-print-logo class=\"margin-top-10 print-logo-height-80\">\n</div>\n<h4>{{ 'checkin.checkinManifest' | translate }}</h4>\n<div class=\"remove-left-pad remove-right-pad col-sm-12\" id=\"print-section\">\n<div class=\"col-sm-12 text-align-left margin-top-10 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-6 col-print-6 remove-left-pad\">\n<div>\n<span class=\"fs-print-12\">{{ 'checkout.fromLocation' | translate}}:</span>\n</div>\n<div>\n<h3 class=\"margin-zero fs-print-40\">\n<strong>{{'bagout_print.fromLocationName' | translate}}</strong>\n</h3>\n</div>\n<div>\n<h4 class=\"fs-print-40 margin-0\">{{'bagout_print.fromLocationAddress' | translate}}</h4>\n</div>\n</div>\n<div class=\"col-sm-6 text-align-right remove-right-pad\">\n<div class=\"margin-zero text-align-right\">\n<span class=\"fs-print-12\">{{ 'checkout.toLocation' | translate }}</span>\n</div>\n<div ng-if=\"$ctrl.messengerDetails.messengerId\">\n<h3 class=\"margin-zero fs-print-40\">\n<strong>\n{{ $ctrl.messengerDetails.firstName }} {{ $ctrl.messengerDetails.lastName }} | {{ $ctrl.messengerDetails.messengerId }}\n</strong>\n</h3>\n</div>\n<div ng-if=\"!$ctrl.messengerDetails.messengerId\">\n<h3 class=\"margin-zero text-align-right\">\n<strong>\n{{ 'checkout.n_a' | translate }}\n</strong>\n</h3>\n</div>\n</div>\n</div>\n<div>\n<br><br><br>\n</div>\n<div class=\"col-sm-12 text-align-left margin-top-10 print-margin-top-05 remove-left-pad remove-right-pad\">\n<strong>\n{{ 'checkout.routeId' | translate }}:\n</strong>\n<span>{{ $ctrl.routeId }}</span>\n<strong class=\"padding-left-10\">\n{{ 'checkout.totalBags' | translate }}:\n</strong>\n<span>{{ $ctrl.shipmentReportData.shipmentDetail.checkIn.totalBag }}</span>\n<strong class=\"padding-left-10\">\n{{ 'checkout.totalCoin' | translate }}:\n</strong>\n<span>{{ $ctrl.shipmentReportData.shipmentDetail.checkIn.totalCoin }}</span>\n<strong class=\"padding-left-10\">\n{{ 'checkout.totalAmount' | translate}}:\n</strong>\n<span>{{ $ctrl.shipmentReportData.shipmentDetail.checkIn.totalAmount | currency: '$'}}</span>\n<span class=\"pull-right\">\n<strong>\n{{ 'checkout.deliveryDate' | translate }}:\n</strong>\n<span>{{ $ctrl.deliveryDate | date: 'longDate'}}</span>\n</span>\n</div>\n<div class=\"col-sm-12 margin-top-10 remove-left-pad remove-right-pad\">\n<table class=\"table table-striped table-bordered\">\n<thead class=\"header-row\">\n<tr>\n<td>\n<strong>#</strong>\n</td>\n<td>\n<strong>{{ 'checkout.trackingId' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.fromLocationName' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.ToLocationName' | translate }}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.transactionType' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.amount' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.verify' | translate}}</strong>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipments in $ctrl.nonHoldShipments\">\n<td>{{ $index+1 }}</td>\n<td>{{ shipments.trackingId }}\n<span ng-if=\"shipments.holdFlag\">\n<img src=\"" + __webpack_require__(80) + "\" class=\"hold-icon-size\">\n</span>\n</td>\n<td>{{ shipments.fromLocationId }} | {{ shipments.fromLocationName }}</td>\n<td>{{ shipments.toLocationId }} | {{ shipments.toLocationName }}</td>\n<td>{{ shipments.shiptypeId }}</td>\n<td>{{ shipments.amount | currency:'$' }}</td>\n<td></td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 text-align-left margin-top-10 print-margin-top-10\" ng-if=\"$ctrl.model.itemList.length > 0\">\n<strong>{{ 'checkout.routeId' | translate }}:</strong>\n<span>{{ $ctrl.routeId }}</span>\n<strong class=\"margin-left-10\">{{ 'bagout.totalItems' | translate }}:</strong>\n<span>{{ $ctrl.model.itemList.length }}</span>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12\" ng-if=\"$ctrl.model.itemList.length > 0\">\n<table class=\"margin-top-10 table table-striped table-bordered table-pad-5\">\n<thead class=\"text-center\">\n<tr class=\"header-row\">\n<td><strong>#</strong></td>\n<td><strong>{{'item.items' | translate}}</strong></td>\n<td><strong>{{'atm_residual.trackingId' | translate}}</strong></td>\n<td><strong>{{'common.notes' | translate}}</strong></td>\n<td><strong>{{ 'checkout.verify' | translate}}</strong></td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in $ctrl.model.itemList track by $index\">\n<td>{{$index+1}}</td>\n<td>{{data.label}}\n<span ng-if=\"data.onHold\">\n<img src=\"" + __webpack_require__(80) + "\" class=\"hold-icon-size\">\n</span>\n</td>\n<td>{{data.barcode}}</td>\n<td>\n<span ng-if=\"data.notes\">{{data.notes}}</span>\n<span ng-if=\"!data.notes\">{{'common.n_a' | translate}}</span>\n</td>\n<td></td>\n</tr>\n</tbody>\n</table>\n</div>\n<center>\n<div class=\"checkin-verify margin-top-20\">\n<div class=\"checkin-promise\">\n<h4 class=\"padding-left-50\">{{ 'checkout.promise' | translate }}</h4>\n</div>\n<div class=\"manifest-content\">\n<h4 class=\"padding-left-50 margin-bottom-0\">{{ 'checkout.fullName' | translate }}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"padding-left-50 content-position\">{{'checkout.signature' | translate}}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"padding-left-50 content-position padding-left-10\">{{ 'checkout.verifyDate' | translate }}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n</div>\n</div>\n</center>\n</div>\n<div class=\"print-page second-page col-sm-12\" ng-if=\"$ctrl.isRouteAutoCheckin == true\">\n<div class=\"align-center-horizontally\">\n<img stream-print-logo class=\"margin-top-10 print-logo-height-80\">\n</div>\n<h4>{{ 'checkin.checkinManifest' | translate }} Not Delivered</h4>\n<div class=\"col-sm-12 text-align-left margin-top-10 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-6 col-print-6 remove-left-pad\">\n<div>\n<span class=\"fs-print-12\">{{ 'checkout.fromLocation' | translate}}:</span>\n</div>\n<div>\n<h3 class=\"margin-zero fs-print-40\">\n<strong>{{'bagout_print.fromLocationName' | translate}}</strong>\n</h3>\n</div>\n<div>\n<h4 class=\"fs-print-40 margin-0\">{{'bagout_print.fromLocationAddress' | translate}}</h4>\n</div>\n</div>\n<div class=\"col-sm-6 text-align-right remove-right-pad\">\n<div class=\"margin-zero text-align-right\">\n<span class=\"fs-print-12\">{{ 'checkout.toLocation' | translate }}</span>\n</div>\n<div ng-if=\"$ctrl.messengerDetails.messengerId\">\n<h3 class=\"margin-zero fs-print-40\">\n<strong>\n{{ $ctrl.messengerDetails.firstName }} {{ $ctrl.messengerDetails.lastName }} | {{ $ctrl.messengerDetails.messengerId }}\n</strong>\n</h3>\n</div>\n<div ng-if=\"!$ctrl.messengerDetails.messengerId\">\n<h3 class=\"margin-zero text-align-right\">\n<strong>\n{{ 'checkout.n_a' | translate }}\n</strong>\n</h3>\n</div>\n</div>\n</div>\n<div>\n<br><br><br>\n</div>\n<div class=\"col-sm-12 text-align-left margin-top-10 print-margin-top-05 remove-left-pad remove-right-pad\">\n<strong>\n{{ 'checkout.routeId' | translate }}:\n</strong>\n<span>{{ $ctrl.routeId }}</span>\n<strong class=\"padding-left-10\">\n{{ 'checkout.totalBags' | translate }}:\n</strong>\n<span>{{ $ctrl.shipmentReportData.shipmentDetail.notDelivered.totalBag }}</span>\n<strong class=\"padding-left-10\">\n{{ 'checkout.totalCoin' | translate }}:\n</strong>\n<span>{{ $ctrl.shipmentReportData.shipmentDetail.notDelivered.totalCoin }}</span>\n<strong class=\"padding-left-10\">\n{{ 'checkout.totalAmount' | translate}}:\n</strong>\n<span>{{ $ctrl.shipmentReportData.shipmentDetail.notDelivered.totalAmount | currency: '$'}}</span>\n<span class=\"pull-right\">\n<strong>\n{{ 'checkout.deliveryDate' | translate }}:\n</strong>\n<span>{{ $ctrl.deliveryDate | date: 'longDate'}}</span>\n</span>\n</div>\n<div class=\"col-sm-12 margin-top-10 remove-left-pad remove-right-pad\">\n<table class=\"table table-striped table-bordered\">\n<thead class=\"header-row\">\n<tr>\n<td><strong>#</strong></td>\n<td><strong>{{ 'checkout.trackingId' | translate }}</strong></td>\n<td><strong>{{ 'checkout.fromLocationName' | translate }}</strong></td>\n<td><strong>{{ 'checkout.ToLocationName' | translate }}</strong></td>\n<td><strong>{{ 'checkout.transactionType' | translate }}</strong></td>\n<td><strong>{{ 'checkout.amount' | translate }}</strong></td>\n<td><strong>{{ 'checkout.verify' | translate }}</strong></td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipments in $ctrl.holdShipments\">\n<td>{{ $index+1 }}</td>\n<td>{{ shipments.trackingId }}\n<span ng-if=\"shipments.holdFlag\">\n<img src=\"" + __webpack_require__(80) + "\" class=\"hold-icon-size\">\n</span>\n</td>\n<td>{{ shipments.fromLocationId }} | {{ shipments.fromLocationName }}</td>\n<td>{{ shipments.toLocationId }} | {{ shipments.toLocationName }}</td>\n<td>{{ shipments.shiptypeId }}</td>\n<td>{{ shipments.amount | currency:'$' }}</td>\n<td></td>\n</tr>\n</tbody>\n</table>\n</div>\n<center>\n<div class=\"checkin-verify margin-top-20\">\n<div class=\"checkin-promise\">\n<h4 class=\"padding-left-50\">{{ 'checkout.promise' | translate }}</h4>\n</div>\n<div class=\"manifest-content\">\n<h4 class=\"padding-left-50 margin-bottom-0\">{{ 'checkout.fullName' | translate }}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"padding-left-50 content-position\">{{'checkout.signature' | translate}}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"padding-left-50 content-position padding-left-10\">{{ 'checkout.verifyDate' | translate }}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n</div>\n</div>\n</center>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.generateCheckinManifest\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-50\"></span>\n</div>";
var id1="print_checkin.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\" style=\"text-align: center;\" ng-if=\"!$ctrl.hasRoute\">\n<div class=\"row\" ng-if=\"$ctrl.checkedoutRoute\">\n<div class=\"col-sm-12 align-center-horizontally\">\n<div class=\"margin-right-30 align-center-vertically\">\n<span class=\"glyphicon glyphicon-ok text-success\" style=\"font-size: 70px;\"></span>\n</div>\n<div class=\"align-center-vertically\">\n<div class=\"text-align-left\">\n<div class=\"font-size-22\">\n<span class=\"text-success\">\n<b>{{'route.route' | translate}} {{$ctrl.checkedoutRoute}}</b>\n</span>\n</div>\n<div class=\"font-size-15\">\n<span class=\"text-success\">{{'checkout.successfullyCheckedout' | translate}} </span>\n</div>\n<div class=\"font-size-15\">\n<span class=\"text-success\">{{$ctrl.lastStatusUpdate | date:'hh:mm:ss a'}}</span>\n</div>\n</div>\n</div>\n<div class=\"btn-margin-top-10 checkout-manifest-btn\">\n<button class=\"btn btn-success\" ng-click=\"$ctrl.printManifest()\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{'checkout.print_manifest' | translate}}\n</button>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.checkedoutRoute && !$ctrl.isCheckOutNextRoute && $ctrl.isEnableMultiFunction\">\n<div class=\"col-sm-12\">\n<hr>\n</div>\n<div class=\"col-sm-12 align-center-horizontally\">\n<div class=\"margin-right-30 align-center-vertically\" ng-if=\"$ctrl.routeCheckedOutData.isAutoOptimize\">\n<span class=\"glyphicon glyphicon-ok text-success\" style=\"font-size: 70px;\"></span>\n</div>\n<div class=\"margin-right-30 align-center-vertically\" ng-if=\"!$ctrl.routeCheckedOutData.isAutoOptimize\">\n<span class=\"glyphicon glyphicon-minus lbl-grey-color\" style=\"font-size: 70px;\"></span>\n</div>\n<div class=\"align-center-vertically\">\n<div class=\"text-align-left\">\n<div class=\"font-size-22\">\n<span ng-class=\"{'lbl-grey-color' : !$ctrl.routeCheckedOutData.isAutoOptimize, 'text-success' : $ctrl.routeCheckedOutData.isAutoOptimize}\" style=\"padding-right: 10px;\">\n<b>{{'checkout.auto_optimizing_route' | translate}}</b>\n</span>\n</div>\n<div class=\"font-size-15\" ng-if=\"$ctrl.optimizedStops\">\n<span class=\"text-success\">{{$ctrl.optimizedStops}} of {{$ctrl.optimizedStops}} {{'checkout.stops_optimized' | translate}}</span>\n</div>\n</div>\n</div>\n<div ng-class=\"{'margin-top-20': !$ctrl.optimizedStops, 'btn-margin-top-10': $ctrl.optimizedStops}\" class=\"checkout-manifest-btn\">\n<button class=\"btn btn-success\" ng-disabled=\"!$ctrl.routeCheckedOutData.isAutoOptimize\" ng-click=\"$ctrl.AutoOptimizeRoute()\">\n{{'checkout.btn_view' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-offset-2 col-sm-9 align-center-horizontally margin-top-20\" style=\"padding-right: 0px;\">\n<div class=\"margin-right-30 align-center-vertically\" ng-if=\"$ctrl.routeCheckedOutData.isAutoOpenATMs\">\n<span class=\"glyphicon glyphicon-ok text-success\" style=\"font-size: 70px;\"></span>\n</div>\n<div class=\"margin-right-30 align-center-vertically\" ng-if=\"!$ctrl.routeCheckedOutData.isAutoOpenATMs\">\n<span class=\"glyphicon glyphicon-minus lbl-grey-color\" style=\"font-size: 70px;\"></span>\n</div>\n<div class=\"align-center-vertically\">\n<div class=\"text-align-left\">\n<div class=\"font-size-22\">\n<span ng-class=\"{'lbl-grey-color' : !$ctrl.routeCheckedOutData.isAutoOpenATMs, 'text-success' : $ctrl.routeCheckedOutData.isAutoOpenATMs}\">\n<b>{{'checkout.auto_generate_codes' | translate}}</b>\n</span>\n</div>\n<div class=\"font-size-15\" ng-if=\"$ctrl.routeCheckedOutData.isAutoOpenATMs\">\n<span class=\"text-success\">{{$ctrl.routeCheckedOutData.totalOpenedLock}} of {{$ctrl.routeCheckedOutData.totalLocations}} {{'checkout.opened' | translate}}\n<span ng-if=\"$ctrl.routeCheckedOutData.failedToOpen > 0\">| {{$ctrl.routeCheckedOutData.failedToOpen}} {{'checkout.failed_to_open' | translate}}</span>\n</span>\n</div>\n</div>\n</div>\n<div class=\"btn-margin-top-10 checkout-manifest-btn\" ng-class=\"{'margin-top-20': !$ctrl.routeCheckedOutData.isAutoOpenATMs}\">\n<button class=\"btn btn-success\" ng-disabled=\"!$ctrl.routeCheckedOutData.isAutoOpenATMs\" ng-click=\"$ctrl.autoGenerateAtmCodes()\">\n{{'checkout.btn_view' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-10 align-center-horizontally margin-top-20\" ng-if=\"$ctrl.isInventoryBulkCoinOfCOD\">\n<div class=\"margin-right-30 align-center-vertically padding-left-60\">\n<span class=\"glyphicon glyphicon-ok text-success\" style=\"font-size: 70px;\"></span>\n</div>\n<div class=\"align-center-vertically\">\n<div class=\"text-align-left\">\n<div class=\"font-size-22\">\n<span class=\"text-success\">\n<b>{{'checkout.bulk_coin_debit' | translate}}</b>\n</span>\n</div>\n<div class=\"font-size-15\">\n<span class=\"text-success\">\n<b>{{'checkout.coin_debit_successful' | translate}}</b>\n</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-10 align-center-horizontally margin-top-20\">\n<div class=\"margin-right-30 align-center-vertically padding-left-60\">\n<span class=\"glyphicon glyphicon-ok text-success\" style=\"font-size: 70px;\"></span>\n</div>\n<div class=\"align-center-vertically\">\n<div class=\"text-align-left\">\n<div class=\"font-size-22\">\n<span class=\"text-success\">\n<b>{{'navbar.serviceTickets_title' | translate}}</b>\n</span>\n</div>\n<div class=\"font-size-15\">\n<span class=\"text-success\">\n<b>{{$ctrl.routeCheckedOutData.serviceTicketsInfo.totalServiceTickets}} {{'checkout.pending_messenger_accept' | translate}}</b>\n</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row col-sm-11 align-center-horizontally margin-top-20 route-file-padding\">\n<div class=\"margin-right-30 align-center-vertically\">\n<span class=\"glyphicon glyphicon-ok text-success\" style=\"font-size: 70px;\"></span>\n</div>\n<div class=\"align-center-vertically txt-margin-right-25\">\n<div class=\"text-align-left\">\n<div class=\"font-size-22\">\n<span class=\"text-success\">\n<b>{{'checkout.route_file_released' | translate}}</b>\n</span>\n</div>\n<div class=\"font-size-15\">\n<span class=\"text-success\">{{$ctrl.checkedoutRoute}}{{$ctrl.zipSuffix}}.zip</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"align-center-horizontally margin-top-20 route-file-padding row remove-left-pad\" style=\"width: 36%;float: none !important;margin: 20px auto 0 !important;\" ng-if=\"$ctrl.routeCheckedOutData.sendRouteSheet\">\n<div class=\"margin-right-30 align-center-vertically\">\n<span class=\"glyphicon glyphicon-ok text-success\" style=\"font-size: 70px;\"></span>\n</div>\n<div class=\"align-center-vertically txt-margin-right-25\">\n<div class=\"text-align-left\">\n<div class=\"font-size-22\">\n<span class=\"text-success\">\n<b>Route Sheet Sent</b>\n</span>\n</div>\n<div class=\"font-size-15\">\n<span class=\"text-success\">Route Sheet Sent to {{$ctrl.routeCheckedOutData.routeSheetRecipients.split(',').join(', ')}}</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<hr>\n</div>\n<div class=\"row col-sm-12\">\n<button class=\"btn btn-secondary\" type=\"button\" ng-click=\"$ctrl.closeInfo()\">\n{{ 'common.close' | translate }}\n</button>\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.checkOutNextRoute()\">\n{{'checkout.check_out_next_route' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 text-center\" ng-if=\"$ctrl.isCheckOutNextRoute\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 111px; margin: 0 auto;\">\n{{'checkout.waitForRoute' | translate}}\n</div>\n<div style=\"padding-top: 51px;\" class=\"col-sm-4 col-sm-offset-4\">\n<div class=\"row\">\n<div class=\"col-sm-8 col-sm-offset-2\">\n<input autocomplete=\"off\" type=\"text\" class=\"form-control\" id=\"route-scan-id\" ng-model=\"$ctrl.scannedRouteId\" style=\"width: 200px; margin: 0 auto;\" strip-prefix on-press-enter=\"$ctrl.routeScanned()\" scan-type=\"'route'\"/>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\" style=\"text-align: center;\" ng-if=\"$ctrl.hasRoute && !$ctrl.hasMessenger && $ctrl.isShipmentThrown\">\n<div class=\"col-sm-12 text-center\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 111px; margin: 0 auto;\">\n{{'checkout.waitForMessenger' | translate}}\n</div>\n<div style=\"padding-top: 51px;\">\n<input type=\"text\" autocomplete=\"off\" style=\"width: 200px; margin: 0 auto;\" class=\"form-control\" ng-model=\"$ctrl.model.messenger\" strip-prefix id=\"messenger-scan-id\" on-press-enter=\"$ctrl.messengerScanned()\" scan-type=\"'messenger'\" ng-blur=\"$ctrl.setFocus()\"/>\n</div>\n</div>\n</div>\n<div class=\"row\" style=\"text-align: center;\" ng-if=\"$ctrl.hasMessenger && $ctrl.checkoutTruckLiability && !$ctrl.finalTruckIdData\">\n<div class=\"col-sm-12 text-center\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 111px; margin: 0 auto;\">\n{{'checkout.waitForTruckId' | translate}}\n</div>\n<div style=\"padding-top: 51px;\">\n<input type=\"text\" autocomplete=\"off\" style=\"width: 200px; margin: 0 auto;\" class=\"form-control\" ng-model=\"$ctrl.model.truckId\" strip-prefix id=\"truckId-scan-id\" on-press-enter=\"$ctrl.truckIDScanned()\" scan-type=\"'truckId'\" ng-blur=\"$ctrl.setFocus()\"/>\n</div>\n</div>\n</div>\n<div class=\"row\" style=\"text-align: center;\" ng-if=\"$ctrl.checkoutTruckLiability ? ($ctrl.finalTruckIdData && !$ctrl.hasFromTanker) : ($ctrl.hasMessenger &&  !$ctrl.hasFromTanker)\">\n<div class=\"col-sm-12 text-center\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 111px; margin: 0 auto;\">\n{{'checkout.waitForFromTanker' | translate}}\n</div>\n<div style=\"padding-top: 51px;\">\n<input autocomplete=\"off\" type=\"text\" class=\"form-control\" id=\"from-tanker-id\" style=\"width: 200px; margin: 0 auto;\" ng-model=\"$ctrl.model.fromTanker\" strip-prefix on-press-enter=\"$ctrl.fromTankerScanned()\" scan-type=\"'tanker'\" capitalize/>\n</div>\n</div>\n</div>\n<div class=\"row\" style=\"text-align: center;\" ng-if=\"$ctrl.checkoutTruckLiability ? ($ctrl.finalTruckIdData && $ctrl.hasFromTanker && !$ctrl.hasWindow) : ($ctrl.hasFromTanker && !$ctrl.hasWindow)\">\n<div class=\"col-sm-12 text-center\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 111px; margin: 0 auto;\">\n{{'checkout.waitForWindow' | translate}}\n</div>\n<div style=\"padding-top: 51px;\">\n<form>\n<input autocomplete=\"off\" type=\"text\" strip-prefix on-press-enter=\"$ctrl.windowScanned()\" scan-type=\"'window'\" class=\"form-control\" id=\"window-scan-id\" ng-model=\"$ctrl.model.window\" style=\"width: 200px; margin: 0 auto;\"/>\n</form>\n</div>\n</div>\n</div>\n<div class=\"row\" style=\"text-align: center;\" ng-if=\"$ctrl.hasWindow && !($ctrl.hasToTanker || $ctrl.hasToTruck)\">\n<div class=\"col-sm-12 text-center\" ng-if=\"$ctrl.model.loadTruckFlag\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 111px; margin: 0 auto;\">\n{{'checkout.waitForToTanker' | translate}}\n</div>\n<div style=\"padding-top: 51px;\">\n<form>\n<input autocomplete=\"off\" type=\"text\" class=\"form-control\" id=\"to-tanker-id\" style=\"width: 200px; margin: 0 auto;\" ng-model=\"$ctrl.model.toTanker\" strip-prefix on-press-enter=\"$ctrl.toTankerScanned()\" scan-type=\"'tanker'\" ng-blur=\"$ctrl.setFocus()\" capitalize/>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.loadTruckFlag && (!$ctrl.model.toTruck || $ctrl.model.restrictToTruck)\">\n<div style=\"width: 450px; height: 150px; font-weight: bold; font-size: 25px; padding-top: 111px; margin: 0 auto;\">\n{{'checkout.waitForToTruck' | translate}}\n</div>\n<div ng-if=\"$ctrl.model.restrictToTruck\" style=\"width: 280px; margin: 0 auto;\">\n<input type=\"text\" class=\"form-control valid\" id=\"to-truck-scan-restricted\" ng-model=\"$ctrl.restrictedTruckDisplay\" ng-init=\"$ctrl.focusElementById('to-truck-scan-restricted')\" on-press-enter=\"$ctrl.toTruckScanned()\" ng-keydown=\"$event.keyCode === 13 && $ctrl.toTruckScanned()\" readonly=\"readonly\" style=\"text-align:center; font-weight:bold; font-size:16px; background-color:#f5f5f5; cursor:default;\"/>\n<div style=\"margin-top:8px; font-size:12px; color:#e67e22; font-weight:normal; text-align:center;\">\n<span class=\"glyphicon glyphicon-lock\" style=\"margin-right:4px;\"></span>\nTruck Restriction is enabled for this route. Only the assigned truck can be used.<br/>\nPress enter to continue\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.restrictToTruck\" style=\"width: 280px; margin: 0 auto;\">\n<ui-select id=\"to-truck-scan\" ng-model=\"$ctrl.model.toTruck\" ng-class=\"{'valid': $ctrl.model.toTruck, 'invalid': !$ctrl.model.toTruck}\" theme=\"bootstrap\" on-select=\"$ctrl.toTruckScanned()\" autofocus>\n<ui-select-match>{{$select.selected.id}} | {{$select.selected.name}}</ui-select-match>\n<ui-select-choices repeat=\"truck.id as truck in $ctrl.model.allTrucks | filter: $select.search\">\n<div ng-bind-html=\"truck.id | highlight: $select.search\"></div>\n</ui-select-choices>\n</ui-select>\n</div>\n</div>\n</div>\n<div class=\"row\" style=\"text-align: center;\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.hasToTanker || $ctrl.hasToTruck\">\n<div class=\"row\">\n<div class=\"col-sm-12\" style=\"padding:0px !important;\">\n<div class=\"align-center-vertically fivecolumns\">\n<div class=\"span2\">\n<div class=\"form-group\">\n<label for=\"contact\">{{'checkout.branch' | translate }}</label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.branch\" disabled=\"\">\n<select ng-if=\"$ctrl.overridenBySupervisor\" ng-options=\"branch.id as branch.id for branch in $ctrl.branches\" ng-model=\"$ctrl.model.branch\" ng-change=\"$ctrl.loadWindows()\" class=\"form-control\"></select>\n</div>\n</div>\n<div class=\"span2\">\n<div class=\"form-group\">\n<label for=\"\">{{'checkout.route' | translate }} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.route\" disabled=\"\">\n</div>\n</div>\n<div class=\"span2\" ng-if=\"$ctrl.checkoutTruckLiability\">\n<div class=\"form-group\">\n<label for=\"\">{{'checkout.truckId' | translate }} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.truckId\" disabled=\"\">\n</div>\n</div>\n<div class=\"span2\">\n<div class=\"form-group\">\n<label for=\"\">{{'checkout.window' | translate }} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.window\" disabled=\"\">\n</div>\n</div>\n<div class=\"span2\">\n<div class=\"form-group\" ng-if=\"$ctrl.hasToTruck\">\n<label for=\"\">{{'checkout.toTruck' | translate }} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.toTruck\" disabled=\"\">\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.hasToTanker\">\n<label for=\"\">{{'checkout.toTanker' | translate }} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.toTanker\" disabled=\"\">\n</div>\n</div>\n<div class=\"span2\">\n<div class=\"form-group\" ng-if=\"$ctrl.hasFromTanker\">\n<label for=\"\">{{'checkout.fromTanker' | translate }} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.fromTanker\" disabled=\"\">\n</div>\n</div>\n<div class=\"span2\">\n<div class=\"form-group\" ng-if=\"$ctrl.model.restrictToTruck\">\n<label for=\"\">{{'checkout.truck' | translate }}</label>\n<input type=\"text\" class=\"form-control truck-field-custom\" ng-model=\"$ctrl.model.restrictTruck.id\" disabled=\"\">\n</div>\n</div>\n<div class=\"span2\" ng-if=\"!$ctrl.autoCheckOut\">\n<div class=\"form-group routeDetailConfiguration\">\n<label for=\"\">{{'configuration.menu.title' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.routeDetailConfiguration\" ng-options=\"routeDetailConfiguration.value as routeDetailConfiguration.label for routeDetailConfiguration in $ctrl.routeDetailConfigurationList\">\n</select>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.routeVerifyData.checkOutByTanker\">\n<div class=\"col-sm-9\">\n<input ng-keydown=\"$event.keyCode === 13 && $ctrl.scanPrefix('tanker', 'scannedTankerId'); $event.keyCode === 13 && $ctrl.scanTankerId();\" type=\"text\" placeholder=\"{{'checkout.scan_tanker_id' | translate}}\" class=\"input-lg form-control checkout-tanker-search-section\" ng-model=\"$ctrl.model.scannedTankerId\" capitalize>\n</div>\n<div class=\"col-sm-3 display-flex\">\n<div class=\"padding-right form-group\">\n<button type=\"button\" class=\"btn btn-primary margin-top-05\" ng-if=\"$ctrl.shipmentAssociateToTankerList.length && $ctrl.model.scannedTankerId\" ng-click=\"$ctrl.shipmentAssociateToTankerModal()\">\n{{'routeControl.shipments' | translate}} <span class=\"badge error-button-badge\">{{$ctrl.shipmentAssociateToTankerList.length}}</span>\n</button>\n</div>\n</div>\n</div>\n<hr/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad text-center\" ng-if=\"$ctrl.hasToTanker || $ctrl.hasToTruck\">\n<div class=\"col-sm-3 text-center\">\n<div class=\"col-sm-12\">\n<h4>\n<strong>{{'checkout.remainingItems' | translate}}</strong>\n</h4>\n</div>\n<div class=\"btn-group z-index0 col-sm-4s\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.cash\" ng-click=\"$ctrl.tabSelection('cash'); $ctrl.checkoutTabSelection('shipment');\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.cash}\">\n{{ 'common.cash' | translate }}\n</label>\n</div>\n<div class=\"btn-group\" ng-if=\"!$ctrl.coinCheckOut\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.coin\" ng-click=\"$ctrl.tabSelection('coin')\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.coin}\">\n{{ 'common.coin' | translate }}\n<span class=\"badge error-button-badge\" ng-if=\"$ctrl.remainingCoinCheckoutItemCount > 0\">{{$ctrl.remainingCoinCheckoutItemCount}}</span>\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.items\" ng-click=\"$ctrl.tabSelection('items'); $ctrl.checkoutTabSelection('items');\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.items}\">\n{{ 'item.items' | translate }}\n<span class=\"badge error-button-badge\" ng-if=\"$ctrl.remainingToCheckoutItemCount > 0\">{{$ctrl.remainingToCheckoutItemCount}}</span>\n</label>\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-md btn-secondary\" ng-click=\"$ctrl.refreshData()\" ng-disabled=\"$ctrl.model.refreshItems\" uib-tooltip=\"{{'item.tooltip_reload' | translate}}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 margin-10\" style=\"border: 1px solid #dedede; padding: 10px\" ng-if=\"$ctrl.model.stats === $ctrl.stats.cash\">\n<img src=\"" + __webpack_require__(399) + "\" style=\"height: 150px\">\n<div>\n<br>\n<a href=\"\" ng-if=\"!$ctrl.coinCheckOut\" class=\"checkout-item-count\"><span class=\"text-success itemsFontSize\" ng-click=\"$ctrl.shipmentInfo(true, $ctrl.stats.cash)\" uib-tooltip=\"{{'checkout.items' | translate}}\" tooltip-placement=\"top\">{{$ctrl.totalCashCheckedOut}}</span></a>\n<a href=\"\" ng-if=\"$ctrl.coinCheckOut\" class=\"checkout-item-count\"><span class=\"text-success itemsFontSize\" ng-click=\"$ctrl.shipmentInfo(true)\" uib-tooltip=\"{{'checkout.items' | translate}}\" tooltip-placement=\"top\">{{$ctrl.totalShipmentCheckedOut}}</span></a>\n&nbsp;\n<span class=\"fnt-size-25\">/</span>\n&nbsp;\n<a href=\"\" ng-if=\"!$ctrl.coinCheckOut\" class=\"checkout-item-count\"><span class=\"text-danger itemsFontSize\" ng-click=\"$ctrl.shipmentInfo(false, $ctrl.stats.cash)\" uib-tooltip=\"{{'checkout.itemsRemaining' | translate}}\" tooltip-placement=\"top\">{{$ctrl.remainingCashCheckoutItemCount}}</span></a>\n<a href=\"\" ng-if=\"$ctrl.coinCheckOut\" class=\"checkout-item-count\"><span class=\"text-danger itemsFontSize\" ng-click=\"$ctrl.shipmentInfo(false)\" uib-tooltip=\"{{'checkout.itemsRemaining' | translate}}\" tooltip-placement=\"top\">{{$ctrl.remainingCheckoutItemCount}}</span></a>\n</div>\n</div>\n<div class=\"col-sm-12 margin-10\" style=\"border: 1px solid #dedede; padding: 10px\" ng-if=\"$ctrl.model.stats === $ctrl.stats.coin\">\n<img src=\"" + __webpack_require__(247) + "\" style=\"height: 124px; opacity: 0.6;\">\n<div class=\"margin-10\">\n<button type=\"button\" ng-click=\"$ctrl.verifyCoinShipment()\" class=\"btn btn-sm btn-success\">\n{{'checkout.verify_coin' | translate}}\n</button>\n</div>\n<div class=\"margin-top-05\">\n<a href=\"\" class=\"checkout-item-count\" uib-tooltip=\"{{'checkout.coin_verified' | translate}}\" tooltip-placement=\"top\">\n<span class=\"text-success itemsFontSize\" ng-class=\"{'disabled' : !$ctrl.coinCheckOut}\" ng-click=\"$ctrl.shipmentInfo(false, $ctrl.stats.coin, 'completed')\">{{$ctrl.totalCoinVerified}}\n</span>\n</a>\n&nbsp;\n<span class=\"fnt-size-25\">/</span>\n&nbsp;\n<a href=\"\" class=\"checkout-item-count\" uib-tooltip=\"{{'checkout.itemsRemaining' | translate}}\" tooltip-placement=\"top\">\n<span class=\"text-danger itemsFontSize\" ng-class=\"{'disabled' : !$ctrl.coinCheckOut}\">{{$ctrl.remainingCoinCheckoutItemCount}}</span>\n</a>\n</div>\n</div>\n<div class=\"col-sm-12 margin-10\" style=\"border: 1px solid #dedede; padding: 10px\" ng-if=\"$ctrl.model.stats === $ctrl.stats.items\">\n<img src=\"" + __webpack_require__(253) + "\" style=\"height: 124px; opacity: 0.6;\">\n<div class=\"margin-top-05\">\n<a href=\"\" class=\"checkout-item-count\" uib-tooltip=\"{{'checkout.items' | translate}}\" tooltip-placement=\"top\" ng-click=\"$ctrl.logisticItemCheckedOutList()\">\n<span class=\"text-success itemsFontSize\">{{$ctrl.logisticItemObj.checkedOutItemsCount}}</span>\n</a>\n&nbsp;\n<span class=\"fnt-size-25\">/</span>\n&nbsp;\n<a href=\"\" class=\"checkout-item-count\" uib-tooltip=\"{{'checkout.itemsRemaining' | translate}}\" tooltip-placement=\"top\" ng-click=\"$ctrl.remainingLogisticItemList()\">\n<span class=\"text-danger itemsFontSize\">{{$ctrl.logisticItemObj.remainingItemsCount}}</span>\n</a>\n</div>\n<div class=\"margin-10\">\n<button type=\"button\" ng-click=\"$ctrl.availableLogisticItems()\" class=\"btn btn-sm btn-success\">\nAvailable Items\n<span class=\"badge error-button-badge\">{{$ctrl.logisticItemObj.availableItemCount}}</span>\n</button>\n</div>\n</div>\n<div class=\"margin-top-10 form-group col-sm-12\" ng-if=\"$ctrl.setupData.enableAutoSubmit\">\n<label for=\"autoSubmit\" class=\"font-12\">{{'checkin.auto_submit' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.autoSubmitItem\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"col-sm-7 text-center\">\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.currentCheckoutTab\" uib-btn-radio=\"$ctrl.checkoutTab.shipment\" ng-click=\"$ctrl.checkoutTabSelection('shipment')\" ng-class=\"{'btn-success': $ctrl.currentCheckoutTab === $ctrl.checkoutTab.shipment}\">\n{{ 'routeControl.shipments' | translate }}\n<span class=\"badge error-button-badge\" ng-if=\"!$ctrl.coinCheckOut\">{{$ctrl.remainingCashCheckoutItemCount + $ctrl.remainingCoinCheckoutItemCount}}</span>\n<span class=\"badge error-button-badge\" ng-if=\"$ctrl.coinCheckOut\">{{$ctrl.remainingCheckoutItemCount + $ctrl.remainingCoinCheckoutItemCount}}</span>\n</button>\n</div>\n<div class=\"btn-group\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.currentCheckoutTab\" uib-btn-radio=\"$ctrl.checkoutTab.items\" ng-click=\"$ctrl.checkoutTabSelection('items')\" ng-class=\"{'btn-success': $ctrl.currentCheckoutTab === $ctrl.checkoutTab.items}\">\n{{ 'item.menu.title' | translate }}\n<span class=\"badge error-button-badge\">{{$ctrl.logisticItemObj.remainingItemsCount}}</span>\n</button>\n</div>\n</div>\n<div ng-if=\"$ctrl.currentCheckoutTab === $ctrl.checkoutTab.shipment\">\n<form ng-keydown=\"$event.keyCode === 13 && $ctrl.scanPrefix('deliveryAndPickups', 'bagId'); $event.keyCode === 13 && $ctrl.bagScanned($event)\" ng-if=\"!$ctrl.autoSubmitItem\">\n<div class=\"checkout-scan-section\">\n<div class=\"padding-10 col-sm-2\" style=\"text-align: right;\">\n<label for=\"contact\">{{'checkout.bag' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input type=\"text\" id=\"bagId\" autocomplete=\"off\" ng-pattern=\"/^[a-zA-Z0-9-$_ ]*$/\" ng-keydown=\"$ctrl.keyPressed('bagId', $event)\" strip-whitespace class=\"form-control input-lg\" ng-class=\"{'disabled' : $ctrl.disabledBag}\" ng-model=\"$ctrl.model.bagId\" ng-disabled=\"$ctrl.disabledBag\" style=\"margin: 0 auto;\" capitalize disable-copy-paste disable-tracking-id-typing/>\n</div>\n<div class=\"padding-10 col-sm-1\">\n<button type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-success pull-left\" ng-click=\"$ctrl.clearScan(true)\">{{'common.clear' | translate}}</button>\n</div>\n</div>\n</form>\n<form ng-keydown=\"$event.keyCode === 13 && $ctrl.scanPrefix('deliveryAndPickups', 'bagId'); $event.keyCode === 13 && $ctrl.autoSubmit($event)\" ng-if=\"$ctrl.autoSubmitItem && $ctrl.setupData.enableAutoSubmit\">\n<div class=\"checkout-scan-section\">\n<div class=\"padding-10 col-sm-2 text-right\">\n<label for=\"contact\">{{'checkout.bag' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input type=\"text\" id=\"bagId\" autocomplete=\"off\" ng-pattern=\"/^[a-zA-Z0-9-$_ ]*$/\" ng-keydown=\"$ctrl.keyPressed('bagId', $event)\" strip-whitespace class=\"form-control input-lg\" ng-class=\"{'disabled' : $ctrl.disabledBag}\" ng-model=\"$ctrl.model.bagId\" ng-disabled=\"$ctrl.disabledBag\" style=\"margin: 0 auto;\" capitalize disable-copy-paste disable-tracking-id-typing/>\n</div>\n<div class=\"padding-10 col-sm-1\">\n<button type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-success pull-left\" ng-click=\"$ctrl.clearScan(true)\">{{'common.clear' | translate}}</button>\n</div>\n</div>\n</form>\n<form ng-show=\"!!$ctrl.model.bagId && !$ctrl.lastStatusUpdate\">\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">{{'checkout.destination' | translate }}</label>\n</div>\n<div class=\"col-sm-8 btn-group\" uib-dropdown>\n<button type=\"button\" style=\"min-height: 35px;\" class=\"btn btn-default btn-block\" disabled=\"disabled\">\n<div class=\"col-sm-12 padding-zero align-center-vertically\">\n<div class=\"text-align-left padding-zero col-sm-10\">\n<div class=\"padding-zero h4\" style=\"white-space: normal;\">\n<strong>{{$ctrl.model.shipment.toLocationName}}</strong>\n</div>\n<div style=\"white-space: normal;\">\n<h5 class=\"padding-zero\">{{$ctrl.model.shipment.toAddress}}</h5>\n</div>\n</div>\n<div class=\"padding-zero col-sm-2\">\n<span class=\"caret pull-right\"></span>\n</div>\n</div>\n</button>\n</div>\n</div>\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">{{'checkout.type' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.shipment.shiptypeId\" ng-options=\"type.id as type.description for type in $ctrl.shiptypes\" disabled=\"disabled\"></select>\n</div>\n</div>\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">{{'checkout.quantity' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.model.shipment.qty\" disabled=\"disabled\"/>\n</div>\n</div>\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">{{'checkout.amount' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.model.shipment.amount\" ng-currency disabled=\"disabled\"/>\n</div>\n</div>\n</form>\n<div class=\"margin-top-20\" ng-if=\"$ctrl.model.lastScan\">\n<strong>Last Scanned: {{$ctrl.model.lastScan}}</strong>\n</div>\n</div>\n<div ng-if=\"$ctrl.currentCheckoutTab === $ctrl.checkoutTab.items\">\n<form ng-keydown=\"$event.keyCode === 13 && $ctrl.scanPrefix('deliveryAndPickups', 'barcode'); $event.keyCode === 13 && $ctrl.logisticItemScan($event)\" ng-if=\"!$ctrl.autoSubmitItem\">\n<div class=\"checkout-scan-section\">\n<div class=\"padding-10 col-sm-2\" style=\"text-align: right;\">\n<label for=\"contact\">{{'common.trackingId' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input type=\"text\" id=\"barcode\" autocomplete=\"off\" ng-pattern=\"/^[a-zA-Z0-9-$_ ]*$/\" ng-keydown=\"$ctrl.itemScanKeyPress($event)\" strip-whitespace class=\"form-control input-lg\" ng-class=\"{'disabled' : $ctrl.logisticItemObj.disableItemScan}\" ng-model=\"$ctrl.logisticItemObj.barcode\" ng-disabled=\"$ctrl.logisticItemObj.disableItemScan\" style=\"margin: 0 auto;\" capitalize/>\n</div>\n<div class=\"padding-10 col-sm-1\">\n<button type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-success pull-left\" ng-click=\"$ctrl.clearItemScan()\">{{'common.clear' | translate}}</button>\n</div>\n</div>\n</form>\n<form ng-keydown=\"$event.keyCode === 13 && $ctrl.scanPrefix('deliveryAndPickups', 'barcode'); $event.keyCode === 13 && $ctrl.autoSubmitItems($event)\" ng-if=\"$ctrl.autoSubmitItem && $ctrl.setupData.enableAutoSubmit\">\n<div class=\"checkout-scan-section\">\n<div class=\"padding-10 col-sm-2 text-right\">\n<label for=\"contact\">{{'common.trackingId' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input type=\"text\" id=\"barcode\" autocomplete=\"off\" ng-pattern=\"/^[a-zA-Z0-9-$_ ]*$/\" ng-keydown=\"$ctrl.itemScanKeyPress($event)\" strip-whitespace class=\"form-control input-lg\" ng-class=\"{'disabled' : $ctrl.logisticItemObj.disableItemScan}\" ng-model=\"$ctrl.logisticItemObj.barcode\" ng-disabled=\"$ctrl.logisticItemObj.disableItemScan\" style=\"margin: 0 auto;\" capitalize/>\n</div>\n<div class=\"padding-10 col-sm-1\">\n<button type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-success pull-left\" ng-click=\"$ctrl.clearItemScan()\">{{'common.clear' | translate}}</button>\n</div>\n</div>\n</form>\n<form ng-show=\"!!$ctrl.logisticItemObj.barcode && !$ctrl.logisticItemObj.lastUpdated\">\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">Item</label>\n</div>\n<div class=\"col-sm-8\">\n<input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.logisticItemObj.itemDetails.label\" disabled=\"disabled\"/>\n</div>\n</div>\n<div class=\"checkout-scan-section\">\n<div class=\"text-padding-05 col-sm-2 text-right\">\n<label for=\"contact\">Note</label>\n</div>\n<div class=\"col-sm-8\">\n<input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.logisticItemObj.itemDetails.notes\" disabled=\"disabled\"/>\n</div>\n</div>\n</form>\n</div>\n</div>\n<div class=\"col-sm-2 remove-left-pad text-center\">\n<div style=\"margin-bottom: 20px; float: right;\">\n<button type=\"button\" class=\"btn btn-primary\" ng-if=\"!$ctrl.routeVerifyData.errorCount\" ng-disabled=\"$ctrl.model.loading || $ctrl.logisticItemObj.remainingItemsCount > 0\" ng-click=\"$ctrl.closeRoute()\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.model.loading}\"></span> {{'checkout.closeRoute' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-primary\" ng-if=\"$ctrl.routeVerifyData.errorCount\" ng-click=\"$ctrl.forceClose()\">\n{{'checkout.forceClose' | translate}}\n<span class=\"badge error-button-badge\">{{$ctrl.routeVerifyData.errorCount}}</span>\n</button>\n</div>\n<div style=\"clear: both;\"></div>\n<div ng-show=\"($ctrl.lastStatusUpdate || $ctrl.bagScanLimitExceed) && $ctrl.currentCheckoutTab === $ctrl.checkoutTab.shipment\">\n<div class=\"glyphicon glyphicon-ok text-success\" ng-show=\"!$ctrl.isError && !$ctrl.bagScanLimitExceed\" style=\"font-size: 100px;\"></div>\n<img src=\"" + __webpack_require__(69) + "\" ng-show=\"$ctrl.isError || $ctrl.bagScanLimitExceed\" alt=\"error\" height=\"120\" width=\"120\">\n<div class=\"text-danger string-break\" ng-if=\"$ctrl.isError && $ctrl.lastScanned || $ctrl.bagScanLimitExceed\">\n<b>{{ 'common.lastScan' | translate }} : {{$ctrl.lastScanned}}</b>\n</div>\n<div class=\"text-danger\" ng-if=\"$ctrl.isError && $ctrl.bagCheckOutError\">\n<b>{{$ctrl.bagCheckOutError}}</b>\n</div>\n<div class=\"text-success\" ng-if=\"!$ctrl.isError && $ctrl.bagCheckOutMessage && !$ctrl.bagScanLimitExceed\">\n<b>{{ 'checkout.trackingId' | translate }}: {{$ctrl.bagIdCopy}}</b>\n</div>\n<div class=\"text-success\" ng-if=\"!$ctrl.isError && $ctrl.bagCheckOutMessage && !$ctrl.bagScanLimitExceed\">\n<b>{{$ctrl.bagCheckOutMessage}}</b>\n</div>\n<div class=\"text-danger\" ng-if=\"$ctrl.bagScanLimitExceed\">\n<b>{{$ctrl.bagScanError}}</b>\n</div>\n<br>\n<span ng-class=\"{'text-danger': ($ctrl.isError || $ctrl.bagScanLimitExceed), 'text-success': (!$ctrl.isError || !$ctrl.bagScanLimitExceed)}\">\n{{$ctrl.lastStatusUpdate | date:'hh:mm:ss a'}}</span>\n<br>\n<div class=\"align-center-horizontally margin-top-20\" ng-if=\"!$ctrl.wasItemFound && !$ctrl.bagScanLimitExceed && $ctrl.addBagToCheckout\">\n<button class=\"btn btn-primary\" ng-click=\"$ctrl.forceAddBag($event)\">\n{{'checkinSelectionModal.forceBag' | translate}}\n</button>\n</div>\n<div class=\"align-center-horizontally margin-top-20\" ng-if=\"!$ctrl.wasItemThrow && $ctrl.isError\">\n<button class=\"btn btn-primary\" ng-click=\"$ctrl.autoThrow()\">AutoThrow</button>\n</div>\n</div>\n<div ng-show=\"($ctrl.logisticItemObj.lastUpdated || $ctrl.logisticItemObj.itemScanLimitExceed) && $ctrl.currentCheckoutTab === $ctrl.checkoutTab.items\">\n<div class=\"glyphicon glyphicon-ok text-success font-size-100\" ng-show=\"!$ctrl.logisticItemObj.isError && !$ctrl.logisticItemObj.itemScanLimitExceed\">\n</div>\n<img src=\"" + __webpack_require__(69) + "\" ng-show=\"$ctrl.logisticItemObj.isError || $ctrl.logisticItemObj.itemScanLimitExceed\" alt=\"error\" height=\"120\" width=\"120\">\n<div class=\"text-danger string-break\" ng-if=\"$ctrl.logisticItemObj.isError && ($ctrl.logisticItemObj.lastScannedItem || $ctrl.logisticItemObj.itemScanLimitExceed)\">\n<b>{{ 'common.lastScan' | translate }} : {{$ctrl.logisticItemObj.lastScannedItem}}</b>\n</div>\n<div class=\"text-danger\" ng-if=\"$ctrl.logisticItemObj.isError && $ctrl.logisticItemObj.itemCheckOutError\">\n<b>{{$ctrl.logisticItemObj.itemCheckOutError}}</b>\n</div>\n<div class=\"text-success\" ng-if=\"!$ctrl.logisticItemObj.isError && $ctrl.logisticItemObj.itemCheckOutMessage && !$ctrl.logisticItemObj.itemScanLimitExceed\">\n<b>{{ 'checkout.trackingId' | translate }}: {{$ctrl.logisticItemObj.lastScannedItem}}</b>\n</div>\n<div class=\"text-success\" ng-if=\"!$ctrl.logisticItemObj.isError && $ctrl.logisticItemObj.itemCheckOutMessage && !$ctrl.logisticItemObj.itemScanLimitExceed\">\n<b>{{$ctrl.logisticItemObj.itemCheckOutMessage}}</b>\n</div>\n<div class=\"text-danger\" ng-if=\"$ctrl.logisticItemObj.itemScanLimitExceed\">\n<b>{{$ctrl.logisticItemObj.itemScanError}}</b>\n</div>\n<div ng-class=\"{'text-danger': ($ctrl.logisticItemObj.isError || $ctrl.logisticItemObj.itemScanLimitExceed), \n\t\t\t\t\t\t\t'text-success': (!$ctrl.logisticItemObj.isError || !$ctrl.logisticItemObj.itemScanLimitExceed)}\" class=\"margin-10\">\n{{$ctrl.logisticItemObj.lastUpdated | date:'hh:mm:ss a'}}\n</div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="checkout.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\" style=\"text-align: center;\">\n<div class=\"col-sm-12\">\n<div>\n<div class=\"align-center-horizontally\">\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<h4>{{ 'checkout.checkoutManifest' | translate }}</h4>\n<div id=\"print-section\">\n<div class=\"col-sm-12 text-align-left margin-top-40\">\n<div class=\"col-sm-6 col-print-6\">\n<div>\n{{ 'checkout.fromLocation' | translate}}:\n</div>\n<div>\n<h3 class=\"margin-zero\">\n<strong>{{'bagout_print.fromLocationName' | translate}}</strong>\n</h3>\n</div>\n<div>\n<h4>{{'bagout_print.fromLocationAddress' | translate}}</h4>\n</div>\n</div>\n<div class=\"col-sm-6 text-align-right\">\n<div class=\"margin-zero text-align-right\">\n{{ 'checkout.toLocation' | translate }}\n</div>\n<div ng-if=\"$ctrl.messengerDetails.messengerId\">\n<h3 class=\"margin-zero\">\n<strong>\n{{ $ctrl.messengerDetails.firstName }} {{ $ctrl.messengerDetails.lastName }} | {{ $ctrl.messengerDetails.messengerId }}\n</strong>\n</h3>\n</div>\n<div ng-if=\"!$ctrl.messengerDetails.messengerId\">\n<h3 class=\"margin-zero text-align-right\">\n<strong>\n{{ 'checkout.n_a' | translate }}\n</strong>\n</h3>\n</div>\n</div>\n</div>\n<div>\n<br><br><br>\n</div>\n<div class=\"col-sm-12 text-align-left margin-top-20 print-margin-top-05\">\n<strong>\n{{ 'checkout.routeId' | translate }}:\n</strong>\n<span>{{ $ctrl.routeId }}</span>\n<strong class=\"margin-left-10\">\n{{ 'checkout.totalBags' | translate }}:\n</strong>\n<span>{{ $ctrl.shipmentReportData.shipmentDetail.checkOut.totalBag }}</span>\n<strong class=\"margin-left-10\">\n{{ 'checkout.totalCoin' | translate }}:\n</strong>\n<span>{{ $ctrl.shipmentReportData.shipmentDetail.checkOut.totalCoin }}</span>\n<strong class=\"margin-left-10\">\n{{ 'checkout.totalAmount' | translate}}:\n</strong>\n<span>{{ $ctrl.shipmentReportData.shipmentDetail.checkOut.totalAmount | currency: '$'}}</span>\n<span class=\"pull-right\">\n<strong>\n{{ 'checkout.deliveryDate' | translate }}:\n</strong>\n<span>{{ $ctrl.deliveryDate | date: 'longDate'}}</span>\n</span>\n</div>\n<div class=\"col-sm-12 margin-top-20\">\n<table class=\"table table-striped table-bordered\">\n<thead class=\"header-row\">\n<tr>\n<td>\n<strong>#</strong>\n</td>\n<td>\n<strong>{{ 'checkout.trackingId' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.fromLocationName' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.ToLocationName' | translate }}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.transactionType' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.denoms' | translate }}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.amount' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.verify' | translate}}</strong>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipments in $ctrl.shipmentReportData.results\">\n<td>{{ $index+1 }}</td>\n<td>{{ shipments.trackingId }}\n<span ng-if=\"shipments.holdFlag\">\n<img src=\"" + __webpack_require__(80) + "\" class=\"hold-icon-size\">\n</span>\n</td>\n<td rowspan=\"{{shipments.rows}}\" ng-if=\"! shipments.matchPreviousRow\">{{ shipments.fromLocationId }} | {{ shipments.fromLocationName }}</td>\n<td rowspan=\"{{shipments.rows}}\" ng-if=\"! shipments.matchPreviousRow\">{{ shipments.toLocationId }} | {{ shipments.toLocationName }}</td>\n<td>{{ shipments.shiptypeId }}</td>\n<td>\n<span ng-if=\"shipments.denominations\" ng-repeat=\"denom in shipments.denominations\">\n<img ng-src=\"assets/images/{{denom}}.png\" class=\"denom-image\" alt=\"{{ denom}}\" style=\"width:30px;height:30px;\"/>\n</span>\n<span ng-if=\"!shipments.denominations || !shipments.denominations.length\">{{ 'checkout.n_a' | translate }}</span>\n</td>\n<td>{{ shipments.amount | currency:'$' }}</td>\n<td></td>\n</tr>\n</tbody>\n</table>\n</div>\n<br/>\n<div class=\"col-sm-12 text-align-left margin-top-20 print-margin-top-05\" ng-if=\"$ctrl.model.itemList.length > 0\">\n<strong>{{ 'checkout.routeId' | translate }}:</strong>\n<span>{{ $ctrl.routeId }}</span>\n<strong class=\"margin-left-10\">{{ 'bagout.totalItems' | translate }}:</strong>\n<span>{{ $ctrl.model.itemList.length }}</span>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.itemList.length > 0\">\n<table class=\"margin-top-10 table table-striped table-bordered table-pad-5\">\n<thead class=\"text-center\">\n<tr class=\"header-row\">\n<td><strong>#</strong></td>\n<td><strong>{{'item.items' | translate}}</strong></td>\n<td><strong>{{'atm_residual.trackingId' | translate}}</strong></td>\n<td><strong>{{'common.notes' | translate}}</strong></td>\n<td><strong>{{ 'checkout.verify' | translate}}</strong></td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in $ctrl.model.itemList track by $index\">\n<td>{{$index+1}}</td>\n<td>{{data.label}}\n<span ng-if=\"data.onHold\">\n<img src=\"" + __webpack_require__(80) + "\" class=\"hold-icon-size\">\n</span>\n</td>\n<td>{{data.barcode}}</td>\n<td>\n<span ng-if=\"data.notes\">{{data.notes}}</span>\n<span ng-if=\"!data.notes\">{{'common.n_a' | translate}}</span>\n</td>\n<td></td>\n</tr>\n</tbody>\n</table>\n</div>\n<center>\n<div class=\"checkout-verify margin-top-20\">\n<div class=\"checkout-promise\">\n<h4 class=\"padding-left-50\">{{ 'checkout.promise' | translate }}</h4>\n</div>\n<div class=\"manifest-content\">\n<h4 class=\"padding-left-50 margin-bottom-0\">{{ 'checkout.fullName' | translate }}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"padding-left-50 content-position\">{{'checkout.signature' | translate}}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"padding-left-50 content-position margin-left-10\">{{ 'checkout.verifyDate' | translate }}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n</div>\n</div>\n</center>\n</div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="print_checkout.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2716 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"w-100 branch-coin-pull-report\">\n<div class=\"col-sm-12 align-center\">\n<div class=\"_col-sm-4 btn-group z-index0\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStats\" uib-btn-radio=\"$ctrl.stats.route\" ng-click=\"$ctrl.tabSelection('route')\" ng-class=\"{'btn-success': $ctrl.model.currentStats === $ctrl.stats.route, \n                               'remove-btn-grp-color': $ctrl.model.currentStats === $ctrl.stats.branch}\">\n{{'bagout.route' | translate}}\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStats\" uib-btn-radio=\"$ctrl.stats.branch\" ng-click=\"$ctrl.tabSelection('branch'); $ctrl.branchCoinPullReport();\" ng-class=\"{'btn-success': $ctrl.model.currentStats === $ctrl.stats.branch, \n                               'remove-btn-grp-color': $ctrl.model.currentStats === $ctrl.stats.route}\">\n{{'common.branch_id' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<hr class=\"cash-variances-line-section\">\n</div>\n<form class=\"col-sm-12 remove-left-pad remove-right-pad align-center margin-10 form-validate\" ng-if=\"$ctrl.model.currentStats === $ctrl.stats.route && !$ctrl.loading\" novalidate>\n<div id=\"route-id\" class=\"col-sm-3\">\n<search-and-select ng-model=\"$ctrl.selected.route\" values=\"$ctrl.routeList\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" onscroll=\"$ctrl.getAllRoutes(searchKey, offset)\" on-click=\"$ctrl.show()\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div id=\"vault-date\" class=\"col-sm-3 margin-top-20\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" date-options=\"$ctrl.startMaxDate\" ng-class=\"{'required-datetimepicker': $ctrl.selected.date, 'disabled': $ctrl.loading}\" hidden-time=\"true\" ng-click=\"$ctrl.show()\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n<div id=\"inline\">\n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.show()\" ng-disabled=\"$ctrl.loading\" ng-class=\"{'disabled': !$ctrl.selected.route }\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>{{'coinPullReport.show' | translate}}\n</button>\n</div>\n<div ng-if=\"$ctrl.coinReportData.length > 0\" class=\"left-pad-07 _display-flex\">\n<button class=\"btn btn-success\" ng-click=\"$ctrl.print()\" aria-hidden=\"true\">Print</button>\n</div>\n</form>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-top-20\" ng-if=\"!$ctrl.loading && $ctrl.showReport && $ctrl.coinReportData.length > 0 && $ctrl.model.currentStats === $ctrl.stats.route\">\n<ng-include src=\"'coin_pull_report_print.html'\"></ng-include>\n</div>\n<div class=\"col-sm-12 align-center font-size-20 margin-10\" ng-if=\"$ctrl.model.branchCoinReport.length && $ctrl.model.currentStats === $ctrl.stats.branch && !$ctrl.loading\">\n<img class=\"logo-section\" stream-print-logo/>\n<span>{{$ctrl.model.branch}} | {{$ctrl.model.day}} | {{$ctrl.model.date | date:'MM/dd/yyyy'}} </span>\n<span class=\"pad-left-10\"><button class=\"btn btn-success\" ng-click=\"$ctrl.printBranchCoinReport()\" aria-hidden=\"true\">Print</button></span>\n</div>\n<div class=\"table-responsive w-100\" ng-if=\"$ctrl.model.currentStats === $ctrl.stats.branch && !$ctrl.loading\" ng-repeat=\"data in $ctrl.model.branchCoinReport track by $index\">\n<div class=\"col-sm-12 align-center\">\n<h3 class=\"bold-font\">{{data.fromLocationId}} | {{data.name}}</h3>\n</div>\n<table class=\"_table-pad-7 margin-bottom-10 table table-hover table-striped table-bordered font-12\">\n<thead>\n<tr>\n<th class=\"text-center action-width\">\n<b>{{'itemHolds.route_id' | translate}}</b>\n</th>\n<th ng-repeat=\"uniqueCoinObj in data.uniqueCoins\" class=\"_borderless-cell text-center\">\n<img ng-src=\"assets/images/{{uniqueCoinObj.coin}}.png\" alt=\"coin_{{uniqueCoinObj.coin}}\" height=\"30\">\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"coinObj in data.coins\" class=\"_borderless-cell\" align=\"center\">\n<td>{{coinObj.routeId}} | {{coinObj.routeName}}</td>\n<td ng-repeat=\"uniqueCoinObj in data.uniqueCoins\">\n<span class=\"_text-success\" ng-if=\"coinObj[uniqueCoinObj.coin]\">{{coinObj[uniqueCoinObj.coin]}}</span>\n<span class=\"text-danger\" ng-if=\"!coinObj[uniqueCoinObj.coin]\">0</span>\n</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td class=\"text-center\"><strong>{{'coinPullReport.total' | translate}}</strong></td>\n<td ng-repeat=\"uniqueCoinObj in data.uniqueCoins\" class=\"_borderless-cell\" align=\"center\">\n<strong>{{uniqueCoinObj.total}}</strong>\n</td>\n</tr>\n</tbody>\n</table>\n<hr ng-if=\"$index + 1 !== $ctrl.model.branchCoinReport.length\" class=\"margin-top-40 remove-bottom-margin\"/>\n</div>\n<div ng-if=\"$ctrl.loading\" class=\"col-sm-12 margin-top-30 text-center\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-70\"></span>\n</div>\n<div class=\"col-sm-12 margin-top-15 alert text-center alert-danger\" ng-if=\"!$ctrl.loading && $ctrl.model.branchCoinReport.length === 0 &&\n\t\t$ctrl.model.currentStats === $ctrl.stats.branch\">\n{{'common.no_data_found' | translate}}\n</div>\n<div class=\"col-sm-12 margin-top-15 alert text-center alert-danger\" ng-if=\"!$ctrl.loading && $ctrl.showReport && $ctrl.coinReportData.length === 0 &&\n\t\t\t    $ctrl.model.currentStats === $ctrl.stats.route\">\n{{'coinPullReport.noDesitnationFound' | translate:$ctrl.model}}\n</div>\n</div>";
var id1="coin_pull_report.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2717 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 align-center margin-10\">\n<img class=\"col-w-10\" stream-print-logo/>\n<span class=\"font-size-25\">{{$ctrl.model.branchCoinReport.branch}} | {{$ctrl.model.branchCoinReport.day}} | {{$ctrl.model.branchCoinReport.date | date:'MM/dd/yyyy'}} </span>\n</div>\n<div class=\"table-responsive w-100 print-margin-top-20 margin-10\" ng-repeat=\"data in $ctrl.model.branchCoinReport.results track by $index\">\n<div class=\"col-sm-12 align-center\">\n<span class=\"font-size-25 bold-font\">{{data.fromLocationId}} | {{data.name}}</span>\n</div>\n<table class=\"_table-pad-7 print-margin-top-10 table table-hover table-striped table-bordered font-12\">\n<thead>\n<tr>\n<th class=\"text-center action-width\">\n<b>{{'itemHolds.route_id' | translate}}</b>\n</th>\n<th ng-repeat=\"uniqueCoinObj in data.uniqueCoins\" class=\"_borderless-cell text-center\">\n<img ng-src=\"assets/images/{{uniqueCoinObj.coin}}.png\" alt=\"coin_{{uniqueCoinObj.coin}}\" height=\"30\">\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"coinObj in data.coins\" class=\"_borderless-cell\" align=\"center\">\n<td>{{coinObj.routeId}} | {{coinObj.routeName}}</td>\n<td ng-repeat=\"uniqueCoinObj in data.uniqueCoins\">\n<span class=\"_text-success\" ng-if=\"coinObj[uniqueCoinObj.coin]\">{{coinObj[uniqueCoinObj.coin]}}</span>\n<span class=\"text-danger\" ng-if=\"!coinObj[uniqueCoinObj.coin]\">0</span>\n</td>\n</tr>\n</tbody>\n<tbody>\n<tr>\n<td class=\"text-center\"><strong>{{'coinPullReport.total' | translate}}</strong></td>\n<td ng-repeat=\"uniqueCoinObj in data.uniqueCoins\" class=\"_borderless-cell\" align=\"center\">\n<strong>{{uniqueCoinObj.total}}</strong>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"pagebreak\"></div>\n</div>\n</div>";
var id1="print_branch_coin.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2718 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row margin-bottom-20 print-margin-top-20\">\n<div class=\"col-sm-6 col-print-6 align-center-vertically\">\n<img stream-print-logo load-from-db=\"true\" height=\"100\"/>\n<span class=\"font-size-25\">{{'coinPullReport.title' | translate}}</span>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"col-sm-12 col-print-6 display-flex align-center-vertically align-end-horizontally\">\n<h2>{{$ctrl.model.route}}</h2>\n</div>\n<div class=\"font-size-16 col-sm-12 display-flex align-end-horizontally\">\n{{$ctrl.model.branch}} | {{$ctrl.model.day}} {{$ctrl.model.date | date:'MM/dd/yyyy'}}\n</div>\n</div>\n</div>\n<div style=\"border: 2px solid #cecece\" class=\"col-sm-12 padding10 margin-bottom-10\" ng-class=\"{'dark-background': data.name === 'Total'}\" ng-repeat=\"data in $ctrl.coinReportData\" ng-if=\"$ctrl.coinReportData.length > 0\">\n<div class=\"col-sm-4 col-print-4 margin-top-30\">\n<span class=\"font-size-18\">{{data.name}}</span>\n</div>\n<div class=\"font-size-18 col-sm-8 align-center-vertically align-end-horizontally\">\n<table class=\"table margin-zero\">\n<tr>\n<th ng-repeat=\"(key, val) in data.coins\" class=\"borderless-cell text-center\" ng-if=\"val > 0\">\n<img ng-if=\"key !=='M'\" ng-src=\"assets/images/{{key}}.png\" alt=\"coin_{{key}}\" height=\"30\">\n<img ng-if=\"key ==='M'\" ng-src=\"assets/images/misc.png\" alt=\"coin_misc\" height=\"30\">\n</th>\n<th class=\"borderless-cell text-center\">\n<strong>{{'coinPullReport.total' | translate}}</strong>\n</th>\n</tr>\n<tr>\n<td ng-repeat=\"(key, val) in data.coins\" class=\"borderless-cell\" align=\"center\" ng-if=\"val > 0\">{{val}}</td>\n<td class=\"borderless-cell\" align=\"center\">\n<strong>{{data.total}}</strong>\n</td>\n</tr>\n</table>\n</div>\n</div>\n<div class=\"col-sm-12 col-print-12 hide-in-print\" ng-if=\"!$ctrl.loading && !$ctrl.coinReportData.length\">\n<div class=\"row alert text-center alert-danger\">\n{{'coinPullReport.noDesitnationFound' | translate}}\n</div>\n</div>";
var id1="coin_pull_report_print.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2719 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'delivery_region_routing.all_delivery_region_routing' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>";
var id1="delivery_region_routing.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2720 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"region-routing-style-section col-sm-12 remove-pad\">\n<div class=\"navbar-header remove-left-pad col-sm-12\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"d-flex align-items-center\" style=\"justify-content: space-between;\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'delivery_region_routing.create_delivery_region_routing' | translate}}\n<span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n<div>\n<button class=\"btn btn-warning\" ng-click=\"$ctrl.saveForAllDays()\" ng-disabled=\"!$ctrl.bulkZones.length || $ctrl.savingAll\">\nSave for All Days\n</button>\n</div>\n</div>\n<div class=\"alert margin-top-10\" ng-if=\"$ctrl.bulkSaveAlert.show\" ng-class=\"{\n                    'alert-success': $ctrl.bulkSaveAlert.type === 'success',\n                    'alert-danger': $ctrl.bulkSaveAlert.type === 'error'\n                }\">\n<button type=\"button\" class=\"close\" ng-click=\"$ctrl.closeBulkAlert()\">\n<span>&times;</span>\n</button>\n<div ng-bind-html=\"$ctrl.bulkSaveAlert.message\"></div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-12 remove-margin-top\">\n<hr>\n</div>\n<div class=\"col-sm-12\">\n<div id=\"service-schedule\" class=\"btn-group btn-group-justified day-of-the-week-section\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.model.weekDays\" ng-disabled=\"$ctrl.loadinglocationZone\" ng-click=\"$ctrl.selectDay(day)\" ng-class=\"{'btn-primary': $ctrl.model.selectedDay === day.value, 'btn-default': $ctrl.model.selectedDay !== day.value,'disabled' : $ctrl.loadinglocationZone}\">\n<i class=\"glyphicon\" ng-class=\"{\n                        'glyphicon-refresh fast-right-spinner': $ctrl.loadinglocationZone && $ctrl.selectedDay === day.value,\n                         'disabled': $ctrl.loadinglocationZone\n                    }\"></i>\n{{day.label}}\n<span class=\"badge hold-item-badge\">{{$ctrl.locationZoneCountObj[day.value].totalRecords || 0}}</span>\n</a>\n</div>\n<div id=\"map\" class=\"leaf-map margin-top-10 remove-z-index\" ng-hide=\"$ctrl.loadinglocationZone\"></div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40 font-size-50\" ng-if=\"$ctrl.loadinglocationZone\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-12 margin-bottom-30 margin-10\" ng-hide=\"$ctrl.loadinglocationZone\">\n<div class=\"w-100 routes-margin-auto\">\n<div class=\"panel panel-default margin-10 remove-bottom-pad routes-shipment-section\" ng-repeat=\"(key, value) in $ctrl.model.bucketObj track by $index\" ng-if=\"!$ctrl.model.bucketObj[key].getLocations\">\n<div class=\"cursor-pointer panel-heading\">\n<div class=\"row panel-title panel-title-center bucket_text_align_center remove-left-padd remove-right-padd\">\n<div class=\"col-sm-6 remove-left-padd remove-right-padd zone-header-title\" ng-click=\"$ctrl.model.bucketObj[key].bucketExpanded=!$ctrl.model.bucketObj[key].bucketExpanded;\">\n<i class=\"glyphicon glyphicon-triangle-bottom\" ng-show=\"$ctrl.model.bucketObj[key].bucketExpanded\"></i>\n<i class=\"glyphicon glyphicon-triangle-right\" ng-hide=\"$ctrl.model.bucketObj[key].bucketExpanded\"></i>\n<strong class=\"f-14\">{{key}}</strong>\n<span class=\"badge\">\n{{$ctrl.model.bucketObj[key].details.total}}\n</span>\n<div class=\"col-sm-5 remove-right-pad zone-rule-action\">\n<button type=\"button\" class=\"btn btn-sm btn-warning\" ng-if=\"$ctrl.model.bucketObj[key].savedRuleCount\" ng-click=\"$event.stopPropagation(); $ctrl.toggleZoneRuleAssignments(key);\">\nAssignment Rules\n<span class=\"badge\">{{$ctrl.model.bucketObj[key].savedRuleCount}}</span>\n</button>\n<button type=\"button\" class=\"btn btn-sm btn-success\" ng-if=\"!$ctrl.model.bucketObj[key].savedRuleCount\" ng-click=\"$event.stopPropagation(); $ctrl.toggleZoneRuleAssignments(key);\">\nSet Assignment\n</button>\n</div>\n</div>\n<div class=\"col-sm-6 remove-left-pad zone-rule-action d-flex align-items-center\" style=\"gap: 8px;\">\n<button type=\"button\" class=\"btn btn-sm btn-primary\" ng-if=\"$ctrl.model.bucketObj[key].locationZoneId\" ng-disabled=\"$ctrl.model.bucketObj[key].syncingZoneLocations\" ng-click=\"$event.stopPropagation(); $event.currentTarget.disabled = true; $ctrl.updateLocationZoneLocations(key);\">\nUpdate Location Zone\n<span ng-if=\"$ctrl.model.bucketObj[key].syncingZoneLocations\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.bucketObj[key].searchText\" name=\"searchText\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.search(key);\" placeholder=\"{{'common.locationId' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9-#()/&, ]*$/\" ng-class=\"{'disabled': $ctrl.model.bucketObj[key].process}\" ng-disabled=\"$ctrl.model.bucketObj[key].process\"/>\n</div>\n</div>\n</div>\n<div class=\"zone-rule-assignment-section form-validate\" ng-if=\"$ctrl.model.bucketObj[key].showRuleAssignments\">\n<div class=\"zone-rule-modal-zone\">\n<span><strong>Assignment Rules</strong></span>\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-disabled=\"$ctrl.model.bucketObj[key].rulesLoading\" ng-click=\"$ctrl.addInlineZoneRuleAssignment(key)\">\nAdd Rule\n</button>\n</div>\n<div class=\"text-align-center\" ng-if=\"$ctrl.model.bucketObj[key].rulesLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n<div class=\"alert alert-info text-center\" ng-if=\"!$ctrl.model.bucketObj[key].rulesLoading && !$ctrl.model.bucketObj[key].ruleAssignments.length\" style=\"margin-bottom: 10px;\">\nNo rules assigned to this zone yet. Click <strong>Add Rule</strong> to create one.\n</div>\n<div class=\"zone-rule-rows-scroll\" ng-if=\"!$ctrl.model.bucketObj[key].rulesLoading\" ng-class=\"{'zone-rule-rows-scroll-editing': $ctrl.hasEditingRuleAssignment(key)}\">\n<div class=\"zone-rule-assignment-row\" ng-repeat=\"rule in ($ctrl.model.bucketObj[key].ruleAssignments | orderBy:'-sequence') track by (rule.id || rule._uid)\" ng-attr-id=\"zone-rule-row-{{rule.id || rule._uid}}\" rule-assignment-draggable drag-disabled=\"rule.isEditing || rule.isSaving || $ctrl.isZoneRuleDragDisabled(key)\" on-drag-start=\"$ctrl.startInlineRuleAssignmentDrag(key, $ctrl.model.bucketObj[key].ruleAssignments.indexOf(rule))\" on-drag-over=\"$ctrl.setInlineRuleAssignmentDragOver(key, $ctrl.model.bucketObj[key].ruleAssignments.indexOf(rule))\" on-drop=\"$ctrl.dropInlineRuleAssignment(key, $ctrl.model.bucketObj[key].ruleAssignments.indexOf(rule))\" on-drag-end=\"$ctrl.clearInlineRuleAssignmentDrag()\" ng-class=\"{\n                                'zone-rule-row-dragging': $ctrl.ruleAssignmentDrag.zoneKey === key && $ctrl.ruleAssignmentDrag.dragIndex === $ctrl.model.bucketObj[key].ruleAssignments.indexOf(rule),\n                                'zone-rule-row-drop-target': $ctrl.ruleAssignmentDrag.zoneKey === key && $ctrl.ruleAssignmentDrag.dragOverIndex === $ctrl.model.bucketObj[key].ruleAssignments.indexOf(rule) && $ctrl.ruleAssignmentDrag.dragIndex !== $ctrl.model.bucketObj[key].ruleAssignments.indexOf(rule),\n                                'zone-rule-row-drag-disabled': $ctrl.isZoneRuleDragDisabled(key)\n                            }\">\n<div class=\"zone-rule-priority\">{{rule.sequence}}</div>\n<div class=\"zone-rule-fields\">\n<div class=\"zone-rule-field zone-rule-field-assignee\">\n<search-and-select ng-model=\"rule.editModel.assignee\" ng-required=\"rule.isEditing\" values=\"$ctrl.model.bucketObj[key].assigneeOptions\" key=\"Key\" totalrecords=\"$ctrl.model.bucketObj[key].totalAssignees\" onscroll=\"$ctrl.loadAssignees(searchKey, offset, key)\" ng-disabled=\"!rule.isEditing\" none-selected=\"'(Select Assignee)'\">\n</search-and-select>\n</div>\n<div class=\"zone-rule-field\">\n<select class=\"form-control input-sm\" ng-disabled=\"!rule.isEditing\" ng-model=\"rule.editModel.isActive\" ng-options=\"option.value as option.label for option in [{label: 'Active', value: true}, {label: 'Inactive', value: false}]\">\n</select>\n</div>\n<div class=\"zone-rule-field\">\n<select class=\"form-control input-sm\" ng-disabled=\"!rule.isEditing\" ng-model=\"rule.editModel.distanceInMiles\" ng-options=\"option.value as option.label for option in $ctrl.ruleAssignmentConfig.distances\">\n<option value=\"\">(Select Distance)</option>\n</select>\n</div>\n<div class=\"zone-rule-field\">\n<select class=\"form-control input-sm\" ng-disabled=\"!rule.isEditing\" ng-model=\"rule.editModel.locationPriority\" ng-options=\"priority.value as priority.label for priority in $ctrl.ruleAssignmentConfig.locationPriorities\">\n<option value=\"\">(Select Location Priority)</option>\n</select>\n</div>\n<div class=\"zone-rule-field zone-rule-field-offset\"></div>\n<div class=\"zone-rule-field\" ng-class=\"{'disabled': !rule.isEditing}\">\n<div isteven-multi-select directive-id=\"zone-customers-select\" input-model=\"rule.editModel.customerOptions\" output-model=\"rule.editModel.selectedCustomers\" button-label=\"Key\" item-label=\"Key\" tick-property=\"ticked\" selection-mode=\"multiple\" max-labels=\"4\" translation=\"$ctrl.customersLocalLang\" style=\"width: 100%;\" class=\"multi-select\" is-disabled=\"!rule.isEditing\">\n</div>\n</div>\n<div class=\"zone-rule-field\" ng-class=\"{'disabled': !rule.isEditing}\">\n<div isteven-multi-select directive-id=\"zone-makes-select\" input-model=\"rule.editModel.makesOptions\" output-model=\"rule.editModel.selectedMakes\" button-label=\"Key\" item-label=\"Key\" tick-property=\"ticked\" selection-mode=\"multiple\" max-labels=\"4\" translation=\"$ctrl.makesLocalLang\" style=\"width: 100%;\" class=\"multi-select\" is-disabled=\"!rule.isEditing\">\n</div>\n</div>\n<div class=\"zone-rule-field\" ng-class=\"{'disabled': !rule.isEditing}\">\n<div isteven-multi-select directive-id=\"zone-action-priorities-select\" input-model=\"rule.editModel.actionPriorityOptions\" output-model=\"rule.editModel.selectedActionPriorities\" button-label=\"Key\" item-label=\"Key\" tick-property=\"ticked\" selection-mode=\"multiple\" max-labels=\"4\" translation=\"$ctrl.actionPrioritiesLocalLang\" style=\"width: 100%;\" class=\"multi-select\" is-disabled=\"!rule.isEditing\">\n</div>\n</div>\n<div class=\"zone-rule-field zone-rule-field-offset\"></div>\n<div class=\"zone-rule-field\">\n<select class=\"form-control input-sm\" ng-disabled=\"!rule.isEditing\" ng-model=\"rule.editModel.mode\" ng-options=\"option for option in $ctrl.ruleAssignmentConfig.modes\">\n<option value=\"\">(Select Mode)</option>\n</select>\n</div>\n<div class=\"zone-rule-field\">\n<select class=\"form-control input-sm\" ng-disabled=\"!rule.isEditing\" ng-model=\"rule.editModel.estWorkloadInHours\" ng-options=\"option.value as option.label for option in $ctrl.ruleAssignmentConfig.estWorkloads\">\n<option value=\"\">(Select Est Workload)</option>\n</select>\n</div>\n<div class=\"zone-rule-field\">\n<select class=\"form-control input-sm\" ng-disabled=\"!rule.isEditing\" ng-model=\"rule.editModel.totalTicketsAssigned\" ng-options=\"option.value as option.label for option in $ctrl.ruleAssignmentConfig.tickets\">\n<option value=\"\">(Select Tickets)</option>\n</select>\n</div>\n<div class=\"zone-rule-field zone-rule-field-offset\"></div>\n<div class=\"zone-rule-field\" ng-class=\"{'disabled': !rule.isEditing}\">\n<div isteven-multi-select directive-id=\"zone-actions-select\" input-model=\"rule.editModel.actionCodesOptions\" output-model=\"rule.editModel.selectedActionCodes\" button-label=\"Key\" item-label=\"Key\" tick-property=\"ticked\" selection-mode=\"multiple\" max-labels=\"4\" translation=\"$ctrl.actionsLocalLang\" style=\"width: 100%;\" class=\"multi-select\" is-disabled=\"!rule.isEditing\">\n</div>\n</div>\n</div>\n<div class=\"zone-rule-row-actions\">\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-if=\"!rule.isEditing\" ng-click=\"$ctrl.startEditZoneRuleAssignment(key, $ctrl.model.bucketObj[key].ruleAssignments.indexOf(rule))\">\n<i class=\"glyphicon glyphicon-pencil\"></i>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-if=\"rule.isEditing\" ng-disabled=\"rule.isSaving || !rule.editModel.assignee\" ng-click=\"$ctrl.saveZoneRuleAssignment(key, $ctrl.model.bucketObj[key].ruleAssignments.indexOf(rule))\">\n<i class=\"glyphicon glyphicon-ok\"></i>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-default\" ng-if=\"rule.isEditing\" ng-disabled=\"rule.isSaving\" ng-click=\"$ctrl.cancelEditZoneRuleAssignment(key, $ctrl.model.bucketObj[key].ruleAssignments.indexOf(rule))\">\n<i class=\"glyphicon glyphicon-remove\"></i>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-if=\"!rule.isEditing\" ng-click=\"$ctrl.deleteZoneRuleAssignment(key, $ctrl.model.bucketObj[key].ruleAssignments.indexOf(rule))\">\n<i class=\"glyphicon glyphicon-trash\"></i>\n</button>\n</div>\n</div>\n<div class=\"zone-rule-load-more-sentinel\" rule-assignment-load-more-sentinel on-load-more=\"$ctrl.loadMoreRules(key)\" scroll-disabled=\"$ctrl.model.bucketObj[key].rulesLoadingMore || !$ctrl.hasMoreRules(key)\">\n</div>\n<div class=\"text-align-center\" ng-if=\"$ctrl.model.bucketObj[key].rulesLoadingMore\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n</div>\n</div>\n<div class=\"table-responsive\">\n<table class=\"table table-hover table-striped table-bordered table-pad-7 font-12\" ng-if=\"$ctrl.model.bucketObj[key].bucketExpanded && $ctrl.model.bucketObj[key].details.results.length &&\n                                      !$ctrl.model.bucketObj[key].process\">\n<thead>\n<tr>\n<th><b>{{'atm_deposit_packing.location_id' | translate}}</b></th>\n<th><b>{{'atm_residual.locationName' | translate}}</b></th>\n<th><b>{{'fuel_surcharge.locationType' | translate}}</b></th>\n<th><b>{{'bagout.branch' | translate}}</b></th>\n<th><b>{{'common.address' | translate}}</b></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.bucketObj[key].details.results\">\n<td>{{data.locationId}}</td>\n<td>{{data.locationName}}</td>\n<td>{{data.locationType}}</td>\n<td>{{data.branchId}}</td>\n<td>{{data.address}}</td>\n</tr>\n</tbody>\n<tfoot ng-if=\"$ctrl.model.bucketObj[key].details.total > $ctrl.model.bucketObj[key].pagination.pageLimit\">\n<tr>\n<td colspan=\"5\">\n<ul uib-pagination total-items=\"$ctrl.model.bucketObj[key].details.total\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.bucketObj[key].pagination.page\" ng-change=\"$ctrl.getLocations(key)\" rotate=\"false\" max-size=\"10\">\n</ul>\n</td>\n</tr>\n</tfoot>\n</table>\n<div class=\"text-align-center\" ng-if=\"$ctrl.model.bucketObj[key].bucketExpanded && $ctrl.model.bucketObj[key].process && !$ctrl.model.bucketObj[key].getLocations\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n<div class=\"location-zone-alert-section\" ng-if=\"$ctrl.model.bucketObj[key].bucketExpanded && !$ctrl.model.bucketObj[key].process && $ctrl.model.bucketObj[key].details.results.length === 0\">\n<div class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': $ctrl.model.bucketObj[key].details.results.length === 0}\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="delivery_region_routing.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2721 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"delivery-region-routing.create\">\n<a translate=\"delivery_region_routing.create_delivery_region_routing\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="delivery_region_routing.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2722 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'delivery_region_routing.edit_delivery_region_routing' | translate}}\n<span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n</div>";
var id1="delivery_region_routing.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2723 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<a role=\"button\" \n                                             ng-repeat=\"remainingDenom in data.remainingDenominations track by $index\"\n                                             ng-click=\"$ctrl.changeDenomination($event, remainingDenom.denominationId, $parent.$parent.$parent.$index, $parent.$index, $index, remainingDenom.faceValue, denomination.amount, remainingDenom.balance, remainingDenom.coinFlag, remainingDenom.symbol)\">\n                                             <img ng-src=\"assets/images/{{remainingDenom.denominationId}}.png\" class=\"custom-icon\"/>\n                                         </a>\n";
var id1="denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
var v2="\n<a role=\"button\" \n                                             ng-repeat=\"remainingDenom in data.remainingDenominations track by $index\"\n                                             ng-click=\"$ctrl.changeDenomination($event, remainingDenom.denominationId, $parent.$parent.$parent.$index, $parent.$index, $index, remainingDenom.faceValue, denomination.amount, remainingDenom.balance, remainingDenom.coinFlag, remainingDenom.symbol)\">\n                                             <img ng-src=\"assets/images/{{remainingDenom.denominationId}}.png\" class=\"custom-icon\"/>\n                                         </a>\n";
var id2="denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id2,v2);}
else{ngModule.run(["$templateCache",function(c){c.put(id2,v2)}]);}
var v3="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"row_ col-sm-12 remove-pad\" style=\"display: flex; justify-content: center;\">\n<div class=\"col-lg-3 col-md-3 col-sm-3 form-group remove-left-pad\">\n<search-and-select ng-model=\"$ctrl.model.fundingSourceId\" values=\"$ctrl.locationLists\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" common-search-flag=\"true\" on-click=\"$ctrl.resetDenominations(); $ctrl.loadData(); $ctrl.resetPendingResidualData(); $ctrl.loadManualDepositData()\" none-selected=\"'atm_deposit_packing.fundingSource'\" required></search-and-select>\n</div>\n<div class=\"col-lg-3 col-md-3 col-sm-3 form-group\">\n<select class=\"form-control\" required ng-model=\"$ctrl.model.account\" ng-change=\"$ctrl.resetDenominations(); $ctrl.loadData(); $ctrl.resetPendingResidualData(); $ctrl.loadManualDepositData()\" ng-options=\"ledger.value as ledger.lable for ledger in $ctrl.ledgers\">\n<option value=\"\" disabled=\"disabled\">({{'orderPacking.selectAccount' | translate}})</option>\n</select>\n</div>\n<div class=\"col-lg-3 col-md-3 col-sm-3 form-group\">\n<select class=\"form-control\" required ng-model=\"$ctrl.model.currency\" ng-change=\"$ctrl.loadData(); $ctrl.resetPendingResidualData(); $ctrl.loadManualDepositData(); $ctrl.setCurrencySymbol()\" ng-options=\"currency.id as currency.id for currency in $ctrl.model.allCurrency\">\n<option value=\"\" disabled=\"disabled\">({{'atm_deposit_packing.currency' | translate}})</option>\n</select>\n</div>\n</div>\n<div ng-hide=\"($ctrl.isManualDeposit() && $ctrl.isResidualDeposit()) || (!$ctrl.isManualDeposit() && !$ctrl.isResidualDeposit())\">\n<div class=\"row_ col-sm-12 remove-pad text-center margin-top-20\" ng-if=\"$ctrl.isValidate()\">\n<div class=\"col-sm-4 remove-left-pad\" ng-if=\"$ctrl.model.stats === $ctrl.stats.pending && $ctrl.isResidualDeposit()\">\n<span class=\"pull-left amount-font-23 amount-margin-top-1\">\n<b ng-if=\"$ctrl.model.account === 'regular'\">{{ $ctrl.pendingResidualData.totalPendingDeposit | currency:$ctrl.currencySymbol:2}}</b>\n<b ng-if=\"$ctrl.model.account === 'emergency'\">{{ $ctrl.emergencyPackPreviewData.summary.totalAmount | currency:$ctrl.currencySymbol:2}}</b>\n</span>\n</div>\n<div class=\"remove-left-pad col-sm-4\" ng-if=\"$ctrl.model.stats === $ctrl.stats.pending && $ctrl.isManualDeposit();\">\n<span class=\"pull-left amount-font-23 amount-margin-top-1\" ng-if=\"$ctrl.model.ledgerData.results.length && !$ctrl.isLoading\">\n<b>{{$ctrl.model.ledgerData.totalAmount | currency:$ctrl.currencySymbol:2}}</b>\n</span>\n</div>\n<div class=\"col-sm-4 remove-left-pad\" ng-if=\"$ctrl.model.stats === $ctrl.stats.packed\">\n<span class=\"pull-left amount-font-23 amount-margin-top-1\" ng-if=\"$ctrl.isFormValidate()\">\n<b>{{ $ctrl.pendingReleaseData.totalPendingRelease | currency:$ctrl.currencySymbol:2}}</b>\n</span>\n</div>\n<div class=\"col-sm-4 remove-left-pad\" ng-if=\"$ctrl.model.stats === $ctrl.stats.released\">\n<span class=\"pull-left amount-font-23 amount-margin-top-1\" ng-if=\"$ctrl.isFormValidate()\">\n<b>{{$ctrl.releasedDeposit.totalReleased | currency:$ctrl.currencySymbol:2}}</b>\n</span>\n</div>\n<div class=\"btn-group z-index0 col-sm-4 deposit-packing-btn-group-section align-center\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.pending\" ng-click=\"$ctrl.tabSelection('pending')\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.pending}\">\n{{ 'common.pending' | translate }}\n<span class=\"badge\" ng-if=\"$ctrl.model.account === 'regular' && $ctrl.isResidualDeposit()\">{{$ctrl.pendingResidualData.totalRecords || 0}}</span>\n<span class=\"badge\" ng-if=\"$ctrl.isManualDeposit();\">\n{{$ctrl.noRecords}}\n</span>\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.packed\" ng-click=\"$ctrl.tabSelection('packed')\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.packed}\">\n{{ 'common.packed' | translate }}\n<span class=\"badge\">{{$ctrl.pendingReleaseData.totalRecords || 0}}</span>\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.released\" ng-click=\"$ctrl.tabSelection('released')\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.released}\">\n{{ 'common.released' | translate }}\n<span class=\"badge\">{{$ctrl.releasedDeposit.totalRecords || 0}}</span>\n</label>\n</div>\n</div>\n<div class=\"col-sm-4 remove-right-pad\" ng-if=\"$ctrl.model.stats === $ctrl.stats.released && $ctrl.releasedDeposit.records.length\">\n<button class=\"pull-right btn btn-warning btn-sm deposit-pack-btn-gap\" ng-disabled=\"$ctrl.isExporting\" type=\"button\" ng-click=\"$ctrl.exportReleasedResidualData()\">\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.isExporting}\"></i>\n{{'atm_deposit_packing.export_data' | translate}}\n</button>\n<button class=\"pull-right btn btn-success btn-sm deposit-pack-btn-gap\" ng-disabled=\"$ctrl.releasedLoader\" type=\"button\" ng-click=\"$ctrl.reloadPageData()\">\n<i class=\"glyphicon glyphicon-repeat\"></i>\n</button>\n</div>\n<div class=\"col-sm-12 align-center-vertically deposit-center-date margin-top-10\" ng-if=\"$ctrl.model.stats === $ctrl.stats.released && $ctrl.isFormValidate()\">\n<div class=\"padding-zero\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRanges\" options=\"$ctrl.model.dateRangPickerOptions\" ng-if=\"$ctrl.model.dateRanges.startDate\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n</div>\n<div class=\"col-sm-4 remove-right-pad\" ng-if=\"$ctrl.model.stats === $ctrl.stats.pending && $ctrl.pendingResidualData.records.length && $ctrl.isResidualDeposit()\">\n<button class=\"pull-right btn btn-warning btn-sm deposit-pack-btn-gap\" ng-disabled=\"$ctrl.isExporting\" type=\"button\" ng-click=\"$ctrl.exportPendingResidalData()\">\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.isExporting}\"></i>\n{{'atm_deposit_packing.export_data' | translate}}\n</button>\n<button class=\"pull-right btn btn-success btn-sm deposit-pack-btn-gap\" ng-disabled=\"$ctrl.loading\" type=\"button\" ng-click=\"$ctrl.reloadPageData()\">\n<i class=\"glyphicon glyphicon-repeat\"></i>\n</button>\n</div>\n<div class=\"remove-right-pad col-sm-4\" ng-if=\"$ctrl.model.stats === $ctrl.stats.pending && $ctrl.model.account === 'emergency' \n                                         && $ctrl.emergencyPackPreviewData.breakdown.length && $ctrl.isResidualDeposit()\">\n<button class=\"pull-right btn btn-success btn-sm deposit-pack-btn-gap\" ng-disabled=\"$ctrl.emergencyPackLoader\" type=\"button\" ng-click=\"$ctrl.reloadPageData()\">\n<i class=\"glyphicon glyphicon-repeat\"></i>\n</button>\n</div>\n<div class=\"col-sm-4 remove-right-pad\" ng-if=\"$ctrl.model.ledgerData.results.length && $ctrl.model.stats === $ctrl.stats.pending && $ctrl.isManualDeposit()\">\n<button class=\"pull-right btn btn-success btn-sm deposit-pack-btn-gap\" ng-disabled=\"$ctrl.isLoading\" type=\"button\" ng-click=\"$ctrl.getLedgerDenomBalance(); $ctrl.resetDenomData();\">\n<i class=\"glyphicon glyphicon-repeat\"></i>\n</button>\n</div>\n<div class=\"col-sm-4 remove-right-pad\" ng-if=\"$ctrl.model.stats === $ctrl.stats.packed && $ctrl.pendingReleaseData.records.length\">\n<button class=\"pull-right btn btn-warning btn-sm deposit-pack-btn-gap\" ng-disabled=\"$ctrl.isExporting\" type=\"button\" ng-click=\"$ctrl.exportPackedResidualData()\">\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.isExporting}\"></i>\n{{'atm_deposit_packing.export_data' | translate}}\n</button>\n<button class=\"col-sm-3 pull-right btn btn-success btn-sm deposit-pack-btn-gap\" ng-disabled=\"$ctrl.isExporting\" type=\"button\" ng-if=\"$ctrl.model.stats === $ctrl.stats.packed && $ctrl.pendingReleaseData.records.length && $ctrl.model.account === 'emergency'\" ng-click=\"$ctrl.printEmergencyPackedData()\">\n{{'atm_deposit_packing.print' | translate}}\n</button>\n<button class=\"pull-right btn btn-success btn-sm deposit-pack-btn-gap\" ng-disabled=\"$ctrl.pendingPackLoader\" type=\"button\" ng-click=\"$ctrl.reloadPageData()\">\n<i class=\"glyphicon glyphicon-repeat\"></i>\n</button>\n</div>\n</div>\n<div class=\"row_ col-sm-12 remove-pad margin-top-10\" ng-if=\"$ctrl.isResidualDeposit() && $ctrl.model.stats === $ctrl.stats.pending && $ctrl.pendingResidualData.records.length\">\n<div class=\"col-md-12 remove-pad\" ng-if=\"!$ctrl.loading\">\n<div class=\"col-sm-4 pack-msg bold-font\" ng-if=\"$ctrl.isValidate() && $ctrl.model.account === 'regular'\">{{$ctrl.msg}}</div>\n<div class=\"_datepicker-center-section col-sm-4 align-center\" ng-if=\"$ctrl.model.account === 'regular'\">\n<div class=\"deposit-pack-date-picker\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" ng-click=\"$ctrl.selectDepositByDate()\" ng-class=\"{'required-datetimepicker': !$ctrl.model.date}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div>\n<button class=\"btn btn-danger btn-sm deposit-pack-btn-gap\" type=\"button\" ng-click=\"$ctrl.resetSelection()\" ng-disabled=\"!$ctrl.residualIds.length\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-4 no-padding deposit-denom-dd text-right remove-right-pad\">\n<span class=\"denom-dd-width\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.denominationGroup\" output-model=\"$ctrl.model.denomination\" button-label=\"icon id\" item-label=\"icon denominationId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.filterDataByDenom();\" on-reset=\"$ctrl.resetData()\" on-select-none=\"$ctrl.resetData();\" on-select-all=\"$ctrl.filterDataByDenom();\" helper-elements=\"all none reset\">\n</span>\n</div>\n</div>\n</div>\n<div class=\"text-align-center font-size-50\" ng-if=\"$ctrl.loading && $ctrl.isValidate() && $ctrl.model.stats === $ctrl.stats.pending && $ctrl.isResidualDeposit()\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner margin-top-40\"></span>\n</div>\n<div class=\"row_\" ng-if=\"$ctrl.model.stats === $ctrl.stats.pending && $ctrl.isResidualDeposit()\">\n<div class=\"margin-top-10 col-sm-12 remove-pad table-responsive\" ng-if=\"$ctrl.pendingResidualData.records.length && $ctrl.isValidate() && !$ctrl.loading\">\n<table class=\"remove-bottom-margin table table-hover table-bordered table-pad-7 pending-residual-records font-12\">\n<thead>\n<tr class=\"text-center\">\n<td ng-click=\"$ctrl.toggleAllSelection()\" align=\"center\" class=\"w-52p cursor-pointer v-align-top\">\n<span>\n<b>{{'common.All'|translate }}</b>\n</span>\n</td>\n<td>\n<b>{{'atm_deposit_packing.tracking_id' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.location_id' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.counted_date' | translate}}</b>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.denom' | translate}}</strong>\n</td>\n<td ng-class=\"{'residual-lbl-width' : $ctrl.pendingResidualData.records.length > 10}\">\n<b>{{'atm_deposit_packing.residual_amount' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"scroll-content text-center\">\n<tr ng-repeat=\"data in $ctrl.pendingResidualData.records track by $index\">\n<td class=\"w-52p\">\n<input type=\"checkbox\" ng-disabled=\"$ctrl.model.loading\" ng-click=\"$ctrl.selectedDeposit($event, data, index)\" ng-model=\"data.isSelected\">\n</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToAtmCount(data.trackingId)\">\n{{data.trackingId}} <span class=\"badge\" ng-style=\"data.type === 'D' ? {'background-color': '#5cb85c'} : {'background-color': '#5bc0de'}\">{{data.type}}</span>\n</a>\n</td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data)\">\n{{data.locationId}}\n</a>\n</td>\n<td>{{data.countedDate | date:'yyyy-MM-dd': 'UTC' }}</td>\n<td>\n<span ng-repeat=\"denom in data.denominationId.split(',') track by $index\">\n<img ng-src=\"assets/images/{{denom.trim()}}.png\" class=\"custom-icon\" title=\"{{denom.trim()}}\" style=\"margin-right: 2px;\"/>\n</span>\n</td>\n<td>{{data.amount | currency:$ctrl.currencySymbol}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-class=\"{ 'margin-top-10' : !$ctrl.pendingResidualData.records.length }\" ng-if=\"($ctrl.pendingResidualData.totalRecords == 0 || $ctrl.isError) && $ctrl.isValidate() && !$ctrl.loading && $ctrl.model.account === 'regular'\">\n<div class=\"alert alert-danger text-align-center\">{{$ctrl.errorMessage}}</div>\n</div>\n<div class=\"text-align-center font-size-70\" ng-if=\"$ctrl.model.loading && $ctrl.isValidate()\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner margin-top-40\"></span>\n</div>\n<div class=\"col-sm-12 margin-top-10 remove-pad\" ng-if=\"$ctrl.denominationsBreakdown.breakdown.length && $ctrl.isValidate() && !$ctrl.model.loading && !$ctrl.loading\">\n<div class=\"row col-sm-12 remove-pad margin-bottom-10\" ng-if=\"$ctrl.isResidualDeposit() && $ctrl.model.account === 'regular'\" ng-style=\"!$ctrl.model.deliveryLocation && {'display': 'flex', 'justify-content': 'center'}\">\n<div class=\"col-sm-12\" ng-if=\"!$ctrl.validDeliveryLocationIds || !$ctrl.validDeliveryLocationIds.length\">\n<div class=\"alert alert-warning text-align-center\">\nNo delivery locations are configured for this funding source. Please configure Delivery To Locations for the funding source location.\n</div>\n</div>\n<div class=\"col-sm-4 form-group delivery-location-search\" ng-if=\"$ctrl.validDeliveryLocationIds && $ctrl.validDeliveryLocationIds.length > 0\">\n<label>{{'atm_deposit_packing.delivery_location' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.deliveryLocation\" values=\"$ctrl.deliveryLocations\" key=\"Key\" totalrecords=\"$ctrl.totalDeliveryLocations\" on-click=\"$ctrl.loadRouteSchedule()\" onscroll=\"$ctrl.getDeliveryLocations(searchKey, offset)\" none-selected=\"'atm_deposit_packing.select_delivery_location'\" required></search-and-select>\n</div>\n<div class=\"col-sm-4 form-group delivery-location-search\" ng-if=\"$ctrl.model.deliveryLocation\">\n<label>{{'atm_deposit_packing.route_id' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.routeSelection\" values=\"$ctrl.routeList\" key=\"Key\" totalrecords=\"$ctrl.totalRoutes\" on-click=\"$ctrl.onRouteChange()\" onscroll=\"$ctrl.getRoutes(searchKey, offset)\" none-selected=\"'common.select_route'\" required></search-and-select>\n</div>\n<div class=\"col-sm-4 form-group\" ng-if=\"$ctrl.model.deliveryLocation\">\n<label>{{'atm_deposit_packing.delivery_date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.deliveryDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.minDeliveryDate\" ng-class=\"{'required-datetimepicker': !$ctrl.model.deliveryDate}\" ng-change=\"$ctrl.loadRouteSchedule()\" ng-keydown=\"$event.preventDefault()\" required/>\n</div>\n</div>\n<table class=\"table table-hover table-bordered table-pad-7\">\n<thead>\n<tr class=\"text-center\">\n<td>\n<b>{{'atm_deposit_packing.tracking_id' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.denom' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.total' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.actions' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr>\n<td class=\"common-width-15\">\n<span ng-if=\"$ctrl.isLimitExceed\" class=\"glyphicon glyphicon-warning-sign deposit-limit-warning\" uib-tooltip=\"{{$ctrl.depositLimitExceedMsg}}\" tooltip-placement=\"top-left\"></span>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.trackingId\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" required capitalize/></td>\n<td>\n<div ng-repeat=\"denomination in $ctrl.denominationsBreakdown.breakdown track by $index\">\n<div class=\"col-sm-3 col-md-3 no-padding margin5\">\n<div class=\"input-group denom-box-width\">\n<span class=\"input-group-addon padding5\">\n<img ng-src=\"assets/images/{{denomination.denominationId}}.png\" class=\"img-currency\"/>\n</span>\n<span class=\"form-control text-right z-index0\">\n{{ denomination.totalAmount | currency:$ctrl.currencySymbol:2}}\n</span>\n</div>\n</div>\n</div>\n</td>\n<td class=\"common-width-15\">{{$ctrl.denominationsBreakdown.summary.totalAmount | currency:$ctrl.currencySymbol:2}}</td>\n<td class=\"col-width-10\">\n<button class=\"btn btn-success btn-sm\" type=\"button\" ng-click=\"$ctrl.pack()\" ng-disabled=\"Form.$invalid || $ctrl.isLimitExceed || $ctrl.packLoader || !$ctrl.deliveryLocations || !$ctrl.deliveryLocations.length || !$ctrl.model.deliveryLocation || !$ctrl.model.routeId || !$ctrl.model.deliveryDate\">\n{{'atm_deposit_packing.pack' | translate}}\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.packLoader}\"></i>\n</button>\n<button class=\"btn btn-info btn-sm\" type=\"button\" ng-click=\"$ctrl.printPackedDepositLabel({ totalAmount: $ctrl.denominationsBreakdown.summary.totalAmount, denominations: $ctrl.denominationsBreakdown.breakdown })\" ng-disabled=\"Form.$invalid\" ng-if=\"$ctrl.model.fundingSourceId && $ctrl.model.fundingSourceId.residualDeposit && $ctrl.denominationsBreakdown.breakdown.length\">\n<span class=\"glyphicon glyphicon-print\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-if=\"$ctrl.successMessage && !$ctrl.packLoader && !$ctrl.loading && $ctrl.model.account === 'regular'\">\n<div class=\"margin-top-10 col-sm-12 alert alert-success text-align-center\">{{$ctrl.successMessage}}</div>\n</div>\n</div>\n<div class=\"text-align-center font-size-70\" ng-if=\"$ctrl.emergencyPackLoader && $ctrl.isValidate() \n        && $ctrl.model.stats === $ctrl.stats.pending && $ctrl.isResidualDeposit()\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner margin-top-40\"></span>\n</div>\n<div class=\"row_ margin-top-20\" ng-if=\"$ctrl.model.stats === $ctrl.stats.pending && $ctrl.isResidualDeposit()\">\n<div class=\"deposit_packing_data_box\" ng-if=\"$ctrl.emergencyPackPreviewData.breakdown.length && $ctrl.isValidate() && !$ctrl.emergencyPackLoader\">\n<div class=\"w-18\" ng-repeat=\"data in $ctrl.emergencyPackPreviewData.breakdown track by $index\">\n<div class=\"input-group\">\n<div class=\"padding5\">\n<img class=\"denom-icon-size\" ng-src=\"assets/images/{{data.denominationId}}.png\" class=\"img-currency\"/>\n</div>\n<div class=\"denom-amount-font-size\">\n<span>{{ data.totalAmount | currency:$ctrl.currencySymbol:2}}</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.emergencyPackPreviewData.breakdown.length && !$ctrl.emergencyPackLoader\">\n<div class=\"row col-sm-12 remove-pad margin-bottom-10\" ng-if=\"$ctrl.model.account === 'emergency' && $ctrl.isResidualDeposit()\" ng-style=\"!$ctrl.model.deliveryLocation && {'display': 'flex', 'justify-content': 'center'}\">\n<div class=\"col-sm-12\" ng-if=\"!$ctrl.validDeliveryLocationIds || !$ctrl.validDeliveryLocationIds.length\">\n<div class=\"alert alert-warning text-align-center\">\nNo delivery locations are configured for this funding source. Please configure Delivery To Locations for the funding source location.\n</div>\n</div>\n<div class=\"col-sm-4 form-group delivery-location-search\" ng-if=\"$ctrl.validDeliveryLocationIds && $ctrl.validDeliveryLocationIds.length > 0\">\n<label>{{'atm_deposit_packing.delivery_location' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.deliveryLocation\" values=\"$ctrl.deliveryLocations\" key=\"Key\" totalrecords=\"$ctrl.totalDeliveryLocations\" on-click=\"$ctrl.loadRouteSchedule()\" onscroll=\"$ctrl.getDeliveryLocations(searchKey, offset)\" none-selected=\"'atm_deposit_packing.select_delivery_location'\" required></search-and-select>\n</div>\n<div class=\"col-sm-4 form-group delivery-location-search\" ng-if=\"$ctrl.model.deliveryLocation\">\n<label>{{'atm_deposit_packing.route_id' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.routeSelection\" values=\"$ctrl.routeList\" key=\"Key\" totalrecords=\"$ctrl.totalRoutes\" on-click=\"$ctrl.onRouteChange()\" onscroll=\"$ctrl.getRoutes(searchKey, offset)\" none-selected=\"'common.select_route'\" required></search-and-select>\n</div>\n<div class=\"col-sm-4 form-group\" ng-if=\"$ctrl.model.deliveryLocation\">\n<label>{{'atm_deposit_packing.delivery_date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.deliveryDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.minDeliveryDate\" ng-class=\"{'required-datetimepicker': !$ctrl.model.deliveryDate}\" ng-change=\"$ctrl.loadRouteSchedule()\" ng-keydown=\"$event.preventDefault()\" required/>\n</div>\n</div>\n<table class=\"table table-hover table-bordered table-pad-7\">\n<thead>\n<tr class=\"text-center\">\n<td>\n<b>{{'atm_deposit_packing.tracking_id' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.denom' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.total' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.actions' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"text-center\" ng-if=\"!$ctrl.model.fundingSourceId.partialECDeposit\">\n<tr>\n<td class=\"common-width-15\">\n<span ng-if=\"$ctrl.isLimitExceed\" class=\"glyphicon glyphicon-warning-sign deposit-limit-warning\" uib-tooltip=\"{{$ctrl.depositLimitExceedMsg}}\" tooltip-placement=\"top\"></span>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.trackingId\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" required capitalize/></td>\n<td>\n<div ng-repeat=\"denomination in $ctrl.emergencyPackPreviewData.breakdown track by $index\">\n<div class=\"col-sm-3 col-md-3 no-padding margin5\">\n<div class=\"input-group denom-box-width\">\n<span class=\"input-group-addon padding5\">\n<img ng-src=\"assets/images/{{denomination.denominationId}}.png\" class=\"img-currency\"/>\n</span>\n<span class=\"form-control text-right z-index0\">\n{{ denomination.totalAmount | currency:$ctrl.currencySymbol:2}}\n</span>\n</div>\n</div>\n</div>\n</td>\n<td class=\"common-width-15\">{{$ctrl.emergencyPackPreviewData.summary.totalAmount | currency:$ctrl.currencySymbol:2}}</td>\n<td class=\"col-width-10\">\n<button class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.emergencyPack()\" ng-disabled=\"Form.$invalid || $ctrl.isLimitExceed || $ctrl.packEmergencyDeposit || !$ctrl.deliveryLocations || !$ctrl.deliveryLocations.length || !$ctrl.model.deliveryLocation || !$ctrl.model.routeId || !$ctrl.model.deliveryDate\">\n{{'atm_deposit_packing.pack' | translate}}\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.packEmergencyDeposit}\"></i>\n</button>\n<button class=\"btn btn-info btn-sm\" type=\"button\" ng-click=\"$ctrl.printPackedDepositLabel({ totalAmount: $ctrl.emergencyPackPreviewData.summary.totalAmount, denominations: $ctrl.emergencyPackPreviewData.breakdown })\" ng-disabled=\"Form.$invalid\" ng-if=\"$ctrl.model.fundingSourceId && $ctrl.model.fundingSourceId.residualDeposit && $ctrl.emergencyPackPreviewData.breakdown.length\">\n<span class=\"glyphicon glyphicon-print\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n<tbody class=\"text-center\" ng-if=\"$ctrl.model.fundingSourceId.partialECDeposit\">\n<tr ng-repeat=\"data in $ctrl.denominationData track by $index\">\n<td class=\"common-width-15\">\n<input type=\"text\" class=\"form-control\" ng-model=\"data.trackingId\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-change=\"$ctrl.checkDuplicateTrackingIds()\" ng-class=\"{'duplicate-tracking-id': data.isDuplicateTrackingId}\" required capitalize/>\n</td>\n<td class=\"no-padding margin5\">\n<div ng-repeat=\"denomination in data.denominations track by $index\">\n<div class=\"col-sm-6 col-md-6 denomination-input-box\">\n<div class=\"no-padding\">\n<div class=\"input-group\">\n<span class=\"input-group-addon padding5\">\n<a role=\"button\" uib-popover-template=\"denomination.template\" popover-is-open=\"denomination.isOpen\" popover-enable=\"data.remainingDenominations.length > 0\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\">\n<img ng-src=\"assets/images/{{denomination.icon}}.png\" class=\"img-currency\"/>\n</a>\n</span>\n<input id=\"denomBox-{{$index+1}}\" class=\"form-control\" type=\"text\" ng-model=\"denomination.inputValue\" ng-class=\"{'invalid-amount' : !$ctrl.denominationData[$parent.$index].denominations[$index].isValid, \n                                                           'ng-valid' : $ctrl.denominationData[$parent.$index].denominations[$index].isValid || denomination.inputValue}\" placeholder=\"{{ denomination.coinFlag ? ('checkin.coinUnit' | translate) : ('checkin.amount' | translate) }}\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.validateAmount($parent.$index, $index, denomination.ledgerDenomBalance, denomination.inputValue, denomination.faceValue, denomination.coinFlag);\" ng-disabled=\"$ctrl.isLoadingPackPreview\" ng-currency=\"{{!denomination.coinFlag}}\" style=\"z-index: 0;\" currency-symbol=\"{{denomination.symbol || $ctrl.currencySymbol}}\" fraction=\"0\" required>\n</div>\n</div>\n<span class=\"col-sm-2 col-md-2 text-right denomination-box-width\">\n<button class=\"btn btn-xs btn-danger btn-icon\" uib-tooltip=\"Close\" ng-click=\"$ctrl.removeDenomination($parent.$index, $index, denomination.balance)\" ng-disabled=\"$ctrl.isLoadingPackPreview\" tooltip-append-to-body=\"true\">\n<i class=\"glyphicon glyphicon-remove\"></i>\n</button>\n</span>\n\n</div>\n</div>\n<div class=\"pull-left\">\n<button class=\"btn btn-xs btn-success btn-icon\" ng-class=\"{'add-btn-margin-7' : data.denominations.length > 0 }\" uib-tooltip=\"Add\" ng-click=\"$ctrl.addDenomination($index)\" tooltip-append-to-body=\"true\" ng-disabled=\"!data.remainingDenominations.length || $ctrl.model.ledgerData.totalAmount === 0 || $ctrl.isLoadingPackPreview\">\n<i class=\"glyphicon glyphicon-plus\"></i>\n</button>\n</div>\n</td>\n<td class=\"common-width-15\">{{data.totalAmount | currency:$ctrl.currencySymbol:2}}</td>\n<td class=\"col-width-10\">\n<button class=\"btn btn-success btn-sm\" type=\"button\" ng-click=\"$ctrl.addRow()\" ng-if=\"$index === $ctrl.denominationData.length - 1 && !$ctrl.packPreviewError && !$ctrl.isWarning\">\n<i class=\"glyphicon glyphicon-plus\"></i>\n</button>\n<button class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"$ctrl.removeRow($index)\" ng-if=\"$ctrl.denominationData.length > 1\">\n<i class=\"glyphicon glyphicon-trash\"></i>\n</button>\n<button class=\"btn btn-info btn-sm\" type=\"button\" ng-click=\"$ctrl.printPackedDepositLabel(data)\" ng-disabled=\"Form.$invalid\" ng-if=\"(data.trackingId && data.denominations.length) || ($ctrl.model.fundingSourceId && $ctrl.model.fundingSourceId.residualDeposit)\">\n<span class=\"glyphicon glyphicon-print\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"row margin-top-10 margin-bottom-10\">\n<div class=\"col-sm-12 text-right\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.adHocPack()\" ng-disabled=\"Form.$invalid || $ctrl.adHocPackLoader || $ctrl.validatePackAllButton() || $ctrl.isLoadingPackPreview || $ctrl.isLimitExceed || $ctrl.packEmergencyDeposit || !$ctrl.deliveryLocations || !$ctrl.deliveryLocations.length || !$ctrl.model.deliveryLocation || !$ctrl.model.routeId || !$ctrl.model.deliveryDate\">\n{{'atm_deposit_packing.pack' | translate}}\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.adHocPackLoader}\"></i>\n</button>\n</div>\n</div>\n<div class=\"margin-top-10\" ng-if=\"$ctrl.isWarning\">\n<div class=\"alert alert-danger text-align-center\" ng-repeat=\"warning in $ctrl.model.adHocPackPreviewData.warnings\">\n{{warning}}\n</div>\n</div>\n<div class=\"margin-top-10\" ng-if=\"$ctrl.packPreviewError\">\n<div class=\"alert alert-danger text-align-center\">\n{{$ctrl.packPreviewError}}\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-top-10\" ng-if=\"!$ctrl.emergencyPackPreviewData.breakdown.length\n                                                         && $ctrl.isValidate() && $ctrl.model.account === 'emergency'\n                                                         && !$ctrl.emergencyPackLoader\">\n<div class=\"alert alert-danger text-align-center\">{{'atm_deposit_packing.no_data_found' | translate}}</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-top-05\" ng-if=\"$ctrl.successMessage && !$ctrl.packEmergencyDeposit && !$ctrl.emergencyPackLoader && $ctrl.model.account === 'emergency'\">\n<div class=\"col-sm-12 alert alert-success text-align-center\">{{$ctrl.successMessage}}</div>\n</div>\n</div>\n<div class=\"text-align-center font-size-70\" ng-if=\"$ctrl.pendingPackLoader && $ctrl.isFormValidate() && $ctrl.model.stats === $ctrl.stats.packed\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner margin-top-40\"></span>\n</div>\n<div class=\"row_\" ng-if=\"$ctrl.model.stats === $ctrl.stats.packed\">\n<div class=\"remove-pad col-sm-12 margin-top-10\" ng-if=\"$ctrl.pendingReleaseData.totalRecords > 0 && $ctrl.isFormValidate() && !$ctrl.pendingPackLoader\">\n<table class=\"table table-hover table-bordered table-pad-5\">\n<thead>\n<tr class=\"text-center\">\n<td>\n<b>#</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.tracking_id' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.packed_date' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.total' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.actions' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat-start=\"pendingRelease in $ctrl.pendingReleaseData.records track by $index\">\n<td>\n<span ng-if=\"$ctrl.model.account === 'regular' && $ctrl.isResidualDeposit();\">\n<button class=\"btn btn-success btn-xs glyphicon glyphicon-plus\" ng-click=\"$ctrl.packedDepositInfo(pendingRelease)\"></button>\n</span>\n<span ng-if=\"$ctrl.model.account === 'emergency' || $ctrl.isManualDeposit();\">\n{{ (($ctrl.paginationObj.page - 1) * $ctrl.paginationObj.pageLimit) + $index + 1 }}\n</span>\n</td>\n<td>\n{{pendingRelease.trackingId}}\n</td>\n<td>{{pendingRelease.createdAt | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n<td>{{pendingRelease.totalAmount | currency:$ctrl.currencySymbol:2}}</td>\n<td class=\"actions-width-20\">\n<button class=\"btn btn-info btn-xs\" ng-click=\"$ctrl.togglePackedDenominations(pendingRelease)\" ng-if=\"pendingRelease.denominations && pendingRelease.denominations.length > 0\">\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-chevron-down': !pendingRelease.showDenominations, 'glyphicon-chevron-up': pendingRelease.showDenominations}\"></i>\n</button>\n<button ng-show=\"$ctrl.model.account === 'regular' && $ctrl.isResidualDeposit()\" class=\"btn btn-success btn-sm\" ng-disabled=\"$ctrl.contentLoader\" ng-click=\"$ctrl.printManifest(pendingRelease, $index)\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{'atm_deposit_packing.print' | translate}}\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.contentLoader}\"></i>\n</button>\n<button class=\"btn btn-success btn-sm\" ng-disabled=\"$ctrl.releaseLoader[pendingRelease.trackingId].process\" ng-click=\"$ctrl.relesePendingDeposit(pendingRelease, $index)\">\n<b>{{'atm_deposit_packing.release' | translate}}</b>\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.releaseLoader[pendingRelease.trackingId].process}\"></i>\n</button>\n<button class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.confirmUndoDeposit(pendingRelease, $index)\">\n<i class=\"glyphicon glyphicon-trash\"></i>\n</button>\n</td>\n</tr>\n<tr ng-repeat-end ng-if=\"pendingRelease.showDenominations && pendingRelease.denominations && pendingRelease.denominations.length > 0\">\n<td colspan=\"5\" class=\"denominations-row\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<table class=\"table table-bordered table-condensed\" style=\"margin-bottom: 0;\">\n<thead>\n<tr class=\"text-center\">\n<th class=\"text-center\"><strong>Denomination</strong></th>\n<th class=\"text-center\"><strong>Face Value</strong></th>\n<th class=\"text-center\"><strong>Quantity</strong></th>\n<th class=\"text-center\"><strong>Amount</strong></th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"denomination in pendingRelease.denominations track by $index\">\n<td>\n<div class=\"input-group\">\n<span class=\"input-group-addon padding5\">\n<img ng-src=\"assets/images/{{denomination.denominationId}}.png\" class=\"img-currency\" style=\"width: 20px; height: 20px;\"/>\n</span>\n<span class=\"form-control\">\n{{denomination.denominationName || denomination.denominationId}}\n</span>\n</div>\n</td>\n<td>{{denomination.denominationFaceValue || denomination.faceValue | currency:(denomination.symbol || $ctrl.currencySymbol):2}}</td>\n<td>{{denomination.change || denomination.quantity || 0}}</td>\n<td>{{denomination.amount | currency:(denomination.symbol || $ctrl.currencySymbol):2}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"row col-sm-12\" ng-if=\"$ctrl.packedDepositTotal > 10\">\n<ul uib-pagination total-items=\"$ctrl.packedDepositTotal\" ng-hide=\"{{($ctrl.packedDepositTotal<=$ctrl.paginationObj.pageLimit)&&($ctrl.paginationObj.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.paginationObj.page\" ng-change=\"$ctrl.jumpToNextPage()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-top-10\" ng-if=\"$ctrl.successMessage && !$ctrl.pendingPackLoader\">\n<div class=\"remove-bottom-margin alert alert-success text-align-center\">{{$ctrl.successMessage}}</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-top-10\" ng-if=\"$ctrl.pendingReleaseData.totalRecords == 0 && $ctrl.isFormValidate() && !$ctrl.pendingPackLoader\">\n<div class=\"alert alert-danger text-align-center\">{{'atm_deposit_packing.no_data_found' | translate}}</div>\n</div>\n</div>\n<div class=\"text-align-center font-size-70\" ng-if=\"$ctrl.releasedLoader && $ctrl.isFormValidate() && $ctrl.model.stats === $ctrl.stats.released\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner margin-top-40\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.model.stats === $ctrl.stats.released && $ctrl.isFormValidate() && !$ctrl.releasedLoader\">\n<table class=\"margin-top-10 table table-hover table-bordered table-pad-5\" ng-if=\"$ctrl.releasedDeposit.totalRecords > 0\">\n<thead>\n<tr class=\"text-center\">\n<td>\n<b>#</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.tracking_id' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.released_date' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.total' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.actions' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat-start=\"released in $ctrl.releasedDeposit.records track by $index\">\n<td>\n<span ng-if=\"$ctrl.model.account === 'regular' && $ctrl.isResidualDeposit()\">\n<button class=\"btn btn-success btn-xs glyphicon glyphicon-plus\" ng-click=\"$ctrl.packedDepositInfo(released)\"></button>\n</span>\n<span ng-if=\"$ctrl.model.account === 'emergency' || $ctrl.isManualDeposit();\">\n{{ (($ctrl.model.pagination.page - 1) * $ctrl.model.pagination.pageLimit) + $index + 1 }}\n</span>\n</td>\n<td>{{released.trackingId}}</td>\n<td>{{released.releasedAt | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n<td>{{released.totalAmount | currency:$ctrl.currencySymbol:2}}</td>\n<td class=\"common-width-15\">\n<button class=\"btn btn-info btn-xs\" ng-click=\"$ctrl.toggleReleasedDenominations(released)\" ng-if=\"released.denominations && released.denominations.length > 0\">\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-chevron-down': !released.showDenominations, 'glyphicon-chevron-up': released.showDenominations}\"></i>\n</button>\n<button class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.printManifest(released, $index)\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{'atm_deposit_packing.print' | translate}}\n</button>\n<button class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.exportReleasedDeposit(released, $index)\" ng-if=\"$ctrl.model.account === 'regular' && $ctrl.isResidualDeposit()\" ng-disabled=\"$ctrl.isExporting\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{'branch_mgmt.daily_balance_sheet.export' | translate}}\n</button>\n</td>\n</tr>\n<tr ng-repeat-end ng-if=\"released.showDenominations && released.denominations && released.denominations.length > 0\">\n<td colspan=\"5\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<table class=\"table table-bordered table-condensed\">\n<thead>\n<tr class=\"text-center\">\n<th class=\"text-center\"><b>Denomination</b></th>\n<th class=\"text-center\"><b>Face Value</b></th>\n<th class=\"text-center\"><b>Quantity</b></th>\n<th class=\"text-center\"><b>Amount</b></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"denomination in released.denominations track by $index\">\n<td>\n<div class=\"input-group\">\n<span class=\"input-group-addon padding5\">\n<img ng-src=\"assets/images/{{denomination.denominationId}}.png\" class=\"img-currency\"/>\n</span>\n<span class=\"form-control\">\n{{denomination.denominationName || denomination.denominationId}}\n</span>\n</div>\n</td>\n<td>{{denomination.denominationFaceValue || denomination.faceValue | currency:(denomination.symbol || $ctrl.currencySymbol):2}}</td>\n<td>{{denomination.change || denomination.quantity || 0}}</td>\n<td>{{denomination.amount | currency:(denomination.symbol || $ctrl.currencySymbol):2}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 margin-top-10\" ng-if=\"$ctrl.releasedDeposit.totalRecords == 0\">\n<div class=\"row alert alert-danger text-align-center\">{{'atm_deposit_packing.no_data_found' | translate}}</div>\n</div>\n<div class=\"row col-sm-12\" ng-if=\"$ctrl.releasedDepositTotal > 10\">\n<ul uib-pagination total-items=\"$ctrl.releasedDepositTotal\" ng-hide=\"{{($ctrl.releasedDepositTotal<=$ctrl.model.pagination.pageLimit)&&($ctrl.model.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.pagination.page\" ng-change=\"$ctrl.nextPage()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.fundingSourceId && $ctrl.model.fundingSourceId.manualDeposit\">\n<div class=\"text-align-center font-size-70\" ng-if=\"$ctrl.isLoading && $ctrl.isValidate() && $ctrl.model.stats === $ctrl.stats.pending\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner margin-top-40\"></span>\n</div>\n<div class=\"col-sm-12 text-center padding-18 denom-position\" ng-if=\"!$ctrl.isLoading && $ctrl.model.ledgerData.results.length && $ctrl.model.stats === $ctrl.stats.pending\">\n<div ng-repeat=\"data in $ctrl.model.ledgerData.results track by $index\" class=\"denom-width\">\n<div class=\"text-center\">\n<img ng-src=\"assets/images/{{data.denominationId}}.png\" class=\"custom-icon\"/>\n<span class=\"text-amount\">\n{{ data.balance | currency:(data.symbol || $ctrl.currencySymbol):2 }}\n</span>\n</div>\n</div>\n</div>\n<div class=\"margin-top-10\" ng-if=\"$ctrl.model.ledgerData.results.length && $ctrl.isValidate() && !$ctrl.isLoading && $ctrl.model.stats === $ctrl.stats.pending\">\n<div class=\"row col-sm-12 remove-pad margin-bottom-10\" ng-if=\"$ctrl.isManualDeposit()\" ng-style=\"!$ctrl.model.deliveryLocation && {'display': 'flex', 'justify-content': 'center'}\">\n<div class=\"col-sm-12\" ng-if=\"!$ctrl.validDeliveryLocationIds || !$ctrl.validDeliveryLocationIds.length\">\n<div class=\"alert alert-warning text-align-center\">\nNo delivery locations are configured for this funding source. Please configure Delivery To Locations for the funding source location.\n</div>\n</div>\n<div class=\"col-sm-4 form-group delivery-location-search\" ng-if=\"$ctrl.validDeliveryLocationIds && $ctrl.validDeliveryLocationIds.length > 0\">\n<label>{{'atm_deposit_packing.delivery_location' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.deliveryLocation\" values=\"$ctrl.deliveryLocations\" key=\"Key\" totalrecords=\"$ctrl.totalDeliveryLocations\" on-click=\"$ctrl.loadRouteSchedule()\" onscroll=\"$ctrl.getDeliveryLocations(searchKey, offset)\" none-selected=\"'atm_deposit_packing.select_delivery_location'\" required></search-and-select>\n</div>\n<div class=\"col-sm-4 form-group delivery-location-search\" ng-if=\"$ctrl.model.deliveryLocation\">\n<label>{{'atm_deposit_packing.route_id' | translate}}</label>\n<search-and-select class=\"padding-bottom-20\" ng-model=\"$ctrl.model.routeSelection\" values=\"$ctrl.routeList\" key=\"Key\" totalrecords=\"$ctrl.totalRoutes\" on-click=\"$ctrl.onRouteChange()\" onscroll=\"$ctrl.getRoutes(searchKey, offset)\" none-selected=\"'common.select_route'\" required></search-and-select>\n</div>\n<div class=\"col-sm-4 form-group\" ng-if=\"$ctrl.model.deliveryLocation\">\n<label>{{'atm_deposit_packing.delivery_date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.deliveryDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.minDeliveryDate\" ng-class=\"{'required-datetimepicker': !$ctrl.model.deliveryDate}\" ng-change=\"$ctrl.loadRouteSchedule()\" ng-keydown=\"$event.preventDefault()\" required/>\n</div>\n</div>\n<div id=\"deposit-packing-table-container\" class=\"col-sm-12 remove-pad\" style=\"max-height: 500px;height: 100%;overflow: auto;scrollbar-width: thin;\">\n<table class=\"table table-hover table-bordered table-pad-7\">\n<thead>\n<tr class=\"text-center\">\n<td style=\"width: 5%;\">\n<b>#</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.tracking_id' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.denom' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.total' | translate}}</b>\n</td>\n<td>\n<b>{{'atm_deposit_packing.actions' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"data in $ctrl.denominationData track by $index\">\n<td style=\"vertical-align: middle;\">\n{{$index + 1}}\n</td>\n<td class=\"common-width-15\">\n<input type=\"text\" class=\"form-control\" ng-model=\"data.trackingId\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" ng-change=\"$ctrl.checkDuplicateTrackingIds()\" ng-class=\"{'duplicate-tracking-id': data.isDuplicateTrackingId}\" required capitalize/>\n</td>\n<td class=\"no-padding margin5\">\n<div ng-repeat=\"denomination in data.denominations track by $index\">\n<div class=\"col-sm-6 col-md-6 denomination-input-box\">\n<div class=\"no-padding\">\n<div class=\"input-group\">\n<span class=\"input-group-addon padding5\">\n<a role=\"button\" uib-popover-template=\"denomination.template\" popover-is-open=\"denomination.isOpen\" popover-enable=\"data.remainingDenominations.length > 0\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\">\n<img ng-src=\"assets/images/{{denomination.icon}}.png\" class=\"img-currency\"/>\n</a>\n</span>\n<input id=\"denomBox-{{$index+1}}\" class=\"form-control\" type=\"text\" ng-model=\"denomination.inputValue\" ng-class=\"{'invalid-amount' : !$ctrl.denominationData[$parent.$index].denominations[$index].isValid, \n                                                           'ng-valid' : $ctrl.denominationData[$parent.$index].denominations[$index].isValid || denomination.inputValue}\" placeholder=\"{{ denomination.coinFlag ? ('checkin.coinUnit' | translate) : ('checkin.amount' | translate) }}\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.validateAmount($parent.$index, $index, denomination.ledgerDenomBalance, denomination.inputValue, denomination.faceValue, denomination.coinFlag);\" ng-disabled=\"$ctrl.isLoadingPackPreview\" ng-currency=\"{{!denomination.coinFlag}}\" style=\"z-index: 0;\" currency-symbol=\"{{denomination.symbol || $ctrl.currencySymbol}}\" fraction=\"0\" required>\n</div>\n</div>\n<span class=\"col-sm-2 col-md-2 text-right denomination-box-width\">\n<button class=\"btn btn-xs btn-danger btn-icon\" uib-tooltip=\"Close\" ng-click=\"$ctrl.removeDenomination($parent.$index, $index, denomination.balance)\" ng-disabled=\"$ctrl.isLoadingPackPreview\" tooltip-append-to-body=\"true\">\n<i class=\"glyphicon glyphicon-remove\"></i>\n</button>\n</span>\n\n</div>\n</div>\n<div class=\"pull-left\">\n<button class=\"btn btn-xs btn-success btn-icon\" ng-class=\"{'add-btn-margin-7' : data.denominations.length > 0 }\" uib-tooltip=\"Add\" ng-click=\"$ctrl.addDenomination($index)\" tooltip-append-to-body=\"true\" ng-disabled=\"!data.remainingDenominations.length || $ctrl.model.ledgerData.totalAmount === 0 || $ctrl.isLoadingPackPreview\">\n<i class=\"glyphicon glyphicon-plus\"></i>\n</button>\n</div>\n</td>\n<td class=\"common-width-15\">{{data.totalAmount | currency:$ctrl.currencySymbol:2}}</td>\n<td class=\"col-width-10\">\n<button class=\"btn btn-success btn-sm\" type=\"button\" ng-click=\"$ctrl.addRow()\" ng-if=\"$index === $ctrl.denominationData.length - 1 && !$ctrl.packPreviewError && !$ctrl.isWarning\">\n<i class=\"glyphicon glyphicon-plus\"></i>\n</button>\n<button class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"$ctrl.removeRow($index)\" ng-if=\"$ctrl.denominationData.length > 1\">\n<i class=\"glyphicon glyphicon-trash\"></i>\n</button>\n<button class=\"btn btn-info btn-sm\" type=\"button\" ng-click=\"$ctrl.printPackedDepositLabel(data)\" ng-disabled=\"Form.$invalid\" ng-if=\"(data.trackingId && data.denominations.length) || ($ctrl.model.fundingSourceId && $ctrl.model.fundingSourceId.residualDeposit)\">\n<span class=\"glyphicon glyphicon-print\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 text-right remove-pad\" ng-class=\"$ctrl.isTableScrollable() ? 'margin-top-20-imp' : 'margin-top-10-imp'\" style=\"margin-bottom: 20px !important;\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.adHocPack()\" ng-disabled=\"Form.$invalid || $ctrl.adHocPackLoader || $ctrl.validatePackAllButton() || $ctrl.isLoadingPackPreview || $ctrl.isLimitExceed || $ctrl.packEmergencyDeposit || !$ctrl.deliveryLocations || !$ctrl.deliveryLocations.length || !$ctrl.model.deliveryLocation || !$ctrl.model.routeId || !$ctrl.model.deliveryDate\">\n{{'atm_deposit_packing.pack' | translate}}\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.adHocPackLoader}\"></i>\n</button>\n</div>\n<div class=\"margin-top-10\" ng-if=\"$ctrl.isWarning\">\n<div class=\"alert alert-danger text-align-center\" ng-repeat=\"warning in $ctrl.model.adHocPackPreviewData.warnings\">\n{{warning}}\n</div>\n</div>\n<div class=\"margin-top-10\" ng-if=\"$ctrl.packPreviewError\">\n<div class=\"alert alert-danger text-align-center\">\n{{$ctrl.packPreviewError}}\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-top-10\" ng-if=\"!$ctrl.model.ledgerData.results.length && !$ctrl.isLoading && $ctrl.isValidate() \n                                              && $ctrl.model.stats === $ctrl.stats.pending\">\n<div class=\"alert alert-danger text-align-center\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</div>\n<div class=\"margin-top-20\" ng-if=\"($ctrl.model.fundingSourceId) && (($ctrl.isResidualDeposit() && $ctrl.isManualDeposit()) || (!$ctrl.isResidualDeposit() && !$ctrl.isManualDeposit()))\">\n<div class=\"alert alert-danger text-align-center\">{{'atm_deposit_packing.error' | translate}}</div>\n</div>\n</form>\n";
var id3="deposit_packing.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id3,v3);}
else{ngModule.run(["$templateCache",function(c){c.put(id3,v3)}]);}
module.exports=v3;

/***/ }),
/* 2724 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\" style=\"text-align: center;\">\n<div class=\"text-align-center font-size-70 margin-top-40\" ng-if=\"$ctrl.loading || $ctrl.pendingPackLoader\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!$ctrl.loading || !$ctrl.pendingPackLoader\">\n<div>\n<div class=\"align-center-horizontally\">\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<div id=\"print-section\">\n<div class=\"col-sm-12 text-align-left margin-top-40\">\n<div class=\"col-sm-4 col-print-4 pull-left\">\n<div>\n{{'atm_deposit_packing.fromLocation' | translate}}:\n</div>\n<div>\n<span class=\"margin-zero data-font-size\">\n<strong>{{ $ctrl.setupFromLocation.name }}</strong>\n</span>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4 pull-center\">\n<div>\n{{'atm_deposit_packing.toLocation' | translate}}:\n</div>\n<div>\n<span class=\"margin-zero data-font-size\">\n<strong>{{$ctrl.toLocation.Key}}</strong>\n</span>\n</div>\n</div>\n<div class=\"col-sm-4 col-print-4 text-align-right\" ng-if=\"$ctrl.carrier\">\n<div class=\"text-align-right\">\n{{'atm_deposit_packing.carrier' | translate}}\n</div>\n<div class=\"text-align-right\">\n<span class=\"margin-zero data-font-size\">\n<strong>{{$ctrl.carrier.Key}}</strong>\n</span>\n</div>\n</div>\n</div>\n<br><br><br><br><br><br>\n<div class=\"col-sm-12 deposit-date-align\">\n<span class=\"pull-right\">\n{{'atm_deposit_packing.depositDate' | translate}}:\n<spna ng-if=\"!$ctrl.contents.depositDate\">\n<strong>{{$ctrl.date | date: 'longDate'}}</strong>\n</spna>\n<spna ng-if=\"$ctrl.contents.depositDate\">\n<strong>{{ $ctrl.contents.depositDate | date : 'yyyy-MM-dd | hh:mm a'}}</strong>\n</spna>\n</span>\n</div>\n<div class=\"col-sm-12 margin-top-20\" ng-if=\"$ctrl.manifestData.account === 'regular' && $ctrl.toLocation.residualDeposit\">\n<table class=\"table table-bordered\">\n<thead>\n<tr>\n<td>\n<strong>#</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.location' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.trackingId' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.type' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.denom' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.totalDeposit' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.verify' | translate}}</strong>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.contents.records track by $index\">\n<td>{{$index+1}}</td>\n<td>{{data.locationId}} | {{data.locationName}}</td>\n<td>{{data.trackingId}}</td>\n<td>Cash</td>\n<td>{{data.denominationId}}</td>\n<td>{{data.amount| currency:(data.currencySymbol || $ctrl.currencySymbol):2}}</td>\n<td>&nbsp;</td>\n</tr>\n<tr class=\"deposit-text-align-left\">\n<td colspan=\"15\">\n<h4 style=\"width: 100%\"><strong>{{'atm_deposit_packing.totalDepositAmount' | translate}}</strong><span style=\"float: right; padding-right: 100px\">\n<strong>{{$ctrl.totalDenomAmount| currency:($ctrl.contents.records[0].currencySymbol || $ctrl.currencySymbol):2}}</strong></span></h4>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 margin-top-20\" ng-if=\"($ctrl.manifestData.account === 'emergency' && !$ctrl.manifestData.printEmergencyPackData) || ($ctrl.toLocation.manualDeposit && !$ctrl.manifestData.printEmergencyPackData)\">\n<table class=\"table table-bordered\">\n<thead>\n<tr>\n<td>\n<strong>#</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.trackingId' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.type' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.released_date' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.totalDeposit' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.verify' | translate}}</strong>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>1</td>\n<td>{{$ctrl.manifestData.trackingId}}</td>\n<td>Cash</td>\n<td>{{$ctrl.manifestData.releasedAt | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n<td>{{$ctrl.manifestData.totalAmount | currency:$ctrl.currencySymbol:2}}</td>\n<td>&nbsp;</td>\n</tr>\n<tr ng-if=\"$ctrl.manifestData.denominations && $ctrl.manifestData.denominations.length > 0\">\n<td colspan=\"6\">\n<table class=\"table table-bordered table-condensed\" style=\"margin-bottom: 0;\">\n<thead>\n<tr class=\"text-center\">\n<th class=\"text-center\"><strong>Denomination</strong></th>\n<th class=\"text-center\"><strong>Face Value</strong></th>\n<th class=\"text-center\"><strong>Quantity</strong></th>\n<th class=\"text-center\"><strong>Amount</strong></th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"denomination in $ctrl.manifestData.denominations track by $index\">\n<td>\n{{denomination.denominationName || denomination.denominationId}}\n</td>\n<td>{{denomination.denominationFaceValue || denomination.faceValue | currency:(denomination.symbol || $ctrl.currencySymbol):2}}</td>\n<td>{{denomination.change || denomination.quantity || 0}}</td>\n<td>{{denomination.amount | currency:(denomination.symbol || $ctrl.currencySymbol):2}}</td>\n</tr>\n</tbody>\n</table>\n</td>\n</tr>\n<tr class=\"deposit-text-align-left\">\n<td colspan=\"15\">\n<h4 style=\"width: 100%\"><strong>{{'atm_deposit_packing.totalDepositAmount' | translate}}</strong><span style=\"float: right; padding-right: 100px\">\n<strong>{{$ctrl.manifestData.totalAmount | currency:$ctrl.currencySymbol:2}}</strong></span></h4>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 margin-top-20\" ng-if=\"($ctrl.manifestData && $ctrl.manifestData.account === 'emergency' && $ctrl.manifestData.printEmergencyPackData)\">\n<table class=\"table table-bordered\">\n<thead>\n<tr>\n<td>\n<strong>#</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.trackingId' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.type' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.packed_date' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.totalDeposit' | translate}}</strong>\n</td>\n<td>\n<strong>{{'atm_deposit_packing.verify' | translate}}</strong>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.pendingReleaseData.records track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{data.trackingId}}</td>\n<td>Cash</td>\n<td>{{data.createdAt | date : 'MM-dd-yyyy | hh:mm a'}}</td>\n<td>{{data.totalAmount | currency:$ctrl.currencySymbol:2}}</td>\n<td>&nbsp;</td>\n</tr>\n<tr class=\"deposit-text-align-left\">\n<td colspan=\"15\">\n<h4 style=\"width: 100%\"><strong>{{'atm_deposit_packing.totalDepositAmount' | translate}}</strong><span style=\"float: right; padding-right: 100px\">\n<strong>{{$ctrl.totalDenomAmount | currency:$ctrl.currencySymbol:2}}</strong></span>\n</h4>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"main-div\">\n<div class=\"deposit-authorization\">\n<h4 class=\"deposit-content\">{{'atm_deposit_packing.authorization' | translate}}</h4>\n</div>\n<div class=\"deposit-context\">\n<h4 class=\"deposit-content full-name\">{{'atm_deposit_packing.fullName' | translate}}</h4>\n<span class=\"deposit-text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"deposit-content lable-position\">{{'atm_deposit_packing.sign' | translate}}</h4>\n<span class=\"deposit-text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"deposit-content lable-position deposit-authorization-date\">{{'atm_deposit_packing.date' | translate}}</h4>\n<span class=\"deposit-text-align-left lineColor\">_________________________________________________</span>\n</div>\n</div>\n<div class=\"main-div\">\n<div class=\"authorization-context deposit-authorization\">\n<h4 class=\"deposit-content\">{{'atm_deposit_packing.received' | translate}}</h4>\n</div>\n<div class=\"deposit-context margin-top-20\">\n<h4 class=\"deposit-content full-name\">{{'atm_deposit_packing.fullName' | translate}}</h4>\n<span class=\"deposit-text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"deposit-content lable-position\">{{'atm_deposit_packing.sign' | translate}}</h4>\n<span class=\"deposit-text-align-left lineColor\">_________________________________________________</span>\n<h4 class=\"deposit-content lable-position deposit-authorization-date\">{{'atm_deposit_packing.date' | translate}}</h4>\n<span class=\"deposit-text-align-left lineColor\">_________________________________________________</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="print_deposit_packing.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2725 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row forgot-password-ui\">\n<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"margin: auto;vertical-align: middle;top: 10rem;\">\n<div class=\"forgot-form-ui\">\n<div class=\"comapany_logo\">\n<center>\n<img stream-company-logo class=\"img-responsive\">\n</center>\n</div>\n<div class=\"page-title\">\n<span ng-if=\"$ctrl.name == 'forgotPassword'\" translate=\"{{ $ctrl.isForceChangePassword ? 'login.change_password_label' : 'login.forgot_password_label' }}\"></span>\n<span ng-if=\"$ctrl.name == 'resetPassword'\" translate=\"login.reset_password_label\"></span>\n</div>\n<div class=\"forgot_form\">\n<form class=\"form well account-login-form\" name=\"form\" ng-submit=\"submitForgotPWD(form)\" novalidate ng-if=\"$ctrl.name == 'forgotPassword'\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label translate=\"login.email\"></label>\n<input type=\"email\" autocomplete=\"off\" name=\"email\" class=\"form-control\" placeholder=\"{{'login.forgot_email_placeholder' | translate }}\" ng-model=\"$ctrl.userCredentials.email\" required>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.error\">\n<div class=\"col-sm-12\">\n<p style=\"color: red; font-weight: bold; text-align: center;\">{{$ctrl.error}}</p>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex justify-space-between align-items-center\">\n<div>\n<a ui-sref=\"login\">\n<i class=\"glyphicon glyphicon-chevron-left\"></i>\n<span>{{'login' | translate}}</span>\n</a>\n</div>\n<button class=\"btn btn-primary btn-lg\" ng-disabled=\"!form.$valid || $ctrl.isForgotLoading\" ng-click=\"$ctrl.submitForgotPWD(form)\" type=\"submit\">\n<span> {{'Submit' | translate}} </span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.isForgotLoading}\"></span>\n</button>\n</div>\n</div>\n</form>\n<form class=\"form well account-login-form\" name=\"resetForm\" ng-submit=\"resetPassword(resetForm)\" novalidate ng-if=\"$ctrl.name == 'resetPassword'\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label translate=\"login.email\"></label>\n<input type=\"text\" autocomplete=\"off\" name=\"email\" class=\"form-control\" placeholder=\"{{ 'forgot_email_placeholder' | translate }}\" ng-model=\"$ctrl.resetCredentials.email\" required ng-disabled=\"true\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label translate=\"login.code\"></label>\n<input type=\"text\" autocomplete=\"one-time-code\" name=\"code\" class=\"form-control\" placeholder=\"{{ 'login.reset_code_placeholder' | translate }}\" ng-model=\"$ctrl.resetCredentials.code\" required>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label translate=\"login.password\"></label>\n<input type=\"{{ $ctrl.togglePassword.pass  ? 'text' : 'password'}}\" autocomplete=\"off\" name=\"password\" class=\"form-control\" placeholder=\"{{ 'login.password_placeholder' | translate }}\" ng-model=\"$ctrl.resetCredentials.password\" ng-change=\"$ctrl.checkPasswordPolicy()\" required>\n<div class=\"password-icon\" ng-click=\"$ctrl.showPassword('pass')\">\n<span class=\"glyphicon\" ng-class=\"$ctrl.togglePassword.pass ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></span>\n</div>\n<span ng-if=\"$ctrl.errors.password\" class=\"text-danger\">{{$ctrl.errors['password']}}</span>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label translate=\"login.confirm_password\"></label>\n<input type=\"{{ $ctrl.togglePassword.cpass  ? 'text' : 'password'}}\" autocomplete=\"off\" name=\"cpassword\" class=\"form-control\" placeholder=\"{{ 'login.confirm_password_placeholder' | translate }}\" ng-model=\"$ctrl.resetCredentials.cpassword\" required>\n<div class=\"password-icon\" ng-if=\"!$ctrl.modelDetails.isWebPassword\" ng-click=\"$ctrl.showPassword('cpass')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.togglePassword.cpass ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n<span ng-show=\"$ctrl.resetCredentials.password!=$ctrl.resetCredentials.cpassword\" class=\"text-danger\">password mismatch</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad alert alert-info remove-margin-bottom text-align-center\" ng-if=\"$ctrl.model.passwordPolicy.isForceChangePassword && $ctrl.model.passwordPolicy.isCurrentPassSameAsPrevious\">\n<span id=\"forceChangePasswordDays\" translate=\"login.duplicate_password_warning\">\n</span>\n</div>\n<div class=\"col-sm-12 remove-pad alert alert-danger remove-margin-bottom\" ng-if=\"$ctrl.model.passwordPolicy && $ctrl.model.passwordPolicy.filterErrors.length > 0\" ng-class=\"{'margin-top-10': $ctrl.model.passwordPolicy.isForceChangePassword && $ctrl.model.passwordPolicy.isCurrentPassSameAsPrevious}\">\n<ul>\n<li ng-repeat=\"error in $ctrl.model.passwordPolicy.filterErrors\">\n{{error.message}}\n</li>\n</ul>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.error || $ctrl.successMsg\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.error\">\n<p style=\"color: red; font-weight: bold; text-align: center;\">{{$ctrl.error}}</p>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.successMsg\">\n<p style=\"color: green; font-weight: bold; text-align: center;\">{{$ctrl.successMsg}}</p>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 d-flex justify-space-between align-items-center margin-10\">\n<div>\n<a ui-sref=\"login\">\n<i class=\"glyphicon glyphicon-chevron-left\"></i>\n<span>{{'login' | translate}}</span>\n</a>\n</div>\n<button class=\"btn btn-primary btn-lg\" ng-disabled=\"!resetForm.$valid || $ctrl.isResetLoading  || !$ctrl.resetCredentials.password || !$ctrl.resetCredentials.cpassword || ($ctrl.resetCredentials.password !== $ctrl.resetCredentials.cpassword)\" ng-click=\"$ctrl.resetPassword(resetForm)\" type=\"submit\">\n<span> {{'Submit' | translate}} </span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.isResetLoading}\"></span>\n</button>\n</div>\n</div>\n</form>\n</div>\n</div>\n</div>\n</div>\n";
var id1="forgot_password.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2726 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"margin-bottom-20\">\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.branch\" ng-options=\"branch for branch in $ctrl.branches\" ng-change=\"$ctrl.loadHolidays()\">\n<option value=\"\" selected=\"selected\">(none)</option>\n</select>\n</div>\n<button ng-show=\"::$ctrl.hasACL['create']\" type=\"button\" ng-click=\"$ctrl.addHoliday()\" class=\"btn btn-primary\">{{'holiday.addHoliday' | translate}}</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-12 remove-pad\" class=\"full-calendar\">\n<div ui-calendar=\"$ctrl.uiConfig.calendar\" class=\"span8 calendar\" ng-model=\"$ctrl.holidays\"></div>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad\" ng-if=\"$ctrl.loading\">\n<div class=\"col-sm-12 text-align-center\">\n<span class=\"font-size-70 glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n</div>\n</div>";
var id1="holiday.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2727 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form action=\"\" name=\"holidayForm\" class=\"form-validate\" novalidate>\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'holiday.'+titleKey | translate}}</h4>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<label for=\"\">{{'holiday.branch' | translate}} *</label>\n<div class=\"form-group\">\n<div class=\"multi-select\" ng-class=\"{\n                            'disabled': isInEditMode,\n                            'invalid-multi-select-value': !model.branch || !model.branch.length,\n                            'valid-multi-select-value': model.branch && model.branch.length\n                        }\" isteven-multi-select max-labels=\"3\" input-model=\"branches\" output-model=\"model.branch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-6\">\n<label for=\"\">{{'holiday.title' | translate}} *</label>\n<div class=\"form-group\">\n<input type=\"text\" ng-model=\"model.name\" class=\"form-control\" required>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<label for=\"\">{{'holiday.startDate' | translate}} *</label>\n<div class=\"_form-group\">\n<datetimepicker class=\"datetimepicker-input\" ng-class=\"{'required-datetimepicker': !model.startDate}\" ng-model=\"model.startDate\" date-format=\"dd-MMM-yyyy\" date-options=\"todayMinDate\" ng-click=\"isDisabledDate(date, mode)\" hidden-time=\"true\" show-button-bar=\"false\"/>\n</div>\n</div>\n<div class=\"col-sm-6\">\n<label for=\"\">{{'holiday.endDate' | translate}} *</label>\n<div class=\"_form-group\">\n<datetimepicker class=\"datetimepicker-input\" ng-class=\"{'required-datetimepicker': !model.endDate}\" ng-model=\"model.endDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"effectiveMinDate\"/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-primary\" ng-class=\"{\n                'disabled': loading || \n                    (isInEditMode && !acl.edit) || \n                    (!isInEditMode && !acl.create) || \n                    holidayForm.$invalid || \n                    !model.branch || !model.branch.length ||\n                    !model.startDate || \n                    !model.endDate\n            }\" ng-click=\"save()\">\n{{ 'common.save' | translate }}\n</button>\n<button class=\"btn btn-default\" ng-class=\"{'disabled': loading}\" type=\"button\" ng-click=\"cancel()\">{{ 'common.cancel' | translate }}</button>\n</div>\n</form>\n";
var id1="holiday-form.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2728 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"home-date-state-section\">\n<div class=\"col-sm-7 dashboard-title remove-left-pad\">\n<h3>{{ 'dashboard.states' | translate }}</h3>\n<div class=\"btn-group dashboard-grp-btn\">\n<button type=\"button\" class=\"btn btn-default\" ng-class=\"{'btn-default': $ctrl.tabShow !== 'numbers', 'btn-primary': $ctrl.tabShow === 'numbers'}\" ng-click=\"$ctrl.dashboarShow('numbers');\">\n<span class=\"glyphicon glyphicon-sd-video\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-class=\"{'btn-default': $ctrl.tabShow !== 'chart', 'btn-primary': $ctrl.tabShow === 'chart'}\" ng-click=\"$ctrl.dashboarShow('chart')\">\n<span class=\"glyphicon glyphicon-stats\"></span>\n</button>\n</div>\n<div class=\"btn-group dashboard-grp-btn\">\n<button ng-if=\"!$ctrl.loading\" type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.$onInit()\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n<button ng-if=\"$ctrl.loading\" type=\"button\" class=\"btn btn-default\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-5 text-right remove-pad\">\n<div class=\"btn-group dashboard-grp-btn\" style=\"margin-top: 2px;\">\n<h3>{{ 'dashboard.vaultDate' | translate }} : {{ $ctrl.vaultDate | date: 'yyyy-MM-dd' }}</h3>\n</div>\n<div class=\"btn-group div-calender\">\n<span class=\"calenderIcon\" ng-click=\"$ctrl.openDatePicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></span>\n<div uib-datepicker-popup ng-model=\"$ctrl.vaultDate\" datepicker-options=\"$ctrl.options\" is-open=\"$ctrl.datePopupIsOpened\" ng-change=\"$ctrl.isDateChanged($ctrl.vaultDate, mode)\" show-button-bar=\"false\"></div>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.tabShow == 'numbers'\">\n<div class=\"margin-left-right--10px_\">\n<div class=\"col-6 col-sm-6 col-lg-4\" ng-repeat=\"countObj in $ctrl.dashboardCount track by $index\" ng-if=\"countObj.aclPermission\">\n<div class=\"card\">\n<div class=\"day-badge row_\">\n<div class=\"day-badge card-body col-auto\">\n<div ng-if=\"countObj.hasCurrency && $ctrl.previousDays[countObj.key]\"> {{$ctrl.previousDays[countObj.key] | currency }}</div>\n<div ng-if=\"!countObj.hasCurrency || !$ctrl.previousDays[countObj.key]\"> {{$ctrl.previousDays[countObj.key] | currency:'':0}}</div>\n</div>\n</div>\n<div class=\"card-body p-3 text-center\">\n<div class=\"h1 m-0\" ng-class=\"{'badge-danger': countObj.itemCount < $ctrl.previousDays[countObj.key], 'badge-success': countObj.itemCount > $ctrl.previousDays[countObj.key]}\">\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-arrow-down': countObj.itemCount < $ctrl.previousDays[countObj.key], \n\t\t\t\t\t\t\t\t\t   'glyphicon-arrow-up': countObj.itemCount > $ctrl.previousDays[countObj.key]}\"></span>\n<span ng-if=\"countObj.hasCurrency && countObj.itemCount\"> {{countObj.itemCount | currency }}</span>\n<span ng-if=\"!countObj.hasCurrency || !countObj.itemCount\"> {{countObj.itemCount | currency:'':0}}</span>\n<span class=\"text-success\" ng-if=\"countObj.key === 'activeAppUsers'\"> {{countObj.itemCount.totalUser}}</span>\n<span ng-if=\"countObj.key === 'serviceTickets'\">\n<span class=\"text-success\" uib-tooltip=\"{{'common.total' | translate}}\">{{countObj.itemCount.totalServiceTickets}}</span>\n<span ng-if=\"countObj.itemCount.totalServiceTickets > 0\" class=\"text-success\" uib-tooltip=\"{{'common.completed' | translate}}\"> | {{countObj.itemCount.completedTickets}}</span>\n<span ng-if=\"countObj.itemCount.totalServiceTickets > 0\" class=\"text-danger\" uib-tooltip=\"{{'common.cancelled' | translate}}\"> | {{countObj.itemCount.cancelledTickets}}</span>\n</span>\n<span ng-if=\"countObj.key === 'routeRunTime'\">\n<span class=\"text-success\" uib-tooltip=\"{{'common.total' | translate}}\">{{countObj.itemCount.total}}</span>\n<span class=\"text-success\" uib-tooltip=\"{{'dashboard.min_route_process_time' | translate}}\" ng-if=\"countObj.itemCount.total > 0\"> | {{countObj.itemCount.minRouteProcessTime}}</span>\n<span class=\"text-danger\" uib-tooltip=\"{{'dashboard.max_route_process_time' | translate}}\" ng-if=\"countObj.itemCount.total > 0\"> | {{countObj.itemCount.maxRouteProcessTime}}</span>\n</span>\n</div>\n<div class=\"text-muted mb-4\">{{ countObj.label }}</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div ng-show=\"$ctrl.tabShow == 'chart'\">\n<div class=\"col-6 col-sm-6 col-lg-4\" ng-repeat=\"graphItem in $ctrl.graphItems track by $index\" ng-if=\"graphItem.aclPermission && graphItem.key !== 'routeRunTime' && graphItem.key !== 'serviceTickets' && graphItem.key !== 'activeAppUsers'\n\t\t\t\t   \t\t  && graphItem.key !== 'countedResidualsAmount' && graphItem.key !== 'cashDepositedAmount'\">\n<div class=\"card\">\n<div class=\"card-body p-3 text-center\">\n<div ng-show=\"$ctrl.dailtStatsDataOrNot\">\n<div class=\"col-sm-12 align-center-horizontally\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': $ctrl.dailtStatsDataOrNot}\" style=\"text-align: center; width:100%\">\n<span>{{ 'error.noDataAvailable' | translate }}</span>\n</div>\n</div>\n</div>\n<div class=\"m-0\">\n<div class=\"britechart js-loading-container-{{graphItem.key}} card--chart\"></div>\n<div class=\"britechart js-line-chart-container-{{graphItem.key}} card--chart\"></div>\n</div>\n<div class=\"text-muted mb-4\"> {{graphItem.label }} </div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.aclPermission.shipment_batch.length || $ctrl.aclPermission.route_control.length\">\n<div class=\"row_\">\n<div class=\"col-sm-4 remove-left-pad\" ng-if=\"$ctrl.aclPermission.route_control.length\">\n<h3>{{ 'dashboard.scheduled_route' | translate }}</h3>\n<div ng-if=\"$ctrl.routeSchedule.length\" class=\"table-wrap\">\n<table class=\"table table-bordered table-hover table-striped font-12\">\n<thead>\n<tr class=\"header-row\">\n<th>{{ 'dashboard.routeId' | translate }}</th>\n<th>{{ 'dashboard.scheduled_date' | translate }}</th>\n</tr>\n</thead>\n<tbody class=\"scroll-content\">\n<tr ng-repeat=\"routeSchedule in $ctrl.routeSchedule\">\n<td>{{routeSchedule.routeId}}</td>\n<td>{{routeSchedule.routeDate}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"!$ctrl.routeSchedule.length\">\n<div class=\"row_ col-sm-12_ align-center-horizontally no-padding remove-right-padding\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': !$ctrl.routeSchedule.length}\" style=\"text-align: center; width:100%\">\n<span>{{ 'dashboard.no_routes_scheduled' | translate }}</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 text-left remove-tbl-padding\" ng-if=\"$ctrl.aclPermission.shipment_batch.length\">\n<h3>{{ 'dashboard.pending_batch' | translate }}</h3>\n<div ng-if=\"$ctrl.uploadedFileList.length\" class=\"table-wrap\">\n<table class=\"table table-bordered table-hover font-12\">\n<thead>\n<tr class=\"header-row\">\n<th>#</th>\n<th>{{ 'dashboard.files' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"batchFile in $ctrl.uploadedFileList track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{batchFile}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"!$ctrl.uploadedFileList.length\">\n<div class=\"row_ col-sm-12_ align-center-horizontally remove-right-padding\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': !$ctrl.uploadedFileList.length}\" style=\"text-align: center; width:100%\">\n<span>{{ 'dashboard.no_batches' | translate }}</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4 text-left remove-right-pad\">\n<h3>{{ 'dashboard.routes_in_progress' | translate }}</h3>\n<div ng-if=\"$ctrl.routeProgressDetails.length\" class=\"table-wrap\">\n<table class=\"table table-bordered table-hover table-striped font-12\">\n<thead>\n<tr class=\"header-row\">\n<th>{{ 'dashboard.route_id' | translate }}</th>\n<th>{{ 'dashboard.total_stops' | translate }}</th>\n<th>{{ 'dashboard.completed_stops' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.routeProgressDetails track by $index\">\n<td>{{data.routeId}}</td>\n<td>{{data.totalRouteStops}}</td>\n<td>{{data.totalCompletedStops}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"!$ctrl.routeProgressDetails.length\">\n<div class=\"col-sm-12 align-center-horizontally no-padding remove-right-padding\">\n<div class=\"alert errLblPos\" ng-class=\"{'alert-danger': !$ctrl.routeProgressDetails.length}\" style=\"text-align: center; width:100%\">\n<span>{{ 'common.no_data_found' | translate }}</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad_\" ng-if=\"$ctrl.aclPermission['setting-log'].length\">\n<div class=\"row\">\n<div class=\"col-sm-6 remove-left-pad\">\n<h3>{{'dashboard.recent_activity' | translate}}</h3>\n</div>\n<div class=\"col-md-auto remove-right-pad pull-right entry-type\">\n<select class=\"form-control\" ng-options=\"entryType.value as entryType.label for entryType in $ctrl.entryTypes | orderBy:'label'\" ng-model=\"$ctrl.entryType\" ng-change=\"$ctrl.recentActivities()\" ng-disabled=\"$ctrl.model.gettingRecentLogs\">\n<option value=\"\">({{'common.All' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.model.gettingRecentLogs\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 40px\"></span>\n</div>\n<div class=\"row\" ng-if=\"!$ctrl.model.gettingRecentLogs\">\n<div class=\"panel-box panel-group list-group recent-activity-block_ remove-top-margin\" id=\"accordion\">\n<div class=\"panel panel-default\" ng-repeat=\"log in $ctrl.logs track by $index\">\n<div class=\"panel-heading cust-panel-color\" data-toggle=\"collapse\" data-target=\"#{{log.logId}}\" aria-expanded=\"false\" aria-controls=\"{{log.logId}}\">\n<h4 class=\"panel-title cursor-pointer\">\n<a class=\"accordion-toggle\">\n<strong>{{log.readableEntryType + ' '}} </strong> <span ng-if=\"log.userId\">{{'log.by' | translate}}</span> {{' ' + log.performedByName}}\n<span class=\"pull-right\">{{$ctrl.moment(log.createdAt).fromNow()}}</span>\n</a>\n</h4>\n</div>\n<div id=\"{{log.logId}}\" class=\"panel-collapse collapse multi-collapse\">\n<div class=\"panel-body\">\n<table class=\"table table-bordered table-striped remove-pad-bottom font-12\">\n<tr ng-repeat=\"detail in log.extraDetails\">\n<td>{{detail.key}}</td>\n<td class=\"wrap-text\">{{detail.value}}</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"text-center\" style=\"padding:0 0 5px 0\" ;><small>Track and Trace <code>{{$ctrl.applicationVersion}}</code></small></div>\n</div>\n</div>\n</div>";
var id1="home.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2729 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad items-list-view-section\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-offset-3 col-sm-6 font-size-20 text-center\">\n<b>{{'item.all_items' | translate}}</b>\n<hr class=\"hr-line\">\n</div>\n</div>\n<div class=\"col-sm-12 _cash-variances-search-section remove-left-pad remove-right-pad\">\n<div class=\"status-count-section margin-top-03 col-sm-8 btn-group remove-left-pad\">\n<button id=\"assigned\" type=\"button\" class=\"btn\" ng-class=\"{'btn-default': $ctrl.selectedItemStatus !== 'assigned', 'btn-primary': $ctrl.selectedItemStatus === 'assigned'}\" ng-click=\"$ctrl.filterRecords('assigned')\">\n<b>{{'checkout.assigned' | translate}}</b>\n<span class=\"badge assigned-item-badge\">{{$ctrl.totalAssigned}}</span>\n</button>\n<button id=\"available\" type=\"button\" class=\"btn\" ng-class=\"{'btn-default': $ctrl.selectedItemStatus !== 'available', 'btn-primary': $ctrl.selectedItemStatus === 'available'}\" ng-click=\"$ctrl.filterRecords('available')\">\n<b>{{'shipment.available' | translate}}</b>\n<span class=\"badge available-item-badge\">{{$ctrl.totalAvailable}}</span>\n</button>\n<button id=\"checkedOut\" type=\"button\" class=\"btn\" ng-class=\"{'btn-default': $ctrl.selectedItemStatus !== 'checkedOut', 'btn-primary': $ctrl.selectedItemStatus === 'checkedOut'}\" ng-click=\"$ctrl.filterRecords('checkedOut')\">\n<b>{{'checkout.checked_out' | translate}}</b>\n<span class=\"badge checked-out-item-badge\">{{$ctrl.totalCheckout}}</span>\n</button>\n<button id=\"hold\" type=\"button\" class=\"btn\" ng-class=\"{'btn-default': $ctrl.selectedItemStatus !== 'hold', 'btn-primary': $ctrl.selectedItemStatus === 'hold'}\" ng-click=\"$ctrl.filterRecords('hold')\">\n<b>{{'itemHolds.holdDateTime' | translate}}</b>\n<span class=\"badge hold-item-badge\">{{$ctrl.totalHold}}</span>\n</button>\n<button id=\"lost\" type=\"button\" class=\"btn\" ng-class=\"{'btn-default': $ctrl.selectedItemStatus !== 'lost', 'btn-primary': $ctrl.selectedItemStatus === 'lost'}\" ng-click=\"$ctrl.filterRecords('lost')\">\n<b>{{'shipment.lost' | translate}}</b>\n<span class=\"badge lost-item-badge\">{{$ctrl.totalLost}}</span>\n</button>\n<button id=\"deleted\" type=\"button\" class=\"btn\" ng-class=\"{'btn-default': $ctrl.selectedItemStatus !== 'deleted', 'btn-primary': $ctrl.selectedItemStatus === 'deleted'}\" ng-click=\"$ctrl.filterRecords('deleted')\">\n<b>{{'shipment.deleted' | translate}}</b>\n<span class=\"badge lost-item-badge\">{{$ctrl.totalDeleted}}</span>\n</button>\n</div>\n<div class=\"col-sm-4 remove-pad filter-section\">\n<div class=\"search-box-width\">\n<input ng-change=\"$ctrl.filterItemView()\" type=\"text\" ng-model-options=\"{debounce: 1000}\" placeholder=\"Search\" class=\"input-lg form-control\" ng-model=\"$ctrl.model.itemsObj.searchText\" id=\"itemsSearchText\" ng-disabled=\"$ctrl.model.itemsObj.loading\">\n</div>\n<div class=\"_col-sm-1 margin-top-05\">\n<button type=\"button\" class=\"btn btn-md btn-success\" ng-click=\"$ctrl.filterItemView()\" ng-disabled=\"$ctrl.model.itemsObj.loading\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<hr class=\"logistic-item-line-section\">\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-top-10\">\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.itemsObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<table class=\"table table-striped table-bordered table-pad-5\" ng-if=\"$ctrl.model.itemsObj.results.length && !$ctrl.model.itemsObj.loading\">\n<thead class=\"text-center\">\n<tr class=\"_header-row\">\n<td><strong>{{'atm_residual.trackingId' | translate}}</strong></td>\n<td ng-click=\"$ctrl.sortData('label')\">\n<strong>{{'itemType.type' | translate}}</strong>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.reverseSort, 'active' : $ctrl.model.sortColumn === 'label'}\"></span>\n</td>\n<td ng-click=\"$ctrl.sortData('status')\">\n<strong>{{'atm_codes_mgmt.status' | translate}}</strong>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.reverseSort, 'active' : $ctrl.model.sortColumn === 'status'}\"></span>\n</td>\n<td><strong>{{'item.expirationDate' | translate}}</strong></td>\n<td><strong>{{'common.notes' | translate}}</strong></td>\n<td> <strong>{{'branch_mgmt.orders_action' | translate}}</strong> </td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in $ctrl.model.itemsObj.results track by $index\">\n<td>{{data.barcode}}</td>\n<td>{{data.label}}</td>\n<td>\n<span ng-class=\"{\n\t\t\t\t\t\t\t'available': data.status === 'available',\n\t\t\t\t\t\t\t'hold': data.status === 'hold',\n\t\t\t\t\t\t\t'checked-out': data.status === 'checkedOut',\n\t\t\t\t\t\t\t'deleted': data.status === 'deleted',\n\t\t\t\t\t\t\t'lost': data.status === 'lost'\n\t\t\t\t\t\t\t}\">\n{{$ctrl.translateStatus(data.status)}}\n</span>\n<span ng-class=\"{\n\t\t\t\t\t\t\t'available': data.status === 'available',\n\t\t\t\t\t\t\t'hold': data.status === 'hold',\n\t\t\t\t\t\t\t'checked-out': data.status === 'checkedOut',\n\t\t\t\t\t\t\t'deleted': data.status === 'deleted',\n\t\t\t\t\t\t\t'lost': data.status === 'lost'\n\t\t\t\t\t\t\t}\" ng-if=\"data.routeId && data.status !== 'available' && data.status !== 'lost'\"> | {{data.routeName}} </span>\n<span ng-if=\"data.userKey && data.status !== 'available' && data.status !== 'lost'\">\n| <a href=\"#\" ng-click=\"$ctrl.goToUserTab(data.userKey)\">{{data.firstName}} {{data.lastName}} ( {{data.userKey}} )</a>\n</span>\n<span ng-if=\"data.assignmentCreatedAt && data.status !== 'available' && data.status !== 'lost'\"> | {{data.assignmentCreatedAt | date: 'short'}}</span>\n</td>\n<td>\n<span ng-if=\"data.expirationDate\">{{data.expirationDate | date:'yyyy-MM-dd': 'UTC'}}</span>\n<span ng-if=\"!data.expirationDate\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"data.ItemNotes\">{{data.AssignmentNotes || data.ItemNotes}}</span>\n<span ng-if=\"!data.ItemNotes\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"remove-white-space\">\n<button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"$ctrl.itemHistory(data)\" uib-tooltip=\"{{'branch_mgmt.item_title' | translate}}\">\n<span class=\"glyphicon glyphicon-align-justify\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.editItems(data)\" uib-tooltip=\"{{'common.Edit' | translate}}\" ng-if=\"$ctrl.hasACL['edit']\" ng-hide=\"data.status === 'lost' || data.status === 'deleted'\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.logisticItemAssign(data)\" uib-tooltip=\"{{'common.assign' | translate}}\" ng-if=\"(!data.userKey && !data.routeId && !data.deleted) || data.status === 'available'\" ng-disabled=\"$ctrl.model.isAssign\">\n<span class=\"glyphicon glyphicon-saved\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"$ctrl.confirmItemHold(data)\" ng-if=\"!data.onHold && !data.checkedIn\" ng-hide=\"data.status === 'lost'\" ng-disabled=\"$ctrl.model.isSendToHold\">\n<span class=\"glyphicon glyphicon-header\" uib-tooltip=\"{{'shipment.hold' | translate}}\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"$ctrl.confirmItemHoldRelease(data)\" ng-if=\"data.onHold && !data.lost && !data.deleted\" ng-disabled=\"$ctrl.model.isReleasingFromHold\">\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"{{'shipment.HOLD_RELEASE' | translate}}\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.confirmItemDelete(data)\" ng-if=\"$ctrl.hasACL['delete'] && !data.lost && !data.deleted && data.status !== 'assigned' && data.status !== 'checkedOut'\" ng-disabled=\"$ctrl.model.isDeleting\">\n<span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"{{'common.Delete' | translate}}\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.confirmItemCheckIn(data)\" ng-hide=\"data.status === 'lost'\" ng-if=\"!data.checkedIn && (data.routeId || data.userKey) && !data.onHold && !data.deleted\" ng-disabled=\"$ctrl.model.isCheckIn\">\n<span class=\"glyphicon glyphicon-check\" uib-tooltip=\"{{'common.side_menu.check_in' | translate}}\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.logisticItemReAssign(data)\" ng-hide=\"data.status === 'lost'\" ng-if=\"data.checkedIn && (data.routeId || data.userKey) && !data.onHold && !data.deleted && data.status !== 'available'\" ng-disabled=\"$ctrl.model.isReAssigning\">\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"{{'item.reassign_item' | translate}}\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.confirmUndoItemAssignment(data)\" ng-hide=\"data.status === 'lost'\" ng-if=\"data.checkedIn && (data.routeId || data.userKey) && !data.onHold && !data.deleted && data.status !== 'available'\" ng-disabled=\"$ctrl.model.isReAssigning || $ctrl.model.undoItemAssignment\">\n<span class=\"glyphicon glyphicon-remove\" uib-tooltip=\"{{'item.cancel_item_assignment' | translate}}\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.confirmItemLost(data)\" ng-if=\"data.onHold && !data.lost && !data.deleted\" ng-disabled=\"$ctrl.model.isLost\">\n<span class=\"glyphicon glyphicon-remove-circle\" uib-tooltip=\"{{'shipment.lost' | translate}}\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.confirmItemReturnToAvailable(data)\" ng-if=\"data.lost && !data.deleted\" ng-disabled=\"$ctrl.model.isReturnAvailable\">\n<span class=\"glyphicon glyphicon-refresh\" uib-tooltip=\"{{'item.return_to_available' | translate}}\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 _margin-10 remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.model.itemsObj.loading && !$ctrl.model.itemsObj.results.length\">\n<span class=\"col-sm-12 alert alert-danger text-align-center\">\n{{'route_sheet.no_data_found' | translate}}\n</span>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.itemsObj.pagination.total > 10 && !$ctrl.model.itemsObj.loading\">\n<ul uib-pagination total-items=\"$ctrl.model.itemsObj.pagination.total\" ng-hide=\"{{($ctrl.model.itemsObj.pagination.total<=$ctrl.model.itemsObj.pagination.pageLimit)&&($ctrl.model.itemsObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.itemsObj.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n</div>";
var id1="item.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2730 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 _remove-pad\">\n<h4 translate=\"item.create_item\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12 _remove-pad settings-item-section\">\n<form ng-submit=\"$ctrl.submit(this)\" name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6\">\n<label>{{'itemType.type' | translate }} *</label>\n<search-and-select ng-model=\"$ctrl.model.itemTypeId\" set-id=\"itemType\" values=\"$ctrl.itemTypeList\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" onscroll=\"$ctrl.loadItemTypes(searchKey, offset)\" none-selected=\"'common.none'\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6\">\n<label>{{'addBagModal.trackingId' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required ng-model=\"$ctrl.model.barcode\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad margin-top-10\">\n<div class=\"col-sm-6 margin-top-10\">\n<label>{{'item.reference' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.reference\">\n</div>\n<div class=\"col-sm-6 margin-top-10\">\n<label>{{'item.expirationDate' | translate }} </label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.expirationDate\" date-format=\"dd-MMM-yyyy\" ng-class=\"{'datetimepicker': !$ctrl.model.expirationDate, 'disabled': $ctrl.loading}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" date-options=\"$ctrl.model.maxDate\"/>\n</div>\n</div>\n<div class=\"col-sm-12 _margin-top-10\">\n<div class=\"col-sm-12 remove-pad\">\n<label for=\"status\">{{'routeStats.notes' | translate }}</label> <br/>\n<textarea rows=\"2\" class=\"form-control\" ng-model=\"$ctrl.model.notes\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-10\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.validateForm()\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"reset\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>";
var id1="item.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2731 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<h4 translate=\"item.edit_item\"></h4>\n<hr/>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.gettingItems\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad settings-item-section\" ng-if=\"!$ctrl.model.gettingItems\">\n<form ng-submit=\"$ctrl.submit(this)\" name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6\">\n<label>{{'itemType.type' | translate }} *</label>\n<search-and-select ng-model=\"$ctrl.model.itemTypeId\" values=\"$ctrl.itemTypeList\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" is-edit=\"true\" onscroll=\"$ctrl.loadItemTypes(searchKey, offset)\" none-selected=\"'common.none'\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6\">\n<label>{{'addBagModal.trackingId' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required disabled=\"disabled\" ng-model=\"$ctrl.model.barcode\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad margin-top-10\">\n<div class=\"col-sm-6 margin-top-10\">\n<label>{{'item.reference' | translate }} </label>\n<input type=\"text\" class=\"form-control\" disabled=\"disabled\" ng-model=\"$ctrl.model.reference\">\n</div>\n<div class=\"col-sm-6 margin-top-10\">\n<label>{{'item.expirationDate' | translate }} </label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.expirationDate\" date-format=\"dd-MMM-yyyy\" ng-class=\"{'datetimepicker': !$ctrl.model.expirationDate, 'disabled': $ctrl.loading}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" date-options=\"$ctrl.maxDate\"/>\n</div>\n</div>\n<div class=\"col-sm-12 _margin-top-10\">\n<div class=\"col-sm-12 remove-pad\">\n<label for=\"status\">{{'routeStats.notes' | translate }}</label> <br/>\n<textarea rows=\"2\" class=\"form-control\" ng-model=\"$ctrl.model.notes\"></textarea>\n</div>\n</div>\n<div class=\"margin-bottom-10 col-sm-12 margin-10\" ng-if=\"$ctrl.errorMessage\">\n<span class=\"col-sm-12 alert alert-danger remove-bottom-margin\">\n{{$ctrl.errorMessage}}\n</span>\n</div>\n<div class=\"col-sm-12\" ng-class=\"{'margin-top-10' : !$ctrl.errorMessage}\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.validateForm() || $ctrl.model.loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.model.loading}\"></span>\n{{'common.update' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>";
var id1="item.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2732 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"items.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"item.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"items.create\">\n<a translate=\"item.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="item.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2733 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-12 item-history-spinner-section\" ng-if=\"!$ctrl.loadCompanyLogo\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-print-12 col-sm-12\" ng-if=\"$ctrl.loadCompanyLogo\">\n<div class=\"col-sm-12 margin-top-20 print-logistic-item-header-section\">\n<div class=\"col-sm-6 col-print-6 remove-padding\" ng-if=\"$ctrl.loadCompanyLogo\">\n<img stream-print-logo class=\"print-logo-height-80\">\n</div>\n<div class=\"col-sm-6 remove-right-pad col-print-6 remove-right-pad text-align-right margin-top-20 font-size-20\">\n<strong>{{ 'branch_mgmt.itemhistory.title' | translate }}</strong>\n<span>| {{$ctrl.model.itemHistoryObj.label}}</span>\n</div>\n</div>\n<div class=\"col-sm-12 col-print-12 margin-top-10 remove-padding\">\n<table class=\"table table-hover table-striped table-bordered\">\n<thead>\n<tr>\n<th class=\"_text-center\">{{'common.entry_type' | translate }}</th>\n<th class=\"_text-center\">{{'common.created' | translate}}</th>\n<th class=\"_text-center\">{{'branch_mgmt.performed_by' | translate}}</th>\n<th class=\"_text-center\">{{'bagout.branch' | translate}}</th>\n<th class=\"_text-center\">{{'dashboard.routeId' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"data in $ctrl.model.itemHistoryObj.results\">\n<td>{{$ctrl.translateItemHistoryMsg(data.entryType)}}</td>\n<td class=\"remove-white-space\">{{data.createdAt | date: 'MM-dd-yyyy | hh:mm a' }}</td>\n<td>{{data.createdByUserId}} | {{data.firstName}} {{data.lastName}}</td>\n<td>{{data.branchId}}</td>\n<td>\n<span ng-if=\"data.routeId\">{{data.routeId}}</span>\n<span ng-if=\"!data.routeId\">{{'common.n_a' | translate}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>";
var id1="item_history.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2734 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"_col-sm-12\">\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'itemType.menu.all' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.model.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.ItemTypeObj.loading\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.ItemTypeObj.totalRecords > 0 && !$ctrl.model.ItemTypeObj.loading\">\n<ul class=\"remove-bottom-pad list-group\">\n<li class=\"list-group-item\" ng-repeat=\"category in $ctrl.model.ItemTypeObj.categoryList track by $index\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{category.label}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\"></div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.editItemType(category)\" uib-tooltip=\"{{ 'common.Edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<div class=\"col-sm-12 remove-left-pad margin-10\">\n<ul class=\"margin-10\" uib-pagination total-items=\"$ctrl.model.ItemTypeObj.totalRecords\" ng-hide=\"{{($ctrl.model.ItemTypeObj.totalRecords<=$ctrl.model.pagination.pageLimit)&&($ctrl.model.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 text-align-center alert alert-danger\" ng-if=\"($ctrl.model.ItemTypeObj.totalRecords === 0 && !$ctrl.model.ItemTypeObj.loading)\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>";
var id1="item_type.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2735 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"itemType.menu.create\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"name\">{{'common.name' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.label\" ng-pattern=\"/^[a-zA-Z0-9 -]*$/\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || Form.$invalid || $ctrl.model.loading\">\n<span ng-if=\"$ctrl.model.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || $ctrl.model.loading\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</div>\n</form>\n</div>";
var id1="item_type.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2736 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"itemType.menu.edit\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6\">\n<label for=\"categoryId\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"categoryId\" placeholder=\"\" disabled=\"disabled\" ng-model=\"$ctrl.model.id\" ng-pattern=\"/^[a-zA-Z0-9 -]*$/\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"name\">{{'common.name' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.label\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"button\" ng-click=\"$ctrl.update(this)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || Form.$invalid || $ctrl.model.isCreate\">\n<span ng-if=\"$ctrl.model.isCreate\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || $ctrl.model.isCreate\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</div>\n</form>\n</div>";
var id1="item_type.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2737 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"items-type.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"itemType.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"items-type.create\">\n<a translate=\"itemType.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="item_type.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2738 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 location-header-part remove-right-pad remove-left-pad\">\n<div class=\"col-sm-3 margin-top-05 remove-right-pad remove-left-pad\">\n<span class=\"font-size-18 pad-right-04\">{{'location.all_locations' | translate}}</span>\n<span ng-if=\"!$ctrl.loading\" class=\"badge active-location-badge cursor-pointer\" uib-tooltip=\"{{'common.active' | translate}}\" tooltip-placement=\"top-left\">{{$ctrl.totalActiveLocation}}</span>\n<span ng-if=\"!$ctrl.loading\" class=\"badge in-active-location-badge cursor-pointer\" uib-tooltip=\"{{'common.inactive' | translate}}\" tooltip-placement=\"top-left\">{{$ctrl.totalInActiveLocation}}</span>\n<span ng-if=\"!$ctrl.loading\">\n<button id=\"filter-by\" type=\"button\" class=\"btn btn-xs\" ng-class=\"{'btn-default': $ctrl.filterByValue !== 'all', 'btn-success': $ctrl.filterByValue === 'all'}\" ng-click=\"$ctrl.filterByBranch('all')\">\n{{'common.All' | translate}}\n</button>\n</span>\n<span ng-if=\"$ctrl.loading\" class=\"font-size-18 glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"location-filter-section\">\n<div class=\"_location-search\">\n<input type=\"text\" ng-model=\"$ctrl.searchObj.text\" class=\"form-control\" search-autofocus ng-keydown=\"$event.keyCode === 13 && $ctrl.search()\" placeholder=\"{{ 'common.search' | translate }}\">\n</div>\n<div class=\"_location-btn-group\">\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'location.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</div>\n<div class=\"_loc-search\">\n<select class=\"form-control\" ng-model=\"$ctrl.searchObj.type\" ng-options=\"locationType.value as locationType.label for locationType in  $ctrl.locationTypes\" ng-change=\"$ctrl.search()\"></select>\n</div>\n<div class=\"_loc-search\">\n<select class=\"form-control\" ng-model=\"$ctrl.searchObj.status\" ng-options=\"status.value as status.label for status in  $ctrl.locationStatus\" ng-change=\"$ctrl.search()\"></select>\n</div>\n<div class=\"_loc-btn-export\" ng-if=\"$ctrl.locations && $ctrl.locations.length\">\n<button type=\"button\" class=\"btn btn-md btn-success\" ng-click=\"$ctrl.exportData()\" ng-disabled=\"$ctrl.isExporting || $ctrl.loading\">\n{{ 'common.export' | translate }}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isExporting\"></span>\n</button>\n</div>\n<div class=\"_padding-left-10\" ng-if=\"$ctrl.selectedLocations.length\">\n<button type=\"button\" class=\"btn btn-md btn-success\" ng-click=\"$ctrl.printLocationBarcodes()\" ng-disabled=\"$ctrl.loading\">\n{{ 'routeSheet.print' | translate }}\n</button>\n</div>\n<div class=\"_padding-left-10\" ng-if=\"!$ctrl.model.filterByAllBranch && $ctrl.maintainDriveDistance && $ctrl.isAllowToBulkUpdateLocationDistance()\">\n<button type=\"button\" class=\"btn btn-md btn-success\" ng-click=\"$ctrl.bulkUpdateLocationDistance()\" ng-disabled=\"$ctrl.isBulkUpdateLocationDistance || $ctrl.loading\" uib-tooltip=\"Update Location Distance\" tooltip-placement=\"top-right\">\n<span class=\"glyphicon glyphicon-refresh\" ng-if=\"!$ctrl.isBulkUpdateLocationDistance\"></span>\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isBulkUpdateLocationDistance\"></span>\n</button>\n</div>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\" class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div ng-if=\"$ctrl.locations && $ctrl.locations.length\">\n<ul class=\"list-group location-change-history\">\n<li class=\"list-group-item\" ng-repeat-start=\"location in $ctrl.locations track by location.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"padding-left-10 location-print-barcode-selection\">\n<input type=\"checkbox\" ng-click=\"$ctrl.selectLocations(location, $event)\" ng-model=\"location.isSelected\">\n</div>\n<div class=\"padding-left-10\">\n<button id=\"expand-btn-{{location.id}}\" class=\"btn btn-xs btn-secondary\" ng-click=\"location.expanded = !location.expanded; $ctrl.setPage(location.expanded, location.id);\n\t\t\t\t\t\t\t\t\t\t  $ctrl.getLocationUpdateHistory(location.expanded, location.id);\" expand>\n<span ng-if=\"location.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!location.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</div>\n<div class=\"col-sm-4\">\n<img ng-src=\"{{$ctrl.loadImage(location.locationType)}} \" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"\"/>\n<span class=\"list-group-item-text\">\n{{location.id}} | {{location.name}}\n</span>\n</div>\n<div class=\"col-sm-6\">\n<span class=\"list-group-item-text\">\n{{location.formattedAddress}}\n</span>\n<span ng-if=\"location.keyNum\">\n| {{location.keyNum}}\n</span>\n</div>\n<div class=\"col-sm-2\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div ng-if=\"location.expanded\" class=\"icon-padding-05 btn-group\">\n<span class=\"badge badge-light future-location-changes-badge\" uib-tooltip=\"{{'location.pending_changes' | translate}}\" tooltip-placement=\"top-right\">{{$ctrl.pendingLocationChanges[location.id].details.total}}</span>\n<span class=\"badge badge-light location-history-badge\">{{$ctrl.locationUpdateHistory[location.id].details.total}}</span>\n</div>\n<div ng-if=\"location.totalPendingChanges && !location.expanded\" class=\"icon-padding-05 btn-group\">\n<span class=\"badge badge-light future-location-changes-badge\" uib-tooltip=\"{{'location.pending_changes' | translate}}\" tooltip-placement=\"top-right\">\n{{location.totalPendingChanges}}\n</span>\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.edit(location)\" uib-tooltip=\"{{ 'location.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n<div ng-repeat-end ng-if=\"location.expanded\">\n<div class=\"_margin-10\">\n<table class=\"table-pad-3 table table-condensed table-bordered inner-tbl-margin-bottom\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.locationHistory[location.id].process\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</div>\n<div class=\"location-history-alert-section\" ng-if=\"!$ctrl.locationHistory[location.id].process && \n\t\t\t\t\t\t\t\t \t\t(!$ctrl.pendingLocationChanges[location.id].details.results.pendingChanges.length && !$ctrl.locationUpdateHistory[location.id].details.results.length)\">\n<div class=\"col-sm-12 alert alert-danger text-center remove-bottom-margin\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<tbody ng-if=\"!$ctrl.locationHistory[location.id].process &&\n\t\t\t\t\t\t\t\t   ($ctrl.pendingLocationChanges[location.id].details.results.pendingChanges.length || $ctrl.locationUpdateHistory[location.id].details.results.length)\">\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'routeSheet.date' | translate}}</th>\n<th class=\"text-center\">{{'location.change_type' | translate}}</th>\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n<th class=\"text-center\">{{'users.user' | translate}}</th>\n</tr>\n<tr class=\"future-location-changes-bg-color\" ng-repeat=\"history in $ctrl.pendingLocationChanges[location.id].details.results.pendingChanges track by $index\" ng-if=\"$ctrl.pendingLocationChanges[location.id].details.results.pendingChanges.length\">\n<td class=\"text-center\">{{history.executeAt | date: 'MM-dd-yyyy | hh:mm a'}}</td>\n<td class=\"text-danger text-center\">{{$ctrl.translateMessage(history.key)}}</td>\n<td class=\"text-center\">\n<span ng-if=\"history.previous.length\" ng-repeat=\"previousChanges in history.previous\">\n<div>{{previousChanges}}<span ng-if=\"$index + 1 !== history.previous.length\">,</span></div>\n</span>\n<span ng-if=\"!history.previous.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"history.changed.length\" ng-repeat=\"changedChanges in history.changed\">\n<div>{{changedChanges}}<span ng-if=\"$index + 1 !== history.changed.length\">,</span></div>\n</span>\n<span ng-if=\"!history.changed.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">{{history.user}}</td>\n</tr>\n<tr ng-repeat=\"history in $ctrl.locationUpdateHistory[location.id].details.results track by $index\" ng-if=\"$ctrl.locationUpdateHistory[location.id].details.results.length\">\n<td class=\"text-center\">{{history.createdAt | date: 'MM-dd-yyyy | hh:mm a'}}</td>\n<td class=\"text-danger text-center\">{{history.entryData.key}}</td>\n<td class=\"text-center\" ng-if=\"!$ctrl.isArray(history.entryData.previous)\">\n<span ng-if=\"history.entryData.previous\">{{history.entryData.previous}}</span>\n<span ng-if=\"!history.entryData.previous\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.isArray(history.entryData.previous)\">\n<span ng-if=\"history.entryData.previous.length\" ng-repeat=\"previousChanges in history.entryData.previous\">\n<div>{{previousChanges}}<span ng-if=\"$index + 1 !== history.entryData.previous.length\">,</span></div>\n</span>\n<span ng-if=\"!history.entryData.previous.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\" ng-if=\"!$ctrl.isArray(history.entryData.changed)\">\n<span ng-if=\"history.entryData.changed\">{{history.entryData.changed}}</span>\n<span ng-if=\"!history.entryData.changed\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.isArray(history.entryData.changed)\">\n<span ng-if=\"history.entryData.changed.length\" ng-repeat=\"changedChanges in history.entryData.changed\">\n<div>{{changedChanges}}<span ng-if=\"$index + 1 !== history.entryData.changed.length\">,</span></div>\n</span>\n<span ng-if=\"!history.entryData.changed.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">{{history.user}}</td>\n</tr>\n</tbody>\n<tfoot ng-if=\"!$ctrl.locationHistory[location.id].process && $ctrl.locationUpdateHistory[location.id].details.results.length\n\t\t\t\t\t\t\t\t          && $ctrl.locationUpdateHistory[location.id].details.total>$ctrl.locationUpdateHistory[location.id].details.pageLimit\">\n<tr>\n<td class=\"location-history-pagination-section\" colspan=\"5\">\n<ul ng-model=\"$ctrl.locationHistory[location.id].page\" uib-pagination total-items=\"$ctrl.locationUpdateHistory[location.id].details.total\" ng-hide=\"{{($ctrl.locationUpdateHistory[location.id].details.total<=$ctrl.locationUpdateHistory[location.id].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.getLocationUpdateHistory(location.expanded, location.id)\" max-size=\"10\"></ul>\n</td>\n</tr>\n</tfoot>\n</table>\n</div>\n</div>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" force-ellipses=\"true\" max-size=\"$ctrl.maxPages\" ng-hide=\"(($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1))\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\">\n</ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.locations || !$ctrl.locations.length) && !$ctrl.loading\">\n<span>{{'location.noLocations' | translate}}</span>\n<ul uib-pagination total-items=\"$ctrl.total\" force-ellipses=\"true\" max-size=\"$ctrl.maxPages\" ng-hide=\"(($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1))\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\">\n</ul>\n</div>\n</div>";
var id1="location.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2739 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row_ align-center-vertically\">\n<div class=\"col-sm-10\">\n<h4 translate=\"location.clone_location\"></h4>\n</div>\n</div>\n<hr class=\"margin-15\"/>\n<div class=\"location-clone-form\">\n<form name=\"cloneForm\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12\">\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"sourceLocation\">{{'location.select_source_location' | translate}}\n<span class=\"text-danger\">*</span></label>\n<search-and-select ng-model=\"$ctrl.sourceLocationSelected\" set-id=\"sourceLocation\" values=\"$ctrl.sourceLocationSearchConfig.results\" key=\"Key\" totalrecords=\"$ctrl.sourceLocationSearchConfig.totalRecords\" onscroll=\"$ctrl.searchSourceLocations(searchKey, offset)\" on-click=\"$ctrl.onSourceLocationSelected()\" none-selected=\"'common.select'\" required>\n</search-and-select>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.sourceLocation\">\n<div class=\"col-sm-6\">\n<div class=\"panel panel-default location-clone-source-details\">\n<div class=\"panel-heading\">\n<strong translate=\"location.source_location_details\"></strong>\n</div>\n<div class=\"panel-body\">\n<p>\n<strong translate=\"location.location_type\"></strong>: {{$ctrl.getSourceLocationType()}}\n</p>\n<p>\n<strong translate=\"location.branches\"></strong>: {{$ctrl.getSourceLocationBranches()}}\n</p>\n<p>\n<strong translate=\"location.funding_source\"></strong>: {{$ctrl.getSourceLocationFundingSource()}}\n</p>\n<p>\n<strong translate=\"location.stop_process\"></strong>: {{$ctrl.getSourceLocationStopProcess()}}\n</p>\n<p>\n<strong translate=\"location.route_like_regular\"></strong>: {{$ctrl.getSourceLocationRouteLikeRegular()}}\n</p>\n</div>\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"panel panel-default location-clone-source-details\">\n<div class=\"panel-heading\">\n<strong translate=\"location.clone_options\"></strong>\n</div>\n<div class=\"panel-body\">\n<div class=\"checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"$ctrl.cloneOptions.branches\" ng-change=\"$ctrl.toggleCloneOption('branches')\"/>\n<strong translate=\"location.clone_branches\"></strong>\n</label>\n</div>\n<div class=\"checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"$ctrl.cloneOptions.lockSetup\" ng-change=\"$ctrl.toggleCloneOption('lockSetup')\"/>\n<strong translate=\"location.clone_lock_setup\"></strong>\n</label>\n</div>\n<div class=\"checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"$ctrl.cloneOptions.denominations\" ng-change=\"$ctrl.toggleCloneOption('denominations')\"/>\n<strong translate=\"location.clone_denominations\"></strong>\n</label>\n</div>\n<div class=\"checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"$ctrl.cloneOptions.deliverToLocations\" ng-change=\"$ctrl.toggleCloneOption('deliverToLocations')\"/>\n<strong translate=\"location.clone_deliver_to_locations\"></strong>\n</label>\n</div>\n<div class=\"checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"$ctrl.cloneOptions.hoursOfOperation\" ng-change=\"$ctrl.toggleCloneOption('hoursOfOperation')\"/>\n<strong translate=\"location.clone_hours_of_operation\"></strong>\n</label>\n</div>\n<div class=\"checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"$ctrl.cloneOptions.weeklyRoutes\" ng-change=\"$ctrl.toggleCloneOption('weeklyRoutes')\"/>\n<strong translate=\"location.clone_weekly_routes\"></strong>\n</label>\n</div>\n<div class=\"checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"$ctrl.cloneOptions.recurringRoutes\" ng-change=\"$ctrl.toggleCloneOption('recurringRoutes')\"/>\n<strong translate=\"location.clone_recurring_routes\"></strong>\n</label>\n</div>\n<div class=\"checkbox\">\n<label>\n<input type=\"checkbox\" ng-model=\"$ctrl.cloneOptions.scheduledLoadAmounts\" ng-change=\"$ctrl.toggleCloneOption('scheduledLoadAmounts')\"/>\n<strong translate=\"location.clone_scheduled_load_amounts\"></strong>\n</label>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.sourceLocation\">\n<div class=\"col-sm-12\">\n<h4 translate=\"location.new_locations\"></h4>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.sourceLocation\">\n<div class=\"col-sm-12\">\n<div class=\"table-responsive location-clone-table\">\n<table class=\"table table-bordered table-striped\">\n<thead>\n<tr>\n<th translate=\"location.id\"></th>\n<th translate=\"location.name\"></th>\n<th translate=\"location.address\"></th>\n<th translate=\"location.city\"></th>\n<th translate=\"location.state\"></th>\n<th translate=\"location.zip\"></th>\n<th ng-if=\"$ctrl.shouldShowBranchColumn()\" translate=\"location.branch\"></th>\n<th>{{'common.action' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"location in $ctrl.getNewLocationsArray() track by location.key\">\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newLocations[location.key].id\" ng-class=\"{'has-error': location.errors.id}\" required/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newLocations[location.key].name\" ng-class=\"{'has-error': location.errors.name}\" required/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newLocations[location.key].address\" ng-class=\"{'has-error': location.errors.address}\" required/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newLocations[location.key].city\" ng-class=\"{'has-error': location.errors.city}\" required/>\n</td>\n<td>\n<div>\n<span class=\"pull-right\" style=\"margin-bottom: 5px;\">\n<span><b>Non US</b></span>\n<input type=\"checkbox\" ng-model=\"$ctrl.newLocations[location.key].isNonUSLocation\" ng-change=\"$ctrl.onNonUSToggle(location.key)\"/>\n</span>\n<div ng-show=\"!$ctrl.newLocations[location.key].isNonUSLocation\">\n<select class=\"form-control\" ng-model=\"$ctrl.newLocations[location.key].state\" ng-options=\"state.value as state.label for state in $ctrl.states\" ng-class=\"{'has-error': location.errors.state}\" required>\n<option value=\"\">(select)</option>\n</select>\n</div>\n<div ng-show=\"$ctrl.newLocations[location.key].isNonUSLocation\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newLocations[location.key].state\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-class=\"{'has-error': location.errors.state}\" required placeholder=\"State\"/>\n<input type=\"text\" class=\"form-control\" style=\"margin-top: 5px;\" ng-model=\"$ctrl.newLocations[location.key].country\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-class=\"{'has-error': location.errors.country}\" ng-required=\"$ctrl.newLocations[location.key].isNonUSLocation\" placeholder=\"Country\"/>\n</div>\n</div>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newLocations[location.key].zip\" ng-pattern=\"/^\\d{5,6}$/\" ng-class=\"{'has-error': location.errors.zip}\" required maxlength=\"6\"/>\n</td>\n<td ng-if=\"$ctrl.shouldShowBranchColumn()\" class=\"location-clone-branch-select\">\n<div class=\"multi-select\" ng-class=\"{\n\t\t\t\t\t\t'invalid-multi-select-value': !location.branches || location.branches.length === 0,\n\t\t\t\t\t\t'valid-multi-select-value': location.branches && location.branches.length > 0,\n\t\t\t\t\t\t'has-error': location.errors.branches\n\t\t\t\t\t\t}\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.getAvailableBranchesForRow(location.key)\" output-model=\"location.branches\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-branch-{{location.key}}\"></div>\n</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeLocationRow(location.key)\" ng-disabled=\"$ctrl.getNewLocationsCount() <= 1\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12\" style=\"padding: 0px !important;\">\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.addNewLocationRow()\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"row margin-top-20\" style=\"margin-bottom: 30px;\" ng-if=\"$ctrl.sourceLocation\">\n<div class=\"col-sm-12\">\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.submit()\" ng-disabled=\"$ctrl.isSubmitting || $ctrl.loading\">\n<span ng-if=\"$ctrl.isSubmitting || $ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</span>\n<span ng-if=\"!$ctrl.isSubmitting && !$ctrl.loading\">\n{{'common.Create' | translate}}\n</span>\n</button>\n<button type=\"button\" class=\"btn btn-default margin-left-10\" ng-click=\"$ctrl.cancel()\" ng-disabled=\"$ctrl.isSubmitting || $ctrl.loading\">\n{{'common.cancel' | translate}}\n</button>\n</div>\n</div>\n</div>\n</form>\n</div>\n";
var id1="location.clone.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2740 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<h4 id=\"inline\"> {{ $ctrl.title | translate}}</h4>\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn\" ng-disabled=\"$ctrl.model.branch.length == 0\" ng-click=\"$ctrl.addDeliverLocationOption()\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"row div-tr\">\n<div class=\"col-sm-3 div-td\">\n<div class=\"dt\">\n<strong>{{ 'shiptype.shiptype' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-3 col-width-32 div-td\">\n<div class=\"dt\">\n<strong>{{ 'common.locationId' | translate }}</strong>\n</div>\n</div>\n<div class=\"col-sm-3 col-width-18 div-td\">\n<div class=\"dt\">\n<strong>{{ 'location.immediately_deliverable' | translate }}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{ 'location.pickup_required' | translate }}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right\">\n<div class=\"dt\">\n<strong>{{'customer.actions' | translate }}</strong>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"form-group\">\n<ul dnd-list=\"$ctrl.model.deliveryToLocation\" class=\"list-group location-sequence\">\n<li ng-repeat=\"delLocationOptions in $ctrl.model.deliveryToLocation\" dnd-draggable=\"delLocationOptions\" dnd-moved=\"$ctrl.model.deliveryToLocation.splice($index, 1); {{delLocationOptions.sortOrder = $index}};\" dnd-effect-allowed=\"move\" class=\"display-flex border-bottom\">\n<input type=\"hidden\" ng-model=\"delLocationOptions.sortOrder\">\n<div class=\"col-sm-3 div-td\">\n<div class=\"dt\">\n<span ng-if=\"delLocationOptions.duplicate\" class=\"glyphicon glyphicon-warning-sign\" style=\"color: red; float: left; top: auto; left: -23px; position: absolute; margin-top: 8px;\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\"></span>\n<search-and-select ng-if=\"$ctrl.isEdit\" ng-model=\"delLocationOptions.shipTypeDetails\" values=\"delLocationOptions.allShipeType\" key=\"Key\" totalrecords=\"delLocationOptions.totalShipment\" ng-click=\"$ctrl.checkDuplicateEntry(); $ctrl.updatePickupRequirement();\" onscroll=\"$ctrl.getEditShipType(searchKey, offset, $index)\" none-selected=\"'common.none'\" required></search-and-select>\n<search-and-select ng-if=\"!$ctrl.isEdit\" ng-model=\"delLocationOptions.shipTypeDetails\" values=\"$ctrl.allShipTypes\" key=\"Key\" totalrecords=\"$ctrl.totalShipTypeRecords\" ng-click=\"$ctrl.checkDuplicateEntry(); $ctrl.updatePickupRequirement();\" onscroll=\"$ctrl.getAllShipType(searchKey, offset)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-3 col-width-32 div-td\">\n<div class=\"dt\">\n<search-and-select ng-if=\"$ctrl.isEdit\" ng-model=\"delLocationOptions.locationDetails\" values=\"delLocationOptions.allLocations\" key=\"Key\" totalrecords=\"delLocationOptions.totalLocation\" ng-click=\"$ctrl.checkDuplicateEntry(delLocationOptions, $index)\" onscroll=\"$ctrl.loadEditLocation(searchKey, offset, $index)\" none-selected=\"'common.none'\" required>\n</search-and-select>\n<search-and-select ng-if=\"!$ctrl.isEdit\" ng-model=\"delLocationOptions.locationDetails\" values=\"$ctrl.allLocations\" key=\"Key\" totalrecords=\"$ctrl.totalLocationRecords\" ng-click=\"$ctrl.checkDuplicateEntry(delLocationOptions, $index)\" onscroll=\"$ctrl.loadLocation(searchKey, offset)\" none-selected=\"'common.none'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-3 col-width-18 div-td align-center\">\n<div class=\"dt\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"delLocationOptions.individualDelivery\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-2 div-td align-center\">\n<div class=\"dt\" ng-class=\"{disabled : delLocationOptions.disablePickupRequire}\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"delLocationOptions.pickupRequired\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeDeliverLocationOption(delLocationOptions, $index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n</div>";
var id1="deliver_location.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"connection-status-container\">\n<div class=\"alert alert-danger\" ng-if=\"$ctrl.custNotSelectError\">\n{{'common.selectFirstCust' | translate}}\n</div>\n</div>\n<div class=\"row_ align-center-vertically\">\n<div class=\"col-sm-10\">\n<h4 translate=\"location.create_location\"></h4>\n</div>\n<div class=\"col-sm-2 margin-right-10 pull-right\">\n<button type=\"button\" ng-if=\"!!$ctrl.error\" class=\"close\" aria-label=\"Close\" ng-click=\"$ctrl.error()\">\n<span aria-hidden=\"true\">&times;</span>\n</button>\n</div>\n</div>\n<hr class=\"margin-15\"/>\n<div class=\"display-flex location-create-form\">\n<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<h4 translate=\"location.general\"></h4>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"name\">{{'location.name' | translate }} </label>\n<input type=\"text\" required class=\"form-control\" id=\"name\" ng-model=\"$ctrl.model.name\">\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"name\">{{'location.id' | translate }} </label>\n<input type=\"text\" class=\"form-control\" id=\"locId\" required ng-model=\"$ctrl.nextAvailableId\">\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"status\">{{'location.status' | translate }} </label> <br/>\n<div class=\"form-control dummy-form-control\">\n<input id=\"status\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"location-type\">{{'location._type' | translate }} </label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model._type\" ng-options=\"_type.value as _type.label for _type in $ctrl._types\" ng-change=\"$ctrl.changeLocationType(); $ctrl.filterStopProcess(); $ctrl.resetCombinedRoutes(); $ctrl.getFilteredDenominations();\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div id=\"inline\" class=\"col-sm-4\">\n<label for=\"customer\">{{'location.customer' | translate }}</label>\n<search-and-select ng-required=\"['REGULAR', 'ON_CALL', 'ATM', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1 && $ctrl.model.setupDetails.billingEnabled\" ng-model=\"$ctrl.model.customer\" set-id=\"customer\" values=\"$ctrl.customer\" key=\"Key\" totalrecords=\"$ctrl.totalCostomers\" onscroll=\"$ctrl.loadCustomer(searchKey, offset)\" on-click=\"$ctrl.changeCustomer()\" none-selected=\"'common.none'\">\n</search-and-select>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"\">{{ 'users.all_branches' | translate }} </label>\n<div ng-if=\"!['WINDOW', 'INTERNAL', 'TANKER'].includes($ctrl.model._type)\" class=\"multi-select location-branch-dd\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t\t\t\t'invalid-multi-select-value': !$ctrl.model.branch.length,\n\t\t\t\t\t\t\t\t\t\t\t\t'valid-multi-select-value': $ctrl.model.branch.length\n\t\t\t\t\t\t\t\t\t\t\t}\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.branch\" output-model=\"$ctrl.model.branch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.loadBranchData()\" on-reset=\"$ctrl.loadBranchData()\" on-select-all=\"$ctrl.loadBranchData()\" on-select-none=\"$ctrl.loadBranchData()\">\n</div>\n<select ng-if=\"['WINDOW', 'INTERNAL', 'TANKER'].includes($ctrl.model._type)\" class=\"form-control\" required ng-model=\"$ctrl.model.singleBranch\" ng-options=\"branch.branchId as branch.branchId for branch in $ctrl.branch\" ng-change=\"$ctrl.onSingleBranchChange()\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"branch\">{{ 'users.default_branches' | translate }} </label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.defaultBranch\" ng-options=\"branch.branchId as branch.branchId for branch in $ctrl.model.branch\" ng-change=\"$ctrl.getSetupDetails(); $ctrl.resetDataOnBranchChange(); ['ATM', 'BANK', 'DELIVERY', 'ON_CALL'].indexOf($ctrl.model._type) > -1 ? $ctrl.getAllFundingSource(searchKey, offset) : null\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"location-address\">{{'location._address' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-required=\"['TRUCK', 'INTERNAL', 'TANKER', 'WINDOW', 'LOCKER'].indexOf($ctrl.model._type) === -1\" ng-model=\"$ctrl.model._address\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"city\">{{'location._city' | translate }} </label>\n<input type=\"text\" ng-required=\"['TRUCK', 'INTERNAL', 'TANKER', 'WINDOW', 'LOCKER'].indexOf($ctrl.model._type) === -1\" class=\"form-control\" ng-model=\"$ctrl.model._city\"/>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"state\">{{'location._state' | translate }} </label>\n<span class=\"pull-right\">\n<span for=\"state\"><b>Non US</b></span>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameAll()\" ng-model=\"$ctrl.model.isNonUSLocation\" ng-click=\"$ctrl.resetText()\"/>\n</span>\n<div ng-show=\"!$ctrl.model.isNonUSLocation\">\n<select class=\"form-control\" ng-model=\"$ctrl.model._state\" ng-options=\"state.value as state.label for state in $ctrl.states\" ng-required=\"['INTERNAL', 'TRUCK', 'TANKER', 'WINDOW', 'LOCKER'].indexOf($ctrl.model._type) === -1\">\n<option value=\"\" ng-disabled=\"['TRUCK', 'INTERNAL'].indexOf($ctrl.model._type) === -1\">(select)\n</option>\n</select>\n</div>\n<div ng-show=\"$ctrl.model.isNonUSLocation\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model._state\" ng-pattern=\"/^[a-zA-Z .]*$/\" ng-required=\"$ctrl.model.isNonUSLocation\">\n</div>\n</div>\n<div class=\"form-group\" ng-class=\"{'col-sm-2': $ctrl.model.isNonUSLocation}\" ng-show=\"$ctrl.model.isNonUSLocation\">\n<label for=\"state\">{{'location.country' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.country\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-required=\"$ctrl.model.isNonUSLocation\">\n</div>\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-4': !$ctrl.model.isNonUSLocation, 'col-sm-2': $ctrl.model.isNonUSLocation}\">\n<label>{{'location._zip' | translate }} </label>\n<input ng-required=\"['TRUCK', 'INTERNAL', 'TANKER', 'WINDOW', 'LOCKER'].indexOf($ctrl.model._type) === -1\" ng-pattern=\"/^\\d{5,6}(?:-\\d{4})?$/\" type=\"text\" ng-required=\"$ctrl.model._type === -1\" class=\"form-control\" ng-model=\"$ctrl.model._zip\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location.refId' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.refId\">\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location._poc' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model._poc\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location.pocEmail' | translate }}</label>\n<input type=\"text\" ng-pattern=\"/^(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+\\s?,)*(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+)$/\" class=\"form-control\" ng-model=\"$ctrl.model.pocEmail\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location.pocPhone' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.pocPhone\" ui-us-phone-number>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 form-group _remove-pad\">\n<div class=\"_form-group\" ng-class=\"{\n\t\t\t\t\t\t\t\t'col-sm-8 _remove-pad': ['REGULAR','ON_CALL', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1, \n\t\t\t\t\t\t\t\t'col-sm-12 _remove-pad': ['REGULAR','ON_CALL', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) === -1 || !$ctrl.model._type\n\t\t\t\t\t\t\t}\">\n<label for=\"comments\">{{'location.comment' | translate }}</label>\n<textarea class=\"form-control\" rows=\"2\" id=\"comments\" ng-model=\"$ctrl.model.comments\" autocomplete=\"off\"></textarea>\n</div>\n<div class=\"_form-group col-sm-4\" ng-if=\"['REGULAR', 'ON_CALL', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1\">\n<label>{{'location.stop_priority' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.stopPriority\" ng-options=\"priority.value as priority.label for priority in $ctrl.stopPriorityList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.batch_import' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.idBatchImport\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" placeholder=\"{{'common.locationId' | translate}}\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.bagout_export' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.idBagoutExport\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" placeholder=\"{{'common.locationId' | translate}}\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.bagout_export_deposit' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.idBagoutDepositExport\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" placeholder=\"{{'common.locationId' | translate}}\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.OTC_lock' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.idOTCLock\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" placeholder=\"{{'common.locationId' | translate}}\"/>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div id=\"model\" class=\"form-group col-sm-4\" ng-if=\"$ctrl.model._type === 'ATM'\">\n<label for=\"name\">{{'truck.model' | translate }} </label>\n<input type=\"text\" class=\"form-control\" id=\"model\" ng-model=\"$ctrl.model.model\">\n</div>\n<div id=\"serialNumber\" class=\"form-group col-sm-4\" ng-if=\"$ctrl.model._type === 'ATM'\">\n<label for=\"serialNumber\">{{'serviceTickets.serialNumber' | translate }} </label>\n<input type=\"text\" class=\"form-control\" id=\"serial-number\" ng-model=\"$ctrl.model.serialNumber\">\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"['ATM'].indexOf($ctrl.model._type) > -1\">\n<label>{{'location.stop_priority' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.stopPriority\" ng-options=\"priority.value as priority.label for priority in $ctrl.stopPriorityList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" style=\"display: flex; flex-wrap: wrap;\">\n<div id=\"NFCScan\" class=\"form-group col-sm-4\">\n<label for=\"NFCScan\">{{'location.nfc_scan' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.NFCScan\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"NFCTagId\" class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.NFCScan\">\n<label class=\"remove-white-space\">{{'location.nfc_tag_id' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.NFCTagId\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" ng-required=\"$ctrl.model.NFCScan\"/>\n</div>\n<div id=\"costCenter\" class=\"form-group col-sm-4 cost-center-section\">\n<label for=\"costCenter\">{{'location.cost_center' | translate }}</label>\n<div class=\"margin-top-02\">\n<search-and-select ng-model=\"$ctrl.model.costCenter\" set-id=\"costCenter\" values=\"$ctrl.costCenterList\" key=\"Key\" totalrecords=\"$ctrl.totalCostCenter\" class=\"dd-z-index\" onscroll=\"$ctrl.loadCostCenter(searchKey, offset)\" none-selected=\"'common.none'\">\n</search-and-select>\n</div>\n</div>\n<div id=\"customerCostCenter\" class=\"form-group col-sm-4 cost-center-section\">\n<label for=\"customerCostCenter\">{{'costCenter.customer_cost_center' | translate }}</label>\n<div class=\"margin-top-02\">\n<search-and-select ng-model=\"$ctrl.model.customerCostCenter\" set-id=\"customerCostCenter\" values=\"$ctrl.customerCostCenterObj.results\" key=\"Key\" totalrecords=\"$ctrl.customerCostCenterObj.total\" class=\"dd-z-index\" onscroll=\"$ctrl.loadCustomersCostCenter(searchKey, offset)\" none-selected=\"'common.none'\">\n</search-and-select>\n</div>\n</div>\n<div id=\"locationZone\" class=\"form-group col-sm-4 location-zone-section\">\n<label for=\"locationZone\">{{'location.location_zone' | translate }}</label>\n<div class=\"margin-top-02\">\n<div class=\"multi-select valid-multi-select-value\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.locationZoneList\" output-model=\"$ctrl.model.selectedLocationZones\" button-label=\"zoneInfo\" item-label=\"label\" search-property=\"zoneInfo\" tick-property=\"ticked\" group-property=\"msGroup\" directive-id=\"location-zone-multi-select\">\n</div>\n</div>\n</div>\n<div id=\"make\" class=\"form-group col-sm-4\">\n<label for=\"make\">{{'truck.make' | translate }} </label>\n<div class=\"multi-select valid-multi-select-value location-atmmake-dd\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.atmMakesList\" output-model=\"$ctrl.model.make\" button-label=\"Key\" item-label=\"Key\" search-property=\"Key\" tick-property=\"ticked\" directive-id=\"multi-select-make\">\n</div>\n</div>\n<div id=\"preventativeMaintenance\" class=\"form-group col-sm-4\" ng-if=\"['ATM', 'ON_CALL'].includes($ctrl.model._type)\">\n<label>{{'location.preventativeMaintenance' | translate}}</label>\n<div class=\"margin-top-02\">\n<search-and-select ng-model=\"$ctrl.model.preventativeMaintenanceId\" set-id=\"preventativeMaintenance\" values=\"$ctrl.pmSearchList\" key=\"Key\" totalrecords=\"$ctrl.totalPMRecords\" onscroll=\"$ctrl.loadPreventativeMaintenances(searchKey, offset)\" class=\"dd-z-index\" none-selected=\"'common.none'\" common-search-flag=\"false\" ng-style=\"$ctrl.isPMSuspended($ctrl.model.preventativeMaintenanceId) && {'background-color': '#F9E3E3'}\">\n</search-and-select>\n</div>\n</div>\n<div id=\"accountNumber\" class=\"form-group col-sm-4\">\n<label for=\"accountNumber\">{{'location.account_no' | translate }}</label>\n<input id=\"accountNumber\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.accountNumber\" ng-pattern=\"/^[a-zA-Z0-9]*$/\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad margin-top-10\" ng-if=\"$ctrl.model._type == 'ATM' || $ctrl.model._type == 'LOCKER' || $ctrl.model._type == 'DELIVERY' || $ctrl.model._type == 'ON_CALL'\">\n<h4>{{'location.primary_lock_section' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location.lockType' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.lockType\" ng-options=\"lockType.value as lockType.label for lockType in $ctrl.lockTypes\" ng-change=\"$ctrl.resetOTCCompany();\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location.otc_company_name' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.OTCCompanyName\" ng-options=\"companyName.value as companyName.label for companyName in $ctrl.OTCCompanyNameList\" ng-disabled=\"$ctrl.model.lockType === 'static'\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.lockType === 'static'\">\n<label>{{'location.static_open_code' | translate }}</label>\n<input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.staticOpenCode\" id=\"static-open-code\" ng-attr-type=\"{{ $ctrl.passWdIcon['primary'].viewStaticOpenCode ? 'text' : 'password'}}\">\n<div class=\"password-icon\" ng-click=\"$ctrl.showPassword('primary', 'viewStaticOpenCode')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['primary'].viewStaticOpenCode ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\">\n<label for=\"OTCGeoFence\">{{'location.OTCGeoFence' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.OTCGeoFence\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\" ng-if=\"$ctrl.model.lockType !== 'static'\">\n<label for=\"closeReq\">{{'location.close_req' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.closeReq\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\" ng-if=\"$ctrl.model.stopProcess === 'L' && $ctrl.model.lockType !== 'static'\">\n<label for=\"closeEndOfStop\">{{'location.close_end_of_stop' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.closeEndOfStop\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\" ng-if=\"$ctrl.model.lockType === 'witz' || $ctrl.model.lockType === 'TDS'\">\n<label for=\"NFCLock\">{{'location.NFC_Lock' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.NFCLock\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad _order-profile-dd-z-index\" ng-if=\"['ATM', 'BANK', 'DELIVERY', 'ON_CALL', 'REGULAR', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1\">\n<h4 translate=\"location.optionalControls\"></h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"machine_owner\">{{'location.machine_owner' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"machine_owner\" ng-model=\"$ctrl.model.machineOwner\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"flm\">{{'common.FLM' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"flm\" ng-model=\"$ctrl.model.FLMProvider\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"slm\">{{'location.SLM' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"slm\" ng-model=\"$ctrl.model.SLMProvider\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"bankWeek\">{{'location.bank_week' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.bankWeek\" ng-options=\"bankWeek.value as bankWeek.label for bankWeek in $ctrl.bankWeekList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.when' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.frequencyOptions\" ng-options=\"frequency.value as frequency.label for frequency in $ctrl.frequencyList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.weekday' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.dayOfWeekOptions\" ng-options=\"weekDay.value as weekDay.label for weekDay in $ctrl.weekDayList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.first_option' | translate}}</label>\n<textarea class=\"form-control\" rows=\"2\" id=\"optional1\" ng-model=\"$ctrl.model.optional1\" autocomplete=\"off\"></textarea>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.second_option' | translate}}</label>\n<textarea class=\"form-control\" rows=\"2\" id=\"optional2\" ng-model=\"$ctrl.model.optional2\" autocomplete=\"off\"></textarea>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.third_option' | translate}}</label>\n<textarea class=\"form-control\" rows=\"2\" id=\"optional3\" ng-model=\"$ctrl.model.optional3\" autocomplete=\"off\"></textarea>\n</div>\n<div class=\"_form-group col-sm-4\">\n<label>{{'branchFundingSource.menu.title' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.bankSourceId\" values=\"$ctrl.model.fundingSourceObj.results\" key=\"Key\" class=\"order-profile-dd-z-index\" totalrecords=\"$ctrl.model.fundingSourceObj.totalRecords\" ng-disabled=\"$ctrl.model.fundingSourceObj.loading\" on-click=\"$ctrl.getAllDenominations(searchKey, offset);\" onscroll=\"$ctrl.getAllFundingSource(searchKey, offset)\" none-selected=\"'checkinSelectionModal.select'\">\n</search-and-select>\n</div>\n<div class=\"_form-group col-sm-4\">\n<label>{{'location.contract_expiration_date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"end-date\" ng-model=\"$ctrl.model.contractExpirationDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.startMaxDate\" ng-class=\"{'datetimepicker': !$ctrl.model.contractExpirationDate, 'disabled': $ctrl.loading}\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n<div class=\"_form-group col-sm-4\" ng-class=\"{'has-error': !$ctrl.isValidTargetStopTime()}\">\n<label for=\"targetStopTime\">{{'location.target_stop_time' | translate }}</label>\n<time-picker format=\"hh:mm a\" ng-model=\"$ctrl.model.targetStopTime\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n<span class=\"text-danger\" ng-if=\"!$ctrl.isValidTargetStopTime()\">Target Stop Time must be at least 1 minute</span>\n</div>\n</div>\n<div class=\"col-sm-12 toggle-grid-container\">\n<div id=\"inline\" class=\"form-group\" ng-if=\"($ctrl.model._type !== 'REGULAR')\">\n<label for=\"handleAtmLikeRegular\">{{'location.route_like_regular' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.handleAtmLikeRegular\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"ATMTransfer\" class=\"form-group\" ng-if=\"$ctrl.model._type === 'ATM' && $ctrl.model.setupDetails.ATMTransfer\">\n<label for=\"ATMTransfer\">{{'setup.atm_transfer' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.ATMTransfer\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"secondaryLock\" class=\"form-group\" ng-if=\"($ctrl.model._type === 'ATM')\">\n<label for=\"secondaryLock\">{{'location.secondary_lock' | translate}}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.secondaryLock\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group\">\n<label for=\"deliveryCutoff\">{{'location.deliveryCutoff' | translate }}</label>\n<div class=\"margin-top-02\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.deliveryCutOff\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"form-group remove-left-pad\" ng-if=\"$ctrl.model.deliveryCutOff\">\n<label for=\"routeCutoff\">{{'location.deliveryCutoffTime' | translate }}</label>\n<time-picker format=\"hh:mm a\" ng-model=\"$ctrl.model.deliveryCutOffTime\" ng-required=\"$ctrl.model.deliveryCutOff\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div class=\"form-group\" ng-if=\"['ATM', 'BANK', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'DELIVERY'].indexOf($ctrl.model._type) !== -1\">\n<label for=\"pickupSLA\">{{'location.pickup_sla' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.pickupSLA\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.model.pickupSLA && ['ATM', 'BANK', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'DELIVERY'].indexOf($ctrl.model._type) !== -1\">\n<label for=\"pickupSLATime\">{{'location.pickup_request_time' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.pickupSLATime\" ng-required=\"$ctrl.model.pickupSLA\" ng-options=\"time.requestTimeSelection as time.requestTimeSelection for time in $ctrl.pickupRequestTimes\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group\" ng-if=\"['ATM', 'BANK', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'DELIVERY'].indexOf($ctrl.model._type) !== -1\">\n<label for=\"autoRerouteMissed\">{{'location.auto_reroute_missed' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.autoRerouteMissed\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group\" ng-if=\"['ATM', 'BANK', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'DELIVERY'].indexOf($ctrl.model._type) !== -1\">\n<label for=\"monthlyCashCountLimit\" style=\"white-space: nowrap;\">Monthly Cash Count Limit</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.monthlyCashCountLimit\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.model.monthlyCashCountLimit && ['ATM', 'BANK', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'DELIVERY'].indexOf($ctrl.model._type) !== -1\">\n<label for=\"monthlyCashCountLimitAmount\" style=\"white-space: nowrap;\">Monthly Cash Count Limit Amount</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.monthlyCashCountLimitAmount\" ng-required=\"$ctrl.model.monthlyCashCountLimit\" ng-currency/>\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.model._type === 'ATM'\">\n<label for=\"packResidual\">{{'location.pack_residual' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.packResidual\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.model._type === 'ATM'\">\n<label for=\"coinPermitted\">{{'location.coin_permitted' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.coinPermitted\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"($ctrl.model._type == 'ATM' || $ctrl.model._type == 'ON_CALL') && $ctrl.model.bankSourceId.Obj.atmForecasting === true\">\n<h4>{{'location.branch_funding_source_controls' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankSourceId.Obj.atmForecasting === true\">\n<label>{{'location.foreCasting_Method' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.forecastingStrategy\" required ng-options=\"forecasting.value as forecasting.label for forecasting in $ctrl.foreCastingList\">\n<option disabled=\"disabled\" value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankSourceId.Obj.atmForecasting === true\">\n<label>{{'location.liabilityThreshold' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"liabilityThreshold\" placeholder=\"$0.00\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"$ctrl.model.liabilityThreshold\">\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankSourceId.Obj.atmForecasting === true\">\n<label>{{'location.securityThreshold' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"securityThreshold\" placeholder=\"$0.00\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"$ctrl.model.securityThreshold\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.balanceType' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.balanceType\" ng-change=\"$ctrl.onFlowThresholdBlur(); $ctrl.resetFlowThreshold()\" ng-options=\"type.value as type.label for type in $ctrl.balanceTypes\">\n<option disabled=\"disabled\" value=\"\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.forecastingFlowDirection' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.forecastingFlowDirection\" required ng-options=\"type.value as type.label for type in $ctrl.forecastingFlowDirection\">\n<option disabled=\"disabled\" value=\"\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankSourceId.Obj.atmForecasting === true\">\n<label>{{'location.flowThreshold' | translate}} *</label>\n<div class=\"input-group\" ng-if=\"$ctrl.model.balanceType !== 'PERCENTAGE'\">\n<input type=\"text\" class=\"form-control\" id=\"flowThreshold\" placeholder=\"$0.00\" ng-model=\"$ctrl.model.flowThreshold\" required ng-currency onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\"/>\n</div>\n<div class=\"input-group\" ng-if=\"$ctrl.model.balanceType === 'PERCENTAGE'\">\n<input type=\"text\" class=\"form-control\" id=\"flowThresholdPercent\" placeholder=\"0.0%\" ng-model=\"$ctrl.model.flowThreshold\" required ng-blur=\"$ctrl.onFlowThresholdBlur()\" ng-focus=\"$ctrl.onFlowThresholdFocus()\" pattern=\"^(?:100(?:\\.0{1,3})?|[0-9]{1,2}(?:\\.[0-9]{1,3})?)%?$\"/>\n</div>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankSourceId.Obj.atmForecasting === true\">\n<label>{{'location.fallbackFillRate' | translate}}</label>\n<input type=\"text\" class=\"form-control\" placeholder=\"0.0000000000\" ng-model=\"$ctrl.model.fallbackFillRate\" ng-pattern=\"/^(0(\\.\\d{0,10})?|1(\\.0{0,10})?)$/\"/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad _margin-top-10\" ng-if=\"($ctrl.model._type == 'ATM' || $ctrl.model._type == 'LOCKER') && $ctrl.model.secondaryLock\">\n<h4>{{'location.secondary_lock_section' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"name\">{{'location.secondary_lock_id' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"secondary_loc_id\" required ng-model=\"$ctrl.model.secondaryLockId\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\">\n</div>\n<div id=\"secondary_lock_type\" class=\"form-group col-sm-4\">\n<label>{{'location.lockType' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.secondaryLockType\" ng-change=\"$ctrl.resetOTCCompany();\" ng-options=\"lockType.value as lockType.label for lockType in $ctrl.lockTypes\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div id=\"secondary_lock_otc_company_name\" class=\"form-group col-sm-4\">\n<label>{{'location.otc_company_name' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.secondaryLockOTCCompanyName\" ng-disabled=\"$ctrl.model.secondaryLockType === 'static'\" ng-options=\"companyName.value as companyName.label for companyName in $ctrl.OTCCompanyNameList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div id=\"inline\" class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.secondaryLockType === 'static'\">\n<label>{{'location.static_open_code' | translate }}</label>\n<input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.secondaryLockStaticOpenCode\" id=\"static-open-code\" ng-attr-type=\"{{ $ctrl.passWdIcon['secondary'].viewStaticOpenCode ? 'text' : 'password'}}\">\n<div class=\"password-icon\" ng-click=\"$ctrl.showPassword('secondary', 'viewStaticOpenCode')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['secondary'].viewStaticOpenCode ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\" ng-hide=\"$ctrl.model.secondaryLockType === 'static'\">\n<label for=\"secondary_lock_close_req\">{{'location.close_req' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.secondaryLockCloseReq\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\" ng-hide=\"$ctrl.model.secondaryLockType === 'static'\">\n<label for=\"secondary_lock_auto_open\">{{'location.auto_open' | translate}}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.secondaryLockAutoOpen\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad location-schedule-section margin-bottom-10\" ng-if=\"$ctrl.model._type == 'ATM' || $ctrl.model._type === 'ON_CALL'\">\n<div class=\"col-sm-12\">\n<div class=\"col-sm-6 remove-left-pad\">\n<h4>{{'location.location_slots' | translate}}</h4>\n</div>\n<div class=\"col-sm-6 pull-right remove-right-pad\" ng-show=\"::$ctrl.hasACL['edit']\">\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn\" style=\"margin-right: 0 !important;\" ng-click=\"$ctrl.createLocationSlots()\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 font-12 remove-right-pad margin-top-5\" ng-if=\"$ctrl.locationSlots.length > 0\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad row div-tr loc-schedule\" style=\"width: 990px;\">\n<div class=\"col-sm-1 div-td\">\n<div class=\"dt\">\n<strong>{{'location.slot' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-5 div-td\">\n<div class=\"dt\">\n<strong>{{'location.denomination' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-5 div-td\">\n<div class=\"dt\">\n<strong>{{'location.tracking_id' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\"><strong>{{'bulkCash.action' | translate}}</strong></div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" style=\"width: 990px;\">\n<ul class=\"list-group location-sequence remove-bottom-margin\">\n<li ng-repeat=\"slot in $ctrl.locationSlots track by $index\" class=\"remove-bottom-margin display-flex border-bottom\">\n<span ng-if=\"slot.isDuplicate\" class=\"glyphicon glyphicon-warning-sign scheduled-location-alert\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\">\n</span>\n<div class=\"col-sm-1 div-td\">\n<div class=\"dt text-center\" style=\"font-weight: bold;margin-top: 8px;font-size: 14px;\">\n{{$index + 1}}\n</div>\n</div>\n<div class=\"col-sm-5 div-td order-profile-dd-z-index\">\n<div class=\"dt\">\n<search-and-select ng-model=\"slot.denominationId\" values=\"$ctrl.model.locationSlotDenominations.results\" key=\"Key\" totalrecords=\"$ctrl.model.locationSlotDenominations.totalRecords\" none-selected=\"'common.none'\" common-search-flag=\"true\" long-dd-width-flag=\"true\" ng-click=\"$ctrl.validateDenominationSelected(); $ctrl.createLocationRecurringLoad(); $ctrl.checkDenomKeyExists()\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-5 div-td\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" ng-model=\"slot.slotTrackingId\" ng-pattern=\"/^[a-z A-Z 0-9]*$/\" ng-change=\"$ctrl.validateLocationSlotsDuplicate()\">\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.deleteLocationSlotsSelected($index)\">\n<span class=\"glyphicon glyphicon-remove\" uib-tooltip=\"{{'batch.tooltip_del' | translate }}\" tooltip-placement=\"top\"></span>\n</button>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 remove-bottom-margin margin-top-10\" ng-if=\"$ctrl.locationSlots.length === 0\">\n<div class=\"alert alert-info\">\nNo location slots configured\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.model._type == 'ATM'\">\n<div class=\"col-sm-12 remove-left-pad\">\n<h4 id=\"inline\" translate=\"location.dispense_strategy\"></h4>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label>{{'location.atm_empty_calculation_method' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.atmEmptyAtCalculationMethod\" required ng-options=\"atmEmptyAtCalculationMethod.value as atmEmptyAtCalculationMethod.label for atmEmptyAtCalculationMethod in $ctrl.atmEmptyAtCalculationMethodList\">\n<option disabled=\"disabled\" value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'PERCENT_CHANGE'\">\n<label>{{'location.aec_percent_change_value' | translate}}</label>\n<input type=\"text\" ng-model=\"$ctrl.model.aecPercentChangeValue\" id=\"aecPercentChangeValue\" class=\"form-control\" pattern=\"^(?:0*(?:\\.\\d+)?|1(\\.0*)?)(%)?$\" ng-blur=\"$ctrl.ngPercentage()\" ng-focus=\"$ctrl.removePercentageSign($ctrl.model.aecPercentChangeValue)\" required/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'PERCENT_CHANGE'\">\n<label>{{'location.aec_percent_change_period_A' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecPercentChangePeriodA\" ng-model=\"$ctrl.model.aecPercentChangePeriodA\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'PERCENT_CHANGE'\">\n<label>{{'location.aec_percent_change_period_B' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecPercentChangePeriodB\" ng-model=\"$ctrl.model.aecPercentChangePeriodB\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'WEIGHTED_AVG'\">\n<label>{{'location.aec_weighted_avg_weight_A' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecWeightedAvgWeightA\" ng-model=\"$ctrl.model.aecWeightedAvgWeightA\" pattern=\"^(?:0*(?:\\.\\d+)?|1(\\.0*)?)$\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'WEIGHTED_AVG'\">\n<label>{{'location.aec_weighted_avg_period_A' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecWeightedAvgPeriodA\" ng-model=\"$ctrl.model.aecWeightedAvgPeriodA\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'WEIGHTED_AVG'\">\n<label>{{'location.aec_weighted_avg_weight_B' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecWeightedAvgWeightB\" ng-model=\"$ctrl.model.aecWeightedAvgWeightB\" pattern=\"^(?:0*(?:\\.\\d+)?|1(\\.0*)?)$\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'WEIGHTED_AVG'\">\n<label>{{'location.aec_weighted_avg_period_B' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecWeightedAvgPeriodA\" ng-model=\"$ctrl.model.aecWeightedAvgPeriodB\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'SINGLE'\">\n<label>{{'location.aec_single_period' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecSinglePeriod\" ng-model=\"$ctrl.model.aecSinglePeriod\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model._type === 'ATM' && $ctrl.model.bankSourceId\">\n<label for=\"\">{{'location.addToSwapRatio' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.addToSwapRatio\" required ng-options=\"addToSwapRatio.value as addToSwapRatio.label for addToSwapRatio in $ctrl.addToSwapRatioOptions\">\n<option disabled=\"disabled\" value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"['TRUCK', 'INTERNAL', 'TANKER', 'WINDOW', 'CARRIER'].indexOf($ctrl.model._type) === -1\">\n<div class=\"remove-left-pad col-sm-12\">\n<h4 id=\"inline\" translate=\"location.routeAssignment\"></h4>\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{ 'location.tooltip_info' | translate }}\" tooltip-placement=\"top\"></span>\n<div id=\"inline\" class=\"form-group checkbox pull-right\">\n<label>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameAll()\" ng-model=\"$ctrl.model.sameForAll\"/>\n<strong>{{'location.sameForAll' | translate }}</strong>\n</label>\n</div>\n</div>\n<div class=\"col-sm-12 week-day-section\">\n<table class=\"table table-striped weekdays-table table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th ng-repeat=\"day in $ctrl.days.slice(0, 4)\">{{day.label}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'location.route'|translate}}</th>\n<td class=\"location-route-assignment-section col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(0, 4)\">\n<search-and-select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) === -1\" ng-model=\"$ctrl.model[day.value].routeId\" set-id=\"route-{{day.id}}\" on-click=\"$ctrl.updateAll(day.value,'routeId')\" values=\"$ctrl.day.routeId\" key=\"Key\" totalrecords=\"$ctrl.totalRoutes\" onscroll=\"$ctrl.loadRoutes(searchKey, offset)\" none-selected=\"'common.none'\" long-dd-width-flag=\"true\"></search-and-select>\n</td>\n</tr>\n<tr ng-if=\"false\">\n<th class=\"col-xs-1\">{{'location.stop'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(0, 4)\">\n<select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL'].indexOf($ctrl.model._type) === -1\" class=\"form-control\" ng-model=\"$ctrl.model[day.value].stops\" ng-options=\"stops.value as stops.label for stops in $ctrl.day.stops\" ng-change=\"$ctrl.updateAll(day.value,'stops')\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr ng-if=\"false\">\n<th class=\"col-xs-1\">{{'location.when'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(0, 4)\">\n<select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL'].indexOf($ctrl.model._type) === -1\" class=\"form-control\" ng-model=\"$ctrl.model[day.value].options\" ng-options=\"options.value as options.label for options in $ctrl.day.options\" ng-change=\"$ctrl.updateAll(day.value,'options')\">\n<option value=\"\">{{'common.none' | translate}}</option>\n</select>\n</td>\n</tr>\n</tbody>\n</table>\n<table class=\"table weekend-table table-striped table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th class=\"col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(4)\">{{day.label}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'location.route'|translate}}</th>\n<td class=\"location-route-assignment-section col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(4)\">\n<search-and-select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) === -1\" ng-model=\"$ctrl.model[day.value].routeId\" set-id=\"route-{{day.id}}\" on-click=\"$ctrl.updateAll(day.value,'routeId')\" values=\"$ctrl.day.routeId\" key=\"Key\" totalrecords=\"$ctrl.totalRoutes\" onscroll=\"$ctrl.loadRoutes(searchKey, offset)\" none-selected=\"'common.none'\" long-dd-width-flag=\"true\"></search-and-select>\n</td>\n</tr>\n<tr ng-if=\"false\">\n<th class=\"col-xs-1\">{{'location.stop'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(4)\">\n<select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL'].indexOf($ctrl.model._type) === -1\" class=\"form-control\" ng-model=\"$ctrl.model[day.value].stops\" ng-options=\"stops.value as stops.label for stops in $ctrl.day.stops\" ng-change=\"$ctrl.updateAll(day.value,'stops')\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr ng-if=\"false\">\n<th>{{'location.when'|translate}}</th>\n<td ng-repeat=\"day in $ctrl.days.slice(4)\">\n<select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL'].indexOf($ctrl.model._type) === -1\" class=\"form-control\" ng-model=\"$ctrl.model[day.value].options\" ng-options=\"options.value as options.label for options in $ctrl.day.options\" ng-change=\"$ctrl.updateAll(day.value,'options')\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad location-schedule-section margin-10\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<h4>{{'location.ad_hoc_stop' | translate}}</h4>\n</div>\n<div class=\"col-sm-6 pull-right remove-right-pad\" ng-show=\"::$ctrl.hasACL['edit']\">\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn\" ng-click=\"$ctrl.createLocationScheduled()\" ng-disabled=\"$ctrl.isLoading\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n</div>\n</div>\n<div class=\"col-sm-12 div-table font-12 remove-right-pad\">\n<div class=\"row div-tr loc-schedule\">\n<div class=\"col-sm-5 div-td\">\n<div class=\"dt\">\n<strong>{{'closeVault.currentVaultDate' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-5 div-td\">\n<div class=\"dt\">\n<strong>{{'checkout.routeId' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td\">\n<div class=\"dt\">\n<strong>{{'itemHolds.routeSequence' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\"><strong>Action</strong></div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<ul class=\"list-group location-sequence remove-bottom-margin\">\n<li ng-repeat=\"locObj in $ctrl.model.scheduledLocations track by $index\" class=\"remove-bottom-margin display-flex border-bottom\">\n<div class=\"col-sm-5 div-td\">\n<span ng-if=\"locObj.isDuplicate\" class=\"glyphicon glyphicon-warning-sign scheduled-location-alert\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\">\n</span>\n<div class=\"dt atm-codes-date-picker-section\">\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"locObj.vaultDate\" date-format=\"dd-MMM-yyyy\" ng-click=\"loadRoutes()\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !locObj.vaultDate}\" ng-keydown=\"$event.preventDefault()\" ng-change=\"$ctrl.validateScheduledLocation();\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"col-sm-5 div-td order-profile-dd-z-index\">\n<div class=\"dt order-profile-dd-z-index\">\n<search-and-select ng-model=\"locObj.routeId\" required=\"true\" values=\"$ctrl.model.routeListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.routeListObj.totalRecords\" onscroll=\"$ctrl.routeList(searchKey, offset)\" none-selected=\"'common.none'\" long-dd-width-flag=\"true\"></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-1 div-td\">\n<div class=\"dt\">\n<input type=\"number\" class=\"form-control\" ng-model=\"locObj.sequence\" required>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.deleteScheduledLocation($index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad recurring-stop-section margin-10\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<h4>{{'location.combined_route_assignment' | translate}}</h4>\n</div>\n</div>\n<div class=\"col-sm-12 week-day-section\">\n<table class=\"table table-striped weekdays-table table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th>{{'location.day.routeId' | translate}}</th>\n<th>{{'branchFundingSource.interval' | translate}}</th>\n<th>{{'routeProgress.sequence' | translate}}</th>\n<th>{{'customer.startDate' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"route in $ctrl.combinedRoutes track by $index\" ng-if=\"$index < 7\">\n<th class=\"col-xs-1\">{{route.day.label}}</th>\n<td class=\"location-route-assignment-section col-sm-3\">\n<search-and-select ng-model=\"route.route\" set-id=\"route-{{route.day.value}}\" values=\"$ctrl.day.routeId\" key=\"Key\" totalrecords=\"$ctrl.totalRoutes\" ng-required=\"((route.anchorDate || route.interval) ? !route.route : false)\" onscroll=\"$ctrl.loadRoutes(searchKey, offset)\" none-selected=\"'common.none'\" long-dd-width-flag=\"true\" on-click=\"$ctrl.validateRouteAssignment();\"></search-and-select>\n</td>\n<td ng-if=\"route.isVisible\" class=\"location-route-assignment-section\">\n<select class=\"form-control\" ng-model=\"route.interval\" required=\"false\" ng-options=\"interval.label for interval in route.combinedRouteIntervals\" ng-required=\"((route.anchorDate || route.route) ? !route.interval : false)\" ng-change=\"$ctrl.validateRecurringLocation(); $ctrl.validateRouteAssignment();\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</td>\n<td ng-if=\"route.isVisible\" class=\"location-route-assignment-section col-xs-1\">\n<input type=\"number\" class=\"form-control\" ng-model=\"route.sequence\" min=\"1\" ng-change=\"$ctrl.validateRouteAssignment();\" ng-required=\"((route.anchorDate || route.route || route.interval) ? !route.sequence : false)\">\n</td>\n<td ng-if=\"route.isVisible\" class=\"atm-codes-date-picker-section col-sm-3\">\n<datetimepicker class=\"datetimepicker-input\" key=\"{{$index}}\" id=\"{{$index}}\" ng-model=\"route.anchorDate\" date-format=\"dd-MMM-yyyy\" ng-click=\"loadRoutes()\" hidden-time=\"true\" show-button-bar=\"true\" date-disabled=\"$ctrl.disableDays(date, mode, route.day)\" ng-change=\"$ctrl.recheckMonthlyOccurences(route.anchorDate, route.day, $index); $ctrl.validateRouteAssignment();\" ng-class=\"{'required-datetimepicker': ((route.route || route.interval) ? !route.anchorDate : false)}\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</td>\n</tr>\n<tr ng-if=\"$ctrl.combinedRoutes.length > 7\">\n<th class=\"col-xs-1\">{{ $ctrl.combinedRoutes[7].day.label }}</th>\n<td class=\"location-route-assignment-section col-sm-3\">\n<search-and-select ng-model=\"$ctrl.model[$ctrl.combinedRoutes[7].day.value].routeId\" set-id=\"route-{{$ctrl.combinedRoutes[7].day.value}}\" values=\"$ctrl.day.routeId\" key=\"Key\" totalrecords=\"$ctrl.totalRoutes\" ng-required=\"(($ctrl.combinedRoutes[7].anchorDate || $ctrl.combinedRoutes[7].interval) ? !$ctrl.combinedRoutes[7].route : false)\" onscroll=\"$ctrl.loadRoutes(searchKey, offset)\" none-selected=\"'common.none'\" long-dd-width-flag=\"true\" on-click=\"$ctrl.validateRouteAssignment();\"></search-and-select>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad location-schedule-section margin-10\" ng-show=\"['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<h4>{{'orderPacking.denominations' | translate}}</h4>\n</div>\n<div class=\"col-sm-6 pull-right remove-right-pad\" ng-show=\"::$ctrl.hasACL['edit']\">\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn\" style=\"margin-right: 0 !important;\" ng-click=\"$ctrl.createLocationDenomination()\" ng-disabled=\"$ctrl.isLoading || $ctrl.model.selectedDenomination.length === $ctrl.filteredDenominations.totalRecords\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n</div>\n</div>\n<div class=\"col-sm-12 font-12 remove-right-pad\">\n<div class=\"row div-tr loc-schedule\">\n<div class=\"col-sm-3 div-td\">\n<div class=\"dt\">\n<strong>{{'atm_residual.denomination' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'location.max_load' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-3 div-td\">\n<div class=\"dt\">\n<strong>{{'location.min_residual_threshold' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-3 div-td\">\n<div class=\"dt\">\n<strong>{{'location.max_residual_threshold' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\"><strong>{{'bulkCash.action' | translate}}</strong></div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<ul class=\"list-group location-sequence remove-bottom-margin\">\n<li ng-repeat=\"denomObj in $ctrl.model.selectedDenomination track by $index\" class=\"remove-bottom-margin display-flex border-bottom\">\n<div class=\"col-sm-3 div-td order-profile-dd-z-index\">\n<span ng-if=\"denomObj.isDuplicate\" class=\"glyphicon glyphicon-warning-sign scheduled-location-alert\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\">\n</span>\n<div class=\"dt order-profile-dd-z-index\">\n<search-and-select ng-model=\"denomObj.denom\" values=\"$ctrl.filteredDenominations.results\" key=\"Key\" totalrecords=\"$ctrl.filteredDenominations.totalRecords\" none-selected=\"'common.none'\" common-search-flag=\"true\" long-dd-width-flag=\"true\" ng-click=\"$ctrl.validateDenominationSelected(); $ctrl.createLocationRecurringLoad(); $ctrl.checkDenomKeyExists(); $ctrl.checkForMaxLoadFaceValueDivisibility()\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" ng-model=\"denomObj.maxLoad\" ng-currency min=\"0\" ng-class=\"{'invalid-amount' : denomObj.denom && denomObj.isMaxLoadValid === false}\" ng-disabled=\"denomObj.disableFields\" placeholder=\"{{'location.max_load' | translate}}\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46 || event.charCode === 0\" ng-change=\"$ctrl.checkForMaxLoadFaceValueDivisibility()\" required>\n</div>\n</div>\n<div class=\"col-sm-3 div-td\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" ng-model=\"denomObj.minResidualThresholdPercentage\" ng-blur=\"$ctrl.ngResidualPercentage($index,'min')\" ng-focus=\"$ctrl.removeResidualPercentageSign($index,'min')\" placeholder=\"{{'location.min_residual_threshold' | translate}}\" pattern=\"^(?:100(?:\\.0{1,3})?|[0-9]{1,2}(?:\\.[0-9]{1,3})?)%?$\" ng-disabled=\"denomObj.disableFields\" required>\n</div>\n</div>\n<div class=\"col-sm-3 div-td\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" ng-model=\"denomObj.maxResidualThresholdPercentage\" ng-blur=\"$ctrl.ngResidualPercentage($index,'max')\" ng-focus=\"$ctrl.removeResidualPercentageSign($index,'max')\" placeholder=\"{{'location.max_residual_threshold' | translate}}\" pattern=\"^(?:100(?:\\.0{1,3})?|[0-9]{1,2}(?:\\.[0-9]{1,3})?)%?$\" ng-disabled=\"denomObj.disableFields\" required>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.deleteDenominationSelected($index)\">\n<span class=\"glyphicon glyphicon-remove\" uib-tooltip=\"{{'batch.tooltip_del' | translate }}\" tooltip-placement=\"top\"></span>\n</button>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad recurring-stop-section margin-10\" ng-show=\"['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<h4>{{'location.schedule_recurring_load' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"At least one denomination and a weekly route assignment are required to set a recurring load.\" tooltip-placement=\"top-right\"></span>\n</h4>\n</div>\n</div>\n<div class=\"col-sm-12 week-day-section\" ng-if=\"$ctrl.model.selectedDenomination.length > 0 && $ctrl.checkDenomKeyExists()\">\n<table class=\"table table-striped weekdays-table table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th class=\"col-xs-1 weekdays-label\">{{'location.weekday'|translate}}</th>\n<th class=\"text-align-center\" ng-repeat=\"denom in $ctrl.model.selectedDenomination\" ng-if=\"denom.denom.id\">\n<img ng-if=\"denom.denom.id !== '1'\" ng-src=\"assets/images/{{denom.denom.id}}.png\" class=\"location-denom-icon-size\"/>\n<img ng-if=\"denom.denom.id == '1'\" src=\"" + __webpack_require__(68) + "\" class=\"location-denom-icon-size\"/>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"location in $ctrl.locationRecurringLoad track by $index\">\n<th class=\"col-xs-1 text-align-center\">{{location.day.label | translate}}</th>\n<td ng-repeat=\"denom in location.denominations\" ng-if=\"denom.denom.Value\">\n<input ng-if=\"!denom.denom.coinFlag\" type=\"text\" class=\"form-control text-center\" ng-model=\"location['recurringLoad'][denom.denom.Value].amount\" placeholder=\"$0.00\" ng-currency fraction=\"0\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.checkForStrapCount();\" ng-class=\"{'invalid-amount' : location['recurringLoad'][denom.denom.id] && !location['recurringLoad'][denom.denom.id].isValid}\" ng-disabled=\"!location.hasLocationScheduleRecurring\">\n<input ng-if=\"denom.denom.coinFlag\" type=\"text\" class=\"form-control text-center\" ng-model=\"location['recurringLoad'][denom.denom.Value].qty\" placeholder=\"0\" fraction=\"0\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.calculateCoinAmount(location['recurringLoad'][denom.denom.Value], denom.denom); $ctrl.checkForStrapCount();\" ng-class=\"{'invalid-amount' : location['recurringLoad'][denom.denom.Value] && !location['recurringLoad'][denom.denom.Value].isValid}\" ng-disabled=\"!location.hasLocationScheduleRecurring\">\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-bottom-margin\" ng-if=\"$ctrl.model.selectedDenomination.length == 0 || !$ctrl.checkDenomKeyExists() \">\n<div class=\"alert alert-info\">\nAt least one denomination and a weekly route assignment are required to set a recurring load.\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad margin-10 location-hours-of-operation\">\n<h4 id=\"inline\" translate=\"location.hours_of_operation\"></h4>\n<div id=\"inline\" class=\"form-group checkbox pull-right\">\n<label>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameOperationTime()\" ng-model=\"$ctrl.model.isSameOperationTime\"/>\n<strong>{{'location.sameForAll' | translate }}</strong>\n</label>\n</div>\n</div>\n<div class=\"col-sm-12 hours-of-operation-main-section-z-index\">\n<div>\n<table class=\"table table-striped weekdays-table table-bordered\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th ng-repeat=\"day in $ctrl.operationDays.slice(0, 4)\">{{day.label}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'location.open_time'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.operationDays.slice(0, 4)\">\n<time-picker ng-model=\"$ctrl.model[$ctrl.openTime+(day.value)]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.updateTime(day.value)\" ng-required=\"($ctrl.model[$ctrl.closeTime+(day.value)] && !$ctrl.model[$ctrl.openTime+(day.value)]) ? true : false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</td>\n</tr>\n<tr>\n<th class=\"col-xs-1\">{{'location.close_time'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.operationDays.slice(0, 4)\">\n<time-picker ng-model=\"$ctrl.model[$ctrl.closeTime+(day.value)]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.updateTime(day.value)\" ng-required=\"($ctrl.model[$ctrl.openTime+(day.value)] && !$ctrl.model[$ctrl.closeTime+(day.value)]) ? true : false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</td>\n</tr>\n</tbody>\n</table>\n<table class=\"table weekend-table table-striped table-bordered\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th class=\"col-xs-2\" ng-repeat=\"day in $ctrl.operationDays.slice(4)\">{{day.label}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'location.open_time'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.operationDays.slice(4)\">\n<time-picker ng-model=\"$ctrl.model[$ctrl.openTime+(day.value)]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.updateTime(day.value)\" ng-required=\"($ctrl.model[$ctrl.closeTime+(day.value)] && !$ctrl.model[$ctrl.openTime+(day.value)]) ? true : false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</td>\n</tr>\n<tr>\n<th class=\"col-xs-1\">{{'location.close_time'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.operationDays.slice(4)\">\n<time-picker ng-model=\"$ctrl.model[$ctrl.closeTime+(day.value)]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.updateTime(day.value)\" ng-required=\"($ctrl.model[$ctrl.openTime+(day.value)] && !$ctrl.model[$ctrl.closeTime+(day.value)]) ? true : false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad\">\n<h4 translate=\"location.seasonOperation\"></h4>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"_form-group col-sm-6 remove-left-pad\">\n<label>{{'location.seasonStart' | translate }}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.seasonStart\" date-format=\"{{$ctrl.dateFormat}}\" ng-change=\"$ctrl.isDisabledDate($ctrl.model.seasonStart)\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.dateOptions\">\n</datetimepicker>\n</div>\n<div class=\"_form-group col-sm-6 remove-pad\">\n<label>{{'location.seasonEnd' | translate }}</label>\n<button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" ng-click=\"$ctrl.resetSeason()\">{{'common.clear' | translate}}</button>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.seasonEnd\" date-format=\"{{$ctrl.dateFormat}}\" date-options=\"$ctrl.todayMinDate\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'disabled': !$ctrl.model.seasonStart}\">\n</datetimepicker>\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-12 remove-pad\">\n<deliver-location ng-model=\"$ctrl.model\" locations=\"$ctrl.locations\" title=\"'location.deliveryToLocations'\" is-valid-directive=\"$ctrl.isValidDirective\"></deliver-location>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<h4 translate=\"location.routeOptions\"></h4>\n<div>\n<div id=\"inline\" class=\"form-group col-sm-4\" ng-show=\"$ctrl.showStopProcess\">\n<label for=\"key-id\">{{'location.stop_process' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.stopProcess\" ng-required=\"$ctrl.showStopProcess\" ng-options=\"stopProcess.value as stopProcess.label for stopProcess in $ctrl.stopProcessList\" ng-change=\"$ctrl.filterStopProcess()\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-4' : $ctrl.showStopProcess, 'col-sm-6': !$ctrl.showStopProcess}\">\n<label>{{'location.maxDepositAmount' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-currency ng-model=\"$ctrl.model.maxDepositAmount\"/>\n</div>\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-4' : $ctrl.showStopProcess, 'col-sm-6': !$ctrl.showStopProcess}\">\n<label for=\"key-id\">{{'location.keyId' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.keyId\"/>\n</div>\n</div>\n<div class=\"location-toggle-section remove-left-pad col-sm-12\">\n<div class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.allowMulti' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.allowMulti\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group remove-left-pad col-sm-3\" ng-if=\"['TANKER', 'TRUCK', 'INTERNAL'].includes($ctrl.model._type)\">\n<label for=\"\">{{'common.side_menu.bulk_transfer' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.bulkTransfer\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\" ng-if=\"['BANK', 'DELIVERY'].includes($ctrl.model._type)\">\n<label for=\"\">{{'location.bagoutEnabled' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.bagoutEnabled\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\" ng-if=\"$ctrl.model._type === 'INTERNAL'\">\n<label for=\"\">{{'location.isTransferHoldLocation' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.isTransferHoldLocation\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\" ng-if=\"$ctrl.model._type === 'DELIVERY'\">\n<label for=\"\">{{'location.last_route_stop' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.lastRouteStop\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<h4 translate=\"location.routeNotification\"></h4>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.deliveries' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.RNdeliveries\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"pickups\">{{'location.pickups' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.RNpickups\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"noPickup\">{{'branch_mgmt.routes.bucket_NO_PICKUP' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.RNnoPickup\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"zeroPickup\">{{'location.zeroAmountPickup' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.RNzeroPickup\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-show=\"$ctrl.model._type == 'BANK'\">\n<div class=\"form-group col-sm-3\">\n<label for=\"\">{{ 'location.centralBank' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.centralBank\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<h4 translate=\"location.transactionRequirments\"></h4>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-12 remove-left-pad\">\n<h4 id=\"inline\" class=\"_col-sm-2\" for=\"\">{{'location.scan' | translate }}</h4>\n</div>\n<div class=\"col-sm-12 _location-receipts-section\">\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.lastTransaction' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.lastTransaction\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location._leave' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model._leave\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.scan_bagout_pieces' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.deliverBagOutPiece\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\" ng-if=\"['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf($ctrl.model._type) > -1\">\n<label for=\"\">{{'location.verifyToTruck' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"ON\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.verifyToTruck\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\" ng-if=\"$ctrl.model.verifyToTruck && ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf($ctrl.model._type) > -1\">\n<label for=\"\">{{'location.verifyCoinToTruck' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.verifyCoinToTruck\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\" ng-show=\"$ctrl.model._type=='ATM'\">\n<label for=\"\">{{'location.atmCassette' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.atmCassette\" ng-change=\"$ctrl.onAtmCassetteChange()\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\" ng-if=\"$ctrl.model.atmCassette && $ctrl.model._type=='ATM'\">\n<label for=\"maxCassettes\">{{'location.maxCassettes' | translate }}</label>\n<br>\n<input type=\"number\" id=\"maxCassettes\" name=\"maxCassettes\" class=\"form-control atm-cassette-max-input\" ng-model=\"$ctrl.model.maxCassettes\" min=\"1\" max=\"6\" ng-required=\"$ctrl.model.atmCassette\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.packCoinSeparately' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.packCoinSeparately\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\" ng-show=\"$ctrl.model._type=='ATM'\">\n<label for=\"\">{{'location.captureDenomStc' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"ON\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.captureDenomStc\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad\">\n<h4 id=\"inline\" class=\"_col-sm-2\" for=\"\">{{'location.receipts' | translate }}</h4>\n</div>\n<div class=\"col-sm-12 _location-receipts-section\">\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.TRdeliveries' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.TRdeliveries\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.TRpickups' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.TRpickups\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.print_delivery_manifest' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.printDeliveryManifest\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.pod_receipt' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.podReceipt\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad\" ng-if=\"$ctrl.model._type === 'DELIVERY' || $ctrl.model._type === 'BANK' || $ctrl.model._type === 'ON_CALL' || $ctrl.model._type === 'REGULAR'\">\n<h4 id=\"inline\" class=\"_col-sm-2\" for=\"data_exchange\">{{'location.data_exchange' | translate }}</h4>\n</div>\n<div class=\"col-sm-12 _location-receipts-section\" ng-if=\"$ctrl.model._type === 'DELIVERY' || $ctrl.model._type === 'BANK' || $ctrl.model._type === 'ON_CALL' || $ctrl.model._type === 'REGULAR'\">\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"sendManifestOnDelivery\">{{'location.sendManifestOnDelivery' | translate }}</label> <br/>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.sendManifestOnDelivery\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" ng-show=\"$ctrl.model.sendManifestOnDelivery\" class=\"form-group col-sm-3\">\n<label for=\"manifestType\">{{'location.manifestType' | translate }}</label>\n<select class=\"form-control\" id=\"manifestType\" name=\"manifestType\" ng-model=\"$ctrl.model.manifestType\" ng-required=\"$ctrl.model.sendManifestOnDelivery\" ng-options=\"type.value as type.label for type in $ctrl.manifestTypeList\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div id=\"inline\" ng-show=\"$ctrl.model.sendManifestOnDelivery\" class=\"form-group col-sm-3\">\n<label for=\"manifestRecipientEmail\">{{'location.manifestRecipientEmail' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.manifestRecipientEmail\" ng-class=\"{'ng-invalid': !$ctrl.hasValidEmails($ctrl.model.manifestRecipientEmail, $ctrl.model.manifestType !== 'bin_manifest_transport'), 'ng-valid': $ctrl.hasValidEmails($ctrl.model.manifestRecipientEmail, $ctrl.model.manifestType !== 'bin_manifest_transport')}\" ng-change=\"$ctrl.emailValidation = $ctrl.hasValidEmails($ctrl.model.manifestRecipientEmail, $ctrl.model.manifestType !== 'bin_manifest_transport')\" ng-pattern=\"/^(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+\\s?,)*(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+)$/\" ng-required=\"$ctrl.model.sendManifestOnDelivery && $ctrl.model.manifestType !== 'bin_manifest_transport'\" placeholder=\"\"/>\n</div>\n<div id=\"inline\" ng-show=\"$ctrl.model.sendManifestOnDelivery && $ctrl.model.manifestType === 'bin_manifest_transport'\" class=\"form-group col-sm-3\">\n<label for=\"zeroAmountPickupRecipientEmail\">{{'location.zeroAmountPickupRecipientEmail' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.zeroAmountPickupRecipientEmail\" ng-class=\"{'ng-invalid': !$ctrl.hasValidEmails($ctrl.model.zeroAmountPickupRecipientEmail, false), 'ng-valid': $ctrl.hasValidEmails($ctrl.model.zeroAmountPickupRecipientEmail, false)}\" ng-change=\"$ctrl.zeroAmountEmailValidation = $ctrl.hasValidEmails($ctrl.model.zeroAmountPickupRecipientEmail, false)\" ng-pattern=\"/^(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+\\s?,)*(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+)$/\" placeholder=\"\"/>\n</div>\n<div id=\"inline\" ng-show=\"$ctrl.model.sendManifestOnDelivery\" class=\"form-group col-sm-3\">\n<label for=\"manifestFileType\">{{'location.manifestFileType' | translate }}</label>\n<select class=\"form-control\" id=\"manifestFileType\" name=\"manifestFileType\" ng-model=\"$ctrl.model.manifestFileType\" ng-required=\"$ctrl.model.sendManifestOnDelivery\" ng-options=\"fileType.value as fileType.label for fileType in $ctrl.manifestFileType\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 remove-left-pad\">\n<h4 id=\"inline\" translate=\"location.GPSlocation\">{{$ctrl.model.latitude}}</h4>\n<button type=\"button\" uib-tooltip=\"{{'location.auto_detect' | translate }}\" tooltip-placement=\"top\" class=\"btn btn-primary btn-xs autoDetect\" ng-click=\"$ctrl.autoDetectGeoCoordinates()\" ng-disabled=\"$ctrl.model.updatingDrivingDistance\">\n{{'location.autoDetect' | translate}}</button>\n</div>\n<div class=\"col-sm-12\" map-lazy-load=\"//maps.google.com/maps/api/js\" map-lazy-load-params=\"{{$ctrl.apiKey}}\" ng-if=\"$ctrl.render\">\n<ng-map id=\"map\" on-click=\"$ctrl._map($event)\" center=\"[42.74, -102.18]\">\n<marker position=\"{{$ctrl.model.latitude}},{{$ctrl.model.longitude}}\" draggable=\"true\" on-dragend=\"$ctrl.onMarkerDragEnd($event)\"></marker>\n</ng-map>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10\">\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-3': ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) > -1 && $ctrl.maintainDriveDistance,\n\t\t\t\t\t\t 'col-sm-6': ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) === -1 || !$ctrl.maintainDriveDistance}\">\n<label>{{'location.latitude' | translate }} </label>\n<input id=\"lat\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.latitude\" ng-change=\"$ctrl.setMarkerPosition(null, null);$ctrl.getAddressFromLatLng($ctrl.model.latitude, $ctrl.model.longitude)\">\n</div>\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-3': ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) > -1 && $ctrl.maintainDriveDistance,\n\t\t\t\t\t\t 'col-sm-6': ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) === -1 || !$ctrl.maintainDriveDistance}\">\n<label>{{'location.longitude' | translate }} </label>\n<input id=\"lng\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.longitude\" ng-change=\"$ctrl.setMarkerPosition(null, null);$ctrl.getAddressFromLatLng($ctrl.model.latitude, $ctrl.model.longitude)\">\n</div>\n<div ng-if=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) > -1 && $ctrl.maintainDriveDistance\">\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.distanceFromBranch' | translate }} </label>\n<input id=\"lng\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.distanceFromBranch\">\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.travelTimeToBranch' | translate }} </label>\n<input id=\"lng\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.travelTimeToBranch\">\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'locationDistance.menu.title' | translate }} </label>\n<input id=\"location-distance\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.locationDistance\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"remove-left-pad col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary margin-bottom-10\" ng-disabled=\"Form.$invalid || !$ctrl.isValidDirective || !$ctrl.model.branch.length || !$ctrl.isValidRecurringLoad || !$ctrl.isValidDenomination || !$ctrl.isValidMaxLoad || !$ctrl.isValidTargetStopTime() || $ctrl.duplicateLocationSlotError\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default margin-bottom-10\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div></form>\n</div>\n<style>\n.uib-timepicker .seconds .ng-valid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t}\n\n\t.uib-timepicker .seconds .ng-invalid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t}\n\n\t.atm-cassette-max-input {\n\t\twidth: 64px;\n\t\theight: 30px;\n\t\tpadding: 4px 8px;\n\t}\n</style>\n";
var id1="location.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"connection-status-container\">\n<div class=\"alert alert-danger\" ng-if=\"$ctrl.custNotSelectError\">\n{{'common.selectFirstCust' | translate}}\n</div>\n</div>\n<div>\n<h4 translate=\"location.edit_location\"></h4>\n<hr class=\"remove-bottom-margin\"/>\n</div>\n<div class=\"col-sm-12 remove-padding margin-10 table-responsive\" ng-if=\"$ctrl.pendingLocationChanges.results.pendingChanges.length && !$ctrl.pendingStopsChangesObj.loading\">\n<div class=\"remove-pad col-sm-12\">\n<h4>\n{{'location.pending_changes' | translate}} <span class=\"badge badge-light future-location-changes-badge\">{{$ctrl.pendingLocationChanges.total}}</span>\n<button type=\"button\" class=\"btn btn-danger btn-xs pull-right\" ng-if=\"$ctrl.hasACL['deleteSaveLater']\" ng-click=\"$ctrl.confirmDeleteAllPendingChanges()\">\n<span class=\"glyphicon glyphicon-trash\"></span> {{'common.delete_all' | translate}}\n</button>\n</h4>\n</div>\n<table class=\"table table-hover table-bordered table-pad-3 font-12\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'routeSheet.date' | translate}}</th>\n<th class=\"text-center\">{{'location.change_type' | translate}}</th>\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n<th class=\"text-center\">{{'users.user' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr class=\"future-location-changes-bg-color\" ng-repeat=\"history in $ctrl.pendingLocationChanges.results.pendingChanges track by $index\">\n<td class=\"text-center\">{{history.executeAt | date: 'MM-dd-yyyy | hh:mm a'}}</td>\n<td class=\"text-danger text-center\">{{$ctrl.translateMessage(history.key)}}</td>\n<td class=\"text-center\">\n<span ng-if=\"history.previous.length\" ng-repeat=\"previousChanges in history.previous\">\n<div>{{previousChanges}}<span ng-if=\"$index + 1 !== history.previous.length\">,</span></div>\n</span>\n<span ng-if=\"!history.previous.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"history.changed.length\" ng-repeat=\"changedChanges in history.changed\">\n<div>{{changedChanges}}<span ng-if=\"$index + 1 !== history.changed.length\">,</span></div>\n</span>\n<span ng-if=\"!history.changed.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">{{history.user}}</td>\n</tr>\n</tbody>\n</table>\n<hr class=\"remove-bottom-margin\"/>\n</div>\n<div>\n<form name=\"Form\" novalidate class=\"form-validate location-edit-form\" autocomplete=\"off\">\n<div class=\"col-sm-12\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<h4 translate=\"location.general\"></h4>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"name\">{{'location.name' | translate }} </label>\n<input type=\"text\" required class=\"form-control\" id=\"name\" ng-model=\"$ctrl.model.name\">\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"location\">{{'location.id' | translate }} </label>\n<input type=\"text\" required class=\"form-control\" id=\"location\" ng-model=\"$ctrl.model.id\">\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"status\">{{'location.status' | translate }} </label> <br/>\n<div class=\"form-control dummy-form-control\">\n<input id=\"status\" type=\"checkbox\" class=\"form-control\" ng-model=\"$ctrl.model.status\" ng-change=\"$ctrl.askToChange()\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\"/>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"location-type\">{{'location._type' | translate }} </label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model._type\" ng-options=\"_type.value as _type.label for _type in $ctrl._types\" ng-change=\"$ctrl.changeLocationType(); $ctrl.allowStopProcess(); $ctrl.filterStopProcess(); $ctrl.getFilteredDenominations(); $ctrl.validateDisabledDenomFields();\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"customer\">{{'location.customer' | translate }}</label>\n<search-and-select ng-model=\"$ctrl.model.customer\" set-id=\"customer\" values=\"$ctrl.customer\" key=\"Key\" totalrecords=\"$ctrl.totalCostomers\" on-click=\"$ctrl.changeCustomer()\" onscroll=\"$ctrl.loadCustomer(searchKey, offset)\" none-selected=\"'common.none'\" ng-disabled=\"!$ctrl.hasACL['editCustomer']\" ng-required=\"['REGULAR', 'ON_CALL', 'ATM', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1 && $ctrl.model.setupDetails.billingEnabled\">\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"\">{{ 'users.all_branches' | translate }} </label>\n<div>\n<div ng-if=\"!['WINDOW', 'INTERNAL', 'TANKER'].includes($ctrl.model._type)\" class=\"multi-select location-branch-dd\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t\t\t\t\t'invalid-multi-select-value': !$ctrl.model.branch.length,\n\t\t\t\t\t\t\t\t\t\t\t\t\t'valid-multi-select-value': $ctrl.model.branch.length\n\t\t\t\t\t\t\t\t\t\t\t\t}\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.branch\" output-model=\"$ctrl.model.branch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.loadBranchData()\" on-reset=\"$ctrl.loadBranchData()\" on-select-all=\"$ctrl.loadBranchData()\" on-select-none=\"$ctrl.loadBranchData()\">\n</div>\n<select ng-if=\"['WINDOW', 'INTERNAL', 'TANKER'].includes($ctrl.model._type)\" class=\"form-control\" required ng-model=\"$ctrl.model.singleBranch\" ng-options=\"branch.branchId as branch.branchId for branch in $ctrl.branch\" ng-change=\"$ctrl.onSingleBranchChange()\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"branch\">{{ 'users.default_branches' | translate }} </label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.defaultBranch\" ng-options=\"branch.branchId as branch.branchId for branch in $ctrl.model.branch\" ng-change=\"$ctrl.getSetupDetails(); $ctrl.resetDataOnBranchChange(); ['ATM', 'BANK', 'DELIVERY', 'ON_CALL'].indexOf($ctrl.model._type) > -1 ? $ctrl.getAllFundingSource(searchKey, offset) : null\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"location-address\">{{'location._address' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-required=\"['INTERNAL', 'TRUCK', 'TANKER', 'WINDOW', 'LOCKER'].indexOf($ctrl.model._type) === -1\" ng-model=\"$ctrl.model._address\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"city\">{{'location._city' | translate }} </label>\n<input type=\"text\" ng-required=\"['INTERNAL', 'TRUCK', 'TANKER', 'WINDOW', 'LOCKER'].indexOf($ctrl.model._type) === -1\" class=\"form-control\" ng-model=\"$ctrl.model._city\"/>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"state\">{{'location._state' | translate }} </label>\n<span class=\"pull-right\">\n<span for=\"state\"><b>Non US</b></span>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameAll()\" ng-model=\"$ctrl.model.isNonUSLocation\" ng-click=\"$ctrl.resetText()\"/>\n</span>\n<div ng-show=\"!$ctrl.model.isNonUSLocation\">\n<select class=\"form-control\" ng-model=\"$ctrl.model._state\" ng-options=\"state.value as state.label for state in $ctrl.states\" ng-required=\"['INTERNAL', 'TRUCK', 'TANKER', 'WINDOW', 'LOCKER'].indexOf($ctrl.model._type) === -1\">\n<option value=\"\" ng-disabled=\"['TRUCK', 'INTERNAL'].indexOf($ctrl.model._type) === -1\">(select)\n</option>\n</select>\n</div>\n<div ng-show=\"$ctrl.model.isNonUSLocation\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model._state\" ng-pattern=\"/^[a-zA-Z .]*$/\" ng-required=\"$ctrl.model.isNonUSLocation\">\n</div>\n</div>\n<div class=\"form-group\" ng-class=\"{'col-sm-2': $ctrl.model.isNonUSLocation}\" ng-show=\"$ctrl.model.isNonUSLocation\">\n<label for=\"state\">{{'location.country' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.country\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-required=\"$ctrl.model.isNonUSLocation\">\n</div>\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-4': !$ctrl.model.isNonUSLocation, 'col-sm-2': $ctrl.model.isNonUSLocation}\">\n<label>{{'location._zip' | translate }} </label>\n<input ng-required=\"['TRUCK', 'INTERNAL', 'TANKER', 'WINDOW', 'LOCKER'].indexOf($ctrl.model._type) === -1\" ng-pattern=\"/^\\d{5,6}(?:-\\d{4})?$/\" type=\"text\" ng-required=\"$ctrl.model._type === -1\" class=\"form-control\" ng-model=\"$ctrl.model._zip\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location.refId' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.refId\">\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location._poc' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model._poc\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location.pocEmail' | translate }}</label>\n<input type=\"text\" ng-pattern=\"/^(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+\\s?,)*(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+)$/\" class=\"form-control\" ng-model=\"$ctrl.model.pocEmail\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location.pocPhone' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.pocPhone\" ui-us-phone-number>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 form-group _remove-pad\">\n<div class=\"_form-group\" ng-class=\"{\n\t\t\t\t\t\t\t\t'col-sm-8 _remove-pad': ['REGULAR','ON_CALL', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1, \n\t\t\t\t\t\t\t\t'col-sm-12 _remove-pad': ['REGULAR','ON_CALL', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) === -1 || !$ctrl.model._type\n\t\t\t\t\t\t\t}\">\n<label for=\"comments\">{{'location.comment' | translate }}</label>\n<textarea class=\"form-control\" rows=\"2\" id=\"comments\" ng-model=\"$ctrl.model.comments\" autocomplete=\"off\"></textarea>\n</div>\n<div class=\"_form-group col-sm-4\" ng-if=\"['REGULAR', 'ON_CALL', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1\">\n<label>{{'location.stop_priority' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.stopPriority\" ng-options=\"priority.value as priority.label for priority in $ctrl.stopPriorityList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.batch_import' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.idBatchImport\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" placeholder=\"{{'common.locationId' | translate}}\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.bagout_export' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.idBagoutExport\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" placeholder=\"{{'common.locationId' | translate}}\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.bagout_export_deposit' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.idBagoutDepositExport\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" placeholder=\"{{'common.locationId' | translate}}\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.OTC_lock' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.idOTCLock\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" placeholder=\"{{'common.locationId' | translate}}\"/>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div id=\"model\" class=\"form-group col-sm-4\" ng-if=\"$ctrl.model._type === 'ATM'\">\n<label for=\"name\">{{'truck.model' | translate }} </label>\n<input type=\"text\" class=\"form-control\" id=\"model\" ng-model=\"$ctrl.model.model\">\n</div>\n<div id=\"serialNumber\" class=\"form-group col-sm-4\" ng-if=\"$ctrl.model._type === 'ATM'\">\n<label for=\"serialNumber\">{{'serviceTickets.serialNumber' | translate }} </label>\n<input type=\"text\" class=\"form-control\" id=\"serial-number\" ng-model=\"$ctrl.model.serialNumber\">\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"['ATM'].indexOf($ctrl.model._type) > -1\">\n<label>{{'location.stop_priority' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.stopPriority\" ng-options=\"priority.value as priority.label for priority in $ctrl.stopPriorityList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" style=\"display: flex; flex-wrap: wrap;\">\n<div id=\"NFCScan\" class=\"form-group col-sm-4\">\n<label for=\"NFCScan\">{{'location.nfc_scan' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.NFCScan\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"NFCTagId\" class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.NFCScan\">\n<label class=\"remove-white-space\">{{'location.nfc_tag_id' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.NFCTagId\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" ng-required=\"$ctrl.model.NFCScan\"/>\n</div>\n<div class=\"col-sm-4 cost-center-section\">\n<div class=\"form-group\">\n<label for=\"costCenter\">{{'location.cost_center' | translate }}</label>\n<search-and-select ng-model=\"$ctrl.model.costCenter\" values=\"$ctrl.costCenterList\" key=\"Key\" totalrecords=\"$ctrl.totalCostCenter\" onscroll=\"$ctrl.loadCostCenter(searchKey, offset)\" none-selected=\"'common.none'\">\n</search-and-select>\n</div>\n</div>\n<div id=\"customerCostCenter\" class=\"form-group col-sm-4 cost-center-section\">\n<label for=\"customerCostCenter\">{{'costCenter.customer_cost_center' | translate }}</label>\n<div class=\"margin-top-02\">\n<search-and-select ng-model=\"$ctrl.model.customerCostCenter\" set-id=\"customerCostCenter\" values=\"$ctrl.customerCostCenterObj.results\" key=\"Key\" totalrecords=\"$ctrl.customerCostCenterObj.total\" onscroll=\"$ctrl.loadCustomersCostCenter(searchKey, offset)\" none-selected=\"'common.none'\">\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4 location-zone-section\">\n<div class=\"form-group\">\n<label for=\"locationZone\">{{'location.location_zone' | translate }}</label>\n<div class=\"multi-select valid-multi-select-value\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.locationZoneList\" output-model=\"$ctrl.model.selectedLocationZones\" button-label=\"zoneInfo\" item-label=\"label\" search-property=\"zoneInfo\" tick-property=\"ticked\" group-property=\"msGroup\" directive-id=\"location-zone-multi-select\">\n</div>\n</div>\n</div>\n<div id=\"make\" class=\"form-group col-sm-4\">\n<label for=\"make\">{{'truck.make' | translate }} </label>\n<div class=\"multi-select valid-multi-select-value location-atmmake-dd\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.atmMakesList\" output-model=\"$ctrl.model.make\" button-label=\"Key\" item-label=\"Key\" search-property=\"Key\" tick-property=\"ticked\" directive-id=\"multi-select-make\">\n</div>\n</div>\n<div id=\"preventativeMaintenance\" class=\"form-group col-sm-4\" ng-if=\"['ATM', 'ON_CALL'].includes($ctrl.model._type)\">\n<label>{{'location.preventativeMaintenance' | translate}}</label>\n<div class=\"margin-top-02\">\n<search-and-select ng-model=\"$ctrl.model.preventativeMaintenanceId\" set-id=\"preventativeMaintenance\" values=\"$ctrl.pmSearchList\" key=\"Key\" totalrecords=\"$ctrl.totalPMRecords\" onscroll=\"$ctrl.loadPreventativeMaintenances(searchKey, offset)\" class=\"dd-z-index\" none-selected=\"'common.none'\" common-search-flag=\"false\" ng-style=\"$ctrl.isPMSuspended($ctrl.model.preventativeMaintenanceId) && {'background-color': '#F9E3E3'}\">\n</search-and-select>\n</div>\n</div>\n<div id=\"accountNumber\" class=\"form-group col-sm-4\">\n<label for=\"accountNumber\">{{'location.account_no' | translate }}</label>\n<input id=\"accountNumber\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.accountNumber\" ng-pattern=\"/^[a-zA-Z0-9]*$/\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-10\" ng-if=\"$ctrl.model._type == 'ATM' || $ctrl.model._type == 'LOCKER' || $ctrl.model._type == 'DELIVERY' || $ctrl.model._type == 'ON_CALL'\">\n<h4>{{'location.primary_lock_section' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location.lockType' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.lockType\" ng-options=\"lockType.value as lockType.label for lockType in $ctrl.lockTypes\" ng-change=\"$ctrl.resetOTCCompany();\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label>{{'location.otc_company_name' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.OTCCompanyName\" ng-options=\"companyName.value as companyName.label for companyName in $ctrl.OTCCompanyNameList\" ng-disabled=\"$ctrl.model.lockType === 'static'\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.lockType === 'static'\">\n<label>{{'location.static_open_code' | translate }}</label>\n<input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.staticOpenCode\" id=\"static-open-code\" ng-attr-type=\"{{ $ctrl.passWdIcon['primary'].viewStaticOpenCode ? 'text' : 'password'}}\">\n<div class=\"password-icon\" ng-click=\"$ctrl.showPassword('primary', 'viewStaticOpenCode')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['primary'].viewStaticOpenCode ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\">\n<label for=\"OTCGeoFence\">{{'location.OTCGeoFence' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.OTCGeoFence\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\" ng-if=\"$ctrl.model.lockType !== 'static'\">\n<label for=\"closeReq\">{{'location.close_req' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.closeReq\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\" ng-if=\"$ctrl.model.stopProcess === 'L' && $ctrl.model.lockType !== 'static'\">\n<label for=\"closeEndOfStop\">{{'location.close_end_of_stop' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.closeEndOfStop\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\" ng-if=\"$ctrl.model.lockType === 'witz' || $ctrl.model.lockType === 'TDS'\">\n<label for=\"NFCLock\">{{'location.NFC_Lock' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.NFCLock\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 _order-profile-dd-z-index\" ng-if=\"['ATM', 'BANK', 'DELIVERY', 'ON_CALL', 'REGULAR', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1\">\n<h4 translate=\"location.optionalControls\"></h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"machine_owner\">{{'location.machine_owner' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"machine_owner\" ng-model=\"$ctrl.model.machineOwner\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"flm\">{{'common.FLM' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"flm\" ng-model=\"$ctrl.model.FLMProvider\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"slm\">{{'location.SLM' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"slm\" ng-model=\"$ctrl.model.SLMProvider\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"bankWeek\">{{'location.bank_week' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.bankWeek\" ng-options=\"bankWeek.value as bankWeek.label for bankWeek in $ctrl.bankWeekList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.when' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.frequencyOptions\" ng-options=\"frequency.value as frequency.label for frequency in $ctrl.frequencyList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.weekday' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.dayOfWeekOptions\" ng-options=\"weekDay.value as weekDay.label for weekDay in $ctrl.weekDayList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.first_option' | translate}}</label>\n<textarea class=\"form-control\" rows=\"2\" id=\"optional1\" ng-model=\"$ctrl.model.optional1\" autocomplete=\"off\"></textarea>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.second_option' | translate}}</label>\n<textarea class=\"form-control\" rows=\"2\" id=\"optional2\" ng-model=\"$ctrl.model.optional2\" autocomplete=\"off\"></textarea>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.third_option' | translate}}</label>\n<textarea class=\"form-control\" rows=\"2\" id=\"optional3\" ng-model=\"$ctrl.model.optional3\" autocomplete=\"off\"></textarea>\n</div>\n<div class=\"_form-group col-sm-4\">\n<label>{{'branch_mgmt.orders_selectATMs' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.bankSourceId\" values=\"$ctrl.model.fundingSourceObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.fundingSourceObj.totalRecords\" class=\"order-profile-dd-z-index\" ng-disabled=\"$ctrl.model.fundingSourceObj.loading\" on-click=\"$ctrl.getLocationDenoms(searchKey, offset); $ctrl.setAlwaysSwapRatio();\" onscroll=\"$ctrl.getAllFundingSource(searchKey, offset)\" none-selected=\"'checkinSelectionModal.select'\">\n</search-and-select>\n</div>\n<div class=\"_form-group col-sm-4\">\n<label>{{'location.contract_expiration_date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"end-date\" ng-model=\"$ctrl.model.contractExpirationDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" date-options=\"$ctrl.startMaxDate\" show-button-bar=\"false\" ng-class=\"{'datetimepicker': !$ctrl.model.contractExpirationDate, 'disabled': $ctrl.loading}\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n<div class=\"_form-group col-sm-4\" ng-class=\"{'has-error': !$ctrl.isValidTargetStopTime()}\">\n<label for=\"targetStopTime\">{{'location.target_stop_time' | translate }}</label>\n<time-picker format=\"hh:mm a\" ng-model=\"$ctrl.model.targetStopTime\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n<span class=\"text-danger\" ng-if=\"!$ctrl.isValidTargetStopTime()\">Target Stop Time must be at least 1 minute</span>\n</div>\n</div>\n<div class=\"col-sm-12 toggle-grid-container\">\n<div id=\"inline\" class=\"form-group\" ng-if=\"($ctrl.model._type !== 'REGULAR')\">\n<label for=\"handleAtmLikeRegular\">{{'location.route_like_regular' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.handleAtmLikeRegular\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"ATMTransfer\" class=\"form-group\" ng-if=\"($ctrl.model._type === 'ATM') && $ctrl.model.setupDetails.ATMTransfer\">\n<label for=\"ATMTransfer\">{{'setup.atm_transfer' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.ATMTransfer\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"secondaryLock\" class=\"form-group\" ng-if=\"($ctrl.model._type === 'ATM')\">\n<label for=\"secondaryLock\">{{'location.secondary_lock' | translate}}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.secondaryLock\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group\">\n<label for=\"deliveryCutoff\">{{'location.deliveryCutoff' | translate }}</label>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.deliveryCutOff\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"form-group remove-left-pad\" ng-if=\"$ctrl.model.deliveryCutOff\">\n<label for=\"routeCutoff\">{{'location.deliveryCutoffTime' | translate }}</label>\n<time-picker format=\"hh:mm a\" ng-model=\"$ctrl.model.deliveryCutOffTime\" ng-required=\"$ctrl.model.deliveryCutOff\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div class=\"form-group\" ng-if=\"['ATM', 'BANK', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'DELIVERY'].indexOf($ctrl.model._type) !== -1\">\n<label for=\"pickupSLA\">{{'location.pickup_sla' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.pickupSLA\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.model.pickupSLA && ['ATM', 'BANK', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'DELIVERY'].indexOf($ctrl.model._type) !== -1\">\n<label for=\"pickupSLATime\">{{'location.pickup_request_time' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.pickupSLATime\" ng-required=\"$ctrl.model.pickupSLA\" ng-options=\"time.requestTimeSelection as time.requestTimeSelection for time in $ctrl.pickupRequestTimes\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group\" ng-if=\"['ATM', 'BANK', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'DELIVERY'].indexOf($ctrl.model._type) !== -1\">\n<label for=\"autoRerouteMissed\">{{'location.auto_reroute_missed' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.autoRerouteMissed\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group\" ng-if=\"['ATM', 'BANK', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'DELIVERY'].indexOf($ctrl.model._type) !== -1\">\n<label for=\"monthlyCashCountLimit\" style=\"white-space: nowrap;\">Monthly Cash Count Limit</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.monthlyCashCountLimit\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.model.monthlyCashCountLimit && ['ATM', 'BANK', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'DELIVERY'].indexOf($ctrl.model._type) !== -1\">\n<label for=\"monthlyCashCountLimitAmount\" style=\"white-space: nowrap;\">Monthly Cash Count Limit Amount</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.monthlyCashCountLimitAmount\" ng-required=\"$ctrl.model.monthlyCashCountLimit\" ng-currency/>\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.model._type === 'ATM'\">\n<label for=\"packResidual\">{{'location.pack_residual' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.packResidual\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.model._type === 'ATM'\">\n<label for=\"coinPermitted\">{{'location.coin_permitted' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.coinPermitted\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"($ctrl.model._type == 'ATM' || $ctrl.model._type == 'ON_CALL') && $ctrl.model.bankSourceId.atmForecasting === true\">\n<h4>{{'location.branch_funding_source_controls' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankSourceId.atmForecasting === true\">\n<label>{{'location.foreCasting_Method' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.forecastingStrategy\" required ng-options=\"forecasting.value as forecasting.label for forecasting in $ctrl.foreCastingList\">\n<option disabled=\"disabled\" value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankSourceId.atmForecasting === true\">\n<label>{{'location.liabilityThreshold' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"liabilityThreshold\" placeholder=\"$0.00\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"$ctrl.model.liabilityThreshold\">\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankSourceId.atmForecasting === true\">\n<label>{{'location.securityThreshold' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"securityThreshold\" placeholder=\"$0.00\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"$ctrl.model.securityThreshold\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.balanceType' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.balanceType\" ng-change=\"$ctrl.onFlowThresholdBlur(); $ctrl.resetFlowThreshold()\" ng-options=\"type.value as type.label for type in $ctrl.balanceTypes\" required>\n<option disabled=\"disabled\" value=\"\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label>{{'location.forecastingFlowDirection' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.forecastingFlowDirection\" required ng-options=\"type.value as type.label for type in $ctrl.forecastingFlowDirection\">\n<option disabled=\"disabled\" value=\"\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.balanceType !== 'PERCENTAGE'\">\n<label>{{'location.flowThreshold' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"flowThreshold\" placeholder=\"$0.00\" ng-model=\"$ctrl.model.flowThreshold\" required ng-currency onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.balanceType === 'PERCENTAGE'\">\n<label>{{'location.flowThreshold' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"flowThresholdPercent\" placeholder=\"0.0%\" ng-model=\"$ctrl.model.flowThreshold\" required ng-blur=\"$ctrl.onFlowThresholdBlur()\" ng-focus=\"$ctrl.onFlowThresholdFocus()\" pattern=\"^(?:100(?:\\.0{1,3})?|[0-9]{1,2}(?:\\.[0-9]{1,3})?)%?$\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.bankSourceId.atmForecasting === true\">\n<label>{{'location.fallbackFillRate' | translate}}</label>\n<input type=\"text\" class=\"form-control\" placeholder=\"0.0000%\" ng-model=\"$ctrl.fallbackFillRateDisplay\" ng-disabled=\"true\"/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 _margin-top-10\" ng-if=\"($ctrl.model._type == 'ATM' || $ctrl.model._type == 'LOCKER') && $ctrl.model.secondaryLock\">\n<h4>{{'location.secondary_lock_section' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div id=\"inline\" class=\"form-group col-sm-4\">\n<label for=\"name\">{{'location.secondary_lock_id' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"secondary_loc_id\" required ng-model=\"$ctrl.model.secondaryLockId\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\">\n</div>\n<div id=\"secondary_lock_type\" class=\"form-group col-sm-4\">\n<label>{{'location.lockType' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.secondaryLockType\" ng-change=\"$ctrl.resetOTCCompany();\" ng-options=\"lockType.value as lockType.label for lockType in $ctrl.lockTypes\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div id=\"secondary_lock_otc_company_name\" class=\"form-group col-sm-4\">\n<label>{{'location.otc_company_name' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.secondaryLockOTCCompanyName\" ng-disabled=\"$ctrl.model.secondaryLockType === 'static'\" ng-options=\"companyName.value as companyName.label for companyName in $ctrl.OTCCompanyNameList\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div id=\"inline\" class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.secondaryLockType === 'static'\">\n<label>{{'location.static_open_code' | translate }}</label>\n<input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.secondaryLockStaticOpenCode\" id=\"static-open-code\" ng-attr-type=\"{{ $ctrl.passWdIcon['secondary'].viewStaticOpenCode ? 'text' : 'password'}}\">\n<div class=\"password-icon\" ng-click=\"$ctrl.showPassword('secondary', 'viewStaticOpenCode')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['secondary'].viewStaticOpenCode ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\" ng-hide=\"$ctrl.model.secondaryLockType === 'static'\">\n<label for=\"secondary_lock_close_req\">{{'location.close_req' | translate }}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.secondaryLockCloseReq\" type=\"checkbox\"/>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-2\" ng-hide=\"$ctrl.model.secondaryLockType === 'static'\">\n<label for=\"secondary_lock_auto_open\">{{'location.auto_open' | translate}}</label>\n<div class=\"margin-top-02\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.secondaryLockAutoOpen\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 location-schedule-section margin-bottom-10\" ng-if=\"$ctrl.model._type == 'ATM' || $ctrl.model._type === 'ON_CALL'\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<h4>{{'location.location_slots' | translate}}</h4>\n</div>\n<div class=\"col-sm-6\" ng-show=\"::$ctrl.hasACL['edit']\">\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn\" ng-click=\"$ctrl.createLocationSlots()\" style=\"margin-right: 5px;\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 font-12 remove-right-pad margin-top-5\" ng-if=\"$ctrl.model.locationSlots && $ctrl.model.locationSlots.length > 0\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad row div-tr loc-schedule\" style=\"width: 990px;\">\n<div class=\"col-sm-1 div-td\">\n<div class=\"dt\">\n<strong>{{'location.slot' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-5 div-td\">\n<div class=\"dt\">\n<strong>{{'location.denomination' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-5 div-td\">\n<div class=\"dt\">\n<strong>{{'location.tracking_id' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\" style=\"width: 10%;\">\n<div class=\"dt\"><strong>{{'bulkCash.action' | translate}}</strong></div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" style=\"width: 990px;\">\n<ul class=\"list-group location-sequence remove-bottom-margin\">\n<li ng-repeat=\"slot in $ctrl.model.locationSlots track by $index\" class=\"remove-bottom-margin display-flex border-bottom\">\n<span ng-if=\"slot.isDuplicate\" class=\"glyphicon glyphicon-warning-sign scheduled-location-alert\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\">\n</span>\n<div class=\"col-sm-1 div-td\">\n<div class=\"dt text-center\" style=\"font-weight: bold;margin-top: 8px;font-size: 14px;\">\n{{$index + 1}}\n</div>\n</div>\n<div class=\"col-sm-5 div-td order-profile-dd-z-index\">\n<div class=\"dt\">\n<search-and-select ng-model=\"slot.denominationId\" values=\"$ctrl.model.locationSlotDenominations.results\" key=\"Key\" totalrecords=\"$ctrl.model.locationSlotDenominations.totalRecords\" none-selected=\"'common.none'\" common-search-flag=\"true\" ng-click=\"$ctrl.validateDenominationSelected(); $ctrl.createLocationRecurringLoad(); $ctrl.checkDenomKeyExists()\" ng-disabled=\"!slot.isEditing\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-5 div-td\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" ng-model=\"slot.slotTrackingId\" ng-disabled=\"!slot.isEditing\" ng-pattern=\"/^[a-z A-Z 0-9]*$/\" ng-change=\"$ctrl.validateLocationSlotsDuplicate()\">\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\" style=\"width: 10%;\">\n<div class=\"dt\">\n<button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"$ctrl.editLocationSlot($index)\">\n<span class=\"glyphicon glyphicon-edit\" uib-tooltip=\"{{'edit' | translate }}\" tooltip-placement=\"top\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.deleteLocationSlotsSelected($index)\">\n<span class=\"glyphicon glyphicon-remove\" uib-tooltip=\"{{'batch.tooltip_del' | translate }}\" tooltip-placement=\"top\"></span>\n</button>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-05\" ng-if=\"!$ctrl.model.locationSlots || $ctrl.model.locationSlots.length === 0\">\n<div class=\"alert remove-bottom-margin alert-info\">\nNo location slots configured\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model._type == 'ATM'\">\n<div class=\"col-sm-12 remove-left-pad\">\n<h4 id=\"inline\" translate=\"location.dispense_strategy\"></h4>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label>{{'location.atm_empty_calculation_method' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.atmEmptyAtCalculationMethod\" required ng-options=\"atmEmptyAtCalculationMethod.value as atmEmptyAtCalculationMethod.label for atmEmptyAtCalculationMethod in $ctrl.atmEmptyAtCalculationMethodList\">\n<option disabled=\"disabled\" value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'PERCENT_CHANGE'\">\n<label>{{'location.aec_percent_change_value' | translate}}</label>\n<input type=\"text\" ng-model=\"$ctrl.model.aecPercentChangeValue\" id=\"aecPercentChangeValue\" class=\"form-control\" pattern=\"^(?:0*(?:\\.\\d+)?|1(\\.0*)?)(%)?$\" ng-blur=\"$ctrl.ngPercentage()\" ng-focus=\"$ctrl.removePercentageSign($ctrl.model.aecPercentChangeValue)\" required/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'PERCENT_CHANGE'\">\n<label>{{'location.aec_percent_change_period_A' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecPercentChangePeriodA\" ng-model=\"$ctrl.model.aecPercentChangePeriodA\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'PERCENT_CHANGE'\">\n<label>{{'location.aec_percent_change_period_B' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecPercentChangePeriodB\" ng-model=\"$ctrl.model.aecPercentChangePeriodB\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'WEIGHTED_AVG'\">\n<label>{{'location.aec_weighted_avg_weight_A' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecWeightedAvgWeightA\" ng-model=\"$ctrl.model.aecWeightedAvgWeightA\" pattern=\"^(?:0*(?:\\.\\d+)?|1(\\.0*)?)$\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'WEIGHTED_AVG'\">\n<label>{{'location.aec_weighted_avg_period_A' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecWeightedAvgPeriodA\" ng-model=\"$ctrl.model.aecWeightedAvgPeriodA\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'WEIGHTED_AVG'\">\n<label>{{'location.aec_weighted_avg_weight_B' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecWeightedAvgWeightB\" ng-model=\"$ctrl.model.aecWeightedAvgWeightB\" pattern=\"^(?:0*(?:\\.\\d+)?|1(\\.0*)?)$\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'WEIGHTED_AVG'\">\n<label>{{'location.aec_weighted_avg_period_B' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecWeightedAvgPeriodB\" ng-model=\"$ctrl.model.aecWeightedAvgPeriodB\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.atmEmptyAtCalculationMethod === 'SINGLE'\">\n<label>{{'location.aec_single_period' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"aecSinglePeriod\" ng-model=\"$ctrl.model.aecSinglePeriod\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" required>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model._type === 'ATM' && $ctrl.model.bankSourceId\">\n<label for=\"\">{{'location.addToSwapRatio' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.addToSwapRatio\" required ng-options=\"addToSwapRatio.value as addToSwapRatio.label for addToSwapRatio in $ctrl.addToSwapRatioOptions\">\n<option disabled=\"disabled\" value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"['TRUCK', 'INTERNAL', 'TANKER', 'WINDOW', 'CARRIER'].indexOf($ctrl.model._type) === -1\">\n<div class=\"col-sm-12 remove-left-pad\">\n<h4 id=\"inline\" translate=\"location.routeAssignment\"></h4>\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{ 'location.tooltip_info' | translate }}\" tooltip-placement=\"top\"></span>\n<div id=\"inline\" class=\"form-group checkbox pull-right\">\n<label>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameAll()\" ng-model=\"$ctrl.model.sameForAll\"/>\n<strong>{{'location.sameForAll' | translate }}</strong>\n</label>\n</div>\n</div>\n<div class=\"col-sm-12 week-day-section\">\n<table class=\"table table-striped weekdays-table table-bordered\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th ng-repeat=\"day in $ctrl.days.slice(0, 4)\">{{day.label}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'location.route'|translate}}</th>\n<td class=\"location-route-assignment-section col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(0, 4) track by $index\">\n<search-and-select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) === -1\" ng-model=\"$ctrl.model[day.value].routeId\" set-id=\"route-{{day.id}}\" on-click=\"$ctrl.updateAll(day.value,'routeId')\" values=\"$ctrl.dayArray[$index][day.value]\" key=\"Key\" totalrecords=\"$ctrl.total[$index][day.value].total\" onscroll=\"$ctrl.loadDaysRoutes(searchKey, offset, $index, day.value)\" none-selected=\"'common.none'\" long-dd-width-flag=\"true\"></search-and-select>\n</td>\n</tr>\n<tr ng-if=\"false\">\n<th class=\"col-xs-1\">{{'location.stop'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(0, 4)\">\n<select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL'].indexOf($ctrl.model._type) === -1\" class=\"form-control\" ng-model=\"$ctrl.model[day.value].stops\" ng-options=\"stops.value as stops.label for stops in $ctrl.day.stops\" ng-change=\"$ctrl.updateAll(day.value,'stops')\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr ng-if=\"false\">\n<th class=\"col-xs-1\">{{'location.when'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(0, 4)\">\n<select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL'].indexOf($ctrl.model._type) === -1\" class=\"form-control\" ng-model=\"$ctrl.model[day.value].options\" ng-options=\"options.value as options.label for options in $ctrl.day.options\" ng-change=\"$ctrl.updateAll(day.value,'options')\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</td>\n</tr>\n</tbody>\n</table>\n<table class=\"table weekend-table table-striped table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th class=\"col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(4)\">{{day.label}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'location.route'|translate}}</th>\n<td class=\"location-route-assignment-section col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(4) track by $index\">\n<search-and-select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) === -1\" ng-model=\"$ctrl.model[day.value].routeId\" set-id=\"route-{{day.id}}\" on-click=\"$ctrl.updateAll(day.value,'routeId')\" values=\"$ctrl.dayArray[$index+4][day.value]\" key=\"Key\" totalrecords=\"$ctrl.total[$index+4][day.value].total\" onscroll=\"$ctrl.loadDaysRoutes(searchKey, offset, $index+4, day.value)\" none-selected=\"'common.none'\" long-dd-width-flag=\"true\"></search-and-select>\n</td>\n</tr>\n<tr ng-if=\"false\">\n<th class=\"col-xs-1\">{{'location.stop'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.days.slice(4)\">\n<select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL'].indexOf($ctrl.model._type) === -1\" class=\"form-control\" ng-model=\"$ctrl.model[day.value].stops\" ng-options=\"stops.value as stops.label for stops in $ctrl.day.stops\" ng-change=\"$ctrl.updateAll(day.value,'stops')\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr ng-if=\"false\">\n<th>{{'location.when'|translate}}</th>\n<td ng-repeat=\"day in $ctrl.days.slice(4)\">\n<select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL'].indexOf($ctrl.model._type) === -1\" class=\"form-control\" ng-model=\"$ctrl.model[day.value].options\" ng-options=\"options.value as options.label for options in $ctrl.day.options\" ng-change=\"$ctrl.updateAll(day.value,'options')\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad location-schedule-section margin-10\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<h4>{{'location.ad_hoc_stop' | translate}}</h4>\n</div>\n<div class=\"col-sm-6 pull-right remove-right-pad\" ng-show=\"::$ctrl.hasACL['edit']\">\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn\" ng-click=\"$ctrl.createLocationScheduled()\" ng-disabled=\"$ctrl.isLoading\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n</div>\n</div>\n<div class=\"col-sm-12 div-table font-12 remove-right-pad\">\n<div class=\"row div-tr loc-schedule\">\n<div class=\"col-sm-5 div-td\">\n<div class=\"dt\">\n<strong>{{'closeVault.currentVaultDate' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-5 div-td\">\n<div class=\"dt\">\n<strong>{{'checkout.routeId' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td\">\n<div class=\"dt\">\n<strong>{{'itemHolds.routeSequence' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\"><strong>Action</strong></div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<ul class=\"list-group location-sequence remove-bottom-margin\">\n<li ng-repeat=\"locObj in $ctrl.model.scheduledLocations track by $index\" class=\"remove-bottom-margin display-flex border-bottom\">\n<div class=\"col-sm-5 div-td\">\n<span ng-if=\"locObj.isDuplicate\" class=\"glyphicon glyphicon-warning-sign scheduled-location-alert\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\">\n</span>\n<div class=\"dt atm-codes-date-picker-section\">\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"locObj.vaultDate\" date-format=\"dd-MMM-yyyy\" ng-click=\"loadRoutes()\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !locObj.vaultDate}\" ng-keydown=\"$event.preventDefault()\" ng-change=\"$ctrl.validateScheduledLocation();\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"col-sm-5 div-td\">\n<div class=\"dt\">\n<search-and-select ng-model=\"locObj.routeId\" required=\"true\" values=\"$ctrl.model.routeListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.routeListObj.totalRecords\" onscroll=\"$ctrl.routeList(searchKey, offset)\" none-selected=\"'common.none'\" long-dd-width-flag=\"true\"></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-1 div-td\">\n<div class=\"dt\">\n<input type=\"number\" class=\"form-control\" ng-model=\"locObj.sequence\" min=\"0\" required>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.deleteScheduledLocation($index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad recurring-stop-section margin-10\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<h4>{{'location.combined_route_assignment' | translate}}</h4>\n</div>\n</div>\n<div class=\"col-sm-12 week-day-section\">\n<table class=\"table table-striped weekdays-table table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th>{{'location.day.routeId' | translate}}</th>\n<th>{{'branchFundingSource.interval' | translate}}</th>\n<th>{{'routeProgress.sequence' | translate}}</th>\n<th>{{'customer.startDate' | translate}}</th>\n<th></th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"route in $ctrl.combinedRoutes track by $index\" ng-if=\"$index < 7\">\n<th class=\"col-xs-1\">{{route.day.label | translate}}</th>\n<td class=\"location-route-assignment-section col-sm-3\">\n<search-and-select ng-required=\"((route.anchorDate || route.interval) ? !route.route : false)\" ng-model=\"route.route\" set-id=\"route-{{route.day.value}}\" values=\"$ctrl.dayArray[$index][route.day.value]\" key=\"Key\" totalrecords=\"$ctrl.total[$index][route.day.value].total\" onscroll=\"$ctrl.loadDaysRoutes(searchKey, offset, $index, route.day.value)\" none-selected=\"'common.none'\" long-dd-width-flag=\"true\" on-click=\"$ctrl.createLocationRecurringLoad(); $ctrl.validateDeleteRecurringStops(route);\"></search-and-select>\n</td>\n<td ng-if=\"route.isVisible\" class=\"location-route-assignment-section\">\n<select class=\"form-control\" ng-model=\"route.interval\" required=\"false\" ng-options=\"interval.label for interval in route.combinedRouteIntervals\" ng-required=\"((route.anchorDate || route.route) ? !route.interval : false)\" ng-change=\"$ctrl.validateRecurringLocation(); $ctrl.validateRouteAssignment(); $ctrl.validateDeleteRecurringStops(route);\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</td>\n<td ng-if=\"route.isVisible\" class=\"location-route-assignment-section col-xs-1\">\n<input type=\"number\" class=\"form-control\" ng-model=\"route.sequence\" min=\"1\" ng-change=\"$ctrl.validateRouteAssignment();\" ng-required=\"((route.anchorDate || route.route || route.interval) ? !route.sequence : false)\">\n</td>\n<td ng-if=\"route.isVisible\" class=\"atm-codes-date-picker-section col-sm-3\">\n<div class=\"input-group\">\n<datetimepicker class=\"datetimepicker-input\" key=\"{{$index}}\" id=\"{{$index}}\" ng-model=\"route.anchorDate\" date-format=\"dd-MMM-yyyy\" ng-click=\"loadRoutes()\" hidden-time=\"true\" show-button-bar=\"true\" date-disabled=\"$ctrl.disableDays(date, mode, route.day)\" ng-change=\"$ctrl.recheckMonthlyOccurences(route.anchorDate, route.day, $index); $ctrl.validateRouteAssignment(); $ctrl.validateDeleteRecurringStops(route);\" timezone=\"UTC\" ng-required=\"((route.route || route.interval) ? !route.anchorDate : false)\" ng-class=\"{'required-datetimepicker': ((route.route || route.interval) ? !route.anchorDate : false)}\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n</td>\n<td ng-if=\"route.isVisible\" class=\"d-flex gap-5\">\n<button type=\"button\" ng-click=\"$ctrl.showNextScheduledOccurences(route)\" class=\"btn btn-primary\" ng-disabled=\"!route.interval || !route.anchorDate || !route.day || !route.interval.label || !$ctrl.model.status\">\n<span class=\"glyphicon glyphicon-refresh\" uib-tooltip=\"{{'routeAssugment.view_next_occurences' | translate}}\" tooltip-placement=\"top\">\n</span>\n</button>\n<button type=\"button\" class=\"btn btn-danger\" ng-click=\"$ctrl.deleteCombinedRoute(route); $ctrl.validateRouteAssignment();\" ng-disabled=\"!route.id\">\n<span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"{{'common.Delete' | translate}}\" tooltip-placement=\"top\">\n</span>\n</button>\n</td>\n</tr>\n<tr ng-if=\"$ctrl.combinedRoutes.length > 7\">\n<th class=\"col-xs-1\">{{ $ctrl.combinedRoutes[7].day.label | translate }}</th>\n<td class=\"location-route-assignment-section col-sm-3\">\n<search-and-select ng-disabled=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'TRUCK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) === -1\" ng-required=\"(($ctrl.combinedRoutes[7].anchorDate || $ctrl.combinedRoutes[7].interval) ? !$ctrl.combinedRoutes[6].route : false)\" ng-model=\"$ctrl.model[$ctrl.combinedRoutes[7].day.value].routeId\" set-id=\"route-{{$ctrl.combinedRoutes[7].day.value}}\" values=\"$ctrl.dayArray[7][$ctrl.combinedRoutes[7].day.value]\" key=\"Key\" totalrecords=\"$ctrl.total[7][$ctrl.combinedRoutes[7].day.value].total\" onscroll=\"$ctrl.loadDaysRoutes(searchKey, offset, 7, $ctrl.combinedRoutes[7].day.value)\" none-selected=\"'common.none'\" long-dd-width-flag=\"true\" on-click=\"$ctrl.updateAll($ctrl.combinedRoutes[7].day.value,'routeId')\"></search-and-select>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad location-schedule-section margin-10\" ng-show=\"['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<h4>{{'orderPacking.denominations' | translate}}</h4>\n</div>\n<div class=\"col-sm-6 pull-right remove-right-pad\" ng-show=\"::$ctrl.hasACL['edit']\">\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn\" style=\"margin-right: 15px !important;\" ng-click=\"$ctrl.createLocationDenomination()\" ng-disabled=\"$ctrl.isLoading || $ctrl.model.selectedDenomination.length === $ctrl.filteredDenominations.totalRecords\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n</div>\n</div>\n<div class=\"col-sm-12 font-12\">\n<div class=\"row div-tr loc-schedule\">\n<div class=\"col-sm-3 div-td\" style=\"width: 25%;\">\n<div class=\"dt\">\n<strong>{{'atm_residual.denomination' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'location.max_load' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-3 div-td\">\n<div class=\"dt\">\n<strong>{{'location.min_residual_threshold' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-3 div-td\">\n<div class=\"dt\">\n<strong>{{'location.max_residual_threshold' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\" style=\"width: 10%;\">\n<div class=\"dt\"><strong>{{'bulkCash.action' | translate}}</strong></div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<ul class=\"list-group location-sequence remove-bottom-margin\">\n<li ng-repeat=\"denomObj in $ctrl.model.selectedDenomination track by $index\" class=\"remove-bottom-margin display-flex border-bottom\">\n<div class=\"col-sm-3 div-td order-profile-dd-z-index\" style=\"width: 25%;\">\n<span ng-if=\"denomObj.isDuplicate\" class=\"glyphicon glyphicon-warning-sign scheduled-location-alert\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\">\n</span>\n<div class=\"dt order-profile-dd-z-index\">\n<search-and-select ng-model=\"denomObj.denomination\" values=\"$ctrl.filteredDenominations.results\" key=\"Key\" totalrecords=\"$ctrl.filteredDenominations.totalRecords\" long-dd-width-flag=\"true\" none-selected=\"'common.none'\" common-search-flag=\"true\" ng-click=\"$ctrl.validateDenominationSelected(); $ctrl.createLocationRecurringLoad(); $ctrl.checkDenomKeyExists(); $ctrl.checkForMaxLoadFaceValueDivisibility()\" ng-disabled=\"(denomObj.isDisabled && !denomObj.isEditing)\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" ng-model=\"denomObj.maxLoad\" ng-currency min=\"0\" ng-class=\"{'invalid-amount' : denomObj.denomination && denomObj.isMaxLoadValid === false}\" ng-disabled=\"(denomObj.isDisabled && !denomObj.isEditing) || (denomObj.disableFields)\" placeholder=\"{{'location.max_load' | translate}}\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46 || event.charCode === 0\" ng-change=\"$ctrl.checkForMaxLoadFaceValueDivisibility()\" required>\n</div>\n</div>\n<div class=\"col-sm-3 div-td\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" ng-model=\"denomObj.minResidualThresholdPercentage\" ng-blur=\"$ctrl.ngResidualPercentage($index,'min')\" ng-focus=\"$ctrl.removeResidualPercentageSign($index,'min')\" ng-disabled=\"(denomObj.isDisabled && !denomObj.isEditing) || (denomObj.disableFields)\" pattern=\"^(?:100(?:\\.0{1,3})?|[0-9]{1,2}(?:\\.[0-9]{1,3})?)%?$\" placeholder=\"{{'location.min_residual_threshold' | translate}}\" required/>\n</div>\n</div>\n<div class=\"col-sm-3 div-td\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" ng-model=\"denomObj.maxResidualThresholdPercentage\" ng-blur=\"$ctrl.ngResidualPercentage($index,'max')\" ng-focus=\"$ctrl.removeResidualPercentageSign($index,'max')\" ng-disabled=\"(denomObj.isDisabled && !denomObj.isEditing) || (denomObj.disableFields)\" pattern=\"^(?:100(?:\\.0{1,3})?|[0-9]{1,2}(?:\\.[0-9]{1,3})?)%?$\" placeholder=\"{{'location.max_residual_threshold' | translate}}\" required/>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\" style=\"width: 10%;\">\n<div class=\"dt\">\n<button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"$ctrl.editDenominationSelected($index)\" ng-show=\"!$ctrl.isNewRow(denomObj)\">\n<span class=\"glyphicon glyphicon-edit\" uib-tooltip=\"{{'edit' | translate }}\" tooltip-placement=\"top\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.deleteDenominationSelected($index)\">\n<span class=\"glyphicon glyphicon-remove\" uib-tooltip=\"{{'batch.tooltip_del' | translate }}\" tooltip-placement=\"top\"></span>\n</button>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad recurring-stop-section margin-10\" ng-show=\"['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO'].indexOf($ctrl.model._type) > -1\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<h4>{{'location.schedule_recurring_load' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"At least one denomination and a weekly route assignment are required to set a recurring load.\" tooltip-placement=\"top-right\"></span>\n</h4>\n</div>\n</div>\n<div class=\"col-sm-12 week-day-section\" ng-if=\"$ctrl.model.selectedDenomination.length > 0 && $ctrl.checkDenomKeyExists()\">\n<table class=\"table table-striped weekdays-table table-bordered remove-bottom-margin\">\n<thead>\n<tr>\n<th class=\"col-xs-1 weekdays-label\">{{'location.weekday'|translate}}</th>\n<th class=\"text-align-center\" ng-repeat=\"denom in $ctrl.model.selectedDenomination\" ng-if=\"denom.denomination.Value\">\n<img ng-if=\"denom.id !== '1' && denom.denomination.Value\" ng-src=\"assets/images/{{denom.denomination.Value}}.png\" class=\"location-denom-icon-size\"/>\n<img ng-if=\"denom.id == '1'\" src=\"" + __webpack_require__(68) + "\" class=\"location-denom-icon-size\"/>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"location in $ctrl.locationRecurringLoad track by $index\">\n{{location}}\n<th class=\"col-xs-1 text-align-center\">{{location.day.label | translate}}</th>\n<td ng-repeat=\"denom in location.denominations\" ng-if=\"denom.denomination.Value\">\n<input ng-if=\"!denom.denomination.coinFlag\" type=\"text\" class=\"form-control text-center\" ng-model=\"location['recurringLoad'][denom.denomination.Value].amount\" placeholder=\"$0.00\" ng-currency fraction=\"0\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.checkForStrapCount();\" ng-class=\"{'invalid-amount' : location['recurringLoad'][denom.denomination.Value] && !location['recurringLoad'][denom.denomination.Value].isValid}\" ng-disabled=\"!location.hasLocationScheduleRecurring\">\n<input ng-if=\"denom.denomination.coinFlag\" type=\"text\" class=\"form-control text-center\" ng-model=\"location['recurringLoad'][denom.denomination.Value].qty\" placeholder=\"0\" fraction=\"0\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.calculateCoinAmount(location['recurringLoad'][denom.denomination.Value], denom.denomination); $ctrl.checkForStrapCount();\" ng-class=\"{'invalid-amount' : location['recurringLoad'][denom.denomination.Value] && !location['recurringLoad'][denom.denomination.Value].isValid}\" ng-disabled=\"!location.hasLocationScheduleRecurring\">\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.selectedDenomination.length == 0 || !$ctrl.checkDenomKeyExists() \">\n<div class=\"alert alert-info remove-bottom-margin\">\nAt least one denomination and a weekly route assignment are required to set a recurring load.\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10 location-hours-of-operation\">\n<div class=\"col-sm-12 remove-left-pad\">\n<h4 id=\"inline\" translate=\"location.hours_of_operation\"></h4>\n<div id=\"inline\" class=\"form-group checkbox pull-right\">\n<label>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameOperationTime()\" ng-model=\"$ctrl.model.isSameOperationTime\"/>\n<strong>{{'location.sameForAll' | translate }}</strong>\n</label>\n</div>\n</div>\n<div class=\"col-sm-12 hours-of-operation-main-section-z-index\">\n<table class=\"table table-striped weekdays-table table-bordered\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th ng-repeat=\"day in $ctrl.operationDays.slice(0, 4)\">{{day.label}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'location.open_time'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.operationDays.slice(0, 4)\">\n<time-picker ng-model=\"$ctrl.model[$ctrl.openTime+(day.value)]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.updateTime(day.value)\" ng-required=\"($ctrl.model[$ctrl.closeTime+(day.value)] && !$ctrl.model[$ctrl.openTime+(day.value)]) ? true : false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</td>\n</tr>\n<tr>\n<th class=\"col-xs-1\">{{'location.close_time'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.operationDays.slice(0, 4)\">\n<time-picker ng-model=\"$ctrl.model[$ctrl.closeTime+(day.value)]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.updateTime(day.value)\" ng-required=\"($ctrl.model[$ctrl.openTime+(day.value)] && !$ctrl.model[$ctrl.closeTime+(day.value)]) ? true : false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</td>\n</tr>\n</tbody>\n</table>\n<table class=\"table weekend-table table-striped table-bordered\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th class=\"col-xs-2\" ng-repeat=\"day in $ctrl.operationDays.slice(4)\">{{day.label}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'location.open_time'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.operationDays.slice(4)\">\n<time-picker ng-model=\"$ctrl.model[$ctrl.openTime+(day.value)]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.updateTime(day.value)\" ng-required=\"($ctrl.model[$ctrl.closeTime+(day.value)] && !$ctrl.model[$ctrl.openTime+(day.value)]) ? true : false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</td>\n</tr>\n<tr>\n<th class=\"col-xs-1\">{{'location.close_time'|translate}}</th>\n<td class=\"col-xs-2\" ng-repeat=\"day in $ctrl.operationDays.slice(4)\">\n<time-picker ng-model=\"$ctrl.model[$ctrl.closeTime+(day.value)]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.updateTime(day.value)\" ng-required=\"($ctrl.model[$ctrl.openTime+(day.value)] && !$ctrl.model[$ctrl.closeTime+(day.value)]) ? true : false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad\">\n<h4 translate=\"location.seasonOperation\"></h4>\n<div class=\"form-group_ col-sm-6\">\n<label>{{'location.seasonStart' | translate }}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.seasonStart\" date-format=\"{{$ctrl.dateFormat}}\" ng-change=\"$ctrl.isDisabledDate($ctrl.model.seasonStart)\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.dateOptions\"/>\n</div>\n<div class=\"form-group_ col-sm-6 remove-pad\">\n<label>{{'location.seasonEnd' | translate }}</label>\n<button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" ng-click=\"$ctrl.resetSeason()\">{{'common.clear' | translate}}</button>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.seasonEnd\" date-format=\"{{$ctrl.dateFormat}}\" date-options=\"$ctrl.todayMinDate\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'disabled': !$ctrl.model.seasonStart}\">\n</datetimepicker>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.renderDirective\">\n<div>\n<deliver-location ng-model=\"$ctrl.model\" locations=\"$ctrl.locations\" title=\"'location.deliveryToLocations'\" is-valid-directive=\"$ctrl.isValidDirective\" is-edit=\"true\">\n</deliver-location>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<h4 translate=\"location.routeOptions\"></h4>\n<div>\n<div id=\"inline\" class=\"form-group col-sm-4\" ng-show=\"$ctrl.showStopProcess\">\n<label for=\"key-id\">{{'location.stop_process' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.stopProcess\" ng-required=\"$ctrl.showStopProcess\" ng-options=\"stopProcess.value as stopProcess.label for stopProcess in $ctrl.stopProcessList\" ng-change=\"$ctrl.filterStopProcess()\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-4' : $ctrl.showStopProcess, 'col-sm-6': !$ctrl.showStopProcess}\">\n<label>{{'location.maxDepositAmount' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.maxDepositAmount\" ng-currency/>\n</div>\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-4' : $ctrl.showStopProcess, 'col-sm-6': !$ctrl.showStopProcess}\">\n<label for=\"key-id\">{{'location.keyId' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.keyId\"/>\n</div>\n</div>\n<div class=\"location-toggle-section remove-left-pad col-sm-12\">\n<div class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.allowMulti' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.allowMulti\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group remove-left-pad col-sm-3\" ng-if=\"['TANKER', 'TRUCK', 'INTERNAL'].includes($ctrl.model._type)\">\n<label for=\"\">{{'common.side_menu.bulk_transfer' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.bulkTransfer\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group remove-left-pad col-sm-3\" ng-if=\"['BANK', 'DELIVERY'].includes($ctrl.model._type)\">\n<label for=\"\">{{'location.bagoutEnabled' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.bagoutEnabled\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\" ng-if=\"$ctrl.model._type === 'INTERNAL'\">\n<label for=\"\">{{'location.isTransferHoldLocation' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.isTransferHoldLocation\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\" ng-if=\"$ctrl.model._type === 'DELIVERY'\">\n<label for=\"\">{{'location.last_route_stop' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.lastRouteStop\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<h4 translate=\"location.routeNotification\"></h4>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.deliveries' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.RNdeliveries\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"pickups\">{{'location.pickups' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.RNpickups\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"noPickup\">{{'branch_mgmt.routes.bucket_NO_PICKUP' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.RNnoPickup\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"zeroPickup\">{{'location.zeroAmountPickup' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.RNzeroPickup\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-show=\"$ctrl.model._type == 'BANK'\">\n<div class=\"form-group col-sm-3\">\n<label for=\"\">{{ 'location.centralBank' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" style=\"width: 25%;\" ng-model=\"$ctrl.model.centralBank\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<h4 translate=\"location.transactionRequirments\"></h4>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-12 remove-left-pad\">\n<h4 id=\"inline\" class=\"_col-sm-2\" for=\"\">{{'location.scan' | translate }}</h4>\n</div>\n<div class=\"col-sm-12 _location-receipts-section\">\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.lastTransaction' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.lastTransaction\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location._leave' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model._leave\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.scan_bagout_pieces' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.deliverBagOutPiece\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\" ng-if=\"['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf($ctrl.model._type) > -1\">\n<label for=\"\">{{'location.verifyToTruck' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"ON\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.verifyToTruck\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\" ng-if=\"$ctrl.model.verifyToTruck && ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf($ctrl.model._type) > -1\">\n<label for=\"\">{{'location.verifyCoinToTruck' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.verifyCoinToTruck\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\" ng-show=\"$ctrl.model._type=='ATM'\">\n<label for=\"\">{{'location.atmCassette' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.atmCassette\" ng-change=\"$ctrl.onAtmCassetteChange()\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\" ng-if=\"$ctrl.model.atmCassette && $ctrl.model._type=='ATM'\">\n<label for=\"maxCassettes\">{{'location.maxCassettes' | translate }}</label>\n<br>\n<input type=\"number\" id=\"maxCassettes\" name=\"maxCassettes\" class=\"form-control atm-cassette-max-input\" ng-model=\"$ctrl.model.maxCassettes\" min=\"1\" max=\"6\" ng-required=\"$ctrl.model.atmCassette\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.packCoinSeparately' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.packCoinSeparately\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\" ng-show=\"$ctrl.model._type=='ATM'\">\n<label for=\"\">{{'location.captureDenomStc' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"ON\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.captureDenomStc\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad\">\n<h4 id=\"inline\" class=\"_col-sm-2\" for=\"\">{{'location.receipts' | translate }}</h4>\n</div>\n<div class=\"col-sm-12 _location-receipts-section\">\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.TRdeliveries' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.TRdeliveries\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.TRpickups' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.TRpickups\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.print_delivery_manifest' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.printDeliveryManifest\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.pod_receipt' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.podReceipt\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad\" ng-if=\"$ctrl.model._type === 'DELIVERY' || $ctrl.model._type === 'BANK' || $ctrl.model._type === 'ON_CALL' || $ctrl.model._type === 'REGULAR'\">\n<h4 id=\"inline\" class=\"_col-sm-2\" for=\"\">{{'location.data_exchange' | translate }}</h4>\n</div>\n<div class=\"col-sm-12 _location-receipts-section\" ng-if=\"$ctrl.model._type === 'DELIVERY' || $ctrl.model._type === 'BANK' || $ctrl.model._type === 'ON_CALL' || $ctrl.model._type === 'REGULAR'\">\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"\">{{'location.sendManifestOnDelivery' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.sendManifestOnDelivery\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" ng-show=\"$ctrl.model.sendManifestOnDelivery\" class=\"form-group col-sm-3\">\n<label for=\"manifestType\">{{'location.manifestType' | translate }}</label>\n<select class=\"form-control\" id=\"manifestType\" name=\"manifestType\" ng-model=\"$ctrl.model.manifestType\" ng-required=\"$ctrl.model.sendManifestOnDelivery\" ng-options=\"type.value as type.label for type in $ctrl.manifestTypeList\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div id=\"inline\" ng-show=\"$ctrl.model.sendManifestOnDelivery\" class=\"form-group col-sm-3\">\n<label for=\"manifestRecipientEmail\">{{'location.manifestRecipientEmail' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.manifestRecipientEmail\" ng-class=\"{'ng-invalid': !$ctrl.hasValidEmails($ctrl.model.manifestRecipientEmail, $ctrl.model.manifestType !== 'bin_manifest_transport'), 'ng-valid': $ctrl.hasValidEmails($ctrl.model.manifestRecipientEmail, $ctrl.model.manifestType !== 'bin_manifest_transport')}\" ng-change=\"$ctrl.emailValidation = $ctrl.hasValidEmails($ctrl.model.manifestRecipientEmail, $ctrl.model.manifestType !== 'bin_manifest_transport')\" ng-pattern=\"/^(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+\\s?,)*(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+)$/\" ng-required=\"$ctrl.model.sendManifestOnDelivery && $ctrl.model.manifestType !== 'bin_manifest_transport'\" placeholder=\"\"/>\n</div>\n<div id=\"inline\" ng-show=\"$ctrl.model.sendManifestOnDelivery && $ctrl.model.manifestType === 'bin_manifest_transport'\" class=\"form-group col-sm-3\">\n<label for=\"zeroAmountPickupRecipientEmail\">{{'location.zeroAmountPickupRecipientEmail' | translate }}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.zeroAmountPickupRecipientEmail\" ng-class=\"{'ng-invalid': !$ctrl.hasValidEmails($ctrl.model.zeroAmountPickupRecipientEmail, false), 'ng-valid': $ctrl.hasValidEmails($ctrl.model.zeroAmountPickupRecipientEmail, false)}\" ng-change=\"$ctrl.zeroAmountEmailValidation = $ctrl.hasValidEmails($ctrl.model.zeroAmountPickupRecipientEmail, false)\" ng-pattern=\"/^(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+\\s?,)*(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+)$/\" placeholder=\"\"/>\n</div>\n<div id=\"inline\" ng-show=\"$ctrl.model.sendManifestOnDelivery\" class=\"form-group col-sm-3\">\n<label for=\"manifestFileType\">{{'location.manifestFileType' | translate }}</label>\n<select class=\"form-control\" id=\"manifestFileType\" name=\"manifestFileType\" ng-model=\"$ctrl.model.manifestFileType\" ng-required=\"$ctrl.model.sendManifestOnDelivery\" ng-options=\"fileType.value as fileType.label for fileType in $ctrl.manifestFileType\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12\">\n<h4 id=\"inline\" translate=\"location.GPSlocation\">{{$ctrl.model.latitude}}</h4>\n<button type=\"button\" uib-tooltip=\"{{'location.auto_detect' | translate }}\" tooltip-placement=\"top\" class=\"btn btn-primary btn-xs autoDetect\" ng-click=\"$ctrl.autoDetect()\" ng-disabled=\"$ctrl.loading || $ctrl.model.updatingDrivingDistance\">\n{{'location.autoDetect' | translate}}</button>\n</div>\n<div class=\"col-sm-12\" map-lazy-load=\"//maps.google.com/maps/api/js\" map-lazy-load-params=\"{{$ctrl.apiKey}}\" ng-if=\"$ctrl.render\">\n<ng-map id=\"map\" on-click=\"$ctrl._map($event)\" center=\"{{$ctrl.getCenter()}}\">\n<marker position=\"{{$ctrl.model.latitude}},{{$ctrl.model.longitude}}\" draggable=\"true\" on-dragend=\"$ctrl.onMarkerDragEnd($event)\"></marker>\n</ng-map>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10\">\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-3': ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) > -1 && $ctrl.maintainDriveDistance,\n\t\t\t\t\t 'col-sm-6': ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) === -1 || !$ctrl.maintainDriveDistance}\">\n<label>{{'location.latitude' | translate }} </label>\n<input id=\"lat\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.latitude\" ng-change=\"$ctrl.setMarkerPosition(null, null);$ctrl.getAddressFromLatLng($ctrl.model.latitude, $ctrl.model.longitude)\">\n</div>\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-3': ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) > -1 && $ctrl.maintainDriveDistance,\n\t\t\t\t\t 'col-sm-6': ['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) === -1 || !$ctrl.maintainDriveDistance}\">\n<label>{{'location.longitude' | translate }} </label>\n<input id=\"lng\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.longitude\" ng-change=\"$ctrl.setMarkerPosition(null, null);$ctrl.getAddressFromLatLng($ctrl.model.latitude, $ctrl.model.longitude)\">\n</div>\n<div ng-if=\"['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf($ctrl.model._type) > -1 && $ctrl.maintainDriveDistance\">\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.distanceFromBranch' | translate }} </label>\n<input id=\"lng\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.distanceFromBranch\">\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'location.travelTimeToBranch' | translate }} </label>\n<input id=\"lng\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.travelTimeToBranch\">\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label>{{'locationDistance.menu.title' | translate }} </label>\n<input id=\"lng\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.locationDistance\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary margin-bottom-10\" ng-show=\"::$ctrl.hasACL['edit']\" ng-disabled=\"$ctrl.isFormInvalid(Form)|| !$ctrl.isValidDirective || !$ctrl.model.branch.length \n\t\t\t\t\t\t\t|| !$ctrl.isValidTargetStopTime() || !$ctrl.isValid || !$ctrl.isValidMaxLoad || $ctrl.loading || !$ctrl.isValidRecurringStops || !$ctrl.isValidRecurringLoad || $ctrl.duplicateLocationSlotError\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default margin-bottom-10\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n<button type=\"button\" class=\"btn btn-warning margin-bottom-10\" ng-click=\"$ctrl.saveLater()\" ng-disabled=\"!$ctrl.isValidDirective || !$ctrl.model.branch.length || !$ctrl.model.defaultBranch\" ng-class=\"{'disabled': $ctrl.loading}\">{{'location.save_later'| translate }}\n</button>\n<button type=\"button\" class=\"btn btn-primary margin-bottom-10\" ng-click=\"$ctrl.getLocationLogs($ctrl.model.id)\" ng-disabled=\"!$ctrl.isValidDirective || !$ctrl.model.branch.length || !$ctrl.model.defaultBranch\" ng-class=\"{'disabled': $ctrl.loading}\">{{'location.location_logs' | translate}}\n</button>\n</div>\n</form>\n</div>\n<style>\n.uib-timepicker .seconds .ng-valid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t}\n\n\t.uib-timepicker .seconds .ng-invalid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t}\n\n\t.atm-cassette-max-input {\n\t\twidth: 64px;\n\t\theight: 30px;\n\t\tpadding: 4px 8px;\n\t}\n</style>\n";
var id1="location.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2743 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"location.menu.import_locations\"></h4>\n<hr/>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" class=\"form-validate\" novalidate>\n<div class=\"form-group\">\n<label for=\"description\">{{'location.location_data' | translate}} *</label>\n<textarea class=\"form-control\" name=\"\" cols=\"30\" rows=\"5\" ng-model=\"$ctrl.model.locations\" placeholder=\"\" required></textarea>\n</div>\n<button type=\"button\" ng-click=\"$ctrl.uploadLocationData()\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'location.upload' | translate}}\n</button>\n<div class=\"alert-success margin-10\" ng-if=\"$ctrl.model.locationData.length\">\n<div class=\"alert\">\n{{'location.location_processed' | translate}} {{$ctrl.model.locationData.length}}\n</div>\n</div>\n<div class=\"col-sm-12 margin-10\" ng-if=\"$ctrl.model.locationData.length\">\n<table class=\"table table-striped\">\n<thead>\n<tr>\n<th>#</th>\n<th>{{'common.locationId' | translate}}</th>\n<th>{{'location.status' | translate}}</th>\n</tr>\n</thead>\n<tbody ng-repeat=\"data in $ctrl.model.locationData track by $index\">\n<td>{{$index+1}}</td>\n<td>{{data.location_id}}</td>\n<td>{{data.status}}</td>\n</tbody>\n</table>\n</div>\n</form>\n</div>";
var id1="location.import_locations.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2744 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"location.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"location.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"location.create\">\n<a translate=\"location.menu.create\"></a>\n</li>\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"location.missinglatlng({page: 1})\">\n<a translate=\"location.menu.missing_gps_latlngs\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['importLocations']\" ui-sref-active=\"active\" ui-sref=\"location.import_locations({page: 1})\">\n<a translate=\"location.menu.import_locations\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['clone']\" ui-sref-active=\"active\" ui-sref=\"location.clone\">\n<a translate=\"location.menu.clone_location\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>";
var id1="location.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2745 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'location.menu.missing_gps_latlngs' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<button type=\"button\" class=\"btn btn-sm btn-success\" ng-if=\"$ctrl.enableGeoCoding\" ng-click=\"$ctrl.fixGeoCode()\" ng-class=\"{'disabled': $ctrl.model.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.model.loading}\"></span>{{'location.FixGeoCode' | translate}}</button>\n<div class=\"form-group\">\n<input type=\"text\" ng-model=\"$ctrl.searchObj.text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'location.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n<div class=\"form-group\">\n<select class=\"form-control\" ng-model=\"$ctrl.searchObj.type\" ng-options=\"locationType.value as locationType.label for locationType in  $ctrl.locationTypes\" ng-change=\"$ctrl.search()\"></select>\n</div>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.locations && $ctrl.locations.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"location in $ctrl.locations track by location.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<img ng-src=\"{{$ctrl.loadImage(location.locationType)}} \" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"\"/>\n<span class=\"list-group-item-text\">\n{{location.id}} | {{location.name}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(location)\" uib-tooltip=\"{{ 'location.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"location.expand\">\n<div class=\"col-sm-12\">\n<hr/>\n<div>\nExtra details here\n<br>\n<br>\n<br>\n<br> Extra Details\n</div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" force-ellipses=\"true\" max-size=\"$ctrl.maxPages\" ng-hide=\"(($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1))\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\"></ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.locations || !$ctrl.locations.length) && !$ctrl.loading\">\n<span>{{'location.noLocations' | translate}}</span>\n<ul uib-pagination total-items=\"$ctrl.total\" force-ellipses=\"true\" max-size=\"$ctrl.maxPages\" ng-hide=\"(($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1))\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\"></ul>\n</div>\n</div>\n</div>";
var id1="location.missinglatlng.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2746 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\" style=\"text-align: center;\">\n<div class=\"col-sm-12\">\n<div id=\"print-section\" class=\"print-location-barcodes margin-top-02\" ng-repeat=\"data in $ctrl.model.selectedLocations track by $index\">\n<div class=\"_barcode-center-align auto-adjust-page-css location-barcode-print-section\">\n<div>\n<div>\n<angular-barcode ng-model=\"data.locationId\" class=\"location-barcodes _barcode-page\" bc-options=\"$ctrl.model.barcodeOptions\" bc-class=\"barcode\" bc-type=\"svg\">\n</angular-barcode>\n</div>\n<div class=\"pre-print-location location-details-section\">\n<div><b>{{data.locationName}}</b></div>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n</div>\n</div>\n</div>\n<head>\n<style>\nsvg.barcode {\n            width: 100% !important;\n        }\n\n        @media print {\n            body {\n                visibility: visible;\n                width: 100% !important;\n            }\n\n            .auto-adjust-page-css {\n                width: 100% !important;\n                height: 100% !important;\n                margin: auto !important;\n            }\n\n            .barcode-center-align {\n                display: flex !important;\n                align-items: center !important;\n                justify-content: center !important;\n                margin: auto !important;\n                height: 100vh !important;\n            }\n        }\n</style>\n</head>";
var id1="print_location_barcodes.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2747 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"log_style_container\">\n<div>\n<div class=\"navbar-header align-center-vertically\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'log.menu.all' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn\" ng-class=\"{'btn-default': $ctrl.logsOf !== 'supervisors', 'btn-primary': $ctrl.logsOf === 'supervisors'}\" ng-click=\"$ctrl.setLogsOf('supervisors')\">\n{{'log.supervisors' | translate}}\n</button>\n<button type=\"button\" class=\"btn\" ng-class=\"{'btn-default': $ctrl.logsOf !== 'users', 'btn-primary': $ctrl.logsOf === 'users'}\" ng-click=\"$ctrl.setLogsOf('users')\">\n{{'log.users' | translate}}\n</button>\n</div>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'log.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n<div class=\"form-group\">\n<select class=\"form-control\" ng-options=\"entryType.value as entryType.label for entryType in $ctrl.entryTypes | orderBy:'label'\" ng-model=\"$ctrl.entryType\" ng-change=\"$ctrl.loadData()\">\n<option value=\"\">({{'common.All' | translate}})</option>\n</select>\n</div>\n</form>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form>\n<div>\n<div class=\"row col-sm-4 pull-right\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRange\" ng-change=\"$ctrl.loadData($ctrl.model.dateRange)\" ng-if=\"$ctrl.model.dateRange.startDate\" options=\"$ctrl.model.dateRangPickerOptions\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"col-sm-3 pull-right\">\n<select class=\"form-control\" ng-options=\"branch.branchId as branch.branchId for branch in $ctrl.branches\" ng-model=\"$ctrl.model.branchId\" ng-change=\"$ctrl.filterData()\" ng-if=\"!$ctrl.model.loading\">\n<option value=\"\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.logs && $ctrl.logs.length\">\n<div class=\"panel-box panel-group list-group recent-activity-block\" id=\"accordion\">\n<div class=\"panel panel-default\" ng-repeat=\"log in $ctrl.logs track by log.id\">\n<div class=\"panel-heading cust-panel-color\" data-toggle=\"collapse\" data-target=\"#{{log.id}}\" aria-expanded=\"false\" aria-controls=\"{{log.id}}\" ng-class=\"{ 'log-warning': log.flagged }\">\n<h4 class=\"panel-title cursor-pointer\">\n<a class=\"accordion-toggle\">\n<strong>{{log.readableEntryType + ' '}} </strong> <span ng-if=\"log.userId\">{{'log.by' | translate}}</span> {{' ' + log.user.firstName + ' ' + log.user.lastName + ' '}}\n<span ng-if=\"log.message\"> | <span class=\"message-color\">{{log.message}}</span></span>\n<span class=\"pull-right\">{{log.createdAt | date: 'short'}}</span>\n</a>\n</h4>\n</div>\n<div id=\"{{log.id}}\" class=\"panel-collapse collapse multi-collapse\">\n<div class=\"panel-body\">\n<table class=\"table table-bordered table-striped remove-pad-bottom\">\n<tr ng-repeat=\"detail in log.extraDetails\">\n<td>{{detail.key}}</td>\n<td class=\"wrap-text\">\n<span ng-if=\"(detail.key !== 'pickupImageName' && detail.key !== 'deliveryImageName')\">{{detail.value}}</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value !=='null') || (detail.key === 'deliveryImageName' && detail.value !=='null')\">Captured</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value =='null') || (detail.key === 'deliveryImageName' && detail.value =='null')\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value !=='null') || (detail.key === 'deliveryImageName' && detail.value !=='null')\">\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showShipmentReceipt(log.extraDetails, detail.key == 'pickupImageName' ? 'pickup': 'delivery')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n</div>\n<div class=\"padding-left-10\">\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" items-per-page=\"$ctrl.pageLimit\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"$ctrl.maxPages\"></ul>\n</div>\n</div>\n<div class=\"text-align-center alert alert-danger margin-top-20\" ng-if=\"!$ctrl.logs || !$ctrl.logs.length\">\n<span>{{'log.noLogs' | translate}}</span>\n<ul uib-pagination total-items=\"$ctrl.total\" items-per-page=\"$ctrl.pageLimit\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"$ctrl.maxPages\"></ul>\n</div>\n</div>\n</div>";
var id1="log.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2748 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"log.all\"><a>{{'log.menu.all' | translate}}</a></li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view><ui-view>\n</ui-view></ui-view></div>\n</div>\n</div>";
var id1="log.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row\">\n<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"margin: auto;vertical-align: middle;top: 10rem;\">\n<div class=\"login-form\">\n<div class=\"comapany_logo\">\n<center>\n<img stream-company-logo load-from-db=\"true\" class=\"img-responsive\">\n</center>\n</div>\n<div class=\"login_form\">\n<form class=\"form well account-login-form\" name=\"form\" ng-submit=\"login(form)\" novalidate>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label translate=\"login.email\"></label>\n<input type=\"text\" autocomplete=\"off\" name=\"email\" class=\"form-control\" placeholder=\"{{ 'login.email_placeholder' | translate }}\" ng-model=\"$ctrl.userCredentials.emailOrUserId\" required>\n</div>\n<div class=\"form-group\">\n<label translate=\"login.password\"></label>\n<input type=\"password\" autocomplete=\"off\" name=\"password\" class=\"form-control\" placeholder=\"{{ 'login.password_placeholder' | translate }}\" ng-model=\"$ctrl.userCredentials.password\" required>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad alert alert-info remove-margin-bottom\" ng-if=\"$ctrl.model.passwordPolicy.forceChangePasswordDays && $ctrl.model.passwordPolicy.isForceChangePassword\">\n<ul>\n<li id=\"forceChangePasswordDays\">\n<span translate=\"login.force_change_password_message\"></span>\n<b>{{$ctrl.model.passwordPolicy.forceChangePasswordDays}}</b> days.\n</li>\n</ul>\n</div>\n<div class=\"col-sm-12 remove-pad alert alert-danger password_policy_criteria_message_padding\" ng-if=\"$ctrl.model.passwordPolicy.errors.length > 0 && !$ctrl.model.passwordPolicy.isForceChangePassword\">\n<span>{{'login.password_policy_criteria_message' | translate}}</span>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.error\">\n<div class=\"col-sm-12\">\n<p style=\"color: red; font-weight: bold; text-align: center;\">{{$ctrl.error}}</p>\n</div>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 margin-top-10\">\n<div class=\"col-sm-8 remove-left-pad remove-right-pad\">\n<label><input type=\"checkbox\" ng-model=\"user.remember\"/> {{'login.remember_me' | translate }} <br/><small>\n{{ 'login.remember_me_message' | translate }}</small></label>\n</div>\n<div class=\"col-sm-4 remove-left-pad remove-right-pad text-right\">\n<button class=\"btn btn-primary btn-lg\" ng-disabled=\"!form.$valid\" ng-click=\"$ctrl.login()\" type=\"submit\" translate=\"login.button\"></button>\n</div>\n</div>\n<div class=\"text-center\">\n<a ng-if=\"!$ctrl.model.passwordPolicy.forceChangePasswordDays\" ui-sref=\"forgot_password\" translate=\"login.forgot_password\"></a>\n<a ng-if=\"$ctrl.model.passwordPolicy.forceChangePasswordDays\" ui-sref=\"change_password({ isForceChangedPassword: $ctrl.model.passwordPolicy.forceChangePasswordDays })\" translate=\"login.change_password\"></a>\n</div>\n</form>\n</div>\n<div class=\"download_app text-center\" ng-if=\"$ctrl.appData && $ctrl.appData.android\">\n<h3>Download TNT Mobile App</h3>\n<div class=\"download_img\">\n<img src=\"" + __webpack_require__(395) + "\" class=\"img-responsive crs-pointer\" ng-click=\"$ctrl.downloadFile()\">\n</div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="login.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2750 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<navbar></navbar>\n<div class=\"container-fluid\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<ui-view>\n</ui-view>\n</div>\n</div>\n</div>";
var id1="main.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1=" <!--ng-if=\"$ctrl.newCash.fundingSource && !$ctrl.loadBfsDenomination\"-->\n                                <a popover-is-open=\"$ctrl.denomination.isOpen\" role=\"button\" \n                                    ng-repeat=\"denomination in $ctrl.newCash.remainingAtmDenominations track by $index\" \n                                    ng-click=\"$ctrl.changeDenomType($event, $parent.$index, denomination, 'atmDenominations')\">\n                                    <denom-icon denom-id=\"denomination.id\" icon-size=\"30\"> </denom-icon>\n                                </a>\n";
var id1="order-view-atm-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
var v2="\n<a popover-is-open=\"$ctrl.denomination.isOpen\" role=\"button\" \n                                    ng-repeat=\"denomination in $ctrl.newCash.remainingAtmDenominations track by $index\" \n                                    ng-click=\"$ctrl.changeDenomType($event, $parent.$index, denomination, 'atmDenominations')\">\n                                    <denom-icon denom-id=\"denomination.id\" icon-size=\"30\"> </denom-icon>\n                                </a>\n";
var id2="order-view-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id2,v2);}
else{ngModule.run(["$templateCache",function(c){c.put(id2,v2)}]);}
var v3="\n<a popover-is-open=\"$ctrl.multiDenominations.isOpen\" role=\"button\" \n                                ng-repeat=\"multiDenominations in $ctrl.newCash.remainingMultiDenominations | filter:{multiDenomPackable: true} track by $index\" \n                                ng-click=\"$ctrl.changeDenomType($event, $parent.$index, multiDenominations, 'multiDenominations')\">\n                                <denom-icon denom-id=\"multiDenominations.id\" icon-size=\"30\"> </denom-icon>\n                            </a>\n";
var id3="order-view-multi-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id3,v3);}
else{ngModule.run(["$templateCache",function(c){c.put(id3,v3)}]);}
var v4="\n<a popover-is-open=\"$ctrl.denominations.isOpen\" role=\"button\" \n                                ng-repeat=\"denominations in $ctrl.newCash.remainingDenominations | filter:{multiDenomPackable: false} track by $index\" \n                                ng-click=\"$ctrl.changeDenomType($event, $parent.$index, denominations, 'denominations')\">\n                                <denom-icon denom-id=\"denominations.id\" icon-size=\"30\"> </denom-icon>\n                            </a>\n";
var id4="order-view-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id4,v4);}
else{ngModule.run(["$templateCache",function(c){c.put(id4,v4)}]);}
var v5="\n<a ng-click=\"$ctrl.changeCoinType($event, key, type.icon, $index)\" role=\"button\" ng-repeat=\"type in $ctrl.coinTypes[key].denomList track by $index\">\n                                <denom-icon denom-id=\"type.icon\" ng-if=\"type.icon !== 'M'\" icon-size=\"30\"> </denom-icon>\n                                <denom-icon denom-id=\"'misc'\" ng-if=\"type.icon === 'M'\" icon-size=\"30\"> </denom-icon>\n                            </a>\n";
var id5="order-view-coin-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id5,v5);}
else{ngModule.run(["$templateCache",function(c){c.put(id5,v5)}]);}
var v6="\n<a popover-is-open=\"$ctrl.multiDenominations.isOpen\" role=\"button\" \n                                ng-repeat=\"multiDenominations in $ctrl.newCash.remainingMultiDenominations | filter:{multiDenomPackable: true} | orderBy:'sortOrder':true track by $index\" \n                                ng-click=\"$ctrl.changeDenomType($event, $parent.$index, multiDenominations, 'multiDenominations')\">\n                                <denom-icon denom-id=\"multiDenominations.id\" icon-size=\"30\"> </denom-icon>\n                            </a>\n";
var id6="order-view-multi-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id6,v6);}
else{ngModule.run(["$templateCache",function(c){c.put(id6,v6)}]);}
var v7="\n<a popover-is-open=\"$ctrl.denominations.isOpen\" role=\"button\" \n                                ng-repeat=\"denomination in $ctrl.newCash.remainingDenominations | filter:{multiDenomPackable: false} | orderBy:'sortOrder':true track by $index\" \n                                ng-click=\"$ctrl.changeDenomType($event, $parent.$index, denomination, 'denominations')\">\n                                <denom-icon denom-id=\"denomination.id\" icon-size=\"30\"> </denom-icon>\n                            </a>\n";
var id7="order-view-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id7,v7);}
else{ngModule.run(["$templateCache",function(c){c.put(id7,v7)}]);}
var v8="\n<a ng-click=\"$ctrl.changeCoinType($event, key, type.icon, $index)\" role=\"button\" ng-repeat=\"type in $ctrl.coinTypes[key].denomList track by $index\">\n                                <denom-icon denom-id=\"type.icon\" ng-if=\"type.icon !== 'M'\" icon-size=\"30\"> </denom-icon>\n                                <denom-icon denom-id=\"'misc'\" ng-if=\"type.icon === 'M'\" icon-size=\"30\"> </denom-icon>\n                            </a>\n";
var id8="order-view-coin-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id8,v8);}
else{ngModule.run(["$templateCache",function(c){c.put(id8,v8)}]);}
var v9="\n<a ng-click=\"$ctrl.changeCoinType($event, key, type.icon, $index)\" role=\"button\" ng-repeat=\"type in $ctrl.coinTypes[key].denomList track by $index\">\n                                <denom-icon denom-id=\"type.icon\" ng-if=\"type.icon !== 'M'\" icon-size=\"30\"> </denom-icon>\n                                <denom-icon denom-id=\"'misc'\" ng-if=\"type.icon === 'M'\" icon-size=\"30\"> </denom-icon>\n                            </a>\n";
var id9="order-view-coin-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id9,v9);}
else{ngModule.run(["$templateCache",function(c){c.put(id9,v9)}]);}
var v10="\n<a popover-is-open=\"$ctrl.multiDenominations.isOpen\" role=\"button\" \n                                    ng-repeat=\"multiDenominations in $ctrl.newCash.remainingMultiDenominations | filter:{multiDenomPackable: true} | orderBy:'sortOrder' track by $index\" \n                                    ng-click=\"$ctrl.changeDenomType($event, $parent.$index, multiDenominations, 'multiDenominations')\">\n                                    <denom-icon denom-id=\"multiDenominations.id\" icon-size=\"30\"> </denom-icon>\n                                </a>\n";
var id10="order-view-multi-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id10,v10);}
else{ngModule.run(["$templateCache",function(c){c.put(id10,v10)}]);}
var v11="\n<a popover-is-open=\"$ctrl.denominations.isOpen\" role=\"button\" \n                                    ng-repeat=\"denomination in $ctrl.newCash.remainingDenominations | filter:{multiDenomPackable: false} | orderBy:'sortOrder' track by $index\" \n                                    ng-click=\"$ctrl.changeDenomType($event, $parent.$index, denomination, 'denominations')\">\n                                    <denom-icon denom-id=\"denomination.id\" icon-size=\"30\"> </denom-icon>\n                                </a>\n";
var id11="order-view-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id11,v11);}
else{ngModule.run(["$templateCache",function(c){c.put(id11,v11)}]);}
var v12=" <!--ng-if=\"$ctrl.newCash.fundingSource && !$ctrl.loadBfsDenomination\"-->\n                                <a popover-is-open=\"$ctrl.denomination.isOpen\" role=\"button\" \n                                    ng-repeat=\"denomination in $ctrl.newCash.remainingAtmDenominations | orderBy:'sortOrder' track by $index\" \n                                    ng-click=\"$ctrl.changeDenomType($event, $parent.$index, denomination, 'atmDenominations')\">\n                                    <denom-icon denom-id=\"denomination.id\" icon-size=\"30\"> </denom-icon>\n                                </a>\n";
var id12="order-view-atm-denomination-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id12,v12);}
else{ngModule.run(["$templateCache",function(c){c.put(id12,v12)}]);}
var v13="<div class=\"col-sm-12 remove-left-pad remove-right-pad cash-scheduled\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"d-flex justify-space-between margin-bottom-10\">\n<form class=\"master-cash-section\">\n<div class=\"loc-btn-export\" ng-if=\"$ctrl.locations && $ctrl.locations.length && !$ctrl.loading\">\n<button type=\"button\" class=\"btn btn-md btn-success\" ng-click=\"$ctrl.exportData()\" ng-disabled=\"$ctrl.isExporting\">\n{{ 'common.export' | translate }}\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isExporting\"></span>\n</button>\n</div>\n</form>\n<div class=\"d-flex justify-space-between info-legend align-items-center\">\n<div class=\"d-flex align-items-center\">\n<div class=\"square scheduled\"></div>\n<div>{{'common.scheduled' | translate}}</div>\n</div>\n<div class=\"d-flex align-items-center\">\n<div class=\"square pending-pack\"></div>\n<div>{{'routeControl.pending_pack' | translate}}</div>\n</div>\n<div class=\"d-flex align-items-center\">\n<div class=\"square packed\"></div>\n<div>{{'shipment.packed' | translate}}</div>\n</div>\n<div class=\"d-flex align-items-center\">\n<div class=\"square hold\"></div>\n<div>{{'shipment.hold' | translate}}</div>\n</div>\n<div class=\"d-flex align-items-center\">\n<div class=\"square crved\"></div>\n<div>{{'shipment.CRVed' | translate}}</div>\n</div>\n<div class=\"d-flex align-items-center\">\n<div class=\"square completed\"></div>\n<div>{{'branch_mgmt.orders.completed' | translate}}</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"calendar-filter col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"justify-space-between align-items-center cash-filter-list\" style=\"position: relative; z-index: 3\">\n<div class=\"btn-group set-grid\">\n<button id=\"all\" type=\"button\" class=\"btn _width-23\" ng-class=\"{'btn-default': $ctrl.currentOrderStat !== null, 'all-filter-button': $ctrl.currentOrderStat === null}\" ng-click=\"$ctrl.getOrderStats($ctrl.orderStatObj.All)\" ng-disabled=\"$ctrl.model.gettingServiceOrder\">\n{{'common.All' | translate}}\n</button>\n<button id=\"scheduled\" type=\"button\" class=\"btn _width-23\" ng-class=\"{'btn-default': $ctrl.currentOrderStat !== $ctrl.orderStatObj.Scheduled, 'scheduled-filter-button': $ctrl.currentOrderStat === $ctrl.orderStatObj.Scheduled}\" ng-click=\"$ctrl.getOrderStats($ctrl.orderStatObj.Scheduled)\" ng-disabled=\"$ctrl.model.gettingServiceOrder\">\n{{'common.scheduled' | translate}}\n</button>\n<button id=\"at-risk\" type=\"button\" class=\"btn _width-23\" ng-class=\"{'btn-default': $ctrl.currentOrderStat !== $ctrl.orderStatObj.atRisk, 'btn-danger': $ctrl.currentOrderStat === $ctrl.orderStatObj.atRisk}\" ng-click=\"$ctrl.getOrderStats($ctrl.orderStatObj.atRisk)\" ng-disabled=\"$ctrl.model.gettingServiceOrder\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].atRisk\">\n{{'master_cash_schedule.at_risk' | translate}}\n</button>\n<button id=\"atm\" type=\"button\" class=\"btn _width-23\" ng-class=\"{'btn-default': $ctrl.currentOrderStat !== $ctrl.orderStatObj.ATM, 'btn-success': $ctrl.currentOrderStat === $ctrl.orderStatObj.ATM}\" ng-click=\"$ctrl.getOrderStats($ctrl.orderStatObj.ATM)\" ng-disabled=\"$ctrl.model.gettingServiceOrder\">\n{{'master_cash_schedule.atm' | translate}}\n</button>\n<button id=\"cash\" type=\"button\" class=\"btn _width-23\" ng-class=\"{'btn-default': $ctrl.currentOrderStat !== $ctrl.orderStatObj.Cash, 'btn-primary': $ctrl.currentOrderStat === $ctrl.orderStatObj.Cash}\" ng-click=\"$ctrl.getOrderStats($ctrl.orderStatObj.Cash)\" ng-disabled=\"$ctrl.model.gettingServiceOrder\">\n{{'atm_residual.order_type_COD' | translate}}\n</button>\n</div>\n<div class=\"col-sm-6_ remove-pad-left remove-pad-right\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.dateRangeOptions\" options=\"$ctrl.dateRangPickerOptions\" ng-paste=\"$event.preventDefault()\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"col-sm-6_ btn-group remove-pad-left remove-pad-right\">\n<button id=\"table-view\" type=\"button\" class=\"btn _width-23\" ng-class=\"{'btn-default': $ctrl.$currentViewTab !== 'table', 'btn-primary': $ctrl.$currentViewTab == 'table'}\" ng-click=\"$ctrl.tabViewSelection('table');\" ng-disabled=\"$ctrl.model.gettingServiceOrder\">\nTable\n</button>\n<button id=\"calendar-view\" type=\"button\" class=\"btn _width-23\" ng-class=\"{'btn-default': $ctrl.$currentViewTab !== 'calender', 'btn-primary': $ctrl.$currentViewTab == 'calender'}\" ng-click=\"$ctrl.tabViewSelection('calender');\" ng-disabled=\"$ctrl.model.gettingServiceOrder\">\nCalendar\n</button>\n<button type=\"button\" class=\"btn-new btn btn-success\" ng-class=\"{'disabled': !$ctrl.isAllowToCreateCashDeliveries(calendarDay.formatedDate)}\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].create\" ng-click=\"$ctrl.createNewCashSchedule()\" ng-disabled=\"$ctrl.model.gettingServiceOrder\" style=\"border-top-left-radius: 4px; border-bottom-left-radius: 4px; float: right;\">\n+ New\n</button>\n<button class=\"btn _btn-sm btn-success margin-right-05\" ng-click=\"$ctrl.convertNext7VaultDateScheduledOrderToPackableOrderModal(order)\" ng-disabled=\"$ctrl.isCreteAllPackableOrder\" ng-if=\"$ctrl.currentOrderStat === $ctrl.orderStatObj.Scheduled && $ctrl.allOrders.length > 0\" style=\"border-top-left-radius: 4px; border-bottom-left-radius: 4px; float: right;\">\n<span class=\"glyphicon glyphicon-compressed\" uib-tooltip=\"Convert Scheduled Orders to Packable Order\" tooltip-placement=\"bottom-right\"></span>\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isCreteAllPackableOrder\"></span>\n</button>\n</div>\n<div>\n<div class=\"d-flex align-items-center\">\n<div class=\"master-cash-search\">\n<input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"form-control\" ng-model-options=\"{debounce: 1000}\" id=\"masterCashSearch\" ng-change=\"$ctrl.filterOrderView()\" placeholder=\"{{ 'common.search' | translate }}\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" ng-disabled=\"$ctrl.model.gettingServiceOrder\">\n</div>\n<div class=\"master-cash-btn-group\">\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.filterOrderView()\" ng-disabled=\"$ctrl.model.gettingServiceOrder\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n</div>\n<div class=\"pl-5 padding-left-5\">\n<button type=\"button\" class=\"btn btn-danger\" ng-click=\"$ctrl.resetFilter()\" ng-disabled=\"$ctrl.model.gettingServiceOrder\">\n{{'common.reset' | translate}}\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-2_\" style=\"padding-bottom: 7px;\" ng-class=\"{'disable-div': $ctrl.model.gettingServiceOrder}\">\n<div class=\"multi-select order-view-branch-dd\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.filterDataSet.userBranches\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.resetDataOnBranchChange(); $ctrl.filterOrderView(); $ctrl.getBranchCurrentVaultDate();\" on-select-all=\"$ctrl.filterOrderView(); $ctrl.getBranchCurrentVaultDate();\" on-select-none=\"$ctrl.filterOrderView(); $ctrl.getBranchCurrentVaultDate();\" on-reset=\"$ctrl.resetDataOnBranchChange(); $ctrl.filterOrderView(); $ctrl.getBranchCurrentVaultDate();\" selection-mode=\"single\" is-disabled=\"$ctrl.model.gettingServiceOrder\">\n</div>\n</div>\n<div class=\"col-sm-2_ _p-0\" style=\"padding-bottom: 7px;\">\n<search-and-select ng-model=\"$ctrl.model.status\" values=\"$ctrl.filterDataSet.status\" totalrecords=\"$ctrl.filterDataSet.totalStatus\" key=\"Key\" on-click=\"$ctrl.filterOrderView()\" none-selected=\"'common.select_status'\" ng-disabled=\"$ctrl.model.gettingServiceOrder\" onscroll=\"$ctrl.getAllStatus(searchKey)\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-2_ _p-0\" style=\"padding-bottom: 7px;\">\n<search-and-select ng-model=\"$ctrl.model.fundingSourceId\" values=\"$ctrl.filterDataSet.branchFundingSource\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalBranchFundingSource\" onscroll=\"$ctrl.getAllFundingSource(searchKey, offset)\" on-click=\"$ctrl.onMainFundingSourceSelected();\" none-selected=\"'orderPacking.selectFromLocation'\" ng-disabled=\"$ctrl.model.gettingServiceOrder || $ctrl.isLoading\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-2_\" style=\"padding-bottom: 7px;\">\n<search-and-select ng-model=\"$ctrl.filter.customerId\" values=\"$ctrl.filterDataSet.customerList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalCustomer\" on-click=\"$ctrl.filterOrderView();\" onscroll=\"$ctrl.getCustomer(searchKey, offset)\" none-selected=\"'common.select_customer'\" ng-disabled=\"$ctrl.model.gettingServiceOrder || $ctrl.userDetails.customerUser\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-2_ _p-0\">\n<search-and-select ng-model=\"$ctrl.filter.locationId\" values=\"$ctrl.mainPageFilters.locationList\" key=\"Key\" totalrecords=\"$ctrl.mainPageFilters.totalLocation\" on-click=\"$ctrl.filterOrderView();\" is-change-offset=\"true\" is-change-offset-value=\"$ctrl.mainPageFilters.offset\" onscroll=\"$ctrl.loadLocation(searchKey, offset, true)\" none-selected=\"'common.select_location'\" ng-disabled=\"$ctrl.model.gettingServiceOrder\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-2_ _p-0\">\n<search-and-select ng-model=\"$ctrl.model.routeId\" values=\"$ctrl.filterDataSet.routeList\" key=\"Key\" value=\"Value\" totalrecords=\"$ctrl.filterDataSet.totalRoutes\" on-click=\"$ctrl.filterOrderView()\" onscroll=\"$ctrl.getActiveRoutes(searchKey,offset)\" none-selected=\"'common.select_route'\" ng-disabled=\"$ctrl.model.gettingServiceOrder || $ctrl.isLoading\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-2_\">\n<select class=\"form-control\" ng-model=\"$ctrl.filter.orderType\" ng-options=\"orderType.value as orderType.key for orderType in $ctrl.filterDataSet.orderTypes\" ng-change=\"$ctrl.filterOrderView();\" ng-disabled=\"$ctrl.model.gettingServiceOrder\">\n<option value=\"\">({{'common.select_OrderType' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-2_ _p-0\" ng-class=\"{'disable-div': $ctrl.model.gettingServiceOrder}\">\n<div class=\"multi-select location-branch-dd\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.filterDataSet.denomsList\" output-model=\"$ctrl.filter.selectedDenoms\" button-label=\"Key\" item-label=\"Key\" search-property=\"Key\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.filterOrderView();\" on-select-all=\"$ctrl.filterOrderView();\" on-select-none=\"$ctrl.filterOrderView();\" on-reset=\"$ctrl.filterOrderView();\" translation=\"$ctrl.istevenMultiSelectLocalLang\" is-disabled=\"$ctrl.model.gettingServiceOrder\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.gettingServiceOrder\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"col-sm-12 calender-start remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.model.gettingServiceOrder\">\n<div class=\"col-sm-12 header_cal\" ng-if=\"$ctrl.$currentViewTab=='calender'\">\n<i class=\"glyphicon glyphicon-chevron-left angle-left\" ng-click=\"$ctrl.previousMonth()\" ng-disabled=\"$ctrl.model.gettingServiceOrder\"></i>\n<span>{{$ctrl._calendar.displayMonth}}, {{$ctrl._calendar.displayYear}}</span>\n<i class=\"glyphicon glyphicon-chevron-right angle-right\" ng-click=\"$ctrl.nextMonth()\" ng-disabled=\"$ctrl.model.gettingServiceOrder\"></i>\n</div>\n<div class=\"col-sm-12 p-0 mb-70\">\n<table class=\"table table-bordered calendar-table\" ng-if=\"$ctrl.calendarDays && $ctrl.calendarDays.length && $ctrl.$currentViewTab=='calender'\">\n<thead>\n<tr>\n<th class=\"week-day-name text-center\" ng-repeat=\"weekName in $ctrl.weekDaysName\">\n<span>{{weekName | uppercase}}</span>\n</th>\n</tr>\n</thead>\n<tbody ng-if=\"$ctrl.calendarDays && $ctrl.calendarDays.length\">\n<tr ng-repeat=\"calendarWeek in $ctrl.calendarDays\">\n<td class=\"calendar-day\" ng-class=\"{\n                                        'past-date': calendarDay.isPastDate, \n                                        'today': calendarDay.isToday, \n                                        'selected-day': calendarDay.formatedDate == $ctrl._calendar.selectedDateData.formatedDate }\" ng-repeat=\"calendarDay in calendarWeek;\" style=\"width:200px;\">\n<div ng-if=\"calendarDay.isMonthDate\" class=\"date-cell\">\n<div class=\"calendar-date\">\n<div class=\"d-flex justify-space-between\" ng-class=\"{'margin-bottom-10' : !$ctrl.collection[calendarDay.formatedDate].total}\">\n<div class=\"cursor-pointer date-badge badge badge-default time-slab-badge\" uib-tooltip=\"{{'checkout.verifyDate' | translate}}\">\n{{calendarDay.date | date: 'd'}}\n</div>\n<div class=\"cursor-pointer\" ng-click=\"$ctrl.openOrderDetailsModal(calendarDay.formatedDate)\" ng-class=\"{'total-orders-badge badge' : $ctrl.collection[calendarDay.formatedDate].collections.length > 0,\n                                                        'no-orders-badge badge' : !$ctrl.collection[calendarDay.formatedDate].collections.length}\" uib-tooltip=\"{{'branch_mgmt.branch_performance.total_orders' | translate}}\">\n{{$ctrl.collection[calendarDay.formatedDate].collections.length || 0}}\n</div>\n<div class=\"total\">\n<span class=\"bold-text\" ng-if=\"$ctrl.collection[calendarDay.formatedDate].total\">\n{{$ctrl.collection[calendarDay.formatedDate].total | currency:'$':2}}\n</span>\n<span class=\"bold-text\" ng-if=\"!$ctrl.collection[calendarDay.formatedDate].total\"> {{0 | currency:'$':2}}</span>\n</div>\n</div>\n<div ng-if=\"calendarDay.formatedDate && $ctrl.collection[calendarDay.formatedDate]\">\n<ul class=\"list-group margin-top-5 list-group-margin-bottom scroll-view\">\n<li class=\"list-group-item denom-list margin-bottom-3\" ng-repeat=\"dateCollection in $ctrl.collection[calendarDay.formatedDate].collections\" ng-click=\"$ctrl.handleEditCash(dateCollection)\">\n<div class=\"d-a-flex\">\n<div class=\"denom-total shipment-details-section\" ng-class=\"{\n                                                                    'packed' : dateCollection.status == 'packed',\n                                                                    'pending-pack' : dateCollection.status == 'pendingPack',\n                                                                    'completed' : dateCollection.status == 'completed',\n                                                                    'hold' : dateCollection.status == 'hold',\n                                                                    'crved' : dateCollection.status == 'CRVed',\n                                                                    'cancelled' : dateCollection.status == 'cancelled',\n                                                                    'scheduled' : dateCollection.status == 'scheduled',\n                                                                }\" style=\"align-self: stretch\">\n<div class=\"bold-font\">\n<span>{{dateCollection.toLocationId}}</span>\n<span class=\"pull-right padding-right-05\" ng-if=\"dateCollection.isEC\">\n<img src=\"" + __webpack_require__(249) + "\" class=\"ec-icon\" uib-tooltip=\"{{'common.emergency' | translate}}\" tooltip-placement=\"left\"/>\n</span>\n</div>\n<div>{{dateCollection.amount || 0 | currency:'$':2}}</div>\n<div ng-if=\"dateCollection.orderNo\">{{dateCollection.orderNo}}</div>\n<span class=\"pull-right padding-right-05\" ng-if=\"dateCollection.orderType\">\n<img ng-src=\"assets/images/Order_Type_{{dateCollection.orderType}}_Icon.png\" class=\"img-currency\"/>\n</span>\n<span class=\"pull-right padding-right-05\" ng-if=\"dateCollection.type == 'scheduledPackableOrder'\">\n<img src=\"" + __webpack_require__(138) + "\" class=\"ec-icon\" uib-tooltip=\"Packable Order\" tooltip-placement=\"top-right\"/>\n</span>\n<span class=\"pull-right padding-right-05\" ng-if=\"dateCollection.type == 'scheduledATMLoadOrders'\">\n<img src=\"" + __webpack_require__(241) + "\" class=\"ec-icon\" uib-tooltip=\"ATM Load Order\" tooltip-placement=\"top-right\"/>\n</span>\n</div>\n</div>\n</li>\n</ul>\n</div>\n<span uib-tooltip=\"{{'error.91906' | translate}}\" tooltip-placement=\"top-left\" tooltip-enable=\"!$ctrl.isAllowToCreateCashDeliveries(calendarDay.formatedDate)\">\n<button class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.hasACL['master_cash_schedule'].create ? $ctrl.createNewCashSchedule(calendarDay) : ''\" ng-class=\"{'disabled': !$ctrl.isAllowToCreateCashDeliveries(calendarDay.formatedDate) || !$ctrl.hasACL['master_cash_schedule'].create}\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n</button>\n</span>\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 p-0 mb-70\" ng-if=\"$ctrl.$currentViewTab == 'table' && !$ctrl.model.gettingServiceOrder\">\n<div class=\"table-view\">\n<table class=\"table table-bordered table-hover table-striped table-sortable text-align-center font-12\" ng-if=\"$ctrl.allOrders.length > 0\">\n<thead>\n<tr>\n<th style=\"width: 12%\" class=\"text-align-center table-header\" ng-click=\"$ctrl.sortCollection('serviceDate')\">{{ 'common.routeDate' | translate }}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'serviceDate'}\"></span>\n</th>\n<th style=\"width: 12%\" class=\"text-align-center table-header\" ng-click=\"$ctrl.sortCollection('status')\">{{ 'common.status' | translate }}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'status'}\"></span>\n</th>\n<th style=\"width: 12%\" class=\"text-align-center table-header\" ng-click=\"$ctrl.sortCollection('toLocationId')\">{{ 'common.location' | translate }}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'toLocationId'}\"></span>\n</th>\n<th style=\"width: 10%\" class=\"text-align-center table-header\" ng-click=\"$ctrl.sortCollection('amount')\">{{ 'master_cash_schedule.amount' | translate }}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amount'}\"></span>\n</th>\n<th style=\"width: 10%\" class=\"text-align-center table-header\" ng-click=\"$ctrl.sortCollection('orderType')\">{{ 'common.type' | translate }}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'orderType'}\"></span>\n</th>\n<th style=\"width: 12%\" class=\"text-align-center table-header\" ng-click=\"$ctrl.sortCollection('orderNo')\">{{ 'master_cash_schedule.orderNo' | translate }}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'orderNo'}\"></span>\n</th>\n<th style=\"width: 13%\" class=\"text-align-center table-header\" ng-click=\"$ctrl.sortCollection('routeId')\">{{ 'common.route' | translate }}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeId'}\"></span>\n</th>\n<th style=\"width: 12%\" class=\"text-align-center table-header\">{{ 'master_cash_schedule.denoms' | translate }}</th>\n<th style=\"width: 7%\" class=\"text-align-center table-header\">{{ 'common.action' | translate }}</th>\n</tr>\n</thead>\n<tbody class=\"scrollable-tbody\">\n<tr ng-repeat=\"order in $ctrl.allOrders track by $index\">\n<td style=\"width: 12%\">\n{{ $ctrl.normalizeDate(order.serviceDate) | date:'yyyy-MM-dd': 'UTC' }}\n</td>\n<td style=\"width: 12%\" ng-class=\"{\n                                'packed-shipment-table-section' : order.status == 'packed',\n                                'pending-pack-shipment-table-section' : order.status == 'pendingPack',\n                                'completed-shipment-table-section' : order.status == 'completed',\n                                'hold-shipment-table-section' : order.status == 'hold',\n                                'crved-shipment-table-section' : order.status == 'CRVed',\n                                'pending-shipment-table-section' : order.status == 'cancelled',\n                                'scheduled-shipment-table-section' : order.status == 'scheduled',\n                            }\">\n{{ ('master_cash_schedule.' + order.status) | translate }}\n<span class=\"pull-right padding-right-05\" ng-if=\"order.type == 'scheduledPackableOrder'\">\n<img src=\"" + __webpack_require__(138) + "\" class=\"ec-icon\" uib-tooltip=\"Packable Order\" tooltip-placement=\"top-right\"/>\n</span>\n<span class=\"pull-right padding-right-05\" ng-if=\"order.type == 'scheduledATMLoadOrders'\">\n<img src=\"" + __webpack_require__(241) + "\" class=\"ec-icon\" uib-tooltip=\"ATM Load Order\" tooltip-placement=\"top-right\"/>\n</span>\n<div ng-if=\"!(order.status === 'pendingPack' || order.status === 'scheduled')\" class=\"tracking-ids\">\n<div ng-if=\"order.parentTrackingId\">\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(order.parentTrackingId)\" class=\"table-tracking\">\n{{ order.parentTrackingId }}\n</a>\n</div>\n<div ng-if=\"!order.parentTrackingId\" ng-repeat=\"trackingId in order.trackingIds track by $index\">\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(trackingId)\" class=\"table-tracking\">\n{{ trackingId }}\n</a>\n</div>\n</div>\n</td>\n<td style=\"width: 12%\">\n<div class=\"icon-list-section\" style=\"justify-content: space-between;\">\n<div>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(order)\" uib-tooltip=\"{{ order.formatAddress }}\" tooltip-placement=\"top\">\n{{ order.toLocationId}}\n</a> | <span>{{order.toLocationName}} </span>\n</div>\n<div>\n<img ng-if=\"order.toLocationType\" ng-src=\"{{$ctrl.loadImage(order.toLocationType)}} \" class=\"custom-icon\" style=\"width: 20px; float:right;\" uib-tooltip=\"\"/>\n</div>\n</div>\n</td>\n<td style=\"width: 10%\">\n<b>{{ order.amount | currency:\"$\":2 }}</b>\n</td>\n<td style=\"width: 10%\">\n<div ng-if=\"order.orderType\">\n{{ ('atm_residual.order_type_' + order.orderType) | translate }}\n</div>\n<div ng-if=\"!order.orderType && !order.shiptypeId\">\n{{ 'common.n_a' | translate }}\n</div>\n<div ng-if=\"!order.orderType && !order.orderNo\">\n{{ order.shiptypeId | translate }}\n</div>\n</td>\n<td style=\"width: 12%\">\n<div ng-if=\"order.orderNo\">\n<a href=\"#\" ng-click=\"$ctrl.redirectToOrderTab(order)\">\n{{order.orderNo}}\n</a>\n</div>\n<div ng-if=\"!order.orderNo\">\n{{ 'common.n_a' | translate }}\n</div>\n</td>\n<td style=\"width: 13%\">\n<a href=\"#\" ng-click=\"$ctrl.goToRouteTab(order)\">\n{{ order.routeId }}\n</a>\n</td>\n<td style=\"width: 12%\">\n<div ng-repeat=\"denom in order.denominations | orderBy:'sortOrder'\" class=\"table-denoms\" ng-if=\"order.denominations.length > 0\">\n<denom-icon denom-id=\"denom.icon\" icon-size=\"23\"> </denom-icon>\n<span class=\"denom-amount\" style=\"font-size: 15px\">{{ denom.amount | currency:\"$\":2 }}</span>\n</div>\n<div class=\"text-center\" ng-if=\"order.denominations.length === 0\" class=\"table-denoms\">{{'common.n_a' | translate}}</div>\n</td>\n<td style=\"width: 7%\">\n<div ng-if=\"(order.status==='pendingPack' || (order.status==='scheduled' && order.type !== 'scheduledATMLoadOrders' && order.type !== 'scheduledPackableOrder')) && $ctrl.hasACL['master_cash_schedule'].create\">\n<button class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.handleEditCash(order)\" ng-disabled=\"order.status==='scheduled'\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].edit\">\n<span class=\"glyphicon glyphicon-pencil\" uib-tooltip=\"Edit\" tooltip-placement=\"top\"></span>\n</button>\n<button class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.cancelAtmOrder(order)\" ng-if=\"order.status==='pendingPack' && $ctrl.hasACL['master_cash_schedule'].delete\">\n<span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"Delete\" tooltip-placement=\"top\"></span>\n</button>\n<button class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.cancelRecurringATMLoadShipment(order)\" ng-if=\"order.status==='scheduled' && $ctrl.hasACL['master_cash_schedule'].delete\">\n<span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"Delete\" tooltip-placement=\"top\"></span>\n</button>\n<button ng-if=\"order.status==='pendingPack'\" class=\"btn btn-xs btn-success _margin-top-10\" ng-click=\"$ctrl.redirectToOrderPack(order)\">\n{{ 'routeControl.order_pack' | translate }}\n</button>\n</div>\n<div>\n<button class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.handleEditCash(order)\" ng-if=\"(order.type == 'scheduledATMLoadOrders' || order.type == 'scheduledPackableOrder') && $ctrl.hasACL['master_cash_schedule'].edit\">\n<span class=\"glyphicon glyphicon-pencil\" uib-tooltip=\"Edit\" tooltip-placement=\"top-right\"></span>\n</button>\n<button class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.convertScheduledOrderToPackableOrderModal(order)\" ng-if=\"order.type == 'scheduledATMLoadOrders' && $ctrl.hasACL['master_cash_schedule'].create\" ng-disabled=\"$ctrl.isCretePackableOrder\">\n<span class=\"glyphicon glyphicon-check\" uib-tooltip=\"Convert to Packable Order\" tooltip-placement=\"top-right\"></span>\n</button>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div ng-if=\"(!$ctrl.allOrders || $ctrl.allOrders.length === 0) && !$ctrl.model.gettingServiceOrder\" class=\"alert alert-danger text-align-center\">\nNo Data Found\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl._calendar.isSidePanelOpen || $ctrl._calendar.isEdit\" class=\"selected-date-panel\" style=\"z-index: 5\">\n<div class=\"create-new w-100\" ng-if=\"$ctrl._calendar.isEdit\">\n<div class=\"panel-header _word-break\" ng-class=\"{\n                            'packed-shipment-header-section' : $ctrl.newCash.status == 'packed',\n                            'pending-pack-shipment-header-section' : $ctrl.newCash.status == 'pendingPack',\n                            'completed-shipment-header-section' : $ctrl.newCash.status == 'completed',\n                            'hold-shipment-header-section' : $ctrl.newCash.status == 'hold',\n                            'crved-shipment-header-section' : $ctrl.newCash.status == 'CRVed',\n                            'cancelled-shipment-header-section' : $ctrl.newCash.status == 'cancelled',\n                            'scheduled-shipment-header-section' : $ctrl.newCash.status == 'scheduled',\n                        }\">\n<span class=\"total-amount\">\n<span ng-if=\"$ctrl.newCash.status == 'scheduled' && $ctrl.newCash.coinShipments.length && !$ctrl.newCash.packedFlag\">{{$ctrl.newCash.shiptypeId}} | </span>\n<span ng-if=\"!$ctrl.newCash.orderNo || !$ctrl.newCash.deliveredFlag\">\n{{$ctrl.getHeaderTotal() | currency:'$':2}}\n</span>\n<span ng-if=\"$ctrl.newCash.orderNo && $ctrl.newCash.deliveredFlag\">\n{{$ctrl.newCash.loadedAmount || 0 | currency:'$':2}}\n</span>\n<span> | {{$ctrl.newCash.locationId.Value}}</span>\n</span>\n</div>\n<div class=\"panel-body\">\n<div class=\"cash-schedule-form\">\n<form name=\"cashForm\" novalidate class=\"form-validate\">\n<div class=\"margin-bottom-10\" ng-if=\"$ctrl.newCash.status == 'scheduled' && $ctrl.newCash.scheduleWeekDays\">\n<label>Schedule</label>\n<input class=\"form-control\" type=\"text\" name=\"scheduleWeekDays\" ng-model=\"$ctrl.newCash.scheduleWeekDays\" required disabled=\"disabled\"/>\n</div>\n<div class=\"margin-bottom-10\" ng-if=\"$ctrl.newCash.status == 'scheduled'\">\n<label>{{'location.when' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"recurringFrequency\" ng-model=\"$ctrl.newCash.recurringFrequency\" required disabled=\"disabled\"/>\n</div>\n<div class=\"margin-bottom-10\" ng-if=\"$ctrl.newCash.status == 'scheduled' && $ctrl.newCash.recurringDayInterval\">\n<label>{{'master_cash_schedule.interval_days' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"recurringDayInterval\" ng-model=\"$ctrl.newCash.recurringDayInterval\" required disabled=\"disabled\"/>\n</div>\n<div class=\"margin-bottom-10\" ng-if=\"$ctrl.newCash.status == 'scheduled' && $ctrl.newCash.frequencyWeek\">\n<label>{{'master_cash_schedule.frequency_week' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"frequencyWeek\" ng-model=\"$ctrl.newCash.frequencyWeek\" required disabled=\"disabled\"/>\n</div>\n<div class=\"margin-bottom-10\" ng-if=\"$ctrl.newCash.fundingSourceId\">\n<label>{{'branch_mgmt.orders_selectATMs' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"fundingSourceId\" ng-model=\"$ctrl.newCash.fundingSource.Key\" required disabled=\"disabled\"/>\n</div>\n<div class=\"margin-bottom-10\" ng-if=\"$ctrl.cloneShipmentObj.orderNo\">\n<label>{{'master_cash_schedule.orderNo' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"orderNo\" ng-model=\"$ctrl.newCash.orderNo\" required ng-disabled=\"$ctrl.newCash.status !== 'pendingPack' || !$ctrl.newCash.cashOrderId\" placeholder=\"{{'master_cash_schedule.orderNo' | translate}}\"/>\n</div>\n<div class=\"margin-bottom-10\" ng-if=\"$ctrl.newCash.batchId\">\n<label>{{'master_cash_schedule.batch_id' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"batchId\" ng-model=\"$ctrl.newCash.batchId\" required disabled=\"disabled\"/>\n</div>\n<div class=\"margin-bottom-10\" ng-if=\"$ctrl.newCash.orderTypeOrShiptypeId\">\n<label ng-if=\"!$ctrl.newCash.isPackableOrder\">{{'master_cash_schedule.orderType' | translate}}</label>\n<label ng-if=\"$ctrl.newCash.isPackableOrder\">{{'master_cash_schedule.shipType' | translate}}</label>\n<select ng-if=\"$ctrl.newCash.status !== 'scheduled'\" class=\"form-control\" ng-model=\"$ctrl.newCash.orderTypeOrShiptypeId\" ng-disabled=\"$ctrl.newCash.status !== 'pendingPack' || $ctrl.newCash.isPackableOrder\" ng-options=\"orderType.value as orderType.key for orderType in $ctrl.allOrderTypes\" ng-change=\"$ctrl.handleOrderTypeChange($ctrl.newCash.orderTypeOrShiptypeId)\">\n<option value=\"\" disabled=\"disabled\">({{'common.select_OrderType' | translate}})</option>\n</select>\n<input class=\"form-control\" ng-if=\"$ctrl.newCash.status == 'scheduled'\" type=\"text\" name=\"orderType\" ng-model=\"$ctrl.newCash.orderTypeOrShiptypeId\" required disabled=\"disabled\"/>\n</div>\n<div class=\"margin-bottom-10\">\n<label>{{'master_cash_schedule.date' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"id\" ng-if=\"$ctrl.newCash.status == 'scheduled'\" placeholder=\"{{'master_cash_schedule.date' | translate}}\" ng-model=\"$ctrl.newCash.vaultDate\" disabled=\"disabled\"/>\n<datetimepicker class=\"edit-order-view-date-picker-section datetimepicker-input\" ng-model=\"$ctrl.newCash.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-if=\"$ctrl.newCash.status !== 'scheduled'\" date-options=\"$ctrl.maxDate\" ng-change=\"$ctrl.onEditVaultDateChange()\">\n</datetimepicker>\n</div>\n<div ng-class=\"{'margin-bottom-10': !$ctrl.newCash.isPackableOrder, 'hold-route-dropdown': $ctrl.isHoldRoute($ctrl.newCash.routeId)}\">\n<label>{{'master_cash_schedule.route' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.newCash.routeId\" ng-options=\"route.Value as route.Key for route in $ctrl.filterDataSet.routeList\" ng-if=\"$ctrl.newCash.status !== 'scheduled'\" required ng-disabled=\"!$ctrl.hasACL['master_cash_schedule'].edit || $ctrl.userDetails.customerUser || $ctrl.model.isGettingLocationRoutes\">\n<option value=\"\">{{'checkout.selectRoute' | translate}}</option>\n</select>\n<input class=\"form-control\" type=\"text\" name=\"routeId\" placeholder=\"{{'checkout.selectRoute' | translate}}\" ng-model=\"$ctrl.newCash.routeId\" ng-disabled=\"true\" ng-if=\"$ctrl.newCash.status == 'scheduled'\"/>\n</div>\n<div class=\"row\" ng-if=\"!$ctrl.newCash.coinShipments.length && !$ctrl.newCash.isPackableOrder\">\n<div class=\"col-sm-6\">\n<label>{{'master_cash_schedule.cash' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.cashAmount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"2\" ng-disabled=\"true\" required>\n</div>\n<div class=\"col-sm-6\">\n<label>{{'master_cash_schedule.coin' | translate}}</label>\n<input id=\"shipment-coin-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.coinAmount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"2\" ng-disabled=\"true\" required>\n</div>\n</div>\n<div class=\"col-sm-12 text-center remove-pad-left remove-pad-right margin-top-10 margin-bottom-10 icon-list-section\" ng-if=\"$ctrl.newCash.coinShipments.length\">\n<div class=\"remove-pad denom-controls\" ng-class=\"{'col-sm-6' : $ctrl.updatedCash.cashShipmentAmount,\n                                                   'col-sm-12' : !$ctrl.updatedCash.cashShipmentAmount}\">\n<div class=\"input-group\">\n<span class=\"input-group-addon padding5\" ng-class=\"{'icon-width-40' : $ctrl.updatedCash.cashShipmentAmount,\n                                                      'icon-width-50' : !$ctrl.updatedCash.cashShipmentAmount}\">\n<img src=\"" + __webpack_require__(247) + "\" class=\"img-currency\" uib-tooltip=\"{{'common.coin' | translate}}\"/>\n</span>\n<span class=\"form-control text-right z-index0\">\n{{$ctrl.updatedCash.coinShipmentAmount | currency:'$':($ctrl.model.currentStats === $ctrl.shipmentsCreateStats.prePacked.all ? 2 : 0)}}\n</span>\n</div>\n</div>\n<div class=\"remove-pad col-sm-6 edit-denom-controls\" ng-if=\"$ctrl.updatedCash.cashShipmentAmount\">\n<div class=\"input-group\">\n<span class=\"input-group-addon padding5 icon-width-40\">\n<img src=\"" + __webpack_require__(397) + "\" class=\"img-currency\" uib-tooltip=\"{{'common.cash' | translate}}\"/>\n</span>\n<input id=\"cashShipment\" class=\"form-control text-right z-index0\" name=\"cashShipment\" type=\"text\" ng-model=\"$ctrl.updatedCash.cashShipmentAmount\" ng-currency ng-attr-fraction=\"{{$ctrl.model.currentStats === $ctrl.shipmentsCreateStats.prePacked.all ? 2 : 0}}\" required>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad-left remove-pad-right\" ng-class=\"{'form-denom-list section-block' : $ctrl.newCash.coinShipments.length === 1,\n                                                    'form-denom-list' : $ctrl.newCash.coinShipments.length > 1}\">\n<div class=\"remove-pad-left remove-pad-right\" ng-repeat=\"coinShipment in $ctrl.updatedCash.coinShipments track by $index\">\n<div class=\"w-100 text-center\">\n<div class=\"denom-controls\">\n<span class=\"w-100 input-group-addon\">\n<denom-icon ng-if=\"coinShipment.shiptypeId !== 'M'\" denom-id=\"coinShipment.shiptypeId\" icon-size=\"22\"> </denom-icon>\n<denom-icon ng-if=\"coinShipment.shiptypeId === 'M'\" denom-id=\"'misc'\" icon-size=\"22\"> </denom-icon>\n</span>\n<input id=\"coinShipment-{{$parent.$index+1}}-{{$index+1}}\" name=\"coinShipment-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-model=\"$ctrl.updatedCash.coinShipments[$index].qty\" ng-change=\"$ctrl.updateTotalUpdateAmount(coinShipment);\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" required fraction=\"0\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"margin-top-10 col-sm-12 remove-pad-left remove-pad-right\" ng-class=\"{'edit-denom section-block' : $ctrl.newCash.denominations.length === 1,\n                                                    'edit-denom' : $ctrl.newCash.denominations.length > 1}\" ng-if=\"!$ctrl.newCash.isPackableOrder && !$ctrl.newCash.coinShipments.length && $ctrl.newCash.atmDenominations.length > 0\">\n<label>{{'master_cash_schedule.denominations' | translate}}</label>\n<div>\n<div class=\"col-sm-12 remove-pad-left remove-pad-right edit-denom\" ng-repeat=\"denomination in $ctrl.newCash.atmDenominations track by $index\" ng-init=\"$ctrl.atmDenomIndex = $index\" ng-if=\"denomination.isEnabled\">\n<div class=\"w-100 text-center\" ng-class=\"{\n                                                        'remove-pad-left_': $index < $ctrl.newCash.denominations.length ,\n                                                        'remove-pad-right_': $ctrl.newCash.denominations.length == $index+1\n                                                    }\">\n<div class=\"list-group-margin-bottom edit-denom-controls\" ng-style=\"!($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type =='scheduledATMLoadOrders') && {'pointer-events': 'none', 'cursor': 'not-allowed'}\">\n<span class=\"input-group-addon\" ng-show=\"denomination.isEnabled\">\n<a role=\"button\" uib-popover-template=\"denomination.template\" popover-is-open=\"denomination.isOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\" popover-enable=\"$ctrl.newCash.atmDenominations.length > 0\">\n<denom-icon denom-id=\"denomination.icon\" ng-if=\"denomination.icon\" icon-size=\"22\"> </denom-icon>\n</a>\n</span>\n<div class=\"input-group\" style=\"position: relative; display: inline-flex; width: 100%;\">\n<input ng-if=\"denomination.isEnabled && $ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center edit-input-denom\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.atmDenominations[$index].isValid, \n                                                            'ng-valid' : $ctrl.newCash.atmDenominations[$index].isValid && ($ctrl.newCash.atmDenominations[$index].amount > 0 || $ctrl.newCash.atmDenominations[$index].billCount > 0),\n                                                            'disabled': !$ctrl.hasACL['master_cash_schedule'].edit}\" ng-model=\"$ctrl.newCash.atmDenominations[$index].amount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'atmDenominations');\n                                                            $ctrl.calculateDenominationAmount(); $ctrl.checkForStrapCount('atmDenominations');\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-currency fraction=\"2\" min=\"0\" currency-symbol=\"$\" ng-disabled=\"!($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type =='scheduledATMLoadOrders') || $ctrl.newCash.orderType === 'P' || $ctrl.newCash.orderType === 'T'\" required>\n<input ng-if=\"denomination.isEnabled && !$ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center edit-input-denom\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.atmDenominations[$index].isValid, \n                                                            'ng-valid' : $ctrl.newCash.atmDenominations[$index].isValid && ($ctrl.newCash.atmDenominations[$index].amount > 0 || $ctrl.newCash.atmDenominations[$index].billCount > 0),\n                                                            'disabled': !$ctrl.hasACL['master_cash_schedule'].edit}\" ng-model=\"$ctrl.newCash.atmDenominations[$index].billCount\" placeholder=\"{{ 'atm_residual.bills' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'atmDenominations');\n                                                            $ctrl.calculateDenominationAmount(); $ctrl.checkForStrapCount('atmDenominations');\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency currency-symbol=\"\" min=\"0\" fraction=\"0\" ng-disabled=\"!($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type =='scheduledATMLoadOrders') || $ctrl.newCash.orderType === 'P' || $ctrl.newCash.orderType === 'T'\" required>\n<button class=\"btn btn-xs btn-danger edit-turn-off-button\" ng-click=\"$ctrl.turnOffDenom(denomination, $index, 'atmDenominations'); $event.stopPropagation();\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].delete && ($ctrl.newCash.status =='pendingPack' || $ctrl.newCash.type =='scheduledATMLoadOrders')\">\nX\n</button>\n</div>\n</div>\n</div>\n</div>\n<button class=\"btn btn-xs btn-success\" type=\"button\" ng-disabled=\"$ctrl.newCash.atmDenominations.length === $ctrl.atmDenomIndex+1\" ng-click=\"$ctrl.newCash.atmDenominations[atmDenomIndex + 1] && $ctrl.handleDenomination($ctrl.newCash.atmDenominations[atmDenomIndex + 1], 'remainingAtmDenominations');\" style=\"width: 20px;\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].create && ($ctrl.newCash.status =='pendingPack' || $ctrl.newCash.type =='scheduledATMLoadOrders')\">\n<span class=\"glyphicon-plus\"></span>\n</button>\n</div>\n</div>\n<div class=\"edit-denom-controls col-sm-12 remove-pad-left remove-pad-right\" ng-if=\"$ctrl.newCash.isPackableOrder\">\n<div class=\"col-sm-12 remove-pad-left remove-pad-right _margin-top-10\" ng-if=\"$ctrl.newCash.isPackableOrder\">\n<div class=\"margin-bottom-10 col-sm-12 remove-pad-left\" style=\"width: 50%; padding-right: 5px !important;\" ng-if=\"!$ctrl.newCash.coinShipments.length && $ctrl.newCash.isPackableOrder\">\n<label>{{'master_cash_schedule.cash' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control-edit\" ng-model=\"$ctrl.newCash.cashShipmentAmount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"2\" ng-disabled=\"true\" required disabled=\"disabled\">\n</div>\n<div class=\"margin-bottom-10 col-sm-12 remove-pad-left remove-pad-right\" style=\"width: 50%; padding-left: 5px !important;\" ng-if=\"!$ctrl.newCash.coinShipments.length && $ctrl.newCash.isPackableOrder\">\n<label>{{'master_cash_schedule.coin' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control-edit\" ng-model=\"$ctrl.newCash.coinShipmentAmount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"2\" ng-disabled=\"true\" required disabled=\"disabled\">\n</div>\n</div>\n</div>\n<div class=\"edit-denom-controls col-sm-12 remove-pad-left remove-pad-right\" ng-if=\"$ctrl.newCash.isPackableOrder\">\n<div class=\"margin-top-10 col-sm-12 remove-pad-left remove-pad-right\" ng-class=\"{'edit-denom section-block' : $ctrl.newCash.denominations.length === 1,\n                                       'edit-denom' : $ctrl.newCash.denominations.length > 1,\n                                       'multi-denom-edit': ($ctrl.newCash.isPackableOrder && ($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')) || \n                                       ($ctrl.newCash.denominations | filter:{isEnabled:true}).length > 0,\n                                        'denom-edit-w-100': !(($ctrl.newCash.isPackableOrder && ($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')) || \n                                      ($ctrl.newCash.denominations | filter:{isEnabled:true}).length > 0)\n                                    }\" ng-if=\"($ctrl.newCash.isPackableOrder && ($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')) || ($ctrl.newCash.multiDenominations | filter:{isEnabled:true}).length > 0\">\n<label>Multi-Denom</label>\n<div>\n<div class=\"col-sm-12 remove-pad-left remove-pad-right edit-denom\" ng-repeat=\"denomination in $ctrl.newCash.multiDenominations track by $index\" ng-class=\"{'remove-pad-right': !(($ctrl.newCash.isPackableOrder && ($ctrl.newCash.status == 'pendingPack'|| $ctrl.newCash.type == 'scheduledPackableOrder')) || ($ctrl.newCash.denominations | filter:{isEnabled:true}).length > 0) }\" ng-init=\"$ctrl.multiDenomIndex = $index\" ng-if=\"denomination.isEnabled\">\n<div class=\"w-100 text-center remove-pad-left remove-pad-right\">\n<div class=\"list-group-margin-bottom edit-denom-controls\" ng-style=\"!($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder') && {'pointer-events': 'none', 'cursor': 'not-allowed'}\">\n<span class=\"input-group-addon\" ng-show=\"denomination.isEnabled\">\n<a role=\"button\" uib-popover-template=\"denomination.template\" popover-is-open=\"denomination.isOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\" popover-enable=\"$ctrl.newCash.multiDenominations.length > 0\" ng-disabled=\"$ctrl.newCash.status !=='pendingPack' || $ctrl.newCash.type !== 'scheduledPackableOrder'\">\n<denom-icon denom-id=\"denomination.icon\" ng-if=\"denomination.icon\" icon-size=\"22\"> </denom-icon>\n</a>\n</span>\n<div class=\"input-group\" style=\"position: relative; display: inline-flex; width: 100%;\">\n<input ng-if=\"denomination.isEnabled && $ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center edit-input-denom\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.multiDenominations[$index].isValid, \n                                                   'ng-valid' : $ctrl.newCash.multiDenominations[$index].isValid && ($ctrl.newCash.multiDenominations[$index].amount > 0 || $ctrl.newCash.multiDenominations[$index].billCount > 0),\n                                                    'disabled': !$ctrl.hasACL['master_cash_schedule'].edit}\" ng-model=\"$ctrl.newCash.multiDenominations[$index].amount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'multiDenominations');\n                                                   $ctrl.calculateDenominationAmount(); $ctrl.checkForStrapCount('multiDenominations');\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-currency fraction=\"2\" min=\"0\" currency-symbol=\"$\" ng-disabled=\"!($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')\" required>\n<input ng-if=\"denomination.isEnabled && !$ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center edit-input-denom\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.multiDenominations[$index].isValid, \n                                                   'ng-valid' : $ctrl.newCash.multiDenominations[$index].isValid && ($ctrl.newCash.multiDenominations[$index].amount > 0 || $ctrl.newCash.multiDenominations[$index].billCount > 0),\n                                                    'disabled': !$ctrl.hasACL['master_cash_schedule'].edit}\" ng-model=\"$ctrl.newCash.multiDenominations[$index].billCount\" placeholder=\"{{ denomination.coinFlag ? 'atm_residual.qty' : 'atm_residual.bills' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'multiDenominations');\n                                                   $ctrl.calculateDenominationAmount(); $ctrl.checkForStrapCount('multiDenominations');\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency currency-symbol=\"\" min=\"0\" fraction=\"0\" ng-disabled=\"!($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')\" required>\n<button class=\"btn btn-xs btn-danger edit-turn-off-button\" ng-click=\"$ctrl.turnOffDenom(denomination, $index, 'multiDenominations'); $event.stopPropagation();\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].delete && ($ctrl.newCash.status =='pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')\">\nX\n</button>\n</div>\n</div>\n</div>\n</div>\n<button class=\"btn btn-xs btn-success\" type=\"button\" ng-disabled=\"$ctrl.newCash.multiDenominations.length === $ctrl.multiDenomIndex+1 || $ctrl.newCash.multiDenominations.length === 0\" ng-click=\"$ctrl.newCash.multiDenominations[multiDenomIndex + 1] && $ctrl.handleDenomination($ctrl.newCash.multiDenominations[$ctrl.multiDenomIndex+1], 'remainingMultiDenominations');\" style=\"width: 20px;\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].edit && ($ctrl.newCash.status =='pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')\">\n<span class=\"glyphicon-plus\"></span>\n</button>\n</div>\n</div>\n<div class=\"margin-top-10 col-sm-12 remove-pad-left remove-pad-right\" ng-class=\"{'edit-denom section-block' : $ctrl.newCash.denominations.length === 1,\n                                           'edit-denom' : $ctrl.newCash.denominations.length > 1,\n                                           'single-denom-edit': (($ctrl.newCash.isPackableOrder && ($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')) || ($ctrl.newCash.multiDenominations | filter:{isEnabled:true}).length > 0),\n                                            'denom-edit-w-100': !(($ctrl.newCash.isPackableOrder && ($ctrl.newCash.status == 'pendingPack'|| $ctrl.newCash.type == 'scheduledPackableOrder')) || \n                                          ($ctrl.newCash.multiDenominations | filter:{isEnabled:true}).length > 0)}\" ng-if=\"($ctrl.newCash.isPackableOrder && ($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')) || ($ctrl.newCash.denominations | filter:{isEnabled:true}).length > 0\">\n<label>Single-Denom</label>\n<div>\n<div>\n<div class=\"col-sm-12 remove-pad-left remove-pad-right edit-denom\" ng-repeat=\"denomination in $ctrl.newCash.denominations track by $index\" ng-init=\"$ctrl.singleDenomIndex = $index\" ng-if=\"denomination.isEnabled\">\n<div class=\"w-100 text-center remove-pad-left remove-pad-right\">\n<div class=\"list-group-margin-bottom edit-denom-controls\" ng-style=\"!($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type =='scheduledPackableOrder') && {'pointer-events': 'none', 'cursor': 'not-allowed'}\">\n<span class=\"input-group-addon\" ng-show=\"denomination.isEnabled\">\n<a role=\"button\" uib-popover-template=\"denomination.template\" popover-is-open=\"denomination.isOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\" popover-enable=\"$ctrl.newCash.denominations.length > 0\" ng-disabled=\"!($ctrl.newCash.status =='pendingPack' || $ctrl.newCash.type =='scheduledPackableOrder')\">\n<denom-icon denom-id=\"denomination.icon\" ng-if=\"denomination.icon\" icon-size=\"22\"> </denom-icon>\n</a>\n</span>\n<div class=\"input-group\" style=\"position: relative; display: inline-flex; width: 100%;\">\n<input ng-if=\"denomination.isEnabled && $ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center edit-input-denom\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.denominations[$index].isValid, \n                                                   'ng-valid' : $ctrl.newCash.denominations[$index].isValid && ($ctrl.newCash.denominations[$index].amount > 0 || $ctrl.newCash.denominations[$index].billCount > 0),\n                                                   'disabled': !$ctrl.hasACL['master_cash_schedule'].edit}\" ng-model=\"$ctrl.newCash.denominations[$index].amount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'denominations');\n                                                   $ctrl.calculateDenominationAmount(); $ctrl.checkForStrapCount('denominations');\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-currency fraction=\"2\" min=\"0\" currency-symbol=\"$\" ng-disabled=\"!($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')\" required>\n<input ng-if=\"denomination.isEnabled && !$ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center edit-input-denom\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.denominations[$index].isValid, \n                                                   'ng-valid' : $ctrl.newCash.denominations[$index].isValid && ($ctrl.newCash.denominations[$index].amount > 0 || $ctrl.newCash.denominations[$index].billCount > 0),\n                                                   'disabled': !$ctrl.hasACL['master_cash_schedule'].edit}\" ng-model=\"$ctrl.newCash.denominations[$index].billCount\" placeholder=\"{{ denomination.coinFlag ? 'atm_residual.qty' : 'atm_residual.bills' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'denominations');\n                                                   $ctrl.calculateDenominationAmount(); $ctrl.checkForStrapCount('denominations');\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency currency-symbol=\"\" min=\"0\" fraction=\"0\" ng-disabled=\"!($ctrl.newCash.status == 'pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')\" required>\n<button class=\"btn btn-xs btn-danger edit-turn-off-button\" ng-click=\"$ctrl.turnOffDenom(denomination, $index, 'denominations'); $event.stopPropagation();\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].delete && ($ctrl.newCash.status =='pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')\">\nX\n</button>\n</div>\n</div>\n</div>\n</div>\n<button class=\"btn btn-xs btn-success\" type=\"button\" ng-disabled=\"$ctrl.newCash.denominations.length === $ctrl.singleDenomIndex+1 || $ctrl.newCash.denominations.length === 0\" ng-click=\"$ctrl.newCash.denominations[singleDenomIndex + 1] && $ctrl.handleDenomination($ctrl.newCash.denominations[singleDenomIndex + 1], 'remainingDenominations');\" style=\"width: 20px;\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].edit && ($ctrl.newCash.status =='pendingPack' || $ctrl.newCash.type == 'scheduledPackableOrder')\">\n<span class=\"glyphicon-plus\"></span>\n</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"!$ctrl.isValidStrapBillCount && $ctrl.newCash.status =='pendingPack'\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\" style=\"margin-bottom: 0px !important;\">\n{{'addBagModal.notDivisibleByStrapError' | translate}}\n</span>\n</div>\n<div class=\"_margin-top-10 col-sm-12 remove-pad-left remove-pad-right\">\n<button class=\"btn btn-success\" type=\"submit\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].edit && (!$ctrl.newCash.id || $ctrl.newCash.status == 'pendingPack')\" ng-click=\"$ctrl.updatePendingPackShipment($event)\" ng-disabled=\"cashForm.$invalid || $ctrl.newCash.isUpdatingAtmOrders || !$ctrl.checkForStrapCount() || !$ctrl.isValidStrapBillCount || !$ctrl.isValidBillCount || ($ctrl.userDetails.customerUser && $ctrl.newCash.orderType !== 'A' && $ctrl.newCash.orderType !== 'S' && $ctrl.newCash.orderType !== 'COD')\">\n{{'common.update' | translate}}\n<span ng-if=\"$ctrl.newCash.isUpdatingAtmOrders\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].edit && (!$ctrl.newCash.id || ( $ctrl.newCash.type == 'scheduledATMLoadOrders' || $ctrl.newCash.type == 'scheduledPackableOrder'))\" ng-click=\"$ctrl.updateScheduledShipment($event)\" ng-disabled=\"cashForm.$invalid || $ctrl.newCash.isUpdatingAtmOrders || !$ctrl.checkForStrapCount() || !$ctrl.isValidStrapBillCount || !$ctrl.isValidBillCount || ($ctrl.userDetails.customerUser && $ctrl.newCash.orderType !== 'A' && $ctrl.newCash.orderType !== 'S' && $ctrl.newCash.orderType !== 'COD')\">\n{{'common.update' | translate}}\n<span ng-if=\"$ctrl.newCash.isUpdatingAtmOrders\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n<button class=\"btn btn-danger\" type=\"submit\" ng-if=\"$ctrl.hasACL['master_cash_schedule'].delete && (!$ctrl.newCash.id || ($ctrl.newCash.status == 'pendingPack'))\" ng-click=\"$ctrl.cancelAtmOrder($ctrl.newCash)\" ng-disabled=\"cashForm.$invalid || $ctrl.newCash.deleteAtmOrders\">\n{{'common.Delete' | translate}}\n<span ng-if=\"$ctrl.newCash.deleteAtmOrders\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-if=\"$ctrl.newCash.batchId && !$ctrl.newCash.orderNo && $ctrl.hasACL['master_cash_schedule'].edit\" ng-click=\"$ctrl.updatePackedCashBag($event)\" ng-disabled=\"cashForm.$invalid || $ctrl.newCash.isUpdatingPackedCashBag || ($ctrl.userDetails.customerUser && $ctrl.newCash.orderType !== 'A' && $ctrl.newCash.orderType !== 'S' && $ctrl.newCash.orderType !== 'COD')\">\n{{'common.update' | translate}}\n<span ng-if=\"$ctrl.newCash.isUpdatingPackedCashBag\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.closePanel()\">{{'common.close' | translate}}</button>\n</div>\n</form>\n</div>\n\n\n\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl._calendar.isSidePanelOpen && $ctrl._calendar.isNew\" class=\"selected-date-panel panel-width-45\" style=\"z-index: 5\">\n<div class=\"create-new w-100\">\n<div class=\"panel-header pending-shipment-header-section\">\n<div class=\"col-sm-5 remove-pad total-amount\">\n<span> {{$ctrl.newCash.totalAmount || 0 | currency:'$':2}}</span>\n<span ng-if=\"$ctrl.newCash.toLocation\"> | {{$ctrl.newCash.toLocation.Value}}</span>\n</div>\n<div class=\"col-sm-7 remove-pad order-create-tab-section\">\n<div class=\"btn-group\">\n<div class=\"btn-group\" ng-if=\"!$ctrl.customerUser\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStats\" uib-btn-radio=\"$ctrl.shipmentsCreateStats.prePacked.all\" ng-click=\"$ctrl.tabSelection('prePacked', 'all')\" ng-class=\"{'btn-success': $ctrl.model.currentStats === $ctrl.shipmentsCreateStats.prePacked.all, \n                                                   'remove-group-btn-color': ($ctrl.model.currentStats === $ctrl.shipmentsCreateStats.ATMOrders.all || $ctrl.model.currentStats === $ctrl.shipmentsCreateStats.cashDeliveries.all)}\">\n{{ 'master_cash_schedule.pre_packed' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStats\" uib-btn-radio=\"$ctrl.shipmentsCreateStats.cashDeliveries.all\" ng-click=\"$ctrl.tabSelection('cashDeliveries', 'all'); $ctrl.childTabSelection('cashDeliveries', 'single'); $ctrl.generateOrderNumber()\" ng-class=\"{'btn-success': $ctrl.model.currentStats === $ctrl.shipmentsCreateStats.cashDeliveries.all, \n                                                   'remove-group-btn-color': ($ctrl.model.currentStats === $ctrl.shipmentsCreateStats.ATMOrders.all || $ctrl.model.currentStats === $ctrl.shipmentsCreateStats.prePacked.all)}\">\n{{ 'shipment.unpacked' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentStats\" uib-btn-radio=\"$ctrl.shipmentsCreateStats.ATMOrders.all\" ng-click=\"$ctrl.tabSelection('ATMOrders', 'all'); $ctrl.childTabSelection('ATMOrders', 'single'); $ctrl.generateOrderNumber();\" ng-class=\"{'btn-success': $ctrl.model.currentStats === $ctrl.shipmentsCreateStats.ATMOrders.all, \n                                                  'remove-group-btn-color': ($ctrl.model.currentStats === $ctrl.shipmentsCreateStats.cashDeliveries.all || $ctrl.model.currentStats === $ctrl.shipmentsCreateStats.prePacked.all)}\">\n{{ 'common.ATM_load' | translate }}\n</label>\n</div>\n</div>\n</div>\n</div>\n<div class=\"panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.shipmentsCreateStats.prePacked.all && !$ctrl.customerUser\">\n<div class=\"cash-schedule-form\">\n<form name=\"preLoadForm\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"margin-bottom-10 col-sm-6 remove-pad-left\" ng-if=\"$ctrl.newCash.batchId\">\n<label>{{'master_cash_schedule.batch_id' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"batchId\" ng-model=\"$ctrl.newCash.batchId\" required disabled=\"disabled\"/>\n</div>\n<div class=\"col-sm-6 remove-pad-right create-order-view-date-picker-section margin-bottom-10\">\n<label for=\"\">{{'common.vault_date' | translate }} </label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.newCash.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.onVaultDateChange()\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"margin-bottom-10 col-sm-6 remove-pad-left\">\n<label>{{'shipmentBatch.location' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.fromLocation\" values=\"$ctrl.fromLocationObj.results\" key=\"Key\" totalrecords=\"$ctrl.fromLocationObj.totalRecords\" on-click=\"$ctrl.getDeliverToBankLocations(); $ctrl.getRouteListFromSelectedLocation();\" onscroll=\"$ctrl.loadFromLocation(searchKey, offset)\" none-selected=\"'bulkCash.selectFromLocation'\" required>\n</search-and-select>\n</div>\n<div class=\"margin-bottom-10 col-sm-6 remove-pad-right\">\n<label>{{'bagout.toLocation' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.toLocation\" values=\"$ctrl.deliveryLocationObj.results\" key=\"Key\" totalrecords=\"$ctrl.deliveryLocationObj.totalRecords\" ng-disabled=\"!$ctrl.newCash.fromLocation\" onscroll=\"$ctrl.getDeliverToBankLocations(searchKey, offset)\" none-selected=\"'Select ToLocation'\" on-click=\"$ctrl.getLocationNextRoute(); $ctrl.resetRouteId('toLocation');\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"margin-bottom-10 col-sm-6 remove-pad-left\" ng-class=\"{'hold-route-dropdown': $ctrl.isHoldRoute($ctrl.newCash.routeId)}\">\n<label>{{'master_cash_schedule.route' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.routeId\" values=\"$ctrl.filterDataSet.routeList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalRoutes\" common-search-flag=\"true\" none-selected=\"'master_cash_schedule.route'\" required ng-disabled=\"!$ctrl.newCash.toLocation\">\n</search-and-select>\n</div>\n<div class=\"col-sm-6 remove-pad-right margin-bottom-10\">\n<label>{{'master_cash_schedule.cash_amount' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control\" ng-change=\"$ctrl.getCurrency()\" ng-model=\"$ctrl.newCash.cashAmount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" ng-currency fraction=\"2\" required>\n</div>\n</div>\n<div class=\"margin-bottom-10 col-sm-12 remove-pad-right remove-pad-left\">\n<label>{{'common.trackingId' | translate}}</label>\n<input id=\"new-tracking-id\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.trackingId\" placeholder=\"{{ 'bagout.trackingId' | translate }}\" ng-pattern=\"/^[a-zA-Z0-9-$_ ]*$/\" required>\n</div>\n<div class=\"margin-bottom-10 col-sm-12 remove-pad-right remove-pad-left\">\n<table class=\"table margin-zero table-pad-3\">\n<tr>\n<td ng-repeat=\"key in $ctrl.denominationTypeKeys\" class=\"coin-entry bordered-cell\" align=\"center\">\n<a role=\"button\" uib-popover-template=\"$ctrl.coinTypes[key].template\" popover-placement=\"top-left\" popover-is-open=\"$ctrl.coinTypes[key].isOpen\" popover-trigger=\"'outsideClick'\">\n<denom-icon ng-if=\"$ctrl.coinTypes[key].selected !== 'M'\" denom-id=\"$ctrl.coinTypes[key].selected\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"$ctrl.coinTypes[key].selected === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n</a>\n<input min=\"0\" type=\"number\" class=\"coin-entry form-control margin-top-05 text-center\" ng-change=\"$ctrl.getCurrency(); $ctrl.getCurrencyTotal();\" ng-model=\"$ctrl.newCash.coinShipmentObj[$ctrl.coinTypes[key].categoryName]\"/>\n</td>\n</tr></table>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"margin-bottom-10 col-sm-6 remove-pad-left\">\n<label>{{'master_cash_schedule.coin_amount' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.coinAmount\" placeholder=\"{{'master_cash_schedule.coin_amount' | translate}}\" disabled=\"disabled\" ng-currency fraction=\"2\" required>\n</div>\n<div class=\"col-sm-6 remove-pad-right _margin-bottom-10\">\n<label>{{'bagout.totalAmount' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.totalAmount\" placeholder=\"{{'bagout.totalAmount' | translate}}\" disabled=\"disabled\" ng-currency fraction=\"2\" required>\n</div>\n</div>\n<div class=\"_margin-top-10 col-sm-12 remove-pad-left remove-pad-right\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.closePanel()\">{{'common.close' | translate}}</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-if=\"!$ctrl.newCash.id\" ng-disabled=\"$ctrl.isCommitDisabled || preLoadForm.$invalid\" ng-click=\"$ctrl.createCashDeliveries($event)\">{{'common.Create' | translate}}</button>\n</div>\n</form>\n</div>\n\n</div>\n<div class=\"w-100 align-center margin-10\" ng-if=\"$ctrl.model.currentStats === $ctrl.shipmentsCreateStats.cashDeliveries.all\">\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentChildStat\" uib-btn-radio=\"$ctrl.shipmentsCreateStats.cashDeliveries.single\" ng-click=\"$ctrl.tabSelection('cashDeliveries', 'all'); $ctrl.childTabSelection('cashDeliveries', 'single'); $ctrl.generateOrderNumber()\" ng-class=\"{'btn-success': $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.cashDeliveries.single, \n                                               'remove-group-btn-color': $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.cashDeliveries.recurring}\">\nSingle\n</label>\n</div>\n<div class=\"btn-group\" ng-if=\"!$ctrl.customerUser\" ng-class=\"{'disabled-state-cursor' : !$ctrl.allowRecurring()}\" uib-tooltip=\"Past Date\" tooltip-placement=\"top-left\" tooltip-enable=\"!$ctrl.allowRecurring()\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentChildStat\" uib-btn-radio=\"$ctrl.shipmentsCreateStats.cashDeliveries.recurring\" ng-click=\"$ctrl.tabSelection('cashDeliveries', 'all'); $ctrl.childTabSelection('cashDeliveries', 'recurring'); $ctrl.generateOrderNumber()\" ng-class=\"{'btn-success': $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.cashDeliveries.recurring, \n                                              'remove-group-btn-color': $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.cashDeliveries.single,\n                                              'disabled disabled-state': !$ctrl.allowRecurring()}\">\nRecurring\n</label>\n</div>\n</div>\n</div>\n<div class=\"panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.shipmentsCreateStats.cashDeliveries.all && $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.cashDeliveries.single\">\n<div class=\"cash-schedule-form\">\n<form name=\"cashForm\" novalidate class=\"form-validate\">\n<div class=\"text-align-center col-sm-12\" ng-if=\"$ctrl.model.gettingOrderNo || $ctrl.loadDenomination\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-30\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.gettingOrderNo && !$ctrl.loadDenomination\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-left\">\n<label>{{'branch_mgmt.orders_selectATMs' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.fundingSource\" values=\"$ctrl.filterDataSet.branchFundingSource\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalBranchFundingSource\" on-click=\"$ctrl.getFundingSourceDenomination($ctrl.newCash.fundingSource.Value); $ctrl.onFundingSourceSelected();\" onscroll=\"$ctrl.getAllFundingSource(searchKey, offset)\" none-selected=\"'bulkCash.selectFundingSource'\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\">\n<label>{{'master_cash_schedule.orderNo' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"orderNo\" ng-model=\"$ctrl.newCash.orderNo\" required ng-pattern=\"/^[0-9]*$/\" placeholder=\"{{'master_cash_schedule.orderNo' | translate}}\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-left\">\n<label>{{'master_cash_schedule.location' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.toLocation\" values=\"$ctrl.filterDataSet.locationList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalLocation\" onscroll=\"$ctrl.loadLocation(searchKey, offset)\" none-selected=\"'common.select_location'\" on-click=\"$ctrl.getLocationNextRoute(); $ctrl.resetRouteId('toLocation');\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\" ng-class=\"{'hold-route-dropdown': $ctrl.isHoldRoute($ctrl.newCash.routeId)}\">\n<label>{{'master_cash_schedule.route' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.routeId\" values=\"$ctrl.filterDataSet.routeList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalRoutes\" common-search-flag=\"true\" ng-disabled=\"$ctrl.model.isGettingLocationRoutes || !$ctrl.newCash.toLocation || $ctrl.userDetails.customerUser\" none-selected=\"'master_cash_schedule.route'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3 margin-bottom-10 create-order-view-date-picker-section remove-pad-left remove-pad-right\">\n<label>{{'master_cash_schedule.date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-if=\"$ctrl.shouldApplyCustomerFundingSourceLeadDate()\" ng-model=\"$ctrl.newCash.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.onVaultDateChange()\" date-options=\"$ctrl.maxDate\" date-disabled=\"$ctrl.isNonBusinessDay(date, mode)\">\n</datetimepicker>\n<datetimepicker class=\"datetimepicker-input\" ng-if=\"!$ctrl.shouldApplyCustomerFundingSourceLeadDate()\" ng-model=\"$ctrl.newCash.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.onVaultDateChange()\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-5 margin-bottom-10 remove-pad-right\">\n<div>\n<label>{{'master_cash_schedule.shipType' | translate}}</label>\n</div>\n<select class=\"form-control\" ng-model=\"$ctrl.newCash.orderType\" required ng-options=\"shipType.value as shipType.key for shipType in $ctrl.filterDataSet.shipTypes\" ng-change=\"$ctrl.validateBillCount();\">\n<option value=\"\" disabled=\"disabled\">({{'common.select_shiptype' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-4 margin-bottom-10 remove-pad-right z-index0\">\n<label>{{'transaction_log.account' | translate}}</label>\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.newCash.account\" uib-btn-radio=\"$ctrl.model.ATMLoadAccountStats.regular\" ng-class=\"{'btn-success': $ctrl.newCash.account === $ctrl.model.ATMLoadAccountStats.regular,\n                                                                                                   'remove-btn-grp-color': $ctrl.newCash.account === $ctrl.model.ATMLoadAccountStats.emergency}\">\n{{ 'common.regular' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.newCash.account\" uib-btn-radio=\"$ctrl.model.ATMLoadAccountStats.emergency\" ng-class=\"{'btn-success': $ctrl.newCash.account === $ctrl.model.ATMLoadAccountStats.emergency,\n                                                                                                   'remove-btn-grp-color': $ctrl.newCash.account === $ctrl.model.ATMLoadAccountStats.regular}\">\n{{ 'common.emergency' | translate }}\n</label>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"margin-bottom-10 col-sm-4 remove-pad-left\">\n<label>{{'master_cash_schedule.coin_amount' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.coinAmount\" placeholder=\"{{'master_cash_schedule.coin_amount' | translate}}\" disabled=\"disabled\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"2\" required>\n</div>\n<div class=\"margin-bottom-10 col-sm-4 remove-pad-left\">\n<label>{{'master_cash_schedule.cash_amount' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.cashAmount\" placeholder=\"{{'master_cash_schedule.cash_amount' | translate}}\" disabled=\"disabled\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"2\" required>\n</div>\n<div class=\"col-sm-4 remove-pad-right _margin-bottom-10\">\n<label>{{'bagout.totalAmount' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.totalAmount\" placeholder=\"{{'bagout.totalAmount' | translate}}\" disabled=\"disabled\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"2\" required>\n</div>\n</div>\n<div class=\"margin-bottom-10 margin-top-05 remove-pad-right z-index0\" ng-if=\"$ctrl.newCash.fundingSource && !$ctrl.loadBfsDenomination && $ctrl.newCash.multiDenominations.length > 0 \">\n<label>Multi-Denom Packed</label>\n<div class=\"multi-denomination-box-border\" style=\"display: flex;\">\n<div class=\"col-sm-12 form-denom-list remove-pad-left remove-pad-right\" style=\"display: flex; flex-wrap:wrap;\">\n<div class=\"col-sm-3 remove-pad-left remove-pad-right\" ng-repeat=\"multiDenomination in $ctrl.newCash.multiDenominations track by $index\" ng-if=\"multiDenomination.isEnabled\" ng-init=\"$ctrl.multiDenomIndex = $index\" style=\"flex: 0 0 23.5%;\">\n<div class=\"w-100 text-center\" ng-class=\"{\n                                                                                            'remove-pad-left_': $index < $ctrl.newCash.multiDenominations.length ,\n                                                                                            'remove-pad-right_': $ctrl.newCash.multiDenominations.length == $index+1\n                                                                                        }\">\n<div class=\"_form-group denom-controls\">\n<div class=\"btn-xs\" ng-class=\"{\n                                                                'btn': $index === 0, \n                                                                'btn-warning': multiDenomination.isEnabled , \n                                                                'btn-default': !multiDenomination.isEnabled\n                                                            }\" ng-if=\"multiDenomination.isEnabled\" style=\"display: flex; align-items: center; justify-content: space-between; padding: 0 5px;\">\n<span style=\"margin: 0 auto;\">{{$index + 1}}</span>\n<button class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.turnOffDenom(multiDenomination, $index, 'multiDenominations'); $event.stopPropagation();\" style=\"margin: 2px 0; font-size: 7px;\">\nX\n</button>\n</div>\n<span class=\"w-100 input-group-addon border-radius-05\" ng-show=\"multiDenomination.isEnabled\">\n<a role=\"button\" uib-popover-template=\"multiDenomination.template\" popover-is-open=\"multiDenomination.isOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\" popover-enable=\"$ctrl.newCash.multiDenominations.length > 0\">\n<denom-icon denom-id=\"multiDenomination.icon\" ng-if=\"multiDenomination.icon\" icon-size=\"35\"> </denom-icon>\n</a>\n</span>\n<input ng-if=\"multiDenomination.isEnabled && $ctrl.shouldUseAmountInput(multiDenomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.multiDenominations[$index].isValid, \n                                                                            'ng-valid' : $ctrl.newCash.multiDenominations[$index].isValid || $ctrl.newCash.multiDenominations[$index].amount}\" ng-model=\"$ctrl.newCash.multiDenominations[$index].amount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'multiDenominations');\n                                                                           $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('multiDenominations')\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-currency fraction=\"2\" min=\"0\" currency-symbol=\"$\" ng-required=\"multiDenomination.isEnabled\">\n<input ng-if=\"multiDenomination.isEnabled && !$ctrl.shouldUseAmountInput(multiDenomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.multiDenominations[$index].isValid, \n                                                                            'ng-valid' : $ctrl.newCash.multiDenominations[$index].isValid || $ctrl.newCash.multiDenominations[$index].amount}\" ng-model=\"$ctrl.newCash.multiDenominations[$index].billCount\" placeholder=\"{{ multiDenomination.coinFlag ? 'atm_residual.qty' : 'atm_residual.bills' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'multiDenominations');\n                                                                           $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('multiDenominations')\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"0\" min=\"0\" currency-symbol=\"\" ng-required=\"multiDenomination.isEnabled\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-1 remove-pad-left remove-pad-right\" style=\"display: flex; justify-content: center; align-items: center; flex: 0 0 6%; padding: 5px;\">\n<button class=\"btn btn-xs btn-success\" type=\"button\" ng-click=\"$ctrl.handleDenomination($ctrl.newCash.multiDenominations[$ctrl.multiDenomIndex+1], 'remainingMultiDenominations')\" ng-disabled=\"!$ctrl.newCash.multiDenominations[$ctrl.multiDenomIndex+1]\">\n<span class=\"glyphicon-plus\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"remove-pad-right col-sm-12 remove-left-pad z-index0 margin-top-05\" ng-if=\"$ctrl.newCash.fundingSource && !$ctrl.loadBfsDenomination && $ctrl.newCash.denominations.length > 0 \">\n<label>Single-Denom Packed</label>\n<div style=\"display: flex;\">\n<div class=\"col-sm-12 remove-pad-left remove-pad-right form-denom-list\" style=\"display: flex; flex-wrap:wrap;\">\n<div class=\"col-sm-3 single-denomination-box-border\" ng-repeat=\"denomination in $ctrl.newCash.denominations track by $index\" ng-if=\"denomination.isEnabled\" ng-init=\"$ctrl.singleDenomIndex = $index\" style=\"flex: 0 0 23.5%;\">\n<div class=\"w-100 text-center\" ng-class=\"{\n                                                                                                                            'remove-pad-left_': $index < $ctrl.newCash.denominations.length ,\n                                                                                                                            'remove-pad-right_': $ctrl.newCash.denominations.length == $index+1\n                                                                                                                        }\">\n<div class=\"_form-group denom-controls\">\n<div class=\"btn-xs\" ng-class=\"{\n                                                                'btn': $index === 0, \n                                                                'btn-warning': denomination.isEnabled , \n                                                                'btn-default': !denomination.isEnabled\n                                                            }\" ng-if=\"denomination.isEnabled\" style=\"display: flex; align-items: center; justify-content: space-between; padding: 0 5px;\">\n<span style=\"margin: 0 auto;\">{{$index + 1}}</span>\n<button class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.turnOffDenom(denomination, $index, 'denominations'); $event.stopPropagation();\" style=\"margin: 2px 0; font-size: 7px;\">\nX\n</button>\n</div>\n<span class=\"w-100 input-group-addon border-radius-05\" ng-show=\"denomination.isEnabled\">\n<a role=\"button\" uib-popover-template=\"denomination.template\" popover-is-open=\"denomination.isOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\" popover-enable=\"$ctrl.newCash.denominations.length > 0\">\n<denom-icon denom-id=\"denomination.icon\" ng-if=\"denomination.icon\" icon-size=\"35\"> </denom-icon>\n</a>\n</span>\n<input ng-if=\"denomination.isEnabled && $ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.denominations[$index].isValid, \n                                                                                                                            'ng-valid' : $ctrl.newCash.denominations[$index].isValid || $ctrl.newCash.denominations[$index].amount}\" ng-model=\"$ctrl.newCash.denominations[$index].amount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'denominations');\n                                                                           $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('denominations')\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-currency fraction=\"2\" min=\"0\" currency-symbol=\"$\" ng-required=\"denomination.isEnabled\">\n<input ng-if=\"denomination.isEnabled && !$ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.denominations[$index].isValid, \n                                                                                                                            'ng-valid' : $ctrl.newCash.denominations[$index].isValid || $ctrl.newCash.denominations[$index].amount}\" ng-model=\"$ctrl.newCash.denominations[$index].billCount\" placeholder=\"{{ denomination.coinFlag ? 'atm_residual.qty' : 'atm_residual.bills' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'denominations');\n                                                                           $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('denominations')\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"0\" min=\"0\" currency-symbol=\"\" ng-required=\"denomination.isEnabled\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-1 remove-pad-left remove-pad-right\" style=\"display: flex; justify-content: center; align-items: center; flex: 0 0 6%; padding: 5px;\">\n<button class=\"btn btn-xs btn-success\" type=\"button\" ng-click=\"$ctrl.handleDenomination($ctrl.newCash.denominations[$ctrl.singleDenomIndex+1],'remainingDenominations')\" ng-disabled=\"!$ctrl.newCash.denominations[$ctrl.singleDenomIndex+1]\">\n<span class=\"glyphicon-plus\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section margin-top-05\" ng-if=\"!$ctrl.isValidBillCount && ($ctrl.isZeroInvalid || $ctrl.isMultipleInvalid)\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\n{{($ctrl.getSelectedFundingSourceData().allowAmount && $ctrl.isMultipleInvalid) ? ('addBagModal.divisibleByDenomError' | translate) : ('addBagModal.requiredAmountError' | translate)}}\n</span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"!$ctrl.isValidStrapBillCount\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\n{{'addBagModal.notDivisibleByStrapError' | translate}}\n</span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"$ctrl.newCash.multiDenominations.length == 0 && $ctrl.newCash.denominations.length==0 && !$ctrl.loadBfsDenomination\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\nNo BranchFundingSource Denominations Found\n</span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"$ctrl.invalidSingleDenomCoin\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\n{{$ctrl.getInvalidSingleDenomCoinMessage()}}\n</span>\n</div>\n<div class=\"_margin-top-10 col-sm-12 remove-pad-left remove-pad-right\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.closePanel()\" ng-disabled=\"$ctrl.newCash.isCreatingAtmOrders\">{{'common.close' | translate}}</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-if=\"!$ctrl.newCash.id\" ng-disabled=\"$ctrl.isCommitDisabled || cashForm.$invalid || $ctrl.loading || $ctrl.validateATMOrderCreateBtn() || $ctrl.newCash.isCreatingAtmOrders || !$ctrl.isValidBillCount || !$ctrl.checkForStrapCount() || !$ctrl.isValidStrapBillCount || $ctrl.invalidSingleDenomCoin\" ng-click=\"$ctrl.createPackableOrder()\">{{'common.Create' | translate}}\n<span ng-if=\"$ctrl.newCash.isCreatingAtmOrders\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n</div>\n</div></form>\n</div>\n\n\n\n</div>\n<div class=\"panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.shipmentsCreateStats.cashDeliveries.all && $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.cashDeliveries.recurring\">\n<div class=\"cash-schedule-form\">\n<div class=\"text-align-center col-sm-12\" ng-if=\"$ctrl.model.gettingOrderNo\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-30\"></span>\n</div>\n<form name=\"ATMOrdersCreateForm\" novalidate class=\"form-validate\" ng-if=\"!$ctrl.model.gettingOrderNo\">\n<div class=\"col-sm-12 remove-pad\"><hr class=\"master-cash-line-section\"></div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad remove-right-pad margin-bottom-10 btn-group _btn-group-justified\">\n<a class=\"btn btn-xs\" ng-repeat=\"pattern in $ctrl.recurringPatternList\" ng-click=\"$ctrl.selectedPattern(pattern); $ctrl.resetRecurringData();\" ng-class=\"{'btn-primary': $ctrl.newCash.selectedPattern === pattern.value,\n                                                                                           'btn-default': $ctrl.newCash.selectedPattern !== pattern.value}\">\n{{pattern.label}}\n</a>\n</div>\n<div class=\"col-sm-5 scheduled margin-top-03 pull-right schedule-weeks-input remove-right-pad\" ng-if=\"$ctrl.newCash.selectedPattern === 'weekly'\">\n{{'master_cash_schedule.recur_every' | translate}}\n<input type=\"number\" min=\"1\" max=\"4\" required class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.newCash.recurWeeks\"> {{'master_cash_schedule.weeks_on' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 daily-schedule-section-border scheduled _margin-top-03 daily-schedule-input\" ng-if=\"$ctrl.newCash.selectedPattern === 'daily'\">\n{{'master_cash_schedule.recur_every' | translate}}\n<input type=\"number\" min=\"1\" required class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.newCash.recurringDayInterval\"> {{'master_cash_schedule.days' | translate}}\n</div>\n<div class=\"scheduled-week-btn-section form-group remove-left-pad remove-right-pad col-sm-12 remove-bottom-margin\">\n<div id=\"service-schedule\" class=\"btn-group btn-group-justified\" ng-if=\"$ctrl.newCash.selectedPattern === 'weekly'\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.serviceSchedule\" ng-click=\"$ctrl.toggleDay(day)\" ng-class=\"{'btn-primary': $ctrl.isDaySelected(day),'btn-default': !$ctrl.isDaySelected(day)}\">\n{{day.label}}\n</a>\n</div>\n</div>\n<div class=\"col-sm-12 daily-schedule-section-border\" ng-if=\"$ctrl.newCash.selectedPattern === 'monthly'\">\n<div class=\"scheduled-week-btn-section _form-group remove-left-pad remove-right-pad col-sm-12\">\n<div id=\"service-schedule\" class=\"daily-schedule-input btn-group btn-group-justified\">\n<div class=\"col-sm-1 remove-pad\">\n<a class=\"btn btn-xs\" ng-click=\"$ctrl.getMonthlyPattern('day'); $ctrl.resetMothlyPattern();\" ng-class=\"{'btn-primary': $ctrl.selectedMonthlyPattern === 'day',\n                                                                   'btn-default': $ctrl.selectedMonthlyPattern !== 'day'}\">\n{{'master_cash_schedule.day' | translate}}\n</a>\n</div>\n<input type=\"number\" min=\"1\" max=\"31\" ng-required=\"$ctrl.selectedMonthlyPattern === 'day'\" class=\"form-control\" placeholder=\"Day\" ng-model=\"$ctrl.newCash.recurringMonthObj.day.dayInterval\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'the'\"> {{'master_cash_schedule.of_every' | translate}}\n<input type=\"number\" min=\"1\" max=\"12\" ng-required=\"$ctrl.selectedMonthlyPattern === 'day'\" class=\"form-control\" placeholder=\"Month\" ng-model=\"$ctrl.newCash.recurringMonthObj.day.monthInterval\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'the'\"> {{'master_cash_schedule.months' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<hr class=\"monthly-schedule-line-section\"/>\n</div>\n<div class=\"the-month-padding _form-group remove-left-pad remove-right-pad col-sm-12 _margin-bottom-07\">\n<div id=\"service-schedule\" class=\"_daily-schedule-input btn-group btn-group-justified\">\n<div class=\"col-sm-1 remove-pad\">\n<a class=\"the-month-btn-padding btn btn-xs\" ng-click=\"$ctrl.getMonthlyPattern('the'); $ctrl.resetMothlyPattern();\" ng-class=\"{'btn-primary': $ctrl.selectedMonthlyPattern === 'the', \n                                                                   'btn-default': $ctrl.selectedMonthlyPattern !== 'the'}\">\n{{'master_cash_schedule.the' | translate}}\n</a>\n</div>\n<div class=\"col-sm-3 remove-pad\">\n<select class=\"form-control\" ng-model=\"$ctrl.newCash.recurringMonthObj.month.weekInterval\" ng-required=\"$ctrl.selectedMonthlyPattern === 'the'\" ng-options=\"week_interval.value as week_interval.lable for week_interval in $ctrl.newCash.recurringMonthObj.month.weekIntervalList\" ng-change=\"$ctrl.validateBillCount();\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'day'\">\n<option value=\"\" disabled=\"disabled\">({{'master_cash_schedule.select_week' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-3 remove-right-pad\">\n<select class=\"form-control\" ng-model=\"$ctrl.newCash.recurringMonthObj.month.selectedWeekDay\" ng-required=\"$ctrl.selectedMonthlyPattern === 'the'\" ng-options=\"week_day.value as week_day.lable for week_day in $ctrl.newCash.recurringMonthObj.month.weekDayList\" ng-change=\"$ctrl.validateBillCount();\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'day'\">\n<option value=\"\" disabled=\"disabled\">({{'master_cash_schedule.select_weekDay' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-5 d-flex\">\n<span class=\"remove-white-space of-every-text-section\">{{'master_cash_schedule.of_every' | translate}}</span>\n<input type=\"number\" min=\"1\" max=\"12\" ng-required=\"$ctrl.selectedMonthlyPattern === 'the'\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.newCash.recurringMonthObj.month.monthInterval\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'day'\">\n<span class=\"months-text-section\">{{'master_cash_schedule.months' | translate}}</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10\">\n<div class=\"col-sm-3 remove-left-pad\">\n<label>{{'master_cash_schedule.start_at' | translate}}</label>\n<datetimepicker class=\"edit-order-view-date-picker-section datetimepicker-input\" ng-model=\"$ctrl.newCash.recurringStartDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.validateEndDate();\" date-options=\"$ctrl.minRecurrStartDate\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-3 remove-pad-right\">\n<label>{{'master_cash_schedule.end_by' | translate}}</label>\n<datetimepicker class=\"edit-order-view-date-picker-section datetimepicker-input\" ng-class=\"{'disabled': !$ctrl.newCash.recurringStartDate,\n                                                       'required-datetimepicker': !$ctrl.newCash.recurringEndDate && !$ctrl.newCash.endRecurringAfter}\" ng-model=\"$ctrl.newCash.recurringEndDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.minRecurrDate\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6 d-flex margin-top-25\">\n<span class=\"remove-white-space of-every-text-section\">{{'master_cash_schedule.end_after' | translate}}</span>\n<input type=\"number\" min=\"1\" max=\"12\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.newCash.endRecurringAfter\" ng-required=\"!$ctrl.newCash.recurringEndDate && !$ctrl.newCash.endRecurringAfter\">\n<span class=\"months-text-section\">{{'master_cash_schedule.occurrences' | translate}}</span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\"><hr class=\"master-cash-line-section\"></div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-left\">\n<label>{{'branch_mgmt.orders_selectATMs' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.fundingSource\" values=\"$ctrl.filterDataSet.branchFundingSource\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalBranchFundingSource\" on-click=\"$ctrl.getFundingSourceDenomination($ctrl.newCash.fundingSource.Value); $ctrl.onFundingSourceSelected();\" onscroll=\"$ctrl.getAllFundingSource(searchKey, offset)\" none-selected=\"'bulkCash.selectFundingSource'\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\">\n<label>{{'master_cash_schedule.orderNo' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"orderNo\" ng-model=\"$ctrl.newCash.orderNo\" required ng-pattern=\"/^[0-9]*$/\" placeholder=\"{{'master_cash_schedule.orderNo' | translate}}\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-left\">\n<label>{{'master_cash_schedule.location' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.toLocation\" values=\"$ctrl.filterDataSet.locationList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalLocation\" onscroll=\"$ctrl.loadLocation(searchKey, offset)\" none-selected=\"'common.select_location'\" on-click=\"$ctrl.getLocationNextRoute(); $ctrl.resetRouteId('toLocation');\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\" ng-class=\"{'hold-route-dropdown': $ctrl.isHoldRoute($ctrl.newCash.routeId)}\">\n<label>{{'master_cash_schedule.route' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.routeId\" values=\"$ctrl.filterDataSet.routeList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalRoutes\" common-search-flag=\"true\" ng-disabled=\"$ctrl.model.isGettingLocationRoutes || !$ctrl.newCash.toLocation\" none-selected=\"'master_cash_schedule.route'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 create-order-view-date-picker-section remove-pad-left\">\n<label>{{'master_cash_schedule.date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-if=\"$ctrl.shouldApplyCustomerFundingSourceLeadDate()\" ng-model=\"$ctrl.newCash.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.onVaultDateChange()\" date-options=\"$ctrl.maxDate\" date-disabled=\"$ctrl.isNonBusinessDay(date, mode)\">\n</datetimepicker>\n<datetimepicker class=\"datetimepicker-input\" ng-if=\"!$ctrl.shouldApplyCustomerFundingSourceLeadDate()\" ng-model=\"$ctrl.newCash.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.onVaultDateChange()\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\">\n<div>\n<label>{{'master_cash_schedule.shipType' | translate}}</label>\n</div>\n<select class=\"form-control\" ng-model=\"$ctrl.newCash.orderType\" required ng-options=\"shipType.value as shipType.key for shipType in $ctrl.filterDataSet.shipTypes\" ng-change=\"$ctrl.validateBillCount();\">\n<option value=\"\" disabled=\"disabled\">({{'common.select_shiptype' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"margin-bottom-10 col-sm-4 remove-pad-left\">\n<label>{{'master_cash_schedule.coin_amount' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.coinAmount\" placeholder=\"{{'master_cash_schedule.coin_amount' | translate}}\" disabled=\"disabled\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"2\" required>\n</div>\n<div class=\"margin-bottom-10 col-sm-4 remove-pad-left\">\n<label>{{'master_cash_schedule.cash_amount' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.cashAmount\" placeholder=\"{{'master_cash_schedule.cash_amount' | translate}}\" disabled=\"disabled\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"2\" required>\n</div>\n<div class=\"col-sm-4 remove-pad-right _margin-bottom-10\">\n<label>{{'bagout.totalAmount' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.totalAmount\" placeholder=\"{{'bagout.totalAmount' | translate}}\" disabled=\"disabled\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"0\" required>\n</div>\n</div>\n<div class=\"margin-bottom-10 margin-top-05 remove-pad-right z-index0\" ng-if=\"$ctrl.newCash.fundingSource && !$ctrl.loadBfsDenomination && $ctrl.newCash.multiDenominations.length >0\">\n<label>Multi-Denom Packed</label>\n<div class=\"multi-denomination-box-border\" style=\"display: flex;\">\n<div class=\"col-sm-12 form-denom-list remove-pad-left remove-pad-right\" style=\"display: flex; flex-wrap:wrap;\">\n<div class=\"col-sm-3 remove-pad-left remove-pad-right\" ng-repeat=\"multiDenomination in $ctrl.newCash.multiDenominations track by $index\" ng-if=\"multiDenomination.isEnabled\" ng-init=\"$ctrl.multiDenomIndex = $index\" style=\"flex: 0 0 23.5%;\">\n<div class=\"w-100 text-center\" ng-class=\"{\n                                                                                        'remove-pad-left_': $index < $ctrl.newCash.multiDenominations.length ,\n                                                                                        'remove-pad-right_': $ctrl.newCash.multiDenominations.length == $index+1\n                                                                                    }\">\n<div class=\"_form-group denom-controls\">\n<div class=\"btn-xs\" ng-class=\"{\n                                                            'btn': $index === 0, \n                                                            'btn-warning': multiDenomination.isEnabled , \n                                                            'btn-default': !multiDenomination.isEnabled\n                                                        }\" ng-if=\"multiDenomination.isEnabled\" style=\"display: flex; align-items: center; justify-content: space-between; padding: 0 5px;\">\n<span style=\"margin: 0 auto;\">{{$index + 1}}</span>\n<button class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.turnOffDenom(multiDenomination, $index, 'multiDenominations'); $event.stopPropagation();\" style=\"margin: 2px 0; font-size: 7px;\">\nX\n</button>\n</div>\n<span class=\"w-100 input-group-addon border-radius-05\" ng-show=\"multiDenomination.isEnabled\">\n<a role=\"button\" uib-popover-template=\"multiDenomination.template\" popover-is-open=\"multiDenomination.isOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\" popover-enable=\"$ctrl.newCash.multiDenominations.length > 0\">\n<denom-icon denom-id=\"multiDenomination.icon\" ng-if=\"multiDenomination.icon\" icon-size=\"35\"> </denom-icon>\n</a>\n</span>\n<input ng-if=\"multiDenomination.isEnabled && $ctrl.shouldUseAmountInput(multiDenomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.multiDenominations[$index].isValid, \n                                                                                        'ng-valid' : $ctrl.newCash.multiDenominations[$index].isValid || $ctrl.newCash.multiDenominations[$index].amount}\" ng-model=\"$ctrl.newCash.multiDenominations[$index].amount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'multiDenominations');\n                                                                                   $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('multiDenominations')\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-currency fraction=\"2\" min=\"0\" currency-symbol=\"$\" ng-required=\"multiDenomination.isEnabled\">\n<input ng-if=\"multiDenomination.isEnabled && !$ctrl.shouldUseAmountInput(multiDenomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.multiDenominations[$index].isValid, \n                                                                                        'ng-valid' : $ctrl.newCash.multiDenominations[$index].isValid || $ctrl.newCash.multiDenominations[$index].amount}\" ng-model=\"$ctrl.newCash.multiDenominations[$index].billCount\" placeholder=\"{{ multiDenomination.coinFlag ? 'atm_residual.qty' : 'atm_residual.bills' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'multiDenominations');\n                                                                                                   $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('multiDenominations')\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"0\" min=\"0\" currency-symbol=\"\" ng-required=\"multiDenomination.isEnabled\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-1 remove-pad-left remove-pad-right\" style=\"display: flex; justify-content: center; align-items: center; flex: 0 0 6%; padding: 5px;\">\n<button class=\"btn btn-xs btn-success\" type=\"button\" ng-click=\"$ctrl.handleDenomination($ctrl.newCash.multiDenominations[$ctrl.multiDenomIndex+1], 'remainingMultiDenominations')\" ng-disabled=\"!$ctrl.newCash.multiDenominations[$ctrl.multiDenomIndex+1]\">\n<span class=\"glyphicon-plus\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"remove-pad-right col-sm-12 remove-left-pad z-index0 margin-top-05\" ng-if=\"$ctrl.newCash.fundingSource && !$ctrl.loadBfsDenomination && $ctrl.newCash.denominations.length > 0 \">\n<label>Single-Denom Packed</label>\n<div style=\"display: flex;\">\n<div class=\"col-sm-12 remove-pad-left remove-pad-right form-denom-list\" style=\"display: flex; flex-wrap:wrap;\">\n<div class=\"col-sm-3 single-denomination-box-border\" ng-repeat=\"denomination in $ctrl.newCash.denominations track by $index\" ng-if=\"denomination.isEnabled\" ng-init=\"$ctrl.singleDenomIndex = $index\" style=\"flex: 0 0 23.5%;\">\n<div class=\"w-100 text-center\" ng-class=\"{\n                                                                                                                        'remove-pad-left_': $index < $ctrl.newCash.denominations.length ,\n                                                                                                                        'remove-pad-right_': $ctrl.newCash.denominations.length == $index+1\n                                                                                                                    }\">\n<div class=\"_form-group denom-controls\">\n<div class=\"btn-xs\" ng-class=\"{\n                                                            'btn': $index === 0, \n                                                            'btn-warning': denomination.isEnabled , \n                                                            'btn-default': !denomination.isEnabled\n                                                        }\" ng-if=\"denomination.isEnabled\" style=\"display: flex; align-items: center; justify-content: space-between; padding: 0 5px;\">\n<span style=\"margin: 0 auto;\">{{$index + 1}}</span>\n<button class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.turnOffDenom(denomination, $index, 'denominations'); $event.stopPropagation();\" style=\"margin: 2px 0; font-size: 7px;\">\nX\n</button>\n</div>\n<span class=\"w-100 input-group-addon border-radius-05\" ng-show=\"denomination.isEnabled\">\n<a role=\"button\" uib-popover-template=\"denomination.template\" popover-is-open=\"denomination.isOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\" popover-enable=\"$ctrl.newCash.denominations.length > 0\">\n<denom-icon denom-id=\"denomination.icon\" ng-if=\"denomination.icon\" icon-size=\"35\"> </denom-icon>\n</a>\n</span>\n<input ng-if=\"denomination.isEnabled && $ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.denominations[$index].isValid, \n                                                                                                                        'ng-valid' : $ctrl.newCash.denominations[$index].isValid || $ctrl.newCash.denominations[$index].amount}\" ng-model=\"$ctrl.newCash.denominations[$index].amount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'denominations');\n                                                                                                                                  $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('denominations')\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-currency fraction=\"2\" min=\"0\" currency-symbol=\"$\" ng-required=\"denomination.isEnabled\">\n<input ng-if=\"denomination.isEnabled && !$ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.denominations[$index].isValid, \n                                                                                                                        'ng-valid' : $ctrl.newCash.denominations[$index].isValid || $ctrl.newCash.denominations[$index].amount}\" ng-model=\"$ctrl.newCash.denominations[$index].billCount\" placeholder=\"{{ denomination.coinFlag ? 'atm_residual.qty' : 'atm_residual.bills' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'denominations');\n                                                                                                                                  $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('denominations')\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"0\" min=\"0\" currency-symbol=\"\" ng-required=\"denomination.isEnabled\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-1 remove-pad-left remove-pad-right\" style=\"display: flex; justify-content: center; align-items: center; flex: 0 0 6%; padding: 5px;\">\n<button class=\"btn btn-xs btn-success\" type=\"button\" ng-click=\"$ctrl.handleDenomination($ctrl.newCash.denominations[$ctrl.singleDenomIndex+1],'remainingDenominations')\" ng-disabled=\"!$ctrl.newCash.denominations[$ctrl.singleDenomIndex+1]\">\n<span class=\"glyphicon-plus\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"!$ctrl.isValidBillCount && ($ctrl.isZeroInvalid || $ctrl.isMultipleInvalid)\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\n{{($ctrl.getSelectedFundingSourceData().allowAmount && $ctrl.isMultipleInvalid) ? ('addBagModal.divisibleByDenomError' | translate) : ('addBagModal.requiredAmountError' | translate)}}\n</span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"!$ctrl.isValidStrapBillCount\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\n{{'addBagModal.notDivisibleByStrapError' | translate}}\n</span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"$ctrl.newCash.multiDenominations.length == 0 || $ctrl.newCash.denominations.length==0 && !$ctrl.loadBfsDenomination\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\nNo BranchFundingSource Denominations Found\n</span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"$ctrl.invalidSingleDenomCoin\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\n{{$ctrl.getInvalidSingleDenomCoinMessage()}}\n</span>\n</div>\n<div class=\"margin-top-10 col-sm-12 remove-pad-left remove-pad-right\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.closePanel()\">\n{{'common.close' | translate}}\n</button>\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.confirmRecurring($ctrl.model.currentStats);\" ng-disabled=\"cashForm.$invalid || ATMOrdersCreateForm.$invalid || $ctrl.loading ||\n                                        $ctrl.validateATMOrderCreateBtn() || $ctrl.newCash.isCreateRecurring || !$ctrl.isValidBillCount || !$ctrl.checkForStrapCount() ||!$ctrl.isValidStrapBillCount || $ctrl.invalidSingleDenomCoin\">\n{{'master_cash_schedule.make_recurring' | translate}}\n</button>\n</div>\n</form>\n</div>\n\n\n\n</div>\n<div class=\"w-100 align-center margin-10\" ng-if=\"$ctrl.model.currentStats === $ctrl.shipmentsCreateStats.ATMOrders.all\">\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentChildStat\" uib-btn-radio=\"$ctrl.shipmentsCreateStats.ATMOrders.single\" ng-click=\"$ctrl.tabSelection('ATMOrders', 'all'); $ctrl.childTabSelection('ATMOrders', 'single'); $ctrl.generateOrderNumber();\" ng-class=\"{'btn-success': $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.ATMOrders.single, \n                                               'remove-group-btn-color': $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.ATMOrders.recurring}\">\nSingle\n</label>\n</div>\n<div class=\"btn-group\" ng-if=\"!$ctrl.customerUser\" ng-class=\"{'disabled-state-cursor' : !$ctrl.allowRecurring()}\" uib-tooltip=\"Past Date\" tooltip-placement=\"top-left\" tooltip-enable=\"!$ctrl.allowRecurring()\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.currentChildStat\" uib-btn-radio=\"$ctrl.shipmentsCreateStats.ATMOrders.recurring\" ng-click=\"$ctrl.tabSelection('ATMOrders', 'all'); $ctrl.childTabSelection('ATMOrders', 'recurring'); $ctrl.generateOrderNumber();\" ng-class=\"{'btn-success': $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.ATMOrders.recurring, \n                                              'remove-group-btn-color': $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.ATMOrders.single,\n                                              'disabled disabled-state': !$ctrl.allowRecurring()}\">\nRecurring\n</label>\n</div>\n</div>\n</div>\n<div class=\"panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.shipmentsCreateStats.ATMOrders.all && $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.ATMOrders.single\">\n<div class=\"cash-schedule-form\">\n<div class=\"text-align-center col-sm-12\" ng-if=\"$ctrl.model.gettingOrderNo\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-30\"></span>\n</div>\n<form name=\"ATMOrdersCreateForm\" novalidate class=\"form-validate\" ng-if=\"!$ctrl.model.gettingOrderNo\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-left\">\n<label>{{'branch_mgmt.orders_selectATMs' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.fundingSource\" values=\"$ctrl.filterDataSet.branchFundingSource\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalBranchFundingSource\" on-click=\"$ctrl.getFundingSourceDenomination($ctrl.newCash.fundingSource.Value); $ctrl.onFundingSourceSelected()\" onscroll=\"$ctrl.getAllFundingSource(searchKey, offset)\" none-selected=\"'bulkCash.selectFundingSource'\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\">\n<label>{{'master_cash_schedule.orderNo' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"orderNo\" ng-model=\"$ctrl.newCash.orderNo\" required ng-pattern=\"/^[0-9]*$/\" placeholder=\"{{'master_cash_schedule.orderNo' | translate}}\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-left\">\n<label>{{'master_cash_schedule.location' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.toLocation\" values=\"$ctrl.filterDataSet.locationList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalLocation\" onscroll=\"$ctrl.loadLocation(searchKey, offset)\" none-selected=\"'common.select_location'\" on-click=\"$ctrl.getLocationNextRoute(); $ctrl.resetRouteId('toLocation');\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\" ng-class=\"{'hold-route-dropdown': $ctrl.isHoldRoute($ctrl.newCash.routeId)}\">\n<label>{{'master_cash_schedule.route' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.routeId\" values=\"$ctrl.filterDataSet.routeList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalRoutes\" common-search-flag=\"true\" ng-disabled=\"$ctrl.model.isGettingLocationRoutes || !$ctrl.newCash.toLocation || $ctrl.userDetails.customerUser\" none-selected=\"'master_cash_schedule.route'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3 margin-bottom-10 create-order-view-date-picker-section remove-pad-left remove-pad-right\">\n<label>{{'master_cash_schedule.date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-if=\"$ctrl.shouldApplyCustomerFundingSourceLeadDate()\" ng-model=\"$ctrl.newCash.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.onVaultDateChange()\" date-options=\"$ctrl.maxDate\" date-disabled=\"$ctrl.isNonBusinessDay(date, mode)\">\n</datetimepicker>\n<datetimepicker class=\"datetimepicker-input\" ng-if=\"!$ctrl.shouldApplyCustomerFundingSourceLeadDate()\" ng-model=\"$ctrl.newCash.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.onVaultDateChange()\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-5 margin-bottom-10 remove-pad-right\">\n<div>\n<label>{{'master_cash_schedule.orderType' | translate}}</label>\n</div>\n<select class=\"form-control\" ng-model=\"$ctrl.newCash.orderType\" required ng-options=\"orderType.value as orderType.key for orderType in $ctrl.filterDataSet.orderTypes\" ng-change=\"$ctrl.validateBillCount();\">\n<option value=\"\" disabled=\"disabled\">({{'common.select_OrderType' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-4 margin-bottom-10 remove-pad-right z-index0\">\n<label>{{'transaction_log.account' | translate}}</label>\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.newCash.account\" uib-btn-radio=\"$ctrl.model.ATMLoadAccountStats.regular\" ng-class=\"{'btn-success': $ctrl.newCash.account === $ctrl.model.ATMLoadAccountStats.regular,\n                                                               'remove-btn-grp-color': $ctrl.newCash.account === $ctrl.model.ATMLoadAccountStats.emergency}\">\n{{ 'common.regular' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.newCash.account\" uib-btn-radio=\"$ctrl.model.ATMLoadAccountStats.emergency\" ng-class=\"{'btn-success': $ctrl.newCash.account === $ctrl.model.ATMLoadAccountStats.emergency,\n                                                               'remove-btn-grp-color': $ctrl.newCash.account === $ctrl.model.ATMLoadAccountStats.regular}\">\n{{ 'common.emergency' | translate }}\n</label>\n</div>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12\" ng-if=\"$ctrl.newCash.fundingSource && $ctrl.loadBfsDenomination\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-30\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.newCash.fundingSource && !$ctrl.loadBfsDenomination\">\n<div class=\"margin-bottom-10 col-sm-4 remove-pad-left\">\n<label>{{'master_cash_schedule.coin_amount' | translate}}</label>\n<input id=\"shipment-coin-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.coinAmount\" placeholder=\"{{'master_cash_schedule.coin_amount' | translate}}\" disabled=\"disabled\" ng-currency fraction=\"2\" required>\n</div>\n<div class=\"margin-bottom-10 col-sm-4 remove-pad-left\">\n<label>{{'master_cash_schedule.cash_amount' | translate}}</label>\n<input id=\"shipment-cash-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.cashAmount\" placeholder=\"{{'master_cash_schedule.cash_amount' | translate}}\" disabled=\"disabled\" ng-currency fraction=\"2\" required>\n</div>\n<div class=\"col-sm-4 remove-pad-right _margin-bottom-10\">\n<label>{{'bagout.totalAmount' | translate}}</label>\n<input id=\"shipment-total-amount\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.totalAmount\" placeholder=\"{{'bagout.totalAmount' | translate}}\" disabled=\"disabled\" ng-currency fraction=\"2\" required>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad-left remove-pad-right\" ng-if=\"$ctrl.newCash.fundingSource && !$ctrl.loadBfsDenomination\">\n<div class=\"multi-denomination-box-border\" style=\"display: flex;\">\n<div class=\"col-sm-12 form-denom-list remove-pad-left remove-pad-right\" style=\"display: flex; flex-wrap:wrap;\">\n<div class=\"col-sm-3 remove-pad-left remove-pad-right\" ng-repeat=\"denomination in $ctrl.newCash.atmDenominations track by $index\" ng-if=\"denomination.isEnabled\" ng-init=\"$ctrl.atmDenomIndex = $index\" style=\"flex: 0 0 23.5%;\">\n<div class=\"w-100 text-center\" ng-class=\"{\n                                                            'remove-pad-left_': $index < $ctrl.newCash.atmDenominations.length ,\n                                                            'remove-pad-right_': $ctrl.newCash.atmDenominations.length == $index+1\n                                                        }\">\n<div class=\"_form-group denom-controls\">\n<div class=\"btn-xs\" ng-class=\"{\n                                                            'btn': $index === 0, \n                                                            'btn-warning': denomination.isEnabled , \n                                                            'btn-default': !denomination.isEnabled\n                                                        }\" ng-if=\"denomination.isEnabled\" style=\"display: flex; align-items: center; justify-content: space-between; padding: 0 5px;\">\n<span style=\"margin: 0 auto;\">{{$index + 1}}</span>\n<button class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.turnOffDenom(denomination, $index, 'atmDenominations'); $event.stopPropagation();\" style=\"margin: 2px 0; font-size: 7px;\">\nX\n</button>\n</div>\n<span class=\"w-100 input-group-addon border-radius-05\" ng-show=\"denomination.isEnabled\">\n<a role=\"button\" uib-popover-template=\"denomination.template\" popover-is-open=\"denomination.isOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\" popover-enable=\"$ctrl.newCash.atmDenominations.length > 0\">\n<denom-icon denom-id=\"denomination.icon\" ng-if=\"denomination.icon\" icon-size=\"35\"> </denom-icon>\n</a>\n</span>\n<input ng-if=\"denomination.isEnabled && $ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.atmDenominations[$index].isValid, \n                                                            'ng-valid' : $ctrl.newCash.atmDenominations[$index].isValid || $ctrl.newCash.atmDenominations[$index].amount}\" ng-model=\"$ctrl.newCash.atmDenominations[$index].amount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'atmDenominations');\n                                                                       $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('atmDenominations')\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-currency fraction=\"2\" min=\"0\" currency-symbol=\"$\" ng-required=\"denomination.isEnabled\" ng-disabled=\"$ctrl.newCash.orderType === 'P' || $ctrl.newCash.orderType === 'T'\">\n<input ng-if=\"denomination.isEnabled && !$ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.atmDenominations[$index].isValid, \n                                                            'ng-valid' : $ctrl.newCash.atmDenominations[$index].isValid || $ctrl.newCash.atmDenominations[$index].amount}\" ng-model=\"$ctrl.newCash.atmDenominations[$index].billCount\" placeholder=\"{{ denomination.coinFlag ? 'atm_residual.qty' : 'atm_residual.bills' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'atmDenominations');\n                                                                       $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('atmDenominations')\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"0\" min=\"0\" currency-symbol=\"\" ng-required=\"denomination.isEnabled\" ng-disabled=\"$ctrl.newCash.orderType === 'P' || $ctrl.newCash.orderType === 'T'\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-1 remove-pad-left remove-pad-right\" style=\"display: flex; justify-content: center; align-items: center; flex: 0 0 6%; padding: 5px;\">\n<button class=\"btn btn-xs btn-success\" type=\"button\" ng-click=\"$ctrl.handleDenomination($ctrl.newCash.atmDenominations[$ctrl.atmDenomIndex+1], 'remainingAtmDenominations')\" ng-disabled=\"!$ctrl.newCash.atmDenominations[$ctrl.atmDenomIndex+1]\">\n<span class=\"glyphicon-plus\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-10 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.newCash.atmDenominations.length==0 && !$ctrl.loadBfsDenomination\">\n<span class=\"col-sm-12 alert alert-danger text-align-center remove-bottom-margin\">\nNo branch funding source denomination found\n</span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"!$ctrl.isValidBillCount && ($ctrl.isZeroInvalid || $ctrl.isMultipleInvalid)\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\n{{($ctrl.getSelectedFundingSourceData().allowAmount && $ctrl.isMultipleInvalid) ? ('addBagModal.divisibleByDenomError' | translate) : ('addBagModal.requiredAmountError' | translate)}}\n</span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"!$ctrl.isValidStrapBillCount\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\n{{'addBagModal.notDivisibleByStrapError' | translate}}\n</span>\n</div>\n<div class=\"margin-top-10 col-sm-12 remove-pad-left remove-pad-right\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.closePanel()\" ng-disabled=\"$ctrl.newCash.isCreatingAtmOrders\">\n{{'common.close' | translate}}\n</button>\n<button class=\"btn btn-success\" type=\"submit\" ng-if=\"!$ctrl.newCash.id\" ng-disabled=\"ATMOrdersCreateForm.$invalid || $ctrl.loading || $ctrl.validateATMOrderCreateBtn() || $ctrl.newCash.isCreatingAtmOrders || !$ctrl.isValidBillCount || !$ctrl.isValidStrapBillCount\" ng-click=\"$ctrl.createAtmOrders($event)\">\n{{'common.Create' | translate}}\n<span ng-if=\"$ctrl.newCash.isCreatingAtmOrders\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n</div>\n</form>\n\n</div>\n</div>\n<div class=\"panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.shipmentsCreateStats.ATMOrders.all && $ctrl.model.currentChildStat === $ctrl.shipmentsCreateStats.ATMOrders.recurring\">\n<div class=\"cash-schedule-form\">\n<div class=\"text-align-center col-sm-12\" ng-if=\"$ctrl.model.gettingOrderNo\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-30\"></span>\n</div>\n<form name=\"ATMOrdersCreateForm\" novalidate class=\"form-validate\" ng-if=\"!$ctrl.model.gettingOrderNo\">\n<div class=\"col-sm-12 remove-pad\"><hr class=\"master-cash-line-section\"></div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad remove-right-pad margin-bottom-10 btn-group _btn-group-justified\">\n<a class=\"btn btn-xs\" ng-repeat=\"pattern in $ctrl.recurringPatternList\" ng-click=\"$ctrl.selectedPattern(pattern); $ctrl.resetRecurringData();\" ng-class=\"{'btn-primary': $ctrl.newCash.selectedPattern === pattern.value,\n                                                                                           'btn-default': $ctrl.newCash.selectedPattern !== pattern.value}\">\n{{pattern.label}}\n</a>\n</div>\n<div class=\"col-sm-5 scheduled margin-top-03 pull-right schedule-weeks-input remove-right-pad\" ng-if=\"$ctrl.newCash.selectedPattern === 'weekly'\">\n{{'master_cash_schedule.recur_every' | translate}}\n<input type=\"number\" min=\"1\" max=\"4\" required class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.newCash.recurWeeks\"> {{'master_cash_schedule.weeks_on' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 daily-schedule-section-border scheduled _margin-top-03 daily-schedule-input\" ng-if=\"$ctrl.newCash.selectedPattern === 'daily'\">\n{{'master_cash_schedule.recur_every' | translate}}\n<input type=\"number\" min=\"1\" required class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.newCash.recurringDayInterval\"> {{'master_cash_schedule.days' | translate}}\n</div>\n<div class=\"scheduled-week-btn-section form-group remove-left-pad remove-right-pad col-sm-12 remove-bottom-margin\">\n<div id=\"service-schedule\" class=\"btn-group btn-group-justified\" ng-if=\"$ctrl.newCash.selectedPattern === 'weekly'\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.serviceSchedule\" ng-click=\"$ctrl.toggleDay(day)\" ng-class=\"{'btn-primary': $ctrl.isDaySelected(day),'btn-default': !$ctrl.isDaySelected(day)}\">\n{{day.label}}\n</a>\n</div>\n</div>\n<div class=\"col-sm-12 daily-schedule-section-border\" ng-if=\"$ctrl.newCash.selectedPattern === 'monthly'\">\n<div class=\"scheduled-week-btn-section _form-group remove-left-pad remove-right-pad col-sm-12\">\n<div id=\"service-schedule\" class=\"daily-schedule-input btn-group btn-group-justified\">\n<div class=\"col-sm-1 remove-pad\">\n<a class=\"btn btn-xs\" ng-click=\"$ctrl.getMonthlyPattern('day'); $ctrl.resetMothlyPattern();\" ng-class=\"{'btn-primary': $ctrl.selectedMonthlyPattern === 'day',\n                                                                   'btn-default': $ctrl.selectedMonthlyPattern !== 'day'}\">\n{{'master_cash_schedule.day' | translate}}\n</a>\n</div>\n<input type=\"number\" min=\"1\" max=\"31\" ng-required=\"$ctrl.selectedMonthlyPattern === 'day'\" class=\"form-control\" placeholder=\"Day\" ng-model=\"$ctrl.newCash.recurringMonthObj.day.dayInterval\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'the'\"> {{'master_cash_schedule.of_every' | translate}}\n<input type=\"number\" min=\"1\" max=\"12\" ng-required=\"$ctrl.selectedMonthlyPattern === 'day'\" class=\"form-control\" placeholder=\"Month\" ng-model=\"$ctrl.newCash.recurringMonthObj.day.monthInterval\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'the'\"> {{'master_cash_schedule.months' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<hr class=\"monthly-schedule-line-section\"/>\n</div>\n<div class=\"the-month-padding _form-group remove-left-pad remove-right-pad col-sm-12 _margin-bottom-07\">\n<div id=\"service-schedule\" class=\"_daily-schedule-input btn-group btn-group-justified\">\n<div class=\"col-sm-1 remove-pad\">\n<a class=\"the-month-btn-padding btn btn-xs\" ng-click=\"$ctrl.getMonthlyPattern('the'); $ctrl.resetMothlyPattern();\" ng-class=\"{'btn-primary': $ctrl.selectedMonthlyPattern === 'the', \n                                                                   'btn-default': $ctrl.selectedMonthlyPattern !== 'the'}\">\n{{'master_cash_schedule.the' | translate}}\n</a>\n</div>\n<div class=\"col-sm-3 remove-pad\">\n<select class=\"form-control\" ng-model=\"$ctrl.newCash.recurringMonthObj.month.weekInterval\" ng-required=\"$ctrl.selectedMonthlyPattern === 'the'\" ng-options=\"week_interval.value as week_interval.lable for week_interval in $ctrl.newCash.recurringMonthObj.month.weekIntervalList\" ng-change=\"$ctrl.validateBillCount();\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'day'\">\n<option value=\"\" disabled=\"disabled\">({{'master_cash_schedule.select_week' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-3 remove-right-pad\">\n<select class=\"form-control\" ng-model=\"$ctrl.newCash.recurringMonthObj.month.selectedWeekDay\" ng-required=\"$ctrl.selectedMonthlyPattern === 'the'\" ng-options=\"week_day.value as week_day.lable for week_day in $ctrl.newCash.recurringMonthObj.month.weekDayList\" ng-change=\"$ctrl.validateBillCount();\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'day'\">\n<option value=\"\" disabled=\"disabled\">({{'master_cash_schedule.select_weekDay' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-5 d-flex\">\n<span class=\"remove-white-space of-every-text-section\">{{'master_cash_schedule.of_every' | translate}}</span>\n<input type=\"number\" min=\"1\" max=\"12\" ng-required=\"$ctrl.selectedMonthlyPattern === 'the'\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.newCash.recurringMonthObj.month.monthInterval\" ng-disabled=\"$ctrl.selectedMonthlyPattern === 'day'\">\n<span class=\"months-text-section\">{{'master_cash_schedule.months' | translate}}</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10\">\n<div class=\"col-sm-3 remove-left-pad\">\n<label>{{'master_cash_schedule.start_at' | translate}}</label>\n<datetimepicker class=\"edit-order-view-date-picker-section datetimepicker-input\" ng-model=\"$ctrl.newCash.recurringStartDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.validateEndDate();\" date-options=\"$ctrl.minRecurrStartDate\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-3 remove-pad-right\">\n<label>{{'master_cash_schedule.end_by' | translate}}</label>\n<datetimepicker class=\"edit-order-view-date-picker-section datetimepicker-input\" ng-class=\"{'disabled': !$ctrl.newCash.recurringStartDate,\n                                                       'required-datetimepicker': !$ctrl.newCash.recurringEndDate && !$ctrl.newCash.endRecurringAfter}\" ng-model=\"$ctrl.newCash.recurringEndDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" date-options=\"$ctrl.minRecurrDate\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6 d-flex margin-top-25\">\n<span class=\"remove-white-space of-every-text-section\">{{'master_cash_schedule.end_after' | translate}}</span>\n<input type=\"number\" min=\"1\" max=\"12\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.newCash.endRecurringAfter\" ng-required=\"!$ctrl.newCash.recurringEndDate && !$ctrl.newCash.endRecurringAfter\">\n<span class=\"months-text-section\">{{'master_cash_schedule.occurrences' | translate}}</span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\"><hr class=\"master-cash-line-section\"></div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-left\">\n<label>{{'branch_mgmt.orders_selectATMs' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.fundingSource\" values=\"$ctrl.filterDataSet.branchFundingSource\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalBranchFundingSource\" on-click=\"$ctrl.getFundingSourceDenomination($ctrl.newCash.fundingSource.Value); $ctrl.onFundingSourceSelected();\" onscroll=\"$ctrl.getAllFundingSource(searchKey, offset)\" none-selected=\"'bulkCash.selectFundingSource'\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\">\n<label>{{'master_cash_schedule.orderNo' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"orderNo\" ng-model=\"$ctrl.newCash.orderNo\" required ng-pattern=\"/^[0-9]*$/\" placeholder=\"{{'master_cash_schedule.orderNo' | translate}}\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-left\">\n<label>{{'master_cash_schedule.location' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.toLocation\" values=\"$ctrl.filterDataSet.locationList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalLocation\" onscroll=\"$ctrl.loadLocation(searchKey, offset)\" none-selected=\"'common.select_location'\" on-click=\"$ctrl.getLocationNextRoute(); $ctrl.getLocationOrdersSinceSwap(); $ctrl.resetRouteId('toLocation');\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\" ng-class=\"{'hold-route-dropdown': $ctrl.isHoldRoute($ctrl.newCash.routeId)}\">\n<label>{{'master_cash_schedule.route' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.routeId\" values=\"$ctrl.filterDataSet.routeList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalRoutes\" common-search-flag=\"true\" ng-disabled=\"$ctrl.model.isGettingLocationRoutes || !$ctrl.newCash.toLocation\" none-selected=\"'master_cash_schedule.route'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 create-order-view-date-picker-section remove-pad-left\">\n<label>{{'master_cash_schedule.date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-if=\"$ctrl.shouldApplyCustomerFundingSourceLeadDate()\" ng-model=\"$ctrl.newCash.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.onVaultDateChange()\" date-options=\"$ctrl.maxDate\" date-disabled=\"$ctrl.isNonBusinessDay(date, mode)\">\n</datetimepicker>\n<datetimepicker class=\"datetimepicker-input\" ng-if=\"!$ctrl.shouldApplyCustomerFundingSourceLeadDate()\" ng-model=\"$ctrl.newCash.vaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.onVaultDateChange()\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\">\n<div>\n<label>{{'master_cash_schedule.orderType' | translate}}</label>\n</div>\n<select class=\"form-control\" ng-model=\"$ctrl.newCash.orderType\" required ng-options=\"orderType.value as orderType.key for orderType in $ctrl.filterDataSet.orderTypes\" ng-change=\"$ctrl.validateBillCount();\" ng-disabled=\"$ctrl.nextOrderType\">\n<option value=\"\" disabled=\"disabled\">({{'common.select_OrderType' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12\" ng-if=\"$ctrl.newCash.fundingSource && $ctrl.loadBfsDenomination\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-30\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.newCash.fundingSource && !$ctrl.loadBfsDenomination && $ctrl.newCash.atmDenominations.length > 0\">\n<div class=\"margin-bottom-10 col-sm-4 remove-pad-left\">\n<label>{{'master_cash_schedule.coin_amount' | translate}}</label>\n<input id=\"shipment-coin-amount-recurring\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.coinAmount\" placeholder=\"{{'master_cash_schedule.coin_amount' | translate}}\" disabled=\"disabled\" ng-currency fraction=\"2\" required>\n</div>\n<div class=\"margin-bottom-10 col-sm-4 remove-pad-left\">\n<label>{{'master_cash_schedule.cash_amount' | translate}}</label>\n<input id=\"shipment-cash-amount-recurring\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.cashAmount\" placeholder=\"{{'master_cash_schedule.cash_amount' | translate}}\" disabled=\"disabled\" ng-currency fraction=\"2\" required>\n</div>\n<div class=\"col-sm-4 remove-pad-right _margin-bottom-10\">\n<label>{{'bagout.totalAmount' | translate}}</label>\n<input id=\"shipment-total-amount-recurring\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.newCash.totalAmount\" placeholder=\"{{'bagout.totalAmount' | translate}}\" disabled=\"disabled\" ng-currency fraction=\"2\" required>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad-left remove-pad-right\" ng-if=\"$ctrl.newCash.fundingSource && !$ctrl.loadBfsDenomination && $ctrl.newCash.atmDenominations.length > 0\">\n<div class=\"multi-denomination-box-border\" style=\"display: flex;\">\n<div class=\"col-sm-12 form-denom-list remove-pad-left remove-pad-right\" style=\"display: flex; flex-wrap:wrap;\">\n<div class=\"col-sm-3 remove-pad-left remove-pad-right\" ng-repeat=\"denomination in $ctrl.newCash.atmDenominations track by $index\" ng-if=\"denomination.isEnabled\" ng-init=\"$ctrl.recAtmDenomIndex = $index\" style=\"flex: 0 0 23.5%;\">\n<div class=\"w-100 text-center\" ng-class=\"{\n                                                            'remove-pad-left_': $index < $ctrl.newCash.atmDenominations.length ,\n                                                            'remove-pad-right_': $ctrl.newCash.atmDenominations.length == $index+1\n                                                        }\">\n<div class=\"_form-group denom-controls\">\n<div class=\"btn-xs\" ng-class=\"{\n                                                            'btn': $index === 0, \n                                                            'btn-warning': denomination.isEnabled , \n                                                            'btn-default': !denomination.isEnabled\n                                                        }\" ng-if=\"denomination.isEnabled\" style=\"display: flex; align-items: center; justify-content: space-between; padding: 0 5px;\">\n<span style=\"margin: 0 auto;\">{{$index + 1}}</span>\n<button class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.turnOffDenom(denomination, $index,'atmDenominations'); $event.stopPropagation();\" style=\"margin: 2px 0; font-size: 7px;\">\nX\n</button>\n</div>\n<span class=\"w-100 input-group-addon border-radius-05\" ng-show=\"denomination.isEnabled\">\n<a role=\"button\" uib-popover-template=\"denomination.template\" popover-is-open=\"denomination.isOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\" popover-enable=\"$ctrl.newCash.atmDenominations.length > 0\">\n<denom-icon denom-id=\"denomination.icon\" ng-if=\"denomination.icon\" icon-size=\"35\"> </denom-icon>\n</a>\n</span>\n<input ng-if=\"denomination.isEnabled && $ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.atmDenominations[$index].isValid, \n                                                            'ng-valid' : $ctrl.newCash.atmDenominations[$index].isValid || $ctrl.newCash.atmDenominations[$index].amount}\" ng-model=\"$ctrl.newCash.atmDenominations[$index].amount\" placeholder=\"{{ 'bulkCash.amount' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'atmDenominations');\n                                                                       $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('atmDenominations')\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-currency fraction=\"2\" min=\"0\" currency-symbol=\"$\" ng-required=\"denomination.isEnabled\" ng-disabled=\"$ctrl.newCash.orderType === 'P' || $ctrl.newCash.orderType === 'T'\">\n<input ng-if=\"denomination.isEnabled && !$ctrl.shouldUseAmountInput(denomination)\" id=\"denomAmount-{{$parent.$index+1}}-{{$index+1}}\" name=\"denomAmount-{{$index+1}}\" type=\"text\" class=\"form-control text-center\" ng-class=\"{'invalid-amount' : !$ctrl.newCash.atmDenominations[$index].isValid, \n                                                            'ng-valid' : $ctrl.newCash.atmDenominations[$index].isValid || $ctrl.newCash.atmDenominations[$index].amount}\" ng-model=\"$ctrl.newCash.atmDenominations[$index].billCount\" placeholder=\"{{ denomination.coinFlag ? 'atm_residual.qty' : 'atm_residual.bills' | translate }}\" ng-change=\"$ctrl.handleDenominationInputChange($index, 'atmDenominations');\n                                                                       $ctrl.calculateDenominationAmount(); $ctrl.validateATMOrderCreateBtn(); $ctrl.checkForStrapCount('atmDenominations')\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-currency fraction=\"0\" min=\"0\" currency-symbol=\"\" ng-required=\"denomination.isEnabled\" ng-disabled=\"$ctrl.newCash.orderType === 'P' || $ctrl.newCash.orderType === 'T'\">\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-1 remove-pad-left remove-pad-right\" style=\"display: flex; justify-content: center; align-items: center; flex: 0 0 6%; padding: 5px;\">\n<button class=\"btn btn-xs btn-success\" type=\"button\" ng-click=\"$ctrl.handleDenomination($ctrl.newCash.atmDenominations[$ctrl.recAtmDenomIndex+1],'remainingAtmDenominations')\" ng-disabled=\"!$ctrl.newCash.atmDenominations[$ctrl.recAtmDenomIndex+1]\">\n<span class=\"glyphicon-plus\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-10 remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.newCash.atmDenominations.length && !$ctrl.loadBfsDenomination\">\n<span class=\"col-sm-12 alert alert-danger text-align-center remove-bottom-margin\">\nNo branch funding source denomination found\n</span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"!$ctrl.isValidBillCount && ($ctrl.isZeroInvalid || $ctrl.isMultipleInvalid)\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\n{{($ctrl.getSelectedFundingSourceData().allowAmount && $ctrl.isMultipleInvalid) ? ('addBagModal.divisibleByDenomError' | translate) : ('addBagModal.requiredAmountError' | translate)}}\n</span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad master-cash-denom-alert-section\" ng-if=\"!$ctrl.isValidStrapBillCount\">\n<span class=\"margin-top-05 col-sm-12 alert alert-danger text-align-center\">\n{{'addBagModal.notDivisibleByStrapError' | translate}}\n</span>\n</div>\n<div class=\"margin-top-10 col-sm-12 remove-pad-left remove-pad-right\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.closePanel()\">\n{{'common.close' | translate}}\n</button>\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.confirmRecurring($ctrl.model.currentStats);\" ng-disabled=\"ATMOrdersCreateForm.$invalid || $ctrl.loading || \n                                        $ctrl.validateATMOrderCreateBtn() || $ctrl.newCash.isCreateRecurring || !$ctrl.isValidBillCount || !$ctrl.isValidStrapBillCount\">\n{{'master_cash_schedule.make_recurring' | translate}}\n</button>\n</div>\n</form>\n\n</div>\n</div>\n<div class=\"panel-body\" ng-if=\"$ctrl.model.currentStats === $ctrl.shipmentsCreateStats.stops.multiple\">\n<div class=\"cash-schedule-form\">\n<form name=\"stopsSchedule\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-left\">\n<label>{{'master_cash_schedule.location' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.toLocation\" values=\"$ctrl.filterDataSet.locationList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalLocation\" onscroll=\"$ctrl.loadLocation(searchKey, offset)\" none-selected=\"'common.select_location'\" ng-click=\"$ctrl.resetRouteId('toLocation');\" required>\n</search-and-select>\n</div>\n<div class=\"col-sm-6 margin-bottom-10 remove-pad-right\" ng-class=\"{'hold-route-dropdown': $ctrl.isHoldRoute($ctrl.newCash.routeId)}\">\n<label>{{'master_cash_schedule.route' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.newCash.routeId\" values=\"$ctrl.filterDataSet.routeList\" key=\"Key\" totalrecords=\"$ctrl.filterDataSet.totalRoutes\" common-search-flag=\"true\" none-selected=\"'master_cash_schedule.route'\" required ng-disabled=\"!$ctrl.newCash.toLocation\">\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label>{{'routeProgress.sequence' | translate}}</label>\n<input class=\"form-control\" type=\"number\" min=\"0\" ng-model=\"$ctrl.newCash.routeSequence\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\"><hr class=\"master-cash-line-section\"></div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6 remove-left-pad remove-right-pad margin-bottom-10 btn-group _btn-group-justified\">\n<a class=\"btn btn-xs\" ng-repeat=\"pattern in $ctrl.recurringPatternList\" ng-click=\"$ctrl.selectedPattern(pattern)\" ng-class=\"{'btn-primary': $ctrl.newCash.selectedPattern === pattern.value,\n                                                           'btn-default': $ctrl.newCash.selectedPattern !== pattern.value}\">\n{{pattern.label}}\n</a>\n</div>\n<div class=\"col-sm-5 pull-right scheduled margin-top-03 pull-right schedule-weeks-input remove-right-pad\" ng-if=\"$ctrl.newCash.selectedPattern !== 'daily'\">\n{{'master_cash_schedule.recur_every' | translate}}\n<input type=\"number\" min=\"1\" max=\"4\" required class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.newCash.recurWeeks\"> {{'master_cash_schedule.weeks_on' | translate}}\n</div>\n</div>\n<div class=\"scheduled-week-btn-section form-group remove-left-pad remove-right-pad col-sm-12\">\n<div id=\"service-schedule\" class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.serviceSchedule\" ng-click=\"$ctrl.toggleDay(day)\" ng-class=\"{'btn-primary': $ctrl.isDaySelected(day),'btn-default': !$ctrl.isDaySelected(day)}\">\n{{day.label}}\n</a>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-10\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label>{{'master_cash_schedule.start_at' | translate}}</label>\n<datetimepicker class=\"edit-order-view-date-picker-section datetimepicker-input\" ng-model=\"$ctrl.newCash.recurringStartDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" ng-change=\"$ctrl.validateEndDate();\" date-options=\"$ctrl.minRecurrStartDate\">\n</datetimepicker>\n</div>\n<div class=\"col-sm-6 remove-pad-right\">\n<label>{{'master_cash_schedule.end_by' | translate}}</label>\n<datetimepicker class=\"edit-order-view-date-picker-section datetimepicker-input\" ng-class=\"{'disabled': !$ctrl.newCash.recurringStartDate, \n                                            'required-datetimepicker': !$ctrl.newCash.recurringEndDate}\" ng-model=\"$ctrl.newCash.recurringEndDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\" date-options=\"$ctrl.minRecurrDate\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"_margin-top-10 col-sm-12 remove-pad-left remove-pad-right\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.closePanel()\">\n{{'common.close' | translate}}\n</button>\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.confirmLocationRecurring();\" ng-disabled=\"$ctrl.validateStopsScheduleBtn() || $ctrl.newCash.isCreateRecurring\">\n{{'master_cash_schedule.make_recurring' | translate}}\n</button>\n</div>\n</form>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-50\"></span>\n</div>\n</div>\n";
var id13="master_cash_schedule.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id13,v13);}
else{ngModule.run(["$templateCache",function(c){c.put(id13,v13)}]);}
module.exports=v13;

/***/ }),
/* 2752 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid padding-20\" ng-if=\"$ctrl.model.printData\">\n<div class=\"text-center margin-bottom-20\">\n<h2>Order Details - {{$ctrl.model.printData.formattedDate}}</h2>\n<h4>{{$ctrl.model.printData.orders.length}} Orders | {{$ctrl.model.printData.totalAmount | currency:'$':2}}</h4>\n</div>\n<div class=\"row margin-bottom-20\">\n<div class=\"col-sm-12 text-center\" style=\"display: flex; justify-content: center; flex-wrap: wrap;\">\n<div class=\"d-inline-flex align-items-center margin-right-20\" ng-repeat=\"denom in $ctrl.model.printData.denomTotals\" style=\"margin: 10px;\">\n<denom-icon denom-id=\"denom.id\" icon-size=\"30\"></denom-icon>\n<span style=\"font-size: 16px; margin-left: 10px;\">{{denom.amount | currency:'$':2}}</span>\n</div>\n</div>\n</div>\n<table class=\"table table-bordered table-striped text-align-center\" style=\"width: 100%;\">\n<thead>\n<tr>\n<th class=\"text-align-center\" style=\"min-width: 200px;\">Tracking ID</th>\n<th class=\"text-align-center\">Location</th>\n<th class=\"text-align-center\">Order Type</th>\n<th class=\"text-align-center contents-no-wrap\">Order No.</th>\n<th class=\"text-align-center\">Amount</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"order in $ctrl.model.printData.orders\">\n<td>\n<div ng-if=\"order.parentTrackingId\">{{order.parentTrackingId}}</div>\n<div ng-if=\"!order.parentTrackingId && order.trackingIds && order.trackingIds.length > 0\" ng-repeat=\"trackingId in order.trackingIds track by $index\">\n{{trackingId}}\n</div>\n<div ng-if=\"!order.parentTrackingId && (!order.trackingIds || order.trackingIds.length === 0)\">N/A</div>\n</td>\n<td>\n{{order.toLocationId}} | <span>{{order.toLocationName}}</span>\n</td>\n<td>\n<div ng-if=\"order.orderType\">{{ ('atm_residual.order_type_' + order.orderType) | translate }}</div>\n<div ng-if=\"!order.orderType && !order.shiptypeId\">{{ 'common.n_a' | translate }}</div>\n<div ng-if=\"!order.orderType && order.shiptypeId\">{{ order.shiptypeId | translate }}</div>\n</td>\n<td>{{order.orderNo || 'N/A'}}</td>\n<td>\n<strong>{{order.amount | currency:'$':2}}</strong>\n<div class=\"margin-top-5 small\" ng-if=\"order.denominations && order.denominations.length > 0\">\n<span ng-repeat=\"denom in order.denominations\" class=\"margin-right-10\" style=\"display: inline-flex; align-items: center; margin-top: 5px;\">\n<denom-icon denom-id=\"denom.id\" icon-size=\"20\"></denom-icon>\n<span style=\"margin-left: 5px;\">{{denom.amount | currency:'$':2}}</span>\n</span>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n";
var id1="print_master_cash_schedule.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2753 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"currency-pick-report-container\">\n<div class=\"col-sm-12 order-history-center-section form-validate\">\n<div class=\"col-md-3 col-sm-4 margin-top-5\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" ng-class=\"{'required-datetimepicker': !$ctrl.model.date}\" hidden-time=\"true\" ng-change=\"$ctrl.loadRoutes(); $ctrl.loadData();\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"col-md-3 col-sm-4 form-group\">\n<search-and-select class=\"funding-source-dd-height\" ng-model=\"$ctrl.model.fundingSource\" values=\"$ctrl.locationLists\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" onscroll=\"$ctrl.getFundingSource(searchKey, offset)\" none-selected=\"'branch_mgmt.orders_selectATMs'\" on-click=\"$ctrl.clearSearch(); $ctrl.loadData();\" required></search-and-select>\n</div>\n<div class=\"col-md-3 col-sm-4 form-group\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.route\" ng-change=\"$ctrl.filterData()\" ng-options=\"route.routeId as route.routeId for route in $ctrl.routeList\">\n<option value=\"\" selected=\"selected\">{{'common.All' | translate}}</option>\n</select>\n</div>\n<div class=\"pull-right form-group\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.print()\" ng-disabled=\"!$ctrl.model.fundingSource || \n             $ctrl.model.loading || \n             !$ctrl.denominations.length\">\n<span class=\"glyphicon glyphicon-print\"></span>\n<span>{{ 'branch_mgmt.itemHistory.print' | translate }}</span>\n</button>\n</div>\n</div>\n<div class=\"margin-top-05\" ng-if=\"!model.loading && (!$ctrl.denominations.length || !$ctrl.model.fundingSource)\">\n<div class=\"col-sm-12 alert text-center remove-bottom-margin alert-danger\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row margin-top-20\" ng-if=\"$ctrl.denominations.length && !$ctrl.model.loading && $ctrl.model.fundingSource\">\n<div class=\"col-sm-12\">\n<div class=\"table-wrapper\">\n<div class=\"scrollable-columns\">\n<table class=\"table currency-pick-table\">\n<thead>\n<tr>\n<th class=\"text-center\">{{ 'currency_pick_report.denominations' | translate }}</th>\n<th class=\"text-center\">{{ 'currency_pick_report.bundles' | translate }}</th>\n<th class=\"text-center\">{{ 'currency_pick_report.straps' | translate }}</th>\n<th class=\"text-center\">{{ 'currency_pick_report.loose' | translate }}</th>\n<th class=\"text-center\">{{ 'currency_pick_report.total' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"denom in $ctrl.denominations\">\n<td class=\"category-name\">\n<div class=\"denom-info\">\n<img ng-src=\"assets/images/{{denom.id}}.png\" class=\"denom-image\" alt=\"{{ denom.id }}\" style=\"width:35px\"/>\n</div>\n</td>\n<td class=\"data-cell text-center\">\n<div class=\"qty\">{{denom.bundleQty || '-'}}</div>\n<div class=\"amt\" ng-if=\"denom.bundleQty\">{{$ctrl.formatAmount(denom.bundleAmt)}}\n</div>\n</td>\n<td class=\"data-cell text-center\">\n<div class=\"qty\">{{denom.strapQty || '-'}}</div>\n<div class=\"amt\" ng-if=\"denom.strapQty\">{{$ctrl.formatAmount(denom.strapAmt)}}\n</div>\n</td>\n<td class=\"data-cell text-center\">\n<div class=\"qty\">{{denom.looseQty || '-'}}</div>\n<div class=\"amt\" ng-if=\"denom.looseQty\">{{$ctrl.formatAmount(denom.looseAmt)}}\n</div>\n</td>\n<td class=\"data-cell text-center total-amount\">\n<span>{{$ctrl.formatAmount(denom.total)}}</span>\n</td>\n</tr>\n<tr class=\"grand-total-row\">\n<td class=\"category-name text-center\">\n<strong>{{ 'currency_pick_report.total' | translate }}</strong>\n</td>\n<td class=\"data-cell text-right total-amount\" colspan=\"5\" style=\"padding-right: 100px;\">\n<span><strong>{{$ctrl.formatAmount($ctrl.grandTotals.total)}}</strong></span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="currency_pick_report.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2754 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"print-currency-pick-report-container\">\n<div class=\"header-section\">\n<div class=\"title margin-top-20\">\n{{ 'print_currency_pick_report.title' | translate }}\n</div>\n<div class=\"logo-container\">\n<img stream-print-logo load-from-db=\"true\" class=\"margin-top-10 print-logo-height-65\">\n</div>\n</div>\n<div class=\"info-section font-size-16 margin-bottom-10\">\n<strong>\n<span ng-if=\"$ctrl.date\"> {{$ctrl.date}}</span>\n<span ng-if=\"$ctrl.date && ($ctrl.fundingSource || $ctrl.routeId)\">|</span>\n<span ng-if=\"$ctrl.fundingSource\">{{$ctrl.fundingSource}}</span>\n<span ng-if=\"$ctrl.fundingSource && $ctrl.routeId\">|</span>\n<span ng-if=\"$ctrl.routeId\">{{$ctrl.routeId}}</span>\n</strong>\n</div>\n<div class=\"row margin-top-10\" ng-if=\"$ctrl.denominations.length\">\n<div class=\"col-sm-12\">\n<div class=\"table-responsive\">\n<table class=\"table currency-pick-table\">\n<thead>\n<tr>\n<th class=\"text-center\">{{ 'currency_pick_report.denominations' | translate }}</th>\n<th class=\"text-center\">{{ 'currency_pick_report.bundles' | translate }}</th>\n<th class=\"text-center\">{{ 'currency_pick_report.straps' | translate }}</th>\n<th class=\"text-center\">{{ 'currency_pick_report.loose' | translate }}</th>\n<th class=\"text-center\">{{ 'currency_pick_report.total' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"denom in $ctrl.denominations\">\n<td class=\"category-name\">\n<div class=\"denom-info\">\n<img ng-src=\"assets/images/{{denom.id}}.png\" class=\"denom-image\" alt=\"{{ denom.id }}\" style=\"width:35px\"/>\n</div>\n</td>\n<td class=\"data-cell text-center\">\n<div class=\"qty\">{{denom.bundleQty || '-'}}</div>\n<div class=\"amt\" ng-if=\"denom.bundleQty\">{{$ctrl.formatAmount(denom.bundleAmt)}}</div>\n</td>\n<td class=\"data-cell text-center\">\n<div class=\"qty\">{{denom.strapQty || '-'}}</div>\n<div class=\"amt\" ng-if=\"denom.strapQty\">{{$ctrl.formatAmount(denom.strapAmt)}}</div>\n</td>\n<td class=\"data-cell text-center\">\n<div class=\"qty\">{{denom.looseQty || '-'}}</div>\n<div class=\"amt\" ng-if=\"denom.looseQty\">{{$ctrl.formatAmount(denom.looseAmt)}}</div>\n</td>\n<td class=\"data-cell text-center total-amount\">\n<span>{{$ctrl.formatAmount(denom.total)}}</span>\n</td>\n</tr>\n<tr class=\"grand-total-row\">\n<td class=\"category-name text-center\">\n<strong>{{ 'currency_pick_report.total' | translate }}</strong>\n</td>\n<td class=\"data-cell text-right total-amount\" colspan=\"5\" style=\"padding-right: 90px;\">\n<span><strong>{{$ctrl.formatAmount($ctrl.grandTotals.total)}}</strong></span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"signature-section margin-top-40\" ng-if=\"$ctrl.denominations.length\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"table-responsive\">\n<div class=\"signature-wrapper\">\n<div class=\"signature-row\">\n<h4 class=\"sig-label\">{{ 'currency_pick_report.pulling_user' | translate }}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n</div>\n<div class=\"signature-row\">\n<h4 class=\"sig-label\">{{ 'currency_pick_report.verify_user' | translate }}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n</div>\n<div class=\"signature-row\">\n<h4 class=\"sig-label\">{{ 'currency_pick_report.packing_user' | translate }}</h4>\n<span class=\"text-align-left lineColor\">_________________________________________________</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="print_currency_pick_report.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"col-sm-12 align-center form-validate\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<search-and-select ng-model=\"$ctrl.model.locationId\" values=\"$ctrl.locationLists\" key=\"Key\" ng-change=\"$ctrl.onBFSChange();\" totalrecords=\"$ctrl.totalRecords\" ng-disabled=\"!$ctrl.model.branchId\" common-search-flag=\"true\" none-selected=\"'orderPacking.selectFromLocation'\" on-click=\"$ctrl.onBFSChange();\" class=\"funding-source-dd-height\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4\" ng-show=\"$ctrl.model.stats === 'completed' || $ctrl.model.stats === 'onHold'\">\n<div class=\"order-pack-datetimepicker-section form-group\" ng-show=\"$ctrl.model.stats === 'completed'\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-disabled=\"!$ctrl.model.locationId\" ng-click=\"$ctrl.getOrderPackingList(true); $ctrl.getPackedShipment(); \" ng-keydown=\"$event.preventDefault()\" required>\n</datetimepicker>\n</div>\n<div class=\"order-pack-datetimepicker-section form-group\" ng-show=\"$ctrl.model.stats === 'onHold'\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-disabled=\"!$ctrl.model.locationId\" ng-click=\"$ctrl.getPendingPackShipmentsOnHold();\" ng-keydown=\"$event.preventDefault()\" required>\n</datetimepicker>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 align-center margin-bottom-10 z-index0\">\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.ledger\" uib-btn-radio=\"$ctrl.accounts.regular\" ng-click=\"$ctrl.loadOrderPackingList('regular'); $ctrl.getAvailableLedgerBalance();\" ng-class=\"{'btn-success': $ctrl.model.ledger === $ctrl.accounts.regular}\">\n{{ 'common.regular' | translate }}\n<span ng-if=\"$ctrl.model.stats === 'pending'\" class=\"badge\">{{$ctrl.regularCount || 0}}</span>\n<span ng-if=\"$ctrl.model.stats === 'completed'\" class=\"badge\">{{$ctrl.orderPackedRegularCount || 0}}</span>\n<span ng-if=\"$ctrl.model.stats === 'onHold'\" class=\"badge\">{{$ctrl.regularShipmentsOnHoldCount || 0}}</span>\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.ledger\" uib-btn-radio=\"$ctrl.accounts.emergency\" ng-click=\"$ctrl.loadOrderPackingList('emergency'); $ctrl.getAvailableLedgerBalance();\" ng-class=\"{'btn-success': $ctrl.model.ledger === $ctrl.accounts.emergency}\">\n{{ 'common.emergency' | translate }}\n<span ng-if=\"$ctrl.model.stats === 'pending'\" class=\"badge\">{{$ctrl.emergencyCount || 0}}</span>\n<span ng-if=\"$ctrl.model.stats === 'completed'\" class=\"badge\">{{$ctrl.orderPackedEmergencyCount || 0}}</span>\n<span ng-if=\"$ctrl.model.stats === 'onHold'\" class=\"badge\">{{$ctrl.emergencyShipmentsOnHoldCount || 0}}</span>\n</label>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.locationId && !$ctrl.model.loading\" class=\"col-sm-12 _div-margin-top remove-pad\">\n<div class=\"center-table\">\n<div class=\"col-sm-12 table-responsive remove-left-pad remove-right-pad\">\n<h4 class=\"_remove-pad\">Cash Denom Balance</h4>\n<table class=\"table-pad-3 remove-bottom-margin table table-bordered text-align-center font-12 border-black\">\n<thead>\n<tr>\n<th ng-class=\"$ctrl.getLedgerBalanceClass(denom.id)\" class=\"text-align-center border-black\" ng-repeat=\"denom in $ctrl.cashLedgerDenoms | orderBy:['sortOrder', 'faceValue']\">\n<denom-icon denom-id=\"denom.id\" icon-size=\"14\" label=\"{{denom.id}}\" class=\"custom-icon\"></denom-icon>\n</th>\n<th rowspan=\"2\" ng-class=\"$ctrl.getTotalClass()\" class=\"text-align-center border-black\">Total\n</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td ng-repeat=\"denom in $ctrl.cashLedgerDenoms | orderBy:['sortOrder', 'faceValue']\" ng-class=\"$ctrl.getLedgerBalanceClass(denom.id)\" class=\"border-black\">\n{{ $ctrl.getCurrentDenomLedgerBalance(denom.id) | currency:($ctrl.getDenomLedgerSymbol(denom.id) || $ctrl.currencySymbol):2 }}\n</td>\n<td class=\"total-balance border-black\" ng-class=\"$ctrl.getTotalClass()\">\n{{ $ctrl.cashTotalBalance | currency:$ctrl.currencySymbol:2 }}\n</td>\n</tr>\n<tr ng-if=\"$ctrl.packedShipments.length && $ctrl.model.stats === 'completed'\">\n<td ng-repeat=\"denom in $ctrl.cashLedgerDenoms | orderBy:['sortOrder', 'faceValue']\" ng-class=\"$ctrl.getLedgerBalanceClass(denom.id)\" class=\"border-black\">\n{{ $ctrl.getPackedAmount(denom.id) | currency:($ctrl.getDenomLedgerSymbol(denom.id) || $ctrl.currencySymbol):2 }}\n</td>\n<td class=\"total-balance border-black\">\n{{ $ctrl.getPackedCashTotal() | currency:$ctrl.currencySymbol:2 }}\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.locationId && !$ctrl.model.loading\" class=\"col-sm-12 _div-margin-top remove-pad\">\n<div class=\"center-table\">\n<div class=\"col-sm-12 table-responsive remove-left-pad remove-right-pad\">\n<h4 class=\"_remove-pad\">Coin Denom Balance</h4>\n<table class=\"table-pad-3 table table-bordered text-align-center font-12 border-black\">\n<thead>\n<tr>\n<th ng-class=\"$ctrl.getLedgerBalanceClass(denom.id)\" class=\"text-align-center border-black\" ng-repeat=\"denom in $ctrl.coinLedgerDenoms | orderBy:['sortOrder', 'faceValue']\">\n<denom-icon denom-id=\"denom.id\" label=\"{{denom.id}}\" class=\"custom-icon\" icon-size=\"14\"> </denom-icon>\n</th>\n<th rowspan=\"2\" ng-class=\"$ctrl.getTotalClass()\" class=\"text-align-center border-black\">Total\n</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td ng-repeat=\"denom in $ctrl.coinLedgerDenoms | orderBy:['sortOrder', 'faceValue']\" ng-class=\"$ctrl.getLedgerBalanceClass(denom.id)\" class=\"border-black\">\n{{ $ctrl.getCurrentDenomLedgerBalance(denom.id) | currency:($ctrl.getDenomLedgerSymbol(denom.id) || $ctrl.currencySymbol):2 }}\n</td>\n<td class=\"total-balance border-black\" ng-class=\"$ctrl.getTotalClass()\">\n{{ $ctrl.coinTotalBalance | currency:$ctrl.currencySymbol:2 }}\n</td>\n</tr>\n<tr ng-if=\"$ctrl.packedShipments.length && $ctrl.model.stats === 'completed'\">\n<td ng-repeat=\"denom in $ctrl.coinLedgerDenoms | orderBy:['sortOrder', 'faceValue']\" ng-class=\"$ctrl.getLedgerBalanceClass(denom.id)\" class=\"border-black\">\n{{ $ctrl.getPackedAmount(denom.id) | currency:($ctrl.getDenomLedgerSymbol(denom.id) || $ctrl.currencySymbol):2 }}\n</td>\n<td class=\"total-balance border-black\">\n{{ $ctrl.getPackedCoinTotal() | currency:$ctrl.currencySymbol:2}}\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.orderShipments.length && $ctrl.model.stats === 'pending'\">\n<div class=\"row_\">\n<div class=\"col-sm-3 margin-top-10\">\n<div class=\"form-group text-align-center\">\n<span>{{ 'orderPacking.remaining_orders' | translate }}:</span>\n<br/>\n<span class=\"order-packing-font-35\">\n<b>{{ $ctrl.remainingOrders }}</b>\n</span>\n</div>\n</div>\n<div class=\"col-sm-3 margin-top-10\">\n<div class=\"form-group pull-right text-align-center\">\n<span>{{ 'orderPacking.remaining_shipments' | translate }}:</span>\n<br/>\n<span class=\"order-packing-font-35\">\n<b>{{ $ctrl.orderShipments.length }}</b>\n</span>\n</div>\n</div>\n<div class=\"col-sm-4 margin-top-10\">\n<div class=\"text-center\">\n<span>{{ 'orderPacking.cash_remaining' | translate }}:</span>\n<br/>\n<span class=\"order-packing-font-35\">\n<b>{{ $ctrl.totalDenomAmount | currency:$ctrl.currencySymbol:2 }}</b>\n<button type=\"button\" class=\"ledger-short-fall-btn-margin btn btn-xs btn-success\" ng-click=\"$ctrl.getAvailableLedgerBalance();\" uib-tooltip=\"{{'orderPacking.view_ledger_shortfall' | translate}}\" ng-disabled=\"$ctrl.model.gettingLedgerDenomBalance\">\n<i class=\"glyphicon glyphicon-th-list\"></i>\n</button>\n</span>\n<div ng-if=\"$ctrl.model.ledgerShortFall\">\n<span class=\"font-size-20 bulk-cash-link-btn\" ng-class=\"{'text-danger': $ctrl.model.ledgerShortFall < 0, 'text-success': $ctrl.model.ledgerShortFall >= 0}\" ng-click=\"$ctrl.goToBulkCash()\"> ({{$ctrl.model.ledgerShortFall | currency:$ctrl.currencySymbol:2}})\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-1 order-pack-btn-margin-bottom margin-top-30\" style=\"margin-left: 100px;\" ng-if=\"$ctrl.model.stats === 'pending' && $ctrl.model.printPrePack && $ctrl.model.locationId && $ctrl.orderShipments.length > 0\">\n<button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.printBarcodes()\" ng-disabled=\"!$ctrl.validatePrePackPrintBtn()\">\n{{'shipment.print_pre_pack' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 text-center padding-18 denom-position\">\n<div ng-repeat=\"denomination in $ctrl.denominationsArray | orderBy:['sortOrder', 'faceValue'] track by $index\" class=\"denom-width\">\n<div class=\"text-center\">\n<denom-icon denom-id=\"denomination.denominationId\" class=\"custom-icon\" icon-size=\"30\"> </denom-icon>\n<span class=\"text-amount\">\n{{ denomination.denomAmount | currency:(denomination.symbol || $ctrl.currencySymbol):2 }}\n</span>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.onHoldShipmentList.length && $ctrl.model.stats === $ctrl.stats.onHold\">\n<div class=\"col-sm-12 text-center\">\n<div class=\"text-center\">\n<span>{{ 'bulkCash.totalAmount' | translate }}:</span>\n<br/>\n<span style=\"font-size: 35px;\">\n<b>{{ $ctrl.totalDenomAmount | currency:$ctrl.currencySymbol:2 }}</b>\n</span>\n</div>\n</div>\n<div class=\"col-sm-12 text-center padding-18 denom-position\">\n<div ng-repeat=\"denomination in $ctrl.denominationsArray | orderBy:['sortOrder', 'faceValue'] track by $index\" class=\"denom-width\">\n<div class=\"text-center\">\n<denom-icon denom-id=\"denomination.denominationId\" class=\"custom-icon\" icon-size=\"30\"> </denom-icon>\n<span class=\"text-amount\">\n{{ denomination.denomAmount | currency:(denomination.symbol || $ctrl.currencySymbol):2 }}\n</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<hr>\n</div>\n<div class=\"col-sm-12 margin-bottom-20 btn-group-section\">\n<div class=\"btn-group z-index0\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.pending\" ng-click=\"$ctrl.tabSelection('pending')\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.pending}\">\n{{ 'common.pending' | translate }}\n<span ng-if=\"$ctrl.model.ledger === $ctrl.accounts.regular\" class=\"badge\">{{$ctrl.regularCount || 0}}</span>\n<span ng-if=\"$ctrl.model.ledger === $ctrl.accounts.emergency\" class=\"badge\">{{$ctrl.emergencyCount || 0}}</span>\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.completed\" ng-click=\"$ctrl.tabSelection('completed'); $ctrl.getPackedShipment()\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.completed}\">\n{{ 'common.completed' | translate }}\n<span ng-if=\"$ctrl.model.ledger === $ctrl.accounts.regular\" class=\"badge\">{{$ctrl.orderPackedRegularCount || 0}}</span>\n<span ng-if=\"$ctrl.model.ledger === $ctrl.accounts.emergency\" class=\"badge\">{{$ctrl.orderPackedEmergencyCount || 0}}</span>\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.onHold\" ng-click=\"$ctrl.tabSelection('onHold'); $ctrl.getPendingPackShipmentsOnHold()\" ng-class=\"{'btn-success': $ctrl.model.stats === $ctrl.stats.onHold}\">\n{{ 'shipment.hold' | translate }}\n<span ng-if=\"$ctrl.model.ledger === $ctrl.accounts.regular\" class=\"badge\">{{$ctrl.regularShipmentsOnHoldCount || 0}}</span>\n<span ng-if=\"$ctrl.model.ledger === $ctrl.accounts.emergency\" class=\"badge\">{{$ctrl.emergencyShipmentsOnHoldCount || 0}}</span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-class=\"{'order-auto-center-section d-flex align-items-end' : ($ctrl.allOrderShipments.length && $ctrl.model.stats === $ctrl.stats.pending) || \n         ($ctrl.allPackedShipments.length && $ctrl.model.stats === $ctrl.stats.completed) ||\n         ($ctrl.shipmentsOnHoldList.length && $ctrl.model.stats === $ctrl.stats.onHold)}\">\n<div class=\"col-sm-2 remove-pad search-section\" ng-if=\"($ctrl.allOrderShipments.length && $ctrl.model.stats === $ctrl.stats.pending) || \n                    ($ctrl.allPackedShipments.length && $ctrl.model.stats === $ctrl.stats.completed) ||\n                    ($ctrl.shipmentsOnHoldList.length && $ctrl.model.stats === $ctrl.stats.onHold)\">\n<input type=\"text\" placeholder=\"{{'common.search' | translate}}\" class=\"form-control\" id=\"searchtext\" ng-model=\"$ctrl.model.searchText\" ng-keydown=\"$event.keyCode === 13 && $ctrl.loadOrderPackingList()\">\n</div>\n<div class=\"col-sm-2 remove-pad search-section\" ng-if=\"($ctrl.allOrderShipments.length && $ctrl.model.stats === $ctrl.stats.pending)\">\n<div>\n<label>Delivery Date</label>\n<button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" ng-click=\"$ctrl.model.pendingFilterDate = null;$ctrl.loadOrderPackingList()\">{{'common.clear' | translate}}</button>\n<datetimepicker class=\"common-date-picker-section datetimepicker-input\" ng-model=\"$ctrl.model.pendingFilterDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" placeholder=\"{{'common.date' | translate}}\" ng-click=\"$ctrl.getOrderPackingList(true); $ctrl.getPackedShipment(); \" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"col-sm-2 remove-pad pull-right\" ng-if=\"($ctrl.allOrderShipments.length && $ctrl.model.stats === $ctrl.stats.pending) || \n                                    ($ctrl.allPackedShipments.length && $ctrl.model.stats === $ctrl.stats.completed) ||\n                                    ($ctrl.shipmentsOnHoldList.length && $ctrl.model.stats === $ctrl.stats.onHold)\">\n<label>{{'shipment.route' | translate}}</label>\n<select id=\"routes\" class=\"form-control\" ng-model=\"$ctrl.model.route\" ng-options=\"route for route in $ctrl.routeList\" ng-change=\"$ctrl.loadOrderPackingList()\">\n<option value=\"\" selected=\"selected\">({{'common.All' |translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-2 remove-pad pull-right\" ng-if=\"($ctrl.allOrderShipments.length && $ctrl.model.stats === $ctrl.stats.pending) ||\n                                    ($ctrl.allPackedShipments.length && $ctrl.model.stats === $ctrl.stats.completed) ||\n                                    ($ctrl.shipmentsOnHoldList.length && $ctrl.model.stats === $ctrl.stats.onHold)\">\n<label>{{'shipment.customer' | translate}}</label>\n<select id=\"customer\" class=\"form-control\" ng-model=\"$ctrl.model.customerId\" ng-options=\"customer.value as customer.label for customer in $ctrl.customerList\" ng-change=\"$ctrl.loadOrderPackingList()\">\n<option value=\"\" selected=\"selected\">({{'common.All' |translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-2 remove-pad pull-right\" ng-if=\"($ctrl.allOrderShipments.length && $ctrl.model.stats === $ctrl.stats.pending) || \n                                        ($ctrl.allPackedShipments.length && $ctrl.model.stats === $ctrl.stats.completed) ||\n                                        ($ctrl.shipmentsOnHoldList.length && $ctrl.model.stats === $ctrl.stats.onHold)\">\n<label>{{'shipment.order_type' | translate}}</label>\n<select id=\"order-type\" class=\"form-control\" ng-model=\"$ctrl.model.orderType\" ng-options=\"orderType.value as orderType.label for orderType in $ctrl.orderTypeList\" ng-change=\"$ctrl.loadOrderPackingList()\">\n<option value=\"\" selected=\"selected\">({{'common.All' |translate}})</option>\n</select>\n</div>\n<div class=\"order-pack-btn-margin-bottom margin-top-02\" ng-if=\"$ctrl.packedShipments.length && $ctrl.model.stats === 'completed'\">\n<button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.printPackedShipmentLabel()\" ng-if=\"$ctrl.model.printPackLabel\" ng-disabled=\"!$ctrl.validateBarcodeBtn()\">\n{{'orderPacking.print_labels' | translate}}\n</button>\n</div>\n<div class=\"order-pack-btn-margin-bottom margin-top-02\" ng-if=\"$ctrl.packedShipments.length && $ctrl.model.stats === 'completed'\">\n<button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.exportPackedShipment()\">\n{{'common.export' | translate}}\n</button>\n</div>\n<div class=\"order-pack-btn-margin-bottom margin-top-02\" ng-if=\"$ctrl.packedShipments.length && $ctrl.model.stats === 'completed'\">\n<button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.printPackedOrders()\">\n{{'coinPullReport.print' | translate}}\n</button>\n</div>\n<div class=\"order-pack-btn-margin-bottom margin-top-02\" ng-if=\"$ctrl.model.stats === 'pending' && $ctrl.model.locationId && $ctrl.orderShipments.length > 0 && $ctrl.canViewCurrencyPick\">\n<button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.goToCurrencyPick()\">\n{{'orderPacking.currency_pick' | translate}}\n</button>\n</div>\n<div class=\"order-pack-btn-margin-bottom margin-top-02\" ng-if=\"$ctrl.model.stats === 'pending' && $ctrl.model.locationId && $ctrl.orderShipments.length > 0\">\n<button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.exportPendingPackShipments()\">\n{{'common.export' | translate}}\n</button>\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.loading && $ctrl.model.stats === 'pending' && $ctrl.model.locationId\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!$ctrl.model.loading && $ctrl.orderShipments && $ctrl.orderShipments.length && $ctrl.model.stats === 'pending'\" class=\"col-sm-12 div-margin-top remove-pad\">\n<div class=\"row_ table-responsive\">\n<table class=\"table table-bordered table-hover table-striped table-sortable text-align-center font-12\">\n<thead>\n<td ng-click=\"$ctrl.toggleAllPrePackShipments()\" align=\"center\" class=\"print-pre-pack-checkbox-w cursor-pointer\" ng-if=\"$ctrl.model.printPrePack\">\n<span><b>{{'routeControl.all' | translate}}</b></span>\n</td>\n<td style=\"width: 10%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('P','orderNo')\">\n{{ 'common.orderId' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'orderNo'}\"></span>\n</td>\n<td style=\"width: 10%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('P','orderType')\">\n{{ 'common.order_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'orderType'}\"></span>\n</td>\n<td style=\"width: 8%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('P','amount')\">\n{{ 'common.total' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amount'}\"></span>\n</td>\n<td style=\"width: 7%;\" class=\"pointer\">\n{{ 'common.denomination' | translate}}\n</td>\n<td style=\"width: 20%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('P','toLocationId')\">\n{{ 'common.to' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'toLocationId'}\"></span>\n</td>\n<td style=\"width: 10%;\" ng-click=\"$ctrl.sortCollection('P','vaultDate')\">\n{{ 'orderPacking.load_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'vaultDate'}\"></span>\n</td>\n<td style=\"width: 10%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('P','defRouteSequence')\">\n{{ 'common.route' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'defRouteSequence'}\"></span>\n</td>\n<td style=\"width: 10%;\">\n{{ 'common.action' | translate }}\n</td>\n</thead>\n<tbody>\n<tr ng-repeat=\"orderShipment in $ctrl.orderShipments | orderBy:$ctrl.getSortExpression():$ctrl.reverseSort track by $index\">\n<td align=\"center\" ng-if=\"$ctrl.model.printPrePack\">\n<input type=\"checkbox\" ng-click=\"$ctrl.selectedPrePackShipments($event, orderShipment)\" ng-model=\"orderShipment.isSelected\">\n</td>\n<td>\n<span data-createdate=\"{{orderShipment.createdAt}}\" data-updatedat=\"{{orderShipment.updatedAt}}\">\n<a href=\"#\" ng-click=\"$ctrl.redirectToOrderTab(orderShipment)\">\n{{orderShipment.orderNo}}\n</a>\n</span>\n</td>\n<td>\n{{$ctrl.getOrderType(orderShipment)}}\n</td>\n<td>\n<b>{{ orderShipment.amount | currency:(orderShipment.symbol || $ctrl.currencySymbol):2 }}</b>\n</td>\n<td>\n<div class=\"denom-container\">\n<div ng-repeat=\"denom in orderShipment.denominations | orderBy:['sortOrder', 'faceValue']\" class=\"denom-badge\">\n<denom-icon denom-id=\"denom.id\" icon-size=\"20\"> </denom-icon>\n<span class=\"denom-amount\">{{ denom.amount | currency:(denom.symbol || $ctrl.currencySymbol):2 }}</span>\n</div>\n</div>\n</td>\n<td class=\"text-left\" ng-if=\"orderShipment.toLocationId\">\n<div>\n<span><a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(orderShipment)\">{{orderShipment.toLocation.id}}</a></span>\n<span class=\"cursor-pointer\" ng-if=\"orderShipment.toLocation.name\" uib-tooltip=\"{{$ctrl.formatAddress(orderShipment)}}\"> | {{orderShipment.toLocation.name}}</span>\n<span class=\"text-left\" ng-if=\"!orderShipment.toLocation.name\">\n| {{'common.n_a' |translate}}\n</span>\n</div>\n<div ng-if=\"orderShipment.eventFlag\">\n<span class=\"location-comment-color\">{{orderShipment.toLocation.comments}}</span>\n</div>\n</td>\n<td>\n{{ orderShipment.vaultDate | date:'yyyy-MM-dd': 'UTC' }}\n</td>\n<td class=\"text-left\" ng-if=\"!orderShipment.toLocation.address && !orderShipment.toLocation.city && !orderShipment.toLocation.state && !orderShipment.toLocation.zip\">\n{{'common.n_a' |translate}}\n</td>\n<td class=\"contents-no-wrap\">\n<span>{{orderShipment.routeId}}</span>\n<span ng-if=\"orderShipment.defRouteSequence >= 0\"> | <span class=\"order-pack-route-seq-color\">{{orderShipment.defRouteSequence}}</span></span>\n<span ng-if=\"orderShipment.defRouteSequence == null\" class=\"order-pack-route-seq-color\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<div>\n<button id=\"pack-btn\" class=\"btn btn-xs btn-success\" uib-tooltip=\"Pack\" ng-click=\"$ctrl.orderPack(orderShipment)\" ng-disabled=\"$ctrl.isLoading || !$ctrl.model.ledger || $ctrl.model.gettingLedgerDenomBalance\" tooltip-append-to-body=\"true\">\n<span>{{ 'orderPacking.pack' | translate }}</span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.lastOrderDetails(orderShipment)\" ng-disabled=\"$ctrl.model.gettingLedgerDenomBalance\">\n<span class=\"glyphicon glyphicon-list-alt\" uib-tooltip=\"{{'orderPacking.last_order_details' | translate}}\" tooltip-placement=\"top\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.softDeleteShipment(orderShipment)\" ng-disabled=\"$ctrl.model.gettingLedgerDenomBalance\">\n<span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"{{'common.Delete' | translate}}\" tooltip-placement=\"top\"></span>\n</button>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.loading && (!$ctrl.orderShipments || !$ctrl.orderShipments.length) && $ctrl.model.stats === 'pending'\">\n<div class=\"col-sm-12 alert alert-danger text-align-center div-margin-top\">\n{{'common.noRecords' | translate}}\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.gettingPackedShipmentList && $ctrl.model.stats === 'completed'\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!$ctrl.model.gettingPackedShipmentList && $ctrl.packedShipments && $ctrl.packedShipments.length && $ctrl.model.stats === 'completed'\" class=\"col-sm-12 div-margin-top table-responsive remove-pad\">\n<div class=\"row_\">\n<table class=\"table table-bordered table-hover table-striped table-sortable text-align-center font-12\">\n<thead>\n<td ng-click=\"$ctrl.toggleAllShipmentSelection()\" align=\"center\" class=\"cursor-pointer\" ng-if=\"$ctrl.model.printPackLabel\">\n<span>\n<b>{{'routeControl.all' | translate}}</b>\n</span>\n</td>\n<td style=\"width: 10%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('C','orderNo')\">\n{{ 'common.orderId' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'orderNo'}\"></span>\n</td>\n<td style=\"width: 8%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('C','orderType')\">\n{{ 'common.order_type' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'orderType'}\"></span>\n</td>\n<td style=\"width: 8%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('C','amount')\">\n{{ 'common.total' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'amount'}\"></span>\n</td>\n<td style=\"width: 4%;\" class=\"pointer\">\n{{ 'common.denomination' | translate}}\n</td>\n<td style=\"width: 20%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('C','toLocationId')\">\n{{ 'common.to' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'toLocationId'}\"></span>\n</td>\n<td style=\"width: 20%;\">\n{{ 'common.address' | translate}}\n</td>\n<td style=\"width: 10%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('C','routeId')\">\n{{ 'common.route' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'routeId'}\"></span>\n</td>\n<td style=\"width: 10%;\" ng-click=\"$ctrl.sortCollection('C','vaultDate')\">\n{{ 'orderPacking.timeStamp' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'vaultDate'}\"></span>\n</td>\n<td style=\"width: 10%;\">\n{{ 'common.action' | translate}}\n</td>\n</thead>\n<tbody>\n<tr ng-repeat=\"packShipment in $ctrl.packedShipments | orderBy:$ctrl.getSortExpression():$ctrl.reverseSort track by $index\">\n<td align=\"center\" ng-if=\"$ctrl.model.printPackLabel\">\n<input type=\"checkbox\" ng-click=\"$ctrl.selectedShipments($event, packShipment)\" ng-model=\"packShipment.isSelected\">\n</td>\n<td ng-if=\"packShipment.orderNo\">\n<a href=\"#\" ng-click=\"$ctrl.redirectToOrderTab(packShipment)\">{{ packShipment.orderNo }}</a>\n</td>\n<td ng-if=\"!packShipment.orderNo\">\n{{'common.n_a' |translate}}\n</td>\n<td>\n{{$ctrl.getOrderType(packShipment)}}\n</td>\n<td>\n<b>{{ packShipment.amount | currency:(packShipment.symbol || $ctrl.currencySymbol):2 }}</b>\n</td>\n<td>\n<div class=\"denom-container\">\n<div ng-repeat=\"denom in packShipment.denominations | orderBy:['sortOrder', 'faceValue']\" class=\"denom-badge\" ng-if=\"denom\">\n<denom-icon denom-id=\"denom.id\" icon-size=\"20\"> </denom-icon>\n<span class=\"denom-amount\">{{ denom.amount | currency:(denom.symbol || $ctrl.currencySymbol):2 }}</span>\n</div>\n</div>\n</td>\n<td class=\"text-left\" ng-if=\"packShipment.toLocationId\">\n<span>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(packShipment)\">{{packShipment.toLocation.id}}</a>\n</span>\n<span ng-if=\"packShipment.toLocation.name\">| {{packShipment.toLocation.name}}</span>\n<span class=\"text-left\" ng-if=\"!packShipment.toLocation.name\">\n| {{'common.n_a' |translate}}\n</span>\n</td>\n<td class=\"text-left\" ng-if=\"packShipment.toLocation.address || packShipment.toLocation.city || packShipment.toLocation.state || packShipment.toLocation.zip\">\n<span ng-if=\"packShipment.toLocation.address\">{{packShipment.toLocation.address}},</span>\n<span ng-if=\"packShipment.toLocation.city\">{{packShipment.toLocation.city}},</span>\n<span ng-if=\"packShipment.toLocation.state\">{{packShipment.toLocation.state}},</span>\n<span ng-if=\"packShipment.toLocation.zip\">{{packShipment.toLocation.zip}}</span>\n</td>\n<td class=\"text-left\" ng-if=\"!packShipment.toLocation.address && !packShipment.toLocation.city && !packShipment.toLocation.state && !packShipment.toLocation.zip\">\n{{'common.n_a' |translate}}\n</td>\n<td class=\"contents-no-wrap\">\n<span>{{ packShipment.routeId }}</span>\n<span ng-if=\"packShipment.defRouteSequence >= 0\"> | <span class=\"order-pack-route-seq-color\">{{packShipment.defRouteSequence}}</span></span>\n</td>\n<td ng-if=\"packShipment.vaultDate\">\n{{ packShipment.vaultDate | date:'yyyy-MM-dd': 'UTC' }}\n</td>\n<td ng-if=\"!packShipment.vaultDate\">\n{{ 'common.n_a' | translate }}\n</td>\n<td>\n<button ng-if=\"!packShipment.checkedOut && !packShipment.packableOrderShipmentId && !packShipment.deliveredFlag && (!packShipment.denomination || !packShipment.denomination.coinFlag || packShipment.coinDebited === 1)\" type=\"button\" ng-click=\"$ctrl.convertToCrv(packShipment, $event)\" class=\"btn btn-xs btn-warning\" uib-tooltip=\"{{'itemHolds.converttocrv' | translate}}\" tooltip-placement=\"top-right\" ng-class=\"{'disabled': ($ctrl.gettingPackedShipmentList)}\">\n{{'orderPacking.convert_to_crv' | translate}}</button>\n<button ng-if=\"!packShipment.checkedOut && packShipment.packableOrderShipmentId && !packShipment.deliveredFlag && !packShipment.convertToCRV && (!packShipment.denomination || !packShipment.denomination.coinFlag || packShipment.coinDebited === 1)\" type=\"button\" ng-click=\"$ctrl.convertToCrvPackableOrder(packShipment,$event)\" class=\"btn btn-xs btn-warning\" uib-tooltip=\"{{'itemHolds.converttocrv' | translate}}\" tooltip-placement=\"top-right\" ng-class=\"{'disabled': ($ctrl.gettingPackedShipmentList)}\">\n{{'orderPacking.convert_to_crv' | translate}}</button>\n<span ng-if=\"packShipment.checkedOut\" uib-tooltip=\"{{'orderPacking.checked_out_error' | translate}}\" tooltip-placement=\"top-right\">\n<button type=\"button\" class=\"btn btn-xs btn-warning\" ng-class=\"{'disabled': (packShipment.checkedOut)}\">{{'orderPacking.convert_to_crv' | translate}}</button>\n</span>\n<button ng-if=\"(packShipment.orderNo && packShipment.denominationId) && (!packShipment.checkedOut && packShipment.holdFlag) \n                                           && (packShipment.orderType !== 'T' && packShipment.orderType !== 'P')\" ng-disabled=\"!$ctrl.isAllowedToUnpack(packShipment)\" type=\"button\" class=\"btn btn-xs btn-warning remove-pad\" ng-click=\"$ctrl.orderPackingUndo(packShipment)\" ng-class=\"{'disabled': ($ctrl.gettingPackedShipmentList)}\">\n<img src=\"" + __webpack_require__(119) + "\" class=\"icon-height-19\" uib-tooltip=\"{{'orderPacking.unpack_order' | translate}}\" tooltip-placement=\"top-right\">\n</button>\n<button ng-if=\"(packShipment.orderNo && packShipment.denominationId) && (packShipment.orderType === 'T' || packShipment.orderType === 'P')\" type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.softDeleteShipment(packShipment)\" ng-class=\"{'disabled': ($ctrl.gettingPackedShipmentList)}\">\n<span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"{{'common.soft_delete' | translate}}\" tooltip-placement=\"top\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.gettingPackedShipmentList && (!$ctrl.packedShipments || !$ctrl.packedShipments.length) && $ctrl.model.stats === 'completed'\">\n<div class=\"col-sm-12 alert alert-danger text-align-center div-margin-top\">\n{{'common.noRecords' | translate}}\n</div>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.loadOnHoldShipments && $ctrl.model.stats === 'onHold'\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div ng-if=\"!$ctrl.loadOnHoldShipments && $ctrl.onHoldShipmentList.length && $ctrl.model.stats === 'onHold'\" class=\"col-sm-12 div-margin-top remove-pad\">\n<div class=\"row_ table-responsive\">\n<table class=\"table table-bordered table-hover table-striped table-sortable text-align-center font-12\">\n<thead>\n<td style=\"width: 8%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('H','trackingId')\">\n{{ 'bagout.trackingId' | translate}}\n<i class=\"sort\" ng-class=\"$ctrl.getSortClass('trackingId')\"></i>\n</td>\n<td style=\"width: 10%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('H','orderNo')\">\n{{ 'common.orderId' | translate}}\n<i class=\"sort\" ng-class=\"$ctrl.getSortClass('orderNo')\"></i>\n</td>\n<td style=\"width: 8%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('H','orderType')\">\n{{ 'common.order_type' | translate}}\n<i class=\"sort\" ng-class=\"$ctrl.getSortClass('orderType')\"></i>\n</td>\n<td style=\"width: 8%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('H','amount')\">\n{{ 'branch_mgmt.amount' | translate}}\n<i class=\"sort\" ng-class=\"$ctrl.getSortClass('amount')\"></i>\n</td>\n<td style=\"width: 4%;\" class=\"pointer\">\n{{ 'common.denomination' | translate}}\n</td>\n<td style=\"width: 20%;\" class=\"pointer\">\n{{ 'common.to' | translate}}\n<i class=\"sort\" ng-class=\"$ctrl.getSortClass('toLocationId')\"></i>\n</td>\n<td style=\"width: 10%;\" class=\"pointer\" ng-click=\"$ctrl.sortCollection('H','defRouteSequence')\">\n{{ 'common.route' | translate}}\n<i class=\"sort\" ng-class=\"$ctrl.getSortClass('defRouteSequence')\"></i>\n</td>\n<td style=\"width: 10%;\">\n{{ 'branch_mgmt.route_date' | translate}}\n</td>\n<td>\n<b>{{'itemHolds.reason' | translate}}</b>\n</td>\n<td style=\"width: 10%;\">\n{{ 'common.action' | translate}}\n</td>\n</thead>\n<tbody>\n<tr ng-repeat=\"onHoldShipment in $ctrl.onHoldShipmentList | orderBy:$ctrl.getSortExpression():$ctrl.reverseSort track by $index\">\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(onHoldShipment.trackingId)\">\n{{onHoldShipment.trackingId}}\n</a>\n</td>\n<td>\n<a href=\"#\" ng-if=\"onHoldShipment.orderNo\" ng-click=\"$ctrl.redirectToOrderTab(onHoldShipment)\">{{ onHoldShipment.orderNo }}\n</a>\n<span ng-if=\"!onHoldShipment.orderNo\">{{'common.n_a' |translate}}</span>\n</td>\n<td>{{$ctrl.getOrderType(onHoldShipment)}} </td>\n<td>\n<b>{{ onHoldShipment.amount | currency:(onHoldShipment.symbol || $ctrl.currencySymbol):2 }}</b>\n</td>\n<td>\n<div class=\"denom-container\">\n<div ng-repeat=\"denom in onHoldShipment.denominations | orderBy:['sortOrder', 'faceValue']\" class=\"denom-badge\" ng-if=\"denom\">\n<denom-icon denom-id=\"denom.id\" icon-size=\"20\"> </denom-icon>\n<span class=\"denom-amount\">{{ denom.amount | currency:(denom.symbol || $ctrl.currencySymbol):2 }}</span>\n</div>\n</div>\n</td>\n<td class=\"text-left\" ng-if=\"onHoldShipment.toLocationId\">\n<span>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(onHoldShipment)\">\n{{onHoldShipment.toLocationId}}\n</a>\n</span>\n<span ng-if=\"onHoldShipment.toLocation\">| {{onHoldShipment.toLocation}}</span>\n<span class=\"text-left\" ng-if=\"!onHoldShipment.toLocation\">\n| {{'common.n_a' |translate}}\n</span>\n</td>\n<td class=\"contents-no-wrap\">\n<span>{{ onHoldShipment.routeId }}</span>\n<span ng-if=\"onHoldShipment.defRouteSequence >= 0\"> | <span class=\"order-pack-route-seq-color\">{{onHoldShipment.defRouteSequence}}</span></span>\n<span ng-if=\"onHoldShipment.defRouteSequence == null\" class=\"order-pack-route-seq-color\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{onHoldShipment.vaultDate | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td>{{onHoldShipment.reason}}</td>\n<td>\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.releaseItem(onHoldShipment)\">\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"{{'branch_mgmt.item_release_holds.title' | translate}}\" tooltip-placement=\"top\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loadOnHoldShipments && !$ctrl.onHoldShipmentList.length && $ctrl.model.stats === 'onHold'\">\n<div class=\"col-sm-12 alert alert-danger text-align-center div-margin-top\">\n{{'common.noRecords' | translate}}\n</div>\n</div>\n</div>\n";
var id1="order_packing.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2756 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\" style=\"text-align: center;\">\n<div class=\"text-align-center font-size-70 margin-top-40\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!$ctrl.loading\">\n<div id=\"print-section\" class=\"margin-top-02\" ng-if=\"!$ctrl.model.isPrePackPrint && !$ctrl.model.multiDenomPack && !$ctrl.model.depositShipmentLabelPrePack\" ng-repeat=\"data in $ctrl.model.shipmentDetails track by $index\">\n<div class=\"_barcode-center-align auto-adjust-page-css barcode-print-section\">\n<div>\n<div>\n<div class=\"margin-top-02 align-center-horizontally\">\n<img stream-print-logo style=\"height: 20px;\"><span class=\"print-company-title-section\">{{'bagout_print.fromLocationName' | translate}} | {{data.vaultDate}}</span>\n&nbsp;|&nbsp; <b> <span ng-if=\"data.fundingSource\">{{data.fundingSource}}</span>\n</b></div>\n</div>\n<div>\n<angular-barcode ng-model=\"data.trackingId\" class=\"order-packing-labels _barcode-page\" bc-options=\"$ctrl.model.barcodeOptions\" bc-class=\"barcode\" bc-type=\"svg\">\n</angular-barcode>\n</div>\n<div class=\"_border-top-01\">\n<div class=\"font-size-14\">\n<span>{{data.locationInfo.id}} | {{$ctrl.formatLocationAddress(data.locationInfo)}}</span>\n</div>\n<div class=\"font-size-14\">\n<span>{{data.orderNo}}, {{$ctrl.getOrderType(data)}}</span><span>, </span>\n<span><b>{{data.amount | currency:(data.symbol || $ctrl.currencySymbol):2}}</b></span><span>, </span>\n<span>{{data.denominationId}}, </span>\n<span>{{data.routeId}}</span>\n<span ng-if=\"data.defRouteSequence >= 0\"> | <b>{{data.defRouteSequence}}</b></span>\n<span ng-if=\"data.defRouteSequence == null\">{{'common.n_a' | translate}}</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n<div id=\"print-section\" class=\"margin-top-02\" ng-if=\"$ctrl.model.depositShipmentLabelPrePack && !$ctrl.model.isPrePackPrint && !$ctrl.model.multiDenomPack\" ng-repeat=\"data in $ctrl.model.shipmentDetails track by $index\">\n<div class=\"_barcode-center-align auto-adjust-page-css barcode-print-section\">\n<div>\n<div>\n<div class=\"margin-top-02 align-center-horizontally\">\n<img stream-print-logo style=\"height: 20px;\"><span class=\"print-company-title-section\">{{'bagout_print.fromLocationName' | translate}} | {{data.vaultDate}}</span>\n&nbsp;|&nbsp; <b> <span ng-if=\"data.fundingSource\">{{data.fundingSource}}</span> |&nbsp;</b> <span ng-if=\"data.totalDenomAmount > 0\"><b>Total: {{data.totalDenomAmount|currency:(data.symbol || $ctrl.currencySymbol):2}}</b></span>\n</div>\n</div>\n<div>\n<angular-barcode ng-model=\"data.trackingId\" class=\"order-packing-labels _barcode-page\" bc-options=\"$ctrl.model.barcodeOptions\" bc-class=\"barcode\" bc-type=\"svg\">\n</angular-barcode>\n</div>\n<div class=\"_border-top-01\">\n<div class=\"pre-print-location\" style=\"font: 16px monospace; margin-top: -7px;\">\n<span> <b>{{data.toLocationId}} | {{data.locationInfo.name}}</b></span>\n</div>\n<div class=\"font-size-14\">\n<span>{{$ctrl.formatLocationAddress(data.locationInfo)}}</span>\n</div>\n<div class=\"font-size-14\">\n<span><span ng-if=\"data.orderNo\">{{data.orderNo}}, </span>{{$ctrl.getOrderType(data)}}</span><span>, </span>\n<span ng-repeat=\"denomination in data.denominations\">\n<span><b>({{denomination.id}} - {{denomination.amount | currency:(denomination.symbol || $ctrl.currencySymbol):0}})</b>, </span>\n</span>\n<span>{{data.routeId}}</span>\n<span ng-if=\"data.defRouteSequence >= 0\"> | <b>{{data.defRouteSequence}}</b></span>\n<span ng-if=\"data.defRouteSequence == null\">{{'common.n_a' | translate}}</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n<div id=\"print-section\" class=\"margin-top-02\" ng-if=\"$ctrl.model.isPrePackPrint && !$ctrl.model.multiDenomPack\" ng-repeat=\"data in $ctrl.model.shipmentDetails track by $index\">\n<div class=\"_barcode-center-align auto-adjust-page-css barcode-print-section\">\n<div>\n<div>\n<div class=\"margin-top-02 align-center-horizontally\">\n<img stream-print-logo style=\"height: 20px;\"><span class=\"print-company-title-section\">{{'bagout_print.fromLocationName' | translate}} | {{data.vaultDate}}</span>\n&nbsp;|&nbsp; <b> <span ng-if=\"data.fundingSource\">{{data.fundingSource}}</span> |&nbsp;</b> <span ng-if=\"data.totalDenomAmount > 0\"><b>Total: {{data.totalDenomAmount|currency:(data.symbol || $ctrl.currencySymbol):2}}</b></span>\n</div>\n</div>\n<div>\n<angular-barcode ng-model=\"data.toLocationId\" class=\"order-packing-labels _barcode-page\" bc-options=\"$ctrl.model.barcodeOptions\" bc-class=\"barcode\" bc-type=\"svg\">\n</angular-barcode>\n</div>\n<div class=\"pre-print-location\" style=\"font: 16px monospace; margin-top: -7px;\">\n<span> <b>{{data.toLocationId}} | {{data.locationInfo.name}}</b></span>\n</div>\n<div>\n{{$ctrl.formatLocationAddress(data.locationInfo)}}\n</div>\n<div class=\"_border-top-01\">\n<div class=\"font-size-14\">\n<span>{{data.orderNo}}, {{$ctrl.getOrderType(data)}}</span><span>, </span>\n<span><b>{{data.amount | currency:(data.symbol || $ctrl.currencySymbol):0}}</b></span><span>, </span>\n<span>{{data.denominationId}}, </span>\n<span>{{data.routeId}}</span>\n<span ng-if=\"data.defRouteSequence >= 0\"> | <b>{{data.defRouteSequence}}</b></span>\n<span ng-if=\"data.defRouteSequence == null\">{{'common.n_a' | translate}}</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n<div id=\"print-section\" class=\"margin-top-02\" ng-if=\"$ctrl.model.isPrePackPrint && $ctrl.model.multiDenomPack\" ng-repeat=\"data in $ctrl.model.shipmentDetails track by $index\">\n<div class=\"_barcode-center-align auto-adjust-page-css barcode-print-section\">\n<div>\n<div>\n<div class=\"margin-top-02 align-center-horizontally\">\n<img stream-print-logo style=\"height: 20px;\"><span class=\"print-company-title-section\">{{'bagout_print.fromLocationName' | translate}} | {{data.vaultDate}}</span> &nbsp;|&nbsp; <b> <span ng-if=\"data.fundingSource\">{{data.fundingSource}}</span>\n|&nbsp;</b> <span ng-if=\"data.totalDenomAmount > 0\"><b>Total: {{data.totalDenomAmount|currency:(data.symbol || $ctrl.currencySymbol):2}}</b></span>\n</div>\n</div>\n<div>\n<angular-barcode ng-model=\"data.toLocationId\" class=\"order-packing-labels _barcode-page\" bc-options=\"$ctrl.model.barcodeOptions\" bc-class=\"barcode\" bc-type=\"svg\">\n</angular-barcode>\n</div>\n<div class=\"pre-print-location\" style=\"font: 16px monospace; margin-top: -7px;\">\n<span> <b>{{data.toLocationId}} | {{data.locationInfo.name}}</b></span>\n</div>\n<div>\n{{$ctrl.formatLocationAddress(data.locationInfo)}}\n</div>\n<div class=\"_border-top-01\">\n<div class=\"font-size-14\">\n<span>{{data.orderNo}}, {{$ctrl.getOrderType(data)}}</span><span>, </span>\n<span ng-repeat=\"denomination in data.denominations\">\n<span><b>({{denomination.id}} - {{denomination.amount | currency:(denomination.symbol || $ctrl.currencySymbol):0}})</b>, </span>\n</span>\n<span>{{data.routeId}}</span>\n<span ng-if=\"data.defRouteSequence >= 0\"> | <b>{{data.defRouteSequence}}</b></span>\n<span ng-if=\"data.defRouteSequence == null\">{{'common.n_a' | translate}}</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n<div id=\"print-section\" class=\"margin-top-02\" ng-if=\"!$ctrl.model.isPrePackPrint && $ctrl.model.multiDenomPack\" ng-repeat=\"data in $ctrl.model.shipmentDetails track by $index\">\n<div class=\"_barcode-center-align auto-adjust-page-css barcode-print-section\">\n<div>\n<div>\n<div class=\"margin-top-02 align-center-horizontally\">\n<img stream-print-logo style=\"height: 20px;\"><span class=\"print-company-title-section\">{{'bagout_print.fromLocationName' | translate}} | {{data.vaultDate}}</span> &nbsp;|&nbsp; <b> <span ng-if=\"data.fundingSource\">{{data.fundingSource}}</span>\n|&nbsp;</b> <span ng-if=\"data.totalDenomAmount > 0\"><b>Total: {{data.totalDenomAmount|currency:(data.symbol || $ctrl.currencySymbol):2}}</b></span>\n</div>\n</div>\n<div>\n<angular-barcode ng-model=\"data.trackingId\" class=\"order-packing-labels _barcode-page\" bc-options=\"$ctrl.model.barcodeOptions\" bc-class=\"barcode\" bc-type=\"svg\">\n</angular-barcode>\n</div>\n<div class=\"_border-top-01\">\n<div class=\"font-size-14\">\n<span>{{data.locationInfo.id}} | {{$ctrl.formatLocationAddress(data.locationInfo)}}</span>\n</div>\n<div class=\"font-size-14\">\n<span>{{data.orderNo}}, {{$ctrl.getOrderType(data)}}</span><span>, </span>\n<span ng-repeat=\"denomination in data.denominations\">\n<span><b>({{denomination.id}} - {{denomination.amount | currency:(denomination.symbol || $ctrl.currencySymbol):0}})</b>, </span>\n</span>\n<span>{{data.routeId}}</span>\n<span ng-if=\"data.defRouteSequence >= 0\"> | <b>{{data.defRouteSequence}}</b></span>\n<span ng-if=\"data.defRouteSequence == null\">{{'common.n_a' | translate}}</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n</div>\n</div>\n</div>\n<head>\n<style>\nsvg.barcode {\n            width: 100% !important;\n        }\n\n        @media print {\n            body {\n                visibility: visible;\n                width: 100% !important;\n            }\n\n            .auto-adjust-page-css {\n                width: 100% !important;\n                height: 100% !important;\n                margin: auto !important;\n            }\n\n            .barcode-center-align {\n                display: flex !important;\n                align-items: center !important;\n                justify-content: center !important;\n                margin: auto !important;\n                height: 100vh !important;\n            }\n        }\n</style>\n</head>\n";
var id1="print_barcodes.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2757 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"text-align-center font-size-70 margin-top-40\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-12 col-print-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-8 col-print-8 remove-left-pad service-history-print-title-section\">\n<div>\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<div class=\"margin-top-20 font-size-20\">\n<strong>Packed Orders</strong>\n<span>| {{'itemHolds.asOf' | translate}} {{$ctrl.vaultDate}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-repeat=\"account in $ctrl.accounts\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad font-size-16 print-margin-bottom-05 margin-bottom-05\" ng-if=\"$ctrl.model.results[account.value].length > 0\">\nAccount: <strong>{{account.label}}</strong>\n&nbsp;&nbsp; Total: <strong> {{account.label == 'Regular' ? $ctrl.regularOrdersTotal : $ctrl.emergencyOrdersTotal | currency:($ctrl.currencySymbol || '$')}} </strong>\n</div>\n<div id=\"print-section\" ng-if=\"$ctrl.model.results[account.value].length > 0\">\n<table class=\"table table-bordered table-condensed table-hover\">\n<thead>\n<tr class=\"remove-white-space\">\n<th ng-repeat=\"header in $ctrl.headers track by $index\">{{header}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"row in $ctrl.model.results[account.value] track by $index\" ng-class=\"{ 'remove-border-top': $ctrl.shouldRemoveBorder($index, account.value)}\">\n<td ng-repeat=\"header in $ctrl.headers track by $index\" ng-class=\"{'remove-border-top': $ctrl.shouldRemoveBorder($parent.$index, account.value)}\">\n<span ng-if=\"!($index == 1 && $ctrl.shouldRemoveBorder($parent.$index, account.value))\">\n<span class=\"align-center\" ng-if=\"$index == 5\">\n<img ng-src=\"assets/images/{{row[$index]}}.png\" class=\"img-currency\"/>\n</span>\n<span ng-hide=\"$index == 5\">{{row[$index]}}</span>\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"show-only-in-print\">\n<div class=\"signPosremove-left-pad remove-right-pad\">\n<span class=\"bagout-contents\">{{ \"bagout.userContent\" | translate }}</span>\n</div>\n<div class=\"col-print-12 col-sm-12 remove-left-pad remove-right-pad signPos bagout-contents margin-bottom- margin-top-10\" ng-repeat=\"user in $ctrl.users\">\n<div class=\"col-print-5 textPoss bagout-contents\">\n<span>{{user.label}}:</span>\n<span>{{ \"bagout.fullName\" | translate }}: <span>_______________________</span></span>\n</div>\n<div class=\"col-print-4 textPoss bagout-contents\">\n<span>|&nbsp;{{\"bagout.userSignature\" | translate}}: <span>_______________________</span></span>\n</div>\n<div class=\"col-print-3 textPoss bagout-contents\">\n<span>|&nbsp;{{\"bagout.cntDate\" | translate}}: <span>_______________________</span></span>\n</div>\n</div>\n</div>\n</div>\n";
var id1="print_packed_orders.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2758 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"print-packing-slip-container\">\n<div class=\"header-section\">\n<div class=\"title margin-top-20\">\n{{ 'printPackingSlip.title' | translate }}\n</div>\n<div class=\"logo-container\">\n<img stream-print-logo load-from-db=\"true\" class=\"margin-top-10 print-logo-height-65\">\n</div>\n<div class=\"order-no-container\"> {{ 'printPackingSlip.orderNo' | translate }}: {{$ctrl.orderNo}}</div>\n</div>\n<div class=\"route-info-section\" ng-if=\"$ctrl.model.shipmentData.length\">\n{{$ctrl.locationId}} | {{ $ctrl.routeId }} | {{ $ctrl.DateUtil.convetToBrowserTimezone($ctrl.shipmentPackedDate) }}\n</div>\n<div class=\"table-section\">\n<table class=\"table table-bordered\">\n<thead>\n<tr>\n<th class=\"blue-header\"> {{ 'printPackingSlip.toLocationId' | translate }}</th>\n<th class=\"blue-header\"> {{ 'printPackingSlip.shipType' | translate }}</th>\n<th class=\"blue-header\"> {{ 'printPackingSlip.trackingId' | translate }}</th>\n<th class=\"blue-header\"> {{ 'printPackingSlip.stc' | translate }}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"parent in $ctrl.parentTrackingIds\">\n<td> {{ $ctrl.model.shipmentData[0].toLocation.id }} | {{ $ctrl.model.shipmentData[0].toLocation.name }}\n</td>\n<td> {{ $ctrl.model.shipmentData[0].shiptypeId || 'N/A' }}</td>\n<td>{{ parent.trackingId }}</td>\n<td>\n<div ng-if=\"$ctrl.isSingleParentTracking\">\n<div ng-repeat=\"shipment in $ctrl.model.shipmentData\" class=\"margin-top-5\">\n<img ng-src=\"assets/images/{{ shipment.denomination.id }}.png\" class=\"denom-image\" alt=\"{{ shipment.denomination.name }}\" style=\"width:28px\"/><span ng-if=\"shipment.denomination.id\"> | </span>\n{{shipment.denomination.name}}\n<span ng-if=\"shipment.denominationId\"> | </span>\n{{ shipment.amount ? $ctrl.formatAmount(shipment.amount) : '' }}\n</div>\n</div>\n<div ng-if=\"!$ctrl.isSingleParentTracking\">\n<div ng-if=\"$ctrl.model.shipmentData[$index]\">\n{{ $ctrl.model.shipmentData[$index].denominationId }}\n<span ng-if=\"$ctrl.model.shipmentData[$index].denominationId\"> | </span>\n{{ $ctrl.model.shipmentData[$index].amount ? $ctrl.formatAmount($ctrl.model.shipmentData[$index].amount) : '' }}\n</div>\n</div>\n</td>\n</tr>\n<tr class=\"total-row\">\n<td colspan=\"3\" class=\"text-right\"> <strong> {{ 'printPackingSlip.total' | translate }} </strong>\n</td>\n<td> <strong> {{ $ctrl.formatAmount($ctrl.totalAmount) }} </strong></td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n";
var id1="print_packing_slip.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2759 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12 reporting-css-section\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-offset-4 col-sm-4 font-size-20 text-center\">\n<b>{{'liability.title' | translate}}</b>\n<hr class=\"margin-bottom-10\">\n</div>\n<div class=\"remove-pad col-sm-12\">\n<hr class=\"cash-variances-line-section\">\n</div>\n<div class=\"col-sm-12 cash-variances-search-section remove-left-pad remove-right-pad margin-10\">\n<div class=\"col-sm-3 remove-left-pad vault-operation-date-picker-w-23\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" ng-change=\"$ctrl.loadData();\" options=\"$ctrl.model.dateRangeOptions\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled': $ctrl.model.loadCountVariances}\"/>\n</div>\n<div class=\"col-sm-3 reporting-branch-dd remove-left-pad multi-select location-branch-dd\" ng-class=\"{'invalid-multi-select-value': !$ctrl.model.branch.length, 'valid-multi-select-value': $ctrl.model.branch.length}\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.model.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"\n                        $ctrl.resetData(); \n                        $ctrl.getRouteList(searchKey, offset); \n                        $ctrl.getTruckData(searchKey, offset); \n                        $ctrl.getMessangerData(searchKey, offset)\" on-select-all=\"\n                        $ctrl.resetData(); \n                        $ctrl.getRouteList(searchKey, offset); \n                        $ctrl.getTruckData(searchKey, offset); \n                        $ctrl.getMessangerData(searchKey, offset)\" on-select-none=\"\n                        $ctrl.resetData(); \n                        $ctrl.getRouteList(searchKey, offset); \n                        $ctrl.getTruckData(searchKey, offset); \n                        $ctrl.getMessangerData(searchKey, offset);\" on-reset=\"\n                        $ctrl.resetData(); \n                        $ctrl.getRouteList(searchKey, offset); \n                        $ctrl.getTruckData(searchKey, offset); \n                        $ctrl.getMessangerData(searchKey, offset);\" is-disabled=\"$ctrl.model.liabilityReportObj.loading\" selection-mode=\"single\">\n</div>\n<div class=\"col-sm-3 remove-left-pad\">\n<search-and-select ng-model=\"$ctrl.model.route\" values=\"$ctrl.model.routeListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.routeListObj.totalRecords\" on-click=\"$ctrl.loadData()\" onscroll=\"$ctrl.getRouteList(searchKey, offset);\" ng-disabled=\"!$ctrl.model.selectedBranch || $ctrl.model.routeListObj.loading\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div class=\"col-sm-3 remove-left-pad\">\n<search-and-select ng-model=\"$ctrl.model.truck\" values=\"$ctrl.model.truckListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.truckListObj.totalRecords\" on-click=\"$ctrl.loadData()\" onscroll=\"$ctrl.getTruckData(searchKey, offset)\" ng-disabled=\"!$ctrl.model.selectedBranch || $ctrl.model.truckListObj.loading\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div class=\"col-sm-3 remove-pad\">\n<search-and-select ng-model=\"$ctrl.model.messenger\" values=\"$ctrl.model.messengerListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.messengerListObj.messangerTotalRecord\" on-click=\"$ctrl.loadData()\" onscroll=\"$ctrl.getMessangerData(searchKey, offset)\" ng-disabled=\"!$ctrl.model.selectedBranch || $ctrl.model.messengerListObj.loading\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-validate remove-padding\" novalidate>\n<div class=\"col-sm-12 margin-10 remove-left-pad remove-right-pad\">\n<span class=\"col-sm-12 alert alert-danger text-align-center\">\n{{'route_sheet.no_data_found' | translate}}\n</span>\n</div>\n</div>\n</div>\n</form>";
var id1="liability.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2760 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-offset-4 col-sm-4 font-size-20 text-center\">\n<b>{{'on_hold.title' | translate}}</b>\n<hr class=\"margin-bottom-10\">\n</div>\n<div class=\"remove-pad col-sm-12\">\n<hr class=\"cash-variances-line-section\">\n</div>\n<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12 cash-variances-search-section remove-left-pad remove-right-pad margin-10\">\n<div class=\"col-sm-3 remove-left-pad\">\n<input ng-change=\"$ctrl.search()\" type=\"text\" ng-model-options=\"{debounce: 1000}\" search-autofocus placeholder=\"{{ 'branch_mgmt.tracking_Id' | translate }}\" class=\"form-control\" ng-model=\"$ctrl.model.searchText\" name=\"searchText\">\n</div>\n<div class=\"col-sm-3 remove-left-pad vault-operation-date-picker-w-23\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" ng-change=\"$ctrl.search();\" options=\"$ctrl.model.dateRangeOptions\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled': $ctrl.model.loadCountVariances}\"/>\n</div>\n<div class=\"col-sm-3 remove-left-pad\">\n<div class=\"multi-select location-branch-dd\" ng-class=\"{'invalid-multi-select-value': !$ctrl.model.branch.length, 'valid-multi-select-value':$ctrl.model.branch.length}\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.model.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"\n                            $ctrl.resetData(); \n                            $ctrl.getRouteList(searchKey, offset); \n                            $ctrl.loadSupervisors();\n                            $ctrl.search();\" on-select-all=\"\n                            $ctrl.resetData(); \n                            $ctrl.getRouteList(searchKey, offset); \n                            $ctrl.loadSupervisors();\n                            $ctrl.search();\" on-select-none=\"\n                            $ctrl.resetData(); \n                            $ctrl.getRouteList(searchKey, offset); \n                            $ctrl.loadSupervisors();\n                            $ctrl.search();\" on-reset=\"\n                            $ctrl.resetData(); \n                            $ctrl.getRouteList(searchKey, offset); \n                            $ctrl.loadSupervisors();\n                            $ctrl.search();\" s-disabled=\"$ctrl.model.onHoldReportObj.loading\">\n</div>\n</div>\n<div class=\"col-sm-3 remove-left-pad\">\n<search-and-select ng-model=\"$ctrl.model.routeId\" values=\"$ctrl.model.routeListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.routeListObj.totalRecords\" on-click=\"$ctrl.search()\" onscroll=\"$ctrl.getRouteList(searchKey, offset);\" ng-disabled=\"!$ctrl.model.selectedBranch || $ctrl.model.routeListObj.loading\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div class=\"col-sm-3 remove-left-pad\">\n<search-and-select ng-model=\"$ctrl.model.supvHoldId\" values=\"$ctrl.model.supervisorListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.supervisorListObj.totalRecords\" on-click=\"$ctrl.search()\" onscroll=\"$ctrl.loadSupervisors(searchKey, offset)\" ng-disabled=\"!$ctrl.model.selectedBranch || $ctrl.model.supervisorListObj.loading\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div class=\"pull-right\" ng-if=\"$ctrl.model.onHoldReportObj.results.length\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-right\" ng-click=\"$ctrl.exportToCSV()\" ng-disabled=\"$ctrl.model.onHoldReportObj.loading || $ctrl.model.isExporting\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExporting\"></span>\n{{'common.export' | translate}}</button>\n</div>\n</div>\n</form>\n</div>\n<div class=\"col-sm-12 form-validate remove-padding\" novalidate>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.onHoldReportObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 60px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding\" ng-if=\"!$ctrl.model.onHoldReportObj.loading && $ctrl.model.onHoldReportObj.results.length\">\n<div class=\"col-sm-12 remove-padding table-margin-top-10 table-responsive\">\n<table class=\"table-pad-3 table table-striped table-bordered\">\n<thead class=\"text-center\">\n<tr>\n<td class=\"remove-white-space\"><strong>{{'bagout.trackingId' | translate}}</strong></td>\n<td><strong>{{'users.branchId' | translate}}</strong></td>\n<td><strong>{{'common.vault_date' | translate}}</strong> </td>\n<td><strong>{{'bagout.amount' | translate}}</strong></td>\n<td class=\"remove-white-space\"><strong>{{'denomination.shiptype' | translate}}</strong></td>\n<td class=\"remove-white-space\"><strong>{{'branch_mgmt.orders_no' | translate}}</strong></td>\n<td class=\"remove-white-space\"><strong>{{'common.orderType' | translate}}</strong></td>\n<td><strong>{{'common.emergency' | translate}}</strong></td>\n<td><strong>{{'dashboard.routeId' | translate}}</strong></td>\n<td class=\"remove-white-space\"><strong>{{'checkout.fromLocationName' | translate}}</strong>\n</td>\n<td class=\"remove-white-space\"><strong>{{'checkout.ToLocationName' | translate}}</strong>\n</td>\n<td><strong>{{'common.reason' | translate}}</strong></td>\n<td><strong>{{'common.comment' | translate}}</strong></td>\n<td class=\"remove-white-space\"><strong>{{'itemHolds.verified_on' | translate}}</strong>\n</td>\n<td><strong>{{'verifyHoldShipments.supervisor' | translate}}</strong></td>\n</tr>\n</thead>\n<tbody class=\"text-align-center\">\n<tr ng-repeat=\"data in $ctrl.model.onHoldReportObj.results | orderBy : 'trackingId' track by $index\">\n<td><a href=\"#\" ng-click=\"$ctrl.goToItemHistory(data.trackingId)\">{{data.trackingId}}</a>\n</td>\n<td>{{data.branchId}}</td>\n<td class=\"remove-white-space\">{{data.vaultDate | date:'yyyy-MM-dd': 'UTC' }}</td>\n<td>{{data.amount}}</td>\n<td class=\"remove-white-space\">{{data.shiptypeDescription}}</td>\n<td class=\"remove-white-space\">{{data.orderNo}}\n<span ng-if=\"!data.orderNo\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"remove-white-space\">{{data.orderType}}\n<span ng-if=\"!data.orderType\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{data.isEc}}</td>\n<td class=\"remove-white-space\">{{data.routeId}}</td>\n<td class=\"remove-white-space\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.fromLocationId)\">{{data.fromLocationId}}</a>\n</td>\n<td class=\"remove-white-space\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.toLocationId)\">{{data.toLocationId}}</a>\n</td>\n<td>\n<div ng-if=\"data.reason\" class=\"glyphicon glyphicon-comment cursor-pointer\" uib-tooltip=\"{{data.reason}}\" tooltip-placement=\"top-right\">\n</div>\n<span ng-if=\"!data.reason\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<div ng-if=\"data.comments !== null && data.comments !== '' && data.comments !== ' '\" class=\"glyphicon glyphicon-comment cursor-pointer\" uib-tooltip=\"{{data.comments}}\" tooltip-placement=\"top-right\">\n</div>\n<span ng-if=\"data.comments === null || data.comments === '' || data.comments === ' '\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"remove-white-space\">{{data.verifiedOnVaultDate | date:'yyyy-MM-dd': 'UTC'}}\n<span ng-if=\"!data.verifiedOnVaultDate\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"remove-white-space\">{{data.supvHoldUserId }} | {{data.supvHoldUserName}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"remove-pad col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.onHoldReportObj.pagination.total > 10\">\n<ul uib-pagination total-items=\"$ctrl.model.onHoldReportObj.pagination.total\" ng-hide=\"{{($ctrl.model.onHoldReportObj.pagination.total<=$ctrl.model.onHoldReportObj.pagination.pageLimit)&&($ctrl.model.onHoldReportObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.onHoldReportObj.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div ng-if=\"!$ctrl.model.onHoldReportObj.loading && !$ctrl.model.onHoldReportObj.results.length\" class=\"margin-top-20\">\n<span class=\"col-sm-12 matgin-top-20 alert alert-danger text-align-center\">\n{{'common.noDataFound' | translate}}\n</span>\n</div>\n</div>\n</div>";
var id1="on_hold.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2761 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-offset-4 col-sm-4 font-size-20 text-center\">\n<b>{{'route_performance.title' | translate}}</b>\n<hr class=\"margin-bottom-10\">\n</div>\n<div class=\"remove-pad col-sm-12\">\n<hr class=\"cash-variances-line-section\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"text-center alert alert-danger margin-top-05\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</form>";
var id1="route_performance.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2762 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<ul class=\"nav nav-tabs hide-in-print\">\n<li ng-repeat=\"tab in $ctrl.tabs\" role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"{{tab.state}}\" ng-show=\"::$ctrl.hasAcl(tab.key)\">\n<a class=\"branch-mgmt-badge\">\n{{tab.title | translate}}\n</a>\n</li>\n</ul>\n<div class=\"remove-pad\">\n<div class=\"mt-20\">\n<ui-view></ui-view>\n</div>\n</div>\n</div>";
var id1="reporting.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2763 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"w-100\">\n<h4 translate=\"\">{{'resetAtmCode.all_atm_codes' | translate}}</h4>\n<hr/>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"_form-group col-sm-6\">\n<label for=\"resetAtmCode\">{{'resetAtmCode.route' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.route\" values=\"$ctrl.routeList\" key=\"Key\" totalrecords=\"$ctrl.totalRecord\" on-click=\"$ctrl.getAtmCodeFromRedis()\" onscroll=\"$ctrl.loadRoutes(searchKey, offset)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"atmcode\">{{'resetAtmCode.date' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" ng-class=\"{'required-datetimepicker': !$ctrl.model.date}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" ng-click=\"$ctrl.getAtmCodeFromRedis()\"/>\n</div>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12\">\n<table class=\"table table-hover table-bordered table-pad-7 font-12\" ng-if=\"$ctrl.model.allAtmCodes.length && !$ctrl.model.loading\">\n<thead>\n<tr>\n<td class=\"text-center\">\n<b>#</b>\n</td>\n<td class=\"text-center\">\n<b>{{'resetAtmCode.key' | translate}}</b>\n</td>\n<td class=\"text-center\">\n<b>{{'resetAtmCode.value' | translate}}</b>\n</td>\n<td></td>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"data in $ctrl.model.allAtmCodes track by $index\">\n<td>{{$index + 1}}</td>\n<td>{{data}}</td>\n<td class=\"info-btn-width\"><button class=\"btn btn-success\" ng-click=\"$ctrl.getAtmCode(data)\">\n<i class=\"glyphicon glyphicon-info-sign\"></i> {{'resetAtmCode.get_value' | translate}}\n</button>\n</td>\n<td class=\"text-center delete-btn-width\">\n<button class=\"btn btn-danger\" ng-click=\"$ctrl.confirmDelete(data)\" ng-disabled=\"$ctrl.model.isDeleting\">\n<i class=\"glyphicon glyphicon-trash\"></i>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!$ctrl.model.allAtmCodes.length && !$ctrl.model.loading\">\n<div class=\"col-sm-12 alert text-center alert-danger\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</form>\n</div>";
var id1="reset_atm_code.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2764 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"reset-atm-code.all\" ng-click=\"$ctrl.goToAll()\"><a>{{'resetAtmCode.menu.all' | translate}}</a></li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="reset_atm_code.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<!DOCTYPE html>\n<html>\n<head>\n<style>\n.w-2 {\n\t\t\twidth: 2%;\n\t\t\ttext-align: center;\n\t\t}\n\n\t\t.w-13 {\n\t\t\twidth: 13%;\n\t\t}\n\n\t\t.w-10 {\n\t\t\twidth: 11%;\n\t\t}\n\n\t\t.mt-5 {\n\t\t\tmargin-top: 5px;\n\t\t}\n\n\t\t.w-25 {\n\t\t\twidth: 25%\n\t\t}\n\n\t\t.remove-pad-1 {\n\t\t\tmargin: 0 !important;\n\t\t\tpadding-top: 0px;\n\t\t\tpadding-left: 0px;\n\t\t\tpadding-right: 0;\n\t\t\tpadding-bottom: 0;\n\t\t}\n\n\t\t.v-align {\n\t\t\tvertical-align: top !important;\n\t\t}\n\n\t\t.coin_shipment {\n\t\t\tfloat: right;\n\t\t}\n</style>\n</head>\n<div ng-if=\"$ctrl.routeSheet.length > 0\">\n<body>\n<table class=\"table\" style=\"width: 100%;border: 1px solid #ccc;\">\n<tr>\n<td style=\"width: 8%;\">\n<img stream-print-logo style=\"float: left; height: 60px;\">\n</td>\n<td style=\"width: 40%;\">\n<h4 style=\"margin-top: 5px;\">{{$ctrl.model.route.name}}</h4>\n<p>{{ $ctrl.branchName }}, {{$ctrl.model.date | date: 'EEEE, MM/dd/yyyy'}} | Start Time: 7:00 AM</p>\n</td>\n<td style=\"padding-left: 0;\">\n<angular-barcode ng-model=\"$ctrl.model.barcodeId\" bc-options=\"$ctrl.barcodeOptions\" bc-class=\"barcode\" bc-type=\"image\" style=\"height: 50px;\"></angular-barcode>\n</td>\n<td> <img src=\"" + __webpack_require__(258) + "\" class=\"custom-icon\" style=\"width: 30px\">\n<h4 style=\"display: inline;\"> {{$ctrl.routeSheet.length}}</h4>\n</td>\n<td><img src=\"" + __webpack_require__(177) + "\" class=\"custom-icon\" style=\"width: 30px\">\n<h4 style=\"display: inline;\"> {{$ctrl.totalBags}}</h4>\n</td>\n<td><img src=\"" + __webpack_require__(251) + "\" class=\"custom-icon\" style=\"width: 30px\">\n<h4 style=\"display: inline;\">{{$ctrl.totalKeys}}</h4>\n</td>\n</tr>\n</table>\n<table class=\"table\" style=\"margin-top: -20px;border-left: 1px solid #ccc;border-right: 1px solid #ccc;\">\n<tr style=\"border-top:1px solid #ccc;\">\n<td>{{ 'route.branchId' | translate }}: <span ng-if=\"$ctrl.branchId\">{{ $ctrl.branchId }}</span> <span ng-if=\"!$ctrl.branchId\">{{ 'common.n_a' | translate }}</span></td>\n<td>{{ 'routeSheet.driver' | translate }}: <span ng-if=\"$ctrl.driverId\">{{ $ctrl.driverId }}</span>\n<span ng-if=\"!$ctrl.driverId\">{{ 'common.n_a' | translate }}</span></td>\n<td>{{ 'routeSheet.messenger' | translate }}: <span ng-if=\"$ctrl.messengerId\">{{ $ctrl.messengerId }}</span> <span ng-if=\"!$ctrl.messengerId\">{{ 'common.n_a' | translate }}</span></td>\n<td>{{ 'routeSheet.guard' | translate }}: <span ng-if=\"$ctrl.guardId\">{{ $ctrl.guardId }}</span> <span ng-if=\"!$ctrl.guardId\">{{ 'common.n_a' | translate }}</span></td>\n<td colspan=\"2\">{{ 'branch_mgmt.route_truck' | translate }}: <span ng-if=\"$ctrl.vehicleId\">{{ $ctrl.vehicleId }}</span>\n<span ng-if=\"!$ctrl.vehicleId\">{{ 'common.n_a' | translate }}</span></td>\n</tr>\n</table>\n<table class=\"table table-bordered table-pad-4\" style=\"margin-top: -20px;width:100%;\">\n<tr ng-repeat=\"detail in $ctrl.routeSheet track by $index\" ng-class=\"{'future-location-changes-bg-color': detail.status === 'scheduled'}\">\n<td class=\"w-2\">{{detail.seq}}</td>\n<td class=\"remove-pad-1 v-align\">\n<div class=\"col-lg-12 col-md-12 col-sm-12 remove-pad-1\">\n<div class=\"title col-print-8 col-lg-8 col-md-8 col-sm-8 remove-pad-1\">\n<div style=\"font-weight: bold\">\n{{detail.name}} | {{detail.locationId}}\n<img ng-show=\"detail.locationType == 'REGULAR'\" alt=\"REGULAR\" src=\"" + __webpack_require__(256) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'ATM'\" alt=\"ATM\" src=\"" + __webpack_require__(244) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'BANK'\" alt=\"BANK\" src=\"" + __webpack_require__(245) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'NO_SHIP_NO_GO'\" alt=\"NO_SHIP_NO_GO\" src=\"" + __webpack_require__(254) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'INTERNAL'\" alt=\"INTERNAL\" src=\"" + __webpack_require__(250) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'TRUCK'\" alt=\"TRUCK\" src=\"" + __webpack_require__(260) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'TANKER'\" alt=\"TANKER\" src=\"" + __webpack_require__(259) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'WINDOW'\" alt=\"WINDOW\" src=\"" + __webpack_require__(262) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'CARRIER'\" alt=\"CARRIER\" src=\"" + __webpack_require__(246) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'ON_CALL'\" alt=\"ON CALL\" src=\"" + __webpack_require__(255) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'LOCKER'\" alt=\"LOCKER\" src=\"" + __webpack_require__(252) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'DELIVERY'\" alt=\"DELIVERY\" src=\"" + __webpack_require__(248) + "\" height=\"20\" width=\"20\"/>\n<img ng-show=\"detail.locationType == 'VAULT'\" alt=\"VAULT\" src=\"" + __webpack_require__(261) + "\" height=\"20\" width=\"20\"/>\n</div>\n<span ng-if=\"detail.status !== 'scheduled'\">{{detail.address}}, {{detail.city}}, {{detail.state}}, {{detail.zip}}</span>\n<span ng-if=\"detail.status === 'scheduled'\">{{detail.address}}</span>\n</div>\n<div class=\"amt-box col-print-4 col-lg-4 col-md-4 col-sm-4 remove-pad-1\" style=\"float: right; text-align: right;\">\n<img src=\"" + __webpack_require__(251) + "\" class=\"custom-icon\" style=\"width: 20px\" ng-if=\"detail.keyNum\"/>\n<strong ng-if=\"detail.keyNum\">{{detail.keyNum}}</strong>\n<img src=\"" + __webpack_require__(177) + "\" class=\"custom-icon\" style=\"width: 20px\" ng-if=\"detail.status !== 'scheduled'\"/>\n<strong>{{detail.totalCashShipments}}</strong>\n<strong ng-show=\"detail.totalCash\"> | {{detail.totalCash | currency:fractionSize:0}}</strong>\n</div>\n</div>\n<div class=\"col-lg-12 col-print-12 remove-pad-1\">\n<div style=\"margin-top: 1% !important;\">\n<span ng-if=\"detail.openTime\">{{'routeSheet.open' | translate}} | {{$ctrl.DateUtil.convertTime(detail.openTime, true)}}</span>\n<span ng-if=\"detail.closeTime\">- {{'routeSheet.close' | translate}} | {{$ctrl.DateUtil.convertTime(detail.closeTime, true)}}</span>\n</div>\n<div class=\"remove-pad-1 col-lg-6 col-md-6 col-sm-6 col-print-6\" style=\"text-align: right; text-align: left; margin-top: 1% !important;\" ng-if=\"detail.comments\">\n<div style=\"border: 1px solid lightgray;\"><span style=\"bottom: 0; left: 0; padding: 5px;\">{{detail.comments}}</span></div>\n</div>\n<div class=\"coin_shipment\">\n<div style=\"text-align: center; float: left; padding: 5px;\" class=\"coin_img_text\">\n<div class=\"coin_img_circle\" style=\"display: inline-block; margin-right: 10px;\" ng-repeat=\"coinKey in detail.sortedCoinsOrder track by $index\">\n<img ng-if=\"coinKey !== 'M'\" ng-src=\"../../../assets/images/{{coinKey}}.png\" width=\"20\" style=\"display: block; margin: auto;\">\n<img ng-if=\"coinKey === 'M'\" src=\"" + __webpack_require__(403) + "\" width=\"20\" style=\"display: block; margin: auto;\">\n<span>{{detail.totals[coinKey].qty}}</span>\n</div>\n</div>\n<div class=\"coin-total\" style=\"float: left; text-align: right; margin-top: 5px;\">\n<strong ng-show=\"detail.totalCoin\" style=\"padding: 3px;\">| {{detail.totalCoin | currency:'$':2}}</strong>\n</div>\n</div>\n</div>\n</td>\n<td class=\"w-25 v-align\">\n<div class=\"shipment-track-data col-print-12 col-lg-12 col-md-12 remove-pad-1\">\n<div>\n<div ng-repeat=\"trackingIds in detail.bagStack track by $index\" ng-class=\"{'trackingId-border' : trackingIds.length > 1}\" class=\"shipment-data\" style=\"float: left; margin-bottom: 4px;margin-left: 1px; margin-right: 2px; padding-left: 2px; padding-right: 2px\">\n<div ng-repeat=\"trackingId in trackingIds track by $index\">\n{{trackingId}}\n</div>\n</div>\n</div>\n</div>\n</td>\n<td class=\"w-10\">\n<div ng-if=\"detail.status !== 'scheduled'\" class=\"col-lg-12 col-md-12 remove-pad-1\" style=\"border-bottom: 1px solid #ccc;\">\n<span>{{'routeSheet.start' | translate}}: </span>\n</div>\n<div ng-if=\"detail.status !== 'scheduled'\" class=\"col-lg-12 col-md-12 remove-pad-1\">\n<span>{{'routeSheet.end' | translate}}: </span>\n</div>\n</td>\n<td class=\"w-10 v-align\" style=\"margin: 0;padding: 0;\">\n<span ng-if=\"detail.status !== 'scheduled'\">{{'routeSheet.total' | translate}}: </span>\n</td>\n</tr>\n</table>\n</body>\n</div>\n<div ng-if=\"$ctrl.noDataFound && !$ctrl.routeSheet.length && !$ctrl.loading\">\n<div class=\"alert margin-top-20\" ng-class=\"{'alert-danger': !$ctrl.routeSheet.length}\" style=\"text-align: center; width:100%\">\n<span>{{'route_sheet.no_shipment_packed' | translate}}</span>\n</div>\n</div>\n</html>\n";
var id1="print.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2766 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\">\n<div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"align-center-vertically hide-in-print\">\n<div id=\"inline\" class=\"_form-group\">\n<label for=\"contact\">{{'routeSheet.route' | translate }} *</label>\n</div>\n<div id=\"inline\" class=\"_form-group padding-left-5 ui-select-container col-sm-3 form-validate\">\n<search-and-select ng-model=\"$ctrl.model.route\" values=\"$ctrl.routeList\" key=\"Key\" totalrecords=\"$ctrl.totalRecord\" onscroll=\"$ctrl.getRouteData(searchKey, offset)\" on-click=\"$ctrl.show()\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div id=\"inline\" class=\"_form-group padding-left-10\">\n<label for=\"\">{{'routeSheet.date' | translate }} </label>\n</div>\n<div id=\"inline\" class=\"_form-group padding-left-5 form-validate col-sm-3\">\n<datetimepicker required=\"true\" ng-class=\"{'disabled': !$ctrl.model.route}\" class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" ng-click=\"$ctrl.show()\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div id=\"inline\" class=\"_form-group padding-left-10\">\n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.show()\" ng-disabled=\"$ctrl.loading\" ng-class=\"{'disabled': !$ctrl.model.route || !$ctrl.model.date || $ctrl.loading }\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>{{'routeSheet.show'|translate}}\n</button>\n</div>\n<div style=\"margin-left: auto;\" class=\"display-flex\" ng-if=\"$ctrl.model.route\">\n<div ng-if=\"$ctrl.routeSheet.length > 0\" class=\"_form-group align-center-vertically\">\n<span>\n<b>{{'routeSheet.print' | translate }}&nbsp;</b>\n</span>\n</div>\n<div ng-if=\"$ctrl.routeSheet.length > 0\" id=\"inline\" class=\"_form-group margin-right-10\">\n<select ng-change=\"$ctrl.filterData()\" class=\"form-control\" ng-model=\"$ctrl.printSeq\" ng-options=\"route.seq as route.seq for route in $ctrl.fullRouteSheet\" style=\"width: 80px\">\n<option value=\"\">{{'common.All' | translate}}</option>\n</select>\n</div>\n<div ng-if=\"$ctrl.routeSheet.length > 0\" id=\"inline\" class=\"_form-group\">\n<button class=\"form-control glyphicon glyphicon-print\" target=\"_blank\" ng-click=\"$ctrl.print()\" aria-hidden=\"true\"></button>\n</div>\n</div>\n</div>\n<span ng-if=\"$ctrl.model.route\">\n<ng-include src=\"'print.html'\">\n</ng-include>\n</span>\n</div>\n</div>\n</div>\n</div>";
var id1="routeSheet.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\" style=\"text-align: center;\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-repeat=\"data in $ctrl.printData track by $index\" ng-if=\"!$ctrl.loading && $ctrl.printData.length > 0\">\n<div>\n<div class=\"align-center-horizontally\">\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<h4>{{ 'shipmentBatch.manifestAll' | translate }}</h4>\n<div id=\"print-section\">\n<div class=\"remove-left-pad remove-right-pad col-sm-12 text-align-left margin-top-40\">\n<div class=\"col-sm-7 col-print-7 remove-left-pad\">\n<div>{{ 'shipmentBatch.fromLocation' | translate}}:</div>\n<div>\n<h3 class=\"margin-zero\">\n<strong>{{'bagout_print.fromLocationName' | translate}}</strong>\n</h3>\n</div>\n<div>\n<h4>{{'bagout_print.fromLocationAddress' | translate}}</h4>\n</div>\n</div>\n<div class=\"col-sm-5 col-print-5 remove-right-pad\">\n<div class=\"margin-zero text-align-left\">\n{{'shipmentBatch.toLocation' | translate}}:\n</div>\n<div>\n<h3 class=\"margin-zero\">\n<div>\n<strong>{{data.info[0].name }} </strong>\n<span>| {{data.info[0].toLocationId}}</span>\n</div>\n</h3>\n<div class=\"margin-zero\">\n<h4>\n{{data.info[0].toLocationAddress}}\n</h4>\n</div>\n</div>\n</div>\n</div>\n<div class=\"hide-in-print\">\n<br><br><br>\n</div>\n<div class=\"remove-left-pad col-sm-12 col-print-12 text-align-left margin-top-20 print-margin-bottom-20\">\n<div class=\"col-sm-9 col-print-9 shipment-info remove-left-pad\">\n<strong>\n{{ 'shipmentBatch.route' | translate }}:\n</strong>\n<span>{{ data.info[0].routeIds }}</span>\n<strong class=\"margin-left-10\">\n{{ 'shipmentBatch.totalBags' | translate }}:\n</strong>\n<span>{{ data.info[0].totalCashShipment }}</span>\n<strong class=\"margin-left-10\">\n{{ 'shipmentBatch.totalCoin' | translate }}:\n</strong>\n<span>{{ data.info[0].totalCoinShipment }}</span>\n<strong class=\"margin-left-10\">\n{{ 'shipmentBatch.totalAmount' | translate}}:\n</strong>\n<span>{{ data.info[0].amount | currency: '$'}}</span>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-20 remove-left-pad remove-right-pad\">\n<table class=\"table table-striped table-bordered\">\n<thead class=\"header-row\">\n<tr>\n<td>\n<strong>#</strong>\n</td>\n<td>\n<strong>{{ 'shipmentBatch.tracking_id' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'closeVault.vault_date' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'shipmentBatch.deliveryDate' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.fromLocationName' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.ToLocationName' | translate }}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.transactionType' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.amount' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.verify' | translate}}</strong>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in data.shipments\">\n<td>{{$index+1}}</td>\n<td>{{shipment.trackingId}}\n<span ng-if=\"shipment.coinFlag\"> | {{shipment.qty}}</span>\n<span ng-if=\"shipment.holdFlag\">\n| <img src=\"" + __webpack_require__(80) + "\" class=\"hold-icon-size\">\n</span>\n</td>\n<td>{{shipment.vaultDate | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td>{{shipment.deliveryDate | date:'yyyy-MM-dd | hh:mm a'}}</td>\n<td>{{shipment.fromLocation}}</td>\n<td>{{shipment.toLocation}}</td>\n<td>{{shipment.shiptypeId}}</td>\n<td>{{shipment.amount | currency:'$'}}</td>\n<td></td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"checkout-verify\">\n<div class=\"manifest-content margin-top-40 remove-print-margin margin-bottom-50\">\n<div>\n<span class=\"text-align-left lineColor print-margin-bottom-20\">_________________________________________</span>\n<h4 class=\"text-align-center\">{{'branch_mgmt.route_messenger' | translate}}</h4>\n</div>\n<div class=\"margin-top-30\">\n<span class=\"text-align-left lineColor\">_________________________________________</span>\n<h4 class=\"text-align-center\">{{'checkin.customer' | translate}}</h4>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 margin-top-20\" ng-if=\"$ctrl.printData.length == 0 && !$ctrl.loading\">\n<div class=\"col-sm-12 alert text-center alert-danger\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n</div>";
var id1="delivery_manifest_all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2768 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\" style=\"text-align: center;\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.loading && $ctrl.printData.length > 0\">\n<div class=\"align-center-horizontally\">\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<h4>{{ 'shipmentBatch.delivery_manifest_combined' | translate }}</h4>\n<div id=\"print-section\" class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"remove-left-pad remove-right-pad col-sm-12\">\n<div class=\"remove-left-pad remove-right-pad col-sm-12 col-print-12 text-align-left margin-top-20 print-margin-bottom-20\">\n<div class=\"col-sm-9 col-print-9 shipment-info remove-left-pad remove-right-pad\">\n<strong> {{ 'shipmentBatch.route' | translate }}:</strong>\n<span>{{$ctrl.routeId}}</span>\n<strong class=\"margin-left-10\">{{'shipmentBatch.totalBags' | translate}}:</strong>\n<span>{{ $ctrl.totalCashShipment }}</span>\n<strong class=\"margin-left-10\">{{'shipmentBatch.totalCoin' | translate}}:</strong>\n<span>{{ $ctrl.coinShipmentQty }}</span>\n<strong class=\"margin-left-10\">{{'bulkCash.totalAmount' | translate}}:</strong>\n<span>{{$ctrl.total.totalAmount | currency:'$'}}</span>\n</div>\n<div class=\"col-sm-3 col-print-3 pull-right remove-right-pad text-right\">\n<strong>{{'closeVault.vault_date' | translate}}:</strong>\n<span>{{$ctrl.vaultDate}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-10 remove-left-pad remove-right-pad\">\n<table class=\"table table-striped table-bordered\">\n<thead class=\"header-row\">\n<tr>\n<td><strong>#</strong></td>\n<td><strong>{{'shipmentBatch.tracking_id' | translate}}</strong></td>\n<td><strong>{{'checkout.fromLocationName' | translate}}</strong></td>\n<td><strong>{{'checkout.ToLocationName' | translate}}</strong></td>\n<td><strong>{{'checkout.amount' | translate}}</strong></td>\n<td><strong>{{'denomination.shiptype' | translate}}</strong></td>\n<td><strong>{{'common.status' | translate}}</strong></td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in $ctrl.printData\">\n<td>{{$index + 1}}</td>\n<td>{{shipment.trackingId}}\n<span ng-if=\"shipment.coinFlag\"> | {{shipment.qty}}</span>\n</td>\n<td>\n<img ng-src=\"assets/images/{{$ctrl.loadLocationTypeIcon(shipment.fromLocationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{shipment.fromLocationType}}\"/>\n{{shipment.fromLocation}}\n</td>\n<td>\n<img ng-src=\"assets/images/{{$ctrl.loadLocationTypeIcon(shipment.toLocationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{shipment.toLocationType}}\"/>\n{{shipment.ToLocation}}\n</td>\n<td>{{shipment.amount | currency:'$'}}</td>\n<td>{{shipment.shiptypeId}}</td>\n<td>{{$ctrl.translateStatus(shipment.status)}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 margin-top-20\" ng-if=\"$ctrl.printData.length == 0 && !$ctrl.loading\">\n<div class=\"col-sm-12 alert text-center alert-danger\">\n{{'common.noDataFound' | translate}}\n</div>\n</div>\n</div>\n</div>";
var id1="delivery_manifest_combined.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<div class=\"route-settings-popover\">\n        <div class=\"row\">\n            <div class=\"col-xs-6 text-center remove-pad border-right\">\n                <div class=\"setting-label\"><i class=\"glyphicon glyphicon-time\"></i> Max Route Time</div>\n                <div class=\"setting-value text-primary\"><strong>{{!route.maxRouteTime ? \"N/A\" : route.maxRouteTime || \"N/A\"}}</strong></div>\n            </div>\n            <div class=\"col-xs-6 text-center remove-pad\">\n                <div class=\"setting-label\"><i class=\"glyphicon glyphicon-cutlery\"></i> Lunch (Minutes)</div>\n                <div class=\"setting-value text-primary\"><strong>{{!route.lunchMinutes ? \"N/A\" : route.lunchMinutes.substring(3) || 'N/A'}}</strong></div>\n            </div>\n        </div>\n        <div class=\"row border-top margin-top-5 padding-top-5\">\n            <div class=\"col-xs-6 text-center remove-pad border-right\">\n                <div class=\"setting-label\"><i class=\"glyphicon glyphicon-hourglass\"></i> Break (Minutes)</div>\n                <div class=\"setting-value text-primary\"><strong>{{!route.breakMinutes ? \"N/A\" : route.breakMinutes.substring(3) || 'N/A'}}</strong></div>\n            </div>\n            <div class=\"col-xs-6 text-center remove-pad\">\n                <div class=\"setting-label\"><i class=\"glyphicon glyphicon-dashboard\"></i> Est. Route Speed</div>\n                <div class=\"setting-value text-primary\"><strong>{{!route.estimatedRouteSpeed ? \"N/A\" : route.estimatedRouteSpeed + ' ' + 'mph' || 'N/A'}}</strong></div>\n            </div>\n        </div>\n    </div>\n";
var id1="routeSettingsPopover.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
var v2="<div>\n<div class=\"form-row\">\n<div class=\"col-sm-12 remove-pad align-center-vertically\">\n<div class=\"col-sm-12 remove-left-pad margin-bottom-10\" ng-if=\"$ctrl.allRoutes && $ctrl.allRoutes.length\">\n<button class=\"btn btn-warning margin-bottom-5\" ng-click=\"$ctrl.releaseRoutes()\" ng-disabled=\"$ctrl.releasingRoutes || $ctrl.isPreviousVaultDate\">\n{{'routeControl.release'|translate }}\n</button>\n<button class=\"btn btn-success margin-bottom-5\" ng-click=\"$ctrl.printSheets()\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{'routeControl.printRoute'|translate }}\n</button>\n<button class=\"btn btn-success margin-bottom-5\" ng-click=\"$ctrl.printCoins()\">\n<span class=\"glyphicon glyphicon-print\"></span>\n{{'routeControl.printCoin'|translate }}\n</button>\n<button ng-show=\"::$ctrl.hasPermission['stopTransfer']\" ng-disabled=\"($ctrl.selectedRouteArr.length == 0 || $ctrl.selectedRouteArr.length > 2 || $ctrl.isPreviousVaultDate || $ctrl.isRouteCheckedIn)\" class=\"btn btn-success margin-bottom-5\" ng-click=\"$ctrl.stopTransferView(false)\">\n{{'routeControl.stop_transfer'|translate }}\n</button>\n<button ng-show=\"::$ctrl.hasPermission['adHocCheckin']\" class=\"btn btn-warning margin-bottom-5\" ng-disabled=\"$ctrl.isPreviousVaultDate\" ng-click=\"$ctrl.openAdHocCheckinModal()\">\n{{'routeControl.adHocCheckin'|translate }}\n</button>\n<span class=\"form-group form-checbox\">\n<input type=\"checkbox\" name=\"fancy-checkbox-default\" ng-click=\"$ctrl.showCheckedInRoutes($event)\" ng-model=\"$ctrl.model.checkedInRoute\" id=\"fancy-checkbox-default\" autocomplete=\"off\"/>\n<div class=\"btn-group btn-checkbox-group margin-bottom-5\">\n<label for=\"fancy-checkbox-default\" class=\"btn btn-default\">\n<span class=\"glyphicon glyphicon-ok\"></span>\n<span> </span>\n</label>\n<label for=\"fancy-checkbox-default\" class=\"btn btn-primary\">\n{{'routeControl.checkedInRoutes' | translate}}\n</label>\n</div>\n</span>\n</div>\n<div class=\"form-group margin-top-5\" ng-class=\"{'col-sm-5 col-sm-offset-7': !$ctrl.allRoutes.length}\" ng-if=\"!$ctrl.model.loading\">\n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.redirectToItemHold()\">\n{{'routeControl.onhold' | translate}}\n<i class=\"glyphicon\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t'glyphicon-refresh fast-right-spinner': $ctrl.model.loading,\n\t\t\t\t\t}\"></i>\n<span class=\"badge error-button-badge\">{{$ctrl.holdCount}}</span>\n</button>\n</div>\n<div ng-class=\"{'col-sm-5 remove-right-pad': $ctrl.allRoutes && $ctrl.allRoutes.length, 'col-sm-12': !$ctrl.allRoutes || !$ctrl.allRoutes.length}\">\n<div class=\"pull-right display-flex\">\n<div class=\"form-group form-validate margin-right-10\">\n<label for=\"route-date\">{{'routeControl.routeDate'|translate }}</label>\n<br>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" ng-click=\"$ctrl.loadRoutes(); $ctrl.clear()\" ng-class=\"{'required-datetimepicker': !$ctrl.model.date, 'disabled': $ctrl.loading}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"form-group\">\n<button class=\"btn btn-success margin-top-25\" ng-class=\"{'disabled': !$ctrl.model.date || $ctrl.loading }\" ng-click=\"$ctrl.loadRoutes(); $ctrl.clear()\">\n{{'routeControl.getRoutes'|translate}}\n</button>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"_table-responsive col-sm-12 remove-pad\">\n<table class=\"table table-hover table-bordered table-pad-4\" ng-if=\"!$ctrl.loading && $ctrl.routes && $ctrl.routes.length\">\n<tr class=\"header-row\">\n<td ng-click=\"$ctrl.toggleAllRouteSelection()\" align=\"center\" class=\"cursor-pointer v-align-top\" style=\"padding-top: 8px !important;\">\n<span>\n<b>{{'routeControl.all'|translate }}</b>\n</span>\n</td>\n<th>{{'routeControl.route'|translate }}</th>\n<th>{{'routeControl.stops'|translate }}</th>\n<th>{{'routeControl.shipments'|translate }}</th>\n<th>{{'routeControl.totalCashCoin'|translate }}</th>\n<th>{{'routeControl.controls'|translate }}</th>\n<th class=\"routeControl-lastReleased-width\">{{'routeControl.route_status'|translate }}</th>\n</tr>\n<tr ng-repeat=\"route in $ctrl.routes\" ng-class=\"{'active': route.isSelected}\">\n<td align=\"center\">\n<input type=\"checkbox\" ng-click=\"$ctrl.selectedRoute($event, route)\" ng-model=\"route.isSelected\">\n</td>\n<td>\n<a href=\"\" ng-click=\"$ctrl.editRoute(route)\" class=\"btn-link text-decoration-none pl-5 pr-5\" uib-popover-template=\"'routeSettingsPopover.html'\" popover-trigger=\"'mouseenter'\" popover-placement=\"top-left\" popover-append-to-body=\"true\" popover-class=\"route-settings-popover-container\">\n{{route.routeName}}\n</a>\n<button class=\"btn btn-default btn-xs\" ng-if=\"!route.isCheckedOut && route.origination === 'USER'\" ng-click=\"$ctrl.openMessengerModal(route)\" uib-tooltip=\"{{'routeControl.messengerID' | translate}}\">\n<span class=\"glyphicon glyphicon-user\"></span>\n</button>\n<button class=\"btn btn-default btn-xs\" ng-if=\"route.isCheckedOut\" ng-click=\"$ctrl.routeDetail(route)\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button id=\"routeProgress\" class=\"btn btn-default btn-xs\" ng-if=\"route.isCheckedOut\" uib-tooltip=\"{{'common.side_menu.route_progress' | translate}}\" ng-click=\"$ctrl.goToRouteProgress(route)\">\n<span class=\"glyphicon glyphicon-road\"></span>\n</button>\n<div class=\"btn-group\" ng-if=\"route.isCheckedOut && route.serviceTicketCount > 0 && !route.isCheckedIn\" uib-tooltip=\"{{'serviceTickets.service_tickets_assigned' | translate}}\">\n<button type=\"button\" class=\"btn btn-default btn-xs\" style=\"cursor: default; pointer-events: none;\">\n<span class=\"glyphicon glyphicon-tag\"></span>\n</button>\n<button class=\"btn btn-xs\" ng-click=\"$ctrl.showRouteServiceTickets(route)\" ng-class=\"{'btn-primary': route.serviceTicketCount > 0, 'btn-default': !route.serviceTicketCount}\">\n{{route.serviceTicketCount || 0}}\n</button>\n</div>\n<span ng-if=\"route.isCheckedIn\" class=\"glyphicon glyphicon-ok checked-in-route\"></span>\n<div ng-if=\"route.estimatedReturnTime || route.estimatedRouteMilage.routeAnalysis.OverallSummary.TotalTimeInService\" class=\"route-ert\">\n<span class=\"ert-item margin-right-10\" uib-tooltip=\"Estimated Route Time\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\">\n<i class=\"glyphicon glyphicon-time\"></i>\n<span class=\"label-text\">ERT :</span>\n<span class=\"value-text\">{{route.estimatedRouteMilage.routeAnalysis.OverallSummary.TotalTimeInService || 'N/A'}}</span>\n</span>\n<span class=\"errt-item\" uib-tooltip=\"Estimated Route Return Time\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\">\n<i class=\"glyphicon glyphicon-log-out\"></i>\n<span class=\"label-text\">ERRT :</span>\n<span class=\"value-text\">{{route.estimatedReturnTime ? $ctrl.moment(route.estimatedReturnTime).format('YYYY-MM-DD | hh:mm A') : 'N/A'}}</span>\n</span>\n</div>\n</td>\n<td class=\"text-align-center\">\n<span class=\"history-link-btn\" ng-click=\"$ctrl.routeStopListModal(route)\">\n{{route.stops}}\n</span>\n<span class=\"cursor-pointer\" ng-if=\"route.isDuplicateStops\">\n<img ng-src=\"assets/images/red-alert.png\" class=\"duplicate-stop-alert-icon margin-bottom-5\" uib-tooltip=\"{{'location.duplicate_stops' | translate}}\" ng-click=\"$ctrl.duplicateRouteStopList(route)\">\n</span>\n</td>\n<td class=\"text-align-center remove-white-space total-shipments-badge\">\n<button type=\"button\" ng-click=\"$ctrl.shipmentListModal(route)\" class=\"btn btn-link text-decoration-none remove-pad\" ng-class=\"{'disabled' : $ctrl.loadShipmentList}\">\n<span class=\"badge shipment-count-bg-color\">\n{{route.totalShipments}}\n</span>\n</button> |\n<span>\n<button type=\"button\" ng-click=\"$ctrl.remainingToPackShipments(route)\" class=\"btn btn-link text-decoration-none remove-pad\">\n<span ng-if=\"route.pendingPackShipmentCount > 0\">\n<img src=\"" + __webpack_require__(242) + "\" class=\"orange-icon-style\" uib-tooltip=\"{{'routeControl.pending_pack' | translate}}\">\n</span>\n<span ng-if=\"route.pendingPackShipmentCount === 0 || route.pendingPackShipmentCount === null\">\n<img src=\"" + __webpack_require__(138) + "\" class=\"grey-icon-style\" uib-tooltip=\"{{'routeControl.pending_pack' | translate}}\">\n</span>\n</button> |\n</span>\n<span>\n<button type=\"button\" ng-click=\"$ctrl.remainingToThrowShipments(route)\" class=\"btn btn-link text-decoration-none remove-pad\">\n<span ng-if=\"route.remainingToThrowShipmentCount > 0 && !route.isCheckedOut\">\n<img src=\"" + __webpack_require__(393) + "\" class=\"orange-icon-style\" uib-tooltip=\"{{'routeControl.pending_throw' | translate}}\">\n</span>\n<span ng-if=\"route.remainingToThrowShipmentCount === 0 || route.remainingToThrowShipmentCount === null || route.isCheckedOut\">\n<img src=\"" + __webpack_require__(392) + "\" class=\"grey-icon-style\" uib-tooltip=\"{{'routeControl.pending_throw' | translate}}\">\n</span>\n</button> |\n</span>\n<span>\n<button type=\"button\" ng-click=\"$ctrl.holdShipmentList(route)\" class=\"btn btn-link text-decoration-none remove-pad\">\n<span ng-if=\"route.holdShipmentCount > 0\">\n<img src=\"" + __webpack_require__(390) + "\" class=\"orange-icon-style\" uib-tooltip=\"{{'routeControl.on_hold' | translate}}\">\n</span>\n<span ng-if=\"route.holdShipmentCount === 0 || route.holdShipmentCount === null\">\n<img src=\"" + __webpack_require__(389) + "\" class=\"grey-icon-style\" uib-tooltip=\"{{'routeControl.on_hold' | translate}}\">\n</span>\n</button> |\n</span>\n<span>\n<button type=\"button\" ng-click=\"$ctrl.pickupDeliveryShipmentsModal(route, 'pickup')\" class=\"btn btn-link text-decoration-none remove-pad\">\n<span ng-if=\"route.totalPickupsCount > 0 && route.totalPickupsCount !== null\">\n<img src=\"" + __webpack_require__(242) + "\" class=\"orange-icon-style\" uib-tooltip=\"{{'shipment.PICKUP' | translate}}\">\n</span>\n<span ng-if=\"route.totalPickupsCount === null || route.totalPickupsCount === 0\">\n<img src=\"" + __webpack_require__(138) + "\" class=\"grey-icon-style\" uib-tooltip=\"{{'shipment.PICKUP' | translate}}\">\n</span>\n</button>\n</span>\n<span ng-if=\"route.hasCancelledShipments\">\n| <button type=\"button\" ng-click=\"$ctrl.pendingCancelShipmentModal(route)\" class=\"btn btn-link text-decoration-none remove-pad\">\n<span ng-if=\"route.hasCancelledShipments\">\n<img src=\"" + __webpack_require__(388) + "\" class=\"orange-icon-style\" uib-tooltip=\"{{'branch_mgmt.pending_cancel' | translate}}\">\n</span>\n</button>\n</span>\n<span ng-if=\"route.pendingTransferShipmentCount > 0\">\n|<button type=\"button\" ng-click=\"$ctrl.pendingShipmentTransferModal(route)\" class=\"btn btn-link text-decoration-none remove-pad\">\n<span>\n<img src=\"" + __webpack_require__(394) + "\" class=\"transfer-icon-style\" uib-tooltip=\"Pending Transfer\">\n</span>\n</button>\n</span>\n</td>\n<td>\n<div>\n<img ng-src=\"assets/images/pending.png\" class=\"alert-icon-width\" uib-tooltip=\"{{'routeControl.totalCashCoin' | translate}}\">\n{{route.totalCash | currency:\"$\"}}\n</div>\n<div ng-if=\"route.amountDelivered > 0\">\n<button ng-click=\"$ctrl.pickupDeliveryShipmentsModal(route, 'delivered')\" class=\"btn btn-link text-decoration-none remove-pad\">\n<img ng-src=\"assets/images/arrow-inbound.png\" class=\"alert-icon-width\" uib-tooltip=\"{{'location.delivered' | translate}}\">\n</button>\n{{route.amountDelivered | currency:\"$\"}}\n</div>\n<div ng-if=\"route.amountPickup > 0\">\n<img ng-src=\"assets/images/arrow-outbound-orange.png\" class=\"alert-icon-width\" uib-tooltip=\"{{'shipment.pickedUp' | translate}}\">\n{{route.amountPickup | currency:\"$\"}}\n</div>\n</td>\n<td>\n<button class=\"btn btn-warning\" ng-if=\"!$ctrl.isUnassignedRoute(route)\" ng-disabled=\"route.status === 'processing' || route.isReleased || $ctrl.isPreviousVaultDate\" ng-click=\"$ctrl.releaseRoute(route)\">\n<i class=\"glyphicon\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t'glyphicon-refresh fast-right-spinner': route.status === 'processing',\n\t\t\t\t\t\t\t\t\t'glyphicon-ok': route.status === 'success',\n\t\t\t\t\t\t\t\t\t'glyphicon-remove': route.status === 'error',\n\t\t\t\t\t\t\t\t}\"></i>\n<span ng-if=\"route.isCheckedOut\">{{'routeControl.route_file'|translate }}</span>\n<span ng-if=\"!route.checkedOutTime && route.routeTransfered\">{{'routeControl.re_release'|translate }}</span>\n<span ng-if=\"!route.routeTransfered && !route.checkedOutTime\">{{'routeControl.release'|translate }}</span>\n</button>\n<button ng-if=\"route.lastReleasedAt && !route.isCheckedOut && !$ctrl.isUnassignedRoute(route)\" ng-disabled=\"!route.lastReleasedAt || $ctrl.isPreviousVaultDate\" class=\"btn btn-warning\" ng-click=\"$ctrl.loadSequence(route)\">{{'Sequence' | translate}}\n</button>\n<button ng-if=\"route.isCheckedOut && route.arriveTime && route.leaveTime && !$ctrl.isUnassignedRoute(route)\" class=\"btn btn-warning\" ng-click=\"$ctrl.redirectToCheckInScreen(route)\">\n{{'routeControl.check_in' | translate}}\n</button>\n<button ng-if=\"$ctrl.isUnassignedRoute(route)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.autoRouteLoading || !$ctrl.isAllowToAutoRoutingControl() || route.stops === 0 || $ctrl.selectedRoutes.length === 0\" ng-click=\"$ctrl.goToAutoRouting()\">\n<i class=\"glyphicon\" ng-if=\"$ctrl.autoRouteLoading\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t'glyphicon-refresh fast-right-spinner': $ctrl.autoRouteLoading,\n\t\t\t\t\t\t\t\t}\"></i>\nAuto Routing\n</button>\n<span class=\"btn-group\" ng-if=\"!$ctrl.isUnassignedRoute(route)\">\n<button class=\"btn btn-success dropdown-toggle\" type=\"button\" id=\"dropdownMenuButton\" data-toggle=\"dropdown\">\n<i class=\"glyphicon glyphicon-print\"></i> {{'routeSheet.print' | translate}}\n</button>\n<ul class=\"dropdown-menu\">\n<li ng-repeat=\"(key, obj) in $ctrl.printItemList\">\n<a class=\"dropdown-item\" href=\"#\" ng-click=\"$ctrl.generateManifest(route, obj.value);\">{{obj.label}}</a>\n</li>\n</ul>\n</span>\n<span class=\"btn-group margin-left-5\" ng-if=\"!$ctrl.isUnassignedRoute(route)\">\n<button class=\"btn btn-primary dropdown-toggle\" type=\"button\" id=\"emailMenuButton\" data-toggle=\"dropdown\" ng-disabled=\"route.isEmailSending\">\n<i class=\"glyphicon\" ng-class=\"{\n\t\t\t\t\t\t\t\t   'glyphicon-refresh fast-right-spinner': route.isEmailSending,\n\t\t\t\t\t\t\t\t   'glyphicon-envelope': !route.isEmailSending\n\t\t\t\t\t\t\t   }\"></i>\n{{'customer.email' | translate}}\n</button>\n<ul class=\"dropdown-menu\" style=\"padding: 15px; min-width: 300px;\">\n<li>\n<div class=\"form-group\">\n<label>{{'common.enter_email' | translate}}</label>\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"Enter multiple emails separated by commas.\" tooltip-placement=\"top\">\n</span>\n<input type=\"text\" class=\"form-control\" ng-model=\"route.receiverMail\" placeholder=\"{{'common.enter_email' | translate}}\" ng-disabled=\"route.isEmailSending\">\n</div>\n<div class=\"margin-top-10\">\n<button class=\"btn btn-primary btn-block\" ng-click=\"$ctrl.generateManifest(route, 'emailDeliveryManifest')\" ng-disabled=\"!$ctrl.hasValidEmails(route.receiverMail) || route.isEmailSending\">\n{{'shipmentBatch.manifest' | translate}}\n</button>\n<button class=\"btn btn-primary btn-block margin-top-5\" ng-click=\"$ctrl.generateManifest(route, 'emailDeliveryManifestAll')\" ng-disabled=\"!$ctrl.hasValidEmails(route.receiverMail) || route.isEmailSending\">\n{{'shipmentBatch.manifestAll' | translate}}\n</button>\n<button class=\"btn btn-primary btn-block margin-top-5\" ng-click=\"$ctrl.generateManifest(route, 'emailDeliveryManifestCombined')\" ng-disabled=\"!$ctrl.hasValidEmails(route.receiverMail) || route.isEmailSending\">\n{{'shipmentBatch.delivery_manifest_combined' | translate}}\n</button>\n<button class=\"btn btn-primary btn-block margin-top-5\" ng-click=\"$ctrl.generateManifest(route, 'emailRouteSheet')\" ng-disabled=\"!$ctrl.hasValidEmails(route.receiverMail) || route.isEmailSending\">\n{{'navbar.routeSheet_title' | translate}}\n</button>\n</div>\n</li>\n</ul>\n</span>\n<div class=\"margin-top-5\" ng-if=\"$ctrl.routeStopTransferedData.toRouteId === route.routeId && !$ctrl.isUnassignedRoute(route)\">\n<div class=\"remove-pad col-sm-12 stop-transfer-msg\">\n</div>\n</div>\n<div class=\"margin-top-5\" ng-if=\"route.hasCancelledShipments && !$ctrl.isUnassignedRoute(route)\">\n<button class=\"btn btn-danger\" uib-tooltip=\"{{'routeControl.cancelled_shipments' | translate}}\" ng-click=\"$ctrl.goToCancelledShipmentTab(route)\">{{'common.cancelled' | translate}}</button>\n</div>\n</td>\n<td>\n<div ng-if=\"route.lastReleasedAt && route.lastReleasedBy\">\n<div><span class=\"glyphicon glyphicon-check icon-padding-05\" uib-tooltip=\"{{'routeControl.released' | translate}}\"></span>{{route.releasedByFirstName + ' ' + route.releasedByLastName}}\n</div>\n<div>{{$ctrl.moment(route.lastReleasedAt).format(\"MM/DD/YYYY | hh:mm A\")}}</div>\n</div>\n<div ng-if=\"route.lastDownloadedById\">\n<span>\n<hr class=\"last-released-route\"></span>\n<div><span class=\"glyphicon glyphicon-download icon-padding-05\" uib-tooltip=\"{{'routeControl.downloaded' | translate}}\"></span>{{route.lastDownloadedByFirstName + ' ' + route.lastDownloadedByLastName}}\n</div>\n<div>{{$ctrl.moment(route.lastDownloadedAt).format('MM/DD/YYYY | hh:mm A')}}</div>\n</div>\n<div class=\"text-danger route-relese-error\" ng-if=\"$ctrl.releaseRouteErrors[route.routeId]\">\n<div>{{'errorModal.title' | translate}} | {{$ctrl.releaseRouteErrors[route.routeId].errorCode}} </div>\n<div> {{$ctrl.releaseRouteErrors[route.routeId].message}}</div>\n</div>\n</td>\n</tr>\n</table>\n<div class=\"alert alert-danger text-align-center\" ng-if=\"!$ctrl.loading && (!$ctrl.routes || !$ctrl.routes.length)\">\n<span>{{'routeControl.noRoutesFound' | translate}}</span>\n</div>\n<p class=\"text-align-center font-size-70\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</p>\n</div>\n</div>\n\n";
var id2="route_control.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id2,v2);}
else{ngModule.run(["$templateCache",function(c){c.put(id2,v2)}]);}
module.exports=v2;

/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"form-row remove-pad no-mb-form\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-4 col-md-4 col-lg-5 remove-left-pad\">\n<div class=\"form-group\">\n<label for=\"vaultdate\">{{'routeProgress.vault_date' | translate}} *</label>\n<datetimepicker class=\"datetimepicker-input\" ng-class=\"{'required-datetimepicker': !$ctrl.model.date}\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" date-options=\"$ctrl.minVaultDate\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" ng-click=\"$ctrl.loadRoutes(); $ctrl.resetData()\"/>\n</div>\n</div>\n<div class=\"col-sm-4 remove-pad\">\n<div class=\"form-group\">\n<label for=\"route\">{{'routeProgress.route' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.route\" ng-disabled=\"$ctrl.gettingRoutes\" ng-options=\"route.routeId as (route.routeId + ' | ' + route.routeName) for route in $ctrl.model.allRoutes\" ng-change=\"$ctrl.getRouteStops()\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-4 col-lg-3 d-flex col-md-2 remove-right-pad btn-margin-top-24 text-right\" style=\"gap: 5px;\">\n<div>\n<div class=\"btn-div\">\n<select class=\"form-control\" required ng-model=\"$ctrl.model.timezone\" ng-options=\"timezone.value as timezone.label for timezone in $ctrl.model.timezoneList\" ng-disabled=\"$ctrl.loading || !$ctrl.model.route\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<button class=\"btn btn-sm btn-success btn-height-33\" ng-disabled=\"!$ctrl.model.route\" ng-click=\"$ctrl.goToRouteTab()\">{{'routeControl.routeDetail' | translate}}\n</button>\n<button class=\"btn btn-sm btn-success btn-height-33\" ng-disabled=\"!$ctrl.model.route\" ng-click=\"$ctrl.refreshData()\">\n<i class=\"glyphicon glyphicon-repeat\"></i>\n</button>\n</div>\n</form>\n</div>\n<div class=\"form-row remove-pad font-size-10\" ng-if=\"$ctrl.model.route && !$ctrl.model.loading\">\n<div class=\"col-sm-12 remove-pad\">\n<div ng-if=\"$ctrl.stopsInfo.routeDetails.vehicleId\" class=\"col-sm-3 mh-45 remove-left-pad\">\n<strong>{{ 'branch_mgmt.route_truck' | translate }}:</strong>\n{{ $ctrl.stopsInfo.routeDetails.vehicleId }}\n</div>\n<div ng-if=\"$ctrl.stopsInfo.routeDetails.driverId\" class=\"col-sm-3 mh-45\">\n<strong>{{ 'branch_mgmt.route_driver' | translate }}:</strong>\n<span>\n<a href=\"#\" ng-click=\"$ctrl.goToUserTab($ctrl.stopsInfo.routeDetails.driverId)\">\n{{ $ctrl.stopsInfo.routeDetails.driverId }}\n</a>\n</span>\n<span> | {{ $ctrl.stopsInfo.routeDetails.driver }}</span>\n</div>\n<div ng-if=\"$ctrl.stopsInfo.routeDetails.messengerId\" class=\"col-sm-3 mh-45\">\n<strong>{{ 'branch_mgmt.route_messenger' | translate }}:</strong>\n<span>\n<a href=\"#\" ng-click=\"$ctrl.goToUserTab($ctrl.stopsInfo.routeDetails.messengerId)\">\n{{ $ctrl.stopsInfo.routeDetails.messengerId }}\n</a>\n</span>\n<span> | {{ $ctrl.stopsInfo.routeDetails.messenger }}</span>\n</div>\n<div ng-if=\"$ctrl.stopsInfo.routeDetails.guardId\" class=\"col-sm-3 mh-45\">\n<strong>{{ 'routeSheet.guard' | translate }}:</strong>\n<span>\n<a href=\"#\" ng-click=\"$ctrl.goToUserTab($ctrl.stopsInfo.routeDetails.guardId)\">\n{{ $ctrl.stopsInfo.routeDetails.guardId }}\n</a>\n</span>\n<span> | {{ $ctrl.stopsInfo.routeDetails.guard }}</span>\n</div>\n<div class=\"col-sm-3 mh-45\" ng-if=\"$ctrl.stopsInfo.routeDetails.leaveTime\">\n<strong>{{ 'routeProgress.start_time' | translate }}:</strong>\n<span>{{$ctrl.DateUtil.convertDateTime($ctrl.stopsInfo.routeDetails.leaveTime, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm A')}}</span>\n</div>\n<div class=\"col-sm-3 mh-45 pull-left remove-left-pad\" ng-if=\"$ctrl.stopsInfo.routeDetails.arrTime\" ng-class=\"{'col-sm-4': ($ctrl.stopsInfo.routeDetails.messengerId && $ctrl.stopsInfo.routeDetails.driverId) ||\n                                        ($ctrl.stopsInfo.routeDetails.messengerId && $ctrl.stopsInfo.routeDetails.guardId) ||\n                                        ($ctrl.stopsInfo.routeDetails.driverId && $ctrl.stopsInfo.routeDetails.guardId)}\">\n<strong>{{ 'routeProgress.end_time' | translate }}:</strong>\n<span>{{$ctrl.DateUtil.convertDateTime($ctrl.stopsInfo.routeDetails.arrTime, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm A')}}</span>\n</div>\n<div class=\"col-sm-3 mh-45 pull-left remove-left-pad text-danger\" ng-if=\"$ctrl.model.routeStops.length && !$ctrl.stopsInfo.routeDetails.leaveTime && $ctrl.model.routeStartTime\" ng-class=\"{'col-sm-4': ($ctrl.stopsInfo.routeDetails.messengerId && $ctrl.stopsInfo.routeDetails.driverId) ||\n                                    ($ctrl.stopsInfo.routeDetails.messengerId && $ctrl.stopsInfo.routeDetails.guardId) ||\n                                    ($ctrl.stopsInfo.routeDetails.driverId && $ctrl.stopsInfo.routeDetails.guardId)}\">\n<strong>{{ 'routeProgress.estimated_route_start_time' | translate }}:</strong>\n<span>{{$ctrl.DateUtil.convertDateTime($ctrl.model.routeStartTime, $ctrl.model.timezone, 'hh:mm A')}}</span>\n</div>\n</div>\n</div>\n<div class=\"form-row remove-pad\" ng-if=\"$ctrl.model.routeStops.length && !$ctrl.model.loading && $ctrl.model.route\">\n<div class=\"col-sm-12 remove-pad rp-margin-top-10\" style=\"height:30px\">\n<uib-progress max=\"$ctrl.stopsInfo.totalStops\" style=\"height:30px\">\n<uib-bar ng-repeat=\"bar in $ctrl.stackData track by $index\" value=\"bar.value\" type=\"{{bar.type}}\">\n<div class=\"progress-bar-value\">\n<span>\n{{bar.value}}<span ng-if=\"bar.type === 'warning'\">/</span><span ng-if=\"bar.type !== 'warning'\"> / </span>{{$ctrl.stopsInfo.totalStops}}\n</span>\n</div>\n</uib-bar>\n</uib-progress>\n</div>\n</div>\n<div class=\"loader_center text-align-center margin-top-40\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"col-sm-12 remove-padding rp-margin-top-10\" ng-if=\"$ctrl.model.routeStops.length && !$ctrl.model.loading\">\n<div id=\"map\" class=\"border-radius-05 leaf-map dd-z-index\"></div>\n<div class=\"btn-group btn-group-justified margin-bottom-10\">\n<a class=\"btn\" ng-repeat=\"obj in $ctrl.mapMarkerFilters track by $index\" ng-class=\"obj.isChecked ? 'btn-success' : 'btn-default' \" ng-click=\"$ctrl.manageMarkers($index)\">\n<span>{{obj.label}}</span>\n</a>\n</div>\n<div class=\"col-sm-12 remove-padding rp-margin-top-10\">\n<div class=\"ert-erm-container\" ng-if=\"!$ctrl.model.routeDetails.arrTime && $ctrl.model.estimatedRouteMilageError == null\">\n<div class=\"d-flex\">\n<div class=\"ert-erm-item margin-right-10\">\n<i class=\"glyphicon glyphicon-time\" uib-tooltip=\"Estimated Route Time\"></i>\n<span class=\"label-text\">ERT :</span>\n<span class=\"value-text\">{{$ctrl.model.estimatedRouteMilage.routeAnalysis.OverallSummary.TotalTimeInService || 'N/A'}}</span>\n</div>\n<div class=\"ert-erm-item margin-right-10\">\n<i class=\"glyphicon glyphicon-road\" uib-tooltip=\"Estimated Route Mileage\"></i>\n<span class=\"label-text\">ERM :</span>\n<span class=\"value-text\">{{$ctrl.model.estimatedRouteMilage.routeAnalysis ? ($ctrl.formatMiles($ctrl.model.estimatedRouteMilage.routeAnalysis.OverallSummary.TotalDistanceMiles) + ' miles') : 'N/A'}}</span>\n</div>\n<div class=\"ert-erm-item\">\n<i class=\"glyphicon glyphicon-log-out\" uib-tooltip=\"Estimated Route Return Time\"></i>\n<span class=\"label-text\">ERRT :</span>\n<span class=\"value-text\">{{$ctrl.model.estimatedRouteMilage.estimatedRouteReturnTime ? $ctrl.DateUtil.convertDateTime($ctrl.model.estimatedRouteMilage.estimatedRouteReturnTime, $ctrl.model.timezone, 'YYYY-MM-DD | hh:mm A') : 'N/A'}}</span>\n</div>\n</div>\n<div class=\"ert-erm-item\">\n<button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.getEstimatedRouteMilage()\" ng-disabled=\"$ctrl.model.estimatedRouteMilageLoading\" uib-tooltip=\"{{$ctrl.model.estimatedRouteMilageLoading ? 'Calculating...' : 'Calculate ERM & ETA'}}\" tooltip-placement=\"left-top\">\n<i class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.estimatedRouteMilageLoading\"></i>\n<span ng-if=\"!$ctrl.model.estimatedRouteMilageLoading\">Calculate ERM & ETA</span>\n</button>\n</div>\n</div>\n<div class=\"ert-erm-container\" ng-if=\"$ctrl.model.routeDetails.arrTime && $ctrl.model.estimatedRouteMilageError == null\">\n<div class=\"d-flex\">\n<div class=\"ert-erm-item margin-right-10\">\n<i class=\"glyphicon glyphicon-time\" uib-tooltip=\"Estimated Route Time\"></i>\n<span class=\"label-text\">Total Time :</span>\n<span class=\"value-text\">{{$ctrl.calculateTotalTime($ctrl.model.routeDetails.arrTime, $ctrl.model.routeDetails.leaveTime)}}</span>\n</div>\n<div class=\"ert-erm-item\">\n<i class=\"glyphicon glyphicon-road\" uib-tooltip=\"Estimated Route Mileage\"></i>\n<span class=\"label-text\">Total Distance :</span>\n<span class=\"value-text\">{{$ctrl.formatMiles($ctrl.model.routeDetails.endMiles - $ctrl.model.routeDetails.begMiles) || 'N/A'}} miles</span>\n</div>\n</div>\n<div class=\"d-flex\">\n<div class=\"ert-erm-item\" style=\"margin-right: 30px;\">\n<span class=\"label-text\">{{ 'common.begin_mileage' | translate }}:</span>\n<span class=\"value-text\">{{$ctrl.model.routeDetails.begMiles || 'N/A'}}</span>\n</div>\n<div class=\"ert-erm-item\">\n<span class=\"label-text\">{{ 'common.end_mileage' | translate }}:</span>\n<span class=\"value-text\">{{$ctrl.model.routeDetails.endMiles || 'N/A'}}</span>\n</div>\n</div>\n</div>\n<div class=\"ert-erm-container mb-0 alert alert-danger\" ng-if=\"$ctrl.model.estimatedRouteMilageError !== null\">\n<div class=\"ert-erm-item\">\nUnable to get estimated route mileage and time : {{$ctrl.model.estimatedRouteMilageError}}\n<a class=\"ml-5\" ng-if=\"$ctrl.model.estimatedRouteMilageError === 'Route has not started and no start time is set'\" ui-sref=\"routes.edit({id: $ctrl.model.route, day: $ctrl.getRouteEditDay()})\">Go to Route Settings</a>\n</div>\n</div>\n<div class=\"route_progress_table table-responsive\">\n<table class=\"table table-striped table-hover table-bordered\">\n<thead>\n<tr>\n<th class=\"remove-white-space seq-col-width d-th-8\" ng-click=\"$ctrl.sortData('_index')\">{{'routeProgress.seq' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.model.reverseSort, 'active' : $ctrl.model.sortColumn === '_index'}\"></span>\n</th>\n<th class=\"remove-white-space text-center order-col-width d-th-9\" ng-click=\"$ctrl.sortData('stopProcessOrder')\">{{'routeProgress.order' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.model.reverseSort, 'active' : $ctrl.model.sortColumn === 'stopProcessOrder'}\"></span>\n</th>\n<th class=\"remove-white-space text-center order-col-width d-th-9\">ETA</th>\n<th class=\"remove-white-space text-center\" ng-click=\"$ctrl.sortData('stopStatus')\">{{'common.status' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.model.reverseSort, 'active' : $ctrl.model.sortColumn === 'stopStatus'}\"></span>\n</th>\n<th class=\"remove-white-space text-center\">{{'routeProgress.location' | translate}}</th>\n<th class=\"remove-white-space text-center\">{{'routeProgress.location_type' | translate}}</th>\n<th class=\"remove-white-space text-center completed-date-width d-th-18\" ng-click=\"$ctrl.sortData('completedTime')\">{{'routeProgress.stop_completed' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.model.reverseSort, 'active' : $ctrl.model.sortColumn === 'completedTime'}\"></span>\n</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"data in $ctrl.model.routeStops | orderBy:$ctrl.model.sortColumn:$ctrl.model.reverseSort track by $index\">\n<td>\n<span ng-if=\"data._index !== 0\"> {{data._index}} </span>\n<span ng-if=\"data._index === 0\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"data.completedTime\">{{data.stopProcessOrder}}</span>\n<span ng-if=\"!data.completedTime\">-</span>\n</td>\n<td>\n<span ng-if=\"!data.completedTime\">{{data.estimatedTimeArrival ? $ctrl.DateUtil.convertDateTime(data.estimatedTimeArrival, $ctrl.model.timezone, 'hh:mm A') : 'N/A'}}</span>\n<span ng-if=\"data.completedTime\">-</span>\n</td>\n<td class=\"contents-no-wrap\">\n<span ng-class=\"{'text-danger': (data.stopStatus === 'CANT' || data.stopStatus === 'NOT' || data.stopStatus === 'NO_PICKUP' || data.stopStatus === 'DELIVERED_NO_PICKUP' || data.stopStatus === 'CRV'),\n                                                 'bold-font': data.totalTransactionRecords > 0 && (data.stopStatus === 'CANT' || data.stopStatus === 'NO_PICKUP' || data.stopStatus === 'DELIVERED_NO_PICKUP'),\n                                                 'partial-status-color bold-font': data.stopStatus === 'PARTIAL'}\">\n{{$ctrl.getStopStatus(data)}}\n</span>\n<span class=\"margin-left-5\" ng-if=\"data.routeProgressComments\">\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.getComments(data, data.routeProgressComments)\" uib-tooltip=\"{{'checkout.comments' | translate}}\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n</span>\n<span class=\"transaction-count-badge\" ng-if=\"data.totalTransactionRecords > 0\">\n<span class=\"badge transaction-count-bg-color cursor-pointer\" ng-click=\"$ctrl.stopCommentsModal(data)\" uib-tooltip=\"{{'routeProgress.stop_comments' | translate}}\">\n{{data.totalTransactionRecords}}\n</span>\n</span>\n</td>\n<td class=\"location-position\">\n<span class=\"cursor-pointer badge shipment-count-bg-color\" uib-tooltip=\"Delivery Shipments\">{{data.totalShipments}}</span>\n<span class=\"cursor-pointer badge shipment-pickup-count-bg-color\" ng-click=\"$ctrl.redirectToHistoryTab(data)\" uib-tooltip=\"Shipment Picked Up\">{{data.totalPickupShipments}}</span> |\n<span ng-repeat=\"trackingId in data.holdTrackingIds\" ng-if=\"data.holdTrackingIds.length\">\n<button type=\"button\" class=\"btn btn-link remove-link-btn-pad\" ng-click=\"$ctrl.goToItemHold(trackingId)\">\n<span>\n<img src=\"" + __webpack_require__(80) + "\" class=\"item-hold-icon\" uib-tooltip=\"{{trackingId}}\">\n</span>\n</button>\n</span>\n<span class=\"badge shipment-hold-badge-color\" ng-if=\"data.holdTrackingIds.length\">{{data.holdTrackingIds.length}}</span>\n<span>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(data.locationId)\">\n{{data.locationId}}\n</a>\n<span>| {{data.name}} | {{data.address}} | {{data.city}}</span>\n<span ng-if=\"data.stopPriority\"> | ({{$ctrl.CommonLayoutService.ordinalSuffixOfStopPriority(data.stopPriority)}})</span>\n</span>\n</td>\n<td>\n<img ng-src=\"{{$ctrl.loadImage(data.locationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{data.locationType}}\"/>\n</td>\n<td>\n<span ng-if=\"data.completedTime\" ng-class=\"{'text-danger': data.stopStatus === 'CANT'|| data.stopStatus === 'NOT' || data.stopStatus === 'NO_PICKUP' || data.stopStatus === 'DELIVERED_NO_PICKUP' || data.stopStatus === 'CRV',\n                                                 'partial-status-color': data.stopStatus === 'PARTIAL'}\">\n{{$ctrl.DateUtil.convertDateTime(data.completedTime, $ctrl.model.timezone, 'MM-DD-YYYY | hh:mm A')}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.route && $ctrl.stopsInfo.routeDetails.checkedIn && !$ctrl.model.routeStops.length && !$ctrl.model.loading\">\n<div class=\"col-sm-12 alert text-center margin-10 alert-danger\" style=\"margin-bottom: 0px;\">\n{{'routeProgress.checked_in' | translate}} | {{'common.View' | translate}}\n<span class=\"route-link-btn\" ng-click=\"$ctrl.goToRouteTab()\">{{'routeControl.routeDetail' | translate}}</span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.route && !$ctrl.model.routeStops.length && !$ctrl.model.loading && !$ctrl.stopsInfo.routeDetails.checkedIn\">\n<div class=\"col-sm-12 alert text-center margin-10\" ng-class=\"{'alert-danger': !$ctrl.model.routeStops.length}\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n";
var id1="route_progress.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"route-stats\">\n<div class=\"remove-left-pad form-group col-sm-12 form-validate remove-bottom-pad\">\n<div class=\"remove-right-pad\" ng-class=\"{\n                    'col-sm-3': $ctrl.model.selectedRoute.routeId !== route.routeId && $ctrl.model.selectedRoute.shipmentLocations.length !== 0,\n                    'col-sm-4': $ctrl.model.selectedRoute.routeId === route.routeId || $ctrl.model.selectedRoute.shipmentLocations.length === 0,\n                    \n                }\">\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.vaultDate\" date-format=\"dd-MMM-yyyy\" ng-click=\"$ctrl.resetData(); $ctrl.filterRouteList(searchKey,offset); $ctrl.getRouteList(); $ctrl.clear()\" ng-class=\"{'required-datetimepicker': !$ctrl.vaultDate, 'disabled': $ctrl.loading}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<div class=\"remove-right-pad\" ng-class=\"{\n                    'col-sm-3': $ctrl.model.selectedRoute.routeId !== route.routeId && $ctrl.model.selectedRoute.shipmentLocations.length !== 0,\n                    'col-sm-4': $ctrl.model.selectedRoute.routeId === route.routeId || $ctrl.model.selectedRoute.shipmentLocations.length === 0,\n                   \n                }\">\n<div class=\"multi-select vault-operation-branch-dd valid-multi-select-value\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.branchObj.results\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.resetData(); $ctrl.filterRouteList(searchKey,offset); $ctrl.getRouteList()\" on-select-all=\" $ctrl.filterRouteList(searchKey,offset); $ctrl.getRouteList()\" on-select-none=\"$ctrl.resetData(); $ctrl.filterRouteList(searchKey,offset); $ctrl.getRouteList()\" on-reset=\"$ctrl.resetData(); $ctrl.filterRouteList(searchKey,offset); $ctrl.getRouteList()\" is-disabled=\"$ctrl.model.loadCountVariances\">\n</div>\n</div>\n<div class=\"remove-right-pad\" ng-class=\"{\n                    'col-sm-3': $ctrl.model.selectedRoute.routeId !== route.routeId && $ctrl.model.selectedRoute.shipmentLocations.length !== 0,\n                    'col-sm-4': $ctrl.model.selectedRoute.routeId === route.routeId || $ctrl.model.selectedRoute.shipmentLocations.length === 0,\n                   \n                }\">\n<search-and-select ng-model=\"$ctrl.model.routeId\" values=\"$ctrl.model.routeListObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.routeListObj.totalRecords\" on-click=\"$ctrl.getRouteList();\" onscroll=\"$ctrl.filterRouteList(searchKey,offset);\" ng-disabled=\"!$ctrl.model.selectedBranch || $ctrl.gettingRoutes\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div class=\"remove-right-pad\" ng-class=\"{\n                    'col-sm-3': $ctrl.model.selectedRoute.routeId !== route.routeId && $ctrl.model.selectedRoute.shipmentLocations.length !== 0,\n                    'col-sm-4': $ctrl.model.selectedRoute.routeId === route.routeId || $ctrl.model.selectedRoute.shipmentLocations.length === 0,\n                    \n                }\" ng-if=\"$ctrl.model.selectedRoute.routeId && $ctrl.model.selectedRoute.shipmentLocations.length !== 0\">\n<button type=\"button\" class=\"btn btn-success font-size-20 pull-left\" ng-click=\"$ctrl.exportData($ctrl.model.selectedRoute)\" ng-disabled=\"$ctrl.model.isExporting\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.model.isExporting\"></span>\n{{'common.export' | translate}}</button>\n</div>\n</div>\n<div class=\"col-sm-12 route-stats\">\n<div class=\"row\">\n<div class=\"col-sm-3 remove-pad\">\n<div>\n<ul class=\"route-list\" id=\"scroll-effect\">\n<li class=\"panel route-list-item\" ng-class=\"{'active': $ctrl.model.selectedRoute.routeId == route.routeId}\" ng-click=\"$ctrl.getRouteStops(route)\" ng-repeat-start=\"route in $ctrl.model.allRoutes track by $index\" id=\"panel-{{$index}}\">\n<div class=\"panel-heading\">\n<div class=\"d-flex justify-space-between\">\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-triangle-bottom': $ctrl.model.selectedRoute.routeId == route.routeId, 'glyphicon-triangle-right': $ctrl.model.selectedRoute.routeId != route.routeId}\"></i>\n<span class=\"router-title\">{{route.routeId}}</span>\n<span class=\"router-date\">{{route.routeDate | date:'yyyy-MM-dd': 'UTC' }}</span>\n</div>\n<div class=\"d-flex justify-space-between\" ng-if=\"route.leaveTime\">\n<strong>{{'routeProgress.start_time' | translate}}</strong>\n<span>{{route.leaveTime}}</span>\n</div>\n<div class=\"d-flex justify-space-between\" ng-if=\"route.arrTime\">\n<strong>{{'routeProgress.end_time' | translate}}</strong>\n<span>{{ route.arrTime}}</span>\n</div>\n<div class=\"d-flex justify-space-between\" ng-if=\"route.routeProcessTime\">\n<strong>{{'common.duration' | translate}}</strong>\n<span>{{ route.routeProcessTime}}</span>\n</div>\n<div class=\"d-flex justify-space-between\" ng-if=\"route.messengerId\">\n<strong>{{'branch_mgmt.route_messenger' | translate}}</strong>\n<span>{{route.messengerId}} | {{route.messenger}}</span>\n</div>\n<div class=\"d-flex justify-space-between\" ng-if=\"route.driverId\">\n<strong>{{'branch_mgmt.route_driver' | translate}}</strong>\n<span>{{route.driverId}} | {{route.driver}}</span>\n</div>\n<div class=\"d-flex justify-space-between\" ng-if=\"route.guardId\">\n<strong>{{'route.requireGuard' | translate}}</strong>\n<span>{{route.guardId}} | {{route.guard}}</span>\n</div>\n<div class=\"d-flex justify-space-between\" ng-if=\"route.vehicleId\">\n<strong>{{'routeControl.vehicleID' | translate}}</strong>\n<span>{{route.vehicleId}}</span>\n</div>\n<div class=\"d-flex justify-space-between\" ng-if=\"route.begMiles\">\n<strong>{{'routeControl.beginning_mileage' | translate}}</strong>\n<span>{{route.begMiles | currency:\"\":0}}</span>\n</div>\n<div class=\"d-flex justify-space-between\" ng-if=\"route.endMiles\">\n<strong>{{'routeControl.end_mileage' | translate}}</strong>\n<span>{{route.endMiles | currency:\"\":0}}</span>\n</div>\n<div class=\"d-flex justify-space-between text-muted\">\n<span class=\"router-desc\">{{route.branchId}}</span>\n</div>\n</div>\n</li>\n<li ng-repeat-end ng-if=\"$ctrl.model.selectedRoute.routeId == route.routeId  && $ctrl.model.allRoutes && $ctrl.model.allRoutes.length\" class=\"panel-collapse collapse fade in\">\n<div class=\"panel-body\">\n<div class=\"text-align-center\" ng-if=\"route.isLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 20px\"></span>\n</div>\n<div class=\"timeline-section\" ng-if=\"route && !route.isLoading\">\n<div class=\"timeline p-4 block\">\n<div class=\"tl-item\" ng-class=\"{'active': $ctrl.model.selectedLocation.locationId == routeLoc.locationId}\" ng-repeat=\"routeLoc in route.shipmentLocations\" ng-click=\"$ctrl.onLocationSelect(routeLoc)\">\n<div class=\"tl-dot b-warning\"></div>\n<div class=\"tl-content\">\n<div class=\"d-flex justify-space-between\">\n<span class=\"router-title\">\n<span ng-if=\"routeLoc.routeSeq\" class=\"text-danger\">{{routeLoc.routeSeq}}</span>\n<span ng-if=\"!routeLoc.routeSeq\">{{'common.n_a' | translate}}</span>\n<span>| {{routeLoc.locationId}} | {{routeLoc.name}}</span>\n</span>\n</div>\n<div class=\"d-flex justify-space-between text-muted\">\n<span>\n<span ng-if=\"routeLoc.zip\">{{routeLoc.zip}}</span>\n{{routeLoc.address}} {{routeLoc.city}}, {{routeLoc.state}}\n</span>\n</div>\n</div>\n</div>\n<div class=\"w-100 text-center margin-10 text-danger\" ng-if=\"!$ctrl.model.loadingMap && !route.shipmentLocations.length\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"map-padd\" ng-class=\"$ctrl.showShipmentSidebar ? 'col-sm-6 ' : 'col-sm-9 '\">\n<div class=\"text-align-center\" ng-if=\"$ctrl.model.loadingMap\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div id=\"map\" class=\"leaf-map z-index0\" ng-hide=\"$ctrl.model.loadingMap\">\n</div>\n</div>\n<div class=\"text-align-center\" ng-if=\"$ctrl.model.infoWindowLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div id=\"locationShipmentInfo\" class=\"location-shipment-info-panel col-sm-3\" ng-hide=\"!$ctrl.showShipmentSidebar || $ctrl.model.infoWindowLoading\">\n<div class=\"shipment-detail\" ng-if=\"!$ctrl.model.infoWindowLoading && $ctrl.model.selectedLocation && $ctrl.model.selectedLocation.locationId\">\n<div>\n<div class=\"panel-head-section w-100 billing-approval-tab-section\">\n<div>\n<div class=\"location-title\"> {{'routeStats.shipmentOverview' | translate}} </div>\n</div>\n<div>\n<button type=\"button\" class=\"close\" ng-click=\"$ctrl.closeNav()\">&times;</button>\n</div>\n</div>\n<div class=\"panel-head-section w-100\">\n<div>\n<div class=\"location-title\">\n<span>\n<img ng-src=\"assets/images/{{$ctrl.CommonLayoutService.loadLocationTypeIcon($ctrl.model.selectedLocation.locationType)}}\" class=\"img-currency\" uib-tooltip=\"{{$ctrl.model.selectedLocation.locationType}}\" tooltip-placement=\"top-left\"/>\n</span>\n<span>{{$ctrl.model.selectedLocation.locationId}} | </span>\n<span ng-class=\"{'text-danger': $ctrl.model.selectedLocation.stopStatus === 'CANT'|| $ctrl.model.selectedLocation.stopStatus === 'NO_PICKUP' || $ctrl.model.selectedLocation.stopStatus === 'DELIVERED_NO_PICKUP'}\">\n{{$ctrl.getStopStatus($ctrl.model.selectedLocation)}} |\n</span>\n<span>{{$ctrl.model.selectedLocation.name}} | </span>\n<span class=\"text-muted\">{{$ctrl.model.selectedRoute.routeId}} ({{$ctrl.model.selectedRoute.branchId}})</span>\n</div>\n<div>\n<i class=\"glyphicon glyphicon-map-marker\"></i>\n<span>\n{{$ctrl.model.selectedLocation.address}}, {{$ctrl.model.selectedLocation.zip}}, {{$ctrl.model.selectedLocation.city}}, {{$ctrl.model.selectedLocation.state}}\n</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 location-activity-section remove-right-pad remove-left-pad\" ng-if=\"$ctrl.model.locationActivity\">\n<div>\n<span class=\"bold-font\" ng-if=\"$ctrl.model.locationActivity.stopStarted\">{{'routeProgress.stop_started' | translate}}: </span>\n{{$ctrl.model.locationActivity.stopStarted | date:'yyyy-MM-dd | HH:mm:ss' }}\n</div>\n<div>\n<span class=\"bold-font\" ng-if=\"$ctrl.model.locationActivity.arriveCustTime\">{{'route_stats.arrives' | translate}}: </span>\n{{$ctrl.model.locationActivity.arriveCustTime | date:'yyyy-MM-dd | HH:mm:ss'}}\n</div>\n<div>\n<span class=\"bold-font\" ng-if=\"$ctrl.model.locationActivity.leaveTruckTime\">{{'route_stats.exit_truck' | translate}}: </span>\n{{$ctrl.model.locationActivity.leaveTruckTime | date:'yyyy-MM-dd | HH:mm:ss'}}\n</div>\n<div>\n<span class=\"bold-font\" ng-if=\"$ctrl.model.locationActivity.returnTruckTime\">{{'route_stats.return_truck' | translate}}: </span>\n{{$ctrl.model.locationActivity.returnTruckTime | date:'yyyy-MM-dd | HH:mm:ss'}}\n</div>\n<div>\n<span class=\"bold-font\" ng-if=\"$ctrl.model.locationActivity.leaveCustTime\">{{'route_stats.leave' | translate}}: </span>\n{{$ctrl.model.locationActivity.leaveCustTime | date:'yyyy-MM-dd | HH:mm:ss'}}\n</div>\n<div>\n<span class=\"bold-font\" ng-if=\"$ctrl.model.locationActivity.stopCompleted\">{{'routeProgress.stop_completed' | translate}}: </span>\n{{$ctrl.model.locationActivity.stopCompleted | date:'yyyy-MM-dd | HH:mm:ss'}}\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad content-scroll\" id=\"scroll-effect-sidebar\">\n<div ng-if=\"$ctrl.model.shipmentDetails && $ctrl.model.shipmentDetails.length\" class=\"shipment-details\" ng-repeat=\"shipment in $ctrl.model.shipmentDetails track by $index\">\n<div class=\"pickup-section margin-bottom-5\" ng-if=\"shipment.pickupFlag\">\n<div class=\"section-header\">\n<img src=\"" + __webpack_require__(405) + "\"/>\n<span class=\"dot\">\n{{shipment.trackingId}} | {{$ctrl.translateTransactionType(shipment.status)}}\n</span>\n<span ng-if=\"shipment.pickupImageName\">\n<b>|</b>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipment, 'pickup')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n</div>\n<div class=\"section-content\">\n<div>\n<span class=\"font-weight-600\">{{'routeStats.pickup_on' | translate}}:</span>\n{{shipment.pickupDate | date:'yyyy-MM-dd | HH:mm:ss' }}\n</div>\n<div>\n<span>\n<span class=\"bold-font\">{{'routeStats.shipmentAmount' | translate}}:\n</span>\n{{shipment.amount | currency}}\n</span>\n</div>\n</div>\n</div>\n<div class=\"delivery-section margin-bottom-5\" ng-if=\"shipment.deliveredFlag\">\n<div class=\"section-header\">\n<img src=\"" + __webpack_require__(400) + "\"/>\n<span class=\"dot\">\n{{shipment.trackingId}} | {{$ctrl.translateTransactionType(shipment.status)}}\n</span>\n<span ng-if=\"shipment.deliveryImageName\">\n<b>|</b>\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showReceipt(shipment, 'delivery')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n</div>\n<div class=\"section-content\">\n<div>\n<span>\n<span class=\"bold-font\">{{'routeStats.deliveredAt' | translate}}:\n</span>\n{{shipment.deliveryDate | date:'yyyy-MM-dd | HH:mm:ss'}}\n</span>\n</div>\n<div>\n<span>\n<span class=\"bold-font\">{{'routeStats.shipmentAmount' | translate}}:\n</span>\n{{shipment.amount | currency}}\n</span>\n</div>\n<div>\n<span>\n<span class=\"bold-font\">{{'routeStats.deliveredAmount' | translate}} : </span>\n<span ng-if=\"shipment.loadedAmount >= 0\">{{shipment.loadedAmount | currency}}</span>\n<span ng-if=\"shipment.loadedAmount == null\">{{'common.n_a' | translate}}</span>\n</span>\n</div>\n</div>\n</div>\n<div class=\"status-section margin-bottom-5\" ng-if=\"!shipment.pickupFlag && !shipment.deliveredFlag\">\n<div class=\"section-header\">\n<img ng-if=\"$ctrl.translateTransactionType(shipment.status, shipment) == 'Packed'\" src=\"" + __webpack_require__(404) + "\"/>\n<img ng-if=\"$ctrl.translateTransactionType(shipment.status, shipment) == 'Hold'\" src=\"" + __webpack_require__(402) + "\"/>\n<span class=\"dot\" ng-class=\"{'text-danger': shipment.status === 'shipment.cant'}\">\n{{shipment.trackingId}} | {{$ctrl.translateTransactionType(shipment.status, shipment)}}\n</span>\n</div>\n<div class=\"section-content\">\n<div>\n<span>\n<span class=\"bold-font\">{{'routeStats.amount' | translate}}: </span>\n{{shipment.amount | currency}}\n</span>\n</div>\n</div>\n</div>\n<div class=\"history-section\" ng-if=\"shipment.transactionHistory && shipment.transactionHistory.length\">\n<span class=\"line\">\n<p><span>{{'routeStats.transactions' | translate}}</span></p>\n</span>\n<div class=\"trans-history\">\n<div ng-repeat=\"history in shipment.transactionHistory\">\n<div class=\"d-flex justify-space-between\">\n<span>\n<span class=\"font-weight-600\">{{'routeStats.status' | translate}}:</span>\n<span class=\"text-danger\">{{$ctrl.translateTransactionType(history.tranType)}}</span>\n</span>\n<span>\n<span class=\"font-weight-600\">{{'routeStats.amount' | translate}}:</span>\n<span class=\"text-danger\">{{history.amount | currency}}</span>\n</span>\n</div>\n<div><span class=\"font-weight-600\">{{'routeStats.comments' | translate}}:</span>\n{{history.comments}}\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"service-ticket-section margin-bottom-5\" ng-if=\"$ctrl.model.shipmentServiceTickets && $ctrl.model.shipmentServiceTickets.length\">\n<div class=\"section-header\">\n<img src=\"" + __webpack_require__(406) + "\"/>\n<span class=\"dot\">{{'routeStats.serviceTickets' | translate}}</span>\n</div>\n<div class=\"section-content\" ng-repeat=\"serviceTicket in $ctrl.model.shipmentServiceTickets\">\n<div class=\"w-100\">\n<span class=\"font-weight-600\">\n{{'serviceTickets.encounter_id' | translate}}:\n</span> {{serviceTicket.encounterId}}\n</div>\n<div class=\"w-100 d-flex justify-space-between\">\n<span>\n<span class=\"font-weight-600\">{{'routeStats.status' | translate}}:</span>\n<span ng-class=\"{'complete-status-color': (serviceTicket.status === 'COMPLETE'),\n                                                                                        'accepted-status-color':(serviceTicket.status === 'ACCEPTED'),\n                                                                                        'assigned-status-color': (serviceTicket.status === 'ASSIGNED'),\n                                                                                        'unassigned-status-color':(serviceTicket.status === 'UNASSIGNED'),\n                                                                                        'on-route-status-color':(serviceTicket.status === 'ON_ROUTE'),\n                                                                                        'on-site-status-color':(serviceTicket.status === 'ON_SITE'),\n                                                                                        'hold-status-color':(serviceTicket.status === 'HOLD'),\n                                                                                        'cancelled-status-color':(serviceTicket.status === 'CANCELLED'),\n                                                                                        'unaccepted-status-color':(serviceTicket.status === 'UNACCEPTED'),\n                                                                                        'pending-assign-status-color':(serviceTicket.status === 'PENDING_ASSIGN')}\">\n<b>{{serviceTicket.status}}</b>\n</span>\n</span>\n</div>\n<div class=\"w-100\">\n<span><span class=\"font-weight-600\">{{'common.updated' | translate}}:</span>\n{{serviceTicket.updatedAt | date:'yyyy-MM-dd | HH:mm:ss' }}</span>\n</div>\n<div class=\"w-100\">\n<span class=\"font-weight-600\">\n{{'common.created' | translate}}:\n</span>{{serviceTicket.createdAt | date:'yyyy-MM-dd | HH:mm:ss'}}\n</div>\n<div class=\"w-100\">\n<span><span class=\"font-weight-600\">{{'routeStats.notes' | translate}}:</span>\n{{serviceTicket.note}}</span>\n</div>\n<div class=\"w-100 text-right\" ng-if=\"serviceTicket.userId\">\n<span>\n- <b>{{serviceTicket.userId}} | {{serviceTicket.userName}}</b>\n</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="route_stats.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row\" ng-if=\"true || $ctrl.hasTanker\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-4 col-sm-offset-4 align-center-horizontally\">\n<h3>\n</h3>\n</div>\n<div class=\"col-sm-4\" ng-if=\"false\">\n<form ng-submit=\"$ctrl.bagScanned()\" class=\"align-center-vertically\">\n<div class=\"col-sm-5\" style=\"text-align: right;\">\n<label for=\"contact\">{{'routeThrow.fromTanker' | translate }}</label>\n</div>\n<div class=\"col-sm-6\">\n<input type=\"text\" class=\"form-control\" style=\"margin: 0 auto;\" ng-model=\"$ctrl.model.fromTanker\" disabled=\"disabled\">\n</div>\n<div class=\"col-sm-1 padding-zero\">\n<button type=\"button\" tabindex=\"-1\" class=\"btn btn-xs btn-danger pull-left\" ng-click=\"$ctrl.endScan(true)\">\n{{'routeThrow.end' | translate}}\n</button>\n</div>\n</form>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 align-center-vertically margin-top-20-datepicker form-validate\">\n<div class=\"col-sm-offset-5\">\n<div class=\"col-sm-10\">\n<div class=\"text-align-center\">\n<label>{{ 'routeThrow.deliveryDate' | translate }}</label>\n</div>\n<datetimepicker class=\"datetimepicker-input\" date-options=\"$ctrl.minVaultDate\" ng-model=\"$ctrl.nextVaultDate\" ng-class=\"{'required-datetimepicker': !$ctrl.nextVaultDate}\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row margin-top-20 align-center-vertically\" ng-if=\"$ctrl.model.shipment\">\n<div class=\"col-sm-12\">\n<div class=\"row\">\n<div class=\"col-sm-12 text-align-center\">\n<span style=\"font-size: 70px;\" ng-class=\"{'text-danger': $ctrl.model.route.holdRoute}\">\n<strong>\n{{$ctrl.model.route.name}}\n</strong>\n</span>\n</div>\n<div class=\"col-sm-12 text-align-center text-success\">\n<h3>\n<a href=\"\" ng-click=\"$ctrl.showThrownShipmentsModal()\" style=\"color: inherit;\">{{$ctrl.model.thrownShipments}} {{'routeThrow.thrown' | translate}}</a> |\n<a href=\"\" ng-click=\"$ctrl.showRemainingShipmentsModal()\" style=\"color: inherit;\">{{$ctrl.model.notThrown}} {{'routeThrow.remaining' | translate}}</a>\n</h3>\n</div>\n<div class=\"col-sm-12 text-align-center\">\n<h3>\n<strong>\n{{$ctrl.model.shipment.toLocationId}} | {{$ctrl.model.shipment.toLocationName}}\n</strong>\n</h3>\n</div>\n<div class=\"col-sm-12 text-align-center\">\n<h3>\n<strong>\n{{$ctrl.model.shipment.toAddress}}\n</strong>\n</h3>\n</div>\n<div class=\"col-sm-12 text-align-center\">\n<h3>\n<strong>\n{{'routeThrow.delivery' | translate}}:\n<span ng-class=\"{'text-danger': $ctrl.model.route.holdRoute, 'text-success': !$ctrl.model.route.holdRoute}\">\n{{$ctrl.shipmentDeliveryDate | date: 'MM/dd/yyyy'}}\n</span>\n</strong>\n</h3>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row margin-top-20\">\n<div class=\"col-sm-6 align-center-horizontally\">\n<form ng-submit=\"$ctrl.bagScanned()\" class=\"col-sm-9 form-validate\" novalidate>\n<div class=\"row margin-bottom-10 align-center-vertically\">\n<div class=\"col-sm-3\" style=\"text-align: right;\">\n<label for=\"contact\">{{'routeThrow.item' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input type=\"text\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\" class=\"form-control\" style=\"margin: 0 auto;\" id=\"bagId\" ng-model=\"$ctrl.model.bagId\" autocomplete=\"off\" ng-keydown=\"$ctrl.keyPressed('bagId', $event)\" ng-disabled=\"$ctrl.model.loading\" capitalize disable-copy-paste disable-tracking-id-typing>\n</div>\n<div class=\"col-sm-1 padding-zero\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 25px; margin-left: 5px;\"></span>\n</div>\n</div>\n<div ng-if=\"$ctrl.lastBagScanned\" style=\"margin-top: -5px;\" class=\"col-xs-11\">\n<div class=\"pull-right text-align-right\">\n<p>{{'common.lastScan' | translate}}: <b>{{$ctrl.lastBagScanned}}</b></p>\n</div>\n</div>\n</form>\n</div>\n<div class=\"col-sm-6 align-center-horizontally\">\n<form ng-submit=\"$ctrl.toTankerScanned()\" class=\"col-sm-9 form-validate\" novalidate>\n<div class=\"row margin-bottom-10 align-center-vertically\">\n<div class=\"col-sm-3\" style=\"text-align: right;\">\n<label for=\"contact\">{{'routeThrow.toTanker' | translate }}</label>\n</div>\n<div class=\"col-sm-8\">\n<input type=\"text\" ng-pattern=\"/^[a-zA-Z0-9- ]*$/\" class=\"form-control\" style=\"margin: 0 auto;\" id=\"toTanker\" ng-disabled=\"!$ctrl.model.shipment || $ctrl.model.loading || $ctrl.loading\" ng-model=\"$ctrl.model.toTanker\" autocomplete=\"off\" ng-keydown=\"$ctrl.keyPressed('toTanker', $event)\" capitalize>\n</div>\n<div class=\"col-sm-1 padding-zero\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 25px; margin-left: 5px;\"></span>\n</div>\n</div>\n<div ng-if=\"$ctrl.lastToTankerScanned || $ctrl.isAlreadyThrown\" style=\"margin-top: -5px;\" class=\"col-xs-11\">\n<div class=\"pull-right text-align-right\">\n<p ng-if=\"!$ctrl.isAlreadyThrown\">Expected Tanker: <b>{{$ctrl.lastToTankerScanned}}</b></p>\n<p ng-if=\"$ctrl.isAlreadyThrown\">Assigned Tanker: <b>{{$ctrl.assignedTankerId}}</b></p>\n</div>\n</div>\n</form>\n</div>\n</div>\n<div class=\"row margin-top-20\">\n<div class=\"col-sm-12 align-center-vertically align-center-horizontally\" ng-show=\"$ctrl.lastStatusUpdate\">\n<div class=\"pull-right\">\n<span class=\"glyphicon glyphicon-ok text-success\" ng-show=\"!$ctrl.isError\" style=\"font-size: 100px;\"></span>\n<img src=\"" + __webpack_require__(69) + "\" class=\"img-120\" ng-show=\"$ctrl.isError\" alt=\"error\">\n</div>\n<div class=\"pull-right margin-left-20\">\n<div class=\"text-danger margin-top-5\" ng-if=\"$ctrl.isError && $ctrl.bagRouteThrowError\">\n<b>{{$ctrl.bagRouteThrowError}}</b>\n</div>\n<div class=\"text-danger margin-top-5 text-size-15\" ng-if=\"$ctrl.isError && $ctrl.bagRouteThrowError && $ctrl.bagRouteThrowError === 'Wrong Tanker for Item'\">\n<b>{{$ctrl.scanItem}} {{ $ctrl.lastBagScanned }} {{ $ctrl.scanAgain }}</b>\n</div>\n<div class=\"text-success margin-top-5\" ng-if=\"!$ctrl.isError && $ctrl.bagRouteThrowMessage\">\n<b>{{$ctrl.bagRouteThrowMessage}}</b>\n</div>\n<div ng-class=\"{'text-danger': $ctrl.isError, 'text-success': !$ctrl.isError}\" class=\"margin-top-5\">{{$ctrl.lastStatusUpdate | date:'hh:mm:ss a'}}</div>\n<div ng-show=\"$ctrl.showForceHoldBtn\">\n<button class=\"btn btn-warning bold-font\" ng-click=\"$ctrl.itemForceHold()\">{{'routeThrow.forcetohold' |translate}}</button>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="route_throw.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header align-center-vertically\">\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'route.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n<div class=\"form-group\">\n<select id=\"userStatus\" class=\"form-control\" ng-model=\"$ctrl._status\" ng-options=\"status.value as status.label for status in $ctrl.userStatus\" ng-change=\"$ctrl.loadData()\">\n</select>\n</div>\n<div class=\"form-group\">\n<select id=\"activeStatus\" class=\"form-control\" ng-model=\"$ctrl._activeStatus\" ng-options=\"status.value as status.label for status in $ctrl.activeStatusList\" ng-change=\"$ctrl.loadData()\">\n</select>\n</div>\n</form>\n</div>\n</div>\n<div class=\"row_\">\n<div class=\"_col-sm-12\">\n<div class=\"form-group\">\n<div class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.days\" ng-disabled=\"$ctrl.loadingRouteSequence\" ng-click=\"$ctrl.selectDay(day)\" ng-class=\"{'btn-primary': $ctrl.selectedDay === day.value,'btn-default': $ctrl.selectedDay !== day.value, 'disabled' : $ctrl.loadingRouteSequence}\">\n<i class=\"glyphicon\" ng-class=\"{\n\t\t\t\t\t\t   'glyphicon-refresh fast-right-spinner': $ctrl.loadingRouteSequence && $ctrl.selectedDay === day.value,\n\t\t\t\t\t\t   'disabled': $ctrl.loadingRouteSequence\n\t\t\t\t\t   }\"></i> {{day.label}}\n</a>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.routes && $ctrl.routes.length\">\n<ul class=\"route-display-section list-group\">\n<li class=\"list-group-item\" ng-repeat-start=\"route in $ctrl.routes track by route.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"padding-left-10\">\n<button id=\"expand-btn-{{route.id}}\" class=\"btn btn-xs btn-secondary\" ng-click=\"route.expanded = !route.expanded; $ctrl.setPage(route.expanded, route.id);\n\t\t\t\t\t\t\t\t\t\t  $ctrl.getRouteUpdateHistory(route.expanded, route.id);\" expand>\n<span ng-if=\"route.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!route.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\">\n<span class=\"list-group-item-text\">\n{{route.name}}\n</span>\n</div>\n<div class=\"col-sm-8\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loadingRouteSequence}\"></span>\n<span ng-class=\"{'span-border-right': route.locationsOnRoute.totalActiveLocations !=0 }\" class=\"list-group-item-text icon-padding-05\">\n<img src=\"" + __webpack_require__(258) + "\" uib-tooltip=\"{{'routeControl.stops' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>\n{{route.locationsOnRoute ? route.locationsOnRoute.totalActiveLocations : 0}}\n</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.ATM\">\n<img src=\"" + __webpack_require__(244) + "\" uib-tooltip=\"{{'routeControl.ATM' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span> {{route.locationsOnRoute ? route.locationsOnRoute.ATM : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.REGULAR\">\n<img src=\"" + __webpack_require__(256) + "\" uib-tooltip=\"{{'routeControl.regular' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.REGULAR : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.BANK\">\n<img src=\"" + __webpack_require__(245) + "\" uib-tooltip=\"{{'routeControl.bank' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.BANK : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.NO_SHIP_NO_GO\">\n<img src=\"" + __webpack_require__(254) + "\" uib-tooltip=\"{{'routeControl.nsng' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.NO_SHIP_NO_GO : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.INTERNAL\">\n<img src=\"" + __webpack_require__(250) + "\" uib-tooltip=\"{{'routeControl.internal' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.INTERNAL : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.TRUCK\">\n<img src=\"" + __webpack_require__(260) + "\" uib-tooltip=\"{{'routeControl.truck' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.TRUCK : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.TANKER\">\n<img src=\"" + __webpack_require__(259) + "\" uib-tooltip=\"{{'routeControl.tanker' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.TANKER : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.CARRIER\">\n<img src=\"" + __webpack_require__(246) + "\" uib-tooltip=\"{{'routeControl.carrier' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.CARRIER : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.WINDOW\">\n<img src=\"" + __webpack_require__(262) + "\" uib-tooltip=\"{{'routeControl.window' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.WINDOW : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.ON_CALL\">\n<img src=\"" + __webpack_require__(255) + "\" uib-tooltip=\"{{'routeControl.on_call' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.ON_CALL : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.LOCKER\">\n<img src=\"" + __webpack_require__(252) + "\" uib-tooltip=\"{{'location_types.LOCKER' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.LOCKER : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.DELIVERY\">\n<img src=\"" + __webpack_require__(248) + "\" uib-tooltip=\"{{'location_types.DELIVERY' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.DELIVERY : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05\" ng-if=\"route.locationsOnRoute.VAULT\">\n<img src=\"" + __webpack_require__(261) + "\" uib-tooltip=\"{{'location_types.VAULT' | translate}}\" class=\"custom-icon\" style=\"width: 20px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.VAULT : 0}}</span>\n</span>\n<span class=\"list-group-item-text icon-padding-05 span-border-left\" ng-if=\"route.locationsOnRoute.totalNonActiveLocation\">\n<img src=\"" + __webpack_require__(391) + "\" uib-tooltip=\"{{'routeControl.inactive' | translate}}\" class=\"custom-icon\" style=\"width: 30px\"/>\n<span>{{route.locationsOnRoute ? route.locationsOnRoute.totalNonActiveLocation : 0}}</span>\n</span>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10 small branch-margin-top\">\n{{route.last|translate}}{{$ctrl.moment(route.updatedAt).format('DD/MM/YYYY hh:mmA ')}} <br>\n<span>{{route.branchId}}</span>\n</div>\n<div ng-if=\"route.expanded\" class=\"icon-padding-05 btn-group\">\n<span class=\"badge badge-light future-location-changes-badge\">{{$ctrl.pendingRouteChanges[route.id].details.total}}</span>\n<span class=\"badge badge-light route-history-badge\">{{$ctrl.routeUpdateHistory[route.id].details.total}}</span>\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.edit(route)\" uib-tooltip=\"{{ 'route.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n<div ng-repeat-end ng-if=\"route.expanded\">\n<div class=\"_margin-10\">\n<table class=\"table-pad-3 table table-condensed table-bordered inner-tbl-margin-bottom\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.uiProcessSection[route.id].process\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</div>\n<div class=\"route-history-alert-section\" ng-if=\"!$ctrl.uiProcessSection[route.id].process &&\n\t\t\t\t\t\t\t\t \t    (!$ctrl.pendingRouteChanges[route.id].details.results.length && !$ctrl.routeUpdateHistory[route.id].details.results.length)\">\n<div class=\"col-sm-12 alert alert-danger text-center remove-bottom-margin\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<tbody ng-if=\"!$ctrl.uiProcessSection[route.id].process && \n\t\t\t\t\t\t\t\t  ($ctrl.pendingRouteChanges[route.id].details.results.length || $ctrl.routeUpdateHistory[route.id].details.results.length)\">\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'routeSheet.date' | translate}}</th>\n<th class=\"text-center\">{{'location.change_type' | translate}}</th>\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n<th class=\"text-center\">{{'users.user' | translate}}</th>\n</tr>\n<tr class=\"future-location-changes-bg-color\" ng-repeat=\"history in $ctrl.pendingRouteChanges[route.id].details.results track by $index\" ng-if=\"$ctrl.pendingRouteChanges[route.id].details.results.length\">\n<td class=\"text-center\">{{history.executeAt | date: 'MM-dd-yyyy | hh:mm a'}}</td>\n<td class=\"text-danger text-center\">{{$ctrl.translateMessage(history.key)}}</td>\n<td class=\"text-center\">\n<span ng-if=\"history.previous.length\" ng-repeat=\"previousChanges in history.previous\">\n<div>{{previousChanges}}<span ng-if=\"$index + 1 !== history.previous.length\">,</span></div>\n</span>\n<span ng-if=\"!history.previous.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"history.changed.length\" ng-repeat=\"updatedValue in history.changed\">\n<div>{{updatedValue}}<span ng-if=\"$index + 1 !== history.changed.length\">,</span></div>\n</span>\n<span ng-if=\"!history.changed.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">{{history.user}}</td>\n</tr>\n<tr ng-repeat=\"history in $ctrl.routeUpdateHistory[route.id].details.results track by $index\" ng-if=\"$ctrl.routeUpdateHistory[route.id].details.results.length\">\n<td class=\"text-center\">{{history.createdAt | date: 'MM-dd-yyyy | hh:mm a'}}</td>\n<td class=\"text-danger text-center\">{{history.entryData.key}}</td>\n<td class=\"text-center\" ng-if=\"!$ctrl.isArray(history.entryData.previous)\">\n<span ng-if=\"history.entryData.previous\">{{history.entryData.previous}}</span>\n<span ng-if=\"!history.entryData.previous\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.isArray(history.entryData.previous)\">\n<span ng-if=\"history.entryData.previous.length\" ng-repeat=\"previousChanges in history.entryData.previous\">\n<div>{{previousChanges}}<span ng-if=\"$index + 1 !== history.entryData.previous.length\">,</span></div>\n</span>\n<span ng-if=\"!history.entryData.previous.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\" ng-if=\"!$ctrl.isArray(history.entryData.changed)\">\n<span ng-if=\"history.entryData.changed\">{{history.entryData.changed}}</span>\n<span ng-if=\"!history.entryData.changed\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\" ng-if=\"$ctrl.isArray(history.entryData.changed)\">\n<span ng-if=\"history.entryData.changed.length\" ng-repeat=\"updatedValue in history.entryData.changed\">\n<div>{{updatedValue}}<span ng-if=\"$index + 1 !== history.entryData.changed.length\">,</span></div>\n</span>\n<span ng-if=\"!history.entryData.changed.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">{{history.user}}</td>\n</tr>\n</tbody>\n<tfoot ng-if=\"!$ctrl.uiProcessSection[route.id].process && $ctrl.routeUpdateHistory[route.id].details.results.length\n\t\t\t\t\t\t\t\t          && $ctrl.routeUpdateHistory[route.id].details.total>$ctrl.routeUpdateHistory[route.id].details.pageLimit\">\n<tr>\n<td class=\"route-history-pagination-section\" colspan=\"5\">\n<ul ng-model=\"$ctrl.uiProcessSection[route.id].page\" uib-pagination total-items=\"$ctrl.routeUpdateHistory[route.id].details.total\" ng-hide=\"{{($ctrl.routeUpdateHistory[route.id].details.total<=$ctrl.routeUpdateHistory[route.id].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.getRouteUpdateHistory(route.expanded, route.id)\" max-size=\"10\"></ul>\n</td>\n</tr>\n</tfoot>\n</table>\n</div>\n</div>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"alert alert-danger text-align-center\" ng-if=\"(!$ctrl.routes || !$ctrl.routes.length) && !$ctrl.loading\">\n<span>{{'route.noRoutes' | translate}}</span>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>\n";
var id1="routes.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2774 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad display-flex\" style=\"display: flex; justify-content: space-between; align-items: center; width: 100%;\">\n<h4 translate=\"route.create_route\"></h4>\n<div class=\"form-group remove-bottom-margin\" style=\"display: inline-flex; align-items: center; gap: 10px; padding-right: 15px;\">\n<label for=\"status\" style=\"margin-bottom: 0;\">{{'location.status' | translate }}</label>\n<input id=\"status\" type=\"checkbox\" class=\"form-control\" ng-model=\"$ctrl.model.active\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<hr style=\"margin-top: 10px; margin-bottom: 15px;\"/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'common.id' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.id\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"name\">{{'route.name' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"name\" placeholder=\"\" ng-model=\"$ctrl.model.name\">\n<span ng-if=\"$ctrl.errors.name\" class=\"text-danger\">{{$ctrl.errors['name']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"contact\">{{'route.shortName' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"shortName\" placeholder=\"\" ng-model=\"$ctrl.model.shortName\">\n<span ng-if=\"$ctrl.errors.shortName\" class=\"text-danger\">{{$ctrl.errors['shortName']}}</span>\n</div>\n</div>\n<div class=\"row col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"\">{{'route.beginTime' | translate }}</label>\n<time-picker class=\"enable-hour-input\" ng-model=\"$ctrl.model.beginTime\" format=\"hh:mm a\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"liability-limit\">{{'route.liabilityLimit' | translate}}</label>\n<input type=\"text\" id=\"liability-limit\" ng-currency ng-model=\"$ctrl.model.liabilityLimit\" placeholder=\"$0.00\" class=\"form-control\"/>\n</div>\n</div>\n<div id=\"NFCTagId\" class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.NFCScan\">\n<label class=\"remove-white-space\">{{'location.nfc_tag_id' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.NFCTagId\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" ng-required=\"$ctrl.model.NFCScan\"/>\n</div>\n</div>\n<div class=\"row col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"\">{{'route.max_route_time' | translate }}</label>\n<time-picker ng-model=\"$ctrl.model.maxRouteTime\" class=\"enable-hour-input\" is-meridian=\"false\" display-time-format=\"false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"\">{{'route.max_mileage' | translate }}</label>\n<input type=\"number\" class=\"form-control no-spinner\" ng-model=\"$ctrl.model.maxMileage\" min=\"0\" step=\"0.01\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"\">{{'route.estimated_route_speed' | translate }}</label>\n<input type=\"number\" class=\"form-control no-spinner\" ng-model=\"$ctrl.model.estimatedRouteSpeed\" min=\"0\" step=\"0.01\">\n</div>\n</div>\n<div class=\"col-sm-12 toggle-grid-container margin-bottom-10\">\n<div>\n<label for=\"\">{{'route.lunch' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.lunch\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-if=\"$ctrl.model.lunch\">\n<label for=\"\">{{'route.lunch_minutes' | translate }}</label>\n<time-picker ng-model=\"$ctrl.model.lunchMinutes\" is-meridian=\"false\" display-time-format=\"false\" hide-hours=\"true\" tab=\"route\" ng-required=\"$ctrl.model.lunch\" show-seconds=\"true\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div ng-if=\"$ctrl.model.lunch\">\n<label for=\"\">{{'route.lunch_in_truck' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.lunchInTruck\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"\">{{'route.break' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.break\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-if=\"$ctrl.model.break\">\n<label for=\"\">{{'route.break_minutes' | translate }}</label>\n<time-picker ng-model=\"$ctrl.model.breakMinutes\" is-meridian=\"false\" display-time-format=\"false\" hide-hours=\"true\" tab=\"route\" ng-required=\"$ctrl.model.break\" show-seconds=\"true\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div ng-if=\"$ctrl.model.break\">\n<label for=\"\">{{'route.break_in_truck' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.breakInTruck\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"contact\">{{'route.holdRoute' | translate }} </label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.holdRoute\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.holdRoute\" class=\"text-danger\">{{$ctrl.errors['holdRoute']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.specialRoute' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.specialFlag\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.specialFlag\" class=\"text-danger\">{{$ctrl.errors['specialFlag']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.eventRoute' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.eventRoute\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.eventRoute\" class=\"text-danger\">{{$ctrl.errors['eventRoute']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.shuttleRoute' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.shuttleRoute\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.shuttleRoute\" class=\"text-danger\">{{$ctrl.errors['shuttleRoute']}}</span>\n</div>\n<div ng-class=\"{'disabled':true}\">\n<label for=\"contact\">{{'route.updateAfterStop' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.uploadOnEndRouteOnly\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.uploadOnEndRouteOnly\" class=\"text-danger\">{{$ctrl.errors['uploadOnEndRouteOnly']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.loadTruck' | translate }} </label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.loadTruck\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.loadTruck\" class=\"text-danger\">{{$ctrl.errors['loadTruck']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireDriver' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireDriver\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireDriver\" class=\"text-danger\">{{$ctrl.errors['requireDriver']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireGuard' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireGuard\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireGuard\" class=\"text-danger\">{{$ctrl.errors['requireGuard']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.bagoutFlag' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bagoutFlag\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.bagoutFlag\" class=\"text-danger\">{{$ctrl.errors['bagoutFlag']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireThrow' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireThrow\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetTankerAssignment(); $ctrl.validateToggles();\"/>\n<span ng-if=\"$ctrl.errors.requireThrow\" class=\"text-danger\">{{$ctrl.errors['requireThrow']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireLoadedAmount' | translate }} </label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireLoadedAmount\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireLoadedAmount\" class=\"text-danger\">{{$ctrl.errors['requireLoadedAmount']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireResidualScan' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireResidualScan\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireResidualScan\" class=\"text-danger\">{{$ctrl.errors['requireResidualScan']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireBranchScan' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireBranchScan\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireBranchScan\" class=\"text-danger\">{{$ctrl.errors['requireBranchScan']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.optimize_on_checkout' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoOptimize\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoOptimize\" class=\"text-danger\">{{$ctrl.errors['autoOptimize']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.autoOpenAtms' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoOpenATMs\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoOpenATMs\" class=\"text-danger\">{{$ctrl.errors['autoOpenATMs']}}</span>\n</div>\n<div>\n<label for=\"autoCheckIn\">{{'route.auto_check_in' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoCheckIn\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoCheckIn\" class=\"text-danger\">{{$ctrl.errors['autoCheckIn']}}</span>\n</div>\n<div>\n<label for=\"autoCheckOut\">{{'route.auto_check_out' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoCheckOut\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoCheckOut\" class=\"text-danger\">{{$ctrl.errors['autoCheckOut']}}</span>\n</div>\n<div>\n<label for=\"checkOutByTanker\">{{'route.check_out_by_tanker' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.checkOutByTanker\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.checkOutByTanker\" class=\"text-danger\">{{$ctrl.errors['checkOutByTanker']}}</span>\n</div>\n<div>\n<label for=\"autoCheckInUpdate\">{{'route.auto_check_in_update' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoCheckInUpdate\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoCheckInUpdate\" class=\"text-danger\">{{$ctrl.errors['autoCheckInUpdate']}}</span>\n</div>\n<div>\n<label for=\"autoThrowOnPack\">{{'route.auto_throw_on_pack' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoThrowOnPack\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoThrowOnPack\" class=\"text-danger\">{{$ctrl.errors['autoThrowOnPack']}}</span>\n</div>\n<div id=\"NFCScan\">\n<label for=\"NFCScan\">{{'location.nfc_scan' | translate }}</label>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.NFCScan\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div>\n<label for=\"requireTruckScan\">{{'route.scan_from_truck' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireTruckScan\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireTruckScan\" class=\"text-danger\">{{$ctrl.errors['requireTruckScan']}}</span>\n</div>\n<div>\n<label for=\"bagoutOnTruck\">{{'route.bagout_on_truck' | translate}}</label>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bagoutOnTruck\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.bagoutOnTruck\" class=\"text-danger\">{{$ctrl.errors['bagoutOnTruck']}}</span>\n</div>\n</div>\n<div>\n<label for=\"routeCutoff\">{{'route.routeCutoff' | translate}}</label>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.routeCutOff\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.routeCutOff\" class=\"text-danger\">{{$ctrl.errors['routeCutOff']}}</span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.routeCutOff\">\n<label for=\"routeCutoff\">{{'route.routeCutoffTime' | translate}}</label>\n<time-picker format=\"hh:mm a\" ng-model=\"$ctrl.model.routeCutOffTime\" ng-required=\"$ctrl.model.routeCutOff\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div>\n<label for=\"routeCutoff\">{{'route.restrictToTruck' | translate}}</label>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.restrictToTruck\" ng-change=\"$ctrl.restrictToTruckChanged()\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.restrictToTruck\" class=\"text-danger\">{{$ctrl.errors['restrictToTruck']}}</span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.restrictToTruck\">\n<label for=\"routeCutoff\">{{'route.restrictTruck' | translate}}</label>\n<search-and-select ng-required=\"$ctrl.model.restrictToTruck\" ng-model=\"$ctrl.model.restrictTruck\" values=\"$ctrl.truckOptions.options\" key=\"Key\" totalrecords=\"$ctrl.truckOptions.totalRecords\" none-selected=\"'common.none'\" common-search-flag=\"true\" on-click=\"$ctrl.restrictTruckChanged()\"></search-and-select>\n</div>\n<div>\n<label for=\"routeCutoff\">{{'route.optimize_after_stop' | translate}}</label>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.optimizeAfterStop\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.optimizeAfterStop\" class=\"text-danger\">{{$ctrl.errors['optimizeAfterStop']}}</span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.autoCheckIn\">\n<label for=\"autoSendPickupManifest\">{{ 'route.auto_send_pickup_manifest' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoSendPickupManifest\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoSendPickupManifest\" class=\"text-danger\">{{ $ctrl.errors['autoSendPickupManifest'] }}</span>\n</div>\n<div class=\"pickup-manifest-recipient-email-container\" ng-if=\"$ctrl.model.autoSendPickupManifest && $ctrl.model.autoCheckIn\">\n<label for=\"pickupManifestRecipientEmail\">{{ 'route.pickup_manifest_recipient_email' | translate }} *</label>\n<textarea id=\"pickupManifestRecipientEmail\" rows=\"3\" ng-model=\"$ctrl.model.pickupManifestRecipientEmail\" placeholder=\"{{'customer.email' | translate }}\" class=\"form-control\" required ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\">\n\t\t\t\t</textarea>\n<span ng-if=\"$ctrl.errors.pickupManifestRecipientEmail\" class=\"text-danger\">{{ $ctrl.errors['pickupManifestRecipientEmail'] }}</span>\n</div>\n<div>\n<label for=\"origination\">{{'route.origination' | translate }} *</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.origination\" required ng-options=\"origination.value as origination.label for origination in $ctrl.originationOptions\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div>\n<label for=\"sendRouteSheet\">{{ 'route.send_route_sheet' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.sendRouteSheet\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-show=\"$ctrl.model.sendRouteSheet\">\n<label for=\"routeSheetRecipients\" class=\"font-12\">{{'route.route_sheet_recipients' | translate }}\n</label>\n<br>\n<input type=\"text\" class=\"form-control\" id=\"routeSheetRecipients\" placeholder=\"\" ng-model=\"$ctrl.model.routeSheetRecipients\" ng-required=\"$ctrl.model.sendRouteSheet\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\">\n</div>\n<div>\n<label for=\"sendRouteSheet\">Scan User Items</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.scanUserItems\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"sendRouteSheet\">Reschedule Deliveries</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.rescheduleDeliveries\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-if=\"$ctrl.model.rescheduleDeliveries\">\n<label for=\"sendRouteSheet\">Holding Location</label>\n<search-and-select set-id=\"location\" ng-model=\"$ctrl.model.rescheduleHoldLocationId\" values=\"$ctrl.internalLocationsObj.results\" key=\"Key\" totalrecords=\"$ctrl.internalLocationsObj.totalRecords\" onscroll=\"$ctrl.loadInternalLocations(searchKey, offset)\" ng-disabled=\"$ctrl.isLoadingInternalLocations\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div>\n<label for=\"autoTransferAndClose\">{{'route.auto_transfer_and_close' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoTransferAndClose\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.origination === 'TRUCK' && $ctrl.model.restrictToTruck && $ctrl.restrictTruckAddress\">\n<div class=\"alert alert-info\" style=\"margin-bottom: 15px; border-radius: 4px; padding: 10px 15px;\">\n<div>\n<strong>{{'route.restrictTruck' | translate}} Address:</strong> {{$ctrl.restrictTruckAddress}}\n</div>\n</div>\n</div>\n<div class=\"form-group col-sm-12\">\n<label for=\"description\">{{'common.description' | translate }}</label>\n<textarea class=\"form-control\" name=\"\" cols=\"30\" rows=\"5\" ng-model=\"$ctrl.model.description\" placeholder=\"Description\"></textarea>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-10\" ng-if=\"$ctrl.model.requireThrow\">\n<div class=\"col-sm-12\">\n<h4 id=\"inline\" translate=\"route.tankerAssignment\"></h4>\n<div id=\"inline\" class=\"form-group checkbox pull-right\">\n<label>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameForAll()\" ng-model=\"$ctrl.model.sameForAll\"/>\n<strong>{{'location.sameForAll' | translate }}</strong>\n</label>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<table class=\"table table-striped weekdays-table table-bordered\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th ng-repeat=\"day in $ctrl.weekdays.slice(0, 4)\">{{day.label}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'itemHolds.tanker'|translate}}</th>\n<td class=\"col-xs-2 route-tanker-assignment-section\" ng-repeat=\"day in $ctrl.weekdays.slice(0, 4)\">\n<search-and-select ng-model=\"$ctrl.model[day.value].tankerId\" set-id=\"route-{{day.id}}\" values=\"$ctrl.dayArray[$index][day.value]\" key=\"Key\" totalrecords=\"$ctrl.total[$index][day.value].total\" none-selected=\"'common.none'\" on-click=\"$ctrl.updateAll(day.value,'tankerId', day.day)\" extend-dd-width=\"true\" common-search-flag=\"true\"></search-and-select>\n</td>\n</tr>\n</tbody>\n</table>\n<table class=\"table weekend-table table-striped table-bordered\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th class=\"col-xs-2\" ng-repeat=\"day in $ctrl.weekdays.slice(4)\">{{day.label}}</th>\n<th class=\"col-xs-2 display-none-td-cell\">&nbsp;</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'itemHolds.tanker'|translate}}</th>\n<td class=\"col-xs-2 route-tanker-assignment-section\" ng-repeat=\"day in $ctrl.weekdays.slice(4)\">\n<search-and-select ng-model=\"$ctrl.model[day.value].tankerId\" set-id=\"route-{{day.id}}\" values=\"$ctrl.dayArray[$index+4][day.value]\" key=\"Key\" totalrecords=\"$ctrl.total[$index+4][day.value].total\" none-selected=\"'common.none'\" on-click=\"$ctrl.updateAll(day.value,'tankerId', day.day)\" extend-dd-width=\"true\" common-search-flag=\"true\"></search-and-select>\n</td>\n<td class=\"col-xs-2 display-none-td-cell\">&nbsp;</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 form-group\">\n<h4>Route Scheduled</h4>\n<div class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.routeDays\" ng-click=\"$ctrl.isDaySelected(day)\" ng-class=\"{'btn-primary': day.tick, 'btn-default': !day.tick}\">\n{{day.key}}\n</a>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<span class=\"col-sm-12 alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></span>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary margin-bottom-10\" ng-class=\"{'disabled': $ctrl.loading}\" ng-disabled=\"Form.$invalid\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default margin-bottom-10\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}\n</button>\n</div>\n</form>\n</div>\n<style>\n.uib-timepicker .hours .ng-valid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t\t/* display: none; */\n\t}\n\n\t.uib-timepicker .hours .ng-invalid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t\t/* display: none; */\n\t}\n\n\t.enable-hour-input .uib-timepicker .hours .ng-valid {\n\t\tpointer-events: visibleFill !important;\n\t\tbackground-color: #DFF5DF !important;\n    \tborder-color: #BEEBBE !important;\n\t}\n\n\t.enable-hour-input .uib-timepicker .hours .ng-invalid {\n\t\tpointer-events: visibleFill !important;\n\t\tbackground-color: #F9E3E3 !important;\n\t\tborder-color: #F4C6C6 !important;\n\t}\n\n\t/* .horizontal-padding-10 {\n        padding: 0px 29px;\n    } */\n</style>\n";
var id1="routes.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2775 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row_ align-center-vertically\" style=\"display: flex; justify-content: space-between; align-items: center; width: 100%;\">\n<div class=\"col-sm-3\">\n<h4 translate=\"route.edit_route\"></h4>\n</div>\n<div class=\"col-sm-3 text-right\" style=\"padding-right: 15px;\">\n<div class=\"form-group remove-bottom-margin\" style=\"display: inline-flex; align-items: center; gap: 10px;\">\n<label for=\"status\" style=\"margin-bottom: 0;\">{{'location.status' | translate }}</label>\n<input id=\"status\" type=\"checkbox\" class=\"form-control\" ng-model=\"$ctrl.model.active\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\"/>\n</div>\n</div>\n</div>\n<hr class=\"remove-bottom-margin\" style=\"width: 100%;\"/>\n<div class=\"col-sm-12 margin-10 table-responsive\" ng-if=\"$ctrl.pendingRouteChanges.results.length\">\n<div class=\"remove-pad col-sm-12\">\n<h4>{{'location.pending_changes' | translate}} <span class=\"badge badge-light future-location-changes-badge\">{{$ctrl.pendingRouteChanges.total}}</span></h4>\n</div>\n<table class=\"table table-hover table-bordered table-pad-3 font-12\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'routeSheet.date' | translate}}</th>\n<th class=\"text-center\">{{'location.change_type' | translate}}</th>\n<th class=\"text-center\">{{'common.previous' | translate}}</th>\n<th class=\"text-center\">{{'location.changed' | translate}}</th>\n<th class=\"text-center\">{{'users.user' | translate}}</th>\n<th class=\"text-center\"></th>\n</tr>\n</thead>\n<tbody>\n<tr class=\"future-location-changes-bg-color\" ng-repeat=\"history in $ctrl.pendingRouteChanges.results track by $index\">\n<td class=\"text-center\">{{history.executeAt | date: 'MM-dd-yyyy | hh:mm a'}}</td>\n<td class=\"text-danger text-center\">{{$ctrl.translateMessage(history.key)}}</td>\n<td class=\"text-center\">\n<span ng-if=\"history.previous.length\" ng-repeat=\"previousChanges in history.previous\">\n<div>{{previousChanges}}<span ng-if=\"$index + 1 !== history.previous.length\">,</span></div>\n</span>\n<span ng-if=\"!history.previous.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"history.changed.length\" ng-repeat=\"changedChanges in history.changed\">\n<div>{{changedChanges}}<span ng-if=\"$index + 1 !== history.changed.length\">,</span></div>\n</span>\n<span ng-if=\"!history.changed.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">{{history.user}}</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.confirmDelete(history.jobId)\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n<hr class=\"remove-bottom-margin\"/>\n</div>\n<div class=\"col-sm-12 margin-10\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row_\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"id\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" id=\"id\" placeholder=\"\" ng-model=\"$ctrl.rawId\" disabled=\"\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"name\">{{'route.name' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"name\" placeholder=\"\" ng-model=\"$ctrl.model.name\">\n<span ng-if=\"$ctrl.errors.name\" class=\"text-danger\">{{$ctrl.errors['name']}}</span>\n</div>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"contact\">{{'route.shortName' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"shortName\" placeholder=\"\" ng-model=\"$ctrl.model.shortName\">\n<span ng-if=\"$ctrl.errors.shortName\" class=\"text-danger\">{{$ctrl.errors['shortName']}}</span>\n</div>\n</div>\n<div class=\"row_\">\n<div class=\"form-group col-sm-4\">\n<label for=\"\">{{'route.beginTime' | translate }}</label>\n<time-picker class=\"enable-hour-input\" ng-model=\"$ctrl.model.beginTime\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"liability-limit\">{{'route.liabilityLimit' | translate}}</label>\n<input type=\"text\" id=\"liability-limit\" ng-currency ng-model=\"$ctrl.model.liabilityLimit\" placeholder=\"$0.00\" class=\"form-control\"/>\n</div>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"contact\">{{'route.branchId' | translate }} *</label>\n<br><select id=\"branchid\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.branch\" required ng-options=\"branch for branch in $ctrl.branch\" ng-change=\"$ctrl.branchChanged()\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n<span ng-if=\"$ctrl.errors.branch\" class=\"text-danger\">{{$ctrl.errors['branch']}}</span>\n</div>\n<div class=\"row\"></div>\n<div class=\"row col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"\">{{'route.max_route_time' | translate }}</label>\n<time-picker ng-model=\"$ctrl.model.maxRouteTime\" class=\"enable-hour-input\" is-meridian=\"false\" display-time-format=\"false\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"\">{{'route.max_mileage' | translate }}</label>\n<input type=\"number\" class=\"form-control no-spinner\" ng-model=\"$ctrl.model.maxMileage\" min=\"0\" step=\"0.01\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"\">{{'route.estimated_route_speed' | translate }}</label>\n<input type=\"number\" class=\"form-control no-spinner\" ng-model=\"$ctrl.model.estimatedRouteSpeed\" min=\"0\" step=\"0.01\">\n</div>\n</div>\n<div class=\"col-sm-12 toggle-grid-container margin-bottom-10\">\n<div>\n<label for=\"\">{{'route.lunch' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.lunch\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-if=\"$ctrl.model.lunch\">\n<label for=\"\">{{'route.lunch_minutes' | translate }}</label>\n<time-picker ng-model=\"$ctrl.model.lunchMinutes\" is-meridian=\"false\" display-time-format=\"false\" ng-required=\"$ctrl.model.lunch\" hide-hours=\"true\" tab=\"route\" show-seconds=\"true\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div ng-if=\"$ctrl.model.lunch\">\n<label for=\"\">{{'route.lunch_in_truck' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.lunchInTruck\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"\">{{'route.break' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.break\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-if=\"$ctrl.model.break\">\n<label for=\"\">{{'route.break_minutes' | translate }}</label>\n<time-picker ng-model=\"$ctrl.model.breakMinutes\" is-meridian=\"false\" display-time-format=\"false\" ng-required=\"$ctrl.model.break\" tab=\"route\" hide-hours=\"true\" show-seconds=\"true\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n</time-picker>\n</div>\n<div ng-if=\"$ctrl.model.break\">\n<label for=\"\">{{'route.break_in_truck' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.breakInTruck\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"contact\">{{'route.holdRoute' | translate }} </label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.holdRoute\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.holdRoute\" class=\"text-danger\">{{$ctrl.errors['holdRoute']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.specialRoute' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.specialFlag\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.specialFlag\" class=\"text-danger\">{{$ctrl.errors['specialFlag']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.eventRoute' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.eventRoute\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.eventRoute\" class=\"text-danger\">{{$ctrl.errors['eventRoute']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.shuttleRoute' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.shuttleRoute\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.shuttleRoute\" class=\"text-danger\">{{$ctrl.errors['shuttleRoute']}}</span>\n</div>\n<div ng-class=\"{'disabled':true}\">\n<label for=\"contact\">{{'route.updateAfterStop' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.uploadOnEndRouteOnly\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.uploadOnEndRouteOnly\" class=\"text-danger\">{{$ctrl.errors['uploadOnEndRouteOnly']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.loadTruck' | translate }} </label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.loadTruck\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.loadTruck\" class=\"text-danger\">{{$ctrl.errors['loadTruck']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireDriver' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireDriver\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireDriver\" class=\"text-danger\">{{$ctrl.errors['requireDriver']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireGuard' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireGuard\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireGuard\" class=\"text-danger\">{{$ctrl.errors['requireGuard']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.bagoutFlag' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bagoutFlag\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.bagoutFlag\" class=\"text-danger\">{{$ctrl.errors['bagoutFlag']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireThrow' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireThrow\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.resetTankerAssignment(); $ctrl.validateToggles();\"/>\n<span ng-if=\"$ctrl.errors.requireThrow\" class=\"text-danger\">{{$ctrl.errors['requireThrow']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireLoadedAmount' | translate }} </label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireLoadedAmount\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireLoadedAmount\" class=\"text-danger\">{{$ctrl.errors['requireLoadedAmount']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireResidualScan' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireResidualScan\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireResidualScan\" class=\"text-danger\">{{$ctrl.errors['requireResidualScan']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.requireBranchScan' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireBranchScan\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireBranchScan\" class=\"text-danger\">{{$ctrl.errors['requireBranchScan']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.optimize_on_checkout' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoOptimize\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoOptimize\" class=\"text-danger\">{{$ctrl.errors['autoOptimize']}}</span>\n</div>\n<div>\n<label for=\"contact\">{{'route.autoOpenAtms' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoOpenATMs\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoOpenATMs\" class=\"text-danger\">{{$ctrl.errors['autoOpenATMs']}}</span>\n</div>\n<div>\n<label for=\"autoCheckIn\">{{'route.auto_check_in' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoCheckIn\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoCheckIn\" class=\"text-danger\">{{$ctrl.errors['autoCheckIn']}}</span>\n</div>\n<div>\n<label for=\"autoCheckOut\">{{'route.auto_check_out' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoCheckOut\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoCheckOut\" class=\"text-danger\">{{$ctrl.errors['autoCheckOut']}}</span>\n</div>\n<div>\n<label for=\"checkOutByTanker\">{{'route.check_out_by_tanker' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.checkOutByTanker\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.checkOutByTanker\" class=\"text-danger\">{{$ctrl.errors['checkOutByTanker']}}</span>\n</div>\n<div>\n<label for=\"autoCheckInUpdate\">{{'route.auto_check_in_update' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoCheckInUpdate\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoCheckInUpdate\" class=\"text-danger\">{{$ctrl.errors['autoCheckInUpdate']}}</span>\n</div>\n<div ng-if=\"$ctrl.model.requireThrow\">\n<label for=\"autoThrowOnPack\">{{'route.auto_throw_on_pack' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoThrowOnPack\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoThrowOnPack\" class=\"text-danger\">{{$ctrl.errors['autoThrowOnPack']}}</span>\n</div>\n<div id=\"NFCScan\">\n<label for=\"NFCScan\">{{'location.nfc_scan' | translate }}</label>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.NFCScan\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div id=\"NFCTagId\" ng-if=\"$ctrl.model.NFCScan\">\n<label class=\"remove-white-space\">{{'location.nfc_tag_id' | translate }} </label>\n<div>\n<input type=\"text\" class=\"form-control width-85\" ng-model=\"$ctrl.model.NFCTagId\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" ng-required=\"$ctrl.model.NFCScan\"/>\n</div>\n</div>\n<div>\n<label for=\"requireTruckScan\">{{'route.scan_from_truck' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.requireTruckScan\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.requireTruckScan\" class=\"text-danger\">{{$ctrl.errors['requireTruckScan']}}</span>\n</div>\n<div>\n<label for=\"bagoutOnTruck\">{{'route.bagout_on_truck' | translate}}</label>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bagoutOnTruck\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.bagoutOnTruck\" class=\"text-danger\">{{$ctrl.errors['bagoutOnTruck']}}</span>\n</div>\n</div>\n<div>\n<label for=\"routeCutoff\">{{'route.routeCutoff' | translate}}</label>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.routeCutOff\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.routeCutOff\" class=\"text-danger\">{{$ctrl.errors['routeCutOff']}}</span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.routeCutOff\">\n<label for=\"routeCutoff\">{{'route.routeCutoffTime' | translate}}</label>\n<time-picker format=\"hh:mm a\" class=\"width-85\" ng-model=\"$ctrl.model.routeCutOffTime\" ng-required=\"$ctrl.model.routeCutOff\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div>\n<label for=\"routeCutoff\">{{'route.restrictToTruck' | translate}}</label>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.restrictToTruck\" ng-change=\"$ctrl.restrictToTruckChanged()\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.restrictToTruck\" class=\"text-danger\">{{$ctrl.errors['restrictToTruck']}}</span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.restrictToTruck\">\n<label for=\"routeCutoff\">{{'route.restrictTruck' | translate}}</label>\n<search-and-select class=\"width-85\" ng-required=\"$ctrl.model.restrictToTruck\" ng-model=\"$ctrl.model.restrictTruck\" values=\"$ctrl.truckOptions.options\" key=\"Key\" totalrecords=\"$ctrl.truckOptions.totalRecords\" none-selected=\"'common.none'\" common-search-flag=\"true\" on-click=\"$ctrl.restrictTruckChanged()\"></search-and-select>\n</div>\n<div>\n<label for=\"routeCutoff\">{{'route.optimize_after_stop' | translate}}</label>\n<div>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.optimizeAfterStop\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.optimizeAfterStop\" class=\"text-danger\">{{$ctrl.errors['optimizeAfterStop']}}</span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.autoCheckIn\">\n<label for=\"autoSendPickupManifest\">{{ 'route.auto_send_pickup_manifest' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoSendPickupManifest\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoSendPickupManifest\" class=\"text-danger\">{{ $ctrl.errors['autoSendPickupManifest'] }}</span>\n</div>\n<div class=\"pickup-manifest-recipient-email-container\" ng-if=\"$ctrl.model.autoSendPickupManifest && $ctrl.model.autoCheckIn\">\n<label for=\"pickupManifestRecipientEmail\">{{ 'route.pickup_manifest_recipient_email' | translate }} *</label>\n<textarea id=\"pickupManifestRecipientEmail\" rows=\"3\" ng-model=\"$ctrl.model.pickupManifestRecipientEmail\" placeholder=\"{{'customer.email' | translate }}\" class=\"form-control\" required ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\">\n\t\t\t\t</textarea>\n<span ng-if=\"$ctrl.errors.pickupManifestRecipientEmail\" class=\"text-danger\">{{ $ctrl.errors['pickupManifestRecipientEmail'] }}</span>\n</div>\n<div>\n<label for=\"origination\">{{'route.origination' | translate }} *</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.origination\" required ng-change=\"$ctrl.originationChanged()\" ng-options=\"origination.value as origination.label for origination in $ctrl.originationOptions\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div>\n<label for=\"sendRouteSheet\">{{ 'route.send_route_sheet' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.sendRouteSheet\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-show=\"$ctrl.model.sendRouteSheet\">\n<label for=\"routeSheetRecipients\" class=\"font-12\">{{'route.route_sheet_recipients' | translate }}\n</label>\n<br>\n<input type=\"text\" class=\"form-control\" id=\"routeSheetRecipients\" placeholder=\"\" ng-model=\"$ctrl.model.routeSheetRecipients\" ng-required=\"$ctrl.model.sendRouteSheet\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\">\n</div>\n<div>\n<label for=\"sendRouteSheet\">Scan User Items</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.scanUserItems\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"sendRouteSheet\">Reschedule Deliveries</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.rescheduleDeliveries\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-if=\"$ctrl.model.rescheduleDeliveries\">\n<label for=\"sendRouteSheet\">Holding Location</label>\n<search-and-select set-id=\"location\" ng-model=\"$ctrl.model.rescheduleHoldLocationId\" values=\"$ctrl.internalLocationsObj.results\" key=\"Key\" totalrecords=\"$ctrl.internalLocationsObj.totalRecords\" onscroll=\"$ctrl.loadInternalLocations(searchKey, offset)\" ng-disabled=\"$ctrl.isLoadingInternalLocations\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div>\n<label for=\"autoTransferAndClose\">{{'route.auto_transfer_and_close' | translate }}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoTransferAndClose\" switch-size=\"small\" switch-on-text=\"{{ 'common.yes' | translate }}\" switch-off-text=\"{{ 'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n<span ng-if=\"$ctrl.errors.autoTransferAndClose\" class=\"text-danger\">{{$ctrl.errors['autoTransferAndClose']}}</span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.origination === 'TRUCK' && $ctrl.model.restrictToTruck && $ctrl.restrictTruckAddress\">\n<div class=\"alert alert-info\" style=\"margin-bottom: 15px; border-radius: 4px; padding: 10px 15px;\">\n<div>\n<strong>{{'route.restrictTruck' | translate}} Address:</strong> {{$ctrl.restrictTruckAddress}}\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<textarea name=\"\" id=\"description\" cols=\"30\" rows=\"5\" ng-model=\"$ctrl.model.description\" class=\"form-control\"></textarea>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.requireThrow\">\n<div class=\"col-sm-12 remove-pad\">\n<h4 id=\"inline\" translate=\"route.tankerAssignment\"></h4>\n<div id=\"inline\" class=\"form-group checkbox pull-right\">\n<label>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameForAll()\" ng-model=\"$ctrl.model.sameForAll\"/>\n<strong>{{'location.sameForAll' | translate }}</strong>\n</label>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<table class=\"table table-striped weekdays-table table-bordered\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th ng-repeat=\"day in $ctrl.weekdays.slice(0, 4)\">{{day.label}}</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'itemHolds.tanker'|translate}}</th>\n<td class=\"col-xs-2 route-tanker-assignment-section\" ng-repeat=\"day in $ctrl.weekdays.slice(0, 4)\">\n<search-and-select ng-model=\"$ctrl.model[day.value].tankerId\" set-id=\"route-{{day.id}}\" values=\"$ctrl.dayArray[$index][day.value]\" key=\"Key\" totalrecords=\"$ctrl.total[$index][day.value].total\" none-selected=\"'common.none'\" on-click=\"$ctrl.updateAll(day.value,'tankerId', day.day)\" extend-dd-width=\"true\" common-search-flag=\"true\"></search-and-select>\n</td>\n</tr>\n</tbody>\n</table>\n<table class=\"table weekend-table table-striped table-bordered\">\n<thead>\n<tr>\n<th class=\"col-xs-1\">{{'location.weekday'|translate}}</th>\n<th class=\"col-xs-2\" ng-repeat=\"day in $ctrl.weekdays.slice(4)\">{{day.label}}</th>\n<th class=\"col-xs-2 display-none-td-cell\">&nbsp;</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"col-xs-1\">{{'itemHolds.tanker'|translate}}</th>\n<td class=\"col-xs-2 route-tanker-assignment-section\" ng-repeat=\"day in $ctrl.weekdays.slice(4)\">\n<search-and-select ng-model=\"$ctrl.model[day.value].tankerId\" set-id=\"route-{{day.id}}\" values=\"$ctrl.dayArray[$index+4][day.value]\" key=\"Key\" totalrecords=\"$ctrl.total[$index+4][day.value].total\" none-selected=\"'common.none'\" on-click=\"$ctrl.updateAll(day.value,'tankerId', day.day)\" extend-dd-width=\"true\" common-search-flag=\"true\"></search-and-select>\n</td>\n<td class=\"col-xs-2 display-none-td-cell\">&nbsp;</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 form-group\">\n<h4>Route Scheduled</h4>\n<div class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.routeDays\" ng-click=\"$ctrl.isDaySelected(day)\" ng-class=\"{'btn-primary': day.tick, 'btn-default': !day.tick}\">\n{{day.key}}\n</a>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<h4>Route Stops Scheduled</h4>\n<div id=\"map\" class=\"leaf-map margin-bottom-10 col-sm-12 remove-z-index\"></div>\n<div class=\"text-right\" ng-show=\"::$ctrl.hasACL['edit']\">\n<button type=\"button\" class=\"btn btn-warning\" ng-disabled=\"$ctrl.isLoading\" ng-click=\"$ctrl.routeTransferView()\">{{'route.transfer' | translate}}</button>\n</div>\n<div class=\"form-group margin-top-10\">\n<div class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.days\" ng-disabled=\"$ctrl.loadingRouteSequence\" ng-click=\"$ctrl.selectDay(day)\" ng-class=\"{'btn-primary': $ctrl.selectedDay === day.value,'btn-default': $ctrl.selectedDay !== day.value, 'disabled' : $ctrl.loadingRouteSequence}\">\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.loadingRouteSequence && $ctrl.selectedDay === day.value, 'disabled': $ctrl.loadingRouteSequence }\">\n</i>\n{{day.label}}\n</a>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.routeSequenceData.length\">\n<div class=\"margin-10 pull-left col-sm-6 remove-left-pad\">\n<label for=\"\">{{'route.routeStop' | translate}} </label>\n</div>\n<div class=\"col-sm-6 remove-right-pad text-right\">\n<button type=\"button\" class=\"btn btn-md btn-success\" ng-click=\"$ctrl.printLocationBarcodes()\">\n{{ 'orderPacking.print_labels' | translate }}\n</button>\n</div>\n</div>\n<div class=\"alert alert-info route-seq-info margin-top-05 col-sm-12 remove-bottom-margin\" ng-if=\"$ctrl.routeSequenceData.length > 1\">\n<span class=\"glyphicon glyphicon-info-sign\"></span>\n{{'route.sequenceReorderInfo' | translate}}\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad form-group margin-top-10\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loadingRouteSequence}\"></span>\n<ul ng-if=\"$ctrl.routeSequenceData && $ctrl.routeSequenceData.length\" dnd-list=\"$ctrl.routeSequenceData\" class=\"list-group remove-bottom-margin location-sequence\">\n<li class=\"list-group-item display-flex\" ng-repeat=\"location in $ctrl.routeSequenceData\" ng-class=\"{'list-highlight' : location[$ctrl.currrentSelectedDay] === 0}\" dnd-draggable=\"location\" dnd-moved=\"$ctrl.routeSequenceLocationMoved($index)\" dnd-effect-allowed=\"move\">\n<div class=\"col-sm-1 align-center-vertically\" ng-if=\"$ctrl.routeSequenceData.length === 1\" ng-class=\"{'inactive-location' : !location.active}\">\n<strong>{{$index+1}}</strong></div>\n<div class=\"col-sm-1 remove-pad route-seq-order\" dnd-nodrag ng-if=\"$ctrl.routeSequenceData.length > 1\">\n<input type=\"number\" class=\"form-control route-seq-input no-spinner\" min=\"1\" max=\"{{$ctrl.routeSequenceData.length}}\" ng-model=\"$ctrl.sequenceInput[$index]\" ng-model-options=\"{ debounce: 1000, allowInvalid: true }\" ng-change=\"$ctrl.sequenceTyped($index)\">\n<span class=\"route-seq-move\">\n<button type=\"button\" class=\"btn btn-xs btn-default\" ng-disabled=\"$index === 0\" ng-click=\"$ctrl.moveLocation($index, -1)\">\n<span class=\"glyphicon glyphicon-chevron-up\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-default\" ng-disabled=\"$index === $ctrl.routeSequenceData.length - 1\" ng-click=\"$ctrl.moveLocation($index, 1)\">\n<span class=\"glyphicon glyphicon-chevron-down\"></span>\n</button>\n</span>\n</div>\n<div class=\"align-center-vertically\" ng-class=\"$ctrl.routeSequenceData.length > 1 ? 'col-sm-11' : 'col-sm-11'\">\n<div class=\"col-sm-7\">\n<span ng-class=\"{'inactive-location' : !location.active}\">\n<span ng-if=\"!location.active\"><strong>({{'route.inactive_location' | translate}})</strong></span>\n<strong>{{location.name}} | {{location.address}}, {{location.city}}</strong>\n</span>\n</div>\n<div class=\"col-sm-1\">\n<img ng-src=\"{{$ctrl.loadImage(location.locationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"\"/>\n</div>\n<div class=\"col-sm-3 align-center-vertically\" ng-class=\"{'inactive-location' : !location.active}\">\n<strong>{{location.id}}</strong>\n</div>\n<div class=\"col-sm-2 align-center-vertically small\" ng-class=\"{'inactive-location' : !location.active}\">\n<span><b>{{location.branchId}}</b></span>\n</div>\n</div>\n<div class=\"pull-right\" ng-show=\"::$ctrl.hasACL['edit']\">\n<button type=\"button\" ng-click=\"$ctrl.editLocation(location)\" class=\"btn btn-default btn-sm\" uib-tooltip=\"Edit&nbsp;Location\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</li>\n</ul>\n<div class=\"remove-bottom-margin alert alert-danger text-center\" ng-show=\"!$ctrl.routeSequenceData || !$ctrl.routeSequenceData.length\">\n<strong>{{'route.noRouteSequenceLocation' | translate}} {{$ctrl.getSelectedDay()}}</strong>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<span class=\"col-sm-12 alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></span>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary margin-bottom-10\" ng-show=\"::$ctrl.hasACL['edit']\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default margin-bottom-10\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}\n</button>\n<button type=\"button\" ng-if=\"$ctrl.isTankerAssignmentChanged\" class=\"btn btn-warning margin-bottom-10\" ng-click=\"$ctrl.saveLater()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'location.save_later'| translate }}\n</button>\n</div>\n</form>\n</div>\n<style>\n.uib-timepicker .hours .ng-valid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t\t/* display: none; */\n\t}\n\n\t.uib-timepicker .hours .ng-invalid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t\t/* display: none; */\n\t}\n\n\t.enable-hour-input .uib-timepicker .hours .ng-valid {\n\t\tpointer-events: visibleFill !important;\n\t\tbackground-color: #DFF5DF !important;\n\t\tborder-color: #BEEBBE !important;\n\t}\n\n\t.enable-hour-input .uib-timepicker .hours .ng-invalid {\n\t\tpointer-events: visibleFill !important;\n\t\tbackground-color: #F9E3E3 !important;\n\t\tborder-color: #F4C6C6 !important;\n\t}\n\n\t.route-seq-info {\n\t\tpadding: 8px 12px;\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.route-seq-info .glyphicon {\n\t\tmargin-right: 5px;\n\t}\n\n\t.route-seq-order {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 4px;\n\t}\n\n\t.route-seq-input {\n\t\twidth: 52px;\n\t\theight: 28px;\n\t\tpadding: 2px 4px;\n\t\ttext-align: center;\n\t\tfont-weight: bold;\n\t}\n\n\t.route-seq-move {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t}\n\n\t.route-seq-move .btn {\n\t\tpadding: 0 5px;\n\t\tline-height: 1.1;\n\t\tfont-size: 10px;\n\t}\n\n\t/* .horizontal-padding-10 {\n        padding: 0px 29px;\n    } */\n</style>\n";
var id1="routes.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2776 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"routes.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"route.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"routes.create\">\n<a translate=\"route.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="routes.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2777 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<span class=\"col-sm-10\">\n<h4 translate=\"\">{{'serviceSettings.service_order_actions' | translate}}</h4>\n</span>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-10 remove-pad\">\n<input ng-change=\"$ctrl.loadData()\" type=\"text\" ng-model-options=\"{debounce: 1000}\" placeholder=\"{{ 'addBagModal.search' | translate }}\" class=\"input-lg form-control\" ng-model=\"$ctrl.model.searchText\" search-autofocus>\n</div>\n<div class=\"margin-top-05 col-sm-2 remove-right-pad\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.createActionCodeModal()\" ng-if=\"$ctrl.hasACL['create']\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'serviceSettings.action_code' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"remove-padding\" ng-if=\"!$ctrl.model.loading\">\n<div class=\"panel panel-default margin-10 remove-bottom-pad\" ng-repeat=\"actions in $ctrl.model.actionCodes track by $index\">\n<div class=\"cursor-pointer panel-heading\">\n<div class=\"row panel-title bucket_text_align_center remove-left-padd remove-right-padd\">\n<div class=\"col-sm-10 remove-left-padd remove-right-padd\" ng-click=\"actions.panelExpanded=!actions.panelExpanded; $ctrl.getActionCodeResponse(actions);\">\n<i class=\"glyphicon glyphicon-triangle-bottom\" ng-show=\"actions.panelExpanded\"></i>\n<i class=\"glyphicon glyphicon-triangle-right\" ng-hide=\"actions.panelExpanded\"></i>\n<strong class=\"f-14\">{{actions.label}}</strong>\n</div>\n</div>\n</div>\n<div ng-if=\"actions.panelExpanded\" class=\"panel-body\">\n<div class=\"row_\">\n<div class=\"col-sm-12 remove-left-pad\">\n<div class=\"col-sm-4 remove-left-pad\">\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label class=\"font-12\">{{'serviceSettings.id' | translate}}</label>\n<input readonly=\"readonly\" type=\"text\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.id\" class=\"text-center form-control\"/>\n</div>\n</div>\n<div class=\"col-sm-9\">\n<div class=\"form-group\">\n<label class=\"font-12\">{{'serviceSettings.label' | translate}}</label>\n<input type=\"text\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.label\" class=\"form-control\" required/>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label class=\"font-12\">{{'location.preventativeMaintenance' | translate}}</label>\n<div class=\"margin-top-02\">\n<search-and-select ng-model=\"$ctrl.model.actionCodeData[actions.id].details.preventativeMaintenanceId\" set-id=\"preventativeMaintenanceEdit_{{actions.id}}\" values=\"$ctrl.pmSearchList\" key=\"Key\" totalrecords=\"$ctrl.totalPMRecords\" onscroll=\"$ctrl.loadPreventativeMaintenances(searchKey, offset)\" class=\"dd-z-index\" none-selected=\"'common.none'\" common-search-flag=\"false\" ng-style=\"$ctrl.isPMSuspended($ctrl.model.actionCodeData[actions.id].details.preventativeMaintenanceId) && {'background-color': '#F9E3E3'}\">\n</search-and-select>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-8\">\n<div class=\"form-group col-sm-3 remove-white-space\">\n<label for=\"minResponse\" class=\"font-12\">{{'serviceSettings.resolve_required' | translate}}</label>\n<br/>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.actionCodeData[actions.id].details.minResponseSelect\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3 remove-pad\">\n<label for=\"actonCode\" class=\"font-12\">{{'serviceSettings.multiple_resolve_codes' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.actionCodeData[actions.id].details.maxResponseSelect\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"thresholds\" class=\"font-12\">{{'serviceSettings.thresholds' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.actionCodeData[actions.id].details.thresholds\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"thresholds\" class=\"font-12\">Parts Capture</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.actionCodeData[actions.id].details.partsCapture\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"requirePicture\" class=\"font-12\">{{'serviceSettings.require_picture' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.actionCodeData[actions.id].details.requirePicture\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3 remove-pad\">\n<label for=\"requireCause\" class=\"font-12\">{{'serviceSettings.require_root_cause' | translate}}</label>\n<br/>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.actionCodeData[actions.id].details.minRootCauseSelect\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3 remove-white-space\">\n<label for=\"requireMultipleCause\" class=\"font-12\">{{'serviceSettings.multiple_root_cause' | translate}}</label>\n<br/>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.actionCodeData[actions.id].details.maxRootCauseSelect\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"openRequired\" class=\"font-12\">{{'serviceSettings.open_required' | translate}}</label>\n<br/>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.actionCodeData[actions.id].details.openRequired\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label class=\"font-12\">{{'serviceSettings.priority' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.serviceActionPriorityId\" ng-options=\"priority.id as priority.priority for priority in $ctrl.prioritiesList\">\n<option value=\"\">(None)</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3 remove-pad\">\n<label class=\"font-12\">{{'serviceSettings.service_type' | translate}}</label><br>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm\" ng-repeat=\"stype in ['FLM', 'SLM']\" ng-click=\"$ctrl.model.actionCodeData[actions.id].details.serviceType = stype\" ng-class=\"{'btn-success': $ctrl.model.actionCodeData[actions.id].details.serviceType === stype, 'btn-default': $ctrl.model.actionCodeData[actions.id].details.serviceType !== stype}\">\n&nbsp;{{stype}}&nbsp;\n</button>\n</div>\n</div>\n<div class=\"form-group col-sm-5\">\n<label class=\"font-12\">{{'serviceSettings.expected_time_to_complete' | translate}}</label>\n<time-picker class=\"time-picker-width\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.expectedCompletionTime\" format=\"hh:mm\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" is-meridian=\"false\" display-time-format=\"false\">\n</time-picker>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"autoAssignable_{{actions.id}}\" class=\"font-12\">Auto Assignable</label>\n<br/>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.actionCodeData[actions.id].details.autoAssignable\" switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad\">\n<div class=\"col-sm-12 d-a-flex\">\n<h4>{{'serviceSettings.resolve_codes' | translate}}</h4>\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn pull-right\" ng-click=\"$ctrl.addNewServiceResponse(actions.id)\" ng-if=\"$ctrl.hasACL['edit']\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n</div>\n<div class=\"_form-group col-sm-12\">\n<ul dnd-list=\"$ctrl.model.actionCodeData[actions.id].details.responses\" dnd-allowed-types=\"actions.id\" class=\"w-60\">\n<li ng-repeat=\"item in $ctrl.model.actionCodeData[actions.id].details.responses\" dnd-draggable=\"item\" dnd-effect-allowed=\"move\" dnd-moved=\"$ctrl.model.actionCodeData[actions.id].details.responses.splice($index, 1); {{$ctrl.model.actionCodeData[actions.id].details.responses[$index].sortOrder = $index+1}}\" dnd-selected=\"models.selected = item\" ng-class=\"{selected: models.selected === item}\" style=\"padding-bottom: 30px;\">\n<div class=\"margin-top-10 col-sm-9\">\n<div class=\"col-sm-12 d-flex remove-left-pad remove-pad-right\">\n<input readonly=\"readonly\" class=\"form-control text-center response-no-input cursor-pointer\" type=\"text\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.responses[$index].sortOrder\" required/>\n<input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.responses[$index].label\" required/>\n<div>\n<div class=\"ml-5\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"$ctrl.hasACL['edit']\" ng-click=\"$ctrl.removeServiceResponse(actions.id, $index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"margin-top-10 remove-left-pad col-sm-3\">\n<select class=\"form-control\" ng-options=\"category.value as category.label for category in $ctrl.categoryList\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.responses[$index].category\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-12 remove-left-pad root-cause-container\">\n<div class=\"col-sm-12 d-a-flex\">\n<h4>{{'serviceSettings.root_causes' | translate}}</h4>\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn pull-right\" ng-click=\"$ctrl.addNewRootCause(actions.id)\" ng-if=\"$ctrl.hasACL['edit']\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}\n</button>\n</div>\n<div class=\"_form-group col-sm-12\">\n<ul dnd-list=\"$ctrl.model.actionCodeData[actions.id].details.rootCauses\" dnd-allowed-types=\"actions.id\" class=\"w-60\">\n<li ng-repeat=\"item in $ctrl.model.actionCodeData[actions.id].details.rootCauses\" dnd-draggable=\"item\" dnd-effect-allowed=\"move\" dnd-moved=\"$ctrl.model.actionCodeData[actions.id].details.rootCauses.splice($index, 1); {{$ctrl.model.actionCodeData[actions.id].details.rootCauses[$index].sortOrder = $index+1}}\" dnd-selected=\"models.selected = item\" ng-class=\"{selected: models.selected === item}\" style=\"padding-bottom: 30px\">\n<div class=\"margin-top-10 col-sm-12\">\n<div class=\"col-sm-12 d-flex remove-left-pad remove-pad-right\">\n<input readonly=\"readonly\" class=\"form-control text-center response-no-input cursor-pointer\" type=\"text\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.rootCauses[$index].sortOrder\" required/>\n<input class=\"form-control\" type=\"text\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.rootCauses[$index].label\" required/>\n<div>\n<div class=\"ml-5\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"$ctrl.hasACL['edit']\" ng-click=\"$ctrl.removeRootCause(actions.id, $index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.model.actionCodeData[actions.id].details.thresholds\">\n<div class=\"col-sm-12\">\n<br/>\n<div class=\"col-sm-3\">\n<time-picker class=\"time-picker-width\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.redThreshold\" format=\"hh:mm a\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" is-meridian=\"false\" display-time-format=\"false\">\n</time-picker>\n</div>\n<div class=\"col-sm-3\">\n<time-picker class=\"orange-thres-hold time-picker-width\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.orangeThreshold\" format=\"hh:mm a\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" is-meridian=\"false\" display-time-format=\"false\">\n</time-picker>\n</div>\n<div class=\"col-sm-3\">\n<time-picker class=\"yellow-thres-hold time-picker-width\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.yellowThreshold\" format=\"hh:mm a\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" is-meridian=\"false\" display-time-format=\"false\">\n</time-picker>\n</div>\n<div class=\"col-sm-3\">\n<time-picker class=\"blue-thres-hold time-picker-width\" ng-model=\"$ctrl.model.actionCodeData[actions.id].details.otherThreshold\" format=\"hh:mm a\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" is-meridian=\"false\" display-time-format=\"false\">\n</time-picker>\n</div>\n</div>\n</div>\n<div class=\"align-center-horizontally\" ng-if=\"$ctrl.isDuplicate\">\n<span class=\"alert alert-danger text-center remove-bottom-pad threshold-error\">{{'serviceSettings.duplicate_thresholds' | translate}}</span>\n</div>\n<div class=\"margin-top-05 col-sm-12\" ng-if=\"($ctrl.model.actionCodeData[actions.id].details.minResponseSelect \n                                         && $ctrl.model.actionCodeData[actions.id].details.responses.length == 0) && !$ctrl.loading\">\n<div class=\"col-sm-12 alert text-center alert-danger remove-bottom-margin\">\n{{'serviceSettings.require_resolve_codes' | translate}}\n</div>\n</div>\n<div class=\"margin-top-05 col-sm-12\" ng-if=\"($ctrl.model.actionCodeData[actions.id].details.minRootCauseSelect \n                                         && $ctrl.model.actionCodeData[actions.id].details.rootCauses.length == 0) && !$ctrl.loading\">\n<div class=\"col-sm-12 alert text-center alert-danger remove-bottom-margin\">{{'serviceSettings.require_root_causes' | translate}}</div>\n</div>\n<div class=\"col-sm-12 margin-10\">\n<button type=\"button\" ng-click=\"$ctrl.updateServiceItem(actions.id)\" ng-if=\"$ctrl.hasACL['edit']\" ng-disabled=\"($ctrl.disableCodeUpdate(actions.id) || !$ctrl.model.actionCodeData[actions.id].details.label || $ctrl.loading || ($ctrl.model.actionCodeData[actions.id].details.minRootCauseSelect && $ctrl.model.actionCodeData[actions.id].details.rootCauses.length == 0) ||\n                                                  ($ctrl.model.actionCodeData[actions.id].details.minResponseSelect && $ctrl.model.actionCodeData[actions.id].details.responses.length == 0))\" class=\"btn btn-primary ng-binding pull-right\">\n<span ng-class=\"{ 'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading} \"></span> {{'common.save' | translate}}\n</button>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.actionCodes.length && !$ctrl.model.loading\">\n<div class=\"alert text-center alert-danger\" style=\"margin-bottom: 0px;\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div class=\"col-sms-12 margin-10\" ng-if=\"!$ctrl.model.loading\">\n<ul uib-pagination total-items=\"$ctrl.pagination.total\" force-ellipses=\"true\" max-size=\"$ctrl.pagination.maxPages\" ng-hide=\"(($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1))\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\"></ul>\n</div>\n</form>\n</div>\n";
var id1="service_settings.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2778 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad atm-makes-style-section\">\n<div class=\"col-sm-12 remove-pad-right remove-left-pad\">\n<div>\n<span class=\"col-sm-10\">\n<h4 translate=\"\">{{'serviceSettings.atmMakes' | translate}}</h4>\n</span>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<hr class=\"hr-line\"/>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"remove-pad col-sm-10\">\n<input ng-change=\"$ctrl.loadData()\" type=\"text\" ng-model-options=\"{debounce: 1000}\" placeholder=\"{{ 'addBagModal.search' | translate }}\" class=\"input-lg form-control\" ng-model=\"$ctrl.model.searchText\" search-autofocus>\n</div>\n<div class=\"margin-top-05 col-sm-2 remove-right-pad\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.addAtmMake()\">\n<span class=\"glyphicon glyphicon-plus\"></span> ATM Make\n</button>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.originalAtmMakes.length && $ctrl.model.atmMakes.length\">\n<hr class=\"hr-line\"/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.loading\">\n<div class=\"table-responsive\" ng-hide=\"!$ctrl.model.originalAtmMakes.length\">\n<table class=\"table table-bordered table-striped atm-makes-table\">\n<thead>\n<tr>\n<th class=\"text-center\">#</th>\n<th>ATM Make</th>\n<th>Status</th>\n<th>Created Date</th>\n<th>Updated Date</th>\n<th>Updated By</th>\n<th class=\"text-center\">Action</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"item in $ctrl.model.atmMakes track by item.id\">\n<td class=\"text-center\">\n{{($ctrl.pagination.page - 1) * $ctrl.pagination.pageLimit + $index + 1}}\n</td>\n<td class=\"atm-make-name-cell\">\n<input class=\"form-control\" type=\"text\" ng-model=\"item.vendorName\" placeholder=\"Vendor Name\" required/>\n</td>\n<td class=\"atm-make-status-cell\">\n<input bs-switch switch-size=\"small\" ng-model=\"item.active\" type=\"checkbox\" switch-on-text=\"Active\" switch-off-text=\"Inactive\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</td>\n<td class=\"remove-white-space\">\n{{item.createdAt ? $ctrl.DateUtil.convetToBrowserTimezone(item.createdAt) : 'N/A'}}\n</td>\n<td class=\"remove-white-space\">\n{{item.updatedAt ? $ctrl.DateUtil.convetToBrowserTimezone(item.updatedAt) : 'N/A'}}\n</td>\n<td class=\"remove-white-space\">\n{{$ctrl.getUpdatedByLabel(item)}}\n</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeAtmMake($index)\" uib-tooltip=\"Delete\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 _margin-10\" ng-hide=\"!$ctrl.model.originalAtmMakes.length\">\n<button type=\"button\" ng-click=\"$ctrl.updateAtmMakes()\" ng-disabled=\"($ctrl.disableUpdate() || $ctrl.model.saving)\" class=\"btn btn-primary ng-binding pull-right w-100\">\n<span ng-class=\"{ 'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.model.saving} \"></span>\n{{'common.save' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.originalAtmMakes.length && !$ctrl.model.loading\">\n<div class=\"alert text-center alert-danger\" style=\"margin-bottom: 0px;\" ng-class=\"{'margin-10' : !$ctrl.model.originalAtmMakes.length}\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-hide=\"(($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1) || $ctrl.model.loading)\">\n<hr class=\"hr-line\"/>\n</div>\n<div class=\"col-sms-12 margin-10 margin-bottom-20\" ng-hide=\"(($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1)) || $ctrl.model.loading\">\n<ul uib-pagination total-items=\"$ctrl.pagination.total\" force-ellipses=\"true\" max-size=\"$ctrl.pagination.maxPages\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\"></ul>\n</div>\n</form>\n</div>\n</div>\n";
var id1="atm-makes.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2779 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-bottom-20 atm-makes-style-section\">\n<div class=\"col-sm-12 remove-pad-right remove-left-pad\">\n<div>\n<span class=\"col-sm-10\">\n<h4 translate=\"\">{{'serviceSettings.action_priorities' | translate}}</h4>\n</span>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<hr class=\"hr-line\"/>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"remove-pad col-sm-10\">\n<input ng-change=\"$ctrl.loadData()\" type=\"text\" ng-model-options=\"{debounce: 1000}\" search-autofocus placeholder=\"{{ 'common.search' | translate }}\" class=\"input-lg form-control\" ng-model=\"$ctrl.model.searchText\">\n</div>\n<div class=\"margin-top-05 col-sm-2 remove-right-pad\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.addPriority()\">\n<span class=\"glyphicon glyphicon-plus\"></span> New\n</button>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.originalPriorities.length && $ctrl.model.priorities.length\">\n<hr class=\"hr-line\"/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.loading\">\n<div class=\"table-responsive\" ng-hide=\"!$ctrl.model.originalPriorities.length\">\n<table class=\"table table-bordered table-striped atm-makes-table\">\n<thead>\n<tr>\n<th class=\"text-center\">#</th>\n<th>Priority</th>\n<th>Status</th>\n<th>Description</th>\n<th>Created Date</th>\n<th>Updated Date</th>\n<th class=\"text-center\">Action</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"item in $ctrl.model.priorities track by item.id\">\n<td class=\"text-center\">\n{{($ctrl.pagination.page - 1) * $ctrl.pagination.pageLimit + $index + 1}}\n</td>\n<td>\n<input class=\"form-control\" type=\"text\" ng-model=\"item.priority\" placeholder=\"Priority\" required/>\n</td>\n<td>\n<input bs-switch switch-size=\"small\" ng-model=\"item.active\" type=\"checkbox\" switch-on-text=\"Active\" switch-off-text=\"Inactive\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</td>\n<td>\n<textarea class=\"form-control\" rows=\"2\" ng-model=\"item.description\" placeholder=\"Description\" style=\"resize: vertical;\"></textarea>\n</td>\n<td class=\"remove-white-space\">\n{{item.createdAt ? $ctrl.DateUtil.convetToBrowserTimezone(item.createdAt) : 'N/A'}}\n</td>\n<td class=\"remove-white-space\">\n{{item.updatedAt ? $ctrl.DateUtil.convetToBrowserTimezone(item.updatedAt) : 'N/A'}}\n</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removePriority($index)\" uib-tooltip=\"Delete\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 _margin-10\" ng-hide=\"!$ctrl.model.originalPriorities.length\">\n<button type=\"button\" ng-click=\"$ctrl.updatePriorities()\" ng-disabled=\"($ctrl.disableUpdate() || $ctrl.model.saving)\" class=\"btn btn-primary ng-binding pull-right w-100\">\n<span ng-class=\"{ 'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.model.saving} \"></span>\n{{'common.save' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.originalPriorities.length && !$ctrl.model.loading\">\n<div class=\"alert text-center alert-danger\" style=\"margin-bottom: 0px;\" ng-class=\"{'margin-10' : !$ctrl.model.originalPriorities.length}\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-hide=\"(($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1) || $ctrl.model.loading)\">\n<hr class=\"hr-line\"/>\n</div>\n<div class=\"col-sms-12 margin-10 margin-bottom-20\" ng-hide=\"(($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1)) || $ctrl.model.loading\">\n<ul uib-pagination total-items=\"$ctrl.pagination.total\" force-ellipses=\"true\" max-size=\"$ctrl.pagination.maxPages\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\"></ul>\n</div>\n</form>\n</div>\n</div>\n";
var id1="service-action-priorities.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2780 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad service-checklist-style-section\">\n<div class=\"col-sm-12 remove-pad-right remove-left-pad\">\n<div>\n<span class=\"col-sm-10\">\n<h4 translate=\"\">{{'serviceSettings.service_checklist' | translate}}</h4>\n</span>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<hr class=\"hr-line\"/>\n</div>\n<div class=\"col-sm-12\" ng-hide=\"$ctrl.model.isServiceChecklist || $ctrl.model.loading\">\n<div class=\"alert text-center alert-danger\" style=\"margin-bottom: 0px;\">\nService Checklist is currently disabled by administrator.\n</div>\n</div>\n<div class=\"col-sm-12\" ng-hide=\"!$ctrl.model.isServiceChecklist\">\n<div class=\"remove-pad\" ng-class=\"{'col-sm-10' : $ctrl.hasServiceCheckListACL['create'], 'col-sm-12' : !$ctrl.hasServiceCheckListACL['create']}\">\n<input ng-change=\"$ctrl.loadData()\" type=\"text\" ng-model-options=\"{debounce: 1000}\" placeholder=\"{{ 'addBagModal.search' | translate }}\" class=\"input-lg form-control\" ng-model=\"$ctrl.model.searchText\">\n</div>\n<div class=\"margin-top-05 col-sm-2 remove-right-pad\">\n<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.createServiceChecklist()\" ng-if=\"$ctrl.hasServiceCheckListACL['create']\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'serviceSettings.service_checklist' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.originalChecklist.length && $ctrl.model.serviceChecklist.length\">\n<hr class=\"hr-line\"/>\n</div>\n<div class=\"col-sm-12\" ng-hide=\"!$ctrl.model.isServiceChecklist\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.loading\">\n<div ng-hide=\"!$ctrl.model.originalChecklist.length\">\n<ul dnd-list=\"$ctrl.model.serviceChecklist\" class=\"w-60\">\n<li ng-repeat=\"item in $ctrl.model.serviceChecklist\" dnd-draggable=\"item\" dnd-moved=\"$ctrl.updateSortOrder($index);\" dnd-effect-allowed=\"move\" dnd-disable-if=\"!$ctrl.hasServiceCheckListACL['edit']\" class=\"display-flex _border-bottom\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 d-flex remove-left-pad remove-pad-right\" ng-class=\"{'margin-bottom-10' : $index !== $ctrl.model.serviceChecklist.length - 1}\">\n<input readonly=\"readonly\" class=\"form-control text-center response-no-input cursor-pointer\" type=\"text\" ng-model=\"item.sortOrder\" required/>\n<input class=\"form-control\" type=\"text\" ng-model=\"item.label\" required ng-disabled=\"!$ctrl.hasServiceCheckListACL['edit']\"/>\n<input class=\"form-control ml-5 text-center text-input-section\" type=\"number\" min=\"1\" ng-model=\"item.daySelection\" ng-class=\"{'remove-right-margin': !$ctrl.hasServiceCheckListACL['edit']}\" ng-disabled=\"!$ctrl.hasServiceCheckListACL['edit']\" required/>\n<div ng-if=\"$ctrl.hasServiceCheckListACL['delete']\">\n<div class=\"ml-5\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeServiceChecklist($index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</div>\n</div>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.model.originalChecklist.length && $ctrl.model.serviceChecklist.length\">\n<hr class=\"hr-line\"/>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 _margin-10\" ng-hide=\"!$ctrl.model.originalChecklist.length\" ng-class=\"{'margin-10' : !$ctrl.model.serviceChecklist.length}\">\n<button type=\"button\" ng- ng-click=\"$ctrl.updateServiceChecklist()\" ng-if=\"$ctrl.hasServiceCheckListACL['edit'] || $ctrl.hasServiceCheckListACL['delete']\" ng-disabled=\"($ctrl.disableCodeUpdate() || $ctrl.loading)\" class=\"btn btn-primary ng-binding pull-right w-100\">\n<span ng-class=\"{ 'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading} \"></span>\n{{'common.save' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.originalChecklist.length && !$ctrl.model.loading\">\n<div class=\"alert text-center alert-danger\" style=\"margin-bottom: 0px;\" ng-class=\"{'margin-10' : !$ctrl.model.originalChecklist.length}\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-hide=\"(($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1) && $ctrl.model.loading)\">\n<hr class=\"hr-line\"/>\n</div>\n<div class=\"col-sms-12 margin-10 margin-bottom-20\" ng-hide=\"(($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1)) || $ctrl.model.loading\">\n<ul uib-pagination total-items=\"$ctrl.pagination.total\" force-ellipses=\"true\" max-size=\"$ctrl.pagination.maxPages\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\"></ul>\n</div>\n</form>\n</div>\n</div>";
var id1="service_checklists.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2781 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"service-settings.all\" ng-click=\"$ctrl.goToAll()\"><a>{{'serviceSettings.service_order_actions' | translate}}</a></li>\n<li role=\"presentation\" ui-sref-active=\"active\" ng-show=\"$ctrl.hasServiceCheckListACL['view']\" ui-sref=\"service-settings.checklist\"><a>{{'serviceSettings.service-checklist' | translate}}</a></li>\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"service-settings.atmMakes\"><a>{{'serviceSettings.atmMakes' | translate}}</a></li>\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"service-settings.actionPriorities\"><a>{{'serviceSettings.action_priorities' | translate}}</a></li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>\n";
var id1="service_settings.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2782 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<div class=\"w-100\">\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'service_ticket_parts.all_service_ticket_parts' | translate}} <span ng-if=\"$ctrl.model.serviceOrderPartsObj.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"remove-pad collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.model.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div class=\"text-align-center font-size-70 margin-10\" ng-if=\"$ctrl.model.serviceOrderPartsObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div ng-if=\"!$ctrl.model.serviceOrderPartsObj.loading\">\n<div ng-if=\"$ctrl.model.serviceOrderPartsObj.results.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"serviceOrderParts in $ctrl.model.serviceOrderPartsObj.results track by serviceOrderParts.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{serviceOrderParts.id}} | {{serviceOrderParts.label}}\n<span class=\"text-success\"> | {{serviceOrderParts.serialNumber}}</span>\n<span class=\"text-success\" ng-if=\"serviceOrderParts.partCharge\"> | {{serviceOrderParts.partCharge | currency:\"$\"}}</span>\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(serviceOrderParts)\" uib-tooltip=\"{{ 'common.Edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['delete']\" ng-click=\"$ctrl.delete(serviceOrderParts)\" uib-tooltip=\"{{ 'common.Delete' | translate }}\" ng-disabled=\"$ctrl.allowOnlyOnce\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.model.serviceOrderPartsObj.totalRecords\" ng-hide=\"($ctrl.model.serviceOrderPartsObj.totalRecords<=$ctrl.model.serviceOrderPartsObj.pagination.pageLimit)&&($ctrl.model.serviceOrderPartsObj.pagination.page==1)\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.serviceOrderPartsObj.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n\n</div>\n<div class=\"text-align-center\" ng-if=\"!$ctrl.model.serviceOrderPartsObj.loading && !$ctrl.model.serviceOrderPartsObj.results.length\">\n<span class=\"alert alert-danger col-sm-12\">{{'serviceTicketParts.noData' | translate}}</span>\n</div>\n</div>\n</div>";
var id1="service_ticket_parts.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2783 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"heading-section\">\n<h4 translate=\"service_ticket_parts.create_service_ticket_parts\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"shipment-form-section\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3 form-group\">\n<label for=\"label\" class=\"font-12\">{{'serviceSettings.label' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.label\">\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"serial-number\" class=\"font-12\">{{'serviceTicketParts.item_number' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" required ng-model=\"$ctrl.model.serialNumber\">\n</div>\n<div id=\"inline\" class=\"col-sm-3 form-group\">\n<label for=\"sort-order\" class=\"font-12\">{{'shiptype.sortOrder' | translate }} *</label>\n<input type=\"number\" min=\"1\" required class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.sortOrder\">\n</div>\n<div id=\"inline\" class=\"col-sm-3 form-group\">\n<label for=\"partCharge\" class=\"font-12\">{{'service_ticket_parts.part_charge' | translate }}</label>\n<input type=\"text\" class=\"form-control\" placeholder=\"$0.00\" ng-model=\"$ctrl.model.partCharge\" ng-currency>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.create(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.model.isCreate}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.model.isCreate}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.model.isCreate}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n</form>\n</div>\n</div>";
var id1="service_ticket_parts.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2784 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"w-100\">\n<div class=\"heading-section\">\n<h4 translate=\"service_ticket_parts.edit_service_ticket_parts\"></h4>\n<hr/>\n</div>\n<div class=\"text-align-center font-size-70 margin-10\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.loading\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3 form-group\">\n<label for=\"label\" class=\"font-12\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" disabled=\"disabled\" ng-model=\"$ctrl.rawId\">\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"label\" class=\"font-12\">{{'serviceSettings.label' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.label\">\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"serial-number\" class=\"font-12\">{{'serviceTicketParts.item_number' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" required ng-model=\"$ctrl.model.serialNumber\">\n</div>\n<div id=\"inline\" class=\"col-sm-3 form-group\">\n<label for=\"sort-order\" class=\"font-12\">{{'shiptype.sortOrder' | translate }} *</label>\n<input type=\"number\" min=\"1\" required class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.sortOrder\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div id=\"inline\" class=\"col-sm-3 form-group\">\n<label for=\"partCharge\" class=\"font-12\">{{'service_ticket_parts.part_charge' | translate }}</label>\n<input type=\"text\" class=\"form-control\" placeholder=\"$0.00\" ng-model=\"$ctrl.model.partCharge\" ng-currency>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.update(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.model.isUpdating}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.model.isUpdating}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.model.isUpdating}\">{{'common.reset' | translate }}</button>\n</div>\n<div class=\"col-sm-12 margin-10\">\n<div class=\"alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n</div>\n</div>\n</form>\n</div>\n</div>";
var id1="service_ticket_parts.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2785 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"service-ticket-parts.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"service_ticket_parts.all_service_ticket_parts\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"service-ticket-parts.create\">\n<a translate=\"service_ticket_parts.create_service_ticket_parts\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="service_ticket_parts.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group remove-left-pad\">\n<div class=\"multi-select user-branch-search-dd valid-multi-select-value\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"Value\" item-label=\"Value\" search-property=\"Value\" tick-property=\"ticked\" directive-id=\"multi-select-button\" selection-mode=\"multiple\" on-item-click=\"$ctrl.onBranchChange();\" on-reset=\"$ctrl.onBranchChange(); \" on-select-all=\"$ctrl.onBranchChange(); \" on-select-none=\"$ctrl.onBranchChange(); \" disable-property=\"$ctrl.model.isLoadingServiceOrder\" translation=\"$ctrl.localLang\" is-disabled=\"$ctrl.model.isLoadingServiceOrder\">\n</div>\n</div>\n<div class=\"col-sm-4 form-group\">\n<search-and-select ng-model=\"$ctrl.model.selectedLocation\" values=\"$ctrl.locationList\" key=\"Key\" updated-values=\"$ctrl.updatedLocationList\" totalrecords=\"$ctrl.totalLocations\" common-search-flag=\"true\" none-selected=\"'common.select_location'\"></search-and-select>\n</div>\n<div class=\"col-sm-4 remove-right-pad form-group\">\n<search-and-select ng-model=\"$ctrl.model.selectedRoute\" values=\"$ctrl.routeList\" key=\"Key\" totalrecords=\"$ctrl.totalRoutes\" common-search-flag=\"true\" none-selected=\"'common.select_route'\"></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 remove-left-pad _form-group\">\n<search-and-select ng-model=\"$ctrl.model.selectedUser\" values=\"$ctrl.userList\" key=\"Key\" totalrecords=\"$ctrl.totalUsers\" none-selected=\"'common.select_user'\" common-search-flag=\"true\"></search-and-select>\n</div>\n<div class=\"col-sm-4 _form-group\">\n<search-and-select ng-model=\"$ctrl.model.selectedAction\" values=\"$ctrl.actions\" key=\"Key\" totalrecords=\"$ctrl.totalActions\" none-selected=\"'common.select_action'\" common-search-flag=\"true\"></search-and-select>\n</div>\n<div class=\"col-sm-4 remove-right-pad form-group\">\n<search-and-select ng-model=\"$ctrl.model.selectedServiceZone\" values=\"$ctrl.serviceZoneList\" key=\"Key\" totalrecords=\"$ctrl.totalServiceZone\" common-search-flag=\"true\" none-selected=\"'common.select_serviceZone'\"></search-and-select>\n</div>\n<div class=\"col-sm-4 _form-group remove-left-pad margin-bottom-20\">\n<search-and-select ng-model=\"$ctrl.model.selectedCustomer\" values=\"$ctrl.customerList\" key=\"Key\" updated-values=\"$ctrl.updatedcustomerList\" totalrecords=\"$ctrl.totalCustomer\" common-search-flag=\"true\" none-selected=\"'common.select_customer'\"></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad\">\n<div class=\"col-sm-6 remove-left-pad _form-group d-flex service-tickets-btn-row\">\n<div class=\"_form-group\" ng-if=\"$ctrl.hasACL && $ctrl.hasACL.create\">\n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.showCreateModal()\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n{{'shipmentBatch.add' | translate}}\n</button>\n</div>\n<div class=\"_form-group\">\n<button type=\"button\" class=\"btn btn-md btn-primary\" ng-click=\"$ctrl.resetData()\" ng-disabled=\"$ctrl.disabledResetBtn || $ctrl.model.isLoadingServiceOrder\">\n{{'common.reset' | translate}}\n</button>\n</div>\n<div class=\"_form-group\">\n<button type=\"button\" class=\"btn btn-md btn-success\" ng-click=\"$ctrl.getServiceOrders();\" ng-disabled=\"$ctrl.model.isLoadingServiceOrder\">\n{{'common.search' | translate}}\n</button>\n</div>\n<div class=\"_form-group\" ng-if=\"$ctrl.canRunAutoAssignNow\">\n<button type=\"button\" class=\"btn btn-md btn-warning\" ng-click=\"$ctrl.runAutoAssignNow()\" ng-disabled=\"$ctrl.isRunningAutoAssignNow\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isRunningAutoAssignNow\"></span>\nRun Auto-Assign\n</button>\n</div>\n<div class=\"margin-top-03 _form-group pull-right setting-switch-section\">\n<input id=\"mapStatus\" ng-if=\"$ctrl.showBucketSearch()\" switch-on-text=\"{{'serviceTickets.show_map' | translate }}\" switch-off-text=\"{{'serviceTickets.hide_map' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.mapStatus\" type=\"checkbox\" ng-change=\"$ctrl.reloadMap(); $ctrl.validateMap();\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.model.isLoadingServiceOrder\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div ng-class=\"{'margin-10': $ctrl.model.mapStatus && !$ctrl.model.isLoadingServiceOrder && !$ctrl.serviceOrderError && $ctrl.isValid}\" ng-if=\"$ctrl.model.mapStatus && !$ctrl.model.isLoadingServiceOrder && !$ctrl.serviceOrderError && $ctrl.isValid\">\n<div id=\"map\" class=\"border-radius-05 leaf-map map-z-index\"></div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-show=\"$ctrl.showBucketSearch()\" ng-if=\"!$ctrl.model.isLoadingServiceOrder\">\n<div class=\"remove-left-pad margin-top-20\" ng-class=\"$ctrl.hasACL && $ctrl.hasACL.create ? 'col-lg-8 col-md-6 col-sm-6' : 'remove-left-pad  col-lg-8 col-md-8 col-sm-7'\">\n<input type=\"text\" strip-prefix class=\"form-control bucket-search\" ng-model=\"$ctrl.model.searchKey\" name=\"searchKey\" on-press-enter=\"$ctrl.getServiceOrders();\" search-autofocus placeholder=\"{{'serviceTickets.search_location_ticket' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\"/>\n</div>\n<div class=\"col-sm-5 col-md-4 col-lg-4 remove-right-pad text-right last-updated-time\">\n<strong>{{'branch_mgmt.bagout_lastUpdated' | translate}}: {{$ctrl.lastUpdatedTime}}</strong>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-10\">\n<div ng-class=\"{'padding-bottom-50': $ctrl.isValid && !$ctrl.model.isLoadingServiceOrder && !$ctrl.serviceOrderError}\">\n<div class=\"panel panel-default margin-10 remove-bottom-pad\" ng-repeat=\"status in $ctrl.buckets track by $index\" ng-if=\"(!$ctrl.model.isLoadingServiceOrder && $ctrl.model.serviceOrderData[status.bucket].items && $ctrl.model.serviceOrderData[status.bucket].items.length) || \n                     ((status.bucket == 'COMPLETE' || status.bucket == 'CANCELLED') && !$ctrl.model.isLoadingServiceOrder && $ctrl.totalCompletedAndCancelledServiceTickets > 0)\">\n<div class=\"cursor-pointer panel-heading\">\n<div class=\"row panel-title panel-title-center bucket_text_align_center remove-left-padd remove-right-padd\">\n<div class=\"col-sm-5 remove-left-padd remove-right-padd\" ng-click=\"status.bucketExpanded=!status.bucketExpanded; $ctrl.autoCloseTable(status); $ctrl.setStatusExpanded(status.bucket)\">\n<i class=\"glyphicon glyphicon-triangle-bottom\" ng-show=\"status.bucketExpanded\"></i>\n<i class=\"glyphicon glyphicon-triangle-right\" ng-hide=\"status.bucketExpanded\"></i>\n<strong class=\"f-14\">{{$ctrl.getBucketName(status.bucket)}}</strong>\n<span class=\"badge\" ng-class=\"{'complete-bucket-color': (status.bucket === 'COMPLETE'),\n                                                        'accepted-bucket-color':(status.bucket === 'ACCEPTED'),\n                                                        'assigned-bucket-color': (status.bucket === 'ASSIGNED'),\n                                                        'unassigned-bucket-color':(status.bucket === 'UNASSIGNED'),\n                                                        'on-route-bucket-color':(status.bucket === 'ON_ROUTE'),\n                                                        'on-site-bucket-color':(status.bucket === 'ON_SITE'),\n                                                        'hold-bucket-color':(status.bucket === 'HOLD'),\n                                                        'pending-messenger-accept-bucket-color':(status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT'),\n                                                        'cant-completed-bucket-color':(status.bucket === 'CANT_COMPLETE_BUCKET'),\n                                                        'cancelled-bucket-color':(status.bucket === 'CANCELLED'),\n                                                        'unaccepted-bucket-color':(status.bucket === 'UNACCEPTED'),\n                                                        'pending-assign-bucket-color':(status.bucket === 'PENDING_ASSIGN')}\">\n{{$ctrl.model.serviceOrderData[status.bucket].totalCount || $ctrl.model.serviceOrderData[status.bucket].items.length}}\n</span>\n</div>\n<div class=\"col-sm-6 pull-right text-right remove-right-padd\">\n<span ng-if=\"$ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].totalRedThreshold > 0\">\n<span class=\"label thres-hold-red\">\n<span class=\"badge threshold-badge\">{{$ctrl.serviceOrderThresolds[status.bucket].totalRedThreshold}}</span> {{'serviceTickets.red_threshold_label' | translate}}\n</span>\n</span>\n<span class=\"margin-left-10\" ng-if=\"$ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].totalOrangeThreshold > 0\">\n<span class=\"label thres-hold-orange\">\n<span class=\"badge threshold-badge\">{{$ctrl.serviceOrderThresolds[status.bucket].totalOrangeThreshold}}</span> {{'serviceTickets.orange_threshold_label' | translate}}\n</span>\n</span>\n<span class=\"margin-left-10\" ng-if=\"$ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].totalYellowThreshold > 0\">\n<span class=\"label thres-hold-yellow\">\n<span class=\"badge threshold-badge\">{{$ctrl.serviceOrderThresolds[status.bucket].totalYellowThreshold}}</span> {{'serviceTickets.yellow_threshold_label' | translate}}\n</span>\n</span>\n</div>\n<div class=\"col-sm-1 tools-d-flex-end pull-right text-right remove-right-padd\">\n<div ng-if=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') && !$ctrl.model.searchKey\" ng-click=\"$ctrl.getSelectedBucket(status.bucket);\">\n<input date-range-picker class=\"form-control ticket-daterange-picker date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions[status.bucket]\" options=\"$ctrl.model.dateRangPickerOptionsfor\" ng-if=\"$ctrl.model.dateRangeOptions[status.bucket].startDate\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<button type=\"button\" class=\"btn btn-xs pull-right\" ng-click=\"status.isShow=!status.isShow; $ctrl.validateMarkers(status); $ctrl.bucketsExpand[status.bucket].isShow = !status.isShow;\" ng-class=\"{'btn-default': !status.isShow, 'btn-success': status.isShow}\" ng-disabled=\"!$ctrl.model.mapStatus || !$ctrl.model.serviceOrderData[status.bucket].items.length\">\n{{'serviceTickets.map' | translate}}\n</button>\n</div>\n</div>\n</div>\n<div class=\"align-center-horizontally\" ng-show=\"!$ctrl.model.serviceOrderData[status.bucket].process && status.bucketExpanded && $ctrl.model.serviceOrderData[status.bucket].items && !$ctrl.model.serviceOrderData[status.bucket].items.length && (status.bucket == 'COMPLETE' || status.bucket == 'CANCELLED')\">\n<div class=\"_col-sm-11 alert errLblPos text-center alert-danger no-data-margin-10\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<div class=\"align-center-horizontally\" ng-show=\"status.bucketExpanded && $ctrl.model.serviceOrderData[status.bucket].process\">\n<div class=\"text-align-center text-center no-data-margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</div>\n<div class=\"table-responsive\" ng-show=\"status.bucketExpanded && $ctrl.model.serviceOrderData[status.bucket].items && $ctrl.model.serviceOrderData[status.bucket].items.length && !$ctrl.model.serviceOrderData[status.bucket].process\">\n<table class=\"table table-striped table-hover table-bordered remove-bottom-pad\" ng-if=\"$ctrl.isValid && !$ctrl.model.isLoadingServiceOrder\">\n<thead>\n<tr>\n<th class=\"expand-panel-width\"></th>\n<th class=\"remove-white-space\" ng-click=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? ($ctrl.bucketSort('encounterId', status.bucket)) : ($ctrl.serviceTicketSort('encounterId',status.bucket))\">{{'serviceTickets.ticket' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]) : ($ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]), 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'encounterId'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? ($ctrl.bucketSort('priority', status.bucket)) : ($ctrl.serviceTicketSort('priority',status.bucket))\">{{'serviceTickets.priority' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]) : ($ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]), 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'priority'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? ($ctrl.bucketSort('locationId', status.bucket)) : ($ctrl.serviceTicketSort('locationId',status.bucket))\">{{'serviceTickets.location' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]) : ($ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]), 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'locationId'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-if=\"$ctrl.model.selectedBranch.length > 1\" ng-click=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? ($ctrl.bucketSort('branchId', status.bucket)) : ($ctrl.serviceTicketSort('branchId',status.bucket))\">{{'common.branch_id' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]) : ($ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]), 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'branchId'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? ($ctrl.bucketSort('userId', status.bucket)) : ($ctrl.serviceTicketSort('userId',status.bucket))\" ng-if=\"(status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket === 'ASSIGNED' ||\n                                         status.bucket === 'HOLD' || status.bucket === 'CANT_COMPLETE_BUCKET' || status.bucket === 'COMPLETE' || \n                                         status.bucket === 'CANCELLED' || status.bucket === 'ON_ROUTE' || status.bucket === 'ON_SITE')\">\n{{'serviceTickets.status_ASSIGNED' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]) : ($ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]), 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'userId'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"$ctrl.serviceTicketSort('createdAt',status.bucket)\" ng-if=\"status.bucket === 'UNASSIGNED' || status.bucket === 'UNACCEPTED' || status.bucket === 'PENDING_ASSIGN'\">\n{{'serviceTickets.created_date' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': (status.bucket === 'COMPLETE') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]) :  ($ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]), 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'createdAt'}\"></span>\n</th>\n<th class=\"remove-white-space\">{{'common.action' | translate}}\n</th>\n<th class=\"remove-white-space\" ng-click=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? ($ctrl.bucketSort('timeOpen', status.bucket)) : ($ctrl.serviceTicketSort('timeOpen', status.bucket))\">{{ 'serviceTickets.time_open' | translate }}\n<span class=\"sortorder\" ng-class=\"{'reverse': (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? (!$ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]) : ($ctrl.sortOrderData[status.bucket][$ctrl.reverseSort]),'active': $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timeOpen'}\"></span>\n</th>\n<th class=\"remove-white-space\" class=\"width-80\" ng-click=\"$ctrl.serviceTicketSort('timeToAssigned', status.bucket)\" ng-if=\"(status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket === 'ASSIGNED')\">{{'serviceTickets.time_to_assign' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.sortOrderData[status.bucket][$ctrl.reverseSort], 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timeToAssigned'}\"></span>\n</th>\n<th class=\"remove-white-space\" class=\"width-80\" ng-click=\"$ctrl.serviceTicketSort('timeAssigned', status.bucket)\" ng-if=\"status.bucket === 'ASSIGNED'\">{{'serviceTickets.time_assign' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.sortOrderData[status.bucket][$ctrl.reverseSort],'active': $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timeAssigned'}\"></span>\n</th>\n<th class=\"width-80 remove-white-space\" ng-click=\"$ctrl.serviceTicketSort('timePending', status.bucket)\" ng-if=\"status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT'\">{{'serviceTickets.time_pending' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.sortOrderData[status.bucket][$ctrl.reverseSort],'active': $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timePending'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"$ctrl.serviceTicketSort('timeToHold',status.bucket)\" ng-if=\"status.bucket === 'HOLD'\">{{'serviceTickets.time_to_hold' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.sortOrderData[status.bucket][$ctrl.reverseSort], 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timeToHold'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"$ctrl.serviceTicketSort('timeOnHold',status.bucket)\" ng-if=\"status.bucket === 'HOLD'\">{{'serviceTickets.time_on_hold' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.sortOrderData[status.bucket][$ctrl.reverseSort], 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timeOnHold'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"$ctrl.serviceTicketSort('timeToOnRoute',status.bucket)\" ng-if=\"status.bucket === 'ON_ROUTE'\">{{'serviceTickets.time_to_on_route' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.sortOrderData[status.bucket][$ctrl.reverseSort], 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timeToOnRoute'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"$ctrl.serviceTicketSort('timeOnRoute',status.bucket)\" ng-if=\"status.bucket === 'ON_ROUTE'\">{{'serviceTickets.time_on_route' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.sortOrderData[status.bucket][$ctrl.reverseSort], 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timeOnRoute'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"$ctrl.serviceTicketSort('timeToOnSite',status.bucket)\" ng-if=\"status.bucket === 'ON_SITE'\">{{'serviceTickets.time_to_on_site' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.sortOrderData[status.bucket][$ctrl.reverseSort], 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timeToOnSite'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"$ctrl.serviceTicketSort('timeOnSite',status.bucket)\" ng-if=\"status.bucket === 'ON_SITE'\">{{'serviceTickets.time_on_site' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.sortOrderData[status.bucket][$ctrl.reverseSort], 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timeOnSite'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"$ctrl.serviceTicketSort('timeToCant',status.bucket)\" ng-if=\"status.bucket === 'CANT_COMPLETE_BUCKET'\">{{'serviceTickets.time_to_cant' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.sortOrderData[status.bucket][$ctrl.reverseSort], 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timeToCant'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"$ctrl.serviceTicketSort('timeFromCant',status.bucket)\" ng-if=\"status.bucket === 'CANT_COMPLETE_BUCKET'\">{{'serviceTickets.time_from_cant' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': $ctrl.sortOrderData[status.bucket][$ctrl.reverseSort], 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'timeFromCant'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"$ctrl.bucketSort('completedAt',status.bucket)\" ng-if=\"status.bucket === 'COMPLETE'\">{{'common.completed' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.sortOrderData[status.bucket][$ctrl.reverseSort], 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'completedAt'}\"></span>\n</th>\n<th class=\"remove-white-space\" ng-click=\"$ctrl.bucketSort('cancelledAt',status.bucket)\" ng-if=\"status.bucket === 'CANCELLED'\">{{'common.cancelled' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.sortOrderData[status.bucket][$ctrl.reverseSort], 'active' : $ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn] === 'cancelledAt'}\"></span>\n</th>\n<th>{{'serviceTickets.action' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat-start=\"orders in (status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') ? ($ctrl.model.serviceOrderData[status.bucket].items) : ($ctrl.containsTimeKeyword($ctrl.sortOrderData[status.bucket][$ctrl.sortColumn]) ? ($ctrl.model.serviceOrderData[status.bucket].items | orderBy: $ctrl.sortTime(status.bucket, $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn])) : ($ctrl.model.serviceOrderData[status.bucket].items | orderBy: ($ctrl.sortOrderData[status.bucket] && $ctrl.sortOrderData[status.bucket][$ctrl.sortColumn]):$ctrl.sortOrderData[status.bucket][$ctrl.reverseSort])) track by $index\" ng-class=\"{'priority-alert-row': orders.isPriorityAlert && (status.bucket !== 'COMPLETE' && status.bucket !== 'CANCELLED'), \n                                           'priority-48hr-row': orders.requestedTimeframe === '48HR' && !orders.isPriorityAlert && (status.bucket !== 'COMPLETE' && status.bucket !== 'CANCELLED'),\n                                           'priority-72hr-row': orders.requestedTimeframe === '72HR' && !orders.isPriorityAlert && (status.bucket !== 'COMPLETE' && status.bucket !== 'CANCELLED')}\">\n<td class=\"expand-btn-style\">\n<button id=\"expand-btn-{{orders.serviceOrderId}}\" type=\"button\" class=\"btn btn-sm btn-secondary\" ng-click=\"orders.expanded = !orders.expanded; $ctrl.loadOrderHistoryData(orders, $event); \n                                            $ctrl.showChildBucket(orders.expanded, status.bucket, $parent.$index,orders);\" expand>\n<span ng-if=\"orders.expanded\">\n<span class=\"glyphicon glyphicon-triangle-bottom\"></span>\n</span>\n<span ng-if=\"!orders.expanded\">\n<span class=\"glyphicon glyphicon-triangle-right\"></span>\n</span>\n</button>\n</td>\n<td ng-class=\"{'thres-hold-red' : $ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].redThresholdIds.indexOf(orders.encounterId) > -1, \n                                           'thres-hold-orange' : $ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].orangeThresholdIds.indexOf(orders.encounterId) > -1,\n                                           'thres-hold-yellow' : $ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].yellowThresholdIds.indexOf(orders.encounterId) > -1,\n                                           'encounter-id-w-90' : orders.externalProcessorId}\">\n<span ng-if=\"orders.externalProcessorId\">\n<label class=\"ex-lbl-section\" for=\"externalProcessorId\">\n<span class=\"cursor-pointer\" uib-tooltip=\"{{orders.externalProcessorName}}\" tooltip-placement=\"top-left\">\n{{'serviceTickets.EX' | translate}}\n</span>\n</label>\n</span>\n<span ng-class=\"{'txt-color-white' : $ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].redThresholdIds.indexOf(orders.encounterId) > -1\n                                                 || $ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].orangeThresholdIds.indexOf(orders.encounterId) > -1}\">\n{{orders.encounterId}}\n</span>\n</td>\n<td>\n<div class=\"ticket-priority-meta\">\n{{orders.priority}}\n<span ng-if=\"orders.displayRequestedTimeframe && (status.bucket !== 'COMPLETE' && status.bucket !== 'CANCELLED')\">\n|\n<span class=\"ticket-priority-pill\" ng-class=\"{'ticket-priority-pill-alert': orders.isPriorityAlert,\n                                                                                         'ticket-priority-pill-48hr': orders.requestedTimeframe === '48HR' && !orders.isPriorityAlert,\n                                                                                         'ticket-priority-pill-72hr': orders.requestedTimeframe === '72HR' && !orders.isPriorityAlert}\">\n{{orders.displayRequestedTimeframe}}\n</span>\n</span>\n</div>\n<div class=\"ticket-priority-subtext\" ng-if=\"orders.targetTime\">\n<b>Target:</b> {{$ctrl.DateUtil.convetToBrowserTimezone(orders.targetTime)}}\n</div>\n<div class=\"ticket-priority-subtext\" ng-if=\"orders.priorityRemaining\" ng-class=\"{'ticket-priority-overdue': orders.priorityRemaining.includes('Overdue')}\">\n<b ng-if=\"!orders.priorityRemaining.includes('Overdue')\">{{orders.priorityRemaining}}</b>\n<span ng-if=\"orders.priorityRemaining.includes('Overdue')\">{{orders.priorityRemaining}}</span>\n</div>\n</td>\n<td class=\"service-location-width\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(orders)\">\n<span class=\"cursor-pointer\" uib-tooltip=\"{{$ctrl.formatAddress(orders)}}\" tooltip-placement=\"top-left\">{{orders.locationId}}</span>\n</a> | {{orders.locationName}}\n<span ng-if=\"orders.stopPriority\">\n| ({{$ctrl.CommonLayoutService.ordinalSuffixOfStopPriority(orders.stopPriority)}})\n</span>\n<span ng-if=\"orders.locationZoneName\">\n| ({{orders.locationZoneName}})\n</span>\n</td>\n<td ng-if=\"$ctrl.model.selectedBranch.length > 1\">\n{{orders.branchId}}\n</td>\n<td ng-if=\"status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket === 'ASSIGNED' ||\n                                        status.bucket === 'HOLD' || status.bucket === 'CANT_COMPLETE_BUCKET' || status.bucket === 'COMPLETE' ||\n                                        status.bucket === 'CANCELLED' || status.bucket === 'ON_ROUTE' || status.bucket === 'ON_SITE'\">\n<div>\n<a href=\"#\" ng-hide=\"((status.bucket === 'ASSIGNED' && orders.isBranchUnassignedRoute && orders.userId) || (orders.isBranchUnassignedRoute))\" ng-click=\"$ctrl.goToRouteTab(orders)\">\n{{orders.routeId}}\n</a>\n<span ng-hide=\"(!orders.routeId || !orders.userId) ||\n                                                    (status.bucket === 'ASSIGNED' && orders.isBranchUnassignedRoute && orders.userId) || (orders.isBranchUnassignedRoute)\">|</span>\n<span ng-if=\"orders.externalProcessorId && orders.externalProcessorName\">\n<span ng-hide=\"(status.bucket === 'ASSIGNED' && orders.isBranchUnassignedRoute) || (orders.isBranchUnassignedRoute) || (orders.userId)\">|</span>\n{{orders.externalProcessorName}}\n</span>\n</div>\n<div ng-if=\"(status.bucket === 'ASSIGNED' || status.bucket === 'HOLD' || status.bucket === 'CANT_COMPLETE_BUCKET' ||\n                                             status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED' || status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT' ||\n                                             status.bucket === 'ON_ROUTE' || status.bucket === 'ON_SITE') && orders.routeId && orders.userId\">\n<span ng-show=\"(!orders.isBranchUnassignedRoute && orders.externalProcessorId && orders.externalProcessorName && orders.userId)\">|</span>\n<a href=\"#\" ng-click=\"$ctrl.goToUserTab(orders)\">\n{{orders.userId}}\n</a> {{orders.username}}\n</div>\n</td>\n<td ng-if=\"status.bucket === 'UNASSIGNED' || status.bucket === 'UNACCEPTED' || status.bucket === 'PENDING_ASSIGN'\">\n{{$ctrl.DateUtil.convetToBrowserTimezone(orders.createdAt)}}\n</td>\n<td class=\"text-danger\">\n<div class=\"action-code-w-150\">\n<span>\n{{orders.thresholds.length}} |\n</span>\n<span ng-repeat=\"actionCode in orders.thresholds track by $index\">\n{{actionCode.label}}<span ng-if=\"$index + 1 !== orders.thresholds.length\">,</span>\n</span>\n</div>\n</td>\n<td ng-class=\"{'thres-hold-red' : $ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].redThresholdIds.indexOf(orders.encounterId) > -1, \n                                            'thres-hold-orange' : $ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].orangeThresholdIds.indexOf(orders.encounterId) > -1,\n                                            'thres-hold-yellow' : $ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].yellowThresholdIds.indexOf(orders.encounterId) > -1}\">\n<div>\n<span ng-if=\"status.bucket === 'UNASSIGNED' || status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket === 'ASSIGNED' ||\n                                                 status.bucket === 'HOLD' || status.bucket === 'CANT_COMPLETE_BUCKET' || status.bucket === 'ON_ROUTE' || status.bucket === 'ON_SITE'\n                                                 || status.bucket === 'UNACCEPTED' ||  status.bucket === 'PENDING_ASSIGN' \">\n<div ng-if=\"orders.createdAt\">\n<span ng-class=\"{'open-time-color' : $ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].yellowThresholdIds.indexOf(orders.encounterId) === -1,\n                                                            'txt-color-white' : $ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].redThresholdIds.indexOf(orders.encounterId) > -1 \n                                                             ||  $ctrl.serviceOrderThresolds[status.bucket] && $ctrl.serviceOrderThresolds[status.bucket].orangeThresholdIds.indexOf(orders.encounterId) > -1}\">\n<strong>{{orders.timeOpen}}</strong>\n</span>\n</div>\n</span>\n<span class=\"open-time-color\" ng-if=\"status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED'\">\n<strong ng-if=\"status.bucket === 'COMPLETE'\">\n{{orders.timeOpen}}\n</strong>\n<strong ng-if=\"status.bucket === 'CANCELLED'\">\n{{orders.timeOpen}}\n</strong>\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket === 'ASSIGNED' \">\n<div ng-if=\"$ctrl.calculateAssignAndAcceptTime(orders.firstAssignOn, orders.acceptedOn) && (status.bucket == 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket == 'ASSIGNED') && orders.acceptedOn && orders.firstAssignOn\">\n<span class=\"open-time-color\">\n<strong>{{orders.timeToAssigned}}</strong>\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket === 'ASSIGNED'\">\n<div ng-if=\"(orders.statusTimestamp) && ($ctrl.calculateAssignAndAcceptTime(orders.statusTimestamp, orders.acceptedOn) && (status.bucket == 'ASSIGNED_PENDING_MESSENGER_ACCEPT' || status.bucket == 'ASSIGNED'))\">\n<span ng-if=\"$ctrl.checkBrowserDiff(orders.statusTimestamp) >= 0 \">\n<div ng-if=\"status.bucket === 'ASSIGNED'\">\n<span class=\"open-time-color\"><strong>{{orders.timeAssigned}}</strong></span>\n</div>\n<div ng-if=\"status.bucket === 'ASSIGNED_PENDING_MESSENGER_ACCEPT'\">\n<span class=\"open-time-color\"><strong>{{orders.timePending}}</strong></span>\n</div>\n</span>\n<span ng-if=\"$ctrl.checkBrowserDiff(orders.statusTimestamp) < 0 \" class=\"open-time-color bold-font\">00:00:00\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'HOLD'\">\n<div ng-if=\"$ctrl.calculateAssignAndAcceptTime(orders.statusTimestamp, orders.acceptedOn) && orders.acceptedOn && orders.statusTimestamp\">\n<span class=\"open-time-color\">\n<strong>{{orders.timeToHold}}</strong>\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'HOLD'\">\n<div ng-if=\"(orders.statusTimestamp)\">\n<span ng-if=\"$ctrl.checkBrowserDiff(orders.statusTimestamp) >= 0 \">\n<div>\n<span class=\"open-time-color\"><strong>{{orders.timeOnHold}}</strong></span>\n</div>\n</span>\n<span ng-if=\"$ctrl.checkBrowserDiff(orders.statusTimestamp) < 0 \" class=\"open-time-color bold-font\">00:00:00\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'CANT_COMPLETE_BUCKET'\">\n<div ng-if=\"$ctrl.calculateAssignAndAcceptTime(orders.statusTimestamp, orders.acceptedOn) && orders.acceptedOn && orders.statusTimestamp\">\n<span class=\"open-time-color\">\n<strong>{{orders.timeToCant}}</strong>\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'CANT_COMPLETE_BUCKET'\">\n<div ng-if=\"orders.statusTimestamp\">\n<span ng-if=\"$ctrl.checkBrowserDiff(orders.statusTimestamp) >= 0 \">\n<div>\n<span class=\"open-time-color\"><strong>{{orders.timeFromCant}}</strong></span>\n</div>\n</span>\n<span ng-if=\"$ctrl.checkBrowserDiff(orders.statusTimestamp) < 0 \" class=\"open-time-color bold-font\">00:00:00\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'ON_ROUTE'\">\n<div ng-if=\"$ctrl.calculateAssignAndAcceptTime(orders.firstOnRouteOn, orders.acceptedOn) && orders.acceptedOn && orders.firstOnRouteOn\">\n<span class=\"open-time-color\">\n<strong>{{orders.timeToOnRoute}}</strong>\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'ON_ROUTE'\">\n<div ng-if=\"orders.firstOnRouteOn\">\n<span ng-if=\"$ctrl.checkBrowserDiff(orders.firstOnRouteOn) >= 0 \">\n<div>\n<span class=\"open-time-color\"><strong>{{orders.timeOnRoute}}</strong></span>\n</div>\n</span>\n<span ng-if=\"$ctrl.checkBrowserDiff(orders.firstOnRouteOn) < 0 \" class=\"open-time-color bold-font\">00:00:00\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'ON_SITE'\">\n<div ng-if=\"$ctrl.calculateAssignAndAcceptTime(orders.firstOnSiteOn, orders.acceptedOn) && orders.acceptedOn && orders.firstOnSiteOn\">\n<span class=\"open-time-color\">\n<strong>{{orders.timeToOnSite}}</strong>\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'ON_SITE'\">\n<div ng-if=\"orders.statusTimestamp\">\n<span ng-if=\"$ctrl.checkBrowserDiff(orders.statusTimestamp) >= 0 \">\n<div>\n<span class=\"open-time-color\"><strong>{{orders.timeOnSite}}</strong></span>\n</div>\n</span>\n<span ng-if=\"$ctrl.checkBrowserDiff(orders.statusTimestamp) < 0 \" class=\"open-time-color bold-font\">00:00:00\n</span>\n</div>\n</td>\n<td ng-if=\"status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED'\">\n<span class=\"open-time-color\">\n<strong ng-if=\"status.bucket === 'COMPLETE'\">\n{{$ctrl.DateUtil.convetToBrowserTimezone(orders.completedAt)}}\n</strong>\n<strong ng-if=\"status.bucket === 'CANCELLED'\">\n{{$ctrl.DateUtil.convetToBrowserTimezone(orders.cancelledAt)}}\n</strong>\n</span>\n</td>\n<td>\n<div class=\"action-btn-position\">\n<button type=\"button\" class=\"btn btn-xs btn-danger remove-pad\" ng-click=\"$ctrl.undoServiceOrder(orders)\" uib-tooltip=\"{{'serviceTickets.undo' | translate}}\" ng-if=\"status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED'\" ng-disabled=\"orders.externalProcessorId\">\n<img src=\"" + __webpack_require__(119) + "\" class=\"undo-icon-height-20\">\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.serviceOrderAssignModal(orders)\" uib-tooltip=\"{{'common.assign' | translate}}\" ng-class=\"{'disabled': $ctrl.assignTo[orders.encounterId].process}\" ng-hide=\"status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED'\" ng-disabled=\"orders.externalProcessorId || $ctrl.customerId\">\n<span class=\"glyphicon glyphicon-user\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-warning\" ng-click=\"$ctrl.resendExternalServiceTickets(orders)\" ng-if=\"status.bucket === 'UNACCEPTED' && orders.externalProcessorId\" ng-disabled=\"$ctrl.externalProcessorObj[orders.serviceOrderId].process\">\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"{{'common.resend' | translate}}\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success\" uib-tooltip=\"{{'serviceTickets.update' | translate}}\" ng-click=\"orders.externalProcessorId ? $ctrl.externalServiceOrderStatusUpdateModal(orders) : $ctrl.serviceOrderStatusUpdateModal(orders);\" ng-class=\"{'disabled': $ctrl.statusUpdate[orders.encounterId].process}\" ng-hide=\"status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED'\" ng-disabled=\"orders.externalProcessorId && !$ctrl.hasACL.updateExternal\">\n<span class=\"glyphicon glyphicon-check\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.serviceOrderNotes(orders, status.bucket, $event)\" uib-tooltip=\"{{'common.notes' | translate}}\" ng-disabled=\"$ctrl.serviceHistory[orders.serviceOrderId].process\">\n<span class=\"glyphicon glyphicon-list-alt\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.details(orders)\" uib-tooltip=\"{{'common.details' | translate}}\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-info\" ng-click=\"$ctrl.viewServiceTicketImages(orders, $event)\" ng-if=\"orders.hasImages\" uib-tooltip=\"{{'common.images' | translate}}\" tooltip-placement=\"top-right\" ng-disabled=\"orders.loadingImages\">\n<span class=\"glyphicon\" ng-class=\"orders.loadingImages ? 'glyphicon-refresh fast-right-spinner' : 'glyphicon-picture'\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.getServiceOrderHistory(orders, $event)\" ng-if=\"orders.expanded\" ng-disabled=\"$ctrl.serviceHistory[orders.serviceOrderId].process\">\n<span class=\"glyphicon glyphicon-refresh\" uib-tooltip=\"{{'common.refresh' | translate}}\"></span>\n</button>\n</div>\n</td>\n</tr>\n<tr ng-repeat-end ng-show=\"orders.expanded\">\n<td></td>\n<td colspan=\"11\" ng-if=\"$ctrl.serviceHistory[orders.serviceOrderId].process\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</td>\n<td colspan=\"11\" ng-if=\"!$ctrl.serviceHistory[orders.serviceOrderId].process\">\n<div>\n<table class=\"table table-condensed table-bordered inner-tbl-margin-bottom\">\n<thead>\n<tr class=\"tbl-header-color\">\n<th colspan=\"11\">{{'serviceTickets.service_actions' | translate}}\n<span class=\"badge badge-bg-color\">{{$ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderActionHistory.length}}</span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"text-center\">#</th>\n<th class=\"text-center\">{{'serviceTickets.action' | translate}}</th>\n<th class=\"text-center\">{{'common.status' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.userTime' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.resolve_codes' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.root_causes' | translate}}</th>\n<th class=\"text-center\">{{'serviceTicketParts.parts' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.parts_note' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.action_note' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.action_user_note' | translate}}</th>\n<th class=\"text-center\">{{'serviceTickets.images' | translate}}</th>\n</tr>\n<tr ng-repeat=\"data in $ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderActionHistory\">\n<td class=\"text-center\">{{$index + 1}}</td>\n<td class=\"text-center\">{{data.actionCode}}</td>\n<td class=\"text-center\">\n<span class=\"text-danger\" ng-if=\"data.completed\">{{'common.completed' | translate}}</span>\n<span class=\"text-danger\" ng-if=\"!data.completed\">{{'common.pending' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.completedByUserId\">{{data.username}} | </span>\n<span ng-if=\"data.completedAt\"> {{$ctrl.DateUtil.convetToBrowserTimezone(data.completedAt)}}</span>\n</td>\n<td class=\"text-center\">\n<div ng-repeat=\"resolveCode in data.actionCodeResponse track by $index\">\n<span>\n{{resolveCode}}<span ng-if=\"$index + 1 !== data.actionCodeResponse.length\">,</span>\n</span>\n</div>\n</td>\n<td class=\"text-center\">\n<div ng-repeat=\"rootCauseCode in data.actionCodeRootCause track by $index\">\n<span>\n{{rootCauseCode}}<span ng-if=\"$index + 1 !== data.actionCodeRootCause.length\">,</span>\n</span>\n</div>\n</td>\n<td class=\"text-center\">\n<div ng-repeat=\"part in data.serviceOrderParts track by $index\" ng-if=\"data.serviceOrderParts.length\">\n<span>\n{{part}}<span ng-if=\"$index + 1 !== data.serviceOrderParts.length\">,</span>\n</span>\n</div>\n</td>\n<td class=\"_history-details-section\">\n<div ng-repeat=\"note in data.serviceOrderPartsNotes track by $index\" ng-if=\"data.serviceOrderPartsNotes.length\">\n<span>\n{{note}}<span ng-if=\"$index + 1 !== data.serviceOrderPartsNotes.length\">,</span>\n</span>\n</div>\n</td>\n<td class=\"_history-details-section\">\n<span>{{data.serviceOrderActionNote}}</span>\n</td>\n<td>\n<span>{{data.serviceOrderActionUserNote}}</span>\n</td>\n<td class=\"text-center\">\n<button id=\"service-ticket-resolve-image-{{$index}}\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.serviceTicketResolveImage(data.pictures, orders.encounterId, $index)\" ng-if=\"data.pictures && data.pictures.images.length > 0\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"margin-10\">\n<table class=\"table table-condensed table-bordered inner-tbl-margin-bottom\">\n<thead>\n<tr class=\"tbl-header-color\">\n<th ng-attr-colspan=\"{{orders.externalProcessorId ? ($ctrl.hasACL.edit ? 7 : 6) : ($ctrl.hasACL.edit ? 6 : 5)}}\">\n<div style=\"display:flex; justify-content:space-between; align-items:center;\">\n<div>\n{{'serviceTickets.service_order_update_history' | translate}}\n<span class=\"badge badge-bg-color\">\n{{$ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderUpdateHistory.length}}\n</span>\n</div>\n<button ng-if=\"$ctrl.hasACL.edit && $ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderUpdateHistory.length > 0\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.openUpdateServiceHistory($ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderUpdateHistory, orders)\">\n<span>Update</span>\n</button>\n</div>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"text-center\">#</th>\n<th class=\"text-center\">{{'serviceTickets.update' | translate}}</th>\n<th class=\"text-center\">{{'common.dateTime' | translate}}</th>\n<th class=\"text-center\" ng-if=\"!orders.externalProcessorId\">{{'branch_mgmt.performed_by' | translate}}</th>\n<th class=\"text-center\" ng-if=\"orders.externalProcessorId\">{{'serviceTickets.technician' | translate}}</th>\n<th class=\"text-center\" ng-if=\"orders.externalProcessorId\">{{'serviceTickets.external_processor' | translate}}</th>\n<th class=\"text-center history-details-section\">{{'serviceTickets.note_details' | translate}}</th>\n</tr>\n<tr ng-repeat=\"data in $ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderUpdateHistory\">\n<td class=\"text-center\">{{$index + 1}}</td>\n<td class=\"text-danger text-center\">\n<span ng-if=\"data.statusUpdate\">\n<div>{{data.statusUpdate[0]}}</div>\n<div>{{data.statusUpdate[1]}}</div>\n</span>\n<span ng-if=\"data.status && !data.entryType\">{{$ctrl.getBucketName(data.status)}}</span>\n<span ng-if=\"data.entryType && !data.status && !data.statusUpdate\">{{$ctrl.translateEntryType(data.entryType)}}</span>\n</td>\n<td class=\"text-center\">\n<span>{{$ctrl.DateUtil.convetToBrowserTimezone(data.timestamp, true)}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"data.performedById\">\n{{data.performedById}} | {{data.performedByName}}\n<span ng-if=\"data.vehicleId\"> | ({{data.vehicleId}})</span>\n</span>\n<span ng-if=\"!data.performedById && data.userId\">\n{{data.userId}} | {{data.userName}}\n<span ng-if=\"data.vehicleId\"> | ({{data.vehicleId}})</span>\n</span>\n<span ng-if=\"!data.performedById && !data.userId && !data.externalProcessorId\">{{'serviceTickets.system' | translate}}</span>\n<span ng-if=\"!data.performedById && !data.userId && data.externalProcessorId\">{{data.technician}}\n<span ng-if=\"data.vehicleId\"> | ({{data.vehicleId}})</span>\n</span>\n</td>\n<td class=\"text-center\" ng-if=\"data.externalProcessorId\">\n{{data.externalProcessorId}}\n<span ng-if=\"data.externalProcessorName\"> | {{data.externalProcessorName}}</span>\n</td>\n<td>\n<span>\n<span ng-if=\"(data.status === 'ACCEPTED' || data.status === 'ASSIGNED' || data.status === 'HOLD' || data.status === 'HOLD_PARTS' ||\n                                                                     data.status === 'INCOMPLETED' || data.status === 'CANCELLED') && !data.entryData\">\n<span ng-if=\"data.serviceOrderStatusNote\">{{data.serviceOrderStatusNote}}</span>\n<span ng-if=\"!data.serviceOrderStatusNote\">{{'common.n_a' | translate}}</span>\n</span>\n<span ng-if=\"(data.status === 'ON_ROUTE' || data.status === 'ON_SITE') && !data.entryData\">\n<span ng-if=\"data.serviceOrderStatusNote\">{{data.serviceOrderStatusNote}}</span>\n<span ng-if=\"!data.serviceOrderStatusNote\">{{'common.n_a' | translate}}</span>\n</span>\n<span ng-if=\"data.status === 'COMPLETE' && !data.entryData\">\n<span ng-if=\"data.serviceOrderStatusNote\">{{data.serviceOrderStatusNote}}</span>\n<span ng-if=\"!data.serviceOrderStatusNote\">{{'common.n_a' | translate}}</span>\n</span>\n<span ng-if=\"data.entryData && data.entryType !== 'update-service-order-note'\">{{$ctrl.formatJsonObj(data.entryData)}}</span>\n<span ng-if=\"data.entryData && data.entryType === 'update-service-order-note'\">\n<span ng-init=\"h = $ctrl.getUpdateNoteHistory(data.entryData)\">\n{{h.info}} | serviceOrderStatusNotes:\n<span ng-repeat=\"n in h.notes\">\n<span ng-repeat=\"(k, v) in n\"><strong>{{$ctrl.getBucketName(k)}}</strong>: {{v}}</span>{{$last ? '' : ' | '}}\n</span>\n</span>\n</span>\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"margin-10\" ng-if=\"orders.externalProcessorId\">\n<table class=\"table table-condensed table-bordered inner-tbl-margin-bottom\">\n<thead>\n<tr class=\"tbl-header-color\">\n<th colspan=\"6\">{{'serviceTickets.service_order_external_processor_request_update_history' | translate}}\n<span class=\"badge badge-bg-color\">\n{{$ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderExternalProcessorHistory.length}}\n</span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th class=\"text-center\">#</th>\n<th class=\"text-center\">{{'serviceTickets.update' | translate}}</th>\n<th class=\"text-center\">{{'common.dateTime' | translate}}</th>\n<th class=\"text-center\" ng-if=\"!orders.externalProcessorId\">{{'branch_mgmt.performed_by' | translate}}</th>\n<th class=\"text-center\" ng-if=\"orders.externalProcessorId\">{{'serviceTickets.technician' | translate}}</th>\n<th class=\"text-center\" ng-if=\"orders.externalProcessorId\">{{'serviceTickets.external_processor' | translate}}</th>\n<th class=\"text-center history-details-section\">{{'serviceTickets.note_details' | translate}}</th>\n</tr>\n<tr ng-repeat=\"data in $ctrl.model.serviceHistoryData[orders.serviceOrderId].details.serviceOrderExternalProcessorHistory\">\n<td class=\"text-center\">{{$index + 1}}</td>\n<td class=\"text-danger text-center\">\n<span>\n<div>{{data.ServiceOrderExternalProcessorRequestmethod}}</div>\n</span>\n</td>\n<td class=\"text-center\">{{$ctrl.DateUtil.convetToBrowserTimezone(data.createdAt)}}</td>\n<td class=\"text-center\">\n<span>{{'serviceTickets.system' | translate | lowercase}}</span>\n</td>\n<td class=\"text-center\">\n<span>{{data.ExternalName}}</span>\n</td>\n<td>\n<span ng-if=\"data.ServiceOrderExternalProcessorRequestmethod === 'CREATE'\">{{'serviceTickets.createRequest' | translate}}</span>\n<span ng-if=\"data.ServiceOrderExternalProcessorRequestmethod === 'UPDATE'\">{{'serviceTickets.updateRequest' | translate}}</span>\n<span ng-if=\"data.ServiceOrderExternalProcessorRequestmethod === 'CANCEL'\">{{'serviceTickets.cancelRequest' | translate}}</span>\n<span ng-if=\"data.ServiceOrderExternalProcessorRequestmethod === 'COMPLETE'\">{{'serviceTickets.completeRequest' | translate}}</span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</td>\n</tr>\n</tbody>\n<tfoot ng-if=\"(status.bucket === 'COMPLETE' || status.bucket === 'CANCELLED') && ($ctrl.model.serviceOrderData[status.bucket].totalCount > $ctrl.model.serviceOrderData[status.bucket].pageLimit)\">\n<tr>\n<td colspan=\"9\" ng-if=\"!$ctrl.model.serviceOrderData[status.bucket].process\">\n<ul uib-pagination total-items=\"$ctrl.model.serviceOrderData[status.bucket].totalCount\" ng-hide=\"{{($ctrl.model.serviceOrderData[status.bucket].totalCount<=$ctrl.model.serviceOrderData[status.bucket].pageLimit)&&($ctrl.model.serviceOrderData[status.bucket].page==1)}}\" items-per-page=\"$ctrl.model.serviceOrderData[status.bucket].pageLimit\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.serviceOrderData[status.bucket].page\" ng-change=\"$ctrl.bucketPageChange(status.bucket)\" rotate=\"false\" max-size=\"10\"></ul>\n</td>\n</tr>\n</tfoot>\n</table>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad align-center-horizontally\" ng-if=\"$ctrl.totalCompletedAndCancelledServiceTickets == 0 && $ctrl.model.totalServiceOrders == 0\n                                                  && !$ctrl.model.isLoadingServiceOrder && !$ctrl.serviceOrderError\">\n<div class=\"col-sm-12 alert errLblPos text-center alert-danger\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad align-center-horizontally\" ng-if=\"!$ctrl.model.isLoadingServiceOrder && $ctrl.serviceOrderError\">\n<div class=\"col-sm-12 alert errLblPos text-center\" ng-class=\"{'alert-danger': $ctrl.serviceOrderError}\">\n<span>{{$ctrl.serviceOrderError}}</span>\n</div>\n</div>\n</form>\n";
var id1="service_tickets.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2787 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<ul class=\"nav nav-tabs\">\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('users')\" ui-sref-active=\"active\" ui-sref=\"users\">\n<a translate=\"users.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('branch')\" ui-sref-active=\"active\" ui-sref=\"branch\">\n<a translate=\"branch.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('batch')\" ui-sref-active=\"active\" ui-sref=\"batch\">\n<a translate=\"batch.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('location')\" ui-sref-active=\"active\" ui-sref=\"location\">\n<a translate=\"location.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('routes')\" ui-sref-active=\"active\" ui-sref=\"routes\">\n<a translate=\"route.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('items-type')\" ui-sref-active=\"active\" ui-sref=\"items-type\">\n<a translate=\"itemType.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('items')\" ui-sref-active=\"active\" ui-sref=\"items\">\n<a translate=\"item.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('carrier')\" ui-sref-active=\"active\" ui-sref=\"carrier\">\n<a translate=\"carrier.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('truck')\" ui-sref-active=\"active\" ui-sref=\"truck\">\n<a translate=\"truck.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('holiday')\" ui-sref-active=\"active\" ui-sref=\"holiday\">\n<a translate=\"holiday.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('branch-funding-source')\" ui-sref-active=\"active\" ui-sref=\"branch-funding-source\">\n<a translate=\"branchFundingSource.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('branch-funding-source-holiday')\" ui-sref-active=\"active\" ui-sref=\"branch-funding-source-holiday\">\n<a translate=\"branchFundingSourceHoliday.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('log')\" ui-sref-active=\"active\" ui-sref=\"log\">\n<a translate=\"log.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('reset-atm-code')\" ui-sref-active=\"active\" ui-sref=\"reset-atm-code\">\n<a translate=\"resetAtmCode.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('service-settings')\" ui-sref-active=\"active\" ui-sref=\"service-settings\">\n<a translate=\"serviceSettings.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('delivery-region-routing')\" ui-sref-active=\"active\" ui-sref=\"delivery-region-routing\">\n<a translate=\"deliveryRegionRouting.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('service-ticket-parts')\" ui-sref-active=\"active\" ui-sref=\"service-ticket-parts\">\n<a translate=\"serviceTicketParts.menu.title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasAcl('preventative-maintenance')\" ng-click=\"$ctrl.go('/v2/index.html#/preventative-maintenance')\">\n<a translate=\"location.preventativeMaintenance\"></a>\n</li>\n</ul>\n<div style=\"padding: 20px 0px;\">\n<ui-view></ui-view>\n</div>\n</div>\n";
var id1="settings.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\" ng-if=\"$ctrl.currentStat == 'DeliveryManifestStat'\">\n<div class=\"row\" style=\"text-align: center;\">\n<div class=\"col-sm-12\" ng-repeat=\"shipmentData in $ctrl.printData track by $index\">\n<div>\n<div class=\"align-center-horizontally\">\n<img stream-print-logo style=\"height: 80px;\">\n</div>\n<h4>{{ 'shipmentBatch.manifest' | translate }}</h4>\n<div id=\"print-section\">\n<div class=\"row col-sm-12 text-align-left margin-top-40\">\n<div class=\"col-sm-7 col-print-7\">\n<div> {{ 'shipmentBatch.fromLocation' | translate}}: </div>\n<div>\n<h3 class=\"margin-zero\">\n<strong>{{'bagout_print.fromLocationName' | translate}}</strong>\n</h3>\n</div>\n<div>\n<h4>{{'bagout_print.fromLocationAddress' | translate}}</h4>\n</div>\n</div>\n<div class=\"col-sm-5 col-print-5\">\n<div class=\"margin-zero text-align-left\">\n{{ 'shipmentBatch.toLocation' | translate }}:\n</div>\n<div>\n<h3 class=\"margin-zero\">\n<div>\n<strong>{{shipmentData.info[0].name }}</strong>\n<span> | {{shipmentData.info[0].toLocationId }}</span>\n</div>\n</h3>\n<div class=\"margin-zero\">\n<h4>\n{{shipmentData.info[0].toLocationAddress}}\n</h4>\n</div>\n</div>\n</div>\n</div>\n<div class=\"hide-in-print\">\n<br><br><br>\n</div>\n<div class=\"col-sm-12 col-print-12 text-align-left margin-top-20 print-margin-bottom-20\">\n<div class=\"col-sm-9 col-print-9 shipment-info remove-left-pad\">\n<strong>\n{{ 'shipmentBatch.route' | translate }}:\n</strong>\n<span>{{ shipmentData.info[0].routeIds }}</span>\n<strong class=\"margin-left-10\">\n{{ 'shipmentBatch.totalBags' | translate }}:\n</strong>\n<span>{{ shipmentData.info[0].totalCashShipment }}</span>\n<strong class=\"margin-left-10\">\n{{ 'shipmentBatch.totalCoin' | translate }}:\n</strong>\n<span>{{ shipmentData.info[0].totalCoinShipment }}</span>\n<strong class=\"margin-left-10\">\n{{ 'shipmentBatch.totalAmount' | translate}}:\n</strong>\n<span>{{ shipmentData.info[0].amount | currency: '$'}}</span>\n</div>\n<div class=\"col-sm-3 col-print-3 pull-right remove-pad text-right\">\n<div>\n<strong>\n{{ 'shipmentBatch.shipmentDate' | translate }}:\n</strong>\n<span ng-if=\"shipmentData.info[0].pickupDate\">{{ shipmentData.info[0].pickupDate | date: 'longDate'}}</span>\n<span ng-if=\"!shipmentData.info[0].pickupDate\">{{ shipmentData.info[0].vaultDate | date: 'longDate'}}</span>\n</div>\n<div>\n<strong>\n{{ 'shipmentBatch.deliveryDate' | translate }}:\n</strong>\n<span>{{ shipmentData.info[0].deliveryDate | date: 'longDate'}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-20\">\n<table class=\"table table-striped table-bordered\">\n<thead class=\"header-row\">\n<tr>\n<td>\n<strong>#</strong>\n</td>\n<td>\n<strong>{{ 'shipmentBatch.tracking_id' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.fromLocationName' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.ToLocationName' | translate }}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.transactionType' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.amount' | translate}}</strong>\n</td>\n<td>\n<strong>{{ 'checkout.verify' | translate}}</strong>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"shipment in shipmentData.shipments\">\n<td>{{ $index+1 }}</td>\n<td>{{ shipment.trackingId }}\n<span ng-if=\"shipment.coinFlag\"> | {{shipment.qty}}</span>\n<span ng-if=\"shipment.holdFlag\">\n<img src=\"" + __webpack_require__(80) + "\" class=\"hold-icon-size\">\n</span>\n</td>\n<td>{{ shipment.fromLocation }}</td>\n<td>{{ shipment.toLocation }}</td>\n<td>{{ shipment.shiptypeId }}</td>\n<td>{{ shipment.amount | currency:'$' }}</td>\n<td></td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"checkout-verify\">\n<div class=\"manifest-content margin-top-40 remove-print-margin margin-bottom-50\">\n<div>\n<span class=\"text-align-left lineColor print-margin-bottom-20\">_________________________________________</span>\n<h4 class=\"text-align-center\">{{'branch_mgmt.route_messenger' | translate}}</h4>\n</div>\n<div class=\"margin-top-30\">\n<span class=\"text-align-left lineColor\">_________________________________________</span>\n<h4 class=\"text-align-center\">{{'checkin.customer' | translate}}</h4>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n</div>\n</div>\n<div class=\"container-fluid\" ng-if=\"$ctrl.currentStat == 'pendingStat'\">\n<div class=\"row\">\n<div id=\"print-section\" class=\"margin-top-02\">\n<div class=\"barcode-print-page\">\n<div class=\"barcode-row\" ng-repeat=\"row in $ctrl.model.columnData\">\n<div class=\"barcode-column\" ng-repeat=\"col in row\">\n<div class=\"_barcode-center-align auto-adjust-page-css barcode-print-section\">\n<div>\n<div>\n<div class=\"margin-top-02 align-center-horizontally\">\n<span class=\"print-company-title-section\">\n<span ng-if=\"col.routeId\">{{col.routeId}} </span>\n<span ng-if=\"col.locationType\"> | {{col.locationType}}</span>\n<span><b> | {{col.total | currency:\"$\"}}</b></span>\n</span>\n</div>\n</div>\n<div>\n<angular-barcode ng-model=\"col.trackingId\" class=\"tracking-id-labels _barcode-page\" bc-options=\"$ctrl.model.barcodeOptions\" bc-class=\"barcode\" bc-type=\"svg\">\n</angular-barcode>\n</div>\n<div class=\"pre-print-tracking-id-location\">\n<span ng-if=\"col.locationId\"><b>{{col.locationId}}</b></span>\n<span ng-if=\"col.locationName\"><b>| {{col.locationName}}</b></span>\n</div>\n<div class=\"print-delivery-date-font-size\">\n<span ng-if=\"col.deliveryDate\">{{col.deliveryDate}}</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"container-fluid\" ng-if=\"$ctrl.currentStat == 'completedStat'\">\n<div class=\"row\">\n<div id=\"print-section\" class=\"margin-top-02\">\n<div class=\"complete-barcode-print-page\">\n<div class=\"complete-barcode-row\" ng-repeat=\"col in $ctrl.model.columnn\">\n<div class=\"complete-barcode-column\" ng-repeat=\"row in col\">\n<div class=\"_barcode-center-align auto-adjust-page-css barcode-print-section\">\n<div>\n<div>\n<div class=\"margin-top-02 align-center-horizontally\">\n<span class=\"print-company-title-section\">\n<span ng-if=\"row.routeId\">{{row.routeId}} </span>\n<span ng-if=\"row.locationType\"> | {{row.locationType}}</span>\n<span><b> | {{row.amount | currency:\"$\"}}</b></span>\n</span>\n</div>\n</div>\n<div>\n<angular-barcode ng-model=\"row.trackingId\" class=\"complete-tracking-id-labels _barcode-page\" bc-options=\"$ctrl.model.barcodeOptions\" bc-class=\"barcode\" bc-type=\"svg\">\n</angular-barcode>\n</div>\n<div class=\"complete-pre-print-tracking-id-location\">\n<span ng-if=\"row.location\"><b>{{row.location}}</b></span>\n</div>\n<div class=\"print-delivery-date-font-size\">\n<span ng-if=\"row.deliveryDate\">{{row.deliveryDate | date: 'dd-MMM-yyyy'}}</span>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"pagebreak\"></div>\n</div>\n</div>\n</div>\n</div>\n";
var id1="print_batch.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2789 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<a ng-click=\"$ctrl.changeType($event, key.group, type.icon, $index)\" role=\"button\" ng-repeat=\"type in $ctrl.coinTypes[key.group].denomList track by $index\">\n\t\t\t\t\t<denom-icon ng-if=\"type.icon !== 'M' && type.icon !== 'MXD'\" denom-id=\"type.icon\" icon-size=\"30\"> </denom-icon>\n\t\t\t\t\t<denom-icon ng-if=\"type.icon === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n\t\t\t\t\t<denom-icon ng-if=\"type.icon === 'MXD'\" denom-id=\"'MXD-route-sheet'\" icon-size=\"30\"> </denom-icon>\n\t\t\t\t</a>\n";
var id1="coin-selection.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
var v2="\n<div>\n\t\t\t\t\t<div class=\"\">\n\t\t\t\t\t\t<div class=\"\">\n\t\t\t\t\t\t\t<span >\n\t\t\t\t\t\t\t\t<strong>{{'shipmentBatch.locationSuspended' | translate}} </strong>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"align-center-vertically \" >\n\t\t\t\t\t\t\t<input id=\"status\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\"\n\t\t\t\t\t\t\tbs-switch switch-size=\"small\" switch-on-color=\"success\" ng-change=\"onUpdateLocation()\"\n\t\t\t\t\t\t\tswitch-off-color=\"danger\" ng-model=\"model.suspendStatus\" type=\"checkbox\" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n";
var id2="update-location.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id2,v2);}
else{ngModule.run(["$templateCache",function(c){c.put(id2,v2)}]);}
var v3="\n<div>\n\t\t\t\t\t<div class=\"align-center-vertically\">\n\t\t\t\t\t\t<div class=\"margin-right-10\">\n\t\t\t\t\t\t\t<span class=\"font-size-20\">\n\t\t\t\t\t\t\t\t<strong>{{model.locationName}}</strong>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"pull-right\">\n\t\t\t\t\t\t\t<button \n\t\t\t\t\t\t\t\tclass=\"btn btn-xs btn-success pull-right\" \n\t\t\t\t\t\t\t\tng-click=\"onCreateLocation()\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t{{'setup.new' | translate}}\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<span>{{model.locationAddress}}</span>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n";
var id3="create-location.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id3,v3);}
else{ngModule.run(["$templateCache",function(c){c.put(id3,v3)}]);}
var v4="<div class=\"margin-bottom-20\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 text-center\">\n<div class=\"_col-sm-4 btn-group z-index0 margin-bottom-10\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.currentStats\" uib-btn-radio=\"$ctrl.stats.deliveryShipment\" ng-click=\"$ctrl.tabSelection('deliveryShipment')\" ng-class=\"{'btn-success': $ctrl.currentStats === $ctrl.stats.deliveryShipment, \n\t\t\t\t\t\t\t   'remove-btn-grp-color': $ctrl.currentStats !== $ctrl.stats.deliveryShipment}\">\n{{'shipmentBatch.delivery_shipment' | translate}}\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.currentStats\" uib-btn-radio=\"$ctrl.stats.atmLoads\" ng-click=\"$ctrl.tabSelection('atmLoads');\" ng-class=\"{'btn-success': $ctrl.currentStats === $ctrl.stats.atmLoads, \n\t\t\t\t\t\t\t   'remove-btn-grp-color': $ctrl.currentStats !== $ctrl.stats.atmLoads}\">\n{{'location.atm_load' | translate}}\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.currentStats\" uib-btn-radio=\"$ctrl.stats.completedShipment\" ng-click=\"$ctrl.tabSelection('completedShipment');\" ng-class=\"{'btn-success': $ctrl.currentStats === $ctrl.stats.completedShipment, \n\t\t\t\t\t\t\t   'remove-btn-grp-color': $ctrl.currentStats !== $ctrl.stats.completedShipment}\">\n{{'shipmentBatch.completed_shipment' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\"><hr class=\"shipment-batch-line-section\"></div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.currentStats === $ctrl.stats.deliveryShipment\">\n<div class=\"col-sm-12 remove-pad shipment-batch-top-section\">\n<div class=\"col-sm-3 from-location margin-bottom-5 remove-left-pad\">\n<label for=\"customer\">{{'branch.branches' | translate}} *</label>\n<div class=\"multi-select valid-multi-select-value\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.branches\" output-model=\"$ctrl.model.branches\" button-label=\"Key\" item-label=\"Key\" search-property=\"Key\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.branchChanged()\" on-select-all=\"$ctrl.selectAllBranches()\" on-reset=\"$ctrl.model.branches = [{Value: $ctrl.model.branchId}];$ctrl.branchChanged();\" on-select-none=\"$ctrl.locations= []; $ctrl.model.location = ''\" required>\n</div>\n</div>\n<div class=\"col-sm-3 from-location margin-bottom-5 remove-left-pad\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{ 'shipmentBatch.tooltip_info' | translate }}\" tooltip-placement=\"right\"></span>\n<label for=\"customer\">{{'shipmentBatch.location' | translate }} *</label>\n<search-and-select ng-model=\"$ctrl.model.location\" values=\"$ctrl.locations\" key=\"Key\" totalrecords=\"$ctrl.totalLocationRecords\" long-dd-width-flag=\"true\" on-click=\"$ctrl.fromLocationChanged()\" none-selected=\"'shipmentBatch.locationPlaceholder'\" hide-count=\"true\" is-change-offset=\"$ctrl.changeOffsetFlag\" is-change-offset-value=\"$ctrl.offset\" common-search-flag=\"true\" required common-search-flag=\"true\"></search-and-select>\n</div>\n<div class=\"remove-left-pad col-sm-2 margin-bottom-5\">\n<label for=\"batch-master\">{{'shipmentBatch.batch_master' | translate }}</label>\n<input class=\"form-control\" type=\"text\" disabled=\"disabled\" ng-model=\"$ctrl.model.batchMaster\"/>\n</div>\n<div class=\"remove-left-pad col-sm-2 margin-bottom-5\">\n<label for=\"\">{{'shipmentBatch.pickupDate' | translate }} </label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.pickupDate\" date-options=\"$ctrl.pickupDateOptions\" ng-click=\"$ctrl.isDateChanged(date, mode)\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n<div class=\"remove-left-pad col-sm-2 margin-bottom-5\">\n<label for=\"\">{{'shipmentBatch.deliveryDate' | translate }} </label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.deliveryDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-change=\"$ctrl.deliveryDateChanged()\" date-options=\"$ctrl.deliveryDateOptions\" ng-keydown=\"$event.preventDefault()\" show-button-bar=\"false\">\n</datetimepicker>\n</div>\n<div class=\"margin-bottom-10\">\n<label class=\"hidden-xs\" style=\"width: 100%\">&nbsp;&nbsp;</label>\n<div class=\"btn-group buttongroup\" role=\"group\">\n<button type=\"button\" class=\"btn btn-success\" ng-if=\"$ctrl.model.autoGenerateTrackIdToggle && $ctrl.autoGenerateToggle && $ctrl.getTotalByName('total')\" ng-click=\"$ctrl.printLabels()\">{{'orderPacking.print_labels' |translate}}\n</button>\n<button class=\"btn btn-success\" ng-disabled=\"!$ctrl.model.location || !$ctrl.model.batchMaster || !$ctrl.model.deliveryDate || !$ctrl.areShipmentsValid || $ctrl.isRouteDisabled || $ctrl.commitDisabled()\" ng-click=\"$ctrl.setNewRoutes()\">\n<i class=\"glyphicon\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t'glyphicon-refresh fast-right-spinner': $ctrl.isRouteDisabled,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}\"></i>{{'shipmentBatch.route' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.executeReleaseRoutes()\" ng-disabled=\"$ctrl.isCommitDisabled || !$ctrl.areShipmentsValid || !$ctrl.isRoutesSet || $ctrl.commitDisabled()\">\n{{'shipmentBatch.commit' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!$ctrl.uploadedFiles.length || $ctrl.isDisabled || !$ctrl.model.location\" ng-click=\"$ctrl.selectUploadFile()\" ng-if=\"!$ctrl.isRoutesSet && $ctrl.uploadedFiles.length\">\n{{'shipmentBatch.uploadedFiles' | translate}}\n<span class=\"badge\">{{$ctrl.uploadedFiles.length}}</span>\n</button>\n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.uploadBatchFile()\">{{'shipmentBatch.upload_file' | translate}}</button>\n<button type=\"button\" class=\"btn btn-danger\" ng-click=\"$ctrl.performReset()\">{{'shipmentBatch.reset' | translate}}</button>\n</div>\n</div>\n</div>\n<div class=\"form-group\">\n<label for=\"exampleInputPassword1\">{{'shipmentBatch.description' | translate }} </label>\n<textarea class=\"form-control\" rows=\"2\" ng-model=\"$ctrl.model.description\"></textarea>\n<span ng-if=\"$ctrl.errors.description\" class=\"text-danger\">{{$ctrl.errors['description']}}</span>\n</div>\n<div class=\"batch-controls-container\">\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.coinOnlyBatch\" uib-btn-radio=\"false\" ng-class=\"{'btn-success': !$ctrl.model.coinOnlyBatch,\n\t\t\t\t\t\t\t\t   'remove-btn-grp-color': $ctrl.model.coinOnlyBatch}\" ng-click=\"$ctrl.onCoinOnlyBatchToggle()\">{{'shipmentBatch.cash_coin' | translate}}</button>\n<button type=\"button\" class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.coinOnlyBatch\" uib-btn-radio=\"true\" ng-class=\"{'btn-success': $ctrl.model.coinOnlyBatch,\n\t\t\t\t\t\t\t\t   'remove-btn-grp-color': !$ctrl.model.coinOnlyBatch}\" ng-click=\"$ctrl.onCoinOnlyBatchToggle()\">{{'shipmentBatch.coin_only' | translate}}</button>\n</div>\n<div class=\"amount-toggle-wrapper\">\n<label>Amount</label>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.amountToggle\" switch-size=\"mini\" switch-on-text=\"ON\" switch-off-text=\"OFF\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.onAmountToggleChange()\"/>\n</div>\n</div>\n<table class=\"table table-bordered table-striped batch-shipment\">\n<thead class=\"border-bottom-2\">\n<tr>\n<td align=\"center\" class=\"shipment-batch-col-width-150\">\n<span for=\"\">{{'shipmentBatch.locationId'|translate}}</span>\n<div class=\"pull-right\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.bankLocationDDToggle\" switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.bankLocationToggleChange()\"/>\n</div>\n</td>\n<td align=\"center\" class=\"shipment-batch-col-width-100\">\n<span for=\"\">{{'shipmentBatch.tracking_id'|translate}}</span>\n<div class=\"pull-right\" ng-if=\"$ctrl.autoGenerateToggle && !$ctrl.model.coinOnlyBatch\">\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.autoGenerateTrackIdToggle\" switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.autoGenerateTrackingToggleChange();\"/>\n</div>\n</td>\n<td align=\"center\" class=\"shipment-batch-col-width-70\">\n<span for=\"\">{{'shipmentBatch.total' | translate}}</span>\n</td>\n<td align=\"center\" class=\"coin-entry\" ng-repeat=\"key in $ctrl.denominationTypeData\">\n<a role=\"button\" uib-popover-template=\"$ctrl.coinTypes[key.group].template\" popover-is-open=\"$ctrl.coinTypes[key.group].isOpen\" popover-append-to-body=\"true\" popover-trigger=\"'outsideClick'\">\n<denom-icon ng-if=\"$ctrl.coinTypes[key.group].selected !== 'M' && $ctrl.coinTypes[key.group].selected !== 'MXD'\" denom-id=\"$ctrl.coinTypes[key.group].selected\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"$ctrl.coinTypes[key.group].selected === 'M'\" denom-id=\"'misc'\" icon-size=\"30\"> </denom-icon>\n<denom-icon ng-if=\"$ctrl.coinTypes[key.group].selected === 'MXD'\" denom-id=\"'MXD-route-sheet'\" icon-size=\"30\"> </denom-icon>\n</a>\n</td>\n<td align=\"center\" class=\"shipment-batch-col-width-80\">\n<span>{{'shipmentBatch.currency'|translate}}</span>\n</td>\n<td align=\"center\" class=\"col-width-100\">\n<span>{{'shipmentBatch.route'|translate}}</span>\n</td>\n<td align=\"center\" class=\"shipment-batch-col-width-25 _padding-horizontal-29\">\n</td>\n</tr>\n</thead>\n<tbody class=\"scroll-content\">\n<tr class=\"shipment-record\" shipment-record ng-repeat=\"shipmentBatchRecord in $ctrl.model.shipments\" is-routes-set=\"$ctrl.isRoutesSet\" record-model=\"shipmentBatchRecord\" currency=\"$ctrl.getCurrency($index)\" currency-total=\"$ctrl.getCurrencyTotal()\" batch-master=\"$ctrl.model.batchMaster\" on-tab=\"$ctrl.addOnTab($index)\" on-remove=\"$ctrl.confirmRemove($index)\" on-create-location=\"!shipmentBatchRecord.isSuspended ? $ctrl.createLocation($index):'';\" on-update-location=\"shipmentBatchRecord.isSuspended ? $ctrl.updateLocation($index, shipmentBatchRecord.suspendStatus):'';\" duplicate-tracking-ids=\"$ctrl.model.duplicateTrackingIds\" show-bank-location-dd=\"$ctrl.model.bankLocationDDToggle\" bank-locations=\"$ctrl.bankLocationsObj\" denomination-type-obj=\"{denomTypes: $ctrl.denominationTypeData, coinTypes: $ctrl.coinTypes}\" amount-toggle=\"$ctrl.model.amountToggle\" coin-values=\"$ctrl.coinValues\" coin-only-batch=\"$ctrl.model.coinOnlyBatch\" is-generate-tracking-id-loading=\"$ctrl.model.isGenerateTrackingIdLoading\"/>\n<tr>\n<td align=\"left\" style=\"padding: 2px;\">\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.addOnButton()\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n<tbody>\n<tr align=\"center\" ng-if=\"$ctrl.model.shipments && $ctrl.model.shipments.length\">\n<td class=\"shipment-batch-col-width-140\"></td>\n<td class=\"shipment-batch-col-width-70\"></td>\n<td class=\"wrap-text shipment-batch-col-width-70\">\n<span>{{$ctrl.getTotalByName('total')|currency:'$'}}</span>\n</td>\n<td class=\"wrap-text coin-entry\" ng-repeat=\"key in $ctrl.denominationTypeData\">\n{{$ctrl.getTotalByName($ctrl.coinTypes[key.group].categoryName, key.group ,true)|currency:'$'}}\n</td>\n<td class=\"wrap-text shipment-batch-col-width-80\">{{$ctrl.getCurrencyTotal() | currency:'$'}}</td>\n<td class=\"col-width-100\"></td>\n<td class=\"shipment-batch-col-width-25 _padding-horizontal-29\"></td>\n</tr>\n</tbody>\n</table>\n</div></form>\n</div>\n\n\n\n\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.currentStats === $ctrl.stats.atmLoads\">\n<form name=\"ATMLoadForm\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.atmLoadModel.atmLoadShipment.length > 0\">\n<table class=\"table-pad-7 table table-bordered table-striped margin-bottom-06\">\n<thead class=\"border-bottom-2\">\n<tr>\n<td align=\"center\">\n<span for=\"\">{{'atm_deposit_packing.fundingSource' | translate}}</span>\n</td>\n<td align=\"center\">\n<span for=\"\">{{'branch_mgmt.servicehistory.order_no' | translate}}</span>\n</td>\n<td align=\"center\">\n<span for=\"\">{{'common.location' | translate}}</span>\n</td>\n<td align=\"center\">\n<span>{{'bypassCode.route'|translate}}</span>\n</td>\n<td align=\"center\">\n<span>{{'routeControl.routeDate'|translate}}</span>\n</td>\n<td align=\"center\">\n<span>{{'branch_mgmt.orders_orderType'|translate}}</span>\n</td>\n<td align=\"center\" ng-repeat=\"denomination in $ctrl.atmLoadModel.denominations\">\n<denom-icon denom-id=\"denomination.id\" icon-size=\"30\"> </denom-icon>\n</td>\n<td align=\"center col-width-6\">\n{{'common.action' | translate}}\n</td>\n</tr>\n</thead>\n<tbody>\n<tr align=\"center\" ng-repeat=\"shipment in $ctrl.atmLoadModel.atmLoadShipment track by $index\">\n<td>{{shipment.fundingSource.Key}}</td>\n<td>{{shipment.orderNo}}</td>\n<td>{{shipment.location.Value}}</td>\n<td>{{shipment.route.Value}}</td>\n<td>{{shipment.vaultDate | date: 'yyyy-MM-dd'}}</td>\n<td>{{$ctrl.getOrderType(shipment.orderType)}}</td>\n<td ng-repeat=\"denomination in $ctrl.atmLoadModel.denominations\">\n<span ng-if=\"shipment.denominations[denomination.id].amount >= 0\">{{shipment.denominations[denomination.id].amount | currency:'$'}}</span>\n<span ng-if=\"!shipment.denominations[denomination.id]\">-</span>\n</td>\n<td class=\"col-width-6\">\n<button type=\"button\" class=\"btn btn-xs btn-primary\" ng-click=\"$ctrl.editAtmLoad(shipment, $index)\" uib-tooltip=\"{{'common.Edit' | translate}}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.deleteAtmLoad(shipment, $index)\" uib-tooltip=\"{{'common.Delete' | translate}}\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.atmLoadModel.atmLoadShipment.length <= 0\">\n<span class=\"col-sm-12 alert alert-danger text-align-center remove-bottom-margin\">\n{{'route_sheet.no_data_found' | translate}}\n</span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-class=\"{'margin-top-06': $ctrl.atmLoadModel.atmLoadShipment.length === 0}\"><hr class=\"shipment-batch-line-section\"></div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"pull-right\">\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.newAtmLoads()\" ng-disabled=\"$ctrl.atmLoadModel.isCreatingAtmOrders\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.resetAtmLoads()\" ng-disabled=\"$ctrl.atmLoadModel.atmLoadShipment.length == 0  || $ctrl.atmLoadModel.isCreatingAtmOrders\">\n<span class=\"glyphicon glyphicon-trash\"></span> {{'common.reset' | translate}}</button>\n<button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"$ctrl.createAtmLoads()\" ng-disabled=\"$ctrl.atmLoadModel.atmLoadShipment.length == 0 || $ctrl.atmLoadModel.isCreatingAtmOrders\">\n<span class=\"glyphicon glyphicon-check\"></span> {{'common.Create' | translate}}\n<i class=\"glyphicon\" ng-class=\"{'glyphicon-refresh fast-right-spinner': $ctrl.atmLoadModel.isCreatingAtmOrders}\"></i>\n</button>\n</div>\n</div>\n</form>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.currentStats === $ctrl.stats.completedShipment\">\n<form name=\"CompletedShipmentForm\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-left-pad\">\n<div class=\"remove-left-pad col-sm-6 margin-bottom-5\">\n<label for=\"\">{{'branch_mgmt.daily_balance_sheet.vaultDate' | translate }} </label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" ng-click=\"$ctrl.dateChange();\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" placeholder=\"{{'common.select_date' | translate}}\"/>\n</div>\n<div class=\"remove-right-pad col-sm-6\">\n<label for=\"\">{{'master_cash_schedule.batch_id' | translate }} </label>\n<input class=\"form-control\" type=\"text\" ng-change=\"$ctrl.search()\" ng-model=\"$ctrl.model.searchText\" search-autofocus placeholder=\"{{'master_cash_schedule.batch_id' | translate}}\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.loading;\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<table class=\"table-pad-7 table table-bordered table-striped margin-bottom-06\" ng-if=\"!$ctrl.model.loading && $ctrl.shipment.results.length > 0\">\n<thead class=\"border-bottom-2\">\n<tr>\n<td align=\"center\" class=\"remove-white-space\" ng-click=\"$ctrl.sortData('batchId')\">\n<span for=\"\">{{'master_cash_schedule.batch_id' | translate}}</span>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.reverseSort, 'active' : $ctrl.model.sortColumn === 'batchId'}\"></span>\n</td>\n<td align=\"center\" class=\"remove-white-space\">\n<span for=\"\">{{'branch_mgmt.daily_balance_sheet.vaultDate' | translate}}</span>\n</td>\n<td align=\"center\" class=\"remove-white-space\" ng-click=\"$ctrl.sortData('fromLocationId')\">\n<span for=\"\">{{'shipmentBatch.location' | translate}}</span>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.reverseSort, 'active' : $ctrl.model.sortColumn === 'fromLocationId'}\"></span>\n</td>\n<td align=\"center\" class=\"remove-white-space\">\n<span for=\"\">{{'shipmentBatch.total_shipments' | translate}}</span>\n</td>\n<td align=\"center\" class=\"remove-white-space\">\n<span for=\"\">{{'shipmentBatch.total_coin_quantity' | translate}}</span>\n</td>\n<td align=\"center\" class=\"remove-white-space\" ng-click=\"$ctrl.sortData('totalCoinValue')\">\n<span for=\"\">{{'shipmentBatch.total_coin_amount' | translate}}</span>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.reverseSort, 'active' : $ctrl.model.sortColumn === 'totalCoinValue'}\"></span>\n</td>\n<td align=\"center\" class=\"remove-white-space\">\n<span for=\"\">{{'shipmentBatch.total_cash_quantity' | translate}}</span>\n</td>\n<td align=\"center\" class=\"remove-white-space\" ng-click=\"$ctrl.sortData('totalCashValue')\">\n<span for=\"\">{{'shipmentBatch.total_cash_amount' | translate}}</span>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.reverseSort, 'active' : $ctrl.model.sortColumn === 'totalCashValue'}\"></span>\n</td>\n<td align=\"center\" class=\"remove-white-space\" ng-click=\"$ctrl.sortData('totalValue')\">\n<span for=\"\">{{'bagout.totalAmount' | translate}}</span>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.reverseSort, 'active' : $ctrl.model.sortColumn === 'totalValue'}\"></span>\n</td>\n<td align=\"center\">\n<span for=\"\">{{'bulkCash.action' | translate}}</span>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr align=\"center\" ng-repeat=\"shipment in $ctrl.shipment.results track by $index\">\n<td class=\"remove-white-space\">{{shipment.batchId}}</td>\n<td class=\"remove-white-space\">{{shipment.vaultDate | date: 'yyyy-MM-dd'}}</td>\n<td>{{shipment.fromLocationId}}</td>\n<td>{{shipment.totalShipment}}</td>\n<td>{{shipment.totalCoinQty}}</td>\n<td>{{shipment.totalCoinValue}}</td>\n<td>{{shipment.totalCashQty}}</td>\n<td>{{shipment.totalCashValue}}</td>\n<td>{{shipment.totalValue}}</td>\n<td>\n<button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"$ctrl.printCompleteShipmentLabels(shipment.batchId, shipment.fromLocationId)\">\n{{'orderPacking.print_labels' | translate}}\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12 remove-pad item-hold-pagination-margin-bottom\" ng-if=\"$ctrl.pagination.total > 10 && !$ctrl.model.loading\">\n<ul class=\"margin-bottom-10\" uib-pagination total-items=\"$ctrl.pagination.total\" ng-hide=\"{{($ctrl.pagination.total<=$ctrl.pagination.pageLimit)&&($ctrl.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"$ctrl.pagination.maxPages\"></ul>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.shipment.results.length <= 0 && !$ctrl.model.loading\">\n<span class=\"col-sm-12 alert alert-danger text-align-center remove-bottom-margin\">\n{{'route_sheet.no_data_found' | translate}}\n</span>\n</div>\n</div>\n</form>\n</div>\n";
var id4="shipment_batch.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id4,v4);}
else{ngModule.run(["$templateCache",function(c){c.put(id4,v4)}]);}
module.exports=v4;

/***/ }),
/* 2790 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<td class=\"shipment-batch-col-width-150\">\n<div ng-class=\"{'has-error has-feedback': model.location === null}\" uib-popover-template=\"model.isSuspended ? 'update-location.html' : 'create-location.html'\" popover-class=\"popover\" popover-is-open=\"model.popoverStatus\" popover-placement=\"top-left\" popover-enable=\"!model.defaultBranch && !model.isFromOtherBranch && model.location === null || !model.location && model.defaultBranch == model.branchId && model.refId !== model.location.id && model.locationName\" popover-trigger=\"'outsideClick'\">\n<div ng-hide=\"!showBankLocationDd\" class=\"shipment-batch-assignment-section\">\n<search-and-select ng-disabled=\"model.location\" ng-model=\"model.refIdObj\" values=\"bankLocations.list\" key=\"Key\" totalrecords=\"bankLocations.totalLocationRecords\" long-dd-width-flag=\"true\" ng-click=\"setRefId()\" none-selected=\"'common.none'\" common-search-flag=\"true\"></search-and-select>\n</div>\n<div ng-hide=\"showBankLocationDd\" class=\"shipment-route-assignment-section\">\n<input type=\"text\" class=\"text-center form-control\" id=\"showBankLocationDdInp\" ng-disabled=\"model.location\" ng-model=\"model.refId\" required capitalize/>\n</div>\n<span ng-show=\"model.location === null\" class=\"glyphicon glyphicon-remove form-control-feedback\"></span>\n</div>\n</td>\n<td class=\"shipment-batch-col-width-100\">\n<div ng-class=\"((model.checkScanLimit && (model.trackingId.length > model.scanLimit)) || (duplicateTrackingIds.includes(model.trackingId))) ? 'has-error _has-feedback' : ''\" uib-tooltip=\"{{'common.scan_error' | translate}}\" tooltip-enable=\"(model.checkScanLimit && (model.trackingId.length > model.scanLimit))\" tooltip-trigger=\"'mouseenter'\">\n<input type=\"text\" ng-pattern=\"/^[a-z A-Z 0-9]*$/\" onkeypress=\"return event.keyCode != 126 && event.keyCode != 96 && event.keyCode != 33 && event.keyCode != 64 && event.keyCode != 35\r\n                    && event.keyCode != 36 && event.keyCode != 37 && event.keyCode != 94 && event.keyCode != 38 && event.keyCode != 42\r\n                    && event.keyCode != 40 && event.keyCode != 41 && event.keyCode != 95 && event.keyCode != 45 && event.keyCode != 43\r\n                    && event.keyCode != 61 && event.keyCode != 91 && event.keyCode != 93 && event.keyCode != 123 && event.keyCode != 125\r\n                    && event.keyCode != 124 && event.keyCode != 92 && event.keyCode != 58 && event.keyCode != 59 && event.keyCode != 39\r\n                    && event.keyCode != 34 && event.keyCode != 47 && event.keyCode != 60 && event.keyCode != 62 && event.keyCode != 63\r\n                    && event.keyCode != 44 && event.keyCode != 46\" class=\"text-center form-control\" ng-model=\"model.trackingId\" ng-required=\"!coinOnlyBatch\" ng-readonly=\"coinOnlyBatch\" capitalize/>\n<span ng-show=\"(model.checkScanLimit && (model.trackingId.length > model.scanLimit))\" class=\"glyphicon glyphicon-remove form-control-feedback\"></span>\n</div>\n</td>\n<td class=\"shipment-batch-col-width-70\">\n<input type=\"text\" class=\"text-center form-control\" ng-model=\"model.total\" ng-currency ng-disabled=\"coinOnlyBatch || !batchMaster || (!model.total && currencyTotal < 0)\" min=\"0\" required=\"\"/>\n</td>\n<td class=\"coin-entry\" ng-repeat=\"key in denominationTypeObj.denomTypes\">\n<input ng-style=\"{'display': amountToggle ? 'none' : ''}\" min=\"0\" type=\"number\" class=\"form-control\" ng-model=\"model[denominationTypeObj.coinTypes[key.group].categoryName]\" ng-model-options=\"{ allowInvalid: true }\" ng-pattern=\"/^[0-9_,]*$/\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-disabled=\"!batchMaster || (!model[denominationTypeObj.coinTypes[key.group].categoryName] && currencyTotal < 0) || model.locationType === 'ATM'\"/>\n<div ng-style=\"{'display': amountToggle ? '' : 'none'}\" ng-class=\"{'has-error': model.amountErrors[denominationTypeObj.coinTypes[key.group].categoryName]}\">\n<input min=\"0\" type=\"text\" ng-currency class=\"form-control\" ng-style=\"{\r\n          'background-color': model.amountErrors[denominationTypeObj.coinTypes[key.group].categoryName] ? '#F9E3E3' : '#DFF5DF',\r\n          'border-color': model.amountErrors[denominationTypeObj.coinTypes[key.group].categoryName] ? '#A94442' : '#BEEBBE'\r\n        }\" ng-model=\"amountModel[denominationTypeObj.coinTypes[key.group].categoryName]\" ng-change=\"onAmountChange(denominationTypeObj.coinTypes[key.group].categoryName, key.group)\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46\" ng-focus=\"onAmountFocus(denominationTypeObj.coinTypes[key.group].categoryName)\" ng-blur=\"onAmountBlur()\" ng-disabled=\"!batchMaster || (!model[denominationTypeObj.coinTypes[key.group].categoryName] && currencyTotal < 0) || model.locationType === 'ATM'\"/>\n</div>\n</td>\n<td class=\"wrap-text shipment-batch-col-width-80\" align=\"center\">\n<span ng-class=\"{'text-danger': currency < 0}\">{{currency | currency:'$'}}</span>\n</td>\n<td class=\"col-width-100\">\n<select class=\"form-control\" ng-if=\"model.location && model.total >= 0 && model.trackingId && isRoutesSet\" ng-keydown=\"onTab($event,$index)\" ng-model=\"model.routeId\" ng-options=\"routeId for routeId in model.routeIds | shipmentRouteFilter:model\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">(select)</option>\n</select>\n</td>\n<td align=\"center\" class=\"shipment-batch-col-width-20\">\n<button type=\"button\" class=\"btn btn-danger btn-xs\" uib-tooltip=\"{{ 'shipmentBatch.tooltip_del' | translate }}\" ng-click=\"onRemove()\" ng-keydown=\"executeOnTab($event)\" ng-disabled=\"isGenerateTrackingIdLoading\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</td>\n<style>\n.popover {\r\n    z-index: 1010; /* A value higher than 1010 that solves the problem */\r\n}\n</style>\n";
var id1="shipment_record.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2791 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"_col-sm-12\">\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'billableEvents.all_events' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.model.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.billableEventObj.loading\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.billableEventObj.totalRecords > 0 && !$ctrl.model.billableEventObj.loading\">\n<ul class=\"remove-bottom-pad list-group\">\n<li class=\"list-group-item\" ng-repeat=\"event in $ctrl.model.billableEventObj.eventList track by $index\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{$ctrl.translateMessage(event.type)}} | {{event.billingCategory.name}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\"></div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(event)\" uib-tooltip=\"{{ 'common.Edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['delete']\" ng-click=\"$ctrl.delete(event)\" uib-tooltip=\"{{ 'common.Delete' | translate }}\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<div class=\"col-sm-12 remove-left-pad margin-10\">\n<ul class=\"margin-10\" uib-pagination total-items=\"$ctrl.model.billableEventObj.totalRecords\" ng-hide=\"{{($ctrl.model.billableEventObj.totalRecords<=$ctrl.model.pagination.pageLimit)&&($ctrl.model.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 text-align-center alert alert-danger\" ng-if=\"($ctrl.model.billableEventObj.totalRecords === 0 && !$ctrl.model.billableEventObj.loading)\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>";
var id1="billable_events.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2792 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"billable_events.all({page: 1})\"><a>{{'billableEvents.all_events' | translate}}</a></li>\n<li role=\"presentation\" ui-sref-active=\"active\" ng-show=\"$ctrl.hasACL['create']\" ui-sref=\"billable_events.create\">\n<a>{{'billableEvents.create_event' | translate}}</a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="billable_events.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2793 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"billableEvents.new_event\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"event\">{{'common.event' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.entryType\" values=\"$ctrl.model.entryTypeObj.entryTypes\" key=\"Key\" totalrecords=\"$ctrl.model.entryTypeObj.totalRecords\" ng-disabled=\"$ctrl.model.billableEventObj.loading || $ctrl.model.isCreate\" common-search-flag=\"true\" none-selected=\"'checkinSelectionModal.select'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"billing-category\">{{'billableEvents.billing_category' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.billingCategory\" values=\"$ctrl.model.billingCategoryObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.billingCategoryObj.totalRecords\" ng-disabled=\"$ctrl.model.billingCategoryObj.loading || $ctrl.model.isCreate\" onscroll=\"$ctrl.getBillingCategory(searchKey, offset)\" none-selected=\"'checkinSelectionModal.select'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"generalLedgerCode\">{{'common.generalLedgerCode' | translate}} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.generalLedgerCode\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.model.entryType && $ctrl.model.entryType.Value === 'order-create'\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"createdBy\">\n{{'billableEvents.createdBy' | translate}} *\n</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.createdBy\" ng-options=\"type.value as type.label for type in $ctrl.createdByOptions\">\n<option value=\"\">\n({{'common.select' | translate}})\n</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"inventoryType\">\n{{'billableEvents.inventory_type' | translate}} *\n</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.inventoryType\" ng-options=\"type.value as type.label for type in $ctrl.inventoryTypeOptions\">\n<option value=\"\">\n({{'common.select' | translate}})\n</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<textarea cols=\"30\" rows=\"3\" ng-model=\"$ctrl.model.description\" class=\"form-control\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || Form.$invalid || $ctrl.model.isCreate || $ctrl.model.billingCategoryObj.loading\">\n<span ng-if=\"$ctrl.model.isCreate\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || $ctrl.model.isCreate || $ctrl.model.billingCategoryObj.loading\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</div>\n</form>\n</div>";
var id1="billable_events.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2794 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"billableEvents.edit_title\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"event\">{{'common.id' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required disabled=\"disabled\" placeholder=\"\" ng-model=\"$ctrl.rawId\">\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"event\">{{'billableEvents.event' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required disabled=\"disabled\" placeholder=\"\" ng-model=\"$ctrl.model.entryType\">\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"billing-category\">{{'billableEvents.billing_category' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.billingCategory\" values=\"$ctrl.model.billingCategoryObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.billingCategoryObj.totalRecords\" ng-disabled=\"$ctrl.model.billingCategoryObj.loading || $ctrl.model.isCreate\" onscroll=\"$ctrl.getBillingCategory(searchKey, offset)\" none-selected=\"'checkinSelectionModal.select'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"generalLedgerCode\">{{'common.generalLedgerCode' | translate}} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.generalLedgerCode\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.model.isOrderCreate\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"createdBy\">\n{{'billableEvents.createdBy' | translate}} *\n</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.createdBy\" ng-options=\"type.value as type.label for type in $ctrl.createdByOptions\">\n<option value=\"\">\n({{'common.select' | translate}})\n</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"inventoryType\">\n{{'billableEvents.inventory_type' | translate}} *\n</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.inventoryType\" ng-options=\"type.value as type.label for type in $ctrl.inventoryTypeOptions\">\n<option value=\"\">\n({{'common.select' | translate}})\n</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<textarea cols=\"30\" rows=\"3\" ng-model=\"$ctrl.model.description\" class=\"form-control\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"button\" ng-click=\"$ctrl.update(this)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || Form.$invalid || $ctrl.model.isCreate || $ctrl.model.billingCategoryObj.loading\">\n<span ng-if=\"$ctrl.model.isCreate\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || $ctrl.model.isCreate || $ctrl.model.billingCategoryObj.loading\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</div>\n</form>\n</div>";
var id1="billable_events.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2795 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"_col-sm-12\">\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'billingCategory.all_billing_category' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.model.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.billingCategoryObj.loading\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.billingCategoryObj.totalRecords > 0 && !$ctrl.model.billingCategoryObj.loading\">\n<ul class=\"remove-bottom-pad list-group\">\n<li class=\"list-group-item\" ng-repeat=\"category in $ctrl.model.billingCategoryObj.categoryList track by $index\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{category.name}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\"></div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(category)\" uib-tooltip=\"{{ 'common.Edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<div class=\"col-sm-12 remove-left-pad margin-10\">\n<ul class=\"margin-10\" uib-pagination total-items=\"$ctrl.model.billingCategoryObj.totalRecords\" ng-hide=\"{{($ctrl.model.billingCategoryObj.totalRecords<=$ctrl.model.pagination.pageLimit)&&($ctrl.model.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 text-align-center alert alert-danger\" ng-if=\"($ctrl.model.billingCategoryObj.totalRecords === 0 && !$ctrl.model.billingCategoryObj.loading)\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>";
var id1="billing_category.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2796 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"billing_category.all\" ng-click=\"$ctrl.goToAll()\"><a>{{'billingCategory.all_billing_category' | translate}}</a></li>\n<li role=\"presentation\" ui-sref-active=\"active\" ng-show=\"$ctrl.hasACL['create']\" ui-sref=\"billing_category.create\">\n<a>{{'billingCategory.create_billing_category' | translate}}</a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="billing_category.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2797 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"billingCategory.new_billing_category\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"name\">{{'common.name' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.name\">\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"generalLedgerCode\">{{'common.generalLedgerCode' | translate}} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.generalLedgerCode\">\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"margin-top-02 form-group\">\n<label for=\"status\">{{'location.status' | translate }} </label>\n<br/>\n<input id=\"status\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<textarea cols=\"30\" rows=\"3\" ng-model=\"$ctrl.model.description\" class=\"form-control\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || Form.$invalid || $ctrl.model.isCreate\">\n<span ng-if=\"$ctrl.model.isCreate\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || $ctrl.model.isCreate\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</div>\n</form>\n</div>";
var id1="billing_category.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2798 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"billingCategory.edit_title\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3\">\n<label for=\"categoryId\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"categoryId\" placeholder=\"\" disabled=\"disabled\" ng-model=\"$ctrl.model.id\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"name\">{{'common.name' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.name\">\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"generalLedgerCode\">{{'common.generalLedgerCode' | translate}} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.generalLedgerCode\">\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"margin-top-02 form-group\">\n<label for=\"status\">{{'location.status' | translate }} </label>\n<br/>\n<input id=\"status\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<textarea cols=\"30\" rows=\"3\" ng-model=\"$ctrl.model.description\" class=\"form-control\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"button\" ng-click=\"$ctrl.update(this)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || Form.$invalid || $ctrl.model.isCreate\">\n<span ng-if=\"$ctrl.model.isCreate\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-disabled=\"$ctrl.model.entryTypeObj.loading || $ctrl.model.isCreate\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</div>\n</form>\n</div>";
var id1="billing_category.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2799 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'contract.all_contracts' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n<button type=\"button\" class=\"btn btn-warning btn-sm navbar-btn\" ng-click=\"$ctrl.showUncoveredOnCallLocations()\" ng-disabled=\"$ctrl.uncoveredOnCallLocationCountLoading\" style=\"font-weight: bold !important;\">\n{{'contract.locations_not_covered' | translate}} |\n<span ng-if=\"$ctrl.uncoveredOnCallLocationCountLoading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</span>\n<span ng-if=\"!$ctrl.uncoveredOnCallLocationCountLoading\" class=\"badge\">\n{{$ctrl.uncoveredOnCallLocationCount || 0}}\n</span>\n</button>\n</div>\n<div class=\"alert alert-danger\" ng-if=\"$ctrl.uncoveredOnCallLocationCountError\">\n{{$ctrl.uncoveredOnCallLocationCountError}}\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\">\n</div>\n<div class=\"form-group\">\n<select class=\"form-control\" ng-model=\"$ctrl._status\" ng-options=\"status.value as status.label for status in  $ctrl.contractStatus\" ng-change=\"$ctrl.refresh()\"></select>\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'contract.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.contracts && $ctrl.contracts.length\">\n<ul class=\"customer-cu-history list-group\">\n<li class=\"list-group-item\" ng-repeat=\"contract in $ctrl.contracts track by contract.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"padding-left-10\">\n<button id=\"expand-btn-{{contract.id}}\" class=\"btn btn-xs btn-secondary\" ng-click=\"contract.expanded = !contract.expanded; $ctrl.toggleExpand(contract); $ctrl.resetSearchText(contract);\n\t\t\t\t\t\t\t\t\t\t $ctrl.setCustomerHistoryPage(contract.expanded, contract.id); $ctrl.getCustomerHistory(contract, $event)\" expand>\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-triangle-right': !contract.expanded, 'glyphicon-triangle-bottom': contract.expanded}\"></span>\n</button>\n</div>\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{contract.contractName}} | {{'branch_mgmt.bagout_lastUpdated' | translate}} ({{contract.updatedAt | date: 'MM-dd-yyyy | hh:mm a'}})\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"history-badge-section\">\n<div class=\"_remove-right-pad _icon-padding-05 btn-group\">\n<span class=\"badge badge-light customer-cu-history-badge cursor-pointer\" uib-tooltip=\"{{'contract.total_contract_rules' | translate}}\" tooltip-placement=\"top-right\" ng-click=\"$ctrl.customerHistoryFn(contract, $event)\">\n{{contract.totalContractRules}}</span>\n</div>\n<div class=\"_remove-right-pad _icon-padding-05 btn-group\">\n<span class=\"badge badge-light customer-cu-history-badge cursor-pointer\" uib-tooltip=\"{{'customer.customer_using' | translate}}\" tooltip-placement=\"top-right\" ng-click=\"$ctrl.customerHistoryFn(contract, $event)\">\n{{contract.totalCustomerUsing}}</span>\n</div>\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(contract)\" uib-tooltip=\"{{ 'contract.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"contract.expand && $ctrl.currentStats[contract.id] === $ctrl.contractHistoryStats.customers\" ng-class=\"{'table-margin-bottom-09' : contract.expanded && !$ctrl.customerHistoryObj.history[contract.id].process && !$ctrl.customerHistoryObj.history[contract.id].details.results.length}\">\n<hr class=\"remove-bottom-margin margin-10\"/>\n<div class=\"customer-cu-history-bg remove-left-pad remove-right-pad col-sm-12 _margin-10\" ng-if=\"!$ctrl.customerHistoryObj.history[contract.id].process\">\n<div class=\"margin-top-02 col-sm-6\">\n<div class=\"icon-padding-05 btn-group\">\n<span class=\"text-color-white\"><b>{{'customer.customer_using' | translate}}</b></span>\n<span class=\"badge badge-light customer-cu-history-badge\" uib-tooltip=\"{{'location.pending_changes' | translate}}\">\n{{$ctrl.customerHistoryObj.history[contract.id].details.totalRecords}}\n</span>\n</div>\n</div>\n<div class=\"margin-top-04 col-sm-3 pull-right\">\n<div class=\"_form-group\">\n<input type=\"text\" class=\"form-control txt-input-height-25\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.customerHistoryObj.extraDetails[contract.id].searchText\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.searchCustomerHistory(contract, $event)\">\n</div>\n</div>\n</div>\n<div class=\"_table-responsive remove-right-pad remove-left-pad col-sm-12 margin-top-02\">\n<table class=\"table-pad-3 table table-condensed table-bordered _table-margin-bottom-0\" ng-class=\"{'table-margin-bottom-09' : contract.expanded}\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.customerHistoryObj.history[contract.id].process\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</div>\n<div class=\"location-history-alert-section\" ng-if=\"!$ctrl.customerHistoryObj.history[contract.id].process && !$ctrl.customerHistoryObj.history[contract.id].details.results.length\">\n<div class=\"col-sm-12 alert alert-danger text-center remove-bottom-margin\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<tbody ng-if=\"!$ctrl.customerHistoryObj.history[contract.id].process && $ctrl.customerHistoryObj.history[contract.id].details.results.length\">\n<tr class=\"header-row\">\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('customerName', contract, $event)\">\n{{'location.customer' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'customerName'}\"></span>\n</th>\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('totalLocations', contract, $event)\">\n{{'location.menu.title' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'totalLocations'}\"></span>\n</th>\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('billingCategory', contract, $event)\">\n{{'billableEvents.billing_category' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingCategory'}\"></span>\n</th>\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('dateAssociated', contract, $event)\">\n{{'customer.date_associated' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'dateAssociated'}\"></span>\n</th>\n</tr>\n<tr ng-repeat=\"history in $ctrl.customerHistoryObj.history[contract.id].details.results track by $index\">\n<td class=\"text-center\">\n{{history.customerName}} |\n<a href=\"#\" ng-click=\"$ctrl.goToCustomerTab(history)\">\n<span class=\"cursor-pointer\" tooltip-placement=\"top-left\">{{history.customerId}}</span>\n</a>\n</td>\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToLocationTab(history)\" ng-if=\"history.totalLocations > 0\">\n<span class=\"cursor-pointer\" tooltip-placement=\"top-left\">{{history.totalLocations}}</span>\n</a>\n<span ng-if=\"history.totalLocations == 0\">\n{{history.totalLocations}}\n</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"history.billingCategory.length\" ng-repeat=\"billingCategory in history.billingCategory track by $index\">\n<span>{{billingCategory}}<span ng-if=\"$index + 1 !== history.billingCategory.length\"> | </span></span>\n</span>\n<span ng-if=\"!history.billingCategory.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">{{history.dateAssociated | date: 'MM-dd-yyyy'}}</td>\n</tr>\n</tbody>\n<tfoot ng-if=\"!$ctrl.customerHistoryObj.history[contract.id].process && $ctrl.customerHistoryObj.history[contract.id].details.results.length\n\t\t\t\t\t\t\t\t\t\t\t&& $ctrl.customerHistoryObj.history[contract.id].details.totalRecords>$ctrl.customerHistoryObj.history[contract.id].details.pageLimit\">\n<tr>\n<td class=\"location-history-pagination-section\" colspan=\"5\">\n<ul ng-model=\"$ctrl.customerHistoryObj.extraDetails[contract.id].page\" uib-pagination total-items=\"$ctrl.customerHistoryObj.history[contract.id].details.totalRecords\" ng-hide=\"{{($ctrl.customerHistoryObj.history[contract.id].details.totalRecords<=$ctrl.customerHistoryObj.history[contract.id].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.getCustomerHistory(contract, $event)\" max-size=\"10\">\n</ul>\n</td>\n</tr>\n</tfoot>\n</table>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" force-ellipses=\"true\" max-size=\"$ctrl.maxPages\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\"></ul>\n</div>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.contracts || !$ctrl.contracts.length) && !$ctrl.loading\">\n<span>{{'contract.noContracts' | translate}}</span>\n<ul uib-pagination total-items=\"$ctrl.total\" force-ellipses=\"true\" max-size=\"$ctrl.maxPages\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\"></ul>\n</div>\n</div>";
var id1="contract.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2800 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row\">\n<div class=\"col-sm-2\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"contract.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"contract.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"contract.create\">\n<a translate=\"contract.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="contract.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2801 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<h4 translate=\"contract.menu.create\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-class=\"{'customer-contract-margin-bottom-50': $ctrl.billingRulesOptions.length > 0}\">\n<div class=\"form-validate\" autocomplete=\"off\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"contact-name\">{{'contract.contractName' | translate }} *</label>\n<input type=\"text\" required ng-model=\"$ctrl.model.contractName\" id=\"contact\" class=\"form-control\" ng-pattern=\"/^[a-zA-Z0-9 -_]*$/\">\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"contact\">{{'contract.contractStatus' | translate }}</label><br/>\n<input class=\"margin-top-02\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"contact\">{{'customer.billToCustomer' | translate }}</label><br/>\n<input class=\"margin-top-02\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.useCustomerOnBillingRules\" type=\"checkbox\" ng-change=\"$ctrl.resetBillToCustomers()\"/>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<textarea cols=\"30\" rows=\"3\" ng-model=\"$ctrl.model.description\" class=\"form-control\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"billing-increment\">{{'contract.billing_increment' | translate}}</label>\n<div class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"billingIncrement in $ctrl.billingIncrementList\" ng-click=\"$ctrl.selectBillingIncrement(billingIncrement)\" ng-class=\"{'btn-primary': $ctrl.model.selectedBillingDuration === billingIncrement.value,\n\t\t\t\t\t\t\t\t   'btn-default': $ctrl.model.selectedBillingDuration !== billingIncrement.value,\n\t\t\t\t\t\t\t\t   'disabled': billingIncrement.value !== 'MONTHLY' && $ctrl.model.disableBillingIncrement}\">\n{{billingIncrement.label}}\n</a>\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group col-sm-6\">\n<label for=\"start-date\">{{'contract.contract_start' | translate }}</label>\n<span ng-if=\"($ctrl.requiredStartDate && !$ctrl.model.contractStartDate) || (!$ctrl.model.contractStartDate)\"><label>*</label></span>\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"$ctrl.model.contractStartDate\" date-format=\"dd-MMM-yyyy\" ng-click=\"$ctrl.isDisabledDate(date, mode); $ctrl.contractDatesChanged()\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': ($ctrl.requiredStartDate && !$ctrl.model.contractStartDate) || (!$ctrl.model.contractStartDate)}\" date-options=\"$ctrl.startMaxDate\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"end-date\">{{'contract.contract_end' | translate }}</label>\n<button type=\"button\" class=\"margin-left-10 btn btn-xs btn-success\" ng-click=\"$ctrl.clear();$ctrl.contractDatesChanged();\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.clear' | translate }}</button>\n<datetimepicker class=\"datetimepicker-input\" id=\"end-date\" ng-model=\"$ctrl.model.contractEndDate\" date-format=\"dd-MMM-yyyy\" date-options=\"$ctrl.startMinDate\" ng-click=\"$ctrl.contractDatesChanged()\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label for=\"contract-type\">{{'contractType.menu.title' | translate }}</label>\n<search-and-select class=\"contract-type-dd\" ng-model=\"$ctrl.model.contractTypeId\" values=\"$ctrl.model.contractTypeObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.contractTypeObj.totalRecords\" onscroll=\"$ctrl.getContractTypeList(searchKey, offset);\" ng-disabled=\"$ctrl.model.contractTypeObj.loading\" none-selected=\"'common.select'\">\n</search-and-select>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"bailment_interest\">{{'contract.bailment_interest' | translate }}</label>\n<input type=\"text\" ng-model=\"$ctrl.model.bailmentInterest\" id=\"bailmentInterest\" class=\"form-control\" ng-blur=\"$ctrl.ngPercentage()\" ng-focus=\"$ctrl.removePercentageSign($ctrl.model.bailmentInterest)\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div ng-if=\"$ctrl.showBillingWarning === true\">\n<span class=\"col-sm-12 alert-info alert text-center\" style=\"margin-bottom: 10px;\">\n<span class=\"glyphicon glyphicon-info-sign\"></span>\nOne or more billing rules have a start/end date that overlaps with or extends beyond the contract's start / end date. To save the contract, please adjust the contract rule's start / end date accordingly.\n</span>\n</div>\n<h4 class=\"margin-top-5\">Billing Rules</h4>\n<div class=\"margin-bottom-10\">\n<ul dnd-list=\"$ctrl.billingRulesOptions\" class=\"list-group location-sequence\" dnd-drop=\"$ctrl.onDrop(event, index, item, external, type)\">\n<li class=\"billing-rules-border remove-pad col-sm-12 margin-top-05\" ng-repeat=\"contractRules in $ctrl.billingRulesOptions track by $index\" dnd-effect-allowed=\"move\" dnd-draggable=\"contractRules\">\n<div class=\"_form-group w-100\" ng-if=\"!contractRules.isEdit\">\n<div class=\"margin-10 col-sm-10\">\n<label for=\"status\" class=\"font-size-17\">{{contractRules.name}} | {{contractRules.billingCategoryObj.billingCategory.label}}</label>\n</div>\n<div class=\"col-sm-2 remove-right-pad\">\n<h4 class=\"billing-rules-status billing-rules-status-label\">\n<span class=\"label label-success\" ng-if=\"contractRules.status\">{{'common.active' | translate}}</span>\n<span class=\"label label-danger\" ng-if=\"!contractRules.status\">{{'common.suspended' | translate}}</span>\n</h4>\n</div>\n</div>\n<div class=\"_form-group margin-top-05 w-100\" ng-if=\"!contractRules.isEdit\">\n<div class=\"font-size-15 margin-bottom-10 col-sm-11\">\n<span>{{contractRules.billingEventObj.billingEvent.label}} | </span>\n<span ng-if=\"contractRules.locationTypeObj.locationType\">{{contractRules.locationTypeObj.locationType.label}} | </span>\n<span ng-if=\"contractRules.locationTypeObj.serviceType\">{{contractRules.serviceTypeObj.serviceType.label}} | </span>\n<span ng-if=\"contractRules.locationTypeObj.scheduleType\">{{contractRules.scheduleTypeObj.scheduleType.label}} | </span>\n<span ng-if=\"contractRules.locationTypeObj.orderType\">{{contractRules.orderTypeObj.orderType.label}} | </span>\n<span>{{contractRules.billingTypeObj.billingType.label}}\n<span class=\"text-success\" ng-if=\"contractRules.locationDistanceId\">\n= {{contractRules.locationDistance.label}} ({{contractRules.locationDistance.mileRange}})\n</span>\n</span>\n<span class=\"text-success\" ng-if=\"contractRules.dollarRate !== null\"> |\n<span>{{'contract.dollar_rate' | translate}} = </span>{{contractRules.dollarRate | currency}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.percentageRate !== null\"> |\n<span>{{'contract.percentage_rate' | translate}} =\n</span>{{$ctrl.percentageMask(contractRules.percentageRate, 2)}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.dollarRateAbove !== null\"> |\n<span>{{'contract.rate_above' | translate}} = </span>{{contractRules.dollarRateAbove | currency}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.dollarRateBelow !== null\"> |\n<span>{{'contract.rate_below' | translate}} = </span>{{contractRules.dollarRateBelow | currency}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.percentageRateAbove !== null\"> |\n<span>{{'contract.rate_above' | translate}} =\n</span>{{$ctrl.percentageMask(contractRules.percentageRateAbove, 2)}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.percentageRateBelow !== null\"> |\n<span>{{'contract.rate_below' | translate}} =\n</span>{{$ctrl.percentageMask(contractRules.percentageRateBelow, 2)}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.itemThreshold !== null\"> |\n<span>{{'contract.threshold' | translate}} =\n</span>{{contractRules.itemThreshold}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.itemIncrement !== null\"> |\n<span>{{'contract.increment' | translate}} =\n</span>{{contractRules.itemIncrement}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.valueThreshold !== null\"> |\n<span>{{'contract.threshold' | translate}} = </span>{{contractRules.valueThreshold | currency}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.valueIncrement !== null\"> |\n<span>{{'contract.increment' | translate}} = </span>{{contractRules.valueIncrement | currency}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.timeThreshold\"> |\n<span>{{'contract.threshold' | translate}} =\n</span>{{$ctrl.getTime(contractRules.timeThreshold, contractRules.billingTypeObj.billingType['value'])}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.timeIncrement\"> |\n<span>{{'contract.increment' | translate}} =\n</span>{{$ctrl.getTime(contractRules.timeIncrement)}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.generalLedgerCode !== null\"> |\n<span>{{'common.generalLedgerCode' | translate}} =\n</span>{{contractRules.generalLedgerCode}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.applyWrapFee\"> |\n<span>{{'billableEvents.wrap_fee' | translate}} = </span>{{contractRules.wrapFee | currency}}\n</span>\n</div>\n<div class=\"text-right col-sm-1 margin-bottom-10 remove-pad\">\n<div class=\"pad-right-02 btn-group\">\n<button type=\"button\" ng-click=\"$ctrl.editBillingRules(contractRules)\" class=\"btn btn-success btn-xs\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"$ctrl.removeBillingRules($index)\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n<button ng-if=\"!contractRules.isEdit\" type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"$ctrl.duplicateBillingRule(contractRules)\">\n<span class=\"glyphicon glyphicon-duplicate\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<form name=\"billingRulesForm\" novalidate class=\"form-validate\" autocomplete=\"off\" ng-if=\"contractRules.isEdit\">\n<div class=\"remove-pad items-err-lbl-margin-top col-sm-12\">\n<div class=\"remove-pad col-sm-10\">\n<div class=\"_form-group col-sm-4 atm-codes-date-picker-section\">\n<label for=\"start-date\">Rule Active Date</label>\n<label>*</label>\n<datetimepicker class=\"datetimepicker-input atm-codes-date-picker-section\" id=\"start-date\" ng-model=\"contractRules.startDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-click=\"$ctrl.contractDatesChanged(contractRules)\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': !contractRules.startDate}\" date-options=\"$ctrl.ruleStartDateOptions\" ng-keydown=\"$event.preventDefault();\">\n</datetimepicker>\n</div>\n<div class=\"_form-group col-sm-4 atm-codes-date-picker-section\">\n<label for=\"start-date\">Rule End Date</label>\n<datetimepicker class=\"datetimepicker-input atm-codes-date-picker-section\" id=\"cont-end-date\" ng-model=\"contractRules.endDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-click=\"$ctrl.contractDatesChanged()\" date-options=\"{minDate: contractRules.startDate || $ctrl.model.contractStartDate,maxDate: $ctrl.ruleStartDateOptions['maxDate']}\" ng-keydown=\"$event.preventDefault();\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"_form-group pull-right _col-sm-3 icon-padding-05 margin-top-20\">\n<div class=\"margin-top-05 btn-group service-tab\" data-toggle=\"buttons\">\n<button id=\"active-btn-{{$index}}\" type=\"button\" class=\"btn btn-default btn-sm ignore-validation-css\" ng-model=\"contractRules.status\" uib-btn-radio=\"$ctrl.contractRulesStatus.active\" ng-click=\"$ctrl.updateContractRuleStatus($index, true)\" ng-class=\"{'btn-success': contractRules.status === $ctrl.contractRulesStatus.active, \n\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': contractRules.status === $ctrl.contractRulesStatus.suspended}\">\n{{'common.active' | translate}}\n</button>\n<button id=\"inactive-btn-{{$index}}\" type=\"button\" class=\"btn btn-sm btn-default ignore-validation-css\" ng-model=\"contractRules.status\" uib-btn-radio=\"$ctrl.contractRulesStatus.suspended\" ng-click=\"$ctrl.updateContractRuleStatus($index, false);\" ng-class=\"{'btn-danger': contractRules.status === $ctrl.contractRulesStatus.suspended, \n\t\t\t\t\t\t\t\t\t\t           'remove-btn-grp-color': contractRules.status === $ctrl.contractRulesStatus.active}\">\n{{'common.suspended' | translate}}\n</button>\n</div>\n</div>\n<div class=\"remove-pad items-err-lbl-margin-top col-sm-12\">\n<div><hr class=\"remove-top-margin margin-bottom-10\"/></div>\n<div class=\"form-group col-sm-3\">\n<label for=\"contact-name\">{{'common.name' | translate }} *</label>\n<input type=\"text\" required ng-model=\"contractRules.name\" id=\"contact\" class=\"form-control\">\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<input type=\"text\" ng-model=\"contractRules.description\" id=\"description\" class=\"form-control\">\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"generalLedgerCode\">{{'common.generalLedgerCode' | translate}} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"contractRules.generalLedgerCode\">\n</div>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'billableEvents.billing_category' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.billingCategoryObj.billingCategory\" ng-change=\"$ctrl.getBillingEventsByCategory(contractRules, $index);\" required ng-options=\"category.label for category in contractRules.billingCategoryObj.billingCategoryOptions track by category.billingCategoryId\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-3\">\n<label>{{'billableEvents.billing_events' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.billingEventObj.billingEvent\" ng-change=\"$ctrl.preOrPostBillCfg(contractRules, $index); $ctrl.serviceTypeOptionChoice(contractRules); $ctrl.locationTypeOptionChoice(contractRules); $ctrl.orderTypeOptionChoice(contractRules); $ctrl.isAllowScheduleType(contractRules, $index); $ctrl.billingTypeOptionChoice(contractRules)\" required ng-options=\"item as item.label for item in contractRules.billingEventObj.billingEventOptions track by item.value\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'location._type' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.locationTypeObj.locationType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-options=\"item as item.label for item in contractRules.locationTypeObj.locationTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'contract.service_type' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.serviceTypeObj.serviceType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index)\" ng-options=\"item as item.label for item in contractRules.serviceTypeObj.serviceTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled || $ctrl.isDisableServiceTypeOptions\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'branch_mgmt.item_orderType' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.orderTypeObj.orderType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index)\" ng-options=\"item as item.label for item in contractRules.orderTypeObj.orderTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled || contractRules.billingEventObj.billingEvent.value === 'stop-completed'\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group _col-sm-3\" ng-class=\"{'col-sm-3': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) === -1 ||\n\t\t\t\t\t\t\t\t\t\t\t               ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcontractRules.billingEventObj.billingEvent.value !== 'coin-delivery', \n\t\t\t\t   \t\t\t\t\t\t\t   'col-sm-2': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcontractRules.billingEventObj.billingEvent.value === 'coin-delivery'}\">\n<label>{{'billableEvents.billing_type' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.billingTypeObj.billingType\" required ng-change=\"!$ctrl.validateBillingRuleFormControl($index); $ctrl.validateBillingType(contractRules, $index)\" ng-options=\"item as item.label for item in contractRules.billingTypeObj.billingTypeOptions track by item.value\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'combined_time'\">\n<label>{{'billableEvents.service_time' | translate}}</label>\n<div class=\"valid-multi-select-value remove-left-pad multi-select vault-close-search-dd\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.serviceTimeTypes\" output-model=\"contractRules.serviceTimeTypeObj.serviceTimeType\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n<div class=\"remove-pad _col-sm-6\" ng-class=\"{'col-sm-6': ['time_threshold', 'value_threshold', 'item_threshold', 'combined_time'].indexOf(contractRules.billingTypeObj.billingType.value) === -1 ||\n\t\t\t\t\t\t\t\t\t \t\t\t\t\t\t['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t contractRules.billingEventObj.billingEvent.value !== 'coin-delivery', \n\t\t\t\t\t\t\t\t\t\t\t\t'billing-type-value-section': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 &&\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcontractRules.billingEventObj.billingEvent.value === 'coin-delivery'}\">\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-6\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'hourly_rate'\">\n<label>{{'contract.rate_first_hour' | translate}}</label>\n<input type=\"text\" ng-currency class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.rateFirstHour\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-6\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'hourly_rate'\">\n<label>{{'contract.rate_fifteen_minutes' | translate}}</label>\n<input type=\"text\" ng-currency class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.rateFifteenMinutes\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div ng-class=\"{'col-sm-3': ['per_item', 'fixed', 'combined_time'].indexOf(contractRules.billingTypeObj.billingType.value) > -1,\n\t\t\t\t\t\t\t\t\t\t\t\t   'col-sm-6': ['drive_distance'].indexOf(contractRules.billingTypeObj.billingType.value) > -1}\" ng-if=\"['per_item', 'drive_distance', 'fixed', 'combined_time'].indexOf(contractRules.billingTypeObj.billingType.value) > -1\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} ($) </label>\n<input type=\"text\" ng-currency ng-required=\"['per_item', 'fixed'].indexOf(contractRules.billingTypeObj.billingType.value) > -1\" class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.dollarRate\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"form-group col-sm-6\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'drive_distance'\">\n<label>{{'billableEvents.location_distance' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.locationDistanceId\" required ng-change=\"$ctrl.updateLocationDistance(contractRules, contractRules.locationDistanceId, $index)\" ng-options=\"obj.id as (obj.label + ' | ' + '(' + obj.minRange + ' - ' + obj.maxRange + ')') for obj in $ctrl.model.locationDistanceOptions\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"['percentage_fee', 'part_markup'].indexOf(contractRules.billingTypeObj.billingType.value) > -1\">\n<label ng-if=\"contractRules.billingTypeObj.billingType.value === 'percentage_fee'\">{{'branch_mgmt.billing_approval.rate' | translate}} (%)</label>\n<label ng-if=\"contractRules.billingTypeObj.billingType.value === 'part_markup'\">{{'branch_mgmt.billing_approval.markup' | translate}} (%) *</label>\n<input type=\"text\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.percentageRate\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='item_threshold'\">\n<label>{{'contract.threshold' | translate}} *</label>\n<input type=\"number\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.itemThreshold\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='item_threshold'\">\n<label>{{'contract.increment' | translate}} *</label>\n<input type=\"number\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.itemIncrement\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='value_threshold' || contractRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.threshold' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.valueThreshold\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='value_threshold' || contractRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.increment' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.valueIncrement\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='time_threshold'\">\n<label>{{'contract.threshold' | translate}}</label>\n<time-picker ng-model=\"contractRules.timeThreshold\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" required show-seconds=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='time_threshold'\">\n<label>{{'contract.increment' | translate}}</label>\n<time-picker ng-model=\"contractRules.timeIncrement\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" required show-seconds=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"(contractRules.billingTypeObj.billingType.value === 'time_threshold' || contractRules.billingTypeObj.billingType.value === 'value_threshold'\n\t\t\t\t\t\t\t\t\t\t || contractRules.billingTypeObj.billingType.value === 'item_threshold')\">\n<label>{{'contract.rate_above' | translate}}($) </label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.dollarRateAbove\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.rate_above' | translate}}(%)</label>\n<input type=\"text\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.percentageRateAbove\">\n</div>\n<div class=\"col-sm-4 enable-hour-input\" ng-if=\"['service_ticket_overage_time_charge'].indexOf(contractRules.billingTypeObj.billingType.value) > -1\">\n<label>Base Time</label>\n<time-picker ng-model=\"contractRules.timeThreshold\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" required show-seconds=\"true\" show-full-time=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n<div class=\"col-sm-4\" ng-if=\"['service_ticket_overage_time_charge'].indexOf(contractRules.billingTypeObj.billingType.value) > -1\">\n<label>Base Rate ($) </label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.dollarRate\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"col-sm-4\" ng-if=\"['service_ticket_overage_time_charge'].indexOf(contractRules.billingTypeObj.billingType.value) > -1\">\n<label>Overage Rate ($) </label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.overageRate\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"col-sm-3 remove-pad\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'fixed'\">\n<label>{{'contract.billing_time' | translate}}</label>\n<br/>\n<div class=\"btn-group z-index0\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"contractRules.billingTime\" uib-btn-radio=\"$ctrl.stats.pre\" ng-click=\"$ctrl.tabSelection('pre')\" ng-disabled=\"(contractRules.billingEventObj.billingEvent.value === 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed') || \n\t\t\t\t\t\t\t\t\t\t\t\t(contractRules.billingEventObj.billingEvent.value !== 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed')\" ng-class=\"{'btn-success': contractRules.billingTime === $ctrl.stats.pre, \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': contractRules.billingTime === $ctrl.stats.post}\">\n{{'common.pre' | translate}}\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"contractRules.billingTime\" uib-btn-radio=\"$ctrl.stats.post\" ng-disabled=\"(contractRules.billingEventObj.billingEvent.value === 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed') || \n\t\t\t\t\t\t\t\t\t\t\t\t(contractRules.billingEventObj.billingEvent.value !== 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed')\" ng-click=\"$ctrl.tabSelection('post');\" ng-class=\"{'btn-success': contractRules.billingTime === $ctrl.stats.post, \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': contractRules.billingTime === $ctrl.stats.pre}\">\n{{'common.post' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-6\" ng-if=\"contractRules.billingEventObj.billingEvent.value === 'pre-bill'\">\n<label>{{'billableEvents.pre_billing_events' | translate}}</label>\n<div class=\"valid-multi-select-value remove-left-pad multi-select customer-contract-location-multi-select-dd\" isteven-multi-select max-labels=\"1\" input-model=\"contractRules.billingEventObj.preBillingEventOptions\" output-model=\"contractRules.billingEventObj.preBillingEvents\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n<div class=\"col-sm-6\" ng-if=\"contractRules.billingEventObj.billingEvent.value === 'post-bill'\">\n<label>{{'billableEvents.post_billing_events' | translate}}</label>\n<div class=\"valid-multi-select-value remove-left-pad multi-select customer-contract-location-multi-select-dd\" isteven-multi-select max-labels=\"1\" input-model=\"contractRules.billingEventObj.postBillingEventOptions\" output-model=\"contractRules.billingEventObj.postBillingEvents\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n<div class=\"_form-group col-sm-3 remove-right-pad\" ng-if=\"contractRules.billingTypeObj.billingType && \n\t\t\t\t\t\t\t\t\t\t \t\t['combined_time', 'drive_distance', 'hourly_rate', 'part_markup'].indexOf(contractRules.billingTypeObj.billingType.value) === -1 &&\n\t\t\t\t\t\t\t\t\t\t\t\tcontractRules.billingEventObj.billingEvent.value === 'coin-delivery'\">\n<label>{{'billableEvents.apply_wrap_fee' | translate}}</label>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"contractRules.applyWrapFee\" type=\"checkbox\"/>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingEventObj.billingEvent.value === 'coin-delivery' && contractRules.applyWrapFee\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.wrapFee\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.model.useCustomerOnBillingRules\">\n<div><hr class=\"remove-bottom-margin\"/></div>\n<div class=\"col-sm-6 margin-10\">\n<div class=\"_form-group\">\n<label for=\"bill-to-customer\">{{'location.customer' | translate }} * </label>\n<search-and-select class=\"contract-customer-dd\" ng-model=\"contractRules.billToCustomerId\" values=\"$ctrl.model.customerObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.customerObj.totalRecords\" on-click=\"$ctrl.loadData()\" onscroll=\"$ctrl.getCustomerList(searchKey, offset);\" ng-disabled=\"$ctrl.model.customerObj.loading\" none-selected=\"'common.none'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-6 margin-10\">\n<label for=\"\">{{ 'contract.location_applicable' | translate }}\n<button class=\"btn btn-success btn-xs\" type=\"button\" ng-click=\"$ctrl.bulkImportLocationModal(contractRules, $index)\">\nImport\n</button>\n</label>\n<div>\n<paginated-search-and-select page-limit=\"$ctrl.contractLocationListObj.pagination.pageLimit\" ng-model=\"contractRules.contractRulesLocations\" key=\"key\" total-count=\"contractRules.contractLocationsDistance.length\" display-label=\"'value'\" options=\"contractRules.locationOptions\" search=\"true\" onscroll=\"$ctrl.getContractLocationList(searchKey, contractRules.locationDistance.id,offset, $index, selectAllFlag)\" none-selected=\"\" selected-prefix=\"''\" is-loading=\"ddLoading\" all-label=\"'Select'\" mode=\"'create'\" label-name=\"value\" toggle-count=\"true\" ng-change=\"$ctrl.filterChange(contractRules)\" location-distance-id=\"contractRules.locationDistance\" billing-type=\"contractRules.billingTypeObj.billingType.value === 'drive_distance'\" on-show-all=\"$ctrl.showAllFlag = true;\">\n</paginated-search-and-select>\n</div>\n</div>\n</div>\n<div class=\"margin-10 col-sm-12\">\n<div class=\"margin-bottom-10\">\n<button type=\"button\" ng-click=\"$ctrl.setEditFlag(contractRules); $ctrl.saveBillingRules(contractRules, $event)\" class=\"btn btn-primary\" ng-disabled=\"billingRulesForm.$invalid || !contractRules.startDate || (contractRules.endDate && contractRules.startDate > contractRules.endDate)\">\n{{'common.save' | translate}}\n</button>\n<button ng-if=\"$ctrl.billingRulesOptions.length > 0\" type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeBillingRules($index)\">\n<span class=\"glyphicon glyphicon-trash\"></span></button>\n\n</div>\n</div>\n</div>\n</div></form>\n</div>\n</li>\n</ul>\n<div class=\"col-sm-12 billing-rules-margin-top-10 remove-pad billing-rules-border\" ng-repeat=\"billingRules in $ctrl.billingRulesOptions track by $index\" ng-if=\"false && billingRules.isEdit\">\n<form name=\"billingRulesForm\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"remove-pad items-err-lbl-margin-top col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"contact-name\">{{'common.name' | translate }} *</label>\n<input type=\"text\" required ng-model=\"billingRules.name\" id=\"contact\" class=\"form-control\">\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<input type=\"text\" ng-model=\"billingRules.description\" id=\"description\" class=\"form-control\">\n</div>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"contact\">{{'common.status' | translate }}</label>\n<br>\n<input class=\"margin-top-02\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"billingRules.status\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-3\">\n<label>{{'billableEvents.billing_events' | translate}}</label>\n<select class=\"form-control\" ng-model=\"billingRules.billingEventObj.billingEvent\" ng-change=\"$ctrl.preOrPostBillCfg(billingRules, $index); $ctrl.serviceTypeOptionChoice(billingRules, $index); $ctrl.locationTypeOptionChoice(billingRules); $ctrl.orderTypeOptionChoice(billingRules); $ctrl.isAllowScheduleType(contractRules, $index); $ctrl.billingTypeOptionChoice(contractRules)\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-options=\"item as item.label for item in billingRules.billingEventObj.billingEventOptions track by item.value\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'location._type' | translate}}</label>\n<select class=\"form-control\" ng-model=\"billingRules.locationTypeObj.locationType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-options=\"item as item.label for item in billingRules.locationTypeObj.locationTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'contract.service_type' | translate}}</label>\n<select class=\"form-control\" ng-model=\"billingRules.serviceTypeObj.serviceType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index)\" ng-options=\"item as item.label for item in billingRules.serviceTypeObj.serviceTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'branch_mgmt.item_orderType' | translate}}</label>\n<select class=\"form-control\" ng-model=\"billingRules.orderTypeObj.orderType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index)\" ng-options=\"item as item.label for item in billingRules.orderTypeObj.orderTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group _col-sm-3\" ng-class=\"{'col-sm-3': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) === -1 ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t contractRules.billingEventObj.billingEvent.value !== 'coin-delivery', \n\t\t\t\t\t\t\t\t\t   \t\t'col-sm-2': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t contractRules.billingEventObj.billingEvent.value === 'coin-delivery'}\">\n<label>{{'billableEvents.billing_type' | translate}}</label>\n<select class=\"form-control\" ng-model=\"billingRules.billingTypeObj.billingType\" required ng-change=\"!$ctrl.validateBillingRuleFormControl($index); $ctrl.validateBillingType(billingRules, $index)\" ng-options=\"item as item.label for item in billingRules.billingTypeObj.billingTypeOptions track by item.value\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'combined_time'\">\n<label>{{'billableEvents.service_time' | translate}}</label>\n<div class=\"valid-multi-select-value remove-left-pad multi-select vault-close-search-dd\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.serviceTimeTypes\" output-model=\"contractRules.serviceTimeTypeObj.serviceTimeType\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n<div class=\"remove-pad _col-sm-6\" ng-class=\"{'col-sm-6': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) === -1 ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t contractRules.billingEventObj.billingEvent.value !== 'coin-delivery', \n\t\t\t   \t\t\t\t\t\t\t\t'billing-type-value-section': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 &&\n\t\t\t\t\t\t\t\t\t\t\t   \t\t\t contractRules.billingEventObj.billingEvent.value === 'coin-delivery'}\">\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value === 'fixed'\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.dollarRate\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section\" ng-class=\"{'col-sm-3': ['per_item', 'hourly_rate', 'combined_time'].indexOf(billingRules.billingTypeObj.billingType.value) > -1,\n\t\t\t\t\t\t\t\t\t\t\t'col-sm-6': ['drive_distance'].indexOf(billingRules.billingTypeObj.billingType.value) > -1}\" ng-if=\"['per_item', 'hourly_rate', 'drive_distance', 'combined_time'].indexOf(billingRules.billingTypeObj.billingType.value) > -1\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} ($)</label>\n<input type=\"text\" ng-currency ng-required=\"['per_item', 'hourly_rate'].indexOf(billingRules.billingTypeObj.billingType.value) > -1\" class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.dollarRate\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"form-group col-sm-6\" ng-if=\"billingRules.billingTypeObj.billingType.value === 'drive_distance'\">\n<label>{{'billableEvents.location_distance' | translate}}</label>\n<select class=\"form-control\" ng-model=\"contractRules.locationDistanceId\" required ng-change=\"$ctrl.updateLocationDistance(contractRules, contractRules.locationDistanceId, $index)\" ng-options=\"obj.id as (obj.label + ' | ' + '(' + obj.minRange + ' - ' + obj.maxRange + ')') for obj in $ctrl.model.locationDistanceOptions\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value === 'percentage_fee'\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} (%)</label>\n<input type=\"text\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.percentageRate\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='item_threshold'\">\n<label>{{'contract.threshold' | translate}}</label>\n<input type=\"number\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.itemThreshold\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='item_threshold'\">\n<label>{{'contract.increment' | translate}}</label>\n<input type=\"number\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.itemIncrement\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='value_threshold' || billingRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.threshold' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.valueThreshold\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='value_threshold' || billingRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.increment' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.valueIncrement\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='time_threshold'\">\n<label>{{'contract.threshold' | translate}}</label>\n<time-picker ng-model=\"billingRules.timeThreshold\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" required show-seconds=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='time_threshold'\">\n<label>{{'contract.increment' | translate}}</label>\n<time-picker ng-model=\"billingRules.timeIncrement\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" required show-seconds=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"(billingRules.billingTypeObj.billingType.value === 'time_threshold' || billingRules.billingTypeObj.billingType.value === 'value_threshold'\n\t\t\t\t\t\t\t\t\t || billingRules.billingTypeObj.billingType.value === 'item_threshold')\">\n<label>{{'contract.rate_above' | translate}}($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.dollarRateAbove\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.rate_above' | translate}}(%)</label>\n<input type=\"text\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.percentageRateAbove\">\n</div>\n<div class=\"col-sm-3 remove-pad\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'fixed'\">\n<label>{{'contract.billing_time' | translate}}</label>\n<br/>\n<div class=\"btn-group z-index0\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"contractRules.billingTime\" uib-btn-radio=\"$ctrl.stats.pre\" ng-click=\"$ctrl.tabSelection('pre')\" ng-disabled=\"(contractRules.billingEventObj.billingEvent.value === 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed') || \n\t\t\t\t\t\t\t\t\t\t\t(contractRules.billingEventObj.billingEvent.value !== 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed')\" ng-class=\"{'btn-success': contractRules.billingTime === $ctrl.stats.pre, \n\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': contractRules.billingTime === $ctrl.stats.post}\">\n{{'common.pre' | translate}}\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"contractRules.billingTime\" uib-btn-radio=\"$ctrl.stats.post\" ng-disabled=\"(contractRules.billingEventObj.billingEvent.value === 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed') || \n\t\t\t\t\t\t\t\t\t\t\t(contractRules.billingEventObj.billingEvent.value !== 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed')\" ng-click=\"$ctrl.tabSelection('post');\" ng-class=\"{'btn-success': contractRules.billingTime === $ctrl.stats.post, \n\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': contractRules.billingTime === $ctrl.stats.pre}\">\n{{'common.post' | translate}}\n</button>\n</div>\n</div>\n<div class=\"_form-group col-sm-3\">\n<label>{{'billableEvents.apply_wrap_fee' | translate}}</label>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"billingRules.applyWrapFee\" type=\"checkbox\"/>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.applyWrapFee\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.wrapFee\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n</div>\n<div class=\"margin-10 col-sm-12\">\n<div class=\"margin-bottom-10\">\n<button type=\"button\" ng-click=\"$ctrl.setEditFlag(billingRules); $ctrl.saveBillingRules(billingRules, $event)\" class=\"btn btn-primary\" ng-disabled=\"billingRulesForm.$invalid\">\n{{'common.save' | translate}}\n</button>\n<button ng-if=\"$ctrl.billingRulesOptions.length > 0\" type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeBillingRules($index)\">\n<span class=\"glyphicon glyphicon-trash\"></span></button>\n\n</div>\n</div>\n</div>\n</form>\n</div>\n<div class=\"row col-sm-6\" ng-class=\"{'margin-10': $ctrl.billingRulesOptions.length > 0}\">\n<div class=\"col-sm-3 remove-pad\">\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.addBillingRules($event)\" ng-disabled=\"!$ctrl.validateBillingRuleFormControl($parent.$index)\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'contract.new_rule' | translate}}</button>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.errorMessage\" class=\"col-sm-12 margin-10\">\n<span class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': $ctrl.errorMessage}\" style=\"margin-bottom: 0px;\"> {{$ctrl.errorMessage}}</span>\n</div>\n<div ng-if=\"($ctrl.requiredStartDate && !$ctrl.model.contractStartDate) || (!$ctrl.model.contractStartDate)\" class=\"col-sm-12 margin-10\">\n<span class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': ($ctrl.requiredStartDate && !$ctrl.model.contractStartDate) || (!$ctrl.model.contractStartDate)}\" style=\"margin-bottom: 0px;\"> {{$ctrl.startDateErrorMessage}}</span>\n</div>\n<div class=\"margin-10 col-sm-12 margin-bottom-20\">\n<div class=\"remove-pad col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.isInvalidForm() || !$ctrl.validateBillingRuleFormControl() || !$ctrl.isBailmentInterestValid() || $ctrl.showBillingWarning === true\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n</div>\n</div>\n<style>\n.uib-timepicker .hours .ng-valid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t\t/* display: none; */\n\t}\n\n\t.uib-timepicker .hours .ng-invalid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t\t/* display: none; */\n\t}\n\t\n\t.enable-hour-input .uib-timepicker .hours .ng-valid {\n\t\tpointer-events: visibleFill !important;\n\t\tbackground-color: #DFF5DF !important;\n    \tborder-color: #BEEBBE !important;\n\t}\n\n\t.enable-hour-input .uib-timepicker .hours .ng-invalid {\n\t\tpointer-events: visibleFill !important;\n\t\tbackground-color: #F9E3E3 !important;\n\t\tborder-color: #F4C6C6 !important;\n\t}\n\n\t/* .horizontal-padding-10 {\n        padding: 0px 29px;\n    } */\n</style>\n";
var id1="contract.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2802 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"contract.edit_contract\"></h4>\n<hr/>\n</div>\n<div class=\"remove-pad col-sm-12 contract-edit-style-section\">\n<div class=\"form-validate\" autocomplete=\"off\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"contact-name\">{{'contract.contractName' | translate }} *</label>\n<input type=\"text\" ng-change=\"$ctrl.handleFormChange()\" required ng-model=\"$ctrl.model.contractName\" id=\"contact\" class=\"form-control\" ng-pattern=\"/^[a-zA-Z0-9 -_]*$/\">\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"contact\">{{'contract.contractStatus' | translate }}</label><br/>\n<input ng-change=\"$ctrl.handleFormChange()\" class=\"margin-top-02\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"contact\">{{'customer.billToCustomer' | translate }}</label><br/>\n<input ng-change=\"$ctrl.handleFormChange();$ctrl.resetBillToCustomers();\" class=\"margin-top-02\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.useCustomerOnBillingRules\" type=\"checkbox\" ng-change=\"$ctrl.resetBillToCustomers();$ctrl.handleFormChange()\"/>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<textarea cols=\"30\" rows=\"3\" ng-model=\"$ctrl.model.description\" class=\"form-control\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<label for=\"billing-increment\">{{'contract.billing_increment' | translate}}</label>\n<div class=\"form-group btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"billingIncrement in $ctrl.billingIncrementList\" ng-click=\"$ctrl.selectBillingIncrement(billingIncrement); $ctrl.handleFormChange()\" ng-class=\"{'btn-primary': $ctrl.model.selectedBillingDuration === billingIncrement.value,'btn-default': \n\t\t\t\t\t\t\t   $ctrl.model.selectedBillingDuration !== billingIncrement.value,\n\t\t\t\t\t\t\t   'disabled': billingIncrement.value !== 'MONTHLY' && $ctrl.model.disableBillingIncrement}\">\n{{billingIncrement.label}}\n</a>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group col-sm-6\">\n<label for=\"start-date\">{{'contract.contract_start' | translate }}</label>\n<span ng-if=\"($ctrl.requiredStartDate && !$ctrl.model.contractStartDate) || (!$ctrl.model.contractStartDate)\"><label>*</label></span>\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"$ctrl.model.contractStartDate\" date-format=\"dd-MMM-yyyy\" ng-click=\"$ctrl.isDisabledDate(date, mode); $ctrl.handleFormChange()\" hidden-time=\"true\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': $ctrl.requiredStartDate && !$ctrl.model.contractStartDate}\" date-options=\"$ctrl.startMaxDate\" ng-keydown=\"$event.preventDefault();\">\n</datetimepicker>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"end-date\">{{'contract.contract_end' | translate }}</label>\n<button type=\"button\" class=\"margin-left-10 btn btn-xs btn-success\" ng-click=\"$ctrl.clear();$ctrl.handleFormChange();$ctrl.contractDatesChanged()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.clear' | translate }}</button>\n<datetimepicker class=\"datetimepicker-input\" id=\"end-date\" ng-model=\"$ctrl.model.contractEndDate\" date-format=\"dd-MMM-yyyy\" date-options=\"$ctrl.startMinDate\" ng-click=\"$ctrl.handleFormChange(); $ctrl.contractDatesChanged()\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault();\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-6\">\n<label for=\"contract-type\">{{'contractType.menu.title' | translate }}</label>\n<search-and-select class=\"contract-customer-dd\" ng-model=\"$ctrl.model.contractTypeId\" values=\"$ctrl.contractTypeObj.results\" key=\"Key\" totalrecords=\"$ctrl.contractTypeObj.totalRecords\" onscroll=\"$ctrl.getContractTypeList(searchKey, offset);\" ng-disabled=\"$ctrl.contractTypeObj.loading\" none-selected=\"'common.none'\">\n</search-and-select>\n</div>\n<div class=\"_form-group col-sm-6\">\n<label for=\"bailment_interest\">{{'contract.bailment_interest' | translate }}</label>\n<input type=\"text\" ng-model=\"$ctrl.model.bailmentInterest\" id=\"bailmentInterest\" class=\"form-control\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\" ng-blur=\"$ctrl.ngPercentage()\" ng-focus=\"$ctrl.removePercentageSign($ctrl.model.bailmentInterest)\"/>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"btn-group margin-top-05\">\n<label for=\"\" class=\"btn-group btn btn-primary\" ng-click=\"$ctrl.selectedTab = 'rules'; $ctrl.resetLogsOptions()\" ng-class=\"{'btn-primary': $ctrl.selectedTab === 'rules', 'btn-default': $ctrl.selectedTab !== 'rules'}\">\n{{'contract.contractRule' | translate}}\n</label>\n<label for=\"\" class=\"btn-group btn btn-default\" ng-click=\"$ctrl.selectedTab = 'history'; $ctrl.loadData();\" ng-class=\"{'btn-primary': $ctrl.selectedTab === 'history', 'btn-default': $ctrl.selectedTab !== 'history'}\">\n{{'contract.updateContractHistory' | translate}}\n</label>\n</div>\n<div class=\"com-sm-12 margin-top-20\" ng-if=\"$ctrl.selectedTab === 'rules'\">\n<div ng-if=\"$ctrl.showBillingWarning === true\">\n<span class=\"col-sm-12 alert-info alert text-center\" style=\"margin-bottom: 10px;\">\n<span class=\"glyphicon glyphicon-info-sign\"></span>\nOne or more billing rules have a start/end date that overlaps with or extends beyond the contract's start / end date. To save the contract, please adjust the contract rule's start / end date accordingly.\n</span>\n</div>\n<div class=\"col-sm-8 remove-pad\">\n<h4 class=\"margin-top-5\">Billing Rules</h4>\n<div class=\"margin-top-5 margin-bottom-5\" ng-if=\"!$ctrl.contractRulesLocationLoading && !$ctrl.loading\">\n<span ng-if=\"!$ctrl.loading\" class=\"badge active-location-badge cursor-pointer\" ng-click=\"$ctrl.filterByValue = 'active'\" uib-tooltip=\"{{'common.active' | translate}}\" tooltip-placement=\"top-left\">{{$ctrl.contractRulesRecordStats.active}}</span>\n<span ng-if=\"!$ctrl.loading\" class=\"badge in-active-location-badge cursor-pointer\" ng-click=\"$ctrl.filterByValue = 'inactive'\" uib-tooltip=\"{{'common.inactive' | translate}}\" tooltip-placement=\"top-left\">{{$ctrl.contractRulesRecordStats.inactive}}</span>\n<span ng-if=\"!$ctrl.loading\">\n<button id=\"filter-by\" type=\"button\" class=\"btn btn-xs\" ng-class=\"{'btn-default': $ctrl.filterByValue !== 'all', 'btn-success': $ctrl.filterByValue === 'all'}\" ng-click=\"$ctrl.filterByValue !== 'all' ? $ctrl.filterByValue = 'all' : $ctrl.filterByValue = 'active'\">\n{{'common.All' | translate}}\n</button>\n</span>\n</div>\n</div>\n<div class=\"col-sm-4 remove-pad\">\n<input type=\"text\" class=\"form-control margin-bottom-10\" ng-model=\"$ctrl.contractRulesLocationSearchText\" name=\"searchText\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.getContractRulesLocation();\" placeholder=\"{{'common.locationId' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9,/$_+*@ ]*$/\"/>\n</div>\n<div class=\"margin-bottom-10\">\n<div class=\"text-align-center\" ng-if=\"$ctrl.contractRulesLocationLoading || $ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<ul dnd-list=\"$ctrl.billingRulesOptions\" dnd-drop=\"$ctrl.onDrop(event, index, item, external, type)\" class=\"list-group location-sequence\" ng-if=\"!$ctrl.contractRulesLocationLoading && !$ctrl.loading\">\n<li class=\"billing-rules-border remove-pad col-sm-12 margin-top-05\" ng-repeat=\"contractRules in $ctrl.billingRulesOptions track by $index\" dnd-effect-allowed=\"move\" dnd-draggable=\"contractRules\" dnd-disable-if=\"$ctrl.checkIsEdit()\" ng-if=\"$ctrl.shouldDisplayRule(contractRules)\">\n<div class=\"_form-group w-100\" ng-if=\"contractRules.contractRulesId || (contractRules.isNew && !contractRules.isEdit) || (!contractRules.isNew && !contractRules.isEdit)\">\n<div class=\"margin-10 col-sm-10\">\n<label for=\"status\" class=\"font-size-17\">{{contractRules.name}} | {{contractRules.billingCategoryObj.billingCategory.label}} ({{contractRules.status === true ? \"Active\" : \"Inactive\"}})</label>\n</div>\n<div class=\"col-sm-2 remove-right-pad\">\n<h4 class=\"billing-rules-status billing-rules-status-label\">\n<span class=\"label label-success\" ng-if=\"contractRules.status\">{{'common.active' | translate}}</span>\n<span class=\"label label-danger\" ng-if=\"!contractRules.status\">{{'common.suspended' | translate}}</span>\n</h4>\n</div>\n</div>\n<div class=\"_form-group margin-top-05 w-100\" ng-if=\"contractRules.contractRulesId || (contractRules.isNew && !contractRules.isEdit) || (!contractRules.isNew && !contractRules.isEdit)\">\n<div class=\"font-size-15 margin-bottom-10 col-sm-11\">\n<span>{{contractRules.billingEventObj.billingEvent.label}} | </span>\n<span ng-if=\"contractRules.locationTypeObj.locationType\">{{contractRules.locationTypeObj.locationType.label}} | </span>\n<span ng-if=\"contractRules.locationTypeObj.serviceType\">{{contractRules.serviceTypeObj.serviceType.label}} | </span>\n<span ng-if=\"contractRules.locationTypeObj.scheduleType\">{{contractRules.scheduleTypeObj.scheduleType.label}} | </span>\n<span ng-if=\"contractRules.locationTypeObj.orderType\">{{contractRules.orderTypeObj.orderType.label}} | </span>\n<span>{{contractRules.billingTypeObj.billingType.label}}\n<span class=\"text-success\" ng-if=\"contractRules.locationDistanceId\">\n= {{contractRules.locationDistance.label}} ({{contractRules.locationDistance.mileRange}})\n</span>\n</span>\n<span class=\"text-success\" ng-if=\"contractRules.dollarRate !== null\"> |\n<span>{{'contract.dollar_rate' | translate}} = </span>{{contractRules.dollarRate | currency}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.percentageRate !== null\"> |\n<span>{{'contract.percentage_rate' | translate}} =\n</span>{{$ctrl.percentageMask(contractRules.percentageRate, 2)}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.dollarRateAbove !== null\"> |\n<span>{{'contract.rate_above' | translate}} = </span>{{contractRules.dollarRateAbove | currency}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.dollarRateBelow !== null\"> |\n<span>{{'contract.rate_below' | translate}} = </span>{{contractRules.dollarRateBelow | currency}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.percentageRateAbove !== null\"> |\n<span>{{'contract.rate_above' | translate}} =\n</span>{{$ctrl.percentageMask(contractRules.percentageRateAbove, 2)}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.percentageRateBelow !== null\"> |\n<span>{{'contract.rate_below' | translate}} =\n</span>{{$ctrl.percentageMask(contractRules.percentageRateBelow, 2)}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.itemThreshold !== null\"> |\n<span>{{'contract.threshold' | translate}} =\n</span>{{contractRules.itemThreshold}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.itemIncrement !== null\"> |\n<span>{{'contract.increment' | translate}} =\n</span>{{contractRules.itemIncrement}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.valueThreshold !== null\"> |\n<span>{{'contract.threshold' | translate}} = </span>{{contractRules.valueThreshold | currency}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.valueIncrement !== null\"> |\n<span>{{'contract.increment' | translate}} = </span>{{contractRules.valueIncrement | currency}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.timeThreshold\"> |\n<span>{{'contract.threshold' | translate}} =\n</span>{{contractRules.timeThreshold | date:'HH:mm:ss'}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.timeIncrement\"> |\n<span>{{'contract.increment' | translate}} =\n</span>{{contractRules.timeIncrement}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.generalLedgerCode !== null\"> |\n<span>{{'common.generalLedgerCode' | translate}} =\n</span>{{contractRules.generalLedgerCode}}</span>\n<span class=\"text-success\" ng-if=\"contractRules.applyWrapFee\"> |\n<span>{{'billableEvents.wrap_fee' | translate}} = </span>{{contractRules.wrapFee | currency}}\n</span>\n</div>\n<div class=\"text-right col-sm-1 margin-bottom-10 remove-pad\">\n<div class=\"pad-right-02 btn-group\">\n<button ng-if=\"!contractRules.isEdit\" type=\"button\" ng-click=\"$ctrl.editBillingRules(contractRules, $index)\" class=\"btn btn-success btn-xs\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n<button ng-if=\"!contractRules.isEdit\" type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"$ctrl.removeBillingContract(contractRules, $index)\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n<button ng-if=\"!contractRules.isEdit\" type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"$ctrl.duplicateBillingRule(contractRules)\">\n<span class=\"glyphicon glyphicon-duplicate\"></span>\n</button>\n<button ng-if=\"contractRules.isEdit\" type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"$ctrl.closeFormEdit(contractRules, $index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad form-border-top\" ng-if=\"contractRules.isEdit\">\n<form name=\"contractRulesForm\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"remove-pad items-err-lbl-margin-top col-sm-12\">\n<div class=\"remove-pad col-sm-10\">\n<div class=\"_form-group col-sm-4 atm-codes-date-picker-section\">\n<label for=\"start-date\">Rule Active Date</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"cont-start-date\" ng-model=\"contractRules.startDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-click=\"$ctrl.contractDatesChanged(true)\" show-button-bar=\"false\" ng-class=\"{'required-datetimepicker': contractRules.isNew && !contractRules.startDate}\" date-options=\"$ctrl.ruleStartDateOptions\" ng-keydown=\"$event.preventDefault();\">\n</datetimepicker>\n</div>\n<div class=\"_form-group col-sm-4 atm-codes-date-picker-section\">\n<label for=\"start-date\">Rule End Date</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"cont-end-date\" ng-model=\"contractRules.endDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" ng-click=\"$ctrl.contractDatesChanged(true)\" show-button-bar=\"false\" date-options=\"{minDate: contractRules.startDate || $ctrl.model.contractStartDate, maxDate: $ctrl.ruleStartDateOptions['maxDate']}\" ng-keydown=\"$event.preventDefault();\">\n</datetimepicker>\n</div>\n</div>\n<div class=\"_form-group pull-right _col-sm-3 icon-padding-05 margin-top-20\">\n<div class=\"margin-top-05 btn-group service-tab\" data-toggle=\"buttons\">\n<button id=\"active-btn-{{$index}}\" type=\"button\" class=\"btn btn-default btn-sm ignore-validation-css\" ng-model=\"contractRules.status\" uib-btn-radio=\"$ctrl.contractRulesStatus.active\" ng-click=\"$ctrl.updateContractRuleStatus($index, true);\" ng-class=\"{'btn-success': contractRules.status === $ctrl.contractRulesStatus.active, \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': contractRules.status === $ctrl.contractRulesStatus.suspended}\">\n{{'common.active' | translate}}\n</button>\n<button id=\"inactive-btn-{{$index}}\" type=\"button\" class=\"btn btn-sm btn-default ignore-validation-css\" ng-model=\"contractRules.status\" uib-btn-radio=\"$ctrl.contractRulesStatus.suspended\" ng-click=\"$ctrl.updateContractRuleStatus($index, false);\" ng-class=\"{'btn-danger': contractRules.status === $ctrl.contractRulesStatus.suspended, \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': contractRules.status === $ctrl.contractRulesStatus.active}\">\n{{'common.suspended' | translate}}\n</button>\n</div>\n</div>\n</div>\n<div class=\"remove-pad items-err-lbl-margin-top col-sm-12\">\n<div><hr class=\"remove-top-margin margin-bottom-10\"/></div>\n<div class=\"form-group col-sm-3\">\n<label for=\"contact-name\">{{'common.name' | translate }} *</label>\n<input type=\"text\" required ng-model=\"contractRules.name\" id=\"contact\" class=\"form-control\">\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<input type=\"text\" ng-model=\"contractRules.description\" id=\"description\" class=\"form-control\">\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"generalLedgerCode\">{{'common.generalLedgerCode' | translate}} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"contractRules.generalLedgerCode\">\n</div>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'billableEvents.billing_category' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.billingCategoryObj.billingCategory\" ng-change=\"$ctrl.getBillingEventsByCategory(contractRules, $index);\" required ng-options=\"category.label for category in contractRules.billingCategoryObj.billingCategoryOptions track by category.billingCategoryId\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-3\">\n<label>{{'billableEvents.billing_events' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.billingEventObj.billingEvent\" ng-change=\"$ctrl.preOrPostBillCfg(contractRules, $index); $ctrl.serviceTypeOptionChoice(contractRules, $index); $ctrl.locationTypeOptionChoice(contractRules); $ctrl.orderTypeOptionChoice(contractRules); $ctrl.isAllowScheduleType(contractRules, $index); $ctrl.billingTypeOptionChoice(contractRules);\" required ng-options=\"item as item.label for item in contractRules.billingEventObj.billingEventOptions track by item.value\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'location._type' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.locationTypeObj.locationType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-options=\"item as item.label for item in contractRules.locationTypeObj.locationTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'contract.service_type' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.serviceTypeObj.serviceType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index)\" ng-options=\"item as item.label for item in contractRules.serviceTypeObj.serviceTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled || $ctrl.isDisableServiceTypeOptions[$index].disabled\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'branch_mgmt.item_orderType' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.orderTypeObj.orderType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" required ng-change=\"!$ctrl.validateBillingRuleFormControl($index)\" ng-options=\"item as item.label for item in contractRules.orderTypeObj.orderTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled || contractRules.billingEventObj.billingEvent.value === 'stop-completed'\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group _col-sm-3\" ng-class=\"{'col-sm-3': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) === -1 ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t contractRules.billingEventObj.billingEvent.value !== 'coin-delivery', \n\t\t\t\t\t\t\t\t\t\t\t\t\t  'col-sm-2': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t contractRules.billingEventObj.billingEvent.value === 'coin-delivery'}\">\n<label>{{'billableEvents.billing_type' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.billingTypeObj.billingType\" required ng-change=\"!$ctrl.validateBillingRuleFormControl($index); $ctrl.validateBillingType(contractRules, $index)\" ng-options=\"item as item.label for item in contractRules.billingTypeObj.billingTypeOptions track by item.value\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'combined_time'\">\n<label>{{'billableEvents.service_time' | translate}}</label>\n<div class=\"valid-multi-select-value remove-left-pad multi-select vault-close-search-dd\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.serviceTimeTypes\" output-model=\"contractRules.serviceTimeTypeObj.serviceTimeType\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n<div class=\"remove-pad _col-sm-6\" ng-class=\"{'col-sm-6': ['time_threshold', 'value_threshold', 'item_threshold', 'combined_time'].indexOf(contractRules.billingTypeObj.billingType.value) === -1 ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  contractRules.billingEventObj.billingEvent.value !== 'coin-delivery', \n\t\t\t\t\t\t\t\t\t\t\t\t\t 'billing-type-value-section': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 &&\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  contractRules.billingEventObj.billingEvent.value === 'coin-delivery'}\">\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-6\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'hourly_rate'\">\n<label>{{'contract.rate_first_hour' | translate}}</label>\n<input type=\"text\" ng-currency class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.rateFirstHour\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-6\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'hourly_rate'\">\n<label>{{'contract.rate_fifteen_minutes' | translate}}</label>\n<input type=\"text\" ng-currency class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.rateFifteenMinutes\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section\" ng-class=\"{'col-sm-3': ['per_item', 'fixed', 'combined_time'].indexOf(contractRules.billingTypeObj.billingType.value) > -1,\n\t\t\t\t\t\t\t\t\t\t\t\t\t   'col-sm-6': ['drive_distance'].indexOf(contractRules.billingTypeObj.billingType.value) > -1}\" ng-if=\"['per_item', 'drive_distance', 'fixed', 'combined_time'].indexOf(contractRules.billingTypeObj.billingType.value) > -1\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} ($)</label>\n<input type=\"text\" ng-currency ng-required=\"['per_item', 'fixed'].indexOf(contractRules.billingTypeObj.billingType.value) > -1\" class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.dollarRate\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"form-group col-sm-6\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'drive_distance'\">\n<label>{{'billableEvents.location_distance' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.locationDistanceId\" required ng-change=\"$ctrl.updateLocationDistance(contractRules, contractRules.locationDistanceId, $index)\" ng-options=\"obj.id as (obj.label + ' | ' + '(' + obj.minRange + ' - ' + obj.maxRange + ')') for obj in $ctrl.model.locationDistanceOptions\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"['percentage_fee', 'part_markup'].indexOf(contractRules.billingTypeObj.billingType.value) > -1\">\n<label ng-if=\"contractRules.billingTypeObj.billingType.value === 'percentage_fee'\">{{'branch_mgmt.billing_approval.rate' | translate}} (%) *</label>\n<label ng-if=\"contractRules.billingTypeObj.billingType.value === 'part_markup'\">{{'branch_mgmt.billing_approval.markup' | translate}} (%) *</label>\n<input type=\"text\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.percentageRate\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='item_threshold'\">\n<label>{{'contract.threshold' | translate}}</label>\n<input type=\"number\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.itemThreshold\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='item_threshold'\">\n<label>{{'contract.increment' | translate}}</label>\n<input type=\"number\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.itemIncrement\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='value_threshold' || contractRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.threshold' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.valueThreshold\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='value_threshold' || contractRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.increment' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.valueIncrement\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='time_threshold'\">\n<label>{{'contract.threshold' | translate}}</label>\n<time-picker ng-model=\"contractRules.timeThreshold\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" required show-seconds=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='time_threshold'\">\n<label>{{'contract.increment' | translate}}</label>\n<time-picker ng-model=\"contractRules.timeIncrement\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" required show-seconds=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"(contractRules.billingTypeObj.billingType.value === 'time_threshold' || contractRules.billingTypeObj.billingType.value === 'value_threshold'\n\t\t\t\t\t\t\t\t\t\t\t || contractRules.billingTypeObj.billingType.value === 'item_threshold')\">\n<label>{{'contract.rate_above' | translate}}($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.dollarRateAbove\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.rate_above' | translate}}(%)</label>\n<input type=\"text\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.percentageRateAbove\">\n</div>\n<div class=\"col-sm-4 enable-hour-input\" ng-if=\"contractRules.billingTypeObj.billingType.value == 'service_ticket_overage_time_charge'\">\n<label>Base Time *</label>\n<time-picker ng-model=\"contractRules.timeThreshold\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" required show-seconds=\"true\" show-full-time=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n<div class=\"col-sm-4\" ng-if=\"contractRules.billingTypeObj.billingType.value == 'service_ticket_overage_time_charge'\">\n<label>Base Rate ($) *</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.dollarRate\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"col-sm-4\" ng-if=\"contractRules.billingTypeObj.billingType.value == 'service_ticket_overage_time_charge'\">\n<label>Overage Rate ($) *</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.overageRate\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"col-sm-3 remove-right-pad\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'fixed'\">\n<label>{{'contract.billing_time' | translate}}</label>\n<br/>\n<div class=\"btn-group z-index0\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"contractRules.billingTime\" uib-btn-radio=\"$ctrl.stats.pre\" ng-click=\"$ctrl.tabSelection('pre')\" ng-disabled=\"(contractRules.billingEventObj.billingEvent.value === 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed') || \n\t\t\t\t\t\t\t\t\t\t\t\t\t(contractRules.billingEventObj.billingEvent.value !== 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed')\" ng-class=\"{'btn-success': contractRules.billingTime === $ctrl.stats.pre, \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': contractRules.billingTime === $ctrl.stats.post}\">\n{{'common.pre' | translate}}\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"contractRules.billingTime\" uib-btn-radio=\"$ctrl.stats.post\" ng-disabled=\"(contractRules.billingEventObj.billingEvent.value === 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed') ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t(contractRules.billingEventObj.billingEvent.value !== 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed')\" ng-click=\"$ctrl.tabSelection('post');\" ng-class=\"{'btn-success': contractRules.billingTime === $ctrl.stats.post, \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': contractRules.billingTime === $ctrl.stats.pre}\">\n{{'common.post' | translate}}\n</button>\n</div>\n</div>\n<div class=\"_form-group col-sm-3 remove-right-pad\" ng-if=\"contractRules.billingTypeObj.billingType && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ['combined_time', 'drive_distance', 'hourly_rate', 'part_markup'].indexOf(contractRules.billingTypeObj.billingType.value) === -1 &&\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcontractRules.billingEventObj.billingEvent.value === 'coin-delivery'\">\n<label>{{'billableEvents.apply_wrap_fee' | translate}}</label>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"contractRules.applyWrapFee\" type=\"checkbox\"/>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"contractRules.billingEventObj.billingEvent.value === 'coin-delivery' && contractRules.applyWrapFee\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.wrapFee\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"col-sm-6\" ng-if=\"contractRules.billingEventObj.billingEvent.value === 'pre-bill'\">\n<label>{{'billableEvents.pre_billing_events' | translate}}</label>\n<div class=\"valid-multi-select-value remove-left-pad multi-select contract-location-multi-select-dd\" isteven-multi-select max-labels=\"1\" input-model=\"contractRules.billingEventObj.preBillingEventOptions\" output-model=\"contractRules.billingEventObj.preBillingEvents\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n<div class=\"col-sm-6\" ng-if=\"contractRules.billingEventObj.billingEvent.value === 'post-bill'\">\n<label>{{'billableEvents.post_billing_events' | translate}}</label>\n<div class=\"valid-multi-select-value remove-left-pad multi-select contract-location-multi-select-dd\" isteven-multi-select max-labels=\"1\" input-model=\"contractRules.billingEventObj.postBillingEventOptions\" output-model=\"contractRules.billingEventObj.postBillingEvents\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.model.useCustomerOnBillingRules\">\n<div><hr class=\"remove-bottom-margin\"/></div>\n<div class=\"col-sm-6 margin-10\">\n<div class=\"_form-group\">\n<label for=\"bill-to-customer\">{{'location.customer' | translate }} * </label>\n<search-and-select class=\"contract-customer-dd\" ng-model=\"contractRules.billToCustomerId\" values=\"$ctrl.customerObj.results\" key=\"Key\" totalrecords=\"$ctrl.customerObj.totalRecords\" onscroll=\"$ctrl.getCustomerList(searchKey, offset);\" ng-disabled=\"$ctrl.customerObj.loading\" none-selected=\"'common.none'\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-6 margin-10\">\n<label for=\"\">{{ 'contract.location_applicable' | translate }}\n<button class=\"btn btn-success btn-xs\" type=\"button\" ng-click=\"$ctrl.bulkImportLocationModal(contractRules, $index)\">\nImport\n</button>\n</label>\n<div>\n<paginated-search-and-select page-limit=\"$ctrl.locationObj.pageLimit\" ng-model=\"contractRules.contractRulesLocations\" key=\"key\" total-count=\"contractRules.contractLocationsDistance.length\" display-label=\"'value'\" options=\"contractRules.locationOptions\" search=\"true\" onscroll=\"$ctrl.getContractLocationList(searchKey, contractRules.billingTypeObj.billingType.value === 'drive_distance' ? contractRules.locationDistance.id: null, offset, $index, selectAllFlag)\" none-selected=\"\" selected-prefix=\"''\" is-loading=\"ddLoading\" all-label=\"'Select'\" label-name=\"value\" toggle-count=\"true\" ng-change=\"$ctrl.filterChange(contractRules)\" mode=\"'edit'\" location-distance-id=\"contractRules.locationDistance\" billing-type=\"contractRules.billingTypeObj.billingType.value === 'drive_distance'\" on-show-all=\"$ctrl.showAllFlag = true;\">\n</paginated-search-and-select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.model.useCustomerOnBillingRules\">\n<div>\n<hr class=\"remove-bottom-margin\"/>\n</div>\n<div class=\"col-sm-6 margin-10\">\n<label for=\"\">{{ 'contract.location_applicable' | translate }}\n<button class=\"btn btn-success btn-xs\" type=\"button\" ng-click=\"$ctrl.bulkImportLocationModal(contractRules, $index)\">\nImport\n</button>\n</label>\n<div>\n<paginated-search-and-select page-limit=\"$ctrl.associateLocationObj.pageLimit\" ng-model=\"contractRules.contractRulesLocations\" key=\"key\" total-count=\"contractRules.customerLocationsDistance.length\" display-label=\"'value'\" options=\"contractRules.locationOptions\" search=\"true\" onscroll=\"$ctrl.getCustomerLocationList(searchKey, contractRules.billingTypeObj.billingType.value === 'drive_distance' ? contractRules.locationDistance.id: null, offset, selectAllFlag, $index)\" none-selected=\"\" selected-prefix=\"''\" is-loading=\"ddLoading\" all-label=\"'Select'\" label-name=\"value\" toggle-count=\"true\" ng-change=\"$ctrl.filterChange(contractRules)\" mode=\"'edit'\" location-distance-id=\"contractRules.locationDistance\" billing-type=\"contractRules.billingTypeObj.billingType.value === 'drive_distance'\" on-show-all=\"$ctrl.showAllFlag = true;\">\n</paginated-search-and-select>\n</div>\n</div>\n</div>\n<div class=\"margin-10 col-sm-12\">\n<div class=\"margin-bottom-10\">\n<button type=\"button\" id=\"ruleSave\" ng-click=\"$ctrl.saveBillingRules(contractRules, $index);\" class=\"btn btn-primary\" ng-disabled=\"contractRulesForm.$invalid || contractRules.isNew === true && !contractRules.startDate || (contractRules.endDate && contractRules.startDate >= contractRules.endDate)\">\n{{'common.save' | translate}}\n</button>\n<button ng-if=\"$ctrl.billingRulesOptions.length > 0\" type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeBillingContract(contractRules, $index)\">\n<span class=\"glyphicon glyphicon-trash\"></span></button>\n\n</div>\n</div>\n</div>\n</form>\n</div>\n</li>\n</ul>\n<div class=\"col-sm-12 margin-5 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.billingRulesOptions.length !== 0 && \n\t\t\t\t\t\t   (\n\t\t\t\t\t\t\t   ($ctrl.filterByValue === 'active' && $ctrl.contractRulesRecordStats.active === 0 && !$ctrl.hasNonNewBillingRules()) || \n\t\t\t\t\t\t\t   ($ctrl.filterByValue === 'inactive' && $ctrl.contractRulesRecordStats.inactive === 0 && !$ctrl.hasNonNewBillingRules())\n\t\t\t\t\t\t   )\">\n<div class=\"col-sm-12 alert text-align-center alert-danger\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 margin-5 remove-left-pad remove-right-pad\" ng-if=\"$ctrl.contractRules.length==0 && (!$ctrl.contractRulesLocationLoading && !$ctrl.loading)\" ng-hide=\"$ctrl.billingRulesOptions.length > 0\">\n<div class=\"col-sm-12 alert text-align-center alert-danger\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n<div class=\"col-sm-12 billing-rules-margin-top-10 remove-pad billing-rules-border\" ng-repeat=\"billingRules in $ctrl.billingRulesOptions track by $index\" ng-if=\"false && billingRules.isEdit\">\n<form name=\"billingRulesForm\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"_form-group pull-right _col-sm-3 icon-padding-05\">\n<div class=\"margin-top-05 btn-group service-tab\" data-toggle=\"buttons\">\n<button id=\"active-btn-{{$index}}\" type=\"button\" class=\"btn btn-default btn-sm ignore-validation-css\" ng-model=\"contractRules.status\" uib-btn-radio=\"$ctrl.contractRulesStatus.active\" ng-click=\"$ctrl.updateContractRuleStatus($index, true)\" ng-class=\"{'btn-success': contractRules.status === $ctrl.contractRulesStatus.active, \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': contractRules.status === $ctrl.contractRulesStatus.suspended}\">\n{{'common.active' | translate}}\n</button>\n<button id=\"inactive-btn-{{$index}}\" type=\"button\" class=\"btn btn-sm btn-default ignore-validation-css\" ng-model=\"contractRules.status\" uib-btn-radio=\"$ctrl.contractRulesStatus.suspended\" ng-click=\"$ctrl.updateContractRuleStatus($index, false);\" ng-class=\"{'btn-danger': contractRules.status === $ctrl.contractRulesStatus.suspended, \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': contractRules.status === $ctrl.contractRulesStatus.active}\">\n{{'common.suspended' | translate}}\n</button>\n</div>\n</div>\n<div class=\"remove-pad items-err-lbl-margin-top col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"contact-name\">{{'common.name' | translate }} *</label>\n<input type=\"text\" required ng-model=\"billingRules.name\" id=\"contact\" class=\"form-control\">\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<input type=\"text\" ng-model=\"billingRules.description\" id=\"description\" class=\"form-control\">\n</div>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'billableEvents.billing_category' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.billingCategoryObj.billingCategory\" ng-change=\"$ctrl.getBillingEventsByCategory(contractRules, $index);\" required ng-options=\"category.label for category in contractRules.billingCategoryObj.billingCategoryOptions track by category.billingCategoryId\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-3\">\n<label>{{'billableEvents.billing_events' | translate}}</label>\n<select class=\"form-control\" ng-model=\"billingRules.billingEventObj.billingEvent\" ng-change=\"$ctrl.preOrPostBillCfg(billingRules, $index); $ctrl.serviceTypeOptionChoice(billingRules, $index); $ctrl.locationTypeOptionChoice(billingRules); $ctrl.orderTypeOptionChoice(billingRules); $ctrl.isAllowScheduleType(contractRules, $index); $ctrl.billingTypeOptionChoice(billingRules);\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-options=\"item as item.label for item in billingRules.billingEventObj.billingEventOptions track by item.value\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'location._type' | translate}}</label>\n<select class=\"form-control\" ng-model=\"billingRules.locationTypeObj.locationType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-options=\"item as item.label for item in billingRules.locationTypeObj.locationTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'contract.service_type' | translate}}</label>\n<select class=\"form-control\" ng-model=\"billingRules.serviceTypeObj.serviceType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index)\" ng-options=\"item as item.label for item in billingRules.serviceTypeObj.serviceTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'branch_mgmt.item_orderType' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"contractRules.orderTypeObj.orderType\" ng-required=\"!$ctrl.disableOtherOptions[$index].disabled\" required ng-change=\"!$ctrl.validateBillingRuleFormControl($index)\" ng-options=\"item as item.label for item in contractRules.orderTypeObj.orderTypeOptions track by item.value\" ng-disabled=\"$ctrl.disableOtherOptions[$index].disabled\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_form-group _col-sm-3\" ng-class=\"{'col-sm-3': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) === -1 ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t contractRules.billingEventObj.billingEvent.value !== 'coin-delivery', \n\t\t\t\t\t\t\t\t\t\t\t\t 'col-sm-2': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t contractRules.billingEventObj.billingEvent.value === 'coin-delivery'}\">\n<label>{{'billableEvents.billing_type' | translate}}</label>\n<select class=\"form-control\" ng-model=\"billingRules.billingTypeObj.billingType\" required ng-change=\"!$ctrl.validateBillingRuleFormControl($index); $ctrl.validateBillingType(billingRules, $index)\" ng-options=\"item as item.label for item in billingRules.billingTypeObj.billingTypeOptions track by item.value\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-3\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'combined_time'\">\n<label>{{'billableEvents.service_time' | translate}}</label>\n<div class=\"valid-multi-select-value remove-left-pad multi-select vault-close-search-dd\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.serviceTimeTypes\" output-model=\"contractRules.serviceTimeTypeObj.serviceTimeType\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n<div class=\"remove-pad _col-sm-6\" ng-class=\"{'col-sm-6': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) === -1 ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 && \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t contractRules.billingEventObj.billingEvent.value !== 'coin-delivery', \n\t\t\t\t\t\t\t\t\t\t\t\t   'billing-type-value-section': ['time_threshold', 'value_threshold', 'item_threshold'].indexOf(contractRules.billingTypeObj.billingType.value) > -1 &&\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcontractRules.billingEventObj.billingEvent.value === 'coin-delivery'}\">\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value === 'fixed'\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.dollarRate\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value === 'per_item'\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} ($)</label>\n<input type=\"text\" ng-currency ng-required=\"!billingRules.percentageRate\" class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.dollarRate\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value === 'percentage_fee'\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} (%)</label>\n<input type=\"text\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.percentageRate\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='item_threshold'\">\n<label>{{'contract.threshold' | translate}}</label>\n<input type=\"number\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.itemThreshold\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='item_threshold'\">\n<label>{{'contract.increment' | translate}}</label>\n<input type=\"number\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.itemIncrement\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='value_threshold' || billingRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.threshold' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.valueThreshold\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='value_threshold' || billingRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.increment' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.valueIncrement\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='time_threshold'\">\n<label>{{'contract.threshold' | translate}}</label>\n<time-picker ng-model=\"billingRules.timeThreshold\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" required show-seconds=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='time_threshold'\">\n<label>{{'contract.increment' | translate}}</label>\n<time-picker ng-model=\"billingRules.timeIncrement\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" required show-seconds=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"(billingRules.billingTypeObj.billingType.value === 'time_threshold' || billingRules.billingTypeObj.billingType.value === 'value_threshold'\n\t\t\t\t\t\t\t\t\t\t || billingRules.billingTypeObj.billingType.value === 'item_threshold')\">\n<label>{{'contract.rate_above' | translate}}($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.dollarRateAbove\">\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.billingTypeObj.billingType.value ==='percentage_threshold'\">\n<label>{{'contract.rate_above' | translate}}(%)</label>\n<input type=\"text\" required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.percentageRateAbove\">\n</div>\n<div class=\"col-sm-4 enable-hour-input\" ng-if=\"billingRules.billingTypeObj.billingType.value == 'service_ticket_overage_time_charge'\">\n<label>Base Time</label>\n<time-picker ng-model=\"contractRules.timeThreshold\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" required show-seconds=\"true\" show-full-time=\"true\" is-meridian=\"false\" display-time-format=\"false\" show-spinners=\"false\">\n</time-picker>\n</div>\n<div class=\"col-sm-4\" ng-if=\"billingRules.billingTypeObj.billingType.value == 'service_ticket_overage_time_charge'\">\n<label>Base Rate ($) </label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.dollarRate\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"col-sm-4\" ng-if=\"billingRules.billingTypeObj.billingType.value == 'service_ticket_overage_time_charge'\">\n<label>Overage Rate ($) </label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"contractRules.overageRate\" ng-class=\"{'invalid-field-section': contractRules.billingRangeError}\">\n</div>\n<div class=\"col-sm-3 remove-pad\" ng-if=\"contractRules.billingTypeObj.billingType.value === 'fixed'\">\n<label>{{'contract.billing_time' | translate}}</label>\n<br/>\n<div class=\"btn-group z-index0\">\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"billingRules.billingTime\" uib-btn-radio=\"$ctrl.stats.pre\" ng-click=\"$ctrl.tabSelection('pre')\" ng-disabled=\"(contractRules.billingEventObj.billingEvent.value === 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed') || \n\t\t\t\t\t\t\t\t\t\t\t\t(contractRules.billingEventObj.billingEvent.value !== 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed')\" ng-class=\"{'btn-success': billingRules.billingTime === $ctrl.stats.pre, \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': billingRules.billingTime === $ctrl.stats.post}\">\n{{'common.pre' | translate}}\n</button>\n<button class=\"btn btn-default ignore-validation-css\" ng-model=\"billingRules.billingTime\" uib-btn-radio=\"$ctrl.stats.post\" ng-disabled=\"(contractRules.billingEventObj.billingEvent.value === 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed') || \n\t\t\t\t\t\t\t\t\t\t\t\t(contractRules.billingEventObj.billingEvent.value !== 'pre-bill' && contractRules.billingTypeObj.billingType.value === 'fixed')\" ng-click=\"$ctrl.tabSelection('post');\" ng-class=\"{'btn-success': billingRules.billingTime === $ctrl.stats.post, \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   'remove-btn-grp-color': billingRules.billingTime === $ctrl.stats.pre}\">\n{{'common.post' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-6\" ng-if=\"contractRules.billingEventObj.billingEvent.value === 'pre-bill'\">\n<label>{{'billableEvents.pre_billing_events' | translate}}</label>\n<div class=\"valid-multi-select-value remove-left-pad multi-select contract-location-multi-select-dd\" isteven-multi-select max-labels=\"1\" input-model=\"contractRules.billingEventObj.preBillingEventOptions\" output-model=\"contractRules.billingEventObj.preBillingEvents\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n<div class=\"col-sm-6\" ng-if=\"contractRules.billingEventObj.billingEvent.value === 'post-bill'\">\n<label>{{'billableEvents.post_billing_events' | translate}}</label>\n<div class=\"valid-multi-select-value remove-left-pad multi-select contract-location-multi-select-dd\" isteven-multi-select max-labels=\"1\" input-model=\"contractRules.billingEventObj.postBillingEventOptions\" output-model=\"contractRules.billingEventObj.postBillingEvents\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button\">\n</div>\n</div>\n<div class=\"_form-group col-sm-3\">\n<label>{{'billableEvents.apply_wrap_fee' | translate}}</label>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"billingRules.applyWrapFee\" type=\"checkbox\"/>\n</div>\n<div class=\"remove-pad_ _billing-threshold-input-section col-sm-3\" ng-if=\"billingRules.applyWrapFee\">\n<label>{{'branch_mgmt.billing_approval.rate' | translate}} ($)</label>\n<input type=\"text\" ng-currency required class=\"form-control\" ng-change=\"!$ctrl.validateBillingRuleFormControl($index);\" ng-model=\"billingRules.wrapFee\" ng-class=\"{'invalid-field-section': billingRules.billingRangeError}\">\n</div>\n</div>\n<div class=\"margin-10 col-sm-12\">\n<div class=\"margin-bottom-10\">\n<button type=\"button\" ng-click=\"$ctrl.saveBillingRules(billingRules, $index)\" class=\"btn btn-primary\" ng-disabled=\"billingRulesForm.$invalid || !billingRules.startDate\">\n{{'common.save' | translate}}\n</button>\n<button ng-if=\"$ctrl.billingRulesOptions.length > 0\" type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeBillingContract(billingRules, $index)\">\n<span class=\"glyphicon glyphicon-trash\"></span></button>\n\n</div>\n</div>\n</div>\n</form>\n</div>\n<div class=\"row col-sm-6\" ng-class=\"{'margin-10': $ctrl.billingRulesOptions.length > 0}\">\n<div class=\"col-sm-3 remove-pad\">\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.addBillingRules($event)\" ng-disabled=\"!$ctrl.validateBillingRuleFormControl($parent.$index)\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'contract.new_rule' | translate}}</button>\n</div>\n</div>\n</div>\n</div>\n<div class=\"margin-top-20\" ng-if=\"$ctrl.selectedTab === 'history'\">\n<h4 class=\"margin-top-05\">{{'contract.updateContractHistory' | translate}}</h4>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"navbar-collapse col-sm-12\">\n<form class=\"navbar-form d-flex\">\n<div>\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'log.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</div>\n<div class=\"form-group\">\n<select class=\"form-control\" ng-options=\"entryType.value as entryType.label for entryType in $ctrl.entryTypes | orderBy:'label'\" ng-model=\"$ctrl.entryType\" ng-change=\"$ctrl.page = 1;$ctrl.loadData();\">\n<option value=\"\">({{'common.All' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRange\" ng-change=\"$ctrl.loadData($ctrl.model.dateRange)\" ng-if=\"$ctrl.model.dateRange.startDate\" options=\"$ctrl.model.dateRangPickerOptions\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n<button class=\"btn btn-success\" ng-click=\"$ctrl.print()\" ng-if=\"$ctrl.contractLogs && $ctrl.contractLogs.length && !$ctrl.loading\"> <i class=\"glyphicon glyphicon-print\"></i> {{'routeSheet.print' | translate}}</button>\n<button class=\"btn btn-primary\" ng-disabled=\"$ctrl.isExporting\" ng-click=\"$ctrl.exportToCsv()\" ng-if=\"$ctrl.contractLogs && $ctrl.contractLogs.length && !$ctrl.loading\">{{'branch_mgmt.daily_balance_sheet.export' | translate}} <span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.isExporting\"></span></button>\n</form>\n</div>\n</div>\n<div ng-class=\"{'cus-height': $ctrl.contractLogs.length  || $ctrl.loading}\">\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.contractLogs && $ctrl.contractLogs.length\">\n<div class=\"col-sm-12 panel-group list-group remove-right-pad\" id=\"accordion\">\n<div class=\"panel panel-default\" ng-repeat=\"log in $ctrl.contractLogs track by log.id\">\n<div class=\"panel-heading cust-panel-color\" data-toggle=\"collapse\" data-target=\"#{{log.id}}\" aria-expanded=\"false\" aria-controls=\"{{log.id}}\" ng-class=\"{ 'log-warning': log.flagged }\">\n<h4 class=\"panel-title cursor-pointer\">\n<a class=\"accordion-toggle\">\n<strong>{{log.readableEntryType + ' '}} </strong> <span ng-if=\"log.userId\">{{'log.by' | translate}}</span> {{' ' + log.user.firstName + ' ' + log.user.lastName + ' '}}\n<span ng-if=\"log.message\"> | <span class=\"message-color\">{{log.message}}</span></span>\n<span class=\"pull-right\">{{log.createdAt | date: 'short'}}</span>\n</a>\n</h4>\n</div>\n<div id=\"{{log.id}}\" class=\"panel-collapse collapse multi-collapse\">\n<div class=\"panel-body\">\n<table class=\"table table-bordered table-striped remove-pad-bottom\">\n<tr ng-repeat=\"detail in log.extraDetails\">\n<td>{{detail.key}}</td>\n<td class=\"wrap-text\">\n<span ng-if=\"(detail.key !== 'pickupImageName' && detail.key !== 'deliveryImageName')\">{{detail.value}}</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value !=='null') || (detail.key === 'deliveryImageName' && detail.value !=='null')\">Captured</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value =='null') || (detail.key === 'deliveryImageName' && detail.value =='null')\">{{'common.n_a' | translate}}</span>\n<span ng-if=\"(detail.key === 'pickupImageName' && detail.value !=='null') || (detail.key === 'deliveryImageName' && detail.value !=='null')\">\n<button id=\"shipment-image\" type=\"button\" class=\"btn btn-link remove-pad\" ng-click=\"$ctrl.showShipmentReceipt(log.extraDetails, detail.key == 'pickupImageName' ? 'pickup': 'delivery')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</button>\n</span>\n</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n<div class=\"margin-top-20\">\n<ul uib-pagination total-items=\"$ctrl.total\" ng-if=\"$ctrl.total>=$ctrl.pageLimit\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" items-per-page=\"$ctrl.pageLimit\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"$ctrl.maxPages\"></ul>\n</div>\n</div>\n</div>\n<div class=\"text-align-center alert alert-danger margin-top-10 col-sm-12\" ng-if=\"!$ctrl.contractLogs || !$ctrl.contractLogs.length\">\n<span>{{'log.noLogs' | translate}}</span>\n</div>\n</div>\n<div ng-if=\"$ctrl.loading\" class=\"col-sm-12 spinner_design\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n</div>\n</div>\n</div>\n<div ng-if=\"$ctrl.errorMessage && $ctrl.selectedTab === 'rules'\" class=\"col-sm-12 margin-10\">\n<span class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': $ctrl.errorMessage}\" style=\"margin-bottom: 0px;\"> {{$ctrl.errorMessage}}</span>\n</div>\n<div ng-if=\"($ctrl.requiredStartDate && !$ctrl.model.contractStartDate) || (!$ctrl.model.contractStartDate) && !$ctrl.loading && $ctrl.selectedTab === 'rules'\" class=\"col-sm-12 margin-10\">\n<span class=\"col-sm-12 alert text-center\" ng-class=\"{'alert-danger': ($ctrl.requiredStartDate && !$ctrl.model.contractStartDate) || (!$ctrl.model.contractStartDate)}\" style=\"margin-bottom: 0px;\"> {{$ctrl.startDateErrorMessage}}</span>\n</div>\n<div class=\"col-sm-12 margin-10\">\n<span class=\"col-sm-12 alert-info alert text-center\" ng-if=\"$ctrl.mainFormChanged && $ctrl.selectedTab === 'rules'\" style=\"margin-bottom: 0px;\">\n<span class=\"glyphicon glyphicon-info-sign\"></span>\nData has been modified. Please ensure you save your changes to preserve them.\n</span>\n</div>\n<div class=\"col-sm-12 margin-10 margin-bottom-20\" ng-if=\"$ctrl.selectedTab === 'rules'\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.isInvalidForm() || !$ctrl.validateBillingRuleFormControl() || !$ctrl.isBailmentInterestValid() || $ctrl.showBillingWarning === true\" ng-class=\"{'disabled': $ctrl.loading}\">\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset();$ctrl.mainFormChanged = false; $ctrl.showBillingWarning = false\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n</div>\n<style>\n.uib-timepicker .hours .ng-valid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t\t/* display: none; */\n\t}\n\n\t.uib-timepicker .hours .ng-invalid {\n\t\tpointer-events: none;\n\t\tbackground: gainsboro;\n\t\t/* display: none; */\n\t}\n\n\t.enable-hour-input .uib-timepicker .hours .ng-valid {\n\t\tpointer-events: visibleFill !important;\n\t\tbackground-color: #DFF5DF !important;\n    \tborder-color: #BEEBBE !important;\n\t}\n\n\t.enable-hour-input .uib-timepicker .hours .ng-invalid {\n\t\tpointer-events: visibleFill !important;\n\t\tbackground-color: #F9E3E3 !important;\n\t\tborder-color: #F4C6C6 !important;\n\t}\n\n\t/* .horizontal-padding-10 {\n        padding: 0px 29px;\n    } */\n</style>\n";
var id1="contract.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2803 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"print-history-css-section container-fluid col-sm-12 remove-left-pad remove-right-pad\">\n<h2 class=\"text-center\">{{'contract.updateContractHistory' | translate}}</h2>\n<div class=\"col-sm-12 remove-right-pad\">\n<h5 class=\"margin-right-10 font-size-16 pull-right\">\n<span class=\"bold-font\">{{'contract.contract' | translate}}:</span>\n{{$ctrl.model.history.contractDetails.contractId}} | {{$ctrl.model.history.contractDetails.contractName}}\n</h5>\n</div>\n<table class=\"table table-hover table-striped table-bordered table-pad-7 margin-top-05\">\n<thead>\n<tr>\n<th>{{'contract.contractRulesId'| translate}}</th>\n<th>{{'billableEvents.event' | translate}}</th>\n<th>{{'branch_mgmt.bypass_code_user.title' | translate}}</th>\n<th>{{'common.entry_time'| translate}}</th>\n<th>{{'printHistory.extraDetails' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"log in $ctrl.model.history.results\">\n<td>{{$ctrl.flexibleObjectParser(log.extraDetails).contractRulesId}}</td>\n<td>{{$ctrl.translateEntryType(log.entryType)}}</td>\n<td>{{log.user.firstName}} {{log.user.lastName}}</td>\n<td>{{log.entryTime | date: 'yyyy-MM-dd | hh:mm a'}}</td>\n<td>\n<div class=\"extra-details-container\">\n{{$ctrl.flexibleObjectParser(log.extraDetails)}}\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>";
var id1="print_history.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2804 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"_col-sm-12\">\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'contractType.all_contract_type' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.model.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.contractTypeObj.loading\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.contractTypeObj.totalRecords > 0 && !$ctrl.model.contractTypeObj.loading\">\n<ul class=\"remove-bottom-pad list-group\">\n<li class=\"list-group-item\" ng-repeat=\"contractType in $ctrl.model.contractTypeObj.contractTypeList track by $index\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{contractType.type}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\"></div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(contractType)\" uib-tooltip=\"{{ 'common.Edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<div class=\"col-sm-12 remove-left-pad margin-10\">\n<ul class=\"margin-10\" uib-pagination total-items=\"$ctrl.model.contractTypeObj.totalRecords\" ng-hide=\"{{($ctrl.model.contractTypeObj.totalRecords<=$ctrl.model.pagination.pageLimit)&&($ctrl.model.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 text-align-center alert alert-danger\" ng-if=\"($ctrl.model.contractTypeObj.totalRecords === 0 && !$ctrl.model.contractTypeObj.loading)\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>";
var id1="contract_type.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2805 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"contract_type.all\" ng-click=\"$ctrl.goToAll()\"><a>{{'contractType.all_contract_type' | translate}}</a></li>\n<li role=\"presentation\" ui-sref-active=\"active\" ng-show=\"$ctrl.hasACL['create']\" ui-sref=\"contract_type.create\">\n<a>{{'contractType.create_contract_type' | translate}}</a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="contract_type.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2806 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"contractType.new_contract_type\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"name\">{{'contractType.menu.title' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.type\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<textarea cols=\"30\" rows=\"3\" ng-model=\"$ctrl.model.description\" class=\"form-control\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || $ctrl.model.isCreate\">\n<span ng-if=\"$ctrl.model.isCreate\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-disabled=\"$ctrl.model.isCreate\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</div>\n</form>\n</div>";
var id1="contract_type.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2807 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"contractType.edit_title\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-6\">\n<label for=\"categoryId\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"categoryId\" placeholder=\"\" disabled=\"disabled\" ng-model=\"$ctrl.model.id\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"name\">{{'contractType.menu.title' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.type\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate}}</label>\n<textarea cols=\"30\" rows=\"3\" ng-model=\"$ctrl.model.description\" class=\"form-control\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.model.errorMessage\" ng-bind-html=\"$ctrl.model.errorMessage\"></div>\n<button type=\"button\" ng-click=\"$ctrl.update(this)\" class=\"btn btn-primary\" ng-disabled=\"$ctrl.model.isUpdating || Form.$invalid || $ctrl.loading\">\n<span ng-if=\"$ctrl.model.isCreate\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-disabled=\"$ctrl.model.isUpdating || $ctrl.loading\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</div>\n</form>\n</div>";
var id1="contract_type.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2808 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'customer.all_customers' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'customer.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n<div class=\"form-group\">\n<select id=\"userStatus\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl._status\" ng-change=\"$ctrl.search()\" ng-options=\"status.value as status.label for status in $ctrl.userStatus\">\n</select>\n</div>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.customers && $ctrl.customers.length\">\n<ul class=\"customer-change-history list-group\">\n<li class=\"list-group-item\" ng-repeat=\"customer in $ctrl.customers track by customer.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"padding-left-10\">\n<button id=\"expand-btn-{{customer.id}}\" class=\"btn btn-xs btn-secondary\" ng-click=\"customer.expanded = !customer.expanded; $ctrl.toggleExpand(customer); $ctrl.resetSearchText(customer);\n\t\t\t\t\t\t\t\t\t\t $ctrl.setLocationHistoryPage(customer.expanded, customer.id); $ctrl.getCustomerLocationHistory(customer, $event)\" expand>\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-triangle-right': !customer.expanded, 'glyphicon-triangle-bottom': customer.expanded}\"></span>\n</button>\n</div>\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{customer.id}} | {{customer.name}} | Last Updated ({{customer.updatedAt | date: 'MM-dd-yyyy | hh:mm a'}})\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"remove-right-pad icon-padding-05 btn-group\">\n<span class=\"badge badge-light customer-location-suspended-history-badge cursor-pointer\" uib-tooltip=\"{{'shipmentBatch.locationSuspended' | translate}}\" tooltip-placement=\"top-left\" ng-click=\"$ctrl.locationHistoryFn(customer, $event)\">\n{{customer.suspendedLocations}}</span>\n</div>\n<div class=\"remove-right-pad icon-padding-05 btn-group\">\n<span class=\"badge badge-light customer-location-history-badge cursor-pointer\" uib-tooltip=\"{{'customer.location_active' | translate}}\" tooltip-placement=\"top-left\" ng-click=\"$ctrl.locationHistoryFn(customer, $event)\">\n{{customer.activeLocations}}</span>\n</div>\n<div class=\"icon-padding-05 btn-group\">\n<span class=\"badge badge-light customer-contract-history-badge cursor-pointer\" uib-tooltip=\"{{'customer.contracts' | translate}}\" tooltip-placement=\"top-left\" ng-click=\"$ctrl.contractHistoryFn(customer, $event)\">\n{{customer.totalContracts}}\n</span>\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(customer);\" uib-tooltip=\"{{ 'customer.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"customer.expand && $ctrl.currentStats[customer.id] === $ctrl.customerHistoryStats.locations\" ng-class=\"{'table-margin-bottom-09' : customer.expanded && !$ctrl.customerLocationHistoryObj.history[customer.id].process && !$ctrl.customerLocationHistoryObj.history[customer.id].details.results.length}\">\n<hr class=\"remove-bottom-margin margin-10\"/>\n<div class=\"customer-location-history-bg remove-left-pad remove-right-pad col-sm-12 _margin-10\" ng-if=\"!$ctrl.customerLocationHistoryObj.history[customer.id].process\">\n<div class=\"margin-top-04 col-sm-6\">\n<div class=\"icon-padding-05 btn-group\">\n<span class=\"text-color-white\"><b>{{'location.menu.title' | translate}}</b></span>\n<span class=\"badge badge-light customer-location-history-badge\" uib-tooltip=\"{{'location.pending_changes' | translate}}\">\n{{$ctrl.customerLocationHistoryObj.history[customer.id].details.totalRecords}}\n</span>\n</div>\n</div>\n<div class=\"col-sm-6 pull-right customer-search-and-export-section\">\n<div class=\"margin-top-03\">\n<input type=\"text\" class=\"form-control customer-search-box-height\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.customerLocationHistoryObj.extraDetails[customer.id].searchText\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.searchLocationHistory(customer, $event)\">\n</div>\n<div class=\"_form-group text-padding-05\" ng-if=\"$ctrl.customerLocationHistoryObj.history[customer.id].details.totalRecords > 0\">\n<button type=\"button\" id=\"export-btn-other\" class=\"btn btn-sm font-size-20 customer-export-location\" ng-click=\"$ctrl.exportCustomerLocationHistory(customer)\" ng-disabled=\"$ctrl.customerLocationHistoryObj.extraDetails[customer.id].isExport\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.customerLocationHistoryObj.extraDetails[customer.id].isExport\"></span>\n<span class=\"glyphicon glyphicon-download\"></span>\n{{'location.menu.title' | translate}}</button>\n</div>\n<div class=\"_form-group text-padding-05\" ng-if=\"customer.billToContractTransportId !== null\">\n<button type=\"button\" id=\"export-btn-other\" class=\"btn btn-sm font-size-20 customer-export-location\" ng-click=\"$ctrl.exportCustomerLocationBillingRule(customer)\" ng-disabled=\"$ctrl.customerLocationHistoryObj.extraDetails[customer.id].isExportCustomerBillingRule\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" ng-if=\"$ctrl.customerLocationHistoryObj.extraDetails[customer.id].isExportCustomerBillingRule\"></span>\n<span class=\"glyphicon glyphicon-download\"></span>\n{{'contract.billing_rule' | translate}}</button>\n</div>\n</div>\n</div>\n<div class=\"remove-right-pad remove-left-pad col-sm-12 margin-top-02\">\n<table class=\"table-pad-3 table table-condensed table-bordered _table-margin-bottom-0\" ng-class=\"{'table-margin-bottom-09' : customer.expanded}\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.customerLocationHistoryObj.history[customer.id].process\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</div>\n<div class=\"location-history-alert-section\" ng-if=\"!$ctrl.customerLocationHistoryObj.history[customer.id].process && !$ctrl.customerLocationHistoryObj.history[customer.id].details.results.length\">\n<div class=\"col-sm-12 alert alert-danger text-center remove-bottom-margin\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<tbody ng-if=\"!$ctrl.customerLocationHistoryObj.history[customer.id].process && $ctrl.customerLocationHistoryObj.history[customer.id].details.results.length\">\n<tr class=\"header-row\">\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('locationId', customer, $event)\">\n{{'common.locationId' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationId'}\"></span>\n</th>\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('locationName', customer, $event)\">\n{{'location.location' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationName'}\"></span>\n</th>\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('locationType', customer, $event)\">\n{{'location.locationType' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'locationType'}\"></span>\n</th>\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('branchId', customer, $event)\">\n{{'location.branch' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'branchId'}\"></span>\n</th>\n<th class=\"text-center contents-no-wrap\">{{'billableEvents.location_distance' | translate}}</th>\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('address', customer, $event)\">\n{{'setup.address' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'address'}\"></span>\n</th>\n</tr>\n<tr ng-repeat=\"history in $ctrl.customerLocationHistoryObj.history[customer.id].details.results track by $index\">\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(history.locationId)\">\n<span class=\"cursor-pointer remove-white-space\" tooltip-placement=\"top-left\">{{history.locationId}}\n<span ng-if=\"history.active == 0\" style=\"color: #a94442;\"> ({{'common.suspended' | translate}})</span>\n</span>\n</a>\n</td>\n<td class=\"text-center\">{{history.locationName}}</td>\n<td class=\"text-center\">\n<img ng-src=\"{{$ctrl.loadLocationTypeImage(history.locationType)}}\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{history.locationType}}\"/>\n</td>\n<td class=\"text-center\">{{history.branchId}}</td>\n<td class=\"text-center\">\n<span ng-if=\"history.locationDistanceName\">{{history.locationDistanceName}}</span>\n<span ng-if=\"!history.locationDistanceName\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-center\">{{history.address}}</td>\n</tr>\n</tbody>\n<tfoot ng-if=\"!$ctrl.customerLocationHistoryObj.history[customer.id].process && $ctrl.customerLocationHistoryObj.history[customer.id].details.results.length\n\t\t\t\t\t\t\t\t\t\t\t   && $ctrl.customerLocationHistoryObj.history[customer.id].details.totalRecords>$ctrl.customerLocationHistoryObj.history[customer.id].details.pageLimit\">\n<tr>\n<td class=\"location-history-pagination-section\" colspan=\"5\">\n<ul ng-model=\"$ctrl.customerLocationHistoryObj.extraDetails[customer.id].page\" uib-pagination total-items=\"$ctrl.customerLocationHistoryObj.history[customer.id].details.totalRecords\" ng-hide=\"{{($ctrl.customerLocationHistoryObj.history[customer.id].details.totalRecords<=$ctrl.customerLocationHistoryObj.history[customer.id].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.getCustomerLocationHistory(customer, $event)\" max-size=\"10\">\n</ul>\n</td>\n</tr>\n</tfoot>\n</table>\n</div>\n</div>\n<div class=\"row\" ng-class=\"{'table-margin-bottom-09' : customer.expanded && !$ctrl.customerContractHistoryObj.history[customer.id].process && !$ctrl.customerContractHistoryObj.history[customer.id].details.results.length}\" ng-show=\"customer.expand && $ctrl.currentStats[customer.id] === $ctrl.customerHistoryStats.contracts\">\n<hr class=\"remove-bottom-margin margin-10\"/>\n<div class=\"customer-contract-history-bg remove-left-pad remove-right-pad col-sm-12 _margin-10\" ng-if=\"!$ctrl.customerContractHistoryObj.history[customer.id].process\">\n<div class=\"margin-top-02 col-sm-6\">\n<div class=\"icon-padding-05 btn-group\">\n<span class=\"text-color-white\"><b>{{'contract.menu.title' | translate}}</b></span>\n<span class=\"badge badge-light customer-contract-history-badge\" uib-tooltip=\"{{'location.pending_changes' | translate}}\">\n{{$ctrl.customerContractHistoryObj.history[customer.id].details.totalRecords}}\n</span>\n</div>\n</div>\n<div class=\"margin-top-04 col-sm-3 pull-right\">\n<div class=\"_form-group\">\n<input type=\"text\" class=\"form-control txt-input-height-25\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.customerContractHistoryObj.extraDetails[customer.id].searchText\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.searchContractHistory(customer, $event)\">\n</div>\n</div>\n</div>\n<div class=\"remove-right-pad remove-left-pad col-sm-12 margin-top-02\">\n<table class=\"table-pad-3 table table-condensed table-bordered _table-margin-bottom-0\" ng-class=\"{'table-margin-bottom-09' : customer.expanded}\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.customerContractHistoryObj.history[customer.id].process\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</div>\n<div class=\"location-history-alert-section\" ng-if=\"!$ctrl.customerContractHistoryObj.history[customer.id].process && !$ctrl.customerContractHistoryObj.history[customer.id].details.results.length\">\n<div class=\"col-sm-12 alert alert-danger text-center remove-bottom-margin\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<tbody ng-if=\"!$ctrl.customerContractHistoryObj.history[customer.id].process && $ctrl.customerContractHistoryObj.history[customer.id].details.results.length\">\n<tr class=\"header-row\">\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('contractId', customer, $event)\">\n{{'contract.contractId' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'contractId'}\"></span>\n</th>\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('contractStatus', customer, $event)\">\n{{'customer.status' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'contractStatus'}\"></span>\n</th>\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('billingCategory', customer, $event)\">\n{{'billableEvents.billing_category' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'billingCategory'}\"></span>\n</th>\n<th class=\"text-center contents-no-wrap\" ng-click=\"$ctrl.sortData('updatedAt', customer, $event)\">\n{{'customer.date_associated' | translate}}\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'updatedAt'}\"></span>\n</th>\n</tr>\n<tr ng-repeat=\"history in $ctrl.customerContractHistoryObj.history[customer.id].details.results\">\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToContractHistory(history.contractId)\">\n<span class=\"cursor-pointer\" tooltip-placement=\"top-left\">{{history.contractId}}</span>\n</a>\n</td>\n<td class=\"text-center\">\n<span class=\"text-success\" ng-if=\"history.contractStatus\">{{'customer_types.active' | translate}}</span>\n<span class=\"text-danger\" ng-if=\"!history.contractStatus\">{{'common.suspended' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"history.billingCategory.length\" ng-repeat=\"billingCategory in history.billingCategory track by $index\">\n<span>{{billingCategory}}<span ng-if=\"$index + 1 !== history.billingCategory.length\">,</span></span>\n</span>\n<span ng-if=\"!history.billingCategory.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n<td class=\"text-center\">\n{{history.updatedAt | date: 'MM-dd-yyyy'}}\n</td>\n</tr>\n</tbody>\n<tfoot ng-if=\"!$ctrl.customerContractHistoryObj.history[customer.id].process && $ctrl.customerContractHistoryObj.history[customer.id].details.results.length\n\t\t\t\t\t\t\t\t\t\t\t   && $ctrl.customerContractHistoryObj.history[customer.id].details.totalRecords>$ctrl.customerContractHistoryObj.history[customer.id].details.pageLimit\">\n<tr>\n<td class=\"location-history-pagination-section\" colspan=\"5\">\n<ul ng-model=\"$ctrl.customerContractHistoryObj.extraDetails[customer.id].page\" uib-pagination total-items=\"$ctrl.customerContractHistoryObj.history[customer.id].details.totalRecords\" ng-hide=\"{{($ctrl.customerContractHistoryObj.history[customer.id].details.totalRecords<=$ctrl.customerContractHistoryObj.history[customer.id].details.pageLimit)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-change=\"$ctrl.getCustomerLocationHistory(customer, $event)\" max-size=\"10\">\n</ul>\n</td>\n</tr>\n</tfoot>\n</table>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.customers || !$ctrl.customers.length) && !$ctrl.loading\">\n<span>{{'customer.noCustomers' | translate}}</span>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>";
var id1="customer.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2809 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<h4>{{'customer.contractOverrides' | translate }}</h4>\n<table class=\"table table-striped table-bordered\">\n<thead>\n<th>{{'customer.serviceOption' | translate }}</th>\n<th>{{'customer.unitBasis' | translate }}</th>\n<th>{{'customer.unitRate' | translate }}</th>\n<th>{{'customer.billToCategory' | translate }}</th>\n<th>{{'customer.actions' | translate }}</th>\n</thead>\n<tbody>\n<tr ng-repeat=\"unitBasisOption in $ctrl.selectedUnitBasisOptions\">\n<td>\n<div>\n<select class=\"form-control\" ng-model=\"unitBasisOption.serviceName\" ng-options=\"item as item.label for item in $ctrl.serviceOptions track by item.key\" ng-change=\"$ctrl.unitBasisOptionChanged(unitBasisOption, $index)\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">{{'common.none' | translate }}</option>\n</select>\n</div>\n</td>\n<td>\n<select class=\"form-control\" ng-model=\"$ctrl.model[unitBasisOption.models.basis]\" ng-options=\"option.value as option.label for option in unitBasisOption.options\" ng-disabled=\"!unitBasisOption.models\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">{{'common.select' | translate }}</option>\n</select>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model[unitBasisOption.models.rate]\" ng-disabled=\"!unitBasisOption.models || $ctrl.isNoneSelected(unitBasisOption)\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"/>\n</td>\n<td>\n<select class=\"form-control\" ng-model=\"$ctrl.model[unitBasisOption.models.billToCategory]\" ng-options=\"option.value as option.label for option in $ctrl.billToCategoryOptions\" ng-disabled=\"!unitBasisOption.models\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">{{'common.select' | translate }}</option>\n</select>\n</td>\n<td>\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeUnitBasisOption($index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.addUnitBasisOption()\">{{'setup.new' | translate }}</button>";
var id1="service_option.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2810 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"customer.create_customer\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"row_ remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"name\">{{'customer.name' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"name\" placeholder=\"{{'customer.name' | translate }}\" ng-model=\"$ctrl.model.name\">\n<span ng-if=\"$ctrl.errors.name\" class=\"text-danger\">{{$ctrl.errors['name']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"accounting-id\">{{'customer.accountingId' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"accounting-id\" placeholder=\"{{'customer.accountingId' | translate }}\" ng-model=\"$ctrl.model.accountingId\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"status\">{{'customer.status' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n<span ng-if=\"$ctrl.errors.status\" class=\"text-danger\">{{$ctrl.errors['status']}}</span>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"form-group col-sm-6\">\n<label for=\"billing-address\">{{'customer.billing' | translate }} {{'customer.address' | translate }} *</label>\n<textarea required class=\"form-control\" rows=\"3\" id=\"billing-address\" placeholder=\"{{'customer.address' | translate }}\" ng-model=\"$ctrl.model._address\" autocomplete=\"off\"></textarea>\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"billing-address-2\">{{'customer.billing' | translate }} {{'customer.address' | translate }} 2</label>\n<textarea class=\"form-control\" rows=\"3\" id=\"billing-address-2\" ng-model=\"$ctrl.model._address2\" autocomplete=\"off\"></textarea>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-city\">{{'customer.billing' | translate }} {{'customer.city' | translate }} *</label>\n<input required class=\"form-control\" rows=\"3\" id=\"billing-city\" ng-model=\"$ctrl.model._city\" placeholder=\"{{'customer.city' | translate }}\"/>\n<span ng-if=\"$ctrl.errors.billing-city\" class=\"text-danger\">{{$ctrl.errors['billing-city']}}</span>\n</div>\n<div class=\"_form-group col-sm-4\">\n<label for=\"billing-state\">{{'customer.billing' | translate }} {{'customer.state' | translate }} *</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model._state\" ng-options=\"billingState for billingState in $ctrl.states\" ng-required=\"true\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n<span ng-if=\"$ctrl.errors.billing-state\" class=\"text-danger\">{{$ctrl.errors['billing-state']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-zip\">{{'customer.billing' | translate }} {{'customer.zip' | translate }} *</label>\n<input required class=\"form-control\" rows=\"3\" id=\"billing-zip\" ng-model=\"$ctrl.model._zip\" placeholder=\"{{'customer.zip' | translate }}\" ng-pattern=\"/^\\d{5}(?:-\\d{4})?$/\"/>\n<span ng-if=\"$ctrl.errors.billing-zip\" class=\"text-danger\">{{$ctrl.errors['billing-zip']}}</span>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-poc\">{{'customer.billing' | translate }} {{'customer.POC' | translate }} *</label>\n<input required class=\"form-control\" rows=\"3\" id=\"billing-poc\" ng-model=\"$ctrl.model._POC\" placeholder=\"{{'customer.POC' | translate }}\"/>\n<span ng-if=\"$ctrl.errors.billing-poc\" class=\"text-danger\">{{$ctrl.errors['billing-poc']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-phone\">{{'customer.billing' | translate }} {{'customer.phone' | translate }} *</label>\n<input class=\"form-control\" rows=\"3\" id=\"billing-phone\" ng-model=\"$ctrl.model._phone\" required placeholder=\"{{'customer.phone' | translate }}\" ui-us-phone-number/>\n<span ng-if=\"$ctrl.errors.billing-phone\" class=\"text-danger\">{{$ctrl.errors['billing-phone']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-email\">{{'customer.billing' | translate }} {{'customer.email' | translate }} *</label>\n<input required class=\"form-control\" rows=\"3\" type=\"text\" id=\"billing-email\" ng-model=\"$ctrl.model._email\" placeholder=\"{{'customer.email' | translate }}\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\"/>\n<span ng-if=\"$ctrl.errors.billing-email\" class=\"text-danger\">{{$ctrl.errors['billing-email']}}</span>\n</div>\n</div>\n<div class=\"row_ remove-pad margin-10\">\n<div class=\"col-sm-12 margin-bottom-10 remove-left-pad\">\n<div class=\"remove-left-pad col-sm-12\">\n<h4>{{'customer.contractDetails' | translate }}</h4>\n</div>\n<div class=\"margin-top-04 _form-group col-sm-3\">\n<label class=\"pad-right-02\" for=\"servicePriority\">{{'customer.service_priority' | translate }}</label>\n<br/>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.servicePriority\" type=\"checkbox\"/>\n<span ng-if=\"$ctrl.errors.servicePriority\" class=\"text-danger\">{{$ctrl.errors['servicePriority']}}</span>\n</div>\n<div class=\"margin-top-04 _form-group col-sm-4\">\n<label class=\"pad-right-02\" for=\"onDemandPickup\">{{'customer.on_demand_pickups' | translate }}</label>\n<br/>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.inactive' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.onDemandPickup\" type=\"checkbox\"/>\n<span ng-if=\"$ctrl.errors.onDemandPickup\" class=\"text-danger\">{{$ctrl.errors['onDemandPickup']}}</span>\n</div>\n<div class=\"margin-top-04 _form-group col-sm-3 remove-pad-left\">\n<label class=\"pad-right-02\" for=\"billingStatus\">{{'customer.billing_status' | translate }}</label>\n<br/>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.inactive' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billingStatus\" type=\"checkbox\"/>\n<span ng-if=\"$ctrl.errors.billingStatus\" class=\"text-danger\">{{$ctrl.errors['billingStatus']}}</span>\n</div>\n<div class=\"margin-top-04 _form-group col-sm-2\">\n<label class=\"pad-right-02\" for=\"orderCutoff\">{{'customer.orderCutoff' | translate}}</label>\n<br/>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.orderCutoff\" ng-change=\"$ctrl.resetCustomerOrderLeadData()\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-12 margin-top-04 remove-left-pad\">\n<div class=\"_form-group col-sm-4\" ng-style=\"$ctrl.model.orderCutoff ? {'width': '20%'} : {}\">\n<label for=\"start-date\">{{'customer.startDate' | translate }}</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"$ctrl.model.effectiveDate\" ng-required=\"$ctrl.model.expirationDate\" date-format=\"dd-MMM-yyyy\" ng-click=\"$ctrl.isDisabledDate(date, mode)\" ng-class=\"{'required-datetimepicker': $ctrl.model.expirationDate && !$ctrl.model.effectiveDate}\" hidden-time=\"true\" show-button-bar=\"false\">\n</datetimepicker>\n</div>\n<div class=\"_form-group col-sm-4\" ng-style=\"$ctrl.model.orderCutoff ? {'width': '20%'} : {}\">\n<label for=\"end-date\">{{'customer.endDate' | translate }}</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"end-date\" ng-model=\"$ctrl.model.expirationDate\" date-format=\"dd-MMM-yyyy\" date-options=\"$ctrl.effectiveMinDate\" hidden-time=\"true\" ng-class=\"{'required-datetimepicker': $ctrl.model.effectiveDate && !$ctrl.model.expirationDate}\" show-button-bar=\"false\">\n</datetimepicker>\n</div>\n<div class=\"form-group col-sm-4\" ng-style=\"$ctrl.model.orderCutoff ? {'width': '20%'} : {}\">\n<label for=\"annual-increase\">{{'customer.annual_increase' | translate }} (%)</label>\n<input class=\"form-control\" rows=\"3\" id=\"annual-increase\" ng-model=\"$ctrl.model.annualIncrease\" ng-blur=\"$ctrl.ngPercentage()\" ng-focus=\"$ctrl.removePrecentageSign($ctrl.model.annualIncrease)\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\"/>\n</div>\n<div class=\"_form-group col-sm-2\" ng-style=\"$ctrl.model.orderCutoff ? {'width': '20%'} : {}\" ng-if=\"$ctrl.model.orderCutoff\">\n<label for=\"orderCutoffDays\">{{'customer.orderCutoffDays' | translate}}</label>\n<input type=\"number\" name=\"orderCutoffDays\" class=\"form-control\" id=\"orderCutoffDays\" min=\"1\" max=\"365\" step=\"1\" ng-model=\"$ctrl.model.orderCutoffDays\" ng-required=\"$ctrl.model.orderCutoff\"/>\n</div>\n<div class=\"_form-group col-sm-2\" ng-style=\"$ctrl.model.orderCutoff ? {'width': '20%'} : {}\" ng-if=\"$ctrl.model.orderCutoff\">\n<label for=\"orderCutoffTime\">{{'customer.orderCutoffTime' | translate}}</label>\n<time-picker id=\"orderCutoffTime\" ng-model=\"$ctrl.model.orderCutoffTime\" ng-required=\"$ctrl.model.orderCutoff\"></time-picker>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"service-email\">{{'customer.serviceEmail' | translate }}</label>\n<input class=\"form-control\" rows=\"3\" type=\"text\" id=\"service-email\" ng-model=\"$ctrl.model.serviceEmail\" placeholder=\"{{'customer.serviceEmail' | translate }}\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\"/>\n<span ng-if=\"$ctrl.errors.service-email\" class=\"text-danger\">{{$ctrl.errors['service-email']}}</span>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-12\">\n<div>\n<label for=\"service-schedule\">{{'customer.serviceSchedule' | translate }}</label>\n</div>\n<div id=\"service-schedule\" class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.serviceSchedule\" ng-click=\"$ctrl.toggleDay(day)\" ng-class=\"{'btn-primary': $ctrl.isDaySelected(day),'btn-default': !$ctrl.isDaySelected(day)}\">\n{{day.label}}\n</a>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"remove-left-pad col-sm-12\">\n<div>\n<h4>{{'customer.surcharges' | translate}}</h4>\n</div>\n<div class=\"customer-surcharge-list\">\n<div class=\"customer-surcharge-item\" ng-repeat=\"type in $ctrl.surchargeTypeList track by type\" ng-class=\"{'col-sm-3': !$ctrl.model.surcharges[type].enabled, 'customer-surcharge-item-open': $ctrl.model.surcharges[type].enabled}\" ng-style=\"{order: $ctrl.model.surcharges[type].enabled ? $index : $index + $ctrl.surchargeTypeList.length}\">\n<div class=\"customer-surcharge-field\">\n<label>{{$ctrl.surchargeLabelKeys[type] | translate}}</label>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.surcharges[type].enabled\" type=\"checkbox\"/>\n</div>\n<div class=\"customer-surcharge-item-fields\" ng-if=\"$ctrl.model.surcharges[type].enabled\">\n<div class=\"customer-surcharge-field\">\n<label>%</label>\n<input class=\"form-control\" ng-model=\"$ctrl.model.surcharges[type].percentage\" ng-keypress=\"$ctrl.blockNonNumericKeypress($event)\" ng-required=\"$ctrl.model.surcharges[type].enabled\" pattern=\"(^100(\\.0+)?$)|(^[1-9][0-9]?(\\.[0-9]+)?$)|(^0?\\.[0-9]*[1-9][0-9]*$)\"/>\n</div>\n<div class=\"customer-surcharge-field\">\n<label>{{'customer.surcharge_interval' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.surcharges[type].interval\" ng-options=\"interval.value as interval.label for interval in $ctrl.intervalOptions\" ng-required=\"$ctrl.model.surcharges[type].enabled\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"customer-surcharge-field\">\n<label>{{'customer.surcharge_billing_events' | translate}}</label>\n<div class=\"remove-left-pad multi-select contract-location-multi-select-dd\" ng-class=\"{'valid-multi-select-value': $ctrl.model.surcharges[type].billingEvents.length, 'invalid-multi-select-value': !$ctrl.model.surcharges[type].billingEvents.length}\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.surcharges[type].billingEventOptions\" output-model=\"$ctrl.model.surcharges[type].billingEvents\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button-{{type}}\">\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"_margin-bottom-10 remove-left-pad col-sm-6\">\n<h4>{{'customer.contract_type_detail' | translate }}</h4>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-category\">{{'contractType.menu.title' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.contractType\" values=\"$ctrl.model.contractTypeObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.contractTypeObj.totalRecords\" onscroll=\"$ctrl.getContractType(searchKey, offset)\" none-selected=\"'checkinSelectionModal.select'\">\n</search-and-select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"pocName\">{{'carrier.POCName' | translate }}</label>\n<input class=\"form-control\" rows=\"3\" id=\"pocName\" ng-model=\"$ctrl.model.contractPocName\" placeholder=\"{{'carrier.POCName' | translate }}\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\"/>\n<span ng-if=\"$ctrl.errors.pocName\" class=\"text-danger\">{{$ctrl.errors['pocName']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"pocEmail\">{{'carrier.POCEmail' | translate }}</label>\n<input type=\"email\" class=\"form-control\" rows=\"3\" id=\"pocEmail\" ng-model=\"$ctrl.model.contractPocEmail\" placeholder=\"{{'carrier.POCEmail' | translate }}\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\"/>\n<span ng-if=\"$ctrl.errors.pocEmail\" class=\"text-danger\">{{$ctrl.errors['pocEmail']}}</span>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"pocPhone\">{{'carrier.POCPhone' | translate }}</label>\n<input class=\"form-control\" rows=\"3\" id=\"pocPhone\" ng-model=\"$ctrl.model.contractPocPhone\" placeholder=\"{{'carrier.POCPhone' | translate }}\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\" ui-us-phone-number/>\n<span ng-if=\"$ctrl.errors.pocPhone\" class=\"text-danger\">{{$ctrl.errors['pocPhone']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-address\">{{'customer.address' | translate }}</label>\n<textarea class=\"form-control\" rows=\"1\" id=\"billing-address\" placeholder=\"{{'customer.address' | translate }}\" ng-model=\"$ctrl.model.contractAddress\" autocomplete=\"off\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\"></textarea>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"city\">{{'customer.city' | translate }}</label>\n<input class=\"form-control\" rows=\"3\" id=\"city\" ng-model=\"$ctrl.model.contractCity\" placeholder=\"{{'customer.city' | translate }}\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\"/>\n<span ng-if=\"$ctrl.errors.city\" class=\"text-danger\">{{$ctrl.errors['city']}}</span>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"state\">{{'customer.state' | translate }}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.contractState\" ng-options=\"state for state in $ctrl.states\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n<span ng-if=\"$ctrl.errors.state\" class=\"text-danger\">{{$ctrl.errors['state']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"zip\">{{'customer.zip' | translate }}</label>\n<input class=\"form-control\" rows=\"3\" id=\"zip\" ng-model=\"$ctrl.model.contractZip\" placeholder=\"{{'customer.zip' | translate }}\" ng-pattern=\"/^\\d{5}(?:-\\d{4})?$/\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\"/>\n<span ng-if=\"$ctrl.errors.zip\" class=\"text-danger\">{{$ctrl.errors['zip']}}</span>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"billing-category\">{{'customer.payment_method' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.paymentMethod\" ng-options=\"paymentMethod.value as paymentMethod.label for paymentMethod in $ctrl.paymentMethodList\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"_margin-bottom-10 remove-left-pad col-sm-6\">\n<h4>{{'customer.contractDocuments' | translate }}</h4>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-12\">\n<button type=\"button\" class=\"col-sm-6 btn btn-primary w-100\" ng-click=\"$ctrl.uploadContractDocuments('create')\">{{'customer.upload_file' | translate}}\n<span class=\"badge documents-count-badge cursor-pointer\">{{$ctrl.model.selectedFiles.length}}</span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad\" style=\"padding-top: 15px\">\n<div class=\"remove-left-pad remove-right-pad margin-bottom-10 col-sm-12\">\n<div class=\"remove-left-pad col-sm-6\">\n<h4>{{'customer.billing_category_contract_mapping' | translate}}</h4>\n</div>\n<div id=\"inline\" class=\"text-right form-group col-sm-6 checkbox pull-right\">\n<label>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameForAll()\" ng-model=\"$ctrl.model.sameForAll\"/>\n<strong>{{'location.sameForAll' | translate }}</strong>\n</label>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-transport\">{{'customer.transport' | translate }}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractTransportId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractTransportId && !$ctrl.billingCategoryObj['billToContractTransportId'].process\">\n{{$ctrl.billingCategoryObj['billToContractTransportId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractTransportId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.transport)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractTransportStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractTransportId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractTransportId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.transport)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractTransportStatus\"></search-and-select>\n</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-deposit\">{{'customer.deposit' | translate }}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractDepositId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractDepositId && !$ctrl.billingCategoryObj['billToContractDepositId'].process\">\n{{$ctrl.billingCategoryObj['billToContractDepositId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractDepositId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.deposit)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractDepositStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractDepositId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractDepositId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.deposit)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractDepositStatus\"></search-and-select>\n</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-change-order\">{{'customer.changeOrder' | translate }}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractChangeOrderId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractChangeOrderId && !$ctrl.billingCategoryObj['billToContractChangeOrderId'].process\">\n{{$ctrl.billingCategoryObj['billToContractChangeOrderId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractChangeOrderId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.changeOrder)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractChangeOrderStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractChangeOrderId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractChangeOrderId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.changeOrder)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractChangeOrderStatus\"></search-and-select>\n</span>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-transport\">{{'entry_type.atm-service' | translate }}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractATMServiceId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractATMServiceId && !$ctrl.billingCategoryObj['billToContractATMServiceId'].process\">\n{{$ctrl.billingCategoryObj['billToContractATMServiceId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractATMServiceId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.ATMService)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractATMServiceStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractATMServiceId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractATMServiceId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.ATMService)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractATMServiceStatus\"></search-and-select>\n</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-deposit\">{{'customer.cash_handling' | translate}}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractCashHandlingId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractCashHandlingId && !$ctrl.billingCategoryObj['billToContractCashHandlingId'].process\">\n{{$ctrl.billingCategoryObj['billToContractCashHandlingId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractCashHandlingId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.cashHandling)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractCashHandlingStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractCashHandlingId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractCashHandlingId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.cashHandling)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractCashHandlingStatus\"></search-and-select>\n</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-change-order\">{{'customer.repair_maintenance' | translate}}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractMaintenanceId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractMaintenanceId && !$ctrl.billingCategoryObj['billToContractMaintenanceId'].process\">\n{{$ctrl.billingCategoryObj['billToContractMaintenanceId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractMaintenanceId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.maintenance)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractMaintenanceStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractMaintenanceId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractMaintenanceId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.maintenance)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractMaintenanceStatus\"></search-and-select>\n</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad margin-top-20\">\n<input type=\"checkbox\" ng-model=\"$ctrl.model.createNewLocation\"/>\n<label>{{ 'customer.createLocation' | translate }}</label>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.errorMessage\">\n<div class=\"form-group alert alert-danger\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n</div>\n<div class=\"margin-10 col-sm-12 margin-bottom-20\">\n<button type=\"button\" ng-click=\"$ctrl.addUnitBasisOption();$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || $ctrl.surchargeBillingEventsMissing($ctrl.model.surcharges)\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>\n";
var id1="customer.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2811 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"customer.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"customer.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"customer.create\">\n<a translate=\"customer.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-left-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="customer.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2812 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"customer.edit_customer\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12 _remove-pad\">\n<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"row\">\n<div class=\"_form-group col-sm-3\">\n<label for=\"customer-id\">{{'common.id' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"customer-id\" disabled=\"disabled\" placeholder=\"{{'common.id' | translate }}\" ng-model=\"$ctrl.model.id\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"_form-group col-sm-3\">\n<label for=\"name\">{{'customer.name' | translate }} *</label>\n<input class=\"form-control\" required rows=\"3\" id=\"name\" ng-model=\"$ctrl.model.name\"/>\n<span ng-if=\"$ctrl.errors.name\" class=\"text-danger\">{{$ctrl.errors['name']}}</span>\n</div>\n<div class=\"_form-group col-sm-3\">\n<label for=\"accounting-id\">{{'customer.accountingId' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"accounting-id\" placeholder=\"{{'customer.accountingId' | translate }}\" ng-model=\"$ctrl.model.accountingId\">\n</div>\n<div class=\"_form-group col-sm-3\">\n<label for=\"\">{{'customer.status' | translate }} *</label> <br>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.askToChange()\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n<span ng-if=\"$ctrl.errors.status\" class=\"text-danger\">{{$ctrl.errors['status']}}</span>\n</div>\n<div class=\"col-sm-3\">&nbsp;</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-6\">\n<label for=\"billing-address\">{{'customer.billing' | translate }} {{'customer.address' | translate }} *</label>\n<textarea class=\"form-control\" required rows=\"3\" id=\"billing-address\" placeholder=\"{{'customer.address' | translate }}\" ng-model=\"$ctrl.model._address\"></textarea>\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"billing-address-2\">{{'customer.billing' | translate }} {{'customer.address' | translate }} 2</label>\n<textarea class=\"form-control\" rows=\"3\" id=\"billing-address-2\" ng-model=\"$ctrl.model._address2\"></textarea>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-city\">{{'customer.billing' | translate }} {{'customer.city' | translate }} *</label>\n<input class=\"form-control\" required ng-model=\"$ctrl.model._city\" id=\"billing-city\" placeholder=\"{{'customer.city' | translate }}\"/>\n<span ng-if=\"$ctrl.errors.billing-city\" class=\"text-danger\">{{$ctrl.errors['billing-city']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-state\">{{'customer.billing' | translate }} {{'customer.state' | translate }} *</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model._state\" ng-options=\"billingState for billingState in $ctrl.states\" ng-required=\"true\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n<span ng-if=\"$ctrl.errors.billing-state\" class=\"text-danger\">{{$ctrl.errors['billing-state']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-zip\">{{'customer.billing' | translate }} {{'customer.zip' | translate }} *</label>\n<input class=\"form-control\" required ng-model=\"$ctrl.model._zip\" id=\"billing-zip\" placeholder=\"{{'customer.zip' | translate }}\" ng-pattern=\"/^\\d{5}(?:-\\d{4})?$/\"/>\n<span ng-if=\"$ctrl.errors.billing-zip\" class=\"text-danger\">{{$ctrl.errors['billing-zip']}}</span>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-poc\">{{'customer.billing' | translate }} {{'customer.POC' | translate }} *</label>\n<input class=\"form-control\" required ng-model=\"$ctrl.model._POC\" id=\"billing-poc\" placeholder=\"{{'customer.POC' | translate }}\"/>\n<span ng-if=\"$ctrl.errors.billing-poc\" class=\"text-danger\">{{$ctrl.errors['billing-poc']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-phone\">{{'customer.billing' | translate }} {{'customer.phone' | translate }} *</label>\n<input class=\"form-control\" required ng-model=\"$ctrl.model._phone\" id=\"billing-phone\" placeholder=\"{{'customer.phone' | translate }}\" ui-us-phone-number/>\n<span ng-if=\"$ctrl.errors.billing-phone\" class=\"text-danger\">{{$ctrl.errors['billing-phone']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-email\">{{'customer.billing' | translate }} {{'customer.email' | translate }} *</label>\n<input class=\"form-control\" required ng-model=\"$ctrl.model._email\" type=\"text\" id=\"billing-email\" placeholder=\"{{'customer.email' | translate }}\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\"/>\n<span ng-if=\"$ctrl.errors.billing-email\" class=\"text-danger\">{{$ctrl.errors['billing-email']}}</span>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-12 margin-bottom-10 remove-left-pad\">\n<div class=\"remove-left-pad col-sm-12\">\n<h4>{{'customer.contractDetails' | translate }}</h4>\n</div>\n<div class=\"margin-top-04 _form-group col-sm-3\">\n<label class=\"pad-right-02\" for=\"servicePriority\">{{'customer.service_priority' | translate }}</label>\n<br/>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.servicePriority\" type=\"checkbox\"/>\n<span ng-if=\"$ctrl.errors.servicePriority\" class=\"text-danger\">{{$ctrl.errors['servicePriority']}}</span>\n</div>\n<div class=\"margin-top-04 _form-group col-sm-4\">\n<label class=\"pad-right-02\" for=\"onDemandPickup\">{{'customer.on_demand_pickups' | translate }}</label>\n<br/>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.inactive' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.onDemandPickup\" type=\"checkbox\"/>\n<span ng-if=\"$ctrl.errors.onDemandPickup\" class=\"text-danger\">{{$ctrl.errors['onDemandPickup']}}</span>\n</div>\n<div class=\"margin-top-04 _form-group col-sm-3 remove-pad-left\">\n<label class=\"pad-right-02\" for=\"billingStatus\">{{'customer.billing_status' | translate }}</label>\n<br/>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.inactive' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billingStatus\" type=\"checkbox\"/>\n<span ng-if=\"$ctrl.errors.billingStatus\" class=\"text-danger\">{{$ctrl.errors['billingStatus']}}</span>\n</div>\n<div class=\"margin-top-04 _form-group col-sm-2\">\n<div>\n<label class=\"pad-right-02\" for=\"orderCutoff\">{{'customer.orderCutoff' | translate}}</label>\n<br/>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.orderCutoff\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"row_ remove-pad\">\n<div class=\"remove-left-pad col-sm-12 margin-top-4\">\n<div class=\"_form-group col-sm-4\" ng-style=\"$ctrl.model.orderCutoff ? {'width': '20%'} : {}\">\n<label for=\"start-date\">{{'customer.startDate' | translate }}</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"start-date\" ng-model=\"$ctrl.model.effectiveDate\" date-format=\"dd-MMM-yyyy\" ng-click=\"$ctrl.isDisabledDate(date, mode)\" hidden-time=\"true\" ng-class=\"{'required-datetimepicker': $ctrl.model.expirationDate && !$ctrl.model.effectiveDate}\" show-button-bar=\"false\">\n</datetimepicker>\n</div>\n<div class=\"_form-group col-sm-4\" ng-style=\"$ctrl.model.orderCutoff ? {'width': '20%'} : {}\">\n<label for=\"end-date\">{{'customer.endDate' | translate }}</label>\n<datetimepicker class=\"datetimepicker-input\" id=\"end-date\" ng-model=\"$ctrl.model.expirationDate\" date-format=\"dd-MMM-yyyy\" date-options=\"$ctrl.effectiveMinDate\" ng-class=\"{'required-datetimepicker': $ctrl.model.effectiveDate && !$ctrl.model.expirationDate}\" hidden-time=\"true\" show-button-bar=\"false\">\n</datetimepicker>\n</div>\n<div class=\"form-group col-sm-4\" ng-style=\"$ctrl.model.orderCutoff ? {'width': '20%'} : {}\">\n<label for=\"annual-increase\">{{'customer.annual_increase' | translate }} (%)</label>\n<input class=\"form-control\" id=\"annual-increase\" ng-model=\"$ctrl.model.annualIncrease\" ng-blur=\"$ctrl.ngPercentage()\" ng-focus=\"$ctrl.removePrecentageSign($ctrl.model.annualIncrease)\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\"/>\n</div>\n<div class=\"_form-group col-sm-4\" ng-style=\"$ctrl.model.orderCutoff ? {'width': '20%'} : {}\" ng-if=\"$ctrl.model.orderCutoff\">\n<label class=\"pad-right-02\" for=\"orderCutoffDays\">{{'customer.orderCutoffDays' | translate}}</label>\n<input type=\"number\" class=\"form-control\" id=\"orderCutoffDays\" min=\"1\" max=\"365\" step=\"1\" ng-model=\"$ctrl.model.orderCutoffDays\" ng-required=\"$ctrl.model.orderCutoff\"/>\n</div>\n<div class=\"_form-group col-sm-4\" ng-style=\"$ctrl.model.orderCutoff ? {'width': '20%'} : {}\" ng-if=\"$ctrl.model.orderCutoff\">\n<label class=\"pad-right-02\" for=\"orderCutoffTime\">{{'customer.orderCutoffTime' | translate}}</label>\n<time-picker id=\"orderCutoffTime\" ng-model=\"$ctrl.model.orderCutoffTime\" ng-required=\"$ctrl.model.orderCutoff\"></time-picker>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"remove-left-pad col-sm-12 margin-top-4\">\n<div class=\"form-group col-sm-4\">\n<label for=\"service-email\">{{'customer.serviceEmail' | translate }}</label>\n<input class=\"form-control\" ng-model=\"$ctrl.model.serviceEmail\" type=\"text\" id=\"service-email\" placeholder=\"{{'customer.serviceEmail' | translate }}\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\"/>\n<span ng-if=\"$ctrl.errors.service-email\" class=\"text-danger\">{{$ctrl.errors['service-email']}}</span>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-12\">\n<div>\n<label for=\"service-schedule\">{{'customer.serviceSchedule' | translate }}</label>\n</div>\n<div id=\"service-schedule\" class=\"btn-group btn-group-justified\">\n<a class=\"btn\" ng-repeat=\"day in $ctrl.serviceSchedule\" ng-click=\"$ctrl.toggleDay(day)\" ng-class=\"{'btn-primary': $ctrl.isDaySelected(day),'btn-default': !$ctrl.isDaySelected(day)}\">\n{{day.label}}\n</a>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"remove-left-pad col-sm-12\">\n<div>\n<h4>{{'customer.surcharges' | translate}}\n<button type=\"button\" class=\"btn btn-primary btn-xs surcharge-history-button\" ng-click=\"$ctrl.openSurchargeHistory()\" ng-disabled=\"$ctrl.surchargeHistoryLoading\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.surchargeHistoryLoading ? 'glyphicon-refresh fast-right-spinner' : 'glyphicon-time'\"></i>\n{{'customer.surcharge_history' | translate}}\n</button>\n</h4>\n</div>\n<div class=\"customer-surcharge-list\">\n<div class=\"customer-surcharge-item\" ng-repeat=\"type in $ctrl.surchargeTypeList track by type\" ng-class=\"{'col-sm-3': !$ctrl.model.surcharges[type].enabled, 'customer-surcharge-item-open': $ctrl.model.surcharges[type].enabled}\" ng-style=\"{order: $ctrl.model.surcharges[type].enabled ? $index : $index + $ctrl.surchargeTypeList.length}\">\n<div class=\"customer-surcharge-field\">\n<label>{{$ctrl.surchargeLabelKeys[type] | translate}}</label>\n<input bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate}}\" switch-off-text=\"{{'common.no' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.surcharges[type].enabled\" type=\"checkbox\"/>\n</div>\n<div class=\"customer-surcharge-item-fields\" ng-if=\"$ctrl.model.surcharges[type].enabled\">\n<div class=\"customer-surcharge-field\">\n<label>%</label>\n<input class=\"form-control\" ng-model=\"$ctrl.model.surcharges[type].percentage\" ng-keypress=\"$ctrl.blockNonNumericKeypress($event)\" ng-required=\"$ctrl.model.surcharges[type].enabled\" pattern=\"(^100(\\.0+)?$)|(^[1-9][0-9]?(\\.[0-9]+)?$)|(^0?\\.[0-9]*[1-9][0-9]*$)\"/>\n</div>\n<div class=\"customer-surcharge-field\">\n<label>{{'customer.surcharge_interval' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.surcharges[type].interval\" ng-options=\"interval.value as interval.label for interval in $ctrl.intervalOptions\" ng-required=\"$ctrl.model.surcharges[type].enabled\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"customer-surcharge-field\">\n<label>{{'customer.surcharge_billing_events' | translate}}</label>\n<div class=\"remove-left-pad multi-select contract-location-multi-select-dd\" ng-class=\"{'valid-multi-select-value': $ctrl.model.surcharges[type].billingEvents.length, 'invalid-multi-select-value': !$ctrl.model.surcharges[type].billingEvents.length}\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.surcharges[type].billingEventOptions\" output-model=\"$ctrl.model.surcharges[type].billingEvents\" button-label=\"label\" item-label=\"label\" search-property=\"label\" tick-property=\"ticked\" directive-id=\"multi-select-button-{{type}}\">\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"_margin-bottom-10 remove-left-pad col-sm-6\">\n<h4>{{'customer.contract_type_detail' | translate }}</h4>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"billing-category\">{{'contractType.menu.title' | translate}} </label>\n<search-and-select ng-model=\"$ctrl.model.contractType\" values=\"$ctrl.model.contractTypeObj.results\" key=\"Key\" totalrecords=\"$ctrl.model.contractTypeObj.totalRecords\" onscroll=\"$ctrl.getContractType(searchKey, offset)\" none-selected=\"'checkinSelectionModal.select'\" on-click=\"$ctrl.handleCustomerContractData($ctrl.model.contractType)\">\n</search-and-select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"pocName\">{{'carrier.POCName' | translate }} </label>\n<input class=\"form-control\" rows=\"3\" id=\"pocName\" ng-model=\"$ctrl.model.contractPocName\" placeholder=\"{{'carrier.POCName' | translate }}\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\"/>\n<span ng-if=\"$ctrl.errors.pocName\" class=\"text-danger\">{{$ctrl.errors['pocName']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"pocEmail\">{{'carrier.POCEmail' | translate }} </label>\n<input type=\"email\" class=\"form-control\" rows=\"3\" id=\"pocEmail\" ng-model=\"$ctrl.model.contractPocEmail\" placeholder=\"{{'carrier.POCEmail' | translate }}\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\"/>\n<span ng-if=\"$ctrl.errors.pocEmail\" class=\"text-danger\">{{$ctrl.errors['pocEmail']}}</span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"pocPhone\">{{'carrier.POCPhone' | translate }} </label>\n<input class=\"form-control\" rows=\"3\" id=\"pocPhone\" ng-model=\"$ctrl.model.contractPocPhone\" placeholder=\"{{'carrier.POCPhone' | translate }}\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\" ui-us-phone-number/>\n<span ng-if=\"$ctrl.errors.pocPhone\" class=\"text-danger\">{{$ctrl.errors['pocPhone']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"billing-address\">{{'customer.address' | translate }} </label>\n<textarea class=\"form-control\" rows=\"1\" id=\"billing-address\" placeholder=\"{{'customer.address' | translate }}\" ng-model=\"$ctrl.model.contractAddress\" autocomplete=\"off\" ng-required=\"$ctrl.model.contractType !== null\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\"></textarea>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"city\">{{'customer.city' | translate }} </label>\n<input class=\"form-control\" rows=\"3\" id=\"city\" ng-model=\"$ctrl.model.contractCity\" placeholder=\"{{'customer.city' | translate }}\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\"/>\n<span ng-if=\"$ctrl.errors.city\" class=\"text-danger\">{{$ctrl.errors['city']}}</span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\">\n<label for=\"state\">{{'customer.state' | translate }} </label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.contractState\" ng-options=\"state for state in $ctrl.states\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n<span ng-if=\"$ctrl.errors.state\" class=\"text-danger\">{{$ctrl.errors['state']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"zip\">{{'customer.zip' | translate }} </label>\n<input class=\"form-control\" rows=\"3\" id=\"zip\" ng-model=\"$ctrl.model.contractZip\" placeholder=\"{{'customer.zip' | translate }}\" ng-pattern=\"/^\\d{5}(?:-\\d{4})?$/\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-required=\"$ctrl.model.contractType !== null\"/>\n<span ng-if=\"$ctrl.errors.zip\" class=\"text-danger\">{{$ctrl.errors['zip']}}</span>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"billing-category\">{{'customer.payment_method' | translate}} </label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.contractPaymentMethod\" ng-disabled=\"$ctrl.model.contractType === null || $ctrl.model.contractType === undefined\" ng-options=\"paymentMethod.value as paymentMethod.label for paymentMethod in $ctrl.paymentMethodList\" ng-required=\"$ctrl.model.contractType !== null\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"_margin-bottom-10 remove-left-pad col-sm-6\">\n<h4>{{'customer.contractDocuments' | translate }}</h4>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"col-sm-6\">\n<button type=\"button\" class=\"col-sm-6 btn btn-primary\" style=\"width: 100% !important;\" ng-click=\"$ctrl.uploadContractDocuments('edit')\">{{'customer.upload_file' | translate}}</button><span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-6\">\n<button type=\"button\" class=\"col-sm-6 btn btn-success\" style=\"width: 100% !important;\" ng-click=\"$ctrl.viewContractDocuments()\">{{'customer.view_document' | translate}}\n<span class=\"badge all-documents-count-badge cursor-pointer\" ng-model=\"$ctrl.model.totalContractDocuments\">{{$ctrl.model.totalContractDocuments}}</span>\n</button>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"remove-left-pad remove-right-pad margin-bottom-10 margin-top-05 col-sm-12\">\n<div class=\"remove-left-pad col-sm-6\">\n<h4>{{'customer.billing_category_contract_mapping' | translate}}</h4>\n</div>\n<div id=\"inline\" class=\"text-right form-group col-sm-6 checkbox pull-right\">\n<label>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameForAll()\" ng-model=\"$ctrl.model.sameForAll\"/>\n<strong>{{'location.sameForAll' | translate }}</strong>\n</label>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-transport\">{{'customer.transport' | translate }}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractTransportId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractTransportId && !$ctrl.billingCategoryObj['billToContractTransportId'].process\">\n{{$ctrl.billingCategoryObj['billToContractTransportId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractTransportId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.transport)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractTransportStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractTransportId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractTransportId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.transport)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractTransportStatus\"></search-and-select>\n</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-deposit\">{{'customer.deposit' | translate }}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractDepositId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractDepositId && !$ctrl.billingCategoryObj['billToContractDepositId'].process\">\n{{$ctrl.billingCategoryObj['billToContractDepositId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractDepositId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.deposit)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractDepositStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractDepositId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractDepositId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.deposit)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractDepositStatus\"></search-and-select>\n</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-change-order\">{{'customer.changeOrder' | translate }}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractChangeOrderId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractChangeOrderId && !$ctrl.billingCategoryObj['billToContractChangeOrderId'].process\">\n{{$ctrl.billingCategoryObj['billToContractChangeOrderId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractChangeOrderId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.changeOrder)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractChangeOrderStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractChangeOrderId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractChangeOrderId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.changeOrder)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractChangeOrderStatus\"></search-and-select>\n</span>\n</div>\n</div>\n</div>\n<div class=\"row_ remove-pad\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-transport\">{{'entry_type.atm-service' | translate }}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractATMServiceId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractATMServiceId && !$ctrl.billingCategoryObj['billToContractATMServiceId'].process\">\n{{$ctrl.billingCategoryObj['billToContractATMServiceId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractATMServiceId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.ATMService)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractATMServiceStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractATMServiceId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractATMServiceId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.ATMService)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractATMServiceStatus\"></search-and-select>\n</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-deposit\">{{'customer.cash_handling' | translate}}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractCashHandlingId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractCashHandlingId && !$ctrl.billingCategoryObj['billToContractCashHandlingId'].process\">\n{{$ctrl.billingCategoryObj['billToContractCashHandlingId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractCashHandlingId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.cashHandling)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractCashHandlingStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractCashHandlingId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractCashHandlingId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.cashHandling)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractCashHandlingStatus\"></search-and-select>\n</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<span>\n<label for=\"btc-change-order\">{{'customer.repair_maintenance' | translate}}</label>\n</span>\n<span class=\"badge badge-light location-history-badge cursor-pointer\" uib-tooltip=\"{{$ctrl.billingCategoryObj['billToContractMaintenanceId'].details.billingEvent}}\" tooltip-placement=\"top-left\" ng-if=\"$ctrl.model.billToContractMaintenanceId && !$ctrl.billingCategoryObj['billToContractMaintenanceId'].process\">\n{{$ctrl.billingCategoryObj['billToContractMaintenanceId'].details.totalRecords}}\n</span>\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.billingCategoryObj['billToContractMaintenanceId'].process}\"></span>\n<span class=\"pull-right\">\n<input bs-switch switch-size=\"mini\" switch-on-text=\"{{'common.on' | translate }}\" ng-change=\"$ctrl.resetBillingCategory($ctrl.contractIdKeyObj.maintenance)\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.billToContractMaintenanceStatus\" type=\"checkbox\"/>\n</span>\n<span>\n<search-and-select ng-model=\"$ctrl.model.billToContractMaintenanceId\" values=\"$ctrl.contracts\" key=\"Key\" totalrecords=\"$ctrl.totalContract\" onscroll=\"$ctrl.loadContractData(searchKey, offset)\" on-click=\"$ctrl.sameForAll($ctrl.model.billToContractMaintenanceId); $ctrl.getBillingRulesInfo($ctrl.contractIdKeyObj.maintenance)\" none-selected=\"'common.select'\" ng-disabled=\"!$ctrl.model.billToContractMaintenanceStatus\"></search-and-select>\n</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.errorMessage\">\n<div class=\"form-group alert alert-danger\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"margin-bottom-20\">\n<button type=\"button\" ng-click=\"$ctrl.addUnitBasisOption();$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || $ctrl.surchargeBillingEventsMissing($ctrl.model.surcharges)\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n</form>\n</div>\n";
var id1="customer.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2813 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"fuel-surcharge\">\n<div class=\"row\">\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'fuel_surcharge.menu.all' | translate}}\n<span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" ng-model=\"$ctrl.searchObj.searchText\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.applyFilter()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<div class=\"form-group\">\n<select class=\"form-control\" ng-model=\"$ctrl.searchObj.status\" ng-options=\"status.value as status.label for status in  $ctrl.statusList\" ng-change=\"$ctrl.applyFilter()\"></select>\n</div>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.fuelSurcharges && $ctrl.fuelSurcharges.length\">\n<ul class=\"list-group fuel-surcharge-list-group\">\n<li class=\"list-group-item fuel-surcharge-list\" ng-repeat-start=\"fuelSurcharge in $ctrl.fuelSurcharges track by fuelSurcharge.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"padding-left-10\">\n<button id=\"expand-btn-{{fuelSurcharge.id}}\" class=\"btn btn-xs btn-secondary\" ng-click=\"$ctrl.expandFuelSurchageCustomer(fuelSurcharge); $ctrl.getFuelSurchargeCustomers(fuelSurcharge)\" expand>\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-triangle-right': !fuelSurcharge.expanded, 'glyphicon-triangle-bottom': fuelSurcharge.expanded}\"></span>\n</button>\n</div>\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n<span class=\"bold-font_\">{{fuelSurcharge.id}} | {{fuelSurcharge.name}} </span>|\n<span ng-if=\"fuelSurcharge.status\" class=\"text-success\">{{'common.active' | translate}}</span>\n<span ng-if=\"!fuelSurcharge.status\" class=\"text-danger\">{{'common.suspended' | translate}}</span>\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"icon-padding-05\">\n<span class=\"badge badge-info\">\n<span uib-tooltip=\"{{'fuel_surcharge.applied_monthly' | translate}}\" ng-if=\"fuelSurcharge.appliedRange == 'MONTHLY'\">\n{{'fuel_surcharge.monthly' | translate}}\n</span>\n<span uib-tooltip=\"{{'fuel_surcharge.applied_weekly' | translate}}\" ng-if=\"fuelSurcharge.appliedRange == 'WEEKLY'\">\n{{'fuel_surcharge.weekly' | translate}}\n</span>\n<span uib-tooltip=\"{{'fuel_surcharge.applied_bi_weekly' | translate}}\" ng-if=\"fuelSurcharge.appliedRange == 'BI_WEEKLY'\">\n{{'fuel_surcharge.bi_weekly' | translate}}\n</span>\n</span>\n</div>\n<div class=\"icon-padding-05\">\n<span class=\"badge badge-light\" uib-tooltip=\"{{'fuel_surcharge.surcharges' | translate}}\">\n{{fuelSurcharge.surcharges.length}}\n</span>\n</div>\n<div class=\"icon-padding-05\">\n<span class=\"badge badge-success badge-custome-success\" uib-tooltip=\"{{'fuel_surcharge.customers' | translate}}\">\n{{fuelSurcharge.customers}}\n</span>\n</div>\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-if=\"$ctrl.hasACL.edit\" ng-click=\"$ctrl.edit(fuelSurcharge)\" uib-tooltip=\"{{'common.Edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n<div ng-repeat-end ng-if=\"fuelSurcharge.expanded\">\n<div class=\"_margin-10\">\n<div class=\"w-100 remove-padding\">\n<table class=\"table-pad-3 table table-condensed table-bordered inner-tbl-margin-bottom\">\n<thead ng-if=\"fuelSurcharge.customerList && fuelSurcharge.customerList.length\">\n<tr class=\"header-row\">\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('customerName', fuelSurcharge)\">\n<b>{{'fuel_surcharge.customers' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t\t\t\t\t'reverse': !$ctrl.reverseSort, \n\t\t\t\t\t\t\t\t\t\t\t\t\t'active' : $ctrl.sortColumn === 'customerName'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('totalLocation', fuelSurcharge)\">\n<b>{{'fuel_surcharge.locations' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t\t\t\t\t'reverse': !$ctrl.reverseSort, \n\t\t\t\t\t\t\t\t\t\t\t\t\t'active' : $ctrl.sortColumn === 'totalLocation'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('totalBranch', fuelSurcharge)\">\n<b>{{'fuel_surcharge.branches' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t\t\t\t'reverse': !$ctrl.reverseSort, \n\t\t\t\t\t\t\t\t\t\t\t\t'active' : $ctrl.sortColumn === 'totalBranch'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\">fuel_surcharge.associated_date\n</th>\n</tr>\n</thead>\n<tbody ng-if=\"!fuelSurcharge.isCustomerLoading\">\n<tr ng-if=\"fuelSurcharge.customerList && fuelSurcharge.customerList.length\" ng-repeat=\"fuelSurchargeCustomer in fuelSurcharge.customerList track by $index\">\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToCustomer(fuelSurchargeCustomer.id)\">\n{{fuelSurchargeCustomer.id}} | {{fuelSurchargeCustomer.customerName}}\n</a>\n</td>\n<td class=\"text-center cursor-pointer\" ng-click=\"$ctrl.showLocations(fuelSurcharge, fuelSurchargeCustomer.id)\">\n{{fuelSurchargeCustomer.totalLocation}}</td>\n<td class=\"text-center\">{{fuelSurchargeCustomer.totalBranch}}</td>\n<td class=\"text-center\">{{fuelSurchargeCustomer.updatedAt | date: 'yyyy-MM-dd | hh:mm a'}}</td>\n</tr>\n<tr ng-if=\"!fuelSurcharge.customerList || !fuelSurcharge.customerList.length\">\n<td class=\"text-align-center alert alert-danger\" colspan=\"4\">\n<span>{{'fuel_surcharge.noFuelSurchargeCustomers' | translate}}</span>\n</td>\n</tr>\n<tr ng-if=\"fuelSurcharge.customerList.length && (fuelSurcharge.totalCustomers >= 10 && fuelSurcharge.customerFilter.page ==1)\" class=\"fuel-surcharge-pagination-section\">\n<td colspan=\"5\" align=\"right\">\n<div class=\"right-btn-section\">\n<ul uib-pagination total-items=\"fuelSurcharge.totalCustomers\" ng-hide=\"{{(fuelSurcharge.totalCustomers <= fuelSurcharge.customerFilter.limit)&&(fuelSurcharge.customerFilter.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"fuelSurcharge.customerFilter.page\" ng-change=\"$ctrl.onCustomerPageChange(fuelSurcharge)\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</td>\n</tr>\n</tbody>\n<tbody ng-if=\"fuelSurcharge.isCustomerLoading\">\n<tr>\n<td colspan=\"4\">\n<div class=\"w-100 text-align-center\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"$ctrl.maxPages\"></ul>\n</div>\n</div>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"!$ctrl.fuelSurcharges || !$ctrl.fuelSurcharges.length\">\n<span>{{'fuel_surcharge.noFuelSurcharge' | translate}}</span>\n</div>";
var id1="fuel_surcharges.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2814 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"fuel_surcharge.menu.create\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"id\">{{'common.id' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"id\" ng-model=\"$ctrl.model.id\" required/>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"name\">{{'fuel_surcharge.name' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"$ctrl.model.name\" required/>\n</div>\n<div class=\"col-sm-2 form-group\">\n<label name=\"status\">{{'fuel_surcharge.status' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.status\" switch-size=\"small\" switch-on-text=\"{{'common.active' | translate}}\" switch-off-text=\"{{'common.suspended' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"col-sm-6\"></div>\n<div class=\"col-sm-12 form-group\">\n<label for=\"exampleInputPassword1\">{{'common.description' | translate }} *</label>\n<textarea class=\"form-control\" rows=\"3\" required ng-model=\"$ctrl.model.description\"></textarea>\n<span ng-if=\"$ctrl.errors.description\" class=\"text-danger\">{{$ctrl.errors['description']}}</span>\n</div>\n<div class=\"col-sm-6\">\n<label>{{'fuel_surcharge.applied' | translate}}</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.appliedRange\" ng-options=\"applied.value as applied.label for applied in $ctrl.appliedList\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'|translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-6 form-group\">\n<label>{{'fuel_surcharge.branch_applicable' | translate}}</label>\n<div>\n<div class=\"fuel-surcharge-branch-dd multi-select\" ng-class=\"{\n\t\t\t\t\t\t\t'invalid-multi-select-value': !$ctrl.model.branchIds.length,\n\t\t\t\t\t\t\t'valid-multi-select-value': $ctrl.model.branchIds.length\n\t\t\t\t\t\t}\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.branches\" output-model=\"$ctrl.model.branchIds\" button-label=\"id\" item-label=\"id\" search-property=\"id\" tick-property=\"ticked\" directive-id=\"multi-select-button\" translation=\"$ctrl.localLang\" on-item-click=\"$ctrl.autoSelectSameForAll();\" on-select-all=\"$ctrl.autoSelectSameForAll();\" on-select-none=\"$ctrl.removeSelection();\" on-reset=\"$ctrl.removeSelection();\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-header-title\">\n<label>{{'fuel_surcharge.surcharges' | translate}}</label>\n<button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"$ctrl.addNewSurcharge()\" ng-disabled=\"!$ctrl.isSurchargeValid()\"><span class=\"glyphicon glyphicon-plus\"></span>\n<span>{{'common.new' | translate}}</span>\n</button>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\"><label>{{'fuel_surcharge.fuel_price_range' | translate}}</label></div>\n<div class=\"col-sm-4\"><label>{{'fuel_surcharge.surcharges' | translate}}</label></div>\n<div class=\"col-sm-2\"></div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.model.surcharges && $ctrl.model.surcharges.length\" ng-repeat=\"surcharge in $ctrl.model.surcharges track by $index\">\n<div class=\"col-sm-2 form-group\">\n<input class=\"form-control\" name=\"surcharge-{{$index}}\" ng-disabled=\"$index\" ng-model=\"$ctrl.model.surcharges[$index].priceRange.from\" step=\"0.01\" placeholder=\"$0.0\" ng-min=\"$index ? $ctrl.model.surcharges[$index-1].priceRange.to : 0\" ng-currency required/>\n</div>\n<div class=\"col-sm-2 form-group\">\n<input class=\"form-control\" name=\"surcharge-{{$index}}\" ng-model=\"$ctrl.model.surcharges[$index].priceRange.to\" step=\"0.01\" placeholder=\"$0.0\" ng-blur=\"$ctrl.onSurchargeChange($event, $index)\" ng-min=\"$ctrl.model.surcharges[$index].priceRange.from\" ng-currency required/>\n</div>\n<div class=\"col-sm-4 form-group\">\n<input class=\"form-control\" name=\"surcharge-{{$index}}\" ng-model=\"$ctrl.model.surcharges[$index].surcharge\" placeholder=\"0.00%\" required pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\" ng-blur=\"$ctrl.ngPercentage($index)\" ng-focus=\"$ctrl.removePrecentageSign($index)\"/>\n</div>\n<div class=\"col-sm-2 form-group remove-pad-left\">\n<button class=\"btn btn-danger btn-sm margin-top-02\" ng-click=\"$ctrl.removeSurcharge($index)\" ng-if=\"$ctrl.model.surcharges.length > 1\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 form-header-title mb-1\">\n<label>{{'fuel_surcharge.customers' | translate}}</label>\n<span class=\"badge badge-custome-success\">{{$ctrl.model.customers.length}}</span>\n<button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"$ctrl.addNewCustomer()\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n<span>{{'common.new' | translate}}</span>\n</button>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.customers && $ctrl.model.customers.length\">\n<table class=\"table table-bordered\">\n<thead>\n<tr>\n<th>{{'fuel_surcharge.customer' | translate}}</th>\n<th>{{'fuel_surcharge.locations' | translate}}</th>\n<th>{{'fuel_surcharge.branches' | translate}}</th>\n<th>{{'fuel_surcharge.associationDate' | translate}}</th>\n<th>{{'fuel_surcharge.action' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"(key, customer) in $ctrl.model.customers\">\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToCustomer(customer.id)\">\n{{customer.label}}\n</a>\n</td>\n<td>\n<span class=\"cursor-pointer\" ng-click=\"$ctrl.showLocations(customer.id)\">{{customer.location}} </span>\n</td>\n<td> {{customer.branch}} </td>\n<td> {{customer.updatedAt | date: 'yyyy-MM-dd | hh:mm a'}} </td>\n<td>\n<button class=\"btn btn-danger btn-xs\" ng-click=\"$ctrl.removeCustomer(key)\" ng-hide=\"false\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n<br/>\n</div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary margin-bottom-10\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default margin-bottom-10\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>";
var id1="fuel_surcharges.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2815 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row\">\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'fuel_surcharge.menu.customerNotAssociated' | translate}}\n<span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n<span ng-if=\"!$ctrl.loading\" class=\"badge badge-success badge-custome-success\">{{$ctrl.total}}</span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'users.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div class=\"col-sm-12_\" ng-if=\"$ctrl.customers && $ctrl.customers.length\">\n<table class=\"table-pad-3 table table-bordered table-responsive mb-0\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('name')\">\n<b>{{'fuel_surcharge.customer' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t'reverse': !$ctrl.reverseSort, \n\t\t\t\t\t\t\t\t\t'active' : $ctrl.sortColumn === 'name'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('billingAddress')\">\n<b>{{'fuel_surcharge.address' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{\n\t\t\t\t\t\t\t\t'reverse': !$ctrl.reverseSort, \n\t\t\t\t\t\t\t\t'active' : $ctrl.sortColumn === 'billingAddress'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('isEnabled')\">\n<b>{{'common.status' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t'reverse': !$ctrl.reverseSort, \n\t\t\t\t\t\t\t\t\t'active' : $ctrl.sortColumn === 'isEnabled'}\"></span>\n</th>\n<th class=\"text-center contents-no-wrap\">{{'fuel_surcharge.service_day' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"customer in $ctrl.customers track by $index\">\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToCustomer(customer.id)\">{{customer.id}} | {{customer.name}}</a>\n</td>\n<td class=\"text-center\">{{customer.address}}</td>\n<td class=\"text-center\">\n<span ng-if=\"customer.isEnabled\" class=\"text-success\">{{'common.active' | translate}}</span>\n<span ng-if=\"!customer.isEnabled\" class=\"text-danger\">{{'common.inactive' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<span ng-if=\"customer.serviceDays.length\" ng-repeat=\"days in customer.serviceDays\">\n<span>{{days}}<span ng-if=\"$index + 1 !== customer.serviceDays.length\">,</span></span>\n</span>\n<span ng-if=\"!customer.serviceDays.length\">\n{{'common.n_a' | translate}}\n</span>\n</td>\n</tr>\n</tbody>\n</table>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.loadDataList()\" rotate=\"false\" max-size=\"$ctrl.maxPages\"></ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"!$ctrl.customers || !$ctrl.customers.length\">\n<span>{{'common.noRecords' | translate}}</span>\n</div>\n</div>\n</div>";
var id1="customer_not_associated.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2816 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"fuel_surcharge.menu.edit\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"id\">{{'common.id' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"id\" ng-model=\"$ctrl.model.id\" required ng-disabled=\"true\"/>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"name\">{{'fuel_surcharge.name' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"$ctrl.model.name\" required/>\n</div>\n<div class=\"col-sm-2 form-group\">\n<label name=\"status\">{{'fuel_surcharge.status' | translate}}</label>\n<br>\n<input type=\"checkbox\" bs-switch ng-model=\"$ctrl.model.status\" switch-size=\"small\" switch-on-text=\"{{'common.active' | translate}}\" switch-off-text=\"{{'common.suspended' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"col-sm-6\"></div>\n<div class=\"col-sm-12 form-group\">\n<label for=\"exampleInputPassword1\">{{'common.description' | translate }} *</label>\n<textarea class=\"form-control\" rows=\"3\" required ng-model=\"$ctrl.model.description\"></textarea>\n<span ng-if=\"$ctrl.errors.description\" class=\"text-danger\">{{$ctrl.errors['description']}}</span>\n</div>\n<div class=\"col-sm-6 form-group\">\n<label>{{'fuel_surcharge.applied' | translate}}</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.appliedRange\" ng-options=\"applied.value as applied.label for applied in $ctrl.appliedList\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'|translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-6 form-group\">\n<label>{{'fuel_surcharge.branch_applicable' | translate}}</label>\n<div>\n<div class=\"fuel-surcharge-branch-dd multi-select\" ng-class=\"{\n\t\t\t\t\t\t\t'invalid-multi-select-value': !$ctrl.model.branchIds.length,\n\t\t\t\t\t\t\t'valid-multi-select-value': $ctrl.model.branchIds.length\n\t\t\t\t\t\t}\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.branches\" output-model=\"$ctrl.model.branchIds\" button-label=\"id\" item-label=\"id\" search-property=\"id\" tick-property=\"ticked\" directive-id=\"multi-select-button\" translation=\"$ctrl.localLang\" on-item-click=\"$ctrl.autoSelectSameForAll();\" on-select-all=\"$ctrl.autoSelectSameForAll();\" on-select-none=\"$ctrl.removeSelection();\" on-reset=\"$ctrl.removeSelection();\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-header-title\">\n<label class=\"bold-font\">{{'fuel_surcharge.surcharges' | translate}}</label>\n<button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"$ctrl.addNewSurcharge()\" ng-disabled=\"!$ctrl.isSurchargeValid()\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n<span>{{'common.new' | translate}}</span>\n</button>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\"><label>{{'fuel_surcharge.fuel_price_range' | translate}}</label></div>\n<div class=\"col-sm-4\"><label>{{'fuel_surcharge.surcharges' | translate}}</label></div>\n<div class=\"col-sm-2\"></div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.model.surcharges && $ctrl.model.surcharges.length\" ng-repeat=\"surcharge in $ctrl.model.surcharges track by $index\">\n<div class=\"col-sm-2 form-group\">\n<input class=\"form-control\" name=\"surcharge-{{$index}}\" ng-disabled=\"$ctrl.model.surcharges[$index] && $ctrl.model.surcharges[$index+1].priceRange.from > $ctrl.model.surcharges[$index].priceRange.to\" ng-model=\"$ctrl.model.surcharges[$index].priceRange.from\" step=\"0.01\" placeholder=\"$0.0\" ng-min=\"$index ? $ctrl.model.surcharges[$index-1].priceRange.to : 0\" ng-currency required/>\n</div>\n<div class=\"col-sm-2 form-group\">\n<input class=\"form-control\" name=\"surcharge-{{$index}}\" ng-model=\"$ctrl.model.surcharges[$index].priceRange.to\" step=\"0.01\" placeholder=\"$0.0\" ng-blur=\"$ctrl.onSurchargeChange($event, $index)\" ng-min=\"$ctrl.model.surcharges[$index].priceRange.from\" ng-currency required/>\n</div>\n<div class=\"col-sm-4 form-group\">\n<input class=\"form-control\" name=\"surcharge-{{$index}}\" ng-model=\"$ctrl.model.surcharges[$index].surcharge\" placeholder=\"0.00%\" required pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\" ng-blur=\"$ctrl.ngPercentage($index);\" ng-focus=\"$ctrl.removePrecentageSign($index)\"/>\n</div>\n<div class=\"col-sm-2 form-group remove-pad-left\">\n<button class=\"btn btn-danger btn-sm margin-top-02\" ng-click=\"$ctrl.removeSurcharge($index)\" ng-if=\"$ctrl.model.surcharges.length > 1\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 form-header-title\">\n<label>{{'fuel_surcharge.customers' | translate}}</label>\n<span class=\"badge badge-custome-success\">{{$ctrl.getCustomerCount()}}</span>\n<button class=\"btn btn-xs btn-primary pull-right\" ng-click=\"$ctrl.addNewCustomer()\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n<span>{{'common.new' | translate}}</span>\n</button>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.getCustomerCount()\">\n<table class=\"table table-bordered\">\n<thead>\n<tr>\n<th>{{'fuel_surcharge.customer' | translate}}</th>\n<th>{{'fuel_surcharge.locations' | translate}}</th>\n<th>{{'fuel_surcharge.branches' | translate}}</th>\n<th>{{'fuel_surcharge.associationDate' | translate}}</th>\n<th>{{'fuel_surcharge.action' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"(key, customer) in $ctrl.model.customers\" ng-if=\"!customer.isRemoved\">\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToCustomer(customer.id)\">\n{{customer.label}}\n</a>\n</td>\n<td> <span class=\"cursor-pointer\" ng-click=\"$ctrl.showLocations(customer.id)\">{{customer.location}}\n</span></td>\n<td> {{customer.branch}} </td>\n<td> {{customer.updatedAt | date: 'yyyy-MM-dd | hh:mm a'}} </td>\n<td>\n<button class=\"btn btn-danger btn-xs\" ng-click=\"$ctrl.removeCustomer(key)\" ng-hide=\"false\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n<br/>\n</div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary margin-bottom-10\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default margin-bottom-10\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>";
var id1="fuel_surcharges.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2817 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_ fuel_surcharge\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"fuel_surcharges.all({page:1})\">\n<a translate=\"fuel_surcharge.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL.fuel_surcharges.create\" ui-sref-active=\"active\" ui-sref=\"fuel_surcharges.create\">\n<a translate=\"fuel_surcharge.menu.create\"></a>\n</li>\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"fuel_surcharges.customernotassociated\">\n<a translate=\"fuel_surcharge.menu.customerNotAssociated\"></a>\n</li>\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"fuel_surcharges.locationnotassociated\">\n<a translate=\"fuel_surcharge.menu.locationNotAssociated\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL.price_point.view\" ui-sref-active=\"active\" ui-sref=\"fuel_surcharges.pricePoint\">\n<a translate=\"fuel_surcharge.menu.fuelPricePoint\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="fuel_surcharges.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2818 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row\">\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'fuel_surcharge.menu.locationNotAssociated' | translate}}\n<span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n<span ng-if=\"!$ctrl.loading\" class=\"badge badge-success badge-custome-success\">{{$ctrl.total}}</span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'users.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div class=\"col-sm-12_\" ng-if=\"$ctrl.locations && $ctrl.locations.length\">\n<table class=\"table-pad-3 table table-bordered table-responsive mb-0\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('locationName')\">\n<b>{{'fuel_surcharge.locations' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t'reverse': !$ctrl.reverseSort, \n\t\t\t\t\t\t\t\t\t'active' : $ctrl.sortColumn === 'locationName'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('address')\">\n<b>{{'fuel_surcharge.address' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{\n\t\t\t\t\t\t\t\t'reverse': !$ctrl.reverseSort, \n\t\t\t\t\t\t\t\t'active' : $ctrl.sortColumn === 'address'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('active')\">\n<b>{{'common.active' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t'reverse': !$ctrl.reverseSort, \n\t\t\t\t\t\t\t\t\t'active' : $ctrl.sortColumn === 'active'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('locationType')\">\n<b>{{'fuel_surcharge.locationType' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{\n\t\t\t\t\t\t\t\t\t'reverse': !$ctrl.reverseSort, \n\t\t\t\t\t\t\t\t\t'active' : $ctrl.sortColumn === 'locationType'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('customerName')\">\n<b>{{'fuel_surcharge.customer' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{\n\t\t\t\t\t\t\t\t'reverse': !$ctrl.reverseSort, \n\t\t\t\t\t\t\t\t'active' : $ctrl.sortColumn === 'customerName'}\"></span>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"location in $ctrl.locations track by $index\">\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToLocation(location.id)\">{{location.id}} | {{location.locationName}}</a>\n</td>\n<td class=\"text-center\">{{location.address}}</td>\n<td class=\"text-center\">\n<span ng-if=\"location.active\" class=\"text-success\">{{'common.active' | translate}}</span>\n<span ng-if=\"!location.active\" class=\"text-danger\">{{'common.inactive' | translate}}</span>\n</td>\n<td class=\"text-center\">\n<img ng-src=\"{{$ctrl.loadImage(location.locationType)}} \" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{location.locationType}}\"/>\n</td>\n<td class=\"text-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToCustomer(location.customerId)\">{{location.customerId}} | {{location.customerName}}</a>\n</td>\n</tr>\n</tbody>\n</table>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.loadLocations()\" rotate=\"false\" max-size=\"$ctrl.maxPages\"></ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"!$ctrl.locations || !$ctrl.locations.length\">\n<span>{{'common.noRecords' | translate}}</span>\n</div>\n</div>\n</div>";
var id1="location_not_associated.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2819 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"fuel_surcharge.menu.fuelPricePoint\">\n<span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\" ng-if=\"$ctrl.hasACL.create\">\n<div class=\"col-sm-3\">\n<label for=\"date\">{{'price_point.date' | translate}}</label>\n<datetimepicker class=\"datetimepicker-input\" ng-model=\"$ctrl.model.date\" date-format=\"dd-MMM-yyyy\" ng-change=\"$ctrl.onDateChange()\" ng-class=\"{'required-datetimepicker': !$ctrl.model.date, 'disabled': $ctrl.loading}\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" date-options=\"$ctrl.minVaultDate\"/>\n</div>\n<div class=\"col-sm-3\">\n<label for=\"pricePoint\">{{'price_point.price_point' | translate}}</label>\n<input class=\"form-control\" ng-currency type=\"text\" name=\"pricePoint\" ng-model=\"$ctrl.model.pricePoint\" ng-currency required/>\n</div>\n<div class=\"col-sm-3\">\n<label>{{'price_point.period' | translate}}</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.period\" ng-options=\"period.value as period.label for period in $ctrl.periodList\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'| translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-3\">\n<label for=\"periodApplied\">{{'price_point.period_applied' | translate}}</label>\n<input class=\"form-control\" type=\"text\" name=\"periodApplied\" ng-model=\"$ctrl.model.periodAppliedWord\" ng-disabled=\"true\" required/>\n</div>\n<div class=\"col-sm-12\">\n<label for=\"comments\">{{'common.comment' | translate}}</label>\n<textarea class=\"form-control\" rows=\"3\" required ng-model=\"$ctrl.model.comment\"></textarea>\n</div>\n<div class=\"col-sm-12 margin-top-20\" ng-if=\"$ctrl.errorMessage\">\n<div class=\"remove-bottom-pad form-group alert alert-danger\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-20\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary margin-bottom-10\" ng-if=\"!$ctrl.rawId\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.update(this)\" class=\"btn btn-primary margin-bottom-10\" ng-if=\"$ctrl.rawId\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.update' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default margin-bottom-10\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n<button type=\"button\" class=\"btn btn-default margin-bottom-10\" ng-click=\"$ctrl.reset(true)\" ng-if=\"$ctrl.rawId\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.cancel' | translate }}</button>\n</div>\n</form>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.hasACL.view && !$ctrl.loading\">\n<table class=\"table-pad-3 table table-condensed table-bordered inner-tbl-margin-bottom\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('pricePoint')\">\n<b>{{'price_point.fuel_price' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{ 'reverse': !$ctrl.reverseSort,  'active' : $ctrl.sortColumn === 'pricePoint'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('date')\">\n<b>{{'price_point.period' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{ 'reverse': !$ctrl.reverseSort,  'active' : $ctrl.sortColumn === 'date'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('createdAt')\">\n<b>{{'price_point.date_added' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{ 'reverse': !$ctrl.reverseSort, 'active' : $ctrl.sortColumn === 'createdAt'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\" ng-click=\"$ctrl.sortData('appliedByUserId')\">\n<b>{{'price_point.user' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{ 'reverse': !$ctrl.reverseSort,  'active' : $ctrl.sortColumn === 'appliedByUserId'}\"></span>\n</th>\n<th class=\"text-center table-label-font-section\">\n<b>{{'common.action' | translate}}</b>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-if=\"$ctrl.pricePoints && $ctrl.pricePoints.length\" ng-repeat=\"pricePoint in $ctrl.pricePoints track by $index\">\n<td class=\"text-center\">{{pricePoint.pricePoint | currency}}</td>\n<td class=\"text-center\">{{pricePoint.date | date: 'MMMM yyyy'}}</td>\n<td class=\"text-center\">{{pricePoint.date | date: 'MM-dd-yyyy'}}</td>\n<td class=\"text-center\">\n{{pricePoint.appliedByUser.id}} | {{pricePoint.appliedByUser.firstName}} {{pricePoint.appliedByUser.lastName}}\n</td>\n<td class=\"text-center\">\n<button type=\"button\" class=\"btn btn-xs btn-default\" ng-if=\"$ctrl.hasACL.edit\" ng-click=\"$ctrl.edit(pricePoint)\" uib-tooltip=\"{{ 'common.Edit' | translate }}\" ng-disabled=\"$ctrl.isPastDate(pricePoint.date)\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</td>\n</tr>\n<tr ng-if=\"$ctrl.pricePoints && !$ctrl.pricePoints.length\">\n<td colspan=\"5\">\n<div class=\"text-align-center alert alert-danger remove-bottom-pad alert-pad-10\">\n<span>{{'price_point.noPricePointFound' | translate}}</span>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=10)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.loadPricePointList()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>";
var id1="price_point.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2820 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'locationDistance.all_location_distance' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.model.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.locationDistanceObj.loading\">\n<div class=\"text-align-center col-sm-12 margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.locationDistanceObj.totalRecords > 0 && !$ctrl.model.locationDistanceObj.loading\">\n<ul class=\"remove-bottom-pad list-group\">\n<li class=\"list-group-item\" ng-repeat=\"locationDistanceObj in $ctrl.model.locationDistanceObj.results track by $index\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{locationDistanceObj.label}}\n</span>\n<span class=\"list-group-item-text\" ng-if=\"locationDistanceObj.mileRange\">\n| <span class=\"text-success\">{{locationDistanceObj.mileRange}}</span>\n</span>\n<span class=\"list-group-item-text\">\n| {{locationDistanceObj.minRange}} - {{locationDistanceObj.maxRange}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\"></div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(locationDistanceObj)\" uib-tooltip=\"{{ 'common.Edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<div class=\"col-sm-12 remove-left-pad margin-10\">\n<ul class=\"margin-10\" uib-pagination total-items=\"$ctrl.model.locationDistanceObj.totalRecords\" ng-hide=\"{{($ctrl.model.locationDistanceObj.totalRecords<=$ctrl.model.pagination.pageLimit)&&($ctrl.model.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 text-align-center alert alert-danger\" ng-if=\"($ctrl.model.locationDistanceObj.totalRecords === 0 && !$ctrl.model.locationDistanceObj.loading)\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>";
var id1="location_distance.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2821 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n<h4 translate=\"locationDistance.create_location_distance\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"label\">{{'serviceSettings.label' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"label\" placeholder=\"\" ng-model=\"$ctrl.model.label\">\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"mileRange\">{{'locationDistance.mile_range' | translate }}</label>\n<input type=\"text\" class=\"form-control\" id=\"mileRange\" placeholder=\"\" ng-model=\"$ctrl.model.mileRange\">\n</div>\n</div>\n<div id=\"inline\" class=\"col-sm-3 form-group\">\n<label for=\"minRange\" class=\"font-12\">{{'locationDistance.min_range' | translate }} *</label>\n<input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"$ctrl.model.minRange\" ng-change=\"$ctrl.validateRange()\" required>\n</div>\n<div id=\"inline\" class=\"col-sm-3 form-group\">\n<label for=\"maxRange\" class=\"font-12\">{{'locationDistance.max_range' | translate }} *</label>\n<input type=\"number\" min=\"1\" class=\"form-control\" ng-model=\"$ctrl.model.maxRange\" ng-change=\"$ctrl.validateRange()\" required>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger text-center\" ng-if=\"$ctrl.model.errorMessage || $ctrl.rangeError\" ng-bind-html=\"$ctrl.model.errorMessage || $ctrl.rangeError\"></div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || $ctrl.rangeError\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}\n</button>\n</div>\n</form>\n</div>";
var id1="location_distance.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2822 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n<h4 translate=\"locationDistance.edit_location_distance\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"location-distance-id\" class=\"font-12\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required disabled=\"disabled\" placeholder=\"\" ng-model=\"$ctrl.model.id\">\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"label\">{{'serviceSettings.label' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"label\" placeholder=\"\" ng-model=\"$ctrl.model.label\">\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"mileRange\">{{'locationDistance.mile_range' | translate }}</label>\n<input type=\"text\" class=\"form-control\" id=\"mileRange\" placeholder=\"\" ng-model=\"$ctrl.model.mileRange\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div id=\"inline\" class=\"col-sm-4 form-group\">\n<label for=\"minRange\" class=\"font-12\">{{'locationDistance.min_range' | translate }} *</label>\n<input type=\"number\" min=\"0\" class=\"form-control\" ng-model=\"$ctrl.model.minRange\" ng-change=\"$ctrl.validateRange()\" required>\n</div>\n<div id=\"inline\" class=\"col-sm-4 form-group\">\n<label for=\"maxRange\" class=\"font-12\">{{'locationDistance.max_range' | translate }} *</label>\n<input type=\"number\" min=\"1\" class=\"form-control\" ng-model=\"$ctrl.model.maxRange\" ng-change=\"$ctrl.validateRange()\" required>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger text-center\" ng-if=\"$ctrl.model.errorMessage || $ctrl.rangeError\" ng-bind-html=\"$ctrl.model.errorMessage || $ctrl.rangeError\"></div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.update()\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || $ctrl.rangeError\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.update' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}\n</button>\n</div>\n</form>\n</div>";
var id1="location_distance.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2823 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_ remove-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"location_distance.all({page: 1})\"><a>{{'locationDistance.all_location_distance' | translate}}</a></li>\n<li role=\"presentation\" ui-sref-active=\"active\" ng-show=\"$ctrl.hasACL['create']\" ui-sref=\"location_distance.create\">\n<a>{{'locationDistance.create_location_distance' | translate}}</a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="location_distance.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2824 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<ul class=\"nav nav-tabs hide-in-print\">\n<li ng-repeat=\"tab in $ctrl.tabs\" role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"{{tab.state}}\" ng-show=\"::$ctrl.hasAcl(tab.key)\">\n<a class=\"branch-mgmt-badge\">\n{{tab.title | translate}}\n</a>\n</li>\n</ul>\n<div class=\"remove-pad\">\n<div class=\"mt-20\">\n<ui-view></ui-view>\n</div>\n</div>\n</div>";
var id1="tnt_billing.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2825 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n</div>";
var id1="atm_load_profile.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2826 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"atm_load_profile.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"atmLoadProfile.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"atm_load_profile.create\">\n<a translate=\"atmLoadProfile.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>";
var id1="atm_load_profile.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2827 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n</div>";
var id1="atm_load_profile.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2828 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n<h4 translate=\"\"></h4>\n<hr/>\n</div>";
var id1="atm_load_profile.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2829 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<h1>configuration</h1>";
var id1="configuration.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2830 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'costCenter.all_cost_center' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse remove-pad\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'costCenter.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.costcenters && $ctrl.costcenters.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"costCenter in $ctrl.costcenters track by costCenter.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-8\">\n<div class=\"list-group-item-text\">\n<div class=\"col-sm-11\">\n<span>{{ costCenter.id }} | {{ costCenter.name }} {{ costCenter.description ? ' | ' + costCenter.description : '' }}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(costCenter)\" uib-tooltip=\"{{ 'costCenter.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.costcenters || !$ctrl.costcenters.length) && !$ctrl.loading\">\n<span>{{'costCenter.noCostCenter' | translate}}</span>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>";
var id1="cost_center.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2831 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"cost_center.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"costCenter.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"cost_center.create\">\n<a translate=\"costCenter.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>";
var id1="cost_center.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2832 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"heading-section\">\n<h4 translate=\"costCenter.create_cost_center\"></h4>\n<hr/>\n</div>\n<div class=\"cost-center-id-section\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"costCenter-form-section\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"cost-center-name\" class=\"font-12\">{{'costCenter.name' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.name\">\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"cost-center-status\" class=\"font-12\">{{'costCenter.status' | translate }} </label><br/>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"customer-cost-center\" class=\"font-12\">{{'costCenter.customer_cost_center' | translate }} </label><br/>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.customerFlag\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 form-group\">\n<label for=\"description\" class=\"font-12\">{{'costCenter.description' | translate }} </label>\n<textarea class=\"form-control\" placeholder=\"\" rows=\"2\" ng-model=\"$ctrl.model.description\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n</form>\n</div>";
var id1="cost_center.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2833 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"heading-section\">\n<h4 translate=\"costCenter.edit_cost_center\"></h4>\n<hr/>\n</div>\n<div class=\"costCenter-id-section\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"costCenter-form-section\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3 form-group\">\n<label for=\"cost-center-id\" class=\"font-12\">{{'costCenter.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required disabled=\"disabled\" placeholder=\"\" ng-model=\"$ctrl.rawId\">\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"cost-center-name\" class=\"font-12\">{{'costCenter.name' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.name\">\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"cost-center-status\" class=\"font-12\">{{'costCenter.status' | translate }} </label><br/>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"customer-cost-center\" class=\"font-12\">{{'costCenter.customer_cost_center' | translate }} </label><br/>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.customerFlag\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 form-group\">\n<label for=\"description\" class=\"font-12\">{{'costCenter.description' | translate }} </label>\n<textarea class=\"form-control\" placeholder=\"\" rows=\"2\" ng-model=\"$ctrl.model.description\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n</form>\n</div>";
var id1="cost_center.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2834 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'currency.all_currency' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'currency.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.currencies && $ctrl.currencies.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"currency in $ctrl.currencies track by currency.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{currency.id}} | {{currency.name}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(currency)\" uib-tooltip=\"{{ 'currency.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['delete']\" ng-click=\"$ctrl.delete(currency)\" uib-tooltip=\"{{ 'currency.tooltip_delete' | translate }}\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.currencies || !$ctrl.currencies.length) && !$ctrl.loading\">\n{{'currency.noCurrencies' | translate}}\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>\n";
var id1="currency.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2835 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"\">{{'currency.new_currency' | translate}}</h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"currencyId\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"currencyId\" placeholder=\"\" ng-model=\"$ctrl.model.id\"/>\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"currencyName\">{{'currency.name'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"currencyName\" placeholder=\"\" ng-model=\"$ctrl.model.name\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"decimals\">{{'currency.decimals' | translate}} *</label>\n<input type=\"number\" min=\"0\" max=\"4\" class=\"form-control\" id=\"decimals\" required placeholder=\"\" ng-model=\"$ctrl.model.decimals\"/>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"sortOrder\">{{'currency.sort_order' | translate}} *</label>\n<input type=\"number\" min=\"1\" required class=\"form-control\" id=\"sortOrder\" placeholder=\"\" ng-model=\"$ctrl.model.sortOrder\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"symbol\">{{'currency.symbol' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"symbol\" maxlength=\"10\" ng-model=\"$ctrl.model.symbol\"/>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n<div>\n<button type=\"button\" ng-click=\"$ctrl.submit()\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || $ctrl.loading\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</form>\n</div>\n";
var id1="currency.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2836 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"currency.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"currency.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"currency.create\">\n<a translate=\"currency.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view></ui-view>\n</div>\n</div>\n</div>\n";
var id1="currency.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2837 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"\">{{'currency.edit_currency' | translate}}</h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"text-align-center col-sm-12 margin-10\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<form name=\"Form\" novalidate class=\"form-validate\" ng-if=\"!$ctrl.model.loading\">\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"currencyId\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" disabled=\"disabled\" required id=\"currencyId\" placeholder=\"\" ng-model=\"$ctrl.model.id\"/>\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"currencyName\">{{'currency.name'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"currencyName\" placeholder=\"\" ng-model=\"$ctrl.model.name\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"decimals\">{{'currency.decimals' | translate}} *</label>\n<input type=\"number\" min=\"0\" max=\"4\" class=\"form-control\" id=\"decimals\" required placeholder=\"\" ng-model=\"$ctrl.model.decimals\"/>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"sortOrder\">{{'currency.sort_order' | translate}} *</label>\n<input type=\"number\" min=\"1\" required class=\"form-control\" id=\"sortOrder\" placeholder=\"\" ng-model=\"$ctrl.model.sortOrder\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"symbol\">{{'currency.symbol' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"symbol\" maxlength=\"10\" ng-model=\"$ctrl.model.symbol\"/>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n<div>\n<button type=\"button\" ng-click=\"$ctrl.submit()\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || $ctrl.loading\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">\n{{'common.reset' | translate }}\n</button>\n</div>\n</form>\n</div>\n";
var id1="currency.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2838 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'denomination.all_denomination' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'denomination.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.denominations && $ctrl.denominations.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"denomination in $ctrl.denominations track by denomination.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{denomination.id}} | {{denomination.name}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(denomination)\" uib-tooltip=\"{{ 'denomination.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.denominations || !$ctrl.denominations.length) && !$ctrl.loading\">\n{{'denomination.noDenominations' | translate}}\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>";
var id1="denomination.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2839 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"\">{{'denomination.new_denom' | translate}}</h4>\n<hr/>\n</div>\n<div class=\"col-sm-12 denomination-create-form-style\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"denominationId\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"denominationId\" placeholder=\"\" ng-model=\"$ctrl.model.id\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"denominationName\">{{'denomination.name'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"denominationName\" placeholder=\"\" ng-model=\"$ctrl.model.name\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"faceValue\">{{'denomination.face_value' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"faceValue\" required placeholder=\"\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" ng-model=\"$ctrl.model.faceValue\">\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"currency\">{{'denomination.currency' | translate}} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.currencyId\" ng-options=\"currency.id as (currency.id + ' | ' + currency.name) for currency in $ctrl.currencyData\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'|translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"shiptype\">{{'denomination.shiptype' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.shiptypeId\" values=\"$ctrl.shiptypeList\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" onscroll=\"$ctrl.loadshiptype(searchKey, offset)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div class=\"form-group col-sm-2\" ng-if=\"!$ctrl.model.coinFlag\">\n<label for=\"strapCount\"> {{'denomination.strap_count' | translate}} *</label>\n<input type=\"text\" ng-currency currency-symbol=\"\" fraction=\"0\" min=\"0\" class=\"form-control\" id=\"strapCount\" ng-model=\"$ctrl.model.strapCount\" ng-required=\"$ctrl.model.shiptypeId.Value === 'C'\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.calculateCount('bundleCount')\">\n</div>\n<div class=\"form-group col-sm-2\" ng-if=\"!$ctrl.model.coinFlag\">\n<label for=\"bundleCount\">{{'denomination.bundle_count' | translate}} *</label>\n<input type=\"text\" ng-currency currency-symbol=\"\" fraction=\"0\" min=\"0\" class=\"form-control\" id=\"bundleCount\" ng-model=\"$ctrl.model.bundleCount\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.calculateCount('strapCount')\" ng-required=\"$ctrl.model.shiptypeId.Value === 'C'\">\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.coinFlag && $ctrl.model.coinPackaging && $ctrl.model.coinPackaging !== 'INDIVIDUAL'\">\n<label for=\"individualDenominationId\">{{'denomination.individual_denomination' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.individualDenominationId\" values=\"$ctrl.denominationList\" key=\"Key\" totalrecords=\"$ctrl.totalDenominationRecords\" onscroll=\"$ctrl.loadDenomination(searchKey, offset)\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad denom-ui-section\">\n<div class=\"form-group _col-sm-2\">\n<label for=\"coinFlag\">{{'common.coin' | translate}} *</label>\n<div>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.coinFlag\" ng-change=\"$ctrl.onCoinFlagChange()\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group _col-sm-2\" ng-if=\"$ctrl.model.coinFlag\">\n<label for=\"coinPackaging\">{{'denomination.coinPackaging' | translate}}</label>\n<select class=\"form-control\" id=\"coinPackaging\" ng-model=\"$ctrl.model.coinPackaging\" ng-change=\"$ctrl.onCoinPackagingChange()\" ng-options=\"packaging for packaging in $ctrl.packagingOptions\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group _col-sm-2\">\n<label for=\"multiDenomPackable\" class=\"remove-white-space\">{{'denomination.multiDenomPackable' | translate}}</label>\n<div ng-class=\"{'disabled': !$ctrl.isMultiDenomPackableAllowed()}\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.multiDenomPackable\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group _col-sm-2\">\n<label for=\"unfit\">{{'denomination.unfit' | translate}}</label>\n<div>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.unfit\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group _col-sm-2\" ng-if=\"$ctrl.model.coinFlag\">\n<label for=\"sortOrder\">{{'denomination.sort_order' | translate}} *</label>\n<input type=\"number\" min=\"1\" required class=\"form-control\" id=\"sortOrder\" placeholder=\"\" ng-model=\"$ctrl.model.sortOrder\">\n</div>\n<div class=\"form-group _col-sm-4\">\n<label>\n{{'denomination.load_detect_thresholds' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'denomination.load_detect_thresholds_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<input type=\"text\" class=\"form-control\" id=\"loadDetectThreshold\" placeholder=\"$0.00\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"$ctrl.model.loadDetectThreshold\">\n</div>\n<div class=\"form-group _col-sm-4\" ng-if=\"!$ctrl.model.coinFlag\">\n<label for=\"sortOrder\">{{'denomination.sort_order' | translate}} *</label>\n<input type=\"number\" min=\"1\" required class=\"form-control\" id=\"sortOrder\" placeholder=\"\" ng-model=\"$ctrl.model.sortOrder\">\n</div>\n</div>\n<div class=\"form-group col-sm-12 alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<div>\n<button type=\"button\" ng-click=\"$ctrl.submit()\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || $ctrl.loading || $ctrl.shiptypeMismatch\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>\n";
var id1="denomination.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2840 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"denomination.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"denomination.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"denomination.create\">\n<a translate=\"denomination.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="denomination.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2841 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"\">{{'denomination.edit_denom' | translate}}</h4>\n<hr/>\n</div>\n<div class=\"col-sm-12 denomination-create-form-style\">\n<div class=\"text-align-center col-sm-12 margin-10\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<form name=\"Form\" novalidate class=\"form-validate\" ng-if=\"!$ctrl.model.loading\">\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"denominationId\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" disabled=\"disabled\" required id=\"denominationId\" placeholder=\"\" ng-model=\"$ctrl.model.id\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"denominationName\">{{'denomination.name'| translate}} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"denominationName\" placeholder=\"\" ng-model=\"$ctrl.model.name\">\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"faceValue\">{{'denomination.face_value' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"faceValue\" required placeholder=\"\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" ng-model=\"$ctrl.model.faceValue\">\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.hasLedgerHistory()\">\n<div class=\"margin-bottom-10 col-sm-12\">\n<div class=\"alert alert-info face-value-ledger-note remove-bottom-margin\">\n<span class=\"glyphicon glyphicon-info-sign\"></span>\n{{'denomination.face_value_in_use' | translate}}\n<strong>{{$ctrl.formatNoteCount($ctrl.ledgerUsage.entryCount)}}</strong>\n{{'denomination.face_value_in_use_suffix' | translate}}\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"currency\">{{'denomination.currency' | translate}} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.currencyId\" ng-options=\"currency.id as (currency.id + ' | ' + currency.name) for currency in $ctrl.currencyData\">\n<option value=\"\" disabled=\"disabled\">({{'common.select'|translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"shiptype\">{{'denomination.shiptype' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.shiptypeId\" values=\"$ctrl.shiptypeList\" key=\"Key\" totalrecords=\"$ctrl.totalRecords\" onscroll=\"$ctrl.getAllShiptype(searchKey, offset)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div class=\"form-group col-sm-2\" ng-if=\"!$ctrl.model.coinFlag\">\n<label for=\"strapCount\"> {{'denomination.strap_count' | translate}} *</label>\n<input type=\"text\" ng-currency currency-symbol=\"\" fraction=\"0\" min=\"0\" class=\"form-control\" id=\"strapCount\" ng-model=\"$ctrl.model.strapCount\" ng-required=\"$ctrl.model.shiptypeId.Value === 'C'\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.calculateCount('bundleCount')\">\n</div>\n<div class=\"form-group col-sm-2\" ng-if=\"!$ctrl.model.coinFlag\">\n<label for=\"bundleCount\">{{'denomination.bundle_count' | translate}} *</label>\n<input type=\"text\" ng-currency currency-symbol=\"\" fraction=\"0\" min=\"0\" class=\"form-control\" id=\"bundleCount\" ng-model=\"$ctrl.model.bundleCount\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-change=\"$ctrl.calculateCount('strapCount')\" ng-required=\"$ctrl.model.shiptypeId.Value === 'C'\">\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.coinFlag && $ctrl.model.coinPackaging && $ctrl.model.coinPackaging !== 'INDIVIDUAL'\">\n<label for=\"individualDenominationId\">{{'denomination.individual_denomination' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.individualDenominationId\" values=\"$ctrl.denominationList\" key=\"Key\" totalrecords=\"$ctrl.totalDenominationRecords\" onscroll=\"$ctrl.getAllDenominations(searchKey, offset)\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad denom-ui-section\">\n<div class=\"form-group _col-sm-2\">\n<label for=\"coinFlag\">{{'common.coin' | translate}} *</label>\n<div>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.coinFlag\" ng-change=\"$ctrl.onCoinFlagChange()\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group _col-sm-2\" ng-if=\"$ctrl.model.coinFlag\">\n<label for=\"coinPackaging\">{{'denomination.coinPackaging' | translate}}</label>\n<select class=\"form-control\" id=\"coinPackaging\" ng-model=\"$ctrl.model.coinPackaging\" ng-change=\"$ctrl.onCoinPackagingChange()\" ng-options=\"packaging for packaging in $ctrl.packagingOptions\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group _col-sm-2\">\n<label for=\"multiDenomPackable\" class=\"remove-white-space\">{{'denomination.multiDenomPackable' | translate}}</label>\n<div ng-class=\"{'disabled': !$ctrl.isMultiDenomPackableAllowed()}\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.multiDenomPackable\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group _col-sm-2\">\n<label for=\"unfit\">{{'denomination.unfit' | translate}}</label>\n<div>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.unfit\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group _col-sm-2\" ng-if=\"$ctrl.model.coinFlag\">\n<label for=\"sortOrder\">{{'denomination.sort_order' | translate}} *</label>\n<input type=\"number\" min=\"1\" required class=\"form-control\" id=\"sortOrder\" placeholder=\"\" ng-model=\"$ctrl.model.sortOrder\">\n</div>\n<div class=\"form-group _col-sm-4\">\n<label>\n{{'denomination.load_detect_thresholds' | translate}}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'denomination.load_detect_thresholds_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<input type=\"text\" class=\"form-control\" id=\"loadDetectThreshold\" placeholder=\"$0.00\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"$ctrl.model.loadDetectThreshold\">\n</div>\n<div class=\"form-group _col-sm-4\" ng-if=\"!$ctrl.model.coinFlag\">\n<label for=\"sortOrder\">{{'denomination.sort_order' | translate}} *</label>\n<input type=\"number\" min=\"1\" required class=\"form-control\" id=\"sortOrder\" placeholder=\"\" ng-model=\"$ctrl.model.sortOrder\">\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-2\">\n<label for=\"icon\">{{'common.current_icon' | translate}}</label>\n<hr style=\"margin-top: 0px;\"/>\n<img ng-if=\"$ctrl.model.isIconExists && $ctrl.model.id\" id=\"denomination\" ng-src=\"assets/images/{{$ctrl.model.id}}.png\" height=\"100\" width=\"100\">\n<span ng-if=\"!$ctrl.model.isIconExists\" id=\"no-icon-message\"><b>{{'common.no_icon_available' | translate}}</b></span>\n</div>\n</div>\n<div class=\"form-group col-sm-12 alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n<div>\n<button type=\"button\" ng-click=\"$ctrl.submit()\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || $ctrl.loading || $ctrl.shiptypeMismatch\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>\n";
var id1="denomination.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2842 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad environment-config environment-config-section\">\n<div class=\"w-100\">\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'environment_config.all' | translate}}\n</h4>\n</div>\n</div>\n<div class=\"text-align-center font-size-70 margin-10 col-sm-12\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-12 _remove-pad\" ng-if=\"$ctrl.environmentConfig && !$ctrl.loading\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"route-stops-bar-section col-sm-3 remove-left-pad\">\n<label>{{'environment_config.otc_anywhere' | translate}}</label>\n</div>\n<div class=\"col-sm-3 pull-right remove-right-pad\" ng-show=\"::$ctrl.hasACL['edit']\">\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn\" ng-click=\"$ctrl.addOTCConfig()\" ng-disabled=\"$ctrl.isLoading\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n</div>\n</div>\n<div class=\"div-table font-12\">\n<div class=\"row div-tr margin-top-05 otc-anywhere-section\">\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'account.company_name' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'account.user_name' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'account.user_password' | translate}}</strong>\n</div>\n</div>\n<div class=\"w-12 div-td\">\n<div class=\"dt\">\n<strong>{{'environment_config.secure' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'environment_config.host_name' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td content-no-wrap\">\n<div class=\"dt\">\n<strong>{{'environment_config.disable_lock_status' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right\">\n<div class=\"dt\">\n<strong>{{'common.action' | translate}}</strong>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<ul class=\"list-group location-sequence remove-bottom-margin\">\n<li ng-repeat=\"otcObj in $ctrl.model.otcConfig track by $index\" class=\"remove-bottom-margin display-flex border-bottom\">\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<span ng-if=\"otcObj.isDuplicate\" class=\"glyphicon glyphicon-warning-sign\" style=\"color: red; float: left; top: auto; left: -23px; position: absolute; margin-top: 8px;\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\"></span>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\" ng-model=\"otcObj.companyName\" ng-change=\"$ctrl.validateOTCConfig(); $ctrl.setPasswordMap('OTC', otcObj.companyName, 'viewPass')\">\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-disabled=\"!otcObj.companyName\" ng-model=\"otcObj.user\">\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<input type=\"password\" class=\"form-control\" ng-model=\"otcObj.password\" required ng-disabled=\"!otcObj.companyName\" ng-attr-type=\"{{ $ctrl.passWdIcon['OTC'][otcObj.companyName].viewPass ? 'text' : 'password'}}\">\n<div class=\"otc-password-icon\" ng-if=\"otcObj.companyName\" ng-click=\"$ctrl.viewPassword('OTC', otcObj.companyName, 'viewPass')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['OTC'][otcObj.companyName].viewPass ? 'glyphicon-eye-open' : 'glyphicon-eye-close'\"></i>\n</div>\n</div>\n</div>\n<div class=\"w-12 div-td\">\n<div class=\"dt\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"otcObj.secure\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-2 div-td text-center\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"otcObj.hostName\" ng-disabled=\"!otcObj.companyName\">\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"otcObj.disableLockStatus\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeOTCConfig($index); $ctrl.validateLiability();\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"header-section\"><label>{{'account.google_maps' | translate}}</label></div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-5 remove-left-pad\">\n<label for=\"googleMapFrontEndKey\">{{'environment_config.front_end_key' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"googleMapFrontEndKey\" placeholder=\"\" ng-model=\"$ctrl.model.googleMapFrontEndKey\">\n</div>\n<div class=\"col-sm-5\">\n<label for=\"googleMapBackEndKey\">{{'environment_config.back_end_key' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"googleMapBackEndKey\" placeholder=\"\" ng-model=\"$ctrl.model.googleMapBackEndKey\">\n</div>\n<div class=\"col-sm-2 remove-left-pad remove-right-pad\">\n<label for=\"maintainDriveDistance\">{{'environment_config.maintain_drive_distance' | translate}}</label>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.maintainDriveDistance\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-5 remove-left-pad\" style=\"margin-top: 16px;\">\n<label for=\"ETADistanceKey\">{{'enviornment_config.ETADistanceKey' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"ETADistanceKey\" placeholder=\"\" ng-model=\"$ctrl.model.ETADistanceKey\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"header-section\"><label>{{'environment_config.routific' | translate}}</label></div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"routificApiKey\">{{'environment_config.routific_key' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"routificApiKey\" placeholder=\"\" ng-model=\"$ctrl.model.routificApiKey\">\n</div>\n<div class=\"col-sm-2\">\n<label for=\"enable\">{{'common.enable' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.enableRoutific\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"header-section\"><label>{{'environment_config.route_optimization_engine' | translate}}</label></div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"routeOptimizationEngine\">{{'environment_config.select_engine' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.routeOptimizationEngine\" ng-options=\"item.value as item.label for item in $ctrl.routeOptimizationEngine\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">{{'common.select' | translate }}</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"header-section\"><label>{{'message.web_title' | translate}}</label></div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"page_title\">{{'environment_config.preview_text' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"page_title\" placeholder=\"\" ng-model=\"$ctrl.model.pageTitle\">\n</div>\n<div class=\"col-sm-4\">\n<label for=\"printFromLocationName\">{{'bagout.fromLocationName' | translate}} ({{'branch_mgmt.itemHistory.print' | translate}})</label>\n<input type=\"text\" class=\"form-control\" id=\"printFromLocationName\" placeholder=\"\" ng-model=\"$ctrl.model.printFromLocationName\">\n</div>\n<div class=\"col-sm-4\">\n<label for=\"printFromLocationAddress\">{{'environment_config.from_location_address_print' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"printFromLocationAddress\" placeholder=\"\" ng-model=\"$ctrl.model.printFromLocationAddress\">\n</div>\n</div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"companyName\">{{'account.company_name' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"companyName\" placeholder=\"\" ng-model=\"$ctrl.model.companyName\">\n</div>\n<div class=\"col-sm-4\">\n<label for=\"company_address\">{{'environment_config.company_address' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"company_address\" placeholder=\"\" ng-model=\"$ctrl.model.companyAddress\">\n</div>\n<div class=\"col-sm-4\">\n<label for=\"company_phoneNumber\">{{'environment_config.company_phone_number' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"company_phoneNumber\" placeholder=\"\" ng-model=\"$ctrl.model.companyPhoneNumber\" ui-us-phone-number>\n</div>\n</div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"company_email\">{{'environment_config.company_email' | translate}}</label>\n<input type=\"email\" class=\"form-control\" id=\"company_email\" placeholder=\"\" ng-model=\"$ctrl.model.companyEmail\">\n</div>\n<div class=\"col-sm-8\">\n<label for=\"company_footerText\">{{'environment_config.footer_text' | translate}}</label>\n<textarea class=\"form-control\" id=\"company_footerText\" placeholder=\"\" ng-model=\"$ctrl.model.footerText\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"companyLogo\">{{'environment_config.company_logo' | translate}}</label>\n<div>\n<input-file ng-model=\"$ctrl.model.companyLogo\" btn-class=\"btn btn2\" file-types=\"image/*\" selected-files=\"$ctrl.model.selectedFiles\">\n</input-file>\n</div>\n<div class=\"_margin-top-05\" ng-if=\"$ctrl.model.companyLogo.length\">\n<a href=\"#\" class=\"btn btn-info btn-md\" ng-click=\"$ctrl.viewAppLogo($ctrl.model.companyLogo, 'Company Logo')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</a>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"printLogo\">{{'environment_config.print_logo' | translate}}</label>\n<div>\n<input-file ng-model=\"$ctrl.model.printLogo\" btn-class=\"btn btn2\" file-types=\"image/*\" selected-files=\"$ctrl.model.selectedFiles\">\n</input-file>\n</div>\n<div class=\"_margin-top-05\" ng-if=\"$ctrl.model.printLogo.length\">\n<a href=\"#\" class=\"btn btn-info btn-md\" ng-click=\"$ctrl.viewAppLogo($ctrl.model.printLogo, 'Print Logo')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</a>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"sessionLength\">{{'environment_config.session_length' | translate}}</label>\n<input type=\"number\" min=\"1\" class=\"form-control\" id=\"sessionLength\" ng-pattern=\"/^(0|[1-9]\\d*)$/\" placeholder=\"\" ng-model=\"$ctrl.model.sessionLength\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"header-section\"><label>{{'environment_config.nfc_controls' | translate}}</label></div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"communicationPassword\">{{'environment_config.communication_password' | translate}}</label>\n<input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.communicationPassword\" id=\"communication-password\" ng-attr-type=\"{{ $ctrl.passWdIcon['NFC'].viewCommunicationPassword ? 'text' : 'password'}}\" ng-pattern=\"/^[0-9]*$/\">\n<div class=\"password-icon\" ng-click=\"$ctrl.viewPassword('NFC', null, 'viewCommunicationPassword')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['NFC'].viewCommunicationPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"cryptographyPassword\">{{'environment_config.cryptography_password' | translate}}</label>\n<input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.cryptographyPassword\" id=\"cryptography-password\" ng-attr-type=\"{{ $ctrl.passWdIcon['NFC'].viewCryptographyPassword ? 'text' : 'password'}}\">\n<div class=\"password-icon\" ng-click=\"$ctrl.viewPassword('NFC', null, 'viewCryptographyPassword')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['NFC'].viewCryptographyPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"masterPassword\">{{'environment_config.master_password' | translate}}</label>\n<input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.masterPassword\" id=\"master-password\" ng-attr-type=\"{{ $ctrl.passWdIcon['NFC'].viewMasterPassword ? 'text' : 'password'}}\">\n<div class=\"password-icon\" ng-click=\"$ctrl.viewPassword('NFC', null, 'viewMasterPassword')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['NFC'].viewMasterPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"header-section\"><label>{{'shipment.bagout' | translate}}</label></div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"enable\">{{'environment_config.generate_xml_file' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.generateXMLFile\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"enable\">{{'environment_config.generate_csv_file' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.generateCSVFile\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"bagOutScanLimit\">Max. Bagout Character Length</label>\n<input type=\"number\" min=\"1\" class=\"form-control\" id=\"bagOutScanLimit\" placeholder=\"\" ng-model=\"$ctrl.model.bagOutScanLimit\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"header-section\"><label>{{'environment_config.cron_scheduler' | translate}}</label></div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"enable\">{{'environment_config.otc_user_sync' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.OTCUserSync\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"enable\">{{'environment_config.auto_create_packable_shipment' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.autoCreatePackableShipment\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"enable\">{{'environment_config.auto_assign_service_tickets' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.autoAssignServiceTickets\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"header-section\"><label>{{'environment_config.2FA' | translate}}</label></div>\n<div class=\"col-sm-04 _form-group\">\n<div class=\"col-sm-4\">\n<label for=\"2FA\">{{'common.enable' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.enable2FA\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"header-section\"><label>{{'environment_config.other_control' | translate}}</label></div>\n<div class=\"col-sm-04 _form-group\">\n<div class=\"col-sm-4\">\n<label for=\"2FA\">{{'environment_config.enable_route_progress_tracking' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.enableRouteProgressTracking\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"2FA\">{{'environment_config.auto_reassign' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.autoReassign\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"bluetoothScanner\">{{'environment_config.prompt_bluetooth_scanner' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.promptBluetoothScanner\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"header-section\">\n<label>{{'environment_config.permissions' | translate}}\n<i class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"Add comma separated string (e.g Coorworks Admin, Robin Miles)\" tooltip-placement=\"right\"></i>\n</label>\n</div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"atmCodesPermission\">{{'common.side_menu.atm_codes_mgmt' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"atmCodesPermission\" placeholder=\"\" ng-model=\"$ctrl.model.atmCodesPermission\" ng-pattern=\"/^([a-z0-9\\s]+,)*([a-z0-9\\s]+)$/i\" ng-change=\"$ctrl.validatePermissions()\">\n<div class=\"text-danger\" ng-if=\"$ctrl.permissionErrors.atmCodesPermission !== null\">{{$ctrl.permissionErrors.atmCodesPermission}}</div>\n</div>\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"settingsPermission\">{{'common.side_menu.settings' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"settingsPermission\" placeholder=\"\" ng-model=\"$ctrl.model.settingsPermission\" ng-pattern=\"/^([a-z0-9\\s]+,)*([a-z0-9\\s]+)$/i\" ng-change=\"$ctrl.validatePermissions()\">\n<div class=\"text-danger\" ng-if=\"$ctrl.permissionErrors.settingsPermission !== null\">{{$ctrl.permissionErrors.settingsPermission}}</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"tntBypassCodePermission\">{{'branch_mgmt.tnt_bypass_code.title' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"tntBypassCodePermission\" placeholder=\"\" ng-model=\"$ctrl.model.tntBypassCodePermission\" ng-pattern=\"/^([a-z0-9\\s]+,)*([a-z0-9\\s]+)$/i\" ng-change=\"$ctrl.validatePermissions()\">\n<div class=\"text-danger\" ng-if=\"$ctrl.permissionErrors.tntBypassCodePermission !== null\">{{$ctrl.permissionErrors.tntBypassCodePermission}}</div>\n</div>\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"environmentConfigPermission\">{{'environment_config.menu.title' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"environmentConfigPermission\" placeholder=\"\" ng-model=\"$ctrl.model.environmentConfigPermission\" ng-pattern=\"/^([a-z0-9\\s]+,)*([a-z0-9\\s]+)$/i\" ng-change=\"$ctrl.validatePermissions()\">\n<div class=\"text-danger\" ng-if=\"$ctrl.permissionErrors.environmentConfigPermission !== null\">{{$ctrl.permissionErrors.environmentConfigPermission}}</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"vaultOperationsPermission\">{{'environment_config.vault_operations' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"vaultOperationsPermission\" placeholder=\"\" ng-model=\"$ctrl.model.vaultOperationsPermission\" ng-pattern=\"/^([a-z0-9\\s]+,)*([a-z0-9\\s]+)$/i\" ng-change=\"$ctrl.validatePermissions()\">\n<div class=\"text-danger\" ng-if=\"$ctrl.permissionErrors.vaultOperationsPermission !== null\">{{$ctrl.permissionErrors.vaultOperationsPermission}}</div>\n</div>\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"bulkCashPermission\">{{'environment_config.bulk_cash_credit_debit' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"bulkCashPermission\" placeholder=\"\" ng-model=\"$ctrl.model.bulkCashPermission\" ng-pattern=\"/^([a-z0-9\\s]+,)*([a-z0-9\\s]+)$/i\" ng-change=\"$ctrl.validatePermissions()\">\n<div class=\"text-danger\" ng-if=\"$ctrl.permissionErrors.bulkCashPermission !== null\">{{$ctrl.permissionErrors.bulkCashPermission}}</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"userEditPermission\">Users Edit</label>\n<input type=\"text\" class=\"form-control\" id=\"userEditPermission\" placeholder=\"\" ng-model=\"$ctrl.model.userEditPermission\" ng-pattern=\"/^([a-z0-9\\s]+,)*([a-z0-9\\s]+)$/i\" ng-change=\"$ctrl.validatePermissions()\">\n<div class=\"text-danger\" ng-if=\"$ctrl.permissionErrors.userEditPermission !== null\">{{$ctrl.permissionErrors.userEditPermission}}</div>\n</div>\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"softDeleteShipmentPermission\">Soft Delete Shipment</label>\n<input type=\"text\" class=\"form-control\" id=\"softDeleteShipmentPermission\" placeholder=\"\" ng-model=\"$ctrl.model.softDeleteShipmentPermission\" ng-pattern=\"/^([a-z0-9\\s]+,)*([a-z0-9\\s]+)$/i\" ng-change=\"$ctrl.validatePermissions()\">\n<div class=\"text-danger\" ng-if=\"$ctrl.permissionErrors.softDeleteShipmentPermission\">{{$ctrl.permissionErrors.softDeleteShipmentPermission}}</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"changeVaultDatePermission\">Change Vault Date</label>\n<input type=\"text\" class=\"form-control\" id=\"changeVaultDatePermission\" placeholder=\"\" ng-model=\"$ctrl.model.changeVaultDatePermission\" ng-pattern=\"/^([a-z0-9\\s]+,)*([a-z0-9\\s]+)$/i\" ng-change=\"$ctrl.validatePermissions()\">\n<div class=\"text-danger\" ng-if=\"$ctrl.permissionErrors.changeVaultDatePermission\">{{$ctrl.permissionErrors.changeVaultDatePermission}}</div>\n</div>\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"automatedRoutingControlPermission\">Automated Routing Control</label>\n<input type=\"text\" class=\"form-control\" id=\"automatedRoutingControlPermission\" placeholder=\"\" ng-model=\"$ctrl.model.automatedRoutingControlPermission\" ng-pattern=\"/^([a-z0-9\\s]+,)*([a-z0-9\\s]+)$/i\" ng-change=\"$ctrl.validatePermissions()\">\n<div class=\"text-danger\" ng-if=\"$ctrl.permissionErrors.automatedRoutingControlPermission\">{{$ctrl.permissionErrors.automatedRoutingControlPermission}}</div>\n</div>\n</div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"bulkUpdateUserPermission\">Bulk Update User Permission</label>\n<input type=\"text\" class=\"form-control\" id=\"bulkUpdateUserPermission\" placeholder=\"\" ng-model=\"$ctrl.model.bulkUpdateUserPermission\" ng-pattern=\"/^([a-z0-9\\s]+,)*([a-z0-9\\s]+)$/i\" ng-change=\"$ctrl.validatePermissions()\">\n<div class=\"text-danger\" ng-if=\"$ctrl.permissionErrors.bulkUpdateUserPermission\">{{$ctrl.permissionErrors.bulkUpdateUserPermission}}</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad\">\n<div class=\"header-section\">\n<label>{{'environment_config.fuel_rate_import' | translate}}\n</label></div>\n<div class=\"col-sm-6\">\n<label for=\"userEditPermission\">{{'account.url' | translate}}</label>\n<input type=\"text\" class=\"form-control\" placeholder=\"https://example.com\" ng-model=\"$ctrl.model.fuelRateImportDataURL\" ng-pattern=\"/^(https?:\\/\\/)?(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)$/\">\n</div>\n<div class=\"col-sm-4\">\n<label for=\"fuelRateImportStatus\">{{'bagout.status' | translate}}</label>\n<br>\n<div class=\"btn-group\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.fuelRateImportStatus\" uib-btn-radio=\"$ctrl.stats.active\" ng-click=\"$ctrl.tabSelection('active')\" ng-class=\"{\n                                    'btn-success': $ctrl.model.fuelRateImportStatus === $ctrl.stats.active,\n                                    'fuel-rate-status-section': $ctrl.model.fuelRateImportStatus !== $ctrl.stats.active\n                                }\">\n{{ 'common.active' | translate }}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" ng-model=\"$ctrl.model.fuelRateImportStatus\" uib-btn-radio=\"$ctrl.stats.suspended\" ng-click=\"$ctrl.tabSelection('suspended')\" ng-class=\"{\n                                    'btn-danger': $ctrl.model.fuelRateImportStatus === $ctrl.stats.suspended,\n                                    'fuel-rate-status-section': $ctrl.model.fuelRateImportStatus !== $ctrl.stats.suspended\n                                }\">\n{{ 'common.suspended' | translate }}\n</label>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\" ng-if=\"!$ctrl.loading\">\n<div class=\"header-section col-sm-12 remove-left-pad remove-right-pad\"><label>{{'common.reference' | translate}}</label></div>\n<div class=\"col-sm-12 _form-group\">\n<table class=\"table table-bordered table-striped remove-pad-bottom font-12\" ng-if=\"$ctrl.model.paths.length\">\n<thead>\n<tr class=\"_header-row\">\n<th>{{'serviceSettings.label' | translate}}</th>\n<th>{{'common.path' | translate}}</th>\n</tr>\n</thead>\n<tr ng-repeat=\"detail in $ctrl.model.paths\" ng-if=\"detail.value\">\n<td>{{detail.label}}</td>\n<td class=\"wrap-text\">\n<span ng-if=\"detail.label !== 'SFTP Watch'\">{{detail.value}}</span>\n<div ng-repeat=\"path in detail.value track by $index\" ng-if=\"detail.label === 'SFTP Watch'\">\n<span>\n{{path}}<span ng-if=\"$index + 1 !== detail.value.length\">,</span>\n</span>\n</div>\n</td>\n</tr>\n</table>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-top-20\">\n<div class=\"alert alert-danger remove-bottom-margin\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n</div>\n<div class=\"col-sm-12 margin-bottom-10 remove-left-pad\" ng-show=\"::$ctrl.hasACL['edit']\">\n<button type=\"button\" ng-click=\"$ctrl.update()\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || !$ctrl.isValidLength() || $ctrl.loading || $ctrl.hasPermissionErrors()\" ng-class=\"{'disabled': $ctrl.isUpdating || $ctrl.loading}\" ng-if=\"!$ctrl.loading\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.isUpdating}\"></span>\n{{'common.update' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-if=\"!$ctrl.loading\" ng-class=\"{'disabled': $ctrl.isUpdating || $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>\n<div ng-if=\"!$ctrl.environmentConfig && !$ctrl.loading\">\n<div class=\"col-sm-12 alert alert-danger text-center\"> {{'common.no_data_found' | translate}}</div>\n</div>\n</div>\n";
var id1="environment_config.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2843 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid environment-config\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"heading-section\">\n<h4 translate=\"environment_config.create\"></h4>\n<hr/>\n</div>\n<div class=\"text-align-center font-size-70 margin-10\" ng-if=\"$ctrl.gettingDetails\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-12 _remove-pad\" ng-if=\"!$ctrl.environmentConfig && !$ctrl.gettingDetails\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"route-stops-bar-section col-sm-3 remove-left-pad\">\n<label>{{'environment_config.otc_anywhere' | translate}}</label>\n</div>\n<div class=\"col-sm-3 pull-right remove-right-pad\">\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn\" ng-click=\"$ctrl.addOTCConfig()\" ng-disabled=\"$ctrl.isLoading\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n</div>\n</div>\n<div class=\"div-table font-12\">\n<div class=\"row div-tr margin-top-05 otc-anywhere-section\">\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'account.company_name' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'account.user_name' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'account.user_password' | translate}}</strong>\n</div>\n</div>\n<div class=\"w-12 div-td\">\n<div class=\"dt\">\n<strong>{{'environment_config.secure' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'environment_config.host_name' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td content-no-wrap\">\n<div class=\"dt\">\n<strong>{{'environment_config.disable_lock_status' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right\">\n<div class=\"dt\">\n<strong>{{'common.action' | translate}}</strong>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<ul class=\"list-group location-sequence remove-bottom-margin\">\n<li ng-repeat=\"otcObj in $ctrl.model.otcConfig track by $index\" class=\"remove-bottom-margin display-flex border-bottom\">\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<span ng-if=\"otcObj.isDuplicate\" class=\"glyphicon glyphicon-warning-sign\" style=\"color: red; float: left; top: auto; left: -23px; position: absolute; margin-top: 8px;\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\"></span>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\" ng-model=\"otcObj.companyName\" ng-change=\"$ctrl.validateOTCConfig(); $ctrl.setPasswordMap('OTC', otcObj.companyName, 'viewPass')\">\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-disabled=\"!otcObj.companyName\" ng-model=\"otcObj.user\">\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<input type=\"password\" class=\"form-control\" ng-model=\"otcObj.password\" required ng-disabled=\"!otcObj.companyName\" ng-attr-type=\"{{ $ctrl.passWdIcon['OTC'][otcObj.companyName].viewPass ? 'text' : 'password'}}\">\n<div class=\"otc-password-icon\" ng-if=\"otcObj.companyName\" ng-click=\"$ctrl.viewPassword('OTC', otcObj.companyName, 'viewPass')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['OTC'][otcObj.companyName].viewPass ? 'glyphicon-eye-open' : 'glyphicon-eye-close'\"></i>\n</div>\n</div>\n</div>\n<div class=\"w-12 div-td\">\n<div class=\"dt\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"otcObj.secure\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-2 div-td text-center\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"otcObj.hostName\" ng-disabled=\"!otcObj.companyName\">\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"otcObj.disableLockStatus\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeOTCConfig($index); $ctrl.validateLiability();\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"header-section\"><label>Google Map</label></div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-5 remove-left-pad\">\n<label for=\"googleMapFrontEndKey\">Front End Key</label>\n<input type=\"text\" class=\"form-control\" id=\"googleMapFrontEndKey\" placeholder=\"\" ng-model=\"$ctrl.model.googleMapFrontEndKey\">\n</div>\n<div class=\"col-sm-5\">\n<label for=\"googleMapBackEndKey\">Back End Key</label>\n<input type=\"text\" class=\"form-control\" id=\"googleMapBackEndKey\" placeholder=\"\" ng-model=\"$ctrl.model.googleMapBackEndKey\">\n</div>\n<div class=\"col-sm-2 remove-left-pad remove-right-pad\">\n<label for=\"maintainDriveDistance\">{{'environment_config.maintain_drive_distance' | translate}}</label>\n<input class=\"margin-top-02\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.maintainDriveDistance\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-5 remove-left-pad\" style=\"margin-top: 16px;\">\n<label for=\"ETADistanceKey\">{{'enviornment_config.ETADistanceKey' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"ETADistanceKey\" placeholder=\"\" ng-model=\"$ctrl.model.ETADistanceKey\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"header-section\"><label>{{'environment_config.routific' | translate}}</label></div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"routificApiKey\">{{'environment_config.routific_key' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"routificApiKey\" placeholder=\"\" ng-model=\"$ctrl.model.routificApiKey\">\n</div>\n<div class=\"col-sm-2\">\n<label for=\"routificApiKey\">{{'common.enable' | translate}}</label>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.enableRoutific\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"header-section\"><label>{{'environment_config.route_optimization_engine' | translate}}</label></div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"routeOptimizationEngine\">{{'environment_config.route_optimization_engine' | translate}} *</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.routeOptimizationEngine\" ng-options=\"item.value as item.label for item in $ctrl.routeOptimizationEngine\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">{{'common.select' | translate }}</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"header-section\"><label>{{'message.web_title' | translate}}</label></div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"page_title\">{{'environment_config.preview_text' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"page_title\" placeholder=\"\" ng-model=\"$ctrl.model.pageTitle\">\n</div>\n<div class=\"col-sm-4\">\n<label for=\"printFromLocationName\">{{'bagout.fromLocationName' | translate}} ({{'branch_mgmt.itemHistory.print' | translate}})</label>\n<input type=\"text\" class=\"form-control\" id=\"printFromLocationName\" placeholder=\"\" ng-model=\"$ctrl.model.printFromLocationName\">\n</div>\n<div class=\"col-sm-4\">\n<label for=\"printFromLocationAddress\">{{'environment_config.from_location_address_print' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"printFromLocationAddress\" placeholder=\"\" ng-model=\"$ctrl.model.printFromLocationAddress\">\n</div>\n</div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"companyName\">{{'account.company_name' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"companyName\" placeholder=\"\" ng-model=\"$ctrl.model.companyName\">\n</div>\n<div class=\"col-sm-4\">\n<label for=\"company_address\">{{'environment_config.company_address' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"company_address\" placeholder=\"\" ng-model=\"$ctrl.model.companyAddress\">\n</div>\n<div class=\"col-sm-4\">\n<label for=\"company_phoneNumber\">{{'environment_config.company_phone_number' | translate}}</label>\n<input type=\"text\" class=\"form-control\" id=\"company_phoneNumber\" placeholder=\"\" ng-model=\"$ctrl.model.companyPhoneNumber\" ui-us-phone-number>\n</div>\n</div>\n<div class=\"col-sm-12 form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"company_email\">{{'environment_config.company_email' | translate}}</label>\n<input type=\"email\" class=\"form-control\" id=\"company_email\" placeholder=\"\" ng-model=\"$ctrl.model.companyEmail\">\n</div>\n<div class=\"col-sm-8\">\n<label for=\"company_footerText\">{{'environment_config.footer_text' | translate}}</label>\n<textarea class=\"form-control\" id=\"company_footerText\" placeholder=\"\" ng-model=\"$ctrl.model.footerText\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"companyLogo\">{{'environment_config.company_logo' | translate}}</label>\n<div>\n<input-file ng-model=\"$ctrl.model.companyLogo\" btn-class=\"btn btn2\" file-types=\"image/*\" selected-files=\"$ctrl.model.selectedFiles\">\n</input-file>\n</div>\n<div class=\"_margin-top-05\" ng-if=\"$ctrl.model.companyLogo.length\">\n<a href=\"#\" class=\"btn btn-info btn-md\" ng-click=\"$ctrl.viewAppLogo($ctrl.model.companyLogo, 'Company Logo')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</a>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"printLogo\">{{'environment_config.print_logo' | translate}}</label>\n<div class=\"_col-sm-2\">\n<input-file ng-model=\"$ctrl.model.printLogo\" btn-class=\"btn btn2\" file-types=\"image/*\" selected-files=\"$ctrl.model.selectedFiles\">\n</input-file>\n</div>\n<div class=\"_margin-top-05\" ng-if=\"$ctrl.model.printLogo.length\">\n<a href=\"#\" class=\"btn btn-info btn-md\" ng-click=\"$ctrl.viewAppLogo($ctrl.model.printLogo, 'Print Logo')\">\n<span class=\"glyphicon glyphicon-paperclip btn-link-color-black img-width\"></span>\n</a>\n</div>\n</div>\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"sessionLength\">{{'environment_config.session_length' | translate}}</label>\n<input type=\"number\" min=\"1\" class=\"form-control\" id=\"sessionLength\" ng-pattern=\"/^$|^[1-9]+$/\" placeholder=\"\" ng-model=\"$ctrl.model.sessionLength\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"header-section\"><label>{{'environment_config.nfc_controls' | translate}}</label></div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"communicationPassword\">{{'environment_config.communication_password' | translate}}</label>\n<input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.communicationPassword\" id=\"communication-password\" ng-attr-type=\"{{ $ctrl.passWdIcon['NFC'].viewCommunicationPassword ? 'text' : 'password'}}\" ng-pattern=\"/^[0-9]*$/\">\n<div class=\"password-icon\" ng-click=\"$ctrl.viewPassword('NFC', null, 'viewCommunicationPassword')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['NFC'].viewCommunicationPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"cryptographyPassword\">{{'environment_config.cryptography_password' | translate}}</label>\n<input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.cryptographyPassword\" id=\"cryptography-password\" ng-attr-type=\"{{ $ctrl.passWdIcon['NFC'].viewCryptographyPassword ? 'text' : 'password'}}\">\n<div class=\"password-icon\" ng-click=\"$ctrl.viewPassword('NFC', null, 'viewCryptographyPassword')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['NFC'].viewCryptographyPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"masterPassword\">{{'environment_config.master_password' | translate}}</label>\n<input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.masterPassword\" id=\"master-password\" ng-attr-type=\"{{ $ctrl.passWdIcon['NFC'].viewMasterPassword ? 'text' : 'password'}}\">\n<div class=\"password-icon\" ng-click=\"$ctrl.viewPassword('NFC', null, 'viewMasterPassword')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon['NFC'].viewMasterPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"header-section\"><label>{{'shipment.bagout' | translate}}</label></div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"enable\">{{'environment_config.generate_xml_file' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.generateXMLFile\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"enable\">{{'environment_config.generate_csv_file' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.generateCSVFile\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-4 remove-left-pad\">\n<label for=\"bagOutScanLimit\">Max. Bagout Character Length</label>\n<input type=\"number\" min=\"1\" class=\"form-control\" id=\"bagOutScanLimit\" placeholder=\"\" ng-model=\"$ctrl.model.bagOutScanLimit\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"header-section\"><label>{{'environment_config.cron_scheduler' | translate}}</label></div>\n<div class=\"col-sm-12 _form-group\">\n<div class=\"col-sm-6 remove-left-pad\">\n<label for=\"enable\">{{'environment_config.otc_user_sync' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.OTCUserSync\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"header-section\"><label>{{'environment_config.2FA' | translate}}</label></div>\n<div class=\"col-sm-04 _form-group\">\n<div class=\"col-sm-6\">\n<label for=\"2FA\">{{'common.enable' | translate}}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.enable2FA\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad margin-top-20\">\n<div class=\"alert alert-danger remove-bottom-margin\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n</div>\n<div class=\"col-sm-12 margin-bottom-10 remove-left-pad\">\n<button type=\"button\" ng-click=\"$ctrl.create(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || !$ctrl.isValid()\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n<div ng-if=\"$ctrl.environmentConfig\">\n<div class=\"col-sm-12 alert alert-danger text-center\">{{'environment_config.already_exists_msg' | translate}}</div>\n</div>\n</form>\n</div>\n";
var id1="environment_config.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2844 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="";
var id1="environment_config.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2845 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"environment_config.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"environment_config.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"environment_config.create\">\n<a translate=\"environment_config.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="environment_config.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2846 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<div class=\"w-100\">\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'location_zone.all_location_zone' | translate}} <span ng-if=\"$ctrl.model.locationZoneObj.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"remove-pad collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.model.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'branchFundingSource.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div class=\"text-align-center font-size-70 margin-10\" ng-if=\"$ctrl.model.locationZoneObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div ng-if=\"!$ctrl.model.locationZoneObj.loading\">\n<div ng-if=\"$ctrl.model.locationZoneObj.results.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"locationZone in $ctrl.model.locationZoneObj.results track by locationZone.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{locationZone.id}} | {{locationZone.name}}\n<span class=\"text-success\"> | {{locationZone.type}}</span>\n<span> | {{locationZone.branchId}}</span>\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(locationZone)\" uib-tooltip=\"{{ 'common.Edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['delete']\" ng-click=\"$ctrl.delete(locationZone)\" uib-tooltip=\"{{ 'common.Delete' | translate }}\" ng-disabled=\"$ctrl.allowOnlyOnce\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.model.locationZoneObj.totalRecords\" ng-hide=\"($ctrl.model.locationZoneObj.totalRecords<=$ctrl.model.locationZoneObj.pagination.pageLimit)&&($ctrl.model.locationZoneObj.pagination.page==1)\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.locationZoneObj.pagination.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n\n</div>\n<div class=\"text-align-center\" ng-if=\"!$ctrl.model.locationZoneObj.loading && !$ctrl.model.locationZoneObj.results.length\">\n<span class=\"alert alert-danger col-sm-12\">{{'locationZone.noData' | translate}}</span>\n</div>\n</div>\n</div>";
var id1="location_zone.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2847 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"heading-section\">\n<h4 translate=\"location_zone.create_location_zone\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"shipment-form-section\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"label\" class=\"font-12\">{{'locationZone.name' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.name\">\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"serial-number\" class=\"font-12\">{{'locationZone.type' | translate }}</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.type\" ng-options=\"type.value as type.label for type in $ctrl.locationZoneTypes\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"label\" class=\"font-12\">{{'common.branch_id' | translate}}</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.branchId\" ng-options=\"branch for branch in $ctrl.branch\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 form-group\">\n<label for=\"description\" class=\"font-12\">{{'locationZone.description' | translate }} </label>\n<textarea class=\"form-control\" placeholder=\"\" rows=\"2\" ng-model=\"$ctrl.model.description\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n</form>\n</div>\n</div>";
var id1="location_zone.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2848 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"heading-section\">\n<h4 translate=\"location_zone.edit_location_zone\"></h4>\n<hr/>\n</div>\n<div class=\"text-align-center font-size-70 margin-10\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.model.loading\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3 form-group\">\n<label for=\"label\" class=\"font-12\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" disabled=\"disabled\" ng-model=\"$ctrl.rawId\">\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"label\" class=\"font-12\">{{'locationZone.name' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.name\">\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"serial-number\" class=\"font-12\">{{'locationZone.type' | translate }}</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.type\" ng-options=\"type.value as type.label for type in $ctrl.locationZoneTypes\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"label\" class=\"font-12\">{{'common.branch_id' | translate}}</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.branchId\" ng-options=\"branch for branch in $ctrl.branch\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 form-group\">\n<label for=\"description\" class=\"font-12\">{{'locationZone.description' | translate }} </label>\n<textarea class=\"form-control\" placeholder=\"\" rows=\"2\" ng-model=\"$ctrl.model.description\"></textarea>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3 form-group\">\n<label for=\"label\" class=\"font-12\">{{'locationZone.created_time' | translate }} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" disabled=\"disabled\" ng-model=\"$ctrl.model.createdAt\">\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"serial-number\" class=\"font-12\">{{'common.created_by_user' | translate }}</label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" disabled=\"disabled\" ng-model=\"$ctrl.model.createdByUserId\">\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"label\" class=\"font-12\">{{'locationZone.updated_time' | translate }} </label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" disabled=\"disabled\" ng-model=\"$ctrl.model.updatedAt\">\n</div>\n<div class=\"col-sm-3 form-group\">\n<label for=\"serial-number\" class=\"font-12\">{{'common.updated_by_user' | translate }}</label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" disabled=\"disabled\" ng-model=\"$ctrl.model.modifiedByUserId\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.update(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.model.isUpdating}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.model.isUpdating}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.model.isUpdating}\">{{'common.reset' | translate }}</button>\n</div>\n<div class=\"col-sm-12 margin-10\">\n<div class=\"alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n</div>\n</div>\n</form>\n</div>\n</div>";
var id1="location_zone.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2849 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"location_zone.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"location_zone.all_location_zone\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="location_zone.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2850 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"_navbar-brand msg-title-section remove-pad-left margin-10\">\n{{'message.all_messages' | translate}}\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"remove-right-pad navbar-form navbar-right\">\n<div class=\"btn-group _margin-bottom-10\">\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" id=\"english\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.english\" ng-click=\"$ctrl.tabSelection('E');\" ng-class=\"{'btn-success': $ctrl.model.selectedLanguage === 'E'}\">\n{{ 'users.E' | translate}}\n</label>\n</div>\n<div class=\"btn-group\">\n<label class=\"btn btn-default ignore-validation-css\" id=\"spanish\" ng-model=\"$ctrl.model.stats\" uib-btn-radio=\"$ctrl.stats.spanish\" ng-click=\"$ctrl.tabSelection('S');\" ng-class=\"{'btn-success': $ctrl.model.selectedLanguage === 'S'}\">\n{{ 'users.S' | translate}}\n</label>\n</div>\n</div>\n<div class=\"form-group\">\n<select class=\"form-control\" ng-change=\"$ctrl.loadData()\" ng-model=\"$ctrl.model.serchText\" ng-options=\"type.value as type.label for type in  $ctrl.messageTypes\">\n<option value=\"\" selected=\"selected\">({{'message.all' | translate}})</option>\n</select>\n</div>\n</form>\n</div>\n</div>\n<div class=\"margin-top-20 text-align-center font-size-70 col-sm-12\" ng-if=\"$ctrl.model.loadBuckets && !$ctrl.model.errorMessage\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"form-row remove-pad\" ng-if=\"!$ctrl.model.loadBuckets\">\n<div ng-class=\"{'padding-bottom-50': !$ctrl.model.loadBuckets && !$ctrl.model.errorMessage && $ctrl.model.buckets.results.length}\">\n<div class=\"panel panel-default margin-bottom-10 _remove-bottom-pad message-type-panel\" ng-repeat=\"bucket in $ctrl.model.buckets.results track by $index\">\n<div class=\"cursor-pointer panel-heading\">\n<div class=\"row panel-title panel-title-center bucket_text_align_center remove-left-padd remove-right-padd\">\n<div class=\"col-sm-10 remove-left-padd remove-right-padd\" ng-click=\"bucket.bucketExpanded = !bucket.bucketExpanded; $ctrl.setPage(bucket.bucketExpanded, bucket.messageType); $ctrl.getLanguageMessages(bucket)\">\n<i class=\"glyphicon glyphicon-triangle-bottom\" ng-show=\"bucket.bucketExpanded\"></i>\n<i class=\"glyphicon glyphicon-triangle-right\" ng-hide=\"bucket.bucketExpanded\"></i>\n<strong class=\"f-14\">{{$ctrl.translateMessageType(bucket.messageType)}}\n<span ng-if=\"(bucket.messageType == 'M' || bucket.messageType == 'D_R' || bucket.messageType == 'CNT' || bucket.messageType == 'D_CNT' || bucket.messageType == 'R' || bucket.messageType == 'NP')\" uib-tooltip=\"{{'message.mobile_title' | translate}}\" class=\"glyphicon glyphicon-phone\">\n</span>\n<span ng-if=\"(bucket.messageType == 'T' || bucket.messageType == 'SM' || bucket.messageType == 'UI' || bucket.messageType == 'H')\" uib-tooltip=\"{{'message.web_title' | translate}}\" class=\"glyphicon glyphicon-blackboard\">\n</span>\n</strong>\n<span class=\"message-type-badge-color badge\">{{bucket.total}}</span>\n</div>\n<div class=\"col-sm-2 pull-right\">\n<button type=\"button\" class=\"btn btn-success btn-xs pull-right\" ng-click=\"$ctrl.createLanguageMessage(bucket)\" ng-if=\"$ctrl.hasACL['create']\">\n<span class=\"glyphicon glyphicon-plus\"></span></button>\n</div>\n</div>\n</div>\n<div class=\"align-center-horizontally\" ng-show=\"bucket.bucketExpanded && $ctrl.model.bucketList[bucket.messageType].loading\">\n<div class=\"text-align-center text-center no-data-margin-10\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 30px\"></span>\n</div>\n</div>\n<div class=\"table-responsive\" ng-show=\"bucket.bucketExpanded && bucket.total > 0 && !$ctrl.model.bucketList[bucket.messageType].loading\">\n<div class=\"language-message-filter-section margin-top-05 col-sm-12\">\n<input type=\"text\" class=\"form-control bucket-search\" id=\"{{bucket.messageType}}-bucketSearch\" ng-model=\"$ctrl.model.bucketList[bucket.messageType].searchKey\" name=\"searchKey\" ng-model-options=\"{debounce: 1000}\" ng-change=\"$ctrl.searchLanguageMessages(bucket)\" placeholder=\"{{'message.search_title' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\"/>\n</div>\n<div class=\"language-message-filter-section col-sm-12 location-history-alert-section\" ng-show=\"!$ctrl.model.bucketList[bucket.messageType].loading && bucket.bucketExpanded && !$ctrl.model.bucketList[bucket.messageType].results.length\">\n<span class=\"remove-bottom-margin alert-danger col-sm-12 alert errLblPos text-center\">{{'common.no_data_found' | translate}}</span>\n</div>\n<ul class=\"col-sm-12 remove-bottom-pad language-message-list-group list-group\">\n<li class=\"list-group-item\" ng-repeat=\"message in $ctrl.model.bucketList[bucket.messageType].results track by message.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-8\">\n<span class=\"list-group-item-text\">\n<div class=\"col-sm-12\">\n<strong>{{message.description}}</strong> | {{message.languageName}}\n</div>\n</span>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\"></div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" tooltip-placement=\"left-top\" ng-click=\"$ctrl.updateLanguageMessageModal(message, bucket)\" uib-tooltip=\"{{ 'message.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['delete']\" tooltip-placement=\"left-top\" ng-click=\"$ctrl.delete(message, bucket)\" uib-tooltip=\"{{ 'message.tooltip_delete' | translate }}\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<div class=\"language-message-pagination-section\" ng-if=\"$ctrl.model.bucketList[bucket.messageType].totalRecords > $ctrl.model.bucketList[bucket.messageType].pagination.pageLimit\">\n<ul uib-pagination total-items=\"$ctrl.model.bucketList[bucket.messageType].totalRecords\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.messageTypeList[bucket.messageType].page\" ng-change=\"$ctrl.pageChange(bucket)\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad align-center-horizontally\" ng-if=\"!$ctrl.model.loadBuckets && !$ctrl.model.errorMessage && !$ctrl.model.buckets.results.length\">\n<div class=\"col-sm-12 alert errLblPos text-center\" ng-class=\"{'alert-danger': !$ctrl.isValid}\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad items-err-lbl-margin-top\" ng-if=\"!$ctrl.model.loadBuckets && $ctrl.model.errorMessage\">\n<div class=\"col-sm-12 alert errLblPos text-center\" ng-class=\"{'alert-danger': $ctrl.model.errorMessage}\">\n<span>{{$ctrl.model.errorMessage}}</span>\n</div>\n</div>\n</form>";
var id1="message.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2851 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"message.create_message\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"message-id\">{{'message.messageId' | translate}} *</label>\n<input type=\"text\" id=\"message-id\" ng-model=\"$ctrl.model.messageId\" class=\"form-control\" required/>\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"message-id\">{{'message.type' | translate}} *</label>\n<select ng-model=\"$ctrl.model.type\" ng-options=\"type.value as type.label for type in $ctrl.messageTypes\" class=\"form-control\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-repeat=\"language in $ctrl.languages\">\n<div class=\"form-group\">\n<label for=\"\" ng-if=\"language.id == 'E'\">{{'message.descriptionInEng' | translate}} *</label>\n<label for=\"\" ng-if=\"language.id == 'S'\">{{'message.descriptionInSpn' | translate}} *</label>\n<textarea cols=\"30\" rows=\"5\" ng-model=\"$ctrl.model.description[language.id]\" class=\"form-control\" required></textarea>\n</div>\n</div>\n<div id=\"inline\" class=\"form-group col-sm-3\">\n<label for=\"defaultSelection\">{{'message.defaultSelection' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.defaultSelection\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n<br/>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n</form>\n</div>\n";
var id1="message.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2852 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"navbar-header align-center-vertically\">\n<h4 class=\"navbar-brand remove-pad-left\" style=\"margin: 0px;\">\n{{'common.duplicates' | translate}}\n<span ng-if=\"!$ctrl.loading\" class=\"duplicate-msg-badge message-type-badge-color badge\">{{$ctrl.totalDuplicateRecords}}</span>\n<span class=\"duplicate-msg-tooltip glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'message.duplicate_message_tooltip' | translate}}\" tooltip-placement=\"right\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right remove-pad-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\" style=\"max-width: 165px;\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\" uib-tooltip=\"{{ 'message.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n<div class=\"form-group\">\n<select class=\"form-control\" ng-change=\"$ctrl.search()\" ng-model=\"$ctrl.messageType\" ng-options=\"type.value as type.label for type in  $ctrl.messageTypes\">\n<option value=\"\" selected=\"selected\">({{'message.all' | translate}})</option>\n</select>\n</div>\n</form>\n</div>\n</div>\n<div class=\"col-sm-12 text-center margin-top-20\" ng-if=\"$ctrl.loading\">\n<span class=\"font-size-70 glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.duplicateMsgs && $ctrl.duplicateMsgs.length\">\n<ul class=\"remove-bottom-margin duplicate-language-message-list-group list-group\">\n<li class=\"list-group-item\" ng-repeat=\"message in $ctrl.duplicateMsgs\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-8\">\n<span class=\"list-group-item-text\">\n<div class=\"margin-top-05 col-sm-12\">\n<strong>{{message.messageId}} | {{$ctrl.translateMessageType(message.type)}} ({{message.type}})</strong>\n<p>{{message.description}}</p>\n</div>\n</span>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" tooltip-placement=\"left-top\" ng-click=\"$ctrl.updateLanguageMessageModal(message)\" uib-tooltip=\"{{ 'message.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-12 alert errLblPos alert-danger text-center\" ng-if=\"!$ctrl.duplicateMsgs.length && !$ctrl.error\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n<div class=\"col-sm-12 alert errLblPos alert-danger text-center\" ng-if=\"$ctrl.error\">\n<span>{{$ctrl.error}}</span>\n</div>\n<div class=\"row col-sm-12 margin-10 margin-bottom-10\">\n<ul uib-pagination total-items=\"$ctrl.totalDuplicateRecords\" ng-hide=\"{{($ctrl.totalDuplicateRecords<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.loadData()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>";
var id1="duplicate_message.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2853 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"message.edit_message\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"message-id\">{{'message.messageId' | translate}} *</label>\n<input type=\"text\" id=\"message-id\" ng-model=\"$ctrl.model.messageId\" class=\"form-control\" required/>\n</div>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"form-group\">\n<label for=\"message-id\">{{'message.type' | translate}} *</label>\n<select ng-model=\"$ctrl.model.type\" ng-options=\"type.value as type.label for type in $ctrl.messageTypes\" class=\"form-control\" required>\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"\" ng-if=\"$ctrl.model.language.id == 'E'\">{{'message.descriptionInEng' | translate}} *</label>\n<label for=\"\" ng-if=\"$ctrl.model.language.id == 'S'\">{{'message.descriptionInSpn' | translate}} *</label>\n<textarea cols=\"30\" rows=\"5\" ng-model=\"$ctrl.model.description\" class=\"form-control\" required></textarea>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n<br/>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n</form>\n</div>";
var id1="message.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2854 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"message.all\" ng-click=\"$ctrl.goToAll()\"><a>{{'message.all_messages' | translate}}</a></li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"message.create\">\n<a translate=\"message.menu.create\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['view']\" ui-sref-active=\"active\" ui-sref=\"message.duplicateMessage\">\n<a>{{'common.duplicates' | translate}} {{'common.message' | translate}}</a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view><ui-view>\n</ui-view></ui-view></div>\n</div>\n</div>";
var id1="message.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2855 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"mobileApp.menu_all_title\"></h4>\n<hr/>\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-40\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"col-sm-12 app-font-size-15\" ng-if=\"($ctrl.apps.android || $ctrl.apps.ios) && !$ctrl.loading\">\n<table class=\"table table-striped\">\n<thead>\n<tr>\n<th>{{'mobileApp.platform' | translate}}</th>\n<th>{{'mobileApp.version' | translate}}</th>\n<th>{{'mobileApp.download_link' | translate}}</th>\n<th>{{'common.created' | translate}}</th>\n<th>{{'common.updated' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-if=\"$ctrl.androidData\">\n<td>{{'mobileApp.android' | translate}}</td>\n<td>{{$ctrl.androidData.version}}</td>\n<td>\n<a target=\"_blank\" href=\"{{$ctrl.androidData.downloadLink}}\">{{$ctrl.androidData.downloadLink}}</a>\n</td>\n<td>{{$ctrl.androidData.createdAt | date: 'short'}}</td>\n<td>{{$ctrl.androidData.updatedAt | date: 'short'}}</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"!$ctrl.loading && !($ctrl.apps.android || $ctrl.apps.ios)\" class=\"col-sm-12 remove-pad margin-top-10\">\n<div class=\"col-sm-12 alert alert-danger text-align-center\">\n{{'mobileApp.no_data_found' | translate}}\n</div>\n</div>";
var id1="mobile_app.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2856 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"mobileApp.menu_create_title\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"platform\">{{'mobileApp.platform' | translate }}:</label>\n<span>{{'mobileApp.android' | translate}}</span>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"version\">{{'mobileApp.version' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"version\" placeholder=\"\" ng-model=\"$ctrl.model.version\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"downloadLink\">{{'mobileApp.download_link' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"downloadLink\" placeholder=\"\" ng-model=\"$ctrl.model.downloadLink\">\n</div>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n</form>\n</div>";
var id1="mobile_app.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2857 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"mobile_app.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"mobileApp.menu_all_title\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"mobile_app.create\">\n<a translate=\"mobileApp.menu_create_title\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="mobile_app.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2858 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad text-align-center\">\n<span class=\"alert alert-danger col-sm-12\">{{'common.no_data_found' | translate}}</span>\n</div>";
var id1="notification_management.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2859 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n</div>";
var id1="notification_management.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2860 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n<h4 translate=\"\"></h4>\n<hr/>\n</div>";
var id1="notification_management.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2861 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"notification_management.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"notificationManagement.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"notification_management.create\">\n<a translate=\"notificationManagement.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>";
var id1="notification_management.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2862 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad text-align-center\">\n<span class=\"alert alert-danger col-sm-12\">{{'common.no_data_found' | translate}}</span>\n</div>";
var id1="service_assignment_rules.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2863 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n</div>";
var id1="service_assignment_rules.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2864 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n<h4 translate=\"\"></h4>\n<hr/>\n</div>";
var id1="service_assignment_rules.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2865 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"service_assignment_rules.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"serviceAssignmentRules.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"service_assignment_rules.create\">\n<a translate=\"serviceAssignmentRules.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>";
var id1="service_assignment_rules.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2866 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'setup.all_setups' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'setup.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.setups && $ctrl.setups.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"setup in $ctrl.setups track by setup.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{setup.id}} | {{setup.branchId}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(setup)\" uib-tooltip=\"{{ 'setup.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.setups || !$ctrl.setups.length) && !$ctrl.loading\">\n{{'setup.noSetups' | translate}}\n</div>\n</div>\n</div>";
var id1="setup.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2867 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"remove-pad col-sm-12\">\n<div class=\"remove-left-pad remove-right-pad col-sm-12 margin-bottom-10 align-center-vertically\">\n<div class=\"col-sm-6 padding-zero\">\n<label>{{'setup.scannerPrefixes' | translate}}</label>\n</div>\n<div class=\"col-sm-6 padding-zero\">\n<button type=\"button\" class=\"btn pull-right btn-success btn-sm\" ng-click=\"$ctrl.addNewPrefix()\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n{{'setup.new' | translate}}\n</button>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<table class=\"table table-striped table-bordered\">\n<thead>\n<th>{{'setup.type' | translate }}</th>\n<th>{{'setup.prefix' | translate }}</th>\n<td align=\"center\">\n<strong>\n{{'setup.action' | translate }}\n</strong>\n</td>\n</thead>\n<tbody id=\"prdv\">\n<tr ng-repeat=\"prefixObj in $ctrl.model\">\n<td>\n<select ng-disabled=\"prefixObj.type === 'messenger'\" class=\"form-control\" ng-model=\"prefixObj.type\" ng-options=\"availablePrefix.value as availablePrefix.label for availablePrefix in $ctrl.avaialablePrefixes\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.none' | translate}})</option>\n</select>\n</td>\n<td>\n<input type=\"text\" ng-model=\"prefixObj.value\" class=\"form-control\" required ng-disabled=\"prefixObj.type === 'messenger'\">\n</td>\n<td>\n<div class=\"align-center-horizontally\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removePrefix($index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>";
var id1="prefix-table.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2868 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"setup.create_setup\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-branch\">{{'setup.branch' | translate}} *</label>\n<select id=\"setup-branch\" class=\"form-control\" ng-change=\"$ctrl.loadBranchData()\" ng-model=\"$ctrl.model.branchId\" ng-options=\"branch for branch in $ctrl.branches\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-vault\">{{'setup.vault' | translate}} *</label>\n<select id=\"setup-vault\" class=\"form-control\" ng-model=\"$ctrl.model.vaultId\" ng-options=\"vault for vault in $ctrl.vaults\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-language\">{{'setup.language' | translate}} *</label>\n<select id=\"setup-language\" class=\"form-control\" ng-model=\"$ctrl.model.defaultLanguageId\" ng-options=\"language.value as language.label for language in $ctrl.languages\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label>{{'common.description' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required ng-model=\"$ctrl.model.description\">\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12\">\n<div class=\"form-group\">\n<label for=\"setup-address\">{{'setup.address' | translate}} *</label>\n<textarea id=\"setup-address\" class=\"form-control\" rows=\"5\" cols=\"30\" ng-model=\"$ctrl.model.address\" required></textarea>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-city\">{{'setup.city' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"setup-city\" ng-model=\"$ctrl.model.city\" ng-pattern=\"/^[a-zA-Z ]*$/\" required/>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-state\">{{'setup.state' | translate}} *</label>\n<span class=\"pull-right\">\n<span for=\"state\"><b>Non US</b></span>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameAll()\" ng-model=\"$ctrl.model.isNonUSLocation\" ng-click=\"$ctrl.resetText()\"/>\n</span>\n<div ng-show=\"!$ctrl.model.isNonUSLocation\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.state\" ng-options=\"state for state in  $ctrl.states\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div ng-show=\"$ctrl.model.isNonUSLocation\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.state\" ng-pattern=\"/^[a-zA-Z ]*$/\" required>\n</div>\n</div>\n<div class=\"form-group\" ng-class=\"{'col-sm-2': $ctrl.model.isNonUSLocation}\" ng-show=\"$ctrl.model.isNonUSLocation\">\n<label for=\"state\">{{'location.country' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.country\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-required=\"$ctrl.model.isNonUSLocation\">\n</div>\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-4': !$ctrl.model.isNonUSLocation, 'col-sm-2': $ctrl.model.isNonUSLocation}\">\n<label>{{'location._zip' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" id=\"setup-zip\" ng-model=\"$ctrl.model.zip\" ng-pattern=\"/^\\d{5,6}(?:-\\d{3})?$/\" required/>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-language\">{{'setup.availableCurrencies' | translate}} *</label>\n<div isteven-multi-select input-model=\"$ctrl.currencyOptions\" output-model=\"$ctrl.model.availableCurrencyIds\" button-label=\"id\" item-label=\"id\" tick-property=\"ticked\" search-property=\"id\" max-labels=\"3\" selection-mode=\"multiple\" directive-id=\"currency-multi-select\" on-item-click=\"$ctrl.onAvailableCurrenciesChange()\" on-select-all=\"$ctrl.onAvailableCurrenciesChange()\" on-select-none=\"$ctrl.onAvailableCurrenciesChange()\" class=\"multi-select\">\n</div>\n<div ng-if=\"$ctrl.model.availableCurrencyIds && $ctrl.model.availableCurrencyIds.length > 0\" style=\"margin-top: 10px;\">\n<label for=\"primary-currency\">{{'setup.primaryCurrency' | translate}} *</label>\n<select id=\"primary-currency\" class=\"form-control\" ng-model=\"$ctrl.model.currencyId\" ng-options=\"currencyObj.id as currencyObj.id for currencyObj in ($ctrl.model.availableCurrencyIds || [])\">\n</select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-telno\">{{'setup.telno' | translate}} *</label>\n<input id=\"setup-telno\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.telno\" ui-us-phone-number required>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-defaultSupervisor\">{{'setup.defaultsupervisor' | translate}} *</label>\n<select id=\"setup-defaultSupervisor\" class=\"form-control\" ng-model=\"$ctrl.model.defaultSupervisorId\" ng-options=\"user as (user.userId + ' | ' + user.username) for user in $ctrl.supervisors\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"from-location\">{{'setup.fromLocation' | translate}} *</label>\n<search-and-select set-id=\"location\" ng-model=\"$ctrl.model.fromLocationId\" values=\"$ctrl.locationLists\" key=\"Key\" totalrecords=\"$ctrl.totalLocatin\" onscroll=\"$ctrl.getAllLocation(searchKey, offset)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"from-company\">{{'setup.bagoutFromCompany' | translate}} *</label>\n<input id=\"from-company\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.bagoutFromCompany\" ng-pattern=\"/^[a-zA-Z-_ ]*$/\" required>\n</div>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"bagout-branch-id\">{{'setup.bagout_branch_id' | translate}}</label>\n<input type=\"text\" id=\"bagout-branch-id\" ng-model=\"$ctrl.model.bagoutBranchId\" class=\"form-control\" ng-pattern=\"/^[0-9]*$/\"/>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"from-tanker\">{{ 'setup.tanker' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.tankerId\" set-id=\"tanker\" values=\"$ctrl.tankerList\" key=\"Key\" totalrecords=\"$ctrl.totaltanker\" onscroll=\"$ctrl.loadTanker(searchKey, offset)\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<a ui-sref=\"routes.create\" class=\"btn btn-success btn-xs pull-right\">{{'setup.new_label' | translate}}</a>\n<label for=\"hold-route\">{{'setup.holdRoute' | translate}} *</label>\n<search-and-select ng-model=\"$ctrl.model.holdRouteId\" set-id=\"holdRoute\" values=\"$ctrl.holdRouteList\" key=\"Key\" totalrecords=\"$ctrl.totalHoldRoutes\" onscroll=\"$ctrl.loadHoldRoutes(searchKey, offset)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"unassigned-route\">{{'setup.unassigned_route' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.unassignedRouteId\" set-id=\"unassigned-route\" values=\"$ctrl.unassignedRoutes\" key=\"Key\" totalrecords=\"$ctrl.totalUnassignedRoutes\" onscroll=\"$ctrl.loadUnassignedRoutes(searchKey, offset)\" none-selected=\"'common.none'\">\n</search-and-select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"from-tanker\">{{ 'setup.virtualTanker' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.virtualTankerId\" set-id=\"virtual\" values=\"$ctrl.virtualTankerList\" key=\"Key\" totalrecords=\"$ctrl.totalVtanker\" onscroll=\"$ctrl.loadVirtual(searchKey, offset)\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"defaultWindow\">{{ 'setup.defaultWindow' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.defaultWindowId\" set-id=\"defaultWindowId\" values=\"$ctrl.windowObj.results\" key=\"Key\" totalrecords=\"$ctrl.windowObj.totalRecords\" onscroll=\"$ctrl.getBranchWindow(searchKey, offset)\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"defaultFromTanker\">{{ 'setup.defaultFromTanker' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.defaultFromTankerId\" set-id=\"defaultFromTankerId\" values=\"$ctrl.fromTankerObj.results\" key=\"Key\" totalrecords=\"$ctrl.fromTankerObj.totalRecords\" onscroll=\"$ctrl.loadFromTanker(searchKey, offset)\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"defaultToTanker\">{{ 'setup.defaultToTanker' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.defaultToTankerId\" set-id=\"defaultToTankerId\" values=\"$ctrl.toTankerObj.results\" key=\"Key\" totalrecords=\"$ctrl.toTankerObj.totalRecords\" onscroll=\"$ctrl.loadToTanker(searchKey, offset)\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group margin-zero\">\n<label for=\"setup-current-vault-date\">{{'setup.currentVaultDate' | translate }} *</label>\n<br>\n<datetimepicker required=\"true\" class=\"datetimepicker-input\" ng-model=\"$ctrl.model.currentVaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\"/>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-exit-password\">{{'setup.exitPassword' | translate}} *</label>\n<input id=\"setup-exit-password\" type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.exitPassword\" ng-attr-type=\"{{ $ctrl.passWdIcon.exitPassword ? 'text' : 'password'}}\" required>\n<div class=\"password-icon\" ng-click=\"$ctrl.showPassword('exitPassword')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon.exitPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n<span ng-if=\"$ctrl.errors.password\" class=\"text-danger\">{{$ctrl.errors['password']}}</span>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-confirm-exit-password\">{{'setup.confirmExitPassword' | translate}} *</label>\n<input id=\"setup-confirm-exit-password\" type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.confirmExitPassword\" ng-attr-type=\"{{ $ctrl.passWdIcon.confirmExitPassword ? 'text' : 'password'}}\" required>\n<div class=\"password-icon\" ng-click=\"$ctrl.showPassword('confirmExitPassword')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon.confirmExitPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-data-from-server\">{{'setup.dataFromServer' | translate}} *</label>\n<input type=\"text\" id=\"setup-data-from-server\" class=\"form-control\" ng-model=\"$ctrl.model.dataFromServer\" required>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-data-to-server\">{{'setup.dataToServer' | translate}} *</label>\n<input type=\"text\" id=\"setup-data-to-server\" class=\"form-control\" ng-model=\"$ctrl.model.dataToServer\" required>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-from-hht-protocol\">{{'setup.fromHHTProtocol' | translate}} *</label>\n<select id=\"setup-from-hht-protocol\" class=\"form-control\" ng-model=\"$ctrl.model.fromHHTProtocol\" ng-options=\"option.value as option.label for option in $ctrl.HHTProtocolValues\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-to-hht-protocol\">{{'setup.toHHTProtocol' | translate}} *</label>\n<select id=\"setup-to-hht-protocol\" class=\"form-control\" ng-model=\"$ctrl.model.toHHTProtocol\" ng-options=\"option.value as option.label for option in $ctrl.HHTProtocolValues\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"setup-timezone\">{{'setup.timezone' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.timezone\" values=\"$ctrl.timezoneList\" key=\"Key\" totalrecords=\"$ctrl.totalTimezones\" none-selected=\"'common.select'\" common-search-flag=\"true\" on-click=\"$ctrl.prioritizeTimezone($ctrl.model.timezone.Value)\" required>\n</search-and-select>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad margin-top-10\">\n<div class=\"remove-left-pad remove-right-pad col-sm-12 margin-bottom-10 align-center-vertically\">\n<div class=\"col-sm-6 padding-zero\">\n<label>{{'setup.countStations' | translate}}</label>\n</div>\n<div class=\"col-sm-6 padding-zero\">\n<button type=\"button\" class=\"btn pull-right btn-success btn-sm\" ng-click=\"$ctrl.addCounter()\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n{{'setup.new' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"table-responsive\">\n<table class=\"table table-bordered table-hover\">\n<thead>\n<tr>\n<th>{{'setup.counterName' | translate}}</th>\n<th>{{'setup.counterSerial' | translate}}</th>\n<th class=\"text-center\">{{'common.actions' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"counter in $ctrl.counters track by $index\">\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"counter.name\" placeholder=\"{{'setup.counterName' | translate}}\" required>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"counter.serialNumber\" placeholder=\"{{'setup.counterSerial' | translate}}\" required>\n</td>\n<td>\n<div class=\"align-center-horizontally\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeCounter($index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.loadPrefixDirective\">\n<prefix-table class=\"col-sm-12 remove-pad\" model-value=\"$ctrl.model.prefixes\" prefixes=\"$ctrl.prefixes\"></prefix-table>\n</div>\n<div class=\"row col-sm-12 margin-top-10\">\n<h4 translate=\"setup.routeControl\"></h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"req-messenger-stop-scan\" class=\"font-12\">{{'setup.reqMessengerStopScan' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"req-messenger-stop-scan\" bs-switch ng-model=\"$ctrl.model.reqMessengerStopScan\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"at-location-scan\" class=\"font-12\">{{'setup.atLocationScan' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.at_location_scan_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"at-location-scan\" bs-switch ng-model=\"$ctrl.model.atLocationScan\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"contact\" class=\"font-12\">{{'setup.requireDriver' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.require_driver_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"setup-require-driver\" bs-switch ng-model=\"$ctrl.model.requireDriver\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"contact\" class=\"font-12\">{{'setup.requireGuard' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.require_guard_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"setup-require-guard\" bs-switch ng-model=\"$ctrl.model.requireGuard\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\">\n<div class=\"form-group col-sm-3\">\n<label for=\"setup-coin-checkin\" class=\"font-12\">{{'setup.useHolidayRoutes' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.use_holiday_routes_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"setup-use-holiday-routes\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.useHolidayRoutes\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"setup-no-print-delivery\" class=\"font-12\">{{'setup.noPrintDelivery' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.no_print_delivery_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"setup-no-print-delivery\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.noPrintDelivery\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"setup-no-print-pickup\" class=\"font-12\">{{'setup.noPrintPickup' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.no_print_pickup_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"setup-no-print-pickup\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.noPrintPickup\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"etup-atm-transfer\" class=\"font-12\">{{'setup.atm_transfer' | translate }}</label>\n<br>\n<input id=\"setup-atm-transfer\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.ATMTransfer\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"enable-auto-submit\" class=\"font-12\">{{'setup.enable_auto_submit' | translate }}</label>\n<br>\n<input id=\"enable-auto-submit\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.enableAutoSubmit\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"default-load-truck\" class=\"font-12\">{{'setup.default_load_truck_tanker' | translate }}</label>\n<br>\n<input id=\"default-load-truck\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.loadTruck\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"default-check-in-tanker\" class=\"font-12\">{{'setup.default_check_in_tanker' | translate }}</label>\n<br>\n<input id=\"default-check-in-tanker\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.checkInTanker\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"cant-scan-location\" class=\"font-12\">{{'setup.cant_scan_location' | translate }}</label>\n<br>\n<input id=\"cant-scan-location\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.cantScanLocation\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"cant-scan-truck\" class=\"font-12\">{{'setup.cant_scan_truck' | translate }}</label>\n<br>\n<input id=\"cant-scan-truck\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.cantScanTruck\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"cant-scan-bag\" class=\"font-12\">{{'setup.cant_scan_bag' | translate }}</label>\n<br>\n<input id=\"cant-scan-bag\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.cantScanBag\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"route-nfc\" class=\"font-12\">{{'setup.route_nfc' | translate }}</label>\n<br>\n<input id=\"route-nfc\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.routeNFC\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"truck-nfc\" class=\"font-12\">{{'setup.truck_nfc' | translate }}</label>\n<br>\n<input id=\"truck-nfc\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.truckNFC\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"cant-scan-nfc\" class=\"font-12\">{{'setup.cant_scan_nfc' | translate }}</label>\n<br>\n<input id=\"cant-scan-nfc\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.cantScanNFC\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"load_break_down\" class=\"font-12\">{{'setup.load_break_down' | translate }}</label>\n<br>\n<input id=\"load_break_down\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.loadBreakdown\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"pack_slip\" class=\"font-12\">{{'setup.pack_slip' | translate }}</label>\n<br>\n<input id=\"pack_slip\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.packSlip\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"add-bag-to-checkout\" class=\"font-12\">{{'setup.addBagToCheckout' | translate }}\n</label>\n<br>\n<input type=\"checkbox\" id=\"add-bag-to-checkout\" bs-switch ng-model=\"$ctrl.model.addBagToCheckout\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"row col-sm-12 margin-top-10\">\n<h4>{{'setup.coinControl' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"setup-coin-total\" class=\"font-12\">{{'setup.showCoinTotal' | translate }}</label>\n<br>\n<input id=\"setup-coin-total\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.showCoinTotal\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"setup-coin-checkin\" class=\"font-12\">{{'setup.coinCheckIn' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.coin_checkIn_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"setup-coin-checkin\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.coinCheckIn\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"setup-coin-checkout\" class=\"font-12\">{{'setup.coinCheckOut' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.coin_check_out_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"setup-coin-checkout\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.coinCheckOut\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"row col-sm-12 margin-top-10\">\n<h4>{{'setup.branchControl' | translate}}</h4>\n<div class=\"col-sm-12 remove-right-pad toggle-grid-container\">\n<div>\n<label for=\"setup-coin-checkin\" class=\"font-12\">{{'setup.locationRequiresCustomer' | translate }}</label>\n<br>\n<input id=\"setup-location-requires-customer\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.locationRequiresCustomer\" type=\"checkbox\"/>\n</div>\n<div>\n<label for=\"packing-required\" class=\"font-12\">{{'setup.packingRequired' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"packing-required\" bs-switch ng-model=\"$ctrl.model.packingRequired\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"setup-coin-checkin\" class=\"font-12\">{{'setup.allowBulkHoldVerify' | translate }}</label>\n<br>\n<input id=\"setup-allow-bulk-hold-verify\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.allowBulkHoldVerify\" type=\"checkbox\"/>\n</div>\n<div>\n<label for=\"enable-geo-coding\" class=\"font-12\">{{'setup.enableGeoCoding' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.enable_geo_coding_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"enable-geo-coding\" bs-switch ng-model=\"$ctrl.model.enableGeoCoding\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<div>\n<label for=\"setup-transmit-msg-files\" class=\"font-12\">{{'setup.transmitMsgFiles' | translate }}</label>\n<br>\n<input id=\"setup-transmit-msg-files\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.transmitMsgFiles\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"setup-service-tickets\" class=\"font-12\">{{'common.side_menu.service_tickets' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.service_tickets_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"setup-service-tickets\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.serviceTickets\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<label for=\"auto-delete-bagouts\" class=\"font-12\">{{'setup.auto_delete_bagouts' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.auto_delete_bagouts_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"auto-delete-bagouts\" bs-switch ng-model=\"$ctrl.model.autoDeleteBagouts\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<div>\n<label for=\"delete-pickups\" class=\"font-12\">{{'setup.delete_pickups' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.delete_pickups_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"delete-pickups\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.deletePickups\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"pickup-id-length\" class=\"font-12\">{{'setup.pickup_id_length' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.pickup_id_length_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"pickup-id-length\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.pickupIdLength\" type=\"checkbox\"/>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.pickupIdLength\">\n<div>\n<label for=\"characters-required\">{{'setup.characters_required' | translate}} *</label>\n<input type=\"number\" id=\"characters-required\" ng-model=\"$ctrl.model.charactersRequired\" class=\"form-control\" required/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"edit-pickup-id\" class=\"font-12\">{{'setup.edit_pickup_id' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.edit_pickup_id_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"edit-pickup-id\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.editPickupId\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<label for=\"ignore-pack-requirement\" class=\"font-12\">{{'setup.ignorePackRequirement' | translate }}</label>\n<br>\n<input id=\"ignore-pack-requirement\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.ignorePackRequirement\" type=\"checkbox\"/>\n</div>\n<div>\n<label for=\"setup-billing\" class=\"font-12\">{{'customer.billing' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"setup-billing\" bs-switch ng-model=\"$ctrl.model.billingEnabled\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"print-packLabel\" class=\"font-12\">{{'setup.print_pack_label' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"print-packLabel\" bs-switch ng-model=\"$ctrl.model.printPackLabel\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.onPrintPack();\"/>\n</div>\n<div>\n<label for=\"print-pre-packLabel\" class=\"font-12\">{{'setup.print_pre_pack_label' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"print-pre-packLabel\" bs-switch ng-model=\"$ctrl.model.printPrePack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.onPrePrintPack();\"/>\n</div>\n<div>\n<label for=\"verify-pickup-unique\" class=\"font-12\">{{'setup.verify_pickup_unique' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"verify-pickup-unique\" bs-switch ng-model=\"$ctrl.model.verifyPickupUnique\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"not-delivered-resolution\" class=\"font-12\">{{'setup.notDeliveredResolution' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"not-delivered-resolution\" bs-switch ng-model=\"$ctrl.model.notDeliveredResolution\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"enable-auto-check-in-check-out\" class=\"font-12\">{{'setup.enableAutoCheckInCheckOut' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"enable-auto-check-in-check-out\" bs-switch ng-model=\"$ctrl.model.enableAutoCheckInCheckOut\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"additional-pickup\" class=\"font-12\">{{'setup.additional_pickup' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"additional-pickup\" bs-switch ng-model=\"$ctrl.model.additionalPickup\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"service-order-truck-scan\" class=\"font-12\">{{'setup.service_order_truck_scan' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"service-order-truck-scan\" bs-switch ng-model=\"$ctrl.model.serviceOrderTruckScan\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<div>\n<label for=\"require-signature-name\" class=\"font-12\">{{'setup.require_signature_name' | translate }}</label>\n<br>\n<input id=\"require-signature-name\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.requireSignatureName\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"auto-assign-service-ticket\" class=\"font-12\">{{'setup.auto_assign_service_tickets' | translate }}</label>\n<br>\n<input id=\"auto-assign-service-ticket\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.autoAssignServiceTicket\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"disable-copy-paste\" class=\"font-12\">{{'setup.disable_copy_paste' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.disable_copy_paste_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"disable-copy-paste\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.disableCopyPaste\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"disable-tracking-id-typing\" class=\"font-12\">{{'setup.disable_trackingid_typing' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.disable_trackingid_typing_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"disable-tracking-id-typing\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.disableTrackingIdTyping\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"assign_service_zone\" class=\"font-12\">{{'setup.assign_service_zone' | translate }}</label>\n<br>\n<input id=\"assign_service_zone\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.assignServiceZone\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<label class=\"remove-white-space\" for=\"service_location_types\">Service Location Types</label>\n<div isteven-multi-select input-model=\"$ctrl.serviceLocationTypeOptions\" output-model=\"$ctrl.selectedServiceLocationTypes\" button-label=\"label\" item-label=\"label\" tick-property=\"ticked\" search-property=\"label\" max-labels=\"5\" selection-mode=\"multiple\" directive-id=\"service-location-type-select\" on-item-click=\"$ctrl.updateServiceLocationTypes()\" on-select-all=\"$ctrl.updateServiceLocationTypes()\" on-select-none=\"$ctrl.selectNoneServiceLocationTypes()\" class=\"multi-select\" ng-class=\"{'valid-create-service-location-types': $ctrl.selectedServiceLocationTypes.length}\">\n</div>\n</div>\n<div>\n<label class=\"remove-white-space\" for=\"default_service_ticket_assignment\">{{'setup.default_service_ticket_assignment' | translate}} </label>\n<select id=\"default_service_ticket_assignment\" class=\"form-control\" ng-model=\"$ctrl.model.defaultServiceTicketAssignment\" ng-options=\"serviceTicketAssignment.value as serviceTicketAssignment.label for serviceTicketAssignment in $ctrl.defaultServiceTicketAssignment\">\n<option value=\"\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div>\n<label for=\"unassign-on-vault-close\" class=\"font-12\">{{'setup.unassign_on_vault_close' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"unassign-on-vault-close\" bs-switch ng-model=\"$ctrl.model.unassignOnVaultClose\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"checkout-truck-liability\" class=\"font-12\">{{'setup.checkout_truck_liability' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"checkout-truck-liability\" bs-switch ng-model=\"$ctrl.model.checkoutTruckLiability\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<div>\n<label for=\"shipment-checklist\" class=\"font-12\">{{'setup.shipmentChecklist' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"service-checklist\" bs-switch ng-model=\"$ctrl.model.serviceChecklist\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"autoGenerateTrackingId\" class=\"font-12\">{{'setup.auto_generate_tracking_id' | translate }}</label>\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.auto_generate_tracking_id_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n<br>\n<input type=\"checkbox\" id=\"autoGenerateTrackingId\" bs-switch ng-model=\"$ctrl.model.autoGenerateTrackingId\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.autoGenerateTrackingId\">\n<div>\n<label for=\"trackingIdPrefix\" class=\"font-12\">{{'setup.tracking_id_prefix' | translate }} *</label>\n<br>\n<input type=\"text\" id=\"trackingIdPrefix\" ng-model=\"$ctrl.model.trackingIdPrefix\" class=\"form-control\" required/>\n</div>\n</div>\n<div class=\"remove-right-pad\" ng-if=\"$ctrl.model.autoGenerateTrackingId\">\n<div>\n<label for=\"trackingIdNumber\" class=\"font-12\">{{'setup.tracking_id_number' | translate }} *</label>\n<br>\n<input type=\"text\" id=\"trackingIdNumber\" ng-model=\"$ctrl.model.trackingIdNumber\" class=\"form-control\" required/>\n</div>\n</div>\n<div>\n<label for=\"unassign-on-day-close\" class=\"font-12\">{{'setup.unassign_on_day_close' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"unassign-day-day-close\" bs-switch ng-model=\"$ctrl.model.unassignOnDayClose\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"unassign-on-day-close\" class=\"font-12\">{{'setup.auto_close_vault' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"auto-close-vault\" bs-switch ng-model=\"$ctrl.model.autoCloseVault\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"convert-to-pickup\" class=\"font-12\">{{'setup.convert_to_pickup' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"convert-to-pickup\" bs-switch ng-model=\"$ctrl.model.convertToPickup\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"mark-undelivered-anytime\" class=\"font-12\">{{'setup.mark_undelivered_anytime' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"mark-undelivered-anytime\" bs-switch ng-model=\"$ctrl.model.undeliveredAnytimeFlag\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"virtual-tankers\" class=\"font-12\">{{'setup.virtual_tankers' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"virtual-tankers\" bs-switch ng-model=\"$ctrl.model.virtualTankers\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"autoDetectScannerCode\" class=\"font-12\">{{'setup.auto_detect_scanner_code' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"autoDetectScannerCode\" bs-switch ng-model=\"$ctrl.model.autoDetectScannerCode\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-if=\"!$ctrl.model.autoDetectScannerCode\">\n<label class=\"remove-white-space\" for=\"setup.barcode_types\">{{'setup.barcode_types' | translate}} </label>\n<select id=\"setup.barcode_types\" class=\"form-control\" ng-model=\"$ctrl.model.barcodeType\" ng-options=\"barCodeTypes.value as barCodeTypes.label for barCodeTypes in $ctrl.barCodeTypes\" ng-required=\"!$ctrl.model.autoDetectScannerCode\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div>\n<label for=\"enforceChecksum\" class=\"font-12\">{{'setup.enforceChecksum' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"enforceChecksum\" bs-switch ng-model=\"$ctrl.model.enforceChecksum\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-if=\"$ctrl.model.enforceChecksum\">\n<label for=\"\">{{'setup.checksumDigits' | translate}}</label>\n<input type=\"number\" id=\"checksumDigits\" ng-model=\"$ctrl.model.checksumDigits\" class=\"form-control\" min=\"1\" max=\"72\" ng-required=\"$ctrl.model.enforceChecksum\"/>\n</div>\n<div>\n<label for=\"locationOnHold\" class=\"font-12\">{{'setup.locationOnHold' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"locationOnHold\" bs-switch ng-model=\"$ctrl.model.locationOnHold\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"row col-sm-12 margin-top-10\">\n<h4>{{'setup.bypassControls' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"bypass-location\" class=\"font-12\">{{'setup.location_scan' | translate }}</label>\n<br>\n<input id=\"bypass-location\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.bypassLocation\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"bypass-item\" class=\"font-12\">{{'setup.item_scan' | translate }}</label>\n<br>\n<input id=\"bypass-item\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.bypassItem\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"skip-deliveries\" class=\"font-12\">{{'setup.skip_deliveries' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.skip_deliveries_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"skip-deliveries\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.bypassDelivery\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"bypass-pickup\" class=\"font-12\">{{'setup.pickup_load' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.pickup_load_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"bypass-pickup\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.bypassPickup\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"cant-close-atm\" class=\"font-12\">{{'shipment.CANT_CLOSE_ATM' | translate }}</label>\n<br>\n<input id=\"cant-close-atm\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.bypassCantCloseATM\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"row col-sm-12 margin-top-10\">\n<h4>{{'setup.OTC_control' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"cencon\" class=\"font-12\">{{'setup.cencon' | translate}}</label>\n<br>\n<input id=\"cencon\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.OTCCencon\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"LMS\" class=\"font-12\">{{'setup.LMS' | translate}}</label>\n<br>\n<input id=\"LMS\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.OTCLMS\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"Witzco\" class=\"font-12\">{{'setup.TDS' | translate}}\n</label>\n<br>\n<input id=\"Witzco\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.OTCTDS\" type=\"checkbox\"/>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.OTCCencon\" ng-class=\"{'col-sm-12' : $ctrl.model.OTCCencon && !$ctrl.model.OTCLMS, 'col-sm-6' : $ctrl.model.OTCCencon && $ctrl.model.OTCLMS}\">\n<h4>{{'setup.cencon_title' | translate}}</h4>\n<table class=\"table-striped table table-hover table-bordered remove-pad table-pad-3\">\n<thead>\n<tr class=\"_header-row\">\n<th class=\"text-center\">{{'bagout.type' | translate}}</th>\n<th class=\"text-center\">{{'location.day.options' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr>\n<td>{{'setup.auto_open' | translate}}</td>\n<td>\n<select id=\"OTC-cencon-checkout-mode\" class=\"form-control\" ng-model=\"$ctrl.model.OTCCenconCheckoutMode\" ng-options=\"lock.value as lock.label for lock in $ctrl.cenconLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr>\n<td>{{'setup.manually_open_route_stop' | translate}}</td>\n<td>\n<select id=\"OTC-cencon-route-mode\" class=\"form-control\" ng-model=\"$ctrl.model.OTCCenconRouteMode\" ng-options=\"lock.value as lock.label for lock in $ctrl.cenconLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr>\n<td>{{'setup.setup.manually_open_service_stop' | translate}}</td>\n<td>\n<select id=\"OTC-cencon-service-mode\" class=\"form-control\" ng-model=\"$ctrl.model.OTCCenconServiceMode\" ng-options=\"lock.value as lock.label for lock in $ctrl.cenconLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-if=\"$ctrl.model.OTCLMS\" ng-class=\"{'col-sm-12' : !$ctrl.model.OTCCencon && $ctrl.model.OTCLMS, 'col-sm-6' : $ctrl.model.OTCCencon && $ctrl.model.OTCLMS}\">\n<h4>{{'setup.LMS_title' | translate}}</h4>\n<table class=\"table-striped table table-hover table-bordered remove-pad table-pad-3\">\n<thead>\n<tr class=\"_header-row\">\n<th class=\"text-center\">{{'bagout.type' | translate}}</th>\n<th class=\"text-center\">{{'location.day.options' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr>\n<td>{{'setup.auto_open' | translate}}</td>\n<td>\n<select id=\"OTC-LMS-checkout-dur\" class=\"form-control\" ng-model=\"$ctrl.model.OTCLMSCheckoutDur\" ng-options=\"lock.value as lock.label for lock in $ctrl.LMSLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr>\n<td>{{'setup.manually_open_route_stop' | translate}}</td>\n<td>\n<select id=\"OTC-LMS-route-dur\" class=\"form-control\" ng-model=\"$ctrl.model.OTCLMSRouteDur\" ng-options=\"lock.value as lock.label for lock in $ctrl.LMSLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr>\n<td>{{'setup.setup.manually_open_service_stop' | translate}}</td>\n<td>\n<select id=\"OTC-LMS-service-dur\" class=\"form-control\" ng-model=\"$ctrl.model.OTCLMSServiceDur\" ng-options=\"lock.value as lock.label for lock in $ctrl.LMSLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"row col-sm-12 margin-10\">\n<h4>{{'setup.supervisorControl' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"at-supervisorScan-scan\" class=\"font-12\">{{'setup.supervisoraddbag' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'setup.supervisor_scan_info'  | translate}}\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"at-supervisorScan-scan\" bs-switch ng-model=\"$ctrl.model.supervisorScan\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"cancel-supervisor-challenge\" class=\"font-12\">{{'setup.cancel_supervisor_challenge' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"Cancel supervisor challenge in checkin/checkout\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"cancel-supervisor-challenge\" bs-switch ng-model=\"$ctrl.model.cancelSupervisorChallenge\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12 margin-top-10\">\n<h4>{{'setup.operationsControl' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"vault-liability\" class=\"font-12\">{{'setup.vaultLiability' | translate }}</label>\n<br>\n<input type=\"text\" id=\"vault-liability\" ng-currency ng-model=\"$ctrl.model.vaultLiability\" placeholder=\"$0.00\" class=\"form-control\"/>\n</div>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"alert-threshold\" class=\"font-12\">{{'setup.alertThreshold' | translate }}</label>\n<br>\n<input type=\"text\" id=\"alert-threshold\" ng-model=\"$ctrl.model.alertThreshold\" class=\"form-control\" ng-blur=\"$ctrl.ngPercentage()\" ng-focus=\"$ctrl.removePrecentageSign($ctrl.model.alertThreshold)\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"alert-alertRecipientEmailalertRecipientEmail\" class=\"font-12\">{{'setup.alertRecipientEmail' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.recipient_email_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"text\" class=\"form-control\" id=\"alertRecipientEmail\" placeholder=\"\" ng-model=\"$ctrl.model.alertRecipientEmail\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\">\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"max-items-per-bagout\">{{'setup.maxItemsPerBagout' | translate}}</label>\n<input type=\"number\" id=\"max-items-per-bagout\" ng-model=\"$ctrl.model.maxItemsPerBagout\" class=\"form-control\"/>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"limit-per-atm-deposit\">{{'setup.limitPerATMDeposit' | translate}}</label>\n<input type=\"text\" id=\"limit-per-atm-deposit\" ng-currency ng-model=\"$ctrl.model.limitPerATMDeposit\" placeholder=\"$0.00\" class=\"form-control\"/>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"pack-char-length\">{{'setup.packCharLength' | translate}}</label>\n<input type=\"number\" id=\"pack-char-length\" ng-model=\"$ctrl.model.packCharLength\" class=\"form-control\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"gps-lat\">{{'setup.gpsLat' | translate}} *</label>\n<input type=\"text\" id=\"gps-lat\" ng-pattern=\"/^(\\+|-)?((\\d((\\.)|\\.\\d{1,6})?)|(0*?[0-8]\\d((\\.)|\\.\\d{1,6})?)|(0*?90((\\.)|\\.0{1,6})?))$/\" ng-model=\"$ctrl.model.gpsLat\" class=\"form-control\" required/>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"gpsLong\">{{'setup.gpsLong' | translate}} *</label>\n<input type=\"text\" id=\"gpsLong\" ng-pattern=\"/^(\\+|-)?((\\d((\\.)|\\.\\d{1,6})?)|(0*?\\d\\d((\\.)|\\.\\d{1,6})?)|(0*?1[0-7]\\d((\\.)|\\.\\d{1,6})?)|(0*?180((\\.)|\\.0{1,6})?))$/\" ng-model=\"$ctrl.model.gpsLong\" class=\"form-control\" required/>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"limit-per-route\">{{'setup.limitPerRoute' | translate}}</label>\n<input type=\"text\" id=\"limit-per-route\" ng-currency ng-model=\"$ctrl.model.limitPerRoute\" placeholder=\"$0.00\" class=\"form-control\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-10 remove-pad\">\n<h4>{{'setup.password_policy' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"vault-liability\" class=\"font-12\">{{'setup.enforce_strong_password' | translate }}</label>\n<br>\n<input id=\"LMS\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.enforceStrongPassword\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"minimum-password-length\" class=\"font-12\">{{'setup.minimum_password_length' | translate }}</label>\n<br>\n<input type=\"number\" id=\"minimum-password-length\" ng-model=\"$ctrl.model.minimumPasswordLength\" class=\"form-control\" min=\"0\" max=\"16\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"lowercase-character-length\" class=\"font-12\">{{'setup.lowercase_character_length' | translate }}</label>\n<br>\n<input type=\"number\" id=\"lowercase-character-length\" ng-model=\"$ctrl.model.lowercaseCharacterLength\" class=\"form-control\" min=\"0\" max=\"10\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"uppercase-character-length\" class=\"font-12\">{{'setup.uppercase_character_length' | translate }}</label>\n<br>\n<input type=\"number\" id=\"uppercase-character-length\" ng-model=\"$ctrl.model.uppercaseCharacterLength\" class=\"form-control\" min=\"0\" max=\"10\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"numeric-character-length\" class=\"font-12\">{{'setup.numeric_character_length' | translate }}</label>\n<br>\n<input type=\"number\" id=\"numeric-character-length\" ng-model=\"$ctrl.model.numericCharacterLength\" class=\"form-control\" min=\"0\" max=\"10\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"special-character-length\" class=\"font-12\">{{'setup.special_character_length' | translate }}</label>\n<br>\n<input type=\"number\" id=\"special-character-length\" ng-model=\"$ctrl.model.specialCharacterLength\" class=\"form-control\" min=\"0\" max=\"10\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"force-change-password-days\" class=\"font-12\">{{'setup.force_change_password_days' | translate }}</label>\n<br>\n<input type=\"number\" id=\"force-change-password-days\" ng-model=\"$ctrl.model.forceChangePasswordDays\" class=\"form-control\" min=\"0\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 _margin-top-10 remove-pad\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"remove-pad col-sm-6\">\n<h4>{{'setup.branch_cost' | translate}}</h4>\n</div>\n<div class=\"col-sm-6\" ng-class=\"{'margin-bottom-10': $ctrl.branchCost.length > 0}\">\n<button type=\"button\" class=\"btn pull-right btn-success btn-sm\" ng-click=\"$ctrl.addNewCost($event)\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n{{'setup.new' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<table class=\"table table-striped table-bordered\" ng-if=\"$ctrl.branchCost && $ctrl.branchCost.length > 0\">\n<thead>\n<th>{{'common.name' | translate }}</th>\n<th>{{'setup.start_distance' | translate }}</th>\n<th>{{'setup.end_distance' | translate }}</th>\n<th>{{'setup.standard_load' | translate }}</th>\n<th>{{'setup.ec_load' | translate }}</th>\n<td align=\"center\">\n<strong>{{'setup.action' | translate }}</strong>\n</td>\n</thead>\n<tbody id=\"branchCost\" ng-repeat=\"branchCost in $ctrl.branchCost track by $index\">\n<tr>\n<td>\n<span ng-if=\"branchCost.isDuplicate\" class=\"glyphicon glyphicon-warning-sign\" style=\"color: red; float: left; top: auto; left: -23px; position: absolute; margin-top: 8px;\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\">\n</span>\n<span ng-if=\"branchCost.isValid\" class=\"glyphicon glyphicon-warning-sign\" style=\"color: red; float: left; top: auto; left: -23px; position: absolute; margin-top: 8px;\" uib-tooltip=\"{{'setup.distance_record' | translate }}\">\n</span>\n<input type=\"text\" class=\"form-control\" ng-model=\"branchCost.name\" required>\n</td>\n<td>\n<input type=\"number\" class=\"form-control\" ng-model=\"branchCost.startDistance\" min=\"0\" ng-change=\"$ctrl.validateBranchCost(); $ctrl.validateDistance();\" required>\n</td>\n<td>\n<input type=\"number\" class=\"form-control\" ng-model=\"branchCost.endDistance\" min=\"0\" ng-change=\"$ctrl.validateBranchCost(); $ctrl.validateDistance();\" required>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-currency ng-model=\"branchCost.standardLoad\" placeholder=\"$0.00\" min=\"0\" required/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-currency ng-model=\"branchCost.ecLoad\" placeholder=\"$0.00\" min=\"0\" required/>\n</td>\n<td>\n<div class=\"align-center-horizontally\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeCost($index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 alert text-center alert-info remove-left-pad margin-bottom-10\" ng-if=\"!$ctrl.branchCost || $ctrl.branchCost.length === 0\" style=\"margin-bottom: 0px;\">\n{{'setup.branch_cost_record' | translate}}\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"margin-bottom-10 btn btn-primary\" ng-disabled=\"Form.$invalid || !$ctrl.isDuplicateBranchCost || $ctrl.isValidDistance || !$ctrl.isAllDataFilled()\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"margin-bottom-10 btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div></form>\n</div>\n";
var id1="setup.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2869 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<span class=\"edit-setp-title-section\">{{'setup.edit_setup' | translate}} <hr> </span>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.gettingSetupDetails\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-70\"></span>\n</div>\n<form name=\"Form\" novalidate class=\"form-validate\" ng-if=\"!$ctrl.gettingSetupDetails\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-branch\">{{'setup.branch' | translate}} *</label>\n<select id=\"setup-branch\" class=\"form-control\" ng-change=\"$ctrl.loadBranchData()\" ng-model=\"$ctrl.model.branchId\" ng-options=\"branch for branch in $ctrl.branches\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-vault\">{{'setup.vault' | translate}} *</label>\n<select id=\"setup-vault\" class=\"form-control\" ng-model=\"$ctrl.model.vaultId\" ng-options=\"vault for vault in $ctrl.vaults\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-language\">{{'setup.language' | translate}} *</label>\n<select id=\"setup-language\" class=\"form-control\" ng-model=\"$ctrl.model.defaultLanguageId\" ng-options=\"language.value as language.label for language in $ctrl.languages\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 form-group\">\n<label>{{'common.description' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required ng-model=\"$ctrl.model.description\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-12 form-group\">\n<label for=\"setup-address\">{{'setup.address' | translate}} *</label>\n<textarea id=\"setup-address\" class=\"form-control\" rows=\"5\" cols=\"30\" ng-model=\"$ctrl.model.address\" required></textarea>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-city\">{{'setup.city' | translate}} *</label>\n<input type=\"text\" class=\"form-control\" id=\"setup-city\" ng-model=\"$ctrl.model.city\" required/>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-state\">{{'setup.state' | translate}} *</label>\n<span class=\"pull-right\">\n<span for=\"state\"><b>Non US</b></span>\n<input type=\"checkbox\" ng-change=\"$ctrl.sameAll()\" ng-model=\"$ctrl.model.isNonUSLocation\" ng-click=\"$ctrl.resetText()\"/>\n</span>\n<div ng-show=\"!$ctrl.model.isNonUSLocation\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.state\" ng-options=\"state for state in  $ctrl.states\" required>\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div ng-show=\"$ctrl.model.isNonUSLocation\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.state\" ng-pattern=\"/^[a-zA-Z ]*$/\" required>\n</div>\n</div>\n<div class=\"form-group\" ng-class=\"{'col-sm-2': $ctrl.model.isNonUSLocation}\" ng-show=\"$ctrl.model.isNonUSLocation\">\n<label for=\"state\">{{'location.country' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.country\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-required=\"$ctrl.model.isNonUSLocation\">\n</div>\n<div id=\"inline\" class=\"form-group\" ng-class=\"{'col-sm-4': !$ctrl.model.isNonUSLocation, 'col-sm-2': $ctrl.model.isNonUSLocation}\">\n<label>{{'location._zip' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" id=\"setup-zip\" ng-model=\"$ctrl.model.zip\" ng-pattern=\"/^\\d{5,6}(?:-\\d{3})?$/\" required/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-language\">{{'setup.availableCurrencies' | translate}} *</label>\n<div isteven-multi-select input-model=\"$ctrl.currencyOptions\" output-model=\"$ctrl.model.availableCurrencyIds\" button-label=\"id\" item-label=\"id\" tick-property=\"ticked\" search-property=\"id\" max-labels=\"3\" selection-mode=\"multiple\" directive-id=\"currency-multi-select\" on-item-click=\"$ctrl.onAvailableCurrenciesChange()\" on-select-all=\"$ctrl.onAvailableCurrenciesChange()\" on-select-none=\"$ctrl.onAvailableCurrenciesChange()\" style=\"width: 100%;\" class=\"multi-select\">\n</div>\n<div ng-if=\"$ctrl.model.availableCurrencyIds && $ctrl.model.availableCurrencyIds.length > 0\" style=\"margin-top: 10px;\">\n<label for=\"primary-currency\">{{'setup.primaryCurrency' | translate}} *</label>\n<select id=\"primary-currency\" class=\"form-control\" ng-model=\"$ctrl.model.currencyId\" ng-options=\"currencyObj.id as currencyObj.id for currencyObj in ($ctrl.model.availableCurrencyIds || [])\">\n</select>\n</div>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-telno\">{{'setup.telno' | translate}} *</label>\n<input id=\"setup-telno\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.telno\" ui-us-phone-number required>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-defaultSupervisor\">{{'setup.defaultsupervisor' | translate}} *</label>\n<select id=\"setup-defaultSupervisor\" class=\"form-control\" ng-model=\"$ctrl.model.defaultSupervisorId\" ng-options=\"user.Value as user.Key for user in $ctrl.supervisors\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"from-location\">{{'setup.fromLocation' | translate}}* </label>\n<search-and-select set-id=\"location\" ng-model=\"$ctrl.model.fromLocationId\" values=\"$ctrl.locations\" key=\"Key\" totalrecords=\"$ctrl.totalLocation\" onscroll=\"$ctrl.loadInternalLocations(searchKey, offset)\" is-edit=\"true\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"from-company\">{{'setup.bagoutFromCompany' | translate}} *</label>\n<input id=\"from-company\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.bagoutFromCompany\" ng-pattern=\"/^[a-zA-Z-_ ]*$/\" required>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"bagout-branch-id\">{{'setup.bagout_branch_id' | translate}}</label>\n<input type=\"text\" id=\"bagout-branch-id\" ng-model=\"$ctrl.model.bagoutBranchId\" class=\"form-control\" ng-pattern=\"/^[0-9]*$/\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"from-tanker\">{{ 'setup.tanker' | translate}}</label>\n<search-and-select set-id=\"tanker\" ng-model=\"$ctrl.model.tankerId\" values=\"$ctrl.tankers\" key=\"Key\" totalrecords=\"$ctrl.totalTanker\" onscroll=\"$ctrl.loadTanker(searchKey, offset)\" is-edit=\"true\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div class=\"col-sm-4 form-group\">\n<a ui-sref=\"routes.create\" class=\"btn btn-success btn-xs pull-right\">{{'setup.new_label' | translate}}</a>\n<label for=\"hold-route\">{{'setup.holdRoute' | translate}} *</label>\n<search-and-select set-id=\"holdRoute\" ng-model=\"$ctrl.model.holdRouteId\" values=\"$ctrl.routes\" key=\"Key\" totalrecords=\"$ctrl.totalRoute\" onscroll=\"$ctrl.loadHoldRoutes(searchKey, offset)\" is-edit=\"true\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"unassigned-route\">{{'setup.unassigned_route' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.unassignedRouteId\" set-id=\"unassigned-route\" values=\"$ctrl.unassignedRoutes\" key=\"Key\" totalrecords=\"$ctrl.totalUnassignedRoute\" onscroll=\"$ctrl.loadUnassignedRoutes(searchKey, offset)\" none-selected=\"'common.none'\">\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"from-tanker\">{{ 'setup.virtualTanker' | translate}}</label>\n<search-and-select set-id=\"virtualTankers\" ng-model=\"$ctrl.model.virtualTankerId\" values=\"$ctrl.virtualTankers\" key=\"Key\" totalrecords=\"$ctrl.totalVirtualTanker\" onscroll=\"$ctrl.loadVirtualTanker(searchKey, offset)\" is-edit=\"true\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"defaultWindow\">{{ 'setup.defaultWindow' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.defaultWindowId\" set-id=\"defaultWindowId\" values=\"$ctrl.windowObj.results\" key=\"Key\" totalrecords=\"$ctrl.windowObj.totalRecords\" onscroll=\"$ctrl.getBranchWindow(searchKey, offset)\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"defaultFromTanker\">{{ 'setup.defaultFromTanker' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.defaultFromTankerId\" set-id=\"defaultFromTankerId\" values=\"$ctrl.fromTankerObj.results\" key=\"Key\" totalrecords=\"$ctrl.fromTankerObj.totalRecords\" onscroll=\"$ctrl.loadFromTanker(searchKey, offset)\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"defaultToTanker\">{{ 'setup.defaultToTanker' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.defaultToTankerId\" set-id=\"defaultToTankerId\" values=\"$ctrl.toTankerObj.results\" key=\"Key\" totalrecords=\"$ctrl.toTankerObj.totalRecords\" onscroll=\"$ctrl.loadToTanker(searchKey, offset)\" none-selected=\"'common.none'\"></search-and-select>\n</div>\n<div class=\"col-sm-4 _form-group\">\n<div class=\"margin-zero\">\n<label for=\"setup-current-vault-date\">{{'setup.currentVaultDate' | translate }} *</label>\n<br>\n<datetimepicker class=\"datetimepicker-input\" ng-click=\"$ctrl.vaultDateChanged()\" ng-model=\"$ctrl.model.currentVaultDate\" date-format=\"dd-MMM-yyyy\" hidden-time=\"true\" show-button-bar=\"false\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled' : !$ctrl.isAllowToChangeVaultSDate()}\"/>\n</div>\n</div>\n<div class=\"col-sm-4 _form-group\">\n<label for=\"setup-exit-password\">{{'setup.exitPassword' | translate}} *</label>\n<input id=\"setup-exit-password\" type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.exitPassword\" ng-attr-type=\"{{ $ctrl.passWdIcon.exitPassword ? 'text' : 'password'}}\" required>\n<div class=\"password-icon\" ng-click=\"$ctrl.showPassword('exitPassword')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon.exitPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n<span ng-if=\"$ctrl.errors.password\" class=\"text-danger\">{{$ctrl.errors['password']}}</span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 _form-group\">\n<label for=\"setup-confirm-exit-password\">{{'setup.confirmExitPassword' | translate}} *</label>\n<input id=\"setup-confirm-exit-password\" ng-required=\"$ctrl.model.exitPassword\" type=\"password\" class=\"form-control\" ng-attr-type=\"{{ $ctrl.passWdIcon.confirmExitPassword ? 'text' : 'password'}}\" ng-model=\"$ctrl.model.confirmExitPassword\" required>\n<div class=\"password-icon\" ng-click=\"$ctrl.showPassword('confirmExitPassword')\">\n<i class=\"glyphicon\" ng-class=\"$ctrl.passWdIcon.confirmExitPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'\"></i>\n</div>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-data-from-server\">{{'setup.dataFromServer' | translate}} *</label>\n<input type=\"text\" id=\"setup-data-from-server\" class=\"form-control\" ng-model=\"$ctrl.model.dataFromServer\" required>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-data-to-server\">{{'setup.dataToServer' | translate}} *</label>\n<input type=\"text\" id=\"setup-data-to-server\" class=\"form-control\" ng-model=\"$ctrl.model.dataToServer\" required>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-from-hht-protocol\">{{'setup.fromHHTProtocol' | translate}} *</label>\n<select id=\"setup-from-hht-protocol\" class=\"form-control\" ng-model=\"$ctrl.model.fromHHTProtocol\" ng-options=\"option.value as option.label for option in $ctrl.HHTProtocolValues\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-to-hht-protocol\">{{'setup.toHHTProtocol' | translate}} *</label>\n<select id=\"setup-to-hht-protocol\" class=\"form-control\" ng-model=\"$ctrl.model.toHHTProtocol\" ng-options=\"option.value as option.label for option in $ctrl.HHTProtocolValues\" required>\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"setup-timezone\">{{'setup.timezone' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.timezone\" values=\"$ctrl.timezoneList\" key=\"Key\" totalrecords=\"$ctrl.totalTimezones\" none-selected=\"'common.select'\" common-search-flag=\"true\" on-click=\"$ctrl.prioritizeTimezone($ctrl.model.timezone.Value)\" required>\n</search-and-select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad margin-top-10\" style=\"padding-left: 15px !important; padding-right: 15px !important;\">\n<div class=\"remove-left-pad remove-right-pad col-sm-12 margin-bottom-10 align-center-vertically\">\n<div class=\"col-sm-6 padding-zero\">\n<label>{{'setup.countStations' | translate}}</label>\n</div>\n<div class=\"col-sm-6 padding-zero\">\n<button type=\"button\" class=\"btn pull-right btn-success btn-sm\" ng-click=\"$ctrl.addCounter()\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n{{'setup.new' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"table-responsive\">\n<table class=\"table table-striped table-bordered\">\n<thead>\n<tr>\n<th>{{'setup.counterName' | translate}}</th>\n<th>{{'setup.counterSerial' | translate}}</th>\n<th class=\"text-center\">{{'common.actions' | translate}}</th>\n</tr>\n</thead>\n<tbody>\n<tr ng-repeat=\"counter in $ctrl.counters track by $index\">\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"counter.name\" placeholder=\"{{'setup.counterName' | translate}}\" required>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"counter.serialNumber\" placeholder=\"{{'setup.counterSerial' | translate}}\" required>\n</td>\n<td>\n<div class=\"align-center-horizontally\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeCounter($index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<div class=\"remove-pad col-sm-12\" ng-if=\"$ctrl.loadDirective\">\n<prefix-table class=\"col-sm-12\" model-value=\"$ctrl.model.prefixes\" prefixes=\"$ctrl.prefixes\"></prefix-table>\n</div>\n<div class=\"col-sm-12\">\n<h4 translate=\"setup.routeControl\"></h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"req-messenger-stop-scan\" class=\"font-12\">{{'setup.reqMessengerStopScan' | translate }}\n</label>\n<br>\n<input type=\"checkbox\" id=\"req-messenger-stop-scan\" bs-switch ng-model=\"$ctrl.model.reqMessengerStopScan\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"at-location-scan\" class=\"font-12\">{{'setup.atLocationScan' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.at_location_scan_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"at-location-scan\" bs-switch ng-model=\"$ctrl.model.atLocationScan\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"contact\" class=\"font-12\">{{'setup.requireDriver' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.require_driver_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"setup-require-driver\" bs-switch ng-model=\"$ctrl.model.requireDriver\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"contact\" class=\"font-12\">{{'setup.requireGuard' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.require_guard_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"setup-require-guard\" bs-switch ng-model=\"$ctrl.model.requireGuard\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"setup-coin-checkin\" class=\"font-12\">{{'setup.useHolidayRoutes' | translate }}</label>\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.use_holiday_routes_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n<br>\n<input id=\"setup-use-holiday-routes\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.useHolidayRoutes\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"setup-no-print-delivery\" class=\"font-12\">{{'setup.noPrintDelivery' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.no_print_delivery_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"setup-no-print-delivery\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.noPrintDelivery\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"setup-no-print-pickup\" class=\"font-12\">{{'setup.noPrintPickup' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.no_print_pickup_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"setup-no-print-pickup\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.noPrintPickup\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-3\">\n<div class=\"form-group\">\n<label for=\"setup-atm-transfer\" class=\"font-12\">{{'setup.atm_transfer' | translate }}\n</label>\n<br>\n<input id=\"setup-atm-transfer\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.ATMTransfer\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"enable-auto-submit\" class=\"font-12\">{{'setup.enable_auto_submit' | translate }}</label>\n<br>\n<input id=\"enable-auto-submit\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.enableAutoSubmit\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"default-load-truck\" class=\"font-12\">{{'setup.default_load_truck_tanker' | translate }}</label>\n<br>\n<input id=\"default-load-truck\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.loadTruck\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"default-check-in-tanker\" class=\"font-12\">{{'setup.default_check_in_tanker' | translate }}</label>\n<br>\n<input id=\"default-check-in-tanker\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.checkInTanker\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"cant-scan-location\" class=\"font-12\">{{'setup.cant_scan_location' | translate }}</label>\n<br>\n<input id=\"cant-scan-location\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.cantScanLocation\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"cant-scan-truck\" class=\"font-12\">{{'setup.cant_scan_truck' | translate }}</label>\n<br>\n<input id=\"cant-scan-truck\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.cantScanTruck\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"cant-scan-bag\" class=\"font-12\">{{'setup.cant_scan_bag' | translate }}</label>\n<br>\n<input id=\"cant-scan-bag\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.cantScanBag\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"route-nfc\" class=\"font-12\">{{'setup.route_nfc' | translate }}</label>\n<br>\n<input id=\"route-nfc\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.routeNFC\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"truck-nfc\" class=\"font-12\">{{'setup.truck_nfc' | translate }}</label>\n<br>\n<input id=\"truck-nfc\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.truckNFC\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"cant-scan-nfc\" class=\"font-12\">{{'setup.cant_scan_nfc' | translate }}</label>\n<br>\n<input id=\"cant-scan-nfc\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.cantScanNFC\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"load_break_down\" class=\"font-12\">{{'setup.load_break_down' | translate }}</label>\n<br>\n<input id=\"load_break_down\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.loadBreakdown\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"pack_slip\" class=\"font-12\">{{'setup.pack_slip' | translate }}</label>\n<br>\n<input id=\"pack_slip\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.packSlip\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"add-bag-to-checkout\" class=\"font-12\">{{'setup.addBagToCheckout' | translate }}\n</label>\n<br>\n<input type=\"checkbox\" id=\"add-bag-to-checkout\" bs-switch ng-model=\"$ctrl.model.addBagToCheckout\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"col-sm-12 _margin-top-10\">\n<h4>{{'setup.coinControl' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3 form-group\">\n<label for=\"setup-coin-total\" class=\"font-12\">{{'setup.showCoinTotal' | translate }}</label>\n<br>\n<input id=\"setup-coin-total\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.showCoinTotal\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"setup-coin-checkin\" class=\"font-12\">{{'setup.coinCheckIn' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.coin_checkIn_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"setup-coin-checkin\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.coinCheckIn\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"setup-coin-checkout\" class=\"font-12\">{{'setup.coinCheckOut' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.coin_check_out_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"setup-coin-checkout\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.coinCheckOut\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 _margin-top-10\">\n<h4>{{'setup.branchControl' | translate}}</h4>\n<div class=\"col-sm-12 remove-right-pad form-group toggle-grid-container\">\n<div>\n<label for=\"setup-coin-checkin\" class=\"font-12\">{{'setup.locationRequiresCustomer' | translate }}</label>\n<br>\n<input id=\"setup-location-requires-customer\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.locationRequiresCustomer\" type=\"checkbox\"/>\n</div>\n<div>\n<label for=\"packing-required\" class=\"font-12\">{{'setup.packingRequired' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"packing-required\" bs-switch ng-model=\"$ctrl.model.packingRequired\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"setup-coin-checkin\" class=\"font-12\">{{'setup.allowBulkHoldVerify' | translate }}</label>\n<br>\n<input id=\"setup-allow-bulk-hold-verify\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.allowBulkHoldVerify\" type=\"checkbox\"/>\n</div>\n<div>\n<label for=\"enable-geo-coding\" class=\"font-12\">{{'setup.enableGeoCoding' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.enable_geo_coding_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"enable-geo-coding\" bs-switch ng-model=\"$ctrl.model.enableGeoCoding\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"setup-transmit-msg-files\" class=\"font-12\">{{'setup.transmitMsgFiles' | translate }}</label>\n<br>\n<input id=\"setup-transmit-msg-files\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.transmitMsgFiles\" type=\"checkbox\"/>\n</div>\n<div>\n<label for=\"setup-service-tickets\" class=\"font-12\">{{'common.side_menu.service_tickets' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.service_tickets_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"setup-service-tickets\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.serviceTickets\" type=\"checkbox\"/>\n</div>\n<div>\n<label for=\"auto-delete-bagouts\" class=\"font-12\">{{'setup.auto_delete_bagouts' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.auto_delete_bagouts_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"auto-delete-bagouts\" bs-switch ng-model=\"$ctrl.model.autoDeleteBagouts\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"delete-pickups\" class=\"font-12\">{{'setup.delete_pickups' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.delete_pickups_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"delete-pickups\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.deletePickups\" type=\"checkbox\"/>\n</div>\n<div>\n<label for=\"pickup-id-length\" class=\"font-12\">{{'setup.pickup_id_length' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.pickup_id_length_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"pickup-id-length\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.pickupIdLength\" type=\"checkbox\"/>\n</div>\n<div ng-if=\"$ctrl.model.pickupIdLength\">\n<label for=\"characters-required\">{{'setup.characters_required' | translate}} *</label>\n<input type=\"number\" id=\"characters-required\" ng-model=\"$ctrl.model.charactersRequired\" class=\"form-control\" required/>\n</div>\n<div>\n<label for=\"edit-pickup-id\" class=\"font-12\">{{'setup.edit_pickup_id' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.edit_pickup_id_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"edit-pickup-id\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.editPickupId\" type=\"checkbox\"/>\n</div>\n<div>\n<label for=\"ignore-pack-requirement\" class=\"font-12\">{{'setup.ignorePackRequirement' | translate }}</label>\n<br>\n<input id=\"ignore-pack-requirement\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.ignorePackRequirement\" type=\"checkbox\"/>\n</div>\n<div>\n<label for=\"setup-billing\" class=\"font-12\">{{'customer.billing' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"setup-billing\" bs-switch ng-model=\"$ctrl.model.billingEnabled\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"print-packLabel\" class=\"font-12\">{{'setup.print_pack_label' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"print-packLabel\" bs-switch ng-model=\"$ctrl.model.printPackLabel\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.onPrintPack();\"/>\n</div>\n<div>\n<label for=\"print-pre-packLabel\" class=\"font-12\">{{'setup.print_pre_pack_label' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"print-pre-packLabel\" bs-switch ng-model=\"$ctrl.model.printPrePack\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.onPrePrintPack();\"/>\n</div>\n<div>\n<label for=\"verify-pickup-unique\" class=\"font-12\">{{'setup.verify_pickup_unique' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"verify-pickup-unique\" bs-switch ng-model=\"$ctrl.model.verifyPickupUnique\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"not-delivered-resolution\" class=\"font-12\">{{'setup.notDeliveredResolution' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"not-delivered-resolution\" bs-switch ng-model=\"$ctrl.model.notDeliveredResolution\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"enable-auto-check-in-check-out\" class=\"font-12\">{{'setup.enableAutoCheckInCheckOut' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"enable-auto-check-in-check-out\" bs-switch ng-model=\"$ctrl.model.enableAutoCheckInCheckOut\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"additional-pickup\" class=\"font-12\">{{'setup.additional_pickup' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"additional-pickup\" bs-switch ng-model=\"$ctrl.model.additionalPickup\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"service-order-truck-scan\" class=\"font-12\">{{'setup.service_order_truck_scan' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"service-order-truck-scan\" bs-switch ng-model=\"$ctrl.model.serviceOrderTruckScan\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<div>\n<label for=\"require-signature-name\" class=\"font-12\">{{'setup.require_signature_name' | translate }}</label>\n<br>\n<input id=\"require-signature-name\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.requireSignatureName\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"auto-assign-service-ticket\" class=\"font-12\">{{'setup.auto_assign_service_tickets' | translate }}</label>\n<br>\n<input id=\"auto-assign-service-ticket\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.autoAssignServiceTicket\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"disable-copy-paste\" class=\"font-12\">{{'setup.disable_copy_paste' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.disable_copy_paste_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"disable-copy-paste\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.disableCopyPaste\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"disable-tracking-id-typing\" class=\"font-12\">{{'setup.disable_trackingid_typing' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.disable_trackingid_typing_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"disable-tracking-id-typing\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.disableTrackingIdTyping\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"assign_service_zone\" class=\"font-12\">{{'setup.assign_service_zone' | translate }}</label>\n<br>\n<input id=\"assign_service_zone\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.assignServiceZone\" type=\"checkbox\"/>\n</div>\n</div>\n<div>\n<label class=\"remove-white-space\" for=\"service_location_types\">Service Location Types</label>\n<div isteven-multi-select input-model=\"$ctrl.serviceLocationTypeOptions\" output-model=\"$ctrl.selectedServiceLocationTypes\" button-label=\"label\" item-label=\"label\" tick-property=\"ticked\" search-property=\"label\" max-labels=\"5\" selection-mode=\"multiple\" directive-id=\"service-location-type-select\" on-item-click=\"$ctrl.updateServiceLocationTypes()\" on-select-all=\"$ctrl.updateServiceLocationTypes()\" on-select-none=\"$ctrl.selectNoneServiceLocationTypes()\" class=\"multi-select\" ng-class=\"{'valid-service-location-types': $ctrl.selectedServiceLocationTypes.length}\">\n</div>\n</div>\n<div>\n<label class=\"remove-white-space\" for=\"default_service_ticket_assignment\">{{'setup.default_service_ticket_assignment' | translate}} </label>\n<select id=\"default_service_ticket_assignment\" class=\"form-control\" ng-model=\"$ctrl.model.defaultServiceTicketAssignment\" ng-options=\"serviceTicketAssignment.value as serviceTicketAssignment.label for serviceTicketAssignment in $ctrl.defaultServiceTicketAssignment\">\n<option value=\"\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div>\n<label for=\"unassign-on-vault-close\" class=\"font-12\">{{'setup.unassign_on_vault_close' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"unassign-on-vault-close\" bs-switch ng-model=\"$ctrl.model.unassignOnVaultClose\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"checkout-truck-liability\" class=\"font-12\">{{'setup.checkout_truck_liability' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"checkout-truck-liability\" bs-switch ng-model=\"$ctrl.model.checkoutTruckLiability\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<div>\n<label for=\"shipment-checklist\" class=\"font-12\">{{'setup.shipmentChecklist' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"service-checklist\" bs-switch ng-model=\"$ctrl.model.serviceChecklist\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div>\n<div>\n<label for=\"autoGenerateTrackingId\" class=\"font-12\">{{'setup.auto_generate_tracking_id' | translate }}</label>\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.auto_generate_tracking_id_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n<br>\n<input type=\"checkbox\" id=\"autoGenerateTrackingId\" bs-switch ng-model=\"$ctrl.model.autoGenerateTrackingId\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.autoGenerateTrackingId\">\n<div>\n<label for=\"trackingIdPrefix\" class=\"font-12\">{{'setup.tracking_id_prefix' | translate }} *</label>\n<br>\n<input type=\"text\" id=\"trackingIdPrefix\" ng-model=\"$ctrl.model.trackingIdPrefix\" class=\"form-control\" required/>\n</div>\n</div>\n<div class=\"remove-right-pad\" ng-if=\"$ctrl.model.autoGenerateTrackingId\">\n<div>\n<label for=\"trackingIdNumber\" class=\"font-12\">{{'setup.tracking_id_number' | translate }} *</label>\n<br>\n<input type=\"text\" id=\"trackingIdNumber\" ng-model=\"$ctrl.model.trackingIdNumber\" class=\"form-control\" required/>\n</div>\n</div>\n<div>\n<label for=\"unassign-on-day-close\" class=\"font-12\">{{'setup.unassign_on_day_close' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"unassign-day-day-close\" bs-switch ng-model=\"$ctrl.model.unassignOnDayClose\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"unassign-on-day-close\" class=\"font-12\">{{'setup.auto_close_vault' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"auto-close-vault\" bs-switch ng-model=\"$ctrl.model.autoCloseVault\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"convert-to-pickup\" class=\"font-12\">{{'setup.convert_to_pickup' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"convert-to-pickup\" bs-switch ng-model=\"$ctrl.model.convertToPickup\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"mark-undelivered-anytime\" class=\"font-12\">{{'setup.mark_undelivered_anytime' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"mark-undelivered-anytime\" bs-switch ng-model=\"$ctrl.model.undeliveredAnytimeFlag\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"virtual-tankers\" class=\"font-12\">{{'setup.virtual_tankers' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"virtual-tankers\" bs-switch ng-model=\"$ctrl.model.virtualTankers\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div>\n<label for=\"autoDetectScannerCode\" class=\"font-12\">{{'setup.auto_detect_scanner_code' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"autoDetectScannerCode\" bs-switch ng-model=\"$ctrl.model.autoDetectScannerCode\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-if=\"!$ctrl.model.autoDetectScannerCode\">\n<label class=\"remove-white-space\" for=\"setup.barcode_types\">{{'setup.barcode_types' | translate}} </label>\n<select id=\"setup.barcode_types\" class=\"form-control\" ng-model=\"$ctrl.model.barcodeType\" ng-options=\"barCodeTypes.value as barCodeTypes.label for barCodeTypes in $ctrl.barCodeTypes\" ng-required=\"!$ctrl.model.autoDetectScannerCode\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div>\n<label for=\"enforceChecksum\" class=\"font-12\">{{'setup.enforceChecksum' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"enforceChecksum\" bs-switch ng-model=\"$ctrl.model.enforceChecksum\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div ng-if=\"$ctrl.model.enforceChecksum\">\n<label for=\"\">{{'setup.checksumDigits' | translate}}</label>\n<input type=\"number\" id=\"checksumDigits\" ng-model=\"$ctrl.model.checksumDigits\" class=\"form-control\" min=\"1\" max=\"72\" ng-required=\"$ctrl.model.enforceChecksum\"/>\n</div>\n<div>\n<label for=\"locationOnHold\" class=\"font-12\">{{'setup.locationOnHold' | translate }}</label>\n<br>\n<input type=\"checkbox\" id=\"locationOnHold\" bs-switch ng-model=\"$ctrl.model.locationOnHold\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 _margin-top-10\">\n<h4>{{'setup.bypassControls' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-3 form-group\">\n<label for=\"bypass-location\" class=\"font-12\">{{'setup.location_scan' | translate }}</label>\n<br>\n<input id=\"bypass-location\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.bypassLocation\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"bypass-item\" class=\"font-12\">{{'setup.item_scan' | translate }}</label>\n<br>\n<input id=\"bypass-item\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.bypassItem\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"skip-deliveries\" class=\"font-12\">{{'setup.skip_deliveries' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.skip_deliveries_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"skip-deliveries\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.bypassDelivery\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"bypass-pickup\" class=\"font-12\">{{'setup.pickup_load' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.pickup_load_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input id=\"bypass-pickup\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.bypassPickup\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-3\">\n<label for=\"cant-close-atm\" class=\"font-12\">{{'shipment.CANT_CLOSE_ATM' | translate }}</label>\n<br>\n<input id=\"cant-close-atm\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.bypassCantCloseATM\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 _margin-top-10\">\n<h4>{{'setup.OTC_control' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"cencon\" class=\"font-12\">{{'setup.cencon' | translate}}</label>\n<br>\n<input id=\"cencon\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.OTCCencon\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"LMS\" class=\"font-12\">{{'setup.LMS' | translate}}</label>\n<br>\n<input id=\"LMS\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.OTCLMS\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"Witzco\" class=\"font-12\">{{'setup.TDS' | translate}}\n</label>\n<br>\n<input id=\"Witzco\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.OTCTDS\" type=\"checkbox\"/>\n</div>\n</div>\n<div ng-if=\"$ctrl.model.OTCCencon\" ng-class=\"{'col-sm-12' : $ctrl.model.OTCCencon && !$ctrl.model.OTCLMS, 'col-sm-6' : $ctrl.model.OTCCencon && $ctrl.model.OTCLMS}\">\n<h4>{{'setup.cencon_title' | translate}}</h4>\n<table class=\"table-striped table table-hover table-bordered remove-pad table-pad-3\">\n<thead>\n<tr class=\"_header-row\">\n<th class=\"text-center\">{{'bagout.type' | translate}}</th>\n<th class=\"text-center\">{{'location.day.options' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr>\n<td>{{'setup.auto_open' | translate}}</td>\n<td>\n<select id=\"OTC-cencon-checkout-mode\" class=\"form-control\" ng-model=\"$ctrl.model.OTCCenconCheckoutMode\" ng-options=\"lock.value as lock.label for lock in $ctrl.cenconLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr>\n<td>{{'setup.manually_open_route_stop' | translate}}</td>\n<td>\n<select id=\"OTC-cencon-route-mode\" class=\"form-control\" ng-model=\"$ctrl.model.OTCCenconRouteMode\" ng-options=\"lock.value as lock.label for lock in $ctrl.cenconLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr>\n<td>{{'setup.setup.manually_open_service_stop' | translate}}</td>\n<td>\n<select id=\"OTC-cencon-service-mode\" class=\"form-control\" ng-model=\"$ctrl.model.OTCCenconServiceMode\" ng-options=\"lock.value as lock.label for lock in $ctrl.cenconLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div ng-class=\"{'col-sm-12' : !$ctrl.model.OTCCencon && $ctrl.model.OTCLMS, 'col-sm-6' : $ctrl.model.OTCCencon && $ctrl.model.OTCLMS}\" ng-if=\"$ctrl.model.OTCLMS\">\n<h4>{{'setup.LMS_title' | translate}}</h4>\n<table class=\"table-striped table table-hover table-bordered remove-pad table-pad-3\">\n<thead>\n<tr class=\"_header-row\">\n<th class=\"text-center\">{{'bagout.type' | translate}}</th>\n<th class=\"text-center\">{{'location.day.options' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr>\n<td>{{'setup.auto_open' | translate}}</td>\n<td>\n<select id=\"OTC-LMS-checkout-dur\" class=\"form-control\" ng-model=\"$ctrl.model.OTCLMSCheckoutDur\" ng-options=\"lock.value as lock.label for lock in $ctrl.LMSLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr>\n<td>{{'setup.manually_open_route_stop' | translate}}</td>\n<td>\n<select id=\"OTC-LMS-route-dur\" class=\"form-control\" ng-model=\"$ctrl.model.OTCLMSRouteDur\" ng-options=\"lock.value as lock.label for lock in $ctrl.LMSLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n<tr>\n<td>{{'setup.setup.manually_open_service_stop' | translate}}</td>\n<td>\n<select id=\"OTC-LMS-service-dur\" class=\"form-control\" ng-model=\"$ctrl.model.OTCLMSServiceDur\" ng-options=\"lock.value as lock.label for lock in $ctrl.LMSLockOptions\">\n<option value=\"\" disabled=\"disabled\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-class=\"{'margin-10': $ctrl.model.OTCCencon || $ctrl.model.OTCLMS}\">\n<h4>{{'setup.supervisorControl' | translate}}</h4>\n<div class=\"form-group col-sm-3\">\n<label for=\"at-supervisorScan-scan\" class=\"font-12\">{{'setup.supervisoraddbag' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{'setup.supervisor_scan_info'  | translate}}\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"at-supervisorScan-scan\" bs-switch ng-model=\"$ctrl.model.supervisorScan\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"cancel-supervisor-challenge\" class=\"font-12\">{{'setup.cancel_supervisor_challenge' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"Cancel supervisor challenge in checkin/checkout\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"checkbox\" id=\"cancel-supervisor-challenge\" bs-switch ng-model=\"$ctrl.model.cancelSupervisorChallenge\" switch-size=\"small\" switch-on-text=\"{{'common.on' | translate}}\" switch-off-text=\"{{'common.off' | translate}}\" switch-on-color=\"success\" switch-off-color=\"danger\"/>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<h4>{{'setup.operationsControl' | translate}}</h4>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"form-group col-sm-4\">\n<label for=\"vault-liability\" class=\"font-12\">{{'setup.vaultLiability' | translate }}</label>\n<br>\n<input type=\"text\" id=\"vault-liability\" ng-currency ng-model=\"$ctrl.model.vaultLiability\" placeholder=\"$0.00\" class=\"form-control\" ng-change=\"$ctrl.validateVaultLiability()\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"alert-threshold\" class=\"font-12\">{{'setup.alertThreshold' | translate }}</label>\n<br>\n<input type=\"text\" id=\"alert-threshold\" ng-model=\"$ctrl.model.alertThreshold\" class=\"form-control\" ng-blur=\"$ctrl.ngPercentage()\" ng-focus=\"$ctrl.removePrecentageSign($ctrl.model.alertThreshold)\" pattern=\"(^100(\\.0{1,2})?%?$)|(^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?%?$)\" ng-change=\"$ctrl.validateVaultLiability()\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"alert-recipient-email\" class=\"font-12\">{{'setup.alertRecipientEmail' | translate }}\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip-html=\"'{{'setup.recipient_email_info' | translate}}'\" tooltip-placement=\"top-right\"></span>\n</label>\n<br>\n<input type=\"text\" class=\"form-control\" id=\"alertRecipientEmail\" placeholder=\"\" ng-model=\"$ctrl.model.alertRecipientEmail\" ng-pattern=\"/^(?!.*\\b([a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)\\b.*\\b\\1\\b)(?!.{256,})(\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*(?:\\s*,\\s*[a-zA-Z0-9.!#$%&'*+\\-=?^_`{|}~]+@[a-zA-Z0-9\\-]+(?:\\.[a-zA-Z0-9\\-]+)*)*\\s*)$/i\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"max-items-per-bagout\">{{'setup.maxItemsPerBagout' | translate}}</label>\n<input type=\"number\" id=\"max-items-per-bagout\" ng-model=\"$ctrl.model.maxItemsPerBagout\" class=\"form-control\"/>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"limit-per-atm-deposit\">{{'setup.limitPerATMDeposit' | translate}}</label>\n<input type=\"text\" id=\"limit-per-atm-deposit\" ng-currency ng-model=\"$ctrl.model.limitPerATMDeposit\" placeholder=\"$0.00\" class=\"form-control\"/>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"pack-char-length\">{{'setup.packCharLength' | translate}}</label>\n<input type=\"number\" id=\"pack-char-length\" ng-model=\"$ctrl.model.packCharLength\" class=\"form-control\"/>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"gps-lat\">{{'setup.gpsLat' | translate}} *</label>\n<input type=\"text\" id=\"gps-lat\" ng-pattern=\"/^(\\+|-)?((\\d((\\.)|\\.\\d{1,6})?)|(0*?[0-8]\\d((\\.)|\\.\\d{1,6})?)|(0*?90((\\.)|\\.0{1,6})?))$/\" ng-model=\"$ctrl.model.gpsLat\" class=\"form-control\" required/>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"gpsLong\">{{'setup.gpsLong' | translate}} *</label>\n<input type=\"text\" id=\"gpsLong\" ng-pattern=\"/^(\\+|-)?((\\d((\\.)|\\.\\d{1,6})?)|(0*?\\d\\d((\\.)|\\.\\d{1,6})?)|(0*?1[0-7]\\d((\\.)|\\.\\d{1,6})?)|(0*?180((\\.)|\\.0{1,6})?))$/\" ng-model=\"$ctrl.model.gpsLong\" class=\"form-control\" required/>\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"limit-per-route\">{{'setup.limitPerRoute' | translate}}</label>\n<input type=\"text\" id=\"limit-per-route\" ng-currency ng-model=\"$ctrl.model.limitPerRoute\" placeholder=\"$0.00\" class=\"form-control\"/>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-10\">\n<h4>{{'setup.password_policy' | translate}}</h4>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4\">\n<div class=\"form-group\">\n<label for=\"vault-liability\" class=\"font-12\">{{'setup.enforce_strong_password' | translate }}</label>\n<br>\n<input id=\"enforceStrongPassword\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.enforceStrongPassword\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"minimum-password-length\" class=\"font-12\">{{'setup.minimum_password_length' | translate }}</label>\n<br>\n<input type=\"number\" id=\"minimum-password-length\" ng-model=\"$ctrl.model.minimumPasswordLength\" class=\"form-control\" min=\"0\" max=\"16\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"lowercase-character-length\" class=\"font-12\">{{'setup.lowercase_character_length' | translate }}</label>\n<br>\n<input type=\"number\" id=\"lowercase-character-length\" ng-model=\"$ctrl.model.lowercaseCharacterLength\" class=\"form-control\" min=\"0\" max=\"10\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"uppercase-character-length\" class=\"font-12\">{{'setup.uppercase_character_length' | translate }}</label>\n<br>\n<input type=\"number\" id=\"uppercase-character-length\" ng-model=\"$ctrl.model.uppercaseCharacterLength\" class=\"form-control\" min=\"0\" max=\"10\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"numeric-character-length\" class=\"font-12\">{{'setup.numeric_character_length' | translate }}</label>\n<br>\n<input type=\"number\" id=\"numeric-character-length\" ng-model=\"$ctrl.model.numericCharacterLength\" class=\"form-control\" min=\"0\" max=\"10\"/>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"special-character-length\" class=\"font-12\">{{'setup.special_character_length' | translate }}</label>\n<br>\n<input type=\"number\" id=\"special-character-length\" ng-model=\"$ctrl.model.specialCharacterLength\" class=\"form-control\" min=\"0\" max=\"10\"/>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.enforceStrongPassword\">\n<label for=\"force-change-password-days\" class=\"font-12\">{{'setup.force_change_password_days' | translate }}</label>\n<br>\n<input type=\"number\" id=\"force-change-password-days\" ng-model=\"$ctrl.model.forceChangePasswordDays\" class=\"form-control\" min=\"0\"/>\n</div>\n</div>\n</div>\n<div class=\"col-sm-12 _margin-top-10\">\n<div class=\"remove-pad col-sm-12\">\n<div class=\"remove-pad col-sm-6\">\n<h4>{{'setup.branch_cost' | translate}}</h4>\n</div>\n<div class=\"col-sm-6\" ng-class=\"{'margin-bottom-10': $ctrl.branchCost.length > 0}\">\n<button type=\"button\" class=\"btn pull-right btn-success btn-sm\" ng-click=\"$ctrl.addNewCost($event)\">\n<span class=\"glyphicon glyphicon-plus\"></span>\n{{'setup.new' | translate}}\n</button>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<table class=\"table table-striped table-bordered\" ng-if=\"$ctrl.branchCost && $ctrl.branchCost.length > 0\">\n<thead>\n<th>{{'common.name' | translate }}</th>\n<th>{{'setup.start_distance' | translate }}</th>\n<th>{{'setup.end_distance' | translate }}</th>\n<th>{{'setup.standard_load' | translate }}</th>\n<th>{{'setup.ec_load' | translate }}</th>\n<td align=\"center\">\n<strong>{{'setup.action' | translate }}</strong>\n</td>\n</thead>\n<tbody id=\"branchCost\" ng-repeat=\"branchCost in $ctrl.branchCost track by $index\">\n<tr>\n<td>\n<span ng-if=\"branchCost.isDuplicate\" class=\"glyphicon glyphicon-warning-sign\" style=\"color: red; float: left; top: auto; left: -23px; position: absolute; margin-top: 8px;\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\">\n</span>\n<span ng-if=\"branchCost.isValid\" class=\"glyphicon glyphicon-warning-sign\" style=\"color: red; float: left; top: auto; left: -23px; position: absolute; margin-top: 8px;\" uib-tooltip=\"{{'setup.distance_record' | translate }}\">\n</span>\n<input type=\"text\" class=\"form-control\" ng-model=\"branchCost.name\" required>\n</td>\n<td>\n<input type=\"number\" class=\"form-control\" ng-model=\"branchCost.startDistance\" min=\"0\" ng-change=\"$ctrl.validateBranchCost(); $ctrl.validateDistance();\" required>\n</td>\n<td>\n<input type=\"number\" class=\"form-control\" ng-model=\"branchCost.endDistance\" min=\"0\" ng-change=\"$ctrl.validateBranchCost(); $ctrl.validateDistance();\" required>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-currency ng-model=\"branchCost.standardLoad\" placeholder=\"$0.00\" min=\"0\" required/>\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-currency ng-model=\"branchCost.ecLoad\" placeholder=\"$0.00\" min=\"0\" required/>\n</td>\n<td>\n<div class=\"align-center-horizontally\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeCost($index)\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<div class=\"col-sm-12 alert text-center alert-info remove-left-pad margin-bottom-10\" ng-if=\"!$ctrl.branchCost || $ctrl.branchCost.length === 0\" style=\"margin-bottom: 0px;\">\n{{'setup.branch_cost_record' | translate}}\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary margin-bottom-10\" ng-disabled=\"Form.$invalid || !$ctrl.isDuplicateBranchCost || $ctrl.isValidDistance || !$ctrl.isAllDataFilled()\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default margin-bottom-10\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>\n";
var id1="setup.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2870 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"setup.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"setup.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"setup.create\">\n<a translate=\"setup.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n<ui-view>\n</ui-view></ui-view></div>\n</div>\n</div>";
var id1="setup.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2871 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'shiptype.all_shiptype' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'shiptype.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n<div class=\"form-group\">\n<select id=\"userStatus\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl._status\" ng-options=\"status.value as status.label for status in  $ctrl.userStatus\" ng-change=\"$ctrl.search()\"></select>\n</div>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.shiptypes && $ctrl.shiptypes.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"shiptype in $ctrl.shiptypes track by shiptype.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-8\">\n<div class=\"list-group-item-text\">\n<div class=\"col-sm-11\">\n<span>{{shiptype.id}} | {{shiptype.description}}</span>\n</div>\n</div>\n</div>\n<div class=\"col-sm-4\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(shiptype)\" uib-tooltip=\"{{ 'shiptype.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"shiptype.expand\">\n<div class=\"col-sm-12\">\n<hr/>\n<div>\nExtra details here\n<br>\n<br>\n<br>\n<br> Extra Details\n</div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.shiptypes || !$ctrl.shiptypes.length) && !$ctrl.loading\">\n<span>{{'shiptype.noShiptypes' | translate}}</span>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>";
var id1="shiptype.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2872 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"heading-section\">\n<h4 translate=\"shiptype.create_shiptype\"></h4>\n<hr/>\n</div>\n<div class=\"shipment-id-section\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"shipmentid-title-section\">\n<div class=\"pull-left\">\n<h4 for=\"shipmentIDs\">{{'shiptype.shipmentID' | translate }}</h4>\n</div>\n<div class=\"pull-right\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"shipment-form-section\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"ship-type-id\" class=\"font-12\">{{'shiptype.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.id\">\n</div>\n<div class=\"col-sm-8 form-group\">\n<label for=\"description\" class=\"font-12\">{{'shiptype.description' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.description\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"unit-value\" class=\"font-12\">{{'shiptype.unitValue' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" ng-model=\"$ctrl.model.unitValue\">\n</div>\n<div id=\"inline\" class=\"col-sm-2 form-group\">\n<label for=\"coin\" class=\"font-12\">{{'shiptype.sortOrder' | translate }} *</label>\n<input type=\"number\" min=\"1\" required class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.sortOrder\">\n</div>\n<div id=\"inline\" class=\"col-sm-2 form-group\">\n<label for=\"coin\" class=\"font-12\">{{'shiptype.coin' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{ $ctrl.toggleSwitchUI.label.on }}\" switch-off-text=\"{{ $ctrl.toggleSwitchUI.label.off }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.coinFlag\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"col-sm-2 form-group\">\n<label for=\"use-amount\" class=\"font-12\">{{'shiptype.useAmount' | translate }}</label>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.amountFlag\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"col-sm-2 form-group\" ng-show=\"$ctrl.model.amountFlag\">\n<label for=\"amount\" class=\"font-12\">{{'shiptype.amount' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" ng-required=\"$ctrl.model.amountFlag ? true : false\" placeholder=\"$0.00\" ng-model=\"$ctrl.model.amount\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 || event.charCode === 46\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-2 form-group\">\n<label for=\"tnt_app\">{{'shiptype.tnt_app' | translate }} </label> <br/>\n<input id=\"status\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor}}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.hhtFlag\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-2 form-group\">\n<label for=\"countable\">{{'shiptype.countable' | translate }} </label> <br/>\n<input id=\"countable\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor}}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.countable\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-4 form-group\" ng-if=\"$ctrl.model.countable\">\n<label for=\"days-to-count\" class=\"font-12\">{{'shiptype.daysToCount' | translate }} *</label>\n<input type=\"number\" class=\"form-control\" ng-required=\"$ctrl.model.countable ? true : false\" placeholder=\"\" ng-model=\"$ctrl.model.daysToCount\" min=\"0\" max=\"365\">\n</div>\n<div class=\"col-sm-4 form-group\">\n<label for=\"batch-display\">{{'shiptype.batchDisplay' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.batchField\">\n</div>\n<div class=\"col-sm-4 form-group\" ng-if=\"!$ctrl.model.countable\">\n<label for=\"batch-display\">{{'shiptype.denomination_type' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.denominationType\" ng-options=\"denominationType.value as denominationType.label for denominationType in $ctrl.denominationTypes\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\" ng-if=\"$ctrl.model.countable\">\n<label for=\"batch-display\">{{'shiptype.denomination_type' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.denominationType\" ng-options=\"denominationType.value as denominationType.label for denominationType in $ctrl.denominationTypes\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n</form>\n</div>\n";
var id1="shiptype.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2873 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"heading-section\">\n<h4 translate=\"shiptype.edit_shiptype\"></h4>\n<hr/>\n</div>\n<div class=\"shipment-id-section\">\n<div class=\"text-align-center col-sm-12 margin-10\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<form name=\"Form\" novalidate class=\"form-validate\" ng-if=\"!$ctrl.model.loading\">\n<div class=\"shipmentid-title-section\">\n<div class=\"pull-left\">\n<h4 for=\"shipmentIDs\">{{'shiptype.shipmentID' | translate }}</h4>\n</div>\n<div class=\"pull-right\">\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.status\" ng-change=\"$ctrl.askToChange()\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"shipment-form-section\">\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"ship-type-id\" class=\"font-12\">{{'shiptype.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required disabled=\"disabled\" placeholder=\"\" ng-model=\"$ctrl.rawId\">\n</div>\n<div class=\"col-sm-8 form-group\">\n<label for=\"description\" class=\"font-12\">{{'shiptype.description' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.description\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-4 form-group\">\n<label for=\"unit-value\" class=\"font-12\">{{'shiptype.unitValue' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" ng-model=\"$ctrl.model.unitValue\">\n</div>\n<div id=\"inline\" class=\"col-sm-2 form-group\">\n<label for=\"coin\" class=\"font-12\">{{'shiptype.sortOrder' | translate }} *</label>\n<input type=\"number\" min=\"1\" required class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.sortOrder\">\n</div>\n<div id=\"inline\" class=\"col-sm-2 form-group\">\n<label for=\"coin\" class=\"font-12\">{{'shiptype.coin' | translate }}</label>\n<br>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{ $ctrl.toggleSwitchUI.label.on }}\" switch-off-text=\"{{ $ctrl.toggleSwitchUI.label.off }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.coinFlag\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"col-sm-2 form-group\">\n<label for=\"use-amount\" class=\"font-12\">{{'shiptype.useAmount' | translate }}</label>\n<input bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-text=\"{{ $ctrl.toggleSwitchUI.label.on }}\" switch-off-text=\"{{ $ctrl.toggleSwitchUI.label.off }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.amountFlag\" type=\"checkbox\"/>\n</div>\n<div id=\"inline\" class=\"col-sm-2 form-group\" ng-show=\"$ctrl.model.amountFlag\">\n<label for=\"amount\" class=\"font-12\">{{'shiptype.amount' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" ng-required=\"$ctrl.model.amountFlag ? true : false\" placeholder=\"$0.00\" ng-model=\"$ctrl.model.amount\" ng-currency onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 || event.charCode === 46\">\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"col-sm-2 form-group\">\n<label for=\"tnt_app\">{{'shiptype.tnt_app' | translate }} </label> <br/>\n<input id=\"status\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor}}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.hhtFlag\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-2 form-group\">\n<label for=\"countable\">{{'shiptype.countable' | translate }} </label> <br/>\n<input id=\"countable\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor}}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.countable\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-2 form-group\" ng-if=\"$ctrl.model.countable\">\n<label for=\"days-to-count\" class=\"font-12\">{{'shiptype.daysToCount' | translate }} *</label>\n<input type=\"number\" class=\"form-control\" ng-required=\"$ctrl.model.countable ? true : false\" placeholder=\"\" ng-model=\"$ctrl.model.daysToCount\" min=\"0\" max=\"365\">\n</div>\n<div class=\"col-sm-4 form-group\" ng-if=\"!$ctrl.model.countable\">\n<label for=\"batch-display\">{{'shiptype.batchDisplay' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.batchField\">\n</div>\n<div class=\"col-sm-4 form-group\" ng-if=\"!$ctrl.model.countable\">\n<label for=\"batch-display\">{{'shiptype.denomination_type' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.denominationType\" ng-options=\"denominationType.value as denominationType.label for denominationType in $ctrl.denominationTypes\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"col-sm-3 form-group\" ng-if=\"$ctrl.model.countable\">\n<label for=\"batch-display\">{{'shiptype.batchDisplay' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required placeholder=\"\" ng-model=\"$ctrl.model.batchField\">\n</div>\n<div class=\"col-sm-3 form-group\" ng-if=\"$ctrl.model.countable\">\n<label for=\"batch-display\">{{'shiptype.denomination_type' | translate}}</label>\n<select class=\"form-control\" ng-model=\"$ctrl.model.denominationType\" ng-options=\"denominationType.value as denominationType.label for denominationType in $ctrl.denominationTypes\">\n<option value=\"\">({{'common.none' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-2\">\n<label for=\"icon\">{{'common.current_icon' | translate}}</label>\n<hr style=\"margin-top: 0px;\"/>\n<img ng-if=\"$ctrl.model.isIconExists && $ctrl.rawId\" id=\"shiptype-icon\" ng-src=\"assets/images/{{$ctrl.rawId}}.png\" height=\"100\" width=\"100\">\n<span ng-if=\"!$ctrl.model.isIconExists\" id=\"no-icon-message\"><b>{{'common.no_icon_available' | translate}}</b></span>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<div class=\"alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n</div>\n<div class=\"col-sm-12\">\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</div>\n</form>\n</div>\n";
var id1="shiptype.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2874 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"shiptype.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"shiptype.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"shiptype.create\">\n<a translate=\"shiptype.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="shiptype.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2875 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 user-permission-all-section\">\n<div class=\"text-align-center font-size-70 margin-10 col-sm-12\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-offset-4 col-sm-4 font-size-20 text-center\">\n<b>{{'userPermissionReport.menu.title' | translate}}</b>\n<hr>\n</div>\n<div class=\"col-sm-12 remove-left-pad remove-right-pad align-center\">\n<div class=\"col-sm-3\">\n<div class=\"multi-select location-branch-dd\" ng-class=\"{'invalid-multi-select-value': !$ctrl.model.selectedBranch.length, 'valid-multi-select-value': $ctrl.model.selectedBranch.length}\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.userBranchList\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.getUsers(); $ctrl.resetData()\" on-select-all=\"$ctrl.getUsers(); $ctrl.resetData()\" on-select-none=\"$ctrl.getUsers(); $ctrl.resetData()\" on-reset=\"$ctrl.getUsers(); $ctrl.resetData()\" is-disabled=\"$ctrl.model.loading || $ctrl.model.userPermissionsObj.loading || $ctrl.model.isExporting\">\n</div>\n</div>\n<div class=\"remove-left-pad col-sm-3\">\n<div class=\"multi-select location-branch-dd\" ng-class=\"{'invalid-multi-select-value': !$ctrl.model.selectedUsers.length, 'valid-multi-select-value': $ctrl.model.selectedUsers.length}\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.userListObj.results\" output-model=\"$ctrl.model.selectedUsers\" button-label=\"userName\" item-label=\"key\" search-property=\"key\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.resetData();\" on-select-all=\"$ctrl.resetData();\" on-select-none=\"$ctrl.resetData();\" on-reset=\"$ctrl.resetData();\" is-disabled=\"$ctrl.model.userListObj.loading || $ctrl.model.userPermissionsObj.loading || $ctrl.model.isExporting\">\n</div>\n</div>\n<div>\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.getUsersPermission()\" ng-disabled=\"$ctrl.isLoading || !$ctrl.model.selectedUsers.length || !$ctrl.model.selectedBranch.length || $ctrl.model.userPermissionsObj.loading ||\n                             $ctrl.model.isExporting\">\n{{'coinPullReport.show' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$ctrl.userPermissionReport()\" ng-if=\"$ctrl.model.userPermissionsObj.results.length > 0\" ng-disabled=\"$ctrl.isLoading || !$ctrl.model.selectedUsers.length || $ctrl.model.isExporting ||\n                    !$ctrl.model.selectedBranch.length || $ctrl.model.userPermissionsObj.loading\">\n{{'common.export' | translate}}\n<span ng-if=\"$ctrl.model.isExporting\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\">\n<hr class=\"cash-variances-line-section\">\n</div>\n<div class=\"text-align-center col-sm-12 margin-top-20\" ng-if=\"$ctrl.model.userPermissionsObj.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner font-size-70\"></span>\n</div>\n<div class=\"margin-top-10 col-sm-12 remove-pad table-responsive\" ng-if=\"$ctrl.model.selectedUsers.length && $ctrl.model.selectedBranch.length && !$ctrl.model.userPermissionsObj.loading\">\n<div class=\"panel panel-default margin-bottom-10 _remove-bottom-pad message-type-panel\" ng-repeat=\"obj in $ctrl.model.userPermissionsObj.results track by obj.userId\">\n<div class=\"cursor-pointer panel-heading\">\n<div class=\"row panel-title panel-title-center bucket_text_align_center remove-left-padd remove-right-padd\">\n<div class=\"col-sm-10 remove-left-padd remove-right-padd\" ng-click=\"obj.bucketExpanded = !obj.bucketExpanded\">\n<i class=\"glyphicon glyphicon-triangle-bottom\" ng-show=\"obj.bucketExpanded\"></i>\n<i class=\"glyphicon glyphicon-triangle-right\" ng-hide=\"obj.bucketExpanded\"></i>\n<strong class=\"f-14\">{{obj.userId}} | {{obj.userName}}</strong>\n</div>\n</div>\n</div>\n<div class=\"table-responsive\" ng-show=\"obj.bucketExpanded\">\n<div class=\"alert text-center alert-danger error-msg-section\" ng-if=\"obj.branchList.length === 0\">\n<span>{{'common.no_data_found' | translate}}</span>\n</div>\n<div class=\"panel-box panel-group list-group recent-activity-block\" id=\"accordion\" ng-if=\"obj.branchList.length > 0\">\n<div class=\"panel panel-default\" ng-repeat=\"branchId in obj.branchList track by $index\">\n<div class=\"panel-heading cust-panel-color\" data-toggle=\"collapse\" data-target=\"#{{obj.userId}}-{{$index}}\" aria-expanded=\"false\" aria-controls=\"{{obj.userId}}-{{$index}}\">\n<h4 class=\"panel-title cursor-pointer\">\n<a class=\"accordion-toggle\">\n<strong>{{branchId}}</strong>\n</a>\n</h4>\n</div>\n<div id=\"{{obj.userId}}-{{$index}}\" class=\"panel-collapse collapse multi-collapse\">\n<div class=\"panel-body\">\n<div class=\"panel-box panel-group list-group recent-activity-block\" id=\"accordion\">\n<div class=\"panel panel-default\" ng-repeat=\"(key, value) in obj.permissions[branchId] track by key\" ng-if=\"value.permissions.length > 0\">\n<div class=\"panel-heading cust-panel-color\" data-toggle=\"collapse\" data-target=\"#{{$ctrl.generateUniqueId(branchId, obj.userId, key)}}\" aria-expanded=\"false\" aria-controls=\"{{$ctrl.generateUniqueId(branchId, obj.userId, key)}}\">\n<h4 class=\"panel-title cursor-pointer\">\n<span class=\"{{$ctrl.iconMap(key)}}\"></span>\n<a class=\"accordion-toggle\">\n<strong>{{$ctrl.translateHeader(key)}}</strong>\n</a>\n</h4>\n</div>\n<div id=\"{{$ctrl.generateUniqueId(branchId, obj.userId, key)}}\" class=\"panel-collapse collapse multi-collapse\">\n<div class=\"panel-body\">\n<table class=\"table table-bordered table-striped remove-pad-bottom\">\n<tr ng-repeat=\"userPermission in value.permissions\" ng-if=\"userPermission.key !== 'setting' && userPermission.key !== 'branch_mgmt'\">\n<td>\n<span>{{$ctrl.translatePageName(userPermission.key)}}</span>\n</td>\n<td>\n<button uib-tooltip=\"{{$ctrl.getTooltip(page_permission)}}\" tooltip-placement=\"bottom-right\" ng-repeat=\"page_permission in userPermission.permission\" type=\"button\" class=\"pull-right btn btn-sm\" ng-class=\"{'glyphicon glyphicon-ok': page_permission == 'create',\n                                                                           'glyphicon glyphicon-edit': (page_permission == 'edit' || page_permission == 'updateExternal' || page_permission == 'editCommitted'),\n                                                                           'glyphicon glyphicon-eye-open': page_permission == 'view',\n                                                                           'glyphicon glyphicon-asterisk': page_permission == 'all',\n                                                                           'glyphicon glyphicon-import': page_permission == 'importLocations',\n                                                                           'glyphicon glyphicon-transfer': page_permission == 'stopTransfer',\n                                                                           'glyphicon glyphicon-calendar': page_permission == 'changeVaultDate',\n                                                                           'glyphicon glyphicon-list-alt': page_permission == 'report',\n                                                                           'glyphicon glyphicon-road': page_permission == 'editRoute',\n                                                                           'glyphicon glyphicon-warning-sign': page_permission == 'atRisk',\n                                                                           'glyphicon glyphicon-trash': page_permission == 'delete'}\">\n</button>\n</td>\n</tr>\n</table>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>";
var id1="user_permission_report.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2876 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<ui-view>\n</ui-view></div>";
var id1="user_permission_report.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2877 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<ul class=\"nav nav-tabs hide-in-print\">\n<li ng-repeat=\"tab in $ctrl.tabs\" role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"{{tab.state}}\" ng-show=\"::$ctrl.hasAcl(tab.key)\">\n<a class=\"branch-mgmt-badge\">\n{{tab.title | translate}}\n</a>\n</li>\n</ul>\n<div class=\"remove-pad\">\n<div class=\"mt-20\">\n<ui-view></ui-view>\n</div>\n</div>\n</div>";
var id1="tnt_control.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2878 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'truck.all_trucks' | translate}}\n</h4>\n</div>\n<div class=\"navbar-form navbar-left remove-left-pad\">\n<button id=\"filter-by\" type=\"button\" class=\"btn btn-xs margin-top-06\" ng-class=\"{'btn-default': $ctrl.filterByValue !== 'all', 'btn-success': $ctrl.filterByValue === 'all'}\" ng-click=\"$ctrl.filterByBranch('all')\">\n{{'common.All' | translate}}\n</button>\n</div>\n<div class=\"col-sm-1 remove-left-pad settings-batch-loader\">\n<span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'truck.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.trucks && $ctrl.trucks.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"truck in $ctrl.trucks track by truck.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{truck.id}} | {{truck.make}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(truck)\" uib-tooltip=\"{{ 'truck.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"truck.expand\">\n<div class=\"col-sm-12\">\n<hr/>\n<div>\nExtra details here\n<br>\n<br>\n<br>\n<br> Extra Details\n</div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"(!$ctrl.trucks || !$ctrl.trucks.length) && !$ctrl.loading\">\n{{'truck.noTrucks' | translate}}\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n</div>";
var id1="truck.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2879 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"truck.create_truck\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<br/>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"exampleInputEmail1\" placeholder=\"\" disabled=\"disabled\" ng-model=\"$ctrl.model.id\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"col-sm-4\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{ 'truck.tooltip_info' | translate }}\" tooltip-placement=\"top\"></span>\n<label for=\"exampleInputEmail1\">{{'location.location' | translate }} *</label>\n<search-and-select ng-model=\"$ctrl.model.locationId\" key=\"Key\" values=\"$ctrl.locations\" totalrecords=\"$ctrl.totalRecord\" none-selected=\"'common.select'\" on-click=\"$ctrl.setVehicleId()\" common-search-flag=\"true\" required></search-and-select>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"status\">{{'location.status' | translate }} </label>\n<br/>\n<input id=\"status\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-change=\"$ctrl.askToChange()\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"row\">\n<br/>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'truck.make' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.make\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['make']}}</span>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'truck.model' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.model\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['model']}}</span>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'truck.year' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" pattern=\"^\\d{4}$\" required id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.year\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['year']}}</span>\n</div>\n</div>\n<div class=\"row\">\n<br/>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'truck.vinnum' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.vinnum\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['vinnum']}}</span>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'truck.platenum' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.platenum\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['platenum']}}</span>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"fuelType\">{{'truck.fuel_type' | translate}} *</label>\n<select class=\"form-control\" id=\"fuelType\" ng-model=\"$ctrl.model.fuelType\" ng-options=\"option.value as option.name for option in $ctrl.fuelTypeList\" required></select>\n</div>\n</div>\n<div class=\"row\">\n<br/>\n<div id=\"inline\" class=\"_form-group col-sm-6\">\n<label for=\"location-address\">{{'truck.address' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.locationId.address\" disabled=\"disabled\"/>\n</div>\n<div id=\"inline\" class=\"_form-group col-sm-2\">\n<label for=\"city\">{{'setup.city' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.locationId.city\" disabled=\"disabled\"/>\n</div>\n<div id=\"inline\" class=\"_form-group col-sm-2\">\n<label for=\"state\">{{'customer.state' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.locationId.state\" disabled=\"disabled\"/>\n</div>\n<div id=\"inline\" class=\"_form-group col-sm-2\">\n<label>{{'customer.zip' | translate }}</label>\n<input class=\"form-control\" ng-model=\"$ctrl.model.locationId.zip\" disabled=\"disabled\"/>\n</div>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 margin-10\">\n<div id=\"nfcTitle\">\n<h4 translate=\"NFC\"></h4>\n</div>\n<div class=\"col-sm-3 remove-right-pad\">\n<label for=\"NFCScan\" class=\"margin-right-10\">{{'location.nfc_scan' | translate}}</label>\n<br/>\n<input id=\"NFCScan\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.NFCScan\" type=\"checkbox\" ng-change=\"$ctrl.resetLiability();\"/>\n</div>\n<div id=\"NFCTagId\" class=\"col-sm-3\" ng-if=\"$ctrl.model.NFCScan\">\n<label class=\"remove-white-space\">{{'location.nfc_tag_id' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.NFCTagId\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" ng-required=\"$ctrl.model.NFCScan\"/>\n</div>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 margin-10\">\n<div id=\"liabilityTitle\">\n<h4 translate=\"Liability\"></h4>\n</div>\n<div class=\"col-sm-3 remove-right-pad\">\n<label for=\"truckLiability\" class=\"margin-right-10\">{{'truck.truck_liability' | translate}}</label>\n<br/>\n<input id=\"truckLiability\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.truckLiability\" type=\"checkbox\" ng-change=\"$ctrl.resetLiability();\"/>\n</div>\n<div class=\"col-sm-3\" ng-if=\"$ctrl.model.truckLiability\">\n<label for=\"liability-limit\" class=\"margin-right-10\">{{'route.liabilityLimit' | translate}}</label>\n<input type=\"text\" id=\"liability-limit\" ng-currency ng-model=\"$ctrl.model.liabilityLimit\" placeholder=\"$0.00\" min=\"1\" class=\"form-control\" ng-change=\"$ctrl.validateLiability();\" required/>\n</div>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 margin-10\">\n<div id=\"lockersTitle\">\n<h4 translate=\"Lockers\"></h4>\n</div>\n<div class=\"col-sm-3 remove-right-pad\">\n<label for=\"lockers\" class=\"margin-right-10\">{{'vehicle_locker.truck_lockers' | translate}}</label>\n<br/>\n<input id=\"lockers\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-change=\"$ctrl.resetLockers()\" ng-model=\"$ctrl.model.lockers\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-3 remove-pad\" ng-if=\"$ctrl.model.lockers\">\n<label for=\"liability\" class=\"margin-right-10\">{{'truck.locker_liability' | translate}}</label>\n<br/>\n<input id=\"liability\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.liability\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-3 pull-right margin-top-20\" ng-if=\"$ctrl.model.lockers\">\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn\" ng-click=\"$ctrl.addTruckLockers(searchKey, offset)\" ng-disabled=\"$ctrl.model.truckLockers.length >= 6 || $ctrl.isLoading\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n</div>\n</div>\n<div class=\"div-table font-12 col-lg-12\" ng-if=\"$ctrl.model.lockers\">\n<div class=\"row div-tr margin-top-05\">\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'serviceSettings.label' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\" ng-if=\"!$ctrl.model.liability\">\n<div class=\"dt\">\n<strong>{{'vehicle_locker.max_shipments' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\" ng-if=\"$ctrl.model.liability\">\n<div class=\"dt\">\n<strong>{{'vehicle_locker.max_liability' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-7 div-td\">\n<div class=\"dt\">\n<strong>{{'branch_mgmt.search' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right\">\n<div class=\"dt\">\n<strong>{{'common.action' | translate}}</strong>\n</div>\n</div>\n</div>\n<div class=\"_form-group\">\n<ul class=\"remove-bottom-margin list-group location-sequence\">\n<li ng-repeat=\"locker in $ctrl.model.truckLockers track by $index\" class=\"display-flex border-bottom\">\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<span ng-if=\"locker.isDuplicate\" class=\"glyphicon glyphicon-warning-sign\" style=\"color: red; float: left; top: auto; left: -23px; position: absolute; margin-top: 8px;\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\"></span>\n<input type=\"text\" class=\"form-control\" required id=\"label\" placeholder=\"\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\" ng-model=\"locker.label\">\n</div>\n</div>\n<div class=\"col-sm-2 div-td\" ng-if=\"!$ctrl.model.liability\">\n<div class=\"dt\">\n<input type=\"number\" class=\"form-control\" required id=\"maxShipment\" placeholder=\"\" ng-pattern=\"/^[0-9]{1,3}$/\" ng-model=\"locker.maxShipment\">\n</div>\n</div>\n<div class=\"col-sm-2 div-td\" ng-if=\"$ctrl.model.liability\">\n<div class=\"dt\">\n<input type=\"text\" id=\"locker-liability\" ng-currency required ng-model=\"locker.maxLiability\" placeholder=\"$0.00\" class=\"form-control\" ng-class=\"{'color-red': $ctrl.isLiabilityExceed}\" min=\"1\" ng-change=\"$ctrl.validateLiability();\"/>\n</div>\n</div>\n<div class=\"col-sm-7 div-td\">\n<div class=\"dt\">\n<search-and-select ng-model=\"locker.location\" values=\"$ctrl.locationData\" key=\"Key\" totalrecords=\"$ctrl.totalLocations\" ng-click=\"$ctrl.validateLocker(locker, $index)\" onscroll=\"$ctrl.loadLockerLocations(searchKey, offset, $index)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeLockers($index); $ctrl.validateLiability();\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"margin-bottom-20 margin-top-15 col-sm-12 remove-left-pad\">\n<div class=\"margin-10 form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.isLiabilityExceed\" ng-bind-html=\"$ctrl.liabilityError\"></div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || $ctrl.loading || !$ctrl.isValid || $ctrl.isLiabilityExceed\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>";
var id1="truck.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2880 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"truck.edit_truck\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<br/>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"exampleInputEmail1\" placeholder=\"\" disabled=\"disabled\" ng-model=\"$ctrl.model.id\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"col-sm-4\">\n<span class=\"glyphicon glyphicon-info-sign\" uib-tooltip=\"{{ 'truck.tooltip_info' | translate }}\" tooltip-placement=\"top\"></span>\n<label for=\"exampleInputEmail1\">{{'location.location' | translate }} *</label>\n<search-and-select ng-model=\"$ctrl.model.locationId\" key=\"Key\" values=\"$ctrl.locations\" totalrecords=\"$ctrl.totalRecord\" is-edit=\"true\" none-selected=\"'common.select'\" common-search-flag=\"true\" required></search-and-select>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"status\">{{'location.status' | translate }} </label>\n<br/>\n<input id=\"status\" switch-on-text=\"{{'common.active' | translate }}\" switch-off-text=\"{{'common.suspended' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-change=\"$ctrl.askToChange()\" ng-model=\"$ctrl.model.status\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"row\">\n<br/>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'truck.make' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.make\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['make']}}</span>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'truck.model' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.model\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['model']}}</span>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'truck.year' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" pattern=\"^\\d{4}$\" required id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.year\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['year']}}</span>\n</div>\n</div>\n<div class=\"row\">\n<br/>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'truck.vinnum' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.vinnum\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['vinnum']}}</span>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"exampleInputEmail1\">{{'truck.platenum' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.platenum\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['platenum']}}</span>\n</div>\n<div class=\"col-sm-4\">\n<label for=\"fuelType\">{{'truck.fuel_type' | translate}} *</label>\n<select class=\"form-control\" id=\"fuelType\" ng-model=\"$ctrl.model.fuelType\" ng-options=\"option.value as option.name for option in $ctrl.fuelTypeList\" required></select>\n</div>\n</div>\n<div class=\"row\">\n<br/>\n<div id=\"inline\" class=\"_form-group col-sm-6\">\n<label for=\"location-address\">{{'truck.address' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.locationId.address\" disabled=\"disabled\"/>\n</div>\n<div id=\"inline\" class=\"_form-group col-sm-2\">\n<label for=\"city\">{{'setup.city' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.locationId.city\" disabled=\"disabled\"/>\n</div>\n<div id=\"inline\" class=\"_form-group col-sm-2\">\n<label for=\"state\">{{'customer.state' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.locationId.state\" disabled=\"disabled\"/>\n</div>\n<div id=\"inline\" class=\"_form-group col-sm-2\">\n<label>{{'customer.zip' | translate }}</label>\n<input class=\"form-control\" ng-model=\"$ctrl.model.locationId.zip\" disabled=\"disabled\"/>\n</div>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 margin-10\">\n<div id=\"nfcTitle\">\n<h4 translate=\"NFC\"></h4>\n</div>\n<div class=\"col-sm-3 remove-right-pad\">\n<label for=\"NFCScan\" class=\"margin-right-10\">{{'location.nfc_scan' | translate}}</label>\n<br/>\n<input id=\"NFCScan\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.NFCScan\" type=\"checkbox\" ng-change=\"$ctrl.resetLiability();\"/>\n</div>\n<div id=\"NFCTagId\" class=\"col-sm-3\" ng-if=\"$ctrl.model.NFCScan\">\n<label class=\"remove-white-space\">{{'location.nfc_tag_id' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.NFCTagId\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\" ng-required=\"$ctrl.model.NFCScan\"/>\n</div>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 margin-10\">\n<div id=\"liabilityTitle\">\n<h4 translate=\"Liability\"></h4>\n</div>\n<div class=\"col-sm-3 remove-right-pad\">\n<label for=\"truckLiability\" class=\"margin-right-10\">{{'truck.truck_liability' | translate}}</label>\n<br/>\n<input id=\"truckLiability\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.truckLiability\" type=\"checkbox\" ng-change=\"$ctrl.resetLiability();\"/>\n</div>\n<div class=\"col-sm-3\" ng-if=\"$ctrl.model.truckLiability\">\n<label for=\"liability-limit\" class=\"margin-right-10\">{{'route.liabilityLimit' | translate}}</label>\n<input type=\"text\" id=\"liability-limit\" ng-currency ng-model=\"$ctrl.model.liabilityLimit\" placeholder=\"$0.00\" min=\"1\" class=\"form-control\" ng-change=\"$ctrl.validateLiability();\" required/>\n</div>\n</div>\n<div class=\"remove-left-pad remove-right-pad col-sm-12 margin-10\">\n<div id=\"lockersTitle\">\n<h4 translate=\"Lockers\"></h4>\n</div>\n<div class=\"col-sm-3 remove-right-pad\">\n<label for=\"lockers\" class=\"margin-right-10\">{{'vehicle_locker.truck_lockers' | translate}}</label>\n<br/>\n<input id=\"lockers\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-change=\"$ctrl.resetLockers()\" ng-model=\"$ctrl.model.lockers\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-3 remove-pad\" ng-if=\"$ctrl.model.lockers\">\n<label for=\"liability\" class=\"margin-right-10\">{{'truck.locker_liability' | translate}}</label>\n<br/>\n<input id=\"liability\" switch-on-text=\"{{'common.on' | translate }}\" switch-off-text=\"{{'common.off' | translate }}\" bs-switch switch-size=\"{{ $ctrl.toggleSwitchUI.size }}\" switch-on-color=\"{{ $ctrl.toggleSwitchUI.onColor }}\" switch-off-color=\"{{ $ctrl.toggleSwitchUI.offColor }}\" ng-model=\"$ctrl.model.liability\" type=\"checkbox\"/>\n</div>\n<div class=\"col-sm-3 pull-right margin-top-20\" ng-if=\"$ctrl.model.lockers\">\n<button type=\"button\" class=\"btn btn-success btn-sm new-btn\" ng-click=\"$ctrl.addTruckLockers(searchKey, offset)\" ng-disabled=\"$ctrl.model.truckLockers.length >= 6 || $ctrl.isLoading\">\n<span class=\"glyphicon glyphicon-plus\"></span> {{'setup.new' | translate}}</button>\n</div>\n</div>\n<div class=\"div-table font-12 col-lg-12\" ng-if=\"$ctrl.model.lockers\">\n<div class=\"row div-tr margin-top-05\">\n<div class=\"col-sm-1 div-td\">\n<div class=\"dt\">\n<strong>{{'shipmentBatch.locrefId' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<strong>{{'serviceSettings.label' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\" ng-if=\"!$ctrl.model.liability\">\n<div class=\"dt\">\n<strong>{{'vehicle_locker.max_shipments' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-2 div-td\" ng-if=\"$ctrl.model.liability\">\n<div class=\"dt\">\n<strong>{{'vehicle_locker.max_liability' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-6 div-td\">\n<div class=\"dt\">\n<strong>{{'branch_mgmt.search' | translate}}</strong>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right\">\n<div class=\"dt\">\n<strong>{{'common.action' | translate}}</strong>\n</div>\n</div>\n</div>\n<div class=\"_form-group\">\n<ul class=\"remove-bottom-margin list-group location-sequence\">\n<li ng-repeat=\"locker in $ctrl.model.truckLockers track by $index\" class=\"display-flex border-bottom\">\n<div class=\"col-sm-1 div-td\">\n<div class=\"dt\">\n<span ng-if=\"locker.isDuplicate\" class=\"glyphicon glyphicon-warning-sign\" style=\"color: red; float: left; top: auto; left: -23px; position: absolute; margin-top: 8px;\" uib-tooltip=\"{{'customer.duplicate_record' | translate }}\"></span>\n<input type=\"text\" class=\"form-control\" id=\"lockerId\" placeholder=\"\" ng-model=\"locker.id\" disabled=\"disabled\">\n</div>\n</div>\n<div class=\"col-sm-2 div-td\">\n<div class=\"dt\">\n<input type=\"text\" class=\"form-control\" required id=\"label\" placeholder=\"\" ng-pattern=\"/^[a-zA-Z0-9-$ ]*$/\" ng-model=\"locker.label\">\n</div>\n</div>\n<div class=\"col-sm-2 div-td\" ng-if=\"!$ctrl.model.liability\">\n<div class=\"dt\">\n<input type=\"number\" class=\"form-control\" required id=\"maxShipment\" placeholder=\"\" ng-pattern=\"/^[0-9]{1,3}$/\" ng-model=\"locker.maxShipment\">\n</div>\n</div>\n<div class=\"col-sm-2 div-td\" ng-if=\"$ctrl.model.liability\">\n<div class=\"dt\">\n<input type=\"text\" id=\"locker-liability\" ng-currency required ng-model=\"locker.maxLiability\" placeholder=\"$0.00\" class=\"form-control\" ng-class=\"{'color-red': $ctrl.isLiabilityExceed}\" min=\"1\" ng-change=\"$ctrl.validateLiability();\"/>\n</div>\n</div>\n<div class=\"col-sm-6 div-td\">\n<div class=\"dt\">\n<search-and-select ng-model=\"locker.location\" values=\"locker.lockerLocations\" key=\"Key\" totalrecords=\"locker.totalLocations\" ng-click=\"$ctrl.validateLocker(locker, $index)\" onscroll=\"$ctrl.loadLockerLocations(searchKey, offset, $index)\" none-selected=\"'common.none'\" required></search-and-select>\n</div>\n</div>\n<div class=\"col-sm-1 div-td border-right text-center\">\n<div class=\"dt\">\n<button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.removeLockers($index); $ctrl.validateLiability();\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"margin-bottom-20 margin-top-15 col-sm-12 remove-left-pad\">\n<div class=\"margin-10 form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\"></div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.isLiabilityExceed\" ng-bind-html=\"$ctrl.liabilityError\"></div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || $ctrl.loading || !$ctrl.isValid || $ctrl.isLiabilityExceed\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</div>\n</form>\n</div>";
var id1="truck.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2881 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"truck.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"truck.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"truck.create\">\n<a translate=\"truck.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n<ui-view>\n</ui-view></ui-view></div>\n</div>\n</div>";
var id1="truck.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2882 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12\">\n<form ng-submit=\"$ctrl.submit(this)\" name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"form-group col-sm-6\">\n<label>{{'users.firstName' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required ng-model=\"$ctrl.model.firstName\"/>\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'users.lastName' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required ng-model=\"$ctrl.model.lastName\"/>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-6\">\n<label>{{'users.languageId' | translate }} </label><br>\n<div id=\"language\" class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-md\" ng-repeat=\"language in $ctrl.language\" ng-click=\"$ctrl.toggle(language)\" ng-class=\"{'btn-primary': $ctrl.isLangSelected(language),'btn-default': !$ctrl.isLangSelected(language)}\">\n{{language.label}}\n</button>\n</div>\n</div>\n<div class=\"form-group col-sm-6\" ng-class=\"{'disabled' :$ctrl.model.isCustomerUser}\">\n<label for=\"\">{{'users.supervisor' | translate }} </label><br>\n<input id=\"holiday-service\" bs-switch switch-size=\"small\" switch-on-text=\"Yes\" switch-off-text=\"No\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.supervisor\" type=\"checkbox\">\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-6\">\n<label>{{'users.email' | translate }}</label>\n<input disabled=\"disabled\" type=\"email\" required class=\"form-control\" required ng-model=\"$ctrl.model.email\">\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"branch\">{{'users.branchId' | translate }}</label>\n<select disabled=\"disabled\" class=\"form-control\" required ng-model=\"$ctrl.model.branchId\" ng-options=\"branch for branch in $ctrl.branches\"> </select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-6\">\n<label>{{'users.password' | translate }}</label>\n<input type=\"password\" class=\"form-control\" ng-model=\"$ctrl.model.password\" ng-required=\"$ctrl.cnfPassword\">\n</div>\n<div class=\"form-group col-sm-6\">\n<label>{{'users.cnfpassword' | translate }}</label>\n<input type=\"password\" class=\"form-control\" ng-required=\"$ctrl.model.password\" ng-model=\"$ctrl.cnfPassword\">\n<span ng-show=\"$ctrl.model.password!=$ctrl.cnfPassword && $ctrl.cnfPassword.length\" class=\"text-danger\">{{ 'users.confirm_password_error' | translate }}</span>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid || ($ctrl.model.password && $ctrl.model.password!==$ctrl.cnfPassword)\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n</form>\n</div>\n";
var id1="user_profile.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'users.all_users' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n<div class=\"remove-left-pad user-stats-btn-section btn-group\">\n<button id=\"active-user\" type=\"button\" class=\"btn\" ng-class=\"{'btn-default': $ctrl.userStats !== 'active', 'btn-primary': $ctrl.userStats === 'active'}\" ng-click=\"$ctrl.getUserStats('active')\">\n{{'common.active' | translate}}\n<span class=\"badge\">{{$ctrl.userInfo.totalActiveUser}}</span>\n</button>\n<button id=\"inactive-user\" type=\"button\" class=\"btn\" ng-class=\"{'btn-default': $ctrl.userStats !== 'inactive', 'btn-primary': $ctrl.userStats === 'inactive'}\" ng-click=\"$ctrl.getUserStats('inactive')\">\n{{'common.disabled' | translate}}\n<span class=\"badge\">{{$ctrl.userInfo.totalInActiveUser}}</span>\n</button>\n</div>\n</div>\n<div class=\"navbar-form navbar-left remove-left-pad remove-right-pad\">\n<button id=\"filter-by\" type=\"button\" class=\"btn btn-sm margin-top-03\" ng-class=\"{'btn-default': $ctrl.filterByValue !== 'all', 'btn-success': $ctrl.filterByValue === 'all'}\" ng-click=\"$ctrl.filterByBranch('all')\">\n{{'common.All' | translate}}\n</button>\n<button id=\"updatePermissions\" type=\"button\" class=\"btn btn-sm btn-primary margin-top-03\" ng-if=\"$ctrl.hasBulkUpdateUserPermission\" ng-click=\"$ctrl.bulkUpdateUserPermissions()\" ng-disabled=\"$ctrl.updatingCustomerUserPermissions\">\n{{'users.cloneUserSettings' | translate}}\n</button>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" ng-model=\"$ctrl.searchText\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'users.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n<div class=\"form-group\">\n<select id=\"userStatus\" class=\"form-control\" ng-model=\"$ctrl._status\" ng-options=\"status.value as status.label for status in  $ctrl.userStatus\" ng-change=\"$ctrl.search()\"></select>\n</div>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<div ng-if=\"$ctrl.users && $ctrl.users.length\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"user in $ctrl.users track by user.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-4\">\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-eye-open': user.supervisor, 'glyphicon glyphicon-eye-close': !user.supervisor}\" style=\"padding-right: 5px;\" uib-tooltip=\"{{ user.supervisor ? 'users.supervisor' : 'users.user' | translate }}\"></span>\n<span class=\"list-group-item-text\">\n{{user.firstName + ' ' + user.lastName}}\n</span>\n<strong ng-if=\"$ctrl.isMe(user.id)\">(me)</strong>\n<img ng-if=\"user.languageId == 'E'\" src=\"" + __webpack_require__(401) + "\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{ 'users.E' | translate }}\"/>\n<img ng-if=\"user.languageId == 'S'\" src=\"" + __webpack_require__(407) + "\" class=\"custom-icon\" style=\"width: 20px\" uib-tooltip=\"{{ 'users.S' | translate }}\"/>\n</div>\n<div ng-if=\"user.lastWebLoginSource\" class=\"pull-right\" ng-class=\"{'col-sm-3' : (user.lastWebLoginSource), 'col-sm-6' : (user.lastWebLoginSource && !user.lastMobileLoginSource)}\">\n<strong class=\"text-muted\">{{'users.last_web_login' | translate}}:</strong>\n<span class=\"text-muted\">{{user.lastWebLoginDate | date:'short'}}</span>\n<span class=\"text-muted\" ng-if=\"user.lastWebLoginSource\">({{user.lastWebLoginSource || ''}})</span>\n</div>\n<div ng-if=\"user.lastMobileLoginSource\" class=\"pull-right\" ng-class=\"{'col-sm-3' : (user.lastMobileLoginSource), 'col-sm-6' : (user.lastMobileLoginSource && !user.lastWebLoginSource)}\">\n<strong class=\"text-muted\">{{'users.last_mobile_login' | translate}}</strong>\n<span class=\"text-muted\">{{user.lastMobileLoginDate | date:'short'}}</span>\n<span class=\"text-muted\" ng-if=\"user.lastMobileLoginSource\">({{user.lastMobileLoginSource.appVersion || ''}})</span>\n</div>\n<div ng-class=\"{'col-sm-6': !user.lastMobileLoginSource && !user.lastWebLoginSource}\"></div>\n<div class=\"col-sm-2\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\" ng-show=\"$ctrl.hasUserEditPermission\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.edit(user)\" uib-tooltip=\"{{ 'users.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n</div>\n\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"usersexpand\">\n<div class=\"col-sm-12\">\n<hr/>\n<div>\nExtra details here\n<br>\n<br>\n<br>\n<br> Extra Details\n</div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>\n<div class=\"text-align-center alert alert-danger\" ng-if=\"!$ctrl.loading && (!$ctrl.users || !$ctrl.users.length)\">\n<span>{{'users.noUsers' | translate}}</span>\n</div>\n</div>\n";
var id1="users.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2884 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"users.create_users\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-12\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"row\">\n<div class=\"form-group col-sm-4\">\n<label for=\"firstName\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"id\" placeholder=\"\" ng-model=\"$ctrl.model.id\" ng-pattern=\"/^[1-9][0-9]*$/\" minlength=\"0\" maxlength=\"9\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"firstName\">{{'users.firstName' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"firstName\" placeholder=\"\" ng-model=\"$ctrl.model.firstName\" ng-pattern=\"/^[a-zA-Z0-9 -]*$/\">\n<span ng-if=\"$ctrl.errors.firstName\" class=\"text-danger\">{{$ctrl.errors['name']}}</span>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"lastName\">{{'users.lastName' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"lastName\" placeholder=\"\" ng-model=\"$ctrl.model.lastName\" ng-pattern=\"/^[a-zA-Z0-9 -]*$/\">\n<span ng-if=\"$ctrl.errors.lastName\" class=\"text-danger\">{{$ctrl.errors['name']}}</span>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-sm-12 toggles-style d-flex\">\n<div class=\"form-group\">\n<label for=\"\">{{'users.languageId' | translate }} * </label><br>\n<div id=\"language\" class=\"btn-group\">\n<button class=\"btn btn-md\" type=\"button\" ng-repeat=\"language in $ctrl.language\" ng-click=\"$ctrl.toggle(language)\" ng-class=\"{'btn-primary': $ctrl.isLangSelected(language),'btn-default': !$ctrl.isLangSelected(language)}\">\n{{language.label}}\n</button>\n</div>\n<span ng-if=\"$ctrl.errors.languageId\" class=\"text-danger\">{{$ctrl.errors['languageId']}}</span>\n</div>\n<div class=\"form-group\" ng-class=\"{'disabled': $ctrl.isDisabledSupervisor}\">\n<label for=\"\">{{'users.supervisor' | translate }} </label><br>\n<input id=\"supervisor\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.supervisor\" type=\"checkbox\" ng-change=\"$ctrl.setCustomerUser(false); $ctrl.clearFundingSourceIfServiceOnly();\"/>\n</div>\n<div class=\"form-group\">\n<label for=\"\">{{'users.handheldUser' | translate }} </label><br>\n<input id=\"handheldUser\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" ng-change=\"$ctrl.resetKeyId();$ctrl.setCustomerUser(false); $ctrl.clearFundingSourceIfServiceOnly();\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.downloadToHHT\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group\">\n<label for=\"\">{{'users.webUser' | translate }} </label><br>\n<input id=\"webUser\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" ng-change=\"$ctrl.resetWebUserData();$ctrl.setCustomerUser(false); $ctrl.clearFundingSourceIfServiceOnly();\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.isWebUser\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group\">\n<label for=\"\">{{'users.service_user' | translate }} </label><br>\n<input id=\"serviceUser\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.serviceUser\" type=\"checkbox\" ng-change=\"$ctrl.setCustomerUser(false); $ctrl.resetServiceZone(); $ctrl.clearFundingSourceIfServiceOnly();\"/>\n</div>\n<div class=\"form-group\">\n<label for=\"\">{{'users.customer_user' | translate }} </label><br>\n<input id=\"customerUser\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.setCustomerUser(true)\" ng-model=\"$ctrl.model.customerUser\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group\">\n<label for=\"\">{{'users.shipmentTransfer' | translate }}</label><br>\n<input id=\"shipmentTransfer\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.shipmentTransfer\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.isWebUser || $ctrl.model.customerUser\">\n<label for=\"email\">{{'users.email' | translate }} *</label>\n<input type=\"email\" ng-required=\"$ctrl.model.isWebUser || $ctrl.model.customerUser\" class=\"form-control\" id=\"email\" placeholder=\"\" ng-model=\"$ctrl.model.email\">\n<span ng-if=\"$ctrl.errors.email\" class=\"text-danger\">{{$ctrl.errors['email']}}</span>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.customerUser\">\n<label for=\"userPass\">{{'users.password' | translate }} *</label>\n<input type=\"password\" class=\"form-control\" required id=\"userPass\" placeholder=\"\" ng-model=\"$ctrl.model.password\">\n<span ng-if=\"$ctrl.errors.password\" class=\"text-danger\">{{$ctrl.errors['password']}}</span>\n</div>\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.customerUser\">\n<label for=\"cnfPass\">{{'users.cnfpassword' | translate }} *</label>\n<input type=\"password\" class=\"form-control\" required id=\"cnfPass\" placeholder=\"\" ng-model=\"$ctrl.cnfPassword\">\n<span ng-show=\"$ctrl.model.password!=$ctrl.cnfPassword\" class=\"text-danger\">{{ 'users.confirm_password_error' | translate }}</span>\n</div>\n<div ng-class=\"{'col-sm-4': $ctrl.model.isWebUser, 'col-sm-12': !$ctrl.model.isWebUser}\">\n<label for=\"\">{{ 'users.all_branches' | translate }} *</label>\n<div class=\"form-group\">\n<div class=\"multi-select\" ng-class=\"{\n\t\t\t\t\t\t\t'invalid-multi-select-value': !$ctrl.model.branch.length,\n\t\t\t\t\t\t\t'valid-multi-select-value': $ctrl.model.branch.length,\n\t\t\t\t\t\t\t'user-multi-select-dd': ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && !$ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t(!$ctrl.model.downloadToHHT && $ctrl.model.isWebUser && !$ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t(!$ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t(!$ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser),\n\t\t\t\t\t\t\t'user-branch-multi-select-dd': (!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser)  || \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   (!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && !$ctrl.model.serviceUser)||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && !$ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser)\n\t\t\t\t\t\t}\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.branches\" output-model=\"$ctrl.model.branch\" button-label=\"id\" item-label=\"id\" search-property=\"id\" tick-property=\"ticked\" directive-id=\"multi-select-button\" translation=\"$ctrl.localLang\" on-item-click=\"$ctrl.autoSelectSameForAll(); $ctrl.getFundingSource(); $ctrl.loadServiceZone();\" on-select-all=\"$ctrl.autoSelectSameForAll(); $ctrl.getFundingSource(); $ctrl.loadServiceZone();\" on-select-none=\"$ctrl.removeSelection(); $ctrl.getFundingSource(); $ctrl.loadServiceZone();\" on-reset=\"$ctrl.removeSelection(); $ctrl.getFundingSource(); $ctrl.loadServiceZone();\" is-disabled=\"$ctrl.loadFundingSource\">\n</div>\n</div>\n</div>\n<div class=\"form-group\" ng-class=\"{'col-sm-4': $ctrl.model.isWebUser, 'col-sm-12': !$ctrl.model.isWebUser}\">\n<label for=\"branch\">{{ 'users.default_branches' | translate }} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.branchId\" ng-options=\"branch.id as branch.id for branch in $ctrl.model.branch\" ng-change=\"$ctrl.validateAutoChekInChekOut();$ctrl.getBranchCounters()\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.model.isWebUser\">\n<div class=\"form-group col-sm-6\">\n<label for=\"userPass\">{{'users.password' | translate }} *</label>\n<input type=\"password\" class=\"form-control\" required id=\"userPass\" placeholder=\"\" ng-model=\"$ctrl.model.password\">\n<span ng-if=\"$ctrl.errors.password\" class=\"text-danger\">{{$ctrl.errors['password']}}</span>\n</div>\n<div class=\"form-group col-sm-6\">\n<label for=\"cnfPass\">{{'users.cnfpassword' | translate }} *</label>\n<input type=\"password\" class=\"form-control\" required id=\"cnfPass\" placeholder=\"\" ng-model=\"$ctrl.cnfPassword\">\n<span ng-show=\"$ctrl.model.password!=$ctrl.cnfPassword\" class=\"text-danger\">{{ 'users.confirm_password_error' | translate }}</span>\n</div>\n</div>\n<div class=\"row toggle-field-container\">\n<div class=\"form-group\" ng-class=\"{'col-sm-4': ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser) || ($ctrl.model.downloadToHHT),\n\t\t\t\t\t\t\t\t\t 'col-sm-6': ($ctrl.model.serviceUser) || ($ctrl.model.serviceUser && $ctrl.model.downloadToHHT), \n\t\t\t\t\t\t\t\t\t 'col-sm-12': ($ctrl.model.serviceUser && !$ctrl.model.isWebUser && !$ctrl.model.downloadToHHT)}\" ng-if=\"$ctrl.model.downloadToHHT || $ctrl.model.serviceUser\">\n<label for=\"branch\">{{ 'users.defaultAppView' | translate }} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.defaultAppView\" ng-options=\"appview.value as appview.label for appview in $ctrl.defaultAppView\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div id=\"user-phone\" class=\"form-group\" ng-class=\"{'col-sm-6': (!$ctrl.model.downloadToHHT && $ctrl.model.isWebUser) || ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t \t\t\t($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser),\n\t\t\t\t\t\t\t\t\t\t\t\t'col-sm-12':(!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser),\n\t\t\t\t\t\t\t\t\t\t\t\t'col-sm-4': ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser) || ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser)}\">\n<label>{{'users.phone' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-required=\"$ctrl.model.downloadToHHT || $ctrl.model.serviceUser\" ng-model=\"$ctrl.model.phone\" ui-us-phone-number>\n</div>\n<div id=\"user-payrollId\" class=\"form-group\" ng-class=\"{\n\t\t\t\t\t'col-sm-4': ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && !$ctrl.model.serviceUser) || ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && !$ctrl.model.serviceUser),\n\t\t\t\t\t'col-sm-12':($ctrl.model.isWebUser && $ctrl.model.serviceUser && !$ctrl.model.downloadToHHT) || (!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser)\n\t\t\t\t\t|| (!$ctrl.model.isWebUser && !$ctrl.model.serviceUser && !$ctrl.model.downloadToHHT),\n\t\t\t\t\t'col-sm-6': ($ctrl.model.isWebUser && !$ctrl.model.serviceUser && !$ctrl.model.downloadToHHT) || ($ctrl.model.serviceUser && $ctrl.model.downloadToHHT && !$ctrl.model.isWebUser)\n\t\t\t\t\t|| ($ctrl.model.isWebUser && $ctrl.model.serviceUser && $ctrl.model.downloadToHHT)\n\t\t\t\t\t}\">\n<label>{{'users.payroll' | translate}}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.payrollId\">\n</div>\n<div class=\"form-group\" ng-class=\"{'col-sm-4': ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser) || ($ctrl.model.downloadToHHT),\n\t\t\t\t\t\t\t\t\t 'col-sm-6': ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser) || ($ctrl.model.isWebUser && $ctrl.model.serviceUser),\n\t\t\t\t\t\t\t\t\t 'col-sm-12': (!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser)}\" ng-if=\"$ctrl.model.downloadToHHT || $ctrl.model.serviceUser\">\n<label for=\"lastName\">{{'users.hhtPassword' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"$ctrl.model.hhtPassword\" ng-required=\"$ctrl.model.downloadToHHT\">\n</div>\n<div class=\"_form-group\" ng-class=\"{'col-sm-6': (!$ctrl.model.downloadToHHT && $ctrl.model.isWebUser) || ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser) ||\n\t\t\t\t\t($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser),\n\t\t\t   \t\t'col-sm-12':(!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser),\n\t\t\t   \t\t'col-sm-4 margin-bottom-10': ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser) || ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser)}\">\n<label for=\"user-timezone\">{{'setup.timezone' | translate}}</label>\n<select id=\"user-timezone\" class=\"form-control\" ng-model=\"$ctrl.model.timezone\" ng-options=\"timezone.value as timezone.label  for timezone in $ctrl.timezoneList\" ng-required=\"$ctrl.model.customerUser\">\n<option value=\"\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"_form-group\" ng-if=\"$ctrl.model.isWebUser\" ng-class=\"{\n\t\t\t\t\t\t\t'col-sm-6': $ctrl.model.isWebUser && (!$ctrl.model.downloadToHHT || ($ctrl.model.serviceUser && $ctrl.model.downloadToHHT)),\n\t\t\t\t\t\t\t'col-sm-4': $ctrl.model.isWebUser && $ctrl.model.downloadToHHT && !$ctrl.model.serviceUser,\n\t\t\t\t\t\t\t'col-sm-12': $ctrl.model.isWebUser && $ctrl.model.serviceUser && !$ctrl.model.downloadToHHT,\n\t\t\t\t\t\t\t'margin-bottom-10': $ctrl.model.isWebUser && $ctrl.model.serviceUser\n\t\t\t\t\t\t}\">\n<label for=\"user-count-station\">{{'setup.count_station' | translate}}</label>\n<select id=\"user-count-station\" class=\"form-control\" ng-model=\"$ctrl.model.branchCounterId\" ng-options=\"countStation.value as countStation.label  for countStation in $ctrl.countStationList\">\n<option value=\"\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"_form-group col-sm-12 margin-bottom-10\" ng-class=\"{'margin-top-15': !$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser}\" ng-if=\"$ctrl.model.serviceUser\">\n<div class=\"row toggles-row\">\n<div class=\"form-group col-sm-3 toggle-field-container\">\n<label>{{'user.limit_to_service_zone' | translate}}</label>\n<input id=\"limit_to_service_zone\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.limitToServiceZone\" type=\"checkbox\" ng-change=\"$ctrl.resetServiceZone()\"/>\n</div>\n<div class=\"form-group col-sm-6 user-service-zone-multi-select-dd\" ng-class=\"{'user-multi-select-dd': ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser) || ($ctrl.model.serviceUser && $ctrl.model.isWebUser) || \n\t\t\t\t\t\t\t\t\t\t($ctrl.model.downloadToHHT && $ctrl.model.serviceUser)}\" ng-if=\"$ctrl.model.limitToServiceZone\">\n<label for=\"\">{{ 'location.location_zone' | translate }} </label>\n<div class=\"multi-select\" ng-class=\"{'invalid-multi-select-value': !$ctrl.model.selectedZones.length,\n\t\t\t\t\t\t\t\t'valid-multi-select-value': $ctrl.model.selectedZones.length}\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.serviceZoneData\" output-model=\"$ctrl.model.selectedZones\" button-label=\"zoneInfo\" item-label=\"label\" search-property=\"zoneInfo\" tick-property=\"ticked\" group-property=\"msGroup\" directive-id=\"user-service-zone-multi-select\" translation=\"$ctrl.localLang\" on-item-click=\"$ctrl.autoSelectSameForAll();\" on-select-all=\"$ctrl.autoSelectSameForAll();\" on-select-none=\"$ctrl.autoSelectSameForAll();\" on-reset=\"$ctrl.autoSelectSameForAll();\" is-disabled=\"$ctrl.loadFundingSource\">\n</div>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.serviceUser\">\n<label>{{'users.self_assign' | translate }}</label>\n<input id=\"selfAssignServiceTicket\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.selfAssignServiceTicket\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\">\n<label>{{'users.reject_tickets' | translate}}</label>\n<input id=\"reject_service_tickets\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.rejectTickets\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.serviceUser\">\n<label>{{'users.user_assign' | translate }}</label>\n<input id=\"userAssignServiceTicket\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.userAssignServiceTicket\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.serviceUser\">\n<label>{{'user.add_actions' | translate }}</label>\n<input id=\"addActions\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.addActions\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.serviceUser\">\n<label>{{'user.create_ticket' | translate }}</label>\n<input id=\"createTickets\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.createTickets\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"_form-group remove-left-pad remove-right-pad col-sm-12\" ng-if=\"$ctrl.model.serviceUser\">\n<div class=\"col-sm-4 margin-bottom-10\">\n<label for=\"serviceLevel\">{{'user.service_level' | translate }}</label>\n<select class=\"form-control\" id=\"serviceLevel\" ng-model=\"$ctrl.model.serviceLevel\" ng-options=\"sl.value as sl.label for sl in $ctrl.serviceLevelList\">\n</select>\n</div>\n<div class=\"col-sm-4 margin-bottom-10\">\n<label for=\"userOrigin\">{{'user.user_origin' | translate }}</label>\n<select class=\"form-control\" id=\"userOrigin\" ng-model=\"$ctrl.model.userOrigin\" ng-options=\"uo.value as uo.label for uo in $ctrl.userOriginList\">\n</select>\n</div>\n<div id=\"make\" class=\"form-group col-sm-4 margin-bottom-10\">\n<label for=\"make\">{{'user.certified_atm_makes' | translate }}</label>\n<div class=\"multi-select valid-multi-select-value user-atmmake-dd\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.atmMakesList\" output-model=\"$ctrl.model.make\" button-label=\"Key\" item-label=\"Key\" search-property=\"Key\" tick-property=\"ticked\" directive-id=\"multi-select-make\">\n</div>\n</div>\n</div>\n<div class=\"_form-group remove-left-pad remove-right-pad col-sm-12\" ng-if=\"$ctrl.model.serviceUser && $ctrl.model.userOrigin === 'USER'\">\n<div class=\"form-group col-sm-4\">\n<label for=\"address\">{{'location._address' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"address\" ng-model=\"$ctrl.model.address\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"city\">{{'location._city' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"city\" ng-model=\"$ctrl.model.city\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<span class=\"pull-right\">\n<span for=\"state\"><b>Non US</b></span>\n<input type=\"checkbox\" ng-model=\"$ctrl.model.isNonUSLocation\" ng-click=\"$ctrl.resetText()\"/>\n</span>\n<label for=\"state\" style=\"display: inline-block;\">{{'location._state' | translate }} *</label>\n<div ng-show=\"!$ctrl.model.isNonUSLocation\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.state\" ng-options=\"state.value as state.label for state in $ctrl.states\" ng-required=\"!$ctrl.model.isNonUSLocation\">\n<option value=\"\">(select)</option>\n</select>\n</div>\n<div ng-show=\"$ctrl.model.isNonUSLocation\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.state\" ng-pattern=\"/^[a-zA-Z .]*$/\" ng-required=\"$ctrl.model.isNonUSLocation\">\n</div>\n</div>\n</div>\n<div class=\"_form-group remove-left-pad remove-right-pad col-sm-12\" ng-if=\"$ctrl.model.serviceUser && $ctrl.model.userOrigin === 'USER'\">\n<div class=\"form-group\" ng-class=\"{'col-sm-2': $ctrl.model.isNonUSLocation}\" ng-show=\"$ctrl.model.isNonUSLocation\">\n<label for=\"country\">{{'location.country' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" id=\"country\" ng-model=\"$ctrl.model.country\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-required=\"$ctrl.model.isNonUSLocation\">\n</div>\n<div class=\"form-group\" ng-class=\"{'col-sm-4': !$ctrl.model.isNonUSLocation, 'col-sm-2': $ctrl.model.isNonUSLocation}\">\n<label for=\"zip\">{{'location._zip' | translate }} *</label>\n<input required ng-pattern=\"/^\\d{5,6}(?:-\\d{4})?$/\" type=\"text\" class=\"form-control\" id=\"zip\" ng-model=\"$ctrl.model.zip\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<div class=\"d-flex justify-content-between-add align-items-center w-100\">\n<label for=\"lat\">{{'location.latitude' | translate }}</label>\n<button type=\"button\" uib-tooltip=\"{{'location.auto_detect' | translate }}\" tooltip-placement=\"top\" class=\"btn btn-primary btn-xs\" ng-click=\"$ctrl.autoDetect()\" ng-disabled=\"$ctrl.autoDetecting\">\n<span ng-if=\"$ctrl.autoDetecting\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'location.autoDetect' | translate}}</button>\n</div>\n<input type=\"text\" class=\"form-control\" id=\"lat\" ng-model=\"$ctrl.model.lat\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"long\">{{'location.longitude' | translate }}</label>\n<input type=\"text\" class=\"form-control\" id=\"long\" ng-model=\"$ctrl.model.long\"/>\n</div>\n</div>\n<div class=\"_form-group remove-pad-left remove-pad-right\" ng-class=\"{'col-sm-12': $ctrl.model.serviceUser,\n\t\t\t\t\t\t'col-sm-4': !$ctrl.model.serviceUser && $ctrl.model.downloadToHHT && $ctrl.model.isWebUser,\n\t\t\t\t\t\t'col-sm-4': $ctrl.model.downloadToHHT}\" ng-if=\"$ctrl.model.downloadToHHT && $ctrl.enableAutoCheckInCheckOut\">\n<div class=\"form-group col-sm-3\" ng-class=\"{'margin-right-10': !($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser)  &&  !($ctrl.model.downloadToHHT && $ctrl.model.serviceUser),\n\t\t\t\t\t'margin-right-0': $ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser\n\t\t\t\t}\">\n<label for=\"\" class=\"remove-white-space\">{{'users.auto_check_in' | translate }} </label><br>\n<input id=\"autoCheckIn\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.autoCheckIn\" ng-change=\"$ctrl.forceSupervisorToSetOn()\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3\" ng-class=\"{\n       'margin-left-20': !($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser) &&  !($ctrl.model.downloadToHHT && $ctrl.model.serviceUser),\n       'margin-left-0': $ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser\n     }\">\n<label for=\"\" class=\"remove-white-space\">{{'users.auto_check_out' | translate }} </label><br>\n<input id=\"autoCheckOut\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.autoCheckOut\" ng-change=\"$ctrl.forceSupervisorToSetOn()\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"form-group toggle-field-container margin-bottom-10\" ng-class=\"{\n\t\t\t\t\t\t'col-sm-4': !$ctrl.enableAutoCheckInCheckOut && !($ctrl.model.isWebUser && $ctrl.model.downloadToHHT),\n\t\t\t\t\t\t'col-sm-12': $ctrl.enableAutoCheckInCheckOut || ($ctrl.model.isWebUser && $ctrl.model.downloadToHHT)\n\t\t\t\t\t}\" ng-if=\"!$ctrl.model.serviceUser && $ctrl.model.downloadToHHT\">\n<label for=\"reject_service_tickets \">{{'users.reject_tickets' | translate}}</label>\n<input id=\"reject_service_tickets\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.rejectTickets\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"col-sm-12 margin-top-20 remove-pad-left remove-pad-right margin-bottom-10\" ng-if=\"$ctrl.model.downloadToHHT || $ctrl.model.serviceUser || $ctrl.model.isWebUser\">\n<label for=\"\" style=\"margin-bottom: 10px;\">{{'user.work_schedule' | translate}}</label>\n<div style=\"border: 1px solid #ccc; padding: 10px 5px 5px 5px; border-radius: 4px;\">\n<table style=\"table-layout: fixed; width: 100%; border-collapse: collapse; margin-bottom: 5px;\">\n<tr>\n<td style=\"width: 84px; vertical-align: middle; text-align: left; padding-left: 5px;\"><b>{{'location.weekday' | translate}}</b></td>\n<td ng-repeat=\"day in $ctrl.scheduleDays\" style=\"padding: 0;\">\n<a class=\"btn btn-block\" style=\"border-radius: 0; border: 1px solid #ccc;\" ng-click=\"$ctrl.toggleScheduleDay(day)\" ng-class=\"{'btn-primary': day.active, 'btn-default': !day.active}\" ng-style=\"$first ? {'border-top-left-radius': '4px', 'border-bottom-left-radius': '4px'} : ($last ? {'border-top-right-radius': '4px', 'border-bottom-right-radius': '4px'} : {})\">\n{{day.shortLabel}}\n</a>\n</td>\n</tr>\n</table>\n<div class=\"table-responsive\" style=\"overflow: visible !important;\">\n<table class=\"table table-condensed text-center\" style=\"table-layout: fixed; margin-bottom: 0;\">\n<tbody>\n<tr>\n<td style=\"vertical-align: middle; border-top: none;padding: 0px;text-align: left;width: 84px;padding-left: 5px;\"><b>{{'user.start_time' | translate}}</b></td>\n<td ng-repeat=\"day in $ctrl.scheduleDays\" style=\"border-top: none;padding-left: 0px;\" ng-style=\"$last ? {'padding-right': '0px'} : {}\" ng-class=\"{'bg-danger-light': $ctrl.scheduleErrors[day.key + 'Order']}\">\n<div ng-if=\"day.active\">\n<time-picker ng-model=\"$ctrl.model.schedule[day.startKey]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.validateScheduleDay(day)\" ng-required=\"day.active\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div ng-if=\"!day.active\" class=\"input-group\">\n<span class=\"form-control time-picker-value disabled\" style=\"opacity: 0.6; cursor: not-allowed; background-color: #eee;\"></span>\n<span class=\"input-group-btn\">\n<button class=\"btn btn-danger\" type=\"button\" disabled=\"disabled\">\n<span class=\"glyphicon glyphicon-remove-sign\"></span>\n</button>\n</span>\n</div>\n</td>\n</tr>\n<tr>\n<td style=\"vertical-align: middle; border-top: none;padding: 0px;text-align: left;width: 84px;padding-left: 5px;\"><b>{{'user.end_time' | translate}}</b></td>\n<td ng-repeat=\"day in $ctrl.scheduleDays\" style=\"border-top: none;padding-left: 0px;\" ng-style=\"$last ? {'padding-right': '0px'} : {}\" ng-class=\"{'bg-danger-light': $ctrl.scheduleErrors[day.key + 'Order']}\">\n<div ng-if=\"day.active\">\n<time-picker ng-model=\"$ctrl.model.schedule[day.endKey]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.validateScheduleDay(day)\" ng-required=\"day.active\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div ng-if=\"!day.active\" class=\"input-group\">\n<span class=\"form-control time-picker-value disabled\" style=\"opacity: 0.6; cursor: not-allowed; background-color: #eee;\"></span>\n<span class=\"input-group-btn\">\n<button class=\"btn btn-danger\" type=\"button\" disabled=\"disabled\">\n<span class=\"glyphicon glyphicon-remove-sign\"></span>\n</button>\n</span>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"alert alert-danger margin-top-10\" ng-if=\"$ctrl.hasScheduleErrors()\" style=\"margin-bottom: 0px;\">\n{{'user.schedule_time_error' | translate}}\n</div>\n</div>\n<div ng-if=\"$ctrl.model.downloadToHHT\">\n<table class=\"table table-hover table-bordered remove-pad table-pad-3\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'users.otc_company_name' | translate}}</th>\n<th class=\"text-center\">{{'users.lock_keys' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"data in $ctrl.OTCCompanyNameList track by $index\">\n<td>{{ data.label }}</td>\n<td>\n<table class=\"table table-hover table-bordered remove-pad\">\n<tbody>\n<tr ng-repeat=\"lock in $ctrl.company[data.value].lockSystem track by $index\">\n<td style=\"width: 30%;\">\n{{lock.label}}\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.OTCKeys[data.value][lock.value]\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" minlength=\"0\" maxlength=\"20\">\n</td>\n</tr>\n</tbody>\n</table>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"branch-funding-src-dd-width\" ng-class=\"{'margin-10': $ctrl.model.customerUser}\" ng-if=\"$ctrl.model.customerUser\">\n<label for=\"\">{{'users.customer_title' | translate}}</label>\n<search-and-select ng-model=\"$ctrl.model.customer\" values=\"$ctrl.customerList\" key=\"Key\" totalrecords=\"$ctrl.totalCustomer\" onscroll=\"$ctrl.getCustomer(searchKey, offset)\" on-click=\"$ctrl.getFundingSource()\" none-selected=\"'common.none'\" ng-required=\"$ctrl.model.customerUser\">\n</search-and-select>\n</div>\n<div class=\"margin-top-10 remove-left-pad remove-right-pad col-sm-12 branch-funding-src-dd-width\" ng-if=\"$ctrl.model.branch.length > 0 && !$ctrl.isServiceOnlyUser()\">\n<label for=\"\">{{'users.funding_source_title' | translate}}</label>\n<div class=\"form-group remove-left-pad remove-right-pad col-sm-12\">\n<div class=\"multi-select valid-multi-select-value branch-funding-src-dd\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.branchFundingSourceGrouped\" output-model=\"$ctrl.selectedFundingSource\" button-label=\"name\" item-label=\"label\" search-property=\"name\" tick-property=\"ticked\" group-property=\"msGroup\" directive-id=\"multi-select-button\" translation=\"$ctrl.localLang\">\n</div>\n</div>\n</div>\n<div class=\"row margin-10\">\n<div class=\"col-sm-12\">\n<label class=\"pull-left\" for=\"\">{{ 'users.permission' | translate }} *</label>\n<div class=\"form-group checkbox pull-right\" style=\"margin-top: 0px !important;\" ng-if=\"$ctrl.model.branch.length > 1\">\n<label>\n<input type=\"checkbox\" ng-model=\"$ctrl.model.sameForAll\"/>\n<strong>{{'users.sameForAllBranch' | translate }}</strong>\n</label>\n</div>\n<select class=\"form-control\" ng-required=\"($ctrl.model.isWebUser || $ctrl.model.customerUser) ? true : false\" ng-model=\"$ctrl.model.branchPermission\" ng-disabled=\"!($ctrl.model.isWebUser || $ctrl.model.customerUser)\" ng-options=\"branch.id as branch.id for branch in $ctrl.model.branch\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"(parentKey,permissions) in $ctrl.permissions\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-8 permission-item-container\">\n<input type=\"checkbox\" ng-if=\"$ctrl.model.customerUser && $ctrl.customerPermissions.indexOf(parentKey) >= 0\" ng-checked=\"$ctrl.hasPerm('default_redirect', parentKey) || $ctrl.hasChildDefaultRedirect(parentKey)\" ng-disabled=\"!$ctrl.hasAnyPerm(parentKey) && !$ctrl.hasChildDefaultRedirect(parentKey)\" ng-click=\"$ctrl.toggleDefaultRedirect(parentKey)\" class=\"default-redirect-checkbox\" uib-tooltip=\"{{ 'users.default_redirect_tooltip' | translate }}\" tooltip-placement=\"top\"/>\n<span style=\"vertical-align: middle;\">{{permissions.title_key | translate}}</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"btn-group pull-right\">\n<button ng-repeat=\"(key,val) in permissions.permission\" type=\"button\" class=\"btn btn-sm\" ng-click=\"$ctrl.togglePerm(key,parentKey)\" ng-class=\"{'btn-primary': $ctrl.hasPerm(key,parentKey),'btn-default': !$ctrl.hasPerm(key,parentKey)}\" ng-disabled=\"$ctrl.disabledPermissions(parentKey, key)\" ng-if=\"(parentKey !== 'bulk_cash_management' || ($ctrl.model.customerUser ? (key === 'view' || key === 'export') : key !== 'view')) && key !== 'default_redirect'\">\n<span>{{$ctrl.format(key, parentKey)}}</span>\n</button>\n</div>\n<button type=\"button\" ng-show=\"permissions.child || false\" class=\"btn btn-sm btn-default pull-right margin-right-10\" ng-click=\"$ctrl.toggleExpand(parentKey)\" ng-disabled=\"false && !$ctrl.model.isWebUser && (0 > $ctrl.customerPermissions.indexOf(parentKey))\">\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-plus': !$ctrl.expand(parentKey), 'glyphicon-minus':$ctrl.expand(parentKey)}\"></span>\n</button>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n<div class=\"row\" ng-show=\"$ctrl.expand(parentKey)\">\n<div class=\"col-sm-12\">\n<hr/>\n<div class=\"col-sm-12 remove-pad-left remove-pad-right\">\n<ul class=\"remove-bottom-margin list-group\">\n<li class=\"list-group-item\" ng-repeat=\"(parentKey,permissions) in permissions.child\">\n<div class=\"row align-right-vertically\">\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-5 pull-left remove-pad-left permission-item-container\">\n<input type=\"checkbox\" ng-if=\"$ctrl.model.customerUser && $ctrl.customerPermissions.indexOf(parentKey) >= 0\" ng-checked=\"$ctrl.hasPerm('default_redirect', parentKey)\" ng-disabled=\"!$ctrl.hasAnyPerm(parentKey) || !$ctrl.hasActiveAncestors(parentKey)\" ng-click=\"$ctrl.toggleDefaultRedirect(parentKey)\" class=\"default-redirect-checkbox\" uib-tooltip=\"{{ 'users.default_redirect_tooltip' | translate }}\" tooltip-placement=\"top\"/>\n<span style=\"vertical-align: middle;\">{{permissions.title_key | translate}}</span>\n</div>\n<div class=\"col-sm-7 remove-right-pad\">\n<div class=\"btn-group pull-right\">\n<button ng-repeat=\"(key,val) in permissions.permission\" type=\"button\" class=\"btn btn-sm\" ng-click=\"$ctrl.togglePerm(key,parentKey); $ctrl.allowSettings(key,parentKey)\" ng-class=\"{'btn-primary': $ctrl.hasPerm(key,parentKey),'btn-default': !$ctrl.hasPerm(key,parentKey)}\" ng-disabled=\"$ctrl.disabledPermissions(parentKey, key)\" ng-if=\"key !== 'default_redirect'\">\n<span>{{$ctrl.format(key, parentKey)}}</span>\n</button>\n</div>\n<button type=\"button\" ng-show=\"permissions.child || false\" class=\"btn btn-sm btn-default pull-right margin-right-10\" ng-click=\"$ctrl.toggleExpand(parentKey)\" ng-disabled=\"false && !$ctrl.model.isWebUser && (0 > $ctrl.customerPermissions.indexOf(parentKey))\">\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-plus': !$ctrl.expand(parentKey), 'glyphicon-minus':$ctrl.expand(parentKey)}\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-show=\"$ctrl.expand(parentKey)\">\n<hr/>\n<div class=\"col-sm-12\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"(parentKey,permissions) in permissions.child\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-6 permission-item-container\">\n<input type=\"checkbox\" ng-if=\"$ctrl.model.customerUser && $ctrl.customerPermissions.indexOf(parentKey) >= 0 && permissions.permission.hasOwnProperty('default_redirect')\" ng-checked=\"$ctrl.hasPerm('default_redirect', parentKey)\" ng-disabled=\"!$ctrl.hasAnyPerm(parentKey) || !$ctrl.hasActiveAncestors(parentKey)\" ng-click=\"$ctrl.toggleDefaultRedirect(parentKey)\" class=\"default-redirect-checkbox\" uib-tooltip=\"{{ 'users.default_redirect_tooltip' | translate }}\" tooltip-placement=\"top\"/>\n<span style=\"vertical-align: middle;\">{{permissions.title_key | translate}}</span>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"btn-group pull-right\">\n<button ng-repeat=\"(key,val) in permissions.permission\" type=\"button\" class=\"btn btn-sm\" ng-click=\"$ctrl.togglePerm(key,parentKey); $ctrl.allowSettings(key,parentKey)\" ng-class=\"{'btn-primary': $ctrl.hasPerm(key,parentKey),'btn-default': !$ctrl.hasPerm(key,parentKey)}\" ng-disabled=\"$ctrl.disabledPermissions(parentKey, key)\" ng-if=\"key !== 'default_redirect'\">\n<span>{{$ctrl.format(key, parentKey)}}</span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary margin-bottom-10\" ng-disabled=\"Form.$invalid ||  $ctrl.model.password!==$ctrl.cnfPassword || ($ctrl.model.selectedZones.length==0 && $ctrl.model.limitToServiceZone) || $ctrl.hasScheduleErrors()\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default margin-bottom-10\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</form>\n<div map-lazy-load=\"//maps.google.com/maps/api/js\" map-lazy-load-params=\"{{$ctrl.apiKey}}\" ng-if=\"$ctrl.render\"></div>\n</div>\n";
var id1="users.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2885 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"user-edit-header\">\n<div class=\"col-sm-6 margin-10\">\n<h4 translate=\"users.edit_users\"></h4>\n</div>\n<div class=\"col-sm-6 margin-10\" ng-show=\"::$ctrl.hasACL['edit']\">\n<button type=\"button\" class=\"btn btn-primary pull-right ml-5\" ng-if=\"$ctrl.model.isWebUser || $ctrl.model.customerUser\" ng-click=\"$ctrl.changePassword(true) \" ng-class=\"{ 'disabled': $ctrl.loading} \">{{'users.changeWebPassword' | translate }}</button>\n<button type=\"button\" class=\"btn btn-primary pull-right ml-5\" ng-if=\"$ctrl.model.downloadToHHT || $ctrl.model.serviceUser\" ng-click=\"$ctrl.changePassword(false) \" ng-class=\"{ 'disabled': $ctrl.loading} \">\n{{'users.changeAppPassword' | translate }}</button>\n</div>\n</div>\n<div class=\"col-sm-12 text-center font-size-70 margin-top-30\" ng-if=\"$ctrl.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</div>\n<div class=\"col-sm-12\" ng-if=\"!$ctrl.loading\">\n<form name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"col-sm-12 remove-pad\" ng-if=\"$ctrl.lastUpdated\">\n<div class=\"alert alert-info\">\n<strong>{{'entry_type.update-user' | translate}} {{'log.by' | translate}} :\n</strong> {{$ctrl.lastUpdated.userId}} | {{$ctrl.lastUpdated.userName}}\n<span class=\"pull-right\">{{$ctrl.moment($ctrl.lastUpdated.createdAt).fromNow()}}</span>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-3\">\n<label for=\"firstName\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"id\" placeholder=\"\" ng-model=\"$ctrl.model.id\" disabled=\"disabled\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"firstName\">{{'users.firstName' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"firstName\" placeholder=\"\" ng-model=\"$ctrl.model.firstName\" ng-pattern=\"/^[a-zA-Z0-9 -]*$/\">\n<span ng-if=\"$ctrl.errors.firstName\" class=\"text-danger\">{{$ctrl.errors['name']}}</span>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"lastName\">{{'users.lastName' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"lastName\" placeholder=\"\" ng-model=\"$ctrl.model.lastName\" ng-pattern=\"/^[a-zA-Z0-9 -]*$/\">\n<span ng-if=\"$ctrl.errors.lastName\" class=\"text-danger\">{{$ctrl.errors['name']}}</span>\n</div>\n<div class=\"form-group col-sm-3\">\n<label for=\"\">{{'users.languageId' | translate }} </label><br>\n<div id=\"language\" class=\"btn-group\">\n<button class=\"btn btn-md\" type=\"button\" ng-repeat=\"language in $ctrl.language\" ng-click=\"$ctrl.toggle(language)\" ng-class=\"{'btn-primary': $ctrl.isLangSelected(language),'btn-default': !$ctrl.isLangSelected(language)}\">\n{{language.label}}\n</button>\n</div>\n<span ng-if=\"$ctrl.errors.languageId\" class=\"text-danger\">{{$ctrl.errors['languageId']}}</span>\n</div>\n</div>\n<div class=\"toggles-style d-flex\">\n<div class=\"form-group\" ng-class=\"{'disabled': $ctrl.isDisabledSupervisor}\">\n<label for=\"\">{{'users.supervisor' | translate }} </label><br>\n<input id=\"supervisor\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.supervisor\" type=\"checkbox\" ng-change=\"$ctrl.setCustomerUser(false); $ctrl.clearFundingSourceIfServiceOnly();\"/>\n</div>\n<div class=\"form-group\">\n<label for=\"\">{{'users.handheldUser' | translate }}</label><br>\n<input id=\"handheldUser\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" ng-change=\"$ctrl.resetKeyId();$ctrl.setCustomerUser(false); $ctrl.clearFundingSourceIfServiceOnly();\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.downloadToHHT\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group\">\n<label for=\"\">{{'users.webUser' | translate }} </label><br>\n<input id=\"webUser\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" ng-change=\"$ctrl.resetWebUserData(); $ctrl.setCustomerUser(false); $ctrl.clearFundingSourceIfServiceOnly();\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.isWebUser\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group\">\n<label for=\"\">{{'users.service_user' | translate }} </label><br>\n<input id=\"serviceUser\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.serviceUser\" type=\"checkbox\" ng-change=\"$ctrl.setCustomerUser(false); $ctrl.resetServiceZone(); $ctrl.clearFundingSourceIfServiceOnly();\"/>\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.usersDefaultBranch.ATMTransfer\">\n<label for=\"\">{{'setup.atm_transfer' | translate }} </label><br>\n<input id=\"ATMTransfer\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.ATMTransfer\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group\" ng-class=\"{'disabled' :(($ctrl.defaultModel.supervisor || $ctrl.defaultModel.downloadToHHT || $ctrl.defaultModel.isWebUser || $ctrl.defaultModel.serviceUser) && !$ctrl.defaultModel.customerUser)}\">\n<label for=\"\">{{'users.customer_user' | translate }} </label><br>\n<input id=\"customerUser\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-change=\"$ctrl.setCustomerUser(true);\" ng-model=\"$ctrl.model.customerUser\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group\">\n<label for=\"\">{{'users.shipmentTransfer' | translate }}</label><br>\n<input id=\"shipmentTransfer\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.shipmentTransfer\" type=\"checkbox\"/>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group col-sm-4\" ng-if=\"$ctrl.model.isWebUser || $ctrl.model.customerUser\">\n<label for=\"email\">{{'users.email' | translate }} *</label>\n<input type=\"email\" class=\"form-control\" required id=\"email\" placeholder=\"\" ng-model=\"$ctrl.model.email\">\n<span ng-if=\"$ctrl.errors.email\" class=\"text-danger\">{{$ctrl.errors['email']}}</span>\n</div>\n<div ng-class=\"{'col-sm-4': ($ctrl.model.isWebUser || $ctrl.model.customerUser), 'col-sm-12': !($ctrl.model.isWebUser || $ctrl.model.customerUser)}\">\n<label for=\"\">{{ 'users.all_branches' | translate }} *</label>\n<div class=\"form-group\">\n<div class=\"multi-select\" ng-class=\"{\n\t\t\t\t\t\t\t'invalid-multi-select-value': !$ctrl.model.branch.length,\n\t\t\t\t\t\t\t'valid-multi-select-value': $ctrl.model.branch.length,\n\t\t\t\t\t\t\t'user-multi-select-dd': ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && !$ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t(!$ctrl.model.downloadToHHT && $ctrl.model.isWebUser && !$ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t(!$ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t(!$ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser),\n\t\t\t\t\t\t\t'user-branch-multi-select-dd': (!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser)  || \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   (!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && !$ctrl.model.serviceUser)||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && !$ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser)\n\t\t\t\t\t\t}\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.branchData\" output-model=\"$ctrl.model.branch\" button-label=\"id\" item-label=\"id\" search-property=\"id\" tick-property=\"ticked\" directive-id=\"multi-select-button\" translation=\"$ctrl.localLang\" on-item-click=\"$ctrl.autoSelectSameForAll(); $ctrl.getFundingSource(); $ctrl.loadServiceZone();\" on-select-all=\"$ctrl.autoSelectSameForAll(); $ctrl.getFundingSource(); $ctrl.loadServiceZone();\" on-select-none=\"$ctrl.autoSelectSameForAll(); $ctrl.getFundingSource(); $ctrl.loadServiceZone();\" on-reset=\"$ctrl.autoSelectSameForAll(); $ctrl.getFundingSource(); $ctrl.loadServiceZone();\" is-disabled=\"$ctrl.loadFundingSource\">\n</div>\n</div>\n</div>\n<div class=\"form-group\" ng-class=\"{'col-sm-4': ($ctrl.model.isWebUser || $ctrl.model.customerUser), 'col-sm-12': !($ctrl.model.isWebUser || $ctrl.model.customerUser)}\">\n<label for=\"branch\">{{ 'users.default_branches' | translate }} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.branchId\" ng-options=\"branch.id as branch.id for branch in $ctrl.model.branch\" ng-change=\"$ctrl.dropdownBranchPermission(); $ctrl.getSetupDetails(); $ctrl.validateAutoChekInChekOut(); $ctrl.getBranchCounters()\">\n<option value=\"\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"form-group\" ng-class=\"{'col-sm-4': ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser) || ($ctrl.model.downloadToHHT),\n\t\t\t\t\t\t\t\t\t\t\t\t'col-sm-6': ($ctrl.model.serviceUser) || ($ctrl.model.serviceUser && $ctrl.model.downloadToHHT), \n\t\t\t\t\t\t\t\t\t\t\t\t'col-sm-12': ($ctrl.model.serviceUser && !$ctrl.model.isWebUser && !$ctrl.model.downloadToHHT)}\" ng-if=\"$ctrl.model.downloadToHHT || $ctrl.model.serviceUser\">\n<label for=\"branch\">{{ 'users.defaultAppView' | translate }} *</label>\n<select class=\"form-control\" required ng-model=\"$ctrl.model.defaultAppView\" ng-options=\"appview.value as appview.label for appview in $ctrl.defaultAppView\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div id=\"user-phone\" class=\"form-group\" ng-class=\"{'col-sm-12':(!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser) || ((!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && !$ctrl.model.serviceUser)),\n\t\t\t\t\t\t\t\t\t\t\t   'col-sm-4': ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser) || (!$ctrl.model.downloadToHHT && $ctrl.model.isWebUser) || ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser),\n\t\t\t\t\t\t\t\t\t\t\t   'col-sm-6': (!$ctrl.model.downloadToHHT && $ctrl.model.isWebUser) || ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t   ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser)}\">\n<label>{{'users.phone' | translate }} </label>\n<input type=\"text\" class=\"form-control\" ng-required=\"$ctrl.model.downloadToHHT || $ctrl.model.serviceUser\" ng-model=\"$ctrl.model.phone\" ui-us-phone-number>\n</div>\n<div id=\"user-payrollId\" class=\"form-group\" ng-class=\"{'col-sm-4': ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && !$ctrl.model.serviceUser) || ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && !$ctrl.model.serviceUser),\n\t\t\t\t\t\t\t\t\t\t\t\t'col-sm-12':($ctrl.model.isWebUser && $ctrl.model.serviceUser && !$ctrl.model.downloadToHHT) || (!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t(!$ctrl.model.isWebUser && !$ctrl.model.serviceUser && !$ctrl.model.downloadToHHT),\n\t\t\t\t\t\t\t\t\t\t\t\t'col-sm-6': ($ctrl.model.isWebUser && !$ctrl.model.serviceUser && !$ctrl.model.downloadToHHT) || ($ctrl.model.serviceUser && $ctrl.model.downloadToHHT && !$ctrl.model.isWebUser) ||\n\t\t\t\t\t\t\t\t\t\t\t\t($ctrl.model.isWebUser && $ctrl.model.serviceUser && $ctrl.model.downloadToHHT)}\">\n<label>{{'users.payroll' | translate}}</label>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.payrollId\">\n</div>\n<div class=\"form-group\" ng-class=\"{\n\t\t\t\t\t\t\t\t  'col-sm-12': !$ctrl.model.isWebUser && ((!$ctrl.model.downloadToHHT && !$ctrl.model.isWebUser) || (!$ctrl.model.downloadToHHT && !$ctrl.model.serviceUser) || (!$ctrl.model.downloadToHHT && $ctrl.model.serviceUser)),\n\t\t\t\t\t\t\t\t  'col-sm-4': !$ctrl.model.isWebUser && ( ($ctrl.model.downloadToHHT) || (!$ctrl.model.downloadToHHT)) || ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && !$ctrl.model.serviceUser),\n\t\t\t\t\t\t\t\t  'col-sm-6': $ctrl.model.isWebUser || (!$ctrl.model.downloadToHHT && $ctrl.model.isWebUser) || ($ctrl.model.downloadToHHT && !$ctrl.model.isWebUser && $ctrl.model.serviceUser)|| ($ctrl.model.downloadToHHT && $ctrl.model.isWebUser && $ctrl.model.serviceUser)}\">\n<label for=\"user-timezone\">{{'setup.timezone' | translate}}</label>\n<select id=\"user-timezone\" class=\"form-control\" ng-model=\"$ctrl.model.timezone\" ng-options=\"timezone.value as timezone.label  for timezone in $ctrl.timezoneList\" ng-required=\"$ctrl.model.customerUser\">\n<option value=\"\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group\" ng-if=\"$ctrl.model.isWebUser\" ng-class=\"{\n\t\t\t\t       'col-sm-6': $ctrl.model.isWebUser || ($ctrl.model.isWebUser && (!$ctrl.model.downloadToHHT || ($ctrl.model.serviceUser && $ctrl.model.downloadToHHT))),\n\t\t\t\t       'col-sm-4': $ctrl.model.isWebUser && $ctrl.model.downloadToHHT && !$ctrl.model.serviceUser,\n\t\t\t\t       'margin-bottom-10': $ctrl.model.isWebUser && $ctrl.model.serviceUser\n\t\t\t\t     }\">\n<label for=\"user-count-station\">{{'setup.count_station' | translate}}</label>\n<select id=\"user-count-station\" class=\"form-control\" ng-model=\"$ctrl.model.branchCounterId\" ng-options=\"countStation.value as countStation.label for countStation in $ctrl.countStationList\">\n<option value=\"\" selected=\"selected\">({{'common.select' | translate}})</option>\n</select>\n</div>\n<div class=\"form-group col-sm-12 margin-top-10\" ng-if=\"$ctrl.model.downloadToHHT || $ctrl.model.serviceUser\">\n<div class=\"row toggles-row\">\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.downloadToHHT && $ctrl.enableAutoCheckInCheckOut\">\n<label>{{'users.auto_check_in' | translate }}</label>\n<input id=\"autoCheckIn\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.autoCheckIn\" ng-change=\"$ctrl.forceSupervisorToSetOn()\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.downloadToHHT && $ctrl.enableAutoCheckInCheckOut\">\n<label>{{'users.auto_check_out' | translate }}</label>\n<input id=\"autoCheckOut\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.autoCheckOut\" ng-change=\"$ctrl.forceSupervisorToSetOn()\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.downloadToHHT || $ctrl.model.serviceUser\">\n<label>{{'users.reject_tickets' | translate}}</label>\n<input id=\"reject_service_tickets\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.rejectTickets\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.serviceUser\">\n<label>{{'user.limit_to_service_zone' | translate}}</label>\n<input id=\"limit_to_service_zone\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.limitToServiceZone\" type=\"checkbox\" ng-change=\"$ctrl.resetServiceZone()\"/>\n</div>\n<div class=\"form-group col-sm-6 user-service-zone-multi-select-dd\" ng-if=\"$ctrl.model.serviceUser && $ctrl.model.limitToServiceZone\">\n<label for=\"\">{{ 'location.location_zone' | translate }} </label>\n<div class=\"multi-select\" ng-class=\"{'invalid-multi-select-value': !$ctrl.model.selectedZones.length,\n\t\t\t\t\t\t\t\t'valid-multi-select-value': $ctrl.model.selectedZones.length}\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.serviceZoneData\" output-model=\"$ctrl.model.selectedZones\" button-label=\"zoneInfo\" item-label=\"label\" search-property=\"zoneInfo\" tick-property=\"ticked\" group-property=\"msGroup\" directive-id=\"user-service-zone-multi-select\" translation=\"$ctrl.localLang\" on-item-click=\"$ctrl.autoSelectSameForAll();\" on-select-all=\"$ctrl.autoSelectSameForAll();\" on-select-none=\"$ctrl.autoSelectSameForAll();\" on-reset=\"$ctrl.autoSelectSameForAll();\" is-disabled=\"$ctrl.loadFundingSource\">\n</div>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.serviceUser\">\n<label>{{'users.self_assign' | translate }}</label>\n<input id=\"selfAssignServiceTicket\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.selfAssignServiceTicket\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.serviceUser\">\n<label>{{'users.user_assign' | translate }}</label>\n<input id=\"userAssignServiceTicket\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.userAssignServiceTicket\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.serviceUser\">\n<label>{{'user.add_actions' | translate }}</label>\n<input id=\"addActions\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.addActions\" type=\"checkbox\"/>\n</div>\n<div class=\"form-group col-sm-3 toggle-field-container\" ng-if=\"$ctrl.model.serviceUser\">\n<label>{{'user.create_ticket' | translate }}</label>\n<input id=\"createTickets\" bs-switch switch-size=\"small\" switch-on-text=\"{{'common.yes' | translate }}\" switch-off-text=\"{{'common.no' | translate }}\" switch-on-color=\"success\" switch-off-color=\"danger\" ng-model=\"$ctrl.model.createTickets\" type=\"checkbox\"/>\n</div>\n</div>\n</div>\n<div class=\"form-group remove-left-pad remove-right-pad col-sm-12\" ng-if=\"$ctrl.model.serviceUser\">\n<div class=\"col-sm-4 margin-bottom-10\">\n<label for=\"serviceLevel\">{{'user.service_level' | translate }}</label>\n<select class=\"form-control\" id=\"serviceLevel\" ng-model=\"$ctrl.model.serviceLevel\" ng-options=\"sl.value as sl.label for sl in $ctrl.serviceLevelList\">\n</select>\n</div>\n<div class=\"col-sm-4 margin-bottom-10\">\n<label for=\"userOrigin\">{{'user.user_origin' | translate }}</label>\n<select class=\"form-control\" id=\"userOrigin\" ng-model=\"$ctrl.model.userOrigin\" ng-options=\"uo.value as uo.label for uo in $ctrl.userOriginList\">\n</select>\n</div>\n<div id=\"make\" class=\"form-group col-sm-4 margin-bottom-10\">\n<label for=\"make\">{{'user.certified_atm_makes' | translate }}</label>\n<div class=\"multi-select valid-multi-select-value user-atmmake-dd\" isteven-multi-select max-labels=\"3\" input-model=\"$ctrl.atmMakesList\" output-model=\"$ctrl.model.make\" button-label=\"Key\" item-label=\"Key\" search-property=\"Key\" tick-property=\"ticked\" directive-id=\"multi-select-make\">\n</div>\n</div>\n</div>\n<div class=\"_form-group remove-left-pad remove-right-pad col-sm-12\" ng-if=\"$ctrl.model.serviceUser && $ctrl.model.userOrigin === 'USER'\">\n<div class=\"form-group col-sm-4\">\n<label for=\"address\">{{'location._address' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"address\" ng-model=\"$ctrl.model.address\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"city\">{{'location._city' | translate }} *</label>\n<input type=\"text\" required class=\"form-control\" id=\"city\" ng-model=\"$ctrl.model.city\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<span class=\"pull-right\">\n<span for=\"state\"><b>Non US</b></span>\n<input type=\"checkbox\" ng-model=\"$ctrl.model.isNonUSLocation\" ng-click=\"$ctrl.resetText()\"/>\n</span>\n<label for=\"state\" style=\"display: inline-block;\">{{'location._state' | translate }} *</label>\n<div ng-show=\"!$ctrl.model.isNonUSLocation\">\n<select class=\"form-control\" ng-model=\"$ctrl.model.state\" ng-options=\"state.value as state.label for state in $ctrl.states\" ng-required=\"!$ctrl.model.isNonUSLocation\">\n<option value=\"\">(select)</option>\n</select>\n</div>\n<div ng-show=\"$ctrl.model.isNonUSLocation\">\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.model.state\" ng-pattern=\"/^[a-zA-Z .]*$/\" ng-required=\"$ctrl.model.isNonUSLocation\">\n</div>\n</div>\n</div>\n<div class=\"_form-group remove-left-pad remove-right-pad col-sm-12\" ng-if=\"$ctrl.model.serviceUser && $ctrl.model.userOrigin === 'USER'\">\n<div class=\"form-group\" ng-class=\"{'col-sm-2': $ctrl.model.isNonUSLocation}\" ng-show=\"$ctrl.model.isNonUSLocation\">\n<label for=\"country\">{{'location.country' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" id=\"country\" ng-model=\"$ctrl.model.country\" ng-pattern=\"/^[a-zA-Z ]*$/\" ng-required=\"$ctrl.model.isNonUSLocation\">\n</div>\n<div class=\"form-group\" ng-class=\"{'col-sm-4': !$ctrl.model.isNonUSLocation, 'col-sm-2': $ctrl.model.isNonUSLocation}\">\n<label for=\"zip\">{{'location._zip' | translate }} *</label>\n<input required ng-pattern=\"/^\\d{5,6}(?:-\\d{4})?$/\" type=\"text\" class=\"form-control\" id=\"zip\" ng-model=\"$ctrl.model.zip\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<div class=\"d-flex justify-content-between-add align-items-center w-100\">\n<label for=\"lat\">{{'location.latitude' | translate }}</label>\n<button type=\"button\" uib-tooltip=\"{{'location.auto_detect' | translate }}\" tooltip-placement=\"top\" class=\"btn btn-primary btn-xs\" ng-click=\"$ctrl.autoDetect()\" ng-disabled=\"$ctrl.autoDetecting\">\n<span ng-if=\"$ctrl.autoDetecting\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n{{'location.autoDetect' | translate}}</button>\n</div>\n<input type=\"text\" class=\"form-control\" id=\"lat\" ng-model=\"$ctrl.model.lat\"/>\n</div>\n<div class=\"form-group col-sm-4\">\n<label for=\"long\">{{'location.longitude' | translate }}</label>\n<input type=\"text\" class=\"form-control\" id=\"long\" ng-model=\"$ctrl.model.long\"/>\n</div>\n</div>\n<div class=\"col-sm-12\" ng-if=\"$ctrl.model.downloadToHHT || $ctrl.model.serviceUser || $ctrl.model.isWebUser\">\n<label for=\"\" style=\"margin-bottom: 10px;\">{{'user.work_schedule' | translate}}</label>\n<div style=\"border: 1px solid #ccc; padding: 10px 5px 5px 5px; border-radius: 4px;\">\n<table style=\"table-layout: fixed; width: 100%; border-collapse: collapse; margin-bottom: 5px;\">\n<tr>\n<td style=\"width: 84px; vertical-align: middle; text-align: left; padding-left: 5px;\"><b>{{'location.weekday' | translate}}</b></td>\n<td ng-repeat=\"day in $ctrl.scheduleDays\" style=\"padding: 0;\">\n<a class=\"btn btn-block\" style=\"border-radius: 0; border: 1px solid #ccc;\" ng-click=\"$ctrl.toggleScheduleDay(day)\" ng-class=\"{'btn-primary': day.active, 'btn-default': !day.active}\" ng-style=\"$first ? {'border-top-left-radius': '4px', 'border-bottom-left-radius': '4px'} : ($last ? {'border-top-right-radius': '4px', 'border-bottom-right-radius': '4px'} : {})\">\n{{day.shortLabel}}\n</a>\n</td>\n</tr>\n</table>\n<div class=\"table-responsive\" style=\"overflow: visible !important;\">\n<table class=\"table table-condensed text-center\" style=\"table-layout: fixed; margin-bottom: 0;\">\n<tbody>\n<tr>\n<td style=\"vertical-align: middle; border-top: none;padding: 0px;text-align: left;width: 84px;padding-left: 5px;\"><b>{{'user.start_time' | translate}}</b></td>\n<td ng-repeat=\"day in $ctrl.scheduleDays\" style=\"border-top: none;padding-left: 0px;\" ng-style=\"$last ? {'padding-right': '0px'} : {}\">\n<div ng-if=\"day.active\">\n<time-picker ng-model=\"$ctrl.model.schedule[day.startKey]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.validateScheduleDay(day)\" ng-required=\"day.active\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div ng-if=\"!day.active\" class=\"input-group\">\n<span class=\"form-control time-picker-value disabled\" style=\"opacity: 0.6; cursor: not-allowed; background-color: #eee;\"></span>\n<span class=\"input-group-btn\">\n<button class=\"btn btn-danger\" type=\"button\" disabled=\"disabled\">\n<span class=\"glyphicon glyphicon-remove-sign\"></span>\n</button>\n</span>\n</div>\n</td>\n</tr>\n<tr>\n<td style=\"vertical-align: middle; border-top: none;padding: 0px;text-align: left;width: 84px;padding-left: 5px;\"><b>{{'user.end_time' | translate}}</b></td>\n<td ng-repeat=\"day in $ctrl.scheduleDays\" style=\"border-top: none;padding-left: 0px;\" ng-style=\"$last ? {'padding-right': '0px'} : {}\">\n<div ng-if=\"day.active\">\n<time-picker ng-model=\"$ctrl.model.schedule[day.endKey]\" display-time-format=\"false\" is-meridian=\"false\" ng-change=\"$ctrl.validateScheduleDay(day)\" ng-required=\"day.active\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"></time-picker>\n</div>\n<div ng-if=\"!day.active\" class=\"input-group\">\n<span class=\"form-control time-picker-value disabled\" style=\"opacity: 0.6; cursor: not-allowed; background-color: #eee;\"></span>\n<span class=\"input-group-btn\">\n<button class=\"btn btn-danger\" type=\"button\" disabled=\"disabled\">\n<span class=\"glyphicon glyphicon-remove-sign\"></span>\n</button>\n</span>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n<div class=\"alert alert-danger margin-top-10\" ng-if=\"$ctrl.hasScheduleErrors()\" style=\"margin-bottom: 0px;\">\n{{'user.schedule_time_error' | translate}}\n</div>\n</div>\n</div>\n<div class=\"margin-top-10 table-responsive\" ng-if=\"$ctrl.model.downloadToHHT\">\n<table class=\"table table-hover table-bordered remove-pad table-pad-3\">\n<thead>\n<tr class=\"header-row\">\n<th class=\"text-center\">{{'users.otc_company_name' | translate}}</th>\n<th class=\"text-center\">{{'users.lock_keys' | translate}}</th>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"data in $ctrl.OTCCompanyNameList track by $index\">\n<td>{{ data.label }}\n<button type=\"button\" ng-disabled=\"$ctrl.isSyncWithOTC[data.value].process || !$ctrl.model.phone\" class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.syncWithOTC(data.value)\">\n<span ng-class=\"{ 'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.isSyncWithOTC[data.value].process} \"></span>\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"{{'users.sync_with_otc' | translate}}\" tooltip-placement=\"top\" ng-if=\"!$ctrl.isSyncWithOTC[data.value].process\"></span>\n</button>\n</td>\n<td>\n<table class=\"table table-hover table-bordered remove-pad\">\n<tbody>\n<tr ng-repeat=\"lock in $ctrl.company[data.value].lockSystem track by $index\">\n<td style=\"width: 30%;\">\n{{lock.label}}\n</td>\n<td>\n<input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.OTCKeys[data.value][lock.value]\" ng-pattern=\"/^[a-zA-Z0-9 ]*$/\" minlength=\"0\" maxlength=\"20\">\n</td>\n</tr>\n</tbody>\n</table>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"branch-funding-src-dd-width\" ng-class=\"{'margin-10': $ctrl.model.downloadToHHT}\" ng-if=\"$ctrl.model.customerUser\">\n<label for=\"\">{{'users.customer_title' | translate}} </label>\n<search-and-select ng-model=\"$ctrl.model.customer\" values=\"$ctrl.customerList\" key=\"Key\" on-click=\"$ctrl.getFundingSource();\" totalrecords=\"$ctrl.totalCustomer\" onscroll=\"$ctrl.getCustomer(searchKey, offset)\" is-edit=\"true\" none-selected=\"'common.none'\" ng-required=\"$ctrl.model.customerUser\">\n</search-and-select>\n</div>\n<div class=\"row_ margin-top-10 col-sm-12_ branch-funding-src-dd-width\" ng-class=\"{'margin-10': $ctrl.model.downloadToHHT}\" ng-if=\"$ctrl.model.branch.length > 0 && !$ctrl.isServiceOnlyUser()\">\n<label for=\"\">{{'users.funding_source_title' | translate}}</label>\n<div class=\"form-group extra-section-css\">\n<div class=\"multi-select valid-multi-select-value edit-branch-funding-src-dd\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.branchFundingSourceGrouped\" output-model=\"$ctrl.selectedFundingSource\" button-label=\"name\" item-label=\"label\" search-property=\"name\" tick-property=\"ticked\" group-property=\"msGroup\" directive-id=\"multi-select-button\" translation=\"$ctrl.localLang\">\n</div>\n</div>\n</div>\n<div class=\"row margin-10\">\n<div class=\"col-sm-12\">\n<label class=\"pull-left\" for=\"\">{{ 'users.permission' | translate }} *</label>\n<div class=\"form-group checkbox pull-right\" style=\"margin-top: 0px !important;\" ng-show=\"::$ctrl.hasACL['edit']\" ng-if=\"$ctrl.model.branch.length > 1\">\n<label>\n<input type=\"checkbox\" ng-model=\"$ctrl.model.sameForAll\" ng-disabled=\"!($ctrl.model.isWebUser || $ctrl.model.customerUser)\" ng-click=\"$ctrl.assignPermissions()\"/>\n<strong>{{'users.sameForAllBranch' | translate }}</strong>\n</label>\n</div>\n<select class=\"form-control\" ng-required=\"($ctrl.model.isWebUser || $ctrl.model.customerUser) ? true : false\" ng-model=\"$ctrl.model.branchPermission\" ng-disabled=\"!($ctrl.model.isWebUser || $ctrl.model.customerUser)\" ng-options=\"branch.id as branch.id for branch in $ctrl.model.branch\" ng-change=\"$ctrl.getBranchPermission()\">\n<option value=\"\" selected=\"selected\" disabled=\"disabled\">({{'common.select' | translate}})</option>\n</select>\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"(parentKey,permissions) in $ctrl.permissions\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-8 permission-item-container\">\n<input type=\"checkbox\" ng-if=\"$ctrl.model.customerUser && $ctrl.customerPermissions.indexOf(parentKey) >= 0\" ng-checked=\"$ctrl.hasPerm('default_redirect', parentKey) || $ctrl.hasChildDefaultRedirect(parentKey)\" ng-disabled=\"!$ctrl.hasAnyPerm(parentKey) && !$ctrl.hasChildDefaultRedirect(parentKey)\" ng-click=\"$ctrl.toggleDefaultRedirect(parentKey)\" class=\"default-redirect-checkbox\" uib-tooltip=\"{{ 'users.default_redirect_tooltip' | translate }}\" tooltip-placement=\"top\"/>\n<span style=\"vertical-align: middle;\">{{permissions.title_key | translate}}</span>\n</div>\n<div class=\"col-sm-5\" ng-show=\"::$ctrl.hasACL['edit']\">\n<div class=\"btn-group pull-right\">\n<button ng-repeat=\"(key,val) in permissions.permission\" type=\"button\" class=\"btn btn-sm\" ng-click=\"$ctrl.togglePerm(key,parentKey)\" ng-class=\"{'btn-primary': $ctrl.hasPerm(key,parentKey),'btn-default': !$ctrl.hasPerm(key,parentKey)}\" ng-disabled=\"$ctrl.disabledPermissions(parentKey, key)\" ng-if=\"(parentKey !== 'bulk_cash_management' || ($ctrl.model.customerUser ? (key === 'view' || key === 'export') : key !== 'view')) && key !== 'default_redirect'\">\n<span>{{$ctrl.format(key, parentKey)}}</span>\n</button>\n</div>\n<button type=\"button\" ng-show=\"permissions.child||false\" class=\"btn btn-sm btn-default pull-right margin-right-10\" ng-click=\"$ctrl.toggleExpand(parentKey)\" ng-disabled=\"false && !$ctrl.model.isWebUser\">\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-plus': !$ctrl.expand(parentKey), 'glyphicon-minus':$ctrl.expand(parentKey)}\"></span>\n</button>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n<div class=\"row\" ng-show=\"$ctrl.expand(parentKey)\">\n<div class=\"col-sm-12\">\n<hr/>\n<div class=\"col-sm-12 remove-pad-left remove-pad-right\">\n<ul class=\"remove-bottom-margin list-group\">\n<li class=\"list-group-item\" ng-repeat=\"(parentKey,permissions) in permissions.child\">\n<div class=\"row align-right-vertically\">\n<div class=\"col-sm-12 align-center-vertically\">\n<div class=\"col-sm-5 pull-left remove-pad-left permission-item-container\">\n<input type=\"checkbox\" ng-if=\"$ctrl.model.customerUser && $ctrl.customerPermissions.indexOf(parentKey) >= 0\" ng-checked=\"$ctrl.hasPerm('default_redirect', parentKey)\" ng-disabled=\"!$ctrl.hasAnyPerm(parentKey) || !$ctrl.hasActiveAncestors(parentKey)\" ng-click=\"$ctrl.toggleDefaultRedirect(parentKey)\" class=\"default-redirect-checkbox\" uib-tooltip=\"{{ 'users.default_redirect_tooltip' | translate }}\" tooltip-placement=\"top\"/>\n<span style=\"vertical-align: middle;\">{{permissions.title_key | translate}}</span>\n</div>\n<div class=\"col-sm-7 remove-right-pad\">\n<div class=\"btn-group pull-right\">\n<button ng-repeat=\"(key,val) in permissions.permission\" type=\"button\" class=\"btn btn-sm\" ng-click=\"$ctrl.togglePerm(key,parentKey); $ctrl.allowSettings(key,parentKey)\" ng-class=\"{'btn-primary': $ctrl.hasPerm(key,parentKey),'btn-default': !$ctrl.hasPerm(key,parentKey)}\" ng-disabled=\"$ctrl.disabledPermissions(parentKey, key)\" ng-if=\"key !== 'default_redirect'\">\n<span>{{$ctrl.format(key, parentKey)}}</span>\n</button>\n</div>\n<button type=\"button\" ng-show=\"permissions.child || false\" class=\"btn btn-sm btn-default pull-right margin-right-10\" ng-click=\"$ctrl.toggleExpand(parentKey)\" ng-disabled=\"false && !$ctrl.model.isWebUser && (0 > $ctrl.customerPermissions.indexOf(parentKey))\">\n<span class=\"glyphicon\" ng-class=\"{'glyphicon-plus': !$ctrl.expand(parentKey), 'glyphicon-minus':$ctrl.expand(parentKey)}\"></span>\n</button>\n</div>\n</div>\n<div class=\"col-sm-12 remove-pad\" ng-show=\"$ctrl.expand(parentKey)\">\n<hr/>\n<div class=\"col-sm-12\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"(parentKey,permissions) in permissions.child\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-6 permission-item-container\">\n<input type=\"checkbox\" ng-if=\"$ctrl.model.customerUser && $ctrl.customerPermissions.indexOf(parentKey) >= 0 && permissions.permission.hasOwnProperty('default_redirect')\" ng-checked=\"$ctrl.hasPerm('default_redirect', parentKey)\" ng-disabled=\"!$ctrl.hasAnyPerm(parentKey) || !$ctrl.hasActiveAncestors(parentKey)\" ng-click=\"$ctrl.toggleDefaultRedirect(parentKey)\" class=\"default-redirect-checkbox\" uib-tooltip=\"{{ 'users.default_redirect_tooltip' | translate }}\" tooltip-placement=\"top\"/>\n<span style=\"vertical-align: middle;\">{{permissions.title_key | translate}}</span>\n</div>\n<div class=\"col-sm-6\">\n<div class=\"btn-group pull-right\">\n<button ng-repeat=\"(key,val) in permissions.permission\" type=\"button\" class=\"btn btn-sm\" ng-click=\"$ctrl.togglePerm(key,parentKey); $ctrl.allowSettings(key,parentKey)\" ng-class=\"{'btn-primary': $ctrl.hasPerm(key,parentKey),'btn-default': !$ctrl.hasPerm(key,parentKey)}\" ng-disabled=\"$ctrl.disabledPermissions(parentKey, key)\" ng-if=\"key !== 'default_redirect'\">\n<span>{{$ctrl.format(key, parentKey)}}</span>\n</button>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage \" ng-bind-html=\"$ctrl.errorMessage \">\n</div>\n<button type=\"button\" ng-click=\"$ctrl.submit(this)\" class=\"btn btn-primary margin-bottom-10\" ng-show=\"::$ctrl.hasACL['edit'] || $ctrl.model.limitToServiceZone \" ng-disabled=\"Form.$invalid || ($ctrl.model.selectedZones.length==0 && $ctrl.model.limitToServiceZone) || $ctrl.hasScheduleErrors()\" ng-class=\"{ 'disabled': $ctrl.loading} \">\n<span ng-class=\"{ 'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading} \"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default margin-bottom-10\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.reset() \" ng-class=\"{ 'disabled': $ctrl.loading} \">{{'common.reset' | translate }}</button>\n</form>\n<div map-lazy-load=\"//maps.google.com/maps/api/js\" map-lazy-load-params=\"{{$ctrl.apiKey}}\" ng-if=\"$ctrl.render\"></div>\n</div>\n";
var id1="users.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2886 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row_\">\n<div class=\"col-sm-2 remove-left-pad\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"users.all\" ng-click=\"$ctrl.goToAll()\">\n<a translate=\"users.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"users.create\">\n<a translate=\"users.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10 remove-right-pad\">\n<ui-view>\n</ui-view></div>\n</div>\n</div>";
var id1="users.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2887 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div>\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'vault.all_vaults' | translate}} <span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n<div class=\"collapse navbar-collapse\">\n<form class=\"navbar-form navbar-right\">\n<div class=\"form-group\">\n<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'common.search' | translate }}\" ng-model=\"$ctrl.searchText\">\n</div>\n<button type=\"submit\" class=\"btn btn-default\" ng-click=\"$ctrl.search()\">\n<span class=\"glyphicon glyphicon-search\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\" uib-tooltip=\"{{ 'vault.tooltip_reload' | translate }}\">\n<span class=\"glyphicon glyphicon-refresh\"></span>\n</button>\n</form>\n</div>\n</div>\n<div ng-if=\"!$ctrl.loading\">\n<ul class=\"list-group\">\n<li class=\"list-group-item\" ng-repeat=\"vault in $ctrl.vaultes track by vault.id\">\n<div class=\"row align-center-vertically\">\n<div class=\"col-sm-7\">\n<span class=\"list-group-item-text\">\n{{vault.id}} | {{vault.description}}\n</span>\n</div>\n<div class=\"col-sm-5\">\n<div class=\"pull-right display-flex\">\n<div class=\"margin-right-10\">\n</div>\n<div class=\"btn-group\">\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['edit']\" ng-click=\"$ctrl.edit(vault)\" uib-tooltip=\"{{ 'vault.tooltip_edit' | translate }}\">\n<span class=\"glyphicon glyphicon-pencil\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-sm btn-default\" ng-show=\"::$ctrl.hasACL['delete']\" ng-click=\"$ctrl.delete(vault)\" uib-tooltip=\"{{ 'vault.tooltip_delete' | translate }}\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button></div>\n\n</div>\n<div class=\"clearfix\"></div>\n</div>\n</div>\n<div class=\"row\" ng-show=\"vault.expand\">\n<div class=\"col-sm-12\">\n<hr/>\n<div>\nExtra details here\n<br>\n<br>\n<br>\n<br> Extra Details\n</div>\n</div>\n</div>\n</li>\n</ul>\n<ul uib-pagination total-items=\"$ctrl.total\" next-text=\"{{'common.next'| translate}}\" ng-hide=\"{{($ctrl.total<=$ctrl.pageLimit)&&($ctrl.page==1)}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.page\" ng-change=\"$ctrl.pageChange()\" rotate=\"false\" max-size=\"10\"></ul>\n</div>\n</div>";
var id1="vault.all.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2888 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"vault.create_vault\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-6\">\n<form ng-submit=\"$ctrl.submit(this)\" name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"form-group\">\n<label for=\"exampleInputEmail1\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" required id=\"exampleInputEmail1\" placeholder=\"\" ng-model=\"$ctrl.model.id\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group\">\n<label for=\"exampleInputPassword1\">{{'common.description' | translate }} *</label>\n<textarea class=\"form-control\" rows=\"3\" required ng-model=\"$ctrl.model.description\"></textarea>\n<span ng-if=\"$ctrl.errors.description\" class=\"text-danger\">{{$ctrl.errors['description']}}</span>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"reset\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</form>\n</div>";
var id1="vault.create.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2889 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<h4 translate=\"vault.edit_vault\"></h4>\n<hr/>\n</div>\n<div class=\"col-sm-6\">\n<form ng-submit=\"$ctrl.submit(this)\" name=\"Form\" novalidate class=\"form-validate\">\n<div class=\"form-group\">\n<label for=\"id\">{{'common.id' | translate }} *</label>\n<input type=\"text\" class=\"form-control\" id=\"id\" required placeholder=\"\" ng-model=\"$ctrl.model.id\" disabled=\"\">\n<span ng-if=\"$ctrl.errors.id\" class=\"text-danger\">{{$ctrl.errors['id']}}</span>\n</div>\n<div class=\"form-group\">\n<label for=\"description\">{{'common.description' | translate }} *</label>\n<textarea class=\"form-control\" required rows=\"3\" id=\"description\" ng-model=\"$ctrl.model.description\"></textarea>\n<span ng-if=\"$ctrl.errors.description\" class=\"text-danger\">{{$ctrl.errors['description']}}</span>\n</div>\n<div class=\"form-group alert alert-danger\" ng-if=\"$ctrl.errorMessage\" ng-bind-html=\"$ctrl.errorMessage\">\n</div>\n<button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"Form.$invalid\" ng-class=\"{'disabled': $ctrl.loading}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span> {{'common.save' | translate}}\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.reset()\" ng-class=\"{'disabled': $ctrl.loading}\">{{'common.reset' | translate }}</button>\n</form>\n</div>";
var id1="vault.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2890 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row\">\n<div class=\"col-sm-2\">\n<ul class=\"nav nav-pills nav-stacked\">\n<li role=\"presentation\" ui-sref-active=\"active\" ng-click=\"$ctrl.goToAll()\" ui-sref=\"vault.all\">\n<a translate=\"vault.menu.all\"></a>\n</li>\n<li role=\"presentation\" ng-show=\"::$ctrl.hasACL['create']\" ui-sref-active=\"active\" ui-sref=\"vault.create\">\n<a translate=\"vault.menu.create\"></a>\n</li>\n</ul>\n</div>\n<div class=\"col-sm-10\">\n<ui-view>\n<ui-view>\n</ui-view></ui-view></div>\n</div>\n</div>";
var id1="vault.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2891 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<h1>Vault Balance</h1>";
var id1="vault_balance.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2892 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\">\n<div class=\"row text-align-center margin-top-40\">\n<h3>\n{{'closeVault.currentVaultDate' | translate}}: {{$ctrl.model.vaultDate}}\n</h3>\n</div>\n<div class=\"row text-align-center margin-top-20\">\n<div class=\"col-sm-offset-4 col-sm-4\">\n<button class=\"btn btn-block btn-lg btn-success\" ng-click=\"$ctrl.verifyCloseVault()\" ng-disabled=\"$ctrl.model.loading || $ctrl.loading || $ctrl.model.verifyErrors.length > 0\" ng-class=\"{'disabled': $ctrl.model.loading || $ctrl.loading || $ctrl.model.verifyErrors.length > 0 || $ctrl.model.isError}\">\n<span ng-class=\"{'glyphicon glyphicon-refresh fast-right-spinner': $ctrl.loading}\"></span>\n{{'closeVault.closeVault' | translate}}\n</button>\n</div>\n<div class=\"col-sm-offset-4 col-sm-4 resetBtn\" ng-click=\"$ctrl.truncateAllData()\" ng-show=\"$ctrl.userData.supervisor && $ctrl.showReset\">\n<button class=\"btn btn-block btn-lg btn-danger\">\n{{'closeVault.resetData' | translate}}\n</button>\n</div>\n</div>\n<div class=\"row text-align-center margin-top-40\" ng-if=\"$ctrl.model.verifyErrors.length > 0\">\n<hr>\n</div>\n<div class=\"row margin-top-20\" ng-if=\"$ctrl.model.verifyErrors.length > 0 && !$ctrl.model.loading\">\n<div class=\"form-group col-sm-3\">\n<label>{{'message.messages' | translate}}:</label>\n<div ng-class=\"{'disabled': $ctrl.model.loading}\" class=\"multi-select vault-close-search-dd\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.errorMessageList\" output-model=\"$ctrl.model.errorMessages\" button-label=\"translateMessage\" item-label=\"translateMessage\" search-property=\"message\" tick-property=\"ticked\" disable-property=\"$ctrl.model.loading\" directive-id=\"multi-select-button\">\n</div>\n</div>\n<div class=\"col-sm-3\">\n<label>{{'common.trackingId' | translate}}:</label>\n<input type=\"text\" ng-model-options=\"{debounce: 1000}\" class=\"form-control\" ng-model=\"$ctrl.model.searchText\" ng-disabled=\"$ctrl.model.loading\" placeholder=\"{{'common.searchPlaceHolder' | translate}}\">\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'common.originlocation' | translate}}:</label>\n<div ng-class=\"{'disabled': $ctrl.model.loading}\" class=\"multi-select vault-close-search-dd\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.model.originLocationList\" output-model=\"$ctrl.model.originLocations\" button-label=\"originLocationId\" item-label=\"originLocation\" search-property=\"originLocationId\" tick-property=\"ticked\" disable-property=\"$ctrl.model.loading\" directive-id=\"multi-select-button\">\n</div>\n</div>\n<div class=\"form-group col-sm-3\">\n<label>{{'common.destinationlocation' | translate}}:</label>\n<div ng-class=\"{'disabled': $ctrl.model.loading}\" class=\"multi-select vault-close-search-dd\" isteven-multi-select max-labels=\"2\" input-model=\"$ctrl.model.destinationLocationList\" output-model=\"$ctrl.model.destinationLocations\" button-label=\"destinationLocationId\" item-label=\"destinationLocation\" search-property=\"destinationLocationId\" tick-property=\"ticked\" disable-property=\"$ctrl.model.loading\" directive-id=\"multi-select-button\">\n</div>\n</div>\n</div>\n<div class=\"text-align-center margin-top-40\" ng-if=\"$ctrl.model.loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 70px\"></span>\n</div>\n<div class=\"row margin-top-20\" ng-if=\"$ctrl.model.verifyErrors.length > 0 && !$ctrl.model.loading\">\n<div class=\"col-sm-0\"></div>\n<div class=\"table-responsive col-sm-12\">\n<table class=\"table table-hover table-striped table-bordered\">\n<thead>\n<tr>\n<td>{{'common.number' | translate}}</td>\n<td>{{'common.message' | translate}}</td>\n<td>{{'common.tracking_id' | translate}}</td>\n<td>{{'common.originlocation' | translate}}</td>\n<td>{{'common.destinationlocation' | translate}}</td>\n<td>{{'coinPullReport.route' | translate}}</td>\n<td>{{'bypassCode.date' | translate}}</td>\n<td>{{'common.actions' | translate}}</td>\n</tr></thead>\n<tbody>\n<tr ng-repeat=\"row in $ctrl.model.verifyErrors | filter: $ctrl.filterData()\">\n<td>{{$index + 1}}</td>\n<td>{{row.translateMessage}}\n<span ng-if=\"row.message === 'LEDGER_CASH_DENOM_DIVERGENCE' || row.message === 'LEDGER_ECB'\"> | </span>\n<div ng-if=\"row.message === 'LEDGER_CASH_DENOM_DIVERGENCE' || row.message === 'LEDGER_ECB'\">\n<strong>\n({{$ctrl.capitalizeFirstLetter(row.ledgerAccount)}} | {{row.currencyId}} | {{row.fundingSourceId}} | {{row.fundingSourceName}})\n</strong>\n</div>\n<div ng-if=\"row.message === 'BALANCE_CHECK_VARIANCE'\">\n<strong>\n({{row.fundingSourceId}} | {{row.fundingSourceName}})\n</strong>\n</div>\n</td>\n<td ng-if=\"row.translateMessage === $ctrl.bagOutError && row.trackingId\">\n<a href=\"#\" ng-click=\"$ctrl.bagOutClose(row.trackingId)\">{{row.trackingId}}</a>\n</td>\n<td ng-if=\"row.translateMessage !== $ctrl.bagOutError && row.trackingId\">\n<span><a href=\"#\" ng-click=\"$ctrl.redirectToItemTab(row.trackingId)\" ng-if=\"row.message !== 'ITEM_NOT_CHECKED_IN'\">{{row.trackingId}}</a></span>\n<span ng-if=\"row.message == 'ITEM_NOT_CHECKED_IN'\">{{row.trackingId}}</span>\n</td>\n<td ng-if=\"!row.trackingId\">\n{{ 'common.n_a' | translate }}\n</td>\n<td ng-if=\"row.originLocationId && row.originLocationName\"><span ng-if=\"row.originLocationId\">{{row.originLocationId}}</span>\n<span ng-if=\"row.originLocationName\">| {{row.originLocationName}}</span></td>\n<td ng-if=\"!row.originLocationId && !row.originLocationName\">{{ 'common.n_a' | translate }}</td>\n<td ng-if=\"row.destinationLocationId && row.destinationLocationName\">\n<span ng-if=\"row.destinationLocationId\">\n<a href=\"#\" ng-click=\"$ctrl.redirectToServiceHistory(row.destinationLocationId)\">{{row.destinationLocationId}}</a>\n</span>\n<span ng-if=\"row.destinationLocationName\">| {{row.destinationLocationName}}</span></td>\n<td ng-if=\"!row.destinationLocationId && !row.destinationLocationName\">{{ 'common.n_a' | translate }}</td>\n<td ng-if=\"row.routeId\">\n<span ng-if=\"row.message !== 'ITEM_NOT_CHECKED_IN'\"><a href=\"#\" ng-click=\"$ctrl.goToRouteTab(row)\">{{row.routeId}}</a> | </span>\n<span ng-if=\"row.message == 'ITEM_NOT_CHECKED_IN'\">{{row.routeId}} | </span>\n<span>{{row.routeName}}</span>\n</td>\n<td ng-if=\"!row.routeId\">{{ 'common.n_a' | translate }}</td>\n<td ng-if=\"row.routeDate\">{{row.routeDate | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td ng-if=\"!row.routeDate\">\n{{ 'common.n_a' | translate }}\n</td>\n<td class=\"text-center\">\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'DELIVERY_NOT_PACKED'\">\n{{'closeVault.pack' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'DELIVERY_NOT_THROWN'\">\n{{'closeVault.throw' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'DELIVERY_NOT_CHECKED_OUT'\">\n{{'closeVault.check_out' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'PICKUP_NOT_CHECKED_IN' || row.message === 'DELIVERY_NOT_DELIVERED'\">\n{{'closeVault.check_in' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"['PICKUP_NOT_BAGGED_OUT', 'SHIPMENT_NOT_BAGGED_OUT'].includes(row.message)\">\n{{'closeVault.bag_out' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'HOLD_NOT_VERIFIED'\">\n{{'closeVault.hold_verify' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'DEPOSIT_NOT_RELEASED'\">\n{{'closeVault.deposit_pack' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'BAGOUT_NOT_CLOSED'\">\n{{'closeVault.bagout_close' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'BULK_TRANSFER_NOT_CLOSED'\">\n{{'closeVault.bt_close' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.routeCheckIn(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'ROUTE_NOT_CHECKED_IN'\">\n{{'closeVault.check_in' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'CRV_NOT_COUNTED'\">\n{{'navbar.ATM_count' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'RESIDUAL_NOT_APPROVED'\">\n{{'branch_mgmt.final_residual_count_commit.title' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'BALANCECHECK_MISSING' || row.message === 'BALANCE_CHECK_VARIANCE'\">\n{{'branch_mgmt.physical_cash_count.title' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.goToItemTab()\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'ITEM_NOT_CHECKED_IN'\">\n{{'item.items' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.goToATMCountTab()\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'COUNTABLE_PICKUP_NOT_COUNTED'\">\n{{'branch_mgmt.cash_count' | translate}}\n</button>\n<button type=\"button\" ng-click=\"$ctrl.redirectTo(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'BULK_DEPOSIT_COUNT_NOT_COMPLETED'\">\n{{'branch_mgmt.cash_count' | translate}}\n<button type=\"button\" ng-click=\"$ctrl.cancelShipmentTransfer(row)\" class=\"btn btn-sm btn-success\" ng-if=\"row.message === 'PENDING_SHIPMENT_TRANSFER'\" ng-disabled=\"$ctrl.isCancelTransferLoading\">\nCancel Transfer\n</button>\n</button></td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"col-sm-0\"></div>\n</div>\n</div>";
var id1="vault_close.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2893 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"Form\" novalidate class=\"form-validate\" autocomplete=\"off\">\n<div class=\"col-sm-12 remove-left-pad remove-right-pad\">\n<div class=\"col-sm-12 vault-operations-search-section remove-left-pad remove-right-pad margin-10\">\n<div class=\"vault-operation-date-picker-w-23\" ng-if=\"$ctrl.model.dateRangeOptions.startDate\">\n<input date-range-picker class=\"form-control date-picker\" type=\"text\" ng-model=\"$ctrl.model.dateRangeOptions\" ng-change=\"$ctrl.loadData();\" options=\"$ctrl.model.dateRangPickerOptionsfor\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57 && event.keyCode == 13\" ng-keydown=\"$event.preventDefault()\" ng-class=\"{'disabled': $ctrl.model.loadCountVariances}\"/>\n</div>\n<div class=\"col-sm-3 remove-right-pad\">\n<div class=\"multi-select vault-operation-branch-dd valid-multi-select-value\" isteven-multi-select max-labels=\"1\" input-model=\"$ctrl.model.branchObj.results\" output-model=\"$ctrl.model.selectedBranch\" button-label=\"branchId\" item-label=\"branchId\" search-property=\"branchId\" tick-property=\"ticked\" directive-id=\"multi-select-button\" on-item-click=\"$ctrl.loadData();\" on-select-all=\"$ctrl.loadData();\" on-select-none=\"$ctrl.loadData();\" on-reset=\"$ctrl.loadData();\" is-disabled=\"$ctrl.model.loadCountVariances\">\n</div>\n</div>\n<div class=\"col-sm-3 pull-right\">\n<select class=\"form-control\" required ng-model=\"$ctrl.model.timezone\" ng-options=\"timezone.value as timezone.label for timezone in $ctrl.model.timezoneList\" ng-change=\"$ctrl.loadData();\" ng-disabled=\"$ctrl.model.loadCountVariances\">\n<option value=\"\" disabled=\"disabled\">({{'common.none' | translate}})</option>\n</select>\n</div>\n</div>\n<div class=\"col-sm-12\"><hr class=\"vault-operations-line-section\"></div>\n</div>\n<div class=\"col-sm-12 margin-10\">\n<div class=\"remove-right-pad col-sm-12 margin-bottom-10\">\n<div class=\"row pull-left font-size-20\">\n<strong>{{'route.all_routes' | translate}}</strong>\n<span class=\"badge vault-operations-badge-section\" ng-if=\"!$ctrl.model.routesObj.gettingRoutes\">{{$ctrl.model.routesObj.totalRecords}}</span>\n</div>\n<div class=\"remove-right-pad col-sm-2 pull-right\" ng-if=\"!$ctrl.model.routesObj.gettingRoutes\">\n<input type=\"text\" strip-prefix class=\"form-control\" ng-model=\"$ctrl.model.routesObj.searchText\" name=\"routeSearchText\" id=\"routeSearchText\" on-press-enter=\"$ctrl.filterRouteList()\" placeholder=\"{{'common.search' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\"/>\n</div>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.model.routesObj.gettingRoutes\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row remove-padding table-responsive\">\n<table class=\"table-pad-5 table table-hover table-bordered table-padding-5 font-12\" ng-if=\"$ctrl.model.routesObj.results.length && !$ctrl.model.routesObj.gettingRoutes\">\n<thead>\n<tr>\n<td class=\"text-center\" ng-click=\"$ctrl.sortRouteData('routeId', $event)\">\n<b>{{'dashboard.routeId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.routesObj.reverseSort, 'active' : $ctrl.model.routesObj.sortColumn === 'routeId'}\"></span>\n</td>\n<td class=\"text-center _order-col-width\" ng-click=\"$ctrl.sortRouteData('routeDate', $event)\">\n<b>{{'routeControl.routeDate' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.routesObj.reverseSort, 'active' : $ctrl.model.routesObj.sortColumn === 'routeDate'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortRouteData('vehicleId', $event)\">\n<b>{{'vaultOperations.vehicle' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.routesObj.reverseSort, 'active' : $ctrl.model.routesObj.sortColumn === 'vehicleId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortRouteData('messengerId', $event)\">\n<b>{{'branch_mgmt.route_messenger' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.routesObj.reverseSort, 'active' : $ctrl.model.routesObj.sortColumn === 'messengerId'}\"></span>\n</td>\n<td class=\"text-center content-no-wrap\" ng-click=\"$ctrl.sortRouteData('checkoutTime', $event)\">\n<b>{{'routeControl.checkout_time' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.routesObj.reverseSort, 'active' : $ctrl.model.routesObj.sortColumn === 'checkoutTime'}\"></span>\n</td>\n<td class=\"text-center content-no-wrap\" ng-click=\"$ctrl.sortRouteData('leaveTime', $event)\">\n<b>{{'routeControl.leave_time' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.routesObj.reverseSort, 'active' : $ctrl.model.routesObj.sortColumn === 'leaveTime'}\"></span>\n</td>\n<td class=\"text-center content-no-wrap\" ng-click=\"$ctrl.sortRouteData('arrTime', $event)\">\n<b>{{'routeControl.arrive_time' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.routesObj.reverseSort, 'active' : $ctrl.model.routesObj.sortColumn === 'arrTime'}\"></span>\n</td>\n<td class=\"text-center content-no-wrap\" ng-click=\"$ctrl.sortRouteData('complTime', $event)\">\n<b>{{'vaultOperations.check_in_time' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.routesObj.reverseSort, 'active' : $ctrl.model.routesObj.sortColumn === 'complTime'}\"></span>\n</td>\n<td class=\"text-center content-no-wrap\" ng-click=\"$ctrl.sortRouteData('routeId', $event)\">\n<b>{{'vaultOperations.start_mileage' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.routesObj.reverseSort, 'active' : $ctrl.model.routesObj.sortColumn === 'tid'}\"></span>\n</td>\n<td class=\"text-center content-no-wrap\" ng-click=\"$ctrl.sortRouteData('begMiles', $event)\">\n<b>{{'routeControl.end_mileage' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.routesObj.reverseSort, 'active' : $ctrl.model.routesObj.sortColumn === 'begMiles'}\"></span>\n</td>\n<td>\n<b>{{'branch_mgmt.route_action' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"routeObj in $ctrl.model.routesObj.results\">\n<td><a href=\"#\" ng-click=\"$ctrl.goToRouteTab(routeObj)\">{{routeObj.routeId}}</a></td>\n<td>{{routeObj.routeDate | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td>\n<span ng-if=\"routeObj.vehicleId\"><a href=\"#\" ng-click=\"$ctrl.goToVehicleTab(routeObj.vehicleId)\">{{routeObj.vehicleId}}</a></span>\n<span ng-if=\"!routeObj.vehicleId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"routeObj.messengerId\"><a href=\"#\" ng-click=\"$ctrl.goToUserTab(routeObj.messengerId)\">{{routeObj.messengerId}}</a></span>\n<span ng-if=\"!routeObj.messengerId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"routeObj.checkoutTime\">{{routeObj.checkoutTime}}</span>\n<span ng-if=\"!routeObj.checkoutTime\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"routeObj.leaveTime\">{{routeObj.leaveTime}}</span>\n<span ng-if=\"!routeObj.leaveTime\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"routeObj.arrTime\">{{routeObj.arrTime}}</span>\n<span ng-if=\"!routeObj.arrTime\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"routeObj.complTime\">{{routeObj.complTime}}</span>\n<span ng-if=\"!routeObj.complTime\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"routeObj.begMiles\">{{routeObj.begMiles | currency:'':0}}</span>\n<span ng-if=\"!routeObj.begMiles\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"routeObj.endMiles\">{{routeObj.endMiles | currency:'':0}}</span>\n<span ng-if=\"!routeObj.endMiles\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"remove-white-space\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.editRouteDetails(routeObj)\" ng-disabled=\"!routeObj.checkoutTime\">\n<span class=\"glyphicon glyphicon-pencil\" uib-tooltip=\"{{'common.Edit' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.undoCheckInTime(routeObj)\" ng-if=\"routeObj.complTime && $ctrl.isPastVaultDate(routeObj.routeDate, routeObj.branchVaultDate)\">\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"{{'entry_type.undo-check-in-time' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-warning text-decoration-none\" ng-click=\"$ctrl.markAllDelivered(routeObj)\" ng-if=\"routeObj.pendingDeliveriesCount > 0\">\n<span class=\"glyphicon glyphicon-ok\" uib-tooltip=\"{{ 'vaultOperations.mark_all_delivered' | translate }}\" tooltip-placement=\"top-right\"></span>\n</button>\n<button type=\"button\" class=\"btn btn-xs btn-primary text-decoration-none\" ng-if=\"routeObj.pendingDeliveriesCount > 0\" ng-click=\"$ctrl.rescheduleDeliveries(routeObj)\">\n<b uib-tooltip=\"{{'vaultOperations.reschedule_deliveries' | translate}}\" tooltip-placement=\"top-right\">R</b>\n</button>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"row _col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.routesObj.pagination.total > 10 && !$ctrl.model.routesObj.gettingRoutes\">\n<ul uib-pagination total-items=\"$ctrl.model.routesObj.pagination.total\" ng-hide=\"{{($ctrl.model.routesObj.pagination.total<=$ctrl.model.routesObj.pagination.pageLimit)&&($ctrl.model.routesObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.routesObj.pagination.page\" ng-change=\"$ctrl.pageChange('routes')\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n<div ng-if=\"!$ctrl.model.routesObj.results.length && !$ctrl.model.routesObj.gettingRoutes\">\n<div class=\"row alert text-center alert-danger\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"col-sm-12\">\n<div class=\"remove-right-pad col-sm-12 margin-bottom-10\">\n<div class=\"row pull-left font-size-20\">\n<strong>{{'vaultOperations.deliveries_loads' | translate}}</strong>\n<span class=\"badge vault-operations-badge-section\" ng-if=\"!$ctrl.model.loadShipmentObj.gettingLoadShipment\">{{$ctrl.model.loadShipmentObj.totalRecords}}</span>\n</div>\n<div class=\"remove-right-pad col-sm-2 pull-right\" ng-if=\"!$ctrl.model.loadShipmentObj.gettingLoadShipment\">\n<input type=\"text\" strip-prefix class=\"form-control\" ng-model=\"$ctrl.model.loadShipmentObj.searchText\" name=\"loadShipmentSearchText\" id=\"loadShipmentSearchText\" on-press-enter=\"$ctrl.filterDeliveries()\" placeholder=\"{{'common.search' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\"/>\n</div>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.model.loadShipmentObj.gettingLoadShipment\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row remove-padding table-responsive\">\n<table class=\"table-pad-3 table table-hover table-bordered table-padding-5 font-12\" ng-if=\"$ctrl.model.loadShipmentObj.results.length && !$ctrl.model.loadShipmentObj.gettingLoadShipment\">\n<thead>\n<tr>\n<td class=\"text-center vault-date-col-width\" ng-click=\"$ctrl.sortDeliveryShipmentData('vaultDate', $event)\">\n<b>{{'branch_mgmt.item_holds.vaultDate' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.loadShipmentObj.reverseSort, 'active' : $ctrl.model.loadShipmentObj.sortColumn === 'vaultDate'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortDeliveryShipmentData('trackingId', $event)\">\n<b>{{'branch_mgmt.tracking_Id' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.loadShipmentObj.reverseSort, 'active' : $ctrl.model.loadShipmentObj.sortColumn === 'trackingId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortDeliveryShipmentData('branchId', $event)\">\n<b>{{'users.branchId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.loadShipmentObj.reverseSort, 'active' : $ctrl.model.loadShipmentObj.sortColumn === 'branchId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortDeliveryShipmentData('routeId', $event)\">\n<b>{{'dashboard.routeId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.loadShipmentObj.reverseSort, 'active' : $ctrl.model.loadShipmentObj.sortColumn === 'routeId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortDeliveryShipmentData('toLocationId', $event)\">\n<b>{{'bagout.toLocation' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.loadShipmentObj.reverseSort, 'active' : $ctrl.model.loadShipmentObj.sortColumn === 'toLocationId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortDeliveryShipmentData('orderType', $event)\">\n<b>{{'checkout.transactionType' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.loadShipmentObj.reverseSort, 'active' : $ctrl.model.loadShipmentObj.sortColumn === 'orderType'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortDeliveryShipmentData('status', $event)\">\n<b>{{'common.status' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.loadShipmentObj.reverseSort, 'active' : $ctrl.model.loadShipmentObj.sortColumn === 'status'}\"></span>\n</td>\n<td class=\"text-center col-w-13\" ng-click=\"$ctrl.sortDeliveryShipmentData('formattedDeliveryDate', $event)\">\n<b>{{'checkout.deliveryDate' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.loadShipmentObj.reverseSort, 'active' : $ctrl.model.loadShipmentObj.sortColumn === 'formattedDeliveryDate'}\"></span>\n</td>\n<td class=\"text-center col-w-09\" ng-click=\"$ctrl.sortDeliveryShipmentData('amount', $event)\">\n<b>{{'branch_mgmt.final_residual_count_commit.amount_requested' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.loadShipmentObj.reverseSort, 'active' : $ctrl.model.loadShipmentObj.sortColumn === 'amount'}\"></span>\n</td>\n<td class=\"text-center col-w-09\" ng-click=\"$ctrl.sortDeliveryShipmentData('loadedAmount', $event)\">\n<b>{{'branch_mgmt.mark_as_delivered.delivered_amount' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.loadShipmentObj.reverseSort, 'active' : $ctrl.model.loadShipmentObj.sortColumn === 'loadedAmount'}\"></span>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.route_action' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"loadShipments in $ctrl.model.loadShipmentObj.results\">\n<td>{{loadShipments.vaultDate | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td><a href=\"#\" ng-click=\"$ctrl.goToItemHistory(loadShipments)\">{{loadShipments.trackingId}}</a></td>\n<td>{{loadShipments.branchId}}</td>\n<td><a href=\"#\" ng-click=\"$ctrl.goToRouteTab(loadShipments)\">{{loadShipments.routeId}}</a></td>\n<td>\n<a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(loadShipments.toLocationId)\">{{loadShipments.toLocationId}}</a>\n</td>\n<td>\n<span class=\"text-danger\" ng-if=\"loadShipments.orderType\">{{loadShipments.orderType}}</span>\n<span ng-if=\"!loadShipments.orderType\">{{'common.n_a' | translate}}</span>\n</td>\n<td class=\"text-danger\">\n<span ng-if=\"loadShipments.status\">{{$ctrl.translateStatus(loadShipments.status)}}</span>\n<span ng-if=\"!loadShipments.status\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"loadShipments.formattedDeliveryDate\">{{loadShipments.formattedDeliveryDate}}</span>\n<span ng-if=\"!loadShipments.formattedDeliveryDate\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{loadShipments.amountFlag ? (loadShipments.amount | currency:\"$\") : (loadShipments.qty != null ? loadShipments.qty : 'N/A')}}</td>\n<td>\n<span ng-if=\"loadShipments.loadedAmount !== null\">{{loadShipments.loadedAmount | currency:\"$\"}}</span>\n<span ng-if=\"loadShipments.loadedAmount == null\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<div class=\"remove-white-space remove-pad col-sm-12\" ng-if=\"!$ctrl.isShipmentCounted(loadShipments)\">\n<span class=\"margin-top-02\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.editLoadShipmentModal(loadShipments)\" ng-disabled=\"loadShipments.status !== 'shipment.hold' && \n                                        (\n                                          (!loadShipments.pickupFlag && !loadShipments.checkedOut && !loadShipments.packedFlag && !loadShipments.deleted && !loadShipments.holdFlag && !loadShipments.deliveredFlag) \n                                          || (loadShipments.deleted) || (loadShipments.checkedOut && loadShipments.coinFlag)\n                                        )\">\n<span class=\"glyphicon glyphicon-pencil\" uib-tooltip=\"{{'common.Edit' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!loadShipments.deleted && !loadShipments.deliveredFlag && loadShipments.packedFlag && loadShipments.checkedOut && !loadShipments.checkedIn\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.markAsDelivered(loadShipments)\">\n<span class=\"glyphicon glyphicon-ok\" uib-tooltip=\"{{'itemHolds.mark_as_delivered' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!loadShipments.deleted && loadShipments.checkedOut && loadShipments.deliveredFlag && loadShipments.deliveryDate && !loadShipments.checkedIn\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.markUndeliveredWithCRV(loadShipments)\" ng-disabled=\"$ctrl.restrictShipmentUpdate(loadShipments.vaultDate, loadShipments.branchCurrentVaultDate) && !loadShipments.undeliveredAnytimeFlag\">\n<span class=\"glyphicon glyphicon-share\" uib-tooltip=\"{{'vaultOperations.bagout.mark_undeliver' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!loadShipments.holdFlag && !loadShipments.deleted && !loadShipments.deliveredFlag && !loadShipments.checkedIn\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.sendToHold(loadShipments)\">\n<span class=\"glyphicon glyphicon-circle-arrow-left\" uib-tooltip=\"{{'branch_mgmt.itemHistory.sendToHold' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!loadShipments.checkedOut && !loadShipments.deleted && loadShipments.packedFlag && !loadShipments.holdFlag && !$ctrl.isManualCheckoutBlocked(loadShipments)\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.shipmentCheckOut(loadShipments)\">\n<span class=\"glyphicon glyphicon-backward\" uib-tooltip=\"{{'navbar.checkout_title' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!loadShipments.deleted && loadShipments.holdFlag\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.releaseItem(loadShipments, 'Deliveries')\">\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"{{'branch_mgmt.item_release_holds.title' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!loadShipments.deleted && loadShipments.holdFlag && loadShipments.toLocation.locationType === 'ATM' && !loadShipments.packableOrderShipmentId && !loadShipments.deliveredFlag && (!loadShipments.coinFlag || (loadShipments.coinFlag && loadShipments.coinDebited))\">\n<button type=\"button\" ng-click=\"$ctrl.convertToCrv(loadShipments)\" class=\"btn btn-xs btn-warning\" uib-tooltip=\"{{'itemHolds.converttocrv' | translate}}\" ng-disabled=\"$ctrl.isLoading\" tooltip-placement=\"top-right\">\n<span class=\"glyphicon glyphicon-copyright-mark\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!loadShipments.deleted && loadShipments.orderNo && loadShipments.holdFlag && loadShipments.packedFlag && loadShipments.packableOrderShipmentId && loadShipments.checkedOut && !loadShipments.deliveredFlag && (!loadShipments.coinFlag || (loadShipments.coinFlag && loadShipments.coinDebited))\">\n<button type=\"button\" ng-click=\"$ctrl.convertToCrvPackableOrder(loadShipments)\" class=\"btn btn-xs btn-warning\" uib-tooltip=\"{{'itemHolds.converttocrv' | translate}}\" ng-disabled=\"$ctrl.isLoading\" tooltip-placement=\"top-right\">\n<span class=\"glyphicon glyphicon-copyright-mark\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!loadShipments.deleted && loadShipments.holdFlag && $ctrl.isPastVaultDate(loadShipments.vaultDate, loadShipments.branchCurrentVaultDate)\">\n<button type=\"button\" ng-click=\"$ctrl.removeHoldShipment(loadShipments, 'Deliveries')\" class=\"btn btn-xs btn-danger\" uib-tooltip=\"{{'vaultOperations.remove_from_hold' | translate}}\" ng-disabled=\"$ctrl.isRemovingFromHold\" tooltip-placement=\"top-right\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"loadShipments.checkedOut && !loadShipments.deleted && !loadShipments.deliveredFlag && !loadShipments.checkedIn && loadShipments.individuallyDeliverable === 1 && !loadShipments.cancelled && !loadShipments.pickupFlag\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.shipmentCheckInDelivery(loadShipments)\">\n<span class=\"glyphicon glyphicon-forward\" uib-tooltip=\"{{'checkin.title' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!loadShipments.deleted && !loadShipments.deliveredFlag && !loadShipments.cancelled \n                                           && loadShipments.individuallyDeliverable === 1 && !loadShipments.pickupFlag \n                                           && loadShipments.fromLocationBagoutEnabled === 1 && !$ctrl.isShipmentCounted(loadShipments)\">\n<button type=\"button\" class=\"btn btn-xs btn-warning text-decoration-none\" ng-click=\"$ctrl.convertToBagoutablePickup(loadShipments)\" ng-disabled=\"$ctrl.isConvertingToBagout\" uib-tooltip=\"Send to Bagout\" tooltip-placement=\"top-right\">\n<span class=\"glyphicon glyphicon-repeat\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!loadShipments.deleted && !loadShipments.deliveredFlag && !loadShipments.cancelled \n                                           && loadShipments.individuallyDeliverable === 1 && !loadShipments.pickupFlag\">\n<button type=\"button\" class=\"btn btn-xs btn-primary text-decoration-none\" ng-click=\"$ctrl.convertToPickup(loadShipments)\" ng-disabled=\"$ctrl.isConvertingToPickup\" uib-tooltip=\"Convert to Pickup\" tooltip-placement=\"top-right\">\n<span class=\"glyphicon glyphicon-transfer\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-hide=\"loadShipments.coinFlag || loadShipments.orderNo || !$ctrl.hasSoftDeleteShipmentPermission\">\n<button type=\"button\" class=\"btn btn-xs btn-danger btn-mob-small mr-1\" ng-disabled=\"$ctrl.isSoftDeleting || loadShipments.deleted\" style=\"margin-right: 0px;\" ng-click=\"$ctrl.softDeleteShipment(loadShipments, 'Deliveries')\" tooltip-placement=\"top-right\" uib-tooltip=\"{{'common.soft_delete' | translate}}\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"$ctrl.hasSoftDeleteShipmentPermission && loadShipments.coinFlag\">\n<button type=\"button\" class=\"btn btn-xs btn-danger btn-mob-small\" style=\"margin-right: 0px;\" ng-disabled=\"$ctrl.isSoftDeleting || loadShipments.deleted || (loadShipments.coinDebited)\" ng-if=\"( !loadShipments.coinDebited && loadShipments.checkedOut ) || ( !loadShipments.coinDebited && loadShipments.checkedIn )\" ng-click=\"$ctrl.softDeleteShipment(loadShipments, 'Deliveries')\" tooltip-placement=\"top-right\" uib-tooltip=\"{{'common.soft_delete' | translate}}\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"(loadShipments.checkedIn || loadShipments.pending || loadShipments.holdFlag) && !loadShipments.orderNo\">\n<button type=\"button\" class=\"btn btn-xs btn-primary text-decoration-none\" ng-click=\"$ctrl.branchTransfer(loadShipments, 'Deliveries')\" uib-tooltip=\"{{'branch_mgmt.itemHistory.branch_transfer' | translate}}\" tooltip-placement=\"top-right\">\n<b>T</b>\n</button>\n</span>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"row _col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.loadShipmentObj.pagination.total > 10 && !$ctrl.model.loadShipmentObj.gettingLoadShipment\">\n<ul uib-pagination total-items=\"$ctrl.model.loadShipmentObj.pagination.total\" ng-hide=\"{{($ctrl.model.loadShipmentObj.pagination.total<=$ctrl.model.loadShipmentObj.pagination.pageLimit)&&($ctrl.model.loadShipmentObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.loadShipmentObj.pagination.page\" ng-change=\"$ctrl.pageChange('loadShipments')\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n<div ng-if=\"!$ctrl.model.loadShipmentObj.results.length && !$ctrl.model.loadShipmentObj.gettingLoadShipment\">\n<div class=\"row alert text-center alert-danger\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n<div class=\"margin-bottom-40 col-sm-12\">\n<div class=\"remove-right-pad col-sm-12 margin-bottom-10\">\n<div class=\"row pull-left font-size-20\">\n<strong>{{'vaultOperations.pickups_residuals' | translate}}</strong>\n<span class=\"badge vault-operations-badge-section\" ng-if=\"!$ctrl.model.residualShipmentObj.gettingResidualShipment\">{{$ctrl.model.residualShipmentObj.totalRecords}}</span>\n</div>\n<div class=\"remove-right-pad col-sm-2 pull-right\" ng-if=\"!$ctrl.model.residualShipmentObj.gettingResidualShipment\">\n<input type=\"text\" strip-prefix class=\"form-control\" ng-model=\"$ctrl.model.residualShipmentObj.searchText\" name=\"residualShipmentSearchText\" id=\"residualShipmentSearchText\" on-press-enter=\"$ctrl.filterPickupShipment()\" placeholder=\"{{'common.search' | translate}}\" ng-pattern=\"/^[a-zA-Z0-9-_ ]*$/\"/>\n</div>\n</div>\n<div class=\"text-align-center margin-top-20\" ng-if=\"$ctrl.model.residualShipmentObj.gettingResidualShipment\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"row remove-padding table-responsive\">\n<table class=\"table-pad-3 table table-hover table-bordered table-padding-5 font-12\" ng-if=\"$ctrl.model.residualShipmentObj.results.length && !$ctrl.model.residualShipmentObj.gettingResidualShipment\">\n<thead>\n<tr>\n<td class=\"text-center\" ng-click=\"$ctrl.sortPickupShipmentData('vaultDate', $event)\">\n<b>{{'branch_mgmt.item_holds.vaultDate' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.residualShipmentObj.reverseSort, 'active' : $ctrl.model.residualShipmentObj.sortColumn === 'vaultDate'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortPickupShipmentData('trackingId', $event)\">\n<b>{{'branch_mgmt.tracking_Id' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.residualShipmentObj.reverseSort, 'active' : $ctrl.model.residualShipmentObj.sortColumn === 'trackingId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortPickupShipmentData('branchId', $event)\">\n<b>{{'users.branchId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.residualShipmentObj.reverseSort, 'active' : $ctrl.model.residualShipmentObj.sortColumn === 'branchId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortPickupShipmentData('routeId', $event)\">\n<b>{{'dashboard.routeId' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.residualShipmentObj.reverseSort, 'active' : $ctrl.model.residualShipmentObj.sortColumn === 'routeId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortPickupShipmentData('fromLocationId', $event)\">\n<b>{{'bagout.fromLocation' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.residualShipmentObj.reverseSort, 'active' : $ctrl.model.residualShipmentObj.sortColumn === 'fromLocationId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortPickupShipmentData('shiptypeId', $event)\">\n<b>{{'bagout.type' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.residualShipmentObj.reverseSort, 'active' : $ctrl.model.residualShipmentObj.sortColumn === 'shiptypeId'}\"></span>\n</td>\n<td class=\"text-center\" ng-click=\"$ctrl.sortPickupShipmentData('status', $event)\">\n<b>{{'common.status' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.residualShipmentObj.reverseSort, 'active' : $ctrl.model.residualShipmentObj.sortColumn === 'status'}\"></span>\n</td>\n<td class=\"text-center col-w-13\" ng-click=\"$ctrl.sortPickupShipmentData('formattedPickupDate', $event)\">\n<b>{{'shipmentBatch.pickupDate' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.residualShipmentObj.reverseSort, 'active' : $ctrl.model.residualShipmentObj.sortColumn === 'formattedPickupDate'}\"></span>\n</td>\n<td class=\"text-center col-w-09\" ng-click=\"$ctrl.sortPickupShipmentData('amount', $event)\">\n<b>{{'branch_mgmt.amount' | translate}}</b>\n<span class=\"sortorder\" ng-class=\"{'reverse': !$ctrl.model.residualShipmentObj.reverseSort, 'active' : $ctrl.model.residualShipmentObj.sortColumn === 'amount'}\"></span>\n</td>\n<td class=\"text-center\">\n<b>{{'branch_mgmt.route_action' | translate}}</b>\n</td>\n</tr>\n</thead>\n<tbody class=\"text-center\">\n<tr ng-repeat=\"pickupShipments in $ctrl.model.residualShipmentObj.results\">\n<td>{{pickupShipments.vaultDate | date:'yyyy-MM-dd': 'UTC'}}</td>\n<td class=\"d-flex align-center\">\n<a href=\"#\" ng-click=\"$ctrl.goToItemHistory(pickupShipments)\">{{pickupShipments.trackingId}}</a>\n<span ng-if=\"pickupShipments.individuallyDeliverable\" class=\"immidiate-delivery-icon margin-left-05 cursor-pointer\" uib-tooltip=\"{{'location.immediately_deliverable' | translate}}\"> ID\n</span>\n</td>\n<td>{{pickupShipments.branchId}}</td>\n<td><a href=\"#\" ng-click=\"$ctrl.goToRouteTab(pickupShipments)\">{{pickupShipments.routeId}}</a></td>\n<td><a href=\"#\" ng-click=\"$ctrl.goToServiceHistory(pickupShipments.fromLocationId)\">{{pickupShipments.fromLocationId}}</a>\n</td>\n<td>\n<span class=\"text-danger\" ng-if=\"pickupShipments.shiptypeId\">{{pickupShipments.description}}</span>\n<span ng-if=\"!pickupShipments.shiptypeId\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span class=\"text-danger\" ng-if=\"pickupShipments.status\">{{$ctrl.translateStatus(pickupShipments.status)}}</span>\n<span ng-if=\"!pickupShipments.status\">{{'common.n_a' | translate}}</span>\n</td>\n<td>\n<span ng-if=\"pickupShipments.formattedPickupDate\">{{pickupShipments.formattedPickupDate}}</span>\n<span ng-if=\"!pickupShipments.formattedPickupDate\">{{'common.n_a' | translate}}</span>\n</td>\n<td>{{ pickupShipments.amountFlag ? (pickupShipments.amount | currency:\"$\") : (pickupShipments.qty != null ? pickupShipments.qty : 'N/A') }}</td>\n<td>\n<div class=\"remove-white-space remove-pad col-sm-12\" ng-if=\"!$ctrl.isShipmentCounted(pickupShipments)\">\n<span class=\"margin-top-02\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.editPickupShipmentModal(pickupShipments)\" ng-disabled=\"pickupShipments.status === 'shipment.counted' || pickupShipments.status === 'shipment.bagout' || pickupShipments.deleted ||\n                                                     pickupShipments.status === 'shipment.deposited'\">\n<span class=\"glyphicon glyphicon-pencil\" uib-tooltip=\"{{'common.Edit' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!pickupShipments.packedFlag && !pickupShipments.checkedIn && !pickupShipments.deliveryDate && pickupShipments.holdFlag\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.markAsCheckedIn(pickupShipments)\">\n<span class=\"glyphicon glyphicon-ok\" uib-tooltip=\"{{'vaultOperations.mark_checked_in' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!pickupShipments.holdFlag && !pickupShipments.deleted && $ctrl.isParentResidualPickup(pickupShipments) && pickupShipments.status !== 'shipment.onRoute'\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.sendToHold(pickupShipments)\">\n<span class=\"glyphicon glyphicon-circle-arrow-left\" uib-tooltip=\"{{'branch_mgmt.itemHistory.sendToHold' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!pickupShipments.checkedIn && !pickupShipments.deleted && !pickupShipments.holdFlag && pickupShipments.status !== 'shipment.delivered'\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.shipmentCheckIn(pickupShipments)\">\n<span class=\"glyphicon glyphicon-forward\" uib-tooltip=\"{{'checkin.title' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!pickupShipments.deleted && !pickupShipments.deliveredFlag && !pickupShipments.orderNo && pickupShipments.checkedOut \n                                        && !pickupShipments.checkedIn && pickupShipments.individuallyDeliverable && pickupShipments.pickupFlag\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.markAsDelivered(pickupShipments, 'Pickups')\">\n<span class=\"glyphicon glyphicon-ok\" uib-tooltip=\"{{'itemHolds.mark_as_delivered' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!pickupShipments.deleted && pickupShipments.holdFlag && $ctrl.canReleaseForCount(pickupShipments)\">\n<button type=\"button\" class=\"btn btn-xs btn-info text-decoration-none\" ng-click=\"$ctrl.releaseForCount(pickupShipments)\">\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"Release for Count\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!pickupShipments.deleted && pickupShipments.holdFlag\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.releaseItem(pickupShipments, 'Pickups')\">\n<span class=\"glyphicon glyphicon-repeat\" uib-tooltip=\"{{'branch_mgmt.item_release_holds.title' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"!pickupShipments.deleted && pickupShipments.holdFlag\">\n<button type=\"button\" ng-click=\"$ctrl.removeHoldShipment(pickupShipments, 'Pickups')\" class=\"btn btn-xs btn-danger\" uib-tooltip=\"{{'vaultOperations.remove_from_hold' | translate}}\" ng-disabled=\"$ctrl.isRemovingFromHold\" tooltip-placement=\"top-right\">\n<span class=\"glyphicon glyphicon-remove\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-hide=\"pickupShipments.orderNo || !$ctrl.hasSoftDeleteShipmentPermission || pickupShipments.isRequiredPickup || pickupShipments.status === 'shipment.delivered'\">\n<button type=\"button\" class=\"btn btn-xs btn-danger btn-mob-small mr-1\" ng-disabled=\"$ctrl.isSoftDeleting || pickupShipments.deleted\" ng-click=\"$ctrl.softDeleteShipment(pickupShipments, 'Pickups')\" tooltip-placement=\"top-right\" uib-tooltip=\"{{'common.soft_delete' | translate}}\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"pickupShipments.isRequiredPickup && $ctrl.hasSoftDeleteShipmentPermission\">\n<button type=\"button\" class=\"btn btn-xs btn-danger btn-mob-small _mr-1\" ng-disabled=\"$ctrl.isSoftDeleting || pickupShipments.deleted\" ng-click=\"$ctrl.softDeleteShipment(pickupShipments, 'Pickups')\" tooltip-placement=\"top-right\" uib-tooltip=\"{{'common.soft_delete' | translate}}\">\n<span class=\"glyphicon glyphicon-trash\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"pickupShipments.checkedIn && !pickupShipments.packedFlag && !pickupShipments.deleted && !pickupShipments.countStartedAt\">\n<button type=\"button\" class=\"btn btn-xs btn-success text-decoration-none\" ng-click=\"$ctrl.makeDeliverablePickup(pickupShipments)\">\n<span class=\"glyphicon glyphicon-share-alt\" uib-tooltip=\"{{'branch_mgmt.make_deliverable' | translate}}\" tooltip-placement=\"top-right\"></span>\n</button>\n</span>\n<span class=\"margin-top-02\" ng-if=\"pickupShipments.individuallyDeliverable && !pickupShipments.deleted && pickupShipments.status !== 'shipment.delivered'\">\n<button type=\"button\" class=\"btn btn-xs btn-primary text-decoration-none\" ng-click=\"$ctrl.transferPickupToRoute(pickupShipments)\">\n<b uib-tooltip=\"{{'common.transfer' | translate}}\" tooltip-placement=\"top-right\">T</b>\n</button>\n</span>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<div class=\"row _col-sm-12 margin-bottom-10\" ng-if=\"$ctrl.model.residualShipmentObj.pagination.total > 10 && !$ctrl.model.residualShipmentObj.gettingResidualShipment\">\n<ul uib-pagination total-items=\"$ctrl.model.residualShipmentObj.pagination.total\" ng-hide=\"{{($ctrl.model.residualShipmentObj.pagination.total<=$ctrl.model.residualShipmentObj.pagination.pageLimit)&&($ctrl.model.residualShipmentObj.pagination.page==1)}}\" next-text=\"{{'common.next'| translate}}\" previous-text=\"{{'common.previous'| translate}}\" ng-model=\"$ctrl.model.residualShipmentObj.pagination.page\" ng-change=\"$ctrl.pageChange('pickupShipments')\" rotate=\"false\" max-size=\"10\">\n</ul>\n</div>\n<div ng-if=\"!$ctrl.model.residualShipmentObj.results.length && !$ctrl.model.residualShipmentObj.gettingResidualShipment\">\n<div class=\"row alert text-center alert-danger\">\n{{'common.no_data_found' | translate}}\n</div>\n</div>\n</div>\n</form>\n";
var id1="vault_operations.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2894 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row\">\n<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"margin: auto;vertical-align: middle;top: 10rem;\">\n<div class=\"login-form\">\n<div class=\"comapany_logo\">\n<center>\n<img stream-company-logo load-from-db=\"true\" class=\"img-responsive\">\n</center>\n</div>\n<div class=\"login_form\">\n<form class=\"form well account-login-form\" name=\"form\" ng-submit=\"login(form)\" novalidate>\n<div class=\"row\">\n<div class=\"col-sm-12 form-group\">\n<label translate=\"login.reset_code_placeholder\"></label>\n<input type=\"text\" autocomplete=\"off\" name=\"code\" class=\"form-control\" id=\"code2FA\" placeholder=\"{{ 'login.reset_code_placeholder' | translate }}\" ng-model=\"$ctrl.model.code\" ng-disabled=\"$ctrl.model.loading\" required>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.model.successMessage\">\n<div class=\"col-sm-12\">\n<p class=\"success-message-section\">{{$ctrl.model.successMessage}}</p>\n</div>\n</div>\n<div class=\"row\" ng-if=\"$ctrl.model.errorMessage\">\n<div class=\"col-sm-12\">\n<p class=\"error-message-section\">{{$ctrl.model.errorMessage}}</p>\n</div>\n</div>\n<div class=\"col-sm-12 align-center cursor-pointer\">\n<a ng-click=\"$ctrl.send2FACode()\" ng-disabled=\"$ctrl.model.loading\" translate=\"login.resend_code\"></a>\n</div>\n<div class=\"col-sm-12 align-items-center\">\n<a ui-sref=\"login\">\n<i class=\"glyphicon glyphicon-chevron-left\"></i>\n<span>{{'login' | translate}}</span>\n</a>\n<span class=\"pull-right\">\n<button class=\"btn btn-primary btn-lg\" ng-disabled=\"!$ctrl.model.code || $ctrl.model.loading\" ng-click=\"$ctrl.verify2FACode()\" type=\"submit\">\n<span>{{'bagout.verify' | translate}}</span>\n</button>\n</span>\n</div>\n</div>\n</form>\n</div>\n</div>\n</div>\n</div>";
var id1="verify_2FA_code.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2895 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<connection-status></connection-status>\n<app-header></app-header>\n<div ui-view></div>\n<app-footer></app-footer>\n";
var id1="app-view.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2896 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n</div>\n";
var id1="footer.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2897 */
/***/ (function(module, exports) {

var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<navbar></navbar>\n";
var id1="header.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;

/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n(__webpack_require__(12)):"function"==typeof define&&define.amd?define("ng-currency",["angular"],n):"object"==typeof exports?exports["ng-currency"]=n(require("angular")):e["ng-currency"]=n(e.angular)}(this,function(e){return function(e){function n(t){if(r[t])return r[t].exports;var u=r[t]={i:t,l:!1,exports:{}};return e[t].call(u.exports,u,u.exports,n),u.l=!0,u.exports}var r={};return n.m=e,n.c=r,n.i=function(e){return e},n.d=function(e,r,t){n.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:t})},n.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(r,"a",r),r},n.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},n.p="",n(n.s=3)}([function(e,n,r){"use strict";function t(e,n){if(!(e instanceof n))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(n,"__esModule",{value:!0});var u=function(){function e(e,n){for(var r=0;r<n.length;r++){var t=n[r];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}return function(n,r,t){return r&&e(n.prototype,r),t&&e(n,t),n}}(),o=function(){function e(){t(this,e),this._defaults={fraction:2,hardCap:!1,min:void 0,max:void 0,currencySymbol:void 0}}return u(e,[{key:"$get",value:function(){var e=this;return{get defaults(){return e.defaults}}}},{key:"defaults",get:function(){return this._defaults},set:function(e){this._defaults=e}}]),e}();n.default=o},function(e,n,r){"use strict";function t(e,n,r,t){return{require:"ngModel",link:function(u,o,i,a){function c(){if(M){var e=void 0,n=void 0,r=void 0;if(a.$options&&(a.$options.getOption?(n=a.$options.getOption("updateOn"),r=a.$options.getOption("debounce")):(n=a.$options.updateOn,r=a.$options.debounce)),"blur"===n||r){e=a.$viewValue;for(var t=a.$parsers.length-1;t>=0;t--)e=a.$parsers[t](e)}else e=a.$$rawModelValue;for(var u=a.$formatters.length-1;u>=0;u--)e=a.$formatters[u](e);a.$viewValue=e,a.$render()}}function f(){if(a.$validate(),M){var e=l(a.$$rawModelValue);e!==a.$$rawModelValue&&(a.$setViewValue(e.toFixed(x)),a.$commitViewValue(),c())}}function l(e){return g&&(void 0!==y&&e>y?e=y:void 0!==b&&e<b&&(e=b)),e}function d(e){return RegExp("\\d|\\-|\\"+e,"g")}function s(e){return RegExp("\\-{0,1}((\\"+e+")|([0-9]{1,}\\"+e+"?))&?[0-9]{0,"+x+"}","g")}function v(r){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];r=String(r);var u=n.NUMBER_FORMATS.DECIMAL_SEP,o=null;-1===r.indexOf(n.NUMBER_FORMATS.DECIMAL_SEP)&&-1!==r.indexOf(".")&&x>0&&(u=".");var i=e("currency")("-1",p(),x),a=RegExp("[0-9."+n.NUMBER_FORMATS.DECIMAL_SEP+n.NUMBER_FORMATS.GROUP_SEP+"]+");return i.replace(a.exec(i),"")===r.replace(a.exec(r),"")&&(r="-"+a.exec(r)),RegExp("^-[\\s]*$","g").test(r)&&(r="-0"),d(u).test(r)&&(o=r.match(d(u)).join("").match(s(u))||[""],o=o[0],o=t?o.replace(u,"."):o),o||null}function p(){return void 0===m?n.NUMBER_FORMATS.CURRENCY_SYM:m}var $=t.defaults,g=$.hardCap,b=$.min,y=$.max,m=$.currencySymbol,x=$.fraction,O=i.required,M=!0;i.$observe("ngCurrency",function(e){M="false"!==e,M?c():(a.$viewValue=a.$$rawModelValue,a.$render())}),i.$observe("hardCap",function(e){g="true"===e,f()}),i.$observe("min",function(e){b=e?Number(e):void 0,f()}),i.$observe("max",function(e){y=e?Number(e):void 0,f()}),i.$observe("currencySymbol",function(e){m=e,c()}),i.$observe("required",function(e){O=e,f()}),i.$observe("fraction",function(e){x=e||2,c(),f()}),r(function(){u.$emit("currencyRedraw")}),a.$parsers.push(function(e){return M&&-1===[void 0,null,""].indexOf(e)?(e=v(e),e=l(Number(e))):e}),a.$formatters.push(function(n){return M&&-1===[void 0,null,""].indexOf(n)?e("currency")(n,p(),x):n}),a.$validators.min=function(e){return!(O||-1===[void 0,null,""].indexOf(e)&&!isNaN(e))||(!M||-1!==[void 0,null].indexOf(b)||isNaN(b)||e>=b)},a.$validators.max=function(e){return!(O||-1===[void 0,null,""].indexOf(e)&&!isNaN(e))||(!M||-1!==[void 0,null].indexOf(y)||isNaN(y)||e<=y)},a.$validators.fraction=function(e){return!M||!e||!isNaN(e)},u.$on("currencyRedraw",function(){f(),c()}),o.bind("focus",function(){if(M){var e=v(a.$viewValue,!1);a.$viewValue!==e&&(a.$viewValue=e,a.$render(),o.triggerHandler("focus"))}}),o.bind("blur",c)}}}Object.defineProperty(n,"__esModule",{value:!0}),n.default=t,t.$inject=["$filter","$locale","$timeout","ngCurrencySettings"]},function(n,r){n.exports=e},function(e,n,r){"use strict";function t(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(n,"__esModule",{value:!0});var u=r(2),o=t(u),i=r(0),a=t(i),c=r(1),f=t(c),l=o.default.module("ng-currency",[]);l.provider("ngCurrencySettings",a.default),l.directive("ngCurrency",f.default),n.default=l.name}])});
//# sourceMappingURL=ng-currency.js.map

/***/ }),
/* 2899 */
/***/ (function(module, exports) {

/*** Directives and services for responding to idle users in AngularJS
* @author Mike Grabski <me@mikegrabski.com>
* @version v1.3.2
* @link https://github.com/HackedByChinese/ng-idle.git
* @license MIT
*/
(function(window, angular, undefined) {
'use strict';
angular.module('ngIdle', ['ngIdle.keepalive', 'ngIdle.idle', 'ngIdle.countdown', 'ngIdle.title', 'ngIdle.localStorage']);
angular.module('ngIdle.keepalive', [])
  .provider('Keepalive', function() {
    var options = {
      http: null,
      interval: 10 * 60
    };

    this.http = function(value) {
      if (!value) throw new Error('Argument must be a string containing a URL, or an object containing the HTTP request configuration.');
      if (angular.isString(value)) {
        value = {
          url: value,
          method: 'GET'
        };
      }

      value.cache = false;

      options.http = value;
    };

    var setInterval = this.interval = function(seconds) {
      seconds = parseInt(seconds);

      if (isNaN(seconds) || seconds <= 0) throw new Error('Interval must be expressed in seconds and be greater than 0.');
      options.interval = seconds;
    };

    this.$get = ['$rootScope', '$log', '$interval', '$http',
      function($rootScope, $log, $interval, $http) {

        var state = {
          ping: null
        };

        function handleResponse(response) {
          $rootScope.$broadcast('KeepaliveResponse', response.data, response.status);
        }

        function ping() {
          $rootScope.$broadcast('Keepalive');

          if (angular.isObject(options.http)) {
            $http(options.http)
              .then(handleResponse)
              .catch(handleResponse);
          }
        }

        return {
          _options: function() {
            return options;
          },
          setInterval: setInterval,
          start: function() {
            $interval.cancel(state.ping);

            state.ping = $interval(ping, options.interval * 1000);
            return state.ping;
          },
          stop: function() {
            $interval.cancel(state.ping);
          },
          ping: function() {
            ping();
          }
        };
      }
    ];
  });

angular.module('ngIdle.idle', ['ngIdle.keepalive', 'ngIdle.localStorage'])
  .provider('Idle', function() {
    var options = {
      idle: 20 * 60, // in seconds (default is 20min)
      timeout: 30, // in seconds (default is 30sec)
      autoResume: 'idle', // lets events automatically resume (unsets idle state/resets warning)
      interrupt: 'mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll',
      windowInterrupt: null,
      keepalive: true
    };

    /**
     *  Sets the number of seconds a user can be idle before they are considered timed out.
     *  @param {Number|Boolean} seconds A positive number representing seconds OR 0 or false to disable this feature.
     */
    var setTimeout = this.timeout = function(seconds) {
      if (seconds === false) options.timeout = 0;
      else if (angular.isNumber(seconds) && seconds >= 0) options.timeout = seconds;
      else throw new Error('Timeout must be zero or false to disable the feature, or a positive integer (in seconds) to enable it.');
    };

    this.interrupt = function(events) {
      options.interrupt = events;
    };

    this.windowInterrupt = function(events) {
      options.windowInterrupt = events;
    };

    var setIdle = this.idle = function(seconds) {
      if (seconds <= 0) throw new Error('Idle must be a value in seconds, greater than 0.');

      options.idle = seconds;
    };

    this.autoResume = function(value) {
      if (value === true) options.autoResume = 'idle';
      else if (value === false) options.autoResume = 'off';
      else options.autoResume = value;
    };

    this.keepalive = function(enabled) {
      options.keepalive = enabled === true;
    };

    this.$get = ['$interval', '$log', '$rootScope', '$document', 'Keepalive', 'IdleLocalStorage', '$window',
      function($interval, $log, $rootScope, $document, Keepalive, LocalStorage, $window) {
        var state = {
          idle: null,
          timeout: null,
          idling: false,
          running: false,
          countdown: null
        };

        var id = new Date().getTime();

        function startKeepalive() {
          if (!options.keepalive) return;

          if (state.running) Keepalive.ping();

          Keepalive.start();
        }

        function stopKeepalive() {
          if (!options.keepalive) return;

          Keepalive.stop();
        }

        function toggleState() {
          state.idling = !state.idling;
          var name = state.idling ? 'IdleStart' : 'IdleEnd';

          if (state.idling) {
            $rootScope.$broadcast(name);
            stopKeepalive();
            if (options.timeout) {
              state.countdown = options.timeout;
              countdown();
              state.timeout = $interval(countdown, 1000, options.timeout, false);
            }
          } else {
            startKeepalive();
            $rootScope.$broadcast(name);
          }

          $interval.cancel(state.idle);
        }

        function countdown() {

          // check not called when no longer idling
          // possible with multiple tabs
          if(!state.idling){
            return;
          }

          // countdown has expired, so signal timeout
          if (state.countdown <= 0) {
            timeout();
            return;
          }

          // countdown hasn't reached zero, so warn and decrement
          $rootScope.$broadcast('IdleWarn', state.countdown);
          state.countdown--;
        }

        function interrupted(anotherTab) {
          $rootScope.$broadcast('IdleInterrupt', anotherTab);
        }

        function timeout() {
          stopKeepalive();
          $interval.cancel(state.idle);
          $interval.cancel(state.timeout);

          state.idling = true;
          state.running = false;
          state.countdown = 0;

          $rootScope.$broadcast('IdleTimeout');
        }

        function changeOption(self, fn, value) {
          var reset = self.running();

          self.unwatch();
          fn(value);
          if (reset) self.watch();
        }

        function getExpiry() {
          var obj = LocalStorage.get('expiry');

          return obj && obj.time ? new Date(obj.time) : null;
        }

        function setExpiry(date) {
          if (!date) LocalStorage.remove('expiry');
          else LocalStorage.set('expiry', {id: id, time: date});
        }

        var svc = {
          _options: function() {
            return options;
          },
          _getNow: function() {
            return new Date();
          },
          getIdle: function(){
            return options.idle;
          },
          getTimeout: function(){
            return options.timeout;
          },
          setIdle: function(seconds) {
            changeOption(this, setIdle, seconds);
          },
          setTimeout: function(seconds) {
            changeOption(this, setTimeout, seconds);
          },
          isExpired: function() {
            var expiry = getExpiry();
            return expiry !== null && expiry <= this._getNow();
          },
          running: function() {
            return state.running;
          },
          idling: function() {
            return state.idling;
          },
          watch: function(noExpiryUpdate) {
            $interval.cancel(state.idle);
            $interval.cancel(state.timeout);

            // calculate the absolute expiry date, as added insurance against a browser sleeping or paused in the background
            var timeout = !options.timeout ? 0 : options.timeout;
            if (!noExpiryUpdate) setExpiry(new Date(new Date().getTime() + ((options.idle + timeout) * 1000)));


            if (state.idling) toggleState(); // clears the idle state if currently idling
            else if (!state.running) startKeepalive(); // if about to run, start keep alive

            state.running = true;

            state.idle = $interval(toggleState, options.idle * 1000, 0, false);
          },
          unwatch: function() {
            $interval.cancel(state.idle);
            $interval.cancel(state.timeout);

            state.idling = false;
            state.running = false;
            setExpiry(null);

            stopKeepalive();
          },
          interrupt: function(anotherTab) {
            if (!state.running) return;

            if (options.timeout && this.isExpired()) {
              timeout();
              return;
            } else {
              interrupted(anotherTab);
            }

            // note: you can no longer auto resume once we exceed the expiry; you will reset state by calling watch() manually
            if (anotherTab || options.autoResume === 'idle' || (options.autoResume === 'notIdle' && !state.idling)) this.watch(anotherTab);
          }
        };

        var lastMove = {
          clientX: null,
          clientY: null,
          swap: function(event) {
            var last = {clientX: this.clientX, clientY: this.clientY};
            this.clientX = event.clientX;
            this.clientY = event.clientY;
            return last;
          },
          hasMoved: function(event) {
            var last = this.swap(event);
            if (this.clientX === null || event.movementX || event.movementY) return true;
            else if (last.clientX != event.clientX || last.clientY != event.clientY) return true;
            else return false;
          }
        };

        $document.find('html').on(options.interrupt, function(event) {
          if (event.type === 'mousemove' && event.originalEvent && event.originalEvent.movementX === 0 && event.originalEvent.movementY === 0) {
            return; // Fix for Chrome desktop notifications, triggering mousemove event.
          }

          if (event.type !== 'mousemove' || lastMove.hasMoved(event)) {
            svc.interrupt();
          }
        });

        if(options.windowInterrupt) {
          var eventList = options.windowInterrupt.split(' ');
          var fn = function() {
            svc.interrupt();
          };

          for(var i=0; i<eventList.length; i++) {
            if ($window.addEventListener) $window.addEventListener(eventList[i], fn, false);
            else $window.attachEvent(eventList[i], fn)
          }
        }

        var wrap = function(event) {
          if (event.key === 'ngIdle.expiry' && event.newValue && event.newValue !== event.oldValue) {
            var val = angular.fromJson(event.newValue);
            if (val.id === id) return;
            svc.interrupt(true);
          }
        };

        if ($window.addEventListener) $window.addEventListener('storage', wrap, false);
        else if ($window.attachEvent) $window.attachEvent('onstorage', wrap);

        return svc;
      }
    ];
  });

angular.module('ngIdle.countdown', ['ngIdle.idle'])
  .directive('idleCountdown', ['Idle', function(Idle) {
    return {
      restrict: 'A',
      scope: {
        value: '=idleCountdown'
      },
      link: function($scope) {
        // Initialize the scope's value to the configured timeout.
        $scope.value = Idle.getTimeout();

        $scope.$on('IdleWarn', function(e, countdown) {
          $scope.$evalAsync(function() {
            $scope.value = countdown;
          });
        });

        $scope.$on('IdleTimeout', function() {
          $scope.$evalAsync(function() {
            $scope.value = 0;
          });
        });
      }
    };
  }]);

angular.module('ngIdle.title', [])
  .provider('Title', function() {
    var options = {
      enabled: true
    };

    var setEnabled = this.enabled = function(enabled) {
      options.enabled = enabled === true;
    };

    function padLeft(nr, n, str){
      return new Array(n-String(nr).length+1).join(str||'0')+nr;
    }

    this.$get = ['$document', '$interpolate', function($document, $interpolate) {
      var state = {
        original: null,
        idle: '{{minutes}}:{{seconds}} until your session times out!',
        timedout: 'Your session has expired.'
      };

      return {
        setEnabled: setEnabled,
        isEnabled: function() {
          return options.enabled;
        },
        original: function(val) {
          if (angular.isUndefined(val)) return state.original;

          state.original = val;
        },
        store: function(overwrite) {
          if (overwrite || !state.original) state.original = this.value();
        },
        value: function(val) {
          if (angular.isUndefined(val)) return $document[0].title;

          $document[0].title = val;
        },
        idleMessage: function(val) {
          if (angular.isUndefined(val)) return state.idle;

          state.idle = val;
        },
        timedOutMessage: function(val) {
          if (angular.isUndefined(val)) return state.timedout;

          state.timedout = val;
        },
        setAsIdle: function(countdown) {
          this.store();

          var remaining = { totalSeconds: countdown };
          remaining.minutes = Math.floor(countdown/60);
          remaining.seconds = padLeft(countdown - remaining.minutes * 60, 2);

          this.value($interpolate(this.idleMessage())(remaining));
        },
        setAsTimedOut: function() {
          this.store();

          this.value(this.timedOutMessage());
        },
        restore: function() {
          if (this.original()) this.value(this.original());
        }
      };
    }];
  })
  .directive('title', ['Title', function(Title) {
      return {
        restrict: 'E',
        link: function($scope, $element, $attr) {
          if (!Title.isEnabled() || $attr.idleDisabled) return;

          Title.store(true);

          $scope.$on('IdleStart', function() {
            Title.original($element[0].innerText);
          });

          $scope.$on('IdleWarn', function(e, countdown) {
            Title.setAsIdle(countdown);
          });

          $scope.$on('IdleEnd', function() {
            Title.restore();
          });

          $scope.$on('IdleTimeout', function() {
            Title.setAsTimedOut();
          });
        }
      };
  }]);

angular.module('ngIdle.localStorage', [])
  .service('IdleStorageAccessor', ['$window', function($window) {
    return {
      get: function() {
        return $window.localStorage;
      }
    }
  }])
  .service('IdleLocalStorage', ['IdleStorageAccessor', function(IdleStorageAccessor) {
    function AlternativeStorage() {
      var storageMap = {};

      this.setItem = function (key, value) {
          storageMap[key] = value;
      };

      this.getItem = function (key) {
          if(typeof storageMap[key] !== 'undefined' ) {
              return storageMap[key];
          }
          return null;
      };

      this.removeItem = function (key) {
          storageMap[key] = undefined;
      };
    }

    function getStorage() {
       try {
          var s = IdleStorageAccessor.get();
          s.setItem('ngIdleStorage', '');
          s.removeItem('ngIdleStorage');

          return s;
       } catch(err) {
          return new AlternativeStorage();
       }
    }

    // Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
    // throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
    // to avoid the entire page breaking, without having to do a check at each usage of Storage.
    var storage = getStorage();

    return {
      set: function(key, value) {
        storage.setItem('ngIdle.'+key, angular.toJson(value));
      },
      get: function(key) {
        return angular.fromJson(storage.getItem('ngIdle.'+key));
      },
      remove: function(key) {
        storage.removeItem('ngIdle.'+key);
      },
      _wrapped: function() {
        return storage;
      }
    };
}]);

})(window, window.angular);

/***/ }),
/* 2900 */
/***/ (function(module, exports) {

/*!
 * ngToast v2.0.0 (http://tameraydin.github.io/ngToast)
 * Copyright 2016 Tamer Aydin (http://tamerayd.in)
 * Licensed under MIT (http://tameraydin.mit-license.org/)
 */

(function(window, angular, undefined) {
  'use strict';

  angular.module('ngToast.provider', [])
    .provider('ngToast', [
      function() {
        var messages = [],
            messageStack = [];

        var defaults = {
          animation: false,
          className: 'success',
          additionalClasses: null,
          dismissOnTimeout: true,
          timeout: 4000,
          dismissButton: false,
          dismissButtonHtml: '&times;',
          dismissOnClick: true,
          onDismiss: null,
          compileContent: false,
          combineDuplications: false,
          horizontalPosition: 'right', // right, center, left
          verticalPosition: 'top', // top, bottom,
          maxNumber: 0,
          newestOnTop: true
        };

        function Message(msg) {
          var id = Math.floor(Math.random()*1000);
          while (messages.indexOf(id) > -1) {
            id = Math.floor(Math.random()*1000);
          }

          this.id = id;
          this.count = 0;
          this.animation = defaults.animation;
          this.className = defaults.className;
          this.additionalClasses = defaults.additionalClasses;
          this.dismissOnTimeout = defaults.dismissOnTimeout;
          this.timeout = defaults.timeout;
          this.dismissButton = defaults.dismissButton;
          this.dismissButtonHtml = defaults.dismissButtonHtml;
          this.dismissOnClick = defaults.dismissOnClick;
          this.onDismiss = defaults.onDismiss;
          this.compileContent = defaults.compileContent;

          angular.extend(this, msg);
        }

        this.configure = function(config) {
          angular.extend(defaults, config);
        };

        this.$get = [function() {
          var _createWithClassName = function(className, msg) {
            msg = (typeof msg === 'object') ? msg : {content: msg};
            msg.className = className;

            return this.create(msg);
          };

          return {
            settings: defaults,
            messages: messages,
            dismiss: function(id) {
              if (id) {
                for (var i = messages.length - 1; i >= 0; i--) {
                  if (messages[i].id === id) {
                    messages.splice(i, 1);
                    messageStack.splice(messageStack.indexOf(id), 1);
                    return;
                  }
                }

              } else {
                while(messages.length > 0) {
                  messages.pop();
                }
                messageStack = [];
              }
            },
            create: function(msg) {
              msg = (typeof msg === 'object') ? msg : {content: msg};

              if (defaults.combineDuplications) {
                for (var i = messageStack.length - 1; i >= 0; i--) {
                  var _msg = messages[i];
                  var _className = msg.className || 'success';

                  if (_msg.content === msg.content &&
                      _msg.className === _className) {
                    messages[i].count++;
                    return;
                  }
                }
              }

              if (defaults.maxNumber > 0 &&
                  messageStack.length >= defaults.maxNumber) {
                this.dismiss(messageStack[0]);
              }

              var newMsg = new Message(msg);
              messages[defaults.newestOnTop ? 'unshift' : 'push'](newMsg);
              messageStack.push(newMsg.id);

              return newMsg.id;
            },
            success: function(msg) {
              return _createWithClassName.call(this, 'success', msg);
            },
            info: function(msg) {
              return _createWithClassName.call(this, 'info', msg);
            },
            warning: function(msg) {
              return _createWithClassName.call(this, 'warning', msg);
            },
            danger: function(msg) {
              return _createWithClassName.call(this, 'danger', msg);
            }
          };
        }];
      }
    ]);

})(window, window.angular);

(function(window, angular) {
  'use strict';

  angular.module('ngToast.directives', ['ngToast.provider'])
    .run(['$templateCache',
      function($templateCache) {
        $templateCache.put('ngToast/toast.html',
          '<div class="ng-toast ng-toast--{{hPos}} ng-toast--{{vPos}} {{animation ? \'ng-toast--animate-\' + animation : \'\'}}">' +
            '<ul class="ng-toast__list">' +
              '<toast-message ng-repeat="message in messages" ' +
                'message="message" count="message.count">' +
                '<span ng-bind-html="message.content"></span>' +
              '</toast-message>' +
            '</ul>' +
          '</div>');
        $templateCache.put('ngToast/toastMessage.html',
          '<li class="ng-toast__message {{message.additionalClasses}}"' +
            'ng-mouseenter="onMouseEnter()"' +
            'ng-mouseleave="onMouseLeave()">' +
            '<div class="alert alert-{{message.className}}" ' +
              'ng-class="{\'alert-dismissible\': message.dismissButton}">' +
              '<button type="button" class="close" ' +
                'ng-if="message.dismissButton" ' +
                'ng-bind-html="message.dismissButtonHtml" ' +
                'ng-click="!message.dismissOnClick && dismiss()">' +
              '</button>' +
              '<span ng-if="count" class="ng-toast__message__count">' +
                '{{count + 1}}' +
              '</span>' +
              '<span ng-if="!message.compileContent" ng-transclude></span>' +
            '</div>' +
          '</li>');
      }
    ])
    .directive('toast', ['ngToast', '$templateCache', '$log',
      function(ngToast, $templateCache, $log) {
        return {
          replace: true,
          restrict: 'EA',
          templateUrl: 'ngToast/toast.html',
          compile: function(tElem, tAttrs) {
            if (tAttrs.template) {
              var template = $templateCache.get(tAttrs.template);
              if (template) {
                tElem.replaceWith(template);
              } else {
                $log.warn('ngToast: Provided template could not be loaded. ' +
                  'Please be sure that it is populated before the <toast> element is represented.');
              }
            }

            return function(scope) {
              scope.hPos = ngToast.settings.horizontalPosition;
              scope.vPos = ngToast.settings.verticalPosition;
              scope.animation = ngToast.settings.animation;
              scope.messages = ngToast.messages;
            };
          }
        };
      }
    ])
    .directive('toastMessage', ['$timeout', '$compile', 'ngToast',
      function($timeout, $compile, ngToast) {
        return {
          replace: true,
          transclude: true,
          restrict: 'EA',
          scope: {
            message: '=',
            count: '='
          },
          controller: ['$scope', 'ngToast', function($scope, ngToast) {
            $scope.dismiss = function() {
              ngToast.dismiss($scope.message.id);
            };
          }],
          templateUrl: 'ngToast/toastMessage.html',
          link: function(scope, element, attrs, ctrl, transclude) {
            element.attr('data-message-id', scope.message.id);

            var dismissTimeout;
            var scopeToBind = scope.message.compileContent;

            scope.cancelTimeout = function() {
              $timeout.cancel(dismissTimeout);
            };

            scope.startTimeout = function() {
              if (scope.message.dismissOnTimeout) {
                dismissTimeout = $timeout(function() {
                  ngToast.dismiss(scope.message.id);
                }, scope.message.timeout);
              }
            };

            scope.onMouseEnter = function() {
              scope.cancelTimeout();
            };

            scope.onMouseLeave = function() {
              scope.startTimeout();
            };

            if (scopeToBind) {
              var transcludedEl;

              transclude(scope, function(clone) {
                transcludedEl = clone;
                element.children().append(transcludedEl);
              });

              $timeout(function() {
                $compile(transcludedEl.contents())
                  (typeof scopeToBind === 'boolean' ?
                    scope.$parent : scopeToBind, function(compiledClone) {
                    transcludedEl.replaceWith(compiledClone);
                  });
              }, 0);
            }

            scope.startTimeout();

            if (scope.message.dismissOnClick) {
              element.bind('click', function() {
                ngToast.dismiss(scope.message.id);
                scope.$apply();
              });
            }

            if (scope.message.onDismiss) {
              scope.$on('$destroy',
                scope.message.onDismiss.bind(scope.message));
            }
          }
        };
      }
    ]);

})(window, window.angular);

(function(window, angular) {
  'use strict';

  angular
    .module('ngToast', [
      'ngSanitize',
      'ngToast.directives',
      'ngToast.provider'
    ]);

})(window, window.angular);


/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

(function(root, factory) {
if (true) {
module.exports = factory(__webpack_require__(12));
} else if (typeof define === "function" && define.amd) {
define(['angular'], factory);
} else{
factory(root.angular);
}
}(this, function(angular) {
/**
 * AngularJS Google Maps Ver. 1.18.3
 *
 * The MIT License (MIT)
 * 
 * Copyright (c) 2014, 2015, 1016 Allen Kim
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
angular.module('ngMap', []);

/**
 * @ngdoc controller
 * @name MapController
 */
(function() {
  'use strict';
  var Attr2MapOptions;

  var __MapController = function(
      $scope, $element, $attrs, $parse, $interpolate, _Attr2MapOptions_, NgMap, NgMapPool, escapeRegExp
    ) {
    Attr2MapOptions = _Attr2MapOptions_;
    var vm = this;
    var exprStartSymbol = $interpolate.startSymbol();
    var exprEndSymbol = $interpolate.endSymbol();

    vm.mapOptions; /** @memberof __MapController */
    vm.mapEvents;  /** @memberof __MapController */
    vm.eventListeners;  /** @memberof __MapController */

    /**
     * Add an object to the collection of group
     * @memberof __MapController
     * @function addObject
     * @param groupName the name of collection that object belongs to
     * @param obj  an object to add into a collection, i.e. marker, shape
     */
    vm.addObject = function(groupName, obj) {
      if (vm.map) {
        vm.map[groupName] = vm.map[groupName] || {};
        var len = Object.keys(vm.map[groupName]).length;
        vm.map[groupName][obj.id || len] = obj;

        if (vm.map instanceof google.maps.Map) {
          //infoWindow.setMap works like infoWindow.open
          if (groupName != "infoWindows" && obj.setMap) {
            obj.setMap && obj.setMap(vm.map);
          }
          if (obj.centered && obj.position) {
            vm.map.setCenter(obj.position);
          }
          (groupName == 'markers') && vm.objectChanged('markers');
          (groupName == 'customMarkers') && vm.objectChanged('customMarkers');
        }
      }
    };

    /**
     * Delete an object from the collection and remove from map
     * @memberof __MapController
     * @function deleteObject
     * @param {Array} objs the collection of objects. i.e., map.markers
     * @param {Object} obj the object to be removed. i.e., marker
     */
    vm.deleteObject = function(groupName, obj) {
      /* delete from group */
      if (obj.map) {
        var objs = obj.map[groupName];
        for (var name in objs) {
          if (objs[name] === obj) {
            void 0;
            google.maps.event.clearInstanceListeners(obj);
            delete objs[name];
          }
        }

        /* delete from map */
        obj.map && obj.setMap && obj.setMap(null);

        (groupName == 'markers') && vm.objectChanged('markers');
        (groupName == 'customMarkers') && vm.objectChanged('customMarkers');
      }
    };

    /**
     * @memberof __MapController
     * @function observeAttrSetObj
     * @param {Hash} orgAttrs attributes before its initialization
     * @param {Hash} attrs    attributes after its initialization
     * @param {Object} obj    map object that an action is to be done
     * @description watch changes of attribute values and
     * do appropriate action based on attribute name
     */
    vm.observeAttrSetObj = function(orgAttrs, attrs, obj) {
      if (attrs.noWatcher) {
        return false;
      }
      var attrsToObserve = Attr2MapOptions.getAttrsToObserve(orgAttrs);
      for (var i=0; i<attrsToObserve.length; i++) {
        var attrName = attrsToObserve[i];
        attrs.$observe(attrName, NgMap.observeAndSet(attrName, obj));
      }
    };

    /**
     * @memberof __MapController
     * @function zoomToIncludeMarkers
     */
    vm.zoomToIncludeMarkers = function() {
      // Only fit to bounds if we have any markers
      // object.keys is supported in all major browsers (IE9+)
      if ((vm.map.markers != null && Object.keys(vm.map.markers).length > 0) || (vm.map.customMarkers != null && Object.keys(vm.map.customMarkers).length > 0)) {
        var bounds = new google.maps.LatLngBounds();
        for (var k1 in vm.map.markers) {
          bounds.extend(vm.map.markers[k1].getPosition());
        }
        for (var k2 in vm.map.customMarkers) {
          bounds.extend(vm.map.customMarkers[k2].getPosition());
        }
    	  if (vm.mapOptions.maximumZoom) {
    		  vm.enableMaximumZoomCheck = true; //enable zoom check after resizing for markers
    	  }
        vm.map.fitBounds(bounds);
      }
    };

    /**
     * @memberof __MapController
     * @function objectChanged
     * @param {String} group name of group e.g., markers
     */
    vm.objectChanged = function(group) {
      if ( vm.map &&
        (group == 'markers' || group == 'customMarkers') &&
        vm.map.zoomToIncludeMarkers == 'auto'
      ) {
        vm.zoomToIncludeMarkers();
      }
    };

    /**
     * @memberof __MapController
     * @function initializeMap
     * @description
     *  . initialize Google map on <div> tag
     *  . set map options, events, and observers
     *  . reset zoom to include all (custom)markers
     */
    vm.initializeMap = function() {
      var mapOptions = vm.mapOptions,
          mapEvents = vm.mapEvents;

      var lazyInitMap = vm.map; //prepared for lazy init
      vm.map = NgMapPool.getMapInstance($element[0]);
      NgMap.setStyle($element[0]);

      // set objects for lazyInit
      if (lazyInitMap) {

        /**
         * rebuild mapOptions for lazyInit
         * because attributes values might have been changed
         */
        var filtered = Attr2MapOptions.filter($attrs);
        var options = Attr2MapOptions.getOptions(filtered);
        var controlOptions = Attr2MapOptions.getControlOptions(filtered);
        mapOptions = angular.extend(options, controlOptions);
        void 0;

        for (var group in lazyInitMap) {
          var groupMembers = lazyInitMap[group]; //e.g. markers
          if (typeof groupMembers == 'object') {
            for (var id in groupMembers) {
              vm.addObject(group, groupMembers[id]);
            }
          }
        }
        vm.map.showInfoWindow = vm.showInfoWindow;
        vm.map.hideInfoWindow = vm.hideInfoWindow;
      }

      // set options
      mapOptions.zoom = mapOptions.zoom || 15;
      var center = mapOptions.center;
      var exprRegExp = new RegExp(escapeRegExp(exprStartSymbol) + '.*' + escapeRegExp(exprEndSymbol));

      if (!mapOptions.center ||
        ((typeof center === 'string') && center.match(exprRegExp))
      ) {
        mapOptions.center = new google.maps.LatLng(0, 0);
      } else if( (typeof center === 'string') && center.match(/^[0-9.-]*,[0-9.-]*$/) ){
        var lat = parseFloat(center.split(',')[0]);
        var lng = parseFloat(center.split(',')[1]);
        mapOptions.center = new google.maps.LatLng(lat, lng);
      } else if (!(center instanceof google.maps.LatLng)) {
        var geoCenter = mapOptions.center;
        delete mapOptions.center;
        NgMap.getGeoLocation(geoCenter, mapOptions.geoLocationOptions).
          then(function (latlng) {
            vm.map.setCenter(latlng);
            var geoCallback = mapOptions.geoCallback;
            geoCallback && $parse(geoCallback)($scope);
          }, function () {
            if (mapOptions.geoFallbackCenter) {
              vm.map.setCenter(mapOptions.geoFallbackCenter);
            }
          });
      }
      vm.map.setOptions(mapOptions);

      // set events
      for (var eventName in mapEvents) {
        var event = mapEvents[eventName];
        var listener = google.maps.event.addListener(vm.map, eventName, event);
        vm.eventListeners[eventName] = listener;
      }

      // set observers
      vm.observeAttrSetObj(orgAttrs, $attrs, vm.map);
      vm.singleInfoWindow = mapOptions.singleInfoWindow;

      google.maps.event.trigger(vm.map, 'resize');

      google.maps.event.addListenerOnce(vm.map, "idle", function () {
        NgMap.addMap(vm);
        if (mapOptions.zoomToIncludeMarkers) {
          vm.zoomToIncludeMarkers();
        }
        //TODO: it's for backward compatibiliy. will be removed
        $scope.map = vm.map;
        $scope.$emit('mapInitialized', vm.map);

        //callback
        if ($attrs.mapInitialized) {
          $parse($attrs.mapInitialized)($scope, {map: vm.map});
        }
      });

	  //add maximum zoom listeners if zoom-to-include-markers and and maximum-zoom are valid attributes
	  if (mapOptions.zoomToIncludeMarkers && mapOptions.maximumZoom) {
	    google.maps.event.addListener(vm.map, 'zoom_changed', function() {
          if (vm.enableMaximumZoomCheck == true) {
			vm.enableMaximumZoomCheck = false;
	        google.maps.event.addListenerOnce(vm.map, 'bounds_changed', function() {
		      vm.map.setZoom(Math.min(mapOptions.maximumZoom, vm.map.getZoom()));
		    });
	  	  }
	    });
	  }
    };

    $scope.google = google; //used by $scope.eval to avoid eval()

    /**
     * get map options and events
     */
    var orgAttrs = Attr2MapOptions.orgAttributes($element);
    var filtered = Attr2MapOptions.filter($attrs);
    var options = Attr2MapOptions.getOptions(filtered, {scope: $scope});
    var controlOptions = Attr2MapOptions.getControlOptions(filtered);
    var mapOptions = angular.extend(options, controlOptions);
    var mapEvents = Attr2MapOptions.getEvents($scope, filtered);
    void 0;
    Object.keys(mapEvents).length && void 0;

    vm.mapOptions = mapOptions;
    vm.mapEvents = mapEvents;
    vm.eventListeners = {};

    if (options.lazyInit) { // allows controlled initialization
      // parse angular expression for dynamic ids
      if (!!$attrs.id &&
      	  // starts with, at position 0
	  $attrs.id.indexOf(exprStartSymbol, 0) === 0 &&
	  // ends with
	  $attrs.id.indexOf(exprEndSymbol, $attrs.id.length - exprEndSymbol.length) !== -1) {
        var idExpression = $attrs.id.slice(2,-2);
        var mapId = $parse(idExpression)($scope);
      } else {
        var mapId = $attrs.id;
      }
      vm.map = {id: mapId}; //set empty, not real, map
      NgMap.addMap(vm);
    } else {
      vm.initializeMap();
    }

    //Trigger Resize
    if(options.triggerResize) {
      google.maps.event.trigger(vm.map, 'resize');
    }

    $element.bind('$destroy', function() {
      NgMapPool.returnMapInstance(vm.map);
      NgMap.deleteMap(vm);
    });
  }; // __MapController

  __MapController.$inject = [
    '$scope', '$element', '$attrs', '$parse', '$interpolate', 'Attr2MapOptions', 'NgMap', 'NgMapPool', 'escapeRegexpFilter'
  ];
  angular.module('ngMap').controller('__MapController', __MapController);
})();

/**
 * @ngdoc directive
 * @name bicycling-layer
 * @param Attr2Options {service}
 *   convert html attribute to Google map api options
 * @description
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @example
 *
 *   <map zoom="13" center="34.04924594193164, -118.24104309082031">
 *     <bicycling-layer></bicycling-layer>
 *    </map>
 */
(function() {
  'use strict';
  var parser;

  var linkFunc = function(scope, element, attrs, mapController) {
    mapController = mapController[0]||mapController[1];
    var orgAttrs = parser.orgAttributes(element);
    var filtered = parser.filter(attrs);
    var options = parser.getOptions(filtered, {scope: scope});
    var events = parser.getEvents(scope, filtered);

    void 0;

    var layer = getLayer(options, events);
    mapController.addObject('bicyclingLayers', layer);
    mapController.observeAttrSetObj(orgAttrs, attrs, layer);  //observers
    element.bind('$destroy', function() {
      mapController.deleteObject('bicyclingLayers', layer);
    });
  };

  var getLayer = function(options, events) {
    var layer = new google.maps.BicyclingLayer(options);
    for (var eventName in events) {
      google.maps.event.addListener(layer, eventName, events[eventName]);
    }
    return layer;
  };

  var bicyclingLayer= function(Attr2MapOptions) {
    parser = Attr2MapOptions;
    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],
      link: linkFunc
     };
  };
  bicyclingLayer.$inject = ['Attr2MapOptions'];

  angular.module('ngMap').directive('bicyclingLayer', bicyclingLayer);
})();

/**
 * @ngdoc directive
 * @name custom-control
 * @param Attr2Options {service} convert html attribute to Google map api options
 * @param $compile {service} AngularJS $compile service
 * @description
 *   Build custom control and set to the map with position
 *
 *   Requires:  map directive
 *
 *   Restrict To:  Element
 *
 * @attr {String} position position of this control
 *        i.e. TOP_RIGHT
 * @attr {Number} index index of the control
 * @example
 *
 * Example:
 *  <map center="41.850033,-87.6500523" zoom="3">
 *    <custom-control id="home" position="TOP_LEFT" index="1">
 *      <div style="background-color: white;">
 *        <b>Home</b>
 *      </div>
 *    </custom-control>
 *  </map>
 *
 */
(function() {
  'use strict';
  var parser, NgMap;

  var linkFunc = function(scope, element, attrs, mapController, $transclude) {
    mapController = mapController[0]||mapController[1];
    var filtered = parser.filter(attrs);
    var options = parser.getOptions(filtered, {scope: scope});
    var events = parser.getEvents(scope, filtered);

    /**
     * build a custom control element
     */
    var customControlEl = element[0].parentElement.removeChild(element[0]);
    var content = $transclude();
    angular.element(customControlEl).append(content);

    /**
     * set events
     */
    for (var eventName in events) {
      google.maps.event.addDomListener(customControlEl, eventName, events[eventName]);
    }

    mapController.addObject('customControls', customControlEl);
    var position = options.position;
    mapController.map.controls[google.maps.ControlPosition[position]].push(customControlEl);

    element.bind('$destroy', function() {
      mapController.deleteObject('customControls', customControlEl);
    });
  };

  var customControl =  function(Attr2MapOptions, _NgMap_)  {
    parser = Attr2MapOptions, NgMap = _NgMap_;

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],
      link: linkFunc,
      transclude: true
    }; // return
  };
  customControl.$inject = ['Attr2MapOptions', 'NgMap'];

  angular.module('ngMap').directive('customControl', customControl);
})();

/**
 * @ngdoc directive
 * @memberof ngmap
 * @name custom-marker
 * @param Attr2Options {service} convert html attribute to Google map api options
 * @param $timeout {service} AngularJS $timeout
 * @description
 *   Marker with html
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @attr {String} position required, position on map
 * @attr {Number} z-index optional
 * @attr {Boolean} visible optional
 * @example
 *
 * Example:
 *   <map center="41.850033,-87.6500523" zoom="3">
 *     <custom-marker position="41.850033,-87.6500523">
 *       <div>
 *         <b>Home</b>
 *       </div>
 *     </custom-marker>
 *   </map>
 *
 */
/* global document */
(function() {
  'use strict';
  var parser, $timeout, $compile, NgMap;

  var CustomMarker = function(options) {
    options = options || {};

    this.el = document.createElement('div');
    this.el.style.display = 'inline-block';
    this.el.style.visibility = "hidden";
    this.visible = true;
    for (var key in options) { /* jshint ignore:line */
     this[key] = options[key];
    }
  };

  var setCustomMarker = function() {

    CustomMarker.prototype = new google.maps.OverlayView();

    CustomMarker.prototype.setContent = function(html, scope) {
      this.el.innerHTML = html;
      this.el.style.position = 'absolute';
      if (scope) {
        $compile(angular.element(this.el).contents())(scope);
      }
    };

    CustomMarker.prototype.getDraggable = function() {
      return this.draggable;
    };

    CustomMarker.prototype.setDraggable = function(draggable) {
      this.draggable = draggable;
    };

    CustomMarker.prototype.getPosition = function() {
      return this.position;
    };

    CustomMarker.prototype.setPosition = function(position) {
      position && (this.position = position); /* jshint ignore:line */
      var _this = this;
      if (this.getProjection() && typeof this.position.lng == 'function') {
        void 0;
        var setPosition = function() {
          if (!_this.getProjection()) { return; }
          var posPixel = _this.getProjection().fromLatLngToDivPixel(_this.position);
          var x = Math.round(posPixel.x - (_this.el.offsetWidth/2));
          var y = Math.round(posPixel.y - _this.el.offsetHeight - 10); // 10px for anchor
          _this.el.style.left = x + "px";
          _this.el.style.top = y + "px";
          _this.el.style.visibility = "visible";
        };
        if (_this.el.offsetWidth && _this.el.offsetHeight) {
          setPosition();
        } else {
          //delayed left/top calculation when width/height are not set instantly
          $timeout(setPosition, 300);
        }
      }
    };

    CustomMarker.prototype.setZIndex = function(zIndex) {
      zIndex && (this.zIndex = zIndex); /* jshint ignore:line */
      this.el.style.zIndex = this.zIndex;
    };

    CustomMarker.prototype.getVisible = function() {
      return this.visible;
    };

    CustomMarker.prototype.setVisible = function(visible) {
      this.el.style.display = visible ? 'inline-block' : 'none';
      this.visible = visible;
    };

    CustomMarker.prototype.addClass = function(className) {
      var classNames = this.el.className.trim().split(' ');
      (classNames.indexOf(className) == -1) && classNames.push(className); /* jshint ignore:line */
      this.el.className = classNames.join(' ');
    };

    CustomMarker.prototype.removeClass = function(className) {
      var classNames = this.el.className.split(' ');
      var index = classNames.indexOf(className);
      (index > -1) && classNames.splice(index, 1); /* jshint ignore:line */
      this.el.className = classNames.join(' ');
    };

    CustomMarker.prototype.onAdd = function() {
      this.getPanes().overlayMouseTarget.appendChild(this.el);
    };

    CustomMarker.prototype.draw = function() {
      this.setPosition();
      this.setZIndex(this.zIndex);
      this.setVisible(this.visible);
    };

    CustomMarker.prototype.onRemove = function() {
      this.el.parentNode.removeChild(this.el);
      //this.el = null;
    };
  };

  var linkFunc = function(orgHtml, varsToWatch) {
    //console.log('orgHtml', orgHtml, 'varsToWatch', varsToWatch);

    return function(scope, element, attrs, mapController) {
      mapController = mapController[0]||mapController[1];
      var orgAttrs = parser.orgAttributes(element);

      var filtered = parser.filter(attrs);
      var options = parser.getOptions(filtered, {scope: scope});
      var events = parser.getEvents(scope, filtered);

      /**
       * build a custom marker element
       */
      element[0].style.display = 'none';
      void 0;
      var customMarker = new CustomMarker(options);

      $timeout(function() { //apply contents, class, and location after it is compiled

        scope.$watch('[' + varsToWatch.join(',') + ']', function() {
          customMarker.setContent(orgHtml, scope);
        }, true);

        customMarker.setContent(element[0].innerHTML, scope);
        var classNames = element[0].firstElementChild.className;
        customMarker.addClass('custom-marker');
        customMarker.addClass(classNames);
        void 0;

        if (!(options.position instanceof google.maps.LatLng)) {
          NgMap.getGeoLocation(options.position).then(
                function(latlng) {
                  customMarker.setPosition(latlng);
                }
          );
        }

      });

      void 0;
      for (var eventName in events) { /* jshint ignore:line */
        google.maps.event.addDomListener(
          customMarker.el, eventName, events[eventName]);
      }
      mapController.addObject('customMarkers', customMarker);

      //set observers
      mapController.observeAttrSetObj(orgAttrs, attrs, customMarker);

      element.bind('$destroy', function() {
        //Is it required to remove event listeners when DOM is removed?
        mapController.deleteObject('customMarkers', customMarker);
      });

    }; // linkFunc
  };


  var customMarkerDirective = function(
      _$timeout_, _$compile_, $interpolate, Attr2MapOptions, _NgMap_, escapeRegExp
    )  {
    parser = Attr2MapOptions;
    $timeout = _$timeout_;
    $compile = _$compile_;
    NgMap = _NgMap_;

    var exprStartSymbol = $interpolate.startSymbol();
    var exprEndSymbol = $interpolate.endSymbol();
    var exprRegExp = new RegExp(escapeRegExp(exprStartSymbol) + '([^' + exprEndSymbol.substring(0, 1) + ']+)' + escapeRegExp(exprEndSymbol), 'g');

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],
      compile: function(element) {
        setCustomMarker();
        element[0].style.display ='none';
        var orgHtml = element.html();
        var matches = orgHtml.match(exprRegExp);
        var varsToWatch = [];
        //filter out that contains '::', 'this.'
        (matches || []).forEach(function(match) {
          var toWatch = match.replace(exprStartSymbol,'').replace(exprEndSymbol,'');
          if (match.indexOf('::') == -1 &&
            match.indexOf('this.') == -1 &&
            varsToWatch.indexOf(toWatch) == -1) {
            varsToWatch.push(match.replace(exprStartSymbol,'').replace(exprEndSymbol,''));
          }
        });

        return linkFunc(orgHtml, varsToWatch);
      }
    }; // return
  };// function
  customMarkerDirective.$inject =
    ['$timeout', '$compile', '$interpolate', 'Attr2MapOptions', 'NgMap', 'escapeRegexpFilter'];

  angular.module('ngMap').directive('customMarker', customMarkerDirective);
})();

/**
 * @ngdoc directive
 * @name directions
 * @description
 *   Enable directions on map.
 *   e.g., origin, destination, draggable, waypoints, etc
 *
 *   Requires:  map directive
 *
 *   Restrict To:  Element
 *
 * @attr {String} DirectionsRendererOptions
 *   [Any DirectionsRendererOptions](https://developers.google.com/maps/documentation/javascript/reference#DirectionsRendererOptions)
 * @attr {String} DirectionsRequestOptions
 *   [Any DirectionsRequest options](https://developers.google.com/maps/documentation/javascript/reference#DirectionsRequest)
 * @example
 *  <map zoom="14" center="37.7699298, -122.4469157">
 *    <directions
 *      draggable="true"
 *      panel="directions-panel"
 *      travel-mode="{{travelMode}}"
 *      waypoints="[{location:'kingston', stopover:true}]"
 *      origin="{{origin}}"
 *      destination="{{destination}}">
 *    </directions>
 *  </map>
 */
/* global document */
(function() {
  'use strict';
  var NgMap, $timeout, NavigatorGeolocation;

  var getDirectionsRenderer = function(options, events) {
    if (options.panel) {
      options.panel = document.getElementById(options.panel) ||
        document.querySelector(options.panel);
    }
    var renderer = new google.maps.DirectionsRenderer(options);
    for (var eventName in events) {
      google.maps.event.addListener(renderer, eventName, events[eventName]);
    }
    return renderer;
  };

  var updateRoute = function(renderer, options) {
    var directionsService = new google.maps.DirectionsService();

    /* filter out valid keys only for DirectionsRequest object*/
    var request = options;
    request.travelMode = request.travelMode || 'DRIVING';
    var validKeys = [
      'origin', 'destination', 'travelMode', 'transitOptions', 'unitSystem',
      'durationInTraffic', 'waypoints', 'optimizeWaypoints', 
      'provideRouteAlternatives', 'avoidHighways', 'avoidTolls', 'region'
    ];
    for(var key in request){
      (validKeys.indexOf(key) === -1) && (delete request[key]);
    }

    if(request.waypoints) {
      // Check fo valid values
      if(request.waypoints == "[]" || request.waypoints === "") {
        delete request.waypoints;
      }
    }

    var showDirections = function(request) {
      directionsService.route(request, function(response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
          $timeout(function() {
            renderer.setDirections(response);
          });
        }
      });
    };

    if (request.origin && request.destination) {
      if (request.origin == 'current-location') {
        NavigatorGeolocation.getCurrentPosition().then(function(ll) {
          request.origin = new google.maps.LatLng(ll.coords.latitude, ll.coords.longitude);
          showDirections(request);
        });
      } else if (request.destination == 'current-location') {
        NavigatorGeolocation.getCurrentPosition().then(function(ll) {
          request.destination = new google.maps.LatLng(ll.coords.latitude, ll.coords.longitude);
          showDirections(request);
        });
      } else {
        showDirections(request);
      }
    }
  };

  var directions = function(
      Attr2MapOptions, _$timeout_, _NavigatorGeolocation_, _NgMap_) {
    var parser = Attr2MapOptions;
    NgMap = _NgMap_;
    $timeout = _$timeout_;
    NavigatorGeolocation = _NavigatorGeolocation_;

    var linkFunc = function(scope, element, attrs, mapController) {
      mapController = mapController[0]||mapController[1];

      var orgAttrs = parser.orgAttributes(element);
      var filtered = parser.filter(attrs);
      var options = parser.getOptions(filtered, {scope: scope});
      var events = parser.getEvents(scope, filtered);
      var attrsToObserve = parser.getAttrsToObserve(orgAttrs);

      var renderer = getDirectionsRenderer(options, events);
      mapController.addObject('directionsRenderers', renderer);

      attrsToObserve.forEach(function(attrName) {
        (function(attrName) {
          attrs.$observe(attrName, function(val) {
            if (attrName == 'panel') {
              $timeout(function(){
                var panel =
                  document.getElementById(val) || document.querySelector(val);
                void 0;
                panel && renderer.setPanel(panel);
              });
            } else if (options[attrName] !== val) { //apply only if changed
              var optionValue = parser.toOptionValue(val, {key: attrName});
              void 0;
              options[attrName] = optionValue;
              updateRoute(renderer, options);
            }
          });
        })(attrName);
      });

      NgMap.getMap().then(function() {
        updateRoute(renderer, options);
      });
      element.bind('$destroy', function() {
        mapController.deleteObject('directionsRenderers', renderer);
      });
    };

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],
      link: linkFunc
    };
  }; // var directions
  directions.$inject =
    ['Attr2MapOptions', '$timeout', 'NavigatorGeolocation', 'NgMap'];

  angular.module('ngMap').directive('directions', directions);
})();


/**
 * @ngdoc directive
 * @name drawing-manager
 * @param Attr2Options {service} convert html attribute to Google map api options
 * @description
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @example
 * Example:
 *
 *  <map zoom="13" center="37.774546, -122.433523" map-type-id="SATELLITE">
 *    <drawing-manager
 *      on-overlaycomplete="onMapOverlayCompleted()"
 *      position="ControlPosition.TOP_CENTER"
 *      drawingModes="POLYGON,CIRCLE"
 *      drawingControl="true"
 *      circleOptions="fillColor: '#FFFF00';fillOpacity: 1;strokeWeight: 5;clickable: false;zIndex: 1;editable: true;" >
 *    </drawing-manager>
 *  </map>
 *
 *  TODO: Add remove button.
 *  currently, for our solution, we have the shapes/markers in our own
 *  controller, and we use some css classes to change the shape button
 *  to a remove button (<div>X</div>) and have the remove operation in our own controller.
 */
(function() {
  'use strict';
  angular.module('ngMap').directive('drawingManager', [
    'Attr2MapOptions', function(Attr2MapOptions) {
    var parser = Attr2MapOptions;

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],

      link: function(scope, element, attrs, mapController) {
        mapController = mapController[0]||mapController[1];

        var filtered = parser.filter(attrs);
        var options = parser.getOptions(filtered, {scope: scope});
        var controlOptions = parser.getControlOptions(filtered);
        var events = parser.getEvents(scope, filtered);

        /**
         * set options
         */
        var drawingManager = new google.maps.drawing.DrawingManager({
          drawingMode: options.drawingmode,
          drawingControl: options.drawingcontrol,
          drawingControlOptions: controlOptions.drawingControlOptions,
          circleOptions:options.circleoptions,
          markerOptions:options.markeroptions,
          polygonOptions:options.polygonoptions,
          polylineOptions:options.polylineoptions,
          rectangleOptions:options.rectangleoptions
        });

        //Observers
        attrs.$observe('drawingControlOptions', function (newValue) {
          drawingManager.drawingControlOptions = parser.getControlOptions({drawingControlOptions: newValue}).drawingControlOptions;
          drawingManager.setDrawingMode(null);
          drawingManager.setMap(mapController.map);
        });


        /**
         * set events
         */
        for (var eventName in events) {
          google.maps.event.addListener(drawingManager, eventName, events[eventName]);
        }

        mapController.addObject('mapDrawingManager', drawingManager);

        element.bind('$destroy', function() {
          mapController.deleteObject('mapDrawingManager', drawingManager);
        });
      }
    }; // return
  }]);
})();

/**
 * @ngdoc directive
 * @name dynamic-maps-engine-layer
 * @description
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @example
 * Example:
 *   <map zoom="14" center="[59.322506, 18.010025]">
 *     <dynamic-maps-engine-layer
 *       layer-id="06673056454046135537-08896501997766553811">
 *     </dynamic-maps-engine-layer>
 *    </map>
 */
(function() {
  'use strict';

  angular.module('ngMap').directive('dynamicMapsEngineLayer', [
    'Attr2MapOptions', function(Attr2MapOptions) {
    var parser = Attr2MapOptions;

    var getDynamicMapsEngineLayer = function(options, events) {
      var layer = new google.maps.visualization.DynamicMapsEngineLayer(options);

      for (var eventName in events) {
        google.maps.event.addListener(layer, eventName, events[eventName]);
      }

      return layer;
    };

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],

      link: function(scope, element, attrs, mapController) {
        mapController = mapController[0]||mapController[1];

        var filtered = parser.filter(attrs);
        var options = parser.getOptions(filtered, {scope: scope});
        var events = parser.getEvents(scope, filtered, events);

        var layer = getDynamicMapsEngineLayer(options, events);
        mapController.addObject('mapsEngineLayers', layer);
      }
     }; // return
  }]);
})();

/**
 * @ngdoc directive
 * @name fusion-tables-layer
 * @description
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @example
 * Example:
 *   <map zoom="11" center="41.850033, -87.6500523">
 *     <fusion-tables-layer query="{
 *       select: 'Geocodable address',
 *       from: '1mZ53Z70NsChnBMm-qEYmSDOvLXgrreLTkQUvvg'}">
 *     </fusion-tables-layer>
 *   </map>
 */
(function() {
  'use strict';

  angular.module('ngMap').directive('fusionTablesLayer', [
    'Attr2MapOptions', function(Attr2MapOptions) {
    var parser = Attr2MapOptions;

    var getLayer = function(options, events) {
      var layer = new google.maps.FusionTablesLayer(options);

      for (var eventName in events) {
        google.maps.event.addListener(layer, eventName, events[eventName]);
      }

      return layer;
    };

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],

      link: function(scope, element, attrs, mapController) {
        mapController = mapController[0]||mapController[1];

        var filtered = parser.filter(attrs);
        var options = parser.getOptions(filtered, {scope: scope});
        var events = parser.getEvents(scope, filtered, events);
        void 0;

        var layer = getLayer(options, events);
        mapController.addObject('fusionTablesLayers', layer);
        element.bind('$destroy', function() {
          mapController.deleteObject('fusionTablesLayers', layer);
        });
      }
     }; // return
  }]);
})();

/**
 * @ngdoc directive
 * @name heatmap-layer
 * @param Attr2Options {service} convert html attribute to Google map api options
 * @description
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @example
 *
 * <map zoom="11" center="[41.875696,-87.624207]">
 *   <heatmap-layer data="taxiData"></heatmap-layer>
 * </map>
 */
(function() {
  'use strict';

  angular.module('ngMap').directive('heatmapLayer', [
    'Attr2MapOptions', '$window', function(Attr2MapOptions, $window) {
    var parser = Attr2MapOptions;
    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],

      link: function(scope, element, attrs, mapController) {
        mapController = mapController[0]||mapController[1];

        var filtered = parser.filter(attrs);

        /**
         * set options
         */
        var options = parser.getOptions(filtered, {scope: scope});
        options.data = $window[attrs.data] || scope[attrs.data];
        if (options.data instanceof Array) {
          options.data = new google.maps.MVCArray(options.data);
        } else {
          throw "invalid heatmap data";
        }
        var layer = new google.maps.visualization.HeatmapLayer(options);

        /**
         * set events
         */
        var events = parser.getEvents(scope, filtered);
        void 0;

        mapController.addObject('heatmapLayers', layer);
      }
     }; // return
  }]);
})();

/**
 * @ngdoc directive
 * @name info-window
 * @param Attr2MapOptions {service}
 *   convert html attribute to Google map api options
 * @param $compile {service} $compile service
 * @description
 *  Defines infoWindow and provides compile method
 *
 *  Requires:  map directive
 *
 *  Restrict To:  Element
 *
 *  NOTE: this directive should **NOT** be used with `ng-repeat`
 *  because InfoWindow itself is a template, and a template must be
 *  reused by each marker, thus, should not be redefined repeatedly
 *  by `ng-repeat`.
 *
 * @attr {Boolean} visible
 *   Indicates to show it when map is initialized
 * @attr {Boolean} visible-on-marker
 *   Indicates to show it on a marker when map is initialized
 * @attr {Expression} geo-callback
 *   if position is an address, the expression is will be performed
 *   when geo-lookup is successful. e.g., geo-callback="showDetail()"
 * @attr {String} &lt;InfoWindowOption> Any InfoWindow options,
 *   https://developers.google.com/maps/documentation/javascript/reference?csw=1#InfoWindowOptions
 * @attr {String} &lt;InfoWindowEvent> Any InfoWindow events,
 *   https://developers.google.com/maps/documentation/javascript/reference
 * @example
 * Usage:
 *   <map MAP_ATTRIBUTES>
 *    <info-window id="foo" ANY_OPTIONS ANY_EVENTS"></info-window>
 *   </map>
 *
 * Example:
 *  <map center="41.850033,-87.6500523" zoom="3">
 *    <info-window id="1" position="41.850033,-87.6500523" >
 *      <div ng-non-bindable>
 *        Chicago, IL<br/>
 *        LatLng: {{chicago.lat()}}, {{chicago.lng()}}, <br/>
 *        World Coordinate: {{worldCoordinate.x}}, {{worldCoordinate.y}}, <br/>
 *        Pixel Coordinate: {{pixelCoordinate.x}}, {{pixelCoordinate.y}}, <br/>
 *        Tile Coordinate: {{tileCoordinate.x}}, {{tileCoordinate.y}} at Zoom Level {{map.getZoom()}}
 *      </div>
 *    </info-window>
 *  </map>
 */
/* global google */
(function() {
  'use strict';

  var infoWindow = function(Attr2MapOptions, $compile, $q, $templateRequest, $timeout, $parse, NgMap)  {
    var parser = Attr2MapOptions;

    var getInfoWindow = function(options, events, element) {
      var infoWindow;

      /**
       * set options
       */
      if (options.position && !(options.position instanceof google.maps.LatLng)) {
        delete options.position;
      }
      infoWindow = new google.maps.InfoWindow(options);

      /**
       * set events
       */
      for (var eventName in events) {
        if (eventName) {
          google.maps.event.addListener(infoWindow, eventName, events[eventName]);
        }
      }

      /**
       * set template and template-related functions
       * it must have a container element with ng-non-bindable
       */
      var templatePromise = $q(function(resolve) {
        if (angular.isString(element)) {
          $templateRequest(element).then(function (requestedTemplate) {
            resolve(angular.element(requestedTemplate).wrap('<div>').parent());
          }, function(message) {
            throw "info-window template request failed: " + message;
          });
        }
        else {
          resolve(element);
        }
      }).then(function(resolvedTemplate) {
        var template = resolvedTemplate.html().trim();
        if (angular.element(template).length != 1) {
          throw "info-window working as a template must have a container";
        }
        infoWindow.__template = template.replace(/\s?ng-non-bindable[='"]+/,"");
      });

      infoWindow.__open = function(map, scope, anchor) {
        templatePromise.then(function() {
          $timeout(function() {
            anchor && (scope.anchor = anchor);
            var el = $compile(infoWindow.__template)(scope);
            infoWindow.setContent(el[0]);
            scope.$apply();
            if (anchor && anchor.getPosition) {
              infoWindow.open(map, anchor);
            } else if (anchor && anchor instanceof google.maps.LatLng) {
              infoWindow.open(map);
              infoWindow.setPosition(anchor);
            } else {
              infoWindow.open(map);
            }
            var infoWindowContainerEl = infoWindow.content.parentElement.parentElement.parentElement;
            infoWindowContainerEl.className = "ng-map-info-window";
          });
        });
      };

      return infoWindow;
    };

    var linkFunc = function(scope, element, attrs, mapController) {
      mapController = mapController[0]||mapController[1];

      element.css('display','none');

      var orgAttrs = parser.orgAttributes(element);
      var filtered = parser.filter(attrs);
      var options = parser.getOptions(filtered, {scope: scope});
      var events = parser.getEvents(scope, filtered);

      var infoWindow = getInfoWindow(options, events, options.template || element);
      var address;
      if (options.position && !(options.position instanceof google.maps.LatLng)) {
        address = options.position;
      }
      if (address) {
        NgMap.getGeoLocation(address).then(function(latlng) {
          infoWindow.setPosition(latlng);
          infoWindow.__open(mapController.map, scope, latlng);
          var geoCallback = attrs.geoCallback;
          geoCallback && $parse(geoCallback)(scope);
        });
      }

      mapController.addObject('infoWindows', infoWindow);
      mapController.observeAttrSetObj(orgAttrs, attrs, infoWindow);

      mapController.showInfoWindow =
      mapController.map.showInfoWindow = mapController.showInfoWindow ||
        function(p1, p2, p3) { //event, id, marker
          var id = typeof p1 == 'string' ? p1 : p2;
          var marker = typeof p1 == 'string' ? p2 : p3;
          if (typeof marker == 'string') {
            //Check if markers if defined to avoid odd 'undefined' errors
            if (
              typeof mapController.map.markers != "undefined"
              && typeof mapController.map.markers[marker] != "undefined") {
                marker = mapController.map.markers[marker];
            } else if (
              //additionally check if that marker is a custom marker
              typeof mapController.map.customMarkers !== "undefined"
              && typeof mapController.map.customMarkers[marker] !== "undefined") {
                marker = mapController.map.customMarkers[marker];
            } else {
              //Better error output if marker with that id is not defined
              throw new Error("Cant open info window for id " + marker + ". Marker or CustomMarker is not defined")
            }
          }

          var infoWindow = mapController.map.infoWindows[id];
          var anchor = marker ? marker : (this.getPosition ? this : null);
          infoWindow.__open(mapController.map, scope, anchor);
          if(mapController.singleInfoWindow) {
            if(mapController.lastInfoWindow) {
              scope.hideInfoWindow(mapController.lastInfoWindow);
            }
            mapController.lastInfoWindow = id;
          }
        };

      mapController.hideInfoWindow =
      mapController.map.hideInfoWindow = mapController.hideInfoWindow ||
        function(p1, p2) {
          var id = typeof p1 == 'string' ? p1 : p2;
          var infoWindow = mapController.map.infoWindows[id];
          infoWindow.close();
        };

      //TODO DEPRECATED
      scope.showInfoWindow = mapController.map.showInfoWindow;
      scope.hideInfoWindow = mapController.map.hideInfoWindow;

      var map = infoWindow.mapId ? {id:infoWindow.mapId} : 0;
      NgMap.getMap(map).then(function(map) {
        infoWindow.visible && infoWindow.__open(map, scope);
        if (infoWindow.visibleOnMarker) {
          var markerId = infoWindow.visibleOnMarker;
          infoWindow.__open(map, scope, map.markers[markerId]);
        }
      });

    }; //link

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],
      link: linkFunc
    };

  }; // infoWindow
  infoWindow.$inject =
    ['Attr2MapOptions', '$compile', '$q', '$templateRequest', '$timeout', '$parse', 'NgMap'];

  angular.module('ngMap').directive('infoWindow', infoWindow);
})();

/**
 * @ngdoc directive
 * @name kml-layer
 * @param Attr2MapOptions {service} convert html attribute to Google map api options
 * @description
 *   renders Kml layer on a map
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @attr {Url} url url of the kml layer
 * @attr {KmlLayerOptions} KmlLayerOptions
 *   (https://developers.google.com/maps/documentation/javascript/reference#KmlLayerOptions) 
 * @attr {String} &lt;KmlLayerEvent> Any KmlLayer events,
 *   https://developers.google.com/maps/documentation/javascript/reference
 * @example
 * Usage:
 *   <map MAP_ATTRIBUTES>
 *    <kml-layer ANY_KML_LAYER ANY_KML_LAYER_EVENTS"></kml-layer>
 *   </map>
 *
 * Example:
 *
 * <map zoom="11" center="[41.875696,-87.624207]">
 *   <kml-layer url="https://gmaps-samples.googlecode.com/svn/trunk/ggeoxml/cta.kml" >
 *   </kml-layer>
 * </map>
 */
(function() {
  'use strict';

  angular.module('ngMap').directive('kmlLayer', [
    'Attr2MapOptions', function(Attr2MapOptions) {
    var parser = Attr2MapOptions;

    var getKmlLayer = function(options, events) {
      var kmlLayer = new google.maps.KmlLayer(options);
      for (var eventName in events) {
        google.maps.event.addListener(kmlLayer, eventName, events[eventName]);
      }
      return kmlLayer;
    };

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],

      link: function(scope, element, attrs, mapController) {
        mapController = mapController[0]||mapController[1];

        var orgAttrs = parser.orgAttributes(element);
        var filtered = parser.filter(attrs);
        var options = parser.getOptions(filtered, {scope: scope});
        var events = parser.getEvents(scope, filtered);
        void 0;

        var kmlLayer = getKmlLayer(options, events);
        mapController.addObject('kmlLayers', kmlLayer);
        mapController.observeAttrSetObj(orgAttrs, attrs, kmlLayer);  //observers
        element.bind('$destroy', function() {
          mapController.deleteObject('kmlLayers', kmlLayer);
        });
      }
     }; // return
  }]);
})();

/**
 * @ngdoc directive
 * @name map-data
 * @param Attr2MapOptions {service}
 *   convert html attribute to Google map api options
 * @description
 *   set map data
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @wn {String} method-name, run map.data[method-name] with attribute value
 * @example
 * Example:
 *
 *  <map zoom="11" center="[41.875696,-87.624207]">
 *    <map-data load-geo-json="https://storage.googleapis.com/maps-devrel/google.json"></map-data>
 *   </map>
 */
(function() {
  'use strict';

  angular.module('ngMap').directive('mapData', [
    'Attr2MapOptions', 'NgMap', function(Attr2MapOptions, NgMap) {
    var parser = Attr2MapOptions;
    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],

      link: function(scope, element, attrs, mapController) {
        mapController = mapController[0] || mapController[1];
        var filtered = parser.filter(attrs);
        var options = parser.getOptions(filtered, {scope: scope});
        var events = parser.getEvents(scope, filtered, events);

        void 0;
        NgMap.getMap(mapController.map.id).then(function(map) {
          //options
          for (var key in options) {
            var val = options[key];
            if (typeof scope[val] === "function") {
              map.data[key](scope[val]);
            } else {
              map.data[key](val);
            }
          }

          //events
          for (var eventName in events) {
            map.data.addListener(eventName, events[eventName]);
          }
        });
      }
     }; // return
  }]);
})();

/**
 * @ngdoc directive
 * @name map-lazy-load
 * @param Attr2Options {service} convert html attribute to Google map api options
 * @description
 *  Requires: Delay the initialization of map directive
 *    until the map is ready to be rendered
 *  Restrict To: Attribute
 *
 * @attr {String} map-lazy-load
 *    Maps api script source file location.
 *    Example:
 *      'https://maps.google.com/maps/api/js'
 * @attr {String} map-lazy-load-params
 *   Maps api script source file location via angular scope variable.
 *   Also requires the map-lazy-load attribute to be present in the directive.
 *   Example: In your controller, set
 *     $scope.googleMapsURL = 'https://maps.google.com/maps/api/js?v=3.20&client=XXXXXenter-api-key-hereXXXX'
 *
 * @example
 * Example:
 *
 *   <div map-lazy-load="http://maps.google.com/maps/api/js">
 *     <map center="Brampton" zoom="10">
 *       <marker position="Brampton"></marker>
 *     </map>
 *   </div>
 *
 *   <div map-lazy-load="http://maps.google.com/maps/api/js"
 *        map-lazy-load-params="{{googleMapsUrl}}">
 *     <map center="Brampton" zoom="10">
 *       <marker position="Brampton"></marker>
 *     </map>
 *   </div>
 */
/* global window, document */
(function() {
  'use strict';
  var $timeout, $compile, src, savedHtml = [], elements = [];

  var preLinkFunc = function(scope, element, attrs) {
    var mapsUrl = attrs.mapLazyLoadParams || attrs.mapLazyLoad;

    if(window.google === undefined || window.google.maps === undefined) {
      elements.push({
        scope: scope,
        element: element,
        savedHtml: savedHtml[elements.length],
      });

      window.lazyLoadCallback = function() {
        void 0;
        $timeout(function() { /* give some time to load */
          elements.forEach(function(elm) {
              elm.element.html(elm.savedHtml);
              $compile(elm.element.contents())(elm.scope);
          });
        }, 100);
      };

      var scriptEl = document.createElement('script');
      void 0;

      scriptEl.src = mapsUrl +
        (mapsUrl.indexOf('?') > -1 ? '&' : '?') +
        'callback=lazyLoadCallback';

        if (!document.querySelector('script[src="' + scriptEl.src + '"]')) {
          document.body.appendChild(scriptEl);
        }
    } else {
      element.html(savedHtml);
      $compile(element.contents())(scope);
    }
  };

  var compileFunc = function(tElement, tAttrs) {

    (!tAttrs.mapLazyLoad) && void 0;
    savedHtml.push(tElement.html());
    src = tAttrs.mapLazyLoad;

    /**
     * if already loaded, stop processing it
     */
    if(window.google !== undefined && window.google.maps !== undefined) {
      return false;
    }

    tElement.html('');  // will compile again after script is loaded

    return {
      pre: preLinkFunc
    };
  };

  var mapLazyLoad = function(_$compile_, _$timeout_) {
    $compile = _$compile_, $timeout = _$timeout_;
    return {
      compile: compileFunc
    };
  };
  mapLazyLoad.$inject = ['$compile','$timeout'];

  angular.module('ngMap').directive('mapLazyLoad', mapLazyLoad);
})();

/**
 * @ngdoc directive
 * @name map-type
 * @param Attr2MapOptions {service} 
 *   convert html attribute to Google map api options
 * @description
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @example
 * Example:
 *
 *   <map zoom="13" center="34.04924594193164, -118.24104309082031">
 *     <map-type name="coordinate" object="coordinateMapType"></map-type>
 *   </map>
 */
(function() {
  'use strict';

  angular.module('ngMap').directive('mapType', ['$parse', 'NgMap',
    function($parse, NgMap) {

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],

      link: function(scope, element, attrs, mapController) {
        mapController = mapController[0]||mapController[1];

        var mapTypeName = attrs.name, mapTypeObject;
        if (!mapTypeName) {
          throw "invalid map-type name";
        }
        mapTypeObject = $parse(attrs.object)(scope);
        if (!mapTypeObject) {
          throw "invalid map-type object";
        }

        NgMap.getMap().then(function(map) {
          map.mapTypes.set(mapTypeName, mapTypeObject);
        });
        mapController.addObject('mapTypes', mapTypeObject);
      }
     }; // return
  }]);
})();

/**
 * @ngdoc directive
 * @memberof ngMap
 * @name ng-map
 * @param Attr2Options {service}
 *  convert html attribute to Google map api options
 * @description
 * Implementation of {@link __MapController}
 * Initialize a Google map within a `<div>` tag
 *   with given options and register events
 *
 * @attr {Expression} map-initialized
 *   callback function when map is initialized
 *   e.g., map-initialized="mycallback(map)"
 * @attr {Expression} geo-callback if center is an address or current location,
 *   the expression is will be executed when geo-lookup is successful.
 *   e.g., geo-callback="showMyStoreInfo()"
 * @attr {Array} geo-fallback-center
 *   The center of map incase geolocation failed. i.e. [0,0]
 * @attr {Object} geo-location-options
 *  The navigator geolocation options.
 *  e.g., { maximumAge: 3000, timeout: 5000, enableHighAccuracy: true }.
 *  If none specified, { timeout: 5000 }.
 *  If timeout not specified, timeout: 5000 added
 * @attr {Boolean} zoom-to-include-markers
 *  When true, map boundary will be changed automatially
 *  to include all markers when initialized
 * @attr {Boolean} default-style
 *  When false, the default styling,
 *  `display:block;height:300px`, will be ignored.
 * @attr {String} &lt;MapOption> Any Google map options,
 *  https://developers.google.com/maps/documentation/javascript/reference?csw=1#MapOptions
 * @attr {String} &lt;MapEvent> Any Google map events,
 *  https://rawgit.com/allenhwkim/angularjs-google-maps/master/build/map_events.html
 * @attr {Boolean} single-info-window
 *  When true the map will only display one info window at the time,
 *  if not set or false,
 *  everytime an info window is open it will be displayed with the othe one.
 * @attr {Boolean} trigger-resize
 *  Default to false.  Set to true to trigger resize of the map.  Needs to be done anytime you resize the map
 * @example
 * Usage:
 *   <map MAP_OPTIONS_OR_MAP_EVENTS ..>
 *     ... Any children directives
 *   </map>
 *
 * Example:
 *   <map center="[40.74, -74.18]" on-click="doThat()">
 *   </map>
 *
 *   <map geo-fallback-center="[40.74, -74.18]" zoom-to-inlude-markers="true">
 *   </map>
 */
(function () {
  'use strict';

  var mapDirective = function () {
    return {
      restrict: 'AE',
      controller: '__MapController',
      controllerAs: 'ngmap'
    };
  };

  angular.module('ngMap').directive('map', [mapDirective]);
  angular.module('ngMap').directive('ngMap', [mapDirective]);
})();

/**
 * @ngdoc directive
 * @name maps-engine-layer
 * @description
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @example
 * Example:
 *  <map zoom="14" center="[59.322506, 18.010025]">
 *    <maps-engine-layer layer-id="06673056454046135537-08896501997766553811">
 *    </maps-engine-layer>
 *  </map>
 */
(function() {
  'use strict';

  angular.module('ngMap').directive('mapsEngineLayer', ['Attr2MapOptions', function(Attr2MapOptions) {
    var parser = Attr2MapOptions;

    var getMapsEngineLayer = function(options, events) {
      var layer = new google.maps.visualization.MapsEngineLayer(options);

      for (var eventName in events) {
        google.maps.event.addListener(layer, eventName, events[eventName]);
      }

      return layer;
    };

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],

      link: function(scope, element, attrs, mapController) {
        mapController = mapController[0]||mapController[1];

        var filtered = parser.filter(attrs);
        var options = parser.getOptions(filtered, {scope: scope});
        var events = parser.getEvents(scope, filtered, events);
        void 0;

        var layer = getMapsEngineLayer(options, events);
        mapController.addObject('mapsEngineLayers', layer);
      }
     }; // return
  }]);
})();

/**
 * @ngdoc directive
 * @name marker
 * @param Attr2Options {service} convert html attribute to Google map api options
 * @param NavigatorGeolocation It is used to find the current location
 * @description
 *  Draw a Google map marker on a map with given options and register events
 *
 *  Requires:  map directive
 *
 *  Restrict To:  Element
 *
 * @attr {String} position address, 'current', or [latitude, longitude]
 *  example:
 *    '1600 Pennsylvania Ave, 20500  Washingtion DC',
 *    'current position',
 *    '[40.74, -74.18]'
 * @attr {Boolean} centered if set, map will be centered with this marker
 * @attr {Expression} geo-callback if position is an address,
 *   the expression is will be performed when geo-lookup is successful.
 *   e.g., geo-callback="showStoreInfo()"
 * @attr {Boolean} no-watcher if true, no attribute observer is added.
 *   Useful for many ng-repeat
 * @attr {String} &lt;MarkerOption>
 *   [Any Marker options](https://developers.google.com/maps/documentation/javascript/reference?csw=1#MarkerOptions)
 * @attr {String} &lt;MapEvent>
 *   [Any Marker events](https://developers.google.com/maps/documentation/javascript/reference)
 * @example
 * Usage:
 *   <map MAP_ATTRIBUTES>
 *    <marker ANY_MARKER_OPTIONS ANY_MARKER_EVENTS"></MARKER>
 *   </map>
 *
 * Example:
 *   <map center="[40.74, -74.18]">
 *    <marker position="[40.74, -74.18]" on-click="myfunc()"></div>
 *   </map>
 *
 *   <map center="the cn tower">
 *    <marker position="the cn tower" on-click="myfunc()"></div>
 *   </map>
 */
/* global google */
(function() {
  'use strict';
  var parser, $parse, NgMap;

  var getMarker = function(options, events) {
    var marker;

    if (NgMap.defaultOptions.marker) {
      for (var key in NgMap.defaultOptions.marker) {
        if (typeof options[key] == 'undefined') {
          void 0;
          options[key] = NgMap.defaultOptions.marker[key];
        }
      }
    }

    if (!(options.position instanceof google.maps.LatLng)) {
      options.position = new google.maps.LatLng(0,0);
    }
    marker = new google.maps.Marker(options);

    /**
     * set events
     */
    if (Object.keys(events).length > 0) {
      void 0;
    }
    for (var eventName in events) {
      if (eventName) {
        google.maps.event.addListener(marker, eventName, events[eventName]);
      }
    }

    return marker;
  };

  var linkFunc = function(scope, element, attrs, mapController) {
    mapController = mapController[0]||mapController[1];

    var orgAttrs = parser.orgAttributes(element);
    var filtered = parser.filter(attrs);
    var markerOptions = parser.getOptions(filtered, scope, {scope: scope});
    var markerEvents = parser.getEvents(scope, filtered);
    void 0;

    var address;
    if (!(markerOptions.position instanceof google.maps.LatLng)) {
      address = markerOptions.position;
    }
    var marker = getMarker(markerOptions, markerEvents);
    mapController.addObject('markers', marker);
    if (address) {
      NgMap.getGeoLocation(address).then(function(latlng) {
        marker.setPosition(latlng);
        markerOptions.centered && marker.map.setCenter(latlng);
        var geoCallback = attrs.geoCallback;
        geoCallback && $parse(geoCallback)(scope);
      });
    }

    //set observers
    mapController.observeAttrSetObj(orgAttrs, attrs, marker); /* observers */

    element.bind('$destroy', function() {
      mapController.deleteObject('markers', marker);
    });
  };

  var marker = function(Attr2MapOptions, _$parse_, _NgMap_) {
    parser = Attr2MapOptions;
    $parse = _$parse_;
    NgMap = _NgMap_;

    return {
      restrict: 'E',
      require: ['^?map','?^ngMap'],
      link: linkFunc
    };
  };

  marker.$inject = ['Attr2MapOptions', '$parse', 'NgMap'];
  angular.module('ngMap').directive('marker', marker);

})();

/**
 * @ngdoc directive
 * @name overlay-map-type
 * @param Attr2MapOptions {service} convert html attribute to Google map api options
 * @param $window {service}
 * @description
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @example
 * Example:
 *
 * <map zoom="13" center="34.04924594193164, -118.24104309082031">
 *   <overlay-map-type index="0" object="coordinateMapType"></map-type>
 * </map>
 */
(function() {
  'use strict';

  angular.module('ngMap').directive('overlayMapType', [
    'NgMap', function(NgMap) {

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],

      link: function(scope, element, attrs, mapController) {
        mapController = mapController[0]||mapController[1];

        var initMethod = attrs.initMethod || "insertAt";
        var overlayMapTypeObject = scope[attrs.object];

        NgMap.getMap().then(function(map) {
          if (initMethod == "insertAt") {
            var index = parseInt(attrs.index, 10);
            map.overlayMapTypes.insertAt(index, overlayMapTypeObject);
          } else if (initMethod == "push") {
            map.overlayMapTypes.push(overlayMapTypeObject);
          }
        });
        mapController.addObject('overlayMapTypes', overlayMapTypeObject);
      }
     }; // return
  }]);
})();

/**
 * @ngdoc directive
 * @name places-auto-complete
 * @param Attr2MapOptions {service} convert html attribute to Google map api options
 * @description
 *   Provides address auto complete feature to an input element
 *   Requires: input tag
 *   Restrict To: Attribute
 *
 * @attr {AutoCompleteOptions}
 *   [Any AutocompleteOptions](https://developers.google.com/maps/documentation/javascript/3.exp/reference#AutocompleteOptions)
 *
 * @example
 * Example:
 *   <script src="https://maps.googleapis.com/maps/api/js?libraries=places"></script>
 *   <input places-auto-complete types="['geocode']" on-place-changed="myCallback(place)" component-restrictions="{country:'au'}"/>
 */
/* global google */
(function() {
  'use strict';

  var placesAutoComplete = function(Attr2MapOptions, $timeout) {
    var parser = Attr2MapOptions;

    var linkFunc = function(scope, element, attrs, ngModelCtrl) {
      if (attrs.placesAutoComplete ==='false') {
        return false;
      }
      var filtered = parser.filter(attrs);
      var options = parser.getOptions(filtered, {scope: scope});
      var events = parser.getEvents(scope, filtered);
      var autocomplete = new google.maps.places.Autocomplete(element[0], options);
      for (var eventName in events) {
        google.maps.event.addListener(autocomplete, eventName, events[eventName]);
      }

      var updateModel = function() {
        $timeout(function(){
          ngModelCtrl && ngModelCtrl.$setViewValue(element.val());
        },100);
      };
      google.maps.event.addListener(autocomplete, 'place_changed', updateModel);
      element[0].addEventListener('change', updateModel);

      attrs.$observe('types', function(val) {
        if (val) {
          var optionValue = parser.toOptionValue(val, {key: 'types'});
          autocomplete.setTypes(optionValue);
        }
      });
	  
	  attrs.$observe('componentRestrictions', function (val) {
		 if (val) {
		   autocomplete.setComponentRestrictions(scope.$eval(val));
		 }
	   });
    };
	
    return {
      restrict: 'A',
      require: '?ngModel',
      link: linkFunc
    };
  };

  placesAutoComplete.$inject = ['Attr2MapOptions', '$timeout'];
  angular.module('ngMap').directive('placesAutoComplete', placesAutoComplete);
})();

/**
 * @ngdoc directive
 * @name shape
 * @param Attr2MapOptions {service} convert html attribute to Google map api options
 * @description
 *   Initialize a Google map shape in map with given options and register events
 *   The shapes are:
 *     . circle
 *     . polygon
 *     . polyline
 *     . rectangle
 *     . groundOverlay(or image)
 *
 *   Requires:  map directive
 *
 *   Restrict To:  Element
 *
 * @attr {Boolean} centered if set, map will be centered with this marker
 * @attr {Expression} geo-callback if shape is a circle and the center is
 *   an address, the expression is will be performed when geo-lookup
 *   is successful. e.g., geo-callback="showDetail()"
 * @attr {String} &lt;OPTIONS>
 *   For circle, [any circle options](https://developers.google.com/maps/documentation/javascript/reference#CircleOptions)
 *   For polygon, [any polygon options](https://developers.google.com/maps/documentation/javascript/reference#PolygonOptions)
 *   For polyline, [any polyline options](https://developers.google.com/maps/documentation/javascript/reference#PolylineOptions)
 *   For rectangle, [any rectangle options](https://developers.google.com/maps/documentation/javascript/reference#RectangleOptions)
 *   For image, [any groundOverlay options](https://developers.google.com/maps/documentation/javascript/reference#GroundOverlayOptions)
 * @attr {String} &lt;MapEvent> [Any Shape events](https://developers.google.com/maps/documentation/javascript/reference)
 * @example
 * Usage:
 *   <map MAP_ATTRIBUTES>
 *    <shape name=SHAPE_NAME ANY_SHAPE_OPTIONS ANY_SHAPE_EVENTS"></MARKER>
 *   </map>
 *
 * Example:
 *
 *   <map zoom="11" center="[40.74, -74.18]">
 *     <shape id="polyline" name="polyline" geodesic="true"
 *       stroke-color="#FF0000" stroke-opacity="1.0" stroke-weight="2"
 *       path="[[40.74,-74.18],[40.64,-74.10],[40.54,-74.05],[40.44,-74]]" >
 *     </shape>
 *   </map>
 *
 *   <map zoom="11" center="[40.74, -74.18]">
 *     <shape id="polygon" name="polygon" stroke-color="#FF0000"
 *       stroke-opacity="1.0" stroke-weight="2"
 *       paths="[[40.74,-74.18],[40.64,-74.18],[40.84,-74.08],[40.74,-74.18]]" >
 *     </shape>
 *   </map>
 *
 *   <map zoom="11" center="[40.74, -74.18]">
 *     <shape id="rectangle" name="rectangle" stroke-color='#FF0000'
 *       stroke-opacity="0.8" stroke-weight="2"
 *       bounds="[[40.74,-74.18], [40.78,-74.14]]" editable="true" >
 *     </shape>
 *   </map>
 *
 *   <map zoom="11" center="[40.74, -74.18]">
 *     <shape id="circle" name="circle" stroke-color='#FF0000'
 *       stroke-opacity="0.8"stroke-weight="2"
 *       center="[40.70,-74.14]" radius="4000" editable="true" >
 *     </shape>
 *   </map>
 *
 *   <map zoom="11" center="[40.74, -74.18]">
 *     <shape id="image" name="image"
 *       url="https://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg"
 *       bounds="[[40.71,-74.22],[40.77,-74.12]]" opacity="0.7"
 *       clickable="true">
 *     </shape>
 *   </map>
 *
 *  For full-working example, please visit
 *    [shape example](https://rawgit.com/allenhwkim/angularjs-google-maps/master/build/shape.html)
 */
/* global google */
(function() {
  'use strict';

  var getShape = function(options, events) {
    var shape;

    var shapeName = options.name;
    delete options.name;  //remove name bcoz it's not for options
    void 0;

    /**
     * set options
     */
    switch(shapeName) {
      case "circle":
        if (!(options.center instanceof google.maps.LatLng)) {
          options.center = new google.maps.LatLng(0,0);
        } 
        shape = new google.maps.Circle(options);
        break;
      case "polygon":
        shape = new google.maps.Polygon(options);
        break;
      case "polyline":
        shape = new google.maps.Polyline(options);
        break;
      case "rectangle":
        shape = new google.maps.Rectangle(options);
        break;
      case "groundOverlay":
      case "image":
        var url = options.url;
        var opts = {opacity: options.opacity, clickable: options.clickable, id:options.id};
        shape = new google.maps.GroundOverlay(url, options.bounds, opts);
        break;
    }

    /**
     * set events
     */
    for (var eventName in events) {
      if (events[eventName]) {
        google.maps.event.addListener(shape, eventName, events[eventName]);
      }
    }
    return shape;
  };

  var shape = function(Attr2MapOptions, $parse, NgMap) {
    var parser = Attr2MapOptions;

    var linkFunc = function(scope, element, attrs, mapController) {
      mapController = mapController[0]||mapController[1];

      var orgAttrs = parser.orgAttributes(element);
      var filtered = parser.filter(attrs);
      var shapeOptions = parser.getOptions(filtered, {scope: scope});
      var shapeEvents = parser.getEvents(scope, filtered);

      var address, shapeType;
      shapeType = shapeOptions.name;
      if (!(shapeOptions.center instanceof google.maps.LatLng)) {
        address = shapeOptions.center;
      }
      var shape = getShape(shapeOptions, shapeEvents);
      mapController.addObject('shapes', shape);

      if (address && shapeType == 'circle') {
        NgMap.getGeoLocation(address).then(function(latlng) {
          shape.setCenter(latlng);
          shape.centered && shape.map.setCenter(latlng);
          var geoCallback = attrs.geoCallback;
          geoCallback && $parse(geoCallback)(scope);
        });
      }

      //set observers
      mapController.observeAttrSetObj(orgAttrs, attrs, shape);
      element.bind('$destroy', function() {
        mapController.deleteObject('shapes', shape);
      });
    };

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],
      link: linkFunc
     }; // return
  };
  shape.$inject = ['Attr2MapOptions', '$parse', 'NgMap'];

  angular.module('ngMap').directive('shape', shape);

})();

/**
 * @ngdoc directive
 * @name streetview-panorama
 * @param Attr2MapOptions {service} convert html attribute to Google map api options
 * @description
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @attr container Optional, id or css selector, if given, streetview will be in the given html element
 * @attr {String} &lt;StreetViewPanoramaOption>
 *   [Any Google StreetViewPanorama options](https://developers.google.com/maps/documentation/javascript/reference?csw=1#StreetViewPanoramaOptions)
 * @attr {String} &lt;StreetViewPanoramaEvent>
 *   [Any Google StreetViewPanorama events](https://developers.google.com/maps/documentation/javascript/reference#StreetViewPanorama)
 *
 * @example
 *   <map zoom="11" center="[40.688738,-74.043871]" >
 *     <street-view-panorama
 *       click-to-go="true"
 *       disable-default-ui="true"
 *       disable-double-click-zoom="true"
 *       enable-close-button="true"
 *       pano="my-pano"
 *       position="40.688738,-74.043871"
 *       pov="{heading:0, pitch: 90}"
 *       scrollwheel="false"
 *       visible="true">
 *     </street-view-panorama>
 *   </map>
 */
/* global google, document */
(function() {
  'use strict';

  var streetViewPanorama = function(Attr2MapOptions, NgMap) {
    var parser = Attr2MapOptions;

    var getStreetViewPanorama = function(map, options, events) {
      var svp, container;
      if (options.container) {
        container = document.getElementById(options.container);
        container = container || document.querySelector(options.container);
      }
      if (container) {
        svp = new google.maps.StreetViewPanorama(container, options);
      } else {
        svp = map.getStreetView();
        svp.setOptions(options);
      }

      for (var eventName in events) {
        eventName &&
          google.maps.event.addListener(svp, eventName, events[eventName]);
      }
      return svp;
    };

    var linkFunc = function(scope, element, attrs) {
      var filtered = parser.filter(attrs);
      var options = parser.getOptions(filtered, {scope: scope});
      var controlOptions = parser.getControlOptions(filtered);
      var svpOptions = angular.extend(options, controlOptions);

      var svpEvents = parser.getEvents(scope, filtered);
      void 0;

      NgMap.getMap().then(function(map) {
        var svp = getStreetViewPanorama(map, svpOptions, svpEvents);

        map.setStreetView(svp);
        (!svp.getPosition()) && svp.setPosition(map.getCenter());
        google.maps.event.addListener(svp, 'position_changed', function() {
          if (svp.getPosition() !== map.getCenter()) {
            map.setCenter(svp.getPosition());
          }
        });
        //needed for geo-callback
        var listener =
          google.maps.event.addListener(map, 'center_changed', function() {
            svp.setPosition(map.getCenter());
            google.maps.event.removeListener(listener);
          });
      });

    }; //link

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],
      link: linkFunc
    };

  };
  streetViewPanorama.$inject = ['Attr2MapOptions', 'NgMap'];

  angular.module('ngMap').directive('streetViewPanorama', streetViewPanorama);
})();

/**
 * @ngdoc directive
 * @name traffic-layer
 * @param Attr2MapOptions {service} convert html attribute to Google map api options
 * @description
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @example
 * Example:
 *
 *   <map zoom="13" center="34.04924594193164, -118.24104309082031">
 *     <traffic-layer></traffic-layer>
 *    </map>
 */
(function() {
  'use strict';

  angular.module('ngMap').directive('trafficLayer', [
    'Attr2MapOptions', function(Attr2MapOptions) {
    var parser = Attr2MapOptions;

    var getLayer = function(options, events) {
      var layer = new google.maps.TrafficLayer(options);
      for (var eventName in events) {
        google.maps.event.addListener(layer, eventName, events[eventName]);
      }
      return layer;
    };

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],

      link: function(scope, element, attrs, mapController) {
        mapController = mapController[0]||mapController[1];

        var orgAttrs = parser.orgAttributes(element);
        var filtered = parser.filter(attrs);
        var options = parser.getOptions(filtered, {scope: scope});
        var events = parser.getEvents(scope, filtered);
        void 0;

        var layer = getLayer(options, events);
        mapController.addObject('trafficLayers', layer);
        mapController.observeAttrSetObj(orgAttrs, attrs, layer);  //observers
        element.bind('$destroy', function() {
          mapController.deleteObject('trafficLayers', layer);
        });
      }
     }; // return
  }]);
})();

/**
 * @ngdoc directive
 * @name transit-layer
 * @param Attr2MapOptions {service} convert html attribute to Google map api options
 * @description
 *   Requires:  map directive
 *   Restrict To:  Element
 *
 * @example
 * Example:
 *
 *  <map zoom="13" center="34.04924594193164, -118.24104309082031">
 *    <transit-layer></transit-layer>
 *  </map>
 */
(function() {
  'use strict';

  angular.module('ngMap').directive('transitLayer', [
    'Attr2MapOptions', function(Attr2MapOptions) {
    var parser = Attr2MapOptions;

    var getLayer = function(options, events) {
      var layer = new google.maps.TransitLayer(options);
      for (var eventName in events) {
        google.maps.event.addListener(layer, eventName, events[eventName]);
      }
      return layer;
    };

    return {
      restrict: 'E',
      require: ['?^map','?^ngMap'],

      link: function(scope, element, attrs, mapController) {
        mapController = mapController[0]||mapController[1];

        var orgAttrs = parser.orgAttributes(element);
        var filtered = parser.filter(attrs);
        var options = parser.getOptions(filtered, {scope: scope});
        var events = parser.getEvents(scope, filtered);
        void 0;

        var layer = getLayer(options, events);
        mapController.addObject('transitLayers', layer);
        mapController.observeAttrSetObj(orgAttrs, attrs, layer);  //observers
        element.bind('$destroy', function() {
          mapController.deleteObject('transitLayers', layer);
        });
      }
     }; // return
  }]);
})();

/**
 * @ngdoc filter
 * @name camel-case
 * @description
 *   Converts string to camel cased
 */
(function() {
  'use strict';

  var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
  var MOZ_HACK_REGEXP = /^moz([A-Z])/;

  var camelCaseFilter = function() {
    return function(name) {
      return name.
        replace(SPECIAL_CHARS_REGEXP,
          function(_, separator, letter, offset) {
            return offset ? letter.toUpperCase() : letter;
        }).
        replace(MOZ_HACK_REGEXP, 'Moz$1');
    };
  };

  angular.module('ngMap').filter('camelCase', camelCaseFilter);
})();

/**
 * @ngdoc filter
 * @name escape-regex
 * @description
 *   Escapes all regex special characters in a string
 */
(function() {
  'use strict';



  var escapeRegexpFilter = function() {
    return function(string) {
			return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
		};
  };

  angular.module('ngMap').filter('escapeRegexp', escapeRegexpFilter);
})();

/**
 * @ngdoc filter
 * @name jsonize
 * @description
 *   Converts json-like string to json string
 */
(function() {
  'use strict';

  var jsonizeFilter = function() {
    return function(str) {
      try {       // if parsable already, return as it is
        JSON.parse(str);
        return str;
      } catch(e) { // if not parsable, change little
        return str
          // wrap keys without quote with valid double quote
          .replace(/([\$\w]+)\s*:/g,
            function(_, $1) {
              return '"'+$1+'":';
            }
          )
          // replacing single quote wrapped ones to double quote
          .replace(/'([^']+)'/g,
            function(_, $1) {
              return '"'+$1+'"';
            }
          )
          .replace(/''/g, '""');
      }
    };
  };

  angular.module('ngMap').filter('jsonize', jsonizeFilter);
})();

/**
 * @ngdoc service
 * @name Attr2MapOptions
 * @description
 *   Converts tag attributes to options used by google api v3 objects
 */
/* global google */
(function() {
  'use strict';

  //i.e. "2015-08-12T06:12:40.858Z"
  var isoDateRE =
    /^(\d{4}\-\d\d\-\d\d([tT][\d:\.]*)?)([zZ]|([+\-])(\d\d):?(\d\d))?$/;

  var Attr2MapOptions = function(
      $parse, $timeout, $log, $interpolate, NavigatorGeolocation, GeoCoder,
      camelCaseFilter, jsonizeFilter, escapeRegExp
    ) {

    var exprStartSymbol = $interpolate.startSymbol();
    var exprEndSymbol = $interpolate.endSymbol();

    /**
     * Returns the attributes of an element as hash
     * @memberof Attr2MapOptions
     * @param {HTMLElement} el html element
     * @returns {Hash} attributes
     */
    var orgAttributes = function(el) {
      (el.length > 0) && (el = el[0]);
      var orgAttributes = {};
      for (var i=0; i<el.attributes.length; i++) {
        var attr = el.attributes[i];
        orgAttributes[attr.name] = attr.value;
      }
      return orgAttributes;
    };

    var getJSON = function(input) {
      var re =/^[\+\-]?[0-9\.]+,[ ]*\ ?[\+\-]?[0-9\.]+$/; //lat,lng
      if (input.match(re)) {
        input = "["+input+"]";
      }
      return JSON.parse(jsonizeFilter(input));
    };
    
    var getLatLng = function(input) {
      var output = input;
      if (input[0].constructor == Array) { 
        if ((input[0][0].constructor == Array && input[0][0].length == 2) || input[0][0].constructor == Object) {
            var preoutput;
            var outputArray = [];
            for (var i = 0; i < input.length; i++) {
                preoutput = input[i].map(function(el){
                    return new google.maps.LatLng(el[0], el[1]);
                });
                outputArray.push(preoutput);
            }
            output = outputArray;
        } else {
            output = input.map(function(el) {
                return new google.maps.LatLng(el[0], el[1]);
            });
        }
      } else if (!isNaN(parseFloat(input[0])) && isFinite(input[0])) {
        output = new google.maps.LatLng(output[0], output[1]);
      }
      return output;
    };

    var toOptionValue = function(input, options) {
      var output;
      try { // 1. Number?
        output = getNumber(input);
      } catch(err) {
        try { // 2. JSON?
          var output = getJSON(input);
          if (output instanceof Array) {
            if (output[0].constructor == Object) {
              output = output;
            } else if (output[0] instanceof Array) {
              if (output[0][0].constructor == Object) {
                output = output;
              } else {
                output = getLatLng(output);
              }
            } else {
                output = getLatLng(output);
            }
          }
          // JSON is an object (not array or null)
          else if (output === Object(output)) {
            // check for nested hashes and convert to Google API options
            var newOptions = options;
            newOptions.doNotConverStringToNumber = true;
            output = getOptions(output, newOptions);
          }
        } catch(err2) {
          // 3. Google Map Object function Expression. i.e. LatLng(80,-49)
          if (input.match(/^[A-Z][a-zA-Z0-9]+\(.*\)$/)) {
            try {
              var exp = "new google.maps."+input;
              output = eval(exp); /* jshint ignore:line */
            } catch(e) {
              output = input;
            }
          // 4. Google Map Object constant Expression. i.e. MayTypeId.HYBRID
          } else if (input.match(/^([A-Z][a-zA-Z0-9]+)\.([A-Z]+)$/)) {
            try {
              var matches = input.match(/^([A-Z][a-zA-Z0-9]+)\.([A-Z]+)$/);
              output = google.maps[matches[1]][matches[2]];
            } catch(e) {
              output = input;
            }
          // 5. Google Map Object constant Expression. i.e. HYBRID
          } else if (input.match(/^[A-Z]+$/)) {
            try {
              var capitalizedKey = options.key.charAt(0).toUpperCase() +
                options.key.slice(1);
              if (options.key.match(/temperatureUnit|windSpeedUnit|labelColor/)) {
                capitalizedKey = capitalizedKey.replace(/s$/,"");
                output = google.maps.weather[capitalizedKey][input];
              } else {
                output = google.maps[capitalizedKey][input];
              }
            } catch(e) {
              output = input;
            }
          // 6. Date Object as ISO String
          } else if (input.match(isoDateRE)) {
            try {
              output = new Date(input);
            } catch(e) {
              output = input;
            }
          // 7. evaluate dynamically bound values
        } else if (input.match(new RegExp('^' + escapeRegExp(exprStartSymbol))) && options.scope) {
            try {
              var expr = input.replace(new RegExp(escapeRegExp(exprStartSymbol)),'').replace(new RegExp(escapeRegExp(exprEndSymbol), 'g'),'');
              output = options.scope.$eval(expr);
            } catch (err) {
              output = input;
            }
          } else {
            output = input;
          }
        } // catch(err2)
      } // catch(err)

      // convert output more for center and position
      if (
        (options.key == 'center' || options.key == 'position') &&
        output instanceof Array
      ) {
        output = new google.maps.LatLng(output[0], output[1]);
      }

      // convert output more for shape bounds
      if (options.key == 'bounds' && output instanceof Array) {
        output = new google.maps.LatLngBounds(output[0], output[1]);
      }

      // convert output more for shape icons
      if (options.key == 'icons' && output instanceof Array) {

        for (var i=0; i<output.length; i++) {
          var el = output[i];
          if (el.icon.path.match(/^[A-Z_]+$/)) {
            el.icon.path =  google.maps.SymbolPath[el.icon.path];
          }
        }
      }

      // convert output more for marker icon
      if (options.key == 'icon' && output instanceof Object) {
        if ((""+output.path).match(/^[A-Z_]+$/)) {
          output.path = google.maps.SymbolPath[output.path];
        }
        for (var key in output) { //jshint ignore:line
          var arr = output[key];
          if (key == "anchor" || key == "origin" || key == "labelOrigin") {
            output[key] = new google.maps.Point(arr[0], arr[1]);
          } else if (key == "size" || key == "scaledSize") {
            output[key] = new google.maps.Size(arr[0], arr[1]);
          }
        }
      }

      return output;
    };

    var getAttrsToObserve = function(attrs) {
      var attrsToObserve = [];
      var exprRegExp = new RegExp(escapeRegExp(exprStartSymbol) + '.*' + escapeRegExp(exprEndSymbol), 'g');

      if (!attrs.noWatcher) {
        for (var attrName in attrs) { //jshint ignore:line
          var attrValue = attrs[attrName];
          if (attrValue && attrValue.match(exprRegExp)) { // if attr value is {{..}}
            attrsToObserve.push(camelCaseFilter(attrName));
          }
        }
      }

      return attrsToObserve;
    };

    /**
     * filters attributes by skipping angularjs methods $.. $$..
     * @memberof Attr2MapOptions
     * @param {Hash} attrs tag attributes
     * @returns {Hash} filterd attributes
     */
    var filter = function(attrs) {
      var options = {};
      for(var key in attrs) {
        if (key.match(/^\$/) || key.match(/^ng[A-Z]/)) {
          void(0);
        } else {
          options[key] = attrs[key];
        }
      }
      return options;
    };

    /**
     * converts attributes hash to Google Maps API v3 options
     * ```
     *  . converts numbers to number
     *  . converts class-like string to google maps instance
     *    i.e. `LatLng(1,1)` to `new google.maps.LatLng(1,1)`
     *  . converts constant-like string to google maps constant
     *    i.e. `MapTypeId.HYBRID` to `google.maps.MapTypeId.HYBRID`
     *    i.e. `HYBRID"` to `google.maps.MapTypeId.HYBRID`
     * ```
     * @memberof Attr2MapOptions
     * @param {Hash} attrs tag attributes
     * @param {Hash} options
     * @returns {Hash} options converted attributess
     */
    var getOptions = function(attrs, params) {
      params = params || {};
      var options = {};
      for(var key in attrs) {
        if (attrs[key] || attrs[key] === 0) {
          if (key.match(/^on[A-Z]/)) { //skip events, i.e. on-click
            continue;
          } else if (key.match(/ControlOptions$/)) { // skip controlOptions
            continue;
          } else {
            // nested conversions need to be typechecked
            // (non-strings are fully converted)
            if (typeof attrs[key] !== 'string') {
              options[key] = attrs[key];
            } else {
              if (params.doNotConverStringToNumber &&
                attrs[key].match(/^[0-9]+$/)
              ) {
                options[key] = attrs[key];
              } else {
                options[key] = toOptionValue(attrs[key], {key: key, scope: params.scope});
              }
            }
          }
        } // if (attrs[key])
      } // for(var key in attrs)
      return options;
    };

    /**
     * converts attributes hash to scope-specific event function
     * @memberof Attr2MapOptions
     * @param {scope} scope angularjs scope
     * @param {Hash} attrs tag attributes
     * @returns {Hash} events converted events
     */
    var getEvents = function(scope, attrs) {
      var events = {};
      var toLowercaseFunc = function($1){
        return "_"+$1.toLowerCase();
      };
      var EventFunc = function(attrValue) {
        // funcName(argsStr)
        var matches = attrValue.match(/([^\(]+)\(([^\)]*)\)/);
        var funcName = matches[1];
        var argsStr = matches[2].replace(/event[ ,]*/,'');  //remove string 'event'
        var argsExpr = $parse("["+argsStr+"]"); //for perf when triggering event
        return function(event) {
          var args = argsExpr(scope); //get args here to pass updated model values
          function index(obj,i) {return obj[i];}
          var f = funcName.split('.').reduce(index, scope);
          f && f.apply(this, [event].concat(args));
          $timeout( function() {
            scope.$apply();
          });
        };
      };

      for(var key in attrs) {
        if (attrs[key]) {
          if (!key.match(/^on[A-Z]/)) { //skip if not events
            continue;
          }

          //get event name as underscored. i.e. zoom_changed
          var eventName = key.replace(/^on/,'');
          eventName = eventName.charAt(0).toLowerCase() + eventName.slice(1);
          eventName = eventName.replace(/([A-Z])/g, toLowercaseFunc);

          var attrValue = attrs[key];
          events[eventName] = new EventFunc(attrValue);
        }
      }
      return events;
    };

    /**
     * control means map controls, i.e streetview, pan, etc, not a general control
     * @memberof Attr2MapOptions
     * @param {Hash} filtered filtered tag attributes
     * @returns {Hash} Google Map options
     */
    var getControlOptions = function(filtered) {
      var controlOptions = {};
      if (typeof filtered != 'object') {
        return false;
      }

      for (var attr in filtered) {
        if (filtered[attr]) {
          if (!attr.match(/(.*)ControlOptions$/)) {
            continue; // if not controlOptions, skip it
          }

          //change invalid json to valid one, i.e. {foo:1} to {"foo": 1}
          var orgValue = filtered[attr];
          var newValue = orgValue.replace(/'/g, '"');
          newValue = newValue.replace(/([^"]+)|("[^"]+")/g, function($0, $1, $2) {
            if ($1) {
              return $1.replace(/([a-zA-Z0-9]+?):/g, '"$1":');
            } else {
              return $2;
            }
          });
          try {
            var options = JSON.parse(newValue);
            for (var key in options) { //assign the right values
              if (options[key]) {
                var value = options[key];
                if (typeof value === 'string') {
                  value = value.toUpperCase();
                } else if (key === "mapTypeIds") {
                  value = value.map( function(str) {
                    if (str.match(/^[A-Z]+$/)) { // if constant
                      return google.maps.MapTypeId[str.toUpperCase()];
                    } else { // else, custom map-type
                      return str;
                    }
                  });
                }

                if (key === "style") {
                  var str = attr.charAt(0).toUpperCase() + attr.slice(1);
                  var objName = str.replace(/Options$/,'')+"Style";
                  options[key] = google.maps[objName][value];
                } else if (key === "position") {
                  options[key] = google.maps.ControlPosition[value];
                } else {
                  options[key] = value;
                }
              }
            }
            controlOptions[attr] = options;
          } catch (e) {
            void 0;
          }
        }
      } // for

      return controlOptions;
    };

    return {
      filter: filter,
      getOptions: getOptions,
      getEvents: getEvents,
      getControlOptions: getControlOptions,
      toOptionValue: toOptionValue,
      getAttrsToObserve: getAttrsToObserve,
      orgAttributes: orgAttributes
    }; // return

  };
  Attr2MapOptions.$inject= [
    '$parse', '$timeout', '$log', '$interpolate', 'NavigatorGeolocation', 'GeoCoder',
    'camelCaseFilter', 'jsonizeFilter', 'escapeRegexpFilter'
  ];

  angular.module('ngMap').service('Attr2MapOptions', Attr2MapOptions);
})();

/**
 * @ngdoc service
 * @name GeoCoder
 * @description
 *   Provides [defered/promise API](https://docs.angularjs.org/api/ng/service/$q)
 *   service for Google Geocoder service
 */
(function() {
  'use strict';
  var $q;
  /**
   * @memberof GeoCoder
   * @param {Hash} options
   *   https://developers.google.com/maps/documentation/geocoding/#geocoding
   * @example
   * ```
   *   GeoCoder.geocode({address: 'the cn tower'}).then(function(result) {
   *     //... do something with result
   *   });
   * ```
   * @returns {HttpPromise} Future object
   */
  var geocodeFunc = function(options) {
    var deferred = $q.defer();
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode(options, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        deferred.resolve(results);
      } else {
        deferred.reject(status);
      }
    });
    return deferred.promise;
  };

  var GeoCoder = function(_$q_) {
    $q = _$q_;
    return {
      geocode : geocodeFunc
    };
  };
  GeoCoder.$inject = ['$q'];

  angular.module('ngMap').service('GeoCoder', GeoCoder);
})();

/**
 * @ngdoc service
 * @name GoogleMapsApi
 * @description
 *   Load Google Maps API Service
 */
(function() {
  'use strict';
  var $q;
  var $timeout;

  var GoogleMapsApi = function(_$q_, _$timeout_) {
    $q = _$q_;
    $timeout = _$timeout_;

    return {

      /**
       * Load google maps into document by creating a script tag
       * @memberof GoogleMapsApi
       * @param {string} mapsUrl
       * @example
       *   GoogleMapsApi.load(myUrl).then(function() {
       *     console.log('google map has been loaded')
       *   });
       */
      load: function (mapsUrl) {

        var deferred = $q.defer();

        if (window.google === undefined || window.google.maps === undefined) {

          window.lazyLoadCallback = function() {
            $timeout(function() { /* give some time to load */
              deferred.resolve(window.google)
            }, 100);
          };

          var scriptEl = document.createElement('script');
          scriptEl.src = mapsUrl +
            (mapsUrl.indexOf('?') > -1 ? '&' : '?') +
            'callback=lazyLoadCallback';

          if (!document.querySelector('script[src="' + scriptEl.src + '"]')) {
            document.body.appendChild(scriptEl);
          }
        } else {
          deferred.resolve(window.google)
        }

        return deferred.promise;
      }

    }
  }
  GoogleMapsApi.$inject = ['$q', '$timeout'];

  angular.module('ngMap').service('GoogleMapsApi', GoogleMapsApi);
})();



/**
 * @ngdoc service
 * @name NavigatorGeolocation
 * @description
 *  Provides [defered/promise API](https://docs.angularjs.org/api/ng/service/$q)
 *  service for navigator.geolocation methods
 */
/* global google */
(function() {
  'use strict';
  var $q;

  /**
   * @memberof NavigatorGeolocation
   * @param {Object} geoLocationOptions the navigator geolocations options.
   *  i.e. { maximumAge: 3000, timeout: 5000, enableHighAccuracy: true }.
   *  If none specified, { timeout: 5000 }. 
   *  If timeout not specified, timeout: 5000 added
   * @param {function} success success callback function
   * @param {function} failure failure callback function
   * @example
   * ```
   *  NavigatorGeolocation.getCurrentPosition()
   *    .then(function(position) {
   *      var lat = position.coords.latitude, lng = position.coords.longitude;
   *      .. do something lat and lng
   *    });
   * ```
   * @returns {HttpPromise} Future object
   */
  var getCurrentPosition = function(geoLocationOptions) {
    var deferred = $q.defer();
    if (navigator.geolocation) {

      if (geoLocationOptions === undefined) {
        geoLocationOptions = { timeout: 5000 };
      }
      else if (geoLocationOptions.timeout === undefined) {
        geoLocationOptions.timeout = 5000;
      }

      navigator.geolocation.getCurrentPosition(
        function(position) {
          deferred.resolve(position);
        }, function(evt) {
          void 0;
          deferred.reject(evt);
        },
        geoLocationOptions
      );
    } else {
      deferred.reject("Browser Geolocation service failed.");
    }
    return deferred.promise;
  };

  var NavigatorGeolocation = function(_$q_) {
    $q = _$q_;
    return {
      getCurrentPosition: getCurrentPosition
    };
  };
  NavigatorGeolocation.$inject = ['$q'];

  angular.module('ngMap').
    service('NavigatorGeolocation', NavigatorGeolocation);
})();

/**
 * @ngdoc factory
 * @name NgMapPool
 * @description
 *   Provide map instance to avoid memory leak
 */
(function() {
  'use strict';
  /**
   * @memberof NgMapPool
   * @desc map instance pool
   */
  var mapInstances = [];
  var $window, $document, $timeout;

  var add = function(el) {
    var mapDiv = $document.createElement("div");
    mapDiv.style.width = "100%";
    mapDiv.style.height = "100%";
    el.appendChild(mapDiv);
    var map = new $window.google.maps.Map(mapDiv, {});
    mapInstances.push(map);
    return map;
  };

  var findById = function(el, id) {
    var notInUseMap;
    for (var i=0; i<mapInstances.length; i++) {
      var map = mapInstances[i];
      if (map.id == id && !map.inUse) {
        var mapDiv = map.getDiv();
        el.appendChild(mapDiv);
        notInUseMap = map;
        break;
      }
    }
    return notInUseMap;
  };

  var findUnused = function(el) { //jshint ignore:line
    var notInUseMap;
    for (var i=0; i<mapInstances.length; i++) {
      var map = mapInstances[i];
      if (map.id) {
        continue;
      }
      if (!map.inUse) {
        var mapDiv = map.getDiv();
        el.appendChild(mapDiv);
        notInUseMap = map;
        break;
      }
    }
    return notInUseMap;
  };

  /**
   * @memberof NgMapPool
   * @function getMapInstance
   * @param {HtmlElement} el map container element
   * @return map instance for the given element
   */
  var getMapInstance = function(el) {
    var map = findById(el, el.id) || findUnused(el);
    if (!map) {
      map = add(el);
    } else {
      /* firing map idle event, which is used by map controller */
      $timeout(function() {
        google.maps.event.trigger(map, 'idle');
      }, 100);
    }
    map.inUse = true;
    return map;
  };

  /**
   * @memberof NgMapPool
   * @function returnMapInstance
   * @param {Map} an instance of google.maps.Map
   * @desc sets the flag inUse of the given map instance to false, so that it 
   * can be reused later
   */
  var returnMapInstance = function(map) {
    map.inUse = false;
  };
  
  /**
   * @memberof NgMapPool
   * @function resetMapInstances
   * @desc resets mapInstance array
   */
  var resetMapInstances = function() {
    for(var i = 0;i < mapInstances.length;i++) {
        mapInstances[i] = null;
    }
    mapInstances = [];
  };
  
  /**
   * @memberof NgMapPool
   * @function deleteMapInstance
   * @desc delete a mapInstance
   */
  var deleteMapInstance= function(mapId) {
	  for( var i=0; i<mapInstances.length; i++ ) {
		  if( (mapInstances[i] !== null) && (mapInstances[i].id == mapId)) {
			  mapInstances[i]= null;
			  mapInstances.splice( i, 1 );
		  }
	  }
  };

  var NgMapPool = function(_$document_, _$window_, _$timeout_) {
    $document = _$document_[0], $window = _$window_, $timeout = _$timeout_;

    return {
	  mapInstances: mapInstances,
      resetMapInstances: resetMapInstances,
      getMapInstance: getMapInstance,
      returnMapInstance: returnMapInstance,
      deleteMapInstance: deleteMapInstance
    };
  };

  NgMapPool.$inject = [ '$document', '$window', '$timeout'];

  angular.module('ngMap').factory('NgMapPool', NgMapPool);

})();

/**
 * @ngdoc provider
 * @name NgMap
 * @description
 *  common utility service for ng-map
 */
(function() {
  'use strict';
  var $window, $document, $q;
  var NavigatorGeolocation, Attr2MapOptions, GeoCoder, camelCaseFilter, NgMapPool;

  var mapControllers = {};

  var getStyle = function(el, styleProp) {
    var y;
    if (el.currentStyle) {
      y = el.currentStyle[styleProp];
    } else if ($window.getComputedStyle) {
      y = $document.defaultView.
        getComputedStyle(el, null).
        getPropertyValue(styleProp);
    }
    return y;
  };

  /**
   * @memberof NgMap
   * @function initMap
   * @param id optional, id of the map. default 0
   */
  var initMap = function(id) {
    var ctrl = mapControllers[id || 0];
    if (!(ctrl.map instanceof google.maps.Map)) {
      ctrl.initializeMap();
      return ctrl.map;
    } else {
      void 0;
    }
  };

  /**
   * @memberof NgMap
   * @function getMap
   * @param {String} optional, id e.g., 'foo'
   * @returns promise
   */
  var getMap = function(id, options) {
    options = options || {};
    id = typeof id === 'object' ? id.id : id;

    var deferred = $q.defer();
    var timeout = options.timeout || 10000;

    function waitForMap(timeElapsed){
      var keys = Object.keys(mapControllers);
      var theFirstController = mapControllers[keys[0]];
      if(id && mapControllers[id]){
        deferred.resolve(mapControllers[id].map);
      } else if (!id && theFirstController && theFirstController.map) {
        deferred.resolve(theFirstController.map);
      } else if (timeElapsed > timeout) {
        deferred.reject('could not find map');
      } else {
        $window.setTimeout( function(){
          waitForMap(timeElapsed+100);
        }, 100);
      }
    }
    waitForMap(0);

    return deferred.promise;
  };

  /**
   * @memberof NgMap
   * @function addMap
   * @param mapController {__MapContoller} a map controller
   * @returns promise
   */
  var addMap = function(mapCtrl) {
    if (mapCtrl.map) {
      var len = Object.keys(mapControllers).length;
      mapControllers[mapCtrl.map.id || len] = mapCtrl;
    }
  };

  /**
   * @memberof NgMap
   * @function deleteMap
   * @param mapController {__MapContoller} a map controller
   */
  var deleteMap = function(mapCtrl) {
    var len = Object.keys(mapControllers).length - 1;
    var mapId = mapCtrl.map.id || len;
    if (mapCtrl.map) {
      for (var eventName in mapCtrl.eventListeners) {
        void 0;
        var listener = mapCtrl.eventListeners[eventName];
        google.maps.event.removeListener(listener);
      }
      if (mapCtrl.map.controls) {
        mapCtrl.map.controls.forEach(function(ctrl) {
          ctrl.clear();
        });
      }
    }

    //Remove Heatmap Layers
    if (mapCtrl.map.heatmapLayers) {
      Object.keys(mapCtrl.map.heatmapLayers).forEach(function (layer) {
        mapCtrl.deleteObject('heatmapLayers', mapCtrl.map.heatmapLayers[layer]);
      });
    }

    NgMapPool.deleteMapInstance(mapId);

    delete mapControllers[mapId];
  };

  /**
   * @memberof NgMap
   * @function getGeoLocation
   * @param {String} address
   * @param {Hash} options geo options
   * @returns promise
   */
  var getGeoLocation = function(string, options) {
    var deferred = $q.defer();
    if (!string || string.match(/^current/i)) { // current location
      NavigatorGeolocation.getCurrentPosition(options).then(
        function(position) {
          var lat = position.coords.latitude;
          var lng = position.coords.longitude;
          var latLng = new google.maps.LatLng(lat,lng);
          deferred.resolve(latLng);
        },
        function(error) {
          deferred.reject(error);
        }
      );
    } else {
      GeoCoder.geocode({address: string}).then(
        function(results) {
          deferred.resolve(results[0].geometry.location);
        },
        function(error) {
          deferred.reject(error);
        }
      );
      // var geocoder = new google.maps.Geocoder();
      // geocoder.geocode(options, function (results, status) {
      //   if (status == google.maps.GeocoderStatus.OK) {
      //     deferred.resolve(results);
      //   } else {
      //     deferred.reject(status);
      //   }
      // });
    }

    return deferred.promise;
  };

  /**
   * @memberof NgMap
   * @function observeAndSet
   * @param {String} attrName attribute name
   * @param {Object} object A Google maps object to be changed
   * @returns attribue observe function
   */
  var observeAndSet = function(attrName, object) {
    void 0;
    return function(val) {
      if (val) {
        var setMethod = camelCaseFilter('set-'+attrName);
        var optionValue = Attr2MapOptions.toOptionValue(val, {key: attrName});
        if (object[setMethod]) { //if set method does exist
          void 0;
          /* if an location is being observed */
          if (attrName.match(/center|position/) &&
            typeof optionValue == 'string') {
            getGeoLocation(optionValue).then(function(latlng) {
              object[setMethod](latlng);
            });
          } else {
            object[setMethod](optionValue);
          }
        }
      }
    };
  };

  /**
   * @memberof NgMap
   * @function setStyle
   * @param {HtmlElement} map contriner element
   * @desc set display, width, height of map container element
   */
  var setStyle = function(el) {
    //if style is not given to the map element, set display and height
    var defaultStyle = el.getAttribute('default-style');
    if (defaultStyle == "true") {
      el.style.display = 'block';
      el.style.height = '300px';
    } else {
      if (getStyle(el, 'display') != "block") {
        el.style.display = 'block';
      }
      if (getStyle(el, 'height').match(/^(0|auto)/)) {
        el.style.height = '300px';
      }
    }
  };

  angular.module('ngMap').provider('NgMap', function() {
    var defaultOptions = {};

    /**
     * @memberof NgMap
     * @function setDefaultOptions
     * @param {Hash} options
     * @example
     *  app.config(function(NgMapProvider) {
     *    NgMapProvider.setDefaultOptions({
     *      marker: {
     *        optimized: false
     *      }
     *    });
     *  });
     */
    this.setDefaultOptions = function(options) {
      defaultOptions = options;
    };

    var NgMap = function(
        _$window_, _$document_, _$q_,
        _NavigatorGeolocation_, _Attr2MapOptions_,
        _GeoCoder_, _camelCaseFilter_, _NgMapPool_
      ) {
      $window = _$window_;
      $document = _$document_[0];
      $q = _$q_;
      NavigatorGeolocation = _NavigatorGeolocation_;
      Attr2MapOptions = _Attr2MapOptions_;
      GeoCoder = _GeoCoder_;
      camelCaseFilter = _camelCaseFilter_;
      NgMapPool = _NgMapPool_;

      return {
        defaultOptions: defaultOptions,
        addMap: addMap,
        deleteMap: deleteMap,
        getMap: getMap,
        initMap: initMap,
        setStyle: setStyle,
        getGeoLocation: getGeoLocation,
        observeAndSet: observeAndSet
      };
    };
    NgMap.$inject = [
      '$window', '$document', '$q',
      'NavigatorGeolocation', 'Attr2MapOptions',
      'GeoCoder', 'camelCaseFilter', 'NgMapPool'
    ];

    this.$get = NgMap;
  });
})();

/**
 * @ngdoc service
 * @name StreetView
 * @description
 *  Provides [defered/promise API](https://docs.angularjs.org/api/ng/service/$q)
 *  service for [Google StreetViewService]
 *  (https://developers.google.com/maps/documentation/javascript/streetview)
 */
(function() {
  'use strict';
  var $q;

  /**
   * Retrieves panorama id from the given map (and or position)
   * @memberof StreetView
   * @param {map} map Google map instance
   * @param {LatLng} latlng Google LatLng instance
   *   default: the center of the map
   * @example
   *   StreetView.getPanorama(map).then(function(panoId) {
   *     $scope.panoId = panoId;
   *   });
   * @returns {HttpPromise} Future object
   */
  var getPanorama = function(map, latlng) {
    latlng = latlng || map.getCenter();
    var deferred = $q.defer();
    var svs = new google.maps.StreetViewService();
    svs.getPanoramaByLocation( (latlng||map.getCenter), 100,
      function (data, status) {
        // if streetView available
        if (status === google.maps.StreetViewStatus.OK) {
          deferred.resolve(data.location.pano);
        } else {
          // no street view available in this range, or some error occurred
          deferred.resolve(false);
          //deferred.reject('Geocoder failed due to: '+ status);
        }
      }
    );
    return deferred.promise;
  };

  /**
   * Set panorama view on the given map with the panorama id
   * @memberof StreetView
   * @param {map} map Google map instance
   * @param {String} panoId Panorama id fro getPanorama method
   * @example
   *   StreetView.setPanorama(map, panoId);
   */
  var setPanorama = function(map, panoId) {
    var svp = new google.maps.StreetViewPanorama(
      map.getDiv(), {enableCloseButton: true}
    );
    svp.setPano(panoId);
  };

  var StreetView = function(_$q_) {
    $q = _$q_;

    return {
      getPanorama: getPanorama,
      setPanorama: setPanorama
    };
  };
  StreetView.$inject = ['$q'];

  angular.module('ngMap').service('StreetView', StreetView);
})();

return 'ngMap';
}));

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(926);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./leaflet_awesome_number_markers.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!./leaflet_awesome_number_markers.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(927);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../css-loader/index.js!./loading-bar.min.css", function() {
		var newContent = require("!!../../css-loader/index.js!./loading-bar.min.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(928);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../css-loader/index.js!./angular-moment-picker.min.css", function() {
		var newContent = require("!!../../css-loader/index.js!./angular-moment-picker.min.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(929);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../css-loader/index.js!./datetimepicker.css", function() {
		var newContent = require("!!../css-loader/index.js!./datetimepicker.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(930);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../css-loader/index.js!./daterangepicker.css", function() {
		var newContent = require("!!../css-loader/index.js!./daterangepicker.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(932);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../css-loader/index.js!./fullcalendar.css", function() {
		var newContent = require("!!../../css-loader/index.js!./fullcalendar.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(933);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../css-loader/index.js!./isteven-multi-select.css", function() {
		var newContent = require("!!../css-loader/index.js!./isteven-multi-select.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(934);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../css-loader/index.js!./leaflet.css", function() {
		var newContent = require("!!../../css-loader/index.js!./leaflet.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(935);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../css-loader/index.js!./ngToast.min.css", function() {
		var newContent = require("!!../../css-loader/index.js!./ngToast.min.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(936);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../css-loader/index.js!./normalize.css", function() {
		var newContent = require("!!../css-loader/index.js!./normalize.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(937);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../css-loader/index.js!../resolve-url-loader/index.js!../sass-loader/index.js?sourceMap!./lib/bootstrap.styles.loader.js?{\"bootstrapVersion\":3,\"useCustomIconFontPath\":false,\"extractStyles\":false,\"styleLoaders\":[\"style\",\"css\",\"sass\"],\"styles\":[\"mixins\",\"normalize\",\"print\",\"glyphicons\",\"scaffolding\",\"type\",\"code\",\"grid\",\"tables\",\"forms\",\"buttons\",\"component-animations\",\"dropdowns\",\"button-groups\",\"input-groups\",\"navs\",\"navbar\",\"breadcrumbs\",\"pagination\",\"pager\",\"labels\",\"badges\",\"jumbotron\",\"thumbnails\",\"alerts\",\"progress-bars\",\"media\",\"list-group\",\"panels\",\"wells\",\"responsive-embed\",\"close\",\"modals\",\"tooltip\",\"popovers\",\"carousel\",\"utilities\",\"responsive-utilities\"],\"scripts\":[\"transition\",\"alert\",\"button\",\"carousel\",\"collapse\",\"dropdown\",\"modal\",\"tooltip\",\"popover\",\"scrollspy\",\"tab\",\"affix\"],\"configFilePath\":\"/Users/appgambit/Work/Bhavin/TNT/client_build/TNT/node_modules/bootstrap-loader/.bootstraprc-3-default\",\"bootstrapPath\":\"/Users/appgambit/Work/Bhavin/TNT/client_build/TNT/node_modules/bootstrap-sass\",\"bootstrapRelPath\":\"../bootstrap-sass\"}!./no-op.js", function() {
		var newContent = require("!!../css-loader/index.js!../resolve-url-loader/index.js!../sass-loader/index.js?sourceMap!./lib/bootstrap.styles.loader.js?{\"bootstrapVersion\":3,\"useCustomIconFontPath\":false,\"extractStyles\":false,\"styleLoaders\":[\"style\",\"css\",\"sass\"],\"styles\":[\"mixins\",\"normalize\",\"print\",\"glyphicons\",\"scaffolding\",\"type\",\"code\",\"grid\",\"tables\",\"forms\",\"buttons\",\"component-animations\",\"dropdowns\",\"button-groups\",\"input-groups\",\"navs\",\"navbar\",\"breadcrumbs\",\"pagination\",\"pager\",\"labels\",\"badges\",\"jumbotron\",\"thumbnails\",\"alerts\",\"progress-bars\",\"media\",\"list-group\",\"panels\",\"wells\",\"responsive-embed\",\"close\",\"modals\",\"tooltip\",\"popovers\",\"carousel\",\"utilities\",\"responsive-utilities\"],\"scripts\":[\"transition\",\"alert\",\"button\",\"carousel\",\"collapse\",\"dropdown\",\"modal\",\"tooltip\",\"popover\",\"scrollspy\",\"tab\",\"affix\"],\"configFilePath\":\"/Users/appgambit/Work/Bhavin/TNT/client_build/TNT/node_modules/bootstrap-loader/.bootstraprc-3-default\",\"bootstrapPath\":\"/Users/appgambit/Work/Bhavin/TNT/client_build/TNT/node_modules/bootstrap-sass\",\"bootstrapRelPath\":\"../bootstrap-sass\"}!./no-op.js");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(938);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.print.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.print.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(939);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(940);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./connection-status.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./connection-status.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(941);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./denom-icon.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./denom-icon.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(942);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./file-upload.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./file-upload.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(943);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(944);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./paginated-search-and-select.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./paginated-search-and-select.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(945);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./search-and-select.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./search-and-select.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(946);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./modal.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./modal.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(947);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./time-picker.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./time-picker.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(948);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./timeoutCountdown.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./timeoutCountdown.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(949);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./access_denied.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./access_denied.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(950);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./ach_management.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./ach_management.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(951);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./app_event_logs.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./app_event_logs.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(952);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./atm_codes_management.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./atm_codes_management.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(953);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./atm_count.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./atm_count.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(954);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./atm_count_print.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./atm_count_print.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2930 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(955);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./auto_routing.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./auto_routing.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(956);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./bagout.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./bagout.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(957);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(958);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./batch.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./batch.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(959);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./batch.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./batch.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2935 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(960);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./batch.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./batch.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(961);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2937 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(962);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./branch.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./branch.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(963);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./window.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./window.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(964);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(965);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch_funding_source.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch_funding_source.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(966);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./branch_funding_source.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./branch_funding_source.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(967);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch_funding_source.create.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch_funding_source.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(968);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch_funding_source.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch_funding_source.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(969);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch_funding_source_holiday.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch_funding_source_holiday.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(970);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./branch_funding_source_holiday.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./branch_funding_source_holiday.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(971);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch_funding_source_holiday.create.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./branch_funding_source_holiday.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(972);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./branch_management.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./branch_management.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(973);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./average_daily_vault_balance.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./average_daily_vault_balance.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(974);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./bagouts.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./bagouts.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2950 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(975);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bagouts.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bagouts.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2951 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(976);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./billing_approval.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./billing_approval.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(977);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./bin_manifest.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./bin_manifest.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2953 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(978);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./branch_performance.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./branch_performance.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(979);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./bypass_code.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./bypass_code.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(980);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./cancelled_shipments.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./cancelled_shipments.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(981);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./cash_deliveries.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./cash_deliveries.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(982);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./contact_request.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./contact_request.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(983);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contact_request_print.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contact_request_print.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2959 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(984);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./count_variances.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./count_variances.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2960 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(985);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./customer_pickup_reports.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./customer_pickup_reports.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(986);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./customer_report.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./customer_report.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2962 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(987);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./daily_balance_sheet.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./daily_balance_sheet.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2963 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(988);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./daily_balance_sheet_print.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./daily_balance_sheet_print.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(989);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./daily_balance_sheet_report_print.scss", function() {
		var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./daily_balance_sheet_report_print.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(990);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./deleted_shipments.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./deleted_shipments.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(991);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./deposit_reports.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./deposit_reports.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(992);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./final_residual_count_commit.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./final_residual_count_commit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(993);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./final_residual_count_commit_print.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./final_residual_count_commit_print.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(994);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./import_file_view.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./import_file_view.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(995);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./item_holds.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./item_holds.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(997);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./items.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./items.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2972 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(998);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./location_holds.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./location_holds.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2973 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(999);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./locations.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./locations.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1000);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./print.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./print.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1001);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./lock_open_errors.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./lock_open_errors.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2976 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1002);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./mileage_report.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./mileage_report.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1003);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./monthly_report.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./monthly_report.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2978 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1004);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./orders.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./orders.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2979 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1005);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./print.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./print.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2980 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1008);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./restore_route_assignments.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./restore_route_assignments.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2981 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1009);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./print_routes.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./print_routes.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2982 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1010);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./routes.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./routes.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2983 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1011);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./stop_performance.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./stop_performance.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2984 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1012);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./stop_scheduling.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./stop_scheduling.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2985 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1013);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./print_tankers.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./print_tankers.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2986 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1014);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./tankers.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./tankers.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2987 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1015);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./tnt_bypass_code.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./tnt_bypass_code.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2988 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1016);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./bulk_cash_management.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./bulk_cash_management.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2989 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1017);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_bulk_cash.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_bulk_cash.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2990 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1018);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./carrier.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./carrier.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2991 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1019);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./carrier.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./carrier.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2992 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1020);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./cash_activity.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./cash_activity.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2993 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1021);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./checkin.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./checkin.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2994 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1022);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_checkin.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_checkin.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2995 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1023);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./checkout.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./checkout.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2996 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1024);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_checkout.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_checkout.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2997 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1025);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./coin_management.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./coin_management.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2998 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1026);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./coin_pull_report.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./coin_pull_report.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1027);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_branch_coin.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_branch_coin.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3000 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1028);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./coin_pull_report_print.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./coin_pull_report_print.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3001 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1029);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./delivery_region_routing.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./delivery_region_routing.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1030);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./delivery_region_routing.create.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./delivery_region_routing.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1031);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./delivery_region_routing.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./delivery_region_routing.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1032);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./delivery_region_routing.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./delivery_region_routing.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1033);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./deposit_packing.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./deposit_packing.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3006 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1034);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_deposit_packing.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_deposit_packing.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1035);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./forgot_password.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./forgot_password.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1036);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./holiday.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./holiday.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1037);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1038);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1039);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3012 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1040);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./item.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./item.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3013 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1041);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item_history.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item_history.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3014 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1042);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item_type.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item_type.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3015 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1043);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item_type.create.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item_type.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3016 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1044);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item_type.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./item_type.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3017 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1045);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./item_type.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./item_type.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3018 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1046);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3019 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1047);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.clone.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.clone.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3020 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1048);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./deliver_location.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./deliver_location.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3021 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1049);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.create.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3022 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1050);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3023 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1051);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.import_locations.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.import_locations.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3024 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1052);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./location.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./location.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3025 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1053);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.missinglatlng.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./location.missinglatlng.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3026 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1054);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_location_barcodes.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_location_barcodes.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3027 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1055);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./log.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./log.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1056);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./log.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./log.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3029 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1057);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./login.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./login.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3030 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1058);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./main.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./main.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3031 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1059);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./master_cash_schedule.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./master_cash_schedule.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3032 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1060);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./on_demand_call.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./on_demand_call.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3033 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1061);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./currency_pick_report.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./currency_pick_report.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1062);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./print_currency_pick_report.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./print_currency_pick_report.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1063);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./order_packing.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./order_packing.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1064);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_barcodes.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_barcodes.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1066);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_packing_slip.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_packing_slip.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1067);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./pickup_request_management.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./pickup_request_management.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1068);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./liability.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./liability.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1069);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./on_hold.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./on_hold.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1070);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./route_performance.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./route_performance.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3042 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1071);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./reporting.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./reporting.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3043 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1072);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./reset_atm_code.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./reset_atm_code.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1073);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./reset_atm_code.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./reset_atm_code.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1074);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1075);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./routeSheet.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./routeSheet.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1076);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./delivery_manifest_all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./delivery_manifest_all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1077);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./delivery_manifest_combined.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./delivery_manifest_combined.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1078);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./route_control.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./route_control.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1079);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./route_progress.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./route_progress.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3051 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1080);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./route_stats.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./route_stats.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3052 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1081);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./route_throw.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./route_throw.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1082);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./routes.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./routes.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1083);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./routes.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./routes.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1084);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./routes.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./routes.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1085);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./service_settings.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./service_settings.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3057 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1086);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./atm-makes.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./atm-makes.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1087);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./service_checklists.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./service_checklists.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3059 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1088);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./service_settings.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./service_settings.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1089);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./service_ticket_parts.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./service_ticket_parts.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3061 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1090);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./service_ticket_parts.create.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./service_ticket_parts.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1091);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./service_ticket_parts.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./service_ticket_parts.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1092);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./service_ticket_parts.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./service_ticket_parts.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3064 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1093);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./service_tickets.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./service_tickets.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1094);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./settings.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./settings.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1095);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_batch.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./print_batch.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3067 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1096);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./shipment_batch.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./shipment_batch.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3068 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1097);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billable_events.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billable_events.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1098);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./billable_events.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./billable_events.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1099);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billable_events.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billable_events.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1100);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billable_events.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billable_events.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3072 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1101);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billing_category.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billing_category.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3073 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1102);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./billing_category.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./billing_category.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3074 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1103);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billing_category.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billing_category.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3075 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1104);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billing_category.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./billing_category.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1105);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3077 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1106);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./contract.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./contract.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3078 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1107);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3079 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1108);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3080 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1109);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./print_history.scss", function() {
		var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./print_history.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1110);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract_type.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract_type.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3082 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1111);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./contract_type.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./contract_type.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1112);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract_type.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract_type.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3084 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1113);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract_type.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./contract_type.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1114);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./customer.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./customer.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3086 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1115);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./customer.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./customer.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3087 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1116);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./customer.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./customer.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3088 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1117);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./customer.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./customer.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3089 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1118);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./fuel_surcharges.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./fuel_surcharges.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3090 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1119);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./fuel_surcharges.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./fuel_surcharges.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3091 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1120);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./customer_not_associated.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./customer_not_associated.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3092 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1121);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./fuel_surcharges.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./fuel_surcharges.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1122);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./fuel_surcharges.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./fuel_surcharges.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1123);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_not_associated.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_not_associated.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1124);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_distance.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_distance.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1125);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_distance.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_distance.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1126);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_distance.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_distance.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3098 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1127);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./location_distance.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./location_distance.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3099 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1128);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./tnt_billing.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./tnt_billing.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3100 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1129);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./atm_load_profile.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./atm_load_profile.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3101 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1130);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./atm_load_profile.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./atm_load_profile.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3102 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1131);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./atm_load_profile.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./atm_load_profile.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3103 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1132);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./configuration.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./configuration.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3104 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1133);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./cost_center.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./cost_center.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3105 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1134);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./cost_center.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./cost_center.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3106 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1135);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./cost_center.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./cost_center.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3107 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1136);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./cost_center.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./cost_center.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3108 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1137);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./currency.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./currency.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3109 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1138);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./currency.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./currency.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3110 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1139);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./currency.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./currency.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3111 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1140);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./currency.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./currency.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3112 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1141);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./denomination.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./denomination.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3113 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1142);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./denomination.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./denomination.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3114 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1143);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./denomination.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./denomination.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3115 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1146);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./environment_config.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./environment_config.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3116 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1147);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./environment_config.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./environment_config.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3117 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1148);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./environment_config.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./environment_config.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3118 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1149);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_zone.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_zone.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3119 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1150);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_zone.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_zone.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3120 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1151);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_zone.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./location_zone.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3121 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1152);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./location_zone.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./location_zone.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3122 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1153);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./message.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./message.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3123 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1154);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./message.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./message.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3124 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1155);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./duplicate_message.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./duplicate_message.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3125 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1156);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./message.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./message.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3126 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1157);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./message.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./message.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3127 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1158);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./mobile_app.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./mobile_app.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3128 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1159);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./mobile_app.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./mobile_app.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3129 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1160);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./mobile_app.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./mobile_app.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3130 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1161);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./notification_management.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./notification_management.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3131 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1162);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./notification_management.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./notification_management.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3132 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1163);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./notification_management.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./notification_management.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3133 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1164);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./notification_management.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./notification_management.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3134 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1165);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./service_assignment_rules.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./service_assignment_rules.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3135 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1166);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./service_assignment_rules.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./service_assignment_rules.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3136 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1167);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./service_assignment_rules.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./service_assignment_rules.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3137 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1168);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./service_assignment_rules.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./service_assignment_rules.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3138 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1169);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./setup.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./setup.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3139 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1170);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./setup.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./setup.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3140 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1171);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./setup.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./setup.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3141 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1172);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./setup.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./setup.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3142 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1173);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./shiptype.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./shiptype.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3143 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1174);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./shiptype.create.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./shiptype.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3144 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1175);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./shiptype.edit.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./shiptype.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3145 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1176);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./shiptype.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./shiptype.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3146 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1177);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./user_permission_report.all.scss", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./user_permission_report.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3147 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1178);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./user_permission_report.scss", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./user_permission_report.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3148 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1179);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./tnt_control.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./tnt_control.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3149 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1180);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./tnt_react_app.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./tnt_react_app.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3150 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1181);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./truck.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./truck.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3151 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1182);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./truck.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./truck.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3152 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1183);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./truck.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./truck.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3153 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1184);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./users.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./users.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3154 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1185);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./users.create.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./users.create.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3155 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1186);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./users.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./users.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3156 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1187);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./users.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./users.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3157 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1188);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./vault.all.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./vault.all.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3158 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1189);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./vault.edit.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./vault.edit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3159 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1190);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./vault.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./vault.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3160 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1191);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./vault_balance.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./vault_balance.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3161 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1192);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./vault_close.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./vault_close.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3162 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1193);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./vault_operations.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./vault_operations.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3163 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1194);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./verify_2FA_code.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./verify_2FA_code.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3164 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1195);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../css-loader/index.js!./select.min.css", function() {
		var newContent = require("!!../../css-loader/index.js!./select.min.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3165 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 3166 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*!
 * ui-select
 * http://github.com/angular-ui/ui-select
 * Version: 0.19.8 - 2017-04-18T05:43:43.673Z
 * License: MIT
 */


(function () { 
"use strict";
var KEY = {
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    HOME: 36,
    END: 35,
    BACKSPACE: 8,
    DELETE: 46,
    COMMAND: 91,

    MAP: { 91 : "COMMAND", 8 : "BACKSPACE" , 9 : "TAB" , 13 : "ENTER" , 16 : "SHIFT" , 17 : "CTRL" , 18 : "ALT" , 19 : "PAUSEBREAK" , 20 : "CAPSLOCK" , 27 : "ESC" , 32 : "SPACE" , 33 : "PAGE_UP", 34 : "PAGE_DOWN" , 35 : "END" , 36 : "HOME" , 37 : "LEFT" , 38 : "UP" , 39 : "RIGHT" , 40 : "DOWN" , 43 : "+" , 44 : "PRINTSCREEN" , 45 : "INSERT" , 46 : "DELETE", 48 : "0" , 49 : "1" , 50 : "2" , 51 : "3" , 52 : "4" , 53 : "5" , 54 : "6" , 55 : "7" , 56 : "8" , 57 : "9" , 59 : ";", 61 : "=" , 65 : "A" , 66 : "B" , 67 : "C" , 68 : "D" , 69 : "E" , 70 : "F" , 71 : "G" , 72 : "H" , 73 : "I" , 74 : "J" , 75 : "K" , 76 : "L", 77 : "M" , 78 : "N" , 79 : "O" , 80 : "P" , 81 : "Q" , 82 : "R" , 83 : "S" , 84 : "T" , 85 : "U" , 86 : "V" , 87 : "W" , 88 : "X" , 89 : "Y" , 90 : "Z", 96 : "0" , 97 : "1" , 98 : "2" , 99 : "3" , 100 : "4" , 101 : "5" , 102 : "6" , 103 : "7" , 104 : "8" , 105 : "9", 106 : "*" , 107 : "+" , 109 : "-" , 110 : "." , 111 : "/", 112 : "F1" , 113 : "F2" , 114 : "F3" , 115 : "F4" , 116 : "F5" , 117 : "F6" , 118 : "F7" , 119 : "F8" , 120 : "F9" , 121 : "F10" , 122 : "F11" , 123 : "F12", 144 : "NUMLOCK" , 145 : "SCROLLLOCK" , 186 : ";" , 187 : "=" , 188 : "," , 189 : "-" , 190 : "." , 191 : "/" , 192 : "`" , 219 : "[" , 220 : "\\" , 221 : "]" , 222 : "'"
    },

    isControl: function (e) {
        var k = e.which;
        switch (k) {
        case KEY.COMMAND:
        case KEY.SHIFT:
        case KEY.CTRL:
        case KEY.ALT:
            return true;
        }

        if (e.metaKey || e.ctrlKey || e.altKey) return true;

        return false;
    },
    isFunctionKey: function (k) {
        k = k.which ? k.which : k;
        return k >= 112 && k <= 123;
    },
    isVerticalMovement: function (k){
      return ~[KEY.UP, KEY.DOWN].indexOf(k);
    },
    isHorizontalMovement: function (k){
      return ~[KEY.LEFT,KEY.RIGHT,KEY.BACKSPACE,KEY.DELETE].indexOf(k);
    },
    toSeparator: function (k) {
      var sep = {ENTER:"\n",TAB:"\t",SPACE:" "}[k];
      if (sep) return sep;
      // return undefined for special keys other than enter, tab or space.
      // no way to use them to cut strings.
      return KEY[k] ? undefined : k;
    }
  };

function isNil(value) {
  return angular.isUndefined(value) || value === null;
}

/**
 * Add querySelectorAll() to jqLite.
 *
 * jqLite find() is limited to lookups by tag name.
 * TODO This will change with future versions of AngularJS, to be removed when this happens
 *
 * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
 * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
 */
if (angular.element.prototype.querySelectorAll === undefined) {
  angular.element.prototype.querySelectorAll = function(selector) {
    return angular.element(this[0].querySelectorAll(selector));
  };
}

/**
 * Add closest() to jqLite.
 */
if (angular.element.prototype.closest === undefined) {
  angular.element.prototype.closest = function( selector) {
    var elem = this[0];
    var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;

    while (elem) {
      if (matchesSelector.bind(elem)(selector)) {
        return elem;
      } else {
        elem = elem.parentElement;
      }
    }
    return false;
  };
}

var latestId = 0;

var uis = angular.module('ui.select', [])

.constant('uiSelectConfig', {
  theme: 'bootstrap',
  searchEnabled: true,
  sortable: false,
  placeholder: '', // Empty by default, like HTML tag <select>
  refreshDelay: 1000, // In milliseconds
  closeOnSelect: true,
  skipFocusser: false,
  dropdownPosition: 'auto',
  removeSelected: true,
  resetSearchInput: true,
  generateId: function() {
    return latestId++;
  },
  appendToBody: false,
  spinnerEnabled: false,
  spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
  backspaceReset: true
})

// See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
.service('uiSelectMinErr', function() {
  var minErr = angular.$$minErr('ui.select');
  return function() {
    var error = minErr.apply(this, arguments);
    var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
    return new Error(message);
  };
})

// Recreates old behavior of ng-transclude. Used internally.
.directive('uisTranscludeAppend', function () {
  return {
    link: function (scope, element, attrs, ctrl, transclude) {
        transclude(scope, function (clone) {
          element.append(clone);
        });
      }
    };
})

/**
 * Highlights text that matches $select.search.
 *
 * Taken from AngularUI Bootstrap Typeahead
 * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
 */
.filter('highlight', function() {
  function escapeRegexp(queryToEscape) {
    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
  }

  return function(matchItem, query) {
    return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
  };
})

/**
 * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
 *
 * Taken from AngularUI Bootstrap Position:
 * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
 */
.factory('uisOffset',
  ['$document', '$window',
  function ($document, $window) {

  return function(element) {
    var boundingClientRect = element[0].getBoundingClientRect();
    return {
      width: boundingClientRect.width || element.prop('offsetWidth'),
      height: boundingClientRect.height || element.prop('offsetHeight'),
      top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
      left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
    };
  };
}]);

uis.directive('uiSelectChoices',
  ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
  function(uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {

  return {
    restrict: 'EA',
    require: '^uiSelect',
    replace: true,
    transclude: true,
    templateUrl: function(tElement) {
      // Needed so the uiSelect can detect the transcluded content
      tElement.addClass('ui-select-choices');

      // Gets theme attribute from parent (ui-select)
      var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
      return theme + '/choices.tpl.html';
    },

    compile: function(tElement, tAttrs) {

      if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");

      // var repeat = RepeatParser.parse(attrs.repeat);
      var groupByExp = tAttrs.groupBy;
      var groupFilterExp = tAttrs.groupFilter;

      if (groupByExp) {
        var groups = tElement.querySelectorAll('.ui-select-choices-group');
        if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
        groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
      }

      var parserResult = RepeatParser.parse(tAttrs.repeat);

      var choices = tElement.querySelectorAll('.ui-select-choices-row');
      if (choices.length !== 1) {
        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
      }

      choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp))
             .attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed


      var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
      if (rowsInner.length !== 1) {
        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
      }
      rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat

      // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
      var clickTarget = $window.document.addEventListener ? choices : rowsInner;
      clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');

      return function link(scope, element, attrs, $select) {


        $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
        $select.disableChoiceExpression = attrs.uiDisableChoice;
        $select.onHighlightCallback = attrs.onHighlight;
        $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
        $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;

        scope.$watch('$select.search', function(newValue) {
          if(newValue && !$select.open && $select.multiple) $select.activate(false, true);
          $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
          if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
            $select.refresh(attrs.refresh);
          } else {
            $select.items = [];
          }
        });

        attrs.$observe('refreshDelay', function() {
          // $eval() is needed otherwise we get a string instead of a number
          var refreshDelay = scope.$eval(attrs.refreshDelay);
          $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
        });

        scope.$watch('$select.open', function(open) {
          if (open) {
            tElement.attr('role', 'listbox');
            $select.refresh(attrs.refresh);
          } else {
            element.removeAttr('role');
          }
        });
      };
    }
  };
}]);

/**
 * Contains ui-select "intelligence".
 *
 * The goal is to limit dependency on the DOM whenever possible and
 * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
 */
uis.controller('uiSelectCtrl',
  ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
  function($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {

  var ctrl = this;

  var EMPTY_SEARCH = '';

  ctrl.placeholder = uiSelectConfig.placeholder;
  ctrl.searchEnabled = uiSelectConfig.searchEnabled;
  ctrl.sortable = uiSelectConfig.sortable;
  ctrl.refreshDelay = uiSelectConfig.refreshDelay;
  ctrl.paste = uiSelectConfig.paste;
  ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
  ctrl.refreshing = false;
  ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
  ctrl.spinnerClass = uiSelectConfig.spinnerClass;
  ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
  ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
  ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
  ctrl.search = EMPTY_SEARCH;

  ctrl.activeIndex = 0; //Dropdown of choices
  ctrl.items = []; //All available choices

  ctrl.open = false;
  ctrl.focus = false;
  ctrl.disabled = false;
  ctrl.selected = undefined;

  ctrl.dropdownPosition = 'auto';

  ctrl.focusser = undefined; //Reference to input element used to handle focus events
  ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
  ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
  ctrl.tagging = {isActivated: false, fct: undefined};
  ctrl.taggingTokens = {isActivated: false, tokens: undefined};
  ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
  ctrl.clickTriggeredSelect = false;
  ctrl.$filter = $filter;
  ctrl.$element = $element;

  // Use $injector to check for $animate and store a reference to it
  ctrl.$animate = (function () {
    try {
      return $injector.get('$animate');
    } catch (err) {
      // $animate does not exist
      return null;
    }
  })();

  ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
  if (ctrl.searchInput.length !== 1) {
    throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
  }

  ctrl.isEmpty = function() {
    return isNil(ctrl.selected) || ctrl.selected === '' || (ctrl.multiple && ctrl.selected.length === 0);
  };

  function _findIndex(collection, predicate, thisArg){
    if (collection.findIndex){
      return collection.findIndex(predicate, thisArg);
    } else {
      var list = Object(collection);
      var length = list.length >>> 0;
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return i;
        }
      }
      return -1;
    }
  }

  // Most of the time the user does not want to empty the search input when in typeahead mode
  function _resetSearchInput() {
    if (ctrl.resetSearchInput) {
      ctrl.search = EMPTY_SEARCH;
      //reset activeIndex
      if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
        ctrl.activeIndex = _findIndex(ctrl.items, function(item){
          return angular.equals(this, item);
        }, ctrl.selected);
      }
    }
  }

    function _groupsFilter(groups, groupNames) {
      var i, j, result = [];
      for(i = 0; i < groupNames.length ;i++){
        for(j = 0; j < groups.length ;j++){
          if(groups[j].name == [groupNames[i]]){
            result.push(groups[j]);
          }
        }
      }
      return result;
    }

  // When the user clicks on ui-select, displays the dropdown list
  ctrl.activate = function(initSearchValue, avoidReset) {
    if (!ctrl.disabled  && !ctrl.open) {
      if(!avoidReset) _resetSearchInput();

      $scope.$broadcast('uis:activate');
      ctrl.open = true;
      ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
      // ensure that the index is set to zero for tagging variants
      // that where first option is auto-selected
      if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
        ctrl.activeIndex = 0;
      }

      var container = $element.querySelectorAll('.ui-select-choices-content');
      var searchInput = $element.querySelectorAll('.ui-select-search');
      if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
        var animateHandler = function(elem, phase) {
          if (phase === 'start' && ctrl.items.length === 0) {
            // Only focus input after the animation has finished
            ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
            $timeout(function () {
              ctrl.focusSearchInput(initSearchValue);
            });
          } else if (phase === 'close') {
            // Only focus input after the animation has finished
            ctrl.$animate.off('enter', container[0], animateHandler);
            $timeout(function () {
              ctrl.focusSearchInput(initSearchValue);
            });
          }
        };

        if (ctrl.items.length > 0) {
          ctrl.$animate.on('enter', container[0], animateHandler);
        } else {
          ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
        }
      } else {
        $timeout(function () {
          ctrl.focusSearchInput(initSearchValue);
          if(!ctrl.tagging.isActivated && ctrl.items.length > 1) {
            _ensureHighlightVisible();
          }
        });
      }
    }
    else if (ctrl.open && !ctrl.searchEnabled) {
      // Close the selection if we don't have search enabled, and we click on the select again
      ctrl.close();
    }
  };

  ctrl.focusSearchInput = function (initSearchValue) {
    ctrl.search = initSearchValue || ctrl.search;
    ctrl.searchInput[0].focus();
  };

  ctrl.findGroupByName = function(name) {
    return ctrl.groups && ctrl.groups.filter(function(group) {
      return group.name === name;
    })[0];
  };

  ctrl.parseRepeatAttr = function(repeatAttr, groupByExp, groupFilterExp) {
    function updateGroups(items) {
      var groupFn = $scope.$eval(groupByExp);
      ctrl.groups = [];
      angular.forEach(items, function(item) {
        var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
        var group = ctrl.findGroupByName(groupName);
        if(group) {
          group.items.push(item);
        }
        else {
          ctrl.groups.push({name: groupName, items: [item]});
        }
      });
      if(groupFilterExp){
        var groupFilterFn = $scope.$eval(groupFilterExp);
        if( angular.isFunction(groupFilterFn)){
          ctrl.groups = groupFilterFn(ctrl.groups);
        } else if(angular.isArray(groupFilterFn)){
          ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
        }
      }
      ctrl.items = [];
      ctrl.groups.forEach(function(group) {
        ctrl.items = ctrl.items.concat(group.items);
      });
    }

    function setPlainItems(items) {
      ctrl.items = items || [];
    }

    ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;

    ctrl.parserResult = RepeatParser.parse(repeatAttr);

    ctrl.isGrouped = !!groupByExp;
    ctrl.itemProperty = ctrl.parserResult.itemName;

    //If collection is an Object, convert it to Array

    var originalSource = ctrl.parserResult.source;

    //When an object is used as source, we better create an array and use it as 'source'
    var createArrayFromObject = function(){
      var origSrc = originalSource($scope);
      $scope.$uisSource = Object.keys(origSrc).map(function(v){
        var result = {};
        result[ctrl.parserResult.keyName] = v;
        result.value = origSrc[v];
        return result;
      });
    };

    if (ctrl.parserResult.keyName){ // Check for (key,value) syntax
      createArrayFromObject();
      ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
      $scope.$watch(originalSource, function(newVal, oldVal){
        if (newVal !== oldVal) createArrayFromObject();
      }, true);
    }

    ctrl.refreshItems = function (data){
      data = data || ctrl.parserResult.source($scope);
      var selectedItems = ctrl.selected;
      //TODO should implement for single mode removeSelected
      if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.multiple || !ctrl.removeSelected) {
        ctrl.setItemsFn(data);
      }else{
        if ( data !== undefined && data !== null ) {
          var filteredItems = data.filter(function(i) {
            return angular.isArray(selectedItems) ? selectedItems.every(function(selectedItem) {
              return !angular.equals(i, selectedItem);
            }) : !angular.equals(i, selectedItems);
          });
          ctrl.setItemsFn(filteredItems);
        }
      }
      if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up'){
        $scope.calculateDropdownPos();
      }
      $scope.$broadcast('uis:refresh');
    };

    // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
    $scope.$watchCollection(ctrl.parserResult.source, function(items) {
      if (items === undefined || items === null) {
        // If the user specifies undefined or null => reset the collection
        // Special case: items can be undefined if the user did not initialized the collection on the scope
        // i.e $scope.addresses = [] is missing
        ctrl.items = [];
      } else {
        if (!angular.isArray(items)) {
          throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
        } else {
          //Remove already selected items (ex: while searching)
          //TODO Should add a test
          ctrl.refreshItems(items);

          //update the view value with fresh data from items, if there is a valid model value
          if(angular.isDefined(ctrl.ngModel.$modelValue)) {
            ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
          }
        }
      }
    });

  };

  var _refreshDelayPromise;

  /**
   * Typeahead mode: lets the user refresh the collection using his own function.
   *
   * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
   */
  ctrl.refresh = function(refreshAttr) {
    if (refreshAttr !== undefined) {
      // Debounce
      // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
      // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
      if (_refreshDelayPromise) {
        $timeout.cancel(_refreshDelayPromise);
      }
      _refreshDelayPromise = $timeout(function() {
        if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
          var refreshPromise = $scope.$eval(refreshAttr);
          if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
            ctrl.refreshing = true;
            refreshPromise.finally(function() {
              ctrl.refreshing = false;
            });
          }
        }
      }, ctrl.refreshDelay);
    }
  };

  ctrl.isActive = function(itemScope) {
    if ( !ctrl.open ) {
      return false;
    }
    var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
    var isActive =  itemIndex == ctrl.activeIndex;

    if ( !isActive || itemIndex < 0 ) {
      return false;
    }

    if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
      itemScope.$eval(ctrl.onHighlightCallback);
    }

    return isActive;
  };

  var _isItemSelected = function (item) {
    return (ctrl.selected && angular.isArray(ctrl.selected) &&
        ctrl.selected.filter(function (selection) { return angular.equals(selection, item); }).length > 0);
  };

  var disabledItems = [];

  function _updateItemDisabled(item, isDisabled) {
    var disabledItemIndex = disabledItems.indexOf(item);
    if (isDisabled && disabledItemIndex === -1) {
      disabledItems.push(item);
    }

    if (!isDisabled && disabledItemIndex > -1) {
      disabledItems.splice(disabledItemIndex, 1);
    }
  }

  function _isItemDisabled(item) {
    return disabledItems.indexOf(item) > -1;
  }

  ctrl.isDisabled = function(itemScope) {

    if (!ctrl.open) return;

    var item = itemScope[ctrl.itemProperty];
    var itemIndex = ctrl.items.indexOf(item);
    var isDisabled = false;

    if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {

      if (item.isTag) return false;

      if (ctrl.multiple) {
        isDisabled = _isItemSelected(item);
      }

      if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
        isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression));
      }

      _updateItemDisabled(item, isDisabled);
    }

    return isDisabled;
  };


  // When the user selects an item with ENTER or clicks the dropdown
  ctrl.select = function(item, skipFocusser, $event) {
    if (isNil(item) || !_isItemDisabled(item)) {

      if ( ! ctrl.items && ! ctrl.search && ! ctrl.tagging.isActivated) return;

      if (!item || !_isItemDisabled(item)) {
        // if click is made on existing item, prevent from tagging, ctrl.search does not matter
        ctrl.clickTriggeredSelect = false;
        if($event && ($event.type === 'click' || $event.type === 'touchend') && item)
          ctrl.clickTriggeredSelect = true;

        if(ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
          // if taggingLabel is disabled and item is undefined we pull from ctrl.search
          if ( ctrl.taggingLabel === false ) {
            if ( ctrl.activeIndex < 0 ) {
              if (item === undefined) {
                item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
              }
              if (!item || angular.equals( ctrl.items[0], item ) ) {
                return;
              }
            } else {
              // keyboard nav happened first, user selected from dropdown
              item = ctrl.items[ctrl.activeIndex];
            }
          } else {
            // tagging always operates at index zero, taggingLabel === false pushes
            // the ctrl.search value without having it injected
            if ( ctrl.activeIndex === 0 ) {
              // ctrl.tagging pushes items to ctrl.items, so we only have empty val
              // for `item` if it is a detected duplicate
              if ( item === undefined ) return;

              // create new item on the fly if we don't already have one;
              // use tagging function if we have one
              if ( ctrl.tagging.fct !== undefined && typeof item === 'string' ) {
                item = ctrl.tagging.fct(item);
                if (!item) return;
              // if item type is 'string', apply the tagging label
              } else if ( typeof item === 'string' ) {
                // trim the trailing space
                item = item.replace(ctrl.taggingLabel,'').trim();
              }
            }
          }
          // search ctrl.selected for dupes potentially caused by tagging and return early if found
          if (_isItemSelected(item)) {
            ctrl.close(skipFocusser);
            return;
          }
        }
        _resetSearchInput();
        $scope.$broadcast('uis:select', item);

        if (ctrl.closeOnSelect) {
          ctrl.close(skipFocusser);
        }
      }
    }
  };

  // Closes the dropdown
  ctrl.close = function(skipFocusser) {
    if (!ctrl.open) return;
    if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
    ctrl.open = false;
    _resetSearchInput();
    $scope.$broadcast('uis:close', skipFocusser);

  };

  ctrl.setFocus = function(){
    if (!ctrl.focus) ctrl.focusInput[0].focus();
  };

  ctrl.clear = function($event) {
    ctrl.select(null);
    $event.stopPropagation();
    $timeout(function() {
      ctrl.focusser[0].focus();
    }, 0, false);
  };

  // Toggle dropdown
  ctrl.toggle = function(e) {
    if (ctrl.open) {
      ctrl.close();
      e.preventDefault();
      e.stopPropagation();
    } else {
      ctrl.activate();
    }
  };

  // Set default function for locked choices - avoids unnecessary
  // logic if functionality is not being used
  ctrl.isLocked = function () {
    return false;
  };

  $scope.$watch(function () {
    return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
  }, _initaliseLockedChoices);

  function _initaliseLockedChoices(doInitalise) {
    if(!doInitalise) return;

    var lockedItems = [];

    function _updateItemLocked(item, isLocked) {
      var lockedItemIndex = lockedItems.indexOf(item);
      if (isLocked && lockedItemIndex === -1) {
        lockedItems.push(item);
        }

      if (!isLocked && lockedItemIndex > -1) {
        lockedItems.splice(lockedItemIndex, 1);
      }
    }

    function _isItemlocked(item) {
      return lockedItems.indexOf(item) > -1;
    }

    ctrl.isLocked = function (itemScope, itemIndex) {
      var isLocked = false,
          item = ctrl.selected[itemIndex];

      if(item) {
        if (itemScope) {
          isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression));
          _updateItemLocked(item, isLocked);
        } else {
          isLocked = _isItemlocked(item);
        }
      }

      return isLocked;
    };
  }


  var sizeWatch = null;
  var updaterScheduled = false;
  ctrl.sizeSearchInput = function() {

    var input = ctrl.searchInput[0],
        container = ctrl.$element[0],
        calculateContainerWidth = function() {
          // Return the container width only if the search input is visible
          return container.clientWidth * !!input.offsetParent;
        },
        updateIfVisible = function(containerWidth) {
          if (containerWidth === 0) {
            return false;
          }
          var inputWidth = containerWidth - input.offsetLeft;
          if (inputWidth < 50) inputWidth = containerWidth;
          ctrl.searchInput.css('width', inputWidth+'px');
          return true;
        };

    ctrl.searchInput.css('width', '10px');
    $timeout(function() { //Give tags time to render correctly
      if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
        sizeWatch = $scope.$watch(function() {
          if (!updaterScheduled) {
            updaterScheduled = true;
            $scope.$$postDigest(function() {
              updaterScheduled = false;
              if (updateIfVisible(calculateContainerWidth())) {
                sizeWatch();
                sizeWatch = null;
              }
            });
          }
        }, angular.noop);
      }
    });
  };

  function _handleDropDownSelection(key) {
    var processed = true;
    switch (key) {
      case KEY.DOWN:
        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
        else if (ctrl.activeIndex < ctrl.items.length - 1) {
          var idx = ++ctrl.activeIndex;
          while(_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
            ctrl.activeIndex = ++idx;
          }
        }
        break;
      case KEY.UP:
        var minActiveIndex = (ctrl.search.length === 0 && ctrl.tagging.isActivated) ? -1 : 0;
        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
        else if (ctrl.activeIndex > minActiveIndex) {
          var idxmin = --ctrl.activeIndex;
          while(_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
            ctrl.activeIndex = --idxmin;
          }
        }
        break;
      case KEY.TAB:
        if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
        break;
      case KEY.ENTER:
        if(ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)){
          ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
        } else {
          ctrl.activate(false, true); //In case its the search input in 'multiple' mode
        }
        break;
      case KEY.ESC:
        ctrl.close();
        break;
      default:
        processed = false;
    }
    return processed;
  }

  // Bind to keyboard shortcuts
  ctrl.searchInput.on('keydown', function(e) {

    var key = e.which;

    if (~[KEY.ENTER,KEY.ESC].indexOf(key)){
      e.preventDefault();
      e.stopPropagation();
    }

    $scope.$apply(function() {

      var tagged = false;

      if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
        if(!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
          e.preventDefault();
          e.stopPropagation();
        }
        if ( ctrl.taggingTokens.isActivated ) {
          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
            if ( ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode] ) {
              // make sure there is a new value to push via tagging
              if ( ctrl.search.length > 0 ) {
                tagged = true;
              }
            }
          }
          if ( tagged ) {
            $timeout(function() {
              ctrl.searchInput.triggerHandler('tagged');
              var newItem = ctrl.search.replace(KEY.MAP[e.keyCode],'').trim();
              if ( ctrl.tagging.fct ) {
                newItem = ctrl.tagging.fct( newItem );
              }
              if (newItem) ctrl.select(newItem, true);
            });
          }
        }
      }

    });

    if(KEY.isVerticalMovement(key) && ctrl.items.length > 0){
      _ensureHighlightVisible();
    }

    if (key === KEY.ENTER || key === KEY.ESC) {
      e.preventDefault();
      e.stopPropagation();
    }

  });

  ctrl.searchInput.on('paste', function (e) {
    var data;

    if (window.clipboardData && window.clipboardData.getData) { // IE
      data = window.clipboardData.getData('Text');
    } else {
      data = (e.originalEvent || e).clipboardData.getData('text/plain');
    }

    // Prepend the current input field text to the paste buffer.
    data = ctrl.search + data;

    if (data && data.length > 0) {
      // If tagging try to split by tokens and add items
      if (ctrl.taggingTokens.isActivated) {
        var items = [];
        for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {  // split by first token that is contained in data
          var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
          if (data.indexOf(separator) > -1) {
            items = data.split(separator);
            break;  // only split by one token
          }
        }
        if (items.length === 0) {
          items = [data];
        }
        var oldsearch = ctrl.search;
        angular.forEach(items, function (item) {
          var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
          if (newItem) {
            ctrl.select(newItem, true);
          }
        });
        ctrl.search = oldsearch || EMPTY_SEARCH;
        e.preventDefault();
        e.stopPropagation();
      } else if (ctrl.paste) {
        ctrl.paste(data);
        ctrl.search = EMPTY_SEARCH;
        e.preventDefault();
        e.stopPropagation();
      }
    }
  });

  ctrl.searchInput.on('tagged', function() {
    $timeout(function() {
      _resetSearchInput();
    });
  });

  // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
  function _ensureHighlightVisible() {
    var container = $element.querySelectorAll('.ui-select-choices-content');
    var choices = container.querySelectorAll('.ui-select-choices-row');
    if (choices.length < 1) {
      throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
    }

    if (ctrl.activeIndex < 0) {
      return;
    }

    var highlighted = choices[ctrl.activeIndex];
    var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
    var height = container[0].offsetHeight;

    if (posY > height) {
      container[0].scrollTop += posY - height;
    } else if (posY < highlighted.clientHeight) {
      if (ctrl.isGrouped && ctrl.activeIndex === 0)
        container[0].scrollTop = 0; //To make group header visible when going all the way up
      else
        container[0].scrollTop -= highlighted.clientHeight - posY;
    }
  }

  var onResize = $$uisDebounce(function() {
    ctrl.sizeSearchInput();
  }, 50);

  angular.element($window).bind('resize', onResize);

  $scope.$on('$destroy', function() {
    ctrl.searchInput.off('keyup keydown tagged blur paste');
    angular.element($window).off('resize', onResize);
  });

  $scope.$watch('$select.activeIndex', function(activeIndex) {
    if (activeIndex)
      $element.find('input').attr(
        'aria-activedescendant',
        'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
  });

  $scope.$watch('$select.open', function(open) {
    if (!open)
      $element.find('input').removeAttr('aria-activedescendant');
  });
}]);

uis.directive('uiSelect',
  ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
  function($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {

  return {
    restrict: 'EA',
    templateUrl: function(tElement, tAttrs) {
      var theme = tAttrs.theme || uiSelectConfig.theme;
      return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
    },
    replace: true,
    transclude: true,
    require: ['uiSelect', '^ngModel'],
    scope: true,

    controller: 'uiSelectCtrl',
    controllerAs: '$select',
    compile: function(tElement, tAttrs) {

      // Allow setting ngClass on uiSelect
      var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
      if(match) {
        var combined = '{'+ match[1] +', '+ match[2] +'}';
        tAttrs.ngClass = combined;
        tElement.attr('ng-class', combined);
      }

      //Multiple or Single depending if multiple attribute presence
      if (angular.isDefined(tAttrs.multiple))
        tElement.append('<ui-select-multiple/>').removeAttr('multiple');
      else
        tElement.append('<ui-select-single/>');

      if (tAttrs.inputId)
        tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;

      return function(scope, element, attrs, ctrls, transcludeFn) {

        var $select = ctrls[0];
        var ngModel = ctrls[1];

        $select.generatedId = uiSelectConfig.generateId();
        $select.baseTitle = attrs.title || 'Select box';
        $select.focusserTitle = $select.baseTitle + ' focus';
        $select.focusserId = 'focusser-' + $select.generatedId;

        $select.closeOnSelect = function() {
          if (angular.isDefined(attrs.closeOnSelect)) {
            return $parse(attrs.closeOnSelect)();
          } else {
            return uiSelectConfig.closeOnSelect;
          }
        }();

        scope.$watch('skipFocusser', function() {
            var skipFocusser = scope.$eval(attrs.skipFocusser);
            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
        });

        $select.onSelectCallback = $parse(attrs.onSelect);
        $select.onRemoveCallback = $parse(attrs.onRemove);

        //Set reference to ngModel from uiSelectCtrl
        $select.ngModel = ngModel;

        $select.choiceGrouped = function(group){
          return $select.isGrouped && group && group.name;
        };

        if(attrs.tabindex){
          attrs.$observe('tabindex', function(value) {
            $select.focusInput.attr('tabindex', value);
            element.removeAttr('tabindex');
          });
        }

        scope.$watch(function () { return scope.$eval(attrs.searchEnabled); }, function(newVal) {
          $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
        });

        scope.$watch('sortable', function() {
            var sortable = scope.$eval(attrs.sortable);
            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
        });

        attrs.$observe('backspaceReset', function() {
          // $eval() is needed otherwise we get a string instead of a boolean
          var backspaceReset = scope.$eval(attrs.backspaceReset);
          $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
        });

        attrs.$observe('limit', function() {
          //Limit the number of selections allowed
          $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;
        });

        scope.$watch('removeSelected', function() {
            var removeSelected = scope.$eval(attrs.removeSelected);
            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
        });

        attrs.$observe('disabled', function() {
          // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
          $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
        });

        attrs.$observe('resetSearchInput', function() {
          // $eval() is needed otherwise we get a string instead of a boolean
          var resetSearchInput = scope.$eval(attrs.resetSearchInput);
          $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
        });

        attrs.$observe('paste', function() {
          $select.paste = scope.$eval(attrs.paste);
        });

        attrs.$observe('tagging', function() {
          if(attrs.tagging !== undefined)
          {
            // $eval() is needed otherwise we get a string instead of a boolean
            var taggingEval = scope.$eval(attrs.tagging);
            $select.tagging = {isActivated: true, fct: taggingEval !== true ? taggingEval : undefined};
          }
          else
          {
            $select.tagging = {isActivated: false, fct: undefined};
          }
        });

        attrs.$observe('taggingLabel', function() {
          if(attrs.tagging !== undefined )
          {
            // check eval for FALSE, in this case, we disable the labels
            // associated with tagging
            if ( attrs.taggingLabel === 'false' ) {
              $select.taggingLabel = false;
            }
            else
            {
              $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
            }
          }
        });

        attrs.$observe('taggingTokens', function() {
          if (attrs.tagging !== undefined) {
            var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',','ENTER'];
            $select.taggingTokens = {isActivated: true, tokens: tokens };
          }
        });

        attrs.$observe('spinnerEnabled', function() {
          // $eval() is needed otherwise we get a string instead of a boolean
          var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
          $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
        });

        attrs.$observe('spinnerClass', function() {
          var spinnerClass = attrs.spinnerClass;
          $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
        });

        //Automatically gets focus when loaded
        if (angular.isDefined(attrs.autofocus)){
          $timeout(function(){
            $select.setFocus();
          });
        }

        //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
        if (angular.isDefined(attrs.focusOn)){
          scope.$on(attrs.focusOn, function() {
              $timeout(function(){
                $select.setFocus();
              });
          });
        }

        function onDocumentClick(e) {
          if (!$select.open) return; //Skip it if dropdown is close

          var contains = false;

          if (__webpack_provided_window_dot_jQuery) {
            // Firefox 3.6 does not support element.contains()
            // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
            contains = __webpack_provided_window_dot_jQuery.contains(element[0], e.target);
          } else {
            contains = element[0].contains(e.target);
          }

          if (!contains && !$select.clickTriggeredSelect) {
            var skipFocusser;
            if (!$select.skipFocusser) {
              //Will lose focus only with certain targets
              var focusableControls = ['input','button','textarea','select'];
              var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
              skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
              if (!skipFocusser) skipFocusser =  ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
            } else {
              skipFocusser = true;
            }
            $select.close(skipFocusser);
            scope.$digest();
          }
          $select.clickTriggeredSelect = false;
        }

        // See Click everywhere but here event http://stackoverflow.com/questions/12931369
        $document.on('click', onDocumentClick);

        scope.$on('$destroy', function() {
          $document.off('click', onDocumentClick);
        });

        // Move transcluded elements to their correct position in main template
        transcludeFn(scope, function(clone) {
          // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html

          // One day jqLite will be replaced by jQuery and we will be able to write:
          // var transcludedElement = clone.filter('.my-class')
          // instead of creating a hackish DOM element:
          var transcluded = angular.element('<div>').append(clone);

          var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
          transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
          transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
          if (transcludedMatch.length !== 1) {
            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
          }
          element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);

          var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
          transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
          transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
          if (transcludedChoices.length !== 1) {
            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
          }
          element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);

          var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
          transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
          transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
          if (transcludedNoChoice.length == 1) {
            element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
          }
        });

        // Support for appending the select field to the body when its open
        var appendToBody = scope.$eval(attrs.appendToBody);
        if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
          scope.$watch('$select.open', function(isOpen) {
            if (isOpen) {
              positionDropdown();
            } else {
              resetDropdown();
            }
          });

          // Move the dropdown back to its original location when the scope is destroyed. Otherwise
          // it might stick around when the user routes away or the select field is otherwise removed
          scope.$on('$destroy', function() {
            resetDropdown();
          });
        }

        // Hold on to a reference to the .ui-select-container element for appendToBody support
        var placeholder = null,
            originalWidth = '';

        function positionDropdown() {
          // Remember the absolute position of the element
          var offset = uisOffset(element);

          // Clone the element into a placeholder element to take its original place in the DOM
          placeholder = angular.element('<div class="ui-select-placeholder"></div>');
          placeholder[0].style.width = offset.width + 'px';
          placeholder[0].style.height = offset.height + 'px';
          element.after(placeholder);

          // Remember the original value of the element width inline style, so it can be restored
          // when the dropdown is closed
          originalWidth = element[0].style.width;

          // Now move the actual dropdown element to the end of the body
          $document.find('body').append(element);

          element[0].style.position = 'absolute';
          element[0].style.left = offset.left + 'px';
          element[0].style.top = offset.top + 'px';
          element[0].style.width = offset.width + 'px';
        }

        function resetDropdown() {
          if (placeholder === null) {
            // The dropdown has not actually been display yet, so there's nothing to reset
            return;
          }

          // Move the dropdown element back to its original location in the DOM
          placeholder.replaceWith(element);
          placeholder = null;

          element[0].style.position = '';
          element[0].style.left = '';
          element[0].style.top = '';
          element[0].style.width = originalWidth;

          // Set focus back on to the moved element
          $select.setFocus();
        }

        // Hold on to a reference to the .ui-select-dropdown element for direction support.
        var dropdown = null,
            directionUpClassName = 'direction-up';

        // Support changing the direction of the dropdown if there isn't enough space to render it.
        scope.$watch('$select.open', function() {

          if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up'){
            scope.calculateDropdownPos();
          }

        });

        var setDropdownPosUp = function(offset, offsetDropdown){

          offset = offset || uisOffset(element);
          offsetDropdown = offsetDropdown || uisOffset(dropdown);

          dropdown[0].style.position = 'absolute';
          dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
          element.addClass(directionUpClassName);

        };

        var setDropdownPosDown = function(offset, offsetDropdown){

          element.removeClass(directionUpClassName);

          offset = offset || uisOffset(element);
          offsetDropdown = offsetDropdown || uisOffset(dropdown);

          dropdown[0].style.position = '';
          dropdown[0].style.top = '';

        };

        var calculateDropdownPosAfterAnimation = function() {
          // Delay positioning the dropdown until all choices have been added so its height is correct.
          $timeout(function() {
            if ($select.dropdownPosition === 'up') {
              //Go UP
              setDropdownPosUp();
            } else {
              //AUTO
              element.removeClass(directionUpClassName);

              var offset = uisOffset(element);
              var offsetDropdown = uisOffset(dropdown);

              //https://code.google.com/p/chromium/issues/detail?id=342307#c4
              var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).

              // Determine if the direction of the dropdown needs to be changed.
              if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
                //Go UP
                setDropdownPosUp(offset, offsetDropdown);
              }else{
                //Go DOWN
                setDropdownPosDown(offset, offsetDropdown);
              }
            }

            // Display the dropdown once it has been positioned.
            dropdown[0].style.opacity = 1;
          });
        };

        var opened = false;
        
        scope.calculateDropdownPos = function() {
          if ($select.open) {
            dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');

            if (dropdown.length === 0) {
              return;
            }

           // Hide the dropdown so there is no flicker until $timeout is done executing.
           if ($select.search === '' && !opened) {
              dropdown[0].style.opacity = 0;
              opened = true;
           }

            if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
              var needsCalculated = true;

              $select.$animate.on('enter', dropdown, function (elem, phase) {
                if (phase === 'close' && needsCalculated) {
                  calculateDropdownPosAfterAnimation();
                  needsCalculated = false;
                }
              });
            } else {
              calculateDropdownPosAfterAnimation();
            }
          } else {
            if (dropdown === null || dropdown.length === 0) {
              return;
            }

            // Reset the position of the dropdown.
            dropdown[0].style.opacity = 0;
            dropdown[0].style.position = '';
            dropdown[0].style.top = '';
            element.removeClass(directionUpClassName);
          }
        };
      };
    }
  };
}]);

uis.directive('uiSelectMatch', ['uiSelectConfig', function(uiSelectConfig) {
  return {
    restrict: 'EA',
    require: '^uiSelect',
    replace: true,
    transclude: true,
    templateUrl: function(tElement) {
      // Needed so the uiSelect can detect the transcluded content
      tElement.addClass('ui-select-match');

      var parent = tElement.parent();
      // Gets theme attribute from parent (ui-select)
      var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
      var multi = angular.isDefined(getAttribute(parent, 'multiple'));

      return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');      
    },
    link: function(scope, element, attrs, $select) {
      $select.lockChoiceExpression = attrs.uiLockChoice;
      attrs.$observe('placeholder', function(placeholder) {
        $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
      });

      function setAllowClear(allow) {
        $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
      }

      attrs.$observe('allowClear', setAllowClear);
      setAllowClear(attrs.allowClear);

      if($select.multiple){
        $select.sizeSearchInput();
      }

    }
  };

  function getAttribute(elem, attribute) {
    if (elem[0].hasAttribute(attribute))
      return elem.attr(attribute);

    if (elem[0].hasAttribute('data-' + attribute))
      return elem.attr('data-' + attribute);

    if (elem[0].hasAttribute('x-' + attribute))
      return elem.attr('x-' + attribute);
  }
}]);

uis.directive('uiSelectMultiple', ['uiSelectMinErr','$timeout', function(uiSelectMinErr, $timeout) {
  return {
    restrict: 'EA',
    require: ['^uiSelect', '^ngModel'],

    controller: ['$scope','$timeout', function($scope, $timeout){

      var ctrl = this,
          $select = $scope.$select,
          ngModel;

      if (angular.isUndefined($select.selected))
        $select.selected = [];

      //Wait for link fn to inject it
      $scope.$evalAsync(function(){ ngModel = $scope.ngModel; });

      ctrl.activeMatchIndex = -1;

      ctrl.updateModel = function(){
        ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
        ctrl.refreshComponent();
      };

      ctrl.refreshComponent = function(){
        //Remove already selected items
        //e.g. When user clicks on a selection, the selected array changes and
        //the dropdown should remove that item
        if($select.refreshItems){
          $select.refreshItems();
        }
        if($select.sizeSearchInput){
          $select.sizeSearchInput();
        }
      };

      // Remove item from multiple select
      ctrl.removeChoice = function(index){

        // if the choice is locked, don't remove it
        if($select.isLocked(null, index)) return false;

        var removedChoice = $select.selected[index];

        var locals = {};
        locals[$select.parserResult.itemName] = removedChoice;

        $select.selected.splice(index, 1);
        ctrl.activeMatchIndex = -1;
        $select.sizeSearchInput();

        // Give some time for scope propagation.
        $timeout(function(){
          $select.onRemoveCallback($scope, {
            $item: removedChoice,
            $model: $select.parserResult.modelMapper($scope, locals)
          });
        });

        ctrl.updateModel();

        return true;
      };

      ctrl.getPlaceholder = function(){
        //Refactor single?
        if($select.selected && $select.selected.length) return;
        return $select.placeholder;
      };


    }],
    controllerAs: '$selectMultiple',

    link: function(scope, element, attrs, ctrls) {

      var $select = ctrls[0];
      var ngModel = scope.ngModel = ctrls[1];
      var $selectMultiple = scope.$selectMultiple;

      //$select.selected = raw selected objects (ignoring any property binding)

      $select.multiple = true;

      //Input that will handle focus
      $select.focusInput = $select.searchInput;

      //Properly check for empty if set to multiple
      ngModel.$isEmpty = function(value) {
        return !value || value.length === 0;
      };

      //From view --> model
      ngModel.$parsers.unshift(function () {
        var locals = {},
            result,
            resultMultiple = [];
        for (var j = $select.selected.length - 1; j >= 0; j--) {
          locals = {};
          locals[$select.parserResult.itemName] = $select.selected[j];
          result = $select.parserResult.modelMapper(scope, locals);
          resultMultiple.unshift(result);
        }
        return resultMultiple;
      });

      // From model --> view
      ngModel.$formatters.unshift(function (inputValue) {
        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
            locals = {},
            result;
        if (!data) return inputValue;
        var resultMultiple = [];
        var checkFnMultiple = function(list, value){
          if (!list || !list.length) return;
          for (var p = list.length - 1; p >= 0; p--) {
            locals[$select.parserResult.itemName] = list[p];
            result = $select.parserResult.modelMapper(scope, locals);
            if($select.parserResult.trackByExp){
                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
                if(propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName){
                  if(matches && matches.length>0 && result[matches[1]] == value[matches[1]]){
                      resultMultiple.unshift(list[p]);
                      return true;
                  }
                }
            }
            if (angular.equals(result,value)){
              resultMultiple.unshift(list[p]);
              return true;
            }
          }
          return false;
        };
        if (!inputValue) return resultMultiple; //If ngModel was undefined
        for (var k = inputValue.length - 1; k >= 0; k--) {
          //Check model array of currently selected items
          if (!checkFnMultiple($select.selected, inputValue[k])){
            //Check model array of all items available
            if (!checkFnMultiple(data, inputValue[k])){
              //If not found on previous lists, just add it directly to resultMultiple
              resultMultiple.unshift(inputValue[k]);
            }
          }
        }
        return resultMultiple;
      });

      //Watch for external model changes
      scope.$watchCollection(function(){ return ngModel.$modelValue; }, function(newValue, oldValue) {
        if (oldValue != newValue){
          //update the view value with fresh data from items, if there is a valid model value
          if(angular.isDefined(ngModel.$modelValue)) {
            ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
          }
          $selectMultiple.refreshComponent();
        }
      });

      ngModel.$render = function() {
        // Make sure that model value is array
        if(!angular.isArray(ngModel.$viewValue)){
          // Have tolerance for null or undefined values
          if (isNil(ngModel.$viewValue)){
            ngModel.$viewValue = [];
          } else {
            throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
          }
        }
        $select.selected = ngModel.$viewValue;
        $selectMultiple.refreshComponent();
        scope.$evalAsync(); //To force $digest
      };

      scope.$on('uis:select', function (event, item) {
        if($select.selected.length >= $select.limit) {
          return;
        }
        $select.selected.push(item);
        var locals = {};
        locals[$select.parserResult.itemName] = item;

        $timeout(function(){
          $select.onSelectCallback(scope, {
            $item: item,
            $model: $select.parserResult.modelMapper(scope, locals)
          });
        });
        $selectMultiple.updateModel();
      });

      scope.$on('uis:activate', function () {
        $selectMultiple.activeMatchIndex = -1;
      });

      scope.$watch('$select.disabled', function(newValue, oldValue) {
        // As the search input field may now become visible, it may be necessary to recompute its size
        if (oldValue && !newValue) $select.sizeSearchInput();
      });

      $select.searchInput.on('keydown', function(e) {
        var key = e.which;
        scope.$apply(function() {
          var processed = false;
          // var tagged = false; //Checkme
          if(KEY.isHorizontalMovement(key)){
            processed = _handleMatchSelection(key);
          }
          if (processed  && key != KEY.TAB) {
            //TODO Check si el tab selecciona aun correctamente
            //Crear test
            e.preventDefault();
            e.stopPropagation();
          }
        });
      });
      function _getCaretPosition(el) {
        if(angular.isNumber(el.selectionStart)) return el.selectionStart;
        // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
        else return el.value.length;
      }
      // Handles selected options in "multiple" mode
      function _handleMatchSelection(key){
        var caretPosition = _getCaretPosition($select.searchInput[0]),
            length = $select.selected.length,
            // none  = -1,
            first = 0,
            last  = length-1,
            curr  = $selectMultiple.activeMatchIndex,
            next  = $selectMultiple.activeMatchIndex+1,
            prev  = $selectMultiple.activeMatchIndex-1,
            newIndex = curr;

        if(caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;

        $select.close();

        function getNewActiveMatchIndex(){
          switch(key){
            case KEY.LEFT:
              // Select previous/first item
              if(~$selectMultiple.activeMatchIndex) return prev;
              // Select last item
              else return last;
              break;
            case KEY.RIGHT:
              // Open drop-down
              if(!~$selectMultiple.activeMatchIndex || curr === last){
                $select.activate();
                return false;
              }
              // Select next/last item
              else return next;
              break;
            case KEY.BACKSPACE:
              // Remove selected item and select previous/first
              if(~$selectMultiple.activeMatchIndex){
                if($selectMultiple.removeChoice(curr)) {
                  return prev;
                } else {
                  return curr;
                }

              } else {
                // If nothing yet selected, select last item
                return last;
              }
              break;
            case KEY.DELETE:
              // Remove selected item and select next item
              if(~$selectMultiple.activeMatchIndex){
                $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
                return curr;
              }
              else return false;
          }
        }

        newIndex = getNewActiveMatchIndex();

        if(!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
        else $selectMultiple.activeMatchIndex = Math.min(last,Math.max(first,newIndex));

        return true;
      }

      $select.searchInput.on('keyup', function(e) {

        if ( ! KEY.isVerticalMovement(e.which) ) {
          scope.$evalAsync( function () {
            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
          });
        }
        // Push a "create new" item into array if there is a search string
        if ( $select.tagging.isActivated && $select.search.length > 0 ) {

          // return early with these keys
          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which) ) {
            return;
          }
          // always reset the activeIndex to the first item when tagging
          $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
          // taggingLabel === false bypasses all of this
          if ($select.taggingLabel === false) return;

          var items = angular.copy( $select.items );
          var stashArr = angular.copy( $select.items );
          var newItem;
          var item;
          var hasTag = false;
          var dupeIndex = -1;
          var tagItems;
          var tagItem;

          // case for object tagging via transform `$select.tagging.fct` function
          if ( $select.tagging.fct !== undefined) {
            tagItems = $select.$filter('filter')(items,{'isTag': true});
            if ( tagItems.length > 0 ) {
              tagItem = tagItems[0];
            }
            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
            if ( items.length > 0 && tagItem ) {
              hasTag = true;
              items = items.slice(1,items.length);
              stashArr = stashArr.slice(1,stashArr.length);
            }
            newItem = $select.tagging.fct($select.search);
            // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
            if (
              stashArr.some(function (origItem) {
                 return angular.equals(origItem, newItem);
              }) ||
              $select.selected.some(function (origItem) {
                return angular.equals(origItem, newItem);
              })
            ) {
              scope.$evalAsync(function () {
                $select.activeIndex = 0;
                $select.items = items;
              });
              return;
            }
            if (newItem) newItem.isTag = true;
          // handle newItem string and stripping dupes in tagging string context
          } else {
            // find any tagging items already in the $select.items array and store them
            tagItems = $select.$filter('filter')(items,function (item) {
              return item.match($select.taggingLabel);
            });
            if ( tagItems.length > 0 ) {
              tagItem = tagItems[0];
            }
            item = items[0];
            // remove existing tag item if found (should only ever be one tag item)
            if ( item !== undefined && items.length > 0 && tagItem ) {
              hasTag = true;
              items = items.slice(1,items.length);
              stashArr = stashArr.slice(1,stashArr.length);
            }
            newItem = $select.search+' '+$select.taggingLabel;
            if ( _findApproxDupe($select.selected, $select.search) > -1 ) {
              return;
            }
            // verify the the tag doesn't match the value of an existing item from
            // the searched data set or the items already selected
            if ( _findCaseInsensitiveDupe(stashArr.concat($select.selected)) ) {
              // if there is a tag from prev iteration, strip it / queue the change
              // and return early
              if ( hasTag ) {
                items = stashArr;
                scope.$evalAsync( function () {
                  $select.activeIndex = 0;
                  $select.items = items;
                });
              }
              return;
            }
            if ( _findCaseInsensitiveDupe(stashArr) ) {
              // if there is a tag from prev iteration, strip it
              if ( hasTag ) {
                $select.items = stashArr.slice(1,stashArr.length);
              }
              return;
            }
          }
          if ( hasTag ) dupeIndex = _findApproxDupe($select.selected, newItem);
          // dupe found, shave the first item
          if ( dupeIndex > -1 ) {
            items = items.slice(dupeIndex+1,items.length-1);
          } else {
            items = [];
            if (newItem) items.push(newItem);
            items = items.concat(stashArr);
          }
          scope.$evalAsync( function () {
            $select.activeIndex = 0;
            $select.items = items;

            if ($select.isGrouped) {
              // update item references in groups, so that indexOf will work after angular.copy
              var itemsWithoutTag = newItem ? items.slice(1) : items;
              $select.setItemsFn(itemsWithoutTag);
              if (newItem) {
                // add tag item as a new group
                $select.items.unshift(newItem);
                $select.groups.unshift({name: '', items: [newItem], tagging: true});
              }
            }
          });
        }
      });
      function _findCaseInsensitiveDupe(arr) {
        if ( arr === undefined || $select.search === undefined ) {
          return false;
        }
        var hasDupe = arr.filter( function (origItem) {
          if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
            return false;
          }
          return origItem.toUpperCase() === $select.search.toUpperCase();
        }).length > 0;

        return hasDupe;
      }
      function _findApproxDupe(haystack, needle) {
        var dupeIndex = -1;
        if(angular.isArray(haystack)) {
          var tempArr = angular.copy(haystack);
          for (var i = 0; i <tempArr.length; i++) {
            // handle the simple string version of tagging
            if ( $select.tagging.fct === undefined ) {
              // search the array for the match
              if ( tempArr[i]+' '+$select.taggingLabel === needle ) {
              dupeIndex = i;
              }
            // handle the object tagging implementation
            } else {
              var mockObj = tempArr[i];
              if (angular.isObject(mockObj)) {
                mockObj.isTag = true;
              }
              if ( angular.equals(mockObj, needle) ) {
                dupeIndex = i;
              }
            }
          }
        }
        return dupeIndex;
      }

      $select.searchInput.on('blur', function() {
        $timeout(function() {
          $selectMultiple.activeMatchIndex = -1;
        });
      });

    }
  };
}]);

uis.directive('uiSelectNoChoice',
    ['uiSelectConfig', function (uiSelectConfig) {
        return {
            restrict: 'EA',
            require: '^uiSelect',
            replace: true,
            transclude: true,
            templateUrl: function (tElement) {
                // Needed so the uiSelect can detect the transcluded content
                tElement.addClass('ui-select-no-choice');
      
                // Gets theme attribute from parent (ui-select)
                var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
                return theme + '/no-choice.tpl.html';
            }
        };
    }]);

uis.directive('uiSelectSingle', ['$timeout','$compile', function($timeout, $compile) {
  return {
    restrict: 'EA',
    require: ['^uiSelect', '^ngModel'],
    link: function(scope, element, attrs, ctrls) {

      var $select = ctrls[0];
      var ngModel = ctrls[1];

      //From view --> model
      ngModel.$parsers.unshift(function (inputValue) {
        // Keep original value for undefined and null
        if (isNil(inputValue)) {
          return inputValue;
        }

        var locals = {},
            result;
        locals[$select.parserResult.itemName] = inputValue;
        result = $select.parserResult.modelMapper(scope, locals);
        return result;
      });

      //From model --> view
      ngModel.$formatters.unshift(function (inputValue) {
        // Keep original value for undefined and null
        if (isNil(inputValue)) {
          return inputValue;
        }

        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
            locals = {},
            result;
        if (data){
          var checkFnSingle = function(d){
            locals[$select.parserResult.itemName] = d;
            result = $select.parserResult.modelMapper(scope, locals);
            return result === inputValue;
          };
          //If possible pass same object stored in $select.selected
          if ($select.selected && checkFnSingle($select.selected)) {
            return $select.selected;
          }
          for (var i = data.length - 1; i >= 0; i--) {
            if (checkFnSingle(data[i])) return data[i];
          }
        }
        return inputValue;
      });

      //Update viewValue if model change
      scope.$watch('$select.selected', function(newValue) {
        if (ngModel.$viewValue !== newValue) {
          ngModel.$setViewValue(newValue);
        }
      });

      ngModel.$render = function() {
        $select.selected = ngModel.$viewValue;
      };

      scope.$on('uis:select', function (event, item) {
        $select.selected = item;
        var locals = {};
        locals[$select.parserResult.itemName] = item;

        $timeout(function() {
          $select.onSelectCallback(scope, {
            $item: item,
            $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
          });
        });
      });

      scope.$on('uis:close', function (event, skipFocusser) {
        $timeout(function(){
          $select.focusser.prop('disabled', false);
          if (!skipFocusser) $select.focusser[0].focus();
        },0,false);
      });

      scope.$on('uis:activate', function () {
        focusser.prop('disabled', true); //Will reactivate it on .close()
      });

      //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
      var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
      $compile(focusser)(scope);
      $select.focusser = focusser;

      //Input that will handle focus
      $select.focusInput = focusser;

      element.parent().append(focusser);
      focusser.bind("focus", function(){
        scope.$evalAsync(function(){
          $select.focus = true;
        });
      });
      focusser.bind("blur", function(){
        scope.$evalAsync(function(){
          $select.focus = false;
        });
      });
      focusser.bind("keydown", function(e){

        if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
          e.preventDefault();
          e.stopPropagation();
          $select.select(undefined);
          scope.$apply();
          return;
        }

        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
          return;
        }

        if (e.which == KEY.DOWN  || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE){
          e.preventDefault();
          e.stopPropagation();
          $select.activate();
        }

        scope.$digest();
      });

      focusser.bind("keyup input", function(e){

        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
          return;
        }

        $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
        focusser.val('');
        scope.$digest();

      });


    }
  };
}]);

// Make multiple matches sortable
uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function($timeout, uiSelectConfig, uiSelectMinErr) {
  return {
    require: ['^^uiSelect', '^ngModel'],
    link: function(scope, element, attrs, ctrls) {
      if (scope[attrs.uiSelectSort] === null) {
        throw uiSelectMinErr('sort', 'Expected a list to sort');
      }

      var $select = ctrls[0];
      var $ngModel = ctrls[1];

      var options = angular.extend({
          axis: 'horizontal'
        },
        scope.$eval(attrs.uiSelectSortOptions));

      var axis = options.axis;
      var draggingClassName = 'dragging';
      var droppingClassName = 'dropping';
      var droppingBeforeClassName = 'dropping-before';
      var droppingAfterClassName = 'dropping-after';

      scope.$watch(function(){
        return $select.sortable;
      }, function(newValue){
        if (newValue) {
          element.attr('draggable', true);
        } else {
          element.removeAttr('draggable');
        }
      });

      element.on('dragstart', function(event) {
        element.addClass(draggingClassName);

        (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
      });

      element.on('dragend', function() {
        removeClass(draggingClassName);
      });

      var move = function(from, to) {
        /*jshint validthis: true */
        this.splice(to, 0, this.splice(from, 1)[0]);
      };

      var removeClass = function(className) {
        angular.forEach($select.$element.querySelectorAll('.' + className), function(el){
          angular.element(el).removeClass(className);
        });
      };

      var dragOverHandler = function(event) {
        event.preventDefault();

        var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);

        if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
          removeClass(droppingAfterClassName);
          element.addClass(droppingBeforeClassName);

        } else {
          removeClass(droppingBeforeClassName);
          element.addClass(droppingAfterClassName);
        }
      };

      var dropTimeout;

      var dropHandler = function(event) {
        event.preventDefault();

        var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);

        // prevent event firing multiple times in firefox
        $timeout.cancel(dropTimeout);
        dropTimeout = $timeout(function() {
          _dropHandler(droppedItemIndex);
        }, 20);
      };

      var _dropHandler = function(droppedItemIndex) {
        var theList = scope.$eval(attrs.uiSelectSort);
        var itemToMove = theList[droppedItemIndex];
        var newIndex = null;

        if (element.hasClass(droppingBeforeClassName)) {
          if (droppedItemIndex < scope.$index) {
            newIndex = scope.$index - 1;
          } else {
            newIndex = scope.$index;
          }
        } else {
          if (droppedItemIndex < scope.$index) {
            newIndex = scope.$index;
          } else {
            newIndex = scope.$index + 1;
          }
        }

        move.apply(theList, [droppedItemIndex, newIndex]);

        $ngModel.$setViewValue(Date.now());

        scope.$apply(function() {
          scope.$emit('uiSelectSort:change', {
            array: theList,
            item: itemToMove,
            from: droppedItemIndex,
            to: newIndex
          });
        });

        removeClass(droppingClassName);
        removeClass(droppingBeforeClassName);
        removeClass(droppingAfterClassName);

        element.off('drop', dropHandler);
      };

      element.on('dragenter', function() {
        if (element.hasClass(draggingClassName)) {
          return;
        }

        element.addClass(droppingClassName);

        element.on('dragover', dragOverHandler);
        element.on('drop', dropHandler);
      });

      element.on('dragleave', function(event) {
        if (event.target != element) {
          return;
        }

        removeClass(droppingClassName);
        removeClass(droppingBeforeClassName);
        removeClass(droppingAfterClassName);

        element.off('dragover', dragOverHandler);
        element.off('drop', dropHandler);
      });
    }
  };
}]);

/**
 * Debounces functions
 *
 * Taken from UI Bootstrap $$debounce source code
 * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
 *
 */
uis.factory('$$uisDebounce', ['$timeout', function($timeout) {
  return function(callback, debounceTime) {
    var timeoutPromise;

    return function() {
      var self = this;
      var args = Array.prototype.slice.call(arguments);
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }

      timeoutPromise = $timeout(function() {
        callback.apply(self, args);
      }, debounceTime);
    };
  };
}]);

uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
  return {
    restrict: 'A',
    require: 'uiSelect',
    link: function (scope, element, attrs, $select) {
      $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);

      scope.$watch('$select.open', function (isOpen, previousState) {
        if (isOpen !== previousState) {
          $timeout(function () {
            $select.onOpenCloseCallback(scope, {
              isOpen: isOpen
            });
          });
        }
      });
    }
  };
}]);

/**
 * Parses "repeat" attribute.
 *
 * Taken from AngularJS ngRepeat source code
 * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
 *
 * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
 * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
 */

uis.service('uisRepeatParser', ['uiSelectMinErr','$parse', function(uiSelectMinErr, $parse) {
  var self = this;

  /**
   * Example:
   * expression = "address in addresses | filter: {street: $select.search} track by $index"
   * itemName = "address",
   * source = "addresses | filter: {street: $select.search}",
   * trackByExp = "$index",
   */
  self.parse = function(expression) {


    var match;
    //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
    // If an array is used as collection

    // if (isObjectCollection){
    // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
    match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

    // 1 Alias
    // 2 Item
    // 3 Key on (key,value)
    // 4 Value on (key,value)
    // 5 Source expression (including filters)
    // 6 Track by

    if (!match) {
      throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
              expression);
    }
    
    var source = match[5], 
        filters = '';

    // When using (key,value) ui-select requires filters to be extracted, since the object
    // is converted to an array for $select.items 
    // (in which case the filters need to be reapplied)
    if (match[3]) {
      // Remove any enclosing parenthesis
      source = match[5].replace(/(^\()|(\)$)/g, '');
      // match all after | but not after ||
      var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
      if(filterMatch && filterMatch[1].trim()) {
        filters = filterMatch[1];
        source = source.replace(filters, '');
      }      
    }

    return {
      itemName: match[4] || match[2], // (lhs) Left-hand side,
      keyName: match[3], //for (key, value) syntax
      source: $parse(source),
      filters: filters,
      trackByExp: match[6],
      modelMapper: $parse(match[1] || match[4] || match[2]),
      repeatExpression: function (grouped) {
        var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
        if (this.trackByExp) {
          expression += ' track by ' + this.trackByExp;
        }
        return expression;
      } 
    };

  };

  self.getGroupNgRepeatExpression = function() {
    return '$group in $select.groups track by $group.name';
  };

}]);

}());
angular.module("ui.select").run(["$templateCache", function($templateCache) {$templateCache.put("bootstrap/choices.tpl.html","<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
$templateCache.put("bootstrap/match-multiple.tpl.html","<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
$templateCache.put("bootstrap/match.tpl.html","<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
$templateCache.put("bootstrap/no-choice.tpl.html","<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
$templateCache.put("bootstrap/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
$templateCache.put("bootstrap/select.tpl.html","<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
$templateCache.put("select2/choices.tpl.html","<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
$templateCache.put("select2/match-multiple.tpl.html","<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
$templateCache.put("select2/match.tpl.html","<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
$templateCache.put("select2/no-choice.tpl.html","<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("select2/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
$templateCache.put("select2/select.tpl.html","<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
$templateCache.put("selectize/choices.tpl.html","<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown\" ng-class=\"{\'single\': !$select.multiple, \'multi\': $select.multiple}\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
$templateCache.put("selectize/match-multiple.tpl.html","<div class=\"ui-select-match\" data-value=\"\" ng-repeat=\"$item in $select.selected track by $index\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'active\':$selectMultiple.activeMatchIndex === $index}\" ui-select-sort=\"$select.selected\"><span class=\"ui-select-match-item\" ng-class=\"{\'select-locked\':$select.isLocked(this, $index)}\"><span uis-transclude-append=\"\"></span> <span class=\"remove ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&times;</span></span></div>");
$templateCache.put("selectize/match.tpl.html","<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"></span></div>");
$templateCache.put("selectize/no-choice.tpl.html","<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("selectize/select-multiple.tpl.html","<div class=\"ui-select-container selectize-control multi plugin-remove_button\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-model=\"$select.search\" ng-disabled=\"$select.disabled\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
$templateCache.put("selectize/select.tpl.html","<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 3167 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3166);
module.exports = 'ui.select';


/***/ }),
/* 3168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ }),
/* 3169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "448c34a56d699c29117adc64c43affeb.woff2";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// vendor.bundle.js